/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	jQuery = __webpack_require__(12);
	angular = __webpack_require__(27);
	moment = __webpack_require__(1);
	enviroment = __webpack_require__(158);
	if(!enviroment.isDevelopment) {
	  // ============================================================================
	// SENTRY ERROR TRACKING & MONITORING SETUP
	// ============================================================================
	// Initialize Sentry for error tracking
	// All Sentry logic is centralized in sentryIntegration.js
	// ============================================================================
	  var sentryIntegration = __webpack_require__(159);
	  sentryIntegration.init();
	} 
	EXIF = __webpack_require__(467);
	Dropzone = __webpack_require__(466);
	Promise = __webpack_require__(213);
	QRCode = __webpack_require__(214)
	// io = require('../node_modules/socket.io-client/dist/socket.io.js');
	owasp = __webpack_require__(211);
	slugify = __webpack_require__(320);
	window.diff_match_patch = __webpack_require__(194);
	intersectionObserverGlobal = __webpack_require__(458)
	__webpack_require__(186);
	__webpack_require__(182);
	__webpack_require__(184);
	__webpack_require__(210)
	__webpack_require__(333);
	__webpack_require__(200);
	__webpack_require__(190)
	__webpack_require__(180);
	// require('../node_modules/angular-socket-io/socket.js');
	__webpack_require__(468);
	__webpack_require__(470);
	__webpack_require__(208);
	__webpack_require__(465);
	__webpack_require__(469);
	__webpack_require__(471);
	__webpack_require__(197);
	__webpack_require__(472);
	__webpack_require__(332);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(329);
	__webpack_require__(328)
	__webpack_require__(473);
	__webpack_require__(327);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(331);
	__webpack_require__(330);
	__webpack_require__(462);
	// require('../node_modules/tinymce/plugins/insertdatetime/plugin');
	__webpack_require__(474);
	__webpack_require__(463);
	__webpack_require__(322);
	__webpack_require__(188);
	__webpack_require__(185);
	__webpack_require__(191);
	__webpack_require__(187);
	wpautop = __webpack_require__(475);
	window.Highcharts = __webpack_require__(196);
	window.videojs = __webpack_require__(417);
	// require('../node_modules/videojs-contrib-hls/dist/videojs-contrib-hls.min.js');
	var tinycolor = __webpack_require__(141);
	__webpack_require__(464);
	__webpack_require__(321);
	__webpack_require__(579);
	__webpack_require__(505);
	__webpack_require__(499);
	__webpack_require__(565);
	// require('./development/assets/ext-modules/blogsModule/blogsModule.js');
	// require('./development/assets/ext-modules/newsServicesModule/newsServicesModule.js');
	__webpack_require__(578);
	__webpack_require__(520);
	__webpack_require__(539);
	__webpack_require__(492);
	__webpack_require__(485);
	__webpack_require__(639);
	__webpack_require__(544);
	__webpack_require__(532);
	__webpack_require__(496);
	// require('./development/assets/ext-modules/focusModule/focusModule.js');
	// require('./development/assets/ext-modules/newstickerModule/newstickerModule.js');
	__webpack_require__(545);
	__webpack_require__(512);
	__webpack_require__(525);
	__webpack_require__(509);
	__webpack_require__(658);
	// require('./development/assets/ext-modules/eSportsModule/eSportsModule.js');
	__webpack_require__(476);
	// require('./development/assets/ext-modules/wCupModule/wCupModule.js');
	// require('./development/assets/ext-modules/covidRestrictionsModule/covidRestrictionsModule.js');
	// require('./development/assets/ext-modules/blicModule/blicModule.js');
	// require('./development/assets/ext-modules/catalogsModule/catalogModule.js');
	__webpack_require__(422);
	
	// ============================================================================
	// SENTRY TEST CONTROLLER (Development Only)
	// ============================================================================
	// Load this AFTER Sentry is initialized and app.js is loaded
	// Get the 'app' module from Angular since it's already registered
	// This provides a test panel for manually testing Sentry integration
	// Only loads in development, automatically hidden in production
	// ============================================================================
	// if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
	//   // Get the Angular app module that was registered in app.js
	//   var app = angular.module('app');
	//   require('./development/assets/app/js/sentryTestController.js')(app);
	//   console.log('🧪 Sentry Test Controller loaded (development mode)');
	// }
	// ============================================================================
	


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.15.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return this._months;
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return this._monthsShort;
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return this._weekdays;
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(203)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	
	            if (tZone === 0) {
	                this.utcOffset(0, true);
	            } else {
	                this.utcOffset(offsetFromString(matchOffset, this._i));
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.15.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(156)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reverseBytes = exports.sliceBytes = exports.bytesMatch = exports.concatTypedArrays = exports.stringToBytes = exports.bytesToString = exports.numberToBytes = exports.bytesToNumber = exports.IS_LITTLE_ENDIAN = exports.IS_BIG_ENDIAN = exports.ENDIANNESS = exports.toBinaryString = exports.toHexString = exports.toUint8 = exports.isTypedArray = exports.isArrayBufferView = exports.padStart = exports.countBytes = exports.countBits = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(2));
	
	// const log2 = Math.log2 ? Math.log2 : (x) => (Math.log(x) / Math.log(2));
	var repeat = function repeat(str, len) {
	  var acc = '';
	
	  while (len--) {
	    acc += str;
	  }
	
	  return acc;
	}; // count the number of bits it would take to represent a number
	// we used to do this with log2 but BigInt does not support builtin math
	// Math.ceil(log2(x));
	
	
	var countBits = function countBits(x) {
	  return x.toString(2).length;
	}; // count the number of whole bytes it would take to represent a number
	
	
	exports.countBits = countBits;
	
	var countBytes = function countBytes(x) {
	  return Math.ceil(countBits(x) / 8);
	};
	
	exports.countBytes = countBytes;
	
	var padStart = function padStart(b, len, str) {
	  if (str === void 0) {
	    str = ' ';
	  }
	
	  return (repeat(str, len) + b.toString()).slice(-len);
	};
	
	exports.padStart = padStart;
	
	var isArrayBufferView = function isArrayBufferView(obj) {
	  if (ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(obj);
	  }
	
	  return obj && obj.buffer instanceof ArrayBuffer;
	};
	
	exports.isArrayBufferView = isArrayBufferView;
	
	var isTypedArray = function isTypedArray(obj) {
	  return isArrayBufferView(obj);
	};
	
	exports.isTypedArray = isTypedArray;
	
	var toUint8 = function toUint8(bytes) {
	  if (bytes instanceof Uint8Array) {
	    return bytes;
	  }
	
	  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
	    // any non-number or NaN leads to empty uint8array
	    // eslint-disable-next-line
	    if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) {
	      bytes = 0;
	    } else {
	      bytes = [bytes];
	    }
	  }
	
	  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
	};
	
	exports.toUint8 = toUint8;
	
	var toHexString = function toHexString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(16), 2, '0');
	  }
	
	  return str;
	};
	
	exports.toHexString = toHexString;
	
	var toBinaryString = function toBinaryString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(2), 8, '0');
	  }
	
	  return str;
	};
	
	exports.toBinaryString = toBinaryString;
	var BigInt = _window.default.BigInt || Number;
	var BYTE_TABLE = [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	
	var ENDIANNESS = function () {
	  var a = new Uint16Array([0xFFCC]);
	  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
	
	  if (b[0] === 0xFF) {
	    return 'big';
	  }
	
	  if (b[0] === 0xCC) {
	    return 'little';
	  }
	
	  return 'unknown';
	}();
	
	exports.ENDIANNESS = ENDIANNESS;
	var IS_BIG_ENDIAN = ENDIANNESS === 'big';
	exports.IS_BIG_ENDIAN = IS_BIG_ENDIAN;
	var IS_LITTLE_ENDIAN = ENDIANNESS === 'little';
	exports.IS_LITTLE_ENDIAN = IS_LITTLE_ENDIAN;
	
	var bytesToNumber = function bytesToNumber(bytes, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$signed = _ref.signed,
	      signed = _ref$signed === void 0 ? false : _ref$signed,
	      _ref$le = _ref.le,
	      le = _ref$le === void 0 ? false : _ref$le;
	
	  bytes = toUint8(bytes);
	  var fn = le ? 'reduce' : 'reduceRight';
	  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
	  var number = obj.call(bytes, function (total, byte, i) {
	    var exponent = le ? i : Math.abs(i + 1 - bytes.length);
	    return total + BigInt(byte) * BYTE_TABLE[exponent];
	  }, BigInt(0));
	
	  if (signed) {
	    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
	    number = BigInt(number);
	
	    if (number > max) {
	      number -= max;
	      number -= max;
	      number -= BigInt(2);
	    }
	  }
	
	  return Number(number);
	};
	
	exports.bytesToNumber = bytesToNumber;
	
	var numberToBytes = function numberToBytes(number, _temp2) {
	  var _ref2 = _temp2 === void 0 ? {} : _temp2,
	      _ref2$le = _ref2.le,
	      le = _ref2$le === void 0 ? false : _ref2$le;
	
	  // eslint-disable-next-line
	  if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) {
	    number = 0;
	  }
	
	  number = BigInt(number);
	  var byteCount = countBytes(number);
	  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
	
	  for (var i = 0; i < byteCount; i++) {
	    var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
	    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(0xFF));
	
	    if (number < 0) {
	      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
	      bytes[byteIndex] -= i === 0 ? 1 : 2;
	    }
	  }
	
	  return bytes;
	};
	
	exports.numberToBytes = numberToBytes;
	
	var bytesToString = function bytesToString(bytes) {
	  if (!bytes) {
	    return '';
	  } // TODO: should toUint8 handle cases where we only have 8 bytes
	  // but report more since this is a Uint16+ Array?
	
	
	  bytes = Array.prototype.slice.call(bytes);
	  var string = String.fromCharCode.apply(null, toUint8(bytes));
	
	  try {
	    return decodeURIComponent(escape(string));
	  } catch (e) {// if decodeURIComponent/escape fails, we are dealing with partial
	    // or full non string data. Just return the potentially garbled string.
	  }
	
	  return string;
	};
	
	exports.bytesToString = bytesToString;
	
	var stringToBytes = function stringToBytes(string, stringIsBytes) {
	  if (typeof string !== 'string' && string && typeof string.toString === 'function') {
	    string = string.toString();
	  }
	
	  if (typeof string !== 'string') {
	    return new Uint8Array();
	  } // If the string already is bytes, we don't have to do this
	  // otherwise we do this so that we split multi length characters
	  // into individual bytes
	
	
	  if (!stringIsBytes) {
	    string = unescape(encodeURIComponent(string));
	  }
	
	  var view = new Uint8Array(string.length);
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view;
	};
	
	exports.stringToBytes = stringToBytes;
	
	var concatTypedArrays = function concatTypedArrays() {
	  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
	    buffers[_key] = arguments[_key];
	  }
	
	  buffers = buffers.filter(function (b) {
	    return b && (b.byteLength || b.length) && typeof b !== 'string';
	  });
	
	  if (buffers.length <= 1) {
	    // for 0 length we will return empty uint8
	    // for 1 length we return the first uint8
	    return toUint8(buffers[0]);
	  }
	
	  var totalLen = buffers.reduce(function (total, buf, i) {
	    return total + (buf.byteLength || buf.length);
	  }, 0);
	  var tempBuffer = new Uint8Array(totalLen);
	  var offset = 0;
	  buffers.forEach(function (buf) {
	    buf = toUint8(buf);
	    tempBuffer.set(buf, offset);
	    offset += buf.byteLength;
	  });
	  return tempBuffer;
	};
	/**
	 * Check if the bytes "b" are contained within bytes "a".
	 *
	 * @param {Uint8Array|Array} a
	 *        Bytes to check in
	 *
	 * @param {Uint8Array|Array} b
	 *        Bytes to check for
	 *
	 * @param {Object} options
	 *        options
	 *
	 * @param {Array|Uint8Array} [offset=0]
	 *        offset to use when looking at bytes in a
	 *
	 * @param {Array|Uint8Array} [mask=[]]
	 *        mask to use on bytes before comparison.
	 *
	 * @return {boolean}
	 *         If all bytes in b are inside of a, taking into account
	 *         bit masks.
	 */
	
	
	exports.concatTypedArrays = concatTypedArrays;
	
	var bytesMatch = function bytesMatch(a, b, _temp3) {
	  var _ref3 = _temp3 === void 0 ? {} : _temp3,
	      _ref3$offset = _ref3.offset,
	      offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
	      _ref3$mask = _ref3.mask,
	      mask = _ref3$mask === void 0 ? [] : _ref3$mask;
	
	  a = toUint8(a);
	  b = toUint8(b); // ie 11 does not support uint8 every
	
	  var fn = b.every ? b.every : Array.prototype.every;
	  return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
	  fn.call(b, function (bByte, i) {
	    var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
	    return bByte === aByte;
	  });
	};
	
	exports.bytesMatch = bytesMatch;
	
	var sliceBytes = function sliceBytes(src, start, end) {
	  if (Uint8Array.prototype.slice) {
	    return Uint8Array.prototype.slice.call(src, start, end);
	  }
	
	  return new Uint8Array(Array.prototype.slice.call(src, start, end));
	};
	
	exports.sliceBytes = sliceBytes;
	
	var reverseBytes = function reverseBytes(src) {
	  if (src.reverse) {
	    return src.reverse();
	  }
	
	  return Array.prototype.reverse.call(src);
	};
	
	exports.reverseBytes = reverseBytes;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var VersionCheck = __webpack_require__(138)
	var Regex = __webpack_require__(137)
	
	/**
	 * Numeric mode encodes data from the decimal digit set (0 - 9)
	 * (byte values 30HEX to 39HEX).
	 * Normally, 3 data characters are represented by 10 bits.
	 *
	 * @type {Object}
	 */
	exports.NUMERIC = {
	  id: 'Numeric',
	  bit: 1 << 0,
	  ccBits: [10, 12, 14]
	}
	
	/**
	 * Alphanumeric mode encodes data from a set of 45 characters,
	 * i.e. 10 numeric digits (0 - 9),
	 *      26 alphabetic characters (A - Z),
	 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
	 * Normally, two input characters are represented by 11 bits.
	 *
	 * @type {Object}
	 */
	exports.ALPHANUMERIC = {
	  id: 'Alphanumeric',
	  bit: 1 << 1,
	  ccBits: [9, 11, 13]
	}
	
	/**
	 * In byte mode, data is encoded at 8 bits per character.
	 *
	 * @type {Object}
	 */
	exports.BYTE = {
	  id: 'Byte',
	  bit: 1 << 2,
	  ccBits: [8, 16, 16]
	}
	
	/**
	 * The Kanji mode efficiently encodes Kanji characters in accordance with
	 * the Shift JIS system based on JIS X 0208.
	 * The Shift JIS values are shifted from the JIS X 0208 values.
	 * JIS X 0208 gives details of the shift coded representation.
	 * Each two-byte character value is compacted to a 13-bit binary codeword.
	 *
	 * @type {Object}
	 */
	exports.KANJI = {
	  id: 'Kanji',
	  bit: 1 << 3,
	  ccBits: [8, 10, 12]
	}
	
	/**
	 * Mixed mode will contain a sequences of data in a combination of any of
	 * the modes described above
	 *
	 * @type {Object}
	 */
	exports.MIXED = {
	  bit: -1
	}
	
	/**
	 * Returns the number of bits needed to store the data length
	 * according to QR Code specifications.
	 *
	 * @param  {Mode}   mode    Data mode
	 * @param  {Number} version QR Code version
	 * @return {Number}         Number of bits
	 */
	exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
	  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)
	
	  if (!VersionCheck.isValid(version)) {
	    throw new Error('Invalid version: ' + version)
	  }
	
	  if (version >= 1 && version < 10) return mode.ccBits[0]
	  else if (version < 27) return mode.ccBits[1]
	  return mode.ccBits[2]
	}
	
	/**
	 * Returns the most efficient mode to store the specified data
	 *
	 * @param  {String} dataStr Input data string
	 * @return {Mode}           Best mode
	 */
	exports.getBestModeForData = function getBestModeForData (dataStr) {
	  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
	  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
	  else if (Regex.testKanji(dataStr)) return exports.KANJI
	  else return exports.BYTE
	}
	
	/**
	 * Return mode name as string
	 *
	 * @param {Mode} mode Mode object
	 * @returns {String}  Mode name
	 */
	exports.toString = function toString (mode) {
	  if (mode && mode.id) return mode.id
	  throw new Error('Invalid mode')
	}
	
	/**
	 * Check if input param is a valid mode object
	 *
	 * @param   {Mode}    mode Mode object
	 * @returns {Boolean} True if valid mode, false otherwise
	 */
	exports.isValid = function isValid (mode) {
	  return mode && mode.bit && mode.ccBits
	}
	
	/**
	 * Get mode object from its name
	 *
	 * @param   {String} string Mode name
	 * @returns {Mode}          Mode object
	 */
	function fromString (string) {
	  if (typeof string !== 'string') {
	    throw new Error('Param is not a string')
	  }
	
	  var lcStr = string.toLowerCase()
	
	  switch (lcStr) {
	    case 'numeric':
	      return exports.NUMERIC
	    case 'alphanumeric':
	      return exports.ALPHANUMERIC
	    case 'kanji':
	      return exports.KANJI
	    case 'byte':
	      return exports.BYTE
	    default:
	      throw new Error('Unknown mode: ' + string)
	  }
	}
	
	/**
	 * Returns mode from a value.
	 * If value is not a valid mode, returns defaultValue
	 *
	 * @param  {Mode|String} value        Encoding mode
	 * @param  {Mode}        defaultValue Fallback value
	 * @return {Mode}                     Encoding mode
	 */
	exports.from = function from (value, defaultValue) {
	  if (exports.isValid(value)) {
	    return value
	  }
	
	  try {
	    return fromString(value)
	  } catch (e) {
	    return defaultValue
	  }
	}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var toSJISFunction
	var CODEWORDS_COUNT = [
	  0, // Not used
	  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
	  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
	  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
	  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
	]
	
	/**
	 * Returns the QR Code size for the specified version
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         size of QR code
	 */
	exports.getSymbolSize = function getSymbolSize (version) {
	  if (!version) throw new Error('"version" cannot be null or undefined')
	  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
	  return version * 4 + 17
	}
	
	/**
	 * Returns the total number of codewords used to store data and EC information.
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         Data length in bits
	 */
	exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
	  return CODEWORDS_COUNT[version]
	}
	
	/**
	 * Encode data with Bose-Chaudhuri-Hocquenghem
	 *
	 * @param  {Number} data Value to encode
	 * @return {Number}      Encoded value
	 */
	exports.getBCHDigit = function (data) {
	  var digit = 0
	
	  while (data !== 0) {
	    digit++
	    data >>>= 1
	  }
	
	  return digit
	}
	
	exports.setToSJISFunction = function setToSJISFunction (f) {
	  if (typeof f !== 'function') {
	    throw new Error('"toSJISFunc" is not a valid function.')
	  }
	
	  toSJISFunction = f
	}
	
	exports.isKanjiModeEnabled = function () {
	  return typeof toSJISFunction !== 'undefined'
	}
	
	exports.toSJIS = function toSJIS (kanji) {
	  return toSJISFunction(kanji)
	}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Implementation of a subset of node.js Buffer methods for the browser.
	 * Based on https://github.com/feross/buffer
	 */
	
	/* eslint-disable no-proto */
	
	'use strict'
	
	var isArray = __webpack_require__(14)
	
	function typedArraySupport () {
	  // Can typed array instances be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	
	function Buffer (arg, offset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, offset, length)
	  }
	
	  if (typeof arg === 'number') {
	    return allocUnsafe(this, arg)
	  }
	
	  return from(this, arg, offset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	
	  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true,
	      enumerable: false,
	      writable: false
	    })
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	function createBuffer (that, length) {
	  var buf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    buf = new Uint8Array(length)
	    buf.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    buf = that
	    if (buf === null) {
	      buf = new Buffer(length)
	    }
	    buf.length = length
	  }
	
	  return buf
	}
	
	function allocUnsafe (that, size) {
	  var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      buf[i] = 0
	    }
	  }
	
	  return buf
	}
	
	function fromString (that, string) {
	  var length = byteLength(string) | 0
	  var buf = createBuffer(that, length)
	
	  var actual = buf.write(string)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    buf.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    buf = fromArrayLike(that, buf)
	  }
	
	  return buf
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(that, len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function byteLength (string) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  return utf8ToBytes(string).length
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function from (that, value, offset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, offset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, offset)
	  }
	
	  return fromObject(that, value)
	}
	
	Buffer.prototype.write = function write (string, offset, length) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	    } else {
	      length = undefined
	    }
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  return utf8Write(this, string, offset, length)
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    // Return an augmented `Uint8Array` instance
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	Buffer.prototype.fill = function fill (val, start, end) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : new Buffer(val)
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return createBuffer(null, 0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = allocUnsafe(null, length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	Buffer.byteLength = byteLength
	
	Buffer.prototype._isBuffer = true
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	module.exports.alloc = function (size) {
	  var buffer = new Buffer(size)
	  buffer.fill(0)
	  return buffer
	}
	
	module.exports.from = function (data) {
	  return new Buffer(data)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11).Buffer))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict'
	
	/**
	 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
	 *
	 * Works with anything that has a `length` property and index access properties, including NodeList.
	 *
	 * @template {unknown} T
	 * @param {Array<T> | ({length:number, [number]: T})} list
	 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
	 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
	 * 				allows injecting a custom implementation in tests
	 * @returns {T | undefined}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
	 */
	function find(list, predicate, ac) {
		if (ac === undefined) {
			ac = Array.prototype;
		}
		if (list && typeof ac.find === 'function') {
			return ac.find.call(list, predicate);
		}
		for (var i = 0; i < list.length; i++) {
			if (Object.prototype.hasOwnProperty.call(list, i)) {
				var item = list[i];
				if (predicate.call(undefined, item, i, list)) {
					return item;
				}
			}
		}
	}
	
	/**
	 * "Shallow freezes" an object to render it immutable.
	 * Uses `Object.freeze` if available,
	 * otherwise the immutability is only in the type.
	 *
	 * Is used to create "enum like" objects.
	 *
	 * @template T
	 * @param {T} object the object to freeze
	 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
	 * 				allows to inject custom object constructor for tests
	 * @returns {Readonly<T>}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
	 */
	function freeze(object, oc) {
		if (oc === undefined) {
			oc = Object
		}
		return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object
	}
	
	/**
	 * Since we can not rely on `Object.assign` we provide a simplified version
	 * that is sufficient for our needs.
	 *
	 * @param {Object} target
	 * @param {Object | null | undefined} source
	 *
	 * @returns {Object} target
	 * @throws TypeError if target is not an object
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
	 */
	function assign(target, source) {
		if (target === null || typeof target !== 'object') {
			throw new TypeError('target is not an object')
		}
		for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key]
			}
		}
		return target
	}
	
	/**
	 * All mime types that are allowed as input to `DOMParser.parseFromString`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
	 * @see DOMParser.prototype.parseFromString
	 */
	var MIME_TYPE = freeze({
		/**
		 * `text/html`, the only mime type that triggers treating an XML document as HTML.
		 *
		 * @see DOMParser.SupportedType.isHTML
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
		 */
		HTML: 'text/html',
	
		/**
		 * Helper method to check a mime type if it indicates an HTML document
		 *
		 * @param {string} [value]
		 * @returns {boolean}
		 *
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
		isHTML: function (value) {
			return value === MIME_TYPE.HTML
		},
	
		/**
		 * `application/xml`, the standard mime type for XML documents.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
		 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_APPLICATION: 'application/xml',
	
		/**
		 * `text/html`, an alias for `application/xml`.
		 *
		 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
		 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_TEXT: 'text/xml',
	
		/**
		 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
		 * but is parsed as an XML document.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
		 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
		 */
		XML_XHTML_APPLICATION: 'application/xhtml+xml',
	
		/**
		 * `image/svg+xml`,
		 *
		 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
		 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
		 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
		 */
		XML_SVG_IMAGE: 'image/svg+xml',
	})
	
	/**
	 * Namespaces that are used in this code base.
	 *
	 * @see http://www.w3.org/TR/REC-xml-names
	 */
	var NAMESPACE = freeze({
		/**
		 * The XHTML namespace.
		 *
		 * @see http://www.w3.org/1999/xhtml
		 */
		HTML: 'http://www.w3.org/1999/xhtml',
	
		/**
		 * Checks if `uri` equals `NAMESPACE.HTML`.
		 *
		 * @param {string} [uri]
		 *
		 * @see NAMESPACE.HTML
		 */
		isHTML: function (uri) {
			return uri === NAMESPACE.HTML
		},
	
		/**
		 * The SVG namespace.
		 *
		 * @see http://www.w3.org/2000/svg
		 */
		SVG: 'http://www.w3.org/2000/svg',
	
		/**
		 * The `xml:` namespace.
		 *
		 * @see http://www.w3.org/XML/1998/namespace
		 */
		XML: 'http://www.w3.org/XML/1998/namespace',
	
		/**
		 * The `xmlns:` namespace
		 *
		 * @see https://www.w3.org/2000/xmlns/
		 */
		XMLNS: 'http://www.w3.org/2000/xmlns/',
	})
	
	exports.assign = assign;
	exports.find = find;
	exports.freeze = freeze;
	exports.MIME_TYPE = MIME_TYPE;
	exports.NAMESPACE = NAMESPACE;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(28)
	var ieee754 = __webpack_require__(31)
	var isArray = __webpack_require__(199)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*eslint-disable no-unused-vars*/
	/*!
	 * jQuery JavaScript Library v3.1.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-07-07T21:44Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.0
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-01-04
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true;
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
		// Known :disabled false positives:
		// IE: *[disabled]:not(button, input, select, textarea, optgroup, option, menuitem, fieldset)
		// not IE: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Check form elements and option elements for explicit disabling
			return "label" in elem && elem.disabled === disabled ||
				"form" in elem && elem.disabled === disabled ||
	
				// Check non-disabled form elements for fieldset[disabled] ancestors
				"form" in elem && elem.disabled === false && (
					// Support: IE6-11+
					// Ancestry is covered for us
					elem.isDisabled === disabled ||
	
					// Otherwise, assume any non-<option> under fieldset[disabled] is disabled
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						("label" in elem || !disabledAncestor( elem )) !== disabled
				);
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnotwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? JSON.parse( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) ),
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support: IE <=9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox <=42
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				return ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			opt.duration = typeof opt.duration === "number" ?
				opt.duration : opt.duration in jQuery.fx.speeds ?
					jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in uncached url if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rts, "" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	return jQuery;
	} );


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	exports.L = { bit: 1 }
	exports.M = { bit: 0 }
	exports.Q = { bit: 3 }
	exports.H = { bit: 2 }
	
	function fromString (string) {
	  if (typeof string !== 'string') {
	    throw new Error('Param is not a string')
	  }
	
	  var lcStr = string.toLowerCase()
	
	  switch (lcStr) {
	    case 'l':
	    case 'low':
	      return exports.L
	
	    case 'm':
	    case 'medium':
	      return exports.M
	
	    case 'q':
	    case 'quartile':
	      return exports.Q
	
	    case 'h':
	    case 'high':
	      return exports.H
	
	    default:
	      throw new Error('Unknown EC Level: ' + string)
	  }
	}
	
	exports.isValid = function isValid (level) {
	  return level && typeof level.bit !== 'undefined' &&
	    level.bit >= 0 && level.bit < 4
	}
	
	exports.from = function from (value, defaultValue) {
	  if (exports.isValid(value)) {
	    return value
	  }
	
	  try {
	    return fromString(value)
	  } catch (e) {
	    return defaultValue
	  }
	}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(319);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	function highlightDifferences(original, suggestion) {
	    // Create temporary elements to work with HTML
	    var originalDiv = document.createElement('div');
	    var suggestionDiv = document.createElement('div');
	    
	    // Store for shortcode mappings
	    var shortcodeMappings = {};
	    var counter = 0;
	    
	    // Function to create unique identifier (same as in helpersFunction.js)
	    function createPlaceholder(type) {
	        return '<span id="shortcode_' + type + '_' + (counter++) + '"></span>';
	    }
	    
	    // Replace shortcodes with placeholders
	    function replaceShortcodes(content) {
	        return content
	            // Handle caption blocks
	            .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, function(match) {
	                var placeholder = createPlaceholder('caption');
	                shortcodeMappings[placeholder] = match;
	                return placeholder;
	            })
	            // Handle gallery blocks
	            .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, function(match) {
	                var placeholder = createPlaceholder('gallery');
	                shortcodeMappings[placeholder] = match;
	                return placeholder;
	            })
	            // Handle embed blocks
	            .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, function(match) {
	                var placeholder = createPlaceholder('embed');
	                shortcodeMappings[placeholder] = match;
	                return placeholder;
	            });
	    }
	    
	    // Replace shortcodes in both original and suggestion
	    original = replaceShortcodes(original);
	    suggestion = replaceShortcodes(suggestion);
	    
	    // Preserve block elements inside paragraphs by wrapping them in a special container
	    function preserveBlockElements(content) {
	        return content.replace(/<p>([\s\S]*?)<\/p>/g, function(match, content) {
	            // If paragraph contains block elements, wrap them in a special container
	            if (/<(?:ul|ol)[^>]*>/i.test(content)) {
	                return '<div class="preserve-paragraph">' + content + '</div>';
	            }
	            return match;
	        });
	    }
	    
	    original = preserveBlockElements(original);
	    suggestion = preserveBlockElements(suggestion);
	    
	    originalDiv.innerHTML = original;
	    suggestionDiv.innerHTML = suggestion;
	
	    // Function to get text content with positions and parent elements
	    function getTextWithContext(element) {
	        var result = [];
	        
	        function traverse(node, parentPath) {
	            parentPath = parentPath || '';
	            
	            // Skip processing of shortcode placeholders
	            if (node.id && node.id.startsWith('shortcode_')) {
	                return;
	            }
	            
	            // Handle preserved paragraphs
	            if (node.classList && node.classList.contains('preserve-paragraph')) {
	                result.push({
	                    text: node.innerHTML,
	                    node: node,
	                    parentPath: parentPath,
	                    isPreserved: true
	                });
	                return;
	            }
	            
	            if (node.nodeType === Node.TEXT_NODE) {
	                var text = node.textContent;
	                if (text.trim()) {
	                    result.push({
	                        text: text,
	                        node: node,
	                        parentPath: parentPath
	                    });
	                }
	            }
	            if (node.childNodes) {
	                var currentPath = parentPath + (node.nodeName || '') + '>';
	                Array.from(node.childNodes).forEach(function(child) {
	                    traverse(child, currentPath);
	                });
	            }
	        }
	        
	        traverse(element);
	        return result;
	    }
	
	    // Get text content from both elements
	    var originalTexts = getTextWithContext(originalDiv);
	    var suggestionTexts = getTextWithContext(suggestionDiv);
	
	    // Function to normalize text for comparison
	    function normalizeText(text) {
	        return text.normalize('NFC'); // Normalize to composed form
	    }
	
	    // Compare and highlight differences
	    for (var i = 0; i < suggestionTexts.length; i++) {
	        var suggestionText = suggestionTexts[i];
	        var originalText = originalTexts[i];
	
	        // Skip processing for preserved content
	        if (suggestionText.isPreserved) {
	            continue;
	        }
	
	        if (!originalText || normalizeText(suggestionText.text) !== normalizeText(originalText.text)) {
	            // Use diff-match-patch to find differences
	            var dmp = new diff_match_patch();
	            var diffs = dmp.diff_main(
	                originalText ? normalizeText(originalText.text) : '', 
	                normalizeText(suggestionText.text)
	            );
	            dmp.diff_cleanupSemantic(diffs);
	
	            if (diffs.length > 0) {
	                var textNode = suggestionText.node;
	                if (textNode) {
	                    var parent = textNode.parentNode;
	                    var newNodes = [];
	
	                    diffs.forEach(function(diff) {
	                        if (diff[0] === 1) { // Insertion
	                            var span = document.createElement('span');
	                            span.className = 'diff';
	                            span.style.backgroundColor = '#a3e4a3';
	                            span.textContent = diff[1];
	                            newNodes.push(span);
	                        } else if (diff[0] === 0) { // Equal
	                            newNodes.push(document.createTextNode(diff[1]));
	                        }
	                    });
	
	                    // Replace the original node with new nodes
	                    newNodes.forEach(function(node) {
	                        parent.insertBefore(node, textNode);
	                    });
	                    parent.removeChild(textNode);
	                }
	            }
	        }
	    }
	
	    // Restore original shortcodes and paragraph structure
	    var result = suggestionDiv.innerHTML;
	    
	    // First restore shortcodes
	    Object.keys(shortcodeMappings).forEach(function(placeholder) {
	        result = result.replace(placeholder, shortcodeMappings[placeholder]);
	    });
	    
	    // Then restore paragraph structure
	    result = result.replace(/<div class="preserve-paragraph">([\s\S]*?)<\/div>/g, function(match, content) {
	        return '<p>' + content + '</p>';
	    });
	    
	    return result;
	}
	function cyrillicToLatin(content) {
	    // Serbian Cyrillic to Latin mapping
	    var cyrillicToLatin = {
	        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'ђ': 'đ', 'е': 'e', 'ж': 'ž', 'з': 'z',
	        'и': 'i', 'ј': 'j', 'к': 'k', 'л': 'l', 'љ': 'lj', 'м': 'm', 'н': 'n', 'њ': 'nj', 'о': 'o',
	        'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'ћ': 'ć', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
	        'ч': 'č', 'џ': 'dž', 'ш': 'š',
	        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Ђ': 'Đ', 'Е': 'E', 'Ж': 'Ž', 'З': 'Z',
	        'И': 'I', 'Ј': 'J', 'К': 'K', 'Л': 'L', 'Љ': 'Lj', 'М': 'M', 'Н': 'N', 'Њ': 'Nj', 'О': 'O',
	        'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'Ћ': 'Ć', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C',
	        'Ч': 'Č', 'Џ': 'Dž', 'Ш': 'Š'
	    };
	      
	    // Convert Cyrillic to Latin while preserving existing Latin characters
	    var latinContent = content.replace(/[а-шА-ШЂЉЊЋЏђљњћџ]/g, function(match) {
	        return cyrillicToLatin[match] || match;
	    });
	    return latinContent;
	}
	var shortcodeStore = {};
	function specifiedShortcodePlaceholderEditorContent(content, shortcodes) {
	    var placeholderCounter = 0;
	    shortcodeStore = {};
	    // Define which shortcodes to preserve
	    var preserveShortcodes = shortcodes;
	    // Create regex pattern for the specified shortcodes
	    var shortcodePattern = new RegExp('<(' + preserveShortcodes.join('|') + ')[^>]*>([\\s\\S]*?)<\\/\\1>', 'g');
	                
	    // Replace specified shortcodes with placeholders
	    content = content.replace(shortcodePattern, function(match, tag) {
	      var placeholder = 'SHORTCODE_PLACEHOLDER_' + placeholderCounter;
	      shortcodeStore[placeholder] = match;
	      placeholderCounter++;
	      return placeholder;
	    });
	    return content;
	}
	function specifiedShortcodeRestoreEditorContent(content) {
	   // Restore all other shortcodes
	   for (var placeholder in shortcodeStore) {
	    content = content.replace(placeholder, shortcodeStore[placeholder]);
	  }
	  return content;
	}
	
	module.exports = {
	    highlightDifferences: highlightDifferences,
	    cyrillicToLatin: cyrillicToLatin,
	    specifiedShortcodePlaceholderEditorContent: specifiedShortcodePlaceholderEditorContent,
	    specifiedShortcodeRestoreEditorContent: specifiedShortcodeRestoreEditorContent
	};
	


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var isNativeReflectConstruct = __webpack_require__(163);
	var setPrototypeOf = __webpack_require__(8);
	function _construct(t, e, r) {
	  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
	  var o = [null];
	  o.push.apply(o, e);
	  var p = new (t.bind.apply(t, o))();
	  return r && setPrototypeOf(p, r.prototype), p;
	}
	module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(8);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHvcCodec = exports.getAvcCodec = exports.getAv1Codec = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	// https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
	// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#AV1
	var getAv1Codec = function getAv1Codec(bytes) {
	  var codec = '';
	  var profile = bytes[1] >>> 3;
	  var level = bytes[1] & 0x1F;
	  var tier = bytes[2] >>> 7;
	  var highBitDepth = (bytes[2] & 0x40) >> 6;
	  var twelveBit = (bytes[2] & 0x20) >> 5;
	  var monochrome = (bytes[2] & 0x10) >> 4;
	  var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
	  var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
	  var chromaSamplePosition = bytes[2] & 0x03;
	  codec += profile + "." + (0, _byteHelpers.padStart)(level, 2, '0');
	
	  if (tier === 0) {
	    codec += 'M';
	  } else if (tier === 1) {
	    codec += 'H';
	  }
	
	  var bitDepth;
	
	  if (profile === 2 && highBitDepth) {
	    bitDepth = twelveBit ? 12 : 10;
	  } else {
	    bitDepth = highBitDepth ? 10 : 8;
	  }
	
	  codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0'); // TODO: can we parse color range??
	
	  codec += "." + monochrome;
	  codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
	  return codec;
	};
	
	exports.getAv1Codec = getAv1Codec;
	
	var getAvcCodec = function getAvcCodec(bytes) {
	  var profileId = (0, _byteHelpers.toHexString)(bytes[1]);
	  var constraintFlags = (0, _byteHelpers.toHexString)(bytes[2] & 0xFC);
	  var levelId = (0, _byteHelpers.toHexString)(bytes[3]);
	  return "" + profileId + constraintFlags + levelId;
	};
	
	exports.getAvcCodec = getAvcCodec;
	
	var getHvcCodec = function getHvcCodec(bytes) {
	  var codec = '';
	  var profileSpace = bytes[1] >> 6;
	  var profileId = bytes[1] & 0x1F;
	  var tierFlag = (bytes[1] & 0x20) >> 5;
	  var profileCompat = bytes.subarray(2, 6);
	  var constraintIds = bytes.subarray(6, 12);
	  var levelId = bytes[12];
	
	  if (profileSpace === 1) {
	    codec += 'A';
	  } else if (profileSpace === 2) {
	    codec += 'B';
	  } else if (profileSpace === 3) {
	    codec += 'C';
	  }
	
	  codec += profileId + "."; // ffmpeg does this in big endian
	
	  var profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...
	
	  if (profileCompatVal > 255) {
	    profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat), 2);
	  }
	
	  codec += profileCompatVal.toString(16) + ".";
	
	  if (tierFlag === 0) {
	    codec += 'L';
	  } else {
	    codec += 'H';
	  }
	
	  codec += levelId;
	  var constraints = '';
	
	  for (var i = 0; i < constraintIds.length; i++) {
	    var v = constraintIds[i];
	
	    if (v) {
	      if (constraints) {
	        constraints += '.';
	      }
	
	      constraints += v.toString(16);
	    }
	  }
	
	  if (constraints) {
	    codec += "." + constraints;
	  }
	
	  return codec;
	};
	
	exports.getHvcCodec = getHvcCodec;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = decodeB64ToUint8Array;
	
	var _window = _interopRequireDefault(__webpack_require__(2));
	
	var atob = function atob(s) {
	  return _window.default.atob ? _window.default.atob(s) : Buffer.from(s, 'base64').toString('binary');
	};
	
	function decodeB64ToUint8Array(b64Text) {
	  var decodedString = atob(b64Text);
	  var array = new Uint8Array(decodedString.length);
	
	  for (var i = 0; i < decodedString.length; i++) {
	    array[i] = decodedString.charCodeAt(i);
	  }
	
	  return array;
	}
	
	module.exports = exports.default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11).Buffer))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getId3Offset = exports.getId3Size = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	var ID3 = (0, _byteHelpers.toUint8)([0x49, 0x44, 0x33]);
	
	var getId3Size = function getId3Size(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var flags = bytes[offset + 5];
	  var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
	  var footerPresent = (flags & 16) >> 4;
	
	  if (footerPresent) {
	    return returnSize + 20;
	  }
	
	  return returnSize + 10;
	};
	
	exports.getId3Size = getId3Size;
	
	var getId3Offset = function getId3Offset(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  if (bytes.length - offset < 10 || !(0, _byteHelpers.bytesMatch)(bytes, ID3, {
	    offset: offset
	  })) {
	    return offset;
	  }
	
	  offset += getId3Size(bytes, offset); // recursive check for id3 tags as some files
	  // have multiple ID3 tag sections even though
	  // they should not.
	
	  return getId3Offset(bytes, offset);
	};
	
	exports.getId3Offset = getId3Offset;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _urlToolkit = _interopRequireDefault(__webpack_require__(416));
	
	var _window = _interopRequireDefault(__webpack_require__(2));
	
	var DEFAULT_LOCATION = 'http://example.com';
	
	var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
	  // return early if we don't need to resolve
	  if (/^[a-z]+:/i.test(relativeUrl)) {
	    return relativeUrl;
	  } // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
	
	
	  if (/^data:/.test(baseUrl)) {
	    baseUrl = _window.default.location && _window.default.location.href || '';
	  } // IE11 supports URL but not the URL constructor
	  // feature detect the behavior we want
	
	
	  var nativeURL = typeof _window.default.URL === 'function';
	  var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
	  // and if baseUrl isn't an absolute url
	
	  var removeLocation = !_window.default.location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
	
	  if (nativeURL) {
	    baseUrl = new _window.default.URL(baseUrl, _window.default.location || DEFAULT_LOCATION);
	  } else if (!/\/\//i.test(baseUrl)) {
	    baseUrl = _urlToolkit.default.buildAbsoluteURL(_window.default.location && _window.default.location.href || '', baseUrl);
	  }
	
	  if (nativeURL) {
	    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
	    // and if we're location-less, remove the location
	    // otherwise, return the url unmodified
	
	    if (removeLocation) {
	      return newUrl.href.slice(DEFAULT_LOCATION.length);
	    } else if (protocolLess) {
	      return newUrl.href.slice(newUrl.protocol.length);
	    }
	
	    return newUrl.href;
	  }
	
	  return _urlToolkit.default.buildAbsoluteURL(baseUrl, relativeUrl);
	};
	
	var _default = resolveUrl;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(9);
	
	var find = conventions.find;
	var NAMESPACE = conventions.NAMESPACE;
	
	/**
	 * A prerequisite for `[].filter`, to drop elements that are empty
	 * @param {string} input
	 * @returns {boolean}
	 */
	function notEmptyString (input) {
		return input !== ''
	}
	/**
	 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
	 * @see https://infra.spec.whatwg.org/#ascii-whitespace
	 *
	 * @param {string} input
	 * @returns {string[]} (can be empty)
	 */
	function splitOnASCIIWhitespace(input) {
		// U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
		return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : []
	}
	
	/**
	 * Adds element as a key to current if it is not already present.
	 *
	 * @param {Record<string, boolean | undefined>} current
	 * @param {string} element
	 * @returns {Record<string, boolean | undefined>}
	 */
	function orderedSetReducer (current, element) {
		if (!current.hasOwnProperty(element)) {
			current[element] = true;
		}
		return current;
	}
	
	/**
	 * @see https://infra.spec.whatwg.org/#ordered-set
	 * @param {string} input
	 * @returns {string[]}
	 */
	function toOrderedSet(input) {
		if (!input) return [];
		var list = splitOnASCIIWhitespace(input);
		return Object.keys(list.reduce(orderedSetReducer, {}))
	}
	
	/**
	 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
	 * which we can not rely on being available.
	 *
	 * @param {any[]} list
	 * @returns {function(any): boolean}
	 */
	function arrayIncludes (list) {
		return function(element) {
			return list && list.indexOf(element) !== -1;
		}
	}
	
	function copy(src,dest){
		for(var p in src){
			if (Object.prototype.hasOwnProperty.call(src, p)) {
				dest[p] = src[p];
			}
		}
	}
	
	/**
	^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
	^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
	 */
	function _extends(Class,Super){
		var pt = Class.prototype;
		if(!(pt instanceof Super)){
			function t(){};
			t.prototype = Super.prototype;
			t = new t();
			copy(pt,t);
			Class.prototype = pt = t;
		}
		if(pt.constructor != Class){
			if(typeof Class != 'function'){
				console.error("unknown Class:"+Class)
			}
			pt.constructor = Class
		}
	}
	
	// Node Types
	var NodeType = {}
	var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
	var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
	var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
	var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
	var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
	var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
	var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
	var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
	var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
	var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
	var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
	var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;
	
	// ExceptionCode
	var ExceptionCode = {}
	var ExceptionMessage = {};
	var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
	var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
	var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
	var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
	var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
	var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
	var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
	var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
	var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
	var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
	//level2
	var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
	var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
	var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
	var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
	var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);
	
	/**
	 * DOM Level 2
	 * Object DOMException
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
	 */
	function DOMException(code, message) {
		if(message instanceof Error){
			var error = message;
		}else{
			error = this;
			Error.call(this, ExceptionMessage[code]);
			this.message = ExceptionMessage[code];
			if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
		}
		error.code = code;
		if(message) this.message = this.message + ": " + message;
		return error;
	};
	DOMException.prototype = Error.prototype;
	copy(ExceptionCode,DOMException)
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
	 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
	 * The items in the NodeList are accessible via an integral index, starting from 0.
	 */
	function NodeList() {
	};
	NodeList.prototype = {
		/**
		 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
		 * @standard level1
		 */
		length:0,
		/**
		 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
		 * @standard level1
		 * @param index  unsigned long
		 *   Index into the collection.
		 * @return Node
		 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
		 */
		item: function(index) {
			return index >= 0 && index < this.length ? this[index] : null;
		},
		toString:function(isHTML,nodeFilter){
			for(var buf = [], i = 0;i<this.length;i++){
				serializeToString(this[i],buf,isHTML,nodeFilter);
			}
			return buf.join('');
		},
		/**
		 * @private
		 * @param {function (Node):boolean} predicate
		 * @returns {Node[]}
		 */
		filter: function (predicate) {
			return Array.prototype.filter.call(this, predicate);
		},
		/**
		 * @private
		 * @param {Node} item
		 * @returns {number}
		 */
		indexOf: function (item) {
			return Array.prototype.indexOf.call(this, item);
		},
	};
	
	function LiveNodeList(node,refresh){
		this._node = node;
		this._refresh = refresh
		_updateLiveList(this);
	}
	function _updateLiveList(list){
		var inc = list._node._inc || list._node.ownerDocument._inc;
		if (list._inc !== inc) {
			var ls = list._refresh(list._node);
			__set__(list,'length',ls.length);
			if (!list.$$length || ls.length < list.$$length) {
				for (var i = ls.length; i in list; i++) {
					if (Object.prototype.hasOwnProperty.call(list, i)) {
						delete list[i];
					}
				}
			}
			copy(ls,list);
			list._inc = inc;
		}
	}
	LiveNodeList.prototype.item = function(i){
		_updateLiveList(this);
		return this[i] || null;
	}
	
	_extends(LiveNodeList,NodeList);
	
	/**
	 * Objects implementing the NamedNodeMap interface are used
	 * to represent collections of nodes that can be accessed by name.
	 * Note that NamedNodeMap does not inherit from NodeList;
	 * NamedNodeMaps are not maintained in any particular order.
	 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
	 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
	 * and does not imply that the DOM specifies an order to these Nodes.
	 * NamedNodeMap objects in the DOM are live.
	 * used for attributes or DocumentType entities
	 */
	function NamedNodeMap() {
	};
	
	function _findNodeIndex(list,node){
		var i = list.length;
		while(i--){
			if(list[i] === node){return i}
		}
	}
	
	function _addNamedNode(el,list,newAttr,oldAttr){
		if(oldAttr){
			list[_findNodeIndex(list,oldAttr)] = newAttr;
		}else{
			list[list.length++] = newAttr;
		}
		if(el){
			newAttr.ownerElement = el;
			var doc = el.ownerDocument;
			if(doc){
				oldAttr && _onRemoveAttribute(doc,el,oldAttr);
				_onAddAttribute(doc,el,newAttr);
			}
		}
	}
	function _removeNamedNode(el,list,attr){
		//console.log('remove attr:'+attr)
		var i = _findNodeIndex(list,attr);
		if(i>=0){
			var lastIndex = list.length-1
			while(i<lastIndex){
				list[i] = list[++i]
			}
			list.length = lastIndex;
			if(el){
				var doc = el.ownerDocument;
				if(doc){
					_onRemoveAttribute(doc,el,attr);
					attr.ownerElement = null;
				}
			}
		}else{
			throw new DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
		}
	}
	NamedNodeMap.prototype = {
		length:0,
		item:NodeList.prototype.item,
		getNamedItem: function(key) {
	//		if(key.indexOf(':')>0 || key == 'xmlns'){
	//			return null;
	//		}
			//console.log()
			var i = this.length;
			while(i--){
				var attr = this[i];
				//console.log(attr.nodeName,key)
				if(attr.nodeName == key){
					return attr;
				}
			}
		},
		setNamedItem: function(attr) {
			var el = attr.ownerElement;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			var oldAttr = this.getNamedItem(attr.nodeName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
		/* returns Node */
		setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
			var el = attr.ownerElement, oldAttr;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
	
		/* returns Node */
		removeNamedItem: function(key) {
			var attr = this.getNamedItem(key);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
	
	
		},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
	
		//for level2
		removeNamedItemNS:function(namespaceURI,localName){
			var attr = this.getNamedItemNS(namespaceURI,localName);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
		},
		getNamedItemNS: function(namespaceURI, localName) {
			var i = this.length;
			while(i--){
				var node = this[i];
				if(node.localName == localName && node.namespaceURI == namespaceURI){
					return node;
				}
			}
			return null;
		}
	};
	
	/**
	 * The DOMImplementation interface represents an object providing methods
	 * which are not dependent on any particular document.
	 * Such an object is returned by the `Document.implementation` property.
	 *
	 * __The individual methods describe the differences compared to the specs.__
	 *
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
	 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
	 */
	function DOMImplementation() {
	}
	
	DOMImplementation.prototype = {
		/**
		 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
		 * The different implementations fairly diverged in what kind of features were reported.
		 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
		 *
		 * @deprecated It is deprecated and modern browsers return true in all cases.
		 *
		 * @param {string} feature
		 * @param {string} [version]
		 * @returns {boolean} always true
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
		 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
		 */
		hasFeature: function(feature, version) {
				return true;
		},
		/**
		 * Creates an XML Document object of the specified type with its document element.
		 *
		 * __It behaves slightly different from the description in the living standard__:
		 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
		 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string|null} namespaceURI
		 * @param {string} qualifiedName
		 * @param {DocumentType=null} doctype
		 * @returns {Document}
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocument: function(namespaceURI,  qualifiedName, doctype){
			var doc = new Document();
			doc.implementation = this;
			doc.childNodes = new NodeList();
			doc.doctype = doctype || null;
			if (doctype){
				doc.appendChild(doctype);
			}
			if (qualifiedName){
				var root = doc.createElementNS(namespaceURI, qualifiedName);
				doc.appendChild(root);
			}
			return doc;
		},
		/**
		 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
		 *
		 * __This behavior is slightly different from the in the specs__:
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string} qualifiedName
		 * @param {string} [publicId]
		 * @param {string} [systemId]
		 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
		 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocumentType: function(qualifiedName, publicId, systemId){
			var node = new DocumentType();
			node.name = qualifiedName;
			node.nodeName = qualifiedName;
			node.publicId = publicId || '';
			node.systemId = systemId || '';
	
			return node;
		}
	};
	
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
	 */
	
	function Node() {
	};
	
	Node.prototype = {
		firstChild : null,
		lastChild : null,
		previousSibling : null,
		nextSibling : null,
		attributes : null,
		parentNode : null,
		childNodes : null,
		ownerDocument : null,
		nodeValue : null,
		namespaceURI : null,
		prefix : null,
		localName : null,
		// Modified in DOM Level 2:
		insertBefore:function(newChild, refChild){//raises
			return _insertBefore(this,newChild,refChild);
		},
		replaceChild:function(newChild, oldChild){//raises
			_insertBefore(this, newChild,oldChild, assertPreReplacementValidityInDocument);
			if(oldChild){
				this.removeChild(oldChild);
			}
		},
		removeChild:function(oldChild){
			return _removeChild(this,oldChild);
		},
		appendChild:function(newChild){
			return this.insertBefore(newChild,null);
		},
		hasChildNodes:function(){
			return this.firstChild != null;
		},
		cloneNode:function(deep){
			return cloneNode(this.ownerDocument||this,this,deep);
		},
		// Modified in DOM Level 2:
		normalize:function(){
			var child = this.firstChild;
			while(child){
				var next = child.nextSibling;
				if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
					this.removeChild(next);
					child.appendData(next.data);
				}else{
					child.normalize();
					child = next;
				}
			}
		},
	  	// Introduced in DOM Level 2:
		isSupported:function(feature, version){
			return this.ownerDocument.implementation.hasFeature(feature,version);
		},
	    // Introduced in DOM Level 2:
	    hasAttributes:function(){
	    	return this.attributes.length>0;
	    },
		/**
		 * Look up the prefix associated to the given namespace URI, starting from this node.
		 * **The default namespace declarations are ignored by this method.**
		 * See Namespace Prefix Lookup for details on the algorithm used by this method.
		 *
		 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
		 *
		 * @param {string | null} namespaceURI
		 * @returns {string | null}
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
		 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
		 * @see https://github.com/xmldom/xmldom/issues/322
		 */
	    lookupPrefix:function(namespaceURI){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			for(var n in map){
							if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
								return n;
							}
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    lookupNamespaceURI:function(prefix){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			if(Object.prototype.hasOwnProperty.call(map, prefix)){
	    				return map[prefix] ;
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    isDefaultNamespace:function(namespaceURI){
	    	var prefix = this.lookupPrefix(namespaceURI);
	    	return prefix == null;
	    }
	};
	
	
	function _xmlEncoder(c){
		return c == '<' && '&lt;' ||
	         c == '>' && '&gt;' ||
	         c == '&' && '&amp;' ||
	         c == '"' && '&quot;' ||
	         '&#'+c.charCodeAt()+';'
	}
	
	
	copy(NodeType,Node);
	copy(NodeType,Node.prototype);
	
	/**
	 * @param callback return true for continue,false for break
	 * @return boolean true: break visit;
	 */
	function _visitNode(node,callback){
		if(callback(node)){
			return true;
		}
		if(node = node.firstChild){
			do{
				if(_visitNode(node,callback)){return true}
	        }while(node=node.nextSibling)
	    }
	}
	
	
	
	function Document(){
		this.ownerDocument = this;
	}
	
	function _onAddAttribute(doc,el,newAttr){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
		}
	}
	
	function _onRemoveAttribute(doc,el,newAttr,remove){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			delete el._nsMap[newAttr.prefix?newAttr.localName:'']
		}
	}
	
	/**
	 * Updates `el.childNodes`, updating the indexed items and it's `length`.
	 * Passing `newChild` means it will be appended.
	 * Otherwise it's assumed that an item has been removed,
	 * and `el.firstNode` and it's `.nextSibling` are used
	 * to walk the current list of child nodes.
	 *
	 * @param {Document} doc
	 * @param {Node} el
	 * @param {Node} [newChild]
	 * @private
	 */
	function _onUpdateChild (doc, el, newChild) {
		if(doc && doc._inc){
			doc._inc++;
			//update childNodes
			var cs = el.childNodes;
			if (newChild) {
				cs[cs.length++] = newChild;
			} else {
				var child = el.firstChild;
				var i = 0;
				while (child) {
					cs[i++] = child;
					child = child.nextSibling;
				}
				cs.length = i;
				delete cs[cs.length];
			}
		}
	}
	
	/**
	 * Removes the connections between `parentNode` and `child`
	 * and any existing `child.previousSibling` or `child.nextSibling`.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 *
	 * @param {Node} parentNode
	 * @param {Node} child
	 * @returns {Node} the child that was removed.
	 * @private
	 */
	function _removeChild (parentNode, child) {
		var previous = child.previousSibling;
		var next = child.nextSibling;
		if (previous) {
			previous.nextSibling = next;
		} else {
			parentNode.firstChild = next;
		}
		if (next) {
			next.previousSibling = previous;
		} else {
			parentNode.lastChild = previous;
		}
		child.parentNode = null;
		child.previousSibling = null;
		child.nextSibling = null;
		_onUpdateChild(parentNode.ownerDocument, parentNode);
		return child;
	}
	
	/**
	 * Returns `true` if `node` can be a parent for insertion.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasValidParentNodeType(node) {
		return (
			node &&
			(node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE)
		);
	}
	
	/**
	 * Returns `true` if `node` can be inserted according to it's `nodeType`.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasInsertableNodeType(node) {
		return (
			node &&
			(isElementNode(node) ||
				isTextNode(node) ||
				isDocTypeNode(node) ||
				node.nodeType === Node.DOCUMENT_FRAGMENT_NODE ||
				node.nodeType === Node.COMMENT_NODE ||
				node.nodeType === Node.PROCESSING_INSTRUCTION_NODE)
		);
	}
	
	/**
	 * Returns true if `node` is a DOCTYPE node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isDocTypeNode(node) {
		return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
	}
	
	/**
	 * Returns true if the node is an element
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isElementNode(node) {
		return node && node.nodeType === Node.ELEMENT_NODE;
	}
	/**
	 * Returns true if `node` is a text node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isTextNode(node) {
		return node && node.nodeType === Node.TEXT_NODE;
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Document} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementInsertionPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
		if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Node} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementReplacementPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
	
		function hasElementChildThatIsNotChild(node) {
			return isElementNode(node) && node !== child;
		}
	
		if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * @private
	 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
	 *
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidity1to5(parent, node, child) {
		// 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
		if (!hasValidParentNodeType(parent)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
		}
		// 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
		// not implemented!
		// 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
		if (child && child.parentNode !== parent) {
			throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
		}
		if (
			// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
			!hasInsertableNodeType(node) ||
			// 5. If either `node` is a Text node and `parent` is a document,
			// the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
			// || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
			// or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
			(isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE)
		) {
			throw new DOMException(
				HIERARCHY_REQUEST_ERR,
				'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType
			);
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If node has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child,
			// `child` is a doctype, or `child` is non-null and a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child, `child` is a doctype,
			// or `child` is non-null and a doctype is following `child`.
			if (!isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			// `parent` has a doctype child,
			if (find(parentChildNodes, isDocTypeNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// `child` is non-null and an element is preceding `child`,
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
			// or `child` is null and `parent` has an element child.
			if (!child && parentElementChild) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
			}
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreReplacementValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If `node` has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child that is not `child` or a doctype is following `child`.
			if (!isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			function hasDoctypeChildThatIsNotChild(node) {
				return isDocTypeNode(node) && node !== child;
			}
	
			// `parent` has a doctype child that is not `child`,
			if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// or an element is preceding `child`.
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
		}
	}
	
	/**
	 * @private
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function _insertBefore(parent, node, child, _inDocumentAssertion) {
		// To ensure pre-insertion validity of a node into a parent before a child, run these steps:
		assertPreInsertionValidity1to5(parent, node, child);
	
		// If parent is a document, and any of the statements below, switched on the interface node implements,
		// are true, then throw a "HierarchyRequestError" DOMException.
		if (parent.nodeType === Node.DOCUMENT_NODE) {
			(_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
		}
	
		var cp = node.parentNode;
		if(cp){
			cp.removeChild(node);//remove and update
		}
		if(node.nodeType === DOCUMENT_FRAGMENT_NODE){
			var newFirst = node.firstChild;
			if (newFirst == null) {
				return node;
			}
			var newLast = node.lastChild;
		}else{
			newFirst = newLast = node;
		}
		var pre = child ? child.previousSibling : parent.lastChild;
	
		newFirst.previousSibling = pre;
		newLast.nextSibling = child;
	
	
		if(pre){
			pre.nextSibling = newFirst;
		}else{
			parent.firstChild = newFirst;
		}
		if(child == null){
			parent.lastChild = newLast;
		}else{
			child.previousSibling = newLast;
		}
		do{
			newFirst.parentNode = parent;
			// Update ownerDocument for each node being inserted
			var targetDoc = parent.ownerDocument || parent;
			_updateOwnerDocument(newFirst, targetDoc);
		}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
		_onUpdateChild(parent.ownerDocument||parent, parent);
		//console.log(parent.lastChild.nextSibling == null)
		if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
			node.firstChild = node.lastChild = null;
		}
		return node;
	}
	
	/**
	 * Recursively updates the ownerDocument property for a node and all its descendants
	 * @param {Node} node
	 * @param {Document} newOwnerDocument
	 * @private
	 */
	function _updateOwnerDocument(node, newOwnerDocument) {
		if (node.ownerDocument === newOwnerDocument) {
			return;
		}
		
		node.ownerDocument = newOwnerDocument;
		
		// Update attributes if this is an element
		if (node.nodeType === ELEMENT_NODE && node.attributes) {
			for (var i = 0; i < node.attributes.length; i++) {
				var attr = node.attributes.item(i);
				if (attr) {
					attr.ownerDocument = newOwnerDocument;
				}
			}
		}
		
		// Recursively update child nodes
		var child = node.firstChild;
		while (child) {
			_updateOwnerDocument(child, newOwnerDocument);
			child = child.nextSibling;
		}
	}
	
	/**
	 * Appends `newChild` to `parentNode`.
	 * If `newChild` is already connected to a `parentNode` it is first removed from it.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 * @param {Node} parentNode
	 * @param {Node} newChild
	 * @returns {Node}
	 * @private
	 */
	function _appendSingleChild (parentNode, newChild) {
		if (newChild.parentNode) {
			newChild.parentNode.removeChild(newChild);
		}
		newChild.parentNode = parentNode;
		newChild.previousSibling = parentNode.lastChild;
		newChild.nextSibling = null;
		if (newChild.previousSibling) {
			newChild.previousSibling.nextSibling = newChild;
		} else {
			parentNode.firstChild = newChild;
		}
		parentNode.lastChild = newChild;
		_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
		
		// Update ownerDocument for the new child and all its descendants
		var targetDoc = parentNode.ownerDocument || parentNode;
		_updateOwnerDocument(newChild, targetDoc);
		
		return newChild;
	}
	
	Document.prototype = {
		//implementation : null,
		nodeName :  '#document',
		nodeType :  DOCUMENT_NODE,
		/**
		 * The DocumentType node of the document.
		 *
		 * @readonly
		 * @type DocumentType
		 */
		doctype :  null,
		documentElement :  null,
		_inc : 1,
	
		insertBefore :  function(newChild, refChild){//raises
			if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
				var child = newChild.firstChild;
				while(child){
					var next = child.nextSibling;
					this.insertBefore(child,refChild);
					child = next;
				}
				return newChild;
			}
			_insertBefore(this, newChild, refChild);
			_updateOwnerDocument(newChild, this);
			if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
				this.documentElement = newChild;
			}
	
			return newChild;
		},
		removeChild :  function(oldChild){
			if(this.documentElement == oldChild){
				this.documentElement = null;
			}
			return _removeChild(this,oldChild);
		},
		replaceChild: function (newChild, oldChild) {
			//raises
			_insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
			_updateOwnerDocument(newChild, this);
			if (oldChild) {
				this.removeChild(oldChild);
			}
			if (isElementNode(newChild)) {
				this.documentElement = newChild;
			}
		},
		// Introduced in DOM Level 2:
		importNode : function(importedNode,deep){
			return importNode(this,importedNode,deep);
		},
		// Introduced in DOM Level 2:
		getElementById :	function(id){
			var rtv = null;
			_visitNode(this.documentElement,function(node){
				if(node.nodeType == ELEMENT_NODE){
					if(node.getAttribute('id') == id){
						rtv = node;
						return true;
					}
				}
			})
			return rtv;
		},
	
		/**
		 * The `getElementsByClassName` method of `Document` interface returns an array-like object
		 * of all child elements which have **all** of the given class name(s).
		 *
		 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
		 *
		 *
		 * Warning: This is a live LiveNodeList.
		 * Changes in the DOM will reflect in the array as the changes occur.
		 * If an element selected by this array no longer qualifies for the selector,
		 * it will automatically be removed. Be aware of this for iteration purposes.
		 *
		 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
		 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
		 */
		getElementsByClassName: function(classNames) {
			var classNamesSet = toOrderedSet(classNames)
			return new LiveNodeList(this, function(base) {
				var ls = [];
				if (classNamesSet.length > 0) {
					_visitNode(base.documentElement, function(node) {
						if(node !== base && node.nodeType === ELEMENT_NODE) {
							var nodeClassNames = node.getAttribute('class')
							// can be null if the attribute does not exist
							if (nodeClassNames) {
								// before splitting and iterating just compare them for the most common case
								var matches = classNames === nodeClassNames;
								if (!matches) {
									var nodeClassNamesSet = toOrderedSet(nodeClassNames)
									matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet))
								}
								if(matches) {
									ls.push(node);
								}
							}
						}
					});
				}
				return ls;
			});
		},
	
		//document factory method:
		createElement :	function(tagName){
			var node = new Element();
			node.ownerDocument = this;
			node.nodeName = tagName;
			node.tagName = tagName;
			node.localName = tagName;
			node.childNodes = new NodeList();
			var attrs	= node.attributes = new NamedNodeMap();
			attrs._ownerElement = node;
			return node;
		},
		createDocumentFragment :	function(){
			var node = new DocumentFragment();
			node.ownerDocument = this;
			node.childNodes = new NodeList();
			return node;
		},
		createTextNode :	function(data){
			var node = new Text();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createComment :	function(data){
			var node = new Comment();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createCDATASection :	function(data){
			var node = new CDATASection();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createProcessingInstruction :	function(target,data){
			var node = new ProcessingInstruction();
			node.ownerDocument = this;
			node.tagName = node.nodeName = node.target = target;
			node.nodeValue = node.data = data;
			return node;
		},
		createAttribute :	function(name){
			var node = new Attr();
			node.ownerDocument	= this;
			node.name = name;
			node.nodeName	= name;
			node.localName = name;
			node.specified = true;
			return node;
		},
		createEntityReference :	function(name){
			var node = new EntityReference();
			node.ownerDocument	= this;
			node.nodeName	= name;
			return node;
		},
		// Introduced in DOM Level 2:
		createElementNS :	function(namespaceURI,qualifiedName){
			var node = new Element();
			var pl = qualifiedName.split(':');
			var attrs	= node.attributes = new NamedNodeMap();
			node.childNodes = new NodeList();
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.tagName = qualifiedName;
			node.namespaceURI = namespaceURI;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			attrs._ownerElement = node;
			return node;
		},
		// Introduced in DOM Level 2:
		createAttributeNS :	function(namespaceURI,qualifiedName){
			var node = new Attr();
			var pl = qualifiedName.split(':');
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.name = qualifiedName;
			node.namespaceURI = namespaceURI;
			node.specified = true;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			return node;
		}
	};
	_extends(Document,Node);
	
	
	function Element() {
		this._nsMap = {};
	};
	Element.prototype = {
		nodeType : ELEMENT_NODE,
		hasAttribute : function(name){
			return this.getAttributeNode(name)!=null;
		},
		getAttribute : function(name){
			var attr = this.getAttributeNode(name);
			return attr && attr.value || '';
		},
		getAttributeNode : function(name){
			return this.attributes.getNamedItem(name);
		},
		setAttribute : function(name, value){
			var attr = this.ownerDocument.createAttribute(name);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		removeAttribute : function(name){
			var attr = this.getAttributeNode(name)
			attr && this.removeAttributeNode(attr);
		},
	
		//four real opeartion method
		appendChild:function(newChild){
			if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
				return this.insertBefore(newChild,null);
			}else{
				return _appendSingleChild(this,newChild);
			}
		},
		setAttributeNode : function(newAttr){
			return this.attributes.setNamedItem(newAttr);
		},
		setAttributeNodeNS : function(newAttr){
			return this.attributes.setNamedItemNS(newAttr);
		},
		removeAttributeNode : function(oldAttr){
			//console.log(this == oldAttr.ownerElement)
			return this.attributes.removeNamedItem(oldAttr.nodeName);
		},
		//get real attribute name,and remove it by removeAttributeNode
		removeAttributeNS : function(namespaceURI, localName){
			var old = this.getAttributeNodeNS(namespaceURI, localName);
			old && this.removeAttributeNode(old);
		},
	
		hasAttributeNS : function(namespaceURI, localName){
			return this.getAttributeNodeNS(namespaceURI, localName)!=null;
		},
		getAttributeNS : function(namespaceURI, localName){
			var attr = this.getAttributeNodeNS(namespaceURI, localName);
			return attr && attr.value || '';
		},
		setAttributeNS : function(namespaceURI, qualifiedName, value){
			var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		getAttributeNodeNS : function(namespaceURI, localName){
			return this.attributes.getNamedItemNS(namespaceURI, localName);
		},
	
		getElementsByTagName : function(tagName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
						ls.push(node);
					}
				});
				return ls;
			});
		},
		getElementsByTagNameNS : function(namespaceURI, localName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
						ls.push(node);
					}
				});
				return ls;
	
			});
		}
	};
	Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
	Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
	
	
	_extends(Element,Node);
	function Attr() {
	};
	Attr.prototype.nodeType = ATTRIBUTE_NODE;
	_extends(Attr,Node);
	
	
	function CharacterData() {
	};
	CharacterData.prototype = {
		data : '',
		substringData : function(offset, count) {
			return this.data.substring(offset, offset+count);
		},
		appendData: function(text) {
			text = this.data+text;
			this.nodeValue = this.data = text;
			this.length = text.length;
		},
		insertData: function(offset,text) {
			this.replaceData(offset,0,text);
	
		},
		appendChild:function(newChild){
			throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
		},
		deleteData: function(offset, count) {
			this.replaceData(offset,count,"");
		},
		replaceData: function(offset, count, text) {
			var start = this.data.substring(0,offset);
			var end = this.data.substring(offset+count);
			text = start + text + end;
			this.nodeValue = this.data = text;
			this.length = text.length;
		}
	}
	_extends(CharacterData,Node);
	function Text() {
	};
	Text.prototype = {
		nodeName : "#text",
		nodeType : TEXT_NODE,
		splitText : function(offset) {
			var text = this.data;
			var newText = text.substring(offset);
			text = text.substring(0, offset);
			this.data = this.nodeValue = text;
			this.length = text.length;
			var newNode = this.ownerDocument.createTextNode(newText);
			if(this.parentNode){
				this.parentNode.insertBefore(newNode, this.nextSibling);
			}
			return newNode;
		}
	}
	_extends(Text,CharacterData);
	function Comment() {
	};
	Comment.prototype = {
		nodeName : "#comment",
		nodeType : COMMENT_NODE
	}
	_extends(Comment,CharacterData);
	
	function CDATASection() {
	};
	CDATASection.prototype = {
		nodeName : "#cdata-section",
		nodeType : CDATA_SECTION_NODE
	}
	_extends(CDATASection,CharacterData);
	
	
	function DocumentType() {
	};
	DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
	_extends(DocumentType,Node);
	
	function Notation() {
	};
	Notation.prototype.nodeType = NOTATION_NODE;
	_extends(Notation,Node);
	
	function Entity() {
	};
	Entity.prototype.nodeType = ENTITY_NODE;
	_extends(Entity,Node);
	
	function EntityReference() {
	};
	EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
	_extends(EntityReference,Node);
	
	function DocumentFragment() {
	};
	DocumentFragment.prototype.nodeName =	"#document-fragment";
	DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
	_extends(DocumentFragment,Node);
	
	
	function ProcessingInstruction() {
	}
	ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
	_extends(ProcessingInstruction,Node);
	function XMLSerializer(){}
	XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
		return nodeSerializeToString.call(node,isHtml,nodeFilter);
	}
	Node.prototype.toString = nodeSerializeToString;
	function nodeSerializeToString(isHtml,nodeFilter){
		var buf = [];
		var refNode = this.nodeType == 9 && this.documentElement || this;
		var prefix = refNode.prefix;
		var uri = refNode.namespaceURI;
	
		if(uri && prefix == null){
			//console.log(prefix)
			var prefix = refNode.lookupPrefix(uri);
			if(prefix == null){
				//isHTML = true;
				var visibleNamespaces=[
				{namespace:uri,prefix:null}
				//{namespace:uri,prefix:''}
				]
			}
		}
		serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
		//console.log('###',this.nodeType,uri,prefix,buf.join(''))
		return buf.join('');
	}
	
	function needNamespaceDefine(node, isHTML, visibleNamespaces) {
		var prefix = node.prefix || '';
		var uri = node.namespaceURI;
		// According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
		// and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
		// > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
		// in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
		// and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
		// > [...] Furthermore, the attribute value [...] must not be an empty string.
		// so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
		if (!uri) {
			return false;
		}
		if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
			return false;
		}
	
		var i = visibleNamespaces.length
		while (i--) {
			var ns = visibleNamespaces[i];
			// get namespace prefix
			if (ns.prefix === prefix) {
				return ns.namespace !== uri;
			}
		}
		return true;
	}
	/**
	 * Well-formed constraint: No < in Attribute Values
	 * > The replacement text of any entity referred to directly or indirectly
	 * > in an attribute value must not contain a <.
	 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
	 * @see https://www.w3.org/TR/xml11/#NT-AttValue
	 *
	 * Literal whitespace other than space that appear in attribute values
	 * are serialized as their entity references, so they will be preserved.
	 * (In contrast to whitespace literals in the input which are normalized to spaces)
	 * @see https://www.w3.org/TR/xml11/#AVNormalize
	 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
	 */
	function addSerializedAttribute(buf, qualifiedName, value) {
		buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"')
	}
	
	function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
		if (!visibleNamespaces) {
			visibleNamespaces = [];
		}
	
		if(nodeFilter){
			node = nodeFilter(node);
			if(node){
				if(typeof node == 'string'){
					buf.push(node);
					return;
				}
			}else{
				return;
			}
			//buf.sort.apply(attrs, attributeSorter);
		}
	
		switch(node.nodeType){
		case ELEMENT_NODE:
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;
	
			isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML
	
			var prefixedNodeName = nodeName
			if (!isHTML && !node.prefix && node.namespaceURI) {
				var defaultNS
				// lookup current default ns from `xmlns` attribute
				for (var ai = 0; ai < attrs.length; ai++) {
					if (attrs.item(ai).name === 'xmlns') {
						defaultNS = attrs.item(ai).value
						break
					}
				}
				if (!defaultNS) {
					// lookup current default ns in visibleNamespaces
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
							defaultNS = namespace.namespace
							break
						}
					}
				}
				if (defaultNS !== node.namespaceURI) {
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.namespace === node.namespaceURI) {
							if (namespace.prefix) {
								prefixedNodeName = namespace.prefix + ':' + nodeName
							}
							break
						}
					}
				}
			}
	
			buf.push('<', prefixedNodeName);
	
			for(var i=0;i<len;i++){
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				}else if(attr.nodeName == 'xmlns'){
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
	
			for(var i=0;i<len;i++){
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
					var prefix = attr.prefix||'';
					var uri = attr.namespaceURI;
					addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
				serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
			}
	
			// add namespace for current node
			if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
				var prefix = node.prefix||'';
				var uri = node.namespaceURI;
				addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
	
			if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
				buf.push('>');
				//if is cdata child node
				if(isHTML && /^script$/i.test(nodeName)){
					while(child){
						if(child.data){
							buf.push(child.data);
						}else{
							serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						}
						child = child.nextSibling;
					}
				}else
				{
					while(child){
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						child = child.nextSibling;
					}
				}
				buf.push('</',prefixedNodeName,'>');
			}else{
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while(child){
				serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return addSerializedAttribute(buf, node.name, node.value);
		case TEXT_NODE:
			/**
			 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
			 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
			 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
			 * `&amp;` and `&lt;` respectively.
			 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
			 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
			 * when that string is not marking the end of a CDATA section.
			 *
			 * In the content of elements, character data is any string of characters
			 * which does not contain the start-delimiter of any markup
			 * and does not include the CDATA-section-close delimiter, `]]>`.
			 *
			 * @see https://www.w3.org/TR/xml/#NT-CharData
			 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
			 */
			return buf.push(node.data
				.replace(/[<&>]/g,_xmlEncoder)
			);
		case CDATA_SECTION_NODE:
			return buf.push( '<![CDATA[',node.data,']]>');
		case COMMENT_NODE:
			return buf.push( "<!--",node.data,"-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ',node.name);
			if(pubid){
				buf.push(' PUBLIC ', pubid);
				if (sysid && sysid!='.') {
					buf.push(' ', sysid);
				}
				buf.push('>');
			}else if(sysid && sysid!='.'){
				buf.push(' SYSTEM ', sysid, '>');
			}else{
				var sub = node.internalSubset;
				if(sub){
					buf.push(" [",sub,"]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push( "<?",node.target," ",node.data,"?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push( '&',node.nodeName,';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??',node.nodeName);
		}
	}
	function importNode(doc,node,deep){
		var node2;
		switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
			//var attrs = node2.attributes;
			//var len = attrs.length;
			//for(var i=0;i<len;i++){
				//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
			//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
		}
		if(!node2){
			node2 = node.cloneNode(false);//false
		}
		node2.ownerDocument = doc;
		node2.parentNode = null;
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(importNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	//
	//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
	//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
	function cloneNode(doc,node,deep){
		var node2 = new node.constructor();
		for (var n in node) {
			if (Object.prototype.hasOwnProperty.call(node, n)) {
				var v = node[n];
				if (typeof v != "object") {
					if (v != node2[n]) {
						node2[n] = v;
					}
				}
			}
		}
		if(node.childNodes){
			node2.childNodes = new NodeList();
		}
		node2.ownerDocument = doc;
		switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs	= node.attributes;
			var attrs2	= node2.attributes = new NamedNodeMap();
			var len = attrs.length
			attrs2._ownerElement = node2;
			for(var i=0;i<len;i++){
				node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
		}
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(cloneNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	
	function __set__(object,key,value){
		object[key] = value
	}
	//do dynamic
	try{
		if(Object.defineProperty){
			Object.defineProperty(LiveNodeList.prototype,'length',{
				get:function(){
					_updateLiveList(this);
					return this.$$length;
				}
			});
	
			Object.defineProperty(Node.prototype,'textContent',{
				get:function(){
					return getTextContent(this);
				},
	
				set:function(data){
					switch(this.nodeType){
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while(this.firstChild){
							this.removeChild(this.firstChild);
						}
						if(data || String(data)){
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
	
					default:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
					}
				}
			})
	
			function getTextContent(node){
				switch(node.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while(node){
						if(node.nodeType!==7 && node.nodeType !==8){
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
				}
			}
	
			__set__ = function(object,key,value){
				//console.log(value)
				object['$$'+key] = value
			}
		}
	}catch(e){//ie8
	}
	
	//if(typeof require == 'function'){
		exports.DocumentType = DocumentType;
		exports.DOMException = DOMException;
		exports.DOMImplementation = DOMImplementation;
		exports.Element = Element;
		exports.Node = Node;
		exports.NodeList = NodeList;
		exports.XMLSerializer = XMLSerializer;
	//}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(189);
	module.exports = angular;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(662);
	
	var doccy;
	
	if (typeof document !== 'undefined') {
	    doccy = document;
	} else {
	    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	}
	
	module.exports = doccy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar_ly = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ly;
	
	}));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es_do = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es_do;
	
	}));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	}));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_hk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_hk;
	
	}));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var ECLevel = __webpack_require__(13)
	
	var EC_BLOCKS_TABLE = [
	// L  M  Q  H
	  1, 1, 1, 1,
	  1, 1, 1, 1,
	  1, 1, 2, 2,
	  1, 2, 2, 4,
	  1, 2, 4, 4,
	  2, 4, 4, 4,
	  2, 4, 6, 5,
	  2, 4, 6, 6,
	  2, 5, 8, 8,
	  4, 5, 8, 8,
	  4, 5, 8, 11,
	  4, 8, 10, 11,
	  4, 9, 12, 16,
	  4, 9, 16, 16,
	  6, 10, 12, 18,
	  6, 10, 17, 16,
	  6, 11, 16, 19,
	  6, 13, 18, 21,
	  7, 14, 21, 25,
	  8, 16, 20, 25,
	  8, 17, 23, 25,
	  9, 17, 23, 34,
	  9, 18, 25, 30,
	  10, 20, 27, 32,
	  12, 21, 29, 35,
	  12, 23, 34, 37,
	  12, 25, 34, 40,
	  13, 26, 35, 42,
	  14, 28, 38, 45,
	  15, 29, 40, 48,
	  16, 31, 43, 51,
	  17, 33, 45, 54,
	  18, 35, 48, 57,
	  19, 37, 51, 60,
	  19, 38, 53, 63,
	  20, 40, 56, 66,
	  21, 43, 59, 70,
	  22, 45, 62, 74,
	  24, 47, 65, 77,
	  25, 49, 68, 81
	]
	
	var EC_CODEWORDS_TABLE = [
	// L  M  Q  H
	  7, 10, 13, 17,
	  10, 16, 22, 28,
	  15, 26, 36, 44,
	  20, 36, 52, 64,
	  26, 48, 72, 88,
	  36, 64, 96, 112,
	  40, 72, 108, 130,
	  48, 88, 132, 156,
	  60, 110, 160, 192,
	  72, 130, 192, 224,
	  80, 150, 224, 264,
	  96, 176, 260, 308,
	  104, 198, 288, 352,
	  120, 216, 320, 384,
	  132, 240, 360, 432,
	  144, 280, 408, 480,
	  168, 308, 448, 532,
	  180, 338, 504, 588,
	  196, 364, 546, 650,
	  224, 416, 600, 700,
	  224, 442, 644, 750,
	  252, 476, 690, 816,
	  270, 504, 750, 900,
	  300, 560, 810, 960,
	  312, 588, 870, 1050,
	  336, 644, 952, 1110,
	  360, 700, 1020, 1200,
	  390, 728, 1050, 1260,
	  420, 784, 1140, 1350,
	  450, 812, 1200, 1440,
	  480, 868, 1290, 1530,
	  510, 924, 1350, 1620,
	  540, 980, 1440, 1710,
	  570, 1036, 1530, 1800,
	  570, 1064, 1590, 1890,
	  600, 1120, 1680, 1980,
	  630, 1204, 1770, 2100,
	  660, 1260, 1860, 2220,
	  720, 1316, 1950, 2310,
	  750, 1372, 2040, 2430
	]
	
	/**
	 * Returns the number of error correction block that the QR Code should contain
	 * for the specified version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction blocks
	 */
	exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel.L:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel.M:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel.Q:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel.H:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Returns the number of error correction codewords to use for the specified
	 * version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction codewords
	 */
	exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel.L:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel.M:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel.Q:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel.H:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	}


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	var numeric = '[0-9]+'
	var alphanumeric = '[A-Z $%*+\\-./:]+'
	var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
	  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
	  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
	  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
	kanji = kanji.replace(/u/g, '\\u')
	
	var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'
	
	exports.KANJI = new RegExp(kanji, 'g')
	exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
	exports.BYTE = new RegExp(byte, 'g')
	exports.NUMERIC = new RegExp(numeric, 'g')
	exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')
	
	var TEST_KANJI = new RegExp('^' + kanji + '$')
	var TEST_NUMERIC = new RegExp('^' + numeric + '$')
	var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')
	
	exports.testKanji = function testKanji (str) {
	  return TEST_KANJI.test(str)
	}
	
	exports.testNumeric = function testNumeric (str) {
	  return TEST_NUMERIC.test(str)
	}
	
	exports.testAlphanumeric = function testAlphanumeric (str) {
	  return TEST_ALPHANUMERIC.test(str)
	}


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Check if QR Code version is valid
	 *
	 * @param  {Number}  version QR Code version
	 * @return {Boolean}         true if valid version, false otherwise
	 */
	exports.isValid = function isValid (version) {
	  return !isNaN(version) && version >= 1 && version <= 40
	}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	function hex2rgba (hex) {
	  if (typeof hex === 'number') {
	    hex = hex.toString()
	  }
	
	  if (typeof hex !== 'string') {
	    throw new Error('Color should be defined as hex string')
	  }
	
	  var hexCode = hex.slice().replace('#', '').split('')
	  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
	    throw new Error('Invalid hex color: ' + hex)
	  }
	
	  // Convert from short to long form (fff -> ffffff)
	  if (hexCode.length === 3 || hexCode.length === 4) {
	    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
	      return [c, c]
	    }))
	  }
	
	  // Add default alpha value
	  if (hexCode.length === 6) hexCode.push('F', 'F')
	
	  var hexValue = parseInt(hexCode.join(''), 16)
	
	  return {
	    r: (hexValue >> 24) & 255,
	    g: (hexValue >> 16) & 255,
	    b: (hexValue >> 8) & 255,
	    a: hexValue & 255,
	    hex: '#' + hexCode.slice(0, 6).join('')
	  }
	}
	
	exports.getOptions = function getOptions (options) {
	  if (!options) options = {}
	  if (!options.color) options.color = {}
	
	  var margin = typeof options.margin === 'undefined' ||
	    options.margin === null ||
	    options.margin < 0 ? 4 : options.margin
	
	  var width = options.width && options.width >= 21 ? options.width : undefined
	  var scale = options.scale || 4
	
	  return {
	    width: width,
	    scale: width ? 4 : scale,
	    margin: margin,
	    color: {
	      dark: hex2rgba(options.color.dark || '#000000ff'),
	      light: hex2rgba(options.color.light || '#ffffffff')
	    },
	    type: options.type,
	    rendererOpts: options.rendererOpts || {}
	  }
	}
	
	exports.getScale = function getScale (qrSize, opts) {
	  return opts.width && opts.width >= qrSize + opts.margin * 2
	    ? opts.width / (qrSize + opts.margin * 2)
	    : opts.scale
	}
	
	exports.getImageWidth = function getImageWidth (qrSize, opts) {
	  var scale = exports.getScale(qrSize, opts)
	  return Math.floor((qrSize + opts.margin * 2) * scale)
	}
	
	exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
	  var size = qr.modules.size
	  var data = qr.modules.data
	  var scale = exports.getScale(size, opts)
	  var symbolSize = Math.floor((size + opts.margin * 2) * scale)
	  var scaledMargin = opts.margin * scale
	  var palette = [opts.color.light, opts.color.dark]
	
	  for (var i = 0; i < symbolSize; i++) {
	    for (var j = 0; j < symbolSize; j++) {
	      var posDst = (i * symbolSize + j) * 4
	      var pxColor = opts.color.light
	
	      if (i >= scaledMargin && j >= scaledMargin &&
	        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
	        var iSrc = Math.floor((i - scaledMargin) / scale)
	        var jSrc = Math.floor((j - scaledMargin) / scale)
	        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
	      }
	
	      imgData[posDst++] = pxColor.r
	      imgData[posDst++] = pxColor.g
	      imgData[posDst++] = pxColor.b
	      imgData[posDst] = pxColor.a
	    }
	  }
	}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// This file is autogenerated. It's used to publish CJS to npm.
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
	})(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    }, _typeof(obj);
	  }
	
	  // https://github.com/bgrins/TinyColor
	  // Brian Grinstead, MIT License
	
	  var trimLeft = /^\s+/;
	  var trimRight = /\s+$/;
	  function tinycolor(color, opts) {
	    color = color ? color : "";
	    opts = opts || {};
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	      return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	      return new tinycolor(color, opts);
	    }
	    var rgb = inputToRGB(color);
	    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) this._r = Math.round(this._r);
	    if (this._g < 1) this._g = Math.round(this._g);
	    if (this._b < 1) this._b = Math.round(this._b);
	    this._ok = rgb.ok;
	  }
	  tinycolor.prototype = {
	    isDark: function isDark() {
	      return this.getBrightness() < 128;
	    },
	    isLight: function isLight() {
	      return !this.isDark();
	    },
	    isValid: function isValid() {
	      return this._ok;
	    },
	    getOriginalInput: function getOriginalInput() {
	      return this._originalInput;
	    },
	    getFormat: function getFormat() {
	      return this._format;
	    },
	    getAlpha: function getAlpha() {
	      return this._a;
	    },
	    getBrightness: function getBrightness() {
	      //http://www.w3.org/TR/AERT#color-contrast
	      var rgb = this.toRgb();
	      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function getLuminance() {
	      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	      var rgb = this.toRgb();
	      var RsRGB, GsRGB, BsRGB, R, G, B;
	      RsRGB = rgb.r / 255;
	      GsRGB = rgb.g / 255;
	      BsRGB = rgb.b / 255;
	      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
	      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
	      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
	      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
	    },
	    setAlpha: function setAlpha(value) {
	      this._a = boundAlpha(value);
	      this._roundA = Math.round(100 * this._a) / 100;
	      return this;
	    },
	    toHsv: function toHsv() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      return {
	        h: hsv.h * 360,
	        s: hsv.s,
	        v: hsv.v,
	        a: this._a
	      };
	    },
	    toHsvString: function toHsvString() {
	      var hsv = rgbToHsv(this._r, this._g, this._b);
	      var h = Math.round(hsv.h * 360),
	        s = Math.round(hsv.s * 100),
	        v = Math.round(hsv.v * 100);
	      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
	    },
	    toHsl: function toHsl() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      return {
	        h: hsl.h * 360,
	        s: hsl.s,
	        l: hsl.l,
	        a: this._a
	      };
	    },
	    toHslString: function toHslString() {
	      var hsl = rgbToHsl(this._r, this._g, this._b);
	      var h = Math.round(hsl.h * 360),
	        s = Math.round(hsl.s * 100),
	        l = Math.round(hsl.l * 100);
	      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
	    },
	    toHex: function toHex(allow3Char) {
	      return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function toHexString(allow3Char) {
	      return "#" + this.toHex(allow3Char);
	    },
	    toHex8: function toHex8(allow4Char) {
	      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function toHex8String(allow4Char) {
	      return "#" + this.toHex8(allow4Char);
	    },
	    toRgb: function toRgb() {
	      return {
	        r: Math.round(this._r),
	        g: Math.round(this._g),
	        b: Math.round(this._b),
	        a: this._a
	      };
	    },
	    toRgbString: function toRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function toPercentageRgb() {
	      return {
	        r: Math.round(bound01(this._r, 255) * 100) + "%",
	        g: Math.round(bound01(this._g, 255) * 100) + "%",
	        b: Math.round(bound01(this._b, 255) * 100) + "%",
	        a: this._a
	      };
	    },
	    toPercentageRgbString: function toPercentageRgbString() {
	      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function toName() {
	      if (this._a === 0) {
	        return "transparent";
	      }
	      if (this._a < 1) {
	        return false;
	      }
	      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function toFilter(secondColor) {
	      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	      var secondHex8String = hex8String;
	      var gradientType = this._gradientType ? "GradientType = 1, " : "";
	      if (secondColor) {
	        var s = tinycolor(secondColor);
	        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	      }
	      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
	    },
	    toString: function toString(format) {
	      var formatSet = !!format;
	      format = format || this._format;
	      var formattedString = false;
	      var hasAlpha = this._a < 1 && this._a >= 0;
	      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	      if (needsAlphaFormat) {
	        // Special case for "transparent", all other non-alpha formats
	        // will return rgba when there is transparency.
	        if (format === "name" && this._a === 0) {
	          return this.toName();
	        }
	        return this.toRgbString();
	      }
	      if (format === "rgb") {
	        formattedString = this.toRgbString();
	      }
	      if (format === "prgb") {
	        formattedString = this.toPercentageRgbString();
	      }
	      if (format === "hex" || format === "hex6") {
	        formattedString = this.toHexString();
	      }
	      if (format === "hex3") {
	        formattedString = this.toHexString(true);
	      }
	      if (format === "hex4") {
	        formattedString = this.toHex8String(true);
	      }
	      if (format === "hex8") {
	        formattedString = this.toHex8String();
	      }
	      if (format === "name") {
	        formattedString = this.toName();
	      }
	      if (format === "hsl") {
	        formattedString = this.toHslString();
	      }
	      if (format === "hsv") {
	        formattedString = this.toHsvString();
	      }
	      return formattedString || this.toHexString();
	    },
	    clone: function clone() {
	      return tinycolor(this.toString());
	    },
	    _applyModification: function _applyModification(fn, args) {
	      var color = fn.apply(null, [this].concat([].slice.call(args)));
	      this._r = color._r;
	      this._g = color._g;
	      this._b = color._b;
	      this.setAlpha(color._a);
	      return this;
	    },
	    lighten: function lighten() {
	      return this._applyModification(_lighten, arguments);
	    },
	    brighten: function brighten() {
	      return this._applyModification(_brighten, arguments);
	    },
	    darken: function darken() {
	      return this._applyModification(_darken, arguments);
	    },
	    desaturate: function desaturate() {
	      return this._applyModification(_desaturate, arguments);
	    },
	    saturate: function saturate() {
	      return this._applyModification(_saturate, arguments);
	    },
	    greyscale: function greyscale() {
	      return this._applyModification(_greyscale, arguments);
	    },
	    spin: function spin() {
	      return this._applyModification(_spin, arguments);
	    },
	    _applyCombination: function _applyCombination(fn, args) {
	      return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function analogous() {
	      return this._applyCombination(_analogous, arguments);
	    },
	    complement: function complement() {
	      return this._applyCombination(_complement, arguments);
	    },
	    monochromatic: function monochromatic() {
	      return this._applyCombination(_monochromatic, arguments);
	    },
	    splitcomplement: function splitcomplement() {
	      return this._applyCombination(_splitcomplement, arguments);
	    },
	    // Disabled until https://github.com/bgrins/TinyColor/issues/254
	    // polyad: function (number) {
	    //   return this._applyCombination(polyad, [number]);
	    // },
	    triad: function triad() {
	      return this._applyCombination(polyad, [3]);
	    },
	    tetrad: function tetrad() {
	      return this._applyCombination(polyad, [4]);
	    }
	  };
	
	  // If input is an object, force 1 into "1.0" to handle ratios properly
	  // String input requires "1.0" as input, so 1 will be treated as 1
	  tinycolor.fromRatio = function (color, opts) {
	    if (_typeof(color) == "object") {
	      var newColor = {};
	      for (var i in color) {
	        if (color.hasOwnProperty(i)) {
	          if (i === "a") {
	            newColor[i] = color[i];
	          } else {
	            newColor[i] = convertToPercentage(color[i]);
	          }
	        }
	      }
	      color = newColor;
	    }
	    return tinycolor(color, opts);
	  };
	
	  // Given a string or object, convert that input to RGB
	  // Possible string inputs:
	  //
	  //     "red"
	  //     "#f00" or "f00"
	  //     "#ff0000" or "ff0000"
	  //     "#ff000000" or "ff000000"
	  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
	  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	  //
	  function inputToRGB(color) {
	    var rgb = {
	      r: 0,
	      g: 0,
	      b: 0
	    };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	    if (typeof color == "string") {
	      color = stringInputToObject(color);
	    }
	    if (_typeof(color) == "object") {
	      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	        rgb = rgbToRgb(color.r, color.g, color.b);
	        ok = true;
	        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	        s = convertToPercentage(color.s);
	        v = convertToPercentage(color.v);
	        rgb = hsvToRgb(color.h, s, v);
	        ok = true;
	        format = "hsv";
	      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	        s = convertToPercentage(color.s);
	        l = convertToPercentage(color.l);
	        rgb = hslToRgb(color.h, s, l);
	        ok = true;
	        format = "hsl";
	      }
	      if (color.hasOwnProperty("a")) {
	        a = color.a;
	      }
	    }
	    a = boundAlpha(a);
	    return {
	      ok: ok,
	      format: color.format || format,
	      r: Math.min(255, Math.max(rgb.r, 0)),
	      g: Math.min(255, Math.max(rgb.g, 0)),
	      b: Math.min(255, Math.max(rgb.b, 0)),
	      a: a
	    };
	  }
	
	  // Conversion Functions
	  // --------------------
	
	  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	  // `rgbToRgb`
	  // Handle bounds / percentage checking to conform to CSS color spec
	  // <http://www.w3.org/TR/css3-color/>
	  // *Assumes:* r, g, b in [0, 255] or [0, 1]
	  // *Returns:* { r, g, b } in [0, 255]
	  function rgbToRgb(r, g, b) {
	    return {
	      r: bound01(r, 255) * 255,
	      g: bound01(g, 255) * 255,
	      b: bound01(b, 255) * 255
	    };
	  }
	
	  // `rgbToHsl`
	  // Converts an RGB color value to HSL.
	  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	  // *Returns:* { h, s, l } in [0,1]
	  function rgbToHsl(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      l = (max + min) / 2;
	    if (max == min) {
	      h = s = 0; // achromatic
	    } else {
	      var d = max - min;
	      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      l: l
	    };
	  }
	
	  // `hslToRgb`
	  // Converts an HSL color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hslToRgb(h, s, l) {
	    var r, g, b;
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	    if (s === 0) {
	      r = g = b = l; // achromatic
	    } else {
	      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	      var p = 2 * l - q;
	      r = hue2rgb(p, q, h + 1 / 3);
	      g = hue2rgb(p, q, h);
	      b = hue2rgb(p, q, h - 1 / 3);
	    }
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHsv`
	  // Converts an RGB color value to HSV
	  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	  // *Returns:* { h, s, v } in [0,1]
	  function rgbToHsv(r, g, b) {
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	    var max = Math.max(r, g, b),
	      min = Math.min(r, g, b);
	    var h,
	      s,
	      v = max;
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	    if (max == min) {
	      h = 0; // achromatic
	    } else {
	      switch (max) {
	        case r:
	          h = (g - b) / d + (g < b ? 6 : 0);
	          break;
	        case g:
	          h = (b - r) / d + 2;
	          break;
	        case b:
	          h = (r - g) / d + 4;
	          break;
	      }
	      h /= 6;
	    }
	    return {
	      h: h,
	      s: s,
	      v: v
	    };
	  }
	
	  // `hsvToRgb`
	  // Converts an HSV color value to RGB.
	  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	  // *Returns:* { r, g, b } in the set [0, 255]
	  function hsvToRgb(h, s, v) {
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	    var i = Math.floor(h),
	      f = h - i,
	      p = v * (1 - s),
	      q = v * (1 - f * s),
	      t = v * (1 - (1 - f) * s),
	      mod = i % 6,
	      r = [v, q, p, p, t, v][mod],
	      g = [t, v, v, q, p, p][mod],
	      b = [p, p, t, v, v, q][mod];
	    return {
	      r: r * 255,
	      g: g * 255,
	      b: b * 255
	    };
	  }
	
	  // `rgbToHex`
	  // Converts an RGB color to hex
	  // Assumes r, g, and b are contained in the set [0, 255]
	  // Returns a 3 or 6 character hex
	  function rgbToHex(r, g, b, allow3Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToHex`
	  // Converts an RGBA color plus alpha transparency to hex
	  // Assumes r, g, b are contained in the set [0, 255] and
	  // a in [0, 1]. Returns a 4 or 8 character rgba hex
	  function rgbaToHex(r, g, b, a, allow4Char) {
	    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	    return hex.join("");
	  }
	
	  // `rgbaToArgbHex`
	  // Converts an RGBA color to an ARGB Hex8 string
	  // Rarely used, but required for "toFilter()"
	  function rgbaToArgbHex(r, g, b, a) {
	    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	    return hex.join("");
	  }
	
	  // `equals`
	  // Can be called with any tinycolor input
	  tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) return false;
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	  };
	  tinycolor.random = function () {
	    return tinycolor.fromRatio({
	      r: Math.random(),
	      g: Math.random(),
	      b: Math.random()
	    });
	  };
	
	  // Modification Functions
	  // ----------------------
	  // Thanks to less.js for some of the basics here
	  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	  function _desaturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _saturate(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	  }
	  function _greyscale(color) {
	    return tinycolor(color).desaturate(100);
	  }
	  function _lighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	  function _brighten(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
	    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
	    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
	    return tinycolor(rgb);
	  }
	  function _darken(color, amount) {
	    amount = amount === 0 ? 0 : amount || 10;
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	  }
	
	  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	  // Values outside of this range will be wrapped into this range.
	  function _spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	  }
	
	  // Combination Functions
	  // ---------------------
	  // Thanks to jQuery xColor for some of the ideas behind these
	  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	  function _complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	  }
	  function polyad(color, number) {
	    if (isNaN(number) || number <= 0) {
	      throw new Error("Argument to polyad must be a positive number");
	    }
	    var hsl = tinycolor(color).toHsl();
	    var result = [tinycolor(color)];
	    var step = 360 / number;
	    for (var i = 1; i < number; i++) {
	      result.push(tinycolor({
	        h: (hsl.h + i * step) % 360,
	        s: hsl.s,
	        l: hsl.l
	      }));
	    }
	    return result;
	  }
	  function _splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [tinycolor(color), tinycolor({
	      h: (h + 72) % 360,
	      s: hsl.s,
	      l: hsl.l
	    }), tinycolor({
	      h: (h + 216) % 360,
	      s: hsl.s,
	      l: hsl.l
	    })];
	  }
	  function _analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
	      hsl.h = (hsl.h + part) % 360;
	      ret.push(tinycolor(hsl));
	    }
	    return ret;
	  }
	  function _monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h,
	      s = hsv.s,
	      v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	    while (results--) {
	      ret.push(tinycolor({
	        h: h,
	        s: s,
	        v: v
	      }));
	      v = (v + modification) % 1;
	    }
	    return ret;
	  }
	
	  // Utility Functions
	  // ---------------------
	
	  tinycolor.mix = function (color1, color2, amount) {
	    amount = amount === 0 ? 0 : amount || 50;
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	    var p = amount / 100;
	    var rgba = {
	      r: (rgb2.r - rgb1.r) * p + rgb1.r,
	      g: (rgb2.g - rgb1.g) * p + rgb1.g,
	      b: (rgb2.b - rgb1.b) * p + rgb1.b,
	      a: (rgb2.a - rgb1.a) * p + rgb1.a
	    };
	    return tinycolor(rgba);
	  };
	
	  // Readability Functions
	  // ---------------------
	  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	  // `contrast`
	  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	  tinycolor.readability = function (color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
	  };
	
	  // `isReadable`
	  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
	  // The third argument is an optional Object.
	  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	  // *Example*
	  //    tinycolor.isReadable("#000", "#111") => false
	  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	  tinycolor.isReadable = function (color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	    out = false;
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	      case "AAsmall":
	      case "AAAlarge":
	        out = readability >= 4.5;
	        break;
	      case "AAlarge":
	        out = readability >= 3;
	        break;
	      case "AAAsmall":
	        out = readability >= 7;
	        break;
	    }
	    return out;
	  };
	
	  // `mostReadable`
	  // Given a base color and a list of possible foreground or background
	  // colors for that base, returns the most readable color.
	  // Optionally returns Black or White if the most readable color is unreadable.
	  // *Example*
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	  tinycolor.mostReadable = function (baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors;
	    level = args.level;
	    size = args.size;
	    for (var i = 0; i < colorList.length; i++) {
	      readability = tinycolor.readability(baseColor, colorList[i]);
	      if (readability > bestScore) {
	        bestScore = readability;
	        bestColor = tinycolor(colorList[i]);
	      }
	    }
	    if (tinycolor.isReadable(baseColor, bestColor, {
	      level: level,
	      size: size
	    }) || !includeFallbackColors) {
	      return bestColor;
	    } else {
	      args.includeFallbackColors = false;
	      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
	    }
	  };
	
	  // Big List of Colors
	  // ------------------
	  // <https://www.w3.org/TR/css-color-4/#named-colors>
	  var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	  };
	
	  // Make it easy to access colors via `hexNames[hex]`
	  var hexNames = tinycolor.hexNames = flip(names);
	
	  // Utilities
	  // ---------
	
	  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	  function flip(o) {
	    var flipped = {};
	    for (var i in o) {
	      if (o.hasOwnProperty(i)) {
	        flipped[o[i]] = i;
	      }
	    }
	    return flipped;
	  }
	
	  // Return a valid alpha value [0,1] with all invalid values being set to 1
	  function boundAlpha(a) {
	    a = parseFloat(a);
	    if (isNaN(a) || a < 0 || a > 1) {
	      a = 1;
	    }
	    return a;
	  }
	
	  // Take input from [0, n] and return it as [0, 1]
	  function bound01(n, max) {
	    if (isOnePointZero(n)) n = "100%";
	    var processPercent = isPercentage(n);
	    n = Math.min(max, Math.max(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	      n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if (Math.abs(n - max) < 0.000001) {
	      return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return n % max / parseFloat(max);
	  }
	
	  // Force a number between 0 and 1
	  function clamp01(val) {
	    return Math.min(1, Math.max(0, val));
	  }
	
	  // Parse a base-16 hex value into a base-10 integer
	  function parseIntFromHex(val) {
	    return parseInt(val, 16);
	  }
	
	  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	  function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
	  }
	
	  // Check to see if string passed in is a percentage
	  function isPercentage(n) {
	    return typeof n === "string" && n.indexOf("%") != -1;
	  }
	
	  // Force a hex value to have 2 characters
	  function pad2(c) {
	    return c.length == 1 ? "0" + c : "" + c;
	  }
	
	  // Replace a decimal with it's percentage value
	  function convertToPercentage(n) {
	    if (n <= 1) {
	      n = n * 100 + "%";
	    }
	    return n;
	  }
	
	  // Converts a decimal to a hex value
	  function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	  }
	  // Converts a hex value to a decimal
	  function convertHexToDecimal(h) {
	    return parseIntFromHex(h) / 255;
	  }
	  var matchers = function () {
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    return {
	      CSS_UNIT: new RegExp(CSS_UNIT),
	      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	  }();
	
	  // `isValidCSSUnit`
	  // Take in a single string / number and check to see if it looks like a CSS unit
	  // (see `matchers` above for definition).
	  function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	  }
	
	  // `stringInputToObject`
	  // Permissive string parsing.  Take in a number of formats, and output an object
	  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	  function stringInputToObject(color) {
	    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
	    var named = false;
	    if (names[color]) {
	      color = names[color];
	      named = true;
	    } else if (color == "transparent") {
	      return {
	        r: 0,
	        g: 0,
	        b: 0,
	        a: 0,
	        format: "name"
	      };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if (match = matchers.rgb.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3]
	      };
	    }
	    if (match = matchers.rgba.exec(color)) {
	      return {
	        r: match[1],
	        g: match[2],
	        b: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsl.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3]
	      };
	    }
	    if (match = matchers.hsla.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        l: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hsv.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3]
	      };
	    }
	    if (match = matchers.hsva.exec(color)) {
	      return {
	        h: match[1],
	        s: match[2],
	        v: match[3],
	        a: match[4]
	      };
	    }
	    if (match = matchers.hex8.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        a: convertHexToDecimal(match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex6.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1]),
	        g: parseIntFromHex(match[2]),
	        b: parseIntFromHex(match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    if (match = matchers.hex4.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        a: convertHexToDecimal(match[4] + "" + match[4]),
	        format: named ? "name" : "hex8"
	      };
	    }
	    if (match = matchers.hex3.exec(color)) {
	      return {
	        r: parseIntFromHex(match[1] + "" + match[1]),
	        g: parseIntFromHex(match[2] + "" + match[2]),
	        b: parseIntFromHex(match[3] + "" + match[3]),
	        format: named ? "name" : "hex"
	      };
	    }
	    return false;
	  }
	  function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {
	      level: "AA",
	      size: "small"
	    };
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	      level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	      size = "small";
	    }
	    return {
	      level: level,
	      size: size
	    };
	  }
	
	  return tinycolor;
	
	}));


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	function addKeywordToPostData(keywords, postData) {
	    // Find the keyword object with isMain: true
	    var mainKeywordObj = (keywords || []).find(function(kw) { return kw.isMain; });
	    // Use the 'name' property if found, otherwise empty string
	    var mainKeyword = mainKeywordObj ? mainKeywordObj.name : '';
	    if(mainKeyword) {
	        postData.vars = postData.vars || {};
	        postData.vars.keyword = mainKeyword;
	    }
	}
	
	function addKeywordsToPostData(keywords, postData) {
	    postData.vars = postData.vars || {};
	    postData.vars.keywords = keywords.map(function(kw) {
	        return kw.name;
	    })
	}
	
	// Store for shortcode mappings
	var shortcodeMappings = {};
	
	function replaceShortcodesWithPlaceholders(content) {
	    if (!content) return '';
	    
	    // Reset mappings for new content
	    shortcodeMappings = {};
	    var counter = 0;
	    
	    // Function to create unique identifier
	    function createPlaceholder(type) {
	        return '<shortcode id="shortcode_' + type + '_' + (counter++) + '">';
	    }
	    
	    var processedContent = content
	        // Remove summary blocks entirely
	        .replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '')
	        // Handle caption blocks
	        .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, function(match) {
	            var placeholder = createPlaceholder('caption');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle gallery blocks
	        .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, function(match) {
	            var placeholder = createPlaceholder('gallery');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle embed blocks
	        .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, function(match) {
	            var placeholder = createPlaceholder('embed');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle video shortcodes
	        .replace(/\[video[^\]]*\]/g, function(match) {
	            var placeholder = createPlaceholder('video');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle poll shortcodes
	        .replace(/\[poll[^\]]*\][\s\S]*?\[\/poll\]/g, function(match) {
	            var placeholder = createPlaceholder('poll');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle rating shortcodes
	        .replace(/\[rating[^\]]*\][\s\S]*?\[\/rating\]/g, function(match) {
	            var placeholder = createPlaceholder('rating');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle quote shortcodes
	        .replace(/\[quote[^\]]*\]([\s\S]*?)\[\/quote\]/g, function(match) {
	            var placeholder = createPlaceholder('quote');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle readalso shortcodes
	        .replace(/\[readalso[^\]]*\][\s\S]*?\[\/readalso\]/g, function(match) {
	            var placeholder = createPlaceholder('readalso');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        })
	        // Handle liveblog shortcodes
	        .replace(/\[liveblog[^\]]*\][\s\S]*?\[\/liveblog\]/g, function(match) {
	            var placeholder = createPlaceholder('liveblog');
	            shortcodeMappings[placeholder] = match;
	            return placeholder;
	        });
	    return processedContent;
	}
	
	function restoreShortcodes(content) {
	    if (!content) return content;
	    
	    var restoredContent = content;
	    // Restore all shortcodes in reverse order to handle nested cases
	    Object.keys(shortcodeMappings).reverse().forEach(function(placeholder) {
	        restoredContent = restoredContent.replace(placeholder, shortcodeMappings[placeholder]);
	    });
	    return restoredContent;
	}
	
	module.exports = {
	    addKeywordToPostData: addKeywordToPostData,
	    addKeywordsToPostData: addKeywordsToPostData,
	    replaceShortcodesWithPlaceholders: replaceShortcodesWithPlaceholders,
	    restoreShortcodes: restoreShortcodes
	};
	


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	module.exports = {
	    //test
	    // isDevelopment: false
	    isDevelopment: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '' || window.location.hostname.includes('dev'),
	}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// ============================================================================
	// SENTRY INTEGRATION MODULE
	// ============================================================================
	// This file contains all Sentry error tracking logic for the application.
	// It handles:
	// 1. Sentry initialization with environment detection
	// 2. Angular $exceptionHandler integration with automatic user tracking
	// 3. Centralized error reporting configuration
	//
	// Usage:
	//   In entry.js: require('./path/to/sentryIntegration').init();
	//   In app.js:   require('./path/to/sentryIntegration').setupAngular(app);
	// ============================================================================
	var enviroment = __webpack_require__(158);
	module.exports = {
	  
	  // ==========================================================================
	  // INITIALIZE SENTRY
	  // ==========================================================================
	  // Call this from entry.js AFTER Sentry CDN loads
	  // This sets up the Sentry client with environment detection
	  // ==========================================================================
	  init: function() {
	    
	    // Check if Sentry was loaded from CDN
	    if (typeof window.Sentry === 'undefined') {
	      console.warn('⚠️ Sentry not loaded! Add the Sentry script tag to your HTML <head>');
	      
	      // Create a dummy Sentry object to prevent errors
	      window.Sentry = {
	        init: function() {},
	        captureException: function() {},
	        captureMessage: function() {},
	        setUser: function() {},
	        setTag: function() {},
	        setExtra: function() {},
	        addBreadcrumb: function() {},
	        withScope: function(callback) { 
	          callback({ 
	            setTag: function() {}, 
	            setExtra: function() {}, 
	            setLevel: function() {}, 
	            captureException: function() {} 
	          }); 
	        }
	      };
	      return;
	    }
	    
	    var Sentry = window.Sentry;
	    
	    // ========================================================================
	    var environment = enviroment.isDevelopment ? 'development' : 'production';
	    // ========================================================================
	    // INITIALIZE SENTRY (BOTH ENVIRONMENTS, BUT DIFFERENT CONFIGS)
	    // ========================================================================
	    
	    var sentryConfig = {
	      // DSN (Data Source Name) - unique identifier for your Sentry project
	      dsn: "https://4a940b2fa6c580af9562b9de091074c5@o4509842006933504.ingest.de.sentry.io/4510827296260176",
	      
	      // Environment - automatically detected based on hostname
	      environment: environment,
	      
	      // sendDefaultPii (Personally Identifiable Information)
	      // When true, Sentry automatically collects IP addresses and user agent
	      sendDefaultPii: true,
	      
	      // tracesSampleRate - controls performance monitoring
	      tracesSampleRate: enviroment.isDevelopment ? 0 : 0.1,
	    };
	    
	    if (enviroment.isDevelopment) {
	      // ======================================================================
	      // DEVELOPMENT: DISABLE ALL DEFAULT INTEGRATIONS
	      // ======================================================================
	      // This is the ONLY way to prevent function wrapping completely!
	      // defaultIntegrations: false tells Sentry: "Don't load ANY integrations"
	      // We use an empty array to ensure no integrations are loaded
	      // ======================================================================
	      sentryConfig.defaultIntegrations = false;
	      sentryConfig.integrations = [];  // Empty array = no integrations at all
	    } else {
	      // ======================================================================
	      // PRODUCTION: USE ALL DEFAULT INTEGRATIONS
	      // ======================================================================
	      sentryConfig.integrations = [
	        Sentry.breadcrumbsIntegration({
	          console: true,
	          dom: true,
	          fetch: true,
	          history: true,
	        }),
	      ];
	    }
	    
	    Sentry.init(sentryConfig);
	    
	    console.log('✅ Sentry initialized successfully');
	    
	    // ========================================================================
	    // HELPER FUNCTION: GET USER CONTEXT FROM LOCALSTORAGE
	    // ========================================================================
	    // This function reads user data from localStorage directly
	    // Used by global error handlers that don't have access to Angular's $injector
	    // ========================================================================
	    function getUserContextFromStorage() {
	      try {
	        var token = localStorage.getItem('userToken');
	        if (!token) {
	          return null; // Not authenticated
	        }
	        
	        var userId = localStorage.getItem('userId');
	        var userName = localStorage.getItem('userName');
	        var userLastName = localStorage.getItem('userLastName');
	        var roleId = localStorage.getItem('roleId');
	        
	        return {
	          id: userId,
	          username: (userName + ' ' + (userLastName || '')).trim(),
	          role_id: roleId
	        };
	      } catch (e) {
	        console.warn('Could not read user context from localStorage:', e);
	        return null;
	      }
	    }
	    
	    // ========================================================================
	    // GLOBAL ERROR HANDLER (for non-Angular errors)
	    // ========================================================================
	    // Catches JavaScript errors that occur outside Angular's execution context
	    // Examples: setTimeout callbacks, third-party library errors, etc.
	    // ========================================================================
	    window.addEventListener('error', function(event) {
	      if (window.Sentry) {
	        // Set user context from localStorage
	        var userContext = getUserContextFromStorage();
	        if (userContext) {
	          window.Sentry.setUser(userContext);
	        }
	        
	        // Capture the error with context
	        window.Sentry.withScope(function(scope) {
	          scope.setTag('error_handler', 'global_window_error');
	          scope.setExtra('filename', event.filename);
	          scope.setExtra('lineno', event.lineno);
	          scope.setExtra('colno', event.colno);
	          
	          // event.error contains the actual Error object
	          scope.captureException(event.error || new Error(event.message));
	        });
	      }
	    });
	    
	    // ========================================================================
	    // UNHANDLED PROMISE REJECTION HANDLER
	    // ========================================================================
	    // Catches unhandled promise rejections (e.g., from native Promises, fetch)
	    // ========================================================================
	    window.addEventListener('unhandledrejection', function(event) {
	      if (window.Sentry) {
	        // Set user context from localStorage
	        var userContext = getUserContextFromStorage();
	        if (userContext) {
	          window.Sentry.setUser(userContext);
	        }
	        
	        // Capture the rejection with context
	        window.Sentry.withScope(function(scope) {
	          scope.setTag('error_handler', 'unhandled_promise_rejection');
	          
	          // event.reason contains the rejection value
	          scope.captureException(event.reason);
	        });
	      }
	    });
	    
	    console.log('✅ Global error handlers configured with user context support');
	  },
	  
	  // ==========================================================================
	  // SETUP ANGULAR INTEGRATION
	  // ==========================================================================
	  // Call this from app.js to integrate with Angular's error handling
	  // This decorator automatically:
	  // - Reads user from localStorage on every error
	  // - Sends errors to Sentry with full context
	  // - Preserves Angular's default error logging
	  // ==========================================================================
	  setupAngular: function(app) {
	    
	    // Use array notation for minification safety
	    app.config(['$provide', function($provide) {
	      
	      // Decorate Angular's $exceptionHandler
	      // Use array notation for minification safety
	      $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function($delegate, $injector) {
	        
	        return function(exception, cause) {
	          
	          // ==============================================================
	          // SET SENTRY USER CONTEXT FROM LOCALSTORAGE
	          // ==============================================================
	          // Read user data from localStorage and set in Sentry
	          // This ensures every error has user context, even after refresh
	          // ==============================================================
	          if (window.Sentry) {
	            try {
	              // Get authtokenService (use $injector to avoid circular dependency)
	              var authtokenService = $injector.get('authtokenService');
	              
	              // Check if user is authenticated
	              if (authtokenService.isAuthenticated()) {
	                // Get user data from localStorage
	                var userId = authtokenService.getUserId();
	                var userName = authtokenService.getName();
	                var userLastName = authtokenService.getLastName();
	                var roleId = authtokenService.getRoleId();
	                
	                // Set user context in Sentry
	                window.Sentry.setUser({
	                  id: userId,
	                  username: (userName + ' ' + userLastName).trim(),
	                  role_id: roleId
	                  // Note: We don't have email in localStorage
	                  // If you add it, include it here
	                });
	              }
	            } catch (e) {
	              // If there's an error getting user context, don't break error reporting
	              console.warn('Could not set Sentry user context:', e);
	            }
	          }
	          
	          // ==============================================================
	          // SEND ERROR TO SENTRY
	          // ==============================================================
	          if (window.Sentry) {
	            window.Sentry.withScope(function(scope) {
	              // Add the 'cause' parameter as extra data
	              if (cause) {
	                scope.setExtra('cause', cause);
	              }
	              
	              // Add Angular context
	              scope.setTag('error_handler', 'angular_exception_handler');
	              
	              // Send the exception to Sentry
	              scope.captureException(exception);
	            });
	          }
	          
	          // ==============================================================
	          // CALL ANGULAR'S ORIGINAL ERROR HANDLER
	          // ==============================================================
	          // This ensures errors are still logged to console
	          $delegate(exception, cause);
	        };
	      }]); // Close array notation
	    }]); // Close array notation
	    
	    console.log('✅ Sentry Angular integration configured');
	  }
	  
	};
	


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	function _getPrototypeOf(t) {
	  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(8);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	function _isNativeFunction(t) {
	  try {
	    return -1 !== Function.toString.call(t).indexOf("[native code]");
	  } catch (n) {
	    return "function" == typeof t;
	  }
	}
	module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(160);
	var setPrototypeOf = __webpack_require__(8);
	var isNativeFunction = __webpack_require__(162);
	var construct = __webpack_require__(20);
	function _wrapNativeSuper(t) {
	  var r = "function" == typeof Map ? new Map() : void 0;
	  return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
	    if (null === t || !isNativeFunction(t)) return t;
	    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
	    if (void 0 !== r) {
	      if (r.has(t)) return r.get(t);
	      r.set(t, Wrapper);
	    }
	    function Wrapper() {
	      return construct(t, arguments, getPrototypeOf(this).constructor);
	    }
	    return Wrapper.prototype = Object.create(t.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: !1,
	        writable: !0,
	        configurable: !0
	      }
	    }), setPrototypeOf(Wrapper, t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
	}
	module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_VIDEO_CODEC = exports.DEFAULT_AUDIO_CODEC = exports.muxerSupportsCodec = exports.browserSupportsCodec = exports.getMimeForCodec = exports.isTextCodec = exports.isAudioCodec = exports.isVideoCodec = exports.codecsFromDefault = exports.parseCodecs = exports.mapLegacyAvcCodecs = exports.translateLegacyCodecs = exports.translateLegacyCodec = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(2));
	
	var regexs = {
	  // to determine mime types
	  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
	  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
	  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
	  // to determine if a codec is audio or video
	  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
	  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
	  text: /^(stpp.ttml.im1t)/,
	  // mux.js support regex
	  muxerVideo: /^(avc0?1)/,
	  muxerAudio: /^(mp4a)/,
	  // match nothing as muxer does not support text right now.
	  // there cannot never be a character before the start of a string
	  // so this matches nothing.
	  muxerText: /a^/
	};
	var mediaTypes = ['video', 'audio', 'text'];
	var upperMediaTypes = ['Video', 'Audio', 'Text'];
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string} codec
	 *        Codec string to translate
	 * @return {string}
	 *         The translated codec string
	 */
	
	var translateLegacyCodec = function translateLegacyCodec(codec) {
	  if (!codec) {
	    return codec;
	  }
	
	  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
	    var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
	    var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
	    return 'avc1.' + profileHex + '00' + avcLevelHex;
	  });
	};
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec strings with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string[]} codecs
	 *        An array of codec strings to translate
	 * @return {string[]}
	 *         The translated array of codec strings
	 */
	
	
	exports.translateLegacyCodec = translateLegacyCodec;
	
	var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
	  return codecs.map(translateLegacyCodec);
	};
	/**
	 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
	 * standard `avc1.<hhhhhh>`.
	 *
	 * @param {string} codecString
	 *        The codec string
	 * @return {string}
	 *         The codec string with old apple-style codecs replaced
	 *
	 * @private
	 */
	
	
	exports.translateLegacyCodecs = translateLegacyCodecs;
	
	var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
	  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
	    return translateLegacyCodecs([match])[0];
	  });
	};
	/**
	 * @typedef {Object} ParsedCodecInfo
	 * @property {number} codecCount
	 *           Number of codecs parsed
	 * @property {string} [videoCodec]
	 *           Parsed video codec (if found)
	 * @property {string} [videoObjectTypeIndicator]
	 *           Video object type indicator (if found)
	 * @property {string|null} audioProfile
	 *           Audio profile
	 */
	
	/**
	 * Parses a codec string to retrieve the number of codecs specified, the video codec and
	 * object type indicator, and the audio profile.
	 *
	 * @param {string} [codecString]
	 *        The codec string to parse
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.mapLegacyAvcCodecs = mapLegacyAvcCodecs;
	
	var parseCodecs = function parseCodecs(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  var codecs = codecString.split(',');
	  var result = [];
	  codecs.forEach(function (codec) {
	    codec = codec.trim();
	    var codecType;
	    mediaTypes.forEach(function (name) {
	      var match = regexs[name].exec(codec.toLowerCase());
	
	      if (!match || match.length <= 1) {
	        return;
	      }
	
	      codecType = name; // maintain codec case
	
	      var type = codec.substring(0, match[1].length);
	      var details = codec.replace(type, '');
	      result.push({
	        type: type,
	        details: details,
	        mediaType: name
	      });
	    });
	
	    if (!codecType) {
	      result.push({
	        type: codec,
	        details: '',
	        mediaType: 'unknown'
	      });
	    }
	  });
	  return result;
	};
	/**
	 * Returns a ParsedCodecInfo object for the default alternate audio playlist if there is
	 * a default alternate audio playlist for the provided audio group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 * @param {string} audioGroupId
	 *        ID of the audio group for which to find the default codec info
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.parseCodecs = parseCodecs;
	
	var codecsFromDefault = function codecsFromDefault(master, audioGroupId) {
	  if (!master.mediaGroups.AUDIO || !audioGroupId) {
	    return null;
	  }
	
	  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
	
	  if (!audioGroup) {
	    return null;
	  }
	
	  for (var name in audioGroup) {
	    var audioType = audioGroup[name];
	
	    if (audioType.default && audioType.playlists) {
	      // codec should be the same for all playlists within the audio type
	      return parseCodecs(audioType.playlists[0].attributes.CODECS);
	    }
	  }
	
	  return null;
	};
	
	exports.codecsFromDefault = codecsFromDefault;
	
	var isVideoCodec = function isVideoCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.video.test(codec.trim().toLowerCase());
	};
	
	exports.isVideoCodec = isVideoCodec;
	
	var isAudioCodec = function isAudioCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.audio.test(codec.trim().toLowerCase());
	};
	
	exports.isAudioCodec = isAudioCodec;
	
	var isTextCodec = function isTextCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.text.test(codec.trim().toLowerCase());
	};
	
	exports.isTextCodec = isTextCodec;
	
	var getMimeForCodec = function getMimeForCodec(codecString) {
	  if (!codecString || typeof codecString !== 'string') {
	    return;
	  }
	
	  var codecs = codecString.toLowerCase().split(',').map(function (c) {
	    return translateLegacyCodec(c.trim());
	  }); // default to video type
	
	  var type = 'video'; // only change to audio type if the only codec we have is
	  // audio
	
	  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
	    type = 'audio';
	  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
	    // text uses application/<container> for now
	    type = 'application';
	  } // default the container to mp4
	
	
	  var container = 'mp4'; // every codec must be able to go into the container
	  // for that container to be the correct one
	
	  if (codecs.every(function (c) {
	    return regexs.mp4.test(c);
	  })) {
	    container = 'mp4';
	  } else if (codecs.every(function (c) {
	    return regexs.webm.test(c);
	  })) {
	    container = 'webm';
	  } else if (codecs.every(function (c) {
	    return regexs.ogg.test(c);
	  })) {
	    container = 'ogg';
	  }
	
	  return type + "/" + container + ";codecs=\"" + codecString + "\"";
	};
	
	exports.getMimeForCodec = getMimeForCodec;
	
	var browserSupportsCodec = function browserSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return _window.default.MediaSource && _window.default.MediaSource.isTypeSupported && _window.default.MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
	};
	
	exports.browserSupportsCodec = browserSupportsCodec;
	
	var muxerSupportsCodec = function muxerSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return codecString.toLowerCase().split(',').every(function (codec) {
	    codec = codec.trim(); // any match is supported.
	
	    for (var i = 0; i < upperMediaTypes.length; i++) {
	      var type = upperMediaTypes[i];
	
	      if (regexs["muxer" + type].test(codec)) {
	        return true;
	      }
	    }
	
	    return false;
	  });
	};
	
	exports.muxerSupportsCodec = muxerSupportsCodec;
	var DEFAULT_AUDIO_CODEC = 'mp4a.40.2';
	exports.DEFAULT_AUDIO_CODEC = DEFAULT_AUDIO_CODEC;
	var DEFAULT_VIDEO_CODEC = 'avc1.4d400d';
	exports.DEFAULT_VIDEO_CODEC = DEFAULT_VIDEO_CODEC;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLikelyFmp4MediaSegment = exports.detectContainerForBytes = exports.isLikely = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	var _mp4Helpers = __webpack_require__(170);
	
	var _ebmlHelpers = __webpack_require__(167);
	
	var _id3Helpers = __webpack_require__(24);
	
	var _nalHelpers = __webpack_require__(171);
	
	var CONSTANTS = {
	  // "webm" string literal in hex
	  'webm': (0, _byteHelpers.toUint8)([0x77, 0x65, 0x62, 0x6d]),
	  // "matroska" string literal in hex
	  'matroska': (0, _byteHelpers.toUint8)([0x6d, 0x61, 0x74, 0x72, 0x6f, 0x73, 0x6b, 0x61]),
	  // "fLaC" string literal in hex
	  'flac': (0, _byteHelpers.toUint8)([0x66, 0x4c, 0x61, 0x43]),
	  // "OggS" string literal in hex
	  'ogg': (0, _byteHelpers.toUint8)([0x4f, 0x67, 0x67, 0x53]),
	  // ac-3 sync byte, also works for ec-3 as that is simply a codec
	  // of ac-3
	  'ac3': (0, _byteHelpers.toUint8)([0x0b, 0x77]),
	  // "RIFF" string literal in hex used for wav and avi
	  'riff': (0, _byteHelpers.toUint8)([0x52, 0x49, 0x46, 0x46]),
	  // "AVI" string literal in hex
	  'avi': (0, _byteHelpers.toUint8)([0x41, 0x56, 0x49]),
	  // "WAVE" string literal in hex
	  'wav': (0, _byteHelpers.toUint8)([0x57, 0x41, 0x56, 0x45]),
	  // "ftyp3g" string literal in hex
	  '3gp': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x33, 0x67]),
	  // "ftyp" string literal in hex
	  'mp4': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70]),
	  // "styp" string literal in hex
	  'fmp4': (0, _byteHelpers.toUint8)([0x73, 0x74, 0x79, 0x70]),
	  // "ftypqt" string literal in hex
	  'mov': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x71, 0x74]),
	  // moov string literal in hex
	  'moov': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x76]),
	  // moof string literal in hex
	  'moof': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x66])
	};
	var _isLikely = {
	  aac: function aac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x10], {
	      offset: offset,
	      mask: [0xFF, 0x16]
	    });
	  },
	  mp3: function mp3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x02], {
	      offset: offset,
	      mask: [0xFF, 0x06]
	    });
	  },
	  webm: function webm(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is webm
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.webm);
	  },
	  mkv: function mkv(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is matroska
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.matroska);
	  },
	  mp4: function mp4(bytes) {
	    // if this file is another base media file format, it is not mp4
	    if (_isLikely['3gp'](bytes) || _isLikely.mov(bytes)) {
	      return false;
	    } // if this file starts with a ftyp or styp box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mp4, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.fmp4, {
	      offset: 4
	    })) {
	      return true;
	    } // if this file starts with a moof/moov box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moof, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moov, {
	      offset: 4
	    })) {
	      return true;
	    }
	  },
	  mov: function mov(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mov, {
	      offset: 4
	    });
	  },
	  '3gp': function gp(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS['3gp'], {
	      offset: 4
	    });
	  },
	  ac3: function ac3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ac3, {
	      offset: offset
	    });
	  },
	  ts: function ts(bytes) {
	    if (bytes.length < 189 && bytes.length >= 1) {
	      return bytes[0] === 0x47;
	    }
	
	    var i = 0; // check the first 376 bytes for two matching sync bytes
	
	    while (i + 188 < bytes.length && i < 188) {
	      if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) {
	        return true;
	      }
	
	      i += 1;
	    }
	
	    return false;
	  },
	  flac: function flac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.flac, {
	      offset: offset
	    });
	  },
	  ogg: function ogg(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ogg);
	  },
	  avi: function avi(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.avi, {
	      offset: 8
	    });
	  },
	  wav: function wav(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.wav, {
	      offset: 8
	    });
	  },
	  'h264': function h264(bytes) {
	    // find seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH264Nal)(bytes, 7, 3).length;
	  },
	  'h265': function h265(bytes) {
	    // find video_parameter_set_rbsp or seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH265Nal)(bytes, [32, 33], 3).length;
	  }
	}; // get all the isLikely functions
	// but make sure 'ts' is above h264 and h265
	// but below everything else as it is the least specific
	
	var isLikelyTypes = Object.keys(_isLikely) // remove ts, h264, h265
	.filter(function (t) {
	  return t !== 'ts' && t !== 'h264' && t !== 'h265';
	}) // add it back to the bottom
	.concat(['ts', 'h264', 'h265']); // make sure we are dealing with uint8 data.
	
	isLikelyTypes.forEach(function (type) {
	  var isLikelyFn = _isLikely[type];
	
	  _isLikely[type] = function (bytes) {
	    return isLikelyFn((0, _byteHelpers.toUint8)(bytes));
	  };
	}); // export after wrapping
	
	var isLikely = _isLikely; // A useful list of file signatures can be found here
	// https://en.wikipedia.org/wiki/List_of_file_signatures
	
	exports.isLikely = isLikely;
	
	var detectContainerForBytes = function detectContainerForBytes(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  for (var i = 0; i < isLikelyTypes.length; i++) {
	    var type = isLikelyTypes[i];
	
	    if (isLikely[type](bytes)) {
	      return type;
	    }
	  }
	
	  return '';
	}; // fmp4 is not a container
	
	
	exports.detectContainerForBytes = detectContainerForBytes;
	
	var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment(bytes) {
	  return (0, _mp4Helpers.findBox)(bytes, ['moof']).length > 0;
	};
	
	exports.isLikelyFmp4MediaSegment = isLikelyFmp4MediaSegment;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseData = exports.parseTracks = exports.decodeBlock = exports.findEbml = exports.EBML_TAGS = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	var _codecHelpers = __webpack_require__(22);
	
	// relevant specs for this parser:
	// https://matroska-org.github.io/libebml/specs.html
	// https://www.matroska.org/technical/elements.html
	// https://www.webmproject.org/docs/container/
	var EBML_TAGS = {
	  EBML: (0, _byteHelpers.toUint8)([0x1A, 0x45, 0xDF, 0xA3]),
	  DocType: (0, _byteHelpers.toUint8)([0x42, 0x82]),
	  Segment: (0, _byteHelpers.toUint8)([0x18, 0x53, 0x80, 0x67]),
	  SegmentInfo: (0, _byteHelpers.toUint8)([0x15, 0x49, 0xA9, 0x66]),
	  Tracks: (0, _byteHelpers.toUint8)([0x16, 0x54, 0xAE, 0x6B]),
	  Track: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackNumber: (0, _byteHelpers.toUint8)([0xd7]),
	  DefaultDuration: (0, _byteHelpers.toUint8)([0x23, 0xe3, 0x83]),
	  TrackEntry: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackType: (0, _byteHelpers.toUint8)([0x83]),
	  FlagDefault: (0, _byteHelpers.toUint8)([0x88]),
	  CodecID: (0, _byteHelpers.toUint8)([0x86]),
	  CodecPrivate: (0, _byteHelpers.toUint8)([0x63, 0xA2]),
	  VideoTrack: (0, _byteHelpers.toUint8)([0xe0]),
	  AudioTrack: (0, _byteHelpers.toUint8)([0xe1]),
	  // Not used yet, but will be used for live webm/mkv
	  // see https://www.matroska.org/technical/basics.html#block-structure
	  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
	  Cluster: (0, _byteHelpers.toUint8)([0x1F, 0x43, 0xB6, 0x75]),
	  Timestamp: (0, _byteHelpers.toUint8)([0xE7]),
	  TimestampScale: (0, _byteHelpers.toUint8)([0x2A, 0xD7, 0xB1]),
	  BlockGroup: (0, _byteHelpers.toUint8)([0xA0]),
	  BlockDuration: (0, _byteHelpers.toUint8)([0x9B]),
	  Block: (0, _byteHelpers.toUint8)([0xA1]),
	  SimpleBlock: (0, _byteHelpers.toUint8)([0xA3])
	};
	/**
	 * This is a simple table to determine the length
	 * of things in ebml. The length is one based (starts at 1,
	 * rather than zero) and for every zero bit before a one bit
	 * we add one to length. We also need this table because in some
	 * case we have to xor all the length bits from another value.
	 */
	
	exports.EBML_TAGS = EBML_TAGS;
	var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
	
	var getLength = function getLength(byte) {
	  var len = 1;
	
	  for (var i = 0; i < LENGTH_TABLE.length; i++) {
	    if (byte & LENGTH_TABLE[i]) {
	      break;
	    }
	
	    len++;
	  }
	
	  return len;
	}; // length in ebml is stored in the first 4 to 8 bits
	// of the first byte. 4 for the id length and 8 for the
	// data size length. Length is measured by converting the number to binary
	// then 1 + the number of zeros before a 1 is encountered starting
	// from the left.
	
	
	var getvint = function getvint(bytes, offset, removeLength, signed) {
	  if (removeLength === void 0) {
	    removeLength = true;
	  }
	
	  if (signed === void 0) {
	    signed = false;
	  }
	
	  var length = getLength(bytes[offset]);
	  var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
	  // as they will be modified below to remove the dataSizeLen bits and we do not
	  // want to modify the original data. normally we could just call slice on
	  // uint8array but ie 11 does not support that...
	
	  if (removeLength) {
	    valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
	    valueBytes[0] ^= LENGTH_TABLE[length - 1];
	  }
	
	  return {
	    length: length,
	    value: (0, _byteHelpers.bytesToNumber)(valueBytes, {
	      signed: signed
	    }),
	    bytes: valueBytes
	  };
	};
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return path.match(/.{1,2}/g).map(function (p) {
	      return normalizePath(p);
	    });
	  }
	
	  if (typeof path === 'number') {
	    return (0, _byteHelpers.numberToBytes)(path);
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
	  if (offset >= bytes.length) {
	    return bytes.length;
	  }
	
	  var innerid = getvint(bytes, offset, false);
	
	  if ((0, _byteHelpers.bytesMatch)(id.bytes, innerid.bytes)) {
	    return offset;
	  }
	
	  var dataHeader = getvint(bytes, offset + innerid.length);
	  return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
	};
	/**
	 * Notes on the EBLM format.
	 *
	 * EBLM uses "vints" tags. Every vint tag contains
	 * two parts
	 *
	 * 1. The length from the first byte. You get this by
	 *    converting the byte to binary and counting the zeros
	 *    before a 1. Then you add 1 to that. Examples
	 *    00011111 = length 4 because there are 3 zeros before a 1.
	 *    00100000 = length 3 because there are 2 zeros before a 1.
	 *    00000011 = length 7 because there are 6 zeros before a 1.
	 *
	 * 2. The bits used for length are removed from the first byte
	 *    Then all the bytes are merged into a value. NOTE: this
	 *    is not the case for id ebml tags as there id includes
	 *    length bits.
	 *
	 */
	
	
	var findEbml = function findEbml(bytes, paths) {
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var id = getvint(bytes, i, false);
	    var dataHeader = getvint(bytes, i + id.length);
	    var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
	
	    if (dataHeader.value === 0x7f) {
	      dataHeader.value = getInfinityDataSize(id, bytes, dataStart);
	
	      if (dataHeader.value !== bytes.length) {
	        dataHeader.value -= dataStart;
	      }
	    }
	
	    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
	    var data = bytes.subarray(dataStart, dataEnd);
	
	    if ((0, _byteHelpers.bytesMatch)(paths[0], id.bytes)) {
	      if (paths.length === 1) {
	        // this is the end of the paths and we've found the tag we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next tag inside of the data
	        // of this one
	        results = results.concat(findEbml(data, paths.slice(1)));
	      }
	    }
	
	    var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
	
	    i += totalLength;
	  }
	
	  return results;
	}; // see https://www.matroska.org/technical/basics.html#block-structure
	
	
	exports.findEbml = findEbml;
	
	var decodeBlock = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
	  var duration;
	
	  if (type === 'group') {
	    duration = findEbml(block, [EBML_TAGS.BlockDuration])[0];
	
	    if (duration) {
	      duration = (0, _byteHelpers.bytesToNumber)(duration);
	      duration = 1 / timestampScale * duration * timestampScale / 1000;
	    }
	
	    block = findEbml(block, [EBML_TAGS.Block])[0];
	    type = 'block'; // treat data as a block after this point
	  }
	
	  var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
	  var trackNumber = getvint(block, 0);
	  var timestamp = dv.getInt16(trackNumber.length, false);
	  var flags = block[trackNumber.length + 2];
	  var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
	
	  var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
	
	  var parsed = {
	    duration: duration,
	    trackNumber: trackNumber.value,
	    keyframe: type === 'simple' && flags >> 7 === 1,
	    invisible: (flags & 0x08) >> 3 === 1,
	    lacing: (flags & 0x06) >> 1,
	    discardable: type === 'simple' && (flags & 0x01) === 1,
	    frames: [],
	    pts: ptsdts,
	    dts: ptsdts,
	    timestamp: timestamp
	  };
	
	  if (!parsed.lacing) {
	    parsed.frames.push(data);
	    return parsed;
	  }
	
	  var numberOfFrames = data[0] + 1;
	  var frameSizes = [];
	  var offset = 1; // Fixed
	
	  if (parsed.lacing === 2) {
	    var sizeOfFrame = (data.length - offset) / numberOfFrames;
	
	    for (var i = 0; i < numberOfFrames; i++) {
	      frameSizes.push(sizeOfFrame);
	    }
	  } // xiph
	
	
	  if (parsed.lacing === 1) {
	    for (var _i = 0; _i < numberOfFrames - 1; _i++) {
	      var size = 0;
	
	      do {
	        size += data[offset];
	        offset++;
	      } while (data[offset - 1] === 0xFF);
	
	      frameSizes.push(size);
	    }
	  } // ebml
	
	
	  if (parsed.lacing === 3) {
	    // first vint is unsinged
	    // after that vints are singed and
	    // based on a compounding size
	    var _size = 0;
	
	    for (var _i2 = 0; _i2 < numberOfFrames - 1; _i2++) {
	      var vint = _i2 === 0 ? getvint(data, offset) : getvint(data, offset, true, true);
	      _size += vint.value;
	      frameSizes.push(_size);
	      offset += vint.length;
	    }
	  }
	
	  frameSizes.forEach(function (size) {
	    parsed.frames.push(data.subarray(offset, offset + size));
	    offset += size;
	  });
	  return parsed;
	}; // VP9 Codec Feature Metadata (CodecPrivate)
	// https://www.webmproject.org/docs/container/
	
	
	exports.decodeBlock = decodeBlock;
	
	var parseVp9Private = function parseVp9Private(bytes) {
	  var i = 0;
	  var params = {};
	
	  while (i < bytes.length) {
	    var id = bytes[i] & 0x7f;
	    var len = bytes[i + 1];
	    var val = void 0;
	
	    if (len === 1) {
	      val = bytes[i + 2];
	    } else {
	      val = bytes.subarray(i + 2, i + 2 + len);
	    }
	
	    if (id === 1) {
	      params.profile = val;
	    } else if (id === 2) {
	      params.level = val;
	    } else if (id === 3) {
	      params.bitDepth = val;
	    } else if (id === 4) {
	      params.chromaSubsampling = val;
	    } else {
	      params[id] = val;
	    }
	
	    i += 2 + len;
	  }
	
	  return params;
	};
	
	var parseTracks = function parseTracks(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var decodedTracks = [];
	  var tracks = findEbml(bytes, [EBML_TAGS.Segment, EBML_TAGS.Tracks, EBML_TAGS.Track]);
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Tracks, EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    return decodedTracks;
	  }
	
	  tracks.forEach(function (track) {
	    var trackType = findEbml(track, EBML_TAGS.TrackType)[0];
	
	    if (!trackType || !trackType.length) {
	      return;
	    } // 1 is video, 2 is audio, 17 is subtitle
	    // other values are unimportant in this context
	
	
	    if (trackType[0] === 1) {
	      trackType = 'video';
	    } else if (trackType[0] === 2) {
	      trackType = 'audio';
	    } else if (trackType[0] === 17) {
	      trackType = 'subtitle';
	    } else {
	      return;
	    } // todo parse language
	
	
	    var decodedTrack = {
	      rawCodec: (0, _byteHelpers.bytesToString)(findEbml(track, [EBML_TAGS.CodecID])[0]),
	      type: trackType,
	      codecPrivate: findEbml(track, [EBML_TAGS.CodecPrivate])[0],
	      number: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.TrackNumber])[0]),
	      defaultDuration: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.DefaultDuration])[0]),
	      default: findEbml(track, [EBML_TAGS.FlagDefault])[0],
	      rawData: track
	    };
	    var codec = '';
	
	    if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) {
	      codec = "avc1." + (0, _codecHelpers.getAvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) {
	      codec = "hev1." + (0, _codecHelpers.getHvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
	      } else {
	        codec = 'mp4v.20.9';
	      }
	    } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) {
	      codec = 'theora';
	    } else if (/^V_VP8/.test(decodedTrack.rawCodec)) {
	      codec = 'vp8';
	    } else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        var _parseVp9Private = parseVp9Private(decodedTrack.codecPrivate),
	            profile = _parseVp9Private.profile,
	            level = _parseVp9Private.level,
	            bitDepth = _parseVp9Private.bitDepth,
	            chromaSubsampling = _parseVp9Private.chromaSubsampling;
	
	        codec = 'vp09.';
	        codec += (0, _byteHelpers.padStart)(profile, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(level, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(bitDepth, 2, '0') + ".";
	        codec += "" + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name
	
	        var matrixCoefficients = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB1]])[0] || [];
	        var videoFullRangeFlag = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB9]])[0] || [];
	        var transferCharacteristics = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBA]])[0] || [];
	        var colourPrimaries = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBB]])[0] || []; // if we find any optional codec parameter specify them all.
	
	        if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
	          codec += "." + (0, _byteHelpers.padStart)(colourPrimaries[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag[0], 2, '0');
	        }
	      } else {
	        codec = 'vp9';
	      }
	    } else if (/^V_AV1/.test(decodedTrack.rawCodec)) {
	      codec = "av01." + (0, _codecHelpers.getAv1Codec)(decodedTrack.codecPrivate);
	    } else if (/A_ALAC/.test(decodedTrack.rawCodec)) {
	      codec = 'alac';
	    } else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) {
	      codec = 'mp2';
	    } else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) {
	      codec = 'mp3';
	    } else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
	      } else {
	        codec = 'mp4a.40.2';
	      }
	    } else if (/^A_AC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ac-3';
	    } else if (/^A_PCM/.test(decodedTrack.rawCodec)) {
	      codec = 'pcm';
	    } else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) {
	      codec = 'speex';
	    } else if (/^A_EAC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ec-3';
	    } else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) {
	      codec = 'vorbis';
	    } else if (/^A_FLAC/.test(decodedTrack.rawCodec)) {
	      codec = 'flac';
	    } else if (/^A_OPUS/.test(decodedTrack.rawCodec)) {
	      codec = 'opus';
	    }
	
	    decodedTrack.codec = codec;
	    decodedTracks.push(decodedTrack);
	  });
	  return decodedTracks.sort(function (a, b) {
	    return a.number - b.number;
	  });
	};
	
	exports.parseTracks = parseTracks;
	
	var parseData = function parseData(data, tracks) {
	  var allBlocks = [];
	  var segment = findEbml(data, [EBML_TAGS.Segment])[0];
	  var timestampScale = findEbml(segment, [EBML_TAGS.SegmentInfo, EBML_TAGS.TimestampScale])[0]; // in nanoseconds, defaults to 1ms
	
	  if (timestampScale && timestampScale.length) {
	    timestampScale = (0, _byteHelpers.bytesToNumber)(timestampScale);
	  } else {
	    timestampScale = 1000000;
	  }
	
	  var clusters = findEbml(segment, [EBML_TAGS.Cluster]);
	
	  if (!tracks) {
	    tracks = parseTracks(segment);
	  }
	
	  clusters.forEach(function (cluster, ci) {
	    var simpleBlocks = findEbml(cluster, [EBML_TAGS.SimpleBlock]).map(function (b) {
	      return {
	        type: 'simple',
	        data: b
	      };
	    });
	    var blockGroups = findEbml(cluster, [EBML_TAGS.BlockGroup]).map(function (b) {
	      return {
	        type: 'group',
	        data: b
	      };
	    });
	    var timestamp = findEbml(cluster, [EBML_TAGS.Timestamp])[0] || 0;
	
	    if (timestamp && timestamp.length) {
	      timestamp = (0, _byteHelpers.bytesToNumber)(timestamp);
	    } // get all blocks then sort them into the correct order
	
	
	    var blocks = simpleBlocks.concat(blockGroups).sort(function (a, b) {
	      return a.data.byteOffset - b.data.byteOffset;
	    });
	    blocks.forEach(function (block, bi) {
	      var decoded = decodeBlock(block.data, block.type, timestampScale, timestamp);
	      allBlocks.push(decoded);
	    });
	  });
	  return {
	    tracks: tracks,
	    blocks: allBlocks
	  };
	};
	
	exports.parseData = parseData;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forEachMediaGroup = void 0;
	
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {string[]} groups
	 *        The media groups to call the callback for
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	var forEachMediaGroup = function forEachMediaGroup(master, groups, callback) {
	  groups.forEach(function (mediaType) {
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	
	exports.forEachMediaGroup = forEachMediaGroup;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simpleTypeFromSourceType = void 0;
	var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
	var DASH_REGEX = /^application\/dash\+xml/i;
	/**
	 * Returns a string that describes the type of source based on a video source object's
	 * media type.
	 *
	 * @see {@link https://dev.w3.org/html5/pf-summary/video.html#dom-source-type|Source Type}
	 *
	 * @param {string} type
	 *        Video source object media type
	 * @return {('hls'|'dash'|'vhs-json'|null)}
	 *         VHS source type string
	 */
	
	var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
	  if (MPEGURL_REGEX.test(type)) {
	    return 'hls';
	  }
	
	  if (DASH_REGEX.test(type)) {
	    return 'dash';
	  } // Denotes the special case of a manifest object passed to http-streaming instead of a
	  // source URL.
	  //
	  // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
	  //
	  // In this case, vnd stands for vendor, video.js for the organization, VHS for this
	  // project, and the +json suffix identifies the structure of the media type.
	
	
	  if (type === 'application/vnd.videojs.vhs+json') {
	    return 'vhs-json';
	  }
	
	  return null;
	};
	
	exports.simpleTypeFromSourceType = simpleTypeFromSourceType;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseMediaInfo = exports.parseTracks = exports.addSampleDescription = exports.buildFrameTable = exports.findNamedBox = exports.findBox = exports.parseDescriptors = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	var _codecHelpers = __webpack_require__(22);
	
	var _opusHelpers = __webpack_require__(172);
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return (0, _byteHelpers.stringToBytes)(path);
	  }
	
	  if (typeof path === 'number') {
	    return path;
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var DESCRIPTORS;
	
	var parseDescriptors = function parseDescriptors(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	  var i = 0;
	
	  while (bytes.length > i) {
	    var tag = bytes[i];
	    var size = 0;
	    var headerSize = 0; // tag
	
	    headerSize++;
	    var byte = bytes[headerSize]; // first byte
	
	    headerSize++;
	
	    while (byte & 0x80) {
	      size = (byte & 0x7F) << 7;
	      byte = bytes[headerSize];
	      headerSize++;
	    }
	
	    size += byte & 0x7F;
	
	    for (var z = 0; z < DESCRIPTORS.length; z++) {
	      var _DESCRIPTORS$z = DESCRIPTORS[z],
	          id = _DESCRIPTORS$z.id,
	          parser = _DESCRIPTORS$z.parser;
	
	      if (tag === id) {
	        results.push(parser(bytes.subarray(headerSize, headerSize + size)));
	        break;
	      }
	    }
	
	    i += size + headerSize;
	  }
	
	  return results;
	};
	
	exports.parseDescriptors = parseDescriptors;
	DESCRIPTORS = [{
	  id: 0x03,
	  parser: function parser(bytes) {
	    var desc = {
	      tag: 0x03,
	      id: bytes[0] << 8 | bytes[1],
	      flags: bytes[2],
	      size: 3,
	      dependsOnEsId: 0,
	      ocrEsId: 0,
	      descriptors: [],
	      url: ''
	    }; // depends on es id
	
	    if (desc.flags & 0x80) {
	      desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    } // url
	
	
	    if (desc.flags & 0x40) {
	      var len = bytes[desc.size];
	      desc.url = (0, _byteHelpers.bytesToString)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
	      desc.size += len;
	    } // ocr es id
	
	
	    if (desc.flags & 0x20) {
	      desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    }
	
	    desc.descriptors = parseDescriptors(bytes.subarray(desc.size)) || [];
	    return desc;
	  }
	}, {
	  id: 0x04,
	  parser: function parser(bytes) {
	    // DecoderConfigDescriptor
	    var desc = {
	      tag: 0x04,
	      oti: bytes[0],
	      streamType: bytes[1],
	      bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
	      maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
	      avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
	      descriptors: parseDescriptors(bytes.subarray(13))
	    };
	    return desc;
	  }
	}, {
	  id: 0x05,
	  parser: function parser(bytes) {
	    // DecoderSpecificInfo
	    return {
	      tag: 0x05,
	      bytes: bytes
	    };
	  }
	}, {
	  id: 0x06,
	  parser: function parser(bytes) {
	    // SLConfigDescriptor
	    return {
	      tag: 0x06,
	      bytes: bytes
	    };
	  }
	}];
	/**
	 * find any number of boxes by name given a path to it in an iso bmff
	 * such as mp4.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {Uint8Array[]|string[]|string|Uint8Array} name
	 *        An array of paths or a single path representing the name
	 *        of boxes to search through in bytes. Paths may be
	 *        uint8 (character codes) or strings.
	 *
	 * @param {boolean} [complete=false]
	 *        Should we search only for complete boxes on the final path.
	 *        This is very useful when you do not want to get back partial boxes
	 *        in the case of streaming files.
	 *
	 * @return {Uint8Array[]}
	 *         An array of the end paths that we found.
	 */
	
	var findBox = function findBox(bytes, paths, complete) {
	  if (complete === void 0) {
	    complete = false;
	  }
	
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    // short-circuit the search for empty paths
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
	    var type = bytes.subarray(i + 4, i + 8); // invalid box format.
	
	    if (size === 0) {
	      break;
	    }
	
	    var end = i + size;
	
	    if (end > bytes.length) {
	      // this box is bigger than the number of bytes we have
	      // and complete is set, we cannot find any more boxes.
	      if (complete) {
	        break;
	      }
	
	      end = bytes.length;
	    }
	
	    var data = bytes.subarray(i + 8, end);
	
	    if ((0, _byteHelpers.bytesMatch)(type, paths[0])) {
	      if (paths.length === 1) {
	        // this is the end of the path and we've found the box we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next box along the path
	        results.push.apply(results, findBox(data, paths.slice(1), complete));
	      }
	    }
	
	    i = end;
	  } // we've finished searching all of bytes
	
	
	  return results;
	};
	/**
	 * Search for a single matching box by name in an iso bmff format like
	 * mp4. This function is useful for finding codec boxes which
	 * can be placed arbitrarily in sample descriptions depending
	 * on the version of the file or file type.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {string|Uint8Array} name
	 *        The name of the box to find.
	 *
	 * @return {Uint8Array[]}
	 *         a subarray of bytes representing the name boxed we found.
	 */
	
	
	exports.findBox = findBox;
	
	var findNamedBox = function findNamedBox(bytes, name) {
	  name = normalizePath(name);
	
	  if (!name.length) {
	    // short-circuit the search for empty paths
	    return bytes.subarray(bytes.length);
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + name.length), name)) {
	      var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
	      var end = size > 1 ? i + size : bytes.byteLength;
	      return bytes.subarray(i + 4, end);
	    }
	
	    i++;
	  } // we've finished searching all of bytes
	
	
	  return bytes.subarray(bytes.length);
	};
	
	exports.findNamedBox = findNamedBox;
	
	var parseSamples = function parseSamples(data, entrySize, parseEntry) {
	  if (entrySize === void 0) {
	    entrySize = 4;
	  }
	
	  if (parseEntry === void 0) {
	    parseEntry = function parseEntry(d) {
	      return (0, _byteHelpers.bytesToNumber)(d);
	    };
	  }
	
	  var entries = [];
	
	  if (!data || !data.length) {
	    return entries;
	  }
	
	  var entryCount = (0, _byteHelpers.bytesToNumber)(data.subarray(4, 8));
	
	  for (var i = 8; entryCount; i += entrySize, entryCount--) {
	    entries.push(parseEntry(data.subarray(i, i + entrySize)));
	  }
	
	  return entries;
	};
	
	var buildFrameTable = function buildFrameTable(stbl, timescale) {
	  var keySamples = parseSamples(findBox(stbl, ['stss'])[0]);
	  var chunkOffsets = parseSamples(findBox(stbl, ['stco'])[0]);
	  var timeToSamples = parseSamples(findBox(stbl, ['stts'])[0], 8, function (entry) {
	    return {
	      sampleCount: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      sampleDelta: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8))
	    };
	  });
	  var samplesToChunks = parseSamples(findBox(stbl, ['stsc'])[0], 12, function (entry) {
	    return {
	      firstChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      samplesPerChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8)),
	      sampleDescriptionIndex: (0, _byteHelpers.bytesToNumber)(entry.subarray(8, 12))
	    };
	  });
	  var stsz = findBox(stbl, ['stsz'])[0]; // stsz starts with a 4 byte sampleSize which we don't need
	
	  var sampleSizes = parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
	  var frames = [];
	
	  for (var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++) {
	    var samplesInChunk = void 0;
	
	    for (var i = 0; i < samplesToChunks.length; i++) {
	      var sampleToChunk = samplesToChunks[i];
	      var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
	
	      if (isThisOne) {
	        samplesInChunk = sampleToChunk.samplesPerChunk;
	        break;
	      }
	    }
	
	    var chunkOffset = chunkOffsets[chunkIndex];
	
	    for (var _i = 0; _i < samplesInChunk; _i++) {
	      var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
	
	      var keyframe = !keySamples.length;
	
	      if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) {
	        keyframe = true;
	      }
	
	      var frame = {
	        keyframe: keyframe,
	        start: chunkOffset,
	        end: chunkOffset + frameEnd
	      };
	
	      for (var k = 0; k < timeToSamples.length; k++) {
	        var _timeToSamples$k = timeToSamples[k],
	            sampleCount = _timeToSamples$k.sampleCount,
	            sampleDelta = _timeToSamples$k.sampleDelta;
	
	        if (frames.length <= sampleCount) {
	          // ms to ns
	          var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
	          frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
	          frame.duration = sampleDelta;
	          break;
	        }
	      }
	
	      frames.push(frame);
	      chunkOffset += frameEnd;
	    }
	  }
	
	  return frames;
	};
	
	exports.buildFrameTable = buildFrameTable;
	
	var addSampleDescription = function addSampleDescription(track, bytes) {
	  var codec = (0, _byteHelpers.bytesToString)(bytes.subarray(0, 4));
	
	  if (track.type === 'video') {
	    track.info = track.info || {};
	    track.info.width = bytes[28] << 8 | bytes[29];
	    track.info.height = bytes[30] << 8 | bytes[31];
	  } else if (track.type === 'audio') {
	    track.info = track.info || {};
	    track.info.channels = bytes[20] << 8 | bytes[21];
	    track.info.bitDepth = bytes[22] << 8 | bytes[23];
	    track.info.sampleRate = bytes[28] << 8 | bytes[29];
	  }
	
	  if (codec === 'avc1') {
	    var avcC = findNamedBox(bytes, 'avcC'); // AVCDecoderConfigurationRecord
	
	    codec += "." + (0, _codecHelpers.getAvcCodec)(avcC);
	    track.info.avcC = avcC; // TODO: do we need to parse all this?
	
	    /* {
	      configurationVersion: avcC[0],
	      profile: avcC[1],
	      profileCompatibility: avcC[2],
	      level: avcC[3],
	      lengthSizeMinusOne: avcC[4] & 0x3
	    };
	     let spsNalUnitCount = avcC[5] & 0x1F;
	    const spsNalUnits = track.info.avc.spsNalUnits = [];
	     // past spsNalUnitCount
	    let offset = 6;
	     while (spsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }
	    let ppsNalUnitCount = avcC[offset];
	    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
	     // past ppsNalUnitCount
	    offset += 1;
	     while (ppsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }*/
	    // HEVCDecoderConfigurationRecord
	  } else if (codec === 'hvc1' || codec === 'hev1') {
	    codec += "." + (0, _codecHelpers.getHvcCodec)(findNamedBox(bytes, 'hvcC'));
	  } else if (codec === 'mp4a' || codec === 'mp4v') {
	    var esds = findNamedBox(bytes, 'esds');
	    var esDescriptor = parseDescriptors(esds.subarray(4))[0];
	    var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function (_ref) {
	      var tag = _ref.tag;
	      return tag === 0x04;
	    })[0];
	
	    if (decoderConfig) {
	      // most codecs do not have a further '.'
	      // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
	      codec += '.' + (0, _byteHelpers.toHexString)(decoderConfig.oti);
	
	      if (decoderConfig.oti === 0x40) {
	        codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
	      } else if (decoderConfig.oti === 0x20) {
	        codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
	      } else if (decoderConfig.oti === 0xdd) {
	        codec = 'vorbis';
	      }
	    } else if (track.type === 'audio') {
	      codec += '.40.2';
	    } else {
	      codec += '.20.9';
	    }
	  } else if (codec === 'av01') {
	    // AV1DecoderConfigurationRecord
	    codec += "." + (0, _codecHelpers.getAv1Codec)(findNamedBox(bytes, 'av1C'));
	  } else if (codec === 'vp09') {
	    // VPCodecConfigurationRecord
	    var vpcC = findNamedBox(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/
	
	    var profile = vpcC[0];
	    var level = vpcC[1];
	    var bitDepth = vpcC[2] >> 4;
	    var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
	    var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
	    var colourPrimaries = vpcC[3];
	    var transferCharacteristics = vpcC[4];
	    var matrixCoefficients = vpcC[5];
	    codec += "." + (0, _byteHelpers.padStart)(profile, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(level, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(colourPrimaries, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag, 2, '0');
	  } else if (codec === 'theo') {
	    codec = 'theora';
	  } else if (codec === 'spex') {
	    codec = 'speex';
	  } else if (codec === '.mp3') {
	    codec = 'mp4a.40.34';
	  } else if (codec === 'msVo') {
	    codec = 'vorbis';
	  } else if (codec === 'Opus') {
	    codec = 'opus';
	    var dOps = findNamedBox(bytes, 'dOps');
	    track.info.opus = (0, _opusHelpers.parseOpusHead)(dOps); // TODO: should this go into the webm code??
	    // Firefox requires a codecDelay for opus playback
	    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
	
	    track.info.codecDelay = 6500000;
	  } else {
	    codec = codec.toLowerCase();
	  }
	  /* eslint-enable */
	  // flac, ac-3, ec-3, opus
	
	
	  track.codec = codec;
	};
	
	exports.addSampleDescription = addSampleDescription;
	
	var parseTracks = function parseTracks(bytes, frameTable) {
	  if (frameTable === void 0) {
	    frameTable = true;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var traks = findBox(bytes, ['moov', 'trak'], true);
	  var tracks = [];
	  traks.forEach(function (trak) {
	    var track = {
	      bytes: trak
	    };
	    var mdia = findBox(trak, ['mdia'])[0];
	    var hdlr = findBox(mdia, ['hdlr'])[0];
	    var trakType = (0, _byteHelpers.bytesToString)(hdlr.subarray(8, 12));
	
	    if (trakType === 'soun') {
	      track.type = 'audio';
	    } else if (trakType === 'vide') {
	      track.type = 'video';
	    } else {
	      track.type = trakType;
	    }
	
	    var tkhd = findBox(trak, ['tkhd'])[0];
	
	    if (tkhd) {
	      var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	      var tkhdVersion = view.getUint8(0);
	      track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	    }
	
	    var mdhd = findBox(mdia, ['mdhd'])[0];
	
	    if (mdhd) {
	      // mdhd is a FullBox, meaning it will have its own version as the first byte
	      var version = mdhd[0];
	      var index = version === 0 ? 12 : 20;
	      track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
	    }
	
	    var stbl = findBox(mdia, ['minf', 'stbl'])[0];
	    var stsd = findBox(stbl, ['stsd'])[0];
	    var descriptionCount = (0, _byteHelpers.bytesToNumber)(stsd.subarray(4, 8));
	    var offset = 8; // add codec and codec info
	
	    while (descriptionCount--) {
	      var len = (0, _byteHelpers.bytesToNumber)(stsd.subarray(offset, offset + 4));
	      var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
	      addSampleDescription(track, sampleDescriptor);
	      offset += 4 + len;
	    }
	
	    if (frameTable) {
	      track.frameTable = buildFrameTable(stbl, track.timescale);
	    } // codec has no sub parameters
	
	
	    tracks.push(track);
	  });
	  return tracks;
	};
	
	exports.parseTracks = parseTracks;
	
	var parseMediaInfo = function parseMediaInfo(bytes) {
	  var mvhd = findBox(bytes, ['moov', 'mvhd'], true)[0];
	
	  if (!mvhd || !mvhd.length) {
	    return;
	  }
	
	  var info = {}; // ms to ns
	  // mvhd v1 has 8 byte duration and other fields too
	
	  if (mvhd[0] === 1) {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(20, 24));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(24, 32));
	  } else {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(12, 16));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(16, 20));
	  }
	
	  info.bytes = mvhd;
	  return info;
	};
	
	exports.parseMediaInfo = parseMediaInfo;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findH265Nal = exports.findH264Nal = exports.findNal = exports.discardEmulationPreventionBytes = exports.EMULATION_PREVENTION = exports.NAL_TYPE_TWO = exports.NAL_TYPE_ONE = void 0;
	
	var _byteHelpers = __webpack_require__(3);
	
	var NAL_TYPE_ONE = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x00, 0x01]);
	exports.NAL_TYPE_ONE = NAL_TYPE_ONE;
	var NAL_TYPE_TWO = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x01]);
	exports.NAL_TYPE_TWO = NAL_TYPE_TWO;
	var EMULATION_PREVENTION = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x03]);
	/**
	 * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	 * Sequence Payload"
	 *
	 * @param data {Uint8Array} the bytes of a RBSP from a NAL
	 * unit
	 * @return {Uint8Array} the RBSP without any Emulation
	 * Prevention Bytes
	 */
	
	exports.EMULATION_PREVENTION = EMULATION_PREVENTION;
	
	var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(bytes) {
	  var positions = [];
	  var i = 1; // Find all `Emulation Prevention Bytes`
	
	  while (i < bytes.length - 2) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
	      positions.push(i + 2);
	      i++;
	    }
	
	    i++;
	  } // If no Emulation Prevention Bytes were found just return the original
	  // array
	
	
	  if (positions.length === 0) {
	    return bytes;
	  } // Create a new array to hold the NAL unit data
	
	
	  var newLength = bytes.length - positions.length;
	  var newData = new Uint8Array(newLength);
	  var sourceIndex = 0;
	
	  for (i = 0; i < newLength; sourceIndex++, i++) {
	    if (sourceIndex === positions[0]) {
	      // Skip this byte
	      sourceIndex++; // Remove this position index
	
	      positions.shift();
	    }
	
	    newData[i] = bytes[sourceIndex];
	  }
	
	  return newData;
	};
	
	exports.discardEmulationPreventionBytes = discardEmulationPreventionBytes;
	
	var findNal = function findNal(bytes, dataType, types, nalLimit) {
	  if (nalLimit === void 0) {
	    nalLimit = Infinity;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  types = [].concat(types);
	  var i = 0;
	  var nalStart;
	  var nalsFound = 0; // keep searching until:
	  // we reach the end of bytes
	  // we reach the maximum number of nals they want to seach
	  // NOTE: that we disregard nalLimit when we have found the start
	  // of the nal we want so that we can find the end of the nal we want.
	
	  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
	    var nalOffset = void 0;
	
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_ONE)) {
	      nalOffset = 4;
	    } else if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_TWO)) {
	      nalOffset = 3;
	    } // we are unsynced,
	    // find the next nal unit
	
	
	    if (!nalOffset) {
	      i++;
	      continue;
	    }
	
	    nalsFound++;
	
	    if (nalStart) {
	      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
	    }
	
	    var nalType = void 0;
	
	    if (dataType === 'h264') {
	      nalType = bytes[i + nalOffset] & 0x1f;
	    } else if (dataType === 'h265') {
	      nalType = bytes[i + nalOffset] >> 1 & 0x3f;
	    }
	
	    if (types.indexOf(nalType) !== -1) {
	      nalStart = i + nalOffset;
	    } // nal header is 1 length for h264, and 2 for h265
	
	
	    i += nalOffset + (dataType === 'h264' ? 1 : 2);
	  }
	
	  return bytes.subarray(0, 0);
	};
	
	exports.findNal = findNal;
	
	var findH264Nal = function findH264Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h264', type, nalLimit);
	};
	
	exports.findH264Nal = findH264Nal;
	
	var findH265Nal = function findH265Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h265', type, nalLimit);
	};
	
	exports.findH265Nal = findH265Nal;

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOpusHead = exports.parseOpusHead = exports.OPUS_HEAD = void 0;
	var OPUS_HEAD = new Uint8Array([// O, p, u, s
	0x4f, 0x70, 0x75, 0x73, // H, e, a, d
	0x48, 0x65, 0x61, 0x64]); // https://wiki.xiph.org/OggOpus
	// https://vfrmaniac.fushizen.eu/contents/opus_in_isobmff.html
	// https://opus-codec.org/docs/opusfile_api-0.7/structOpusHead.html
	
	exports.OPUS_HEAD = OPUS_HEAD;
	
	var parseOpusHead = function parseOpusHead(bytes) {
	  var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	  var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
	
	  var littleEndian = version !== 0;
	  var config = {
	    version: version,
	    channels: view.getUint8(1),
	    preSkip: view.getUint16(2, littleEndian),
	    sampleRate: view.getUint32(4, littleEndian),
	    outputGain: view.getUint16(8, littleEndian),
	    channelMappingFamily: view.getUint8(10)
	  };
	
	  if (config.channelMappingFamily > 0 && bytes.length > 10) {
	    config.streamCount = view.getUint8(11);
	    config.twoChannelStreamCount = view.getUint8(12);
	    config.channelMapping = [];
	
	    for (var c = 0; c < config.channels; c++) {
	      config.channelMapping.push(view.getUint8(13 + c));
	    }
	  }
	
	  return config;
	};
	
	exports.parseOpusHead = parseOpusHead;
	
	var setOpusHead = function setOpusHead(config) {
	  var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
	  var view = new DataView(new ArrayBuffer(size));
	  var littleEndian = config.version !== 0;
	  view.setUint8(0, config.version);
	  view.setUint8(1, config.channels);
	  view.setUint16(2, config.preSkip, littleEndian);
	  view.setUint32(4, config.sampleRate, littleEndian);
	  view.setUint16(8, config.outputGain, littleEndian);
	  view.setUint8(10, config.channelMappingFamily);
	
	  if (config.channelMappingFamily > 0) {
	    view.setUint8(11, config.streamCount);
	    config.channelMapping.foreach(function (cm, i) {
	      view.setUint8(12 + i, cm);
	    });
	  }
	
	  return new Uint8Array(view.buffer);
	};
	
	exports.setOpusHead = setOpusHead;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * @file stream.js
	 */
	
	/**
	 * A lightweight readable stream implemention that handles event dispatching.
	 *
	 * @class Stream
	 */
	var Stream = /*#__PURE__*/function () {
	  function Stream() {
	    this.listeners = {};
	  }
	  /**
	   * Add a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener the callback to be invoked when an event of
	   * the specified type occurs
	   */
	
	
	  var _proto = Stream.prototype;
	
	  _proto.on = function on(type, listener) {
	    if (!this.listeners[type]) {
	      this.listeners[type] = [];
	    }
	
	    this.listeners[type].push(listener);
	  }
	  /**
	   * Remove a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener  a function previously registered for this
	   * type of event through `on`
	   * @return {boolean} if we could turn it off or not
	   */
	  ;
	
	  _proto.off = function off(type, listener) {
	    if (!this.listeners[type]) {
	      return false;
	    }
	
	    var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	    // In Video.js we slice listener functions
	    // on trigger so that it does not mess up the order
	    // while we loop through.
	    //
	    // Here we slice on off so that the loop in trigger
	    // can continue using it's old reference to loop without
	    // messing up the order.
	
	    this.listeners[type] = this.listeners[type].slice(0);
	    this.listeners[type].splice(index, 1);
	    return index > -1;
	  }
	  /**
	   * Trigger an event of the specified type on this stream. Any additional
	   * arguments to this function are passed as parameters to event listeners.
	   *
	   * @param {string} type the event name
	   */
	  ;
	
	  _proto.trigger = function trigger(type) {
	    var callbacks = this.listeners[type];
	
	    if (!callbacks) {
	      return;
	    } // Slicing the arguments on every invocation of this method
	    // can add a significant amount of overhead. Avoid the
	    // intermediate object creation for the common case of a
	    // single callback argument
	
	
	    if (arguments.length === 2) {
	      var length = callbacks.length;
	
	      for (var i = 0; i < length; ++i) {
	        callbacks[i].call(this, arguments[1]);
	      }
	    } else {
	      var args = Array.prototype.slice.call(arguments, 1);
	      var _length = callbacks.length;
	
	      for (var _i = 0; _i < _length; ++_i) {
	        callbacks[_i].apply(this, args);
	      }
	    }
	  }
	  /**
	   * Destroys the stream and cleans up.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.listeners = {};
	  }
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   *
	   * @param {Stream} destination the stream that will receive all `data` events
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	  ;
	
	  _proto.pipe = function pipe(destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	  };
	
	  return Stream;
	}();
	
	exports.default = Stream;
	module.exports = exports.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(2);
	
	var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
	  if (decodeResponseBody === void 0) {
	    decodeResponseBody = false;
	  }
	
	  return function (err, response, responseBody) {
	    // if the XHR failed, return that error
	    if (err) {
	      callback(err);
	      return;
	    } // if the HTTP status code is 4xx or 5xx, the request also failed
	
	
	    if (response.statusCode >= 400 && response.statusCode <= 599) {
	      var cause = responseBody;
	
	      if (decodeResponseBody) {
	        if (window.TextDecoder) {
	          var charset = getCharset(response.headers && response.headers['content-type']);
	
	          try {
	            cause = new TextDecoder(charset).decode(responseBody);
	          } catch (e) {}
	        } else {
	          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
	        }
	      }
	
	      callback({
	        cause: cause
	      });
	      return;
	    } // otherwise, request succeeded
	
	
	    callback(null, responseBody);
	  };
	};
	
	function getCharset(contentTypeHeader) {
	  if (contentTypeHeader === void 0) {
	    contentTypeHeader = '';
	  }
	
	  return contentTypeHeader.toLowerCase().split(';').reduce(function (charset, contentType) {
	    var _contentType$split = contentType.split('='),
	        type = _contentType$split[0],
	        value = _contentType$split[1];
	
	    if (type.trim() === 'charset') {
	      return value.trim();
	    }
	
	    return charset;
	  }, 'utf-8');
	}
	
	module.exports = httpResponseHandler;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(2);
	
	var _extends = __webpack_require__(10);
	
	var isFunction = __webpack_require__(198);
	
	createXHR.httpHandler = __webpack_require__(174);
	/**
	 * @license
	 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
	 * Copyright (c) 2014 David Björklund
	 * Available under the MIT license
	 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
	 */
	
	var parseHeaders = function parseHeaders(headers) {
	  var result = {};
	
	  if (!headers) {
	    return result;
	  }
	
	  headers.trim().split('\n').forEach(function (row) {
	    var index = row.indexOf(':');
	    var key = row.slice(0, index).trim().toLowerCase();
	    var value = row.slice(index + 1).trim();
	
	    if (typeof result[key] === 'undefined') {
	      result[key] = value;
	    } else if (Array.isArray(result[key])) {
	      result[key].push(value);
	    } else {
	      result[key] = [result[key], value];
	    }
	  });
	  return result;
	};
	
	module.exports = createXHR; // Allow use of default import syntax in TypeScript
	
	module.exports.default = createXHR;
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
	createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
	  createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
	    options = initParams(uri, options, callback);
	    options.method = method.toUpperCase();
	    return _createXHR(options);
	  };
	});
	
	function forEachArray(array, iterator) {
	  for (var i = 0; i < array.length; i++) {
	    iterator(array[i]);
	  }
	}
	
	function isEmpty(obj) {
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) return false;
	  }
	
	  return true;
	}
	
	function initParams(uri, options, callback) {
	  var params = uri;
	
	  if (isFunction(options)) {
	    callback = options;
	
	    if (typeof uri === "string") {
	      params = {
	        uri: uri
	      };
	    }
	  } else {
	    params = _extends({}, options, {
	      uri: uri
	    });
	  }
	
	  params.callback = callback;
	  return params;
	}
	
	function createXHR(uri, options, callback) {
	  options = initParams(uri, options, callback);
	  return _createXHR(options);
	}
	
	function _createXHR(options) {
	  if (typeof options.callback === "undefined") {
	    throw new Error("callback argument missing");
	  }
	
	  var called = false;
	
	  var callback = function cbOnce(err, response, body) {
	    if (!called) {
	      called = true;
	      options.callback(err, response, body);
	    }
	  };
	
	  function readystatechange() {
	    if (xhr.readyState === 4) {
	      setTimeout(loadFunc, 0);
	    }
	  }
	
	  function getBody() {
	    // Chrome with requestType=blob throws errors arround when even testing access to responseText
	    var body = undefined;
	
	    if (xhr.response) {
	      body = xhr.response;
	    } else {
	      body = xhr.responseText || getXml(xhr);
	    }
	
	    if (isJson) {
	      try {
	        body = JSON.parse(body);
	      } catch (e) {}
	    }
	
	    return body;
	  }
	
	  function errorFunc(evt) {
	    clearTimeout(timeoutTimer);
	
	    if (!(evt instanceof Error)) {
	      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
	    }
	
	    evt.statusCode = 0;
	    return callback(evt, failureResponse);
	  } // will load the data & process the response in a special response object
	
	
	  function loadFunc() {
	    if (aborted) return;
	    var status;
	    clearTimeout(timeoutTimer);
	
	    if (options.useXDR && xhr.status === undefined) {
	      //IE8 CORS GET successful response doesn't have a status field, but body is fine
	      status = 200;
	    } else {
	      status = xhr.status === 1223 ? 204 : xhr.status;
	    }
	
	    var response = failureResponse;
	    var err = null;
	
	    if (status !== 0) {
	      response = {
	        body: getBody(),
	        statusCode: status,
	        method: method,
	        headers: {},
	        url: uri,
	        rawRequest: xhr
	      };
	
	      if (xhr.getAllResponseHeaders) {
	        //remember xhr can in fact be XDR for CORS in IE
	        response.headers = parseHeaders(xhr.getAllResponseHeaders());
	      }
	    } else {
	      err = new Error("Internal XMLHttpRequest Error");
	    }
	
	    return callback(err, response, response.body);
	  }
	
	  var xhr = options.xhr || null;
	
	  if (!xhr) {
	    if (options.cors || options.useXDR) {
	      xhr = new createXHR.XDomainRequest();
	    } else {
	      xhr = new createXHR.XMLHttpRequest();
	    }
	  }
	
	  var key;
	  var aborted;
	  var uri = xhr.url = options.uri || options.url;
	  var method = xhr.method = options.method || "GET";
	  var body = options.body || options.data;
	  var headers = xhr.headers = options.headers || {};
	  var sync = !!options.sync;
	  var isJson = false;
	  var timeoutTimer;
	  var failureResponse = {
	    body: undefined,
	    headers: {},
	    statusCode: 0,
	    method: method,
	    url: uri,
	    rawRequest: xhr
	  };
	
	  if ("json" in options && options.json !== false) {
	    isJson = true;
	    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
	
	    if (method !== "GET" && method !== "HEAD") {
	      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
	
	      body = JSON.stringify(options.json === true ? body : options.json);
	    }
	  }
	
	  xhr.onreadystatechange = readystatechange;
	  xhr.onload = loadFunc;
	  xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
	
	  xhr.onprogress = function () {// IE must die
	  };
	
	  xhr.onabort = function () {
	    aborted = true;
	  };
	
	  xhr.ontimeout = errorFunc;
	  xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
	
	  if (!sync) {
	    xhr.withCredentials = !!options.withCredentials;
	  } // Cannot set timeout with sync request
	  // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	  // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	
	
	  if (!sync && options.timeout > 0) {
	    timeoutTimer = setTimeout(function () {
	      if (aborted) return;
	      aborted = true; //IE9 may still call readystatechange
	
	      xhr.abort("timeout");
	      var e = new Error("XMLHttpRequest timeout");
	      e.code = "ETIMEDOUT";
	      errorFunc(e);
	    }, options.timeout);
	  }
	
	  if (xhr.setRequestHeader) {
	    for (key in headers) {
	      if (headers.hasOwnProperty(key)) {
	        xhr.setRequestHeader(key, headers[key]);
	      }
	    }
	  } else if (options.headers && !isEmpty(options.headers)) {
	    throw new Error("Headers cannot be set on an XDomainRequest object");
	  }
	
	  if ("responseType" in options) {
	    xhr.responseType = options.responseType;
	  }
	
	  if ("beforeSend" in options && typeof options.beforeSend === "function") {
	    options.beforeSend(xhr);
	  } // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	  // XMLHttpRequest spec says to pass null as body to indicate no body
	  // See https://github.com/naugtur/xhr/issues/100.
	
	
	  xhr.send(body || null);
	  return xhr;
	}
	
	function getXml(xhr) {
	  // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
	  // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
	  try {
	    if (xhr.responseType === "document") {
	      return xhr.responseXML;
	    }
	
	    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
	
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	      return xhr.responseXML;
	    }
	  } catch (e) {}
	
	  return null;
	}
	
	function noop() {}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(9);
	var dom = __webpack_require__(26)
	var entities = __webpack_require__(177);
	var sax = __webpack_require__(179);
	
	var DOMImplementation = dom.DOMImplementation;
	
	var NAMESPACE = conventions.NAMESPACE;
	
	var ParseError = sax.ParseError;
	var XMLReader = sax.XMLReader;
	
	/**
	 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
	 *
	 * > XML parsed entities are often stored in computer files which,
	 * > for editing convenience, are organized into lines.
	 * > These lines are typically separated by some combination
	 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
	 * >
	 * > To simplify the tasks of applications, the XML processor must behave
	 * > as if it normalized all line breaks in external parsed entities (including the document entity)
	 * > on input, before parsing, by translating all of the following to a single #xA character:
	 * >
	 * > 1. the two-character sequence #xD #xA
	 * > 2. the two-character sequence #xD #x85
	 * > 3. the single character #x85
	 * > 4. the single character #x2028
	 * > 5. any #xD character that is not immediately followed by #xA or #x85.
	 *
	 * @param {string} input
	 * @returns {string}
	 */
	function normalizeLineEndings(input) {
		return input
			.replace(/\r[\n\u0085]/g, '\n')
			.replace(/[\r\u0085\u2028]/g, '\n')
	}
	
	/**
	 * @typedef Locator
	 * @property {number} [columnNumber]
	 * @property {number} [lineNumber]
	 */
	
	/**
	 * @typedef DOMParserOptions
	 * @property {DOMHandler} [domBuilder]
	 * @property {Function} [errorHandler]
	 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
	 * 						defaults to `normalizeLineEndings`
	 * @property {Locator} [locator]
	 * @property {Record<string, string>} [xmlns]
	 *
	 * @see normalizeLineEndings
	 */
	
	/**
	 * The DOMParser interface provides the ability to parse XML or HTML source code
	 * from a string into a DOM `Document`.
	 *
	 * _xmldom is different from the spec in that it allows an `options` parameter,
	 * to override the default behavior._
	 *
	 * @param {DOMParserOptions} [options]
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
	 */
	function DOMParser(options){
		this.options = options ||{locator:{}};
	}
	
	DOMParser.prototype.parseFromString = function(source,mimeType){
		var options = this.options;
		var sax =  new XMLReader();
		var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
		var errorHandler = options.errorHandler;
		var locator = options.locator;
		var defaultNSMap = options.xmlns||{};
		var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
	  	var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
		if(locator){
			domBuilder.setDocumentLocator(locator)
		}
	
		sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
		sax.domBuilder = options.domBuilder || domBuilder;
		if(isHTML){
			defaultNSMap[''] = NAMESPACE.HTML;
		}
		defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
		var normalize = options.normalizeLineEndings || normalizeLineEndings;
		if (source && typeof source === 'string') {
			sax.parse(
				normalize(source),
				defaultNSMap,
				entityMap
			)
		} else {
			sax.errorHandler.error('invalid doc source')
		}
		return domBuilder.doc;
	}
	function buildErrorHandler(errorImpl,domBuilder,locator){
		if(!errorImpl){
			if(domBuilder instanceof DOMHandler){
				return domBuilder;
			}
			errorImpl = domBuilder ;
		}
		var errorHandler = {}
		var isCallback = errorImpl instanceof Function;
		locator = locator||{}
		function build(key){
			var fn = errorImpl[key];
			if(!fn && isCallback){
				fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
			}
			errorHandler[key] = fn && function(msg){
				fn('[xmldom '+key+']\t'+msg+_locator(locator));
			}||function(){};
		}
		build('warning');
		build('error');
		build('fatalError');
		return errorHandler;
	}
	
	//console.log('#\n\n\n\n\n\n\n####')
	/**
	 * +ContentHandler+ErrorHandler
	 * +LexicalHandler+EntityResolver2
	 * -DeclHandler-DTDHandler
	 *
	 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
	 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
	 */
	function DOMHandler() {
	    this.cdata = false;
	}
	function position(locator,node){
		node.lineNumber = locator.lineNumber;
		node.columnNumber = locator.columnNumber;
	}
	/**
	 * @see org.xml.sax.ContentHandler#startDocument
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
	 */
	DOMHandler.prototype = {
		startDocument : function() {
	    	this.doc = new DOMImplementation().createDocument(null, null, null);
	    	if (this.locator) {
	        	this.doc.documentURI = this.locator.systemId;
	    	}
		},
		startElement:function(namespaceURI, localName, qName, attrs) {
			var doc = this.doc;
		    var el = doc.createElementNS(namespaceURI, qName||localName);
		    var len = attrs.length;
		    appendElement(this, el);
		    this.currentElement = el;
	
			this.locator && position(this.locator,el)
		    for (var i = 0 ; i < len; i++) {
		        var namespaceURI = attrs.getURI(i);
		        var value = attrs.getValue(i);
		        var qName = attrs.getQName(i);
				var attr = doc.createAttributeNS(namespaceURI, qName);
				this.locator &&position(attrs.getLocator(i),attr);
				attr.value = attr.nodeValue = value;
				el.setAttributeNode(attr)
		    }
		},
		endElement:function(namespaceURI, localName, qName) {
			var current = this.currentElement
			var tagName = current.tagName;
			this.currentElement = current.parentNode;
		},
		startPrefixMapping:function(prefix, uri) {
		},
		endPrefixMapping:function(prefix) {
		},
		processingInstruction:function(target, data) {
		    var ins = this.doc.createProcessingInstruction(target, data);
		    this.locator && position(this.locator,ins)
		    appendElement(this, ins);
		},
		ignorableWhitespace:function(ch, start, length) {
		},
		characters:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
			//console.log(chars)
			if(chars){
				if (this.cdata) {
					var charNode = this.doc.createCDATASection(chars);
				} else {
					var charNode = this.doc.createTextNode(chars);
				}
				if(this.currentElement){
					this.currentElement.appendChild(charNode);
				}else if(/^\s*$/.test(chars)){
					this.doc.appendChild(charNode);
					//process xml
				}
				this.locator && position(this.locator,charNode)
			}
		},
		skippedEntity:function(name) {
		},
		endDocument:function() {
			this.doc.normalize();
		},
		setDocumentLocator:function (locator) {
		    if(this.locator = locator){// && !('lineNumber' in locator)){
		    	locator.lineNumber = 0;
		    }
		},
		//LexicalHandler
		comment:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
		    var comm = this.doc.createComment(chars);
		    this.locator && position(this.locator,comm)
		    appendElement(this, comm);
		},
	
		startCDATA:function() {
		    //used in characters() methods
		    this.cdata = true;
		},
		endCDATA:function() {
		    this.cdata = false;
		},
	
		startDTD:function(name, publicId, systemId) {
			var impl = this.doc.implementation;
		    if (impl && impl.createDocumentType) {
		        var dt = impl.createDocumentType(name, publicId, systemId);
		        this.locator && position(this.locator,dt)
		        appendElement(this, dt);
						this.doc.doctype = dt;
		    }
		},
		/**
		 * @see org.xml.sax.ErrorHandler
		 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
		 */
		warning:function(error) {
			console.warn('[xmldom warning]\t'+error,_locator(this.locator));
		},
		error:function(error) {
			console.error('[xmldom error]\t'+error,_locator(this.locator));
		},
		fatalError:function(error) {
			throw new ParseError(error, this.locator);
		}
	}
	function _locator(l){
		if(l){
			return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
		}
	}
	function _toString(chars,start,length){
		if(typeof chars == 'string'){
			return chars.substr(start,length)
		}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
			if(chars.length >= start+length || start){
				return new java.lang.String(chars,start,length)+'';
			}
			return chars;
		}
	}
	
	/*
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
	 * used method of org.xml.sax.ext.LexicalHandler:
	 *  #comment(chars, start, length)
	 *  #startCDATA()
	 *  #endCDATA()
	 *  #startDTD(name, publicId, systemId)
	 *
	 *
	 * IGNORED method of org.xml.sax.ext.LexicalHandler:
	 *  #endDTD()
	 *  #startEntity(name)
	 *  #endEntity(name)
	 *
	 *
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
	 * IGNORED method of org.xml.sax.ext.DeclHandler
	 * 	#attributeDecl(eName, aName, type, mode, value)
	 *  #elementDecl(name, model)
	 *  #externalEntityDecl(name, publicId, systemId)
	 *  #internalEntityDecl(name, value)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
	 * IGNORED method of org.xml.sax.EntityResolver2
	 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
	 *  #resolveEntity(publicId, systemId)
	 *  #getExternalSubset(name, baseURI)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
	 * IGNORED method of org.xml.sax.DTDHandler
	 *  #notationDecl(name, publicId, systemId) {};
	 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
	 */
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
		DOMHandler.prototype[key] = function(){return null}
	})
	
	/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
	function appendElement (hander,node) {
	    if (!hander.currentElement) {
	        hander.doc.appendChild(node);
	    } else {
	        hander.currentElement.appendChild(node);
	    }
	}//appendChild and setAttributeNS are preformance key
	
	exports.__DOMHandler = DOMHandler;
	exports.normalizeLineEndings = normalizeLineEndings;
	exports.DOMParser = DOMParser;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var freeze = __webpack_require__(9).freeze;
	
	/**
	 * The entities that are predefined in every XML document.
	 *
	 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
	 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
	 */
	exports.XML_ENTITIES = freeze({
		amp: '&',
		apos: "'",
		gt: '>',
		lt: '<',
		quot: '"',
	});
	
	/**
	 * A map of all entities that are detected in an HTML document.
	 * They contain all entries from `XML_ENTITIES`.
	 *
	 * @see XML_ENTITIES
	 * @see DOMParser.parseFromString
	 * @see DOMImplementation.prototype.createHTMLDocument
	 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
	 * @see https://html.spec.whatwg.org/entities.json JSON
	 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
	 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
	 */
	exports.HTML_ENTITIES = freeze({
		Aacute: '\u00C1',
		aacute: '\u00E1',
		Abreve: '\u0102',
		abreve: '\u0103',
		ac: '\u223E',
		acd: '\u223F',
		acE: '\u223E\u0333',
		Acirc: '\u00C2',
		acirc: '\u00E2',
		acute: '\u00B4',
		Acy: '\u0410',
		acy: '\u0430',
		AElig: '\u00C6',
		aelig: '\u00E6',
		af: '\u2061',
		Afr: '\uD835\uDD04',
		afr: '\uD835\uDD1E',
		Agrave: '\u00C0',
		agrave: '\u00E0',
		alefsym: '\u2135',
		aleph: '\u2135',
		Alpha: '\u0391',
		alpha: '\u03B1',
		Amacr: '\u0100',
		amacr: '\u0101',
		amalg: '\u2A3F',
		AMP: '\u0026',
		amp: '\u0026',
		And: '\u2A53',
		and: '\u2227',
		andand: '\u2A55',
		andd: '\u2A5C',
		andslope: '\u2A58',
		andv: '\u2A5A',
		ang: '\u2220',
		ange: '\u29A4',
		angle: '\u2220',
		angmsd: '\u2221',
		angmsdaa: '\u29A8',
		angmsdab: '\u29A9',
		angmsdac: '\u29AA',
		angmsdad: '\u29AB',
		angmsdae: '\u29AC',
		angmsdaf: '\u29AD',
		angmsdag: '\u29AE',
		angmsdah: '\u29AF',
		angrt: '\u221F',
		angrtvb: '\u22BE',
		angrtvbd: '\u299D',
		angsph: '\u2222',
		angst: '\u00C5',
		angzarr: '\u237C',
		Aogon: '\u0104',
		aogon: '\u0105',
		Aopf: '\uD835\uDD38',
		aopf: '\uD835\uDD52',
		ap: '\u2248',
		apacir: '\u2A6F',
		apE: '\u2A70',
		ape: '\u224A',
		apid: '\u224B',
		apos: '\u0027',
		ApplyFunction: '\u2061',
		approx: '\u2248',
		approxeq: '\u224A',
		Aring: '\u00C5',
		aring: '\u00E5',
		Ascr: '\uD835\uDC9C',
		ascr: '\uD835\uDCB6',
		Assign: '\u2254',
		ast: '\u002A',
		asymp: '\u2248',
		asympeq: '\u224D',
		Atilde: '\u00C3',
		atilde: '\u00E3',
		Auml: '\u00C4',
		auml: '\u00E4',
		awconint: '\u2233',
		awint: '\u2A11',
		backcong: '\u224C',
		backepsilon: '\u03F6',
		backprime: '\u2035',
		backsim: '\u223D',
		backsimeq: '\u22CD',
		Backslash: '\u2216',
		Barv: '\u2AE7',
		barvee: '\u22BD',
		Barwed: '\u2306',
		barwed: '\u2305',
		barwedge: '\u2305',
		bbrk: '\u23B5',
		bbrktbrk: '\u23B6',
		bcong: '\u224C',
		Bcy: '\u0411',
		bcy: '\u0431',
		bdquo: '\u201E',
		becaus: '\u2235',
		Because: '\u2235',
		because: '\u2235',
		bemptyv: '\u29B0',
		bepsi: '\u03F6',
		bernou: '\u212C',
		Bernoullis: '\u212C',
		Beta: '\u0392',
		beta: '\u03B2',
		beth: '\u2136',
		between: '\u226C',
		Bfr: '\uD835\uDD05',
		bfr: '\uD835\uDD1F',
		bigcap: '\u22C2',
		bigcirc: '\u25EF',
		bigcup: '\u22C3',
		bigodot: '\u2A00',
		bigoplus: '\u2A01',
		bigotimes: '\u2A02',
		bigsqcup: '\u2A06',
		bigstar: '\u2605',
		bigtriangledown: '\u25BD',
		bigtriangleup: '\u25B3',
		biguplus: '\u2A04',
		bigvee: '\u22C1',
		bigwedge: '\u22C0',
		bkarow: '\u290D',
		blacklozenge: '\u29EB',
		blacksquare: '\u25AA',
		blacktriangle: '\u25B4',
		blacktriangledown: '\u25BE',
		blacktriangleleft: '\u25C2',
		blacktriangleright: '\u25B8',
		blank: '\u2423',
		blk12: '\u2592',
		blk14: '\u2591',
		blk34: '\u2593',
		block: '\u2588',
		bne: '\u003D\u20E5',
		bnequiv: '\u2261\u20E5',
		bNot: '\u2AED',
		bnot: '\u2310',
		Bopf: '\uD835\uDD39',
		bopf: '\uD835\uDD53',
		bot: '\u22A5',
		bottom: '\u22A5',
		bowtie: '\u22C8',
		boxbox: '\u29C9',
		boxDL: '\u2557',
		boxDl: '\u2556',
		boxdL: '\u2555',
		boxdl: '\u2510',
		boxDR: '\u2554',
		boxDr: '\u2553',
		boxdR: '\u2552',
		boxdr: '\u250C',
		boxH: '\u2550',
		boxh: '\u2500',
		boxHD: '\u2566',
		boxHd: '\u2564',
		boxhD: '\u2565',
		boxhd: '\u252C',
		boxHU: '\u2569',
		boxHu: '\u2567',
		boxhU: '\u2568',
		boxhu: '\u2534',
		boxminus: '\u229F',
		boxplus: '\u229E',
		boxtimes: '\u22A0',
		boxUL: '\u255D',
		boxUl: '\u255C',
		boxuL: '\u255B',
		boxul: '\u2518',
		boxUR: '\u255A',
		boxUr: '\u2559',
		boxuR: '\u2558',
		boxur: '\u2514',
		boxV: '\u2551',
		boxv: '\u2502',
		boxVH: '\u256C',
		boxVh: '\u256B',
		boxvH: '\u256A',
		boxvh: '\u253C',
		boxVL: '\u2563',
		boxVl: '\u2562',
		boxvL: '\u2561',
		boxvl: '\u2524',
		boxVR: '\u2560',
		boxVr: '\u255F',
		boxvR: '\u255E',
		boxvr: '\u251C',
		bprime: '\u2035',
		Breve: '\u02D8',
		breve: '\u02D8',
		brvbar: '\u00A6',
		Bscr: '\u212C',
		bscr: '\uD835\uDCB7',
		bsemi: '\u204F',
		bsim: '\u223D',
		bsime: '\u22CD',
		bsol: '\u005C',
		bsolb: '\u29C5',
		bsolhsub: '\u27C8',
		bull: '\u2022',
		bullet: '\u2022',
		bump: '\u224E',
		bumpE: '\u2AAE',
		bumpe: '\u224F',
		Bumpeq: '\u224E',
		bumpeq: '\u224F',
		Cacute: '\u0106',
		cacute: '\u0107',
		Cap: '\u22D2',
		cap: '\u2229',
		capand: '\u2A44',
		capbrcup: '\u2A49',
		capcap: '\u2A4B',
		capcup: '\u2A47',
		capdot: '\u2A40',
		CapitalDifferentialD: '\u2145',
		caps: '\u2229\uFE00',
		caret: '\u2041',
		caron: '\u02C7',
		Cayleys: '\u212D',
		ccaps: '\u2A4D',
		Ccaron: '\u010C',
		ccaron: '\u010D',
		Ccedil: '\u00C7',
		ccedil: '\u00E7',
		Ccirc: '\u0108',
		ccirc: '\u0109',
		Cconint: '\u2230',
		ccups: '\u2A4C',
		ccupssm: '\u2A50',
		Cdot: '\u010A',
		cdot: '\u010B',
		cedil: '\u00B8',
		Cedilla: '\u00B8',
		cemptyv: '\u29B2',
		cent: '\u00A2',
		CenterDot: '\u00B7',
		centerdot: '\u00B7',
		Cfr: '\u212D',
		cfr: '\uD835\uDD20',
		CHcy: '\u0427',
		chcy: '\u0447',
		check: '\u2713',
		checkmark: '\u2713',
		Chi: '\u03A7',
		chi: '\u03C7',
		cir: '\u25CB',
		circ: '\u02C6',
		circeq: '\u2257',
		circlearrowleft: '\u21BA',
		circlearrowright: '\u21BB',
		circledast: '\u229B',
		circledcirc: '\u229A',
		circleddash: '\u229D',
		CircleDot: '\u2299',
		circledR: '\u00AE',
		circledS: '\u24C8',
		CircleMinus: '\u2296',
		CirclePlus: '\u2295',
		CircleTimes: '\u2297',
		cirE: '\u29C3',
		cire: '\u2257',
		cirfnint: '\u2A10',
		cirmid: '\u2AEF',
		cirscir: '\u29C2',
		ClockwiseContourIntegral: '\u2232',
		CloseCurlyDoubleQuote: '\u201D',
		CloseCurlyQuote: '\u2019',
		clubs: '\u2663',
		clubsuit: '\u2663',
		Colon: '\u2237',
		colon: '\u003A',
		Colone: '\u2A74',
		colone: '\u2254',
		coloneq: '\u2254',
		comma: '\u002C',
		commat: '\u0040',
		comp: '\u2201',
		compfn: '\u2218',
		complement: '\u2201',
		complexes: '\u2102',
		cong: '\u2245',
		congdot: '\u2A6D',
		Congruent: '\u2261',
		Conint: '\u222F',
		conint: '\u222E',
		ContourIntegral: '\u222E',
		Copf: '\u2102',
		copf: '\uD835\uDD54',
		coprod: '\u2210',
		Coproduct: '\u2210',
		COPY: '\u00A9',
		copy: '\u00A9',
		copysr: '\u2117',
		CounterClockwiseContourIntegral: '\u2233',
		crarr: '\u21B5',
		Cross: '\u2A2F',
		cross: '\u2717',
		Cscr: '\uD835\uDC9E',
		cscr: '\uD835\uDCB8',
		csub: '\u2ACF',
		csube: '\u2AD1',
		csup: '\u2AD0',
		csupe: '\u2AD2',
		ctdot: '\u22EF',
		cudarrl: '\u2938',
		cudarrr: '\u2935',
		cuepr: '\u22DE',
		cuesc: '\u22DF',
		cularr: '\u21B6',
		cularrp: '\u293D',
		Cup: '\u22D3',
		cup: '\u222A',
		cupbrcap: '\u2A48',
		CupCap: '\u224D',
		cupcap: '\u2A46',
		cupcup: '\u2A4A',
		cupdot: '\u228D',
		cupor: '\u2A45',
		cups: '\u222A\uFE00',
		curarr: '\u21B7',
		curarrm: '\u293C',
		curlyeqprec: '\u22DE',
		curlyeqsucc: '\u22DF',
		curlyvee: '\u22CE',
		curlywedge: '\u22CF',
		curren: '\u00A4',
		curvearrowleft: '\u21B6',
		curvearrowright: '\u21B7',
		cuvee: '\u22CE',
		cuwed: '\u22CF',
		cwconint: '\u2232',
		cwint: '\u2231',
		cylcty: '\u232D',
		Dagger: '\u2021',
		dagger: '\u2020',
		daleth: '\u2138',
		Darr: '\u21A1',
		dArr: '\u21D3',
		darr: '\u2193',
		dash: '\u2010',
		Dashv: '\u2AE4',
		dashv: '\u22A3',
		dbkarow: '\u290F',
		dblac: '\u02DD',
		Dcaron: '\u010E',
		dcaron: '\u010F',
		Dcy: '\u0414',
		dcy: '\u0434',
		DD: '\u2145',
		dd: '\u2146',
		ddagger: '\u2021',
		ddarr: '\u21CA',
		DDotrahd: '\u2911',
		ddotseq: '\u2A77',
		deg: '\u00B0',
		Del: '\u2207',
		Delta: '\u0394',
		delta: '\u03B4',
		demptyv: '\u29B1',
		dfisht: '\u297F',
		Dfr: '\uD835\uDD07',
		dfr: '\uD835\uDD21',
		dHar: '\u2965',
		dharl: '\u21C3',
		dharr: '\u21C2',
		DiacriticalAcute: '\u00B4',
		DiacriticalDot: '\u02D9',
		DiacriticalDoubleAcute: '\u02DD',
		DiacriticalGrave: '\u0060',
		DiacriticalTilde: '\u02DC',
		diam: '\u22C4',
		Diamond: '\u22C4',
		diamond: '\u22C4',
		diamondsuit: '\u2666',
		diams: '\u2666',
		die: '\u00A8',
		DifferentialD: '\u2146',
		digamma: '\u03DD',
		disin: '\u22F2',
		div: '\u00F7',
		divide: '\u00F7',
		divideontimes: '\u22C7',
		divonx: '\u22C7',
		DJcy: '\u0402',
		djcy: '\u0452',
		dlcorn: '\u231E',
		dlcrop: '\u230D',
		dollar: '\u0024',
		Dopf: '\uD835\uDD3B',
		dopf: '\uD835\uDD55',
		Dot: '\u00A8',
		dot: '\u02D9',
		DotDot: '\u20DC',
		doteq: '\u2250',
		doteqdot: '\u2251',
		DotEqual: '\u2250',
		dotminus: '\u2238',
		dotplus: '\u2214',
		dotsquare: '\u22A1',
		doublebarwedge: '\u2306',
		DoubleContourIntegral: '\u222F',
		DoubleDot: '\u00A8',
		DoubleDownArrow: '\u21D3',
		DoubleLeftArrow: '\u21D0',
		DoubleLeftRightArrow: '\u21D4',
		DoubleLeftTee: '\u2AE4',
		DoubleLongLeftArrow: '\u27F8',
		DoubleLongLeftRightArrow: '\u27FA',
		DoubleLongRightArrow: '\u27F9',
		DoubleRightArrow: '\u21D2',
		DoubleRightTee: '\u22A8',
		DoubleUpArrow: '\u21D1',
		DoubleUpDownArrow: '\u21D5',
		DoubleVerticalBar: '\u2225',
		DownArrow: '\u2193',
		Downarrow: '\u21D3',
		downarrow: '\u2193',
		DownArrowBar: '\u2913',
		DownArrowUpArrow: '\u21F5',
		DownBreve: '\u0311',
		downdownarrows: '\u21CA',
		downharpoonleft: '\u21C3',
		downharpoonright: '\u21C2',
		DownLeftRightVector: '\u2950',
		DownLeftTeeVector: '\u295E',
		DownLeftVector: '\u21BD',
		DownLeftVectorBar: '\u2956',
		DownRightTeeVector: '\u295F',
		DownRightVector: '\u21C1',
		DownRightVectorBar: '\u2957',
		DownTee: '\u22A4',
		DownTeeArrow: '\u21A7',
		drbkarow: '\u2910',
		drcorn: '\u231F',
		drcrop: '\u230C',
		Dscr: '\uD835\uDC9F',
		dscr: '\uD835\uDCB9',
		DScy: '\u0405',
		dscy: '\u0455',
		dsol: '\u29F6',
		Dstrok: '\u0110',
		dstrok: '\u0111',
		dtdot: '\u22F1',
		dtri: '\u25BF',
		dtrif: '\u25BE',
		duarr: '\u21F5',
		duhar: '\u296F',
		dwangle: '\u29A6',
		DZcy: '\u040F',
		dzcy: '\u045F',
		dzigrarr: '\u27FF',
		Eacute: '\u00C9',
		eacute: '\u00E9',
		easter: '\u2A6E',
		Ecaron: '\u011A',
		ecaron: '\u011B',
		ecir: '\u2256',
		Ecirc: '\u00CA',
		ecirc: '\u00EA',
		ecolon: '\u2255',
		Ecy: '\u042D',
		ecy: '\u044D',
		eDDot: '\u2A77',
		Edot: '\u0116',
		eDot: '\u2251',
		edot: '\u0117',
		ee: '\u2147',
		efDot: '\u2252',
		Efr: '\uD835\uDD08',
		efr: '\uD835\uDD22',
		eg: '\u2A9A',
		Egrave: '\u00C8',
		egrave: '\u00E8',
		egs: '\u2A96',
		egsdot: '\u2A98',
		el: '\u2A99',
		Element: '\u2208',
		elinters: '\u23E7',
		ell: '\u2113',
		els: '\u2A95',
		elsdot: '\u2A97',
		Emacr: '\u0112',
		emacr: '\u0113',
		empty: '\u2205',
		emptyset: '\u2205',
		EmptySmallSquare: '\u25FB',
		emptyv: '\u2205',
		EmptyVerySmallSquare: '\u25AB',
		emsp: '\u2003',
		emsp13: '\u2004',
		emsp14: '\u2005',
		ENG: '\u014A',
		eng: '\u014B',
		ensp: '\u2002',
		Eogon: '\u0118',
		eogon: '\u0119',
		Eopf: '\uD835\uDD3C',
		eopf: '\uD835\uDD56',
		epar: '\u22D5',
		eparsl: '\u29E3',
		eplus: '\u2A71',
		epsi: '\u03B5',
		Epsilon: '\u0395',
		epsilon: '\u03B5',
		epsiv: '\u03F5',
		eqcirc: '\u2256',
		eqcolon: '\u2255',
		eqsim: '\u2242',
		eqslantgtr: '\u2A96',
		eqslantless: '\u2A95',
		Equal: '\u2A75',
		equals: '\u003D',
		EqualTilde: '\u2242',
		equest: '\u225F',
		Equilibrium: '\u21CC',
		equiv: '\u2261',
		equivDD: '\u2A78',
		eqvparsl: '\u29E5',
		erarr: '\u2971',
		erDot: '\u2253',
		Escr: '\u2130',
		escr: '\u212F',
		esdot: '\u2250',
		Esim: '\u2A73',
		esim: '\u2242',
		Eta: '\u0397',
		eta: '\u03B7',
		ETH: '\u00D0',
		eth: '\u00F0',
		Euml: '\u00CB',
		euml: '\u00EB',
		euro: '\u20AC',
		excl: '\u0021',
		exist: '\u2203',
		Exists: '\u2203',
		expectation: '\u2130',
		ExponentialE: '\u2147',
		exponentiale: '\u2147',
		fallingdotseq: '\u2252',
		Fcy: '\u0424',
		fcy: '\u0444',
		female: '\u2640',
		ffilig: '\uFB03',
		fflig: '\uFB00',
		ffllig: '\uFB04',
		Ffr: '\uD835\uDD09',
		ffr: '\uD835\uDD23',
		filig: '\uFB01',
		FilledSmallSquare: '\u25FC',
		FilledVerySmallSquare: '\u25AA',
		fjlig: '\u0066\u006A',
		flat: '\u266D',
		fllig: '\uFB02',
		fltns: '\u25B1',
		fnof: '\u0192',
		Fopf: '\uD835\uDD3D',
		fopf: '\uD835\uDD57',
		ForAll: '\u2200',
		forall: '\u2200',
		fork: '\u22D4',
		forkv: '\u2AD9',
		Fouriertrf: '\u2131',
		fpartint: '\u2A0D',
		frac12: '\u00BD',
		frac13: '\u2153',
		frac14: '\u00BC',
		frac15: '\u2155',
		frac16: '\u2159',
		frac18: '\u215B',
		frac23: '\u2154',
		frac25: '\u2156',
		frac34: '\u00BE',
		frac35: '\u2157',
		frac38: '\u215C',
		frac45: '\u2158',
		frac56: '\u215A',
		frac58: '\u215D',
		frac78: '\u215E',
		frasl: '\u2044',
		frown: '\u2322',
		Fscr: '\u2131',
		fscr: '\uD835\uDCBB',
		gacute: '\u01F5',
		Gamma: '\u0393',
		gamma: '\u03B3',
		Gammad: '\u03DC',
		gammad: '\u03DD',
		gap: '\u2A86',
		Gbreve: '\u011E',
		gbreve: '\u011F',
		Gcedil: '\u0122',
		Gcirc: '\u011C',
		gcirc: '\u011D',
		Gcy: '\u0413',
		gcy: '\u0433',
		Gdot: '\u0120',
		gdot: '\u0121',
		gE: '\u2267',
		ge: '\u2265',
		gEl: '\u2A8C',
		gel: '\u22DB',
		geq: '\u2265',
		geqq: '\u2267',
		geqslant: '\u2A7E',
		ges: '\u2A7E',
		gescc: '\u2AA9',
		gesdot: '\u2A80',
		gesdoto: '\u2A82',
		gesdotol: '\u2A84',
		gesl: '\u22DB\uFE00',
		gesles: '\u2A94',
		Gfr: '\uD835\uDD0A',
		gfr: '\uD835\uDD24',
		Gg: '\u22D9',
		gg: '\u226B',
		ggg: '\u22D9',
		gimel: '\u2137',
		GJcy: '\u0403',
		gjcy: '\u0453',
		gl: '\u2277',
		gla: '\u2AA5',
		glE: '\u2A92',
		glj: '\u2AA4',
		gnap: '\u2A8A',
		gnapprox: '\u2A8A',
		gnE: '\u2269',
		gne: '\u2A88',
		gneq: '\u2A88',
		gneqq: '\u2269',
		gnsim: '\u22E7',
		Gopf: '\uD835\uDD3E',
		gopf: '\uD835\uDD58',
		grave: '\u0060',
		GreaterEqual: '\u2265',
		GreaterEqualLess: '\u22DB',
		GreaterFullEqual: '\u2267',
		GreaterGreater: '\u2AA2',
		GreaterLess: '\u2277',
		GreaterSlantEqual: '\u2A7E',
		GreaterTilde: '\u2273',
		Gscr: '\uD835\uDCA2',
		gscr: '\u210A',
		gsim: '\u2273',
		gsime: '\u2A8E',
		gsiml: '\u2A90',
		Gt: '\u226B',
		GT: '\u003E',
		gt: '\u003E',
		gtcc: '\u2AA7',
		gtcir: '\u2A7A',
		gtdot: '\u22D7',
		gtlPar: '\u2995',
		gtquest: '\u2A7C',
		gtrapprox: '\u2A86',
		gtrarr: '\u2978',
		gtrdot: '\u22D7',
		gtreqless: '\u22DB',
		gtreqqless: '\u2A8C',
		gtrless: '\u2277',
		gtrsim: '\u2273',
		gvertneqq: '\u2269\uFE00',
		gvnE: '\u2269\uFE00',
		Hacek: '\u02C7',
		hairsp: '\u200A',
		half: '\u00BD',
		hamilt: '\u210B',
		HARDcy: '\u042A',
		hardcy: '\u044A',
		hArr: '\u21D4',
		harr: '\u2194',
		harrcir: '\u2948',
		harrw: '\u21AD',
		Hat: '\u005E',
		hbar: '\u210F',
		Hcirc: '\u0124',
		hcirc: '\u0125',
		hearts: '\u2665',
		heartsuit: '\u2665',
		hellip: '\u2026',
		hercon: '\u22B9',
		Hfr: '\u210C',
		hfr: '\uD835\uDD25',
		HilbertSpace: '\u210B',
		hksearow: '\u2925',
		hkswarow: '\u2926',
		hoarr: '\u21FF',
		homtht: '\u223B',
		hookleftarrow: '\u21A9',
		hookrightarrow: '\u21AA',
		Hopf: '\u210D',
		hopf: '\uD835\uDD59',
		horbar: '\u2015',
		HorizontalLine: '\u2500',
		Hscr: '\u210B',
		hscr: '\uD835\uDCBD',
		hslash: '\u210F',
		Hstrok: '\u0126',
		hstrok: '\u0127',
		HumpDownHump: '\u224E',
		HumpEqual: '\u224F',
		hybull: '\u2043',
		hyphen: '\u2010',
		Iacute: '\u00CD',
		iacute: '\u00ED',
		ic: '\u2063',
		Icirc: '\u00CE',
		icirc: '\u00EE',
		Icy: '\u0418',
		icy: '\u0438',
		Idot: '\u0130',
		IEcy: '\u0415',
		iecy: '\u0435',
		iexcl: '\u00A1',
		iff: '\u21D4',
		Ifr: '\u2111',
		ifr: '\uD835\uDD26',
		Igrave: '\u00CC',
		igrave: '\u00EC',
		ii: '\u2148',
		iiiint: '\u2A0C',
		iiint: '\u222D',
		iinfin: '\u29DC',
		iiota: '\u2129',
		IJlig: '\u0132',
		ijlig: '\u0133',
		Im: '\u2111',
		Imacr: '\u012A',
		imacr: '\u012B',
		image: '\u2111',
		ImaginaryI: '\u2148',
		imagline: '\u2110',
		imagpart: '\u2111',
		imath: '\u0131',
		imof: '\u22B7',
		imped: '\u01B5',
		Implies: '\u21D2',
		in: '\u2208',
		incare: '\u2105',
		infin: '\u221E',
		infintie: '\u29DD',
		inodot: '\u0131',
		Int: '\u222C',
		int: '\u222B',
		intcal: '\u22BA',
		integers: '\u2124',
		Integral: '\u222B',
		intercal: '\u22BA',
		Intersection: '\u22C2',
		intlarhk: '\u2A17',
		intprod: '\u2A3C',
		InvisibleComma: '\u2063',
		InvisibleTimes: '\u2062',
		IOcy: '\u0401',
		iocy: '\u0451',
		Iogon: '\u012E',
		iogon: '\u012F',
		Iopf: '\uD835\uDD40',
		iopf: '\uD835\uDD5A',
		Iota: '\u0399',
		iota: '\u03B9',
		iprod: '\u2A3C',
		iquest: '\u00BF',
		Iscr: '\u2110',
		iscr: '\uD835\uDCBE',
		isin: '\u2208',
		isindot: '\u22F5',
		isinE: '\u22F9',
		isins: '\u22F4',
		isinsv: '\u22F3',
		isinv: '\u2208',
		it: '\u2062',
		Itilde: '\u0128',
		itilde: '\u0129',
		Iukcy: '\u0406',
		iukcy: '\u0456',
		Iuml: '\u00CF',
		iuml: '\u00EF',
		Jcirc: '\u0134',
		jcirc: '\u0135',
		Jcy: '\u0419',
		jcy: '\u0439',
		Jfr: '\uD835\uDD0D',
		jfr: '\uD835\uDD27',
		jmath: '\u0237',
		Jopf: '\uD835\uDD41',
		jopf: '\uD835\uDD5B',
		Jscr: '\uD835\uDCA5',
		jscr: '\uD835\uDCBF',
		Jsercy: '\u0408',
		jsercy: '\u0458',
		Jukcy: '\u0404',
		jukcy: '\u0454',
		Kappa: '\u039A',
		kappa: '\u03BA',
		kappav: '\u03F0',
		Kcedil: '\u0136',
		kcedil: '\u0137',
		Kcy: '\u041A',
		kcy: '\u043A',
		Kfr: '\uD835\uDD0E',
		kfr: '\uD835\uDD28',
		kgreen: '\u0138',
		KHcy: '\u0425',
		khcy: '\u0445',
		KJcy: '\u040C',
		kjcy: '\u045C',
		Kopf: '\uD835\uDD42',
		kopf: '\uD835\uDD5C',
		Kscr: '\uD835\uDCA6',
		kscr: '\uD835\uDCC0',
		lAarr: '\u21DA',
		Lacute: '\u0139',
		lacute: '\u013A',
		laemptyv: '\u29B4',
		lagran: '\u2112',
		Lambda: '\u039B',
		lambda: '\u03BB',
		Lang: '\u27EA',
		lang: '\u27E8',
		langd: '\u2991',
		langle: '\u27E8',
		lap: '\u2A85',
		Laplacetrf: '\u2112',
		laquo: '\u00AB',
		Larr: '\u219E',
		lArr: '\u21D0',
		larr: '\u2190',
		larrb: '\u21E4',
		larrbfs: '\u291F',
		larrfs: '\u291D',
		larrhk: '\u21A9',
		larrlp: '\u21AB',
		larrpl: '\u2939',
		larrsim: '\u2973',
		larrtl: '\u21A2',
		lat: '\u2AAB',
		lAtail: '\u291B',
		latail: '\u2919',
		late: '\u2AAD',
		lates: '\u2AAD\uFE00',
		lBarr: '\u290E',
		lbarr: '\u290C',
		lbbrk: '\u2772',
		lbrace: '\u007B',
		lbrack: '\u005B',
		lbrke: '\u298B',
		lbrksld: '\u298F',
		lbrkslu: '\u298D',
		Lcaron: '\u013D',
		lcaron: '\u013E',
		Lcedil: '\u013B',
		lcedil: '\u013C',
		lceil: '\u2308',
		lcub: '\u007B',
		Lcy: '\u041B',
		lcy: '\u043B',
		ldca: '\u2936',
		ldquo: '\u201C',
		ldquor: '\u201E',
		ldrdhar: '\u2967',
		ldrushar: '\u294B',
		ldsh: '\u21B2',
		lE: '\u2266',
		le: '\u2264',
		LeftAngleBracket: '\u27E8',
		LeftArrow: '\u2190',
		Leftarrow: '\u21D0',
		leftarrow: '\u2190',
		LeftArrowBar: '\u21E4',
		LeftArrowRightArrow: '\u21C6',
		leftarrowtail: '\u21A2',
		LeftCeiling: '\u2308',
		LeftDoubleBracket: '\u27E6',
		LeftDownTeeVector: '\u2961',
		LeftDownVector: '\u21C3',
		LeftDownVectorBar: '\u2959',
		LeftFloor: '\u230A',
		leftharpoondown: '\u21BD',
		leftharpoonup: '\u21BC',
		leftleftarrows: '\u21C7',
		LeftRightArrow: '\u2194',
		Leftrightarrow: '\u21D4',
		leftrightarrow: '\u2194',
		leftrightarrows: '\u21C6',
		leftrightharpoons: '\u21CB',
		leftrightsquigarrow: '\u21AD',
		LeftRightVector: '\u294E',
		LeftTee: '\u22A3',
		LeftTeeArrow: '\u21A4',
		LeftTeeVector: '\u295A',
		leftthreetimes: '\u22CB',
		LeftTriangle: '\u22B2',
		LeftTriangleBar: '\u29CF',
		LeftTriangleEqual: '\u22B4',
		LeftUpDownVector: '\u2951',
		LeftUpTeeVector: '\u2960',
		LeftUpVector: '\u21BF',
		LeftUpVectorBar: '\u2958',
		LeftVector: '\u21BC',
		LeftVectorBar: '\u2952',
		lEg: '\u2A8B',
		leg: '\u22DA',
		leq: '\u2264',
		leqq: '\u2266',
		leqslant: '\u2A7D',
		les: '\u2A7D',
		lescc: '\u2AA8',
		lesdot: '\u2A7F',
		lesdoto: '\u2A81',
		lesdotor: '\u2A83',
		lesg: '\u22DA\uFE00',
		lesges: '\u2A93',
		lessapprox: '\u2A85',
		lessdot: '\u22D6',
		lesseqgtr: '\u22DA',
		lesseqqgtr: '\u2A8B',
		LessEqualGreater: '\u22DA',
		LessFullEqual: '\u2266',
		LessGreater: '\u2276',
		lessgtr: '\u2276',
		LessLess: '\u2AA1',
		lesssim: '\u2272',
		LessSlantEqual: '\u2A7D',
		LessTilde: '\u2272',
		lfisht: '\u297C',
		lfloor: '\u230A',
		Lfr: '\uD835\uDD0F',
		lfr: '\uD835\uDD29',
		lg: '\u2276',
		lgE: '\u2A91',
		lHar: '\u2962',
		lhard: '\u21BD',
		lharu: '\u21BC',
		lharul: '\u296A',
		lhblk: '\u2584',
		LJcy: '\u0409',
		ljcy: '\u0459',
		Ll: '\u22D8',
		ll: '\u226A',
		llarr: '\u21C7',
		llcorner: '\u231E',
		Lleftarrow: '\u21DA',
		llhard: '\u296B',
		lltri: '\u25FA',
		Lmidot: '\u013F',
		lmidot: '\u0140',
		lmoust: '\u23B0',
		lmoustache: '\u23B0',
		lnap: '\u2A89',
		lnapprox: '\u2A89',
		lnE: '\u2268',
		lne: '\u2A87',
		lneq: '\u2A87',
		lneqq: '\u2268',
		lnsim: '\u22E6',
		loang: '\u27EC',
		loarr: '\u21FD',
		lobrk: '\u27E6',
		LongLeftArrow: '\u27F5',
		Longleftarrow: '\u27F8',
		longleftarrow: '\u27F5',
		LongLeftRightArrow: '\u27F7',
		Longleftrightarrow: '\u27FA',
		longleftrightarrow: '\u27F7',
		longmapsto: '\u27FC',
		LongRightArrow: '\u27F6',
		Longrightarrow: '\u27F9',
		longrightarrow: '\u27F6',
		looparrowleft: '\u21AB',
		looparrowright: '\u21AC',
		lopar: '\u2985',
		Lopf: '\uD835\uDD43',
		lopf: '\uD835\uDD5D',
		loplus: '\u2A2D',
		lotimes: '\u2A34',
		lowast: '\u2217',
		lowbar: '\u005F',
		LowerLeftArrow: '\u2199',
		LowerRightArrow: '\u2198',
		loz: '\u25CA',
		lozenge: '\u25CA',
		lozf: '\u29EB',
		lpar: '\u0028',
		lparlt: '\u2993',
		lrarr: '\u21C6',
		lrcorner: '\u231F',
		lrhar: '\u21CB',
		lrhard: '\u296D',
		lrm: '\u200E',
		lrtri: '\u22BF',
		lsaquo: '\u2039',
		Lscr: '\u2112',
		lscr: '\uD835\uDCC1',
		Lsh: '\u21B0',
		lsh: '\u21B0',
		lsim: '\u2272',
		lsime: '\u2A8D',
		lsimg: '\u2A8F',
		lsqb: '\u005B',
		lsquo: '\u2018',
		lsquor: '\u201A',
		Lstrok: '\u0141',
		lstrok: '\u0142',
		Lt: '\u226A',
		LT: '\u003C',
		lt: '\u003C',
		ltcc: '\u2AA6',
		ltcir: '\u2A79',
		ltdot: '\u22D6',
		lthree: '\u22CB',
		ltimes: '\u22C9',
		ltlarr: '\u2976',
		ltquest: '\u2A7B',
		ltri: '\u25C3',
		ltrie: '\u22B4',
		ltrif: '\u25C2',
		ltrPar: '\u2996',
		lurdshar: '\u294A',
		luruhar: '\u2966',
		lvertneqq: '\u2268\uFE00',
		lvnE: '\u2268\uFE00',
		macr: '\u00AF',
		male: '\u2642',
		malt: '\u2720',
		maltese: '\u2720',
		Map: '\u2905',
		map: '\u21A6',
		mapsto: '\u21A6',
		mapstodown: '\u21A7',
		mapstoleft: '\u21A4',
		mapstoup: '\u21A5',
		marker: '\u25AE',
		mcomma: '\u2A29',
		Mcy: '\u041C',
		mcy: '\u043C',
		mdash: '\u2014',
		mDDot: '\u223A',
		measuredangle: '\u2221',
		MediumSpace: '\u205F',
		Mellintrf: '\u2133',
		Mfr: '\uD835\uDD10',
		mfr: '\uD835\uDD2A',
		mho: '\u2127',
		micro: '\u00B5',
		mid: '\u2223',
		midast: '\u002A',
		midcir: '\u2AF0',
		middot: '\u00B7',
		minus: '\u2212',
		minusb: '\u229F',
		minusd: '\u2238',
		minusdu: '\u2A2A',
		MinusPlus: '\u2213',
		mlcp: '\u2ADB',
		mldr: '\u2026',
		mnplus: '\u2213',
		models: '\u22A7',
		Mopf: '\uD835\uDD44',
		mopf: '\uD835\uDD5E',
		mp: '\u2213',
		Mscr: '\u2133',
		mscr: '\uD835\uDCC2',
		mstpos: '\u223E',
		Mu: '\u039C',
		mu: '\u03BC',
		multimap: '\u22B8',
		mumap: '\u22B8',
		nabla: '\u2207',
		Nacute: '\u0143',
		nacute: '\u0144',
		nang: '\u2220\u20D2',
		nap: '\u2249',
		napE: '\u2A70\u0338',
		napid: '\u224B\u0338',
		napos: '\u0149',
		napprox: '\u2249',
		natur: '\u266E',
		natural: '\u266E',
		naturals: '\u2115',
		nbsp: '\u00A0',
		nbump: '\u224E\u0338',
		nbumpe: '\u224F\u0338',
		ncap: '\u2A43',
		Ncaron: '\u0147',
		ncaron: '\u0148',
		Ncedil: '\u0145',
		ncedil: '\u0146',
		ncong: '\u2247',
		ncongdot: '\u2A6D\u0338',
		ncup: '\u2A42',
		Ncy: '\u041D',
		ncy: '\u043D',
		ndash: '\u2013',
		ne: '\u2260',
		nearhk: '\u2924',
		neArr: '\u21D7',
		nearr: '\u2197',
		nearrow: '\u2197',
		nedot: '\u2250\u0338',
		NegativeMediumSpace: '\u200B',
		NegativeThickSpace: '\u200B',
		NegativeThinSpace: '\u200B',
		NegativeVeryThinSpace: '\u200B',
		nequiv: '\u2262',
		nesear: '\u2928',
		nesim: '\u2242\u0338',
		NestedGreaterGreater: '\u226B',
		NestedLessLess: '\u226A',
		NewLine: '\u000A',
		nexist: '\u2204',
		nexists: '\u2204',
		Nfr: '\uD835\uDD11',
		nfr: '\uD835\uDD2B',
		ngE: '\u2267\u0338',
		nge: '\u2271',
		ngeq: '\u2271',
		ngeqq: '\u2267\u0338',
		ngeqslant: '\u2A7E\u0338',
		nges: '\u2A7E\u0338',
		nGg: '\u22D9\u0338',
		ngsim: '\u2275',
		nGt: '\u226B\u20D2',
		ngt: '\u226F',
		ngtr: '\u226F',
		nGtv: '\u226B\u0338',
		nhArr: '\u21CE',
		nharr: '\u21AE',
		nhpar: '\u2AF2',
		ni: '\u220B',
		nis: '\u22FC',
		nisd: '\u22FA',
		niv: '\u220B',
		NJcy: '\u040A',
		njcy: '\u045A',
		nlArr: '\u21CD',
		nlarr: '\u219A',
		nldr: '\u2025',
		nlE: '\u2266\u0338',
		nle: '\u2270',
		nLeftarrow: '\u21CD',
		nleftarrow: '\u219A',
		nLeftrightarrow: '\u21CE',
		nleftrightarrow: '\u21AE',
		nleq: '\u2270',
		nleqq: '\u2266\u0338',
		nleqslant: '\u2A7D\u0338',
		nles: '\u2A7D\u0338',
		nless: '\u226E',
		nLl: '\u22D8\u0338',
		nlsim: '\u2274',
		nLt: '\u226A\u20D2',
		nlt: '\u226E',
		nltri: '\u22EA',
		nltrie: '\u22EC',
		nLtv: '\u226A\u0338',
		nmid: '\u2224',
		NoBreak: '\u2060',
		NonBreakingSpace: '\u00A0',
		Nopf: '\u2115',
		nopf: '\uD835\uDD5F',
		Not: '\u2AEC',
		not: '\u00AC',
		NotCongruent: '\u2262',
		NotCupCap: '\u226D',
		NotDoubleVerticalBar: '\u2226',
		NotElement: '\u2209',
		NotEqual: '\u2260',
		NotEqualTilde: '\u2242\u0338',
		NotExists: '\u2204',
		NotGreater: '\u226F',
		NotGreaterEqual: '\u2271',
		NotGreaterFullEqual: '\u2267\u0338',
		NotGreaterGreater: '\u226B\u0338',
		NotGreaterLess: '\u2279',
		NotGreaterSlantEqual: '\u2A7E\u0338',
		NotGreaterTilde: '\u2275',
		NotHumpDownHump: '\u224E\u0338',
		NotHumpEqual: '\u224F\u0338',
		notin: '\u2209',
		notindot: '\u22F5\u0338',
		notinE: '\u22F9\u0338',
		notinva: '\u2209',
		notinvb: '\u22F7',
		notinvc: '\u22F6',
		NotLeftTriangle: '\u22EA',
		NotLeftTriangleBar: '\u29CF\u0338',
		NotLeftTriangleEqual: '\u22EC',
		NotLess: '\u226E',
		NotLessEqual: '\u2270',
		NotLessGreater: '\u2278',
		NotLessLess: '\u226A\u0338',
		NotLessSlantEqual: '\u2A7D\u0338',
		NotLessTilde: '\u2274',
		NotNestedGreaterGreater: '\u2AA2\u0338',
		NotNestedLessLess: '\u2AA1\u0338',
		notni: '\u220C',
		notniva: '\u220C',
		notnivb: '\u22FE',
		notnivc: '\u22FD',
		NotPrecedes: '\u2280',
		NotPrecedesEqual: '\u2AAF\u0338',
		NotPrecedesSlantEqual: '\u22E0',
		NotReverseElement: '\u220C',
		NotRightTriangle: '\u22EB',
		NotRightTriangleBar: '\u29D0\u0338',
		NotRightTriangleEqual: '\u22ED',
		NotSquareSubset: '\u228F\u0338',
		NotSquareSubsetEqual: '\u22E2',
		NotSquareSuperset: '\u2290\u0338',
		NotSquareSupersetEqual: '\u22E3',
		NotSubset: '\u2282\u20D2',
		NotSubsetEqual: '\u2288',
		NotSucceeds: '\u2281',
		NotSucceedsEqual: '\u2AB0\u0338',
		NotSucceedsSlantEqual: '\u22E1',
		NotSucceedsTilde: '\u227F\u0338',
		NotSuperset: '\u2283\u20D2',
		NotSupersetEqual: '\u2289',
		NotTilde: '\u2241',
		NotTildeEqual: '\u2244',
		NotTildeFullEqual: '\u2247',
		NotTildeTilde: '\u2249',
		NotVerticalBar: '\u2224',
		npar: '\u2226',
		nparallel: '\u2226',
		nparsl: '\u2AFD\u20E5',
		npart: '\u2202\u0338',
		npolint: '\u2A14',
		npr: '\u2280',
		nprcue: '\u22E0',
		npre: '\u2AAF\u0338',
		nprec: '\u2280',
		npreceq: '\u2AAF\u0338',
		nrArr: '\u21CF',
		nrarr: '\u219B',
		nrarrc: '\u2933\u0338',
		nrarrw: '\u219D\u0338',
		nRightarrow: '\u21CF',
		nrightarrow: '\u219B',
		nrtri: '\u22EB',
		nrtrie: '\u22ED',
		nsc: '\u2281',
		nsccue: '\u22E1',
		nsce: '\u2AB0\u0338',
		Nscr: '\uD835\uDCA9',
		nscr: '\uD835\uDCC3',
		nshortmid: '\u2224',
		nshortparallel: '\u2226',
		nsim: '\u2241',
		nsime: '\u2244',
		nsimeq: '\u2244',
		nsmid: '\u2224',
		nspar: '\u2226',
		nsqsube: '\u22E2',
		nsqsupe: '\u22E3',
		nsub: '\u2284',
		nsubE: '\u2AC5\u0338',
		nsube: '\u2288',
		nsubset: '\u2282\u20D2',
		nsubseteq: '\u2288',
		nsubseteqq: '\u2AC5\u0338',
		nsucc: '\u2281',
		nsucceq: '\u2AB0\u0338',
		nsup: '\u2285',
		nsupE: '\u2AC6\u0338',
		nsupe: '\u2289',
		nsupset: '\u2283\u20D2',
		nsupseteq: '\u2289',
		nsupseteqq: '\u2AC6\u0338',
		ntgl: '\u2279',
		Ntilde: '\u00D1',
		ntilde: '\u00F1',
		ntlg: '\u2278',
		ntriangleleft: '\u22EA',
		ntrianglelefteq: '\u22EC',
		ntriangleright: '\u22EB',
		ntrianglerighteq: '\u22ED',
		Nu: '\u039D',
		nu: '\u03BD',
		num: '\u0023',
		numero: '\u2116',
		numsp: '\u2007',
		nvap: '\u224D\u20D2',
		nVDash: '\u22AF',
		nVdash: '\u22AE',
		nvDash: '\u22AD',
		nvdash: '\u22AC',
		nvge: '\u2265\u20D2',
		nvgt: '\u003E\u20D2',
		nvHarr: '\u2904',
		nvinfin: '\u29DE',
		nvlArr: '\u2902',
		nvle: '\u2264\u20D2',
		nvlt: '\u003C\u20D2',
		nvltrie: '\u22B4\u20D2',
		nvrArr: '\u2903',
		nvrtrie: '\u22B5\u20D2',
		nvsim: '\u223C\u20D2',
		nwarhk: '\u2923',
		nwArr: '\u21D6',
		nwarr: '\u2196',
		nwarrow: '\u2196',
		nwnear: '\u2927',
		Oacute: '\u00D3',
		oacute: '\u00F3',
		oast: '\u229B',
		ocir: '\u229A',
		Ocirc: '\u00D4',
		ocirc: '\u00F4',
		Ocy: '\u041E',
		ocy: '\u043E',
		odash: '\u229D',
		Odblac: '\u0150',
		odblac: '\u0151',
		odiv: '\u2A38',
		odot: '\u2299',
		odsold: '\u29BC',
		OElig: '\u0152',
		oelig: '\u0153',
		ofcir: '\u29BF',
		Ofr: '\uD835\uDD12',
		ofr: '\uD835\uDD2C',
		ogon: '\u02DB',
		Ograve: '\u00D2',
		ograve: '\u00F2',
		ogt: '\u29C1',
		ohbar: '\u29B5',
		ohm: '\u03A9',
		oint: '\u222E',
		olarr: '\u21BA',
		olcir: '\u29BE',
		olcross: '\u29BB',
		oline: '\u203E',
		olt: '\u29C0',
		Omacr: '\u014C',
		omacr: '\u014D',
		Omega: '\u03A9',
		omega: '\u03C9',
		Omicron: '\u039F',
		omicron: '\u03BF',
		omid: '\u29B6',
		ominus: '\u2296',
		Oopf: '\uD835\uDD46',
		oopf: '\uD835\uDD60',
		opar: '\u29B7',
		OpenCurlyDoubleQuote: '\u201C',
		OpenCurlyQuote: '\u2018',
		operp: '\u29B9',
		oplus: '\u2295',
		Or: '\u2A54',
		or: '\u2228',
		orarr: '\u21BB',
		ord: '\u2A5D',
		order: '\u2134',
		orderof: '\u2134',
		ordf: '\u00AA',
		ordm: '\u00BA',
		origof: '\u22B6',
		oror: '\u2A56',
		orslope: '\u2A57',
		orv: '\u2A5B',
		oS: '\u24C8',
		Oscr: '\uD835\uDCAA',
		oscr: '\u2134',
		Oslash: '\u00D8',
		oslash: '\u00F8',
		osol: '\u2298',
		Otilde: '\u00D5',
		otilde: '\u00F5',
		Otimes: '\u2A37',
		otimes: '\u2297',
		otimesas: '\u2A36',
		Ouml: '\u00D6',
		ouml: '\u00F6',
		ovbar: '\u233D',
		OverBar: '\u203E',
		OverBrace: '\u23DE',
		OverBracket: '\u23B4',
		OverParenthesis: '\u23DC',
		par: '\u2225',
		para: '\u00B6',
		parallel: '\u2225',
		parsim: '\u2AF3',
		parsl: '\u2AFD',
		part: '\u2202',
		PartialD: '\u2202',
		Pcy: '\u041F',
		pcy: '\u043F',
		percnt: '\u0025',
		period: '\u002E',
		permil: '\u2030',
		perp: '\u22A5',
		pertenk: '\u2031',
		Pfr: '\uD835\uDD13',
		pfr: '\uD835\uDD2D',
		Phi: '\u03A6',
		phi: '\u03C6',
		phiv: '\u03D5',
		phmmat: '\u2133',
		phone: '\u260E',
		Pi: '\u03A0',
		pi: '\u03C0',
		pitchfork: '\u22D4',
		piv: '\u03D6',
		planck: '\u210F',
		planckh: '\u210E',
		plankv: '\u210F',
		plus: '\u002B',
		plusacir: '\u2A23',
		plusb: '\u229E',
		pluscir: '\u2A22',
		plusdo: '\u2214',
		plusdu: '\u2A25',
		pluse: '\u2A72',
		PlusMinus: '\u00B1',
		plusmn: '\u00B1',
		plussim: '\u2A26',
		plustwo: '\u2A27',
		pm: '\u00B1',
		Poincareplane: '\u210C',
		pointint: '\u2A15',
		Popf: '\u2119',
		popf: '\uD835\uDD61',
		pound: '\u00A3',
		Pr: '\u2ABB',
		pr: '\u227A',
		prap: '\u2AB7',
		prcue: '\u227C',
		prE: '\u2AB3',
		pre: '\u2AAF',
		prec: '\u227A',
		precapprox: '\u2AB7',
		preccurlyeq: '\u227C',
		Precedes: '\u227A',
		PrecedesEqual: '\u2AAF',
		PrecedesSlantEqual: '\u227C',
		PrecedesTilde: '\u227E',
		preceq: '\u2AAF',
		precnapprox: '\u2AB9',
		precneqq: '\u2AB5',
		precnsim: '\u22E8',
		precsim: '\u227E',
		Prime: '\u2033',
		prime: '\u2032',
		primes: '\u2119',
		prnap: '\u2AB9',
		prnE: '\u2AB5',
		prnsim: '\u22E8',
		prod: '\u220F',
		Product: '\u220F',
		profalar: '\u232E',
		profline: '\u2312',
		profsurf: '\u2313',
		prop: '\u221D',
		Proportion: '\u2237',
		Proportional: '\u221D',
		propto: '\u221D',
		prsim: '\u227E',
		prurel: '\u22B0',
		Pscr: '\uD835\uDCAB',
		pscr: '\uD835\uDCC5',
		Psi: '\u03A8',
		psi: '\u03C8',
		puncsp: '\u2008',
		Qfr: '\uD835\uDD14',
		qfr: '\uD835\uDD2E',
		qint: '\u2A0C',
		Qopf: '\u211A',
		qopf: '\uD835\uDD62',
		qprime: '\u2057',
		Qscr: '\uD835\uDCAC',
		qscr: '\uD835\uDCC6',
		quaternions: '\u210D',
		quatint: '\u2A16',
		quest: '\u003F',
		questeq: '\u225F',
		QUOT: '\u0022',
		quot: '\u0022',
		rAarr: '\u21DB',
		race: '\u223D\u0331',
		Racute: '\u0154',
		racute: '\u0155',
		radic: '\u221A',
		raemptyv: '\u29B3',
		Rang: '\u27EB',
		rang: '\u27E9',
		rangd: '\u2992',
		range: '\u29A5',
		rangle: '\u27E9',
		raquo: '\u00BB',
		Rarr: '\u21A0',
		rArr: '\u21D2',
		rarr: '\u2192',
		rarrap: '\u2975',
		rarrb: '\u21E5',
		rarrbfs: '\u2920',
		rarrc: '\u2933',
		rarrfs: '\u291E',
		rarrhk: '\u21AA',
		rarrlp: '\u21AC',
		rarrpl: '\u2945',
		rarrsim: '\u2974',
		Rarrtl: '\u2916',
		rarrtl: '\u21A3',
		rarrw: '\u219D',
		rAtail: '\u291C',
		ratail: '\u291A',
		ratio: '\u2236',
		rationals: '\u211A',
		RBarr: '\u2910',
		rBarr: '\u290F',
		rbarr: '\u290D',
		rbbrk: '\u2773',
		rbrace: '\u007D',
		rbrack: '\u005D',
		rbrke: '\u298C',
		rbrksld: '\u298E',
		rbrkslu: '\u2990',
		Rcaron: '\u0158',
		rcaron: '\u0159',
		Rcedil: '\u0156',
		rcedil: '\u0157',
		rceil: '\u2309',
		rcub: '\u007D',
		Rcy: '\u0420',
		rcy: '\u0440',
		rdca: '\u2937',
		rdldhar: '\u2969',
		rdquo: '\u201D',
		rdquor: '\u201D',
		rdsh: '\u21B3',
		Re: '\u211C',
		real: '\u211C',
		realine: '\u211B',
		realpart: '\u211C',
		reals: '\u211D',
		rect: '\u25AD',
		REG: '\u00AE',
		reg: '\u00AE',
		ReverseElement: '\u220B',
		ReverseEquilibrium: '\u21CB',
		ReverseUpEquilibrium: '\u296F',
		rfisht: '\u297D',
		rfloor: '\u230B',
		Rfr: '\u211C',
		rfr: '\uD835\uDD2F',
		rHar: '\u2964',
		rhard: '\u21C1',
		rharu: '\u21C0',
		rharul: '\u296C',
		Rho: '\u03A1',
		rho: '\u03C1',
		rhov: '\u03F1',
		RightAngleBracket: '\u27E9',
		RightArrow: '\u2192',
		Rightarrow: '\u21D2',
		rightarrow: '\u2192',
		RightArrowBar: '\u21E5',
		RightArrowLeftArrow: '\u21C4',
		rightarrowtail: '\u21A3',
		RightCeiling: '\u2309',
		RightDoubleBracket: '\u27E7',
		RightDownTeeVector: '\u295D',
		RightDownVector: '\u21C2',
		RightDownVectorBar: '\u2955',
		RightFloor: '\u230B',
		rightharpoondown: '\u21C1',
		rightharpoonup: '\u21C0',
		rightleftarrows: '\u21C4',
		rightleftharpoons: '\u21CC',
		rightrightarrows: '\u21C9',
		rightsquigarrow: '\u219D',
		RightTee: '\u22A2',
		RightTeeArrow: '\u21A6',
		RightTeeVector: '\u295B',
		rightthreetimes: '\u22CC',
		RightTriangle: '\u22B3',
		RightTriangleBar: '\u29D0',
		RightTriangleEqual: '\u22B5',
		RightUpDownVector: '\u294F',
		RightUpTeeVector: '\u295C',
		RightUpVector: '\u21BE',
		RightUpVectorBar: '\u2954',
		RightVector: '\u21C0',
		RightVectorBar: '\u2953',
		ring: '\u02DA',
		risingdotseq: '\u2253',
		rlarr: '\u21C4',
		rlhar: '\u21CC',
		rlm: '\u200F',
		rmoust: '\u23B1',
		rmoustache: '\u23B1',
		rnmid: '\u2AEE',
		roang: '\u27ED',
		roarr: '\u21FE',
		robrk: '\u27E7',
		ropar: '\u2986',
		Ropf: '\u211D',
		ropf: '\uD835\uDD63',
		roplus: '\u2A2E',
		rotimes: '\u2A35',
		RoundImplies: '\u2970',
		rpar: '\u0029',
		rpargt: '\u2994',
		rppolint: '\u2A12',
		rrarr: '\u21C9',
		Rrightarrow: '\u21DB',
		rsaquo: '\u203A',
		Rscr: '\u211B',
		rscr: '\uD835\uDCC7',
		Rsh: '\u21B1',
		rsh: '\u21B1',
		rsqb: '\u005D',
		rsquo: '\u2019',
		rsquor: '\u2019',
		rthree: '\u22CC',
		rtimes: '\u22CA',
		rtri: '\u25B9',
		rtrie: '\u22B5',
		rtrif: '\u25B8',
		rtriltri: '\u29CE',
		RuleDelayed: '\u29F4',
		ruluhar: '\u2968',
		rx: '\u211E',
		Sacute: '\u015A',
		sacute: '\u015B',
		sbquo: '\u201A',
		Sc: '\u2ABC',
		sc: '\u227B',
		scap: '\u2AB8',
		Scaron: '\u0160',
		scaron: '\u0161',
		sccue: '\u227D',
		scE: '\u2AB4',
		sce: '\u2AB0',
		Scedil: '\u015E',
		scedil: '\u015F',
		Scirc: '\u015C',
		scirc: '\u015D',
		scnap: '\u2ABA',
		scnE: '\u2AB6',
		scnsim: '\u22E9',
		scpolint: '\u2A13',
		scsim: '\u227F',
		Scy: '\u0421',
		scy: '\u0441',
		sdot: '\u22C5',
		sdotb: '\u22A1',
		sdote: '\u2A66',
		searhk: '\u2925',
		seArr: '\u21D8',
		searr: '\u2198',
		searrow: '\u2198',
		sect: '\u00A7',
		semi: '\u003B',
		seswar: '\u2929',
		setminus: '\u2216',
		setmn: '\u2216',
		sext: '\u2736',
		Sfr: '\uD835\uDD16',
		sfr: '\uD835\uDD30',
		sfrown: '\u2322',
		sharp: '\u266F',
		SHCHcy: '\u0429',
		shchcy: '\u0449',
		SHcy: '\u0428',
		shcy: '\u0448',
		ShortDownArrow: '\u2193',
		ShortLeftArrow: '\u2190',
		shortmid: '\u2223',
		shortparallel: '\u2225',
		ShortRightArrow: '\u2192',
		ShortUpArrow: '\u2191',
		shy: '\u00AD',
		Sigma: '\u03A3',
		sigma: '\u03C3',
		sigmaf: '\u03C2',
		sigmav: '\u03C2',
		sim: '\u223C',
		simdot: '\u2A6A',
		sime: '\u2243',
		simeq: '\u2243',
		simg: '\u2A9E',
		simgE: '\u2AA0',
		siml: '\u2A9D',
		simlE: '\u2A9F',
		simne: '\u2246',
		simplus: '\u2A24',
		simrarr: '\u2972',
		slarr: '\u2190',
		SmallCircle: '\u2218',
		smallsetminus: '\u2216',
		smashp: '\u2A33',
		smeparsl: '\u29E4',
		smid: '\u2223',
		smile: '\u2323',
		smt: '\u2AAA',
		smte: '\u2AAC',
		smtes: '\u2AAC\uFE00',
		SOFTcy: '\u042C',
		softcy: '\u044C',
		sol: '\u002F',
		solb: '\u29C4',
		solbar: '\u233F',
		Sopf: '\uD835\uDD4A',
		sopf: '\uD835\uDD64',
		spades: '\u2660',
		spadesuit: '\u2660',
		spar: '\u2225',
		sqcap: '\u2293',
		sqcaps: '\u2293\uFE00',
		sqcup: '\u2294',
		sqcups: '\u2294\uFE00',
		Sqrt: '\u221A',
		sqsub: '\u228F',
		sqsube: '\u2291',
		sqsubset: '\u228F',
		sqsubseteq: '\u2291',
		sqsup: '\u2290',
		sqsupe: '\u2292',
		sqsupset: '\u2290',
		sqsupseteq: '\u2292',
		squ: '\u25A1',
		Square: '\u25A1',
		square: '\u25A1',
		SquareIntersection: '\u2293',
		SquareSubset: '\u228F',
		SquareSubsetEqual: '\u2291',
		SquareSuperset: '\u2290',
		SquareSupersetEqual: '\u2292',
		SquareUnion: '\u2294',
		squarf: '\u25AA',
		squf: '\u25AA',
		srarr: '\u2192',
		Sscr: '\uD835\uDCAE',
		sscr: '\uD835\uDCC8',
		ssetmn: '\u2216',
		ssmile: '\u2323',
		sstarf: '\u22C6',
		Star: '\u22C6',
		star: '\u2606',
		starf: '\u2605',
		straightepsilon: '\u03F5',
		straightphi: '\u03D5',
		strns: '\u00AF',
		Sub: '\u22D0',
		sub: '\u2282',
		subdot: '\u2ABD',
		subE: '\u2AC5',
		sube: '\u2286',
		subedot: '\u2AC3',
		submult: '\u2AC1',
		subnE: '\u2ACB',
		subne: '\u228A',
		subplus: '\u2ABF',
		subrarr: '\u2979',
		Subset: '\u22D0',
		subset: '\u2282',
		subseteq: '\u2286',
		subseteqq: '\u2AC5',
		SubsetEqual: '\u2286',
		subsetneq: '\u228A',
		subsetneqq: '\u2ACB',
		subsim: '\u2AC7',
		subsub: '\u2AD5',
		subsup: '\u2AD3',
		succ: '\u227B',
		succapprox: '\u2AB8',
		succcurlyeq: '\u227D',
		Succeeds: '\u227B',
		SucceedsEqual: '\u2AB0',
		SucceedsSlantEqual: '\u227D',
		SucceedsTilde: '\u227F',
		succeq: '\u2AB0',
		succnapprox: '\u2ABA',
		succneqq: '\u2AB6',
		succnsim: '\u22E9',
		succsim: '\u227F',
		SuchThat: '\u220B',
		Sum: '\u2211',
		sum: '\u2211',
		sung: '\u266A',
		Sup: '\u22D1',
		sup: '\u2283',
		sup1: '\u00B9',
		sup2: '\u00B2',
		sup3: '\u00B3',
		supdot: '\u2ABE',
		supdsub: '\u2AD8',
		supE: '\u2AC6',
		supe: '\u2287',
		supedot: '\u2AC4',
		Superset: '\u2283',
		SupersetEqual: '\u2287',
		suphsol: '\u27C9',
		suphsub: '\u2AD7',
		suplarr: '\u297B',
		supmult: '\u2AC2',
		supnE: '\u2ACC',
		supne: '\u228B',
		supplus: '\u2AC0',
		Supset: '\u22D1',
		supset: '\u2283',
		supseteq: '\u2287',
		supseteqq: '\u2AC6',
		supsetneq: '\u228B',
		supsetneqq: '\u2ACC',
		supsim: '\u2AC8',
		supsub: '\u2AD4',
		supsup: '\u2AD6',
		swarhk: '\u2926',
		swArr: '\u21D9',
		swarr: '\u2199',
		swarrow: '\u2199',
		swnwar: '\u292A',
		szlig: '\u00DF',
		Tab: '\u0009',
		target: '\u2316',
		Tau: '\u03A4',
		tau: '\u03C4',
		tbrk: '\u23B4',
		Tcaron: '\u0164',
		tcaron: '\u0165',
		Tcedil: '\u0162',
		tcedil: '\u0163',
		Tcy: '\u0422',
		tcy: '\u0442',
		tdot: '\u20DB',
		telrec: '\u2315',
		Tfr: '\uD835\uDD17',
		tfr: '\uD835\uDD31',
		there4: '\u2234',
		Therefore: '\u2234',
		therefore: '\u2234',
		Theta: '\u0398',
		theta: '\u03B8',
		thetasym: '\u03D1',
		thetav: '\u03D1',
		thickapprox: '\u2248',
		thicksim: '\u223C',
		ThickSpace: '\u205F\u200A',
		thinsp: '\u2009',
		ThinSpace: '\u2009',
		thkap: '\u2248',
		thksim: '\u223C',
		THORN: '\u00DE',
		thorn: '\u00FE',
		Tilde: '\u223C',
		tilde: '\u02DC',
		TildeEqual: '\u2243',
		TildeFullEqual: '\u2245',
		TildeTilde: '\u2248',
		times: '\u00D7',
		timesb: '\u22A0',
		timesbar: '\u2A31',
		timesd: '\u2A30',
		tint: '\u222D',
		toea: '\u2928',
		top: '\u22A4',
		topbot: '\u2336',
		topcir: '\u2AF1',
		Topf: '\uD835\uDD4B',
		topf: '\uD835\uDD65',
		topfork: '\u2ADA',
		tosa: '\u2929',
		tprime: '\u2034',
		TRADE: '\u2122',
		trade: '\u2122',
		triangle: '\u25B5',
		triangledown: '\u25BF',
		triangleleft: '\u25C3',
		trianglelefteq: '\u22B4',
		triangleq: '\u225C',
		triangleright: '\u25B9',
		trianglerighteq: '\u22B5',
		tridot: '\u25EC',
		trie: '\u225C',
		triminus: '\u2A3A',
		TripleDot: '\u20DB',
		triplus: '\u2A39',
		trisb: '\u29CD',
		tritime: '\u2A3B',
		trpezium: '\u23E2',
		Tscr: '\uD835\uDCAF',
		tscr: '\uD835\uDCC9',
		TScy: '\u0426',
		tscy: '\u0446',
		TSHcy: '\u040B',
		tshcy: '\u045B',
		Tstrok: '\u0166',
		tstrok: '\u0167',
		twixt: '\u226C',
		twoheadleftarrow: '\u219E',
		twoheadrightarrow: '\u21A0',
		Uacute: '\u00DA',
		uacute: '\u00FA',
		Uarr: '\u219F',
		uArr: '\u21D1',
		uarr: '\u2191',
		Uarrocir: '\u2949',
		Ubrcy: '\u040E',
		ubrcy: '\u045E',
		Ubreve: '\u016C',
		ubreve: '\u016D',
		Ucirc: '\u00DB',
		ucirc: '\u00FB',
		Ucy: '\u0423',
		ucy: '\u0443',
		udarr: '\u21C5',
		Udblac: '\u0170',
		udblac: '\u0171',
		udhar: '\u296E',
		ufisht: '\u297E',
		Ufr: '\uD835\uDD18',
		ufr: '\uD835\uDD32',
		Ugrave: '\u00D9',
		ugrave: '\u00F9',
		uHar: '\u2963',
		uharl: '\u21BF',
		uharr: '\u21BE',
		uhblk: '\u2580',
		ulcorn: '\u231C',
		ulcorner: '\u231C',
		ulcrop: '\u230F',
		ultri: '\u25F8',
		Umacr: '\u016A',
		umacr: '\u016B',
		uml: '\u00A8',
		UnderBar: '\u005F',
		UnderBrace: '\u23DF',
		UnderBracket: '\u23B5',
		UnderParenthesis: '\u23DD',
		Union: '\u22C3',
		UnionPlus: '\u228E',
		Uogon: '\u0172',
		uogon: '\u0173',
		Uopf: '\uD835\uDD4C',
		uopf: '\uD835\uDD66',
		UpArrow: '\u2191',
		Uparrow: '\u21D1',
		uparrow: '\u2191',
		UpArrowBar: '\u2912',
		UpArrowDownArrow: '\u21C5',
		UpDownArrow: '\u2195',
		Updownarrow: '\u21D5',
		updownarrow: '\u2195',
		UpEquilibrium: '\u296E',
		upharpoonleft: '\u21BF',
		upharpoonright: '\u21BE',
		uplus: '\u228E',
		UpperLeftArrow: '\u2196',
		UpperRightArrow: '\u2197',
		Upsi: '\u03D2',
		upsi: '\u03C5',
		upsih: '\u03D2',
		Upsilon: '\u03A5',
		upsilon: '\u03C5',
		UpTee: '\u22A5',
		UpTeeArrow: '\u21A5',
		upuparrows: '\u21C8',
		urcorn: '\u231D',
		urcorner: '\u231D',
		urcrop: '\u230E',
		Uring: '\u016E',
		uring: '\u016F',
		urtri: '\u25F9',
		Uscr: '\uD835\uDCB0',
		uscr: '\uD835\uDCCA',
		utdot: '\u22F0',
		Utilde: '\u0168',
		utilde: '\u0169',
		utri: '\u25B5',
		utrif: '\u25B4',
		uuarr: '\u21C8',
		Uuml: '\u00DC',
		uuml: '\u00FC',
		uwangle: '\u29A7',
		vangrt: '\u299C',
		varepsilon: '\u03F5',
		varkappa: '\u03F0',
		varnothing: '\u2205',
		varphi: '\u03D5',
		varpi: '\u03D6',
		varpropto: '\u221D',
		vArr: '\u21D5',
		varr: '\u2195',
		varrho: '\u03F1',
		varsigma: '\u03C2',
		varsubsetneq: '\u228A\uFE00',
		varsubsetneqq: '\u2ACB\uFE00',
		varsupsetneq: '\u228B\uFE00',
		varsupsetneqq: '\u2ACC\uFE00',
		vartheta: '\u03D1',
		vartriangleleft: '\u22B2',
		vartriangleright: '\u22B3',
		Vbar: '\u2AEB',
		vBar: '\u2AE8',
		vBarv: '\u2AE9',
		Vcy: '\u0412',
		vcy: '\u0432',
		VDash: '\u22AB',
		Vdash: '\u22A9',
		vDash: '\u22A8',
		vdash: '\u22A2',
		Vdashl: '\u2AE6',
		Vee: '\u22C1',
		vee: '\u2228',
		veebar: '\u22BB',
		veeeq: '\u225A',
		vellip: '\u22EE',
		Verbar: '\u2016',
		verbar: '\u007C',
		Vert: '\u2016',
		vert: '\u007C',
		VerticalBar: '\u2223',
		VerticalLine: '\u007C',
		VerticalSeparator: '\u2758',
		VerticalTilde: '\u2240',
		VeryThinSpace: '\u200A',
		Vfr: '\uD835\uDD19',
		vfr: '\uD835\uDD33',
		vltri: '\u22B2',
		vnsub: '\u2282\u20D2',
		vnsup: '\u2283\u20D2',
		Vopf: '\uD835\uDD4D',
		vopf: '\uD835\uDD67',
		vprop: '\u221D',
		vrtri: '\u22B3',
		Vscr: '\uD835\uDCB1',
		vscr: '\uD835\uDCCB',
		vsubnE: '\u2ACB\uFE00',
		vsubne: '\u228A\uFE00',
		vsupnE: '\u2ACC\uFE00',
		vsupne: '\u228B\uFE00',
		Vvdash: '\u22AA',
		vzigzag: '\u299A',
		Wcirc: '\u0174',
		wcirc: '\u0175',
		wedbar: '\u2A5F',
		Wedge: '\u22C0',
		wedge: '\u2227',
		wedgeq: '\u2259',
		weierp: '\u2118',
		Wfr: '\uD835\uDD1A',
		wfr: '\uD835\uDD34',
		Wopf: '\uD835\uDD4E',
		wopf: '\uD835\uDD68',
		wp: '\u2118',
		wr: '\u2240',
		wreath: '\u2240',
		Wscr: '\uD835\uDCB2',
		wscr: '\uD835\uDCCC',
		xcap: '\u22C2',
		xcirc: '\u25EF',
		xcup: '\u22C3',
		xdtri: '\u25BD',
		Xfr: '\uD835\uDD1B',
		xfr: '\uD835\uDD35',
		xhArr: '\u27FA',
		xharr: '\u27F7',
		Xi: '\u039E',
		xi: '\u03BE',
		xlArr: '\u27F8',
		xlarr: '\u27F5',
		xmap: '\u27FC',
		xnis: '\u22FB',
		xodot: '\u2A00',
		Xopf: '\uD835\uDD4F',
		xopf: '\uD835\uDD69',
		xoplus: '\u2A01',
		xotime: '\u2A02',
		xrArr: '\u27F9',
		xrarr: '\u27F6',
		Xscr: '\uD835\uDCB3',
		xscr: '\uD835\uDCCD',
		xsqcup: '\u2A06',
		xuplus: '\u2A04',
		xutri: '\u25B3',
		xvee: '\u22C1',
		xwedge: '\u22C0',
		Yacute: '\u00DD',
		yacute: '\u00FD',
		YAcy: '\u042F',
		yacy: '\u044F',
		Ycirc: '\u0176',
		ycirc: '\u0177',
		Ycy: '\u042B',
		ycy: '\u044B',
		yen: '\u00A5',
		Yfr: '\uD835\uDD1C',
		yfr: '\uD835\uDD36',
		YIcy: '\u0407',
		yicy: '\u0457',
		Yopf: '\uD835\uDD50',
		yopf: '\uD835\uDD6A',
		Yscr: '\uD835\uDCB4',
		yscr: '\uD835\uDCCE',
		YUcy: '\u042E',
		yucy: '\u044E',
		Yuml: '\u0178',
		yuml: '\u00FF',
		Zacute: '\u0179',
		zacute: '\u017A',
		Zcaron: '\u017D',
		zcaron: '\u017E',
		Zcy: '\u0417',
		zcy: '\u0437',
		Zdot: '\u017B',
		zdot: '\u017C',
		zeetrf: '\u2128',
		ZeroWidthSpace: '\u200B',
		Zeta: '\u0396',
		zeta: '\u03B6',
		Zfr: '\u2128',
		zfr: '\uD835\uDD37',
		ZHcy: '\u0416',
		zhcy: '\u0436',
		zigrarr: '\u21DD',
		Zopf: '\u2124',
		zopf: '\uD835\uDD6B',
		Zscr: '\uD835\uDCB5',
		zscr: '\uD835\uDCCF',
		zwj: '\u200D',
		zwnj: '\u200C',
	});
	
	/**
	 * @deprecated use `HTML_ENTITIES` instead
	 * @see HTML_ENTITIES
	 */
	exports.entityMap = exports.HTML_ENTITIES;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var dom = __webpack_require__(26)
	exports.DOMImplementation = dom.DOMImplementation
	exports.XMLSerializer = dom.XMLSerializer
	exports.DOMParser = __webpack_require__(176).DOMParser


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var NAMESPACE = __webpack_require__(9).NAMESPACE;
	
	//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
	//[5]   	Name	   ::=   	NameStartChar (NameChar)*
	var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
	var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
	var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
	//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
	//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
	
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
	var S_TAG = 0;//tag name offerring
	var S_ATTR = 1;//attr name offerring
	var S_ATTR_SPACE=2;//attr name end and space offer
	var S_EQ = 3;//=space?
	var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
	var S_ATTR_END = 5;//attr value end and no space(quot end)
	var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
	var S_TAG_CLOSE = 7;//closed el<el />
	
	/**
	 * Creates an error that will not be caught by XMLReader aka the SAX parser.
	 *
	 * @param {string} message
	 * @param {any?} locator Optional, can provide details about the location in the source
	 * @constructor
	 */
	function ParseError(message, locator) {
		this.message = message
		this.locator = locator
		if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
	}
	ParseError.prototype = new Error();
	ParseError.prototype.name = ParseError.name
	
	function XMLReader(){
	
	}
	
	XMLReader.prototype = {
		parse:function(source,defaultNSMap,entityMap){
			var domBuilder = this.domBuilder;
			domBuilder.startDocument();
			_copy(defaultNSMap ,defaultNSMap = {})
			parse(source,defaultNSMap,entityMap,
					domBuilder,this.errorHandler);
			domBuilder.endDocument();
		}
	}
	function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
		function fixedFromCharCode(code) {
			// String.prototype.fromCharCode does not supports
			// > 2 bytes unicode chars directly
			if (code > 0xffff) {
				code -= 0x10000;
				var surrogate1 = 0xd800 + (code >> 10)
					, surrogate2 = 0xdc00 + (code & 0x3ff);
	
				return String.fromCharCode(surrogate1, surrogate2);
			} else {
				return String.fromCharCode(code);
			}
		}
		function entityReplacer(a){
			var k = a.slice(1,-1);
			if (Object.hasOwnProperty.call(entityMap, k)) {
				return entityMap[k];
			}else if(k.charAt(0) === '#'){
				return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
			}else{
				errorHandler.error('entity not found:'+a);
				return a;
			}
		}
		function appendText(end){//has some bugs
			if(end>start){
				var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
				locator&&position(start);
				domBuilder.characters(xt,0,end-start);
				start = end
			}
		}
		function position(p,m){
			while(p>=lineEnd && (m = linePattern.exec(source))){
				lineStart = m.index;
				lineEnd = lineStart + m[0].length;
				locator.lineNumber++;
				//console.log('line++:',locator,startPos,endPos)
			}
			locator.columnNumber = p-lineStart+1;
		}
		var lineStart = 0;
		var lineEnd = 0;
		var linePattern = /.*(?:\r\n?|\n)|.*$/g
		var locator = domBuilder.locator;
	
		var parseStack = [{currentNSMap:defaultNSMapCopy}]
		var closeMap = {};
		var start = 0;
		while(true){
			try{
				var tagStart = source.indexOf('<',start);
				if(tagStart<0){
					if(!source.substr(start).match(/^\s*$/)){
						var doc = domBuilder.doc;
		    			var text = doc.createTextNode(source.substr(start));
		    			doc.appendChild(text);
		    			domBuilder.currentElement = text;
					}
					return;
				}
				if(tagStart>start){
					appendText(tagStart);
				}
				switch(source.charAt(tagStart+1)){
				case '/':
					var end = source.indexOf('>',tagStart+3);
					var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
					var config = parseStack.pop();
					if(end<0){
	
		        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
		        		end = tagStart+1+tagName.length;
		        	}else if(tagName.match(/\s</)){
		        		tagName = tagName.replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
		        		end = tagStart+1+tagName.length;
					}
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
			        if(endIgnoreCaseMach){
			        	domBuilder.endElement(config.uri,config.localName,tagName);
						if(localNSMap){
							for (var prefix in localNSMap) {
								if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
									domBuilder.endPrefixMapping(prefix);
								}
							}
						}
						if(!endMatch){
			            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
						}
			        }else{
			        	parseStack.push(config)
			        }
	
					end++;
					break;
					// end elment
				case '?':// <?...?>
					locator&&position(tagStart);
					end = parseInstruction(source,tagStart,domBuilder);
					break;
				case '!':// <!doctype,<![CDATA,<!--
					locator&&position(tagStart);
					end = parseDCC(source,tagStart,domBuilder,errorHandler);
					break;
				default:
					locator&&position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
					var len = el.length;
	
	
					if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
						el.closed = true;
						if(!entityMap.nbsp){
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if(locator && len){
						var locator2 = copyLocator(locator,{});
						//try{//attribute position fixed
						for(var i = 0;i<len;i++){
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator,{});
						}
						domBuilder.locator = locator2
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
						domBuilder.locator = locator;
					}else{
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
					}
	
					if (NAMESPACE.isHTML(el.uri) && !el.closed) {
						end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
					} else {
						end++;
					}
				}
			}catch(e){
				if (e instanceof ParseError) {
					throw e;
				}
				errorHandler.error('element parse error: '+e)
				end = -1;
			}
			if(end>start){
				start = end;
			}else{
				//TODO: 这里有可能sax回退，有位置错误风险
				appendText(Math.max(tagStart,start)+1);
			}
		}
	}
	function copyLocator(f,t){
		t.lineNumber = f.lineNumber;
		t.columnNumber = f.columnNumber;
		return t;
	}
	
	/**
	 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
	 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
	 */
	function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){
	
		/**
		 * @param {string} qname
		 * @param {string} value
		 * @param {number} startIndex
		 */
		function addAttribute(qname, value, startIndex) {
			if (el.attributeNames.hasOwnProperty(qname)) {
				errorHandler.fatalError('Attribute ' + qname + ' redefined')
			}
			el.addValue(
				qname,
				// @see https://www.w3.org/TR/xml/#AVNormalize
				// since the xmldom sax parser does not "interpret" DTD the following is not implemented:
				// - recursive replacement of (DTD) entity references
				// - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
				value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer),
				startIndex
			)
		}
		var attrName;
		var value;
		var p = ++start;
		var s = S_TAG;//status
		while(true){
			var c = source.charAt(p);
			switch(c){
			case '=':
				if(s === S_ATTR){//attrName
					attrName = source.slice(start,p);
					s = S_EQ;
				}else if(s === S_ATTR_SPACE){
					s = S_EQ;
				}else{
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName'); // No known test case
				}
				break;
			case '\'':
			case '"':
				if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
					){//equal
					if(s === S_ATTR){
						errorHandler.warning('attribute value must after "="')
						attrName = source.slice(start,p)
					}
					start = p+1;
					p = source.indexOf(c,start)
					if(p>0){
						value = source.slice(start, p);
						addAttribute(attrName, value, start-1);
						s = S_ATTR_END;
					}else{
						//fatalError: no end quot match
						throw new Error('attribute value no end \''+c+'\' match');
					}
				}else if(s == S_ATTR_NOQUOT_VALUE){
					value = source.slice(start, p);
					addAttribute(attrName, value, start);
					errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
					start = p+1;
					s = S_ATTR_END
				}else{
					//fatalError: no equal before
					throw new Error('attribute value must after "="'); // No known test case
				}
				break;
			case '/':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					s =S_TAG_CLOSE;
					el.closed = true;
				case S_ATTR_NOQUOT_VALUE:
				case S_ATTR:
					break;
					case S_ATTR_SPACE:
						el.closed = true;
					break;
				//case S_EQ:
				default:
					throw new Error("attribute invalid close char('/')") // No known test case
				}
				break;
			case ''://end document
				errorHandler.error('unexpected end of input');
				if(s == S_TAG){
					el.setTagName(source.slice(start,p));
				}
				return p;
			case '>':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					break;//normal
				case S_ATTR_NOQUOT_VALUE://Compatible state
				case S_ATTR:
					value = source.slice(start,p);
					if(value.slice(-1) === '/'){
						el.closed  = true;
						value = value.slice(0,-1)
					}
				case S_ATTR_SPACE:
					if(s === S_ATTR_SPACE){
						value = attrName;
					}
					if(s == S_ATTR_NOQUOT_VALUE){
						errorHandler.warning('attribute "'+value+'" missed quot(")!');
						addAttribute(attrName, value, start)
					}else{
						if(!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
						}
						addAttribute(value, value, start)
					}
					break;
				case S_EQ:
					throw new Error('attribute value missed!!');
				}
	//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case '\u0080':
				c = ' ';
			default:
				if(c<= ' '){//space
					switch(s){
					case S_TAG:
						el.setTagName(source.slice(start,p));//tagName
						s = S_TAG_SPACE;
						break;
					case S_ATTR:
						attrName = source.slice(start,p)
						s = S_ATTR_SPACE;
						break;
					case S_ATTR_NOQUOT_VALUE:
						var value = source.slice(start, p);
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						addAttribute(attrName, value, start)
					case S_ATTR_END:
						s = S_TAG_SPACE;
						break;
					//case S_TAG_SPACE:
					//case S_EQ:
					//case S_ATTR_SPACE:
					//	void();break;
					//case S_TAG_CLOSE:
						//ignore warning
					}
				}else{//not space
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch(s){
					//case S_TAG:void();break;
					//case S_ATTR:void();break;
					//case S_ATTR_NOQUOT_VALUE:void();break;
					case S_ATTR_SPACE:
						var tagName =  el.tagName;
						if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
							errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
						}
						addAttribute(attrName, attrName, start);
						start = p;
						s = S_ATTR;
						break;
					case S_ATTR_END:
						errorHandler.warning('attribute space is required"'+attrName+'"!!')
					case S_TAG_SPACE:
						s = S_ATTR;
						start = p;
						break;
					case S_EQ:
						s = S_ATTR_NOQUOT_VALUE;
						start = p;
						break;
					case S_TAG_CLOSE:
						throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
			}//end outer switch
			//console.log('p++',p)
			p++;
		}
	}
	/**
	 * @return true if has new namespace define
	 */
	function appendElement(el,domBuilder,currentNSMap){
		var tagName = el.tagName;
		var localNSMap = null;
		//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
		var i = el.length;
		while(i--){
			var a = el[i];
			var qName = a.qName;
			var value = a.value;
			var nsp = qName.indexOf(':');
			if(nsp>0){
				var prefix = a.prefix = qName.slice(0,nsp);
				var localName = qName.slice(nsp+1);
				var nsPrefix = prefix === 'xmlns' && localName
			}else{
				localName = qName;
				prefix = null
				nsPrefix = qName === 'xmlns' && ''
			}
			//can not set prefix,because prefix !== ''
			a.localName = localName ;
			//prefix == null for no ns prefix attribute
			if(nsPrefix !== false){//hack!!
				if(localNSMap == null){
					localNSMap = {}
					//console.log(currentNSMap,0)
					_copy(currentNSMap,currentNSMap={})
					//console.log(currentNSMap,1)
				}
				currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
				a.uri = NAMESPACE.XMLNS
				domBuilder.startPrefixMapping(nsPrefix, value)
			}
		}
		var i = el.length;
		while(i--){
			a = el[i];
			var prefix = a.prefix;
			if(prefix){//no prefix attribute has no namespace
				if(prefix === 'xml'){
					a.uri = NAMESPACE.XML;
				}if(prefix !== 'xmlns'){
					a.uri = currentNSMap[prefix || '']
	
					//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
				}
			}
		}
		var nsp = tagName.indexOf(':');
		if(nsp>0){
			prefix = el.prefix = tagName.slice(0,nsp);
			localName = el.localName = tagName.slice(nsp+1);
		}else{
			prefix = null;//important!!
			localName = el.localName = tagName;
		}
		//no prefix element has default namespace
		var ns = el.uri = currentNSMap[prefix || ''];
		domBuilder.startElement(ns,localName,tagName,el);
		//endPrefixMapping and startPrefixMapping have not any help for dom builder
		//localNSMap = null
		if(el.closed){
			domBuilder.endElement(ns,localName,tagName);
			if(localNSMap){
				for (prefix in localNSMap) {
					if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
						domBuilder.endPrefixMapping(prefix);
					}
				}
			}
		}else{
			el.currentNSMap = currentNSMap;
			el.localNSMap = localNSMap;
			//parseStack.push(el);
			return true;
		}
	}
	function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
		if(/^(?:script|textarea)$/i.test(tagName)){
			var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
			var text = source.substring(elStartEnd+1,elEndStart);
			if(/[&<]/.test(text)){
				if(/^script$/i.test(tagName)){
					//if(!/\]\]>/.test(text)){
						//lexHandler.startCDATA();
						domBuilder.characters(text,0,text.length);
						//lexHandler.endCDATA();
						return elEndStart;
					//}
				}//}else{//text area
					text = text.replace(/&#?\w+;/g,entityReplacer);
					domBuilder.characters(text,0,text.length);
					return elEndStart;
				//}
	
			}
		}
		return elStartEnd+1;
	}
	function fixSelfClosed(source,elStartEnd,tagName,closeMap){
		//if(tagName in closeMap){
		var pos = closeMap[tagName];
		if(pos == null){
			//console.log(tagName)
			pos =  source.lastIndexOf('</'+tagName+'>')
			if(pos<elStartEnd){//忘记闭合
				pos = source.lastIndexOf('</'+tagName)
			}
			closeMap[tagName] =pos
		}
		return pos<elStartEnd;
		//}
	}
	
	function _copy (source, target) {
		for (var n in source) {
			if (Object.prototype.hasOwnProperty.call(source, n)) {
				target[n] = source[n];
			}
		}
	}
	
	function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
		var next= source.charAt(start+2)
		switch(next){
		case '-':
			if(source.charAt(start + 3) === '-'){
				var end = source.indexOf('-->',start+4);
				//append comment source.substring(4,end)//<!--
				if(end>start){
					domBuilder.comment(source,start+4,end-start-4);
					return end+3;
				}else{
					errorHandler.error("Unclosed comment");
					return -1;
				}
			}else{
				//error
				return -1;
			}
		default:
			if(source.substr(start+3,6) == 'CDATA['){
				var end = source.indexOf(']]>',start+9);
				domBuilder.startCDATA();
				domBuilder.characters(source,start+9,end-start-9);
				domBuilder.endCDATA()
				return end+3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
			var matchs = split(source,start);
			var len = matchs.length;
			if(len>1 && /!doctype/i.test(matchs[0][0])){
				var name = matchs[1][0];
				var pubid = false;
				var sysid = false;
				if(len>3){
					if(/^public$/i.test(matchs[2][0])){
						pubid = matchs[3][0];
						sysid = len>4 && matchs[4][0];
					}else if(/^system$/i.test(matchs[2][0])){
						sysid = matchs[3][0];
					}
				}
				var lastMatch = matchs[len-1]
				domBuilder.startDTD(name, pubid, sysid);
				domBuilder.endDTD();
	
				return lastMatch.index+lastMatch[0].length
			}
		}
		return -1;
	}
	
	
	
	function parseInstruction(source,start,domBuilder){
		var end = source.indexOf('?>',start);
		if(end){
			var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
			if(match){
				var len = match[0].length;
				domBuilder.processingInstruction(match[1], match[2]) ;
				return end+2;
			}else{//error
				return -1;
			}
		}
		return -1;
	}
	
	function ElementAttributes(){
		this.attributeNames = {}
	}
	ElementAttributes.prototype = {
		setTagName:function(tagName){
			if(!tagNamePattern.test(tagName)){
				throw new Error('invalid tagName:'+tagName)
			}
			this.tagName = tagName
		},
		addValue:function(qName, value, offset) {
			if(!tagNamePattern.test(qName)){
				throw new Error('invalid attribute:'+qName)
			}
			this.attributeNames[qName] = this.length;
			this[this.length++] = {qName:qName,value:value,offset:offset}
		},
		length:0,
		getLocalName:function(i){return this[i].localName},
		getLocator:function(i){return this[i].locator},
		getQName:function(i){return this[i].qName},
		getURI:function(i){return this[i].uri},
		getValue:function(i){return this[i].value}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
	}
	
	
	
	function split(source,start){
		var match;
		var buf = [];
		var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		reg.lastIndex = start;
		reg.exec(source);//skip <
		while(match = reg.exec(source)){
			buf.push(match);
			if(match[1])return buf;
		}
	}
	
	exports.XMLReader = XMLReader;
	exports.ParseError = ParseError;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.12.1 - 2015-02-20
	 * License: MIT
	 */
	angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.transition', [])
	
	/**
	 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
	 * @param  {DOMElement} element  The DOMElement that will be animated.
	 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
	 *   - As a string, it represents the css class to be added to the element.
	 *   - As an object, it represents a hash of style attributes to be applied to the element.
	 *   - As a function, it represents a function to be called that will cause the transition to occur.
	 * @return {Promise}  A promise that is resolved when the transition finishes.
	 */
	.factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {
	
	  var $transition = function(element, trigger, options) {
	    options = options || {};
	    var deferred = $q.defer();
	    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];
	
	    var transitionEndHandler = function(event) {
	      $rootScope.$apply(function() {
	        element.unbind(endEventName, transitionEndHandler);
	        deferred.resolve(element);
	      });
	    };
	
	    if (endEventName) {
	      element.bind(endEventName, transitionEndHandler);
	    }
	
	    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
	    $timeout(function() {
	      if ( angular.isString(trigger) ) {
	        element.addClass(trigger);
	      } else if ( angular.isFunction(trigger) ) {
	        trigger(element);
	      } else if ( angular.isObject(trigger) ) {
	        element.css(trigger);
	      }
	      //If browser does not support transitions, instantly resolve
	      if ( !endEventName ) {
	        deferred.resolve(element);
	      }
	    });
	
	    // Add our custom cancel function to the promise that is returned
	    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
	    // i.e. it will therefore never raise a transitionEnd event for that transition
	    deferred.promise.cancel = function() {
	      if ( endEventName ) {
	        element.unbind(endEventName, transitionEndHandler);
	      }
	      deferred.reject('Transition cancelled');
	    };
	
	    return deferred.promise;
	  };
	
	  // Work out the name of the transitionEnd event
	  var transElement = document.createElement('trans');
	  var transitionEndEventNames = {
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'transitionend',
	    'OTransition': 'oTransitionEnd',
	    'transition': 'transitionend'
	  };
	  var animationEndEventNames = {
	    'WebkitTransition': 'webkitAnimationEnd',
	    'MozTransition': 'animationend',
	    'OTransition': 'oAnimationEnd',
	    'transition': 'animationend'
	  };
	  function findEndEventName(endEventNames) {
	    for (var name in endEventNames){
	      if (transElement.style[name] !== undefined) {
	        return endEventNames[name];
	      }
	    }
	  }
	  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
	  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
	  return $transition;
	}]);
	
	angular.module('ui.bootstrap.collapse', ['ui.bootstrap.transition'])
	
	  .directive('collapse', ['$transition', function ($transition) {
	
	    return {
	      link: function (scope, element, attrs) {
	
	        var initialAnimSkip = true;
	        var currentTransition;
	
	        function doTransition(change) {
	          var newTransition = $transition(element, change);
	          if (currentTransition) {
	            currentTransition.cancel();
	          }
	          currentTransition = newTransition;
	          newTransition.then(newTransitionDone, newTransitionDone);
	          return newTransition;
	
	          function newTransitionDone() {
	            // Make sure it's this transition, otherwise, leave it alone.
	            if (currentTransition === newTransition) {
	              currentTransition = undefined;
	            }
	          }
	        }
	
	        function expand() {
	          if (initialAnimSkip) {
	            initialAnimSkip = false;
	            expandDone();
	          } else {
	            element.removeClass('collapse').addClass('collapsing');
	            doTransition({ height: element[0].scrollHeight + 'px' }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing');
	          element.addClass('collapse in');
	          element.css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (initialAnimSkip) {
	            initialAnimSkip = false;
	            collapseDone();
	            element.css({height: 0});
	          } else {
	            // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
	            element.css({ height: element[0].scrollHeight + 'px' });
	            //trigger reflow so a browser realizes that height was updated from auto to a specific value
	            var x = element[0].offsetWidth;
	
	            element.removeClass('collapse in').addClass('collapsing');
	
	            doTransition({ height: 0 }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.removeClass('collapsing');
	          element.addClass('collapse');
	        }
	
	        scope.$watch(attrs.collapse, function (shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])
	
	.constant('accordionConfig', {
	  closeOthers: true
	})
	
	.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {
	
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if ( closeOthers ) {
	      angular.forEach(this.groups, function (group) {
	        if ( group !== openGroup ) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if ( index !== -1 ) {
	      this.groups.splice(index, 1);
	    }
	  };
	
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('accordion', function () {
	  return {
	    restrict:'EA',
	    controller:'AccordionController',
	    transclude: true,
	    replace: false,
	    templateUrl: 'template/accordion/accordion.html'
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('accordionGroup', function() {
	  return {
	    require:'^accordion',         // We need this directive to be inside an accordion
	    restrict:'EA',
	    transclude:true,              // It transcludes the contents of the directive into the template
	    replace: true,                // The element containing the directive will be replaced with the template
	    templateUrl:'template/accordion/accordion-group.html',
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.$watch('isOpen', function(value) {
	        if ( value ) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function() {
	        if ( !scope.isDisabled ) {
	          scope.isOpen = !scope.isOpen;
	        }
	      };
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	// <accordion-group>
	//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
	// </accordion-group>
	.directive('accordionHeading', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^accordionGroup',
	    link: function(scope, element, attr, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, function() {}));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	// <div class="accordion-group">
	//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
	//   ...
	// </div>
	.directive('accordionTransclude', function() {
	  return {
	    require: '^accordionGroup',
	    link: function(scope, element, attr, controller) {
	      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
	        if ( heading ) {
	          element.html('');
	          element.append(heading);
	        }
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('AlertController', ['$scope', '$attrs', function ($scope, $attrs) {
	  $scope.closeable = 'close' in $attrs;
	  this.close = $scope.close;
	}])
	
	.directive('alert', function () {
	  return {
	    restrict:'EA',
	    controller:'AlertController',
	    templateUrl:'template/alert/alert.html',
	    transclude:true,
	    replace:true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	})
	
	.directive('dismissOnTimeout', ['$timeout', function($timeout) {
	  return {
	    require: 'alert',
	    link: function(scope, element, attrs, alertCtrl) {
	      $timeout(function(){
	        alertCtrl.close();
	      }, parseInt(attrs.dismissOnTimeout, 10));
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.bindHtml', [])
	
	  .directive('bindHtmlUnsafe', function () {
	    return function (scope, element, attr) {
	      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
	      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
	        element.html(value || '');
	      });
	    };
	  });
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('buttonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('ButtonsController', ['buttonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('btnRadio', function () {
	  return {
	    require: ['btnRadio', 'ngModel'],
	    controller: 'ButtonsController',
	    link: function (scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function () {
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	    }
	  };
	})
	
	.directive('btnCheckbox', function () {
	  return {
	    require: ['btnCheckbox', 'ngModel'],
	    controller: 'ButtonsController',
	    link: function (scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attributeValue, defaultValue) {
	        var val = scope.$eval(attributeValue);
	        return angular.isDefined(val) ? val : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.bind(buttonsCtrl.toggleEvent, function () {
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	/**
	* @ngdoc overview
	* @name ui.bootstrap.carousel
	*
	* @description
	* AngularJS version of an image carousel.
	*
	*/
	angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
	.controller('CarouselController', ['$scope', '$timeout', '$interval', '$transition', function ($scope, $timeout, $interval, $transition) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    currentIndex = -1,
	    currentInterval, isPlaying;
	  self.currentSlide = null;
	
	  var destroyed = false;
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = slides.indexOf(nextSlide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > currentIndex ? 'next' : 'prev';
	    }
	    if (nextSlide && nextSlide !== self.currentSlide) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition.cancel();
	        //Timeout so ng-class in template has time to fix classes for finished slide
	        $timeout(goNext);
	      } else {
	        goNext();
	      }
	    }
	    function goNext() {
	      // Scope has been destroyed, stop here.
	      if (destroyed) { return; }
	      //If we have a slide to transition from and we have a transition type and we're allowed, go
	      if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
	        //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
	        nextSlide.$element.addClass(direction);
	        var reflow = nextSlide.$element[0].offsetWidth; //force reflow
	
	        //Set all other slides to stop doing their stuff for the new transition
	        angular.forEach(slides, function(slide) {
	          angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
	        });
	        angular.extend(nextSlide, {direction: direction, active: true, entering: true});
	        angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});
	
	        $scope.$currentTransition = $transition(nextSlide.$element, {});
	        //We have to create new pointers inside a closure since next & current will change
	        (function(next,current) {
	          $scope.$currentTransition.then(
	            function(){ transitionDone(next, current); },
	            function(){ transitionDone(next, current); }
	          );
	        }(nextSlide, self.currentSlide));
	      } else {
	        transitionDone(nextSlide, self.currentSlide);
	      }
	      self.currentSlide = nextSlide;
	      currentIndex = nextIndex;
	      //every time you change slides, reset the timer
	      restartTimer();
	    }
	    function transitionDone(next, current) {
	      angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
	      angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
	      $scope.$currentTransition = null;
	    }
	  };
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  /* Allow outside people to call indexOf on slides array */
	  self.indexOfSlide = function(slide) {
	    return slides.indexOf(slide);
	  };
	
	  $scope.next = function() {
	    var newIndex = (currentIndex + 1) % slides.length;
	
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (!$scope.$currentTransition) {
	      return self.select(slides[newIndex], 'next');
	    }
	  };
	
	  $scope.prev = function() {
	    var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
	
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (!$scope.$currentTransition) {
	      return self.select(slides[newIndex], 'prev');
	    }
	  };
	
	  $scope.isActive = function(slide) {
	     return self.currentSlide === slide;
	  };
	
	  $scope.$watch('interval', restartTimer);
	  $scope.$on('$destroy', resetTimer);
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  self.addSlide = function(slide, element) {
	    slide.$element = element;
	    slides.push(slide);
	    //if this is the first slide or the slide is set to active, select it
	    if(slides.length === 1 || slide.active) {
	      self.select(slides[slides.length-1]);
	      if (slides.length == 1) {
	        $scope.play();
	      }
	    } else {
	      slide.active = false;
	    }
	  };
	
	  self.removeSlide = function(slide) {
	    //get the index of the slide inside the carousel
	    var index = slides.indexOf(slide);
	    slides.splice(index, 1);
	    if (slides.length > 0 && slide.active) {
	      if (index >= slides.length) {
	        self.select(slides[index-1]);
	      } else {
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	    }
	  };
	
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:carousel
	 * @restrict EA
	 *
	 * @description
	 * Carousel is the outer container for a set of image 'slides' to showcase.
	 *
	 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
	 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
	 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <carousel>
	      <slide>
	        <img src="http://placekitten.com/150/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>Beautiful!</p>
	        </div>
	      </slide>
	      <slide>
	        <img src="http://placekitten.com/100/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>D'aww!</p>
	        </div>
	      </slide>
	    </carousel>
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	 */
	.directive('carousel', [function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    controller: 'CarouselController',
	    require: 'carousel',
	    templateUrl: 'template/carousel/carousel.html',
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '='
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:slide
	 * @restrict EA
	 *
	 * @description
	 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
	 *
	 * @param {boolean=} active Model binding, whether or not this slide is currently active.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	<div ng-controller="CarouselDemoCtrl">
	  <carousel>
	    <slide ng-repeat="slide in slides" active="slide.active">
	      <img ng-src="{{slide.image}}" style="margin:auto;">
	      <div class="carousel-caption">
	        <h4>Slide {{$index}}</h4>
	        <p>{{slide.text}}</p>
	      </div>
	    </slide>
	  </carousel>
	  Interval, in milliseconds: <input type="number" ng-model="myInterval">
	  <br />Enter a negative number to stop the interval.
	</div>
	  </file>
	  <file name="script.js">
	function CarouselDemoCtrl($scope) {
	  $scope.myInterval = 5000;
	}
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	*/
	
	.directive('slide', function() {
	  return {
	    require: '^carousel',
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    templateUrl: 'template/carousel/slide.html',
	    scope: {
	      active: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('dateParser', ['$locale', 'orderByFilter', function($locale, orderByFilter) {
	
	  this.parsers = {};
	
	  var formatCodeToRegex = {
	    'yyyy': {
	      regex: '\\d{4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'yy': {
	      regex: '\\d{2}',
	      apply: function(value) { this.year = +value + 2000; }
	    },
	    'y': {
	      regex: '\\d{1,4}',
	      apply: function(value) { this.year = +value; }
	    },
	    'MMMM': {
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
	    },
	    'MMM': {
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
	    },
	    'MM': {
	      regex: '0[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'M': {
	      regex: '[1-9]|1[0-2]',
	      apply: function(value) { this.month = value - 1; }
	    },
	    'dd': {
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'd': {
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function(value) { this.date = +value; }
	    },
	    'EEEE': {
	      regex: $locale.DATETIME_FORMATS.DAY.join('|')
	    },
	    'EEE': {
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
	    }
	  };
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    angular.forEach(formatCodeToRegex, function(data, code) {
	      var index = format.indexOf(code);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + code.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({ index: index, apply: data.apply });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.parse = function(input, format) {
	    if ( !angular.isString(input) || !format ) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ( !this.parsers[format] ) {
	      this.parsers[format] = createParser(format);
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex);
	
	    if ( results && results.length ) {
	      var fields = { year: 1900, month: 0, date: 1, hours: 0 }, dt;
	
	      for( var i = 1, n = results.length; i < n; i++ ) {
	        var mapper = map[i-1];
	        if ( mapper.apply ) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      if ( isValid(fields.year, fields.month, fields.date) ) {
	        dt = new Date( fields.year, fields.month, fields.date, fields.hours);
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if ( month === 1 && date > 28) {
	        return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	    }
	
	    if ( month === 3 || month === 5 || month === 8 || month === 10) {
	        return date < 31;
	    }
	
	    return true;
	  }
	}]);
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$position', ['$document', '$window', function ($document, $window) {
	
	    function getStyle(el, cssprop) {
	      if (el.currentStyle) { //IE
	        return el.currentStyle[cssprop];
	      } else if ($window.getComputedStyle) {
	        return $window.getComputedStyle(el)[cssprop];
	      }
	      // finally try and get inline style
	      return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	      return (getStyle(element, 'position') || 'static' ) === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param element
	     */
	    var parentOffsetEl = function (element) {
	      var docDomEl = $document[0];
	      var offsetParent = element.offsetParent || docDomEl;
	      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docDomEl;
	    };
	
	    return {
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/
	       */
	      position: function (element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl != $document[0]) {
	          offsetParentBCR = this.offset(angular.element(offsetParentEl));
	          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: elBCR.top - offsetParentBCR.top,
	          left: elBCR.left - offsetParentBCR.left
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/
	       */
	      offset: function (element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	        };
	      },
	
	      /**
	       * Provides coordinates for the targetEl in relation to hostEl
	       */
	      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {
	
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos,
	          targetElWidth,
	          targetElHeight,
	          targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	          center: function () {
	            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	          },
	          left: function () {
	            return hostElPos.left;
	          },
	          right: function () {
	            return hostElPos.left + hostElPos.width;
	          }
	        };
	
	        var shiftHeight = {
	          center: function () {
	            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	          },
	          top: function () {
	            return hostElPos.top;
	          },
	          bottom: function () {
	            return hostElPos.top + hostElPos.height;
	          }
	        };
	
	        switch (pos0) {
	          case 'right':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: shiftWidth[pos0]()
	            };
	            break;
	          case 'left':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: hostElPos.left - targetElWidth
	            };
	            break;
	          case 'bottom':
	            targetElPos = {
	              top: shiftHeight[pos0](),
	              left: shiftWidth[pos1]()
	            };
	            break;
	          default:
	            targetElPos = {
	              top: hostElPos.top - targetElHeight,
	              left: shiftWidth[pos1]()
	            };
	            break;
	        }
	
	        return targetElPos;
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
	
	.constant('datepickerConfig', {
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  datepickerMode: 'day',
	  minMode: 'day',
	  maxMode: 'year',
	  showWeeks: true,
	  startingDay: 0,
	  yearRange: 20,
	  minDate: null,
	  maxDate: null
	})
	
	.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', 'dateFilter', 'datepickerConfig', function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  // Configuration attributes
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	                   'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange'], function( key, index ) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  // Watchable date attributes
	  angular.forEach(['minDate', 'maxDate'], function( key ) {
	    if ( $attrs[key] ) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	  this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function( ngModelCtrl_ ) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if ( ngModelCtrl.$modelValue ) {
	      var date = new Date( ngModelCtrl.$modelValue ),
	          isValid = !isNaN(date);
	
	      if ( isValid ) {
	        this.activeDate = date;
	      } else {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	      ngModelCtrl.$setValidity('date', isValid);
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if ( this.element ) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
	      ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0
	    };
	  };
	
	  this.isDisabled = function( date ) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function( date ) {
	    if ( $scope.datepickerMode === self.minMode ) {
	      var dt = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
	      ngModelCtrl.$setViewValue( dt );
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) - 1 ];
	    }
	  };
	
	  $scope.move = function( direction ) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function( direction ) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) + direction ];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13:'enter', 32:'space', 33:'pageup', 34:'pagedown', 35:'end', 36:'home', 37:'left', 38:'up', 39:'right', 40:'down' };
	
	  var focusElement = function() {
	    $timeout(function() {
	      self.element[0].focus();
	    }, 0 , false);
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('datepicker.focus', focusElement);
	
	  $scope.keydown = function( evt ) {
	    var key = $scope.keys[evt.which];
	
	    if ( !key || evt.shiftKey || evt.altKey ) {
	      return;
	    }
	
	    evt.preventDefault();
	    evt.stopPropagation();
	
	    if (key === 'enter' || key === 'space') {
	      if ( self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	      focusElement();
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	      focusElement();
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.directive( 'datepicker', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/datepicker.html',
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&'
	    },
	    require: ['datepicker', '?^ngModel'],
	    controller: 'DatepickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        datepickerCtrl.init( ngModelCtrl );
	      }
	    }
	  };
	})
	
	.directive('daypicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/day.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      scope.showWeeks = ctrl.showWeeks;
	
	      ctrl.step = { months: 1 };
	      ctrl.element = element;
	
	      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	      function getDaysInMonth( year, month ) {
	        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	      }
	
	      function getDates(startDate, n) {
	        var dates = new Array(n), current = new Date(startDate), i = 0;
	        current.setHours(12); // Prevent repeated dates because of timezone bug
	        while ( i < n ) {
	          dates[i++] = new Date(current);
	          current.setDate( current.getDate() + 1 );
	        }
	        return dates;
	      }
	
	      ctrl._refreshView = function() {
	        var year = ctrl.activeDate.getFullYear(),
	          month = ctrl.activeDate.getMonth(),
	          firstDayOfMonth = new Date(year, month, 1),
	          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
	          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
	          firstDate = new Date(firstDayOfMonth);
	
	        if ( numDisplayedFromPreviousMonth > 0 ) {
	          firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
	        }
	
	        // 42 is the number of days on a six-month calendar
	        var days = getDates(firstDate, 42);
	        for (var i = 0; i < 42; i ++) {
	          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
	            secondary: days[i].getMonth() !== month,
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.labels = new Array(7);
	        for (var j = 0; j < 7; j++) {
	          scope.labels[j] = {
	            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
	            full: dateFilter(days[j].date, 'EEEE')
	          };
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
	        scope.rows = ctrl.split(days, 7);
	
	        if ( scope.showWeeks ) {
	          scope.weekNumbers = [];
	          var weekNumber = getISO8601WeekNumber( scope.rows[0][0].date ),
	              numWeeks = scope.rows.length;
	          while( scope.weekNumbers.push(weekNumber++) < numWeeks ) {}
	        }
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return (new Date( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - new Date( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
	      };
	
	      function getISO8601WeekNumber(date) {
	        var checkDate = new Date(date);
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	        var time = checkDate.getTime();
	        checkDate.setMonth(0); // Compare with Jan 1
	        checkDate.setDate(1);
	        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	      }
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getDate();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 7;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 7;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setMonth(month, 1);
	          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
	        } else if (key === 'home') {
	          date = 1;
	        } else if (key === 'end') {
	          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
	        }
	        ctrl.activeDate.setDate(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('monthpicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/month.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      ctrl.step = { years: 1 };
	      ctrl.element = element;
	
	      ctrl._refreshView = function() {
	        var months = new Array(12),
	            year = ctrl.activeDate.getFullYear();
	
	        for ( var i = 0; i < 12; i++ ) {
	          months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
	        scope.rows = ctrl.split(months, 3);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return new Date( date1.getFullYear(), date1.getMonth() ) - new Date( date2.getFullYear(), date2.getMonth() );
	      };
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getMonth();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 3;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 3;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	          ctrl.activeDate.setFullYear(year);
	        } else if (key === 'home') {
	          date = 0;
	        } else if (key === 'end') {
	          date = 11;
	        }
	        ctrl.activeDate.setMonth(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('yearpicker', ['dateFilter', function (dateFilter) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/datepicker/year.html',
	    require: '^datepicker',
	    link: function(scope, element, attrs, ctrl) {
	      var range = ctrl.yearRange;
	
	      ctrl.step = { years: range };
	      ctrl.element = element;
	
	      function getStartingYear( year ) {
	        return parseInt((year - 1) / range, 10) * range + 1;
	      }
	
	      ctrl._refreshView = function() {
	        var years = new Array(range);
	
	        for ( var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++ ) {
	          years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
	            uid: scope.uniqueId + '-' + i
	          });
	        }
	
	        scope.title = [years[0].label, years[range - 1].label].join(' - ');
	        scope.rows = ctrl.split(years, 5);
	      };
	
	      ctrl.compare = function(date1, date2) {
	        return date1.getFullYear() - date2.getFullYear();
	      };
	
	      ctrl.handleKeyDown = function( key, evt ) {
	        var date = ctrl.activeDate.getFullYear();
	
	        if (key === 'left') {
	          date = date - 1;   // up
	        } else if (key === 'up') {
	          date = date - 5;   // down
	        } else if (key === 'right') {
	          date = date + 1;   // down
	        } else if (key === 'down') {
	          date = date + 5;
	        } else if (key === 'pageup' || key === 'pagedown') {
	          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
	        } else if (key === 'home') {
	          date = getStartingYear( ctrl.activeDate.getFullYear() );
	        } else if (key === 'end') {
	          date = getStartingYear( ctrl.activeDate.getFullYear() ) + range - 1;
	        }
	        ctrl.activeDate.setFullYear(date);
	      };
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.constant('datepickerPopupConfig', {
	  datepickerPopup: 'yyyy-MM-dd',
	  currentText: 'Today',
	  clearText: 'Clear',
	  closeText: 'Done',
	  closeOnDateSelection: true,
	  appendToBody: false,
	  showButtonBar: true
	})
	
	.directive('datepickerPopup', ['$compile', '$parse', '$document', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig',
	function ($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig) {
	  return {
	    restrict: 'EA',
	    require: 'ngModel',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&'
	    },
	    link: function(scope, element, attrs, ngModel) {
	      var dateFormat,
	          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
	          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	
	      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	      scope.getText = function( key ) {
	        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	      };
	
	      attrs.$observe('datepickerPopup', function(value) {
	          dateFormat = value || datepickerPopupConfig.datepickerPopup;
	          ngModel.$render();
	      });
	
	      // popup element used to display calendar
	      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
	      popupEl.attr({
	        'ng-model': 'date',
	        'ng-change': 'dateSelection()'
	      });
	
	      function cameltoDash( string ){
	        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	      }
	
	      // datepicker element
	      var datepickerEl = angular.element(popupEl.children()[0]);
	      if ( attrs.datepickerOptions ) {
	        angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function( value, option ) {
	          datepickerEl.attr( cameltoDash(option), value );
	        });
	      }
	
	      scope.watchData = {};
	      angular.forEach(['minDate', 'maxDate', 'datepickerMode'], function( key ) {
	        if ( attrs[key] ) {
	          var getAttribute = $parse(attrs[key]);
	          scope.$parent.$watch(getAttribute, function(value){
	            scope.watchData[key] = value;
	          });
	          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	          // Propagate changes from datepicker to outside
	          if ( key === 'datepickerMode' ) {
	            var setAttribute = getAttribute.assign;
	            scope.$watch('watchData.' + key, function(value, oldvalue) {
	              if ( value !== oldvalue ) {
	                setAttribute(scope.$parent, value);
	              }
	            });
	          }
	        }
	      });
	      if (attrs.dateDisabled) {
	        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	      }
	
	      function parseDate(viewValue) {
	        if (!viewValue) {
	          ngModel.$setValidity('date', true);
	          return null;
	        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	          ngModel.$setValidity('date', true);
	          return viewValue;
	        } else if (angular.isString(viewValue)) {
	          var date = dateParser.parse(viewValue, dateFormat) || new Date(viewValue);
	          if (isNaN(date)) {
	            ngModel.$setValidity('date', false);
	            return undefined;
	          } else {
	            ngModel.$setValidity('date', true);
	            return date;
	          }
	        } else {
	          ngModel.$setValidity('date', false);
	          return undefined;
	        }
	      }
	      ngModel.$parsers.unshift(parseDate);
	
	      // Inner change
	      scope.dateSelection = function(dt) {
	        if (angular.isDefined(dt)) {
	          scope.date = dt;
	        }
	        ngModel.$setViewValue(scope.date);
	        ngModel.$render();
	
	        if ( closeOnDateSelection ) {
	          scope.isOpen = false;
	          element[0].focus();
	        }
	      };
	
	      element.bind('input change keyup', function() {
	        scope.$apply(function() {
	          scope.date = ngModel.$modelValue;
	        });
	      });
	
	      // Outter change
	      ngModel.$render = function() {
	        var date = ngModel.$viewValue ? dateFilter(ngModel.$viewValue, dateFormat) : '';
	        element.val(date);
	        scope.date = parseDate( ngModel.$modelValue );
	      };
	
	      var documentClickBind = function(event) {
	        if (scope.isOpen && event.target !== element[0]) {
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	        }
	      };
	
	      var keydown = function(evt, noApply) {
	        scope.keydown(evt);
	      };
	      element.bind('keydown', keydown);
	
	      scope.keydown = function(evt) {
	        if (evt.which === 27) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          scope.close();
	        } else if (evt.which === 40 && !scope.isOpen) {
	          scope.isOpen = true;
	        }
	      };
	
	      scope.$watch('isOpen', function(value) {
	        if (value) {
	          scope.$broadcast('datepicker.focus');
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	          $document.bind('click', documentClickBind);
	        } else {
	          $document.unbind('click', documentClickBind);
	        }
	      });
	
	      scope.select = function( date ) {
	        if (date === 'today') {
	          var today = new Date();
	          if (angular.isDate(ngModel.$modelValue)) {
	            date = new Date(ngModel.$modelValue);
	            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	          } else {
	            date = new Date(today.setHours(0, 0, 0, 0));
	          }
	        }
	        scope.dateSelection( date );
	      };
	
	      scope.close = function() {
	        scope.isOpen = false;
	        element[0].focus();
	      };
	
	      var $popup = $compile(popupEl)(scope);
	      // Prevent jQuery cache memory leak (template is now redundant after linking)
	      popupEl.remove();
	
	      if ( appendToBody ) {
	        $document.find('body').append($popup);
	      } else {
	        element.after($popup);
	      }
	
	      scope.$on('$destroy', function() {
	        $popup.remove();
	        element.unbind('keydown', keydown);
	        $document.unbind('click', documentClickBind);
	      });
	    }
	  };
	}])
	
	.directive('datepickerPopupWrap', function() {
	  return {
	    restrict:'EA',
	    replace: true,
	    transclude: true,
	    templateUrl: 'template/datepicker/popup.html',
	    link:function (scope, element, attrs) {
	      element.bind('click', function(event) {
	        event.preventDefault();
	        event.stopPropagation();
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.dropdown', [])
	
	.constant('dropdownConfig', {
	  openClass: 'open'
	})
	
	.service('dropdownService', ['$document', function($document) {
	  var openScope = null;
	
	  this.open = function( dropdownScope ) {
	    if ( !openScope ) {
	      $document.bind('click', closeDropdown);
	      $document.bind('keydown', escapeKeyBind);
	    }
	
	    if ( openScope && openScope !== dropdownScope ) {
	        openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function( dropdownScope ) {
	    if ( openScope === dropdownScope ) {
	      openScope = null;
	      $document.unbind('click', closeDropdown);
	      $document.unbind('keydown', escapeKeyBind);
	    }
	  };
	
	  var closeDropdown = function( evt ) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if ( evt && toggleElement && toggleElement[0].contains(evt.target) ) {
	        return;
	    }
	
	    openScope.$apply(function() {
	      openScope.isOpen = false;
	    });
	  };
	
	  var escapeKeyBind = function( evt ) {
	    if ( evt.which === 27 ) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    }
	  };
	}])
	
	.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate) {
	  var self = this,
	      scope = $scope.$new(), // create a child scope so we are not polluting original one
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;
	
	  this.init = function( element ) {
	    self.$element = element;
	
	    if ( $attrs.isOpen ) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	  };
	
	  this.toggle = function( open ) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.focusToggleElement = function() {
	    if ( self.toggleElement ) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function( isOpen, wasOpen ) {
	    $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);
	
	    if ( isOpen ) {
	      scope.focusToggleElement();
	      dropdownService.open( scope );
	    } else {
	      dropdownService.close( scope );
	    }
	
	    setIsOpen($scope, isOpen);
	    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	      toggleInvoker($scope, { open: !!isOpen });
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    scope.isOpen = false;
	  });
	
	  $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	}])
	
	.directive('dropdown', function() {
	  return {
	    controller: 'DropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init( element );
	    }
	  };
	})
	
	.directive('dropdownToggle', function() {
	  return {
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if ( !dropdownCtrl ) {
	        return;
	      }
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if ( !element.hasClass('disabled') && !attrs.disabled ) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.transition'])
	
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function () {
	    return {
	      createNew: function () {
	        var stack = [];
	
	        return {
	          add: function (key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function (key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function () {
	            return stack[stack.length - 1];
	          },
	          remove: function (key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function () {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function () {
	            return stack.length;
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('modalBackdrop', ['$timeout', function ($timeout) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      templateUrl: 'template/modal/backdrop.html',
	      link: function (scope, element, attrs) {
	        scope.backdropClass = attrs.backdropClass || '';
	
	        scope.animate = false;
	
	        //trigger CSS transitions
	        $timeout(function () {
	          scope.animate = true;
	        });
	      }
	    };
	  }])
	
	  .directive('modalWindow', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '@',
	        animate: '='
	      },
	      replace: true,
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'template/modal/window.html';
	      },
	      link: function (scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        scope.size = attrs.size;
	
	        $timeout(function () {
	          // trigger CSS transitions
	          scope.animate = true;
	
	          /**
	           * Auto-focusing of a freshly-opened modal element causes any child elements
	           * with the autofocus attribute to lose focus. This is an issue on touch
	           * based devices which will show and then hide the onscreen keyboard.
	           * Attempts to refocus the autofocus element via JavaScript will not reopen
	           * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	           * the modal element if the modal does not contain an autofocus element.
	           */
	          if (!element[0].querySelectorAll('[autofocus]').length) {
	            element[0].focus();
	          }
	        });
	
	        scope.close = function (evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop && modal.value.backdrop != 'static' && (evt.target === evt.currentTarget)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('modalTransclude', function () {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  })
	
	  .factory('$modalStack', ['$transition', '$timeout', '$document', '$compile', '$rootScope', '$$stackedMap',
	    function ($transition, $timeout, $document, $compile, $rootScope, $$stackedMap) {
	
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var $modalStack = {};
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex){
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance) {
	
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	
	        //remove window DOM element
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function() {
	          modalWindow.modalScope.$destroy();
	          body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
	          checkRemoveBackdrop();
	        });
	      }
	
	      function checkRemoveBackdrop() {
	          //remove backdrop if no longer needed
	          if (backdropDomEl && backdropIndex() == -1) {
	            var backdropScopeRef = backdropScope;
	            removeAfterAnimate(backdropDomEl, backdropScope, 150, function () {
	              backdropScopeRef.$destroy();
	              backdropScopeRef = null;
	            });
	            backdropDomEl = undefined;
	            backdropScope = undefined;
	          }
	      }
	
	      function removeAfterAnimate(domEl, scope, emulateTime, done) {
	        // Closing animation
	        scope.animate = false;
	
	        var transitionEndEventName = $transition.transitionEndEventName;
	        if (transitionEndEventName) {
	          // transition out
	          var timeout = $timeout(afterAnimating, emulateTime);
	
	          domEl.bind(transitionEndEventName, function () {
	            $timeout.cancel(timeout);
	            afterAnimating();
	            scope.$apply();
	          });
	        } else {
	          // Ensure this call is async
	          $timeout(afterAnimating);
	        }
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          domEl.remove();
	          if (done) {
	            done();
	          }
	        }
	      }
	
	      $document.bind('keydown', function (evt) {
	        var modal;
	
	        if (evt.which === 27) {
	          modal = openedWindows.top();
	          if (modal && modal.value.keyboard) {
	            evt.preventDefault();
	            $rootScope.$apply(function () {
	              $modalStack.dismiss(modal.key, 'escape key press');
	            });
	          }
	        }
	      });
	
	      $modalStack.open = function (modalInstance, modal) {
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard
	        });
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.index = currBackdropIndex;
	          var angularBackgroundDomEl = angular.element('<div modal-backdrop></div>');
	          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
	          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
	          body.append(backdropDomEl);
	        }
	
	        var angularDomEl = angular.element('<div modal-window></div>');
	        angularDomEl.attr({
	          'template-url': modal.windowTemplateUrl,
	          'window-class': modal.windowClass,
	          'size': modal.size,
	          'index': openedWindows.length() - 1,
	          'animate': 'animate'
	        }).html(modal.content);
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	        body.append(modalDomEl);
	        body.addClass(OPENED_MODAL_CLASS);
	      };
	
	      $modalStack.close = function (modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance);
	        }
	      };
	
	      $modalStack.dismiss = function (modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance);
	        }
	      };
	
	      $modalStack.dismissAll = function (reason) {
	        var topModal = this.getTop();
	        while (topModal) {
	          this.dismiss(topModal.key, reason);
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function () {
	        return openedWindows.top();
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$modal', function () {
	
	    var $modalProvider = {
	      options: {
	        backdrop: true, //can be also false or 'static'
	        keyboard: true
	      },
	      $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack',
	        function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {
	
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $http.get(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl,
	                {cache: $templateCache}).then(function (result) {
	                  return result.data;
	              });
	          }
	
	          function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function (value) {
	              if (angular.isFunction(value) || angular.isArray(value)) {
	                promisesArr.push($q.when($injector.invoke(value)));
	              }
	            });
	            return promisesArr;
	          }
	
	          $modal.open = function (modalOptions) {
	
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              close: function (result) {
	                $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            //verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise =
	              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	
	            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {
	
	              var modalScope = (modalOptions.scope || $rootScope).$new();
	              modalScope.$close = modalInstance.close;
	              modalScope.$dismiss = modalInstance.dismiss;
	
	              var ctrlInstance, ctrlLocals = {};
	              var resolveIter = 1;
	
	              //controllers
	              if (modalOptions.controller) {
	                ctrlLocals.$scope = modalScope;
	                ctrlLocals.$modalInstance = modalInstance;
	                angular.forEach(modalOptions.resolve, function (value, key) {
	                  ctrlLocals[key] = tplAndVars[resolveIter++];
	                });
	
	                ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                if (modalOptions.controllerAs) {
	                  modalScope[modalOptions.controllerAs] = ctrlInstance;
	                }
	              }
	
	              $modalStack.open(modalInstance, {
	                scope: modalScope,
	                deferred: modalResultDeferred,
	                content: tplAndVars[0],
	                backdrop: modalOptions.backdrop,
	                keyboard: modalOptions.keyboard,
	                backdropClass: modalOptions.backdropClass,
	                windowClass: modalOptions.windowClass,
	                windowTemplateUrl: modalOptions.windowTemplateUrl,
	                size: modalOptions.size
	              });
	
	            }, function resolveError(reason) {
	              modalResultDeferred.reject(reason);
	            });
	
	            templateAndResolvePromise.then(function () {
	              modalOpenedDeferred.resolve(true);
	            }, function () {
	              modalOpenedDeferred.reject(false);
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.pagination', [])
	
	.controller('PaginationController', ['$scope', '$attrs', '$parse', function ($scope, $attrs, $parse) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page) {
	    if ( $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function( key ) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	
	  $scope.$watch('totalItems', function() {
	    $scope.totalPages = self.calculateTotalPages();
	  });
	
	  $scope.$watch('totalPages', function(value) {
	    setNumPages($scope.$parent, value); // Readonly variable
	
	    if ( $scope.page > value ) {
	      $scope.selectPage(value);
	    } else {
	      ngModelCtrl.$render();
	    }
	  });
	}])
	
	.constant('paginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true
	})
	
	.directive('pagination', ['$parse', 'paginationConfig', function($parse, paginationConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@'
	    },
	    require: ['pagination', '?ngModel'],
	    controller: 'PaginationController',
	    templateUrl: 'template/pagination/pagination.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = ( angular.isDefined(maxSize) && maxSize < totalPages );
	
	        // recompute if maxSize
	        if ( isMaxSized ) {
	          if ( rotate ) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if ( isMaxSized && ! rotate ) {
	          if ( startPage > 1 ) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if ( endPage < totalPages ) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.constant('pagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('pager', ['pagerConfig', function(pagerConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@'
	    },
	    require: ['pager', '?ngModel'],
	    controller: 'PaginationController',
	    templateUrl: 'template/pagination/pager.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module( 'ui.bootstrap.tooltip', [ 'ui.bootstrap.position', 'ui.bootstrap.bindHtml' ] )
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider( '$tooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    animation: true,
	    popupDelay: 0
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'focus': 'blur'
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function( value ) {
			angular.extend( globalOptions, value );
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers ( triggers ) {
	    angular.extend( triggerMap, triggers );
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake-case.
	   */
	  function snake_case(name){
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = [ '$window', '$compile', '$timeout', '$document', '$position', '$interpolate', function ( $window, $compile, $timeout, $document, $position, $interpolate ) {
	    return function $tooltip ( type, prefix, defaultTriggerShow ) {
	      var options = angular.extend( {}, defaultOptions, globalOptions );
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers ( trigger ) {
	        var show = trigger || options.trigger || defaultTriggerShow;
	        var hide = triggerMap[show] || show;
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case( type );
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName +'-popup '+
	          'title="'+startSym+'title'+endSym+'" '+
	          'content="'+startSym+'content'+endSym+'" '+
	          'placement="'+startSym+'placement'+endSym+'" '+
	          'animation="animation" '+
	          'is-open="isOpen"'+
	          '>'+
	        '</div>';
	
	      return {
	        restrict: 'EA',
	        compile: function (tElem, tAttrs) {
	          var tooltipLinker = $compile( template );
	
	          return function link ( scope, element, attrs ) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var popupTimeout;
	            var appendToBody = angular.isDefined( options.appendToBody ) ? options.appendToBody : false;
	            var triggers = getTriggers( undefined );
	            var hasEnableExp = angular.isDefined(attrs[prefix+'Enable']);
	            var ttScope = scope.$new(true);
	
	            var positionTooltip = function () {
	
	              var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	              ttPosition.top += 'px';
	              ttPosition.left += 'px';
	
	              // Now set the calculated positioning.
	              tooltip.css( ttPosition );
	            };
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind () {
	              if ( ! ttScope.isOpen ) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if(hasEnableExp && !scope.$eval(attrs[prefix+'Enable'])) {
	                return;
	              }
	
	              prepareTooltip();
	
	              if ( ttScope.popupDelay ) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!popupTimeout) {
	                  popupTimeout = $timeout( show, ttScope.popupDelay, false );
	                  popupTimeout.then(function(reposition){reposition();});
	                }
	              } else {
	                show()();
	              }
	            }
	
	            function hideTooltipBind () {
	              scope.$apply(function () {
	                hide();
	              });
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	
	              popupTimeout = null;
	
	              // If there is a pending remove transition, we must cancel it, lest the
	              // tooltip be mysteriously removed.
	              if ( transitionTimeout ) {
	                $timeout.cancel( transitionTimeout );
	                transitionTimeout = null;
	              }
	
	              // Don't show empty tooltips.
	              if ( ! ttScope.content ) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // Set the initial positioning.
	              tooltip.css({ top: 0, left: 0, display: 'block' });
	              ttScope.$digest();
	
	              positionTooltip();
	
	              // And show the tooltip.
	              ttScope.isOpen = true;
	              ttScope.$digest(); // digest required as $apply is not called
	
	              // Return positioning function as promise callback for correct
	              // positioning after draw.
	              return positionTooltip;
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              // First things first: we don't show it anymore.
	              ttScope.isOpen = false;
	
	              //if tooltip is going to be shown after delay, we must cancel this
	              $timeout.cancel( popupTimeout );
	              popupTimeout = null;
	
	              // And now we remove it from the DOM. However, if we have animation, we
	              // need to wait for it to expire beforehand.
	              // FIXME: this is a placeholder for a port of the transitions library.
	              if ( ttScope.animation ) {
	                if (!transitionTimeout) {
	                  transitionTimeout = $timeout(removeTooltip, 500);
	                }
	              } else {
	                removeTooltip();
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                removeTooltip();
	              }
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if ( appendToBody ) {
	                  $document.find( 'body' ).append( tooltip );
	                } else {
	                  element.after( tooltip );
	                }
	              });
	            }
	
	            function removeTooltip() {
	              transitionTimeout = null;
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            function prepareTooltip() {
	              prepPlacement();
	              prepPopupDelay();
	            }
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe( type, function ( val ) {
	              ttScope.content = val;
	
	              if (!val && ttScope.isOpen ) {
	                hide();
	              }
	            });
	
	            attrs.$observe( prefix+'Title', function ( val ) {
	              ttScope.title = val;
	            });
	
	            function prepPlacement() {
	              var val = attrs[ prefix + 'Placement' ];
	              ttScope.placement = angular.isDefined( val ) ? val : options.placement;
	            }
	
	            function prepPopupDelay() {
	              var val = attrs[ prefix + 'PopupDelay' ];
	              var delay = parseInt( val, 10 );
	              ttScope.popupDelay = ! isNaN(delay) ? delay : options.popupDelay;
	            }
	
	            var unregisterTriggers = function () {
	              element.unbind(triggers.show, showTooltipBind);
	              element.unbind(triggers.hide, hideTooltipBind);
	            };
	
	            function prepTriggers() {
	              var val = attrs[ prefix + 'Trigger' ];
	              unregisterTriggers();
	
	              triggers = getTriggers( val );
	
	              if ( triggers.show === triggers.hide ) {
	                element.bind( triggers.show, toggleTooltipBind );
	              } else {
	                element.bind( triggers.show, showTooltipBind );
	                element.bind( triggers.hide, hideTooltipBind );
	              }
	            }
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // if a tooltip is attached to <body> we need to remove it on
	            // location change as its parent scope will probably not be destroyed
	            // by the change.
	            if ( appendToBody ) {
	              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess () {
	              if ( ttScope.isOpen ) {
	                hide();
	              }
	            });
	            }
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              $timeout.cancel( transitionTimeout );
	              $timeout.cancel( popupTimeout );
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	.directive( 'tooltipPopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive( 'tooltip', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'tooltip', 'tooltip', 'mouseenter' );
	}])
	
	.directive( 'tooltipHtmlUnsafePopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
	  };
	})
	
	.directive( 'tooltipHtmlUnsafe', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'tooltipHtmlUnsafe', 'tooltip', 'mouseenter' );
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html popovers, and selector delegatation.
	 */
	angular.module( 'ui.bootstrap.popover', [ 'ui.bootstrap.tooltip' ] )
	
	.directive( 'popoverPopup', function () {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html'
	  };
	})
	
	.directive( 'popover', [ '$tooltip', function ( $tooltip ) {
	  return $tooltip( 'popover', 'popover', 'click' );
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('progressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {
	    var self = this,
	        animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	    this.bars = [];
	    $scope.max = angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : progressConfig.max;
	
	    this.addBar = function(bar, element) {
	        if ( !animate ) {
	            element.css({'transition': 'none'});
	        }
	
	        this.bars.push(bar);
	
	        bar.$watch('value', function( value ) {
	            bar.percent = +(100 * value / $scope.max).toFixed(2);
	        });
	
	        bar.$on('$destroy', function() {
	            element = null;
	            self.removeBar(bar);
	        });
	    };
	
	    this.removeBar = function(bar) {
	        this.bars.splice(this.bars.indexOf(bar), 1);
	    };
	}])
	
	.directive('progress', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        controller: 'ProgressController',
	        require: 'progress',
	        scope: {},
	        templateUrl: 'template/progressbar/progress.html'
	    };
	})
	
	.directive('bar', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        require: '^progress',
	        scope: {
	            value: '=',
	            type: '@'
	        },
	        templateUrl: 'template/progressbar/bar.html',
	        link: function(scope, element, attrs, progressCtrl) {
	            progressCtrl.addBar(scope, element);
	        }
	    };
	})
	
	.directive('progressbar', function() {
	    return {
	        restrict: 'EA',
	        replace: true,
	        transclude: true,
	        controller: 'ProgressController',
	        scope: {
	            value: '=',
	            type: '@'
	        },
	        templateUrl: 'template/progressbar/progressbar.html',
	        link: function(scope, element, attrs, progressCtrl) {
	            progressCtrl.addBar(scope, angular.element(element.children()[0]));
	        }
	    };
	});
	angular.module('ui.bootstrap.rating', [])
	
	.constant('ratingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null
	})
	
	.controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl  = { $setViewValue: angular.noop };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) :
	                        new Array( angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max );
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff }, states[i]);
	    }
	    return states;
	  };
	
	  $scope.rate = function(value) {
	    if ( !$scope.readonly && value >= 0 && value <= $scope.range.length ) {
	      ngModelCtrl.$setViewValue(value);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if ( !$scope.readonly ) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate( $scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1) );
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	  };
	}])
	
	.directive('rating', function() {
	  return {
	    restrict: 'EA',
	    require: ['rating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'RatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        ratingCtrl.init( ngModelCtrl );
	      }
	    }
	  };
	});
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.tabs
	 *
	 * @description
	 * AngularJS version of the tabs directive.
	 */
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
	  var ctrl = this,
	      tabs = ctrl.tabs = $scope.tabs = [];
	
	  ctrl.select = function(selectedTab) {
	    angular.forEach(tabs, function(tab) {
	      if (tab.active && tab !== selectedTab) {
	        tab.active = false;
	        tab.onDeselect();
	      }
	    });
	    selectedTab.active = true;
	    selectedTab.onSelect();
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    tabs.push(tab);
	    // we can't run the select function on the first tab
	    // since that would select it twice
	    if (tabs.length === 1) {
	      tab.active = true;
	    } else if (tab.active) {
	      ctrl.select(tab);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = tabs.indexOf(tab);
	    //Select a new tab if the tab to be removed is selected and not destroyed
	    if (tab.active && tabs.length > 1 && !destroyed) {
	      //If this is the last tab, select the previous tab. else, the next tab.
	      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
	      ctrl.select(tabs[newActiveIndex]);
	    }
	    tabs.splice(index, 1);
	  };
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabset
	 * @restrict EA
	 *
	 * @description
	 * Tabset is the outer container for the tabs directive
	 *
	 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab heading="Tab 1"><b>First</b> Content!</tab>
	      <tab heading="Tab 2"><i>Second</i> Content!</tab>
	    </tabset>
	    <hr />
	    <tabset vertical="true">
	      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
	      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
	    </tabset>
	    <tabset justified="true">
	      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
	      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tabset', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    controller: 'TabsetController',
	    templateUrl: 'template/tabs/tabset.html',
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tab
	 * @restrict EA
	 *
	 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	 * @param {string=} select An expression to evaluate when the tab is selected.
	 * @param {boolean=} active A binding, telling whether or not this tab is selected.
	 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	 *
	 * @description
	 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <div ng-controller="TabsDemoCtrl">
	      <button class="btn btn-small" ng-click="items[0].active = true">
	        Select item 1, using active binding
	      </button>
	      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	        Enable/disable item 2, using disabled binding
	      </button>
	      <br />
	      <tabset>
	        <tab heading="Tab 1">First Tab</tab>
	        <tab select="alertMe()">
	          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	          Second Tab, with alert callback and html heading!
	        </tab>
	        <tab ng-repeat="item in items"
	          heading="{{item.title}}"
	          disabled="item.disabled"
	          active="item.active">
	          {{item.content}}
	        </tab>
	      </tabset>
	    </div>
	  </file>
	  <file name="script.js">
	    function TabsDemoCtrl($scope) {
	      $scope.items = [
	        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	      ];
	
	      $scope.alertMe = function() {
	        setTimeout(function() {
	          alert("You've selected the alert tab!");
	        });
	      };
	    };
	  </file>
	</example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabHeading
	 * @restrict EA
	 *
	 * @description
	 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <tabset>
	      <tab>
	        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
	        And some content, too!
	      </tab>
	      <tab>
	        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	        That's right.
	      </tab>
	    </tabset>
	  </file>
	</example>
	 */
	.directive('tab', ['$parse', function($parse) {
	  return {
	    require: '^tabset',
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/tabs/tab.html',
	    transclude: true,
	    scope: {
	      active: '=?',
	      heading: '@',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    compile: function(elm, attrs, transclude) {
	      return function postLink(scope, elm, attrs, tabsetCtrl) {
	        scope.$watch('active', function(active) {
	          if (active) {
	            tabsetCtrl.select(scope);
	          }
	        });
	
	        scope.disabled = false;
	        if ( attrs.disabled ) {
	          scope.$parent.$watch($parse(attrs.disabled), function(value) {
	            scope.disabled = !! value;
	          });
	        }
	
	        scope.select = function() {
	          if ( !scope.disabled ) {
	            scope.active = true;
	          }
	        };
	
	        tabsetCtrl.addTab(scope);
	        scope.$on('$destroy', function() {
	          tabsetCtrl.removeTab(scope);
	        });
	
	        //We need to transclude later, once the content container is ready.
	        //when this link happens, we're inside a tab heading.
	        scope.$transcludeFn = transclude;
	      };
	    }
	  };
	}])
	
	.directive('tabHeadingTransclude', [function() {
	  return {
	    restrict: 'A',
	    require: '^tab',
	    link: function(scope, elm, attrs, tabCtrl) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}])
	
	.directive('tabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^tabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.tabContentTransclude);
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	  function isTabHeading(node) {
	    return node.tagName &&  (
	      node.hasAttribute('tab-heading') ||
	      node.hasAttribute('data-tab-heading') ||
	      node.tagName.toLowerCase() === 'tab-heading' ||
	      node.tagName.toLowerCase() === 'data-tab-heading'
	    );
	  }
	})
	
	;
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('timepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  showMeridian: true,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true
	})
	
	.controller('TimepickerController', ['$scope', '$attrs', '$parse', '$log', '$locale', 'timepickerConfig', function($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
	
	  this.init = function( ngModelCtrl_, inputs ) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	    if ( mousewheel ) {
	      this.setupMousewheelEvents( hoursInputEl, minutesInputEl );
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents( hoursInputEl, minutesInputEl );
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = parseInt(value, 10);
	    });
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = parseInt(value, 10);
	    });
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if ( ngModelCtrl.$error.time ) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined( hours ) && angular.isDefined( minutes )) {
	          selected.setHours( hours );
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    });
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate ( ) {
	    var hours = parseInt( $scope.hours, 10 );
	    var valid = ( $scope.showMeridian ) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
	    if ( !valid ) {
	      return undefined;
	    }
	
	    if ( $scope.showMeridian ) {
	      if ( hours === 12 ) {
	        hours = 0;
	      }
	      if ( $scope.meridian === meridians[1] ) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = parseInt($scope.minutes, 10);
	    return ( minutes >= 0 && minutes < 60 ) ? minutes : undefined;
	  }
	
	  function pad( value ) {
	    return ( angular.isDefined(value) && value.toString().length < 2 ) ? '0' + value : value;
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function( hoursInputEl, minutesInputEl ) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
	      return (e.detail || delta > 0);
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply( (isScrollingUp(e)) ? $scope.incrementHours() : $scope.decrementHours() );
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply( (isScrollingUp(e)) ? $scope.incrementMinutes() : $scope.decrementMinutes() );
	      e.preventDefault();
	    });
	
	  };
	
	  this.setupInputEvents = function( hoursInputEl, minutesInputEl ) {
	    if ( $scope.readonlyInput ) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes) {
	      ngModelCtrl.$setViewValue( null );
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate();
	
	      if ( angular.isDefined(hours) ) {
	        selected.setHours( hours );
	        refresh( 'h' );
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function(e) {
	      if ( !$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply( function() {
	          $scope.hours = pad( $scope.hours );
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate();
	
	      if ( angular.isDefined(minutes) ) {
	        selected.setMinutes( minutes );
	        refresh( 'm' );
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function(e) {
	      if ( !$scope.invalidMinutes && $scope.minutes < 10 ) {
	        $scope.$apply( function() {
	          $scope.minutes = pad( $scope.minutes );
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : null;
	
	    if ( isNaN(date) ) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if ( date ) {
	        selected = date;
	      }
	      makeValid();
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh( keyboardChange ) {
	    makeValid();
	    ngModelCtrl.$setViewValue( new Date(selected) );
	    updateTemplate( keyboardChange );
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	  }
	
	  function updateTemplate( keyboardChange ) {
	    var hours = selected.getHours(), minutes = selected.getMinutes();
	
	    if ( $scope.showMeridian ) {
	      hours = ( hours === 0 || hours === 12 ) ? 12 : hours % 12; // Convert 24 to 12 hour system
	    }
	
	    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	    $scope.minutes = keyboardChange === 'm' ? minutes : pad(minutes);
	    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	  }
	
	  function addMinutes( minutes ) {
	    var dt = new Date( selected.getTime() + minutes * 60000 );
	    selected.setHours( dt.getHours(), dt.getMinutes() );
	    refresh();
	  }
	
	  $scope.incrementHours = function() {
	    addMinutes( hourStep * 60 );
	  };
	  $scope.decrementHours = function() {
	    addMinutes( - hourStep * 60 );
	  };
	  $scope.incrementMinutes = function() {
	    addMinutes( minuteStep );
	  };
	  $scope.decrementMinutes = function() {
	    addMinutes( - minuteStep );
	  };
	  $scope.toggleMeridian = function() {
	    addMinutes( 12 * 60 * (( selected.getHours() < 12 ) ? 1 : -1) );
	  };
	}])
	
	.directive('timepicker', function () {
	  return {
	    restrict: 'EA',
	    require: ['timepicker', '?^ngModel'],
	    controller:'TimepickerController',
	    replace: true,
	    scope: {},
	    templateUrl: 'template/timepicker/timepicker.html',
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if ( ngModelCtrl ) {
	        timepickerCtrl.init( ngModelCtrl, element.find('input') );
	      }
	    }
	  };
	});
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('typeaheadParser', ['$parse', function ($parse) {
	
	  //                      00000111000000000000022200000000000000003333333333333330000000000044000
	  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	
	  return {
	    parse:function (input) {
	
	      var match = input.match(TYPEAHEAD_REGEXP);
	      if (!match) {
	        throw new Error(
	          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	            ' but got "' + input + '".');
	      }
	
	      return {
	        itemName:match[3],
	        source:$parse(match[4]),
	        viewMapper:$parse(match[2] || match[1]),
	        modelMapper:$parse(match[1])
	      };
	    }
	  };
	}])
	
	  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$position', 'typeaheadParser',
	    function ($compile, $parse, $q, $timeout, $document, $position, typeaheadParser) {
	
	  var HOT_KEYS = [9, 13, 27, 38, 40];
	
	  return {
	    require:'ngModel',
	    link:function (originalScope, element, attrs, modelCtrl) {
	
	      //SUPPORTED ATTRIBUTES (OPTIONS)
	
	      //minimal no of characters that needs to be entered before typeahead kicks-in
	      var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;
	
	      //minimal wait time after last character typed before typehead kicks-in
	      var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	      //should it restrict model values to the ones selected from the popup only?
	      var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	      //binding to a variable that indicates if matches are being retrieved asynchronously
	      var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	      //a callback executed when a match is selected
	      var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	      var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	      var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	      var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	      //INTERNAL VARIABLES
	
	      //model setter executed upon match selection
	      var $setModelValue = $parse(attrs.ngModel).assign;
	
	      //expressions used by typeahead
	      var parserResult = typeaheadParser.parse(attrs.typeahead);
	
	      var hasFocus;
	
	      //create a child scope for the typeahead directive so we are not polluting original scope
	      //with typeahead-specific data (matches, query etc.)
	      var scope = originalScope.$new();
	      originalScope.$on('$destroy', function(){
	        scope.$destroy();
	      });
	
	      // WAI-ARIA
	      var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      element.attr({
	        'aria-autocomplete': 'list',
	        'aria-expanded': false,
	        'aria-owns': popupId
	      });
	
	      //pop-up element used to display matches
	      var popUpEl = angular.element('<div typeahead-popup></div>');
	      popUpEl.attr({
	        id: popupId,
	        matches: 'matches',
	        active: 'activeIdx',
	        select: 'select(activeIdx)',
	        query: 'query',
	        position: 'position'
	      });
	      //custom item template
	      if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	        popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	      }
	
	      var resetMatches = function() {
	        scope.matches = [];
	        scope.activeIdx = -1;
	        element.attr('aria-expanded', false);
	      };
	
	      var getMatchId = function(index) {
	        return popupId + '-option-' + index;
	      };
	
	      // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	      // This attribute is added or removed automatically when the `activeIdx` changes.
	      scope.$watch('activeIdx', function(index) {
	        if (index < 0) {
	          element.removeAttr('aria-activedescendant');
	        } else {
	          element.attr('aria-activedescendant', getMatchId(index));
	        }
	      });
	
	      var getMatchesAsync = function(inputValue) {
	
	        var locals = {$viewValue: inputValue};
	        isLoadingSetter(originalScope, true);
	        $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	
	          //it might happen that several async queries were in progress if a user were typing fast
	          //but we are interested only in responses that correspond to the current view value
	          var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	          if (onCurrentRequest && hasFocus) {
	            if (matches.length > 0) {
	
	              scope.activeIdx = focusFirst ? 0 : -1;
	              scope.matches.length = 0;
	
	              //transform labels
	              for(var i=0; i<matches.length; i++) {
	                locals[parserResult.itemName] = matches[i];
	                scope.matches.push({
	                  id: getMatchId(i),
	                  label: parserResult.viewMapper(scope, locals),
	                  model: matches[i]
	                });
	              }
	
	              scope.query = inputValue;
	              //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	              //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	              //due to other elements being rendered
	              scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	              scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	              element.attr('aria-expanded', true);
	            } else {
	              resetMatches();
	            }
	          }
	          if (onCurrentRequest) {
	            isLoadingSetter(originalScope, false);
	          }
	        }, function(){
	          resetMatches();
	          isLoadingSetter(originalScope, false);
	        });
	      };
	
	      resetMatches();
	
	      //we need to propagate user's query so we can higlight matches
	      scope.query = undefined;
	
	      //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later 
	      var timeoutPromise;
	
	      var scheduleSearchWithTimeout = function(inputValue) {
	        timeoutPromise = $timeout(function () {
	          getMatchesAsync(inputValue);
	        }, waitTime);
	      };
	
	      var cancelPreviousTimeout = function() {
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	      };
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function (inputValue) {
	
	        hasFocus = true;
	
	        if (inputValue && inputValue.length >= minSearch) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        } else {
	          if (!inputValue) {
	            // Reset in case user had typed something previously.
	            modelCtrl.$setValidity('editable', true);
	            return inputValue;
	          } else {
	            modelCtrl.$setValidity('editable', false);
	            return undefined;
	          }
	        }
	      });
	
	      modelCtrl.$formatters.push(function (modelValue) {
	
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        if (inputFormatter) {
	
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	
	        } else {
	
	          //it might happen that we don't have enough info to properly render input value
	          //we need to check for this situation and simply return model value if we can't apply custom formatting
	          locals[parserResult.itemName] = modelValue;
	          candidateViewValue = parserResult.viewMapper(originalScope, locals);
	          locals[parserResult.itemName] = undefined;
	          emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	          return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
	        }
	      });
	
	      scope.select = function (activeIdx) {
	        //called from within the $digest() cycle
	        var locals = {};
	        var model, item;
	
	        locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	        model = parserResult.modelMapper(originalScope, locals);
	        $setModelValue(originalScope, model);
	        modelCtrl.$setValidity('editable', true);
	
	        onSelectCallback(originalScope, {
	          $item: item,
	          $model: model,
	          $label: parserResult.viewMapper(originalScope, locals)
	        });
	
	        resetMatches();
	
	        //return focus to the input element if a match was selected via a mouse click event
	        // use timeout to avoid $rootScope:inprog error
	        $timeout(function() { element[0].focus(); }, 0, false);
	      };
	
	      //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	      element.bind('keydown', function (evt) {
	
	        //typeahead is open and an "interesting" key was pressed
	        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	          return;
	        }
	
	        // if there's nothing selected (i.e. focusFirst) and enter is hit, don't do anything
	        if (scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)) {
	          return;
	        }
	
	        evt.preventDefault();
	
	        if (evt.which === 40) {
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	
	        } else if (evt.which === 38) {
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	
	        } else if (evt.which === 13 || evt.which === 9) {
	          scope.$apply(function () {
	            scope.select(scope.activeIdx);
	          });
	
	        } else if (evt.which === 27) {
	          evt.stopPropagation();
	
	          resetMatches();
	          scope.$digest();
	        }
	      });
	
	      element.bind('blur', function (evt) {
	        hasFocus = false;
	      });
	
	      // Keep reference to click handler to unbind it.
	      var dismissClickHandler = function (evt) {
	        if (element[0] !== evt.target) {
	          resetMatches();
	          scope.$digest();
	        }
	      };
	
	      $document.bind('click', dismissClickHandler);
	
	      originalScope.$on('$destroy', function(){
	        $document.unbind('click', dismissClickHandler);
	        if (appendToBody) {
	          $popup.remove();
	        }
	      });
	
	      var $popup = $compile(popUpEl)(scope);
	      if (appendToBody) {
	        $document.find('body').append($popup);
	      } else {
	        element.after($popup);
	      }
	    }
	  };
	
	}])
	
	  .directive('typeaheadPopup', function () {
	    return {
	      restrict:'EA',
	      scope:{
	        matches:'=',
	        query:'=',
	        active:'=',
	        position:'=',
	        select:'&'
	      },
	      replace:true,
	      templateUrl:'template/typeahead/typeahead-popup.html',
	      link:function (scope, element, attrs) {
	
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function () {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function (matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function (matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function (activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  })
	
	  .directive('typeaheadMatch', ['$http', '$templateCache', '$compile', '$parse', function ($http, $templateCache, $compile, $parse) {
	    return {
	      restrict:'EA',
	      scope:{
	        index:'=',
	        match:'=',
	        query:'='
	      },
	      link:function (scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $http.get(tplUrl, {cache: $templateCache}).success(function(tplContent){
	           element.replaceWith($compile(tplContent.trim())(scope));
	        });
	      }
	    };
	  }])
	
	  .filter('typeaheadHighlight', function() {
	
	    function escapeRegexp(queryToEscape) {
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function(matchItem, query) {
	      return query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem;
	    };
	  });
	
	angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion-group.html",
	    "<div class=\"panel panel-default\">\n" +
	    "  <div class=\"panel-heading\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a href class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div class=\"panel-collapse\" collapse=\"!isOpen\">\n" +
	    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion.html",
	    "<div class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "        <li ng-repeat=\"slide in slides track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
	    "    </ol>\n" +
	    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
	    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': leaving || (active && !entering),\n" +
	    "    'prev': (next || active) && direction=='prev',\n" +
	    "    'next': (next || active) && direction=='next',\n" +
	    "    'right': direction=='prev',\n" +
	    "    'left': direction=='next'\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
	    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
	    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
	    "</div>");
	}]);
	
	angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{5 + showWeeks}}\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/popup.html",
	    "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" +
	    "	<li ng-transclude></li>\n" +
	    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	    "		<span class=\"btn-group pull-left\">\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	    "		</span>\n" +
	    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	    "	</li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
	    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/backdrop.html",
	    "<div class=\"modal-backdrop fade {{ backdropClass }}\"\n" +
	    "     ng-class=\"{in: animate}\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/window.html",
	    "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
	    "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
	    "</div>");
	}]);
	
	angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious(), previous: align}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext(), next: align}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
	    "</ul>");
	}]);
	
	angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\">{{getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\">{{getText('last')}}</a></li>\n" +
	    "</ul>");
	}]);
	
	angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
	    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover.html",
	    "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");
	}]);
	
	angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude></div>");
	}]);
	
	angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>\n" +
	    "</div>");
	}]);
	
	angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
	    "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\">\n" +
	    "        <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    </i>\n" +
	    "</span>");
	}]);
	
	angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tab.html",
	    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
	    "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\" \n" +
	    "         ng-repeat=\"tab in tabs\" \n" +
	    "         ng-class=\"{active: tab.active}\"\n" +
	    "         tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/timepicker/timepicker.html",
	    "<table>\n" +
	    "	<tbody>\n" +
	    "		<tr class=\"text-center\">\n" +
	    "			<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "			<td>&nbsp;</td>\n" +
	    "			<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "			<td ng-show=\"showMeridian\"></td>\n" +
	    "		</tr>\n" +
	    "		<tr>\n" +
	    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "				<input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
	    "			</td>\n" +
	    "			<td>:</td>\n" +
	    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "				<input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
	    "			</td>\n" +
	    "			<td ng-show=\"showMeridian\"><button type=\"button\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" +
	    "		</tr>\n" +
	    "		<tr class=\"text-center\">\n" +
	    "			<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "			<td>&nbsp;</td>\n" +
	    "			<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "			<td ng-show=\"showMeridian\"></td>\n" +
	    "		</tr>\n" +
	    "	</tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-match.html",
	    "<a tabindex=\"-1\" bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
	}]);
	
	angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen()\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{match.id}}\">\n" +
	    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * # ngResource
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 *
	 * <div doc-module-components="ngResource"></div>
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The function
	 *   will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling a
	 *   "non-GET" action method).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body)
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
	 *   the default set of resource actions. The declaration should be created in the format of {@link
	 *   ng.$http#usage $http.config}:
	 *
	 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *        ...}
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes to using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     response body and headers and returns its transformed (typically deserialized) version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	 *     GET request, otherwise if a cache instance built with
	 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	 *     caching.
	 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in $resource, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
	 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
	 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
	 *     completed/cancelled request will have no effect.<br />
	 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
	 *     for more information.
	 *   - **`responseType`** - `{string}` - see
	 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
	 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
	 *     with `http response` object. See {@link ng.$http $http interceptors}.
	 *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   { 'get':    {method:'GET'},
	 *     'save':   {method:'POST'},
	 *     'query':  {method:'GET', isArray:true},
	 *     'remove': {method:'DELETE'},
	 *     'delete': {method:'DELETE'} };
	 *   ```
	 *
	 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
	 *   destination and parameters. When the data is returned from the server then the object is an
	 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
	 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
	 *   read, update, delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId:'@id'});
	 *   var user = User.get({userId:123}, function() {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a $resource object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
	 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
	 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   Success callback is called with (value, responseHeaders) arguments, where the value is
	 *   the populated resource instance or collection object. The error callback is called
	 *   with (httpResponse) argument.
	 *
	 *   Class actions return empty instance (with additional properties below).
	 *   Instance actions return promise of the action.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in
	 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object, without
	 *     the `resource` property.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the interceptor.
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching Angular-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON()_behavior)).
	 *
	 * @example
	 *
	 * # Credit card resource
	 *
	 * ```js
	     // Define CreditCard class
	     var CreditCard = $resource('/user/:userId/card/:cardId',
	      {userId:123, cardId:'@id'}, {
	       charge: {method:'POST', params:{charge:true}}
	      });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query(function() {
	       // GET: /user/123/card
	       // server returns: [ {id:456, number:'1234', name:'Smith'} ];
	
	       var card = cards[0];
	       // each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	       card.name = "J. Smith";
	       // non GET methods are mapped onto the instances
	       card.$save();
	       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
	       // server returns: {id:456, number:'1234', name: 'J. Smith'};
	
	       // our custom method is mapped as well.
	       card.$charge({amount:9.99});
	       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
	     });
	
	     // we can create an instance as well
	     var newCard = new CreditCard({number:'0123'});
	     newCard.name = "Mike Smith";
	     newCard.$save();
	     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
	     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
	     expect(newCard.id).toEqual(789);
	 * ```
	 *
	 * The object returned from this function execution is a resource "class" which has "static" method
	 * for each action in the definition.
	 *
	 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
	 * `headers`.
	 *
	 * @example
	 *
	 * # User resource
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
	 * in the response that came from the server as well as $http header getter function, so one
	 * could rewrite the above example and get access to http headers as:
	 *
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user, getResponseHeaders){
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         //user => saved user object
	         //putResponseHeaders => $http header getter
	       });
	     });
	   ```
	 *
	 * You can also access the raw `$http` promise via the `$promise` property on the object returned
	 *
	   ```
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123})
	         .$promise.then(function(user) {
	           $scope.user = user;
	         });
	   ```
	 *
	 * @example
	 *
	 * # Creating a custom 'PUT' request
	 *
	 * In this example we create a custom method on our resource to make a PUT request
	 * ```js
	 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
	 *
	 *    // Some APIs expect a PUT request in the format URL/object/ID
	 *    // Here we are creating an 'update' method
	 *    app.factory('Notes', ['$resource', function($resource) {
	 *    return $resource('/notes/:id', null,
	 *        {
	 *            'update': { method:'PUT' }
	 *        });
	 *    }]);
	 *
	 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
	 *    // We pass in $routeParams and our Notes factory along with $scope
	 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
	                                      function($scope, $routeParams, Notes) {
	 *    // First get a note object from the factory
	 *    var note = Notes.get({ id:$routeParams.id });
	 *    $id = note.id;
	 *
	 *    // Now call update passing in the ID first then the object you are updating
	 *    Notes.update({ id:$id }, note);
	 *
	 *    // This will PUT /notes/ID with the note object in the request payload
	 *    }]);
	 * ```
	 *
	 * @example
	 *
	 * # Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       this.availableHotels.$cancelRequest();
	
	       // Let's query for hotels in '<destination>'
	       // (calls: /api/hotel?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  provider('$resource', function() {
	    var PROTOCOL_AND_DOMAIN_REGEX = /^https?:\/\/[^\/]*/;
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     });
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'}
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	        forEach = angular.forEach,
	        extend = angular.extend,
	        copy = angular.copy,
	        isFunction = angular.isFunction;
	
	      /**
	       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
	       * (pchar) allowed in path segments:
	       *    segment       = *pchar
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriSegment(val) {
	        return encodeUriQuery(val, true).
	          replace(/%26/gi, '&').
	          replace(/%3D/gi, '=').
	          replace(/%2B/gi, '+');
	      }
	
	
	      /**
	       * This method is intended for encoding *key* or *value* parts of query component. We need a
	       * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
	       * have to be encoded per http://tools.ietf.org/html/rfc3986:
	       *    query       = *( pchar / "/" / "?" )
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriQuery(val, pctEncodeSpaces) {
	        return encodeURIComponent(val).
	          replace(/%40/gi, '@').
	          replace(/%3A/gi, ':').
	          replace(/%24/g, '$').
	          replace(/%2C/gi, ',').
	          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	      }
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndDomain = '';
	
	          var urlParams = self.urlParams = {};
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', "hasOwnProperty is not a valid parameter name.");
	            }
	            if (!(new RegExp("^\\d+$").test(param)) && param &&
	              (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp("\\?.*=:" + param + "(?:\\W|$)")).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_DOMAIN_REGEX, function(match) {
	            protocolAndDomain = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (angular.isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp("(\/?):" + urlParam + "(\\W|$)", "g"), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) == '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // then replace collapse `/.` if found in the last URL path segment before the query
	          // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // replace escaped `/\.` with `/.`
	          config.url = protocolAndDomain + url.replace(/\/\\\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) == '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
	          var numericTimeout = action.timeout;
	          var cancellable = angular.isDefined(action.cancellable) ? action.cancellable :
	              (options && angular.isDefined(options.cancellable)) ? options.cancellable :
	              provider.defaults.cancellable;
	
	          if (numericTimeout && !angular.isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, success, error;
	
	            /* jshint -W086 */ /* (purposefully fall through case statements) */
	            switch (arguments.length) {
	              case 4:
	                error = a4;
	                success = a3;
	              //fallthrough
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    success = a1;
	                    error = a2;
	                    break;
	                  }
	
	                  success = a2;
	                  error = a3;
	                  //fallthrough
	                } else {
	                  params = a1;
	                  data = a2;
	                  success = a3;
	                  break;
	                }
	              case 1:
	                if (isFunction(a1)) success = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  "Expected up to 4 arguments [params, data, success, error], got {0} arguments",
	                  arguments.length);
	            }
	            /* jshint +W086 */ /* (purposefully fall through case statements) */
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            var promise = $http(httpConfig).then(function(response) {
	              var data = response.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                // jshint -W018
	                if (angular.isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    angular.isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                // jshint +W018
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === "object") {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	              response.resource = value;
	
	              return response;
	            }, function(response) {
	              (error || noop)(response);
	              return $q.reject(response);
	            });
	
	            promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = angular.noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            promise = promise.then(
	              function(response) {
	                var value = responseInterceptor(response);
	                (success || noop)(value, response.headers);
	                return value;
	              },
	              responseErrorInterceptor);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = timeoutDeferred.resolve;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        Resource.bind = function(additionalParamDefaults) {
	          return resourceFactory(url, extend({}, paramDefaults, additionalParamDefaults), actions);
	        };
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(181);
	module.exports = 'ngResource';


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      angular.extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} regexp New regexp to whitelist urls with.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (angular.isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = toMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = toMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	// They can potentially allow for arbitrary javascript to be executed. See #11290
	var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	        "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	// Blocked Elements (will be stripped)
	var blockedElements = toMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function toMap(str, lowercaseKeys) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	  }
	  return obj;
	}
	
	var inertBodyElement;
	(function(window) {
	  var doc;
	  if (window.document && window.document.implementation) {
	    doc = window.document.implementation.createHTMLDocument("inert");
	  } else {
	    throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	  }
	  var docElement = doc.documentElement || doc.getDocumentElement();
	  var bodyElements = docElement.getElementsByTagName('body');
	
	  // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	  if (bodyElements.length === 1) {
	    inertBodyElement = bodyElements[0];
	  } else {
	    var html = doc.createElement('html');
	    inertBodyElement = doc.createElement('body');
	    html.appendChild(inertBodyElement);
	    doc.appendChild(html);
	  }
	})(window);
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (html === null || html === undefined) {
	    html = '';
	  } else if (typeof html !== 'string') {
	    html = '' + html;
	  }
	  inertBodyElement.innerHTML = html;
	
	  //mXSS protection
	  var mXSSAttempts = 5;
	  do {
	    if (mXSSAttempts === 0) {
	      throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	    }
	    mXSSAttempts--;
	
	    // strip custom-namespaced attributes on IE<=11
	    if (window.document.documentMode) {
	      stripCustomNsAttrs(inertBodyElement);
	    }
	    html = inertBodyElement.innerHTML; //trigger mXSS
	    inertBodyElement.innerHTML = html;
	  } while (html !== inertBodyElement.innerHTML);
	
	  var node = inertBodyElement.firstChild;
	  while (node) {
	    switch (node.nodeType) {
	      case 1: // ELEMENT_NODE
	        handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	        break;
	      case 3: // TEXT NODE
	        handler.chars(node.textContent);
	        break;
	    }
	
	    var nextNode;
	    if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	        handler.end(node.nodeName.toLowerCase());
	      }
	      nextNode = node.nextSibling;
	      if (!nextNode) {
	        while (nextNode == null) {
	          node = node.parentNode;
	          if (node === inertBodyElement) break;
	          nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	            handler.end(node.nodeName.toLowerCase());
	          }
	        }
	      }
	    }
	    node = nextNode;
	  }
	
	  while (node = inertBodyElement.firstChild) {
	    inertBodyElement.removeChild(node);
	  }
	}
	
	function attrToMap(attrs) {
	  var map = {};
	  for (var i = 0, ii = attrs.length; i < ii; i++) {
	    var attr = attrs[i];
	    map[attr.name] = attr.value;
	  }
	  return map;
	}
	
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.join('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignoreCurrentElement = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && blockedElements[tag]) {
	        ignoreCurrentElement = tag;
	      }
	      if (!ignoreCurrentElement && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out('>');
	      }
	    },
	    end: function(tag) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	        out('</');
	        out(tag);
	        out('>');
	      }
	      if (tag == ignoreCurrentElement) {
	        ignoreCurrentElement = false;
	      }
	    },
	    chars: function(chars) {
	      if (!ignoreCurrentElement) {
	        out(encodeEntities(chars));
	      }
	    }
	  };
	}
	
	
	/**
	 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	 * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	 * to allow any of these custom attributes. This method strips them all.
	 *
	 * @param node Root element to process
	 */
	function stripCustomNsAttrs(node) {
	  if (node.nodeType === window.Node.ELEMENT_NODE) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var attrNode = attrs[i];
	      var attrName = attrNode.name.toLowerCase();
	      if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
	        node.removeAttributeNode(attrNode);
	        i--;
	        l--;
	      }
	    }
	  }
	
	  var nextNode = node.firstChild;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	
	  nextNode = node.nextSibling;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	}
	
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key;
	      html.push('<a ');
	      if (angular.isFunction(attributes)) {
	        attributes = attributes(url);
	      }
	      if (angular.isObject(attributes)) {
	        for (key in attributes) {
	          html.push(key + '="' + attributes[key] + '" ');
	        }
	      } else {
	        attributes = {};
	      }
	      if (angular.isDefined(target) && !('target' in attributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(183);
	module.exports = 'ngSanitize';


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * angular-slugify -- provides slugification for AngularJS
	 *
	 * Copyright © 2013 Paul Smith <paulsmith@pobox.com>
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the “Software”), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	(function() {
	    "use strict";
	
	    var mod = angular.module("slugifier", []);
	
	    // Unicode (non-control) characters in the Latin-1 Supplement and Latin
	    // Extended-A blocks, transliterated into ASCII characters.
	    var charmap = {
	        ' ': " ",
	        '¡': "!",
	        '¢': "c",
	        '£': "lb",
	        '¥': "yen",
	        '¦': "|",
	        '§': "SS",
	        '¨': "\"",
	        '©': "(c)",
	        'ª': "a",
	        '«': "<<",
	        '¬': "not",
	        '­': "-",
	        '®': "(R)",
	        '°': "^0",
	        '±': "+/-",
	        '²': "^2",
	        '³': "^3",
	        '´': "'",
	        'µ': "u",
	        '¶': "P",
	        '·': ".",
	        '¸': ",",
	        '¹': "^1",
	        'º': "o",
	        '»': ">>",
	        '¼': " 1/4 ",
	        '½': " 1/2 ",
	        '¾': " 3/4 ",
	        '¿': "?",
	        'À': "`A",
	        'Á': "'A",
	        'Â': "^A",
	        'Ã': "~A",
	        'Ä': '"A',
	        'Å': "A",
	        'Æ': "AE",
	        'Ç': "C",
	        'È': "`E",
	        'É': "'E",
	        'Ê': "^E",
	        'Ë': '"E',
	        'Ì': "`I",
	        'Í': "'I",
	        'Î': "^I",
	        'Ï': '"I',
	        'Ð': "D",
	        'Ñ': "~N",
	        'Ò': "`O",
	        'Ó': "'O",
	        'Ô': "^O",
	        'Õ': "~O",
	        'Ö': '"O',
	        '×': "x",
	        'Ø': "O",
	        'Ù': "`U",
	        'Ú': "'U",
	        'Û': "^U",
	        'Ü': '"U',
	        'Ý': "'Y",
	        'Þ': "Th",
	        'ß': "ss",
	        'à': "`a",
	        'á': "'a",
	        'â': "^a",
	        'ã': "~a",
	        'ä': '"a',
	        'å': "a",
	        'æ': "ae",
	        'ç': "c",
	        'è': "`e",
	        'é': "'e",
	        'ê': "^e",
	        'ë': '"e',
	        'ì': "`i",
	        'í': "'i",
	        'î': "^i",
	        'ï': '"i',
	        'ð': "d",
	        'ñ': "~n",
	        'ò': "`o",
	        'ó': "'o",
	        'ô': "^o",
	        'õ': "~o",
	        'ö': '"o',
	        '÷': ":",
	        'ø': "o",
	        'ù': "`u",
	        'ú': "'u",
	        'û': "^u",
	        'ü': '"u',
	        'ý': "'y",
	        'þ': "th",
	        'ÿ': '"y',
	        'Ā': "A",
	        'ā': "a",
	        'Ă': "A",
	        'ă': "a",
	        'Ą': "A",
	        'ą': "a",
	        'Ć': "'C",
	        'ć': "'c",
	        'Ĉ': "^C",
	        'ĉ': "^c",
	        'Ċ': "C",
	        'ċ': "c",
	        'Č': "C",
	        'č': "c",
	        'Ď': "D",
	        'ď': "d",
	        'Đ': "D",
	        'đ': "d",
	        'Ē': "E",
	        'ē': "e",
	        'Ĕ': "E",
	        'ĕ': "e",
	        'Ė': "E",
	        'ė': "e",
	        'Ę': "E",
	        'ę': "e",
	        'Ě': "E",
	        'ě': "e",
	        'Ĝ': "^G",
	        'ĝ': "^g",
	        'Ğ': "G",
	        'ğ': "g",
	        'Ġ': "G",
	        'ġ': "g",
	        'Ģ': "G",
	        'ģ': "g",
	        'Ĥ': "^H",
	        'ĥ': "^h",
	        'Ħ': "H",
	        'ħ': "h",
	        'Ĩ': "~I",
	        'ĩ': "~i",
	        'Ī': "I",
	        'ī': "i",
	        'Ĭ': "I",
	        'ĭ': "i",
	        'Į': "I",
	        'į': "i",
	        'İ': "I",
	        'ı': "i",
	        'Ĳ': "IJ",
	        'ĳ': "ij",
	        'Ĵ': "^J",
	        'ĵ': "^j",
	        'Ķ': "K",
	        'ķ': "k",
	        'Ĺ': "L",
	        'ĺ': "l",
	        'Ļ': "L",
	        'ļ': "l",
	        'Ľ': "L",
	        'ľ': "l",
	        'Ŀ': "L",
	        'ŀ': "l",
	        'Ł': "L",
	        'ł': "l",
	        'Ń': "'N",
	        'ń': "'n",
	        'Ņ': "N",
	        'ņ': "n",
	        'Ň': "N",
	        'ň': "n",
	        'ŉ': "'n",
	        'Ō': "O",
	        'ō': "o",
	        'Ŏ': "O",
	        'ŏ': "o",
	        'Ő': '"O',
	        'ő': '"o',
	        'Œ': "OE",
	        'œ': "oe",
	        'Ŕ': "'R",
	        'ŕ': "'r",
	        'Ŗ': "R",
	        'ŗ': "r",
	        'Ř': "R",
	        'ř': "r",
	        'Ś': "'S",
	        'ś': "'s",
	        'Ŝ': "^S",
	        'ŝ': "^s",
	        'Ş': "S",
	        'ş': "s",
	        'Š': "S",
	        'š': "s",
	        'Ţ': "T",
	        'ţ': "t",
	        'Ť': "T",
	        'ť': "t",
	        'Ŧ': "T",
	        'ŧ': "t",
	        'Ũ': "~U",
	        'ũ': "~u",
	        'Ū': "U",
	        'ū': "u",
	        'Ŭ': "U",
	        'ŭ': "u",
	        'Ů': "U",
	        'ů': "u",
	        'Ű': '"U',
	        'ű': '"u',
	        'Ų': "U",
	        'ų': "u",
	        'Ŵ': "^W",
	        'ŵ': "^w",
	        'Ŷ': "^Y",
	        'ŷ': "^y",
	        'Ÿ': '"Y',
	        'Ź': "'Z",
	        'ź': "'z",
	        'Ż': "Z",
	        'ż': "z",
	        'Ž': "Z",
	        'ž': "z",
	        'ſ': "s"
	    };
	
	    function _slugify(s) {
	        if (!s) return "";
	        var ascii = [];
	        var ch, cp;
	        for (var i = 0; i < s.length; i++) {
	            if ((cp = s.charCodeAt(i)) < 0x180) {
	                ch = String.fromCharCode(cp);
	                ascii.push(charmap[ch] || ch);
	            }
	        }
	        s = ascii.join("");
	        s = s.replace(/[^\w\s-]/g, "").trim().toLowerCase();
	        return s.replace(/[-\s]+/g, "-");
	    }
	
	    mod.factory("Slug", function() {
	        return {
	            slugify: _slugify
	        };
	    });
	
	    mod.directive("slug", ["Slug", function(Slug) {
	        return {
	            restrict: "E",
	            scope: {
	                to: "=",
	            },
	            transclude: true,
	            replace: true,
	            template: "<div ng-transclude></div>",
	            link: function(scope, elem, attrs) {
	                if (!attrs.from) {
	                    throw "must set attribute 'from'";
	                }
	                scope.$parent.$watch(attrs.from, function(val) {
	                    scope.to = Slug.slugify(val);
	                });
	            }
	        };
	    }]);
	
	    mod.filter("slugify", ["Slug", function(Slug) {
	        return function(input) {
	            return Slug.slugify(input);
	        };
	    }]);
	
	    module.exports = mod;
	})();


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.3.1
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }).then(null, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            result.$$resolveAs = view.resolveAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .constant("$state.runtime", { autoinject: true })
	  .provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @example
	 * A view can be unnamed or named.
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre>
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * </pre>
	 *
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * Example usage of $resolve in a view template
	 * <pre>
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope),
	            inherited     = $element.inheritedData('$uiView');
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            var $uiViewData = currentEl.data('$uiViewAnim');
	            renderer.leave(currentEl, function() {
	              $uiViewData.$$animLeave.resolve();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            var animEnter = $q.defer(), animLeave = $q.defer();
	            var viewAnimData = {
	              $animEnter: animEnter.promise,
	              $animLeave: animLeave.promise,
	              $$animLeave: animLeave
	            };
	
	            clone.data('$uiViewAnim', viewAnimData);
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              animEnter.resolve();
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var resolveData = angular.extend({}, locals);
	        scope[locals.$$resolveAs] = resolveData;
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	          }
	          if (isFunction(controller.$onInit)) controller.$onInit();
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var uiViewCreatedBy = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element.bind("click", hookFn);
	      scope.$on('$destroy', function() {
	        element.unbind("click", hookFn);
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element.bind("click", hookFn);
	      scope.$on('$destroy', function() {
	        element.unbind("click", hookFn);
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        var deregister = addState(newState, newParams, uiSrefActive);
	        update();
	        return deregister;
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        var stateInfo = {
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        };
	
	        states.push(stateInfo);
	        activeClasses[stateHash] = activeClass;
	
	        return function removeState() {
	          var idx = states.indexOf(stateInfo);
	          if (idx !== -1) states.splice(idx, 1);
	        };
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	/*
	 jQuery UI Sortable plugin wrapper
	
	 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
	 */
	angular
	  .module('ui.sortable', [])
	  .value('uiSortableConfig', {
	    // the default for jquery-ui sortable is "> *", we need to restrict this to
	    // ng-repeat items
	    // if the user uses
	    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
	  })
	  .directive('uiSortable', [
	    'uiSortableConfig',
	    '$timeout',
	    '$log',
	    function(uiSortableConfig, $timeout, $log) {
	      return {
	        require: '?ngModel',
	        scope: {
	          ngModel: '=',
	          uiSortable: '=',
	          ////Expression bindings from html.
	          create: '&uiSortableCreate',
	          // helper:'&uiSortableHelper',
	          start: '&uiSortableStart',
	          activate: '&uiSortableActivate',
	          // sort:'&uiSortableSort',
	          // change:'&uiSortableChange',
	          // over:'&uiSortableOver',
	          // out:'&uiSortableOut',
	          beforeStop: '&uiSortableBeforeStop',
	          update: '&uiSortableUpdate',
	          remove: '&uiSortableRemove',
	          receive: '&uiSortableReceive',
	          deactivate: '&uiSortableDeactivate',
	          stop: '&uiSortableStop'
	        },
	        link: function(scope, element, attrs, ngModel) {
	          var savedNodes;
	          var helper;
	
	          function combineCallbacks(first, second) {
	            var firstIsFunc = typeof first === 'function';
	            var secondIsFunc = typeof second === 'function';
	            if (firstIsFunc && secondIsFunc) {
	              return function() {
	                first.apply(this, arguments);
	                second.apply(this, arguments);
	              };
	            } else if (secondIsFunc) {
	              return second;
	            }
	            return first;
	          }
	
	          function getSortableWidgetInstance(element) {
	            // this is a fix to support jquery-ui prior to v1.11.x
	            // otherwise we should be using `element.sortable('instance')`
	            var data = element.data('ui-sortable');
	            if (
	              data &&
	              typeof data === 'object' &&
	              data.widgetFullName === 'ui-sortable'
	            ) {
	              return data;
	            }
	            return null;
	          }
	
	          function setItemChildrenWidth(item) {
	            item.children().each(function() {
	              var $el = angular.element(this);
	
	              // Preserve the with of the element
	              $el.width($el.width());
	            });
	          }
	
	          function dummyHelper(e, item) {
	            return item;
	          }
	
	          function patchSortableOption(key, value) {
	            if (callbacks[key]) {
	              if (key === 'stop') {
	                // call apply after stop
	                value = combineCallbacks(value, function() {
	                  scope.$apply();
	                });
	
	                value = combineCallbacks(value, afterStop);
	              }
	              // wrap the callback
	              value = combineCallbacks(callbacks[key], value);
	            } else if (wrappers[key]) {
	              value = wrappers[key](value);
	            }
	
	            // patch the options that need to have values set
	            if (!value && (key === 'items' || key === 'ui-model-items')) {
	              value = uiSortableConfig.items;
	            }
	
	            return value;
	          }
	
	          function patchUISortableOptions(
	            newOpts,
	            oldOpts,
	            sortableWidgetInstance
	          ) {
	            function addDummyOptionKey(value, key) {
	              if (!(key in opts)) {
	                // add the key in the opts object so that
	                // the patch function detects and handles it
	                opts[key] = null;
	              }
	            }
	            // for this directive to work we have to attach some callbacks
	            angular.forEach(callbacks, addDummyOptionKey);
	
	            // only initialize it in case we have to
	            // update some options of the sortable
	            var optsDiff = null;
	
	            if (oldOpts) {
	              // reset deleted options to default
	              var defaultOptions;
	              angular.forEach(oldOpts, function(oldValue, key) {
	                if (!newOpts || !(key in newOpts)) {
	                  if (key in directiveOpts) {
	                    if (key === 'ui-floating') {
	                      opts[key] = 'auto';
	                    } else {
	                      opts[key] = patchSortableOption(key, undefined);
	                    }
	                    return;
	                  }
	
	                  if (!defaultOptions) {
	                    defaultOptions = angular.element.ui.sortable().options;
	                  }
	                  var defaultValue = defaultOptions[key];
	                  defaultValue = patchSortableOption(key, defaultValue);
	
	                  if (!optsDiff) {
	                    optsDiff = {};
	                  }
	                  optsDiff[key] = defaultValue;
	                  opts[key] = defaultValue;
	                }
	              });
	            }
	
	            newOpts = angular.extend({}, newOpts);
	            // update changed options
	            // handle the custom option of the directive first
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                if (
	                  key === 'ui-floating' &&
	                  (value === false || value === true) &&
	                  sortableWidgetInstance
	                ) {
	                  sortableWidgetInstance.floating = value;
	                }
	
	                if (
	                  key === 'ui-preserve-size' &&
	                  (value === false || value === true)
	                ) {
	                  var userProvidedHelper = opts.helper;
	                  newOpts.helper = function(e, item) {
	                    if (opts['ui-preserve-size'] === true) {
	                      setItemChildrenWidth(item);
	                    }
	                    return (userProvidedHelper || dummyHelper).apply(
	                      this,
	                      arguments
	                    );
	                  };
	                }
	
	                opts[key] = patchSortableOption(key, value);
	              }
	            });
	
	            // handle the normal option of the directive
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                // the custom option of the directive are already handled
	                return;
	              }
	
	              value = patchSortableOption(key, value);
	
	              if (!optsDiff) {
	                optsDiff = {};
	              }
	              optsDiff[key] = value;
	              opts[key] = value;
	            });
	
	            return optsDiff;
	          }
	
	          function getPlaceholderElement(element) {
	            var placeholder = element.sortable('option', 'placeholder');
	
	            // placeholder.element will be a function if the placeholder, has
	            // been created (placeholder will be an object).  If it hasn't
	            // been created, either placeholder will be false if no
	            // placeholder class was given or placeholder.element will be
	            // undefined if a class was given (placeholder will be a string)
	            if (
	              placeholder &&
	              placeholder.element &&
	              typeof placeholder.element === 'function'
	            ) {
	              var result = placeholder.element();
	              // workaround for jquery ui 1.9.x,
	              // not returning jquery collection
	              result = angular.element(result);
	              return result;
	            }
	            return null;
	          }
	
	          function getPlaceholderExcludesludes(element, placeholder) {
	            // exact match with the placeholder's class attribute to handle
	            // the case that multiple connected sortables exist and
	            // the placeholder option equals the class of sortable items
	            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
	            var excludes = element.find(
	              '[class="' +
	                placeholder.attr('class') +
	                '"]:not(' +
	                notCssSelector +
	                ')'
	            );
	            return excludes;
	          }
	
	          function hasSortingHelper(element, ui) {
	            var helperOption = element.sortable('option', 'helper');
	            return (
	              helperOption === 'clone' ||
	              (typeof helperOption === 'function' &&
	                ui.item.sortable.isCustomHelperUsed())
	            );
	          }
	
	          function getSortingHelper(element, ui /*, savedNodes*/) {
	            var result = null;
	            if (
	              hasSortingHelper(element, ui) &&
	              element.sortable('option', 'appendTo') === 'parent'
	            ) {
	              // The .ui-sortable-helper element (that's the default class name)
	              result = helper;
	            }
	            return result;
	          }
	
	          // thanks jquery-ui
	          function isFloating(item) {
	            return (
	              /left|right/.test(item.css('float')) ||
	              /inline|table-cell/.test(item.css('display'))
	            );
	          }
	
	          function getElementContext(elementScopes, element) {
	            for (var i = 0; i < elementScopes.length; i++) {
	              var c = elementScopes[i];
	              if (c.element[0] === element[0]) {
	                return c;
	              }
	            }
	          }
	
	          function afterStop(e, ui) {
	            ui.item.sortable._destroy();
	          }
	
	          // return the index of ui.item among the items
	          // we can't just do ui.item.index() because there it might have siblings
	          // which are not items
	          function getItemIndex(item) {
	            return item
	              .parent()
	              .find(opts['ui-model-items'])
	              .index(item);
	          }
	
	          var opts = {};
	
	          // directive specific options
	          var directiveOpts = {
	            'ui-floating': undefined,
	            'ui-model-items': uiSortableConfig.items,
	            'ui-preserve-size': undefined
	          };
	
	          var callbacks = {
	            create: null,
	            start: null,
	            activate: null,
	            // sort: null,
	            // change: null,
	            // over: null,
	            // out: null,
	            beforeStop: null,
	            update: null,
	            remove: null,
	            receive: null,
	            deactivate: null,
	            stop: null
	          };
	
	          var wrappers = {
	            helper: null
	          };
	
	          angular.extend(
	            opts,
	            directiveOpts,
	            uiSortableConfig,
	            scope.uiSortable
	          );
	
	          if (!angular.element.fn || !angular.element.fn.jquery) {
	            $log.error(
	              'ui.sortable: jQuery should be included before AngularJS!'
	            );
	            return;
	          }
	
	          function wireUp() {
	            // When we add or remove elements, we need the sortable to 'refresh'
	            // so it can find the new/removed elements.
	            scope.$watchCollection('ngModel', function() {
	              // Timeout to let ng-repeat modify the DOM
	              $timeout(
	                function() {
	                  // ensure that the jquery-ui-sortable widget instance
	                  // is still bound to the directive's element
	                  if (!!getSortableWidgetInstance(element)) {
	                    element.sortable('refresh');
	                  }
	                },
	                0,
	                false
	              );
	            });
	
	            callbacks.start = function(e, ui) {
	              if (opts['ui-floating'] === 'auto') {
	                // since the drag has started, the element will be
	                // absolutely positioned, so we check its siblings
	                var siblings = ui.item.siblings();
	                var sortableWidgetInstance = getSortableWidgetInstance(
	                  angular.element(e.target)
	                );
	                sortableWidgetInstance.floating = isFloating(siblings);
	              }
	
	              // Save the starting position of dragged item
	              var index = getItemIndex(ui.item);
	              ui.item.sortable = {
	                model: ngModel.$modelValue[index],
	                index: index,
	                source: element,
	                sourceList: ui.item.parent(),
	                sourceModel: ngModel.$modelValue,
	                cancel: function() {
	                  ui.item.sortable._isCanceled = true;
	                },
	                isCanceled: function() {
	                  return ui.item.sortable._isCanceled;
	                },
	                isCustomHelperUsed: function() {
	                  return !!ui.item.sortable._isCustomHelperUsed;
	                },
	                _isCanceled: false,
	                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
	                _destroy: function() {
	                  angular.forEach(ui.item.sortable, function(value, key) {
	                    ui.item.sortable[key] = undefined;
	                  });
	                },
	                _connectedSortables: [],
	                _getElementContext: function(element) {
	                  return getElementContext(this._connectedSortables, element);
	                }
	              };
	            };
	
	            callbacks.activate = function(e, ui) {
	              var isSourceContext = ui.item.sortable.source === element;
	              var savedNodesOrigin = isSourceContext
	                ? ui.item.sortable.sourceList
	                : element;
	              var elementContext = {
	                element: element,
	                scope: scope,
	                isSourceContext: isSourceContext,
	                savedNodesOrigin: savedNodesOrigin
	              };
	              // save the directive's scope so that it is accessible from ui.item.sortable
	              ui.item.sortable._connectedSortables.push(elementContext);
	
	              // We need to make a copy of the current element's contents so
	              // we can restore it after sortable has messed it up.
	              // This is inside activate (instead of start) in order to save
	              // both lists when dragging between connected lists.
	              savedNodes = savedNodesOrigin.contents();
	              helper = ui.helper;
	
	              // If this list has a placeholder (the connected lists won't),
	              // don't inlcude it in saved nodes.
	              var placeholder = getPlaceholderElement(element);
	              if (placeholder && placeholder.length) {
	                var excludes = getPlaceholderExcludesludes(
	                  element,
	                  placeholder
	                );
	                savedNodes = savedNodes.not(excludes);
	              }
	            };
	
	            callbacks.update = function(e, ui) {
	              // Save current drop position but only if this is not a second
	              // update that happens when moving between lists because then
	              // the value will be overwritten with the old value
	              if (!ui.item.sortable.received) {
	                ui.item.sortable.dropindex = getItemIndex(ui.item);
	                var droptarget = ui.item
	                  .parent()
	                  .closest(
	                    '[ui-sortable], [data-ui-sortable], [x-ui-sortable]'
	                  );
	                ui.item.sortable.droptarget = droptarget;
	                ui.item.sortable.droptargetList = ui.item.parent();
	
	                var droptargetContext = ui.item.sortable._getElementContext(
	                  droptarget
	                );
	                ui.item.sortable.droptargetModel =
	                  droptargetContext.scope.ngModel;
	
	                // Cancel the sort (let ng-repeat do the sort for us)
	                // Don't cancel if this is the received list because it has
	                // already been canceled in the other list, and trying to cancel
	                // here will mess up the DOM.
	                element.sortable('cancel');
	              }
	
	              // Put the nodes back exactly the way they started (this is very
	              // important because ng-repeat uses comment elements to delineate
	              // the start and stop of repeat sections and sortable doesn't
	              // respect their order (even if we cancel, the order of the
	              // comments are still messed up).
	              var sortingHelper =
	                !ui.item.sortable.received &&
	                getSortingHelper(element, ui, savedNodes);
	              if (sortingHelper && sortingHelper.length) {
	                // Restore all the savedNodes except from the sorting helper element.
	                // That way it will be garbage collected.
	                savedNodes = savedNodes.not(sortingHelper);
	              }
	              var elementContext = ui.item.sortable._getElementContext(element);
	              savedNodes.appendTo(elementContext.savedNodesOrigin);
	
	              // If this is the target connected list then
	              // it's safe to clear the restored nodes since:
	              // update is currently running and
	              // stop is not called for the target list.
	              if (ui.item.sortable.received) {
	                savedNodes = null;
	              }
	
	              // If received is true (an item was dropped in from another list)
	              // then we add the new item to this list otherwise wait until the
	              // stop event where we will know if it was a sort or item was
	              // moved here from another list
	              if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
	                scope.$apply(function() {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex,
	                    0,
	                    ui.item.sortable.moved
	                  );
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              }
	            };
	
	            callbacks.stop = function(e, ui) {
	              // If the received flag hasn't be set on the item, this is a
	              // normal sort, if dropindex is set, the item was moved, so move
	              // the items in the list.
	              var wasMoved =
	                'dropindex' in ui.item.sortable &&
	                !ui.item.sortable.isCanceled();
	
	              if (wasMoved && !ui.item.sortable.received) {
	                scope.$apply(function() {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex,
	                    0,
	                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]
	                  );
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              } else if (
	                !wasMoved &&
	                !angular.equals(
	                  element.contents().toArray(),
	                  savedNodes.toArray()
	                )
	              ) {
	                // if the item was not moved
	                // and the DOM element order has changed,
	                // then restore the elements
	                // so that the ngRepeat's comment are correct.
	
	                var sortingHelper = getSortingHelper(element, ui, savedNodes);
	                if (sortingHelper && sortingHelper.length) {
	                  // Restore all the savedNodes except from the sorting helper element.
	                  // That way it will be garbage collected.
	                  savedNodes = savedNodes.not(sortingHelper);
	                }
	                var elementContext = ui.item.sortable._getElementContext(
	                  element
	                );
	                savedNodes.appendTo(elementContext.savedNodesOrigin);
	              }
	
	              // It's now safe to clear the savedNodes and helper
	              // since stop is the last callback.
	              savedNodes = null;
	              helper = null;
	            };
	
	            callbacks.receive = function(e, ui) {
	              // An item was dropped here from another list, set a flag on the
	              // item.
	              ui.item.sortable.received = true;
	            };
	
	            callbacks.remove = function(e, ui) {
	              // Workaround for a problem observed in nested connected lists.
	              // There should be an 'update' event before 'remove' when moving
	              // elements. If the event did not fire, cancel sorting.
	              if (!('dropindex' in ui.item.sortable)) {
	                element.sortable('cancel');
	                ui.item.sortable.cancel();
	              }
	
	              // Remove the item from this list's model and copy data into item,
	              // so the next list can retrive it
	              if (!ui.item.sortable.isCanceled()) {
	                scope.$apply(function() {
	                  ui.item.sortable.moved = ngModel.$modelValue.splice(
	                    ui.item.sortable.index,
	                    1
	                  )[0];
	                });
	              }
	            };
	
	            // setup attribute handlers
	            angular.forEach(callbacks, function(value, key) {
	              callbacks[key] = combineCallbacks(callbacks[key], function() {
	                var attrHandler = scope[key];
	                var attrHandlerFn;
	                if (
	                  typeof attrHandler === 'function' &&
	                  (
	                    'uiSortable' +
	                    key.substring(0, 1).toUpperCase() +
	                    key.substring(1)
	                  ).length &&
	                  typeof (attrHandlerFn = attrHandler()) === 'function'
	                ) {
	                  attrHandlerFn.apply(this, arguments);
	                }
	              });
	            });
	
	            wrappers.helper = function(inner) {
	              if (inner && typeof inner === 'function') {
	                return function(e, item) {
	                  var oldItemSortable = item.sortable;
	                  var index = getItemIndex(item);
	
	                  item.sortable = {
	                    model: ngModel.$modelValue[index],
	                    index: index,
	                    source: element,
	                    sourceList: item.parent(),
	                    sourceModel: ngModel.$modelValue,
	                    _restore: function() {
	                      angular.forEach(item.sortable, function(value, key) {
	                        item.sortable[key] = undefined;
	                      });
	
	                      item.sortable = oldItemSortable;
	                    }
	                  };
	
	                  var innerResult = inner.apply(this, arguments);
	                  item.sortable._restore();
	                  item.sortable._isCustomHelperUsed = item !== innerResult;
	                  return innerResult;
	                };
	              }
	              return inner;
	            };
	
	            scope.$watchCollection(
	              'uiSortable',
	              function(newOpts, oldOpts) {
	                // ensure that the jquery-ui-sortable widget instance
	                // is still bound to the directive's element
	                var sortableWidgetInstance = getSortableWidgetInstance(element);
	                if (!!sortableWidgetInstance) {
	                  var optsDiff = patchUISortableOptions(
	                    newOpts,
	                    oldOpts,
	                    sortableWidgetInstance
	                  );
	
	                  if (optsDiff) {
	                    element.sortable('option', optsDiff);
	                  }
	                }
	              },
	              true
	            );
	
	            patchUISortableOptions(opts);
	          }
	
	          function init() {
	            if (ngModel) {
	              wireUp();
	            } else {
	              $log.info('ui.sortable: ngModel not provided!', element);
	            }
	
	            // Create sortable
	            element.sortable(opts);
	          }
	
	          function initIfEnabled() {
	            if (scope.uiSortable && scope.uiSortable.disabled) {
	              return false;
	            }
	
	            init();
	
	            // Stop Watcher
	            initIfEnabled.cancelWatcher();
	            initIfEnabled.cancelWatcher = angular.noop;
	
	            return true;
	          }
	
	          initIfEnabled.cancelWatcher = angular.noop;
	
	          if (!initIfEnabled()) {
	            initIfEnabled.cancelWatcher = scope.$watch(
	              'uiSortable.disabled',
	              initIfEnabled
	            );
	          }
	        }
	      };
	    }
	  ]);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * @license Angular UI Tree v2.22.5
	 * (c) 2010-2017. https://github.com/angular-ui-tree/angular-ui-tree
	 * License: MIT
	 */
	(function () {
	  'use strict';
	
	  angular.module('ui.tree', [])
	    .constant('treeConfig', {
	      treeClass: 'angular-ui-tree',
	      emptyTreeClass: 'angular-ui-tree-empty',
	      hiddenClass: 'angular-ui-tree-hidden',
	      nodesClass: 'angular-ui-tree-nodes',
	      nodeClass: 'angular-ui-tree-node',
	      handleClass: 'angular-ui-tree-handle',
	      placeholderClass: 'angular-ui-tree-placeholder',
	      dragClass: 'angular-ui-tree-drag',
	      dragThreshold: 3,
	      defaultCollapsed: false,
	      appendChildOnHover: true
	    });
	
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeHandleController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$nodeScope = null;
	        $scope.$type = 'uiTreeHandle';
	
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .controller('TreeNodeController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$modelValue = null; // Model value for node;
	        $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
	        $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
	        $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
	        $scope.$treeScope = null; // uiTree scope
	        $scope.$handleScope = null; // it's handle scope
	        $scope.$type = 'uiTreeNode';
	        $scope.$$allowNodeDrop = false;
	        $scope.collapsed = false;
	        $scope.expandOnHover = false;
	
	        //Called by uiTreeNode Directive on load.
	        $scope.init = function (controllersArr) {
	          var treeNodesCtrl = controllersArr[0];
	          $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;
	
	          //Find the scope of it's parent node.
	          $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;
	
	          //modelValue for current node.
	          $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
	          $scope.$parentNodesScope = treeNodesCtrl.scope;
	
	          //Init sub nodes.
	          treeNodesCtrl.scope.initSubNode($scope);
	
	          $element.on('$destroy', function () {
	
	            //Destroy sub nodes.
	            treeNodesCtrl.scope.destroySubNode($scope);
	          });
	        };
	
	        //Return the index of child node in parent node (nodesScope).
	        $scope.index = function () {
	          return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
	        };
	
	        $scope.dragEnabled = function () {
	          return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
	        };
	
	        $scope.isSibling = function (targetNode) {
	          return $scope.$parentNodesScope == targetNode.$parentNodesScope;
	        };
	
	        $scope.isChild = function (targetNode) {
	          var nodes = $scope.childNodes();
	          return nodes && nodes.indexOf(targetNode) > -1;
	        };
	
	        //TODO(jcarter): This method is on uiTreeHelper already.
	        $scope.prev = function () {
	          var index = $scope.index();
	          if (index > 0) {
	            return $scope.siblings()[index - 1];
	          }
	          return null;
	        };
	
	        //Calls childNodes on parent.
	        $scope.siblings = function () {
	          return $scope.$parentNodesScope.childNodes();
	        };
	
	        $scope.childNodesCount = function () {
	          return $scope.childNodes() ? $scope.childNodes().length : 0;
	        };
	
	        $scope.hasChild = function () {
	          return $scope.childNodesCount() > 0;
	        };
	
	        $scope.childNodes = function () {
	          return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ?
	            $scope.$childNodesScope.childNodes() :
	            null;
	        };
	
	        $scope.accept = function (sourceNode, destIndex) {
	          return $scope.$childNodesScope &&
	            $scope.$childNodesScope.$modelValue &&
	            $scope.$childNodesScope.accept(sourceNode, destIndex);
	        };
	
	        $scope.remove = function () {
	          return $scope.$parentNodesScope.removeNode($scope);
	        };
	
	        $scope.toggle = function () {
	          $scope.collapsed = !$scope.collapsed;
	          $scope.$treeScope.$callbacks.toggle($scope.collapsed, $scope);
	        };
	
	        $scope.collapse = function () {
	          $scope.collapsed = true;
	        };
	
	        $scope.expand = function () {
	          $scope.collapsed = false;
	        };
	
	        $scope.depth = function () {
	          var parentNode = $scope.$parentNodeScope;
	          if (parentNode) {
	            return parentNode.depth() + 1;
	          }
	          return 1;
	        };
	
	        /**
	        * Returns the depth of the deepest subtree under this node
	        * @param scope a TreeNodesController scope object
	        * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
	        *   result is 0 (it has no subtree).
	        */
	        function countSubTreeDepth(scope) {
	          if (!scope) {
	            return 0;
	          }
	          var thisLevelDepth = 0,
	              childNodes = scope.childNodes(),
	              childNode,
	              childDepth,
	              i;
	          if (!childNodes || childNodes.length === 0) {
	            return 0;
	          }
	          for (i = childNodes.length - 1; i >= 0 ; i--) {
	            childNode = childNodes[i],
	            childDepth = 1 + countSubTreeDepth(childNode);
	            thisLevelDepth = Math.max(thisLevelDepth, childDepth);
	          }
	          return thisLevelDepth;
	        }
	
	        $scope.maxSubDepth = function () {
	          return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeNodesController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$modelValue = null;
	        $scope.$nodeScope = null; // the scope of node which the nodes belongs to
	        $scope.$treeScope = null;
	        $scope.$type = 'uiTreeNodes';
	        $scope.$nodesMap = {};
	
	        $scope.nodropEnabled = false;
	        $scope.maxDepth = 0;
	        $scope.cloneEnabled = false;
	
	        $scope.initSubNode = function (subNode) {
	          if (!subNode.$modelValue) {
	            return null;
	          }
	          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
	        };
	
	        $scope.destroySubNode = function (subNode) {
	          if (!subNode.$modelValue) {
	            return null;
	          }
	          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
	        };
	
	        $scope.accept = function (sourceNode, destIndex) {
	          return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
	        };
	
	        $scope.beforeDrag = function (sourceNode) {
	          return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
	        };
	
	        $scope.isParent = function (node) {
	          return node.$parentNodesScope == $scope;
	        };
	
	        $scope.hasChild = function () {
	          return $scope.$modelValue.length > 0;
	        };
	
	        $scope.safeApply = function (fn) {
	          var phase = this.$root.$$phase;
	          if (phase == '$apply' || phase == '$digest') {
	            if (fn && (typeof (fn) === 'function')) {
	              fn();
	            }
	          } else {
	            this.$apply(fn);
	          }
	        };
	
	        //Called in apply method of UiTreeHelper.dragInfo.
	        $scope.removeNode = function (node) {
	          var index = $scope.$modelValue.indexOf(node.$modelValue);
	          if (index > -1) {
	            $scope.safeApply(function () {
	              $scope.$modelValue.splice(index, 1)[0];
	            });
	            return $scope.$treeScope.$callbacks.removed(node);
	          }
	          return null;
	        };
	
	        //Called in apply method of UiTreeHelper.dragInfo.
	        $scope.insertNode = function (index, nodeData) {
	          $scope.safeApply(function () {
	            $scope.$modelValue.splice(index, 0, nodeData);
	          });
	        };
	
	        $scope.childNodes = function () {
	          var i, nodes = [];
	          if ($scope.$modelValue) {
	            for (i = 0; i < $scope.$modelValue.length; i++) {
	              nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
	            }
	          }
	          return nodes;
	        };
	
	        $scope.depth = function () {
	          if ($scope.$nodeScope) {
	            return $scope.$nodeScope.depth();
	          }
	          return 0; // if it has no $nodeScope, it's root
	        };
	
	        // check if depth limit has reached
	        $scope.outOfDepth = function (sourceNode) {
	          var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
	          if (maxDepth > 0) {
	            return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
	          }
	          return false;
	        };
	
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$nodesScope = null; // root nodes
	        $scope.$type = 'uiTree';
	        $scope.$emptyElm = null;
	        $scope.$callbacks = null;
	
	        $scope.dragEnabled = true;
	        $scope.emptyPlaceholderEnabled = true;
	        $scope.maxDepth = 0;
	        $scope.dragDelay = 0;
	        $scope.cloneEnabled = false;
	        $scope.nodropEnabled = false;
	
	        // Check if it's a empty tree
	        $scope.isEmpty = function () {
	          return ($scope.$nodesScope && $scope.$nodesScope.$modelValue
	          && $scope.$nodesScope.$modelValue.length === 0);
	        };
	
	        // add placeholder to empty tree
	        $scope.place = function (placeElm) {
	          $scope.$nodesScope.$element.append(placeElm);
	          $scope.$emptyElm.remove();
	        };
	
	        this.resetEmptyElement = function () {
	          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) &&
	            $scope.emptyPlaceholderEnabled) {
	            $element.append($scope.$emptyElm);
	          } else {
	            $scope.$emptyElm.remove();
	          }
	        };
	
	        $scope.resetEmptyElement = this.resetEmptyElement;
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTree', ['treeConfig', '$window',
	      function (treeConfig, $window) {
	        return {
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeController',
	          link: function (scope, element, attrs, ctrl) {
	            var callbacks = {
	              accept: null,
	              beforeDrag: null
	            },
	            config = {},
	            tdElm,
	            $trElm,
	            emptyElmColspan;
	
	            //Adding configured class to uiTree.
	            angular.extend(config, treeConfig);
	
	            if (config.treeClass) {
	              element.addClass(config.treeClass);
	            }
	
	            //Determining if uiTree is on a table.
	            if (element.prop('tagName').toLowerCase() === 'table') {
	              scope.$emptyElm = angular.element($window.document.createElement('tr'));
	              $trElm = element.find('tr');
	              
	              //If we can find a tr, then we can use its td children as the empty element colspan.
	              if ($trElm.length > 0) {
	                emptyElmColspan = angular.element($trElm).children().length;
	              } else {
	                
	                //If not, by setting a huge colspan we make sure it takes full width.
	                //TODO(jcarter): Check for negative side effects.
	                emptyElmColspan = 1000000;
	              }
	              tdElm = angular.element($window.document.createElement('td'))
	                .attr('colspan', emptyElmColspan);
	              scope.$emptyElm.append(tdElm);
	            } else {
	              scope.$emptyElm = angular.element($window.document.createElement('div'));
	            }
	
	            if (config.emptyTreeClass) {
	              scope.$emptyElm.addClass(config.emptyTreeClass);
	            }
	
	            scope.$watch('$nodesScope.$modelValue.length', function (val) {
	              if (!angular.isNumber(val)) {
	                return;
	              }
	
	              ctrl.resetEmptyElement();
	            }, true);
	
	            scope.$watch(attrs.dragEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.dragEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.emptyPlaceholderEnabled = val;
	                ctrl.resetEmptyElement();
	              }
	            });
	
	            scope.$watch(attrs.nodropEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.nodropEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.cloneEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.cloneEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.maxDepth, function (val) {
	              if ((typeof val) == 'number') {
	                scope.maxDepth = val;
	              }
	            });
	
	            scope.$watch(attrs.dragDelay, function (val) {
	              if ((typeof val) == 'number') {
	                scope.dragDelay = val;
	              }
	            });
	
	            /**
	             * Callback checks if the destination node can accept the dragged node.
	             * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
	             * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
	             * if it is set on the ui-tree or ui-tree-nodes.
	             * This callback can be overridden, but callers must manually enforce nodrop and max-depth
	             * themselves if they need those to be enforced.
	             * @param sourceNodeScope Scope of the ui-tree-node being dragged
	             * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
	             * @param destIndex Index in the destination nodes array where the source node will drop
	             * @returns {boolean} True if the node is permitted to be dropped here
	             */
	            callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
	              return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
	            };
	
	            callbacks.beforeDrag = function (sourceNodeScope) {
	              return true;
	            };
	
	            callbacks.expandTimeoutStart = function()
	            {
	
	            };
	
	            callbacks.expandTimeoutCancel = function()
	            {
	
	            };
	
	            callbacks.expandTimeoutEnd = function()
	            {
	
	            };
	
	            callbacks.removed = function (node) {
	
	            };
	
	            /**
	             * Callback is fired when a node is successfully dropped in a new location
	             * @param event
	             */
	            callbacks.dropped = function (event) {
	
	            };
	
	            /**
	             * Callback is fired each time the user starts dragging a node
	             * @param event
	             */
	            callbacks.dragStart = function (event) {
	
	            };
	
	            /**
	             * Callback is fired each time a dragged node is moved with the mouse/touch.
	             * @param event
	             */
	            callbacks.dragMove = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
	             * accepted or reverted.
	             * @param event
	             */
	            callbacks.dragStop = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when a user drops a node (but prior to processing the drop action)
	             * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
	             * If it returns falsy, or a resolve Promise, the node move is accepted
	             * If it returns truthy, or a rejected Promise, the node move is reverted
	             * @param event
	             * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
	             */
	            callbacks.beforeDrop = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when a user toggles node (but after processing the toggle action)
	             * @param sourceNodeScope
	             * @param collapsed
	             */
	            callbacks.toggle = function (collapsed, sourceNodeScope) {
	
	            };
	
	            scope.$watch(attrs.uiTree, function (newVal, oldVal) {
	              angular.forEach(newVal, function (value, key) {
	                if (callbacks[key]) {
	                  if (typeof value === 'function') {
	                    callbacks[key] = value;
	                  }
	                }
	              });
	
	              scope.$callbacks = callbacks;
	            }, true);
	
	
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTreeHandle', ['treeConfig',
	      function (treeConfig) {
	        return {
	          require: '^uiTreeNode',
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeHandleController',
	          link: function (scope, element, attrs, treeNodeCtrl) {
	            var config = {};
	            angular.extend(config, treeConfig);
	            if (config.handleClass) {
	              element.addClass(config.handleClass);
	            }
	            // connect with the tree node.
	            if (scope != treeNodeCtrl.scope) {
	              scope.$nodeScope = treeNodeCtrl.scope;
	              treeNodeCtrl.scope.$handleScope = scope;
	            }
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .directive('uiTreeNode', ['treeConfig', 'UiTreeHelper', '$window', '$document', '$timeout', '$q',
	      function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q) {
	        return {
	          require: ['^uiTreeNodes', '^uiTree'],
	          restrict: 'A',
	          controller: 'TreeNodeController',
	          link: function (scope, element, attrs, controllersArr) {
	            var config = {},
	              hasTouch = 'ontouchstart' in window,
	              firstMoving,
	              dragInfo,
	              pos,
	              placeElm,
	              hiddenPlaceElm,
	              dragElm,
	              scrollContainerElm,
	              unhover,
	              treeScope = null,
	              elements, // As a parameter for callbacks
	              dragDelaying = true,
	              dragStarted = false,
	              dragTimer = null,
	              body = document.body,
	              html = document.documentElement,
	              document_height,
	              document_width,
	              dragStart,
	              tagName,
	              dragMove,
	              dragEnd,
	              dragStartEvent,
	              dragMoveEvent,
	              dragEndEvent,
	              dragCancelEvent,
	              dragDelay,
	              bindDragStartEvents,
	              bindDragMoveEvents,
	              unbindDragMoveEvents,
	              keydownHandler,
	              isHandleChild,
	              el,
	              isUiTreeRoot,
	              treeOfOrigin;
	
	            //Adding configured class to ui-tree-node.
	            angular.extend(config, treeConfig);
	
	            if (config.nodeClass) {
	              element.addClass(config.nodeClass);
	            }
	
	            //Call init function in nodeCtrl, sets parent node and sets up sub nodes.
	            scope.init(controllersArr);
	
	            scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
	            scope.expandOnHover = !!UiTreeHelper.getNodeAttribute(scope, 'expandOnHover');
	            scope.scrollContainer = UiTreeHelper.getNodeAttribute(scope, 'scrollContainer') || attrs.scrollContainer || null;
	            scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;
	
	            scope.$watch(attrs.collapsed, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.collapsed = val;
	              }
	            });
	
	            //Watches to trigger behavior based on actions and settings.
	            scope.$watch('collapsed', function (val) {
	              UiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
	              attrs.$set('collapsed', val);
	            });
	
	            scope.$watch(attrs.expandOnHover, function(val) {
	              if ((typeof val) === 'boolean' || (typeof val) === 'number') {
	                scope.expandOnHover = val;
	              }
	            });
	
	            scope.$watch('expandOnHover', function (val) {
	              UiTreeHelper.setNodeAttribute(scope, 'expandOnHover', val);
	              attrs.$set('expandOnHover', val);
	            });
	
	            attrs.$observe('scrollContainer', function(val) {
	              if ((typeof val) === 'string') {
	                scope.scrollContainer = val;
	              }
	            });
	
	            scope.$watch('scrollContainer', function(val) {
	              UiTreeHelper.setNodeAttribute(scope, 'scrollContainer', val);
	              attrs.$set('scrollContainer', val);
	              scrollContainerElm = document.querySelector(val);
	            });
	
	            scope.$on('angular-ui-tree:collapse-all', function () {
	              scope.collapsed = true;
	            });
	
	            scope.$on('angular-ui-tree:expand-all', function () {
	              scope.collapsed = false;
	            });
	
	            /**
	             * Called when the user has grabbed a node and started dragging it.
	             *
	             * @param {MouseEvent} e event that is triggered by DOM.
	             * @return undefined?
	             */
	            dragStart = function (e) {
	
	              //Disable right click.
	              if (!hasTouch && (e.button === 2 || e.which === 3)) {
	                return;
	              }
	
	              //Event has already fired in other scope.
	              if (e.uiTreeDragging || (e.originalEvent && e.originalEvent.uiTreeDragging)) {
	                return;
	              }
	
	              //The node being dragged.
	              var eventElm = angular.element(e.target),
	                isHandleChild,
	                cloneElm,
	                eventElmTagName,
	                tagName,
	                eventObj,
	                tdElm,
	                hStyle,
	                isTreeNode,
	                isTreeNodeHandle;
	
	              //If the target element is a child element of a ui-tree-handle,
	              // use the containing handle element as target element.
	              isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(eventElm);
	              if (isHandleChild) {
	                eventElm = angular.element(isHandleChild);
	              }
	
	              cloneElm = element.clone();
	              isTreeNode = UiTreeHelper.elementIsTreeNode(eventElm);
	              isTreeNodeHandle = UiTreeHelper.elementIsTreeNodeHandle(eventElm);
	
	              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
	              if (!isTreeNode && !isTreeNodeHandle) {
	                return;
	              }
	
	              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
	              if (isTreeNode && UiTreeHelper.elementContainsTreeNodeHandler(eventElm)) {
	                return;
	              }
	
	              //Dragging not allowed on inputs or buttons.
	              eventElmTagName = eventElm.prop('tagName').toLowerCase();
	              if (eventElmTagName == 'input' ||
	                  eventElmTagName == 'textarea' ||
	                  eventElmTagName == 'button' ||
	                  eventElmTagName == 'select') {
	                return;
	              }
	
	              //Check if it or it's parents has a 'data-nodrag' attribute
	              el = angular.element(e.target);
	              isUiTreeRoot = el[0].attributes['ui-tree'];
	              while (el && el[0] && el[0] !== element && !isUiTreeRoot) {
	
	                //Checking that I can access attributes.
	                if (el[0].attributes) {
	                  isUiTreeRoot = el[0].attributes['ui-tree'];
	                }
	
	                //If the node mark as `nodrag`, DONOT drag it.
	                if (UiTreeHelper.nodrag(el)) {
	                  return;
	                }
	                el = el.parent();
	              }
	
	              //If users beforeDrag calback returns falsey, do not initiate.
	              if (!scope.beforeDrag(scope)) {
	                return;
	              }
	
	              //Set property checked at start of function to prevent running logic again.
	              e.uiTreeDragging = true;
	              if (e.originalEvent) {
	                e.originalEvent.uiTreeDragging = true;
	              }
	              e.preventDefault();
	
	              //Get original event if TouchEvent.
	              eventObj = UiTreeHelper.eventObj(e);
	
	              //Set boolean used to specify beginning of move.
	              firstMoving = true;
	
	              //Setting drag info properties and methods in scope of node being moved.
	              dragInfo = UiTreeHelper.dragInfo(scope);
	
	              //Setting original tree to adjust horizontal behavior in drag move.
	              treeOfOrigin = dragInfo.source.$treeScope.$id;
	
	              //Determine tage name of element ui-tree-node is on.
	              tagName = element.prop('tagName');
	
	              if (tagName.toLowerCase() === 'tr') {
	
	                //Create a new table column as placeholder.
	                placeElm = angular.element($window.document.createElement(tagName));
	
	                //Create a column placeholder and set colspan to whole row length.
	                tdElm = angular.element($window.document.createElement('td'))
	                    .addClass(config.placeholderClass)
	                    .attr('colspan', element[0].children.length);
	                placeElm.append(tdElm);
	              } else {
	
	                //If not a table just duplicate element and add placeholder class.
	                placeElm = angular.element($window.document.createElement(tagName))
	                    .addClass(config.placeholderClass);
	              }
	
	              //Create a hidden placeholder and add class from config.
	              hiddenPlaceElm = angular.element($window.document.createElement(tagName));
	              if (config.hiddenClass) {
	                hiddenPlaceElm.addClass(config.hiddenClass);
	              }
	
	              //Getting starting position of element being moved.
	              pos = UiTreeHelper.positionStarted(eventObj, element);
	              placeElm.css('height', element.prop('offsetHeight') + 'px');
	
	              //Creating drag element to represent node.
	              dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop('tagName')))
	                  .addClass(scope.$parentNodesScope.$element.attr('class')).addClass(config.dragClass);
	              dragElm.css('width', UiTreeHelper.width(element) + 'px');
	              dragElm.css('z-index', 9999);
	
	              //Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element.
	              hStyle = (element[0].querySelector('.angular-ui-tree-handle') || element[0]).currentStyle;
	              if (hStyle) {
	                document.body.setAttribute('ui-tree-cursor', $document.find('body').css('cursor') || '');
	                $document.find('body').css({'cursor': hStyle.cursor + '!important'});
	              }
	
	              //If tree is sourceOnly (noDragDrop) don't show placeholder when moving about it.
	              if (scope.sourceOnly) {
	                placeElm.css('display', 'none');
	              }
	
	              //Insert placeholder.
	              element.after(placeElm);
	              element.after(hiddenPlaceElm);
	              if (dragInfo.isClone() && scope.sourceOnly) {
	                dragElm.append(cloneElm);
	              } else {
	                dragElm.append(element);
	              }
	
	              //Create drag element.
	              $document.find('body').append(dragElm);
	
	              //Set drag elements position on screen.
	              dragElm.css({
	                'left': eventObj.pageX - pos.offsetX + 'px',
	                'top': eventObj.pageY - pos.offsetY + 'px'
	              });
	              elements = {
	                placeholder: placeElm,
	                dragging: dragElm
	              };
	
	              //Create all drag/move bindings.
	              bindDragMoveEvents();
	
	              //Fire dragStart callback.
	              scope.$apply(function () {
	                scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
	              });
	
	              //Get bounds of document.
	              document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	              document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	            };
	
	            dragMove = function (e) {
	              var eventObj = UiTreeHelper.eventObj(e),
	                prev,
	                next,
	                leftElmPos,
	                topElmPos,
	                top_scroll,
	                bottom_scroll,
	                scrollContainerElmRect,
	                target,
	                targetX,
	                targetY,
	                displayElm,
	                targetNode,
	                targetElm,
	                isEmpty,
	                scrollDownBy,
	                scrollUpBy,
	                targetOffset,
	                targetBefore,
	                moveWithinTree,
	                targetBeforeBuffer,
	                targetHeight,
	                targetChildElm,
	                targetChildHeight;
	
	              //If check ensures that drag element was created.
	              if (dragElm) {
	                e.preventDefault();
	
	                //Deselect anything (text, etc.) that was selected when move began.
	                if ($window.getSelection) {
	                  $window.getSelection().removeAllRanges();
	                } else if ($window.document.selection) {
	                  $window.document.selection.empty();
	                }
	
	                //Get top left positioning of element being moved.
	                leftElmPos = eventObj.pageX - pos.offsetX;
	                topElmPos = eventObj.pageY - pos.offsetY;
	
	                //dragElm can't leave the screen on the left.
	                if (leftElmPos < 0) {
	                  leftElmPos = 0;
	                }
	
	                //dragElm can't leave the screen on the top.
	                if (topElmPos < 0) {
	                  topElmPos = 0;
	                }
	
	                //dragElm can't leave the screen on the bottom.
	                if ((topElmPos + 10) > document_height) {
	                  topElmPos = document_height - 10;
	                }
	
	                //dragElm can't leave the screen on the right.
	                if ((leftElmPos + 10) > document_width) {
	                  leftElmPos = document_width - 10;
	                }
	
	                //Updating element being moved css.
	                dragElm.css({
	                  'left': leftElmPos + 'px',
	                  'top': topElmPos + 'px'
	                });
	
	                if (scrollContainerElm) {
	                  //Getting position to top and bottom of container element.
	                  scrollContainerElmRect = scrollContainerElm.getBoundingClientRect();
	                  top_scroll = scrollContainerElm.scrollTop;
	                  bottom_scroll = top_scroll + scrollContainerElm.clientHeight;
	
	                  //To scroll down if cursor y-position is greater than the bottom position of the container vertical scroll
	                  if (scrollContainerElmRect.bottom < eventObj.clientY && bottom_scroll < scrollContainerElm.scrollHeight) {
	                    scrollDownBy = Math.min(scrollContainerElm.scrollHeight - bottom_scroll, 10);
	                    scrollContainerElm.scrollTop += scrollDownBy;
	                  }
	
	                  //To scroll top if cursor y-position is less than the top position of the container vertical scroll
	                  if (scrollContainerElmRect.top > eventObj.clientY && top_scroll > 0) {
	                    scrollUpBy = Math.min(top_scroll, 10);
	                    scrollContainerElm.scrollTop -= scrollUpBy;
	                  }
	                } else {
	                  //Getting position to top and bottom of page.
	                  top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
	                  bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);
	
	                  //To scroll down if cursor y-position is greater than the bottom position of the window vertical scroll
	                  if (bottom_scroll < eventObj.pageY && bottom_scroll < document_height) {
	                    scrollDownBy = Math.min(document_height - bottom_scroll, 10);
	                    window.scrollBy(0, scrollDownBy);
	                  }
	
	                  //To scroll top if cursor y-position is less than the top position of the window vertical scroll
	                  if (top_scroll > eventObj.pageY) {
	                    scrollUpBy = Math.min(top_scroll, 10);
	                    window.scrollBy(0, -scrollUpBy);
	                  }
	                }
	
	                //Calling service to update position coordinates based on move.
	                UiTreeHelper.positionMoved(e, pos, firstMoving);
	                if (firstMoving) {
	                  firstMoving = false;
	                  return;
	                }
	
	                //Setting X point for elementFromPoint.
	                targetX = eventObj.pageX - ($window.pageXOffset ||
	                    $window.document.body.scrollLeft ||
	                    $window.document.documentElement.scrollLeft) -
	                    ($window.document.documentElement.clientLeft || 0);
	
	                targetY = eventObj.pageY - ($window.pageYOffset ||
	                    $window.document.body.scrollTop ||
	                    $window.document.documentElement.scrollTop) -
	                    ($window.document.documentElement.clientTop || 0);
	
	                //Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
	                // pick the drag element itself as the target. To prevent this, we hide the drag element while
	                // selecting the target.
	                if (angular.isFunction(dragElm.hide)) {
	                  dragElm.hide();
	                } else {
	                  displayElm = dragElm[0].style.display;
	                  dragElm[0].style.display = 'none';
	                }
	
	                //When using elementFromPoint() inside an iframe, you have to call
	                // elementFromPoint() twice to make sure IE8 returns the correct value
	                //MDN: The elementFromPoint() method of the Document interface returns the topmost element at the specified coordinates.
	                $window.document.elementFromPoint(targetX, targetY);
	
	                //Set target element (element in specified x/y coordinates).
	                targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));
	
	                //If the target element is a child element of a ui-tree-handle,
	                // use the containing handle element as target element
	                isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(targetElm);
	                if (isHandleChild) {
	                  targetElm = angular.element(isHandleChild);
	                }
	
	                if (angular.isFunction(dragElm.show)) {
	                  dragElm.show();
	                } else {
	                  dragElm[0].style.display = displayElm;
	                }
	
	                //Assigning scope to target you are moving draggable over.
	                if (UiTreeHelper.elementIsTree(targetElm)) {
	                  targetNode = targetElm.controller('uiTree').scope;
	                } else if (UiTreeHelper.elementIsTreeNodeHandle(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeHandle').scope;
	                } else if (UiTreeHelper.elementIsTreeNode(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNode').scope;
	                } else if (UiTreeHelper.elementIsTreeNodes(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNodes').scope;
	                } else if (UiTreeHelper.elementIsPlaceholder(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNodes').scope;
	                } else if (targetElm.controller('uiTreeNode')) {
	                  //Is a child element of a node.
	                  targetNode = targetElm.controller('uiTreeNode').scope;
	                }
	
	                moveWithinTree =  (targetNode && targetNode.$treeScope && targetNode.$treeScope.$id && targetNode.$treeScope.$id === treeOfOrigin);
	
	                /* (jcarter) Notes to developers:
	                 *  pos.dirAx is either 0 or 1
	                 *  1 means horizontal movement is happening
	                 *  0 means vertical movement is happening
	                 */
	
	                // Move nodes up and down in nesting level.
	                if (moveWithinTree && pos.dirAx) {
	
	                  // increase horizontal level if previous sibling exists and is not collapsed
	                  // example 1.1.1 becomes 1.2
	                  if (pos.distX > 0) {
	                    prev = dragInfo.prev();
	                    if (prev && !prev.collapsed
	                      && prev.accept(scope, prev.childNodesCount())) {
	                      prev.$childNodesScope.$element.append(placeElm);
	                      dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
	                    }
	                  }
	
	                  // decrease horizontal level
	                  // example 1.2 become 1.1.1
	                  if (pos.distX < 0) {
	                    // we can't decrease a level if an item preceeds the current one
	                    next = dragInfo.next();
	                    if (!next) {
	                      target = dragInfo.parentNode(); // As a sibling of it's parent node
	                      if (target
	                        && target.$parentNodesScope.accept(scope, target.index() + 1)) {
	                        target.$element.after(placeElm);
	                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
	                      }
	                    }
	                  }
	                } else { //Either in origin tree and moving horizontally OR you are moving within a new tree.
	
	                  //Check it's new position.
	                  isEmpty = false;
	
	                  //Exit if target is not a uiTree or child of one.
	                  if (!targetNode) {
	                    return;
	                  }
	
	                  //Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
	                  if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
	                    placeElm.css('display', '');
	                  }
	
	                  //Set whether target tree is empty or not.
	                  if (targetNode.$type === 'uiTree' && targetNode.dragEnabled) {
	                    isEmpty = targetNode.isEmpty();
	                  }
	
	                  //If target is a handle set new target to handle's node.
	                  if (targetNode.$type === 'uiTreeHandle') {
	                    targetNode = targetNode.$nodeScope;
	                  }
	
	                  //Check if it is a uiTreeNode or it's an empty tree.
	                  if (targetNode.$type !== 'uiTreeNode' && !isEmpty) {
	
	                    // Allow node to return to its original position if no longer hovering over target
	                    if (config.appendChildOnHover) {
	                      next = dragInfo.next();
	                      if (!next && unhover) {
	                        target = dragInfo.parentNode();
	                        target.$element.after(placeElm);
	                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
	                        unhover = false;
	                      }
	                    }
	                    return;
	                  }
	
	                  //If placeholder move from empty tree, reset it.
	                  if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
	                    treeScope.resetEmptyElement();
	                    treeScope = null;
	                  }
	
	                  //It's an empty tree
	                  if (isEmpty) {
	                    treeScope = targetNode;
	                    if (targetNode.$nodesScope.accept(scope, 0)) {
	                      targetNode.place(placeElm);
	                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
	                    }
	                  //Not empty and drag enabled.
	                  } else if (targetNode.dragEnabled()) {
	
	                      //Setting/Resetting data for exanding on hover.
	                      if (angular.isDefined(scope.expandTimeoutOn) && scope.expandTimeoutOn !== targetNode.id) {
	                        $timeout.cancel(scope.expandTimeout);
	                        delete scope.expandTimeout;
	                        delete scope.expandTimeoutOn;
	
	                        scope.$callbacks.expandTimeoutCancel();
	                      }
	
	                      //Determining if expansion is needed.
	                      if (targetNode.collapsed) {
	                        if (scope.expandOnHover === true || (angular.isNumber(scope.expandOnHover) && scope.expandOnHover === 0)) {
	                          targetNode.collapsed = false;
	                          targetNode.$treeScope.$callbacks.toggle(false, targetNode);
	                        } else if (scope.expandOnHover !== false && angular.isNumber(scope.expandOnHover) && scope.expandOnHover > 0) {
	
	                          //Triggering expansion.
	                          if (angular.isUndefined(scope.expandTimeoutOn)) {
	                            scope.expandTimeoutOn = targetNode.$id;
	
	                            scope.$callbacks.expandTimeoutStart();
	                            scope.expandTimeout = $timeout(function()
	                            {
	                              scope.$callbacks.expandTimeoutEnd();
	                              targetNode.collapsed = false;
	                              targetNode.$treeScope.$callbacks.toggle(false, targetNode);
	                            }, scope.expandOnHover);
	                          }
	                        }
	                      }
	
	                    //Get the element of ui-tree-node
	                    targetElm = targetNode.$element;
	                    targetOffset = UiTreeHelper.offset(targetElm);
	                    targetHeight = UiTreeHelper.height(targetElm);
	                    targetChildElm = targetNode.$childNodesScope ? targetNode.$childNodesScope.$element : null;
	                    targetChildHeight = targetChildElm ? UiTreeHelper.height(targetChildElm) : 0;
	                    targetHeight -= targetChildHeight;
	                    targetBeforeBuffer = config.appendChildOnHover ? targetHeight * 0.25 : UiTreeHelper.height(targetElm) / 2;
	                    targetBefore = eventObj.pageY < (targetOffset.top + targetBeforeBuffer);
	
	                    if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
	                      if (targetBefore) {
	                        targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
	                        dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
	                      } else {
	                        // Try to append as a child if dragged upwards onto targetNode
	                        if (config.appendChildOnHover && targetNode.accept(scope, targetNode.childNodesCount())) {
	                          targetNode.$childNodesScope.$element.prepend(placeElm);
	                          dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), 0);
	                          unhover = true;
	                        } else {
	                          targetElm.after(placeElm);
	                          dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
	                        }
	                      }
	
	                    //We have to check if it can add the dragging node as a child.
	                    } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) {
	                      targetNode.$childNodesScope.$element.append(placeElm);
	                      dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
	                    }
	                  }
	                }
	
	                //Triggering dragMove callback.
	                scope.$apply(function () {
	                  scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
	                });
	              }
	            };
	
	            dragEnd = function (e) {
	
	              var dragEventArgs = dragInfo.eventArgs(elements, pos);
	
	              e.preventDefault();
	
	              //TODO(jcarter): Is dragStart need to be unbound?
	              unbindDragMoveEvents();
	
	              //This cancel the collapse/expand login running.
	              $timeout.cancel(scope.expandTimeout);
	
	              scope.$treeScope.$apply(function () {
	                $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))
	
	                     //Promise resolved (or callback didn't return false)
	                    .then(function (allowDrop) {
	                      if (allowDrop !== false && scope.$$allowNodeDrop) {
	                        //Node drop accepted.
	                        dragInfo.apply();
	
	                        //Fire the dropped callback only if the move was successful.
	                        scope.$treeScope.$callbacks.dropped(dragEventArgs);
	                      } else {
	                        //Drop canceled - revert the node to its original position.
	                        bindDragStartEvents();
	                      }
	                    })
	
	                    //Promise rejected - revert the node to its original position.
	                    .catch(function () {
	                      bindDragStartEvents();
	                    })
	                    .finally(function () {
	
	                      //Replace placeholder with newly dropped element.
	                      hiddenPlaceElm.replaceWith(scope.$element);
	                      placeElm.remove();
	
	                      //Remove drag element if still in DOM.
	                      if (dragElm) {
	                        dragElm.remove();
	                        dragElm = null;
	                      }
	
	                      //Fire dragStope callback.
	                      scope.$treeScope.$callbacks.dragStop(dragEventArgs);
	                      scope.$$allowNodeDrop = false;
	                      dragInfo = null;
	
	                      //Restore cursor in Opera 12.16 and IE
	                      var oldCur = document.body.getAttribute('ui-tree-cursor');
	                      if (oldCur !== null) {
	                        $document.find('body').css({'cursor': oldCur});
	                        document.body.removeAttribute('ui-tree-cursor');
	                      }
	                    });
	              });
	            };
	
	            dragStartEvent = function (e) {
	              if (scope.dragEnabled()) {
	                dragStart(e);
	              }
	            };
	
	            dragMoveEvent = function (e) {
	              dragMove(e);
	            };
	
	            dragEndEvent = function (e) {
	              scope.$$allowNodeDrop = true;
	              dragEnd(e);
	            };
	
	            dragCancelEvent = function (e) {
	              dragEnd(e);
	            };
	
	            dragDelay = (function () {
	              var to;
	
	              return {
	                exec: function (fn, ms) {
	                  if (!ms) {
	                    ms = 0;
	                  }
	                  this.cancel();
	                  to = $timeout(fn, ms);
	                },
	                cancel: function () {
	                  $timeout.cancel(to);
	                }
	              };
	            })();
	
	            keydownHandler = function (e) {
	              if (e.keyCode === 27) {
	                dragEndEvent(e);
	              }
	            };
	
	            /**
	             * Binds the mouse/touch events to enable drag start for this node.
	             */
	            //This is outside of bindDragMoveEvents because of the potential for a delay setting.
	            bindDragStartEvents = function () {
	              element.bind('touchstart mousedown', function (e) {
	                //Don't call drag delay if no delay was specified.
	                if (scope.dragDelay > 0) {
	                  dragDelay.exec(function () {
	                    dragStartEvent(e);
	                  }, scope.dragDelay);
	                } else {
	                  dragStartEvent(e);
	                }
	              });
	              element.bind('touchend touchcancel mouseup', function () {
	                if (scope.dragDelay > 0) {
	                  dragDelay.cancel();
	                }
	              });
	            };
	            bindDragStartEvents();
	
	            /**
	             * Binds mouse/touch events that handle moving/dropping this dragged node
	             */
	            bindDragMoveEvents = function () {
	              angular.element($document).bind('touchend', dragEndEvent);
	              angular.element($document).bind('touchcancel', dragEndEvent);
	              angular.element($document).bind('touchmove', dragMoveEvent);
	              angular.element($document).bind('mouseup', dragEndEvent);
	              angular.element($document).bind('mousemove', dragMoveEvent);
	              angular.element($document).bind('mouseleave', dragCancelEvent);
	              angular.element($document).bind('keydown', keydownHandler);
	            };
	
	            /**
	             * Unbinds mouse/touch events that handle moving/dropping this dragged node.
	             */
	            unbindDragMoveEvents = function () {
	              angular.element($document).unbind('touchend', dragEndEvent);
	              angular.element($document).unbind('touchcancel', dragEndEvent);
	              angular.element($document).unbind('touchmove', dragMoveEvent);
	              angular.element($document).unbind('mouseup', dragEndEvent);
	              angular.element($document).unbind('mousemove', dragMoveEvent);
	              angular.element($document).unbind('mouseleave', dragCancelEvent);
	              angular.element($document).unbind('keydown', keydownHandler);
	            };
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTreeNodes', ['treeConfig', '$window',
	      function (treeConfig) {
	        return {
	          require: ['ngModel', '?^uiTreeNode', '^uiTree'],
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeNodesController',
	          link: function (scope, element, attrs, controllersArr) {
	
	            var config = {},
	                ngModel = controllersArr[0],
	                treeNodeCtrl = controllersArr[1],
	                treeCtrl = controllersArr[2];
	
	            angular.extend(config, treeConfig);
	            if (config.nodesClass) {
	              element.addClass(config.nodesClass);
	            }
	
	            if (treeNodeCtrl) {
	              treeNodeCtrl.scope.$childNodesScope = scope;
	              scope.$nodeScope = treeNodeCtrl.scope;
	            } else {
	              // find the root nodes if there is no parent node and have a parent ui-tree
	              treeCtrl.scope.$nodesScope = scope;
	            }
	            scope.$treeScope = treeCtrl.scope;
	
	            if (ngModel) {
	              ngModel.$render = function () {
	                scope.$modelValue = ngModel.$modelValue;
	              };
	            }
	
	            scope.$watch(function () {
	              return attrs.maxDepth;
	            }, function (val) {
	              if ((typeof val) == 'number') {
	                scope.maxDepth = val;
	              }
	            });
	
	            scope.$watch(function () {
	              return attrs.nodropEnabled;
	            }, function (newVal) {
	              if ((typeof newVal) != 'undefined') {
	                scope.nodropEnabled = true;
	              }
	            }, true);
	
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	  /**
	   * @ngdoc service
	   * @name ui.tree.service:UiTreeHelper
	   * @requires ng.$document
	   * @requires ng.$window
	   *
	   * @description
	   * angular-ui-tree.
	   */
	    .factory('UiTreeHelper', ['$document', '$window', 'treeConfig',
	      function ($document, $window, treeConfig) {
	        return {
	
	          /**
	           * A hashtable used to storage data of nodes
	           * @type {Object}
	           */
	          nodesData: {},
	
	          setNodeAttribute: function (scope, attrName, val) {
	            if (!scope.$modelValue) {
	              return null;
	            }
	            var data = this.nodesData[scope.$modelValue.$$hashKey];
	            if (!data) {
	              data = {};
	              this.nodesData[scope.$modelValue.$$hashKey] = data;
	            }
	            data[attrName] = val;
	          },
	
	          getNodeAttribute: function (scope, attrName) {
	            if (!scope.$modelValue) {
	              return null;
	            }
	            var data = this.nodesData[scope.$modelValue.$$hashKey];
	            if (data) {
	              return data[attrName];
	            }
	            return null;
	          },
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.tree.service:$nodrag
	           * @param  {Object} targetElm angular element
	           * @return {Bool} check if the node can be dragged.
	           */
	          nodrag: function (targetElm) {
	            if (typeof targetElm.attr('data-nodrag') != 'undefined') {
	              return targetElm.attr('data-nodrag') !== 'false';
	            }
	            return false;
	          },
	
	          /**
	           * Get the event object for touches.
	           * 
	           * @param  {MouseEvent|TouchEvent} e MouseEvent or TouchEvent that kicked off dragX method.
	           * @return {MouseEvent|TouchEvent} Object returned as original event object.
	           */
	          eventObj: function (e) {
	            var obj = e;
	            if (e.targetTouches !== undefined) {
	              //Set obj equal to the first Touch object in the TouchList.
	              obj = e.targetTouches.item(0);
	            //Logic to set obj to original TouchEvent.
	            } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
	              obj = e.originalEvent.targetTouches.item(0);
	            }
	            return obj;
	          },
	
	          /**
	           * Generate object used to store data about node being moved.
	           * 
	           * {angular.$scope} node Scope of the node that is being moved.
	           */
	          dragInfo: function (node) {
	            return {
	              source: node,
	              sourceInfo: {
	                cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
	                nodeScope: node,
	                index: node.index(),
	                nodesScope: node.$parentNodesScope
	              },
	              index: node.index(),
	
	              //Slice(0) just duplicates an array.
	              siblings: node.siblings().slice(0),
	              parent: node.$parentNodesScope,
	
	              //Reset parent to source parent.
	              resetParent: function() {
	                this.parent = node.$parentNodesScope;
	              },
	
	              //Move the node to a new position, determining where the node will be inserted to when dropped happens here.
	              moveTo: function (parent, siblings, index) {
	                this.parent = parent;
	
	                //Duplicate siblings array.
	                this.siblings = siblings.slice(0);
	
	                //If source node is in the target nodes
	                var i = this.siblings.indexOf(this.source);
	                if (i > -1) {
	                  this.siblings.splice(i, 1);
	                  if (this.source.index() < index) {
	                    index--;
	                  }
	                }
	
	                this.siblings.splice(index, 0, this.source);
	                this.index = index;
	              },
	
	              //Get parent nodes nodeScope.
	              parentNode: function () {
	                return this.parent.$nodeScope;
	              },
	
	              //Get previous sibling node.
	              prev: function () {
	                if (this.index > 0) {
	                  return this.siblings[this.index - 1];
	                }
	
	                return null;
	              },
	
	              //Get next sibling node.
	              next: function () {
	                if (this.index < this.siblings.length - 1) {
	                  return this.siblings[this.index + 1];
	                }
	
	                return null;
	              },
	
	              //Return what cloneEnabled is set to on uiTree.
	              isClone: function () {
	                return this.source.$treeScope.cloneEnabled === true;
	              },
	
	              //Returns a copy of node passed in.
	              clonedNode: function (node) {
	                return angular.copy(node);
	              },
	
	              //Returns true if parent or index have changed (move happened within any uiTree).
	              isDirty: function () {
	                return this.source.$parentNodesScope != this.parent ||
	                  this.source.index() != this.index;
	              },
	
	              //Return whether node has a new parent (set on moveTo method).
	              isForeign: function () {
	                return this.source.$treeScope !== this.parent.$treeScope;
	              },
	
	              //Sets arguments passed to user callbacks.
	              eventArgs: function (elements, pos) {
	                return {
	                  source: this.sourceInfo,
	                  dest: {
	                    index: this.index,
	                    nodesScope: this.parent
	                  },
	                  elements: elements,
	                  pos: pos
	                };
	              },
	
	              //Method that actually manipulates the node being moved.
	              apply: function () {
	
	                var nodeData = this.source.$modelValue;
	
	                //Nodrop enabled on tree or parent
	                if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
	                  return;
	                }
	
	                //Node was dropped in the same place - do nothing.
	                if (!this.isDirty()) {
	                  return;
	                }
	
	                //CloneEnabled and cross-tree so copy and do not remove from source.
	                if (this.isClone() && this.isForeign()) {
	                  this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
	                //Any other case, remove and reinsert.
	                } else {
	                  this.source.remove();
	                  this.parent.insertNode(this.index, nodeData);
	                }
	              }
	            };
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#height
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the height of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {String} Height
	           */
	          height: function (element) {
	            return element.prop('scrollHeight');
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#width
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the width of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {String} Width
	           */
	          width: function (element) {
	            return element.prop('scrollWidth');
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#offset
	           * @methodOf ui.nestedSortable.service:UiTreeHelper
	           *
	           * @description
	           * Get the offset values of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {Object} Object with properties width, height, top and left
	           */
	          offset: function (element) {
	            var boundingClientRect = element[0].getBoundingClientRect();
	
	            return {
	              width: element.prop('offsetWidth'),
	              height: element.prop('offsetHeight'),
	              top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
	              left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
	            };
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#positionStarted
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the start position of the target element according to the provided event properties.
	           *
	           * @param {Object} e Event
	           * @param {Object} target Target element
	           * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
	           */
	          positionStarted: function (e, target) {
	            var pos = {},
	            pageX = e.pageX,
	            pageY = e.pageY;
	
	            //Check to set correct data for TouchEvents
	            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
	              pageX = e.originalEvent.touches[0].pageX;
	              pageY = e.originalEvent.touches[0].pageY;
	            }
	            pos.offsetX = pageX - this.offset(target).left;
	            pos.offsetY = pageY - this.offset(target).top;
	            pos.startX = pos.lastX = pageX;
	            pos.startY = pos.lastY = pageY;
	            pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
	            pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
	            return pos;
	          },
	
	          positionMoved: function (e, pos, firstMoving) {
	
	            var pageX = e.pageX,
	            pageY = e.pageY,
	            newAx;
	
	            //If there are multiple touch points, choose one to use as X and Y.
	            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
	              pageX = e.originalEvent.touches[0].pageX;
	              pageY = e.originalEvent.touches[0].pageY;
	            }
	
	            //Mouse position last event.
	            pos.lastX = pos.nowX;
	            pos.lastY = pos.nowY;
	
	            //Mouse position this event.
	            pos.nowX = pageX;
	            pos.nowY = pageY;
	
	            //Distance mouse moved between events.          
	            pos.distX = pos.nowX - pos.lastX;
	            pos.distY = pos.nowY - pos.lastY;
	
	            //Direction mouse was moving.           
	            pos.lastDirX = pos.dirX;
	            pos.lastDirY = pos.dirY;
	
	            //Direction mouse is now moving (on both axis).          
	            pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
	            pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;
	
	            //Axis mouse is now moving on.         
	            newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;
	
	            //Do nothing on first move.
	            if (firstMoving) {
	              pos.dirAx = newAx;
	              pos.moving = true;
	              return;
	            }
	
	            //Calc distance moved on this axis (and direction).          
	            if (pos.dirAx !== newAx) {
	              pos.distAxX = 0;
	              pos.distAxY = 0;
	            } else {
	              pos.distAxX += Math.abs(pos.distX);
	              if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
	                pos.distAxX = 0;
	              }
	              pos.distAxY += Math.abs(pos.distY);
	              if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
	                pos.distAxY = 0;
	              }
	            }
	            pos.dirAx = newAx;
	          },
	
	          elementIsTreeNode: function (element) {
	            return typeof element.attr('ui-tree-node') !== 'undefined';
	          },
	
	          elementIsTreeNodeHandle: function (element) {
	            return typeof element.attr('ui-tree-handle') !== 'undefined';
	          },
	          elementIsTree: function (element) {
	            return typeof element.attr('ui-tree') !== 'undefined';
	          },
	          elementIsTreeNodes: function (element) {
	            return typeof element.attr('ui-tree-nodes') !== 'undefined';
	          },
	          elementIsPlaceholder: function (element) {
	            return element.hasClass(treeConfig.placeholderClass);
	          },
	          elementContainsTreeNodeHandler: function (element) {
	            return element[0].querySelectorAll('[ui-tree-handle]').length >= 1;
	          },
	          treeNodeHandlerContainerOfElement: function (element) {
	            return findFirstParentElementWithAttribute('ui-tree-handle', element[0]);
	          }
	        };
	      }
	    ]);
	
	  // TODO: optimize this loop
	  //(Jcarter): Suggest adding a parent element property on uiTree, then all these bubble
	  // to <html> can trigger to stop when they reach the parent.
	  function findFirstParentElementWithAttribute(attributeName, childObj) {
	    //Undefined if the mouse leaves the browser window
	    if (childObj === undefined) {
	      return null;
	    }
	    var testObj = childObj.parentNode,
	    count = 1,
	    //Check for setAttribute due to exception thrown by Firefox when a node is dragged outside the browser window
	    res = (typeof testObj.setAttribute === 'function' && testObj.hasAttribute(attributeName)) ? testObj : null;
	    while (testObj && typeof testObj.setAttribute === 'function' && !testObj.hasAttribute(attributeName)) {
	      testObj = testObj.parentNode;
	      res = testObj;
	      //Stop once we reach top of page.
	      if (testObj === document.documentElement) {
	        res = null;
	        break;
	      }
	      count++;
	    }
	    return res;
	  }
	
	})();

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.8/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        "Can't copy! Making copies of Window or Scope instances is not supported.");
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        //Support: IE10
	        if (!source.slice) {
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2 && t1 == 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) == o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() == o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, "events");
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.5.8',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 5,
	  dot: 8,
	  codeName: 'arbitrary-fallbacks'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || function(arg) {
	  // jshint bitwise: false
	  return !!(this.compareDocumentPosition(arg) & 16);
	  // jshint bitwise: true
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^\(]+?)=>/;
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Support: Edge 12-13 only
	      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	      return typeof func === 'function'
	        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner(); // jshint ignore:line
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            toAdd    && jqLiteAddClass(elm, toAdd);
	            toRemove && jqLiteRemoveClass(elm, toRemove);
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        passed ? callback() : waitForTick(callback);
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      /* jshint newcap: false */
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default translusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = directive.restrict || 'EA';
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = "<span " + attrName + ">";
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          /* jshint -W021 */
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	          /* jshint +W021 */
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (controller.identifier && bindings) {
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          } else {
	            controller.bindingInfo = {};
	          }
	
	          var controllerResult = controller();
	          if (controllerResult !== controller.instance) {
	            // If the controller constructor has a return value, overwrite the instance
	            // from setupControllers
	            controller.instance = controllerResult;
	            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              "Controller '{0}', required by directive '{1}', can't be found!",
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller == '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              if (!directive.$$bindings) {
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue) return;
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, parentGet.literal);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, "", text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    //TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = function() {
	  this.$get = ['$window', function($window) {
	    var callbacks = $window.angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(haystack, needle) {
	  return haystack.lastIndexOf(needle, 0) === 0;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute url is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    /*jshint bitwise: false*/
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	    /*jshint bitwise: true*/
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensivelly, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        $scope.$$childHead && cleanUpScope($scope.$$childHead);
	        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @param {string=} anyPropertyKey The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	  if (i == (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceeding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	/* jshint maxlen:220 */
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	/* jshint maxlen:200 */
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // jshint bitwise: false
	          if (selector === true || (scope.$index & 1) === selector) {
	          // jshint bitwise: true
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (interpolateValueFn) {
	      // The value attribute is interpolated
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        var interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        var interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*************************
	 * Croppie
	 * Copyright 2016
	 * Foliotek
	 * Version: 2.4.1
	 *************************/
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	        // CommonJS
	        factory(exports);
	    } else {
	        // Browser globals
	        factory((root.commonJsStrict = {}));
	    }
	}(this, function (exports) {
	
	    /* Polyfills */
	    if (typeof Promise !== 'function') {
	        /*! promise-polyfill 3.1.0 */
	        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"==typeof a?a:null,this.onRejected="function"==typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"==typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"==typeof g||"function"==typeof g)){var h=g.then;if("function"==typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"==typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!=typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
	    }
	
	    if ( typeof window.CustomEvent !== "function" ) {
	        (function(){
	            function CustomEvent ( event, params ) {
	                params = params || { bubbles: false, cancelable: false, detail: undefined };
	                var evt = document.createEvent( 'CustomEvent' );
	                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	                return evt;
	            }
	            CustomEvent.prototype = window.Event.prototype;
	            window.CustomEvent = CustomEvent;
	        }());
	    }
	
	    if (!HTMLCanvasElement.prototype.toBlob) {
	        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	            value: function (callback, type, quality) {
	                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
	                len = binStr.length,
	                arr = new Uint8Array(len);
	
	                for (var i=0; i<len; i++ ) {
	                    arr[i] = binStr.charCodeAt(i);
	                }
	
	                callback( new Blob( [arr], {type: type || 'image/png'} ) );
	            }
	        });
	    }
	    /* End Polyfills */
	
	    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
	        emptyStyles = document.createElement('div').style,
	        CSS_TRANS_ORG,
	        CSS_TRANSFORM,
	        CSS_USERSELECT;
	
	    function vendorPrefix(prop) {
	        if (prop in emptyStyles) {
	            return prop;
	        }
	
	        var capProp = prop[0].toUpperCase() + prop.slice(1),
	            i = cssPrefixes.length;
	
	        while (i--) {
	            prop = cssPrefixes[i] + capProp;
	            if (prop in emptyStyles) {
	                return prop;
	            }
	        }
	    }
	
	    CSS_TRANSFORM = vendorPrefix('transform');
	    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
	    CSS_USERSELECT = vendorPrefix('userSelect');
	
	    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
	    function deepExtend(destination, source) {
	        destination = destination || {};
	        for (var property in source) {
	            if (source[property] && source[property].constructor && source[property].constructor === Object) {
	                destination[property] = destination[property] || {};
	                deepExtend(destination[property], source[property]);
	            } else {
	                destination[property] = source[property];
	            }
	        }
	        return destination;
	    }
	
	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            var later = function () {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    }
	
	    function dispatchChange(element) {
	        if ("createEvent" in document) {
	            var evt = document.createEvent("HTMLEvents");
	            evt.initEvent("change", false, true);
	            element.dispatchEvent(evt);
	        }
	        else {
	            element.fireEvent("onchange");
	        }
	    }
	
	    //http://jsperf.com/vanilla-css
	    function css(el, styles, val) {
	        if (typeof (styles) === 'string') {
	            var tmp = styles;
	            styles = {};
	            styles[tmp] = val;
	        }
	
	        for (var prop in styles) {
	            el.style[prop] = styles[prop];
	        }
	    }
	
	    function addClass(el, c) {
	        if (el.classList) {
	            el.classList.add(c);
	        }
	        else {
	            el.className += ' ' + c;
	        }
	    }
	
	    function removeClass(el, c) {
	        if (el.classList) {
	            el.classList.remove(c);
	        }
	        else {
	            el.className = el.className.replace(c, '');
	        }
	    }
	
	    function num(v) {
	        return parseInt(v, 10);
	    }
	
	    /* Utilities */
	    function loadImage(src, imageEl) {
	        var img = imageEl || new Image();
	        img.style.opacity = 0;
	
	        return new Promise(function (resolve) {
	            if (img.src === src) {
	                // If image source hasn't changed resolve immediately
	                resolve(img);
	            } 
	            else {
	                img.removeAttribute('crossOrigin');
	                if (src.match(/^https?:\/\/|^\/\//)) {
	                    img.setAttribute('crossOrigin', 'anonymous');
	                }
	                img.onload = function () {
	                    setTimeout(function () {
	                        resolve(img);
	                    }, 1);
	                }
	                img.src = src;
	            }
	        });
	    }
	
	
	    /* CSS Transform Prototype */
	    var TRANSLATE_OPTS = {
	        'translate3d': {
	            suffix: ', 0px'
	        },
	        'translate': {
	            suffix: ''
	        }
	    };
	    var Transform = function (x, y, scale) {
	        this.x = parseFloat(x);
	        this.y = parseFloat(y);
	        this.scale = parseFloat(scale);
	    };
	
	    Transform.parse = function (v) {
	        if (v.style) {
	            return Transform.parse(v.style[CSS_TRANSFORM]);
	        }
	        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
	            return Transform.fromMatrix(v);
	        }
	        else {
	            return Transform.fromString(v);
	        }
	    };
	
	    Transform.fromMatrix = function (v) {
	        var vals = v.substring(7).split(',');
	        if (!vals.length || v === 'none') {
	            vals = [1, 0, 0, 1, 0, 0];
	        }
	
	        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
	    };
	
	    Transform.fromString = function (v) {
	        var values = v.split(') '),
	            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
	            scale = values.length > 1 ? values[1].substring(6) : 1,
	            x = translate.length > 1 ? translate[0] : 0,
	            y = translate.length > 1 ? translate[1] : 0;
	
	        return new Transform(x, y, scale);
	    };
	
	    Transform.prototype.toString = function () {
	        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
	        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
	    };
	
	    var TransformOrigin = function (el) {
	        if (!el || !el.style[CSS_TRANS_ORG]) {
	            this.x = 0;
	            this.y = 0;
	            return;
	        }
	        var css = el.style[CSS_TRANS_ORG].split(' ');
	        this.x = parseFloat(css[0]);
	        this.y = parseFloat(css[1]);
	    };
	
	    TransformOrigin.prototype.toString = function () {
	        return this.x + 'px ' + this.y + 'px';
	    };
	
	    function getExifOrientation (img, cb) {
	        if (!window.EXIF) {
	            cb(0);
	        }
	
	        EXIF.getData(img, function () {
	            var orientation = EXIF.getTag(this, 'Orientation');
	            cb(orientation);
	        });
	    }
	
	    function drawCanvas(canvas, img, orientation) {
	        var width = img.width,
	            height = img.height,
	            ctx = canvas.getContext('2d');
	
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        ctx.save();
	        switch (orientation) {
	          case 2:
	             ctx.translate(width, 0);
	             ctx.scale(-1, 1);
	             break;
	
	          case 3:
	              ctx.translate(width, height);
	              ctx.rotate(180*Math.PI/180);
	              break;
	
	          case 4:
	              ctx.translate(0, height);
	              ctx.scale(1, -1);
	              break;
	
	          case 5:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.scale(1, -1);
	              break;
	
	          case 6:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.translate(0, -height);
	              break;
	
	          case 7:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(-90*Math.PI/180);
	              ctx.translate(-width, height);
	              ctx.scale(1, -1);
	              break;
	
	          case 8:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.translate(0, width);
	              ctx.rotate(-90*Math.PI/180);
	              break;
	        }
	        ctx.drawImage(img, 0,0, width, height);
	        ctx.restore();
	    }
	
	    /* Private Methods */
	    function _create() {
	        var self = this,
	            contClass = 'croppie-container',
	            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
	            boundary, img, viewport, overlay, canvas, bw, bh;
	
	        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
	        // Properties on class
	        self.data = {};
	        self.elements = {};
	
	        // Generating Markup
	        boundary = self.elements.boundary = document.createElement('div');
	        viewport = self.elements.viewport = document.createElement('div');
	        img = self.elements.img = document.createElement('img');
	        overlay = self.elements.overlay = document.createElement('div');
	
	        if (self.options.useCanvas) {
	            self.elements.canvas = document.createElement('canvas');
	            self.elements.preview = self.elements.canvas;
	        }
	        else {
	            self.elements.preview = self.elements.img;
	        }
	
	        addClass(boundary, 'cr-boundary');
	        bw = self.options.boundary.width;
	        bh = self.options.boundary.height;
	        css(boundary, {
	            width: (bw + (isNaN(bw) ? '' : 'px')),
	            height: (bh + (isNaN(bh) ? '' : 'px'))
	        });
	
	        addClass(viewport, 'cr-viewport');
	        if (customViewportClass) {
	            addClass(viewport, customViewportClass);
	        }
	        css(viewport, {
	            width: self.options.viewport.width + 'px',
	            height: self.options.viewport.height + 'px'
	        });
	        viewport.setAttribute('tabindex', 0);
	
	        addClass(self.elements.preview, 'cr-image');
	        addClass(overlay, 'cr-overlay');
	
	        self.element.appendChild(boundary);
	        boundary.appendChild(self.elements.preview);
	        boundary.appendChild(viewport);
	        boundary.appendChild(overlay);
	
	        addClass(self.element, contClass);
	        if (self.options.customClass) {
	            addClass(self.element, self.options.customClass);
	        }
	
	        _initDraggable.call(this);
	
	        if (self.options.enableZoom) {
	            _initializeZoom.call(self);
	        }
	
	        // if (self.options.enableOrientation) {
	        //     _initRotationControls.call(self);
	        // }
	    }
	
	    // function _initRotationControls () {
	    //     var self = this,
	    //         wrap, btnLeft, btnRight, iLeft, iRight;
	
	    //     wrap = document.createElement('div');
	    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
	    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');
	
	    //     wrap.appendChild(btnLeft);
	    //     wrap.appendChild(btnRight);
	
	    //     iLeft = document.createElement('i');
	    //     iRight = document.createElement('i');
	    //     btnLeft.appendChild(iLeft);
	    //     btnRight.appendChild(iRight);
	
	    //     addClass(wrap, 'cr-rotate-controls');
	    //     addClass(btnLeft, 'cr-rotate-l');
	    //     addClass(btnRight, 'cr-rotate-r');
	
	    //     self.elements.boundary.appendChild(wrap);
	
	    //     btnLeft.addEventListener('click', function () {
	    //         self.rotate(-90);
	    //     });
	    //     btnRight.addEventListener('click', function () {
	    //         self.rotate(90);
	    //     });
	    // }
	
	    function _hasExif() {
	        return this.options.enableExif && window.EXIF;
	    }
	
	    function _setZoomerVal(v) {
	        if (this.options.enableZoom) {
	            var z = this.elements.zoomer,
	                val = fix(v, 4);
	
	            z.value = Math.max(z.min, Math.min(z.max, val));
	        }
	    }
	
	    function _initializeZoom() {
	        var self = this,
	            wrap = self.elements.zoomerWrap = document.createElement('div'),
	            zoomer = self.elements.zoomer = document.createElement('input');
	
	        addClass(wrap, 'cr-slider-wrap');
	        addClass(zoomer, 'cr-slider');
	        zoomer.type = 'range';
	        zoomer.step = '0.0001';
	        zoomer.value = 1;
	        zoomer.style.display = self.options.showZoomer ? '' : 'none';
	
	        self.element.appendChild(wrap);
	        wrap.appendChild(zoomer);
	
	        self._currentZoom = 1;
	
	        function change() {
	            _onZoom.call(self, {
	                value: parseFloat(zoomer.value),
	                origin: new TransformOrigin(self.elements.preview),
	                viewportRect: self.elements.viewport.getBoundingClientRect(),
	                transform: Transform.parse(self.elements.preview)
	            });
	        }
	
	        function scroll(ev) {
	            var delta, targetZoom;
	
	            if (ev.wheelDelta) {
	                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
	            } else if (ev.deltaY) {
	                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
	            } else if (ev.detail) {
	                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
	            } else {
	                delta = 0;
	            }
	
	            targetZoom = self._currentZoom + (delta * self._currentZoom);
	
	            ev.preventDefault();
	            _setZoomerVal.call(self, targetZoom);
	            change.call(self);
	        }
	
	        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
	        self.elements.zoomer.addEventListener('change', change);
	
	        if (self.options.mouseWheelZoom) {
	            self.elements.boundary.addEventListener('mousewheel', scroll);
	            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
	        }
	    }
	
	    function _onZoom(ui) {
	        var self = this,
	            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
	            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
	            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview),
	            transCss = {};
	
	        function applyCss() {
	            var transCss = {};
	            transCss[CSS_TRANSFORM] = transform.toString();
	            transCss[CSS_TRANS_ORG] = origin.toString();
	            css(self.elements.preview, transCss);
	        }
	
	        self._currentZoom = ui ? ui.value : self._currentZoom;
	        transform.scale = self._currentZoom;
	        applyCss();
	
	
	        if (self.options.enforceBoundary) {
	            var boundaries = _getVirtualBoundaries.call(self, vpRect),
	                transBoundaries = boundaries.translate,
	                oBoundaries = boundaries.origin;
	
	            if (transform.x >= transBoundaries.maxX) {
	                origin.x = oBoundaries.minX;
	                transform.x = transBoundaries.maxX;
	            }
	
	            if (transform.x <= transBoundaries.minX) {
	                origin.x = oBoundaries.maxX;
	                transform.x = transBoundaries.minX;
	            }
	
	            if (transform.y >= transBoundaries.maxY) {
	                origin.y = oBoundaries.minY;
	                transform.y = transBoundaries.maxY;
	            }
	
	            if (transform.y <= transBoundaries.minY) {
	                origin.y = oBoundaries.maxY;
	                transform.y = transBoundaries.minY;
	            }
	        }
	        applyCss();
	        _debouncedOverlay.call(self);
	        _triggerUpdate.call(self);
	    }
	
	    function _getVirtualBoundaries(viewport) {
	        var self = this,
	            scale = self._currentZoom,
	            vpWidth = viewport.width,
	            vpHeight = viewport.height,
	            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
	            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
	            imgRect = self.elements.preview.getBoundingClientRect(),
	            curImgWidth = imgRect.width,
	            curImgHeight = imgRect.height,
	            halfWidth = vpWidth / 2,
	            halfHeight = vpHeight / 2;
	
	        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
	        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));
	
	        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
	        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));
	
	        var originMinX = (1 / scale) * halfWidth;
	        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;
	
	        var originMinY = (1 / scale) * halfHeight;
	        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;
	
	        return {
	            translate: {
	                maxX: maxX,
	                minX: minX,
	                maxY: maxY,
	                minY: minY
	            },
	            origin: {
	                maxX: originMaxX,
	                minX: originMinX,
	                maxY: originMaxY,
	                minY: originMinY
	            }
	        };
	    }
	
	    function _updateCenterPoint() {
	        var self = this,
	            scale = self._currentZoom,
	            data = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
	            pc = new TransformOrigin(self.elements.preview),
	            top = (vpData.top - data.top) + (vpData.height / 2),
	            left = (vpData.left - data.left) + (vpData.width / 2),
	            center = {},
	            adj = {};
	
	        center.y = top / scale;
	        center.x = left / scale;
	
	        adj.y = (center.y - pc.y) * (1 - scale);
	        adj.x = (center.x - pc.x) * (1 - scale);
	
	        transform.x -= adj.x;
	        transform.y -= adj.y;
	
	        var newCss = {};
	        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
	        newCss[CSS_TRANSFORM] = transform.toString();
	        css(self.elements.preview, newCss);
	    }
	
	    function _initDraggable() {
	        var self = this,
	            isDragging = false,
	            originalX,
	            originalY,
	            originalDistance,
	            vpRect,
	            transform;
	
	        function assignTransformCoordinates(deltaX, deltaY) {
	            var imgRect = self.elements.preview.getBoundingClientRect(),
	                top = transform.y + deltaY,
	                left = transform.x + deltaX;
	
	            if (self.options.enforceBoundary) {
	                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
	                    transform.y = top;
	                }
	
	                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
	                    transform.x = left;
	                }
	            }
	            else {
	                transform.y = top;
	                transform.x = left;
	            }
	        }
	
	        function keyDown(ev) {
	            var LEFT_ARROW  = 37,
	                UP_ARROW    = 38,
	                RIGHT_ARROW = 39,
	                DOWN_ARROW  = 40;
	
	            if (ev.shiftKey && (ev.keyCode == UP_ARROW || ev.keyCode == DOWN_ARROW)) {
	                var zoom = 0.0;
	                if (ev.keyCode == UP_ARROW) {
	                    zoom = parseFloat(self.elements.zoomer.value, 10) + parseFloat(self.elements.zoomer.step, 10)
	                }
	                else {
	                    zoom = parseFloat(self.elements.zoomer.value, 10) - parseFloat(self.elements.zoomer.step, 10)
	                }
	                self.setZoom(zoom);
	            }
	            else if (ev.keyCode >= 37 && ev.keyCode <= 40) {
	                ev.preventDefault();
	                var movement = parseKeyDown(ev.keyCode);
	
	                transform = Transform.parse(self.elements.preview);
	                document.body.style[CSS_USERSELECT] = 'none';
	                vpRect = self.elements.viewport.getBoundingClientRect();
	                keyMove(movement);
	            };
	
	            function parseKeyDown(key) {
	                switch (key) {
	                    case LEFT_ARROW:
	                        return [1, 0];
	                    case UP_ARROW:
	                        return [0, 1];
	                    case RIGHT_ARROW:
	                        return [-1, 0];
	                    case DOWN_ARROW:
	                        return [0, -1];
	                };
	            };
	        }
	
	        function keyMove(movement) {
	            var deltaX = movement[0],
	                deltaY = movement[1],
	                newCss = {};
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        function mouseDown(ev) {
	            ev.preventDefault();
	            if (isDragging) return;
	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }
	
	            transform = Transform.parse(self.elements.preview);
	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	            vpRect = self.elements.viewport.getBoundingClientRect();
	        }
	
	        function mouseMove(ev) {
	            ev.preventDefault();
	            var pageX = ev.pageX,
	                pageY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }
	
	            var deltaX = pageX - originalX,
	                deltaY = pageY - originalY,
	                newCss = {};
	
	            if (ev.type == 'touchmove') {
	                if (ev.touches.length > 1) {
	                    var touch1 = ev.touches[0];
	                    var touch2 = ev.touches[1];
	                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));
	
	                    if (!originalDistance) {
	                        originalDistance = dist / self._currentZoom;
	                    }
	
	                    var scale = dist / originalDistance;
	
	                    _setZoomerVal.call(self, scale);
	                    dispatchChange(self.elements.zoomer);
	                    return;
	                }
	            }
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }
	
	        function mouseUp() {
	            isDragging = false;
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        self.elements.overlay.addEventListener('mousedown', mouseDown);
	        self.elements.viewport.addEventListener('keydown', keyDown);
	        self.elements.overlay.addEventListener('touchstart', mouseDown);
	    }
	
	    function _updateOverlay() {
	        var self = this,
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            imgData = self.elements.preview.getBoundingClientRect();
	
	        css(self.elements.overlay, {
	            width: imgData.width + 'px',
	            height: imgData.height + 'px',
	            top: (imgData.top - boundRect.top) + 'px',
	            left: (imgData.left - boundRect.left) + 'px'
	        });
	    }
	    var _debouncedOverlay = debounce(_updateOverlay, 500);
	
	    function _triggerUpdate() {
	        var self = this,
	            data = self.get(),
	            ev;
	
	        if (!_isVisible.call(self)) {
	            return;
	        }
	
	        self.options.update.call(self, data);
	        if (self.$ && typeof Prototype == 'undefined') {
	            self.$(self.element).trigger('update', data); 
	        }
	        else {
	            var ev;
	            if (window.CustomEvent) {
	                ev = new CustomEvent('update', { detail: data });
	            } else {
	                ev = document.createEvent('CustomEvent');
	                ev.initCustomEvent('update', true, true, data);
	            }
	
	            self.element.dispatchEvent(ev);
	        }
	    }
	
	    function _isVisible() {
	        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
	    }
	
	    function _updatePropertiesFromImage() {
	        var self = this,
	            minZoom = 0,
	            maxZoom = 1.5,
	            initialZoom = 1,
	            cssReset = {},
	            img = self.elements.preview,
	            zoomer = self.elements.zoomer,
	            transformReset = new Transform(0, 0, initialZoom),
	            originReset = new TransformOrigin(),
	            isVisible = _isVisible.call(self),
	            imgData,
	            vpData,
	            boundaryData,
	            minW,
	            minH;
	
	        if (!isVisible || self.data.bound) {
	            // if the croppie isn't visible or it doesn't need binding
	            return;
	        }
	
	        self.data.bound = true;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        cssReset[CSS_TRANS_ORG] = originReset.toString();
	        cssReset['opacity'] = 1;
	        css(img, cssReset);
	
	        imgData = img.getBoundingClientRect();
	        vpData = self.elements.viewport.getBoundingClientRect();
	        boundaryData = self.elements.boundary.getBoundingClientRect();
	        self._originalImageWidth = imgData.width;
	        self._originalImageHeight = imgData.height;
	
	        if (self.options.enableZoom) {
	            if (self.options.enforceBoundary) {
	                minW = vpData.width / imgData.width;
	                minH = vpData.height / imgData.height;
	                minZoom = Math.max(minW, minH);
	            }
	
	            if (minZoom >= maxZoom) {
	                maxZoom = minZoom + 1;
	            }
	
	            zoomer.min = fix(minZoom, 4);
	            zoomer.max = fix(maxZoom, 4);
	            var defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
	            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
	            _setZoomerVal.call(self, initialZoom);
	            dispatchChange(zoomer);
	        }
	        else {
	            self._currentZoom = initialZoom;
	        }
	
	        transformReset.scale = self._currentZoom;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        css(img, cssReset);
	
	        if (self.data.points.length) {
	            _bindPoints.call(self, self.data.points);
	        }
	        else {
	            _centerImage.call(self);
	        }
	
	        _updateCenterPoint.call(self);
	        _updateOverlay.call(self);
	    }
	
	    function _bindPoints(points) {
	        if (points.length != 4) {
	            throw "Croppie - Invalid number of points supplied: " + points;
	        }
	        var self = this,
	            pointsWidth = points[2] - points[0],
	            // pointsHeight = points[3] - points[1],
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            vpOffset = {
	                left: vpData.left - boundRect.left,
	                top: vpData.top - boundRect.top
	            },
	            scale = vpData.width / pointsWidth,
	            originTop = points[1],
	            originLeft = points[0],
	            transformTop = (-1 * points[1]) + vpOffset.top,
	            transformLeft = (-1 * points[0]) + vpOffset.left,
	            newCss = {};
	
	        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
	        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
	        css(self.elements.preview, newCss);
	
	        _setZoomerVal.call(self, scale);
	        self._currentZoom = scale;
	    }
	
	    function _centerImage() {
	        var self = this,
	            imgDim = self.elements.preview.getBoundingClientRect(),
	            vpDim = self.elements.viewport.getBoundingClientRect(),
	            boundDim = self.elements.boundary.getBoundingClientRect(),
	            vpLeft = vpDim.left - boundDim.left,
	            vpTop = vpDim.top - boundDim.top,
	            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
	            h = vpTop - ((imgDim.height - vpDim.height) / 2),
	            transform = new Transform(w, h, self._currentZoom);
	
	        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
	    }
	
	    function _transferImageToCanvas(customOrientation) {
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            ctx = canvas.getContext('2d'),
	            exif = _hasExif.call(self),
	            customOrientation = self.options.enableOrientation && customOrientation;
	
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        if (exif) {
	            getExifOrientation(img, function (orientation) {
	                drawCanvas(canvas, img, num(orientation, 10));
	                if (customOrientation) {
	                    drawCanvas(canvas, img, customOrientation);
	                }
	            });
	        } else if (customOrientation) {
	            drawCanvas(canvas, img, customOrientation);
	        }
	    }
	
	    function _getCanvas(data) {
	        var self = this,
	            points = data.points,
	            left = num(points[0]),
	            top = num(points[1]),
	            right = num(points[2]),
	            bottom = num(points[3]),
	            width = right-left,
	            height = bottom-top,
	            circle = data.circle,
	            canvas = document.createElement('canvas'),
	            ctx = canvas.getContext('2d'),
	            outWidth = width,
	            outHeight = height,
	            startX = 0,
	            startY = 0,
	            canvasWidth = outWidth,
	            canvasHeight = outHeight,
	            customDimensions = (data.outputWidth && data.outputHeight),
	            outputRatio = 1;
	
	        if (customDimensions) {
	            canvasWidth = data.outputWidth;
	            canvasHeight = data.outputHeight;
	            outputRatio = canvasWidth / outWidth;
	        }
	
	        canvas.width = canvasWidth;
	        canvas.height = canvasHeight;
	
	        if (data.backgroundColor) {
	            ctx.fillStyle = data.backgroundColor;
	            ctx.fillRect(0, 0, outWidth, outHeight);
	        }
	        // start fixing data to send to draw image for enforceBoundary: false
	        if (left < 0) {
	            startX = Math.abs(left);
	            left = 0;
	        }
	        if (top < 0) {
	            startY = Math.abs(top);
	            top = 0;
	        }
	        if (right > self._originalImageWidth) {
	            width = self._originalImageWidth - left;
	            outWidth = width;
	        }
	        if (bottom > self._originalImageHeight) {
	            height = self._originalImageHeight - top;
	            outHeight = height;
	        }
	
	        if (outputRatio !== 1) {
	            startX *= outputRatio;
	            startY *= outputRatio;
	            outWidth *= outputRatio;
	            outHeight *= outputRatio;
	        }
	
	        ctx.drawImage(this.elements.preview, left, top, width, height, startX, startY, outWidth, outHeight);
	        if (circle) {
	            ctx.fillStyle = '#fff';
	            ctx.globalCompositeOperation = 'destination-in';
	            ctx.beginPath();
	            ctx.arc(outWidth / 2, outHeight / 2, outWidth / 2, 0, Math.PI * 2, true);
	            ctx.closePath();
	            ctx.fill();
	        }
	        return canvas;
	    }
	
	    function _getHtmlResult(data) {
	        var points = data.points,
	            div = document.createElement('div'),
	            img = document.createElement('img'),
	            width = points[2] - points[0],
	            height = points[3] - points[1];
	
	        addClass(div, 'croppie-result');
	        div.appendChild(img);
	        css(img, {
	            left: (-1 * points[0]) + 'px',
	            top: (-1 * points[1]) + 'px'
	        });
	        img.src = data.url;
	        css(div, {
	            width: width + 'px',
	            height: height + 'px'
	        });
	
	        return div;
	    }
	
	    function _getBase64Result(data) {
	        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
	    }
	
	    function _getBlobResult(data) {
	        var self = this;
	        return new Promise(function (resolve, reject) {
	            _getCanvas.call(self, data).toBlob(function (blob) {
	                resolve(blob);
	            }, data.format, data.quality);
	        });
	    }
	
	    function _bind(options, cb) {
	        var self = this,
	            url,
	            points = [],
	            zoom = null;
	
	        if (typeof (options) === 'string') {
	            url = options;
	            options = {};
	        }
	        else if (Array.isArray(options)) {
	            points = options.slice();
	        }
	        else if (typeof (options) == 'undefined' && self.data.url) { //refreshing
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            return null;
	        }
	        else {
	            url = options.url;
	            points = options.points || [];
	            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
	        }
	
	        self.data.bound = false;
	        self.data.url = url || self.data.url;
	        self.data.boundZoom = zoom;
	
	        return loadImage(url, self.elements.img).then(function (img) {
	            if(!points.length){
	                var iWidth = img.naturalWidth;
	                var iHeight = img.naturalHeight;
	
	                var rect = self.elements.viewport.getBoundingClientRect();
	                var aspectRatio = rect.width / rect.height;
	                var width, height;
	
	                if( iWidth / iHeight > aspectRatio){
	                    height = iHeight;
	                    width = height * aspectRatio;
	                }else{
	                    width = iWidth;
	                    height = width / aspectRatio;
	                }
	
	                var x0 = (iWidth - width) / 2;
	                var y0 = (iHeight - height) / 2;
	                var x1 = x0 + width;
	                var y1 = y0 + height;
	
	                self.data.points = [x0, y0, x1, y1];
	            } else {
	                if(self.options.relative){
	                    // de-relative points
	                    points = [
	                        points[0] * img.naturalWidth / 100,
	                        points[1] * img.naturalHeight / 100,
	                        points[2] * img.naturalWidth / 100,
	                        points[3] * img.naturalHeight / 100
	                    ];
	                }
	
	                self.data.points = points.map(function (p) {
	                    return parseFloat(p);
	                });
	            }
	
	            if (self.options.useCanvas) {
	                self.elements.img.exifdata = null;
	                _transferImageToCanvas.call(self, options.orientation || 1);
	            }
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            cb && cb();
	        });
	    }
	
	    function fix(v, decimalPoints) {
	        return parseFloat(v).toFixed(decimalPoints || 0);
	    }
	
	    function _get() {
	        var self = this,
	            imgData = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            x1 = vpData.left - imgData.left,
	            y1 = vpData.top - imgData.top,
	            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2,
	            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
	            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
	            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
	            scale = self._currentZoom;
	
	        if (scale === Infinity || isNaN(scale)) {
	            scale = 1;
	        }
	
	        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
	        x1 = Math.max(max, x1 / scale);
	        y1 = Math.max(max, y1 / scale);
	        x2 = Math.max(max, x2 / scale);
	        y2 = Math.max(max, y2 / scale);
	
	        return {
	            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
	            zoom: scale
	        };
	    }
	
	    var RESULT_DEFAULTS = {
	            type: 'canvas',
	            format: 'png',
	            quality: 1
	        },
	        RESULT_FORMATS = ['jpeg', 'webp', 'png'];
	
	    function _result(options) {
	        var self = this,
	            data = _get.call(self),
	            opts = deepExtend(RESULT_DEFAULTS, deepExtend({}, options)),
	            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
	            size = opts.size,
	            format = opts.format,
	            quality = opts.quality,
	            backgroundColor = opts.backgroundColor,
	            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
	            vpRect = self.elements.viewport.getBoundingClientRect(),
	            ratio = vpRect.width / vpRect.height,
	            prom;
	
	        if (size === 'viewport') {
	            data.outputWidth = vpRect.width;
	            data.outputHeight = vpRect.height;
	        } else if (typeof size === 'object') {
	            if (size.width && size.height) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.height;
	            } else if (size.width) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.width / ratio;
	            } else if (size.height) {
	                data.outputWidth = size.height * ratio;
	                data.outputHeight = size.height;
	            }
	        }
	
	        if (RESULT_FORMATS.indexOf(format) > -1) {
	            data.format = 'image/' + format;
	            data.quality = quality;
	        }
	
	        data.circle = circle;
	        data.url = self.data.url;
	        data.backgroundColor = backgroundColor;
	
	        prom = new Promise(function (resolve, reject) {
	            switch(resultType.toLowerCase())
	            {
	                case 'rawcanvas':
	                    resolve(_getCanvas.call(self, data));
	                    break;
	                case 'canvas':
	                case 'base64':
	                    resolve(_getBase64Result.call(self, data));
	                    break;
	                case 'blob':
	                    _getBlobResult.call(self, data).then(resolve);
	                    break;
	                default:
	                    resolve(_getHtmlResult.call(self, data));
	                    break;
	            }
	        });
	        return prom;
	    }
	
	    function _refresh() {
	        _updatePropertiesFromImage.call(this);
	    }
	
	    function _rotate(deg) {
	        if (!this.options.useCanvas) {
	            throw 'Croppie: Cannot rotate without enableOrientation';
	        }
	
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            copy = document.createElement('canvas'),
	            ornt = 1;
	
	        copy.width = canvas.width;
	        copy.height = canvas.height;
	        var ctx = copy.getContext('2d');
	        ctx.drawImage(canvas, 0, 0);
	
	        if (deg === 90 || deg === -270) ornt = 6;
	        if (deg === -90 || deg === 270) ornt = 8;
	        if (deg === 180 || deg === -180) ornt = 3;
	
	        drawCanvas(canvas, copy, ornt);
	        _onZoom.call(self);
	    }
	
	    function _destroy() {
	        var self = this;
	        self.element.removeChild(self.elements.boundary);
	        removeClass(self.element, 'croppie-container');
	        if (self.options.enableZoom) {
	            self.element.removeChild(self.elements.zoomerWrap);
	        }
	        delete self.elements;
	    }
	
	    if (window.jQuery) {
	        var $ = window.jQuery;
	        $.fn.croppie = function (opts) {
	            var ot = typeof opts;
	
	            if (ot === 'string') {
	                var args = Array.prototype.slice.call(arguments, 1);
	                var singleInst = $(this).data('croppie');
	
	                if (opts === 'get') {
	                    return singleInst.get();
	                }
	                else if (opts === 'result') {
	                    return singleInst.result.apply(singleInst, args);
	                }
	                else if (opts === 'bind') {
	                    return singleInst.bind.apply(singleInst, args);
	                }
	
	                return this.each(function () {
	                    var i = $(this).data('croppie');
	                    if (!i) return;
	
	                    var method = i[opts];
	                    if ($.isFunction(method)) {
	                        method.apply(i, args);
	                        if (opts === 'destroy') {
	                            $(this).removeData('croppie');
	                        }
	                    }
	                    else {
	                        throw 'Croppie ' + opts + ' method not found';
	                    }
	                });
	            }
	            else {
	                return this.each(function () {
	                    var i = new Croppie(this, opts);
	                    i.$ = $;
	                    $(this).data('croppie', i);
	                });
	            }
	        };
	    }
	
	    function Croppie(element, opts) {
	        this.element = element;
	        this.options = deepExtend(deepExtend({}, Croppie.defaults), opts);
	
	        if (this.element.tagName.toLowerCase() === 'img') {
	            var origImage = this.element;
	            addClass(origImage, 'cr-original-image');
	            var replacementDiv = document.createElement('div');
	            this.element.parentNode.appendChild(replacementDiv);
	            replacementDiv.appendChild(origImage);
	            this.element = replacementDiv;
	            this.options.url = this.options.url || origImage.src;
	        }
	
	        _create.call(this);
	        if (this.options.url) {
	            var bindOpts = {
	                url: this.options.url,
	                points: this.options.points
	            };
	            delete this.options['url'];
	            delete this.options['points'];
	            _bind.call(this, bindOpts);
	        }
	    }
	
	    Croppie.defaults = {
	        viewport: {
	            width: 100,
	            height: 100,
	            type: 'square'
	        },
	        boundary: { },
	        orientationControls: {
	            enabled: true,
	            leftClass: '',
	            rightClass: ''
	        },
	        customClass: '',
	        showZoomer: true,
	        enableZoom: true,
	        mouseWheelZoom: true,
	        enableExif: false,
	        enforceBoundary: true,
	        enableOrientation: false,
	        update: function () { }
	    };
	
	    Croppie.globals = {
	        translate: 'translate3d'
	    };
	
	    deepExtend(Croppie.prototype, {
	        bind: function (options, cb) {
	            return _bind.call(this, options, cb);
	        },
	        get: function () {
	            var data = _get.call(this);
	            var points = data.points;
	            if (this.options.relative) {
	                //
	                // Relativize points
	                //
	                points[0] /= this.elements.img.naturalWidth / 100;
	                points[1] /= this.elements.img.naturalHeight / 100;
	                points[2] /= this.elements.img.naturalWidth / 100;
	                points[3] /= this.elements.img.naturalHeight / 100;
	            }
	            return data;
	        },
	        result: function (type) {
	            return _result.call(this, type);
	        },
	        refresh: function () {
	            return _refresh.call(this);
	        },
	        setZoom: function (v) {
	            _setZoomerVal.call(this, v);
	            dispatchChange(this.elements.zoomer);
	        },
	        rotate: function (deg) {
	            _rotate.call(this, deg);
	        },
	        destroy: function () {
	            return _destroy.call(this);
	        }
	    });
	
	    exports.Croppie = window.Croppie = Croppie;
	
	    if (typeof module === 'object' && !!module.exports) {
	        module.exports = Croppie;
	    }
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).setImmediate))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Roboto;src:url(" + __webpack_require__(377) + ");src:url(" + __webpack_require__(374) + ");src:url(" + __webpack_require__(375) + ");src:url(" + __webpack_require__(376) + ")}/*!\r\n *  Font Awesome 4.6.3 by @davegandy - http://fontawesome.io - @fontawesome\r\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\r\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(339) + ");src:url(" + __webpack_require__(338) + "?#iefix&v=4.6.3) format(\"embedded-opentype\"),url(" + __webpack_require__(342) + ") format(\"woff2\"),url(" + __webpack_require__(343) + ") format(\"woff\"),url(" + __webpack_require__(341) + ") format(\"truetype\"),url(" + __webpack_require__(340) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14286em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14286em;width:2.14286em;top:.14286em;text-align:center}.fa-li.fa-lg{left:-1.85714em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}/*!\r\n * animate.css -http://daneden.me/animate\r\n * Version - 3.5.0\r\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\r\n *\r\n * Copyright (c) 2016 Daniel Eden\r\n */.animated{animation-duration:1s;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{animation-duration:.75s}@keyframes bounce{0%,20%,53%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{transform:translate3d(0,-30px,0)}40%,43%,70%{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{animation-name:bounce;transform-origin:center bottom}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{animation-name:flash}.pulse{animation-name:pulse}@keyframes rubberBand{0%{transform:scaleX(1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}to{transform:scaleX(1)}}.rubberBand{animation-name:rubberBand}@keyframes shake{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes headShake{0%{transform:translateX(0)}6.5%{transform:translateX(-6px) rotateY(-9deg)}18.5%{transform:translateX(5px) rotateY(7deg)}31.5%{transform:translateX(-3px) rotateY(-5deg)}43.5%{transform:translateX(2px) rotateY(3deg)}50%{transform:translateX(0)}}.headShake{animation-timing-function:ease-in-out;animation-name:headShake}@keyframes swing{20%{transform:rotate(15deg)}40%{transform:rotate(-10deg)}60%{transform:rotate(5deg)}80%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}.swing{transform-origin:top center;animation-name:swing}@keyframes tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{transform:scaleX(1)}}.tada{animation-name:tada}@keyframes wobble{0%{transform:none}15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}to{transform:none}}.wobble{animation-name:wobble}@keyframes jello{0%,11.1%,to{transform:none}22.2%{transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{transform:skewX(6.25deg) skewY(6.25deg)}44.4%{transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{transform:skewX(.39063deg) skewY(.39063deg)}88.8%{transform:skewX(-.19531deg) skewY(-.19531deg)}}.jello{animation-name:jello;transform-origin:center}@keyframes bounceIn{0%,20%,40%,60%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-name:bounceIn}@keyframes bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}.bounceInLeft{animation-name:bounceInLeft}@keyframes bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}.bounceInRight{animation-name:bounceInRight}@keyframes bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}.bounceInUp{animation-name:bounceInUp}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-name:bounceOut}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{animation-name:bounceOutDown}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{animation-name:bounceOutLeft}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{animation-name:bounceOutRight}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}to{opacity:1;transform:none}}.fadeInDownBig{animation-name:fadeInDownBig}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}to{opacity:1;transform:none}}.fadeInLeftBig{animation-name:fadeInLeftBig}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}to{opacity:1;transform:none}}.fadeInRightBig{animation-name:fadeInRightBig}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}to{opacity:1;transform:none}}.fadeInUpBig{animation-name:fadeInUpBig}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{animation-name:fadeOutDownBig}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{animation-name:fadeOutLeftBig}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{animation-name:fadeOutRightBig}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{animation-name:fadeOutUpBig}@keyframes flip{0%{transform:perspective(400px) rotateY(-1turn)}0%,40%{animation-timing-function:ease-out}40%{transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95)}to{transform:perspective(400px);animation-timing-function:ease-in}}.animated.flip{backface-visibility:visible;animation-name:flip}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{animation-timing-function:ease-in}40%{transform:perspective(400px) rotateX(-20deg)}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.flipInX{backface-visibility:visible!important;animation-name:flipInX}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{animation-timing-function:ease-in}40%{transform:perspective(400px) rotateY(-20deg)}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{animation-name:flipOutX;backface-visibility:visible!important}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{backface-visibility:visible!important;animation-name:flipOutY}@keyframes lightSpeedIn{0%{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg)}60%,80%{opacity:1}80%{transform:skewX(-5deg)}to{transform:none;opacity:1}}.lightSpeedIn{animation-name:lightSpeedIn;animation-timing-function:ease-out}@keyframes lightSpeedOut{0%{opacity:1}to{transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{animation-name:lightSpeedOut;animation-timing-function:ease-in}@keyframes rotateIn{0%{transform-origin:center;transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;transform:none;opacity:1}}.rotateIn{animation-name:rotateIn}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInDownLeft{animation-name:rotateInDownLeft}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInDownRight{animation-name:rotateInDownRight}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInUpLeft{animation-name:rotateInUpLeft}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInUpRight{animation-name:rotateInUpRight}@keyframes rotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;transform:rotate(200deg);opacity:0}}.rotateOut{animation-name:rotateOut}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{animation-name:rotateOutDownLeft}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{animation-name:rotateOutDownRight}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{animation-name:rotateOutUpLeft}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;transform:rotate(90deg);opacity:0}}.rotateOutUpRight{animation-name:rotateOutUpRight}@keyframes hinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;animation-timing-function:ease-in-out}20%,60%{transform:rotate(80deg);transform-origin:top left}40%,80%{transform:rotate(60deg);transform-origin:top left;animation-timing-function:ease-in-out;opacity:1}to{transform:translate3d(0,700px,0);opacity:0}}.hinge{animation-name:hinge}@keyframes rollIn{0%{opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;transform:none}}.rollIn{animation-name:rollIn}@keyframes rollOut{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{animation-name:rollOut}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{animation-name:zoomIn}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{animation-name:zoomInDown}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{animation-name:zoomInLeft}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{animation-name:zoomInRight}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{animation-name:zoomInUp}@keyframes zoomOut{0%{opacity:1}50%{transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}.zoomOut{animation-name:zoomOut}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{animation-name:zoomOutDown}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{animation-name:zoomOutLeft}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{animation-name:zoomOutRight}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{animation-name:zoomOutUp}@keyframes slideInDown{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInDown{animation-name:slideInDown}@keyframes slideInLeft{0%{transform:translate3d(-100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInLeft{animation-name:slideInLeft}@keyframes slideInRight{0%{transform:translate3d(100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInRight{animation-name:slideInRight}@keyframes slideInUp{0%{transform:translate3d(0,100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInUp{animation-name:slideInUp}@keyframes slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,100%,0)}}.slideOutDown{animation-name:slideOutDown}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-100%,0,0)}}.slideOutLeft{animation-name:slideOutLeft}@keyframes slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(100%,0,0)}}.slideOutRight{animation-name:slideOutRight}@keyframes slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-100%,0)}}.slideOutUp{animation-name:slideOutUp}body{background:#fff;font-family:Roboto,sans-serif!important;box-sizing:border-box;position:relative;height:100%}.container{padding:0;clear:both;width:100%;float:left;margin-left:0;margin-right:0}.ui-view-container{height:100%;position:relative}.ui-view-container>div{height:100%}[ui-view].ng-enter,[ui-view].ng-leave{position:absolute;left:0;right:0;transition:all .25s ease-in-out}[ui-view].ng-enter{opacity:0;transform:scale3d(.96,.96,.96)}[ui-view].ng-enter-active{opacity:1;transform:scaleX(1)}[ui-view].ng-leave{opacity:1;transform:translateZ(0)}[ui-view].ng-leave-active{opacity:0}/*!\r\n * Bootstrap v3.3.7 (http://getbootstrap.com)\r\n * Copyright 2011-2016 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\r\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(142) + ");src:url(" + __webpack_require__(142) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(337) + ") format(\"woff2\"),url(" + __webpack_require__(336) + ") format(\"woff\"),url(" + __webpack_require__(335) + ") format(\"truetype\"),url(" + __webpack_require__(334) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.33333%}.col-xs-2{width:16.66667%}.col-xs-3{width:25%}.col-xs-4{width:33.33333%}.col-xs-5{width:41.66667%}.col-xs-6{width:50%}.col-xs-7{width:58.33333%}.col-xs-8{width:66.66667%}.col-xs-9{width:75%}.col-xs-10{width:83.33333%}.col-xs-11{width:91.66667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.33333%}.col-xs-pull-2{right:16.66667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.33333%}.col-xs-pull-5{right:41.66667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.33333%}.col-xs-pull-8{right:66.66667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.33333%}.col-xs-pull-11{right:91.66667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.33333%}.col-xs-push-2{left:16.66667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.33333%}.col-xs-push-5{left:41.66667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.33333%}.col-xs-push-8{left:66.66667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.33333%}.col-xs-push-11{left:91.66667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3{width:25%}.col-sm-4{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.33333%}.col-sm-pull-2{right:16.66667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.33333%}.col-sm-pull-5{right:41.66667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.33333%}.col-sm-pull-8{right:66.66667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.33333%}.col-sm-pull-11{right:91.66667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.33333%}.col-md-2{width:16.66667%}.col-md-3{width:25%}.col-md-4{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6{width:50%}.col-md-7{width:58.33333%}.col-md-8{width:66.66667%}.col-md-9{width:75%}.col-md-10{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.33333%}.col-md-pull-2{right:16.66667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.33333%}.col-md-pull-5{right:41.66667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.33333%}.col-md-pull-8{right:66.66667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.33333%}.col-md-pull-11{right:91.66667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.33333%}.col-lg-2{width:16.66667%}.col-lg-3{width:25%}.col-lg-4{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6{width:50%}.col-lg-7{width:58.33333%}.col-lg-8{width:66.66667%}.col-lg-9{width:75%}.col-lg-10{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.33333%}.col-lg-pull-2{right:16.66667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.33333%}.col-lg-pull-5{right:41.66667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.33333%}.col-lg-pull-8{right:66.66667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.33333%}.col-lg-pull-11{right:91.66667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input.btn[type=date],.input-group-sm>.input-group-btn>input.btn[type=datetime-local],.input-group-sm>.input-group-btn>input.btn[type=month],.input-group-sm>.input-group-btn>input.btn[type=time],.input-group-sm>input.form-control[type=date],.input-group-sm>input.form-control[type=datetime-local],.input-group-sm>input.form-control[type=month],.input-group-sm>input.form-control[type=time],.input-group-sm>input.input-group-addon[type=date],.input-group-sm>input.input-group-addon[type=datetime-local],.input-group-sm>input.input-group-addon[type=month],.input-group-sm>input.input-group-addon[type=time],.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input.btn[type=date],.input-group-lg>.input-group-btn>input.btn[type=datetime-local],.input-group-lg>.input-group-btn>input.btn[type=month],.input-group-lg>.input-group-btn>input.btn[type=time],.input-group-lg>input.form-control[type=date],.input-group-lg>input.form-control[type=datetime-local],.input-group-lg>input.form-control[type=month],.input-group-lg>input.form-control[type=time],.input-group-lg>input.input-group-addon[type=date],.input-group-lg>input.input-group-addon[type=datetime-local],.input-group-lg>input.input-group-addon[type=month],.input-group-lg>input.input-group-addon[type=time],.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select.btn[multiple],.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select.form-control[multiple],.input-group-sm>select.input-group-addon[multiple],.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select.btn[multiple],.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select.form-control[multiple],.input-group-lg>select.input-group-addon[multiple],.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.33333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#eee;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#d5d5d5;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#d5d5d5;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#c3c3c3;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#eee;border-color:#ccc}.btn-default .badge{color:#eee;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#ff8d00;border-color:#e67f00}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#cc7100;border-color:#663800}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7100;border-color:#a85d00}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#a85d00;border-color:#663800}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#ff8d00;border-color:#e67f00}.btn-warning .badge{color:#ff8d00;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger-inverse,.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-danger-inverse{border-color:#fff}.btn-danger-inverse.focus,.btn-danger-inverse:focus{color:#d9534f;background-color:#e6e6e6;border-color:#bfbfbf}.btn-danger-inverse.active,.btn-danger-inverse:active,.btn-danger-inverse:hover,.open>.btn-danger-inverse.dropdown-toggle{color:#d9534f;background-color:#e6e6e6;border-color:#e0e0e0}.btn-danger-inverse.active.focus,.btn-danger-inverse.active:focus,.btn-danger-inverse.active:hover,.btn-danger-inverse:active.focus,.btn-danger-inverse:active:focus,.btn-danger-inverse:active:hover,.open>.btn-danger-inverse.dropdown-toggle.focus,.open>.btn-danger-inverse.dropdown-toggle:focus,.open>.btn-danger-inverse.dropdown-toggle:hover{color:#d9534f;background-color:#d4d4d4;border-color:#bfbfbf}.btn-danger-inverse.active,.btn-danger-inverse:active,.open>.btn-danger-inverse.dropdown-toggle{background-image:none}.btn-danger-inverse.disabled.focus,.btn-danger-inverse.disabled:focus,.btn-danger-inverse.disabled:hover,.btn-danger-inverse[disabled].focus,.btn-danger-inverse[disabled]:focus,.btn-danger-inverse[disabled]:hover,fieldset[disabled] .btn-danger-inverse.focus,fieldset[disabled] .btn-danger-inverse:focus,fieldset[disabled] .btn-danger-inverse:hover{background-color:#fff;border-color:#fff}.btn-danger-inverse .badge{color:#fff;background-color:#d9534f}.btn-dark{color:#fff;background-color:#323331;border-color:#323331}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#191918;border-color:#000}.btn-dark.active,.btn-dark:active,.btn-dark:hover,.open>.btn-dark.dropdown-toggle{color:#fff;background-color:#191918;border-color:#131413}.btn-dark.active.focus,.btn-dark.active:focus,.btn-dark.active:hover,.btn-dark:active.focus,.btn-dark:active:focus,.btn-dark:active:hover,.open>.btn-dark.dropdown-toggle.focus,.open>.btn-dark.dropdown-toggle:focus,.open>.btn-dark.dropdown-toggle:hover{color:#fff;background-color:#070707;border-color:#000}.btn-dark.active,.btn-dark:active,.open>.btn-dark.dropdown-toggle{background-image:none}.btn-dark.disabled.focus,.btn-dark.disabled:focus,.btn-dark.disabled:hover,.btn-dark[disabled].focus,.btn-dark[disabled]:focus,.btn-dark[disabled]:hover,fieldset[disabled] .btn-dark.focus,fieldset[disabled] .btn-dark:focus,fieldset[disabled] .btn-dark:hover{background-color:#323331;border-color:#323331}.btn-dark .badge{color:#323331;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:1200px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:0;padding-left:0;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch;width:auto;border-top:0;box-shadow:none}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px;float:left;margin:0}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}.realtime-block .navbar-nav>li>a{padding:10px 5px}@media (min-width:600px){.realtime-block .navbar-nav>li>a{padding:10px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.33333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#ff8d00}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#cc7100}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.alert{padding:15px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}@font-face{font-family:Open Sans;font-weight:300;font-style:normal;src:url(" + __webpack_require__(149) + ");src:url(" + __webpack_require__(149) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(364) + ") format(\"woff\"),url(" + __webpack_require__(363) + ") format(\"truetype\"),url(" + __webpack_require__(362) + "#OpenSansLight) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:300;font-style:italic;src:url(" + __webpack_require__(148) + ");src:url(" + __webpack_require__(148) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(361) + ") format(\"woff\"),url(" + __webpack_require__(360) + ") format(\"truetype\"),url(" + __webpack_require__(359) + "#OpenSansLightItalic) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:400;font-style:normal;src:url(" + __webpack_require__(150) + ");src:url(" + __webpack_require__(150) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(367) + ") format(\"woff\"),url(" + __webpack_require__(366) + ") format(\"truetype\"),url(" + __webpack_require__(365) + "#OpenSansRegular) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:400;font-style:italic;src:url(" + __webpack_require__(147) + ");src:url(" + __webpack_require__(147) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(358) + ") format(\"woff\"),url(" + __webpack_require__(357) + ") format(\"truetype\"),url(" + __webpack_require__(356) + "#OpenSansItalic) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:600;font-style:normal;src:url(" + __webpack_require__(152) + ");src:url(" + __webpack_require__(152) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(373) + ") format(\"woff\"),url(" + __webpack_require__(372) + ") format(\"truetype\"),url(" + __webpack_require__(371) + "#OpenSansSemibold) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:600;font-style:italic;src:url(" + __webpack_require__(151) + ");src:url(" + __webpack_require__(151) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(370) + ") format(\"woff\"),url(" + __webpack_require__(369) + ") format(\"truetype\"),url(" + __webpack_require__(368) + "#OpenSansSemiboldItalic) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:700;font-style:normal;src:url(" + __webpack_require__(144) + ");src:url(" + __webpack_require__(144) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(349) + ") format(\"woff\"),url(" + __webpack_require__(348) + ") format(\"truetype\"),url(" + __webpack_require__(347) + "#OpenSansBold) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:700;font-style:italic;src:url(" + __webpack_require__(143) + ");src:url(" + __webpack_require__(143) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(346) + ") format(\"woff\"),url(" + __webpack_require__(345) + ") format(\"truetype\"),url(" + __webpack_require__(344) + "#OpenSansBoldItalic) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:800;font-style:normal;src:url(" + __webpack_require__(146) + ");src:url(" + __webpack_require__(146) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(355) + ") format(\"woff\"),url(" + __webpack_require__(354) + ") format(\"truetype\"),url(" + __webpack_require__(353) + "#OpenSansExtrabold) format(\"svg\")}@font-face{font-family:Open Sans;font-weight:800;font-style:italic;src:url(" + __webpack_require__(145) + ");src:url(" + __webpack_require__(145) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(352) + ") format(\"woff\"),url(" + __webpack_require__(351) + ") format(\"truetype\"),url(" + __webpack_require__(350) + "#OpenSansExtraboldItalic) format(\"svg\")}@-ms-viewport{width:auto}body,html{height:100%}body{font-weight:300;overflow-x:hidden}th{font-weight:600}a{cursor:pointer;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,color .15s ease-in-out}.btn{transition:background-color .15s ease-in-out,border-color .15s ease-in-out}.form-control{transition:border-color .15s ease-in-out,background-color .15s ease-in-out}.widget-chart-simple .widget-body{padding-top:10px}.widget-chart-simple .chart-value{font-size:24px}.widget-chart-simple .chart{margin-top:20px}.jqstooltip{box-sizing:content-box}.widget-chart-changes .chart{margin:-15px -20px 0;padding:15px 0 0}.widget-chart-changes .chart-title{margin:20px 0 0}.widget-chart-changes .chart-value,.widget-chart-changes .chart-value-change{padding:0 20px}.widget-chart-changes .chart-value{margin-bottom:0;font-weight:700;font-size:21px;line-height:1;color:#fff}.widget-chart-changes .chart-value-change{color:hsla(0,0%,100%,.7);font-size:85%}.widget-chart-stats-simple>header h1,.widget-chart-stats-simple>header h2,.widget-chart-stats-simple>header h3,.widget-chart-stats-simple>header h4,.widget-chart-stats-simple>header h5,.widget-chart-stats-simple>header h6{margin-bottom:5px}.widget-chart-stats-simple .chart{height:200px;margin:10px -20px -15px}.widget-chart-stats-simple .chart>.chart-inner{height:100%}.widget-big-chart .chart{height:200px}.chart-stats{border-top:1px solid #eee}.progress-stats .description,.progress-stats .name{margin-bottom:2px}.progress-stats .status{margin-top:15px}@media (max-width:1199px){.progress-stats .description+.progress{margin-bottom:0}}.list-group-sortable>.list-group-item{margin-bottom:0;border-radius:4px}.list-group-sortable>.list-group-item+.list-group-item{margin-top:10px}.list-group-sortable>.list-group-item-placeholder{border:1px dashed #777;background-color:#ddd}.list-group-sortable:last-of-type>.list-group-item:last-child{border-bottom:1px solid #ddd}.icon-list{margin-top:20px}.icon-list-item{height:32px;font-size:14px;line-height:32px}.icon-list-item>a{color:#333;text-decoration:none}.icon-list-item .fa,.icon-list-item .glyphicon{width:32px;margin-right:10px}.icon-list-item:hover .fa,.icon-list-item:hover .glyphicon{font-size:28px}.icon-list-item:hover .fa{vertical-align:-5px}.icon-list-item:hover .glyphicon{vertical-align:-6px}.widget-invoice{padding:40px}.widget-invoice>header .invoice-logo{max-height:50px}.widget-invoice>header+.widget-body{margin-top:70px}.full-calendar{margin-top:10px}.calendar-controls .btn{font-size:13px}.calendar-external-events{margin-top:20px}.calendar-external-events .external-event{margin:10px 0;padding:6px;font-size:13px;cursor:pointer;border-radius:4px;background-color:#fff;border:1px solid #bbb}@media (min-width:1200px){.widget-calendar{margin-top:-100px}}.post-links{margin-bottom:0;font-size:12px;padding-left:0}.post-links:after{display:block;content:\"\";clear:both}.post-links>li{float:left;list-style:none}.post-links>li+li:before{color:#999;content:\"\\25CF\";padding:0 8px}.post-links>li>a{text-decoration:none;color:#777}.post-links>li>a:hover{color:#777}.post-links.no-separator>li+li{margin-left:12px}.post-links.no-separator>li+li:before{content:normal}.tags{padding-left:0;list-style:none}.tags:after{display:block;content:\"\";clear:both}.tags>li{float:left}.tags>li>a{padding:2px 8px;font-size:13px;border-radius:6px;border:1px solid #fff;color:inherit;text-decoration:none}.tags>li>a:hover{background-color:rgba(0,0,0,.1)}.tags>li>a .fa{font-size:8px;vertical-align:2px;margin-right:3px;opacity:.8}.tags>li+li>a{margin-left:6px}.widget-top-overflow>img+.tags{position:absolute;bottom:0;right:0;margin:20px}.alert-dismissible .close{right:0}.transition-height{transition:height .15s ease-in-out}.circle,.circle-o,.rounded{display:inline-block;width:1.42857em;height:1.42857em;line-height:1.42857em;text-align:center}.circle,.circle-o{border-radius:50%}.rounded{border-radius:5px}.circle-lg,.rounded-lg{width:2.2em;height:2.2em;line-height:2.2em}.circle-o{border:.28571em solid transparent}.circle-o.circle-o-danger{border-color:#d9534f}.circle-o.circle-o-warning{border-color:#ff8d00}.circle-o.circle-o-success{border-color:#5cb85c}.circle-o.circle-o-info{border-color:#5bc0de}.circle-o.circle-o-primary{border-color:#337ab7}.circle-o.circle-o-black{border-color:#000}.circle-o.circle-o-gray-darker{border-color:#222}.circle-o.circle-o-gray-dark{border-color:#333}.circle-o.circle-o-gray{border-color:#555}.circle-o.circle-o-gray-light{border-color:#777}.circle-o.circle-o-gray-lighter{border-color:#eee}.circle-o.circle-o-white{border-color:#fff}.thumb-xlg{width:100px}.thumb-xlg>.fa,.thumb-xlg>.glyphicon{line-height:100px}.thumb-lg{width:60px}.thumb-lg>.fa,.thumb-lg>.glyphicon{line-height:60px}.thumb{width:48px}.thumb>.fa,.thumb>.glyphicon{line-height:48px}.thumb-sm{width:34px}.thumb-sm>.fa,.thumb-sm>.glyphicon{line-height:34px}.thumb-xs{width:28px}.thumb-xs>.fa,.thumb-xs>.glyphicon{line-height:28px}.thumb,.thumb-lg,.thumb-sm,.thumb-xlg,.thumb-xs{position:relative;display:inline-block;text-align:center}.thumb-lg img,.thumb-sm img,.thumb-xlg img,.thumb-xs img,.thumb img{height:auto;max-width:100%;vertical-align:middle}.thumb-lg .status,.thumb-sm .status,.thumb-xlg .status,.thumb-xs .status,.thumb .status{position:absolute;top:0;left:0;display:inline-block;width:.7em;height:.7em;border:.15em solid #fff;border-radius:50%}.thumb-lg .status.status-bottom,.thumb-sm .status.status-bottom,.thumb-xlg .status.status-bottom,.thumb-xs .status.status-bottom,.thumb .status.status-bottom{top:auto;left:auto;bottom:0;right:0}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.input-group-no-border .form-control:first-child,.input-group-no-border .input-group-addon:first-child,.input-group-no-border .input-group-btn:first-child>.btn,.input-group-no-border .input-group-btn:first-child>.btn-group>.btn,.input-group-no-border .input-group-btn:first-child>.dropdown-toggle,.input-group-no-border .input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-no-border .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group-transparent .form-control:first-child,.input-group-transparent .input-group-addon:first-child,.input-group-transparent .input-group-btn:first-child>.btn,.input-group-transparent .input-group-btn:first-child>.btn-group>.btn,.input-group-transparent .input-group-btn:first-child>.dropdown-toggle,.input-group-transparent .input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-transparent .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}.input-group-no-border .form-control:last-child,.input-group-no-border .input-group-addon:last-child,.input-group-no-border .input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-no-border .input-group-btn:first-child>.btn:not(:first-child),.input-group-no-border .input-group-btn:last-child>.btn,.input-group-no-border .input-group-btn:last-child>.btn-group>.btn,.input-group-no-border .input-group-btn:last-child>.dropdown-toggle,.input-group-transparent .form-control:last-child,.input-group-transparent .input-group-addon:last-child,.input-group-transparent .input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-transparent .input-group-btn:first-child>.btn:not(:first-child),.input-group-transparent .input-group-btn:last-child>.btn,.input-group-transparent .input-group-btn:last-child>.btn-group>.btn,.input-group-transparent .input-group-btn:last-child>.dropdown-toggle{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none;padding-left:0}.input-group-no-border .input-group-addon,.input-group-transparent .input-group-addon{background-color:#fff;transition:border-color .15s ease-in-out}.focus.input-group-no-border .input-group-addon,.input-group-no-border .form-control:focus+.input-group-addon,.input-group-transparent.focus .input-group-addon,.input-group-transparent .form-control:focus+.input-group-addon{border-color:#66afe9}.input-group-no-border .form-control,.input-group-no-border .input-group-addon,.input-no-border{border:none;transition:background-color .15s ease-in-out}.input-group-no-border.focus .input-group-addon,.input-group-no-border .form-control:focus,.input-group-no-border .form-control:focus+.input-group-addon,.input-group-no-border .input-group-addon:focus,.input-no-border:focus{background-color:#f1f1f1}.input-group-rounded .form-control:first-child,.input-group-rounded .input-group-addon:first-child,.input-group-rounded .input-group-btn:first-child>.btn,.input-group-rounded .input-group-btn:first-child>.btn-group>.btn,.input-group-rounded .input-group-btn:first-child>.dropdown-toggle,.input-group-rounded .input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-rounded .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle){border-top-left-radius:4px;border-bottom-left-radius:4px}.input-group-rounded .form-control:last-child,.input-group-rounded .input-group-addon:last-child,.input-group-rounded .input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-rounded .input-group-btn:first-child>.btn:not(:first-child),.input-group-rounded .input-group-btn:last-child>.btn,.input-group-rounded .input-group-btn:last-child>.btn-group>.btn,.input-group-rounded .input-group-btn:last-child>.dropdown-toggle{border-top-right-radius:4px;border-bottom-right-radius:4px}.chart-overflow-bottom{margin:0 -20px -15px}.globe{font-size:64px}.globe>i{position:relative}.globe>i>i{position:absolute;left:0}.thin-scroll::-webkit-scrollbar{height:8px;width:8px}.thin-scroll::-webkit-scrollbar:hover{background-color:#e9e9e9;border:none}.thin-scroll::-webkit-scrollbar-thumb{border:none;background-color:rgba(0,0,0,.2);box-shadow:inset 1px 1px 0 rgba(0,0,0,.1)}.thin-scroll::-webkit-scrollbar-thumb:hover{background-color:#777}@keyframes bg-attention{0%{background-color:#ffefdb}5%{background-color:#ffd8a8}0%{background-color:transparent}}.bg-attention{animation:bg-attention 10s}.value0{font-size:54px}.value0,.value1{margin:0;font-weight:600}.value1{font-size:36px}.value2{font-size:30px}.value2,.value3{margin:0;font-weight:600}.value3{font-size:24px}.value4{font-size:18px}.value4,.value5{margin:0;font-weight:600}.value5{font-size:14px}.value6{margin:0;font-size:12px;font-weight:600}.help{font-size:85%;color:#777}.text-align-center{text-align:center}.text-align-right{text-align:right}.no-margin{margin:0}.mt-xlg{margin-top:40px}.mt-n-xlg{margin-top:-40px}.mt-lg{margin-top:30px}.mt-n-lg{margin-top:-30px}.mt,.mt-md,.mt-n{margin-top:20px}.mt-n-md{margin-top:-20px}.mt-sm{margin-top:10px}.mt-n-sm{margin-top:-10px}.mt-xs{margin-top:5px}.mt-n-xs{margin-top:-5px}.mt-0,.mt-n-0{margin-top:0}.mb-xlg{margin-bottom:40px}.mb-n-xlg{margin-bottom:-40px}.mb-lg{margin-bottom:30px}.mb-n-lg{margin-bottom:-30px}.mb,.mb-md,.mb-n{margin-bottom:20px}.mb-n-md{margin-bottom:-20px}.mb-sm{margin-bottom:10px}.mb-n-sm{margin-bottom:-10px}.mb-xs{margin-bottom:5px}.mb-n-xs{margin-bottom:-5px}.mb-0,.mb-n-0{margin-bottom:0}.ml-lg{margin-left:20px}.ml-n-lg{margin-left:-20px}.ml,.ml-md,.ml-n{margin-left:15px}.ml-n-md{margin-left:-15px}.ml-sm{margin-left:10px}.ml-n-sm{margin-left:-10px}.ml-xs{margin-left:5px}.ml-n-xs{margin-left:-5px}.ml-0,.ml-n-0{margin-left:0}.mr-lg{margin-right:20px}.mr-n-lg{margin-right:-20px}.mr,.mr-md,.mr-n{margin-right:15px}.mr-n-md{margin-right:-15px}.mr-sm{margin-right:10px}.mr-n-sm{margin-right:-10px}.mr-xs{margin-right:5px}.mr-n-xs{margin-right:-5px}.mr-0,.mr-n-0{margin-right:0}.no-padding{padding:0}.display-inline{display:inline}.display-n-inline{display:-inline}.display-inline-block{display:inline-block}.display-n-inline-block{display:-inline}.display-block{display:block}.display-n-block{display:-inline}.width-50{width:50px}.width-n-50{width:-inline}.width-100{width:100px}.width-n-100{width:-inline}.width-150{width:150px}.width-n-150{width:-inline}.width-200{width:200px}.width-n-200{width:-inline}.height-50{height:50px}.height-n-50{height:-inline}.height-100{height:100px}.height-n-100{height:-inline}.height-150{height:150px}.height-n-150{height:-inline}.height-200{height:200px}.height-n-200{height:-inline}.height-250{height:250px}.height-n-250{height:-inline}.max-height-50{max-height:50px}.max-height-n-50{max-height:-inline}.max-height-100{max-height:100px}.max-height-n-100{max-height:-inline}.max-height-150{max-height:150px}.max-height-n-150{max-height:-inline}.max-height-200{max-height:200px}.max-height-n-200{max-height:-inline}.max-height-250{max-height:250px}.max-height-n-250{max-height:-inline}.opacity-10{opacity:.1}.opacity-n-10{opacity:-inline}.opacity-20{opacity:.2}.opacity-n-20{opacity:-inline}.opacity-30{opacity:.3}.opacity-n-30{opacity:-inline}.opacity-40{opacity:.4}.opacity-n-40{opacity:-inline}.opacity-50{opacity:.5}.opacity-n-50{opacity:-inline}.opacity-60{opacity:.6}.opacity-n-60{opacity:-inline}.opacity-70{opacity:.7}.opacity-n-70{opacity:-inline}.opacity-80{opacity:.8}.opacity-n-80{opacity:-inline}.opacity-90{opacity:.9}.opacity-n-90{opacity:-inline}.z-index-more{z-index:1}.z-index-n-more{z-index:-inline}.z-index-less{z-index:-1}.z-index-n-less{z-index:-inline}.no-border{border:none}.bt{border-top:1px solid #ddd}.br{border-right:1px solid #ddd}.bb{border-bottom:1px solid #ddd}.bl{border-left:1px solid #ddd}.fw-semi-bold{font-weight:600}.fw-normal{font-weight:400}.fw-bold{font-weight:700}.fw-thin{font-weight:300}.rotate-45{transform:rotate(45deg)}.rotate-135{transform:rotate(135deg)}.rotate-225{transform:rotate(225deg)}.rotate-315{transform:rotate(315deg)}.deemphasize{font-size:85%;color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#5cb85c}a.text-success:focus,a.text-success:hover{color:#449d44}.text-info{color:#5bc0de}a.text-info:focus,a.text-info:hover{color:#31b0d5}.text-warning{color:#ff8d00}a.text-warning:focus,a.text-warning:hover{color:#cc7100}.text-danger{color:#d9534f}a.text-danger:focus,a.text-danger:hover{color:#c9302c}.text-link{color:#337ab7}a.text-link:focus,a.text-link:hover{color:#286090}.bg-primary{background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#5cb85c}a.bg-success:focus,a.bg-success:hover{background-color:#449d44}.bg-info{background-color:#5bc0de}a.bg-info:focus,a.bg-info:hover{background-color:#31b0d5}.bg-warning{background-color:#ff8d00}a.bg-warning:focus,a.bg-warning:hover{background-color:#cc7100}.bg-danger{background-color:#d9534f}a.bg-danger:focus,a.bg-danger:hover{background-color:#c9302c}.bg-primary-light{background-color:#dee4ee}a.bg-primary-light:focus,a.bg-primary-light:hover{background-color:#bcc8dd}.bg-success-light{background-color:#78e878}a.bg-success-light:focus,a.bg-success-light:hover{background-color:#4ce14c}.bg-info-light{background-color:#f2fafa}a.bg-info-light:focus,a.bg-info-light:hover{background-color:#cdecec}.bg-warning-light{background-color:#ffd497}a.bg-warning-light:focus,a.bg-warning-light:hover{background-color:#ffbf64}.bg-danger-light{background-color:#ff8b88}a.bg-danger-light:focus,a.bg-danger-light:hover{background-color:#ff5955}.bg-body{background-color:#eee}a.bg-body:focus,a.bg-body:hover{background-color:#d5d5d5}.bg-body-light{background-color:#f6f6f6}a.bg-body-light:focus,a.bg-body-light:hover{background-color:#dcdcdc}.bg-gray{background-color:#555}a.bg-gray:focus,a.bg-gray:hover{background-color:#3c3c3c}.bg-gray-transparent{background-color:rgba(85,85,85,.6)}a.bg-gray-transparent:focus,a.bg-gray-transparent:hover{background-color:rgba(60,60,60,.6)}.bg-gray-dark{background-color:#333}a.bg-gray-dark:focus,a.bg-gray-dark:hover{background-color:#1a1a1a}.bg-black,a.bg-black:focus,a.bg-black:hover{background-color:#000}.bg-gray-light{background-color:#777}a.bg-gray-light:focus,a.bg-gray-light:hover{background-color:#5e5e5e}.bg-gray-lighter{background-color:#eee}a.bg-gray-lighter:focus,a.bg-gray-lighter:hover{background-color:#d5d5d5}.bg-transparent,a.bg-transparent:focus,a.bg-transparent:hover{background-color:transparent}.bg-white{background-color:#fff}a.bg-white:focus,a.bg-white:hover{background-color:#e6e6e6}.bg-sidebar{background-color:#242424}a.bg-sidebar:focus,a.bg-sidebar:hover{background-color:#0b0b0b}.bg-body,.bg-body-light,.bg-danger,.bg-gray,.bg-gray-transparent,.bg-info,.bg-primary,.bg-success,.bg-transparent,.bg-warning{transition:background-color .15s ease-in-out}.text-white{color:#fff}a.text-white:focus,a.text-white:hover{color:#e6e6e6}.text-gray{color:#555}a.text-gray:focus,a.text-gray:hover{color:#3c3c3c}.text-gray-dark{color:#333}a.text-gray-dark:focus,a.text-gray-dark:hover{color:#1a1a1a}.text-gray-light{color:#777}a.text-gray-light:focus,a.text-gray-light:hover{color:#5e5e5e}.text-semi-muted{color:#b6b6b6}a.text-semi-muted:focus,a.text-semi-muted:hover{color:#9d9d9d}.text-gray-darker{color:#222}a.text-gray-darker:focus,a.text-gray-darker:hover{color:#090909}.text-gray-lighter{color:#eee}a.text-gray-lighter:focus,a.text-gray-lighter:hover{color:#d5d5d5}.text-bg-sidebar{color:#242424}a.text-bg-sidebar:focus,a.text-bg-sidebar:hover{color:#0b0b0b}.fade-up.ng-enter{animation:fadeInUp .5s}.fade-up.ng-leave{animation:fadeOutUp .5s}.fade-down.ng-enter{animation:fadeInDown .5s}.fade-down.ng-leave{animation:fadeOutDown .5s}.fade.ng-enter{animation:fadeIn .5s}.fade.ng-leave{animation:fadeOut .5s}.fade-right.ng-enter{animation:fadeInRight .5s}.fade-right.ng-leave{animation:fadeOutLeft .5s}.fade-left.ng-enter{animation:fadeInLeft .5s}.fade-left.ng-leave{animation:fadeOutRight .5s}.fade-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-left-big.ng-leave{animation:fadeOutRightBig .5s}.blockquote-sm{padding:3px 15px;font-size:14px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:500}.form-control{font-weight:400}.form-control,.form-control:focus{box-shadow:none}label{font-weight:400}.help-block{font-size:85%;color:#777}legend{font-size:15px;font-weight:400}.form-group{margin-bottom:20px}.input-group-addon.bg-primary{border-color:#286090}.input-group-addon.bg-success{border-color:#4ce14c}.input-group-addon.bg-info{border-color:#afd9ee}.input-group-addon.bg-warning{border-color:#f7ecb5}.input-group-addon.bg-danger{border-color:#e4b9b9}@media (min-width:768px){.form-horizontal.form-label-left .control-label{text-align:left}}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#5cb85c}.has-success .form-control{border-color:#5cb85c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#449d44;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #a3d7a3}.has-success .input-group-addon{color:#5cb85c;border-color:#5cb85c;background-color:#5cb85c}.has-success .form-control-feedback{color:#5cb85c}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#ff8d00}.has-warning .form-control{border-color:#ff8d00;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#cc7100;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #fb6}.has-warning .input-group-addon{color:#ff8d00;border-color:#ff8d00;background-color:#ff8d00}.has-warning .form-control-feedback{color:#ff8d00}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#d9534f}.has-error .form-control{border-color:#d9534f;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#c9302c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #eba5a3}.has-error .input-group-addon{color:#d9534f;border-color:#d9534f;background-color:#d9534f}.has-error .form-control-feedback{color:#d9534f}.has-error .form-control:focus,.has-success .form-control:focus,.has-warning .form-control:focus{box-shadow:none}.input-group-addon,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-lg,.input-sm{border-radius:2px}.input-rounded{border-radius:4px}.checkbox label,.radio label{margin-bottom:5px;min-height:0}.table>thead>tr>th{font-weight:600;text-transform:uppercase;border-bottom-width:1px}.table-bordered th{background-color:#eee}.table-lg>tbody>tr>td,.table-lg>tbody>tr>th,.table-lg>tfoot>tr>td,.table-lg>tfoot>tr>th,.table-lg>thead>tr>td,.table-lg>thead>tr>th{padding:10px}.table-sm>tbody>tr>td,.table-sm>tbody>tr>th,.table-sm>tfoot>tr>td,.table-sm>tfoot>tr>th,.table-sm>thead>tr>td,.table-sm>thead>tr>th{padding:6px}.table-hover>tbody>tr:hover .progress{background-color:#fff}.dropdown-menu{font-size:13px}.dropdown-menu>li>a{padding-top:5px;padding-bottom:5px}.nav-tabs{border-bottom:none;background-color:#ddd;border-top-left-radius:4px;border-top-right-radius:4px}.nav-tabs>li{margin-bottom:0}.nav-tabs>li>a{padding:12px 18px;border:none;color:#777;font-weight:500;transition:color .15s ease-in-out}.nav-tabs>li>a:hover{background-color:transparent;color:#333}.nav-tabs>li.open>a,.nav-tabs>li.open>a:focus,.nav-tabs>li.open>a:hover{background-color:#fff;color:#555}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{border:none;box-shadow:1px 1px 2px #ccc}.tab-content{position:relative;z-index:1;background-color:#fff}.tab-content>.tab-pane{padding:20px}.tabbable:after{display:block;content:\"\";clear:both}.tab-content{overflow:auto}.tabs-below>.nav-tabs,.tabs-left>.nav-tabs,.tabs-right>.nav-tabs{border-bottom:0}.pill-content>.pill-pane,.tab-content>.tab-pane{display:none}.pill-content>.active,.tab-content>.active{display:block}.tabs-left>.nav-tabs>li,.tabs-right>.nav-tabs>li{float:none}.tabs-left>.nav-tabs>li>a,.tabs-right>.nav-tabs>li>a{min-width:74px;margin-right:0;margin-bottom:3px}.tabs-left>.nav-tabs>li:last-child>a,.tabs-right>.nav-tabs>li:last-child>a{margin-bottom:0}.tabs-left>.nav-tabs{float:left;border-top-right-radius:0}.tabs-left>.nav-tabs>li>a{margin-right:-1px;border-radius:4px 0 0 4px}.tabs-right>.nav-tabs{float:right;border-top-left-radius:0}.tabs-right>.nav-tabs>li>a{margin-left:-1px;border-radius:0 4px 4px 0}.tabs-right>.nav-tabs>li.active>a{box-shadow:-1px 1px 2px #ccc}.navbar{border:none;font-weight:500}.navbar,.navbar h5{font-size:13px}.navbar .deemphasize{font-size:12px}.navbar-form .form-control{font-size:13px}.navbar-form .input-group{width:245px}.navbar-form .input-group-addon{color:#777}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}}.navbar-header>.navbar-nav{float:right;margin-left:10px;margin-right:10px}.navbar-header>.navbar-nav.navbar-right{float:right}@media (max-width:767px){.navbar-header>.navbar-nav+.navbar-brand{height:60px;line-height:30px}}.navbar-header>.navbar-nav>li{float:left}.navbar-header>.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}@media (min-width:768px){.navbar-nav.navbar-right:last-child{margin-right:0}}.btn-rounded{border-radius:6px}.btn-gray{color:#333;background-color:#ddd;border-color:#d0d0d0}.btn-gray.focus,.btn-gray:focus{color:#333;background-color:#c4c4c4;border-color:#919191}.btn-gray.active,.btn-gray:active,.btn-gray:hover,.open>.btn-gray.dropdown-toggle{color:#333;background-color:#c4c4c4;border-color:#b2b2b2}.btn-gray.active.focus,.btn-gray.active:focus,.btn-gray.active:hover,.btn-gray:active.focus,.btn-gray:active:focus,.btn-gray:active:hover,.open>.btn-gray.dropdown-toggle.focus,.open>.btn-gray.dropdown-toggle:focus,.open>.btn-gray.dropdown-toggle:hover{color:#333;background-color:#b2b2b2;border-color:#919191}.btn-gray.active,.btn-gray:active,.open>.btn-gray.dropdown-toggle{background-image:none}.btn-gray.disabled.focus,.btn-gray.disabled:focus,.btn-gray.disabled:hover,.btn-gray[disabled].focus,.btn-gray[disabled]:focus,.btn-gray[disabled]:hover,fieldset[disabled] .btn-gray.focus,fieldset[disabled] .btn-gray:focus,fieldset[disabled] .btn-gray:hover{background-color:#ddd;border-color:#d0d0d0}.btn-gray .badge{color:#ddd;background-color:#333}.btn-outline{color:#fff;background-color:transparent;border-color:#fff}.btn-outline.focus,.btn-outline:focus{color:#fff;background-color:transparent;border-color:#bfbfbf}.btn-outline.active,.btn-outline:active,.btn-outline:hover,.open>.btn-outline.dropdown-toggle{color:#fff;background-color:transparent;border-color:#e0e0e0}.btn-outline.active.focus,.btn-outline.active:focus,.btn-outline.active:hover,.btn-outline:active.focus,.btn-outline:active:focus,.btn-outline:active:hover,.open>.btn-outline.dropdown-toggle.focus,.open>.btn-outline.dropdown-toggle:focus,.open>.btn-outline.dropdown-toggle:hover{color:#fff;background-color:transparent;border-color:#bfbfbf}.btn-outline.active,.btn-outline:active,.open>.btn-outline.dropdown-toggle{background-image:none}.btn-outline.disabled.focus,.btn-outline.disabled:focus,.btn-outline.disabled:hover,.btn-outline[disabled].focus,.btn-outline[disabled]:focus,.btn-outline[disabled]:hover,fieldset[disabled] .btn-outline.focus,fieldset[disabled] .btn-outline:focus,fieldset[disabled] .btn-outline:hover{background-color:transparent;border-color:#fff}.btn-outline .badge{color:transparent;background-color:#fff}.btn-outline:focus,.btn-outline:hover{background-color:hsla(0,0%,100%,.1)}.btn-link.active:focus,.btn-link:active:focus,.btn-link:focus{outline:0}.label{font-size:11px;font-weight:600}.btn-toolbar{margin-top:10px;margin-bottom:10px}.widget-body.no-padding>.list-group{margin:0}.widget-body.no-padding>.list-group .list-group-item{border-width:1px 0}.list-group-lg .list-group-item{padding:15px}.list-group:last-of-type .list-group-item:last-child{border-bottom:0}.panel{border:none;box-shadow:none}.panel-heading{padding-top:13px;padding-bottom:13px}.panel-title>a{display:block}.panel-title>a>i{transition:transform .35s ease}.panel-title>a.collapsed{color:#777}.panel-title>a.collapsed:hover{color:#333}.panel-title>a.collapsed>i{transform:rotate(180deg)}.h1.panel-title,h1.panel-title{font-size:36px}.h2.panel-title,h2.panel-title{font-size:30px}.h3.panel-title,h3.panel-title{font-size:24px}.h4.panel-title,h4.panel-title{font-size:18px}.h5.panel-title,h5.panel-title{font-size:14px}.h6.panel-title,h6.panel-title{font-size:12px}.dropdown-menu>.panel{margin-top:-5px;margin-bottom:-5px}.panel-heading{border-color:#ddd}.tooltip-inner{border-radius:3px}.alert-sm{padding:10px 12px;font-size:13px}.alert-sm .close{font-size:18px}.alert-dismissable .close{position:static;color:#000}.popover{border:none;box-shadow:none}.popover-content{padding:20px}.pagination{font-weight:400}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{border-radius:4px;margin:0 2px 2px}/*! ngTable v1.0.0 by Vitalii Savchuk(esvit666@gmail.com) - https://github.com/esvit/ng-table - New BSD License */.ng-table th{text-align:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-table th.sortable{cursor:pointer}.ng-table th.sortable .sort-indicator{padding-right:18px;position:relative}.ng-table th.sortable .sort-indicator:after,.ng-table th.sortable .sort-indicator:before{content:\"\";border-width:0 4px 4px;border-style:solid;border-color:#000 transparent;visibility:visible;right:5px;top:50%;position:absolute;opacity:.3;margin-top:-4px}.ng-table th.sortable .sort-indicator:before{margin-top:2px;border-bottom:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #000}.ng-table th.sortable .sort-indicator:hover:after,.ng-table th.sortable .sort-indicator:hover:before{opacity:1;visibility:visible}.ng-table th.sortable.sort-asc,.ng-table th.sortable.sort-desc{background-color:rgba(141,192,219,.25);text-shadow:0 1px 1px hsla(0,0%,100%,.75)}.ng-table th.sortable.sort-asc .sort-indicator:after,.ng-table th.sortable.sort-desc .sort-indicator:after{margin-top:-2px}.ng-table th.sortable.sort-asc .sort-indicator:before,.ng-table th.sortable.sort-desc .sort-indicator:before{visibility:hidden}.ng-table th.sortable.sort-asc .sort-indicator:after,.ng-table th.sortable.sort-asc .sort-indicator:hover:after,.ng-table th.sortable.sort-desc .sort-indicator:after{visibility:visible;filter:alpha(opacity=60);-khtml-opacity:.6;-moz-opacity:.6;opacity:.6}.ng-table th.sortable.sort-desc .sort-indicator:after{border-bottom:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #000;box-shadow:none}.ng-table th.filter .input-filter{margin:0;display:block;width:100%;min-height:30px;box-sizing:border-box}.ng-table .ng-table-group-header th{text-align:left}.ng-table .ng-table-group-selector{display:block}.ng-table .ng-table-group-close,.ng-table .ng-table-group-toggle{float:right}.ng-table .ng-table-group-toggle{margin-right:5px}@media only screen and (max-width:800px){.ng-table-responsive{border-bottom:1px solid #999}.ng-table-responsive tr{border-top:1px solid #999;border-left:1px solid #999;border-right:1px solid #999}.ng-table-responsive td:before{position:absolute;padding:8px;left:0;top:0;width:50%;white-space:nowrap;text-align:left;font-weight:700}.ng-table-responsive thead tr th{text-align:left}.ng-table-responsive thead tr.ng-table-filters th{padding:0}.ng-table-responsive thead tr.ng-table-filters th form>div{padding:8px}.ng-table-responsive td{border:0;border-bottom:1px solid #eee;position:relative;padding-left:50%;white-space:normal;text-align:left}.ng-table-responsive td:before{content:attr(data-title-text)}.ng-table-responsive,.ng-table-responsive tbody,.ng-table-responsive td,.ng-table-responsive th,.ng-table-responsive thead,.ng-table-responsive tr{display:block}}.ng-table-pagination{margin-top:0}.filter:after,.filter:before,.ng-table-group-selector:after,.ng-table-group-selector:before{display:table;content:\" \"}.filter:after,.ng-table-group-selector:after{clear:both}.filter>.filter-cell{float:left;box-sizing:border-box}.filter-horizontal>.filter-cell{padding:0 2px}.filter-horizontal>.filter-cell:first-child{padding-left:0}.filter-horizontal>.filter-cell.last,.filter-horizontal>.filter-cell:last-child{padding-right:0}.s12{width:100%}.s11{width:91.66666666666666%}.s10{width:83.33333333333334%}.s9{width:75%}.s8{width:66.66666666666666%}.s7{width:58.333333333333336%}.s6{width:50%}.s5{width:41.66666666666667%}.s4{width:33.33333333333333%}.s3{width:25%}.s2{width:16.666666666666664%}.s1{width:8.333333333333332%}@media (max-width:468px){.s1,.s2,.s3,.s4,.s5,.s6,.s7,.s8,.s9,.s10,.s11,.s12{width:100%}.filter>.filter-cell{padding:0}}a,body,h1,h2,h3,h4,h5,li,p,td,textarea,th{font-family:Open Sans,sans-serif!important}.content h1{color:#555;font-size:24px;margin-bottom:20px;text-transform:capitalize;position:relative}.content h1 .btn{display:block;margin-top:20px}@media (min-width:420px){.content h1 .btn{display:inline;margin-top:0}}@media (min-width:600px){.content h1{font-size:30px;margin-bottom:30px}}.misspelled-container{min-height:20px}.highlight-error{background-color:#ff8b88}.mobile-width{display:block}@media (min-width:600px){.mobile-width{display:none}}.italic{font-style:italic}.app{height:100%}.widget .widget-body{padding:10px 0}.position-relative{position:relative}.readonly{background:#eee!important}.input-description{font-size:12px;margin-top:5px}.clickable{color:#0074a2;cursor:pointer!important;text-decoration:none}.clickable:hover{color:#33b0dd;text-decoration:none}.clickable-danger{color:#d9534f;cursor:pointer!important;text-decoration:none}.clickable-danger:hover{color:#e27c79;text-decoration:none}.clickable-warning{color:#ff8d00;cursor:pointer!important;text-decoration:none}.clickable-warning:hover{color:#ffd497;text-decoration:none}.clickable-info{color:#0a2730;cursor:pointer!important;text-decoration:none}.clickable-info:hover{color:#2390b0;text-decoration:none}.clickable-default{color:#777;cursor:pointer!important;text-decoration:none}.clickable-default:hover{color:#333;text-decoration:none}.no-clickable{cursor:default!important;text-decoration:none!important}.error-border,.form-group .input-group .error-border,.input-group-no-border .error-border.form-control{border:1px solid #de1d1d!important}.error-border.dropzone{border:none!important}.not-clickable{pointer-events:none}.danger{color:#d9534f}.success{color:#5cb85c}input.strong{border:1px solid #5cb85c!important}input.weak{border:1px solid #d9534f!important}.clickable-success{color:#5cb85c;cursor:pointer}.clickable-success:hover{text-decoration:none;color:#78e878}.limit td{border-bottom:2px solid #5cb85c!important}.nav.navbar-nav span{display:inline-block}.nav.navbar-nav .margin-top{vertical-align:middle;text-align:center}.nav.navbar-nav .margin-top#analytic p{background:url(" + __webpack_require__(379) + ") 50% no-repeat;background-size:30px 30px}.nav.navbar-nav .margin-top p{font-size:16px;font-weight:700;margin:0;margin-left:5px;line-height:30px;width:50px;height:30px}.nav.navbar-nav .margin-top i,.nav.navbar-nav .margin-top p{vertical-align:middle;display:inline-block}.nav.navbar-nav .fa-male{font-size:22px}.sidebar-name{margin-left:5px}.sidebar-set{position:absolute;top:0;right:15px}.fa-dashboard:before,.fa-database:before,.fa-tachometer:before{font-size:20px;font-weight:700;display:inline-block;margin-right:5px}.required-error{font-size:12px;font-weight:700;color:#d9534f}.animate-show{height:20px;opacity:1;padding-top:5px}.animate-show.ng-hide-add.ng-hide-add-active,.animate-show.ng-hide-remove.ng-hide-remove-active{transition:all .5s linear}.animate-show.ng-hide{height:0;opacity:0;padding-top:0}.table input[type=checkbox]{width:16px;height:16px}.table-chechbox{width:30px}.editShow{display:block!important}.editHidden{display:none}.input-group-no-border .form-control{width:60px!important;text-align:center;padding-right:0;border:1px solid #eee!important}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px}.comment-count,.comment-priority{font-size:14px;font-weight:600;height:1.4em;line-height:1.4em;min-width:.7em;padding:0 6px;display:inline-block;border-radius:5px;background-color:#bbb;color:#fff;text-align:center}.comment-count:after,.comment-priority:after{content:\"\";display:block;width:0;height:0;margin-left:8px;border-top:5px solid #bbb;border-right:5px solid transparent}.cancel{color:#d9534f}.cancel,.edit-submit{font-size:13px;font-weight:700;display:inline-block;cursor:pointer}.edit-submit{color:#5cb85c;margin:0 6px}.fa-pencil:before{font-size:12px;color:#0074a2;cursor:pointer}.fa-pencil:hover:before{color:#33b0dd}.table>thead>tr>th{font-weight:400;text-transform:capitalize;font-weight:12px}.inline{display:inline-block}.sidebar{position:fixed;z-index:100;left:-204px;top:0;bottom:0;width:204px;background-color:#242424;color:#aaa;overflow-y:scroll;overflow-x:hidden}.sidebar,.sidebar.sidebar-show{transition:left .3s ease-in-out}.sidebar.sidebar-show{left:0}@media (min-width:1200px){.sidebar{left:0;z-index:0}}.loader-wrapper{position:fixed;top:0;width:100%;height:100%;z-index:10;left:0;right:0;bottom:0}@media (min-width:1200px){.loader-wrapper{padding-left:204px}}.loader-wrapper .image-wrapper{background-color:rgba(36,36,36,.1);position:relative;width:100%;height:100%}.loader-wrapper.modal-show{padding-left:0!important}.loader-wrapper img{position:absolute;top:50%;left:50%;z-index:11;width:100px;height:100px;margin-left:-50px;margin-top:-50px}.page-controls{position:static!important;margin-bottom:0!important}.input-group .form-control{z-index:0!important}.navbar-header{position:relative}.content-wrap,.loader-wrap,.page-controls{left:0;transition:left .3s ease-in-out}@media (min-width:1200px){.content-wrap,.loader-wrap,.page-controls{margin-left:204px;left:154px}}.nav-collapsed .content-wrap,.nav-collapsed .loader-wrap,.nav-collapsed .page-controls{left:0}.content-wrap{left:0;transition:left .3s ease-in-out}@media (min-width:1200px){.content-wrap{margin-left:204px;left:0}}.nav-collapsed .content-wrap{left:0}.page-controls{transition:left .3s ease-in-out,right .3s ease-in-out!important;right:-204px}.nav-collapsed .page-controls{right:0}.page-controls{position:absolute;z-index:1}@media (max-width:767px){.page-controls .navbar-brand{position:absolute;left:0;right:0;font-weight:700;text-align:left}.page-controls .navbar-brand>.fa-circle{font-size:10px}.page-controls .navbar-nav{position:relative}}.page-controls .avatar{width:30px;margin-top:-5px}.page-controls .avatar.pull-left{margin-right:5px}.page-controls .avatar.pull-right{margin-left:5px}.page-controls .navbar-nav>li>a .circle.circle.lg,.page-controls .navbar-nav>li>a .rounded.rounded-lg{margin:-7px -7px -8px}@media (min-width:768px) and (max-width:991px){.page-controls .navbar-form.navbar-left{padding-right:0}}.page-controls .navbar-nav .fa-times{font-size:20px;vertical-align:-2px}@-moz-document url-prefix(){.page-controls .navbar-nav>li>a>.rounded-lg>i{vertical-align:-8%}}.content-wrap{position:relative;z-index:0;height:100%}.content{min-height:100%;background-color:#eee;padding:10px}.content.fade-in-up.ng-enter{animation:fadeInUp .5s}.content.fade-in-up.ng-leave{animation:fadeOutUp .5s}.logo{margin:10px 0;height:30px;width:100%;line-height:30px;text-align:left;vertical-align:middle;font-weight:700;font-size:18px;display:flex;align-items:center;transition:width .3s ease-in-out}@media (max-width:1200px){.logo{width:auto}}.logo a{padding-left:20px;display:inline-block;width:110px;height:24px;margin-left:10px;background:url(" + __webpack_require__(394) + ") no-repeat;color:#fff;text-decoration:none;background-size:100%}@media (max-width:1200px){.logo a{margin-left:10px;padding-left:20px}}.nav-collapsed .logo{width:50px}@media (min-width:1200px){.nav-static .logo{width:100%;transition:none}}.logo>span{display:block;margin-left:10px;line-height:30px}.sidebar-nav a{font-size:15px!important}.sidebar-nav ul a{font-size:14px!important}.sidebar-nav li a{display:block;color:#aaa;text-decoration:none;cursor:pointer}.sidebar-nav li a .toggle{float:right;line-height:18px;margin-right:10px;transition:transform .35s ease}.sidebar-nav li a.collapsed .toggle{transform:rotate(-90deg)}.sidebar-nav li a .label{float:right;line-height:15px;margin-top:7px;margin-right:15px}@media (min-height:670px){.sidebar-nav li a .label{margin-top:12px}}.sidebar-nav>li>a{position:relative;border-top:1px solid #2d2d2d;padding-left:40px;line-height:44px}.sidebar-nav>li>a:hover{background-color:#111}.sidebar-nav>li>a .icon{display:block;position:absolute;top:9px;left:11px;width:28px;height:28px;line-height:28px;text-align:center}.sidebar-nav>li>a .icon .fa,.sidebar-nav>li>a .icon .glyphicon{font-size:16px;color:hsla(0,0%,67%,.7)}.sidebar-nav>li>a .icon .glyphicon{left:-1px}.sidebar-nav>li>a .icon .glyphicon-map-marker{top:2px}.sidebar-nav>li>a .icon .glyphicon-th{top:1px;left:0}.sidebar-nav>li>a .icon .glyphicon-tree-conifer{left:0}.sidebar-nav>li>a .icon .fa-envelope{position:relative;top:-1px}.sidebar-nav>li>a .icon .glyphicon-user{left:0;top:2px}.sidebar-nav>li>a .toggle{line-height:44px}.sidebar-nav>.open>a{background-color:#161616}.sidebar-nav>li:last-child>a{border-bottom:1px solid #2d2d2d}.sidebar-nav>.active>a{color:#fff;background-color:#242424;background:#111}.sidebar-nav>.active>a .icon{border-radius:50%;background-color:transparent}.sidebar-nav>.active>a .icon .fa,.sidebar-nav>.active>a .icon .glyphicon{color:#242424}.sidebar-nav>.active>a .icon .fa:before{color:#e42828}.sidebar-nav>li ul{padding:0;background-color:#313131;list-style:none}.sidebar-nav>li ul>li>a{padding:5px 0 5px 40px}.sidebar-nav>li ul>li>a:hover{background-color:#1e1e1e}.sidebar-nav>li ul>li.active>a{font-weight:400;color:#fff;cursor:default}.sidebar-nav>li ul>li ul>li>a{padding-left:55px}.sidebar-nav>li>ul:before{content:\"\";display:block;padding-top:10px}.sidebar-nav>li>ul:after{content:\"\";display:block;padding-bottom:10px}.sidebar-nav-title{margin:35px 0 5px 11px;font-size:14px;text-transform:uppercase;opacity:1;transition:opacity .3s ease-in-out}.sidebar-nav-title .action-link{color:#aaa;float:right;margin-right:15px;margin-top:-1px}.sidebar-nav-title .action-link .fa,.sidebar-nav-title .action-link .glyphicon{font-size:9px}.nav-collapsed .sidebar-nav-title{opacity:0}@media (min-width:992px){.nav-static .sidebar-nav-title{opacity:1;transition:none}}.sidebar-status{position:relative;margin:10px 0 20px;padding:0 15px 0 11px}.sidebar-status>a{display:block;line-height:40px;color:#eee;text-decoration:none}.sidebar-status .dropdown-menu{position:fixed;top:60px;margin:0 20px;width:320px;color:#333}@media (max-width:380px){.sidebar-status .dropdown-menu{width:100%;margin:0}}@media (max-height:500px){.sidebar-status .dropdown-menu{bottom:20px}.sidebar-status .notifications .panel-heading{position:absolute;top:0;left:0;right:0}.sidebar-status .notifications .list-group{position:absolute;top:85px;left:0;right:0;bottom:43px;height:auto}.sidebar-status .notifications .panel-footer{position:absolute;bottom:0;left:0;right:0}}.sidebar-labels{list-style:none;padding:11px;padding-right:15px;font-size:13px}.sidebar-labels>li>a{color:#eee;text-decoration:none;font-weight:400}.sidebar-labels>li>a .circle,.sidebar-labels>li>a .circle-o{position:relative;top:-2px;font-size:9px;height:12px;width:12px;line-height:12px;transition:margin-left .3s ease-in-out}.sidebar-labels>li>a .fa-circle{font-size:11px;vertical-align:1px;transition:margin-left .3s ease-in-out}.sidebar-labels>li>a .circle-o{top:1px;left:1px}.sidebar-labels>li>a .label-name{opacity:1;transition:opacity .3s ease-in-out}.nav-collapsed .sidebar-labels>li>a .circle,.nav-collapsed .sidebar-labels>li>a .circle-o,.nav-collapsed .sidebar-labels>li>a .fa-circle{margin-left:8px}.nav-collapsed .sidebar-labels>li>a .label-name{opacity:0}@media (min-width:992px){.nav-static .sidebar-labels>li>a .circle,.nav-static .sidebar-labels>li>a .circle-o,.nav-static .sidebar-labels>li>a .fa-circle{margin-left:0;transition:none}.nav-static .sidebar-labels>li>a .label-name{opacity:1;transition:none}}.sidebar-labels>li+li{margin-top:10px}.sidebar-alerts{font-size:13px;transition:opacity .3s ease-in-out;opacity:1}.nav-collapsed .sidebar-alerts{opacity:0}@media (min-width:992px){.nav-static .sidebar-alerts{opacity:1;transition:none}}.sidebar-alerts .alert{margin-bottom:0;padding:10px 11px;padding-right:15px}.sidebar-alerts .alert .close{font-size:16px;text-shadow:none;opacity:1;color:#aaa}.sidebar-alerts .progress{background-color:#3e3e3e}.chat-sidebar{position:fixed;top:0;bottom:0;right:-254px;width:254px;background-color:#242424;transition:right .3s ease-in-out}.chat-sidebar-container{position:relative}.chat-sidebar-container,.chat-sidebar-container .sidebar{left:0;transition:left .3s ease-in-out}.chat-sidebar-container.chat-sidebar-opened,.chat-sidebar-container.chat-sidebar-opened .sidebar{left:-254px}.chat-sidebar-container.chat-sidebar-opened .chat-sidebar{right:0}.chat-sidebar-header{position:absolute;top:0;padding:10px;z-index:3;background-color:#242424}.chat-sidebar-content{color:#aaa}.chat-sidebar-contacts{padding:20px;left:-100%;transition:left .4s ease-in-out}.chat-sidebar-contacts.open{left:0}.chat-sidebar-contacts .sidebar-nav-title{margin-left:10px;margin-right:10px}.chat-sidebar-contacts .sidebar-nav-title:first-child{margin-top:0}.nav-collapsed .chat-sidebar-contacts .sidebar-nav-title{opacity:1}.chat-sidebar-chat{right:-100%;padding-bottom:54px;background-color:#242424;transition:right .2s ease-in-out}.chat-sidebar-chat.open{right:0}.chat-sidebar-chat .title{margin-bottom:0}.chat-sidebar-chat .title>a{display:block;padding:10px 16px;background-color:hsla(0,0%,100%,.1);color:#eee;text-decoration:none}.chat-sidebar-chat .message-list{list-style:none;padding-left:0;padding-top:10px}.chat-sidebar-chat .message{padding:10px 20px}.chat-sidebar-chat .message:after{display:block;content:\"\";clear:both}.chat-sidebar-chat .message>.thumb-sm{float:left}.chat-sidebar-chat .message.from-me>.thumb-sm{float:right}.chat-sidebar-chat .message-body{position:relative;margin-left:50px;padding:10px;font-size:13px;font-weight:400;background-color:#eee;color:#333;border-radius:4px}.chat-sidebar-chat .message-body:before{right:100%;top:8px;content:\" \";height:0;width:0;position:absolute;border:10px solid transparent;border-right-color:#eee}.chat-sidebar-chat .message.from-me .message-body{margin-left:0;margin-right:50px;background-color:#ff8d00;color:#333}.chat-sidebar-chat .message.from-me .message-body:before{right:auto;left:100%;border-right-color:transparent;border-left-color:#ff8d00}.chat-sidebar-panel{position:absolute;top:0;bottom:0;width:100%;padding-top:100px}.chat-sidebar-title{margin-left:10px;margin-right:10px;text-transform:uppercase;font-size:15px;font-weight:400}.chat-sidebar-user-group{margin-top:10px}.chat-sidebar-user-group .list-group-item{background-color:transparent;margin-left:-20px;margin-right:-20px;margin-bottom:0;padding:10px 20px;border:0;color:#eee;border-radius:0}.chat-sidebar-user-group .list-group-item.active,.chat-sidebar-user-group .list-group-item.active:focus,.chat-sidebar-user-group .list-group-item.active:hover{background-color:hsla(0,0%,100%,.1);color:#ff8d00}.chat-sidebar-user-group .list-group-item.active .badge{background-color:#d9534f;color:#fff}.chat-sidebar-user-group .list-group-item.active .message-sender{font-weight:600}.chat-sidebar-user-group .list-group-item .circle-o{margin-top:13px;font-size:8px}.chat-sidebar-user-group .list-group-item .fa-circle{font-size:11px;line-height:37px}.chat-sidebar-user-group .list-group-item .badge{margin-top:9px;margin-right:6px;padding:3px 5px}.chat-sidebar-user-group .thumb-sm .status,.chat-sidebar-user-group .thumb .status{border-color:#242424}.chat-sidebar-user-group a.list-group-item:hover{color:#eee;background-color:rgba(0,0,0,.15)}.chat-sidebar-user-group .message-preview{margin:0;width:100px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:85%;color:#777}.chat-sidebar-user-group .message-sender{margin:0 0 5px}.chat-sidebar-footer{position:absolute;bottom:0;right:-100%;width:100%;margin-bottom:0;padding:10px;background-color:#3a3a3a;transition:right .2s ease-in-out}.chat-sidebar-footer.open{right:0}.chat-notification{position:absolute;right:0;top:35px;z-index:20;margin-top:3px;padding:5px 0;cursor:pointer}.chat-notification:before{content:\" \";position:absolute;top:0;right:18px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #333}.chat-notification-inner{min-width:120px;padding:8px;font-size:12px;border-radius:4px;text-decoration:none;background-color:#333;color:#fff}.chat-notification-inner .title{margin:0;font-weight:600;line-height:28px}.chat-notification-inner .title .thumb-xs{vertical-align:-9px;margin-right:5px}.chat-notification-inner .text{margin-top:5px;margin-bottom:0;color:#777}.chat-notification-sing{position:absolute;top:15px;left:11px;display:inline-block;width:8px;height:8px;border-radius:50%;background-color:#d9534f}.page-title{margin:0 0 20px}@media (min-width:768px){.notifications{width:333px}}.notifications .list-group{height:320px;overflow-y:scroll}.notifications .list-group-item{transition:background-color .15s ease-in-out}.notifications .list-group-item:hover{background-color:#f5f5f5}.notifications .list-group-item:hover .progress{background-color:#fff}.notifications .list-group-item .progress{transition:background-color .15s ease-in-out}.notifications .btn-notifications-reload{color:#777}.widget{position:relative;margin-bottom:30px;padding:15px 10px;background:#fff;border-radius:3px}@media (min-width:800px){.widget{padding:15px 20px}}.widget>header{margin:-15px -10px;padding:15px 10px}@media (min-width:800px){.widget>header{margin:-15px -20px;padding:15px 20px}}.widget>header h1,.widget>header h2,.widget>header h3,.widget>header h4,.widget>header h5,.widget>header h6{margin:0}.widget>header+.widget-body,.widget>header+.widget-body.no-padding{margin-top:15px}.widget>.widget-body.no-padding{margin:-15px -20px}.widget>.widget-body.no-padding+footer{margin-top:15px}.widget>footer{margin:0 -10px -15px;padding:15px 10px}@media (min-width:800px){.widget>footer{margin:0 -20px -15px;padding:15px 20px}}.widget:hover .widget-controls-hover{opacity:1}.widget .loader{position:absolute;top:0;bottom:0;left:0;right:0}.widget .loader .spinner{position:absolute;top:50%;width:100%;margin-top:-10px;font-size:20px;text-align:center}.widget .widget-table-overflow{margin:0 -20px -15px}.widget-controls{position:absolute;z-index:1;top:0;right:0;padding:14px;font-size:12px}.widget-controls.left{left:0;right:auto}.widget-controls.widget-controls-hover{opacity:0;transition:opacity .15s}.widget-controls>a{padding:1px 4px;border-radius:4px;color:rgba(0,0,0,.4);transition:color .15s ease-in-out}.widget-controls>a:hover{color:rgba(0,0,0,.1)}.widget-controls>a>.fa{vertical-align:middle}.widget-controls>a>.glyphicon{vertical-align:-1px}.widget-controls>.btn-group{vertical-align:baseline}.widget-controls .fa-refresh{position:relative;top:-1px}.widget-icon{opacity:.5;font-size:42px}.widget-image{position:relative;overflow:hidden;margin:-15px -20px;border-radius:4px}.widget-image>img{max-width:100%;border-radius:4px 4px 0 0;transition:transform .15s ease}.widget-image:hover>img{transform:scale(1.1)}.widget-image .title{position:absolute;top:0;left:0;margin:20px}.widget-image .info{position:absolute;top:0;right:0;margin:20px}.widget-footer-bottom{position:absolute;bottom:0;width:100%}.widget-sm{height:230px}.widget-md{height:373px}.windget-padding-md{padding:15px 20px}.windget-padding-lg{padding:30px 40px}.widget-body-container{position:relative;height:100%}.widget-middle-overflow,.widget-top-overflow{position:relative;margin:0 -20px}.widget-middle-overflow>img,.widget-top-overflow>img{max-width:100%}.widget-top-overflow{margin-top:-15px;overflow:hidden}.widget-top-overflow,.widget-top-overflow>img{border-top-left-radius:4px;border-top-right-radius:4px}.widget-top-overflow>.btn-toolbar{position:absolute;top:0;right:0;z-index:1;margin-right:20px}@media (min-width:768px){.widget-top-overflow>.btn-toolbar{top:auto;bottom:0}}.widget-container{min-height:30px}.widget-container .widget:not(.fullscreened)>header{cursor:move}.widget-placeholder{background:hsla(0,0%,100%,.4);border:1px dashed #777;margin:-1px -1px 29px}.form-actions{margin:20px 0 0;padding:20px;background-color:#f5f5f5}.form-horizontal .form-actions .row{margin-left:-35px;margin-right:-35px}input.search,input[type=search]{background-color:#fff;background:url(" + __webpack_require__(400) + ") 5px 60% no-repeat #fff}.input-group-lg>input.search,.input-group-lg>input[type=search],.input-group-sm>input.search,.input-group-sm>input[type=search],input.search,input[type=search]{padding-left:26px}.btn-inverse{color:#fff;background-color:#555;border-color:#3c3c3c}.btn-inverse.focus,.btn-inverse:focus{color:#fff;background-color:#3c3c3c;border-color:#000}.btn-inverse.active,.btn-inverse:active,.btn-inverse:hover,.open>.btn-inverse.dropdown-toggle{color:#fff;background-color:#3c3c3c;border-color:#1d1d1d}.btn-inverse.active.focus,.btn-inverse.active:focus,.btn-inverse.active:hover,.btn-inverse:active.focus,.btn-inverse:active:focus,.btn-inverse:active:hover,.open>.btn-inverse.dropdown-toggle.focus,.open>.btn-inverse.dropdown-toggle:focus,.open>.btn-inverse.dropdown-toggle:hover{color:#fff;background-color:#2a2a2a;border-color:#000}.btn-inverse.active,.btn-inverse:active,.open>.btn-inverse.dropdown-toggle{background-image:none}.btn-inverse.disabled.focus,.btn-inverse.disabled:focus,.btn-inverse.disabled:hover,.btn-inverse[disabled].focus,.btn-inverse[disabled]:focus,.btn-inverse[disabled]:hover,fieldset[disabled] .btn-inverse.focus,fieldset[disabled] .btn-inverse:focus,fieldset[disabled] .btn-inverse:hover{background-color:#555;border-color:#3c3c3c}.btn-inverse .badge{color:#555;background-color:#fff}.content-map{position:absolute;top:0;bottom:0;left:0;right:0}.content-map+.page-title{position:relative;z-index:2}.content-map-controls{position:absolute;right:0;top:0;z-index:2;margin-top:90px;margin-right:40px}#datetimepicker2>a{background:#5cb85c}#datetimepicker2>a:hover{border-color:#ccc}#datetimepicker2>a span{color:#fff}@keyframes passing-through{0%{opacity:0;transform:translateY(40px)}30%,70%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-40px)}}@keyframes slide-in{0%{opacity:0;transform:translateY(40px)}30%{opacity:1;transform:translateY(0)}}@keyframes pulse{0%{transform:scale(1)}10%{transform:scale(1.1)}20%{transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,.3);background:#fff;padding:20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:.5}.dropzone .dz-message{margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(180deg,#eee,#ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:#fff}.dropzone .dz-preview.dz-image-preview .dz-details{transition:opacity .2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;color:rgba(0,0,0,.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid hsla(0,0%,78%,.8);background-color:hsla(0,0%,100%,.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:hsla(0,0%,100%,.4);padding:0 .4em;border-radius:3px}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{animation:passing-through 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;animation:slide-in 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview.dz-success .dz-success-mark{opacity:0}@media (min-width:992px){.dropzone .dz-preview.dz-success .dz-success-mark{opacity:.5}}.dropzone .dz-preview .dz-error-mark svg,.dropzone .dz-preview .dz-success-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;transition:all .2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;transition:opacity .4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:hsla(0,0%,100%,.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(180deg,#666,#444);position:absolute;top:0;left:0;bottom:0;width:0;transition:width .3s ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;transition:opacity .3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(180deg,#be2626,#a92222);padding:.5em 1.2em;color:#fff}.dropzone .dz-preview .dz-error-message:after{content:\"\";position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}.angular-ui-tree-empty{border:1px dashed #bbb;min-height:100px;background-color:#e5e5e5;background-image:linear-gradient(45deg,#fff 25%,transparent 0,transparent 75%,#fff 0,#fff),linear-gradient(45deg,#fff 25%,transparent 0,transparent 75%,#fff 0,#fff);background-size:60px 60px;background-position:0 0,30px 30px;pointer-events:none}.angular-ui-tree-nodes{position:relative;margin:0;padding:0;list-style:none}.angular-ui-tree-nodes .angular-ui-tree-nodes{padding-left:20px}.angular-ui-tree-node,.angular-ui-tree-placeholder{position:relative;margin:0;padding:0;min-height:20px;line-height:20px}.angular-ui-tree-hidden{display:none}.angular-ui-tree-placeholder{margin:10px;padding:0;min-height:30px}.angular-ui-tree-handle{cursor:move;text-decoration:none;font-weight:700;box-sizing:border-box;min-height:20px;line-height:20px}.angular-ui-tree-drag{position:absolute;pointer-events:none;z-index:999;opacity:.8}.angular-ui-tree-drag .tree-node-content{margin-top:0}.angular-ui-tree-handle{background:#f8faff;border:1px solid #dae2ea;color:#7c9eb2;padding:10px}.angular-ui-tree-handle:hover{color:#438eb9;background:#f4f6f7;border-color:#dce2e8}tr.angular-ui-tree-empty{height:100px}.group-title{background-color:#687074!important;color:#fff!important}.tree-node{border:1px solid #dae2ea;background:#f8faff;color:#7c9eb2}.nodrop{background-color:#f2dede}.tree-node-content{margin:10px}.tree-handle{padding:10px;background:#428bca;color:#fff;margin-right:10px}.angular-ui-tree-placeholder{background:#f0f9ff;border:2px dashed #bed2db;box-sizing:border-box}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-modal-dialog,.vjs-button>.vjs-icon-placeholder:before,.vjs-modal-dialog .vjs-modal-dialog-content{position:absolute;top:0;left:0;width:100%;height:100%}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.vjs-button>.vjs-icon-placeholder:before{text-align:center}@font-face{font-family:VideoJS;src:url(" + __webpack_require__(378) + "?#iefix) format(\"eot\")}@font-face{font-family:VideoJS;src:url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\"),url(data:application/x-font-ttf;charset=utf-8;base64,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) format(\"truetype\");font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder,.vjs-icon-play{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder:before,.vjs-icon-play:before{content:\"\\F101\"}.vjs-icon-play-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-play-circle:before{content:\"\\F102\"}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder,.vjs-icon-pause{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before,.vjs-icon-pause:before{content:\"\\F103\"}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder,.vjs-icon-volume-mute{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before,.vjs-icon-volume-mute:before{content:\"\\F104\"}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder,.vjs-icon-volume-low{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before,.vjs-icon-volume-low:before{content:\"\\F105\"}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder,.vjs-icon-volume-mid{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before,.vjs-icon-volume-mid:before{content:\"\\F106\"}.video-js .vjs-mute-control .vjs-icon-placeholder,.vjs-icon-volume-high{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control .vjs-icon-placeholder:before,.vjs-icon-volume-high:before{content:\"\\F107\"}.video-js .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-enter:before{content:\"\\F108\"}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-exit:before{content:\"\\F109\"}.vjs-icon-square{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-square:before{content:\"\\F10A\"}.vjs-icon-spinner{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-spinner:before{content:\"\\F10B\"}.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subtitles-button .vjs-icon-placeholder,.vjs-icon-subtitles{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subtitles-button .vjs-icon-placeholder:before,.vjs-icon-subtitles:before{content:\"\\F10C\"}.video-js .vjs-captions-button .vjs-icon-placeholder,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-captions{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-captions-button .vjs-icon-placeholder:before,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-captions:before{content:\"\\F10D\"}.video-js .vjs-chapters-button .vjs-icon-placeholder,.vjs-icon-chapters{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-chapters-button .vjs-icon-placeholder:before,.vjs-icon-chapters:before{content:\"\\F10E\"}.vjs-icon-share{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-share:before{content:\"\\F10F\"}.vjs-icon-cog{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-cog:before{content:\"\\F110\"}.video-js .vjs-play-progress,.video-js .vjs-volume-level,.vjs-icon-circle{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-progress:before,.video-js .vjs-volume-level:before,.vjs-icon-circle:before{content:\"\\F111\"}.vjs-icon-circle-outline{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-outline:before{content:\"\\F112\"}.vjs-icon-circle-inner-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-inner-circle:before{content:\"\\F113\"}.vjs-icon-hd{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-hd:before{content:\"\\F114\"}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder,.vjs-icon-cancel{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before,.vjs-icon-cancel:before{content:\"\\F115\"}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder,.vjs-icon-replay{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before,.vjs-icon-replay:before{content:\"\\F116\"}.vjs-icon-facebook{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-facebook:before{content:\"\\F117\"}.vjs-icon-gplus{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-gplus:before{content:\"\\F118\"}.vjs-icon-linkedin{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-linkedin:before{content:\"\\F119\"}.vjs-icon-twitter{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-twitter:before{content:\"\\F11A\"}.vjs-icon-tumblr{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-tumblr:before{content:\"\\F11B\"}.vjs-icon-pinterest{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-pinterest:before{content:\"\\F11C\"}.video-js .vjs-descriptions-button .vjs-icon-placeholder,.vjs-icon-audio-description{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-descriptions-button .vjs-icon-placeholder:before,.vjs-icon-audio-description:before{content:\"\\F11D\"}.video-js .vjs-audio-button .vjs-icon-placeholder,.vjs-icon-audio{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-audio-button .vjs-icon-placeholder:before,.vjs-icon-audio:before{content:\"\\F11E\"}.video-js{display:block;vertical-align:top;box-sizing:border-box;color:#fff;background-color:#000;position:relative;padding:0;font-size:10px;line-height:1;font-weight:400;font-style:normal;font-family:Arial,Helvetica,sans-serif}.video-js:-moz-full-screen{position:absolute}.video-js:-webkit-full-screen{width:100%!important;height:100%!important}.video-js[tabindex=\"-1\"]{outline:none}.video-js *,.video-js :after,.video-js :before{box-sizing:inherit}.video-js ul{font-family:inherit;font-size:inherit;line-height:inherit;list-style-position:outside;margin:0}.video-js.vjs-4-3,.video-js.vjs-16-9,.video-js.vjs-fluid{width:100%;max-width:100%;height:0}.video-js.vjs-16-9{padding-top:56.25%}.video-js.vjs-4-3{padding-top:75%}.video-js.vjs-fill,.video-js .vjs-tech{width:100%;height:100%}.video-js .vjs-tech{position:absolute;top:0;left:0}body.vjs-full-window{padding:0;margin:0;height:100%;overflow-y:auto}.vjs-full-window .video-js.vjs-fullscreen{position:fixed;overflow:hidden;z-index:1000;left:0;top:0;bottom:0;right:0}.video-js.vjs-fullscreen{width:100%!important;height:100%!important;padding-top:0!important}.video-js.vjs-fullscreen.vjs-user-inactive{cursor:none}.vjs-hidden{display:none!important}.vjs-disabled{opacity:.5;cursor:default}.video-js .vjs-offscreen{height:1px;left:-9999px;position:absolute;top:0;width:1px}.vjs-lock-showing{display:block!important;opacity:1;visibility:visible}.vjs-no-js{padding:20px;color:#fff;background-color:#000;font-size:18px;font-family:Arial,Helvetica,sans-serif;text-align:center;width:300px;height:150px;margin:0 auto}.vjs-no-js a,.vjs-no-js a:visited{color:#66a8cc}.video-js .vjs-big-play-button{font-size:3em;line-height:1.5em;height:1.5em;width:3em;display:block;position:absolute;top:10px;left:10px;padding:0;cursor:pointer;opacity:1;border:.06666em solid #fff;background-color:#2b333f;background-color:rgba(43,51,63,.7);border-radius:.3em;transition:all .4s}.vjs-big-play-centered .vjs-big-play-button{top:50%;left:50%;margin-top:-.75em;margin-left:-1.5em}.video-js .vjs-big-play-button:focus,.video-js:hover .vjs-big-play-button{border-color:#fff;background-color:#73859f;background-color:rgba(115,133,159,.5);transition:all 0s}.vjs-controls-disabled .vjs-big-play-button,.vjs-error .vjs-big-play-button,.vjs-has-started .vjs-big-play-button,.vjs-using-native-controls .vjs-big-play-button{display:none}.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button{display:block}.video-js button{background:none;border:none;color:inherit;display:inline-block;overflow:visible;font-size:inherit;line-height:inherit;text-transform:none;text-decoration:none;transition:none;-moz-appearance:none;appearance:none}.vjs-control .vjs-button{width:100%;height:100%}.video-js .vjs-control.vjs-close-button{cursor:pointer;height:3em;position:absolute;right:0;top:.5em;z-index:2}.video-js .vjs-modal-dialog{background:rgba(0,0,0,.8);background:linear-gradient(180deg,rgba(0,0,0,.8),hsla(0,0%,100%,0));overflow:auto;box-sizing:content-box}.video-js .vjs-modal-dialog>*{box-sizing:border-box}.vjs-modal-dialog .vjs-modal-dialog-content{font-size:1.2em;line-height:1.5;padding:20px 24px;z-index:1}.vjs-menu-button{cursor:pointer}.vjs-menu-button.vjs-disabled{cursor:default}.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu{display:none}.vjs-menu .vjs-menu-content{display:block;padding:0;margin:0;font-family:Arial,Helvetica,sans-serif;overflow:auto;box-sizing:content-box}.vjs-menu .vjs-menu-content>*{box-sizing:border-box}.vjs-scrubbing .vjs-menu-button:hover .vjs-menu{display:none}.vjs-menu li{list-style:none;margin:0;padding:.2em 0;line-height:1.4em;font-size:1.2em;text-align:center;text-transform:lowercase}.vjs-menu li.vjs-menu-item:focus,.vjs-menu li.vjs-menu-item:hover{background-color:#73859f;background-color:rgba(115,133,159,.5)}.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li.vjs-selected:hover{background-color:#fff;color:#2b333f}.vjs-menu li.vjs-menu-title{text-align:center;text-transform:uppercase;font-size:1em;line-height:2em;padding:0;margin:0 0 .3em;font-weight:700;cursor:default}.vjs-menu-button-popup .vjs-menu{display:none;position:absolute;bottom:0;width:10em;left:-3em;height:0;margin-bottom:1.5em;border-top-color:rgba(43,51,63,.7)}.vjs-menu-button-popup .vjs-menu .vjs-menu-content{background-color:#2b333f;background-color:rgba(43,51,63,.7);position:absolute;width:100%;bottom:1.5em;max-height:15em}.vjs-menu-button-popup .vjs-menu.vjs-lock-showing,.vjs-workinghover .vjs-menu-button-popup:hover .vjs-menu{display:block}.video-js .vjs-menu-button-inline{transition:all .4s;overflow:hidden}.video-js .vjs-menu-button-inline:before{width:2.222222222em}.video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline{width:12em}.vjs-menu-button-inline .vjs-menu{opacity:0;height:100%;width:auto;position:absolute;left:4em;top:0;padding:0;margin:0;transition:all .4s}.vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-menu-button-inline:focus .vjs-menu,.vjs-menu-button-inline:hover .vjs-menu{display:block;opacity:1}.vjs-no-flex .vjs-menu-button-inline .vjs-menu{display:block;opacity:1;position:relative;width:auto}.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu{width:auto}.vjs-menu-button-inline .vjs-menu-content{width:auto;height:100%;margin:0;overflow:hidden}.video-js .vjs-control-bar{display:none;width:100%;position:absolute;bottom:0;left:0;right:0;height:3em;background-color:#2b333f;background-color:rgba(43,51,63,.7)}.vjs-has-started .vjs-control-bar{display:-ms-flexbox;display:flex;visibility:visible;opacity:1;transition:visibility .1s,opacity .1s}.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{visibility:visible;opacity:0;transition:visibility 1s,opacity 1s}.vjs-controls-disabled .vjs-control-bar,.vjs-error .vjs-control-bar,.vjs-using-native-controls .vjs-control-bar{display:none!important}.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{opacity:1;visibility:visible}.vjs-has-started.vjs-no-flex .vjs-control-bar{display:table}.video-js .vjs-control{position:relative;text-align:center;margin:0;padding:0;height:100%;width:4em;-ms-flex:none;flex:none}.vjs-button>.vjs-icon-placeholder:before{font-size:1.8em;line-height:1.67}.video-js .vjs-control:focus,.video-js .vjs-control:focus:before,.video-js .vjs-control:hover:before{text-shadow:0 0 1em #fff}.video-js .vjs-control-text{border:0;clip:rect(0 0 0 0);height:1px;overflow:hidden;padding:0;position:absolute;width:1px}.vjs-no-flex .vjs-control{display:table-cell;vertical-align:middle}.video-js .vjs-custom-control-spacer{display:none}.video-js .vjs-progress-control{cursor:pointer;-ms-flex:auto;flex:auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-width:4em}.video-js .vjs-progress-control.disabled{cursor:default}.vjs-live .vjs-progress-control{display:none}.vjs-no-flex .vjs-progress-control{width:auto}.video-js .vjs-progress-holder{-ms-flex:auto;flex:auto;transition:all .2s;height:.3em}.video-js .vjs-progress-control .vjs-progress-holder{margin:0 10px}.video-js .vjs-progress-control:hover .vjs-progress-holder{font-size:1.6666666666666667em}.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled{font-size:1em}.video-js .vjs-progress-holder .vjs-load-progress,.video-js .vjs-progress-holder .vjs-load-progress div,.video-js .vjs-progress-holder .vjs-play-progress{position:absolute;display:block;height:100%;margin:0;padding:0;width:0;left:0;top:0}.video-js .vjs-play-progress{background-color:#fff}.video-js .vjs-play-progress:before{font-size:.9em;position:absolute;right:-.5em;top:-.333333333333333em;z-index:1}.video-js .vjs-load-progress{background:#bfc7d3;background:rgba(115,133,159,.5)}.video-js .vjs-load-progress div{background:#fff;background:rgba(115,133,159,.75)}.video-js .vjs-time-tooltip{background-color:#fff;background-color:hsla(0,0%,100%,.8);border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:relative;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-progress-holder:focus .vjs-time-tooltip{display:none}.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,.video-js .vjs-progress-control:hover .vjs-time-tooltip{display:block;font-size:.6em;visibility:visible}.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip{font-size:1em}.video-js .vjs-progress-control .vjs-mouse-display{display:none;position:absolute;width:1px;height:100%;background-color:#000;z-index:1}.vjs-no-flex .vjs-progress-control .vjs-mouse-display{z-index:0}.video-js .vjs-progress-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display{display:none}.vjs-mouse-display .vjs-time-tooltip{color:#fff;background-color:#000;background-color:rgba(0,0,0,.8)}.video-js .vjs-slider{position:relative;cursor:pointer;padding:0;margin:0 .45em;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#73859f;background-color:rgba(115,133,159,.5)}.video-js .vjs-slider.disabled{cursor:default}.video-js .vjs-slider:focus{text-shadow:0 0 1em #fff;box-shadow:0 0 1em #fff}.video-js .vjs-mute-control{cursor:pointer;-ms-flex:none;flex:none;padding-left:2em;padding-right:2em;padding-bottom:3em}.video-js .vjs-volume-control{cursor:pointer;margin-right:1em;display:-ms-flexbox;display:flex}.video-js .vjs-volume-control.vjs-volume-horizontal{width:5em}.video-js .vjs-volume-panel .vjs-volume-control{visibility:visible;opacity:0;width:1px;height:1px;margin-left:-1px}.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical,.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical .vjs-volume-level{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\"}.video-js .vjs-volume-panel{transition:width 1s}.video-js .vjs-volume-panel .vjs-mute-control:active~.vjs-volume-control,.video-js .vjs-volume-panel .vjs-mute-control:focus~.vjs-volume-control,.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active,.video-js .vjs-volume-panel .vjs-volume-control:active,.video-js .vjs-volume-panel .vjs-volume-control:focus,.video-js .vjs-volume-panel .vjs-volume-control:hover,.video-js .vjs-volume-panel:active .vjs-volume-control,.video-js .vjs-volume-panel:focus .vjs-volume-control,.video-js .vjs-volume-panel:hover .vjs-volume-control{visibility:visible;opacity:1;position:relative;transition:visibility .1s,opacity .1s,height .1s,width .1s,left 0s,top 0s}.video-js .vjs-volume-panel .vjs-mute-control:active~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-mute-control:focus~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:focus.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-horizontal,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em}.video-js .vjs-volume-panel .vjs-mute-control:active~.vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-mute-control:active~.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-mute-control:active~.vjs-volume-control.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-mute-control:focus~.vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-mute-control:focus~.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-mute-control:focus~.vjs-volume-control.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-mute-control:hover~.vjs-volume-control.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-volume-control:focus.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control:focus.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-volume-control:focus.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel .vjs-volume-control:hover.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical .vjs-volume-level,.video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical .vjs-volume-bar,.video-js .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-vertical .vjs-volume-level{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:focus,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:hover{width:9em;transition:width .1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{height:8em;width:3em;left:-3.5em;transition:visibility 1s,opacity 1s,height 1s 1s,width 1s 1s,left 1s 1s,top 1s 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{transition:visibility 1s,opacity 1s,height 1s 1s,width 1s,left 1s 1s,top 1s 1s}.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em;visibility:visible;opacity:1;position:relative;transition:none}.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{position:absolute;bottom:3em;left:.5em}.video-js .vjs-volume-panel{display:-ms-flexbox;display:flex}.video-js .vjs-volume-bar{margin:1.35em .45em}.vjs-volume-bar.vjs-slider-horizontal{width:5em;height:.3em}.vjs-volume-bar.vjs-slider-vertical{width:.3em;height:5em;margin:1.35em auto}.video-js .vjs-volume-level{position:absolute;bottom:0;left:0;background-color:#fff}.video-js .vjs-volume-level:before{position:absolute;font-size:.9em}.vjs-slider-vertical .vjs-volume-level{width:.3em}.vjs-slider-vertical .vjs-volume-level:before{top:-.5em;left:-.3em}.vjs-slider-horizontal .vjs-volume-level{height:.3em}.vjs-slider-horizontal .vjs-volume-level:before{top:-.3em;right:-.5em}.video-js .vjs-volume-panel.vjs-volume-panel-vertical{width:4em}.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level{height:100%}.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level{width:100%}.video-js .vjs-volume-vertical{width:3em;height:8em;bottom:8em;background-color:#2b333f;background-color:rgba(43,51,63,.7)}.video-js .vjs-volume-horizontal .vjs-menu{left:-2em}.vjs-poster{display:inline-block;background-repeat:no-repeat;background-position:50% 50%;background-size:contain;background-color:#000;cursor:pointer;margin:0;position:absolute;top:0;right:0;bottom:0;left:0;height:100%}.vjs-poster,.vjs-poster img{vertical-align:middle;padding:0}.vjs-poster img{display:block;margin:0 auto;max-height:100%;width:100%}.vjs-has-started .vjs-poster{display:none}.vjs-audio.vjs-has-started .vjs-poster{display:block}.vjs-using-native-controls .vjs-poster{display:none}.video-js .vjs-live-control{display:-ms-flexbox;display:flex;-ms-flex-align:flex-start;align-items:flex-start;-ms-flex:auto;flex:auto;font-size:1em;line-height:3em}.vjs-no-flex .vjs-live-control{display:table-cell;width:auto;text-align:left}.video-js .vjs-time-control{-ms-flex:none;flex:none;font-size:1em;line-height:3em;min-width:2em;width:auto;padding-left:1em;padding-right:1em}.video-js .vjs-current-time,.vjs-live .vjs-time-control,.vjs-no-flex .vjs-current-time{display:none}.vjs-no-flex .vjs-remaining-time.vjs-time-control.vjs-control{width:0!important;white-space:nowrap}.video-js .vjs-duration,.vjs-no-flex .vjs-duration{display:none}.vjs-time-divider{display:none;line-height:3em}.vjs-live .vjs-time-divider{display:none}.video-js .vjs-play-control .vjs-icon-placeholder{cursor:pointer;-ms-flex:none;flex:none}.vjs-text-track-display{position:absolute;bottom:3em;left:0;right:0;top:0;pointer-events:none}.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display{bottom:1em}.video-js .vjs-text-track{font-size:1.4em;text-align:center;margin-bottom:.1em;background-color:#000;background-color:rgba(0,0,0,.5)}.vjs-subtitles{color:#fff}.vjs-captions{color:#fc6}.vjs-tt-cue{display:block}video::-webkit-media-text-track-display{transform:translateY(-3em)}.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display{transform:translateY(-1.5em)}.video-js .vjs-fullscreen-control{cursor:pointer;-ms-flex:none;flex:none}.vjs-playback-rate .vjs-playback-rate-value,.vjs-playback-rate>.vjs-menu-button{position:absolute;top:0;left:0;width:100%;height:100%}.vjs-playback-rate .vjs-playback-rate-value{pointer-events:none;font-size:1.5em;line-height:2;text-align:center}.vjs-playback-rate .vjs-menu{width:4em;left:0}.vjs-error .vjs-error-display .vjs-modal-dialog-content{font-size:1.4em;text-align:center}.vjs-error .vjs-error-display:before{color:#fff;content:\"X\";font-family:Arial,Helvetica,sans-serif;font-size:4em;left:0;line-height:1;margin-top:-.5em;position:absolute;text-shadow:.05em .05em .1em #000;text-align:center;top:50%;vertical-align:middle;width:100%}.vjs-loading-spinner{display:none;position:absolute;top:50%;left:50%;margin:-25px 0 0 -25px;opacity:.85;text-align:left;border:6px solid rgba(43,51,63,.7);box-sizing:border-box;background-clip:padding-box;width:50px;height:50px;border-radius:25px}.vjs-seeking .vjs-loading-spinner,.vjs-waiting .vjs-loading-spinner{display:block}.vjs-loading-spinner:after,.vjs-loading-spinner:before{content:\"\";position:absolute;margin:-6px;box-sizing:inherit;width:inherit;height:inherit;border-radius:inherit;opacity:1;border:inherit;border-color:transparent;border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:before{animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite}.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:before{border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:after{border-top-color:#fff;animation-delay:.44s}@keyframes vjs-spinner-spin{to{transform:rotate(1turn)}}@keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}.vjs-chapters-button .vjs-menu ul{width:24em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder{position:absolute}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:\"\\F10D\";font-size:1.5em;line-height:inherit}.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-custom-control-spacer{-ms-flex:auto;flex:auto}.video-js.vjs-layout-tiny:not(.vjs-fullscreen).vjs-no-flex .vjs-custom-control-spacer{width:auto}.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-subtitles-button .vjs-audio-button,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-audio-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-progress-control,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subtitles-button,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-control,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-audio-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-chapters-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-current-time,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-descriptions-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-duration,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-mute-control,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-playback-rate,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-remaining-time,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subtitles-button,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-time-divider,.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-control{display:none}.vjs-modal-dialog.vjs-text-track-settings{background-color:#2b333f;background-color:rgba(43,51,63,.75);color:#fff;height:70%}.vjs-text-track-settings .vjs-modal-dialog-content{display:table}.vjs-text-track-settings .vjs-track-settings-colors,.vjs-text-track-settings .vjs-track-settings-controls,.vjs-text-track-settings .vjs-track-settings-font{display:table-cell}.vjs-text-track-settings .vjs-track-settings-controls{text-align:right;vertical-align:bottom}.vjs-text-track-settings fieldset{margin:5px;padding:3px;border:none}.vjs-text-track-settings fieldset span{display:inline-block;margin-left:5px}.vjs-text-track-settings legend{color:#fff;margin:0 0 5px}.vjs-text-track-settings .vjs-label{position:absolute;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);display:block;margin:0 0 5px;padding:0;border:0;height:1px;width:1px;overflow:hidden}.vjs-track-settings-controls button:active,.vjs-track-settings-controls button:focus{outline-style:solid;outline-width:medium;background-image:linear-gradient(0deg,#fff 88%,#73859f)}.vjs-track-settings-controls button:hover{color:rgba(43,51,63,.75)}.vjs-track-settings-controls button{background-color:#fff;background-image:linear-gradient(-180deg,#fff 88%,#73859f);color:#2b333f;cursor:pointer;border-radius:2px}.vjs-track-settings-controls .vjs-default-button{margin-right:1em}@media print{.video-js>:not(.vjs-tech):not(.vjs-poster){visibility:hidden}}@media \\0screen{.vjs-user-inactive.vjs-playing .vjs-control-bar :before{content:\"\"}}@media \\0screen{.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{visibility:hidden}}.vjs-picture-in-picture-control,.vjs-remaining-time,.vjs-seek-to-live-control{display:none!important}/*!\r\n * Stylesheet for the Date Range Picker, for use with Bootstrap 3.x\r\n *\r\n * Copyright 2013 Dan Grossman ( http://www.dangrossman.info )\r\n * Licensed under the Apache License v2.0\r\n * http://www.apache.org/licenses/LICENSE-2.0\r\n *\r\n * Built for http://www.improvely.com\r\n */.daterangepicker.dropdown-menu{max-width:none;z-index:3000}.daterangepicker.opensleft .calendar,.daterangepicker.opensleft .ranges,.daterangepicker.opensright .calendar,.daterangepicker.opensright .ranges{float:left;margin:4px}.daterangepicker .ranges{width:160px;text-align:left;float:left!important}.daterangepicker .ranges .range_inputs>div{float:left}.daterangepicker .ranges .range_inputs>div:nth-child(2){padding-left:11px}.daterangepicker .calendar{display:none;max-width:270px}.daterangepicker.show-calendar .calendar{display:block}.daterangepicker .calendar.single .calendar-date{border:none}.daterangepicker .calendar td,.daterangepicker .calendar th{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;white-space:nowrap;text-align:center;min-width:32px}.daterangepicker .daterangepicker_end_input label,.daterangepicker .daterangepicker_start_input label{color:#333;display:block;font-size:11px;font-weight:400;height:20px;line-height:20px;margin-bottom:2px;text-shadow:#fff 1px 1px 0;text-transform:uppercase;width:74px}.daterangepicker .ranges input{font-size:11px}.daterangepicker .ranges .input-mini{border:1px solid #ccc;border-radius:4px;color:#555;display:block;font-size:11px;height:30px;line-height:30px;vertical-align:middle;margin:0 0 10px;padding:0 6px;width:74px}.daterangepicker .ranges ul{list-style:none;margin:0;padding:0}.daterangepicker .ranges li{font-size:13px;background:#f5f5f5;border:1px solid #f5f5f5;color:#08c;padding:3px 12px;margin-bottom:8px;border-radius:5px;cursor:pointer}.daterangepicker .ranges li.active,.daterangepicker .ranges li:hover{background:#08c;border:1px solid #08c;color:#fff}.daterangepicker .calendar-date{border:1px solid #ddd;padding:4px;border-radius:4px;background:#fff}.daterangepicker .calendar-time{text-align:center;margin:8px auto 0;line-height:30px}.daterangepicker{position:absolute;background:#fff;top:100px;left:20px;padding:4px;margin-top:1px;border-radius:4px}.daterangepicker.opensleft:before{position:absolute;top:-7px;right:9px;display:inline-block;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-left:7px solid transparent;border-bottom-color:rgba(0,0,0,.2);content:\"\"}.daterangepicker.opensleft:after{position:absolute;top:-6px;right:10px;display:inline-block;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent;content:\"\"}.daterangepicker.opensright:before{position:absolute;top:-7px;left:9px;display:inline-block;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-left:7px solid transparent;border-bottom-color:rgba(0,0,0,.2);content:\"\"}.daterangepicker.opensright:after{position:absolute;top:-6px;left:10px;display:inline-block;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent;content:\"\"}.daterangepicker table{width:100%;margin:0}.daterangepicker td,.daterangepicker th{text-align:center;width:20px;height:20px;border-radius:4px;cursor:pointer;white-space:nowrap}.daterangepicker td.disabled,.daterangepicker td.off{color:#999}.daterangepicker td.available:hover,.daterangepicker th.available:hover{background:#eee}.daterangepicker td.in-range{background:#ebf4f8;border-radius:0}.daterangepicker td.available+td.start-date{border-radius:4px 0 0 4px}.daterangepicker td.in-range+td.end-date{border-radius:0 4px 4px 0}.daterangepicker td.start-date.end-date{border-radius:4px!important}.daterangepicker td.active,.daterangepicker td.active:hover{background-color:#357ebd;border-color:#3071a9;color:#fff}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.daterangepicker select.monthselect{margin-right:2%;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.ampmselect,.daterangepicker select.hourselect,.daterangepicker select.minuteselect{width:50px;margin-bottom:0}.daterangepicker_start_input{float:left}.daterangepicker_end_input{float:left;padding-left:11px}.daterangepicker th.month{width:auto}.logo a,.sidebar-nav a{text-transform:capitalize}.collapsed+ul{max-height:0;overflow:hidden}.active .collapsed+ul{max-height:500px;transition:all .45s ease-in-out}.sidebar-nav li.active a.collapsed .toggle{webkit-transform:rotate(0deg);transform:rotate(0deg)}.sidebar-nav>li ul>li.active>a.allpages,.sidebar-nav>li ul>li.active>a.allpolls,.sidebar-nav>li ul>li.active>a.allposts,.sidebar-nav>li ul>li.active>a.categories,.sidebar-nav>li ul>li.active>a.library,.sidebar-nav>li ul>li.active>a.tags{cursor:pointer}.hamburger{float:right}@media (max-width:1200px){.navbar-header{float:right}}.navbar .user-block{float:right;margin-left:0;margin-right:0}@media (min-width:1200px){.navbar .user-block{margin-right:-5px}}.navbar .user-block .nav>li>a{padding-left:10px;padding-right:10px}.navbar .user-block .user-block-name{display:none}@media (min-width:992px){.navbar .user-block .user-block-name{display:inline-block}}.navbar .realtime-block{margin-left:-5px;float:left;margin-right:0}.navbar .realtime-block .dropdown-menu{padding:5px 0;min-width:280px}.navbar .realtime-block .dropdown-menu li{padding:5px 15px;color:#555;font-weight:600;text-transform:capitalize;line-height:14px}.navbar .realtime-block .dropdown-menu li span{font-weight:700;font-size:14px}.navbar .notification-block{margin-left:0;margin-right:0;line-height:20px}.navbar .notification-block .notification-block-inner{padding:15px 10px}.navbar .notification-block .nav>li>a{padding-left:5px;padding-right:5px}@media (min-width:600px){.navbar .notification-block .nav>li>a{padding-left:10px;padding-right:10px}}.navbar .notification-block .nav>li>a,.navbar .notification-block .notification-block-inner a{font-size:15px}.navbar .notification-block .nav>li>a,.navbar .notification-block .nav>li>a:hover,.navbar .notification-block .notification-block-inner a,.navbar .notification-block .notification-block-inner a:hover{color:#838383}.navbar .notification-block .nav>li>a.notification-highlights,.navbar .notification-block .notification-block-inner a.notification-highlights{color:#de1d1d!important}.navbar .notification-block.notification-block-small .dropdown-menu{min-width:auto}.navbar .notification-block .dropdown-menu{padding:10px;min-width:320px;left:50%;transform:translateX(-50%)}@media (min-width:600px){.navbar .notification-block .dropdown-menu{right:0;left:auto;transform:translateX(0)}}.navbar .notification-block .dropdown-menu>div{font-size:18px;font-weight:600;margin-bottom:10px}.navbar .notification-block .dropdown-menu>ul{max-height:600px;overflow:auto}.navbar .notification-block .dropdown-menu>ul a{color:#337ab7;font-size:14px}.navbar .notification-block .dropdown-menu>ul a.default-color,.navbar .notification-block .dropdown-menu>ul a.default-color:hover{color:#333}.navbar .notification-block .dropdown-menu>ul a:hover{color:#337ab7;opacity:.8;text-decoration:none}.navbar .notification-block .dropdown-menu>ul li{padding:5px 0;font-size:14px}.navbar .notification-block .dropdown-menu>ul .title{color:#333}.navbar .notification-block .dropdown-menu>ul .time{font-size:12px}.navbar .notification-block .assigned_icon-wrapper,.navbar .notification-block .notification_icon-wrapper{display:block;margin-right:5px}.navbar .notification-block .assigned_icon-wrapper{width:20px}.navbar .notification-block .notification_icon-wrapper{width:28px}.navbar-focus-block{padding:16px 10px;cursor:pointer}@media (min-width:992px){.navbar-focus-block{padding:10px}}.navbar-focus-block .navbar-focus-block-text{font-size:16px;color:#777;line-height:30px}.navbar-focus-block svg circle{fill:transparent}.navbar-focus-block svg.locked circle{fill:#e77777}.navbar-focus-block svg.current circle{fill:#5cb85c}.navbar-focus-block.active{cursor:default}.navbar-focus-block .navbar-focus-block-text{display:none}@media (min-width:992px){.navbar-focus-block .navbar-focus-block-text{display:block}}.sidebar-nav>li>ul>li>a{position:relative}.sidebar-nav svg{position:absolute;left:10px;top:50%;transform:translateY(-50%);display:block;width:18px;height:18px}.sidebar-nav svg circle{fill:transparent}.sidebar-nav svg.locked circle{fill:#e77777}.sidebar-nav svg.current circle{fill:#5cb85c}.ng-cloak,.x-ng-cloak,[data-ng-cloak],[ng-cloak],[ng\\:cloak],[x-ng-cloak]{display:none!important}.color-picker-wrapper .input-group .color-picker-input-swatch{width:100%;max-width:160px;text-align:center;padding-left:0}.color-picker-action-close{webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out;display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;background-color:#d9534f;border-color:#d43f3a;padding:4px 8px}.color-picker-action-close:hover{background-color:#c9302c;border-color:#ac2925}.color-picker-action-reset{webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out;display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;background-color:#337ab7;border-color:#2e6da4;padding:4px 8px}.color-picker-action-reset:hover{background-color:#286090;border-color:#204d74}.real-time-analitics-title{font-size:24px;font-weight:700;margin-bottom:30px;color:#555}.isp-chart-title{font-size:20px;font-weight:700;text-transform:capitalize;margin-bottom:5px;color:#555}.hc-chart{display:block;width:100%;height:100%;min-width:310px}.hc-chart .highcharts-color-none tspan{font-size:11px!important}.isp-chart{width:100%;height:300px;position:relative}.isp-chart.isp-chart-total{height:400px}.isp-chart-wrapper{margin-bottom:30px}.hc-chart .highcharts-credits,.highcharts-range-selector-group{display:none!important}.hc-chart-zoom-wrapper{overflow:hidden;margin-top:10px}.hc-chart-zoom-wrapper li,.hc-chart-zoom-wrapper p,.hc-chart-zoom-wrapper ul{float:left;line-height:26px}.hc-chart-zoom-wrapper ul{margin-bottom:0}.hc-chart-zoom-wrapper li{margin:0 3px}.hc-chart-zoom-wrapper li a{display:block;cursor:pointer;width:34px;background:#eee;font-weight:600;text-align:center;font-size:12px;color:#fff;background-color:#337ab7;border-color:#2e6da4;border-radius:4px;text-decoration:none;transition:all .15s ease-in-out;opacity:.95}@media (min-width:480px){.hc-chart-zoom-wrapper li a{width:40px}}.hc-chart-zoom-wrapper li a.active,.hc-chart-zoom-wrapper li a:hover{background-color:#286090;border-color:#204d74;opacity:1}.hc-chart-zoom-wrapper li a:hover{transition:all .15s ease-in-out}.hc-chart-zoom-wrapper li:first-child{margin-left:0}.visible-sm{display:block!important}@media (min-width:1200px){.visible-sm{display:none!important}}.normalize{margin:0;padding:0}.normalizeImp{margin:0!important;padding:0!important}.ver-al-m{vertical-align:middle!important}.widget-only-header header{border-bottom:none}textarea.url-field{min-height:70px;word-break:break-all}.float-left{float:left}.overflow{overflow:hidden}.vertical-top{vertical-align:top}.width-100{width:100%}.hidden-sm{display:none!important}@media (min-width:1200px){.hidden-sm{display:block!important}}.text-transfomr-ca{text-transform:capitalize}.form-group textarea{min-height:80px}.text-center{text-align:center}.sidebar-nav>li>a .icon{left:5px}.sidebar-nav>li>a .icon .fa.fa-mobile{font-size:26px;font-size:22px}.btn-info.active{background-color:#269abc;border-color:#1b6d85}ul{list-style:none;padding:0}.overflow-hidden{overflow:hidden}.disabled-select{cursor:not-allowed;pointer-events:none;opacity:.5}.remove-from-list{line-height:14px;cursor:pointer;color:#fff;background-color:#777;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;display:inline-block;width:14px;height:14px;text-align:center;margin-right:5px}.remove-from-list:hover{background-color:#d9534f}.list-added,.list-tags{margin-top:10px;margin-bottom:20px}.list-added li,.list-tags li{display:inline-block;margin-right:12px;margin-bottom:5px}.list-approvals{margin-bottom:0}.list-approvals li{display:inline-block;margin-right:20px;margin-bottom:8px}.list-approvals img{width:24px;display:block;cursor:pointer}.list-approvals span{display:inline-block;line-height:24px;vertical-align:middle}.list-approvals .remove-from-list{line-height:12px;margin-right:0;margin-left:3px}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:auto}section.widget{width:100%;float:left;margin-left:0;margin-right:0}section.widget header.has-btn-header h5{line-height:34px}section.widget.share-on-telegraf-x{padding-bottom:0}section.widget.share-on-telegraf-x .widget-body{padding:15px 0}section.widget.share-on-telegraf-x header{padding-top:10px;padding-bottom:10px}.vjs-poster{background-size:100%}hr{margin:10px 0}.table-filter{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}.table-filter>span{line-height:33px;float:left;text-align:center;margin-top:20px;display:block;width:100%}@media (min-width:600px){.table-filter>span{width:auto;display:inline-block}}@media (min-width:1600px){.table-filter>span{margin-top:0}}.table-filter .bulk-actions{position:relative;margin-right:0;display:block;float:left;width:100%}@media (min-width:600px){.table-filter .bulk-actions{width:auto;margin-right:30px}}.table-filter .bulk-actions>a{margin-top:20px;width:100%}@media (min-width:600px){.table-filter .bulk-actions>a{width:auto;margin-top:0}}.table-filter .bulk-actions select{width:100%}@media (min-width:600px){.table-filter .bulk-actions select{width:auto}}.table-filter .change-preview{display:block;float:left;margin-right:20px;line-height:33px}.table-filter .change-preview a{margin-right:5px}.table-filter select{border-radius:4px;-webkit-radius:4px;-moz-radius:4px;height:33px;width:100%;display:block;float:left;margin-right:5px}@media (min-width:600px){.table-filter select{width:auto}}.table-filter>select{clear:left;margin-top:20px}@media (min-width:1600px){.table-filter>select{clear:inherit;margin-top:0}}.table-filter>a.btn{float:left;display:block;margin-bottom:0;margin-top:20px;width:100%}@media (min-width:600px){.table-filter>a.btn{width:auto}}@media (min-width:1600px){.table-filter>a.btn{margin-top:0}}@media (min-width:600px){.table-filter>a.btn.btn-info{margin-left:30px}}.table-filter .search{display:block;width:100%;float:right}@media (min-width:600px){.table-filter .search{width:250px}}.categories-posts .table-filter .search,.tags-posts .table-filter .search{margin-top:20px;width:100%}@media (min-width:600px){.categories-posts .table-filter .search,.tags-posts .table-filter .search{width:300px;margin-top:0}}.table-filter .search .search-wrapper,.table-filter .search .type-all{display:inline-block}.table-filter label{line-height:33px}.range-picker{margin-right:5px;display:block;float:left;margin-top:20px;margin-bottom:0;width:100%;clear:left}@media (min-width:1600px){.range-picker{clear:inherit;margin-top:0}}@media (min-width:600px){.range-picker{width:200px}}.range-picker input{width:100%}.range-picker.range-picker-full-width{width:100%;margin-top:0;margin-right:0}.status-filter{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}.status-filter ul{float:left}.status-filter li{float:left;padding-right:5px;line-height:25px}.status-filter li a:hover{text-decoration:none}.status-filter .active{color:#555;font-weight:700}.status-filter>.search{float:right;width:100%}@media (min-width:600px){.status-filter>.search{width:300px}}.dropted{opacity:.4}.form-control{height:33px;padding-top:0;padding-bottom:0;line-height:33px}textarea.form-control{line-height:18px;padding:7px}.slideInFadeDown{animation:slideInFadeDown .3s linear}@keyframes slideInFadeDown{0%{transform:translate3d(0,-100%,0);visibility:visible;opacity:0}50%{opacity:0}to{transform:translateZ(0);opacity:1}}.background-white{background:#fff}.form-group.inline-block,.inline-block{display:inline-block!important}.middle-align{vertical-align:middle}.auto-width{width:auto!important}.fake-textarea{line-height:18px;padding:7px;min-height:80px;font-size:18px;border:1px solid #de1d1d!important;color:#555;border-radius:2px;font-weight:400}.post-row{position:relative}.full-width{width:100%!important}.quick-edit{width:100%}.pagination{margin-right:20px}.ng-table-counts{margin-bottom:20px}.mce-flow-layout-item.mce-last{position:absolute;top:0;right:0}.edit-media .mce-flow-layout-item.mce-last{float:none}.btn-small{padding-top:0;padding-bottom:0;line-height:18px}.grey-btn{border:1px solid #ccc;background-color:#f0f0f0;color:#333}.grey-btn:hover{background-color:#e3e3e3}.forbiden-placeholder{position:absolute;left:0;top:0;bottom:0;right:0;background:rgba(0,0,0,.4);z-index:1;cursor:default;min-height:54px}.forbiden-placeholder:after{position:absolute;content:\"\";top:50%;left:50%;width:60%;padding-bottom:60%;height:0;background:url(" + __webpack_require__(389) + ") no-repeat;background-size:100%;transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.mce-i-poll{background:url(" + __webpack_require__(396) + ") no-repeat;width:20px;height:20px}.mce-i-rating{background:url(" + __webpack_require__(398) + ") no-repeat;width:20px;height:20px}.mce-i-latin{background:url(" + __webpack_require__(383) + ") no-repeat;width:22px;height:20px;background-size:100% auto}.mce-i-h2,.mce-i-h3{width:20px;height:20px;display:block}.mce-i-h2:after,.mce-i-h3:after{content:\"H2\";font-weight:700}.mce-i-h3:after{content:\"H3\"}.mce-i-quote{background:url(" + __webpack_require__(397) + ") no-repeat;width:20px;height:20px}.mce-i-tnow{background:url(" + __webpack_require__(404) + ") no-repeat;width:20px;height:20px}.mce-i-daljinac{background:url(" + __webpack_require__(386) + ") no-repeat;width:20px;height:20px}.mce-i-interview{background:url(" + __webpack_require__(392) + ") no-repeat;width:20px;height:20px}.mce-i-video{background:url(" + __webpack_require__(406) + ") no-repeat;width:20px;height:20px}.mce-i-embed{background:url(" + __webpack_require__(388) + ") no-repeat;width:20px;height:20px}.mce-i-telegraf-tv{background:url(" + __webpack_require__(403) + ") no-repeat;width:20px;height:20px}.mce-i-tag{background:url(" + __webpack_require__(402) + ") no-repeat;width:20px;height:20px;background-size:100%;background-position:50%}.mce-i-gallery{background:url(" + __webpack_require__(390) + ") no-repeat;width:20px;height:20px}.mce-i-recommended-news{background:url(" + __webpack_require__(399) + ") no-repeat;width:20px;height:20px;background-size:100%;background-position:50%}.mce-i-blog{background:url(" + __webpack_require__(381) + ") no-repeat;width:24px;height:24px}.mce-i-ai-button .mce-btn.mce-active:hover,.mce-i-ai-button>div,.mce-i-ai-button>div.mce-active,.mce-i-ai-button>div.mce-opened,.mce-i-ai-button>div.mce-opened-under,.mce-i-ai-button>div:focus,.mce-i-ai-button>div:hover{background-color:#000;border-color:#000;border-radius:5px}.mce-i-ai-button .mce-btn.mce-active:hover .mce-txt,.mce-i-ai-button>div.mce-active .mce-txt,.mce-i-ai-button>div.mce-opened-under .mce-txt,.mce-i-ai-button>div.mce-opened .mce-txt,.mce-i-ai-button>div .mce-txt,.mce-i-ai-button>div:focus .mce-txt,.mce-i-ai-button>div:hover .mce-txt{color:#fff;display:inline-block;vertical-align:middle}.mce-i-ai-button .mce-btn.mce-active:hover .mce-caret,.mce-i-ai-button>div.mce-active .mce-caret,.mce-i-ai-button>div .mce-caret,.mce-i-ai-button>div.mce-opened-under .mce-caret,.mce-i-ai-button>div.mce-opened .mce-caret,.mce-i-ai-button>div:focus .mce-caret,.mce-i-ai-button>div:hover .mce-caret{border-top-color:#fff}.mce-i-ai-button .mce-btn.mce-active:hover .mce-i-ai,.mce-i-ai-button>div.mce-active .mce-i-ai,.mce-i-ai-button>div .mce-i-ai,.mce-i-ai-button>div.mce-opened-under .mce-i-ai,.mce-i-ai-button>div.mce-opened .mce-i-ai,.mce-i-ai-button>div:focus .mce-i-ai,.mce-i-ai-button>div:hover .mce-i-ai{vertical-align:middle;background:url(" + __webpack_require__(153) + ") no-repeat;width:20px;height:20px;background-position:0;padding-right:5px}.mce-i-ai-button .mce-btn.mce-active:hover,.mce-i-ai-button>div.mce-active,.mce-i-ai-button>div.mce-opened,.mce-i-ai-button>div.mce-opened-under,.mce-i-ai-button>div:focus,.mce-i-ai-button>div:hover{background-color:#404040;border-color:#404040}.mce-menu{border-radius:5px;background-color:#fff;margin-top:1px}.mce-menu .mce-ai-menu-item:hover{background-color:#000;color:#fff}.mce-tinymce.mce-container.mce-panel{width:100%!important;border-color:#ccc;box-sizing:border-box}.mce-tinymce.mce-container.mce-panel iframe{min-height:600px!important}.edit-media .mce-tinymce.mce-container.mce-panel iframe{min-height:200px!important}.mce-flow-layout{padding-right:40px;position:relative}.close-edit{position:absolute;right:0;top:0}section.widget section.widget.edit{margin:0;padding:0}.mobileHiddenTable{display:none}@media (min-width:600px){.mobileHiddenTable{display:table-cell}}.capitalize{text-transform:capitalize}p.permalink span{line-height:27px;display:inline-block}p.permalink input{width:200px;height:27px}p.permalink a,p.permalink input{margin-right:5px;vertical-align:top}p.permalink a{padding:3px 6px}p.permalink .edit-slug{margin-right:5px;background:#f9f5c2;padding:0 2px}p.permalink .show-edit{display:inline-block}p.permalink .hidden-edit{display:none}.post-editor{margin-bottom:20px}.disccusion select,.ng-table--order select,.single-user select,.systems-data select,.widget.attributes select,.widget.choice select{width:auto;display:inline-block}.disccusion label,.ng-table--order label,.single-user label,.systems-data label,.widget.attributes label,.widget.choice label{margin-right:10px}.disccusion label.readonly,.ng-table--order label.readonly,.single-user label.readonly,.systems-data label.readonly,.widget.attributes label.readonly,.widget.choice label.readonly{border-radius:4px;padding:0 10px}.disccusion .input-group,.ng-table--order .input-group,.single-user .input-group,.systems-data .input-group,.widget.attributes .input-group,.widget.choice .input-group{display:inline-block;vertical-align:middle}.disccusion .input-group input,.ng-table--order .input-group input,.single-user .input-group input,.systems-data .input-group input,.widget.attributes .input-group input,.widget.choice .input-group input{padding:0}.qrcode-wrapper{width:250px;height:250px;position:relative;margin:0 auto}.lazy-loading{display:block;position:absolute;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.7);z-index:1}.single-post.edit-post .f-image .lazy-loading{position:relative;width:100%;height:0;padding-bottom:56.45%}.lazy-loading-on-scroll{padding-bottom:75%;background:#fff;position:relative}.lazy-loading-on-scroll .lazy-loading img{width:auto;top:50%;left:50%}.lazy-loading .image-wrapper{position:relative;width:100%;height:100%}.single-post.edit-post .f-image .lazy-loading .image-wrapper{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.lazy-loading img{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.single-post.edit-post .f-image .spinner-show{height:0}.spinner-show+.lazy-loading{visibility:visible}.single-post.edit-post .f-image .spinner-show+.lazy-loading{display:block}.spinner-hide+.lazy-loading{visibility:hidden}.single-post.edit-post .f-image .spinner-hide+.lazy-loading{display:none}.grid-wrapper{padding:10px;background:#eee;margin-bottom:20px;width:100%;float:left;margin-left:0;margin-right:0;overflow:hidden!important}.upload_video .grid-wrapper{overflow:initial!important;margin-bottom:0}.set-image-modal .grid-wrapper{position:absolute;left:15px;right:15px;bottom:1px;top:150px;overflow:hidden;width:auto;top:170px}@media (min-width:360px){.set-image-modal .grid-wrapper{top:150px}}@media (min-width:600px){.set-image-modal .grid-wrapper{top:170px}}@media (min-width:700px){.set-image-modal .grid-wrapper{top:150px}}@media (min-width:992px){.set-image-modal .grid-wrapper{top:85px}}@media (min-width:1350px){.set-image-modal .grid-wrapper{top:65px}}.set-image-modal .grid-wrapper>ul{padding:10px;overflow-y:scroll;position:absolute;top:0;right:0;bottom:0;left:0}.grid-wrapper ul{width:100%;float:left;margin-left:0;margin-right:0;margin:0}.grid-wrapper li{float:left;text-align:center;padding:5px;width:50%;position:relative}@media (min-width:600px){.grid-wrapper li{width:25%}}@media (min-width:1200px){.grid-wrapper li{width:20%}}@media (min-width:1600px){.grid-wrapper li{width:10%}}.set-image-modal .grid-wrapper li{width:100%}@media (min-width:420px){.set-image-modal .grid-wrapper li{width:50%}}@media (min-width:600px){.set-image-modal .grid-wrapper li{width:100%}}@media (min-width:800px){.set-image-modal .grid-wrapper li{width:50%}}@media (min-width:992px){.set-image-modal .grid-wrapper li{width:25%}}@media (min-width:1200px){.set-image-modal .grid-wrapper li{width:20%}}@media (min-width:1600px){.set-image-modal .grid-wrapper li{width:12.5%}}.upload_video .grid-wrapper li{width:100%}.upload_video .grid-wrapper li.portrait{width:50%}@media (min-width:600px){.upload_video .grid-wrapper li{width:50%}.upload_video .grid-wrapper li.portrait{width:33%}}@media (min-width:992px){.upload_video .grid-wrapper li{width:25%}.upload_video .grid-wrapper li.uploadedThumb{width:20%}.upload_video .grid-wrapper li.portrait{width:15%}}.video_edit .upload_video .grid-wrapper li{width:100%}.video_edit .upload_video .grid-wrapper li.portrait{width:50%}@media (min-width:600px){.video_edit .upload_video .grid-wrapper li{width:50%}.video_edit .upload_video .grid-wrapper li.portrait{width:33%}}@media (min-width:1350px){.video_edit .upload_video .grid-wrapper li{width:25%}.video_edit .upload_video .grid-wrapper li.portrait,.video_edit .upload_video .grid-wrapper li.uploadedThumb{width:20%}}.upload_video .grid-wrapper li.portrait .img-wrapp{padding-bottom:177.78%}.grid-wrapper li .img-wrapp{padding-bottom:75%;position:relative;background:#fff}.grid-wrapper li .img-wrapp.active,.grid-wrapper li .img-wrapp.multi-select{box-shadow:0 0 4px 4px #33b0dd}.grid-wrapper li .img-wrapp .loader-thumb{position:absolute;top:0;left:0;bottom:0;right:0;display:block;text-align:center}.grid-wrapper li .img-wrapp .loader-thumb img{vertical-align:middle;width:auto;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);width:80px;height:80px}.all-videos .grid-wrapper li .img-wrapp,.video-modal .grid-wrapper li .img-wrapp{background-size:auto 100%;background-repeat:no-repeat;background-position:50%}.grid-wrapper li img{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;max-width:100%;display:block}.grid-wrapper .dropzone{margin-bottom:0}.video-wrapper .vjs-poster{background-size:auto 100%}.search-wrapper{position:relative}.search-wrapper .autocomplete-result{position:absolute;top:33px;left:0;background:#ddd;border:1px solid #ccc;border-top:none;border-radius:4px;width:100%;height:350px;overflow-y:scroll;z-index:1}.upload_video .search-wrapper .autocomplete-result.restriction-autocomplete,.video-edit .search-wrapper .autocomplete-result.restriction-autocomplete{height:200px}.search-wrapper .autocomplete-result li{padding:4px 12px;line-height:20px;cursor:pointer}.search-wrapper .autocomplete-result li.active,.search-wrapper .autocomplete-result li:hover{background:#fff}.search-wrapper .autocomplete-result li.text-center.active,.search-wrapper .autocomplete-result li.text-center:hover{background:#ddd}.search-wrapper .autocomplete-result li a.btn{position:static!important}.bulk-actions-edit .search-wrapper li{font-size:13px}#sidebar::-webkit-scrollbar{width:1px}#sidebar::-webkit-scrollbar-thumb,#sidebar::-webkit-scrollbar-track{background-color:#242424;width:1px}@-moz-document url-prefix(){table{border-collapse:separate}.table>thead:first-child>tr:first-child>th{border-top:1px solid #dee4ee}.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #dee4ee}}.margin-left-5{margin-left:5px!important}.margin-right-5{margin-right:5px!important}.margin-right-0{margin-right:0!important}.margin-left-10{margin-left:10px!important}.margin-left-0{margin-left:0!important}.margin-right-10{margin-right:10px!important}.margin-left-20{margin-left:20px!important}.margin-right-20{margin-right:20px!important}.margin-bottom-20{margin-bottom:20px!important}.margin-bottom-15{margin-bottom:15px!important}.margin-bottom-10{margin-bottom:10px!important}.margin-bottom-5{margin-bottom:5px!important}.margin-top-0{margin-top:0!important}.margin-top-5{margin-top:5px!important}.margin-top-10{margin-top:10px!important}.margin-top-15{margin-top:15px!important}.margin-top-20{margin-top:20px!important}.margin-bottom-0{margin-bottom:0!important}.padding-top-0{padding-top:0!important}.padding-bottom-0{padding-bottom:0!important}.padding-top-15{padding-top:15px!important}.padding-bottom-15{padding-bottom:15px!important}.character-count{position:absolute;top:0;right:0;color:#fff;line-height:24px;padding:0 5px;background:#337ab7;opacity:.6}.character-count.danger{opacity:1;background:#d9534f}.character-count.warning{opacity:.8;background:#ff8d00}.character-count-wrapper{position:relative}.character-count-wrapper textarea{padding-right:35px}.upload-type-wrapper{overflow:hidden;margin-bottom:10px}.set-image-modal .upload-type-wrapper{margin-top:10px;margin-right:10px}.upload-type-wrapper label,.upload-type-wrapper select{float:right;width:auto}.upload-type-wrapper label{display:block;margin-right:10px;margin:0 10px 0 0;line-height:33px}.event-stream-error,.offline-error-wrapper{position:fixed;bottom:0;left:0;right:0;padding:10px;background:#de1d1d;color:#fff;text-align:center;font-weight:600;font-size:16px;letter-spacing:.05em;z-index:100059}.event-stream-error{background:#ff8d00}.danger-color{color:#d9534f}.remove-large{text-align:center;font-size:24px;font-weight:700}.search .remove-large{position:absolute;right:0;top:0;bottom:0;width:26px}.align-middle{vertical-align:middle!important}.relative-position{position:relative}option.level0{font-weight:700!important}@media (min-width:1200px){.search-all-post-sortable-wrapper .status-filter{display:-ms-flexbox;display:flex;margin-left:-10px;margin-right:-10px;width:auto;float:none}}.search-all-post-sortable-wrapper .status-filter>div{margin-bottom:15px;width:100%}@media (min-width:1200px){.search-all-post-sortable-wrapper .status-filter>div{width:auto;margin-bottom:0;flex-grow:1;flex-basis:0;padding:0 10px}}.search-all-post-sortable-wrapper .status-filter>div:last-child{margin-bottom:0}.search-all-post-sortable-wrapper .status-filter .search-tag input,.search-all-post-sortable-wrapper .status-filter .search-title input{padding-right:30px}.search-all-post-sortable-wrapper .status-filter .autocomplete-result li{float:none}.search-all-post-sortable-wrapper .status-filter label{line-height:24px}.pr-focus-news-modal .search-all-post-sortable-wrapper .sortable-grid,.recommended-news-modal .search-all-post-sortable-wrapper .sortable-grid{overflow-y:auto}.search-all-post-sortable-wrapper .title-cell{border-right:1px solid #ddd}.pr-focus-news-modal .search-all-post-sortable-wrapper .title-cell{border-right:none}.search-all-post-sortable-wrapper .load-more{margin-top:10px}.ui-sortable-placeholder{height:60px;background:transparent!important;border:3px dashed #ddd!important;visibility:visible!important}.focus-right-block .ui-sortable-placeholder{height:70px}.related-galleries .ui-sortable-placeholder{height:140px}.notification-settings .ui-sortable-placeholder{height:40px}.related-video-box .ui-sortable-placeholder{height:130px}.related-video-box.banner-slider .ui-sortable-placeholder{height:240px}.esports-custom-widget.related-video-box .ui-sortable-placeholder{height:180px}.sortable-upload-attachments .ui-sortable-placeholder{background:none;border:none;position:relative}.sortable-upload-attachments .ui-sortable-placeholder:before{content:\"\";display:block;position:absolute;top:5px;left:5px;right:0;height:0;width:calc(100% - 10px);padding-bottom:calc(75% - 10px);border:3px dashed #ddd;visibility:visible!important}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{font-size:15px}@media (min-width:600px){.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{font-size:18px}}.input-md{font-size:14px}@media (min-width:600px){.input-md{font-size:16px}}.textarea-md{height:auto;min-height:70px!important;width:100%!important;min-width:100%!important;box-sizing:border-box}@media (min-width:600px){.textarea-md{min-height:52px!important}}.textarea-lg{height:auto;min-height:88px!important;width:100%!important;min-width:100%!important;box-sizing:border-box}@media (min-width:600px){.textarea-lg{min-height:70px!important}}.nowrap{white-space:nowrap}.daterangepicker.dropdown-menu.opensleft{left:20px!important}@media (min-width:600px){.daterangepicker.dropdown-menu.opensleft{left:auto!important}}.daterangepicker.dropdown-menu.opensleft .daterangepicker-inner>div:nth-child(2){order:3}.daterangepicker-inner{display:-ms-flexbox;display:flex;overflow-x:auto}.daterangepicker-inner>div:first-child{min-width:160px}.daterangepicker.dropdown-menu.opensright{right:20px!important}@media (min-width:600px){.daterangepicker.dropdown-menu.opensright{right:auto!important}}.highlighted-text-wrapper{padding:7px 35px 7px 7px;line-height:18px;height:70px;border:1px solid #ccc;border-radius:4px;font-weight:400;overflow-y:auto}@media (min-width:600px){.highlighted-text-wrapper{height:52px}}.moderator_guide_text{margin-top:10px;word-break:normal!important}.moderator_guide_text span{display:block;font-style:italic;color:#e67f00;line-height:16px}.moderator_guide_text label{font-size:13px!important;margin:0!important;line-height:20px!important}.upload-photo-wrapper{padding-bottom:140px}@keyframes blink-animation{50%{opacity:0}}.live-badge{display:inline-block;margin-top:10px;width:20px;height:20px;background-color:#323331;border-radius:5px;position:relative}.live-badge:after{display:block;content:\"\";position:absolute;width:8px;height:8px;top:6px;left:6px;border-radius:50%;animation:blink-animation 1s step-start 0s infinite;-webkit-animation:blink-animation 1s step-start 0s infinite}.live-badge.vesti:after,.live-badge:after{background:#e5282a}.live-badge.sport:after{background:#27d050}.live-badge.jetset:after{background:#da2569}.live-badge.biznis:after{background:#3cbaee}.live-badge.pop-i-kultura:after{background:#9144c4}.live-badge.hi-tech:after{background:#276ad1}.live-badge.zanimljivosti:after{background:#29b2a3}.live-badge.zivot-i-stil:after{background:#f7a324}.live-badge.foto:after{background:#b51719}.live-badge.putovanja:after{background:#f82}.live-badge.esports:after{background:#26ce45}.live-badge.auto:after{background:#e5282a}.live-badge.ona:after{background:#b798ec}.live-badge.aero:after{background:#8ea2ae}.comments-priority-1{background:#ff8d00}.comments-priority-1:after{border-top-color:#ff8d00}.comments-priority-2{background:#d92c27}.comments-priority-2:after{border-top-color:#d92c27}.clear-both{clear:both}.comment_title mark,.comments_author mark{background-color:#ffdfd6}.search-post-dir.search-wrapper{width:100%;float:left;margin-left:0;margin-right:0;margin-top:20px;padding-right:100px}.search-post-dir.search-wrapper div.btn{margin:20px 0;position:absolute;top:0;right:0;width:auto;margin:0}.search-post-dir.search-wrapper .autocomplete-result{right:100px;width:auto}.search-post-dir.search-wrapper .remove{position:absolute;z-index:1;top:0;right:100px;background:#fff;font-size:24px;font-weight:700;width:33px;height:100%;text-align:center}.search-post-dir.search-wrapper.no-btn{margin-top:0;padding-right:0}.search-post-dir.search-wrapper.no-btn .autocomplete-result{right:0;width:100%}.search-post-dir.search-wrapper.no-btn .remove{right:0}.edit-pencil-wrapper{display:inline-block;padding:0 5px}.poll-modal .modal--media-content,.tinymce-modal .modal--media-content{top:51px;padding:20px}.poll-modal .poll-align select,.tinymce-modal .poll-align select{width:auto;display:inline-block}@media (min-width:600px){.title-block{position:relative}}@media (min-width:600px){.title-block label{line-height:33px}}.title-block .title-action{margin-top:10px}@media (min-width:600px){.title-block .title-action{position:absolute;top:0;right:0;margin-top:0}}@media (min-width:600px){.title-block a,.title-block select{float:left}}.title-block select{margin-bottom:10px}@media (min-width:600px){.title-block select{width:auto;margin-right:10px}}.toltip-el{position:absolute;z-index:10;font-size:12px;border:1px solid #2e6da4;background:#337ab7;color:#fff;border-radius:4px;display:block;right:0;bottom:0;font-size:10px;width:50px;height:20px;text-align:center;font-weight:700;line-height:18px}@keyframes fadeInLeftAndShake{0%{opacity:0;transform:translate3d(-100%,0,0)}50%{opacity:1;transform:none}55%,75%,95%{transform:rotate(-5deg)}65%,85%{transform:rotate(5deg)}to{transform:none}}.fadeInLeftAndShake{animation:fadeInLeftAndShake 1s;display:block;transform-origin:center center}.keywords{line-height:20px}.keywords .keywords-container{margin:15px 0}.keywords .keywords-header{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #eee;font-weight:700;color:#666;font-size:13px}.keywords .keyword-label{flex:1}.keywords .keywords-list{padding-bottom:8px}.keywords .counts-label{display:flex;gap:8px;align-items:center}.keywords .counts-label .count-label{width:30px;text-align:center}.keywords .counts-label .action-label{width:20px;text-align:center}.keywords input[type=radio]{margin-top:0}.keywords .keyword-item{display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid #eee;font-weight:400}.keywords .keyword-controls{flex:1;display:flex;align-items:center;gap:8px}.keywords .keyword-controls .keyword-name{word-break:break-word;hyphens:auto;padding-right:5px}.keywords .keyword-counts{display:flex;gap:8px;align-items:center}.keywords .keyword-counts .count{width:30px;text-align:center;padding:2px 6px;border-radius:3px;color:#fff}.keywords .keyword-counts .count.success{background:#5cb85c}.keywords .keyword-counts .count.danger{background:#d9534f}.keywords .keyword-counts .count.default{background:#eee;color:#333}.keywords .remove-btn{width:20px;border:none;background:none;color:#d9534f;font-size:18px;font-weight:700;cursor:pointer;padding:0;text-align:center}.keywords .remove-btn:hover{opacity:.8}.keywords .keywords-empty{padding:8px 0;font-size:13px;color:#666;margin:15px 0;border-bottom:1px solid #eee;border-top:1px solid #eee}.keywords .keywords-empty p{margin:0}.keywords .tooltip-trigger{position:relative;cursor:help;text-align:center;border-radius:50%;background:#666;color:#fff;font-style:italic;font-size:12px}.keywords .tooltip-trigger:hover .keywords-tooltip{display:block}.keywords .keywords-tooltip{display:none;position:absolute;right:-10px;top:25px;width:360px;padding:20px;background:#fff;border:1px solid #ddd;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15);z-index:100000;text-align:left;color:#333;line-height:1.5}@media (min-width:600px){.keywords .keywords-tooltip{width:400px}}.keywords .keywords-tooltip:before{content:\"\";position:absolute;top:-6px;right:13px;width:10px;height:10px;background:#fff;transform:rotate(45deg);border-left:1px solid #ddd;border-top:1px solid #ddd}.keywords .keywords-tooltip h4{margin:0 0 15px;font-size:16px;font-weight:700}.keywords .keywords-tooltip h5{margin:15px 0 8px;font-size:15px;font-weight:700}.keywords .keywords-tooltip ul{margin:0;padding-left:15px;list-style-type:disc}.keywords .keywords-tooltip li{margin:5px 0;font-size:14px;line-height:1.4}.keywords .clear-all-keywords-container{text-align:right}.keywords .clear-all-keywords{font-size:12px;font-weight:600;color:#d9534f;cursor:pointer;display:inline-block}.keywords .clear-all-keywords:hover{opacity:.8}.stats-indicators{display:flex;gap:5px}.stats-indicators,.status-circle{align-items:center;justify-content:center}.status-circle{width:20px;height:20px;border-radius:50%;display:inline-flex}.status-circle.status-red{background-color:#d9534f}.status-circle.status-green{background-color:#5cb85c}.status-circle.status-no-value{background-color:transparent}.divider{color:#666;font-weight:700}div.flex-display{display:flex!important;align-items:center}@media (min-width:992px){div.flex-display-desktop{display:flex!important;align-items:center}}.gap-10{gap:10px!important}.gap-15{gap:15px!important}.gap-20{gap:20px!important}input[type=checkbox]:disabled{opacity:.6!important;cursor:not-allowed!important}.remove-item{position:absolute;right:5px;top:5px;font-size:2.5rem;line-height:2.5rem;width:24px;height:24px;text-align:center;display:block}.focus-input input:focus{border:1px solid #337ab7!important}.table-wrapper{width:100%;float:left;margin-left:0;margin-right:0;overflow-x:auto}@media (min-width:992px){.table-wrapper{overflow-x:initial}}.ng-table{margin-bottom:20px;min-width:600px}.all-countries .ng-table,.search-comment-modal .ng-table{min-width:200px}.all-approvals .ng-table{min-width:700px}.ng-table td li:last-child .coma{display:none}.ng-table thead th{vertical-align:middle!important}.ng-table+div{float:none}.ng-table+div .ng-table-counts{float:right}.attach-to-post-modal .ng-table tr{cursor:pointer}.ng-table tr:hover .title-actions{visibility:visible}.ng-table--order{width:72px}.ng-table--order input{width:60px!important;text-align:center;padding-right:0}.ng-table--status{width:142px;text-transform:capitalize;text-align:center}.ng-table--visibility{width:80px;text-align:center}.ng-table--tags{width:192px}.ng-table--tags .tags-edit{display:none}.ng-table--comments-post{width:200px}.ng-table--comments-post>a{display:block;margin:10px 0}.ng-table--stores{width:100px}.ng-table--author{width:120px}.search-comment-modal .ng-table--author.comments_author{display:none}@media (min-width:600px){.search-comment-modal .ng-table--author.comments_author{display:table-cell}}.ng-table--author.comments_author div{width:250px;word-break:break-all}.ng-table--author .author-edit{display:none;width:160px}.all-approvals .ng-table--author{width:140px}.ng-table--author input{width:120px}.media-library .ng-table--author{width:112px}.media-library .ng-table--author span{display:block;width:100px}.ng-table--comment_count{width:58px;text-align:center}.ng-table--comment_count span{cursor:pointer}.ng-table--categories{width:102px}.ng-table--date{width:100px;text-align:center}.ng-table--date span{display:block;width:90px;margin-bottom:20px}.all-approvals .ng-table--date span,.all-countries .ng-table--date span{margin-bottom:0}.ng-table--stats{width:80px;text-align:center}.ng-table--check{width:40px;text-align:center}.ng-table--check .checkbox,.ng-table-sort-header .checkbox{padding-left:20px!important}.ng-table--id{width:70px;text-align:center}.ng-table--id img{width:40px;height:40px;margin-top:10px}.ng-table--description{width:200px}.ng-table--description .description-edit{display:none}.ng-table--description input{width:80%}.ng-table--signature span{display:block;width:140px;font-size:12px;word-wrap:break-word}.ng-table--transcode,.ng-table--travel-status{font-size:20px}.ng-table--transcode i,.ng-table--travel-status i{line-height:40px;width:40px;height:40px}.ng-table--transcode img,.ng-table--travel-status img{width:40px;height:40px}.ng-table--approval,.ng-table--travel-status{width:80px}.ng-table--approval img{width:40px;cursor:pointer;display:block;margin:0 auto}.ng-table--document_id{width:140px}.ng-table--uploaded-to{width:250px}.ng-table--uploaded-to span{display:block}.ng-table--uploaded-to a.attach-action{display:block;margin-top:20px}.ng-table--count{width:70px;text-align:center}.all-countries .ng-table--title{padding-left:12px}.ng-table--title.comment_title .title{font-size:14px}.ng-table--title.comment_title .title>div{margin-bottom:10px}.ng-table--title .media-image{display:block;float:left;width:90px}.all-users .ng-table--title .media-image{width:30px}.all-users .ng-table--title .media-image img{width:auto;max-width:100%}.ng-table--title .media-image img{width:100%}.ng-table--title .title-wrapp{margin-left:110px;display:block}.all-users .ng-table--title .title-wrapp{margin-left:50px}.ng-table--title .title{padding-bottom:10px;font-size:15px}.all-countries .ng-table--title .title{font-size:16px;padding-bottom:0}.all-approvals .ng-table--title .title{padding-bottom:0;padding-left:5px}.ng-table--title .title .title-edit{display:none}.ng-table--title .title .title-edit input{width:100%}.ng-table--title .title .title-edit label{display:block}.ng-table--title .title .title-edit .btn{margin-bottom:15px}.ng-table--title .title .title-edit .checkbox{padding-left:25px}.ng-table--title .title .post-status{font-size:12px;text-transform:capitalize}.ng-table--title .title.level1 .category-name:before{content:\"--\";display:inline-block;font-size:16px;font-weight:600}.ng-table--title .title.level2 .category-name:before{content:\"----\";display:inline-block;font-size:16px;font-weight:600}.ng-table--title .title.level3 .category-name:before{content:\"------\";display:inline-block;font-size:16px;font-weight:600}.ng-table--title .title.level4 .category-name:before{content:\"--------\";display:inline-block;font-size:16px;font-weight:600}.ng-table--title .title.level5 .category-name:before{content:\"----------\";display:inline-block;font-size:16px;font-weight:600}.ng-table--title .title-actions{visibility:visible}@media (min-width:800px){.ng-table--title .title-actions{visibility:hidden}}.ng-table--title .title-actions ul{margin-bottom:0}.ng-table--title .title-actions li{display:inline-block}.ng-table--title .title-actions li:last-child .divider-bar{display:none}.ng-table th .sort-indicator.comments,.ng-table th.sortable .sort-indicator.comments{text-indent:-10000px;display:block;width:46px;height:25px;background:url(" + __webpack_require__(385) + ") 4px no-repeat;background-size:25px 25px}.ng-table th .sort-indicator.comments{background-position:50%}.ng-table th .stats-indicators-header{display:flex;align-items:center;justify-content:center;gap:5px;color:#666}.ng-table th .stats-indicators-header i{width:20px;cursor:help;font-size:16px}.ng-table .form-control{display:inline-block}.ng-table label{font-size:11px}.ng-table-pager{overflow:hidden;min-width:600px;margin:0;margin-bottom:15px}.all-countries .ng-table-pager{min-width:300px}.empty-table{padding:20px;border:1px solid #ddd;border-top:none;margin-top:-20px}.empty-table p{font-size:14px;margin-bottom:0}@media (min-width:600px){.empty-table p{font-size:16px}}.search-comment-modal .empty-table{border:none;padding:0}.attach-to-post-modal .empty-table{margin-top:0}.pagination{float:left;margin:0;margin-right:10px}.ng-table-counts{margin:0;float:right!important;display:none}@media (min-width:992px){.ng-table-counts{display:block}}.ng-table-counts .btn{padding:3px 6px;border:none!important;box-shadow:none;border-radius:4px!important;color:#337ab7;margin:0 2px;outline:none!important}.ng-table-counts .btn.active{background:#337ab7!important;color:#fff}.ng-table-counts .btn:hover{background:#eee}.pagination>li>a,.pagination>li>span{border:none;padding:3px 6px}.all-countries .pagination>li>a,.all-countries .pagination>li>span{padding:3px}@media (min-width:480px){.all-countries .pagination>li>a,.all-countries .pagination>li>span{padding:3px 6px}}.goTo{float:left}.goTo--input{text-align:center;width:60px;position:relative;line-height:27px;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;height:27px}.goTo--button,.goTo--input{vertical-align:top;display:inline-block;padding:3px 6px}.goTo--button{border:none}.all-countries .ng-table thead th:first-of-type{text-align:left;padding-left:12px}.bulk-actions-edit{float:left;margin-left:0;margin-right:0;font-size:11px;line-height:14px;height:auto;padding:10px;margin-top:10px;background-color:#fff;background-image:none;border:1px solid #ccc;width:100%}@media (min-width:1600px){.bulk-actions-edit{margin-bottom:20px}}.bulk-actions-edit h2{text-transform:uppercase}.bulk-actions-edit h2,.bulk-actions-edit h3{font-size:11px;line-height:14px;margin-top:0}.bulk-actions-edit ul{margin-bottom:0}.bulk-actions-edit--wrapper{min-width:800px}.bulk-actions-edit--title{width:31.91489%;float:left;margin-right:2.12766%}.table-filter .bulk-actions-edit--title{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}@media (min-width:800px){.table-filter .bulk-actions-edit--title{width:31.91489%;float:left;margin-right:2.12766%;margin-bottom:0}}.quick-edit .bulk-actions-edit--title{width:31.91489%;float:left;margin-right:2.12766%}.quick-edit .bulk-actions-edit--title .form-group{overflow:hidden}.quick-edit .bulk-actions-edit--title .form-control{width:100%;float:left}.quick-edit .bulk-actions-edit--title label{width:20%;float:left;line-height:33px}.quick-edit.pages .bulk-actions-edit--title{width:48.93617%;float:left;margin-right:2.12766%}.bulk-actions-edit--title ul{color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;min-height:180px;overflow-y:auto;padding:5px}.bulk-actions-edit--title ul li{margin-bottom:10px}@media (min-width:800px){.media-library .bulk-actions-edit--title ul{min-height:465px}}@media (min-width:800px){.media-library .bulk-actions-edit--title.add-restrictions-bulk-title ul{min-height:96px}}.media-library .bulk-actions-edit--title{font-size:13px;width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}@media (min-width:800px){.media-library .bulk-actions-edit--title{width:48.93617%;float:left;margin-right:2.12766%;margin-bottom:0}}.bulk-actions-edit--other{width:40.42553%;float:left;margin-right:2.12766%;margin-right:0}.table-filter .bulk-actions-edit--other{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}@media (min-width:600px){.table-filter .bulk-actions-edit--other{width:48.93617%;float:left;margin-right:2.12766%;margin-bottom:0;margin-right:0}}@media (min-width:800px){.table-filter .bulk-actions-edit--other{width:40.42553%;float:left;margin-right:2.12766%;margin-right:0}}.media-library .bulk-actions-edit--other{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:800px){.media-library .bulk-actions-edit--other{width:48.93617%;float:left;margin-right:2.12766%;margin-bottom:0;margin-right:0;margin-top:25px}}.quick-edit .bulk-actions-edit--other{width:40.42553%;float:left;margin-right:2.12766%;margin-right:0;padding-top:25px}.quick-edit .bulk-actions-edit--other .comments label{vertical-align:middle;line-height:24px;margin:0;margin-right:10px}.quick-edit .bulk-actions-edit--other .comments input{vertical-align:middle;margin:0 10px 0 0;width:20px;height:24px}.bulk-actions-edit--other textarea{width:100%;height:50px;margin-bottom:10px}.quick-edit.pages .bulk-actions-edit--other{width:48.93617%;float:left;margin-right:2.12766%;margin-right:0}.bulk-actions-edit--other__row{width:65.95745%;float:left;margin-right:2.12766%;margin-bottom:10px}.bulk-actions-edit--other__row h3{width:30%;float:left;line-height:33px;margin-bottom:0}.media-library .bulk-actions-edit--other__row h3{line-height:14px;margin-bottom:5px}.bulk-actions-edit--other__row:last-child{margin-bottom:0}.bulk-actions-edit--other__row select{float:left;width:70%;margin-right:0}.bulk-actions-edit--other__button{overflow:hidden;margin-bottom:10px}.bulk-actions-edit--other__button a{width:100px;float:right}.bulk-actions-edit--other.add-restrictions-bulk-other h3{width:auto;margin-right:12px;font-size:13px;line-height:33px}.bulk-actions-edit--other.add-restrictions-bulk-other .input-group-no-border input{padding:0}.bulk-actions-edit--other.add-restrictions-bulk-other input{width:100%;text-align:center}.bulk-actions-edit--other.add-restrictions-bulk-other .range-picker{margin-top:0}.bulk-actions-edit--categories{width:23.40426%;float:left;margin-right:2.12766%}.bulk-actions-edit--categories>ul{color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;height:180px;overflow-y:scroll;padding:5px}.bulk-actions-edit--categories li{line-height:14px;font-size:11px;margin-bottom:5px}.bulk-actions-edit--categories li.level1{padding-left:15px}.bulk-actions-edit--categories li input{margin-right:5px}.bulk-actions-edit--categories li ul{margin-top:5px}.modal--overlay{background-color:rgba(0,0,0,.7);position:fixed;top:0;right:0;bottom:0;left:0;z-index:100050}.modal--overlay .set-image-modal .right-column .form-group{font-size:12px;margin-bottom:10px;overflow:hidden}.modal--overlay .set-image-modal .right-column .form-group input{font-size:12px}.modal--overlay .set-image-modal .right-column .form-group:last-child{margin-bottom:0}.modal--overlay.video-modal input{display:inline-block;width:200px}.modal--overlay.video-modal select{display:inline-block;width:auto;margin-bottom:10px}.modal--overlay.add-to-exchange .checkbox-primary{display:block;margin-bottom:10px}.modal--overlay.add-to-exchange .checkbox-primary label{font-size:15px;margin-right:0;line-height:18px}.modal--overlay .modal-overlay{position:absolute;top:0;left:0;bottom:0;right:0;background:hsla(0,0%,100%,.5);z-index:2}.modal--Category-dialog{padding:10px;position:fixed;background:#fff;z-index:100050;visibility:hidden;text-align:left;top:50%;left:50%;box-shadow:0 3px 6px rgba(0,0,0,.3);margin-left:-165px;width:370px;margin-top:-220px;visibility:visible;height:440px;overflow-y:scroll}.modal--Category-dialog input{margin-right:5px}.modal--Category-dialog>ul{margin-top:50px}.modal--Category-dialog li{margin-bottom:5px}.modal--Category-dialog li ul{margin-top:5px}.modal--Category-dialog .level1{padding-left:15px}.modal--Category-dialog .btn{margin-right:5px}.modal--Category-header{position:fixed;top:50%;left:50%;margin-top:-220px;margin-left:-165px;width:350px;padding:10px;background:#fff}.modal--media-dialog{position:fixed;background:#fff;z-index:100050;top:10px;left:10px;bottom:10px;right:10px;box-shadow:0 3px 6px rgba(0,0,0,.3)}@media (min-width:600px){.modal--media-dialog{left:20px;bottom:20px;right:20px;top:20px}}.dictionary .modal--media-dialog{top:20px;left:20px;bottom:20px;right:20px}.dictionary .modal--media-dialog .set-image-modal{padding:0 10px}@media (min-width:600px){.dictionary .modal--media-dialog .set-image-modal{padding:0 20px}}@media (min-width:800px){.dictionary .modal--media-dialog{top:20%;left:20%;bottom:20%;right:20%}}@media (min-width:992px){.dictionary .modal--media-dialog{top:30%;left:30%;bottom:30%;right:30%}}@media (min-width:1200px){.dictionary .modal--media-dialog{top:35%;left:35%;bottom:35%;right:35%}}.dictionary .modal--media-dialog .clickable{cursor:auto!important;font-size:16px}.add-to-exchange .modal--media-dialog{bottom:auto!important}.editor-insert-tag .modal--media-dialog{top:50%;left:50%;bottom:auto;right:auto;width:320px;height:400px;margin-left:-160px;margin-top:-200px}.editor-insert-tag .modal--media-dialog .modal--media-content{padding:0 10px 10px;top:61px}.editor-insert-tag .modal--media-dialog .modal--media-content .autocomplete-result{top:33px;height:296px}.blog-modal .modal--media-dialog,.editor-insert-post .modal--media-dialog{top:50%;left:50%;bottom:auto;right:auto;max-width:1000px;width:100%;height:400px;transform:translate(-50%,-50%)}.blog-modal .modal--media-dialog .modal--media-content,.editor-insert-post .modal--media-dialog .modal--media-content{padding:0 10px 10px;top:41px}.blog-modal .modal--media-dialog .modal--media-content .autocomplete-result,.editor-insert-post .modal--media-dialog .modal--media-content .autocomplete-result{top:33px;height:296px}.modal--media-header{position:relative;border-bottom:1px solid #ddd}.modal--media-header h2{font-size:14px;padding:0 10px;line-height:50px;margin:0;font-weight:600}@media (min-width:420px){.modal--media-header h2{font-size:18px}}@media (min-width:600px){.modal--media-header h2{font-size:22px;padding:0 20px}}@media (min-width:800px){.modal--media-header h2{font-size:24px}}.modal--media-header i{vertical-align:middle;line-height:50px;font-size:30px;color:#ddd}.modal--media-header .after,.modal--media-header .before,.modal--media-header .btn{position:absolute;top:0;width:50px;height:50px;border-right:1px solid #ddd;text-align:center;cursor:pointer}.modal--media-header .after{right:100px}.modal--media-header .before{right:150px;border-left:1px solid #ddd}.modal--media-header .btn{right:10px;width:70px;height:auto;margin-top:9px}@media (min-width:600px){.modal--media-header .btn{right:20px}}.modal--media-wrapper{position:relative;height:100%}.has-sidebar .modal--media-wrapper{float:left;width:100%}@media (min-width:1350px){.has-sidebar .modal--media-wrapper{width:87%}}.modal--media-wrapper .tab-pane{position:relative}.modal--media-content{overflow:hidden;position:absolute;top:51px;left:0;right:0;bottom:0}.pr-focus-news-modal .modal--media-content,.recommended-news-modal .modal--media-content{overflow-y:auto}@media (min-width:800px){.pr-focus-news-modal .modal--media-content,.recommended-news-modal .modal--media-content{overflow-y:initial}}.modal--media-content.crop-image-modal{overflow-y:scroll}.modal--media-content.crop-image-modal .left-column{width:100%!important;height:auto;border:none}.modal--media-content.crop-image-modal .left-column .crop-image-wrapper{position:relative;overflow-y:scroll}@media (min-width:800px){.modal--media-content.crop-image-modal .left-column .crop-image-wrapper{overflow-y:initial}}.modal--media-content.crop-image-modal .left-column .action{margin:20px 0;text-align:center}@media (min-width:1200px){.modal--media-content.crop-image-modal .left-column{margin-right:400px;width:auto!important}}.modal--media-content.crop-image-modal .right-column{height:auto;width:100%!important;position:static}@media (min-width:1200px){.modal--media-content.crop-image-modal .right-column{padding-top:40px;border-left:1px solid #ddd;width:399px!important;position:absolute;top:1px;right:1px;bottom:auto}}.modal--media-content.crop-image-modal .column-wrapper{height:auto;position:relative}.modal--media-content.crop-image-modal .thumbs-wrap{border:1px solid #fff;margin:10px 0;padding:10px;cursor:pointer}.modal--media-content.crop-image-modal .thumbs-wrap.active,.modal--media-content.crop-image-modal .thumbs-wrap:hover{border:1px solid #33b0dd}.modal--media-content.crop-image-modal .thumbs-wrap.active{background:#33b0dd}.modal--media-content.crop-image-modal .thumbs-wrap img{max-width:100%}.modal--media-content.crop-image-modal .thumbs-wrap p{font-size:12px}.modal--media-content.crop-image-modal .selected-image{padding:10px}@media (min-width:1200px){.modal--media-content.crop-image-modal .selected-image{position:fixed;top:71px;right:20px;width:415px;background:#f5f5f5;margin-bottom:0}}@media (min-width:1200px){.modal--media-content.crop-image-modal .crop-image-wrapper-outer{position:fixed;top:91px;left:20px;right:430px;bottom:20px;overflow-y:auto}}.modal--media-content.attach-to-post-modal{padding:10px;overflow-y:auto;bottom:70px}.modal--media-content.attach-to-post-modal .form-group.search{width:100%;max-width:350px}@media (min-width:600px){.modal--media-content.attach-to-post-modal{padding:20px}}.modal--media-content.media-modal{overflow-y:scroll;bottom:50px}.modal--media-content.media-modal img{display:block;max-width:100%;max-height:calc(100% - 48px);margin:0 auto}.modal--media-content.media-modal .image-wrapp{height:100%}.modal--media-content.media-modal .left-column{height:auto}@media (min-width:600px){.modal--media-content.media-modal .left-column{height:100%}}.modal--media-content.media-modal .left-column .img-wrapper{position:relative;max-width:830px;min-height:430px;margin:0 auto}.add-to-exchange .modal--media-content{position:relative;padding:20px!important;padding-bottom:60px!important;top:auto;left:auto;bottom:auto;right:auto}.modal--media-content .left-column{height:100%;width:100%!important;padding:10px;position:relative}.modal--media-content .left-column .edit-link{margin-top:15px}@media (min-width:600px){.modal--media-content .left-column{width:auto!important;margin-right:320px;border-right:1px solid #ddd}}.pr-focus-news-modal .modal--media-content .left-column,.recommended-news-modal .modal--media-content .left-column{height:auto}@media (min-width:600px){.pr-focus-news-modal .modal--media-content .left-column,.recommended-news-modal .modal--media-content .left-column{width:50%!important;margin-right:0;height:100%}}@media (min-width:1200px){.pr-focus-news-modal .modal--media-content .left-column,.recommended-news-modal .modal--media-content .left-column{padding-top:20px}}.modal--media-content .right-column{background:#f5f5f5;width:100%!important;margin-top:20px;padding:0 5px}@media (min-width:600px){.modal--media-content .right-column{padding:0 10px;width:319px!important;position:absolute;top:1px;right:1px;bottom:1px;margin-top:0;overflow-y:auto}}.modal--media-content .right-column input,.modal--media-content .right-column label,.modal--media-content .right-column select,.modal--media-content .right-column textarea{float:right}.modal--media-content .right-column input,.modal--media-content .right-column select,.modal--media-content .right-column textarea{width:150px!important}@media (min-width:420px){.modal--media-content .right-column input,.modal--media-content .right-column select,.modal--media-content .right-column textarea{width:210px!important}}.modal--media-content .right-column input[type=checkbox]{width:20px!important}.modal--media-content .right-column textarea{min-height:70px;font-size:13px}.modal--media-content .right-column textarea.textarea-middle{min-height:52px}.modal--media-content .right-column .custom-url{margin-top:5px}.pr-focus-news-modal .modal--media-content .right-column,.recommended-news-modal .modal--media-content .right-column{background:transparent;margin-top:0;padding-top:10px;padding-bottom:20px}@media (min-width:600px){.pr-focus-news-modal .modal--media-content .right-column,.recommended-news-modal .modal--media-content .right-column{padding-top:20px;width:50%!important;top:0}}.modal--media-content .right-column h5{margin-bottom:15px}.modal--media-content .attachment-display,.modal--media-content .edit-actions,.modal--media-content .editing-details,.modal--media-content .gallery-details,.modal--media-content .image-details{padding:10px 0}@media (min-width:992px){.modal--media-content .attachment-display,.modal--media-content .edit-actions,.modal--media-content .editing-details,.modal--media-content .gallery-details,.modal--media-content .image-details{border-bottom:1px solid #ddd}}.modal--media-content .gallery-details,.modal--media-content .image-details{padding-top:15px}.modal--media-content .editing-details .form-group,.modal--media-content .image-details{overflow:hidden}.modal--media-content .editing-details label{font-size:12px;line-height:33px;float:right;height:100%;margin-bottom:0}.modal--media-content .editing-details span{padding-top:6px;float:right;display:block;width:200px!important}.modal--media-content .editing-details.video-details textarea{min-height:88px!important}.modal--media-content .gallery-details .checkbox input,.modal--media-content .video-actions .checkbox input{float:none}.modal--media-content .gallery-details .checkbox label,.modal--media-content .video-actions .checkbox label{float:none;margin-right:0}.modal--media-content .gallery-details textarea,.modal--media-content .video-actions textarea{min-height:110px!important}.modal--media-content .gallery-details h5{margin-bottom:10px}.modal--media-content .gallery-details textarea{width:100%!important;float:none!important;min-height:70px!important;font-size:14px}.modal--media-content .gallery-details label{float:none!important;line-height:20px!important}.modal--media-content label{margin-right:5px;line-height:33px}.modal--media-content .slide-show,.modal--media-content .type-all{margin-top:6px!important;margin-bottom:6px}@media (min-width:992px){.modal--media-content .slide-show,.modal--media-content .type-all{float:right}}.modal--media-content .slide-show label,.modal--media-content .type-all label{line-height:18px;margin-bottom:0;margin-right:0}.modal--media-content .slide-show label:after,.modal--media-content .slide-show label:before,.modal--media-content .type-all label:after,.modal--media-content .type-all label:before{padding-top:0}.modal--media-content .type-all{margin-left:10px;float:right}.modal--media-content .slide-show{display:block}@media (min-width:992px){.modal--media-content .slide-show{float:left;margin-left:10px}}.modal--media-content .search-comment-modal{overflow-y:scroll;height:100%;padding:20px}.modal--media-content .search-comment-modal .empty-table{width:100%;float:left;margin-left:0;margin-right:0;margin-top:0;border:1px solid #ddd;padding:20px}.modal--sidebar{float:left;width:13%;height:100%;border-right:1px solid #ddd;background:#f5f5f5;padding-top:15px;display:none}.modal--sidebar a{display:block;line-height:35px;padding-left:20px;font-size:16px}.modal--sidebar .status-filter li{float:none;padding-right:0}@media (min-width:1350px){.modal--sidebar{display:block}}.bulk-actions-edit .categories-tree{width:23.40426%;float:left;margin-right:2.12766%}.table-filter .bulk-actions-edit .categories-tree{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}@media (min-width:600px){.table-filter .bulk-actions-edit .categories-tree{width:48.93617%;float:left;margin-right:2.12766%;margin-bottom:0}}@media (min-width:800px){.table-filter .bulk-actions-edit .categories-tree{width:23.40426%;float:left;margin-right:2.12766%}}.bulk-actions-edit .categories-tree>ul{height:180px}.quick-edit .categories-tree ul{height:260px}.single-post--widget .categories-tree>ul{border-radius:0 4px 4px 4px;-webkit-border-radius:0 4px 4px 4px;-moz-border-radius:0 4px 4px 4px}.single-post--widget .categories-tree li{font-size:14px}.categories-tree .acordion-categories,.categories-tree>ul{color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;height:220px;overflow-y:auto;padding:5px;position:relative;margin-bottom:0}.categories-tree li{line-height:14px;font-size:11px;padding-bottom:6px}.categories-tree li:last-child{padding-bottom:0}.categories-tree li ul{margin-top:5px}.categories-tree input,.categories-tree label,.categories-tree li{-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.categories-tree .acordion-categories ul{padding-left:15px}.categories-tree .checkbox{margin-bottom:0}.checkbox,.radio{padding-left:20px;position:relative;display:inline-block;margin:0;padding-left:25px!important;margin-bottom:5px}.ng-table .checkbox,.ng-table .radio{margin:0}.checkbox.disabled,.radio.disabled{opacity:.5}.checkbox+.checkbox,.radio+.radio{margin-top:0}.checkbox input[type=checkbox],.checkbox input[type=radio]{opacity:0;z-index:1;position:absolute;top:0;left:0;width:20px;height:20px;cursor:pointer;margin:0}.checkbox label,.radio label{line-height:20px;margin-bottom:0;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox-primary input[type=checkbox]:checked+label:before,.checkbox-primary input[type=radio]:checked+label:before{background-color:#5d8fc2;border-color:#5d8fc2}.acordion-checkbox.checkbox-primary input[type=checkbox]+label:before,.acordion-checkbox.checkbox-primary input[type=radio]+label:before{background:#aaa;border-color:#aaa}.selected-child.acordion-checkbox.checkbox-primary input[type=checkbox]+label:before,.selected-child.acordion-checkbox.checkbox-primary input[type=radio]+label:before{background-color:#5d8fc2;border-color:#5d8fc2}.checkbox label:before{content:\"\";border:1px solid #ccc;border-radius:3px;background-color:#fff;transition:border .15s ease-in-out,color .15s ease-in-out;width:20px;height:20px}.checkbox label:after,.checkbox label:before{position:absolute;left:0;top:0}.checkbox-primary input[type=checkbox]:checked+label:after,.checkbox-primary input[type=radio]:checked+label:after{color:#fff}.checkbox input[type=checkbox]:checked+label:after,.checkbox input[type=radio]:checked+label:after{font-family:FontAwesome;content:\"\\F00C\"}.acordion-checkbox.checkbox input[type=checkbox]+label:after,.acordion-checkbox.checkbox input[type=radio]+label:after{font-family:Glyphicons Halflings;content:\"\\E080\";color:#fff}.acordion-checkbox.checkbox.open input[type=checkbox]+label:after,.acordion-checkbox.checkbox.open input[type=radio]+label:after{content:\"\\E114\";text-align:center}.checkbox label:after{width:20px;height:20px;font-size:14px;color:#555;text-align:center}.btn.addfields,.btn.removefields{font-size:20px;width:40px;height:40px;float:right}.btn.removefields{margin-left:10px}.btn.btn-black{background-color:#000;color:#fff;border-color:#000}.btn.btn-black:active,.btn.btn-black:focus,.btn.btn-black:hover{background-color:#404040}.btn.btn-ai{padding-left:40px;background-image:url(" + __webpack_require__(153) + ");background-size:20px;background-position:10px 50%;background-repeat:no-repeat}.disabled-btn{cursor:text;opacity:.2;background-color:#fff;border-color:#ccc}.disabled-btn:active,.disabled-btn:focus,.disabled-btn:hover{background-color:#fff!important;border-color:#ccc!important}.input-group-btn:last-child>.btn{height:33px}.switch-wrapper{line-height:34px;font-size:14px;font-weight:700}.switch{position:relative;display:inline-block;width:60px;height:34px;margin-bottom:0}.switch input{opacity:0;width:0;height:0}.slider{cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc}.slider,.slider:before{position:absolute;transition:.4s}.slider:before{content:\"\";background-color:#fff}.switch .slider:before{height:26px;width:26px;left:4px;bottom:4px}input:checked+.slider{background-color:#337ab7}input:focus+.slider{box-shadow:0 0 1px #337ab7}.switch input:checked+.slider:before{transform:translateX(26px)}.switch .slider.round{border-radius:34px}.switch .slider.round:before{border-radius:50%}.switch-wrapper.small-switch{line-height:17px;font-size:12px}.switch-wrapper.small-switch .switch{width:30px;height:17px}.switch-wrapper.small-switch .slider:before{height:13px;width:13px;left:2px;bottom:2px}.switch-wrapper.small-switch input:checked+.slider:before{transform:translateX(13px)}.switch-wrapper.small-switch .slider.round{border-radius:17px}.action-btn{width:30px;height:30px;border-radius:2px;display:inline-block;color:#fff;outline:none;border:none;cursor:pointer;transition:all .3s ease}.action-btn i:before{font-size:16px;color:#fff}.action-btn:hover i:before{color:#fff}.action-btn.action-btn-primary{background-color:#337ab7}.action-btn.action-btn-primary:hover{background-color:#286090;transition:all .3s ease}.action-btn.action-btn-danger{background-color:#d9534f}.action-btn.action-btn-danger:hover{background-color:#c9302c;transition:all .3s ease}.btn-choice{font-size:16px;font-weight:700;line-height:30px;transition:all .3s ease;cursor:pointer}.btn-choice.btn-choice-success{color:#5cb85c}.btn-choice.btn-choice-success span{background-color:#5cb85c}.btn-choice.btn-choice-success:hover{color:#449d44;transition:all .3s ease}.btn-choice.btn-choice-success:hover span{background-color:#449d44;transition:all .3s ease}.btn-choice span{display:inline-block;width:30px;height:30px;line-height:30px;text-align:center;margin-left:5px;color:#fff;transition:all .3s ease;font-weight:400;font-size:30px;vertical-align:top}.dropzone{border:none;padding:0;margin-bottom:30px}.set-image-modal .dropzone{margin:10px}.approvals-wrapper .dropzone .dz-image{display:none!important}.dropzone .dz-message{border:3px dashed #ccc;display:table!important;min-height:200px;height:200px;text-align:center;width:100%;margin:0}.dropzone .dz-message span{display:table-cell;vertical-align:middle}.dropzone .dz-preview{display:block;margin:10px 0;background:#ccc!important;min-height:50px;padding:10px}.approvals-wrapper .dropzone .dz-preview{padding:15px 10px}.dropzone .dz-preview .dz-image{width:50px;height:50px;border-radius:0;display:inline-block;vertical-align:middle;margin-right:10px}.dropzone .dz-preview .dz-image img{max-width:100%;height:auto;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.dropzone .dz-preview .dz-progress{opacity:1!important;left:auto;right:0;margin-left:0;margin-right:10px}.dropzone .dz-preview .dz-progress .dz-upload{background:#64bd63}.dropzone .dz-preview .dz-details{position:static;vertical-align:middle;min-width:auto;max-width:auto;width:auto;display:inline-block;padding:5px 0;text-align:center;opacity:1}.dropzone .dz-preview .dz-details>div{display:inline-block;margin:0!important;vertical-align:middle}@media (min-width:800px){.dropzone .dz-preview .dz-details{opacity:0}}.dropzone .dz-preview .dz-details .dz-size{display:none}@media (min-width:600px){.dropzone .dz-preview .dz-details .dz-size{display:inline-block}}.dropzone .dz-preview .dz-remove{display:none}.dropzone .dz-preview .dz-error-message{left:50%!important;margin-left:-70px!important;top:50px!important}.upload_image .form-group{width:100%;overflow:hidden}.set-image-modal .upload_image .form-group{padding:0 10px}.sortable-grid{overflow-x:hidden;width:100%;float:left;margin:10px 0 20px}.focus-right-block .sortable-grid,.pr-focus-news-modal .sortable-grid,.recommended-news-modal .sortable-grid{margin:0;float:none}.focus-right-block .sortable-grid h4,.pr-focus-news-modal .sortable-grid h4,.recommended-news-modal .sortable-grid h4{margin-top:0;line-height:24px;margin-bottom:5px;font-weight:700}.pr-focus-news-modal .sortable-grid,.recommended-news-modal .sortable-grid{padding-bottom:0}.sortable-grid .image-cell{width:120px}.sortable-grid .image-cell img{width:100%}.sortable-grid .document_id{width:70px}.sortable-grid .document_id img{width:30px;height:30px;margin-top:5px}.sortable-grid .remove{width:60px}.focus-right-block .sortable-grid .document_id,.focus-right-block .sortable-grid .order-cell,.focus-right-block .sortable-grid .title-cell,.pr-focus-news-modal .right-column .sortable-grid .document_id,.pr-focus-news-modal .right-column .sortable-grid .order-cell,.pr-focus-news-modal .right-column .sortable-grid .title-cell,.recommended-news-modal .right-column .sortable-grid .document_id,.recommended-news-modal .right-column .sortable-grid .order-cell,.recommended-news-modal .right-column .sortable-grid .title-cell{font-weight:600}.sortable-grid .document_id,.sortable-grid .ng-table--id,.sortable-grid .th_id{border-right:1px solid #ddd}.sortable-grid table{border:1px solid #ddd;width:100%}.sortable-grid .empty-row,.sortable-grid td,.sortable-grid th{padding:10px 8px}.sortable-grid tbody td,.sortable-grid th{border-bottom:1px solid #ddd}.sortable-grid tbody tr{transition:background .2s ease-in}.sortable-grid tbody tr:nth-child(odd){background:#f9f9f9}.sortable-grid tbody tr:hover{background:#f9f9f9;cursor:pointer}.sortable-grid tfoot td{font-weight:600}.sortable-grid .order-cell{text-align:center}.sortable-grid .number-focus-news{font-style:italic;margin-bottom:5px;line-height:24px}.sortable-grid .empty-row{float:left;width:100%;border:1px solid #ddd}.hover-attr{margin-top:5px;visibility:visible;float:left}@media (min-width:1200px){.hover-attr{visibility:hidden}}tr:hover .hover-attr{visibility:visible}.all-focus .hover-attr{margin-top:0}.sortable-grid-flex{border:1px solid #ccc}.sortable-grid-flex .sortable-grid-flex-header,.sortable-grid-flex .sortable-grid-flex-item-wrapper{display:flex;flex-wrap:nowrap;align-items:stretch;width:100%;border-bottom:1px solid #ccc}.sortable-grid-flex .sortable-grid-flex-item-wrapper:last-child{border-bottom:none}.sortable-grid-flex .item-name{flex:1}.sortable-grid-flex .item-number{width:120px}.sortable-grid-flex .item-index{width:60px;display:flex;align-items:center;justify-content:center}.sortable-grid-flex .item-action{width:80px;display:flex;align-items:center;justify-content:center}.sortable-grid-flex .item-action button{margin:2px}.sortable-grid-flex .sortable-grid-flex-header-item,.sortable-grid-flex .sortable-grid-flex-item{background:#eee;align-items:center;border-right:1px solid #ccc}.sortable-grid-flex .sortable-grid-flex-header-item:last-child,.sortable-grid-flex .sortable-grid-flex-item:last-child{border-right:none}.sortable-grid-flex .sortable-grid-flex-header-item{font-size:16px;padding:8px;line-height:12px;font-weight:700}.sortable-grid-flex .sortable-grid-flex-item{position:relative}.sortable-grid-flex .sortable-grid-flex-item .focus-input{width:100%}.sortable-grid-flex .sortable-grid-flex-item .focus-input.disabled-input:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:transparent;cursor:grab}.sortable-grid-flex .sortable-grid-flex-item .focus-input.disabled-input input{background:#eee}.sortable-grid-flex .sortable-grid-flex-item input{line-height:46px;height:46px;border:none;width:100%;padding:0 8px;border-radius:0}.sortable-grid-flex .sortable-container.ui-sortable-helper{cursor:grabbing!important}.sortable-grid-flex .no-items-found{text-align:center;padding:10px;font-size:16px;font-weight:700;color:#666;background:#fff}.custom-tooltip{bottom:100%;color:#fff;opacity:0;visibility:hidden;padding:20px;pointer-events:none;transform:translateY(10px);transition:all .25s ease-out;-ms-box-shadow:2px 2px 6px rgba(0,0,0,.28);-o-box-shadow:2px 2px 6px rgba(0,0,0,.28);box-shadow:2px 2px 6px rgba(0,0,0,.28);background:#5bc0de}.custom-tooltip,.custom-tooltip:before{display:block;position:absolute;width:100%}.custom-tooltip:before{bottom:-20px;content:\" \";height:20px;left:0}.custom-tooltip:after{border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #5bc0de;bottom:-10px;content:\" \";height:0;left:50%;margin-left:-13px;position:absolute;width:0}.custom-tooltip.show{opacity:1;visibility:visible;pointer-events:auto;transform:translateY(0)}.lte8 .wrapper .custom-tooltip{display:none}.lte8 .wrapper:hover .custom-tooltip{display:block}.revisions{overflow-y:scroll}.revisions .match,.revisions .textdiff span{color:gray}.revisions .ins,.revisions ins{color:#000;background:#bfb}.revisions .del,.revisions del{color:#000;background:#fbb}.revisions .noselect{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.revisions pre{font-size:12px}.revisions pre,.revisions pre span{white-space:pre-wrap}.revisions h3{font-size:14px;text-transform:uppercase;line-height:20px;margin-top:0}.revisions .column-wrapper{padding:10px;overflow:hidden}@media (min-width:600px){.revisions .column-wrapper{padding:20px}}.revisions .column-wrapper div.column{margin-bottom:30px}@media (min-width:600px){.revisions .column-wrapper div.column{width:31.91489%;float:left;margin-right:2.12766%}.revisions .column-wrapper div.column:last-child{margin-right:0}}.revisions .column-wrapper .revisions-controls{width:100%;float:left;margin-left:0;margin-right:0}.revisions .column-wrapper .revisions-controls select{width:auto;display:inline-block}.revisions .column-wrapper .revisions-header{width:100%;float:left;margin-left:0;margin-right:0;margin-bottom:20px}.revisions .column-wrapper .revisions-header h3{margin:0}.revisions .column-wrapper .header{min-height:50px}.revisions .column-wrapper .header h3,.revisions .column-wrapper .header span{color:#286090;font-style:italic;font-weight:700;text-align:center}.flag-big{display:inline-block;background:url(" + __webpack_require__(17) + ") no-repeat;background-size:960px auto;width:30px;height:20px}@media (min-width:600px){.flag-big{width:48px;height:32px;background-size:1536px auto}}.flag-small{display:inline-block;background:url(" + __webpack_require__(17) + ") no-repeat;width:30px;height:20px;background-size:960px auto}.flag-smallest{display:inline-block;background:url(" + __webpack_require__(17) + ") no-repeat;width:24px;height:16px;background-size:768px auto}.flag-big-placeholder{display:inline-block;width:30px;height:20px;background:#d8d8d8;border:1px solid #aba8a8}@media (min-width:600px){.flag-big-placeholder{width:48px;height:32px}}.flag-small-placeholder{width:30px;height:20px}.flag-small-placeholder,.flag-smallest-placeholder{display:inline-block;background:#d8d8d8;border:1px solid #aba8a8}.flag-smallest-placeholder{width:24px;height:16px}.flag-smallest-rus{background-position:0 0}.flag-smallest-ksa{background-position:-24px 0}.flag-smallest-egy{background-position:-48px 0}.flag-smallest-uru{background-position:-72px 0}.flag-smallest-por{background-position:-96px 0}.flag-smallest-spa{background-position:-120px 0}.flag-smallest-mar{background-position:-144px 0}.flag-smallest-irn{background-position:-168px 0}.flag-smallest-fra{background-position:-192px 0}.flag-smallest-aus{background-position:-216px 0}.flag-smallest-per{background-position:-240px 0}.flag-smallest-den{background-position:-264px 0}.flag-smallest-arg{background-position:-288px 0}.flag-smallest-icl{background-position:-312px 0}.flag-smallest-cro{background-position:-336px 0}.flag-smallest-nga{background-position:-360px 0}.flag-smallest-bra{background-position:-384px 0}.flag-smallest-sui{background-position:-408px 0}.flag-smallest-crc{background-position:-432px 0}.flag-smallest-srb{background-position:-456px 0}.flag-smallest-ger{background-position:-480px 0}.flag-smallest-mex{background-position:-504px 0}.flag-smallest-swe{background-position:-528px 0}.flag-smallest-kor{background-position:-552px 0}.flag-smallest-bel{background-position:-576px 0}.flag-smallest-pan{background-position:-600px 0}.flag-smallest-tun{background-position:-624px 0}.flag-smallest-eng{background-position:-648px 0}.flag-smallest-pol{background-position:-672px 0}.flag-smallest-sen{background-position:-696px 0}.flag-smallest-col{background-position:-720px 0}.flag-smallest-jpn{background-position:-744px 0}.flag-small-rus{background-position:0 0}.flag-small-ksa{background-position:-30px 0}.flag-small-egy{background-position:-60px 0}.flag-small-uru{background-position:-90px 0}.flag-small-por{background-position:-120px 0}.flag-small-spa{background-position:-150px 0}.flag-small-mar{background-position:-180px 0}.flag-small-irn{background-position:-210px 0}.flag-small-fra{background-position:-240px 0}.flag-small-aus{background-position:-270px 0}.flag-small-per{background-position:-300px 0}.flag-small-den{background-position:-330px 0}.flag-small-arg{background-position:-360px 0}.flag-small-icl{background-position:-390px 0}.flag-small-cro{background-position:-420px 0}.flag-small-nga{background-position:-450px 0}.flag-small-bra{background-position:-480px 0}.flag-small-sui{background-position:-510px 0}.flag-small-crc{background-position:-540px 0}.flag-small-srb{background-position:-570px 0}.flag-small-ger{background-position:-600px 0}.flag-small-mex{background-position:-630px 0}.flag-small-swe{background-position:-660px 0}.flag-small-kor{background-position:-690px 0}.flag-small-bel{background-position:-720px 0}.flag-small-pan{background-position:-750px 0}.flag-small-tun{background-position:-780px 0}.flag-small-eng{background-position:-810px 0}.flag-small-pol{background-position:-840px 0}.flag-small-sen{background-position:-870px 0}.flag-small-col{background-position:-900px 0}.flag-small-jpn{background-position:-930px 0}.flag-big-rus{background-position:0 0}.flag-big-ksa{background-position:-30px 0}@media (min-width:600px){.flag-big-ksa{background-position:-48px 0}}.flag-big-egy{background-position:-60px 0}@media (min-width:600px){.flag-big-egy{background-position:-96px 0}}.flag-big-uru{background-position:-90px 0}@media (min-width:600px){.flag-big-uru{background-position:-144px 0}}.flag-big-por{background-position:-120px 0}@media (min-width:600px){.flag-big-por{background-position:-192px 0}}.flag-big-spa{background-position:-150px 0}@media (min-width:600px){.flag-big-spa{background-position:-240px 0}}.flag-big-mar{background-position:-180px 0}@media (min-width:600px){.flag-big-mar{background-position:-288px 0}}.flag-big-irn{background-position:-210px 0}@media (min-width:600px){.flag-big-irn{background-position:-336px 0}}.flag-big-fra{background-position:-240px 0}@media (min-width:600px){.flag-big-fra{background-position:-384px 0}}.flag-big-aus{background-position:-270px 0}@media (min-width:600px){.flag-big-aus{background-position:-432px 0}}.flag-big-per{background-position:-300px 0}@media (min-width:600px){.flag-big-per{background-position:-480px 0}}.flag-big-den{background-position:-330px 0}@media (min-width:600px){.flag-big-den{background-position:-528px 0}}.flag-big-arg{background-position:-360px 0}@media (min-width:600px){.flag-big-arg{background-position:-576px 0}}.flag-big-icl{background-position:-390px 0}@media (min-width:600px){.flag-big-icl{background-position:-624px 0}}.flag-big-cro{background-position:-420px 0}@media (min-width:600px){.flag-big-cro{background-position:-672px 0}}.flag-big-nga{background-position:-450px 0}@media (min-width:600px){.flag-big-nga{background-position:-720px 0}}.flag-big-bra{background-position:-480px 0}@media (min-width:600px){.flag-big-bra{background-position:-768px 0}}.flag-big-sui{background-position:-510px 0}@media (min-width:600px){.flag-big-sui{background-position:-816px 0}}.flag-big-crc{background-position:-540px 0}@media (min-width:600px){.flag-big-crc{background-position:-864px 0}}.flag-big-srb{background-position:-570px 0}@media (min-width:600px){.flag-big-srb{background-position:-912px 0}}.flag-big-ger{background-position:-600px 0}@media (min-width:600px){.flag-big-ger{background-position:-960px 0}}.flag-big-mex{background-position:-630px 0}@media (min-width:600px){.flag-big-mex{background-position:-1008px 0}}.flag-big-swe{background-position:-660px 0}@media (min-width:600px){.flag-big-swe{background-position:-1056px 0}}.flag-big-kor{background-position:-690px 0}@media (min-width:600px){.flag-big-kor{background-position:-1104px 0}}.flag-big-bel{background-position:-720px 0}@media (min-width:600px){.flag-big-bel{background-position:-1152px 0}}.flag-big-pan{background-position:-750px 0}@media (min-width:600px){.flag-big-pan{background-position:-1200px 0}}.flag-big-tun{background-position:-780px 0}@media (min-width:600px){.flag-big-tun{background-position:-1248px 0}}.flag-big-eng{background-position:-810px 0}@media (min-width:600px){.flag-big-eng{background-position:-1296px 0}}.flag-big-pol{background-position:-840px 0}@media (min-width:600px){.flag-big-pol{background-position:-1344px 0}}.flag-big-sen{background-position:-870px 0}@media (min-width:600px){.flag-big-sen{background-position:-1392px 0}}.flag-big-col{background-position:-900px 0}@media (min-width:600px){.flag-big-col{background-position:-1440px 0}}.flag-big-jpn{background-position:-930px 0}@media (min-width:600px){.flag-big-jpn{background-position:-1488px 0}}.edit-media .range-picker input,.restrictions-modal .range-picker input,.upload_image .range-picker input{width:330px}.edit-media .input-group-no-border,.restrictions-modal .input-group-no-border,.upload_image .input-group-no-border{margin-top:20px}.upload_image .checkbox,.upload_image .radio{width:100%}.upload_image .range-picker-restriction{margin:5px 0 20px}.edit-media .range-picker-restriction{width:100%;margin-bottom:20px}.insert-media-restriction .input-group-no-border{padding:0!important}.ribon,.ribon-wrapper{overflow:hidden}.ribon{background-color:#000;white-space:nowrap;position:absolute;right:-30%;top:10%;width:100%;transform:rotate(45deg);box-shadow:0 0 10px #000}.ribon.ribon-primary{background:#48a3f1;background:linear-gradient(180deg,#78acd9 0,#1d4568);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$color1,endColorstr=$color2,GradientType=0);box-shadow:0 0 10px #78acd9}.ribon.ribon-primary>div{border:1px solid #78acd9}.ribon.ribon-primary>div p,.ribon.ribon-primary>div span{text-shadow:2px 0 0 #1d4568,-2px 0 0 #1d4568,0 2px 0 #1d4568,0 -2px 0 #1d4568,1px 1px #1d4568,-1px -1px 0 #1d4568,1px -1px 0 #1d4568,-1px 1px 0 #1d4568}.ribon.ribon-success{background:#48a3f1;background:linear-gradient(180deg,#a3d7a3 0,#357935);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$color1,endColorstr=$color2,GradientType=0);box-shadow:0 0 10px #a3d7a3}.ribon.ribon-success>div{border:1px solid #a3d7a3}.ribon.ribon-success>div p,.ribon.ribon-success>div span{text-shadow:2px 0 0 #357935,-2px 0 0 #357935,0 2px 0 #357935,0 -2px 0 #357935,1px 1px #357935,-1px -1px 0 #357935,1px -1px 0 #357935,-1px 1px 0 #357935}.ribon.ribon-info{background:#48a3f1;background:linear-gradient(180deg,#b0e1ef 0,#2390b0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$color1,endColorstr=$color2,GradientType=0);box-shadow:0 0 10px #b0e1ef}.ribon.ribon-info>div{border:1px solid #b0e1ef}.ribon.ribon-info>div p,.ribon.ribon-info>div span{text-shadow:2px 0 0 #2390b0,-2px 0 0 #2390b0,0 2px 0 #2390b0,0 -2px 0 #2390b0,1px 1px #2390b0,-1px -1px 0 #2390b0,1px -1px 0 #2390b0,-1px 1px 0 #2390b0}.ribon.ribon-warning{background:#48a3f1;background:linear-gradient(180deg,#fb6 0,#950);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$color1,endColorstr=$color2,GradientType=0);box-shadow:0 0 10px #fb6}.ribon.ribon-warning>div{border:1px solid #fb6}.ribon.ribon-warning>div p,.ribon.ribon-warning>div span{text-shadow:2px 0 0 #950,-2px 0 0 #950,0 2px 0 #950,0 -2px 0 #950,1px 1px #950,-1px -1px 0 #950,1px -1px 0 #950,-1px 1px 0 #950}.ribon.ribon-danger{background:#48a3f1;background:linear-gradient(180deg,#eba5a3 0,#a02622);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$color1,endColorstr=$color2,GradientType=0);box-shadow:0 0 10px #eba5a3}.ribon.ribon-danger>div{border:1px solid #eba5a3}.ribon.ribon-danger>div p,.ribon.ribon-danger>div span{text-shadow:2px 0 0 #a02622,-2px 0 0 #a02622,0 2px 0 #a02622,0 -2px 0 #a02622,1px 1px #a02622,-1px -1px 0 #a02622,1px -1px 0 #a02622,-1px 1px 0 #a02622}.ribon>div{border:1px solid #000;display:block;margin:1px 0;text-align:center}.ribon>div p,.ribon>div span{display:block;color:#fff;line-height:11px;text-decoration:none;font-size:11px;text-transform:uppercase;padding:2%;text-shadow:0 0 5px #000;margin-bottom:0}.ribon>div i{color:#fff}.ribon>div span{display:inline-block;padding:0 3%}.uppy-Root{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;color:#333;font-family:-apple-system,blinkmacsystemfont,Segoe UI,helvetica,arial,sans-serif;line-height:1;position:relative;text-align:left}.uppy-Root[dir=rtl],[dir=rtl] .uppy-Root{text-align:right}.uppy-Root *,.uppy-Root :after,.uppy-Root :before{box-sizing:inherit}.uppy-Root [hidden]{display:none}.uppy-u-reset{-webkit-appearance:none;backface-visibility:visible;background:none;border:none;border-collapse:initial;border-image:none;border-radius:0;border-spacing:0;box-shadow:none;clear:none;color:inherit;cursor:auto;display:inline;empty-cells:show;float:none;font-family:inherit;font-size:inherit;font-stretch:normal;font-style:normal;font-variant:normal;font-weight:400;hyphens:none;left:auto;letter-spacing:normal;line-height:1;list-style:none;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;outline:medium none invert;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;text-align:left;text-decoration:none;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-origin:initial;transform-style:flat;transition:none 0s ease 0s;unicode-bidi:normal;vertical-align:initial;visibility:visible;white-space:normal;z-index:auto}[dir=rtl] .uppy-u-reset{text-align:right}.uppy-c-textInput{background-color:#fff;border:1px solid #ddd;border-radius:4px;font-size:14px;line-height:1.5;padding:6px 8px}.uppy-size--md .uppy-c-textInput{padding:8px 10px}.uppy-c-textInput:focus{border-color:#2275d799;box-shadow:0 0 0 3px #2275d726;outline:none}[data-uppy-theme=dark] .uppy-c-textInput{background-color:#333;border-color:#333;color:#eaeaea}[data-uppy-theme=dark] .uppy-c-textInput:focus{border-color:#525252;box-shadow:none}.uppy-c-icon{fill:currentColor;display:inline-block;max-height:100%;max-width:100%;overflow:hidden}.uppy-c-btn{display:inline-block;font-family:inherit;font-size:16px;font-weight:500;line-height:1;transition-duration:.3s;transition-property:background-color,color;-webkit-user-select:none;user-select:none;vertical-align:middle;white-space:nowrap}.uppy-c-btn,[dir=rtl] .uppy-c-btn{text-align:center}.uppy-c-btn:not(:disabled):not(.disabled){cursor:pointer}.uppy-c-btn::-moz-focus-inner{border:0}.uppy-c-btn-primary{background-color:#2275d7;border-radius:4px;color:#fff;font-size:14px;padding:10px 18px}.uppy-c-btn-primary:hover{background-color:#1b5dab}.uppy-c-btn-primary:focus{box-shadow:0 0 0 3px #2275d766;outline:none}.uppy-size--md .uppy-c-btn-primary{padding:13px 22px}[data-uppy-theme=dark] .uppy-c-btn-primary{color:#eaeaea}[data-uppy-theme=dark] .uppy-c-btn-primary:focus{outline:none}[data-uppy-theme=dark] .uppy-c-btn-primary::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-c-btn-primary:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-c-btn-link{background-color:initial;border-radius:4px;color:#525252;font-size:14px;line-height:1;padding:10px 15px}.uppy-c-btn-link:hover{color:#333}.uppy-c-btn-link:focus{box-shadow:0 0 0 3px #2275d740;outline:none}.uppy-size--md .uppy-c-btn-link{padding:13px 18px}[data-uppy-theme=dark] .uppy-c-btn-link{color:#eaeaea}[data-uppy-theme=dark] .uppy-c-btn-link:focus{outline:none}[data-uppy-theme=dark] .uppy-c-btn-link::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-c-btn-link:focus{box-shadow:0 0 0 2px #aae1ffd9}[data-uppy-theme=dark] .uppy-c-btn-link:hover{color:#939393}.uppy-c-btn--small{border-radius:2px;font-size:.9em;padding:7px 16px}.uppy-size--md .uppy-c-btn--small{border-radius:2px;padding:8px 10px}.uppy-Informer{bottom:60px;left:0;position:absolute;right:0;text-align:center;z-index:1005}.uppy-Informer span>div{margin-bottom:6px}.uppy-Informer-animated{opacity:0;transform:translateY(350%);transition:all .3s ease-in;z-index:-1000}.uppy-Informer p{background-color:#757575;border-radius:18px;color:#fff;display:inline-block;font-size:12px;font-weight:400;line-height:1.4;margin:0;max-width:90%;padding:6px 15px}.uppy-size--md .uppy-Informer p{font-size:14px;line-height:1.3;max-width:500px;padding:10px 20px}[data-uppy-theme=dark] .uppy-Informer p{background-color:#333}[dir=ltr] .uppy-Informer p span{left:3px}[dir=rtl] .uppy-Informer p span{right:3px}[dir=ltr] .uppy-Informer p span{margin-left:-1px}[dir=rtl] .uppy-Informer p span{margin-right:-1px}.uppy-Informer p span{background-color:#fff;border-radius:50%;color:#525252;display:inline-block;font-size:10px;height:13px;line-height:12px;position:relative;top:-1px;vertical-align:middle;width:13px}.uppy-Informer p span:hover{cursor:help}.uppy-Informer p span:after{word-wrap:break-word;line-height:1.3}.uppy-Root [aria-label][role~=tooltip]{position:relative}.uppy-Root [aria-label][role~=tooltip]:after,.uppy-Root [aria-label][role~=tooltip]:before{backface-visibility:hidden;box-sizing:border-box;opacity:0;pointer-events:none;position:absolute;transform:translateZ(0);transform-origin:top;transition:all var(--microtip-transition-duration,.18s) var(--microtip-transition-easing,ease-in-out) var(--microtip-transition-delay,0s);will-change:transform;z-index:10}.uppy-Root [aria-label][role~=tooltip]:before{background-size:100% auto!important;content:\"\"}.uppy-Root [aria-label][role~=tooltip]:after{background:#111111e6;border-radius:4px;box-sizing:initial;color:#fff;content:attr(aria-label);font-size:var(--microtip-font-size,13px);font-weight:var(--microtip-font-weight,normal);padding:.5em 1em;text-transform:var(--microtip-text-transform,none);white-space:nowrap}.uppy-Root [aria-label][role~=tooltip]:focus:after,.uppy-Root [aria-label][role~=tooltip]:focus:before,.uppy-Root [aria-label][role~=tooltip]:hover:after,.uppy-Root [aria-label][role~=tooltip]:hover:before{opacity:1;pointer-events:auto}.uppy-Root [role~=tooltip][data-microtip-position|=top]:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='12'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M2.658 0h32.004c-6 0-11.627 12.002-16.002 12.002C14.285 12.002 8.594 0 2.658 0z'/%3E%3C/svg%3E\") no-repeat;bottom:100%;height:6px;left:50%;margin-bottom:5px;transform:translate3d(-50%,0,0);width:18px}.uppy-Root [role~=tooltip][data-microtip-position|=top]:after{bottom:100%;left:50%;margin-bottom:11px;transform:translate3d(-50%,0,0)}.uppy-Root [role~=tooltip][data-microtip-position=top]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position|=top]:hover:before{transform:translate3d(-50%,-5px,0)}.uppy-Root [role~=tooltip][data-microtip-position=top-left]:after{bottom:100%;transform:translate3d(calc(-100% + 16px),0,0)}.uppy-Root [role~=tooltip][data-microtip-position=top-left]:hover:after{transform:translate3d(calc(-100% + 16px),-5px,0)}.uppy-Root [role~=tooltip][data-microtip-position=top-right]:after{bottom:100%;transform:translate3d(-16px,0,0)}.uppy-Root [role~=tooltip][data-microtip-position=top-right]:hover:after{transform:translate3d(-16px,-5px,0)}.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='12'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M33.342 12H1.338c6 0 11.627-12.002 16.002-12.002C21.715-.002 27.406 12 33.342 12z'/%3E%3C/svg%3E\") no-repeat;bottom:auto;height:6px;left:50%;margin-bottom:0;margin-top:5px;top:100%;transform:translate3d(-50%,-10px,0);width:18px}.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:after{left:50%;margin-top:11px;top:100%;transform:translate3d(-50%,-10px,0)}.uppy-Root [role~=tooltip][data-microtip-position=bottom]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:hover:before{transform:translate3d(-50%,0,0)}.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:after{top:100%;transform:translate3d(calc(-100% + 16px),-10px,0)}.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:hover:after{transform:translate3d(calc(-100% + 16px),0,0)}.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:after{top:100%;transform:translate3d(-16px,-10px,0)}.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:hover:after{transform:translate3d(-16px,0,0)}.uppy-Root [role~=tooltip][data-microtip-position=left]:after,.uppy-Root [role~=tooltip][data-microtip-position=left]:before{bottom:auto;left:auto;right:100%;top:50%;transform:translate3d(10px,-50%,0)}.uppy-Root [role~=tooltip][data-microtip-position=left]:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='36'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M0 33.342V1.338c0 6 12.002 11.627 12.002 16.002C12.002 21.715 0 27.406 0 33.342z'/%3E%3C/svg%3E\") no-repeat;height:18px;margin-bottom:0;margin-right:5px;width:6px}.uppy-Root [role~=tooltip][data-microtip-position=left]:after{margin-right:11px}.uppy-Root [role~=tooltip][data-microtip-position=left]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position=left]:hover:before{transform:translate3d(0,-50%,0)}.uppy-Root [role~=tooltip][data-microtip-position=right]:after,.uppy-Root [role~=tooltip][data-microtip-position=right]:before{bottom:auto;left:100%;top:50%;transform:translate3d(-10px,-50%,0)}.uppy-Root [role~=tooltip][data-microtip-position=right]:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='36'%3E%3Cpath fill='rgba(17, 17, 17, 0.9)' d='M12 2.658v32.004c0-6-12.002-11.627-12.002-16.002C-.002 14.285 12 8.594 12 2.658z'/%3E%3C/svg%3E\") no-repeat;height:18px;margin-bottom:0;margin-left:5px;width:6px}.uppy-Root [role~=tooltip][data-microtip-position=right]:after{margin-left:11px}.uppy-Root [role~=tooltip][data-microtip-position=right]:hover:after,.uppy-Root [role~=tooltip][data-microtip-position=right]:hover:before{transform:translate3d(0,-50%,0)}.uppy-Root [role~=tooltip][data-microtip-size=small]:after{white-space:normal;width:80px}.uppy-Root [role~=tooltip][data-microtip-size=medium]:after{white-space:normal;width:150px}.uppy-Root [role~=tooltip][data-microtip-size=large]:after{white-space:normal;width:260px}.uppy-StatusBar{background-color:#fff;color:#fff;display:flex;font-size:12px;font-weight:400;height:40px;line-height:40px;position:relative;transition:height .2s;z-index:1001}.uppy-size--md .uppy-StatusBar{height:46px}[data-uppy-theme=dark] .uppy-StatusBar{background-color:#1f1f1f}.uppy-StatusBar:before{background-color:#eaeaea;bottom:0;content:\"\";height:2px;left:0;position:absolute;right:0;top:0;width:100%}[data-uppy-theme=dark] .uppy-StatusBar:before{background-color:#757575}.uppy-StatusBar[aria-hidden=true]{height:0;overflow-y:hidden}.uppy-StatusBar.is-complete .uppy-StatusBar-progress{background-color:#1bb240}.uppy-StatusBar.is-error .uppy-StatusBar-progress{background-color:#e32437}.uppy-StatusBar.is-complete .uppy-StatusBar-statusIndicator{color:#1bb240}.uppy-StatusBar.is-error .uppy-StatusBar-statusIndicator{color:#e32437}.uppy-StatusBar:not([aria-hidden=true]).is-waiting{background-color:#fff;border-top:1px solid #eaeaea;height:65px}[data-uppy-theme=dark] .uppy-StatusBar:not([aria-hidden=true]).is-waiting{background-color:#1f1f1f;border-top:1px solid #333}.uppy-StatusBar-progress{background-color:#2275d7;height:2px;position:absolute;transition:background-color,width .3s ease-out;z-index:1001}.uppy-StatusBar-progress.is-indeterminate{animation:uppy-StatusBar-ProgressStripes 1s linear infinite;background-image:linear-gradient(45deg,rgba(0,0,0,.301961) 25%,transparent 0,transparent 50%,rgba(0,0,0,.301961) 0,rgba(0,0,0,.301961) 75%,transparent 0,transparent);background-size:64px 64px}@keyframes uppy-StatusBar-ProgressStripes{0%{background-position:0 0}to{background-position:64px 0}}.uppy-StatusBar.is-postprocessing .uppy-StatusBar-progress,.uppy-StatusBar.is-preprocessing .uppy-StatusBar-progress{background-color:#f6a623}.uppy-StatusBar.is-waiting .uppy-StatusBar-progress{display:none}[dir=ltr] .uppy-StatusBar-content{padding-left:10px}[dir=rtl] .uppy-StatusBar-content{padding-right:10px}.uppy-StatusBar-content{align-items:center;color:#333;display:flex;height:100%;position:relative;text-overflow:ellipsis;white-space:nowrap;z-index:1002}[dir=ltr] .uppy-size--md .uppy-StatusBar-content{padding-left:15px}[dir=rtl] .uppy-size--md .uppy-StatusBar-content{padding-right:15px}[data-uppy-theme=dark] .uppy-StatusBar-content{color:#eaeaea}[dir=ltr] .uppy-StatusBar-status{padding-right:.3em}[dir=rtl] .uppy-StatusBar-status{padding-left:.3em}.uppy-StatusBar-status{display:flex;flex-direction:column;font-weight:400;justify-content:center;line-height:1.4}.uppy-StatusBar-statusPrimary{font-weight:500;line-height:1}[data-uppy-theme=dark] .uppy-StatusBar-statusPrimary{color:#eaeaea}.uppy-StatusBar-statusSecondary{color:#757575;display:inline-block;font-size:11px;line-height:1.2;margin-top:1px;white-space:nowrap}[data-uppy-theme=dark] .uppy-StatusBar-statusSecondary{color:#bbb}[dir=ltr] .uppy-StatusBar-statusSecondaryHint{margin-right:5px}[dir=rtl] .uppy-StatusBar-statusSecondaryHint{margin-left:5px}.uppy-StatusBar-statusSecondaryHint{display:inline-block;line-height:1;vertical-align:middle}[dir=ltr] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{margin-right:8px}[dir=rtl] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{margin-left:8px}[dir=ltr] .uppy-StatusBar-statusIndicator{margin-right:7px}[dir=rtl] .uppy-StatusBar-statusIndicator{margin-left:7px}.uppy-StatusBar-statusIndicator{color:#525252;position:relative;top:1px}.uppy-StatusBar-statusIndicator svg{vertical-align:text-bottom}[dir=ltr] .uppy-StatusBar-actions{right:10px}[dir=rtl] .uppy-StatusBar-actions{left:10px}.uppy-StatusBar-actions{align-items:center;bottom:0;display:flex;position:absolute;top:0;z-index:1004}.uppy-StatusBar.is-waiting .uppy-StatusBar-actions{background-color:#fafafa;height:100%;padding:0 15px;position:static;width:100%}[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actions{background-color:#1f1f1f}.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts{flex-direction:column;height:90px}.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts{flex-direction:row;height:65px}.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions{flex-direction:column;justify-content:center}.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions{flex-direction:row;justify-content:normal}.uppy-StatusBar-actionCircleBtn{cursor:pointer;line-height:1;margin:3px;opacity:.9}.uppy-StatusBar-actionCircleBtn:focus{outline:none}.uppy-StatusBar-actionCircleBtn::-moz-focus-inner{border:0}.uppy-StatusBar-actionCircleBtn:focus{box-shadow:0 0 0 3px #2275d780}[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus{outline:none}[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-StatusBar-actionCircleBtn:hover{opacity:1}.uppy-StatusBar-actionCircleBtn:focus{border-radius:50%}.uppy-StatusBar-actionCircleBtn svg{vertical-align:bottom}.uppy-StatusBar-actionBtn{color:#2275d7;display:inline-block;font-size:10px;line-height:inherit;vertical-align:middle}.uppy-size--md .uppy-StatusBar-actionBtn{font-size:11px}.uppy-StatusBar-actionBtn--disabled{opacity:.4}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--disabled{opacity:.7}[dir=ltr] .uppy-StatusBar-actionBtn--retry{margin-right:6px}[dir=rtl] .uppy-StatusBar-actionBtn--retry{margin-left:6px}.uppy-StatusBar-actionBtn--retry{background-color:#ff4b23;border-radius:8px;color:#fff;height:16px;line-height:1;padding:1px 6px 3px 18px;position:relative}.uppy-StatusBar-actionBtn--retry:focus{outline:none}.uppy-StatusBar-actionBtn--retry::-moz-focus-inner{border:0}.uppy-StatusBar-actionBtn--retry:focus{box-shadow:0 0 0 3px #2275d780}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus{outline:none}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-StatusBar-actionBtn--retry:hover{background-color:#f92d00}[dir=ltr] .uppy-StatusBar-actionBtn--retry svg{left:6px}[dir=rtl] .uppy-StatusBar-actionBtn--retry svg{right:6px}.uppy-StatusBar-actionBtn--retry svg{position:absolute;top:3px}.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload{background-color:#1bb240;color:#fff;font-size:14px;line-height:1;padding:15px 10px;width:100%}.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover{background-color:#189c38}[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload{background-color:#1c8b37}[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover{background-color:#18762f}.uppy-size--md .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload{padding:13px 22px;width:auto}.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover{background-color:#1bb240;cursor:not-allowed}[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover{background-color:#1c8b37}.uppy-StatusBar:not(.is-waiting) .uppy-StatusBar-actionBtn--upload{background-color:initial;color:#2275d7}[dir=ltr] .uppy-StatusBar-actionBtn--uploadNewlyAdded{padding-right:3px}[dir=ltr] .uppy-StatusBar-actionBtn--uploadNewlyAdded,[dir=rtl] .uppy-StatusBar-actionBtn--uploadNewlyAdded{padding-left:3px}[dir=rtl] .uppy-StatusBar-actionBtn--uploadNewlyAdded{padding-right:3px}.uppy-StatusBar-actionBtn--uploadNewlyAdded{border-radius:3px;padding-bottom:1px}.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus{outline:none}.uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner{border:0}.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus{box-shadow:0 0 0 3px #2275d780}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus{outline:none}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-StatusBar-actionBtn--done{border-radius:3px;line-height:1;padding:7px 8px}.uppy-StatusBar-actionBtn--done:focus{outline:none}.uppy-StatusBar-actionBtn--done::-moz-focus-inner{border:0}.uppy-StatusBar-actionBtn--done:hover{color:#1b5dab}.uppy-StatusBar-actionBtn--done:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done:focus{background-color:#333}[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done{color:#02baf2}.uppy-size--md .uppy-StatusBar-actionBtn--done{font-size:14px}.uppy-StatusBar-serviceMsg{color:#000;font-size:11px;line-height:1.1;padding-left:10px}.uppy-size--md .uppy-StatusBar-serviceMsg{font-size:14px;padding-left:15px}[data-uppy-theme=dark] .uppy-StatusBar-serviceMsg{color:#eaeaea}.uppy-StatusBar-serviceMsg-ghostsIcon{left:6px;opacity:.5;position:relative;top:2px;vertical-align:text-bottom;width:10px}.uppy-size--md .uppy-StatusBar-serviceMsg-ghostsIcon{left:10px;top:1px;width:15px}[dir=ltr] .uppy-StatusBar-details{left:2px}[dir=rtl] .uppy-StatusBar-details{right:2px}.uppy-StatusBar-details{appearance:none;background-color:#939393;border-radius:50%;color:#fff;cursor:help;display:inline-block;font-size:10px;font-weight:600;height:13px;line-height:12px;position:relative;text-align:center;top:0;vertical-align:middle;width:13px}.uppy-StatusBar-details:after{word-wrap:break-word;line-height:1.3}[dir=ltr] .uppy-StatusBar-spinner{margin-right:10px}[dir=rtl] .uppy-StatusBar-spinner{margin-left:10px}.uppy-StatusBar-spinner{fill:#2275d7;animation-duration:1s;animation-iteration-count:infinite;animation-name:uppy-StatusBar-spinnerAnimation;animation-timing-function:linear}.uppy-StatusBar.is-postprocessing .uppy-StatusBar-spinner,.uppy-StatusBar.is-preprocessing .uppy-StatusBar-spinner{fill:#f6a623}@keyframes uppy-StatusBar-spinnerAnimation{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;padding:6px}.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list:after{content:\"\";flex:auto}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem{margin:0;position:relative;width:50%}.uppy-size--md .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem{width:33.3333%}.uppy-size--lg .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem{width:25%}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem:before{content:\"\";display:block;padding-top:100%}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected img,.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected svg{opacity:.85}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--disabled{opacity:.5}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner{background-color:#93939333}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner{background-color:#eaeaea33}.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg{fill:#000000b3;height:30%;width:30%}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg{fill:#fffc}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner{border-radius:4px;bottom:7px;height:calc(100% - 14px);left:7px;overflow:hidden;position:absolute;right:7px;text-align:center;top:7px;width:calc(100% - 14px)}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner:focus{box-shadow:0 0 0 3px #2275d7e6;outline:none}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner{box-shadow:0 0 0 3px #aae1ffb3}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner img{border-radius:4px;height:100%;object-fit:cover;width:100%}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox{background-color:#2275d7;border-radius:50%;height:26px;opacity:0;position:absolute;right:16px;top:16px;width:26px;z-index:1002}[dir=ltr] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after{left:7px}[dir=rtl] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after{right:7px}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox:after{height:7px;top:8px;width:12px}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--is-checked{opacity:1}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label{box-shadow:0 0 0 3px #2275d780}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label:focus{outline:none}.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus+label::-moz-focus-inner{border:0}.uppy-ProviderBrowser-viewType--list{background-color:#fff}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list{background-color:#1f1f1f}.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem{align-items:center;display:flex;margin:0;padding:7px 15px}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem{color:#eaeaea}.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem--disabled{opacity:.6}[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{margin-right:15px}[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{margin-left:15px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{background-color:#fff;border:1px solid #cfcfcf;border-radius:3px;height:17px;width:17px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus{border:1px solid #2275d7;box-shadow:0 0 0 3px #2275d740;outline:none}[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after{left:3px}[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after{right:3px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:after{height:5px;opacity:0;top:4px;width:9px}[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus{border-color:#02baf2b3;box-shadow:0 0 0 3px #02baf233}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox--is-checked{background-color:#2275d7;border-color:#2275d7}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox--is-checked:after{opacity:1}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner{align-items:center;display:flex;overflow:hidden;padding:2px;text-overflow:ellipsis;white-space:nowrap}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner:focus{outline:none;text-decoration:underline}[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{margin-right:8px}[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{margin-left:8px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{max-height:20px;max-width:20px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner span{line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--disabled .uppy-ProviderBrowserItem-inner{cursor:default}[dir=ltr] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{margin-right:7px}[dir=rtl] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{margin-left:7px}.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{width:20px}.uppy-ProviderBrowserItem-checkbox{cursor:pointer;flex-shrink:0;position:relative}.uppy-ProviderBrowserItem-checkbox:disabled{cursor:default}.uppy-ProviderBrowserItem-checkbox:after{border-bottom:2px solid #eaeaea;border-left:2px solid #eaeaea;content:\"\";cursor:pointer;position:absolute;transform:rotate(-45deg)}.uppy-ProviderBrowserItem-checkbox:disabled:after{cursor:default}[data-uppy-theme=dark] .uppy-ProviderBrowserItem-checkbox{background-color:#1f1f1f;border-color:#939393}[data-uppy-theme=dark] .uppy-ProviderBrowserItem-checkbox--is-checked{background-color:#333}.uppy-SearchProvider{align-items:center;display:flex;flex:1;flex-direction:column;height:100%;justify-content:center;width:100%}[data-uppy-theme=dark] .uppy-SearchProvider{background-color:#1f1f1f}.uppy-SearchProvider-input{margin-bottom:15px;max-width:650px;width:90%}.uppy-size--md .uppy-SearchProvider-input{margin-bottom:20px}.uppy-SearchProvider-searchButton{padding:13px 25px}.uppy-size--md .uppy-SearchProvider-searchButton{padding:13px 30px}.uppy-DashboardContent-panelBody{align-items:center;display:flex;flex:1;justify-content:center}[data-uppy-theme=dark] .uppy-DashboardContent-panelBody{background-color:#1f1f1f}.uppy-Provider-auth,.uppy-Provider-empty,.uppy-Provider-error,.uppy-Provider-loading{align-items:center;color:#939393;display:flex;flex:1;flex-flow:column wrap;justify-content:center}.uppy-Provider-empty{color:#939393}.uppy-Provider-authIcon svg{height:75px;margin-bottom:15px;width:100px}.uppy-Provider-authTitle{color:#757575;font-size:17px;font-weight:400;line-height:1.4;margin-bottom:30px;max-width:500px;padding:0 15px;text-align:center}.uppy-size--md .uppy-Provider-authTitle{font-size:20px}[data-uppy-theme=dark] .uppy-Provider-authTitle{color:#cfcfcf}[dir=ltr] .uppy-Provider-breadcrumbs{text-align:left}[dir=rtl] .uppy-Provider-breadcrumbs{text-align:right}.uppy-Provider-breadcrumbs{color:#525252;flex:1;font-size:12px;margin-bottom:10px}.uppy-size--md .uppy-Provider-breadcrumbs{margin-bottom:0}[data-uppy-theme=dark] .uppy-Provider-breadcrumbs{color:#eaeaea}[dir=ltr] .uppy-Provider-breadcrumbsIcon{margin-right:4px}[dir=rtl] .uppy-Provider-breadcrumbsIcon{margin-left:4px}.uppy-Provider-breadcrumbsIcon{color:#525252;display:inline-block;line-height:1;vertical-align:middle}.uppy-Provider-breadcrumbsIcon svg{fill:#525252;height:13px;width:13px}.uppy-Provider-breadcrumbs button{border-radius:3px;display:inline-block;line-height:inherit;padding:4px}.uppy-Provider-breadcrumbs button:focus{outline:none}.uppy-Provider-breadcrumbs button::-moz-focus-inner{border:0}.uppy-Provider-breadcrumbs button:hover{color:#1b5dab}.uppy-Provider-breadcrumbs button:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button:focus{background-color:#333}.uppy-Provider-breadcrumbs button:not(:last-of-type){text-decoration:underline}.uppy-Provider-breadcrumbs button:last-of-type{color:#333;cursor:normal;font-weight:500;pointer-events:none}.uppy-Provider-breadcrumbs button:hover{cursor:pointer}[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button{color:#eaeaea}.uppy-ProviderBrowser{display:flex;flex:1;flex-direction:column;font-size:14px;font-weight:400;height:100%}.uppy-ProviderBrowser-user{color:#333;font-weight:500;margin:0 8px 0 0}[data-uppy-theme=dark] .uppy-ProviderBrowser-user{color:#eaeaea}[dir=ltr] .uppy-ProviderBrowser-user:after{left:4px}[dir=rtl] .uppy-ProviderBrowser-user:after{right:4px}.uppy-ProviderBrowser-user:after{color:#939393;content:\"\\B7\";font-weight:400;position:relative}.uppy-ProviderBrowser-header{border-bottom:1px solid #eaeaea;position:relative;z-index:1001}[data-uppy-theme=dark] .uppy-ProviderBrowser-header{border-bottom:1px solid #333}.uppy-ProviderBrowser-headerBar{background-color:#fafafa;color:#757575;font-size:12px;line-height:1.4;padding:7px 15px;z-index:1001}.uppy-size--md .uppy-ProviderBrowser-headerBar{align-items:center;display:flex}[data-uppy-theme=dark] .uppy-ProviderBrowser-headerBar{background-color:#1f1f1f}.uppy-ProviderBrowser-headerBar--simple{display:block;justify-content:center;text-align:center}.uppy-ProviderBrowser-headerBar--simple .uppy-Provider-breadcrumbsWrap{display:inline-block;flex:none;vertical-align:middle}.uppy-ProviderBrowser-search{align-items:center;background-color:#fff;display:flex;height:30px;margin-bottom:5px;margin-top:10px;position:relative;width:100%}[data-uppy-theme=dark] .uppy-ProviderBrowser-search{background-color:#1f1f1f}[dir=ltr] .uppy-ProviderBrowser-searchIcon{left:16px}[dir=rtl] .uppy-ProviderBrowser-searchIcon{right:16px}.uppy-ProviderBrowser-searchIcon{color:#bbb;height:12px;position:absolute;width:12px;z-index:1002}[dir=ltr] .uppy-ProviderBrowser-searchInput{padding-left:27px}[dir=rtl] .uppy-ProviderBrowser-searchInput{padding-right:27px}.uppy-ProviderBrowser-searchInput{background-color:initial;border:0;border-radius:4px;font-family:-apple-system,blinkmacsystemfont,Segoe UI,helvetica,arial,sans-serif;font-size:12px;height:30px;line-height:1.4;margin:0 8px;outline:0;width:100%;z-index:1001}[data-uppy-theme=dark] .uppy-ProviderBrowser-searchInput{background-color:#1f1f1f;color:#eaeaea}.uppy-ProviderBrowser-searchInput:focus{background-color:#f4f4f4;outline:0}[data-uppy-theme=dark] .uppy-ProviderBrowser-searchInput:focus{background-color:#333}[dir=ltr] .uppy-ProviderBrowser-searchClose{right:12px}[dir=rtl] .uppy-ProviderBrowser-searchClose{left:12px}.uppy-ProviderBrowser-searchClose{color:#939393;cursor:pointer;height:22px;padding:6px;position:absolute;top:4px;width:22px;z-index:1002}.uppy-ProviderBrowser-searchClose:hover{color:#757575}.uppy-ProviderBrowser-searchClose svg{vertical-align:text-top}.uppy-ProviderBrowser-searchInput::placeholder{color:#939393;opacity:1}.uppy-ProviderBrowser-userLogout{border-radius:3px;color:#2275d7;cursor:pointer;line-height:inherit;padding:4px}.uppy-ProviderBrowser-userLogout:focus{outline:none}.uppy-ProviderBrowser-userLogout::-moz-focus-inner{border:0}.uppy-ProviderBrowser-userLogout:hover{color:#1b5dab}.uppy-ProviderBrowser-userLogout:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout:focus{background-color:#333}.uppy-ProviderBrowser-userLogout:hover{text-decoration:underline}[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout{color:#eaeaea}.uppy-ProviderBrowser-body{flex:1;position:relative}.uppy-ProviderBrowser-list{-webkit-overflow-scrolling:touch;background-color:#fff;border-spacing:0;bottom:0;display:block;flex:1;height:100%;left:0;list-style:none;margin:0;overflow-x:hidden;overflow-y:auto;padding:0;position:absolute;right:0;top:0;width:100%}[data-uppy-theme=dark] .uppy-ProviderBrowser-list{background-color:#1f1f1f}.uppy-ProviderBrowser-list:focus{outline:none}.uppy-ProviderBrowserItem-inner{cursor:pointer;font-size:13px;font-weight:500}.uppy-ProviderBrowser-footer{align-items:center;background-color:#fff;border-top:1px solid #eaeaea;display:flex;height:65px;padding:0 15px}[dir=ltr] .uppy-ProviderBrowser-footer button{margin-right:8px}[dir=rtl] .uppy-ProviderBrowser-footer button{margin-left:8px}[data-uppy-theme=dark] .uppy-ProviderBrowser-footer{background-color:#1f1f1f;border-top:1px solid #333}.uppy-Dashboard-Item-previewInnerWrap{align-items:center;border-radius:3px;box-shadow:0 0 2px 0 #0006;display:flex;flex-direction:column;height:100%;justify-content:center;overflow:hidden;position:relative;width:100%}.uppy-size--md .uppy-Dashboard-Item-previewInnerWrap{box-shadow:0 1px 2px #00000026}.uppy-Dashboard-Item-previewInnerWrap:after{background-color:#000000a6;bottom:0;content:\"\";display:none;left:0;position:absolute;right:0;top:0;z-index:1001}.uppy-Dashboard-Item-previewLink{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1002}.uppy-Dashboard-Item-previewLink:focus{box-shadow:inset 0 0 0 3px #76abe9}[data-uppy-theme=dark] .uppy-Dashboard-Item-previewLink:focus{box-shadow:inset 0 0 0 3px #016c8d}.uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg{border-radius:3px;height:100%;object-fit:cover;transform:translateZ(0);width:100%}.uppy-Dashboard-Item-progress{color:#fff;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);transition:all .35 ease;width:120px;z-index:1002}.uppy-Dashboard-Item-progressIndicator{display:inline-block;height:38px;opacity:.9;width:38px}.uppy-size--md .uppy-Dashboard-Item-progressIndicator{height:55px;width:55px}button.uppy-Dashboard-Item-progressIndicator{cursor:pointer}button.uppy-Dashboard-Item-progressIndicator:focus{outline:none}button.uppy-Dashboard-Item-progressIndicator::-moz-focus-inner{border:0}button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--bg,button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--retry{fill:#76abe9}.uppy-Dashboard-Item-progressIcon--circle{height:100%;width:100%}.uppy-Dashboard-Item-progressIcon--bg{stroke:#fff6}.uppy-Dashboard-Item-progressIcon--progress{stroke:#fff;transition:stroke-dashoffset .5s ease-out}.uppy-Dashboard-Item-progressIcon--play{fill:#fff;stroke:#fff;transition:all .2s}.uppy-Dashboard-Item-progressIcon--cancel{fill:#fff;transition:all .2s}.uppy-Dashboard-Item-progressIcon--pause{fill:#fff;stroke:#fff;transition:all .2s}.uppy-Dashboard-Item-progressIcon--check{fill:#fff;transition:all .2s}.uppy-Dashboard-Item-progressIcon--retry{fill:#fff}[dir=ltr] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{right:-8px}[dir=rtl] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{left:-8px}[dir=ltr] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{left:auto}[dir=rtl] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{right:auto}.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{top:-9px;transform:none;width:auto}.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator{height:18px;width:18px}.uppy-size--md .uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator{height:28px;width:28px}.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator{height:18px;opacity:1;width:18px}.uppy-size--md .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator{height:22px;width:22px}.uppy-Dashboard-Item.is-processing .uppy-Dashboard-Item-progress{opacity:0}[dir=ltr] .uppy-Dashboard-Item-fileInfo{padding-right:5px}[dir=rtl] .uppy-Dashboard-Item-fileInfo{padding-left:5px}.uppy-Dashboard-Item-name{word-wrap:anywhere;font-size:12px;font-weight:500;line-height:1.3;margin-bottom:5px;word-break:break-all}[data-uppy-theme=dark] .uppy-Dashboard-Item-name{color:#eaeaea}.uppy-Dashboard-Item-status{color:#757575;font-size:11px;font-weight:400;line-height:1}[data-uppy-theme=dark] .uppy-Dashboard-Item-status{color:#bbb}.uppy-Dashboard-Item-statusSize{display:inline-block;text-transform:uppercase;vertical-align:bottom}.uppy-Dashboard-Item-reSelect{color:#2275d7;font-family:inherit;font-size:inherit;font-weight:600}.uppy-Dashboard-Item-action{color:#939393;cursor:pointer}.uppy-Dashboard-Item-action:focus{outline:none}.uppy-Dashboard-Item-action::-moz-focus-inner{border:0}.uppy-Dashboard-Item-action:focus{box-shadow:0 0 0 3px #2275d780}.uppy-Dashboard-Item-action:hover{color:#1f1f1f;opacity:1}[data-uppy-theme=dark] .uppy-Dashboard-Item-action{color:#cfcfcf}[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus{outline:none}[data-uppy-theme=dark] .uppy-Dashboard-Item-action::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus{box-shadow:0 0 0 2px #aae1ffd9}[data-uppy-theme=dark] .uppy-Dashboard-Item-action:hover{color:#eaeaea}.uppy-Dashboard-Item-action--remove{color:#1f1f1f;opacity:.95}.uppy-Dashboard-Item-action--remove:hover{color:#000;opacity:1}[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove{color:#525252}[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove:hover{color:#333}.uppy-Dashboard:not(.uppy-size--md) .uppy-Dashboard-Item-actionWrapper{align-items:center;display:flex}.uppy-Dashboard:not(.uppy-size--md) .uppy-Dashboard-Item-action{height:22px;margin-left:3px;padding:3px;width:22px}.uppy-Dashboard:not(.uppy-size--md) .uppy-Dashboard-Item-action:focus{border-radius:3px}.uppy-size--md .uppy-Dashboard-Item-action--copyLink,.uppy-size--md .uppy-Dashboard-Item-action--edit{height:16px;padding:0;width:16px}.uppy-size--md .uppy-Dashboard-Item-action--copyLink:focus,.uppy-size--md .uppy-Dashboard-Item-action--edit:focus{border-radius:3px}[dir=ltr] .uppy-size--md .uppy-Dashboard-Item-action--remove{right:-8px}[dir=rtl] .uppy-size--md .uppy-Dashboard-Item-action--remove{left:-8px}.uppy-size--md .uppy-Dashboard-Item-action--remove{height:18px;padding:0;position:absolute;top:-8px;width:18px;z-index:1002}.uppy-size--md .uppy-Dashboard-Item-action--remove:focus{border-radius:50%}[dir=ltr] .uppy-Dashboard-Item{padding-right:0}[dir=rtl] .uppy-Dashboard-Item{padding-left:0}.uppy-Dashboard-Item{align-items:center;border-bottom:1px solid #eaeaea;display:flex;padding:10px}[data-uppy-theme=dark] .uppy-Dashboard-Item{border-bottom:1px solid #333}[dir=ltr] .uppy-size--md .uppy-Dashboard-Item{float:left}[dir=rtl] .uppy-size--md .uppy-Dashboard-Item{float:right}.uppy-size--md .uppy-Dashboard-Item{border-bottom:0;display:block;height:215px;margin:5px 15px;padding:0;position:relative;width:calc(33.333% - 30px)}.uppy-size--lg .uppy-Dashboard-Item{height:190px;margin:5px 15px;width:calc(25% - 30px)}.uppy-size--xl .uppy-Dashboard-Item{height:210px;width:calc(20% - 30px)}.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-previewInnerWrap{opacity:.2}.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-name{opacity:.7}.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='35' height='39'%3E%3Cpath d='M1.708 38.66c1.709 0 3.417-3.417 6.834-3.417 3.416 0 5.125 3.417 8.61 3.417 3.348 0 5.056-3.417 8.473-3.417 4.305 0 5.125 3.417 6.833 3.417.889 0 1.709-.889 1.709-1.709v-19.68C34.167-5.757 0-5.757 0 17.271v19.68c0 .82.888 1.709 1.708 1.709zm8.542-17.084a3.383 3.383 0 0 1-3.417-3.416 3.383 3.383 0 0 1 3.417-3.417 3.383 3.383 0 0 1 3.417 3.417 3.383 3.383 0 0 1-3.417 3.416zm13.667 0A3.383 3.383 0 0 1 20.5 18.16a3.383 3.383 0 0 1 3.417-3.417 3.383 3.383 0 0 1 3.416 3.417 3.383 3.383 0 0 1-3.416 3.416z' fill='%2523000'/%3E%3C/svg%3E\");background-position:50% 10px;background-repeat:no-repeat;background-size:25px;bottom:0;content:\"\";left:0;opacity:.5;position:absolute;right:0;top:0;z-index:1005}.uppy-size--md .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview:before{background-position:50% 50%;background-size:40px}.uppy-Dashboard-Item-preview{position:relative}.uppy-Dashboard:not(.uppy-size--md) .uppy-Dashboard-Item-preview{flex-grow:0;flex-shrink:0;height:50px;width:50px}.uppy-size--md .uppy-Dashboard-Item-preview{height:140px;width:100%}.uppy-size--lg .uppy-Dashboard-Item-preview{height:120px}.uppy-size--xl .uppy-Dashboard-Item-preview{height:140px}[dir=ltr] .uppy-Dashboard-Item-fileInfoAndButtons{padding-right:8px}[dir=rtl] .uppy-Dashboard-Item-fileInfoAndButtons{padding-left:8px}[dir=ltr] .uppy-Dashboard-Item-fileInfoAndButtons{padding-left:12px}[dir=rtl] .uppy-Dashboard-Item-fileInfoAndButtons{padding-right:12px}.uppy-Dashboard-Item-fileInfoAndButtons{align-items:center;display:flex;flex-grow:1;justify-content:space-between}.uppy-size--md .uppy-Dashboard-Item-fileInfoAndButtons{align-items:flex-start;padding:9px 0 0;width:100%}.uppy-Dashboard-Item-fileInfo{flex-grow:1;flex-shrink:1}.uppy-Dashboard-Item-actionWrapper{flex-grow:0;flex-shrink:0}.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-previewInnerWrap:after,.uppy-Dashboard-Item.is-inprogress .uppy-Dashboard-Item-previewInnerWrap:after{display:block}.uppy-Dashboard-Item.is-inprogress:not(.is-resumable) .uppy-Dashboard-Item-action--remove{display:none}[dir=ltr] .uppy-Dashboard-Item-errorDetails{left:6px}[dir=rtl] .uppy-Dashboard-Item-errorDetails{right:6px}.uppy-Dashboard-Item-errorDetails{appearance:none;background-color:#939393;border-radius:50%;color:#fff;cursor:help;display:inline-block;font-size:8px;font-weight:600;height:12px;line-height:12px;position:relative;text-align:center;top:-1px;vertical-align:middle;width:12px}.uppy-Dashboard-Item-errorDetails:after{word-wrap:break-word;line-height:1.3}.uppy-Dashboard-FileCard{background-color:#fff;border-radius:5px;bottom:0;box-shadow:0 0 10px 4px #0000001a;display:flex;flex-direction:column;height:100%;left:0;position:absolute;right:0;top:0;width:100%;z-index:1005}.uppy-Dashboard-FileCard .uppy-DashboardContent-bar{border-top-left-radius:5px;border-top-right-radius:5px}.uppy-Dashboard-FileCard .uppy-Dashboard-FileCard-actions{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.uppy-Dashboard-FileCard-inner{display:flex;flex-direction:column;flex-grow:1;flex-shrink:1;height:100%;min-height:0}.uppy-Dashboard-FileCard-preview{align-items:center;border-bottom:1px solid #eaeaea;display:flex;flex-grow:0;flex-shrink:1;height:60%;justify-content:center;min-height:0;position:relative}[data-uppy-theme=dark] .uppy-Dashboard-FileCard-preview{background-color:#333;border-bottom:0}.uppy-Dashboard-FileCard-preview img.uppy-Dashboard-Item-previewImg{border-radius:3px;box-shadow:0 3px 20px #00000026;flex:0 0 auto;max-height:90%;max-width:90%;object-fit:cover}[dir=ltr] .uppy-Dashboard-FileCard-edit{right:10px}[dir=rtl] .uppy-Dashboard-FileCard-edit{left:10px}.uppy-Dashboard-FileCard-edit{background-color:#00000080;border-radius:50px;color:#fff;font-size:13px;padding:7px 15px;position:absolute;top:10px}.uppy-Dashboard-FileCard-edit:focus{outline:none}.uppy-Dashboard-FileCard-edit::-moz-focus-inner{border:0}.uppy-Dashboard-FileCard-edit:focus{box-shadow:0 0 0 3px #2275d780}.uppy-Dashboard-FileCard-edit:hover{background-color:#000c}.uppy-Dashboard-FileCard-info{-webkit-overflow-scrolling:touch;flex-grow:0;flex-shrink:0;height:40%;overflow-y:auto;padding:30px 20px 20px}[data-uppy-theme=dark] .uppy-Dashboard-FileCard-info{background-color:#1f1f1f}.uppy-Dashboard-FileCard-fieldset{border:0;font-size:0;margin:auto auto 12px;max-width:640px;padding:0}.uppy-Dashboard-FileCard-label{color:#525252;display:inline-block;font-size:12px;vertical-align:middle;width:22%}.uppy-size--md .uppy-Dashboard-FileCard-label{font-size:14px}[data-uppy-theme=dark] .uppy-Dashboard-FileCard-label{color:#eaeaea}.uppy-Dashboard-FileCard-input{display:inline-block;vertical-align:middle;width:78%}.uppy-Dashboard-FileCard-actions{align-items:center;background-color:#fafafa;border-top:1px solid #eaeaea;display:flex;flex-grow:0;flex-shrink:0;height:55px;padding:0 15px}.uppy-size--md .uppy-Dashboard-FileCard-actions{height:65px}[data-uppy-theme=dark] .uppy-Dashboard-FileCard-actions{background-color:#1f1f1f;border-top:1px solid #333}[dir=ltr] .uppy-Dashboard-FileCard-actionsBtn{margin-right:10px}[dir=rtl] .uppy-Dashboard-FileCard-actionsBtn{margin-left:10px}.uppy-transition-slideDownUp-enter{opacity:.01;transform:translate3d(0,-105%,0);transition:transform .25s ease-in-out,opacity .25s ease-in-out}.uppy-transition-slideDownUp-enter.uppy-transition-slideDownUp-enter-active{opacity:1;transform:translateZ(0)}.uppy-transition-slideDownUp-leave{opacity:1;transform:translateZ(0);transition:transform .25s ease-in-out,opacity .25s ease-in-out}.uppy-transition-slideDownUp-leave.uppy-transition-slideDownUp-leave-active{opacity:.01;transform:translate3d(0,-105%,0)}@keyframes uppy-Dashboard-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes uppy-Dashboard-fadeOut{0%{opacity:1}to{opacity:0}}@keyframes uppy-Dashboard-slideDownAndFadeIn{0%{opacity:0;transform:translate3d(-50%,-70%,0)}to{opacity:1;transform:translate3d(-50%,-50%,0)}}@keyframes uppy-Dashboard-slideDownAndFadeIn--small{0%{opacity:0;transform:translate3d(0,-20%,0)}to{opacity:1;transform:translateZ(0)}}@keyframes uppy-Dashboard-slideUpFadeOut{0%{opacity:1;transform:translate3d(-50%,-50%,0)}to{opacity:0;transform:translate3d(-50%,-70%,0)}}@keyframes uppy-Dashboard-slideUpFadeOut--small{0%{opacity:1;transform:translateZ(0)}to{opacity:0;transform:translate3d(0,-20%,0)}}.uppy-Dashboard--modal{z-index:1001}.uppy-Dashboard--modal[aria-hidden=true]{display:none}.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-inner{animation:uppy-Dashboard-slideDownAndFadeIn--small .3s cubic-bezier(0,0,.2,1)}@media only screen and (min-width:820px){.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-inner{animation:uppy-Dashboard-slideDownAndFadeIn .3s cubic-bezier(0,0,.2,1)}}.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose>.uppy-Dashboard-overlay{animation:uppy-Dashboard-fadeIn .3s cubic-bezier(0,0,.2,1)}.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-inner{animation:uppy-Dashboard-slideUpFadeOut--small .3s cubic-bezier(0,0,.2,1)}@media only screen and (min-width:820px){.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-inner{animation:uppy-Dashboard-slideUpFadeOut .3s cubic-bezier(0,0,.2,1)}}.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing>.uppy-Dashboard-overlay{animation:uppy-Dashboard-fadeOut .3s cubic-bezier(0,0,.2,1)}.uppy-Dashboard-isFixed{height:100vh;overflow:hidden}.uppy-Dashboard--modal .uppy-Dashboard-overlay{background-color:#00000080;bottom:0;left:0;position:fixed;right:0;top:0;z-index:1001}.uppy-Dashboard-inner{background-color:#fafafa;border:1px solid #eaeaea;border-radius:5px;max-height:100%;max-width:100%;outline:none;position:relative}.uppy-size--md .uppy-Dashboard-inner{min-height:auto}@media only screen and (min-width:820px){.uppy-Dashboard-inner{height:550px;width:750px}}.uppy-Dashboard--modal .uppy-Dashboard-inner{z-index:1002}[data-uppy-theme=dark] .uppy-Dashboard-inner{background-color:#1f1f1f}.uppy-Dashboard--isDisabled .uppy-Dashboard-inner{cursor:not-allowed}.uppy-Dashboard-innerWrap{border-radius:5px;display:flex;flex-direction:column;height:100%;opacity:0;overflow:hidden;position:relative}.uppy-Dashboard--isInnerWrapVisible .uppy-Dashboard-innerWrap{opacity:1}.uppy-Dashboard--isDisabled .uppy-Dashboard-innerWrap{filter:grayscale(100%);opacity:.6;pointer-events:none;-webkit-user-select:none;user-select:none}.uppy-Dashboard--isDisabled .uppy-ProviderIconBg{fill:#9f9f9f}.uppy-Dashboard--modal .uppy-Dashboard-inner{border:none;bottom:15px;left:15px;position:fixed;right:15px;top:35px}@media only screen and (min-width:820px){.uppy-Dashboard--modal .uppy-Dashboard-inner{box-shadow:0 5px 15px 4px #00000026;left:50%;right:auto;top:50%;transform:translate(-50%,-50%)}}[dir=ltr] .uppy-Dashboard-close{right:-2px}[dir=rtl] .uppy-Dashboard-close{left:-2px}.uppy-Dashboard-close{color:#ffffffe6;cursor:pointer;display:block;font-size:27px;position:absolute;top:-33px;z-index:1005}.uppy-Dashboard-close:focus{outline:none}.uppy-Dashboard-close::-moz-focus-inner{border:0}.uppy-Dashboard-close:focus{color:#8cb8ed}@media only screen and (min-width:820px){[dir=ltr] .uppy-Dashboard-close{right:-35px}[dir=rtl] .uppy-Dashboard-close{left:-35px}.uppy-Dashboard-close{font-size:35px;top:-10px}}.uppy-Dashboard-serviceMsg{background-color:#fffbf7;border-bottom:1px solid #edd4b9;border-top:1px solid #edd4b9;font-size:12px;font-weight:500;line-height:1.3;padding:12px 0;position:relative;top:-1px;z-index:1004}.uppy-size--md .uppy-Dashboard-serviceMsg{font-size:14px;line-height:1.4}[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg{background-color:#1f1f1f;border-bottom:1px solid #333;border-top:1px solid #333;color:#eaeaea}.uppy-Dashboard-serviceMsg-title{display:block;line-height:1;margin-bottom:4px;padding-left:42px}.uppy-Dashboard-serviceMsg-text{padding:0 15px}.uppy-Dashboard-serviceMsg-actionBtn{color:#2275d7;font-size:inherit;font-weight:inherit;vertical-align:initial}[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg-actionBtn{color:#02baf2e6}.uppy-Dashboard-serviceMsg-icon{left:15px;position:absolute;top:10px}.uppy-Dashboard-AddFiles{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;text-align:center}[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles{border:1px dashed #dfdfdf;border-radius:3px;height:calc(100% - 14px);margin:7px}.uppy-Dashboard-AddFilesPanel .uppy-Dashboard-AddFiles{border:none;height:calc(100% - 54px)}.uppy-Dashboard--modal .uppy-Dashboard-AddFiles{border-color:#cfcfcf}[data-uppy-theme=dark] .uppy-Dashboard-AddFiles{border-color:#757575}.uppy-Dashboard-AddFiles-info{display:none;margin-top:auto;padding-bottom:15px;padding-top:15px}.uppy-size--height-md .uppy-Dashboard-AddFiles-info{display:block}.uppy-size--md .uppy-Dashboard-AddFiles-info{bottom:25px;left:0;padding-bottom:0;padding-top:30px;position:absolute;right:0}[data-uppy-num-acquirers=\"0\"] .uppy-Dashboard-AddFiles-info{margin-top:0}.uppy-Dashboard-browse{color:#2275d7e6;cursor:pointer}.uppy-Dashboard-browse:focus{outline:none}.uppy-Dashboard-browse::-moz-focus-inner{border:0}.uppy-Dashboard-browse:focus,.uppy-Dashboard-browse:hover{border-bottom:1px solid #2275d7}[data-uppy-theme=dark] .uppy-Dashboard-browse{color:#02baf2e6}[data-uppy-theme=dark] .uppy-Dashboard-browse:focus,[data-uppy-theme=dark] .uppy-Dashboard-browse:hover{border-bottom:1px solid #02baf2}.uppy-Dashboard-browseBtn{display:block;font-size:14px;font-weight:500;margin-bottom:5px;margin-top:8px;width:100%}.uppy-size--md .uppy-Dashboard-browseBtn{font-size:15px;margin:15px auto;padding:13px 44px;width:auto}.uppy-Dashboard-AddFiles-list{-webkit-overflow-scrolling:touch;display:flex;flex:1;flex-direction:column;margin-top:2px;overflow-y:auto;padding:2px 0;width:100%}.uppy-size--md .uppy-Dashboard-AddFiles-list{flex:none;flex-direction:row;flex-wrap:wrap;justify-content:center;margin-top:15px;max-width:600px;overflow-y:visible;padding-top:0}.uppy-DashboardTab{border-bottom:1px solid #eaeaea;text-align:center;width:100%}[data-uppy-theme=dark] .uppy-DashboardTab{border-bottom:1px solid #333}.uppy-size--md .uppy-DashboardTab{border-bottom:none;display:inline-block;margin-bottom:10px;width:auto}.uppy-DashboardTab-btn{align-items:center;appearance:none;background-color:initial;color:#525252;cursor:pointer;display:flex;flex-direction:row;height:100%;padding:12px 15px;width:100%}.uppy-DashboardTab-btn:focus{outline:none}[dir=ltr] .uppy-size--md .uppy-DashboardTab-btn{margin-right:1px}[dir=rtl] .uppy-size--md .uppy-DashboardTab-btn{margin-left:1px}.uppy-size--md .uppy-DashboardTab-btn{border-radius:5px;flex-direction:column;padding:10px 3px;width:86px}[data-uppy-theme=dark] .uppy-DashboardTab-btn{color:#eaeaea}.uppy-DashboardTab-btn::-moz-focus-inner{border:0}.uppy-DashboardTab-btn:hover{background-color:#f1f3f6}[data-uppy-theme=dark] .uppy-DashboardTab-btn:hover{background-color:#333}.uppy-DashboardTab-btn:active,.uppy-DashboardTab-btn:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-DashboardTab-btn:active,[data-uppy-theme=dark] .uppy-DashboardTab-btn:focus{background-color:#525252}[dir=ltr] .uppy-DashboardTab-btn svg{margin-right:10px}[dir=rtl] .uppy-DashboardTab-btn svg{margin-left:10px}.uppy-DashboardTab-btn svg{display:inline-block;max-height:100%;max-width:100%;overflow:hidden;transition:transform .15s ease-in-out;vertical-align:text-top}[dir=ltr] .uppy-size--md .uppy-DashboardTab-btn svg{margin-right:0}[dir=rtl] .uppy-size--md .uppy-DashboardTab-btn svg{margin-left:0}.uppy-DashboardTab-name{font-size:14px;font-weight:500}.uppy-size--md .uppy-DashboardTab-name{font-size:11px;line-height:15px;margin-bottom:0;margin-top:8px}.uppy-DashboardTab svg{height:23px;vertical-align:middle;width:23px}.uppy-size--md .uppy-DashboardTab svg{height:30px;width:30px}.uppy-Dashboard-input{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}.uppy-DashboardContent-bar{align-items:center;background-color:#fafafa;border-bottom:1px solid #eaeaea;display:flex;flex-shrink:0;height:40px;justify-content:space-between;padding:0 10px;position:relative;width:100%;z-index:1004}.uppy-size--md .uppy-DashboardContent-bar{height:50px;padding:0 15px}[data-uppy-theme=dark] .uppy-DashboardContent-bar{background-color:#1f1f1f;border-bottom:1px solid #333}.uppy-DashboardContent-title{font-size:12px;font-weight:500;left:0;line-height:40px;margin:auto;max-width:170px;overflow-x:hidden;position:absolute;right:0;text-align:center;text-overflow:ellipsis;top:0;white-space:nowrap;width:100%}.uppy-size--md .uppy-DashboardContent-title{font-size:14px;line-height:50px;max-width:300px}[data-uppy-theme=dark] .uppy-DashboardContent-title{color:#eaeaea}[dir=ltr] .uppy-DashboardContent-back,[dir=ltr] .uppy-DashboardContent-save{margin-left:-6px}[dir=rtl] .uppy-DashboardContent-back,[dir=rtl] .uppy-DashboardContent-save{margin-right:-6px}.uppy-DashboardContent-back,.uppy-DashboardContent-save{-webkit-appearance:none;background:none;border:0;border-radius:3px;color:inherit;color:#2275d7;cursor:pointer;font-family:inherit;font-size:inherit;font-size:12px;font-weight:400;line-height:1;margin:0;padding:7px 6px}.uppy-DashboardContent-back:focus,.uppy-DashboardContent-save:focus{outline:none}.uppy-DashboardContent-back::-moz-focus-inner,.uppy-DashboardContent-save::-moz-focus-inner{border:0}.uppy-DashboardContent-back:hover,.uppy-DashboardContent-save:hover{color:#1b5dab}.uppy-DashboardContent-back:focus,.uppy-DashboardContent-save:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-DashboardContent-back:focus,[data-uppy-theme=dark] .uppy-DashboardContent-save:focus{background-color:#333}.uppy-size--md .uppy-DashboardContent-back,.uppy-size--md .uppy-DashboardContent-save{font-size:14px}[data-uppy-theme=dark] .uppy-DashboardContent-back,[data-uppy-theme=dark] .uppy-DashboardContent-save{color:#02baf2}[dir=ltr] .uppy-DashboardContent-addMore{margin-right:-5px}[dir=rtl] .uppy-DashboardContent-addMore{margin-left:-5px}.uppy-DashboardContent-addMore{-webkit-appearance:none;background:none;border:0;border-radius:3px;color:inherit;color:#2275d7;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:500;height:29px;line-height:1;margin:0;padding:7px 8px;width:29px}.uppy-DashboardContent-addMore:focus{outline:none}.uppy-DashboardContent-addMore::-moz-focus-inner{border:0}.uppy-DashboardContent-addMore:hover{color:#1b5dab}.uppy-DashboardContent-addMore:focus{background-color:#eceef2}[data-uppy-theme=dark] .uppy-DashboardContent-addMore:focus{background-color:#333}[dir=ltr] .uppy-size--md .uppy-DashboardContent-addMore{margin-right:-8px}[dir=rtl] .uppy-size--md .uppy-DashboardContent-addMore{margin-left:-8px}.uppy-size--md .uppy-DashboardContent-addMore{font-size:14px;height:auto;width:auto}[data-uppy-theme=dark] .uppy-DashboardContent-addMore{color:#02baf2}[dir=ltr] .uppy-DashboardContent-addMore svg{margin-right:4px}[dir=rtl] .uppy-DashboardContent-addMore svg{margin-left:4px}.uppy-DashboardContent-addMore svg{vertical-align:initial}.uppy-size--md .uppy-DashboardContent-addMore svg{height:11px;width:11px}.uppy-DashboardContent-addMoreCaption{display:none}.uppy-size--md .uppy-DashboardContent-addMoreCaption{display:inline}.uppy-DashboardContent-panel{background-color:#f5f5f5;flex:1}.uppy-Dashboard-AddFilesPanel,.uppy-DashboardContent-panel{border-radius:5px;bottom:0;display:flex;flex-direction:column;left:0;overflow:hidden;position:absolute;right:0;top:0;z-index:1005}.uppy-Dashboard-AddFilesPanel{background:#fafafa;background:linear-gradient(0deg,#fafafa 35%,hsla(0,0%,98%,.85098));box-shadow:0 0 10px 5px #00000026}[data-uppy-theme=dark] .uppy-Dashboard-AddFilesPanel{background-color:#333;background-image:linear-gradient(0deg,#1f1f1f 35%,rgba(31,31,31,.85098))}.uppy-Dashboard--isAddFilesPanelVisible .uppy-Dashboard-files{filter:blur(2px)}.uppy-Dashboard-progress{bottom:0;height:12%;left:0;position:absolute;width:100%}.uppy-Dashboard-progressBarContainer.is-active{height:100%;left:0;position:absolute;top:0;width:100%;z-index:1004}.uppy-Dashboard:not(.uppy-size--md) .uppy-StatusBar-additionalInfo{display:none}.uppy-Dashboard-filesContainer{flex:1;margin:0;overflow-y:hidden;position:relative}.uppy-Dashboard-filesContainer:after{clear:both;content:\"\";display:table}.uppy-Dashboard-files{-webkit-overflow-scrolling:touch;flex:1;margin:0;overflow-y:auto;padding:0 0 10px}.uppy-size--md .uppy-Dashboard-files{padding-top:10px}.uppy-Dashboard-dropFilesHereHint{align-items:center;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='48' height='48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z' fill='%232275D7'/%3E%3C/svg%3E\");background-position:50% 50%;background-repeat:no-repeat;border:1px dashed #2275d7;border-radius:3px;bottom:7px;color:#757575;display:flex;font-size:16px;justify-content:center;left:7px;padding-top:90px;position:absolute;right:7px;text-align:center;top:7px;visibility:hidden;z-index:2000}[data-uppy-theme=dark] .uppy-Dashboard-dropFilesHereHint{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='48' height='48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z' fill='%2302BAF2'/%3E%3C/svg%3E\");border-color:#02baf2;color:#bbb}.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-dropFilesHereHint{visibility:visible}.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-files,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-progressindicators,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-serviceMsg,.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-DashboardContent-bar{opacity:.15}.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-AddFiles{opacity:.03}.uppy-Dashboard-AddFiles-title{color:#000;font-size:17px;font-weight:500;line-height:1.35;margin-bottom:5px;margin-top:15px;padding:0 15px;text-align:inline-start;width:100%}.uppy-size--md .uppy-Dashboard-AddFiles-title{font-size:25px;font-weight:400;margin-top:5px;max-width:480px;text-align:center}[data-uppy-num-acquirers=\"0\"] .uppy-Dashboard-AddFiles-title{text-align:center}[data-uppy-theme=dark] .uppy-Dashboard-AddFiles-title{color:#eaeaea}.uppy-Dashboard-AddFiles-title button{font-weight:500}.uppy-size--md .uppy-Dashboard-AddFiles-title button{font-weight:400}.uppy-Dashboard-note{color:#757575;font-size:14px;line-height:1.25;margin:auto;max-width:350px;padding:0 15px;text-align:center}.uppy-size--md .uppy-Dashboard-note{font-size:15px;line-height:1.35;max-width:600px}[data-uppy-theme=dark] .uppy-Dashboard-note{color:#cfcfcf}a.uppy-Dashboard-poweredBy{color:#939393;display:inline-block;font-size:11px;margin-top:8px;text-align:center;text-decoration:none}.uppy-Dashboard-poweredByIcon{fill:none;stroke:#939393;margin-left:1px;margin-right:1px;opacity:.9;position:relative;top:1px;vertical-align:text-top}.uppy-Dashboard-Item-previewIcon{height:25px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:25px;z-index:100}.uppy-size--md .uppy-Dashboard-Item-previewIcon{height:38px;width:38px}.uppy-Dashboard-Item-previewIcon svg{height:100%;width:100%}.uppy-Dashboard-Item-previewIconWrap{height:76px;max-height:75%;position:relative}.uppy-Dashboard-Item-previewIconBg{filter:drop-shadow(rgba(0,0,0,.1) 0 1px 1px);height:100%;width:100%}.uppy-Dashboard-upload{height:50px;position:relative;width:50px}.uppy-size--md .uppy-Dashboard-upload{height:60px;width:60px}.uppy-Dashboard-upload .uppy-c-icon{position:relative;top:1px;width:50%}[dir=ltr] .uppy-Dashboard-uploadCount{right:-12px}[dir=rtl] .uppy-Dashboard-uploadCount{left:-12px}.uppy-Dashboard-uploadCount{background-color:#1bb240;border-radius:50%;color:#fff;font-size:8px;height:16px;line-height:16px;position:absolute;top:-12px;width:16px}.uppy-size--md .uppy-Dashboard-uploadCount{font-size:9px;height:18px;line-height:18px;width:18px}.uppy-DragDrop-container{align-items:center;background-color:#fff;border-radius:7px;cursor:pointer;display:flex;font-family:-apple-system,blinkmacsystemfont,Segoe UI,helvetica,arial,sans-serif;justify-content:center;max-width:100%}.uppy-DragDrop-container::-moz-focus-inner{border:0}.uppy-DragDrop-container:focus{box-shadow:0 0 0 3px #2275d766;outline:none}.uppy-DragDrop-inner{line-height:1.4;margin:0;padding:80px 20px;text-align:center}.uppy-DragDrop-arrow{fill:#e0e0e0;height:60px;margin-bottom:17px;width:60px}.uppy-DragDrop--isDragDropSupported{border:2px dashed #adadad}.uppy-DragDrop--isDraggingOver{background:#eaeaea;border:2px dashed #2275d7}.uppy-DragDrop--isDraggingOver .uppy-DragDrop-arrow{fill:#939393}.uppy-DragDrop-label{display:block;font-size:1.15em;margin-bottom:5px}.uppy-DragDrop-browse{color:#2275d7;cursor:pointer}.uppy-DragDrop-note{color:#adadad;font-size:1em}.uppy-FileInput-container{margin-bottom:15px}.uppy-FileInput-btn{-webkit-appearance:none;background:none;border:1px solid #14457f;border-radius:8px;color:inherit;color:#14457f;cursor:pointer;font-family:inherit;font-family:sans-serif;font-size:inherit;font-size:.85em;line-height:1;margin:0;padding:10px 15px}.uppy-FileInput-btn:hover{background-color:#14457f;color:#fff}.uppy-ProgressBar{height:3px;left:0;position:absolute;top:0;transition:height .2s;width:100%;z-index:10000}.uppy-ProgressBar[aria-hidden=true]{height:0}.uppy-ProgressBar-inner{background-color:#2275d7;box-shadow:0 0 10px #2275d7b3;height:100%;transition:width .4s ease;width:0}.uppy-ProgressBar-percentage{color:#fff;display:none;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}.uppy-Url{align-items:center;display:flex;flex:1;flex-direction:column;height:100%;justify-content:center;width:100%}[data-uppy-theme=dark] .uppy-Url{background-color:#1f1f1f}.uppy-Url-input{margin-bottom:15px;max-width:650px;width:90%}.uppy-size--md .uppy-Url-input{margin-bottom:20px}.uppy-Url-importButton{padding:13px 25px}.uppy-size--md .uppy-Url-importButton{padding:13px 30px}.uppy-Webcam-container{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;width:100%}.uppy-Webcam-videoContainer{background-color:#333;flex:1;flex-grow:1;overflow:hidden;position:relative;text-align:center;width:100%}.uppy-Webcam-video{bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;position:absolute;right:0;top:0}.uppy-Webcam-video--mirrored{transform:scaleX(-1)}.uppy-Webcam-footer{align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;min-height:75px;padding:20px;width:100%}.uppy-Webcam-videoSourceContainer{flex-grow:0;width:100%}.uppy-size--lg .uppy-Webcam-videoSourceContainer{margin:0;width:33%}.uppy-Webcam-videoSource-select{background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23757575%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");background-position:right .4em top 50%,0 0;background-repeat:no-repeat;background-size:.65em auto,100%;border:1px solid #757575;display:block;font-size:16px;line-height:1.2;margin:auto auto 10px;max-width:90%;padding:.4em 1em .3em .4em;text-overflow:ellipsis;white-space:nowrap;width:100%}.uppy-size--lg .uppy-Webcam-videoSource-select{font-size:14px;margin-bottom:0}.uppy-Webcam-videoSource-select::-ms-expand{display:none}.uppy-Webcam-buttonContainer{margin-left:25%;text-align:center;width:50%}.uppy-size--lg .uppy-Webcam-buttonContainer{margin-left:0;width:34%}.uppy-Webcam-recordingLength{color:#757575;flex-grow:0;font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;text-align:right;width:25%}.uppy-size--lg .uppy-Webcam-recordingLength{width:33%}.uppy-Webcam-button{background-color:#e32437;border-radius:50%;color:#fff;cursor:pointer;height:45px;transition:all .3s;width:45px}.uppy-Webcam-button:focus{outline:none}.uppy-Webcam-button::-moz-focus-inner{border:0}.uppy-Webcam-button:focus{box-shadow:0 0 0 3px #2275d780}.uppy-Webcam-button:hover{background-color:#d31b2d}[data-uppy-theme=dark] .uppy-Webcam-button:focus{outline:none}[data-uppy-theme=dark] .uppy-Webcam-button::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-Webcam-button:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-Webcam-button--submit{background-color:#2275d7;margin:0 12px}.uppy-Webcam-button--submit:hover{background-color:#1f69c1}.uppy-Webcam-button svg{fill:currentColor;display:inline-block;height:30px;max-height:100%;max-width:100%;overflow:hidden;vertical-align:text-top;width:30px}.uppy-size--md .uppy-Webcam-button{height:60px;width:60px}.uppy-Webcam-button--picture{margin-right:12px}.uppy-Webcam-permissons{align-items:center;display:flex;flex:1;flex-flow:column wrap;height:100%;justify-content:center;padding:15px}.uppy-Webcam-permissons p{color:#939393;line-height:1.3;line-height:1.45;margin:0;max-width:450px;text-align:center}.uppy-Webcam-permissonsIcon svg{color:#bbb;height:75px;margin-bottom:30px;width:100px}.uppy-Webcam-title{color:#333;font-size:22px;font-weight:400;line-height:1.35;margin:0 0 5px;max-width:500px;padding:0 15px;text-align:center}[data-uppy-theme=dark] .uppy-Webcam-title{color:#eaeaea}.uppy-ScreenCapture-container{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;width:100%}.uppy-ScreenCapture-videoContainer{background-color:#333;flex:1;flex-grow:1;overflow:hidden;position:relative;text-align:center;width:100%}.uppy-size--md .uppy-ScreenCapture-videoContainer{max-width:100%}.uppy-ScreenCapture-video{bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;outline:0;position:absolute;right:0;top:0}.uppy-ScreenCapture-buttonContainer{align-items:center;background-color:#fff;border-top:1px solid #eaeaea;display:flex;height:75px;justify-content:center;padding:0 20px;width:100%}[data-uppy-theme=dark] .uppy-ScreenCapture-buttonContainer{background-color:#1f1f1f;border-top:1px solid #333}.uppy-ScreenCapture-button{border-radius:50%;color:#fff;cursor:pointer;height:45px;transition:all .3s;width:45px}.uppy-ScreenCapture-button:focus{outline:none}.uppy-ScreenCapture-button::-moz-focus-inner{border:0}.uppy-ScreenCapture-button:focus{box-shadow:0 0 0 3px #2275d780}[data-uppy-theme=dark] .uppy-ScreenCapture-button:focus{outline:none}[data-uppy-theme=dark] .uppy-ScreenCapture-button::-moz-focus-inner{border:0}[data-uppy-theme=dark] .uppy-ScreenCapture-button:focus{box-shadow:0 0 0 2px #aae1ffd9}.uppy-size--md .uppy-ScreenCapture-button{height:60px;width:60px}.uppy-ScreenCapture-button:hover{background-color:#d31b2d}.uppy-ScreenCapture-button svg{fill:currentColor;display:inline-block;height:30px;max-height:100%;max-width:100%;overflow:hidden;vertical-align:text-top;width:30px}.uppy-ScreenCapture-button--submit{background-color:#2275d7;margin-left:12px}.uppy-ScreenCapture-button--submit:hover{background-color:#1f69c1}.uppy-ScreenCapture-button--submit:disabled{background-color:#939393;cursor:default}.uppy-ScreenCapture-button--submit:disabled:hover{background-color:#eaeaea}.uppy-ScreenCapture-title{color:#333;font-size:22px;font-weight:400;line-height:1.35;margin:0 0 5px;max-width:500px;padding:0 15px;text-align:center}.uppy-ScreenCapture-icon--stream{margin:1rem;position:absolute;right:0;top:0;z-index:1}.uppy-ScreenCapture-icon--stream svg{fill:#939393}.uppy-ScreenCapture-icon--streamActive svg{animation:uppy-ScreenCapture-icon--blink 1s cubic-bezier(.47,0,.75,.72) infinite}@keyframes uppy-ScreenCapture-icon--blink{0%{fill:#2275d7}50%{fill:#939393}to{fill:#2275d7}}.uppy-ScreenCapture-button--video{background:#e32437;color:#fff}.uppy-ScreenCapture-button--video:hover{background-color:#bc1828}[type=range]{-webkit-appearance:none;background:#0000;margin:9px 0;width:100%}[type=range]::-moz-focus-outer{border:0}[type=range]:focus{outline:0}[type=range]:focus::-webkit-slider-runnable-track{background:#fff3}[type=range]:focus::-ms-fill-lower,[type=range]:focus::-ms-fill-upper{background:#fff3}[type=range]::-webkit-slider-runnable-track{background:#fff3;border:0 solid #0000;border-radius:5px;box-shadow:0 0 0 #0000,0 0 0 #0d0d0d00;cursor:default;height:4px;transition:all .2s ease;width:100%}[type=range]::-webkit-slider-thumb{-webkit-appearance:none;background:#fff;border:0 solid #0000;border-radius:9px;box-shadow:0 0 4px #0003,0 0 0 #0d0d0d33;box-sizing:border-box;cursor:default;height:18px;margin-top:-7px;width:18px}[type=range]::-moz-range-track{background:#fff3;border:0 solid #0000;border-radius:5px;box-shadow:0 0 0 #0000,0 0 0 #0d0d0d00;cursor:default;height:4px;transition:all .2s ease;width:100%}[type=range]::-moz-range-thumb{background:#fff;border:0 solid #0000;border-radius:9px;box-shadow:0 0 4px #0003,0 0 0 #0d0d0d33;box-sizing:border-box;cursor:default;height:18px;width:18px}[type=range]::-ms-track{background:#0000;border-color:#0000;border-width:9px 0;color:#0000;cursor:default;height:4px;transition:all .2s ease;width:100%}[type=range]::-ms-fill-lower{background:#f2f2f233}[type=range]::-ms-fill-lower,[type=range]::-ms-fill-upper{border:0 solid #0000;border-radius:10px;box-shadow:0 0 0 #0000,0 0 0 #0d0d0d00}[type=range]::-ms-fill-upper{background:#fff3}[type=range]::-ms-thumb{background:#fff;border:0 solid #0000;border-radius:9px;box-shadow:0 0 4px #0003,0 0 0 #0d0d0d33;box-sizing:border-box;cursor:default;height:18px;margin-top:1px;width:18px}[type=range]:disabled::-moz-range-thumb,[type=range]:disabled::-ms-fill-lower,[type=range]:disabled::-ms-fill-upper,[type=range]:disabled::-ms-thumb,[type=range]:disabled::-webkit-slider-runnable-track,[type=range]:disabled::-webkit-slider-thumb{cursor:not-allowed}/*!\r\n * Cropper.js v1.5.6\r\n * https://fengyuanchen.github.io/cropperjs\r\n *\r\n * Copyright 2015-present Chen Fengyuan\r\n * Released under the MIT license\r\n *\r\n * Date: 2019-10-04T04:33:44.164Z\r\n */.cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;touch-action:none;-webkit-user-select:none;user-select:none}.cropper-container img{image-orientation:0deg;display:block;height:100%;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-canvas,.cropper-wrap-box{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:1}.cropper-view-box{display:block;height:100%;outline:1px solid #39f;outline-color:#3399ffbf;overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:after,.cropper-center:before{background-color:#eee;content:\" \";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;opacity:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:\" \";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\")}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}.uppy-ImageCropper{display:flex;flex-direction:column;height:100%;width:100%}.uppy-ImageCropper-container{flex-grow:1}.uppy-ImageCropper-image{display:block;max-height:400px}.uppy-ImageCropper-controls{align-items:center;background-color:#0009;bottom:15px;color:#fff;display:flex;justify-content:center;left:50%;padding-top:38px;position:absolute;transform:translateX(-50%)}@media screen and (min-width:768px){.uppy-ImageCropper-controls{padding-top:0}}.uppy-ImageCropper-controls button{height:35px;width:35px}.uppy-ImageCropper-controls button svg{padding:3px}.uppy-size--md .uppy-ImageCropper-controls button{height:40px;width:40px}.uppy-size--md .uppy-ImageCropper-controls button svg{padding:1px}.uppy-ImageCropper-controls button:hover{background-color:#2275d7cc}.uppy-ImageCropper-controls button:focus{background-color:#2275d7cc;outline:none}.uppy-ImageCropper-rangeWrapper{height:38px;left:10px;position:absolute!important;right:10px;top:0}@media screen and (min-width:768px){.uppy-ImageCropper-rangeWrapper{height:auto;position:static!important}.uppy-ImageCropper-range{margin-left:5px;margin-right:15px;width:180px}}.uppy-ImageCropper .cropper-point{height:8px;width:8px}.uppy-ImageCropper .cropper-view-box{outline:2px solid #39f}.uppy-is-drag-over:after{background-color:#eaeaea80;border:5px dashed #bbb;bottom:7px;content:\"\";left:7px;position:fixed;right:7px;top:7px;z-index:10000}/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper{position:relative}.color-picker-wrapper .color-picker-input-wrapper{display:table;position:relative}.color-picker-wrapper .input-group{position:relative;border-collapse:separate}.color-picker-wrapper .input-group .color-picker-input,.color-picker-wrapper .input-group .input-group-addon{display:table-cell}.color-picker-wrapper .input-group .color-picker-input{position:relative;z-index:2;float:left;margin-bottom:0}.color-picker-wrapper .input-group .input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc}.color-picker-wrapper .input-group .input-group-addon:first-child{border-right-width:0}.color-picker-wrapper .input-group .input-group-addon:last-child{border-left-width:0}.color-picker-wrapper .input-group .color-picker-input-swatch{padding-left:12px}.color-picker-wrapper .color-picker-input-swatch{padding-left:36px}.color-picker-wrapper .color-picker-swatch{cursor:pointer;z-index:3}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){position:absolute;top:3px;width:28px;height:70%;box-sizing:border-box;border-radius:3px;vertical-align:middle;background-position:-80px 0;border:1px solid #ccc;padding:0;margin:0;display:inline-block}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-left{left:3px}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon).color-picker-swatch-right{right:3px}.color-picker-wrapper .color-picker-panel{position:absolute;background:#fff;border:1px solid #ccc;box-shadow:0 0 20px rgba(0,0,0,.5);z-index:99999;width:150px;table-layout:fixed;border:1px solid #fff;padding-right:1px;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper{display:table;width:100%}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row{display:table-row}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-overlay{position:absolute;width:100%;height:150px;top:0;left:0;z-index:2}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{background-image:linear-gradient(45deg,grey 25%,transparent 0),linear-gradient(-45deg,grey 25%,transparent 0),linear-gradient(45deg,transparent 75%,grey 0),linear-gradient(-45deg,transparent 75%,grey 0);background-size:10px 10px;background-position:0 0,0 5px,5px -5px,-5px 0}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{display:table-cell;position:relative;left:1px;width:20px;background-color:#fff;cursor:row-resize}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-slider{position:absolute;top:0;left:0;width:18px;height:2px;background:#fff;border:1px solid #000;box-sizing:content-box;margin-top:-1px;z-index:3}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:table-cell;position:relative;width:150px;height:150px;cursor:crosshair}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{width:150px;height:150px;z-index:9}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);pointer-events:none}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker{position:absolute;top:70px;left:70px;width:12px;height:12px;border:1px solid #000;border-radius:10px;margin-top:-6px;margin-left:-6px;background:0 0;box-sizing:content-box;z-index:99}.color-picker-wrapper .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-picker>div{position:absolute;top:0;left:0;width:8px;height:8px;border-radius:8px;border:2px solid #fff;box-sizing:content-box}.color-picker-wrapper .color-picker-panel .color-picker-actions .color-picker-action{width:calc(33.3333% - 6px);margin:3px}.color-picker-wrapper .color-picker-panel.color-picker-show-inline{position:relative}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:230px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness.color-picker-show-alpha,.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-alpha,.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation.color-picker-show-lightness{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-alpha,.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-lightness,.color-picker-wrapper .color-picker-panel.color-picker-show-hue.color-picker-show-saturation,.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-alpha,.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-saturation.color-picker-show-lightness.color-picker-show-alpha{width:210px}.color-picker-wrapper .color-picker-panel.color-picker-show-lightness.color-picker-show-alpha{width:190px}.color-picker-wrapper .color-picker-panel.color-picker-show-alpha,.color-picker-wrapper .color-picker-panel.color-picker-show-hue,.color-picker-wrapper .color-picker-panel.color-picker-show-lightness,.color-picker-wrapper .color-picker-panel.color-picker-show-saturation{width:170px}.color-picker-wrapper .color-picker-panel.color-picker-panel-bottom{top:auto}.color-picker-wrapper .color-picker-panel.color-picker-panel-top{bottom:100%}.color-picker-wrapper .color-picker-panel.color-picker-panel-left{left:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-right{right:0}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-overlay{background-image:url(data:image/png;base64,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);border-radius:50%}.color-picker-wrapper .color-picker-panel.color-picker-panel-round .color-picker-grid-wrapper .color-picker-row .color-picker-grid .color-picker-grid-inner{background-color:#fff}.color-picker-wrapper .color-picker-hidden{display:none}.color-picker-wrapper.color-picker-disabled .color-picker-grid,.color-picker-wrapper.color-picker-disabled .color-picker-hue,.color-picker-wrapper.color-picker-disabled .color-picker-input,.color-picker-wrapper.color-picker-disabled .color-picker-opacity,.color-picker-wrapper.color-picker-disabled .color-picker-swatch{cursor:not-allowed!important}.color-picker-wrapper.color-picker-swatch-only .color-picker-input{padding-left:33px;padding-right:0;width:35px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{width:35px;height:100%;border-right:1px solid #ccc}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:first-child{border-right-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon:last-child{border-left-width:1px}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input{padding:0;width:1px;opacity:0;cursor:pointer}.color-picker-wrapper.color-picker-swatch-only .input-group .color-picker-input:focus{outline:0}.color-picker-wrapper.color-picker-closed .color-picker-panel{display:none}.color-picker-wrapper.color-picker-horizontal .color-picker-panel{width:150px!important}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-grid{display:block}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation{cursor:col-resize;display:block;left:0;width:150px;height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-overlay,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-overlay{height:20px}.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-hue .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-lightness .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-opacity .color-picker-slider,.color-picker-wrapper.color-picker-horizontal .color-picker-panel .color-picker-grid-wrapper .color-picker-row .color-picker-saturation .color-picker-slider{width:2px;height:18px;margin-top:0}/*!\r\n * angularjs-color-picker v3.4.8\r\n * https://github.com/ruhley/angular-color-picker/\r\n *\r\n * Copyright 2017 ruhley\r\n *\r\n * 2017-10-06 09:52:03\r\n *\r\n */.color-picker-wrapper .color-picker-input-wrapper{width:100%}.color-picker-wrapper .color-picker-swatch:not(.input-group-addon){height:28px}.color-picker-wrapper.color-picker-swatch-only .input-group .input-group-addon{border-radius:4px}oi-select{display:block;position:relative;width:100%}oi-select .select-search{cursor:text;border:1px solid #d9d9d9;background-color:#fff;overflow:hidden!important;box-sizing:border-box;border-radius:4px}oi-select .select-search-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:start;justify-content:flex-start;margin:0;padding:2px 4px;list-style:none}oi-select .select-search-list-item{font-size:14px;margin:2px 4px 2px 0;vertical-align:middle;white-space:normal}oi-select .select-search-list-item_selection{cursor:pointer;background:#efefef;border-color:#ebebeb}oi-select .select-search-list-item_selection:hover{border-color:#e5e5e5}oi-select .select-search-list-item_selection.focused,oi-select .select-search-list-item_selection:active{border:1px solid #fff;border-radius:0;box-shadow:inset 0 0 10px 5px #fff}oi-select .select-search-list-item_selection.focused .close{display:none}oi-select .select-search-list-item_selection-remove{padding-left:2px}oi-select .select-search-list-item_loader{float:right;margin-top:6px;width:16px;height:16px;background:url(data:image/gif;base64,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) top}oi-select .select-search-list-item_input{-ms-flex-positive:1;flex-grow:1;margin:4px 0 5px 5px}oi-select .select-search-list-item_input input{padding:0;outline:0;border:0;width:100%}oi-select .select-search-list-item_hide{position:fixed;width:0;height:0;margin:0;opacity:0;pointer-events:none;text-indent:-9999em}oi-select .select-dropdown{position:absolute;width:inherit;overflow-y:scroll;max-height:100px;min-width:160px;font-size:14px;background-color:#fff;border-radius:0 0 4px 4px;border:1px solid #66afe9;border-top:0;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);background-clip:padding-box;z-index:1000}oi-select .select-dropdown-optgroup{margin:0;padding:0}oi-select .select-dropdown-optgroup-header{font-weight:bolder;padding:3px 10px}oi-select .select-dropdown-optgroup-option{padding:3px 20px}oi-select .select-dropdown-optgroup-option.active:not(.disabled){background-color:#f1f1f1;cursor:pointer}oi-select .select-dropdown-optgroup-option.disabled{color:#aaa}oi-select:not(.multiple) .select-search-list-item_selection{color:#000;width:100%;border-color:#fff;text-align:left}oi-select:not(.multiple) .select-search-list-item_selection:not(:active){background:0 0}oi-select:not(.multiple):not(.cleanMode) .select-search-list-item_selection-remove{display:none}oi-select:not(.multiple):not(.cleanMode) .select-search:after{content:\"\";position:absolute;display:block;right:10px;width:0;height:0;margin-top:-19px;border-color:#000 transparent transparent;border-style:solid;border-width:5px 5px 0}oi-select[disabled=disabled] .select-search{cursor:not-allowed;background:#eee;border:1px solid #bdbdbd;opacity:.5}oi-select[disabled=disabled] .select-search-list-item_selection{cursor:not-allowed;box-shadow:none;border-color:transparent}oi-select[disabled=disabled] .select-search-list-item_selection-remove{visibility:hidden}oi-select[disabled=disabled] .select-search-list-item_input input:disabled{cursor:not-allowed;background:0 0}oi-select.focused .select-search{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}oi-select.invalid-item .select-dropdown,oi-select.invalid-item .select-search,oi-select.limited .select-dropdown,oi-select.limited .select-search{border-color:#f1bc28;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(230,189,46,.6)}oi-select.open .select-search{border-radius:4px 4px 0 0;border-bottom:1px solid rgba(0,0,0,.075)}oi-select.open:not(.multiple) .select-search:after{border-color:transparent transparent #000;border-width:0 5px 5px}oi-select.loading:not(.multiple) .select-search:after{border-width:0}oi-select.emptyList .select-dropdown-optgroup-option strong{font-weight:400}oi-select .select-dropdown{min-height:250px}oi-select.focused .select-search,oi-select.open .select-search,oi-select .select-dropdown{border:1px solid #ccc;box-shadow:none}oi-select.multiple:not(.cleanMode) .select-search:after{content:\"\";position:absolute;display:block;right:10px;width:0;height:0;margin-top:-19px;border-color:#000 transparent transparent;border-style:solid;border-width:5px 5px 0}oi-select.open.multiple .select-search:after{border-color:transparent transparent #000;border-width:0 5px 5px}oi-select .select-search-email{font-style:italic;font-size:13px}.notifications-wrapper{max-width:400px;margin:0 auto;position:fixed;left:10px;bottom:10px;right:10px;border-radius:4px;z-index:100060}@media (min-width:600px){.notifications-wrapper{right:auto;width:100%}}.notifications-wrapper .notification-item{margin-top:10px;position:relative;padding:8px 8px 8px 16px;box-shadow:0 6px 12px rgba(0,0,0,.175);background:#fff;border-radius:10px;overflow:hidden}.notifications-wrapper .notification-item:before{position:absolute;display:block;content:\"\";left:0;top:0;bottom:0;width:8px;background:transparent}.notifications-wrapper .notification-item.primary:before{background:#337ab7}.notifications-wrapper .notification-item.info:before{background:#5bc0de}.notifications-wrapper .notification-item.danger:before{background:#d9534f}.notifications-wrapper.show{visibility:visible;opacity:1}.notifications-wrapper .notification-header{overflow:hidden;padding:0 18px 8px 0;position:relative;border-bottom:1px solid #ccc;line-height:18px;color:#777;font-size:12px;font-weight:700;min-height:26px}.notifications-wrapper .notification-content{padding:8px 0;font-size:15px;color:#333;font-weight:700}.notifications-wrapper .close-notification{position:absolute;font-weight:700;right:0;top:0;width:18px;height:18px;line-height:18px;font-size:16px;text-align:center;cursor:pointer}.change-preview-wrapper{overflow:hidden;width:100%;background:#fff;height:38px}.editor-plain-text,.plain-textarea{width:100%;background:#fff;min-height:600px;white-space:pre-wrap;padding:8px;font-size:14px;line-height:18px;box-sizing:border-box;font-family:Georgia,Times New Roman,Bitstream Charter,Times,serif!important}.editor-tabs-wrapper{position:absolute;top:0;right:0;z-index:1}.editor-tabs-wrapper li{float:left;margin-left:5px}.editor-tabs-wrapper li a{color:#333;display:block;padding:0 10px;line-height:37px;border:1px solid #ccc;background-color:#e3e3e3;text-decoration:none;webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.editor-tabs-wrapper li a.active{line-height:38px;background-color:#f0f0f0;border-bottom:none;pointer-events:none;cursor:default}.editor-tabs-wrapper li a.active.text{background-color:#fff}.editor-insert-embedcode .modal--media-content{padding:20px;overflow:hidden}.tinymce-basic-wrapper{position:relative}.mce-container[aria-label=\"Insert/edit link\"] .mce-menu-item{padding:6px 16px!important;border-bottom:1px solid #e0e0e0!important;cursor:pointer;transition:background-color .2s ease}.mce-container[aria-label=\"Insert/edit link\"] .mce-menu-item:hover{background-color:#257cb6!important;color:#fff!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-menu-item:last-child{border-bottom:none!important}.mce-container[aria-label=\"Insert/edit link\"].mce-window{left:50%!important;transform:translateX(-50%)!important}.mce-container[aria-label=\"Insert/edit link\"] .search-results-container{max-height:300px!important;overflow-y:auto!important;border:1px solid #ddd!important;border-radius:4px!important;background-color:#fff!important;box-shadow:0 2px 4px rgba(0,0,0,.1)!important}.mce-container[aria-label=\"Insert/edit link\"] #search-results .mce-menu-item:hover{background-color:#257cb6!important}.mce-container[aria-label=\"Insert/edit link\"] #search-results .mce-menu-item:hover div{color:#fff!important}.mce-container[aria-label=\"Insert/edit link\"] #search-results .load-more-btn:hover{background-color:transparent!important}.mce-container[aria-label=\"Insert/edit link\"] #search-results .load-more-btn:hover button:hover{background-color:#257cb6!important}.mce-container[aria-label=\"Insert/edit link\"] .search-error,.mce-container[aria-label=\"Insert/edit link\"] .search-loading,.mce-container[aria-label=\"Insert/edit link\"] .search-no-results{padding:15px!important;text-align:center!important;color:#666!important;font-size:14px!important}.mce-container[aria-label=\"Insert/edit link\"] .search-error{color:#d32f2f!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-foot .mce-btn{right:15px!important;left:auto!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-foot .mce-btn.mce-primary{right:80px!important;left:auto!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-container-body.mce-abs-layout{overflow:initial!important}@media (max-width:480px){.mce-container[aria-label=\"Insert/edit link\"].mce-window,.mce-container[aria-label=\"Insert link\"].mce-window{width:100%!important;left:0!important;transform:none!important;min-width:100%!important;max-width:100%!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body,.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item,.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body,.mce-container[aria-label=\"Insert link\"] .mce-window-body,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body{width:100%!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-label,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-label{width:100px!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-filepicker,.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-menubtn,.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-textbox,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-filepicker,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-menubtn,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-textbox{box-sizing:border-box!important;width:calc(100% - 100px)!important;left:100px!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-filepicker .mce-textbox,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-abs-layout-item .mce-container-body .mce-filepicker .mce-textbox{width:100%!important;left:0!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-window-body .mce-formitem,.mce-container[aria-label=\"Insert link\"] .mce-window-body .mce-formitem{width:calc(100% - 30px)!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-foot,.mce-container[aria-label=\"Insert/edit link\"] .mce-foot .mce-container-body,.mce-container[aria-label=\"Insert link\"] .mce-foot,.mce-container[aria-label=\"Insert link\"] .mce-foot .mce-container-body{width:100%!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-foot .mce-btn,.mce-container[aria-label=\"Insert link\"] .mce-foot .mce-btn{right:15px!important;left:auto!important}.mce-container[aria-label=\"Insert/edit link\"] .mce-foot .mce-btn.mce-primary,.mce-container[aria-label=\"Insert link\"] .mce-foot .mce-btn.mce-primary{right:80px!important;left:auto!important}}.ai-modal .ai-recommendations-list.inline{display:flex;flex-wrap:wrap;gap:8px}.ai-modal .ai-recommendations-list.inline .ai-recommendation.inline{display:inline-block;margin-bottom:0;border-radius:16px}.ai-modal .ai-recommendations-list.block{display:block}.ai-modal .ai-recommendations-list.block .ai-recommendation.block{display:block;border-radius:4px}.ai-modal .ai-recommendation{border:1px solid #ccc;padding:8px 12px;line-height:16px;font-size:14px;font-weight:600;margin-bottom:8px;cursor:pointer;background:#fff;color:#000;transition:background .2s,color .2s}.ai-modal .ai-recommendation.active{background:#000;color:#fff}.ai-modal .ai-recommendation.inactive{background:#fff;color:#000}.ai-modal .ai-recommendation:last-child{margin-bottom:0}.ai-modal .ai-recommendations-legend{display:flex;align-items:center;gap:16px;margin:16px 0 10px}.ai-modal .ai-recommendations-legend .legend-item{display:flex;align-items:center;gap:6px;font-size:13px;font-weight:400}.ai-modal .ai-recommendations-legend .legend-circle{display:inline-block;width:16px;height:16px;border-radius:50%;border:2px solid #ccc;background:#fff;margin-right:4px;vertical-align:middle}.ai-modal .ai-recommendations-legend .legend-circle.selected{background:#000}@media (min-width:1200px){.ai-modal .modal--media-dialog{top:50%;left:50%;bottom:auto;right:auto;transform:translate(-50%,-50%);width:1140px;height:auto}}.ai-modal .modal--media-content{padding:0 10px 50px}@media (min-width:1200px){.ai-modal .modal--media-content{position:relative;top:auto;left:auto;bottom:auto;right:auto;transform:translate(0);padding:10px 16px 50px}}.ai-modal .modal--media-content.two-columns{overflow-y:auto}.ai-modal .modal--media-content.two-columns .ai-modal-editor-content{display:block}@media (min-width:600px){.ai-modal .modal--media-content.two-columns .ai-modal-editor-content{display:flex}}.ai-modal .modal--media-content.two-columns .ai-modal-editor-content .ai-modal-editor-left-column,.ai-modal .modal--media-content.two-columns .ai-modal-editor-content .ai-modal-editor-right-column{width:100%}@media (min-width:600px){.ai-modal .modal--media-content.two-columns .ai-modal-editor-content .ai-modal-editor-left-column,.ai-modal .modal--media-content.two-columns .ai-modal-editor-content .ai-modal-editor-right-column{width:50%}}.ai-modal .action{background:#f6f6f6;position:absolute;border-top:1px solid #ccc;bottom:0;left:0;right:0;height:50px}.ai-modal .action a{float:right;margin:9px 20px 0 0}.ai-modal .ai-modal-editor-content{display:flex;gap:16px}.ai-modal .ai-modal-editor-content .plain-textarea{font-size:16px;max-width:100%;min-width:100%;outline:none;border:1px solid #ddd}.ai-modal .ai-modal-editor-content .ai-modal-editor-left-column,.ai-modal .ai-modal-editor-content .ai-modal-editor-right-column{width:100%}.ai-modal .ai-modal-editor-content .title{font-size:12px;line-height:16px;margin-top:0;margin-bottom:4px;text-transform:uppercase}.ai-loading-spinner,.ai-modal-error{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:120px;font-size:15px;font-weight:600}.spinner{border:4px solid #f3f3f3;border-top:4px solid #000;border-radius:50%;width:36px;height:36px;animation:spin 1s linear infinite;margin-bottom:10px}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.main-alert{padding-right:20px;position:relative}.alert-wrapper-overlay{position:fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.2);z-index:100059}.alert-wrapper{font-size:18px;max-width:600px;margin:0 auto;position:fixed;top:60px;right:10px;left:10px;border-radius:4px;z-index:100060}.center-alert .alert-wrapper{top:50%;max-width:320px;right:10px;left:10px;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%)}@media (min-width:600px){.center-alert .alert-wrapper{left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);margin:0;right:0}}.warning-alert .alert-wrapper{background:#fff}.alert-wrapper.show{visibility:visible;opacity:1}.alert-wrapper.login{position:relative;margin-top:20px;top:150px}@media (min-width:600px){.alert-wrapper{left:auto;width:100%}}.alert-wrapper>div{padding:8px 0;position:relative;width:100%;float:left;margin-left:0;margin-right:0;padding-right:50px}.center-alert .alert-wrapper>div{padding:40px 30px 40px 20px;text-align:center}.center-alert .alert-wrapper>div .btn{margin-right:20px;margin:0 10px!important}.center-alert .alert-wrapper>div.alert-info{border:1px solid #2390b0}.warning-alert .alert-wrapper>div{padding:0;text-align:left;margin-bottom:0}.warning-alert .alert-wrapper>div .btn{margin:0!important}.alert-wrapper .image-wrapper{width:80px;height:54px;position:absolute;top:50%;left:0;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%)}.warning-alert .alert-wrapper .alert-title{font-size:15px;font-weight:600;background:#313131;line-height:30px;padding:5px 10px;color:#fff}.alert-wrapper .alert-content{margin-left:80px;border-left:1px solid #fff}.center-alert .alert-wrapper .alert-content{margin-left:0;border:none}.warning-alert .alert-wrapper .alert-content{padding:16px 10px}.alert-wrapper .alert-content span{display:block;font-size:18px;line-height:20px;padding-left:20px}.center-alert .alert-wrapper .alert-content span{line-height:25px;text-align:center;margin-bottom:30px;font-weight:700;padding-left:0;font-size:20px}.warning-alert .alert-wrapper .alert-content span{color:#313131;font-size:16px;line-height:1.2;font-weight:500;margin-bottom:0;text-align:left}.alert-wrapper .alert-content .alert-type{font-size:24px;font-weight:700;line-height:30px}.alert-wrapper .close-alert{position:absolute;right:20px;top:50%;width:25px;height:25px;transform:translateY(-50%);-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);cursor:pointer;background:url(" + __webpack_require__(384) + ") 50% no-repeat}.center-alert .alert-wrapper .close-alert{top:5px;right:5px;transform:translateY(0);-webkit-transform:translateY(0);-moz-transform:translateY(0)}.warning-alert .alert-wrapper .close-alert{top:10px;right:10px;width:20px;height:20px;background-image:none;font-size:20px;line-height:20px;color:#fff;font-weight:700}.alert-wrapper .alert-actions{padding:10px}.warning-alert .alert-wrapper .alert-actions{display:flex;justify-content:space-between;gap:16px}.warning-alert .alert-wrapper .alert-actions .btn{width:100%;margin:0!important}.cancel-alert{position:absolute;top:0;right:0;padding:5px;cursor:pointer}.alert-hidden{visibility:hidden}.alert{margin-bottom:20px;margin-top:0;color:#fff!important;border-width:0;padding:10px 20px}.alert.alert-success{background-color:#57af56}.alert.alert-success .image-wrapper{background:url(" + __webpack_require__(401) + ") 50% no-repeat;background-size:54px 54px}.alert.alert-warning{background:#ff8d00}.alert.alert-warning .image-wrapper{background:url(" + __webpack_require__(16) + ") 50% no-repeat;background-size:54px 54px}.alert.alert-info{background:#5bc0de}.alert.alert-info .image-wrapper{background:url(" + __webpack_require__(391) + ") 50% no-repeat;background-size:54px 54px}.alert.alert-danger{background:#de1d1d}.alert.alert-danger .image-wrapper{background:url(" + __webpack_require__(16) + ") 50% no-repeat;background-size:54px 54px}.alert.alert-question{background:#337ab7}.alert.alert-question .image-wrapper{background:url(" + __webpack_require__(16) + ") 50% no-repeat;background-size:54px 54px}.btn-transparent{background:transparent;color:#fff;border:1px solid #fff}.alert-warning .btn-transparent:hover{background:#fb6;color:#fff}.alert-info .btn-transparent:hover{background:#b0e1ef;color:#fff}.server-error{font-size:22px;position:fixed;bottom:0;right:0;left:0;top:0;z-index:100070;background:#fff;display:none}.server-error.shown{display:block}.server-error__wrapper{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);width:auto}.server-error__content{text-align:center;margin-bottom:20px}.server-error__counter,.server-error__message{margin-bottom:20px;color:#d9534f}.croppie-container{width:100%;height:100%}.croppie-container .cr-image{z-index:-1;position:absolute;top:0;left:0;transform-origin:0 0;max-height:none;max-width:none}.croppie-container .cr-boundary{position:relative;overflow:hidden;margin:0 auto;z-index:1;width:100%;height:100%}.croppie-container .cr-viewport{position:absolute;border:1px dashed #fff;margin:auto;top:0;bottom:0;right:0;left:0;box-shadow:0 0 2000px 2000px rgba(0,0,0,.6);z-index:0}.croppie-container .cr-original-image{display:none}.croppie-container .cr-vp-circle{border-radius:50%}.croppie-container .cr-overlay{z-index:1;position:absolute;cursor:move}.croppie-container .cr-slider-wrap{width:75%;margin:15px auto;text-align:center}.croppie-result{position:relative;overflow:hidden}.croppie-result img{position:absolute}.croppie-container .cr-image,.croppie-container .cr-overlay,.croppie-container .cr-viewport{transform:translateZ(0)}.cr-slider{-webkit-appearance:none;width:300px;max-width:100%}.cr-slider::-webkit-slider-runnable-track{width:100%;height:3px;background:rgba(0,0,0,.5);border:0;border-radius:3px}.cr-slider::-webkit-slider-thumb{-webkit-appearance:none;border:none;height:16px;width:16px;border-radius:50%;background:#ddd;margin-top:-6px}.cr-slider:focus{outline:none}.cr-slider::-moz-range-track{width:100%;height:3px;background:rgba(0,0,0,.5);border:0;border-radius:3px}.cr-slider::-moz-range-thumb{border:none;height:16px;width:16px;border-radius:50%;background:#ddd;margin-top:-6px}.cr-slider:-moz-focusring{outline:1px solid #fff;outline-offset:-1px}.cr-slider::-ms-track{width:100%;height:5px;background:transparent;border-color:transparent;border-width:6px 0;color:transparent}.cr-slider::-ms-fill-lower,.cr-slider::-ms-fill-upper{background:rgba(0,0,0,.5);border-radius:10px}.cr-slider::-ms-thumb{border:none;height:16px;width:16px;border-radius:50%;background:#ddd;margin-top:1px}.cr-slider:focus::-ms-fill-lower,.cr-slider:focus::-ms-fill-upper{background:rgba(0,0,0,.5)}.cr-rotate-controls{position:absolute;bottom:5px;left:5px;z-index:1}.cr-rotate-controls button{border:0;background:none}.cr-rotate-controls i:before{display:inline-block;font-style:normal;font-weight:900;font-size:22px}.cr-rotate-l i:before{content:\"\\21BA\"}.cr-rotate-r i:before{content:\"\\21BB\"}#content,.all-posts{width:100%;float:left;margin-left:0;margin-right:0}.single-post--columns-wraper{margin-top:20px}@media (min-width:992px){.single-post--columns-wraper{display:flex;position:relative}}.single-post .grey-btn{margin-bottom:5px;border-radius:0;float:left}.single-post--left-col{position:relative;width:100%}@media (min-width:992px){.single-post--left-col{width:calc(100% - 370px)}.country-restrictions .single-post--left-col{width:50%}}.single-post--right-col{width:100%}@media (min-width:992px){.single-post--right-col{padding-left:20px;width:370px}.country-restrictions .single-post--right-col{width:50%;padding-left:0}}.single-post--widget{border:1px solid #ccc}.country-restrictions .single-post--widget{margin-bottom:20px;width:100%}@media (min-width:992px){.country-restrictions .single-post--widget{width:50%}}.single-post--widget.publish select{width:auto;display:inline-block}.single-post--widget.publish .editable{overflow:hidden}.single-post--widget.publish .editable a,.single-post--widget.publish .editable select{margin-top:10px}.single-post--widget.publish .editable a{vertical-align:top;display:inline-block}.single-post--widget.publish .date-edit a,.single-post--widget.publish .date-edit input,.single-post--widget.publish .date-edit select{vertical-align:top;display:inline-block;margin-top:10px}.single-post--widget.publish .date-edit select{width:auto}.single-post--widget.publish .date-edit input{width:40px;padding:0;text-align:center}.single-post--widget.publish .date-edit span{vertical-align:bottom;font-size:18px}.single-post--widget.publish .status{text-transform:capitalize}.single-post--widget.tags .widget-body{overflow:initial}.single-post--widget footer{overflow:hidden}.single-post--widget footer .clickable-danger{line-height:33px}.single-post--widget.publish .widget-body{overflow:hidden}.single-post--widget.publish .widget-body li{padding:10px 0}.single-post--widget.publish .widget-body li:last-child{padding-bottom:0}.single-post--widget.publish .widget-body ul{clear:both;margin-bottom:0}.single-post--widget.publish .widget-body .edit-option-status{margin-top:15px}.single-post--widget.publish .widget-body .edit-option-status select{width:auto;margin-bottom:0;display:inline-block;vertical-align:middle}.single-post--widget.publish .widget-body>a.preview{float:right}.single-post--widget.categories .widget-body .nav-tabs>li>a{text-align:center;padding:6px 0;border:0!important;box-shadow:none!important;margin-right:0}.single-post--widget.categories .widget-body .nav-tabs>li{width:50%}.single-post--widget.categories .widget-body .nav-tabs>li.active{border-radius:4px 4px 0 0!important;border:1px solid #ccc;border-bottom:none}.single-post--widget.categories .widget-body .nav-tabs{width:100%}.single-post--widget.categories .widget-body .tab-content>.tab-pane{padding:0}.single-post--widget.f-image .widget-body a{display:block;width:100%}.single-post--widget.f-image footer button{margin-right:5px;float:left!important}.country-restrictions .single-post--widget button{margin-top:4px}.country-restrictions .single-post--widget img{width:40px;height:40px}.single-post--widget.categories .required-error{position:absolute;bottom:5px;left:20px}.single-post--widget .search input{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.country-restrictions .single-post .plain-textarea{border:1px solid #ccc;margin-top:38px;min-height:0}.single-post .photo-video-wrapper{position:absolute;bottom:calc(100% + 5px);right:0}.single-post .photo-video-wrapper>div{margin-right:10px}.single-post .photo-video-wrapper>div:last-child{margin-right:0}.single-post .recommended-wrapper h5{margin-bottom:15px}.single-post .recommended-wrapper textarea{max-width:100%!important;min-width:100%!important;width:100%!important;height:70px;min-height:70px!important}@media (min-width:480px){.single-post .recommended-wrapper textarea{height:52px;min-height:52px!important}}@media (min-width:1350px){.single-post .recommended-wrapper textarea{height:34px;min-height:34px!important}}.single-post .recommended-item{margin-bottom:15px}.single-post .systems-data h5{font-size:15px}.single-post .disccusion .form-group:last-child{margin-bottom:0}.single-post .share-image-wrapper{position:relative;max-width:250px;cursor:pointer}.single-post .share-image-wrapper .remove{position:absolute;top:0;right:0;width:30px;height:30px;background:rgba(0,0,0,.7);text-align:center;font-size:24px;line-height:30px;font-weight:700}.single-post .form-group.page-title-wrapper>label,.single-post .form-group.title-wrapper>label{margin-bottom:40px}@media (min-width:600px){.single-post .form-group.page-title-wrapper>label,.single-post .form-group.title-wrapper>label{margin-bottom:5px}}@media (min-width:600px){.single-post .form-group.title-wrapper{margin-bottom:25px}}.body-all-post .single-post--left-col .autocomplete-result{top:57px;z-index:1}.modal-video-wrapper{position:absolute;top:0;left:0;bottom:50px;right:0;overflow-y:scroll}.modal-video-wrapper .grid-wrapper{margin-bottom:0}.video-wrapper-outer{width:100%;max-width:620px;margin:0 auto}.video-loader-wrapper{width:100%;padding-bottom:56.25%;position:relative}.video-loader-wrapper img{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.nav-tabs{background:transparent;position:relative}.edit-image .set-image-modal{top:51px;bottom:50px}.edit-image .left-column{width:55%!important;float:left;margin-right:0;background:#f5f5f5}.edit-image .right-column{padding:10px;position:static;width:45%!important;float:right;background:#fff}.edit-image .right-column img{max-width:100%}.edit-image .action{position:absolute;border-top:1px solid #ccc;bottom:0;left:0;right:0;height:50px}.edit-image .action a{float:right;margin:9px 20px 0 0}.edit-image .tab-buttons{overflow:hidden}.edit-image .tab-buttons .btn{float:left;border-radius:0}.edit-image .tab-buttons .btn.active{color:#333;background-color:#e6e6e6;border-color:#adadad}.set-image-modal{top:71px}.set-image-modal.insert-media .tab-content{bottom:105px}.set-image-modal.insert-media .action{height:100px}.set-image-modal.insert-media .action a{margin-top:29px}.set-image-modal .tab-content{top:43px;position:absolute;bottom:70px;left:0;right:0;overflow:hidden}.set-image-modal .tab-content>.tab-pane{height:100%;padding:0;margin-top:0;border-radius:0 4px 4px 4px;-webkit-border-radius:0 4px 4px 4px;-moz-border-radius:0 4px 4px 4px;border:1px solid #ccc;margin:0 10px;overflow-y:scroll}@media (min-width:600px){.set-image-modal .tab-content>.tab-pane{margin:0 20px;overflow-y:initial}}.set-image-modal .tab-content>.tab-pane.upload_image{overflow-y:scroll!important}.set-image-modal .nav-tabs{margin:0 10px}@media (min-width:600px){.set-image-modal .nav-tabs{margin:0 20px}}.set-image-modal .nav-tabs>li.active{border:1px solid #ccc;border-bottom:none;background:#fff;border-radius:4px 4px 0 0!important}.set-image-modal .nav-tabs>li>a{border:0!important;margin-right:0;box-shadow:none!important;font-size:12px;padding:13px 14px}@media (min-width:420px){.set-image-modal .nav-tabs>li>a{font-size:14px;padding:12px 18px}}.set-image-modal>.clearfix{position:relative;z-index:2}.set-image-modal .left-column{width:75%}@media (min-width:1200px){.set-image-modal .left-column{width:80%}}.set-image-modal .right-column{width:25%}@media (min-width:1200px){.set-image-modal .right-column{width:20%}}.set-image-modal .right-column .video-wrapper{margin-top:10px}.set-image-modal .action{position:absolute;border-top:1px solid #ccc;bottom:0;left:0;right:0;height:50px}.set-image-modal .action a{float:right;margin:9px 20px 0 0}.set-image-modal .image-thumbnail{float:left;margin-bottom:10px}.set-image-modal .image-thumbnail img{display:block;max-width:120px}.set-image-modal .image-details p{margin-left:130px;font-size:12px}.set-image-modal .image-details a{clear:both;margin:0;margin-bottom:10px;display:block}.set-image-modal .search{width:100%}@media (min-width:992px){.set-image-modal .search{max-width:270px;float:right}}.set-image-modal .select_option{width:100%}@media (min-width:992px){.set-image-modal .select_option{max-width:200px;float:left}}.set-image-modal h5{font-size:16px;margin:0 0 20px}.set-image-modal .selected-photo-area{margin:5px 170px 0 10px;background:#eee;padding:2px 0;overflow-x:auto}@media (min-width:600px){.set-image-modal .selected-photo-area{margin-left:20px}}.set-image-modal .selected-photo-area ul{overflow:hidden;margin-bottom:0}.set-image-modal .selected-photo-area li{padding:0 2px;float:left;width:74px;height:70px;position:relative}.set-image-modal .selected-photo-area li img{width:100%;display:block}.set-image-modal .selected-photo-area li .remove-selected-image{position:absolute;width:20px;height:20px;top:0;right:2px;background:url(" + __webpack_require__(382) + ") no-repeat;background-size:100%}.video-block-wrapper .set-featured-video-placeholder-wrapper{width:100%;max-width:350px;margin-bottom:15px}.video-block-wrapper .set-featured-video-placeholder-inner{width:100%;height:0;padding-bottom:56.25%;position:relative}.video-block-wrapper .set-featured-video-placeholder{cursor:pointer;position:absolute;width:100%;height:100%;top:0;left:0;border:3px solid #ccc;color:#555}.video-block-wrapper .set-featured-video-placeholder img{width:50%;position:relative;left:25%}.video-block-wrapper .video-wrapper-outer{margin-left:0;margin-bottom:15px;max-width:350px}.video-block-wrapper .video-wrapper-outer .video-wrapper{position:relative}.video-block-wrapper .set-featured-video-actions{max-width:350px;text-align:center}.editor-character-count{padding:4px 10px;background-color:#f5f5f5;color:#666;font-size:12px;text-align:right;line-height:18px}.editor-character-count span{font-weight:700;line-height:18px;font-size:12px}.news-services-wrapper .table-filter>select{clear:none}.news-services-wrapper .table-filter{float:none;overflow:hidden;background:#fff;margin-bottom:0}@media (min-width:1024px){.news-services-wrapper .table-filter{position:sticky;top:0;z-index:1;margin-left:-3px;padding-left:3px}}.news-services-wrapper .table-filter .form-group,.news-services-wrapper .table-filter a.btn{margin-top:0;margin-bottom:20px}@media (min-width:1024px){.news-services-wrapper .table-filter .form-group,.news-services-wrapper .table-filter a.btn{margin-top:10px;margin-bottom:10px}}.news-services-wrapper .table-filter a.btn{margin-left:0}@media (min-width:600px){.news-services-wrapper .table-filter .form-group{margin-right:20px}}@media (min-width:1024px){.news-services-wrapper .news-services-inner{padding-top:10px;display:-ms-flexbox;display:flex}}@media (min-width:1024px){.news-services-wrapper .news-services-inner .left-block{width:50%;padding-right:30px}}.news-services-wrapper .news-services-inner .right-block{position:fixed;top:0;left:0;bottom:0;right:0;z-index:1;background:#eee}@media (min-width:1024px){.news-services-wrapper .news-services-inner .right-block{width:50%;position:static;top:auto;left:auto;bottom:auto;right:auto;background:transparent}}.news-services-wrapper .news-services-content-header{position:relative}.news-services-wrapper .news-services-item{margin-bottom:8px;border-radius:4px;background:#eee;padding:8px;cursor:pointer}.news-services-wrapper .news-services-item.assigned-downloaded{opacity:.5}.news-services-wrapper .news-item-category-time{line-height:20px;padding:0 8px;background:#254594;color:#fff;font-size:12px;margin-bottom:5px;border-radius:4px}.news-services-wrapper .news-item-category-time.SERBIA,border .news-services-wrapper .news-item-category-time.BGD{background:#e5282a}.news-services-wrapper .news-item-category-time.BIZ,.news-services-wrapper .news-item-category-time.EUROPE{background:#14bdcc}.news-services-wrapper .news-item-category-time.EU{background:#e5282a}.news-services-wrapper .news-item-category-time.KNU{background:#9144c4}.news-services-wrapper .news-item-category-time.BALKAN,.news-services-wrapper .news-item-category-time.Sport{background:#27d050}.news-services-wrapper .news-item-category-time.SPR,.news-services-wrapper .news-item-category-time.WORLD{background:#e6bc27}.news-services-wrapper .news-item-category-time.UPR{background:#e5282a}.news-services-wrapper .news-item-category-time.ZAN{background:#29b2a3}.news-services-wrapper .news-item-title{clear:both;font-size:14px;line-height:20px;font-weight:700}.news-services-wrapper .empty-table{margin:0;border:none}.news-services-wrapper .selected{box-shadow:0 0 0 3px #286090;position:relative}@media (min-width:1024px){.news-services-wrapper .selected:after{position:absolute;content:\"\";display:block;top:50%;left:100%;border-top:9px solid transparent;border-bottom:9px solid transparent;border-left:9px solid #286090;width:0;height:0;margin-top:0;transform:translateY(-50%)}}.news-services-wrapper .news-services-details{line-height:20px;font-size:12px;color:#777}.news-services-wrapper .news-services-content-wrapper{border-radius:4px;background:#eee;margin-bottom:8px}@media (min-width:1024px){.news-services-wrapper .news-services-content-wrapper{position:sticky;top:54px;overflow:hidden}}.news-services-wrapper .news-services-content-wrapper .news-item-category-time{padding:7px 8px;margin-bottom:0}.news-services-wrapper .news-services-content-header{padding:12px;background:#eee;overflow:hidden}@media (min-width:1024px){.news-services-wrapper .news-services-content-header{padding-right:42px}}.news-services-wrapper .news-services-content-header select{width:auto;border-top-right-radius:0;border-bottom-right-radius:0;line-height:34px;height:34px}.news-services-wrapper .news-services-content-header .btn-danger{border-top-left-radius:0;border-bottom-left-radius:0}.news-services-wrapper .news-services-content-header .btn{margin-right:10px}@media (min-width:1024px){.news-services-wrapper .news-services-content-header .btn{margin-right:20px}}.news-services-wrapper .news-services-content-header .btn:last-child{margin-right:0}@media (min-width:1024px){.news-services-wrapper .news-services-content-header .btn:last-child{margin-right:20px}}.news-services-wrapper .news-services-content-header .news-services-details{line-height:20px}@media (min-width:1920px){.news-services-wrapper .news-services-content-header .news-services-details{margin-right:20px;line-height:34px}}.news-services-wrapper .news-services-content-header .news-services-content-btns,.news-services-wrapper .news-services-content-header .news-services-details{float:left;clear:left;margin-top:10px}@media (min-width:1920px){.news-services-wrapper .news-services-content-header .news-services-content-btns,.news-services-wrapper .news-services-content-header .news-services-details{float:right;margin-top:0;clear:none}}.news-services-wrapper .close-post{position:absolute;display:block;right:12px;top:12px;line-height:34px;width:30px;text-align:center;font-size:30px}.news-services-wrapper .news-services-content-inner-outer{padding:8px 12px 12px;overflow-y:auto}.news-services-wrapper .news-services-content-inner h2{font-size:20px;margin:0 0 20px}.news-services-wrapper .news-services-content-inner p{font-size:15px;font-weight:500;line-height:20px}.news-services-wrapper .news-services-content-inner img{max-width:100%;margin-bottom:10px}.news-services-wrapper .news-services-content-footer{padding-top:12px}.news-services-wrapper .news-services-content-footer .news-services-details{font-weight:500}.news-services-wrapper .news-services-content-footer .news-services-details>span:last-child .separator{display:none}.rating .single-post--left-col{overflow:hidden;margin-bottom:20px}@media (min-width:992px){.rating .single-post--left-col{width:calc(100% - 380px)}}.rating .single-post--left-col .choices-wrapper{overflow:hidden}.rating .single-post--left-col .choices-wrapper .form-group{position:relative}.edit-post .rating .single-post--left-col .choices-wrapper .form-group:last-child{margin-bottom:0}.rating .single-post--left-col .choices-wrapper .input-field{margin-right:50px}.rating .single-post--left-col .choices-wrapper .input-group-no-border{position:absolute;right:0;top:0}@media (min-width:992px){.rating .single-post--right-col{width:380px}}.rating .input-group-no-border .form-control{border-radius:4px;width:40px!important}.rating .widget header{background:#f6f6f6}.rating .widget footer{background:transparent}.rating h5{margin:0 0 15px;font-size:15px}.rating .ads,.rating .choice{padding-bottom:0}.rating .dropzone,.rating .dropzone .dz-message{min-height:100px}.rating .dropzone .dz-message{height:100px}.single-post.poll,.single-post.poll .single-post--columns-wraper{min-height:400px}.highlight-words .table-actions{overflow:hidden}.highlight-words .table-actions>div{float:left;width:100%}@media (min-width:800px){.highlight-words .table-actions>div{width:300px;margin-right:20px}}.highlight-words .highlight-words-list-wrapper{overflow:hidden;margin-bottom:20px}.highlight-words .highlight-words-list{margin-bottom:0}@media (min-width:600px){.highlight-words .highlight-words-list{width:48.93617%;float:left}.highlight-words .highlight-words-list:nth-child(odd){margin-right:-100%;clear:both;margin-left:0}.highlight-words .highlight-words-list:nth-child(2n+2){margin-left:51.06383%;margin-right:-100%;clear:none}}@media (min-width:992px){.highlight-words .highlight-words-list{width:23.40426%;float:left}.highlight-words .highlight-words-list:nth-child(4n+1){margin-right:-100%;clear:both;margin-left:0}.highlight-words .highlight-words-list:nth-child(4n+2){margin-left:25.53191%;margin-right:-100%;clear:none}.highlight-words .highlight-words-list:nth-child(4n+3){margin-left:51.06383%;margin-right:-100%;clear:none}.highlight-words .highlight-words-list:nth-child(4n+4){margin-left:76.59574%;margin-right:-100%;clear:none}}.highlight-words .highlight-words-list li{font-size:15px;font-weight:600;border:1px solid #ddd;border-collapse:collapse;display:table;line-height:20px;width:100%;border-bottom:none}.highlight-words .highlight-words-list li:last-child{border-bottom:1px solid #ddd}.highlight-words .highlight-words-list li span{display:table-cell;padding:5px;border:1px solid #ddd;vertical-align:middle;border-bottom:none}.highlight-words .highlight-words-list li span:first-child{width:40px}.highlight-words .highlight-words-list li span:last-child{width:30px}.highlight-words .empty-table{border-top:1px solid #ddd;padding:10px;margin:0}.poll .single-post--left-col{overflow:hidden;margin-bottom:20px}@media (min-width:992px){.poll .single-post--left-col{width:calc(100% - 380px)}}.poll .single-post--left-col .choices-wrapper{overflow:hidden}.poll .single-post--left-col .choices-wrapper .form-group{position:relative}.edit-post .poll .single-post--left-col .choices-wrapper .form-group:last-child{margin-bottom:0}.poll .single-post--left-col .choices-wrapper .input-field{margin-right:50px}.poll .single-post--left-col .choices-wrapper .input-group-no-border{position:absolute;right:0;top:0}@media (min-width:992px){.poll .single-post--right-col{width:380px}}.poll .input-group-no-border .form-control{border-radius:4px;width:40px!important}.poll .choices-wrapper,.poll .title-wrapper{padding:15px;background:#f6f6f6}.poll .widget header{background:#f6f6f6}.poll .widget footer{background:transparent}.poll h5{margin:0 0 15px;font-size:15px}.poll .ads,.poll .choice{padding-bottom:0}.all-focus .checkbox{display:block}.all-focus .focus-items-wrapper{margin-top:20px}@media (min-width:800px){.all-focus .focus-items-wrapper{display:-ms-flexbox;display:flex}}@media (min-width:800px){.all-focus .focus-items-wrapper .focus-left-block{padding-top:9px;width:40%;padding-right:20px}}@media (min-width:800px){.all-focus .focus-items-wrapper .focus-left-block>div{position:sticky;top:0}}@media (min-width:800px){.all-focus .focus-items-wrapper .focus-right-block{width:60%}}.all-focus .focus-items-wrapper .focus-right-block .sortable-grid{margin-bottom:10px}.all-focus .focus-items-wrapper .focus-right-block .sortable-grid h4{line-height:33px}.all-focus .focus-items-wrapper .focus-right-block .sortable-grid .image-cell{width:100px}.all-focus .focus-items-wrapper .sortable-grid{margin-top:0}.all-focus .pr-focus-news-modal .right-column table{height:40px;border-collapse:collapse;border-spacing:0}.all-focus .duplicated-item{box-shadow:inset 0 0 10px red}.all-notifications .ng-table--status{text-transform:capitalize}.all-notifications .ng-table--status>div{margin-bottom:10px}.all-notifications .ng-table--status>div:last-child{margin-bottom:0}.all-notifications .ng-table--status .sent{font-weight:700;color:#5cb85c}.all-notifications .ng-table--status .sending{font-weight:700;color:#ff8d00}.all-notifications .ng-table--status .pending{font-weight:700;color:#337ab7}.all-notifications .ng-table--status .failed{font-weight:700;color:#d9534f}.all-notifications .ng-table--status .dropdown{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.all-notifications .ng-table--status .dropdown .dropdown-toggle{font-weight:600;display:block;line-height:24px;font-size:16px}.all-notifications .ng-table--status .dropdown.open .dropdown-toggle{background-color:#e7e7e7;color:#333}.all-notifications .ng-table--status .dropdown li{padding:2px 15px;font-weight:600;text-align:center;line-height:20px}.all-notifications .ng-table--status .dropdown .dropdown-menu{right:0;min-width:auto;margin:0;border-radius:0;text-transform:none}.all-notifications .input-group-no-border .input-group{display:inline-block;vertical-align:middle}.all-notifications .input-group-no-border label{margin-right:10px;vertical-align:middle}.all-notifications .reload-action img{cursor:pointer}.all-notifications .history-data.dropdown .dropdown-menu{width:auto;min-width:320px;float:none;left:auto;padding:0}.all-notifications .history-data.dropdown .dropdown-menu li{padding:5px;text-align:left;line-height:16px;border-bottom:1px solid rgba(0,0,0,.15)}.all-notifications .history-data.dropdown .dropdown-menu li div{margin:2px 0}.all-notifications .history-data.dropdown .dropdown-menu li:last-child{border-bottom:none}.all-notifications .history-data.dropdown .fa-calendar{font-size:20px;line-height:26px}.all-notifications .ng-table--title textarea{display:block;margin:5px 0}.all-notifications .reload-action img{opacity:.9}.all-notifications .reload-action img:hover{opacity:1}.notification-settings .input-group-no-border .input-group{display:inline-block;vertical-align:middle}.notification-settings .input-group-no-border label{margin-right:10px;vertical-align:middle}.notification-settings select{width:250px}.notification-settings select option[disabled=disabled]{background:#ddd}.notification-settings .widget footer{overflow:hidden}.notification-settings table.table{width:250px}.notification-settings table.table tbody>tr>td{border:none;line-height:24px}.notification-settings table.table .remove{text-align:center;font-size:24px;font-weight:700}.menus__wrapper{position:relative}.menus__left-col,.menus__wrapper{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:992px){.menus__left-col{width:320px}}.menus__right-col{position:relative;width:100%}.menus__right-col:after{display:block;content:\"\";clear:both}@media (min-width:992px){.menus__right-col{width:auto;margin-left:340px}}.menus__name-wrapper{overflow:hidden}.menus__name-wrapper input{display:inline-block}.menus__name-wrapper input.title-slug{width:100%;margin-bottom:10px}@media (min-width:600px){.menus__name-wrapper input.title-slug{margin-bottom:0;width:200px}}.menus__name-wrapper input.title-ver{width:100%}@media (min-width:600px){.menus__name-wrapper input.title-ver{margin-bottom:0;width:100px}}.menus__name-wrapper label{display:block}.menus__name-wrapper .title-type{display:inline-block;margin-bottom:10px;width:100%}@media (min-width:600px){.menus__name-wrapper .title-type{margin-bottom:0;width:auto}}.menus .search-wrapper .autocomplete-result{z-index:2}.menus .menu-sortable-wrapp{width:100%;float:left;margin-left:0;margin-right:0;margin:10px 0}.menus .angular-ui-tree-empty{position:relative;background:none}.menus .angular-ui-tree-empty:after{position:absolute;top:10px;left:10px;display:block;content:\"No menu item.\"}.menus .table-filter label{float:left;line-height:33px}.menus .table-filter>a,.menus .table-filter>select,.menus .table-filter>span{width:100%;margin-top:20px}@media (min-width:600px){.menus .table-filter>a,.menus .table-filter>select,.menus .table-filter>span{width:auto;clear:none;margin-top:0}}.menus .table-filter>select{margin-top:0}.menus .categories-tree ul ul{padding-left:15px}.angular-ui-tree-node .tree-node{background:#f5f5f5;border:none;padding:9px 10px;color:#323331}.angular-ui-tree-node .tree-node.open{background:#e5262b;color:#fff}.angular-ui-tree-node .tree-node.open svg{fill:#fff}.angular-ui-tree-node .tree-node svg{display:inline-block;vertical-align:middle;margin-left:8px;fill:#e5262b}.angular-ui-tree-node .title{display:inline-block;font-size:14px;font-weight:700;vertical-align:middle;line-height:24px}.angular-ui-tree-node .navigation-item-content{display:none;border:1px solid #e5262b;border-top:none;padding:10px;margin:-10px 10px 0;background:#f5f5f5;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.angular-ui-tree-node .navigation-item-content:after{display:block;content:\"\";clear:both}.angular-ui-tree-node .navigation-item-content .edit-text-content,.angular-ui-tree-node .navigation-item-content .form-control,.angular-ui-tree-node .navigation-item-content label{color:#323331;font-size:13px;font-weight:600}.angular-ui-tree-node .navigation-item-content .edit-text-content{text-decoration:none;display:inline-block;cursor:pointer;line-height:24px;vertical-align:middle}.angular-ui-tree-node .navigation-item-content .edit-text-content:hover{text-decoration:underline}.angular-ui-tree-node .navigation-item-content .clickable-danger{color:#e5262b}.angular-ui-tree-node .navigation-item-content .clickable-default{color:#337ab7}.angular-ui-tree-node .navigation-item-content .color-picker-wrapper.color-picker-closed .color-picker-input-wrapper input{display:none}.angular-ui-tree-node .navigation-item-content .color-picker-wrapper-outer{display:inline-block;vertical-align:middle;margin:0 5px}.angular-ui-tree-node .navigation-item-content .color-picker-wrapper-outer.animated{webkit-animation-fill-mode:initial;animation-fill-mode:none}.angular-ui-tree-node .navigation-item-content .color-picker-input-wrapper{width:auto;display:block}.angular-ui-tree-node .navigation-item-content .color-picker-swatch{width:24px;height:24px;display:block;border-radius:50%;border:1px solid #323331;border-right-width:1px!important;padding:6px 11px}.angular-ui-tree-node .navigation-item-content .color-picker-input-swatch{position:absolute;top:calc(100% + 2px);width:174px;max-width:174px;padding-left:2px;border:1px solid #323331;left:50%;transform:translateX(-50%);z-index:110000}.angular-ui-tree-node .navigation-item-content .color-picker-panel{top:calc(100% + 28px);transform:translateX(-50%);left:50%;z-index:110000}.angular-ui-tree-node .navigation-item-content .color-picker-actions{display:none}.angular-ui-tree-node .navigation-item-content .icon-wrapper{margin-left:5px;display:inline-block;vertical-align:middle;cursor:pointer}.angular-ui-tree-node .navigation-item-content .icon-wrapper svg{display:block;fill:#323331}.angular-ui-tree-node .navigation-item-content .icon-wrapper .active svg{fill:#e5262b}.angular-ui-tree-node .colapsed-btn{margin-right:8px}.angular-ui-tree-node .colapsed-item{float:right}.angular-ui-tree-node .navigation-item-type{font-size:14px;line-height:24px;display:inline-block;font-weight:400;text-transform:capitalize;vertical-align:middle}.angular-ui-tree-node .btn-group-xs>.btn,.angular-ui-tree-node .btn-xs{line-height:20px;font-size:14px}.angular-ui-tree-node .btn-danger{border:1px solid #e5262b;background:#e5262b}.angular-ui-tree-node .btn-danger-inverse{border:1px solid #fff;background:#fff;color:#e5262b}.angular-ui-tree-node .btn:hover{opacity:.8}.angular-ui-tree-node .close-content,.angular-ui-tree-node .edit-content{font-size:13px;font-weight:600;margin-right:8px;line-height:24px;cursor:pointer}.angular-ui-tree-node .close-content{color:#fff}.angular-ui-tree-node .btn-action{line-height:16px;font-weight:700;margin-top:10px;width:100%}@media (min-width:480px){.angular-ui-tree-node .btn-action{width:auto}}.angular-ui-tree-node .btn-dark{padding-left:36px;background-image:url(" + __webpack_require__(380) + ");background-repeat:no-repeat;background-size:18px 19px;background-position:12px}.angular-ui-tree-node .dropzone-wrapper{display:inline-block;vertical-align:middle;margin:0 5px}.angular-ui-tree-node .dropzone-wrapper .dropzone{min-height:auto;background:transparent;margin-bottom:0;position:relative}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-message{width:24px;height:24px;background-image:url(" + __webpack_require__(405) + ");background-size:100% 100%;background-repeat:no-repeat;background-position:50%;border:none;display:block!important;min-height:auto}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-message span{display:none}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview{position:absolute;left:100%;top:0;margin:0 0 0 5px;width:120px;min-height:24px;border-radius:4px}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-error-mark,.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-success-mark{margin-top:-8px;left:5px;margin-left:0}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-error-mark svg,.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-success-mark svg{width:16px;height:16px}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-error-message{top:30px!important}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-preview .dz-progress{margin-right:5px}.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-details,.angular-ui-tree-node .dropzone-wrapper .dropzone .dz-image{display:none!important}.angular-ui-tree-node .dropzone-wrapper.has-image .dropzone .dz-message{background-image:url(" + __webpack_require__(387) + ");background-size:auto auto}.angular-ui-tree-placeholder{background:#f5f5f5;border:2px dashed #ddd}.macrosites-page-wrapper .search-post-dir.search-wrapper{float:none}.macrosites-page-wrapper .ng-table--id{width:100px}.macrosites-page-wrapper .post-type{font-size:13px}.single-page--columns-wraper{overflow:hidden;position:relative;margin-top:20px}.single-page .permalink input{width:200px}.single-page .permalink a{margin-right:10px}.single-page--left-col{width:74.46809%;float:left;margin-right:2.12766%}.single-page--right-col{width:23.40426%;float:left;margin-right:2.12766%;margin-right:0}.single-page--widget{border:1px solid #ddd}.single-page--widget footer{overflow:hidden}.single-page--widget footer .clickable-danger{line-height:33px}.single-page--widget.publish .widget-body{overflow:hidden}.single-page--widget.publish .widget-body li{padding:10px 0}.single-page--widget.publish .widget-body .btn{float:right;clear:both}.single-page--widget.publish .widget-body ul{clear:both}.single-page--widget.categories .widget-body .nav-tabs>li>a{text-align:center;padding:12px 0;border:0!important;box-shadow:none!important;margin-right:0}.single-page--widget.categories .widget-body .nav-tabs>li{width:50%}.single-page--widget.categories .widget-body .nav-tabs>li.active{border:1px solid #ddd;border-bottom:none}.single-page--widget.categories .widget-body .nav-tabs{width:100%}.single-page--widget.categories .widget-body .tab-content>.tab-pane{padding:0}.single-page--widget.f-image .widget-body a{display:block;width:100%}.single-page--widget.f-image footer button{margin-right:5px;float:left!important}.single-page .show-edit{display:block}.single-page .hidden-edit{display:none}.categories-posts{overflow:hidden}.categories-posts--left-column{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:1200px){.categories-posts--left-column{width:31.91489%;float:left;margin-right:2.12766%}}.categories-posts--left-column h4{margin:20px 0}.categories-posts--left-column textarea{height:150px!important;display:block}.categories-posts--right-column{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:1200px){.categories-posts--right-column{width:65.95745%;float:left;margin-right:2.12766%;margin-right:0}}.categories-posts .ng-table--title .title-edit textarea{display:block}.categories-posts .ng-table--title .title-edit label{display:inline-block;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.categories-posts .ng-table--title .title-edit .form-group{margin-bottom:15px}.categories-posts .ng-table--title .title-edit .btn{width:100%}.categories-posts .ng-table--title .title-edit .btn:last-child{margin-bottom:0}.categories-posts .ng-table-counts{display:none!important}.tags-posts{overflow:hidden}.tags-posts--left-column{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:1200px){.tags-posts--left-column{width:31.91489%;float:left;margin-right:2.12766%}}.tags-posts--left-column h4{margin:20px 0}.tags-posts--left-column textarea{height:150px!important;display:block}.tags-posts--right-column{width:100%;float:left;margin-left:0;margin-right:0}@media (min-width:1200px){.tags-posts--right-column{width:65.95745%;float:left;margin-right:2.12766%;margin-right:0}}.tags-posts .ng-table--title .title-edit textarea{display:block}.tags-posts .ng-table--title .title-edit label{display:inline-block;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tags-posts .ng-table--title .title-edit .form-group{margin-bottom:15px}.tags-posts .ng-table--title .title-edit .btn{width:100%}.tags-posts .ng-table--title .title-edit .btn:last-child{margin-bottom:0}.tag-edit{min-height:100vh}.tag-edit .single-post--widget.tags{padding-bottom:0}.tag-edit .list-tags{margin:0}.tag-edit .list-tags li{margin-top:10px;margin-bottom:0;line-height:33px}.tag-edit .merge-tags{margin-top:30px}.tag-edit .widget-body{padding:20px 0}.tag-edit input{width:100%}.sign-in-form{padding:80px}.login-logo{display:inline-block;width:70px;height:70px;background:url(" + __webpack_require__(393) + ") no-repeat;background-size:100%;margin-bottom:10px}.login-page{background:#ddd}.form-signin{color:#555;text-align:center;position:relative;top:150px;max-width:380px;padding:15px 35px 45px;margin:0 auto;background-color:#fff;border:1px solid rgba(0,0,0,.1);box-sizing:border-box}.form-signin form{text-align:left}.form-signin .form-signin-heading{text-align:center}.form-signin .checkbox,.form-signin .form-signin-heading{margin-bottom:30px}.form-signin .checkbox{font-weight:400}.form-signin .form-control{position:relative;font-size:16px;height:auto;line-height:42px;height:42px}.form-signin .form-control:focus{z-index:2}.form-signin input{background-color:#eee}.form-signin .form-group{margin-bottom:20px}.form-signin .btn{height:42px;width:100%;display:inline-block;color:#fff;background-color:#1188ea;border-color:#1188ea;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px;margin:0 auto;outline:none}.form-signin .btn:hover{border:1px solid #0e6cba;background:#0e6cba;outline:none}.change-preview .fa.active{color:#000}.download-image-wapper img{width:30px!important;height:30px!important}.download-image-wapper img:hover{opacity:.7}.lock-wrapper{width:30px;height:30px;text-align:center;margin:0 auto}.edit-image .lock-wrapper,.edit-media .lock-wrapper,.media-modal .lock-wrapper,.single-post--widget .lock-wrapper{display:inline-block;margin:0 0 0 10px;vertical-align:bottom}.lock-wrapper:hover{opacity:.7}.lock-wrapper img{margin:0!important;width:30px!important;height:30px!important;display:block!important;max-width:100%!important;max-height:100%!important}.edit-media img{max-width:100%}.edit-media .img-wrapper{width:100%;background:#f5f5f5;min-height:180px;position:relative}@media (min-width:600px){.edit-media .img-wrapper{min-height:300px;max-width:800px}}.edit-media .forbiden-placeholder:after{width:30%;padding-bottom:30%}.edit-media .alert{color:#8a6d3b!important}.edit-media .input-group-no-border .form-control{padding-left:0}.edit-media .input-group-no-border .form-control.error-border{border:1px solid #de1d1d!important}.media-library .ng-table--status{width:70px}.library-modal-action{position:absolute;border-top:1px solid #ccc;bottom:0;left:0;right:0;height:50px;padding:7px 20px 0}.ai-all-configurations .ng-table--date span{margin-bottom:0}.ai-all-configurations .table-filter select{margin-top:0}@media (min-width:600px){.ai-all-configurations .table-filter>a.btn{margin-top:0}}.ai-all-configurations .widget-body.table-wrapper{padding:0}.ai-configuration .messages-wrapper{padding:10px;background-color:#f5f5f5}.all-users a.btn-info,.all-users a.btn-primary,.all-users select{margin-top:0}.single-user .form-group,.single-user input{width:100%;max-width:400px;position:relative}.single-user .custom-tooltip{background:#d9534f}.single-user .custom-tooltip:after{border-top:10px solid #d9534f}.single-user .form-group textarea{min-height:120px}.single-user .ai-functionality .checkbox{margin-bottom:10px;display:block}.single-user .ai-functionality .checkbox label{text-transform:capitalize}.dashboard label{margin-right:10px}.dashboard section.widget{float:none}.dashboard .websites-script-version .input-group{vertical-align:middle;display:inline-block}.dashboard .websites-script-version .input-group input{width:80px}.dashboard .websites-script-version .input-group-no-border:last-child{margin-bottom:0}.dashboard .black-theme .range-picker{margin:0 0 0 10px;display:inline-block;float:none}.dashboard .black-theme .range-picker .form-control{height:34px}.dashboard .black-theme .checkbox{margin:7px 0}.all-logs{width:100%;float:left;margin-left:0;margin-right:0}.all-logs .table-filter{margin-right:0;margin-bottom:0}@media (min-width:600px){.all-logs .table-filter{margin-bottom:0}}@media (min-width:600px) and (min-width:1200px){.all-logs .table-filter{margin-bottom:20px}}.all-logs .table-filter .btn{margin-top:20px}@media (min-width:1600px){.all-logs .table-filter .btn{margin-top:0}}.all-logs .table-filter .btn-primary{clear:both}@media (min-width:1600px){.all-logs .table-filter .btn-primary{clear:none}}.all-logs .bulk-actions{margin-right:0}.all-logs .ng-table--date span{margin-bottom:0}.all-logs tr{cursor:pointer}.all-logs .logs-table{width:100%;background-color:#f5f5f5;border:1px solid #ddd;padding:20px;margin:auto;margin-top:50px;line-height:30px;float:none}@media (min-width:600px){.all-logs .logs-table{width:100%}}@media (min-width:600px) and (min-width:800px){.all-logs .logs-table{width:60%}}.all-logs .logs{word-wrap:break-word;text-align:left;border-bottom:1px solid #000}.all-logs .logs span{font-size:16px}.all-logs .input-field{margin-right:5px;float:left;margin-top:20px;clear:left;width:100%}@media (min-width:600px){.all-logs .input-field{width:130px}}@media (min-width:1600px){.all-logs .input-field{clear:inherit;margin-top:0}}.edit-media img,.video-wrapper img{max-width:100%}.edit-media .video-js,.video-wrapper .video-js{width:100%;background-color:#000;padding-bottom:56.25%;height:auto}.edit-media .video-js video,.video-wrapper .video-js video{width:100%;height:100%}.edit-media .video-js .vjs-big-play-button,.video-wrapper .video-js .vjs-big-play-button{border:none;background:url(" + __webpack_require__(395) + ") 50% no-repeat;background-size:100%;width:15%;height:26.67%;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%)}.edit-media .video-js .vjs-big-play-button:active,.edit-media .video-js .vjs-big-play-button:focus,.video-wrapper .video-js .vjs-big-play-button:active,.video-wrapper .video-js .vjs-big-play-button:focus{outline:none}.edit-media .video-wrapper,.video-wrapper .video-wrapper{max-width:620px;margin:0 auto;position:relative}.video-js .vjs-big-play-button .vjs-icon-placeholder:before{content:none}.video-js .vjs-time-control{display:block}.duration{position:absolute;bottom:0;right:0;margin:4px;border-radius:2px;background-color:hsla(0,0%,7%,.5);padding:2px 4px;color:#fff;font-size:1.2rem;font-weight:500}.media-image,.ng-table--title .media-image{position:relative}.single-post--widget.publish img{width:40px;height:40px}.form-group{display:block!important}.set-image-modal .right-column .video-wrapper{position:relative}.portrait .video-wrapper{max-width:360px}.portrait .video-js{padding-bottom:177.78%}.upload_video .widget>header{border:none}.upload_video .tab-content>.tab-pane{padding:0}.upload_video .categories-tree li label{font-size:14px}.upload_video .categories-tree>ul{margin-bottom:0}.upload_video .widget-body{padding:0}.upload_video .search-wrapper .autocomplete-result{z-index:10}.upload_video .list-tags{margin:0!important}.upload_video .list-tags li{margin-top:5px}.upload_video>.dropzone{position:relative;z-index:1}.upload_video>.dropzone.uploadedVideo{min-height:0;transition:all .4s ease}.upload_video>.dropzone.uploadedVideo .dz-default{height:0;min-height:0;border:none;transition:all .4s ease}.upload_video>.dropzone.uploadedVideo .dz-default span{display:none}.upload_video>.dropzone.error-border .dz-default{border:3px dashed #de1d1d}.upload_video>.dropzone .dz-preview .dz-image{width:60px;height:50px}.upload_video .form-group.animate{position:relative;z-index:-1}.upload_video .grid-wrapper .dropzone{position:absolute;top:0;left:0;right:0;bottom:0;text-align:left;min-height:0}.upload_video .grid-wrapper .dropzone .dz-details,.upload_video .grid-wrapper .dropzone .dz-image{display:none}.upload_video .grid-wrapper .dropzone .dz-message{height:100%;border:none;min-height:0}.upload_video .grid-wrapper .dropzone .dz-message span{border:3px dashed #ccc}.upload_video .grid-wrapper .dropzone.dz-started .dz-message{padding-bottom:70px}.upload_video .grid-wrapper .dropzone.dz-started .dz-preview{position:absolute;bottom:0;left:0;right:0;height:70px;min-height:0;margin-bottom:0}.upload_video .grid-wrapper .dropzone .dz-error-mark,.upload_video .grid-wrapper .dropzone .dz-error-message,.upload_video .grid-wrapper .dropzone .dz-success-mark{left:10px!important;margin-left:0!important}.upload_video .uppy-upload-wrapper .uppy-Dashboard-inner{width:100%!important}.upload_video .uppy-upload-wrapper .transcoding-wrapper{background-color:#fafafa;border:1px solid #eaeaea;border-top:none;border-bottom-left-radius:5px;border-top-right-radius:5px;position:relative;height:50px}.upload_video .uppy-upload-wrapper .transcoding-wrapper h3{line-height:50px;text-align:center;font-size:14px;color:#333;font-weight:600;margin:0;font-family:apple-system,blinkmacsystemfont,Segoe UI,helvetica,arial,sans-serif}.upload_video .uppy-upload-wrapper .transcoding-wrapper .transcoding-progress{height:2px;width:100%;position:absolute;bottom:0;left:0;background-color:#eaeaea}.upload_video .uppy-upload-wrapper .transcoding-wrapper .transcoding-progress.complete .transcoding-progress-bar{background-color:#1bb240}.upload_video .uppy-upload-wrapper .transcoding-wrapper .transcoding-progress-bar{background-color:#2275d7;position:absolute;left:0;top:0;height:100%;width:0;transition:width .3s linear}.ads-txt-wrapper textarea{min-height:600px}.ads-settings-wrapper option[disabled=disabled]{background:#ddd}.ads-settings-wrapper .remove{text-align:center;font-size:24px;font-weight:700;line-height:40px;width:40px}.ads-settings-wrapper .checkbox{margin-bottom:0;padding-left:40px!important}.ads-settings-wrapper .checkbox input[type=checkbox],.ads-settings-wrapper .checkbox label:after,.ads-settings-wrapper .checkbox label:before{top:50%;left:12px;transform:translateY(-50%)}.ads-settings-wrapper .checkbox.acordion-checkbox:not(.disabled-checkbox){padding-left:32px!important}.ads-settings-wrapper .checkbox label{font-weight:600}.ads-settings-wrapper .full-branding-settings-widget .widget-body li{padding-top:12px;padding-bottom:0}.ads-settings-wrapper .full-branding-settings-widget .widget-body li>ul{padding-left:15px}.ads-settings-wrapper .full-branding-settings-widget .widget-body li>ul li{padding-top:6px;padding-bottom:0}.ads-settings-wrapper .full-branding-settings-widget .widget-body .form-group>ul>li:first-child{padding-top:0}.ads-settings-wrapper .full-branding-settings-widget .widget-body .list-added li{padding:0}.ads-settings-wrapper .ads-accordion-item-wrapper,.ads-settings-wrapper .no-items-select{background:#eee;overflow:hidden;line-height:40px}.ads-settings-wrapper .no-items-select{padding-left:10px}.ads-settings-wrapper .no-items-select p{font-weight:400;margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".custom_class{font-size:14px;line-height:18px;overflow:hidden;overflow-y:initial!important;font-family:Georgia,Times New Roman,Bitstream Charter,Times,serif;color:#333}body{background-color:#fff;color:#000;font-family:Verdana,Arial,Helvetica,sans-serif;font-size:11px;scrollbar-3dlight-color:#f0f0ee;scrollbar-arrow-color:#676662;scrollbar-base-color:#f0f0ee;scrollbar-darkshadow-color:#ddd;scrollbar-face-color:#e0e0dd;scrollbar-highlight-color:#f0f0ee;scrollbar-shadow-color:#f0f0ee;scrollbar-track-color:#f5f5f5}.mce-content-body .mce-reset{margin:0;padding:0;border:0;outline:0;vertical-align:top;background:transparent;text-decoration:none;color:#000;font-family:Arial;font-size:11px;text-shadow:none;float:none;position:static;width:auto;height:auto;white-space:nowrap;cursor:inherit;line-height:normal;font-weight:400;text-align:left;-webkit-tap-highlight-color:transparent;box-sizing:content-box;direction:ltr;max-width:none}.mce-object{border:1px dotted #3a3a3a;background:#d5d5d5 url(" + __webpack_require__(415) + ") no-repeat 50%}.mce-preview-object{display:inline-block;position:relative;margin:0 2px;line-height:0;border:1px solid gray}.mce-preview-object .mce-shim{position:absolute;top:0;left:0;width:100%;height:100%;background:url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)}figure.align-left{float:left}figure.align-right{float:right}figure.image.align-center{display:table;margin-left:auto;margin-right:auto}figure.image{display:inline-block;border:1px solid gray;margin:0 2px 0 1px;background:#f5f2f0}figure.image img{margin:8px 8px 0}figure.image figcaption{margin:6px 8px;text-align:center}.mce-preview-object[data-mce-selected=\"2\"] .mce-shim{display:none}.mce-pagebreak{cursor:default;display:block;border:0;width:100%;height:5px;border:1px dashed #666;margin-top:15px;page-break-before:always}@media print{.mce-pagebreak{border:0}}.mce-item-anchor{cursor:default;display:inline-block;-webkit-user-select:all;-webkit-user-modify:read-only;-moz-user-select:all;-moz-user-modify:read-only;user-select:all;user-modify:read-only;width:9px!important;height:9px!important;border:1px dotted #3a3a3a;background:#d5d5d5 url(" + __webpack_require__(413) + ") no-repeat 50%}.mce-nbsp,.mce-shy{background:#aaa}.mce-shy:after{content:\"-\"}hr{cursor:default}.mce-match-marker{background:#aaa;color:#fff}.mce-match-marker-selected{background:#39f;color:#fff}.mce-spellchecker-word{border-bottom:2px solid red;cursor:default}.mce-spellchecker-grammar{border-bottom:2px solid green;cursor:default}.mce-item-table,.mce-item-table caption,.mce-item-table td,.mce-item-table th{border:1px dashed #bbb}td[data-mce-selected],th[data-mce-selected]{background-color:#39f!important}.mce-edit-focus{outline:1px dotted #333}.mce-content-body [contentEditable=false] [contentEditable=true]:focus{outline:2px solid #2d8ac7}.mce-content-body [contentEditable=false] [contentEditable=true]:hover{outline:2px solid #7acaff}.mce-content-body [contentEditable=false][data-mce-selected]{outline:2px solid #2d8ac7}.mce-resize-bar-dragging{background-color:blue;opacity:.25;filter:alpha(opacity=25);zoom:1}.mce-container,.mce-container *,.mce-reset,.mce-widget,.mce-widget *{margin:0;padding:0;border:0;outline:0;vertical-align:top;background:transparent;text-decoration:none;color:#333;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;text-shadow:none;float:none;position:static;width:auto;height:auto;white-space:nowrap;cursor:inherit;-webkit-tap-highlight-color:transparent;line-height:normal;font-weight:400;text-align:left;box-sizing:content-box;direction:ltr;max-width:none}.mce-widget button{box-sizing:border-box}.mce-container [unselectable]{-moz-user-select:none;-webkit-user-select:none;-o-user-select:none;user-select:none}.mce-fade{opacity:0;transition:opacity .15s linear}.mce-fade.mce-in{opacity:1}.mce-tinymce{visibility:inherit!important;position:relative}.mce-fullscreen{z-index:100}div.mce-fullscreen{width:100%;height:auto}.mce-tinymce{display:block}.mce-wordcount{position:absolute;top:0;right:0;padding:8px}div.mce-edit-area{background:#fff;filter:none}.mce-statusbar,.mce-statusbar .mce-container-body{position:relative}.mce-fullscreen .mce-resizehandle{display:none}.mce-charmap{border-collapse:collapse}.mce-charmap td{cursor:default;border:1px solid rgba(0,0,0,.2);width:20px;height:20px;line-height:20px;vertical-align:middle;padding:2px}.mce-charmap td,.mce-charmap td div{text-align:center}.mce-charmap td:hover{background:#d9d9d9}.mce-grid td.mce-grid-cell div{border:1px solid #d6d6d6;width:15px;height:15px;margin:0;cursor:pointer}.mce-grid td.mce-grid-cell div:focus{border-color:#3498db}.mce-grid td.mce-grid-cell div[disabled]{cursor:not-allowed}.mce-grid{border-spacing:2px;border-collapse:separate}.mce-grid a{display:block;border:1px solid transparent}.mce-grid a:focus,.mce-grid a:hover{border-color:#3498db}.mce-grid-border{margin:0 4px}.mce-grid-border a{border-color:#d6d6d6;width:13px;height:13px}.mce-grid-border a.mce-active,.mce-grid-border a:hover{border-color:#3498db;background:#3498db}.mce-text-center{text-align:center}div.mce-tinymce-inline{width:100%}.mce-colorbtn-trans div{text-align:center;vertical-align:middle;font-weight:700;font-size:20px;line-height:16px;color:#707070}.mce-monospace{font-family:Courier New,Courier,monospace}.mce-toolbar-grp{padding:2px 0}.mce-toolbar-grp .mce-flow-layout-item{margin-bottom:0}.mce-rtl .mce-wordcount{left:0;right:auto}.mce-croprect-container,.mce-croprect-handle{position:absolute;top:0;left:0}.mce-croprect-handle{width:20px;height:20px;border:2px solid #fff}.mce-croprect-handle-nw{border-width:2px 0 0 2px;margin:-2px 0 0 -2px;cursor:nw-resize;top:100px;left:100px}.mce-croprect-handle-ne{border-width:2px 2px 0 0;margin:-2px 0 0 -20px;cursor:ne-resize;top:100px;left:200px}.mce-croprect-handle-sw{border-width:0 0 2px 2px;margin:-20px 2px 0 -2px;cursor:sw-resize;top:200px;left:100px}.mce-croprect-handle-se{border-width:0 2px 2px 0;margin:-20px 0 0 -20px;cursor:se-resize;top:200px;left:200px}.mce-croprect-handle-move{position:absolute;cursor:move;border:0}.mce-croprect-block{opacity:.3;filter:alpha(opacity=30);zoom:1;position:absolute;background:#000}.mce-croprect-handle:focus{border-color:#3498db}.mce-croprect-handle-move:focus{outline:1px solid #3498db}.mce-imagepanel{overflow:auto;background:#000}.mce-imagepanel img{position:absolute}.mce-imagetool.mce-btn .mce-ico{display:block;width:20px;height:20px;text-align:center;line-height:20px;font-size:20px;padding:5px}.mce-arrow-up{margin-top:12px}.mce-arrow-down{margin-top:-12px}.mce-arrow:after,.mce-arrow:before{position:absolute;left:50%;display:block;width:0;height:0;border-style:solid;border-color:transparent;content:\"\"}.mce-arrow.mce-arrow-up:before{top:-9px;border-bottom-color:rgba(0,0,0,.2);border-width:0 9px 9px;margin-left:-9px}.mce-arrow.mce-arrow-down:before{bottom:-9px;border-top-color:rgba(0,0,0,.2);border-width:9px 9px 0;margin-left:-9px}.mce-arrow.mce-arrow-up:after{top:-8px;border-bottom-color:#f0f0f0;border-width:0 8px 8px;margin-left:-8px}.mce-arrow.mce-arrow-down:after{bottom:-8px;border-top-color:#f0f0f0;border-width:8px 8px 0;margin-left:-8px}.mce-arrow.mce-arrow-left:after,.mce-arrow.mce-arrow-left:before{margin:0}.mce-arrow.mce-arrow-left:before{left:8px}.mce-arrow.mce-arrow-left:after{left:9px}.mce-arrow.mce-arrow-right:after,.mce-arrow.mce-arrow-right:before{left:auto;margin:0}.mce-arrow.mce-arrow-right:before{right:8px}.mce-arrow.mce-arrow-right:after{right:9px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-left:before{left:-9px;top:50%;border-right-color:rgba(0,0,0,.2);border-width:9px 9px 9px 0;margin-top:-9px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-left:after{left:-8px;top:50%;border-right-color:#f0f0f0;border-width:8px 8px 8px 0;margin-top:-8px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-left{margin-left:12px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-right:before{right:-9px;top:50%;border-left-color:rgba(0,0,0,.2);border-width:9px 0 9px 9px;margin-top:-9px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-right:after{right:-8px;top:50%;border-left-color:#f0f0f0;border-width:8px 0 8px 8px;margin-top:-8px}.mce-arrow.mce-arrow-center.mce-arrow.mce-arrow-right{margin-left:-14px}.mce-container,.mce-container-body{display:block}.mce-autoscroll{overflow:hidden}.mce-scrollbar{position:absolute;width:7px;height:100%;top:2px;right:2px;opacity:.4;filter:alpha(opacity=40);zoom:1}.mce-scrollbar-h{top:auto;right:auto;left:2px;bottom:2px;width:100%;height:7px}.mce-scrollbar-thumb{position:absolute;background-color:#000;border:1px solid #888;border-color:rgba(85,85,85,.6);width:5px;height:100%}.mce-scrollbar-h .mce-scrollbar-thumb{width:100%;height:5px}.mce-scrollbar.mce-active,.mce-scrollbar:hover{background-color:#aaa;opacity:.6;filter:alpha(opacity=60);zoom:1}.mce-scroll{position:relative}.mce-panel{border:0 solid #cacaca;border:0 solid rgba(0,0,0,.2);background-color:#f0f0f0}.mce-floatpanel{position:absolute}.mce-floatpanel.mce-fixed{position:fixed}.mce-floatpanel .mce-arrow,.mce-floatpanel .mce-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.mce-floatpanel .mce-arrow{border-width:11px}.mce-floatpanel .mce-arrow:after{border-width:10px;content:\"\"}.mce-floatpanel.mce-popover{filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);background:transparent;top:0;left:0;background:#fff;border:1px solid rgba(0,0,0,.2);border:1px solid rgba(0,0,0,.25)}.mce-floatpanel.mce-popover.mce-bottom{margin-top:10px;*margin-top:0}.mce-floatpanel.mce-popover.mce-bottom>.mce-arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:rgba(0,0,0,.2);border-bottom-color:rgba(0,0,0,.25);top:-11px}.mce-floatpanel.mce-popover.mce-bottom>.mce-arrow:after{top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.mce-floatpanel.mce-popover.mce-bottom.mce-start{margin-left:-22px}.mce-floatpanel.mce-popover.mce-bottom.mce-start>.mce-arrow{left:20px}.mce-floatpanel.mce-popover.mce-bottom.mce-end{margin-left:22px}.mce-floatpanel.mce-popover.mce-bottom.mce-end>.mce-arrow{right:10px;left:auto}.mce-fullscreen{border:0;padding:0;margin:0;overflow:hidden;height:100%}#mce-modal-block,div.mce-fullscreen{position:fixed;top:0;left:0}#mce-modal-block{opacity:0;filter:alpha(opacity=0);zoom:1;width:100%;height:100%;background:#000}#mce-modal-block.mce-in{opacity:.3;filter:alpha(opacity=30);zoom:1}.mce-window-move{cursor:move}.mce-window{filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);background:transparent;background:#fff;position:fixed;top:0;left:0;opacity:0;transform:scale(.1);transition:transform .1s ease-in,opacity .15s ease-in}.mce-window.mce-in{transform:scale(1);opacity:1}.mce-window-head{padding:9px 15px;border-bottom:1px solid #c5c5c5;position:relative}.mce-window-head .mce-close{position:absolute;right:0;top:0;height:38px;width:38px;text-align:center;cursor:pointer}.mce-window-head .mce-close i{color:#858585}.mce-close:hover i{color:#adadad}.mce-window-head .mce-title{line-height:20px;font-size:20px;font-weight:700;text-rendering:optimizelegibility;padding-right:20px}.mce-foot,.mce-window .mce-container-body{display:block}.mce-foot{background-color:#fff;border-top:1px solid #c5c5c5}.mce-window-head .mce-dragh{position:absolute;top:0;left:0;cursor:move;width:90%;height:100%}.mce-window iframe{width:100%;height:100%}.mce-window-body .mce-listbox{border-color:#ccc}.mce-rtl .mce-window-head .mce-close{position:absolute;right:auto;left:15px}.mce-rtl .mce-window-head .mce-dragh{left:auto;right:0}.mce-rtl .mce-window-head .mce-title{direction:rtl;text-align:right}.mce-tooltip{position:absolute;padding:5px;opacity:.8;filter:alpha(opacity=80);zoom:1}.mce-tooltip-inner{font-size:11px;background-color:#000;color:#fff;max-width:200px;padding:5px 8px 4px;text-align:center;white-space:normal}.mce-tooltip-arrow{position:absolute;width:0;height:0;line-height:0;border:5px dashed #000}.mce-tooltip-arrow-n{border-bottom-color:#000}.mce-tooltip-arrow-s{border-top-color:#000}.mce-tooltip-arrow-e{border-left-color:#000}.mce-tooltip-arrow-w{border-right-color:#000}.mce-tooltip-nw,.mce-tooltip-sw{margin-left:-14px}.mce-tooltip-n .mce-tooltip-arrow{left:50%;margin-left:-5px}.mce-tooltip-n .mce-tooltip-arrow,.mce-tooltip-nw .mce-tooltip-arrow{top:0;border-bottom-style:solid;border-top:none;border-left-color:transparent;border-right-color:transparent}.mce-tooltip-nw .mce-tooltip-arrow{left:10px}.mce-tooltip-ne .mce-tooltip-arrow{top:0;right:10px;border-bottom-style:solid;border-top:none;border-left-color:transparent;border-right-color:transparent}.mce-tooltip-s .mce-tooltip-arrow{left:50%;margin-left:-5px}.mce-tooltip-s .mce-tooltip-arrow,.mce-tooltip-sw .mce-tooltip-arrow{bottom:0;border-top-style:solid;border-bottom:none;border-left-color:transparent;border-right-color:transparent}.mce-tooltip-sw .mce-tooltip-arrow{left:10px}.mce-tooltip-se .mce-tooltip-arrow{bottom:0;right:10px;border-top-style:solid;border-bottom:none;border-left-color:transparent;border-right-color:transparent}.mce-tooltip-e .mce-tooltip-arrow{right:0;top:50%;margin-top:-5px;border-left-style:solid;border-right:none;border-top-color:transparent;border-bottom-color:transparent}.mce-tooltip-w .mce-tooltip-arrow{left:0;top:50%;margin-top:-5px;border-right-style:solid;border-left:none;border-top-color:transparent;border-bottom-color:transparent}.mce-progress{display:inline-block;position:relative;height:20px}.mce-progress .mce-bar-container{display:inline-block;width:100px;height:100%;margin-right:8px;border:1px solid #ccc;overflow:hidden}.mce-progress .mce-text{display:inline-block;margin-top:auto;margin-bottom:auto;font-size:14px;width:40px;color:#333}.mce-bar{display:block;width:0;height:100%;background-color:#d7d7d7;transition:width .2s ease}.mce-notification{position:absolute;background-color:#f0f0f0;padding:5px;margin-top:5px;border:1px solid #ccc;transition:transform .1s ease-in,opacity .15s ease-in;opacity:0}.mce-notification.mce-in{opacity:1}.mce-notification-success{background-color:#dff0d8;border-color:#d6e9c6}.mce-notification-info{background-color:#d9edf7;border-color:#779ecb}.mce-notification-warning{background-color:#fcf8e3;border-color:#faebcc}.mce-notification-error{background-color:#f2dede;border-color:#ebccd1}.mce-notification.mce-has-close{padding-right:15px}.mce-notification .mce-ico{margin-top:5px}.mce-notification-inner{display:inline-block;font-size:14px;margin:5px 8px 4px;text-align:center;white-space:normal;color:#31708f}.mce-notification-inner a{text-decoration:underline;cursor:pointer}.mce-notification .mce-progress{margin-right:8px}.mce-notification .mce-progress .mce-text{margin-top:5px}.mce-notification *,.mce-notification .mce-progress .mce-text{color:#333}.mce-notification .mce-progress .mce-bar-container{border-color:#ccc}.mce-notification .mce-progress .mce-bar-container .mce-bar{background-color:#333}.mce-notification-success *,.mce-notification-success .mce-progress .mce-text{color:#3c763d}.mce-notification-success .mce-progress .mce-bar-container{border-color:#d6e9c6}.mce-notification-success .mce-progress .mce-bar-container .mce-bar{background-color:#3c763d}.mce-notification-info *,.mce-notification-info .mce-progress .mce-text{color:#31708f}.mce-notification-info .mce-progress .mce-bar-container{border-color:#779ecb}.mce-notification-info .mce-progress .mce-bar-container .mce-bar{background-color:#31708f}.mce-notification-warning *,.mce-notification-warning .mce-progress .mce-text{color:#8a6d3b}.mce-notification-warning .mce-progress .mce-bar-container{border-color:#faebcc}.mce-notification-warning .mce-progress .mce-bar-container .mce-bar{background-color:#8a6d3b}.mce-notification-error *,.mce-notification-error .mce-progress .mce-text{color:#a94442}.mce-notification-error .mce-progress .mce-bar-container{border-color:#ebccd1}.mce-notification-error .mce-progress .mce-bar-container .mce-bar{background-color:#a94442}.mce-notification .mce-close{position:absolute;top:6px;right:8px;font-size:20px;font-weight:700;line-height:20px;color:#858585;cursor:pointer;height:20px;overflow:hidden}.mce-abs-layout{position:relative}.mce-abs-end,body .mce-abs-layout-item{position:absolute}.mce-abs-end{width:1px;height:1px}.mce-container-body.mce-abs-layout{overflow:hidden}.mce-btn{border:1px solid #b1b1b1;border-color:transparent;position:relative;text-shadow:0 1px 1px hsla(0,0%,100%,.75);display:inline-block;*display:inline;*zoom:1;background-color:#f0f0f0}.mce-btn:focus,.mce-btn:hover{color:#333;background-color:#e3e3e3;border-color:#ccc}.mce-btn.mce-disabled:hover button,.mce-btn.mce-disabled button{cursor:default;opacity:.4;filter:alpha(opacity=40);zoom:1}.mce-btn.mce-active,.mce-btn.mce-active:hover{background-color:#dbdbdb;border-color:#ccc}.mce-btn:active{background-color:#e0e0e0;border-color:#ccc}.mce-btn button{padding:4px 8px;font-size:14px;line-height:20px;*line-height:16px;cursor:pointer;color:#333;text-align:center;overflow:visible;-webkit-appearance:none}.mce-btn button::-moz-focus-inner{border:0;padding:0}.mce-btn i{text-shadow:1px 1px none}.mce-primary.mce-btn-has-text{min-width:50px}.mce-primary{color:#fff;border:1px solid transparent;border-color:transparent;background-color:#2d8ac7}.mce-primary:focus,.mce-primary:hover{background-color:#257cb6;border-color:transparent}.mce-primary.mce-disabled:hover button,.mce-primary.mce-disabled button{cursor:default;opacity:.4;filter:alpha(opacity=40);zoom:1}.mce-primary.mce-active,.mce-primary.mce-active:hover,.mce-primary:not(.mce-disabled):active{background-color:#206ea1}.mce-primary button,.mce-primary button i{color:#fff;text-shadow:1px 1px none}.mce-btn .mce-txt{font-size:inherit;line-height:inherit;color:inherit}.mce-btn-large button{padding:9px 14px;font-size:16px;line-height:normal}.mce-btn-large i{margin-top:2px}.mce-btn-small button{padding:1px 5px;font-size:12px;*padding-bottom:2px}.mce-btn-small i{line-height:20px;vertical-align:top;*line-height:18px}.mce-btn-small .mce-caret,.mce-btn .mce-caret{margin-top:8px;margin-left:0}.mce-caret{display:inline-block;*display:inline;*zoom:1;width:0;height:0;vertical-align:top;border-top:4px solid #333;border-right:4px solid transparent;border-left:4px solid transparent;content:\"\"}.mce-disabled .mce-caret{border-top-color:#aaa}.mce-caret.mce-up{border-bottom:4px solid #333;border-top:0}.mce-btn-flat{border:0;background:transparent;filter:none}.mce-btn-flat.mce-active,.mce-btn-flat:active,.mce-btn-flat:focus,.mce-btn-flat:hover{border:0;background:#e6e6e6;filter:none}.mce-btn-has-text .mce-ico{padding-right:5px}.mce-rtl .mce-btn button{direction:rtl}.mce-btn-group .mce-btn{border-width:1px;margin:0;margin-left:2px}.mce-btn-group:not(:first-child){border-left:1px solid #d9d9d9;padding-left:3px;margin-left:3px}.mce-btn-group .mce-first{margin-left:0}.mce-btn-group .mce-btn.mce-flow-layout-item{margin:0}.mce-rtl .mce-btn-group .mce-btn{margin-left:0;margin-right:2px}.mce-rtl .mce-btn-group .mce-first{margin-right:0}.mce-rtl .mce-btn-group:not(:first-child){border-left:none;border-right:1px solid #d9d9d9;padding-right:4px;margin-right:4px}.mce-checkbox{cursor:pointer}i.mce-i-checkbox{margin:0 3px 0 0;border:1px solid #c5c5c5;background-color:#f0f0f0;text-indent:-10em;*font-size:0;*line-height:0;*text-indent:0;overflow:hidden}.mce-checked i.mce-i-checkbox{color:#333;font-size:16px;line-height:16px;text-indent:0}.mce-checkbox.mce-focus i.mce-i-checkbox,.mce-checkbox:focus i.mce-i-checkbox{border:1px solid rgba(82,168,236,.8)}.mce-checkbox.mce-disabled .mce-label,.mce-checkbox.mce-disabled i.mce-i-checkbox{color:#acacac}.mce-checkbox .mce-label{vertical-align:middle}.mce-rtl .mce-checkbox{direction:rtl;text-align:right}.mce-rtl i.mce-i-checkbox{margin:0 0 0 3px}.mce-combobox{display:inline-block;*display:inline;*zoom:1;*height:32px}.mce-combobox input{border:1px solid #c5c5c5;border-right-color:#c5c5c5;height:28px}.mce-combobox.mce-disabled input{color:#adadad}.mce-combobox .mce-btn{border:1px solid #c5c5c5;border-left:0}.mce-combobox button{padding-right:8px;padding-left:8px}.mce-combobox.mce-disabled .mce-btn button{cursor:default;opacity:.4;filter:alpha(opacity=40);zoom:1}.mce-colorbox i{border:1px solid #c5c5c5;width:14px;height:14px}.mce-colorbutton .mce-ico{position:relative}.mce-colorbutton-grid{margin:4px}.mce-colorbutton button{padding-right:6px;padding-left:6px}.mce-colorbutton .mce-preview{padding-right:3px;display:block;position:absolute;left:50%;top:50%;margin-left:-17px;margin-top:7px;background:gray;width:13px;height:2px;overflow:hidden}.mce-colorbutton.mce-btn-small .mce-preview{margin-left:-16px;padding-right:0;width:16px}.mce-colorbutton .mce-open{padding-left:4px;padding-right:4px;border-left:1px solid transparent}.mce-colorbutton:hover .mce-open{border-color:#ccc}.mce-colorbutton.mce-btn-small .mce-open{padding:0 3px}.mce-rtl .mce-colorbutton{direction:rtl}.mce-rtl .mce-colorbutton .mce-preview{margin-left:0;padding-right:0;padding-left:3px}.mce-rtl .mce-colorbutton.mce-btn-small .mce-preview{margin-left:0;padding-right:0;padding-left:2px}.mce-rtl .mce-colorbutton .mce-open{padding-left:4px;padding-right:4px;border-left:0}.mce-colorpicker{position:relative;width:250px;height:220px}.mce-colorpicker-sv{position:absolute;top:0;left:0;width:90%;height:100%;border:1px solid #c5c5c5;cursor:crosshair;overflow:hidden}.mce-colorpicker-h-chunk{width:100%}.mce-colorpicker-overlay1,.mce-colorpicker-overlay2{width:100%;height:100%;position:absolute;top:0;left:0}.mce-colorpicker-overlay1{filter:progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr=\"#ffffff\",endColorstr=\"#00ffffff\");-ms-filter:\"progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr='#ffffff', endColorstr='#00ffffff')\";background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.mce-colorpicker-overlay2{filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=\"#00000000\",endColorstr=\"#000000\");-ms-filter:\"progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#00000000', endColorstr='#000000')\";background:linear-gradient(180deg,transparent,#000)}.mce-colorpicker-selector1{background:none;position:absolute;width:12px;height:12px;margin:-8px 0 0 -8px;border:1px solid #000;border-radius:50%}.mce-colorpicker-selector2{position:absolute;width:10px;height:10px;border:1px solid #fff;border-radius:50%}.mce-colorpicker-h{position:absolute;top:0;right:0;width:6.5%;height:100%;border:1px solid #c5c5c5;cursor:crosshair}.mce-colorpicker-h-marker{margin-top:-4px;position:absolute;top:0;left:-1px;width:100%;border:1px solid #333;background:#fff;height:4px;z-index:100}.mce-path{display:inline-block;*display:inline;*zoom:1;padding:8px;white-space:normal}.mce-path .mce-txt{padding-right:3px}.mce-path .mce-path-body,.mce-path .mce-txt{display:inline-block}.mce-path-item{display:inline-block;*display:inline;*zoom:1;cursor:pointer;color:#333}.mce-path-item:hover{text-decoration:underline}.mce-path-item:focus{background:#666;color:#fff}.mce-path .mce-divider{display:inline}.mce-disabled .mce-path-item{color:#aaa}.mce-rtl .mce-path{direction:rtl}.mce-fieldset{border:0 solid #9e9e9e}.mce-fieldset>.mce-container-body{margin-top:-15px}.mce-fieldset-title{margin-left:5px;padding:0 5px}.mce-fit-layout{display:inline-block;*display:inline;*zoom:1}.mce-fit-layout-item{position:absolute}.mce-flow-layout-item{display:inline-block;*display:inline;*zoom:1;margin:2px 0 2px 2px}.mce-flow-layout-item.mce-last{margin-right:2px}.mce-flow-layout{white-space:normal}.mce-tinymce-inline .mce-flow-layout{white-space:nowrap}.mce-rtl .mce-flow-layout{text-align:right;direction:rtl}.mce-rtl .mce-flow-layout-item{margin:2px 2px 2px 0}.mce-rtl .mce-flow-layout-item.mce-last{margin-left:2px}.mce-iframe{border:0 solid rgba(0,0,0,.2);width:100%;height:100%}.mce-infobox{display:inline-block;*display:inline;*zoom:1;text-shadow:0 1px 1px hsla(0,0%,100%,.75);overflow:hidden;border:1px solid red}.mce-infobox div{display:block;margin:5px}.mce-infobox div button{position:absolute;top:50%;right:4px;cursor:pointer;margin-top:-8px;display:none}.mce-infobox div button:focus{outline:2px solid #ccc}.mce-infobox.mce-has-help div{margin-right:25px}.mce-infobox.mce-has-help button{display:block}.mce-infobox.mce-success{background:#dff0d8;border-color:#d6e9c6}.mce-infobox.mce-success div{color:#3c763d}.mce-infobox.mce-warning{background:#fcf8e3;border-color:#faebcc}.mce-infobox.mce-warning div{color:#8a6d3b}.mce-infobox.mce-error{background:#f2dede;border-color:#ebccd1}.mce-infobox.mce-error div{color:#a94442}.mce-rtl .mce-infobox div{text-align:right;direction:rtl}.mce-label{display:inline-block;*display:inline;*zoom:1;text-shadow:0 1px 1px hsla(0,0%,100%,.75);overflow:hidden}.mce-label.mce-autoscroll{overflow:auto}.mce-label.mce-disabled{color:#aaa}.mce-label.mce-multiline{white-space:pre-wrap}.mce-label.mce-success{color:#468847}.mce-label.mce-warning{color:#c09853}.mce-label.mce-error{color:#b94a48}.mce-rtl .mce-label{text-align:right;direction:rtl}.mce-menubar .mce-menubtn{border-color:transparent;background:transparent;filter:none}.mce-menubar .mce-menubtn button{color:#333}.mce-menubar{border:1px solid hsla(0,0%,85%,.52)}.mce-menubar .mce-menubtn button span{color:#333}.mce-menubar .mce-caret{border-top-color:#333}.mce-menubar .mce-menubtn.mce-active,.mce-menubar .mce-menubtn:focus,.mce-menubar .mce-menubtn:hover{border-color:#ccc;background:#fff;filter:none}.mce-menubtn button{color:#333}.mce-menubtn.mce-btn-small span{font-size:12px}.mce-menubtn.mce-fixed-width span{display:inline-block;overflow-x:hidden;text-overflow:ellipsis;width:90px}.mce-menubtn.mce-fixed-width.mce-btn-small span{width:70px}.mce-menubtn .mce-caret{*margin-top:6px}.mce-rtl .mce-menubtn button{direction:rtl;text-align:right}.mce-menu-item{display:block;padding:6px 15px 6px 12px;clear:both;font-weight:400;line-height:20px;color:#333;white-space:nowrap;cursor:pointer;line-height:normal;border-left:4px solid transparent;margin-bottom:1px}.mce-menu-item .mce-ico,.mce-menu-item .mce-text{color:#333}.mce-menu-item.mce-disabled .mce-ico,.mce-menu-item.mce-disabled .mce-text{color:#adadad}.mce-menu-item.mce-selected .mce-ico,.mce-menu-item.mce-selected .mce-text,.mce-menu-item:focus .mce-ico,.mce-menu-item:focus .mce-text,.mce-menu-item:hover .mce-ico,.mce-menu-item:hover .mce-text{color:#fff}.mce-menu-item.mce-disabled:hover{background:#ccc}.mce-menu-shortcut{color:#adadad;display:inline-block;display:inline;zoom:1;padding:0 15px 0 20px}.mce-menu-item.mce-selected .mce-menu-shortcut,.mce-menu-item:focus .mce-menu-shortcut,.mce-menu-item:hover .mce-menu-shortcut{color:#fff}.mce-menu-item .mce-caret{margin-top:4px;*margin-top:3px;margin-right:6px;border-top:4px solid transparent;border-bottom:4px solid transparent;border-left:4px solid #333}.mce-menu-item.mce-selected .mce-caret,.mce-menu-item:focus .mce-caret,.mce-menu-item:hover .mce-caret{border-left-color:#fff}.mce-menu-align .mce-menu-shortcut{*margin-top:-2px}.mce-menu-align .mce-caret,.mce-menu-align .mce-menu-shortcut{position:absolute;right:0}.mce-menu-item.mce-active i{visibility:visible}.mce-menu-item-normal.mce-active{background-color:#3498db}.mce-menu-item-preview.mce-active{border-left:5px solid #aaa}.mce-menu-item-normal.mce-active .mce-text,.mce-menu-item-normal.mce-active:focus .mce-ico,.mce-menu-item-normal.mce-active:focus .mce-text,.mce-menu-item-normal.mce-active:hover .mce-ico,.mce-menu-item-normal.mce-active:hover .mce-text{color:#fff}.mce-menu-item.mce-selected,.mce-menu-item:focus,.mce-menu-item:hover{text-decoration:none;color:#fff;background-color:#2d8ac7}.mce-menu-item-sep:hover,div.mce-menu .mce-menu-item-sep{border:0;padding:0;height:1px;margin:9px 1px;overflow:hidden;background:transparent;border-bottom:1px solid rgba(0,0,0,.1);cursor:default;filter:none}.mce-menu.mce-rtl{direction:rtl}.mce-rtl .mce-menu-item{text-align:right;direction:rtl;padding:6px 12px 6px 15px}.mce-menu-align.mce-rtl .mce-caret,.mce-menu-align.mce-rtl .mce-menu-shortcut{right:auto;left:0}.mce-rtl .mce-menu-item .mce-caret{margin-left:6px;margin-right:0;border-right:4px solid #333;border-left:0}.mce-rtl .mce-menu-item.mce-selected .mce-caret,.mce-rtl .mce-menu-item:focus .mce-caret,.mce-rtl .mce-menu-item:hover .mce-caret{border-left-color:transparent;border-right-color:#fff}.mce-throbber{position:absolute;top:0;left:0;width:100%;height:100%;opacity:.6;filter:alpha(opacity=60);zoom:1;background:#fff url(" + __webpack_require__(414) + ") no-repeat 50%}.mce-throbber-inline{position:static;height:50px}.mce-menu .mce-throbber-inline{height:25px;background-size:contain}.mce-menu{position:absolute;left:0;top:0;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);background:transparent;z-index:1000;padding:5px 0;margin:-1px 0 0;min-width:160px;background:#fff;border:1px solid #989898;border:1px solid rgba(0,0,0,.2);z-index:1002;max-height:400px;overflow:auto;overflow-x:hidden}.mce-menu i{display:none}.mce-menu-has-icons i{display:inline-block;*display:inline}.mce-menu-sub-tr-tl{margin:-6px 0 0 -1px}.mce-menu-sub-br-bl{margin:6px 0 0 -1px}.mce-menu-sub-tl-tr{margin:-6px 0 0 1px}.mce-menu-sub-bl-br{margin:6px 0 0 1px}.mce-listbox button{text-align:left;padding-right:20px;position:relative}.mce-listbox .mce-caret{position:absolute;margin-top:-2px;right:8px;top:50%}.mce-rtl .mce-listbox .mce-caret{right:auto;left:8px}.mce-rtl .mce-listbox button{padding-right:10px;padding-left:20px}.mce-container-body .mce-resizehandle{position:absolute;right:0;bottom:0;width:16px;height:16px;visibility:visible;cursor:s-resize;margin:0}.mce-container-body .mce-resizehandle-both{cursor:se-resize}i.mce-i-resize{color:#333}.mce-selectbox{background:#fff;border:1px solid #c5c5c5}.mce-slider{border:1px solid #aaa;background:#eee;width:100px;height:10px;position:relative;display:block}.mce-slider.mce-vertical{width:10px;height:100px}.mce-slider-handle{border:1px solid #bbb;background:#ddd;display:block;width:13px;height:13px;position:absolute;top:0;left:0;margin-left:-1px;margin-top:-2px}.mce-slider-handle:focus{background:#bbb}.mce-spacer{visibility:hidden}.mce-splitbtn .mce-open{border-left:1px solid transparent}.mce-splitbtn:hover .mce-open{border-left-color:#ccc}.mce-splitbtn button{padding-right:6px;padding-left:6px}.mce-splitbtn .mce-open{padding-right:4px;padding-left:4px}.mce-splitbtn .mce-open.mce-active{background-color:#dbdbdb;outline:1px solid #ccc}.mce-splitbtn.mce-btn-small .mce-open{padding:0 3px}.mce-rtl .mce-splitbtn{direction:rtl;text-align:right}.mce-rtl .mce-splitbtn button{padding-right:4px;padding-left:4px}.mce-rtl .mce-splitbtn .mce-open{border-left:0}.mce-stack-layout-item,.mce-tabs{display:block}.mce-tabs{border-bottom:1px solid #c5c5c5}.mce-tab,.mce-tabs,.mce-tabs+.mce-container-body{background:#fff}.mce-tab{display:inline-block;*display:inline;*zoom:1;border:1px solid #c5c5c5;border-width:0 1px 0 0;padding:8px;text-shadow:0 1px 1px hsla(0,0%,100%,.75);height:13px;cursor:pointer}.mce-tab:hover{background:#fdfdfd}.mce-tab.mce-active{background:#fdfdfd;border-bottom-color:transparent;margin-bottom:-1px;height:14px}.mce-rtl .mce-tabs{text-align:right;direction:rtl}.mce-rtl .mce-tab{border-width:0 0 0 1px}.mce-textbox{background:#fff;border:1px solid #c5c5c5;display:inline-block;transition:border .2s linear,box-shadow .2s linear;height:28px;resize:none;padding:0 4px;white-space:pre-wrap;*white-space:pre;color:#333}.mce-textbox.mce-focus,.mce-textbox:focus{border-color:#3498db}.mce-placeholder .mce-textbox{color:#aaa}.mce-textbox.mce-multiline{padding:4px;height:auto}.mce-textbox.mce-disabled{color:#adadad}.mce-rtl .mce-textbox{text-align:right;direction:rtl}@font-face{font-family:tinymce;src:url(" + __webpack_require__(155) + ");src:url(" + __webpack_require__(155) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(412) + ") format(\"woff\"),url(" + __webpack_require__(411) + ") format(\"truetype\"),url(" + __webpack_require__(410) + "#tinymce) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:tinymce-small;src:url(" + __webpack_require__(154) + ");src:url(" + __webpack_require__(154) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(409) + ") format(\"woff\"),url(" + __webpack_require__(408) + ") format(\"truetype\"),url(" + __webpack_require__(407) + "#tinymce) format(\"svg\");font-weight:400;font-style:normal}.mce-ico{font-family:tinymce,Arial;font-style:normal;font-weight:400;font-variant:normal;font-size:16px;line-height:16px;speak:none;vertical-align:text-top;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;background:transparent 50%;background-size:cover;width:16px;height:16px;color:#333}.mce-btn-small .mce-ico{font-family:tinymce-small,Arial}.mce-i-save:before{content:\"\\E000\"}.mce-i-newdocument:before{content:\"\\E001\"}.mce-i-fullpage:before{content:\"\\E002\"}.mce-i-alignleft:before{content:\"\\E003\"}.mce-i-aligncenter:before{content:\"\\E004\"}.mce-i-alignright:before{content:\"\\E005\"}.mce-i-alignjustify:before{content:\"\\E006\"}.mce-i-alignnone:before{content:\"\\E003\"}.mce-i-paste:before{content:\"\\E008\"}.mce-i-searchreplace:before{content:\"\\E009\"}.mce-i-bullist:before{content:\"\\E00A\"}.mce-i-numlist:before{content:\"\\E00B\"}.mce-i-indent:before{content:\"\\E00C\"}.mce-i-outdent:before{content:\"\\E00D\"}.mce-i-blockquote:before{content:\"\\E00E\"}.mce-i-undo:before{content:\"\\E00F\"}.mce-i-redo:before{content:\"\\E010\"}.mce-i-link:before{content:\"\\E011\"}.mce-i-unlink:before{content:\"\\E012\"}.mce-i-anchor:before{content:\"\\E013\"}.mce-i-image:before{content:\"\\E014\"}.mce-i-media:before{content:\"\\E015\"}.mce-i-help:before{content:\"\\E016\"}.mce-i-code:before{content:\"\\E017\"}.mce-i-insertdatetime:before{content:\"\\E018\"}.mce-i-preview:before{content:\"\\E019\"}.mce-i-backcolor:before,.mce-i-forecolor:before{content:\"\\E01A\"}.mce-i-table:before{content:\"\\E01B\"}.mce-i-hr:before{content:\"\\E01C\"}.mce-i-removeformat:before{content:\"\\E01D\"}.mce-i-subscript:before{content:\"\\E01E\"}.mce-i-superscript:before{content:\"\\E01F\"}.mce-i-charmap:before{content:\"\\E020\"}.mce-i-emoticons:before{content:\"\\E021\"}.mce-i-print:before{content:\"\\E022\"}.mce-i-fullscreen:before{content:\"\\E023\"}.mce-i-spellchecker:before{content:\"\\E024\"}.mce-i-nonbreaking:before{content:\"\\E025\"}.mce-i-template:before{content:\"\\E026\"}.mce-i-pagebreak:before{content:\"\\E027\"}.mce-i-restoredraft:before{content:\"\\E028\"}.mce-i-bold:before{content:\"\\E02A\"}.mce-i-italic:before{content:\"\\E02B\"}.mce-i-underline:before{content:\"\\E02C\"}.mce-i-strikethrough:before{content:\"\\E02D\"}.mce-i-visualblocks:before,.mce-i-visualchars:before{content:\"\\E02E\"}.mce-i-ltr:before{content:\"\\E02F\"}.mce-i-rtl:before{content:\"\\E030\"}.mce-i-copy:before{content:\"\\E031\"}.mce-i-resize:before{content:\"\\E032\"}.mce-i-browse:before{content:\"\\E034\"}.mce-i-pastetext:before{content:\"\\E035\"}.mce-i-rotateleft:before{content:\"\\EAA8\"}.mce-i-rotateright:before{content:\"\\EAA9\"}.mce-i-crop:before{content:\"\\EE78\"}.mce-i-editimage:before{content:\"\\E915\"}.mce-i-options:before{content:\"\\EC6A\"}.mce-i-flipv:before{content:\"\\EAAA\"}.mce-i-fliph:before{content:\"\\EAAC\"}.mce-i-zoomin:before{content:\"\\EB35\"}.mce-i-zoomout:before{content:\"\\EB36\"}.mce-i-sun:before{content:\"\\ECCC\"}.mce-i-moon:before{content:\"\\ECCD\"}.mce-i-arrowleft:before{content:\"\\EDC0\"}.mce-i-arrowright:before{content:\"\\E93C\"}.mce-i-drop:before{content:\"\\E935\"}.mce-i-contrast:before{content:\"\\ECD4\"}.mce-i-sharpen:before{content:\"\\EBA7\"}.mce-i-resize2:before{content:\"\\EDF9\"}.mce-i-orientation:before{content:\"\\E601\"}.mce-i-invert:before{content:\"\\E602\"}.mce-i-gamma:before{content:\"\\E600\"}.mce-i-remove:before{content:\"\\ED6A\"}.mce-i-tablerowprops:before{content:\"\\E604\"}.mce-i-tablecellprops:before{content:\"\\E605\"}.mce-i-table2:before{content:\"\\E606\"}.mce-i-tablemergecells:before{content:\"\\E607\"}.mce-i-tableinsertcolbefore:before{content:\"\\E608\"}.mce-i-tableinsertcolafter:before{content:\"\\E609\"}.mce-i-tableinsertrowbefore:before{content:\"\\E60A\"}.mce-i-tableinsertrowafter:before{content:\"\\E60B\"}.mce-i-tablesplitcells:before{content:\"\\E60D\"}.mce-i-tabledelete:before{content:\"\\E60E\"}.mce-i-tableleftheader:before{content:\"\\E62A\"}.mce-i-tabletopheader:before{content:\"\\E62B\"}.mce-i-tabledeleterow:before{content:\"\\E800\"}.mce-i-tabledeletecol:before{content:\"\\E801\"}.mce-i-codesample:before{content:\"\\E603\"}.mce-i-fill:before{content:\"\\E902\"}.mce-i-borderwidth:before{content:\"\\E903\"}.mce-i-line:before{content:\"\\E904\"}.mce-i-count:before{content:\"\\E905\"}.mce-i-translate:before{content:\"\\E907\"}.mce-i-drag:before{content:\"\\E908\"}.mce-i-home:before{content:\"\\E90B\"}.mce-i-upload:before{content:\"\\E914\"}.mce-i-bubble:before{content:\"\\E91C\"}.mce-i-user:before{content:\"\\E91D\"}.mce-i-lock:before{content:\"\\E926\"}.mce-i-unlock:before{content:\"\\E927\"}.mce-i-settings:before{content:\"\\E928\"}.mce-i-remove2:before{content:\"\\E92A\"}.mce-i-menu:before{content:\"\\E92D\"}.mce-i-warning:before{content:\"\\E930\"}.mce-i-question:before{content:\"\\E931\"}.mce-i-pluscircle:before{content:\"\\E932\"}.mce-i-info:before{content:\"\\E933\"}.mce-i-notice:before{content:\"\\E934\"}.mce-i-arrowup:before{content:\"\\E93B\"}.mce-i-arrowdown:before{content:\"\\E93D\"}.mce-i-arrowup2:before{content:\"\\E93F\"}.mce-i-arrowdown2:before{content:\"\\E940\"}.mce-i-menu2:before{content:\"\\E941\"}.mce-i-newtab:before{content:\"\\E961\"}.mce-i-a11y:before{content:\"\\E900\"}.mce-i-plus:before{content:\"\\E93A\"}.mce-i-minus:before{content:\"\\E939\"}.mce-i-books:before{content:\"\\E911\"}.mce-i-checkbox:before,.mce-i-checkmark:before,.mce-i-selected:before{content:\"\\E033\"}.mce-i-selected{visibility:hidden}i.mce-i-backcolor{text-shadow:none;background:#bbb}.hidden{visibility:hidden!important}.visible{visibility:visible!important;display:block!important}#edit-image{position:absolute;padding:10px;margin:0}#edit-embed,#edit-gallery,#edit-summary{position:absolute;margin:0;display:flex}body.bbc .mce-i-editimage{display:none!important}img::selection{background-color:transparent}img::-moz-selection{background-color:transparent}#edit-image .mce-i-cut,.mce-i-cut,.mce-i-editgallery,.mce-i-editimage,.mce-i-editsummary,.mce-i-remove,.mce-i-remove-embed,.mce-i-remove-gallery,.mce-i-remove-summary{font-size:24px;color:#fff;background-color:#000;width:35px;height:35px;margin-right:5px;line-height:35px;text-align:center;cursor:pointer}#edit-embed i:last-child,#edit-gallery i:last-child{margin-right:0}.mce-i-cut,.mce-i-editgallery,.mce-i-editsummary,.mce-i-remove-embed,.mce-i-remove-gallery,.mce-i-remove-summary{width:20px;height:18px;font-size:14px;line-height:18px}#edit-embed{z-index:1}#edit-embed .mce-i-cut,.mce-i-remove-embed{height:24px;line-height:24px;width:24px;cursor:pointer;font-size:14px;font-weight:700}.mce-i-editgallery:before,.mce-i-editsummary:before{content:\"\\E915\"}.mce-i-remove-embed:before,.mce-i-remove-gallery:before,.mce-i-remove-summary:before{content:\"\\ED6A\"}.mce-i-cut:before{content:\"\\E007\"}captionblock{display:inline-block;background:#f0f0f0;padding:5px;font-size:14px;text-align:center;margin:.5em 1em .5rem 0;color:#333}captionblock a{color:#333;text-decoration:underline}captionblock img{margin-bottom:10px;max-width:100%;display:block;height:auto;margin-left:auto;margin-right:auto}galleryblock{line-height:18px;margin-right:60px;word-break:break-all}embedblock,galleryblock{display:inline-block;position:relative;margin:.5em 1em .5em 0}embedblock{min-height:48px;min-width:300px;text-align:center}summaryblock{display:block;margin:.5em 0;position:relative}embedblock:after{content:\"\";left:0;bottom:0;right:0;z-index:1;background:rgba(0,0,0,.2)}embedblock:after,embedblock:before{position:absolute;display:block;top:0}embedblock:before{content:\"Embed \" attr(type);left:50%;transform:translateX(-50%);z-index:2;color:#fff;font-weight:600;line-height:24px;padding:0 5px;background:#000;text-transform:capitalize}a{color:#00e}.mce-branding{display:none}blockquote{margin:0}@media screen and (min-width:700px){embedblock{margin-right:100px}}@media screen and (min-width:800px){embedblock{margin-right:200px}}@media screen and (min-width:900px){embedblock{margin-right:300px}}@media screen and (min-width:1000px){embedblock{margin-right:400px}}", ""]);
	
	// exports


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	/**
	 * Diff Match and Patch
	 * Copyright 2018 The diff-match-patch Authors.
	 * https://github.com/google/diff-match-patch
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * @fileoverview Computes the difference between two texts to create a patch.
	 * Applies the patch onto another text, allowing for errors.
	 * @author fraser@google.com (Neil Fraser)
	 */
	
	/**
	 * Class containing the diff, match and patch methods.
	 * @constructor
	 */
	var diff_match_patch = function() {
	
	  // Defaults.
	  // Redefine these in your program to override the defaults.
	
	  // Number of seconds to map a diff before giving up (0 for infinity).
	  this.Diff_Timeout = 1.0;
	  // Cost of an empty edit operation in terms of edit characters.
	  this.Diff_EditCost = 4;
	  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
	  this.Match_Threshold = 0.5;
	  // How far to search for a match (0 = exact location, 1000+ = broad match).
	  // A match this many characters away from the expected location will add
	  // 1.0 to the score (0.0 is a perfect match).
	  this.Match_Distance = 1000;
	  // When deleting a large block of text (over ~64 characters), how close do
	  // the contents have to be to match the expected contents. (0.0 = perfection,
	  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
	  // end points of a delete need to match.
	  this.Patch_DeleteThreshold = 0.5;
	  // Chunk size for context length.
	  this.Patch_Margin = 4;
	
	  // The number of bits in an int.
	  this.Match_MaxBits = 32;
	};
	
	
	//  DIFF FUNCTIONS
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	/**
	 * Class representing one diff tuple.
	 * ~Attempts to look like a two-element array (which is what this used to be).~
	 * Constructor returns an actual two-element array, to allow destructing @JackuB
	 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
	 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
	 * @param {string} text Text to be deleted, inserted, or retained.
	 * @constructor
	 */
	diff_match_patch.Diff = function(op, text) {
	  return [op, text];
	};
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
	 *     then don't run a line-level diff first to identify the changed areas.
	 *     Defaults to true, which does a faster, slightly less optimal diff.
	 * @param {number=} opt_deadline Optional time when the diff should be complete
	 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
	 *     instead.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
	    opt_deadline) {
	  // Set a deadline by which time the diff must be complete.
	  if (typeof opt_deadline == 'undefined') {
	    if (this.Diff_Timeout <= 0) {
	      opt_deadline = Number.MAX_VALUE;
	    } else {
	      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
	    }
	  }
	  var deadline = opt_deadline;
	
	  // Check for null inputs.
	  if (text1 == null || text2 == null) {
	    throw new Error('Null input. (diff_main)');
	  }
	
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [new diff_match_patch.Diff(DIFF_EQUAL, text1)];
	    }
	    return [];
	  }
	
	  if (typeof opt_checklines == 'undefined') {
	    opt_checklines = true;
	  }
	  var checklines = opt_checklines;
	
	  // Trim off common prefix (speedup).
	  var commonlength = this.diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = this.diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = this.diff_compute_(text1, text2, checklines, deadline);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, commonprefix));
	  }
	  if (commonsuffix) {
	    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, commonsuffix));
	  }
	  this.diff_cleanupMerge(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {boolean} checklines Speedup flag.  If false, then don't run a
	 *     line-level diff first to identify the changed areas.
	 *     If true, then run a faster, slightly less optimal diff.
	 * @param {number} deadline Time when the diff should be complete by.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
	    deadline) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [new diff_match_patch.Diff(DIFF_INSERT, text2)];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [new diff_match_patch.Diff(DIFF_DELETE, text1)];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [new diff_match_patch.Diff(DIFF_INSERT, longtext.substring(0, i)),
	             new diff_match_patch.Diff(DIFF_EQUAL, shorttext),
	             new diff_match_patch.Diff(DIFF_INSERT,
	                 longtext.substring(i + shorttext.length))];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [new diff_match_patch.Diff(DIFF_DELETE, text1),
	            new diff_match_patch.Diff(DIFF_INSERT, text2)];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = this.diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
	    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
	    // Merge the results.
	    return diffs_a.concat([new diff_match_patch.Diff(DIFF_EQUAL, mid_common)],
	                          diffs_b);
	  }
	
	  if (checklines && text1.length > 100 && text2.length > 100) {
	    return this.diff_lineMode_(text1, text2, deadline);
	  }
	
	  return this.diff_bisect_(text1, text2, deadline);
	};
	
	
	/**
	 * Do a quick line-level diff on both strings, then rediff the parts for
	 * greater accuracy.
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} deadline Time when the diff should be complete by.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
	  // Scan the text on a line-by-line basis first.
	  var a = this.diff_linesToChars_(text1, text2);
	  text1 = a.chars1;
	  text2 = a.chars2;
	  var linearray = a.lineArray;
	
	  var diffs = this.diff_main(text1, text2, false, deadline);
	
	  // Convert the diff back to original text.
	  this.diff_charsToLines_(diffs, linearray);
	  // Eliminate freak matches (e.g. blank lines)
	  this.diff_cleanupSemantic(diffs);
	
	  // Rediff any replacement blocks, this time character-by-character.
	  // Add a dummy entry at the end.
	  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete >= 1 && count_insert >= 1) {
	          // Delete the offending records and add the merged ones.
	          diffs.splice(pointer - count_delete - count_insert,
	                       count_delete + count_insert);
	          pointer = pointer - count_delete - count_insert;
	          var subDiff =
	              this.diff_main(text_delete, text_insert, false, deadline);
	          for (var j = subDiff.length - 1; j >= 0; j--) {
	            diffs.splice(pointer, 0, subDiff[j]);
	          }
	          pointer = pointer + subDiff.length;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	    pointer++;
	  }
	  diffs.pop();  // Remove the dummy entry at the end.
	
	  return diffs;
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} deadline Time at which to bail if not yet complete.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Bail out if deadline is reached.
	    if ((new Date()).getTime() > deadline) {
	      break;
	    }
	
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [new diff_match_patch.Diff(DIFF_DELETE, text1),
	          new diff_match_patch.Diff(DIFF_INSERT, text2)];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @param {number} deadline Time at which to bail if not yet complete.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @private
	 */
	diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
	    deadline) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = this.diff_main(text1a, text2a, false, deadline);
	  var diffsb = this.diff_main(text1b, text2b, false, deadline);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Split two texts into an array of strings.  Reduce the texts to a string of
	 * hashes where each Unicode character represents one line.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
	 *     An object containing the encoded text1, the encoded text2 and
	 *     the array of unique strings.
	 *     The zeroth element of the array of unique strings is intentionally blank.
	 * @private
	 */
	diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
	  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
	  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4
	
	  // '\x00' is a valid character, but various debuggers don't like it.
	  // So we'll insert a junk entry to avoid generating a null character.
	  lineArray[0] = '';
	
	  /**
	   * Split a text into an array of strings.  Reduce the texts to a string of
	   * hashes where each Unicode character represents one line.
	   * Modifies linearray and linehash through being a closure.
	   * @param {string} text String to encode.
	   * @return {string} Encoded string.
	   * @private
	   */
	  function diff_linesToCharsMunge_(text) {
	    var chars = '';
	    // Walk the text, pulling out a substring for each line.
	    // text.split('\n') would would temporarily double our memory footprint.
	    // Modifying text would create many large strings to garbage collect.
	    var lineStart = 0;
	    var lineEnd = -1;
	    // Keeping our own length variable is faster than looking it up.
	    var lineArrayLength = lineArray.length;
	    while (lineEnd < text.length - 1) {
	      lineEnd = text.indexOf('\n', lineStart);
	      if (lineEnd == -1) {
	        lineEnd = text.length - 1;
	      }
	      var line = text.substring(lineStart, lineEnd + 1);
	
	      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
	          (lineHash[line] !== undefined)) {
	        chars += String.fromCharCode(lineHash[line]);
	      } else {
	        if (lineArrayLength == maxLines) {
	          // Bail out at 65535 because
	          // String.fromCharCode(65536) == String.fromCharCode(0)
	          line = text.substring(lineStart);
	          lineEnd = text.length;
	        }
	        chars += String.fromCharCode(lineArrayLength);
	        lineHash[line] = lineArrayLength;
	        lineArray[lineArrayLength++] = line;
	      }
	      lineStart = lineEnd + 1;
	    }
	    return chars;
	  }
	  // Allocate 2/3rds of the space for text1, the rest for text2.
	  var maxLines = 40000;
	  var chars1 = diff_linesToCharsMunge_(text1);
	  maxLines = 65535;
	  var chars2 = diff_linesToCharsMunge_(text2);
	  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
	};
	
	
	/**
	 * Rehydrate the text in a diff from a string of line hashes to real lines of
	 * text.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @param {!Array.<string>} lineArray Array of unique strings.
	 * @private
	 */
	diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
	  for (var i = 0; i < diffs.length; i++) {
	    var chars = diffs[i][1];
	    var text = [];
	    for (var j = 0; j < chars.length; j++) {
	      text[j] = lineArray[chars.charCodeAt(j)];
	    }
	    diffs[i][1] = text.join('');
	  }
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine if the suffix of one string is the prefix of another.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of the first
	 *     string and the start of the second string.
	 * @private
	 */
	diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  // Eliminate the null case.
	  if (text1_length == 0 || text2_length == 0) {
	    return 0;
	  }
	  // Truncate the longer string.
	  if (text1_length > text2_length) {
	    text1 = text1.substring(text1_length - text2_length);
	  } else if (text1_length < text2_length) {
	    text2 = text2.substring(0, text1_length);
	  }
	  var text_length = Math.min(text1_length, text2_length);
	  // Quick check for the worst case.
	  if (text1 == text2) {
	    return text_length;
	  }
	
	  // Start by looking for a single character match
	  // and increase length until no match is found.
	  // Performance analysis: https://neil.fraser.name/news/2010/11/04/
	  var best = 0;
	  var length = 1;
	  while (true) {
	    var pattern = text1.substring(text_length - length);
	    var found = text2.indexOf(pattern);
	    if (found == -1) {
	      return best;
	    }
	    length += found;
	    if (found == 0 || text1.substring(text_length - length) ==
	        text2.substring(0, length)) {
	      best = length;
	      length++;
	    }
	  }
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 * @private
	 */
	diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
	  if (this.Diff_Timeout <= 0) {
	    // Don't risk returning a non-optimal diff if we have unlimited time.
	    return null;
	  }
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	  var dmp = this;  // 'this' becomes 'window' in a closure.
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
	                                               shorttext.substring(j));
	      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
	                                               shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reduce the number of edits by eliminating semantically trivial equalities.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
	  var changes = false;
	  var equalities = [];  // Stack of indices where equalities are found.
	  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
	  /** @type {?string} */
	  var lastEquality = null;
	  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
	  var pointer = 0;  // Index of current position.
	  // Number of characters that changed prior to the equality.
	  var length_insertions1 = 0;
	  var length_deletions1 = 0;
	  // Number of characters that changed after the equality.
	  var length_insertions2 = 0;
	  var length_deletions2 = 0;
	  while (pointer < diffs.length) {
	    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
	      equalities[equalitiesLength++] = pointer;
	      length_insertions1 = length_insertions2;
	      length_deletions1 = length_deletions2;
	      length_insertions2 = 0;
	      length_deletions2 = 0;
	      lastEquality = diffs[pointer][1];
	    } else {  // An insertion or deletion.
	      if (diffs[pointer][0] == DIFF_INSERT) {
	        length_insertions2 += diffs[pointer][1].length;
	      } else {
	        length_deletions2 += diffs[pointer][1].length;
	      }
	      // Eliminate an equality that is smaller or equal to the edits on both
	      // sides of it.
	      if (lastEquality && (lastEquality.length <=
	          Math.max(length_insertions1, length_deletions1)) &&
	          (lastEquality.length <= Math.max(length_insertions2,
	                                           length_deletions2))) {
	        // Duplicate record.
	        diffs.splice(equalities[equalitiesLength - 1], 0,
	                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
	        // Change second copy to insert.
	        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
	        // Throw away the equality we just deleted.
	        equalitiesLength--;
	        // Throw away the previous equality (it needs to be reevaluated).
	        equalitiesLength--;
	        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
	        length_insertions1 = 0;  // Reset the counters.
	        length_deletions1 = 0;
	        length_insertions2 = 0;
	        length_deletions2 = 0;
	        lastEquality = null;
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	
	  // Normalize the diff.
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	  this.diff_cleanupSemanticLossless(diffs);
	
	  // Find any overlaps between deletions and insertions.
	  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
	  //   -> <del>abc</del>xxx<ins>def</ins>
	  // e.g: <del>xxxabc</del><ins>defxxx</ins>
	  //   -> <ins>def</ins>xxx<del>abc</del>
	  // Only extract an overlap if it is as big as the edit ahead or behind it.
	  pointer = 1;
	  while (pointer < diffs.length) {
	    if (diffs[pointer - 1][0] == DIFF_DELETE &&
	        diffs[pointer][0] == DIFF_INSERT) {
	      var deletion = diffs[pointer - 1][1];
	      var insertion = diffs[pointer][1];
	      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
	      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
	      if (overlap_length1 >= overlap_length2) {
	        if (overlap_length1 >= deletion.length / 2 ||
	            overlap_length1 >= insertion.length / 2) {
	          // Overlap found.  Insert an equality and trim the surrounding edits.
	          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
	              insertion.substring(0, overlap_length1)));
	          diffs[pointer - 1][1] =
	              deletion.substring(0, deletion.length - overlap_length1);
	          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
	          pointer++;
	        }
	      } else {
	        if (overlap_length2 >= deletion.length / 2 ||
	            overlap_length2 >= insertion.length / 2) {
	          // Reverse overlap found.
	          // Insert an equality and swap and trim the surrounding edits.
	          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
	              deletion.substring(0, overlap_length2)));
	          diffs[pointer - 1][0] = DIFF_INSERT;
	          diffs[pointer - 1][1] =
	              insertion.substring(0, insertion.length - overlap_length2);
	          diffs[pointer + 1][0] = DIFF_DELETE;
	          diffs[pointer + 1][1] =
	              deletion.substring(overlap_length2);
	          pointer++;
	        }
	      }
	      pointer++;
	    }
	    pointer++;
	  }
	};
	
	
	/**
	 * Look for single edits surrounded on both sides by equalities
	 * which can be shifted sideways to align the edit to a word boundary.
	 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
	  /**
	   * Given two strings, compute a score representing whether the internal
	   * boundary falls on logical boundaries.
	   * Scores range from 6 (best) to 0 (worst).
	   * Closure, but does not reference any external variables.
	   * @param {string} one First string.
	   * @param {string} two Second string.
	   * @return {number} The score.
	   * @private
	   */
	  function diff_cleanupSemanticScore_(one, two) {
	    if (!one || !two) {
	      // Edges are the best.
	      return 6;
	    }
	
	    // Each port of this function behaves slightly differently due to
	    // subtle differences in each language's definition of things like
	    // 'whitespace'.  Since this function's purpose is largely cosmetic,
	    // the choice has been made to use each language's native features
	    // rather than force total conformity.
	    var char1 = one.charAt(one.length - 1);
	    var char2 = two.charAt(0);
	    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
	    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
	    var whitespace1 = nonAlphaNumeric1 &&
	        char1.match(diff_match_patch.whitespaceRegex_);
	    var whitespace2 = nonAlphaNumeric2 &&
	        char2.match(diff_match_patch.whitespaceRegex_);
	    var lineBreak1 = whitespace1 &&
	        char1.match(diff_match_patch.linebreakRegex_);
	    var lineBreak2 = whitespace2 &&
	        char2.match(diff_match_patch.linebreakRegex_);
	    var blankLine1 = lineBreak1 &&
	        one.match(diff_match_patch.blanklineEndRegex_);
	    var blankLine2 = lineBreak2 &&
	        two.match(diff_match_patch.blanklineStartRegex_);
	
	    if (blankLine1 || blankLine2) {
	      // Five points for blank lines.
	      return 5;
	    } else if (lineBreak1 || lineBreak2) {
	      // Four points for line breaks.
	      return 4;
	    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
	      // Three points for end of sentences.
	      return 3;
	    } else if (whitespace1 || whitespace2) {
	      // Two points for whitespace.
	      return 2;
	    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
	      // One point for non-alphanumeric.
	      return 1;
	    }
	    return 0;
	  }
	
	  var pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      var equality1 = diffs[pointer - 1][1];
	      var edit = diffs[pointer][1];
	      var equality2 = diffs[pointer + 1][1];
	
	      // First, shift the edit as far left as possible.
	      var commonOffset = this.diff_commonSuffix(equality1, edit);
	      if (commonOffset) {
	        var commonString = edit.substring(edit.length - commonOffset);
	        equality1 = equality1.substring(0, equality1.length - commonOffset);
	        edit = commonString + edit.substring(0, edit.length - commonOffset);
	        equality2 = commonString + equality2;
	      }
	
	      // Second, step character by character right, looking for the best fit.
	      var bestEquality1 = equality1;
	      var bestEdit = edit;
	      var bestEquality2 = equality2;
	      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
	          diff_cleanupSemanticScore_(edit, equality2);
	      while (edit.charAt(0) === equality2.charAt(0)) {
	        equality1 += edit.charAt(0);
	        edit = edit.substring(1) + equality2.charAt(0);
	        equality2 = equality2.substring(1);
	        var score = diff_cleanupSemanticScore_(equality1, edit) +
	            diff_cleanupSemanticScore_(edit, equality2);
	        // The >= encourages trailing rather than leading whitespace on edits.
	        if (score >= bestScore) {
	          bestScore = score;
	          bestEquality1 = equality1;
	          bestEdit = edit;
	          bestEquality2 = equality2;
	        }
	      }
	
	      if (diffs[pointer - 1][1] != bestEquality1) {
	        // We have an improvement, save it back to the diff.
	        if (bestEquality1) {
	          diffs[pointer - 1][1] = bestEquality1;
	        } else {
	          diffs.splice(pointer - 1, 1);
	          pointer--;
	        }
	        diffs[pointer][1] = bestEdit;
	        if (bestEquality2) {
	          diffs[pointer + 1][1] = bestEquality2;
	        } else {
	          diffs.splice(pointer + 1, 1);
	          pointer--;
	        }
	      }
	    }
	    pointer++;
	  }
	};
	
	// Define some regex patterns for matching boundaries.
	diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
	diff_match_patch.whitespaceRegex_ = /\s/;
	diff_match_patch.linebreakRegex_ = /[\r\n]/;
	diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
	diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;
	
	/**
	 * Reduce the number of edits by eliminating operationally trivial equalities.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
	  var changes = false;
	  var equalities = [];  // Stack of indices where equalities are found.
	  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
	  /** @type {?string} */
	  var lastEquality = null;
	  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
	  var pointer = 0;  // Index of current position.
	  // Is there an insertion operation before the last equality.
	  var pre_ins = false;
	  // Is there a deletion operation before the last equality.
	  var pre_del = false;
	  // Is there an insertion operation after the last equality.
	  var post_ins = false;
	  // Is there a deletion operation after the last equality.
	  var post_del = false;
	  while (pointer < diffs.length) {
	    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
	      if (diffs[pointer][1].length < this.Diff_EditCost &&
	          (post_ins || post_del)) {
	        // Candidate found.
	        equalities[equalitiesLength++] = pointer;
	        pre_ins = post_ins;
	        pre_del = post_del;
	        lastEquality = diffs[pointer][1];
	      } else {
	        // Not a candidate, and can never become one.
	        equalitiesLength = 0;
	        lastEquality = null;
	      }
	      post_ins = post_del = false;
	    } else {  // An insertion or deletion.
	      if (diffs[pointer][0] == DIFF_DELETE) {
	        post_del = true;
	      } else {
	        post_ins = true;
	      }
	      /*
	       * Five types to be split:
	       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
	       * <ins>A</ins>X<ins>C</ins><del>D</del>
	       * <ins>A</ins><del>B</del>X<ins>C</ins>
	       * <ins>A</del>X<ins>C</ins><del>D</del>
	       * <ins>A</ins><del>B</del>X<del>C</del>
	       */
	      if (lastEquality && ((pre_ins && pre_del && post_ins && post_del) ||
	                           ((lastEquality.length < this.Diff_EditCost / 2) &&
	                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
	        // Duplicate record.
	        diffs.splice(equalities[equalitiesLength - 1], 0,
	                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
	        // Change second copy to insert.
	        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
	        equalitiesLength--;  // Throw away the equality we just deleted;
	        lastEquality = null;
	        if (pre_ins && pre_del) {
	          // No changes made which could affect previous entry, keep going.
	          post_ins = post_del = true;
	          equalitiesLength = 0;
	        } else {
	          equalitiesLength--;  // Throw away the previous equality.
	          pointer = equalitiesLength > 0 ?
	              equalities[equalitiesLength - 1] : -1;
	          post_ins = post_del = false;
	        }
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
	  // Add a dummy entry at the end.
	  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = this.diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, new diff_match_patch.Diff(DIFF_EQUAL,
	                    text_insert.substring(0, commonlength)));
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = this.diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          pointer -= count_delete + count_insert;
	          diffs.splice(pointer, count_delete + count_insert);
	          if (text_delete.length) {
	            diffs.splice(pointer, 0,
	                new diff_match_patch.Diff(DIFF_DELETE, text_delete));
	            pointer++;
	          }
	          if (text_insert.length) {
	            diffs.splice(pointer, 0,
	                new diff_match_patch.Diff(DIFF_INSERT, text_insert));
	            pointer++;
	          }
	          pointer++;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    this.diff_cleanupMerge(diffs);
	  }
	};
	
	
	/**
	 * loc is a location in text1, compute and return the equivalent location in
	 * text2.
	 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @param {number} loc Location within text1.
	 * @return {number} Location within text2.
	 */
	diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
	  var chars1 = 0;
	  var chars2 = 0;
	  var last_chars1 = 0;
	  var last_chars2 = 0;
	  var x;
	  for (x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
	      chars1 += diffs[x][1].length;
	    }
	    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
	      chars2 += diffs[x][1].length;
	    }
	    if (chars1 > loc) {  // Overshot the location.
	      break;
	    }
	    last_chars1 = chars1;
	    last_chars2 = chars2;
	  }
	  // Was the location was deleted?
	  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
	    return last_chars2;
	  }
	  // Add the remaining character length.
	  return last_chars2 + (loc - last_chars1);
	};
	
	
	/**
	 * Convert a diff array into a pretty HTML report.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} HTML representation.
	 */
	diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
	  var html = [];
	  var pattern_amp = /&/g;
	  var pattern_lt = /</g;
	  var pattern_gt = />/g;
	  var pattern_para = /\n/g;
	  for (var x = 0; x < diffs.length; x++) {
	    var op = diffs[x][0];    // Operation (insert, delete, equal)
	    var data = diffs[x][1];  // Text of change.
	    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
	        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
	    switch (op) {
	      case DIFF_INSERT:
	        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
	        break;
	      case DIFF_DELETE:
	        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
	        break;
	      case DIFF_EQUAL:
	        html[x] = '<span>' + text + '</span>';
	        break;
	    }
	  }
	  return html.join('');
	};
	
	
	/**
	 * Compute and return the source text (all equalities and deletions).
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Source text.
	 */
	diff_match_patch.prototype.diff_text1 = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_INSERT) {
	      text[x] = diffs[x][1];
	    }
	  }
	  return text.join('');
	};
	
	
	/**
	 * Compute and return the destination text (all equalities and insertions).
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Destination text.
	 */
	diff_match_patch.prototype.diff_text2 = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    if (diffs[x][0] !== DIFF_DELETE) {
	      text[x] = diffs[x][1];
	    }
	  }
	  return text.join('');
	};
	
	
	/**
	 * Compute the Levenshtein distance; the number of inserted, deleted or
	 * substituted characters.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {number} Number of changes.
	 */
	diff_match_patch.prototype.diff_levenshtein = function(diffs) {
	  var levenshtein = 0;
	  var insertions = 0;
	  var deletions = 0;
	  for (var x = 0; x < diffs.length; x++) {
	    var op = diffs[x][0];
	    var data = diffs[x][1];
	    switch (op) {
	      case DIFF_INSERT:
	        insertions += data.length;
	        break;
	      case DIFF_DELETE:
	        deletions += data.length;
	        break;
	      case DIFF_EQUAL:
	        // A deletion and an insertion is one substitution.
	        levenshtein += Math.max(insertions, deletions);
	        insertions = 0;
	        deletions = 0;
	        break;
	    }
	  }
	  levenshtein += Math.max(insertions, deletions);
	  return levenshtein;
	};
	
	
	/**
	 * Crush the diff into an encoded string which describes the operations
	 * required to transform text1 into text2.
	 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
	 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 * @return {string} Delta text.
	 */
	diff_match_patch.prototype.diff_toDelta = function(diffs) {
	  var text = [];
	  for (var x = 0; x < diffs.length; x++) {
	    switch (diffs[x][0]) {
	      case DIFF_INSERT:
	        text[x] = '+' + encodeURI(diffs[x][1]);
	        break;
	      case DIFF_DELETE:
	        text[x] = '-' + diffs[x][1].length;
	        break;
	      case DIFF_EQUAL:
	        text[x] = '=' + diffs[x][1].length;
	        break;
	    }
	  }
	  return text.join('\t').replace(/%20/g, ' ');
	};
	
	
	/**
	 * Given the original text1, and an encoded string which describes the
	 * operations required to transform text1 into text2, compute the full diff.
	 * @param {string} text1 Source string for the diff.
	 * @param {string} delta Delta text.
	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
	 * @throws {!Error} If invalid input.
	 */
	diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
	  var diffs = [];
	  var diffsLength = 0;  // Keeping our own length var is faster in JS.
	  var pointer = 0;  // Cursor in text1
	  var tokens = delta.split(/\t/g);
	  for (var x = 0; x < tokens.length; x++) {
	    // Each token begins with a one character parameter which specifies the
	    // operation of this token (delete, insert, equality).
	    var param = tokens[x].substring(1);
	    switch (tokens[x].charAt(0)) {
	      case '+':
	        try {
	          diffs[diffsLength++] =
	              new diff_match_patch.Diff(DIFF_INSERT, decodeURI(param));
	        } catch (ex) {
	          // Malformed URI sequence.
	          throw new Error('Illegal escape in diff_fromDelta: ' + param);
	        }
	        break;
	      case '-':
	        // Fall through.
	      case '=':
	        var n = parseInt(param, 10);
	        if (isNaN(n) || n < 0) {
	          throw new Error('Invalid number in diff_fromDelta: ' + param);
	        }
	        var text = text1.substring(pointer, pointer += n);
	        if (tokens[x].charAt(0) == '=') {
	          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_EQUAL, text);
	        } else {
	          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_DELETE, text);
	        }
	        break;
	      default:
	        // Blank tokens are ok (from a trailing \t).
	        // Anything else is an error.
	        if (tokens[x]) {
	          throw new Error('Invalid diff operation in diff_fromDelta: ' +
	                          tokens[x]);
	        }
	    }
	  }
	  if (pointer != text1.length) {
	    throw new Error('Delta length (' + pointer +
	        ') does not equal source text length (' + text1.length + ').');
	  }
	  return diffs;
	};
	
	
	//  MATCH FUNCTIONS
	
	
	/**
	 * Locate the best instance of 'pattern' in 'text' near 'loc'.
	 * @param {string} text The text to search.
	 * @param {string} pattern The pattern to search for.
	 * @param {number} loc The location to search around.
	 * @return {number} Best match index or -1.
	 */
	diff_match_patch.prototype.match_main = function(text, pattern, loc) {
	  // Check for null inputs.
	  if (text == null || pattern == null || loc == null) {
	    throw new Error('Null input. (match_main)');
	  }
	
	  loc = Math.max(0, Math.min(loc, text.length));
	  if (text == pattern) {
	    // Shortcut (potentially not guaranteed by the algorithm)
	    return 0;
	  } else if (!text.length) {
	    // Nothing to match.
	    return -1;
	  } else if (text.substring(loc, loc + pattern.length) == pattern) {
	    // Perfect match at the perfect spot!  (Includes case of null pattern)
	    return loc;
	  } else {
	    // Do a fuzzy compare.
	    return this.match_bitap_(text, pattern, loc);
	  }
	};
	
	
	/**
	 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
	 * Bitap algorithm.
	 * @param {string} text The text to search.
	 * @param {string} pattern The pattern to search for.
	 * @param {number} loc The location to search around.
	 * @return {number} Best match index or -1.
	 * @private
	 */
	diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
	  if (pattern.length > this.Match_MaxBits) {
	    throw new Error('Pattern too long for this browser.');
	  }
	
	  // Initialise the alphabet.
	  var s = this.match_alphabet_(pattern);
	
	  var dmp = this;  // 'this' becomes 'window' in a closure.
	
	  /**
	   * Compute and return the score for a match with e errors and x location.
	   * Accesses loc and pattern through being a closure.
	   * @param {number} e Number of errors in match.
	   * @param {number} x Location of match.
	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
	   * @private
	   */
	  function match_bitapScore_(e, x) {
	    var accuracy = e / pattern.length;
	    var proximity = Math.abs(loc - x);
	    if (!dmp.Match_Distance) {
	      // Dodge divide by zero error.
	      return proximity ? 1.0 : accuracy;
	    }
	    return accuracy + (proximity / dmp.Match_Distance);
	  }
	
	  // Highest score beyond which we give up.
	  var score_threshold = this.Match_Threshold;
	  // Is there a nearby exact match? (speedup)
	  var best_loc = text.indexOf(pattern, loc);
	  if (best_loc != -1) {
	    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
	    // What about in the other direction? (speedup)
	    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
	    if (best_loc != -1) {
	      score_threshold =
	          Math.min(match_bitapScore_(0, best_loc), score_threshold);
	    }
	  }
	
	  // Initialise the bit arrays.
	  var matchmask = 1 << (pattern.length - 1);
	  best_loc = -1;
	
	  var bin_min, bin_mid;
	  var bin_max = pattern.length + text.length;
	  var last_rd;
	  for (var d = 0; d < pattern.length; d++) {
	    // Scan for the best match; each iteration allows for one more error.
	    // Run a binary search to determine how far from 'loc' we can stray at this
	    // error level.
	    bin_min = 0;
	    bin_mid = bin_max;
	    while (bin_min < bin_mid) {
	      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
	        bin_min = bin_mid;
	      } else {
	        bin_max = bin_mid;
	      }
	      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
	    }
	    // Use the result from this iteration as the maximum for the next.
	    bin_max = bin_mid;
	    var start = Math.max(1, loc - bin_mid + 1);
	    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
	
	    var rd = Array(finish + 2);
	    rd[finish + 1] = (1 << d) - 1;
	    for (var j = finish; j >= start; j--) {
	      // The alphabet (s) is a sparse hash, so the following line generates
	      // warnings.
	      var charMatch = s[text.charAt(j - 1)];
	      if (d === 0) {  // First pass: exact match.
	        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
	      } else {  // Subsequent passes: fuzzy match.
	        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
	                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
	                last_rd[j + 1];
	      }
	      if (rd[j] & matchmask) {
	        var score = match_bitapScore_(d, j - 1);
	        // This match will almost certainly be better than any existing match.
	        // But check anyway.
	        if (score <= score_threshold) {
	          // Told you so.
	          score_threshold = score;
	          best_loc = j - 1;
	          if (best_loc > loc) {
	            // When passing loc, don't exceed our current distance from loc.
	            start = Math.max(1, 2 * loc - best_loc);
	          } else {
	            // Already passed loc, downhill from here on in.
	            break;
	          }
	        }
	      }
	    }
	    // No hope for a (better) match at greater error levels.
	    if (match_bitapScore_(d + 1, loc) > score_threshold) {
	      break;
	    }
	    last_rd = rd;
	  }
	  return best_loc;
	};
	
	
	/**
	 * Initialise the alphabet for the Bitap algorithm.
	 * @param {string} pattern The text to encode.
	 * @return {!Object} Hash of character locations.
	 * @private
	 */
	diff_match_patch.prototype.match_alphabet_ = function(pattern) {
	  var s = {};
	  for (var i = 0; i < pattern.length; i++) {
	    s[pattern.charAt(i)] = 0;
	  }
	  for (var i = 0; i < pattern.length; i++) {
	    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
	  }
	  return s;
	};
	
	
	//  PATCH FUNCTIONS
	
	
	/**
	 * Increase the context until it is unique,
	 * but don't let the pattern expand beyond Match_MaxBits.
	 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
	 * @param {string} text Source text.
	 * @private
	 */
	diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
	  if (text.length == 0) {
	    return;
	  }
	  if (patch.start2 === null) {
	    throw Error('patch not initialized');
	  }
	  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
	  var padding = 0;
	
	  // Look for the first and last matches of pattern in text.  If two different
	  // matches are found, increase the pattern length.
	  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
	         pattern.length < this.Match_MaxBits - this.Patch_Margin -
	         this.Patch_Margin) {
	    padding += this.Patch_Margin;
	    pattern = text.substring(patch.start2 - padding,
	                             patch.start2 + patch.length1 + padding);
	  }
	  // Add one chunk for good luck.
	  padding += this.Patch_Margin;
	
	  // Add the prefix.
	  var prefix = text.substring(patch.start2 - padding, patch.start2);
	  if (prefix) {
	    patch.diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, prefix));
	  }
	  // Add the suffix.
	  var suffix = text.substring(patch.start2 + patch.length1,
	                              patch.start2 + patch.length1 + padding);
	  if (suffix) {
	    patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, suffix));
	  }
	
	  // Roll back the start points.
	  patch.start1 -= prefix.length;
	  patch.start2 -= prefix.length;
	  // Extend the lengths.
	  patch.length1 += prefix.length + suffix.length;
	  patch.length2 += prefix.length + suffix.length;
	};
	
	
	/**
	 * Compute a list of patches to turn text1 into text2.
	 * Use diffs if provided, otherwise compute it ourselves.
	 * There are four ways to call this function, depending on what data is
	 * available to the caller:
	 * Method 1:
	 * a = text1, b = text2
	 * Method 2:
	 * a = diffs
	 * Method 3 (optimal):
	 * a = text1, b = diffs
	 * Method 4 (deprecated, use method 3):
	 * a = text1, b = text2, c = diffs
	 *
	 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
	 * Array of diff tuples for text1 to text2 (method 2).
	 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
	 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
	 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
	 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
	 */
	diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
	  var text1, diffs;
	  if (typeof a == 'string' && typeof opt_b == 'string' &&
	      typeof opt_c == 'undefined') {
	    // Method 1: text1, text2
	    // Compute diffs from text1 and text2.
	    text1 = /** @type {string} */(a);
	    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
	    if (diffs.length > 2) {
	      this.diff_cleanupSemantic(diffs);
	      this.diff_cleanupEfficiency(diffs);
	    }
	  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
	      typeof opt_c == 'undefined') {
	    // Method 2: diffs
	    // Compute text1 from diffs.
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
	    text1 = this.diff_text1(diffs);
	  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
	      typeof opt_c == 'undefined') {
	    // Method 3: text1, diffs
	    text1 = /** @type {string} */(a);
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
	  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
	      opt_c && typeof opt_c == 'object') {
	    // Method 4: text1, text2, diffs
	    // text2 is not used.
	    text1 = /** @type {string} */(a);
	    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
	  } else {
	    throw new Error('Unknown call format to patch_make.');
	  }
	
	  if (diffs.length === 0) {
	    return [];  // Get rid of the null case.
	  }
	  var patches = [];
	  var patch = new diff_match_patch.patch_obj();
	  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
	  var char_count1 = 0;  // Number of characters into the text1 string.
	  var char_count2 = 0;  // Number of characters into the text2 string.
	  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
	  // text2 (postpatch_text).  We recreate the patches one by one to determine
	  // context info.
	  var prepatch_text = text1;
	  var postpatch_text = text1;
	  for (var x = 0; x < diffs.length; x++) {
	    var diff_type = diffs[x][0];
	    var diff_text = diffs[x][1];
	
	    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
	      // A new patch starts here.
	      patch.start1 = char_count1;
	      patch.start2 = char_count2;
	    }
	
	    switch (diff_type) {
	      case DIFF_INSERT:
	        patch.diffs[patchDiffLength++] = diffs[x];
	        patch.length2 += diff_text.length;
	        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
	                         postpatch_text.substring(char_count2);
	        break;
	      case DIFF_DELETE:
	        patch.length1 += diff_text.length;
	        patch.diffs[patchDiffLength++] = diffs[x];
	        postpatch_text = postpatch_text.substring(0, char_count2) +
	                         postpatch_text.substring(char_count2 +
	                             diff_text.length);
	        break;
	      case DIFF_EQUAL:
	        if (diff_text.length <= 2 * this.Patch_Margin &&
	            patchDiffLength && diffs.length != x + 1) {
	          // Small equality inside a patch.
	          patch.diffs[patchDiffLength++] = diffs[x];
	          patch.length1 += diff_text.length;
	          patch.length2 += diff_text.length;
	        } else if (diff_text.length >= 2 * this.Patch_Margin) {
	          // Time for a new patch.
	          if (patchDiffLength) {
	            this.patch_addContext_(patch, prepatch_text);
	            patches.push(patch);
	            patch = new diff_match_patch.patch_obj();
	            patchDiffLength = 0;
	            // Unlike Unidiff, our patch lists have a rolling context.
	            // https://github.com/google/diff-match-patch/wiki/Unidiff
	            // Update prepatch text & pos to reflect the application of the
	            // just completed patch.
	            prepatch_text = postpatch_text;
	            char_count1 = char_count2;
	          }
	        }
	        break;
	    }
	
	    // Update the current character count.
	    if (diff_type !== DIFF_INSERT) {
	      char_count1 += diff_text.length;
	    }
	    if (diff_type !== DIFF_DELETE) {
	      char_count2 += diff_text.length;
	    }
	  }
	  // Pick up the leftover patch if not empty.
	  if (patchDiffLength) {
	    this.patch_addContext_(patch, prepatch_text);
	    patches.push(patch);
	  }
	
	  return patches;
	};
	
	
	/**
	 * Given an array of patches, return another array that is identical.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
	 */
	diff_match_patch.prototype.patch_deepCopy = function(patches) {
	  // Making deep copies is hard in JavaScript.
	  var patchesCopy = [];
	  for (var x = 0; x < patches.length; x++) {
	    var patch = patches[x];
	    var patchCopy = new diff_match_patch.patch_obj();
	    patchCopy.diffs = [];
	    for (var y = 0; y < patch.diffs.length; y++) {
	      patchCopy.diffs[y] =
	          new diff_match_patch.Diff(patch.diffs[y][0], patch.diffs[y][1]);
	    }
	    patchCopy.start1 = patch.start1;
	    patchCopy.start2 = patch.start2;
	    patchCopy.length1 = patch.length1;
	    patchCopy.length2 = patch.length2;
	    patchesCopy[x] = patchCopy;
	  }
	  return patchesCopy;
	};
	
	
	/**
	 * Merge a set of patches onto the text.  Return a patched text, as well
	 * as a list of true/false values indicating which patches were applied.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
	 * @param {string} text Old text.
	 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
	 *      new text and an array of boolean values.
	 */
	diff_match_patch.prototype.patch_apply = function(patches, text) {
	  if (patches.length == 0) {
	    return [text, []];
	  }
	
	  // Deep copy the patches so that no changes are made to originals.
	  patches = this.patch_deepCopy(patches);
	
	  var nullPadding = this.patch_addPadding(patches);
	  text = nullPadding + text + nullPadding;
	
	  this.patch_splitMax(patches);
	  // delta keeps track of the offset between the expected and actual location
	  // of the previous patch.  If there are patches expected at positions 10 and
	  // 20, but the first patch was found at 12, delta is 2 and the second patch
	  // has an effective expected position of 22.
	  var delta = 0;
	  var results = [];
	  for (var x = 0; x < patches.length; x++) {
	    var expected_loc = patches[x].start2 + delta;
	    var text1 = this.diff_text1(patches[x].diffs);
	    var start_loc;
	    var end_loc = -1;
	    if (text1.length > this.Match_MaxBits) {
	      // patch_splitMax will only provide an oversized pattern in the case of
	      // a monster delete.
	      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
	                                  expected_loc);
	      if (start_loc != -1) {
	        end_loc = this.match_main(text,
	            text1.substring(text1.length - this.Match_MaxBits),
	            expected_loc + text1.length - this.Match_MaxBits);
	        if (end_loc == -1 || start_loc >= end_loc) {
	          // Can't find valid trailing context.  Drop this patch.
	          start_loc = -1;
	        }
	      }
	    } else {
	      start_loc = this.match_main(text, text1, expected_loc);
	    }
	    if (start_loc == -1) {
	      // No match found.  :(
	      results[x] = false;
	      // Subtract the delta for this failed patch from subsequent patches.
	      delta -= patches[x].length2 - patches[x].length1;
	    } else {
	      // Found a match.  :)
	      results[x] = true;
	      delta = start_loc - expected_loc;
	      var text2;
	      if (end_loc == -1) {
	        text2 = text.substring(start_loc, start_loc + text1.length);
	      } else {
	        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
	      }
	      if (text1 == text2) {
	        // Perfect match, just shove the replacement text in.
	        text = text.substring(0, start_loc) +
	               this.diff_text2(patches[x].diffs) +
	               text.substring(start_loc + text1.length);
	      } else {
	        // Imperfect match.  Run a diff to get a framework of equivalent
	        // indices.
	        var diffs = this.diff_main(text1, text2, false);
	        if (text1.length > this.Match_MaxBits &&
	            this.diff_levenshtein(diffs) / text1.length >
	            this.Patch_DeleteThreshold) {
	          // The end points match, but the content is unacceptably bad.
	          results[x] = false;
	        } else {
	          this.diff_cleanupSemanticLossless(diffs);
	          var index1 = 0;
	          var index2;
	          for (var y = 0; y < patches[x].diffs.length; y++) {
	            var mod = patches[x].diffs[y];
	            if (mod[0] !== DIFF_EQUAL) {
	              index2 = this.diff_xIndex(diffs, index1);
	            }
	            if (mod[0] === DIFF_INSERT) {  // Insertion
	              text = text.substring(0, start_loc + index2) + mod[1] +
	                     text.substring(start_loc + index2);
	            } else if (mod[0] === DIFF_DELETE) {  // Deletion
	              text = text.substring(0, start_loc + index2) +
	                     text.substring(start_loc + this.diff_xIndex(diffs,
	                         index1 + mod[1].length));
	            }
	            if (mod[0] !== DIFF_DELETE) {
	              index1 += mod[1].length;
	            }
	          }
	        }
	      }
	    }
	  }
	  // Strip the padding off.
	  text = text.substring(nullPadding.length, text.length - nullPadding.length);
	  return [text, results];
	};
	
	
	/**
	 * Add some padding on text start and end so that edges can match something.
	 * Intended to be called only from within patch_apply.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
	 * @return {string} The padding string added to each side.
	 */
	diff_match_patch.prototype.patch_addPadding = function(patches) {
	  var paddingLength = this.Patch_Margin;
	  var nullPadding = '';
	  for (var x = 1; x <= paddingLength; x++) {
	    nullPadding += String.fromCharCode(x);
	  }
	
	  // Bump all the patches forward.
	  for (var x = 0; x < patches.length; x++) {
	    patches[x].start1 += paddingLength;
	    patches[x].start2 += paddingLength;
	  }
	
	  // Add some padding on start of first diff.
	  var patch = patches[0];
	  var diffs = patch.diffs;
	  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
	    // Add nullPadding equality.
	    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
	    patch.start1 -= paddingLength;  // Should be 0.
	    patch.start2 -= paddingLength;  // Should be 0.
	    patch.length1 += paddingLength;
	    patch.length2 += paddingLength;
	  } else if (paddingLength > diffs[0][1].length) {
	    // Grow first equality.
	    var extraLength = paddingLength - diffs[0][1].length;
	    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
	    patch.start1 -= extraLength;
	    patch.start2 -= extraLength;
	    patch.length1 += extraLength;
	    patch.length2 += extraLength;
	  }
	
	  // Add some padding on end of last diff.
	  patch = patches[patches.length - 1];
	  diffs = patch.diffs;
	  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
	    // Add nullPadding equality.
	    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
	    patch.length1 += paddingLength;
	    patch.length2 += paddingLength;
	  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
	    // Grow last equality.
	    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
	    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
	    patch.length1 += extraLength;
	    patch.length2 += extraLength;
	  }
	
	  return nullPadding;
	};
	
	
	/**
	 * Look through the patches and break up any which are longer than the maximum
	 * limit of the match algorithm.
	 * Intended to be called only from within patch_apply.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
	 */
	diff_match_patch.prototype.patch_splitMax = function(patches) {
	  var patch_size = this.Match_MaxBits;
	  for (var x = 0; x < patches.length; x++) {
	    if (patches[x].length1 <= patch_size) {
	      continue;
	    }
	    var bigpatch = patches[x];
	    // Remove the big old patch.
	    patches.splice(x--, 1);
	    var start1 = bigpatch.start1;
	    var start2 = bigpatch.start2;
	    var precontext = '';
	    while (bigpatch.diffs.length !== 0) {
	      // Create one of several smaller patches.
	      var patch = new diff_match_patch.patch_obj();
	      var empty = true;
	      patch.start1 = start1 - precontext.length;
	      patch.start2 = start2 - precontext.length;
	      if (precontext !== '') {
	        patch.length1 = patch.length2 = precontext.length;
	        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, precontext));
	      }
	      while (bigpatch.diffs.length !== 0 &&
	             patch.length1 < patch_size - this.Patch_Margin) {
	        var diff_type = bigpatch.diffs[0][0];
	        var diff_text = bigpatch.diffs[0][1];
	        if (diff_type === DIFF_INSERT) {
	          // Insertions are harmless.
	          patch.length2 += diff_text.length;
	          start2 += diff_text.length;
	          patch.diffs.push(bigpatch.diffs.shift());
	          empty = false;
	        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
	                   patch.diffs[0][0] == DIFF_EQUAL &&
	                   diff_text.length > 2 * patch_size) {
	          // This is a large deletion.  Let it pass in one chunk.
	          patch.length1 += diff_text.length;
	          start1 += diff_text.length;
	          empty = false;
	          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
	          bigpatch.diffs.shift();
	        } else {
	          // Deletion or equality.  Only take as much as we can stomach.
	          diff_text = diff_text.substring(0,
	              patch_size - patch.length1 - this.Patch_Margin);
	          patch.length1 += diff_text.length;
	          start1 += diff_text.length;
	          if (diff_type === DIFF_EQUAL) {
	            patch.length2 += diff_text.length;
	            start2 += diff_text.length;
	          } else {
	            empty = false;
	          }
	          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
	          if (diff_text == bigpatch.diffs[0][1]) {
	            bigpatch.diffs.shift();
	          } else {
	            bigpatch.diffs[0][1] =
	                bigpatch.diffs[0][1].substring(diff_text.length);
	          }
	        }
	      }
	      // Compute the head context for the next patch.
	      precontext = this.diff_text2(patch.diffs);
	      precontext =
	          precontext.substring(precontext.length - this.Patch_Margin);
	      // Append the end context for this patch.
	      var postcontext = this.diff_text1(bigpatch.diffs)
	                            .substring(0, this.Patch_Margin);
	      if (postcontext !== '') {
	        patch.length1 += postcontext.length;
	        patch.length2 += postcontext.length;
	        if (patch.diffs.length !== 0 &&
	            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
	          patch.diffs[patch.diffs.length - 1][1] += postcontext;
	        } else {
	          patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, postcontext));
	        }
	      }
	      if (!empty) {
	        patches.splice(++x, 0, patch);
	      }
	    }
	  }
	};
	
	
	/**
	 * Take a list of patches and return a textual representation.
	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
	 * @return {string} Text representation of patches.
	 */
	diff_match_patch.prototype.patch_toText = function(patches) {
	  var text = [];
	  for (var x = 0; x < patches.length; x++) {
	    text[x] = patches[x];
	  }
	  return text.join('');
	};
	
	
	/**
	 * Parse a textual representation of patches and return a list of Patch objects.
	 * @param {string} textline Text representation of patches.
	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
	 * @throws {!Error} If invalid input.
	 */
	diff_match_patch.prototype.patch_fromText = function(textline) {
	  var patches = [];
	  if (!textline) {
	    return patches;
	  }
	  var text = textline.split('\n');
	  var textPointer = 0;
	  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
	  while (textPointer < text.length) {
	    var m = text[textPointer].match(patchHeader);
	    if (!m) {
	      throw new Error('Invalid patch string: ' + text[textPointer]);
	    }
	    var patch = new diff_match_patch.patch_obj();
	    patches.push(patch);
	    patch.start1 = parseInt(m[1], 10);
	    if (m[2] === '') {
	      patch.start1--;
	      patch.length1 = 1;
	    } else if (m[2] == '0') {
	      patch.length1 = 0;
	    } else {
	      patch.start1--;
	      patch.length1 = parseInt(m[2], 10);
	    }
	
	    patch.start2 = parseInt(m[3], 10);
	    if (m[4] === '') {
	      patch.start2--;
	      patch.length2 = 1;
	    } else if (m[4] == '0') {
	      patch.length2 = 0;
	    } else {
	      patch.start2--;
	      patch.length2 = parseInt(m[4], 10);
	    }
	    textPointer++;
	
	    while (textPointer < text.length) {
	      var sign = text[textPointer].charAt(0);
	      try {
	        var line = decodeURI(text[textPointer].substring(1));
	      } catch (ex) {
	        // Malformed URI sequence.
	        throw new Error('Illegal escape in patch_fromText: ' + line);
	      }
	      if (sign == '-') {
	        // Deletion.
	        patch.diffs.push(new diff_match_patch.Diff(DIFF_DELETE, line));
	      } else if (sign == '+') {
	        // Insertion.
	        patch.diffs.push(new diff_match_patch.Diff(DIFF_INSERT, line));
	      } else if (sign == ' ') {
	        // Minor equality.
	        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, line));
	      } else if (sign == '@') {
	        // Start of next patch.
	        break;
	      } else if (sign === '') {
	        // Blank line?  Whatever.
	      } else {
	        // WTF?
	        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
	      }
	      textPointer++;
	    }
	  }
	  return patches;
	};
	
	
	/**
	 * Class representing one patch operation.
	 * @constructor
	 */
	diff_match_patch.patch_obj = function() {
	  /** @type {!Array.<!diff_match_patch.Diff>} */
	  this.diffs = [];
	  /** @type {?number} */
	  this.start1 = null;
	  /** @type {?number} */
	  this.start2 = null;
	  /** @type {number} */
	  this.length1 = 0;
	  /** @type {number} */
	  this.length2 = 0;
	};
	
	
	/**
	 * Emulate GNU diff's format.
	 * Header: @@ -382,8 +481,9 @@
	 * Indices are printed as 1-based, not 0-based.
	 * @return {string} The GNU diff string.
	 */
	diff_match_patch.patch_obj.prototype.toString = function() {
	  var coords1, coords2;
	  if (this.length1 === 0) {
	    coords1 = this.start1 + ',0';
	  } else if (this.length1 == 1) {
	    coords1 = this.start1 + 1;
	  } else {
	    coords1 = (this.start1 + 1) + ',' + this.length1;
	  }
	  if (this.length2 === 0) {
	    coords2 = this.start2 + ',0';
	  } else if (this.length2 == 1) {
	    coords2 = this.start2 + 1;
	  } else {
	    coords2 = (this.start2 + 1) + ',' + this.length2;
	  }
	  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
	  var op;
	  // Escape the body of the patch with %xx notation.
	  for (var x = 0; x < this.diffs.length; x++) {
	    switch (this.diffs[x][0]) {
	      case DIFF_INSERT:
	        op = '+';
	        break;
	      case DIFF_DELETE:
	        op = '-';
	        break;
	      case DIFF_EQUAL:
	        op = ' ';
	        break;
	    }
	    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
	  }
	  return text.join('').replace(/%20/g, ' ');
	};
	
	
	// The following export code was added by @ForbesLindesay
	module.exports = diff_match_patch;
	module.exports['diff_match_patch'] = diff_match_patch;
	module.exports['DIFF_DELETE'] = DIFF_DELETE;
	module.exports['DIFF_INSERT'] = DIFF_INSERT;
	module.exports['DIFF_EQUAL'] = DIFF_EQUAL;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/******************************************************************************
	 * Created 2008-08-19.
	 *
	 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
	 *
	 * Copyright (C) 2008
	 *   Wyatt Baldwin <self@wyattbaldwin.com>
	 *   All rights reserved
	 *
	 * Licensed under the MIT license.
	 *
	 *   http://www.opensource.org/licenses/mit-license.php
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *****************************************************************************/
	var dijkstra = {
	  single_source_shortest_paths: function(graph, s, d) {
	    // Predecessor map for each node that has been encountered.
	    // node ID => predecessor node ID
	    var predecessors = {};
	
	    // Costs of shortest paths from s to all nodes encountered.
	    // node ID => cost
	    var costs = {};
	    costs[s] = 0;
	
	    // Costs of shortest paths from s to all nodes encountered; differs from
	    // `costs` in that it provides easy access to the node that currently has
	    // the known shortest path from s.
	    // XXX: Do we actually need both `costs` and `open`?
	    var open = dijkstra.PriorityQueue.make();
	    open.push(s, 0);
	
	    var closest,
	        u, v,
	        cost_of_s_to_u,
	        adjacent_nodes,
	        cost_of_e,
	        cost_of_s_to_u_plus_cost_of_e,
	        cost_of_s_to_v,
	        first_visit;
	    while (!open.empty()) {
	      // In the nodes remaining in graph that have a known cost from s,
	      // find the node, u, that currently has the shortest path from s.
	      closest = open.pop();
	      u = closest.value;
	      cost_of_s_to_u = closest.cost;
	
	      // Get nodes adjacent to u...
	      adjacent_nodes = graph[u] || {};
	
	      // ...and explore the edges that connect u to those nodes, updating
	      // the cost of the shortest paths to any or all of those nodes as
	      // necessary. v is the node across the current edge from u.
	      for (v in adjacent_nodes) {
	        if (adjacent_nodes.hasOwnProperty(v)) {
	          // Get the cost of the edge running from u to v.
	          cost_of_e = adjacent_nodes[v];
	
	          // Cost of s to u plus the cost of u to v across e--this is *a*
	          // cost from s to v that may or may not be less than the current
	          // known cost to v.
	          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
	
	          // If we haven't visited v yet OR if the current known cost from s to
	          // v is greater than the new cost we just found (cost of s to u plus
	          // cost of u to v across e), update v's cost in the cost list and
	          // update v's predecessor in the predecessor list (it's now u).
	          cost_of_s_to_v = costs[v];
	          first_visit = (typeof costs[v] === 'undefined');
	          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
	            costs[v] = cost_of_s_to_u_plus_cost_of_e;
	            open.push(v, cost_of_s_to_u_plus_cost_of_e);
	            predecessors[v] = u;
	          }
	        }
	      }
	    }
	
	    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
	      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
	      throw new Error(msg);
	    }
	
	    return predecessors;
	  },
	
	  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
	    var nodes = [];
	    var u = d;
	    var predecessor;
	    while (u) {
	      nodes.push(u);
	      predecessor = predecessors[u];
	      u = predecessors[u];
	    }
	    nodes.reverse();
	    return nodes;
	  },
	
	  find_path: function(graph, s, d) {
	    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
	    return dijkstra.extract_shortest_path_from_predecessor_list(
	      predecessors, d);
	  },
	
	  /**
	   * A very naive priority queue implementation.
	   */
	  PriorityQueue: {
	    make: function (opts) {
	      var T = dijkstra.PriorityQueue,
	          t = {},
	          key;
	      opts = opts || {};
	      for (key in T) {
	        if (T.hasOwnProperty(key)) {
	          t[key] = T[key];
	        }
	      }
	      t.queue = [];
	      t.sorter = opts.sorter || T.default_sorter;
	      return t;
	    },
	
	    default_sorter: function (a, b) {
	      return a.cost - b.cost;
	    },
	
	    /**
	     * Add a new item to the queue and ensure the highest priority element
	     * is at the front of the queue.
	     */
	    push: function (value, cost) {
	      var item = {value: value, cost: cost};
	      this.queue.push(item);
	      this.queue.sort(this.sorter);
	    },
	
	    /**
	     * Return the highest priority element in the queue.
	     */
	    pop: function () {
	      return this.queue.shift();
	    },
	
	    empty: function () {
	      return this.queue.length === 0;
	    }
	  }
	};
	
	
	// node.js module exports
	if (true) {
	  module.exports = dijkstra;
	}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highstock JS v6.2.0 (2018-10-17)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(U,J){"object"===typeof module&&module.exports?module.exports=U.document?J(U):J: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return J(U)}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):U.Highcharts=J(U)})("undefined"!==typeof window?window:this,function(U){var J=function(){var a="undefined"===typeof U?window:U,E=a.document,F=a.navigator&&a.navigator.userAgent||"",G=E&&E.createElementNS&&!!E.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,q=/(edge|msie|trident)/i.test(F)&&!a.opera,k=-1!==F.indexOf("Firefox"),
	h=-1!==F.indexOf("Chrome"),t=k&&4>parseInt(F.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highstock",version:"6.2.0",deg2rad:2*Math.PI/360,doc:E,hasBidiBug:t,hasTouch:E&&void 0!==E.documentElement.ontouchstart,isMS:q,isWebKit:-1!==F.indexOf("AppleWebKit"),isFirefox:k,isChrome:h,isSafari:!h&&-1!==F.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(F),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:a,marginNames:["plotTop",
	"marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var E=a.charts,F=a.doc,G=a.win;a.error=function(q,k){q=a.isNumber(q)?"Highcharts error #"+q+": www.highcharts.com/errors/"+q:q;if(k)throw Error(q);G.console&&console.log(q)};a.Fx=function(a,k,h){this.options=k;this.elem=a;this.prop=h};a.Fx.prototype={dSetter:function(){var a=this.paths[0],k=this.paths[1],h=[],t=this.now,C=a.length,n;if(1===t)h=this.toD;else if(C===k.length&&1>t)for(;C--;)n=parseFloat(a[C]),
	h[C]=isNaN(n)?k[C]:t*parseFloat(k[C]-n)+n;else h=k;this.elem.attr("d",h,null,!0)},update:function(){var a=this.elem,k=this.prop,h=this.now,t=this.options.step;if(this[k+"Setter"])this[k+"Setter"]();else a.attr?a.element&&a.attr(k,h,null,!0):a.style[k]=h+this.unit;t&&t.call(a,h,this)},run:function(q,k,h){var t=this,C=t.options,n=function(a){return n.stopped?!1:t.step(a)},A=G.requestAnimationFrame||function(a){setTimeout(a,13)},B=function(){for(var e=0;e<a.timers.length;e++)a.timers[e]()||a.timers.splice(e--,
	1);a.timers.length&&A(B)};q!==k||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=q,this.end=k,this.unit=h,this.now=this.start,this.pos=0,n.elem=this.elem,n.prop=this.prop,n()&&1===a.timers.push(n)&&A(B)):(delete C.curAnim[this.prop],C.complete&&0===a.keys(C.curAnim).length&&C.complete.call(this.elem))},step:function(q){var k=+new Date,h,t=this.options,C=this.elem,n=t.complete,A=t.duration,B=t.curAnim;C.attr&&!C.element?q=!1:q||k>=A+this.startTime?(this.now=this.end,this.pos=
	1,this.update(),h=B[this.prop]=!0,a.objectEach(B,function(a){!0!==a&&(h=!1)}),h&&n&&n.call(C),q=!1):(this.pos=t.easing((k-this.startTime)/A),this.now=this.start+(this.end-this.start)*this.pos,this.update(),q=!0);return q},initPath:function(q,k,h){function t(a){var b,f;for(c=a.length;c--;)b="M"===a[c]||"L"===a[c],f=/[a-zA-Z]/.test(a[c+3]),b&&f&&a.splice(c+1,0,a[c+1],a[c+2],a[c+1],a[c+2])}function C(a,b){for(;a.length<v;){a[0]=b[v-a.length];var d=a.slice(0,l);[].splice.apply(a,[0,0].concat(d));f&&(d=
	a.slice(a.length-l),[].splice.apply(a,[a.length,0].concat(d)),c--)}a[0]="M"}function n(a,c){for(var e=(v-a.length)/l;0<e&&e--;)b=a.slice().splice(a.length/w-l,l*w),b[0]=c[v-l-e*l],d&&(b[l-6]=b[l-2],b[l-5]=b[l-1]),[].splice.apply(a,[a.length/w,0].concat(b)),f&&e--}k=k||"";var A,B=q.startX,e=q.endX,d=-1<k.indexOf("C"),l=d?7:3,v,b,c;k=k.split(" ");h=h.slice();var f=q.isArea,w=f?2:1,x;d&&(t(k),t(h));if(B&&e){for(c=0;c<B.length;c++)if(B[c]===e[0]){A=c;break}else if(B[0]===e[e.length-B.length+c]){A=c;x=
	!0;break}void 0===A&&(k=[])}k.length&&a.isNumber(A)&&(v=h.length+A*w*l,x?(C(k,h),n(h,k)):(C(h,k),n(k,h)));return[k,h]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var q,k=arguments,h,t={},C=function(n,h){"object"!==typeof n&&(n={});a.objectEach(h,function(B,e){!a.isObject(B,!0)||a.isClass(B)||a.isDOMElement(B)?n[e]=h[e]:n[e]=C(n[e]||{},
	B)});return n};!0===k[0]&&(t=k[1],k=Array.prototype.slice.call(k,2));h=k.length;for(q=0;q<h;q++)t=C(t,k[q]);return t};a.pInt=function(a,k){return parseInt(a,k||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(q,k){return!!q&&"object"===typeof q&&(!k||!a.isArray(q))};a.isDOMElement=function(q){return a.isObject(q)&&"number"===typeof q.nodeType};a.isClass=function(q){var k=
	q&&q.constructor;return!(!a.isObject(q,!0)||a.isDOMElement(q)||!k||!k.name||"Object"===k.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,k){for(var h=a.length;h--;)if(a[h]===k){a.splice(h,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(q,k,h){var t;a.isString(k)?a.defined(h)?q.setAttribute(k,h):q&&q.getAttribute&&((t=q.getAttribute(k))||"class"!==k||(t=q.getAttribute(k+"Name"))):a.defined(k)&&a.isObject(k)&&
	a.objectEach(k,function(a,n){q.setAttribute(n,a)});return t};a.splat=function(q){return a.isArray(q)?q:[q]};a.syncTimeout=function(a,k,h){if(k)return setTimeout(a,k,h);a.call(0,h)};a.clearTimeout=function(q){a.defined(q)&&clearTimeout(q)};a.extend=function(a,k){var h;a||(a={});for(h in k)a[h]=k[h];return a};a.pick=function(){var a=arguments,k,h,t=a.length;for(k=0;k<t;k++)if(h=a[k],void 0!==h&&null!==h)return h};a.css=function(q,k){a.isMS&&!a.svg&&k&&void 0!==k.opacity&&(k.filter="alpha(opacity\x3d"+
	100*k.opacity+")");a.extend(q.style,k)};a.createElement=function(q,k,h,t,C){q=F.createElement(q);var n=a.css;k&&a.extend(q,k);C&&n(q,{padding:0,border:"none",margin:0});h&&n(q,h);t&&t.appendChild(q);return q};a.extendClass=function(q,k){var h=function(){};h.prototype=new q;a.extend(h.prototype,k);return h};a.pad=function(a,k,h){return Array((k||2)+1-String(a).replace("-","").length).join(h||0)+a};a.relativeLength=function(a,k,h){return/%$/.test(a)?k*parseFloat(a)/100+(h||0):parseFloat(a)};a.wrap=
	function(a,k,h){var t=a[k];a[k]=function(){var a=Array.prototype.slice.call(arguments),n=arguments,A=this;A.proceed=function(){t.apply(A,arguments.length?arguments:n)};a.unshift(t);a=h.apply(this,a);A.proceed=null;return a}};a.datePropsToTimestamps=function(q){a.objectEach(q,function(k,h){a.isObject(k)&&"function"===typeof k.getTime?q[h]=k.getTime():(a.isObject(k)||a.isArray(k))&&a.datePropsToTimestamps(k)})};a.formatSingle=function(q,k,h){var t=/\.([0-9])/,C=a.defaultOptions.lang;/f$/.test(q)?(h=
	(h=q.match(t))?h[1]:-1,null!==k&&(k=a.numberFormat(k,h,C.decimalPoint,-1<q.indexOf(",")?C.thousandsSep:""))):k=(h||a.time).dateFormat(q,k);return k};a.format=function(q,k,h){for(var t="{",C=!1,n,A,B,e,d=[],l;q;){t=q.indexOf(t);if(-1===t)break;n=q.slice(0,t);if(C){n=n.split(":");A=n.shift().split(".");e=A.length;l=k;for(B=0;B<e;B++)l&&(l=l[A[B]]);n.length&&(l=a.formatSingle(n.join(":"),l,h));d.push(l)}else d.push(n);q=q.slice(t+1);t=(C=!C)?"}":"{"}d.push(q);return d.join("")};a.getMagnitude=function(a){return Math.pow(10,
	Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(q,k,h,t,C){var n,A=q;h=a.pick(h,1);n=q/h;k||(k=C?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===t&&(1===h?k=a.grep(k,function(a){return 0===a%1}):.1>=h&&(k=[1/h])));for(t=0;t<k.length&&!(A=k[t],C&&A*h>=q||!C&&n<=(k[t]+(k[t+1]||k[t]))/2);t++);return A=a.correctFloat(A*h,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,k){var h=a.length,t,C;for(C=0;C<h;C++)a[C].safeI=C;a.sort(function(a,h){t=k(a,h);return 0===t?
	a.safeI-h.safeI:t});for(C=0;C<h;C++)delete a[C].safeI};a.arrayMin=function(a){for(var k=a.length,h=a[0];k--;)a[k]<h&&(h=a[k]);return h};a.arrayMax=function(a){for(var k=a.length,h=a[0];k--;)a[k]>h&&(h=a[k]);return h};a.destroyObjectProperties=function(q,k){a.objectEach(q,function(a,t){a&&a!==k&&a.destroy&&a.destroy();delete q[t]})};a.discardElement=function(q){var k=a.garbageBin;k||(k=a.createElement("div"));q&&k.appendChild(q);k.innerHTML=""};a.correctFloat=function(a,k){return parseFloat(a.toPrecision(k||
	14))};a.setAnimation=function(q,k){k.renderer.globalAnimation=a.pick(q,k.options.chart.animation,!0)};a.animObject=function(q){return a.isObject(q)?a.merge(q):{duration:q?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(q,k,h,t){q=+q||0;k=+k;var C=a.defaultOptions.lang,n=(q.toString().split(".")[1]||"").split("e")[0].length,A,B,e=q.toString().split("e");-1===k?k=Math.min(n,20):a.isNumber(k)?k&&e[1]&&0>e[1]&&
	(A=k+ +e[1],0<=A?(e[0]=(+e[0]).toExponential(A).split("e")[0],k=A):(e[0]=e[0].split(".")[0]||0,q=20>k?(e[0]*Math.pow(10,e[1])).toFixed(k):0,e[1]=0)):k=2;B=(Math.abs(e[1]?e[0]:q)+Math.pow(10,-Math.max(k,n)-1)).toFixed(k);n=String(a.pInt(B));A=3<n.length?n.length%3:0;h=a.pick(h,C.decimalPoint);t=a.pick(t,C.thousandsSep);q=(0>q?"-":"")+(A?n.substr(0,A)+t:"");q+=n.substr(A).replace(/(\d{3})(?=\d)/g,"$1"+t);k&&(q+=h+B.slice(-k));e[1]&&0!==+q&&(q+="e"+e[1]);return q};Math.easeInOutSine=function(a){return-.5*
	(Math.cos(Math.PI*a)-1)};a.getStyle=function(q,k,h){if("width"===k)return Math.max(0,Math.min(q.offsetWidth,q.scrollWidth)-a.getStyle(q,"padding-left")-a.getStyle(q,"padding-right"));if("height"===k)return Math.max(0,Math.min(q.offsetHeight,q.scrollHeight)-a.getStyle(q,"padding-top")-a.getStyle(q,"padding-bottom"));G.getComputedStyle||a.error(27,!0);if(q=G.getComputedStyle(q,void 0))q=q.getPropertyValue(k),a.pick(h,"opacity"!==k)&&(q=a.pInt(q));return q};a.inArray=function(q,k,h){return(a.indexOfPolyfill||
	Array.prototype.indexOf).call(k,q,h)};a.grep=function(q,k){return(a.filterPolyfill||Array.prototype.filter).call(q,k)};a.find=Array.prototype.find?function(a,k){return a.find(k)}:function(a,k){var h,t=a.length;for(h=0;h<t;h++)if(k(a[h],h))return a[h]};a.some=function(q,k,h){return(a.somePolyfill||Array.prototype.some).call(q,k,h)};a.map=function(a,k){for(var h=[],t=0,C=a.length;t<C;t++)h[t]=k.call(a[t],a[t],t,a);return h};a.keys=function(q){return(a.keysPolyfill||Object.keys).call(void 0,q)};a.reduce=
	function(q,k,h){return(a.reducePolyfill||Array.prototype.reduce).apply(q,2<arguments.length?[k,h]:[k])};a.offset=function(a){var k=F.documentElement;a=a.parentElement||a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(G.pageYOffset||k.scrollTop)-(k.clientTop||0),left:a.left+(G.pageXOffset||k.scrollLeft)-(k.clientLeft||0)}};a.stop=function(q,k){for(var h=a.timers.length;h--;)a.timers[h].elem!==q||k&&k!==a.timers[h].prop||(a.timers[h].stopped=!0)};a.each=function(q,k,h){return(a.forEachPolyfill||
	Array.prototype.forEach).call(q,k,h)};a.objectEach=function(a,k,h){for(var t in a)a.hasOwnProperty(t)&&k.call(h||a[t],a[t],t,a)};a.addEvent=function(q,k,h,t){var C,n=q.addEventListener||a.addEventListenerPolyfill;C="function"===typeof q&&q.prototype?q.prototype.protoEvents=q.prototype.protoEvents||{}:q.hcEvents=q.hcEvents||{};a.Point&&q instanceof a.Point&&q.series&&q.series.chart&&(q.series.chart.runTrackerClick=!0);n&&n.call(q,k,h,!1);C[k]||(C[k]=[]);C[k].push(h);t&&a.isNumber(t.order)&&(h.order=
	t.order,C[k].sort(function(a,n){return a.order-n.order}));return function(){a.removeEvent(q,k,h)}};a.removeEvent=function(q,k,h){function t(n,e){var d=q.removeEventListener||a.removeEventListenerPolyfill;d&&d.call(q,n,e,!1)}function C(n){var e,d;q.nodeName&&(k?(e={},e[k]=!0):e=n,a.objectEach(e,function(a,v){if(n[v])for(d=n[v].length;d--;)t(v,n[v][d])}))}var n,A;a.each(["protoEvents","hcEvents"],function(B){var e=q[B];e&&(k?(n=e[k]||[],h?(A=a.inArray(h,n),-1<A&&(n.splice(A,1),e[k]=n),t(k,h)):(C(e),
	e[k]=[])):(C(e),q[B]={}))})};a.fireEvent=function(q,k,h,t){var C,n,A,B,e;h=h||{};F.createEvent&&(q.dispatchEvent||q.fireEvent)?(C=F.createEvent("Events"),C.initEvent(k,!0,!0),a.extend(C,h),q.dispatchEvent?q.dispatchEvent(C):q.fireEvent(k,C)):a.each(["protoEvents","hcEvents"],function(d){if(q[d])for(n=q[d][k]||[],A=n.length,h.target||a.extend(h,{preventDefault:function(){h.defaultPrevented=!0},target:q,type:k}),B=0;B<A;B++)(e=n[B])&&!1===e.call(q,h)&&h.preventDefault()});t&&!h.defaultPrevented&&t.call(q,
	h)};a.animate=function(q,k,h){var t,C="",n,A,B;a.isObject(h)||(B=arguments,h={duration:B[2],easing:B[3],complete:B[4]});a.isNumber(h.duration)||(h.duration=400);h.easing="function"===typeof h.easing?h.easing:Math[h.easing]||Math.easeInOutSine;h.curAnim=a.merge(k);a.objectEach(k,function(e,d){a.stop(q,d);A=new a.Fx(q,h,d);n=null;"d"===d?(A.paths=A.initPath(q,q.d,k.d),A.toD=k.d,t=0,n=1):q.attr?t=q.attr(d):(t=parseFloat(a.getStyle(q,d))||0,"opacity"!==d&&(C="px"));n||(n=e);n&&n.match&&n.match("px")&&
	(n=n.replace(/px/g,""));A.run(t,n,C)})};a.seriesType=function(q,k,h,t,C){var n=a.getOptions(),A=a.seriesTypes;n.plotOptions[q]=a.merge(n.plotOptions[k],h);A[q]=a.extendClass(A[k]||function(){},t);A[q].prototype.type=q;C&&(A[q].prototype.pointClass=a.extendClass(a.Point,C));return A[q]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),k=0;return function(){return"highcharts-"+a+"-"+k++}}();G.jQuery&&(G.jQuery.fn.highcharts=function(){var q=[].slice.call(arguments);if(this[0])return q[0]?
	(new (a[a.isString(q[0])?q.shift():"Chart"])(this[0],q[0],q[1]),this):E[a.attr(this[0],"data-highcharts-chart")]})})(J);(function(a){var E=a.each,F=a.isNumber,G=a.map,q=a.merge,k=a.pInt;a.Color=function(h){if(!(this instanceof a.Color))return new a.Color(h);this.init(h)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[k(a[1]),k(a[2]),k(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
	parse:function(a){return[k(a[1]),k(a[2]),k(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(h){var k,C,n,A;if((this.input=h=this.names[h&&h.toLowerCase?h.toLowerCase():""]||h)&&h.stops)this.stops=G(h.stops,function(n){return new a.Color(n[1])});else if(h&&h.charAt&&"#"===h.charAt()&&(k=h.length,h=parseInt(h.substr(1),16),7===k?C=[(h&16711680)>>16,(h&65280)>>8,h&255,1]:4===k&&(C=[(h&3840)>>4|(h&3840)>>8,(h&240)>>4|h&240,(h&15)<<4|h&15,1])),!C)for(n=this.parsers.length;n--&&!C;)A=this.parsers[n],
	(k=A.regex.exec(h))&&(C=A.parse(k));this.rgba=C||[]},get:function(a){var h=this.input,k=this.rgba,n;this.stops?(n=q(h),n.stops=[].concat(n.stops),E(this.stops,function(h,B){n.stops[B]=[n.stops[B][0],h.get(a)]})):n=k&&F(k[0])?"rgb"===a||!a&&1===k[3]?"rgb("+k[0]+","+k[1]+","+k[2]+")":"a"===a?k[3]:"rgba("+k.join(",")+")":h;return n},brighten:function(a){var h,C=this.rgba;if(this.stops)E(this.stops,function(n){n.brighten(a)});else if(F(a)&&0!==a)for(h=0;3>h;h++)C[h]+=k(255*a),0>C[h]&&(C[h]=0),255<C[h]&&
	(C[h]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,k){var h=this.rgba,n=a.rgba;n.length&&h&&h.length?(a=1!==n[3]||1!==h[3],k=(a?"rgba(":"rgb(")+Math.round(n[0]+(h[0]-n[0])*(1-k))+","+Math.round(n[1]+(h[1]-n[1])*(1-k))+","+Math.round(n[2]+(h[2]-n[2])*(1-k))+(a?","+(n[3]+(h[3]-n[3])*(1-k)):"")+")"):k=a.input||"none";return k}};a.color=function(h){return new a.Color(h)}})(J);(function(a){var E,F,G=a.addEvent,q=a.animate,k=a.attr,h=a.charts,t=a.color,C=a.css,
	n=a.createElement,A=a.defined,B=a.deg2rad,e=a.destroyObjectProperties,d=a.doc,l=a.each,v=a.extend,b=a.erase,c=a.grep,f=a.hasTouch,w=a.inArray,x=a.isArray,m=a.isFirefox,I=a.isMS,z=a.isObject,u=a.isString,r=a.isWebKit,K=a.merge,H=a.noop,p=a.objectEach,D=a.pick,g=a.pInt,y=a.removeEvent,O=a.stop,Q=a.svg,L=a.SVG_NS,N=a.symbolSizes,R=a.win;E=a.SVGElement=function(){return this};v(E.prototype,{opacity:1,SVG_NS:L,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
	init:function(a,g){this.element="span"===g?n(g):d.createElementNS(this.SVG_NS,g);this.renderer=a},animate:function(g,b,y){b=a.animObject(D(b,this.renderer.globalAnimation,!0));0!==b.duration?(y&&(b.complete=y),q(this,g,b)):(this.attr(g,null,y),b.step&&b.step.call(this));return this},complexColor:function(g,b,y){var M=this.renderer,c,f,d,L,r,D,w,v,e,m,z,H=[],u;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){g.radialGradient?f="radialGradient":g.linearGradient&&(f="linearGradient");
	f&&(d=g[f],r=M.gradients,w=g.stops,m=y.radialReference,x(d)&&(g[f]=d={x1:d[0],y1:d[1],x2:d[2],y2:d[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===f&&m&&!A(d.gradientUnits)&&(L=d,d=K(d,M.getRadialAttr(m,L),{gradientUnits:"userSpaceOnUse"})),p(d,function(a,g){"id"!==g&&H.push(g,a)}),p(w,function(a){H.push(a)}),H=H.join(","),r[H]?z=r[H].attr("id"):(d.id=z=a.uniqueKey(),r[H]=D=M.createElement(f).attr(d).add(M.defs),D.radAttr=L,D.stops=[],l(w,function(g){0===g[1].indexOf("rgba")?(c=a.color(g[1]),
	v=c.get("rgb"),e=c.get("a")):(v=g[1],e=1);g=M.createElement("stop").attr({offset:g[0],"stop-color":v,"stop-opacity":e}).add(D);D.stops.push(g)})),u="url("+M.url+"#"+z+")",y.setAttribute(b,u),y.gradient=H,g.toString=function(){return u})})},applyTextOutline:function(g){var M=this.element,y,c,f,p,d;-1!==g.indexOf("contrast")&&(g=g.replace(/contrast/g,this.renderer.getContrast(M.style.fill)));g=g.split(" ");c=g[g.length-1];if((f=g[0])&&"none"!==f&&a.svg){this.fakeTS=!0;g=[].slice.call(M.getElementsByTagName("tspan"));
	this.ySetter=this.xSetter;f=f.replace(/(^[\d\.]+)(.*?)$/g,function(a,g,b){return 2*g+b});for(d=g.length;d--;)y=g[d],"highcharts-text-outline"===y.getAttribute("class")&&b(g,M.removeChild(y));p=M.firstChild;l(g,function(a,g){0===g&&(a.setAttribute("x",M.getAttribute("x")),g=M.getAttribute("y"),a.setAttribute("y",g||0),null===g&&M.setAttribute("y",0));a=a.cloneNode(1);k(a,{"class":"highcharts-text-outline",fill:c,stroke:c,"stroke-width":f,"stroke-linejoin":"round"});M.insertBefore(a,p)})}},attr:function(a,
	g,b,y){var M,c=this.element,f,d=this,L,r;"string"===typeof a&&void 0!==g&&(M=a,a={},a[M]=g);"string"===typeof a?d=(this[a+"Getter"]||this._defaultGetter).call(this,a,c):(p(a,function(g,b){L=!1;y||O(this,b);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(b)&&(f||(this.symbolAttr(a),f=!0),L=!0);!this.rotation||"x"!==b&&"y"!==b||(this.doTransform=!0);L||(r=this[b+"Setter"]||this._defaultSetter,r.call(this,g,b,c),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(b)&&
	this.updateShadows(b,g,r))},this),this.afterSetters());b&&b.call(this);return d},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,g,b){for(var y=this.shadows,M=y.length;M--;)b.call(y[M],"height"===a?Math.max(g-(y[M].cutHeight||0),0):"d"===a?this.d:g,a,y[M])},addClass:function(a,g){var b=this.attr("class")||"";-1===b.indexOf(a)&&(g||(a=(b+(b?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==
	w(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var g=this;l("x y r start end width height innerR anchorX anchorY".split(" "),function(b){g[b]=D(a[b],g[b])});g.attr({d:g.renderer.symbols[g.symbolName](g.x,g.y,g.width,g.height,g)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,g){var b;g=g||a.strokeWidth||0;b=Math.round(g)%2/2;
	a.x=Math.floor(a.x||this.x||0)+b;a.y=Math.floor(a.y||this.y||0)+b;a.width=Math.floor((a.width||this.width||0)-2*b);a.height=Math.floor((a.height||this.height||0)-2*b);A(a.strokeWidth)&&(a.strokeWidth=g);return a},css:function(a){var b=this.styles,y={},c=this.element,M,f="",d,L=!b,r=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);b&&p(a,function(a,g){a!==b[g]&&(y[g]=a,L=!0)});L&&(b&&(a=v(b,y)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===c.nodeName.toLowerCase()&&
	a.width&&(M=this.textWidth=g(a.width))),this.styles=a,M&&!Q&&this.renderer.forExport&&delete a.width,c.namespaceURI===this.SVG_NS?(d=function(a,g){return"-"+g.toLowerCase()},p(a,function(a,g){-1===w(g,r)&&(f+=g.replace(/([A-Z])/g,d)+":"+a+";")}),f&&k(c,"style",f)):C(c,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,g){var b=this,y=
	b.element;f&&"click"===a?(y.ontouchstart=function(a){b.touchEventFired=Date.now();a.preventDefault();g.call(y,a)},y.onclick=function(a){(-1===R.navigator.userAgent.indexOf("Android")||1100<Date.now()-(b.touchEventFired||0))&&g.call(y,a)}):y["on"+a]=g;return this},setRadialReference:function(a){var g=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;g&&g.radAttr&&g.animate(this.renderer.getRadialAttr(a,g.radAttr));return this},translate:function(a,g){return this.attr({translateX:a,
	translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,g=this.translateY||0,b=this.scaleX,y=this.scaleY,c=this.inverted,f=this.rotation,d=this.matrix,p=this.element;c&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];A(d)&&a.push("matrix("+d.join(",")+")");c?a.push("rotate(90) scale(-1,1)"):f&&a.push("rotate("+f+" "+D(this.rotationOriginX,p.getAttribute("x"),0)+" "+D(this.rotationOriginY,p.getAttribute("y")||
	0)+")");(A(b)||A(y))&&a.push("scale("+D(b,1)+" "+D(y,1)+")");a.length&&p.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,g,y){var c,f,M,p,d={};f=this.renderer;M=f.alignedObjects;var L,r;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!y||u(y))this.alignTo=c=y||"renderer",b(M,this),M.push(this),y=null}else a=this.alignOptions,g=this.alignByTranslate,c=this.alignTo;y=D(y,f[c],f);c=a.align;f=a.verticalAlign;M=
	(y.x||0)+(a.x||0);p=(y.y||0)+(a.y||0);"right"===c?L=1:"center"===c&&(L=2);L&&(M+=(y.width-(a.width||0))/L);d[g?"translateX":"x"]=Math.round(M);"bottom"===f?r=1:"middle"===f&&(r=2);r&&(p+=(y.height-(a.height||0))/r);d[g?"translateY":"y"]=Math.round(p);this[this.placed?"animate":"attr"](d);this.placed=!0;this.alignAttr=d;return this},getBBox:function(a,g){var b,y=this.renderer,c,f=this.element,d=this.styles,p,M=this.textStr,L,r=y.cache,w=y.cacheKeys,e=f.namespaceURI===this.SVG_NS,m;g=D(g,this.rotation);
	c=g*B;p=d&&d.fontSize;A(M)&&(m=M.toString(),-1===m.indexOf("\x3c")&&(m=m.replace(/[0-9]/g,"0")),m+=["",g||0,p,this.textWidth,d&&d.textOverflow].join());m&&!a&&(b=r[m]);if(!b){if(e||y.forExport){try{(L=this.fakeTS&&function(a){l(f.querySelectorAll(".highcharts-text-outline"),function(g){g.style.display=a})})&&L("none"),b=f.getBBox?v({},f.getBBox()):{width:f.offsetWidth,height:f.offsetHeight},L&&L("")}catch(T){}if(!b||0>b.width)b={width:0,height:0}}else b=this.htmlGetBBox();y.isSVG&&(a=b.width,y=b.height,
	e&&(b.height=y={"11px,17":14,"13px,20":16}[d&&d.fontSize+","+Math.round(y)]||y),g&&(b.width=Math.abs(y*Math.sin(c))+Math.abs(a*Math.cos(c)),b.height=Math.abs(y*Math.cos(c))+Math.abs(a*Math.sin(c))));if(m&&0<b.height){for(;250<w.length;)delete r[w.shift()];r[m]||w.push(m);r[m]=b}}return b},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var g=this;g.animate({opacity:0},{duration:a||150,complete:function(){g.attr({y:-9999})}})},
	add:function(a){var g=this.renderer,b=this.element,y;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&g.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)y=this.zIndexSetter();y||(a?a.element:g.box).appendChild(b);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var g=a.parentNode;g&&g.removeChild(a)},destroy:function(){var a=this,g=a.element||{},y=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,c=g.ownerSVGElement,f=a.clipPath;g.onclick=
	g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;O(a);f&&c&&(l(c.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var g=a.getAttribute("clip-path"),b=f.element.id;(-1<g.indexOf("(#"+b+")")||-1<g.indexOf('("#'+b+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=f.destroy());if(a.stops){for(c=0;c<a.stops.length;c++)a.stops[c]=a.stops[c].destroy();a.stops=null}a.safeRemoveChild(g);for(a.destroyShadows();y&&y.div&&0===y.div.childNodes.length;)g=y.parentGroup,a.safeRemoveChild(y.div),delete y.div,
	y=g;a.alignTo&&b(a.renderer.alignedObjects,a);p(a,function(g,b){delete a[b]});return null},shadow:function(a,g,b){var y=[],c,f,d=this.element,p,L,r,M;if(!a)this.destroyShadows();else if(!this.shadows){L=D(a.width,3);r=(a.opacity||.15)/L;M=this.parentInverted?"(-1,-1)":"("+D(a.offsetX,1)+", "+D(a.offsetY,1)+")";for(c=1;c<=L;c++)f=d.cloneNode(0),p=2*L+1-2*c,k(f,{stroke:a.color||"#000000","stroke-opacity":r*c,"stroke-width":p,transform:"translate"+M,fill:"none"}),f.setAttribute("class",(f.getAttribute("class")||
	"")+" highcharts-shadow"),b&&(k(f,"height",Math.max(k(f,"height")-p,0)),f.cutHeight=p),g?g.element.appendChild(f):d.parentNode&&d.parentNode.insertBefore(f,d),y.push(f);this.shadows=y}return this},destroyShadows:function(){l(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=D(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):
	null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[g]!==a&&(b.setAttribute(g,a),this[g]=a)},dashstyleSetter:function(a){var b,y=this["stroke-width"];"inherit"===y&&(y=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,
	"").split(",");for(b=a.length;b--;)a[b]=g(a[b])*y;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,g,b){this[g]=a;b.setAttribute(g,a)},titleSetter:function(a){var g=this.element.getElementsByTagName("title")[0];g||(g=d.createElementNS(this.SVG_NS,"title"),this.element.appendChild(g));g.firstChild&&g.removeChild(g.firstChild);
	g.appendChild(d.createTextNode(String(D(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,b){"string"===typeof a?b.setAttribute(g,a):a&&this.complexColor(a,g,b)},visibilitySetter:function(a,g,b){"inherit"===a?b.removeAttribute(g):this[g]!==a&&b.setAttribute(g,a);this[g]=a},zIndexSetter:function(a,b){var y=this.renderer,c=this.parentGroup,
	f=(c||y).element||y.box,d,p=this.element,L,r,y=f===y.box;d=this.added;var D;A(a)?(p.setAttribute("data-z-index",a),a=+a,this[b]===a&&(d=!1)):A(this[b])&&p.removeAttribute("data-z-index");this[b]=a;if(d){(a=this.zIndex)&&c&&(c.handleZ=!0);b=f.childNodes;for(D=b.length-1;0<=D&&!L;D--)if(c=b[D],d=c.getAttribute("data-z-index"),r=!A(d),c!==p)if(0>a&&r&&!y&&!D)f.insertBefore(p,b[D]),L=!0;else if(g(d)<=a||r&&(!A(a)||0<=a))f.insertBefore(p,b[D+1]||null),L=!0;L||(f.insertBefore(p,b[y?3:0]||null),L=!0)}return L},
	_defaultSetter:function(a,g,b){b.setAttribute(g,a)}});E.prototype.yGetter=E.prototype.xGetter;E.prototype.translateXSetter=E.prototype.translateYSetter=E.prototype.rotationSetter=E.prototype.verticalAlignSetter=E.prototype.rotationOriginXSetter=E.prototype.rotationOriginYSetter=E.prototype.scaleXSetter=E.prototype.scaleYSetter=E.prototype.matrixSetter=function(a,g){this[g]=a;this.doTransform=!0};E.prototype["stroke-widthSetter"]=E.prototype.strokeSetter=function(a,g,b){this[g]=a;this.stroke&&this["stroke-width"]?
	(E.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===g&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};F=a.SVGRenderer=function(){this.init.apply(this,arguments)};v(F.prototype,{Element:E,SVG_NS:L,init:function(a,g,b,y,c,f){var p;y=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(y));p=y.element;a.appendChild(p);k(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&
	k(p,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=p;this.boxWrapper=y;this.alignedObjects=[];this.url=(m||r)&&d.getElementsByTagName("base").length?R.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(d.createTextNode("Created with Highstock 6.2.0"));this.defs=this.createElement("defs").add();this.allowHTML=f;this.forExport=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,
	b,!1);var L;m&&a.getBoundingClientRect&&(g=function(){C(a,{left:0,top:0});L=a.getBoundingClientRect();C(a,{left:Math.ceil(L.left)-L.left+"px",top:Math.ceil(L.top)-L.top+"px"})},g(),this.unSubPixelFix=G(R,"resize",g))},getStyle:function(a){return this.style=v({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
	this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();e(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:H,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},truncate:function(a,g,b,y,c,f,p){var L=this,r=a.rotation,D,w=y?1:0,v=(b||y).length,e=v,m=[],l=function(a){g.firstChild&&
	g.removeChild(g.firstChild);a&&g.appendChild(d.createTextNode(a))},x=function(f,d){d=d||f;if(void 0===m[d])if(g.getSubStringLength)try{m[d]=c+g.getSubStringLength(0,y?d+1:d)}catch(ha){}else L.getSpanWidth&&(l(p(b||y,f)),m[d]=c+L.getSpanWidth(a,g));return m[d]},z,H;a.rotation=0;z=x(g.textContent.length);if(H=c+z>f){for(;w<=v;)e=Math.ceil((w+v)/2),y&&(D=p(y,e)),z=x(e,D&&D.length-1),w===v?w=v+1:z>f?v=e-1:w=e;0===v?l(""):b&&v===b.length-1||l(D||p(b||y,e))}y&&y.splice(0,e);a.actualWidth=z;a.rotation=r;
	return H},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var b=a.element,y=this,f=y.forExport,r=D(a.textStr,"").toString(),v=-1!==r.indexOf("\x3c"),e=b.childNodes,m,z=k(b,"x"),x=a.styles,H=a.textWidth,u=x&&x.lineHeight,O=x&&x.textOutline,M=x&&"ellipsis"===x.textOverflow,K=x&&"nowrap"===x.whiteSpace,N=x&&x.fontSize,I,n,h=e.length,x=H&&!a.added&&this.box,B=function(a){var c;c=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:N||
	y.style.fontSize||12;return u?g(u):y.fontMetrics(c,a.getAttribute("style")?a:b).h},A=function(a,g){p(y.escapes,function(b,y){g&&-1!==w(b,g)||(a=a.toString().replace(new RegExp(b,"g"),y))});return a},R=function(a,g){var b;b=a.indexOf("\x3c");a=a.substring(b,a.indexOf("\x3e")-b);b=a.indexOf(g+"\x3d");if(-1!==b&&(b=b+g.length+1,g=a.charAt(b),'"'===g||"'"===g))return a=a.substring(b+1),a.substring(0,a.indexOf(g))};I=[r,M,K,u,O,N,H].join();if(I!==a.textCache){for(a.textCache=I;h--;)b.removeChild(e[h]);
	v||O||M||H||-1!==r.indexOf(" ")?(x&&x.appendChild(b),r=v?r.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[r],r=c(r,function(a){return""!==a}),l(r,function(g,c){var p,r=0,D=0;g=g.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");p=g.split("|||");l(p,function(g){if(""!==g||1===
	p.length){var w={},v=d.createElementNS(y.SVG_NS,"tspan"),e,l;(e=R(g,"class"))&&k(v,"class",e);if(e=R(g,"style"))e=e.replace(/(;| |^)color([ :])/,"$1fill$2"),k(v,"style",e);(l=R(g,"href"))&&!f&&(k(v,"onclick",'location.href\x3d"'+l+'"'),k(v,"class","highcharts-anchor"),C(v,{cursor:"pointer"}));g=A(g.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==g){v.appendChild(d.createTextNode(g));r?w.dx=0:c&&null!==z&&(w.x=z);k(v,w);b.appendChild(v);!r&&n&&(!Q&&f&&C(v,{display:"block"}),k(v,"dy",B(v)));if(H){var x=
	g.replace(/([^\^])-/g,"$1- ").split(" "),w=!K&&(1<p.length||c||1<x.length);l=0;var u=B(v);if(M)m=y.truncate(a,v,g,void 0,0,Math.max(0,H-parseInt(N||12,10)),function(a,g){return a.substring(0,g)+"\u2026"});else if(w)for(;x.length;)x.length&&!K&&0<l&&(v=d.createElementNS(L,"tspan"),k(v,{dy:u,x:z}),e&&k(v,"style",e),v.appendChild(d.createTextNode(x.join(" ").replace(/- /g,"-"))),b.appendChild(v)),y.truncate(a,v,null,x,0===l?D:0,H,function(a,g){return x.slice(0,g).join(" ").replace(/- /g,"-")}),D=a.actualWidth,
	l++}r++}}});n=n||b.childNodes.length}),M&&m&&a.attr("title",A(a.textStr,["\x26lt;","\x26gt;"])),x&&x.removeChild(b),O&&a.applyTextOutline&&a.applyTextOutline(O)):b.appendChild(d.createTextNode(A(r)))}},getContrast:function(a){a=t(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,b,y,c,f,p,d,L){var r=this.label(a,g,b,L,null,null,null,null,"button"),D=0;r.attr(K({padding:8,r:2},c));var w,e,m,l;c=K({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,
	style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},c);w=c.style;delete c.style;f=K(c,{fill:"#e6e6e6"},f);e=f.style;delete f.style;p=K(c,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},p);m=p.style;delete p.style;d=K(c,{style:{color:"#cccccc"}},d);l=d.style;delete d.style;G(r.element,I?"mouseover":"mouseenter",function(){3!==D&&r.setState(1)});G(r.element,I?"mouseout":"mouseleave",function(){3!==D&&r.setState(D)});r.setState=function(a){1!==a&&(r.state=D=a);r.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+
	["normal","hover","pressed","disabled"][a||0]);r.attr([c,f,p,d][a||0]).css([w,e,m,l][a||0])};r.attr(c).css(v({cursor:"default"},w));return r.on("click",function(a){3!==D&&y.call(r,a)})},crispLine:function(a,g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g={fill:"none"};x(a)?g.d=a:z(a)&&v(g,a);return this.createElement("path").attr(g)},circle:function(a,g,b){a=z(a)?a:{x:a,y:g,r:b};g=this.createElement("circle");g.xSetter=
	g.ySetter=function(a,g,b){b.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,b,y,c,f){z(a)?(y=a,g=y.y,b=y.r,a=y.x):y={innerR:y,start:c,end:f};a=this.symbol("arc",a,g,b,b,y);a.r=b;return a},rect:function(a,g,b,y,c,f){c=z(a)?a.r:c;var p=this.createElement("rect");a=z(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(b,0),height:Math.max(y,0)};void 0!==f&&(a.strokeWidth=f,a=p.crisp(a));a.fill="none";c&&(a.r=c);p.rSetter=function(a,g,b){k(b,{rx:a,ry:a})};return p.attr(a)},setSize:function(a,g,b){var y=
	this.alignedObjects,c=y.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:D(b,!0)?void 0:0});c--;)y[c].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,g,b,y,c,f){var p={preserveAspectRatio:"none"},d,r=function(a,g){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",g):a.setAttribute("hc-svg-href",
	g)},L=function(g){r(d.element,a);f.call(d,g)};1<arguments.length&&v(p,{x:g,y:b,width:y,height:c});d=this.createElement("image").attr(p);f?(r(d.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),p=new R.Image,G(p,"load",L),p.src=a,p.complete&&L({})):r(d.element,a);return d},symbol:function(a,g,b,y,c,f){var p=this,r,L=/^url\((.*?)\)$/,w=L.test(a),e=!w&&(this.symbols[a]?a:"circle"),m=e&&this.symbols[e],x=A(g)&&m&&m.call(this.symbols,Math.round(g),Math.round(b),
	y,c,f),z,H;m?(r=this.path(x),r.attr("fill","none"),v(r,{symbolName:e,x:g,y:b,width:y,height:c}),f&&v(r,f)):w&&(z=a.match(L)[1],r=this.image(z),r.imgwidth=D(N[z]&&N[z].width,f&&f.width),r.imgheight=D(N[z]&&N[z].height,f&&f.height),H=function(){r.attr({width:r.width,height:r.height})},l(["width","height"],function(a){r[a+"Setter"]=function(a,g){var b={},y=this["img"+g],c="width"===g?"translateX":"translateY";this[g]=a;A(y)&&(this.element&&this.element.setAttribute(g,y),this.alignByTranslate||(b[c]=
	((this[g]||0)-y)/2,this.attr(b)))}}),A(g)&&r.attr({x:g,y:b}),r.isImg=!0,A(r.imgwidth)&&A(r.imgheight)?H():(r.attr({width:0,height:0}),n("img",{onload:function(){var a=h[p.chartIndex];0===this.width&&(C(this,{position:"absolute",top:"-999em"}),d.body.appendChild(this));N[z]={width:this.width,height:this.height};r.imgwidth=this.width;r.imgheight=this.height;r.element&&H();this.parentNode&&this.parentNode.removeChild(this);p.imgCount--;if(!p.imgCount&&a&&a.onload)a.onload()},src:z}),this.imgCount++));
	return r},symbols:{circle:function(a,g,b,y){return this.arc(a+b/2,g+y/2,b/2,y/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,b,y){return["M",a,g,"L",a+b,g,a+b,g+y,a,g+y,"Z"]},triangle:function(a,g,b,y){return["M",a+b/2,g,"L",a+b,g+y,a,g+y,"Z"]},"triangle-down":function(a,g,b,y){return["M",a,g,"L",a+b,g,a+b/2,g+y,"Z"]},diamond:function(a,g,b,y){return["M",a+b/2,g,"L",a+b,g+y/2,a+b/2,g+y,a,g+y/2,"Z"]},arc:function(a,g,b,y,c){var f=c.start,p=c.r||b,r=c.r||y||b,d=c.end-.001;b=c.innerR;y=D(c.open,
	.001>Math.abs(c.end-c.start-2*Math.PI));var L=Math.cos(f),v=Math.sin(f),w=Math.cos(d),d=Math.sin(d);c=.001>c.end-f-Math.PI?0:1;p=["M",a+p*L,g+r*v,"A",p,r,0,c,1,a+p*w,g+r*d];A(b)&&p.push(y?"M":"L",a+b*w,g+b*d,"A",b,b,0,c,0,a+b*L,g+b*v);p.push(y?"":"Z");return p},callout:function(a,g,b,y,c){var f=Math.min(c&&c.r||0,b,y),p=f+6,d=c&&c.anchorX;c=c&&c.anchorY;var r;r=["M",a+f,g,"L",a+b-f,g,"C",a+b,g,a+b,g,a+b,g+f,"L",a+b,g+y-f,"C",a+b,g+y,a+b,g+y,a+b-f,g+y,"L",a+f,g+y,"C",a,g+y,a,g+y,a,g+y-f,"L",a,g+f,
	"C",a,g,a,g,a+f,g];d&&d>b?c>g+p&&c<g+y-p?r.splice(13,3,"L",a+b,c-6,a+b+6,c,a+b,c+6,a+b,g+y-f):r.splice(13,3,"L",a+b,y/2,d,c,a+b,y/2,a+b,g+y-f):d&&0>d?c>g+p&&c<g+y-p?r.splice(33,3,"L",a,c+6,a-6,c,a,c-6,a,g+f):r.splice(33,3,"L",a,y/2,d,c,a,y/2,a,g+f):c&&c>y&&d>a+p&&d<a+b-p?r.splice(23,3,"L",d+6,g+y,d,g+y+6,d-6,g+y,a+f,g+y):c&&0>c&&d>a+p&&d<a+b-p&&r.splice(3,3,"L",d-6,g,d,g-6,d+6,g,b-f,g);return r}},clipRect:function(g,b,y,c){var f=a.uniqueKey(),p=this.createElement("clipPath").attr({id:f}).add(this.defs);
	g=this.rect(g,b,y,c,0).add(p);g.id=f;g.clipPath=p;g.count=0;return g},text:function(a,g,b,y){var c={};if(y&&(this.allowHTML||!this.forExport))return this.html(a,g,b);c.x=Math.round(g||0);b&&(c.y=Math.round(b));A(a)&&(c.text=a);a=this.createElement("text").attr(c);y||(a.xSetter=function(a,g,b){var y=b.getElementsByTagName("tspan"),c,f=b.getAttribute(g),p;for(p=0;p<y.length;p++)c=y[p],c.getAttribute(g)===f&&c.setAttribute(g,a);b.setAttribute(g,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&
	b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?g(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,g,b){var y=a;g&&b&&(y=Math.max(y*Math.cos(g*B),4));return{x:-a/3*Math.sin(g*B),y:y}},label:function(g,b,c,f,p,d,r,L,D){var w=this,e=w.g("button"!==D&&"label"),m=e.text=w.text("",0,0,r).attr({zIndex:1}),x,z,H=0,u=3,O=0,Q,N,I,n,h,B={},k,R,M=/^url\((.*?)\)$/.test(f),t=M,C,q,
	P,S;D&&e.addClass("highcharts-"+D);t=M;C=function(){return(k||0)%2/2};q=function(){var a=m.element.style,g={};z=(void 0===Q||void 0===N||h)&&A(m.textStr)&&m.getBBox();e.width=(Q||z.width||0)+2*u+O;e.height=(N||z.height||0)+2*u;R=u+w.fontMetrics(a&&a.fontSize,m).b;t&&(x||(e.box=x=w.symbols[f]||M?w.symbol(f):w.rect(),x.addClass(("button"===D?"":"highcharts-label-box")+(D?" highcharts-"+D+"-box":"")),x.add(e),a=C(),g.x=a,g.y=(L?-R:0)+a),g.width=Math.round(e.width),g.height=Math.round(e.height),x.attr(v(g,
	B)),B={})};P=function(){var a=O+u,g;g=L?0:R;A(Q)&&z&&("center"===h||"right"===h)&&(a+={center:.5,right:1}[h]*(Q-z.width));if(a!==m.x||g!==m.y)m.attr("x",a),m.hasBoxWidthChanged&&(z=m.getBBox(!0),q()),void 0!==g&&m.attr("y",g);m.x=a;m.y=g};S=function(a,g){x?x.attr(a,g):B[a]=g};e.onAdd=function(){m.add(e);e.attr({text:g||0===g?g:"",x:b,y:c});x&&A(p)&&e.attr({anchorX:p,anchorY:d})};e.widthSetter=function(g){Q=a.isNumber(g)?g:null};e.heightSetter=function(a){N=a};e["text-alignSetter"]=function(a){h=a};
	e.paddingSetter=function(a){A(a)&&a!==u&&(u=e.padding=a,P())};e.paddingLeftSetter=function(a){A(a)&&a!==O&&(O=a,P())};e.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==H&&(H=a,z&&e.attr({x:I}))};e.textSetter=function(a){void 0!==a&&m.textSetter(a);q();P()};e["stroke-widthSetter"]=function(a,g){a&&(t=!0);k=this["stroke-width"]=a;S(g,a)};e.strokeSetter=e.fillSetter=e.rSetter=function(a,g){"r"!==g&&("fill"===g&&a&&(t=!0),e[g]=a);S(g,a)};e.anchorXSetter=function(a,g){p=e.anchorX=a;S(g,Math.round(a)-
	C()-I)};e.anchorYSetter=function(a,g){d=e.anchorY=a;S(g,a-n)};e.xSetter=function(a){e.x=a;H&&(a-=H*((Q||z.width)+2*u),e["forceAnimate:x"]=!0);I=Math.round(a);e.attr("translateX",I)};e.ySetter=function(a){n=e.y=Math.round(a);e.attr("translateY",n)};var X=e.css;return v(e,{css:function(a){if(a){var g={};a=K(a);l(e.textProps,function(b){void 0!==a[b]&&(g[b]=a[b],delete a[b])});m.css(g);"width"in g&&q()}return X.call(e,a)},getBBox:function(){return{width:z.width+2*u,height:z.height+2*u,x:z.x-u,y:z.y-
	u}},shadow:function(a){a&&(q(),x&&x.shadow(a));return e},destroy:function(){y(e.element,"mouseenter");y(e.element,"mouseleave");m&&(m=m.destroy());x&&(x=x.destroy());E.prototype.destroy.call(e);e=w=q=P=S=null}})}});a.Renderer=F})(J);(function(a){var E=a.attr,F=a.createElement,G=a.css,q=a.defined,k=a.each,h=a.extend,t=a.isFirefox,C=a.isMS,n=a.isWebKit,A=a.pick,B=a.pInt,e=a.SVGRenderer,d=a.win,l=a.wrap;h(a.SVGElement.prototype,{htmlCss:function(a){var b="SPAN"===this.element.tagName&&a&&"width"in a,
	c=A(b&&a.width,void 0);b&&(delete a.width,this.textWidth=c,this.htmlUpdateTransform());a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=h(this.styles,a);G(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,c=this.translateX||0,f=this.translateY||0,d=this.x||0,e=this.y||0,m=this.textAlign||
	"left",l={left:0,center:.5,right:1}[m],z=this.styles,u=z&&z.whiteSpace;G(b,{marginLeft:c,marginTop:f});this.shadows&&k(this.shadows,function(a){G(a,{marginLeft:c+1,marginTop:f+1})});this.inverted&&k(b.childNodes,function(c){a.invertChild(c,b)});if("SPAN"===b.tagName){var z=this.rotation,r=this.textWidth&&B(this.textWidth),K=[z,m,b.innerHTML,this.textWidth,this.textAlign].join(),H;(H=r!==this.oldTextWidth)&&!(H=r>this.oldTextWidth)&&((H=this.textPxLength)||(G(b,{width:"",whiteSpace:u||"nowrap"}),H=
	b.offsetWidth),H=H>r);H&&/[ \-]/.test(b.textContent||b.innerText)?(G(b,{width:r+"px",display:"block",whiteSpace:u||"normal"}),this.oldTextWidth=r,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;K!==this.cTT&&(u=a.fontMetrics(b.style.fontSize).b,!q(z)||z===(this.oldRotation||0)&&m===this.oldAlign||this.setSpanRotation(z,l,u),this.getSpanCorrection(!q(z)&&this.textPxLength||b.offsetWidth,u,l,z,m));G(b,{left:d+(this.xCorr||0)+"px",top:e+(this.yCorr||0)+"px"});this.cTT=K;this.oldRotation=z;this.oldAlign=
	m}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,c){var f={},d=this.renderer.getTransformKey();f[d]=f.transform="rotate("+a+"deg)";f[d+(t?"Origin":"-origin")]=f.transformOrigin=100*b+"% "+c+"px";G(this.element,f)},getSpanCorrection:function(a,b,c){this.xCorr=-a*c;this.yCorr=-b}});h(e.prototype,{getTransformKey:function(){return C&&!/Edge/.test(d.navigator.userAgent)?"-ms-transform":n?"-webkit-transform":t?"MozTransform":d.opera?"-o-transform":""},html:function(a,b,c){var f=this.createElement("span"),
	d=f.element,e=f.renderer,m=e.isSVG,v=function(a,b){k(["opacity","visibility"],function(c){l(a,c+"Setter",function(a,c,f,d){a.call(this,c,f,d);b[f]=c})});a.addedSetters=!0};f.textSetter=function(a){a!==d.innerHTML&&delete this.bBox;this.textStr=a;d.innerHTML=A(a,"");f.doTransform=!0};m&&v(f,f.element.style);f.xSetter=f.ySetter=f.alignSetter=f.rotationSetter=function(a,b){"align"===b&&(b="textAlign");f[b]=a;f.doTransform=!0};f.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=
	!1)};f.attr({text:a,x:Math.round(b),y:Math.round(c)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});d.style.whiteSpace="nowrap";f.css=f.htmlCss;m&&(f.add=function(a){var b,c=e.box.parentNode,w=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)w.push(a),a=a.parentGroup;k(w.reverse(),function(a){function d(g,b){a[b]=g;"translateX"===b?r.left=g+"px":r.top=g+"px";a.doTransform=!0}var r,g=E(a.element,"class");g&&(g={className:g});b=a.div=a.div||F("div",g,{position:"absolute",
	left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||c);r=b.style;h(a,{classSetter:function(a){return function(g){this.element.setAttribute("class",g);a.className=g}}(b),on:function(){w[0].div&&f.on.apply({element:w[0].div},arguments);return a},translateXSetter:d,translateYSetter:d});a.addedSetters||v(a,r)})}}else b=c;b.appendChild(d);f.added=!0;f.alignOnAdd&&f.htmlUpdateTransform();return f});return f}})})(J);
	(function(a){var E=a.defined,F=a.each,G=a.extend,q=a.merge,k=a.pick,h=a.timeUnits,t=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var n=k(a&&a.useUTC,!0),h=this;this.options=a=q(!0,this.options||{},a);this.Date=a.Date||t.Date;this.timezoneOffset=(this.useUTC=n)&&a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(n&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,e){var d=
	e.getTime(),l=d-h.getTimezoneOffset(e);e.setTime(l);a=e["getUTC"+a]();e.setTime(d);return a},this.set=function(a,e,d){var l;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===e.getTimezoneOffset()%60)e["set"+a](d);else l=h.getTimezoneOffset(e),l=e.getTime()-l,e.setTime(l),e["setUTC"+a](d),a=h.getTimezoneOffset(e),l=e.getTime()+a,e.setTime(l)}):n?(this.get=function(a,e){return e["getUTC"+a]()},this.set=function(a,e,d){return e["setUTC"+a](d)}):(this.get=function(a,e){return e["get"+a]()},this.set=
	function(a,e,d){return e["set"+a](d)})},makeTime:function(h,n,A,B,e,d){var l,v,b;this.useUTC?(l=this.Date.UTC.apply(0,arguments),v=this.getTimezoneOffset(l),l+=v,b=this.getTimezoneOffset(l),v!==b?l+=b-v:v-36E5!==this.getTimezoneOffset(l-36E5)||a.isSafari||(l-=36E5)):l=(new this.Date(h,n,k(A,1),k(B,0),k(e,0),k(d,0))).getTime();return l},timezoneOffsetFunction:function(){var h=this,n=this.options,k=t.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(n.timezone){if(k)return function(a){return 6E4*
	-k.tz(a,n.timezone).utcOffset()};a.error(25)}return this.useUTC&&n.getTimezoneOffset?function(a){return 6E4*n.getTimezoneOffset(a)}:function(){return 6E4*(h.timezoneOffset||0)}},dateFormat:function(h,n,k){if(!a.defined(n)||isNaN(n))return a.defaultOptions.lang.invalidDate||"";h=a.pick(h,"%Y-%m-%d %H:%M:%S");var B=this,e=new this.Date(n),d=this.get("Hours",e),l=this.get("Day",e),v=this.get("Date",e),b=this.get("Month",e),c=this.get("FullYear",e),f=a.defaultOptions.lang,w=f.weekdays,x=f.shortWeekdays,
	m=a.pad,e=a.extend({a:x?x[l]:w[l].substr(0,3),A:w[l],d:m(v),e:m(v,2," "),w:l,b:f.shortMonths[b],B:f.months[b],m:m(b+1),o:b+1,y:c.toString().substr(2,2),Y:c,H:m(d),k:d,I:m(d%12||12),l:d%12||12,M:m(B.get("Minutes",e)),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:m(e.getSeconds()),L:m(Math.floor(n%1E3),3)},a.dateFormats);a.objectEach(e,function(a,b){for(;-1!==h.indexOf("%"+b);)h=h.replace("%"+b,"function"===typeof a?a.call(B,n):a)});return k?h.substr(0,1).toUpperCase()+h.substr(1):h},resolveDTLFormat:function(h){return a.isObject(h,
	!0)?h:(h=a.splat(h),{main:h[0],from:h[1],to:h[2]})},getTimeTicks:function(a,n,A,B){var e=this,d=[],l,v={},b;l=new e.Date(n);var c=a.unitRange,f=a.count||1,w;B=k(B,1);if(E(n)){e.set("Milliseconds",l,c>=h.second?0:f*Math.floor(e.get("Milliseconds",l)/f));c>=h.second&&e.set("Seconds",l,c>=h.minute?0:f*Math.floor(e.get("Seconds",l)/f));c>=h.minute&&e.set("Minutes",l,c>=h.hour?0:f*Math.floor(e.get("Minutes",l)/f));c>=h.hour&&e.set("Hours",l,c>=h.day?0:f*Math.floor(e.get("Hours",l)/f));c>=h.day&&e.set("Date",
	l,c>=h.month?1:f*Math.floor(e.get("Date",l)/f));c>=h.month&&(e.set("Month",l,c>=h.year?0:f*Math.floor(e.get("Month",l)/f)),b=e.get("FullYear",l));c>=h.year&&e.set("FullYear",l,b-b%f);c===h.week&&(b=e.get("Day",l),e.set("Date",l,e.get("Date",l)-b+B+(b<B?-7:0)));b=e.get("FullYear",l);B=e.get("Month",l);var x=e.get("Date",l),m=e.get("Hours",l);n=l.getTime();e.variableTimezone&&(w=A-n>4*h.month||e.getTimezoneOffset(n)!==e.getTimezoneOffset(A));n=l.getTime();for(l=1;n<A;)d.push(n),n=c===h.year?e.makeTime(b+
	l*f,0):c===h.month?e.makeTime(b,B+l*f):!w||c!==h.day&&c!==h.week?w&&c===h.hour&&1<f?e.makeTime(b,B,x,m+l*f):n+c*f:e.makeTime(b,B,x+l*f*(c===h.day?1:7)),l++;d.push(n);c<=h.hour&&1E4>d.length&&F(d,function(a){0===a%18E5&&"000000000"===e.dateFormat("%H%M%S%L",a)&&(v[a]="day")})}d.info=G(a,{higherRanks:v,totalRange:c*f});return d}}})(J);(function(a){var E=a.color,F=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle",
	"diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,
	chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",
	labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",
	position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:E("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
	pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(E){a.defaultOptions=F(!0,a.defaultOptions,E);
	a.time.update(F(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(F(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(F,q,k){return a.time.dateFormat(F,q,k)}})(J);(function(a){var E=a.correctFloat,F=a.defined,G=a.destroyObjectProperties,q=a.fireEvent,k=a.isNumber,h=a.merge,t=a.pick,C=a.deg2rad;a.Tick=function(a,h,k,e,d){this.axis=a;this.pos=
	h;this.type=k||"";this.isNewLabel=this.isNew=!0;this.parameters=d||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;k||e||this.addLabel()};a.Tick.prototype={addLabel:function(){var n=this,k=n.axis,B=k.options,e=k.chart,d=k.categories,l=k.names,v=n.pos,b=t(n.options&&n.options.labels,B.labels),c=k.tickPositions,f=v===c[0],w=v===c[c.length-1],d=this.parameters.category||(d?t(d[v],l[v],v):v),x=n.label,c=c.info,m,I,z,u;k.isDatetimeAxis&&c&&(I=e.time.resolveDTLFormat(B.dateTimeLabelFormats[!B.grid&&
	c.higherRanks[v]||c.unitName]),m=I.main);n.isFirst=f;n.isLast=w;n.formatCtx={axis:k,chart:e,isFirst:f,isLast:w,dateTimeLabelFormat:m,tickPositionInfo:c,value:k.isLog?E(k.lin2log(d)):d,pos:v};B=k.labelFormatter.call(n.formatCtx,this.formatCtx);if(u=I&&I.list)n.shortenLabel=function(){for(z=0;z<u.length;z++)if(x.attr({text:k.labelFormatter.call(a.extend(n.formatCtx,{dateTimeLabelFormat:u[z]}))}),x.getBBox().width<k.getSlotWidth(n)-2*t(b.padding,5))return;x.attr({text:""})};if(F(x))x&&x.textStr!==B&&
	(!x.textWidth||b.style&&b.style.width||x.styles.width||x.css({width:null}),x.attr({text:B}));else{if(n.label=x=F(B)&&b.enabled?e.renderer.text(B,0,0,b.useHTML).css(h(b.style)).add(k.labelGroup):null)x.textPxLength=x.getBBox().width;n.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var h=this.axis,n=h.options.labels,e=a.x,d=h.chart.chartWidth,l=h.chart.spacing,v=t(h.labelLeft,Math.min(h.pos,l[3])),l=t(h.labelRight,
	Math.max(h.isRadial?0:h.pos+h.len,d-l[1])),b=this.label,c=this.rotation,f={left:0,center:.5,right:1}[h.labelAlign||b.attr("align")],w=b.getBBox().width,x=h.getSlotWidth(this),m=x,I=1,z,u={};if(c||"justify"!==t(n.overflow,"justify"))0>c&&e-f*w<v?z=Math.round(e/Math.cos(c*C)-v):0<c&&e+f*w>l&&(z=Math.round((d-e)/Math.cos(c*C)));else if(d=e+(1-f)*w,e-f*w<v?m=a.x+m*(1-f)-v:d>l&&(m=l-a.x+m*f,I=-1),m=Math.min(x,m),m<x&&"center"===h.labelAlign&&(a.x+=I*(x-m-f*(x-Math.min(w,m)))),w>m||h.autoRotation&&(b.styles||
	{}).width)z=m;z&&(this.shortenLabel?this.shortenLabel():(u.width=z,(n.style||{}).textOverflow||(u.textOverflow="ellipsis"),b.css(u)))},getPosition:function(h,k,B,e){var d=this.axis,l=d.chart,v=e&&l.oldChartHeight||l.chartHeight;h={x:h?a.correctFloat(d.translate(k+B,null,null,e)+d.transB):d.left+d.offset+(d.opposite?(e&&l.oldChartWidth||l.chartWidth)-d.right-d.left:0),y:h?v-d.bottom+d.offset-(d.opposite?d.height:0):a.correctFloat(v-d.translate(k+B,null,null,e)-d.transB)};q(this,"afterGetPosition",
	{pos:h});return h},getLabelPosition:function(a,h,k,e,d,l,v,b){var c=this.axis,f=c.transA,w=c.reversed,x=c.staggerLines,m=c.tickRotCorr||{x:0,y:0},I=d.y,z=e||c.reserveSpaceDefault?0:-c.labelOffset*("center"===c.labelAlign?.5:1),u={};F(I)||(I=0===c.side?k.rotation?-8:-k.getBBox().height:2===c.side?m.y+8:Math.cos(k.rotation*C)*(m.y-k.getBBox(!1,0).height/2));a=a+d.x+z+m.x-(l&&e?l*f*(w?-1:1):0);h=h+I-(l&&!e?l*f*(w?1:-1):0);x&&(k=v/(b||1)%x,c.opposite&&(k=x-k-1),h+=c.labelOffset/x*k);u.x=a;u.y=Math.round(h);
	q(this,"afterGetLabelPosition",{pos:u});return u},getMarkPath:function(a,h,k,e,d,l){return l.crispLine(["M",a,h,"L",a+(d?0:-k),h+(d?k:0)],e)},renderGridLine:function(a,h,k){var e=this.axis,d=e.options,l=this.gridLine,v={},b=this.pos,c=this.type,f=t(this.tickmarkOffset,e.tickmarkOffset),w=e.chart.renderer,x=c?c+"Grid":"grid",m=d[x+"LineWidth"],I=d[x+"LineColor"],d=d[x+"LineDashStyle"];l||(v.stroke=I,v["stroke-width"]=m,d&&(v.dashstyle=d),c||(v.zIndex=1),a&&(h=0),this.gridLine=l=w.path().attr(v).addClass("highcharts-"+
	(c?c+"-":"")+"grid-line").add(e.gridGroup));if(l&&(k=e.getPlotLinePath(b+f,l.strokeWidth()*k,a,"pass")))l[a||this.isNew?"attr":"animate"]({d:k,opacity:h})},renderMark:function(a,h,k){var e=this.axis,d=e.options,l=e.chart.renderer,v=this.type,b=v?v+"Tick":"tick",c=e.tickSize(b),f=this.mark,w=!f,x=a.x;a=a.y;var m=t(d[b+"Width"],!v&&e.isXAxis?1:0),d=d[b+"Color"];c&&(e.opposite&&(c[0]=-c[0]),w&&(this.mark=f=l.path().addClass("highcharts-"+(v?v+"-":"")+"tick").add(e.axisGroup),f.attr({stroke:d,"stroke-width":m})),
	f[w?"attr":"animate"]({d:this.getMarkPath(x,a,c[0],f.strokeWidth()*k,e.horiz,l),opacity:h}))},renderLabel:function(a,h,B,e){var d=this.axis,l=d.horiz,v=d.options,b=this.label,c=v.labels,f=c.step,d=t(this.tickmarkOffset,d.tickmarkOffset),w=!0,x=a.x;a=a.y;b&&k(x)&&(b.xy=a=this.getLabelPosition(x,a,b,l,c,d,e,f),this.isFirst&&!this.isLast&&!t(v.showFirstLabel,1)||this.isLast&&!this.isFirst&&!t(v.showLastLabel,1)?w=!1:!l||c.step||c.rotation||h||0===B||this.handleOverflow(a),f&&e%f&&(w=!1),w&&k(a.y)?(a.opacity=
	B,b[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(b.attr("y",-9999),this.isNewLabel=!0))},render:function(h,k,B){var e=this.axis,d=e.horiz,l=this.pos,v=t(this.tickmarkOffset,e.tickmarkOffset),l=this.getPosition(d,l,v,k),v=l.x,b=l.y,e=d&&v===e.pos+e.len||!d&&b===e.pos?-1:1;B=t(B,1);this.isActive=!0;this.renderGridLine(k,B,e);this.renderMark(l,B,e);this.renderLabel(l,k,B,h);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){G(this,this.axis)}}})(J);var fa=function(a){var E=
	a.addEvent,F=a.animObject,G=a.arrayMax,q=a.arrayMin,k=a.color,h=a.correctFloat,t=a.defaultOptions,C=a.defined,n=a.deg2rad,A=a.destroyObjectProperties,B=a.each,e=a.extend,d=a.fireEvent,l=a.format,v=a.getMagnitude,b=a.grep,c=a.inArray,f=a.isArray,w=a.isNumber,x=a.isString,m=a.merge,I=a.normalizeTickInterval,z=a.objectEach,u=a.pick,r=a.removeEvent,K=a.splat,H=a.syncTimeout,p=a.Tick,D=function(){this.init.apply(this,arguments)};a.extend(D.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
	range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
	style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",
	textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var g=b.isX,y=this;y.chart=a;y.horiz=a.inverted&&!y.isZAxis?!g:g;y.isXAxis=g;y.coll=y.coll||(g?"xAxis":"yAxis");d(this,"init",{userOptions:b});y.opposite=
	b.opposite;y.side=b.side||(y.horiz?y.opposite?0:2:y.opposite?1:3);y.setOptions(b);var f=this.options,p=f.type;y.labelFormatter=f.labels.formatter||y.defaultLabelFormatter;y.userOptions=b;y.minPixelPadding=0;y.reversed=f.reversed;y.visible=!1!==f.visible;y.zoomEnabled=!1!==f.zoomEnabled;y.hasNames="category"===p||!0===f.categories;y.categories=f.categories||y.hasNames;y.names||(y.names=[],y.names.keys={});y.plotLinesAndBandsGroups={};y.isLog="logarithmic"===p;y.isDatetimeAxis="datetime"===p;y.positiveValuesOnly=
	y.isLog&&!y.allowNegativeLog;y.isLinked=C(f.linkedTo);y.ticks={};y.labelEdge=[];y.minorTicks={};y.plotLinesAndBands=[];y.alternateBands={};y.len=0;y.minRange=y.userMinRange=f.minRange||f.maxZoom;y.range=f.range;y.offset=f.offset||0;y.stacks={};y.oldStacks={};y.stacksTouched=0;y.max=null;y.min=null;y.crosshair=u(f.crosshair,K(a.options.tooltip.crosshairs)[g?0:1],!1);b=y.options.events;-1===c(y,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,y):a.axes.push(y),a[y.coll].push(y));y.series=y.series||[];a.inverted&&
	!y.isZAxis&&g&&void 0===y.reversed&&(y.reversed=!0);z(b,function(a,g){E(y,g,a)});y.lin2log=f.linearToLogConverter||y.lin2log;y.isLog&&(y.val2lin=y.log2lin,y.lin2val=y.lin2log);d(this,"afterInit")},setOptions:function(a){this.options=m(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],m(t[this.coll],a));d(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var g=
	this.axis,b=this.value,c=g.chart.time,f=g.categories,d=this.dateTimeLabelFormat,p=t.lang,r=p.numericSymbols,p=p.numericSymbolMagnitude||1E3,e=r&&r.length,D,w=g.options.labels.format,g=g.isLog?Math.abs(b):g.tickInterval;if(w)D=l(w,this,c);else if(f)D=b;else if(d)D=c.dateFormat(d,b);else if(e&&1E3<=g)for(;e--&&void 0===D;)c=Math.pow(p,e+1),g>=c&&0===10*b%c&&null!==r[e]&&0!==b&&(D=a.numberFormat(b/c,-1)+r[e]);void 0===D&&(D=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return D},
	getSeriesExtremes:function(){var a=this,y=a.chart;d(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();B(a.series,function(g){if(g.visible||!y.options.chart.ignoreHiddenSeries){var c=g.options,f=c.threshold,d;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=f&&(f=null);if(a.isXAxis)c=g.xData,c.length&&(g=q(c),d=G(c),w(g)||g instanceof Date||(c=b(c,w),g=q(c),d=G(c)),c.length&&(a.dataMin=Math.min(u(a.dataMin,
	c[0],g),g),a.dataMax=Math.max(u(a.dataMax,c[0],d),d)));else if(g.getExtremes(),d=g.dataMax,g=g.dataMin,C(g)&&C(d)&&(a.dataMin=Math.min(u(a.dataMin,g),g),a.dataMax=Math.max(u(a.dataMax,d),d)),C(f)&&(a.threshold=f),!c.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});d(this,"afterGetSeriesExtremes")},translate:function(a,b,c,f,d,p){var g=this.linkedParent||this,y=1,r=0,e=f?g.oldTransA:g.transA;f=f?g.oldMin:g.min;var D=g.minPixelPadding;d=(g.isOrdinal||g.isBroken||g.isLog&&d)&&g.lin2val;e||
	(e=g.transA);c&&(y*=-1,r=g.len);g.reversed&&(y*=-1,r-=y*(g.sector||g.len));b?(a=(a*y+r-D)/e+f,d&&(a=g.lin2val(a))):(d&&(a=g.val2lin(a)),a=w(f)?y*(a-f)*e+r+y*D+(w(p)?e*p:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,f,d){var g=this.chart,y=this.left,p=this.top,r,e,D=c&&g.oldChartHeight||g.chartHeight,L=c&&g.oldChartWidth||
	g.chartWidth,m;r=this.transB;var v=function(a,g,b){if("pass"!==f&&a<g||a>b)f?a=Math.min(Math.max(g,a),b):m=!0;return a};d=u(d,this.translate(a,null,null,c));d=Math.min(Math.max(-1E5,d),1E5);a=c=Math.round(d+r);r=e=Math.round(D-d-r);w(d)?this.horiz?(r=p,e=D-this.bottom,a=c=v(a,y,y+this.width)):(a=y,c=L-this.right,r=e=v(r,p,p+this.height)):(m=!0,f=!1);return m&&!f?null:g.renderer.crispLine(["M",a,r,"L",c,e],b||1)},getLinearTickPositions:function(a,b,c){var g,y=h(Math.floor(b/a)*a);c=h(Math.ceil(c/a)*
	a);var f=[],d;h(y+a)===y&&(d=20);if(this.single)return[b];for(b=y;b<=c;){f.push(b);b=h(b+a,d);if(b===g)break;g=b}return f},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?u(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,c=a.tickPositions,f=a.minorTickInterval,d=[],p=a.pointRangePadding||0,r=a.min-p,p=a.max+p,e=p-r;if(e&&e/f<a.len/3)if(a.isLog)B(this.paddedTicks,function(g,b,y){b&&d.push.apply(d,
	a.getLogTickPositions(f,y[b-1],y[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())d=d.concat(a.getTimeTicks(a.normalizeTimeTickInterval(f),r,p,b.startOfWeek));else for(b=r+(c[0]-r)%f;b<=p&&b!==d[0];b+=f)d.push(b);0!==d.length&&a.trimTicks(d);return d},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,f,d,p,r,e,D,w,m;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(C(a.min)||C(a.max)?this.minRange=null:(B(this.series,function(a){D=a.xData;for(r=w=a.xIncrement?
	1:D.length-1;0<r;r--)if(e=D[r]-D[r-1],void 0===p||e<p)p=e}),this.minRange=Math.min(5*p,this.dataMax-this.dataMin)));c-b<this.minRange&&(d=this.dataMax-this.dataMin>=this.minRange,m=this.minRange,f=(m-c+b)/2,f=[b-f,u(a.min,b-f)],d&&(f[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=G(f),c=[b+m,u(a.max,b+m)],d&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=q(c),c-b<m&&(f[0]=c-m,f[1]=u(a.min,c-m),b=G(f)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:B(this.series,
	function(g){var b=g.closestPointRange,y=g.visible||!g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip&&C(b)&&y&&(a=C(a)?Math.min(a,b):b)});return a},nameToX:function(a){var g=f(this.categories),b=g?this.categories:this.names,d=a.options.x,p;a.series.requireSorting=!1;C(d)||(d=!1===this.options.uniqueNames?a.series.autoIncrement():g?c(a.name,b):u(b.keys[a.name],-1));-1===d?g||(p=b.length):p=d;void 0!==p&&(this.names[p]=a.name,this.names.keys[a.name]=p);return p},updateNames:function(){var g=
	this,b=this.names;0<b.length&&(B(a.keys(b.keys),function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,B(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();B(a.points,function(b,y){var c;b.options&&(c=g.nameToX(b),void 0!==c&&c!==b.x&&(b.x=c,a.xData[y]=c))})}))},setAxisTranslation:function(a){var g=this,b=g.max-g.min,c=g.axisPointRange||0,f,p=0,r=0,e=g.linkedParent,D=!!g.categories,w=g.transA,m=g.isXAxis;if(m||D||c)f=g.getClosest(),
	e?(p=e.minPointOffset,r=e.pointRangePadding):B(g.series,function(a){var b=D?1:m?u(a.options.pointRange,f,0):g.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,b);g.single||(p=Math.max(p,x(a)?0:b/2),r=Math.max(r,"on"===a?0:b))}),e=g.ordinalSlope&&f?g.ordinalSlope/f:1,g.minPointOffset=p*=e,g.pointRangePadding=r*=e,g.pointRange=Math.min(c,b),m&&(g.closestPointRange=f);a&&(g.oldTransA=w);g.translationSlope=g.transA=w=g.staticScale||g.len/(b+r||1);g.transB=g.horiz?g.left:g.bottom;g.minPixelPadding=
	w*p;d(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(g){var b=this,c=b.chart,f=b.options,p=b.isLog,r=b.isDatetimeAxis,e=b.isXAxis,D=b.isLinked,m=f.maxPadding,l=f.minPadding,x=f.tickInterval,z=f.tickPixelInterval,H=b.categories,K=w(b.threshold)?b.threshold:null,k=b.softThreshold,n,t,A,q;r||H||D||this.getTickAmount();A=u(b.userMin,f.min);q=u(b.userMax,f.max);D?(b.linkedParent=c[b.coll][f.linkedTo],c=b.linkedParent.getExtremes(),b.min=u(c.min,
	c.dataMin),b.max=u(c.max,c.dataMax),f.type!==b.linkedParent.options.type&&a.error(11,1)):(!k&&C(K)&&(b.dataMin>=K?(n=K,l=0):b.dataMax<=K&&(t=K,m=0)),b.min=u(A,n,b.dataMin),b.max=u(q,t,b.dataMax));p&&(b.positiveValuesOnly&&!g&&0>=Math.min(b.min,u(b.dataMin,b.min))&&a.error(10,1),b.min=h(b.log2lin(b.min),15),b.max=h(b.log2lin(b.max),15));b.range&&C(b.max)&&(b.userMin=b.min=A=Math.max(b.dataMin,b.minFromRange()),b.userMax=q=b.max,b.range=null);d(b,"foundExtremes");b.beforePadding&&b.beforePadding();
	b.adjustForMinRange();!(H||b.axisPointRange||b.usePercentage||D)&&C(b.min)&&C(b.max)&&(c=b.max-b.min)&&(!C(A)&&l&&(b.min-=c*l),!C(q)&&m&&(b.max+=c*m));w(f.softMin)&&!w(b.userMin)&&(b.min=Math.min(b.min,f.softMin));w(f.softMax)&&!w(b.userMax)&&(b.max=Math.max(b.max,f.softMax));w(f.floor)&&(b.min=Math.max(b.min,f.floor));w(f.ceiling)&&(b.max=Math.min(b.max,f.ceiling));k&&C(b.dataMin)&&(K=K||0,!C(A)&&b.min<K&&b.dataMin>=K?b.min=K:!C(q)&&b.max>K&&b.dataMax<=K&&(b.max=K));b.tickInterval=b.min===b.max||
	void 0===b.min||void 0===b.max?1:D&&!x&&z===b.linkedParent.options.tickPixelInterval?x=b.linkedParent.tickInterval:u(x,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,H?1:(b.max-b.min)*z/Math.max(b.len,z));e&&!g&&B(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!x&&(b.tickInterval=
	Math.max(b.pointRange,b.tickInterval));g=u(f.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!x&&b.tickInterval<g&&(b.tickInterval=g);r||p||x||(b.tickInterval=I(b.tickInterval,null,v(b.tickInterval),u(f.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var b=this.options,c,f=b.tickPositions;c=this.getMinorTickInterval();var p=b.tickPositioner,r=
	b.startOnTick,e=b.endOnTick;this.tickmarkOffset=this.categories&&"between"===b.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===c&&this.tickInterval?this.tickInterval/5:c;this.single=this.min===this.max&&C(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==b.allowDecimals);this.tickPositions=c=f&&f.slice();!c&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(c=[this.min,this.max],a.error(19)):c=this.isDatetimeAxis?
	this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,b.units),this.min,this.max,b.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),c.length>this.len&&(c=[c[0],c.pop()],c[0]===c[1]&&(c.length=1)),this.tickPositions=c,p&&(p=p.apply(this,[this.min,this.max])))&&(this.tickPositions=c=p);this.paddedTicks=c.slice(0);this.trimTicks(c,r,e);this.isLinked||
	(this.single&&2>c.length&&(this.min-=.5,this.max+=.5),f||p||this.adjustTickAmount());d(this,"afterSetTickPositions")},trimTicks:function(a,b,c){var g=a[0],f=a[a.length-1],d=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-d>a[0];)a.shift();if(c)this.max=f;else for(;this.max+d<a[a.length-1];)a.pop();0===a.length&&C(g)&&!this.options.tickPositions&&a.push((f+g)/2)}},alignToOthers:function(){var a={},b,c=this.options;!1===this.chart.options.chart.alignTicks||
	!1===c.alignTicks||!1===c.startOnTick||!1===c.endOnTick||this.isLog||B(this.chart[this.coll],function(g){var c=g.options,c=[g.horiz?c.left:c.top,c.width,c.height,c.pane].join();g.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!C(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=
	b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,f=this.finalTickAmt,d=b&&b.length,p=u(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(d<c){for(;b.length<c;)b.length%2||this.min===p?b.push(h(b[b.length-1]+a)):b.unshift(h(b[0]-a));this.transA*=(d-1)/(c-1);this.min=b[0];this.max=b[b.length-1]}else d>c&&(this.tickInterval*=2,this.setTickPositions());if(C(f)){for(a=c=b.length;a--;)(3===f&&1===a%2||2>=f&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=
	void 0}}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;B(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=
	this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();d(this,"afterSetScale")},setExtremes:function(a,b,c,f,p){var g=this,r=g.chart;c=u(c,!0);B(g.series,function(a){delete a.kdTree});p=e(p,{min:a,max:b});d(g,"setExtremes",p,function(){g.userMin=a;g.userMax=b;g.eventArgs=p;c&&r.redraw(f)})},zoom:function(a,b){var g=this.dataMin,c=this.dataMax,f=this.options,d=Math.min(g,u(f.min,g)),f=Math.max(c,u(f.max,c));if(a!==this.min||
	b!==this.max)this.allowZoomOutside||(C(g)&&(a<d&&(a=d),a>f&&(a=f)),C(c)&&(b<d&&(b=d),b>f&&(b=f))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,c=this.options,f=c.offsets||[0,0,0,0],d=this.horiz,p=this.width=Math.round(a.relativeLength(u(c.width,b.plotWidth-f[3]+f[1]),b.plotWidth)),r=this.height=Math.round(a.relativeLength(u(c.height,b.plotHeight-f[0]+f[2]),b.plotHeight)),e=this.top=Math.round(a.relativeLength(u(c.top,
	b.plotTop+f[0]),b.plotHeight,b.plotTop)),c=this.left=Math.round(a.relativeLength(u(c.left,b.plotLeft+f[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-r-e;this.right=b.chartWidth-p-c;this.len=Math.max(d?p:r,0);this.pos=d?c:e},getExtremes:function(){var a=this.isLog;return{min:a?h(this.lin2log(this.min)):this.min,max:a?h(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):
	this.min,b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(u(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],c=u(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&
	this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,f=c,d=this.len/(((this.categories?1:0)+this.max-this.min)/c),p,r=a.rotation,e=this.labelMetrics(),D,m=Number.MAX_VALUE,w,v=function(a){a/=d||1;a=1<a?Math.ceil(a):1;return h(a*c)};b?(w=!a.staggerLines&&!a.step&&(C(r)?[r]:d<u(a.autoRotationLimit,80)&&a.autoRotation))&&B(w,function(a){var b;if(a===r||a&&-90<=a&&90>=a)D=v(Math.abs(e.h/Math.sin(n*a))),b=
	D+Math.abs(a/360),b<m&&(m=b,p=a,f=D)}):a.step||(f=v(e.h));this.autoRotation=w;this.labelRotation=u(p,r);return f},getSlotWidth:function(a){var b=this.chart,g=this.horiz,c=this.options.labels,f=Math.max(this.tickPositions.length-(this.categories?0:1),1),d=b.margin[3];return a&&a.slotWidth||g&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/f||!g&&(c.style&&parseInt(c.style.width,10)||d&&d-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,c=this.tickPositions,
	f=this.ticks,d=this.options.labels,p=d&&d.style||{},r=this.horiz,e=this.getSlotWidth(),D=Math.max(1,Math.round(e-2*(d.padding||5))),w={},m=this.labelMetrics(),v=d.style&&d.style.textOverflow,l,z,H=0,u;x(d.rotation)||(w.rotation=d.rotation||0);B(c,function(a){(a=f[a])&&a.label&&a.label.textPxLength>H&&(H=a.label.textPxLength)});this.maxLabelLength=H;if(this.autoRotation)H>D&&H>m.h?w.rotation=this.labelRotation:this.labelRotation=0;else if(e&&(l=D,!v))for(z="clip",D=c.length;!r&&D--;)if(u=c[D],u=f[u].label)u.styles&&
	"ellipsis"===u.styles.textOverflow?u.css({textOverflow:"clip"}):u.textPxLength>e&&u.css({width:e+"px"}),u.getBBox().height>this.len/c.length-(m.h-m.f)&&(u.specificTextOverflow="ellipsis");w.rotation&&(l=H>.5*a.chartHeight?.33*a.chartHeight:H,v||(z="ellipsis"));if(this.labelAlign=d.align||this.autoLabelAlign(this.labelRotation))w.align=this.labelAlign;B(c,function(a){var b=(a=f[a])&&a.label,g=p.width,c={};b&&(b.attr(w),a.shortenLabel?a.shortenLabel():l&&!g&&"nowrap"!==p.whiteSpace&&(l<b.textPxLength||
	"SPAN"===b.element.tagName)?(c.width=l,v||(c.textOverflow=b.specificTextOverflow||z),b.css(c)):b.styles&&b.styles.width&&!c.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=w.rotation)},this);this.tickRotCorr=b.rotCorr(m.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||C(this.min)&&C(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,g=this.horiz,c=this.opposite,f=this.options.title,
	d;this.axisTitle||((d=f.textAlign)||(d=(g?{low:"left",middle:"center",high:"right"}:{low:c?"right":"left",middle:"center",high:c?"left":"right"})[f.align]),this.axisTitle=b.text(f.text,0,0,f.useHTML).attr({zIndex:7,rotation:f.rotation||0,align:d}).addClass("highcharts-axis-title").css(m(f.style)).add(this.axisGroup),this.axisTitle.isNew=!0);f.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():
	b[a]=new p(this,a)},getOffset:function(){var a=this,b=a.chart,c=b.renderer,f=a.options,p=a.tickPositions,r=a.ticks,e=a.horiz,D=a.side,w=b.inverted&&!a.isZAxis?[1,0,3,2][D]:D,m,v,l=0,x,H=0,K=f.title,h=f.labels,k=0,I=b.axisOffset,b=b.clipOffset,n=[-1,1,1,-1][D],t=f.className,A=a.axisParent;m=a.hasData();a.showAxis=v=m||u(f.showEmpty,!0);a.staggerLines=a.horiz&&h.staggerLines;a.axisGroup||(a.gridGroup=c.g("grid").attr({zIndex:f.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+
	(t||"")).add(A),a.axisGroup=c.g("axis").attr({zIndex:f.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(t||"")).add(A),a.labelGroup=c.g("axis-labels").attr({zIndex:h.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(t||"")).add(A));m||a.isLinked?(B(p,function(b,g){a.generateTick(b,g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===D||2===D||{1:"left",3:"right"}[D]===a.labelAlign,u(h.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&B(p,function(a){k=
	Math.max(r[a].getLabelSize(),k)}),a.staggerLines&&(k*=a.staggerLines),a.labelOffset=k*(a.opposite?-1:1)):z(r,function(a,b){a.destroy();delete r[b]});K&&K.text&&!1!==K.enabled&&(a.addTitle(v),v&&!1!==K.reserveSpace&&(a.titleOffset=l=a.axisTitle.getBBox()[e?"height":"width"],x=K.offset,H=C(x)?0:u(K.margin,e?5:10)));a.renderLine();a.offset=n*u(f.offset,I[D]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=0===D?-a.labelMetrics().h:2===D?a.tickRotCorr.y:0;H=Math.abs(k)+H;k&&(H=H-c+n*(e?u(h.y,a.tickRotCorr.y+
	8*n):h.x));a.axisTitleMargin=u(x,H);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(r,p));e=this.tickSize("tick");I[D]=Math.max(I[D],a.axisTitleMargin+l+n*a.offset,H,m&&p.length&&e?e[0]+n*a.offset:0);f=f.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[w]=Math.max(b[w],f);d(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,g=this.opposite,c=this.offset,f=this.horiz,d=this.left+(g?this.width:0)+c,c=b.chartHeight-this.bottom-(g?this.height:0)+c;g&&(a*=-1);return b.renderer.crispLine(["M",
	f?this.left:d,f?c:this.top,"L",f?b.chartWidth-this.right:d,f?c:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,f=this.len,d=this.options.title,p=a?b:c,r=this.opposite,e=this.offset,D=d.x||0,w=d.y||0,m=this.axisTitle,v=
	this.chart.renderer.fontMetrics(d.style&&d.style.fontSize,m),m=Math.max(m.getBBox(null,0).height-v.h-1,0),f={low:p+(a?0:f),middle:p+f/2,high:p+(a?f:0)}[d.align],b=(a?c+this.height:b)+(a?1:-1)*(r?-1:1)*this.axisTitleMargin+[-m,m,v.f,-m][this.side];return{x:a?f+D:b+(r?this.width:0)+e+D,y:a?b+w-(r?this.height:0)+e:f+w}},renderMinorTick:function(a){var b=this.chart.hasRendered&&w(this.oldMin),g=this.minorTicks;g[a]||(g[a]=new p(this,a,"minor"));b&&g[a].isNew&&g[a].render(null,!0);g[a].render(null,!1,
	1)},renderTick:function(a,b){var g=this.isLinked,c=this.ticks,f=this.chart.hasRendered&&w(this.oldMin);if(!g||a>=this.min&&a<=this.max)c[a]||(c[a]=new p(this,a)),f&&c[a].isNew&&c[a].render(b,!0,-1),c[a].render(b)},render:function(){var b=this,c=b.chart,f=b.options,r=b.isLog,e=b.isLinked,D=b.tickPositions,m=b.axisTitle,v=b.ticks,l=b.minorTicks,x=b.alternateBands,u=f.stackLabels,K=f.alternateGridColor,h=b.tickmarkOffset,k=b.axisLine,I=b.showAxis,n=F(c.renderer.globalAnimation),t,A;b.labelEdge.length=
	0;b.overlap=!1;B([v,l,x],function(a){z(a,function(a){a.isActive=!1})});if(b.hasData()||e)b.minorTickInterval&&!b.categories&&B(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),D.length&&(B(D,function(a,g){b.renderTick(a,g)}),h&&(0===b.min||b.single)&&(v[-1]||(v[-1]=new p(b,-1,null,!0)),v[-1].render(-1))),K&&B(D,function(g,f){A=void 0!==D[f+1]?D[f+1]+h:b.max-h;0===f%2&&g<b.max&&A<=b.max+(c.polar?-h:h)&&(x[g]||(x[g]=new a.PlotLineOrBand(b)),t=g+h,x[g].options={from:r?b.lin2log(t):t,to:r?
	b.lin2log(A):A,color:K},x[g].render(),x[g].isActive=!0)}),b._addedPlotLB||(B((f.plotLines||[]).concat(f.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);B([v,l,x],function(a){var b,g=[],f=n.duration;z(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,g.push(b))});H(function(){for(b=g.length;b--;)a[g[b]]&&!a[g[b]].isActive&&(a[g[b]].destroy(),delete a[g[b]])},a!==x&&c.hasRendered&&f?f:0)});k&&(k[k.isPlaced?"animate":"attr"]({d:this.getLinePath(k.strokeWidth())}),k.isPlaced=
	!0,k[I?"show":"hide"](!0));m&&I&&(f=b.getTitlePosition(),w(f.y)?(m[m.isNew?"attr":"animate"](f),m.isNew=!1):(m.attr("y",-9999),m.isNew=!0));u&&u.enabled&&b.renderStackTotals();b.isDirty=!1;d(this,"afterRender")},redraw:function(){this.visible&&(this.render(),B(this.plotLinesAndBands,function(a){a.render()}));B(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,g=b.stacks,f=b.plotLinesAndBands,p;d(this,"destroy",
	{keepEvents:a});a||r(b);z(g,function(a,b){A(a);g[b]=null});B([b.ticks,b.minorTicks,b.alternateBands],function(a){A(a)});if(f)for(a=f.length;a--;)f[a].destroy();B("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(p in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[p]=b.plotLinesAndBandsGroups[p].destroy();z(b,function(a,g){-1===c(g,b.keepProps)&&delete b[g]})},drawCrosshair:function(a,b){var g,c=this.crosshair,
	f=u(c.snap,!0),p,r=this.cross;d(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(C(b)||!f)){f?C(b)&&(p=u(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):p=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);C(p)&&(g=this.getPlotLinePath(b&&(this.isXAxis?b.x:u(b.stackY,b.y)),null,null,null,p)||null);if(!C(g)){this.hideCrosshair();return}f=this.categories&&!this.isRadial;r||(this.cross=r=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
	(f?"category ":"thin ")+c.className).attr({zIndex:u(c.zIndex,2)}).add(),r.attr({stroke:c.color||(f?k("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":u(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&r.attr({dashstyle:c.dashStyle}));r.show().attr({d:g});f&&!c.width&&r.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();d(this,"afterDrawCrosshair",{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=D}(J);(function(a){var E=
	a.Axis,F=a.getMagnitude,G=a.normalizeTickInterval,q=a.timeUnits;E.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};E.prototype.normalizeTimeTickInterval=function(a,h){var k=h||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];h=k[k.length-1];var C=q[h[0]],n=h[1],A;for(A=0;A<k.length&&!(h=k[A],C=q[h[0]],
	n=h[1],k[A+1]&&a<=(C*n[n.length-1]+q[k[A+1][0]])/2);A++);C===q.year&&a<5*C&&(n=[1,2,5]);a=G(a/C,n,"year"===h[0]?Math.max(F(a/C),1):1);return{unitRange:C,count:a,unitName:h[0]}}})(J);(function(a){var E=a.Axis,F=a.getMagnitude,G=a.map,q=a.normalizeTickInterval,k=a.pick;E.prototype.getLogTickPositions=function(a,t,C,n){var h=this.options,B=this.len,e=[];n||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),e=this.getLinearTickPositions(a,t,C);else if(.08<=a)for(var B=Math.floor(t),d,l,v,b,c,h=.3<
	a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];B<C+1&&!c;B++)for(l=h.length,d=0;d<l&&!c;d++)v=this.log2lin(this.lin2log(B)*h[d]),v>t&&(!n||b<=C)&&void 0!==b&&e.push(b),b>C&&(c=!0),b=v;else t=this.lin2log(t),C=this.lin2log(C),a=n?this.getMinorTickInterval():h.tickInterval,a=k("auto"===a?null:a,this._minorAutoInterval,h.tickPixelInterval/(n?5:1)*(C-t)/((n?B/this.tickPositions.length:B)||1)),a=q(a,null,F(a)),e=G(this.getLinearTickPositions(a,t,C),this.log2lin),n||(this._minorAutoInterval=a/5);n||(this.tickInterval=
	a);return e};E.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};E.prototype.lin2log=function(a){return Math.pow(10,a)}})(J);(function(a,E){var F=a.arrayMax,G=a.arrayMin,q=a.defined,k=a.destroyObjectProperties,h=a.each,t=a.erase,C=a.merge,n=a.pick;a.PlotLineOrBand=function(a,h){this.axis=a;h&&(this.options=h,this.id=h.id)};a.PlotLineOrBand.prototype={render:function(){a.fireEvent(this,"render");var h=this,k=h.axis,e=k.horiz,d=h.options,l=d.label,v=h.label,b=d.to,c=d.from,f=d.value,w=q(c)&&
	q(b),x=q(f),m=h.svgElem,I=!m,z=[],u=d.color,r=n(d.zIndex,0),K=d.events,z={"class":"highcharts-plot-"+(w?"band ":"line ")+(d.className||"")},H={},p=k.chart.renderer,D=w?"bands":"lines";k.isLog&&(c=k.log2lin(c),b=k.log2lin(b),f=k.log2lin(f));x?(z.stroke=u,z["stroke-width"]=d.width,d.dashStyle&&(z.dashstyle=d.dashStyle)):w&&(u&&(z.fill=u),d.borderWidth&&(z.stroke=d.borderColor,z["stroke-width"]=d.borderWidth));H.zIndex=r;D+="-"+r;(u=k.plotLinesAndBandsGroups[D])||(k.plotLinesAndBandsGroups[D]=u=p.g("plot-"+
	D).attr(H).add());I&&(h.svgElem=m=p.path().attr(z).add(u));if(x)z=k.getPlotLinePath(f,m.strokeWidth());else if(w)z=k.getPlotBandPath(c,b,d);else return;I&&z&&z.length?(m.attr({d:z}),K&&a.objectEach(K,function(a,b){m.on(b,function(a){K[b].apply(h,[a])})})):m&&(z?(m.show(),m.animate({d:z})):(m.hide(),v&&(h.label=v=v.destroy())));l&&q(l.text)&&z&&z.length&&0<k.width&&0<k.height&&!z.isFlat?(l=C({align:e&&w&&"center",x:e?!w&&4:10,verticalAlign:!e&&w&&"middle",y:e?w?16:10:w?6:-4,rotation:e&&!w&&90},l),
	this.renderLabel(l,z,w,r)):v&&v.hide();return h},renderLabel:function(a,h,e,d){var l=this.label,v=this.axis.chart.renderer;l||(l={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(e?"band":"line")+"-label "+(a.className||"")},l.zIndex=d,this.label=l=v.text(a.text,0,0,a.useHTML).attr(l).add(),l.css(a.style));d=h.xBounds||[h[1],h[4],e?h[6]:h[1]];h=h.yBounds||[h[2],h[5],e?h[7]:h[2]];e=G(d);v=G(h);l.align(a,!1,{x:e,y:v,width:F(d)-e,height:F(h)-v});l.show()},destroy:function(){t(this.axis.plotLinesAndBands,
	this);delete this.axis;k(this)}};a.extend(E.prototype,{getPlotBandPath:function(a,h){var e=this.getPlotLinePath(h,null,null,!0),d=this.getPlotLinePath(a,null,null,!0),l=[],v=this.horiz,b=1,c;a=a<this.min&&h<this.min||a>this.max&&h>this.max;if(d&&e)for(a&&(c=d.toString()===e.toString(),b=0),a=0;a<d.length;a+=6)v&&e[a+1]===d[a+1]?(e[a+1]+=b,e[a+4]+=b):v||e[a+2]!==d[a+2]||(e[a+2]+=b,e[a+5]+=b),l.push("M",d[a+1],d[a+2],"L",d[a+4],d[a+5],e[a+4],e[a+5],e[a+1],e[a+2],"z"),l.isFlat=c;return l},addPlotBand:function(a){return this.addPlotBandOrLine(a,
	"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(h,k){var e=(new a.PlotLineOrBand(this,h)).render(),d=this.userOptions;e&&(k&&(d[k]=d[k]||[],d[k].push(h)),this.plotLinesAndBands.push(e));return e},removePlotBandOrLine:function(a){for(var k=this.plotLinesAndBands,e=this.options,d=this.userOptions,l=k.length;l--;)k[l].id===a&&k[l].destroy();h([e.plotLines||[],d.plotLines||[],e.plotBands||[],d.plotBands||[]],function(d){for(l=d.length;l--;)d[l].id===
	a&&t(d,d[l])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(J,fa);(function(a){var E=a.doc,F=a.each,G=a.extend,q=a.format,k=a.isNumber,h=a.map,t=a.merge,C=a.pick,n=a.splat,A=a.syncTimeout,B=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,d){this.chart=a;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!a.inverted;this.shared=d.shared||
	this.split;this.outside=d.outside&&!this.split},cleanSplit:function(a){F(this.chart.series,function(d){var e=d&&d.tt;e&&(!e.isActive||a?d.tt=e.destroy():e.isActive=!1)})},getLabel:function(){var e=this.chart.renderer,d=this.options,l;this.label||(this.outside&&(this.container=l=a.doc.createElement("div"),l.className="highcharts-tooltip-container",a.css(l,{position:"absolute",top:"1px",pointerEvents:d.style&&d.style.pointerEvents}),a.doc.body.appendChild(l),this.renderer=e=new a.Renderer(l,0,0)),this.split?
	this.label=e.g("tooltip"):(this.label=e.label("",0,0,d.shape||"callout",null,null,d.useHTML,null,"tooltip").attr({padding:d.padding,r:d.borderRadius}),this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),this.label.xSetter=function(a){l.style.left=a+"px"},this.label.ySetter=function(a){l.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();
	t(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,t(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);a.clearTimeout(this.tooltipTimeout)},move:function(e,d,l,v){var b=this,c=b.now,f=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(e-c.x)||1<Math.abs(d-
	c.y)),w=b.followPointer||1<b.len;G(c,{x:f?(2*c.x+e)/3:e,y:f?(c.y+d)/2:d,anchorX:w?void 0:f?(2*c.anchorX+l)/3:l,anchorY:w?void 0:f?(c.anchorY+v)/2:v});b.getLabel().attr(c);f&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(e,d,l,v)},32))},hide:function(e){var d=this;a.clearTimeout(this.hideTimer);e=C(e,this.options.hideDelay,500);this.isHidden||(this.hideTimer=A(function(){d.getLabel()[e?"fadeOut":"hide"]();d.isHidden=!0},e))},getAnchor:function(a,d){var e=
	this.chart,v=e.pointer,b=e.inverted,c=e.plotTop,f=e.plotLeft,w=0,x=0,m,k;a=n(a);this.followPointer&&d?(void 0===d.chartX&&(d=v.normalize(d)),a=[d.chartX-e.plotLeft,d.chartY-c]):a[0].tooltipPos?a=a[0].tooltipPos:(F(a,function(a){m=a.series.yAxis;k=a.series.xAxis;w+=a.plotX+(!b&&k?k.left-f:0);x+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!b&&m?m.top-c:0)}),w/=a.length,x/=a.length,a=[b?e.plotWidth-x:w,this.shared&&!b&&1<a.length&&d?d.chartY-c:b?e.plotHeight-w:x]);return h(a,Math.round)},getPosition:function(a,
	d,l){var e=this.chart,b=this.distance,c={},f=e.inverted&&l.h||0,w,x=this.outside,m=x?E.documentElement.clientWidth-2*b:e.chartWidth,h=x?Math.max(E.body.scrollHeight,E.documentElement.scrollHeight,E.body.offsetHeight,E.documentElement.offsetHeight,E.documentElement.clientHeight):e.chartHeight,z=e.pointer.chartPosition,u=["y",h,d,(x?z.top-b:0)+l.plotY+e.plotTop,x?0:e.plotTop,x?h:e.plotTop+e.plotHeight],r=["x",m,a,(x?z.left-b:0)+l.plotX+e.plotLeft,x?0:e.plotLeft,x?m:e.plotLeft+e.plotWidth],K=!this.followPointer&&
	C(l.ttBelow,!e.inverted===!!l.negative),H=function(a,g,d,p,r,e){var D=d<p-b,m=p+b+d<g,w=p-b-d;p+=b;if(K&&m)c[a]=p;else if(!K&&D)c[a]=w;else if(D)c[a]=Math.min(e-d,0>w-f?w:w-f);else if(m)c[a]=Math.max(r,p+f+d>g?p:p+f);else return!1},p=function(a,g,f,d){var p;d<b||d>g-b?p=!1:c[a]=d<f/2?1:d>g-f/2?g-f-2:d-f/2;return p},D=function(a){var b=u;u=r;r=b;w=a},g=function(){!1!==H.apply(0,u)?!1!==p.apply(0,r)||w||(D(!0),g()):w?c.x=c.y=0:(D(!0),g())};(e.inverted||1<this.len)&&D();g();return c},defaultFormatter:function(a){var d=
	this.points||n(this),e;e=[a.tooltipFooterHeaderFormatter(d[0])];e=e.concat(a.bodyFormatter(d));e.push(a.tooltipFooterHeaderFormatter(d[0],!0));return e},refresh:function(e,d){var l,v=this.options,b,c=e,f,w={},x=[];l=v.formatter||this.defaultFormatter;var w=this.shared,m;v.enabled&&(a.clearTimeout(this.hideTimer),this.followPointer=n(c)[0].series.tooltipOptions.followPointer,f=this.getAnchor(c,d),d=f[0],b=f[1],!w||c.series&&c.series.noSharedTooltip?w=c.getLabelConfig():(F(c,function(a){a.setState("hover");
	x.push(a.getLabelConfig())}),w={x:c[0].category,y:c[0].y},w.points=x,c=c[0]),this.len=x.length,w=l.call(w,this),m=c.series,this.distance=C(m.tooltipOptions.distance,16),!1===w?this.hide():(l=this.getLabel(),this.isHidden&&l.attr({opacity:1}).show(),this.split?this.renderSplit(w,n(e)):(v.style.width||l.css({width:this.chart.spacingBox.width}),l.attr({text:w&&w.join?w.join(""):w}),l.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+C(c.colorIndex,m.colorIndex)),l.attr({stroke:v.borderColor||
	c.color||m.color||"#666666"}),this.updatePosition({plotX:d,plotY:b,negative:c.negative,ttBelow:c.ttBelow,h:f[2]||0})),this.isHidden=!1))},renderSplit:function(e,d){var l=this,v=[],b=this.chart,c=b.renderer,f=!0,w=this.options,x=0,m,h=this.getLabel(),z=b.plotTop;a.isString(e)&&(e=[!1,e]);F(e.slice(0,d.length+1),function(a,r){if(!1!==a){r=d[r-1]||{isHeader:!0,plotX:d[0].plotX};var e=r.series||l,H=e.tt,p=r.series||{},D="highcharts-color-"+C(r.colorIndex,p.colorIndex,"none");H||(e.tt=H=c.label(null,null,
	null,"callout",null,null,w.useHTML).addClass("highcharts-tooltip-box "+D+(r.isHeader?" highcharts-tooltip-header":"")).attr({padding:w.padding,r:w.borderRadius,fill:w.backgroundColor,stroke:w.borderColor||r.color||p.color||"#333333","stroke-width":w.borderWidth}).add(h));H.isActive=!0;H.attr({text:a});H.css(w.style).shadow(w.shadow);a=H.getBBox();p=a.width+H.strokeWidth();r.isHeader?(x=a.height,b.xAxis[0].opposite&&(m=!0,z-=x),p=Math.max(0,Math.min(r.plotX+b.plotLeft-p/2,b.chartWidth+(b.scrollablePixels?
	b.scrollablePixels-b.marginRight:0)-p))):p=r.plotX+b.plotLeft-C(w.distance,16)-p;0>p&&(f=!1);a=(r.series&&r.series.yAxis&&r.series.yAxis.pos)+(r.plotY||0);a-=z;r.isHeader&&(a=m?-x:b.plotHeight+x);v.push({target:a,rank:r.isHeader?1:0,size:e.tt.getBBox().height+1,point:r,x:p,tt:H})}});this.cleanSplit();a.distribute(v,b.plotHeight+x);F(v,function(a){var c=a.point,d=c.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:f||c.isHeader?a.x:c.plotX+b.plotLeft+C(w.distance,16),y:a.pos+z,anchorX:c.isHeader?
	c.plotX+b.plotLeft:c.plotX+d.xAxis.pos,anchorY:c.isHeader?b.plotTop+b.plotHeight/2:c.plotY+d.yAxis.pos})})},updatePosition:function(a){var d=this.chart,e=this.getLabel(),v=(this.options.positioner||this.getPosition).call(this,e.width,e.height,a),b=a.plotX+d.plotLeft;a=a.plotY+d.plotTop;var c;this.outside&&(c=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(e.width+c,e.height+c,!1),b+=d.pointer.chartPosition.left-v.x,a+=d.pointer.chartPosition.top-v.y);this.move(Math.round(v.x),
	Math.round(v.y||0),b,a)},getDateFormat:function(a,d,l,v){var b=this.chart.time,c=b.dateFormat("%m-%d %H:%M:%S.%L",d),f,e,x={millisecond:15,second:12,minute:9,hour:6,day:3},m="millisecond";for(e in B){if(a===B.week&&+b.dateFormat("%w",d)===l&&"00:00:00.000"===c.substr(6)){e="week";break}if(B[e]>a){e=m;break}if(x[e]&&c.substr(x[e])!=="01-01 00:00:00.000".substr(x[e]))break;"week"!==e&&(m=e)}e&&(f=b.resolveDTLFormat(v[e]).main);return f},getXDateFormat:function(a,d,l){d=d.dateTimeLabelFormats;var e=
	l&&l.closestPointRange;return(e?this.getDateFormat(e,a.x,l.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(a,d){d=d?"footer":"header";var e=a.series,v=e.tooltipOptions,b=v.xDateFormat,c=e.xAxis,f=c&&"datetime"===c.options.type&&k(a.key),w=v[d+"Format"];f&&!b&&(b=this.getXDateFormat(a,v,c));f&&b&&F(a.point&&a.point.tooltipDateKeys||["key"],function(a){w=w.replace("{point."+a+"}","{point."+a+":"+b+"}")});return q(w,{point:a,series:e},this.chart.time)},bodyFormatter:function(a){return h(a,
	function(a){var d=a.series.tooltipOptions;return(d[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,d[(a.point.formatPrefix||"point")+"Format"])})}}})(J);(function(a){var E=a.addEvent,F=a.attr,G=a.charts,q=a.color,k=a.css,h=a.defined,t=a.each,C=a.extend,n=a.find,A=a.fireEvent,B=a.isNumber,e=a.isObject,d=a.offset,l=a.pick,v=a.splat,b=a.Tooltip;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,f){this.options=f;this.chart=a;this.runChartClick=
	f.chart.events&&!!f.chart.events.click;this.pinchDown=[];this.lastValidTouch={};b&&(a.tooltip=new b(a,f.tooltip),this.followTouchMove=l(f.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,c=b.options.chart,d=c.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(d=l(c.pinchType,d));this.zoomX=a=/x/.test(d);this.zoomY=d=/y/.test(d);this.zoomHor=a&&!b||d&&b;this.zoomVert=d&&!b||a&&b;this.hasZoom=a||d},normalize:function(a,b){var c;c=a.touches?a.touches.length?a.touches.item(0):
	a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));return C(a,{chartX:Math.round(c.pageX-b.left),chartY:Math.round(c.pageY-b.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};t(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,d){var c;t(a,function(a){var f=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(d,f);if((f=e(a,
	!0))&&!(f=!e(c,!0)))var f=c.distX-a.distX,m=c.dist-a.dist,w=(a.series.group&&a.series.group.zIndex)-(c.series.group&&c.series.group.zIndex),f=0<(0!==f&&b?f:0!==m?m:0!==w?w:c.series.index>a.series.index?-1:1);f&&(c=a)});return c},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var c=a.series,f=c.xAxis,c=c.yAxis,d=l(a.clientX,a.plotX),e=a.shapeArgs;if(f&&c)return b?{chartX:f.len+f.pos-d,chartY:c.len+c.pos-a.plotY}:
	{chartX:d+f.pos,chartY:a.plotY+c.pos};if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}},getHoverData:function(b,f,d,v,m,h,z){var c,r=[],w=z&&z.isBoosting;v=!(!v||!b);z=f&&!f.stickyTracking?[f]:a.grep(d,function(a){return a.visible&&!(!m&&a.directTouch)&&l(a.options.enableMouseTracking,!0)&&a.stickyTracking});f=(c=v?b:this.findNearestKDPoint(z,m,h))&&c.series;c&&(m&&!f.noSharedTooltip?(z=a.grep(d,function(a){return a.visible&&!(!m&&a.directTouch)&&l(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),
	t(z,function(a){var b=n(a.points,function(a){return a.x===c.x&&!a.isNull});e(b)&&(w&&(b=a.getPoint(b)),r.push(b))})):r.push(c));return{hoverPoint:c,hoverSeries:f,hoverPoints:r}},runPointActions:function(b,f){var c=this.chart,d=c.tooltip&&c.tooltip.options.enabled?c.tooltip:void 0,e=d?d.shared:!1,v=f||c.hoverPoint,z=v&&v.series||c.hoverSeries,z=this.getHoverData(v,z,c.series,"touchmove"!==b.type&&(!!f||z&&z.directTouch&&this.isDirectTouch),e,b,{isBoosting:c.isBoosting}),u,v=z.hoverPoint;u=z.hoverPoints;
	f=(z=z.hoverSeries)&&z.tooltipOptions.followPointer;e=e&&z&&!z.noSharedTooltip;if(v&&(v!==c.hoverPoint||d&&d.isHidden)){t(c.hoverPoints||[],function(b){-1===a.inArray(b,u)&&b.setState()});t(u||[],function(a){a.setState("hover")});if(c.hoverSeries!==z)z.onMouseOver();c.hoverPoint&&c.hoverPoint.firePointEvent("mouseOut");if(!v.series)return;v.firePointEvent("mouseOver");c.hoverPoints=u;c.hoverPoint=v;d&&d.refresh(e?u:v,b)}else f&&d&&!d.isHidden&&(v=d.getAnchor([{}],b),d.updatePosition({plotX:v[0],plotY:v[1]}));
	this.unDocMouseMove||(this.unDocMouseMove=E(c.container.ownerDocument,"mousemove",function(b){var c=G[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));t(c.axes,function(c){var f=l(c.crosshair.snap,!0),d=f?a.find(u,function(a){return a.series[c.coll]===c}):void 0;d||!f?c.drawCrosshair(b,d):c.hideCrosshair()})},reset:function(a,b){var c=this.chart,f=c.hoverSeries,d=c.hoverPoint,e=c.hoverPoints,l=c.tooltip,u=l&&l.shared?e:d;a&&u&&t(v(u),function(b){b.series.isCartesian&&void 0===b.plotX&&
	(a=!1)});if(a)l&&u&&(l.refresh(u),l.shared&&e?t(e,function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):d&&(d.setState(d.state,!0),t(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,d)})));else{if(d)d.onMouseOut();e&&t(e,function(a){a.setState()});if(f)f.onMouseOut();l&&l.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());t(c.axes,function(a){a.hideCrosshair()});
	this.hoverX=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,b){var c=this.chart,f;t(c.series,function(d){f=a||d.getPlotBox();d.xAxis&&d.xAxis.zoomEnabled&&d.group&&(d.group.attr(f),d.markerGroup&&(d.markerGroup.attr(f),d.markerGroup.clip(b?c.clipRect:null)),d.dataLabelsGroup&&d.dataLabelsGroup.attr(f))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=
	this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,v=this.zoomHor,l=this.zoomVert,u=b.plotLeft,r=b.plotTop,h=b.plotWidth,H=b.plotHeight,p,D=this.selectionMarker,g=this.mouseDownX,y=this.mouseDownY,k=c.panKey&&a[c.panKey+"Key"];D&&D.touch||(d<u?d=u:d>u+h&&(d=u+h),e<r?e=r:e>r+H&&(e=r+H),this.hasDragged=Math.sqrt(Math.pow(g-d,2)+Math.pow(y-e,2)),10<this.hasDragged&&(p=b.isInsidePlot(g-u,y-r),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&p&&!k&&!D&&(this.selectionMarker=D=b.renderer.rect(u,r,v?1:h,
	l?1:H,0).attr({fill:c.selectionMarkerFill||q("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),D&&v&&(d-=g,D.attr({width:Math.abs(d),x:(0<d?0:d)+g})),D&&l&&(d=e-y,D.attr({height:Math.abs(d),y:(0<d?0:d)+y})),p&&!D&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},v=this.selectionMarker,l=v.attr?v.attr("x"):v.x,u=v.attr?v.attr("y"):v.y,r=v.attr?v.attr("width"):
	v.width,K=v.attr?v.attr("height"):v.height,H;if(this.hasDragged||d)t(c.axes,function(c){if(c.zoomEnabled&&h(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var f=c.horiz,g="touchend"===a.type?c.minPixelPadding:0,p=c.toValue((f?l:u)+g),f=c.toValue((f?l+r:u+K)-g);e[c.coll].push({axis:c,min:Math.min(p,f),max:Math.max(p,f)});H=!0}}),H&&A(c,"selection",e,function(a){c.zoom(C(a,d?{animation:!1}:null))});B(c.index)&&(this.selectionMarker=this.selectionMarker.destroy());d&&this.scaleGroups()}c&&B(c.index)&&
	(k(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){G[a.hoverChartIndex]&&G[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||
	b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=G[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;h(a.hoverChartIndex)&&G[a.hoverChartIndex]&&G[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-
	c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var c;a;){if(c=F(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},
	onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(A(c.series,"click",C(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(C(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&A(b,"click",a)))},setDOMEvents:function(){var b=this,d=b.chart.container,e=d.ownerDocument;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};
	d.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=E(d,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=E(e,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},d.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=E(e,"touchend",b.onDocumentTouchEnd)))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();
	a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,c){b[c]=null})}}})(J);(function(a){var E=a.charts,F=a.each,G=a.extend,q=a.map,k=a.noop,h=a.pick;G(a.Pointer.prototype,{pinchTranslate:function(a,h,k,q,B,e){this.zoomHor&&this.pinchTranslateDirection(!0,a,h,k,q,B,e);this.zoomVert&&this.pinchTranslateDirection(!1,a,h,k,q,
	B,e)},pinchTranslateDirection:function(a,h,k,q,B,e,d,l){var v=this.chart,b=a?"x":"y",c=a?"X":"Y",f="chart"+c,w=a?"width":"height",x=v["plot"+(a?"Left":"Top")],m,n,z=l||1,u=v.inverted,r=v.bounds[a?"h":"v"],K=1===h.length,H=h[0][f],p=k[0][f],D=!K&&h[1][f],g=!K&&k[1][f],y;k=function(){!K&&20<Math.abs(H-D)&&(z=l||Math.abs(p-g)/Math.abs(H-D));n=(x-p)/z+H;m=v["plot"+(a?"Width":"Height")]/z};k();h=n;h<r.min?(h=r.min,y=!0):h+m>r.max&&(h=r.max-m,y=!0);y?(p-=.8*(p-d[b][0]),K||(g-=.8*(g-d[b][1])),k()):d[b]=
	[p,g];u||(e[b]=n-x,e[w]=m);e=u?1/z:z;B[w]=m;B[b]=h;q[u?a?"scaleY":"scaleX":"scale"+c]=z;q["translate"+c]=e*x+(p-e*H)},pinch:function(a){var t=this,n=t.chart,A=t.pinchDown,B=a.touches,e=B.length,d=t.lastValidTouch,l=t.hasZoom,v=t.selectionMarker,b={},c=1===e&&(t.inClass(a.target,"highcharts-tracker")&&n.runTrackerClick||t.runChartClick),f={};1<e&&(t.initiated=!0);l&&t.initiated&&!c&&a.preventDefault();q(B,function(a){return t.normalize(a)});"touchstart"===a.type?(F(B,function(a,b){A[b]={chartX:a.chartX,
	chartY:a.chartY}}),d.x=[A[0].chartX,A[1]&&A[1].chartX],d.y=[A[0].chartY,A[1]&&A[1].chartY],F(n.axes,function(a){if(a.zoomEnabled){var b=n.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(h(a.options.min,a.dataMin)),f=a.toPixels(h(a.options.max,a.dataMax)),e=Math.max(d,f);b.min=Math.min(a.pos,Math.min(d,f)-c);b.max=Math.max(a.pos+a.len,e+c)}}),t.res=!0):t.followTouchMove&&1===e?this.runPointActions(t.normalize(a)):A.length&&(v||(t.selectionMarker=v=G({destroy:k,touch:!0},n.plotBox)),t.pinchTranslate(A,
	B,b,v,f,d),t.hasPinched=l,t.scaleGroups(b,f),t.res&&(t.res=!1,this.reset(!1,0)))},touch:function(k,q){var n=this.chart,t,B;if(n.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=n.index;1===k.touches.length?(k=this.normalize(k),(B=n.isInsidePlot(k.chartX-n.plotLeft,k.chartY-n.plotTop))&&!n.openMenu?(q&&this.runPointActions(k),"touchmove"===k.type&&(q=this.pinchDown,t=q[0]?4<=Math.sqrt(Math.pow(q[0].chartX-k.chartX,2)+Math.pow(q[0].chartY-k.chartY,2)):!1),h(t,
	!0)&&this.pinch(k)):q&&this.reset()):2===k.touches.length&&this.pinch(k)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(h){E[a.hoverChartIndex]&&E[a.hoverChartIndex].pointer.drop(h)}})})(J);(function(a){var E=a.addEvent,F=a.charts,G=a.css,q=a.doc,k=a.extend,h=a.noop,t=a.Pointer,C=a.removeEvent,n=a.win,A=a.wrap;if(!a.hasTouch&&(n.PointerEvent||n.MSPointerEvent)){var B={},e=!!n.PointerEvent,d=function(){var d=
	[];d.item=function(a){return this[a]};a.objectEach(B,function(a){d.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return d},l=function(e,b,c,f){"touch"!==e.pointerType&&e.pointerType!==e.MSPOINTER_TYPE_TOUCH||!F[a.hoverChartIndex]||(f(e),f=F[a.hoverChartIndex].pointer,f[b]({type:c,target:e.currentTarget,preventDefault:h,touches:d()}))};k(t.prototype,{onContainerPointerDown:function(a){l(a,"onContainerTouchStart","touchstart",function(a){B[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},
	onContainerPointerMove:function(a){l(a,"onContainerTouchMove","touchmove",function(a){B[a.pointerId]={pageX:a.pageX,pageY:a.pageY};B[a.pointerId].target||(B[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){l(a,"onDocumentTouchEnd","touchend",function(a){delete B[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,e?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,e?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(q,e?
	"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});A(t.prototype,"init",function(a,b,c){a.call(this,b,c);this.hasZoom&&G(b.container,{"-ms-touch-action":"none","touch-action":"none"})});A(t.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(E)});A(t.prototype,"destroy",function(a){this.batchMSEvents(C);a.call(this)})}})(J);(function(a){var E=a.addEvent,F=a.css,G=a.discardElement,q=a.defined,k=a.each,h=a.fireEvent,t=a.isFirefox,C=a.marginNames,
	n=a.merge,A=a.pick,B=a.setAnimation,e=a.stableSort,d=a.win,l=a.wrap;a.Legend=function(a,b){this.init(a,b)};a.Legend.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),E(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=E(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var b=A(a.padding,8);this.options=
	a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=n(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=A(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,b){var c=this.chart;this.setOptions(n(!0,this.options,a));this.destroy();c.isDirtyLegend=c.isDirtyBox=!0;A(b,!0)&&c.redraw();h(this,"afterUpdate")},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");
	var c=this.options,d=a.legendItem,e=a.legendLine,v=a.legendSymbol,m=this.itemHiddenStyle.color,c=b?c.itemStyle.color:m,l=b?a.color||m:m,z=a.options&&a.options.marker,u={fill:l};d&&d.css({fill:c,color:c});e&&e.attr({stroke:l});v&&(z&&v.isMarker&&(u=a.pointAttribs(),b||(u.stroke=u.fill=m)),v.attr(u));h(this,"afterColorizeItem",{item:a,visible:b})},positionItems:function(){k(this.allItems,this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var b=this.options,
	c=b.symbolPadding,b=!b.rtl,d=a._legendItemPos,e=d[0],d=d[1],l=a.checkbox;if((a=a.legendGroup)&&a.element)a[q(a.translateY)?"animate":"attr"]({translateX:b?e:this.legendWidth-e-2*c-4,translateY:d});l&&(l.x=e,l.y=d)},destroyItem:function(a){var b=a.checkbox;k(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}k(this.getAllItems(),function(b){k(["legendItem","legendGroup"],
	a,b)});k("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,b,c=this.clipHeight||this.legendHeight,d=this.titleHeight;a&&(b=a.translateY,k(this.allItems,function(f){var e=f.checkbox,m;e&&(m=b+d+e.y+(this.scrollOffset||0)+3,F(e,{left:a.translateX+f.checkboxOffset+e.x-20+"px",top:m+"px",display:this.proximate||m>b-6&&m<b+c-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,b=this.padding,
	c=a.title,d=0;c.text&&(this.title||(this.title=this.chart.renderer.label(c.text,b-3,b-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(c.style).add(this.group)),a=this.title.getBBox(),d=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:d}));this.titleHeight=d},setText:function(d){var b=this.options;d.legendItem.attr({text:b.labelFormat?a.format(b.labelFormat,d,this.chart.time):b.labelFormatter.call(d)})},renderItem:function(a){var b=this.chart,c=b.renderer,d=
	this.options,e=this.symbolWidth,l=d.symbolPadding,m=this.itemStyle,v=this.itemHiddenStyle,z="horizontal"===d.layout?A(d.itemDistance,20):0,u=!d.rtl,r=a.legendItem,h=!a.series,H=!h&&a.series.drawLegendSymbol?a.series:a,p=H.options,p=this.createCheckboxForItem&&p&&p.showCheckbox,z=e+l+z+(p?20:0),D=d.useHTML,g=a.options.className;r||(a.legendGroup=c.g("legend-item").addClass("highcharts-"+H.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(h?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),
	a.legendItem=r=c.text("",u?e+l:-l,this.baseline||0,D).css(n(a.visible?m:v)).attr({align:u?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(e=m.fontSize,this.fontMetrics=c.fontMetrics(e,r),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,r.attr("y",this.baseline)),this.symbolHeight=d.symbolHeight||this.fontMetrics.f,H.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,r,D),p&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);m.width||r.css({width:(d.itemWidth||
	d.width||b.spacingBox.width)-z});this.setText(a);b=r.getBBox();a.itemWidth=a.checkboxOffset=d.itemWidth||a.legendItemWidth||b.width+z;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||b.height||this.symbolHeight)},layoutItem:function(a){var b=this.options,c=this.padding,d="horizontal"===b.layout,e=a.itemHeight,l=b.itemMarginBottom||0,m=this.itemMarginTop,v=d?A(b.itemDistance,20):0,z=b.width,u=z||this.chart.spacingBox.width-
	2*c-b.x,b=b.alignColumns&&this.totalItemWidth>u?this.maxItemWidth:a.itemWidth;d&&this.itemX-c+b>u&&(this.itemX=c,this.itemY+=m+this.lastLineHeight+l,this.lastLineHeight=0);this.lastItemY=m+this.itemY+l;this.lastLineHeight=Math.max(e,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];d?this.itemX+=b:(this.itemY+=m+e+l,this.lastLineHeight=e);this.offsetWidth=z||Math.max((d?this.itemX-c-(a.checkbox?0:v):b)+c,this.offsetWidth)},getAllItems:function(){var a=[];k(this.chart.series,function(b){var c=
	b&&b.options;b&&A(c.showInLegend,q(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?b.data:b)))});h(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,b){var c=this.chart,d=this.options,e=this.getAlignment();e&&k([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(f,
	m){f.test(e)&&!q(a[m])&&(c[C[m]]=Math.max(c[C[m]],c.legend[(m+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][m]*d[m%2?"x":"y"]+A(d.margin,12)+b[m]+(0===m&&void 0!==c.options.title.margin?c.titleOffset+c.options.title.margin:0)))})},proximatePositions:function(){var d=this.chart,b=[],c="left"===this.options.align;k(this.allItems,function(f){var e,l;e=c;f.xAxis&&f.points&&(f.xAxis.options.reversed&&(e=!e),e=a.find(e?f.points:f.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),l=f.legendGroup.getBBox().height,
	b.push({target:f.visible?(e?e.plotY:f.xAxis.height)-.3*l:d.plotHeight,size:l,item:f}))},this);a.distribute(b,d.plotHeight);k(b,function(a){a.item._legendItemPos[1]=d.plotTop-d.spacing[0]+a.pos})},render:function(){var a=this.chart,b=a.renderer,c=this.group,d,l,h,m=this.box,I=this.options,z=this.padding;this.itemX=z;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;c||(this.group=c=b.g("legend").attr({zIndex:7}).add(),this.contentGroup=b.g().attr({zIndex:1}).add(c),this.scrollGroup=b.g().add(this.contentGroup));
	this.renderTitle();d=this.getAllItems();e(d,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});I.reversed&&d.reverse();this.allItems=d;this.display=l=!!d.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;k(d,this.renderItem,this);k(d,this.layoutItem,this);d=(I.width||this.offsetWidth)+z;h=this.lastItemY+this.lastLineHeight+this.titleHeight;h=this.handleOverflow(h);h+=z;m||(this.box=m=b.rect().addClass("highcharts-legend-box").attr({r:I.borderRadius}).add(c),
	m.isNew=!0);m.attr({stroke:I.borderColor,"stroke-width":I.borderWidth||0,fill:I.backgroundColor||"none"}).shadow(I.shadow);0<d&&0<h&&(m[m.isNew?"attr":"animate"](m.crisp.call({},{x:0,y:0,width:d,height:h},m.strokeWidth())),m.isNew=!1);m[l?"show":"hide"]();this.legendWidth=d;this.legendHeight=h;l&&(b=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(b=n(b,{y:b.y+a.titleOffset+a.options.title.margin})),c.align(n(I,{width:d,height:h,verticalAlign:this.proximate?"top":I.verticalAlign}),!0,b));this.proximate||
	this.positionItems()},handleOverflow:function(a){var b=this,c=this.chart,d=c.renderer,e=this.options,l=e.y,m=this.padding,c=c.spacingBox.height+("top"===e.verticalAlign?-l:l)-m,l=e.maxHeight,h,z=this.clipRect,u=e.navigation,r=A(u.animation,!0),v=u.arrowSize||12,H=this.nav,p=this.pages,D,g=this.allItems,y=function(a){"number"===typeof a?z.attr({height:a}):z&&(b.clipRect=z.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+m+"px,9999px,"+(m+a)+"px,0)":"auto")};
	"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(c/=2);l&&(c=Math.min(c,l));p.length=0;a>c&&!1!==u.enabled?(this.clipHeight=h=Math.max(c-20-this.titleHeight-m,0),this.currentPage=A(this.currentPage,1),this.fullHeight=a,k(g,function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),f=p.length;if(!f||c-p[f-1]>h&&(D||c)!==p[f-1])p.push(D||c),f++;a.pageIx=f-1;D&&(g[b-1].pageIx=f-1);b===g.length-1&&c+d-p[f-1]>h&&(p.push(c),a.pageIx=f);c!==D&&(D=c)}),z||(z=b.clipRect=
	d.clipRect(0,m,9999,0),b.contentGroup.clip(z)),y(h),H||(this.nav=H=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",0,0,v,v).on("click",function(){b.scroll(-1,r)}).add(H),this.pager=d.text("",15,10).addClass("highcharts-legend-navigation").css(u.style).add(H),this.down=d.symbol("triangle-down",0,0,v,v).on("click",function(){b.scroll(1,r)}).add(H)),b.scroll(0),a=c):H&&(y(),this.nav=H.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,b){var c=
	this.pages,d=c.length;a=this.currentPage+a;var e=this.clipHeight,l=this.options.navigation,m=this.pager,h=this.padding;a>d&&(a=d);0<a&&(void 0!==b&&B(b,this.chart),this.nav.attr({translateX:h,translateY:e+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),m.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
	this.up.attr({fill:1===a?l.inactiveColor:l.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?l.inactiveColor:l.activeColor}).css({cursor:a===d?"default":"pointer"}),this.scrollOffset=-c[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.symbolHeight,d=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-c)/2:
	0,a.baseline-c+1,d?c:a.symbolWidth,c,A(a.options.symbolRadius,c/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,c=b.marker,d=a.symbolWidth,e=a.symbolHeight,l=e/2,m=this.chart.renderer,h=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var z;z={"stroke-width":b.lineWidth||0};b.dashStyle&&(z.dashstyle=b.dashStyle);this.legendLine=m.path(["M",0,a,"L",d,a]).addClass("highcharts-graph").attr(z).add(h);c&&!1!==c.enabled&&d&&
	(b=Math.min(A(c.radius,l),l),0===this.symbol.indexOf("url")&&(c=n(c,{width:e,height:e}),b=0),this.legendSymbol=c=m.symbol(this.symbol,d/2-b,a-b,2*b,2*b,c).addClass("highcharts-point").add(h),c.isMarker=!0)}};(/Trident\/7\.0/.test(d.navigator.userAgent)||t)&&l(a.Legend.prototype,"positionItem",function(a,b){var c=this,d=function(){b._legendItemPos&&a.call(c,b)};d();setTimeout(d)})})(J);(function(a){var E=a.addEvent,F=a.animate,G=a.animObject,q=a.attr,k=a.doc,h=a.Axis,t=a.createElement,C=a.defaultOptions,
	n=a.discardElement,A=a.charts,B=a.css,e=a.defined,d=a.each,l=a.extend,v=a.find,b=a.fireEvent,c=a.grep,f=a.isNumber,w=a.isObject,x=a.isString,m=a.Legend,I=a.marginNames,z=a.merge,u=a.objectEach,r=a.Pointer,K=a.pick,H=a.pInt,p=a.removeEvent,D=a.seriesTypes,g=a.splat,y=a.syncTimeout,O=a.win,Q=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,g){return new Q(a,b,g)};l(Q.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(x(a[0])||a[0].nodeName)this.renderTo=
	a.shift();this.init(a[0],a[1])},init:function(g,c){var d,e,f=g.series,p=g.plotOptions||{};b(this,"init",{args:arguments},function(){g.series=null;d=z(C,g);for(e in d.plotOptions)d.plotOptions[e].tooltip=p[e]&&z(p[e].tooltip)||void 0;d.tooltip.userOptions=g.chart&&g.chart.forExport&&g.tooltip.userOptions||g.tooltip;d.series=g.series=f;this.userOptions=g;var r=d.chart,D=r.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=
	d;this.axes=[];this.series=[];this.time=g.time&&a.keys(g.time).length?new a.Time(g.time):a.time;this.hasCartesianSeries=r.showAxes;var l=this;l.index=A.length;A.push(l);a.chartCount++;D&&u(D,function(a,b){E(l,b,a)});l.xAxis=[];l.yAxis=[];l.pointCount=l.colorCounter=l.symbolCounter=0;b(l,"afterInit");l.firstRender()})},initSeries:function(b){var g=this.options.chart;(g=D[b.type||g.type||g.defaultSeriesType])||a.error(17,!0);g=new g;g.init(this,b);return g},orderSeries:function(a){var b=this.series;
	for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,g){var c=g?b:a;a=g?a:b;return 0<=c&&c<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(g){b(this,"beforeRedraw");var c=this.axes,e=this.series,f=this.pointer,p=this.legend,r=this.userOptions.legend,D=this.isDirtyLegend,m,y,H=this.hasCartesianSeries,h=this.isDirtyBox,z,u=this.renderer,w=u.isHidden(),k=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(g,this);w&&this.temporaryDisplay();
	this.layOutTitles();for(g=e.length;g--;)if(z=e[g],z.options.stacking&&(m=!0,z.isDirty)){y=!0;break}if(y)for(g=e.length;g--;)z=e[g],z.options.stacking&&(z.isDirty=!0);d(e,function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),D=!0):r&&(r.labelFormatter||r.labelFormat)&&(D=!0));a.isDirtyData&&b(a,"updatedData")});D&&p&&p.options.enabled&&(p.render(),this.isDirtyLegend=!1);m&&this.getStacks();H&&d(c,function(a){a.updateNames();a.updateYNames&&a.updateYNames();a.setScale()});
	this.getMargins();H&&(d(c,function(a){a.isDirty&&(h=!0)}),d(c,function(a){var g=a.min+","+a.max;a.extKey!==g&&(a.extKey=g,k.push(function(){b(a,"afterSetExtremes",l(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(h||m)&&a.redraw()}));h&&this.drawChartBox();b(this,"predraw");d(e,function(a){(h||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});f&&f.reset(!0);u.draw();b(this,"redraw");b(this,"render");w&&this.temporaryDisplay(!0);d(k,function(a){a.call()})},get:function(a){function b(b){return b.id===
	a||b.options&&b.options.id===a}var g,c=this.series,d;g=v(this.axes,b)||v(this.series,b);for(d=0;!g&&d<c.length;d++)g=v(c[d].points||[],b);return g},getAxes:function(){var a=this,c=this.options,e=c.xAxis=g(c.xAxis||{}),c=c.yAxis=g(c.yAxis||{});b(this,"getAxes");d(e,function(a,b){a.index=b;a.isX=!0});d(c,function(a,b){a.index=b});e=e.concat(c);d(e,function(b){new h(a,b)});b(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];d(this.series,function(b){a=a.concat(c(b.data||[],function(a){return a.selected}))});
	return a},getSelectedSeries:function(){return c(this.series,function(a){return a.selected})},setTitle:function(a,b,g){var c=this,e=c.options,f;f=e.title=z({style:{color:"#333333",fontSize:e.isStock?"16px":"18px"}},e.title,a);e=e.subtitle=z({style:{color:"#666666"}},e.subtitle,b);d([["title",a,f],["subtitle",b,e]],function(a,b){var g=a[0],d=c[g],e=a[1];a=a[2];d&&e&&(c[g]=d=d.destroy());a&&!d&&(c[g]=c.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+g,zIndex:a.zIndex||4}).add(),
	c[g].update=function(a){c.setTitle(!b&&a,b&&a)},c[g].css(a.style))});c.layOutTitles(g)},layOutTitles:function(a){var b=0,g,c=this.renderer,e=this.spacingBox;d(["title","subtitle"],function(a){var g=this[a],d=this.options[a];a="title"===a?-3:d.verticalAlign?0:b+2;var f;g&&(f=d.style.fontSize,f=c.fontMetrics(f,g).b,g.css({width:(d.width||e.width+d.widthAdjust)+"px"}).align(l({y:a+f},d),!1,"spacingBox"),d.floating||d.verticalAlign||(b=Math.ceil(b+g.getBBox(d.useHTML).height)))},this);g=this.titleOffset!==
	b;this.titleOffset=b;!this.isDirtyBox&&g&&(this.isDirtyBox=this.isDirtyLegend=g,this.hasRendered&&K(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,g=b.width,b=b.height,c=this.renderTo;e(g)||(this.containerWidth=a.getStyle(c,"width"));e(b)||(this.containerHeight=a.getStyle(c,"height"));this.chartWidth=Math.max(0,g||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},
	temporaryDisplay:function(b){var g=this.renderTo;if(b)for(;g&&g.style;)g.hcOrigStyle&&(a.css(g,g.hcOrigStyle),delete g.hcOrigStyle),g.hcOrigDetached&&(k.body.removeChild(g),g.hcOrigDetached=!1),g=g.parentNode;else for(;g&&g.style;){k.body.contains(g)||g.parentNode||(g.hcOrigDetached=!0,k.body.appendChild(g));if("none"===a.getStyle(g,"display",!1)||g.hcOricDetached)g.hcOrigStyle={display:g.style.display,height:g.style.height,overflow:g.style.overflow},b={display:"block",overflow:"hidden"},g!==this.renderTo&&
	(b.height=0),a.css(g,b),g.offsetWidth||g.style.setProperty("display","block","important");g=g.parentNode;if(g===k.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var g,c=this.options,d=c.chart,e,p;g=this.renderTo;var r=a.uniqueKey(),D;g||(this.renderTo=g=d.renderTo);x(g)&&(this.renderTo=g=k.getElementById(g));g||a.error(13,!0);e=H(q(g,"data-highcharts-chart"));f(e)&&A[e]&&A[e].hasRendered&&A[e].destroy();q(g,"data-highcharts-chart",
	this.index);g.innerHTML="";d.skipClone||g.offsetWidth||this.temporaryDisplay();this.getChartSize();e=this.chartWidth;p=this.chartHeight;D=l({position:"relative",overflow:"hidden",width:e+"px",height:p+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},d.style);this.container=g=t("div",{id:r},D,g);this._cursor=g.style.cursor;this.renderer=new (a[d.renderer]||a.Renderer)(g,e,p,null,d.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(d.className);
	this.renderer.setStyle(d.style);this.renderer.chartIndex=this.index;b(this,"afterGetContainer")},getMargins:function(a){var g=this.spacing,c=this.margin,d=this.titleOffset;this.resetMargins();d&&!e(c[0])&&(this.plotTop=Math.max(this.plotTop,d+this.options.title.margin+g[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(c,g);b(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],g=a.margin;a.hasCartesianSeries&&d(a.axes,function(a){a.visible&&
	a.getOffset()});d(I,function(c,d){e(g[d])||(a[c]+=b[d])});a.setChartSize()},reflow:function(b){var g=this,c=g.options.chart,d=g.renderTo,f=e(c.width)&&e(c.height),p=c.width||a.getStyle(d,"width"),c=c.height||a.getStyle(d,"height"),d=b?b.target:O;if(!f&&!g.isPrinting&&p&&c&&(d===O||d===k)){if(p!==g.containerWidth||c!==g.containerHeight)a.clearTimeout(g.reflowTimeout),g.reflowTimeout=y(function(){g.container&&g.setSize(void 0,void 0,!1)},b?100:0);g.containerWidth=p;g.containerHeight=c}},setReflow:function(a){var b=
	this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=E(O,"resize",function(a){b.reflow(a)}),E(this,"destroy",this.unbindReflow))},setSize:function(g,c,e){var f=this,p=f.renderer;f.isResizing+=1;a.setAnimation(e,f);f.oldChartHeight=f.chartHeight;f.oldChartWidth=f.chartWidth;void 0!==g&&(f.options.chart.width=g);void 0!==c&&(f.options.chart.height=c);f.getChartSize();g=p.globalAnimation;(g?F:B)(f.container,{width:f.chartWidth+"px",height:f.chartHeight+
	"px"},g);f.setChartSize(!0);p.setSize(f.chartWidth,f.chartHeight,e);d(f.axes,function(a){a.isDirty=!0;a.setScale()});f.isDirtyLegend=!0;f.isDirtyBox=!0;f.layOutTitles();f.getMargins();f.redraw(e);f.oldChartHeight=null;b(f,"resize");y(function(){f&&b(f,"endResize",null,function(){--f.isResizing})},G(g).duration)},setChartSize:function(a){var g=this.inverted,c=this.renderer,e=this.chartWidth,f=this.chartHeight,p=this.options.chart,r=this.spacing,D=this.clipOffset,l,m,y,H;this.plotLeft=l=Math.round(this.plotLeft);
	this.plotTop=m=Math.round(this.plotTop);this.plotWidth=y=Math.max(0,Math.round(e-l-this.marginRight));this.plotHeight=H=Math.max(0,Math.round(f-m-this.marginBottom));this.plotSizeX=g?H:y;this.plotSizeY=g?y:H;this.plotBorderWidth=p.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:r[3],y:r[0],width:e-r[3]-r[1],height:f-r[0]-r[2]};this.plotBox=c.plotBox={x:l,y:m,width:y,height:H};e=2*Math.floor(this.plotBorderWidth/2);g=Math.ceil(Math.max(e,D[3])/2);c=Math.ceil(Math.max(e,D[0])/2);this.clipBox={x:g,
	y:c,width:Math.floor(this.plotSizeX-Math.max(e,D[1])/2-g),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,D[2])/2-c))};a||d(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});b(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;d(["margin","spacing"],function(g){var c=b[g],e=w(c)?c:[c,c,c,c];d(["Top","Right","Bottom","Left"],function(c,d){a[g][d]=K(b[g+c],e[d])})});d(I,function(b,g){a[b]=K(a.margin[g],a.spacing[g])});a.axisOffset=[0,0,0,
	0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,g=this.renderer,c=this.chartWidth,d=this.chartHeight,e=this.chartBackground,f=this.plotBackground,p=this.plotBorder,r,D=this.plotBGImage,l=a.backgroundColor,m=a.plotBackgroundColor,y=a.plotBackgroundImage,H,z=this.plotLeft,h=this.plotTop,u=this.plotWidth,w=this.plotHeight,k=this.plotBox,v=this.clipRect,K=this.clipBox,x="animate";e||(this.chartBackground=e=g.rect().addClass("highcharts-background").add(),x="attr");r=a.borderWidth||
	0;H=r+(a.shadow?8:0);l={fill:l||"none"};if(r||e["stroke-width"])l.stroke=a.borderColor,l["stroke-width"]=r;e.attr(l).shadow(a.shadow);e[x]({x:H/2,y:H/2,width:c-H-r%2,height:d-H-r%2,r:a.borderRadius});x="animate";f||(x="attr",this.plotBackground=f=g.rect().addClass("highcharts-plot-background").add());f[x](k);f.attr({fill:m||"none"}).shadow(a.plotShadow);y&&(D?D.animate(k):this.plotBGImage=g.image(y,z,h,u,w).add());v?v.animate({width:K.width,height:K.height}):this.clipRect=g.clipRect(K);x="animate";
	p||(x="attr",this.plotBorder=p=g.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());p.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});p[x](p.crisp({x:z,y:h,width:u,height:w},-p.strokeWidth()));this.isDirtyBox=!1;b(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,g,c=a.options.series,e,f;d(["inverted","angular","polar"],function(d){g=D[b.type||b.defaultSeriesType];f=b[d]||g&&g.prototype[d];for(e=c&&c.length;!f&&e--;)(g=
	D[c[e].type])&&g.prototype[d]&&(f=!0);a[d]=f})},linkSeries:function(){var a=this,g=a.series;d(g,function(a){a.linkedSeries.length=0});d(g,function(b){var g=b.options.linkedTo;x(g)&&(g=":previous"===g?a.series[b.index-1]:a.get(g))&&g.linkedParent!==b&&(g.linkedSeries.push(b),b.linkedParent=g,b.visible=K(b.options.visible,g.options.visible,b.visible))});b(this,"afterLinkSeries")},renderSeries:function(){d(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;
	b.items&&d(b.items,function(g){var c=l(b.style,g.style),d=H(c.left)+a.plotLeft,e=H(c.top)+a.plotTop+12;delete c.left;delete c.top;a.renderer.text(g.html,d,e).attr({zIndex:2}).css(c).add()})},render:function(){var a=this.axes,b=this.renderer,g=this.options,c,e,f;this.setTitle();this.legend=new m(this,g.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();g=this.plotWidth;c=this.plotHeight=Math.max(this.plotHeight-21,0);d(a,function(a){a.setScale()});this.getAxisMargins();
	e=1.1<g/this.plotWidth;f=1.05<c/this.plotHeight;if(e||f)d(a,function(a){(a.horiz&&e||!a.horiz&&f)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&d(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=z(!0,this.options.credits,a);a.enabled&&
	!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(O.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var g=this,c=g.axes,e=g.series,f=g.container,r,D=f&&f.parentNode;b(g,"destroy");g.renderer.forExport?a.erase(A,g):A[g.index]=void 0;a.chartCount--;g.renderTo.removeAttribute("data-highcharts-chart");
	p(g);for(r=c.length;r--;)c[r]=c[r].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(r=e.length;r--;)e[r]=e[r].destroy();d("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var b=g[a];b&&b.destroy&&(g[a]=b.destroy())});f&&(f.innerHTML="",p(f),D&&n(f));u(g,function(a,b){delete g[b]})},firstRender:function(){var a=this,g=a.options;if(!a.isReadyToRender||
	a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();d(g.series||[],function(b){a.initSeries(b)});a.linkSeries();b(a,"beforeRender");r&&(a.pointer=new r(a,g));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){d([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);b(this,"load");b(this,"render");e(this.index)&&this.setReflow(this.options.chart.reflow);
	this.onload=null}})})(J);(function(a){var E=a.addEvent,F=a.Chart,G=a.each;E(F,"afterSetChartSize",function(q){var k=this.options.chart.scrollablePlotArea;(k=k&&k.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=k=Math.max(0,k-this.chartWidth))&&(this.plotWidth+=k,this.clipBox.width+=k,q.skipAxes||G(this.axes,function(h){1===h.side?h.getPlotLinePath=function(){var k=this.right,q;this.right=k-h.chart.scrollablePixels;q=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=k;return q}:
	(h.setAxisSize(),h.setAxisTranslation())}))});E(F,"render",function(){this.scrollablePixels?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});F.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);
	this.setUpScrolling=null};F.prototype.applyFixed=function(){var q=this.container,k,h,t=!this.fixedDiv;t&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.fixedRenderer=k=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=k.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(.85).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),
	a.each([this.inverted?".highcharts-xaxis":".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-subtitle",".highcharts-title",".highcharts-legend-checkbox"],function(h){a.each(q.querySelectorAll(h),function(a){(a.namespaceURI===k.SVG_NS?k.box:k.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})}));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);h=this.chartWidth+
	this.scrollablePixels;a.stop(this.container);this.container.style.width=h+"px";this.renderer.boxWrapper.attr({width:h,height:this.chartHeight,viewBox:[0,0,h,this.chartHeight].join(" ")});this.chartBackground.attr({width:h});t&&(h=this.options.chart.scrollablePlotArea,h.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*h.scrollPositionX));t=this.axisOffset;h=this.plotTop-t[0]-1;var t=this.plotTop+this.plotHeight+t[2],C=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?
	["M",0,h,"L",this.plotLeft-1,h,"L",this.plotLeft-1,t,"L",0,t,"Z","M",C,h,"L",this.chartWidth,h,"L",this.chartWidth,t,"L",C,t,"Z"]:["M",0,0]})}})(J);(function(a){var E,F=a.each,G=a.extend,q=a.erase,k=a.fireEvent,h=a.format,t=a.isArray,C=a.isNumber,n=a.pick,A=a.uniqueKey,B=a.defined,e=a.removeEvent;a.Point=E=function(){};a.Point.prototype={init:function(a,e,h){this.series=a;this.color=a.color;this.applyOptions(e,h);this.id=B(this.id)?this.id:A();a.options.colorByPoint?(e=a.options.colors||a.chart.options.colors,
	this.color=this.color||e[a.colorCounter],e=e.length,h=a.colorCounter,a.colorCounter++,a.colorCounter===e&&(a.colorCounter=0)):h=a.colorIndex;this.colorIndex=n(this.colorIndex,h);a.chart.pointCount++;k(this,"afterInit");return this},applyOptions:function(a,e){var d=this.series,b=d.options.pointValKey||d.pointValKey;a=E.prototype.optionsToObject.call(this,a);G(this,a);this.options=this.options?G(this.options,a):a;a.group&&delete this.group;a.dataLabels&&delete this.dataLabels;b&&(this.y=this[b]);this.isNull=
	n(this.isValid&&!this.isValid(),null===this.x||!C(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===e&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===this.x&&d&&(this.x=void 0===e?d.autoIncrement(this):e);return this},setNestedProperty:function(d,e,h){h=h.split(".");a.reduce(h,function(b,c,d,l){b[c]=l.length-1===d?e:a.isObject(b[c],!0)?b[c]:{};return b[c]},d);return d},optionsToObject:function(d){var e={},h=this.series,b=h.options.keys,c=b||h.pointArrayMap||
	["y"],f=c.length,w=0,k=0;if(C(d)||null===d)e[c[0]]=d;else if(t(d))for(!b&&d.length>f&&(h=typeof d[0],"string"===h?e.name=d[0]:"number"===h&&(e.x=d[0]),w++);k<f;)b&&void 0===d[w]||(0<c[k].indexOf(".")?a.Point.prototype.setNestedProperty(e,d[w],c[k]):e[c[k]]=d[w]),w++,k++;else"object"===typeof d&&(e=d,d.dataLabels&&(h._hasPointLabels=!0),d.marker&&(h._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":
	"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,e=a.zones,a=a.zoneAxis||"y",h=0,b;for(b=e[h];this[a]>=b.value;)b=e[++h];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=b&&b.color&&!this.options.color?b.color:this.nonZonedColor;return b},
	destroy:function(){var a=this.series.chart,l=a.hoverPoints,h;a.pointCount--;l&&(this.setState(),q(l,this),l.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)e(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(h in this)this[h]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],e,h=6;h--;)e=a[h],this[e]&&(this[e]=this[e].destroy());this.dataLabels&&
	(F(this.dataLabels,function(a){a.element&&a.destroy()}),delete this.dataLabels);this.connectors&&(F(this.connectors,function(a){a.element&&a.destroy()}),delete this.connectors)},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var d=this.series,e=d.tooltipOptions,b=n(e.valueDecimals,""),c=e.valuePrefix||
	"",f=e.valueSuffix||"";F(d.pointArrayMap||["y"],function(d){d="{point."+d;if(c||f)a=a.replace(RegExp(d+"}","g"),c+d+"}"+f);a=a.replace(RegExp(d+"}","g"),d+":,."+b+"f}")});return h(a,{point:this,series:this.series},d.chart.time)},firePointEvent:function(a,e,h){var b=this,c=this.series.options;(c.point.events[a]||b.options&&b.options.events&&b.options.events[a])&&this.importEvents();"click"===a&&c.allowPointSelect&&(h=function(a){b.select&&b.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});k(this,a,
	e,h)},visible:!0}})(J);(function(a){var E=a.addEvent,F=a.animObject,G=a.arrayMax,q=a.arrayMin,k=a.correctFloat,h=a.defaultOptions,t=a.defaultPlotOptions,C=a.defined,n=a.each,A=a.erase,B=a.extend,e=a.fireEvent,d=a.grep,l=a.isArray,v=a.isNumber,b=a.isString,c=a.merge,f=a.objectEach,w=a.pick,x=a.removeEvent,m=a.splat,I=a.SVGElement,z=a.syncTimeout,u=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",
	enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},
	hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,d,r=a.series,g;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();B(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});
	d=b.events;f(d,function(a,b){E(c,b,a)});if(d&&d.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();n(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);r.length&&(g=r[r.length-1]);c._i=w(g&&g._i,-1)+1;a.orderSeries(this.insert(r));e(this,"afterInit")},insert:function(a){var b=this.options.index,c;if(v(b)){for(c=a.length;c--;)if(b>=w(a[c].options.index,a[c]._i)){a.splice(c+
	1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return w(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;n(b.axisTypes||[],function(f){n(d[f],function(a){e=a.options;if(c[f]===e.index||void 0!==c[f]&&c[f]===e.id||void 0===c[f]&&0===e.index)b.insert(a.series),b[f]=a,a.isDirty=!0});b[f]||b.optionalAxis===f||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,e=v(b)?function(g){var d="y"===g&&c.toYData?c.toYData(a):a[g];c[g+"Data"][b]=
	d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};n(c.parallelArrays,e)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,e=this.chart.time,b=w(b,a.pointStart,0);this.pointInterval=c=w(this.pointInterval,a.pointInterval,1);d&&(a=new e.Date(b),"day"===d?e.set("Date",a,e.get("Date",a)+c):"month"===d?e.set("Month",a,e.get("Month",a)+c):"year"===d&&e.set("FullYear",a,e.get("FullYear",a)+c),c=a.getTime()-b);this.xIncrement=b+c;return b},
	setOptions:function(a){var b=this.chart,d=b.options,f=d.plotOptions,r=(b.userOptions||{}).plotOptions||{},g=f[this.type];this.userOptions=a;b=c(g,f.series,a);this.tooltipOptions=c(h.tooltip,h.plotOptions.series&&h.plotOptions.series.tooltip,h.plotOptions[this.type].tooltip,d.tooltip.userOptions,f.series&&f.series.tooltip,f[this.type].tooltip,a.tooltip);this.stickyTracking=w(a.stickyTracking,r[this.type]&&r[this.type].stickyTracking,r.series&&r.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?
	!0:b.stickyTracking);null===g.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&C(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});e(this,"afterSetOptions",{options:b});return b},getName:function(){return this.name||"Series "+(this.index+
	1)},getCyclic:function(a,b,c){var d,e=this.chart,g=this.userOptions,f=a+"Index",r=a+"Counter",m=c?c.length:w(e.options.chart[a+"Count"],e[a+"Count"]);b||(d=w(g[f],g["_"+f]),C(d)||(e.series.length||(e[r]=0),g["_"+f]=d=e[r]%m,e[r]+=1),c&&(b=c[d]));void 0!==d&&(this[f]=d);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||t[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,
	this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,e=[],f,g,r,m=this.requireSorting;n(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;v(g)&&(g=a.inArray(g,this.xData,r),-1===g||d[g].touched?e.push(b):b!==c.data[g]?(d[g].update(b,!1,null,!1),d[g].touched=!0,m&&(r=g+1)):d[g]&&(d[g].touched=!0),f=!0)},this);if(f)for(b=d.length;b--;)g=d[b],g.touched||g.remove(!1),
	g.touched=!1;else if(b.length===d.length)n(b,function(a,b){d[b].update&&a!==c.data[b]&&d[b].update(a,!1,null,!1)});else return!1;n(e,function(a){this.addPoint(a,!1)},this);return!0},setData:function(c,d,e,f){var p=this,g=p.points,r=g&&g.length||0,m,h=p.options,z=p.chart,u=null,k=p.xAxis,x=h.turboThreshold,H=this.xData,K=this.yData,I=(m=p.pointArrayMap)&&m.length,q;c=c||[];m=c.length;d=w(d,!0);!1!==f&&m&&r&&!p.cropped&&!p.hasGroupedData&&p.visible&&!p.isSeriesBoosting&&(q=this.updateData(c));if(!q){p.xIncrement=
	null;p.colorCounter=0;n(this.parallelArrays,function(a){p[a+"Data"].length=0});if(x&&m>x){for(e=0;null===u&&e<m;)u=c[e],e++;if(v(u))for(e=0;e<m;e++)H[e]=this.autoIncrement(),K[e]=c[e];else if(l(u))if(I)for(e=0;e<m;e++)u=c[e],H[e]=u[0],K[e]=u.slice(1,I+1);else for(e=0;e<m;e++)u=c[e],H[e]=u[0],K[e]=u[1];else a.error(12)}else for(e=0;e<m;e++)void 0!==c[e]&&(u={series:p},p.pointClass.prototype.applyOptions.apply(u,[c[e]]),p.updateParallelArrays(u,e));K&&b(K[0])&&a.error(14,!0);p.data=[];p.options.data=
	p.userOptions.data=c;for(e=r;e--;)g[e]&&g[e].destroy&&g[e].destroy();k&&(k.minRange=k.userMinRange);p.isDirty=z.isDirtyBox=!0;p.isDirtyData=!!g;e=!1}"point"===h.legendType&&(this.processData(),this.generatePoints());d&&z.redraw(e)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,f;f=0;var g,r,m=this.xAxis,l,h=this.options;l=h.cropThreshold;var z=this.getExtremesFromAll||h.getExtremesFromAll,u=this.isCartesian,h=m&&m.val2lin,k=m&&m.isLog,w=this.requireSorting,x,v;if(u&&!this.isDirty&&
	!m.isDirty&&!this.yAxis.isDirty&&!b)return!1;m&&(b=m.getExtremes(),x=b.min,v=b.max);u&&this.sorted&&!z&&(!l||e>l||this.forceCrop)&&(c[e-1]<x||c[0]>v?(c=[],d=[]):this.yData&&(c[0]<x||c[e-1]>v)&&(f=this.cropData(this.xData,this.yData,x,v),c=f.xData,d=f.yData,f=f.start,g=!0));for(l=c.length||1;--l;)e=k?h(c[l])-h(c[l-1]):c[l]-c[l-1],0<e&&(void 0===r||e<r)?r=e:0>e&&w&&(a.error(15),w=!1);this.cropped=g;this.cropStart=f;this.processedXData=c;this.processedYData=d;this.closestPointRange=r},cropData:function(a,
	b,c,d,e){var g=a.length,f=0,p=g,r;e=w(e,this.cropShoulder,1);for(r=0;r<g;r++)if(a[r]>=c){f=Math.max(0,r-e);break}for(c=r;c<g;c++)if(a[c]>d){p=c+e;break}return{xData:a.slice(f,p),yData:b.slice(f,p),start:f,end:p}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,e=this.processedXData,g=this.processedYData,f=this.pointClass,l=e.length,h=this.cropStart||0,z,u=this.hasGroupedData,a=a.keys,k,w=[],x;c||u||(c=[],c.length=b.length,c=this.data=c);a&&u&&(this.options.keys=!1);for(x=0;x<l;x++)z=
	h+x,u?(k=(new f).init(this,[e[x]].concat(m(g[x]))),k.dataGroup=this.groupMap[x],k.dataGroup.options&&(k.options=k.dataGroup.options,B(k,k.dataGroup.options))):(k=c[z])||void 0===b[z]||(c[z]=k=(new f).init(this,b[z],e[x])),k&&(k.index=z,w[x]=k);this.options.keys=a;if(c&&(l!==(d=c.length)||u))for(x=0;x<d;x++)x!==h||u||(x+=l),c[x]&&(c[x].destroyElements(),c[x].plotX=void 0);this.data=c;this.points=w},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,e=[],g=0;d=this.xAxis.getExtremes();
	var f=d.min,r=d.max,m,h,z=this.requireSorting?1:0,u,k;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(k=0;k<d;k++)if(h=c[k],u=a[k],m=(v(u,!0)||l(u))&&(!b.positiveValuesOnly||u.length||0<u),h=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[k+z]||h)>=f&&(c[k-z]||h)<=r,m&&h)if(m=u.length)for(;m--;)"number"===typeof u[m]&&(e[g++]=u[m]);else e[g++]=u;this.dataMin=q(e);this.dataMax=G(e)},translate:function(){this.processedXData||this.processData();this.generatePoints();
	var a=this.options,b=a.stacking,c=this.xAxis,d=c.categories,f=this.yAxis,g=this.points,m=g.length,l=!!this.modifyValue,h=a.pointPlacement,z="between"===h||v(h),u=a.threshold,x=a.startFromThreshold?u:0,n,I,q,t,B=Number.MAX_VALUE;"between"===h&&(h=.5);v(h)&&(h*=w(a.pointRange||c.pointRange));for(a=0;a<m;a++){var A=g[a],F=A.x,E=A.y;I=A.low;var G=b&&f.stacks[(this.negStacks&&E<(x?0:u)?"-":"")+this.stackKey],J;f.positiveValuesOnly&&null!==E&&0>=E&&(A.isNull=!0);A.plotX=n=k(Math.min(Math.max(-1E5,c.translate(F,
	0,0,0,1,h,"flags"===this.type)),1E5));b&&this.visible&&!A.isNull&&G&&G[F]&&(t=this.getStackIndicator(t,F,this.index),J=G[F],E=J.points[t.key],I=E[0],E=E[1],I===x&&t.key===G[F].base&&(I=w(v(u)&&u,f.min)),f.positiveValuesOnly&&0>=I&&(I=null),A.total=A.stackTotal=J.total,A.percentage=J.total&&A.y/J.total*100,A.stackY=E,J.setOffset(this.pointXOffset||0,this.barW||0));A.yBottom=C(I)?Math.min(Math.max(-1E5,f.translate(I,0,1,0,1)),1E5):null;l&&(E=this.modifyValue(E,A));A.plotY=I="number"===typeof E&&Infinity!==
	E?Math.min(Math.max(-1E5,f.translate(E,0,1,0,1)),1E5):void 0;A.isInside=void 0!==I&&0<=I&&I<=f.len&&0<=n&&n<=c.len;A.clientX=z?k(c.translate(F,0,0,0,1,h)):n;A.negative=A.y<(u||0);A.category=d&&void 0!==d[A.x]?d[A.x]:A.x;A.isNull||(void 0!==q&&(B=Math.min(B,Math.abs(n-q))),q=n);A.zone=this.zones.length&&A.getZone()}this.closestPointRangePx=B;e(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return d(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?
	!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,g=this.clipBox,f=g||b.clipBox,r=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),m=b[r],l=b[r+"m"];m||(a&&(f.width=0,e&&(f.x=b.plotSizeX),b[r+"m"]=l=d.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[r]=m=d.clipRect(f),m.count={length:0});a&&!m.count[this.index]&&(m.count[this.index]=!0,m.count.length+=1);!1!==c.clip&&
	(this.group.clip(a||g?m:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=r);a||(m.count[this.index]&&(delete m.count[this.index],--m.count.length),0===m.count.length&&r&&b[r]&&(g||(b[r]=b[r].destroy()),b[r+"m"]&&(b[r+"m"]=b[r+"m"].destroy())))},animate:function(a){var b=this.chart,c=F(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();
	e(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,e,g,f=this.options.marker,m,l,h,z=this[this.specialGroup]||this.markerGroup,u,k=w(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=f.enabledThreshold*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],g=d.graphic,m=d.marker||{},l=!!d.marker,e=k&&void 0===m.enabled||m.enabled,h=d.isInside,e&&!d.isNull?(e=w(m.symbol,this.symbol),u=this.markerAttribs(d,
	d.selected&&"select"),g?g[h?"show":"hide"](!0).animate(u):h&&(0<u.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(e,u.x,u.y,u.width,u.height,l?m:f).add(z)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},e=d.symbol||c.symbol,g=w(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],g=w(b&&b.radius,c&&c.radius,g+(c&&c.radiusPlus||0)));a.hasImage=e&&0===
	e.indexOf("url");a.hasImage&&(g=0);a={x:Math.floor(a.plotX)-g,y:a.plotY-g};g&&(a.width=a.height=2*g);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,e=d&&d.marker||{},g=this.color,f=d&&d.color,m=a&&a.color,d=w(e.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=f||a||m||g;a=e.fillColor||c.fillColor||g;g=e.lineColor||c.lineColor||g;b&&(c=c.states[b],b=e.states&&e.states[b]||{},d=w(b.lineWidth,c.lineWidth,d+w(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||
	a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":d,fill:a}},destroy:function(){var b=this,c=b.chart,d=/AppleWebKit\/533/.test(u.navigator.userAgent),p,m,g=b.data||[],l,h;e(b,"destroy");x(b);n(b.axisTypes||[],function(a){(h=b[a])&&h.series&&(A(h.series,b),h.isDirty=h.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(m=g.length;m--;)(l=g[m])&&l.destroy&&l.destroy();b.points=null;a.clearTimeout(b.animationTimeout);f(b,function(a,b){a instanceof I&&!a.survive&&(p=d&&"group"===
	b?"hide":"destroy",a[p]())});c.hoverSeries===b&&(c.hoverSeries=null);A(c.series,b);c.orderSeries();f(b,function(a,c){delete b[c]})},getGraphPath:function(a,b,c){var d=this,e=d.options,g=e.step,f,m=[],r=[],l;a=a||d.points;(f=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&f&&(g=4-g);!e.connectNulls||b||c||(a=this.getValidPoints(a));n(a,function(f,p){var h=f.plotX,D=f.plotY,u=a[p-1];(f.leftCliff||u&&u.rightCliff)&&!c&&(l=!0);f.isNull&&!C(b)&&0<p?l=!e.connectNulls:f.isNull&&!b?l=!0:(0===p||
	l?p=["M",f.plotX,f.plotY]:d.getPointSpline?p=d.getPointSpline(a,f,p):g?(p=1===g?["L",u.plotX,D]:2===g?["L",(u.plotX+h)/2,u.plotY,"L",(u.plotX+h)/2,D]:["L",h,u.plotY],p.push("L",h,D)):p=["L",h,D],r.push(f.x),g&&(r.push(f.x),2===g&&r.push(f.x)),m.push.apply(m,p),l=!1)});m.xMap=r;return d.graphPath=m},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],d=a.getZonesGraphs(d);n(d,function(d,
	g){var e=d[0],f=a[e];f?(f.endX=a.preventGraphAnimation?null:c.xMap,f.animate({d:c})):c.length&&(a[e]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),f={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?f.dashstyle=d[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[e].attr(f).shadow(2>g&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},getZonesGraphs:function(a){n(this.zones,function(b,c){a.push(["zone-graph-"+c,
	"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,g,f=this.clips||[],m,l=this.graph,h=this.area,u=Math.max(b.chartWidth,b.chartHeight),z=this[(this.zoneAxis||"y")+"Axis"],k,x,v=b.inverted,I,q,t,B,A=!1;d.length&&(l||h)&&z&&void 0!==z.min&&(x=z.reversed,I=z.horiz,l&&!this.showLine&&l.hide(),h&&h.hide(),k=z.getExtremes(),n(d,function(d,p){e=
	x?I?b.plotWidth:0:I?0:z.toPixels(k.min);e=Math.min(Math.max(w(g,e),0),u);g=Math.min(Math.max(Math.round(z.toPixels(w(d.value,k.max),!0)),0),u);A&&(e=g=z.toPixels(k.max));q=Math.abs(e-g);t=Math.min(e,g);B=Math.max(e,g);z.isXAxis?(m={x:v?B:t,y:0,width:q,height:u},I||(m.x=b.plotHeight-m.x)):(m={x:0,y:v?B:t,width:u,height:q},I&&(m.y=b.plotWidth-m.y));v&&c.isVML&&(m=z.isXAxis?{x:0,y:x?t:B,height:m.width,width:b.chartWidth}:{x:m.y-b.plotLeft-b.spacingBox.x,y:0,width:m.height,height:b.chartHeight});f[p]?
	f[p].animate(m):(f[p]=c.clipRect(m),l&&a["zone-graph-"+p].clip(f[p]),h&&a["zone-area-"+p].clip(f[p]));A=d.value>k.max;a.resetZones&&0===g&&(g=void 0)}),this.clips=f)},invertGroups:function(a){function b(){n(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,e;c.xAxis&&(e=E(d,"resize",b),E(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,
	e){var g=this[a],f=!g;f&&(this[a]=g=this.chart.renderer.g().attr({zIndex:d||.1}).add(e));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(C(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);
	return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,f=!!a.animate&&b.renderer.isSVG&&F(d.animation).duration,g=a.visible?"inherit":"hidden",m=d.zIndex,l=a.hasRendered,h=b.seriesGroup,u=b.inverted;c=a.plotGroup("group","series",g,m,h);a.markerGroup=a.plotGroup("markerGroup","markers",g,m,h);f&&a.animate(!0);c.inverted=a.isCartesian?u:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();
	a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(u);!1===d.clip||a.sharedClipKey||l||c.clip(b.clipRect);f&&a.animate();l||(a.animationTimeout=z(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0;e(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:w(d&&d.left,a.plotLeft),
	translateY:w(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,g){var e,f;if(f=c&&c.length)return e=b.kdAxisArray[d%g],c.sort(function(a,b){return a[e]-b[e]}),f=Math.floor(f/2),{point:c[f],left:a(c.slice(0,
	f),d+1,g),right:a(c.slice(f+1),d+1,g)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;z(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,p,m){var l=b.point,h=d.kdAxisArray[p%m],u,z,r=l;z=C(a[e])&&C(l[e])?Math.pow(a[e]-l[e],2):null;u=C(a[g])&&C(l[g])?Math.pow(a[g]-l[g],2):null;u=(z||0)+(u||0);l.dist=C(u)?Math.sqrt(u):Number.MAX_VALUE;l.distX=C(z)?
	Math.sqrt(z):Number.MAX_VALUE;h=a[h]-l[h];u=0>h?"left":"right";z=0>h?"right":"left";b[u]&&(u=c(a,b[u],p+1,m),r=u[f]<r[f]?u:l);b[z]&&Math.sqrt(h*h)<r[f]&&(a=c(a,b[z],p+1,m),r=a[f]<r[f]?a:r);return r}var d=this,e=this.kdAxisArray[0],g=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(J);(function(a){var E=a.Axis,F=a.Chart,G=a.correctFloat,q=a.defined,k=a.destroyObjectProperties,
	h=a.each,t=a.format,C=a.objectEach,n=a.pick,A=a.Series;a.StackItem=function(a,e,d,l,h){var b=a.chart.inverted;this.axis=a;this.isNegative=d;this.options=e;this.x=l;this.total=null;this.points={};this.stack=h;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(b?d?"left":"right":"center"),verticalAlign:e.verticalAlign||(b?"middle":d?"bottom":"top"),y:n(e.y,b?4:d?14:-6),x:n(e.x,b?d?-6:6:0)};this.textAlign=e.textAlign||(b?d?"right":"left":"center")};a.StackItem.prototype={destroy:function(){k(this,
	this.axis)},render:function(a){var e=this.axis.chart,d=this.options,l=d.format,l=l?t(l,this,e.time):d.formatter.call(this);this.label?this.label.attr({text:l,visibility:"hidden"}):this.label=e.renderer.text(l,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a);this.label.labelrank=e.plotHeight},setOffset:function(a,e){var d=this.axis,l=d.chart,h=d.translate(d.usePercentage?100:this.total,0,0,0,1),b=d.translate(0),b=q(h)&&Math.abs(h-b);a=l.xAxis[0].translate(this.x)+
	a;d=q(h)&&this.getStackBox(l,this,a,h,e,b,d);(e=this.label)&&d&&(e.align(this.alignOptions,null,d),d=e.alignAttr,e[!1===this.options.crop||l.isInsidePlot(d.x,d.y)?"show":"hide"](!0))},getStackBox:function(a,e,d,l,h,b,c){var f=e.axis.reversed,k=a.inverted;a=c.height+c.pos-(k?a.plotLeft:a.plotTop);e=e.isNegative&&!f||!e.isNegative&&f;return{x:k?e?l:l-b:d,y:k?a-d-h:e?a-l-b:a-l,width:k?b:h,height:k?h:b}}};F.prototype.getStacks=function(){var a=this;h(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&
	(a.oldStacks=a.stacks)});h(a.series,function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+n(e.options.stack,""))})};E.prototype.buildStacks=function(){var a=this.series,e=n(this.options.reversedStacks,!0),d=a.length,l;if(!this.isXAxis){this.usePercentage=!1;for(l=d;l--;)a[e?l:d-l-1].setStackedPoints();for(l=0;l<d;l++)a[l].modifyStacks()}};E.prototype.renderStackTotals=function(){var a=this.chart,e=a.renderer,d=this.stacks,l=this.stackTotalGroup;
	l||(this.stackTotalGroup=l=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());l.translate(a.plotLeft,a.plotTop);C(d,function(a){C(a,function(a){a.render(l)})})};E.prototype.resetStacks=function(){var a=this,e=a.stacks;a.isXAxis||C(e,function(d){C(d,function(e,h){e.touched<a.stacksTouched?(e.destroy(),delete d[h]):(e.total=null,e.cumulative=null)})})};E.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),C(a,function(a){C(a,function(a){a.cumulative=
	a.total})}))};A.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var h=this.processedXData,e=this.processedYData,d=[],l=e.length,k=this.options,b=k.threshold,c=n(k.startFromThreshold&&b,0),f=k.stack,k=k.stacking,w=this.stackKey,x="-"+w,m=this.negStacks,I=this.yAxis,z=I.stacks,u=I.oldStacks,r,t,H,p,D,g,y;I.stacksTouched+=1;for(D=0;D<l;D++)g=h[D],y=e[D],r=this.getStackIndicator(r,g,this.index),p=r.key,H=(t=m&&y<(c?
	0:b))?x:w,z[H]||(z[H]={}),z[H][g]||(u[H]&&u[H][g]?(z[H][g]=u[H][g],z[H][g].total=null):z[H][g]=new a.StackItem(I,I.options.stackLabels,t,g,f)),H=z[H][g],null!==y?(H.points[p]=H.points[this.index]=[n(H.cumulative,c)],q(H.cumulative)||(H.base=p),H.touched=I.stacksTouched,0<r.index&&!1===this.singleStacks&&(H.points[p][0]=H.points[this.index+","+g+",0"][0])):H.points[p]=H.points[this.index]=null,"percent"===k?(t=t?w:x,m&&z[t]&&z[t][g]?(t=z[t][g],H.total=t.total=Math.max(t.total,H.total)+Math.abs(y)||
	0):H.total=G(H.total+(Math.abs(y)||0))):H.total=G(H.total+(y||0)),H.cumulative=n(H.cumulative,c)+(y||0),null!==y&&(H.points[p].push(H.cumulative),d[D]=H.cumulative);"percent"===k&&(I.usePercentage=!0);this.stackedYData=d;I.oldStacks={}}};A.prototype.modifyStacks=function(){var a=this,e=a.stackKey,d=a.yAxis.stacks,l=a.processedXData,k,b=a.options.stacking;a[b+"Stacker"]&&h([e,"-"+e],function(c){for(var e=l.length,h,x;e--;)if(h=l[e],k=a.getStackIndicator(k,h,a.index,c),x=(h=d[c]&&d[c][h])&&h.points[k.key])a[b+
	"Stacker"](x,h,e)})};A.prototype.percentStacker=function(a,e,d){e=e.total?100/e.total:0;a[0]=G(a[0]*e);a[1]=G(a[1]*e);this.stackedYData[d]=a[1]};A.prototype.getStackIndicator=function(a,e,d,h){!q(a)||a.x!==e||h&&a.key!==h?a={x:e,index:0,key:h}:a.index++;a.key=[d,e,a.index].join();return a}})(J);(function(a){var E=a.addEvent,F=a.animate,G=a.Axis,q=a.createElement,k=a.css,h=a.defined,t=a.each,C=a.erase,n=a.extend,A=a.fireEvent,B=a.inArray,e=a.isNumber,d=a.isObject,l=a.isArray,v=a.merge,b=a.objectEach,
	c=a.pick,f=a.Point,w=a.Series,x=a.seriesTypes,m=a.setAnimation,I=a.splat;n(a.Chart.prototype,{addSeries:function(a,b,d){var e,f=this;a&&(b=c(b,!0),A(f,"addSeries",{options:a},function(){e=f.initSeries(a);f.isDirtyLegend=!0;f.linkSeries();A(f,"afterAddSeries");b&&f.redraw(d)}));return e},addAxis:function(a,b,d,e){var f=b?"xAxis":"yAxis",p=this.options;a=v(a,{index:this[f].length,isX:b});b=new G(this,a);p[f]=I(p[f]||{});p[f].push(a);c(d,!0)&&this.redraw(e);return b},showLoading:function(a){var b=this,
	c=b.options,d=b.loadingDiv,e=c.loading,f=function(){d&&k(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=q("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=q("span",{className:"highcharts-loading-inner"},null,d),E(b,"redraw",f));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;k(d,n(e.style,{zIndex:10}));k(b.loadingSpan,e.labelStyle);b.loadingShown||(k(d,{opacity:0,
	display:""}),F(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",F(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){k(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,d,f,m){var l=this,p={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},u=a.chart,g,r,z=[];A(l,"update",{options:a});if(u){v(!0,l.options.chart,u);"className"in u&&l.setClassName(u.className);"reflow"in u&&l.setReflow(u.reflow);if("inverted"in u||"polar"in u||"type"in u)l.propFromSeries(),g=!0;"alignTicks"in u&&(g=!0);b(u,function(a,b){-1!==
	B("chart."+b,l.propsRequireUpdateSeries)&&(r=!0);-1!==B(b,l.propsRequireDirtyBox)&&(l.isDirtyBox=!0)});"style"in u&&l.renderer.setStyle(u.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&v(!0,this.options.plotOptions,a.plotOptions);b(a,function(a,b){if(l[b]&&"function"===typeof l[b].update)l[b].update(a,!1);else if("function"===typeof l[p[b]])l[p[b]](a);"chart"!==b&&-1!==B(b,l.propsRequireUpdateSeries)&&(r=!0)});t("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;
	a[b]&&("series"===b&&(c=[],t(l[b],function(a,b){a.options.isInternal||c.push(b)})),t(I(a[b]),function(a,g){(g=h(a.id)&&l.get(a.id)||l[b][c?c[g]:g])&&g.coll===b&&(g.update(a,!1),f&&(g.touched=!0));if(!g&&f)if("series"===b)l.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)l.addAxis(a,"xAxis"===b,!1).touched=!0}),f&&t(l[b],function(a){a.touched||a.options.isInternal?delete a.touched:z.push(a)}))});t(z,function(a){a.remove&&a.remove(!1)});g&&t(l.axes,function(a){a.update({},!1)});r&&t(l.series,
	function(a){a.update({},!1)});a.loading&&v(!0,l.options.loading,a.loading);g=u&&u.width;u=u&&u.height;e(g)&&g!==l.chartWidth||e(u)&&u!==l.chartHeight?l.setSize(g,u,m):c(d,!0)&&l.redraw(m);A(l,"afterUpdate",{options:a})},setSubtitle:function(a){this.setTitle(void 0,a)}});n(f.prototype,{update:function(a,b,e,f){function m(){p.applyOptions(a);null===p.y&&g&&(p.graphic=g.destroy());d(a,!0)&&(g&&g.element&&a&&a.marker&&void 0!==a.marker.symbol&&(p.graphic=g.destroy()),a&&a.dataLabels&&p.dataLabel&&(p.dataLabel=
	p.dataLabel.destroy()),p.connector&&(p.connector=p.connector.destroy()));h=p.index;l.updateParallelArrays(p,h);r.data[h]=d(r.data[h],!0)||d(a,!0)?p.options:c(a,r.data[h]);l.isDirty=l.isDirtyData=!0;!l.fixedBox&&l.hasCartesianSeries&&(u.isDirtyBox=!0);"point"===r.legendType&&(u.isDirtyLegend=!0);b&&u.redraw(e)}var p=this,l=p.series,g=p.graphic,h,u=l.chart,r=l.options;b=c(b,!0);!1===f?m():p.firePointEvent("update",{options:a},m)},remove:function(a,b){this.series.removePoint(B(this,this.series.data),
	a,b)}});n(w.prototype,{addPoint:function(a,b,d,e){var f=this.options,p=this.data,m=this.chart,g=this.xAxis,g=g&&g.hasNames&&g.names,l=f.data,h,u,r=this.xData,k,z;b=c(b,!0);h={series:this};this.pointClass.prototype.applyOptions.apply(h,[a]);z=h.x;k=r.length;if(this.requireSorting&&z<r[k-1])for(u=!0;k&&r[k-1]>z;)k--;this.updateParallelArrays(h,"splice",k,0,0);this.updateParallelArrays(h,k);g&&h.name&&(g[z]=h.name);l.splice(k,0,a);u&&(this.data.splice(k,0,null),this.processData());"point"===f.legendType&&
	this.generatePoints();d&&(p[0]&&p[0].remove?p[0].remove(!1):(p.shift(),this.updateParallelArrays(h,"shift"),l.shift()));this.isDirtyData=this.isDirty=!0;b&&m.redraw(e)},removePoint:function(a,b,d){var e=this,f=e.data,p=f[a],l=e.points,g=e.chart,h=function(){l&&l.length===f.length&&l.splice(a,1);f.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(p||{series:e},"splice",a,1);p&&p.destroy();e.isDirty=!0;e.isDirtyData=!0;b&&g.redraw()};m(d,g);b=c(b,!0);p?p.firePointEvent("remove",null,h):
	h()},remove:function(a,b,d){function e(){f.destroy();f.remove=null;p.isDirtyLegend=p.isDirtyBox=!0;p.linkSeries();c(a,!0)&&p.redraw(b)}var f=this,p=f.chart;!1!==d?A(f,"remove",null,e):e()},update:function(b,d){var e=this,f=e.chart,m=e.userOptions,p=e.oldType||e.type,l=b.type||m.type||f.options.chart.type,g=x[p].prototype,h,u=["group","markerGroup","dataLabelsGroup"],k=["navigatorSeries","baseSeries"],z=e.finishedAnimating&&{animation:!1},w=["data","name","turboThreshold"],I=a.keys(b),q=0<I.length;
	t(I,function(a){-1===B(a,w)&&(q=!1)});if(q)b.data&&this.setData(b.data,!1),b.name&&this.setName(b.name,!1);else{k=u.concat(k);t(k,function(a){k[a]=e[a];delete e[a]});b=v(m,z,{index:e.index,pointStart:c(m.pointStart,e.xData[0])},{data:e.options.data},b);e.remove(!1,null,!1);for(h in g)e[h]=void 0;x[l||p]?n(e,x[l||p].prototype):a.error(17,!0);t(k,function(a){e[a]=k[a]});e.init(f,b);b.zIndex!==m.zIndex&&t(u,function(a){e[a]&&e[a].attr({zIndex:b.zIndex})});e.oldType=p;f.linkSeries()}A(this,"afterUpdate");
	c(d,!0)&&f.redraw(q?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});n(G.prototype,{update:function(a,d){var e=this.chart,f=a&&a.events||{};a=v(this.userOptions,a);e.options[this.coll].indexOf&&(e.options[this.coll][e.options[this.coll].indexOf(this.userOptions)]=a);b(e.options[this.coll].events,function(a,b){"undefined"===typeof f[b]&&(f[b]=void 0)});this.destroy(!0);this.init(e,n(a,{events:f}));e.isDirtyBox=!0;c(d,!0)&&e.redraw()},
	remove:function(a){for(var b=this.chart,d=this.coll,e=this.series,f=e.length;f--;)e[f]&&e[f].remove(!1);C(b.axes,this);C(b[d],this);l(b.options[d])?b.options[d].splice(this.options.index,1):delete b.options[d];t(b[d],function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;c(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(J);(function(a){var E=a.color,F=a.each,G=a.map,q=a.pick,k=a.Series,
	h=a.seriesType;h("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(h){var k=[],n=[],t=this.xAxis,B=this.yAxis,e=B.stacks[this.stackKey],d={},l=this.index,v=B.series,b=v.length,c,f=q(B.options.reversedStacks,!0)?1:-1,w;h=h||this.points;if(this.options.stacking){for(w=0;w<h.length;w++)h[w].leftNull=h[w].rightNull=null,d[h[w].x]=h[w];a.objectEach(e,function(a,b){null!==a.total&&n.push(b)});n.sort(function(a,b){return a-b});c=G(v,function(){return this.visible});F(n,
	function(a,m){var h=0,z,u;if(d[a]&&!d[a].isNull)k.push(d[a]),F([-1,1],function(h){var k=1===h?"rightNull":"leftNull",r=0,p=e[n[m+h]];if(p)for(w=l;0<=w&&w<b;)z=p.points[w],z||(w===l?d[a][k]=!0:c[w]&&(u=e[a].points[w])&&(r-=u[1]-u[0])),w+=f;d[a][1===h?"rightCliff":"leftCliff"]=r});else{for(w=l;0<=w&&w<b;){if(z=e[a].points[w]){h=z[1];break}w+=f}h=B.translate(h,0,1,0,1);k.push({isNull:!0,plotX:t.translate(a,0,0,0,1),x:a,plotY:h,yBottom:h})}})}return k},getGraphPath:function(a){var h=k.prototype.getGraphPath,
	n=this.options,t=n.stacking,B=this.yAxis,e,d,l=[],v=[],b=this.index,c,f=B.stacks[this.stackKey],w=n.threshold,x=B.getThreshold(n.threshold),m,n=n.connectNulls||"percent"===t,I=function(d,e,m){var h=a[d];d=t&&f[h.x].points[b];var k=h[m+"Null"]||0;m=h[m+"Cliff"]||0;var p,u,h=!0;m||k?(p=(k?d[0]:d[1])+m,u=d[0]+m,h=!!k):!t&&a[e]&&a[e].isNull&&(p=u=w);void 0!==p&&(v.push({plotX:c,plotY:null===p?x:B.getThreshold(p),isNull:h,isCliff:!0}),l.push({plotX:c,plotY:null===u?x:B.getThreshold(u),doCurve:!1}))};a=
	a||this.points;t&&(a=this.getStackPoints(a));for(e=0;e<a.length;e++)if(d=a[e].isNull,c=q(a[e].rectPlotX,a[e].plotX),m=q(a[e].yBottom,x),!d||n)n||I(e,e-1,"left"),d&&!t&&n||(v.push(a[e]),l.push({x:e,plotX:c,plotY:m})),n||I(e,e+1,"right");e=h.call(this,v,!0,!0);l.reversed=!0;d=h.call(this,l,!0,!0);d.length&&(d[0]="L");d=e.concat(d);h=h.call(this,v,!1,n);d.xMap=e.xMap;this.areaPath=d;return h},drawGraph:function(){this.areaPath=[];k.prototype.drawGraph.apply(this);var a=this,h=this.areaPath,n=this.options,
	A=[["area","highcharts-area",this.color,n.fillColor]];F(this.zones,function(h,e){A.push(["zone-area-"+e,"highcharts-area highcharts-zone-area-"+e+" "+h.className,h.color||a.color,h.fillColor||n.fillColor])});F(A,function(k){var e=k[0],d=a[e];d?(d.endX=a.preventGraphAnimation?null:h.xMap,d.animate({d:h})):(d=a[e]=a.chart.renderer.path(h).addClass(k[1]).attr({fill:q(k[3],E(k[2]).setOpacity(q(n.fillOpacity,.75)).get()),zIndex:0}).add(a.group),d.isArea=!0);d.startX=h.xMap;d.shiftUnit=n.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(J);
	(function(a){var E=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,G,q){var k=G.plotX,h=G.plotY,t=a[q-1];q=a[q+1];var C,n,A,B;if(t&&!t.isNull&&!1!==t.doCurve&&!G.isCliff&&q&&!q.isNull&&!1!==q.doCurve&&!G.isCliff){a=t.plotY;A=q.plotX;q=q.plotY;var e=0;C=(1.5*k+t.plotX)/2.5;n=(1.5*h+a)/2.5;A=(1.5*k+A)/2.5;B=(1.5*h+q)/2.5;A!==C&&(e=(B-n)*(A-k)/(A-C)+h-B);n+=e;B+=e;n>a&&n>h?(n=Math.max(a,h),B=2*h-n):n<a&&n<h&&(n=Math.min(a,h),B=2*h-n);B>q&&B>h?(B=Math.max(q,h),n=2*h-B):B<q&&B<h&&
	(B=Math.min(q,h),n=2*h-B);G.rightContX=A;G.rightContY=B}G=["C",E(t.rightContX,t.plotX),E(t.rightContY,t.plotY),E(C,k),E(n,h),k,h];t.rightContX=t.rightContY=null;return G}})})(J);(function(a){var E=a.seriesTypes.area.prototype,F=a.seriesType;F("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:E.getStackPoints,getGraphPath:E.getGraphPath,drawGraph:E.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(J);(function(a){var E=a.animObject,F=a.color,G=a.each,q=a.extend,k=a.defined,
	h=a.isNumber,t=a.merge,C=a.pick,n=a.Series,A=a.seriesType,B=a.svg;A("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group",
	"dataLabelsGroup"],negStacks:!0,init:function(){n.prototype.init.apply(this,arguments);var a=this,d=a.chart;d.hasRendered&&G(d.series,function(d){d.type===a.type&&(d.isDirty=!0)})},getColumnMetrics:function(){var a=this,d=a.options,h=a.xAxis,k=a.yAxis,b=h.options.reversedStacks,b=h.reversed&&!b||!h.reversed&&b,c,f={},w=0;!1===d.grouping?w=1:G(a.chart.series,function(b){var d=b.options,e=b.yAxis,h;b.type!==a.type||!b.visible&&a.chart.options.chart.ignoreHiddenSeries||k.len!==e.len||k.pos!==e.pos||
	(d.stacking?(c=b.stackKey,void 0===f[c]&&(f[c]=w++),h=f[c]):!1!==d.grouping&&(h=w++),b.columnIndex=h)});var x=Math.min(Math.abs(h.transA)*(h.ordinalSlope||d.pointRange||h.closestPointRange||h.tickInterval||1),h.len),m=x*d.groupPadding,n=(x-2*m)/(w||1),d=Math.min(d.maxPointWidth||h.len,C(d.pointWidth,n*(1-2*d.pointPadding)));a.columnMetrics={width:d,offset:(n-d)/2+(m+((a.columnIndex||0)+(b?1:0))*n-x/2)*(b?-1:1)};return a.columnMetrics},crispCol:function(a,d,h,k){var b=this.chart,c=this.borderWidth,
	e=-(c%2?.5:0),c=c%2?.5:1;b.inverted&&b.renderer.isVML&&(c+=1);this.options.crisp&&(h=Math.round(a+h)+e,a=Math.round(a)+e,h-=a);k=Math.round(d+k)+c;e=.5>=Math.abs(d)&&.5<k;d=Math.round(d)+c;k-=d;e&&k&&(--d,k+=1);return{x:a,y:d,width:h,height:k}},translate:function(){var a=this,d=a.chart,h=a.options,v=a.dense=2>a.closestPointRange*a.xAxis.transA,v=a.borderWidth=C(h.borderWidth,v?0:1),b=a.yAxis,c=h.threshold,f=a.translatedThreshold=b.getThreshold(c),w=C(h.minPointLength,5),x=a.getColumnMetrics(),m=x.width,
	I=a.barW=Math.max(m,1+2*v),z=a.pointXOffset=x.offset;d.inverted&&(f-=.5);h.pointPadding&&(I=Math.ceil(I));n.prototype.translate.apply(a);G(a.points,function(e){var h=C(e.yBottom,f),l=999+Math.abs(h),u=m,l=Math.min(Math.max(-l,e.plotY),b.len+l),p=e.plotX+z,D=I,g=Math.min(l,h),y,x=Math.max(l,h)-g;w&&Math.abs(x)<w&&(x=w,y=!b.reversed&&!e.negative||b.reversed&&e.negative,e.y===c&&a.dataMax<=c&&b.min<c&&(y=!y),g=Math.abs(g-f)>w?h-w:f-(y?w:0));k(e.options.pointWidth)&&(u=D=Math.ceil(e.options.pointWidth),
	p-=Math.round((u-m)/2));e.barX=p;e.pointWidth=u;e.tooltipPos=d.inverted?[b.len+b.pos-d.plotLeft-l,a.xAxis.len-p-D/2,x]:[p+D/2,l+b.pos-d.plotTop,x];e.shapeType="rect";e.shapeArgs=a.crispCol.apply(a,e.isNull?[p,f,D,0]:[p,g,D,x])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,d){var e=this.options,h,b=this.pointAttrToOptions||{};h=b.stroke||"borderColor";var c=
	b["stroke-width"]||"borderWidth",f=a&&a.color||this.color,k=a&&a[h]||e[h]||this.color||f,x=a&&a[c]||e[c]||this[c]||0,b=e.dashStyle;a&&this.zones.length&&(f=a.getZone(),f=a.options.color||f&&f.color||this.color);d&&(a=t(e.states[d],a.options.states&&a.options.states[d]||{}),d=a.brightness,f=a.color||void 0!==d&&F(f).brighten(a.brightness).get()||f,k=a[h]||k,x=a[c]||x,b=a.dashStyle||b);h={fill:f,stroke:k,"stroke-width":x};b&&(h.dashstyle=b);return h},drawPoints:function(){var a=this,d=this.chart,l=
	a.options,k=d.renderer,b=l.animationLimit||250,c;G(a.points,function(e){var f=e.graphic,x=f&&d.pointCount<b?"animate":"attr";if(h(e.plotY)&&null!==e.y){c=e.shapeArgs;if(f)f[x](t(c));else e.graphic=f=k[e.shapeType](c).add(e.group||a.group);l.borderRadius&&f.attr({r:l.borderRadius});f[x](a.pointAttribs(e,e.selected&&"select")).shadow(l.shadow,null,l.stacking&&!l.borderRadius);f.addClass(e.getClassName(),!0)}else f&&(e.graphic=f.destroy())})},animate:function(a){var d=this,e=this.yAxis,h=d.options,b=
	this.chart.inverted,c={},f=b?"translateX":"translateY",k;B&&(a?(c.scaleY=.001,a=Math.min(e.pos+e.len,Math.max(e.pos,e.toPixels(h.threshold))),b?c.translateX=a-e.len:c.translateY=a,d.group.attr(c)):(k=d.group.attr(f),d.group.animate({scaleY:1},q(E(d.options.animation),{step:function(a,b){c[f]=k+b.pos*(e.pos-k);d.group.attr(c)}})),d.animate=null))},remove:function(){var a=this,d=a.chart;d.hasRendered&&G(d.series,function(d){d.type===a.type&&(d.isDirty=!0)});n.prototype.remove.apply(a,arguments)}})})(J);
	(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(J);(function(a){var E=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,
	trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&E.prototype.drawGraph.call(this)}})})(J);(function(a){var E=a.deg2rad,F=a.isNumber,G=a.pick,q=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,h=this.chart,t=2*(a.slicedOffset||0),C=h.plotWidth-2*t,h=h.plotHeight-2*t,n=a.center,n=[G(n[0],"50%"),G(n[1],"50%"),a.size||"100%",a.innerSize||0],A=Math.min(C,h),B,e;for(B=0;4>B;++B)e=n[B],a=2>B||2===B&&
	/%$/.test(e),n[B]=q(e,[C,h,A,n[2]][B])+(a?t:0);n[3]>n[2]&&(n[3]=n[2]);return n},getStartAndEndRadians:function(a,h){a=F(a)?a:0;h=F(h)&&h>a&&360>h-a?h:a+360;return{start:E*(a+-90),end:E*(h+-90)}}}})(J);(function(a){var E=a.addEvent,F=a.CenteredSeriesMixin,G=a.defined,q=a.each,k=a.extend,h=F.getStartAndEndRadians,t=a.inArray,C=a.noop,n=a.pick,A=a.Point,B=a.Series,e=a.seriesType,d=a.setAnimation;e("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,distance:30,enabled:!0,
	formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var d=this,b=d.points,
	c=d.startAngleRad;a||(q(b,function(a){var b=a.graphic,e=a.shapeArgs;b&&(b.attr({r:a.startR||d.center[3]/2,start:c,end:c}),b.animate({r:e.r,start:e.start,end:e.end},d.options.animation))}),d.animate=null)},updateTotals:function(){var a,d=0,b=this.points,c=b.length,e,h=this.options.ignoreHiddenPoint;for(a=0;a<c;a++)e=b[a],d+=h&&!e.visible?0:e.isNull?0:e.y;this.total=d;for(a=0;a<c;a++)e=b[a],e.percentage=0<d&&(e.visible||!h)?e.y/d*100:0,e.total=d},generatePoints:function(){B.prototype.generatePoints.call(this);
	this.updateTotals()},translate:function(a){this.generatePoints();var d=0,b=this.options,c=b.slicedOffset,e=c+(b.borderWidth||0),l,k,m,I=h(b.startAngle,b.endAngle),z=this.startAngleRad=I.start,I=(this.endAngleRad=I.end)-z,u=this.points,r,q=b.dataLabels.distance,b=b.ignoreHiddenPoint,t,p=u.length,D;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){m=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(m)*(a[2]/2+d.labelDistance)};for(t=0;t<p;t++){D=u[t];
	D.labelDistance=n(D.options.dataLabels&&D.options.dataLabels.distance,q);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,D.labelDistance);l=z+d*I;if(!b||D.visible)d+=D.percentage/100;k=z+d*I;D.shapeType="arc";D.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*l)/1E3,end:Math.round(1E3*k)/1E3};m=(k+l)/2;m>1.5*Math.PI?m-=2*Math.PI:m<-Math.PI/2&&(m+=2*Math.PI);D.slicedTranslation={translateX:Math.round(Math.cos(m)*c),translateY:Math.round(Math.sin(m)*c)};k=Math.cos(m)*a[2]/
	2;r=Math.sin(m)*a[2]/2;D.tooltipPos=[a[0]+.7*k,a[1]+.7*r];D.half=m<-Math.PI/2||m>Math.PI/2?1:0;D.angle=m;l=Math.min(e,D.labelDistance/5);D.labelPos=[a[0]+k+Math.cos(m)*D.labelDistance,a[1]+r+Math.sin(m)*D.labelDistance,a[0]+k+Math.cos(m)*l,a[1]+r+Math.sin(m)*l,a[0]+k,a[1]+r,0>D.labelDistance?"center":D.half?"right":"left",m]}},drawGraph:null,drawPoints:function(){var a=this,d=a.chart.renderer,b,c,e,h,x=a.options.shadow;x&&!a.shadowGroup&&(a.shadowGroup=d.g("shadow").add(a.group));q(a.points,function(f){c=
	f.graphic;if(f.isNull)c&&(f.graphic=c.destroy());else{h=f.shapeArgs;b=f.getTranslate();var m=f.shadowGroup;x&&!m&&(m=f.shadowGroup=d.g("shadow").add(a.shadowGroup));m&&m.attr(b);e=a.pointAttribs(f,f.selected&&"select");c?c.setRadialReference(a.center).attr(e).animate(k(h,b)):(f.graphic=c=d[f.shapeType](h).setRadialReference(a.center).attr(b).add(a.group),c.attr(e).attr({"stroke-linejoin":"round"}).shadow(x,m));c.attr({visibility:f.visible?"inherit":"hidden"});c.addClass(f.getClassName())}})},searchPoint:C,
	sortByAngle:function(a,d){a.sort(function(a,c){return void 0!==a.angle&&(c.angle-a.angle)*d})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:F.getCenter,getSymbol:C},{init:function(){A.prototype.init.apply(this,arguments);var a=this,d;a.name=n(a.name,"Slice");d=function(b){a.slice("select"===b.type)};E(a,"select",d);E(a,"unselect",d);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,d){var b=this,c=b.series,e=c.chart,h=c.options.ignoreHiddenPoint;
	d=n(d,h);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,c.options.data[t(b,c.data)]=b.options,q(["graphic","dataLabel","connector","shadowGroup"],function(c){if(b[c])b[c][a?"show":"hide"](!0)}),b.legendItem&&e.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),h&&(c.isDirty=!0),d&&e.redraw())},slice:function(a,e,b){var c=this.series;d(b,c.chart);n(e,!0);this.sliced=this.options.sliced=G(a)?a:!this.sliced;c.options.data[t(this,c.data)]=this.options;this.graphic.animate(this.getTranslate());
	this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var d=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(d.x,d.y,d.r+a,d.r+a,{innerR:this.shapeArgs.r-1,start:d.start,end:d.end})}})})(J);(function(a){var E=a.addEvent,F=a.arrayMax,G=a.defined,q=a.each,k=a.extend,h=a.format,t=a.map,C=a.merge,n=a.noop,A=a.pick,B=a.relativeLength,e=
	a.Series,d=a.seriesTypes,l=a.some,v=a.stableSort,b=a.isArray,c=a.splat;a.distribute=function(b,c,d){function e(a,b){return a.target-b.target}var f,h=!0,k=b,r=[],x;x=0;var w=k.reducedLen||c;for(f=b.length;f--;)x+=b[f].size;if(x>w){v(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(x=f=0;x<=w;)x+=b[f].size,f++;r=b.splice(f-1,b.length)}v(b,e);for(b=t(b,function(a){return{size:a.size,targets:[a.target],align:A(a.align,.5)}});h;){for(f=b.length;f--;)h=b[f],x=(Math.min.apply(0,h.targets)+Math.max.apply(0,
	h.targets))/2,h.pos=Math.min(Math.max(0,x-h.size*h.align),c-h.size);f=b.length;for(h=!1;f--;)0<f&&b[f-1].pos+b[f-1].size>b[f].pos&&(b[f-1].size+=b[f].size,b[f-1].targets=b[f-1].targets.concat(b[f].targets),b[f-1].align=.5,b[f-1].pos+b[f-1].size>c&&(b[f-1].pos=c-b[f-1].size),b.splice(f,1),h=!0)}k.push.apply(k,r);f=0;l(b,function(b){var e=0;if(l(b.targets,function(){k[f].pos=b.pos+e;if(Math.abs(k[f].pos-k[f].target)>d)return q(k.slice(0,f+1),function(a){delete a.pos}),k.reducedLen=(k.reducedLen||c)-
	.1*c,k.reducedLen>.1*c&&a.distribute(k,c,d),!0;e+=k[f].size;f++}))return!0});v(k,e)};e.prototype.drawDataLabels=function(){function d(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}function e(a,c){var d=[],g;if(b(a)&&!b(c))d=t(a,function(a){return C(a,c)});else if(b(c)&&!b(a))d=t(c,function(b){return C(a,b)});else if(b(a)||b(c))for(g=Math.max(a.length,
	c.length);g--;)d[g]=C(a[g],c[g]);else d=C(a,c);return d}var k=this,m=k.chart,l=k.options,z=l.dataLabels,u=k.points,r,n=k.hasRendered||0,v,p=A(z.defer,!!l.animation),D=m.renderer,z=e(e(m.options.plotOptions&&m.options.plotOptions.series&&m.options.plotOptions.series.dataLabels,m.options.plotOptions&&m.options.plotOptions[k.type]&&m.options.plotOptions[k.type].dataLabels),z);if(b(z)||z.enabled||k._hasPointLabels)v=k.plotGroup("dataLabelsGroup","data-labels",p&&!n?"hidden":"visible",z.zIndex||6),p&&
	(v.attr({opacity:+n}),n||E(k,"afterAnimate",function(){k.visible&&v.show(!0);v[l.animation?"animate":"attr"]({opacity:1},{duration:200})})),q(u,function(b){r=c(e(z,b.dlOptions||b.options&&b.options.dataLabels));q(r,function(c,g){var e=c.enabled&&!b.isNull&&d(b,c),f,p,u,r,z=b.dataLabels?b.dataLabels[g]:b.dataLabel,x=b.connectors?b.connectors[g]:b.connector,y=!z;e&&(f=b.getLabelConfig(),p=c[b.formatPrefix+"Format"]||c.format,f=G(p)?h(p,f,m.time):(c[b.formatPrefix+"Formatter"]||c.formatter).call(f,c),
	p=c.style,u=c.rotation,p.color=A(c.color,p.color,k.color,"#000000"),"contrast"===p.color&&(b.contrastColor=D.getContrast(b.color||k.color),p.color=c.inside||0>A(c.distance,b.labelDistance)||l.stacking?b.contrastColor:"#000000"),l.cursor&&(p.cursor=l.cursor),r={fill:c.backgroundColor,stroke:c.borderColor,"stroke-width":c.borderWidth,r:c.borderRadius||0,rotation:u,padding:c.padding,zIndex:1},a.objectEach(r,function(a,b){void 0===a&&delete r[b]}));!z||e&&G(f)?e&&G(f)&&(z?r.text=f:(b.dataLabels=b.dataLabels||
	[],z=b.dataLabels[g]=u?D.text(f,0,-9999).addClass("highcharts-data-label"):D.label(f,0,-9999,c.shape,null,null,c.useHTML,null,"data-label"),g||(b.dataLabel=z),z.addClass(" highcharts-data-label-color-"+b.colorIndex+" "+(c.className||"")+(c.useHTML?" highcharts-tracker":""))),z.options=c,z.attr(r),z.css(p).shadow(c.shadow),z.added||z.add(v),k.alignDataLabel(b,z,c,null,y)):(b.dataLabel=b.dataLabel.destroy(),b.dataLabels&&(1===b.dataLabels.length?delete b.dataLabels:delete b.dataLabels[g]),g||delete b.dataLabel,
	x&&(b.connector=b.connector.destroy(),b.connectors&&(1===b.connectors.length?delete b.connectors:delete b.connectors[g])))})});a.fireEvent(this,"afterDrawDataLabels")};e.prototype.alignDataLabel=function(a,b,c,d,e){var f=this.chart,h=f.inverted,m=A(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),l=A(a.plotY,-9999),x=b.getBBox(),p,D=c.rotation,g=c.align,y=this.visible&&(a.series.forceDL||f.isInsidePlot(m,Math.round(l),h)||d&&f.isInsidePlot(m,h?d.x+1:d.y+d.height-1,h)),w="justify"===A(c.overflow,"justify");
	if(y&&(p=c.style.fontSize,p=f.renderer.fontMetrics(p,b).b,d=k({x:h?this.yAxis.len-l:m,y:Math.round(h?this.xAxis.len-m:l),width:0,height:0},d),k(c,{width:x.width,height:x.height}),D?(w=!1,m=f.renderer.rotCorr(p,D),m={x:d.x+c.x+d.width/2+m.x,y:d.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*d.height},b[e?"attr":"animate"](m).attr({align:g}),l=(D+720)%360,l=180<l&&360>l,"left"===g?m.y-=l?x.height:0:"center"===g?(m.x-=x.width/2,m.y-=x.height/2):"right"===g&&(m.x-=x.width,m.y-=l?0:x.height),b.placed=
	!0,b.alignAttr=m):(b.align(c,null,d),m=b.alignAttr),w&&0<=d.height?a.isLabelJustified=this.justifyDataLabel(b,c,m,x,d,e):A(c.crop,!0)&&(y=f.isInsidePlot(m.x,m.y)&&f.isInsidePlot(m.x+x.width,m.y+x.height)),c.shape&&!D))b[e?"attr":"animate"]({anchorX:h?f.plotWidth-a.plotY:a.plotX,anchorY:h?f.plotHeight-a.plotX:a.plotY});y||(b.attr({y:-9999}),b.placed=!1)};e.prototype.justifyDataLabel=function(a,b,c,d,e,h){var f=this.chart,m=b.align,k=b.verticalAlign,l,p,D=a.box?0:a.padding||0;l=c.x+D;0>l&&("right"===
	m?b.align="left":b.x=-l,p=!0);l=c.x+d.width-D;l>f.plotWidth&&("left"===m?b.align="right":b.x=f.plotWidth-l,p=!0);l=c.y+D;0>l&&("bottom"===k?b.verticalAlign="top":b.y=-l,p=!0);l=c.y+d.height-D;l>f.plotHeight&&("top"===k?b.verticalAlign="bottom":b.y=f.plotHeight-l,p=!0);p&&(a.placed=!h,a.align(b,null,e));return p};d.pie&&(d.pie.prototype.drawDataLabels=function(){var b=this,c=b.data,d,h=b.chart,l=b.options.dataLabels,k=A(l.connectorPadding,10),u=A(l.connectorWidth,1),r=h.plotWidth,n=h.plotHeight,v=
	Math.round(h.chartWidth/3),p,D=b.center,g=D[2]/2,y=D[1],t,B,C,N,E=[[],[]],M,P,S,X,J=[0,0,0,0];b.visible&&(l.enabled||b._hasPointLabels)&&(q(c,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),e.prototype.drawDataLabels.apply(b),q(c,function(a){a.dataLabel&&(a.visible?(E[a.half].push(a),a.dataLabel._pos=null,!G(l.style.width)&&!G(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&
	a.dataLabel.getBBox().width>v&&(a.dataLabel.css({width:.7*v}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),q(E,function(c,e){var f,p,m=c.length,u=[],z;if(m)for(b.sortByAngle(c,e-.5),0<b.maxLabelDistance&&(f=Math.max(0,y-g-b.maxLabelDistance),p=Math.min(y+g+b.maxLabelDistance,h.plotHeight),q(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,y-g-a.labelDistance),a.bottom=Math.min(y+g+a.labelDistance,h.plotHeight),
	z=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+z/2,size:z,rank:a.y},u.push(a.distributeBox))}),f=p+z-f,a.distribute(u,f,f/5)),X=0;X<m;X++)d=c[X],C=d.labelPos,t=d.dataLabel,S=!1===d.visible?"hidden":"inherit",P=f=C[1],u&&G(d.distributeBox)&&(void 0===d.distributeBox.pos?S="hidden":(N=d.distributeBox.size,P=d.top+d.distributeBox.pos)),delete d.positionIndex,M=l.justify?D[0]+(e?-1:1)*(g+d.labelDistance):b.getX(P<d.top+2||P>d.bottom-2?f:P,e,d),t._attr={visibility:S,align:C[6]},
	t._pos={x:M+l.x+({left:k,right:-k}[C[6]]||0),y:P+l.y-10},C.x=M,C.y=P,A(l.crop,!0)&&(B=t.getBBox().width,f=null,M-B<k&&1===e?(f=Math.round(B-M+k),J[3]=Math.max(f,J[3])):M+B>r-k&&0===e&&(f=Math.round(M+B-r+k),J[1]=Math.max(f,J[1])),0>P-N/2?J[0]=Math.max(Math.round(-P+N/2),J[0]):P+N/2>n&&(J[2]=Math.max(Math.round(P+N/2-n),J[2])),t.sideOverflow=f)}),0===F(J)||this.verifyDataLabelOverflow(J))&&(this.placeDataLabels(),u&&q(this.points,function(a){var c;p=a.connector;if((t=a.dataLabel)&&t._pos&&a.visible&&
	0<a.labelDistance){S=t._attr.visibility;if(c=!p)a.connector=p=h.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),p.attr({"stroke-width":u,stroke:l.connectorColor||a.color||"#666666"});p[c?"attr":"animate"]({d:b.connectorPath(a.labelPos)});p.attr("visibility",S)}else p&&(a.connector=p.destroy())}))},d.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return A(this.options.dataLabels.softConnector,
	!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},d.pie.prototype.placeDataLabels=function(){q(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=
	!0):b&&b.attr({y:-9999}))},this)},d.pie.prototype.alignDataLabel=n,d.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,e=c.minSize||80,f,h=null!==c.size;h||(null!==d[0]?f=Math.max(b[2]-Math.max(a[1],a[3]),e):(f=Math.max(b[2]-a[1]-a[3],e),b[0]+=(a[3]-a[1])/2),null!==d[1]?f=Math.max(Math.min(f,b[2]-Math.max(a[0],a[2])),e):(f=Math.max(Math.min(f,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2),f<b[2]?(b[2]=f,b[3]=Math.min(B(c.innerSize||0,f),f),this.translate(b),this.drawDataLabels&&
	this.drawDataLabels()):h=!0);return h});d.column&&(d.column.prototype.alignDataLabel=function(a,b,c,d,h){var f=this.chart.inverted,m=a.series,l=a.dlBox||a.shapeArgs,k=A(a.below,a.plotY>A(this.translatedThreshold,m.yAxis.len)),x=A(c.inside,!!this.options.stacking);l&&(d=C(l),0>d.y&&(d.height+=d.y,d.y=0),l=d.y+d.height-m.yAxis.len,0<l&&(d.height-=l),f&&(d={x:m.yAxis.len-d.y-d.height,y:m.xAxis.len-d.x-d.width,width:d.height,height:d.width}),x||(f?(d.x+=k?0:d.width,d.width=0):(d.y+=k?d.height:0,d.height=
	0)));c.align=A(c.align,!f||x?"center":k?"right":"left");c.verticalAlign=A(c.verticalAlign,f||x?"middle":k?"top":"bottom");e.prototype.alignDataLabel.call(this,a,b,c,d,h);a.isLabelJustified&&a.contrastColor&&b.css({color:a.contrastColor})})})(J);(function(a){var E=a.Chart,F=a.each,G=a.isArray,q=a.objectEach,k=a.pick;a=a.addEvent;a(E,"render",function(){var a=[];F(this.labelCollectors||[],function(h){a=a.concat(h())});F(this.yAxis||[],function(h){h.options.stackLabels&&!h.options.stackLabels.allowOverlap&&
	q(h.stacks,function(h){q(h,function(h){a.push(h.label)})})});F(this.series||[],function(h){var q=h.options.dataLabels;h.visible&&(!1!==q.enabled||h._hasPointLabels)&&F(h.points,function(h){if(h.visible){var n=G(h.dataLabels)?h.dataLabels:h.dataLabel?[h.dataLabel]:[];F(n,function(n){var e=n.options;n.labelrank=k(e.labelrank,h.labelrank,h.shapeArgs&&h.shapeArgs.height);e.allowOverlap||a.push(n)})}})});this.hideOverlappingLabels(a)});E.prototype.hideOverlappingLabels=function(a){var h=a.length,k=this.renderer,
	n,q,B,e,d,l,v=function(a,c,d,e,h,m,l,k){return!(h>a+d||h+l<a||m>c+e||m+k<c)};B=function(a){var b,d,e,h=a.box?0:a.padding||0;e=0;if(a&&(!a.alignAttr||a.placed))return b=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},d=a.parentGroup,a.width||(e=a.getBBox(),a.width=e.width,a.height=e.height,e=k.fontMetrics(null,a.element).h),{x:b.x+(d.translateX||0)+h,y:b.y+(d.translateY||0)+h-e,width:a.width-2*h,height:a.height-2*h}};for(q=0;q<h;q++)if(n=a[q])n.oldOpacity=n.opacity,n.newOpacity=1,n.absoluteBox=B(n);a.sort(function(a,
	c){return(c.labelrank||0)-(a.labelrank||0)});for(q=0;q<h;q++)for(l=(B=a[q])&&B.absoluteBox,n=q+1;n<h;++n)if(d=(e=a[n])&&e.absoluteBox,l&&d&&B!==e&&0!==B.newOpacity&&0!==e.newOpacity&&(d=v(l.x,l.y,l.width,l.height,d.x,d.y,d.width,d.height)))(B.labelrank<e.labelrank?B:e).newOpacity=0;F(a,function(a){var b,d;a&&(d=a.newOpacity,a.oldOpacity!==d&&(a.alignAttr&&a.placed?(d?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=d,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)):a.attr({opacity:d})),a.isOld=
	!0)})}})(J);(function(a){var E=a.addEvent,F=a.Chart,G=a.createElement,q=a.css,k=a.defaultOptions,h=a.defaultPlotOptions,t=a.each,C=a.extend,n=a.fireEvent,A=a.hasTouch,B=a.inArray,e=a.isObject,d=a.Legend,l=a.merge,v=a.pick,b=a.Point,c=a.Series,f=a.seriesTypes,w=a.svg,x;x=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};t(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&
	(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(t(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(A)a[d].on("touchstart",c);a.options.cursor&&a[d].css(q).css({cursor:a.options.cursor})}}),a._hasTracking=!0);n(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,h=
	f.pointer,p=f.renderer,l=f.options.tooltip.snap,g=a.tracker,k,x=function(){if(f.hoverSeries!==a)a.onMouseOver()},v="rgba(192,192,192,"+(w?.0001:.002)+")";if(e&&!c)for(k=e+1;k--;)"M"===d[k]&&d.splice(k+1,0,d[k+1]-l,d[k+2],"L"),(k&&"M"===d[k]||k===e)&&d.splice(k,0,"L",d[k-2]+l,d[k-1]);g?g.attr({d:d}):a.graph&&(a.tracker=p.path(d).attr({"stroke-linejoin":"round",stroke:v,fill:c?v:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*l),visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(c?"highcharts-tracker-area":
	"highcharts-tracker-line").add(a.group),t([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",x).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(A)a.on("touchstart",x)}));n(this,"afterDrawTracker")}};f.column&&(f.column.prototype.drawTracker=x.drawTrackerPoint);f.pie&&(f.pie.prototype.drawTracker=x.drawTrackerPoint);f.scatter&&(f.scatter.prototype.drawTracker=x.drawTrackerPoint);k.legend.itemStyle.cursor="pointer";C(d.prototype,
	{setItemEvents:function(a,c,d){var e=this,f=e.chart.renderer.boxWrapper,h="highcharts-legend-"+(a instanceof b?"point":"series")+"-active";(d?c:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(h);c.css(e.options.itemHoverStyle)}).on("mouseout",function(){c.css(l(a.visible?e.itemStyle:e.itemHiddenStyle));f.removeClass(h);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};f.removeClass(h);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",
	b,c):n(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=G("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);E(a.checkbox,"click",function(b){n(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});C(F.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=k.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=
	e.states,h="chart"===d.relativeTo?null:"plotBox";n(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,h)})},zoomOut:function(){n(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,c=this.pointer,d=!1,f;!a||a.resetSelection?(t(this.axes,function(a){b=a.zoom()}),c.initiated=!1):t(a.xAxis.concat(a.yAxis),
	function(a){var e=a.axis;c[e.isXAxis?"zoomX":"zoomY"]&&(b=e.zoom(a.min,a.max),e.displayBtn&&(d=!0))});f=this.resetZoomButton;d&&!f?this.showResetZoom():!d&&e(f)&&(this.resetZoomButton=f.destroy());b&&this.redraw(v(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&t(d,function(a){a.setState()});t("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],g=(b.pointRange||
	0)/2,k=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),m=b.toValue(h-f,!0)+g*k,k=b.toValue(h+b.len-f,!0)-g*k,u=k<m,h=u?k:m,m=u?m:k,k=Math.min(l.dataMin,g?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),g=Math.max(l.dataMax,g?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding)),u=k-h;0<u&&(m+=u,h=k);u=m-g;0<u&&(m=g,h-=u);b.series.length&&h!==l.min&&m!==l.max&&(b.setExtremes(h,m,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);q(c.container,{cursor:"move"})}});C(b.prototype,
	{select:function(a,b){var c=this,d=c.series,e=d.chart;a=v(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[B(c,d.data)]=c.options;c.setState(a&&"select");b||t(e.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[B(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,
	b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");t(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=l(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){E(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,f=e.options.states[a||"normal"]||{},k=
	h[e.type].marker&&e.options.marker,p=k&&!1===k.enabled,l=k&&k.states&&k.states[a||"normal"]||{},g=!1===l.enabled,m=e.stateMarkerGraphic,x=this.marker||{},w=e.chart,q=e.halo,t,A=k&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===f.enabled||a&&(g||p&&!1===l.enabled)||a&&x.states&&x.states[a]&&!1===x.states[a].enabled)){A&&(t=e.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+
	a),this.graphic.animate(e.pointAttribs(this,a),v(w.options.chart.animation,f.animation)),t&&this.graphic.animate(t,v(w.options.chart.animation,l.animation,k.animation)),m&&m.hide();else{if(a&&l){k=x.symbol||e.symbol;m&&m.currentSymbol!==k&&(m=m.destroy());if(m)m[b?"animate":"attr"]({x:t.x,y:t.y});else k&&(e.stateMarkerGraphic=m=w.renderer.symbol(k,t.x,t.y,t.width,t.height).add(e.markerGroup),m.currentSymbol=k);m&&m.attr(e.pointAttribs(this,a))}m&&(m[a&&w.isInsidePlot(c,d,w.inverted)?"show":"hide"](),
	m.element.point=this)}(c=f.halo)&&c.size?(q||(e.halo=q=w.renderer.path().add((this.graphic||m).parentGroup)),q.show()[b?"animate":"attr"]({d:this.haloPath(c.size)}),q.attr({"class":"highcharts-halo highcharts-color-"+v(this.colorIndex,e.colorIndex)+(this.className?" "+this.className:""),zIndex:-1}),q.point=this,q.attr(C({fill:this.color||e.color,"fill-opacity":c.opacity},c.attributes))):q&&q.point&&q.point.haloPath&&q.animate({d:q.point.haloPath(0)},null,q.hide);this.state=a;n(this,"afterSetState")}},
	haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});C(c.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&n(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&n(this,"mouseOut");!c||this.stickyTracking||
	c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,f=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(t([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==e[a].enabled)&&(a&&(f=e[a].lineWidth||f+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(f={"stroke-width":f},d.animate(f,v(e[a||"normal"]&&e[a||"normal"].animation,
	b.chart.options.chart.animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(f),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,p=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!p:a)?"show":"hide";t(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&
	t(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});t(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);n(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);n(this,a?"select":"unselect")},drawTracker:x.drawTrackerGraph})})(J);(function(a){var E=a.Chart,F=a.each,G=a.inArray,q=a.isArray,k=a.isObject,h=a.pick,t=a.splat;
	E.prototype.setResponsive=function(h){var k=this.options.responsive,q=[],t=this.currentResponsive;k&&k.rules&&F(k.rules,function(d){void 0===d._id&&(d._id=a.uniqueKey());this.matchResponsiveRule(d,q,h)},this);var e=a.merge.apply(0,a.map(q,function(d){return a.find(k.rules,function(a){return a._id===d}).chartOptions})),q=q.toString()||void 0;q!==(t&&t.ruleIds)&&(t&&this.update(t.undoOptions,h),q?(this.currentResponsive={ruleIds:q,mergedOptions:e,undoOptions:this.currentOptions(e)},this.update(e,h)):
	this.currentResponsive=void 0)};E.prototype.matchResponsiveRule=function(a,k){var n=a.condition;(n.callback||function(){return this.chartWidth<=h(n.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=h(n.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=h(n.minWidth,0)&&this.chartHeight>=h(n.minHeight,0)}).call(this)&&k.push(a._id)};E.prototype.currentOptions=function(h){function n(h,e,d,l){var v;a.objectEach(h,function(a,c){if(!l&&-1<G(c,["series","xAxis","yAxis"]))for(a=t(a),d[c]=[],v=0;v<a.length;v++)e[c][v]&&
	(d[c][v]={},n(a[v],e[c][v],d[c][v],l+1));else k(a)?(d[c]=q(a)?[]:{},n(a,e[c]||{},d[c],l+1)):d[c]=e[c]||null})}var A={};n(h,this.options,A,0);return A}})(J);(function(a){var E=a.addEvent,F=a.Axis,G=a.Chart,q=a.css,k=a.defined,h=a.each,t=a.extend,C=a.noop,n=a.pick,A=a.timeUnits,B=a.wrap;B(a.Series.prototype,"init",function(a){var d;a.apply(this,Array.prototype.slice.call(arguments,1));(d=this.xAxis)&&d.options.ordinal&&E(this,"updatedData",function(){delete d.ordinalIndex})});B(F.prototype,"getTimeTicks",
	function(a,d,h,n,b,c,f,w){var e=0,l,v,z={},u,r,q,t=[],p=-Number.MAX_VALUE,D=this.options.tickPixelInterval,g=this.chart.time;if(!this.options.ordinal&&!this.options.breaks||!c||3>c.length||void 0===h)return a.call(this,d,h,n,b);r=c.length;for(l=0;l<r;l++){q=l&&c[l-1]>n;c[l]<h&&(e=l);if(l===r-1||c[l+1]-c[l]>5*f||q){if(c[l]>p){for(v=a.call(this,d,c[e],c[l],b);v.length&&v[0]<=p;)v.shift();v.length&&(p=v[v.length-1]);t=t.concat(v)}e=l+1}if(q)break}a=v.info;if(w&&a.unitRange<=A.hour){l=t.length-1;for(e=
	1;e<l;e++)g.dateFormat("%d",t[e])!==g.dateFormat("%d",t[e-1])&&(z[t[e]]="day",u=!0);u&&(z[t[0]]="day");a.higherRanks=z}t.info=a;if(w&&k(D)){w=g=t.length;l=[];var y;for(u=[];w--;)e=this.translate(t[w]),y&&(u[w]=y-e),l[w]=y=e;u.sort();u=u[Math.floor(u.length/2)];u<.6*D&&(u=null);w=t[g-1]>n?g-1:g;for(y=void 0;w--;)e=l[w],n=Math.abs(y-e),y&&n<.8*D&&(null===u||n<.8*u)?(z[t[w]]&&!z[t[w+1]]?(n=w+1,y=e):n=w,t.splice(n,1)):y=e}return t});t(F.prototype,{beforeSetTickPositions:function(){var a,d=[],l,v=!1,b,
	c=this.getExtremes(),f=c.min,w=c.max,x,m=this.isXAxis&&!!this.options.breaks,c=this.options.ordinal,q=Number.MAX_VALUE,z=this.chart.options.chart.ignoreHiddenSeries;b="highcharts-navigator-xaxis"===this.options.className;var u;!this.options.overscroll||this.max!==this.dataMax||this.chart.mouseIsDown&&!b||this.eventArgs&&(!this.eventArgs||"navigator"===this.eventArgs.trigger)||(this.max+=this.options.overscroll,!b&&k(this.userMin)&&(this.min+=this.options.overscroll));if(c||m){h(this.series,function(b,
	c){l=[];if(!(z&&!1===b.visible||!1===b.takeOrdinalPosition&&!m)&&(d=d.concat(b.processedXData),a=d.length,d.sort(function(a,b){return a-b}),q=Math.min(q,n(b.closestPointRange,q)),a)){for(c=0;c<a-1;)d[c]!==d[c+1]&&l.push(d[c+1]),c++;l[0]!==d[0]&&l.unshift(d[0]);d=l}b.isSeriesBoosting&&(u=!0)});u&&(d.length=0);a=d.length;if(2<a){b=d[1]-d[0];for(x=a-1;x--&&!v;)d[x+1]-d[x]!==b&&(v=!0);!this.options.keepOrdinalPadding&&(d[0]-f>b||w-d[d.length-1]>b)&&(v=!0)}else this.options.overscroll&&(2===a?q=d[1]-d[0]:
	1===a?(q=this.options.overscroll,d=[d[0],d[0]+q]):q=this.overscrollPointsRange);v?(this.options.overscroll&&(this.overscrollPointsRange=q,d=d.concat(this.getOverscrollPositions())),this.ordinalPositions=d,b=this.ordinal2lin(Math.max(f,d[0]),!0),x=Math.max(this.ordinal2lin(Math.min(w,d[d.length-1]),!0),1),this.ordinalSlope=w=(w-f)/(x-b),this.ordinalOffset=f-b*w):(this.overscrollPointsRange=n(this.closestPointRange,this.overscrollPointsRange),this.ordinalPositions=this.ordinalSlope=this.ordinalOffset=
	void 0)}this.isOrdinal=c&&v;this.groupIntervalFactor=null},val2lin:function(a,d){var e=this.ordinalPositions;if(e){var h=e.length,b,c;for(b=h;b--;)if(e[b]===a){c=b;break}for(b=h-1;b--;)if(a>e[b]||0===b){a=(a-e[b])/(e[b+1]-e[b]);c=b+a;break}d=d?c:this.ordinalSlope*(c||0)+this.ordinalOffset}else d=a;return d},lin2val:function(a,d){var e=this.ordinalPositions;if(e){var h=this.ordinalSlope,b=this.ordinalOffset,c=e.length-1,f;if(d)0>a?a=e[0]:a>c?a=e[c]:(c=Math.floor(a),f=a-c);else for(;c--;)if(d=h*c+b,
	a>=d){h=h*(c+1)+b;f=(a-d)/(h-d);break}return void 0!==f&&void 0!==e[c]?e[c]+(f?f*(e[c+1]-e[c]):0):a}return a},getExtendedPositions:function(){var a=this,d=a.chart,k=a.series[0].currentDataGrouping,n=a.ordinalIndex,b=k?k.count+k.unitName:"raw",c=a.options.overscroll,f=a.getExtremes(),w,x;n||(n=a.ordinalIndex={});n[b]||(w={series:[],chart:d,getExtremes:function(){return{min:f.dataMin,max:f.dataMax+c}},options:{ordinal:!0},val2lin:F.prototype.val2lin,ordinal2lin:F.prototype.ordinal2lin},h(a.series,function(b){x=
	{xAxis:w,xData:b.xData.slice(),chart:d,destroyGroupedData:C};x.xData=x.xData.concat(a.getOverscrollPositions());x.options={dataGrouping:k?{enabled:!0,forced:!0,approximation:"open",units:[[k.unitName,[k.count]]]}:{enabled:!1}};b.processData.apply(x);w.series.push(x)}),a.beforeSetTickPositions.apply(w),n[b]=w.ordinalPositions);return n[b]},getOverscrollPositions:function(){var e=this.options.overscroll,d=this.overscrollPointsRange,h=[],k=this.dataMax;if(a.defined(d))for(h.push(k);k<=this.dataMax+e;)k+=
	d,h.push(k);return h},getGroupIntervalFactor:function(a,d,h){var e;h=h.processedXData;var b=h.length,c=[];e=this.groupIntervalFactor;if(!e){for(e=0;e<b-1;e++)c[e]=h[e+1]-h[e];c.sort(function(a,b){return a-b});c=c[Math.floor(b/2)];a=Math.max(a,h[0]);d=Math.min(d,h[b-1]);this.groupIntervalFactor=e=b*c/(d-a)}return e},postProcessTickInterval:function(a){var d=this.ordinalSlope;return d?this.options.breaks?this.closestPointRange||a:a/(d/this.closestPointRange):a}});F.prototype.ordinal2lin=F.prototype.val2lin;
	B(G.prototype,"pan",function(a,d){var e=this.xAxis[0],k=e.options.overscroll,b=d.chartX,c=!1;if(e.options.ordinal&&e.series.length){var f=this.mouseDownX,n=e.getExtremes(),x=n.dataMax,m=n.min,t=n.max,z=this.hoverPoints,u=e.closestPointRange||e.overscrollPointsRange,f=(f-b)/(e.translationSlope*(e.ordinalSlope||u)),r={ordinalPositions:e.getExtendedPositions()},u=e.lin2val,A=e.val2lin,B;r.ordinalPositions?1<Math.abs(f)&&(z&&h(z,function(a){a.setState()}),0>f?(z=r,B=e.ordinalPositions?e:r):(z=e.ordinalPositions?
	e:r,B=r),r=B.ordinalPositions,x>r[r.length-1]&&r.push(x),this.fixedRange=t-m,f=e.toFixedRange(null,null,u.apply(z,[A.apply(z,[m,!0])+f,!0]),u.apply(B,[A.apply(B,[t,!0])+f,!0])),f.min>=Math.min(n.dataMin,m)&&f.max<=Math.max(x,t)+k&&e.setExtremes(f.min,f.max,!0,!1,{trigger:"pan"}),this.mouseDownX=b,q(this.container,{cursor:"move"})):c=!0}else c=!0;c&&(k&&(e.max=e.dataMax+k),a.apply(this,Array.prototype.slice.call(arguments,1)))})})(J);(function(a){function E(){return Array.prototype.slice.call(arguments,
	1)}function F(a){a.apply(this);this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,q(this.pointArrayMap,["y"]))}var G=a.addEvent,q=a.pick,k=a.wrap,h=a.each,t=a.extend,C=a.isArray,n=a.fireEvent,A=a.Axis,B=a.Series;t(A.prototype,{isInBreak:function(a,d){var e=a.repeat||Infinity,h=a.from,b=a.to-a.from;d=d>=h?(d-h)%e:e-(h-d)%e;return a.inclusive?d<=b:d<b&&0!==d},isInAnyBreak:function(a,d){var e=this.options.breaks,h=e&&e.length,b,c,f;if(h){for(;h--;)this.isInBreak(e[h],a)&&(b=!0,c||(c=q(e[h].showPoints,
	this.isXAxis?!1:!0)));f=b&&d?b&&!c:b}return f}});G(A,"afterInit",function(){"function"===typeof this.setBreaks&&this.setBreaks(this.options.breaks,!1)});G(A,"afterSetTickPositions",function(){if(this.isBroken){var a=this.tickPositions,d=this.tickPositions.info,h=[],k;for(k=0;k<a.length;k++)this.isInAnyBreak(a[k])||h.push(a[k]);this.tickPositions=h;this.tickPositions.info=d}});G(A,"afterSetOptions",function(){this.isBroken&&(this.options.ordinal=!1)});A.prototype.setBreaks=function(a,d){function e(a){var c=
	a,d,e;for(e=0;e<b.breakArray.length;e++)if(d=b.breakArray[e],d.to<=a)c-=d.len;else if(d.from>=a)break;else if(b.isInBreak(d,a)){c-=a-d.from;break}return c}function k(a){var c,d;for(d=0;d<b.breakArray.length&&!(c=b.breakArray[d],c.from>=a);d++)c.to<a?a+=c.len:b.isInBreak(c,a)&&(a+=c.len);return a}var b=this,c=C(a)&&!!a.length;b.isDirty=b.isBroken!==c;b.isBroken=c;b.options.breaks=b.userOptions.breaks=a;b.forceRedraw=!0;c||b.val2lin!==e||(delete b.val2lin,delete b.lin2val);c&&(b.userOptions.ordinal=
	!1,b.val2lin=e,b.lin2val=k,b.setExtremes=function(a,b,c,d,e){if(this.isBroken){for(;this.isInAnyBreak(a);)a-=this.closestPointRange;for(;this.isInAnyBreak(b);)b-=this.closestPointRange}A.prototype.setExtremes.call(this,a,b,c,d,e)},b.setAxisTranslation=function(a){A.prototype.setAxisTranslation.call(this,a);this.unitLength=null;if(this.isBroken){a=b.options.breaks;var c=[],d=[],e=0,f,k,l=b.userMin||b.min,r=b.userMax||b.max,t=q(b.pointRangePadding,0),v,p;h(a,function(a){k=a.repeat||Infinity;b.isInBreak(a,
	l)&&(l+=a.to%k-l%k);b.isInBreak(a,r)&&(r-=r%k-a.from%k)});h(a,function(a){v=a.from;for(k=a.repeat||Infinity;v-k>l;)v-=k;for(;v<l;)v+=k;for(p=v;p<r;p+=k)c.push({value:p,move:"in"}),c.push({value:p+(a.to-a.from),move:"out",size:a.breakSize})});c.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-b.value});f=0;v=l;h(c,function(a){f+="in"===a.move?1:-1;1===f&&"in"===a.move&&(v=a.value);0===f&&(d.push({from:v,to:a.value,len:a.value-v-(a.size||0)}),e+=a.value-v-
	(a.size||0))});b.breakArray=d;b.unitLength=r-l-e+t;n(b,"afterBreaks");b.staticScale?b.transA=b.staticScale:b.unitLength&&(b.transA*=(r-b.min+t)/b.unitLength);t&&(b.minPixelPadding=b.transA*b.minPointOffset);b.min=l;b.max=r}});q(d,!0)&&this.chart.redraw()};k(B.prototype,"generatePoints",function(a){a.apply(this,E(arguments));var d=this.xAxis,e=this.yAxis,h=this.points,b,c=h.length,f=this.options.connectNulls,k;if(d&&e&&(d.options.breaks||e.options.breaks))for(;c--;)b=h[c],k=null===b.y&&!1===f,k||!d.isInAnyBreak(b.x,
	!0)&&!e.isInAnyBreak(b.y,!0)||(h.splice(c,1),this.data[c]&&this.data[c].destroyElements())});a.Series.prototype.drawBreaks=function(a,d){var e=this,k=e.points,b,c,f,w;a&&h(d,function(d){b=a.breakArray||[];c=a.isXAxis?a.min:q(e.options.threshold,a.min);h(k,function(e){w=q(e["stack"+d.toUpperCase()],e[d]);h(b,function(b){f=!1;if(c<b.from&&w>b.to||c>b.from&&w<b.from)f="pointBreak";else if(c<b.from&&w>b.from&&w<b.to||c>b.from&&w>b.to&&w<b.from)f="pointInBreak";f&&n(a,f,{point:e,brk:b})})})})};a.Series.prototype.gappedPath=
	function(){var e=this.currentDataGrouping,d=e&&e.totalRange,e=this.options.gapSize,h=this.points.slice(),k=h.length-1,b=this.yAxis;if(e&&0<k)for("value"!==this.options.gapUnit&&(e*=this.closestPointRange),d&&d>e&&(e=d);k--;)h[k+1].x-h[k].x>e&&(d=(h[k].x+h[k+1].x)/2,h.splice(k+1,0,{isNull:!0,x:d}),this.options.stacking&&(d=b.stacks[this.stackKey][d]=new a.StackItem(b,b.options.stackLabels,!1,d,this.stack),d.total=0));return this.getGraphPath(h)};k(a.seriesTypes.column.prototype,"drawPoints",F);k(a.Series.prototype,
	"drawPoints",F)})(J);(function(a){var E=a.addEvent,F=a.arrayMax,G=a.arrayMin,q=a.Axis,k=a.defaultPlotOptions,h=a.defined,t=a.each,C=a.extend,n=a.format,A=a.isNumber,B=a.merge,e=a.pick,d=a.Point,l=a.Series,v=a.Tooltip,b=a.wrap,c=l.prototype,f=c.processData,w=c.generatePoints,x={approximation:"average",groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L","%A, %b %e, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M",
	"%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},m={line:{},spline:{},area:{},areaspline:{},column:{approximation:"sum",groupPixelWidth:10},arearange:{approximation:"range"},areasplinerange:{approximation:"range"},columnrange:{approximation:"range",groupPixelWidth:10},candlestick:{approximation:"ohlc",
	groupPixelWidth:10},ohlc:{approximation:"ohlc",groupPixelWidth:5}},I=a.defaultDataGroupingUnits=[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]],z=a.approximations={sum:function(a){var b=a.length,c;if(!b&&a.hasNulls)c=null;else if(b)for(c=0;b--;)c+=a[b];return c},average:function(a){var b=a.length;a=z.sum(a);A(a)&&b&&(a/=b);return a},averages:function(){var a=
	[];t(arguments,function(b){a.push(z.average(b))});return void 0===a[0]?void 0:a},open:function(a){return a.length?a[0]:a.hasNulls?null:void 0},high:function(a){return a.length?F(a):a.hasNulls?null:void 0},low:function(a){return a.length?G(a):a.hasNulls?null:void 0},close:function(a){return a.length?a[a.length-1]:a.hasNulls?null:void 0},ohlc:function(a,b,c,d){a=z.open(a);b=z.high(b);c=z.low(c);d=z.close(d);if(A(a)||A(b)||A(c)||A(d))return[a,b,c,d]},range:function(a,b){a=z.low(a);b=z.high(b);if(A(a)||
	A(b))return[a,b];if(null===a&&null===b)return null}};c.groupData=function(a,b,c,d){var e=this,f=e.data,g=e.options.data,k=[],l=[],n=[],r=a.length,u,q,w=!!b,v=[];d="function"===typeof d?d:z[d]||m[e.type]&&z[m[e.type].approximation]||z[x.approximation];var C=e.pointArrayMap,I=C&&C.length,H=["x"].concat(C||["y"]),E=0,F=0,K,G;I?t(C,function(){v.push([])}):v.push([]);K=I||1;for(G=0;G<=r&&!(a[G]>=c[0]);G++);for(G;G<=r;G++){for(;void 0!==c[E+1]&&a[G]>=c[E+1]||G===r;){u=c[E];e.dataGroupInfo={start:F,length:v[0].length};
	q=d.apply(e,v);h(e.dataGroupInfo.options)||(e.dataGroupInfo.options=B(e.pointClass.prototype.optionsToObject.call({series:e},e.options.data[F])),t(H,function(a){delete e.dataGroupInfo.options[a]}));void 0!==q&&(k.push(u),l.push(q),n.push(e.dataGroupInfo));F=G;for(u=0;u<K;u++)v[u].length=0,v[u].hasNulls=!1;E+=1;if(G===r)break}if(G===r)break;if(C){u=e.cropStart+G;q=f&&f[u]||e.pointClass.prototype.applyOptions.apply({series:e},[g[u]]);var J;for(u=0;u<I;u++)J=q[C[u]],A(J)?v[u].push(J):null===J&&(v[u].hasNulls=
	!0)}else u=w?b[G]:null,A(u)?v[0].push(u):null===u&&(v[0].hasNulls=!0)}return[k,l,n]};c.processData=function(){var a=this.chart,b=this.options.dataGrouping,d=!1!==this.allowDG&&b&&e(b.enabled,a.options.isStock),k=this.visible||!a.options.chart.ignoreHiddenSeries,p,l=this.currentDataGrouping,g;this.forceCrop=d;this.groupPixelWidth=null;this.hasProcessed=!0;if(!1!==f.apply(this,arguments)&&d){this.destroyGroupedData();var m,n=b.groupAll?this.xData:this.processedXData,x=b.groupAll?this.yData:this.processedYData,
	z=a.plotSizeX,a=this.xAxis,q=a.options.ordinal,w=this.groupPixelWidth=a.getGroupPixelWidth&&a.getGroupPixelWidth();if(w){this.isDirty=p=!0;this.points=null;d=a.getExtremes();g=d.min;d=d.max;q=q&&a.getGroupIntervalFactor(g,d,this)||1;w=w*(d-g)/z*q;z=a.getTimeTicks(a.normalizeTimeTickInterval(w,b.units||I),Math.min(g,n[0]),Math.max(d,n[n.length-1]),a.options.startOfWeek,n,this.closestPointRange);x=c.groupData.apply(this,[n,x,z,b.approximation]);n=x[0];q=x[1];if(b.smoothed&&n.length){m=n.length-1;for(n[m]=
	Math.min(n[m],d);m--&&0<m;)n[m]+=w/2;n[0]=Math.max(n[0],g)}g=z.info;this.closestPointRange=z.info.totalRange;this.groupMap=x[2];if(h(n[0])&&n[0]<a.dataMin&&k){if(!h(a.options.min)&&a.min<=a.dataMin||a.min===a.dataMin)a.min=n[0];a.dataMin=n[0]}b.groupAll&&(b=this.cropData(n,q,a.min,a.max,1),n=b.xData,q=b.yData);this.processedXData=n;this.processedYData=q}else this.groupMap=null;this.hasGroupedData=p;this.currentDataGrouping=g;this.preventGraphAnimation=(l&&l.totalRange)!==(g&&g.totalRange)}};c.destroyGroupedData=
	function(){var a=this.groupedData;t(a||[],function(b,c){b&&(a[c]=b.destroy?b.destroy():null)});this.groupedData=null};c.generatePoints=function(){w.apply(this);this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null};E(d,"update",function(){if(this.dataGroup)return a.error(24),!1});b(v.prototype,"tooltipFooterHeaderFormatter",function(a,b,c){var d=this.chart.time,e=b.series,f=e.tooltipOptions,g=e.options.dataGrouping,h=f.xDateFormat,k,l=e.xAxis;return l&&"datetime"===l.options.type&&
	g&&A(b.key)?(a=e.currentDataGrouping,g=g.dateTimeLabelFormats,a?(l=g[a.unitName],1===a.count?h=l[0]:(h=l[1],k=l[2])):!h&&g&&(h=this.getXDateFormat(b,f,l)),h=d.dateFormat(h,b.key),k&&(h+=d.dateFormat(k,b.key+a.totalRange-1)),n(f[(c?"footer":"header")+"Format"],{point:C(b.point,{key:h}),series:e},d)):a.call(this,b,c)});E(l,"destroy",c.destroyGroupedData);E(l,"afterSetOptions",function(a){a=a.options;var b=this.type,c=this.chart.options.plotOptions,d=k[b].dataGrouping,e=this.useCommonDataGrouping&&x;
	if(m[b]||e)d||(d=B(x,m[b])),a.dataGrouping=B(e,d,c.series&&c.series.dataGrouping,c[b].dataGrouping,this.userOptions.dataGrouping);this.chart.options.isStock&&(this.requireSorting=!0)});E(q,"afterSetScale",function(){t(this.series,function(a){a.hasProcessed=!1})});q.prototype.getGroupPixelWidth=function(){var a=this.series,b=a.length,c,d=0,e=!1,f;for(c=b;c--;)(f=a[c].options.dataGrouping)&&(d=Math.max(d,f.groupPixelWidth));for(c=b;c--;)(f=a[c].options.dataGrouping)&&a[c].hasProcessed&&(b=(a[c].processedXData||
	a[c].data).length,a[c].groupPixelWidth||b>this.chart.plotSizeX/d||b&&f.forced)&&(e=!0);return e?d:0};q.prototype.setDataGrouping=function(a,b){var c;b=e(b,!0);a||(a={forced:!1,units:null});if(this instanceof q)for(c=this.series.length;c--;)this.series[c].update({dataGrouping:a},!1);else t(this.chart.options.series,function(b){b.dataGrouping=a},!1);this.ordinalSlope=null;b&&this.chart.redraw()}})(J);(function(a){var E=a.each,F=a.Point,G=a.seriesType,q=a.seriesTypes;G("ohlc","column",{lineWidth:1,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eOpen: {point.open}\x3cbr/\x3eHigh: {point.high}\x3cbr/\x3eLow: {point.low}\x3cbr/\x3eClose: {point.close}\x3cbr/\x3e'},
	threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0},{directTouch:!1,pointArrayMap:["open","high","low","close"],toYData:function(a){return[a.open,a.high,a.low,a.close]},pointValKey:"close",pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},init:function(){q.column.prototype.init.apply(this,arguments);this.options.stacking=!1},pointAttribs:function(a,h){h=q.column.prototype.pointAttribs.call(this,a,h);var k=this.options;delete h.fill;!a.options.color&&k.upColor&&a.open<a.close&&
	(h.stroke=k.upColor);return h},translate:function(){var a=this,h=a.yAxis,t=!!a.modifyValue,C=["plotOpen","plotHigh","plotLow","plotClose","yBottom"];q.column.prototype.translate.apply(a);E(a.points,function(k){E([k.open,k.high,k.low,k.close,k.low],function(n,q){null!==n&&(t&&(n=a.modifyValue(n)),k[C[q]]=h.toPixels(n,!0))});k.tooltipPos[1]=k.plotHigh+h.pos-a.chart.plotTop})},drawPoints:function(){var a=this,h=a.chart;E(a.points,function(k){var q,n,t,B,e=k.graphic,d,l=!e;void 0!==k.plotY&&(e||(k.graphic=
	e=h.renderer.path().add(a.group)),e.attr(a.pointAttribs(k,k.selected&&"select")),n=e.strokeWidth()%2/2,d=Math.round(k.plotX)-n,t=Math.round(k.shapeArgs.width/2),B=["M",d,Math.round(k.yBottom),"L",d,Math.round(k.plotHigh)],null!==k.open&&(q=Math.round(k.plotOpen)+n,B.push("M",d,q,"L",d-t,q)),null!==k.close&&(q=Math.round(k.plotClose)+n,B.push("M",d,q,"L",d+t,q)),e[l?"attr":"animate"]({d:B}).addClass(k.getClassName(),!0))})},animate:null},{getClassName:function(){return F.prototype.getClassName.call(this)+
	(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}})})(J);(function(a){var E=a.defaultPlotOptions,F=a.each,G=a.merge,q=a.seriesType,k=a.seriesTypes;q("candlestick","ohlc",G(E.column,{states:{hover:{lineWidth:2}},tooltip:E.ohlc.tooltip,threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}),{pointAttribs:function(a,q){var h=k.column.prototype.pointAttribs.call(this,a,q),n=this.options,t=a.open<a.close,B=n.lineColor||this.color;h["stroke-width"]=n.lineWidth;
	h.fill=a.options.color||(t?n.upColor||this.color:this.color);h.stroke=a.lineColor||(t?n.upLineColor||B:B);q&&(a=n.states[q],h.fill=a.color||h.fill,h.stroke=a.lineColor||h.stroke,h["stroke-width"]=a.lineWidth||h["stroke-width"]);return h},drawPoints:function(){var a=this,k=a.chart,q=a.yAxis.reversed;F(a.points,function(h){var n=h.graphic,t,e,d,l,v,b,c,f=!n;void 0!==h.plotY&&(n||(h.graphic=n=k.renderer.path().add(a.group)),n.attr(a.pointAttribs(h,h.selected&&"select")).shadow(a.options.shadow),v=n.strokeWidth()%
	2/2,b=Math.round(h.plotX)-v,t=h.plotOpen,e=h.plotClose,d=Math.min(t,e),t=Math.max(t,e),c=Math.round(h.shapeArgs.width/2),e=q?t!==h.yBottom:Math.round(d)!==Math.round(h.plotHigh),l=q?Math.round(d)!==Math.round(h.plotHigh):t!==h.yBottom,d=Math.round(d)+v,t=Math.round(t)+v,v=[],v.push("M",b-c,t,"L",b-c,d,"L",b+c,d,"L",b+c,t,"Z","M",b,d,"L",b,e?Math.round(q?h.yBottom:h.plotHigh):d,"M",b,t,"L",b,l?Math.round(q?h.plotHigh:h.yBottom):t),n[f?"attr":"animate"]({d:v}).addClass(h.getClassName(),!0))})}})})(J);
	fa=function(a){var E=a.each,F=a.defined,G=a.seriesTypes,q=a.stableSort;return{getPlotBox:function(){return a.Series.prototype.getPlotBox.call(this.options.onSeries&&this.chart.get(this.options.onSeries)||this)},translate:function(){G.column.prototype.translate.apply(this);var a=this.options,h=this.chart,t=this.points,C=t.length-1,n,A,B=a.onSeries,B=B&&h.get(B),a=a.onKey||"y",e=B&&B.options.step,d=B&&B.points,l=d&&d.length,v=h.inverted,b=this.xAxis,c=this.yAxis,f=0,w,x,m,I;if(B&&B.visible&&l)for(f=
	(B.pointXOffset||0)+(B.barW||0)/2,n=B.currentDataGrouping,x=d[l-1].x+(n?n.totalRange:0),q(t,function(a,b){return a.x-b.x}),a="plot"+a[0].toUpperCase()+a.substr(1);l--&&t[C]&&!(w=d[l],n=t[C],n.y=w.y,w.x<=n.x&&void 0!==w[a]&&(n.x<=x&&(n.plotY=w[a],w.x<n.x&&!e&&(m=d[l+1])&&void 0!==m[a]&&(I=(n.x-w.x)/(m.x-w.x),n.plotY+=I*(m[a]-w[a]),n.y+=I*(m.y-w.y))),C--,l++,0>C)););E(t,function(a,d){var e;a.plotX+=f;if(void 0===a.plotY||v)0<=a.plotX&&a.plotX<=b.len?v?(a.plotY=b.translate(a.x,0,1,0,1),a.plotX=F(a.y)?
	c.translate(a.y,0,0,0,1):0):a.plotY=h.chartHeight-b.bottom-(b.opposite?b.height:0)+b.offset-c.top:a.shapeArgs={};(A=t[d-1])&&A.plotX===a.plotX&&(void 0===A.stackIndex&&(A.stackIndex=0),e=A.stackIndex+1);a.stackIndex=e});this.onSeries=B}}}(J);(function(a,E){function F(a){e[a+"pin"]=function(d,h,b,c,f){var k=f&&f.anchorX;f=f&&f.anchorY;"circle"===a&&c>b&&(d-=Math.round((c-b)/2),b=c);d=e[a](d,h,b,c);k&&f&&(d.push("M","circle"===a?d[1]-d[4]:d[1]+d[4]/2,h>f?h:h+c,"L",k,f),d=d.concat(e.circle(k-1,f-1,2,
	2)));return d}}var G=a.addEvent,q=a.each,k=a.merge,h=a.noop,t=a.Renderer,C=a.Series,n=a.seriesType,A=a.TrackerMixin,B=a.VMLRenderer,e=a.SVGRenderer.prototype.symbols;n("flags","column",{pointRange:0,allowOverlapX:!1,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}\x3cbr/\x3e"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},style:{fontSize:"11px",fontWeight:"bold"}},{sorted:!1,noSharedTooltip:!0,allowDG:!1,
	takeOrdinalPosition:!1,trackerGroups:["markerGroup"],forceCrop:!0,init:C.prototype.init,pointAttribs:function(a,e){var d=this.options,b=a&&a.color||this.color,c=d.lineColor,f=a&&a.lineWidth;a=a&&a.fillColor||d.fillColor;e&&(a=d.states[e].fillColor,c=d.states[e].lineColor,f=d.states[e].lineWidth);return{fill:a||b,stroke:c||b,"stroke-width":f||d.lineWidth||0}},translate:E.translate,getPlotBox:E.getPlotBox,drawPoints:function(){var d=this.points,e=this.chart,h=e.renderer,b,c,f=e.inverted,n=this.options,
	x=n.y,m,t,z,u,r,B,A=this.yAxis,p={},D=[];for(t=d.length;t--;)z=d[t],B=(f?z.plotY:z.plotX)>this.xAxis.len,b=z.plotX,u=z.stackIndex,m=z.options.shape||n.shape,c=z.plotY,void 0!==c&&(c=z.plotY+x-(void 0!==u&&u*n.stackDistance)),z.anchorX=u?void 0:z.plotX,r=u?void 0:z.plotY,u=z.graphic,void 0!==c&&0<=b&&!B?(u||(u=z.graphic=h.label("",null,null,m,null,null,n.useHTML).attr(this.pointAttribs(z)).css(k(n.style,z.style)).attr({align:"flag"===m?"left":"center",width:n.width,height:n.height,"text-align":n.textAlign}).addClass("highcharts-point").add(this.markerGroup),
	z.graphic.div&&(z.graphic.div.point=z),u.shadow(n.shadow),u.isNew=!0),0<b&&(b-=u.strokeWidth()%2),m={y:c,anchorY:r},n.allowOverlapX&&(m.x=b,m.anchorX=z.anchorX),u.attr({text:z.options.title||n.title||"A"})[u.isNew?"attr":"animate"](m),n.allowOverlapX||(p[z.plotX]?p[z.plotX].size=Math.max(p[z.plotX].size,u.width):p[z.plotX]={align:0,size:u.width,target:b,anchorX:b}),z.tooltipPos=[b,c+A.pos-e.plotTop]):u&&(z.graphic=u.destroy());n.allowOverlapX||(a.objectEach(p,function(a){a.plotX=a.anchorX;D.push(a)}),
	a.distribute(D,f?A.len:this.xAxis.len,100),q(d,function(a){var b=a.graphic&&p[a.plotX];b&&(a.graphic[a.graphic.isNew?"attr":"animate"]({x:b.pos,anchorX:a.anchorX}),b.pos?a.graphic.isNew=!1:(a.graphic.attr({x:-9999,anchorX:-9999}),a.graphic.isNew=!0))}));n.useHTML&&a.wrap(this.markerGroup,"on",function(b){return a.SVGElement.prototype.on.apply(b.apply(this,[].slice.call(arguments,1)),[].slice.call(arguments,1))})},drawTracker:function(){var a=this.points;A.drawTrackerPoint.apply(this);q(a,function(d){var e=
	d.graphic;e&&G(e.element,"mouseover",function(){0<d.stackIndex&&!d.raised&&(d._y=e.y,e.attr({y:d._y-8}),d.raised=!0);q(a,function(a){a!==d&&a.raised&&a.graphic&&(a.graphic.attr({y:a._y}),a.raised=!1)})})})},animate:function(a){a?this.setClip():this.animate=null},setClip:function(){C.prototype.setClip.apply(this,arguments);!1!==this.options.clip&&this.sharedClipKey&&this.markerGroup.clip(this.chart[this.sharedClipKey])},buildKDTree:h,invertGroups:h});e.flag=function(a,h,k,b,c){var d=c&&c.anchorX||
	a;c=c&&c.anchorY||h;return e.circle(d-1,c-1,2,2).concat(["M",d,c,"L",a,h+b,a,h,a+k,h,a+k,h+b,a,h+b,"Z"])};F("circle");F("square");t===B&&q(["flag","circlepin","squarepin"],function(a){B.prototype.symbols[a]=e[a]})})(J,fa);(function(a){function E(a,c,d){this.init(a,c,d)}var F=a.addEvent,G=a.Axis,q=a.correctFloat,k=a.defaultOptions,h=a.defined,t=a.destroyObjectProperties,C=a.each,n=a.fireEvent,A=a.hasTouch,B=a.merge,e=a.pick,d=a.removeEvent,l,v={height:a.isTouchDevice?20:14,barBorderRadius:0,buttonBorderRadius:0,
	liveRedraw:void 0,margin:10,minWidth:6,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",trackBorderWidth:1};k.scrollbar=B(!0,v,k.scrollbar);a.swapXY=l=function(a,c){var b=a.length,d;if(c)for(c=0;c<b;c+=3)d=a[c+1],a[c+1]=a[c+2],a[c+2]=d;return a};E.prototype={init:function(a,c,
	d){this.scrollbarButtons=[];this.renderer=a;this.userOptions=c;this.options=B(v,c);this.chart=d;this.size=e(this.options.size,this.options.height);c.enabled&&(this.render(),this.initEvents(),this.addEvents())},render:function(){var a=this.renderer,c=this.options,d=this.size,e;this.group=e=a.g("scrollbar").attr({zIndex:c.zIndex,translateY:-99999}).add();this.track=a.rect().addClass("highcharts-scrollbar-track").attr({x:0,r:c.trackBorderRadius||0,height:d,width:d}).add(e);this.track.attr({fill:c.trackBackgroundColor,
	stroke:c.trackBorderColor,"stroke-width":c.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=a.g().add(e);this.scrollbar=a.rect().addClass("highcharts-scrollbar-thumb").attr({height:d,width:d,r:c.barBorderRadius||0}).add(this.scrollbarGroup);this.scrollbarRifles=a.path(l(["M",-3,d/4,"L",-3,2*d/3,"M",0,d/4,"L",0,2*d/3,"M",3,d/4,"L",3,2*d/3],c.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);
	this.scrollbar.attr({fill:c.barBackgroundColor,stroke:c.barBorderColor,"stroke-width":c.barBorderWidth});this.scrollbarRifles.attr({stroke:c.rifleColor,"stroke-width":1});this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);this.drawScrollbarButton(1)},position:function(a,c,d,e){var b=this.options.vertical,f=0,h=this.rendered?"animate":"attr";this.x=a;this.y=c+this.trackBorderWidth;
	this.width=d;this.xOffset=this.height=e;this.yOffset=f;b?(this.width=this.yOffset=d=f=this.size,this.xOffset=c=0,this.barWidth=e-2*d,this.x=a+=this.options.margin):(this.height=this.xOffset=e=c=this.size,this.barWidth=d-2*e,this.y+=this.options.margin);this.group[h]({translateX:a,translateY:this.y});this.track[h]({width:d,height:e});this.scrollbarButtons[1][h]({translateX:b?0:d-c,translateY:b?e-f:0})},drawScrollbarButton:function(a){var b=this.renderer,d=this.scrollbarButtons,e=this.options,h=this.size,
	k;k=b.g().add(this.group);d.push(k);k=b.rect().addClass("highcharts-scrollbar-button").add(k);k.attr({stroke:e.buttonBorderColor,"stroke-width":e.buttonBorderWidth,fill:e.buttonBackgroundColor});k.attr(k.crisp({x:-.5,y:-.5,width:h+1,height:h+1,r:e.buttonBorderRadius},k.strokeWidth()));k=b.path(l(["M",h/2+(a?-1:1),h/2-3,"L",h/2+(a?-1:1),h/2+3,"L",h/2+(a?2:-2),h/2],e.vertical)).addClass("highcharts-scrollbar-arrow").add(d[a]);k.attr({fill:e.buttonArrowColor})},setRange:function(a,c){var b=this.options,
	d=b.vertical,e=b.minWidth,k=this.barWidth,l,n,u=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?"attr":"animate";h(k)&&(a=Math.max(a,0),l=Math.ceil(k*a),this.calculatedWidth=n=q(k*Math.min(c,1)-l),n<e&&(l=(k-e+n)*a,n=e),e=Math.floor(l+this.xOffset+this.yOffset),k=n/2-.5,this.from=a,this.to=c,d?(this.scrollbarGroup[u]({translateY:e}),this.scrollbar[u]({height:n}),this.scrollbarRifles[u]({translateY:k}),this.scrollbarTop=e,this.scrollbarLeft=0):(this.scrollbarGroup[u]({translateX:e}),
	this.scrollbar[u]({width:n}),this.scrollbarRifles[u]({translateX:k}),this.scrollbarLeft=e,this.scrollbarTop=0),12>=n?this.scrollbarRifles.hide():this.scrollbarRifles.show(!0),!1===b.showFull&&(0>=a&&1<=c?this.group.hide():this.group.show()),this.rendered=!0)},initEvents:function(){var a=this;a.mouseMoveHandler=function(b){var c=a.chart.pointer.normalize(b),d=a.options.vertical?"chartY":"chartX",e=a.initPositions;!a.grabbedCenter||b.touches&&0===b.touches[0][d]||(c=a.cursorToScrollbarPosition(c)[d],
	d=a[d],d=c-d,a.hasDragged=!0,a.updatePosition(e[0]+d,e[1]+d),a.hasDragged&&n(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b}))};a.mouseUpHandler=function(b){a.hasDragged&&n(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b});a.grabbedCenter=a.hasDragged=a.chartX=a.chartY=null};a.mouseDownHandler=function(b){b=a.chart.pointer.normalize(b);b=a.cursorToScrollbarPosition(b);a.chartX=b.chartX;a.chartY=b.chartY;a.initPositions=[a.from,a.to];a.grabbedCenter=
	!0};a.buttonToMinClick=function(b){var c=q(a.to-a.from)*a.options.step;a.updatePosition(q(a.from-c),q(a.to-c));n(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.buttonToMaxClick=function(b){var c=(a.to-a.from)*a.options.step;a.updatePosition(a.from+c,a.to+c);n(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.trackClick=function(b){var c=a.chart.pointer.normalize(b),d=a.to-a.from,e=a.y+a.scrollbarTop,h=a.x+a.scrollbarLeft;a.options.vertical&&c.chartY>e||!a.options.vertical&&
	c.chartX>h?a.updatePosition(a.from+d,a.to+d):a.updatePosition(a.from-d,a.to-d);n(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})}},cursorToScrollbarPosition:function(a){var b=this.options,b=b.minWidth>this.calculatedWidth?b.minWidth:0;return{chartX:(a.chartX-this.x-this.xOffset)/(this.barWidth-b),chartY:(a.chartY-this.y-this.yOffset)/(this.barWidth-b)}},updatePosition:function(a,c){1<c&&(a=q(1-q(c-a)),c=1);0>a&&(c=q(c-a),a=0);this.from=a;this.to=c},update:function(a){this.destroy();
	this.init(this.chart.renderer,B(!0,this.options,a),this.chart)},addEvents:function(){var a=this.options.inverted?[1,0]:[0,1],c=this.scrollbarButtons,d=this.scrollbarGroup.element,e=this.mouseDownHandler,h=this.mouseMoveHandler,k=this.mouseUpHandler,a=[[c[a[0]].element,"click",this.buttonToMinClick],[c[a[1]].element,"click",this.buttonToMaxClick],[this.track.element,"click",this.trackClick],[d,"mousedown",e],[d.ownerDocument,"mousemove",h],[d.ownerDocument,"mouseup",k]];A&&a.push([d,"touchstart",e],
	[d.ownerDocument,"touchmove",h],[d.ownerDocument,"touchend",k]);C(a,function(a){F.apply(null,a)});this._events=a},removeEvents:function(){C(this._events,function(a){d.apply(null,a)});this._events.length=0},destroy:function(){var a=this.chart.scroller;this.removeEvents();C(["track","scrollbarRifles","scrollbar","scrollbarGroup","group"],function(a){this[a]&&this[a].destroy&&(this[a]=this[a].destroy())},this);a&&this===a.scrollbar&&(a.scrollbar=null,t(a.scrollbarButtons))}};F(G,"afterInit",function(){var a=
	this;a.options&&a.options.scrollbar&&a.options.scrollbar.enabled&&(a.options.scrollbar.vertical=!a.horiz,a.options.startOnTick=a.options.endOnTick=!1,a.scrollbar=new E(a.chart.renderer,a.options.scrollbar,a.chart),F(a.scrollbar,"changed",function(b){var c=Math.min(e(a.options.min,a.min),a.min,a.dataMin),d=Math.max(e(a.options.max,a.max),a.max,a.dataMax)-c,h;a.horiz&&!a.reversed||!a.horiz&&a.reversed?(h=c+d*this.to,c+=d*this.from):(h=c+d*(1-this.from),c+=d*(1-this.to));a.setExtremes(c,h,!0,!1,b)}))});
	F(G,"afterRender",function(){var a=Math.min(e(this.options.min,this.min),this.min,e(this.dataMin,this.min)),c=Math.max(e(this.options.max,this.max),this.max,e(this.dataMax,this.max)),d=this.scrollbar,k=this.titleOffset||0;if(d){this.horiz?(d.position(this.left,this.top+this.height+2+this.chart.scrollbarsOffsets[1]+(this.opposite?0:k+this.axisTitleMargin+this.offset),this.width,this.height),k=1):(d.position(this.left+this.width+2+this.chart.scrollbarsOffsets[0]+(this.opposite?k+this.axisTitleMargin+
	this.offset:0),this.top,this.width,this.height),k=0);if(!this.opposite&&!this.horiz||this.opposite&&this.horiz)this.chart.scrollbarsOffsets[k]+=this.scrollbar.size+this.scrollbar.options.margin;isNaN(a)||isNaN(c)||!h(this.min)||!h(this.max)?d.setRange(0,0):(k=(this.min-a)/(c-a),a=(this.max-a)/(c-a),this.horiz&&!this.reversed||!this.horiz&&this.reversed?d.setRange(k,a):d.setRange(1-a,1-k))}});F(G,"afterGetOffset",function(){var a=this.horiz?2:1,c=this.scrollbar;c&&(this.chart.scrollbarsOffsets=[0,
	0],this.chart.axisOffset[a]+=c.size+c.options.margin)});a.Scrollbar=E})(J);(function(a){function E(a){this.init(a)}var F=a.addEvent,G=a.Axis,q=a.Chart,k=a.color,h=a.defaultOptions,t=a.defined,C=a.destroyObjectProperties,n=a.each,A=a.erase,B=a.error,e=a.extend,d=a.grep,l=a.hasTouch,v=a.isArray,b=a.isNumber,c=a.isObject,f=a.isTouchDevice,w=a.merge,x=a.pick,m=a.removeEvent,I=a.Scrollbar,z=a.Series,u=a.seriesTypes,r=a.wrap,K=[].concat(a.defaultDataGroupingUnits),H=function(a){var c=d(arguments,b);if(c.length)return Math[a].apply(0,
	c)};K[4]=["day",[1,2,3,4]];K[5]=["week",[1,2,3]];u=void 0===u.areaspline?"line":"areaspline";e(h,{navigator:{height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:k("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:u,fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,smoothed:!0,
	units:K},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},pointRange:0,threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,
	labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}});a.Renderer.prototype.symbols["navigator-handle"]=function(a,b,c,d,e){a=e.width/2;b=Math.round(a/3)+.5;e=e.height;return["M",-a-1,.5,"L",a,.5,"L",a,e+.5,"L",-a-1,e+.5,"L",-a-1,.5,"M",-b,4,"L",-b,e-3,"M",b-1,4,"L",b-1,e-3]};E.prototype={drawHandle:function(a,b,c,d){var e=this.navigatorOptions.handles.height;this.handles[b][d](c?{translateX:Math.round(this.left+this.height/2),translateY:Math.round(this.top+parseInt(a,10)+
	.5-e)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-e/2-1)})},drawOutline:function(a,b,c,d){var e=this.navigatorOptions.maskInside,g=this.outline.strokeWidth(),f=g/2,g=g%2/2,h=this.outlineHeight,k=this.scrollbarHeight,p=this.size,l=this.left-k,m=this.top;c?(l-=f,c=m+b+g,b=m+a+g,a=["M",l+h,m-k-g,"L",l+h,c,"L",l,c,"L",l,b,"L",l+h,b,"L",l+h,m+p+k].concat(e?["M",l+h,c-f,"L",l+h,b+f]:[])):(a+=l+k-g,b+=l+k-g,m+=f,a=["M",l,m,"L",a,m,"L",a,m+h,"L",b,m+h,"L",
	b,m,"L",l+p+2*k,m].concat(e?["M",a-f,m,"L",b+f,m]:[]));this.outline[d]({d:a})},drawMasks:function(a,b,c,d){var e=this.left,g=this.top,f=this.height,h,k,p,l;c?(p=[e,e,e],l=[g,g+a,g+b],k=[f,f,f],h=[a,b-a,this.size-b]):(p=[e,e+a,e+b],l=[g,g,g],k=[a,b-a,this.size-b],h=[f,f,f]);n(this.shades,function(a,b){a[d]({x:p[b],y:l[b],width:k[b],height:h[b]})})},renderElements:function(){var a=this,b=a.navigatorOptions,c=b.maskInside,d=a.chart,e=d.inverted,f=d.renderer,h;a.navigatorGroup=h=f.g("navigator").attr({zIndex:8,
	visibility:"hidden"}).add();var k={cursor:e?"ns-resize":"ew-resize"};n([!c,c,!c],function(c,d){a.shades[d]=f.rect().addClass("highcharts-navigator-mask"+(1===d?"-inside":"-outside")).attr({fill:c?b.maskFill:"rgba(0,0,0,0)"}).css(1===d&&k).add(h)});a.outline=f.path().addClass("highcharts-navigator-outline").attr({"stroke-width":b.outlineWidth,stroke:b.outlineColor}).add(h);b.handles.enabled&&n([0,1],function(c){b.handles.inverted=d.inverted;a.handles[c]=f.symbol(b.handles.symbols[c],-b.handles.width/
	2-1,0,b.handles.width,b.handles.height,b.handles);a.handles[c].attr({zIndex:7-c}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][c]).add(h);var e=b.handles;a.handles[c].attr({fill:e.backgroundColor,stroke:e.borderColor,"stroke-width":e.lineWidth}).css(k)})},update:function(a){n(this.series||[],function(a){a.baseSeries&&delete a.baseSeries.navigatorSeries});this.destroy();w(!0,this.chart.options.navigator,this.options,a);this.init(this.chart)},render:function(c,
	d,e,f){var g=this.chart,h,k,p=this.scrollbarHeight,l,m=this.xAxis;h=m.fake?g.xAxis[0]:m;var n=this.navigatorEnabled,q,D=this.rendered;k=g.inverted;var r,y=g.xAxis[0].minRange,u=g.xAxis[0].options.maxRange;if(!this.hasDragged||t(e)){if(!b(c)||!b(d))if(D)e=0,f=x(m.width,h.width);else return;this.left=x(m.left,g.plotLeft+p+(k?g.plotWidth:0));this.size=q=l=x(m.len,(k?g.plotHeight:g.plotWidth)-2*p);g=k?p:l+2*p;e=x(e,m.toPixels(c,!0));f=x(f,m.toPixels(d,!0));b(e)&&Infinity!==Math.abs(e)||(e=0,f=g);c=m.toValue(e,
	!0);d=m.toValue(f,!0);r=Math.abs(a.correctFloat(d-c));r<y?this.grabbedLeft?e=m.toPixels(d-y,!0):this.grabbedRight&&(f=m.toPixels(c+y,!0)):t(u)&&r>u&&(this.grabbedLeft?e=m.toPixels(d-u,!0):this.grabbedRight&&(f=m.toPixels(c+u,!0)));this.zoomedMax=Math.min(Math.max(e,f,0),q);this.zoomedMin=Math.min(Math.max(this.fixedWidth?this.zoomedMax-this.fixedWidth:Math.min(e,f),0),q);this.range=this.zoomedMax-this.zoomedMin;q=Math.round(this.zoomedMax);e=Math.round(this.zoomedMin);n&&(this.navigatorGroup.attr({visibility:"visible"}),
	D=D&&!this.hasDragged?"animate":"attr",this.drawMasks(e,q,k,D),this.drawOutline(e,q,k,D),this.navigatorOptions.handles.enabled&&(this.drawHandle(e,0,k,D),this.drawHandle(q,1,k,D)));this.scrollbar&&(k?(k=this.top-p,h=this.left-p+(n||!h.opposite?0:(h.titleOffset||0)+h.axisTitleMargin),p=l+2*p):(k=this.top+(n?this.height:-p),h=this.left-p),this.scrollbar.position(h,k,g,p),this.scrollbar.setRange(this.zoomedMin/(l||1),this.zoomedMax/(l||1)));this.rendered=!0}},addMouseEvents:function(){var a=this,b=a.chart,
	c=b.container,d=[],e,f;a.mouseMoveHandler=e=function(b){a.onMouseMove(b)};a.mouseUpHandler=f=function(b){a.onMouseUp(b)};d=a.getPartsEvents("mousedown");d.push(F(c,"mousemove",e),F(c.ownerDocument,"mouseup",f));l&&(d.push(F(c,"touchmove",e),F(c.ownerDocument,"touchend",f)),d.concat(a.getPartsEvents("touchstart")));a.eventsToUnbind=d;a.series&&a.series[0]&&d.push(F(a.series[0].xAxis,"foundExtremes",function(){b.navigator.modifyNavigatorAxisExtremes()}))},getPartsEvents:function(a){var b=this,c=[];
	n(["shades","handles"],function(d){n(b[d],function(e,g){c.push(F(e.element,a,function(a){b[d+"Mousedown"](a,g)}))})});return c},shadesMousedown:function(a,b){a=this.chart.pointer.normalize(a);var c=this.chart,d=this.xAxis,e=this.zoomedMin,f=this.left,h=this.size,k=this.range,p=a.chartX,l,m;c.inverted&&(p=a.chartY,f=this.top);1===b?(this.grabbedCenter=p,this.fixedWidth=k,this.dragOffset=p-e):(a=p-f-k/2,0===b?a=Math.max(0,a):2===b&&a+k>=h&&(a=h-k,this.reversedExtremes?(a-=k,m=this.getUnionExtremes().dataMin):
	l=this.getUnionExtremes().dataMax),a!==e&&(this.fixedWidth=k,b=d.toFixedRange(a,a+k,m,l),t(b.min)&&c.xAxis[0].setExtremes(Math.min(b.min,b.max),Math.max(b.min,b.max),!0,null,{trigger:"navigator"})))},handlesMousedown:function(a,b){this.chart.pointer.normalize(a);a=this.chart;var c=a.xAxis[0],d=this.reversedExtremes;0===b?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=d?c.min:c.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=d?c.max:c.min);
	a.fixedRange=null},onMouseMove:function(b){var c=this,d=c.chart,e=c.left,h=c.navigatorSize,k=c.range,l=c.dragOffset,p=d.inverted;b.touches&&0===b.touches[0].pageX||(b=d.pointer.normalize(b),d=b.chartX,p&&(e=c.top,d=b.chartY),c.grabbedLeft?(c.hasDragged=!0,c.render(0,0,d-e,c.otherHandlePos)):c.grabbedRight?(c.hasDragged=!0,c.render(0,0,c.otherHandlePos,d-e)):c.grabbedCenter&&(c.hasDragged=!0,d<l?d=l:d>h+l-k&&(d=h+l-k),c.render(0,0,d-l,d-l+k)),c.hasDragged&&c.scrollbar&&x(c.scrollbar.options.liveRedraw,
	a.svg&&!f&&!this.chart.isBoosting)&&(b.DOMType=b.type,setTimeout(function(){c.onMouseUp(b)},0)))},onMouseUp:function(a){var b=this.chart,c=this.xAxis,d=this.scrollbar,e,f,h=a.DOMEvent||a;(!this.hasDragged||d&&d.hasDragged)&&"scrollbar"!==a.trigger||(d=this.getUnionExtremes(),this.zoomedMin===this.otherHandlePos?e=this.fixedExtreme:this.zoomedMax===this.otherHandlePos&&(f=this.fixedExtreme),this.zoomedMax===this.size&&(f=this.reversedExtremes?d.dataMin:d.dataMax),0===this.zoomedMin&&(e=this.reversedExtremes?
	d.dataMax:d.dataMin),c=c.toFixedRange(this.zoomedMin,this.zoomedMax,e,f),t(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:h}));"mousemove"!==a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=this.hasDragged=this.dragOffset=null)},removeEvents:function(){this.eventsToUnbind&&(n(this.eventsToUnbind,function(a){a()}),this.eventsToUnbind=
	void 0);this.removeBaseSeriesEvents()},removeBaseSeriesEvents:function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&n(a,function(a){m(a,"updatedData",this.updatedDataHandler)},this),a[0].xAxis&&m(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))},init:function(a){var b=a.options,c=b.navigator,d=c.enabled,e=b.scrollbar,f=e.enabled,b=d?c.height:0,h=f?e.height:0;this.handles=[];this.shades=[];this.chart=a;this.setBaseSeries();this.height=
	b;this.scrollbarHeight=h;this.scrollbarEnabled=f;this.navigatorEnabled=d;this.navigatorOptions=c;this.scrollbarOptions=e;this.outlineHeight=b+h;this.opposite=x(c.opposite,!d&&a.inverted);var k=this,d=k.baseSeries,e=a.xAxis.length,f=a.yAxis.length,l=d&&d[0]&&d[0].xAxis||a.xAxis[0]||{options:{}};a.isDirtyBox=!0;k.navigatorEnabled?(k.xAxis=new G(a,w({breaks:l.options.breaks,ordinal:l.options.ordinal},c.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",isX:!0,type:"datetime",index:e,isInternal:!0,
	offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[h,0,-h,0],width:b}:{offsets:[0,-h,0,h],height:b})),k.yAxis=new G(a,w(c.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:f,isInternal:!0,zoomEnabled:!1},a.inverted?{width:b}:{height:b})),d||c.series.data?k.updateNavigatorSeries(!1):0===a.series.length&&(k.unbindRedraw=F(a,"beforeRedraw",function(){0<a.series.length&&!k.series&&(k.setBaseSeries(),k.unbindRedraw())})),k.reversedExtremes=
	a.inverted&&!k.xAxis.reversed||!a.inverted&&k.xAxis.reversed,k.renderElements(),k.addMouseEvents()):k.xAxis={translate:function(b,c){var d=a.xAxis[0],e=d.getExtremes(),g=d.len-2*h,f=H("min",d.options.min,e.dataMin),d=H("max",d.options.max,e.dataMax)-f;return c?b*d/g+f:g*(b-f)/d},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,!0)},toFixedRange:G.prototype.toFixedRange,fake:!0};a.options.scrollbar.enabled&&(a.scrollbar=k.scrollbar=new I(a.renderer,w(a.options.scrollbar,
	{margin:k.navigatorEnabled?0:10,vertical:a.inverted}),a),F(k.scrollbar,"changed",function(b){var c=k.size,d=c*this.to,c=c*this.from;k.hasDragged=k.scrollbar.hasDragged;k.render(0,0,c,d);(a.options.scrollbar.liveRedraw||"mousemove"!==b.DOMType&&"touchmove"!==b.DOMType)&&setTimeout(function(){k.onMouseUp(b)})}));k.addBaseSeriesEvents();k.addChartEvents()},getUnionExtremes:function(a){var b=this.chart.xAxis[0],c=this.xAxis,d=c.options,e=b.options,f;a&&null===b.dataMin||(f={dataMin:x(d&&d.min,H("min",
	e.min,b.dataMin,c.dataMin,c.min)),dataMax:x(d&&d.max,H("max",e.max,b.dataMax,c.dataMax,c.max))});return f},setBaseSeries:function(a,b){var c=this.chart,d=this.baseSeries=[];a=a||c.options&&c.options.navigator.baseSeries||0;n(c.series||[],function(b,c){b.options.isInternal||!b.options.showInNavigator&&(c!==a&&b.options.id!==a||!1===b.options.showInNavigator)||d.push(b)});this.xAxis&&!this.xAxis.fake&&this.updateNavigatorSeries(!0,b)},updateNavigatorSeries:function(b,c){var d=this,f=d.chart,k=d.baseSeries,
	l,p,q=d.navigatorOptions.series,r,u={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:!1,isInternal:!0},x=d.series=a.grep(d.series||[],function(b){var c=b.baseSeries;return 0>a.inArray(c,k)?(c&&(m(c,"updatedData",d.updatedDataHandler),delete c.navigatorSeries),b.chart&&b.destroy(),!1):!0});k&&k.length&&n(k,function(a){var b=a.navigatorSeries,g=e({color:a.color,visible:a.visible},v(q)?h.navigator.series:
	q);b&&!1===d.navigatorOptions.adaptToUpdatedData||(u.name="Navigator "+k.length,l=a.options||{},r=l.navigatorOptions||{},p=w(l,u,g,r),g=r.data||g.data,d.hasNavigatorData=d.hasNavigatorData||!!g,p.data=g||l.data&&l.data.slice(0),b&&b.options?b.update(p,c):(a.navigatorSeries=f.initSeries(p),a.navigatorSeries.baseSeries=a,x.push(a.navigatorSeries)))});if(q.data&&(!k||!k.length)||v(q))d.hasNavigatorData=!1,q=a.splat(q),n(q,function(a,b){u.name="Navigator "+(x.length+1);p=w(h.navigator.series,{color:f.series[b]&&
	!f.series[b].options.isInternal&&f.series[b].color||f.options.colors[b]||f.options.colors[0]},u,a);p.data=a.data;p.data&&(d.hasNavigatorData=!0,x.push(f.initSeries(p)))});b&&this.addBaseSeriesEvents()},addBaseSeriesEvents:function(){var a=this,b=a.baseSeries||[];b[0]&&b[0].xAxis&&F(b[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes);n(b,function(b){F(b,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)});F(b,"hide",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!1,
	!1)});!1!==this.navigatorOptions.adaptToUpdatedData&&b.xAxis&&F(b,"updatedData",this.updatedDataHandler);F(b,"remove",function(){this.navigatorSeries&&(A(a.series,this.navigatorSeries),t(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),delete this.navigatorSeries)})},this)},getBaseSeriesMin:function(b){return a.reduce(this.baseSeries,function(a,b){return Math.min(a,b.xData[0])},b)},modifyNavigatorAxisExtremes:function(){var a=this.xAxis,b;a.getExtremes&&(!(b=this.getUnionExtremes(!0))||
	b.dataMin===a.min&&b.dataMax===a.max||(a.min=b.dataMin,a.max=b.dataMax))},modifyBaseAxisExtremes:function(){var a=this.chart.navigator,c=this.getExtremes(),d=c.dataMin,e=c.dataMax,c=c.max-c.min,f=a.stickToMin,h=a.stickToMax,k=x(this.options.overscroll,0),l,m,n=a.series&&a.series[0],q=!!this.setExtremes;this.eventArgs&&"rangeSelectorButton"===this.eventArgs.trigger||(f&&(m=d,l=m+c),h&&(l=e+k,f||(m=Math.max(l-c,a.getBaseSeriesMin(n&&n.xData?n.xData[0]:-Number.MAX_VALUE)))),q&&(f||h)&&b(m)&&(this.min=
	this.userMin=m,this.max=this.userMax=l));a.stickToMin=a.stickToMax=null},updatedDataHandler:function(){var a=this.chart.navigator,c=this.navigatorSeries,d=a.getBaseSeriesMin(this.xData[0]);a.stickToMax=a.reversedExtremes?0===Math.round(a.zoomedMin):Math.round(a.zoomedMax)>=Math.round(a.size);a.stickToMin=b(this.xAxis.min)&&this.xAxis.min<=d&&(!this.chart.fixedRange||!a.stickToMax);c&&!a.hasNavigatorData&&(c.options.pointStart=this.xData[0],c.setData(this.options.data,!1,null,!1))},addChartEvents:function(){this.eventsToUnbind||
	(this.eventsToUnbind=[]);this.eventsToUnbind.push(F(this.chart,"redraw",function(){var a=this.navigator,b=a&&(a.baseSeries&&a.baseSeries[0]&&a.baseSeries[0].xAxis||a.scrollbar&&this.xAxis[0]);b&&a.render(b.min,b.max)}),F(this.chart,"getMargins",function(){var a=this.navigator,b=a.opposite?"plotTop":"marginBottom";this.inverted&&(b=a.opposite?"marginRight":"plotLeft");this[b]=(this[b]||0)+(a.navigatorEnabled||!this.inverted?a.outlineHeight:0)+a.navigatorOptions.margin}))},destroy:function(){this.removeEvents();
	this.xAxis&&(A(this.chart.xAxis,this.xAxis),A(this.chart.axes,this.xAxis));this.yAxis&&(A(this.chart.yAxis,this.yAxis),A(this.chart.axes,this.yAxis));n(this.series||[],function(a){a.destroy&&a.destroy()});n("series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" "),function(a){this[a]&&this[a].destroy&&this[a].destroy();this[a]=null},this);n([this.handles],function(a){C(a)},this)}};a.Navigator=E;r(G.prototype,"zoom",function(a,b,
	c){var d=this.chart,e=d.options,g=e.chart.zoomType,h=e.chart.pinchType,k=e.navigator,e=e.rangeSelector,l;this.isXAxis&&(k&&k.enabled||e&&e.enabled)&&(!f&&"x"===g||f&&"x"===h?d.resetZoomButton="blocked":"y"===g?l=!1:(!f&&"xy"===g||f&&"xy"===h)&&this.options.range&&(d=this.previousZoom,t(b)?this.previousZoom=[this.min,this.max]:d&&(b=d[0],c=d[1],delete this.previousZoom)));return void 0!==l?l:a.call(this,b,c)});F(q,"beforeRender",function(){var a=this.options;if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=
	this.navigator=new E(this)});F(q,"afterSetChartSize",function(){var a=this.legend,b=this.navigator,c,d,e,f;b&&(d=a&&a.options,e=b.xAxis,f=b.yAxis,c=b.scrollbarHeight,this.inverted?(b.left=b.opposite?this.chartWidth-c-b.height:this.spacing[3]+c,b.top=this.plotTop+c):(b.left=this.plotLeft+c,b.top=b.navigatorOptions.top||this.chartHeight-b.height-c-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():0)-(d&&"bottom"===d.verticalAlign&&d.enabled&&!d.floating?a.legendHeight+
	x(d.margin,10):0)),e&&f&&(this.inverted?e.options.left=f.options.left=b.left:e.options.top=f.options.top=b.top,e.setAxisSize(),f.setAxisSize()))});F(q,"update",function(a){var b=a.options.navigator||{},c=a.options.scrollbar||{};this.navigator||this.scroller||!b.enabled&&!c.enabled||(w(!0,this.options.navigator,b),w(!0,this.options.scrollbar,c),delete a.options.navigator,delete a.options.scrollbar)});F(q,"afterUpdate",function(){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||
	(this.scroller=this.navigator=new E(this))});r(z.prototype,"addPoint",function(a,b,d,e,f){var g=this.options.turboThreshold;g&&this.xData.length>g&&c(b,!0)&&this.chart.navigator&&B(20,!0);a.call(this,b,d,e,f)});F(q,"afterAddSeries",function(){this.navigator&&this.navigator.setBaseSeries(null,!1)});F(z,"afterUpdate",function(){this.chart.navigator&&!this.options.isInternal&&this.chart.navigator.setBaseSeries(null,!1)});q.prototype.callbacks.push(function(a){var b=a.navigator;b&&a.xAxis[0]&&(a=a.xAxis[0].getExtremes(),
	b.render(a.min,a.max))})})(J);(function(a){function E(a){this.init(a)}var F=a.addEvent,G=a.Axis,q=a.Chart,k=a.css,h=a.createElement,t=a.defaultOptions,C=a.defined,n=a.destroyObjectProperties,A=a.discardElement,B=a.each,e=a.extend,d=a.fireEvent,l=a.isNumber,v=a.merge,b=a.pick,c=a.pInt,f=a.splat,w=a.wrap;e(t,{rangeSelector:{verticalAlign:"top",buttonTheme:{"stroke-width":0,width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputPosition:{align:"right",x:0,y:0},buttonPosition:{align:"left",
	x:0,y:0},labelStyle:{color:"#666666"}}});t.lang=v(t.lang,{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"From",rangeSelectorTo:"To"});E.prototype={clickButton:function(a,c){var d=this,e=d.chart,h=d.buttonOptions[a],k=e.xAxis[0],m=e.scroller&&e.scroller.getUnionExtremes()||k||{},n=m.dataMin,p=m.dataMax,q,g=k&&Math.round(Math.min(k.max,b(p,k.max))),x=h.type,t,m=h._range,v,w,A,C=h.dataGrouping;if(null!==n&&null!==p){e.fixedRange=m;C&&(this.forcedDataGrouping=!0,G.prototype.setDataGrouping.call(k||{chart:this.chart},
	C,!1),this.frozenStates=h.preserveDataGrouping);if("month"===x||"year"===x)k?(x={range:h,max:g,chart:e,dataMin:n,dataMax:p},q=k.minFromRange.call(x),l(x.newMax)&&(g=x.newMax)):m=h;else if(m)q=Math.max(g-m,n),g=Math.min(q+m,p);else if("ytd"===x)if(k)void 0===p&&(n=Number.MAX_VALUE,p=Number.MIN_VALUE,B(e.series,function(a){a=a.xData;n=Math.min(a[0],n);p=Math.max(a[a.length-1],p)}),c=!1),g=d.getYTDExtremes(p,n,e.time.useUTC),q=v=g.min,g=g.max;else{F(e,"beforeRender",function(){d.clickButton(a)});return}else"all"===
	x&&k&&(q=n,g=p);q+=h._offsetMin;g+=h._offsetMax;d.setSelected(a);k?k.setExtremes(q,g,b(c,1),null,{trigger:"rangeSelectorButton",rangeSelectorButton:h}):(t=f(e.options.xAxis)[0],A=t.range,t.range=m,w=t.min,t.min=v,F(e,"load",function(){t.range=A;t.min=w}))}},setSelected:function(a){this.selected=this.options.selected=a},defaultButtons:[{type:"month",count:1,text:"1m"},{type:"month",count:3,text:"3m"},{type:"month",count:6,text:"6m"},{type:"ytd",text:"YTD"},{type:"year",count:1,text:"1y"},{type:"all",
	text:"All"}],init:function(a){var b=this,c=a.options.rangeSelector,e=c.buttons||[].concat(b.defaultButtons),f=c.selected,h=function(){var a=b.minInput,c=b.maxInput;a&&a.blur&&d(a,"blur");c&&c.blur&&d(c,"blur")};b.chart=a;b.options=c;b.buttons=[];a.extraTopMargin=c.height;b.buttonOptions=e;this.unMouseDown=F(a.container,"mousedown",h);this.unResize=F(a,"resize",h);B(e,b.computeButtonRange);void 0!==f&&e[f]&&this.clickButton(f,!1);F(a,"load",function(){a.xAxis&&a.xAxis[0]&&F(a.xAxis[0],"setExtremes",
	function(c){this.max-this.min!==a.fixedRange&&"rangeSelectorButton"!==c.trigger&&"updatedData"!==c.trigger&&b.forcedDataGrouping&&!b.frozenStates&&this.setDataGrouping(!1,!1)})})},updateButtonStates:function(){var a=this,b=this.chart,c=b.xAxis[0],d=Math.round(c.max-c.min),e=!c.hasVisibleSeries,f=b.scroller&&b.scroller.getUnionExtremes()||c,h=f.dataMin,k=f.dataMax,b=a.getYTDExtremes(k,h,b.time.useUTC),p=b.min,n=b.max,g=a.selected,q=l(g),t=a.options.allButtonsEnabled,v=a.buttons;B(a.buttonOptions,function(b,
	f){var l=b._range,m=b.type,u=b.count||1,r=v[f],x=0;b=b._offsetMax-b._offsetMin;f=f===g;var z=l>k-h,y=l<c.minRange,w=!1,D=!1,l=l===d;("month"===m||"year"===m)&&d+36E5>=864E5*{month:28,year:365}[m]*u-b&&d-36E5<=864E5*{month:31,year:366}[m]*u+b?l=!0:"ytd"===m?(l=n-p+b===d,w=!f):"all"===m&&(l=c.max-c.min>=k-h,D=!f&&q&&l);m=!t&&(z||y||D||e);u=f&&l||l&&!q&&!w||f&&a.frozenStates;m?x=3:u&&(q=!0,x=2);r.state!==x&&r.setState(x)})},computeButtonRange:function(a){var c=a.type,d=a.count||1,e={millisecond:1,second:1E3,
	minute:6E4,hour:36E5,day:864E5,week:6048E5};if(e[c])a._range=e[c]*d;else if("month"===c||"year"===c)a._range=864E5*{month:30,year:365}[c]*d;a._offsetMin=b(a.offsetMin,0);a._offsetMax=b(a.offsetMax,0);a._range+=a._offsetMax-a._offsetMin},setInputValue:function(a,b){var c=this.chart.options.rangeSelector,d=this.chart.time,e=this[a+"Input"];C(b)&&(e.previousValue=e.HCTime,e.HCTime=b);e.value=d.dateFormat(c.inputEditDateFormat||"%Y-%m-%d",e.HCTime);this[a+"DateBox"].attr({text:d.dateFormat(c.inputDateFormat||
	"%b %e, %Y",e.HCTime)})},showInput:function(a){var b=this.inputGroup,c=this[a+"DateBox"];k(this[a+"Input"],{left:b.translateX+c.x+"px",top:b.translateY+"px",width:c.width-2+"px",height:c.height-2+"px",border:"2px solid silver"})},hideInput:function(a){k(this[a+"Input"],{border:0,width:"1px",height:"1px"});this.setInputValue(a)},drawInput:function(a){function b(){var a=D.value,b=(x.inputDateParser||Date.parse)(a),e=f.xAxis[0],g=f.scroller&&f.scroller.xAxis?f.scroller.xAxis:e,h=g.dataMin,g=g.dataMax;
	b!==D.previousValue&&(D.previousValue=b,l(b)||(b=a.split("-"),b=Date.UTC(c(b[0]),c(b[1])-1,c(b[2]))),l(b)&&(f.time.useUTC||(b+=6E4*(new Date).getTimezoneOffset()),p?b>d.maxInput.HCTime?b=void 0:b<h&&(b=h):b<d.minInput.HCTime?b=void 0:b>g&&(b=g),void 0!==b&&e.setExtremes(p?b:e.min,p?e.max:b,void 0,void 0,{trigger:"rangeSelectorInput"})))}var d=this,f=d.chart,n=f.renderer.style||{},q=f.renderer,x=f.options.rangeSelector,w=d.div,p="min"===a,D,g,y=this.inputGroup;this[a+"Label"]=g=q.label(t.lang[p?"rangeSelectorFrom":
	"rangeSelectorTo"],this.inputGroup.offset).addClass("highcharts-range-label").attr({padding:2}).add(y);y.offset+=g.width+5;this[a+"DateBox"]=q=q.label("",y.offset).addClass("highcharts-range-input").attr({padding:2,width:x.inputBoxWidth||90,height:x.inputBoxHeight||17,"text-align":"center",stroke:x.inputBoxBorderColor||"#cccccc","stroke-width":1}).on("click",function(){d.showInput(a);d[a+"Input"].focus()}).add(y);y.offset+=q.width+(p?10:0);this[a+"Input"]=D=h("input",{name:a,className:"highcharts-range-selector",
	type:"text"},{top:f.plotTop+"px"},w);g.css(v(n,x.labelStyle));q.css(v({color:"#333333"},n,x.inputStyle));k(D,e({position:"absolute",border:0,width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:n.fontSize,fontFamily:n.fontFamily,top:"-9999em"},x.inputStyle));D.onfocus=function(){d.showInput(a)};D.onblur=function(){d.hideInput(a)};D.onchange=b;D.onkeypress=function(a){13===a.keyCode&&b()}},getPosition:function(){var a=this.chart,b=a.options.rangeSelector,a="top"===b.verticalAlign?a.plotTop-
	a.axisOffset[0]:0;return{buttonTop:a+b.buttonPosition.y,inputTop:a+b.inputPosition.y-10}},getYTDExtremes:function(a,b,c){var d=this.chart.time,e=new d.Date(a),f=d.get("FullYear",e);c=c?d.Date.UTC(f,0,1):+new d.Date(f,0,1);b=Math.max(b||0,c);e=e.getTime();return{max:Math.min(a||e,e),min:b}},render:function(a,c){var d=this,e=d.chart,f=e.renderer,k=e.container,l=e.options,m=l.exporting&&!1!==l.exporting.enabled&&l.navigation&&l.navigation.buttonOptions,p=t.lang,n=d.div,g=l.rangeSelector,q=b(l.chart.style&&
	l.chart.style.zIndex,0)+1,l=g.floating,x=d.buttons,n=d.inputGroup,v=g.buttonTheme,w=g.buttonPosition,A=g.inputPosition,C=g.inputEnabled,E=v&&v.states,F=e.plotLeft,G,J=d.buttonGroup,Y;Y=d.rendered;var Z=d.options.verticalAlign,ba=e.legend,ca=ba&&ba.options,da=w.y,aa=A.y,ea=Y||!1,ga=ea?"animate":"attr",W=0,V=0,T;if(!1!==g.enabled){Y||(d.group=Y=f.g("range-selector-group").attr({zIndex:7}).add(),d.buttonGroup=J=f.g("range-selector-buttons").add(Y),d.zoomText=f.text(p.rangeSelectorZoom,0,15).css(g.labelStyle).add(J),
	B(d.buttonOptions,function(a,b){x[b]=f.button(a.text,0,0,function(){var c=a.events&&a.events.click,e;c&&(e=c.call(a));!1!==e&&d.clickButton(b);d.isActive=!0},v,E&&E.hover,E&&E.select,E&&E.disabled).attr({"text-align":"center"}).add(J)}),!1!==C&&(d.div=n=h("div",null,{position:"relative",height:0,zIndex:q}),k.parentNode.insertBefore(n,k),d.inputGroup=n=f.g("input-group").add(Y),n.offset=0,d.drawInput("min"),d.drawInput("max")));d.zoomText[ga]({x:b(F+w.x,F)});G=b(F+w.x,F)+d.zoomText.getBBox().width+
	5;B(d.buttonOptions,function(a,c){x[c][ga]({x:G});G+=x[c].width+b(g.buttonSpacing,5)});F=e.plotLeft-e.spacing[3];d.updateButtonStates();m&&this.titleCollision(e)&&"top"===Z&&"right"===w.align&&w.y+J.getBBox().height-12<(m.y||0)+m.height&&(W=-40);"left"===w.align?T=w.x-e.spacing[3]:"right"===w.align&&(T=w.x+W-e.spacing[1]);J.align({y:w.y,width:J.getBBox().width,align:w.align,x:T},!0,e.spacingBox);d.group.placed=ea;d.buttonGroup.placed=ea;!1!==C&&(W=m&&this.titleCollision(e)&&"top"===Z&&"right"===A.align&&
	A.y-n.getBBox().height-12<(m.y||0)+m.height+e.spacing[0]?-40:0,"left"===A.align?T=F:"right"===A.align&&(T=-Math.max(e.axisOffset[1],-W)),n.align({y:A.y,width:n.getBBox().width,align:A.align,x:A.x+T-2},!0,e.spacingBox),k=n.alignAttr.translateX+n.alignOptions.x-W+n.getBBox().x+2,m=n.alignOptions.width,p=J.alignAttr.translateX+J.getBBox().x,T=J.getBBox().width+20,(A.align===w.align||p+T>k&&k+m>p&&da<aa+n.getBBox().height)&&n.attr({translateX:n.alignAttr.translateX+(e.axisOffset[1]>=-W?0:-W),translateY:n.alignAttr.translateY+
	J.getBBox().height+10}),d.setInputValue("min",a),d.setInputValue("max",c),d.inputGroup.placed=ea);d.group.align({verticalAlign:Z},!0,e.spacingBox);a=d.group.getBBox().height+20;c=d.group.alignAttr.translateY;"bottom"===Z&&(ba=ca&&"bottom"===ca.verticalAlign&&ca.enabled&&!ca.floating?ba.legendHeight+b(ca.margin,10):0,a=a+ba-20,V=c-a-(l?0:g.y)-10);if("top"===Z)l&&(V=0),e.titleOffset&&(V=e.titleOffset+e.options.title.margin),V+=e.margin[0]-e.spacing[0]||0;else if("middle"===Z)if(aa===da)V=0>aa?c+void 0:
	c;else if(aa||da)V=0>aa||0>da?V-Math.min(aa,da):c-a+NaN;d.group.translate(g.x,g.y+Math.floor(V));!1!==C&&(d.minInput.style.marginTop=d.group.translateY+"px",d.maxInput.style.marginTop=d.group.translateY+"px");d.rendered=!0}},getHeight:function(){var a=this.options,b=this.group,c=a.y,d=a.buttonPosition.y,a=a.inputPosition.y,b=b?b.getBBox(!0).height+13+c:0,c=Math.min(a,d);if(0>a&&0>d||0<a&&0<d)b+=Math.abs(c);return b},titleCollision:function(a){return!(a.options.title.text||a.options.subtitle.text)},
	update:function(a){var b=this.chart;v(!0,b.options.rangeSelector,a);this.destroy();this.init(b);b.rangeSelector.render()},destroy:function(){var b=this,c=b.minInput,d=b.maxInput;b.unMouseDown();b.unResize();n(b.buttons);c&&(c.onfocus=c.onblur=c.onchange=null);d&&(d.onfocus=d.onblur=d.onchange=null);a.objectEach(b,function(a,c){a&&"chart"!==c&&(a.destroy?a.destroy():a.nodeType&&A(this[c]));a!==E.prototype[c]&&(b[c]=null)},this)}};G.prototype.toFixedRange=function(a,c,d,e){var f=this.chart&&this.chart.fixedRange;
	a=b(d,this.translate(a,!0,!this.horiz));c=b(e,this.translate(c,!0,!this.horiz));d=f&&(c-a)/f;.7<d&&1.3>d&&(e?a=c-f:c=a+f);l(a)&&l(c)||(a=c=void 0);return{min:a,max:c}};G.prototype.minFromRange=function(){var a=this.range,c={month:"Month",year:"FullYear"}[a.type],d,e=this.max,f,h,k=function(a,b){var d=new Date(a),e=d["get"+c]();d["set"+c](e+b);e===d["get"+c]()&&d.setDate(0);return d.getTime()-a};l(a)?(d=e-a,h=a):(d=e+k(e,-a.count),this.chart&&(this.chart.fixedRange=e-d));f=b(this.dataMin,Number.MIN_VALUE);
	l(d)||(d=f);d<=f&&(d=f,void 0===h&&(h=k(d,a.count)),this.newMax=Math.min(d+h,this.dataMax));l(e)||(d=void 0);return d};F(q,"afterGetContainer",function(){this.options.rangeSelector.enabled&&(this.rangeSelector=new E(this))});w(q.prototype,"render",function(a,b,c){var d=this.axes,e=this.rangeSelector;e&&(B(d,function(a){a.updateNames();a.setScale()}),this.getAxisMargins(),e.render(),d=e.options.verticalAlign,e.options.floating||("bottom"===d?this.extraBottomMargin=!0:"middle"!==d&&(this.extraTopMargin=
	!0)));a.call(this,b,c)});F(q,"update",function(a){var b=a.options.rangeSelector;a=this.rangeSelector;var c=this.extraBottomMargin,d=this.extraTopMargin;b&&b.enabled&&!C(a)&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=new E(this));this.extraTopMargin=this.extraBottomMargin=!1;a&&(a.render(),b=b&&b.verticalAlign||a.options&&a.options.verticalAlign,a.options.floating||("bottom"===b?this.extraBottomMargin=!0:"middle"!==b&&(this.extraTopMargin=!0)),this.extraBottomMargin!==c||this.extraTopMargin!==
	d)&&(this.isDirtyBox=!0)});w(q.prototype,"redraw",function(a,b,c){var d=this.rangeSelector;d&&!d.options.floating&&(d.render(),d=d.options.verticalAlign,"bottom"===d?this.extraBottomMargin=!0:"middle"!==d&&(this.extraTopMargin=!0));a.call(this,b,c)});F(q,"getMargins",function(){var a=this.rangeSelector;a&&(a=a.getHeight(),this.extraTopMargin&&(this.plotTop+=a),this.extraBottomMargin&&(this.marginBottom+=a))});q.prototype.callbacks.push(function(a){function b(){c=a.xAxis[0].getExtremes();l(c.min)&&
	d.render(c.min,c.max)}var c,d=a.rangeSelector,e,f;d&&(f=F(a.xAxis[0],"afterSetExtremes",function(a){d.render(a.min,a.max)}),e=F(a,"redraw",b),b());F(a,"destroy",function(){d&&(e(),f())})});a.RangeSelector=E})(J);(function(a){var E=a.addEvent,F=a.arrayMax,G=a.arrayMin,q=a.Axis,k=a.Chart,h=a.defined,t=a.each,C=a.extend,n=a.format,A=a.grep,B=a.inArray,e=a.isNumber,d=a.isString,l=a.map,v=a.merge,b=a.pick,c=a.Point,f=a.Renderer,w=a.Series,x=a.splat,m=a.SVGRenderer,I=a.VMLRenderer,z=a.wrap,u=w.prototype,
	r=u.init,J=u.processData,H=c.prototype.tooltipFormatter;a.StockChart=a.stockChart=function(c,e,g){var f=d(c)||c.nodeName,h=arguments[f?1:0],p=h.series,m=a.getOptions(),n,q=b(h.navigator&&h.navigator.enabled,m.navigator.enabled,!0),t=q?{startOnTick:!1,endOnTick:!1}:null,r={marker:{enabled:!1,radius:2}},u={shadow:!1,borderWidth:0};h.xAxis=l(x(h.xAxis||{}),function(a,b){return v({minPadding:0,maxPadding:0,overscroll:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0},m.xAxis,
	m.xAxis&&m.xAxis[b],a,{type:"datetime",categories:null},t)});h.yAxis=l(x(h.yAxis||{}),function(a,c){n=b(a.opposite,!0);return v({labels:{y:-2},opposite:n,showLastLabel:!(!a.categories&&"category"!==a.type),title:{text:null}},m.yAxis,m.yAxis&&m.yAxis[c],a)});h.series=null;h=v({chart:{panning:!0,pinchType:"x"},navigator:{enabled:q},scrollbar:{enabled:b(m.scrollbar.enabled,!0)},rangeSelector:{enabled:b(m.rangeSelector.enabled,!0)},title:{text:null},tooltip:{split:b(m.tooltip.split,!0),crosshairs:!0},
	legend:{enabled:!1},plotOptions:{line:r,spline:r,area:r,areaspline:r,arearange:r,areasplinerange:r,column:u,columnrange:u,candlestick:u,ohlc:u}},h,{isStock:!0});h.series=p;return f?new k(c,h,g):new k(h,e)};z(q.prototype,"autoLabelAlign",function(a){var b=this.chart,c=this.options,b=b._labelPanes=b._labelPanes||{},d=this.options.labels;return this.chart.options.isStock&&"yAxis"===this.coll&&(c=c.top+","+c.height,!b[c]&&d.enabled)?(15===d.x&&(d.x=0),void 0===d.align&&(d.align="right"),b[c]=this,"right"):
	a.apply(this,[].slice.call(arguments,1))});E(q,"destroy",function(){var a=this.chart,b=this.options&&this.options.top+","+this.options.height;b&&a._labelPanes&&a._labelPanes[b]===this&&delete a._labelPanes[b]});z(q.prototype,"getPlotLinePath",function(c,f,g,k,m,n){var p=this,q=this.isLinked&&!this.series?this.linkedParent.series:this.series,r=p.chart,u=r.renderer,v=p.left,w=p.top,y,x,z,A,D=[],C=[],E,F;if("xAxis"!==p.coll&&"yAxis"!==p.coll)return c.apply(this,[].slice.call(arguments,1));C=function(a){var b=
	"xAxis"===a?"yAxis":"xAxis";a=p.options[b];return e(a)?[r[b][a]]:d(a)?[r.get(a)]:l(q,function(a){return a[b]})}(p.coll);t(p.isXAxis?r.yAxis:r.xAxis,function(a){if(h(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var b=a.isXAxis?"yAxis":"xAxis",b=h(a.options[b])?r[b][a.options[b]]:r[b][0];p===b&&C.push(a)}});E=C.length?[]:[p.isXAxis?r.yAxis[0]:r.xAxis[0]];t(C,function(b){-1!==B(b,E)||a.find(E,function(a){return a.pos===b.pos&&a.len===b.len})||E.push(b)});F=b(n,p.translate(f,null,null,k));
	e(F)&&(p.horiz?t(E,function(a){var b;x=a.pos;A=x+a.len;y=z=Math.round(F+p.transB);"pass"!==m&&(y<v||y>v+p.width)&&(m?y=z=Math.min(Math.max(v,y),v+p.width):b=!0);b||D.push("M",y,x,"L",z,A)}):t(E,function(a){var b;y=a.pos;z=y+a.len;x=A=Math.round(w+p.height-F);"pass"!==m&&(x<w||x>w+p.height)&&(m?x=A=Math.min(Math.max(w,x),p.top+p.height):b=!0);b||D.push("M",y,x,"L",z,A)}));return 0<D.length?u.crispPolyLine(D,g||1):null});m.prototype.crispPolyLine=function(a,b){var c;for(c=0;c<a.length;c+=6)a[c+1]===
	a[c+4]&&(a[c+1]=a[c+4]=Math.round(a[c+1])-b%2/2),a[c+2]===a[c+5]&&(a[c+2]=a[c+5]=Math.round(a[c+2])+b%2/2);return a};f===I&&(I.prototype.crispPolyLine=m.prototype.crispPolyLine);z(q.prototype,"hideCrosshair",function(a,b){a.call(this,b);this.crossLabel&&(this.crossLabel=this.crossLabel.hide())});E(q,"afterDrawCrosshair",function(a){var c,d;if(h(this.crosshair.label)&&this.crosshair.label.enabled&&this.cross){var e=this.chart,f=this.options.crosshair.label,k=this.horiz;c=this.opposite;d=this.left;
	var l=this.top,m=this.crossLabel,p=f.format,q="",r="inside"===this.options.tickPosition,t=!1!==this.crosshair.snap,u=0,v=a.e||this.cross&&this.cross.e,w=a.point;a=this.lin2log;var x,z;this.isLog?(x=a(this.min),z=a(this.max)):(x=this.min,z=this.max);a=k?"center":c?"right"===this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";m||(m=this.crossLabel=e.renderer.label(null,null,null,f.shape||"callout").addClass("highcharts-crosshair-label"+(this.series[0]&&" highcharts-color-"+this.series[0].colorIndex)).attr({align:f.align||
	a,padding:b(f.padding,8),r:b(f.borderRadius,3),zIndex:2}).add(this.labelGroup),m.attr({fill:f.backgroundColor||this.series[0]&&this.series[0].color||"#666666",stroke:f.borderColor||"","stroke-width":f.borderWidth||0}).css(C({color:"#ffffff",fontWeight:"normal",fontSize:"11px",textAlign:"center"},f.style)));k?(a=t?w.plotX+d:v.chartX,l+=c?0:this.height):(a=c?this.width+d:0,l=t?w.plotY+l:v.chartY);p||f.formatter||(this.isDatetimeAxis&&(q="%b %d, %Y"),p="{value"+(q?":"+q:"")+"}");q=t?w[this.isXAxis?"x":
	"y"]:this.toValue(k?v.chartX:v.chartY);m.attr({text:p?n(p,{value:q},e.time):f.formatter.call(this,q),x:a,y:l,visibility:q<x||q>z?"hidden":"visible"});f=m.getBBox();if(k){if(r&&!c||!r&&c)l=m.y-f.height}else l=m.y-f.height/2;k?(c=d-f.x,d=d+this.width-f.x):(c="left"===this.labelAlign?d:0,d="right"===this.labelAlign?d+this.width:e.chartWidth);m.translateX<c&&(u=c-m.translateX);m.translateX+f.width>=d&&(u=-(m.translateX+f.width-d));m.attr({x:a+u,y:l,anchorX:k?a:this.opposite?0:e.chartWidth,anchorY:k?this.opposite?
	e.chartHeight:0:l+f.height/2})}});u.init=function(){r.apply(this,arguments);this.setCompare(this.options.compare)};u.setCompare=function(a){this.modifyValue="value"===a||"percent"===a?function(b,c){var d=this.compareValue;if(void 0!==b&&void 0!==d)return b="value"===a?b-d:b/d*100-(100===this.options.compareBase?0:100),c&&(c.change=b),b}:null;this.userOptions.compare=a;this.chart.hasRendered&&(this.isDirty=!0)};u.processData=function(){var a,b=-1,c,d,f=!0===this.options.compareStart?0:1,h,k;J.apply(this,
	arguments);if(this.xAxis&&this.processedYData)for(c=this.processedXData,d=this.processedYData,h=d.length,this.pointArrayMap&&(b=B("close",this.pointArrayMap),-1===b&&(b=B(this.pointValKey||"y",this.pointArrayMap))),a=0;a<h-f;a++)if(k=d[a]&&-1<b?d[a][b]:d[a],e(k)&&c[a+f]>=this.xAxis.min&&0!==k){this.compareValue=k;break}};z(u,"getExtremes",function(a){var b;a.apply(this,[].slice.call(arguments,1));this.modifyValue&&(b=[this.modifyValue(this.dataMin),this.modifyValue(this.dataMax)],this.dataMin=G(b),
	this.dataMax=F(b))});q.prototype.setCompare=function(a,c){this.isXAxis||(t(this.series,function(b){b.setCompare(a)}),b(c,!0)&&this.chart.redraw())};c.prototype.tooltipFormatter=function(c){c=c.replace("{point.change}",(0<this.change?"+":"")+a.numberFormat(this.change,b(this.series.tooltipOptions.changeDecimals,2)));return H.apply(this,[c])};z(w.prototype,"render",function(a){var b;this.chart.is3d&&this.chart.is3d()||this.chart.polar||!this.xAxis||this.xAxis.isRadial||(b=this.yAxis.len-(this.xAxis.axisLine?
	Math.floor(this.xAxis.axisLine.strokeWidth()/2):0),!this.clipBox&&this.animate?(this.clipBox=v(this.chart.clipBox),this.clipBox.width=this.xAxis.len,this.clipBox.height=b):this.chart[this.sharedClipKey]?this.chart[this.sharedClipKey].attr({width:this.xAxis.len,height:b}):this.clipBox&&(this.clipBox.width=this.xAxis.len,this.clipBox.height=b));a.call(this)});z(k.prototype,"getSelectedPoints",function(a){var b=a.call(this);t(this.series,function(a){a.hasGroupedData&&(b=b.concat(A(a.points||[],function(a){return a.selected})))});
	return b});E(k,"update",function(a){a=a.options;"scrollbar"in a&&this.navigator&&(v(!0,this.options.scrollbar,a.scrollbar),this.navigator.update({},!1),delete a.scrollbar)})})(J);return J});
	//# sourceMappingURL=highstock.js.map


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	// 4.9.10 (2020-04-23)
	(function () {
	(function (domGlobals) {
	    'use strict';
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return !f.apply(null, args);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNull = isType('null');
	    var isBoolean = isType('boolean');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(i);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var url = function () {
	      return Global$1.getOrDie('URL');
	    };
	    var createObjectURL = function (blob) {
	      return url().createObjectURL(blob);
	    };
	    var revokeObjectURL = function (u) {
	      url().revokeObjectURL(u);
	    };
	    var URL = {
	      createObjectURL: createObjectURL,
	      revokeObjectURL: revokeObjectURL
	    };
	
	    var nav = domGlobals.navigator, userAgent = nav.userAgent;
	    var opera, webkit, ie, ie11, ie12, gecko, mac, iDevice, android, fileApi, phone, tablet, windowsPhone;
	    var matchMediaQuery = function (query) {
	      return 'matchMedia' in domGlobals.window ? domGlobals.matchMedia(query).matches : false;
	    };
	    opera = false;
	    android = /Android/.test(userAgent);
	    webkit = /WebKit/.test(userAgent);
	    ie = !webkit && !opera && /MSIE/gi.test(userAgent) && /Explorer/gi.test(nav.appName);
	    ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
	    ie11 = userAgent.indexOf('Trident/') !== -1 && (userAgent.indexOf('rv:') !== -1 || nav.appName.indexOf('Netscape') !== -1) ? 11 : false;
	    ie12 = userAgent.indexOf('Edge/') !== -1 && !ie && !ie11 ? 12 : false;
	    ie = ie || ie11 || ie12;
	    gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
	    mac = userAgent.indexOf('Mac') !== -1;
	    iDevice = /(iPad|iPhone)/.test(userAgent);
	    fileApi = 'FormData' in domGlobals.window && 'FileReader' in domGlobals.window && 'URL' in domGlobals.window && !!URL.createObjectURL;
	    phone = matchMediaQuery('only screen and (max-device-width: 480px)') && (android || iDevice);
	    tablet = matchMediaQuery('only screen and (min-width: 800px)') && (android || iDevice);
	    windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
	    if (ie12) {
	      webkit = false;
	    }
	    var contentEditable = !iDevice || fileApi || parseInt(userAgent.match(/AppleWebKit\/(\d*)/)[1], 10) >= 534;
	    var Env = {
	      opera: opera,
	      webkit: webkit,
	      ie: ie,
	      gecko: gecko,
	      mac: mac,
	      iOS: iDevice,
	      android: android,
	      contentEditable: contentEditable,
	      transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
	      caretAfter: ie !== 8,
	      range: domGlobals.window.getSelection && 'Range' in domGlobals.window,
	      documentMode: ie && !ie12 ? domGlobals.document.documentMode || 7 : 10,
	      fileApi: fileApi,
	      ceFalse: ie === false || ie > 8,
	      cacheSuffix: null,
	      container: null,
	      overrideViewPort: null,
	      experimentalShadowDom: false,
	      canHaveCSP: ie === false || ie > 11,
	      desktop: !phone && !tablet,
	      windowsPhone: windowsPhone
	    };
	
	    var promise = function () {
	      function bind(fn, thisArg) {
	        return function () {
	          fn.apply(thisArg, arguments);
	        };
	      }
	      var isArray = Array.isArray || function (value) {
	        return Object.prototype.toString.call(value) === '[object Array]';
	      };
	      var Promise = function (fn) {
	        if (typeof this !== 'object') {
	          throw new TypeError('Promises must be constructed via new');
	        }
	        if (typeof fn !== 'function') {
	          throw new TypeError('not a function');
	        }
	        this._state = null;
	        this._value = null;
	        this._deferreds = [];
	        doResolve(fn, bind(resolve, this), bind(reject, this));
	      };
	      var asap = Promise.immediateFn || typeof setImmediate === 'function' && setImmediate || function (fn) {
	        setTimeout(fn, 1);
	      };
	      function handle(deferred) {
	        var me = this;
	        if (this._state === null) {
	          this._deferreds.push(deferred);
	          return;
	        }
	        asap(function () {
	          var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
	          if (cb === null) {
	            (me._state ? deferred.resolve : deferred.reject)(me._value);
	            return;
	          }
	          var ret;
	          try {
	            ret = cb(me._value);
	          } catch (e) {
	            deferred.reject(e);
	            return;
	          }
	          deferred.resolve(ret);
	        });
	      }
	      function resolve(newValue) {
	        try {
	          if (newValue === this) {
	            throw new TypeError('A promise cannot be resolved with itself.');
	          }
	          if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	            var then = newValue.then;
	            if (typeof then === 'function') {
	              doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	              return;
	            }
	          }
	          this._state = true;
	          this._value = newValue;
	          finale.call(this);
	        } catch (e) {
	          reject.call(this, e);
	        }
	      }
	      function reject(newValue) {
	        this._state = false;
	        this._value = newValue;
	        finale.call(this);
	      }
	      function finale() {
	        for (var i = 0, len = this._deferreds.length; i < len; i++) {
	          handle.call(this, this._deferreds[i]);
	        }
	        this._deferreds = null;
	      }
	      function Handler(onFulfilled, onRejected, resolve, reject) {
	        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	        this.resolve = resolve;
	        this.reject = reject;
	      }
	      function doResolve(fn, onFulfilled, onRejected) {
	        var done = false;
	        try {
	          fn(function (value) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onFulfilled(value);
	          }, function (reason) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onRejected(reason);
	          });
	        } catch (ex) {
	          if (done) {
	            return;
	          }
	          done = true;
	          onRejected(ex);
	        }
	      }
	      Promise.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	      };
	      Promise.prototype.then = function (onFulfilled, onRejected) {
	        var me = this;
	        return new Promise(function (resolve, reject) {
	          handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	        });
	      };
	      Promise.all = function () {
	        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
	        return new Promise(function (resolve, reject) {
	          if (args.length === 0) {
	            return resolve([]);
	          }
	          var remaining = args.length;
	          function res(i, val) {
	            try {
	              if (val && (typeof val === 'object' || typeof val === 'function')) {
	                var then = val.then;
	                if (typeof then === 'function') {
	                  then.call(val, function (val) {
	                    res(i, val);
	                  }, reject);
	                  return;
	                }
	              }
	              args[i] = val;
	              if (--remaining === 0) {
	                resolve(args);
	              }
	            } catch (ex) {
	              reject(ex);
	            }
	          }
	          for (var i = 0; i < args.length; i++) {
	            res(i, args[i]);
	          }
	        });
	      };
	      Promise.resolve = function (value) {
	        if (value && typeof value === 'object' && value.constructor === Promise) {
	          return value;
	        }
	        return new Promise(function (resolve) {
	          resolve(value);
	        });
	      };
	      Promise.reject = function (value) {
	        return new Promise(function (resolve, reject) {
	          reject(value);
	        });
	      };
	      Promise.race = function (values) {
	        return new Promise(function (resolve, reject) {
	          for (var i = 0, len = values.length; i < len; i++) {
	            values[i].then(resolve, reject);
	          }
	        });
	      };
	      return Promise;
	    };
	    var promiseObj = window.Promise ? window.Promise : promise();
	
	    var requestAnimationFramePromise;
	    var requestAnimationFrame = function (callback, element) {
	      var i, requestAnimationFrameFunc = domGlobals.window.requestAnimationFrame;
	      var vendors = [
	        'ms',
	        'moz',
	        'webkit'
	      ];
	      var featurefill = function (callback) {
	        domGlobals.window.setTimeout(callback, 0);
	      };
	      for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
	        requestAnimationFrameFunc = domGlobals.window[vendors[i] + 'RequestAnimationFrame'];
	      }
	      if (!requestAnimationFrameFunc) {
	        requestAnimationFrameFunc = featurefill;
	      }
	      requestAnimationFrameFunc(callback, element);
	    };
	    var wrappedSetTimeout = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 0;
	      }
	      return setTimeout(callback, time);
	    };
	    var wrappedSetInterval = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 1;
	      }
	      return setInterval(callback, time);
	    };
	    var wrappedClearTimeout = function (id) {
	      return clearTimeout(id);
	    };
	    var wrappedClearInterval = function (id) {
	      return clearInterval(id);
	    };
	    var debounce = function (callback, time) {
	      var timer, func;
	      func = function () {
	        var args = arguments;
	        clearTimeout(timer);
	        timer = wrappedSetTimeout(function () {
	          callback.apply(this, args);
	        }, time);
	      };
	      func.stop = function () {
	        clearTimeout(timer);
	      };
	      return func;
	    };
	    var Delay = {
	      requestAnimationFrame: function (callback, element) {
	        if (requestAnimationFramePromise) {
	          requestAnimationFramePromise.then(callback);
	          return;
	        }
	        requestAnimationFramePromise = new promiseObj(function (resolve) {
	          if (!element) {
	            element = domGlobals.document.body;
	          }
	          requestAnimationFrame(resolve, element);
	        }).then(callback);
	      },
	      setTimeout: wrappedSetTimeout,
	      setInterval: wrappedSetInterval,
	      setEditorTimeout: function (editor, callback, time) {
	        return wrappedSetTimeout(function () {
	          if (!editor.removed) {
	            callback();
	          }
	        }, time);
	      },
	      setEditorInterval: function (editor, callback, time) {
	        var timer;
	        timer = wrappedSetInterval(function () {
	          if (!editor.removed) {
	            callback();
	          } else {
	            clearInterval(timer);
	          }
	        }, time);
	        return timer;
	      },
	      debounce: debounce,
	      throttle: debounce,
	      clearInterval: wrappedClearInterval,
	      clearTimeout: wrappedClearTimeout
	    };
	
	    var eventExpandoPrefix = 'mce-data-';
	    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
	    var deprecated = {
	      keyLocation: 1,
	      layerX: 1,
	      layerY: 1,
	      returnValue: 1,
	      webkitMovementX: 1,
	      webkitMovementY: 1,
	      keyIdentifier: 1
	    };
	    var hasIsDefaultPrevented = function (event) {
	      return event.isDefaultPrevented === returnTrue || event.isDefaultPrevented === returnFalse;
	    };
	    var returnFalse = function () {
	      return false;
	    };
	    var returnTrue = function () {
	      return true;
	    };
	    var addEvent = function (target, name, callback, capture) {
	      if (target.addEventListener) {
	        target.addEventListener(name, callback, capture || false);
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + name, callback);
	      }
	    };
	    var removeEvent = function (target, name, callback, capture) {
	      if (target.removeEventListener) {
	        target.removeEventListener(name, callback, capture || false);
	      } else if (target.detachEvent) {
	        target.detachEvent('on' + name, callback);
	      }
	    };
	    var getTargetFromShadowDom = function (event, defaultTarget) {
	      if (event.composedPath) {
	        var composedPath = event.composedPath();
	        if (composedPath && composedPath.length > 0) {
	          return composedPath[0];
	        }
	      }
	      return defaultTarget;
	    };
	    var fix = function (originalEvent, data) {
	      var name;
	      var event = data || {};
	      for (name in originalEvent) {
	        if (!deprecated[name]) {
	          event[name] = originalEvent[name];
	        }
	      }
	      if (!event.target) {
	        event.target = event.srcElement || domGlobals.document;
	      }
	      if (Env.experimentalShadowDom) {
	        event.target = getTargetFromShadowDom(originalEvent, event.target);
	      }
	      if (originalEvent && mouseEventRe.test(originalEvent.type) && originalEvent.pageX === undefined && originalEvent.clientX !== undefined) {
	        var eventDoc = event.target.ownerDocument || domGlobals.document;
	        var doc = eventDoc.documentElement;
	        var body = eventDoc.body;
	        event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	        event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	      }
	      event.preventDefault = function () {
	        event.isDefaultPrevented = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.preventDefault) {
	            originalEvent.preventDefault();
	          } else {
	            originalEvent.returnValue = false;
	          }
	        }
	      };
	      event.stopPropagation = function () {
	        event.isPropagationStopped = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.stopPropagation) {
	            originalEvent.stopPropagation();
	          } else {
	            originalEvent.cancelBubble = true;
	          }
	        }
	      };
	      event.stopImmediatePropagation = function () {
	        event.isImmediatePropagationStopped = returnTrue;
	        event.stopPropagation();
	      };
	      if (hasIsDefaultPrevented(event) === false) {
	        event.isDefaultPrevented = returnFalse;
	        event.isPropagationStopped = returnFalse;
	        event.isImmediatePropagationStopped = returnFalse;
	      }
	      if (typeof event.metaKey === 'undefined') {
	        event.metaKey = false;
	      }
	      return event;
	    };
	    var bindOnReady = function (win, callback, eventUtils) {
	      var doc = win.document, event = { type: 'ready' };
	      if (eventUtils.domLoaded) {
	        callback(event);
	        return;
	      }
	      var isDocReady = function () {
	        return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
	      };
	      var readyHandler = function () {
	        if (!eventUtils.domLoaded) {
	          eventUtils.domLoaded = true;
	          callback(event);
	        }
	      };
	      var waitForDomLoaded = function () {
	        if (isDocReady()) {
	          removeEvent(doc, 'readystatechange', waitForDomLoaded);
	          readyHandler();
	        }
	      };
	      var tryScroll = function () {
	        try {
	          doc.documentElement.doScroll('left');
	        } catch (ex) {
	          Delay.setTimeout(tryScroll);
	          return;
	        }
	        readyHandler();
	      };
	      if (doc.addEventListener && !(Env.ie && Env.ie < 11)) {
	        if (isDocReady()) {
	          readyHandler();
	        } else {
	          addEvent(win, 'DOMContentLoaded', readyHandler);
	        }
	      } else {
	        addEvent(doc, 'readystatechange', waitForDomLoaded);
	        if (doc.documentElement.doScroll && win.self === win.top) {
	          tryScroll();
	        }
	      }
	      addEvent(win, 'load', readyHandler);
	    };
	    var EventUtils = function () {
	      var self = this;
	      var events = {}, count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
	      expando = eventExpandoPrefix + (+new Date()).toString(32);
	      hasMouseEnterLeave = 'onmouseenter' in domGlobals.document.documentElement;
	      hasFocusIn = 'onfocusin' in domGlobals.document.documentElement;
	      mouseEnterLeave = {
	        mouseenter: 'mouseover',
	        mouseleave: 'mouseout'
	      };
	      count = 1;
	      self.domLoaded = false;
	      self.events = events;
	      var executeHandlers = function (evt, id) {
	        var callbackList, i, l, callback;
	        var container = events[id];
	        callbackList = container && container[evt.type];
	        if (callbackList) {
	          for (i = 0, l = callbackList.length; i < l; i++) {
	            callback = callbackList[i];
	            if (callback && callback.func.call(callback.scope, evt) === false) {
	              evt.preventDefault();
	            }
	            if (evt.isImmediatePropagationStopped()) {
	              return;
	            }
	          }
	        }
	      };
	      self.bind = function (target, names, callback, scope) {
	        var id, callbackList, i, name, fakeName, nativeHandler, capture;
	        var win = domGlobals.window;
	        var defaultNativeHandler = function (evt) {
	          executeHandlers(fix(evt || win.event), id);
	        };
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return;
	        }
	        if (!target[expando]) {
	          id = count++;
	          target[expando] = id;
	          events[id] = {};
	        } else {
	          id = target[expando];
	        }
	        scope = scope || target;
	        names = names.split(' ');
	        i = names.length;
	        while (i--) {
	          name = names[i];
	          nativeHandler = defaultNativeHandler;
	          fakeName = capture = false;
	          if (name === 'DOMContentLoaded') {
	            name = 'ready';
	          }
	          if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
	            callback.call(scope, fix({ type: name }));
	            continue;
	          }
	          if (!hasMouseEnterLeave) {
	            fakeName = mouseEnterLeave[name];
	            if (fakeName) {
	              nativeHandler = function (evt) {
	                var current, related;
	                current = evt.currentTarget;
	                related = evt.relatedTarget;
	                if (related && current.contains) {
	                  related = current.contains(related);
	                } else {
	                  while (related && related !== current) {
	                    related = related.parentNode;
	                  }
	                }
	                if (!related) {
	                  evt = fix(evt || win.event);
	                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
	                  evt.target = current;
	                  executeHandlers(evt, id);
	                }
	              };
	            }
	          }
	          if (!hasFocusIn && (name === 'focusin' || name === 'focusout')) {
	            capture = true;
	            fakeName = name === 'focusin' ? 'focus' : 'blur';
	            nativeHandler = function (evt) {
	              evt = fix(evt || win.event);
	              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
	              executeHandlers(evt, id);
	            };
	          }
	          callbackList = events[id][name];
	          if (!callbackList) {
	            events[id][name] = callbackList = [{
	                func: callback,
	                scope: scope
	              }];
	            callbackList.fakeName = fakeName;
	            callbackList.capture = capture;
	            callbackList.nativeHandler = nativeHandler;
	            if (name === 'ready') {
	              bindOnReady(target, nativeHandler, self);
	            } else {
	              addEvent(target, fakeName || name, nativeHandler, capture);
	            }
	          } else {
	            if (name === 'ready' && self.domLoaded) {
	              callback({ type: name });
	            } else {
	              callbackList.push({
	                func: callback,
	                scope: scope
	              });
	            }
	          }
	        }
	        target = callbackList = 0;
	        return callback;
	      };
	      self.unbind = function (target, names, callback) {
	        var id, callbackList, i, ci, name, eventMap;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        id = target[expando];
	        if (id) {
	          eventMap = events[id];
	          if (names) {
	            names = names.split(' ');
	            i = names.length;
	            while (i--) {
	              name = names[i];
	              callbackList = eventMap[name];
	              if (callbackList) {
	                if (callback) {
	                  ci = callbackList.length;
	                  while (ci--) {
	                    if (callbackList[ci].func === callback) {
	                      var nativeHandler = callbackList.nativeHandler;
	                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
	                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
	                      callbackList.nativeHandler = nativeHandler;
	                      callbackList.fakeName = fakeName;
	                      callbackList.capture = capture;
	                      eventMap[name] = callbackList;
	                    }
	                  }
	                }
	                if (!callback || callbackList.length === 0) {
	                  delete eventMap[name];
	                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	                }
	              }
	            }
	          } else {
	            for (name in eventMap) {
	              callbackList = eventMap[name];
	              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	            }
	            eventMap = {};
	          }
	          for (name in eventMap) {
	            return self;
	          }
	          delete events[id];
	          try {
	            delete target[expando];
	          } catch (ex) {
	            target[expando] = null;
	          }
	        }
	        return self;
	      };
	      self.fire = function (target, name, args) {
	        var id;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        args = fix(null, args);
	        args.type = name;
	        args.target = target;
	        do {
	          id = target[expando];
	          if (id) {
	            executeHandlers(args, id);
	          }
	          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
	        } while (target && !args.isPropagationStopped());
	        return self;
	      };
	      self.clean = function (target) {
	        var i, children;
	        var unbind = self.unbind;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	        if (target[expando]) {
	          unbind(target);
	        }
	        if (!target.getElementsByTagName) {
	          target = target.document;
	        }
	        if (target && target.getElementsByTagName) {
	          unbind(target);
	          children = target.getElementsByTagName('*');
	          i = children.length;
	          while (i--) {
	            target = children[i];
	            if (target[expando]) {
	              unbind(target);
	            }
	          }
	        }
	        return self;
	      };
	      self.destroy = function () {
	        events = {};
	      };
	      self.cancel = function (e) {
	        if (e) {
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        return false;
	      };
	    };
	    EventUtils.Event = new EventUtils();
	    EventUtils.Event.bind(domGlobals.window, 'ready', function () {
	    });
	
	    var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains$1, expando = 'sizzle' + -new Date(), preferredDoc = domGlobals.window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	        }
	        return 0;
	      }, strundefined = typeof undefined, MAX_NEGATIVE = 1 << 31, hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, indexOf$1 = arr.indexOf || function (elem) {
	        var i = 0, len = this.length;
	        for (; i < len; i++) {
	          if (this[i] === elem) {
	            return i;
	          }
	        }
	        return -1;
	      }, booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped', whitespace = '[\\x20\\t\\r\\n\\f]', identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+', attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]', pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)', rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'), rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'), rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'), rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g'), rpseudo = new RegExp(pseudos), ridentifier = new RegExp('^' + identifier + '$'), matchExpr = {
	        ID: new RegExp('^#(' + identifier + ')'),
	        CLASS: new RegExp('^\\.(' + identifier + ')'),
	        TAG: new RegExp('^(' + identifier + '|[*])'),
	        ATTR: new RegExp('^' + attributes),
	        PSEUDO: new RegExp('^' + pseudos),
	        CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
	        bool: new RegExp('^(?:' + booleans + ')$', 'i'),
	        needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
	      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig'), funescape = function (_, escaped, escapedWhitespace) {
	        var high = '0x' + escaped - 65536;
	        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
	      };
	    try {
	      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
	      arr[preferredDoc.childNodes.length].nodeType;
	    } catch (e) {
	      push = {
	        apply: arr.length ? function (target, els) {
	          push_native.apply(target, slice.call(els));
	        } : function (target, els) {
	          var j = target.length, i = 0;
	          while (target[j++] = els[i++]) {
	          }
	          target.length = j - 1;
	        }
	      };
	    }
	    var Sizzle = function (selector, context, results, seed) {
	      var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
	      if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
	        setDocument(context);
	      }
	      context = context || document;
	      results = results || [];
	      if (!selector || typeof selector !== 'string') {
	        return results;
	      }
	      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	        return [];
	      }
	      if (documentIsHTML && !seed) {
	        if (match = rquickExpr.exec(selector)) {
	          if (m = match[1]) {
	            if (nodeType === 9) {
	              elem = context.getElementById(m);
	              if (elem && elem.parentNode) {
	                if (elem.id === m) {
	                  results.push(elem);
	                  return results;
	                }
	              } else {
	                return results;
	              }
	            } else {
	              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains$1(context, elem) && elem.id === m) {
	                results.push(elem);
	                return results;
	              }
	            }
	          } else if (match[2]) {
	            push.apply(results, context.getElementsByTagName(selector));
	            return results;
	          } else if ((m = match[3]) && support.getElementsByClassName) {
	            push.apply(results, context.getElementsByClassName(m));
	            return results;
	          }
	        }
	        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	          nid = old = expando;
	          newContext = context;
	          newSelector = nodeType === 9 && selector;
	          if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
	            groups = tokenize(selector);
	            if (old = context.getAttribute('id')) {
	              nid = old.replace(rescape, '\\$&');
	            } else {
	              context.setAttribute('id', nid);
	            }
	            nid = '[id=\'' + nid + '\'] ';
	            i = groups.length;
	            while (i--) {
	              groups[i] = nid + toSelector(groups[i]);
	            }
	            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	            newSelector = groups.join(',');
	          }
	          if (newSelector) {
	            try {
	              push.apply(results, newContext.querySelectorAll(newSelector));
	              return results;
	            } catch (qsaError) {
	            } finally {
	              if (!old) {
	                context.removeAttribute('id');
	              }
	            }
	          }
	        }
	      }
	      return select(selector.replace(rtrim, '$1'), context, results, seed);
	    };
	    function createCache() {
	      var keys = [];
	      function cache(key, value) {
	        if (keys.push(key + ' ') > Expr.cacheLength) {
	          delete cache[keys.shift()];
	        }
	        return cache[key + ' '] = value;
	      }
	      return cache;
	    }
	    function markFunction(fn) {
	      fn[expando] = true;
	      return fn;
	    }
	    function siblingCheck(a, b) {
	      var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
	      if (diff) {
	        return diff;
	      }
	      if (cur) {
	        while (cur = cur.nextSibling) {
	          if (cur === b) {
	            return -1;
	          }
	        }
	      }
	      return a ? 1 : -1;
	    }
	    function createInputPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return name === 'input' && elem.type === type;
	      };
	    }
	    function createButtonPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return (name === 'input' || name === 'button') && elem.type === type;
	      };
	    }
	    function createPositionalPseudo(fn) {
	      return markFunction(function (argument) {
	        argument = +argument;
	        return markFunction(function (seed, matches) {
	          var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
	          while (i--) {
	            if (seed[j = matchIndexes[i]]) {
	              seed[j] = !(matches[j] = seed[j]);
	            }
	          }
	        });
	      });
	    }
	    function testContext(context) {
	      return context && typeof context.getElementsByTagName !== strundefined && context;
	    }
	    support = Sizzle.support = {};
	    isXML = Sizzle.isXML = function (elem) {
	      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	      return documentElement ? documentElement.nodeName !== 'HTML' : false;
	    };
	    setDocument = Sizzle.setDocument = function (node) {
	      var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
	      function getTop(win) {
	        try {
	          return win.top;
	        } catch (ex) {
	        }
	        return null;
	      }
	      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
	        return document;
	      }
	      document = doc;
	      docElem = doc.documentElement;
	      documentIsHTML = !isXML(doc);
	      if (parent && parent !== getTop(parent)) {
	        if (parent.addEventListener) {
	          parent.addEventListener('unload', function () {
	            setDocument();
	          }, false);
	        } else if (parent.attachEvent) {
	          parent.attachEvent('onunload', function () {
	            setDocument();
	          });
	        }
	      }
	      support.attributes = true;
	      support.getElementsByTagName = true;
	      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
	      support.getById = true;
	      Expr.find.ID = function (id, context) {
	        if (typeof context.getElementById !== strundefined && documentIsHTML) {
	          var m = context.getElementById(id);
	          return m && m.parentNode ? [m] : [];
	        }
	      };
	      Expr.filter.ID = function (id) {
	        var attrId = id.replace(runescape, funescape);
	        return function (elem) {
	          return elem.getAttribute('id') === attrId;
	        };
	      };
	      Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
	        if (typeof context.getElementsByTagName !== strundefined) {
	          return context.getElementsByTagName(tag);
	        }
	      } : function (tag, context) {
	        var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
	        if (tag === '*') {
	          while (elem = results[i++]) {
	            if (elem.nodeType === 1) {
	              tmp.push(elem);
	            }
	          }
	          return tmp;
	        }
	        return results;
	      };
	      Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
	        if (documentIsHTML) {
	          return context.getElementsByClassName(className);
	        }
	      };
	      rbuggyMatches = [];
	      rbuggyQSA = [];
	      support.disconnectedMatch = true;
	      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
	      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
	      hasCompare = rnative.test(docElem.compareDocumentPosition);
	      contains$1 = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
	        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
	        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
	      } : function (a, b) {
	        if (b) {
	          while (b = b.parentNode) {
	            if (b === a) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	      sortOrder = hasCompare ? function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	        if (compare) {
	          return compare;
	        }
	        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
	        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	          if (a === doc || a.ownerDocument === preferredDoc && contains$1(preferredDoc, a)) {
	            return -1;
	          }
	          if (b === doc || b.ownerDocument === preferredDoc && contains$1(preferredDoc, b)) {
	            return 1;
	          }
	          return sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
	        }
	        return compare & 4 ? -1 : 1;
	      } : function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
	        if (!aup || !bup) {
	          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
	        } else if (aup === bup) {
	          return siblingCheck(a, b);
	        }
	        cur = a;
	        while (cur = cur.parentNode) {
	          ap.unshift(cur);
	        }
	        cur = b;
	        while (cur = cur.parentNode) {
	          bp.unshift(cur);
	        }
	        while (ap[i] === bp[i]) {
	          i++;
	        }
	        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
	      };
	      return doc;
	    };
	    Sizzle.matches = function (expr, elements) {
	      return Sizzle(expr, null, null, elements);
	    };
	    Sizzle.matchesSelector = function (elem, expr) {
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	      expr = expr.replace(rattributeQuotes, '=\'$1\']');
	      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	        try {
	          var ret = matches.call(elem, expr);
	          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
	            return ret;
	          }
	        } catch (e) {
	        }
	      }
	      return Sizzle(expr, document, null, [elem]).length > 0;
	    };
	    Sizzle.contains = function (context, elem) {
	      if ((context.ownerDocument || context) !== document) {
	        setDocument(context);
	      }
	      return contains$1(context, elem);
	    };
	    Sizzle.attr = function (elem, name) {
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
	    };
	    Sizzle.error = function (msg) {
	      throw new Error('Syntax error, unrecognized expression: ' + msg);
	    };
	    Sizzle.uniqueSort = function (results) {
	      var elem, duplicates = [], j = 0, i = 0;
	      hasDuplicate = !support.detectDuplicates;
	      sortInput = !support.sortStable && results.slice(0);
	      results.sort(sortOrder);
	      if (hasDuplicate) {
	        while (elem = results[i++]) {
	          if (elem === results[i]) {
	            j = duplicates.push(i);
	          }
	        }
	        while (j--) {
	          results.splice(duplicates[j], 1);
	        }
	      }
	      sortInput = null;
	      return results;
	    };
	    getText = Sizzle.getText = function (elem) {
	      var node, ret = '', i = 0, nodeType = elem.nodeType;
	      if (!nodeType) {
	        while (node = elem[i++]) {
	          ret += getText(node);
	        }
	      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	        if (typeof elem.textContent === 'string') {
	          return elem.textContent;
	        } else {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            ret += getText(elem);
	          }
	        }
	      } else if (nodeType === 3 || nodeType === 4) {
	        return elem.nodeValue;
	      }
	      return ret;
	    };
	    Expr = Sizzle.selectors = {
	      cacheLength: 50,
	      createPseudo: markFunction,
	      match: matchExpr,
	      attrHandle: {},
	      find: {},
	      relative: {
	        '>': {
	          dir: 'parentNode',
	          first: true
	        },
	        ' ': { dir: 'parentNode' },
	        '+': {
	          dir: 'previousSibling',
	          first: true
	        },
	        '~': { dir: 'previousSibling' }
	      },
	      preFilter: {
	        ATTR: function (match) {
	          match[1] = match[1].replace(runescape, funescape);
	          match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
	          if (match[2] === '~=') {
	            match[3] = ' ' + match[3] + ' ';
	          }
	          return match.slice(0, 4);
	        },
	        CHILD: function (match) {
	          match[1] = match[1].toLowerCase();
	          if (match[1].slice(0, 3) === 'nth') {
	            if (!match[3]) {
	              Sizzle.error(match[0]);
	            }
	            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
	            match[5] = +(match[7] + match[8] || match[3] === 'odd');
	          } else if (match[3]) {
	            Sizzle.error(match[0]);
	          }
	          return match;
	        },
	        PSEUDO: function (match) {
	          var excess, unquoted = !match[6] && match[2];
	          if (matchExpr.CHILD.test(match[0])) {
	            return null;
	          }
	          if (match[3]) {
	            match[2] = match[4] || match[5] || '';
	          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
	            match[0] = match[0].slice(0, excess);
	            match[2] = unquoted.slice(0, excess);
	          }
	          return match.slice(0, 3);
	        }
	      },
	      filter: {
	        TAG: function (nodeNameSelector) {
	          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
	          return nodeNameSelector === '*' ? function () {
	            return true;
	          } : function (elem) {
	            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	          };
	        },
	        CLASS: function (className) {
	          var pattern = classCache[className + ' '];
	          return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
	            return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
	          });
	        },
	        ATTR: function (name, operator, check) {
	          return function (elem) {
	            var result = Sizzle.attr(elem, name);
	            if (result == null) {
	              return operator === '!=';
	            }
	            if (!operator) {
	              return true;
	            }
	            result += '';
	            return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
	          };
	        },
	        CHILD: function (type, what, argument, first, last) {
	          var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
	          return first === 1 && last === 0 ? function (elem) {
	            return !!elem.parentNode;
	          } : function (elem, context, xml) {
	            var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
	            if (parent) {
	              if (simple) {
	                while (dir) {
	                  node = elem;
	                  while (node = node[dir]) {
	                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	                      return false;
	                    }
	                  }
	                  start = dir = type === 'only' && !start && 'nextSibling';
	                }
	                return true;
	              }
	              start = [forward ? parent.firstChild : parent.lastChild];
	              if (forward && useCache) {
	                outerCache = parent[expando] || (parent[expando] = {});
	                cache = outerCache[type] || [];
	                nodeIndex = cache[0] === dirruns && cache[1];
	                diff = cache[0] === dirruns && cache[2];
	                node = nodeIndex && parent.childNodes[nodeIndex];
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if (node.nodeType === 1 && ++diff && node === elem) {
	                    outerCache[type] = [
	                      dirruns,
	                      nodeIndex,
	                      diff
	                    ];
	                    break;
	                  }
	                }
	              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
	                diff = cache[1];
	              } else {
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	                    if (useCache) {
	                      (node[expando] || (node[expando] = {}))[type] = [
	                        dirruns,
	                        diff
	                      ];
	                    }
	                    if (node === elem) {
	                      break;
	                    }
	                  }
	                }
	              }
	              diff -= last;
	              return diff === first || diff % first === 0 && diff / first >= 0;
	            }
	          };
	        },
	        PSEUDO: function (pseudo, argument) {
	          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
	          if (fn[expando]) {
	            return fn(argument);
	          }
	          if (fn.length > 1) {
	            args = [
	              pseudo,
	              pseudo,
	              '',
	              argument
	            ];
	            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
	              var idx, matched = fn(seed, argument), i = matched.length;
	              while (i--) {
	                idx = indexOf$1.call(seed, matched[i]);
	                seed[idx] = !(matches[idx] = matched[i]);
	              }
	            }) : function (elem) {
	              return fn(elem, 0, args);
	            };
	          }
	          return fn;
	        }
	      },
	      pseudos: {
	        not: markFunction(function (selector) {
	          var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
	          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
	            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
	            while (i--) {
	              if (elem = unmatched[i]) {
	                seed[i] = !(matches[i] = elem);
	              }
	            }
	          }) : function (elem, context, xml) {
	            input[0] = elem;
	            matcher(input, null, xml, results);
	            return !results.pop();
	          };
	        }),
	        has: markFunction(function (selector) {
	          return function (elem) {
	            return Sizzle(selector, elem).length > 0;
	          };
	        }),
	        contains: markFunction(function (text) {
	          text = text.replace(runescape, funescape);
	          return function (elem) {
	            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
	          };
	        }),
	        lang: markFunction(function (lang) {
	          if (!ridentifier.test(lang || '')) {
	            Sizzle.error('unsupported lang: ' + lang);
	          }
	          lang = lang.replace(runescape, funescape).toLowerCase();
	          return function (elem) {
	            var elemLang;
	            do {
	              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
	                elemLang = elemLang.toLowerCase();
	                return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
	              }
	            } while ((elem = elem.parentNode) && elem.nodeType === 1);
	            return false;
	          };
	        }),
	        target: function (elem) {
	          var hash = domGlobals.window.location && domGlobals.window.location.hash;
	          return hash && hash.slice(1) === elem.id;
	        },
	        root: function (elem) {
	          return elem === docElem;
	        },
	        focus: function (elem) {
	          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	        },
	        enabled: function (elem) {
	          return elem.disabled === false;
	        },
	        disabled: function (elem) {
	          return elem.disabled === true;
	        },
	        checked: function (elem) {
	          var nodeName = elem.nodeName.toLowerCase();
	          return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
	        },
	        selected: function (elem) {
	          if (elem.parentNode) {
	            elem.parentNode.selectedIndex;
	          }
	          return elem.selected === true;
	        },
	        empty: function (elem) {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            if (elem.nodeType < 6) {
	              return false;
	            }
	          }
	          return true;
	        },
	        parent: function (elem) {
	          return !Expr.pseudos.empty(elem);
	        },
	        header: function (elem) {
	          return rheader.test(elem.nodeName);
	        },
	        input: function (elem) {
	          return rinputs.test(elem.nodeName);
	        },
	        button: function (elem) {
	          var name = elem.nodeName.toLowerCase();
	          return name === 'input' && elem.type === 'button' || name === 'button';
	        },
	        text: function (elem) {
	          var attr;
	          return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
	        },
	        first: createPositionalPseudo(function () {
	          return [0];
	        }),
	        last: createPositionalPseudo(function (matchIndexes, length) {
	          return [length - 1];
	        }),
	        eq: createPositionalPseudo(function (matchIndexes, length, argument) {
	          return [argument < 0 ? argument + length : argument];
	        }),
	        even: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 0;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        odd: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 1;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; --i >= 0;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; ++i < length;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        })
	      }
	    };
	    Expr.pseudos.nth = Expr.pseudos.eq;
	    for (i in {
	        radio: true,
	        checkbox: true,
	        file: true,
	        password: true,
	        image: true
	      }) {
	      Expr.pseudos[i] = createInputPseudo(i);
	    }
	    for (i in {
	        submit: true,
	        reset: true
	      }) {
	      Expr.pseudos[i] = createButtonPseudo(i);
	    }
	    function setFilters() {
	    }
	    setFilters.prototype = Expr.filters = Expr.pseudos;
	    Expr.setFilters = new setFilters();
	    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
	      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
	      if (cached) {
	        return parseOnly ? 0 : cached.slice(0);
	      }
	      soFar = selector;
	      groups = [];
	      preFilters = Expr.preFilter;
	      while (soFar) {
	        if (!matched || (match = rcomma.exec(soFar))) {
	          if (match) {
	            soFar = soFar.slice(match[0].length) || soFar;
	          }
	          groups.push(tokens = []);
	        }
	        matched = false;
	        if (match = rcombinators.exec(soFar)) {
	          matched = match.shift();
	          tokens.push({
	            value: matched,
	            type: match[0].replace(rtrim, ' ')
	          });
	          soFar = soFar.slice(matched.length);
	        }
	        for (type in Expr.filter) {
	          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
	            matched = match.shift();
	            tokens.push({
	              value: matched,
	              type: type,
	              matches: match
	            });
	            soFar = soFar.slice(matched.length);
	          }
	        }
	        if (!matched) {
	          break;
	        }
	      }
	      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
	    };
	    function toSelector(tokens) {
	      var i = 0, len = tokens.length, selector = '';
	      for (; i < len; i++) {
	        selector += tokens[i].value;
	      }
	      return selector;
	    }
	    function addCombinator(matcher, combinator, base) {
	      var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
	      return combinator.first ? function (elem, context, xml) {
	        while (elem = elem[dir]) {
	          if (elem.nodeType === 1 || checkNonElements) {
	            return matcher(elem, context, xml);
	          }
	        }
	      } : function (elem, context, xml) {
	        var oldCache, outerCache, newCache = [
	            dirruns,
	            doneName
	          ];
	        if (xml) {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              if (matcher(elem, context, xml)) {
	                return true;
	              }
	            }
	          }
	        } else {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              outerCache = elem[expando] || (elem[expando] = {});
	              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	                return newCache[2] = oldCache[2];
	              } else {
	                outerCache[dir] = newCache;
	                if (newCache[2] = matcher(elem, context, xml)) {
	                  return true;
	                }
	              }
	            }
	          }
	        }
	      };
	    }
	    function elementMatcher(matchers) {
	      return matchers.length > 1 ? function (elem, context, xml) {
	        var i = matchers.length;
	        while (i--) {
	          if (!matchers[i](elem, context, xml)) {
	            return false;
	          }
	        }
	        return true;
	      } : matchers[0];
	    }
	    function multipleContexts(selector, contexts, results) {
	      var i = 0, len = contexts.length;
	      for (; i < len; i++) {
	        Sizzle(selector, contexts[i], results);
	      }
	      return results;
	    }
	    function condense(unmatched, map, filter, context, xml) {
	      var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
	      for (; i < len; i++) {
	        if (elem = unmatched[i]) {
	          if (!filter || filter(elem, context, xml)) {
	            newUnmatched.push(elem);
	            if (mapped) {
	              map.push(i);
	            }
	          }
	        }
	      }
	      return newUnmatched;
	    }
	    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
	      if (postFilter && !postFilter[expando]) {
	        postFilter = setMatcher(postFilter);
	      }
	      if (postFinder && !postFinder[expando]) {
	        postFinder = setMatcher(postFinder, postSelector);
	      }
	      return markFunction(function (seed, results, context, xml) {
	        var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
	        if (matcher) {
	          matcher(matcherIn, matcherOut, context, xml);
	        }
	        if (postFilter) {
	          temp = condense(matcherOut, postMap);
	          postFilter(temp, [], context, xml);
	          i = temp.length;
	          while (i--) {
	            if (elem = temp[i]) {
	              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
	            }
	          }
	        }
	        if (seed) {
	          if (postFinder || preFilter) {
	            if (postFinder) {
	              temp = [];
	              i = matcherOut.length;
	              while (i--) {
	                if (elem = matcherOut[i]) {
	                  temp.push(matcherIn[i] = elem);
	                }
	              }
	              postFinder(null, matcherOut = [], temp, xml);
	            }
	            i = matcherOut.length;
	            while (i--) {
	              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf$1.call(seed, elem) : preMap[i]) > -1) {
	                seed[temp] = !(results[temp] = elem);
	              }
	            }
	          }
	        } else {
	          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
	          if (postFinder) {
	            postFinder(null, results, matcherOut, xml);
	          } else {
	            push.apply(results, matcherOut);
	          }
	        }
	      });
	    }
	    function matcherFromTokens(tokens) {
	      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
	          return elem === checkContext;
	        }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
	          return indexOf$1.call(checkContext, elem) > -1;
	        }, implicitRelative, true), matchers = [function (elem, context, xml) {
	            return !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
	          }];
	      for (; i < len; i++) {
	        if (matcher = Expr.relative[tokens[i].type]) {
	          matchers = [addCombinator(elementMatcher(matchers), matcher)];
	        } else {
	          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	          if (matcher[expando]) {
	            j = ++i;
	            for (; j < len; j++) {
	              if (Expr.relative[tokens[j].type]) {
	                break;
	              }
	            }
	            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
	          }
	          matchers.push(matcher);
	        }
	      }
	      return elementMatcher(matchers);
	    }
	    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
	      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
	          var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
	          if (outermost) {
	            outermostContext = context !== document && context;
	          }
	          for (; i !== len && (elem = elems[i]) != null; i++) {
	            if (byElement && elem) {
	              j = 0;
	              while (matcher = elementMatchers[j++]) {
	                if (matcher(elem, context, xml)) {
	                  results.push(elem);
	                  break;
	                }
	              }
	              if (outermost) {
	                dirruns = dirrunsUnique;
	              }
	            }
	            if (bySet) {
	              if (elem = !matcher && elem) {
	                matchedCount--;
	              }
	              if (seed) {
	                unmatched.push(elem);
	              }
	            }
	          }
	          matchedCount += i;
	          if (bySet && i !== matchedCount) {
	            j = 0;
	            while (matcher = setMatchers[j++]) {
	              matcher(unmatched, setMatched, context, xml);
	            }
	            if (seed) {
	              if (matchedCount > 0) {
	                while (i--) {
	                  if (!(unmatched[i] || setMatched[i])) {
	                    setMatched[i] = pop.call(results);
	                  }
	                }
	              }
	              setMatched = condense(setMatched);
	            }
	            push.apply(results, setMatched);
	            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	              Sizzle.uniqueSort(results);
	            }
	          }
	          if (outermost) {
	            dirruns = dirrunsUnique;
	            outermostContext = contextBackup;
	          }
	          return unmatched;
	        };
	      return bySet ? markFunction(superMatcher) : superMatcher;
	    }
	    compile = Sizzle.compile = function (selector, match) {
	      var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
	      if (!cached) {
	        if (!match) {
	          match = tokenize(selector);
	        }
	        i = match.length;
	        while (i--) {
	          cached = matcherFromTokens(match[i]);
	          if (cached[expando]) {
	            setMatchers.push(cached);
	          } else {
	            elementMatchers.push(cached);
	          }
	        }
	        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	        cached.selector = selector;
	      }
	      return cached;
	    };
	    select = Sizzle.select = function (selector, context, results, seed) {
	      var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
	      results = results || [];
	      if (match.length === 1) {
	        tokens = match[0] = match[0].slice(0);
	        if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
	          if (!context) {
	            return results;
	          } else if (compiled) {
	            context = context.parentNode;
	          }
	          selector = selector.slice(tokens.shift().value.length);
	        }
	        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
	        while (i--) {
	          token = tokens[i];
	          if (Expr.relative[type = token.type]) {
	            break;
	          }
	          if (find = Expr.find[type]) {
	            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	              tokens.splice(i, 1);
	              selector = seed.length && toSelector(tokens);
	              if (!selector) {
	                push.apply(results, seed);
	                return results;
	              }
	              break;
	            }
	          }
	        }
	      }
	      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
	      return results;
	    };
	    support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
	    support.detectDuplicates = !!hasDuplicate;
	    setDocument();
	    support.sortDetached = true;
	
	    var isArray$1 = Array.isArray;
	    var toArray = function (obj) {
	      var array = obj, i, l;
	      if (!isArray$1(obj)) {
	        array = [];
	        for (i = 0, l = obj.length; i < l; i++) {
	          array[i] = obj[i];
	        }
	      }
	      return array;
	    };
	    var each$1 = function (o, cb, s) {
	      var n, l;
	      if (!o) {
	        return 0;
	      }
	      s = s || o;
	      if (o.length !== undefined) {
	        for (n = 0, l = o.length; n < l; n++) {
	          if (cb.call(s, o[n], n, o) === false) {
	            return 0;
	          }
	        }
	      } else {
	        for (n in o) {
	          if (o.hasOwnProperty(n)) {
	            if (cb.call(s, o[n], n, o) === false) {
	              return 0;
	            }
	          }
	        }
	      }
	      return 1;
	    };
	    var map$1 = function (array, callback) {
	      var out = [];
	      each$1(array, function (item, index) {
	        out.push(callback(item, index, array));
	      });
	      return out;
	    };
	    var filter$1 = function (a, f) {
	      var o = [];
	      each$1(a, function (v, index) {
	        if (!f || f(v, index, a)) {
	          o.push(v);
	        }
	      });
	      return o;
	    };
	    var indexOf$2 = function (a, v) {
	      var i, l;
	      if (a) {
	        for (i = 0, l = a.length; i < l; i++) {
	          if (a[i] === v) {
	            return i;
	          }
	        }
	      }
	      return -1;
	    };
	    var reduce = function (collection, iteratee, accumulator, thisArg) {
	      var i = 0;
	      if (arguments.length < 3) {
	        accumulator = collection[0];
	      }
	      for (; i < collection.length; i++) {
	        accumulator = iteratee.call(thisArg, accumulator, collection[i], i);
	      }
	      return accumulator;
	    };
	    var findIndex$1 = function (array, predicate, thisArg) {
	      var i, l;
	      for (i = 0, l = array.length; i < l; i++) {
	        if (predicate.call(thisArg, array[i], i, array)) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var find$1 = function (array, predicate, thisArg) {
	      var idx = findIndex$1(array, predicate, thisArg);
	      if (idx !== -1) {
	        return array[idx];
	      }
	      return undefined;
	    };
	    var last$1 = function (collection) {
	      return collection[collection.length - 1];
	    };
	    var ArrUtils = {
	      isArray: isArray$1,
	      toArray: toArray,
	      each: each$1,
	      map: map$1,
	      filter: filter$1,
	      indexOf: indexOf$2,
	      reduce: reduce,
	      findIndex: findIndex$1,
	      find: find$1,
	      last: last$1
	    };
	
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	    var trim = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
	    };
	    var is = function (obj, type) {
	      if (!type) {
	        return obj !== undefined;
	      }
	      if (type === 'array' && ArrUtils.isArray(obj)) {
	        return true;
	      }
	      return typeof obj === type;
	    };
	    var makeMap = function (items, delim, map) {
	      var i;
	      items = items || [];
	      delim = delim || ',';
	      if (typeof items === 'string') {
	        items = items.split(delim);
	      }
	      map = map || {};
	      i = items.length;
	      while (i--) {
	        map[items[i]] = {};
	      }
	      return map;
	    };
	    var hasOwnProperty = function (obj, prop) {
	      return Object.prototype.hasOwnProperty.call(obj, prop);
	    };
	    var create = function (s, p, root) {
	      var self = this;
	      var sp, ns, cn, scn, c, de = 0;
	      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
	      cn = s[3].match(/(^|\.)(\w+)$/i)[2];
	      ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	      if (ns[cn]) {
	        return;
	      }
	      if (s[2] === 'static') {
	        ns[cn] = p;
	        if (this.onCreate) {
	          this.onCreate(s[2], s[3], ns[cn]);
	        }
	        return;
	      }
	      if (!p[cn]) {
	        p[cn] = function () {
	        };
	        de = 1;
	      }
	      ns[cn] = p[cn];
	      self.extend(ns[cn].prototype, p);
	      if (s[5]) {
	        sp = self.resolve(s[5]).prototype;
	        scn = s[5].match(/\.(\w+)$/i)[1];
	        c = ns[cn];
	        if (de) {
	          ns[cn] = function () {
	            return sp[scn].apply(this, arguments);
	          };
	        } else {
	          ns[cn] = function () {
	            this.parent = sp[scn];
	            return c.apply(this, arguments);
	          };
	        }
	        ns[cn].prototype[cn] = ns[cn];
	        self.each(sp, function (f, n) {
	          ns[cn].prototype[n] = sp[n];
	        });
	        self.each(p, function (f, n) {
	          if (sp[n]) {
	            ns[cn].prototype[n] = function () {
	              this.parent = sp[n];
	              return f.apply(this, arguments);
	            };
	          } else {
	            if (n !== cn) {
	              ns[cn].prototype[n] = f;
	            }
	          }
	        });
	      }
	      self.each(p.static, function (f, n) {
	        ns[cn][n] = f;
	      });
	    };
	    var extend = function (obj, ext) {
	      var x = [];
	      for (var _i = 2; _i < arguments.length; _i++) {
	        x[_i - 2] = arguments[_i];
	      }
	      var i, l, name;
	      var args = arguments;
	      var value;
	      for (i = 1, l = args.length; i < l; i++) {
	        ext = args[i];
	        for (name in ext) {
	          if (ext.hasOwnProperty(name)) {
	            value = ext[name];
	            if (value !== undefined) {
	              obj[name] = value;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var walk = function (o, f, n, s) {
	      s = s || this;
	      if (o) {
	        if (n) {
	          o = o[n];
	        }
	        ArrUtils.each(o, function (o, i) {
	          if (f.call(s, o, i, n) === false) {
	            return false;
	          }
	          walk(o, f, n, s);
	        });
	      }
	    };
	    var createNS = function (n, o) {
	      var i, v;
	      o = o || domGlobals.window;
	      n = n.split('.');
	      for (i = 0; i < n.length; i++) {
	        v = n[i];
	        if (!o[v]) {
	          o[v] = {};
	        }
	        o = o[v];
	      }
	      return o;
	    };
	    var resolve$1 = function (n, o) {
	      var i, l;
	      o = o || domGlobals.window;
	      n = n.split('.');
	      for (i = 0, l = n.length; i < l; i++) {
	        o = o[n[i]];
	        if (!o) {
	          break;
	        }
	      }
	      return o;
	    };
	    var explode = function (s, d) {
	      if (!s || is(s, 'array')) {
	        return s;
	      }
	      return ArrUtils.map(s.split(d || ','), trim);
	    };
	    var _addCacheSuffix = function (url) {
	      var cacheSuffix = Env.cacheSuffix;
	      if (cacheSuffix) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
	      }
	      return url;
	    };
	    var Tools = {
	      trim: trim,
	      isArray: ArrUtils.isArray,
	      is: is,
	      toArray: ArrUtils.toArray,
	      makeMap: makeMap,
	      each: ArrUtils.each,
	      map: ArrUtils.map,
	      grep: ArrUtils.filter,
	      inArray: ArrUtils.indexOf,
	      hasOwn: hasOwnProperty,
	      extend: extend,
	      create: create,
	      walk: walk,
	      createNS: createNS,
	      resolve: resolve$1,
	      explode: explode,
	      _addCacheSuffix: _addCacheSuffix
	    };
	
	    var doc = domGlobals.document, push$1 = Array.prototype.push, slice$1 = Array.prototype.slice;
	    var rquickExpr$1 = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	    var Event = EventUtils.Event;
	    var skipUniques = Tools.makeMap('children,contents,next,prev');
	    var isDefined = function (obj) {
	      return typeof obj !== 'undefined';
	    };
	    var isString$1 = function (obj) {
	      return typeof obj === 'string';
	    };
	    var isWindow = function (obj) {
	      return obj && obj === obj.window;
	    };
	    var createFragment = function (html, fragDoc) {
	      var frag, node, container;
	      fragDoc = fragDoc || doc;
	      container = fragDoc.createElement('div');
	      frag = fragDoc.createDocumentFragment();
	      container.innerHTML = html;
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
	      var i;
	      if (isString$1(sourceItem)) {
	        sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
	      } else if (sourceItem.length && !sourceItem.nodeType) {
	        sourceItem = DomQuery.makeArray(sourceItem);
	        if (reverse) {
	          for (i = sourceItem.length - 1; i >= 0; i--) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        } else {
	          for (i = 0; i < sourceItem.length; i++) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        }
	        return targetNodes;
	      }
	      if (sourceItem.nodeType) {
	        i = targetNodes.length;
	        while (i--) {
	          callback.call(targetNodes[i], sourceItem);
	        }
	      }
	      return targetNodes;
	    };
	    var hasClass = function (node, className) {
	      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    };
	    var wrap = function (elements, wrapper, all) {
	      var lastParent, newWrapper;
	      wrapper = DomQuery(wrapper)[0];
	      elements.each(function () {
	        var self = this;
	        if (!all || lastParent !== self.parentNode) {
	          lastParent = self.parentNode;
	          newWrapper = wrapper.cloneNode(false);
	          self.parentNode.insertBefore(newWrapper, self);
	          newWrapper.appendChild(self);
	        } else {
	          newWrapper.appendChild(self);
	        }
	      });
	      return elements;
	    };
	    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
	    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
	    var propFix = {
	      for: 'htmlFor',
	      class: 'className',
	      readonly: 'readOnly'
	    };
	    var cssFix = { float: 'cssFloat' };
	    var attrHooks = {}, cssHooks = {};
	    var DomQuery = function (selector, context) {
	      return new DomQuery.fn.init(selector, context);
	    };
	    var inArray = function (item, array) {
	      var i;
	      if (array.indexOf) {
	        return array.indexOf(item);
	      }
	      i = array.length;
	      while (i--) {
	        if (array[i] === item) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var whiteSpaceRegExp$1 = /^\s*|\s*$/g;
	    var trim$1 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$1, '');
	    };
	    var each$2 = function (obj, callback) {
	      var length, key, i, value;
	      if (obj) {
	        length = obj.length;
	        if (length === undefined) {
	          for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	              value = obj[key];
	              if (callback.call(value, key, value) === false) {
	                break;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < length; i++) {
	            value = obj[i];
	            if (callback.call(value, i, value) === false) {
	              break;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var grep = function (array, callback) {
	      var out = [];
	      each$2(array, function (i, item) {
	        if (callback(item, i)) {
	          out.push(item);
	        }
	      });
	      return out;
	    };
	    var getElementDocument = function (element) {
	      if (!element) {
	        return doc;
	      }
	      if (element.nodeType === 9) {
	        return element;
	      }
	      return element.ownerDocument;
	    };
	    DomQuery.fn = DomQuery.prototype = {
	      constructor: DomQuery,
	      selector: '',
	      context: null,
	      length: 0,
	      init: function (selector, context) {
	        var self = this;
	        var match, node;
	        if (!selector) {
	          return self;
	        }
	        if (selector.nodeType) {
	          self.context = self[0] = selector;
	          self.length = 1;
	          return self;
	        }
	        if (context && context.nodeType) {
	          self.context = context;
	        } else {
	          if (context) {
	            return DomQuery(selector).attr(context);
	          }
	          self.context = context = domGlobals.document;
	        }
	        if (isString$1(selector)) {
	          self.selector = selector;
	          if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
	            match = [
	              null,
	              selector,
	              null
	            ];
	          } else {
	            match = rquickExpr$1.exec(selector);
	          }
	          if (match) {
	            if (match[1]) {
	              node = createFragment(selector, getElementDocument(context)).firstChild;
	              while (node) {
	                push$1.call(self, node);
	                node = node.nextSibling;
	              }
	            } else {
	              node = getElementDocument(context).getElementById(match[2]);
	              if (!node) {
	                return self;
	              }
	              if (node.id !== match[2]) {
	                return self.find(selector);
	              }
	              self.length = 1;
	              self[0] = node;
	            }
	          } else {
	            return DomQuery(context).find(selector);
	          }
	        } else {
	          this.add(selector, false);
	        }
	        return self;
	      },
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	      add: function (items, sort) {
	        var self = this;
	        var nodes, i;
	        if (isString$1(items)) {
	          return self.add(DomQuery(items));
	        }
	        if (sort !== false) {
	          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
	          self.length = nodes.length;
	          for (i = 0; i < nodes.length; i++) {
	            self[i] = nodes[i];
	          }
	        } else {
	          push$1.apply(self, DomQuery.makeArray(items));
	        }
	        return self;
	      },
	      attr: function (name, value) {
	        var self = this;
	        var hook;
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.attr(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            var hook;
	            if (this.nodeType === 1) {
	              hook = attrHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              if (value === null) {
	                this.removeAttribute(name, 2);
	              } else {
	                this.setAttribute(name, value, 2);
	              }
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType === 1) {
	            hook = attrHooks[name];
	            if (hook && hook.get) {
	              return hook.get(self[0], name);
	            }
	            if (booleanMap[name]) {
	              return self.prop(name) ? name : undefined;
	            }
	            value = self[0].getAttribute(name, 2);
	            if (value === null) {
	              value = undefined;
	            }
	          }
	          return value;
	        }
	        return self;
	      },
	      removeAttr: function (name) {
	        return this.attr(name, null);
	      },
	      prop: function (name, value) {
	        var self = this;
	        name = propFix[name] || name;
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.prop(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            if (this.nodeType === 1) {
	              this[name] = value;
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType && name in self[0]) {
	            return self[0][name];
	          }
	          return value;
	        }
	        return self;
	      },
	      css: function (name, value) {
	        var self = this;
	        var elm, hook;
	        var camel = function (name) {
	          return name.replace(/-(\D)/g, function (a, b) {
	            return b.toUpperCase();
	          });
	        };
	        var dashed = function (name) {
	          return name.replace(/[A-Z]/g, function (a) {
	            return '-' + a;
	          });
	        };
	        if (typeof name === 'object') {
	          each$2(name, function (name, value) {
	            self.css(name, value);
	          });
	        } else {
	          if (isDefined(value)) {
	            name = camel(name);
	            if (typeof value === 'number' && !numericCssMap[name]) {
	              value = value.toString() + 'px';
	            }
	            self.each(function () {
	              var style = this.style;
	              hook = cssHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              try {
	                this.style[cssFix[name] || name] = value;
	              } catch (ex) {
	              }
	              if (value === null || value === '') {
	                if (style.removeProperty) {
	                  style.removeProperty(dashed(name));
	                } else {
	                  style.removeAttribute(name);
	                }
	              }
	            });
	          } else {
	            elm = self[0];
	            hook = cssHooks[name];
	            if (hook && hook.get) {
	              return hook.get(elm);
	            }
	            if (elm.ownerDocument.defaultView) {
	              try {
	                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
	              } catch (ex) {
	                return undefined;
	              }
	            } else if (elm.currentStyle) {
	              return elm.currentStyle[camel(name)];
	            } else {
	              return '';
	            }
	          }
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          Event.clean(node);
	          if (node.parentNode) {
	            node.parentNode.removeChild(node);
	          }
	        }
	        return this;
	      },
	      empty: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          while (node.firstChild) {
	            node.removeChild(node.firstChild);
	          }
	        }
	        return this;
	      },
	      html: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          try {
	            while (i--) {
	              self[i].innerHTML = value;
	            }
	          } catch (ex) {
	            DomQuery(self[i]).empty().append(value);
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerHTML : '';
	      },
	      text: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          while (i--) {
	            if ('innerText' in self[i]) {
	              self[i].innerText = value;
	            } else {
	              self[0].textContent = value;
	            }
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerText || self[0].textContent : '';
	      },
	      append: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.appendChild(node);
	          }
	        });
	      },
	      prepend: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.insertBefore(node, this.firstChild);
	          }
	        }, true);
	      },
	      before: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this);
	          });
	        }
	        return self;
	      },
	      after: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this.nextSibling);
	          }, true);
	        }
	        return self;
	      },
	      appendTo: function (val) {
	        DomQuery(val).append(this);
	        return this;
	      },
	      prependTo: function (val) {
	        DomQuery(val).prepend(this);
	        return this;
	      },
	      replaceWith: function (content) {
	        return this.before(content).remove();
	      },
	      wrap: function (content) {
	        return wrap(this, content);
	      },
	      wrapAll: function (content) {
	        return wrap(this, content, true);
	      },
	      wrapInner: function (content) {
	        this.each(function () {
	          DomQuery(this).contents().wrapAll(content);
	        });
	        return this;
	      },
	      unwrap: function () {
	        return this.parent().each(function () {
	          DomQuery(this).replaceWith(this.childNodes);
	        });
	      },
	      clone: function () {
	        var result = [];
	        this.each(function () {
	          result.push(this.cloneNode(true));
	        });
	        return DomQuery(result);
	      },
	      addClass: function (className) {
	        return this.toggleClass(className, true);
	      },
	      removeClass: function (className) {
	        return this.toggleClass(className, false);
	      },
	      toggleClass: function (className, state) {
	        var self = this;
	        if (typeof className !== 'string') {
	          return self;
	        }
	        if (className.indexOf(' ') !== -1) {
	          each$2(className.split(' '), function () {
	            self.toggleClass(this, state);
	          });
	        } else {
	          self.each(function (index, node) {
	            var existingClassName, classState;
	            classState = hasClass(node, className);
	            if (classState !== state) {
	              existingClassName = node.className;
	              if (classState) {
	                node.className = trim$1((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
	              } else {
	                node.className += existingClassName ? ' ' + className : className;
	              }
	            }
	          });
	        }
	        return self;
	      },
	      hasClass: function (className) {
	        return hasClass(this[0], className);
	      },
	      each: function (callback) {
	        return each$2(this, callback);
	      },
	      on: function (name, callback) {
	        return this.each(function () {
	          Event.bind(this, name, callback);
	        });
	      },
	      off: function (name, callback) {
	        return this.each(function () {
	          Event.unbind(this, name, callback);
	        });
	      },
	      trigger: function (name) {
	        return this.each(function () {
	          if (typeof name === 'object') {
	            Event.fire(this, name.type, name);
	          } else {
	            Event.fire(this, name);
	          }
	        });
	      },
	      show: function () {
	        return this.css('display', '');
	      },
	      hide: function () {
	        return this.css('display', 'none');
	      },
	      slice: function () {
	        return new DomQuery(slice$1.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      first: function () {
	        return this.eq(0);
	      },
	      last: function () {
	        return this.eq(-1);
	      },
	      find: function (selector) {
	        var i, l;
	        var ret = [];
	        for (i = 0, l = this.length; i < l; i++) {
	          DomQuery.find(selector, this[i], ret);
	        }
	        return DomQuery(ret);
	      },
	      filter: function (selector) {
	        if (typeof selector === 'function') {
	          return DomQuery(grep(this.toArray(), function (item, i) {
	            return selector(i, item);
	          }));
	        }
	        return DomQuery(DomQuery.filter(selector, this.toArray()));
	      },
	      closest: function (selector) {
	        var result = [];
	        if (selector instanceof DomQuery) {
	          selector = selector[0];
	        }
	        this.each(function (i, node) {
	          while (node) {
	            if (typeof selector === 'string' && DomQuery(node).is(selector)) {
	              result.push(node);
	              break;
	            } else if (node === selector) {
	              result.push(node);
	              break;
	            }
	            node = node.parentNode;
	          }
	        });
	        return DomQuery(result);
	      },
	      offset: function (offset) {
	        var elm, doc, docElm;
	        var x = 0, y = 0, pos;
	        if (!offset) {
	          elm = this[0];
	          if (elm) {
	            doc = elm.ownerDocument;
	            docElm = doc.documentElement;
	            if (elm.getBoundingClientRect) {
	              pos = elm.getBoundingClientRect();
	              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
	              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
	            }
	          }
	          return {
	            left: x,
	            top: y
	          };
	        }
	        return this.css(offset);
	      },
	      push: push$1,
	      sort: [].sort,
	      splice: [].splice
	    };
	    Tools.extend(DomQuery, {
	      extend: Tools.extend,
	      makeArray: function (object) {
	        if (isWindow(object) || object.nodeType) {
	          return [object];
	        }
	        return Tools.toArray(object);
	      },
	      inArray: inArray,
	      isArray: Tools.isArray,
	      each: each$2,
	      trim: trim$1,
	      grep: grep,
	      find: Sizzle,
	      expr: Sizzle.selectors,
	      unique: Sizzle.uniqueSort,
	      text: Sizzle.getText,
	      contains: Sizzle.contains,
	      filter: function (expr, elems, not) {
	        var i = elems.length;
	        if (not) {
	          expr = ':not(' + expr + ')';
	        }
	        while (i--) {
	          if (elems[i].nodeType !== 1) {
	            elems.splice(i, 1);
	          }
	        }
	        if (elems.length === 1) {
	          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
	        } else {
	          elems = DomQuery.find.matches(expr, elems);
	        }
	        return elems;
	      }
	    });
	    var dir = function (el, prop, until) {
	      var matched = [];
	      var cur = el[prop];
	      if (typeof until !== 'string' && until instanceof DomQuery) {
	        until = until[0];
	      }
	      while (cur && cur.nodeType !== 9) {
	        if (until !== undefined) {
	          if (cur === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(cur).is(until)) {
	            break;
	          }
	        }
	        if (cur.nodeType === 1) {
	          matched.push(cur);
	        }
	        cur = cur[prop];
	      }
	      return matched;
	    };
	    var sibling = function (node, siblingName, nodeType, until) {
	      var result = [];
	      if (until instanceof DomQuery) {
	        until = until[0];
	      }
	      for (; node; node = node[siblingName]) {
	        if (nodeType && node.nodeType !== nodeType) {
	          continue;
	        }
	        if (until !== undefined) {
	          if (node === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(node).is(until)) {
	            break;
	          }
	        }
	        result.push(node);
	      }
	      return result;
	    };
	    var firstSibling = function (node, siblingName, nodeType) {
	      for (node = node[siblingName]; node; node = node[siblingName]) {
	        if (node.nodeType === nodeType) {
	          return node;
	        }
	      }
	      return null;
	    };
	    each$2({
	      parent: function (node) {
	        var parent = node.parentNode;
	        return parent && parent.nodeType !== 11 ? parent : null;
	      },
	      parents: function (node) {
	        return dir(node, 'parentNode');
	      },
	      next: function (node) {
	        return firstSibling(node, 'nextSibling', 1);
	      },
	      prev: function (node) {
	        return firstSibling(node, 'previousSibling', 1);
	      },
	      children: function (node) {
	        return sibling(node.firstChild, 'nextSibling', 1);
	      },
	      contents: function (node) {
	        return Tools.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          if (!skipUniques[name]) {
	            result = DomQuery.unique(result);
	          }
	          if (name.indexOf('parents') === 0) {
	            result = result.reverse();
	          }
	        }
	        result = DomQuery(result);
	        if (selector) {
	          return result.filter(selector);
	        }
	        return result;
	      };
	    });
	    each$2({
	      parentsUntil: function (node, until) {
	        return dir(node, 'parentNode', until);
	      },
	      nextUntil: function (node, until) {
	        return sibling(node, 'nextSibling', 1, until).slice(1);
	      },
	      prevUntil: function (node, until) {
	        return sibling(node, 'previousSibling', 1, until).slice(1);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector, filter) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          result = DomQuery.unique(result);
	          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
	            result = result.reverse();
	          }
	        }
	        result = DomQuery(result);
	        if (filter) {
	          return result.filter(filter);
	        }
	        return result;
	      };
	    });
	    DomQuery.fn.is = function (selector) {
	      return !!selector && this.filter(selector).length > 0;
	    };
	    DomQuery.fn.init.prototype = DomQuery.fn;
	    DomQuery.overrideDefaults = function (callback) {
	      var defaults;
	      var sub = function (selector, context) {
	        defaults = defaults || callback();
	        if (arguments.length === 0) {
	          selector = defaults.element;
	        }
	        if (!context) {
	          context = defaults.context;
	        }
	        return new sub.fn.init(selector, context);
	      };
	      DomQuery.extend(sub, this);
	      return sub;
	    };
	    var appendHooks = function (targetHooks, prop, hooks) {
	      each$2(hooks, function (name, func) {
	        targetHooks[name] = targetHooks[name] || {};
	        targetHooks[name][prop] = func;
	      });
	    };
	    if (Env.ie && Env.ie < 8) {
	      appendHooks(attrHooks, 'get', {
	        maxlength: function (elm) {
	          var value = elm.maxLength;
	          if (value === 2147483647) {
	            return undefined;
	          }
	          return value;
	        },
	        size: function (elm) {
	          var value = elm.size;
	          if (value === 20) {
	            return undefined;
	          }
	          return value;
	        },
	        class: function (elm) {
	          return elm.className;
	        },
	        style: function (elm) {
	          var value = elm.style.cssText;
	          if (value.length === 0) {
	            return undefined;
	          }
	          return value;
	        }
	      });
	      appendHooks(attrHooks, 'set', {
	        class: function (elm, value) {
	          elm.className = value;
	        },
	        style: function (elm, value) {
	          elm.style.cssText = value;
	        }
	      });
	    }
	    if (Env.ie && Env.ie < 9) {
	      cssFix.float = 'styleFloat';
	      appendHooks(cssHooks, 'set', {
	        opacity: function (elm, value) {
	          var style = elm.style;
	          if (value === null || value === '') {
	            style.removeAttribute('filter');
	          } else {
	            style.zoom = 1;
	            style.filter = 'alpha(opacity=' + value * 100 + ')';
	          }
	        }
	      });
	    }
	    DomQuery.attrHooks = attrHooks;
	    DomQuery.cssHooks = cssHooks;
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$2 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$2(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie$1 = 'IE';
	    var opera$1 = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie$1, current),
	        isOpera: isBrowser(opera$1, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie$1),
	      opera: constant(opera$1),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android$1 = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android$1, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android$1),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains$2 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var trim$2 = function (str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    };
	    var lTrim = function (str) {
	      return str.replace(/^\s+/g, '');
	    };
	    var rTrim = function (str) {
	      return str.replace(/\s+$/g, '');
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$2(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$2(uastring, 'edge/') && contains$2(uastring, 'chrome') && contains$2(uastring, 'safari') && contains$2(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'chrome') && !contains$2(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$2(uastring, 'msie') || contains$2(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$2(uastring, 'safari') || contains$2(uastring, 'mobile/')) && contains$2(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$2(uastring, 'iphone') || contains$2(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	
	    var keys = Object.keys;
	    var hasOwnProperty$1 = Object.hasOwnProperty;
	    var each$3 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$2 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$3(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      each$3(obj, function (x, i) {
	        var branch = pred(x, i) ? t : f;
	        branch[i] = x;
	      });
	      return {
	        t: t,
	        f: f
	      };
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty$1.call(obj, key);
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom().parentNode : element.dom();
	      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        domGlobals.console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom(), key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      each$3(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get = function (element, key) {
	      var v = element.dom().getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom();
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove = function (element, key) {
	      element.dom().removeAttribute(key);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        domGlobals.console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom();
	      each$3(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$1 = function (element, property) {
	      var dom = element.dom();
	      var styles = domGlobals.window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      var v = r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	      return v === null ? undefined : v;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom();
	      var raw = getUnsafeProperty(dom, property);
	      return Option.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom();
	      if (isSupported(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var toArray$1 = function (target, f) {
	      var r = [];
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	      return r;
	    };
	    var Recurse = { toArray: toArray$1 };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var ELEMENT$1 = ELEMENT;
	    var DOCUMENT$1 = DOCUMENT;
	    var is$1 = function (element, selector) {
	      var dom = element.dom();
	      if (dom.nodeType !== ELEMENT$1) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT$1 && dom.nodeType !== DOCUMENT$1 || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$3 = browser.isIE() ? ieContains : regularContains;
	
	    var owner = function (element) {
	      return Element.fromDom(element.dom().ownerDocument);
	    };
	    var documentElement = function (element) {
	      return Element.fromDom(element.dom().ownerDocument.documentElement);
	    };
	    var defaultView = function (element) {
	      return Element.fromDom(element.dom().ownerDocument.defaultView);
	    };
	    var parent = function (element) {
	      return Option.from(element.dom().parentNode).map(Element.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom();
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = Element.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var prevSibling = function (element) {
	      return Option.from(element.dom().previousSibling).map(Element.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Option.from(element.dom().nextSibling).map(Element.fromDom);
	    };
	    var prevSiblings = function (element) {
	      return reverse(Recurse.toArray(element, prevSibling));
	    };
	    var nextSiblings = function (element) {
	      return Recurse.toArray(element, nextSibling);
	    };
	    var children = function (element) {
	      return map(element.dom().childNodes, Element.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom().childNodes;
	      return Option.from(cs[index]).map(Element.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	    var childNodesCount = function (element) {
	      return element.dom().childNodes.length;
	    };
	    var spot = Immutable('element', 'offset');
	
	    var browser$1 = PlatformDetection$1.detect().browser;
	    var firstElement = function (nodes) {
	      return find(nodes, isElement);
	    };
	    var getTableCaptionDeltaY = function (elm) {
	      if (browser$1.isFirefox() && name(elm) === 'table') {
	        return firstElement(children(elm)).filter(function (elm) {
	          return name(elm) === 'caption';
	        }).bind(function (caption) {
	          return firstElement(nextSiblings(caption)).map(function (body) {
	            var bodyTop = body.dom().offsetTop;
	            var captionTop = caption.dom().offsetTop;
	            var captionHeight = caption.dom().offsetHeight;
	            return bodyTop <= captionTop ? -captionHeight : 0;
	          });
	        }).getOr(0);
	      } else {
	        return 0;
	      }
	    };
	    var getPos = function (body, elm, rootElm) {
	      var x = 0, y = 0, offsetParent;
	      var doc = body.ownerDocument;
	      var pos;
	      rootElm = rootElm ? rootElm : body;
	      if (elm) {
	        if (rootElm === body && elm.getBoundingClientRect && get$1(Element.fromDom(body), 'position') === 'static') {
	          pos = elm.getBoundingClientRect();
	          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
	          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
	          return {
	            x: x,
	            y: y
	          };
	        }
	        offsetParent = elm;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x += offsetParent.offsetLeft || 0;
	          y += offsetParent.offsetTop || 0;
	          offsetParent = offsetParent.offsetParent;
	        }
	        offsetParent = elm.parentNode;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x -= offsetParent.scrollLeft || 0;
	          y -= offsetParent.scrollTop || 0;
	          offsetParent = offsetParent.parentNode;
	        }
	        y += getTableCaptionDeltaY(Element.fromDom(elm));
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var Position = { getPos: getPos };
	
	    var exports$1 = {}, module$1 = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module$1, undefined));
	    var Promise = module$1.exports.boltExport;
	
	    var nu$3 = function (baseFn) {
	      var data = Option.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$3(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        data = Option.some(x);
	        run(callbacks);
	        callbacks = [];
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          domGlobals.setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu$3(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$3,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      domGlobals.setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$4 = function (baseFn) {
	      return make(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$4,
	      pure: pure$1
	    };
	
	    var par = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par$1 = function (futures) {
	      return par(futures, Future.nu);
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (opt) {
	        return value(o);
	      };
	      var orThunk = function (f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOption = function () {
	        return Option.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOption: toOption
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOption: Option.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    function StyleSheetLoader(document, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var idCount = 0;
	      var loadedStates = {};
	      var maxLoadTime;
	      maxLoadTime = settings.maxLoadTime || 5000;
	      var appendToHead = function (node) {
	        document.getElementsByTagName('head')[0].appendChild(node);
	      };
	      var load = function (url, loadedCallback, errorCallback) {
	        var link, style, startTime, state;
	        var passed = function () {
	          var callbacks = state.passed;
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = 2;
	          state.passed = [];
	          state.failed = [];
	        };
	        var failed = function () {
	          var callbacks = state.failed;
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = 3;
	          state.passed = [];
	          state.failed = [];
	        };
	        var isOldWebKit = function () {
	          var webKitChunks = domGlobals.navigator.userAgent.match(/WebKit\/(\d*)/);
	          return !!(webKitChunks && parseInt(webKitChunks[1], 10) < 536);
	        };
	        var wait = function (testCallback, waitCallback) {
	          if (!testCallback()) {
	            if (new Date().getTime() - startTime < maxLoadTime) {
	              Delay.setTimeout(waitCallback);
	            } else {
	              failed();
	            }
	          }
	        };
	        var waitForWebKitLinkLoaded = function () {
	          wait(function () {
	            var styleSheets = document.styleSheets;
	            var styleSheet, i = styleSheets.length, owner;
	            while (i--) {
	              styleSheet = styleSheets[i];
	              owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
	              if (owner && owner.id === link.id) {
	                passed();
	                return true;
	              }
	            }
	          }, waitForWebKitLinkLoaded);
	        };
	        var waitForGeckoLinkLoaded = function () {
	          wait(function () {
	            try {
	              var cssRules = style.sheet.cssRules;
	              passed();
	              return !!cssRules;
	            } catch (ex) {
	            }
	          }, waitForGeckoLinkLoaded);
	        };
	        url = Tools._addCacheSuffix(url);
	        if (!loadedStates[url]) {
	          state = {
	            passed: [],
	            failed: []
	          };
	          loadedStates[url] = state;
	        } else {
	          state = loadedStates[url];
	        }
	        if (loadedCallback) {
	          state.passed.push(loadedCallback);
	        }
	        if (errorCallback) {
	          state.failed.push(errorCallback);
	        }
	        if (state.status === 1) {
	          return;
	        }
	        if (state.status === 2) {
	          passed();
	          return;
	        }
	        if (state.status === 3) {
	          failed();
	          return;
	        }
	        state.status = 1;
	        link = document.createElement('link');
	        link.rel = 'stylesheet';
	        link.type = 'text/css';
	        link.id = 'u' + idCount++;
	        link.async = false;
	        link.defer = false;
	        startTime = new Date().getTime();
	        if (settings.contentCssCors) {
	          link.crossOrigin = 'anonymous';
	        }
	        if ('onload' in link && !isOldWebKit()) {
	          link.onload = waitForWebKitLinkLoaded;
	          link.onerror = failed;
	        } else {
	          if (domGlobals.navigator.userAgent.indexOf('Firefox') > 0) {
	            style = document.createElement('style');
	            style.textContent = '@import "' + url + '"';
	            waitForGeckoLinkLoaded();
	            appendToHead(style);
	            return;
	          }
	          waitForWebKitLinkLoaded();
	        }
	        appendToHead(link);
	        link.href = url;
	      };
	      var loadF = function (url) {
	        return Future.nu(function (resolve) {
	          load(url, compose(resolve, constant(Result.value(url))), compose(resolve, constant(Result.error(url))));
	        });
	      };
	      var unbox = function (result) {
	        return result.fold(identity, identity);
	      };
	      var loadAll = function (urls, success, failure) {
	        par$1(map(urls, loadF)).get(function (result) {
	          var parts = partition(result, function (r) {
	            return r.isValue();
	          });
	          if (parts.fail.length > 0) {
	            failure(parts.fail.map(unbox));
	          } else {
	            success(parts.pass.map(unbox));
	          }
	        });
	      };
	      return {
	        load: load,
	        loadAll: loadAll
	      };
	    }
	
	    function TreeWalker (startNode, rootNode) {
	      var node = startNode;
	      var findSibling = function (node, startName, siblingName, shallow) {
	        var sibling, parent;
	        if (node) {
	          if (!shallow && node[startName]) {
	            return node[startName];
	          }
	          if (node !== rootNode) {
	            sibling = node[siblingName];
	            if (sibling) {
	              return sibling;
	            }
	            for (parent = node.parentNode; parent && parent !== rootNode; parent = parent.parentNode) {
	              sibling = parent[siblingName];
	              if (sibling) {
	                return sibling;
	              }
	            }
	          }
	        }
	      };
	      var findPreviousNode = function (node, startName, siblingName, shallow) {
	        var sibling, parent, child;
	        if (node) {
	          sibling = node[siblingName];
	          if (rootNode && sibling === rootNode) {
	            return;
	          }
	          if (sibling) {
	            if (!shallow) {
	              for (child = sibling[startName]; child; child = child[startName]) {
	                if (!child[startName]) {
	                  return child;
	                }
	              }
	            }
	            return sibling;
	          }
	          parent = node.parentNode;
	          if (parent && parent !== rootNode) {
	            return parent;
	          }
	        }
	      };
	      this.current = function () {
	        return node;
	      };
	      this.next = function (shallow) {
	        node = findSibling(node, 'firstChild', 'nextSibling', shallow);
	        return node;
	      };
	      this.prev = function (shallow) {
	        node = findSibling(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	      this.prev2 = function (shallow) {
	        node = findPreviousNode(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	    }
	
	    var blocks = [
	      'article',
	      'aside',
	      'details',
	      'div',
	      'dt',
	      'figcaption',
	      'footer',
	      'form',
	      'fieldset',
	      'header',
	      'hgroup',
	      'html',
	      'main',
	      'nav',
	      'section',
	      'summary',
	      'body',
	      'p',
	      'dl',
	      'multicol',
	      'dd',
	      'figure',
	      'address',
	      'center',
	      'blockquote',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'listing',
	      'xmp',
	      'pre',
	      'plaintext',
	      'menu',
	      'dir',
	      'ul',
	      'ol',
	      'li',
	      'hr',
	      'table',
	      'tbody',
	      'thead',
	      'tfoot',
	      'th',
	      'tr',
	      'td',
	      'caption'
	    ];
	    var voids = [
	      'area',
	      'base',
	      'basefont',
	      'br',
	      'col',
	      'frame',
	      'hr',
	      'img',
	      'input',
	      'isindex',
	      'link',
	      'meta',
	      'param',
	      'embed',
	      'source',
	      'wbr',
	      'track'
	    ];
	    var tableCells = [
	      'td',
	      'th'
	    ];
	    var tableSections = [
	      'thead',
	      'tbody',
	      'tfoot'
	    ];
	    var textBlocks = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'p',
	      'div',
	      'address',
	      'pre',
	      'form',
	      'blockquote',
	      'center',
	      'dir',
	      'fieldset',
	      'header',
	      'footer',
	      'article',
	      'section',
	      'hgroup',
	      'aside',
	      'nav',
	      'figure'
	    ];
	    var headings = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6'
	    ];
	    var listItems = [
	      'li',
	      'dd',
	      'dt'
	    ];
	    var lists = [
	      'ul',
	      'ol',
	      'dl'
	    ];
	    var wsElements = [
	      'pre',
	      'script',
	      'textarea',
	      'style'
	    ];
	    var lazyLookup = function (items) {
	      var lookup;
	      return function (node) {
	        lookup = lookup ? lookup : mapToObject(items, constant(true));
	        return lookup.hasOwnProperty(name(node));
	      };
	    };
	    var isHeading = lazyLookup(headings);
	    var isBlock = lazyLookup(blocks);
	    var isInline = function (node) {
	      return isElement(node) && !isBlock(node);
	    };
	    var isBr = function (node) {
	      return isElement(node) && name(node) === 'br';
	    };
	    var isTextBlock = lazyLookup(textBlocks);
	    var isList = lazyLookup(lists);
	    var isListItem = lazyLookup(listItems);
	    var isVoid = lazyLookup(voids);
	    var isTableSection = lazyLookup(tableSections);
	    var isTableCell = lazyLookup(tableCells);
	    var isWsPreserveElement = lazyLookup(wsElements);
	
	    var isNodeType = function (type) {
	      return function (node) {
	        return !!node && node.nodeType === type;
	      };
	    };
	    var isRestrictedNode = function (node) {
	      return !!node && !Object.getPrototypeOf(node);
	    };
	    var isElement$1 = isNodeType(1);
	    var matchNodeNames = function (names) {
	      var items = names.toLowerCase().split(' ');
	      return function (node) {
	        var i, name;
	        if (node && node.nodeType) {
	          name = node.nodeName.toLowerCase();
	          for (i = 0; i < items.length; i++) {
	            if (name === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var matchStyleValues = function (name, values) {
	      var items = values.toLowerCase().split(' ');
	      return function (node) {
	        var i, cssValue;
	        if (isElement$1(node)) {
	          for (i = 0; i < items.length; i++) {
	            var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
	            cssValue = computed ? computed.getPropertyValue(name) : null;
	            if (cssValue === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var hasPropValue = function (propName, propValue) {
	      return function (node) {
	        return isElement$1(node) && node[propName] === propValue;
	      };
	    };
	    var hasAttribute = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$1(node) && node.hasAttribute(attrName);
	      };
	    };
	    var hasAttributeValue = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$1(node) && node.getAttribute(attrName) === attrValue;
	      };
	    };
	    var isBogus = function (node) {
	      return isElement$1(node) && node.hasAttribute('data-mce-bogus');
	    };
	    var isBogusAll = function (node) {
	      return isElement$1(node) && node.getAttribute('data-mce-bogus') === 'all';
	    };
	    var isTable = function (node) {
	      return isElement$1(node) && node.tagName === 'TABLE';
	    };
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement$1(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isText$1 = isNodeType(3);
	    var isComment = isNodeType(8);
	    var isDocument = isNodeType(9);
	    var isDocumentFragment = isNodeType(11);
	    var isBr$1 = matchNodeNames('br');
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var NodeType = {
	      isText: isText$1,
	      isElement: isElement$1,
	      isComment: isComment,
	      isDocument: isDocument,
	      isDocumentFragment: isDocumentFragment,
	      isBr: isBr$1,
	      isContentEditableTrue: isContentEditableTrue,
	      isContentEditableFalse: isContentEditableFalse,
	      isRestrictedNode: isRestrictedNode,
	      matchNodeNames: matchNodeNames,
	      hasPropValue: hasPropValue,
	      hasAttribute: hasAttribute,
	      hasAttributeValue: hasAttributeValue,
	      matchStyleValues: matchStyleValues,
	      isBogus: isBogus,
	      isBogusAll: isBogusAll,
	      isTable: isTable
	    };
	
	    var surroundedBySpans = function (node) {
	      var previousIsSpan = node.previousSibling && node.previousSibling.nodeName === 'SPAN';
	      var nextIsSpan = node.nextSibling && node.nextSibling.nodeName === 'SPAN';
	      return previousIsSpan && nextIsSpan;
	    };
	    var isBookmarkNode = function (node) {
	      return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var trimNode = function (dom, node) {
	      var i, children = node.childNodes;
	      if (NodeType.isElement(node) && isBookmarkNode(node)) {
	        return;
	      }
	      for (i = children.length - 1; i >= 0; i--) {
	        trimNode(dom, children[i]);
	      }
	      if (NodeType.isDocument(node) === false) {
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          var trimmedLength = Tools.trim(node.nodeValue).length;
	          if (dom.isBlock(node.parentNode) || trimmedLength > 0) {
	            return;
	          }
	          if (trimmedLength === 0 && surroundedBySpans(node)) {
	            return;
	          }
	        } else if (NodeType.isElement(node)) {
	          children = node.childNodes;
	          if (children.length === 1 && isBookmarkNode(children[0])) {
	            node.parentNode.insertBefore(children[0], node);
	          }
	          if (children.length || isVoid(Element.fromDom(node))) {
	            return;
	          }
	        }
	        dom.remove(node);
	      }
	      return node;
	    };
	    var TrimNode = { trimNode: trimNode };
	
	    var makeMap$1 = Tools.makeMap;
	    var namedEntities, baseEntities, reverseEntities;
	    var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var rawCharsRegExp = /[<>&\"\']/g;
	    var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
	    var asciiMap = {
	      128: '\u20AC',
	      130: '\u201A',
	      131: '\u0192',
	      132: '\u201E',
	      133: '\u2026',
	      134: '\u2020',
	      135: '\u2021',
	      136: '\u02c6',
	      137: '\u2030',
	      138: '\u0160',
	      139: '\u2039',
	      140: '\u0152',
	      142: '\u017d',
	      145: '\u2018',
	      146: '\u2019',
	      147: '\u201C',
	      148: '\u201D',
	      149: '\u2022',
	      150: '\u2013',
	      151: '\u2014',
	      152: '\u02DC',
	      153: '\u2122',
	      154: '\u0161',
	      155: '\u203A',
	      156: '\u0153',
	      158: '\u017e',
	      159: '\u0178'
	    };
	    baseEntities = {
	      '"': '&quot;',
	      '\'': '&#39;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '`': '&#96;'
	    };
	    reverseEntities = {
	      '&lt;': '<',
	      '&gt;': '>',
	      '&amp;': '&',
	      '&quot;': '"',
	      '&apos;': '\''
	    };
	    var nativeDecode = function (text) {
	      var elm;
	      elm = Element.fromTag('div').dom();
	      elm.innerHTML = text;
	      return elm.textContent || elm.innerText || text;
	    };
	    var buildEntitiesLookup = function (items, radix) {
	      var i, chr, entity;
	      var lookup = {};
	      if (items) {
	        items = items.split(',');
	        radix = radix || 10;
	        for (i = 0; i < items.length; i += 2) {
	          chr = String.fromCharCode(parseInt(items[i], radix));
	          if (!baseEntities[chr]) {
	            entity = '&' + items[i + 1] + ';';
	            lookup[chr] = entity;
	            lookup[entity] = chr;
	          }
	        }
	        return lookup;
	      }
	    };
	    namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	    var encodeRaw = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeAllRaw = function (text) {
	      return ('' + text).replace(rawCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeNumeric = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        if (chr.length > 1) {
	          return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	        }
	        return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
	      });
	    };
	    var encodeNamed = function (text, attr, entities) {
	      entities = entities || namedEntities;
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || entities[chr] || chr;
	      });
	    };
	    var getEncodeFunc = function (name, entities) {
	      var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
	      var encodeNamedAndNumeric = function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          if (baseEntities[chr] !== undefined) {
	            return baseEntities[chr];
	          }
	          if (entitiesMap[chr] !== undefined) {
	            return entitiesMap[chr];
	          }
	          if (chr.length > 1) {
	            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	          }
	          return '&#' + chr.charCodeAt(0) + ';';
	        });
	      };
	      var encodeCustomNamed = function (text, attr) {
	        return encodeNamed(text, attr, entitiesMap);
	      };
	      var nameMap = makeMap$1(name.replace(/\+/g, ','));
	      if (nameMap.named && nameMap.numeric) {
	        return encodeNamedAndNumeric;
	      }
	      if (nameMap.named) {
	        if (entities) {
	          return encodeCustomNamed;
	        }
	        return encodeNamed;
	      }
	      if (nameMap.numeric) {
	        return encodeNumeric;
	      }
	      return encodeRaw;
	    };
	    var decode = function (text) {
	      return text.replace(entityRegExp, function (all, numeric) {
	        if (numeric) {
	          if (numeric.charAt(0).toLowerCase() === 'x') {
	            numeric = parseInt(numeric.substr(1), 16);
	          } else {
	            numeric = parseInt(numeric, 10);
	          }
	          if (numeric > 65535) {
	            numeric -= 65536;
	            return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
	          }
	          return asciiMap[numeric] || String.fromCharCode(numeric);
	        }
	        return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
	      });
	    };
	    var Entities = {
	      encodeRaw: encodeRaw,
	      encodeAllRaw: encodeAllRaw,
	      encodeNumeric: encodeNumeric,
	      encodeNamed: encodeNamed,
	      getEncodeFunc: getEncodeFunc,
	      decode: decode
	    };
	
	    var mapCache = {}, dummyObj = {};
	    var makeMap$2 = Tools.makeMap, each$4 = Tools.each, extend$1 = Tools.extend, explode$1 = Tools.explode, inArray$1 = Tools.inArray;
	    var split = function (items, delim) {
	      items = Tools.trim(items);
	      return items ? items.split(delim || ' ') : [];
	    };
	    var compileSchema = function (type) {
	      var schema = {};
	      var globalAttributes, blockContent;
	      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	      var add = function (name, attributes, children) {
	        var ni, attributesOrder, element;
	        var arrayToMap = function (array, obj) {
	          var map = {};
	          var i, l;
	          for (i = 0, l = array.length; i < l; i++) {
	            map[array[i]] = obj || {};
	          }
	          return map;
	        };
	        children = children || [];
	        attributes = attributes || '';
	        if (typeof children === 'string') {
	          children = split(children);
	        }
	        name = split(name);
	        ni = name.length;
	        while (ni--) {
	          attributesOrder = split([
	            globalAttributes,
	            attributes
	          ].join(' '));
	          element = {
	            attributes: arrayToMap(attributesOrder),
	            attributesOrder: attributesOrder,
	            children: arrayToMap(children, dummyObj)
	          };
	          schema[name[ni]] = element;
	        }
	      };
	      var addAttrs = function (name, attributes) {
	        var ni, schemaItem, i, l;
	        name = split(name);
	        ni = name.length;
	        attributes = split(attributes);
	        while (ni--) {
	          schemaItem = schema[name[ni]];
	          for (i = 0, l = attributes.length; i < l; i++) {
	            schemaItem.attributes[attributes[i]] = {};
	            schemaItem.attributesOrder.push(attributes[i]);
	          }
	        }
	      };
	      if (mapCache[type]) {
	        return mapCache[type];
	      }
	      globalAttributes = 'id accesskey class dir lang style tabindex title role';
	      blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
	      phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
	      if (type !== 'html4') {
	        globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
	        blockContent += ' article aside details dialog figure main header footer hgroup section nav';
	        phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
	      }
	      if (type !== 'html5-strict') {
	        globalAttributes += ' xml:lang';
	        html4PhrasingContent = 'acronym applet basefont big font strike tt';
	        phrasingContent = [
	          phrasingContent,
	          html4PhrasingContent
	        ].join(' ');
	        each$4(split(html4PhrasingContent), function (name) {
	          add(name, '', phrasingContent);
	        });
	        html4BlockContent = 'center dir isindex noframes';
	        blockContent = [
	          blockContent,
	          html4BlockContent
	        ].join(' ');
	        flowContent = [
	          blockContent,
	          phrasingContent
	        ].join(' ');
	        each$4(split(html4BlockContent), function (name) {
	          add(name, '', flowContent);
	        });
	      }
	      flowContent = flowContent || [
	        blockContent,
	        phrasingContent
	      ].join(' ');
	      add('html', 'manifest', 'head body');
	      add('head', '', 'base command link meta noscript script style title');
	      add('title hr noscript br');
	      add('base', 'href target');
	      add('link', 'href rel media hreflang type sizes hreflang');
	      add('meta', 'name http-equiv content charset');
	      add('style', 'media type scoped');
	      add('script', 'src async defer type charset');
	      add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
	      add('address dt dd div caption', '', flowContent);
	      add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
	      add('blockquote', 'cite', flowContent);
	      add('ol', 'reversed start type', 'li');
	      add('ul', '', 'li');
	      add('li', 'value', flowContent);
	      add('dl', '', 'dt dd');
	      add('a', 'href target rel media hreflang type', phrasingContent);
	      add('q', 'cite', phrasingContent);
	      add('ins del', 'cite datetime', flowContent);
	      add('img', 'src sizes srcset alt usemap ismap width height');
	      add('iframe', 'src name width height', flowContent);
	      add('embed', 'src type width height');
	      add('object', 'data type typemustmatch name usemap form width height', [
	        flowContent,
	        'param'
	      ].join(' '));
	      add('param', 'name value');
	      add('map', 'name', [
	        flowContent,
	        'area'
	      ].join(' '));
	      add('area', 'alt coords shape href target rel media hreflang type');
	      add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
	      add('colgroup', 'span', 'col');
	      add('col', 'span');
	      add('tbody thead tfoot', '', 'tr');
	      add('tr', '', 'td th');
	      add('td', 'colspan rowspan headers', flowContent);
	      add('th', 'colspan rowspan headers scope abbr', flowContent);
	      add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
	      add('fieldset', 'disabled form name', [
	        flowContent,
	        'legend'
	      ].join(' '));
	      add('label', 'form for', phrasingContent);
	      add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
	      add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
	      add('select', 'disabled form multiple name required size', 'option optgroup');
	      add('optgroup', 'disabled label', 'option');
	      add('option', 'disabled label selected value');
	      add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
	      add('menu', 'type label', [
	        flowContent,
	        'li'
	      ].join(' '));
	      add('noscript', '', flowContent);
	      if (type !== 'html4') {
	        add('wbr');
	        add('ruby', '', [
	          phrasingContent,
	          'rt rp'
	        ].join(' '));
	        add('figcaption', '', flowContent);
	        add('mark rt rp summary bdi', '', phrasingContent);
	        add('canvas', 'width height', flowContent);
	        add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('picture', '', 'img source');
	        add('source', 'src srcset type media sizes');
	        add('track', 'kind src srclang label default');
	        add('datalist', '', [
	          phrasingContent,
	          'option'
	        ].join(' '));
	        add('article section nav aside main header footer', '', flowContent);
	        add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
	        add('figure', '', [
	          flowContent,
	          'figcaption'
	        ].join(' '));
	        add('time', 'datetime', phrasingContent);
	        add('dialog', 'open', flowContent);
	        add('command', 'type label icon disabled checked radiogroup command');
	        add('output', 'for form name', phrasingContent);
	        add('progress', 'value max', phrasingContent);
	        add('meter', 'value min max low high optimum', phrasingContent);
	        add('details', 'open', [
	          flowContent,
	          'summary'
	        ].join(' '));
	        add('keygen', 'autofocus challenge disabled form keytype name');
	      }
	      if (type !== 'html5-strict') {
	        addAttrs('script', 'language xml:space');
	        addAttrs('style', 'xml:space');
	        addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
	        addAttrs('embed', 'align name hspace vspace');
	        addAttrs('param', 'valuetype type');
	        addAttrs('a', 'charset name rev shape coords');
	        addAttrs('br', 'clear');
	        addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
	        addAttrs('img', 'name longdesc align border hspace vspace');
	        addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
	        addAttrs('font basefont', 'size color face');
	        addAttrs('input', 'usemap align');
	        addAttrs('select', 'onchange');
	        addAttrs('textarea');
	        addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
	        addAttrs('ul', 'type compact');
	        addAttrs('li', 'type');
	        addAttrs('ol dl menu dir', 'compact');
	        addAttrs('pre', 'width xml:space');
	        addAttrs('hr', 'align noshade size width');
	        addAttrs('isindex', 'prompt');
	        addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
	        addAttrs('col', 'width align char charoff valign');
	        addAttrs('colgroup', 'width align char charoff valign');
	        addAttrs('thead', 'align char charoff valign');
	        addAttrs('tr', 'align char charoff valign bgcolor');
	        addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
	        addAttrs('form', 'accept');
	        addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
	        addAttrs('tfoot', 'align char charoff valign');
	        addAttrs('tbody', 'align char charoff valign');
	        addAttrs('area', 'nohref');
	        addAttrs('body', 'background bgcolor text link vlink alink');
	      }
	      if (type !== 'html4') {
	        addAttrs('input button select textarea', 'autofocus');
	        addAttrs('input textarea', 'placeholder');
	        addAttrs('a', 'download');
	        addAttrs('link script img', 'crossorigin');
	        addAttrs('iframe', 'sandbox seamless allowfullscreen');
	      }
	      each$4(split('a form meter progress dfn'), function (name) {
	        if (schema[name]) {
	          delete schema[name].children[name];
	        }
	      });
	      delete schema.caption.children.table;
	      delete schema.script;
	      mapCache[type] = schema;
	      return schema;
	    };
	    var compileElementMap = function (value, mode) {
	      var styles;
	      if (value) {
	        styles = {};
	        if (typeof value === 'string') {
	          value = { '*': value };
	        }
	        each$4(value, function (value, key) {
	          styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$1(value, /[, ]/);
	        });
	      }
	      return styles;
	    };
	    function Schema(settings) {
	      var elements = {};
	      var children = {};
	      var patternElements = [];
	      var validStyles;
	      var invalidStyles;
	      var schemaItems;
	      var whiteSpaceElementsMap, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
	      var blockElementsMap, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
	      var customElementsMap = {}, specialElements = {};
	      var createLookupTable = function (option, defaultValue, extendWith) {
	        var value = settings[option];
	        if (!value) {
	          value = mapCache[option];
	          if (!value) {
	            value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
	            value = extend$1(value, extendWith);
	            mapCache[option] = value;
	          }
	        } else {
	          value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
	        }
	        return value;
	      };
	      settings = settings || {};
	      schemaItems = compileSchema(settings.schema);
	      if (settings.verify_html === false) {
	        settings.valid_elements = '*[*]';
	      }
	      validStyles = compileElementMap(settings.valid_styles);
	      invalidStyles = compileElementMap(settings.invalid_styles, 'map');
	      validClasses = compileElementMap(settings.valid_classes, 'map');
	      whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
	      selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
	      shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
	      boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
	      nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object ' + 'script pre code', shortEndedElementsMap);
	      moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
	      textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside main nav figure');
	      blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
	      textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' + 'dfn code mark q sup sub samp');
	      each$4((settings.special || 'script noscript noframes noembed title style textarea xmp').split(' '), function (name) {
	        specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	      });
	      var patternToRegExp = function (str) {
	        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
	      };
	      var addValidElements = function (validElements) {
	        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, key, value;
	        var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
	        if (validElements) {
	          validElements = split(validElements, ',');
	          if (elements['@']) {
	            globalAttributes = elements['@'].attributes;
	            globalAttributesOrder = elements['@'].attributesOrder;
	          }
	          for (ei = 0, el = validElements.length; ei < el; ei++) {
	            matches = elementRuleRegExp.exec(validElements[ei]);
	            if (matches) {
	              prefix = matches[1];
	              elementName = matches[2];
	              outputName = matches[3];
	              attrData = matches[5];
	              attributes = {};
	              attributesOrder = [];
	              element = {
	                attributes: attributes,
	                attributesOrder: attributesOrder
	              };
	              if (prefix === '#') {
	                element.paddEmpty = true;
	              }
	              if (prefix === '-') {
	                element.removeEmpty = true;
	              }
	              if (matches[4] === '!') {
	                element.removeEmptyAttrs = true;
	              }
	              if (globalAttributes) {
	                for (key in globalAttributes) {
	                  attributes[key] = globalAttributes[key];
	                }
	                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
	              }
	              if (attrData) {
	                attrData = split(attrData, '|');
	                for (ai = 0, al = attrData.length; ai < al; ai++) {
	                  matches = attrRuleRegExp.exec(attrData[ai]);
	                  if (matches) {
	                    attr = {};
	                    attrType = matches[1];
	                    attrName = matches[2].replace(/[\\:]:/g, ':');
	                    prefix = matches[3];
	                    value = matches[4];
	                    if (attrType === '!') {
	                      element.attributesRequired = element.attributesRequired || [];
	                      element.attributesRequired.push(attrName);
	                      attr.required = true;
	                    }
	                    if (attrType === '-') {
	                      delete attributes[attrName];
	                      attributesOrder.splice(inArray$1(attributesOrder, attrName), 1);
	                      continue;
	                    }
	                    if (prefix) {
	                      if (prefix === '=') {
	                        element.attributesDefault = element.attributesDefault || [];
	                        element.attributesDefault.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.defaultValue = value;
	                      }
	                      if (prefix === ':') {
	                        element.attributesForced = element.attributesForced || [];
	                        element.attributesForced.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.forcedValue = value;
	                      }
	                      if (prefix === '<') {
	                        attr.validValues = makeMap$2(value, '?');
	                      }
	                    }
	                    if (hasPatternsRegExp.test(attrName)) {
	                      element.attributePatterns = element.attributePatterns || [];
	                      attr.pattern = patternToRegExp(attrName);
	                      element.attributePatterns.push(attr);
	                    } else {
	                      if (!attributes[attrName]) {
	                        attributesOrder.push(attrName);
	                      }
	                      attributes[attrName] = attr;
	                    }
	                  }
	                }
	              }
	              if (!globalAttributes && elementName === '@') {
	                globalAttributes = attributes;
	                globalAttributesOrder = attributesOrder;
	              }
	              if (outputName) {
	                element.outputName = elementName;
	                elements[outputName] = element;
	              }
	              if (hasPatternsRegExp.test(elementName)) {
	                element.pattern = patternToRegExp(elementName);
	                patternElements.push(element);
	              } else {
	                elements[elementName] = element;
	              }
	            }
	          }
	        }
	      };
	      var setValidElements = function (validElements) {
	        elements = {};
	        patternElements = [];
	        addValidElements(validElements);
	        each$4(schemaItems, function (element, name) {
	          children[name] = element.children;
	        });
	      };
	      var addCustomElements = function (customElements) {
	        var customElementRegExp = /^(~)?(.+)$/;
	        if (customElements) {
	          mapCache.text_block_elements = mapCache.block_elements = null;
	          each$4(split(customElements, ','), function (rule) {
	            var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
	            children[name] = children[cloneName];
	            customElementsMap[name] = cloneName;
	            if (!inline) {
	              blockElementsMap[name.toUpperCase()] = {};
	              blockElementsMap[name] = {};
	            }
	            if (!elements[name]) {
	              var customRule = elements[cloneName];
	              customRule = extend$1({}, customRule);
	              delete customRule.removeEmptyAttrs;
	              delete customRule.removeEmpty;
	              elements[name] = customRule;
	            }
	            each$4(children, function (element, elmName) {
	              if (element[cloneName]) {
	                children[elmName] = element = extend$1({}, children[elmName]);
	                element[name] = element[cloneName];
	              }
	            });
	          });
	        }
	      };
	      var addValidChildren = function (validChildren) {
	        var childRuleRegExp = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
	        mapCache[settings.schema] = null;
	        if (validChildren) {
	          each$4(split(validChildren, ','), function (rule) {
	            var matches = childRuleRegExp.exec(rule);
	            var parent, prefix;
	            if (matches) {
	              prefix = matches[1];
	              if (prefix) {
	                parent = children[matches[2]];
	              } else {
	                parent = children[matches[2]] = { '#comment': {} };
	              }
	              parent = children[matches[2]];
	              each$4(split(matches[3], '|'), function (child) {
	                if (prefix === '-') {
	                  delete parent[child];
	                } else {
	                  parent[child] = {};
	                }
	              });
	            }
	          });
	        }
	      };
	      var getElementRule = function (name) {
	        var element = elements[name], i;
	        if (element) {
	          return element;
	        }
	        i = patternElements.length;
	        while (i--) {
	          element = patternElements[i];
	          if (element.pattern.test(name)) {
	            return element;
	          }
	        }
	      };
	      if (!settings.valid_elements) {
	        each$4(schemaItems, function (element, name) {
	          elements[name] = {
	            attributes: element.attributes,
	            attributesOrder: element.attributesOrder
	          };
	          children[name] = element.children;
	        });
	        if (settings.schema !== 'html5') {
	          each$4(split('strong/b em/i'), function (item) {
	            item = split(item, '/');
	            elements[item[1]].outputName = item[0];
	          });
	        }
	        each$4(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function (name) {
	          if (elements[name]) {
	            elements[name].removeEmpty = true;
	          }
	        });
	        each$4(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
	          elements[name].paddEmpty = true;
	        });
	        each$4(split('span'), function (name) {
	          elements[name].removeEmptyAttrs = true;
	        });
	      } else {
	        setValidElements(settings.valid_elements);
	      }
	      addCustomElements(settings.custom_elements);
	      addValidChildren(settings.valid_children);
	      addValidElements(settings.extended_valid_elements);
	      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	      each$4({
	        dd: 'dl',
	        dt: 'dl',
	        li: 'ul ol',
	        td: 'tr',
	        th: 'tr',
	        tr: 'tbody thead tfoot',
	        tbody: 'table',
	        thead: 'table',
	        tfoot: 'table',
	        legend: 'fieldset',
	        area: 'map',
	        param: 'video audio object'
	      }, function (parents, item) {
	        if (elements[item]) {
	          elements[item].parentsRequired = split(parents);
	        }
	      });
	      if (settings.invalid_elements) {
	        each$4(explode$1(settings.invalid_elements), function (item) {
	          if (elements[item]) {
	            delete elements[item];
	          }
	        });
	      }
	      if (!getElementRule('span')) {
	        addValidElements('span[!data-mce-type|*]');
	      }
	      var getValidStyles = function () {
	        return validStyles;
	      };
	      var getInvalidStyles = function () {
	        return invalidStyles;
	      };
	      var getValidClasses = function () {
	        return validClasses;
	      };
	      var getBoolAttrs = function () {
	        return boolAttrMap;
	      };
	      var getBlockElements = function () {
	        return blockElementsMap;
	      };
	      var getTextBlockElements = function () {
	        return textBlockElementsMap;
	      };
	      var getTextInlineElements = function () {
	        return textInlineElementsMap;
	      };
	      var getShortEndedElements = function () {
	        return shortEndedElementsMap;
	      };
	      var getSelfClosingElements = function () {
	        return selfClosingElementsMap;
	      };
	      var getNonEmptyElements = function () {
	        return nonEmptyElementsMap;
	      };
	      var getMoveCaretBeforeOnEnterElements = function () {
	        return moveCaretBeforeOnEnterElementsMap;
	      };
	      var getWhiteSpaceElements = function () {
	        return whiteSpaceElementsMap;
	      };
	      var getSpecialElements = function () {
	        return specialElements;
	      };
	      var isValidChild = function (name, child) {
	        var parent = children[name.toLowerCase()];
	        return !!(parent && parent[child.toLowerCase()]);
	      };
	      var isValid = function (name, attr) {
	        var attrPatterns, i;
	        var rule = getElementRule(name);
	        if (rule) {
	          if (attr) {
	            if (rule.attributes[attr]) {
	              return true;
	            }
	            attrPatterns = rule.attributePatterns;
	            if (attrPatterns) {
	              i = attrPatterns.length;
	              while (i--) {
	                if (attrPatterns[i].pattern.test(name)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            return true;
	          }
	        }
	        return false;
	      };
	      var getCustomElements = function () {
	        return customElementsMap;
	      };
	      return {
	        children: children,
	        elements: elements,
	        getValidStyles: getValidStyles,
	        getValidClasses: getValidClasses,
	        getBlockElements: getBlockElements,
	        getInvalidStyles: getInvalidStyles,
	        getShortEndedElements: getShortEndedElements,
	        getTextBlockElements: getTextBlockElements,
	        getTextInlineElements: getTextInlineElements,
	        getBoolAttrs: getBoolAttrs,
	        getElementRule: getElementRule,
	        getSelfClosingElements: getSelfClosingElements,
	        getNonEmptyElements: getNonEmptyElements,
	        getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
	        getWhiteSpaceElements: getWhiteSpaceElements,
	        getSpecialElements: getSpecialElements,
	        isValidChild: isValidChild,
	        isValid: isValid,
	        getCustomElements: getCustomElements,
	        addValidElements: addValidElements,
	        setValidElements: setValidElements,
	        addCustomElements: addCustomElements,
	        addValidChildren: addValidChildren
	      };
	    }
	
	    var toHex = function (match, r, g, b) {
	      var hex = function (val) {
	        val = parseInt(val, 10).toString(16);
	        return val.length > 1 ? val : '0' + val;
	      };
	      return '#' + hex(r) + hex(g) + hex(b);
	    };
	    function Styles(settings, schema) {
	      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
	      var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
	      var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
	      var trimRightRegExp = /\s+$/;
	      var i;
	      var encodingLookup = {};
	      var encodingItems;
	      var validStyles;
	      var invalidStyles;
	      var invisibleChar = '\uFEFF';
	      settings = settings || {};
	      if (schema) {
	        validStyles = schema.getValidStyles();
	        invalidStyles = schema.getInvalidStyles();
	      }
	      encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
	      for (i = 0; i < encodingItems.length; i++) {
	        encodingLookup[encodingItems[i]] = invisibleChar + i;
	        encodingLookup[invisibleChar + i] = encodingItems[i];
	      }
	      return {
	        toHex: function (color) {
	          return color.replace(rgbRegExp, toHex);
	        },
	        parse: function (css) {
	          var styles = {};
	          var matches, name, value, isEncoded;
	          var urlConverter = settings.url_converter;
	          var urlConverterScope = settings.url_converter_scope || this;
	          var compress = function (prefix, suffix, noJoin) {
	            var top, right, bottom, left;
	            top = styles[prefix + '-top' + suffix];
	            if (!top) {
	              return;
	            }
	            right = styles[prefix + '-right' + suffix];
	            if (!right) {
	              return;
	            }
	            bottom = styles[prefix + '-bottom' + suffix];
	            if (!bottom) {
	              return;
	            }
	            left = styles[prefix + '-left' + suffix];
	            if (!left) {
	              return;
	            }
	            var box = [
	              top,
	              right,
	              bottom,
	              left
	            ];
	            i = box.length - 1;
	            while (i--) {
	              if (box[i] !== box[i + 1]) {
	                break;
	              }
	            }
	            if (i > -1 && noJoin) {
	              return;
	            }
	            styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
	            delete styles[prefix + '-top' + suffix];
	            delete styles[prefix + '-right' + suffix];
	            delete styles[prefix + '-bottom' + suffix];
	            delete styles[prefix + '-left' + suffix];
	          };
	          var canCompress = function (key) {
	            var value = styles[key], i;
	            if (!value) {
	              return;
	            }
	            value = value.split(' ');
	            i = value.length;
	            while (i--) {
	              if (value[i] !== value[0]) {
	                return false;
	              }
	            }
	            styles[key] = value[0];
	            return true;
	          };
	          var compress2 = function (target, a, b, c) {
	            if (!canCompress(a)) {
	              return;
	            }
	            if (!canCompress(b)) {
	              return;
	            }
	            if (!canCompress(c)) {
	              return;
	            }
	            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
	            delete styles[a];
	            delete styles[b];
	            delete styles[c];
	          };
	          var encode = function (str) {
	            isEncoded = true;
	            return encodingLookup[str];
	          };
	          var decode = function (str, keepSlashes) {
	            if (isEncoded) {
	              str = str.replace(/\uFEFF[0-9]/g, function (str) {
	                return encodingLookup[str];
	              });
	            }
	            if (!keepSlashes) {
	              str = str.replace(/\\([\'\";:])/g, '$1');
	            }
	            return str;
	          };
	          var decodeSingleHexSequence = function (escSeq) {
	            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
	          };
	          var decodeHexSequences = function (value) {
	            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
	          };
	          var processUrl = function (match, url, url2, url3, str, str2) {
	            str = str || str2;
	            if (str) {
	              str = decode(str);
	              return '\'' + str.replace(/\'/g, '\\\'') + '\'';
	            }
	            url = decode(url || url2 || url3);
	            if (!settings.allow_script_urls) {
	              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
	              if (/(java|vb)script:/i.test(scriptUrl)) {
	                return '';
	              }
	              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
	                return '';
	              }
	            }
	            if (urlConverter) {
	              url = urlConverter.call(urlConverterScope, url, 'style');
	            }
	            return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
	          };
	          if (css) {
	            css = css.replace(/[\u0000-\u001F]/g, '');
	            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
	              return str.replace(/[;:]/g, encode);
	            });
	            while (matches = styleRegExp.exec(css)) {
	              styleRegExp.lastIndex = matches.index + matches[0].length;
	              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
	              value = matches[2].replace(trimRightRegExp, '');
	              if (name && value) {
	                name = decodeHexSequences(name);
	                value = decodeHexSequences(value);
	                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
	                  continue;
	                }
	                if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
	                  continue;
	                }
	                if (name === 'font-weight' && value === '700') {
	                  value = 'bold';
	                } else if (name === 'color' || name === 'background-color') {
	                  value = value.toLowerCase();
	                }
	                value = value.replace(rgbRegExp, toHex);
	                value = value.replace(urlOrStrRegExp, processUrl);
	                styles[name] = isEncoded ? decode(value, true) : value;
	              }
	            }
	            compress('border', '', true);
	            compress('border', '-width');
	            compress('border', '-color');
	            compress('border', '-style');
	            compress('padding', '');
	            compress('margin', '');
	            compress2('border', 'border-width', 'border-style', 'border-color');
	            if (styles.border === 'medium none') {
	              delete styles.border;
	            }
	            if (styles['border-image'] === 'none') {
	              delete styles['border-image'];
	            }
	          }
	          return styles;
	        },
	        serialize: function (styles, elementName) {
	          var css = '', name, value;
	          var serializeStyles = function (name) {
	            var styleList, i, l, value;
	            styleList = validStyles[name];
	            if (styleList) {
	              for (i = 0, l = styleList.length; i < l; i++) {
	                name = styleList[i];
	                value = styles[name];
	                if (value) {
	                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	                }
	              }
	            }
	          };
	          var isValid = function (name, elementName) {
	            var styleMap;
	            styleMap = invalidStyles['*'];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            styleMap = invalidStyles[elementName];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            return true;
	          };
	          if (elementName && validStyles) {
	            serializeStyles('*');
	            serializeStyles(elementName);
	          } else {
	            for (name in styles) {
	              value = styles[name];
	              if (value && (!invalidStyles || isValid(name, elementName))) {
	                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	              }
	            }
	          }
	          return css;
	        }
	      };
	    }
	
	    var each$5 = Tools.each;
	    var grep$1 = Tools.grep;
	    var isIE = Env.ie;
	    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
	    var whiteSpaceRegExp$2 = /^[ \t\r\n]*$/;
	    var setupAttrHooks = function (styles, settings, getContext) {
	      var attrHooks = {};
	      var keepValues = settings.keep_values;
	      var keepUrlHook = {
	        set: function ($elm, value, name) {
	          if (settings.url_converter) {
	            value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
	          }
	          $elm.attr('data-mce-' + name, value).attr(name, value);
	        },
	        get: function ($elm, name) {
	          return $elm.attr('data-mce-' + name) || $elm.attr(name);
	        }
	      };
	      attrHooks = {
	        style: {
	          set: function ($elm, value) {
	            if (value !== null && typeof value === 'object') {
	              $elm.css(value);
	              return;
	            }
	            if (keepValues) {
	              $elm.attr('data-mce-style', value);
	            }
	            $elm.attr('style', value);
	          },
	          get: function ($elm) {
	            var value = $elm.attr('data-mce-style') || $elm.attr('style');
	            value = styles.serialize(styles.parse(value), $elm[0].nodeName);
	            return value;
	          }
	        }
	      };
	      if (keepValues) {
	        attrHooks.href = attrHooks.src = keepUrlHook;
	      }
	      return attrHooks;
	    };
	    var updateInternalStyleAttr = function (styles, $elm) {
	      var rawValue = $elm.attr('style');
	      var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
	      if (!value) {
	        value = null;
	      }
	      $elm.attr('data-mce-style', value);
	    };
	    var findNodeIndex = function (node, normalized) {
	      var idx = 0, lastNodeType, nodeType;
	      if (node) {
	        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
	          nodeType = node.nodeType;
	          if (normalized && nodeType === 3) {
	            if (nodeType === lastNodeType || !node.nodeValue.length) {
	              continue;
	            }
	          }
	          idx++;
	          lastNodeType = nodeType;
	        }
	      }
	      return idx;
	    };
	    function DOMUtils(doc, settings) {
	      var _this = this;
	      if (settings === void 0) {
	        settings = {};
	      }
	      var attrHooks;
	      var addedStyles = {};
	      var win = domGlobals.window;
	      var files = {};
	      var counter = 0;
	      var stdMode = true;
	      var boxModel = true;
	      var styleSheetLoader = StyleSheetLoader(doc, { contentCssCors: settings.contentCssCors });
	      var boundEvents = [];
	      var schema = settings.schema ? settings.schema : Schema({});
	      var styles = Styles({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope
	      }, settings.schema);
	      var events = settings.ownEvents ? new EventUtils(settings.proxy) : EventUtils.Event;
	      var blockElementsMap = schema.getBlockElements();
	      var $ = DomQuery.overrideDefaults(function () {
	        return {
	          context: doc,
	          element: self.getRoot()
	        };
	      });
	      var isBlock = function (node) {
	        if (typeof node === 'string') {
	          return !!blockElementsMap[node];
	        } else if (node) {
	          var type = node.nodeType;
	          if (type) {
	            return !!(type === 1 && blockElementsMap[node.nodeName]);
	          }
	        }
	        return false;
	      };
	      var get = function (elm) {
	        if (elm && doc && typeof elm === 'string') {
	          var node = doc.getElementById(elm);
	          if (node && node.id !== elm) {
	            return doc.getElementsByName(elm)[1];
	          } else {
	            return node;
	          }
	        }
	        return elm;
	      };
	      var $$ = function (elm) {
	        if (typeof elm === 'string') {
	          elm = get(elm);
	        }
	        return $(elm);
	      };
	      var getAttrib = function (elm, name, defaultVal) {
	        var hook, value;
	        var $elm = $$(elm);
	        if ($elm.length) {
	          hook = attrHooks[name];
	          if (hook && hook.get) {
	            value = hook.get($elm, name);
	          } else {
	            value = $elm.attr(name);
	          }
	        }
	        if (typeof value === 'undefined') {
	          value = defaultVal || '';
	        }
	        return value;
	      };
	      var getAttribs = function (elm) {
	        var node = get(elm);
	        if (!node) {
	          return [];
	        }
	        return node.attributes;
	      };
	      var setAttrib = function (elm, name, value) {
	        var originalValue, hook;
	        if (value === '') {
	          value = null;
	        }
	        var $elm = $$(elm);
	        originalValue = $elm.attr(name);
	        if (!$elm.length) {
	          return;
	        }
	        hook = attrHooks[name];
	        if (hook && hook.set) {
	          hook.set($elm, value, name);
	        } else {
	          $elm.attr(name, value);
	        }
	        if (originalValue !== value && settings.onSetAttrib) {
	          settings.onSetAttrib({
	            attrElm: $elm,
	            attrName: name,
	            attrValue: value
	          });
	        }
	      };
	      var clone = function (node, deep) {
	        if (!isIE || node.nodeType !== 1 || deep) {
	          return node.cloneNode(deep);
	        }
	        if (!deep) {
	          var clone_1 = doc.createElement(node.nodeName);
	          each$5(getAttribs(node), function (attr) {
	            setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
	          });
	          return clone_1;
	        }
	        return null;
	      };
	      var getRoot = function () {
	        return settings.root_element || doc.body;
	      };
	      var getViewPort = function (argWin) {
	        var actWin = !argWin ? win : argWin;
	        var doc = actWin.document;
	        var rootElm =  doc.documentElement ;
	        return {
	          x: actWin.pageXOffset || rootElm.scrollLeft,
	          y: actWin.pageYOffset || rootElm.scrollTop,
	          w: actWin.innerWidth || rootElm.clientWidth,
	          h: actWin.innerHeight || rootElm.clientHeight
	        };
	      };
	      var getPos = function (elm, rootElm) {
	        return Position.getPos(doc.body, get(elm), rootElm);
	      };
	      var setStyle = function (elm, name, value) {
	        var $elm = $$(elm).css(name, value);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var setStyles = function (elm, stylesArg) {
	        var $elm = $$(elm).css(stylesArg);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var getStyle = function (elm, name, computed) {
	        var $elm = $$(elm);
	        if (computed) {
	          return $elm.css(name);
	        }
	        name = name.replace(/-(\D)/g, function (a, b) {
	          return b.toUpperCase();
	        });
	        if (name === 'float') {
	          name = Env.ie && Env.ie < 12 ? 'styleFloat' : 'cssFloat';
	        }
	        return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
	      };
	      var getSize = function (elm) {
	        var w, h;
	        elm = get(elm);
	        w = getStyle(elm, 'width');
	        h = getStyle(elm, 'height');
	        if (w.indexOf('px') === -1) {
	          w = 0;
	        }
	        if (h.indexOf('px') === -1) {
	          h = 0;
	        }
	        return {
	          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
	          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
	        };
	      };
	      var getRect = function (elm) {
	        var pos, size;
	        elm = get(elm);
	        pos = getPos(elm);
	        size = getSize(elm);
	        return {
	          x: pos.x,
	          y: pos.y,
	          w: size.w,
	          h: size.h
	        };
	      };
	      var is = function (elm, selector) {
	        var i;
	        if (!elm) {
	          return false;
	        }
	        if (!Array.isArray(elm)) {
	          if (selector === '*') {
	            return elm.nodeType === 1;
	          }
	          if (simpleSelectorRe.test(selector)) {
	            var selectors = selector.toLowerCase().split(/,/);
	            var elmName = elm.nodeName.toLowerCase();
	            for (i = selectors.length - 1; i >= 0; i--) {
	              if (selectors[i] === elmName) {
	                return true;
	              }
	            }
	            return false;
	          }
	          if (elm.nodeType && elm.nodeType !== 1) {
	            return false;
	          }
	        }
	        var elms = !Array.isArray(elm) ? [elm] : elm;
	        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
	      };
	      var getParents = function (elm, selector, root, collect) {
	        var result = [];
	        var selectorVal;
	        var node = get(elm);
	        collect = collect === undefined;
	        root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
	        if (Tools.is(selector, 'string')) {
	          selectorVal = selector;
	          if (selector === '*') {
	            selector = function (node) {
	              return node.nodeType === 1;
	            };
	          } else {
	            selector = function (node) {
	              return is(node, selectorVal);
	            };
	          }
	        }
	        while (node) {
	          if (node === root || !node.nodeType || node.nodeType === 9) {
	            break;
	          }
	          if (!selector || typeof selector === 'function' && selector(node)) {
	            if (collect) {
	              result.push(node);
	            } else {
	              return [node];
	            }
	          }
	          node = node.parentNode;
	        }
	        return collect ? result : null;
	      };
	      var getParent = function (node, selector, root) {
	        var parents = getParents(node, selector, root, false);
	        return parents && parents.length > 0 ? parents[0] : null;
	      };
	      var _findSib = function (node, selector, name) {
	        var func = selector;
	        if (node) {
	          if (typeof selector === 'string') {
	            func = function (node) {
	              return is(node, selector);
	            };
	          }
	          for (node = node[name]; node; node = node[name]) {
	            if (typeof func === 'function' && func(node)) {
	              return node;
	            }
	          }
	        }
	        return null;
	      };
	      var getNext = function (node, selector) {
	        return _findSib(node, selector, 'nextSibling');
	      };
	      var getPrev = function (node, selector) {
	        return _findSib(node, selector, 'previousSibling');
	      };
	      var select = function (selector, scope) {
	        return Sizzle(selector, get(scope) || settings.root_element || doc, []);
	      };
	      var run = function (elm, func, scope) {
	        var result;
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        if (!node) {
	          return false;
	        }
	        if (Tools.isArray(node) && (node.length || node.length === 0)) {
	          result = [];
	          each$5(node, function (elm, i) {
	            if (elm) {
	              if (typeof elm === 'string') {
	                elm = get(elm);
	              }
	              result.push(func.call(scope, elm, i));
	            }
	          });
	          return result;
	        }
	        var context = scope ? scope : _this;
	        return func.call(context, node);
	      };
	      var setAttribs = function (elm, attrs) {
	        $$(elm).each(function (i, node) {
	          each$5(attrs, function (value, name) {
	            setAttrib(node, name, value);
	          });
	        });
	      };
	      var setHTML = function (elm, html) {
	        var $elm = $$(elm);
	        if (isIE) {
	          $elm.each(function (i, target) {
	            if (target.canHaveHTML === false) {
	              return;
	            }
	            while (target.firstChild) {
	              target.removeChild(target.firstChild);
	            }
	            try {
	              target.innerHTML = '<br>' + html;
	              target.removeChild(target.firstChild);
	            } catch (ex) {
	              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
	            }
	            return html;
	          });
	        } else {
	          $elm.html(html);
	        }
	      };
	      var add = function (parentElm, name, attrs, html, create) {
	        return run(parentElm, function (parentElm) {
	          var newElm = typeof name === 'string' ? doc.createElement(name) : name;
	          setAttribs(newElm, attrs);
	          if (html) {
	            if (typeof html !== 'string' && html.nodeType) {
	              newElm.appendChild(html);
	            } else if (typeof html === 'string') {
	              setHTML(newElm, html);
	            }
	          }
	          return !create ? parentElm.appendChild(newElm) : newElm;
	        });
	      };
	      var create = function (name, attrs, html) {
	        return add(doc.createElement(name), name, attrs, html, true);
	      };
	      var decode = Entities.decode;
	      var encode = Entities.encodeAllRaw;
	      var createHTML = function (name, attrs, html) {
	        var outHtml = '', key;
	        outHtml += '<' + name;
	        for (key in attrs) {
	          if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] !== 'undefined') {
	            outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
	          }
	        }
	        if (typeof html !== 'undefined') {
	          return outHtml + '>' + html + '</' + name + '>';
	        }
	        return outHtml + ' />';
	      };
	      var createFragment = function (html) {
	        var node;
	        var container = doc.createElement('div');
	        var frag = doc.createDocumentFragment();
	        frag.appendChild(container);
	        if (html) {
	          container.innerHTML = html;
	        }
	        while (node = container.firstChild) {
	          frag.appendChild(node);
	        }
	        frag.removeChild(container);
	        return frag;
	      };
	      var remove = function (node, keepChildren) {
	        var $node = $$(node);
	        if (keepChildren) {
	          $node.each(function () {
	            var child;
	            while (child = this.firstChild) {
	              if (child.nodeType === 3 && child.data.length === 0) {
	                this.removeChild(child);
	              } else {
	                this.parentNode.insertBefore(child, this);
	              }
	            }
	          }).remove();
	        } else {
	          $node.remove();
	        }
	        return $node.length > 1 ? $node.toArray() : $node[0];
	      };
	      var removeAllAttribs = function (e) {
	        return run(e, function (e) {
	          var i;
	          var attrs = e.attributes;
	          for (i = attrs.length - 1; i >= 0; i--) {
	            e.removeAttributeNode(attrs.item(i));
	          }
	        });
	      };
	      var parseStyle = function (cssText) {
	        return styles.parse(cssText);
	      };
	      var serializeStyle = function (stylesArg, name) {
	        return styles.serialize(stylesArg, name);
	      };
	      var addStyle = function (cssText) {
	        var head, styleElm;
	        if (self !== DOMUtils.DOM && doc === domGlobals.document) {
	          if (addedStyles[cssText]) {
	            return;
	          }
	          addedStyles[cssText] = true;
	        }
	        styleElm = doc.getElementById('mceDefaultStyles');
	        if (!styleElm) {
	          styleElm = doc.createElement('style');
	          styleElm.id = 'mceDefaultStyles';
	          styleElm.type = 'text/css';
	          head = doc.getElementsByTagName('head')[0];
	          if (head.firstChild) {
	            head.insertBefore(styleElm, head.firstChild);
	          } else {
	            head.appendChild(styleElm);
	          }
	        }
	        if (styleElm.styleSheet) {
	          styleElm.styleSheet.cssText += cssText;
	        } else {
	          styleElm.appendChild(doc.createTextNode(cssText));
	        }
	      };
	      var loadCSS = function (url) {
	        var head;
	        if (self !== DOMUtils.DOM && doc === domGlobals.document) {
	          DOMUtils.DOM.loadCSS(url);
	          return;
	        }
	        if (!url) {
	          url = '';
	        }
	        head = doc.getElementsByTagName('head')[0];
	        each$5(url.split(','), function (url) {
	          var link;
	          url = Tools._addCacheSuffix(url);
	          if (files[url]) {
	            return;
	          }
	          files[url] = true;
	          link = create('link', {
	            rel: 'stylesheet',
	            href: url
	          });
	          head.appendChild(link);
	        });
	      };
	      var toggleClass = function (elm, cls, state) {
	        $$(elm).toggleClass(cls, state).each(function () {
	          if (this.className === '') {
	            DomQuery(this).attr('class', null);
	          }
	        });
	      };
	      var addClass = function (elm, cls) {
	        $$(elm).addClass(cls);
	      };
	      var removeClass = function (elm, cls) {
	        toggleClass(elm, cls, false);
	      };
	      var hasClass = function (elm, cls) {
	        return $$(elm).hasClass(cls);
	      };
	      var show = function (elm) {
	        $$(elm).show();
	      };
	      var hide = function (elm) {
	        $$(elm).hide();
	      };
	      var isHidden = function (elm) {
	        return $$(elm).css('display') === 'none';
	      };
	      var uniqueId = function (prefix) {
	        return (!prefix ? 'mce_' : prefix) + counter++;
	      };
	      var getOuterHTML = function (elm) {
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        return NodeType.isElement(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
	      };
	      var setOuterHTML = function (elm, html) {
	        $$(elm).each(function () {
	          try {
	            if ('outerHTML' in this) {
	              this.outerHTML = html;
	              return;
	            }
	          } catch (ex) {
	          }
	          remove(DomQuery(this).html(html), true);
	        });
	      };
	      var insertAfter = function (node, reference) {
	        var referenceNode = get(reference);
	        return run(node, function (node) {
	          var parent, nextSibling;
	          parent = referenceNode.parentNode;
	          nextSibling = referenceNode.nextSibling;
	          if (nextSibling) {
	            parent.insertBefore(node, nextSibling);
	          } else {
	            parent.appendChild(node);
	          }
	          return node;
	        });
	      };
	      var replace = function (newElm, oldElm, keepChildren) {
	        return run(oldElm, function (oldElm) {
	          if (Tools.is(oldElm, 'array')) {
	            newElm = newElm.cloneNode(true);
	          }
	          if (keepChildren) {
	            each$5(grep$1(oldElm.childNodes), function (node) {
	              newElm.appendChild(node);
	            });
	          }
	          return oldElm.parentNode.replaceChild(newElm, oldElm);
	        });
	      };
	      var rename = function (elm, name) {
	        var newElm;
	        if (elm.nodeName !== name.toUpperCase()) {
	          newElm = create(name);
	          each$5(getAttribs(elm), function (attrNode) {
	            setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
	          });
	          replace(newElm, elm, true);
	        }
	        return newElm || elm;
	      };
	      var findCommonAncestor = function (a, b) {
	        var ps = a, pe;
	        while (ps) {
	          pe = b;
	          while (pe && ps !== pe) {
	            pe = pe.parentNode;
	          }
	          if (ps === pe) {
	            break;
	          }
	          ps = ps.parentNode;
	        }
	        if (!ps && a.ownerDocument) {
	          return a.ownerDocument.documentElement;
	        }
	        return ps;
	      };
	      var toHex = function (rgbVal) {
	        return styles.toHex(Tools.trim(rgbVal));
	      };
	      var isEmpty = function (node, elements) {
	        var i, attributes, type, whitespace, walker, name, brCount = 0;
	        node = node.firstChild;
	        if (node) {
	          walker = new TreeWalker(node, node.parentNode);
	          elements = elements || (schema ? schema.getNonEmptyElements() : null);
	          whitespace = schema ? schema.getWhiteSpaceElements() : {};
	          do {
	            type = node.nodeType;
	            if (NodeType.isElement(node)) {
	              var bogusVal = node.getAttribute('data-mce-bogus');
	              if (bogusVal) {
	                node = walker.next(bogusVal === 'all');
	                continue;
	              }
	              name = node.nodeName.toLowerCase();
	              if (elements && elements[name]) {
	                if (name === 'br') {
	                  brCount++;
	                  node = walker.next();
	                  continue;
	                }
	                return false;
	              }
	              attributes = getAttribs(node);
	              i = attributes.length;
	              while (i--) {
	                name = attributes[i].nodeName;
	                if (name === 'name' || name === 'data-mce-bookmark') {
	                  return false;
	                }
	              }
	            }
	            if (type === 8) {
	              return false;
	            }
	            if (type === 3 && !whiteSpaceRegExp$2.test(node.nodeValue)) {
	              return false;
	            }
	            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && whiteSpaceRegExp$2.test(node.nodeValue)) {
	              return false;
	            }
	            node = walker.next();
	          } while (node);
	        }
	        return brCount <= 1;
	      };
	      var createRng = function () {
	        return doc.createRange();
	      };
	      var split = function (parentElm, splitElm, replacementElm) {
	        var r = createRng(), bef, aft, pa;
	        if (parentElm && splitElm) {
	          r.setStart(parentElm.parentNode, findNodeIndex(parentElm));
	          r.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
	          bef = r.extractContents();
	          r = createRng();
	          r.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
	          r.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
	          aft = r.extractContents();
	          pa = parentElm.parentNode;
	          pa.insertBefore(TrimNode.trimNode(self, bef), parentElm);
	          if (replacementElm) {
	            pa.insertBefore(replacementElm, parentElm);
	          } else {
	            pa.insertBefore(splitElm, parentElm);
	          }
	          pa.insertBefore(TrimNode.trimNode(self, aft), parentElm);
	          remove(parentElm);
	          return replacementElm || splitElm;
	        }
	      };
	      var bind = function (target, name, func, scope) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          while (i--) {
	            target[i] = bind(target[i], name, func, scope);
	          }
	          return target;
	        }
	        if (settings.collect && (target === doc || target === win)) {
	          boundEvents.push([
	            target,
	            name,
	            func,
	            scope
	          ]);
	        }
	        return events.bind(target, name, func, scope || self);
	      };
	      var unbind = function (target, name, func) {
	        var i;
	        if (Tools.isArray(target)) {
	          i = target.length;
	          while (i--) {
	            target[i] = unbind(target[i], name, func);
	          }
	          return target;
	        }
	        if (boundEvents && (target === doc || target === win)) {
	          i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
	              events.unbind(item[0], item[1], item[2]);
	            }
	          }
	        }
	        return events.unbind(target, name, func);
	      };
	      var fire = function (target, name, evt) {
	        return events.fire(target, name, evt);
	      };
	      var getContentEditable = function (node) {
	        if (node && NodeType.isElement(node)) {
	          var contentEditable = node.getAttribute('data-mce-contenteditable');
	          if (contentEditable && contentEditable !== 'inherit') {
	            return contentEditable;
	          }
	          return node.contentEditable !== 'inherit' ? node.contentEditable : null;
	        } else {
	          return null;
	        }
	      };
	      var getContentEditableParent = function (node) {
	        var root = getRoot();
	        var state = null;
	        for (; node && node !== root; node = node.parentNode) {
	          state = getContentEditable(node);
	          if (state !== null) {
	            break;
	          }
	        }
	        return state;
	      };
	      var destroy = function () {
	        if (boundEvents) {
	          var i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            events.unbind(item[0], item[1], item[2]);
	          }
	        }
	        if (Sizzle.setDocument) {
	          Sizzle.setDocument();
	        }
	      };
	      var isChildOf = function (node, parent) {
	        while (node) {
	          if (parent === node) {
	            return true;
	          }
	          node = node.parentNode;
	        }
	        return false;
	      };
	      var dumpRng = function (r) {
	        return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
	      };
	      var self = {
	        doc: doc,
	        settings: settings,
	        win: win,
	        files: files,
	        stdMode: stdMode,
	        boxModel: boxModel,
	        styleSheetLoader: styleSheetLoader,
	        boundEvents: boundEvents,
	        styles: styles,
	        schema: schema,
	        events: events,
	        isBlock: isBlock,
	        $: $,
	        $$: $$,
	        root: null,
	        clone: clone,
	        getRoot: getRoot,
	        getViewPort: getViewPort,
	        getRect: getRect,
	        getSize: getSize,
	        getParent: getParent,
	        getParents: getParents,
	        get: get,
	        getNext: getNext,
	        getPrev: getPrev,
	        select: select,
	        is: is,
	        add: add,
	        create: create,
	        createHTML: createHTML,
	        createFragment: createFragment,
	        remove: remove,
	        setStyle: setStyle,
	        getStyle: getStyle,
	        setStyles: setStyles,
	        removeAllAttribs: removeAllAttribs,
	        setAttrib: setAttrib,
	        setAttribs: setAttribs,
	        getAttrib: getAttrib,
	        getPos: getPos,
	        parseStyle: parseStyle,
	        serializeStyle: serializeStyle,
	        addStyle: addStyle,
	        loadCSS: loadCSS,
	        addClass: addClass,
	        removeClass: removeClass,
	        hasClass: hasClass,
	        toggleClass: toggleClass,
	        show: show,
	        hide: hide,
	        isHidden: isHidden,
	        uniqueId: uniqueId,
	        setHTML: setHTML,
	        getOuterHTML: getOuterHTML,
	        setOuterHTML: setOuterHTML,
	        decode: decode,
	        encode: encode,
	        insertAfter: insertAfter,
	        replace: replace,
	        rename: rename,
	        findCommonAncestor: findCommonAncestor,
	        toHex: toHex,
	        run: run,
	        getAttribs: getAttribs,
	        isEmpty: isEmpty,
	        createRng: createRng,
	        nodeIndex: findNodeIndex,
	        split: split,
	        bind: bind,
	        unbind: unbind,
	        fire: fire,
	        getContentEditable: getContentEditable,
	        getContentEditableParent: getContentEditableParent,
	        destroy: destroy,
	        isChildOf: isChildOf,
	        dumpRng: dumpRng
	      };
	      attrHooks = setupAttrHooks(styles, settings, function () {
	        return self;
	      });
	      return self;
	    }
	    (function (DOMUtils) {
	      DOMUtils.DOM = DOMUtils(domGlobals.document);
	      DOMUtils.nodeIndex = findNodeIndex;
	    }(DOMUtils || (DOMUtils = {})));
	    var DOMUtils$1 = DOMUtils;
	
	    var DOM = DOMUtils$1.DOM;
	    var each$6 = Tools.each, grep$2 = Tools.grep;
	    var isFunction$1 = function (f) {
	      return typeof f === 'function';
	    };
	    var ScriptLoader = function () {
	      var QUEUED = 0;
	      var LOADING = 1;
	      var LOADED = 2;
	      var FAILED = 3;
	      var states = {};
	      var queue = [];
	      var scriptLoadedCallbacks = {};
	      var queueLoadedCallbacks = [];
	      var loading = 0;
	      var loadScript = function (url, success, failure) {
	        var dom = DOM;
	        var elm, id;
	        var done = function () {
	          dom.remove(id);
	          if (elm) {
	            elm.onreadystatechange = elm.onload = elm = null;
	          }
	          success();
	        };
	        var error = function () {
	          if (isFunction$1(failure)) {
	            failure();
	          } else {
	            if (typeof console !== 'undefined' && console.log) {
	              console.log('Failed to load script: ' + url);
	            }
	          }
	        };
	        id = dom.uniqueId();
	        elm = domGlobals.document.createElement('script');
	        elm.id = id;
	        elm.type = 'text/javascript';
	        elm.src = Tools._addCacheSuffix(url);
	        elm.onload = done;
	        elm.onerror = error;
	        (domGlobals.document.getElementsByTagName('head')[0] || domGlobals.document.body).appendChild(elm);
	      };
	      this.isDone = function (url) {
	        return states[url] === LOADED;
	      };
	      this.markDone = function (url) {
	        states[url] = LOADED;
	      };
	      this.add = this.load = function (url, success, scope, failure) {
	        var state = states[url];
	        if (state === undefined) {
	          queue.push(url);
	          states[url] = QUEUED;
	        }
	        if (success) {
	          if (!scriptLoadedCallbacks[url]) {
	            scriptLoadedCallbacks[url] = [];
	          }
	          scriptLoadedCallbacks[url].push({
	            success: success,
	            failure: failure,
	            scope: scope || this
	          });
	        }
	      };
	      this.remove = function (url) {
	        delete states[url];
	        delete scriptLoadedCallbacks[url];
	      };
	      this.loadQueue = function (success, scope, failure) {
	        this.loadScripts(queue, success, scope, failure);
	      };
	      this.loadScripts = function (scripts, success, scope, failure) {
	        var loadScripts;
	        var failures = [];
	        var execCallbacks = function (name, url) {
	          each$6(scriptLoadedCallbacks[url], function (callback) {
	            if (isFunction$1(callback[name])) {
	              callback[name].call(callback.scope);
	            }
	          });
	          scriptLoadedCallbacks[url] = undefined;
	        };
	        queueLoadedCallbacks.push({
	          success: success,
	          failure: failure,
	          scope: scope || this
	        });
	        loadScripts = function () {
	          var loadingScripts = grep$2(scripts);
	          scripts.length = 0;
	          each$6(loadingScripts, function (url) {
	            if (states[url] === LOADED) {
	              execCallbacks('success', url);
	              return;
	            }
	            if (states[url] === FAILED) {
	              execCallbacks('failure', url);
	              return;
	            }
	            if (states[url] !== LOADING) {
	              states[url] = LOADING;
	              loading++;
	              loadScript(url, function () {
	                states[url] = LOADED;
	                loading--;
	                execCallbacks('success', url);
	                loadScripts();
	              }, function () {
	                states[url] = FAILED;
	                loading--;
	                failures.push(url);
	                execCallbacks('failure', url);
	                loadScripts();
	              });
	            }
	          });
	          if (!loading) {
	            var notifyCallbacks = queueLoadedCallbacks.slice(0);
	            queueLoadedCallbacks.length = 0;
	            each$6(notifyCallbacks, function (callback) {
	              if (failures.length === 0) {
	                if (isFunction$1(callback.success)) {
	                  callback.success.call(callback.scope);
	                }
	              } else {
	                if (isFunction$1(callback.failure)) {
	                  callback.failure.call(callback.scope, failures);
	                }
	              }
	            });
	          }
	        };
	        loadScripts();
	      };
	    };
	    ScriptLoader.ScriptLoader = new ScriptLoader();
	
	    var each$7 = Tools.each;
	    function AddOnManager() {
	      var _this = this;
	      var items = [];
	      var urls = {};
	      var lookup = {};
	      var _listeners = [];
	      var get = function (name) {
	        if (lookup[name]) {
	          return lookup[name].instance;
	        }
	        return undefined;
	      };
	      var dependencies = function (name) {
	        var result;
	        if (lookup[name]) {
	          result = lookup[name].dependencies;
	        }
	        return result || [];
	      };
	      var requireLangPack = function (name, languages) {
	        var language = AddOnManager.language;
	        if (language && AddOnManager.languageLoad !== false) {
	          if (languages) {
	            languages = ',' + languages + ',';
	            if (languages.indexOf(',' + language.substr(0, 2) + ',') !== -1) {
	              language = language.substr(0, 2);
	            } else if (languages.indexOf(',' + language + ',') === -1) {
	              return;
	            }
	          }
	          ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
	        }
	      };
	      var add = function (id, addOn, dependencies) {
	        items.push(addOn);
	        lookup[id] = {
	          instance: addOn,
	          dependencies: dependencies
	        };
	        var result = partition(_listeners, function (listener) {
	          return listener.name === id;
	        });
	        _listeners = result.fail;
	        each$7(result.pass, function (listener) {
	          listener.callback();
	        });
	        return addOn;
	      };
	      var remove = function (name) {
	        delete urls[name];
	        delete lookup[name];
	      };
	      var createUrl = function (baseUrl, dep) {
	        if (typeof dep === 'object') {
	          return dep;
	        }
	        return typeof baseUrl === 'string' ? {
	          prefix: '',
	          resource: dep,
	          suffix: ''
	        } : {
	          prefix: baseUrl.prefix,
	          resource: dep,
	          suffix: baseUrl.suffix
	        };
	      };
	      var addComponents = function (pluginName, scripts) {
	        var pluginUrl = _this.urls[pluginName];
	        each$7(scripts, function (script) {
	          ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
	        });
	      };
	      var loadDependencies = function (name, addOnUrl, success, scope) {
	        var deps = dependencies(name);
	        each$7(deps, function (dep) {
	          var newUrl = createUrl(addOnUrl, dep);
	          load(newUrl.resource, newUrl, undefined, undefined);
	        });
	        if (success) {
	          if (scope) {
	            success.call(scope);
	          } else {
	            success.call(ScriptLoader);
	          }
	        }
	      };
	      var load = function (name, addOnUrl, success, scope, failure) {
	        if (urls[name]) {
	          return;
	        }
	        var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
	        if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
	          urlString = AddOnManager.baseURL + '/' + urlString;
	        }
	        urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
	        if (lookup[name]) {
	          loadDependencies(name, addOnUrl, success, scope);
	        } else {
	          ScriptLoader.ScriptLoader.add(urlString, function () {
	            return loadDependencies(name, addOnUrl, success, scope);
	          }, scope, failure);
	        }
	      };
	      var waitFor = function (name, callback) {
	        if (lookup.hasOwnProperty(name)) {
	          callback();
	        } else {
	          _listeners.push({
	            name: name,
	            callback: callback
	          });
	        }
	      };
	      return {
	        items: items,
	        urls: urls,
	        lookup: lookup,
	        _listeners: _listeners,
	        get: get,
	        dependencies: dependencies,
	        requireLangPack: requireLangPack,
	        add: add,
	        remove: remove,
	        createUrl: createUrl,
	        addComponents: addComponents,
	        load: load,
	        waitFor: waitFor
	      };
	    }
	    (function (AddOnManager) {
	      AddOnManager.PluginManager = AddOnManager();
	      AddOnManager.ThemeManager = AddOnManager();
	    }(AddOnManager || (AddOnManager = {})));
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom().insertBefore(element.dom(), v.dom());
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	    var wrap$1 = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom().textContent = '';
	      each(children(element), function (rogue) {
	        remove$1(rogue);
	      });
	    };
	    var remove$1 = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove$1(wrapper);
	    };
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer === null) {
	          timer = domGlobals.setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          domGlobals.clearTimeout(timer);
	        }
	        timer = domGlobals.setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var read = function (element, attr) {
	      var value = get(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$2 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom().classList !== undefined;
	    };
	    var get$2 = function (element) {
	      return read(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$2(element, 'class', clazz);
	    };
	
	    var add$2 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom().classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom().classList : get$2(element);
	      if (classList.length === 0) {
	        remove(element, 'class');
	      }
	    };
	    var remove$4 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom().classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$2 = function (element, clazz) {
	      return supports(element) && element.dom().classList.contains(clazz);
	    };
	
	    var descendants = function (scope, predicate) {
	      var result = [];
	      each(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    var descendants$1 = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      return is(scope, a) ? Option.some(scope) : isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
	    }
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom();
	      var stop = isFunction(isRoot) ? isRoot : constant(false);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = Element.fromDom(element);
	        if (predicate(el)) {
	          return Option.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Option.none();
	    };
	    var closest = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor(scope, function (e) {
	        return is$1(e, selector);
	      }, isRoot);
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      return ClosestOrAncestor(is$1, ancestor$1, scope, selector, isRoot);
	    };
	
	    var annotation = constant('mce-annotation');
	    var dataAnnotation = constant('data-mce-annotation');
	    var dataAnnotationId = constant('data-mce-annotation-uid');
	
	    var identify = function (editor, annotationName) {
	      var rng = editor.selection.getRng();
	      var start = Element.fromDom(rng.startContainer);
	      var root = Element.fromDom(editor.getBody());
	      var selector = annotationName.fold(function () {
	        return '.' + annotation();
	      }, function (an) {
	        return '[' + dataAnnotation() + '="' + an + '"]';
	      });
	      var newStart = child(start, rng.startOffset).getOr(start);
	      var closest = closest$1(newStart, selector, function (n) {
	        return eq(n, root);
	      });
	      var getAttr = function (c, property) {
	        if (has$1(c, property)) {
	          return Option.some(get(c, property));
	        } else {
	          return Option.none();
	        }
	      };
	      return closest.bind(function (c) {
	        return getAttr(c, '' + dataAnnotationId()).bind(function (uid) {
	          return getAttr(c, '' + dataAnnotation()).map(function (name) {
	            var elements = findMarkers(editor, uid);
	            return {
	              uid: uid,
	              name: name,
	              elements: elements
	            };
	          });
	        });
	      });
	    };
	    var isAnnotation = function (elem) {
	      return isElement(elem) && has$2(elem, annotation());
	    };
	    var findMarkers = function (editor, uid) {
	      var body = Element.fromDom(editor.getBody());
	      return descendants$1(body, '[' + dataAnnotationId() + '="' + uid + '"]');
	    };
	    var findAll = function (editor, name) {
	      var body = Element.fromDom(editor.getBody());
	      var markers = descendants$1(body, '[' + dataAnnotation() + '="' + name + '"]');
	      var directory = {};
	      each(markers, function (m) {
	        var uid = get(m, dataAnnotationId());
	        var nodesAlready = directory.hasOwnProperty(uid) ? directory[uid] : [];
	        directory[uid] = nodesAlready.concat([m]);
	      });
	      return directory;
	    };
	
	    var setup = function (editor, registry) {
	      var changeCallbacks = Cell({});
	      var initData = function () {
	        return {
	          listeners: [],
	          previous: Cell(Option.none())
	        };
	      };
	      var withCallbacks = function (name, f) {
	        updateCallbacks(name, function (data) {
	          f(data);
	          return data;
	        });
	      };
	      var updateCallbacks = function (name, f) {
	        var callbackMap = changeCallbacks.get();
	        var data = callbackMap.hasOwnProperty(name) ? callbackMap[name] : initData();
	        var outputData = f(data);
	        callbackMap[name] = outputData;
	        changeCallbacks.set(callbackMap);
	      };
	      var fireCallbacks = function (name, uid, elements) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(true, name, {
	              uid: uid,
	              nodes: map(elements, function (elem) {
	                return elem.dom();
	              })
	            });
	          });
	        });
	      };
	      var fireNoAnnotation = function (name) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(false, name);
	          });
	        });
	      };
	      var onNodeChange = last$2(function () {
	        var callbackMap = changeCallbacks.get();
	        var annotations = sort(keys(callbackMap));
	        each(annotations, function (name) {
	          updateCallbacks(name, function (data) {
	            var prev = data.previous.get();
	            identify(editor, Option.some(name)).fold(function () {
	              if (prev.isSome()) {
	                fireNoAnnotation(name);
	                data.previous.set(Option.none());
	              }
	            }, function (_a) {
	              var uid = _a.uid, name = _a.name, elements = _a.elements;
	              if (!prev.is(uid)) {
	                fireCallbacks(name, uid, elements);
	                data.previous.set(Option.some(uid));
	              }
	            });
	            return {
	              previous: data.previous,
	              listeners: data.listeners
	            };
	          });
	        });
	      }, 30);
	      editor.on('remove', function () {
	        onNodeChange.cancel();
	      });
	      editor.on('nodeChange', function () {
	        onNodeChange.throttle();
	      });
	      var addListener = function (name, f) {
	        updateCallbacks(name, function (data) {
	          return {
	            previous: data.previous,
	            listeners: data.listeners.concat([f])
	          };
	        });
	      };
	      return { addListener: addListener };
	    };
	
	    var setup$1 = function (editor, registry) {
	      var identifyParserNode = function (span) {
	        var optAnnotation = Option.from(span.attributes.map[dataAnnotation()]);
	        return optAnnotation.bind(registry.lookup);
	      };
	      editor.on('init', function () {
	        editor.serializer.addNodeFilter('span', function (spans) {
	          each(spans, function (span) {
	            identifyParserNode(span).each(function (settings) {
	              if (settings.persistent === false) {
	                span.unwrap();
	              }
	            });
	          });
	        });
	      });
	    };
	
	    var create$1 = function () {
	      var annotations = {};
	      var register = function (name, settings) {
	        annotations[name] = {
	          name: name,
	          settings: settings
	        };
	      };
	      var lookup = function (name) {
	        return annotations.hasOwnProperty(name) ? Option.from(annotations[name]).map(function (a) {
	          return a.settings;
	        }) : Option.none();
	      };
	      return {
	        register: register,
	        lookup: lookup
	      };
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var unique = 0;
	    var generate = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var add$3 = function (element, classes) {
	      each(classes, function (x) {
	        add$2(element, x);
	      });
	    };
	
	    var clone = function (original, isDeep) {
	      return Element.fromDom(original.dom().cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone(original, false);
	    };
	    var deep = function (original) {
	      return clone(original, true);
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(Element.fromDom(div));
	    };
	
	    var get$3 = function (element) {
	      return element.dom().innerHTML;
	    };
	    var set$1 = function (element, content) {
	      var owner$1 = owner(element);
	      var docDom = owner$1.dom();
	      var fragment = Element.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml$1(content, docDom);
	      append$1(fragment, contentElements);
	      empty(element);
	      append(element, fragment);
	    };
	
	    var ZWSP = '\uFEFF';
	    var isZwsp = function (chr) {
	      return chr === ZWSP;
	    };
	    var trim$3 = function (text) {
	      return text.replace(new RegExp(ZWSP, 'g'), '');
	    };
	    var Zwsp = {
	      isZwsp: isZwsp,
	      ZWSP: ZWSP,
	      trim: trim$3
	    };
	
	    var isElement$2 = NodeType.isElement;
	    var isText$2 = NodeType.isText;
	    var isCaretContainerBlock = function (node) {
	      if (isText$2(node)) {
	        node = node.parentNode;
	      }
	      return isElement$2(node) && node.hasAttribute('data-mce-caret');
	    };
	    var isCaretContainerInline = function (node) {
	      return isText$2(node) && Zwsp.isZwsp(node.data);
	    };
	    var isCaretContainer = function (node) {
	      return isCaretContainerBlock(node) || isCaretContainerInline(node);
	    };
	    var hasContent = function (node) {
	      return node.firstChild !== node.lastChild || !NodeType.isBr(node.firstChild);
	    };
	    var insertInline = function (node, before) {
	      var doc, sibling, textNode, parentNode;
	      doc = node.ownerDocument;
	      textNode = doc.createTextNode(Zwsp.ZWSP);
	      parentNode = node.parentNode;
	      if (!before) {
	        sibling = node.nextSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (startsWithCaretContainer(sibling)) {
	            sibling.splitText(1);
	            return sibling;
	          }
	        }
	        if (node.nextSibling) {
	          parentNode.insertBefore(textNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(textNode);
	        }
	      } else {
	        sibling = node.previousSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (endsWithCaretContainer(sibling)) {
	            return sibling.splitText(sibling.data.length - 1);
	          }
	        }
	        parentNode.insertBefore(textNode, node);
	      }
	      return textNode;
	    };
	    var isBeforeInline = function (pos) {
	      var container = pos.container();
	      if (!pos || !NodeType.isText(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset()) === Zwsp.ZWSP || pos.isAtStart() && isCaretContainerInline(container.previousSibling);
	    };
	    var isAfterInline = function (pos) {
	      var container = pos.container();
	      if (!pos || !NodeType.isText(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset() - 1) === Zwsp.ZWSP || pos.isAtEnd() && isCaretContainerInline(container.nextSibling);
	    };
	    var createBogusBr = function () {
	      var br = domGlobals.document.createElement('br');
	      br.setAttribute('data-mce-bogus', '1');
	      return br;
	    };
	    var insertBlock = function (blockName, node, before) {
	      var doc, blockNode, parentNode;
	      doc = node.ownerDocument;
	      blockNode = doc.createElement(blockName);
	      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
	      blockNode.setAttribute('data-mce-bogus', 'all');
	      blockNode.appendChild(createBogusBr());
	      parentNode = node.parentNode;
	      if (!before) {
	        if (node.nextSibling) {
	          parentNode.insertBefore(blockNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(blockNode);
	        }
	      } else {
	        parentNode.insertBefore(blockNode, node);
	      }
	      return blockNode;
	    };
	    var startsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[0] === Zwsp.ZWSP;
	    };
	    var endsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[node.data.length - 1] === Zwsp.ZWSP;
	    };
	    var trimBogusBr = function (elm) {
	      var brs = elm.getElementsByTagName('br');
	      var lastBr = brs[brs.length - 1];
	      if (NodeType.isBogus(lastBr)) {
	        lastBr.parentNode.removeChild(lastBr);
	      }
	    };
	    var showCaretContainerBlock = function (caretContainer) {
	      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
	        trimBogusBr(caretContainer);
	        caretContainer.removeAttribute('data-mce-caret');
	        caretContainer.removeAttribute('data-mce-bogus');
	        caretContainer.removeAttribute('style');
	        caretContainer.removeAttribute('_moz_abspos');
	        return caretContainer;
	      }
	      return null;
	    };
	    var isRangeInCaretContainerBlock = function (range) {
	      return isCaretContainerBlock(range.startContainer);
	    };
	
	    var isContentEditableTrue$1 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$1 = NodeType.isContentEditableFalse;
	    var isBr$2 = NodeType.isBr;
	    var isText$3 = NodeType.isText;
	    var isInvalidTextElement = NodeType.matchNodeNames('script style textarea');
	    var isAtomicInline = NodeType.matchNodeNames('img input textarea hr iframe video audio object');
	    var isTable$1 = NodeType.matchNodeNames('table');
	    var isCaretContainer$1 = isCaretContainer;
	    var isCaretCandidate = function (node) {
	      if (isCaretContainer$1(node)) {
	        return false;
	      }
	      if (isText$3(node)) {
	        if (isInvalidTextElement(node.parentNode)) {
	          return false;
	        }
	        return true;
	      }
	      return isAtomicInline(node) || isBr$2(node) || isTable$1(node) || isNonUiContentEditableFalse(node);
	    };
	    var isUnselectable = function (node) {
	      return NodeType.isElement(node) && node.getAttribute('unselectable') === 'true';
	    };
	    var isNonUiContentEditableFalse = function (node) {
	      return isUnselectable(node) === false && isContentEditableFalse$1(node);
	    };
	    var isInEditable = function (node, root) {
	      for (node = node.parentNode; node && node !== root; node = node.parentNode) {
	        if (isNonUiContentEditableFalse(node)) {
	          return false;
	        }
	        if (isContentEditableTrue$1(node)) {
	          return true;
	        }
	      }
	      return true;
	    };
	    var isAtomicContentEditableFalse = function (node) {
	      if (!isNonUiContentEditableFalse(node)) {
	        return false;
	      }
	      return foldl(from$1(node.getElementsByTagName('*')), function (result, elm) {
	        return result || isContentEditableTrue$1(elm);
	      }, false) !== true;
	    };
	    var isAtomic = function (node) {
	      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
	    };
	    var isEditableCaretCandidate = function (node, root) {
	      return isCaretCandidate(node) && isInEditable(node, root);
	    };
	
	    var round = Math.round;
	    var clone$1 = function (rect) {
	      if (!rect) {
	        return {
	          left: 0,
	          top: 0,
	          bottom: 0,
	          right: 0,
	          width: 0,
	          height: 0
	        };
	      }
	      return {
	        left: round(rect.left),
	        top: round(rect.top),
	        bottom: round(rect.bottom),
	        right: round(rect.right),
	        width: round(rect.width),
	        height: round(rect.height)
	      };
	    };
	    var collapse = function (rect, toStart) {
	      rect = clone$1(rect);
	      if (toStart) {
	        rect.right = rect.left;
	      } else {
	        rect.left = rect.left + rect.width;
	        rect.right = rect.left;
	      }
	      rect.width = 0;
	      return rect;
	    };
	    var isEqual = function (rect1, rect2) {
	      return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
	    };
	    var isValidOverflow = function (overflowY, rect1, rect2) {
	      return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
	    };
	    var isAbove = function (rect1, rect2) {
	      if (rect1.bottom - rect1.height / 2 < rect2.top) {
	        return true;
	      }
	      if (rect1.top > rect2.bottom) {
	        return false;
	      }
	      return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
	    };
	    var isBelow = function (rect1, rect2) {
	      if (rect1.top > rect2.bottom) {
	        return true;
	      }
	      if (rect1.bottom < rect2.top) {
	        return false;
	      }
	      return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
	    };
	    var containsXY = function (rect, clientX, clientY) {
	      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
	    };
	    var overflowX = function (outer, inner) {
	      if (inner.left > outer.left && inner.right < outer.right) {
	        return 0;
	      } else {
	        return inner.left < outer.left ? inner.left - outer.left : inner.right - outer.right;
	      }
	    };
	    var overflowY = function (outer, inner) {
	      if (inner.top > outer.top && inner.bottom < outer.bottom) {
	        return 0;
	      } else {
	        return inner.top < outer.top ? inner.top - outer.top : inner.bottom - outer.bottom;
	      }
	    };
	    var getOverflow = function (outer, inner) {
	      return {
	        x: overflowX(outer, inner),
	        y: overflowY(outer, inner)
	      };
	    };
	
	    var getSelectedNode = function (range) {
	      var startContainer = range.startContainer, startOffset = range.startOffset;
	      if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
	        return startContainer.childNodes[startOffset];
	      }
	      return null;
	    };
	    var getNode = function (container, offset) {
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        if (offset >= container.childNodes.length) {
	          offset = container.childNodes.length - 1;
	        }
	        container = container.childNodes[offset];
	      }
	      return container;
	    };
	
	    var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]');
	    var isExtendingChar = function (ch) {
	      return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	    };
	
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie())) : Option.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Option.none();
	    };
	
	    var slice$2 = [].slice;
	    var or = function () {
	      var x = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        x[_i] = arguments[_i];
	      }
	      var args = slice$2.call(arguments);
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (args[i](x)) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var and = function () {
	      var x = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        x[_i] = arguments[_i];
	      }
	      var args = slice$2.call(arguments);
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (!args[i](x)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    };
	    var Predicate = {
	      and: and,
	      or: or
	    };
	
	    var isElement$3 = NodeType.isElement;
	    var isCaretCandidate$1 = isCaretCandidate;
	    var isBlock$1 = NodeType.matchStyleValues('display', 'block table');
	    var isFloated = NodeType.matchStyleValues('float', 'left right');
	    var isValidElementCaretCandidate = Predicate.and(isElement$3, isCaretCandidate$1, not(isFloated));
	    var isNotPre = not(NodeType.matchStyleValues('white-space', 'pre pre-line pre-wrap'));
	    var isText$4 = NodeType.isText;
	    var isBr$3 = NodeType.isBr;
	    var nodeIndex = DOMUtils$1.nodeIndex;
	    var resolveIndex = getNode;
	    var createRange = function (doc) {
	      return 'createRange' in doc ? doc.createRange() : DOMUtils$1.DOM.createRng();
	    };
	    var isWhiteSpace = function (chr) {
	      return chr && /[\r\n\t ]/.test(chr);
	    };
	    var isRange = function (rng) {
	      return !!rng.setStart && !!rng.setEnd;
	    };
	    var isHiddenWhiteSpaceRange = function (range) {
	      var container = range.startContainer;
	      var offset = range.startOffset;
	      var text;
	      if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode) && NodeType.isText(container)) {
	        text = container.data;
	        if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var getBrClientRect = function (brNode) {
	      var doc = brNode.ownerDocument;
	      var rng = createRange(doc);
	      var nbsp = doc.createTextNode('\xA0');
	      var parentNode = brNode.parentNode;
	      var clientRect;
	      parentNode.insertBefore(nbsp, brNode);
	      rng.setStart(nbsp, 0);
	      rng.setEnd(nbsp, 1);
	      clientRect = clone$1(rng.getBoundingClientRect());
	      parentNode.removeChild(nbsp);
	      return clientRect;
	    };
	    var getBoundingClientRectWebKitText = function (rng) {
	      var sc = rng.startContainer;
	      var ec = rng.endContainer;
	      var so = rng.startOffset;
	      var eo = rng.endOffset;
	      if (sc === ec && NodeType.isText(ec) && so === 0 && eo === 1) {
	        var newRng = rng.cloneRange();
	        newRng.setEndAfter(ec);
	        return getBoundingClientRect(newRng);
	      } else {
	        return null;
	      }
	    };
	    var isZeroRect = function (r) {
	      return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
	    };
	    var getBoundingClientRect = function (item) {
	      var clientRect, clientRects;
	      clientRects = item.getClientRects();
	      if (clientRects.length > 0) {
	        clientRect = clone$1(clientRects[0]);
	      } else {
	        clientRect = clone$1(item.getBoundingClientRect());
	      }
	      if (!isRange(item) && isBr$3(item) && isZeroRect(clientRect)) {
	        return getBrClientRect(item);
	      }
	      if (isZeroRect(clientRect) && isRange(item)) {
	        return getBoundingClientRectWebKitText(item);
	      }
	      return clientRect;
	    };
	    var collapseAndInflateWidth = function (clientRect, toStart) {
	      var newClientRect = collapse(clientRect, toStart);
	      newClientRect.width = 1;
	      newClientRect.right = newClientRect.left + 1;
	      return newClientRect;
	    };
	    var getCaretPositionClientRects = function (caretPosition) {
	      var clientRects = [];
	      var beforeNode, node;
	      var addUniqueAndValidRect = function (clientRect) {
	        if (clientRect.height === 0) {
	          return;
	        }
	        if (clientRects.length > 0) {
	          if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
	            return;
	          }
	        }
	        clientRects.push(clientRect);
	      };
	      var addCharacterOffset = function (container, offset) {
	        var range = createRange(container.ownerDocument);
	        if (offset < container.data.length) {
	          if (isExtendingChar(container.data[offset])) {
	            return clientRects;
	          }
	          if (isExtendingChar(container.data[offset - 1])) {
	            range.setStart(container, offset);
	            range.setEnd(container, offset + 1);
	            if (!isHiddenWhiteSpaceRange(range)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	              return clientRects;
	            }
	          }
	        }
	        if (offset > 0) {
	          range.setStart(container, offset - 1);
	          range.setEnd(container, offset);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	          }
	        }
	        if (offset < container.data.length) {
	          range.setStart(container, offset);
	          range.setEnd(container, offset + 1);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
	          }
	        }
	      };
	      if (isText$4(caretPosition.container())) {
	        addCharacterOffset(caretPosition.container(), caretPosition.offset());
	        return clientRects;
	      }
	      if (isElement$3(caretPosition.container())) {
	        if (caretPosition.isAtEnd()) {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, node.data.length);
	          }
	          if (isValidElementCaretCandidate(node) && !isBr$3(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	          }
	        } else {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, 0);
	          }
	          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	            return clientRects;
	          }
	          beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
	          if (isValidElementCaretCandidate(beforeNode) && !isBr$3(beforeNode)) {
	            if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
	            }
	          }
	          if (isValidElementCaretCandidate(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
	          }
	        }
	      }
	      return clientRects;
	    };
	    function CaretPosition(container, offset, clientRects) {
	      var isAtStart = function () {
	        if (isText$4(container)) {
	          return offset === 0;
	        }
	        return offset === 0;
	      };
	      var isAtEnd = function () {
	        if (isText$4(container)) {
	          return offset >= container.data.length;
	        }
	        return offset >= container.childNodes.length;
	      };
	      var toRange = function () {
	        var range;
	        range = createRange(container.ownerDocument);
	        range.setStart(container, offset);
	        range.setEnd(container, offset);
	        return range;
	      };
	      var getClientRects = function () {
	        if (!clientRects) {
	          clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
	        }
	        return clientRects;
	      };
	      var isVisible = function () {
	        return getClientRects().length > 0;
	      };
	      var isEqual = function (caretPosition) {
	        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
	      };
	      var getNode = function (before) {
	        return resolveIndex(container, before ? offset - 1 : offset);
	      };
	      return {
	        container: constant(container),
	        offset: constant(offset),
	        toRange: toRange,
	        getClientRects: getClientRects,
	        isVisible: isVisible,
	        isAtStart: isAtStart,
	        isAtEnd: isAtEnd,
	        isEqual: isEqual,
	        getNode: getNode
	      };
	    }
	    (function (CaretPosition) {
	      CaretPosition.fromRangeStart = function (range) {
	        return CaretPosition(range.startContainer, range.startOffset);
	      };
	      CaretPosition.fromRangeEnd = function (range) {
	        return CaretPosition(range.endContainer, range.endOffset);
	      };
	      CaretPosition.after = function (node) {
	        return CaretPosition(node.parentNode, nodeIndex(node) + 1);
	      };
	      CaretPosition.before = function (node) {
	        return CaretPosition(node.parentNode, nodeIndex(node));
	      };
	      CaretPosition.isAbove = function (pos1, pos2) {
	        return lift2(head(pos2.getClientRects()), last(pos1.getClientRects()), isAbove).getOr(false);
	      };
	      CaretPosition.isBelow = function (pos1, pos2) {
	        return lift2(last(pos2.getClientRects()), head(pos1.getClientRects()), isBelow).getOr(false);
	      };
	      CaretPosition.isAtStart = function (pos) {
	        return pos ? pos.isAtStart() : false;
	      };
	      CaretPosition.isAtEnd = function (pos) {
	        return pos ? pos.isAtEnd() : false;
	      };
	      CaretPosition.isTextPosition = function (pos) {
	        return pos ? NodeType.isText(pos.container()) : false;
	      };
	      CaretPosition.isElementPosition = function (pos) {
	        return CaretPosition.isTextPosition(pos) === false;
	      };
	    }(CaretPosition || (CaretPosition = {})));
	    var CaretPosition$1 = CaretPosition;
	
	    var isText$5 = NodeType.isText;
	    var isBogus$1 = NodeType.isBogus;
	    var nodeIndex$1 = DOMUtils$1.nodeIndex;
	    var normalizedParent = function (node) {
	      var parentNode = node.parentNode;
	      if (isBogus$1(parentNode)) {
	        return normalizedParent(parentNode);
	      }
	      return parentNode;
	    };
	    var getChildNodes = function (node) {
	      if (!node) {
	        return [];
	      }
	      return ArrUtils.reduce(node.childNodes, function (result, node) {
	        if (isBogus$1(node) && node.nodeName !== 'BR') {
	          result = result.concat(getChildNodes(node));
	        } else {
	          result.push(node);
	        }
	        return result;
	      }, []);
	    };
	    var normalizedTextOffset = function (node, offset) {
	      while (node = node.previousSibling) {
	        if (!isText$5(node)) {
	          break;
	        }
	        offset += node.data.length;
	      }
	      return offset;
	    };
	    var equal = function (a) {
	      return function (b) {
	        return a === b;
	      };
	    };
	    var normalizedNodeIndex = function (node) {
	      var nodes, index, numTextFragments;
	      nodes = getChildNodes(normalizedParent(node));
	      index = ArrUtils.findIndex(nodes, equal(node), node);
	      nodes = nodes.slice(0, index + 1);
	      numTextFragments = ArrUtils.reduce(nodes, function (result, node, i) {
	        if (isText$5(node) && isText$5(nodes[i - 1])) {
	          result++;
	        }
	        return result;
	      }, 0);
	      nodes = ArrUtils.filter(nodes, NodeType.matchNodeNames(node.nodeName));
	      index = ArrUtils.findIndex(nodes, equal(node), node);
	      return index - numTextFragments;
	    };
	    var createPathItem = function (node) {
	      var name;
	      if (isText$5(node)) {
	        name = 'text()';
	      } else {
	        name = node.nodeName.toLowerCase();
	      }
	      return name + '[' + normalizedNodeIndex(node) + ']';
	    };
	    var parentsUntil = function (root, node, predicate) {
	      var parents = [];
	      for (node = node.parentNode; node !== root; node = node.parentNode) {
	        if (predicate && predicate(node)) {
	          break;
	        }
	        parents.push(node);
	      }
	      return parents;
	    };
	    var create$2 = function (root, caretPosition) {
	      var container, offset, path = [], outputOffset, childNodes, parents;
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (isText$5(container)) {
	        outputOffset = normalizedTextOffset(container, offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length) {
	          outputOffset = 'after';
	          offset = childNodes.length - 1;
	        } else {
	          outputOffset = 'before';
	        }
	        container = childNodes[offset];
	      }
	      path.push(createPathItem(container));
	      parents = parentsUntil(root, container);
	      parents = ArrUtils.filter(parents, not(NodeType.isBogus));
	      path = path.concat(ArrUtils.map(parents, function (node) {
	        return createPathItem(node);
	      }));
	      return path.reverse().join('/') + ',' + outputOffset;
	    };
	    var resolvePathItem = function (node, name, index) {
	      var nodes = getChildNodes(node);
	      nodes = ArrUtils.filter(nodes, function (node, index) {
	        return !isText$5(node) || !isText$5(nodes[index - 1]);
	      });
	      nodes = ArrUtils.filter(nodes, NodeType.matchNodeNames(name));
	      return nodes[index];
	    };
	    var findTextPosition = function (container, offset) {
	      var node = container, targetOffset = 0, dataLen;
	      while (isText$5(node)) {
	        dataLen = node.data.length;
	        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
	          container = node;
	          offset = offset - targetOffset;
	          break;
	        }
	        if (!isText$5(node.nextSibling)) {
	          container = node;
	          offset = dataLen;
	          break;
	        }
	        targetOffset += dataLen;
	        node = node.nextSibling;
	      }
	      if (isText$5(container) && offset > container.data.length) {
	        offset = container.data.length;
	      }
	      return CaretPosition$1(container, offset);
	    };
	    var resolve$2 = function (root, path) {
	      var parts, container, offset;
	      if (!path) {
	        return null;
	      }
	      parts = path.split(',');
	      path = parts[0].split('/');
	      offset = parts.length > 1 ? parts[1] : 'before';
	      container = ArrUtils.reduce(path, function (result, value) {
	        value = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
	        if (!value) {
	          return null;
	        }
	        if (value[1] === 'text()') {
	          value[1] = '#text';
	        }
	        return resolvePathItem(result, value[1], parseInt(value[2], 10));
	      }, root);
	      if (!container) {
	        return null;
	      }
	      if (!isText$5(container)) {
	        if (offset === 'after') {
	          offset = nodeIndex$1(container) + 1;
	        } else {
	          offset = nodeIndex$1(container);
	        }
	        return CaretPosition$1(container.parentNode, offset);
	      }
	      return findTextPosition(container, parseInt(offset, 10));
	    };
	
	    var trimEmptyTextNode = function (dom, node) {
	      if (NodeType.isText(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var insertNode = function (dom, rng, node) {
	      rng.insertNode(node);
	      trimEmptyTextNode(dom, node.previousSibling);
	      trimEmptyTextNode(dom, node.nextSibling);
	    };
	    var insertFragment = function (dom, rng, frag) {
	      var firstChild = Option.from(frag.firstChild);
	      var lastChild = Option.from(frag.lastChild);
	      rng.insertNode(frag);
	      firstChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.previousSibling);
	      });
	      lastChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.nextSibling);
	      });
	    };
	    var rangeInsertNode = function (dom, rng, node) {
	      if (NodeType.isDocumentFragment(node)) {
	        insertFragment(dom, rng, node);
	      } else {
	        insertNode(dom, rng, node);
	      }
	    };
	
	    var isContentEditableFalse$2 = NodeType.isContentEditableFalse;
	    var getNormalizedTextOffset = function (trim, container, offset) {
	      var node, trimmedOffset;
	      trimmedOffset = trim(container.data.slice(0, offset)).length;
	      for (node = container.previousSibling; node && NodeType.isText(node); node = node.previousSibling) {
	        trimmedOffset += trim(node.data).length;
	      }
	      return trimmedOffset;
	    };
	    var getPoint = function (dom, trim, normalized, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      var point = [];
	      var childNodes, after = 0;
	      var root = dom.getRoot();
	      if (NodeType.isText(container)) {
	        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length && childNodes.length) {
	          after = 1;
	          offset = Math.max(0, childNodes.length - 1);
	        }
	        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
	      }
	      for (; container && container !== root; container = container.parentNode) {
	        point.push(dom.nodeIndex(container, normalized));
	      }
	      return point;
	    };
	    var getLocation = function (trim, selection, normalized, rng) {
	      var dom = selection.dom, bookmark = {};
	      bookmark.start = getPoint(dom, trim, normalized, rng, true);
	      if (!selection.isCollapsed()) {
	        bookmark.end = getPoint(dom, trim, normalized, rng, false);
	      }
	      return bookmark;
	    };
	    var findIndex$2 = function (dom, name, element) {
	      var count = 0;
	      Tools.each(dom.select(name), function (node) {
	        if (node.getAttribute('data-mce-bogus') === 'all') {
	          return;
	        }
	        if (node === element) {
	          return false;
	        }
	        count++;
	      });
	      return count;
	    };
	    var moveEndPoint = function (rng, start) {
	      var container, offset, childNodes;
	      var prefix = start ? 'start' : 'end';
	      container = rng[prefix + 'Container'];
	      offset = rng[prefix + 'Offset'];
	      if (NodeType.isElement(container) && container.nodeName === 'TR') {
	        childNodes = container.childNodes;
	        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
	        if (container) {
	          offset = start ? 0 : container.childNodes.length;
	          rng['set' + (start ? 'Start' : 'End')](container, offset);
	        }
	      }
	    };
	    var normalizeTableCellSelection = function (rng) {
	      moveEndPoint(rng, true);
	      moveEndPoint(rng, false);
	      return rng;
	    };
	    var findSibling = function (node, offset) {
	      var sibling;
	      if (NodeType.isElement(node)) {
	        node = getNode(node, offset);
	        if (isContentEditableFalse$2(node)) {
	          return node;
	        }
	      }
	      if (isCaretContainer(node)) {
	        if (NodeType.isText(node) && isCaretContainerBlock(node)) {
	          node = node.parentNode;
	        }
	        sibling = node.previousSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	        sibling = node.nextSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	      }
	    };
	    var findAdjacentContentEditableFalseElm = function (rng) {
	      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
	    };
	    var getOffsetBookmark = function (trim, normalized, selection) {
	      var element = selection.getNode();
	      var name = element ? element.nodeName : null;
	      var rng = selection.getRng();
	      if (isContentEditableFalse$2(element) || name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, element)
	        };
	      }
	      var sibling = findAdjacentContentEditableFalseElm(rng);
	      if (sibling) {
	        name = sibling.tagName;
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, sibling)
	        };
	      }
	      return getLocation(trim, selection, normalized, rng);
	    };
	    var getCaretBookmark = function (selection) {
	      var rng = selection.getRng();
	      return {
	        start: create$2(selection.dom.getRoot(), CaretPosition$1.fromRangeStart(rng)),
	        end: create$2(selection.dom.getRoot(), CaretPosition$1.fromRangeEnd(rng))
	      };
	    };
	    var getRangeBookmark = function (selection) {
	      return { rng: selection.getRng() };
	    };
	    var createBookmarkSpan = function (dom, id, filled) {
	      var args = {
	        'data-mce-type': 'bookmark',
	        'id': id,
	        'style': 'overflow:hidden;line-height:0px'
	      };
	      return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
	    };
	    var getPersistentBookmark = function (selection, filled) {
	      var dom = selection.dom;
	      var rng = selection.getRng();
	      var id = dom.uniqueId();
	      var collapsed = selection.isCollapsed();
	      var element = selection.getNode();
	      var name = element.nodeName;
	      if (name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(dom, name, element)
	        };
	      }
	      var rng2 = normalizeTableCellSelection(rng.cloneRange());
	      if (!collapsed) {
	        rng2.collapse(false);
	        var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
	        rangeInsertNode(dom, rng2, endBookmarkNode);
	      }
	      rng = normalizeTableCellSelection(rng);
	      rng.collapse(true);
	      var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
	      rangeInsertNode(dom, rng, startBookmarkNode);
	      selection.moveToBookmark({
	        id: id,
	        keep: 1
	      });
	      return { id: id };
	    };
	    var getBookmark = function (selection, type, normalized) {
	      if (type === 2) {
	        return getOffsetBookmark(Zwsp.trim, normalized, selection);
	      } else if (type === 3) {
	        return getCaretBookmark(selection);
	      } else if (type) {
	        return getRangeBookmark(selection);
	      } else {
	        return getPersistentBookmark(selection, false);
	      }
	    };
	    var GetBookmark = {
	      getBookmark: getBookmark,
	      getUndoBookmark: curry(getOffsetBookmark, identity, true),
	      getPersistentBookmark: getPersistentBookmark
	    };
	
	    var CARET_ID = '_mce_caret';
	    var isCaretNode = function (node) {
	      return NodeType.isElement(node) && node.id === CARET_ID;
	    };
	    var getParentCaretContainer = function (body, node) {
	      while (node && node !== body) {
	        if (node.id === CARET_ID) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isElement$4 = NodeType.isElement;
	    var isText$6 = NodeType.isText;
	    var removeNode = function (node) {
	      var parentNode = node.parentNode;
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	    };
	    var getNodeValue = function (node) {
	      try {
	        return node.nodeValue;
	      } catch (ex) {
	        return '';
	      }
	    };
	    var setNodeValue = function (node, text) {
	      if (text.length === 0) {
	        removeNode(node);
	      } else {
	        node.nodeValue = text;
	      }
	    };
	    var trimCount = function (text) {
	      var trimmedText = Zwsp.trim(text);
	      return {
	        count: text.length - trimmedText.length,
	        text: trimmedText
	      };
	    };
	    var removeUnchanged = function (caretContainer, pos) {
	      remove$5(caretContainer);
	      return pos;
	    };
	    var removeTextAndReposition = function (caretContainer, pos) {
	      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
	      var after = trimCount(caretContainer.data.substr(pos.offset()));
	      var text = before.text + after.text;
	      if (text.length > 0) {
	        setNodeValue(caretContainer, text);
	        return CaretPosition$1(caretContainer, pos.offset() - before.count);
	      } else {
	        return pos;
	      }
	    };
	    var removeElementAndReposition = function (caretContainer, pos) {
	      var parentNode = pos.container();
	      var newPosition = indexOf(from$1(parentNode.childNodes), caretContainer).map(function (index) {
	        return index < pos.offset() ? CaretPosition$1(parentNode, pos.offset() - 1) : pos;
	      }).getOr(pos);
	      remove$5(caretContainer);
	      return newPosition;
	    };
	    var removeTextCaretContainer = function (caretContainer, pos) {
	      return isText$6(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeElementCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeAndReposition = function (container, pos) {
	      return CaretPosition$1.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
	    };
	    var remove$5 = function (caretContainerNode) {
	      if (isElement$4(caretContainerNode) && isCaretContainer(caretContainerNode)) {
	        if (hasContent(caretContainerNode)) {
	          caretContainerNode.removeAttribute('data-mce-caret');
	        } else {
	          removeNode(caretContainerNode);
	        }
	      }
	      if (isText$6(caretContainerNode)) {
	        var text = Zwsp.trim(getNodeValue(caretContainerNode));
	        setNodeValue(caretContainerNode, text);
	      }
	    };
	    var CaretContainerRemove = {
	      removeAndReposition: removeAndReposition,
	      remove: remove$5
	    };
	
	    var browser$2 = PlatformDetection$1.detect().browser;
	    var isContentEditableFalse$3 = NodeType.isContentEditableFalse;
	    var isTableCell$1 = function (node) {
	      return NodeType.isElement(node) && /^(TD|TH)$/i.test(node.tagName);
	    };
	    var getAbsoluteClientRect = function (root, element, before) {
	      var clientRect = collapse(element.getBoundingClientRect(), before);
	      var docElm, scrollX, scrollY, margin, rootRect;
	      if (root.tagName === 'BODY') {
	        docElm = root.ownerDocument.documentElement;
	        scrollX = root.scrollLeft || docElm.scrollLeft;
	        scrollY = root.scrollTop || docElm.scrollTop;
	      } else {
	        rootRect = root.getBoundingClientRect();
	        scrollX = root.scrollLeft - rootRect.left;
	        scrollY = root.scrollTop - rootRect.top;
	      }
	      clientRect.left += scrollX;
	      clientRect.right += scrollX;
	      clientRect.top += scrollY;
	      clientRect.bottom += scrollY;
	      clientRect.width = 1;
	      margin = element.offsetWidth - element.clientWidth;
	      if (margin > 0) {
	        if (before) {
	          margin *= -1;
	        }
	        clientRect.left += margin;
	        clientRect.right += margin;
	      }
	      return clientRect;
	    };
	    var trimInlineCaretContainers = function (root) {
	      var contentEditableFalseNodes, node, sibling, i, data;
	      contentEditableFalseNodes = DomQuery('*[contentEditable=false]', root);
	      for (i = 0; i < contentEditableFalseNodes.length; i++) {
	        node = contentEditableFalseNodes[i];
	        sibling = node.previousSibling;
	        if (endsWithCaretContainer(sibling)) {
	          data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(data.length - 1, 1);
	          }
	        }
	        sibling = node.nextSibling;
	        if (startsWithCaretContainer(sibling)) {
	          data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(0, 1);
	          }
	        }
	      }
	    };
	    var FakeCaret = function (root, isBlock, hasFocus) {
	      var lastVisualCaret = Cell(Option.none());
	      var cursorInterval, caretContainerNode;
	      var show = function (before, element) {
	        var clientRect, rng;
	        hide();
	        if (isTableCell$1(element)) {
	          return null;
	        }
	        if (isBlock(element)) {
	          caretContainerNode = insertBlock('p', element, before);
	          clientRect = getAbsoluteClientRect(root, element, before);
	          DomQuery(caretContainerNode).css('top', clientRect.top);
	          var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(root)[0];
	          lastVisualCaret.set(Option.some({
	            caret: caret,
	            element: element,
	            before: before
	          }));
	          lastVisualCaret.get().each(function (caretState) {
	            if (before) {
	              DomQuery(caretState.caret).addClass('mce-visual-caret-before');
	            }
	          });
	          startBlink();
	          rng = element.ownerDocument.createRange();
	          rng.setStart(caretContainerNode, 0);
	          rng.setEnd(caretContainerNode, 0);
	        } else {
	          caretContainerNode = insertInline(element, before);
	          rng = element.ownerDocument.createRange();
	          if (isContentEditableFalse$3(caretContainerNode.nextSibling)) {
	            rng.setStart(caretContainerNode, 0);
	            rng.setEnd(caretContainerNode, 0);
	          } else {
	            rng.setStart(caretContainerNode, 1);
	            rng.setEnd(caretContainerNode, 1);
	          }
	          return rng;
	        }
	        return rng;
	      };
	      var hide = function () {
	        trimInlineCaretContainers(root);
	        if (caretContainerNode) {
	          CaretContainerRemove.remove(caretContainerNode);
	          caretContainerNode = null;
	        }
	        lastVisualCaret.get().each(function (caretState) {
	          DomQuery(caretState.caret).remove();
	          lastVisualCaret.set(Option.none());
	        });
	        clearInterval(cursorInterval);
	      };
	      var startBlink = function () {
	        cursorInterval = Delay.setInterval(function () {
	          if (hasFocus()) {
	            DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
	          } else {
	            DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
	          }
	        }, 500);
	      };
	      var reposition = function () {
	        lastVisualCaret.get().each(function (caretState) {
	          var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
	          DomQuery(caretState.caret).css(clientRect);
	        });
	      };
	      var destroy = function () {
	        return Delay.clearInterval(cursorInterval);
	      };
	      var getCss = function () {
	        return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
	      };
	      return {
	        show: show,
	        hide: hide,
	        getCss: getCss,
	        reposition: reposition,
	        destroy: destroy
	      };
	    };
	    var isFakeCaretTableBrowser = function () {
	      return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
	    };
	    var isFakeCaretTarget = function (node) {
	      return isContentEditableFalse$3(node) || NodeType.isTable(node) && isFakeCaretTableBrowser();
	    };
	
	    var isContentEditableFalse$4 = NodeType.isContentEditableFalse;
	    var isBlockLike = NodeType.matchStyleValues('display', 'block table table-cell table-caption list-item');
	    var isCaretContainer$2 = isCaretContainer;
	    var isCaretContainerBlock$1 = isCaretContainerBlock;
	    var isElement$5 = NodeType.isElement;
	    var isCaretCandidate$2 = isCaretCandidate;
	    var isForwards = function (direction) {
	      return direction > 0;
	    };
	    var isBackwards = function (direction) {
	      return direction < 0;
	    };
	    var skipCaretContainers = function (walk, shallow) {
	      var node;
	      while (node = walk(shallow)) {
	        if (!isCaretContainerBlock$1(node)) {
	          return node;
	        }
	      }
	      return null;
	    };
	    var findNode = function (node, direction, predicateFn, rootNode, shallow) {
	      var walker = new TreeWalker(node, rootNode);
	      if (isBackwards(direction)) {
	        if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
	          node = skipCaretContainers(walker.prev, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.prev, shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      if (isForwards(direction)) {
	        if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
	          node = skipCaretContainers(walker.next, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.next, shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var getParentBlock = function (node, rootNode) {
	      while (node && node !== rootNode) {
	        if (isBlockLike(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
	      return getParentBlock(caretPosition1.container(), rootNode) === getParentBlock(caretPosition2.container(), rootNode);
	    };
	    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
	      var container, offset;
	      if (!caretPosition) {
	        return null;
	      }
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (!isElement$5(container)) {
	        return null;
	      }
	      return container.childNodes[offset + relativeOffset];
	    };
	    var beforeAfter = function (before, node) {
	      var range = node.ownerDocument.createRange();
	      if (before) {
	        range.setStartBefore(node);
	        range.setEndBefore(node);
	      } else {
	        range.setStartAfter(node);
	        range.setEndAfter(node);
	      }
	      return range;
	    };
	    var isNodesInSameBlock = function (root, node1, node2) {
	      return getParentBlock(node1, root) === getParentBlock(node2, root);
	    };
	    var lean = function (left, root, node) {
	      var sibling, siblingName;
	      if (left) {
	        siblingName = 'previousSibling';
	      } else {
	        siblingName = 'nextSibling';
	      }
	      while (node && node !== root) {
	        sibling = node[siblingName];
	        if (isCaretContainer$2(sibling)) {
	          sibling = sibling[siblingName];
	        }
	        if (isContentEditableFalse$4(sibling)) {
	          if (isNodesInSameBlock(root, sibling, node)) {
	            return sibling;
	          }
	          break;
	        }
	        if (isCaretCandidate$2(sibling)) {
	          break;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var before$2 = curry(beforeAfter, true);
	    var after$1 = curry(beforeAfter, false);
	    var normalizeRange = function (direction, root, range) {
	      var node, container, offset, location;
	      var leanLeft = curry(lean, true, root);
	      var leanRight = curry(lean, false, root);
	      container = range.startContainer;
	      offset = range.startOffset;
	      if (isCaretContainerBlock(container)) {
	        if (!isElement$5(container)) {
	          container = container.parentNode;
	        }
	        location = container.getAttribute('data-mce-caret');
	        if (location === 'before') {
	          node = container.nextSibling;
	          if (isFakeCaretTarget(node)) {
	            return before$2(node);
	          }
	        }
	        if (location === 'after') {
	          node = container.previousSibling;
	          if (isFakeCaretTarget(node)) {
	            return after$1(node);
	          }
	        }
	      }
	      if (!range.collapsed) {
	        return range;
	      }
	      if (NodeType.isText(container)) {
	        if (isCaretContainer$2(container)) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (endsWithCaretContainer(container) && offset >= container.data.length - 1) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (startsWithCaretContainer(container) && offset <= 1) {
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          return range;
	        }
	        if (offset === container.data.length) {
	          node = leanRight(container);
	          if (node) {
	            return before$2(node);
	          }
	          return range;
	        }
	        if (offset === 0) {
	          node = leanLeft(container);
	          if (node) {
	            return after$1(node);
	          }
	          return range;
	        }
	      }
	      return range;
	    };
	    var getRelativeCefElm = function (forward, caretPosition) {
	      return Option.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$4);
	    };
	    var getNormalizedRangeEndPoint = function (direction, root, range) {
	      var normalizedRange = normalizeRange(direction, root, range);
	      if (direction === -1) {
	        return CaretPosition.fromRangeStart(normalizedRange);
	      }
	      return CaretPosition.fromRangeEnd(normalizedRange);
	    };
	    var getElementFromPosition = function (pos) {
	      return Option.from(pos.getNode()).map(Element.fromDom);
	    };
	    var getElementFromPrevPosition = function (pos) {
	      return Option.from(pos.getNode(true)).map(Element.fromDom);
	    };
	    var getVisualCaretPosition = function (walkFn, caretPosition) {
	      while (caretPosition = walkFn(caretPosition)) {
	        if (caretPosition.isVisible()) {
	          return caretPosition;
	        }
	      }
	      return caretPosition;
	    };
	    var isMoveInsideSameBlock = function (from, to) {
	      var inSameBlock = isInSameBlock(from, to);
	      if (!inSameBlock && NodeType.isBr(from.getNode())) {
	        return true;
	      }
	      return inSameBlock;
	    };
	
	    var HDirection;
	    (function (HDirection) {
	      HDirection[HDirection['Backwards'] = -1] = 'Backwards';
	      HDirection[HDirection['Forwards'] = 1] = 'Forwards';
	    }(HDirection || (HDirection = {})));
	    var isContentEditableFalse$5 = NodeType.isContentEditableFalse;
	    var isText$7 = NodeType.isText;
	    var isElement$6 = NodeType.isElement;
	    var isBr$4 = NodeType.isBr;
	    var isCaretCandidate$3 = isCaretCandidate;
	    var isAtomic$1 = isAtomic;
	    var isEditableCaretCandidate$1 = isEditableCaretCandidate;
	    var getParents = function (node, root) {
	      var parents = [];
	      while (node && node !== root) {
	        parents.push(node);
	        node = node.parentNode;
	      }
	      return parents;
	    };
	    var nodeAtIndex = function (container, offset) {
	      if (container.hasChildNodes() && offset < container.childNodes.length) {
	        return container.childNodes[offset];
	      }
	      return null;
	    };
	    var getCaretCandidatePosition = function (direction, node) {
	      if (isForwards(direction)) {
	        if (isCaretCandidate$3(node.previousSibling) && !isText$7(node.previousSibling)) {
	          return CaretPosition$1.before(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition$1(node, 0);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isCaretCandidate$3(node.nextSibling) && !isText$7(node.nextSibling)) {
	          return CaretPosition$1.after(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition$1(node, node.data.length);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isBr$4(node)) {
	          return CaretPosition$1.before(node);
	        }
	        return CaretPosition$1.after(node);
	      }
	      return CaretPosition$1.before(node);
	    };
	    var moveForwardFromBr = function (root, nextNode) {
	      var nextSibling = nextNode.nextSibling;
	      if (nextSibling && isCaretCandidate$3(nextSibling)) {
	        if (isText$7(nextSibling)) {
	          return CaretPosition$1(nextSibling, 0);
	        } else {
	          return CaretPosition$1.before(nextSibling);
	        }
	      } else {
	        return findCaretPosition(HDirection.Forwards, CaretPosition$1.after(nextNode), root);
	      }
	    };
	    var findCaretPosition = function (direction, startPos, root) {
	      var node, nextNode, innerNode;
	      var rootContentEditableFalseElm, caretPosition;
	      if (!isElement$6(root) || !startPos) {
	        return null;
	      }
	      if (startPos.isEqual(CaretPosition$1.after(root)) && root.lastChild) {
	        caretPosition = CaretPosition$1.after(root.lastChild);
	        if (isBackwards(direction) && isCaretCandidate$3(root.lastChild) && isElement$6(root.lastChild)) {
	          return isBr$4(root.lastChild) ? CaretPosition$1.before(root.lastChild) : caretPosition;
	        }
	      } else {
	        caretPosition = startPos;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (isText$7(container)) {
	        if (isBackwards(direction) && offset > 0) {
	          return CaretPosition$1(container, --offset);
	        }
	        if (isForwards(direction) && offset < container.length) {
	          return CaretPosition$1(container, ++offset);
	        }
	        node = container;
	      } else {
	        if (isBackwards(direction) && offset > 0) {
	          nextNode = nodeAtIndex(container, offset - 1);
	          if (isCaretCandidate$3(nextNode)) {
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition$1(innerNode, innerNode.data.length);
	                }
	                return CaretPosition$1.after(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition$1(nextNode, nextNode.data.length);
	            }
	            return CaretPosition$1.before(nextNode);
	          }
	        }
	        if (isForwards(direction) && offset < container.childNodes.length) {
	          nextNode = nodeAtIndex(container, offset);
	          if (isCaretCandidate$3(nextNode)) {
	            if (isBr$4(nextNode)) {
	              return moveForwardFromBr(root, nextNode);
	            }
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition$1(innerNode, 0);
	                }
	                return CaretPosition$1.before(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition$1(nextNode, 0);
	            }
	            return CaretPosition$1.after(nextNode);
	          }
	        }
	        node = nextNode ? nextNode : caretPosition.getNode();
	      }
	      if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
	        node = findNode(node, direction, constant(true), root, true);
	        if (isEditableCaretCandidate$1(node, root)) {
	          return getCaretCandidatePosition(direction, node);
	        }
	      }
	      nextNode = findNode(node, direction, isEditableCaretCandidate$1, root);
	      rootContentEditableFalseElm = ArrUtils.last(filter(getParents(container, root), isContentEditableFalse$5));
	      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
	        if (isForwards(direction)) {
	          caretPosition = CaretPosition$1.after(rootContentEditableFalseElm);
	        } else {
	          caretPosition = CaretPosition$1.before(rootContentEditableFalseElm);
	        }
	        return caretPosition;
	      }
	      if (nextNode) {
	        return getCaretCandidatePosition(direction, nextNode);
	      }
	      return null;
	    };
	    var CaretWalker = function (root) {
	      return {
	        next: function (caretPosition) {
	          return findCaretPosition(HDirection.Forwards, caretPosition, root);
	        },
	        prev: function (caretPosition) {
	          return findCaretPosition(HDirection.Backwards, caretPosition, root);
	        }
	      };
	    };
	
	    var walkToPositionIn = function (forward, root, start) {
	      var position = forward ? CaretPosition$1.before(start) : CaretPosition$1.after(start);
	      return fromPosition(forward, root, position);
	    };
	    var afterElement = function (node) {
	      return NodeType.isBr(node) ? CaretPosition$1.before(node) : CaretPosition$1.after(node);
	    };
	    var isBeforeOrStart = function (position) {
	      if (CaretPosition$1.isTextPosition(position)) {
	        return position.offset() === 0;
	      } else {
	        return isCaretCandidate(position.getNode());
	      }
	    };
	    var isAfterOrEnd = function (position) {
	      if (CaretPosition$1.isTextPosition(position)) {
	        var container = position.container();
	        return position.offset() === container.data.length;
	      } else {
	        return isCaretCandidate(position.getNode(true));
	      }
	    };
	    var isBeforeAfterSameElement = function (from, to) {
	      return !CaretPosition$1.isTextPosition(from) && !CaretPosition$1.isTextPosition(to) && from.getNode() === to.getNode(true);
	    };
	    var isAtBr = function (position) {
	      return !CaretPosition$1.isTextPosition(position) && NodeType.isBr(position.getNode());
	    };
	    var shouldSkipPosition = function (forward, from, to) {
	      if (forward) {
	        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
	      } else {
	        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
	      }
	    };
	    var fromPosition = function (forward, root, pos) {
	      var walker = CaretWalker(root);
	      return Option.from(forward ? walker.next(pos) : walker.prev(pos));
	    };
	    var navigate = function (forward, root, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
	          return fromPosition(forward, root, to);
	        } else {
	          return Option.some(to);
	        }
	      });
	    };
	    var navigateIgnore = function (forward, root, from, ignoreFilter) {
	      return navigate(forward, root, from).bind(function (pos) {
	        return ignoreFilter(pos) ? navigateIgnore(forward, root, pos, ignoreFilter) : Option.some(pos);
	      });
	    };
	    var positionIn = function (forward, element) {
	      var startNode = forward ? element.firstChild : element.lastChild;
	      if (NodeType.isText(startNode)) {
	        return Option.some(CaretPosition$1(startNode, forward ? 0 : startNode.data.length));
	      } else if (startNode) {
	        if (isCaretCandidate(startNode)) {
	          return Option.some(forward ? CaretPosition$1.before(startNode) : afterElement(startNode));
	        } else {
	          return walkToPositionIn(forward, element, startNode);
	        }
	      } else {
	        return Option.none();
	      }
	    };
	    var nextPosition = curry(fromPosition, true);
	    var prevPosition = curry(fromPosition, false);
	    var CaretFinder = {
	      fromPosition: fromPosition,
	      nextPosition: nextPosition,
	      prevPosition: prevPosition,
	      navigate: navigate,
	      navigateIgnore: navigateIgnore,
	      positionIn: positionIn,
	      firstPositionIn: curry(positionIn, true),
	      lastPositionIn: curry(positionIn, false)
	    };
	
	    var isStringPathBookmark = function (bookmark) {
	      return typeof bookmark.start === 'string';
	    };
	    var isRangeBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('rng');
	    };
	    var isIdBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('id');
	    };
	    var isIndexBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('name');
	    };
	    var isPathBookmark = function (bookmark) {
	      return Tools.isArray(bookmark.start);
	    };
	
	    var addBogus = function (dom, node) {
	      if (NodeType.isElement(node) && dom.isBlock(node) && !node.innerHTML && !Env.ie) {
	        node.innerHTML = '<br data-mce-bogus="1" />';
	      }
	      return node;
	    };
	    var resolveCaretPositionBookmark = function (dom, bookmark) {
	      var rng, pos;
	      rng = dom.createRng();
	      pos = resolve$2(dom.getRoot(), bookmark.start);
	      rng.setStart(pos.container(), pos.offset());
	      pos = resolve$2(dom.getRoot(), bookmark.end);
	      rng.setEnd(pos.container(), pos.offset());
	      return rng;
	    };
	    var insertZwsp = function (node, rng) {
	      var textNode = node.ownerDocument.createTextNode(Zwsp.ZWSP);
	      node.appendChild(textNode);
	      rng.setStart(textNode, 0);
	      rng.setEnd(textNode, 0);
	    };
	    var isEmpty = function (node) {
	      return node.hasChildNodes() === false;
	    };
	    var tryFindRangePosition = function (node, rng) {
	      return CaretFinder.lastPositionIn(node).fold(function () {
	        return false;
	      }, function (pos) {
	        rng.setStart(pos.container(), pos.offset());
	        rng.setEnd(pos.container(), pos.offset());
	        return true;
	      });
	    };
	    var padEmptyCaretContainer = function (root, node, rng) {
	      if (isEmpty(node) && getParentCaretContainer(root, node)) {
	        insertZwsp(node, rng);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var setEndPoint = function (dom, start, bookmark, rng) {
	      var point = bookmark[start ? 'start' : 'end'];
	      var i, node, offset, children;
	      var root = dom.getRoot();
	      if (point) {
	        offset = point[0];
	        for (node = root, i = point.length - 1; i >= 1; i--) {
	          children = node.childNodes;
	          if (padEmptyCaretContainer(root, node, rng)) {
	            return true;
	          }
	          if (point[i] > children.length - 1) {
	            if (padEmptyCaretContainer(root, node, rng)) {
	              return true;
	            }
	            return tryFindRangePosition(node, rng);
	          }
	          node = children[point[i]];
	        }
	        if (node.nodeType === 3) {
	          offset = Math.min(point[0], node.nodeValue.length);
	        }
	        if (node.nodeType === 1) {
	          offset = Math.min(point[0], node.childNodes.length);
	        }
	        if (start) {
	          rng.setStart(node, offset);
	        } else {
	          rng.setEnd(node, offset);
	        }
	      }
	      return true;
	    };
	    var isValidTextNode = function (node) {
	      return NodeType.isText(node) && node.data.length > 0;
	    };
	    var restoreEndPoint = function (dom, suffix, bookmark) {
	      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
	      var keep = bookmark.keep;
	      var container, offset;
	      if (marker) {
	        node = marker.parentNode;
	        if (suffix === 'start') {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.nextSibling)) {
	              node = marker.nextSibling;
	              idx = 0;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker) + 1;
	            }
	          }
	          container = node;
	          offset = idx;
	        } else {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker);
	            }
	          }
	          container = node;
	          offset = idx;
	        }
	        if (!keep) {
	          prev = marker.previousSibling;
	          next = marker.nextSibling;
	          Tools.each(Tools.grep(marker.childNodes), function (node) {
	            if (NodeType.isText(node)) {
	              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
	            }
	          });
	          while (marker = dom.get(bookmark.id + '_' + suffix)) {
	            dom.remove(marker, true);
	          }
	          if (prev && next && prev.nodeType === next.nodeType && NodeType.isText(prev) && !Env.opera) {
	            idx = prev.nodeValue.length;
	            prev.appendData(next.nodeValue);
	            dom.remove(next);
	            if (suffix === 'start') {
	              container = prev;
	              offset = idx;
	            } else {
	              container = prev;
	              offset = idx;
	            }
	          }
	        }
	        return Option.some(CaretPosition$1(container, offset));
	      } else {
	        return Option.none();
	      }
	    };
	    var alt = function (o1, o2) {
	      return o1.isSome() ? o1 : o2;
	    };
	    var resolvePaths = function (dom, bookmark) {
	      var rng = dom.createRng();
	      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
	        return Option.some(rng);
	      } else {
	        return Option.none();
	      }
	    };
	    var resolveId = function (dom, bookmark) {
	      var startPos = restoreEndPoint(dom, 'start', bookmark);
	      var endPos = restoreEndPoint(dom, 'end', bookmark);
	      return lift2(startPos, alt(endPos, startPos), function (spos, epos) {
	        var rng = dom.createRng();
	        rng.setStart(addBogus(dom, spos.container()), spos.offset());
	        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
	        return rng;
	      });
	    };
	    var resolveIndex$1 = function (dom, bookmark) {
	      return Option.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
	        var rng = dom.createRng();
	        rng.selectNode(elm);
	        return rng;
	      });
	    };
	    var resolve$3 = function (selection, bookmark) {
	      var dom = selection.dom;
	      if (bookmark) {
	        if (isPathBookmark(bookmark)) {
	          return resolvePaths(dom, bookmark);
	        } else if (isStringPathBookmark(bookmark)) {
	          return Option.some(resolveCaretPositionBookmark(dom, bookmark));
	        } else if (isIdBookmark(bookmark)) {
	          return resolveId(dom, bookmark);
	        } else if (isIndexBookmark(bookmark)) {
	          return resolveIndex$1(dom, bookmark);
	        } else if (isRangeBookmark(bookmark)) {
	          return Option.some(bookmark.rng);
	        }
	      }
	      return Option.none();
	    };
	    var ResolveBookmark = { resolve: resolve$3 };
	
	    var getBookmark$1 = function (selection, type, normalized) {
	      return GetBookmark.getBookmark(selection, type, normalized);
	    };
	    var moveToBookmark = function (selection, bookmark) {
	      ResolveBookmark.resolve(selection, bookmark).each(function (rng) {
	        selection.setRng(rng);
	      });
	    };
	    var isBookmarkNode$1 = function (node) {
	      return NodeType.isElement(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var Bookmarks = {
	      getBookmark: getBookmark$1,
	      moveToBookmark: moveToBookmark,
	      isBookmarkNode: isBookmarkNode$1
	    };
	
	    var isInlineBlock = function (node) {
	      return node && /^(IMG)$/.test(node.nodeName);
	    };
	    var moveStart = function (dom, selection, rng) {
	      var offset = rng.startOffset;
	      var container = rng.startContainer, walker, node, nodes;
	      if (rng.startContainer === rng.endContainer) {
	        if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
	          return;
	        }
	      }
	      if (container.nodeType === 1) {
	        nodes = container.childNodes;
	        if (offset < nodes.length) {
	          container = nodes[offset];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	        } else {
	          container = nodes[nodes.length - 1];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	          walker.next(true);
	        }
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3 && !isWhiteSpaceNode(node)) {
	            rng.setStart(node, 0);
	            selection.setRng(rng);
	            return;
	          }
	        }
	      }
	    };
	    var getNonWhiteSpaceSibling = function (node, next, inc) {
	      if (node) {
	        next = next ? 'nextSibling' : 'previousSibling';
	        for (node = inc ? node : node[next]; node; node = node[next]) {
	          if (node.nodeType === 1 || !isWhiteSpaceNode(node)) {
	            return node;
	          }
	        }
	      }
	    };
	    var isTextBlock$1 = function (editor, name) {
	      if (name.nodeType) {
	        name = name.nodeName;
	      }
	      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
	    };
	    var isValid = function (ed, parent, child) {
	      return ed.schema.isValidChild(parent, child);
	    };
	    var isWhiteSpaceNode = function (node) {
	      return node && node.nodeType === 3 && /^([\t \r\n]+|)$/.test(node.nodeValue);
	    };
	    var replaceVars = function (value, vars) {
	      if (typeof value !== 'string') {
	        value = value(vars);
	      } else if (vars) {
	        value = value.replace(/%(\w+)/g, function (str, name) {
	          return vars[name] || str;
	        });
	      }
	      return value;
	    };
	    var isEq = function (str1, str2) {
	      str1 = str1 || '';
	      str2 = str2 || '';
	      str1 = '' + (str1.nodeName || str1);
	      str2 = '' + (str2.nodeName || str2);
	      return str1.toLowerCase() === str2.toLowerCase();
	    };
	    var normalizeStyleValue = function (dom, value, name) {
	      if (name === 'color' || name === 'backgroundColor') {
	        value = dom.toHex(value);
	      }
	      if (name === 'fontWeight' && value === 700) {
	        value = 'bold';
	      }
	      if (name === 'fontFamily') {
	        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	      }
	      return '' + value;
	    };
	    var getStyle = function (dom, node, name) {
	      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
	    };
	    var getTextDecoration = function (dom, node) {
	      var decoration;
	      dom.getParent(node, function (n) {
	        decoration = dom.getStyle(n, 'text-decoration');
	        return decoration && decoration !== 'none';
	      });
	      return decoration;
	    };
	    var getParents$1 = function (dom, node, selector) {
	      return dom.getParents(node, selector, dom.getRoot());
	    };
	    var FormatUtils = {
	      isInlineBlock: isInlineBlock,
	      moveStart: moveStart,
	      getNonWhiteSpaceSibling: getNonWhiteSpaceSibling,
	      isTextBlock: isTextBlock$1,
	      isValid: isValid,
	      isWhiteSpaceNode: isWhiteSpaceNode,
	      replaceVars: replaceVars,
	      isEq: isEq,
	      normalizeStyleValue: normalizeStyleValue,
	      getStyle: getStyle,
	      getTextDecoration: getTextDecoration,
	      getParents: getParents$1
	    };
	
	    var isBookmarkNode$2 = Bookmarks.isBookmarkNode;
	    var getParents$2 = FormatUtils.getParents, isWhiteSpaceNode$1 = FormatUtils.isWhiteSpaceNode, isTextBlock$2 = FormatUtils.isTextBlock;
	    var findLeaf = function (node, offset) {
	      if (typeof offset === 'undefined') {
	        offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	      }
	      while (node && node.hasChildNodes()) {
	        node = node.childNodes[offset];
	        if (node) {
	          offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	        }
	      }
	      return {
	        node: node,
	        offset: offset
	      };
	    };
	    var excludeTrailingWhitespace = function (endContainer, endOffset) {
	      var leaf = findLeaf(endContainer, endOffset);
	      if (leaf.node) {
	        while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
	          leaf = findLeaf(leaf.node.previousSibling);
	        }
	        if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 && leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
	          if (leaf.offset > 1) {
	            endContainer = leaf.node;
	            endContainer.splitText(leaf.offset - 1);
	          }
	        }
	      }
	      return endContainer;
	    };
	    var isBogusBr = function (node) {
	      return node.nodeName === 'BR' && node.getAttribute('data-mce-bogus') && !node.nextSibling;
	    };
	    var findParentContentEditable = function (dom, node) {
	      var parent = node;
	      while (parent) {
	        if (parent.nodeType === 1 && dom.getContentEditable(parent)) {
	          return dom.getContentEditable(parent) === 'false' ? parent : node;
	        }
	        parent = parent.parentNode;
	      }
	      return node;
	    };
	    var findSpace = function (start, remove, node, offset) {
	      var pos, pos2;
	      var str = node.nodeValue;
	      if (typeof offset === 'undefined') {
	        offset = start ? str.length : 0;
	      }
	      if (start) {
	        pos = str.lastIndexOf(' ', offset);
	        pos2 = str.lastIndexOf('\xA0', offset);
	        pos = pos > pos2 ? pos : pos2;
	        if (pos !== -1 && !remove && (pos < offset || !start) && pos <= str.length) {
	          pos++;
	        }
	      } else {
	        pos = str.indexOf(' ', offset);
	        pos2 = str.indexOf('\xA0', offset);
	        pos = pos !== -1 && (pos2 === -1 || pos < pos2) ? pos : pos2;
	      }
	      return pos;
	    };
	    var findWordEndPoint = function (dom, body, container, offset, start, remove) {
	      var walker, node, pos, lastTextNode;
	      if (container.nodeType === 3) {
	        pos = findSpace(start, remove, container, offset);
	        if (pos !== -1) {
	          return {
	            container: container,
	            offset: pos
	          };
	        }
	        lastTextNode = container;
	      }
	      walker = new TreeWalker(container, dom.getParent(container, dom.isBlock) || body);
	      while (node = walker[start ? 'prev' : 'next']()) {
	        if (node.nodeType === 3 && !isBookmarkNode$2(node.parentNode)) {
	          lastTextNode = node;
	          pos = findSpace(start, remove, node);
	          if (pos !== -1) {
	            return {
	              container: node,
	              offset: pos
	            };
	          }
	        } else if (dom.isBlock(node) || FormatUtils.isEq(node, 'BR')) {
	          break;
	        }
	      }
	      if (lastTextNode) {
	        if (start) {
	          offset = 0;
	        } else {
	          offset = lastTextNode.length;
	        }
	        return {
	          container: lastTextNode,
	          offset: offset
	        };
	      }
	    };
	    var findSelectorEndPoint = function (dom, format, rng, container, siblingName) {
	      var parents, i, y, curFormat;
	      if (container.nodeType === 3 && container.nodeValue.length === 0 && container[siblingName]) {
	        container = container[siblingName];
	      }
	      parents = getParents$2(dom, container);
	      for (i = 0; i < parents.length; i++) {
	        for (y = 0; y < format.length; y++) {
	          curFormat = format[y];
	          if ('collapsed' in curFormat && curFormat.collapsed !== rng.collapsed) {
	            continue;
	          }
	          if (dom.is(parents[i], curFormat.selector)) {
	            return parents[i];
	          }
	        }
	      }
	      return container;
	    };
	    var findBlockEndPoint = function (editor, format, container, siblingName) {
	      var node;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      if (!format[0].wrapper) {
	        node = dom.getParent(container, format[0].block, root);
	      }
	      if (!node) {
	        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
	        node = dom.getParent(container.nodeType === 3 ? container.parentNode : container, function (node) {
	          return node !== root && isTextBlock$2(editor, node);
	        }, scopeRoot);
	      }
	      if (node && format[0].wrapper) {
	        node = getParents$2(dom, node, 'ul,ol').reverse()[0] || node;
	      }
	      if (!node) {
	        node = container;
	        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
	          node = node[siblingName];
	          if (FormatUtils.isEq(node, 'br')) {
	            break;
	          }
	        }
	      }
	      return node || container;
	    };
	    var findParentContainer = function (dom, format, startContainer, startOffset, endContainer, endOffset, start) {
	      var container, parent, sibling, siblingName, root;
	      container = parent = start ? startContainer : endContainer;
	      siblingName = start ? 'previousSibling' : 'nextSibling';
	      root = dom.getRoot();
	      if (container.nodeType === 3 && !isWhiteSpaceNode$1(container)) {
	        if (start ? startOffset > 0 : endOffset < container.nodeValue.length) {
	          return container;
	        }
	      }
	      while (true) {
	        if (!format[0].block_expand && dom.isBlock(parent)) {
	          return parent;
	        }
	        for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
	          if (!isBookmarkNode$2(sibling) && !isWhiteSpaceNode$1(sibling) && !isBogusBr(sibling)) {
	            return parent;
	          }
	        }
	        if (parent === root || parent.parentNode === root) {
	          container = parent;
	          break;
	        }
	        parent = parent.parentNode;
	      }
	      return container;
	    };
	    var expandRng = function (editor, rng, format, remove) {
	      var endPoint, startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      var dom = editor.dom;
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = getNode(startContainer, startOffset);
	        if (startContainer.nodeType === 3) {
	          startOffset = 0;
	        }
	      }
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getNode(endContainer, rng.collapsed ? endOffset : endOffset - 1);
	        if (endContainer.nodeType === 3) {
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      startContainer = findParentContentEditable(dom, startContainer);
	      endContainer = findParentContentEditable(dom, endContainer);
	      if (isBookmarkNode$2(startContainer.parentNode) || isBookmarkNode$2(startContainer)) {
	        startContainer = isBookmarkNode$2(startContainer) ? startContainer : startContainer.parentNode;
	        if (rng.collapsed) {
	          startContainer = startContainer.previousSibling || startContainer;
	        } else {
	          startContainer = startContainer.nextSibling || startContainer;
	        }
	        if (startContainer.nodeType === 3) {
	          startOffset = rng.collapsed ? startContainer.length : 0;
	        }
	      }
	      if (isBookmarkNode$2(endContainer.parentNode) || isBookmarkNode$2(endContainer)) {
	        endContainer = isBookmarkNode$2(endContainer) ? endContainer : endContainer.parentNode;
	        if (rng.collapsed) {
	          endContainer = endContainer.nextSibling || endContainer;
	        } else {
	          endContainer = endContainer.previousSibling || endContainer;
	        }
	        if (endContainer.nodeType === 3) {
	          endOffset = rng.collapsed ? 0 : endContainer.length;
	        }
	      }
	      if (rng.collapsed) {
	        endPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, remove);
	        if (endPoint) {
	          startContainer = endPoint.container;
	          startOffset = endPoint.offset;
	        }
	        endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, remove);
	        if (endPoint) {
	          endContainer = endPoint.container;
	          endOffset = endPoint.offset;
	        }
	      }
	      if (format[0].inline) {
	        endContainer = remove ? endContainer : excludeTrailingWhitespace(endContainer, endOffset);
	      }
	      if (format[0].inline || format[0].block_expand) {
	        if (!format[0].inline || (startContainer.nodeType !== 3 || startOffset === 0)) {
	          startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	        }
	        if (!format[0].inline || (endContainer.nodeType !== 3 || endOffset === endContainer.nodeValue.length)) {
	          endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	        }
	      }
	      if (format[0].selector && format[0].expand !== false && !format[0].inline) {
	        startContainer = findSelectorEndPoint(dom, format, rng, startContainer, 'previousSibling');
	        endContainer = findSelectorEndPoint(dom, format, rng, endContainer, 'nextSibling');
	      }
	      if (format[0].block || format[0].selector) {
	        startContainer = findBlockEndPoint(editor, format, startContainer, 'previousSibling');
	        endContainer = findBlockEndPoint(editor, format, endContainer, 'nextSibling');
	        if (format[0].block) {
	          if (!dom.isBlock(startContainer)) {
	            startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	          }
	          if (!dom.isBlock(endContainer)) {
	            endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	          }
	        }
	      }
	      if (startContainer.nodeType === 1) {
	        startOffset = dom.nodeIndex(startContainer);
	        startContainer = startContainer.parentNode;
	      }
	      if (endContainer.nodeType === 1) {
	        endOffset = dom.nodeIndex(endContainer) + 1;
	        endContainer = endContainer.parentNode;
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	    var ExpandRange = { expandRng: expandRng };
	
	    var each$8 = Tools.each;
	    var getEndChild = function (container, index) {
	      var childNodes = container.childNodes;
	      index--;
	      if (index > childNodes.length - 1) {
	        index = childNodes.length - 1;
	      } else if (index < 0) {
	        index = 0;
	      }
	      return childNodes[index] || container;
	    };
	    var walk$1 = function (dom, rng, callback) {
	      var startContainer = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endContainer = rng.endContainer;
	      var endOffset = rng.endOffset;
	      var ancestor;
	      var startPoint;
	      var endPoint;
	      var node;
	      var parent;
	      var siblings;
	      var nodes;
	      nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
	      if (nodes.length > 0) {
	        each$8(nodes, function (node) {
	          callback([node]);
	        });
	        return;
	      }
	      var exclude = function (nodes) {
	        var node;
	        node = nodes[0];
	        if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
	          nodes.splice(0, 1);
	        }
	        node = nodes[nodes.length - 1];
	        if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
	          nodes.splice(nodes.length - 1, 1);
	        }
	        return nodes;
	      };
	      var collectSiblings = function (node, name, endNode) {
	        var siblings = [];
	        for (; node && node !== endNode; node = node[name]) {
	          siblings.push(node);
	        }
	        return siblings;
	      };
	      var findEndPoint = function (node, root) {
	        do {
	          if (node.parentNode === root) {
	            return node;
	          }
	          node = node.parentNode;
	        } while (node);
	      };
	      var walkBoundary = function (startNode, endNode, next) {
	        var siblingName = next ? 'nextSibling' : 'previousSibling';
	        for (node = startNode, parent = node.parentNode; node && node !== endNode; node = parent) {
	          parent = node.parentNode;
	          siblings = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
	          if (siblings.length) {
	            if (!next) {
	              siblings.reverse();
	            }
	            callback(exclude(siblings));
	          }
	        }
	      };
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = startContainer.childNodes[startOffset];
	      }
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getEndChild(endContainer, endOffset);
	      }
	      if (startContainer === endContainer) {
	        return callback(exclude([startContainer]));
	      }
	      ancestor = dom.findCommonAncestor(startContainer, endContainer);
	      for (node = startContainer; node; node = node.parentNode) {
	        if (node === endContainer) {
	          return walkBoundary(startContainer, ancestor, true);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      for (node = endContainer; node; node = node.parentNode) {
	        if (node === startContainer) {
	          return walkBoundary(endContainer, ancestor);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      startPoint = findEndPoint(startContainer, ancestor) || startContainer;
	      endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	      walkBoundary(startContainer, startPoint, true);
	      siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
	      if (siblings.length) {
	        callback(exclude(siblings));
	      }
	      walkBoundary(endContainer, endPoint);
	    };
	    var RangeWalk = { walk: walk$1 };
	
	    var zeroWidth = function () {
	      return '\uFEFF';
	    };
	
	    function NodeValue (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom().nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    }
	
	    var api = NodeValue(isText, 'text');
	    var get$4 = function (element) {
	      return api.get(element);
	    };
	
	    var isZeroWidth = function (elem) {
	      return isText(elem) && get$4(elem) === zeroWidth();
	    };
	    var context = function (editor, elem, wrapName, nodeName) {
	      return parent(elem).fold(function () {
	        return 'skipping';
	      }, function (parent) {
	        if (nodeName === 'br' || isZeroWidth(elem)) {
	          return 'valid';
	        } else if (isAnnotation(elem)) {
	          return 'existing';
	        } else if (isCaretNode(elem)) {
	          return 'caret';
	        } else if (!FormatUtils.isValid(editor, wrapName, nodeName) || !FormatUtils.isValid(editor, name(parent), wrapName)) {
	          return 'invalid-child';
	        } else {
	          return 'valid';
	        }
	      });
	    };
	
	    var shouldApplyToTrailingSpaces = function (rng) {
	      return rng.startContainer.nodeType === 3 && rng.startContainer.nodeValue.length >= rng.startOffset && rng.startContainer.nodeValue[rng.startOffset] === '\xA0';
	    };
	    var applyWordGrab = function (editor, rng) {
	      var r = ExpandRange.expandRng(editor, rng, [{ inline: true }], shouldApplyToTrailingSpaces(rng));
	      rng.setStart(r.startContainer, r.startOffset);
	      rng.setEnd(r.endContainer, r.endOffset);
	      editor.selection.setRng(rng);
	    };
	    var makeAnnotation = function (eDoc, _a, annotationName, decorate) {
	      var _b = _a.uid, uid = _b === void 0 ? generate('mce-annotation') : _b, data = __rest(_a, ['uid']);
	      var master = Element.fromTag('span', eDoc);
	      add$2(master, annotation());
	      set(master, '' + dataAnnotationId(), uid);
	      set(master, '' + dataAnnotation(), annotationName);
	      var _c = decorate(uid, data), _d = _c.attributes, attributes = _d === void 0 ? {} : _d, _e = _c.classes, classes = _e === void 0 ? [] : _e;
	      setAll(master, attributes);
	      add$3(master, classes);
	      return master;
	    };
	    var annotate = function (editor, rng, annotationName, decorate, data) {
	      var newWrappers = [];
	      var master = makeAnnotation(editor.getDoc(), data, annotationName, decorate);
	      var wrapper = Cell(Option.none());
	      var finishWrapper = function () {
	        wrapper.set(Option.none());
	      };
	      var getOrOpenWrapper = function () {
	        return wrapper.get().getOrThunk(function () {
	          var nu = shallow(master);
	          newWrappers.push(nu);
	          wrapper.set(Option.some(nu));
	          return nu;
	        });
	      };
	      var processElements = function (elems) {
	        each(elems, processElement);
	      };
	      var processElement = function (elem) {
	        var ctx = context(editor, elem, 'span', name(elem));
	        switch (ctx) {
	        case 'invalid-child': {
	            finishWrapper();
	            var children$1 = children(elem);
	            processElements(children$1);
	            finishWrapper();
	            break;
	          }
	        case 'valid': {
	            var w = getOrOpenWrapper();
	            wrap$1(elem, w);
	            break;
	          }
	        case 'skipping':
	        case 'existing':
	        case 'caret':
	        }
	      };
	      var processNodes = function (nodes) {
	        var elems = map(nodes, Element.fromDom);
	        processElements(elems);
	      };
	      RangeWalk.walk(editor.dom, rng, function (nodes) {
	        finishWrapper();
	        processNodes(nodes);
	      });
	      return newWrappers;
	    };
	    var annotateWithBookmark = function (editor, name, settings, data) {
	      editor.undoManager.transact(function () {
	        var initialRng = editor.selection.getRng();
	        if (initialRng.collapsed) {
	          applyWordGrab(editor, initialRng);
	        }
	        if (editor.selection.getRng().collapsed) {
	          var wrapper = makeAnnotation(editor.getDoc(), data, name, settings.decorate);
	          set$1(wrapper, '\xA0');
	          editor.selection.getRng().insertNode(wrapper.dom());
	          editor.selection.select(wrapper.dom());
	        } else {
	          var bookmark = GetBookmark.getPersistentBookmark(editor.selection, false);
	          var rng = editor.selection.getRng();
	          annotate(editor, rng, name, settings.decorate, data);
	          editor.selection.moveToBookmark(bookmark);
	        }
	      });
	    };
	
	    function Annotator (editor) {
	      var registry = create$1();
	      setup$1(editor, registry);
	      var changes = setup(editor);
	      return {
	        register: function (name, settings) {
	          registry.register(name, settings);
	        },
	        annotate: function (name, data) {
	          registry.lookup(name).each(function (settings) {
	            annotateWithBookmark(editor, name, settings, data);
	          });
	        },
	        annotationChanged: function (name, callback) {
	          changes.addListener(name, callback);
	        },
	        remove: function (name) {
	          identify(editor, Option.some(name)).each(function (_a) {
	            var elements = _a.elements;
	            each(elements, unwrap);
	          });
	        },
	        getAll: function (name) {
	          var directory = findAll(editor, name);
	          return map$2(directory, function (elems) {
	            return map(elems, function (elem) {
	              return elem.dom();
	            });
	          });
	        }
	      };
	    }
	
	    var hasOnlyOneChild = function (node) {
	      return node.firstChild && node.firstChild === node.lastChild;
	    };
	    var isPaddingNode = function (node) {
	      return node.name === 'br' || node.value === '\xA0';
	    };
	    var isPaddedEmptyBlock = function (schema, node) {
	      var blockElements = schema.getBlockElements();
	      return blockElements[node.name] && hasOnlyOneChild(node) && isPaddingNode(node.firstChild);
	    };
	    var isEmptyFragmentElement = function (schema, node) {
	      var nonEmptyElements = schema.getNonEmptyElements();
	      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
	    };
	    var isListFragment = function (schema, fragment) {
	      var firstChild = fragment.firstChild;
	      var lastChild = fragment.lastChild;
	      if (firstChild && firstChild.name === 'meta') {
	        firstChild = firstChild.next;
	      }
	      if (lastChild && lastChild.attr('id') === 'mce_marker') {
	        lastChild = lastChild.prev;
	      }
	      if (isEmptyFragmentElement(schema, lastChild)) {
	        lastChild = lastChild.prev;
	      }
	      if (!firstChild || firstChild !== lastChild) {
	        return false;
	      }
	      return firstChild.name === 'ul' || firstChild.name === 'ol';
	    };
	    var cleanupDomFragment = function (domFragment) {
	      var firstChild = domFragment.firstChild;
	      var lastChild = domFragment.lastChild;
	      if (firstChild && firstChild.nodeName === 'META') {
	        firstChild.parentNode.removeChild(firstChild);
	      }
	      if (lastChild && lastChild.id === 'mce_marker') {
	        lastChild.parentNode.removeChild(lastChild);
	      }
	      return domFragment;
	    };
	    var toDomFragment = function (dom, serializer, fragment) {
	      var html = serializer.serialize(fragment);
	      var domFragment = dom.createFragment(html);
	      return cleanupDomFragment(domFragment);
	    };
	    var listItems$1 = function (elm) {
	      return Tools.grep(elm.childNodes, function (child) {
	        return child.nodeName === 'LI';
	      });
	    };
	    var isPadding = function (node) {
	      return node.data === '\xA0' || NodeType.isBr(node);
	    };
	    var isListItemPadded = function (node) {
	      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
	    };
	    var isEmptyOrPadded = function (elm) {
	      return !elm.firstChild || isListItemPadded(elm);
	    };
	    var trimListItems = function (elms) {
	      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
	    };
	    var getParentLi = function (dom, node) {
	      var parentBlock = dom.getParent(node, dom.isBlock);
	      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
	    };
	    var isParentBlockLi = function (dom, node) {
	      return !!getParentLi(dom, node);
	    };
	    var getSplit = function (parentNode, rng) {
	      var beforeRng = rng.cloneRange();
	      var afterRng = rng.cloneRange();
	      beforeRng.setStartBefore(parentNode);
	      afterRng.setEndAfter(parentNode);
	      return [
	        beforeRng.cloneContents(),
	        afterRng.cloneContents()
	      ];
	    };
	    var findFirstIn = function (node, rootNode) {
	      var caretPos = CaretPosition$1.before(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.next(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var findLastOf = function (node, rootNode) {
	      var caretPos = CaretPosition$1.after(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.prev(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var insertMiddle = function (target, elms, rootNode, rng) {
	      var parts = getSplit(target, rng);
	      var parentElm = target.parentNode;
	      parentElm.insertBefore(parts[0], target);
	      Tools.each(elms, function (li) {
	        parentElm.insertBefore(li, target);
	      });
	      parentElm.insertBefore(parts[1], target);
	      parentElm.removeChild(target);
	      return findLastOf(elms[elms.length - 1], rootNode);
	    };
	    var insertBefore = function (target, elms, rootNode) {
	      var parentElm = target.parentNode;
	      Tools.each(elms, function (elm) {
	        parentElm.insertBefore(elm, target);
	      });
	      return findFirstIn(target, rootNode);
	    };
	    var insertAfter = function (target, elms, rootNode, dom) {
	      dom.insertAfter(elms.reverse(), target);
	      return findLastOf(elms[0], rootNode);
	    };
	    var insertAtCaret = function (serializer, dom, rng, fragment) {
	      var domFragment = toDomFragment(dom, serializer, fragment);
	      var liTarget = getParentLi(dom, rng.startContainer);
	      var liElms = trimListItems(listItems$1(domFragment.firstChild));
	      var BEGINNING = 1, END = 2;
	      var rootNode = dom.getRoot();
	      var isAt = function (location) {
	        var caretPos = CaretPosition$1.fromRangeStart(rng);
	        var caretWalker = CaretWalker(dom.getRoot());
	        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
	      };
	      if (isAt(BEGINNING)) {
	        return insertBefore(liTarget, liElms, rootNode);
	      } else if (isAt(END)) {
	        return insertAfter(liTarget, liElms, rootNode, dom);
	      }
	      return insertMiddle(liTarget, liElms, rootNode, rng);
	    };
	    var InsertList = {
	      isListFragment: isListFragment,
	      insertAtCaret: insertAtCaret,
	      isParentBlockLi: isParentBlockLi,
	      trimListItems: trimListItems,
	      listItems: listItems$1
	    };
	
	    var each$9 = Tools.each;
	    var ElementUtils = function (dom) {
	      this.compare = function (node1, node2) {
	        if (node1.nodeName !== node2.nodeName) {
	          return false;
	        }
	        var getAttribs = function (node) {
	          var attribs = {};
	          each$9(dom.getAttribs(node), function (attr) {
	            var name = attr.nodeName.toLowerCase();
	            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
	              attribs[name] = dom.getAttrib(node, name);
	            }
	          });
	          return attribs;
	        };
	        var compareObjects = function (obj1, obj2) {
	          var value, name;
	          for (name in obj1) {
	            if (obj1.hasOwnProperty(name)) {
	              value = obj2[name];
	              if (typeof value === 'undefined') {
	                return false;
	              }
	              if (obj1[name] !== value) {
	                return false;
	              }
	              delete obj2[name];
	            }
	          }
	          for (name in obj2) {
	            if (obj2.hasOwnProperty(name)) {
	              return false;
	            }
	          }
	          return true;
	        };
	        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
	          return false;
	        }
	        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
	          return false;
	        }
	        return !Bookmarks.isBookmarkNode(node1) && !Bookmarks.isBookmarkNode(node2);
	      };
	    };
	
	    var getLastChildren = function (elm) {
	      var children = [];
	      var rawNode = elm.dom();
	      while (rawNode) {
	        children.push(Element.fromDom(rawNode));
	        rawNode = rawNode.lastChild;
	      }
	      return children;
	    };
	    var removeTrailingBr = function (elm) {
	      var allBrs = descendants$1(elm, 'br');
	      var brs = filter(getLastChildren(elm).slice(-1), isBr);
	      if (allBrs.length === brs.length) {
	        each(brs, remove$1);
	      }
	    };
	    var fillWithPaddingBr = function (elm) {
	      empty(elm);
	      append(elm, Element.fromHtml('<br data-mce-bogus="1">'));
	    };
	    var isPaddingContents = function (elm) {
	      return isText(elm) ? get$4(elm) === '\xA0' : isBr(elm);
	    };
	    var isPaddedElement = function (elm) {
	      return filter(children(elm), isPaddingContents).length === 1;
	    };
	    var trimBlockTrailingBr = function (elm) {
	      lastChild(elm).each(function (lastChild) {
	        prevSibling(lastChild).each(function (lastChildPrevSibling) {
	          if (isBlock(elm) && isBr(lastChild) && isBlock(lastChildPrevSibling)) {
	            remove$1(lastChild);
	          }
	        });
	      });
	    };
	    var PaddingBr = {
	      removeTrailingBr: removeTrailingBr,
	      fillWithPaddingBr: fillWithPaddingBr,
	      isPaddedElement: isPaddedElement,
	      trimBlockTrailingBr: trimBlockTrailingBr
	    };
	
	    var makeMap$3 = Tools.makeMap;
	    function Writer (settings) {
	      var html = [];
	      var indent, indentBefore, indentAfter, encode, htmlOutput;
	      settings = settings || {};
	      indent = settings.indent;
	      indentBefore = makeMap$3(settings.indent_before || '');
	      indentAfter = makeMap$3(settings.indent_after || '');
	      encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
	      htmlOutput = settings.element_format === 'html';
	      return {
	        start: function (name, attrs, empty) {
	          var i, l, attr, value;
	          if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	          html.push('<', name);
	          if (attrs) {
	            for (i = 0, l = attrs.length; i < l; i++) {
	              attr = attrs[i];
	              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
	            }
	          }
	          if (!empty || htmlOutput) {
	            html[html.length] = '>';
	          } else {
	            html[html.length] = ' />';
	          }
	          if (empty && indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        end: function (name) {
	          var value;
	          html.push('</', name, '>');
	          if (indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        text: function (text, raw) {
	          if (text.length > 0) {
	            html[html.length] = raw ? text : encode(text);
	          }
	        },
	        cdata: function (text) {
	          html.push('<![CDATA[', text, ']]>');
	        },
	        comment: function (text) {
	          html.push('<!--', text, '-->');
	        },
	        pi: function (name, text) {
	          if (text) {
	            html.push('<?', name, ' ', encode(text), '?>');
	          } else {
	            html.push('<?', name, '?>');
	          }
	          if (indent) {
	            html.push('\n');
	          }
	        },
	        doctype: function (text) {
	          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
	        },
	        reset: function () {
	          html.length = 0;
	        },
	        getContent: function () {
	          return html.join('').replace(/\n$/, '');
	        }
	      };
	    }
	
	    function HtmlSerializer (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var writer = Writer(settings);
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      var serialize = function (node) {
	        var handlers, validate;
	        validate = settings.validate;
	        handlers = {
	          3: function (node) {
	            writer.text(node.value, node.raw);
	          },
	          8: function (node) {
	            writer.comment(node.value);
	          },
	          7: function (node) {
	            writer.pi(node.name, node.value);
	          },
	          10: function (node) {
	            writer.doctype(node.value);
	          },
	          4: function (node) {
	            writer.cdata(node.value);
	          },
	          11: function (node) {
	            if (node = node.firstChild) {
	              do {
	                walk(node);
	              } while (node = node.next);
	            }
	          }
	        };
	        writer.reset();
	        var walk = function (node) {
	          var handler = handlers[node.type];
	          var name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
	          if (!handler) {
	            name = node.name;
	            isEmpty = node.shortEnded;
	            attrs = node.attributes;
	            if (validate && attrs && attrs.length > 1) {
	              sortedAttrs = [];
	              sortedAttrs.map = {};
	              elementRule = schema.getElementRule(node.name);
	              if (elementRule) {
	                for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
	                  attrName = elementRule.attributesOrder[i];
	                  if (attrName in attrs.map) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                for (i = 0, l = attrs.length; i < l; i++) {
	                  attrName = attrs[i].name;
	                  if (!(attrName in sortedAttrs.map)) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                attrs = sortedAttrs;
	              }
	            }
	            writer.start(node.name, attrs, isEmpty);
	            if (!isEmpty) {
	              if (node = node.firstChild) {
	                do {
	                  walk(node);
	                } while (node = node.next);
	              }
	              writer.end(name);
	            }
	          } else {
	            handler(node);
	          }
	        };
	        if (node.type === 1 && !settings.inner) {
	          walk(node);
	        } else {
	          handlers[11](node);
	        }
	        return writer.getContent();
	      };
	      return { serialize: serialize };
	    }
	
	    var createRange$1 = function (sc, so, ec, eo) {
	      var rng = domGlobals.document.createRange();
	      rng.setStart(sc, so);
	      rng.setEnd(ec, eo);
	      return rng;
	    };
	    var normalizeBlockSelectionRange = function (rng) {
	      var startPos = CaretPosition$1.fromRangeStart(rng);
	      var endPos = CaretPosition$1.fromRangeEnd(rng);
	      var rootNode = rng.commonAncestorContainer;
	      return CaretFinder.fromPosition(false, rootNode, endPos).map(function (newEndPos) {
	        if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
	          return createRange$1(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
	        } else {
	          return rng;
	        }
	      }).getOr(rng);
	    };
	    var normalize = function (rng) {
	      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
	    };
	    var RangeNormalizer = { normalize: normalize };
	
	    var isAfterNbsp = function (container, offset) {
	      return NodeType.isText(container) && container.nodeValue[offset - 1] === '\xA0';
	    };
	    var trimOrPadLeftRight = function (rng, html) {
	      var container, offset;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      var hasSiblingText = function (siblingName) {
	        return container[siblingName] && container[siblingName].nodeType === 3;
	      };
	      if (container.nodeType === 3) {
	        if (offset > 0) {
	          html = html.replace(/^&nbsp;/, ' ');
	        } else if (!hasSiblingText('previousSibling')) {
	          html = html.replace(/^ /, '&nbsp;');
	        }
	        if (offset < container.length) {
	          html = html.replace(/&nbsp;(<br>|)$/, ' ');
	        } else if (!hasSiblingText('nextSibling')) {
	          html = html.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;');
	        }
	      }
	      return html;
	    };
	    var trimNbspAfterDeleteAndPadValue = function (rng, value) {
	      var container, offset;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      if (container.nodeType === 3 && rng.collapsed) {
	        if (container.data[offset] === '\xA0') {
	          container.deleteData(offset, 1);
	          if (!/[\u00a0| ]$/.test(value)) {
	            value += ' ';
	          }
	        } else if (container.data[offset - 1] === '\xA0') {
	          container.deleteData(offset - 1, 1);
	          if (!/[\u00a0| ]$/.test(value)) {
	            value = ' ' + value;
	          }
	        }
	      }
	      return value;
	    };
	
	    var isTableCell$2 = NodeType.matchNodeNames('td th');
	    var selectionSetContent = function (editor, content) {
	      var rng = editor.selection.getRng();
	      var container = rng.startContainer;
	      var offset = rng.startOffset;
	      if (rng.collapsed && isAfterNbsp(container, offset) && NodeType.isText(container)) {
	        container.insertData(offset - 1, ' ');
	        container.deleteData(offset, 1);
	        rng.setStart(container, offset);
	        rng.setEnd(container, offset);
	        editor.selection.setRng(rng);
	      }
	      editor.selection.setContent(content);
	    };
	    var validInsertion = function (editor, value, parentNode) {
	      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
	        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
	      } else {
	        var node = parentNode.firstChild;
	        var node2 = parentNode.lastChild;
	        if (!node || node === node2 && node.nodeName === 'BR') {
	          editor.dom.setHTML(parentNode, value);
	        } else {
	          selectionSetContent(editor, value);
	        }
	      }
	    };
	    var trimBrsFromTableCell = function (dom, elm) {
	      Option.from(dom.getParent(elm, 'td,th')).map(Element.fromDom).each(PaddingBr.trimBlockTrailingBr);
	    };
	    var reduceInlineTextElements = function (editor, merge) {
	      var textInlineElements = editor.schema.getTextInlineElements();
	      var dom = editor.dom;
	      if (merge) {
	        var root_1 = editor.getBody(), elementUtils_1 = new ElementUtils(dom);
	        Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
	          for (var testNode = node.parentNode; testNode && testNode !== root_1; testNode = testNode.parentNode) {
	            if (textInlineElements[node.nodeName.toLowerCase()] && elementUtils_1.compare(testNode, node)) {
	              dom.remove(node, true);
	            }
	          }
	        });
	      }
	    };
	    var markFragmentElements = function (fragment) {
	      var node = fragment;
	      while (node = node.walk()) {
	        if (node.type === 1) {
	          node.attr('data-mce-fragment', '1');
	        }
	      }
	    };
	    var umarkFragmentElements = function (elm) {
	      Tools.each(elm.getElementsByTagName('*'), function (elm) {
	        elm.removeAttribute('data-mce-fragment');
	      });
	    };
	    var isPartOfFragment = function (node) {
	      return !!node.getAttribute('data-mce-fragment');
	    };
	    var canHaveChildren = function (editor, node) {
	      return node && !editor.schema.getShortEndedElements()[node.nodeName];
	    };
	    var moveSelectionToMarker = function (editor, marker) {
	      var parentEditableFalseElm, parentBlock, nextRng;
	      var dom = editor.dom, selection = editor.selection;
	      var node, node2;
	      var getContentEditableFalseParent = function (node) {
	        var root = editor.getBody();
	        for (; node && node !== root; node = node.parentNode) {
	          if (editor.dom.getContentEditable(node) === 'false') {
	            return node;
	          }
	        }
	        return null;
	      };
	      if (!marker) {
	        return;
	      }
	      editor.selection.scrollIntoView(marker);
	      parentEditableFalseElm = getContentEditableFalseParent(marker);
	      if (parentEditableFalseElm) {
	        dom.remove(marker);
	        selection.select(parentEditableFalseElm);
	        return;
	      }
	      var rng = dom.createRng();
	      node = marker.previousSibling;
	      if (node && node.nodeType === 3) {
	        rng.setStart(node, node.nodeValue.length);
	        if (!Env.ie) {
	          node2 = marker.nextSibling;
	          if (node2 && node2.nodeType === 3) {
	            node.appendData(node2.data);
	            node2.parentNode.removeChild(node2);
	          }
	        }
	      } else {
	        rng.setStartBefore(marker);
	        rng.setEndBefore(marker);
	      }
	      var findNextCaretRng = function (rng) {
	        var caretPos = CaretPosition$1.fromRangeStart(rng);
	        var caretWalker = CaretWalker(editor.getBody());
	        caretPos = caretWalker.next(caretPos);
	        if (caretPos) {
	          return caretPos.toRange();
	        }
	      };
	      parentBlock = dom.getParent(marker, dom.isBlock);
	      dom.remove(marker);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        editor.$(parentBlock).empty();
	        rng.setStart(parentBlock, 0);
	        rng.setEnd(parentBlock, 0);
	        if (!isTableCell$2(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
	          rng = nextRng;
	          dom.remove(parentBlock);
	        } else {
	          dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      selection.setRng(rng);
	    };
	    var insertHtmlAtCaret = function (editor, value, details) {
	      var parser, serializer, parentNode, rootNode, fragment, args;
	      var marker, rng, node, bookmarkHtml, merge;
	      var selection = editor.selection, dom = editor.dom;
	      if (/^ | $/.test(value)) {
	        value = trimOrPadLeftRight(selection.getRng(), value);
	      }
	      parser = editor.parser;
	      merge = details.merge;
	      serializer = HtmlSerializer({ validate: editor.settings.validate }, editor.schema);
	      bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
	      args = {
	        content: value,
	        format: 'html',
	        selection: true,
	        paste: details.paste
	      };
	      args = editor.fire('BeforeSetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('SetContent', {
	          content: args.content,
	          format: 'html',
	          selection: true,
	          paste: details.paste
	        });
	        return;
	      }
	      value = args.content;
	      if (value.indexOf('{$caret}') === -1) {
	        value += '{$caret}';
	      }
	      value = value.replace(/\{\$caret\}/, bookmarkHtml);
	      rng = selection.getRng();
	      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
	      var body = editor.getBody();
	      if (caretElement === body && selection.isCollapsed()) {
	        if (dom.isBlock(body.firstChild) && canHaveChildren(editor, body.firstChild) && dom.isEmpty(body.firstChild)) {
	          rng = dom.createRng();
	          rng.setStart(body.firstChild, 0);
	          rng.setEnd(body.firstChild, 0);
	          selection.setRng(rng);
	        }
	      }
	      if (!selection.isCollapsed()) {
	        editor.selection.setRng(RangeNormalizer.normalize(editor.selection.getRng()));
	        editor.getDoc().execCommand('Delete', false, null);
	        value = trimNbspAfterDeleteAndPadValue(editor.selection.getRng(), value);
	      }
	      parentNode = selection.getNode();
	      var parserArgs = {
	        context: parentNode.nodeName.toLowerCase(),
	        data: details.data,
	        insert: true
	      };
	      fragment = parser.parse(value, parserArgs);
	      if (details.paste === true && InsertList.isListFragment(editor.schema, fragment) && InsertList.isParentBlockLi(dom, parentNode)) {
	        rng = InsertList.insertAtCaret(serializer, dom, editor.selection.getRng(), fragment);
	        editor.selection.setRng(rng);
	        editor.fire('SetContent', args);
	        return;
	      }
	      markFragmentElements(fragment);
	      node = fragment.lastChild;
	      if (node.attr('id') === 'mce_marker') {
	        marker = node;
	        for (node = node.prev; node; node = node.walk(true)) {
	          if (node.type === 3 || !dom.isBlock(node.name)) {
	            if (editor.schema.isValidChild(node.parent.name, 'span')) {
	              node.parent.insert(marker, node, node.name === 'br');
	            }
	            break;
	          }
	        }
	      }
	      editor._selectionOverrides.showBlockCaretContainer(parentNode);
	      if (!parserArgs.invalid) {
	        value = serializer.serialize(fragment);
	        validInsertion(editor, value, parentNode);
	      } else {
	        selectionSetContent(editor, bookmarkHtml);
	        parentNode = selection.getNode();
	        rootNode = editor.getBody();
	        if (parentNode.nodeType === 9) {
	          parentNode = node = rootNode;
	        } else {
	          node = parentNode;
	        }
	        while (node !== rootNode) {
	          parentNode = node;
	          node = node.parentNode;
	        }
	        value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
	        value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
	          return serializer.serialize(fragment);
	        })));
	        if (parentNode === rootNode) {
	          dom.setHTML(rootNode, value);
	        } else {
	          dom.setOuterHTML(parentNode, value);
	        }
	      }
	      reduceInlineTextElements(editor, merge);
	      moveSelectionToMarker(editor, dom.get('mce_marker'));
	      umarkFragmentElements(editor.getBody());
	      trimBrsFromTableCell(editor.dom, editor.selection.getStart());
	      editor.fire('SetContent', args);
	      editor.addVisual();
	    };
	    var processValue = function (value) {
	      var details;
	      if (typeof value !== 'string') {
	        details = Tools.extend({
	          paste: value.paste,
	          data: { paste: value.paste }
	        }, value);
	        return {
	          content: value.content,
	          details: details
	        };
	      }
	      return {
	        content: value,
	        details: {}
	      };
	    };
	    var insertAtCaret$1 = function (editor, value) {
	      var result = processValue(value);
	      insertHtmlAtCaret(editor, result.content, result.details);
	    };
	    var InsertContent = { insertAtCaret: insertAtCaret$1 };
	
	    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
	    var hasStrongRtl = function (text) {
	      return strongRtl.test(text);
	    };
	
	    var getBodySetting = function (editor, name, defaultValue) {
	      var value = editor.getParam(name, defaultValue);
	      if (value.indexOf('=') !== -1) {
	        var bodyObj = editor.getParam(name, '', 'hash');
	        return bodyObj.hasOwnProperty(editor.id) ? bodyObj[editor.id] : defaultValue;
	      } else {
	        return value;
	      }
	    };
	    var getIframeAttrs = function (editor) {
	      return editor.getParam('iframe_attrs', {});
	    };
	    var getDocType = function (editor) {
	      return editor.getParam('doctype', '<!DOCTYPE html>');
	    };
	    var getDocumentBaseUrl = function (editor) {
	      return editor.getParam('document_base_url', '');
	    };
	    var getBodyId = function (editor) {
	      return getBodySetting(editor, 'body_id', 'tinymce');
	    };
	    var getBodyClass = function (editor) {
	      return getBodySetting(editor, 'body_class', '');
	    };
	    var getContentSecurityPolicy = function (editor) {
	      return editor.getParam('content_security_policy', '');
	    };
	    var shouldPutBrInPre = function (editor) {
	      return editor.getParam('br_in_pre', true);
	    };
	    var getForcedRootBlock = function (editor) {
	      if (editor.getParam('force_p_newlines', false)) {
	        return 'p';
	      }
	      var block = editor.getParam('forced_root_block', 'p');
	      return block === false ? '' : block;
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	    var getBrNewLineSelector = function (editor) {
	      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
	    };
	    var getNoNewLineSelector = function (editor) {
	      return editor.getParam('no_newline_selector', '');
	    };
	    var shouldKeepStyles = function (editor) {
	      return editor.getParam('keep_styles', true);
	    };
	    var shouldEndContainerOnEmptyBlock = function (editor) {
	      return editor.getParam('end_container_on_empty_block', false);
	    };
	    var getFontStyleValues = function (editor) {
	      return Tools.explode(editor.getParam('font_size_style_values', ''));
	    };
	    var getFontSizeClasses = function (editor) {
	      return Tools.explode(editor.getParam('font_size_classes', ''));
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter', constant(true), 'function');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	    var shouldReuseFileName = function (editor) {
	      return editor.getParam('images_reuse_filename', false, 'boolean');
	    };
	    var shouldReplaceBlobUris = function (editor) {
	      return editor.getParam('images_replace_blob_uris', true, 'boolean');
	    };
	    var getImageUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', '', 'string');
	    };
	    var getImageUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path', '', 'string');
	    };
	    var getImagesUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials', false, 'boolean');
	    };
	    var getImagesUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', null, 'function');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getInlineBoundarySelector = function (editor) {
	      return editor.getParam('inline_boundaries_selector', 'a[href],code,.mce-annotation', 'string');
	    };
	    var Settings = {
	      getIframeAttrs: getIframeAttrs,
	      getDocType: getDocType,
	      getDocumentBaseUrl: getDocumentBaseUrl,
	      getBodyId: getBodyId,
	      getBodyClass: getBodyClass,
	      getContentSecurityPolicy: getContentSecurityPolicy,
	      shouldPutBrInPre: shouldPutBrInPre,
	      getForcedRootBlock: getForcedRootBlock,
	      getForcedRootBlockAttrs: getForcedRootBlockAttrs,
	      getBrNewLineSelector: getBrNewLineSelector,
	      getNoNewLineSelector: getNoNewLineSelector,
	      shouldKeepStyles: shouldKeepStyles,
	      shouldEndContainerOnEmptyBlock: shouldEndContainerOnEmptyBlock,
	      getFontStyleValues: getFontStyleValues,
	      getFontSizeClasses: getFontSizeClasses,
	      getImagesDataImgFilter: getImagesDataImgFilter,
	      isAutomaticUploadsEnabled: isAutomaticUploadsEnabled,
	      shouldReuseFileName: shouldReuseFileName,
	      shouldReplaceBlobUris: shouldReplaceBlobUris,
	      getImageUploadUrl: getImageUploadUrl,
	      getImageUploadBasePath: getImageUploadBasePath,
	      getImagesUploadCredentials: getImagesUploadCredentials,
	      getImagesUploadHandler: getImagesUploadHandler,
	      shouldUseContentCssCors: shouldUseContentCssCors,
	      getInlineBoundarySelector: getInlineBoundarySelector
	    };
	
	    var isInlineTarget = function (editor, elm) {
	      return is$1(Element.fromDom(elm), Settings.getInlineBoundarySelector(editor));
	    };
	    var isRtl = function (element) {
	      return DOMUtils$1.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
	    };
	    var findInlineParents = function (isInlineTarget, rootNode, pos) {
	      return filter(DOMUtils$1.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
	    };
	    var findRootInline = function (isInlineTarget, rootNode, pos) {
	      var parents = findInlineParents(isInlineTarget, rootNode, pos);
	      return Option.from(parents[parents.length - 1]);
	    };
	    var hasSameParentBlock = function (rootNode, node1, node2) {
	      var block1 = getParentBlock(node1, rootNode);
	      var block2 = getParentBlock(node2, rootNode);
	      return block1 && block1 === block2;
	    };
	    var isAtZwsp = function (pos) {
	      return isBeforeInline(pos) || isAfterInline(pos);
	    };
	    var normalizePosition = function (forward, pos) {
	      if (!pos) {
	        return pos;
	      }
	      var container = pos.container(), offset = pos.offset();
	      if (forward) {
	        if (isCaretContainerInline(container)) {
	          if (NodeType.isText(container.nextSibling)) {
	            return CaretPosition$1(container.nextSibling, 0);
	          } else {
	            return CaretPosition$1.after(container);
	          }
	        } else {
	          return isBeforeInline(pos) ? CaretPosition$1(container, offset + 1) : pos;
	        }
	      } else {
	        if (isCaretContainerInline(container)) {
	          if (NodeType.isText(container.previousSibling)) {
	            return CaretPosition$1(container.previousSibling, container.previousSibling.data.length);
	          } else {
	            return CaretPosition$1.before(container);
	          }
	        } else {
	          return isAfterInline(pos) ? CaretPosition$1(container, offset - 1) : pos;
	        }
	      }
	    };
	    var normalizeForwards = curry(normalizePosition, true);
	    var normalizeBackwards = curry(normalizePosition, false);
	    var InlineUtils = {
	      isInlineTarget: isInlineTarget,
	      findRootInline: findRootInline,
	      isRtl: isRtl,
	      isAtZwsp: isAtZwsp,
	      normalizePosition: normalizePosition,
	      normalizeForwards: normalizeForwards,
	      normalizeBackwards: normalizeBackwards,
	      hasSameParentBlock: hasSameParentBlock
	    };
	
	    var isBeforeRoot = function (rootNode) {
	      return function (elm) {
	        return eq(rootNode, Element.fromDom(elm.dom().parentNode));
	      };
	    };
	    var getParentBlock$1 = function (rootNode, elm) {
	      return contains$3(rootNode, elm) ? closest(elm, function (element) {
	        return isTextBlock(element) || isListItem(element);
	      }, isBeforeRoot(rootNode)) : Option.none();
	    };
	    var placeCaretInEmptyBody = function (editor) {
	      var body = editor.getBody();
	      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
	      editor.selection.setCursorLocation(node, 0);
	    };
	    var paddEmptyBody = function (editor) {
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        placeCaretInEmptyBody(editor);
	      }
	    };
	    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
	      return lift2(CaretFinder.firstPositionIn(elm), CaretFinder.lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	        var normalizedFromPos = InlineUtils.normalizePosition(false, fromPos);
	        if (forward) {
	          return CaretFinder.nextPosition(elm, normalizedFromPos).map(function (nextPos) {
	            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
	          }).getOr(false);
	        } else {
	          return CaretFinder.prevPosition(elm, normalizedFromPos).map(function (prevPos) {
	            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
	          }).getOr(false);
	        }
	      }).getOr(true);
	    };
	    var DeleteUtils = {
	      getParentBlock: getParentBlock$1,
	      paddEmptyBody: paddEmptyBody,
	      willDeleteLastPositionInElement: willDeleteLastPositionInElement
	    };
	
	    var ancestor$2 = function (scope, selector, isRoot) {
	      return ancestor$1(scope, selector, isRoot).isSome();
	    };
	
	    var hasWhitespacePreserveParent = function (rootNode, node) {
	      var rootElement = Element.fromDom(rootNode);
	      var startNode = Element.fromDom(node);
	      return ancestor$2(startNode, 'pre,code', curry(eq, rootElement));
	    };
	    var isWhitespace = function (rootNode, node) {
	      return NodeType.isText(node) && /^[ \t\r\n]*$/.test(node.data) && hasWhitespacePreserveParent(rootNode, node) === false;
	    };
	    var isNamedAnchor = function (node) {
	      return NodeType.isElement(node) && node.nodeName === 'A' && node.hasAttribute('name');
	    };
	    var isContent = function (rootNode, node) {
	      return isCaretCandidate(node) && isWhitespace(rootNode, node) === false || isNamedAnchor(node) || isBookmark(node);
	    };
	    var isBookmark = NodeType.hasAttribute('data-mce-bookmark');
	    var isBogus$2 = NodeType.hasAttribute('data-mce-bogus');
	    var isBogusAll$1 = NodeType.hasAttributeValue('data-mce-bogus', 'all');
	    var isEmptyNode = function (targetNode) {
	      var walker, node, brCount = 0;
	      if (isContent(targetNode, targetNode)) {
	        return false;
	      } else {
	        node = targetNode.firstChild;
	        if (!node) {
	          return true;
	        }
	        walker = new TreeWalker(node, targetNode);
	        do {
	          if (isBogusAll$1(node)) {
	            node = walker.next(true);
	            continue;
	          }
	          if (isBogus$2(node)) {
	            node = walker.next();
	            continue;
	          }
	          if (NodeType.isBr(node)) {
	            brCount++;
	            node = walker.next();
	            continue;
	          }
	          if (isContent(targetNode, node)) {
	            return false;
	          }
	          node = walker.next();
	        } while (node);
	        return brCount <= 1;
	      }
	    };
	    var isEmpty$1 = function (elm) {
	      return isEmptyNode(elm.dom());
	    };
	    var Empty = { isEmpty: isEmpty$1 };
	
	    var BlockPosition = Immutable('block', 'position');
	    var BlockBoundary = Immutable('from', 'to');
	    var getBlockPosition = function (rootNode, pos) {
	      var rootElm = Element.fromDom(rootNode);
	      var containerElm = Element.fromDom(pos.container());
	      return DeleteUtils.getParentBlock(rootElm, containerElm).map(function (block) {
	        return BlockPosition(block, pos);
	      });
	    };
	    var isDifferentBlocks = function (blockBoundary) {
	      return eq(blockBoundary.from().block(), blockBoundary.to().block()) === false;
	    };
	    var hasSameParent = function (blockBoundary) {
	      return parent(blockBoundary.from().block()).bind(function (parent1) {
	        return parent(blockBoundary.to().block()).filter(function (parent2) {
	          return eq(parent1, parent2);
	        });
	      }).isSome();
	    };
	    var isEditable = function (blockBoundary) {
	      return NodeType.isContentEditableFalse(blockBoundary.from().block().dom()) === false && NodeType.isContentEditableFalse(blockBoundary.to().block().dom()) === false;
	    };
	    var skipLastBr = function (rootNode, forward, blockPosition) {
	      if (NodeType.isBr(blockPosition.position().getNode()) && Empty.isEmpty(blockPosition.block()) === false) {
	        return CaretFinder.positionIn(false, blockPosition.block().dom()).bind(function (lastPositionInBlock) {
	          if (lastPositionInBlock.isEqual(blockPosition.position())) {
	            return CaretFinder.fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
	              return getBlockPosition(rootNode, to);
	            });
	          } else {
	            return Option.some(blockPosition);
	          }
	        }).getOr(blockPosition);
	      } else {
	        return blockPosition;
	      }
	    };
	    var readFromRange = function (rootNode, forward, rng) {
	      var fromBlockPos = getBlockPosition(rootNode, CaretPosition$1.fromRangeStart(rng));
	      var toBlockPos = fromBlockPos.bind(function (blockPos) {
	        return CaretFinder.fromPosition(forward, rootNode, blockPos.position()).bind(function (to) {
	          return getBlockPosition(rootNode, to).map(function (blockPos) {
	            return skipLastBr(rootNode, forward, blockPos);
	          });
	        });
	      });
	      return lift2(fromBlockPos, toBlockPos, BlockBoundary).filter(function (blockBoundary) {
	        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable(blockBoundary);
	      });
	    };
	    var read$1 = function (rootNode, forward, rng) {
	      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Option.none();
	    };
	    var BlockMergeBoundary = { read: read$1 };
	
	    var dropLast = function (xs) {
	      return xs.slice(0, -1);
	    };
	    var parentsUntil$1 = function (start, root, predicate) {
	      if (contains$3(root, start)) {
	        return dropLast(parents(start, function (elm) {
	          return predicate(elm) || eq(elm, root);
	        }));
	      } else {
	        return [];
	      }
	    };
	    var parents$1 = function (start, root) {
	      return parentsUntil$1(start, root, constant(false));
	    };
	    var parentsAndSelf = function (start, root) {
	      return [start].concat(parents$1(start, root));
	    };
	    var Parents = {
	      parentsUntil: parentsUntil$1,
	      parents: parents$1,
	      parentsAndSelf: parentsAndSelf
	    };
	
	    var getChildrenUntilBlockBoundary = function (block) {
	      var children$1 = children(block);
	      return findIndex(children$1, isBlock).fold(function () {
	        return children$1;
	      }, function (index) {
	        return children$1.slice(0, index);
	      });
	    };
	    var extractChildren = function (block) {
	      var children = getChildrenUntilBlockBoundary(block);
	      each(children, remove$1);
	      return children;
	    };
	    var removeEmptyRoot = function (rootNode, block) {
	      var parents = Parents.parentsAndSelf(block, rootNode);
	      return find(parents.reverse(), Empty.isEmpty).each(remove$1);
	    };
	    var isEmptyBefore = function (el) {
	      return filter(prevSiblings(el), function (el) {
	        return !Empty.isEmpty(el);
	      }).length === 0;
	    };
	    var nestedBlockMerge = function (rootNode, fromBlock, toBlock, insertionPoint) {
	      if (Empty.isEmpty(toBlock)) {
	        PaddingBr.fillWithPaddingBr(toBlock);
	        return CaretFinder.firstPositionIn(toBlock.dom());
	      }
	      if (isEmptyBefore(insertionPoint) && Empty.isEmpty(fromBlock)) {
	        before(insertionPoint, Element.fromTag('br'));
	      }
	      var position = CaretFinder.prevPosition(toBlock.dom(), CaretPosition$1.before(insertionPoint.dom()));
	      each(extractChildren(fromBlock), function (child) {
	        before(insertionPoint, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var sidelongBlockMerge = function (rootNode, fromBlock, toBlock) {
	      if (Empty.isEmpty(toBlock)) {
	        remove$1(toBlock);
	        if (Empty.isEmpty(fromBlock)) {
	          PaddingBr.fillWithPaddingBr(fromBlock);
	        }
	        return CaretFinder.firstPositionIn(fromBlock.dom());
	      }
	      var position = CaretFinder.lastPositionIn(toBlock.dom());
	      each(extractChildren(fromBlock), function (child) {
	        append(toBlock, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var findInsertionPoint = function (toBlock, block) {
	      var parentsAndSelf = Parents.parentsAndSelf(block, toBlock);
	      return Option.from(parentsAndSelf[parentsAndSelf.length - 1]);
	    };
	    var getInsertionPoint = function (fromBlock, toBlock) {
	      return contains$3(toBlock, fromBlock) ? findInsertionPoint(toBlock, fromBlock) : Option.none();
	    };
	    var trimBr = function (first, block) {
	      CaretFinder.positionIn(first, block.dom()).map(function (position) {
	        return position.getNode();
	      }).map(Element.fromDom).filter(isBr).each(remove$1);
	    };
	    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
	      trimBr(true, fromBlock);
	      trimBr(false, toBlock);
	      return getInsertionPoint(fromBlock, toBlock).fold(curry(sidelongBlockMerge, rootNode, fromBlock, toBlock), curry(nestedBlockMerge, rootNode, fromBlock, toBlock));
	    };
	    var mergeBlocks = function (rootNode, forward, block1, block2) {
	      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
	    };
	    var MergeBlocks = { mergeBlocks: mergeBlocks };
	
	    var backspaceDelete = function (editor, forward) {
	      var position;
	      var rootNode = Element.fromDom(editor.getBody());
	      position = BlockMergeBoundary.read(rootNode.dom(), forward, editor.selection.getRng()).bind(function (blockBoundary) {
	        return MergeBlocks.mergeBlocks(rootNode, forward, blockBoundary.from().block(), blockBoundary.to().block());
	      });
	      position.each(function (pos) {
	        editor.selection.setRng(pos.toRange());
	      });
	      return position.isSome();
	    };
	    var BlockBoundaryDelete = { backspaceDelete: backspaceDelete };
	
	    var deleteRangeMergeBlocks = function (rootNode, selection) {
	      var rng = selection.getRng();
	      return lift2(DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.startContainer)), DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.endContainer)), function (block1, block2) {
	        if (eq(block1, block2) === false) {
	          rng.deleteContents();
	          MergeBlocks.mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
	            selection.setRng(pos.toRange());
	          });
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var isRawNodeInTable = function (root, rawNode) {
	      var node = Element.fromDom(rawNode);
	      var isRoot = curry(eq, root);
	      return ancestor(node, isTableCell, isRoot).isSome();
	    };
	    var isSelectionInTable = function (root, rng) {
	      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
	    };
	    var isEverythingSelected = function (root, rng) {
	      var noPrevious = CaretFinder.prevPosition(root.dom(), CaretPosition$1.fromRangeStart(rng)).isNone();
	      var noNext = CaretFinder.nextPosition(root.dom(), CaretPosition$1.fromRangeEnd(rng)).isNone();
	      return !isSelectionInTable(root, rng) && noPrevious && noNext;
	    };
	    var emptyEditor = function (editor) {
	      editor.setContent('');
	      editor.selection.setCursorLocation();
	      return true;
	    };
	    var deleteRange = function (editor) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
	    };
	    var backspaceDelete$1 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? false : deleteRange(editor);
	    };
	    var BlockRangeDelete = { backspaceDelete: backspaceDelete$1 };
	
	    var generate$1 = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var argLength = arguments.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var args = new Array(argLength);
	          for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i];
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              if (arguments.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
	              }
	              var target = arguments[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              domGlobals.console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$1 };
	
	    var isBr$5 = function (pos) {
	      return getElementFromPosition(pos).exists(isBr);
	    };
	    var findBr = function (forward, root, pos) {
	      var parentBlocks = filter(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	      var scope = head(parentBlocks).getOr(root);
	      return CaretFinder.fromPosition(forward, scope.dom(), pos).filter(isBr$5);
	    };
	    var isBeforeBr = function (root, pos) {
	      return getElementFromPosition(pos).exists(isBr) || findBr(true, root, pos).isSome();
	    };
	    var isAfterBr = function (root, pos) {
	      return getElementFromPrevPosition(pos).exists(isBr) || findBr(false, root, pos).isSome();
	    };
	    var findPreviousBr = curry(findBr, false);
	    var findNextBr = curry(findBr, true);
	
	    var is$2 = function (expected) {
	      return function (actual) {
	        return expected === actual;
	      };
	    };
	    var isNbsp = is$2('\xA0');
	    var isWhiteSpace$1 = function (chr) {
	      return /^[\r\n\t ]$/.test(chr);
	    };
	    var isContent$1 = function (chr) {
	      return !isWhiteSpace$1(chr) && !isNbsp(chr);
	    };
	
	    var isChar = function (forward, predicate, pos) {
	      return Option.from(pos.container()).filter(NodeType.isText).exists(function (text) {
	        var delta = forward ? 0 : -1;
	        return predicate(text.data.charAt(pos.offset() + delta));
	      });
	    };
	    var isBeforeSpace = curry(isChar, true, isWhiteSpace$1);
	    var isAfterSpace = curry(isChar, false, isWhiteSpace$1);
	    var isEmptyText = function (pos) {
	      var container = pos.container();
	      return NodeType.isText(container) && container.data.length === 0;
	    };
	    var isNextToContentEditableFalse = function (relativeOffset, caretPosition) {
	      var node = getChildNodeAtRelativeOffset(relativeOffset, caretPosition);
	      return NodeType.isContentEditableFalse(node) && !NodeType.isBogusAll(node);
	    };
	    var isBeforeContentEditableFalse = curry(isNextToContentEditableFalse, 0);
	    var isAfterContentEditableFalse = curry(isNextToContentEditableFalse, -1);
	    var isNextToTable = function (relativeOffset, caretPosition) {
	      return NodeType.isTable(getChildNodeAtRelativeOffset(relativeOffset, caretPosition));
	    };
	    var isBeforeTable = curry(isNextToTable, 0);
	    var isAfterTable = curry(isNextToTable, -1);
	
	    var isCompoundElement = function (node) {
	      return isTableCell(Element.fromDom(node)) || isListItem(Element.fromDom(node));
	    };
	    var DeleteAction = Adt.generate([
	      { remove: ['element'] },
	      { moveToElement: ['element'] },
	      { moveToPosition: ['position'] }
	    ]);
	    var isAtContentEditableBlockCaret = function (forward, from) {
	      var elm = from.getNode(forward === false);
	      var caretLocation = forward ? 'after' : 'before';
	      return NodeType.isElement(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
	    };
	    var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
	      var inSameBlock = function (elm) {
	        return isInline(Element.fromDom(elm)) && !isInSameBlock(from, to, root);
	      };
	      return getRelativeCefElm(!forward, from).fold(function () {
	        return getRelativeCefElm(forward, to).fold(constant(false), inSameBlock);
	      }, inSameBlock);
	    };
	    var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
	      var toCefElm = to.getNode(forward === false);
	      return DeleteUtils.getParentBlock(Element.fromDom(root), Element.fromDom(from.getNode())).map(function (blockElm) {
	        return Empty.isEmpty(blockElm) ? DeleteAction.remove(blockElm.dom()) : DeleteAction.moveToElement(toCefElm);
	      }).orThunk(function () {
	        return Option.some(DeleteAction.moveToElement(toCefElm));
	      });
	    };
	    var findCefPosition = function (root, forward, from) {
	      return CaretFinder.fromPosition(forward, root, from).bind(function (to) {
	        if (isCompoundElement(to.getNode())) {
	          return Option.none();
	        } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
	          return Option.none();
	        } else if (forward && NodeType.isContentEditableFalse(to.getNode())) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward === false && NodeType.isContentEditableFalse(to.getNode(true))) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward && isAfterContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else if (forward === false && isBeforeContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else {
	          return Option.none();
	        }
	      });
	    };
	    var getContentEditableBlockAction = function (forward, elm) {
	      if (forward && NodeType.isContentEditableFalse(elm.nextSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.nextSibling));
	      } else if (forward === false && NodeType.isContentEditableFalse(elm.previousSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.previousSibling));
	      } else {
	        return Option.none();
	      }
	    };
	    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
	      return deleteAction.fold(function (elm) {
	        return Option.some(DeleteAction.remove(elm));
	      }, function (elm) {
	        return Option.some(DeleteAction.moveToElement(elm));
	      }, function (to) {
	        if (isInSameBlock(from, to, root)) {
	          return Option.none();
	        } else {
	          return Option.some(DeleteAction.moveToPosition(to));
	        }
	      });
	    };
	    var getContentEditableAction = function (root, forward, from) {
	      if (isAtContentEditableBlockCaret(forward, from)) {
	        return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
	          return findCefPosition(root, forward, from);
	        }, Option.some);
	      } else {
	        return findCefPosition(root, forward, from).bind(function (deleteAction) {
	          return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
	        });
	      }
	    };
	    var read$2 = function (root, forward, rng) {
	      var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
	      var from = CaretPosition$1.fromRangeStart(normalizedRange);
	      var rootElement = Element.fromDom(root);
	      if (forward === false && isAfterContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode(true)));
	      } else if (forward && isBeforeContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode()));
	      } else if (forward === false && isBeforeContentEditableFalse(from) && isAfterBr(rootElement, from)) {
	        return findPreviousBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else if (forward && isAfterContentEditableFalse(from) && isBeforeBr(rootElement, from)) {
	        return findNextBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else {
	        return getContentEditableAction(root, forward, from);
	      }
	    };
	
	    var isCollapsibleWhitespace = function (c) {
	      return ' \f\n\r\t\x0B'.indexOf(c) !== -1;
	    };
	    var normalizeContent = function (content, isStartOfContent, isEndOfContent) {
	      var result = foldl(content.split(''), function (acc, c) {
	        if (isCollapsibleWhitespace(c) || c === '\xA0') {
	          if (acc.previousCharIsSpace || acc.str === '' && isStartOfContent || acc.str.length === content.length - 1 && isEndOfContent) {
	            return {
	              previousCharIsSpace: false,
	              str: acc.str + '\xA0'
	            };
	          } else {
	            return {
	              previousCharIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            previousCharIsSpace: false,
	            str: acc.str + c
	          };
	        }
	      }, {
	        previousCharIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	    var normalize$1 = function (node, offset, count) {
	      if (count === 0) {
	        return;
	      }
	      var whitespace = node.data.slice(offset, offset + count);
	      var isEndOfContent = offset + count >= node.data.length;
	      var isStartOfContent = offset === 0;
	      node.replaceData(offset, count, normalizeContent(whitespace, isStartOfContent, isEndOfContent));
	    };
	    var normalizeWhitespaceAfter = function (node, offset) {
	      var content = node.data.slice(offset);
	      var whitespaceCount = content.length - lTrim(content).length;
	      return normalize$1(node, offset, whitespaceCount);
	    };
	    var normalizeWhitespaceBefore = function (node, offset) {
	      var content = node.data.slice(0, offset);
	      var whitespaceCount = content.length - rTrim(content).length;
	      return normalize$1(node, offset - whitespaceCount, whitespaceCount);
	    };
	    var mergeTextNodes = function (prevNode, nextNode, normalizeWhitespace) {
	      var whitespaceOffset = rTrim(prevNode.data).length;
	      prevNode.appendData(nextNode.data);
	      remove$1(Element.fromDom(nextNode));
	      if (normalizeWhitespace) {
	        normalizeWhitespaceAfter(prevNode, whitespaceOffset);
	      }
	      return prevNode;
	    };
	
	    var needsReposition = function (pos, elm) {
	      var container = pos.container();
	      var offset = pos.offset();
	      return CaretPosition$1.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition$1.before(elm).offset();
	    };
	    var reposition = function (elm, pos) {
	      return needsReposition(pos, elm) ? CaretPosition$1(pos.container(), pos.offset() - 1) : pos;
	    };
	    var beforeOrStartOf = function (node) {
	      return NodeType.isText(node) ? CaretPosition$1(node, 0) : CaretPosition$1.before(node);
	    };
	    var afterOrEndOf = function (node) {
	      return NodeType.isText(node) ? CaretPosition$1(node, node.data.length) : CaretPosition$1.after(node);
	    };
	    var getPreviousSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.previousSibling)) {
	        return Option.some(afterOrEndOf(elm.previousSibling));
	      } else {
	        return elm.previousSibling ? CaretFinder.lastPositionIn(elm.previousSibling) : Option.none();
	      }
	    };
	    var getNextSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.nextSibling)) {
	        return Option.some(beforeOrStartOf(elm.nextSibling));
	      } else {
	        return elm.nextSibling ? CaretFinder.firstPositionIn(elm.nextSibling) : Option.none();
	      }
	    };
	    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
	      var startPosition = CaretPosition$1.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
	      return CaretFinder.prevPosition(rootElement, startPosition).fold(function () {
	        return CaretFinder.nextPosition(rootElement, CaretPosition$1.after(elm));
	      }, Option.some);
	    };
	    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
	      return CaretFinder.nextPosition(rootElement, CaretPosition$1.after(elm)).fold(function () {
	        return CaretFinder.prevPosition(rootElement, CaretPosition$1.before(elm));
	      }, Option.some);
	    };
	    var findCaretPositionBackwards = function (rootElement, elm) {
	      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
	        return getNextSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionBackwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPositionForward = function (rootElement, elm) {
	      return getNextSiblingCaretPosition(elm).orThunk(function () {
	        return getPreviousSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionForwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPosition$1 = function (forward, rootElement, elm) {
	      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
	    };
	    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
	      return findCaretPosition$1(forward, rootElement, elm).map(curry(reposition, elm));
	    };
	    var setSelection = function (editor, forward, pos) {
	      pos.fold(function () {
	        editor.focus();
	      }, function (pos) {
	        editor.selection.setRng(pos.toRange(), forward);
	      });
	    };
	    var eqRawNode = function (rawNode) {
	      return function (elm) {
	        return elm.dom() === rawNode;
	      };
	    };
	    var isBlock$2 = function (editor, elm) {
	      return elm && editor.schema.getBlockElements().hasOwnProperty(name(elm));
	    };
	    var paddEmptyBlock = function (elm) {
	      if (Empty.isEmpty(elm)) {
	        var br = Element.fromHtml('<br data-mce-bogus="1">');
	        empty(elm);
	        append(elm, br);
	        return Option.some(CaretPosition$1.before(br.dom()));
	      } else {
	        return Option.none();
	      }
	    };
	    var deleteNormalized = function (elm, afterDeletePosOpt, normalizeWhitespace) {
	      var prevTextOpt = prevSibling(elm).filter(isText);
	      var nextTextOpt = nextSibling(elm).filter(isText);
	      remove$1(elm);
	      return lift3(prevTextOpt, nextTextOpt, afterDeletePosOpt, function (prev, next, pos) {
	        var prevNode = prev.dom(), nextNode = next.dom();
	        var offset = prevNode.data.length;
	        mergeTextNodes(prevNode, nextNode, normalizeWhitespace);
	        return pos.container() === nextNode ? CaretPosition$1(prevNode, offset) : pos;
	      }).orThunk(function () {
	        if (normalizeWhitespace) {
	          prevTextOpt.each(function (elm) {
	            return normalizeWhitespaceBefore(elm.dom(), elm.dom().length);
	          });
	          nextTextOpt.each(function (elm) {
	            return normalizeWhitespaceAfter(elm.dom(), 0);
	          });
	        }
	        return afterDeletePosOpt;
	      });
	    };
	    var isInlineElement = function (editor, element) {
	      return has(editor.schema.getTextInlineElements(), name(element));
	    };
	    var deleteElement = function (editor, forward, elm, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom());
	      var parentBlock = ancestor(elm, curry(isBlock$2, editor), eqRawNode(editor.getBody()));
	      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos, isInlineElement(editor, elm));
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        editor.selection.setCursorLocation();
	      } else {
	        parentBlock.bind(paddEmptyBlock).fold(function () {
	          if (moveCaret) {
	            setSelection(editor, forward, normalizedAfterDeletePos);
	          }
	        }, function (paddPos) {
	          if (moveCaret) {
	            setSelection(editor, forward, Option.some(paddPos));
	          }
	        });
	      }
	    };
	    var DeleteElement = { deleteElement: deleteElement };
	
	    var deleteElement$1 = function (editor, forward) {
	      return function (element) {
	        editor._selectionOverrides.hideFakeCaret();
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(element));
	        return true;
	      };
	    };
	    var moveToElement = function (editor, forward) {
	      return function (element) {
	        var pos = forward ? CaretPosition$1.before(element) : CaretPosition$1.after(element);
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var moveToPosition = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var backspaceDeleteCaret = function (editor, forward) {
	      var result = read$2(editor.getBody(), forward, editor.selection.getRng()).map(function (deleteAction) {
	        return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
	      });
	      return result.getOr(false);
	    };
	    var deleteOffscreenSelection = function (rootElement) {
	      each(descendants$1(rootElement, '.mce-offscreen-selection'), remove$1);
	    };
	    var backspaceDeleteRange = function (editor, forward) {
	      var selectedElement = editor.selection.getNode();
	      if (NodeType.isContentEditableFalse(selectedElement)) {
	        deleteOffscreenSelection(Element.fromDom(editor.getBody()));
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(editor.selection.getNode()));
	        DeleteUtils.paddEmptyBody(editor);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var getContentEditableRoot = function (root, node) {
	      while (node && node !== root) {
	        if (NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var paddEmptyElement = function (editor) {
	      var br;
	      var ceRoot = getContentEditableRoot(editor.getBody(), editor.selection.getNode());
	      if (NodeType.isContentEditableTrue(ceRoot) && editor.dom.isBlock(ceRoot) && editor.dom.isEmpty(ceRoot)) {
	        br = editor.dom.create('br', { 'data-mce-bogus': '1' });
	        editor.dom.setHTML(ceRoot, '');
	        ceRoot.appendChild(br);
	        editor.selection.setRng(CaretPosition$1.before(br).toRange());
	      }
	      return true;
	    };
	    var backspaceDelete$2 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return backspaceDeleteCaret(editor, forward);
	      } else {
	        return backspaceDeleteRange(editor, forward);
	      }
	    };
	    var CefDelete = {
	      backspaceDelete: backspaceDelete$2,
	      paddEmptyElement: paddEmptyElement
	    };
	
	    var isText$8 = NodeType.isText;
	    var startsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[0] === Zwsp.ZWSP;
	    };
	    var endsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[node.data.length - 1] === Zwsp.ZWSP;
	    };
	    var createZwsp = function (node) {
	      return node.ownerDocument.createTextNode(Zwsp.ZWSP);
	    };
	    var insertBefore$1 = function (node) {
	      if (isText$8(node.previousSibling)) {
	        if (endsWithCaretContainer$1(node.previousSibling)) {
	          return node.previousSibling;
	        } else {
	          node.previousSibling.appendData(Zwsp.ZWSP);
	          return node.previousSibling;
	        }
	      } else if (isText$8(node)) {
	        if (startsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.insertData(0, Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        node.parentNode.insertBefore(newNode, node);
	        return newNode;
	      }
	    };
	    var insertAfter$1 = function (node) {
	      if (isText$8(node.nextSibling)) {
	        if (startsWithCaretContainer$1(node.nextSibling)) {
	          return node.nextSibling;
	        } else {
	          node.nextSibling.insertData(0, Zwsp.ZWSP);
	          return node.nextSibling;
	        }
	      } else if (isText$8(node)) {
	        if (endsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.appendData(Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        if (node.nextSibling) {
	          node.parentNode.insertBefore(newNode, node.nextSibling);
	        } else {
	          node.parentNode.appendChild(newNode);
	        }
	        return newNode;
	      }
	    };
	    var insertInline$1 = function (before, node) {
	      return before ? insertBefore$1(node) : insertAfter$1(node);
	    };
	    var insertInlineBefore = curry(insertInline$1, true);
	    var insertInlineAfter = curry(insertInline$1, false);
	
	    var insertInlinePos = function (pos, before) {
	      if (NodeType.isText(pos.container())) {
	        return insertInline$1(before, pos.container());
	      } else {
	        return insertInline$1(before, pos.getNode());
	      }
	    };
	    var isPosCaretContainer = function (pos, caret) {
	      var caretNode = caret.get();
	      return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
	    };
	    var renderCaret = function (caret, location) {
	      return location.fold(function (element) {
	        CaretContainerRemove.remove(caret.get());
	        var text = insertInlineBefore(element);
	        caret.set(text);
	        return Option.some(CaretPosition$1(text, text.length - 1));
	      }, function (element) {
	        return CaretFinder.firstPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            CaretContainerRemove.remove(caret.get());
	            var text = insertInlinePos(pos, true);
	            caret.set(text);
	            return CaretPosition$1(text, 1);
	          } else {
	            return CaretPosition$1(caret.get(), 1);
	          }
	        });
	      }, function (element) {
	        return CaretFinder.lastPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            CaretContainerRemove.remove(caret.get());
	            var text = insertInlinePos(pos, false);
	            caret.set(text);
	            return CaretPosition$1(text, text.length - 1);
	          } else {
	            return CaretPosition$1(caret.get(), caret.get().length - 1);
	          }
	        });
	      }, function (element) {
	        CaretContainerRemove.remove(caret.get());
	        var text = insertInlineAfter(element);
	        caret.set(text);
	        return Option.some(CaretPosition$1(text, 1));
	      });
	    };
	    var BoundaryCaret = { renderCaret: renderCaret };
	
	    var evaluateUntil = function (fns, args) {
	      for (var i = 0; i < fns.length; i++) {
	        var result = fns[i].apply(null, args);
	        if (result.isSome()) {
	          return result;
	        }
	      }
	      return Option.none();
	    };
	    var LazyEvaluator = { evaluateUntil: evaluateUntil };
	
	    var Location = Adt.generate([
	      { before: ['element'] },
	      { start: ['element'] },
	      { end: ['element'] },
	      { after: ['element'] }
	    ]);
	    var rescope = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var before$3 = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return CaretFinder.nextPosition(scope, nPos).bind(curry(InlineUtils.findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.before(inline);
	        });
	      }, Option.none);
	    };
	    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
	      return getParentCaretContainer(rootNode, elm) === null;
	    };
	    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
	      return InlineUtils.findRootInline(isInlineTarget, rootNode, pos).filter(curry(isNotInsideFormatCaretContainer, rootNode));
	    };
	    var start = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var prevPos = CaretFinder.prevPosition(inline, nPos);
	        return prevPos.isNone() ? Option.some(Location.start(inline)) : Option.none();
	      });
	    };
	    var end = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var nextPos = CaretFinder.nextPosition(inline, nPos);
	        return nextPos.isNone() ? Option.some(Location.end(inline)) : Option.none();
	      });
	    };
	    var after$2 = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return CaretFinder.prevPosition(scope, nPos).bind(curry(InlineUtils.findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.after(inline);
	        });
	      }, Option.none);
	    };
	    var isValidLocation = function (location) {
	      return InlineUtils.isRtl(getElement(location)) === false;
	    };
	    var readLocation = function (isInlineTarget, rootNode, pos) {
	      var location = LazyEvaluator.evaluateUntil([
	        before$3,
	        start,
	        end,
	        after$2
	      ], [
	        isInlineTarget,
	        rootNode,
	        pos
	      ]);
	      return location.filter(isValidLocation);
	    };
	    var getElement = function (location) {
	      return location.fold(identity, identity, identity, identity);
	    };
	    var getName = function (location) {
	      return location.fold(constant('before'), constant('start'), constant('end'), constant('after'));
	    };
	    var outside = function (location) {
	      return location.fold(Location.before, Location.before, Location.after, Location.after);
	    };
	    var inside = function (location) {
	      return location.fold(Location.start, Location.start, Location.end, Location.end);
	    };
	    var isEq$1 = function (location1, location2) {
	      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
	    };
	    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
	      return lift2(InlineUtils.findRootInline(isInlineTarget, rootNode, from), InlineUtils.findRootInline(isInlineTarget, rootNode, to), function (fromInline, toInline) {
	        if (fromInline !== toInline && InlineUtils.hasSameParentBlock(rootNode, fromInline, toInline)) {
	          return Location.after(forward ? fromInline : toInline);
	        } else {
	          return location;
	        }
	      }).getOr(location);
	    };
	    var skipNoMovement = function (fromLocation, toLocation) {
	      return fromLocation.fold(constant(true), function (fromLocation) {
	        return !isEq$1(fromLocation, toLocation);
	      });
	    };
	    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var to = CaretFinder.fromPosition(forward, rootNode, from).map(curry(InlineUtils.normalizePosition, forward));
	      var location = to.fold(function () {
	        return fromLocation.map(outside);
	      }, function (to) {
	        return readLocation(isInlineTarget, rootNode, to).map(curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter(curry(skipNoMovement, fromLocation));
	      });
	      return location.filter(isValidLocation);
	    };
	    var findLocationSimple = function (forward, location) {
	      if (forward) {
	        return location.fold(compose(Option.some, Location.start), Option.none, compose(Option.some, Location.after), Option.none);
	      } else {
	        return location.fold(Option.none, compose(Option.some, Location.before), Option.none, compose(Option.some, Location.end));
	      }
	    };
	    var findLocation = function (forward, isInlineTarget, rootNode, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var fromLocation = readLocation(isInlineTarget, rootNode, from);
	      return readLocation(isInlineTarget, rootNode, from).bind(curry(findLocationSimple, forward)).orThunk(function () {
	        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
	      });
	    };
	    var BoundaryLocation = {
	      readLocation: readLocation,
	      findLocation: findLocation,
	      prevLocation: curry(findLocation, false),
	      nextLocation: curry(findLocation, true),
	      getElement: getElement,
	      outside: outside,
	      inside: inside
	    };
	
	    var hasSelectionModifyApi = function (editor) {
	      return isFunction(editor.selection.getSel().modify);
	    };
	    var moveRel = function (forward, selection, pos) {
	      var delta = forward ? 1 : -1;
	      selection.setRng(CaretPosition$1(pos.container(), pos.offset() + delta).toRange());
	      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
	      return true;
	    };
	    var moveByWord = function (forward, editor) {
	      var rng = editor.selection.getRng();
	      var pos = forward ? CaretPosition$1.fromRangeEnd(rng) : CaretPosition$1.fromRangeStart(rng);
	      if (!hasSelectionModifyApi(editor)) {
	        return false;
	      } else if (forward && isBeforeInline(pos)) {
	        return moveRel(true, editor.selection, pos);
	      } else if (!forward && isAfterInline(pos)) {
	        return moveRel(false, editor.selection, pos);
	      } else {
	        return false;
	      }
	    };
	    var WordSelection = {
	      hasSelectionModifyApi: hasSelectionModifyApi,
	      moveByWord: moveByWord
	    };
	
	    var setCaretPosition = function (editor, pos) {
	      var rng = editor.dom.createRng();
	      rng.setStart(pos.container(), pos.offset());
	      rng.setEnd(pos.container(), pos.offset());
	      editor.selection.setRng(rng);
	    };
	    var isFeatureEnabled = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	    var setSelected = function (state, elm) {
	      if (state) {
	        elm.setAttribute('data-mce-selected', 'inline-boundary');
	      } else {
	        elm.removeAttribute('data-mce-selected');
	      }
	    };
	    var renderCaretLocation = function (editor, caret, location) {
	      return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	        setCaretPosition(editor, pos);
	        return location;
	      });
	    };
	    var findLocation$1 = function (editor, caret, forward) {
	      var rootNode = editor.getBody();
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var location = BoundaryLocation.findLocation(forward, isInlineTarget, rootNode, from);
	      return location.bind(function (location) {
	        return renderCaretLocation(editor, caret, location);
	      });
	    };
	    var toggleInlines = function (isInlineTarget, dom, elms) {
	      var selectedInlines = filter(dom.select('*[data-mce-selected="inline-boundary"]'), isInlineTarget);
	      var targetInlines = filter(elms, isInlineTarget);
	      each(difference(selectedInlines, targetInlines), curry(setSelected, false));
	      each(difference(targetInlines, selectedInlines), curry(setSelected, true));
	    };
	    var safeRemoveCaretContainer = function (editor, caret) {
	      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
	        var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        if (CaretPosition$1.isTextPosition(pos) && InlineUtils.isAtZwsp(pos) === false) {
	          setCaretPosition(editor, CaretContainerRemove.removeAndReposition(caret.get(), pos));
	          caret.set(null);
	        }
	      }
	    };
	    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
	      if (editor.selection.isCollapsed()) {
	        var inlines = filter(elms, isInlineTarget);
	        each(inlines, function (inline) {
	          var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	          BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
	            return renderCaretLocation(editor, caret, location);
	          });
	        });
	      }
	    };
	    var move = function (editor, caret, forward) {
	      return function () {
	        return isFeatureEnabled(editor) ? findLocation$1(editor, caret, forward).isSome() : false;
	      };
	    };
	    var moveWord = function (forward, editor, caret) {
	      return function () {
	        return isFeatureEnabled(editor) ? WordSelection.moveByWord(forward, editor) : false;
	      };
	    };
	    var setupSelectedState = function (editor) {
	      var caret = Cell(null);
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      editor.on('NodeChange', function (e) {
	        if (isFeatureEnabled(editor)) {
	          toggleInlines(isInlineTarget, editor.dom, e.parents);
	          safeRemoveCaretContainer(editor, caret);
	          renderInsideInlineCaret(isInlineTarget, editor, caret, e.parents);
	        }
	      });
	      return caret;
	    };
	    var moveNextWord = curry(moveWord, true);
	    var movePrevWord = curry(moveWord, false);
	    var BoundarySelection = {
	      move: move,
	      moveNextWord: moveNextWord,
	      movePrevWord: movePrevWord,
	      setupSelectedState: setupSelectedState,
	      setCaretPosition: setCaretPosition
	    };
	
	    var isFeatureEnabled$1 = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	    var rangeFromPositions = function (from, to) {
	      var range = domGlobals.document.createRange();
	      range.setStart(from.container(), from.offset());
	      range.setEnd(to.container(), to.offset());
	      return range;
	    };
	    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
	      return lift2(CaretFinder.firstPositionIn(elm), CaretFinder.lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	        return CaretFinder.nextPosition(elm, normalizedFirstPos).map(function (pos) {
	          return pos.isEqual(normalizedLastPos);
	        }).getOr(true);
	      }).getOr(true);
	    };
	    var setCaretLocation = function (editor, caret) {
	      return function (location) {
	        return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	          BoundarySelection.setCaretPosition(editor, pos);
	          return true;
	        }).getOr(false);
	      };
	    };
	    var deleteFromTo = function (editor, caret, from, to) {
	      var rootNode = editor.getBody();
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      editor.undoManager.ignore(function () {
	        editor.selection.setRng(rangeFromPositions(from, to));
	        editor.execCommand('Delete');
	        BoundaryLocation.readLocation(isInlineTarget, rootNode, CaretPosition$1.fromRangeStart(editor.selection.getRng())).map(BoundaryLocation.inside).map(setCaretLocation(editor, caret));
	      });
	      editor.nodeChanged();
	    };
	    var rescope$1 = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
	      var rootNode = rescope$1(editor.getBody(), from.container());
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var fromLocation = BoundaryLocation.readLocation(isInlineTarget, rootNode, from);
	      return fromLocation.bind(function (location) {
	        if (forward) {
	          return location.fold(constant(Option.some(BoundaryLocation.inside(location))), Option.none, constant(Option.some(BoundaryLocation.outside(location))), Option.none);
	        } else {
	          return location.fold(Option.none, constant(Option.some(BoundaryLocation.outside(location))), Option.none, constant(Option.some(BoundaryLocation.inside(location))));
	        }
	      }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
	        var toPosition = CaretFinder.navigate(forward, rootNode, from);
	        var toLocation = toPosition.bind(function (pos) {
	          return BoundaryLocation.readLocation(isInlineTarget, rootNode, pos);
	        });
	        if (fromLocation.isSome() && toLocation.isSome()) {
	          return InlineUtils.findRootInline(isInlineTarget, rootNode, from).map(function (elm) {
	            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
	              DeleteElement.deleteElement(editor, forward, Element.fromDom(elm));
	              return true;
	            } else {
	              return false;
	            }
	          }).getOr(false);
	        } else {
	          return toLocation.bind(function (_) {
	            return toPosition.map(function (to) {
	              if (forward) {
	                deleteFromTo(editor, caret, from, to);
	              } else {
	                deleteFromTo(editor, caret, to, from);
	              }
	              return true;
	            });
	          }).getOr(false);
	        }
	      });
	    };
	    var backspaceDelete$3 = function (editor, caret, forward) {
	      if (editor.selection.isCollapsed() && isFeatureEnabled$1(editor)) {
	        var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        return backspaceDeleteCollapsed(editor, caret, forward, from);
	      }
	      return false;
	    };
	    var InlineBoundaryDelete = { backspaceDelete: backspaceDelete$3 };
	
	    var tableCellRng = Immutable('start', 'end');
	    var tableSelection = Immutable('rng', 'table', 'cells');
	    var deleteAction = Adt.generate([
	      { removeTable: ['element'] },
	      { emptyCells: ['cells'] }
	    ]);
	    var isRootFromElement = function (root) {
	      return curry(eq, root);
	    };
	    var getClosestCell = function (container, isRoot) {
	      return closest$1(Element.fromDom(container), 'td,th', isRoot);
	    };
	    var getClosestTable = function (cell, isRoot) {
	      return ancestor$1(cell, 'table', isRoot);
	    };
	    var isExpandedCellRng = function (cellRng) {
	      return eq(cellRng.start(), cellRng.end()) === false;
	    };
	    var getTableFromCellRng = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start(), isRoot).bind(function (startParentTable) {
	        return getClosestTable(cellRng.end(), isRoot).bind(function (endParentTable) {
	          return eq(startParentTable, endParentTable) ? Option.some(startParentTable) : Option.none();
	        });
	      });
	    };
	    var getTableCells = function (table) {
	      return descendants$1(table, 'td,th');
	    };
	    var getCellRangeFromStartTable = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start(), isRoot).bind(function (table) {
	        return last(getTableCells(table)).map(function (endCell) {
	          return tableCellRng(cellRng.start(), endCell);
	        });
	      });
	    };
	    var partialSelection = function (isRoot, rng) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return rng.collapsed ? Option.none() : lift2(startCell, endCell, tableCellRng).fold(function () {
	        return startCell.fold(function () {
	          return endCell.bind(function (endCell) {
	            return getClosestTable(endCell, isRoot).bind(function (table) {
	              return head(getTableCells(table)).map(function (startCell) {
	                return tableCellRng(startCell, endCell);
	              });
	            });
	          });
	        }, function (startCell) {
	          return getClosestTable(startCell, isRoot).bind(function (table) {
	            return last(getTableCells(table)).map(function (endCell) {
	              return tableCellRng(startCell, endCell);
	            });
	          });
	        });
	      }, function (cellRng) {
	        return isWithinSameTable(isRoot, cellRng) ? Option.none() : getCellRangeFromStartTable(cellRng, isRoot);
	      });
	    };
	    var isWithinSameTable = function (isRoot, cellRng) {
	      return getTableFromCellRng(cellRng, isRoot).isSome();
	    };
	    var getCellRng = function (rng, isRoot) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return lift2(startCell, endCell, tableCellRng).filter(isExpandedCellRng).filter(function (cellRng) {
	        return isWithinSameTable(isRoot, cellRng);
	      }).orThunk(function () {
	        return partialSelection(isRoot, rng);
	      });
	    };
	    var getTableSelectionFromCellRng = function (cellRng, isRoot) {
	      return getTableFromCellRng(cellRng, isRoot).map(function (table) {
	        return tableSelection(cellRng, table, getTableCells(table));
	      });
	    };
	    var getTableSelectionFromRng = function (root, rng) {
	      var isRoot = isRootFromElement(root);
	      return getCellRng(rng, isRoot).bind(function (cellRng) {
	        return getTableSelectionFromCellRng(cellRng, isRoot);
	      });
	    };
	    var getCellIndex = function (cells, cell) {
	      return findIndex(cells, function (x) {
	        return eq(x, cell);
	      });
	    };
	    var getSelectedCells = function (tableSelection) {
	      return lift2(getCellIndex(tableSelection.cells(), tableSelection.rng().start()), getCellIndex(tableSelection.cells(), tableSelection.rng().end()), function (startIndex, endIndex) {
	        return tableSelection.cells().slice(startIndex, endIndex + 1);
	      });
	    };
	    var getAction = function (tableSelection) {
	      return getSelectedCells(tableSelection).map(function (selected) {
	        var cells = tableSelection.cells();
	        return selected.length === cells.length ? deleteAction.removeTable(tableSelection.table()) : deleteAction.emptyCells(selected);
	      });
	    };
	    var getActionFromCells = function (cells) {
	      return deleteAction.emptyCells(cells);
	    };
	    var getActionFromRange = function (root, rng) {
	      return getTableSelectionFromRng(root, rng).bind(getAction);
	    };
	    var TableDeleteAction = {
	      getActionFromRange: getActionFromRange,
	      getActionFromCells: getActionFromCells
	    };
	
	    var getRanges = function (selection) {
	      var ranges = [];
	      if (selection) {
	        for (var i = 0; i < selection.rangeCount; i++) {
	          ranges.push(selection.getRangeAt(i));
	        }
	      }
	      return ranges;
	    };
	    var getSelectedNodes = function (ranges) {
	      return bind(ranges, function (range) {
	        var node = getSelectedNode(range);
	        return node ? [Element.fromDom(node)] : [];
	      });
	    };
	    var hasMultipleRanges = function (selection) {
	      return getRanges(selection).length > 1;
	    };
	    var MultiRange = {
	      getRanges: getRanges,
	      getSelectedNodes: getSelectedNodes,
	      hasMultipleRanges: hasMultipleRanges
	    };
	
	    var getCellsFromRanges = function (ranges) {
	      return filter(MultiRange.getSelectedNodes(ranges), isTableCell);
	    };
	    var getCellsFromElement = function (elm) {
	      var selectedCells = descendants$1(elm, 'td[data-mce-selected],th[data-mce-selected]');
	      return selectedCells;
	    };
	    var getCellsFromElementOrRanges = function (ranges, element) {
	      var selectedCells = getCellsFromElement(element);
	      var rangeCells = getCellsFromRanges(ranges);
	      return selectedCells.length > 0 ? selectedCells : rangeCells;
	    };
	    var getCellsFromEditor = function (editor) {
	      return getCellsFromElementOrRanges(MultiRange.getRanges(editor.selection.getSel()), Element.fromDom(editor.getBody()));
	    };
	    var TableCellSelection = {
	      getCellsFromRanges: getCellsFromRanges,
	      getCellsFromElement: getCellsFromElement,
	      getCellsFromElementOrRanges: getCellsFromElementOrRanges,
	      getCellsFromEditor: getCellsFromEditor
	    };
	
	    var emptyCells = function (editor, cells) {
	      each(cells, PaddingBr.fillWithPaddingBr);
	      editor.selection.setCursorLocation(cells[0].dom(), 0);
	      return true;
	    };
	    var deleteTableElement = function (editor, table) {
	      DeleteElement.deleteElement(editor, false, table);
	      return true;
	    };
	    var deleteCellRange = function (editor, rootElm, rng) {
	      return TableDeleteAction.getActionFromRange(rootElm, rng).map(function (action) {
	        return action.fold(curry(deleteTableElement, editor), curry(emptyCells, editor));
	      });
	    };
	    var deleteCaptionRange = function (editor, caption) {
	      return emptyElement(editor, caption);
	    };
	    var deleteTableRange = function (editor, rootElm, rng, startElm) {
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCellRange(editor, rootElm, rng);
	      }, function (caption) {
	        return deleteCaptionRange(editor, caption);
	      }).getOr(false);
	    };
	    var deleteRange$1 = function (editor, startElm) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      var selectedCells = TableCellSelection.getCellsFromEditor(editor);
	      return selectedCells.length !== 0 ? emptyCells(editor, selectedCells) : deleteTableRange(editor, rootNode, rng, startElm);
	    };
	    var getParentCell = function (rootElm, elm) {
	      return find(Parents.parentsAndSelf(elm, rootElm), isTableCell);
	    };
	    var getParentCaption = function (rootElm, elm) {
	      return find(Parents.parentsAndSelf(elm, rootElm), function (elm) {
	        return name(elm) === 'caption';
	      });
	    };
	    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return getParentCell(rootElm, Element.fromDom(to.getNode())).map(function (toCell) {
	          return eq(toCell, fromCell) === false;
	        });
	      });
	    };
	    var emptyElement = function (editor, elm) {
	      PaddingBr.fillWithPaddingBr(elm);
	      editor.selection.setCursorLocation(elm.dom(), 0);
	      return Option.some(true);
	    };
	    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
	      return CaretFinder.firstPositionIn(fromCaption.dom()).bind(function (first) {
	        return CaretFinder.lastPositionIn(fromCaption.dom()).map(function (last) {
	          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
	        });
	      }).getOr(true);
	    };
	    var emptyCaretCaption = function (editor, elm) {
	      return emptyElement(editor, elm);
	    };
	    var validateCaretCaption = function (rootElm, fromCaption, to) {
	      return getParentCaption(rootElm, Element.fromDom(to.getNode())).map(function (toCaption) {
	        return eq(toCaption, fromCaption) === false;
	      });
	    };
	    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
	      }).or(Option.some(true));
	    };
	    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return getParentCell(rootElm, startElm).bind(function (fromCell) {
	        return Empty.isEmpty(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
	      });
	    };
	    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
	      var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return Empty.isEmpty(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
	    };
	    var deleteCaret = function (editor, forward, startElm) {
	      var rootElm = Element.fromDom(editor.getBody());
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCaretCells(editor, forward, rootElm, startElm);
	      }, function (fromCaption) {
	        return deleteCaretCaption(editor, forward, rootElm, fromCaption);
	      }).getOr(false);
	    };
	    var backspaceDelete$4 = function (editor, forward) {
	      var startElm = Element.fromDom(editor.selection.getStart(true));
	      var cells = TableCellSelection.getCellsFromEditor(editor);
	      return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret(editor, forward, startElm) : deleteRange$1(editor, startElm);
	    };
	    var TableDelete = { backspaceDelete: backspaceDelete$4 };
	
	    var isEq$2 = FormatUtils.isEq;
	    var matchesUnInheritedFormatSelector = function (ed, node, name) {
	      var formatList = ed.formatter.get(name);
	      if (formatList) {
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].inherit === false && ed.dom.is(node, formatList[i].selector)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var matchParents = function (editor, node, name, vars) {
	      var root = editor.dom.getRoot();
	      if (node === root) {
	        return false;
	      }
	      node = editor.dom.getParent(node, function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, name)) {
	          return true;
	        }
	        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
	      });
	      return matchNode(editor, node, name, vars);
	    };
	    var matchName = function (dom, node, format) {
	      if (isEq$2(node, format.inline)) {
	        return true;
	      }
	      if (isEq$2(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return node.nodeType === 1 && dom.is(node, format.selector);
	      }
	    };
	    var matchItems = function (dom, node, format, itemName, similar, vars) {
	      var key, value;
	      var items = format[itemName];
	      var i;
	      if (format.onmatch) {
	        return format.onmatch(node, format, itemName);
	      }
	      if (items) {
	        if (typeof items.length === 'undefined') {
	          for (key in items) {
	            if (items.hasOwnProperty(key)) {
	              if (itemName === 'attributes') {
	                value = dom.getAttrib(node, key);
	              } else {
	                value = FormatUtils.getStyle(dom, node, key);
	              }
	              if (similar && !value && !format.exact) {
	                return;
	              }
	              if ((!similar || format.exact) && !isEq$2(value, FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(items[key], vars), key))) {
	                return;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < items.length; i++) {
	            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : FormatUtils.getStyle(dom, node, items[i])) {
	              return format;
	            }
	          }
	        }
	      }
	      return format;
	    };
	    var matchNode = function (ed, node, name, vars, similar) {
	      var formatList = ed.formatter.get(name);
	      var format, i, x, classes;
	      var dom = ed.dom;
	      if (formatList && node) {
	        for (i = 0; i < formatList.length; i++) {
	          format = formatList[i];
	          if (matchName(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
	            if (classes = format.classes) {
	              for (x = 0; x < classes.length; x++) {
	                if (!ed.dom.hasClass(node, classes[x])) {
	                  return;
	                }
	              }
	            }
	            return format;
	          }
	        }
	      }
	    };
	    var match = function (editor, name, vars, node) {
	      var startNode;
	      if (node) {
	        return matchParents(editor, node, name, vars);
	      }
	      node = editor.selection.getNode();
	      if (matchParents(editor, node, name, vars)) {
	        return true;
	      }
	      startNode = editor.selection.getStart();
	      if (startNode !== node) {
	        if (matchParents(editor, startNode, name, vars)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var matchAll = function (editor, names, vars) {
	      var startElement;
	      var matchedFormatNames = [];
	      var checkedMap = {};
	      startElement = editor.selection.getStart();
	      editor.dom.getParent(startElement, function (node) {
	        var i, name;
	        for (i = 0; i < names.length; i++) {
	          name = names[i];
	          if (!checkedMap[name] && matchNode(editor, node, name, vars)) {
	            checkedMap[name] = true;
	            matchedFormatNames.push(name);
	          }
	        }
	      }, editor.dom.getRoot());
	      return matchedFormatNames;
	    };
	    var canApply = function (editor, name) {
	      var formatList = editor.formatter.get(name);
	      var startNode, parents, i, x, selector;
	      var dom = editor.dom;
	      if (formatList) {
	        startNode = editor.selection.getStart();
	        parents = FormatUtils.getParents(dom, startNode);
	        for (x = formatList.length - 1; x >= 0; x--) {
	          selector = formatList[x].selector;
	          if (!selector || formatList[x].defaultBlock) {
	            return true;
	          }
	          for (i = parents.length - 1; i >= 0; i--) {
	            if (dom.is(parents[i], selector)) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    };
	    var MatchFormat = {
	      matchNode: matchNode,
	      matchName: matchName,
	      match: match,
	      matchAll: matchAll,
	      canApply: canApply,
	      matchesUnInheritedFormatSelector: matchesUnInheritedFormatSelector
	    };
	
	    var splitText = function (node, offset) {
	      return node.splitText(offset);
	    };
	    var split$1 = function (rng) {
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      if (startContainer === endContainer && NodeType.isText(startContainer)) {
	        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          endContainer = splitText(startContainer, startOffset);
	          startContainer = endContainer.previousSibling;
	          if (endOffset > startOffset) {
	            endOffset = endOffset - startOffset;
	            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
	            endOffset = endContainer.nodeValue.length;
	            startOffset = 0;
	          } else {
	            endOffset = 0;
	          }
	        }
	      } else {
	        if (NodeType.isText(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          startContainer = splitText(startContainer, startOffset);
	          startOffset = 0;
	        }
	        if (NodeType.isText(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
	          endContainer = splitText(endContainer, endOffset).previousSibling;
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	    var SplitRange = { split: split$1 };
	
	    var ZWSP$1 = Zwsp.ZWSP, CARET_ID$1 = '_mce_caret';
	    var importNode = function (ownerDocument, node) {
	      return ownerDocument.importNode(node, true);
	    };
	    var getEmptyCaretContainers = function (node) {
	      var nodes = [];
	      while (node) {
	        if (node.nodeType === 3 && node.nodeValue !== ZWSP$1 || node.childNodes.length > 1) {
	          return [];
	        }
	        if (node.nodeType === 1) {
	          nodes.push(node);
	        }
	        node = node.firstChild;
	      }
	      return nodes;
	    };
	    var isCaretContainerEmpty = function (node) {
	      return getEmptyCaretContainers(node).length > 0;
	    };
	    var findFirstTextNode = function (node) {
	      var walker;
	      if (node) {
	        walker = new TreeWalker(node, node);
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var createCaretContainer = function (fill) {
	      var caretContainer = Element.fromTag('span');
	      setAll(caretContainer, {
	        'id': CARET_ID$1,
	        'data-mce-bogus': '1',
	        'data-mce-type': 'format-caret'
	      });
	      if (fill) {
	        append(caretContainer, Element.fromText(ZWSP$1));
	      }
	      return caretContainer;
	    };
	    var trimZwspFromCaretContainer = function (caretContainerNode) {
	      var textNode = findFirstTextNode(caretContainerNode);
	      if (textNode && textNode.nodeValue.charAt(0) === ZWSP$1) {
	        textNode.deleteData(0, 1);
	      }
	      return textNode;
	    };
	    var removeCaretContainerNode = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (isCaretContainerEmpty(node)) {
	        DeleteElement.deleteElement(editor, false, Element.fromDom(node), moveCaret);
	      } else {
	        var rng = selection.getRng();
	        var block = dom.getParent(node, dom.isBlock);
	        var textNode = trimZwspFromCaretContainer(node);
	        if (rng.startContainer === textNode && rng.startOffset > 0) {
	          rng.setStart(textNode, rng.startOffset - 1);
	        }
	        if (rng.endContainer === textNode && rng.endOffset > 0) {
	          rng.setEnd(textNode, rng.endOffset - 1);
	        }
	        dom.remove(node, true);
	        if (block && dom.isEmpty(block)) {
	          PaddingBr.fillWithPaddingBr(Element.fromDom(block));
	        }
	        selection.setRng(rng);
	      }
	    };
	    var removeCaretContainer = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (!node) {
	        node = getParentCaretContainer(editor.getBody(), selection.getStart());
	        if (!node) {
	          while (node = dom.get(CARET_ID$1)) {
	            removeCaretContainerNode(editor, node, false);
	          }
	        }
	      } else {
	        removeCaretContainerNode(editor, node, moveCaret);
	      }
	    };
	    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
	      var dom = editor.dom, block = dom.getParent(formatNode, curry(FormatUtils.isTextBlock, editor));
	      if (block && dom.isEmpty(block)) {
	        formatNode.parentNode.replaceChild(caretContainer, formatNode);
	      } else {
	        PaddingBr.removeTrailingBr(Element.fromDom(formatNode));
	        if (dom.isEmpty(formatNode)) {
	          formatNode.parentNode.replaceChild(caretContainer, formatNode);
	        } else {
	          dom.insertAfter(caretContainer, formatNode);
	        }
	      }
	    };
	    var appendNode = function (parentNode, node) {
	      parentNode.appendChild(node);
	      return node;
	    };
	    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
	      var innerMostFormatNode = foldr(formatNodes, function (parentNode, formatNode) {
	        return appendNode(parentNode, formatNode.cloneNode(false));
	      }, caretContainer);
	      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP$1));
	    };
	    var applyCaretFormat = function (editor, name, vars) {
	      var rng, caretContainer, textNode, offset, bookmark, container, text;
	      var selection = editor.selection;
	      rng = selection.getRng(true);
	      offset = rng.startOffset;
	      container = rng.startContainer;
	      text = container.nodeValue;
	      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
	      if (caretContainer) {
	        textNode = findFirstTextNode(caretContainer);
	      }
	      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
	      if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
	        bookmark = selection.getBookmark();
	        rng.collapse(true);
	        rng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name));
	        rng = SplitRange.split(rng);
	        editor.formatter.apply(name, vars, rng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        if (!caretContainer || textNode.nodeValue !== ZWSP$1) {
	          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom());
	          textNode = caretContainer.firstChild;
	          rng.insertNode(caretContainer);
	          offset = 1;
	          editor.formatter.apply(name, vars, caretContainer);
	        } else {
	          editor.formatter.apply(name, vars, caretContainer);
	        }
	        selection.setCursorLocation(textNode, offset);
	      }
	    };
	    var removeCaretFormat = function (editor, name, vars, similar) {
	      var dom = editor.dom, selection = editor.selection;
	      var container, offset, bookmark;
	      var hasContentAfter, node, formatNode;
	      var parents = [], rng = selection.getRng();
	      var caretContainer;
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      node = container;
	      if (container.nodeType === 3) {
	        if (offset !== container.nodeValue.length) {
	          hasContentAfter = true;
	        }
	        node = node.parentNode;
	      }
	      while (node) {
	        if (MatchFormat.matchNode(editor, node, name, vars, similar)) {
	          formatNode = node;
	          break;
	        }
	        if (node.nextSibling) {
	          hasContentAfter = true;
	        }
	        parents.push(node);
	        node = node.parentNode;
	      }
	      if (!formatNode) {
	        return;
	      }
	      if (hasContentAfter) {
	        bookmark = selection.getBookmark();
	        rng.collapse(true);
	        var expandedRng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name), true);
	        expandedRng = SplitRange.split(expandedRng);
	        editor.formatter.remove(name, vars, expandedRng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
	        var newCaretContainer = createCaretContainer(false).dom();
	        var caretNode = insertFormatNodesIntoCaretContainer(parents, newCaretContainer);
	        if (caretContainer) {
	          insertCaretContainerNode(editor, newCaretContainer, caretContainer);
	        } else {
	          insertCaretContainerNode(editor, newCaretContainer, formatNode);
	        }
	        removeCaretContainerNode(editor, caretContainer, false);
	        selection.setCursorLocation(caretNode, 1);
	        if (dom.isEmpty(formatNode)) {
	          dom.remove(formatNode);
	        }
	      }
	    };
	    var disableCaretContainer = function (editor, keyCode) {
	      var selection = editor.selection, body = editor.getBody();
	      removeCaretContainer(editor, null, false);
	      if ((keyCode === 8 || keyCode === 46) && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP$1) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	      if (keyCode === 37 || keyCode === 39) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	    };
	    var setup$2 = function (editor) {
	      editor.on('mouseup keydown', function (e) {
	        disableCaretContainer(editor, e.keyCode);
	      });
	    };
	    var replaceWithCaretFormat = function (targetNode, formatNodes) {
	      var caretContainer = createCaretContainer(false);
	      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom());
	      before(Element.fromDom(targetNode), caretContainer);
	      remove$1(Element.fromDom(targetNode));
	      return CaretPosition$1(innerMost, 0);
	    };
	    var isFormatElement = function (editor, element) {
	      var inlineElements = editor.schema.getTextInlineElements();
	      return inlineElements.hasOwnProperty(name(element)) && !isCaretNode(element.dom()) && !NodeType.isBogus(element.dom());
	    };
	    var isEmptyCaretFormatElement = function (element) {
	      return isCaretNode(element.dom()) && isCaretContainerEmpty(element.dom());
	    };
	
	    var getParentInlines = function (rootElm, startElm) {
	      var parents = Parents.parentsAndSelf(startElm, rootElm);
	      return findIndex(parents, isBlock).fold(constant(parents), function (index) {
	        return parents.slice(0, index);
	      });
	    };
	    var hasOnlyOneChild$1 = function (elm) {
	      return children(elm).length === 1;
	    };
	    var deleteLastPosition = function (forward, editor, target, parentInlines) {
	      var isFormatElement$1 = curry(isFormatElement, editor);
	      var formatNodes = map(filter(parentInlines, isFormatElement$1), function (elm) {
	        return elm.dom();
	      });
	      if (formatNodes.length === 0) {
	        DeleteElement.deleteElement(editor, forward, target);
	      } else {
	        var pos = replaceWithCaretFormat(target.dom(), formatNodes);
	        editor.selection.setRng(pos.toRange());
	      }
	    };
	    var deleteCaret$1 = function (editor, forward) {
	      var rootElm = Element.fromDom(editor.getBody());
	      var startElm = Element.fromDom(editor.selection.getStart());
	      var parentInlines = filter(getParentInlines(rootElm, startElm), hasOnlyOneChild$1);
	      return last(parentInlines).map(function (target) {
	        var fromPos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        if (DeleteUtils.willDeleteLastPositionInElement(forward, fromPos, target.dom()) && !isEmptyCaretFormatElement(target)) {
	          deleteLastPosition(forward, editor, target, parentInlines);
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var backspaceDelete$5 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
	    };
	    var InlineFormatDelete = { backspaceDelete: backspaceDelete$5 };
	
	    var isContentEditableTrue$2 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$6 = NodeType.isContentEditableFalse;
	    var showCaret = function (direction, editor, node, before, scrollIntoView) {
	      return editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView);
	    };
	    var getNodeRange = function (node) {
	      var rng = node.ownerDocument.createRange();
	      rng.selectNode(node);
	      return rng;
	    };
	    var selectNode = function (editor, node) {
	      var e = editor.fire('BeforeObjectSelected', { target: node });
	      if (e.isDefaultPrevented()) {
	        return null;
	      }
	      return getNodeRange(node);
	    };
	    var renderCaretAtRange = function (editor, range, scrollIntoView) {
	      var normalizedRange = normalizeRange(1, editor.getBody(), range);
	      var caretPosition = CaretPosition$1.fromRangeStart(normalizedRange);
	      var caretPositionNode = caretPosition.getNode();
	      if (isContentEditableFalse$6(caretPositionNode)) {
	        return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
	      }
	      var caretPositionBeforeNode = caretPosition.getNode(true);
	      if (isContentEditableFalse$6(caretPositionBeforeNode)) {
	        return showCaret(1, editor, caretPositionBeforeNode, false, false);
	      }
	      var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
	        return isContentEditableFalse$6(node) || isContentEditableTrue$2(node);
	      });
	      if (isContentEditableFalse$6(ceRoot)) {
	        return showCaret(1, editor, ceRoot, false, scrollIntoView);
	      }
	      return null;
	    };
	    var renderRangeCaret = function (editor, range, scrollIntoView) {
	      if (!range || !range.collapsed) {
	        return range;
	      }
	      var caretRange = renderCaretAtRange(editor, range, scrollIntoView);
	      if (caretRange) {
	        return caretRange;
	      }
	      return range;
	    };
	
	    var trimEmptyTextNode$1 = function (dom, node) {
	      if (NodeType.isText(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var deleteContentAndShowCaret = function (editor, range, node, direction, forward, peekCaretPosition) {
	      var caretRange = showCaret(direction, editor, peekCaretPosition.getNode(!forward), forward, true);
	      if (range.collapsed) {
	        var deleteRange = range.cloneRange();
	        if (forward) {
	          deleteRange.setEnd(caretRange.startContainer, caretRange.startOffset);
	        } else {
	          deleteRange.setStart(caretRange.endContainer, caretRange.endOffset);
	        }
	        deleteRange.deleteContents();
	      } else {
	        range.deleteContents();
	      }
	      editor.selection.setRng(caretRange);
	      trimEmptyTextNode$1(editor.dom, node);
	      return true;
	    };
	    var deleteCefBoundaryText = function (editor, forward) {
	      var range = editor.selection.getRng();
	      if (!NodeType.isText(range.commonAncestorContainer)) {
	        return false;
	      }
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
	      var isBeforeContentEditableFalseFn = forward ? isBeforeContentEditableFalse : isAfterContentEditableFalse;
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var nextCaretPosition = InlineUtils.normalizePosition(forward, getNextPosFn(caretPosition));
	      if (!nextCaretPosition) {
	        return false;
	      } else if (isBeforeContentEditableFalseFn(nextCaretPosition)) {
	        return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, nextCaretPosition);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeContentEditableFalseFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, peekCaretPosition);
	        }
	      }
	      return false;
	    };
	    var backspaceDelete$6 = function (editor, forward) {
	      return deleteCefBoundaryText(editor, forward);
	    };
	    var CefBoundaryDelete = { backspaceDelete: backspaceDelete$6 };
	
	    var nativeCommand = function (editor, command) {
	      editor.getDoc().execCommand(command, false, null);
	    };
	    var deleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (CefBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (InlineBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (InlineFormatDelete.backspaceDelete(editor, false)) {
	        return;
	      } else {
	        nativeCommand(editor, 'Delete');
	        DeleteUtils.paddEmptyBody(editor);
	      }
	    };
	    var forwardDeleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (CefBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (InlineBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (InlineFormatDelete.backspaceDelete(editor, true)) {
	        return;
	      } else {
	        nativeCommand(editor, 'ForwardDelete');
	      }
	    };
	    var DeleteCommands = {
	      deleteCommand: deleteCommand,
	      forwardDeleteCommand: forwardDeleteCommand
	    };
	
	    var getSpecifiedFontProp = function (propName, rootElm, elm) {
	      var getProperty = function (elm) {
	        return getRaw(elm, propName);
	      };
	      var isRoot = function (elm) {
	        return eq(Element.fromDom(rootElm), elm);
	      };
	      return closest(Element.fromDom(elm), function (elm) {
	        return getProperty(elm).isSome();
	      }, isRoot).bind(getProperty);
	    };
	    var round$1 = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round$1(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      }
	      return fontSize;
	    };
	    var normalizeFontFamily = function (fontFamily) {
	      return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
	    };
	    var getComputedFontProp = function (propName, elm) {
	      return Option.from(DOMUtils$1.DOM.getStyle(elm, propName, true));
	    };
	    var getFontProp = function (propName) {
	      return function (rootElm, elm) {
	        return Option.from(elm).map(Element.fromDom).filter(isElement).bind(function (element) {
	          return getSpecifiedFontProp(propName, rootElm, element.dom()).or(getComputedFontProp(propName, element.dom()));
	        }).getOr('');
	      };
	    };
	    var FontInfo = {
	      getFontSize: getFontProp('font-size'),
	      getFontFamily: compose(normalizeFontFamily, getFontProp('font-family')),
	      toPt: toPt
	    };
	
	    var findFirstCaretElement = function (editor) {
	      return CaretFinder.firstPositionIn(editor.getBody()).map(function (caret) {
	        var container = caret.container();
	        return NodeType.isText(container) ? container.parentNode : container;
	      });
	    };
	    var isRangeAtStartOfNode = function (rng, root) {
	      return rng.startContainer === root && rng.startOffset === 0;
	    };
	    var getCaretElement = function (editor) {
	      return Option.from(editor.selection.getRng()).bind(function (rng) {
	        var root = editor.getBody();
	        return isRangeAtStartOfNode(rng, root) ? Option.none() : Option.from(editor.selection.getStart(true));
	      });
	    };
	    var fromFontSizeNumber = function (editor, value) {
	      if (/^[0-9\.]+$/.test(value)) {
	        var fontSizeNumber = parseInt(value, 10);
	        if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
	          var fontSizes = Settings.getFontStyleValues(editor);
	          var fontClasses = Settings.getFontSizeClasses(editor);
	          if (fontClasses) {
	            return fontClasses[fontSizeNumber - 1] || value;
	          } else {
	            return fontSizes[fontSizeNumber - 1] || value;
	          }
	        } else {
	          return value;
	        }
	      } else {
	        return value;
	      }
	    };
	    var fontNameAction = function (editor, value) {
	      editor.formatter.toggle('fontname', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontNameQuery = function (editor) {
	      return getCaretElement(editor).fold(function () {
	        return findFirstCaretElement(editor).map(function (caretElement) {
	          return FontInfo.getFontFamily(editor.getBody(), caretElement);
	        }).getOr('');
	      }, function (caretElement) {
	        return FontInfo.getFontFamily(editor.getBody(), caretElement);
	      });
	    };
	    var fontSizeAction = function (editor, value) {
	      editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontSizeQuery = function (editor) {
	      return getCaretElement(editor).fold(function () {
	        return findFirstCaretElement(editor).map(function (caretElement) {
	          return FontInfo.getFontSize(editor.getBody(), caretElement);
	        }).getOr('');
	      }, function (caretElement) {
	        return FontInfo.getFontSize(editor.getBody(), caretElement);
	      });
	    };
	
	    var isEq$3 = function (rng1, rng2) {
	      return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
	    };
	    var RangeCompare = { isEq: isEq$3 };
	
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var hasParent = function (node, rootNode, predicate) {
	      return findParent(node, rootNode, predicate) !== null;
	    };
	    var hasParentWithName = function (node, rootNode, name) {
	      return hasParent(node, rootNode, function (node) {
	        return node.nodeName === name;
	      });
	    };
	    var isTable$2 = function (node) {
	      return node && node.nodeName === 'TABLE';
	    };
	    var isTableCell$3 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var isCeFalseCaretContainer = function (node, rootNode) {
	      return isCaretContainer(node) && hasParent(node, rootNode, isCaretNode) === false;
	    };
	    var hasBrBeforeAfter = function (dom, node, left) {
	      var walker = new TreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (NodeType.isBr(node)) {
	          return true;
	        }
	      }
	    };
	    var isPrevNode = function (node, name) {
	      return node.previousSibling && node.previousSibling.nodeName === name;
	    };
	    var hasContentEditableFalseParent = function (body, node) {
	      while (node && node !== body) {
	        if (NodeType.isContentEditableFalse(node)) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    };
	    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
	      var walker, lastInlineElement, parentBlockContainer;
	      var body = dom.getRoot();
	      var node;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	      if (left && NodeType.isBr(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
	        return Option.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
	      }
	      walker = new TreeWalker(startNode, parentBlockContainer);
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
	          return Option.none();
	        }
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          if (hasParentWithName(node, body, 'A') === false) {
	            return Option.some(CaretPosition(node, left ? node.nodeValue.length : 0));
	          }
	          return Option.none();
	        }
	        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          return Option.none();
	        }
	        lastInlineElement = node;
	      }
	      if (collapsed && lastInlineElement) {
	        return Option.some(CaretPosition(lastInlineElement, 0));
	      }
	      return Option.none();
	    };
	    var normalizeEndPoint = function (dom, collapsed, start, rng) {
	      var container, offset, walker;
	      var body = dom.getRoot();
	      var node, nonEmptyElementsMap;
	      var directionLeft, isAfterNode, normalized = false;
	      container = rng[(start ? 'start' : 'end') + 'Container'];
	      offset = rng[(start ? 'start' : 'end') + 'Offset'];
	      isAfterNode = NodeType.isElement(container) && offset === container.childNodes.length;
	      nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      directionLeft = start;
	      if (isCaretContainer(container)) {
	        return Option.none();
	      }
	      if (NodeType.isElement(container) && offset > container.childNodes.length - 1) {
	        directionLeft = false;
	      }
	      if (NodeType.isDocument(container)) {
	        container = body;
	        offset = 0;
	      }
	      if (container === body) {
	        if (directionLeft) {
	          node = container.childNodes[offset > 0 ? offset - 1 : 0];
	          if (node) {
	            if (isCaretContainer(node)) {
	              return Option.none();
	            }
	            if (nonEmptyElementsMap[node.nodeName] || isTable$2(node)) {
	              return Option.none();
	            }
	          }
	        }
	        if (container.hasChildNodes()) {
	          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
	          container = container.childNodes[offset];
	          offset = NodeType.isText(container) && isAfterNode ? container.data.length : 0;
	          if (!collapsed && container === body.lastChild && isTable$2(container)) {
	            return Option.none();
	          }
	          if (hasContentEditableFalseParent(body, container) || isCaretContainer(container)) {
	            return Option.none();
	          }
	          if (container.hasChildNodes() && isTable$2(container) === false) {
	            node = container;
	            walker = new TreeWalker(container, body);
	            do {
	              if (NodeType.isContentEditableFalse(node) || isCaretContainer(node)) {
	                normalized = false;
	                break;
	              }
	              if (NodeType.isText(node) && node.nodeValue.length > 0) {
	                offset = directionLeft ? 0 : node.nodeValue.length;
	                container = node;
	                normalized = true;
	                break;
	              }
	              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$3(node)) {
	                offset = dom.nodeIndex(node);
	                container = node.parentNode;
	                if (!directionLeft) {
	                  offset++;
	                }
	                normalized = true;
	                break;
	              }
	            } while (node = directionLeft ? walker.next() : walker.prev());
	          }
	        }
	      }
	      if (collapsed) {
	        if (NodeType.isText(container) && offset === 0) {
	          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
	            container = pos.container();
	            offset = pos.offset();
	            normalized = true;
	          });
	        }
	        if (NodeType.isElement(container)) {
	          node = container.childNodes[offset];
	          if (!node) {
	            node = container.childNodes[offset - 1];
	          }
	          if (node && NodeType.isBr(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
	            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
	              container = pos.container();
	              offset = pos.offset();
	              normalized = true;
	            });
	          }
	        }
	      }
	      if (directionLeft && !collapsed && NodeType.isText(container) && offset === container.nodeValue.length) {
	        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
	          container = pos.container();
	          offset = pos.offset();
	          normalized = true;
	        });
	      }
	      return normalized ? Option.some(CaretPosition(container, offset)) : Option.none();
	    };
	    var normalize$2 = function (dom, rng) {
	      var collapsed = rng.collapsed, normRng = rng.cloneRange();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
	        if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
	          normRng.setStart(pos.container(), pos.offset());
	        }
	      });
	      if (!collapsed) {
	        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
	          normRng.setEnd(pos.container(), pos.offset());
	        });
	      }
	      if (collapsed) {
	        normRng.collapse(true);
	      }
	      return RangeCompare.isEq(rng, normRng) ? Option.none() : Option.some(normRng);
	    };
	    var NormalizeRange = { normalize: normalize$2 };
	
	    var hasRightSideContent = function (schema, container, parentBlock) {
	      var walker = new TreeWalker(container, parentBlock);
	      var node;
	      var nonEmptyElementsMap = schema.getNonEmptyElements();
	      while (node = walker.next()) {
	        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
	          return true;
	        }
	      }
	    };
	    var scrollToBr = function (dom, selection, brElm) {
	      var marker = dom.create('span', {}, '&nbsp;');
	      brElm.parentNode.insertBefore(marker, brElm);
	      selection.scrollIntoView(marker);
	      dom.remove(marker);
	    };
	    var moveSelectionToBr = function (dom, selection, brElm, extraBr) {
	      var rng = dom.createRng();
	      if (!extraBr) {
	        rng.setStartAfter(brElm);
	        rng.setEndAfter(brElm);
	      } else {
	        rng.setStartBefore(brElm);
	        rng.setEndBefore(brElm);
	      }
	      selection.setRng(rng);
	    };
	    var insertBrAtCaret = function (editor, evt) {
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var rng = selection.getRng();
	      var brElm;
	      var extraBr;
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && container.nodeType === 3) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var parentBlock = dom.getParent(container, dom.isBlock);
	      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      var isControlKey = evt && evt.ctrlKey;
	      if (containerBlockName === 'LI' && !isControlKey) {
	        parentBlock = containerBlock;
	      }
	      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
	        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
	          brElm = dom.create('br');
	          rng.insertNode(brElm);
	          rng.setStartAfter(brElm);
	          rng.setEndAfter(brElm);
	          extraBr = true;
	        }
	      }
	      brElm = dom.create('br');
	      rangeInsertNode(dom, rng, brElm);
	      scrollToBr(dom, selection, brElm);
	      moveSelectionToBr(dom, selection, brElm, extraBr);
	      editor.undoManager.add();
	    };
	    var insertBrBefore = function (editor, inline) {
	      var br = Element.fromTag('br');
	      before(Element.fromDom(inline), br);
	      editor.undoManager.add();
	    };
	    var insertBrAfter = function (editor, inline) {
	      if (!hasBrAfter(editor.getBody(), inline)) {
	        after(Element.fromDom(inline), Element.fromTag('br'));
	      }
	      var br = Element.fromTag('br');
	      after(Element.fromDom(inline), br);
	      scrollToBr(editor.dom, editor.selection, br.dom());
	      moveSelectionToBr(editor.dom, editor.selection, br.dom(), false);
	      editor.undoManager.add();
	    };
	    var isBeforeBr$1 = function (pos) {
	      return NodeType.isBr(pos.getNode());
	    };
	    var hasBrAfter = function (rootNode, startNode) {
	      if (isBeforeBr$1(CaretPosition$1.after(startNode))) {
	        return true;
	      } else {
	        return CaretFinder.nextPosition(rootNode, CaretPosition$1.after(startNode)).map(function (pos) {
	          return NodeType.isBr(pos.getNode());
	        }).getOr(false);
	      }
	    };
	    var isAnchorLink = function (elm) {
	      return elm && elm.nodeName === 'A' && 'href' in elm;
	    };
	    var isInsideAnchor = function (location) {
	      return location.fold(constant(false), isAnchorLink, isAnchorLink, constant(false));
	    };
	    var readInlineAnchorLocation = function (editor) {
	      var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	      var position = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      return BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), position).filter(isInsideAnchor);
	    };
	    var insertBrOutsideAnchor = function (editor, location) {
	      location.fold(noop, curry(insertBrBefore, editor), curry(insertBrAfter, editor), noop);
	    };
	    var insert = function (editor, evt) {
	      var anchorLocation = readInlineAnchorLocation(editor);
	      if (anchorLocation.isSome()) {
	        anchorLocation.each(curry(insertBrOutsideAnchor, editor));
	      } else {
	        insertBrAtCaret(editor, evt);
	      }
	    };
	    var InsertBr = { insert: insert };
	
	    var create$3 = Immutable('start', 'soffset', 'finish', 'foffset');
	    var SimRange = { create: create$3 };
	
	    var adt = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$4 = adt.before;
	    var on = adt.on;
	    var after$3 = adt.after;
	    var Situ = {
	      before: before$4,
	      on: on,
	      after: after$3,
	      cata: cata,
	      getStart: getStart
	    };
	
	    var adt$1 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$1.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return Element.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$1.domRange;
	    var relative = adt$1.relative;
	    var exact = adt$1.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range = SimRange.create;
	    var Selection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range
	    };
	
	    var browser$3 = PlatformDetection$1.detect().browser;
	    var clamp = function (offset, element) {
	      var max = isText(element) ? get$4(element).length : children(element).length + 1;
	      if (offset > max) {
	        return max;
	      } else if (offset < 0) {
	        return 0;
	      }
	      return offset;
	    };
	    var normalizeRng = function (rng) {
	      return Selection.range(rng.start(), clamp(rng.soffset(), rng.start()), rng.finish(), clamp(rng.foffset(), rng.finish()));
	    };
	    var isOrContains = function (root, elm) {
	      return !NodeType.isRestrictedNode(elm.dom()) && (contains$3(root, elm) || eq(root, elm));
	    };
	    var isRngInRoot = function (root) {
	      return function (rng) {
	        return isOrContains(root, rng.start()) && isOrContains(root, rng.finish());
	      };
	    };
	    var shouldStore = function (editor) {
	      return editor.inline === true || browser$3.isIE();
	    };
	    var nativeRangeToSelectionRange = function (r) {
	      return Selection.range(Element.fromDom(r.startContainer), r.startOffset, Element.fromDom(r.endContainer), r.endOffset);
	    };
	    var readRange = function (win) {
	      var selection = win.getSelection();
	      var rng = !selection || selection.rangeCount === 0 ? Option.none() : Option.from(selection.getRangeAt(0));
	      return rng.map(nativeRangeToSelectionRange);
	    };
	    var getBookmark$2 = function (root) {
	      var win = defaultView(root);
	      return readRange(win.dom()).filter(isRngInRoot(root));
	    };
	    var validate = function (root, bookmark) {
	      return Option.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
	    };
	    var bookmarkToNativeRng = function (bookmark) {
	      var rng = domGlobals.document.createRange();
	      try {
	        rng.setStart(bookmark.start().dom(), bookmark.soffset());
	        rng.setEnd(bookmark.finish().dom(), bookmark.foffset());
	        return Option.some(rng);
	      } catch (_) {
	        return Option.none();
	      }
	    };
	    var store = function (editor) {
	      var newBookmark = shouldStore(editor) ? getBookmark$2(Element.fromDom(editor.getBody())) : Option.none();
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var storeNative = function (editor, rng) {
	      var root = Element.fromDom(editor.getBody());
	      var range = shouldStore(editor) ? Option.from(rng) : Option.none();
	      var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var getRng = function (editor) {
	      var bookmark = editor.bookmark ? editor.bookmark : Option.none();
	      return bookmark.bind(curry(validate, Element.fromDom(editor.getBody()))).bind(bookmarkToNativeRng);
	    };
	    var restore = function (editor) {
	      getRng(editor).each(function (rng) {
	        editor.selection.setRng(rng);
	      });
	    };
	    var SelectionBookmark = {
	      store: store,
	      storeNative: storeNative,
	      readRange: readRange,
	      restore: restore,
	      getRng: getRng,
	      getBookmark: getBookmark$2,
	      validate: validate
	    };
	
	    var indentElement = function (dom, command, useMargin, value, unit, element) {
	      if (dom.getContentEditable(element) === 'false') {
	        return;
	      }
	      var indentStyleName = useMargin ? 'margin' : 'padding';
	      indentStyleName = element.nodeName === 'TABLE' ? 'margin' : indentStyleName;
	      indentStyleName += dom.getStyle(element, 'direction', true) === 'rtl' ? 'Right' : 'Left';
	      if (command === 'outdent') {
	        var styleValue = Math.max(0, parseInt(element.style[indentStyleName] || 0, 10) - value);
	        dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
	      } else {
	        var styleValue = parseInt(element.style[indentStyleName] || 0, 10) + value + unit;
	        dom.setStyle(element, indentStyleName, styleValue);
	      }
	    };
	    var isListComponent = function (el) {
	      return isList(el) || isListItem(el);
	    };
	    var parentIsListComponent = function (el) {
	      return parent(el).map(isListComponent).getOr(false);
	    };
	    var getBlocksToIndent = function (editor) {
	      return filter(map(editor.selection.getSelectedBlocks(), Element.fromDom), function (el) {
	        return !isListComponent(el) && !parentIsListComponent(el);
	      });
	    };
	    var handle = function (editor, command) {
	      var settings = editor.settings, dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
	      var indentUnit = /[a-z%]+$/i.exec(settings.indentation)[0];
	      var indentValue = parseInt(settings.indentation, 10);
	      var useMargin = editor.getParam('indent_use_margin', false);
	      if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
	        if (!settings.forced_root_block && !dom.getParent(selection.getNode(), dom.isBlock)) {
	          formatter.apply('div');
	        }
	      }
	      each(getBlocksToIndent(editor), function (block) {
	        indentElement(dom, command, useMargin, indentValue, indentUnit, block.dom());
	      });
	    };
	
	    var each$a = Tools.each, extend$2 = Tools.extend;
	    var map$3 = Tools.map, inArray$2 = Tools.inArray;
	    function EditorCommands (editor) {
	      var dom, selection, formatter;
	      var commands = {
	        state: {},
	        exec: {},
	        value: {}
	      };
	      var settings = editor.settings, bookmark;
	      editor.on('PreInit', function () {
	        dom = editor.dom;
	        selection = editor.selection;
	        settings = editor.settings;
	        formatter = editor.formatter;
	      });
	      var execCommand = function (command, ui, value, args) {
	        var func, customCommand, state = false;
	        if (editor.removed) {
	          return;
	        }
	        if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
	          editor.focus();
	        } else {
	          SelectionBookmark.restore(editor);
	        }
	        args = editor.fire('BeforeExecCommand', {
	          command: command,
	          ui: ui,
	          value: value
	        });
	        if (args.isDefaultPrevented()) {
	          return false;
	        }
	        customCommand = command.toLowerCase();
	        if (func = commands.exec[customCommand]) {
	          func(customCommand, ui, value);
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        each$a(editor.plugins, function (p) {
	          if (p.execCommand && p.execCommand(command, ui, value)) {
	            editor.fire('ExecCommand', {
	              command: command,
	              ui: ui,
	              value: value
	            });
	            state = true;
	            return false;
	          }
	        });
	        if (state) {
	          return state;
	        }
	        if (editor.theme && editor.theme.execCommand && editor.theme.execCommand(command, ui, value)) {
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        try {
	          state = editor.getDoc().execCommand(command, ui, value);
	        } catch (ex) {
	        }
	        if (state) {
	          editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        return false;
	      };
	      var queryCommandState = function (command) {
	        var func;
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = commands.state[command]) {
	          return func(command);
	        }
	        try {
	          return editor.getDoc().queryCommandState(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      var queryCommandValue = function (command) {
	        var func;
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = commands.value[command]) {
	          return func(command);
	        }
	        try {
	          return editor.getDoc().queryCommandValue(command);
	        } catch (ex) {
	        }
	      };
	      var addCommands = function (commandList, type) {
	        type = type || 'exec';
	        each$a(commandList, function (callback, command) {
	          each$a(command.toLowerCase().split(','), function (command) {
	            commands[type][command] = callback;
	          });
	        });
	      };
	      var addCommand = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.exec[command] = function (command, ui, value, args) {
	          return callback.call(scope || editor, ui, value, args);
	        };
	      };
	      var queryCommandSupported = function (command) {
	        command = command.toLowerCase();
	        if (commands.exec[command]) {
	          return true;
	        }
	        try {
	          return editor.getDoc().queryCommandSupported(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      var addQueryStateHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.state[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	      var addQueryValueHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.value[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	      var hasCustomCommand = function (command) {
	        command = command.toLowerCase();
	        return !!commands.exec[command];
	      };
	      extend$2(this, {
	        execCommand: execCommand,
	        queryCommandState: queryCommandState,
	        queryCommandValue: queryCommandValue,
	        queryCommandSupported: queryCommandSupported,
	        addCommands: addCommands,
	        addCommand: addCommand,
	        addQueryStateHandler: addQueryStateHandler,
	        addQueryValueHandler: addQueryValueHandler,
	        hasCustomCommand: hasCustomCommand
	      });
	      var execNativeCommand = function (command, ui, value) {
	        if (ui === undefined) {
	          ui = false;
	        }
	        if (value === undefined) {
	          value = null;
	        }
	        return editor.getDoc().execCommand(command, ui, value);
	      };
	      var isFormatMatch = function (name) {
	        return formatter.match(name);
	      };
	      var toggleFormat = function (name, value) {
	        formatter.toggle(name, value ? { value: value } : undefined);
	        editor.nodeChanged();
	      };
	      var storeSelection = function (type) {
	        bookmark = selection.getBookmark(type);
	      };
	      var restoreSelection = function () {
	        selection.moveToBookmark(bookmark);
	      };
	      addCommands({
	        'mceResetDesignMode,mceBeginUndoLevel': function () {
	        },
	        'mceEndUndoLevel,mceAddUndoLevel': function () {
	          editor.undoManager.add();
	        },
	        'Cut,Copy,Paste': function (command) {
	          var doc = editor.getDoc();
	          var failed;
	          try {
	            execNativeCommand(command);
	          } catch (ex) {
	            failed = true;
	          }
	          if (command === 'paste' && !doc.queryCommandEnabled(command)) {
	            failed = true;
	          }
	          if (failed || !doc.queryCommandSupported(command)) {
	            var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
	            if (Env.mac) {
	              msg = msg.replace(/Ctrl\+/g, '\u2318+');
	            }
	            editor.notificationManager.open({
	              text: msg,
	              type: 'error'
	            });
	          }
	        },
	        'unlink': function () {
	          if (selection.isCollapsed()) {
	            var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
	            if (elm) {
	              editor.dom.remove(elm, true);
	            }
	            return;
	          }
	          formatter.remove('link');
	        },
	        'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
	          var align = command.substring(7);
	          if (align === 'full') {
	            align = 'justify';
	          }
	          each$a('left,center,right,justify'.split(','), function (name) {
	            if (align !== name) {
	              formatter.remove('align' + name);
	            }
	          });
	          if (align !== 'none') {
	            toggleFormat('align' + align);
	          }
	        },
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var listElm, listParent;
	          execNativeCommand(command);
	          listElm = dom.getParent(selection.getNode(), 'ol,ul');
	          if (listElm) {
	            listParent = listElm.parentNode;
	            if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
	              storeSelection();
	              dom.split(listParent, listElm);
	              restoreSelection();
	            }
	          }
	        },
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          toggleFormat(command);
	        },
	        'ForeColor,HiliteColor': function (command, ui, value) {
	          toggleFormat(command, value);
	        },
	        'FontName': function (command, ui, value) {
	          fontNameAction(editor, value);
	        },
	        'FontSize': function (command, ui, value) {
	          fontSizeAction(editor, value);
	        },
	        'RemoveFormat': function (command) {
	          formatter.remove(command);
	        },
	        'mceBlockQuote': function () {
	          toggleFormat('blockquote');
	        },
	        'FormatBlock': function (command, ui, value) {
	          return toggleFormat(value || 'p');
	        },
	        'mceCleanup': function () {
	          var bookmark = selection.getBookmark();
	          editor.setContent(editor.getContent());
	          selection.moveToBookmark(bookmark);
	        },
	        'mceRemoveNode': function (command, ui, value) {
	          var node = value || selection.getNode();
	          if (node !== editor.getBody()) {
	            storeSelection();
	            editor.dom.remove(node, true);
	            restoreSelection();
	          }
	        },
	        'mceSelectNodeDepth': function (command, ui, value) {
	          var counter = 0;
	          dom.getParent(selection.getNode(), function (node) {
	            if (node.nodeType === 1 && counter++ === value) {
	              selection.select(node);
	              return false;
	            }
	          }, editor.getBody());
	        },
	        'mceSelectNode': function (command, ui, value) {
	          selection.select(value);
	        },
	        'mceInsertContent': function (command, ui, value) {
	          InsertContent.insertAtCaret(editor, value);
	        },
	        'mceInsertRawHTML': function (command, ui, value) {
	          selection.setContent('tiny_mce_marker');
	          var content = editor.getContent();
	          editor.setContent(content.replace(/tiny_mce_marker/g, function () {
	            return value;
	          }));
	        },
	        'mceToggleFormat': function (command, ui, value) {
	          toggleFormat(value);
	        },
	        'mceSetContent': function (command, ui, value) {
	          editor.setContent(value);
	        },
	        'Indent,Outdent': function (command) {
	          handle(editor, command);
	        },
	        'mceRepaint': function () {
	        },
	        'InsertHorizontalRule': function () {
	          editor.execCommand('mceInsertContent', false, '<hr />');
	        },
	        'mceToggleVisualAid': function () {
	          editor.hasVisual = !editor.hasVisual;
	          editor.addVisual();
	        },
	        'mceReplaceContent': function (command, ui, value) {
	          editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, selection.getContent({ format: 'text' })));
	        },
	        'mceInsertLink': function (command, ui, value) {
	          var anchor;
	          if (typeof value === 'string') {
	            value = { href: value };
	          }
	          anchor = dom.getParent(selection.getNode(), 'a');
	          value.href = value.href.replace(' ', '%20');
	          if (!anchor || !value.href) {
	            formatter.remove('link');
	          }
	          if (value.href) {
	            formatter.apply('link', value, anchor);
	          }
	        },
	        'selectAll': function () {
	          var editingHost = dom.getParent(selection.getStart(), NodeType.isContentEditableTrue);
	          if (editingHost) {
	            var rng = dom.createRng();
	            rng.selectNodeContents(editingHost);
	            selection.setRng(rng);
	          }
	        },
	        'delete': function () {
	          DeleteCommands.deleteCommand(editor);
	        },
	        'forwardDelete': function () {
	          DeleteCommands.forwardDeleteCommand(editor);
	        },
	        'mceNewDocument': function () {
	          editor.setContent('');
	        },
	        'InsertLineBreak': function (command, ui, value) {
	          InsertBr.insert(editor, value);
	          return true;
	        }
	      });
	      var alignStates = function (name) {
	        return function () {
	          var nodes = selection.isCollapsed() ? [dom.getParent(selection.getNode(), dom.isBlock)] : selection.getSelectedBlocks();
	          var matches = map$3(nodes, function (node) {
	            return !!formatter.matchNode(node, name);
	          });
	          return inArray$2(matches, true) !== -1;
	        };
	      };
	      addCommands({
	        'JustifyLeft': alignStates('alignleft'),
	        'JustifyCenter': alignStates('aligncenter'),
	        'JustifyRight': alignStates('alignright'),
	        'JustifyFull': alignStates('alignjustify'),
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          return isFormatMatch(command);
	        },
	        'mceBlockQuote': function () {
	          return isFormatMatch('blockquote');
	        },
	        'Outdent': function () {
	          var node;
	          if (settings.inline_styles) {
	            if ((node = dom.getParent(selection.getStart(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return true;
	            }
	            if ((node = dom.getParent(selection.getEnd(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return true;
	            }
	          }
	          return queryCommandState('InsertUnorderedList') || queryCommandState('InsertOrderedList') || !settings.inline_styles && !!dom.getParent(selection.getNode(), 'BLOCKQUOTE');
	        },
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var list = dom.getParent(selection.getNode(), 'ul,ol');
	          return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
	        }
	      }, 'state');
	      addCommands({
	        Undo: function () {
	          editor.undoManager.undo();
	        },
	        Redo: function () {
	          editor.undoManager.redo();
	        }
	      });
	      addQueryValueHandler('FontName', function () {
	        return fontNameQuery(editor);
	      }, this);
	      addQueryValueHandler('FontSize', function () {
	        return fontSizeQuery(editor);
	      }, this);
	    }
	
	    var nativeEvents = Tools.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend', ' ');
	    var Dispatcher = function (settings) {
	      var self = this;
	      var scope, bindings = {}, toggleEvent;
	      var returnFalse = function () {
	        return false;
	      };
	      var returnTrue = function () {
	        return true;
	      };
	      settings = settings || {};
	      scope = settings.scope || self;
	      toggleEvent = settings.toggleEvent || returnFalse;
	      var fire = function (name, args) {
	        var handlers, i, l, callback;
	        name = name.toLowerCase();
	        args = args || {};
	        args.type = name;
	        if (!args.target) {
	          args.target = scope;
	        }
	        if (!args.preventDefault) {
	          args.preventDefault = function () {
	            args.isDefaultPrevented = returnTrue;
	          };
	          args.stopPropagation = function () {
	            args.isPropagationStopped = returnTrue;
	          };
	          args.stopImmediatePropagation = function () {
	            args.isImmediatePropagationStopped = returnTrue;
	          };
	          args.isDefaultPrevented = returnFalse;
	          args.isPropagationStopped = returnFalse;
	          args.isImmediatePropagationStopped = returnFalse;
	        }
	        if (settings.beforeFire) {
	          settings.beforeFire(args);
	        }
	        handlers = bindings[name];
	        if (handlers) {
	          for (i = 0, l = handlers.length; i < l; i++) {
	            callback = handlers[i];
	            if (callback.once) {
	              off(name, callback.func);
	            }
	            if (args.isImmediatePropagationStopped()) {
	              args.stopPropagation();
	              return args;
	            }
	            if (callback.func.call(scope, args) === false) {
	              args.preventDefault();
	              return args;
	            }
	          }
	        }
	        return args;
	      };
	      var on = function (name, callback, prepend, extra) {
	        var handlers, names, i;
	        if (callback === false) {
	          callback = returnFalse;
	        }
	        if (callback) {
	          callback = { func: callback };
	          if (extra) {
	            Tools.extend(callback, extra);
	          }
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	            if (!handlers) {
	              handlers = bindings[name] = [];
	              toggleEvent(name, true);
	            }
	            if (prepend) {
	              handlers.unshift(callback);
	            } else {
	              handlers.push(callback);
	            }
	          }
	        }
	        return self;
	      };
	      var off = function (name, callback) {
	        var i, handlers, bindingName, names, hi;
	        if (name) {
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	            if (!name) {
	              for (bindingName in bindings) {
	                toggleEvent(bindingName, false);
	                delete bindings[bindingName];
	              }
	              return self;
	            }
	            if (handlers) {
	              if (!callback) {
	                handlers.length = 0;
	              } else {
	                hi = handlers.length;
	                while (hi--) {
	                  if (handlers[hi].func === callback) {
	                    handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
	                    bindings[name] = handlers;
	                  }
	                }
	              }
	              if (!handlers.length) {
	                toggleEvent(name, false);
	                delete bindings[name];
	              }
	            }
	          }
	        } else {
	          for (name in bindings) {
	            toggleEvent(name, false);
	          }
	          bindings = {};
	        }
	        return self;
	      };
	      var once = function (name, callback, prepend) {
	        return on(name, callback, prepend, { once: true });
	      };
	      var has = function (name) {
	        name = name.toLowerCase();
	        return !(!bindings[name] || bindings[name].length === 0);
	      };
	      self.fire = fire;
	      self.on = on;
	      self.off = off;
	      self.once = once;
	      self.has = has;
	    };
	    Dispatcher.isNative = function (name) {
	      return !!nativeEvents[name.toLowerCase()];
	    };
	
	    var getEventDispatcher = function (obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new Dispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (Dispatcher.isNative(name) && obj.toggleNativeEvent) {
	              obj.toggleNativeEvent(name, state);
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    };
	    var Observable = {
	      fire: function (name, args, bubble) {
	        var self = this;
	        if (self.removed && name !== 'remove' && name !== 'detach') {
	          return args;
	        }
	        args = getEventDispatcher(self).fire(name, args, bubble);
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	        return args;
	      },
	      on: function (name, callback, prepend) {
	        return getEventDispatcher(this).on(name, callback, prepend);
	      },
	      off: function (name, callback) {
	        return getEventDispatcher(this).off(name, callback);
	      },
	      once: function (name, callback) {
	        return getEventDispatcher(this).once(name, callback);
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      }
	    };
	
	    var firePreProcess = function (editor, args) {
	      return editor.fire('PreProcess', args);
	    };
	    var firePostProcess = function (editor, args) {
	      return editor.fire('PostProcess', args);
	    };
	    var fireRemove = function (editor) {
	      return editor.fire('remove');
	    };
	    var fireDetach = function (editor) {
	      return editor.fire('detach');
	    };
	    var fireSwitchMode = function (editor, mode) {
	      return editor.fire('SwitchMode', { mode: mode });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height
	      });
	    };
	    var Events = {
	      firePreProcess: firePreProcess,
	      firePostProcess: firePostProcess,
	      fireRemove: fireRemove,
	      fireDetach: fireDetach,
	      fireSwitchMode: fireSwitchMode,
	      fireObjectResizeStart: fireObjectResizeStart,
	      fireObjectResized: fireObjectResized
	    };
	
	    var setEditorCommandState = function (editor, cmd, state) {
	      try {
	        editor.getDoc().execCommand(cmd, false, state);
	      } catch (ex) {
	      }
	    };
	    var toggleClass = function (elm, cls, state) {
	      if (has$2(elm, cls) && state === false) {
	        remove$4(elm, cls);
	      } else if (state) {
	        add$2(elm, cls);
	      }
	    };
	    var toggleReadOnly = function (editor, state) {
	      toggleClass(Element.fromDom(editor.getBody()), 'mce-content-readonly', state);
	      if (state) {
	        editor.selection.controlSelection.hideResizeRect();
	        editor.readonly = true;
	        editor.getBody().contentEditable = 'false';
	      } else {
	        editor.readonly = false;
	        editor.getBody().contentEditable = 'true';
	        setEditorCommandState(editor, 'StyleWithCSS', false);
	        setEditorCommandState(editor, 'enableInlineTableEditing', false);
	        setEditorCommandState(editor, 'enableObjectResizing', false);
	        editor.focus();
	        editor.nodeChanged();
	      }
	    };
	    var setMode = function (editor, mode) {
	      if (mode === getMode(editor)) {
	        return;
	      }
	      if (editor.initialized) {
	        toggleReadOnly(editor, mode === 'readonly');
	      } else {
	        editor.on('init', function () {
	          toggleReadOnly(editor, mode === 'readonly');
	        });
	      }
	      Events.fireSwitchMode(editor, mode);
	    };
	    var getMode = function (editor) {
	      return editor.readonly ? 'readonly' : 'design';
	    };
	    var isReadOnly = function (editor) {
	      return editor.readonly === true;
	    };
	
	    var DOM$1 = DOMUtils$1.DOM;
	    var customEventRootDelegates;
	    var getEventTarget = function (editor, eventName) {
	      if (eventName === 'selectionchange') {
	        return editor.getDoc();
	      }
	      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
	        return editor.getDoc().documentElement;
	      }
	      if (editor.settings.event_root) {
	        if (!editor.eventRoot) {
	          editor.eventRoot = DOM$1.select(editor.settings.event_root)[0];
	        }
	        return editor.eventRoot;
	      }
	      return editor.getBody();
	    };
	    var isListening = function (editor) {
	      return !editor.hidden && !editor.readonly;
	    };
	    var fireEvent = function (editor, eventName, e) {
	      if (isListening(editor)) {
	        editor.fire(eventName, e);
	      } else if (isReadOnly(editor)) {
	        e.preventDefault();
	      }
	    };
	    var bindEventDelegate = function (editor, eventName) {
	      var eventRootElm, delegate;
	      if (!editor.delegates) {
	        editor.delegates = {};
	      }
	      if (editor.delegates[eventName] || editor.removed) {
	        return;
	      }
	      eventRootElm = getEventTarget(editor, eventName);
	      if (editor.settings.event_root) {
	        if (!customEventRootDelegates) {
	          customEventRootDelegates = {};
	          editor.editorManager.on('removeEditor', function () {
	            var name;
	            if (!editor.editorManager.activeEditor) {
	              if (customEventRootDelegates) {
	                for (name in customEventRootDelegates) {
	                  editor.dom.unbind(getEventTarget(editor, name));
	                }
	                customEventRootDelegates = null;
	              }
	            }
	          });
	        }
	        if (customEventRootDelegates[eventName]) {
	          return;
	        }
	        delegate = function (e) {
	          var target = e.target;
	          var editors = editor.editorManager.get();
	          var i = editors.length;
	          while (i--) {
	            var body = editors[i].getBody();
	            if (body === target || DOM$1.isChildOf(target, body)) {
	              fireEvent(editors[i], eventName, e);
	            }
	          }
	        };
	        customEventRootDelegates[eventName] = delegate;
	        DOM$1.bind(eventRootElm, eventName, delegate);
	      } else {
	        delegate = function (e) {
	          fireEvent(editor, eventName, e);
	        };
	        DOM$1.bind(eventRootElm, eventName, delegate);
	        editor.delegates[eventName] = delegate;
	      }
	    };
	    var EditorObservable = {
	      bindPendingEventDelegates: function () {
	        var self = this;
	        Tools.each(self._pendingNativeEvents, function (name) {
	          bindEventDelegate(self, name);
	        });
	      },
	      toggleNativeEvent: function (name, state) {
	        var self = this;
	        if (name === 'focus' || name === 'blur') {
	          return;
	        }
	        if (state) {
	          if (self.initialized) {
	            bindEventDelegate(self, name);
	          } else {
	            if (!self._pendingNativeEvents) {
	              self._pendingNativeEvents = [name];
	            } else {
	              self._pendingNativeEvents.push(name);
	            }
	          }
	        } else if (self.initialized) {
	          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          delete self.delegates[name];
	        }
	      },
	      unbindAllNativeEvents: function () {
	        var self = this;
	        var body = self.getBody();
	        var dom = self.dom;
	        var name;
	        if (self.delegates) {
	          for (name in self.delegates) {
	            self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          }
	          delete self.delegates;
	        }
	        if (!self.inline && body && dom) {
	          body.onload = null;
	          dom.unbind(self.getWin());
	          dom.unbind(self.getDoc());
	        }
	        if (dom) {
	          dom.unbind(body);
	          dom.unbind(self.getContainer());
	        }
	      }
	    };
	    EditorObservable = Tools.extend({}, Observable, EditorObservable);
	    var EditorObservable$1 = EditorObservable;
	
	    var sectionResult = Immutable('sections', 'settings');
	    var detection = PlatformDetection$1.detect();
	    var isTouch = detection.deviceType.isTouch();
	    var mobilePlugins = [
	      'lists',
	      'autolink',
	      'autosave'
	    ];
	    var defaultMobileSettings = { theme: 'mobile' };
	    var normalizePlugins = function (plugins) {
	      var pluginNames = isArray(plugins) ? plugins.join(' ') : plugins;
	      var trimmedPlugins = map(isString(pluginNames) ? pluginNames.split(' ') : [], trim$2);
	      return filter(trimmedPlugins, function (item) {
	        return item.length > 0;
	      });
	    };
	    var filterMobilePlugins = function (plugins) {
	      return filter(plugins, curry(contains, mobilePlugins));
	    };
	    var extractSections = function (keys, settings) {
	      var result = bifilter(settings, function (value, key) {
	        return contains(keys, key);
	      });
	      return sectionResult(result.t, result.f);
	    };
	    var getSection = function (sectionResult, name, defaults) {
	      var sections = sectionResult.sections();
	      var sectionSettings = sections.hasOwnProperty(name) ? sections[name] : {};
	      return Tools.extend({}, defaults, sectionSettings);
	    };
	    var hasSection = function (sectionResult, name) {
	      return sectionResult.sections().hasOwnProperty(name);
	    };
	    var getDefaultSettings = function (id, documentBaseUrl, editor) {
	      return {
	        id: id,
	        theme: 'modern',
	        delta_width: 0,
	        delta_height: 0,
	        popup_css: '',
	        plugins: '',
	        document_base_url: documentBaseUrl,
	        add_form_submit_trigger: true,
	        submit_patch: true,
	        add_unload_trigger: true,
	        convert_urls: true,
	        relative_urls: true,
	        remove_script_host: true,
	        object_resizing: true,
	        doctype: '<!DOCTYPE html>',
	        visual: true,
	        font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
	        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
	        forced_root_block: 'p',
	        hidden_input: true,
	        render_ui: true,
	        indentation: '40px',
	        inline_styles: true,
	        convert_fonts_to_spans: true,
	        indent: 'simple',
	        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        entity_encoding: 'named',
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        ie7_compat: true
	      };
	    };
	    var getExternalPlugins = function (overrideSettings, settings) {
	      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
	      if (overrideSettings && overrideSettings.external_plugins) {
	        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
	      } else {
	        return userDefinedExternalPlugins;
	      }
	    };
	    var combinePlugins = function (forcedPlugins, plugins) {
	      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
	    };
	    var processPlugins = function (isTouchDevice, sectionResult, defaultOverrideSettings, settings) {
	      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
	      var plugins = normalizePlugins(settings.plugins);
	      var platformPlugins = isTouchDevice && hasSection(sectionResult, 'mobile') ? filterMobilePlugins(plugins) : plugins;
	      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
	      return Tools.extend(settings, { plugins: combinedPlugins.join(' ') });
	    };
	    var isOnMobile = function (isTouchDevice, sectionResult) {
	      var isInline = sectionResult.settings().inline;
	      return isTouchDevice && hasSection(sectionResult, 'mobile') && !isInline;
	    };
	    var combineSettings = function (isTouchDevice, defaultSettings, defaultOverrideSettings, settings) {
	      var sectionResult = extractSections(['mobile'], settings);
	      var extendedSettings = Tools.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isTouchDevice, sectionResult) ? getSection(sectionResult, 'mobile', defaultMobileSettings) : {}, {
	        validate: true,
	        content_editable: sectionResult.settings().inline,
	        external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
	      });
	      return processPlugins(isTouchDevice, sectionResult, defaultOverrideSettings, extendedSettings);
	    };
	    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
	      var defaultSettings = getDefaultSettings(id, documentBaseUrl, editor);
	      return combineSettings(isTouch, defaultSettings, defaultOverrideSettings, settings);
	    };
	    var getFiltered = function (predicate, editor, name) {
	      return Option.from(editor.settings[name]).filter(predicate);
	    };
	    var getParamObject = function (value) {
	      var output = {};
	      if (typeof value === 'string') {
	        each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
	          var arr = val.split('=');
	          if (arr.length > 1) {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[1]);
	          } else {
	            output[Tools.trim(arr[0])] = Tools.trim(arr);
	          }
	        });
	      } else {
	        output = value;
	      }
	      return output;
	    };
	    var isArrayOf = function (p) {
	      return function (a) {
	        return isArray(a) && forall(a, p);
	      };
	    };
	    var getParam = function (editor, name, defaultVal, type) {
	      var value = name in editor.settings ? editor.settings[name] : defaultVal;
	      if (type === 'hash') {
	        return getParamObject(value);
	      } else if (type === 'string') {
	        return getFiltered(isString, editor, name).getOr(defaultVal);
	      } else if (type === 'number') {
	        return getFiltered(isNumber, editor, name).getOr(defaultVal);
	      } else if (type === 'boolean') {
	        return getFiltered(isBoolean, editor, name).getOr(defaultVal);
	      } else if (type === 'object') {
	        return getFiltered(isObject, editor, name).getOr(defaultVal);
	      } else if (type === 'array') {
	        return getFiltered(isArray, editor, name).getOr(defaultVal);
	      } else if (type === 'string[]') {
	        return getFiltered(isArrayOf(isString), editor, name).getOr(defaultVal);
	      } else if (type === 'function') {
	        return getFiltered(isFunction, editor, name).getOr(defaultVal);
	      } else {
	        return value;
	      }
	    };
	
	    var each$b = Tools.each, explode$2 = Tools.explode;
	    var keyCodeLookup = {
	      f1: 112,
	      f2: 113,
	      f3: 114,
	      f4: 115,
	      f5: 116,
	      f6: 117,
	      f7: 118,
	      f8: 119,
	      f9: 120,
	      f10: 121,
	      f11: 122,
	      f12: 123
	    };
	    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	    function Shortcuts (editor) {
	      var self = this;
	      var shortcuts = {};
	      var pendingPatterns = [];
	      var parseShortcut = function (pattern) {
	        var id, key;
	        var shortcut = {};
	        each$b(explode$2(pattern, '+'), function (value) {
	          if (value in modifierNames) {
	            shortcut[value] = true;
	          } else {
	            if (/^[0-9]{2,}$/.test(value)) {
	              shortcut.keyCode = parseInt(value, 10);
	            } else {
	              shortcut.charCode = value.charCodeAt(0);
	              shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
	            }
	          }
	        });
	        id = [shortcut.keyCode];
	        for (key in modifierNames) {
	          if (shortcut[key]) {
	            id.push(key);
	          } else {
	            shortcut[key] = false;
	          }
	        }
	        shortcut.id = id.join(',');
	        if (shortcut.access) {
	          shortcut.alt = true;
	          if (Env.mac) {
	            shortcut.ctrl = true;
	          } else {
	            shortcut.shift = true;
	          }
	        }
	        if (shortcut.meta) {
	          if (Env.mac) {
	            shortcut.meta = true;
	          } else {
	            shortcut.ctrl = true;
	            shortcut.meta = false;
	          }
	        }
	        return shortcut;
	      };
	      var createShortcut = function (pattern, desc, cmdFunc, scope) {
	        var shortcuts;
	        shortcuts = Tools.map(explode$2(pattern, '>'), parseShortcut);
	        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
	          func: cmdFunc,
	          scope: scope || editor
	        });
	        return Tools.extend(shortcuts[0], {
	          desc: editor.translate(desc),
	          subpatterns: shortcuts.slice(1)
	        });
	      };
	      var hasModifier = function (e) {
	        return e.altKey || e.ctrlKey || e.metaKey;
	      };
	      var isFunctionKey = function (e) {
	        return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
	      };
	      var matchShortcut = function (e, shortcut) {
	        if (!shortcut) {
	          return false;
	        }
	        if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
	          return false;
	        }
	        if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
	          return false;
	        }
	        if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
	          e.preventDefault();
	          return true;
	        }
	        return false;
	      };
	      var executeShortcutAction = function (shortcut) {
	        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
	      };
	      editor.on('keyup keypress keydown', function (e) {
	        if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
	          each$b(shortcuts, function (shortcut) {
	            if (matchShortcut(e, shortcut)) {
	              pendingPatterns = shortcut.subpatterns.slice(0);
	              if (e.type === 'keydown') {
	                executeShortcutAction(shortcut);
	              }
	              return true;
	            }
	          });
	          if (matchShortcut(e, pendingPatterns[0])) {
	            if (pendingPatterns.length === 1) {
	              if (e.type === 'keydown') {
	                executeShortcutAction(pendingPatterns[0]);
	              }
	            }
	            pendingPatterns.shift();
	          }
	        }
	      });
	      self.add = function (pattern, desc, cmdFunc, scope) {
	        var cmd;
	        cmd = cmdFunc;
	        if (typeof cmdFunc === 'string') {
	          cmdFunc = function () {
	            editor.execCommand(cmd, false, null);
	          };
	        } else if (Tools.isArray(cmd)) {
	          cmdFunc = function () {
	            editor.execCommand(cmd[0], cmd[1], cmd[2]);
	          };
	        }
	        each$b(explode$2(Tools.trim(pattern.toLowerCase())), function (pattern) {
	          var shortcut = createShortcut(pattern, desc, cmdFunc, scope);
	          shortcuts[shortcut.id] = shortcut;
	        });
	        return true;
	      };
	      self.remove = function (pattern) {
	        var shortcut = createShortcut(pattern);
	        if (shortcuts[shortcut.id]) {
	          delete shortcuts[shortcut.id];
	          return true;
	        }
	        return false;
	      };
	    }
	
	    var hasFocus = function (element) {
	      var doc = owner(element).dom();
	      return element.dom() === doc.activeElement;
	    };
	    var active = function (_doc) {
	      var doc = _doc !== undefined ? _doc.dom() : domGlobals.document;
	      return Option.from(doc.activeElement).map(Element.fromDom);
	    };
	    var search = function (element) {
	      return active(owner(element)).filter(function (e) {
	        return element.dom().contains(e.dom());
	      });
	    };
	
	    var getContentEditableHost = function (editor, node) {
	      return editor.dom.getParent(node, function (node) {
	        return editor.dom.getContentEditable(node) === 'true';
	      });
	    };
	    var getCollapsedNode = function (rng) {
	      return rng.collapsed ? Option.from(getNode(rng.startContainer, rng.startOffset)).map(Element.fromDom) : Option.none();
	    };
	    var getFocusInElement = function (root, rng) {
	      return getCollapsedNode(rng).bind(function (node) {
	        if (isTableSection(node)) {
	          return Option.some(node);
	        } else if (contains$3(root, node) === false) {
	          return Option.some(root);
	        } else {
	          return Option.none();
	        }
	      });
	    };
	    var normalizeSelection = function (editor, rng) {
	      getFocusInElement(Element.fromDom(editor.getBody()), rng).bind(function (elm) {
	        return CaretFinder.firstPositionIn(elm.dom());
	      }).fold(function () {
	        editor.selection.normalize();
	        return;
	      }, function (caretPos) {
	        return editor.selection.setRng(caretPos.toRange());
	      });
	    };
	    var focusBody = function (body) {
	      if (body.setActive) {
	        try {
	          body.setActive();
	        } catch (ex) {
	          body.focus();
	        }
	      } else {
	        body.focus();
	      }
	    };
	    var hasElementFocus = function (elm) {
	      return hasFocus(elm) || search(elm).isSome();
	    };
	    var hasIframeFocus = function (editor) {
	      return editor.iframeElement && hasFocus(Element.fromDom(editor.iframeElement));
	    };
	    var hasInlineFocus = function (editor) {
	      var rawBody = editor.getBody();
	      return rawBody && hasElementFocus(Element.fromDom(rawBody));
	    };
	    var hasFocus$1 = function (editor) {
	      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
	    };
	    var focusEditor = function (editor) {
	      var selection = editor.selection, contentEditable = editor.settings.content_editable;
	      var body = editor.getBody();
	      var rng = selection.getRng();
	      editor.quirks.refreshContentEditable();
	      var contentEditableHost = getContentEditableHost(editor, selection.getNode());
	      if (editor.$.contains(body, contentEditableHost)) {
	        focusBody(contentEditableHost);
	        normalizeSelection(editor, rng);
	        activateEditor(editor);
	        return;
	      }
	      if (editor.bookmark !== undefined && hasFocus$1(editor) === false) {
	        SelectionBookmark.getRng(editor).each(function (bookmarkRng) {
	          editor.selection.setRng(bookmarkRng);
	          rng = bookmarkRng;
	        });
	      }
	      if (!contentEditable) {
	        if (!Env.opera) {
	          focusBody(body);
	        }
	        editor.getWin().focus();
	      }
	      if (Env.gecko || contentEditable) {
	        focusBody(body);
	        normalizeSelection(editor, rng);
	      }
	      activateEditor(editor);
	    };
	    var activateEditor = function (editor) {
	      return editor.editorManager.setActive(editor);
	    };
	    var focus = function (editor, skipFocus) {
	      if (editor.removed) {
	        return;
	      }
	      skipFocus ? activateEditor(editor) : focusEditor(editor);
	    };
	    var EditorFocus = {
	      focus: focus,
	      hasFocus: hasFocus$1
	    };
	
	    var getProp = function (propName, elm) {
	      var rawElm = elm.dom();
	      return rawElm[propName];
	    };
	    var getComputedSizeProp = function (propName, elm) {
	      return parseInt(get$1(elm, propName), 10);
	    };
	    var getClientWidth = curry(getProp, 'clientWidth');
	    var getClientHeight = curry(getProp, 'clientHeight');
	    var getMarginTop = curry(getComputedSizeProp, 'margin-top');
	    var getMarginLeft = curry(getComputedSizeProp, 'margin-left');
	    var getBoundingClientRect$1 = function (elm) {
	      return elm.dom().getBoundingClientRect();
	    };
	    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
	      var clientWidth = getClientWidth(bodyElm);
	      var clientHeight = getClientHeight(bodyElm);
	      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
	    };
	    var transpose = function (inline, elm, clientX, clientY) {
	      var clientRect = getBoundingClientRect$1(elm);
	      var deltaX = inline ? clientRect.left + elm.dom().clientLeft + getMarginLeft(elm) : 0;
	      var deltaY = inline ? clientRect.top + elm.dom().clientTop + getMarginTop(elm) : 0;
	      var x = clientX - deltaX;
	      var y = clientY - deltaY;
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var isXYInContentArea = function (editor, clientX, clientY) {
	      var bodyElm = Element.fromDom(editor.getBody());
	      var targetElm = editor.inline ? bodyElm : documentElement(bodyElm);
	      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
	      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
	    };
	    var fromDomSafe = function (node) {
	      return Option.from(node).map(Element.fromDom);
	    };
	    var isEditorAttachedToDom = function (editor) {
	      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
	      return fromDomSafe(rawContainer).map(function (container) {
	        return contains$3(owner(container), container);
	      }).getOr(false);
	    };
	    var EditorView = {
	      isXYInContentArea: isXYInContentArea,
	      isEditorAttachedToDom: isEditorAttachedToDom
	    };
	
	    function NotificationManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a NotificationManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        close: unimplemented,
	        reposition: unimplemented,
	        getArgs: unimplemented
	      };
	    }
	
	    function NotificationManager (editor) {
	      var notifications = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
	      };
	      var getTopNotification = function () {
	        return Option.from(notifications[0]);
	      };
	      var isEqual = function (a, b) {
	        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
	      };
	      var reposition = function () {
	        if (notifications.length > 0) {
	          getImplementation().reposition(notifications);
	        }
	      };
	      var addNotification = function (notification) {
	        notifications.push(notification);
	      };
	      var closeNotification = function (notification) {
	        findIndex(notifications, function (otherNotification) {
	          return otherNotification === notification;
	        }).each(function (index) {
	          notifications.splice(index, 1);
	        });
	      };
	      var open = function (args) {
	        if (editor.removed || !EditorView.isEditorAttachedToDom(editor)) {
	          return;
	        }
	        return find(notifications, function (notification) {
	          return isEqual(getImplementation().getArgs(notification), args);
	        }).getOrThunk(function () {
	          editor.editorManager.setActive(editor);
	          var notification = getImplementation().open(args, function () {
	            closeNotification(notification);
	            reposition();
	          });
	          addNotification(notification);
	          reposition();
	          return notification;
	        });
	      };
	      var close = function () {
	        getTopNotification().each(function (notification) {
	          getImplementation().close(notification);
	          closeNotification(notification);
	          reposition();
	        });
	      };
	      var getNotifications = function () {
	        return notifications;
	      };
	      var registerEvents = function (editor) {
	        editor.on('SkinLoaded', function () {
	          var serviceMessage = editor.settings.service_message;
	          if (serviceMessage) {
	            open({
	              text: serviceMessage,
	              type: 'warning',
	              timeout: 0,
	              icon: ''
	            });
	          }
	        });
	        editor.on('ResizeEditor ResizeWindow', function () {
	          Delay.requestAnimationFrame(reposition);
	        });
	        editor.on('remove', function () {
	          each(notifications.slice(), function (notification) {
	            getImplementation().close(notification);
	          });
	        });
	      };
	      registerEvents(editor);
	      return {
	        open: open,
	        close: close,
	        getNotifications: getNotifications
	      };
	    }
	
	    function WindowManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a WindowManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        alert: unimplemented,
	        confirm: unimplemented,
	        close: unimplemented,
	        getParams: unimplemented,
	        setParams: unimplemented
	      };
	    }
	
	    function WindowManager (editor) {
	      var windows = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
	      };
	      var funcBind = function (scope, f) {
	        return function () {
	          return f ? f.apply(scope, arguments) : undefined;
	        };
	      };
	      var fireOpenEvent = function (win) {
	        editor.fire('OpenWindow', { win: win });
	      };
	      var fireCloseEvent = function (win) {
	        editor.fire('CloseWindow', { win: win });
	      };
	      var addWindow = function (win) {
	        windows.push(win);
	        fireOpenEvent(win);
	      };
	      var closeWindow = function (win) {
	        findIndex(windows, function (otherWindow) {
	          return otherWindow === win;
	        }).each(function (index) {
	          windows.splice(index, 1);
	          fireCloseEvent(win);
	          if (windows.length === 0) {
	            editor.focus();
	          }
	        });
	      };
	      var getTopWindow = function () {
	        return Option.from(windows[windows.length - 1]);
	      };
	      var open = function (args, params) {
	        editor.editorManager.setActive(editor);
	        SelectionBookmark.store(editor);
	        var win = getImplementation().open(args, params, closeWindow);
	        addWindow(win);
	        return win;
	      };
	      var alert = function (message, callback, scope) {
	        var win = getImplementation().alert(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	      var confirm = function (message, callback, scope) {
	        var win = getImplementation().confirm(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	      var close = function () {
	        getTopWindow().each(function (win) {
	          getImplementation().close(win);
	          closeWindow(win);
	        });
	      };
	      var getParams = function () {
	        return getTopWindow().map(getImplementation().getParams).getOr(null);
	      };
	      var setParams = function (params) {
	        getTopWindow().each(function (win) {
	          getImplementation().setParams(win, params);
	        });
	      };
	      var getWindows = function () {
	        return windows;
	      };
	      editor.on('remove', function () {
	        each(windows.slice(0), function (win) {
	          getImplementation().close(win);
	        });
	      });
	      return {
	        windows: windows,
	        open: open,
	        alert: alert,
	        confirm: confirm,
	        close: close,
	        getParams: getParams,
	        setParams: setParams,
	        getWindows: getWindows
	      };
	    }
	
	    var data = {};
	    var code = 'en';
	    var I18n = {
	      setCode: function (newCode) {
	        if (newCode) {
	          code = newCode;
	          this.rtl = this.data[newCode] ? this.data[newCode]._dir === 'rtl' : false;
	        }
	      },
	      getCode: function () {
	        return code;
	      },
	      rtl: false,
	      add: function (code, items) {
	        var langData = data[code];
	        if (!langData) {
	          data[code] = langData = {};
	        }
	        for (var name in items) {
	          langData[name] = items[name];
	        }
	        this.setCode(code);
	      },
	      translate: function (text) {
	        var langData = data[code] || {};
	        var toString = function (obj) {
	          if (Tools.is(obj, 'function')) {
	            return Object.prototype.toString.call(obj);
	          }
	          return !isEmpty(obj) ? '' + obj : '';
	        };
	        var isEmpty = function (text) {
	          return text === '' || text === null || Tools.is(text, 'undefined');
	        };
	        var getLangData = function (text) {
	          text = toString(text);
	          return Tools.hasOwn(langData, text) ? toString(langData[text]) : text;
	        };
	        if (isEmpty(text)) {
	          return '';
	        }
	        if (Tools.is(text, 'object') && Tools.hasOwn(text, 'raw')) {
	          return toString(text.raw);
	        }
	        if (Tools.is(text, 'array')) {
	          var values_1 = text.slice(1);
	          text = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
	            return Tools.hasOwn(values_1, $2) ? toString(values_1[$2]) : $1;
	          });
	        }
	        return getLangData(text).replace(/{context:\w+}$/, '');
	      },
	      data: data
	    };
	
	    var PluginManager = AddOnManager.PluginManager;
	    var resolvePluginName = function (targetUrl, suffix) {
	      for (var name in PluginManager.urls) {
	        var matchUrl = PluginManager.urls[name] + '/plugin' + suffix + '.js';
	        if (matchUrl === targetUrl) {
	          return name;
	        }
	      }
	      return null;
	    };
	    var pluginUrlToMessage = function (editor, url) {
	      var plugin = resolvePluginName(url, editor.suffix);
	      return plugin ? I18n.translate([
	        'Failed to load plugin: {0} from url {1}',
	        plugin,
	        url
	      ]) : I18n.translate([
	        'Failed to load plugin url: {0}',
	        url
	      ]);
	    };
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        type: 'error',
	        text: message
	      });
	    };
	    var displayError = function (editor, message) {
	      if (editor._skinLoaded) {
	        displayNotification(editor, message);
	      } else {
	        editor.on('SkinLoaded', function () {
	          displayNotification(editor, message);
	        });
	      }
	    };
	    var uploadError = function (editor, message) {
	      displayError(editor, I18n.translate([
	        'Failed to upload image: {0}',
	        message
	      ]));
	    };
	    var pluginLoadError = function (editor, url) {
	      displayError(editor, pluginUrlToMessage(editor, url));
	    };
	    var pluginInitError = function (editor, name, err) {
	      var message = I18n.translate([
	        'Failed to initialize plugin: {0}',
	        name
	      ]);
	      initError(message, err);
	      displayError(editor, message);
	    };
	    var initError = function (message) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var console = domGlobals.window.console;
	      if (console) {
	        if (console.error) {
	          console.error.apply(console, arguments);
	        } else {
	          console.log.apply(console, arguments);
	        }
	      }
	    };
	    var ErrorReporter = {
	      pluginLoadError: pluginLoadError,
	      pluginInitError: pluginInitError,
	      uploadError: uploadError,
	      displayError: displayError,
	      initError: initError
	    };
	
	    var PluginManager$1 = AddOnManager.PluginManager;
	
	    var ThemeManager = AddOnManager.ThemeManager;
	
	    function XMLHttpRequest () {
	      var f = Global$1.getOrDie('XMLHttpRequest');
	      return new f();
	    }
	
	    function Uploader (uploadStatus, settings) {
	      var pendingPromises = {};
	      var pathJoin = function (path1, path2) {
	        if (path1) {
	          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	        }
	        return path2;
	      };
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr, formData;
	        xhr = XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          var json;
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        formData = new domGlobals.FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var noUpload = function () {
	        return new promiseObj(function (resolve) {
	          resolve([]);
	        });
	      };
	      var handlerSuccess = function (blobInfo, url) {
	        return {
	          url: url,
	          blobInfo: blobInfo,
	          status: true
	        };
	      };
	      var handlerFailure = function (blobInfo, error) {
	        return {
	          url: '',
	          blobInfo: blobInfo,
	          status: false,
	          error: error
	        };
	      };
	      var resolvePending = function (blobUri, result) {
	        Tools.each(pendingPromises[blobUri], function (resolve) {
	          resolve(result);
	        });
	        delete pendingPromises[blobUri];
	      };
	      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
	        uploadStatus.markPending(blobInfo.blobUri());
	        return new promiseObj(function (resolve) {
	          var notification, progress;
	          var noop = function () {
	          };
	          try {
	            var closeNotification_1 = function () {
	              if (notification) {
	                notification.close();
	                progress = noop;
	              }
	            };
	            var success = function (url) {
	              closeNotification_1();
	              uploadStatus.markUploaded(blobInfo.blobUri(), url);
	              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
	              resolve(handlerSuccess(blobInfo, url));
	            };
	            var failure = function (error) {
	              closeNotification_1();
	              uploadStatus.removeFailed(blobInfo.blobUri());
	              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error));
	              resolve(handlerFailure(blobInfo, error));
	            };
	            progress = function (percent) {
	              if (percent < 0 || percent > 100) {
	                return;
	              }
	              if (!notification) {
	                notification = openNotification();
	              }
	              notification.progressBar.value(percent);
	            };
	            handler(blobInfo, success, failure, progress);
	          } catch (ex) {
	            resolve(handlerFailure(blobInfo, ex.message));
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var pendingUploadBlobInfo = function (blobInfo) {
	        var blobUri = blobInfo.blobUri();
	        return new promiseObj(function (resolve) {
	          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
	          pendingPromises[blobUri].push(resolve);
	        });
	      };
	      var uploadBlobs = function (blobInfos, openNotification) {
	        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
	          return !uploadStatus.isUploaded(blobInfo.blobUri());
	        });
	        return promiseObj.all(Tools.map(blobInfos, function (blobInfo) {
	          return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
	        }));
	      };
	      var upload = function (blobInfos, openNotification) {
	        return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
	      };
	      if (isFunction(settings.handler) === false) {
	        settings.handler = defaultHandler;
	      }
	      return { upload: upload };
	    }
	
	    function FileReader () {
	      var f = Global$1.getOrDie('FileReader');
	      return new f();
	    }
	
	    function Uint8Array (arr) {
	      var f = Global$1.getOrDie('Uint8Array');
	      return new f(arr);
	    }
	
	    var requestAnimationFrame$1 = function (callback) {
	      var f = Global$1.getOrDie('requestAnimationFrame');
	      f(callback);
	    };
	    var atob = function (base64) {
	      var f = Global$1.getOrDie('atob');
	      return f(base64);
	    };
	    var Window = {
	      atob: atob,
	      requestAnimationFrame: requestAnimationFrame$1
	    };
	
	    var blobUriToBlob = function (url) {
	      return new promiseObj(function (resolve, reject) {
	        var rejectWithError = function () {
	          reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
	        };
	        try {
	          var xhr = XMLHttpRequest();
	          xhr.open('GET', url, true);
	          xhr.responseType = 'blob';
	          xhr.onload = function () {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              rejectWithError();
	            }
	          };
	          xhr.onerror = rejectWithError;
	          xhr.send();
	        } catch (ex) {
	          rejectWithError();
	        }
	      });
	    };
	    var parseDataUri = function (uri) {
	      var type, matches;
	      var uriParts = decodeURIComponent(uri).split(',');
	      matches = /data:([^;]+)/.exec(uriParts[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uriParts[1]
	      };
	    };
	    var dataUriToBlob = function (uri) {
	      return new promiseObj(function (resolve) {
	        var str, arr, i;
	        var uriParts = parseDataUri(uri);
	        try {
	          str = Window.atob(uriParts.data);
	        } catch (e) {
	          resolve(new domGlobals.Blob([]));
	          return;
	        }
	        arr = Uint8Array(str.length);
	        for (i = 0; i < arr.length; i++) {
	          arr[i] = str.charCodeAt(i);
	        }
	        resolve(new domGlobals.Blob([arr], { type: uriParts.type }));
	      });
	    };
	    var uriToBlob = function (url) {
	      if (url.indexOf('blob:') === 0) {
	        return blobUriToBlob(url);
	      }
	      if (url.indexOf('data:') === 0) {
	        return dataUriToBlob(url);
	      }
	      return null;
	    };
	    var blobToDataUri = function (blob) {
	      return new promiseObj(function (resolve) {
	        var reader = FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var Conversions = {
	      uriToBlob: uriToBlob,
	      blobToDataUri: blobToDataUri,
	      parseDataUri: parseDataUri
	    };
	
	    var count = 0;
	    var uniqueId = function (prefix) {
	      return (prefix || 'blobid') + count++;
	    };
	    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
	      var base64, blobInfo;
	      if (img.src.indexOf('blob:') === 0) {
	        blobInfo = blobCache.getByUri(img.src);
	        if (blobInfo) {
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        } else {
	          Conversions.uriToBlob(img.src).then(function (blob) {
	            Conversions.blobToDataUri(blob).then(function (dataUri) {
	              base64 = Conversions.parseDataUri(dataUri).data;
	              blobInfo = blobCache.create(uniqueId(), blob, base64);
	              blobCache.add(blobInfo);
	              resolve({
	                image: img,
	                blobInfo: blobInfo
	              });
	            });
	          }, function (err) {
	            reject(err);
	          });
	        }
	        return;
	      }
	      base64 = Conversions.parseDataUri(img.src).data;
	      blobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	        return cachedBlobInfo.base64() === base64;
	      });
	      if (blobInfo) {
	        resolve({
	          image: img,
	          blobInfo: blobInfo
	        });
	      } else {
	        Conversions.uriToBlob(img.src).then(function (blob) {
	          blobInfo = blobCache.create(uniqueId(), blob, base64);
	          blobCache.add(blobInfo);
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }
	    };
	    var getAllImages = function (elm) {
	      return elm ? from$1(elm.getElementsByTagName('img')) : [];
	    };
	    function ImageScanner (uploadStatus, blobCache) {
	      var cachedPromises = {};
	      var findAll = function (elm, predicate) {
	        var images;
	        if (!predicate) {
	          predicate = constant(true);
	        }
	        images = filter(getAllImages(elm), function (img) {
	          var src = img.src;
	          if (!Env.fileApi) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-bogus')) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-placeholder')) {
	            return false;
	          }
	          if (!src || src === Env.transparentSrc) {
	            return false;
	          }
	          if (src.indexOf('blob:') === 0) {
	            return !uploadStatus.isUploaded(src) && predicate(img);
	          }
	          if (src.indexOf('data:') === 0) {
	            return predicate(img);
	          }
	          return false;
	        });
	        var promises = map(images, function (img) {
	          if (cachedPromises[img.src]) {
	            return new promiseObj(function (resolve) {
	              cachedPromises[img.src].then(function (imageInfo) {
	                if (typeof imageInfo === 'string') {
	                  return imageInfo;
	                }
	                resolve({
	                  image: img,
	                  blobInfo: imageInfo.blobInfo
	                });
	              });
	            });
	          }
	          var newPromise = new promiseObj(function (resolve, reject) {
	            imageToBlobInfo(blobCache, img, resolve, reject);
	          }).then(function (result) {
	            delete cachedPromises[result.image.src];
	            return result;
	          }).catch(function (error) {
	            delete cachedPromises[img.src];
	            return error;
	          });
	          cachedPromises[img.src] = newPromise;
	          return newPromise;
	        });
	        return promiseObj.all(promises);
	      };
	      return { findAll: findAll };
	    }
	
	    var count$1 = 0;
	    var seed = function () {
	      var rnd = function () {
	        return Math.round(Math.random() * 4294967295).toString(36);
	      };
	      var now = new Date().getTime();
	      return 's' + now.toString(36) + rnd() + rnd() + rnd();
	    };
	    var uuid = function (prefix) {
	      return prefix + count$1++ + seed();
	    };
	    var Uuid = { uuid: uuid };
	
	    function BlobCache () {
	      var cache = [];
	      var mimeToExt = function (mime) {
	        var mimes = {
	          'image/jpeg': 'jpg',
	          'image/jpg': 'jpg',
	          'image/gif': 'gif',
	          'image/png': 'png'
	        };
	        return mimes[mime.toLowerCase()] || 'dat';
	      };
	      var create = function (o, blob, base64, filename) {
	        if (isString(o)) {
	          var id = o;
	          return toBlobInfo({
	            id: id,
	            name: filename,
	            blob: blob,
	            base64: base64
	          });
	        } else if (isObject(o)) {
	          return toBlobInfo(o);
	        } else {
	          throw new Error('Unknown input type');
	        }
	      };
	      var toBlobInfo = function (o) {
	        var id, name;
	        if (!o.blob || !o.base64) {
	          throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
	        }
	        id = o.id || Uuid.uuid('blobid');
	        name = o.name || id;
	        return {
	          id: constant(id),
	          name: constant(name),
	          filename: constant(name + '.' + mimeToExt(o.blob.type)),
	          blob: constant(o.blob),
	          base64: constant(o.base64),
	          blobUri: constant(o.blobUri || URL.createObjectURL(o.blob)),
	          uri: constant(o.uri)
	        };
	      };
	      var add = function (blobInfo) {
	        if (!get(blobInfo.id())) {
	          cache.push(blobInfo);
	        }
	      };
	      var get = function (id) {
	        return findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.id() === id;
	        });
	      };
	      var findFirst = function (predicate) {
	        return filter(cache, predicate)[0];
	      };
	      var getByUri = function (blobUri) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.blobUri() === blobUri;
	        });
	      };
	      var removeByUri = function (blobUri) {
	        cache = filter(cache, function (blobInfo) {
	          if (blobInfo.blobUri() === blobUri) {
	            URL.revokeObjectURL(blobInfo.blobUri());
	            return false;
	          }
	          return true;
	        });
	      };
	      var destroy = function () {
	        each(cache, function (cachedBlobInfo) {
	          URL.revokeObjectURL(cachedBlobInfo.blobUri());
	        });
	        cache = [];
	      };
	      return {
	        create: create,
	        add: add,
	        get: get,
	        getByUri: getByUri,
	        findFirst: findFirst,
	        removeByUri: removeByUri,
	        destroy: destroy
	      };
	    }
	
	    function UploadStatus () {
	      var PENDING = 1, UPLOADED = 2;
	      var blobUriStatuses = {};
	      var createStatus = function (status, resultUri) {
	        return {
	          status: status,
	          resultUri: resultUri
	        };
	      };
	      var hasBlobUri = function (blobUri) {
	        return blobUri in blobUriStatuses;
	      };
	      var getResultUri = function (blobUri) {
	        var result = blobUriStatuses[blobUri];
	        return result ? result.resultUri : null;
	      };
	      var isPending = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
	      };
	      var isUploaded = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
	      };
	      var markPending = function (blobUri) {
	        blobUriStatuses[blobUri] = createStatus(PENDING, null);
	      };
	      var markUploaded = function (blobUri, resultUri) {
	        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
	      };
	      var removeFailed = function (blobUri) {
	        delete blobUriStatuses[blobUri];
	      };
	      var destroy = function () {
	        blobUriStatuses = {};
	      };
	      return {
	        hasBlobUri: hasBlobUri,
	        getResultUri: getResultUri,
	        isPending: isPending,
	        isUploaded: isUploaded,
	        markPending: markPending,
	        markUploaded: markUploaded,
	        removeFailed: removeFailed,
	        destroy: destroy
	      };
	    }
	
	    function EditorUpload (editor) {
	      var blobCache = BlobCache();
	      var uploader, imageScanner;
	      var uploadStatus = UploadStatus();
	      var urlFilters = [];
	      var aliveGuard = function (callback) {
	        return function (result) {
	          if (editor.selection) {
	            return callback(result);
	          }
	          return [];
	        };
	      };
	      var cacheInvalidator = function () {
	        return '?' + new Date().getTime();
	      };
	      var replaceString = function (content, search, replace) {
	        var index = 0;
	        do {
	          index = content.indexOf(search, index);
	          if (index !== -1) {
	            content = content.substring(0, index) + replace + content.substr(index + search.length);
	            index += replace.length - search.length + 1;
	          }
	        } while (index !== -1);
	        return content;
	      };
	      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
	        content = replaceString(content, 'src="' + targetUrl + '"', 'src="' + replacementUrl + '"');
	        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	        return content;
	      };
	      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
	        each(editor.undoManager.data, function (level) {
	          if (level.type === 'fragmented') {
	            level.fragments = map(level.fragments, function (fragment) {
	              return replaceImageUrl(fragment, targetUrl, replacementUrl);
	            });
	          } else {
	            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
	          }
	        });
	      };
	      var openNotification = function () {
	        return editor.notificationManager.open({
	          text: editor.translate('Image uploading...'),
	          type: 'info',
	          timeout: -1,
	          progressBar: true
	        });
	      };
	      var replaceImageUri = function (image, resultUri) {
	        blobCache.removeByUri(image.src);
	        replaceUrlInUndoStack(image.src, resultUri);
	        editor.$(image).attr({
	          'src': Settings.shouldReuseFileName(editor) ? resultUri + cacheInvalidator() : resultUri,
	          'data-mce-src': editor.convertURL(resultUri, 'src')
	        });
	      };
	      var uploadImages = function (callback) {
	        if (!uploader) {
	          uploader = Uploader(uploadStatus, {
	            url: Settings.getImageUploadUrl(editor),
	            basePath: Settings.getImageUploadBasePath(editor),
	            credentials: Settings.getImagesUploadCredentials(editor),
	            handler: Settings.getImagesUploadHandler(editor)
	          });
	        }
	        return scanForImages().then(aliveGuard(function (imageInfos) {
	          var blobInfos;
	          blobInfos = map(imageInfos, function (imageInfo) {
	            return imageInfo.blobInfo;
	          });
	          return uploader.upload(blobInfos, openNotification).then(aliveGuard(function (result) {
	            var filteredResult = map(result, function (uploadInfo, index) {
	              var image = imageInfos[index].image;
	              if (uploadInfo.status && Settings.shouldReplaceBlobUris(editor)) {
	                replaceImageUri(image, uploadInfo.url);
	              } else if (uploadInfo.error) {
	                ErrorReporter.uploadError(editor, uploadInfo.error);
	              }
	              return {
	                element: image,
	                status: uploadInfo.status
	              };
	            });
	            if (callback) {
	              callback(filteredResult);
	            }
	            return filteredResult;
	          }));
	        }));
	      };
	      var uploadImagesAuto = function (callback) {
	        if (Settings.isAutomaticUploadsEnabled(editor)) {
	          return uploadImages(callback);
	        }
	      };
	      var isValidDataUriImage = function (imgElm) {
	        if (forall(urlFilters, function (filter) {
	            return filter(imgElm);
	          }) === false) {
	          return false;
	        }
	        if (imgElm.getAttribute('src').indexOf('data:') === 0) {
	          var dataImgFilter = Settings.getImagesDataImgFilter(editor);
	          return dataImgFilter(imgElm);
	        }
	        return true;
	      };
	      var addFilter = function (filter) {
	        urlFilters.push(filter);
	      };
	      var scanForImages = function () {
	        if (!imageScanner) {
	          imageScanner = ImageScanner(uploadStatus, blobCache);
	        }
	        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
	          result = filter(result, function (resultItem) {
	            if (typeof resultItem === 'string') {
	              ErrorReporter.displayError(editor, resultItem);
	              return false;
	            }
	            return true;
	          });
	          each(result, function (resultItem) {
	            replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
	            resultItem.image.src = resultItem.blobInfo.blobUri();
	            resultItem.image.removeAttribute('data-mce-src');
	          });
	          return result;
	        }));
	      };
	      var destroy = function () {
	        blobCache.destroy();
	        uploadStatus.destroy();
	        imageScanner = uploader = null;
	      };
	      var replaceBlobUris = function (content) {
	        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
	          var resultUri = uploadStatus.getResultUri(blobUri);
	          if (resultUri) {
	            return 'src="' + resultUri + '"';
	          }
	          var blobInfo = blobCache.getByUri(blobUri);
	          if (!blobInfo) {
	            blobInfo = foldl(editor.editorManager.get(), function (result, editor) {
	              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
	            }, null);
	          }
	          if (blobInfo) {
	            var blob = blobInfo.blob();
	            return 'src="data:' + blob.type + ';base64,' + blobInfo.base64() + '"';
	          }
	          return match;
	        });
	      };
	      editor.on('setContent', function () {
	        if (Settings.isAutomaticUploadsEnabled(editor)) {
	          uploadImagesAuto();
	        } else {
	          scanForImages();
	        }
	      });
	      editor.on('RawSaveContent', function (e) {
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('getContent', function (e) {
	        if (e.source_view || e.format === 'raw') {
	          return;
	        }
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('PostRender', function () {
	        editor.parser.addNodeFilter('img', function (images) {
	          each(images, function (img) {
	            var src = img.attr('src');
	            if (blobCache.getByUri(src)) {
	              return;
	            }
	            var resultUri = uploadStatus.getResultUri(src);
	            if (resultUri) {
	              img.attr('src', resultUri);
	            }
	          });
	        });
	      });
	      return {
	        blobCache: blobCache,
	        addFilter: addFilter,
	        uploadImages: uploadImages,
	        uploadImagesAuto: uploadImagesAuto,
	        scanForImages: scanForImages,
	        destroy: destroy
	      };
	    }
	
	    var isBlockElement = function (blockElements, node) {
	      return blockElements.hasOwnProperty(node.nodeName);
	    };
	    var isValidTarget = function (blockElements, node) {
	      if (NodeType.isText(node)) {
	        return true;
	      } else if (NodeType.isElement(node)) {
	        return !isBlockElement(blockElements, node) && !Bookmarks.isBookmarkNode(node);
	      } else {
	        return false;
	      }
	    };
	    var hasBlockParent = function (blockElements, root, node) {
	      return exists(Parents.parents(Element.fromDom(node), Element.fromDom(root)), function (elm) {
	        return isBlockElement(blockElements, elm.dom());
	      });
	    };
	    var shouldRemoveTextNode = function (blockElements, node) {
	      if (NodeType.isText(node)) {
	        if (node.nodeValue.length === 0) {
	          return true;
	        } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var addRootBlocks = function (editor) {
	      var settings = editor.settings, dom = editor.dom, selection = editor.selection;
	      var schema = editor.schema, blockElements = schema.getBlockElements();
	      var node = selection.getStart();
	      var rootNode = editor.getBody();
	      var rng;
	      var startContainer, startOffset, endContainer, endOffset, rootBlockNode;
	      var tempNode, wrapped, restoreSelection;
	      var rootNodeName, forcedRootBlock;
	      forcedRootBlock = settings.forced_root_block;
	      if (!node || !NodeType.isElement(node) || !forcedRootBlock) {
	        return;
	      }
	      rootNodeName = rootNode.nodeName.toLowerCase();
	      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
	        return;
	      }
	      rng = selection.getRng();
	      startContainer = rng.startContainer;
	      startOffset = rng.startOffset;
	      endContainer = rng.endContainer;
	      endOffset = rng.endOffset;
	      restoreSelection = EditorFocus.hasFocus(editor);
	      node = rootNode.firstChild;
	      while (node) {
	        if (isValidTarget(blockElements, node)) {
	          if (shouldRemoveTextNode(blockElements, node)) {
	            tempNode = node;
	            node = node.nextSibling;
	            dom.remove(tempNode);
	            continue;
	          }
	          if (!rootBlockNode) {
	            rootBlockNode = dom.create(forcedRootBlock, editor.settings.forced_root_block_attrs);
	            node.parentNode.insertBefore(rootBlockNode, node);
	            wrapped = true;
	          }
	          tempNode = node;
	          node = node.nextSibling;
	          rootBlockNode.appendChild(tempNode);
	        } else {
	          rootBlockNode = null;
	          node = node.nextSibling;
	        }
	      }
	      if (wrapped && restoreSelection) {
	        rng.setStart(startContainer, startOffset);
	        rng.setEnd(endContainer, endOffset);
	        selection.setRng(rng);
	        editor.nodeChanged();
	      }
	    };
	    var setup$3 = function (editor) {
	      if (editor.settings.forced_root_block) {
	        editor.on('NodeChange', curry(addRootBlocks, editor));
	      }
	    };
	    var ForceBlocks = { setup: setup$3 };
	
	    var getStartNode = function (rng) {
	      var sc = rng.startContainer, so = rng.startOffset;
	      if (NodeType.isText(sc)) {
	        return so === 0 ? Option.some(Element.fromDom(sc)) : Option.none();
	      } else {
	        return Option.from(sc.childNodes[so]).map(Element.fromDom);
	      }
	    };
	    var getEndNode = function (rng) {
	      var ec = rng.endContainer, eo = rng.endOffset;
	      if (NodeType.isText(ec)) {
	        return eo === ec.data.length ? Option.some(Element.fromDom(ec)) : Option.none();
	      } else {
	        return Option.from(ec.childNodes[eo - 1]).map(Element.fromDom);
	      }
	    };
	    var getFirstChildren = function (node) {
	      return firstChild(node).fold(constant([node]), function (child) {
	        return [node].concat(getFirstChildren(child));
	      });
	    };
	    var getLastChildren$1 = function (node) {
	      return lastChild(node).fold(constant([node]), function (child) {
	        if (name(child) === 'br') {
	          return prevSibling(child).map(function (sibling) {
	            return [node].concat(getLastChildren$1(sibling));
	          }).getOr([]);
	        } else {
	          return [node].concat(getLastChildren$1(child));
	        }
	      });
	    };
	    var hasAllContentsSelected = function (elm, rng) {
	      return lift2(getStartNode(rng), getEndNode(rng), function (startNode, endNode) {
	        var start = find(getFirstChildren(elm), curry(eq, startNode));
	        var end = find(getLastChildren$1(elm), curry(eq, endNode));
	        return start.isSome() && end.isSome();
	      }).getOr(false);
	    };
	    var moveEndPoint$1 = function (dom, rng, node, start) {
	      var root = node, walker = new TreeWalker(node, root);
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      do {
	        if (node.nodeType === 3 && Tools.trim(node.nodeValue).length !== 0) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, node.nodeValue.length);
	          }
	          return;
	        }
	        if (nonEmptyElementsMap[node.nodeName] && !/^(TD|TH)$/.test(node.nodeName)) {
	          if (start) {
	            rng.setStartBefore(node);
	          } else {
	            if (node.nodeName === 'BR') {
	              rng.setEndBefore(node);
	            } else {
	              rng.setEndAfter(node);
	            }
	          }
	          return;
	        }
	        if (Env.ie && Env.ie < 11 && dom.isBlock(node) && dom.isEmpty(node)) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, 0);
	          }
	          return;
	        }
	      } while (node = start ? walker.next() : walker.prev());
	      if (root.nodeName === 'BODY') {
	        if (start) {
	          rng.setStart(root, 0);
	        } else {
	          rng.setEnd(root, root.childNodes.length);
	        }
	      }
	    };
	    var hasAnyRanges = function (editor) {
	      var sel = editor.selection.getSel();
	      return sel && sel.rangeCount > 0;
	    };
	
	    function NodeChange (editor) {
	      var lastRng, lastPath = [];
	      var isSameElementPath = function (startElm) {
	        var i, currentPath;
	        currentPath = editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);
	        if (currentPath.length === lastPath.length) {
	          for (i = currentPath.length; i >= 0; i--) {
	            if (currentPath[i] !== lastPath[i]) {
	              break;
	            }
	          }
	          if (i === -1) {
	            lastPath = currentPath;
	            return true;
	          }
	        }
	        lastPath = currentPath;
	        return false;
	      };
	      if (!('onselectionchange' in editor.getDoc())) {
	        editor.on('NodeChange Click MouseUp KeyUp Focus', function (e) {
	          var nativeRng, fakeRng;
	          nativeRng = editor.selection.getRng();
	          fakeRng = {
	            startContainer: nativeRng.startContainer,
	            startOffset: nativeRng.startOffset,
	            endContainer: nativeRng.endContainer,
	            endOffset: nativeRng.endOffset
	          };
	          if (e.type === 'nodechange' || !RangeCompare.isEq(fakeRng, lastRng)) {
	            editor.fire('SelectionChange');
	          }
	          lastRng = fakeRng;
	        });
	      }
	      editor.on('contextmenu', function () {
	        editor.fire('SelectionChange');
	      });
	      editor.on('SelectionChange', function () {
	        var startElm = editor.selection.getStart(true);
	        if (!startElm || !Env.range && editor.selection.isCollapsed()) {
	          return;
	        }
	        if (hasAnyRanges(editor) && !isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
	          editor.nodeChanged({ selectionChange: true });
	        }
	      });
	      editor.on('MouseUp', function (e) {
	        if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
	          if (editor.selection.getNode().nodeName === 'IMG') {
	            Delay.setEditorTimeout(editor, function () {
	              editor.nodeChanged();
	            });
	          } else {
	            editor.nodeChanged();
	          }
	        }
	      });
	      this.nodeChanged = function (args) {
	        var selection = editor.selection;
	        var node, parents, root;
	        if (editor.initialized && selection && !editor.settings.disable_nodechange && !editor.readonly) {
	          root = editor.getBody();
	          node = selection.getStart(true) || root;
	          if (node.ownerDocument !== editor.getDoc() || !editor.dom.isChildOf(node, root)) {
	            node = root;
	          }
	          parents = [];
	          editor.dom.getParent(node, function (node) {
	            if (node === root) {
	              return true;
	            }
	            parents.push(node);
	          });
	          args = args || {};
	          args.element = node;
	          args.parents = parents;
	          editor.fire('NodeChange', args);
	        }
	      };
	    }
	
	    var VK = {
	      BACKSPACE: 8,
	      DELETE: 46,
	      DOWN: 40,
	      ENTER: 13,
	      LEFT: 37,
	      RIGHT: 39,
	      SPACEBAR: 32,
	      TAB: 9,
	      UP: 38,
	      END: 35,
	      HOME: 36,
	      modifierPressed: function (e) {
	        return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e);
	      },
	      metaKeyPressed: function (e) {
	        return Env.mac ? e.metaKey : e.ctrlKey && !e.altKey;
	      }
	    };
	
	    var getNodeClientRects = function (node) {
	      var toArrayWithNode = function (clientRects) {
	        return map(clientRects, function (clientRect) {
	          clientRect = clone$1(clientRect);
	          clientRect.node = node;
	          return clientRect;
	        });
	      };
	      if (NodeType.isElement(node)) {
	        return toArrayWithNode(node.getClientRects());
	      }
	      if (NodeType.isText(node)) {
	        var rng = node.ownerDocument.createRange();
	        rng.setStart(node, 0);
	        rng.setEnd(node, node.data.length);
	        return toArrayWithNode(rng.getClientRects());
	      }
	    };
	    var getClientRects = function (node) {
	      return foldl(node, function (result, node) {
	        return result.concat(getNodeClientRects(node));
	      }, []);
	    };
	
	    var VDirection;
	    (function (VDirection) {
	      VDirection[VDirection['Up'] = -1] = 'Up';
	      VDirection[VDirection['Down'] = 1] = 'Down';
	    }(VDirection || (VDirection = {})));
	    var findUntil = function (direction, root, predicateFn, node) {
	      while (node = findNode(node, direction, isEditableCaretCandidate, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var walkUntil = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
	      var line = 0, node;
	      var result = [];
	      var targetClientRect;
	      var add = function (node) {
	        var i, clientRect, clientRects;
	        clientRects = getClientRects([node]);
	        if (direction === -1) {
	          clientRects = clientRects.reverse();
	        }
	        for (i = 0; i < clientRects.length; i++) {
	          clientRect = clientRects[i];
	          if (isBeflowFn(clientRect, targetClientRect)) {
	            continue;
	          }
	          if (result.length > 0 && isAboveFn(clientRect, ArrUtils.last(result))) {
	            line++;
	          }
	          clientRect.line = line;
	          if (predicateFn(clientRect)) {
	            return true;
	          }
	          result.push(clientRect);
	        }
	      };
	      targetClientRect = ArrUtils.last(caretPosition.getClientRects());
	      if (!targetClientRect) {
	        return result;
	      }
	      node = caretPosition.getNode();
	      add(node);
	      findUntil(direction, root, add, node);
	      return result;
	    };
	    var aboveLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line > lineNumber;
	    };
	    var isLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line === lineNumber;
	    };
	    var upUntil = curry(walkUntil, VDirection.Up, isAbove, isBelow);
	    var downUntil = curry(walkUntil, VDirection.Down, isBelow, isAbove);
	    var positionsUntil = function (direction, root, predicateFn, node) {
	      var caretWalker = CaretWalker(root);
	      var walkFn, isBelowFn, isAboveFn, caretPosition;
	      var result = [];
	      var line = 0, clientRect, targetClientRect;
	      var getClientRect = function (caretPosition) {
	        if (direction === 1) {
	          return ArrUtils.last(caretPosition.getClientRects());
	        }
	        return ArrUtils.last(caretPosition.getClientRects());
	      };
	      if (direction === 1) {
	        walkFn = caretWalker.next;
	        isBelowFn = isBelow;
	        isAboveFn = isAbove;
	        caretPosition = CaretPosition$1.after(node);
	      } else {
	        walkFn = caretWalker.prev;
	        isBelowFn = isAbove;
	        isAboveFn = isBelow;
	        caretPosition = CaretPosition$1.before(node);
	      }
	      targetClientRect = getClientRect(caretPosition);
	      do {
	        if (!caretPosition.isVisible()) {
	          continue;
	        }
	        clientRect = getClientRect(caretPosition);
	        if (isAboveFn(clientRect, targetClientRect)) {
	          continue;
	        }
	        if (result.length > 0 && isBelowFn(clientRect, ArrUtils.last(result))) {
	          line++;
	        }
	        clientRect = clone$1(clientRect);
	        clientRect.position = caretPosition;
	        clientRect.line = line;
	        if (predicateFn(clientRect)) {
	          return result;
	        }
	        result.push(clientRect);
	      } while (caretPosition = walkFn(caretPosition));
	      return result;
	    };
	    var isAboveLine = function (lineNumber) {
	      return function (clientRect) {
	        return aboveLineNumber(lineNumber, clientRect);
	      };
	    };
	    var isLine = function (lineNumber) {
	      return function (clientRect) {
	        return isLineNumber(lineNumber, clientRect);
	      };
	    };
	
	    var isContentEditableFalse$7 = NodeType.isContentEditableFalse;
	    var findNode$1 = findNode;
	    var distanceToRectLeft = function (clientRect, clientX) {
	      return Math.abs(clientRect.left - clientX);
	    };
	    var distanceToRectRight = function (clientRect, clientX) {
	      return Math.abs(clientRect.right - clientX);
	    };
	    var isInside = function (clientX, clientRect) {
	      return clientX >= clientRect.left && clientX <= clientRect.right;
	    };
	    var findClosestClientRect = function (clientRects, clientX) {
	      return ArrUtils.reduce(clientRects, function (oldClientRect, clientRect) {
	        var oldDistance, newDistance;
	        oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
	        newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	        if (isInside(clientX, clientRect)) {
	          return clientRect;
	        }
	        if (isInside(clientX, oldClientRect)) {
	          return oldClientRect;
	        }
	        if (newDistance === oldDistance && isContentEditableFalse$7(clientRect.node)) {
	          return clientRect;
	        }
	        if (newDistance < oldDistance) {
	          return clientRect;
	        }
	        return oldClientRect;
	      });
	    };
	    var walkUntil$1 = function (direction, root, predicateFn, node) {
	      while (node = findNode$1(node, direction, isEditableCaretCandidate, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var findLineNodeRects = function (root, targetNodeRect) {
	      var clientRects = [];
	      var collect = function (checkPosFn, node) {
	        var lineRects;
	        lineRects = filter(getClientRects([node]), function (clientRect) {
	          return !checkPosFn(clientRect, targetNodeRect);
	        });
	        clientRects = clientRects.concat(lineRects);
	        return lineRects.length === 0;
	      };
	      clientRects.push(targetNodeRect);
	      walkUntil$1(VDirection.Up, root, curry(collect, isAbove), targetNodeRect.node);
	      walkUntil$1(VDirection.Down, root, curry(collect, isBelow), targetNodeRect.node);
	      return clientRects;
	    };
	    var getFakeCaretTargets = function (root) {
	      return filter(from$1(root.getElementsByTagName('*')), isFakeCaretTarget);
	    };
	    var caretInfo = function (clientRect, clientX) {
	      return {
	        node: clientRect.node,
	        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
	      };
	    };
	    var closestCaret = function (root, clientX, clientY) {
	      var closestNodeRect;
	      var contentEditableFalseNodeRects = getClientRects(getFakeCaretTargets(root));
	      var targetNodeRects = filter(contentEditableFalseNodeRects, function (rect) {
	        return clientY >= rect.top && clientY <= rect.bottom;
	      });
	      closestNodeRect = findClosestClientRect(targetNodeRects, clientX);
	      if (closestNodeRect) {
	        closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect), clientX);
	        if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
	          return caretInfo(closestNodeRect, clientX);
	        }
	      }
	      return null;
	    };
	
	    var isXYWithinRange = function (clientX, clientY, range) {
	      if (range.collapsed) {
	        return false;
	      }
	      if (Env.ie && Env.ie <= 11 && range.startOffset === range.endOffset - 1 && range.startContainer === range.endContainer) {
	        var elm = range.startContainer.childNodes[range.startOffset];
	        if (NodeType.isElement(elm)) {
	          return exists(elm.getClientRects(), function (rect) {
	            return containsXY(rect, clientX, clientY);
	          });
	        }
	      }
	      return exists(range.getClientRects(), function (rect) {
	        return containsXY(rect, clientX, clientY);
	      });
	    };
	    var RangePoint = { isXYWithinRange: isXYWithinRange };
	
	    var getAbsolutePosition = function (elm) {
	      var doc, docElem, win, clientRect;
	      clientRect = elm.getBoundingClientRect();
	      doc = elm.ownerDocument;
	      docElem = doc.documentElement;
	      win = doc.defaultView;
	      return {
	        top: clientRect.top + win.pageYOffset - docElem.clientTop,
	        left: clientRect.left + win.pageXOffset - docElem.clientLeft
	      };
	    };
	    var getBodyPosition = function (editor) {
	      return editor.inline ? getAbsolutePosition(editor.getBody()) : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getScrollPosition = function (editor) {
	      var body = editor.getBody();
	      return editor.inline ? {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      } : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getBodyScroll = function (editor) {
	      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
	      var inlineScroll = {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      };
	      var iframeScroll = {
	        left: body.scrollLeft || docElm.scrollLeft,
	        top: body.scrollTop || docElm.scrollTop
	      };
	      return editor.inline ? inlineScroll : iframeScroll;
	    };
	    var getMousePosition = function (editor, event) {
	      if (event.target.ownerDocument !== editor.getDoc()) {
	        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
	        var scrollPosition = getBodyScroll(editor);
	        return {
	          left: event.pageX - iframePosition.left + scrollPosition.left,
	          top: event.pageY - iframePosition.top + scrollPosition.top
	        };
	      }
	      return {
	        left: event.pageX,
	        top: event.pageY
	      };
	    };
	    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
	      return {
	        pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
	        pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
	      };
	    };
	    var calc = function (editor, event) {
	      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
	    };
	    var MousePosition = { calc: calc };
	
	    var isContentEditableFalse$8 = NodeType.isContentEditableFalse, isContentEditableTrue$3 = NodeType.isContentEditableTrue;
	    var isDraggable = function (rootElm, elm) {
	      return isContentEditableFalse$8(elm) && elm !== rootElm;
	    };
	    var isValidDropTarget = function (editor, targetElement, dragElement) {
	      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
	        return false;
	      }
	      if (isContentEditableFalse$8(targetElement)) {
	        return false;
	      }
	      return true;
	    };
	    var cloneElement = function (elm) {
	      var cloneElm = elm.cloneNode(true);
	      cloneElm.removeAttribute('data-mce-selected');
	      return cloneElm;
	    };
	    var createGhost = function (editor, elm, width, height) {
	      var clonedElm = elm.cloneNode(true);
	      editor.dom.setStyles(clonedElm, {
	        width: width,
	        height: height
	      });
	      editor.dom.setAttrib(clonedElm, 'data-mce-selected', null);
	      var ghostElm = editor.dom.create('div', {
	        'class': 'mce-drag-container',
	        'data-mce-bogus': 'all',
	        'unselectable': 'on',
	        'contenteditable': 'false'
	      });
	      editor.dom.setStyles(ghostElm, {
	        position: 'absolute',
	        opacity: 0.5,
	        overflow: 'hidden',
	        border: 0,
	        padding: 0,
	        margin: 0,
	        width: width,
	        height: height
	      });
	      editor.dom.setStyles(clonedElm, {
	        margin: 0,
	        boxSizing: 'border-box'
	      });
	      ghostElm.appendChild(clonedElm);
	      return ghostElm;
	    };
	    var appendGhostToBody = function (ghostElm, bodyElm) {
	      if (ghostElm.parentNode !== bodyElm) {
	        bodyElm.appendChild(ghostElm);
	      }
	    };
	    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
	      var overflowX = 0, overflowY = 0;
	      ghostElm.style.left = position.pageX + 'px';
	      ghostElm.style.top = position.pageY + 'px';
	      if (position.pageX + width > maxX) {
	        overflowX = position.pageX + width - maxX;
	      }
	      if (position.pageY + height > maxY) {
	        overflowY = position.pageY + height - maxY;
	      }
	      ghostElm.style.width = width - overflowX + 'px';
	      ghostElm.style.height = height - overflowY + 'px';
	    };
	    var removeElement = function (elm) {
	      if (elm && elm.parentNode) {
	        elm.parentNode.removeChild(elm);
	      }
	    };
	    var isLeftMouseButtonPressed = function (e) {
	      return e.button === 0;
	    };
	    var hasDraggableElement = function (state) {
	      return state.element;
	    };
	    var applyRelPos = function (state, position) {
	      return {
	        pageX: position.pageX - state.relX,
	        pageY: position.pageY + 5
	      };
	    };
	    var start$1 = function (state, editor) {
	      return function (e) {
	        if (isLeftMouseButtonPressed(e)) {
	          var ceElm = find(editor.dom.getParents(e.target), Predicate.or(isContentEditableFalse$8, isContentEditableTrue$3)).getOr(null);
	          if (isDraggable(editor.getBody(), ceElm)) {
	            var elmPos = editor.dom.getPos(ceElm);
	            var bodyElm = editor.getBody();
	            var docElm = editor.getDoc().documentElement;
	            state.element = ceElm;
	            state.screenX = e.screenX;
	            state.screenY = e.screenY;
	            state.maxX = (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2;
	            state.maxY = (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2;
	            state.relX = e.pageX - elmPos.x;
	            state.relY = e.pageY - elmPos.y;
	            state.width = ceElm.offsetWidth;
	            state.height = ceElm.offsetHeight;
	            state.ghost = createGhost(editor, ceElm, state.width, state.height);
	          }
	        }
	      };
	    };
	    var move$1 = function (state, editor) {
	      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
	        editor._selectionOverrides.hideFakeCaret();
	        editor.selection.placeCaretAt(clientX, clientY);
	      }, 0);
	      return function (e) {
	        var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	        if (hasDraggableElement(state) && !state.dragging && movement > 10) {
	          var args = editor.fire('dragstart', { target: state.element });
	          if (args.isDefaultPrevented()) {
	            return;
	          }
	          state.dragging = true;
	          editor.focus();
	        }
	        if (state.dragging) {
	          var targetPos = applyRelPos(state, MousePosition.calc(editor, e));
	          appendGhostToBody(state.ghost, editor.getBody());
	          moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	          throttledPlaceCaretAt(e.clientX, e.clientY);
	        }
	      };
	    };
	    var getRawTarget = function (selection) {
	      var rng = selection.getSel().getRangeAt(0);
	      var startContainer = rng.startContainer;
	      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
	    };
	    var drop = function (state, editor) {
	      return function (e) {
	        if (state.dragging) {
	          if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
	            var targetClone_1 = cloneElement(state.element);
	            var args = editor.fire('drop', {
	              targetClone: targetClone_1,
	              clientX: e.clientX,
	              clientY: e.clientY
	            });
	            if (!args.isDefaultPrevented()) {
	              targetClone_1 = args.targetClone;
	              editor.undoManager.transact(function () {
	                removeElement(state.element);
	                editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
	                editor._selectionOverrides.hideFakeCaret();
	              });
	            }
	          }
	        }
	        removeDragState(state);
	      };
	    };
	    var stop = function (state, editor) {
	      return function () {
	        if (state.dragging) {
	          editor.fire('dragend');
	        }
	        removeDragState(state);
	      };
	    };
	    var removeDragState = function (state) {
	      state.dragging = false;
	      state.element = null;
	      removeElement(state.ghost);
	    };
	    var bindFakeDragEvents = function (editor) {
	      var state = {};
	      var pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
	      pageDom = DOMUtils$1.DOM;
	      rootDocument = domGlobals.document;
	      dragStartHandler = start$1(state, editor);
	      dragHandler = move$1(state, editor);
	      dropHandler = drop(state, editor);
	      dragEndHandler = stop(state, editor);
	      editor.on('mousedown', dragStartHandler);
	      editor.on('mousemove', dragHandler);
	      editor.on('mouseup', dropHandler);
	      pageDom.bind(rootDocument, 'mousemove', dragHandler);
	      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	      editor.on('remove', function () {
	        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
	        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
	      });
	    };
	    var blockIeDrop = function (editor) {
	      editor.on('drop', function (e) {
	        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	        if (isContentEditableFalse$8(realTarget) || isContentEditableFalse$8(editor.dom.getContentEditableParent(realTarget))) {
	          e.preventDefault();
	        }
	      });
	    };
	    var init = function (editor) {
	      bindFakeDragEvents(editor);
	      blockIeDrop(editor);
	    };
	    var DragDropOverrides = { init: init };
	
	    var setup$4 = function (editor) {
	      var renderFocusCaret = first(function () {
	        if (!editor.removed) {
	          var rng = editor.selection.getRng();
	          if (rng.collapsed) {
	            var caretRange = renderRangeCaret(editor, editor.selection.getRng(), false);
	            editor.selection.setRng(caretRange);
	          }
	        }
	      }, 0);
	      editor.on('focus', function () {
	        renderFocusCaret.throttle();
	      });
	      editor.on('blur', function () {
	        renderFocusCaret.cancel();
	      });
	    };
	    var CefFocus = { setup: setup$4 };
	
	    var isContentEditableTrue$4 = NodeType.isContentEditableTrue;
	    var isContentEditableFalse$9 = NodeType.isContentEditableFalse;
	    var getContentEditableRoot$1 = function (editor, node) {
	      var root = editor.getBody();
	      while (node && node !== root) {
	        if (isContentEditableTrue$4(node) || isContentEditableFalse$9(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var SelectionOverrides = function (editor) {
	      var isBlock = function (node) {
	        return editor.dom.isBlock(node);
	      };
	      var rootNode = editor.getBody();
	      var fakeCaret = FakeCaret(editor.getBody(), isBlock, function () {
	        return EditorFocus.hasFocus(editor);
	      });
	      var realSelectionId = 'sel-' + editor.dom.uniqueId();
	      var selectedContentEditableNode;
	      var isFakeSelectionElement = function (elm) {
	        return editor.dom.hasClass(elm, 'mce-offscreen-selection');
	      };
	      var getRealSelectionElement = function () {
	        var container = editor.dom.get(realSelectionId);
	        return container ? container.getElementsByTagName('*')[0] : container;
	      };
	      var setRange = function (range) {
	        if (range) {
	          editor.selection.setRng(range);
	        }
	      };
	      var getRange = function () {
	        return editor.selection.getRng();
	      };
	      var showCaret = function (direction, node, before, scrollIntoView) {
	        if (scrollIntoView === void 0) {
	          scrollIntoView = true;
	        }
	        var e;
	        e = editor.fire('ShowCaret', {
	          target: node,
	          direction: direction,
	          before: before
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        if (scrollIntoView) {
	          editor.selection.scrollIntoView(node, direction === -1);
	        }
	        return fakeCaret.show(before, node);
	      };
	      var getNormalizedRangeEndPoint = function (direction, range) {
	        range = normalizeRange(direction, rootNode, range);
	        if (direction === -1) {
	          return CaretPosition$1.fromRangeStart(range);
	        }
	        return CaretPosition$1.fromRangeEnd(range);
	      };
	      var showBlockCaretContainer = function (blockCaretContainer) {
	        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	          showCaretContainerBlock(blockCaretContainer);
	          setRange(getRange());
	          editor.selection.scrollIntoView(blockCaretContainer[0]);
	        }
	      };
	      var registerEvents = function () {
	        editor.on('mouseup', function (e) {
	          var range = getRange();
	          if (range.collapsed && EditorView.isXYInContentArea(editor, e.clientX, e.clientY)) {
	            setRange(renderCaretAtRange(editor, range, false));
	          }
	        });
	        editor.on('click', function (e) {
	          var contentEditableRoot;
	          contentEditableRoot = getContentEditableRoot$1(editor, e.target);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              e.preventDefault();
	              editor.focus();
	            }
	            if (isContentEditableTrue$4(contentEditableRoot)) {
	              if (editor.dom.isChildOf(contentEditableRoot, editor.selection.getNode())) {
	                removeContentEditableSelection();
	              }
	            }
	          }
	        });
	        editor.on('blur NewBlock', function () {
	          removeContentEditableSelection();
	        });
	        editor.on('ResizeWindow FullscreenStateChanged', function () {
	          return fakeCaret.reposition();
	        });
	        var handleTouchSelect = function (editor) {
	          var moved = false;
	          editor.on('touchstart', function () {
	            moved = false;
	          });
	          editor.on('touchmove', function () {
	            moved = true;
	          });
	          editor.on('touchend', function (e) {
	            var contentEditableRoot = getContentEditableRoot$1(editor, e.target);
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              if (!moved) {
	                e.preventDefault();
	                setContentEditableSelection(selectNode(editor, contentEditableRoot));
	              }
	            }
	          });
	        };
	        var hasNormalCaretPosition = function (elm) {
	          var caretWalker = CaretWalker(elm);
	          if (!elm.firstChild) {
	            return false;
	          }
	          var startPos = CaretPosition$1.before(elm.firstChild);
	          var newPos = caretWalker.next(startPos);
	          return newPos && !isBeforeContentEditableFalse(newPos) && !isAfterContentEditableFalse(newPos);
	        };
	        var isInSameBlock = function (node1, node2) {
	          var block1 = editor.dom.getParent(node1, editor.dom.isBlock);
	          var block2 = editor.dom.getParent(node2, editor.dom.isBlock);
	          return block1 === block2;
	        };
	        var hasBetterMouseTarget = function (targetNode, caretNode) {
	          var targetBlock = editor.dom.getParent(targetNode, editor.dom.isBlock);
	          var caretBlock = editor.dom.getParent(caretNode, editor.dom.isBlock);
	          if (targetBlock && editor.dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse$9(getContentEditableRoot$1(editor, targetBlock)) === false) {
	            return true;
	          }
	          return targetBlock && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
	        };
	        handleTouchSelect(editor);
	        editor.on('mousedown', function (e) {
	          var contentEditableRoot;
	          var targetElm = e.target;
	          if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !editor.dom.isChildOf(targetElm, rootNode)) {
	            return;
	          }
	          if (EditorView.isXYInContentArea(editor, e.clientX, e.clientY) === false) {
	            return;
	          }
	          contentEditableRoot = getContentEditableRoot$1(editor, targetElm);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$9(contentEditableRoot)) {
	              e.preventDefault();
	              setContentEditableSelection(selectNode(editor, contentEditableRoot));
	            } else {
	              removeContentEditableSelection();
	              if (!(isContentEditableTrue$4(contentEditableRoot) && e.shiftKey) && !RangePoint.isXYWithinRange(e.clientX, e.clientY, editor.selection.getRng())) {
	                hideFakeCaret();
	                editor.selection.placeCaretAt(e.clientX, e.clientY);
	              }
	            }
	          } else if (isFakeCaretTarget(targetElm) === false) {
	            removeContentEditableSelection();
	            hideFakeCaret();
	            var caretInfo = closestCaret(rootNode, e.clientX, e.clientY);
	            if (caretInfo) {
	              if (!hasBetterMouseTarget(e.target, caretInfo.node)) {
	                e.preventDefault();
	                var range = showCaret(1, caretInfo.node, caretInfo.before, false);
	                editor.getBody().focus();
	                setRange(range);
	              }
	            }
	          }
	        });
	        editor.on('keypress', function (e) {
	          if (VK.modifierPressed(e)) {
	            return;
	          }
	          switch (e.keyCode) {
	          default:
	            if (isContentEditableFalse$9(editor.selection.getNode())) {
	              e.preventDefault();
	            }
	            break;
	          }
	        });
	        editor.on('getSelectionRange', function (e) {
	          var rng = e.range;
	          if (selectedContentEditableNode) {
	            if (!selectedContentEditableNode.parentNode) {
	              selectedContentEditableNode = null;
	              return;
	            }
	            rng = rng.cloneRange();
	            rng.selectNode(selectedContentEditableNode);
	            e.range = rng;
	          }
	        });
	        editor.on('setSelectionRange', function (e) {
	          e.range = normalizeShortEndedElementSelection(e.range);
	          var rng = setContentEditableSelection(e.range, e.forward);
	          if (rng) {
	            e.range = rng;
	          }
	        });
	        var isPasteBin = function (node) {
	          return node.id === 'mcepastebin';
	        };
	        editor.on('AfterSetSelectionRange', function (e) {
	          var rng = e.range;
	          if (!isRangeInCaretContainer(rng) && !isPasteBin(rng.startContainer.parentNode)) {
	            hideFakeCaret();
	          }
	          if (!isFakeSelectionElement(rng.startContainer.parentNode)) {
	            removeContentEditableSelection();
	          }
	        });
	        editor.on('copy', function (e) {
	          var clipboardData = e.clipboardData;
	          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
	            var realSelectionElement = getRealSelectionElement();
	            if (realSelectionElement) {
	              e.preventDefault();
	              clipboardData.clearData();
	              clipboardData.setData('text/html', realSelectionElement.outerHTML);
	              clipboardData.setData('text/plain', realSelectionElement.outerText);
	            }
	          }
	        });
	        DragDropOverrides.init(editor);
	        CefFocus.setup(editor);
	      };
	      var addCss = function () {
	        var styles = editor.contentStyles, rootClass = '.mce-content-body';
	        styles.push(fakeCaret.getCss());
	        styles.push(rootClass + ' .mce-offscreen-selection {' + 'position: absolute;' + 'left: -9999999999px;' + 'max-width: 1000000px;' + '}' + rootClass + ' *[contentEditable=false] {' + 'cursor: default;' + '}' + rootClass + ' *[contentEditable=true] {' + 'cursor: text;' + '}');
	      };
	      var isWithinCaretContainer = function (node) {
	        return isCaretContainer(node) || startsWithCaretContainer(node) || endsWithCaretContainer(node);
	      };
	      var isRangeInCaretContainer = function (rng) {
	        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
	      };
	      var normalizeShortEndedElementSelection = function (rng) {
	        var shortEndedElements = editor.schema.getShortEndedElements();
	        var newRng = editor.dom.createRng();
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        if (has(shortEndedElements, startContainer.nodeName.toLowerCase())) {
	          if (startOffset === 0) {
	            newRng.setStartBefore(startContainer);
	          } else {
	            newRng.setStartAfter(startContainer);
	          }
	        } else {
	          newRng.setStart(startContainer, startOffset);
	        }
	        if (has(shortEndedElements, endContainer.nodeName.toLowerCase())) {
	          if (endOffset === 0) {
	            newRng.setEndBefore(endContainer);
	          } else {
	            newRng.setEndAfter(endContainer);
	          }
	        } else {
	          newRng.setEnd(endContainer, endOffset);
	        }
	        return newRng;
	      };
	      var setContentEditableSelection = function (range, forward) {
	        var node;
	        var $ = editor.$;
	        var dom = editor.dom;
	        var $realSelectionContainer, sel, startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
	        if (!range) {
	          return null;
	        }
	        if (range.collapsed) {
	          if (!isRangeInCaretContainer(range)) {
	            if (forward === false) {
	              caretPosition = getNormalizedRangeEndPoint(-1, range);
	              if (isFakeCaretTarget(caretPosition.getNode(true))) {
	                return showCaret(-1, caretPosition.getNode(true), false, false);
	              }
	              if (isFakeCaretTarget(caretPosition.getNode())) {
	                return showCaret(-1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
	              }
	            } else {
	              caretPosition = getNormalizedRangeEndPoint(1, range);
	              if (isFakeCaretTarget(caretPosition.getNode())) {
	                return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
	              }
	              if (isFakeCaretTarget(caretPosition.getNode(true))) {
	                return showCaret(1, caretPosition.getNode(true), false, false);
	              }
	            }
	          }
	          return null;
	        }
	        startContainer = range.startContainer;
	        startOffset = range.startOffset;
	        endOffset = range.endOffset;
	        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse$9(startContainer.parentNode)) {
	          startContainer = startContainer.parentNode;
	          startOffset = dom.nodeIndex(startContainer);
	          startContainer = startContainer.parentNode;
	        }
	        if (startContainer.nodeType !== 1) {
	          return null;
	        }
	        if (endOffset === startOffset + 1 && startContainer === range.endContainer) {
	          node = startContainer.childNodes[startOffset];
	        }
	        if (!isContentEditableFalse$9(node)) {
	          return null;
	        }
	        targetClone = origTargetClone = node.cloneNode(true);
	        e = editor.fire('ObjectSelected', {
	          target: node,
	          targetClone: targetClone
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        $realSelectionContainer = descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
	          return $([]);
	        }, function (elm) {
	          return $([elm.dom()]);
	        });
	        targetClone = e.targetClone;
	        if ($realSelectionContainer.length === 0) {
	          $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
	          $realSelectionContainer.appendTo(editor.getBody());
	        }
	        range = editor.dom.createRng();
	        if (targetClone === origTargetClone && Env.ie) {
	          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
	          range.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
	          range.setEndAfter(targetClone);
	        } else {
	          $realSelectionContainer.empty().append('\xA0').append(targetClone).append('\xA0');
	          range.setStart($realSelectionContainer[0].firstChild, 1);
	          range.setEnd($realSelectionContainer[0].lastChild, 0);
	        }
	        $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
	        $realSelectionContainer[0].focus();
	        sel = editor.selection.getSel();
	        sel.removeAllRanges();
	        sel.addRange(range);
	        each(descendants$1(Element.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
	          remove(elm, 'data-mce-selected');
	        });
	        node.setAttribute('data-mce-selected', '1');
	        selectedContentEditableNode = node;
	        hideFakeCaret();
	        return range;
	      };
	      var removeContentEditableSelection = function () {
	        if (selectedContentEditableNode) {
	          selectedContentEditableNode.removeAttribute('data-mce-selected');
	          descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$1);
	          selectedContentEditableNode = null;
	        }
	        descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$1);
	        selectedContentEditableNode = null;
	      };
	      var destroy = function () {
	        fakeCaret.destroy();
	        selectedContentEditableNode = null;
	      };
	      var hideFakeCaret = function () {
	        fakeCaret.hide();
	      };
	      if (Env.ceFalse) {
	        registerEvents();
	        addCss();
	      }
	      return {
	        showCaret: showCaret,
	        showBlockCaretContainer: showBlockCaretContainer,
	        hideFakeCaret: hideFakeCaret,
	        destroy: destroy
	      };
	    };
	
	    var isValidPrefixAttrName = function (name) {
	      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
	    };
	    var trimComments = function (text) {
	      var sanitizedText = text;
	      while (/<!--|--!?>/g.test(sanitizedText)) {
	        sanitizedText = sanitizedText.replace(/<!--|--!?>/g, '');
	      }
	      return sanitizedText;
	    };
	    var isInvalidUri = function (settings, uri) {
	      if (settings.allow_html_data_urls) {
	        return false;
	      } else if (/^data:image\//i.test(uri)) {
	        return settings.allow_svg_data_urls === false && /^data:image\/svg\+xml/i.test(uri);
	      } else {
	        return /^data:/i.test(uri);
	      }
	    };
	    var findEndTagIndex = function (schema, html, startIndex) {
	      var count = 1, index, matches, tokenRegExp, shortEndedElements;
	      shortEndedElements = schema.getShortEndedElements();
	      tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
	      tokenRegExp.lastIndex = index = startIndex;
	      while (matches = tokenRegExp.exec(html)) {
	        index = tokenRegExp.lastIndex;
	        if (matches[1] === '/') {
	          count--;
	        } else if (!matches[1]) {
	          if (matches[2] in shortEndedElements) {
	            continue;
	          }
	          count++;
	        }
	        if (count === 0) {
	          break;
	        }
	      }
	      return index;
	    };
	    var checkBogusAttribute = function (regExp, attrString) {
	      var matches = regExp.exec(attrString);
	      if (matches) {
	        var name = matches[1];
	        var value = matches[2];
	        return typeof name === 'string' && name.toLowerCase() === 'data-mce-bogus' ? value : null;
	      } else {
	        return null;
	      }
	    };
	    function SaxParser(settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var noop = function () {
	      };
	      settings = settings || {};
	      if (settings.fix_self_closing !== false) {
	        settings.fix_self_closing = true;
	      }
	      var comment = settings.comment ? settings.comment : noop;
	      var cdata = settings.cdata ? settings.cdata : noop;
	      var text = settings.text ? settings.text : noop;
	      var start = settings.start ? settings.start : noop;
	      var end = settings.end ? settings.end : noop;
	      var pi = settings.pi ? settings.pi : noop;
	      var doctype = settings.doctype ? settings.doctype : noop;
	      var parse = function (html) {
	        var matches, index = 0, value, endRegExp;
	        var stack = [];
	        var attrList, i, textData, name;
	        var isInternalElement, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
	        var validate, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
	        var attributesRequired, attributesDefault, attributesForced, processHtml;
	        var anyAttributesRequired, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
	        var decode = Entities.decode;
	        var fixSelfClosing;
	        var filteredUrlAttrs = Tools.makeMap('src,href,data,background,formaction,poster,xlink:href');
	        var scriptUriRegExp = /((java|vb)script|mhtml):/i;
	        var processEndTag = function (name) {
	          var pos, i;
	          pos = stack.length;
	          while (pos--) {
	            if (stack[pos].name === name) {
	              break;
	            }
	          }
	          if (pos >= 0) {
	            for (i = stack.length - 1; i >= pos; i--) {
	              name = stack[i];
	              if (name.valid) {
	                end(name.name);
	              }
	            }
	            stack.length = pos;
	          }
	        };
	        var parseAttribute = function (match, name, value, val2, val3) {
	          var attrRule, i;
	          var trimRegExp = /[\s\u0000-\u001F]+/g;
	          name = name.toLowerCase();
	          value = name in fillAttrsMap ? name : decode(value || val2 || val3 || '');
	          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
	            attrRule = validAttributesMap[name];
	            if (!attrRule && validAttributePatterns) {
	              i = validAttributePatterns.length;
	              while (i--) {
	                attrRule = validAttributePatterns[i];
	                if (attrRule.pattern.test(name)) {
	                  break;
	                }
	              }
	              if (i === -1) {
	                attrRule = null;
	              }
	            }
	            if (!attrRule) {
	              return;
	            }
	            if (attrRule.validValues && !(value in attrRule.validValues)) {
	              return;
	            }
	          }
	          if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
	            var uri = value.replace(trimRegExp, '');
	            try {
	              uri = decodeURIComponent(uri);
	            } catch (ex) {
	              uri = unescape(uri);
	            }
	            if (scriptUriRegExp.test(uri)) {
	              return;
	            }
	            if (isInvalidUri(settings, uri)) {
	              return;
	            }
	          }
	          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
	            return;
	          }
	          attrList.map[name] = value;
	          attrList.push({
	            name: name,
	            value: value
	          });
	        };
	        tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)--!?>)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:!DOCTYPE([\\w\\W]*?)>)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + ')', 'g');
	        attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	        shortEndedElements = schema.getShortEndedElements();
	        selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
	        fillAttrsMap = schema.getBoolAttrs();
	        validate = settings.validate;
	        removeInternalElements = settings.remove_internals;
	        fixSelfClosing = settings.fix_self_closing;
	        specialElements = schema.getSpecialElements();
	        processHtml = html + '>';
	        while (matches = tokenRegExp.exec(processHtml)) {
	          if (index < matches.index) {
	            text(decode(html.substr(index, matches.index - index)));
	          }
	          if (value = matches[6]) {
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            processEndTag(value);
	          } else if (value = matches[7]) {
	            if (matches.index + matches[0].length > html.length) {
	              text(decode(html.substr(matches.index)));
	              index = matches.index + matches[0].length;
	              continue;
	            }
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            isShortEnded = value in shortEndedElements;
	            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
	              processEndTag(value);
	            }
	            var bogusValue = checkBogusAttribute(attrRegExp, matches[8]);
	            if (bogusValue !== null) {
	              if (bogusValue === 'all') {
	                index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                tokenRegExp.lastIndex = index;
	                continue;
	              }
	              isValidElement = false;
	            }
	            if (!validate || (elementRule = schema.getElementRule(value))) {
	              isValidElement = true;
	              if (validate) {
	                validAttributesMap = elementRule.attributes;
	                validAttributePatterns = elementRule.attributePatterns;
	              }
	              if (attribsValue = matches[8]) {
	                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
	                if (isInternalElement && removeInternalElements) {
	                  isValidElement = false;
	                }
	                attrList = [];
	                attrList.map = {};
	                attribsValue.replace(attrRegExp, parseAttribute);
	              } else {
	                attrList = [];
	                attrList.map = {};
	              }
	              if (validate && !isInternalElement) {
	                attributesRequired = elementRule.attributesRequired;
	                attributesDefault = elementRule.attributesDefault;
	                attributesForced = elementRule.attributesForced;
	                anyAttributesRequired = elementRule.removeEmptyAttrs;
	                if (anyAttributesRequired && !attrList.length) {
	                  isValidElement = false;
	                }
	                if (attributesForced) {
	                  i = attributesForced.length;
	                  while (i--) {
	                    attr = attributesForced[i];
	                    name = attr.name;
	                    attrValue = attr.value;
	                    if (attrValue === '{$uid}') {
	                      attrValue = 'mce_' + idCount++;
	                    }
	                    attrList.map[name] = attrValue;
	                    attrList.push({
	                      name: name,
	                      value: attrValue
	                    });
	                  }
	                }
	                if (attributesDefault) {
	                  i = attributesDefault.length;
	                  while (i--) {
	                    attr = attributesDefault[i];
	                    name = attr.name;
	                    if (!(name in attrList.map)) {
	                      attrValue = attr.value;
	                      if (attrValue === '{$uid}') {
	                        attrValue = 'mce_' + idCount++;
	                      }
	                      attrList.map[name] = attrValue;
	                      attrList.push({
	                        name: name,
	                        value: attrValue
	                      });
	                    }
	                  }
	                }
	                if (attributesRequired) {
	                  i = attributesRequired.length;
	                  while (i--) {
	                    if (attributesRequired[i] in attrList.map) {
	                      break;
	                    }
	                  }
	                  if (i === -1) {
	                    isValidElement = false;
	                  }
	                }
	                if (attr = attrList.map['data-mce-bogus']) {
	                  if (attr === 'all') {
	                    index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                    tokenRegExp.lastIndex = index;
	                    continue;
	                  }
	                  isValidElement = false;
	                }
	              }
	              if (isValidElement) {
	                start(value, attrList, isShortEnded);
	              }
	            } else {
	              isValidElement = false;
	            }
	            if (endRegExp = specialElements[value]) {
	              endRegExp.lastIndex = index = matches.index + matches[0].length;
	              if (matches = endRegExp.exec(html)) {
	                if (isValidElement) {
	                  textData = html.substr(index, matches.index - index);
	                }
	                index = matches.index + matches[0].length;
	              } else {
	                textData = html.substr(index);
	                index = html.length;
	              }
	              if (isValidElement) {
	                if (textData.length > 0) {
	                  text(textData, true);
	                }
	                end(value);
	              }
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	            if (!isShortEnded) {
	              if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
	                stack.push({
	                  name: value,
	                  valid: isValidElement
	                });
	              } else if (isValidElement) {
	                end(value);
	              }
	            }
	          } else if (value = matches[1]) {
	            if (value.charAt(0) === '>') {
	              value = ' ' + value;
	            }
	            if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
	              value = ' ' + value;
	            }
	            comment(value);
	          } else if (value = matches[2]) {
	            cdata(trimComments(value));
	          } else if (value = matches[3]) {
	            doctype(value);
	          } else if (value = matches[4]) {
	            pi(value, matches[5]);
	          }
	          index = matches.index + matches[0].length;
	        }
	        if (index < html.length) {
	          text(decode(html.substr(index)));
	        }
	        for (i = stack.length - 1; i >= 0; i--) {
	          value = stack[i];
	          if (value.valid) {
	            end(value.name);
	          }
	        }
	      };
	      return { parse: parse };
	    }
	    (function (SaxParser) {
	      SaxParser.findEndTag = findEndTagIndex;
	    }(SaxParser || (SaxParser = {})));
	    var SaxParser$1 = SaxParser;
	
	    var trimHtml = function (tempAttrs, html) {
	      var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
	      return html.replace(trimContentRegExp, '');
	    };
	    var trimInternal = function (serializer, html) {
	      var content = html;
	      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
	      var endTagIndex, index, matchLength, matches, shortEndedElements;
	      var schema = serializer.schema;
	      content = trimHtml(serializer.getTempAttrs(), content);
	      shortEndedElements = schema.getShortEndedElements();
	      while (matches = bogusAllRegExp.exec(content)) {
	        index = bogusAllRegExp.lastIndex;
	        matchLength = matches[0].length;
	        if (shortEndedElements[matches[1]]) {
	          endTagIndex = index;
	        } else {
	          endTagIndex = SaxParser$1.findEndTag(schema, content, index);
	        }
	        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
	        bogusAllRegExp.lastIndex = index - matchLength;
	      }
	      return Zwsp.trim(content);
	    };
	    var trimExternal = trimInternal;
	    var TrimHtml = {
	      trimExternal: trimExternal,
	      trimInternal: trimInternal
	    };
	
	    var KEEP = 0, INSERT = 1, DELETE = 2;
	    var diff = function (left, right) {
	      var size = left.length + right.length + 2;
	      var vDown = new Array(size);
	      var vUp = new Array(size);
	      var snake = function (start, end, diag) {
	        return {
	          start: start,
	          end: end,
	          diag: diag
	        };
	      };
	      var buildScript = function (start1, end1, start2, end2, script) {
	        var middle = getMiddleSnake(start1, end1, start2, end2);
	        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
	          var i = start1;
	          var j = start2;
	          while (i < end1 || j < end2) {
	            if (i < end1 && j < end2 && left[i] === right[j]) {
	              script.push([
	                KEEP,
	                left[i]
	              ]);
	              ++i;
	              ++j;
	            } else {
	              if (end1 - start1 > end2 - start2) {
	                script.push([
	                  DELETE,
	                  left[i]
	                ]);
	                ++i;
	              } else {
	                script.push([
	                  INSERT,
	                  right[j]
	                ]);
	                ++j;
	              }
	            }
	          }
	        } else {
	          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
	          for (var i2 = middle.start; i2 < middle.end; ++i2) {
	            script.push([
	              KEEP,
	              left[i2]
	            ]);
	          }
	          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
	        }
	      };
	      var buildSnake = function (start, diag, end1, end2) {
	        var end = start;
	        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
	          ++end;
	        }
	        return snake(start, end, diag);
	      };
	      var getMiddleSnake = function (start1, end1, start2, end2) {
	        var m = end1 - start1;
	        var n = end2 - start2;
	        if (m === 0 || n === 0) {
	          return null;
	        }
	        var delta = m - n;
	        var sum = n + m;
	        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
	        vDown[1 + offset] = start1;
	        vUp[1 + offset] = end1 + 1;
	        var d, k, i, x, y;
	        for (d = 0; d <= offset; ++d) {
	          for (k = -d; k <= d; k += 2) {
	            i = k + offset;
	            if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
	              vDown[i] = vDown[i + 1];
	            } else {
	              vDown[i] = vDown[i - 1] + 1;
	            }
	            x = vDown[i];
	            y = x - start1 + start2 - k;
	            while (x < end1 && y < end2 && left[x] === right[y]) {
	              vDown[i] = ++x;
	              ++y;
	            }
	            if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
	              if (vUp[i - delta] <= vDown[i]) {
	                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	          for (k = delta - d; k <= delta + d; k += 2) {
	            i = k + offset - delta;
	            if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
	              vUp[i] = vUp[i + 1] - 1;
	            } else {
	              vUp[i] = vUp[i - 1];
	            }
	            x = vUp[i] - 1;
	            y = x - start1 + start2 - k;
	            while (x >= start1 && y >= start2 && left[x] === right[y]) {
	              vUp[i] = x--;
	              y--;
	            }
	            if (delta % 2 === 0 && -d <= k && k <= d) {
	              if (vUp[i] <= vDown[i + delta]) {
	                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	        }
	      };
	      var script = [];
	      buildScript(0, left.length, 0, right.length, script);
	      return script;
	    };
	    var Diff = {
	      KEEP: KEEP,
	      DELETE: DELETE,
	      INSERT: INSERT,
	      diff: diff
	    };
	
	    var getOuterHtml = function (elm) {
	      if (NodeType.isElement(elm)) {
	        return elm.outerHTML;
	      } else if (NodeType.isText(elm)) {
	        return Entities.encodeRaw(elm.data, false);
	      } else if (NodeType.isComment(elm)) {
	        return '<!--' + elm.data + '-->';
	      }
	      return '';
	    };
	    var createFragment$1 = function (html) {
	      var frag, node, container;
	      container = domGlobals.document.createElement('div');
	      frag = domGlobals.document.createDocumentFragment();
	      if (html) {
	        container.innerHTML = html;
	      }
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var insertAt = function (elm, html, index) {
	      var fragment = createFragment$1(html);
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.insertBefore(fragment, target);
	      } else {
	        elm.appendChild(fragment);
	      }
	    };
	    var removeAt = function (elm, index) {
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.removeChild(target);
	      }
	    };
	    var applyDiff = function (diff, elm) {
	      var index = 0;
	      each(diff, function (action) {
	        if (action[0] === Diff.KEEP) {
	          index++;
	        } else if (action[0] === Diff.INSERT) {
	          insertAt(elm, action[1], index);
	          index++;
	        } else if (action[0] === Diff.DELETE) {
	          removeAt(elm, index);
	        }
	      });
	    };
	    var read$3 = function (elm) {
	      return filter(map(from$1(elm.childNodes), getOuterHtml), function (item) {
	        return item.length > 0;
	      });
	    };
	    var write = function (fragments, elm) {
	      var currentFragments = map(from$1(elm.childNodes), getOuterHtml);
	      applyDiff(Diff.diff(currentFragments, fragments), elm);
	      return elm;
	    };
	    var Fragments = {
	      read: read$3,
	      write: write
	    };
	
	    var undoLevelDocument = Cell(Option.none());
	    var lazyTempDocument = function () {
	      return undoLevelDocument.get().getOrThunk(function () {
	        var doc = domGlobals.document.implementation.createHTMLDocument('undo');
	        undoLevelDocument.set(Option.some(doc));
	        return doc;
	      });
	    };
	    var hasIframes = function (html) {
	      return html.indexOf('</iframe>') !== -1;
	    };
	    var createFragmentedLevel = function (fragments) {
	      return {
	        type: 'fragmented',
	        fragments: fragments,
	        content: '',
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createCompleteLevel = function (content) {
	      return {
	        type: 'complete',
	        fragments: null,
	        content: content,
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createFromEditor = function (editor) {
	      var fragments, content, trimmedFragments;
	      fragments = Fragments.read(editor.getBody());
	      trimmedFragments = bind(fragments, function (html) {
	        var trimmed = TrimHtml.trimInternal(editor.serializer, html);
	        return trimmed.length > 0 ? [trimmed] : [];
	      });
	      content = trimmedFragments.join('');
	      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
	    };
	    var applyToEditor = function (editor, level, before) {
	      if (level.type === 'fragmented') {
	        Fragments.write(level.fragments, editor.getBody());
	      } else {
	        editor.setContent(level.content, { format: 'raw' });
	      }
	      editor.selection.moveToBookmark(before ? level.beforeBookmark : level.bookmark);
	    };
	    var getLevelContent = function (level) {
	      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
	    };
	    var getCleanLevelContent = function (level) {
	      var elm = Element.fromTag('body', lazyTempDocument());
	      set$1(elm, getLevelContent(level));
	      each(descendants$1(elm, '*[data-mce-bogus]'), unwrap);
	      return get$3(elm);
	    };
	    var hasEqualContent = function (level1, level2) {
	      return getLevelContent(level1) === getLevelContent(level2);
	    };
	    var hasEqualCleanedContent = function (level1, level2) {
	      return getCleanLevelContent(level1) === getCleanLevelContent(level2);
	    };
	    var isEq$4 = function (level1, level2) {
	      if (!level1 || !level2) {
	        return false;
	      } else if (hasEqualContent(level1, level2)) {
	        return true;
	      } else {
	        return hasEqualCleanedContent(level1, level2);
	      }
	    };
	    var Levels = {
	      createFragmentedLevel: createFragmentedLevel,
	      createCompleteLevel: createCompleteLevel,
	      createFromEditor: createFromEditor,
	      applyToEditor: applyToEditor,
	      isEq: isEq$4
	    };
	
	    function UndoManager (editor) {
	      var self = this, index = 0, data = [], beforeBookmark, isFirstTypedCharacter, locks = 0;
	      var isUnlocked = function () {
	        return locks === 0;
	      };
	      var setTyping = function (typing) {
	        if (isUnlocked()) {
	          self.typing = typing;
	        }
	      };
	      var setDirty = function (state) {
	        editor.setDirty(state);
	      };
	      var addNonTypingUndoLevel = function (e) {
	        setTyping(false);
	        self.add({}, e);
	      };
	      var endTyping = function () {
	        if (self.typing) {
	          setTyping(false);
	          self.add();
	        }
	      };
	      editor.on('init', function () {
	        self.add();
	      });
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command;
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          endTyping();
	          self.beforeChange();
	        }
	      });
	      editor.on('ExecCommand', function (e) {
	        var cmd = e.command;
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('ObjectResizeStart Cut', function () {
	        self.beforeChange();
	      });
	      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
	      editor.on('DragEnd', addNonTypingUndoLevel);
	      editor.on('KeyUp', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
	          addNonTypingUndoLevel();
	          editor.nodeChanged();
	        }
	        if (keyCode === 46 || keyCode === 8) {
	          editor.nodeChanged();
	        }
	        if (isFirstTypedCharacter && self.typing && Levels.isEq(Levels.createFromEditor(editor), data[0]) === false) {
	          if (editor.isDirty() === false) {
	            setDirty(true);
	            editor.fire('change', {
	              level: data[0],
	              lastLevel: null
	            });
	          }
	          editor.fire('TypingUndo');
	          isFirstTypedCharacter = false;
	          editor.nodeChanged();
	        }
	      });
	      editor.on('KeyDown', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
	          if (self.typing) {
	            addNonTypingUndoLevel(e);
	          }
	          return;
	        }
	        var modKey = e.ctrlKey && !e.altKey || e.metaKey;
	        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !self.typing && !modKey) {
	          self.beforeChange();
	          setTyping(true);
	          self.add({}, e);
	          isFirstTypedCharacter = true;
	        }
	      });
	      editor.on('MouseDown', function (e) {
	        if (self.typing) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      var isInsertReplacementText = function (event) {
	        return event.inputType === 'insertReplacementText';
	      };
	      var isInsertTextDataNull = function (event) {
	        return event.inputType === 'insertText' && event.data === null;
	      };
	      editor.on('input', function (e) {
	        if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e))) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.addShortcut('meta+z', '', 'Undo');
	      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
	        if (!e.isDefaultPrevented()) {
	          editor.nodeChanged();
	        }
	      });
	      self = {
	        data: data,
	        typing: false,
	        beforeChange: function () {
	          if (isUnlocked()) {
	            beforeBookmark = GetBookmark.getUndoBookmark(editor.selection);
	          }
	        },
	        add: function (level, event) {
	          var i;
	          var settings = editor.settings;
	          var lastLevel, currentLevel;
	          currentLevel = Levels.createFromEditor(editor);
	          level = level || {};
	          level = Tools.extend(level, currentLevel);
	          if (isUnlocked() === false || editor.removed) {
	            return null;
	          }
	          lastLevel = data[index];
	          if (editor.fire('BeforeAddUndo', {
	              level: level,
	              lastLevel: lastLevel,
	              originalEvent: event
	            }).isDefaultPrevented()) {
	            return null;
	          }
	          if (lastLevel && Levels.isEq(lastLevel, level)) {
	            return null;
	          }
	          if (data[index]) {
	            data[index].beforeBookmark = beforeBookmark;
	          }
	          if (settings.custom_undo_redo_levels) {
	            if (data.length > settings.custom_undo_redo_levels) {
	              for (i = 0; i < data.length - 1; i++) {
	                data[i] = data[i + 1];
	              }
	              data.length--;
	              index = data.length;
	            }
	          }
	          level.bookmark = GetBookmark.getUndoBookmark(editor.selection);
	          if (index < data.length - 1) {
	            data.length = index + 1;
	          }
	          data.push(level);
	          index = data.length - 1;
	          var args = {
	            level: level,
	            lastLevel: lastLevel,
	            originalEvent: event
	          };
	          editor.fire('AddUndo', args);
	          if (index > 0) {
	            setDirty(true);
	            editor.fire('change', args);
	          }
	          return level;
	        },
	        undo: function () {
	          var level;
	          if (self.typing) {
	            self.add();
	            self.typing = false;
	            setTyping(false);
	          }
	          if (index > 0) {
	            level = data[--index];
	            Levels.applyToEditor(editor, level, true);
	            setDirty(true);
	            editor.fire('undo', { level: level });
	          }
	          return level;
	        },
	        redo: function () {
	          var level;
	          if (index < data.length - 1) {
	            level = data[++index];
	            Levels.applyToEditor(editor, level, false);
	            setDirty(true);
	            editor.fire('redo', { level: level });
	          }
	          return level;
	        },
	        clear: function () {
	          data = [];
	          index = 0;
	          self.typing = false;
	          self.data = data;
	          editor.fire('ClearUndos');
	        },
	        hasUndo: function () {
	          return index > 0 || self.typing && data[0] && !Levels.isEq(Levels.createFromEditor(editor), data[0]);
	        },
	        hasRedo: function () {
	          return index < data.length - 1 && !self.typing;
	        },
	        transact: function (callback) {
	          endTyping();
	          self.beforeChange();
	          self.ignore(callback);
	          return self.add();
	        },
	        ignore: function (callback) {
	          try {
	            locks++;
	            callback();
	          } finally {
	            locks--;
	          }
	        },
	        extra: function (callback1, callback2) {
	          var lastLevel, bookmark;
	          if (self.transact(callback1)) {
	            bookmark = data[index].bookmark;
	            lastLevel = data[index - 1];
	            Levels.applyToEditor(editor, lastLevel, true);
	            if (self.transact(callback2)) {
	              data[index - 1].beforeBookmark = bookmark;
	            }
	          }
	        }
	      };
	      return self;
	    }
	
	    var postProcessHooks = {}, filter$2 = ArrUtils.filter, each$c = ArrUtils.each;
	    var addPostProcessHook = function (name, hook) {
	      var hooks = postProcessHooks[name];
	      if (!hooks) {
	        postProcessHooks[name] = hooks = [];
	      }
	      postProcessHooks[name].push(hook);
	    };
	    var postProcess = function (name, editor) {
	      each$c(postProcessHooks[name], function (hook) {
	        hook(editor);
	      });
	    };
	    addPostProcessHook('pre', function (editor) {
	      var rng = editor.selection.getRng();
	      var isPre, blocks;
	      var hasPreSibling = function (pre) {
	        return isPre(pre.previousSibling) && ArrUtils.indexOf(blocks, pre.previousSibling) !== -1;
	      };
	      var joinPre = function (pre1, pre2) {
	        DomQuery(pre2).remove();
	        DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
	      };
	      isPre = NodeType.matchNodeNames('pre');
	      if (!rng.collapsed) {
	        blocks = editor.selection.getSelectedBlocks();
	        each$c(filter$2(filter$2(blocks, isPre), hasPreSibling), function (pre) {
	          joinPre(pre.previousSibling, pre);
	        });
	      }
	    });
	    var Hooks = { postProcess: postProcess };
	
	    var MCE_ATTR_RE = /^(src|href|style)$/;
	    var each$d = Tools.each;
	    var isEq$5 = FormatUtils.isEq;
	    var isTableCell$4 = function (node) {
	      return /^(TH|TD)$/.test(node.nodeName);
	    };
	    var isChildOfInlineParent = function (dom, node, parent) {
	      return dom.isChildOf(node, parent) && node !== parent && !dom.isBlock(parent);
	    };
	    var getContainer = function (ed, rng, start) {
	      var container, offset, lastIdx;
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (NodeType.isElement(container)) {
	        lastIdx = container.childNodes.length - 1;
	        if (!start && offset) {
	          offset--;
	        }
	        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
	      }
	      if (NodeType.isText(container) && start && offset >= container.nodeValue.length) {
	        container = new TreeWalker(container, ed.getBody()).next() || container;
	      }
	      if (NodeType.isText(container) && !start && offset === 0) {
	        container = new TreeWalker(container, ed.getBody()).prev() || container;
	      }
	      return container;
	    };
	    var wrap$2 = function (dom, node, name, attrs) {
	      var wrapper = dom.create(name, attrs);
	      node.parentNode.insertBefore(wrapper, node);
	      wrapper.appendChild(node);
	      return wrapper;
	    };
	    var wrapWithSiblings = function (dom, node, next, name, attrs) {
	      var start = Element.fromDom(node);
	      var wrapper = Element.fromDom(dom.create(name, attrs));
	      var siblings = next ? nextSiblings(start) : prevSiblings(start);
	      append$1(wrapper, siblings);
	      if (next) {
	        before(start, wrapper);
	        prepend(wrapper, start);
	      } else {
	        after(start, wrapper);
	        append(wrapper, start);
	      }
	      return wrapper.dom();
	    };
	    var matchName$1 = function (dom, node, format) {
	      if (isEq$5(node, format.inline)) {
	        return true;
	      }
	      if (isEq$5(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return NodeType.isElement(node) && dom.is(node, format.selector);
	      }
	    };
	    var isColorFormatAndAnchor = function (node, format) {
	      return format.links && node.tagName === 'A';
	    };
	    var find$3 = function (dom, node, next, inc) {
	      node = FormatUtils.getNonWhiteSpaceSibling(node, next, inc);
	      return !node || (node.nodeName === 'BR' || dom.isBlock(node));
	    };
	    var removeNode$1 = function (ed, node, format) {
	      var parentNode = node.parentNode;
	      var rootBlockElm;
	      var dom = ed.dom, forcedRootBlock = ed.settings.forced_root_block;
	      if (format.block) {
	        if (!forcedRootBlock) {
	          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
	            if (!find$3(dom, node, false) && !find$3(dom, node.firstChild, true, 1)) {
	              node.insertBefore(dom.create('br'), node.firstChild);
	            }
	            if (!find$3(dom, node, true) && !find$3(dom, node.lastChild, false, 1)) {
	              node.appendChild(dom.create('br'));
	            }
	          }
	        } else {
	          if (parentNode === dom.getRoot()) {
	            if (!format.list_block || !isEq$5(node, format.list_block)) {
	              each$d(Tools.grep(node.childNodes), function (node) {
	                if (FormatUtils.isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
	                  if (!rootBlockElm) {
	                    rootBlockElm = wrap$2(dom, node, forcedRootBlock);
	                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
	                  } else {
	                    rootBlockElm.appendChild(node);
	                  }
	                } else {
	                  rootBlockElm = 0;
	                }
	              });
	            }
	          }
	        }
	      }
	      if (format.selector && format.inline && !isEq$5(format.inline, node)) {
	        return;
	      }
	      dom.remove(node, 1);
	    };
	    var removeFormat = function (ed, format, vars, node, compareNode) {
	      var i, attrs, stylesModified;
	      var dom = ed.dom;
	      if (!matchName$1(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
	        return false;
	      }
	      if (format.remove !== 'all') {
	        each$d(format.styles, function (value, name) {
	          value = FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(value, vars), name);
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	          if (format.remove_similar || (!compareNode || isEq$5(FormatUtils.getStyle(dom, compareNode, name), value))) {
	            dom.setStyle(node, name, '');
	          }
	          stylesModified = 1;
	        });
	        if (stylesModified && dom.getAttrib(node, 'style') === '') {
	          node.removeAttribute('style');
	          node.removeAttribute('data-mce-style');
	        }
	        each$d(format.attributes, function (value, name) {
	          var valueOut;
	          value = FormatUtils.replaceVars(value, vars);
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	          if (!compareNode || isEq$5(dom.getAttrib(compareNode, name), value)) {
	            if (name === 'class') {
	              value = dom.getAttrib(node, name);
	              if (value) {
	                valueOut = '';
	                each$d(value.split(/\s+/), function (cls) {
	                  if (/mce\-\w+/.test(cls)) {
	                    valueOut += (valueOut ? ' ' : '') + cls;
	                  }
	                });
	                if (valueOut) {
	                  dom.setAttrib(node, name, valueOut);
	                  return;
	                }
	              }
	            }
	            if (name === 'class') {
	              node.removeAttribute('className');
	            }
	            if (MCE_ATTR_RE.test(name)) {
	              node.removeAttribute('data-mce-' + name);
	            }
	            node.removeAttribute(name);
	          }
	        });
	        each$d(format.classes, function (value) {
	          value = FormatUtils.replaceVars(value, vars);
	          if (!compareNode || dom.hasClass(compareNode, value)) {
	            dom.removeClass(node, value);
	          }
	        });
	        attrs = dom.getAttribs(node);
	        for (i = 0; i < attrs.length; i++) {
	          var attrName = attrs[i].nodeName;
	          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
	            return false;
	          }
	        }
	      }
	      if (format.remove !== 'none') {
	        removeNode$1(ed, node, format);
	        return true;
	      }
	    };
	    var findFormatRoot = function (editor, container, name, vars, similar) {
	      var formatRoot;
	      each$d(FormatUtils.getParents(editor.dom, container.parentNode).reverse(), function (parent) {
	        var format;
	        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
	          format = MatchFormat.matchNode(editor, parent, name, vars, similar);
	          if (format && format.split !== false) {
	            formatRoot = parent;
	          }
	        }
	      });
	      return formatRoot;
	    };
	    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
	      var parent, clone, lastClone, firstClone, i, formatRootParent;
	      var dom = editor.dom;
	      if (formatRoot) {
	        formatRootParent = formatRoot.parentNode;
	        for (parent = container.parentNode; parent && parent !== formatRootParent; parent = parent.parentNode) {
	          clone = dom.clone(parent, false);
	          for (i = 0; i < formatList.length; i++) {
	            if (removeFormat(editor, formatList[i], vars, clone, clone)) {
	              clone = 0;
	              break;
	            }
	          }
	          if (clone) {
	            if (lastClone) {
	              clone.appendChild(lastClone);
	            }
	            if (!firstClone) {
	              firstClone = clone;
	            }
	            lastClone = clone;
	          }
	        }
	        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
	          container = dom.split(formatRoot, container);
	        }
	        if (lastClone) {
	          target.parentNode.insertBefore(lastClone, target);
	          firstClone.appendChild(target);
	        }
	      }
	      return container;
	    };
	    var remove$6 = function (ed, name, vars, node, similar) {
	      var formatList = ed.formatter.get(name), format = formatList[0];
	      var bookmark, rng, contentEditable = true;
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var splitToFormatRoot = function (container) {
	        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
	        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
	      };
	      var isRemoveBookmarkNode = function (node) {
	        return Bookmarks.isBookmarkNode(node) && NodeType.isElement(node) && (node.id === '_start' || node.id === '_end');
	      };
	      var process = function (node) {
	        var children, i, l, lastContentEditable, hasContentEditableState;
	        if (NodeType.isElement(node) && dom.getContentEditable(node)) {
	          lastContentEditable = contentEditable;
	          contentEditable = dom.getContentEditable(node) === 'true';
	          hasContentEditableState = true;
	        }
	        children = Tools.grep(node.childNodes);
	        if (contentEditable && !hasContentEditableState) {
	          for (i = 0, l = formatList.length; i < l; i++) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        if (format.deep) {
	          if (children.length) {
	            for (i = 0, l = children.length; i < l; i++) {
	              process(children[i]);
	            }
	            if (hasContentEditableState) {
	              contentEditable = lastContentEditable;
	            }
	          }
	        }
	      };
	      var unwrap = function (start) {
	        var node = dom.get(start ? '_start' : '_end');
	        var out = node[start ? 'firstChild' : 'lastChild'];
	        if (isRemoveBookmarkNode(out)) {
	          out = out[start ? 'firstChild' : 'lastChild'];
	        }
	        if (NodeType.isText(out) && out.data.length === 0) {
	          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
	        }
	        dom.remove(node, true);
	        return out;
	      };
	      var removeRngStyle = function (rng) {
	        var startContainer, endContainer;
	        var commonAncestorContainer = rng.commonAncestorContainer;
	        rng = ExpandRange.expandRng(ed, rng, formatList, true);
	        if (format.split) {
	          rng = SplitRange.split(rng);
	          startContainer = getContainer(ed, rng, true);
	          endContainer = getContainer(ed, rng);
	          if (startContainer !== endContainer) {
	            if (/^(TR|TH|TD)$/.test(startContainer.nodeName) && startContainer.firstChild) {
	              if (startContainer.nodeName === 'TR') {
	                startContainer = startContainer.firstChild.firstChild || startContainer;
	              } else {
	                startContainer = startContainer.firstChild || startContainer;
	              }
	            }
	            if (commonAncestorContainer && /^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName) && isTableCell$4(endContainer) && endContainer.firstChild) {
	              endContainer = endContainer.firstChild || endContainer;
	            }
	            if (isChildOfInlineParent(dom, startContainer, endContainer)) {
	              var marker = Option.from(startContainer.firstChild).getOr(startContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, true, 'span', {
	                'id': '_start',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(true);
	              return;
	            }
	            if (isChildOfInlineParent(dom, endContainer, startContainer)) {
	              var marker = Option.from(endContainer.lastChild).getOr(endContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, false, 'span', {
	                'id': '_end',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(false);
	              return;
	            }
	            startContainer = wrap$2(dom, startContainer, 'span', {
	              'id': '_start',
	              'data-mce-type': 'bookmark'
	            });
	            endContainer = wrap$2(dom, endContainer, 'span', {
	              'id': '_end',
	              'data-mce-type': 'bookmark'
	            });
	            splitToFormatRoot(startContainer);
	            splitToFormatRoot(endContainer);
	            startContainer = unwrap(true);
	            endContainer = unwrap();
	          } else {
	            startContainer = endContainer = splitToFormatRoot(startContainer);
	          }
	          rng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
	          rng.startOffset = dom.nodeIndex(startContainer);
	          rng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
	          rng.endOffset = dom.nodeIndex(endContainer) + 1;
	        }
	        RangeWalk.walk(dom, rng, function (nodes) {
	          each$d(nodes, function (node) {
	            process(node);
	            if (NodeType.isElement(node) && ed.dom.getStyle(node, 'text-decoration') === 'underline' && node.parentNode && FormatUtils.getTextDecoration(dom, node.parentNode) === 'underline') {
	              removeFormat(ed, {
	                deep: false,
	                exact: true,
	                inline: 'span',
	                styles: { textDecoration: 'underline' }
	              }, null, node);
	            }
	          });
	        });
	      };
	      if (node) {
	        if (node.nodeType) {
	          rng = dom.createRng();
	          rng.setStartBefore(node);
	          rng.setEndAfter(node);
	          removeRngStyle(rng);
	        } else {
	          removeRngStyle(node);
	        }
	        return;
	      }
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        return;
	      }
	      if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	        bookmark = GetBookmark.getPersistentBookmark(ed.selection, true);
	        removeRngStyle(selection.getRng());
	        selection.moveToBookmark(bookmark);
	        if (format.inline && MatchFormat.match(ed, name, vars, selection.getStart())) {
	          FormatUtils.moveStart(dom, selection, selection.getRng());
	        }
	        ed.nodeChanged();
	      } else {
	        removeCaretFormat(ed, name, vars, similar);
	      }
	    };
	    var RemoveFormat = {
	      removeFormat: removeFormat,
	      remove: remove$6
	    };
	
	    var each$e = Tools.each;
	    var isElementNode = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !isCaretNode(node) && !NodeType.isBogus(node);
	    };
	    var findElementSibling = function (node, siblingName) {
	      var sibling;
	      for (sibling = node; sibling; sibling = sibling[siblingName]) {
	        if (sibling.nodeType === 3 && sibling.nodeValue.length !== 0) {
	          return node;
	        }
	        if (sibling.nodeType === 1 && !Bookmarks.isBookmarkNode(sibling)) {
	          return sibling;
	        }
	      }
	      return node;
	    };
	    var mergeSiblingsNodes = function (dom, prev, next) {
	      var sibling, tmpSibling;
	      var elementUtils = new ElementUtils(dom);
	      if (prev && next) {
	        prev = findElementSibling(prev, 'previousSibling');
	        next = findElementSibling(next, 'nextSibling');
	        if (elementUtils.compare(prev, next)) {
	          for (sibling = prev.nextSibling; sibling && sibling !== next;) {
	            tmpSibling = sibling;
	            sibling = sibling.nextSibling;
	            prev.appendChild(tmpSibling);
	          }
	          dom.remove(next);
	          Tools.each(Tools.grep(next.childNodes), function (node) {
	            prev.appendChild(node);
	          });
	          return prev;
	        }
	      }
	      return next;
	    };
	    var processChildElements = function (node, filter, process) {
	      each$e(node.childNodes, function (node) {
	        if (isElementNode(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	    var hasStyle = function (dom, name) {
	      return curry(function (name, node) {
	        return !!(node && FormatUtils.getStyle(dom, node, name));
	      }, name);
	    };
	    var applyStyle = function (dom, name, value) {
	      return curry(function (name, value, node) {
	        dom.setStyle(node, name, value);
	        if (node.getAttribute('style') === '') {
	          node.removeAttribute('style');
	        }
	        unwrapEmptySpan(dom, node);
	      }, name, value);
	    };
	    var unwrapEmptySpan = function (dom, node) {
	      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
	        dom.remove(node, true);
	      }
	    };
	    var processUnderlineAndColor = function (dom, node) {
	      var textDecoration;
	      if (node.nodeType === 1 && node.parentNode && node.parentNode.nodeType === 1) {
	        textDecoration = FormatUtils.getTextDecoration(dom, node.parentNode);
	        if (dom.getStyle(node, 'color') && textDecoration) {
	          dom.setStyle(node, 'text-decoration', textDecoration);
	        } else if (dom.getStyle(node, 'text-decoration') === textDecoration) {
	          dom.setStyle(node, 'text-decoration', null);
	        }
	      }
	    };
	    var mergeUnderlineAndColor = function (dom, format, vars, node) {
	      if (format.styles.color || format.styles.textDecoration) {
	        Tools.walk(node, curry(processUnderlineAndColor, dom), 'childNodes');
	        processUnderlineAndColor(dom, node);
	      }
	    };
	    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
	      if (format.styles && format.styles.backgroundColor) {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', FormatUtils.replaceVars(format.styles.backgroundColor, vars)));
	      }
	    };
	    var mergeSubSup = function (dom, format, vars, node) {
	      if (format.inline === 'sub' || format.inline === 'sup') {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
	        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
	      }
	    };
	    var mergeSiblings = function (dom, format, vars, node) {
	      if (node && format.merge_siblings !== false) {
	        node = mergeSiblingsNodes(dom, FormatUtils.getNonWhiteSpaceSibling(node), node);
	        node = mergeSiblingsNodes(dom, node, FormatUtils.getNonWhiteSpaceSibling(node, true));
	      }
	    };
	    var clearChildStyles = function (dom, format, node) {
	      if (format.clear_child_styles) {
	        var selector = format.links ? '*:not(a)' : '*';
	        each$e(dom.select(selector, node), function (node) {
	          if (isElementNode(node)) {
	            each$e(format.styles, function (value, name) {
	              dom.setStyle(node, name, '');
	            });
	          }
	        });
	      }
	    };
	    var mergeWithChildren = function (editor, formatList, vars, node) {
	      each$e(formatList, function (format) {
	        each$e(editor.dom.select(format.inline, node), function (child) {
	          if (!isElementNode(child)) {
	            return;
	          }
	          RemoveFormat.removeFormat(editor, format, vars, child, format.exact ? child : null);
	        });
	        clearChildStyles(editor.dom, format, node);
	      });
	    };
	    var mergeWithParents = function (editor, format, name, vars, node) {
	      if (MatchFormat.matchNode(editor, node.parentNode, name, vars)) {
	        if (RemoveFormat.removeFormat(editor, format, vars, node)) {
	          return;
	        }
	      }
	      if (format.merge_with_parents) {
	        editor.dom.getParent(node.parentNode, function (parent) {
	          if (MatchFormat.matchNode(editor, parent, name, vars)) {
	            RemoveFormat.removeFormat(editor, format, vars, node);
	            return true;
	          }
	        });
	      }
	    };
	    var MergeFormats = {
	      mergeWithChildren: mergeWithChildren,
	      mergeUnderlineAndColor: mergeUnderlineAndColor,
	      mergeBackgroundColorAndFontSize: mergeBackgroundColorAndFontSize,
	      mergeSubSup: mergeSubSup,
	      mergeSiblings: mergeSiblings,
	      mergeWithParents: mergeWithParents
	    };
	
	    var each$f = Tools.each;
	    var isElementNode$1 = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !isCaretNode(node) && !NodeType.isBogus(node);
	    };
	    var applyFormat = function (ed, name, vars, node) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var bookmark, rng;
	      var isCollapsed = !node && ed.selection.isCollapsed();
	      var dom = ed.dom, selection = ed.selection;
	      var setElementFormat = function (elm, fmt) {
	        fmt = fmt || format;
	        if (elm) {
	          if (fmt.onformat) {
	            fmt.onformat(elm, fmt, vars, node);
	          }
	          each$f(fmt.styles, function (value, name) {
	            dom.setStyle(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	          if (fmt.styles) {
	            var styleVal = dom.getAttrib(elm, 'style');
	            if (styleVal) {
	              elm.setAttribute('data-mce-style', styleVal);
	            }
	          }
	          each$f(fmt.attributes, function (value, name) {
	            dom.setAttrib(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	          each$f(fmt.classes, function (value) {
	            value = FormatUtils.replaceVars(value, vars);
	            if (!dom.hasClass(elm, value)) {
	              dom.addClass(elm, value);
	            }
	          });
	        }
	      };
	      var applyNodeStyle = function (formatList, node) {
	        var found = false;
	        if (!format.selector) {
	          return false;
	        }
	        each$f(formatList, function (format) {
	          if ('collapsed' in format && format.collapsed !== isCollapsed) {
	            return;
	          }
	          if (dom.is(node, format.selector) && !isCaretNode(node)) {
	            setElementFormat(node, format);
	            found = true;
	            return false;
	          }
	        });
	        return found;
	      };
	      var applyRngStyle = function (dom, rng, bookmark, nodeSpecific) {
	        var newWrappers = [];
	        var wrapName, wrapElm, contentEditable = true;
	        wrapName = format.inline || format.block;
	        wrapElm = dom.create(wrapName);
	        setElementFormat(wrapElm);
	        RangeWalk.walk(dom, rng, function (nodes) {
	          var currentWrapElm;
	          var process = function (node) {
	            var nodeName, parentName, hasContentEditableState, lastContentEditable;
	            lastContentEditable = contentEditable;
	            nodeName = node.nodeName.toLowerCase();
	            parentName = node.parentNode.nodeName.toLowerCase();
	            if (node.nodeType === 1 && dom.getContentEditable(node)) {
	              lastContentEditable = contentEditable;
	              contentEditable = dom.getContentEditable(node) === 'true';
	              hasContentEditableState = true;
	            }
	            if (FormatUtils.isEq(nodeName, 'br')) {
	              currentWrapElm = 0;
	              if (format.block) {
	                dom.remove(node);
	              }
	              return;
	            }
	            if (format.wrapper && MatchFormat.matchNode(ed, node, name, vars)) {
	              currentWrapElm = 0;
	              return;
	            }
	            if (contentEditable && !hasContentEditableState && format.block && !format.wrapper && FormatUtils.isTextBlock(ed, nodeName) && FormatUtils.isValid(ed, parentName, wrapName)) {
	              node = dom.rename(node, wrapName);
	              setElementFormat(node);
	              newWrappers.push(node);
	              currentWrapElm = 0;
	              return;
	            }
	            if (format.selector) {
	              var found = applyNodeStyle(formatList, node);
	              if (!format.inline || found) {
	                currentWrapElm = 0;
	                return;
	              }
	            }
	            if (contentEditable && !hasContentEditableState && FormatUtils.isValid(ed, wrapName, nodeName) && FormatUtils.isValid(ed, parentName, wrapName) && !(!nodeSpecific && node.nodeType === 3 && node.nodeValue.length === 1 && node.nodeValue.charCodeAt(0) === 65279) && !isCaretNode(node) && (!format.inline || !dom.isBlock(node))) {
	              if (!currentWrapElm) {
	                currentWrapElm = dom.clone(wrapElm, false);
	                node.parentNode.insertBefore(currentWrapElm, node);
	                newWrappers.push(currentWrapElm);
	              }
	              currentWrapElm.appendChild(node);
	            } else {
	              currentWrapElm = 0;
	              each$f(Tools.grep(node.childNodes), process);
	              if (hasContentEditableState) {
	                contentEditable = lastContentEditable;
	              }
	              currentWrapElm = 0;
	            }
	          };
	          each$f(nodes, process);
	        });
	        if (format.links === true) {
	          each$f(newWrappers, function (node) {
	            var process = function (node) {
	              if (node.nodeName === 'A') {
	                setElementFormat(node, format);
	              }
	              each$f(Tools.grep(node.childNodes), process);
	            };
	            process(node);
	          });
	        }
	        each$f(newWrappers, function (node) {
	          var childCount;
	          var getChildCount = function (node) {
	            var count = 0;
	            each$f(node.childNodes, function (node) {
	              if (!FormatUtils.isWhiteSpaceNode(node) && !Bookmarks.isBookmarkNode(node)) {
	                count++;
	              }
	            });
	            return count;
	          };
	          var getChildElementNode = function (root) {
	            var child = false;
	            each$f(root.childNodes, function (node) {
	              if (isElementNode$1(node)) {
	                child = node;
	                return false;
	              }
	            });
	            return child;
	          };
	          var mergeStyles = function (node) {
	            var child, clone;
	            child = getChildElementNode(node);
	            if (child && !Bookmarks.isBookmarkNode(child) && MatchFormat.matchName(dom, child, format)) {
	              clone = dom.clone(child, false);
	              setElementFormat(clone);
	              dom.replace(clone, node, true);
	              dom.remove(child, 1);
	            }
	            return clone || node;
	          };
	          childCount = getChildCount(node);
	          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
	            dom.remove(node, 1);
	            return;
	          }
	          if (format.inline || format.wrapper) {
	            if (!format.exact && childCount === 1) {
	              node = mergeStyles(node);
	            }
	            MergeFormats.mergeWithChildren(ed, formatList, vars, node);
	            MergeFormats.mergeWithParents(ed, format, name, vars, node);
	            MergeFormats.mergeBackgroundColorAndFontSize(dom, format, vars, node);
	            MergeFormats.mergeSubSup(dom, format, vars, node);
	            MergeFormats.mergeSiblings(dom, format, vars, node);
	          }
	        });
	      };
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride && dom.is(node, formatList[i].selector)) {
	            setElementFormat(node, formatList[i]);
	            return;
	          }
	        }
	        return;
	      }
	      if (format) {
	        if (node) {
	          if (node.nodeType) {
	            if (!applyNodeStyle(formatList, node)) {
	              rng = dom.createRng();
	              rng.setStartBefore(node);
	              rng.setEndAfter(node);
	              applyRngStyle(dom, ExpandRange.expandRng(ed, rng, formatList), null, true);
	            }
	          } else {
	            applyRngStyle(dom, node, null, true);
	          }
	        } else {
	          if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	            var curSelNode = ed.selection.getNode();
	            if (!ed.settings.forced_root_block && formatList[0].defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
	              applyFormat(ed, formatList[0].defaultBlock);
	            }
	            ed.selection.setRng(RangeNormalizer.normalize(ed.selection.getRng()));
	            bookmark = GetBookmark.getPersistentBookmark(ed.selection, true);
	            applyRngStyle(dom, ExpandRange.expandRng(ed, selection.getRng(), formatList));
	            if (format.styles) {
	              MergeFormats.mergeUnderlineAndColor(dom, format, vars, curSelNode);
	            }
	            selection.moveToBookmark(bookmark);
	            FormatUtils.moveStart(dom, selection, selection.getRng());
	            ed.nodeChanged();
	          } else {
	            applyCaretFormat(ed, name, vars);
	          }
	        }
	        Hooks.postProcess(name, ed);
	      }
	    };
	    var ApplyFormat = { applyFormat: applyFormat };
	
	    var each$g = Tools.each;
	    var setup$5 = function (formatChangeData, editor) {
	      var currentFormats = {};
	      formatChangeData.set({});
	      editor.on('NodeChange', function (e) {
	        var parents = FormatUtils.getParents(editor.dom, e.element);
	        var matchedFormats = {};
	        parents = Tools.grep(parents, function (node) {
	          return node.nodeType === 1 && !node.getAttribute('data-mce-bogus');
	        });
	        each$g(formatChangeData.get(), function (callbacks, format) {
	          each$g(parents, function (node) {
	            if (editor.formatter.matchNode(node, format, {}, callbacks.similar)) {
	              if (!currentFormats[format]) {
	                each$g(callbacks, function (callback) {
	                  callback(true, {
	                    node: node,
	                    format: format,
	                    parents: parents
	                  });
	                });
	                currentFormats[format] = callbacks;
	              }
	              matchedFormats[format] = callbacks;
	              return false;
	            }
	            if (MatchFormat.matchesUnInheritedFormatSelector(editor, node, format)) {
	              return false;
	            }
	          });
	        });
	        each$g(currentFormats, function (callbacks, format) {
	          if (!matchedFormats[format]) {
	            delete currentFormats[format];
	            each$g(callbacks, function (callback) {
	              callback(false, {
	                node: e.element,
	                format: format,
	                parents: parents
	              });
	            });
	          }
	        });
	      });
	    };
	    var addListeners = function (formatChangeData, formats, callback, similar) {
	      var formatChangeItems = formatChangeData.get();
	      each$g(formats.split(','), function (format) {
	        if (!formatChangeItems[format]) {
	          formatChangeItems[format] = [];
	          formatChangeItems[format].similar = similar;
	        }
	        formatChangeItems[format].push(callback);
	      });
	      formatChangeData.set(formatChangeItems);
	    };
	    var formatChanged = function (editor, formatChangeState, formats, callback, similar) {
	      if (formatChangeState.get() === null) {
	        setup$5(formatChangeState, editor);
	      }
	      addListeners(formatChangeState, formats, callback, similar);
	    };
	    var FormatChanged = { formatChanged: formatChanged };
	
	    var get$5 = function (dom) {
	      var formats = {
	        valigntop: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'top' }
	          }],
	        valignmiddle: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'middle' }
	          }],
	        valignbottom: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'bottom' }
	          }],
	        alignleft: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-left',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'left' },
	            inherit: false,
	            preview: false,
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: { float: 'left' },
	            preview: 'font-family font-size'
	          }
	        ],
	        aligncenter: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'center' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-center',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'img',
	            collapsed: false,
	            styles: {
	              display: 'block',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: false
	          },
	          {
	            selector: 'table',
	            collapsed: false,
	            styles: {
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignright: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-right',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'right' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: { float: 'right' },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignjustify: [{
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'justify' },
	            inherit: false,
	            defaultBlock: 'div',
	            preview: 'font-family font-size'
	          }],
	        bold: [
	          {
	            inline: 'strong',
	            remove: 'all'
	          },
	          {
	            inline: 'span',
	            styles: { fontWeight: 'bold' }
	          },
	          {
	            inline: 'b',
	            remove: 'all'
	          }
	        ],
	        italic: [
	          {
	            inline: 'em',
	            remove: 'all'
	          },
	          {
	            inline: 'span',
	            styles: { fontStyle: 'italic' }
	          },
	          {
	            inline: 'i',
	            remove: 'all'
	          }
	        ],
	        underline: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'underline' },
	            exact: true
	          },
	          {
	            inline: 'u',
	            remove: 'all'
	          }
	        ],
	        strikethrough: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'line-through' },
	            exact: true
	          },
	          {
	            inline: 'strike',
	            remove: 'all'
	          }
	        ],
	        forecolor: {
	          inline: 'span',
	          styles: { color: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        hilitecolor: {
	          inline: 'span',
	          styles: { backgroundColor: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        fontname: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontFamily: '%value' },
	          clear_child_styles: true
	        },
	        fontsize: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontSize: '%value' },
	          clear_child_styles: true
	        },
	        fontsize_class: {
	          inline: 'span',
	          attributes: { class: '%value' }
	        },
	        blockquote: {
	          block: 'blockquote',
	          wrapper: 1,
	          remove: 'all'
	        },
	        subscript: { inline: 'sub' },
	        superscript: { inline: 'sup' },
	        code: { inline: 'code' },
	        link: {
	          inline: 'a',
	          selector: 'a',
	          remove: 'all',
	          split: true,
	          deep: true,
	          onmatch: function () {
	            return true;
	          },
	          onformat: function (elm, fmt, vars) {
	            Tools.each(vars, function (value, key) {
	              dom.setAttrib(elm, key, value);
	            });
	          }
	        },
	        removeformat: [
	          {
	            selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
	            remove: 'all',
	            split: true,
	            expand: false,
	            block_expand: true,
	            deep: true
	          },
	          {
	            selector: 'span',
	            attributes: [
	              'style',
	              'class'
	            ],
	            remove: 'empty',
	            split: true,
	            expand: false,
	            deep: true
	          },
	          {
	            selector: '*',
	            attributes: [
	              'style',
	              'class'
	            ],
	            split: false,
	            expand: false,
	            deep: true
	          }
	        ]
	      };
	      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function (name) {
	        formats[name] = {
	          block: name,
	          remove: 'all'
	        };
	      });
	      return formats;
	    };
	    var DefaultFormats = { get: get$5 };
	
	    function FormatRegistry (editor) {
	      var formats = {};
	      var get = function (name) {
	        return name ? formats[name] : formats;
	      };
	      var register = function (name, format) {
	        if (name) {
	          if (typeof name !== 'string') {
	            Tools.each(name, function (format, name) {
	              register(name, format);
	            });
	          } else {
	            format = format.length ? format : [format];
	            Tools.each(format, function (format) {
	              if (typeof format.deep === 'undefined') {
	                format.deep = !format.selector;
	              }
	              if (typeof format.split === 'undefined') {
	                format.split = !format.selector || format.inline;
	              }
	              if (typeof format.remove === 'undefined' && format.selector && !format.inline) {
	                format.remove = 'none';
	              }
	              if (format.selector && format.inline) {
	                format.mixed = true;
	                format.block_expand = true;
	              }
	              if (typeof format.classes === 'string') {
	                format.classes = format.classes.split(/\s+/);
	              }
	            });
	            formats[name] = format;
	          }
	        }
	      };
	      var unregister = function (name) {
	        if (name && formats[name]) {
	          delete formats[name];
	        }
	        return formats;
	      };
	      register(DefaultFormats.get(editor.dom));
	      register(editor.settings.formats);
	      return {
	        get: get,
	        register: register,
	        unregister: unregister
	      };
	    }
	
	    var each$h = Tools.each;
	    var dom = DOMUtils$1.DOM;
	    var parsedSelectorToHtml = function (ancestry, editor) {
	      var elm, item, fragment;
	      var schema = editor && editor.schema || Schema({});
	      var decorate = function (elm, item) {
	        if (item.classes.length) {
	          dom.addClass(elm, item.classes.join(' '));
	        }
	        dom.setAttribs(elm, item.attrs);
	      };
	      var createElement = function (sItem) {
	        var elm;
	        item = typeof sItem === 'string' ? {
	          name: sItem,
	          classes: [],
	          attrs: {}
	        } : sItem;
	        elm = dom.create(item.name);
	        decorate(elm, item);
	        return elm;
	      };
	      var getRequiredParent = function (elm, candidate) {
	        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
	        var elmRule = schema.getElementRule(name);
	        var parentsRequired = elmRule && elmRule.parentsRequired;
	        if (parentsRequired && parentsRequired.length) {
	          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
	        } else {
	          return false;
	        }
	      };
	      var wrapInHtml = function (elm, ancestry, siblings) {
	        var parent, parentCandidate, parentRequired;
	        var ancestor = ancestry.length > 0 && ancestry[0];
	        var ancestorName = ancestor && ancestor.name;
	        parentRequired = getRequiredParent(elm, ancestorName);
	        if (parentRequired) {
	          if (ancestorName === parentRequired) {
	            parentCandidate = ancestry[0];
	            ancestry = ancestry.slice(1);
	          } else {
	            parentCandidate = parentRequired;
	          }
	        } else if (ancestor) {
	          parentCandidate = ancestry[0];
	          ancestry = ancestry.slice(1);
	        } else if (!siblings) {
	          return elm;
	        }
	        if (parentCandidate) {
	          parent = createElement(parentCandidate);
	          parent.appendChild(elm);
	        }
	        if (siblings) {
	          if (!parent) {
	            parent = dom.create('div');
	            parent.appendChild(elm);
	          }
	          Tools.each(siblings, function (sibling) {
	            var siblingElm = createElement(sibling);
	            parent.insertBefore(siblingElm, elm);
	          });
	        }
	        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
	      };
	      if (ancestry && ancestry.length) {
	        item = ancestry[0];
	        elm = createElement(item);
	        fragment = dom.create('div');
	        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
	        return fragment;
	      } else {
	        return '';
	      }
	    };
	    var selectorToHtml = function (selector, editor) {
	      return parsedSelectorToHtml(parseSelector(selector), editor);
	    };
	    var parseSelectorItem = function (item) {
	      var tagName;
	      var obj = {
	        classes: [],
	        attrs: {}
	      };
	      item = obj.selector = Tools.trim(item);
	      if (item !== '*') {
	        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
	          switch ($1) {
	          case '#':
	            obj.attrs.id = $2;
	            break;
	          case '.':
	            obj.classes.push($2);
	            break;
	          case ':':
	            if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
	              obj.attrs[$2] = $2;
	            }
	            break;
	          }
	          if ($3 === '[') {
	            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
	            if (m) {
	              obj.attrs[m[1]] = m[2];
	            }
	          }
	          return '';
	        });
	      }
	      obj.name = tagName || 'div';
	      return obj;
	    };
	    var parseSelector = function (selector) {
	      if (!selector || typeof selector !== 'string') {
	        return [];
	      }
	      selector = selector.split(/\s*,\s*/)[0];
	      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
	      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
	        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
	        var obj = siblings.pop();
	        if (siblings.length) {
	          obj.siblings = siblings;
	        }
	        return obj;
	      }).reverse();
	    };
	    var getCssText = function (editor, format) {
	      var name, previewFrag, previewElm, items;
	      var previewCss = '', parentFontSize, previewStyles;
	      previewStyles = editor.settings.preview_styles;
	      if (previewStyles === false) {
	        return '';
	      }
	      if (typeof previewStyles !== 'string') {
	        previewStyles = 'font-family font-size font-weight font-style text-decoration ' + 'text-transform color background-color border border-radius outline text-shadow';
	      }
	      var removeVars = function (val) {
	        return val.replace(/%(\w+)/g, '');
	      };
	      if (typeof format === 'string') {
	        format = editor.formatter.get(format);
	        if (!format) {
	          return;
	        }
	        format = format[0];
	      }
	      if ('preview' in format) {
	        previewStyles = format.preview;
	        if (previewStyles === false) {
	          return '';
	        }
	      }
	      name = format.block || format.inline || 'span';
	      items = parseSelector(format.selector);
	      if (items.length) {
	        if (!items[0].name) {
	          items[0].name = name;
	        }
	        name = format.selector;
	        previewFrag = parsedSelectorToHtml(items, editor);
	      } else {
	        previewFrag = parsedSelectorToHtml([name], editor);
	      }
	      previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
	      each$h(format.styles, function (value, name) {
	        value = removeVars(value);
	        if (value) {
	          dom.setStyle(previewElm, name, value);
	        }
	      });
	      each$h(format.attributes, function (value, name) {
	        value = removeVars(value);
	        if (value) {
	          dom.setAttrib(previewElm, name, value);
	        }
	      });
	      each$h(format.classes, function (value) {
	        value = removeVars(value);
	        if (!dom.hasClass(previewElm, value)) {
	          dom.addClass(previewElm, value);
	        }
	      });
	      editor.fire('PreviewFormats');
	      dom.setStyles(previewFrag, {
	        position: 'absolute',
	        left: -65535
	      });
	      editor.getBody().appendChild(previewFrag);
	      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
	      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	      each$h(previewStyles.split(' '), function (name) {
	        var value = dom.getStyle(previewElm, name, true);
	        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
	          value = dom.getStyle(editor.getBody(), name, true);
	          if (dom.toHex(value).toLowerCase() === '#ffffff') {
	            return;
	          }
	        }
	        if (name === 'color') {
	          if (dom.toHex(value).toLowerCase() === '#000000') {
	            return;
	          }
	        }
	        if (name === 'font-size') {
	          if (/em|%$/.test(value)) {
	            if (parentFontSize === 0) {
	              return;
	            }
	            var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
	            value = numValue * parentFontSize + 'px';
	          }
	        }
	        if (name === 'border' && value) {
	          previewCss += 'padding:0 2px;';
	        }
	        previewCss += name + ':' + value + ';';
	      });
	      editor.fire('AfterPreviewFormats');
	      dom.remove(previewFrag);
	      return previewCss;
	    };
	    var Preview = {
	      getCssText: getCssText,
	      parseSelector: parseSelector,
	      selectorToHtml: selectorToHtml
	    };
	
	    var toggle = function (editor, formats, name, vars, node) {
	      var fmt = formats.get(name);
	      if (MatchFormat.match(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
	        RemoveFormat.remove(editor, name, vars, node);
	      } else {
	        ApplyFormat.applyFormat(editor, name, vars, node);
	      }
	    };
	    var ToggleFormat = { toggle: toggle };
	
	    var setup$6 = function (editor) {
	      editor.addShortcut('meta+b', '', 'Bold');
	      editor.addShortcut('meta+i', '', 'Italic');
	      editor.addShortcut('meta+u', '', 'Underline');
	      for (var i = 1; i <= 6; i++) {
	        editor.addShortcut('access+' + i, '', [
	          'FormatBlock',
	          false,
	          'h' + i
	        ]);
	      }
	      editor.addShortcut('access+7', '', [
	        'FormatBlock',
	        false,
	        'p'
	      ]);
	      editor.addShortcut('access+8', '', [
	        'FormatBlock',
	        false,
	        'div'
	      ]);
	      editor.addShortcut('access+9', '', [
	        'FormatBlock',
	        false,
	        'address'
	      ]);
	    };
	    var FormatShortcuts = { setup: setup$6 };
	
	    function Formatter (editor) {
	      var formats = FormatRegistry(editor);
	      var formatChangeState = Cell(null);
	      FormatShortcuts.setup(editor);
	      setup$2(editor);
	      return {
	        get: formats.get,
	        register: formats.register,
	        unregister: formats.unregister,
	        apply: curry(ApplyFormat.applyFormat, editor),
	        remove: curry(RemoveFormat.remove, editor),
	        toggle: curry(ToggleFormat.toggle, editor, formats),
	        match: curry(MatchFormat.match, editor),
	        matchAll: curry(MatchFormat.matchAll, editor),
	        matchNode: curry(MatchFormat.matchNode, editor),
	        canApply: curry(MatchFormat.canApply, editor),
	        formatChanged: curry(FormatChanged.formatChanged, editor, formatChangeState),
	        getCssText: curry(Preview.getCssText, editor)
	      };
	    }
	
	    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
	    var shallow$1 = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty$2.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow$1);
	
	    var register = function (htmlParser, settings, dom) {
	      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
	          node.attr(name, null);
	        }
	      });
	      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
	        var i = nodes.length, node, value;
	        var internalName = 'data-mce-' + name;
	        var urlConverter = settings.url_converter;
	        var urlConverterScope = settings.url_converter_scope;
	        while (i--) {
	          node = nodes[i];
	          value = node.attributes.map[internalName];
	          if (value !== undefined) {
	            node.attr(name, value.length > 0 ? value : null);
	            node.attr(internalName, null);
	          } else {
	            value = node.attributes.map[name];
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	            } else if (urlConverter) {
	              value = urlConverter.call(urlConverterScope, value, name, node.name);
	            }
	            node.attr(name, value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, value;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr('class');
	          if (value) {
	            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
	            node.attr('class', value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.attributes.map['data-mce-type'] === 'bookmark' && !args.cleanup) {
	            var hasChildren = Option.from(node.firstChild).exists(function (firstChild) {
	              return !Zwsp.isZwsp(firstChild.value);
	            });
	            if (hasChildren) {
	              node.unwrap();
	            } else {
	              node.remove();
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('noscript', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i].firstChild;
	          if (node) {
	            node.value = Entities.decode(node.value);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('script,style', function (nodes, name) {
	        var i = nodes.length, node, value, type;
	        var trim = function (value) {
	          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	        };
	        while (i--) {
	          node = nodes[i];
	          value = node.firstChild ? node.firstChild.value : '';
	          if (name === 'script') {
	            type = node.attr('type');
	            if (type) {
	              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
	            }
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
	            }
	          } else {
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('#comment', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.value.indexOf('[CDATA[') === 0) {
	            node.name = '#cdata';
	            node.type = 4;
	            node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '');
	          } else if (node.value.indexOf('mce:protected ') === 0) {
	            node.name = '#text';
	            node.type = 3;
	            node.raw = true;
	            node.value = unescape(node.value).substr(14);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.type === 7) {
	            node.remove();
	          } else if (node.type === 1) {
	            if (name === 'input' && !('type' in node.attributes.map)) {
	              node.attr('type', 'text');
	            }
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
	        each(nodes, function (node) {
	          if (node.attr('data-mce-type') === 'format-caret') {
	            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
	              node.remove();
	            } else {
	              node.unwrap();
	            }
	          }
	        });
	      });
	      htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].attr(name, null);
	        }
	      });
	    };
	    var trimTrailingBr = function (rootNode) {
	      var brNode1, brNode2;
	      var isBr = function (node) {
	        return node && node.name === 'br';
	      };
	      brNode1 = rootNode.lastChild;
	      if (isBr(brNode1)) {
	        brNode2 = brNode1.prev;
	        if (isBr(brNode2)) {
	          brNode1.remove();
	          brNode2.remove();
	        }
	      }
	    };
	    var DomSerializerFilters = {
	      register: register,
	      trimTrailingBr: trimTrailingBr
	    };
	
	    var preProcess = function (editor, node, args) {
	      var impl, doc, oldDoc;
	      var dom = editor.dom;
	      node = node.cloneNode(true);
	      impl = domGlobals.document.implementation;
	      if (impl.createHTMLDocument) {
	        doc = impl.createHTMLDocument('');
	        Tools.each(node.nodeName === 'BODY' ? node.childNodes : [node], function (node) {
	          doc.body.appendChild(doc.importNode(node, true));
	        });
	        if (node.nodeName !== 'BODY') {
	          node = doc.body.firstChild;
	        } else {
	          node = doc.body;
	        }
	        oldDoc = dom.doc;
	        dom.doc = doc;
	      }
	      Events.firePreProcess(editor, merge(args, { node: node }));
	      if (oldDoc) {
	        dom.doc = oldDoc;
	      }
	      return node;
	    };
	    var shouldFireEvent = function (editor, args) {
	      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
	    };
	    var process = function (editor, node, args) {
	      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
	    };
	    var DomSerializerPreProcess = { process: process };
	
	    var removeAttrs = function (node, names) {
	      each(names, function (name) {
	        node.attr(name, null);
	      });
	    };
	    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
	      domParser.addNodeFilter('font', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          var color = node.attr('color');
	          var face = node.attr('face');
	          var size = node.attr('size');
	          if (color) {
	            props.color = color;
	          }
	          if (face) {
	            props['font-family'] = face;
	          }
	          if (size) {
	            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
	          }
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	          removeAttrs(node, [
	            'color',
	            'face',
	            'size'
	          ]);
	        });
	      });
	    };
	    var addStrikeToSpanFilter = function (domParser, styles) {
	      domParser.addNodeFilter('strike', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          props['text-decoration'] = 'line-through';
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	        });
	      });
	    };
	    var addFilters = function (domParser, settings) {
	      var styles = Styles();
	      if (settings.convert_fonts_to_spans) {
	        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
	      }
	      addStrikeToSpanFilter(domParser, styles);
	    };
	    var register$1 = function (domParser, settings) {
	      if (settings.inline_styles) {
	        addFilters(domParser, settings);
	      }
	    };
	    var LegacyFilter = { register: register$1 };
	
	    var whiteSpaceRegExp$3 = /^[ \t\r\n]*$/;
	    var typeLookup = {
	      '#text': 3,
	      '#comment': 8,
	      '#cdata': 4,
	      '#pi': 7,
	      '#doctype': 10,
	      '#document-fragment': 11
	    };
	    var walk$2 = function (node, root, prev) {
	      var sibling;
	      var parent;
	      var startName = prev ? 'lastChild' : 'firstChild';
	      var siblingName = prev ? 'prev' : 'next';
	      if (node[startName]) {
	        return node[startName];
	      }
	      if (node !== root) {
	        sibling = node[siblingName];
	        if (sibling) {
	          return sibling;
	        }
	        for (parent = node.parent; parent && parent !== root; parent = parent.parent) {
	          sibling = parent[siblingName];
	          if (sibling) {
	            return sibling;
	          }
	        }
	      }
	    };
	    var Node$1 = function () {
	      function Node(name, type) {
	        this.name = name;
	        this.type = type;
	        if (type === 1) {
	          this.attributes = [];
	          this.attributes.map = {};
	        }
	      }
	      Node.create = function (name, attrs) {
	        var node, attrName;
	        node = new Node(name, typeLookup[name] || 1);
	        if (attrs) {
	          for (attrName in attrs) {
	            node.attr(attrName, attrs[attrName]);
	          }
	        }
	        return node;
	      };
	      Node.prototype.replace = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        self.insert(node, self);
	        self.remove();
	        return self;
	      };
	      Node.prototype.attr = function (name, value) {
	        var self = this;
	        var attrs, i;
	        if (typeof name !== 'string') {
	          for (i in name) {
	            self.attr(i, name[i]);
	          }
	          return self;
	        }
	        if (attrs = self.attributes) {
	          if (value !== undefined) {
	            if (value === null) {
	              if (name in attrs.map) {
	                delete attrs.map[name];
	                i = attrs.length;
	                while (i--) {
	                  if (attrs[i].name === name) {
	                    attrs = attrs.splice(i, 1);
	                    return self;
	                  }
	                }
	              }
	              return self;
	            }
	            if (name in attrs.map) {
	              i = attrs.length;
	              while (i--) {
	                if (attrs[i].name === name) {
	                  attrs[i].value = value;
	                  break;
	                }
	              }
	            } else {
	              attrs.push({
	                name: name,
	                value: value
	              });
	            }
	            attrs.map[name] = value;
	            return self;
	          }
	          return attrs.map[name];
	        }
	      };
	      Node.prototype.clone = function () {
	        var self = this;
	        var clone = new Node(self.name, self.type);
	        var i, l, selfAttrs, selfAttr, cloneAttrs;
	        if (selfAttrs = self.attributes) {
	          cloneAttrs = [];
	          cloneAttrs.map = {};
	          for (i = 0, l = selfAttrs.length; i < l; i++) {
	            selfAttr = selfAttrs[i];
	            if (selfAttr.name !== 'id') {
	              cloneAttrs[cloneAttrs.length] = {
	                name: selfAttr.name,
	                value: selfAttr.value
	              };
	              cloneAttrs.map[selfAttr.name] = selfAttr.value;
	            }
	          }
	          clone.attributes = cloneAttrs;
	        }
	        clone.value = self.value;
	        clone.shortEnded = self.shortEnded;
	        return clone;
	      };
	      Node.prototype.wrap = function (wrapper) {
	        var self = this;
	        self.parent.insert(wrapper, self);
	        wrapper.append(self);
	        return self;
	      };
	      Node.prototype.unwrap = function () {
	        var self = this;
	        var node, next;
	        for (node = self.firstChild; node;) {
	          next = node.next;
	          self.insert(node, self, true);
	          node = next;
	        }
	        self.remove();
	      };
	      Node.prototype.remove = function () {
	        var self = this, parent = self.parent, next = self.next, prev = self.prev;
	        if (parent) {
	          if (parent.firstChild === self) {
	            parent.firstChild = next;
	            if (next) {
	              next.prev = null;
	            }
	          } else {
	            prev.next = next;
	          }
	          if (parent.lastChild === self) {
	            parent.lastChild = prev;
	            if (prev) {
	              prev.next = null;
	            }
	          } else {
	            next.prev = prev;
	          }
	          self.parent = self.next = self.prev = null;
	        }
	        return self;
	      };
	      Node.prototype.append = function (node) {
	        var self = this;
	        var last;
	        if (node.parent) {
	          node.remove();
	        }
	        last = self.lastChild;
	        if (last) {
	          last.next = node;
	          node.prev = last;
	          self.lastChild = node;
	        } else {
	          self.lastChild = self.firstChild = node;
	        }
	        node.parent = self;
	        return node;
	      };
	      Node.prototype.insert = function (node, refNode, before) {
	        var parent;
	        if (node.parent) {
	          node.remove();
	        }
	        parent = refNode.parent || this;
	        if (before) {
	          if (refNode === parent.firstChild) {
	            parent.firstChild = node;
	          } else {
	            refNode.prev.next = node;
	          }
	          node.prev = refNode.prev;
	          node.next = refNode;
	          refNode.prev = node;
	        } else {
	          if (refNode === parent.lastChild) {
	            parent.lastChild = node;
	          } else {
	            refNode.next.prev = node;
	          }
	          node.next = refNode.next;
	          node.prev = refNode;
	          refNode.next = node;
	        }
	        node.parent = parent;
	        return node;
	      };
	      Node.prototype.getAll = function (name) {
	        var self = this;
	        var node;
	        var collection = [];
	        for (node = self.firstChild; node; node = walk$2(node, self)) {
	          if (node.name === name) {
	            collection.push(node);
	          }
	        }
	        return collection;
	      };
	      Node.prototype.empty = function () {
	        var self = this;
	        var nodes, i, node;
	        if (self.firstChild) {
	          nodes = [];
	          for (node = self.firstChild; node; node = walk$2(node, self)) {
	            nodes.push(node);
	          }
	          i = nodes.length;
	          while (i--) {
	            node = nodes[i];
	            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
	          }
	        }
	        self.firstChild = self.lastChild = null;
	        return self;
	      };
	      Node.prototype.isEmpty = function (elements, whitespace, predicate) {
	        var self = this;
	        var node = self.firstChild, i, name;
	        whitespace = whitespace || {};
	        if (node) {
	          do {
	            if (node.type === 1) {
	              if (node.attributes.map['data-mce-bogus']) {
	                continue;
	              }
	              if (elements[node.name]) {
	                return false;
	              }
	              i = node.attributes.length;
	              while (i--) {
	                name = node.attributes[i].name;
	                if (name === 'name' || name.indexOf('data-mce-bookmark') === 0) {
	                  return false;
	                }
	              }
	            }
	            if (node.type === 8) {
	              return false;
	            }
	            if (node.type === 3 && !whiteSpaceRegExp$3.test(node.value)) {
	              return false;
	            }
	            if (node.type === 3 && node.parent && whitespace[node.parent.name] && whiteSpaceRegExp$3.test(node.value)) {
	              return false;
	            }
	            if (predicate && predicate(node)) {
	              return false;
	            }
	          } while (node = walk$2(node, self));
	        }
	        return true;
	      };
	      Node.prototype.walk = function (prev) {
	        return walk$2(this, null, prev);
	      };
	      return Node;
	    }();
	
	    var paddEmptyNode = function (settings, args, blockElements, node) {
	      var brPreferred = settings.padd_empty_with_br || args.insert;
	      if (brPreferred && blockElements[node.name]) {
	        node.empty().append(new Node$1('br', 1)).shortEnded = true;
	      } else {
	        node.empty().append(new Node$1('#text', 3)).value = '\xA0';
	      }
	    };
	    var isPaddedWithNbsp = function (node) {
	      return hasOnlyChild(node, '#text') && node.firstChild.value === '\xA0';
	    };
	    var hasOnlyChild = function (node, name) {
	      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
	    };
	    var isPadded = function (schema, node) {
	      var rule = schema.getElementRule(node.name);
	      return rule && rule.paddEmpty;
	    };
	    var isEmpty$2 = function (schema, nonEmptyElements, whitespaceElements, node) {
	      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
	        return isPadded(schema, node);
	      });
	    };
	    var isLineBreakNode = function (node, blockElements) {
	      return node && (blockElements[node.name] || node.name === 'br');
	    };
	
	    var register$2 = function (parser, settings) {
	      var schema = parser.schema;
	      if (settings.remove_trailing_brs) {
	        parser.addNodeFilter('br', function (nodes, _, args) {
	          var i;
	          var l = nodes.length;
	          var node;
	          var blockElements = Tools.extend({}, schema.getBlockElements());
	          var nonEmptyElements = schema.getNonEmptyElements();
	          var parent, lastParent, prev, prevName;
	          var whiteSpaceElements = schema.getNonEmptyElements();
	          var elementRule, textNode;
	          blockElements.body = 1;
	          for (i = 0; i < l; i++) {
	            node = nodes[i];
	            parent = node.parent;
	            if (blockElements[node.parent.name] && node === parent.lastChild) {
	              prev = node.prev;
	              while (prev) {
	                prevName = prev.name;
	                if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
	                  if (prevName !== 'br') {
	                    break;
	                  }
	                  if (prevName === 'br') {
	                    node = null;
	                    break;
	                  }
	                }
	                prev = prev.prev;
	              }
	              if (node) {
	                node.remove();
	                if (isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, parent)) {
	                  elementRule = schema.getElementRule(parent.name);
	                  if (elementRule) {
	                    if (elementRule.removeEmpty) {
	                      parent.remove();
	                    } else if (elementRule.paddEmpty) {
	                      paddEmptyNode(settings, args, blockElements, parent);
	                    }
	                  }
	                }
	              }
	            } else {
	              lastParent = node;
	              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
	                lastParent = parent;
	                if (blockElements[parent.name]) {
	                  break;
	                }
	                parent = parent.parent;
	              }
	              if (lastParent === parent && settings.padd_empty_with_br !== true) {
	                textNode = new Node$1('#text', 3);
	                textNode.value = '\xA0';
	                node.replace(textNode);
	              }
	            }
	          }
	        });
	      }
	      parser.addAttributeFilter('href', function (nodes) {
	        var i = nodes.length, node;
	        var appendRel = function (rel) {
	          var parts = rel.split(' ').filter(function (p) {
	            return p.length > 0;
	          });
	          return parts.concat(['noopener']).sort().join(' ');
	        };
	        var addNoOpener = function (rel) {
	          var newRel = rel ? Tools.trim(rel) : '';
	          if (!/\b(noopener)\b/g.test(newRel)) {
	            return appendRel(newRel);
	          } else {
	            return newRel;
	          }
	        };
	        if (!settings.allow_unsafe_link_target) {
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.attr('target') === '_blank') {
	              node.attr('rel', addNoOpener(node.attr('rel')));
	            }
	          }
	        }
	      });
	      if (!settings.allow_html_in_named_anchor) {
	        parser.addAttributeFilter('id,name', function (nodes) {
	          var i = nodes.length, sibling, prevSibling, parent, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
	              parent = node.parent;
	              sibling = node.lastChild;
	              do {
	                prevSibling = sibling.prev;
	                parent.insert(sibling, node);
	                sibling = prevSibling;
	              } while (sibling);
	            }
	          }
	        });
	      }
	      if (settings.fix_list_elements) {
	        parser.addNodeFilter('ul,ol', function (nodes) {
	          var i = nodes.length, node, parentNode;
	          while (i--) {
	            node = nodes[i];
	            parentNode = node.parent;
	            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
	              if (node.prev && node.prev.name === 'li') {
	                node.prev.append(node);
	              } else {
	                var li = new Node$1('li', 1);
	                li.attr('style', 'list-style-type: none');
	                node.wrap(li);
	              }
	            }
	          }
	        });
	      }
	      if (settings.validate && schema.getValidClasses()) {
	        parser.addAttributeFilter('class', function (nodes) {
	          var i = nodes.length, node, classList, ci, className, classValue;
	          var validClasses = schema.getValidClasses();
	          var validClassesMap, valid;
	          while (i--) {
	            node = nodes[i];
	            classList = node.attr('class').split(' ');
	            classValue = '';
	            for (ci = 0; ci < classList.length; ci++) {
	              className = classList[ci];
	              valid = false;
	              validClassesMap = validClasses['*'];
	              if (validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              validClassesMap = validClasses[node.name];
	              if (!valid && validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              if (valid) {
	                if (classValue) {
	                  classValue += ' ';
	                }
	                classValue += className;
	              }
	            }
	            if (!classValue.length) {
	              classValue = null;
	            }
	            node.attr('class', classValue);
	          }
	        });
	      }
	    };
	
	    var makeMap$4 = Tools.makeMap, each$i = Tools.each, explode$3 = Tools.explode, extend$3 = Tools.extend;
	    function DomParser (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var nodeFilters = {};
	      var attributeFilters = [];
	      var matchedNodes = {};
	      var matchedAttributes = {};
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      settings.root_name = settings.root_name || 'body';
	      var fixInvalidChildren = function (nodes) {
	        var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
	        var nonEmptyElements, whitespaceElements, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
	        nonSplitableElements = makeMap$4('tr,td,th,tbody,thead,tfoot,table');
	        nonEmptyElements = schema.getNonEmptyElements();
	        whitespaceElements = schema.getWhiteSpaceElements();
	        textBlockElements = schema.getTextBlockElements();
	        specialElements = schema.getSpecialElements();
	        for (ni = 0; ni < nodes.length; ni++) {
	          node = nodes[ni];
	          if (!node.parent || node.fixed) {
	            continue;
	          }
	          if (textBlockElements[node.name] && node.parent.name === 'li') {
	            sibling = node.next;
	            while (sibling) {
	              if (textBlockElements[sibling.name]) {
	                sibling.name = 'li';
	                sibling.fixed = true;
	                node.parent.insert(sibling, node.parent);
	              } else {
	                break;
	              }
	              sibling = sibling.next;
	            }
	            node.unwrap(node);
	            continue;
	          }
	          parents = [node];
	          for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) && !nonSplitableElements[parent.name]; parent = parent.parent) {
	            parents.push(parent);
	          }
	          if (parent && parents.length > 1) {
	            parents.reverse();
	            newParent = currentNode = filterNode(parents[0].clone());
	            for (i = 0; i < parents.length - 1; i++) {
	              if (schema.isValidChild(currentNode.name, parents[i].name)) {
	                tempNode = filterNode(parents[i].clone());
	                currentNode.append(tempNode);
	              } else {
	                tempNode = currentNode;
	              }
	              for (childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
	                nextNode = childNode.next;
	                tempNode.append(childNode);
	                childNode = nextNode;
	              }
	              currentNode = tempNode;
	            }
	            if (!isEmpty$2(schema, nonEmptyElements, whitespaceElements, newParent)) {
	              parent.insert(newParent, parents[0], true);
	              parent.insert(node, newParent);
	            } else {
	              parent.insert(node, parents[0], true);
	            }
	            parent = parents[0];
	            if (isEmpty$2(schema, nonEmptyElements, whitespaceElements, parent) || hasOnlyChild(parent, 'br')) {
	              parent.empty().remove();
	            }
	          } else if (node.parent) {
	            if (node.name === 'li') {
	              sibling = node.prev;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.append(node);
	                continue;
	              }
	              sibling = node.next;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.insert(node, sibling.firstChild, true);
	                continue;
	              }
	              node.wrap(filterNode(new Node$1('ul', 1)));
	              continue;
	            }
	            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
	              node.wrap(filterNode(new Node$1('div', 1)));
	            } else {
	              if (specialElements[node.name]) {
	                node.empty().remove();
	              } else {
	                node.unwrap();
	              }
	            }
	          }
	        }
	      };
	      var filterNode = function (node) {
	        var i, name, list;
	        name = node.name;
	        if (name in nodeFilters) {
	          list = matchedNodes[name];
	          if (list) {
	            list.push(node);
	          } else {
	            matchedNodes[name] = [node];
	          }
	        }
	        i = attributeFilters.length;
	        while (i--) {
	          name = attributeFilters[i].name;
	          if (name in node.attributes.map) {
	            list = matchedAttributes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedAttributes[name] = [node];
	            }
	          }
	        }
	        return node;
	      };
	      var addNodeFilter = function (name, callback) {
	        each$i(explode$3(name), function (name) {
	          var list = nodeFilters[name];
	          if (!list) {
	            nodeFilters[name] = list = [];
	          }
	          list.push(callback);
	        });
	      };
	      var getNodeFilters = function () {
	        var out = [];
	        for (var name in nodeFilters) {
	          if (nodeFilters.hasOwnProperty(name)) {
	            out.push({
	              name: name,
	              callbacks: nodeFilters[name]
	            });
	          }
	        }
	        return out;
	      };
	      var addAttributeFilter = function (name, callback) {
	        each$i(explode$3(name), function (name) {
	          var i;
	          for (i = 0; i < attributeFilters.length; i++) {
	            if (attributeFilters[i].name === name) {
	              attributeFilters[i].callbacks.push(callback);
	              return;
	            }
	          }
	          attributeFilters.push({
	            name: name,
	            callbacks: [callback]
	          });
	        });
	      };
	      var getAttributeFilters = function () {
	        return [].concat(attributeFilters);
	      };
	      var parse = function (html, args) {
	        var parser, nodes, i, l, fi, fl, list, name;
	        var blockElements;
	        var invalidChildren = [];
	        var isInWhiteSpacePreservedElement;
	        var node;
	        args = args || {};
	        matchedNodes = {};
	        matchedAttributes = {};
	        blockElements = extend$3(makeMap$4('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var children = schema.children;
	        var validate = settings.validate;
	        var rootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
	        var whiteSpaceElements = schema.getWhiteSpaceElements();
	        var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
	        var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
	        var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
	        var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	        isInWhiteSpacePreservedElement = whiteSpaceElements.hasOwnProperty(args.context) || whiteSpaceElements.hasOwnProperty(settings.root_name);
	        var addRootBlocks = function () {
	          var node = rootNode.firstChild, next, rootBlockNode;
	          var trim = function (rootBlockNode) {
	            if (rootBlockNode) {
	              node = rootBlockNode.firstChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(startWhiteSpaceRegExp, '');
	              }
	              node = rootBlockNode.lastChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(endWhiteSpaceRegExp, '');
	              }
	            }
	          };
	          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
	            return;
	          }
	          while (node) {
	            next = node.next;
	            if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
	              if (!rootBlockNode) {
	                rootBlockNode = createNode(rootBlockName, 1);
	                rootBlockNode.attr(settings.forced_root_block_attrs);
	                rootNode.insert(rootBlockNode, node);
	                rootBlockNode.append(node);
	              } else {
	                rootBlockNode.append(node);
	              }
	            } else {
	              trim(rootBlockNode);
	              rootBlockNode = null;
	            }
	            node = next;
	          }
	          trim(rootBlockNode);
	        };
	        var createNode = function (name, type) {
	          var node = new Node$1(name, type);
	          var list;
	          if (name in nodeFilters) {
	            list = matchedNodes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedNodes[name] = [node];
	            }
	          }
	          return node;
	        };
	        var removeWhitespaceBefore = function (node) {
	          var textNode, textNodeNext, textVal, sibling;
	          var blockElements = schema.getBlockElements();
	          for (textNode = node.prev; textNode && textNode.type === 3;) {
	            textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	            if (textVal.length > 0) {
	              textNode.value = textVal;
	              return;
	            }
	            textNodeNext = textNode.next;
	            if (textNodeNext) {
	              if (textNodeNext.type === 3 && textNodeNext.value.length) {
	                textNode = textNode.prev;
	                continue;
	              }
	              if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
	                textNode = textNode.prev;
	                continue;
	              }
	            }
	            sibling = textNode.prev;
	            textNode.remove();
	            textNode = sibling;
	          }
	        };
	        var cloneAndExcludeBlocks = function (input) {
	          var name;
	          var output = {};
	          for (name in input) {
	            if (name !== 'li' && name !== 'p') {
	              output[name] = input[name];
	            }
	          }
	          return output;
	        };
	        parser = SaxParser$1({
	          validate: validate,
	          allow_script_urls: settings.allow_script_urls,
	          allow_conditional_comments: settings.allow_conditional_comments,
	          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	          cdata: function (text) {
	            node.append(createNode('#cdata', 4)).value = text;
	          },
	          text: function (text, raw) {
	            var textNode;
	            if (!isInWhiteSpacePreservedElement) {
	              text = text.replace(allWhiteSpaceRegExp, ' ');
	              if (isLineBreakNode(node.lastChild, blockElements)) {
	                text = text.replace(startWhiteSpaceRegExp, '');
	              }
	            }
	            if (text.length !== 0) {
	              textNode = createNode('#text', 3);
	              textNode.raw = !!raw;
	              node.append(textNode).value = text;
	            }
	          },
	          comment: function (text) {
	            node.append(createNode('#comment', 8)).value = text;
	          },
	          pi: function (name, text) {
	            node.append(createNode(name, 7)).value = text;
	            removeWhitespaceBefore(node);
	          },
	          doctype: function (text) {
	            var newNode;
	            newNode = node.append(createNode('#doctype', 10));
	            newNode.value = text;
	            removeWhitespaceBefore(node);
	          },
	          start: function (name, attrs, empty) {
	            var newNode, attrFiltersLen, elementRule, attrName, parent;
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              newNode = createNode(elementRule.outputName || name, 1);
	              newNode.attributes = attrs;
	              newNode.shortEnded = empty;
	              node.append(newNode);
	              parent = children[node.name];
	              if (parent && children[newNode.name] && !parent[newNode.name]) {
	                invalidChildren.push(newNode);
	              }
	              attrFiltersLen = attributeFilters.length;
	              while (attrFiltersLen--) {
	                attrName = attributeFilters[attrFiltersLen].name;
	                if (attrName in attrs.map) {
	                  list = matchedAttributes[attrName];
	                  if (list) {
	                    list.push(newNode);
	                  } else {
	                    matchedAttributes[attrName] = [newNode];
	                  }
	                }
	              }
	              if (blockElements[name]) {
	                removeWhitespaceBefore(newNode);
	              }
	              if (!empty) {
	                node = newNode;
	              }
	              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = true;
	              }
	            }
	          },
	          end: function (name) {
	            var textNode, elementRule, text, sibling, tempNode;
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              if (blockElements[name]) {
	                if (!isInWhiteSpacePreservedElement) {
	                  textNode = node.firstChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.next;
	                    } else {
	                      sibling = textNode.next;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.next;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                  textNode = node.lastChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.prev;
	                    } else {
	                      sibling = textNode.prev;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.prev;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                }
	              }
	              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = false;
	              }
	              if (elementRule.removeEmpty && isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node)) {
	                if (!node.attributes.map.name && !node.attr('id')) {
	                  tempNode = node.parent;
	                  if (blockElements[node.name]) {
	                    node.empty().remove();
	                  } else {
	                    node.unwrap();
	                  }
	                  node = tempNode;
	                  return;
	                }
	              }
	              if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node))) {
	                paddEmptyNode(settings, args, blockElements, node);
	              }
	              node = node.parent;
	            }
	          }
	        }, schema);
	        var rootNode = node = new Node$1(args.context || settings.root_name, 11);
	        parser.parse(html);
	        if (validate && invalidChildren.length) {
	          if (!args.context) {
	            fixInvalidChildren(invalidChildren);
	          } else {
	            args.invalid = true;
	          }
	        }
	        if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
	          addRootBlocks();
	        }
	        if (!args.invalid) {
	          for (name in matchedNodes) {
	            list = nodeFilters[name];
	            nodes = matchedNodes[name];
	            fi = nodes.length;
	            while (fi--) {
	              if (!nodes[fi].parent) {
	                nodes.splice(fi, 1);
	              }
	            }
	            for (i = 0, l = list.length; i < l; i++) {
	              list[i](nodes, name, args);
	            }
	          }
	          for (i = 0, l = attributeFilters.length; i < l; i++) {
	            list = attributeFilters[i];
	            if (list.name in matchedAttributes) {
	              nodes = matchedAttributes[list.name];
	              fi = nodes.length;
	              while (fi--) {
	                if (!nodes[fi].parent) {
	                  nodes.splice(fi, 1);
	                }
	              }
	              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
	                list.callbacks[fi](nodes, list.name, args);
	              }
	            }
	          }
	        }
	        return rootNode;
	      };
	      var exports = {
	        schema: schema,
	        addAttributeFilter: addAttributeFilter,
	        getAttributeFilters: getAttributeFilters,
	        addNodeFilter: addNodeFilter,
	        getNodeFilters: getNodeFilters,
	        filterNode: filterNode,
	        parse: parse
	      };
	      register$2(exports, settings);
	      LegacyFilter.register(exports, settings);
	      return exports;
	    }
	
	    var addTempAttr = function (htmlParser, tempAttrs, name) {
	      if (Tools.inArray(tempAttrs, name) === -1) {
	        htmlParser.addAttributeFilter(name, function (nodes, name) {
	          var i = nodes.length;
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        });
	        tempAttrs.push(name);
	      }
	    };
	    var postProcess$1 = function (editor, args, content) {
	      if (!args.no_events && editor) {
	        var outArgs = Events.firePostProcess(editor, merge(args, { content: content }));
	        return outArgs.content;
	      } else {
	        return content;
	      }
	    };
	    var getHtmlFromNode = function (dom, node, args) {
	      var html = Zwsp.trim(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
	      return args.selection || isWsPreserveElement(Element.fromDom(node)) ? html : Tools.trim(html);
	    };
	    var parseHtml = function (htmlParser, html, args) {
	      var parserArgs = args.selection ? merge({ forced_root_block: false }, args) : args;
	      var rootNode = htmlParser.parse(html, parserArgs);
	      DomSerializerFilters.trimTrailingBr(rootNode);
	      return rootNode;
	    };
	    var serializeNode = function (settings, schema, node) {
	      var htmlSerializer = HtmlSerializer(settings, schema);
	      return htmlSerializer.serialize(node);
	    };
	    var toHtml = function (editor, settings, schema, rootNode, args) {
	      var content = serializeNode(settings, schema, rootNode);
	      return postProcess$1(editor, args, content);
	    };
	    function DomSerializer (settings, editor) {
	      var dom, schema, htmlParser;
	      var tempAttrs = ['data-mce-selected'];
	      dom = editor && editor.dom ? editor.dom : DOMUtils$1.DOM;
	      schema = editor && editor.schema ? editor.schema : Schema(settings);
	      settings.entity_encoding = settings.entity_encoding || 'named';
	      settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
	      htmlParser = DomParser(settings, schema);
	      DomSerializerFilters.register(htmlParser, settings, dom);
	      var serialize = function (node, parserArgs) {
	        var args = merge({ format: 'html' }, parserArgs ? parserArgs : {});
	        var targetNode = DomSerializerPreProcess.process(editor, node, args);
	        var html = getHtmlFromNode(dom, targetNode, args);
	        var rootNode = parseHtml(htmlParser, html, args);
	        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
	      };
	      return {
	        schema: schema,
	        addNodeFilter: htmlParser.addNodeFilter,
	        addAttributeFilter: htmlParser.addAttributeFilter,
	        serialize: serialize,
	        addRules: function (rules) {
	          schema.addValidElements(rules);
	        },
	        setRules: function (rules) {
	          schema.setValidElements(rules);
	        },
	        addTempAttr: curry(addTempAttr, htmlParser, tempAttrs),
	        getTempAttrs: function () {
	          return tempAttrs;
	        }
	      };
	    }
	
	    function DomSerializer$1 (settings, editor) {
	      var domSerializer = DomSerializer(settings, editor);
	      return {
	        schema: domSerializer.schema,
	        addNodeFilter: domSerializer.addNodeFilter,
	        addAttributeFilter: domSerializer.addAttributeFilter,
	        serialize: domSerializer.serialize,
	        addRules: domSerializer.addRules,
	        setRules: domSerializer.setRules,
	        addTempAttr: domSerializer.addTempAttr,
	        getTempAttrs: domSerializer.getTempAttrs
	      };
	    }
	
	    function BookmarkManager(selection) {
	      return {
	        getBookmark: curry(Bookmarks.getBookmark, selection),
	        moveToBookmark: curry(Bookmarks.moveToBookmark, selection)
	      };
	    }
	    (function (BookmarkManager) {
	      BookmarkManager.isBookmarkNode = Bookmarks.isBookmarkNode;
	    }(BookmarkManager || (BookmarkManager = {})));
	    var BookmarkManager$1 = BookmarkManager;
	
	    var isContentEditableFalse$a = NodeType.isContentEditableFalse;
	    var isContentEditableTrue$5 = NodeType.isContentEditableTrue;
	    var getContentEditableRoot$2 = function (root, node) {
	      while (node && node !== root) {
	        if (isContentEditableTrue$5(node) || isContentEditableFalse$a(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var ControlSelection = function (selection, editor) {
	      var dom = editor.dom, each = Tools.each;
	      var selectedElm, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle;
	      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
	      var width, height;
	      var editableDoc = editor.getDoc(), rootDocument = domGlobals.document;
	      var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
	      var startScrollWidth, startScrollHeight;
	      resizeHandles = {
	        nw: [
	          0,
	          0,
	          -1,
	          -1
	        ],
	        ne: [
	          1,
	          0,
	          1,
	          -1
	        ],
	        se: [
	          1,
	          1,
	          1,
	          1
	        ],
	        sw: [
	          0,
	          1,
	          -1,
	          1
	        ]
	      };
	      var rootClass = '.mce-content-body';
	      editor.contentStyles.push(rootClass + ' div.mce-resizehandle {' + 'position: absolute;' + 'border: 1px solid black;' + 'box-sizing: content-box;' + 'background: #FFF;' + 'width: 7px;' + 'height: 7px;' + 'z-index: 10000' + '}' + rootClass + ' .mce-resizehandle:hover {' + 'background: #000' + '}' + rootClass + ' img[data-mce-selected],' + rootClass + ' hr[data-mce-selected] {' + 'outline: 1px solid black;' + 'resize: none' + '}' + rootClass + ' .mce-clonedresizable {' + 'position: absolute;' + (Env.gecko ? '' : 'outline: 1px dashed black;') + 'opacity: .5;' + 'filter: alpha(opacity=50);' + 'z-index: 10000' + '}' + rootClass + ' .mce-resize-helper {' + 'background: #555;' + 'background: rgba(0,0,0,0.75);' + 'border-radius: 3px;' + 'border: 1px;' + 'color: white;' + 'display: none;' + 'font-family: sans-serif;' + 'font-size: 12px;' + 'white-space: nowrap;' + 'line-height: 14px;' + 'margin: 5px 10px;' + 'padding: 5px;' + 'position: absolute;' + 'z-index: 10001' + '}');
	      var isImage = function (elm) {
	        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
	      };
	      var isEventOnImageOutsideRange = function (evt, range) {
	        return isImage(evt.target) && !RangePoint.isXYWithinRange(evt.clientX, evt.clientY, range);
	      };
	      var contextMenuSelectImage = function (evt) {
	        var target = evt.target;
	        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
	          editor.selection.select(target);
	        }
	      };
	      var getResizeTarget = function (elm) {
	        return editor.dom.is(elm, 'figure.image') ? elm.querySelector('img') : elm;
	      };
	      var isResizable = function (elm) {
	        var selector = editor.settings.object_resizing;
	        if (selector === false || Env.iOS) {
	          return false;
	        }
	        if (typeof selector !== 'string') {
	          selector = 'table,img,figure.image,div';
	        }
	        if (elm.getAttribute('data-mce-resize') === 'false') {
	          return false;
	        }
	        if (elm === editor.getBody()) {
	          return false;
	        }
	        return is$1(Element.fromDom(elm), selector);
	      };
	      var resizeGhostElement = function (e) {
	        var deltaX, deltaY, proportional;
	        var resizeHelperX, resizeHelperY;
	        deltaX = e.screenX - startX;
	        deltaY = e.screenY - startY;
	        width = deltaX * selectedHandle[2] + startW;
	        height = deltaY * selectedHandle[3] + startH;
	        width = width < 5 ? 5 : width;
	        height = height < 5 ? 5 : height;
	        if (isImage(selectedElm) && editor.settings.resize_img_proportional !== false) {
	          proportional = !VK.modifierPressed(e);
	        } else {
	          proportional = VK.modifierPressed(e) || isImage(selectedElm) && selectedHandle[2] * selectedHandle[3] !== 0;
	        }
	        if (proportional) {
	          if (abs(deltaX) > abs(deltaY)) {
	            height = round(width * ratio);
	            width = round(height / ratio);
	          } else {
	            width = round(height / ratio);
	            height = round(width * ratio);
	          }
	        }
	        dom.setStyles(getResizeTarget(selectedElmGhost), {
	          width: width,
	          height: height
	        });
	        resizeHelperX = selectedHandle.startPos.x + deltaX;
	        resizeHelperY = selectedHandle.startPos.y + deltaY;
	        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
	        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	        dom.setStyles(resizeHelper, {
	          left: resizeHelperX,
	          top: resizeHelperY,
	          display: 'block'
	        });
	        resizeHelper.innerHTML = width + ' &times; ' + height;
	        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
	          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
	        }
	        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
	          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
	        }
	        deltaX = rootElement.scrollWidth - startScrollWidth;
	        deltaY = rootElement.scrollHeight - startScrollHeight;
	        if (deltaX + deltaY !== 0) {
	          dom.setStyles(resizeHelper, {
	            left: resizeHelperX - deltaX,
	            top: resizeHelperY - deltaY
	          });
	        }
	        if (!resizeStarted) {
	          Events.fireObjectResizeStart(editor, selectedElm, startW, startH);
	          resizeStarted = true;
	        }
	      };
	      var endGhostResize = function () {
	        resizeStarted = false;
	        var setSizeProp = function (name, value) {
	          if (value) {
	            if (selectedElm.style[name] || !editor.schema.isValid(selectedElm.nodeName.toLowerCase(), name)) {
	              dom.setStyle(getResizeTarget(selectedElm), name, value);
	            } else {
	              dom.setAttrib(getResizeTarget(selectedElm), name, value);
	            }
	          }
	        };
	        setSizeProp('width', width);
	        setSizeProp('height', height);
	        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
	        dom.unbind(editableDoc, 'mouseup', endGhostResize);
	        if (rootDocument !== editableDoc) {
	          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
	          dom.unbind(rootDocument, 'mouseup', endGhostResize);
	        }
	        dom.remove(selectedElmGhost);
	        dom.remove(resizeHelper);
	        showResizeRect(selectedElm);
	        Events.fireObjectResized(editor, selectedElm, width, height);
	        dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
	        editor.nodeChanged();
	      };
	      var showResizeRect = function (targetElm) {
	        var position, targetWidth, targetHeight, e, rect;
	        hideResizeRect();
	        unbindResizeHandleEvents();
	        position = dom.getPos(targetElm, rootElement);
	        selectedElmX = position.x;
	        selectedElmY = position.y;
	        rect = targetElm.getBoundingClientRect();
	        targetWidth = rect.width || rect.right - rect.left;
	        targetHeight = rect.height || rect.bottom - rect.top;
	        if (selectedElm !== targetElm) {
	          selectedElm = targetElm;
	          width = height = 0;
	        }
	        e = editor.fire('ObjectSelected', { target: targetElm });
	        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
	          each(resizeHandles, function (handle, name) {
	            var handleElm;
	            var startDrag = function (e) {
	              startX = e.screenX;
	              startY = e.screenY;
	              startW = getResizeTarget(selectedElm).clientWidth;
	              startH = getResizeTarget(selectedElm).clientHeight;
	              ratio = startH / startW;
	              selectedHandle = handle;
	              handle.startPos = {
	                x: targetWidth * handle[0] + selectedElmX,
	                y: targetHeight * handle[1] + selectedElmY
	              };
	              startScrollWidth = rootElement.scrollWidth;
	              startScrollHeight = rootElement.scrollHeight;
	              selectedElmGhost = selectedElm.cloneNode(true);
	              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
	              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
	              selectedElmGhost.contentEditable = false;
	              selectedElmGhost.unSelectabe = true;
	              dom.setStyles(selectedElmGhost, {
	                left: selectedElmX,
	                top: selectedElmY,
	                margin: 0
	              });
	              selectedElmGhost.removeAttribute('data-mce-selected');
	              rootElement.appendChild(selectedElmGhost);
	              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
	              dom.bind(editableDoc, 'mouseup', endGhostResize);
	              if (rootDocument !== editableDoc) {
	                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
	                dom.bind(rootDocument, 'mouseup', endGhostResize);
	              }
	              resizeHelper = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-helper',
	                'data-mce-bogus': 'all'
	              }, startW + ' &times; ' + startH);
	            };
	            handleElm = dom.get('mceResizeHandle' + name);
	            if (handleElm) {
	              dom.remove(handleElm);
	            }
	            handleElm = dom.add(rootElement, 'div', {
	              'id': 'mceResizeHandle' + name,
	              'data-mce-bogus': 'all',
	              'class': 'mce-resizehandle',
	              'unselectable': true,
	              'style': 'cursor:' + name + '-resize; margin:0; padding:0'
	            });
	            if (Env.ie === 11) {
	              handleElm.contentEditable = false;
	            }
	            dom.bind(handleElm, 'mousedown', function (e) {
	              e.stopImmediatePropagation();
	              e.preventDefault();
	              startDrag(e);
	            });
	            handle.elm = handleElm;
	            dom.setStyles(handleElm, {
	              left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
	              top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
	            });
	          });
	        } else {
	          hideResizeRect();
	        }
	        selectedElm.setAttribute('data-mce-selected', '1');
	      };
	      var hideResizeRect = function () {
	        var name, handleElm;
	        unbindResizeHandleEvents();
	        if (selectedElm) {
	          selectedElm.removeAttribute('data-mce-selected');
	        }
	        for (name in resizeHandles) {
	          handleElm = dom.get('mceResizeHandle' + name);
	          if (handleElm) {
	            dom.unbind(handleElm);
	            dom.remove(handleElm);
	          }
	        }
	      };
	      var updateResizeRect = function (e) {
	        var startElm, controlElm;
	        var isChildOrEqual = function (node, parent) {
	          if (node) {
	            do {
	              if (node === parent) {
	                return true;
	              }
	            } while (node = node.parentNode);
	          }
	        };
	        if (resizeStarted || editor.removed) {
	          return;
	        }
	        each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
	          img.removeAttribute('data-mce-selected');
	        });
	        controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
	        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr')[0];
	        if (isChildOrEqual(controlElm, rootElement)) {
	          disableGeckoResize();
	          startElm = selection.getStart(true);
	          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
	            showResizeRect(controlElm);
	            return;
	          }
	        }
	        hideResizeRect();
	      };
	      var isWithinContentEditableFalse = function (elm) {
	        return isContentEditableFalse$a(getContentEditableRoot$2(editor.getBody(), elm));
	      };
	      var unbindResizeHandleEvents = function () {
	        for (var name in resizeHandles) {
	          var handle = resizeHandles[name];
	          if (handle.elm) {
	            dom.unbind(handle.elm);
	            delete handle.elm;
	          }
	        }
	      };
	      var disableGeckoResize = function () {
	        try {
	          editor.getDoc().execCommand('enableObjectResizing', false, false);
	        } catch (ex) {
	        }
	      };
	      editor.on('init', function () {
	        disableGeckoResize();
	        if (Env.ie && Env.ie >= 11) {
	          editor.on('mousedown click', function (e) {
	            var target = e.target, nodeName = target.nodeName;
	            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
	              if (e.button !== 2) {
	                editor.selection.select(target, nodeName === 'TABLE');
	              }
	              if (e.type === 'mousedown') {
	                editor.nodeChanged();
	              }
	            }
	          });
	          editor.dom.bind(rootElement, 'mscontrolselect', function (e) {
	            var delayedSelect = function (node) {
	              Delay.setEditorTimeout(editor, function () {
	                editor.selection.select(node);
	              });
	            };
	            if (isWithinContentEditableFalse(e.target)) {
	              e.preventDefault();
	              delayedSelect(e.target);
	              return;
	            }
	            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
	              e.preventDefault();
	              if (e.target.tagName === 'IMG') {
	                delayedSelect(e.target);
	              }
	            }
	          });
	        }
	        var throttledUpdateResizeRect = Delay.throttle(function (e) {
	          if (!editor.composing) {
	            updateResizeRect(e);
	          }
	        });
	        editor.on('nodechange ResizeEditor ResizeWindow drop FullscreenStateChanged', throttledUpdateResizeRect);
	        editor.on('keyup compositionend', function (e) {
	          if (selectedElm && selectedElm.nodeName === 'TABLE') {
	            throttledUpdateResizeRect(e);
	          }
	        });
	        editor.on('hide blur', hideResizeRect);
	        editor.on('contextmenu', contextMenuSelectImage);
	      });
	      editor.on('remove', unbindResizeHandleEvents);
	      var destroy = function () {
	        selectedElm = selectedElmGhost = null;
	      };
	      return {
	        isResizable: isResizable,
	        showResizeRect: showResizeRect,
	        hideResizeRect: hideResizeRect,
	        updateResizeRect: updateResizeRect,
	        destroy: destroy
	      };
	    };
	
	    var getPos$1 = function (elm) {
	      var x = 0, y = 0;
	      var offsetParent = elm;
	      while (offsetParent && offsetParent.nodeType) {
	        x += offsetParent.offsetLeft || 0;
	        y += offsetParent.offsetTop || 0;
	        offsetParent = offsetParent.offsetParent;
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var fireScrollIntoViewEvent = function (editor, elm, alignToTop) {
	      var scrollEvent = {
	        elm: elm,
	        alignToTop: alignToTop
	      };
	      editor.fire('scrollIntoView', scrollEvent);
	      return scrollEvent.isDefaultPrevented();
	    };
	    var scrollElementIntoView = function (editor, elm, alignToTop) {
	      var y, viewPort;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      var viewPortY, viewPortH, offsetY = 0;
	      if (fireScrollIntoViewEvent(editor, elm, alignToTop)) {
	        return;
	      }
	      if (!NodeType.isElement(elm)) {
	        return;
	      }
	      if (alignToTop === false) {
	        offsetY = elm.offsetHeight;
	      }
	      if (root.nodeName !== 'BODY') {
	        var scrollContainer = editor.selection.getScrollContainer();
	        if (scrollContainer) {
	          y = getPos$1(elm).y - getPos$1(scrollContainer).y + offsetY;
	          viewPortH = scrollContainer.clientHeight;
	          viewPortY = scrollContainer.scrollTop;
	          if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
	            scrollContainer.scrollTop = y < viewPortY ? y : y - viewPortH + 25;
	          }
	          return;
	        }
	      }
	      viewPort = dom.getViewPort(editor.getWin());
	      y = dom.getPos(elm).y + offsetY;
	      viewPortY = viewPort.y;
	      viewPortH = viewPort.h;
	      if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
	        editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25);
	      }
	    };
	    var getViewPortRect = function (editor) {
	      if (editor.inline) {
	        return editor.getBody().getBoundingClientRect();
	      } else {
	        var win = editor.getWin();
	        return {
	          left: 0,
	          right: win.innerWidth,
	          top: 0,
	          bottom: win.innerHeight,
	          width: win.innerWidth,
	          height: win.innerHeight
	        };
	      }
	    };
	    var scrollBy = function (editor, dx, dy) {
	      if (editor.inline) {
	        editor.getBody().scrollLeft += dx;
	        editor.getBody().scrollTop += dy;
	      } else {
	        editor.getWin().scrollBy(dx, dy);
	      }
	    };
	    var scrollRangeIntoView = function (editor, rng) {
	      head(CaretPosition.fromRangeStart(rng).getClientRects()).each(function (rngRect) {
	        var bodyRect = getViewPortRect(editor);
	        var overflow = getOverflow(bodyRect, rngRect);
	        var margin = 4;
	        var dx = overflow.x > 0 ? overflow.x + margin : overflow.x - margin;
	        var dy = overflow.y > 0 ? overflow.y + margin : overflow.y - margin;
	        scrollBy(editor, overflow.x !== 0 ? dx : 0, overflow.y !== 0 ? dy : 0);
	      });
	    };
	    var ScrollIntoView = {
	      scrollElementIntoView: scrollElementIntoView,
	      scrollRangeIntoView: scrollRangeIntoView
	    };
	
	    var hasCeProperty = function (node) {
	      return NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node);
	    };
	    var findParent$1 = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var findClosestIeRange = function (clientX, clientY, doc) {
	      var element, rng, rects;
	      element = doc.elementFromPoint(clientX, clientY);
	      rng = doc.body.createTextRange();
	      if (!element || element.tagName === 'HTML') {
	        element = doc.body;
	      }
	      rng.moveToElementText(element);
	      rects = Tools.toArray(rng.getClientRects());
	      rects = rects.sort(function (a, b) {
	        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
	        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	        return a - b;
	      });
	      if (rects.length > 0) {
	        clientY = (rects[0].bottom + rects[0].top) / 2;
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	          return rng;
	        } catch (ex) {
	        }
	      }
	      return null;
	    };
	    var moveOutOfContentEditableFalse = function (rng, rootNode) {
	      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
	      return NodeType.isContentEditableFalse(findParent$1(parentElement, rootNode, hasCeProperty)) ? null : rng;
	    };
	    var fromPoint$1 = function (clientX, clientY, doc) {
	      var rng, point;
	      var pointDoc = doc;
	      if (pointDoc.caretPositionFromPoint) {
	        point = pointDoc.caretPositionFromPoint(clientX, clientY);
	        if (point) {
	          rng = doc.createRange();
	          rng.setStart(point.offsetNode, point.offset);
	          rng.collapse(true);
	        }
	      } else if (doc.caretRangeFromPoint) {
	        rng = doc.caretRangeFromPoint(clientX, clientY);
	      } else if (pointDoc.body.createTextRange) {
	        rng = pointDoc.body.createTextRange();
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	        } catch (ex) {
	          rng = findClosestIeRange(clientX, clientY, doc);
	        }
	        return moveOutOfContentEditableFalse(rng, doc.body);
	      }
	      return rng;
	    };
	    var CaretRangeFromPoint = { fromPoint: fromPoint$1 };
	
	    var processRanges = function (editor, ranges) {
	      return map(ranges, function (range) {
	        var evt = editor.fire('GetSelectionRange', { range: range });
	        return evt.range !== range ? evt.range : range;
	      });
	    };
	    var EventProcessRanges = { processRanges: processRanges };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || domGlobals.document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom());
	      });
	      return Element.fromDom(fragment);
	    };
	
	    var tableModel = Immutable('element', 'width', 'rows');
	    var tableRow = Immutable('element', 'cells');
	    var cellPosition = Immutable('x', 'y');
	    var getSpan = function (td, key) {
	      var value = parseInt(get(td, key), 10);
	      return isNaN(value) ? 1 : value;
	    };
	    var fillout = function (table, x, y, tr, td) {
	      var rowspan = getSpan(td, 'rowspan');
	      var colspan = getSpan(td, 'colspan');
	      var rows = table.rows();
	      for (var y2 = y; y2 < y + rowspan; y2++) {
	        if (!rows[y2]) {
	          rows[y2] = tableRow(deep(tr), []);
	        }
	        for (var x2 = x; x2 < x + colspan; x2++) {
	          var cells = rows[y2].cells();
	          cells[x2] = y2 === y && x2 === x ? td : shallow(td);
	        }
	      }
	    };
	    var cellExists = function (table, x, y) {
	      var rows = table.rows();
	      var cells = rows[y] ? rows[y].cells() : [];
	      return !!cells[x];
	    };
	    var skipCellsX = function (table, x, y) {
	      while (cellExists(table, x, y)) {
	        x++;
	      }
	      return x;
	    };
	    var getWidth = function (rows) {
	      return foldl(rows, function (acc, row) {
	        return row.cells().length > acc ? row.cells().length : acc;
	      }, 0);
	    };
	    var findElementPos = function (table, element) {
	      var rows = table.rows();
	      for (var y = 0; y < rows.length; y++) {
	        var cells = rows[y].cells();
	        for (var x = 0; x < cells.length; x++) {
	          if (eq(cells[x], element)) {
	            return Option.some(cellPosition(x, y));
	          }
	        }
	      }
	      return Option.none();
	    };
	    var extractRows = function (table, sx, sy, ex, ey) {
	      var newRows = [];
	      var rows = table.rows();
	      for (var y = sy; y <= ey; y++) {
	        var cells = rows[y].cells();
	        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
	        newRows.push(tableRow(rows[y].element(), slice));
	      }
	      return newRows;
	    };
	    var subTable = function (table, startPos, endPos) {
	      var sx = startPos.x(), sy = startPos.y();
	      var ex = endPos.x(), ey = endPos.y();
	      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
	      return tableModel(table.element(), getWidth(newRows), newRows);
	    };
	    var createDomTable = function (table, rows) {
	      var tableElement = shallow(table.element());
	      var tableBody = Element.fromTag('tbody');
	      append$1(tableBody, rows);
	      append(tableElement, tableBody);
	      return tableElement;
	    };
	    var modelRowsToDomRows = function (table) {
	      return map(table.rows(), function (row) {
	        var cells = map(row.cells(), function (cell) {
	          var td = deep(cell);
	          remove(td, 'colspan');
	          remove(td, 'rowspan');
	          return td;
	        });
	        var tr = shallow(row.element());
	        append$1(tr, cells);
	        return tr;
	      });
	    };
	    var fromDom$1 = function (tableElm) {
	      var table = tableModel(shallow(tableElm), 0, []);
	      each(descendants$1(tableElm, 'tr'), function (tr, y) {
	        each(descendants$1(tr, 'td,th'), function (td, x) {
	          fillout(table, skipCellsX(table, x, y), y, tr, td);
	        });
	      });
	      return tableModel(table.element(), getWidth(table.rows()), table.rows());
	    };
	    var toDom = function (table) {
	      return createDomTable(table, modelRowsToDomRows(table));
	    };
	    var subsection = function (table, startElement, endElement) {
	      return findElementPos(table, startElement).bind(function (startPos) {
	        return findElementPos(table, endElement).map(function (endPos) {
	          return subTable(table, startPos, endPos);
	        });
	      });
	    };
	    var SimpleTableModel = {
	      fromDom: fromDom$1,
	      toDom: toDom,
	      subsection: subsection
	    };
	
	    var findParentListContainer = function (parents) {
	      return find(parents, function (elm) {
	        return name(elm) === 'ul' || name(elm) === 'ol';
	      });
	    };
	    var getFullySelectedListWrappers = function (parents, rng) {
	      return find(parents, function (elm) {
	        return name(elm) === 'li' && hasAllContentsSelected(elm, rng);
	      }).fold(constant([]), function (li) {
	        return findParentListContainer(parents).map(function (listCont) {
	          return [
	            Element.fromTag('li'),
	            Element.fromTag(name(listCont))
	          ];
	        }).getOr([]);
	      });
	    };
	    var wrap$3 = function (innerElm, elms) {
	      var wrapped = foldl(elms, function (acc, elm) {
	        append(elm, acc);
	        return elm;
	      }, innerElm);
	      return elms.length > 0 ? fromElements([wrapped]) : wrapped;
	    };
	    var directListWrappers = function (commonAnchorContainer) {
	      if (isListItem(commonAnchorContainer)) {
	        return parent(commonAnchorContainer).filter(isList).fold(constant([]), function (listElm) {
	          return [
	            commonAnchorContainer,
	            listElm
	          ];
	        });
	      } else {
	        return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
	      }
	    };
	    var getWrapElements = function (rootNode, rng) {
	      var commonAnchorContainer = Element.fromDom(rng.commonAncestorContainer);
	      var parents = Parents.parentsAndSelf(commonAnchorContainer, rootNode);
	      var wrapElements = filter(parents, function (elm) {
	        return isInline(elm) || isHeading(elm);
	      });
	      var listWrappers = getFullySelectedListWrappers(parents, rng);
	      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
	      return map(allWrappers, shallow);
	    };
	    var emptyFragment = function () {
	      return fromElements([]);
	    };
	    var getFragmentFromRange = function (rootNode, rng) {
	      return wrap$3(Element.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
	    };
	    var getParentTable = function (rootElm, cell) {
	      return ancestor$1(cell, 'table', curry(eq, rootElm));
	    };
	    var getTableFragment = function (rootNode, selectedTableCells) {
	      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
	        var firstCell = selectedTableCells[0];
	        var lastCell = selectedTableCells[selectedTableCells.length - 1];
	        var fullTableModel = SimpleTableModel.fromDom(tableElm);
	        return SimpleTableModel.subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
	          return fromElements([SimpleTableModel.toDom(sectionedTableModel)]);
	        });
	      }).getOrThunk(emptyFragment);
	    };
	    var getSelectionFragment = function (rootNode, ranges) {
	      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
	    };
	    var read$4 = function (rootNode, ranges) {
	      var selectedCells = TableCellSelection.getCellsFromElementOrRanges(ranges, rootNode);
	      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
	    };
	    var FragmentReader = { read: read$4 };
	
	    var getTextContent = function (editor) {
	      return Option.from(editor.selection.getRng()).map(function (rng) {
	        var bin = editor.dom.add(editor.getBody(), 'div', {
	          'data-mce-bogus': 'all',
	          'style': 'overflow: hidden; opacity: 0;'
	        }, rng.cloneContents());
	        var text = Zwsp.trim(bin.innerText);
	        editor.dom.remove(bin);
	        return text;
	      }).getOr('');
	    };
	    var getHtmlContent = function (editor, args) {
	      var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
	      var sel = editor.selection.getSel();
	      var fragment;
	      var ranges = EventProcessRanges.processRanges(editor, MultiRange.getRanges(sel));
	      fragment = args.contextual ? FragmentReader.read(Element.fromDom(editor.getBody()), ranges).dom() : rng.cloneContents();
	      if (fragment) {
	        tmpElm.appendChild(fragment);
	      }
	      return editor.selection.serializer.serialize(tmpElm, args);
	    };
	    var getContent = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      args.get = true;
	      args.format = args.format || 'html';
	      args.selection = true;
	      args = editor.fire('BeforeGetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('GetContent', args);
	        return args.content;
	      }
	      if (args.format === 'text') {
	        return getTextContent(editor);
	      } else {
	        args.getInner = true;
	        var content = getHtmlContent(editor, args);
	        if (args.format === 'tree') {
	          return content;
	        } else {
	          args.content = editor.selection.isCollapsed() ? '' : content;
	          editor.fire('GetContent', args);
	          return args.content;
	        }
	      }
	    };
	    var GetSelectionContent = { getContent: getContent };
	
	    var setContent = function (editor, content, args) {
	      var rng = editor.selection.getRng(), caretNode;
	      var doc = editor.getDoc();
	      var frag, temp;
	      args = args || { format: 'html' };
	      args.set = true;
	      args.selection = true;
	      args.content = content;
	      if (!args.no_events) {
	        args = editor.fire('BeforeSetContent', args);
	        if (args.isDefaultPrevented()) {
	          editor.fire('SetContent', args);
	          return;
	        }
	      }
	      content = args.content;
	      if (rng.insertNode) {
	        content += '<span id="__caret">_</span>';
	        if (rng.startContainer === doc && rng.endContainer === doc) {
	          doc.body.innerHTML = content;
	        } else {
	          rng.deleteContents();
	          if (doc.body.childNodes.length === 0) {
	            doc.body.innerHTML = content;
	          } else {
	            if (rng.createContextualFragment) {
	              rng.insertNode(rng.createContextualFragment(content));
	            } else {
	              frag = doc.createDocumentFragment();
	              temp = doc.createElement('div');
	              frag.appendChild(temp);
	              temp.outerHTML = content;
	              rng.insertNode(frag);
	            }
	          }
	        }
	        caretNode = editor.dom.get('__caret');
	        rng = doc.createRange();
	        rng.setStartBefore(caretNode);
	        rng.setEndBefore(caretNode);
	        editor.selection.setRng(rng);
	        editor.dom.remove('__caret');
	        try {
	          editor.selection.setRng(rng);
	        } catch (ex) {
	        }
	      } else {
	        if (rng.item) {
	          doc.execCommand('Delete', false, null);
	          rng = editor.getRng();
	        }
	        if (/^\s+/.test(content)) {
	          rng.pasteHTML('<span id="__mce_tmp">_</span>' + content);
	          editor.dom.remove('__mce_tmp');
	        } else {
	          rng.pasteHTML(content);
	        }
	      }
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	    };
	    var SetSelectionContent = { setContent: setContent };
	
	    var getEndpointElement = function (root, rng, start, real, resolve) {
	      var container = start ? rng.startContainer : rng.endContainer;
	      var offset = start ? rng.startOffset : rng.endOffset;
	      return Option.from(container).map(Element.fromDom).map(function (elm) {
	        return !real || !rng.collapsed ? child(elm, resolve(elm, offset)).getOr(elm) : elm;
	      }).bind(function (elm) {
	        return isElement(elm) ? Option.some(elm) : parent(elm);
	      }).map(function (elm) {
	        return elm.dom();
	      }).getOr(root);
	    };
	    var getStart$2 = function (root, rng, real) {
	      return getEndpointElement(root, rng, true, real, function (elm, offset) {
	        return Math.min(childNodesCount(elm), offset);
	      });
	    };
	    var getEnd = function (root, rng, real) {
	      return getEndpointElement(root, rng, false, real, function (elm, offset) {
	        return offset > 0 ? offset - 1 : offset;
	      });
	    };
	    var skipEmptyTextNodes = function (node, forwards) {
	      var orig = node;
	      while (node && NodeType.isText(node) && node.length === 0) {
	        node = forwards ? node.nextSibling : node.previousSibling;
	      }
	      return node || orig;
	    };
	    var getNode$1 = function (root, rng) {
	      var elm, startContainer, endContainer, startOffset, endOffset;
	      if (!rng) {
	        return root;
	      }
	      startContainer = rng.startContainer;
	      endContainer = rng.endContainer;
	      startOffset = rng.startOffset;
	      endOffset = rng.endOffset;
	      elm = rng.commonAncestorContainer;
	      if (!rng.collapsed) {
	        if (startContainer === endContainer) {
	          if (endOffset - startOffset < 2) {
	            if (startContainer.hasChildNodes()) {
	              elm = startContainer.childNodes[startOffset];
	            }
	          }
	        }
	        if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
	          if (startContainer.length === startOffset) {
	            startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
	          } else {
	            startContainer = startContainer.parentNode;
	          }
	          if (endOffset === 0) {
	            endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
	          } else {
	            endContainer = endContainer.parentNode;
	          }
	          if (startContainer && startContainer === endContainer) {
	            return startContainer;
	          }
	        }
	      }
	      if (elm && elm.nodeType === 3) {
	        return elm.parentNode;
	      }
	      return elm;
	    };
	    var getSelectedBlocks = function (dom, rng, startElm, endElm) {
	      var node, root;
	      var selectedBlocks = [];
	      root = dom.getRoot();
	      startElm = dom.getParent(startElm || getStart$2(root, rng, rng.collapsed), dom.isBlock);
	      endElm = dom.getParent(endElm || getEnd(root, rng, rng.collapsed), dom.isBlock);
	      if (startElm && startElm !== root) {
	        selectedBlocks.push(startElm);
	      }
	      if (startElm && endElm && startElm !== endElm) {
	        node = startElm;
	        var walker = new TreeWalker(startElm, root);
	        while ((node = walker.next()) && node !== endElm) {
	          if (dom.isBlock(node)) {
	            selectedBlocks.push(node);
	          }
	        }
	      }
	      if (endElm && startElm !== endElm && endElm !== root) {
	        selectedBlocks.push(endElm);
	      }
	      return selectedBlocks;
	    };
	    var select$1 = function (dom, node, content) {
	      return Option.from(node).map(function (node) {
	        var idx = dom.nodeIndex(node);
	        var rng = dom.createRng();
	        rng.setStart(node.parentNode, idx);
	        rng.setEnd(node.parentNode, idx + 1);
	        if (content) {
	          moveEndPoint$1(dom, rng, node, true);
	          moveEndPoint$1(dom, rng, node, false);
	        }
	        return rng;
	      });
	    };
	
	    var each$j = Tools.each;
	    var isNativeIeSelection = function (rng) {
	      return !!rng.select;
	    };
	    var isAttachedToDom = function (node) {
	      return !!(node && node.ownerDocument) && contains$3(Element.fromDom(node.ownerDocument), Element.fromDom(node));
	    };
	    var isValidRange = function (rng) {
	      if (!rng) {
	        return false;
	      } else if (isNativeIeSelection(rng)) {
	        return true;
	      } else {
	        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
	      }
	    };
	    var Selection$1 = function (dom, win, serializer, editor) {
	      var bookmarkManager, controlSelection;
	      var selectedRange, explicitRange, selectorChangedData;
	      var setCursorLocation = function (node, offset) {
	        var rng = dom.createRng();
	        if (!node) {
	          moveEndPoint$1(dom, rng, editor.getBody(), true);
	          setRng(rng);
	        } else {
	          rng.setStart(node, offset);
	          rng.setEnd(node, offset);
	          setRng(rng);
	          collapse(false);
	        }
	      };
	      var getContent = function (args) {
	        return GetSelectionContent.getContent(editor, args);
	      };
	      var setContent = function (content, args) {
	        return SetSelectionContent.setContent(editor, content, args);
	      };
	      var getStart = function (real) {
	        return getStart$2(editor.getBody(), getRng(), real);
	      };
	      var getEnd$1 = function (real) {
	        return getEnd(editor.getBody(), getRng(), real);
	      };
	      var getBookmark = function (type, normalized) {
	        return bookmarkManager.getBookmark(type, normalized);
	      };
	      var moveToBookmark = function (bookmark) {
	        return bookmarkManager.moveToBookmark(bookmark);
	      };
	      var select = function (node, content) {
	        select$1(dom, node, content).each(setRng);
	        return node;
	      };
	      var isCollapsed = function () {
	        var rng = getRng(), sel = getSel();
	        if (!rng || rng.item) {
	          return false;
	        }
	        if (rng.compareEndPoints) {
	          return rng.compareEndPoints('StartToEnd', rng) === 0;
	        }
	        return !sel || rng.collapsed;
	      };
	      var collapse = function (toStart) {
	        var rng = getRng();
	        rng.collapse(!!toStart);
	        setRng(rng);
	      };
	      var getSel = function () {
	        return win.getSelection ? win.getSelection() : win.document.selection;
	      };
	      var getRng = function () {
	        var selection, rng, elm, doc;
	        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
	          try {
	            return sourceRange.compareBoundaryPoints(how, destinationRange);
	          } catch (ex) {
	            return -1;
	          }
	        };
	        if (!win) {
	          return null;
	        }
	        doc = win.document;
	        if (typeof doc === 'undefined' || doc === null) {
	          return null;
	        }
	        if (editor.bookmark !== undefined && EditorFocus.hasFocus(editor) === false) {
	          var bookmark = SelectionBookmark.getRng(editor);
	          if (bookmark.isSome()) {
	            return bookmark.map(function (r) {
	              return EventProcessRanges.processRanges(editor, [r])[0];
	            }).getOr(doc.createRange());
	          }
	        }
	        try {
	          if ((selection = getSel()) && !NodeType.isRestrictedNode(selection.anchorNode)) {
	            if (selection.rangeCount > 0) {
	              rng = selection.getRangeAt(0);
	            } else {
	              rng = selection.createRange ? selection.createRange() : doc.createRange();
	            }
	          }
	        } catch (ex) {
	        }
	        rng = EventProcessRanges.processRanges(editor, [rng])[0];
	        if (!rng) {
	          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
	        }
	        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
	          elm = dom.getRoot();
	          rng.setStart(elm, 0);
	          rng.setEnd(elm, 0);
	        }
	        if (selectedRange && explicitRange) {
	          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
	            rng = explicitRange;
	          } else {
	            selectedRange = null;
	            explicitRange = null;
	          }
	        }
	        return rng;
	      };
	      var setRng = function (rng, forward) {
	        var sel, node, evt;
	        if (!isValidRange(rng)) {
	          return;
	        }
	        var ieRange = isNativeIeSelection(rng) ? rng : null;
	        if (ieRange) {
	          explicitRange = null;
	          try {
	            ieRange.select();
	          } catch (ex) {
	          }
	          return;
	        }
	        sel = getSel();
	        evt = editor.fire('SetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	        rng = evt.range;
	        if (sel) {
	          explicitRange = rng;
	          try {
	            sel.removeAllRanges();
	            sel.addRange(rng);
	          } catch (ex) {
	          }
	          if (forward === false && sel.extend) {
	            sel.collapse(rng.endContainer, rng.endOffset);
	            sel.extend(rng.startContainer, rng.startOffset);
	          }
	          selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
	        }
	        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
	          if (rng.endOffset - rng.startOffset < 2) {
	            if (rng.startContainer.hasChildNodes()) {
	              node = rng.startContainer.childNodes[rng.startOffset];
	              if (node && node.tagName === 'IMG') {
	                sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
	                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
	                  sel.setBaseAndExtent(node, 0, node, 1);
	                }
	              }
	            }
	          }
	        }
	        editor.fire('AfterSetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	      };
	      var setNode = function (elm) {
	        setContent(dom.getOuterHTML(elm));
	        return elm;
	      };
	      var getNode = function () {
	        return getNode$1(editor.getBody(), getRng());
	      };
	      var getSelectedBlocks$1 = function (startElm, endElm) {
	        return getSelectedBlocks(dom, getRng(), startElm, endElm);
	      };
	      var isForward = function () {
	        var sel = getSel();
	        var anchorRange, focusRange;
	        if (!sel || !sel.anchorNode || !sel.focusNode) {
	          return true;
	        }
	        anchorRange = dom.createRng();
	        anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
	        anchorRange.collapse(true);
	        focusRange = dom.createRng();
	        focusRange.setStart(sel.focusNode, sel.focusOffset);
	        focusRange.collapse(true);
	        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
	      };
	      var normalize = function () {
	        var rng = getRng();
	        var sel = getSel();
	        if (!MultiRange.hasMultipleRanges(sel) && hasAnyRanges(editor)) {
	          var normRng = NormalizeRange.normalize(dom, rng);
	          normRng.each(function (normRng) {
	            setRng(normRng, isForward());
	          });
	          return normRng.getOr(rng);
	        }
	        return rng;
	      };
	      var selectorChanged = function (selector, callback) {
	        var currentSelectors;
	        if (!selectorChangedData) {
	          selectorChangedData = {};
	          currentSelectors = {};
	          editor.on('NodeChange', function (e) {
	            var node = e.element, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
	            each$j(selectorChangedData, function (callbacks, selector) {
	              each$j(parents, function (node) {
	                if (dom.is(node, selector)) {
	                  if (!currentSelectors[selector]) {
	                    each$j(callbacks, function (callback) {
	                      callback(true, {
	                        node: node,
	                        selector: selector,
	                        parents: parents
	                      });
	                    });
	                    currentSelectors[selector] = callbacks;
	                  }
	                  matchedSelectors[selector] = callbacks;
	                  return false;
	                }
	              });
	            });
	            each$j(currentSelectors, function (callbacks, selector) {
	              if (!matchedSelectors[selector]) {
	                delete currentSelectors[selector];
	                each$j(callbacks, function (callback) {
	                  callback(false, {
	                    node: node,
	                    selector: selector,
	                    parents: parents
	                  });
	                });
	              }
	            });
	          });
	        }
	        if (!selectorChangedData[selector]) {
	          selectorChangedData[selector] = [];
	        }
	        selectorChangedData[selector].push(callback);
	        return exports;
	      };
	      var getScrollContainer = function () {
	        var scrollContainer;
	        var node = dom.getRoot();
	        while (node && node.nodeName !== 'BODY') {
	          if (node.scrollHeight > node.clientHeight) {
	            scrollContainer = node;
	            break;
	          }
	          node = node.parentNode;
	        }
	        return scrollContainer;
	      };
	      var scrollIntoView = function (elm, alignToTop) {
	        return ScrollIntoView.scrollElementIntoView(editor, elm, alignToTop);
	      };
	      var placeCaretAt = function (clientX, clientY) {
	        return setRng(CaretRangeFromPoint.fromPoint(clientX, clientY, editor.getDoc()));
	      };
	      var getBoundingClientRect = function () {
	        var rng = getRng();
	        return rng.collapsed ? CaretPosition$1.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
	      };
	      var destroy = function () {
	        win = selectedRange = explicitRange = null;
	        controlSelection.destroy();
	      };
	      var exports = {
	        bookmarkManager: null,
	        controlSelection: null,
	        dom: dom,
	        win: win,
	        serializer: serializer,
	        editor: editor,
	        collapse: collapse,
	        setCursorLocation: setCursorLocation,
	        getContent: getContent,
	        setContent: setContent,
	        getBookmark: getBookmark,
	        moveToBookmark: moveToBookmark,
	        select: select,
	        isCollapsed: isCollapsed,
	        isForward: isForward,
	        setNode: setNode,
	        getNode: getNode,
	        getSel: getSel,
	        setRng: setRng,
	        getRng: getRng,
	        getStart: getStart,
	        getEnd: getEnd$1,
	        getSelectedBlocks: getSelectedBlocks$1,
	        normalize: normalize,
	        selectorChanged: selectorChanged,
	        getScrollContainer: getScrollContainer,
	        scrollIntoView: scrollIntoView,
	        placeCaretAt: placeCaretAt,
	        getBoundingClientRect: getBoundingClientRect,
	        destroy: destroy
	      };
	      bookmarkManager = BookmarkManager$1(exports);
	      controlSelection = ControlSelection(exports, editor);
	      exports.bookmarkManager = bookmarkManager;
	      exports.controlSelection = controlSelection;
	      return exports;
	    };
	
	    var BreakType;
	    (function (BreakType) {
	      BreakType[BreakType['Br'] = 0] = 'Br';
	      BreakType[BreakType['Block'] = 1] = 'Block';
	      BreakType[BreakType['Wrap'] = 2] = 'Wrap';
	      BreakType[BreakType['Eol'] = 3] = 'Eol';
	    }(BreakType || (BreakType = {})));
	    var flip = function (direction, positions) {
	      return direction === HDirection.Backwards ? positions.reverse() : positions;
	    };
	    var walk$3 = function (direction, caretWalker, pos) {
	      return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
	    };
	    var getBreakType = function (scope, direction, currentPos, nextPos) {
	      if (NodeType.isBr(nextPos.getNode(direction === HDirection.Forwards))) {
	        return BreakType.Br;
	      } else if (isInSameBlock(currentPos, nextPos) === false) {
	        return BreakType.Block;
	      } else {
	        return BreakType.Wrap;
	      }
	    };
	    var getPositionsUntil = function (predicate, direction, scope, start) {
	      var caretWalker = CaretWalker(scope);
	      var currentPos = start, nextPos;
	      var positions = [];
	      while (currentPos) {
	        nextPos = walk$3(direction, caretWalker, currentPos);
	        if (!nextPos) {
	          break;
	        }
	        if (NodeType.isBr(nextPos.getNode(false))) {
	          if (direction === HDirection.Forwards) {
	            return {
	              positions: flip(direction, positions).concat([nextPos]),
	              breakType: BreakType.Br,
	              breakAt: Option.some(nextPos)
	            };
	          } else {
	            return {
	              positions: flip(direction, positions),
	              breakType: BreakType.Br,
	              breakAt: Option.some(nextPos)
	            };
	          }
	        }
	        if (!nextPos.isVisible()) {
	          currentPos = nextPos;
	          continue;
	        }
	        if (predicate(currentPos, nextPos)) {
	          var breakType = getBreakType(scope, direction, currentPos, nextPos);
	          return {
	            positions: flip(direction, positions),
	            breakType: breakType,
	            breakAt: Option.some(nextPos)
	          };
	        }
	        positions.push(nextPos);
	        currentPos = nextPos;
	      }
	      return {
	        positions: flip(direction, positions),
	        breakType: BreakType.Eol,
	        breakAt: Option.none()
	      };
	    };
	    var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
	      return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
	        var positions = getPositionsUntilBreak(scope, pos).positions;
	        return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
	      }).getOr([]);
	    };
	    var findClosestHorizontalPositionFromPoint = function (positions, x) {
	      return foldl(positions, function (acc, newPos) {
	        return acc.fold(function () {
	          return Option.some(newPos);
	        }, function (lastPos) {
	          return lift2(head(lastPos.getClientRects()), head(newPos.getClientRects()), function (lastRect, newRect) {
	            var lastDist = Math.abs(x - lastRect.left);
	            var newDist = Math.abs(x - newRect.left);
	            return newDist <= lastDist ? newPos : lastPos;
	          }).or(acc);
	        });
	      }, Option.none());
	    };
	    var findClosestHorizontalPosition = function (positions, pos) {
	      return head(pos.getClientRects()).bind(function (targetRect) {
	        return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
	      });
	    };
	    var getPositionsUntilPreviousLine = curry(getPositionsUntil, CaretPosition.isAbove, -1);
	    var getPositionsUntilNextLine = curry(getPositionsUntil, CaretPosition.isBelow, 1);
	    var isAtFirstLine = function (scope, pos) {
	      return getPositionsUntilPreviousLine(scope, pos).breakAt.isNone();
	    };
	    var isAtLastLine = function (scope, pos) {
	      return getPositionsUntilNextLine(scope, pos).breakAt.isNone();
	    };
	    var getPositionsAbove = curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
	    var getPositionsBelow = curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
	    var getFirstLinePositions = function (scope) {
	      return CaretFinder.firstPositionIn(scope).map(function (pos) {
	        return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
	      }).getOr([]);
	    };
	    var getLastLinePositions = function (scope) {
	      return CaretFinder.lastPositionIn(scope).map(function (pos) {
	        return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
	      }).getOr([]);
	    };
	
	    var isContentEditableFalse$b = NodeType.isContentEditableFalse;
	    var getSelectedNode$1 = getSelectedNode;
	    var moveToCeFalseHorizontally = function (direction, editor, getNextPosFn, range) {
	      var forwards = direction === HDirection.Forwards;
	      var isBeforeContentEditableFalseFn = forwards ? isBeforeContentEditableFalse : isAfterContentEditableFalse;
	      if (!range.collapsed) {
	        var node = getSelectedNode$1(range);
	        if (isContentEditableFalse$b(node)) {
	          return showCaret(direction, editor, node, direction === HDirection.Backwards, true);
	        }
	      }
	      var rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      if (isBeforeContentEditableFalseFn(caretPosition)) {
	        return selectNode(editor, caretPosition.getNode(!forwards));
	      }
	      var nextCaretPosition = InlineUtils.normalizePosition(forwards, getNextPosFn(caretPosition));
	      if (!nextCaretPosition) {
	        if (rangeIsInContainerBlock) {
	          return range;
	        }
	        return null;
	      }
	      if (isBeforeContentEditableFalseFn(nextCaretPosition)) {
	        return showCaret(direction, editor, nextCaretPosition.getNode(!forwards), forwards, true);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeContentEditableFalseFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, true);
	        }
	      }
	      if (rangeIsInContainerBlock) {
	        return renderRangeCaret(editor, nextCaretPosition.toRange(), true);
	      }
	      return null;
	    };
	    var moveToCeFalseVertically = function (direction, editor, walkerFn, range) {
	      var caretPosition, linePositions, nextLinePositions;
	      var closestNextLineRect, caretClientRect, clientX;
	      var dist1, dist2, contentEditableFalseNode;
	      contentEditableFalseNode = getSelectedNode$1(range);
	      caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
	      nextLinePositions = filter(linePositions, isLine(1));
	      caretClientRect = ArrUtils.last(caretPosition.getClientRects());
	      if (isBeforeContentEditableFalse(caretPosition) || isBeforeTable(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode();
	      }
	      if (isAfterContentEditableFalse(caretPosition) || isAfterTable(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode(true);
	      }
	      if (!caretClientRect) {
	        return null;
	      }
	      clientX = caretClientRect.left;
	      closestNextLineRect = findClosestClientRect(nextLinePositions, clientX);
	      if (closestNextLineRect) {
	        if (isContentEditableFalse$b(closestNextLineRect.node)) {
	          dist1 = Math.abs(clientX - closestNextLineRect.left);
	          dist2 = Math.abs(clientX - closestNextLineRect.right);
	          return showCaret(direction, editor, closestNextLineRect.node, dist1 < dist2, true);
	        }
	      }
	      if (contentEditableFalseNode) {
	        var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), contentEditableFalseNode);
	        closestNextLineRect = findClosestClientRect(filter(caretPositions, isLine(1)), clientX);
	        if (closestNextLineRect) {
	          return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
	        }
	        closestNextLineRect = ArrUtils.last(filter(caretPositions, isLine(0)));
	        if (closestNextLineRect) {
	          return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
	        }
	      }
	    };
	    var createTextBlock = function (editor) {
	      var textBlock = editor.dom.create(Settings.getForcedRootBlock(editor));
	      if (!Env.ie || Env.ie >= 11) {
	        textBlock.innerHTML = '<br data-mce-bogus="1">';
	      }
	      return textBlock;
	    };
	    var exitPreBlock = function (editor, direction, range) {
	      var pre, caretPos, newBlock;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      if (range.collapsed && editor.settings.forced_root_block) {
	        pre = editor.dom.getParent(range.startContainer, 'PRE');
	        if (!pre) {
	          return;
	        }
	        if (direction === 1) {
	          caretPos = getNextVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
	        } else {
	          caretPos = getPrevVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
	        }
	        if (!caretPos) {
	          newBlock = createTextBlock(editor);
	          if (direction === 1) {
	            editor.$(pre).after(newBlock);
	          } else {
	            editor.$(pre).before(newBlock);
	          }
	          editor.selection.select(newBlock, true);
	          editor.selection.collapse();
	        }
	      }
	    };
	    var getHorizontalRange = function (editor, forward) {
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev);
	      var newRange;
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
	      var range = editor.selection.getRng();
	      newRange = moveToCeFalseHorizontally(direction, editor, getNextPosFn, range);
	      if (newRange) {
	        return newRange;
	      }
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	      return null;
	    };
	    var getVerticalRange = function (editor, down) {
	      var newRange;
	      var direction = down ? 1 : -1;
	      var walkerFn = down ? downUntil : upUntil;
	      var range = editor.selection.getRng();
	      newRange = moveToCeFalseVertically(direction, editor, walkerFn, range);
	      if (newRange) {
	        return newRange;
	      }
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	      return null;
	    };
	    var moveH = function (editor, forward) {
	      return function () {
	        var newRng = getHorizontalRange(editor, forward);
	        if (newRng) {
	          editor.selection.setRng(newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	    var moveV = function (editor, down) {
	      return function () {
	        var newRng = getVerticalRange(editor, down);
	        if (newRng) {
	          editor.selection.setRng(newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	    var isCefPosition = function (forward) {
	      return function (pos) {
	        return forward ? isAfterContentEditableFalse(pos) : isBeforeContentEditableFalse(pos);
	      };
	    };
	    var moveToLineEndPoint = function (editor, forward) {
	      return function () {
	        var from = forward ? CaretPosition$1.fromRangeEnd(editor.selection.getRng()) : CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        var result = forward ? getPositionsUntilNextLine(editor.getBody(), from) : getPositionsUntilPreviousLine(editor.getBody(), from);
	        var to = forward ? last(result.positions) : head(result.positions);
	        return to.filter(isCefPosition(forward)).fold(constant(false), function (pos) {
	          editor.selection.setRng(pos.toRange());
	          return true;
	        });
	      };
	    };
	
	    var deflate = function (rect, delta) {
	      return {
	        left: rect.left - delta,
	        top: rect.top - delta,
	        right: rect.right + delta * 2,
	        bottom: rect.bottom + delta * 2,
	        width: rect.width + delta,
	        height: rect.height + delta
	      };
	    };
	    var getCorners = function (getYAxisValue, tds) {
	      return bind(tds, function (td) {
	        var rect = deflate(clone$1(td.getBoundingClientRect()), -1);
	        return [
	          {
	            x: rect.left,
	            y: getYAxisValue(rect),
	            cell: td
	          },
	          {
	            x: rect.right,
	            y: getYAxisValue(rect),
	            cell: td
	          }
	        ];
	      });
	    };
	    var findClosestCorner = function (corners, x, y) {
	      return foldl(corners, function (acc, newCorner) {
	        return acc.fold(function () {
	          return Option.some(newCorner);
	        }, function (oldCorner) {
	          var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
	          var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
	          return Option.some(newDist < oldDist ? newCorner : oldCorner);
	        });
	      }, Option.none());
	    };
	    var getClosestCell$1 = function (getYAxisValue, isTargetCorner, table, x, y) {
	      var cells = descendants$1(Element.fromDom(table), 'td,th,caption').map(function (e) {
	        return e.dom();
	      });
	      var corners = filter(getCorners(getYAxisValue, cells), function (corner) {
	        return isTargetCorner(corner, y);
	      });
	      return findClosestCorner(corners, x, y).map(function (corner) {
	        return corner.cell;
	      });
	    };
	    var getBottomValue = function (rect) {
	      return rect.bottom;
	    };
	    var getTopValue = function (rect) {
	      return rect.top;
	    };
	    var isAbove$1 = function (corner, y) {
	      return corner.y < y;
	    };
	    var isBelow$1 = function (corner, y) {
	      return corner.y > y;
	    };
	    var getClosestCellAbove = curry(getClosestCell$1, getBottomValue, isAbove$1);
	    var getClosestCellBelow = curry(getClosestCell$1, getTopValue, isBelow$1);
	    var findClosestPositionInAboveCell = function (table, pos) {
	      return head(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellAbove(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
	      });
	    };
	    var findClosestPositionInBelowCell = function (table, pos) {
	      return last(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellBelow(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
	      });
	    };
	
	    var moveToRange = function (editor, rng) {
	      editor.selection.setRng(rng);
	      ScrollIntoView.scrollRangeIntoView(editor, rng);
	    };
	    var hasNextBreak = function (getPositionsUntil, scope, lineInfo) {
	      return lineInfo.breakAt.map(function (breakPos) {
	        return getPositionsUntil(scope, breakPos).breakAt.isSome();
	      }).getOr(false);
	    };
	    var startsWithWrapBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0;
	    };
	    var startsWithBrBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Br && lineInfo.positions.length === 1;
	    };
	    var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
	      var lineInfo = getPositionsUntil(scope, pos);
	      if (startsWithWrapBreak(lineInfo) || !NodeType.isBr(pos.getNode()) && startsWithBrBreak(lineInfo)) {
	        return !hasNextBreak(getPositionsUntil, scope, lineInfo);
	      } else {
	        return lineInfo.breakAt.isNone();
	      }
	    };
	    var isAtFirstTableCellLine = curry(isAtTableCellLine, getPositionsUntilPreviousLine);
	    var isAtLastTableCellLine = curry(isAtTableCellLine, getPositionsUntilNextLine);
	    var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
	      var caretPos = CaretPosition$1.fromRangeStart(rng);
	      return CaretFinder.positionIn(!forward, table).map(function (pos) {
	        return pos.isEqual(caretPos);
	      }).getOr(false);
	    };
	    var navigateHorizontally = function (editor, forward, table, td) {
	      var rng = editor.selection.getRng();
	      var direction = forward ? 1 : -1;
	      if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
	        var newRng = showCaret(direction, editor, table, !forward, true);
	        moveToRange(editor, newRng);
	        return true;
	      }
	      return false;
	    };
	    var getClosestAbovePosition = function (root, table, start) {
	      return findClosestPositionInAboveCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition$1.before(table)), rect.left);
	        });
	      }).getOr(CaretPosition$1.before(table));
	    };
	    var getClosestBelowPosition = function (root, table, start) {
	      return findClosestPositionInBelowCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition$1.after(table)), rect.left);
	        });
	      }).getOr(CaretPosition$1.after(table));
	    };
	    var getTable = function (previous, pos) {
	      var node = pos.getNode(previous);
	      return NodeType.isElement(node) && node.nodeName === 'TABLE' ? Option.some(node) : Option.none();
	    };
	    var renderBlock = function (down, editor, table, pos) {
	      var forcedRootBlock = Settings.getForcedRootBlock(editor);
	      if (forcedRootBlock) {
	        editor.undoManager.transact(function () {
	          var element = Element.fromTag(forcedRootBlock);
	          setAll(element, Settings.getForcedRootBlockAttrs(editor));
	          append(element, Element.fromTag('br'));
	          if (down) {
	            after(Element.fromDom(table), element);
	          } else {
	            before(Element.fromDom(table), element);
	          }
	          var rng = editor.dom.createRng();
	          rng.setStart(element.dom(), 0);
	          rng.setEnd(element.dom(), 0);
	          moveToRange(editor, rng);
	        });
	      } else {
	        moveToRange(editor, pos.toRange());
	      }
	    };
	    var moveCaret = function (editor, down, pos) {
	      var table = down ? getTable(true, pos) : getTable(false, pos);
	      var last = down === false;
	      table.fold(function () {
	        return moveToRange(editor, pos.toRange());
	      }, function (table) {
	        return CaretFinder.positionIn(last, editor.getBody()).filter(function (lastPos) {
	          return lastPos.isEqual(pos);
	        }).fold(function () {
	          return moveToRange(editor, pos.toRange());
	        }, function (_) {
	          return renderBlock(down, editor, table, pos);
	        });
	      });
	    };
	    var navigateVertically = function (editor, down, table, td) {
	      var rng = editor.selection.getRng();
	      var pos = CaretPosition$1.fromRangeStart(rng);
	      var root = editor.getBody();
	      if (!down && isAtFirstTableCellLine(td, pos)) {
	        var newPos = getClosestAbovePosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else if (down && isAtLastTableCellLine(td, pos)) {
	        var newPos = getClosestBelowPosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var moveH$1 = function (editor, forward) {
	      return function () {
	        return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	          return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
	            return navigateHorizontally(editor, forward, table);
	          });
	        }).getOr(false);
	      };
	    };
	    var moveV$1 = function (editor, forward) {
	      return function () {
	        return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	          return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
	            return navigateVertically(editor, forward, table, td);
	          });
	        }).getOr(false);
	      };
	    };
	
	    var isTarget = function (node) {
	      return contains(['figcaption'], name(node));
	    };
	    var rangeBefore = function (target) {
	      var rng = domGlobals.document.createRange();
	      rng.setStartBefore(target.dom());
	      rng.setEndBefore(target.dom());
	      return rng;
	    };
	    var insertElement = function (root, elm, forward) {
	      if (forward) {
	        append(root, elm);
	      } else {
	        prepend(root, elm);
	      }
	    };
	    var insertBr = function (root, forward) {
	      var br = Element.fromTag('br');
	      insertElement(root, br, forward);
	      return rangeBefore(br);
	    };
	    var insertBlock$1 = function (root, forward, blockName, attrs) {
	      var block = Element.fromTag(blockName);
	      var br = Element.fromTag('br');
	      setAll(block, attrs);
	      append(block, br);
	      insertElement(root, block, forward);
	      return rangeBefore(br);
	    };
	    var insertEmptyLine = function (root, rootBlockName, attrs, forward) {
	      if (rootBlockName === '') {
	        return insertBr(root, forward);
	      } else {
	        return insertBlock$1(root, forward, rootBlockName, attrs);
	      }
	    };
	    var getClosestTargetBlock = function (pos, root) {
	      var isRoot = curry(eq, root);
	      return closest(Element.fromDom(pos.container()), isBlock, isRoot).filter(isTarget);
	    };
	    var isAtFirstOrLastLine = function (root, forward, pos) {
	      return forward ? isAtLastLine(root.dom(), pos) : isAtFirstLine(root.dom(), pos);
	    };
	    var moveCaretToNewEmptyLine = function (editor, forward) {
	      var root = Element.fromDom(editor.getBody());
	      var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var rootBlock = Settings.getForcedRootBlock(editor);
	      var rootBlockAttrs = Settings.getForcedRootBlockAttrs(editor);
	      return getClosestTargetBlock(pos, root).exists(function () {
	        if (isAtFirstOrLastLine(root, forward, pos)) {
	          var rng = insertEmptyLine(root, rootBlock, rootBlockAttrs, forward);
	          editor.selection.setRng(rng);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var moveV$2 = function (editor, forward) {
	      return function () {
	        if (editor.selection.isCollapsed()) {
	          return moveCaretToNewEmptyLine(editor, forward);
	        } else {
	          return false;
	        }
	      };
	    };
	
	    var defaultPatterns = function (patterns) {
	      return map(patterns, function (pattern) {
	        return merge({
	          shiftKey: false,
	          altKey: false,
	          ctrlKey: false,
	          metaKey: false,
	          keyCode: 0,
	          action: noop
	        }, pattern);
	      });
	    };
	    var matchesEvent = function (pattern, evt) {
	      return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
	    };
	    var match$1 = function (patterns, evt) {
	      return bind(defaultPatterns(patterns), function (pattern) {
	        return matchesEvent(pattern, evt) ? [pattern] : [];
	      });
	    };
	    var action = function (f) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var args = Array.prototype.slice.call(arguments, 1);
	      return function () {
	        return f.apply(null, args);
	      };
	    };
	    var execute = function (patterns, evt) {
	      return find(match$1(patterns, evt), function (pattern) {
	        return pattern.action();
	      });
	    };
	    var MatchKeys = {
	      match: match$1,
	      action: action,
	      execute: execute
	    };
	
	    var executeKeydownOverride = function (editor, caret, evt) {
	      var os = PlatformDetection$1.detect().os;
	      MatchKeys.execute([
	        {
	          keyCode: VK.RIGHT,
	          action: moveH(editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: moveH(editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV(editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: moveH$1(editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: moveH$1(editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV$1(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV$1(editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: BoundarySelection.move(editor, caret, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: BoundarySelection.move(editor, caret, false)
	        },
	        {
	          keyCode: VK.RIGHT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: BoundarySelection.moveNextWord(editor, caret)
	        },
	        {
	          keyCode: VK.LEFT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: BoundarySelection.movePrevWord(editor, caret)
	        },
	        {
	          keyCode: VK.UP,
	          action: moveV$2(editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: moveV$2(editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$7 = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, caret, evt);
	        }
	      });
	    };
	    var ArrowKeys = { setup: setup$7 };
	
	    var executeKeydownOverride$1 = function (editor, caret, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefBoundaryDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefBoundaryDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(TableDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(TableDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var executeKeyupOverride = function (editor, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: MatchKeys.action(CefDelete.paddEmptyElement, editor)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: MatchKeys.action(CefDelete.paddEmptyElement, editor)
	        }
	      ], evt);
	    };
	    var setup$8 = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$1(editor, caret, evt);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupOverride(editor, evt);
	        }
	      });
	    };
	    var DeleteBackspaceKeys = { setup: setup$8 };
	
	    var firstNonWhiteSpaceNodeSibling = function (node) {
	      while (node) {
	        if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
	          return node;
	        }
	        node = node.nextSibling;
	      }
	    };
	    var moveToCaretPosition = function (editor, root) {
	      var walker, node, rng, lastNode = root, tempElm;
	      var dom = editor.dom;
	      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
	      if (!root) {
	        return;
	      }
	      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
	        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
	          root.insertBefore(dom.doc.createTextNode('\xA0'), root.firstChild);
	        }
	      }
	      rng = dom.createRng();
	      root.normalize();
	      if (root.hasChildNodes()) {
	        walker = new TreeWalker(root, root);
	        while (node = walker.current()) {
	          if (NodeType.isText(node)) {
	            rng.setStart(node, 0);
	            rng.setEnd(node, 0);
	            break;
	          }
	          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
	            rng.setStartBefore(node);
	            rng.setEndBefore(node);
	            break;
	          }
	          lastNode = node;
	          node = walker.next();
	        }
	        if (!node) {
	          rng.setStart(lastNode, 0);
	          rng.setEnd(lastNode, 0);
	        }
	      } else {
	        if (NodeType.isBr(root)) {
	          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
	            rng.setStartBefore(root);
	            rng.setEndBefore(root);
	          } else {
	            rng.setStartAfter(root);
	            rng.setEndAfter(root);
	          }
	        } else {
	          rng.setStart(root, 0);
	          rng.setEnd(root, 0);
	        }
	      }
	      editor.selection.setRng(rng);
	      dom.remove(tempElm);
	      editor.selection.scrollIntoView(root);
	    };
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var getParentBlock$2 = function (editor) {
	      return Option.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
	    };
	    var getParentBlockName = function (editor) {
	      return getParentBlock$2(editor).fold(constant(''), function (parentBlock) {
	        return parentBlock.nodeName.toUpperCase();
	      });
	    };
	    var isListItemParentBlock = function (editor) {
	      return getParentBlock$2(editor).filter(function (elm) {
	        return isListItem(Element.fromDom(elm));
	      }).isSome();
	    };
	    var NewLineUtils = {
	      moveToCaretPosition: moveToCaretPosition,
	      getEditableRoot: getEditableRoot,
	      getParentBlock: getParentBlock$2,
	      getParentBlockName: getParentBlockName,
	      isListItemParentBlock: isListItemParentBlock
	    };
	
	    var hasFirstChild = function (elm, name) {
	      return elm.firstChild && elm.firstChild.nodeName === name;
	    };
	    var hasParent$1 = function (elm, parentName) {
	      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
	    };
	    var isListBlock = function (elm) {
	      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
	    };
	    var isNestedList = function (elm) {
	      return isListBlock(elm) && isListBlock(elm.parentNode);
	    };
	    var getContainerBlock = function (containerBlock) {
	      var containerBlockParent = containerBlock.parentNode;
	      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
	        return containerBlockParent;
	      }
	      return containerBlock;
	    };
	    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
	      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	      while (node) {
	        if (NodeType.isElement(node)) {
	          break;
	        }
	        node = node[first ? 'nextSibling' : 'previousSibling'];
	      }
	      return node === parentBlock;
	    };
	    var insert$1 = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
	      var dom = editor.dom;
	      var rng = editor.selection.getRng();
	      if (containerBlock === editor.getBody()) {
	        return;
	      }
	      if (isNestedList(containerBlock)) {
	        newBlockName = 'LI';
	      }
	      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	        } else {
	          dom.replace(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	          newBlock.appendChild(dom.doc.createTextNode(' '));
	          newBlock.appendChild(containerBlock);
	        } else {
	          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	      } else {
	        containerBlock = getContainerBlock(containerBlock);
	        var tmpRng = rng.cloneRange();
	        tmpRng.setStartAfter(parentBlock);
	        tmpRng.setEndAfter(containerBlock);
	        var fragment = tmpRng.extractContents();
	        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
	          newBlock = fragment.firstChild;
	          dom.insertAfter(fragment, containerBlock);
	        } else {
	          dom.insertAfter(fragment, containerBlock);
	          dom.insertAfter(newBlock, containerBlock);
	        }
	      }
	      dom.remove(parentBlock);
	      NewLineUtils.moveToCaretPosition(editor, newBlock);
	    };
	    var InsertLi = { insert: insert$1 };
	
	    var trimZwsp = function (fragment) {
	      each(descendants(Element.fromDom(fragment), isText), function (text) {
	        var rawNode = text.dom();
	        rawNode.nodeValue = Zwsp.trim(rawNode.nodeValue);
	      });
	    };
	    var isEmptyAnchor = function (dom, elm) {
	      return elm && elm.nodeName === 'A' && dom.isEmpty(elm);
	    };
	    var isTableCell$5 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var emptyBlock = function (elm) {
	      elm.innerHTML = '<br data-mce-bogus="1">';
	    };
	    var containerAndSiblingName = function (container, nodeName) {
	      return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
	    };
	    var canSplitBlock = function (dom, node) {
	      return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
	    };
	    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
	      var node = block;
	      var firstChilds = [];
	      var i;
	      if (!node) {
	        return;
	      }
	      while (node = node.firstChild) {
	        if (dom.isBlock(node)) {
	          return;
	        }
	        if (NodeType.isElement(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          firstChilds.push(node);
	        }
	      }
	      i = firstChilds.length;
	      while (i--) {
	        node = firstChilds[i];
	        if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
	          dom.remove(node);
	        } else {
	          if (isEmptyAnchor(dom, node)) {
	            dom.remove(node);
	          }
	        }
	      }
	    };
	    var normalizeZwspOffset = function (start, container, offset) {
	      if (NodeType.isText(container) === false) {
	        return offset;
	      } else if (start) {
	        return offset === 1 && container.data.charAt(offset - 1) === Zwsp.ZWSP ? 0 : offset;
	      } else {
	        return offset === container.data.length - 1 && container.data.charAt(offset) === Zwsp.ZWSP ? container.data.length : offset;
	      }
	    };
	    var includeZwspInRange = function (rng) {
	      var newRng = rng.cloneRange();
	      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
	      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
	      return newRng;
	    };
	    var trimLeadingLineBreaks = function (node) {
	      do {
	        if (NodeType.isText(node)) {
	          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
	        }
	        node = node.firstChild;
	      } while (node);
	    };
	    var getEditableRoot$1 = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var applyAttributes = function (editor, node, forcedRootBlockAttrs) {
	      Option.from(forcedRootBlockAttrs.style).map(editor.dom.parseStyle).each(function (attrStyles) {
	        var currentStyles = getAllRaw(Element.fromDom(node));
	        var newStyles = __assign(__assign({}, currentStyles), attrStyles);
	        editor.dom.setStyles(node, newStyles);
	      });
	      var attrClassesOpt = Option.from(forcedRootBlockAttrs.class).map(function (attrClasses) {
	        return attrClasses.split(/\s+/);
	      });
	      var currentClassesOpt = Option.from(node.className).map(function (currentClasses) {
	        return filter(currentClasses.split(/\s+/), function (clazz) {
	          return clazz !== '';
	        });
	      });
	      lift2(attrClassesOpt, currentClassesOpt, function (attrClasses, currentClasses) {
	        var filteredClasses = filter(currentClasses, function (clazz) {
	          return !contains(attrClasses, clazz);
	        });
	        var newClasses = __spreadArrays(attrClasses, filteredClasses);
	        editor.dom.setAttrib(node, 'class', newClasses.join(' '));
	      });
	      var appliedAttrs = [
	        'style',
	        'class'
	      ];
	      var remainingAttrs = bifilter(forcedRootBlockAttrs, function (_, attrs) {
	        return !contains(appliedAttrs, attrs);
	      }).t;
	      editor.dom.setAttribs(node, remainingAttrs);
	    };
	    var setForcedBlockAttrs = function (editor, node) {
	      var forcedRootBlockName = Settings.getForcedRootBlock(editor);
	      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
	        var forcedRootBlockAttrs = Settings.getForcedRootBlockAttrs(editor);
	        applyAttributes(editor, node, forcedRootBlockAttrs);
	      }
	    };
	    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
	      var newBlock, parentBlock, startNode, node, next, rootBlockName;
	      var blockName = newBlockName || 'P';
	      var dom = editor.dom, editableRoot = getEditableRoot$1(dom, container);
	      parentBlock = dom.getParent(container, dom.isBlock);
	      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
	        parentBlock = parentBlock || editableRoot;
	        if (parentBlock === editor.getBody() || isTableCell$5(parentBlock)) {
	          rootBlockName = parentBlock.nodeName.toLowerCase();
	        } else {
	          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
	        }
	        if (!parentBlock.hasChildNodes()) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          parentBlock.appendChild(newBlock);
	          rng.setStart(newBlock, 0);
	          rng.setEnd(newBlock, 0);
	          return newBlock;
	        }
	        node = container;
	        while (node.parentNode !== parentBlock) {
	          node = node.parentNode;
	        }
	        while (node && !dom.isBlock(node)) {
	          startNode = node;
	          node = node.previousSibling;
	        }
	        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          startNode.parentNode.insertBefore(newBlock, startNode);
	          node = startNode;
	          while (node && !dom.isBlock(node)) {
	            next = node.nextSibling;
	            newBlock.appendChild(node);
	            node = next;
	          }
	          rng.setStart(container, offset);
	          rng.setEnd(container, offset);
	        }
	      }
	      return container;
	    };
	    var addBrToBlockIfNeeded = function (dom, block) {
	      var lastChild;
	      block.normalize();
	      lastChild = block.lastChild;
	      if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
	        dom.add(block, 'br');
	      }
	    };
	    var insert$2 = function (editor, evt) {
	      var tmpRng, editableRoot, container, offset, parentBlock, shiftKey;
	      var newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;
	      var dom = editor.dom;
	      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
	      var rng = editor.selection.getRng();
	      var createNewBlock = function (name) {
	        var node = container, block, clonedNode, caretNode;
	        var textInlineElements = schema.getTextInlineElements();
	        if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
	          block = dom.create(name || newBlockName);
	        } else {
	          block = parentBlock.cloneNode(false);
	        }
	        caretNode = block;
	        if (Settings.shouldKeepStyles(editor) === false) {
	          dom.setAttrib(block, 'style', null);
	          dom.setAttrib(block, 'class', null);
	        } else {
	          do {
	            if (textInlineElements[node.nodeName]) {
	              if (isCaretNode(node) || Bookmarks.isBookmarkNode(node)) {
	                continue;
	              }
	              clonedNode = node.cloneNode(false);
	              dom.setAttrib(clonedNode, 'id', '');
	              if (block.hasChildNodes()) {
	                clonedNode.appendChild(block.firstChild);
	                block.appendChild(clonedNode);
	              } else {
	                caretNode = clonedNode;
	                block.appendChild(clonedNode);
	              }
	            }
	          } while ((node = node.parentNode) && node !== editableRoot);
	        }
	        setForcedBlockAttrs(editor, block);
	        emptyBlock(caretNode);
	        return block;
	      };
	      var isCaretAtStartOrEndOfBlock = function (start) {
	        var walker, node, name, normalizedOffset;
	        normalizedOffset = normalizeZwspOffset(start, container, offset);
	        if (NodeType.isText(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
	          return false;
	        }
	        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
	          return true;
	        }
	        if (start && NodeType.isElement(container) && container === parentBlock.firstChild) {
	          return true;
	        }
	        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
	          return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
	        }
	        walker = new TreeWalker(container, parentBlock);
	        if (NodeType.isText(container)) {
	          if (start && normalizedOffset === 0) {
	            walker.prev();
	          } else if (!start && normalizedOffset === container.nodeValue.length) {
	            walker.next();
	          }
	        }
	        while (node = walker.current()) {
	          if (NodeType.isElement(node)) {
	            if (!node.getAttribute('data-mce-bogus')) {
	              name = node.nodeName.toLowerCase();
	              if (nonEmptyElementsMap[name] && name !== 'br') {
	                return false;
	              }
	            }
	          } else if (NodeType.isText(node) && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
	            return false;
	          }
	          if (start) {
	            walker.prev();
	          } else {
	            walker.next();
	          }
	        }
	        return true;
	      };
	      var insertNewBlockAfter = function () {
	        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
	          newBlock = createNewBlock(newBlockName);
	        } else {
	          newBlock = createNewBlock();
	        }
	        if (Settings.shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
	          newBlock = dom.split(containerBlock, parentBlock);
	        } else {
	          dom.insertAfter(newBlock, parentBlock);
	        }
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      };
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      newBlockName = Settings.getForcedRootBlock(editor);
	      shiftKey = evt.shiftKey;
	      if (NodeType.isElement(container) && container.hasChildNodes()) {
	        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && NodeType.isText(container)) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      editableRoot = getEditableRoot$1(dom, container);
	      if (!editableRoot) {
	        return;
	      }
	      if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
	        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
	      }
	      parentBlock = dom.getParent(container, dom.isBlock);
	      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
	      containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      if (containerBlockName === 'LI' && !evt.ctrlKey) {
	        parentBlock = containerBlock;
	        containerBlock = containerBlock.parentNode;
	        parentBlockName = containerBlockName;
	      }
	      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
	        if (dom.isEmpty(parentBlock)) {
	          InsertLi.insert(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
	          return;
	        }
	      }
	      if (newBlockName && parentBlock === editor.getBody()) {
	        return;
	      }
	      newBlockName = newBlockName || 'P';
	      if (isCaretContainerBlock(parentBlock)) {
	        newBlock = showCaretContainerBlock(parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        setForcedBlockAttrs(editor, newBlock);
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      } else if (isCaretAtStartOrEndOfBlock()) {
	        insertNewBlockAfter();
	      } else if (isCaretAtStartOrEndOfBlock(true)) {
	        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
	        NewLineUtils.moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
	      } else {
	        tmpRng = includeZwspInRange(rng).cloneRange();
	        tmpRng.setEndAfter(parentBlock);
	        fragment = tmpRng.extractContents();
	        trimZwsp(fragment);
	        trimLeadingLineBreaks(fragment);
	        newBlock = fragment.firstChild;
	        dom.insertAfter(fragment, parentBlock);
	        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
	        addBrToBlockIfNeeded(dom, parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        newBlock.normalize();
	        if (dom.isEmpty(newBlock)) {
	          dom.remove(newBlock);
	          insertNewBlockAfter();
	        } else {
	          setForcedBlockAttrs(editor, newBlock);
	          NewLineUtils.moveToCaretPosition(editor, newBlock);
	        }
	      }
	      dom.setAttrib(newBlock, 'id', '');
	      editor.fire('NewBlock', { newBlock: newBlock });
	    };
	    var InsertBlock = { insert: insert$2 };
	
	    var matchesSelector = function (editor, selector) {
	      return NewLineUtils.getParentBlock(editor).filter(function (parentBlock) {
	        return selector.length > 0 && is$1(Element.fromDom(parentBlock), selector);
	      }).isSome();
	    };
	    var shouldInsertBr = function (editor) {
	      return matchesSelector(editor, Settings.getBrNewLineSelector(editor));
	    };
	    var shouldBlockNewLine = function (editor) {
	      return matchesSelector(editor, Settings.getNoNewLineSelector(editor));
	    };
	    var ContextSelectors = {
	      shouldInsertBr: shouldInsertBr,
	      shouldBlockNewLine: shouldBlockNewLine
	    };
	
	    var newLineAction = Adt.generate([
	      { br: [] },
	      { block: [] },
	      { none: [] }
	    ]);
	    var shouldBlockNewLine$1 = function (editor, shiftKey) {
	      return ContextSelectors.shouldBlockNewLine(editor);
	    };
	    var isBrMode = function (requiredState) {
	      return function (editor, shiftKey) {
	        var brMode = Settings.getForcedRootBlock(editor) === '';
	        return brMode === requiredState;
	      };
	    };
	    var inListBlock = function (requiredState) {
	      return function (editor, shiftKey) {
	        return NewLineUtils.isListItemParentBlock(editor) === requiredState;
	      };
	    };
	    var inBlock = function (blockName, requiredState) {
	      return function (editor, shiftKey) {
	        var state = NewLineUtils.getParentBlockName(editor) === blockName.toUpperCase();
	        return state === requiredState;
	      };
	    };
	    var inPreBlock = function (requiredState) {
	      return inBlock('pre', requiredState);
	    };
	    var inSummaryBlock = function () {
	      return inBlock('summary', true);
	    };
	    var shouldPutBrInPre$1 = function (requiredState) {
	      return function (editor, shiftKey) {
	        return Settings.shouldPutBrInPre(editor) === requiredState;
	      };
	    };
	    var inBrContext = function (editor, shiftKey) {
	      return ContextSelectors.shouldInsertBr(editor);
	    };
	    var hasShiftKey = function (editor, shiftKey) {
	      return shiftKey;
	    };
	    var canInsertIntoEditableRoot = function (editor) {
	      var forcedRootBlock = Settings.getForcedRootBlock(editor);
	      var rootEditable = NewLineUtils.getEditableRoot(editor.dom, editor.selection.getStart());
	      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
	    };
	    var match$2 = function (predicates, action) {
	      return function (editor, shiftKey) {
	        var isMatch = foldl(predicates, function (res, p) {
	          return res && p(editor, shiftKey);
	        }, true);
	        return isMatch ? Option.some(action) : Option.none();
	      };
	    };
	    var getAction$1 = function (editor, evt) {
	      return LazyEvaluator.evaluateUntil([
	        match$2([shouldBlockNewLine$1], newLineAction.none()),
	        match$2([inSummaryBlock()], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false)
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true),
	          hasShiftKey
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true)
	        ], newLineAction.br()),
	        match$2([
	          inListBlock(true),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([inListBlock(true)], newLineAction.block()),
	        match$2([
	          isBrMode(true),
	          hasShiftKey,
	          canInsertIntoEditableRoot
	        ], newLineAction.block()),
	        match$2([isBrMode(true)], newLineAction.br()),
	        match$2([inBrContext], newLineAction.br()),
	        match$2([
	          isBrMode(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([canInsertIntoEditableRoot], newLineAction.block())
	      ], [
	        editor,
	        evt.shiftKey
	      ]).getOr(newLineAction.none());
	    };
	    var NewLineAction = { getAction: getAction$1 };
	
	    var insert$3 = function (editor, evt) {
	      NewLineAction.getAction(editor, evt).fold(function () {
	        InsertBr.insert(editor, evt);
	      }, function () {
	        InsertBlock.insert(editor, evt);
	      }, noop);
	    };
	    var InsertNewLine = { insert: insert$3 };
	
	    var endTypingLevel = function (undoManager) {
	      if (undoManager.typing) {
	        undoManager.typing = false;
	        undoManager.add();
	      }
	    };
	    var handleEnterKeyEvent = function (editor, event) {
	      if (event.isDefaultPrevented()) {
	        return;
	      }
	      event.preventDefault();
	      endTypingLevel(editor.undoManager);
	      editor.undoManager.transact(function () {
	        if (editor.selection.isCollapsed() === false) {
	          editor.execCommand('Delete');
	        }
	        InsertNewLine.insert(editor, event);
	      });
	    };
	    var setup$9 = function (editor) {
	      editor.on('keydown', function (event) {
	        if (event.keyCode === VK.ENTER) {
	          handleEnterKeyEvent(editor, event);
	        }
	      });
	    };
	    var EnterKey = { setup: setup$9 };
	
	    var insertTextAtPosition = function (text, pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (NodeType.isText(container)) {
	        container.insertData(offset, text);
	        return Option.some(CaretPosition(container, offset + text.length));
	      } else {
	        return getElementFromPosition(pos).map(function (elm) {
	          var textNode = Element.fromText(text);
	          if (pos.isAtEnd()) {
	            after(elm, textNode);
	          } else {
	            before(elm, textNode);
	          }
	          return CaretPosition(textNode.dom(), text.length);
	        });
	      }
	    };
	    var insertNbspAtPosition = curry(insertTextAtPosition, '\xA0');
	    var insertSpaceAtPosition = curry(insertTextAtPosition, ' ');
	
	    var navigateIgnoreEmptyTextNodes = function (forward, root, from) {
	      return CaretFinder.navigateIgnore(forward, root, from, isEmptyText);
	    };
	    var getClosestBlock = function (root, pos) {
	      return find(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	    };
	    var isAtBeforeAfterBlockBoundary = function (forward, root, pos) {
	      return navigateIgnoreEmptyTextNodes(forward, root.dom(), pos).forall(function (newPos) {
	        return getClosestBlock(root, pos).fold(function () {
	          return isInSameBlock(newPos, pos, root.dom()) === false;
	        }, function (fromBlock) {
	          return isInSameBlock(newPos, pos, root.dom()) === false && contains$3(fromBlock, Element.fromDom(newPos.container()));
	        });
	      });
	    };
	    var isAtBlockBoundary = function (forward, root, pos) {
	      return getClosestBlock(root, pos).fold(function () {
	        return navigateIgnoreEmptyTextNodes(forward, root.dom(), pos).forall(function (newPos) {
	          return isInSameBlock(newPos, pos, root.dom()) === false;
	        });
	      }, function (parent) {
	        return navigateIgnoreEmptyTextNodes(forward, parent.dom(), pos).isNone();
	      });
	    };
	    var isAtStartOfBlock = curry(isAtBlockBoundary, false);
	    var isAtEndOfBlock = curry(isAtBlockBoundary, true);
	    var isBeforeBlock = curry(isAtBeforeAfterBlockBoundary, false);
	    var isAfterBlock = curry(isAtBeforeAfterBlockBoundary, true);
	
	    var nbsp = '\xA0';
	    var isInMiddleOfText = function (pos) {
	      return CaretPosition.isTextPosition(pos) && !pos.isAtStart() && !pos.isAtEnd();
	    };
	    var getClosestBlock$1 = function (root, pos) {
	      var parentBlocks = filter(Parents.parentsAndSelf(Element.fromDom(pos.container()), root), isBlock);
	      return head(parentBlocks).getOr(root);
	    };
	    var hasSpaceBefore = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isAfterSpace(pos);
	      } else {
	        return isAfterSpace(pos) || CaretFinder.prevPosition(getClosestBlock$1(root, pos).dom(), pos).exists(isAfterSpace);
	      }
	    };
	    var hasSpaceAfter = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isBeforeSpace(pos);
	      } else {
	        return isBeforeSpace(pos) || CaretFinder.nextPosition(getClosestBlock$1(root, pos).dom(), pos).exists(isBeforeSpace);
	      }
	    };
	    var isPreValue = function (value) {
	      return contains([
	        'pre',
	        'pre-wrap'
	      ], value);
	    };
	    var isInPre = function (pos) {
	      return getElementFromPosition(pos).bind(function (elm) {
	        return closest(elm, isElement);
	      }).exists(function (elm) {
	        return isPreValue(get$1(elm, 'white-space'));
	      });
	    };
	    var isAtBeginningOfBody = function (root, pos) {
	      return CaretFinder.prevPosition(root.dom(), pos).isNone();
	    };
	    var isAtEndOfBody = function (root, pos) {
	      return CaretFinder.nextPosition(root.dom(), pos).isNone();
	    };
	    var isAtLineBoundary = function (root, pos) {
	      return isAtBeginningOfBody(root, pos) || isAtEndOfBody(root, pos) || isAtStartOfBlock(root, pos) || isAtEndOfBlock(root, pos) || isAfterBr(root, pos) || isBeforeBr(root, pos);
	    };
	    var needsToHaveNbsp = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtLineBoundary(root, pos) || hasSpaceBefore(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbspLeft = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtStartOfBlock(root, pos) || isBeforeBlock(root, pos) || isAfterBr(root, pos) || hasSpaceBefore(root, pos);
	      }
	    };
	    var leanRight = function (pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (NodeType.isText(container) && offset < container.data.length) {
	        return CaretPosition(container, offset + 1);
	      } else {
	        return pos;
	      }
	    };
	    var needsToBeNbspRight = function (root, pos) {
	      var afterPos = leanRight(pos);
	      if (isInPre(afterPos)) {
	        return false;
	      } else {
	        return isAtEndOfBlock(root, afterPos) || isAfterBlock(root, afterPos) || isBeforeBr(root, afterPos) || hasSpaceAfter(root, afterPos);
	      }
	    };
	    var needsToBeNbsp = function (root, pos) {
	      return needsToBeNbspLeft(root, pos) || needsToBeNbspRight(root, pos);
	    };
	    var isNbspAt = function (text, offset) {
	      return isNbsp(text.charAt(offset));
	    };
	    var hasNbsp = function (pos) {
	      var container = pos.container();
	      return NodeType.isText(container) && contains$2(container.data, nbsp);
	    };
	    var normalizeNbspMiddle = function (text) {
	      var chars = text.split('');
	      return map(chars, function (chr, i) {
	        if (isNbsp(chr) && i > 0 && i < chars.length - 1 && isContent$1(chars[i - 1]) && isContent$1(chars[i + 1])) {
	          return ' ';
	        } else {
	          return chr;
	        }
	      }).join('');
	    };
	    var normalizeNbspAtStart = function (root, node) {
	      var text = node.data;
	      var firstPos = CaretPosition(node, 0);
	      if (isNbspAt(text, 0) && !needsToBeNbsp(root, firstPos)) {
	        node.data = ' ' + text.slice(1);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspInMiddleOfTextNode = function (node) {
	      var text = node.data;
	      var newText = normalizeNbspMiddle(text);
	      if (newText !== text) {
	        node.data = newText;
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspAtEnd = function (root, node) {
	      var text = node.data;
	      var lastPos = CaretPosition(node, text.length - 1);
	      if (isNbspAt(text, text.length - 1) && !needsToBeNbsp(root, lastPos)) {
	        node.data = text.slice(0, -1) + ' ';
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbsps = function (root, pos) {
	      return Option.some(pos).filter(hasNbsp).bind(function (pos) {
	        var container = pos.container();
	        var normalized = normalizeNbspAtStart(root, container) || normalizeNbspInMiddleOfTextNode(container) || normalizeNbspAtEnd(root, container);
	        return normalized ? Option.some(pos) : Option.none();
	      });
	    };
	    var normalizeNbspsInEditor = function (editor) {
	      var root = Element.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        normalizeNbsps(root, CaretPosition.fromRangeStart(editor.selection.getRng())).each(function (pos) {
	          editor.selection.setRng(pos.toRange());
	        });
	      }
	    };
	
	    var locationToCaretPosition = function (root) {
	      return function (location) {
	        return location.fold(function (element) {
	          return CaretFinder.prevPosition(root.dom(), CaretPosition$1.before(element));
	        }, function (element) {
	          return CaretFinder.firstPositionIn(element);
	        }, function (element) {
	          return CaretFinder.lastPositionIn(element);
	        }, function (element) {
	          return CaretFinder.nextPosition(root.dom(), CaretPosition$1.after(element));
	        });
	      };
	    };
	    var insertInlineBoundarySpaceOrNbsp = function (root, pos) {
	      return function (checkPos) {
	        return needsToHaveNbsp(root, checkPos) ? insertNbspAtPosition(pos) : insertSpaceAtPosition(pos);
	      };
	    };
	    var setSelection$1 = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        editor.nodeChanged();
	        return true;
	      };
	    };
	    var insertSpaceOrNbspAtSelection = function (editor) {
	      var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	      var root = Element.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        var isInlineTarget = curry(InlineUtils.isInlineTarget, editor);
	        var caretPosition = CaretPosition$1.fromRangeStart(editor.selection.getRng());
	        return BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), caretPosition).bind(locationToCaretPosition(root)).bind(insertInlineBoundarySpaceOrNbsp(root, pos)).exists(setSelection$1(editor));
	      } else {
	        return false;
	      }
	    };
	
	    var executeKeydownOverride$2 = function (editor, evt) {
	      MatchKeys.execute([{
	          keyCode: VK.SPACEBAR,
	          action: MatchKeys.action(insertSpaceOrNbspAtSelection, editor)
	        }], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$a = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$2(editor, evt);
	        }
	      });
	    };
	    var SpaceKey = { setup: setup$a };
	
	    var findBlockCaretContainer = function (editor) {
	      return descendant(Element.fromDom(editor.getBody()), '*[data-mce-caret]').fold(constant(null), function (elm) {
	        return elm.dom();
	      });
	    };
	    var removeIeControlRect = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var showBlockCaretContainer = function (editor, blockCaretContainer) {
	      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	        showCaretContainerBlock(blockCaretContainer);
	        removeIeControlRect(editor);
	        editor.selection.scrollIntoView(blockCaretContainer);
	      }
	    };
	    var handleBlockContainer = function (editor, e) {
	      var blockCaretContainer = findBlockCaretContainer(editor);
	      if (!blockCaretContainer) {
	        return;
	      }
	      if (e.type === 'compositionstart') {
	        e.preventDefault();
	        e.stopPropagation();
	        showBlockCaretContainer(editor, blockCaretContainer);
	        return;
	      }
	      if (hasContent(blockCaretContainer)) {
	        showBlockCaretContainer(editor, blockCaretContainer);
	        editor.undoManager.add();
	      }
	    };
	    var setup$b = function (editor) {
	      editor.on('keyup compositionstart', curry(handleBlockContainer, editor));
	    };
	    var CaretContainerInput = { setup: setup$b };
	
	    var browser$4 = PlatformDetection$1.detect().browser;
	    var setupIeInput = function (editor) {
	      var keypressThrotter = first(function () {
	        if (!editor.composing) {
	          normalizeNbspsInEditor(editor);
	        }
	      }, 0);
	      if (browser$4.isIE()) {
	        editor.on('keypress', function (e) {
	          keypressThrotter.throttle();
	        });
	        editor.on('remove', function (e) {
	          keypressThrotter.cancel();
	        });
	      }
	    };
	    var setup$c = function (editor) {
	      setupIeInput(editor);
	      editor.on('input', function (e) {
	        if (e.isComposing === false) {
	          normalizeNbspsInEditor(editor);
	        }
	      });
	    };
	
	    var executeKeydownOverride$3 = function (editor, evt) {
	      MatchKeys.execute([
	        {
	          keyCode: VK.END,
	          action: moveToLineEndPoint(editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: moveToLineEndPoint(editor, false)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$d = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$3(editor, evt);
	        }
	      });
	    };
	    var HomeEndKeys = { setup: setup$d };
	
	    var setup$e = function (editor) {
	      var caret = BoundarySelection.setupSelectedState(editor);
	      CaretContainerInput.setup(editor);
	      ArrowKeys.setup(editor, caret);
	      DeleteBackspaceKeys.setup(editor, caret);
	      EnterKey.setup(editor);
	      SpaceKey.setup(editor);
	      setup$c(editor);
	      HomeEndKeys.setup(editor);
	    };
	    var KeyboardOverrides = { setup: setup$e };
	
	    function Quirks (editor) {
	      var each = Tools.each;
	      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection, settings = editor.settings, parser = editor.parser;
	      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var mceInternalDataType = isIE ? 'Text' : 'URL';
	      var setEditorCommandState = function (cmd, state) {
	        try {
	          editor.getDoc().execCommand(cmd, false, state);
	        } catch (ex) {
	        }
	      };
	      var isDefaultPrevented = function (e) {
	        return e.isDefaultPrevented();
	      };
	      var setMceInternalContent = function (e) {
	        var selectionHtml, internalContent;
	        if (e.dataTransfer) {
	          if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
	            selection.select(e.target);
	          }
	          selectionHtml = editor.selection.getContent();
	          if (selectionHtml.length > 0) {
	            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
	            e.dataTransfer.setData(mceInternalDataType, internalContent);
	          }
	        }
	      };
	      var getMceInternalContent = function (e) {
	        var internalContent;
	        if (e.dataTransfer) {
	          internalContent = e.dataTransfer.getData(mceInternalDataType);
	          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
	            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	            return {
	              id: unescape(internalContent[0]),
	              html: unescape(internalContent[1])
	            };
	          }
	        }
	        return null;
	      };
	      var insertClipboardContents = function (content, internal) {
	        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
	          editor.execCommand('mceInsertClipboardContent', false, {
	            content: content,
	            internal: internal
	          });
	        } else {
	          editor.execCommand('mceInsertContent', false, content);
	        }
	      };
	      var emptyEditorWhenDeleting = function () {
	        var serializeRng = function (rng) {
	          var body = dom.create('body');
	          var contents = rng.cloneContents();
	          body.appendChild(contents);
	          return selection.serializer.serialize(body, { format: 'html' });
	        };
	        var allContentsSelected = function (rng) {
	          var selection = serializeRng(rng);
	          var allRng = dom.createRng();
	          allRng.selectNode(editor.getBody());
	          var allSelection = serializeRng(allRng);
	          return selection === allSelection;
	        };
	        editor.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          var isCollapsed, body;
	          if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
	            isCollapsed = editor.selection.isCollapsed();
	            body = editor.getBody();
	            if (isCollapsed && !dom.isEmpty(body)) {
	              return;
	            }
	            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
	              return;
	            }
	            e.preventDefault();
	            editor.setContent('');
	            if (body.firstChild && dom.isBlock(body.firstChild)) {
	              editor.selection.setCursorLocation(body.firstChild, 0);
	            } else {
	              editor.selection.setCursorLocation(body, 0);
	            }
	            editor.nodeChanged();
	          }
	        });
	      };
	      var selectAll = function () {
	        editor.shortcuts.add('meta+a', null, 'SelectAll');
	      };
	      var inputMethodFocus = function () {
	        if (!editor.settings.content_editable) {
	          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
	            var rng;
	            if (e.target === editor.getDoc().documentElement) {
	              rng = selection.getRng();
	              editor.getBody().focus();
	              if (e.type === 'mousedown') {
	                if (isCaretContainer(rng.startContainer)) {
	                  return;
	                }
	                selection.placeCaretAt(e.clientX, e.clientY);
	              } else {
	                selection.setRng(rng);
	              }
	            }
	          });
	        }
	      };
	      var removeHrOnBackspace = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (!editor.getBody().getElementsByTagName('hr').length) {
	              return;
	            }
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var node = selection.getNode();
	              var previousSibling = node.previousSibling;
	              if (node.nodeName === 'HR') {
	                dom.remove(node);
	                e.preventDefault();
	                return;
	              }
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
	                dom.remove(previousSibling);
	                e.preventDefault();
	              }
	            }
	          }
	        });
	      };
	      var focusBody = function () {
	        if (!domGlobals.Range.prototype.getClientRects) {
	          editor.on('mousedown', function (e) {
	            if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
	              var body_1 = editor.getBody();
	              body_1.blur();
	              Delay.setEditorTimeout(editor, function () {
	                body_1.focus();
	              });
	            }
	          });
	        }
	      };
	      var selectControlElements = function () {
	        editor.on('click', function (e) {
	          var target = e.target;
	          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
	            e.preventDefault();
	            editor.selection.select(target);
	            editor.nodeChanged();
	          }
	          if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
	            e.preventDefault();
	            selection.select(target);
	          }
	        });
	      };
	      var removeStylesWhenDeletingAcrossBlockElements = function () {
	        var getAttributeApplyFunction = function () {
	          var template = dom.getAttribs(selection.getStart().cloneNode(false));
	          return function () {
	            var target = selection.getStart();
	            if (target !== editor.getBody()) {
	              dom.setAttrib(target, 'style', null);
	              each(template, function (attr) {
	                target.setAttributeNode(attr.cloneNode(true));
	              });
	            }
	          };
	        };
	        var isSelectionAcrossElements = function () {
	          return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
	        };
	        editor.on('keypress', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            editor.getDoc().execCommand('delete', false, null);
	            applyAttributes();
	            e.preventDefault();
	            return false;
	          }
	        });
	        dom.bind(editor.getDoc(), 'cut', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            Delay.setEditorTimeout(editor, function () {
	              applyAttributes();
	            });
	          }
	        });
	      };
	      var disableBackspaceIntoATable = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var previousSibling = selection.getNode().previousSibling;
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
	                e.preventDefault();
	                return false;
	              }
	            }
	          }
	        });
	      };
	      var removeBlockQuoteOnBackSpace = function () {
	        editor.on('keydown', function (e) {
	          var rng, container, offset, root, parent;
	          if (isDefaultPrevented(e) || e.keyCode !== VK.BACKSPACE) {
	            return;
	          }
	          rng = selection.getRng();
	          container = rng.startContainer;
	          offset = rng.startOffset;
	          root = dom.getRoot();
	          parent = container;
	          if (!rng.collapsed || offset !== 0) {
	            return;
	          }
	          while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
	            parent = parent.parentNode;
	          }
	          if (parent.tagName === 'BLOCKQUOTE') {
	            editor.formatter.toggle('blockquote', null, parent);
	            rng = dom.createRng();
	            rng.setStart(container, 0);
	            rng.setEnd(container, 0);
	            selection.setRng(rng);
	          }
	        });
	      };
	      var setGeckoEditingOptions = function () {
	        var setOpts = function () {
	          setEditorCommandState('StyleWithCSS', false);
	          setEditorCommandState('enableInlineTableEditing', false);
	          if (!settings.object_resizing) {
	            setEditorCommandState('enableObjectResizing', false);
	          }
	        };
	        if (!settings.readonly) {
	          editor.on('BeforeExecCommand MouseDown', setOpts);
	        }
	      };
	      var addBrAfterLastLinks = function () {
	        var fixLinks = function () {
	          each(dom.select('a'), function (node) {
	            var parentNode = node.parentNode;
	            var root = dom.getRoot();
	            if (parentNode.lastChild === node) {
	              while (parentNode && !dom.isBlock(parentNode)) {
	                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
	                  return;
	                }
	                parentNode = parentNode.parentNode;
	              }
	              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
	            }
	          });
	        };
	        editor.on('SetContent ExecCommand', function (e) {
	          if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
	            fixLinks();
	          }
	        });
	      };
	      var setDefaultBlockType = function () {
	        if (settings.forced_root_block) {
	          editor.on('init', function () {
	            setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block);
	          });
	        }
	      };
	      var normalizeSelection = function () {
	        editor.on('keyup focusin mouseup', function (e) {
	          if (!VK.modifierPressed(e)) {
	            selection.normalize();
	          }
	        }, true);
	      };
	      var showBrokenImageIcon = function () {
	        editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
	      };
	      var restoreFocusOnKeyDown = function () {
	        if (!editor.inline) {
	          editor.on('keydown', function () {
	            if (domGlobals.document.activeElement === domGlobals.document.body) {
	              editor.getWin().focus();
	            }
	          });
	        }
	      };
	      var bodyHeight = function () {
	        if (!editor.inline) {
	          editor.contentStyles.push('body {min-height: 150px}');
	          editor.on('click', function (e) {
	            var rng;
	            if (e.target.nodeName === 'HTML') {
	              if (Env.ie > 11) {
	                editor.getBody().focus();
	                return;
	              }
	              rng = editor.selection.getRng();
	              editor.getBody().focus();
	              editor.selection.setRng(rng);
	              editor.selection.normalize();
	              editor.nodeChanged();
	            }
	          });
	        }
	      };
	      var blockCmdArrowNavigation = function () {
	        if (Env.mac) {
	          editor.on('keydown', function (e) {
	            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
	              e.preventDefault();
	              editor.selection.getSel().modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
	            }
	          });
	        }
	      };
	      var disableAutoUrlDetect = function () {
	        setEditorCommandState('AutoUrlDetect', false);
	      };
	      var tapLinksAndImages = function () {
	        editor.on('click', function (e) {
	          var elm = e.target;
	          do {
	            if (elm.tagName === 'A') {
	              e.preventDefault();
	              return;
	            }
	          } while (elm = elm.parentNode);
	        });
	        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
	      };
	      var blockFormSubmitInsideEditor = function () {
	        editor.on('init', function () {
	          editor.dom.bind(editor.getBody(), 'submit', function (e) {
	            e.preventDefault();
	          });
	        });
	      };
	      var removeAppleInterchangeBrs = function () {
	        parser.addNodeFilter('br', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            if (nodes[i].attr('class') === 'Apple-interchange-newline') {
	              nodes[i].remove();
	            }
	          }
	        });
	      };
	      var ieInternalDragAndDrop = function () {
	        editor.on('dragstart', function (e) {
	          setMceInternalContent(e);
	        });
	        editor.on('drop', function (e) {
	          if (!isDefaultPrevented(e)) {
	            var internalContent = getMceInternalContent(e);
	            if (internalContent && internalContent.id !== editor.id) {
	              e.preventDefault();
	              var rng = CaretRangeFromPoint.fromPoint(e.x, e.y, editor.getDoc());
	              selection.setRng(rng);
	              insertClipboardContents(internalContent.html, true);
	            }
	          }
	        });
	      };
	      var refreshContentEditable = function () {
	      };
	      var isHidden = function () {
	        var sel;
	        if (!isGecko || editor.removed) {
	          return 0;
	        }
	        sel = editor.selection.getSel();
	        return !sel || !sel.rangeCount || sel.rangeCount === 0;
	      };
	      removeBlockQuoteOnBackSpace();
	      emptyEditorWhenDeleting();
	      if (!Env.windowsPhone) {
	        normalizeSelection();
	      }
	      if (isWebKit) {
	        inputMethodFocus();
	        selectControlElements();
	        setDefaultBlockType();
	        blockFormSubmitInsideEditor();
	        disableBackspaceIntoATable();
	        removeAppleInterchangeBrs();
	        if (Env.iOS) {
	          restoreFocusOnKeyDown();
	          bodyHeight();
	          tapLinksAndImages();
	        } else {
	          selectAll();
	        }
	      }
	      if (Env.ie >= 11) {
	        bodyHeight();
	        disableBackspaceIntoATable();
	      }
	      if (Env.ie) {
	        selectAll();
	        disableAutoUrlDetect();
	        ieInternalDragAndDrop();
	      }
	      if (isGecko) {
	        removeHrOnBackspace();
	        focusBody();
	        removeStylesWhenDeletingAcrossBlockElements();
	        setGeckoEditingOptions();
	        addBrAfterLastLinks();
	        showBrokenImageIcon();
	        blockCmdArrowNavigation();
	        disableBackspaceIntoATable();
	      }
	      return {
	        refreshContentEditable: refreshContentEditable,
	        isHidden: isHidden
	      };
	    }
	
	    var isTextBlockNode = function (node) {
	      return NodeType.isElement(node) && isTextBlock(Element.fromDom(node));
	    };
	    var normalizeSelection$1 = function (editor) {
	      var rng = editor.selection.getRng();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      if (CaretPosition.isElementPosition(startPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          CaretFinder.firstPositionIn(container).each(function (pos) {
	            return rng.setStart(pos.container(), pos.offset());
	          });
	        }
	      }
	      if (CaretPosition.isElementPosition(endPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          CaretFinder.lastPositionIn(container).each(function (pos) {
	            return rng.setEnd(pos.container(), pos.offset());
	          });
	        }
	      }
	      editor.selection.setRng(RangeNormalizer.normalize(rng));
	    };
	    var setup$f = function (editor) {
	      editor.on('click', function (e) {
	        if (e.detail >= 3) {
	          normalizeSelection$1(editor);
	        }
	      });
	    };
	
	    var preventSummaryToggle = function (editor) {
	      editor.on('click', function (e) {
	        if (editor.dom.getParent(e.target, 'details')) {
	          e.preventDefault();
	        }
	      });
	    };
	    var filterDetails = function (editor) {
	      editor.parser.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          details.attr('data-mce-open', details.attr('open'));
	          details.attr('open', 'open');
	        });
	      });
	      editor.serializer.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          var open = details.attr('data-mce-open');
	          details.attr('open', isString(open) ? open : null);
	          details.attr('data-mce-open', null);
	        });
	      });
	    };
	    var setup$g = function (editor) {
	      preventSummaryToggle(editor);
	      filterDetails(editor);
	    };
	
	    var DOM$2 = DOMUtils$1.DOM;
	    var appendStyle = function (editor, text) {
	      var head = Element.fromDom(editor.getDoc().head);
	      var tag = Element.fromTag('style');
	      set(tag, 'type', 'text/css');
	      append(tag, Element.fromText(text));
	      append(head, tag);
	    };
	    var createParser = function (editor) {
	      var parser = DomParser(editor.settings, editor.schema);
	      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	        var dom = editor.dom;
	        var value, internalName;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(name);
	          internalName = 'data-mce-' + name;
	          if (!node.attributes.map[internalName]) {
	            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
	              continue;
	            }
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	              if (!value.length) {
	                value = null;
	              }
	              node.attr(internalName, value);
	              node.attr(name, value);
	            } else if (name === 'tabindex') {
	              node.attr(internalName, value);
	              node.attr(name, null);
	            } else {
	              node.attr(internalName, editor.convertURL(value, name, node.name));
	            }
	          }
	        }
	      });
	      parser.addNodeFilter('script', function (nodes) {
	        var i = nodes.length, node, type;
	        while (i--) {
	          node = nodes[i];
	          type = node.attr('type') || 'no/type';
	          if (type.indexOf('mce-') !== 0) {
	            node.attr('type', 'mce-' + type);
	          }
	        }
	      });
	      parser.addNodeFilter('#cdata', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.type = 8;
	          node.name = '#comment';
	          node.value = '[CDATA[' + node.value + ']]';
	        }
	      });
	      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
	        var i = nodes.length, node;
	        var nonEmptyElements = editor.schema.getNonEmptyElements();
	        while (i--) {
	          node = nodes[i];
	          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
	            node.append(new Node$1('br', 1)).shortEnded = true;
	          }
	        }
	      });
	      return parser;
	    };
	    var autoFocus = function (editor) {
	      if (editor.settings.auto_focus) {
	        Delay.setEditorTimeout(editor, function () {
	          var focusEditor;
	          if (editor.settings.auto_focus === true) {
	            focusEditor = editor;
	          } else {
	            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
	          }
	          if (!focusEditor.destroyed) {
	            focusEditor.focus();
	          }
	        }, 100);
	      }
	    };
	    var initEditor = function (editor) {
	      editor.bindPendingEventDelegates();
	      editor.initialized = true;
	      editor.fire('init');
	      editor.focus(true);
	      editor.nodeChanged({ initial: true });
	      editor.execCallback('init_instance_callback', editor);
	      autoFocus(editor);
	    };
	    var getStyleSheetLoader = function (editor) {
	      return editor.inline ? DOM$2.styleSheetLoader : editor.dom.styleSheetLoader;
	    };
	    var initContentBody = function (editor, skipWrite) {
	      var settings = editor.settings;
	      var targetElm = editor.getElement();
	      var doc = editor.getDoc(), body, contentCssText;
	      if (!settings.inline) {
	        editor.getElement().style.visibility = editor.orgVisibility;
	      }
	      if (!skipWrite && !settings.content_editable) {
	        doc.open();
	        doc.write(editor.iframeHTML);
	        doc.close();
	      }
	      if (settings.content_editable) {
	        editor.on('remove', function () {
	          var bodyEl = this.getBody();
	          DOM$2.removeClass(bodyEl, 'mce-content-body');
	          DOM$2.removeClass(bodyEl, 'mce-edit-focus');
	          DOM$2.setAttrib(bodyEl, 'contentEditable', null);
	        });
	        DOM$2.addClass(targetElm, 'mce-content-body');
	        editor.contentDocument = doc = settings.content_document || domGlobals.document;
	        editor.contentWindow = settings.content_window || domGlobals.window;
	        editor.bodyElement = targetElm;
	        settings.content_document = settings.content_window = null;
	        settings.root_name = targetElm.nodeName.toLowerCase();
	      }
	      body = editor.getBody();
	      body.disabled = true;
	      editor.readonly = settings.readonly;
	      if (!editor.readonly) {
	        if (editor.inline && DOM$2.getStyle(body, 'position', true) === 'static') {
	          body.style.position = 'relative';
	        }
	        body.contentEditable = editor.getParam('content_editable_state', true);
	      }
	      body.disabled = false;
	      editor.editorUpload = EditorUpload(editor);
	      editor.schema = Schema(settings);
	      editor.dom = DOMUtils$1(doc, {
	        keep_values: true,
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        hex_colors: settings.force_hex_style_colors,
	        class_filter: settings.class_filter,
	        update_styles: true,
	        root_element: editor.inline ? editor.getBody() : null,
	        collect: settings.content_editable,
	        schema: editor.schema,
	        contentCssCors: Settings.shouldUseContentCssCors(editor),
	        onSetAttrib: function (e) {
	          editor.fire('SetAttrib', e);
	        }
	      });
	      editor.parser = createParser(editor);
	      editor.serializer = DomSerializer$1(settings, editor);
	      editor.selection = Selection$1(editor.dom, editor.getWin(), editor.serializer, editor);
	      editor.annotator = Annotator(editor);
	      editor.formatter = Formatter(editor);
	      editor.undoManager = UndoManager(editor);
	      editor._nodeChangeDispatcher = new NodeChange(editor);
	      editor._selectionOverrides = SelectionOverrides(editor);
	      setup$g(editor);
	      setup$f(editor);
	      KeyboardOverrides.setup(editor);
	      ForceBlocks.setup(editor);
	      editor.fire('PreInit');
	      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
	        doc.body.spellcheck = false;
	        DOM$2.setAttrib(body, 'spellcheck', 'false');
	      }
	      editor.quirks = Quirks(editor);
	      editor.fire('PostRender');
	      if (settings.directionality) {
	        body.dir = settings.directionality;
	      }
	      if (settings.nowrap) {
	        body.style.whiteSpace = 'nowrap';
	      }
	      if (settings.protect) {
	        editor.on('BeforeSetContent', function (e) {
	          Tools.each(settings.protect, function (pattern) {
	            e.content = e.content.replace(pattern, function (str) {
	              return '<!--mce:protected ' + escape(str) + '-->';
	            });
	          });
	        });
	      }
	      editor.on('SetContent', function () {
	        editor.addVisual(editor.getBody());
	      });
	      editor.load({
	        initial: true,
	        format: 'html'
	      });
	      editor.startContent = editor.getContent({ format: 'raw' });
	      editor.on('compositionstart compositionend', function (e) {
	        editor.composing = e.type === 'compositionstart';
	      });
	      if (editor.contentStyles.length > 0) {
	        contentCssText = '';
	        Tools.each(editor.contentStyles, function (style) {
	          contentCssText += style + '\r\n';
	        });
	        editor.dom.addStyle(contentCssText);
	      }
	      getStyleSheetLoader(editor).loadAll(editor.contentCSS, function (_) {
	        initEditor(editor);
	      }, function (urls) {
	        initEditor(editor);
	      });
	      if (settings.content_style) {
	        appendStyle(editor, settings.content_style);
	      }
	    };
	    var InitContentBody = { initContentBody: initContentBody };
	
	    var DOM$3 = DOMUtils$1.DOM;
	    var relaxDomain = function (editor, ifr) {
	      if (domGlobals.document.domain !== domGlobals.window.location.hostname && Env.ie && Env.ie < 12) {
	        var bodyUuid = Uuid.uuid('mce');
	        editor[bodyUuid] = function () {
	          InitContentBody.initContentBody(editor);
	        };
	        var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + domGlobals.document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
	        DOM$3.setAttrib(ifr, 'src', domainRelaxUrl);
	        return true;
	      }
	      return false;
	    };
	    var normalizeHeight = function (height) {
	      var normalizedHeight = typeof height === 'number' ? height + 'px' : height;
	      return normalizedHeight ? normalizedHeight : '';
	    };
	    var createIframeElement = function (id, title, height, customAttrs) {
	      var iframe = Element.fromTag('iframe');
	      setAll(iframe, customAttrs);
	      setAll(iframe, {
	        id: id + '_ifr',
	        frameBorder: '0',
	        allowTransparency: 'true',
	        title: title
	      });
	      setAll$1(iframe, {
	        width: '100%',
	        height: normalizeHeight(height),
	        display: 'block'
	      });
	      return iframe;
	    };
	    var getIframeHtml = function (editor) {
	      var bodyId, bodyClass, iframeHTML;
	      iframeHTML = Settings.getDocType(editor) + '<html><head>';
	      if (Settings.getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
	        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
	      }
	      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	      bodyId = Settings.getBodyId(editor);
	      bodyClass = Settings.getBodyClass(editor);
	      if (Settings.getContentSecurityPolicy(editor)) {
	        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + Settings.getContentSecurityPolicy(editor) + '" />';
	      }
	      iframeHTML += '</head><body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '"><br></body></html>';
	      return iframeHTML;
	    };
	    var createIframe = function (editor, o) {
	      var title = editor.editorManager.translate('Rich Text Area. Press ALT-F9 for menu. ' + 'Press ALT-F10 for toolbar. Press ALT-0 for help');
	      var ifr = createIframeElement(editor.id, title, o.height, Settings.getIframeAttrs(editor)).dom();
	      ifr.onload = function () {
	        ifr.onload = null;
	        editor.fire('load');
	      };
	      var isDomainRelaxed = relaxDomain(editor, ifr);
	      editor.contentAreaContainer = o.iframeContainer;
	      editor.iframeElement = ifr;
	      editor.iframeHTML = getIframeHtml(editor);
	      DOM$3.add(o.iframeContainer, ifr);
	      return isDomainRelaxed;
	    };
	    var init$1 = function (editor, boxInfo) {
	      var isDomainRelaxed = createIframe(editor, boxInfo);
	      if (boxInfo.editorContainer) {
	        DOM$3.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
	        editor.hidden = DOM$3.isHidden(boxInfo.editorContainer);
	      }
	      editor.getElement().style.display = 'none';
	      DOM$3.setAttrib(editor.id, 'aria-hidden', 'true');
	      if (!isDomainRelaxed) {
	        InitContentBody.initContentBody(editor);
	      }
	    };
	    var InitIframe = { init: init$1 };
	
	    var DOM$4 = DOMUtils$1.DOM;
	    var initPlugin = function (editor, initializedPlugins, plugin) {
	      var Plugin = PluginManager$1.get(plugin);
	      var pluginUrl = PluginManager$1.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
	      plugin = Tools.trim(plugin);
	      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
	        Tools.each(PluginManager$1.dependencies(plugin), function (dep) {
	          initPlugin(editor, initializedPlugins, dep);
	        });
	        if (editor.plugins[plugin]) {
	          return;
	        }
	        try {
	          var pluginInstance = new Plugin(editor, pluginUrl, editor.$);
	          editor.plugins[plugin] = pluginInstance;
	          if (pluginInstance.init) {
	            pluginInstance.init(editor, pluginUrl);
	            initializedPlugins.push(plugin);
	          }
	        } catch (e) {
	          ErrorReporter.pluginInitError(editor, plugin, e);
	        }
	      }
	    };
	    var trimLegacyPrefix = function (name) {
	      return name.replace(/^\-/, '');
	    };
	    var initPlugins = function (editor) {
	      var initializedPlugins = [];
	      Tools.each(editor.settings.plugins.split(/[ ,]/), function (name) {
	        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
	      });
	    };
	    var initTheme = function (editor) {
	      var Theme;
	      var theme = editor.settings.theme;
	      if (isString(theme)) {
	        editor.settings.theme = trimLegacyPrefix(theme);
	        Theme = ThemeManager.get(theme);
	        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
	        if (editor.theme.init) {
	          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
	        }
	      } else {
	        editor.theme = {};
	      }
	    };
	    var renderFromLoadedTheme = function (editor) {
	      var w, h, minHeight, re, info;
	      var settings = editor.settings;
	      var elm = editor.getElement();
	      w = settings.width || DOM$4.getStyle(elm, 'width') || '100%';
	      h = settings.height || DOM$4.getStyle(elm, 'height') || elm.offsetHeight;
	      minHeight = settings.min_height || 100;
	      re = /^[0-9\.]+(|px)$/i;
	      if (re.test('' + w)) {
	        w = Math.max(parseInt(w, 10), 100);
	      }
	      if (re.test('' + h)) {
	        h = Math.max(parseInt(h, 10), minHeight);
	      }
	      info = editor.theme.renderUI({
	        targetNode: elm,
	        width: w,
	        height: h,
	        deltaWidth: settings.delta_width,
	        deltaHeight: settings.delta_height
	      });
	      if (!settings.content_editable) {
	        h = (info.iframeHeight || h) + (typeof h === 'number' ? info.deltaHeight || 0 : '');
	        if (h < minHeight) {
	          h = minHeight;
	        }
	      }
	      info.height = h;
	      return info;
	    };
	    var renderFromThemeFunc = function (editor) {
	      var info;
	      var elm = editor.getElement();
	      info = editor.settings.theme(editor, elm);
	      if (info.editorContainer.nodeType) {
	        info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
	      }
	      if (info.iframeContainer && info.iframeContainer.nodeType) {
	        info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
	      }
	      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
	      return info;
	    };
	    var createThemeFalseResult = function (element) {
	      return {
	        editorContainer: element,
	        iframeContainer: element
	      };
	    };
	    var renderThemeFalseIframe = function (targetElement) {
	      var iframeContainer = DOM$4.create('div');
	      DOM$4.insertAfter(iframeContainer, targetElement);
	      return createThemeFalseResult(iframeContainer);
	    };
	    var renderThemeFalse = function (editor) {
	      var targetElement = editor.getElement();
	      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
	    };
	    var renderThemeUi = function (editor) {
	      var settings = editor.settings, elm = editor.getElement();
	      editor.orgDisplay = elm.style.display;
	      if (isString(settings.theme)) {
	        return renderFromLoadedTheme(editor);
	      } else if (isFunction(settings.theme)) {
	        return renderFromThemeFunc(editor);
	      } else {
	        return renderThemeFalse(editor);
	      }
	    };
	    var init$2 = function (editor) {
	      var settings = editor.settings;
	      var elm = editor.getElement();
	      var boxInfo;
	      editor.rtl = settings.rtl_ui || editor.editorManager.i18n.rtl;
	      editor.editorManager.i18n.setCode(settings.language);
	      settings.aria_label = settings.aria_label || DOM$4.getAttrib(elm, 'aria-label', editor.getLang('aria.rich_text_area'));
	      editor.fire('ScriptsLoaded');
	      initTheme(editor);
	      initPlugins(editor);
	      boxInfo = renderThemeUi(editor);
	      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
	      if (settings.content_css) {
	        Tools.each(Tools.explode(settings.content_css), function (u) {
	          editor.contentCSS.push(editor.documentBaseURI.toAbsolute(u));
	        });
	      }
	      if (settings.content_editable) {
	        return InitContentBody.initContentBody(editor);
	      } else {
	        return InitIframe.init(editor, boxInfo);
	      }
	    };
	    var Init = { init: init$2 };
	
	    var DOM$5 = DOMUtils$1.DOM;
	    var hasSkipLoadPrefix = function (name) {
	      return name.charAt(0) === '-';
	    };
	    var loadLanguage = function (scriptLoader, editor) {
	      var settings = editor.settings;
	      if (settings.language && settings.language !== 'en' && !settings.language_url) {
	        settings.language_url = editor.editorManager.baseURL + '/langs/' + settings.language + '.js';
	      }
	      if (settings.language_url && !editor.editorManager.i18n.data[settings.language]) {
	        scriptLoader.add(settings.language_url);
	      }
	    };
	    var loadTheme = function (scriptLoader, editor, suffix, callback) {
	      var settings = editor.settings, theme = settings.theme;
	      if (isString(theme)) {
	        if (!hasSkipLoadPrefix(theme) && !ThemeManager.urls.hasOwnProperty(theme)) {
	          var themeUrl = settings.theme_url;
	          if (themeUrl) {
	            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
	          } else {
	            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
	          }
	        }
	        scriptLoader.loadQueue(function () {
	          ThemeManager.waitFor(theme, callback);
	        });
	      } else {
	        callback();
	      }
	    };
	    var loadPlugins = function (settings, suffix) {
	      if (Tools.isArray(settings.plugins)) {
	        settings.plugins = settings.plugins.join(' ');
	      }
	      Tools.each(settings.external_plugins, function (url, name) {
	        PluginManager$1.load(name, url);
	        settings.plugins += ' ' + name;
	      });
	      Tools.each(settings.plugins.split(/[ ,]/), function (plugin) {
	        plugin = Tools.trim(plugin);
	        if (plugin && !PluginManager$1.urls[plugin]) {
	          if (hasSkipLoadPrefix(plugin)) {
	            plugin = plugin.substr(1, plugin.length);
	            var dependencies = PluginManager$1.dependencies(plugin);
	            Tools.each(dependencies, function (dep) {
	              var defaultSettings = {
	                prefix: 'plugins/',
	                resource: dep,
	                suffix: '/plugin' + suffix + '.js'
	              };
	              dep = PluginManager$1.createUrl(defaultSettings, dep);
	              PluginManager$1.load(dep.resource, dep);
	            });
	          } else {
	            PluginManager$1.load(plugin, {
	              prefix: 'plugins/',
	              resource: plugin,
	              suffix: '/plugin' + suffix + '.js'
	            });
	          }
	        }
	      });
	    };
	    var loadScripts = function (editor, suffix) {
	      var scriptLoader = ScriptLoader.ScriptLoader;
	      loadTheme(scriptLoader, editor, suffix, function () {
	        loadLanguage(scriptLoader, editor);
	        loadPlugins(editor.settings, suffix);
	        scriptLoader.loadQueue(function () {
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        }, editor, function (urls) {
	          ErrorReporter.pluginLoadError(editor, urls[0]);
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        });
	      });
	    };
	    var render = function (editor) {
	      var settings = editor.settings, id = editor.id;
	      var readyHandler = function () {
	        DOM$5.unbind(domGlobals.window, 'ready', readyHandler);
	        editor.render();
	      };
	      if (!EventUtils.Event.domLoaded) {
	        DOM$5.bind(domGlobals.window, 'ready', readyHandler);
	        return;
	      }
	      if (!editor.getElement()) {
	        return;
	      }
	      if (!Env.contentEditable) {
	        return;
	      }
	      if (!settings.inline) {
	        editor.orgVisibility = editor.getElement().style.visibility;
	        editor.getElement().style.visibility = 'hidden';
	      } else {
	        editor.inline = true;
	      }
	      var form = editor.getElement().form || DOM$5.getParent(id, 'form');
	      if (form) {
	        editor.formElement = form;
	        if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(editor.getElement().nodeName)) {
	          DOM$5.insertAfter(DOM$5.create('input', {
	            type: 'hidden',
	            name: id
	          }), id);
	          editor.hasHiddenInput = true;
	        }
	        editor.formEventDelegate = function (e) {
	          editor.fire(e.type, e);
	        };
	        DOM$5.bind(form, 'submit reset', editor.formEventDelegate);
	        editor.on('reset', function () {
	          editor.setContent(editor.startContent, { format: 'raw' });
	        });
	        if (settings.submit_patch && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
	          form._mceOldSubmit = form.submit;
	          form.submit = function () {
	            editor.editorManager.triggerSave();
	            editor.setDirty(false);
	            return form._mceOldSubmit(form);
	          };
	        }
	      }
	      editor.windowManager = WindowManager(editor);
	      editor.notificationManager = NotificationManager(editor);
	      if (settings.encoding === 'xml') {
	        editor.on('GetContent', function (e) {
	          if (e.save) {
	            e.content = DOM$5.encode(e.content);
	          }
	        });
	      }
	      if (settings.add_form_submit_trigger) {
	        editor.on('submit', function () {
	          if (editor.initialized) {
	            editor.save();
	          }
	        });
	      }
	      if (settings.add_unload_trigger) {
	        editor._beforeUnload = function () {
	          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
	            editor.save({
	              format: 'raw',
	              no_events: true,
	              set_dirty: false
	            });
	          }
	        };
	        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
	      }
	      editor.editorManager.add(editor);
	      loadScripts(editor, editor.suffix);
	    };
	    var Render = { render: render };
	
	    var add$4 = function (editor, name, settings) {
	      var sidebars = editor.sidebars ? editor.sidebars : [];
	      sidebars.push({
	        name: name,
	        settings: settings
	      });
	      editor.sidebars = sidebars;
	    };
	    var Sidebar = { add: add$4 };
	
	    var each$k = Tools.each, trim$4 = Tools.trim;
	    var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
	    var DEFAULT_PORTS = {
	      ftp: 21,
	      http: 80,
	      https: 443,
	      mailto: 25
	    };
	    var URI = function (url, settings) {
	      var self = this;
	      var baseUri, baseUrl;
	      url = trim$4(url);
	      settings = self.settings = settings || {};
	      baseUri = settings.base_uri;
	      if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
	        self.source = url;
	        return;
	      }
	      var isProtocolRelative = url.indexOf('//') === 0;
	      if (url.indexOf('/') === 0 && !isProtocolRelative) {
	        url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
	      }
	      if (!/^[\w\-]*:?\/\//.test(url)) {
	        baseUrl = settings.base_uri ? settings.base_uri.path : new URI(domGlobals.document.location.href).directory;
	        if (settings.base_uri.protocol == '') {
	          url = '//mce_host' + self.toAbsPath(baseUrl, url);
	        } else {
	          url = /([^#?]*)([#?]?.*)/.exec(url);
	          url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, url[1]) + url[2];
	        }
	      }
	      url = url.replace(/@@/g, '(mce_at)');
	      url = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	      each$k(queryParts, function (v, i) {
	        var part = url[i];
	        if (part) {
	          part = part.replace(/\(mce_at\)/g, '@@');
	        }
	        self[v] = part;
	      });
	      if (baseUri) {
	        if (!self.protocol) {
	          self.protocol = baseUri.protocol;
	        }
	        if (!self.userInfo) {
	          self.userInfo = baseUri.userInfo;
	        }
	        if (!self.port && self.host === 'mce_host') {
	          self.port = baseUri.port;
	        }
	        if (!self.host || self.host === 'mce_host') {
	          self.host = baseUri.host;
	        }
	        self.source = '';
	      }
	      if (isProtocolRelative) {
	        self.protocol = '';
	      }
	    };
	    URI.prototype = {
	      setPath: function (path) {
	        var self = this;
	        path = /^(.*?)\/?(\w+)?$/.exec(path);
	        self.path = path[0];
	        self.directory = path[1];
	        self.file = path[2];
	        self.source = '';
	        self.getURI();
	      },
	      toRelative: function (uri) {
	        var self = this;
	        var output;
	        if (uri === './') {
	          return uri;
	        }
	        uri = new URI(uri, { base_uri: self });
	        if (uri.host !== 'mce_host' && self.host !== uri.host && uri.host || self.port !== uri.port || self.protocol !== uri.protocol && uri.protocol !== '') {
	          return uri.getURI();
	        }
	        var tu = self.getURI(), uu = uri.getURI();
	        if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
	          return tu;
	        }
	        output = self.toRelPath(self.path, uri.path);
	        if (uri.query) {
	          output += '?' + uri.query;
	        }
	        if (uri.anchor) {
	          output += '#' + uri.anchor;
	        }
	        return output;
	      },
	      toAbsolute: function (uri, noHost) {
	        uri = new URI(uri, { base_uri: this });
	        return uri.getURI(noHost && this.isSameOrigin(uri));
	      },
	      isSameOrigin: function (uri) {
	        if (this.host == uri.host && this.protocol == uri.protocol) {
	          if (this.port == uri.port) {
	            return true;
	          }
	          var defaultPort = DEFAULT_PORTS[this.protocol];
	          if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
	            return true;
	          }
	        }
	        return false;
	      },
	      toRelPath: function (base, path) {
	        var items, breakPoint = 0, out = '', i, l;
	        base = base.substring(0, base.lastIndexOf('/'));
	        base = base.split('/');
	        items = path.split('/');
	        if (base.length >= items.length) {
	          for (i = 0, l = base.length; i < l; i++) {
	            if (i >= items.length || base[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (base.length < items.length) {
	          for (i = 0, l = items.length; i < l; i++) {
	            if (i >= base.length || base[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (breakPoint === 1) {
	          return path;
	        }
	        for (i = 0, l = base.length - (breakPoint - 1); i < l; i++) {
	          out += '../';
	        }
	        for (i = breakPoint - 1, l = items.length; i < l; i++) {
	          if (i !== breakPoint - 1) {
	            out += '/' + items[i];
	          } else {
	            out += items[i];
	          }
	        }
	        return out;
	      },
	      toAbsPath: function (base, path) {
	        var i, nb = 0, o = [], tr, outPath;
	        tr = /\/$/.test(path) ? '/' : '';
	        base = base.split('/');
	        path = path.split('/');
	        each$k(base, function (k) {
	          if (k) {
	            o.push(k);
	          }
	        });
	        base = o;
	        for (i = path.length - 1, o = []; i >= 0; i--) {
	          if (path[i].length === 0 || path[i] === '.') {
	            continue;
	          }
	          if (path[i] === '..') {
	            nb++;
	            continue;
	          }
	          if (nb > 0) {
	            nb--;
	            continue;
	          }
	          o.push(path[i]);
	        }
	        i = base.length - nb;
	        if (i <= 0) {
	          outPath = o.reverse().join('/');
	        } else {
	          outPath = base.slice(0, i).join('/') + '/' + o.reverse().join('/');
	        }
	        if (outPath.indexOf('/') !== 0) {
	          outPath = '/' + outPath;
	        }
	        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
	          outPath += tr;
	        }
	        return outPath;
	      },
	      getURI: function (noProtoHost) {
	        var s;
	        var self = this;
	        if (!self.source || noProtoHost) {
	          s = '';
	          if (!noProtoHost) {
	            if (self.protocol) {
	              s += self.protocol + '://';
	            } else {
	              s += '//';
	            }
	            if (self.userInfo) {
	              s += self.userInfo + '@';
	            }
	            if (self.host) {
	              s += self.host;
	            }
	            if (self.port) {
	              s += ':' + self.port;
	            }
	          }
	          if (self.path) {
	            s += self.path;
	          }
	          if (self.query) {
	            s += '?' + self.query;
	          }
	          if (self.anchor) {
	            s += '#' + self.anchor;
	          }
	          self.source = s;
	        }
	        return self.source;
	      }
	    };
	    URI.parseDataUri = function (uri) {
	      var type, matches;
	      uri = decodeURIComponent(uri).split(',');
	      matches = /data:([^;]+)/.exec(uri[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uri[1]
	      };
	    };
	    URI.getDocumentBaseUrl = function (loc) {
	      var baseUrl;
	      if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
	        baseUrl = loc.href;
	      } else {
	        baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
	      }
	      if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
	        baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	        if (!/[\/\\]$/.test(baseUrl)) {
	          baseUrl += '/';
	        }
	      }
	      return baseUrl;
	    };
	
	    var defaultFormat = 'html';
	    var trimEmptyContents = function (editor, html) {
	      var blockName = Settings.getForcedRootBlock(editor);
	      var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
	      return html.replace(emptyRegExp, '');
	    };
	    var getContentFromBody = function (editor, args, body) {
	      var content;
	      args.format = args.format ? args.format : defaultFormat;
	      args.get = true;
	      args.getInner = true;
	      if (!args.no_events) {
	        editor.fire('BeforeGetContent', args);
	      }
	      if (args.format === 'raw') {
	        content = Tools.trim(TrimHtml.trimExternal(editor.serializer, body.innerHTML));
	      } else if (args.format === 'text') {
	        content = Zwsp.trim(body.innerText || body.textContent);
	      } else if (args.format === 'tree') {
	        return editor.serializer.serialize(body, args);
	      } else {
	        content = trimEmptyContents(editor, editor.serializer.serialize(body, args));
	      }
	      if (args.format !== 'text' && !isWsPreserveElement(Element.fromDom(body))) {
	        args.content = Tools.trim(content);
	      } else {
	        args.content = content;
	      }
	      if (!args.no_events) {
	        editor.fire('GetContent', args);
	      }
	      return args.content;
	    };
	    var getContent$1 = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      return Option.from(editor.getBody()).fold(constant(args.format === 'tree' ? new Node$1('body', 11) : ''), function (body) {
	        return getContentFromBody(editor, args, body);
	      });
	    };
	
	    var traverse = function (node, fn) {
	      fn(node);
	      if (node.firstChild) {
	        traverse(node.firstChild, fn);
	      }
	      if (node.next) {
	        traverse(node.next, fn);
	      }
	    };
	    var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
	      var nodeMatches = {};
	      var attrMatches = {};
	      var matches = [];
	      if (node.firstChild) {
	        traverse(node.firstChild, function (node) {
	          each(nodeFilters, function (filter) {
	            if (filter.name === node.name) {
	              if (nodeMatches[filter.name]) {
	                nodeMatches[filter.name].nodes.push(node);
	              } else {
	                nodeMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	          each(attributeFilters, function (filter) {
	            if (typeof node.attr(filter.name) === 'string') {
	              if (attrMatches[filter.name]) {
	                attrMatches[filter.name].nodes.push(node);
	              } else {
	                attrMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	        });
	      }
	      for (var name in nodeMatches) {
	        if (nodeMatches.hasOwnProperty(name)) {
	          matches.push(nodeMatches[name]);
	        }
	      }
	      for (var name in attrMatches) {
	        if (attrMatches.hasOwnProperty(name)) {
	          matches.push(attrMatches[name]);
	        }
	      }
	      return matches;
	    };
	    var filter$3 = function (nodeFilters, attributeFilters, node) {
	      var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
	      each(matches, function (match) {
	        each(match.filter.callbacks, function (callback) {
	          callback(match.nodes, match.filter.name, {});
	        });
	      });
	    };
	
	    var defaultFormat$1 = 'html';
	    var isTreeNode = function (content) {
	      return content instanceof Node$1;
	    };
	    var moveSelection = function (editor) {
	      if (EditorFocus.hasFocus(editor)) {
	        CaretFinder.firstPositionIn(editor.getBody()).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = NodeType.isTable(node) ? CaretFinder.firstPositionIn(node).getOr(pos) : pos;
	          editor.selection.setRng(caretPos.toRange());
	        });
	      }
	    };
	    var setEditorHtml = function (editor, html) {
	      editor.dom.setHTML(editor.getBody(), html);
	      moveSelection(editor);
	    };
	    var setContentString = function (editor, body, content, args) {
	      var forcedRootBlockName, padd;
	      if (content.length === 0 || /^\s+$/.test(content)) {
	        padd = '<br data-mce-bogus="1">';
	        if (body.nodeName === 'TABLE') {
	          content = '<tr><td>' + padd + '</td></tr>';
	        } else if (/^(UL|OL)$/.test(body.nodeName)) {
	          content = '<li>' + padd + '</li>';
	        }
	        forcedRootBlockName = Settings.getForcedRootBlock(editor);
	        if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
	          content = padd;
	          content = editor.dom.createHTML(forcedRootBlockName, editor.settings.forced_root_block_attrs, content);
	        } else if (!content) {
	          content = '<br data-mce-bogus="1">';
	        }
	        setEditorHtml(editor, content);
	        editor.fire('SetContent', args);
	      } else {
	        if (args.format !== 'raw') {
	          content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
	            isRootContent: true,
	            insert: true
	          }));
	        }
	        args.content = isWsPreserveElement(Element.fromDom(body)) ? content : Tools.trim(content);
	        setEditorHtml(editor, args.content);
	        if (!args.no_events) {
	          editor.fire('SetContent', args);
	        }
	      }
	      return args.content;
	    };
	    var setContentTree = function (editor, body, content, args) {
	      filter$3(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
	      var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
	      args.content = isWsPreserveElement(Element.fromDom(body)) ? html : Tools.trim(html);
	      setEditorHtml(editor, args.content);
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	      return content;
	    };
	    var setContent$1 = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      args.format = args.format ? args.format : defaultFormat$1;
	      args.set = true;
	      args.content = isTreeNode(content) ? '' : content;
	      if (!isTreeNode(content) && !args.no_events) {
	        editor.fire('BeforeSetContent', args);
	        content = args.content;
	      }
	      return Option.from(editor.getBody()).fold(constant(content), function (body) {
	        return isTreeNode(content) ? setContentTree(editor, body, content, args) : setContentString(editor, body, content, args);
	      });
	    };
	
	    var DOM$6 = DOMUtils$1.DOM;
	    var restoreOriginalStyles = function (editor) {
	      DOM$6.setStyle(editor.id, 'display', editor.orgDisplay);
	    };
	    var safeDestroy = function (x) {
	      return Option.from(x).each(function (x) {
	        return x.destroy();
	      });
	    };
	    var clearDomReferences = function (editor) {
	      editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
	      editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
	      editor.iframeElement = editor.targetElm = null;
	      if (editor.selection) {
	        editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
	      }
	    };
	    var restoreForm = function (editor) {
	      var form = editor.formElement;
	      if (form) {
	        if (form._mceOldSubmit) {
	          form.submit = form._mceOldSubmit;
	          form._mceOldSubmit = null;
	        }
	        DOM$6.unbind(form, 'submit reset', editor.formEventDelegate);
	      }
	    };
	    var remove$7 = function (editor) {
	      if (!editor.removed) {
	        var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
	        var body = editor.getBody();
	        var element = editor.getElement();
	        if (body) {
	          editor.save({ is_removing: true });
	        }
	        editor.removed = true;
	        editor.unbindAllNativeEvents();
	        if (editor.hasHiddenInput && element) {
	          DOM$6.remove(element.nextSibling);
	        }
	        Events.fireRemove(editor);
	        editor.editorManager.remove(editor);
	        if (!editor.inline && body) {
	          restoreOriginalStyles(editor);
	        }
	        Events.fireDetach(editor);
	        DOM$6.remove(editor.getContainer());
	        safeDestroy(_selectionOverrides);
	        safeDestroy(editorUpload);
	        editor.destroy();
	      }
	    };
	    var destroy = function (editor, automatic) {
	      var selection = editor.selection, dom = editor.dom;
	      if (editor.destroyed) {
	        return;
	      }
	      if (!automatic && !editor.removed) {
	        editor.remove();
	        return;
	      }
	      if (!automatic) {
	        editor.editorManager.off('beforeunload', editor._beforeUnload);
	        if (editor.theme && editor.theme.destroy) {
	          editor.theme.destroy();
	        }
	        safeDestroy(selection);
	        safeDestroy(dom);
	      }
	      restoreForm(editor);
	      clearDomReferences(editor);
	      editor.destroyed = true;
	    };
	
	    var DOM$7 = DOMUtils$1.DOM;
	    var extend$4 = Tools.extend, each$l = Tools.each;
	    var resolve$4 = Tools.resolve;
	    var ie$2 = Env.ie;
	    var Editor = function (id, settings, editorManager) {
	      var self = this;
	      var documentBaseUrl = self.documentBaseUrl = editorManager.documentBaseURL;
	      var baseUri = editorManager.baseURI;
	      settings = getEditorSettings(self, id, documentBaseUrl, editorManager.defaultSettings, settings);
	      self.settings = settings;
	      AddOnManager.language = settings.language || 'en';
	      AddOnManager.languageLoad = settings.language_load;
	      AddOnManager.baseURL = editorManager.baseURL;
	      self.id = id;
	      self.setDirty(false);
	      self.plugins = {};
	      self.documentBaseURI = new URI(settings.document_base_url, { base_uri: baseUri });
	      self.baseURI = baseUri;
	      self.contentCSS = [];
	      self.contentStyles = [];
	      self.shortcuts = new Shortcuts(self);
	      self.loadedCSS = {};
	      self.editorCommands = new EditorCommands(self);
	      self.suffix = editorManager.suffix;
	      self.editorManager = editorManager;
	      self.inline = settings.inline;
	      self.buttons = {};
	      self.menuItems = {};
	      if (settings.cache_suffix) {
	        Env.cacheSuffix = settings.cache_suffix.replace(/^[\?\&]+/, '');
	      }
	      if (settings.override_viewport === false) {
	        Env.overrideViewPort = false;
	      }
	      editorManager.fire('SetupEditor', { editor: self });
	      self.execCallback('setup', self);
	      self.$ = DomQuery.overrideDefaults(function () {
	        return {
	          context: self.inline ? self.getBody() : self.getDoc(),
	          element: self.getBody()
	        };
	      });
	    };
	    Editor.prototype = {
	      render: function () {
	        Render.render(this);
	      },
	      focus: function (skipFocus) {
	        EditorFocus.focus(this, skipFocus);
	      },
	      hasFocus: function () {
	        return EditorFocus.hasFocus(this);
	      },
	      execCallback: function (name) {
	        var x = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          x[_i - 1] = arguments[_i];
	        }
	        var self = this;
	        var callback = self.settings[name], scope;
	        if (!callback) {
	          return;
	        }
	        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
	          callback = scope.func;
	          scope = scope.scope;
	        }
	        if (typeof callback === 'string') {
	          scope = callback.replace(/\.\w+$/, '');
	          scope = scope ? resolve$4(scope) : 0;
	          callback = resolve$4(callback);
	          self.callbackLookup = self.callbackLookup || {};
	          self.callbackLookup[name] = {
	            func: callback,
	            scope: scope
	          };
	        }
	        return callback.apply(scope || self, Array.prototype.slice.call(arguments, 1));
	      },
	      translate: function (text) {
	        if (text && Tools.is(text, 'string')) {
	          var lang_1 = this.settings.language || 'en', i18n_1 = this.editorManager.i18n;
	          text = i18n_1.data[lang_1 + '.' + text] || text.replace(/\{\#([^\}]+)\}/g, function (a, b) {
	            return i18n_1.data[lang_1 + '.' + b] || '{#' + b + '}';
	          });
	        }
	        return this.editorManager.translate(text);
	      },
	      getLang: function (name, defaultVal) {
	        return this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + name] || (defaultVal !== undefined ? defaultVal : '{#' + name + '}');
	      },
	      getParam: function (name, defaultVal, type) {
	        return getParam(this, name, defaultVal, type);
	      },
	      nodeChanged: function (args) {
	        this._nodeChangeDispatcher.nodeChanged(args);
	      },
	      addButton: function (name, settings) {
	        var self = this;
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	        if (settings.stateSelector && typeof settings.active === 'undefined') {
	          settings.active = false;
	        }
	        if (!settings.text && !settings.icon) {
	          settings.icon = name;
	        }
	        settings.tooltip = settings.tooltip || settings.title;
	        self.buttons[name] = settings;
	      },
	      addSidebar: function (name, settings) {
	        return Sidebar.add(this, name, settings);
	      },
	      addMenuItem: function (name, settings) {
	        var self = this;
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	        self.menuItems[name] = settings;
	      },
	      addContextToolbar: function (predicate, items) {
	        var self = this;
	        var selector;
	        self.contextToolbars = self.contextToolbars || [];
	        if (typeof predicate === 'string') {
	          selector = predicate;
	          predicate = function (elm) {
	            return self.dom.is(elm, selector);
	          };
	        }
	        self.contextToolbars.push({
	          id: Uuid.uuid('mcet'),
	          predicate: predicate,
	          items: items
	        });
	      },
	      addCommand: function (name, callback, scope) {
	        this.editorCommands.addCommand(name, callback, scope);
	      },
	      addQueryStateHandler: function (name, callback, scope) {
	        this.editorCommands.addQueryStateHandler(name, callback, scope);
	      },
	      addQueryValueHandler: function (name, callback, scope) {
	        this.editorCommands.addQueryValueHandler(name, callback, scope);
	      },
	      addShortcut: function (pattern, desc, cmdFunc, scope) {
	        this.shortcuts.add(pattern, desc, cmdFunc, scope);
	      },
	      execCommand: function (cmd, ui, value, args) {
	        return this.editorCommands.execCommand(cmd, ui, value, args);
	      },
	      queryCommandState: function (cmd) {
	        return this.editorCommands.queryCommandState(cmd);
	      },
	      queryCommandValue: function (cmd) {
	        return this.editorCommands.queryCommandValue(cmd);
	      },
	      queryCommandSupported: function (cmd) {
	        return this.editorCommands.queryCommandSupported(cmd);
	      },
	      show: function () {
	        var self = this;
	        if (self.hidden) {
	          self.hidden = false;
	          if (self.inline) {
	            self.getBody().contentEditable = true;
	          } else {
	            DOM$7.show(self.getContainer());
	            DOM$7.hide(self.id);
	          }
	          self.load();
	          self.fire('show');
	        }
	      },
	      hide: function () {
	        var self = this, doc = self.getDoc();
	        if (!self.hidden) {
	          if (ie$2 && doc && !self.inline) {
	            doc.execCommand('SelectAll');
	          }
	          self.save();
	          if (self.inline) {
	            self.getBody().contentEditable = false;
	            if (self === self.editorManager.focusedEditor) {
	              self.editorManager.focusedEditor = null;
	            }
	          } else {
	            DOM$7.hide(self.getContainer());
	            DOM$7.setStyle(self.id, 'display', self.orgDisplay);
	          }
	          self.hidden = true;
	          self.fire('hide');
	        }
	      },
	      isHidden: function () {
	        return !!this.hidden;
	      },
	      setProgressState: function (state, time) {
	        this.fire('ProgressState', {
	          state: state,
	          time: time
	        });
	      },
	      load: function (args) {
	        var self = this;
	        var elm = self.getElement(), html;
	        if (self.removed) {
	          return '';
	        }
	        if (elm) {
	          args = args || {};
	          args.load = true;
	          html = self.setContent(elm.value !== undefined ? elm.value : elm.innerHTML, args);
	          args.element = elm;
	          if (!args.no_events) {
	            self.fire('LoadContent', args);
	          }
	          args.element = elm = null;
	          return html;
	        }
	      },
	      save: function (args) {
	        var self = this;
	        var elm = self.getElement(), html, form;
	        if (!elm || !self.initialized || self.removed) {
	          return;
	        }
	        args = args || {};
	        args.save = true;
	        args.element = elm;
	        html = args.content = self.getContent(args);
	        if (!args.no_events) {
	          self.fire('SaveContent', args);
	        }
	        if (args.format === 'raw') {
	          self.fire('RawSaveContent', args);
	        }
	        html = args.content;
	        if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
	          if (args.is_removing || !self.inline) {
	            elm.innerHTML = html;
	          }
	          if (form = DOM$7.getParent(self.id, 'form')) {
	            each$l(form.elements, function (elm) {
	              if (elm.name === self.id) {
	                elm.value = html;
	                return false;
	              }
	            });
	          }
	        } else {
	          elm.value = html;
	        }
	        args.element = elm = null;
	        if (args.set_dirty !== false) {
	          self.setDirty(false);
	        }
	        return html;
	      },
	      setContent: function (content, args) {
	        return setContent$1(this, content, args);
	      },
	      getContent: function (args) {
	        return getContent$1(this, args);
	      },
	      insertContent: function (content, args) {
	        if (args) {
	          content = extend$4({ content: content }, args);
	        }
	        this.execCommand('mceInsertContent', false, content);
	      },
	      isDirty: function () {
	        return !this.isNotDirty;
	      },
	      setDirty: function (state) {
	        var oldState = !this.isNotDirty;
	        this.isNotDirty = !state;
	        if (state && state !== oldState) {
	          this.fire('dirty');
	        }
	      },
	      setMode: function (mode) {
	        setMode(this, mode);
	      },
	      getContainer: function () {
	        var self = this;
	        if (!self.container) {
	          self.container = DOM$7.get(self.editorContainer || self.id + '_parent');
	        }
	        return self.container;
	      },
	      getContentAreaContainer: function () {
	        return this.contentAreaContainer;
	      },
	      getElement: function () {
	        if (!this.targetElm) {
	          this.targetElm = DOM$7.get(this.id);
	        }
	        return this.targetElm;
	      },
	      getWin: function () {
	        var self = this;
	        var elm;
	        if (!self.contentWindow) {
	          elm = self.iframeElement;
	          if (elm) {
	            self.contentWindow = elm.contentWindow;
	          }
	        }
	        return self.contentWindow;
	      },
	      getDoc: function () {
	        var self = this;
	        var win;
	        if (!self.contentDocument) {
	          win = self.getWin();
	          if (win) {
	            self.contentDocument = win.document;
	          }
	        }
	        return self.contentDocument;
	      },
	      getBody: function () {
	        var doc = this.getDoc();
	        return this.bodyElement || (doc ? doc.body : null);
	      },
	      convertURL: function (url, name, elm) {
	        var self = this, settings = self.settings;
	        if (settings.urlconverter_callback) {
	          return self.execCallback('urlconverter_callback', url, elm, true, name);
	        }
	        if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
	          return url;
	        }
	        if (settings.relative_urls) {
	          return self.documentBaseURI.toRelative(url);
	        }
	        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	        return url;
	      },
	      addVisual: function (elm) {
	        var self = this;
	        var settings = self.settings;
	        var dom = self.dom;
	        var cls;
	        elm = elm || self.getBody();
	        if (self.hasVisual === undefined) {
	          self.hasVisual = settings.visual;
	        }
	        each$l(dom.select('table,a', elm), function (elm) {
	          var value;
	          switch (elm.nodeName) {
	          case 'TABLE':
	            cls = settings.visual_table_class || 'mce-item-table';
	            value = dom.getAttrib(elm, 'border');
	            if ((!value || value === '0') && self.hasVisual) {
	              dom.addClass(elm, cls);
	            } else {
	              dom.removeClass(elm, cls);
	            }
	            return;
	          case 'A':
	            if (!dom.getAttrib(elm, 'href')) {
	              value = dom.getAttrib(elm, 'name') || elm.id;
	              cls = settings.visual_anchor_class || 'mce-item-anchor';
	              if (value && self.hasVisual) {
	                dom.addClass(elm, cls);
	              } else {
	                dom.removeClass(elm, cls);
	              }
	            }
	            return;
	          }
	        });
	        self.fire('VisualAid', {
	          element: elm,
	          hasVisual: self.hasVisual
	        });
	      },
	      remove: function () {
	        remove$7(this);
	      },
	      destroy: function (automatic) {
	        destroy(this, automatic);
	      },
	      uploadImages: function (callback) {
	        return this.editorUpload.uploadImages(callback);
	      },
	      _scanForImages: function () {
	        return this.editorUpload.scanForImages();
	      }
	    };
	    extend$4(Editor.prototype, EditorObservable$1);
	
	    var isEditorUIElement = function (elm) {
	      return elm.className.toString().indexOf('mce-') !== -1;
	    };
	    var FocusManager = { isEditorUIElement: isEditorUIElement };
	
	    var isManualNodeChange = function (e) {
	      return e.type === 'nodechange' && e.selectionChange;
	    };
	    var registerPageMouseUp = function (editor, throttledStore) {
	      var mouseUpPage = function () {
	        throttledStore.throttle();
	      };
	      DOMUtils$1.DOM.bind(domGlobals.document, 'mouseup', mouseUpPage);
	      editor.on('remove', function () {
	        DOMUtils$1.DOM.unbind(domGlobals.document, 'mouseup', mouseUpPage);
	      });
	    };
	    var registerFocusOut = function (editor) {
	      editor.on('focusout', function () {
	        SelectionBookmark.store(editor);
	      });
	    };
	    var registerMouseUp = function (editor, throttledStore) {
	      editor.on('mouseup touchend', function (e) {
	        throttledStore.throttle();
	      });
	    };
	    var registerEditorEvents = function (editor, throttledStore) {
	      var browser = PlatformDetection$1.detect().browser;
	      if (browser.isIE()) {
	        registerFocusOut(editor);
	      } else {
	        registerMouseUp(editor, throttledStore);
	      }
	      editor.on('keyup nodechange', function (e) {
	        if (!isManualNodeChange(e)) {
	          SelectionBookmark.store(editor);
	        }
	      });
	    };
	    var register$3 = function (editor) {
	      var throttledStore = first(function () {
	        SelectionBookmark.store(editor);
	      }, 0);
	      if (editor.inline) {
	        registerPageMouseUp(editor, throttledStore);
	      }
	      editor.on('init', function () {
	        registerEditorEvents(editor, throttledStore);
	      });
	      editor.on('remove', function () {
	        throttledStore.cancel();
	      });
	    };
	    var SelectionRestore = { register: register$3 };
	
	    var documentFocusInHandler;
	    var DOM$8 = DOMUtils$1.DOM;
	    var isEditorUIElement$1 = function (elm) {
	      return FocusManager.isEditorUIElement(elm);
	    };
	    var isUIElement = function (editor, elm) {
	      var customSelector = editor ? editor.settings.custom_ui_selector : '';
	      var parent = DOM$8.getParent(elm, function (elm) {
	        return isEditorUIElement$1(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
	      });
	      return parent !== null;
	    };
	    var getActiveElement = function () {
	      try {
	        return domGlobals.document.activeElement;
	      } catch (ex) {
	        return domGlobals.document.body;
	      }
	    };
	    var registerEvents = function (editorManager, e) {
	      var editor = e.editor;
	      SelectionRestore.register(editor);
	      editor.on('focusin', function () {
	        var self = this;
	        var focusedEditor = editorManager.focusedEditor;
	        if (focusedEditor !== self) {
	          if (focusedEditor) {
	            focusedEditor.fire('blur', { focusedEditor: self });
	          }
	          editorManager.setActive(self);
	          editorManager.focusedEditor = self;
	          self.fire('focus', { blurredEditor: focusedEditor });
	          self.focus(true);
	        }
	      });
	      editor.on('focusout', function () {
	        var self = this;
	        Delay.setEditorTimeout(self, function () {
	          var focusedEditor = editorManager.focusedEditor;
	          if (!isUIElement(self, getActiveElement()) && focusedEditor === self) {
	            self.fire('blur', { focusedEditor: null });
	            editorManager.focusedEditor = null;
	          }
	        });
	      });
	      if (!documentFocusInHandler) {
	        documentFocusInHandler = function (e) {
	          var activeEditor = editorManager.activeEditor;
	          var target;
	          target = e.target;
	          if (activeEditor && target.ownerDocument === domGlobals.document) {
	            if (target !== domGlobals.document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
	              activeEditor.fire('blur', { focusedEditor: null });
	              editorManager.focusedEditor = null;
	            }
	          }
	        };
	        DOM$8.bind(domGlobals.document, 'focusin', documentFocusInHandler);
	      }
	    };
	    var unregisterDocumentEvents = function (editorManager, e) {
	      if (editorManager.focusedEditor === e.editor) {
	        editorManager.focusedEditor = null;
	      }
	      if (!editorManager.activeEditor) {
	        DOM$8.unbind(domGlobals.document, 'focusin', documentFocusInHandler);
	        documentFocusInHandler = null;
	      }
	    };
	    var setup$h = function (editorManager) {
	      editorManager.on('AddEditor', curry(registerEvents, editorManager));
	      editorManager.on('RemoveEditor', curry(unregisterDocumentEvents, editorManager));
	    };
	    var FocusController = {
	      setup: setup$h,
	      isEditorUIElement: isEditorUIElement$1,
	      isUIElement: isUIElement
	    };
	
	    var DOM$9 = DOMUtils$1.DOM;
	    var explode$4 = Tools.explode, each$m = Tools.each, extend$5 = Tools.extend;
	    var instanceCounter = 0, beforeUnloadDelegate, EditorManager, boundGlobalEvents = false;
	    var legacyEditors = [];
	    var editors = [];
	    var isValidLegacyKey = function (id) {
	      return id !== 'length';
	    };
	    var globalEventDelegate = function (e) {
	      var type = e.type;
	      each$m(EditorManager.get(), function (editor) {
	        switch (type) {
	        case 'scroll':
	          editor.fire('ScrollWindow', e);
	          break;
	        case 'resize':
	          editor.fire('ResizeWindow', e);
	          break;
	        }
	      });
	    };
	    var toggleGlobalEvents = function (state) {
	      if (state !== boundGlobalEvents) {
	        if (state) {
	          DomQuery(window).on('resize scroll', globalEventDelegate);
	        } else {
	          DomQuery(window).off('resize scroll', globalEventDelegate);
	        }
	        boundGlobalEvents = state;
	      }
	    };
	    var removeEditorFromList = function (targetEditor) {
	      var oldEditors = editors;
	      delete legacyEditors[targetEditor.id];
	      for (var i = 0; i < legacyEditors.length; i++) {
	        if (legacyEditors[i] === targetEditor) {
	          legacyEditors.splice(i, 1);
	          break;
	        }
	      }
	      editors = filter(editors, function (editor) {
	        return targetEditor !== editor;
	      });
	      if (EditorManager.activeEditor === targetEditor) {
	        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
	      }
	      if (EditorManager.focusedEditor === targetEditor) {
	        EditorManager.focusedEditor = null;
	      }
	      return oldEditors.length !== editors.length;
	    };
	    var purgeDestroyedEditor = function (editor) {
	      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
	        removeEditorFromList(editor);
	        editor.unbindAllNativeEvents();
	        editor.destroy(true);
	        editor.removed = true;
	        editor = null;
	      }
	      return editor;
	    };
	    EditorManager = {
	      defaultSettings: {},
	      $: DomQuery,
	      majorVersion: '4',
	      minorVersion: '9.10',
	      releaseDate: '2020-04-23',
	      editors: legacyEditors,
	      i18n: I18n,
	      activeEditor: null,
	      settings: {},
	      setup: function () {
	        var self = this;
	        var baseURL, documentBaseURL, suffix = '';
	        documentBaseURL = URI.getDocumentBaseUrl(domGlobals.document.location);
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
	          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(documentBaseURL)) {
	            documentBaseURL += '/';
	          }
	        }
	        var preInit = window.tinymce || window.tinyMCEPreInit;
	        if (preInit) {
	          baseURL = preInit.base || preInit.baseURL;
	          suffix = preInit.suffix;
	        } else {
	          var scripts = domGlobals.document.getElementsByTagName('script');
	          for (var i = 0; i < scripts.length; i++) {
	            var src = scripts[i].src || '';
	            if (src === '') {
	              continue;
	            }
	            var srcScript = src.substring(src.lastIndexOf('/'));
	            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
	              if (srcScript.indexOf('.min') !== -1) {
	                suffix = '.min';
	              }
	              baseURL = src.substring(0, src.lastIndexOf('/'));
	              break;
	            }
	          }
	          if (!baseURL && domGlobals.document.currentScript) {
	            var src = domGlobals.document.currentScript.src;
	            if (src.indexOf('.min') !== -1) {
	              suffix = '.min';
	            }
	            baseURL = src.substring(0, src.lastIndexOf('/'));
	          }
	        }
	        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	        self.documentBaseURL = documentBaseURL;
	        self.baseURI = new URI(self.baseURL);
	        self.suffix = suffix;
	        FocusController.setup(self);
	      },
	      overrideDefaults: function (defaultSettings) {
	        var baseUrl, suffix;
	        baseUrl = defaultSettings.base_url;
	        if (baseUrl) {
	          this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
	          this.baseURI = new URI(this.baseURL);
	        }
	        suffix = defaultSettings.suffix;
	        if (defaultSettings.suffix) {
	          this.suffix = suffix;
	        }
	        this.defaultSettings = defaultSettings;
	        var pluginBaseUrls = defaultSettings.plugin_base_urls;
	        for (var name in pluginBaseUrls) {
	          AddOnManager.PluginManager.urls[name] = pluginBaseUrls[name];
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        var result, invalidInlineTargets;
	        invalidInlineTargets = Tools.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu', ' ');
	        var isInvalidInlineTarget = function (settings, elm) {
	          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
	        };
	        var createId = function (elm) {
	          var id = elm.id;
	          if (!id) {
	            id = elm.name;
	            if (id && !DOM$9.get(id)) {
	              id = elm.name;
	            } else {
	              id = DOM$9.uniqueId();
	            }
	            elm.setAttribute('id', id);
	          }
	          return id;
	        };
	        var execCallback = function (name) {
	          var callback = settings[name];
	          if (!callback) {
	            return;
	          }
	          return callback.apply(self, Array.prototype.slice.call(arguments, 2));
	        };
	        var hasClass = function (elm, className) {
	          return className.constructor === RegExp ? className.test(elm.className) : DOM$9.hasClass(elm, className);
	        };
	        var findTargets = function (settings) {
	          var l, targets = [];
	          if (Env.ie && Env.ie < 11) {
	            ErrorReporter.initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
	            return [];
	          }
	          if (settings.types) {
	            each$m(settings.types, function (type) {
	              targets = targets.concat(DOM$9.select(type.selector));
	            });
	            return targets;
	          } else if (settings.selector) {
	            return DOM$9.select(settings.selector);
	          } else if (settings.target) {
	            return [settings.target];
	          }
	          switch (settings.mode) {
	          case 'exact':
	            l = settings.elements || '';
	            if (l.length > 0) {
	              each$m(explode$4(l), function (id) {
	                var elm;
	                if (elm = DOM$9.get(id)) {
	                  targets.push(elm);
	                } else {
	                  each$m(domGlobals.document.forms, function (f) {
	                    each$m(f.elements, function (e) {
	                      if (e.name === id) {
	                        id = 'mce_editor_' + instanceCounter++;
	                        DOM$9.setAttrib(e, 'id', id);
	                        targets.push(e);
	                      }
	                    });
	                  });
	                }
	              });
	            }
	            break;
	          case 'textareas':
	          case 'specific_textareas':
	            each$m(DOM$9.select('textarea'), function (elm) {
	              if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
	                return;
	              }
	              if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
	                targets.push(elm);
	              }
	            });
	            break;
	          }
	          return targets;
	        };
	        var provideResults = function (editors) {
	          result = editors;
	        };
	        var initEditors = function () {
	          var initCount = 0;
	          var editors = [];
	          var targets;
	          var createEditor = function (id, settings, targetElm) {
	            var editor = new Editor(id, settings, self);
	            editors.push(editor);
	            editor.on('init', function () {
	              if (++initCount === targets.length) {
	                provideResults(editors);
	              }
	            });
	            editor.targetElm = editor.targetElm || targetElm;
	            editor.render();
	          };
	          DOM$9.unbind(window, 'ready', initEditors);
	          execCallback('onpageload');
	          targets = DomQuery.unique(findTargets(settings));
	          if (settings.types) {
	            each$m(settings.types, function (type) {
	              Tools.each(targets, function (elm) {
	                if (DOM$9.is(elm, type.selector)) {
	                  createEditor(createId(elm), extend$5({}, settings, type), elm);
	                  return false;
	                }
	                return true;
	              });
	            });
	            return;
	          }
	          Tools.each(targets, function (elm) {
	            purgeDestroyedEditor(self.get(elm.id));
	          });
	          targets = Tools.grep(targets, function (elm) {
	            return !self.get(elm.id);
	          });
	          if (targets.length === 0) {
	            provideResults([]);
	          } else {
	            each$m(targets, function (elm) {
	              if (isInvalidInlineTarget(settings, elm)) {
	                ErrorReporter.initError('Could not initialize inline editor on invalid inline target element', elm);
	              } else {
	                createEditor(createId(elm), settings, elm);
	              }
	            });
	          }
	        };
	        self.settings = settings;
	        DOM$9.bind(window, 'ready', initEditors);
	        return new promiseObj(function (resolve) {
	          if (result) {
	            resolve(result);
	          } else {
	            provideResults = function (editors) {
	              resolve(editors);
	            };
	          }
	        });
	      },
	      get: function (id) {
	        if (arguments.length === 0) {
	          return editors.slice(0);
	        } else if (isString(id)) {
	          return find(editors, function (editor) {
	            return editor.id === id;
	          }).getOr(null);
	        } else if (isNumber(id)) {
	          return editors[id] ? editors[id] : null;
	        } else {
	          return null;
	        }
	      },
	      add: function (editor) {
	        var self = this;
	        var existingEditor;
	        existingEditor = legacyEditors[editor.id];
	        if (existingEditor === editor) {
	          return editor;
	        }
	        if (self.get(editor.id) === null) {
	          if (isValidLegacyKey(editor.id)) {
	            legacyEditors[editor.id] = editor;
	          }
	          legacyEditors.push(editor);
	          editors.push(editor);
	        }
	        toggleGlobalEvents(true);
	        self.activeEditor = editor;
	        self.fire('AddEditor', { editor: editor });
	        if (!beforeUnloadDelegate) {
	          beforeUnloadDelegate = function () {
	            self.fire('BeforeUnload');
	          };
	          DOM$9.bind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	        return editor;
	      },
	      createEditor: function (id, settings) {
	        return this.add(new Editor(id, settings, this));
	      },
	      remove: function (selector) {
	        var self = this;
	        var i, editor;
	        if (!selector) {
	          for (i = editors.length - 1; i >= 0; i--) {
	            self.remove(editors[i]);
	          }
	          return;
	        }
	        if (isString(selector)) {
	          each$m(DOM$9.select(selector), function (elm) {
	            editor = self.get(elm.id);
	            if (editor) {
	              self.remove(editor);
	            }
	          });
	          return;
	        }
	        editor = selector;
	        if (isNull(self.get(editor.id))) {
	          return null;
	        }
	        if (removeEditorFromList(editor)) {
	          self.fire('RemoveEditor', { editor: editor });
	        }
	        if (editors.length === 0) {
	          DOM$9.unbind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	        editor.remove();
	        toggleGlobalEvents(editors.length > 0);
	        return editor;
	      },
	      execCommand: function (cmd, ui, value) {
	        var self = this, editor = self.get(value);
	        switch (cmd) {
	        case 'mceAddEditor':
	          if (!self.get(value)) {
	            new Editor(value, self.settings, self).render();
	          }
	          return true;
	        case 'mceRemoveEditor':
	          if (editor) {
	            editor.remove();
	          }
	          return true;
	        case 'mceToggleEditor':
	          if (!editor) {
	            self.execCommand('mceAddEditor', 0, value);
	            return true;
	          }
	          if (editor.isHidden()) {
	            editor.show();
	          } else {
	            editor.hide();
	          }
	          return true;
	        }
	        if (self.activeEditor) {
	          return self.activeEditor.execCommand(cmd, ui, value);
	        }
	        return false;
	      },
	      triggerSave: function () {
	        each$m(editors, function (editor) {
	          editor.save();
	        });
	      },
	      addI18n: function (code, items) {
	        I18n.add(code, items);
	      },
	      translate: function (text) {
	        return I18n.translate(text);
	      },
	      setActive: function (editor) {
	        var activeEditor = this.activeEditor;
	        if (this.activeEditor !== editor) {
	          if (activeEditor) {
	            activeEditor.fire('deactivate', { relatedTarget: editor });
	          }
	          editor.fire('activate', { relatedTarget: activeEditor });
	        }
	        this.activeEditor = editor;
	      }
	    };
	    extend$5(EditorManager, Observable);
	    EditorManager.setup();
	    var EditorManager$1 = EditorManager;
	
	    function RangeUtils(dom) {
	      var walk = function (rng, callback) {
	        return RangeWalk.walk(dom, rng, callback);
	      };
	      var split = SplitRange.split;
	      var normalize = function (rng) {
	        return NormalizeRange.normalize(dom, rng).fold(constant(false), function (normalizedRng) {
	          rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
	          rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
	          return true;
	        });
	      };
	      return {
	        walk: walk,
	        split: split,
	        normalize: normalize
	      };
	    }
	    (function (RangeUtils) {
	      RangeUtils.compareRanges = RangeCompare.isEq;
	      RangeUtils.getCaretRangeFromPoint = CaretRangeFromPoint.fromPoint;
	      RangeUtils.getSelectedNode = getSelectedNode;
	      RangeUtils.getNode = getNode;
	    }(RangeUtils || (RangeUtils = {})));
	    var RangeUtils$1 = RangeUtils;
	
	    var min = Math.min, max = Math.max, round$2 = Math.round;
	    var relativePosition = function (rect, targetRect, rel) {
	      var x, y, w, h, targetW, targetH;
	      x = targetRect.x;
	      y = targetRect.y;
	      w = rect.w;
	      h = rect.h;
	      targetW = targetRect.w;
	      targetH = targetRect.h;
	      rel = (rel || '').split('');
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	      if (rel[0] === 'c') {
	        y += round$2(targetH / 2);
	      }
	      if (rel[1] === 'c') {
	        x += round$2(targetW / 2);
	      }
	      if (rel[3] === 'b') {
	        y -= h;
	      }
	      if (rel[4] === 'r') {
	        x -= w;
	      }
	      if (rel[3] === 'c') {
	        y -= round$2(h / 2);
	      }
	      if (rel[4] === 'c') {
	        x -= round$2(w / 2);
	      }
	      return create$4(x, y, w, h);
	    };
	    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
	      var pos, i;
	      for (i = 0; i < rels.length; i++) {
	        pos = relativePosition(rect, targetRect, rels[i]);
	        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
	          return rels[i];
	        }
	      }
	      return null;
	    };
	    var inflate = function (rect, w, h) {
	      return create$4(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
	    };
	    var intersect = function (rect, cropRect) {
	      var x1, y1, x2, y2;
	      x1 = max(rect.x, cropRect.x);
	      y1 = max(rect.y, cropRect.y);
	      x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
	      y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
	      if (x2 - x1 < 0 || y2 - y1 < 0) {
	        return null;
	      }
	      return create$4(x1, y1, x2 - x1, y2 - y1);
	    };
	    var clamp$1 = function (rect, clampRect, fixedSize) {
	      var underflowX1, underflowY1, overflowX2, overflowY2, x1, y1, x2, y2, cx2, cy2;
	      x1 = rect.x;
	      y1 = rect.y;
	      x2 = rect.x + rect.w;
	      y2 = rect.y + rect.h;
	      cx2 = clampRect.x + clampRect.w;
	      cy2 = clampRect.y + clampRect.h;
	      underflowX1 = max(0, clampRect.x - x1);
	      underflowY1 = max(0, clampRect.y - y1);
	      overflowX2 = max(0, x2 - cx2);
	      overflowY2 = max(0, y2 - cy2);
	      x1 += underflowX1;
	      y1 += underflowY1;
	      if (fixedSize) {
	        x2 += underflowX1;
	        y2 += underflowY1;
	        x1 -= overflowX2;
	        y1 -= overflowY2;
	      }
	      x2 -= overflowX2;
	      y2 -= overflowY2;
	      return create$4(x1, y1, x2 - x1, y2 - y1);
	    };
	    var create$4 = function (x, y, w, h) {
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var fromClientRect = function (clientRect) {
	      return create$4(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	    };
	    var Rect = {
	      inflate: inflate,
	      relativePosition: relativePosition,
	      findBestRelativePosition: findBestRelativePosition,
	      intersect: intersect,
	      clamp: clamp$1,
	      create: create$4,
	      fromClientRect: fromClientRect
	    };
	
	    var types = {};
	    var Factory = {
	      add: function (type, typeClass) {
	        types[type.toLowerCase()] = typeClass;
	      },
	      has: function (type) {
	        return !!types[type.toLowerCase()];
	      },
	      get: function (type) {
	        var lctype = type.toLowerCase();
	        var controlType = types.hasOwnProperty(lctype) ? types[lctype] : null;
	        if (controlType === null) {
	          throw new Error('Could not find module for type: ' + type);
	        }
	        return controlType;
	      },
	      create: function (type, settings) {
	        var ControlType;
	        if (typeof type === 'string') {
	          settings = settings || {};
	          settings.type = type;
	        } else {
	          settings = type;
	          type = settings.type;
	        }
	        type = type.toLowerCase();
	        ControlType = types[type];
	        if (!ControlType) {
	          throw new Error('Could not find control by type: ' + type);
	        }
	        ControlType = new ControlType(settings);
	        ControlType.type = type;
	        return ControlType;
	      }
	    };
	
	    var each$n = Tools.each, extend$6 = Tools.extend;
	    var extendClass, initializing;
	    var Class = function () {
	    };
	    Class.extend = extendClass = function (prop) {
	      var self = this;
	      var _super = self.prototype;
	      var prototype, name, member;
	      var Class = function () {
	        var i, mixins, mixin;
	        var self = this;
	        if (!initializing) {
	          if (self.init) {
	            self.init.apply(self, arguments);
	          }
	          mixins = self.Mixins;
	          if (mixins) {
	            i = mixins.length;
	            while (i--) {
	              mixin = mixins[i];
	              if (mixin.init) {
	                mixin.init.apply(self, arguments);
	              }
	            }
	          }
	        }
	      };
	      var dummy = function () {
	        return this;
	      };
	      var createMethod = function (name, fn) {
	        return function () {
	          var self = this;
	          var tmp = self._super;
	          var ret;
	          self._super = _super[name];
	          ret = fn.apply(self, arguments);
	          self._super = tmp;
	          return ret;
	        };
	      };
	      initializing = true;
	      prototype = new self();
	      initializing = false;
	      if (prop.Mixins) {
	        each$n(prop.Mixins, function (mixin) {
	          for (var name_1 in mixin) {
	            if (name_1 !== 'init') {
	              prop[name_1] = mixin[name_1];
	            }
	          }
	        });
	        if (_super.Mixins) {
	          prop.Mixins = _super.Mixins.concat(prop.Mixins);
	        }
	      }
	      if (prop.Methods) {
	        each$n(prop.Methods.split(','), function (name) {
	          prop[name] = dummy;
	        });
	      }
	      if (prop.Properties) {
	        each$n(prop.Properties.split(','), function (name) {
	          var fieldName = '_' + name;
	          prop[name] = function (value) {
	            var self = this;
	            if (value !== undefined) {
	              self[fieldName] = value;
	              return self;
	            }
	            return self[fieldName];
	          };
	        });
	      }
	      if (prop.Statics) {
	        each$n(prop.Statics, function (func, name) {
	          Class[name] = func;
	        });
	      }
	      if (prop.Defaults && _super.Defaults) {
	        prop.Defaults = extend$6({}, _super.Defaults, prop.Defaults);
	      }
	      for (name in prop) {
	        member = prop[name];
	        if (typeof member === 'function' && _super[name]) {
	          prototype[name] = createMethod(name, member);
	        } else {
	          prototype[name] = member;
	        }
	      }
	      Class.prototype = prototype;
	      Class.constructor = Class;
	      Class.extend = extendClass;
	      return Class;
	    };
	
	    var min$1 = Math.min, max$1 = Math.max, round$3 = Math.round;
	    var Color = function (value) {
	      var self = {};
	      var r = 0, g = 0, b = 0;
	      var rgb2hsv = function (r, g, b) {
	        var h, s, v, d, minRGB, maxRGB;
	        h = 0;
	        s = 0;
	        v = 0;
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	        minRGB = min$1(r, min$1(g, b));
	        maxRGB = max$1(r, max$1(g, b));
	        if (minRGB === maxRGB) {
	          v = minRGB;
	          return {
	            h: 0,
	            s: 0,
	            v: v * 100
	          };
	        }
	        d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	        h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	        h = 60 * (h - d / (maxRGB - minRGB));
	        s = (maxRGB - minRGB) / maxRGB;
	        v = maxRGB;
	        return {
	          h: round$3(h),
	          s: round$3(s * 100),
	          v: round$3(v * 100)
	        };
	      };
	      var hsvToRgb = function (hue, saturation, brightness) {
	        var side, chroma, x, match;
	        hue = (parseInt(hue, 10) || 0) % 360;
	        saturation = parseInt(saturation, 10) / 100;
	        brightness = parseInt(brightness, 10) / 100;
	        saturation = max$1(0, min$1(saturation, 1));
	        brightness = max$1(0, min$1(brightness, 1));
	        if (saturation === 0) {
	          r = g = b = round$3(255 * brightness);
	          return;
	        }
	        side = hue / 60;
	        chroma = brightness * saturation;
	        x = chroma * (1 - Math.abs(side % 2 - 1));
	        match = brightness - chroma;
	        switch (Math.floor(side)) {
	        case 0:
	          r = chroma;
	          g = x;
	          b = 0;
	          break;
	        case 1:
	          r = x;
	          g = chroma;
	          b = 0;
	          break;
	        case 2:
	          r = 0;
	          g = chroma;
	          b = x;
	          break;
	        case 3:
	          r = 0;
	          g = x;
	          b = chroma;
	          break;
	        case 4:
	          r = x;
	          g = 0;
	          b = chroma;
	          break;
	        case 5:
	          r = chroma;
	          g = 0;
	          b = x;
	          break;
	        default:
	          r = g = b = 0;
	        }
	        r = round$3(255 * (r + match));
	        g = round$3(255 * (g + match));
	        b = round$3(255 * (b + match));
	      };
	      var toHex = function () {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	          return val.length > 1 ? val : '0' + val;
	        };
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	      var toRgb = function () {
	        return {
	          r: r,
	          g: g,
	          b: b
	        };
	      };
	      var toHsv = function () {
	        return rgb2hsv(r, g, b);
	      };
	      var parse = function (value) {
	        var matches;
	        if (typeof value === 'object') {
	          if ('r' in value) {
	            r = value.r;
	            g = value.g;
	            b = value.b;
	          } else if ('v' in value) {
	            hsvToRgb(value.h, value.s, value.v);
	          }
	        } else {
	          if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
	            r = parseInt(matches[1], 10);
	            g = parseInt(matches[2], 10);
	            b = parseInt(matches[3], 10);
	          } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
	            r = parseInt(matches[1], 16);
	            g = parseInt(matches[2], 16);
	            b = parseInt(matches[3], 16);
	          } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
	            r = parseInt(matches[1] + matches[1], 16);
	            g = parseInt(matches[2] + matches[2], 16);
	            b = parseInt(matches[3] + matches[3], 16);
	          }
	        }
	        r = r < 0 ? 0 : r > 255 ? 255 : r;
	        g = g < 0 ? 0 : g > 255 ? 255 : g;
	        b = b < 0 ? 0 : b > 255 ? 255 : b;
	        return self;
	      };
	      if (value) {
	        parse(value);
	      }
	      self.toRgb = toRgb;
	      self.toHsv = toHsv;
	      self.toHex = toHex;
	      self.parse = parse;
	      return self;
	    };
	
	    var serialize = function (o, quote) {
	      var i, v, t, name;
	      quote = quote || '"';
	      if (o === null) {
	        return 'null';
	      }
	      t = typeof o;
	      if (t === 'string') {
	        v = '\bb\tt\nn\ff\rr""\'\'\\\\';
	        return quote + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function (a, b) {
	          if (quote === '"' && a === '\'') {
	            return a;
	          }
	          i = v.indexOf(b);
	          if (i + 1) {
	            return '\\' + v.charAt(i + 1);
	          }
	          a = b.charCodeAt().toString(16);
	          return '\\u' + '0000'.substring(a.length) + a;
	        }) + quote;
	      }
	      if (t === 'object') {
	        if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
	          for (i = 0, v = '['; i < o.length; i++) {
	            v += (i > 0 ? ',' : '') + serialize(o[i], quote);
	          }
	          return v + ']';
	        }
	        v = '{';
	        for (name in o) {
	          if (o.hasOwnProperty(name)) {
	            v += typeof o[name] !== 'function' ? (v.length > 1 ? ',' + quote : quote) + name + quote + ':' + serialize(o[name], quote) : '';
	          }
	        }
	        return v + '}';
	      }
	      return '' + o;
	    };
	    var JSON$1 = {
	      serialize: serialize,
	      parse: function (text) {
	        try {
	          return JSON.parse(text);
	        } catch (ex) {
	        }
	      }
	    };
	
	    var JSONP = {
	      callbacks: {},
	      count: 0,
	      send: function (settings) {
	        var self = this, dom = DOMUtils$1.DOM, count = settings.count !== undefined ? settings.count : self.count;
	        var id = 'tinymce_jsonp_' + count;
	        self.callbacks[count] = function (json) {
	          dom.remove(id);
	          delete self.callbacks[count];
	          settings.callback(json);
	        };
	        dom.add(dom.doc.body, 'script', {
	          id: id,
	          src: settings.url,
	          type: 'text/javascript'
	        });
	        self.count++;
	      }
	    };
	
	    var XHR = {
	      send: function (settings) {
	        var xhr, count = 0;
	        var ready = function () {
	          if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
	            if (settings.success && count < 10000 && xhr.status === 200) {
	              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
	            } else if (settings.error) {
	              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
	            }
	            xhr = null;
	          } else {
	            setTimeout(ready, 10);
	          }
	        };
	        settings.scope = settings.scope || this;
	        settings.success_scope = settings.success_scope || settings.scope;
	        settings.error_scope = settings.error_scope || settings.scope;
	        settings.async = settings.async === false ? false : true;
	        settings.data = settings.data || '';
	        XHR.fire('beforeInitialize', { settings: settings });
	        xhr = XMLHttpRequest();
	        if (xhr) {
	          if (xhr.overrideMimeType) {
	            xhr.overrideMimeType(settings.content_type);
	          }
	          xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	          if (settings.crossDomain) {
	            xhr.withCredentials = true;
	          }
	          if (settings.content_type) {
	            xhr.setRequestHeader('Content-Type', settings.content_type);
	          }
	          if (settings.requestheaders) {
	            Tools.each(settings.requestheaders, function (header) {
	              xhr.setRequestHeader(header.key, header.value);
	            });
	          }
	          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	          xhr = XHR.fire('beforeSend', {
	            xhr: xhr,
	            settings: settings
	          }).xhr;
	          xhr.send(settings.data);
	          if (!settings.async) {
	            return ready();
	          }
	          setTimeout(ready, 10);
	        }
	      }
	    };
	    Tools.extend(XHR, Observable);
	
	    var extend$7 = Tools.extend;
	    var JSONRequest = function (settings) {
	      this.settings = extend$7({}, settings);
	      this.count = 0;
	    };
	    JSONRequest.sendRPC = function (o) {
	      return new JSONRequest().send(o);
	    };
	    JSONRequest.prototype = {
	      send: function (args) {
	        var ecb = args.error, scb = args.success;
	        args = extend$7(this.settings, args);
	        args.success = function (c, x) {
	          c = JSON$1.parse(c);
	          if (typeof c === 'undefined') {
	            c = { error: 'JSON Parse error.' };
	          }
	          if (c.error) {
	            ecb.call(args.error_scope || args.scope, c.error, x);
	          } else {
	            scb.call(args.success_scope || args.scope, c.result);
	          }
	        };
	        args.error = function (ty, x) {
	          if (ecb) {
	            ecb.call(args.error_scope || args.scope, ty, x);
	          }
	        };
	        args.data = JSON$1.serialize({
	          id: args.id || 'c' + this.count++,
	          method: args.method,
	          params: args.params
	        });
	        args.content_type = 'application/json';
	        XHR.send(args);
	      }
	    };
	
	    var create$5 = function () {
	      return function () {
	        var data = {};
	        var keys = [];
	        var storage = {
	          getItem: function (key) {
	            var item = data[key];
	            return item ? item : null;
	          },
	          setItem: function (key, value) {
	            keys.push(key);
	            data[key] = String(value);
	          },
	          key: function (index) {
	            return keys[index];
	          },
	          removeItem: function (key) {
	            keys = keys.filter(function (k) {
	              return k === key;
	            });
	            delete data[key];
	          },
	          clear: function () {
	            keys = [];
	            data = {};
	          },
	          length: 0
	        };
	        Object.defineProperty(storage, 'length', {
	          get: function () {
	            return keys.length;
	          },
	          configurable: false,
	          enumerable: false
	        });
	        return storage;
	      }();
	    };
	
	    var localStorage;
	    try {
	      localStorage = domGlobals.window.localStorage;
	    } catch (e) {
	      localStorage = create$5();
	    }
	    var LocalStorage = localStorage;
	
	    var tinymce = EditorManager$1;
	    var publicApi = {
	      geom: { Rect: Rect },
	      util: {
	        Promise: promiseObj,
	        Delay: Delay,
	        Tools: Tools,
	        VK: VK,
	        URI: URI,
	        Class: Class,
	        EventDispatcher: Dispatcher,
	        Observable: Observable,
	        I18n: I18n,
	        XHR: XHR,
	        JSON: JSON$1,
	        JSONRequest: JSONRequest,
	        JSONP: JSONP,
	        LocalStorage: LocalStorage,
	        Color: Color
	      },
	      dom: {
	        EventUtils: EventUtils,
	        Sizzle: Sizzle,
	        DomQuery: DomQuery,
	        TreeWalker: TreeWalker,
	        DOMUtils: DOMUtils$1,
	        ScriptLoader: ScriptLoader,
	        RangeUtils: RangeUtils$1,
	        Serializer: DomSerializer$1,
	        ControlSelection: ControlSelection,
	        BookmarkManager: BookmarkManager$1,
	        Selection: Selection$1,
	        Event: EventUtils.Event
	      },
	      html: {
	        Styles: Styles,
	        Entities: Entities,
	        Node: Node$1,
	        Schema: Schema,
	        SaxParser: SaxParser$1,
	        DomParser: DomParser,
	        Writer: Writer,
	        Serializer: HtmlSerializer
	      },
	      ui: { Factory: Factory },
	      Env: Env,
	      AddOnManager: AddOnManager,
	      Annotator: Annotator,
	      Formatter: Formatter,
	      UndoManager: UndoManager,
	      EditorCommands: EditorCommands,
	      WindowManager: WindowManager,
	      NotificationManager: NotificationManager,
	      EditorObservable: EditorObservable$1,
	      Shortcuts: Shortcuts,
	      Editor: Editor,
	      FocusManager: FocusManager,
	      EditorManager: EditorManager$1,
	      DOM: DOMUtils$1.DOM,
	      ScriptLoader: ScriptLoader.ScriptLoader,
	      PluginManager: AddOnManager.PluginManager,
	      ThemeManager: AddOnManager.ThemeManager,
	      trim: Tools.trim,
	      isArray: Tools.isArray,
	      is: Tools.is,
	      toArray: Tools.toArray,
	      makeMap: Tools.makeMap,
	      each: Tools.each,
	      map: Tools.map,
	      grep: Tools.grep,
	      inArray: Tools.inArray,
	      extend: Tools.extend,
	      create: Tools.create,
	      walk: Tools.walk,
	      createNS: Tools.createNS,
	      resolve: Tools.resolve,
	      explode: Tools.explode,
	      _addCacheSuffix: Tools._addCacheSuffix,
	      isOpera: Env.opera,
	      isWebKit: Env.webkit,
	      isIE: Env.ie,
	      isGecko: Env.gecko,
	      isMac: Env.mac
	    };
	    tinymce = Tools.extend(tinymce, publicApi);
	    var Tinymce = tinymce;
	
	    var exportToModuleLoaders = function (tinymce) {
	      if (true) {
	        try {
	          module.exports = tinymce;
	        } catch (_) {
	        }
	      }
	    };
	    var exportToWindowGlobal = function (tinymce) {
	      window.tinymce = tinymce;
	      window.tinyMCE = tinymce;
	    };
	    exportToWindowGlobal(Tinymce);
	    exportToModuleLoaders(Tinymce);
	
	}(window));
	})();
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.tinymce;
	}.call(window));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).setImmediate, (function() { return this; }())))

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  if (!fn) {
	    return false
	  }
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ }),
/* 199 */
14,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.11.4 - 2015-03-11
	* http://jqueryui.com
	* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, draggable.js, droppable.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js, menu.js, progressbar.js, resizable.js, selectable.js, selectmenu.js, slider.js, sortable.js, spinner.js, tabs.js, tooltip.js
	* Copyright 2015 jQuery Foundation and other contributors; Licensed MIT */
	
	(function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}(function( $ ) {
	/*!
	 * jQuery UI Core 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	
	// $.ui might exist from components with no dependencies, e.g., $.ui.position
	$.ui = $.ui || {};
	
	$.extend( $.ui, {
		version: "1.11.4",
	
		keyCode: {
			BACKSPACE: 8,
			COMMA: 188,
			DELETE: 46,
			DOWN: 40,
			END: 35,
			ENTER: 13,
			ESCAPE: 27,
			HOME: 36,
			LEFT: 37,
			PAGE_DOWN: 34,
			PAGE_UP: 33,
			PERIOD: 190,
			RIGHT: 39,
			SPACE: 32,
			TAB: 9,
			UP: 38
		}
	});
	
	// plugins
	$.fn.extend({
		scrollParent: function( includeHidden ) {
			var position = this.css( "position" ),
				excludeStaticParent = position === "absolute",
				overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
				scrollParent = this.parents().filter( function() {
					var parent = $( this );
					if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
						return false;
					}
					return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
				}).eq( 0 );
	
			return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
		},
	
		uniqueId: (function() {
			var uuid = 0;
	
			return function() {
				return this.each(function() {
					if ( !this.id ) {
						this.id = "ui-id-" + ( ++uuid );
					}
				});
			};
		})(),
	
		removeUniqueId: function() {
			return this.each(function() {
				if ( /^ui-id-\d+$/.test( this.id ) ) {
					$( this ).removeAttr( "id" );
				}
			});
		}
	});
	
	// selectors
	function focusable( element, isTabIndexNotNaN ) {
		var map, mapName, img,
			nodeName = element.nodeName.toLowerCase();
		if ( "area" === nodeName ) {
			map = element.parentNode;
			mapName = map.name;
			if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
				return false;
			}
			img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
			return !!img && visible( img );
		}
		return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
			!element.disabled :
			"a" === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN) &&
			// the element and all of its ancestors must be visible
			visible( element );
	}
	
	function visible( element ) {
		return $.expr.filters.visible( element ) &&
			!$( element ).parents().addBack().filter(function() {
				return $.css( this, "visibility" ) === "hidden";
			}).length;
	}
	
	$.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo(function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			}) :
			// support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			},
	
		focusable: function( element ) {
			return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
		},
	
		tabbable: function( element ) {
			var tabIndex = $.attr( element, "tabindex" ),
				isTabIndexNaN = isNaN( tabIndex );
			return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
		}
	});
	
	// support: jQuery <1.8
	if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
		$.each( [ "Width", "Height" ], function( i, name ) {
			var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
				type = name.toLowerCase(),
				orig = {
					innerWidth: $.fn.innerWidth,
					innerHeight: $.fn.innerHeight,
					outerWidth: $.fn.outerWidth,
					outerHeight: $.fn.outerHeight
				};
	
			function reduce( elem, size, border, margin ) {
				$.each( side, function() {
					size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
					if ( border ) {
						size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
					}
					if ( margin ) {
						size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
					}
				});
				return size;
			}
	
			$.fn[ "inner" + name ] = function( size ) {
				if ( size === undefined ) {
					return orig[ "inner" + name ].call( this );
				}
	
				return this.each(function() {
					$( this ).css( type, reduce( this, size ) + "px" );
				});
			};
	
			$.fn[ "outer" + name] = function( size, margin ) {
				if ( typeof size !== "number" ) {
					return orig[ "outer" + name ].call( this, size );
				}
	
				return this.each(function() {
					$( this).css( type, reduce( this, size, true, margin ) + "px" );
				});
			};
		});
	}
	
	// support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
	if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
		$.fn.removeData = (function( removeData ) {
			return function( key ) {
				if ( arguments.length ) {
					return removeData.call( this, $.camelCase( key ) );
				} else {
					return removeData.call( this );
				}
			};
		})( $.fn.removeData );
	}
	
	// deprecated
	$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	
	$.fn.extend({
		focus: (function( orig ) {
			return function( delay, fn ) {
				return typeof delay === "number" ?
					this.each(function() {
						var elem = this;
						setTimeout(function() {
							$( elem ).focus();
							if ( fn ) {
								fn.call( elem );
							}
						}, delay );
					}) :
					orig.apply( this, arguments );
			};
		})( $.fn.focus ),
	
		disableSelection: (function() {
			var eventType = "onselectstart" in document.createElement( "div" ) ?
				"selectstart" :
				"mousedown";
	
			return function() {
				return this.bind( eventType + ".ui-disableSelection", function( event ) {
					event.preventDefault();
				});
			};
		})(),
	
		enableSelection: function() {
			return this.unbind( ".ui-disableSelection" );
		},
	
		zIndex: function( zIndex ) {
			if ( zIndex !== undefined ) {
				return this.css( "zIndex", zIndex );
			}
	
			if ( this.length ) {
				var elem = $( this[ 0 ] ), position, value;
				while ( elem.length && elem[ 0 ] !== document ) {
					// Ignore z-index if position is set to a value where z-index is ignored by the browser
					// This makes behavior of this function consistent across browsers
					// WebKit always returns auto if the element is positioned
					position = elem.css( "position" );
					if ( position === "absolute" || position === "relative" || position === "fixed" ) {
						// IE returns 0 when zIndex is not specified
						// other browsers return a string
						// we ignore the case of nested elements with an explicit value of 0
						// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
						value = parseInt( elem.css( "zIndex" ), 10 );
						if ( !isNaN( value ) && value !== 0 ) {
							return value;
						}
					}
					elem = elem.parent();
				}
			}
	
			return 0;
		}
	});
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	$.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	
	/*!
	 * jQuery UI Widget 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/jQuery.widget/
	 */
	
	
	var widget_uuid = 0,
		widget_slice = Array.prototype.slice;
	
	$.cleanData = (function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; (elem = elems[i]) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	})( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var fullName, existingConstructor, constructor, basePrototype,
			// proxiedPrototype allows the provided prototype to remain unmodified
			// so that it can be used as a mixin for multiple widgets (#8876)
			proxiedPrototype = {},
			namespace = name.split( "." )[ 0 ];
	
		name = name.split( "." )[ 1 ];
		fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		// create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
			// allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
		// extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
			// copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
			// track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		});
	
		basePrototype = new base();
		// we need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = (function() {
				var _super = function() {
						return base.prototype[ prop ].apply( this, arguments );
					},
					_superApply = function( args ) {
						return base.prototype[ prop ].apply( this, args );
					};
				return function() {
					var __super = this._super,
						__superApply = this._superApply,
						returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			})();
		});
		constructor.prototype = $.widget.extend( basePrototype, {
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		});
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
			});
			// remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widget_slice.call( arguments, 1 ),
			inputIndex = 0,
			inputLength = input.length,
			key,
			value;
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string",
				args = widget_slice.call( arguments, 1 ),
				returnValue = this;
	
			if ( isMethodCall ) {
				this.each(function() {
					var methodValue,
						instance = $.data( this, fullName );
					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}
					if ( !instance ) {
						return $.error( "cannot call methods on " + name + " prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}
					if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name + " widget instance" );
					}
					methodValue = instance[ options ].apply( instance, args );
					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				});
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat(args) );
				}
	
				this.each(function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				});
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
		options: {
			disabled: false,
	
			// callbacks
			create: null
		},
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widget_uuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				});
				this.document = $( element.style ?
					// element within the document
					element.ownerDocument :
					// element is window or document
					element.document || element );
				this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
		_getCreateOptions: $.noop,
		_getCreateEventData: $.noop,
		_create: $.noop,
		_init: $.noop,
	
		destroy: function() {
			this._destroy();
			// we can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.unbind( this.eventNamespace )
				.removeData( this.widgetFullName )
				// support: jquery <1.6.3
				// http://bugs.jquery.com/ticket/9413
				.removeData( $.camelCase( this.widgetFullName ) );
			this.widget()
				.unbind( this.eventNamespace )
				.removeAttr( "aria-disabled" )
				.removeClass(
					this.widgetFullName + "-disabled " +
					"ui-state-disabled" );
	
			// clean up events and states
			this.bindings.unbind( this.eventNamespace );
			this.hoverable.removeClass( "ui-state-hover" );
			this.focusable.removeClass( "ui-state-focus" );
		},
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key,
				parts,
				curOption,
				i;
	
			if ( arguments.length === 0 ) {
				// don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
				// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
		_setOption: function( key, value ) {
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this.widget()
					.toggleClass( this.widgetFullName + "-disabled", !!value );
	
				// If the widget is becoming disabled, then nothing is interactive
				if ( value ) {
					this.hoverable.removeClass( "ui-state-hover" );
					this.focusable.removeClass( "ui-state-focus" );
				}
			}
	
			return this;
		},
	
		enable: function() {
			return this._setOptions({ disabled: false });
		},
		disable: function() {
			return this._setOptions({ disabled: true });
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement,
				instance = this;
	
			// no suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// no element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
					// allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
								$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
					eventName = match[1] + instance.eventNamespace,
					selector = match[2];
				if ( selector ) {
					delegateElement.delegate( selector, eventName, handlerProxy );
				} else {
					element.bind( eventName, handlerProxy );
				}
			});
		},
	
		_off: function( element, eventName ) {
			eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.unbind( eventName ).undelegate( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-hover" );
				},
				mouseleave: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-hover" );
				}
			});
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					$( event.currentTarget ).addClass( "ui-state-focus" );
				},
				focusout: function( event ) {
					$( event.currentTarget ).removeClass( "ui-state-focus" );
				}
			});
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig,
				callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
			// the original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
			var hasOptions,
				effectName = !options ?
					method :
					options === true || typeof options === "number" ?
						defaultEffect :
						options.effect || defaultEffect;
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
			if ( options.delay ) {
				element.delay( options.delay );
			}
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue(function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				});
			}
		};
	});
	
	var widget = $.widget;
	
	
	/*!
	 * jQuery UI Mouse 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/mouse/
	 */
	
	
	var mouseHandled = false;
	$( document ).mouseup( function() {
		mouseHandled = false;
	});
	
	var mouse = $.widget("ui.mouse", {
		version: "1.11.4",
		options: {
			cancel: "input,textarea,button,select,option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.bind("mousedown." + this.widgetName, function(event) {
					return that._mouseDown(event);
				})
				.bind("click." + this.widgetName, function(event) {
					if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
						$.removeData(event.target, that.widgetName + ".preventClickEvent");
						event.stopImmediatePropagation();
						return false;
					}
				});
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.unbind("." + this.widgetName);
			if ( this._mouseMoveDelegate ) {
				this.document
					.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
					.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
			}
		},
	
		_mouseDown: function(event) {
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// we may have missed mouseup (out of window)
			(this._mouseStarted && this._mouseUp(event));
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = (event.which === 1),
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
			if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if (!this.mouseDelayMet) {
				this._mouseDelayTimer = setTimeout(function() {
					that.mouseDelayMet = true;
				}, this.options.delay);
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted = (this._mouseStart(event) !== false);
				if (!this._mouseStarted) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
				$.removeData(event.target, this.widgetName + ".preventClickEvent");
			}
	
			// these delegates are required to keep context
			this._mouseMoveDelegate = function(event) {
				return that._mouseMove(event);
			};
			this._mouseUpDelegate = function(event) {
				return that._mouseUp(event);
			};
	
			this.document
				.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function(event) {
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
				// IE mouseup check - mouseup happened when mouse was out of window
				if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
					return this._mouseUp(event);
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
					return this._mouseUp( event );
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if (this._mouseStarted) {
				this._mouseDrag(event);
				return event.preventDefault();
			}
	
			if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
				this._mouseStarted =
					(this._mouseStart(this._mouseDownEvent, event) !== false);
				(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function(event) {
			this.document
				.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if (this._mouseStarted) {
				this._mouseStarted = false;
	
				if (event.target === this._mouseDownEvent.target) {
					$.data(event.target, this.widgetName + ".preventClickEvent", true);
				}
	
				this._mouseStop(event);
			}
	
			mouseHandled = false;
			return false;
		},
	
		_mouseDistanceMet: function(event) {
			return (Math.max(
					Math.abs(this._mouseDownEvent.pageX - event.pageX),
					Math.abs(this._mouseDownEvent.pageY - event.pageY)
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function(/* event */) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function(/* event */) {},
		_mouseDrag: function(/* event */) {},
		_mouseStop: function(/* event */) {},
		_mouseCapture: function(/* event */) { return true; }
	});
	
	
	/*!
	 * jQuery UI Position 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/position/
	 */
	
	(function() {
	
	$.ui = $.ui || {};
	
	var cachedScrollbarWidth, supportsOffsetFractions,
		max = Math.max,
		abs = Math.abs,
		round = Math.round,
		rhorizontal = /left|center|right/,
		rvertical = /top|center|bottom/,
		roffset = /[\+\-]\d+(\.[\d]+)?%?/,
		rposition = /^\w+/,
		rpercent = /%$/,
		_position = $.fn.position;
	
	function getOffsets( offsets, width, height ) {
		return [
			parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
			parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
		];
	}
	
	function parseCss( element, property ) {
		return parseInt( $.css( element, property ), 10 ) || 0;
	}
	
	function getDimensions( elem ) {
		var raw = elem[0];
		if ( raw.nodeType === 9 ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: 0, left: 0 }
			};
		}
		if ( $.isWindow( raw ) ) {
			return {
				width: elem.width(),
				height: elem.height(),
				offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
			};
		}
		if ( raw.preventDefault ) {
			return {
				width: 0,
				height: 0,
				offset: { top: raw.pageY, left: raw.pageX }
			};
		}
		return {
			width: elem.outerWidth(),
			height: elem.outerHeight(),
			offset: elem.offset()
		};
	}
	
	$.position = {
		scrollbarWidth: function() {
			if ( cachedScrollbarWidth !== undefined ) {
				return cachedScrollbarWidth;
			}
			var w1, w2,
				div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
				innerDiv = div.children()[0];
	
			$( "body" ).append( div );
			w1 = innerDiv.offsetWidth;
			div.css( "overflow", "scroll" );
	
			w2 = innerDiv.offsetWidth;
	
			if ( w1 === w2 ) {
				w2 = div[0].clientWidth;
			}
	
			div.remove();
	
			return (cachedScrollbarWidth = w1 - w2);
		},
		getScrollInfo: function( within ) {
			var overflowX = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-x" ),
				overflowY = within.isWindow || within.isDocument ? "" :
					within.element.css( "overflow-y" ),
				hasOverflowX = overflowX === "scroll" ||
					( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
				hasOverflowY = overflowY === "scroll" ||
					( overflowY === "auto" && within.height < within.element[0].scrollHeight );
			return {
				width: hasOverflowY ? $.position.scrollbarWidth() : 0,
				height: hasOverflowX ? $.position.scrollbarWidth() : 0
			};
		},
		getWithinInfo: function( element ) {
			var withinElement = $( element || window ),
				isWindow = $.isWindow( withinElement[0] ),
				isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
			return {
				element: withinElement,
				isWindow: isWindow,
				isDocument: isDocument,
				offset: withinElement.offset() || { left: 0, top: 0 },
				scrollLeft: withinElement.scrollLeft(),
				scrollTop: withinElement.scrollTop(),
	
				// support: jQuery 1.6.x
				// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
				width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
				height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
			};
		}
	};
	
	$.fn.position = function( options ) {
		if ( !options || !options.of ) {
			return _position.apply( this, arguments );
		}
	
		// make a copy, we don't want to modify arguments
		options = $.extend( {}, options );
	
		var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
			target = $( options.of ),
			within = $.position.getWithinInfo( options.within ),
			scrollInfo = $.position.getScrollInfo( within ),
			collision = ( options.collision || "flip" ).split( " " ),
			offsets = {};
	
		dimensions = getDimensions( target );
		if ( target[0].preventDefault ) {
			// force left top to allow flipping
			options.at = "left top";
		}
		targetWidth = dimensions.width;
		targetHeight = dimensions.height;
		targetOffset = dimensions.offset;
		// clone to reuse original targetOffset later
		basePosition = $.extend( {}, targetOffset );
	
		// force my and at to have valid horizontal and vertical positions
		// if a value is missing or invalid, it will be converted to center
		$.each( [ "my", "at" ], function() {
			var pos = ( options[ this ] || "" ).split( " " ),
				horizontalOffset,
				verticalOffset;
	
			if ( pos.length === 1) {
				pos = rhorizontal.test( pos[ 0 ] ) ?
					pos.concat( [ "center" ] ) :
					rvertical.test( pos[ 0 ] ) ?
						[ "center" ].concat( pos ) :
						[ "center", "center" ];
			}
			pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
			pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";
	
			// calculate offsets
			horizontalOffset = roffset.exec( pos[ 0 ] );
			verticalOffset = roffset.exec( pos[ 1 ] );
			offsets[ this ] = [
				horizontalOffset ? horizontalOffset[ 0 ] : 0,
				verticalOffset ? verticalOffset[ 0 ] : 0
			];
	
			// reduce to just the positions without the offsets
			options[ this ] = [
				rposition.exec( pos[ 0 ] )[ 0 ],
				rposition.exec( pos[ 1 ] )[ 0 ]
			];
		});
	
		// normalize collision option
		if ( collision.length === 1 ) {
			collision[ 1 ] = collision[ 0 ];
		}
	
		if ( options.at[ 0 ] === "right" ) {
			basePosition.left += targetWidth;
		} else if ( options.at[ 0 ] === "center" ) {
			basePosition.left += targetWidth / 2;
		}
	
		if ( options.at[ 1 ] === "bottom" ) {
			basePosition.top += targetHeight;
		} else if ( options.at[ 1 ] === "center" ) {
			basePosition.top += targetHeight / 2;
		}
	
		atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
		basePosition.left += atOffset[ 0 ];
		basePosition.top += atOffset[ 1 ];
	
		return this.each(function() {
			var collisionPosition, using,
				elem = $( this ),
				elemWidth = elem.outerWidth(),
				elemHeight = elem.outerHeight(),
				marginLeft = parseCss( this, "marginLeft" ),
				marginTop = parseCss( this, "marginTop" ),
				collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
				collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
				position = $.extend( {}, basePosition ),
				myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );
	
			if ( options.my[ 0 ] === "right" ) {
				position.left -= elemWidth;
			} else if ( options.my[ 0 ] === "center" ) {
				position.left -= elemWidth / 2;
			}
	
			if ( options.my[ 1 ] === "bottom" ) {
				position.top -= elemHeight;
			} else if ( options.my[ 1 ] === "center" ) {
				position.top -= elemHeight / 2;
			}
	
			position.left += myOffset[ 0 ];
			position.top += myOffset[ 1 ];
	
			// if the browser doesn't support fractions, then round for consistent results
			if ( !supportsOffsetFractions ) {
				position.left = round( position.left );
				position.top = round( position.top );
			}
	
			collisionPosition = {
				marginLeft: marginLeft,
				marginTop: marginTop
			};
	
			$.each( [ "left", "top" ], function( i, dir ) {
				if ( $.ui.position[ collision[ i ] ] ) {
					$.ui.position[ collision[ i ] ][ dir ]( position, {
						targetWidth: targetWidth,
						targetHeight: targetHeight,
						elemWidth: elemWidth,
						elemHeight: elemHeight,
						collisionPosition: collisionPosition,
						collisionWidth: collisionWidth,
						collisionHeight: collisionHeight,
						offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
						my: options.my,
						at: options.at,
						within: within,
						elem: elem
					});
				}
			});
	
			if ( options.using ) {
				// adds feedback as second argument to using callback, if present
				using = function( props ) {
					var left = targetOffset.left - position.left,
						right = left + targetWidth - elemWidth,
						top = targetOffset.top - position.top,
						bottom = top + targetHeight - elemHeight,
						feedback = {
							target: {
								element: target,
								left: targetOffset.left,
								top: targetOffset.top,
								width: targetWidth,
								height: targetHeight
							},
							element: {
								element: elem,
								left: position.left,
								top: position.top,
								width: elemWidth,
								height: elemHeight
							},
							horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
							vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
						};
					if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
						feedback.horizontal = "center";
					}
					if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
						feedback.vertical = "middle";
					}
					if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
						feedback.important = "horizontal";
					} else {
						feedback.important = "vertical";
					}
					options.using.call( this, props, feedback );
				};
			}
	
			elem.offset( $.extend( position, { using: using } ) );
		});
	};
	
	$.ui.position = {
		fit: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
					outerWidth = within.width,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = withinOffset - collisionPosLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
					newOverRight;
	
				// element is wider than within
				if ( data.collisionWidth > outerWidth ) {
					// element is initially over the left side of within
					if ( overLeft > 0 && overRight <= 0 ) {
						newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
						position.left += overLeft - newOverRight;
					// element is initially over right side of within
					} else if ( overRight > 0 && overLeft <= 0 ) {
						position.left = withinOffset;
					// element is initially over both left and right sides of within
					} else {
						if ( overLeft > overRight ) {
							position.left = withinOffset + outerWidth - data.collisionWidth;
						} else {
							position.left = withinOffset;
						}
					}
				// too far left -> align with left edge
				} else if ( overLeft > 0 ) {
					position.left += overLeft;
				// too far right -> align with right edge
				} else if ( overRight > 0 ) {
					position.left -= overRight;
				// adjust based on position and margin
				} else {
					position.left = max( position.left - collisionPosLeft, position.left );
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
					outerHeight = data.within.height,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = withinOffset - collisionPosTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
					newOverBottom;
	
				// element is taller than within
				if ( data.collisionHeight > outerHeight ) {
					// element is initially over the top of within
					if ( overTop > 0 && overBottom <= 0 ) {
						newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
						position.top += overTop - newOverBottom;
					// element is initially over bottom of within
					} else if ( overBottom > 0 && overTop <= 0 ) {
						position.top = withinOffset;
					// element is initially over both top and bottom of within
					} else {
						if ( overTop > overBottom ) {
							position.top = withinOffset + outerHeight - data.collisionHeight;
						} else {
							position.top = withinOffset;
						}
					}
				// too far up -> align with top
				} else if ( overTop > 0 ) {
					position.top += overTop;
				// too far down -> align with bottom edge
				} else if ( overBottom > 0 ) {
					position.top -= overBottom;
				// adjust based on position and margin
				} else {
					position.top = max( position.top - collisionPosTop, position.top );
				}
			}
		},
		flip: {
			left: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.left + within.scrollLeft,
					outerWidth = within.width,
					offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
					collisionPosLeft = position.left - data.collisionPosition.marginLeft,
					overLeft = collisionPosLeft - offsetLeft,
					overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
					myOffset = data.my[ 0 ] === "left" ?
						-data.elemWidth :
						data.my[ 0 ] === "right" ?
							data.elemWidth :
							0,
					atOffset = data.at[ 0 ] === "left" ?
						data.targetWidth :
						data.at[ 0 ] === "right" ?
							-data.targetWidth :
							0,
					offset = -2 * data.offset[ 0 ],
					newOverRight,
					newOverLeft;
	
				if ( overLeft < 0 ) {
					newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
					if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
						position.left += myOffset + atOffset + offset;
					}
				} else if ( overRight > 0 ) {
					newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
					if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
						position.left += myOffset + atOffset + offset;
					}
				}
			},
			top: function( position, data ) {
				var within = data.within,
					withinOffset = within.offset.top + within.scrollTop,
					outerHeight = within.height,
					offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
					collisionPosTop = position.top - data.collisionPosition.marginTop,
					overTop = collisionPosTop - offsetTop,
					overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
					top = data.my[ 1 ] === "top",
					myOffset = top ?
						-data.elemHeight :
						data.my[ 1 ] === "bottom" ?
							data.elemHeight :
							0,
					atOffset = data.at[ 1 ] === "top" ?
						data.targetHeight :
						data.at[ 1 ] === "bottom" ?
							-data.targetHeight :
							0,
					offset = -2 * data.offset[ 1 ],
					newOverTop,
					newOverBottom;
				if ( overTop < 0 ) {
					newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
					if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
						position.top += myOffset + atOffset + offset;
					}
				} else if ( overBottom > 0 ) {
					newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
					if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
						position.top += myOffset + atOffset + offset;
					}
				}
			}
		},
		flipfit: {
			left: function() {
				$.ui.position.flip.left.apply( this, arguments );
				$.ui.position.fit.left.apply( this, arguments );
			},
			top: function() {
				$.ui.position.flip.top.apply( this, arguments );
				$.ui.position.fit.top.apply( this, arguments );
			}
		}
	};
	
	// fraction support test
	(function() {
		var testElement, testElementParent, testElementStyle, offsetLeft, i,
			body = document.getElementsByTagName( "body" )[ 0 ],
			div = document.createElement( "div" );
	
		//Create a "fake body" for testing based on method used in jQuery.support
		testElement = document.createElement( body ? "div" : "body" );
		testElementStyle = {
			visibility: "hidden",
			width: 0,
			height: 0,
			border: 0,
			margin: 0,
			background: "none"
		};
		if ( body ) {
			$.extend( testElementStyle, {
				position: "absolute",
				left: "-1000px",
				top: "-1000px"
			});
		}
		for ( i in testElementStyle ) {
			testElement.style[ i ] = testElementStyle[ i ];
		}
		testElement.appendChild( div );
		testElementParent = body || document.documentElement;
		testElementParent.insertBefore( testElement, testElementParent.firstChild );
	
		div.style.cssText = "position: absolute; left: 10.7432222px;";
	
		offsetLeft = $( div ).offset().left;
		supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;
	
		testElement.innerHTML = "";
		testElementParent.removeChild( testElement );
	})();
	
	})();
	
	var position = $.ui.position;
	
	
	/*!
	 * jQuery UI Accordion 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/accordion/
	 */
	
	
	var accordion = $.widget( "ui.accordion", {
		version: "1.11.4",
		options: {
			active: 0,
			animate: {},
			collapsible: false,
			event: "click",
			header: "> li > :first-child,> :not(li):even",
			heightStyle: "auto",
			icons: {
				activeHeader: "ui-icon-triangle-1-s",
				header: "ui-icon-triangle-1-e"
			},
	
			// callbacks
			activate: null,
			beforeActivate: null
		},
	
		hideProps: {
			borderTopWidth: "hide",
			borderBottomWidth: "hide",
			paddingTop: "hide",
			paddingBottom: "hide",
			height: "hide"
		},
	
		showProps: {
			borderTopWidth: "show",
			borderBottomWidth: "show",
			paddingTop: "show",
			paddingBottom: "show",
			height: "show"
		},
	
		_create: function() {
			var options = this.options;
			this.prevShow = this.prevHide = $();
			this.element.addClass( "ui-accordion ui-widget ui-helper-reset" )
				// ARIA
				.attr( "role", "tablist" );
	
			// don't allow collapsible: false and active: false / null
			if ( !options.collapsible && (options.active === false || options.active == null) ) {
				options.active = 0;
			}
	
			this._processPanels();
			// handle negative values
			if ( options.active < 0 ) {
				options.active += this.headers.length;
			}
			this._refresh();
		},
	
		_getCreateEventData: function() {
			return {
				header: this.active,
				panel: !this.active.length ? $() : this.active.next()
			};
		},
	
		_createIcons: function() {
			var icons = this.options.icons;
			if ( icons ) {
				$( "<span>" )
					.addClass( "ui-accordion-header-icon ui-icon " + icons.header )
					.prependTo( this.headers );
				this.active.children( ".ui-accordion-header-icon" )
					.removeClass( icons.header )
					.addClass( icons.activeHeader );
				this.headers.addClass( "ui-accordion-icons" );
			}
		},
	
		_destroyIcons: function() {
			this.headers
				.removeClass( "ui-accordion-icons" )
				.children( ".ui-accordion-header-icon" )
					.remove();
		},
	
		_destroy: function() {
			var contents;
	
			// clean up main element
			this.element
				.removeClass( "ui-accordion ui-widget ui-helper-reset" )
				.removeAttr( "role" );
	
			// clean up headers
			this.headers
				.removeClass( "ui-accordion-header ui-accordion-header-active ui-state-default " +
					"ui-corner-all ui-state-active ui-state-disabled ui-corner-top" )
				.removeAttr( "role" )
				.removeAttr( "aria-expanded" )
				.removeAttr( "aria-selected" )
				.removeAttr( "aria-controls" )
				.removeAttr( "tabIndex" )
				.removeUniqueId();
	
			this._destroyIcons();
	
			// clean up content panels
			contents = this.headers.next()
				.removeClass( "ui-helper-reset ui-widget-content ui-corner-bottom " +
					"ui-accordion-content ui-accordion-content-active ui-state-disabled" )
				.css( "display", "" )
				.removeAttr( "role" )
				.removeAttr( "aria-hidden" )
				.removeAttr( "aria-labelledby" )
				.removeUniqueId();
	
			if ( this.options.heightStyle !== "content" ) {
				contents.css( "height", "" );
			}
		},
	
		_setOption: function( key, value ) {
			if ( key === "active" ) {
				// _activate() will handle invalid values and update this.options
				this._activate( value );
				return;
			}
	
			if ( key === "event" ) {
				if ( this.options.event ) {
					this._off( this.headers, this.options.event );
				}
				this._setupEvents( value );
			}
	
			this._super( key, value );
	
			// setting collapsible: false while collapsed; open first panel
			if ( key === "collapsible" && !value && this.options.active === false ) {
				this._activate( 0 );
			}
	
			if ( key === "icons" ) {
				this._destroyIcons();
				if ( value ) {
					this._createIcons();
				}
			}
	
			// #5332 - opacity doesn't cascade to positioned elements in IE
			// so we need to add the disabled class to the headers and panels
			if ( key === "disabled" ) {
				this.element
					.toggleClass( "ui-state-disabled", !!value )
					.attr( "aria-disabled", value );
				this.headers.add( this.headers.next() )
					.toggleClass( "ui-state-disabled", !!value );
			}
		},
	
		_keydown: function( event ) {
			if ( event.altKey || event.ctrlKey ) {
				return;
			}
	
			var keyCode = $.ui.keyCode,
				length = this.headers.length,
				currentIndex = this.headers.index( event.target ),
				toFocus = false;
	
			switch ( event.keyCode ) {
				case keyCode.RIGHT:
				case keyCode.DOWN:
					toFocus = this.headers[ ( currentIndex + 1 ) % length ];
					break;
				case keyCode.LEFT:
				case keyCode.UP:
					toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
					break;
				case keyCode.SPACE:
				case keyCode.ENTER:
					this._eventHandler( event );
					break;
				case keyCode.HOME:
					toFocus = this.headers[ 0 ];
					break;
				case keyCode.END:
					toFocus = this.headers[ length - 1 ];
					break;
			}
	
			if ( toFocus ) {
				$( event.target ).attr( "tabIndex", -1 );
				$( toFocus ).attr( "tabIndex", 0 );
				toFocus.focus();
				event.preventDefault();
			}
		},
	
		_panelKeyDown: function( event ) {
			if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
				$( event.currentTarget ).prev().focus();
			}
		},
	
		refresh: function() {
			var options = this.options;
			this._processPanels();
	
			// was collapsed or no panel
			if ( ( options.active === false && options.collapsible === true ) || !this.headers.length ) {
				options.active = false;
				this.active = $();
			// active false only when collapsible is true
			} else if ( options.active === false ) {
				this._activate( 0 );
			// was active, but active panel is gone
			} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
				// all remaining panel are disabled
				if ( this.headers.length === this.headers.find(".ui-state-disabled").length ) {
					options.active = false;
					this.active = $();
				// activate previous panel
				} else {
					this._activate( Math.max( 0, options.active - 1 ) );
				}
			// was active, active panel still exists
			} else {
				// make sure active index is correct
				options.active = this.headers.index( this.active );
			}
	
			this._destroyIcons();
	
			this._refresh();
		},
	
		_processPanels: function() {
			var prevHeaders = this.headers,
				prevPanels = this.panels;
	
			this.headers = this.element.find( this.options.header )
				.addClass( "ui-accordion-header ui-state-default ui-corner-all" );
	
			this.panels = this.headers.next()
				.addClass( "ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom" )
				.filter( ":not(.ui-accordion-content-active)" )
				.hide();
	
			// Avoid memory leaks (#10056)
			if ( prevPanels ) {
				this._off( prevHeaders.not( this.headers ) );
				this._off( prevPanels.not( this.panels ) );
			}
		},
	
		_refresh: function() {
			var maxHeight,
				options = this.options,
				heightStyle = options.heightStyle,
				parent = this.element.parent();
	
			this.active = this._findActive( options.active )
				.addClass( "ui-accordion-header-active ui-state-active ui-corner-top" )
				.removeClass( "ui-corner-all" );
			this.active.next()
				.addClass( "ui-accordion-content-active" )
				.show();
	
			this.headers
				.attr( "role", "tab" )
				.each(function() {
					var header = $( this ),
						headerId = header.uniqueId().attr( "id" ),
						panel = header.next(),
						panelId = panel.uniqueId().attr( "id" );
					header.attr( "aria-controls", panelId );
					panel.attr( "aria-labelledby", headerId );
				})
				.next()
					.attr( "role", "tabpanel" );
	
			this.headers
				.not( this.active )
				.attr({
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				})
				.next()
					.attr({
						"aria-hidden": "true"
					})
					.hide();
	
			// make sure at least one header is in the tab order
			if ( !this.active.length ) {
				this.headers.eq( 0 ).attr( "tabIndex", 0 );
			} else {
				this.active.attr({
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				})
				.next()
					.attr({
						"aria-hidden": "false"
					});
			}
	
			this._createIcons();
	
			this._setupEvents( options.event );
	
			if ( heightStyle === "fill" ) {
				maxHeight = parent.height();
				this.element.siblings( ":visible" ).each(function() {
					var elem = $( this ),
						position = elem.css( "position" );
	
					if ( position === "absolute" || position === "fixed" ) {
						return;
					}
					maxHeight -= elem.outerHeight( true );
				});
	
				this.headers.each(function() {
					maxHeight -= $( this ).outerHeight( true );
				});
	
				this.headers.next()
					.each(function() {
						$( this ).height( Math.max( 0, maxHeight -
							$( this ).innerHeight() + $( this ).height() ) );
					})
					.css( "overflow", "auto" );
			} else if ( heightStyle === "auto" ) {
				maxHeight = 0;
				this.headers.next()
					.each(function() {
						maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					})
					.height( maxHeight );
			}
		},
	
		_activate: function( index ) {
			var active = this._findActive( index )[ 0 ];
	
			// trying to activate the already active panel
			if ( active === this.active[ 0 ] ) {
				return;
			}
	
			// trying to collapse, simulate a click on the currently active header
			active = active || this.active[ 0 ];
	
			this._eventHandler({
				target: active,
				currentTarget: active,
				preventDefault: $.noop
			});
		},
	
		_findActive: function( selector ) {
			return typeof selector === "number" ? this.headers.eq( selector ) : $();
		},
	
		_setupEvents: function( event ) {
			var events = {
				keydown: "_keydown"
			};
			if ( event ) {
				$.each( event.split( " " ), function( index, eventName ) {
					events[ eventName ] = "_eventHandler";
				});
			}
	
			this._off( this.headers.add( this.headers.next() ) );
			this._on( this.headers, events );
			this._on( this.headers.next(), { keydown: "_panelKeyDown" });
			this._hoverable( this.headers );
			this._focusable( this.headers );
		},
	
		_eventHandler: function( event ) {
			var options = this.options,
				active = this.active,
				clicked = $( event.currentTarget ),
				clickedIsActive = clicked[ 0 ] === active[ 0 ],
				collapsing = clickedIsActive && options.collapsible,
				toShow = collapsing ? $() : clicked.next(),
				toHide = active.next(),
				eventData = {
					oldHeader: active,
					oldPanel: toHide,
					newHeader: collapsing ? $() : clicked,
					newPanel: toShow
				};
	
			event.preventDefault();
	
			if (
					// click on active header, but not collapsible
					( clickedIsActive && !options.collapsible ) ||
					// allow canceling activation
					( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
				return;
			}
	
			options.active = collapsing ? false : this.headers.index( clicked );
	
			// when the call to ._toggle() comes after the class changes
			// it causes a very odd bug in IE 8 (see #6720)
			this.active = clickedIsActive ? $() : clicked;
			this._toggle( eventData );
	
			// switch classes
			// corner classes on the previously active header stay after the animation
			active.removeClass( "ui-accordion-header-active ui-state-active" );
			if ( options.icons ) {
				active.children( ".ui-accordion-header-icon" )
					.removeClass( options.icons.activeHeader )
					.addClass( options.icons.header );
			}
	
			if ( !clickedIsActive ) {
				clicked
					.removeClass( "ui-corner-all" )
					.addClass( "ui-accordion-header-active ui-state-active ui-corner-top" );
				if ( options.icons ) {
					clicked.children( ".ui-accordion-header-icon" )
						.removeClass( options.icons.header )
						.addClass( options.icons.activeHeader );
				}
	
				clicked
					.next()
					.addClass( "ui-accordion-content-active" );
			}
		},
	
		_toggle: function( data ) {
			var toShow = data.newPanel,
				toHide = this.prevShow.length ? this.prevShow : data.oldPanel;
	
			// handle activating a panel during the animation for another activation
			this.prevShow.add( this.prevHide ).stop( true, true );
			this.prevShow = toShow;
			this.prevHide = toHide;
	
			if ( this.options.animate ) {
				this._animate( toShow, toHide, data );
			} else {
				toHide.hide();
				toShow.show();
				this._toggleComplete( data );
			}
	
			toHide.attr({
				"aria-hidden": "true"
			});
			toHide.prev().attr({
				"aria-selected": "false",
				"aria-expanded": "false"
			});
			// if we're switching panels, remove the old header from the tab order
			// if we're opening from collapsed state, remove the previous header from the tab order
			// if we're collapsing, then keep the collapsing header in the tab order
			if ( toShow.length && toHide.length ) {
				toHide.prev().attr({
					"tabIndex": -1,
					"aria-expanded": "false"
				});
			} else if ( toShow.length ) {
				this.headers.filter(function() {
					return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
				})
				.attr( "tabIndex", -1 );
			}
	
			toShow
				.attr( "aria-hidden", "false" )
				.prev()
					.attr({
						"aria-selected": "true",
						"aria-expanded": "true",
						tabIndex: 0
					});
		},
	
		_animate: function( toShow, toHide, data ) {
			var total, easing, duration,
				that = this,
				adjust = 0,
				boxSizing = toShow.css( "box-sizing" ),
				down = toShow.length &&
					( !toHide.length || ( toShow.index() < toHide.index() ) ),
				animate = this.options.animate || {},
				options = down && animate.down || animate,
				complete = function() {
					that._toggleComplete( data );
				};
	
			if ( typeof options === "number" ) {
				duration = options;
			}
			if ( typeof options === "string" ) {
				easing = options;
			}
			// fall back from options to animation in case of partial down settings
			easing = easing || options.easing || animate.easing;
			duration = duration || options.duration || animate.duration;
	
			if ( !toHide.length ) {
				return toShow.animate( this.showProps, duration, easing, complete );
			}
			if ( !toShow.length ) {
				return toHide.animate( this.hideProps, duration, easing, complete );
			}
	
			total = toShow.show().outerHeight();
			toHide.animate( this.hideProps, {
				duration: duration,
				easing: easing,
				step: function( now, fx ) {
					fx.now = Math.round( now );
				}
			});
			toShow
				.hide()
				.animate( this.showProps, {
					duration: duration,
					easing: easing,
					complete: complete,
					step: function( now, fx ) {
						fx.now = Math.round( now );
						if ( fx.prop !== "height" ) {
							if ( boxSizing === "content-box" ) {
								adjust += fx.now;
							}
						} else if ( that.options.heightStyle !== "content" ) {
							fx.now = Math.round( total - toHide.outerHeight() - adjust );
							adjust = 0;
						}
					}
				});
		},
	
		_toggleComplete: function( data ) {
			var toHide = data.oldPanel;
	
			toHide
				.removeClass( "ui-accordion-content-active" )
				.prev()
					.removeClass( "ui-corner-top" )
					.addClass( "ui-corner-all" );
	
			// Work around for rendering bug in IE (#5421)
			if ( toHide.length ) {
				toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
			}
			this._trigger( "activate", null, data );
		}
	});
	
	
	/*!
	 * jQuery UI Menu 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/menu/
	 */
	
	
	var menu = $.widget( "ui.menu", {
		version: "1.11.4",
		defaultElement: "<ul>",
		delay: 300,
		options: {
			icons: {
				submenu: "ui-icon-carat-1-e"
			},
			items: "> *",
			menus: "ul",
			position: {
				my: "left-1 top",
				at: "right top"
			},
			role: "menu",
	
			// callbacks
			blur: null,
			focus: null,
			select: null
		},
	
		_create: function() {
			this.activeMenu = this.element;
	
			// Flag used to prevent firing of the click handler
			// as the event bubbles up through nested menus
			this.mouseHandled = false;
			this.element
				.uniqueId()
				.addClass( "ui-menu ui-widget ui-widget-content" )
				.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
				.attr({
					role: this.options.role,
					tabIndex: 0
				});
	
			if ( this.options.disabled ) {
				this.element
					.addClass( "ui-state-disabled" )
					.attr( "aria-disabled", "true" );
			}
	
			this._on({
				// Prevent focus from sticking to links inside menu after clicking
				// them (focus should always stay on UL during navigation).
				"mousedown .ui-menu-item": function( event ) {
					event.preventDefault();
				},
				"click .ui-menu-item": function( event ) {
					var target = $( event.target );
					if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
						this.select( event );
	
						// Only set the mouseHandled flag if the event will bubble, see #9469.
						if ( !event.isPropagationStopped() ) {
							this.mouseHandled = true;
						}
	
						// Open submenu on click
						if ( target.has( ".ui-menu" ).length ) {
							this.expand( event );
						} else if ( !this.element.is( ":focus" ) && $( this.document[ 0 ].activeElement ).closest( ".ui-menu" ).length ) {
	
							// Redirect focus to the menu
							this.element.trigger( "focus", [ true ] );
	
							// If the active item is on the top level, let it stay active.
							// Otherwise, blur the active item since it is no longer visible.
							if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
								clearTimeout( this.timer );
							}
						}
					}
				},
				"mouseenter .ui-menu-item": function( event ) {
					// Ignore mouse events while typeahead is active, see #10458.
					// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
					// is over an item in the menu
					if ( this.previousFilter ) {
						return;
					}
					var target = $( event.currentTarget );
					// Remove ui-state-active class from siblings of the newly focused menu item
					// to avoid a jump caused by adjacent elements both having a class with a border
					target.siblings( ".ui-state-active" ).removeClass( "ui-state-active" );
					this.focus( event, target );
				},
				mouseleave: "collapseAll",
				"mouseleave .ui-menu": "collapseAll",
				focus: function( event, keepActiveItem ) {
					// If there's already an active item, keep it active
					// If not, activate the first item
					var item = this.active || this.element.find( this.options.items ).eq( 0 );
	
					if ( !keepActiveItem ) {
						this.focus( event, item );
					}
				},
				blur: function( event ) {
					this._delay(function() {
						if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
							this.collapseAll( event );
						}
					});
				},
				keydown: "_keydown"
			});
	
			this.refresh();
	
			// Clicks outside of a menu collapse any open menus
			this._on( this.document, {
				click: function( event ) {
					if ( this._closeOnDocumentClick( event ) ) {
						this.collapseAll( event );
					}
	
					// Reset the mouseHandled flag
					this.mouseHandled = false;
				}
			});
		},
	
		_destroy: function() {
			// Destroy (sub)menus
			this.element
				.removeAttr( "aria-activedescendant" )
				.find( ".ui-menu" ).addBack()
					.removeClass( "ui-menu ui-widget ui-widget-content ui-menu-icons ui-front" )
					.removeAttr( "role" )
					.removeAttr( "tabIndex" )
					.removeAttr( "aria-labelledby" )
					.removeAttr( "aria-expanded" )
					.removeAttr( "aria-hidden" )
					.removeAttr( "aria-disabled" )
					.removeUniqueId()
					.show();
	
			// Destroy menu items
			this.element.find( ".ui-menu-item" )
				.removeClass( "ui-menu-item" )
				.removeAttr( "role" )
				.removeAttr( "aria-disabled" )
				.removeUniqueId()
				.removeClass( "ui-state-hover" )
				.removeAttr( "tabIndex" )
				.removeAttr( "role" )
				.removeAttr( "aria-haspopup" )
				.children().each( function() {
					var elem = $( this );
					if ( elem.data( "ui-menu-submenu-carat" ) ) {
						elem.remove();
					}
				});
	
			// Destroy menu dividers
			this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
		},
	
		_keydown: function( event ) {
			var match, prev, character, skip,
				preventDefault = true;
	
			switch ( event.keyCode ) {
			case $.ui.keyCode.PAGE_UP:
				this.previousPage( event );
				break;
			case $.ui.keyCode.PAGE_DOWN:
				this.nextPage( event );
				break;
			case $.ui.keyCode.HOME:
				this._move( "first", "first", event );
				break;
			case $.ui.keyCode.END:
				this._move( "last", "last", event );
				break;
			case $.ui.keyCode.UP:
				this.previous( event );
				break;
			case $.ui.keyCode.DOWN:
				this.next( event );
				break;
			case $.ui.keyCode.LEFT:
				this.collapse( event );
				break;
			case $.ui.keyCode.RIGHT:
				if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
					this.expand( event );
				}
				break;
			case $.ui.keyCode.ENTER:
			case $.ui.keyCode.SPACE:
				this._activate( event );
				break;
			case $.ui.keyCode.ESCAPE:
				this.collapse( event );
				break;
			default:
				preventDefault = false;
				prev = this.previousFilter || "";
				character = String.fromCharCode( event.keyCode );
				skip = false;
	
				clearTimeout( this.filterTimer );
	
				if ( character === prev ) {
					skip = true;
				} else {
					character = prev + character;
				}
	
				match = this._filterMenuItems( character );
				match = skip && match.index( this.active.next() ) !== -1 ?
					this.active.nextAll( ".ui-menu-item" ) :
					match;
	
				// If no matches on the current filter, reset to the last character pressed
				// to move down the menu to the first item that starts with that character
				if ( !match.length ) {
					character = String.fromCharCode( event.keyCode );
					match = this._filterMenuItems( character );
				}
	
				if ( match.length ) {
					this.focus( event, match );
					this.previousFilter = character;
					this.filterTimer = this._delay(function() {
						delete this.previousFilter;
					}, 1000 );
				} else {
					delete this.previousFilter;
				}
			}
	
			if ( preventDefault ) {
				event.preventDefault();
			}
		},
	
		_activate: function( event ) {
			if ( !this.active.is( ".ui-state-disabled" ) ) {
				if ( this.active.is( "[aria-haspopup='true']" ) ) {
					this.expand( event );
				} else {
					this.select( event );
				}
			}
		},
	
		refresh: function() {
			var menus, items,
				that = this,
				icon = this.options.icons.submenu,
				submenus = this.element.find( this.options.menus );
	
			this.element.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length );
	
			// Initialize nested menus
			submenus.filter( ":not(.ui-menu)" )
				.addClass( "ui-menu ui-widget ui-widget-content ui-front" )
				.hide()
				.attr({
					role: this.options.role,
					"aria-hidden": "true",
					"aria-expanded": "false"
				})
				.each(function() {
					var menu = $( this ),
						item = menu.parent(),
						submenuCarat = $( "<span>" )
							.addClass( "ui-menu-icon ui-icon " + icon )
							.data( "ui-menu-submenu-carat", true );
	
					item
						.attr( "aria-haspopup", "true" )
						.prepend( submenuCarat );
					menu.attr( "aria-labelledby", item.attr( "id" ) );
				});
	
			menus = submenus.add( this.element );
			items = menus.find( this.options.items );
	
			// Initialize menu-items containing spaces and/or dashes only as dividers
			items.not( ".ui-menu-item" ).each(function() {
				var item = $( this );
				if ( that._isDivider( item ) ) {
					item.addClass( "ui-widget-content ui-menu-divider" );
				}
			});
	
			// Don't refresh list items that are already adapted
			items.not( ".ui-menu-item, .ui-menu-divider" )
				.addClass( "ui-menu-item" )
				.uniqueId()
				.attr({
					tabIndex: -1,
					role: this._itemRole()
				});
	
			// Add aria-disabled attribute to any disabled menu item
			items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );
	
			// If the active item has been removed, blur the menu
			if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
				this.blur();
			}
		},
	
		_itemRole: function() {
			return {
				menu: "menuitem",
				listbox: "option"
			}[ this.options.role ];
		},
	
		_setOption: function( key, value ) {
			if ( key === "icons" ) {
				this.element.find( ".ui-menu-icon" )
					.removeClass( this.options.icons.submenu )
					.addClass( value.submenu );
			}
			if ( key === "disabled" ) {
				this.element
					.toggleClass( "ui-state-disabled", !!value )
					.attr( "aria-disabled", value );
			}
			this._super( key, value );
		},
	
		focus: function( event, item ) {
			var nested, focused;
			this.blur( event, event && event.type === "focus" );
	
			this._scrollIntoView( item );
	
			this.active = item.first();
			focused = this.active.addClass( "ui-state-focus" ).removeClass( "ui-state-active" );
			// Only update aria-activedescendant if there's a role
			// otherwise we assume focus is managed elsewhere
			if ( this.options.role ) {
				this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
			}
	
			// Highlight active parent menu item, if any
			this.active
				.parent()
				.closest( ".ui-menu-item" )
				.addClass( "ui-state-active" );
	
			if ( event && event.type === "keydown" ) {
				this._close();
			} else {
				this.timer = this._delay(function() {
					this._close();
				}, this.delay );
			}
	
			nested = item.children( ".ui-menu" );
			if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
				this._startOpening(nested);
			}
			this.activeMenu = item.parent();
	
			this._trigger( "focus", event, { item: item } );
		},
	
		_scrollIntoView: function( item ) {
			var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
			if ( this._hasScroll() ) {
				borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
				paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
				offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
				scroll = this.activeMenu.scrollTop();
				elementHeight = this.activeMenu.height();
				itemHeight = item.outerHeight();
	
				if ( offset < 0 ) {
					this.activeMenu.scrollTop( scroll + offset );
				} else if ( offset + itemHeight > elementHeight ) {
					this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
				}
			}
		},
	
		blur: function( event, fromFocus ) {
			if ( !fromFocus ) {
				clearTimeout( this.timer );
			}
	
			if ( !this.active ) {
				return;
			}
	
			this.active.removeClass( "ui-state-focus" );
			this.active = null;
	
			this._trigger( "blur", event, { item: this.active } );
		},
	
		_startOpening: function( submenu ) {
			clearTimeout( this.timer );
	
			// Don't open if already open fixes a Firefox bug that caused a .5 pixel
			// shift in the submenu position when mousing over the carat icon
			if ( submenu.attr( "aria-hidden" ) !== "true" ) {
				return;
			}
	
			this.timer = this._delay(function() {
				this._close();
				this._open( submenu );
			}, this.delay );
		},
	
		_open: function( submenu ) {
			var position = $.extend({
				of: this.active
			}, this.options.position );
	
			clearTimeout( this.timer );
			this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
				.hide()
				.attr( "aria-hidden", "true" );
	
			submenu
				.show()
				.removeAttr( "aria-hidden" )
				.attr( "aria-expanded", "true" )
				.position( position );
		},
	
		collapseAll: function( event, all ) {
			clearTimeout( this.timer );
			this.timer = this._delay(function() {
				// If we were passed an event, look for the submenu that contains the event
				var currentMenu = all ? this.element :
					$( event && event.target ).closest( this.element.find( ".ui-menu" ) );
	
				// If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
				if ( !currentMenu.length ) {
					currentMenu = this.element;
				}
	
				this._close( currentMenu );
	
				this.blur( event );
				this.activeMenu = currentMenu;
			}, this.delay );
		},
	
		// With no arguments, closes the currently active menu - if nothing is active
		// it closes all menus.  If passed an argument, it will search for menus BELOW
		_close: function( startMenu ) {
			if ( !startMenu ) {
				startMenu = this.active ? this.active.parent() : this.element;
			}
	
			startMenu
				.find( ".ui-menu" )
					.hide()
					.attr( "aria-hidden", "true" )
					.attr( "aria-expanded", "false" )
				.end()
				.find( ".ui-state-active" ).not( ".ui-state-focus" )
					.removeClass( "ui-state-active" );
		},
	
		_closeOnDocumentClick: function( event ) {
			return !$( event.target ).closest( ".ui-menu" ).length;
		},
	
		_isDivider: function( item ) {
	
			// Match hyphen, em dash, en dash
			return !/[^\-\u2014\u2013\s]/.test( item.text() );
		},
	
		collapse: function( event ) {
			var newItem = this.active &&
				this.active.parent().closest( ".ui-menu-item", this.element );
			if ( newItem && newItem.length ) {
				this._close();
				this.focus( event, newItem );
			}
		},
	
		expand: function( event ) {
			var newItem = this.active &&
				this.active
					.children( ".ui-menu " )
					.find( this.options.items )
					.first();
	
			if ( newItem && newItem.length ) {
				this._open( newItem.parent() );
	
				// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
				this._delay(function() {
					this.focus( event, newItem );
				});
			}
		},
	
		next: function( event ) {
			this._move( "next", "first", event );
		},
	
		previous: function( event ) {
			this._move( "prev", "last", event );
		},
	
		isFirstItem: function() {
			return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
		},
	
		isLastItem: function() {
			return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
		},
	
		_move: function( direction, filter, event ) {
			var next;
			if ( this.active ) {
				if ( direction === "first" || direction === "last" ) {
					next = this.active
						[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
						.eq( -1 );
				} else {
					next = this.active
						[ direction + "All" ]( ".ui-menu-item" )
						.eq( 0 );
				}
			}
			if ( !next || !next.length || !this.active ) {
				next = this.activeMenu.find( this.options.items )[ filter ]();
			}
	
			this.focus( event, next );
		},
	
		nextPage: function( event ) {
			var item, base, height;
	
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isLastItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.nextAll( ".ui-menu-item" ).each(function() {
					item = $( this );
					return item.offset().top - base - height < 0;
				});
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items )
					[ !this.active ? "first" : "last" ]() );
			}
		},
	
		previousPage: function( event ) {
			var item, base, height;
			if ( !this.active ) {
				this.next( event );
				return;
			}
			if ( this.isFirstItem() ) {
				return;
			}
			if ( this._hasScroll() ) {
				base = this.active.offset().top;
				height = this.element.height();
				this.active.prevAll( ".ui-menu-item" ).each(function() {
					item = $( this );
					return item.offset().top - base + height > 0;
				});
	
				this.focus( event, item );
			} else {
				this.focus( event, this.activeMenu.find( this.options.items ).first() );
			}
		},
	
		_hasScroll: function() {
			return this.element.outerHeight() < this.element.prop( "scrollHeight" );
		},
	
		select: function( event ) {
			// TODO: It should never be possible to not have an active item at this
			// point, but the tests don't trigger mouseenter before click.
			this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
			var ui = { item: this.active };
			if ( !this.active.has( ".ui-menu" ).length ) {
				this.collapseAll( event, true );
			}
			this._trigger( "select", event, ui );
		},
	
		_filterMenuItems: function(character) {
			var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
				regex = new RegExp( "^" + escapedCharacter, "i" );
	
			return this.activeMenu
				.find( this.options.items )
	
				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
				.filter(function() {
					return regex.test( $.trim( $( this ).text() ) );
				});
		}
	});
	
	
	/*!
	 * jQuery UI Autocomplete 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/autocomplete/
	 */
	
	
	$.widget( "ui.autocomplete", {
		version: "1.11.4",
		defaultElement: "<input>",
		options: {
			appendTo: null,
			autoFocus: false,
			delay: 300,
			minLength: 1,
			position: {
				my: "left top",
				at: "left bottom",
				collision: "none"
			},
			source: null,
	
			// callbacks
			change: null,
			close: null,
			focus: null,
			open: null,
			response: null,
			search: null,
			select: null
		},
	
		requestIndex: 0,
		pending: 0,
	
		_create: function() {
			// Some browsers only repeat keydown events, not keypress events,
			// so we use the suppressKeyPress flag to determine if we've already
			// handled the keydown event. #7269
			// Unfortunately the code for & in keypress is the same as the up arrow,
			// so we use the suppressKeyPressRepeat flag to avoid handling keypress
			// events when we know the keydown event was used to modify the
			// search term. #7799
			var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
				nodeName = this.element[ 0 ].nodeName.toLowerCase(),
				isTextarea = nodeName === "textarea",
				isInput = nodeName === "input";
	
			this.isMultiLine =
				// Textareas are always multi-line
				isTextarea ? true :
				// Inputs are always single-line, even if inside a contentEditable element
				// IE also treats inputs as contentEditable
				isInput ? false :
				// All other element types are determined by whether or not they're contentEditable
				this.element.prop( "isContentEditable" );
	
			this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
			this.isNewMenu = true;
	
			this.element
				.addClass( "ui-autocomplete-input" )
				.attr( "autocomplete", "off" );
	
			this._on( this.element, {
				keydown: function( event ) {
					if ( this.element.prop( "readOnly" ) ) {
						suppressKeyPress = true;
						suppressInput = true;
						suppressKeyPressRepeat = true;
						return;
					}
	
					suppressKeyPress = false;
					suppressInput = false;
					suppressKeyPressRepeat = false;
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						suppressKeyPress = true;
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						suppressKeyPress = true;
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						suppressKeyPress = true;
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						suppressKeyPress = true;
						this._keyEvent( "next", event );
						break;
					case keyCode.ENTER:
						// when menu is open and has focus
						if ( this.menu.active ) {
							// #6055 - Opera still allows the keypress to occur
							// which causes forms to submit
							suppressKeyPress = true;
							event.preventDefault();
							this.menu.select( event );
						}
						break;
					case keyCode.TAB:
						if ( this.menu.active ) {
							this.menu.select( event );
						}
						break;
					case keyCode.ESCAPE:
						if ( this.menu.element.is( ":visible" ) ) {
							if ( !this.isMultiLine ) {
								this._value( this.term );
							}
							this.close( event );
							// Different browsers have different default behavior for escape
							// Single press can mean undo or clear
							// Double press in IE means clear the whole form
							event.preventDefault();
						}
						break;
					default:
						suppressKeyPressRepeat = true;
						// search timeout should be triggered before the input value is changed
						this._searchTimeout( event );
						break;
					}
				},
				keypress: function( event ) {
					if ( suppressKeyPress ) {
						suppressKeyPress = false;
						if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
							event.preventDefault();
						}
						return;
					}
					if ( suppressKeyPressRepeat ) {
						return;
					}
	
					// replicate some key handlers to allow them to repeat in Firefox and Opera
					var keyCode = $.ui.keyCode;
					switch ( event.keyCode ) {
					case keyCode.PAGE_UP:
						this._move( "previousPage", event );
						break;
					case keyCode.PAGE_DOWN:
						this._move( "nextPage", event );
						break;
					case keyCode.UP:
						this._keyEvent( "previous", event );
						break;
					case keyCode.DOWN:
						this._keyEvent( "next", event );
						break;
					}
				},
				input: function( event ) {
					if ( suppressInput ) {
						suppressInput = false;
						event.preventDefault();
						return;
					}
					this._searchTimeout( event );
				},
				focus: function() {
					this.selectedItem = null;
					this.previous = this._value();
				},
				blur: function( event ) {
					if ( this.cancelBlur ) {
						delete this.cancelBlur;
						return;
					}
	
					clearTimeout( this.searching );
					this.close( event );
					this._change( event );
				}
			});
	
			this._initSource();
			this.menu = $( "<ul>" )
				.addClass( "ui-autocomplete ui-front" )
				.appendTo( this._appendTo() )
				.menu({
					// disable ARIA support, the live region takes care of that
					role: null
				})
				.hide()
				.menu( "instance" );
	
			this._on( this.menu.element, {
				mousedown: function( event ) {
					// prevent moving focus out of the text field
					event.preventDefault();
	
					// IE doesn't prevent moving focus even with event.preventDefault()
					// so we set a flag to know when we should ignore the blur event
					this.cancelBlur = true;
					this._delay(function() {
						delete this.cancelBlur;
					});
	
					// clicking on the scrollbar causes focus to shift to the body
					// but we can't detect a mouseup or a click immediately afterward
					// so we have to track the next mousedown and close the menu if
					// the user clicks somewhere outside of the autocomplete
					var menuElement = this.menu.element[ 0 ];
					if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
						this._delay(function() {
							var that = this;
							this.document.one( "mousedown", function( event ) {
								if ( event.target !== that.element[ 0 ] &&
										event.target !== menuElement &&
										!$.contains( menuElement, event.target ) ) {
									that.close();
								}
							});
						});
					}
				},
				menufocus: function( event, ui ) {
					var label, item;
					// support: Firefox
					// Prevent accidental activation of menu items in Firefox (#7024 #9118)
					if ( this.isNewMenu ) {
						this.isNewMenu = false;
						if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
							this.menu.blur();
	
							this.document.one( "mousemove", function() {
								$( event.target ).trigger( event.originalEvent );
							});
	
							return;
						}
					}
	
					item = ui.item.data( "ui-autocomplete-item" );
					if ( false !== this._trigger( "focus", event, { item: item } ) ) {
						// use value to match what will end up in the input, if it was a key event
						if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
							this._value( item.value );
						}
					}
	
					// Announce the value in the liveRegion
					label = ui.item.attr( "aria-label" ) || item.value;
					if ( label && $.trim( label ).length ) {
						this.liveRegion.children().hide();
						$( "<div>" ).text( label ).appendTo( this.liveRegion );
					}
				},
				menuselect: function( event, ui ) {
					var item = ui.item.data( "ui-autocomplete-item" ),
						previous = this.previous;
	
					// only trigger when focus was lost (click on menu)
					if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
						this.element.focus();
						this.previous = previous;
						// #6109 - IE triggers two focus events and the second
						// is asynchronous, so we need to reset the previous
						// term synchronously and asynchronously :-(
						this._delay(function() {
							this.previous = previous;
							this.selectedItem = item;
						});
					}
	
					if ( false !== this._trigger( "select", event, { item: item } ) ) {
						this._value( item.value );
					}
					// reset the term after the select event
					// this allows custom select handling to work properly
					this.term = this._value();
	
					this.close( event );
					this.selectedItem = item;
				}
			});
	
			this.liveRegion = $( "<span>", {
					role: "status",
					"aria-live": "assertive",
					"aria-relevant": "additions"
				})
				.addClass( "ui-helper-hidden-accessible" )
				.appendTo( this.document[ 0 ].body );
	
			// turning off autocomplete prevents the browser from remembering the
			// value when navigating through history, so we re-enable autocomplete
			// if the page is unloaded before the widget is destroyed. #7790
			this._on( this.window, {
				beforeunload: function() {
					this.element.removeAttr( "autocomplete" );
				}
			});
		},
	
		_destroy: function() {
			clearTimeout( this.searching );
			this.element
				.removeClass( "ui-autocomplete-input" )
				.removeAttr( "autocomplete" );
			this.menu.element.remove();
			this.liveRegion.remove();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "source" ) {
				this._initSource();
			}
			if ( key === "appendTo" ) {
				this.menu.element.appendTo( this._appendTo() );
			}
			if ( key === "disabled" && value && this.xhr ) {
				this.xhr.abort();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
	
			if ( element ) {
				element = element.jquery || element.nodeType ?
					$( element ) :
					this.document.find( element ).eq( 0 );
			}
	
			if ( !element || !element[ 0 ] ) {
				element = this.element.closest( ".ui-front" );
			}
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_initSource: function() {
			var array, url,
				that = this;
			if ( $.isArray( this.options.source ) ) {
				array = this.options.source;
				this.source = function( request, response ) {
					response( $.ui.autocomplete.filter( array, request.term ) );
				};
			} else if ( typeof this.options.source === "string" ) {
				url = this.options.source;
				this.source = function( request, response ) {
					if ( that.xhr ) {
						that.xhr.abort();
					}
					that.xhr = $.ajax({
						url: url,
						data: request,
						dataType: "json",
						success: function( data ) {
							response( data );
						},
						error: function() {
							response([]);
						}
					});
				};
			} else {
				this.source = this.options.source;
			}
		},
	
		_searchTimeout: function( event ) {
			clearTimeout( this.searching );
			this.searching = this._delay(function() {
	
				// Search if the value has changed, or if the user retypes the same value (see #7434)
				var equalValues = this.term === this._value(),
					menuVisible = this.menu.element.is( ":visible" ),
					modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	
				if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
					this.selectedItem = null;
					this.search( null, event );
				}
			}, this.options.delay );
		},
	
		search: function( value, event ) {
			value = value != null ? value : this._value();
	
			// always save the actual value, not the one passed as an argument
			this.term = this._value();
	
			if ( value.length < this.options.minLength ) {
				return this.close( event );
			}
	
			if ( this._trigger( "search", event ) === false ) {
				return;
			}
	
			return this._search( value );
		},
	
		_search: function( value ) {
			this.pending++;
			this.element.addClass( "ui-autocomplete-loading" );
			this.cancelSearch = false;
	
			this.source( { term: value }, this._response() );
		},
	
		_response: function() {
			var index = ++this.requestIndex;
	
			return $.proxy(function( content ) {
				if ( index === this.requestIndex ) {
					this.__response( content );
				}
	
				this.pending--;
				if ( !this.pending ) {
					this.element.removeClass( "ui-autocomplete-loading" );
				}
			}, this );
		},
	
		__response: function( content ) {
			if ( content ) {
				content = this._normalize( content );
			}
			this._trigger( "response", null, { content: content } );
			if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
				this._suggest( content );
				this._trigger( "open" );
			} else {
				// use ._close() instead of .close() so we don't cancel future searches
				this._close();
			}
		},
	
		close: function( event ) {
			this.cancelSearch = true;
			this._close( event );
		},
	
		_close: function( event ) {
			if ( this.menu.element.is( ":visible" ) ) {
				this.menu.element.hide();
				this.menu.blur();
				this.isNewMenu = true;
				this._trigger( "close", event );
			}
		},
	
		_change: function( event ) {
			if ( this.previous !== this._value() ) {
				this._trigger( "change", event, { item: this.selectedItem } );
			}
		},
	
		_normalize: function( items ) {
			// assume all items have the right format when the first item is complete
			if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
				return items;
			}
			return $.map( items, function( item ) {
				if ( typeof item === "string" ) {
					return {
						label: item,
						value: item
					};
				}
				return $.extend( {}, item, {
					label: item.label || item.value,
					value: item.value || item.label
				});
			});
		},
	
		_suggest: function( items ) {
			var ul = this.menu.element.empty();
			this._renderMenu( ul, items );
			this.isNewMenu = true;
			this.menu.refresh();
	
			// size and position menu
			ul.show();
			this._resizeMenu();
			ul.position( $.extend({
				of: this.element
			}, this.options.position ) );
	
			if ( this.options.autoFocus ) {
				this.menu.next();
			}
		},
	
		_resizeMenu: function() {
			var ul = this.menu.element;
			ul.outerWidth( Math.max(
				// Firefox wraps long text (possibly a rounding bug)
				// so we add 1px to avoid the wrapping (#7513)
				ul.width( "" ).outerWidth() + 1,
				this.element.outerWidth()
			) );
		},
	
		_renderMenu: function( ul, items ) {
			var that = this;
			$.each( items, function( index, item ) {
				that._renderItemData( ul, item );
			});
		},
	
		_renderItemData: function( ul, item ) {
			return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
		},
	
		_renderItem: function( ul, item ) {
			return $( "<li>" ).text( item.label ).appendTo( ul );
		},
	
		_move: function( direction, event ) {
			if ( !this.menu.element.is( ":visible" ) ) {
				this.search( null, event );
				return;
			}
			if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
					this.menu.isLastItem() && /^next/.test( direction ) ) {
	
				if ( !this.isMultiLine ) {
					this._value( this.term );
				}
	
				this.menu.blur();
				return;
			}
			this.menu[ direction ]( event );
		},
	
		widget: function() {
			return this.menu.element;
		},
	
		_value: function() {
			return this.valueMethod.apply( this.element, arguments );
		},
	
		_keyEvent: function( keyEvent, event ) {
			if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
				this._move( keyEvent, event );
	
				// prevents moving cursor to beginning/end of the text field in some browsers
				event.preventDefault();
			}
		}
	});
	
	$.extend( $.ui.autocomplete, {
		escapeRegex: function( value ) {
			return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
		},
		filter: function( array, term ) {
			var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
			return $.grep( array, function( value ) {
				return matcher.test( value.label || value.value || value );
			});
		}
	});
	
	// live region extension, adding a `messages` option
	// NOTE: This is an experimental API. We are still investigating
	// a full solution for string manipulation and internationalization.
	$.widget( "ui.autocomplete", $.ui.autocomplete, {
		options: {
			messages: {
				noResults: "No search results.",
				results: function( amount ) {
					return amount + ( amount > 1 ? " results are" : " result is" ) +
						" available, use up and down arrow keys to navigate.";
				}
			}
		},
	
		__response: function( content ) {
			var message;
			this._superApply( arguments );
			if ( this.options.disabled || this.cancelSearch ) {
				return;
			}
			if ( content && content.length ) {
				message = this.options.messages.results( content.length );
			} else {
				message = this.options.messages.noResults;
			}
			this.liveRegion.children().hide();
			$( "<div>" ).text( message ).appendTo( this.liveRegion );
		}
	});
	
	var autocomplete = $.ui.autocomplete;
	
	
	/*!
	 * jQuery UI Button 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/button/
	 */
	
	
	var lastActive,
		baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
		typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
		formResetHandler = function() {
			var form = $( this );
			setTimeout(function() {
				form.find( ":ui-button" ).button( "refresh" );
			}, 1 );
		},
		radioGroup = function( radio ) {
			var name = radio.name,
				form = radio.form,
				radios = $( [] );
			if ( name ) {
				name = name.replace( /'/g, "\\'" );
				if ( form ) {
					radios = $( form ).find( "[name='" + name + "'][type=radio]" );
				} else {
					radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
						.filter(function() {
							return !this.form;
						});
				}
			}
			return radios;
		};
	
	$.widget( "ui.button", {
		version: "1.11.4",
		defaultElement: "<button>",
		options: {
			disabled: null,
			text: true,
			label: null,
			icons: {
				primary: null,
				secondary: null
			}
		},
		_create: function() {
			this.element.closest( "form" )
				.unbind( "reset" + this.eventNamespace )
				.bind( "reset" + this.eventNamespace, formResetHandler );
	
			if ( typeof this.options.disabled !== "boolean" ) {
				this.options.disabled = !!this.element.prop( "disabled" );
			} else {
				this.element.prop( "disabled", this.options.disabled );
			}
	
			this._determineButtonType();
			this.hasTitle = !!this.buttonElement.attr( "title" );
	
			var that = this,
				options = this.options,
				toggleButton = this.type === "checkbox" || this.type === "radio",
				activeClass = !toggleButton ? "ui-state-active" : "";
	
			if ( options.label === null ) {
				options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
			}
	
			this._hoverable( this.buttonElement );
	
			this.buttonElement
				.addClass( baseClasses )
				.attr( "role", "button" )
				.bind( "mouseenter" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return;
					}
					if ( this === lastActive ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				.bind( "mouseleave" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return;
					}
					$( this ).removeClass( activeClass );
				})
				.bind( "click" + this.eventNamespace, function( event ) {
					if ( options.disabled ) {
						event.preventDefault();
						event.stopImmediatePropagation();
					}
				});
	
			// Can't use _focusable() because the element that receives focus
			// and the element that gets the ui-state-focus class are different
			this._on({
				focus: function() {
					this.buttonElement.addClass( "ui-state-focus" );
				},
				blur: function() {
					this.buttonElement.removeClass( "ui-state-focus" );
				}
			});
	
			if ( toggleButton ) {
				this.element.bind( "change" + this.eventNamespace, function() {
					that.refresh();
				});
			}
	
			if ( this.type === "checkbox" ) {
				this.buttonElement.bind( "click" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
				});
			} else if ( this.type === "radio" ) {
				this.buttonElement.bind( "click" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					that.buttonElement.attr( "aria-pressed", "true" );
	
					var radio = that.element[ 0 ];
					radioGroup( radio )
						.not( radio )
						.map(function() {
							return $( this ).button( "widget" )[ 0 ];
						})
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				});
			} else {
				this.buttonElement
					.bind( "mousedown" + this.eventNamespace, function() {
						if ( options.disabled ) {
							return false;
						}
						$( this ).addClass( "ui-state-active" );
						lastActive = this;
						that.document.one( "mouseup", function() {
							lastActive = null;
						});
					})
					.bind( "mouseup" + this.eventNamespace, function() {
						if ( options.disabled ) {
							return false;
						}
						$( this ).removeClass( "ui-state-active" );
					})
					.bind( "keydown" + this.eventNamespace, function(event) {
						if ( options.disabled ) {
							return false;
						}
						if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
							$( this ).addClass( "ui-state-active" );
						}
					})
					// see #8559, we bind to blur here in case the button element loses
					// focus between keydown and keyup, it would be left in an "active" state
					.bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
						$( this ).removeClass( "ui-state-active" );
					});
	
				if ( this.buttonElement.is("a") ) {
					this.buttonElement.keyup(function(event) {
						if ( event.keyCode === $.ui.keyCode.SPACE ) {
							// TODO pass through original event correctly (just as 2nd argument doesn't work)
							$( this ).click();
						}
					});
				}
			}
	
			this._setOption( "disabled", options.disabled );
			this._resetButton();
		},
	
		_determineButtonType: function() {
			var ancestor, labelSelector, checked;
	
			if ( this.element.is("[type=checkbox]") ) {
				this.type = "checkbox";
			} else if ( this.element.is("[type=radio]") ) {
				this.type = "radio";
			} else if ( this.element.is("input") ) {
				this.type = "input";
			} else {
				this.type = "button";
			}
	
			if ( this.type === "checkbox" || this.type === "radio" ) {
				// we don't search against the document in case the element
				// is disconnected from the DOM
				ancestor = this.element.parents().last();
				labelSelector = "label[for='" + this.element.attr("id") + "']";
				this.buttonElement = ancestor.find( labelSelector );
				if ( !this.buttonElement.length ) {
					ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
					this.buttonElement = ancestor.filter( labelSelector );
					if ( !this.buttonElement.length ) {
						this.buttonElement = ancestor.find( labelSelector );
					}
				}
				this.element.addClass( "ui-helper-hidden-accessible" );
	
				checked = this.element.is( ":checked" );
				if ( checked ) {
					this.buttonElement.addClass( "ui-state-active" );
				}
				this.buttonElement.prop( "aria-pressed", checked );
			} else {
				this.buttonElement = this.element;
			}
		},
	
		widget: function() {
			return this.buttonElement;
		},
	
		_destroy: function() {
			this.element
				.removeClass( "ui-helper-hidden-accessible" );
			this.buttonElement
				.removeClass( baseClasses + " ui-state-active " + typeClasses )
				.removeAttr( "role" )
				.removeAttr( "aria-pressed" )
				.html( this.buttonElement.find(".ui-button-text").html() );
	
			if ( !this.hasTitle ) {
				this.buttonElement.removeAttr( "title" );
			}
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "disabled" ) {
				this.widget().toggleClass( "ui-state-disabled", !!value );
				this.element.prop( "disabled", !!value );
				if ( value ) {
					if ( this.type === "checkbox" || this.type === "radio" ) {
						this.buttonElement.removeClass( "ui-state-focus" );
					} else {
						this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
					}
				}
				return;
			}
			this._resetButton();
		},
	
		refresh: function() {
			//See #8237 & #8828
			var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );
	
			if ( isDisabled !== this.options.disabled ) {
				this._setOption( "disabled", isDisabled );
			}
			if ( this.type === "radio" ) {
				radioGroup( this.element[0] ).each(function() {
					if ( $( this ).is( ":checked" ) ) {
						$( this ).button( "widget" )
							.addClass( "ui-state-active" )
							.attr( "aria-pressed", "true" );
					} else {
						$( this ).button( "widget" )
							.removeClass( "ui-state-active" )
							.attr( "aria-pressed", "false" );
					}
				});
			} else if ( this.type === "checkbox" ) {
				if ( this.element.is( ":checked" ) ) {
					this.buttonElement
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					this.buttonElement
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			}
		},
	
		_resetButton: function() {
			if ( this.type === "input" ) {
				if ( this.options.label ) {
					this.element.val( this.options.label );
				}
				return;
			}
			var buttonElement = this.buttonElement.removeClass( typeClasses ),
				buttonText = $( "<span></span>", this.document[0] )
					.addClass( "ui-button-text" )
					.html( this.options.label )
					.appendTo( buttonElement.empty() )
					.text(),
				icons = this.options.icons,
				multipleIcons = icons.primary && icons.secondary,
				buttonClasses = [];
	
			if ( icons.primary || icons.secondary ) {
				if ( this.options.text ) {
					buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
				}
	
				if ( icons.primary ) {
					buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
				}
	
				if ( icons.secondary ) {
					buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
				}
	
				if ( !this.options.text ) {
					buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );
	
					if ( !this.hasTitle ) {
						buttonElement.attr( "title", $.trim( buttonText ) );
					}
				}
			} else {
				buttonClasses.push( "ui-button-text-only" );
			}
			buttonElement.addClass( buttonClasses.join( " " ) );
		}
	});
	
	$.widget( "ui.buttonset", {
		version: "1.11.4",
		options: {
			items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
		},
	
		_create: function() {
			this.element.addClass( "ui-buttonset" );
		},
	
		_init: function() {
			this.refresh();
		},
	
		_setOption: function( key, value ) {
			if ( key === "disabled" ) {
				this.buttons.button( "option", key, value );
			}
	
			this._super( key, value );
		},
	
		refresh: function() {
			var rtl = this.element.css( "direction" ) === "rtl",
				allButtons = this.element.find( this.options.items ),
				existingButtons = allButtons.filter( ":ui-button" );
	
			// Initialize new buttons
			allButtons.not( ":ui-button" ).button();
	
			// Refresh existing buttons
			existingButtons.button( "refresh" );
	
			this.buttons = allButtons
				.map(function() {
					return $( this ).button( "widget" )[ 0 ];
				})
					.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
					.filter( ":first" )
						.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
					.end()
					.filter( ":last" )
						.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
					.end()
				.end();
		},
	
		_destroy: function() {
			this.element.removeClass( "ui-buttonset" );
			this.buttons
				.map(function() {
					return $( this ).button( "widget" )[ 0 ];
				})
					.removeClass( "ui-corner-left ui-corner-right" )
				.end()
				.button( "destroy" );
		}
	});
	
	var button = $.ui.button;
	
	
	/*!
	 * jQuery UI Datepicker 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/datepicker/
	 */
	
	
	$.extend($.ui, { datepicker: { version: "1.11.4" } });
	
	var datepicker_instActive;
	
	function datepicker_getZindex( elem ) {
		var position, value;
		while ( elem.length && elem[ 0 ] !== document ) {
			// Ignore z-index if position is set to a value where z-index is ignored by the browser
			// This makes behavior of this function consistent across browsers
			// WebKit always returns auto if the element is positioned
			position = elem.css( "position" );
			if ( position === "absolute" || position === "relative" || position === "fixed" ) {
				// IE returns 0 when zIndex is not specified
				// other browsers return a string
				// we ignore the case of nested elements with an explicit value of 0
				// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
				value = parseInt( elem.css( "zIndex" ), 10 );
				if ( !isNaN( value ) && value !== 0 ) {
					return value;
				}
			}
			elem = elem.parent();
		}
	
		return 0;
	}
	/* Date picker manager.
	   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
	   Settings for (groups of) date pickers are maintained in an instance object,
	   allowing multiple different settings on the same page. */
	
	function Datepicker() {
		this._curInst = null; // The current instance in use
		this._keyEvent = false; // If the last event was a key event
		this._disabledInputs = []; // List of date picker inputs that have been disabled
		this._datepickerShowing = false; // True if the popup picker is showing , false if not
		this._inDialog = false; // True if showing within a "dialog", false if not
		this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
		this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
		this._appendClass = "ui-datepicker-append"; // The name of the append marker class
		this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
		this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
		this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
		this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
		this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
		this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
		this.regional = []; // Available regional settings, indexed by language code
		this.regional[""] = { // Default regional settings
			closeText: "Done", // Display text for close link
			prevText: "Prev", // Display text for previous month link
			nextText: "Next", // Display text for next month link
			currentText: "Today", // Display text for current month link
			monthNames: ["January","February","March","April","May","June",
				"July","August","September","October","November","December"], // Names of months for drop-down and formatting
			monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
			dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
			dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
			dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
			weekHeader: "Wk", // Column header for week of the year
			dateFormat: "mm/dd/yy", // See format options on parseDate
			firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
			isRTL: false, // True if right-to-left language, false if left-to-right
			showMonthAfterYear: false, // True if the year select precedes month, false for month then year
			yearSuffix: "" // Additional text to append to the year in the month headers
		};
		this._defaults = { // Global defaults for all the date picker instances
			showOn: "focus", // "focus" for popup on focus,
				// "button" for trigger button, or "both" for either
			showAnim: "fadeIn", // Name of jQuery animation for popup
			showOptions: {}, // Options for enhanced animations
			defaultDate: null, // Used when field is blank: actual date,
				// +/-number for offset from today, null for today
			appendText: "", // Display text following the input box, e.g. showing the format
			buttonText: "...", // Text for trigger button
			buttonImage: "", // URL for trigger button image
			buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
			hideIfNoPrevNext: false, // True to hide next/previous month links
				// if not applicable, false to just disable them
			navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
			gotoCurrent: false, // True if today link goes back to current selection instead
			changeMonth: false, // True if month can be selected directly, false if only prev/next
			changeYear: false, // True if year can be selected directly, false if only prev/next
			yearRange: "c-10:c+10", // Range of years to display in drop-down,
				// either relative to today's year (-nn:+nn), relative to currently displayed year
				// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
			showOtherMonths: false, // True to show dates in other months, false to leave blank
			selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
			showWeek: false, // True to show week of the year, false to not show it
			calculateWeek: this.iso8601Week, // How to calculate the week of the year,
				// takes a Date and returns the number of the week for it
			shortYearCutoff: "+10", // Short year values < this are in the current century,
				// > this are in the previous century,
				// string value starting with "+" for current year + value
			minDate: null, // The earliest selectable date, or null for no limit
			maxDate: null, // The latest selectable date, or null for no limit
			duration: "fast", // Duration of display/closure
			beforeShowDay: null, // Function that takes a date and returns an array with
				// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
				// [2] = cell title (optional), e.g. $.datepicker.noWeekends
			beforeShow: null, // Function that takes an input field and
				// returns a set of custom settings for the date picker
			onSelect: null, // Define a callback function when a date is selected
			onChangeMonthYear: null, // Define a callback function when the month or year is changed
			onClose: null, // Define a callback function when the datepicker is closed
			numberOfMonths: 1, // Number of months to show at a time
			showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
			stepMonths: 1, // Number of months to step back/forward
			stepBigMonths: 12, // Number of months to step back/forward for the big links
			altField: "", // Selector for an alternate field to store selected dates into
			altFormat: "", // The date format to use for the alternate field
			constrainInput: true, // The input is constrained by the current date format
			showButtonPanel: false, // True to show button panel, false to not show it
			autoSize: false, // True to size the input for the date format, false to leave as is
			disabled: false // The initial disabled state
		};
		$.extend(this._defaults, this.regional[""]);
		this.regional.en = $.extend( true, {}, this.regional[ "" ]);
		this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
		this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
	}
	
	$.extend(Datepicker.prototype, {
		/* Class name added to elements to indicate already configured with a date picker. */
		markerClassName: "hasDatepicker",
	
		//Keep track of the maximum number of rows displayed (see #7043)
		maxRows: 4,
	
		// TODO rename to "widget" when switching to widget factory
		_widgetDatepicker: function() {
			return this.dpDiv;
		},
	
		/* Override the default settings for all instances of the date picker.
		 * @param  settings  object - the new settings to use as defaults (anonymous object)
		 * @return the manager object
		 */
		setDefaults: function(settings) {
			datepicker_extendRemove(this._defaults, settings || {});
			return this;
		},
	
		/* Attach the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
		 */
		_attachDatepicker: function(target, settings) {
			var nodeName, inline, inst;
			nodeName = target.nodeName.toLowerCase();
			inline = (nodeName === "div" || nodeName === "span");
			if (!target.id) {
				this.uuid += 1;
				target.id = "dp" + this.uuid;
			}
			inst = this._newInst($(target), inline);
			inst.settings = $.extend({}, settings || {});
			if (nodeName === "input") {
				this._connectDatepicker(target, inst);
			} else if (inline) {
				this._inlineDatepicker(target, inst);
			}
		},
	
		/* Create a new instance object. */
		_newInst: function(target, inline) {
			var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
			return {id: id, input: target, // associated target
				selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
				drawMonth: 0, drawYear: 0, // month being drawn
				inline: inline, // is datepicker inline or not
				dpDiv: (!inline ? this.dpDiv : // presentation div
				datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
		},
	
		/* Attach the date picker to an input field. */
		_connectDatepicker: function(target, inst) {
			var input = $(target);
			inst.append = $([]);
			inst.trigger = $([]);
			if (input.hasClass(this.markerClassName)) {
				return;
			}
			this._attachments(input, inst);
			input.addClass(this.markerClassName).keydown(this._doKeyDown).
				keypress(this._doKeyPress).keyup(this._doKeyUp);
			this._autoSize(inst);
			$.data(target, "datepicker", inst);
			//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
			if( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
		},
	
		/* Make attachments based on settings. */
		_attachments: function(input, inst) {
			var showOn, buttonText, buttonImage,
				appendText = this._get(inst, "appendText"),
				isRTL = this._get(inst, "isRTL");
	
			if (inst.append) {
				inst.append.remove();
			}
			if (appendText) {
				inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
				input[isRTL ? "before" : "after"](inst.append);
			}
	
			input.unbind("focus", this._showDatepicker);
	
			if (inst.trigger) {
				inst.trigger.remove();
			}
	
			showOn = this._get(inst, "showOn");
			if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
				input.focus(this._showDatepicker);
			}
			if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
				buttonText = this._get(inst, "buttonText");
				buttonImage = this._get(inst, "buttonImage");
				inst.trigger = $(this._get(inst, "buttonImageOnly") ?
					$("<img/>").addClass(this._triggerClass).
						attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
					$("<button type='button'></button>").addClass(this._triggerClass).
						html(!buttonImage ? buttonText : $("<img/>").attr(
						{ src:buttonImage, alt:buttonText, title:buttonText })));
				input[isRTL ? "before" : "after"](inst.trigger);
				inst.trigger.click(function() {
					if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
						$.datepicker._hideDatepicker();
					} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
						$.datepicker._hideDatepicker();
						$.datepicker._showDatepicker(input[0]);
					} else {
						$.datepicker._showDatepicker(input[0]);
					}
					return false;
				});
			}
		},
	
		/* Apply the maximum length for the date format. */
		_autoSize: function(inst) {
			if (this._get(inst, "autoSize") && !inst.inline) {
				var findMax, max, maxI, i,
					date = new Date(2009, 12 - 1, 20), // Ensure double digits
					dateFormat = this._get(inst, "dateFormat");
	
				if (dateFormat.match(/[DM]/)) {
					findMax = function(names) {
						max = 0;
						maxI = 0;
						for (i = 0; i < names.length; i++) {
							if (names[i].length > max) {
								max = names[i].length;
								maxI = i;
							}
						}
						return maxI;
					};
					date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
						"monthNames" : "monthNamesShort"))));
					date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
						"dayNames" : "dayNamesShort"))) + 20 - date.getDay());
				}
				inst.input.attr("size", this._formatDate(inst, date).length);
			}
		},
	
		/* Attach an inline date picker to a div. */
		_inlineDatepicker: function(target, inst) {
			var divSpan = $(target);
			if (divSpan.hasClass(this.markerClassName)) {
				return;
			}
			divSpan.addClass(this.markerClassName).append(inst.dpDiv);
			$.data(target, "datepicker", inst);
			this._setDate(inst, this._getDefaultDate(inst), true);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
			//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
			if( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
			// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
			// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
			inst.dpDiv.css( "display", "block" );
		},
	
		/* Pop-up the date picker in a "dialog" box.
		 * @param  input element - ignored
		 * @param  date	string or Date - the initial date to display
		 * @param  onSelect  function - the function to call when a date is selected
		 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
		 * @param  pos int[2] - coordinates for the dialog's position within the screen or
		 *					event - with x/y coordinates or
		 *					leave empty for default (screen centre)
		 * @return the manager object
		 */
		_dialogDatepicker: function(input, date, onSelect, settings, pos) {
			var id, browserWidth, browserHeight, scrollX, scrollY,
				inst = this._dialogInst; // internal instance
	
			if (!inst) {
				this.uuid += 1;
				id = "dp" + this.uuid;
				this._dialogInput = $("<input type='text' id='" + id +
					"' style='position: absolute; top: -100px; width: 0px;'/>");
				this._dialogInput.keydown(this._doKeyDown);
				$("body").append(this._dialogInput);
				inst = this._dialogInst = this._newInst(this._dialogInput, false);
				inst.settings = {};
				$.data(this._dialogInput[0], "datepicker", inst);
			}
			datepicker_extendRemove(inst.settings, settings || {});
			date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
			this._dialogInput.val(date);
	
			this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
			if (!this._pos) {
				browserWidth = document.documentElement.clientWidth;
				browserHeight = document.documentElement.clientHeight;
				scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
				scrollY = document.documentElement.scrollTop || document.body.scrollTop;
				this._pos = // should use actual width/height below
					[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
			}
	
			// move input on screen for focus, but hidden behind dialog
			this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
			inst.settings.onSelect = onSelect;
			this._inDialog = true;
			this.dpDiv.addClass(this._dialogClass);
			this._showDatepicker(this._dialogInput[0]);
			if ($.blockUI) {
				$.blockUI(this.dpDiv);
			}
			$.data(this._dialogInput[0], "datepicker", inst);
			return this;
		},
	
		/* Detach a datepicker from its control.
		 * @param  target	element - the target input field or division or span
		 */
		_destroyDatepicker: function(target) {
			var nodeName,
				$target = $(target),
				inst = $.data(target, "datepicker");
	
			if (!$target.hasClass(this.markerClassName)) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			$.removeData(target, "datepicker");
			if (nodeName === "input") {
				inst.append.remove();
				inst.trigger.remove();
				$target.removeClass(this.markerClassName).
					unbind("focus", this._showDatepicker).
					unbind("keydown", this._doKeyDown).
					unbind("keypress", this._doKeyPress).
					unbind("keyup", this._doKeyUp);
			} else if (nodeName === "div" || nodeName === "span") {
				$target.removeClass(this.markerClassName).empty();
			}
	
			if ( datepicker_instActive === inst ) {
				datepicker_instActive = null;
			}
		},
	
		/* Enable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_enableDatepicker: function(target) {
			var nodeName, inline,
				$target = $(target),
				inst = $.data(target, "datepicker");
	
			if (!$target.hasClass(this.markerClassName)) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if (nodeName === "input") {
				target.disabled = false;
				inst.trigger.filter("button").
					each(function() { this.disabled = false; }).end().
					filter("img").css({opacity: "1.0", cursor: ""});
			} else if (nodeName === "div" || nodeName === "span") {
				inline = $target.children("." + this._inlineClass);
				inline.children().removeClass("ui-state-disabled");
				inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
					prop("disabled", false);
			}
			this._disabledInputs = $.map(this._disabledInputs,
				function(value) { return (value === target ? null : value); }); // delete entry
		},
	
		/* Disable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_disableDatepicker: function(target) {
			var nodeName, inline,
				$target = $(target),
				inst = $.data(target, "datepicker");
	
			if (!$target.hasClass(this.markerClassName)) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if (nodeName === "input") {
				target.disabled = true;
				inst.trigger.filter("button").
					each(function() { this.disabled = true; }).end().
					filter("img").css({opacity: "0.5", cursor: "default"});
			} else if (nodeName === "div" || nodeName === "span") {
				inline = $target.children("." + this._inlineClass);
				inline.children().addClass("ui-state-disabled");
				inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
					prop("disabled", true);
			}
			this._disabledInputs = $.map(this._disabledInputs,
				function(value) { return (value === target ? null : value); }); // delete entry
			this._disabledInputs[this._disabledInputs.length] = target;
		},
	
		/* Is the first field in a jQuery collection disabled as a datepicker?
		 * @param  target	element - the target input field or division or span
		 * @return boolean - true if disabled, false if enabled
		 */
		_isDisabledDatepicker: function(target) {
			if (!target) {
				return false;
			}
			for (var i = 0; i < this._disabledInputs.length; i++) {
				if (this._disabledInputs[i] === target) {
					return true;
				}
			}
			return false;
		},
	
		/* Retrieve the instance data for the target control.
		 * @param  target  element - the target input field or division or span
		 * @return  object - the associated instance data
		 * @throws  error if a jQuery problem getting data
		 */
		_getInst: function(target) {
			try {
				return $.data(target, "datepicker");
			}
			catch (err) {
				throw "Missing instance data for this datepicker";
			}
		},
	
		/* Update or retrieve the settings for a date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 * @param  name	object - the new settings to update or
		 *				string - the name of the setting to change or retrieve,
		 *				when retrieving also "all" for all instance settings or
		 *				"defaults" for all global defaults
		 * @param  value   any - the new value for the setting
		 *				(omit if above is an object or to retrieve a value)
		 */
		_optionDatepicker: function(target, name, value) {
			var settings, date, minDate, maxDate,
				inst = this._getInst(target);
	
			if (arguments.length === 2 && typeof name === "string") {
				return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
					(inst ? (name === "all" ? $.extend({}, inst.settings) :
					this._get(inst, name)) : null));
			}
	
			settings = name || {};
			if (typeof name === "string") {
				settings = {};
				settings[name] = value;
			}
	
			if (inst) {
				if (this._curInst === inst) {
					this._hideDatepicker();
				}
	
				date = this._getDateDatepicker(target, true);
				minDate = this._getMinMaxDate(inst, "min");
				maxDate = this._getMinMaxDate(inst, "max");
				datepicker_extendRemove(inst.settings, settings);
				// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
				if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
					inst.settings.minDate = this._formatDate(inst, minDate);
				}
				if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
					inst.settings.maxDate = this._formatDate(inst, maxDate);
				}
				if ( "disabled" in settings ) {
					if ( settings.disabled ) {
						this._disableDatepicker(target);
					} else {
						this._enableDatepicker(target);
					}
				}
				this._attachments($(target), inst);
				this._autoSize(inst);
				this._setDate(inst, date);
				this._updateAlternate(inst);
				this._updateDatepicker(inst);
			}
		},
	
		// change method deprecated
		_changeDatepicker: function(target, name, value) {
			this._optionDatepicker(target, name, value);
		},
	
		/* Redraw the date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 */
		_refreshDatepicker: function(target) {
			var inst = this._getInst(target);
			if (inst) {
				this._updateDatepicker(inst);
			}
		},
	
		/* Set the dates for a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  date	Date - the new date
		 */
		_setDateDatepicker: function(target, date) {
			var inst = this._getInst(target);
			if (inst) {
				this._setDate(inst, date);
				this._updateDatepicker(inst);
				this._updateAlternate(inst);
			}
		},
	
		/* Get the date(s) for the first entry in a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  noDefault boolean - true if no default date is to be used
		 * @return Date - the current date
		 */
		_getDateDatepicker: function(target, noDefault) {
			var inst = this._getInst(target);
			if (inst && !inst.inline) {
				this._setDateFromField(inst, noDefault);
			}
			return (inst ? this._getDate(inst) : null);
		},
	
		/* Handle keystrokes. */
		_doKeyDown: function(event) {
			var onSelect, dateStr, sel,
				inst = $.datepicker._getInst(event.target),
				handled = true,
				isRTL = inst.dpDiv.is(".ui-datepicker-rtl");
	
			inst._keyEvent = true;
			if ($.datepicker._datepickerShowing) {
				switch (event.keyCode) {
					case 9: $.datepicker._hideDatepicker();
							handled = false;
							break; // hide on tab out
					case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
										$.datepicker._currentClass + ")", inst.dpDiv);
							if (sel[0]) {
								$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
							}
	
							onSelect = $.datepicker._get(inst, "onSelect");
							if (onSelect) {
								dateStr = $.datepicker._formatDate(inst);
	
								// trigger custom callback
								onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
							} else {
								$.datepicker._hideDatepicker();
							}
	
							return false; // don't submit the form
					case 27: $.datepicker._hideDatepicker();
							break; // hide on escape
					case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
								-$.datepicker._get(inst, "stepBigMonths") :
								-$.datepicker._get(inst, "stepMonths")), "M");
							break; // previous month/year on page up/+ ctrl
					case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
								+$.datepicker._get(inst, "stepBigMonths") :
								+$.datepicker._get(inst, "stepMonths")), "M");
							break; // next month/year on page down/+ ctrl
					case 35: if (event.ctrlKey || event.metaKey) {
								$.datepicker._clearDate(event.target);
							}
							handled = event.ctrlKey || event.metaKey;
							break; // clear on ctrl or command +end
					case 36: if (event.ctrlKey || event.metaKey) {
								$.datepicker._gotoToday(event.target);
							}
							handled = event.ctrlKey || event.metaKey;
							break; // current on ctrl or command +home
					case 37: if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
							}
							handled = event.ctrlKey || event.metaKey;
							// -1 day on ctrl or command +left
							if (event.originalEvent.altKey) {
								$.datepicker._adjustDate(event.target, (event.ctrlKey ?
									-$.datepicker._get(inst, "stepBigMonths") :
									-$.datepicker._get(inst, "stepMonths")), "M");
							}
							// next month/year on alt +left on Mac
							break;
					case 38: if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, -7, "D");
							}
							handled = event.ctrlKey || event.metaKey;
							break; // -1 week on ctrl or command +up
					case 39: if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
							}
							handled = event.ctrlKey || event.metaKey;
							// +1 day on ctrl or command +right
							if (event.originalEvent.altKey) {
								$.datepicker._adjustDate(event.target, (event.ctrlKey ?
									+$.datepicker._get(inst, "stepBigMonths") :
									+$.datepicker._get(inst, "stepMonths")), "M");
							}
							// next month/year on alt +right
							break;
					case 40: if (event.ctrlKey || event.metaKey) {
								$.datepicker._adjustDate(event.target, +7, "D");
							}
							handled = event.ctrlKey || event.metaKey;
							break; // +1 week on ctrl or command +down
					default: handled = false;
				}
			} else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
				$.datepicker._showDatepicker(this);
			} else {
				handled = false;
			}
	
			if (handled) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
	
		/* Filter entered characters - based on date format. */
		_doKeyPress: function(event) {
			var chars, chr,
				inst = $.datepicker._getInst(event.target);
	
			if ($.datepicker._get(inst, "constrainInput")) {
				chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
				chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
				return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
			}
		},
	
		/* Synchronise manual entry and field/alternate field. */
		_doKeyUp: function(event) {
			var date,
				inst = $.datepicker._getInst(event.target);
	
			if (inst.input.val() !== inst.lastVal) {
				try {
					date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
						(inst.input ? inst.input.val() : null),
						$.datepicker._getFormatConfig(inst));
	
					if (date) { // only if valid
						$.datepicker._setDateFromField(inst);
						$.datepicker._updateAlternate(inst);
						$.datepicker._updateDatepicker(inst);
					}
				}
				catch (err) {
				}
			}
			return true;
		},
	
		/* Pop-up the date picker for a given input field.
		 * If false returned from beforeShow event handler do not show.
		 * @param  input  element - the input field attached to the date picker or
		 *					event - if triggered by focus
		 */
		_showDatepicker: function(input) {
			input = input.target || input;
			if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
				input = $("input", input.parentNode)[0];
			}
	
			if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
				return;
			}
	
			var inst, beforeShow, beforeShowSettings, isFixed,
				offset, showAnim, duration;
	
			inst = $.datepicker._getInst(input);
			if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
				$.datepicker._curInst.dpDiv.stop(true, true);
				if ( inst && $.datepicker._datepickerShowing ) {
					$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
				}
			}
	
			beforeShow = $.datepicker._get(inst, "beforeShow");
			beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
			if(beforeShowSettings === false){
				return;
			}
			datepicker_extendRemove(inst.settings, beforeShowSettings);
	
			inst.lastVal = null;
			$.datepicker._lastInput = input;
			$.datepicker._setDateFromField(inst);
	
			if ($.datepicker._inDialog) { // hide cursor
				input.value = "";
			}
			if (!$.datepicker._pos) { // position below input
				$.datepicker._pos = $.datepicker._findPos(input);
				$.datepicker._pos[1] += input.offsetHeight; // add the height
			}
	
			isFixed = false;
			$(input).parents().each(function() {
				isFixed |= $(this).css("position") === "fixed";
				return !isFixed;
			});
	
			offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
			$.datepicker._pos = null;
			//to avoid flashes on Firefox
			inst.dpDiv.empty();
			// determine sizing offscreen
			inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
			$.datepicker._updateDatepicker(inst);
			// fix width for dynamic number of date pickers
			// and adjust position before showing
			offset = $.datepicker._checkOffset(inst, offset, isFixed);
			inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
				"static" : (isFixed ? "fixed" : "absolute")), display: "none",
				left: offset.left + "px", top: offset.top + "px"});
	
			if (!inst.inline) {
				showAnim = $.datepicker._get(inst, "showAnim");
				duration = $.datepicker._get(inst, "duration");
				inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
				$.datepicker._datepickerShowing = true;
	
				if ( $.effects && $.effects.effect[ showAnim ] ) {
					inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
				} else {
					inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
				}
	
				if ( $.datepicker._shouldFocusInput( inst ) ) {
					inst.input.focus();
				}
	
				$.datepicker._curInst = inst;
			}
		},
	
		/* Generate the date picker content. */
		_updateDatepicker: function(inst) {
			this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
			datepicker_instActive = inst; // for delegate hover events
			inst.dpDiv.empty().append(this._generateHTML(inst));
			this._attachHandlers(inst);
	
			var origyearshtml,
				numMonths = this._getNumberOfMonths(inst),
				cols = numMonths[1],
				width = 17,
				activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );
	
			if ( activeCell.length > 0 ) {
				datepicker_handleMouseover.apply( activeCell.get( 0 ) );
			}
	
			inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
			if (cols > 1) {
				inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
			}
			inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
				"Class"]("ui-datepicker-multi");
			inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
				"Class"]("ui-datepicker-rtl");
	
			if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.focus();
			}
	
			// deffered render of the years select (to avoid flashes on Firefox)
			if( inst.yearshtml ){
				origyearshtml = inst.yearshtml;
				setTimeout(function(){
					//assure that inst.yearshtml didn't change.
					if( origyearshtml === inst.yearshtml && inst.yearshtml ){
						inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
					}
					origyearshtml = inst.yearshtml = null;
				}, 0);
			}
		},
	
		// #6694 - don't focus the input if it's already focused
		// this breaks the change event in IE
		// Support: IE and jQuery <1.9
		_shouldFocusInput: function( inst ) {
			return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
		},
	
		/* Check positioning to remain on screen. */
		_checkOffset: function(inst, offset, isFixed) {
			var dpWidth = inst.dpDiv.outerWidth(),
				dpHeight = inst.dpDiv.outerHeight(),
				inputWidth = inst.input ? inst.input.outerWidth() : 0,
				inputHeight = inst.input ? inst.input.outerHeight() : 0,
				viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
				viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());
	
			offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
			offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
			offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;
	
			// now check if datepicker is showing outside window viewport - move to a better place if so.
			offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
				Math.abs(offset.left + dpWidth - viewWidth) : 0);
			offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
				Math.abs(dpHeight + inputHeight) : 0);
	
			return offset;
		},
	
		/* Find an object's position on the screen. */
		_findPos: function(obj) {
			var position,
				inst = this._getInst(obj),
				isRTL = this._get(inst, "isRTL");
	
			while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
				obj = obj[isRTL ? "previousSibling" : "nextSibling"];
			}
	
			position = $(obj).offset();
			return [position.left, position.top];
		},
	
		/* Hide the date picker from view.
		 * @param  input  element - the input field attached to the date picker
		 */
		_hideDatepicker: function(input) {
			var showAnim, duration, postProcess, onClose,
				inst = this._curInst;
	
			if (!inst || (input && inst !== $.data(input, "datepicker"))) {
				return;
			}
	
			if (this._datepickerShowing) {
				showAnim = this._get(inst, "showAnim");
				duration = this._get(inst, "duration");
				postProcess = function() {
					$.datepicker._tidyDialog(inst);
				};
	
				// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
				if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
					inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
				} else {
					inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
						(showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
				}
	
				if (!showAnim) {
					postProcess();
				}
				this._datepickerShowing = false;
	
				onClose = this._get(inst, "onClose");
				if (onClose) {
					onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
				}
	
				this._lastInput = null;
				if (this._inDialog) {
					this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
					if ($.blockUI) {
						$.unblockUI();
						$("body").append(this.dpDiv);
					}
				}
				this._inDialog = false;
			}
		},
	
		/* Tidy up after a dialog display. */
		_tidyDialog: function(inst) {
			inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
		},
	
		/* Close date picker if clicked elsewhere. */
		_checkExternalClick: function(event) {
			if (!$.datepicker._curInst) {
				return;
			}
	
			var $target = $(event.target),
				inst = $.datepicker._getInst($target[0]);
	
			if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
					$target.parents("#" + $.datepicker._mainDivId).length === 0 &&
					!$target.hasClass($.datepicker.markerClassName) &&
					!$target.closest("." + $.datepicker._triggerClass).length &&
					$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
				( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
					$.datepicker._hideDatepicker();
			}
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustDate: function(id, offset, period) {
			var target = $(id),
				inst = this._getInst(target[0]);
	
			if (this._isDisabledDatepicker(target[0])) {
				return;
			}
			this._adjustInstDate(inst, offset +
				(period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
				period);
			this._updateDatepicker(inst);
		},
	
		/* Action for current link. */
		_gotoToday: function(id) {
			var date,
				target = $(id),
				inst = this._getInst(target[0]);
	
			if (this._get(inst, "gotoCurrent") && inst.currentDay) {
				inst.selectedDay = inst.currentDay;
				inst.drawMonth = inst.selectedMonth = inst.currentMonth;
				inst.drawYear = inst.selectedYear = inst.currentYear;
			} else {
				date = new Date();
				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
			}
			this._notifyChange(inst);
			this._adjustDate(target);
		},
	
		/* Action for selecting a new month/year. */
		_selectMonthYear: function(id, select, period) {
			var target = $(id),
				inst = this._getInst(target[0]);
	
			inst["selected" + (period === "M" ? "Month" : "Year")] =
			inst["draw" + (period === "M" ? "Month" : "Year")] =
				parseInt(select.options[select.selectedIndex].value,10);
	
			this._notifyChange(inst);
			this._adjustDate(target);
		},
	
		/* Action for selecting a day. */
		_selectDay: function(id, month, year, td) {
			var inst,
				target = $(id);
	
			if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
				return;
			}
	
			inst = this._getInst(target[0]);
			inst.selectedDay = inst.currentDay = $("a", td).html();
			inst.selectedMonth = inst.currentMonth = month;
			inst.selectedYear = inst.currentYear = year;
			this._selectDate(id, this._formatDate(inst,
				inst.currentDay, inst.currentMonth, inst.currentYear));
		},
	
		/* Erase the input field and hide the date picker. */
		_clearDate: function(id) {
			var target = $(id);
			this._selectDate(target, "");
		},
	
		/* Update the input field with the selected date. */
		_selectDate: function(id, dateStr) {
			var onSelect,
				target = $(id),
				inst = this._getInst(target[0]);
	
			dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
			if (inst.input) {
				inst.input.val(dateStr);
			}
			this._updateAlternate(inst);
	
			onSelect = this._get(inst, "onSelect");
			if (onSelect) {
				onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
			} else if (inst.input) {
				inst.input.trigger("change"); // fire the change event
			}
	
			if (inst.inline){
				this._updateDatepicker(inst);
			} else {
				this._hideDatepicker();
				this._lastInput = inst.input[0];
				if (typeof(inst.input[0]) !== "object") {
					inst.input.focus(); // restore focus
				}
				this._lastInput = null;
			}
		},
	
		/* Update any alternate field to synchronise with the main field. */
		_updateAlternate: function(inst) {
			var altFormat, date, dateStr,
				altField = this._get(inst, "altField");
	
			if (altField) { // update alternate field too
				altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
				date = this._getDate(inst);
				dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
				$(altField).each(function() { $(this).val(dateStr); });
			}
		},
	
		/* Set as beforeShowDay function to prevent selection of weekends.
		 * @param  date  Date - the date to customise
		 * @return [boolean, string] - is this date selectable?, what is its CSS class?
		 */
		noWeekends: function(date) {
			var day = date.getDay();
			return [(day > 0 && day < 6), ""];
		},
	
		/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
		 * @param  date  Date - the date to get the week for
		 * @return  number - the number of the week within the year that contains this date
		 */
		iso8601Week: function(date) {
			var time,
				checkDate = new Date(date.getTime());
	
			// Find Thursday of this week starting on Monday
			checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
	
			time = checkDate.getTime();
			checkDate.setMonth(0); // Compare with Jan 1
			checkDate.setDate(1);
			return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
		},
	
		/* Parse a string value into a date object.
		 * See formatDate below for the possible formats.
		 *
		 * @param  format string - the expected format of the date
		 * @param  value string - the date in the above format
		 * @param  settings Object - attributes include:
		 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  Date - the extracted date value or null if value is blank
		 */
		parseDate: function (format, value, settings) {
			if (format == null || value == null) {
				throw "Invalid arguments";
			}
	
			value = (typeof value === "object" ? value.toString() : value + "");
			if (value === "") {
				return null;
			}
	
			var iFormat, dim, extra,
				iValue = 0,
				shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
				shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
					new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
				dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
				dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
				monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
				monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
				year = -1,
				month = -1,
				day = -1,
				doy = -1,
				literal = false,
				date,
				// Check whether a format character is doubled
				lookAhead = function(match) {
					var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
					if (matches) {
						iFormat++;
					}
					return matches;
				},
				// Extract a number from the string value
				getNumber = function(match) {
					var isDoubled = lookAhead(match),
						size = (match === "@" ? 14 : (match === "!" ? 20 :
						(match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
						minSize = (match === "y" ? size : 1),
						digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
						num = value.substring(iValue).match(digits);
					if (!num) {
						throw "Missing number at position " + iValue;
					}
					iValue += num[0].length;
					return parseInt(num[0], 10);
				},
				// Extract a name from the string value and convert to an index
				getName = function(match, shortNames, longNames) {
					var index = -1,
						names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
							return [ [k, v] ];
						}).sort(function (a, b) {
							return -(a[1].length - b[1].length);
						});
	
					$.each(names, function (i, pair) {
						var name = pair[1];
						if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
							index = pair[0];
							iValue += name.length;
							return false;
						}
					});
					if (index !== -1) {
						return index + 1;
					} else {
						throw "Unknown name at position " + iValue;
					}
				},
				// Confirm that a literal character matches the string value
				checkLiteral = function() {
					if (value.charAt(iValue) !== format.charAt(iFormat)) {
						throw "Unexpected literal at position " + iValue;
					}
					iValue++;
				};
	
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						checkLiteral();
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d":
							day = getNumber("d");
							break;
						case "D":
							getName("D", dayNamesShort, dayNames);
							break;
						case "o":
							doy = getNumber("o");
							break;
						case "m":
							month = getNumber("m");
							break;
						case "M":
							month = getName("M", monthNamesShort, monthNames);
							break;
						case "y":
							year = getNumber("y");
							break;
						case "@":
							date = new Date(getNumber("@"));
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "!":
							date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "'":
							if (lookAhead("'")){
								checkLiteral();
							} else {
								literal = true;
							}
							break;
						default:
							checkLiteral();
					}
				}
			}
	
			if (iValue < value.length){
				extra = value.substr(iValue);
				if (!/^\s+/.test(extra)) {
					throw "Extra/unparsed characters found in date: " + extra;
				}
			}
	
			if (year === -1) {
				year = new Date().getFullYear();
			} else if (year < 100) {
				year += new Date().getFullYear() - new Date().getFullYear() % 100 +
					(year <= shortYearCutoff ? 0 : -100);
			}
	
			if (doy > -1) {
				month = 1;
				day = doy;
				do {
					dim = this._getDaysInMonth(year, month - 1);
					if (day <= dim) {
						break;
					}
					month++;
					day -= dim;
				} while (true);
			}
	
			date = this._daylightSavingAdjust(new Date(year, month - 1, day));
			if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
				throw "Invalid date"; // E.g. 31/02/00
			}
			return date;
		},
	
		/* Standard date formats. */
		ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
		COOKIE: "D, dd M yy",
		ISO_8601: "yy-mm-dd",
		RFC_822: "D, d M y",
		RFC_850: "DD, dd-M-y",
		RFC_1036: "D, d M y",
		RFC_1123: "D, d M yy",
		RFC_2822: "D, d M yy",
		RSS: "D, d M y", // RFC 822
		TICKS: "!",
		TIMESTAMP: "@",
		W3C: "yy-mm-dd", // ISO 8601
	
		_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
			Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),
	
		/* Format a date object into a string value.
		 * The format can be combinations of the following:
		 * d  - day of month (no leading zero)
		 * dd - day of month (two digit)
		 * o  - day of year (no leading zeros)
		 * oo - day of year (three digit)
		 * D  - day name short
		 * DD - day name long
		 * m  - month of year (no leading zero)
		 * mm - month of year (two digit)
		 * M  - month name short
		 * MM - month name long
		 * y  - year (two digit)
		 * yy - year (four digit)
		 * @ - Unix timestamp (ms since 01/01/1970)
		 * ! - Windows ticks (100ns since 01/01/0001)
		 * "..." - literal text
		 * '' - single quote
		 *
		 * @param  format string - the desired format of the date
		 * @param  date Date - the date value to format
		 * @param  settings Object - attributes include:
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  string - the date in the above format
		 */
		formatDate: function (format, date, settings) {
			if (!date) {
				return "";
			}
	
			var iFormat,
				dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
				dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
				monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
				monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
				// Check whether a format character is doubled
				lookAhead = function(match) {
					var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
					if (matches) {
						iFormat++;
					}
					return matches;
				},
				// Format a number, with leading zero if necessary
				formatNumber = function(match, value, len) {
					var num = "" + value;
					if (lookAhead(match)) {
						while (num.length < len) {
							num = "0" + num;
						}
					}
					return num;
				},
				// Format a name, short or long as requested
				formatName = function(match, value, shortNames, longNames) {
					return (lookAhead(match) ? longNames[value] : shortNames[value]);
				},
				output = "",
				literal = false;
	
			if (date) {
				for (iFormat = 0; iFormat < format.length; iFormat++) {
					if (literal) {
						if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
							literal = false;
						} else {
							output += format.charAt(iFormat);
						}
					} else {
						switch (format.charAt(iFormat)) {
							case "d":
								output += formatNumber("d", date.getDate(), 2);
								break;
							case "D":
								output += formatName("D", date.getDay(), dayNamesShort, dayNames);
								break;
							case "o":
								output += formatNumber("o",
									Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
								break;
							case "m":
								output += formatNumber("m", date.getMonth() + 1, 2);
								break;
							case "M":
								output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
								break;
							case "y":
								output += (lookAhead("y") ? date.getFullYear() :
									(date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
								break;
							case "@":
								output += date.getTime();
								break;
							case "!":
								output += date.getTime() * 10000 + this._ticksTo1970;
								break;
							case "'":
								if (lookAhead("'")) {
									output += "'";
								} else {
									literal = true;
								}
								break;
							default:
								output += format.charAt(iFormat);
						}
					}
				}
			}
			return output;
		},
	
		/* Extract all possible characters from the date format. */
		_possibleChars: function (format) {
			var iFormat,
				chars = "",
				literal = false,
				// Check whether a format character is doubled
				lookAhead = function(match) {
					var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
					if (matches) {
						iFormat++;
					}
					return matches;
				};
	
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						chars += format.charAt(iFormat);
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d": case "m": case "y": case "@":
							chars += "0123456789";
							break;
						case "D": case "M":
							return null; // Accept anything
						case "'":
							if (lookAhead("'")) {
								chars += "'";
							} else {
								literal = true;
							}
							break;
						default:
							chars += format.charAt(iFormat);
					}
				}
			}
			return chars;
		},
	
		/* Get a setting value, defaulting if necessary. */
		_get: function(inst, name) {
			return inst.settings[name] !== undefined ?
				inst.settings[name] : this._defaults[name];
		},
	
		/* Parse existing date and initialise date picker. */
		_setDateFromField: function(inst, noDefault) {
			if (inst.input.val() === inst.lastVal) {
				return;
			}
	
			var dateFormat = this._get(inst, "dateFormat"),
				dates = inst.lastVal = inst.input ? inst.input.val() : null,
				defaultDate = this._getDefaultDate(inst),
				date = defaultDate,
				settings = this._getFormatConfig(inst);
	
			try {
				date = this.parseDate(dateFormat, dates, settings) || defaultDate;
			} catch (event) {
				dates = (noDefault ? "" : dates);
			}
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			inst.currentDay = (dates ? date.getDate() : 0);
			inst.currentMonth = (dates ? date.getMonth() : 0);
			inst.currentYear = (dates ? date.getFullYear() : 0);
			this._adjustInstDate(inst);
		},
	
		/* Retrieve the default date shown on opening. */
		_getDefaultDate: function(inst) {
			return this._restrictMinMax(inst,
				this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
		},
	
		/* A date may be specified as an exact value or a relative one. */
		_determineDate: function(inst, date, defaultDate) {
			var offsetNumeric = function(offset) {
					var date = new Date();
					date.setDate(date.getDate() + offset);
					return date;
				},
				offsetString = function(offset) {
					try {
						return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
							offset, $.datepicker._getFormatConfig(inst));
					}
					catch (e) {
						// Ignore
					}
	
					var date = (offset.toLowerCase().match(/^c/) ?
						$.datepicker._getDate(inst) : null) || new Date(),
						year = date.getFullYear(),
						month = date.getMonth(),
						day = date.getDate(),
						pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
						matches = pattern.exec(offset);
	
					while (matches) {
						switch (matches[2] || "d") {
							case "d" : case "D" :
								day += parseInt(matches[1],10); break;
							case "w" : case "W" :
								day += parseInt(matches[1],10) * 7; break;
							case "m" : case "M" :
								month += parseInt(matches[1],10);
								day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
								break;
							case "y": case "Y" :
								year += parseInt(matches[1],10);
								day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
								break;
						}
						matches = pattern.exec(offset);
					}
					return new Date(year, month, day);
				},
				newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
					(typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));
	
			newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
			if (newDate) {
				newDate.setHours(0);
				newDate.setMinutes(0);
				newDate.setSeconds(0);
				newDate.setMilliseconds(0);
			}
			return this._daylightSavingAdjust(newDate);
		},
	
		/* Handle switch to/from daylight saving.
		 * Hours may be non-zero on daylight saving cut-over:
		 * > 12 when midnight changeover, but then cannot generate
		 * midnight datetime, so jump to 1AM, otherwise reset.
		 * @param  date  (Date) the date to check
		 * @return  (Date) the corrected date
		 */
		_daylightSavingAdjust: function(date) {
			if (!date) {
				return null;
			}
			date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
			return date;
		},
	
		/* Set the date(s) directly. */
		_setDate: function(inst, date, noChange) {
			var clear = !date,
				origMonth = inst.selectedMonth,
				origYear = inst.selectedYear,
				newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));
	
			inst.selectedDay = inst.currentDay = newDate.getDate();
			inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
			inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
			if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
				this._notifyChange(inst);
			}
			this._adjustInstDate(inst);
			if (inst.input) {
				inst.input.val(clear ? "" : this._formatDate(inst));
			}
		},
	
		/* Retrieve the date(s) directly. */
		_getDate: function(inst) {
			var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
				this._daylightSavingAdjust(new Date(
				inst.currentYear, inst.currentMonth, inst.currentDay)));
				return startDate;
		},
	
		/* Attach the onxxx handlers.  These are declared statically so
		 * they work with static code transformers like Caja.
		 */
		_attachHandlers: function(inst) {
			var stepMonths = this._get(inst, "stepMonths"),
				id = "#" + inst.id.replace( /\\\\/g, "\\" );
			inst.dpDiv.find("[data-handler]").map(function () {
				var handler = {
					prev: function () {
						$.datepicker._adjustDate(id, -stepMonths, "M");
					},
					next: function () {
						$.datepicker._adjustDate(id, +stepMonths, "M");
					},
					hide: function () {
						$.datepicker._hideDatepicker();
					},
					today: function () {
						$.datepicker._gotoToday(id);
					},
					selectDay: function () {
						$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
						return false;
					},
					selectMonth: function () {
						$.datepicker._selectMonthYear(id, this, "M");
						return false;
					},
					selectYear: function () {
						$.datepicker._selectMonthYear(id, this, "Y");
						return false;
					}
				};
				$(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
			});
		},
	
		/* Generate the HTML for the current state of the date picker. */
		_generateHTML: function(inst) {
			var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
				controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
				monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
				selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
				cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
				printDate, dRow, tbody, daySettings, otherMonth, unselectable,
				tempDate = new Date(),
				today = this._daylightSavingAdjust(
					new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
				isRTL = this._get(inst, "isRTL"),
				showButtonPanel = this._get(inst, "showButtonPanel"),
				hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
				navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
				numMonths = this._getNumberOfMonths(inst),
				showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
				stepMonths = this._get(inst, "stepMonths"),
				isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
				currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
					new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
				minDate = this._getMinMaxDate(inst, "min"),
				maxDate = this._getMinMaxDate(inst, "max"),
				drawMonth = inst.drawMonth - showCurrentAtPos,
				drawYear = inst.drawYear;
	
			if (drawMonth < 0) {
				drawMonth += 12;
				drawYear--;
			}
			if (maxDate) {
				maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
					maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
				maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
				while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
					drawMonth--;
					if (drawMonth < 0) {
						drawMonth = 11;
						drawYear--;
					}
				}
			}
			inst.drawMonth = drawMonth;
			inst.drawYear = drawYear;
	
			prevText = this._get(inst, "prevText");
			prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
				this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
				this._getFormatConfig(inst)));
	
			prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
				"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
				" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
				(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));
	
			nextText = this._get(inst, "nextText");
			nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
				this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
				this._getFormatConfig(inst)));
	
			next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
				"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
				" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
				(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));
	
			currentText = this._get(inst, "currentText");
			gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
			currentText = (!navigationAsDateFormat ? currentText :
				this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));
	
			controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
				this._get(inst, "closeText") + "</button>" : "");
	
			buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
				(this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
				">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";
	
			firstDay = parseInt(this._get(inst, "firstDay"),10);
			firstDay = (isNaN(firstDay) ? 0 : firstDay);
	
			showWeek = this._get(inst, "showWeek");
			dayNames = this._get(inst, "dayNames");
			dayNamesMin = this._get(inst, "dayNamesMin");
			monthNames = this._get(inst, "monthNames");
			monthNamesShort = this._get(inst, "monthNamesShort");
			beforeShowDay = this._get(inst, "beforeShowDay");
			showOtherMonths = this._get(inst, "showOtherMonths");
			selectOtherMonths = this._get(inst, "selectOtherMonths");
			defaultDate = this._getDefaultDate(inst);
			html = "";
			dow;
			for (row = 0; row < numMonths[0]; row++) {
				group = "";
				this.maxRows = 4;
				for (col = 0; col < numMonths[1]; col++) {
					selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
					cornerClass = " ui-corner-all";
					calender = "";
					if (isMultiMonth) {
						calender += "<div class='ui-datepicker-group";
						if (numMonths[1] > 1) {
							switch (col) {
								case 0: calender += " ui-datepicker-group-first";
									cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
								case numMonths[1]-1: calender += " ui-datepicker-group-last";
									cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
								default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
							}
						}
						calender += "'>";
					}
					calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
						(/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
						(/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
						this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
						row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
						"</div><table class='ui-datepicker-calendar'><thead>" +
						"<tr>";
					thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
					for (dow = 0; dow < 7; dow++) { // days of the week
						day = (dow + firstDay) % 7;
						thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
							"<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
					}
					calender += thead + "</tr></thead><tbody>";
					daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
					if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
						inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
					}
					leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
					curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
					numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
					this.maxRows = numRows;
					printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
					for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
						calender += "<tr>";
						tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
							this._get(inst, "calculateWeek")(printDate) + "</td>");
						for (dow = 0; dow < 7; dow++) { // create date picker days
							daySettings = (beforeShowDay ?
								beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
							otherMonth = (printDate.getMonth() !== drawMonth);
							unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
								(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
							tbody += "<td class='" +
								((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
								(otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
								((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
								(defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
								// or defaultDate is current printedDate and defaultDate is selectedDate
								" " + this._dayOverClass : "") + // highlight selected day
								(unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
								(otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
								(printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
								(printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
								((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
								(unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
								(otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
								(unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
								(printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
								(printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
								(otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
								"' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
							printDate.setDate(printDate.getDate() + 1);
							printDate = this._daylightSavingAdjust(printDate);
						}
						calender += tbody + "</tr>";
					}
					drawMonth++;
					if (drawMonth > 11) {
						drawMonth = 0;
						drawYear++;
					}
					calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
								((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
					group += calender;
				}
				html += group;
			}
			html += buttonPanel;
			inst._keyEvent = false;
			return html;
		},
	
		/* Generate the month and year header. */
		_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
				secondary, monthNames, monthNamesShort) {
	
			var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
				changeMonth = this._get(inst, "changeMonth"),
				changeYear = this._get(inst, "changeYear"),
				showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
				html = "<div class='ui-datepicker-title'>",
				monthHtml = "";
	
			// month selection
			if (secondary || !changeMonth) {
				monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
			} else {
				inMinYear = (minDate && minDate.getFullYear() === drawYear);
				inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
				monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
				for ( month = 0; month < 12; month++) {
					if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
						monthHtml += "<option value='" + month + "'" +
							(month === drawMonth ? " selected='selected'" : "") +
							">" + monthNamesShort[month] + "</option>";
					}
				}
				monthHtml += "</select>";
			}
	
			if (!showMonthAfterYear) {
				html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
			}
	
			// year selection
			if ( !inst.yearshtml ) {
				inst.yearshtml = "";
				if (secondary || !changeYear) {
					html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
				} else {
					// determine range of years to display
					years = this._get(inst, "yearRange").split(":");
					thisYear = new Date().getFullYear();
					determineYear = function(value) {
						var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
							(value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
							parseInt(value, 10)));
						return (isNaN(year) ? thisYear : year);
					};
					year = determineYear(years[0]);
					endYear = Math.max(year, determineYear(years[1] || ""));
					year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
					endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
					inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
					for (; year <= endYear; year++) {
						inst.yearshtml += "<option value='" + year + "'" +
							(year === drawYear ? " selected='selected'" : "") +
							">" + year + "</option>";
					}
					inst.yearshtml += "</select>";
	
					html += inst.yearshtml;
					inst.yearshtml = null;
				}
			}
	
			html += this._get(inst, "yearSuffix");
			if (showMonthAfterYear) {
				html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
			}
			html += "</div>"; // Close datepicker_header
			return html;
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustInstDate: function(inst, offset, period) {
			var year = inst.drawYear + (period === "Y" ? offset : 0),
				month = inst.drawMonth + (period === "M" ? offset : 0),
				day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
				date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));
	
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			if (period === "M" || period === "Y") {
				this._notifyChange(inst);
			}
		},
	
		/* Ensure a date is within any min/max bounds. */
		_restrictMinMax: function(inst, date) {
			var minDate = this._getMinMaxDate(inst, "min"),
				maxDate = this._getMinMaxDate(inst, "max"),
				newDate = (minDate && date < minDate ? minDate : date);
			return (maxDate && newDate > maxDate ? maxDate : newDate);
		},
	
		/* Notify change of month/year. */
		_notifyChange: function(inst) {
			var onChange = this._get(inst, "onChangeMonthYear");
			if (onChange) {
				onChange.apply((inst.input ? inst.input[0] : null),
					[inst.selectedYear, inst.selectedMonth + 1, inst]);
			}
		},
	
		/* Determine the number of months to show. */
		_getNumberOfMonths: function(inst) {
			var numMonths = this._get(inst, "numberOfMonths");
			return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
		},
	
		/* Determine the current maximum date - ensure no time components are set. */
		_getMinMaxDate: function(inst, minMax) {
			return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
		},
	
		/* Find the number of days in a given month. */
		_getDaysInMonth: function(year, month) {
			return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
		},
	
		/* Find the day of the week of the first of a month. */
		_getFirstDayOfMonth: function(year, month) {
			return new Date(year, month, 1).getDay();
		},
	
		/* Determines if we should allow a "next/prev" month display change. */
		_canAdjustMonth: function(inst, offset, curYear, curMonth) {
			var numMonths = this._getNumberOfMonths(inst),
				date = this._daylightSavingAdjust(new Date(curYear,
				curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));
	
			if (offset < 0) {
				date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
			}
			return this._isInRange(inst, date);
		},
	
		/* Is the given date in the accepted range? */
		_isInRange: function(inst, date) {
			var yearSplit, currentYear,
				minDate = this._getMinMaxDate(inst, "min"),
				maxDate = this._getMinMaxDate(inst, "max"),
				minYear = null,
				maxYear = null,
				years = this._get(inst, "yearRange");
				if (years){
					yearSplit = years.split(":");
					currentYear = new Date().getFullYear();
					minYear = parseInt(yearSplit[0], 10);
					maxYear = parseInt(yearSplit[1], 10);
					if ( yearSplit[0].match(/[+\-].*/) ) {
						minYear += currentYear;
					}
					if ( yearSplit[1].match(/[+\-].*/) ) {
						maxYear += currentYear;
					}
				}
	
			return ((!minDate || date.getTime() >= minDate.getTime()) &&
				(!maxDate || date.getTime() <= maxDate.getTime()) &&
				(!minYear || date.getFullYear() >= minYear) &&
				(!maxYear || date.getFullYear() <= maxYear));
		},
	
		/* Provide the configuration settings for formatting/parsing. */
		_getFormatConfig: function(inst) {
			var shortYearCutoff = this._get(inst, "shortYearCutoff");
			shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
			return {shortYearCutoff: shortYearCutoff,
				dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
				monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
		},
	
		/* Format the given date for display. */
		_formatDate: function(inst, day, month, year) {
			if (!day) {
				inst.currentDay = inst.selectedDay;
				inst.currentMonth = inst.selectedMonth;
				inst.currentYear = inst.selectedYear;
			}
			var date = (day ? (typeof day === "object" ? day :
				this._daylightSavingAdjust(new Date(year, month, day))) :
				this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
			return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
		}
	});
	
	/*
	 * Bind hover events for datepicker elements.
	 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
	 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
	 */
	function datepicker_bindHover(dpDiv) {
		var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
		return dpDiv.delegate(selector, "mouseout", function() {
				$(this).removeClass("ui-state-hover");
				if (this.className.indexOf("ui-datepicker-prev") !== -1) {
					$(this).removeClass("ui-datepicker-prev-hover");
				}
				if (this.className.indexOf("ui-datepicker-next") !== -1) {
					$(this).removeClass("ui-datepicker-next-hover");
				}
			})
			.delegate( selector, "mouseover", datepicker_handleMouseover );
	}
	
	function datepicker_handleMouseover() {
		if (!$.datepicker._isDisabledDatepicker( datepicker_instActive.inline? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
			$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
			$(this).addClass("ui-state-hover");
			if (this.className.indexOf("ui-datepicker-prev") !== -1) {
				$(this).addClass("ui-datepicker-prev-hover");
			}
			if (this.className.indexOf("ui-datepicker-next") !== -1) {
				$(this).addClass("ui-datepicker-next-hover");
			}
		}
	}
	
	/* jQuery extend now ignores nulls! */
	function datepicker_extendRemove(target, props) {
		$.extend(target, props);
		for (var name in props) {
			if (props[name] == null) {
				target[name] = props[name];
			}
		}
		return target;
	}
	
	/* Invoke the datepicker functionality.
	   @param  options  string - a command, optionally followed by additional parameters or
						Object - settings for attaching new datepicker functionality
	   @return  jQuery object */
	$.fn.datepicker = function(options){
	
		/* Verify an empty collection wasn't passed - Fixes #6976 */
		if ( !this.length ) {
			return this;
		}
	
		/* Initialise the date picker. */
		if (!$.datepicker.initialized) {
			$(document).mousedown($.datepicker._checkExternalClick);
			$.datepicker.initialized = true;
		}
	
		/* Append datepicker main container to body if not exist. */
		if ($("#"+$.datepicker._mainDivId).length === 0) {
			$("body").append($.datepicker.dpDiv);
		}
	
		var otherArgs = Array.prototype.slice.call(arguments, 1);
		if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
			return $.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this[0]].concat(otherArgs));
		}
		if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
			return $.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this[0]].concat(otherArgs));
		}
		return this.each(function() {
			typeof options === "string" ?
				$.datepicker["_" + options + "Datepicker"].
					apply($.datepicker, [this].concat(otherArgs)) :
				$.datepicker._attachDatepicker(this, options);
		});
	};
	
	$.datepicker = new Datepicker(); // singleton instance
	$.datepicker.initialized = false;
	$.datepicker.uuid = new Date().getTime();
	$.datepicker.version = "1.11.4";
	
	var datepicker = $.datepicker;
	
	
	/*!
	 * jQuery UI Draggable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/draggable/
	 */
	
	
	$.widget("ui.draggable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if (this.options.addClasses){
				this.element.addClass("ui-draggable");
			}
			if (this.options.disabled){
				this.element.addClass("ui-draggable-disabled");
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function(event) {
			var o = this.options;
	
			this._blurActiveElement( event );
	
			// among others, prevent a drag on a resizable-handle
			if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle(event);
			if (!this.handle) {
				return false;
			}
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map(function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			});
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var document = this.document[ 0 ];
	
			// Only need to blur if the event occurred on the draggable itself, see #10527
			if ( !this.handleElement.is( event.target ) ) {
				return;
			}
	
			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
	
				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #9520
				if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {
	
					// Blur any element that currently has focus, see #4261
					$( document.activeElement ).blur();
				}
			} catch ( error ) {}
		},
	
		_mouseStart: function(event) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper(event);
	
			this.helper.addClass("ui-draggable-dragging");
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ($.ui.ddmanager) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter(function() {
					return $( this ).css( "position" ) === "fixed";
				}).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if (this._trigger("start", event) === false) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ($.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
	
			// Reset helper's right/bottom css if they're set and set explicit width/height instead
			// as this prevents resizing of elements with right/bottom set (see #7772)
			this._normalizeRightBottom();
	
			this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position
	
			//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart(this, event);
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function(event, noPropagation) {
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo("absolute");
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if (!noPropagation) {
				var ui = this._uiHash();
				if (this._trigger("drag", event, ui) === false) {
					this._mouseUp({});
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}
	
			return false;
		},
	
		_mouseStop: function(event) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ($.ui.ddmanager && !this.options.dropBehaviour) {
				dropped = $.ui.ddmanager.drop(this, event);
			}
	
			//if a drop comes from outside (a sortable)
			if (this.dropped) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
				$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
					if (that._trigger("stop", event) !== false) {
						that._clear();
					}
				});
			} else {
				if (this._trigger("stop", event) !== false) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop(this, event);
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
				// The interaction is over; whether or not the click resulted in a drag, focus the element
				this.element.focus();
			}
	
			return $.ui.mouse.prototype._mouseUp.call(this, event);
		},
	
		cancel: function() {
	
			if (this.helper.is(".ui-draggable-dragging")) {
				this._mouseUp({});
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function(event) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this.handleElement.addClass( "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this.handleElement.removeClass( "ui-draggable-handle" );
		},
	
		_createHelper: function(event) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if (!helper.parents("body").length) {
				helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
			}
	
			// http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
				helper.css("position", "absolute");
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function(obj) {
			if (typeof obj === "string") {
				obj = obj.split(" ");
			}
			if ($.isArray(obj)) {
				obj = { left: +obj[0], top: +obj[1] || 0 };
			}
			if ("left" in obj) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ("right" in obj) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ("top" in obj) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ("bottom" in obj) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
			//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
			if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
				left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: (parseInt(this.element.css("marginLeft"), 10) || 0),
				top: (parseInt(this.element.css("marginTop"), 10) || 0),
				right: (parseInt(this.element.css("marginRight"), 10) || 0),
				bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document") {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function(d, pos) {
	
			if (!pos) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
					pos.top	+																// The absolute mouse position
					this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
				),
				left: (
					pos.left +																// The absolute mouse position
					this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ){
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if (event.pageX - this.offset.click.left < containment[0]) {
						pageX = containment[0] + this.offset.click.left;
					}
					if (event.pageY - this.offset.click.top < containment[1]) {
						pageY = containment[1] + this.offset.click.top;
					}
					if (event.pageX - this.offset.click.left > containment[2]) {
						pageX = containment[2] + this.offset.click.left;
					}
					if (event.pageY - this.offset.click.top > containment[3]) {
						pageY = containment[3] + this.offset.click.top;
					}
				}
	
				if (o.grid) {
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
					top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
					pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;
	
					left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
					pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
					pageY -																	// The absolute mouse position
					this.offset.click.top	-												// Click offset (relative to the element)
					this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
					( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
					pageX -																	// The absolute mouse position
					this.offset.click.left -												// Click offset (relative to the element)
					this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
					( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this.helper.removeClass("ui-draggable-dragging");
			if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		_normalizeRightBottom: function() {
			if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
				this.helper.width( this.helper.width() );
				this.helper.css( "right", "auto" );
			}
			if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
				this.helper.height( this.helper.height() );
				this.helper.css( "bottom", "auto" );
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	});
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			});
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each(function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// refreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger("activate", event, uiSortable);
				}
			});
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			});
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop(event);
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			});
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					});
				}
	
				if ( innermostIntersecting ) {
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						});
	
						// hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						});
					}
				}
			});
		}
	});
	
	$.ui.plugin.add("draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if (t.css("cursor")) {
				o._cursor = t.css("cursor");
			}
			t.css("cursor", o.cursor);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if (o._cursor) {
				$("body").css("cursor", o._cursor);
			}
		}
	});
	
	$.ui.plugin.add("draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if (t.css("opacity")) {
				o._opacity = t.css("opacity");
			}
			t.css("opacity", o.opacity);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if (o._opacity) {
				$(ui.helper).css("opacity", o._opacity);
			}
		}
	});
	
	$.ui.plugin.add("draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if (!o.axis || o.axis !== "x") {
					if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
					} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
						scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
					}
				}
	
				if (!o.axis || o.axis !== "y") {
					if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
					} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
						scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
					}
				}
	
			}
	
			if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(i, event);
			}
	
		}
	});
	
	$.ui.plugin.add("draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
				var $t = $(this),
					$o = $t.offset();
				if (this !== i.element[0]) {
					i.snapElements.push({
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					});
				}
			});
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for (i = inst.snapElements.length - 1; i >= 0; i--){
	
				l = inst.snapElements[i].left - inst.margins.left;
				r = l + inst.snapElements[i].width;
				t = inst.snapElements[i].top - inst.margins.top;
				b = t + inst.snapElements[i].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
					if (inst.snapElements[i].snapping) {
						(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
					}
					inst.snapElements[i].snapping = false;
					continue;
				}
	
				if (o.snapMode !== "inner") {
					ts = Math.abs(t - y2) <= d;
					bs = Math.abs(b - y1) <= d;
					ls = Math.abs(l - x2) <= d;
					rs = Math.abs(r - x1) <= d;
					if (ts) {
						ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
					}
					if (bs) {
						ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
					}
					if (ls) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
					}
					if (rs) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
					}
				}
	
				first = (ts || bs || ls || rs);
	
				if (o.snapMode !== "outer") {
					ts = Math.abs(t - y1) <= d;
					bs = Math.abs(b - y2) <= d;
					ls = Math.abs(l - x1) <= d;
					rs = Math.abs(r - x2) <= d;
					if (ts) {
						ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
					}
					if (bs) {
						ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
					}
					if (ls) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
					}
					if (rs) {
						ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
					}
				}
	
				if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
					(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = (ts || bs || ls || rs || first);
	
			}
	
		}
	});
	
	$.ui.plugin.add("draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray($(o.stack)).sort(function(a, b) {
					return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
				});
	
			if (!group.length) { return; }
	
			min = parseInt($(group[0]).css("zIndex"), 10) || 0;
			$(group).each(function(i) {
				$(this).css("zIndex", min + i);
			});
			this.css("zIndex", (min + group.length));
		}
	});
	
	$.ui.plugin.add("draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if (t.css("zIndex")) {
				o._zIndex = t.css("zIndex");
			}
			t.css("zIndex", o.zIndex);
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if (o._zIndex) {
				$(ui.helper).css("zIndex", o._zIndex);
			}
		}
	});
	
	var draggable = $.ui.draggable;
	
	
	/*!
	 * jQuery UI Resizable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/resizable/
	 */
	
	
	$.widget("ui.resizable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "resize",
		options: {
			alsoResize: false,
			animate: false,
			animateDuration: "slow",
			animateEasing: "swing",
			aspectRatio: false,
			autoHide: false,
			containment: false,
			ghost: false,
			grid: false,
			handles: "e,s,se",
			helper: false,
			maxHeight: null,
			maxWidth: null,
			minHeight: 10,
			minWidth: 10,
			// See #7960
			zIndex: 90,
	
			// callbacks
			resize: null,
			start: null,
			stop: null
		},
	
		_num: function( value ) {
			return parseInt( value, 10 ) || 0;
		},
	
		_isNumber: function( value ) {
			return !isNaN( parseInt( value, 10 ) );
		},
	
		_hasScroll: function( el, a ) {
	
			if ( $( el ).css( "overflow" ) === "hidden") {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		},
	
		_create: function() {
	
			var n, i, handle, axis, hname,
				that = this,
				o = this.options;
			this.element.addClass("ui-resizable");
	
			$.extend(this, {
				_aspectRatio: !!(o.aspectRatio),
				aspectRatio: o.aspectRatio,
				originalElement: this.element,
				_proportionallyResizeElements: [],
				_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
			});
	
			// Wrap the element if it cannot hold child nodes
			if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {
	
				this.element.wrap(
					$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
						position: this.element.css("position"),
						width: this.element.outerWidth(),
						height: this.element.outerHeight(),
						top: this.element.css("top"),
						left: this.element.css("left")
					})
				);
	
				this.element = this.element.parent().data(
					"ui-resizable", this.element.resizable( "instance" )
				);
	
				this.elementIsWrapper = true;
	
				this.element.css({
					marginLeft: this.originalElement.css("marginLeft"),
					marginTop: this.originalElement.css("marginTop"),
					marginRight: this.originalElement.css("marginRight"),
					marginBottom: this.originalElement.css("marginBottom")
				});
				this.originalElement.css({
					marginLeft: 0,
					marginTop: 0,
					marginRight: 0,
					marginBottom: 0
				});
				// support: Safari
				// Prevent Safari textarea resize
				this.originalResizeStyle = this.originalElement.css("resize");
				this.originalElement.css("resize", "none");
	
				this._proportionallyResizeElements.push( this.originalElement.css({
					position: "static",
					zoom: 1,
					display: "block"
				}) );
	
				// support: IE9
				// avoid IE jump (hard set the margin)
				this.originalElement.css({ margin: this.originalElement.css("margin") });
	
				this._proportionallyResize();
			}
	
			this.handles = o.handles ||
				( !$(".ui-resizable-handle", this.element).length ?
					"e,s,se" : {
						n: ".ui-resizable-n",
						e: ".ui-resizable-e",
						s: ".ui-resizable-s",
						w: ".ui-resizable-w",
						se: ".ui-resizable-se",
						sw: ".ui-resizable-sw",
						ne: ".ui-resizable-ne",
						nw: ".ui-resizable-nw"
					} );
	
			this._handles = $();
			if ( this.handles.constructor === String ) {
	
				if ( this.handles === "all") {
					this.handles = "n,e,s,w,se,sw,ne,nw";
				}
	
				n = this.handles.split(",");
				this.handles = {};
	
				for (i = 0; i < n.length; i++) {
	
					handle = $.trim(n[i]);
					hname = "ui-resizable-" + handle;
					axis = $("<div class='ui-resizable-handle " + hname + "'></div>");
	
					axis.css({ zIndex: o.zIndex });
	
					// TODO : What's going on here?
					if ("se" === handle) {
						axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
					}
	
					this.handles[handle] = ".ui-resizable-" + handle;
					this.element.append(axis);
				}
	
			}
	
			this._renderAxis = function(target) {
	
				var i, axis, padPos, padWrapper;
	
				target = target || this.element;
	
				for (i in this.handles) {
	
					if (this.handles[i].constructor === String) {
						this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
					} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
						this.handles[ i ] = $( this.handles[ i ] );
						this._on( this.handles[ i ], { "mousedown": that._mouseDown });
					}
	
					if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {
	
						axis = $(this.handles[i], this.element);
	
						padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();
	
						padPos = [ "padding",
							/ne|nw|n/.test(i) ? "Top" :
							/se|sw|s/.test(i) ? "Bottom" :
							/^e$/.test(i) ? "Right" : "Left" ].join("");
	
						target.css(padPos, padWrapper);
	
						this._proportionallyResize();
					}
	
					this._handles = this._handles.add( this.handles[ i ] );
				}
			};
	
			// TODO: make renderAxis a prototype function
			this._renderAxis(this.element);
	
			this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
			this._handles.disableSelection();
	
			this._handles.mouseover(function() {
				if (!that.resizing) {
					if (this.className) {
						axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
					}
					that.axis = axis && axis[1] ? axis[1] : "se";
				}
			});
	
			if (o.autoHide) {
				this._handles.hide();
				$(this.element)
					.addClass("ui-resizable-autohide")
					.mouseenter(function() {
						if (o.disabled) {
							return;
						}
						$(this).removeClass("ui-resizable-autohide");
						that._handles.show();
					})
					.mouseleave(function() {
						if (o.disabled) {
							return;
						}
						if (!that.resizing) {
							$(this).addClass("ui-resizable-autohide");
							that._handles.hide();
						}
					});
			}
	
			this._mouseInit();
		},
	
		_destroy: function() {
	
			this._mouseDestroy();
	
			var wrapper,
				_destroy = function(exp) {
					$(exp)
						.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
						.removeData("resizable")
						.removeData("ui-resizable")
						.unbind(".resizable")
						.find(".ui-resizable-handle")
							.remove();
				};
	
			// TODO: Unwrap at same DOM position
			if (this.elementIsWrapper) {
				_destroy(this.element);
				wrapper = this.element;
				this.originalElement.css({
					position: wrapper.css("position"),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css("top"),
					left: wrapper.css("left")
				}).insertAfter( wrapper );
				wrapper.remove();
			}
	
			this.originalElement.css("resize", this.originalResizeStyle);
			_destroy(this.originalElement);
	
			return this;
		},
	
		_mouseCapture: function(event) {
			var i, handle,
				capture = false;
	
			for (i in this.handles) {
				handle = $(this.handles[i])[0];
				if (handle === event.target || $.contains(handle, event.target)) {
					capture = true;
				}
			}
	
			return !this.options.disabled && capture;
		},
	
		_mouseStart: function(event) {
	
			var curleft, curtop, cursor,
				o = this.options,
				el = this.element;
	
			this.resizing = true;
	
			this._renderProxy();
	
			curleft = this._num(this.helper.css("left"));
			curtop = this._num(this.helper.css("top"));
	
			if (o.containment) {
				curleft += $(o.containment).scrollLeft() || 0;
				curtop += $(o.containment).scrollTop() || 0;
			}
	
			this.offset = this.helper.offset();
			this.position = { left: curleft, top: curtop };
	
			this.size = this._helper ? {
					width: this.helper.width(),
					height: this.helper.height()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.originalSize = this._helper ? {
					width: el.outerWidth(),
					height: el.outerHeight()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.sizeDiff = {
				width: el.outerWidth() - el.width(),
				height: el.outerHeight() - el.height()
			};
	
			this.originalPosition = { left: curleft, top: curtop };
			this.originalMousePosition = { left: event.pageX, top: event.pageY };
	
			this.aspectRatio = (typeof o.aspectRatio === "number") ?
				o.aspectRatio :
				((this.originalSize.width / this.originalSize.height) || 1);
	
			cursor = $(".ui-resizable-" + this.axis).css("cursor");
			$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);
	
			el.addClass("ui-resizable-resizing");
			this._propagate("start", event);
			return true;
		},
	
		_mouseDrag: function(event) {
	
			var data, props,
				smp = this.originalMousePosition,
				a = this.axis,
				dx = (event.pageX - smp.left) || 0,
				dy = (event.pageY - smp.top) || 0,
				trigger = this._change[a];
	
			this._updatePrevProperties();
	
			if (!trigger) {
				return false;
			}
	
			data = trigger.apply(this, [ event, dx, dy ]);
	
			this._updateVirtualBoundaries(event.shiftKey);
			if (this._aspectRatio || event.shiftKey) {
				data = this._updateRatio(data, event);
			}
	
			data = this._respectSize(data, event);
	
			this._updateCache(data);
	
			this._propagate("resize", event);
	
			props = this._applyChanges();
	
			if ( !this._helper && this._proportionallyResizeElements.length ) {
				this._proportionallyResize();
			}
	
			if ( !$.isEmptyObject( props ) ) {
				this._updatePrevProperties();
				this._trigger( "resize", event, this.ui() );
				this._applyChanges();
			}
	
			return false;
		},
	
		_mouseStop: function(event) {
	
			this.resizing = false;
			var pr, ista, soffseth, soffsetw, s, left, top,
				o = this.options, that = this;
	
			if (this._helper) {
	
				pr = this._proportionallyResizeElements;
				ista = pr.length && (/textarea/i).test(pr[0].nodeName);
				soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
				soffsetw = ista ? 0 : that.sizeDiff.width;
	
				s = {
					width: (that.helper.width()  - soffsetw),
					height: (that.helper.height() - soffseth)
				};
				left = (parseInt(that.element.css("left"), 10) +
					(that.position.left - that.originalPosition.left)) || null;
				top = (parseInt(that.element.css("top"), 10) +
					(that.position.top - that.originalPosition.top)) || null;
	
				if (!o.animate) {
					this.element.css($.extend(s, { top: top, left: left }));
				}
	
				that.helper.height(that.size.height);
				that.helper.width(that.size.width);
	
				if (this._helper && !o.animate) {
					this._proportionallyResize();
				}
			}
	
			$("body").css("cursor", "auto");
	
			this.element.removeClass("ui-resizable-resizing");
	
			this._propagate("stop", event);
	
			if (this._helper) {
				this.helper.remove();
			}
	
			return false;
	
		},
	
		_updatePrevProperties: function() {
			this.prevPosition = {
				top: this.position.top,
				left: this.position.left
			};
			this.prevSize = {
				width: this.size.width,
				height: this.size.height
			};
		},
	
		_applyChanges: function() {
			var props = {};
	
			if ( this.position.top !== this.prevPosition.top ) {
				props.top = this.position.top + "px";
			}
			if ( this.position.left !== this.prevPosition.left ) {
				props.left = this.position.left + "px";
			}
			if ( this.size.width !== this.prevSize.width ) {
				props.width = this.size.width + "px";
			}
			if ( this.size.height !== this.prevSize.height ) {
				props.height = this.size.height + "px";
			}
	
			this.helper.css( props );
	
			return props;
		},
	
		_updateVirtualBoundaries: function(forceAspectRatio) {
			var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
				o = this.options;
	
			b = {
				minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
				maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
				minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
				maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
			};
	
			if (this._aspectRatio || forceAspectRatio) {
				pMinWidth = b.minHeight * this.aspectRatio;
				pMinHeight = b.minWidth / this.aspectRatio;
				pMaxWidth = b.maxHeight * this.aspectRatio;
				pMaxHeight = b.maxWidth / this.aspectRatio;
	
				if (pMinWidth > b.minWidth) {
					b.minWidth = pMinWidth;
				}
				if (pMinHeight > b.minHeight) {
					b.minHeight = pMinHeight;
				}
				if (pMaxWidth < b.maxWidth) {
					b.maxWidth = pMaxWidth;
				}
				if (pMaxHeight < b.maxHeight) {
					b.maxHeight = pMaxHeight;
				}
			}
			this._vBoundaries = b;
		},
	
		_updateCache: function(data) {
			this.offset = this.helper.offset();
			if (this._isNumber(data.left)) {
				this.position.left = data.left;
			}
			if (this._isNumber(data.top)) {
				this.position.top = data.top;
			}
			if (this._isNumber(data.height)) {
				this.size.height = data.height;
			}
			if (this._isNumber(data.width)) {
				this.size.width = data.width;
			}
		},
	
		_updateRatio: function( data ) {
	
			var cpos = this.position,
				csize = this.size,
				a = this.axis;
	
			if (this._isNumber(data.height)) {
				data.width = (data.height * this.aspectRatio);
			} else if (this._isNumber(data.width)) {
				data.height = (data.width / this.aspectRatio);
			}
	
			if (a === "sw") {
				data.left = cpos.left + (csize.width - data.width);
				data.top = null;
			}
			if (a === "nw") {
				data.top = cpos.top + (csize.height - data.height);
				data.left = cpos.left + (csize.width - data.width);
			}
	
			return data;
		},
	
		_respectSize: function( data ) {
	
			var o = this._vBoundaries,
				a = this.axis,
				ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
				ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
				isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
				isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
				dw = this.originalPosition.left + this.originalSize.width,
				dh = this.position.top + this.size.height,
				cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
			if (isminw) {
				data.width = o.minWidth;
			}
			if (isminh) {
				data.height = o.minHeight;
			}
			if (ismaxw) {
				data.width = o.maxWidth;
			}
			if (ismaxh) {
				data.height = o.maxHeight;
			}
	
			if (isminw && cw) {
				data.left = dw - o.minWidth;
			}
			if (ismaxw && cw) {
				data.left = dw - o.maxWidth;
			}
			if (isminh && ch) {
				data.top = dh - o.minHeight;
			}
			if (ismaxh && ch) {
				data.top = dh - o.maxHeight;
			}
	
			// Fixing jump error on top/left - bug #2330
			if (!data.width && !data.height && !data.left && data.top) {
				data.top = null;
			} else if (!data.width && !data.height && !data.top && data.left) {
				data.left = null;
			}
	
			return data;
		},
	
		_getPaddingPlusBorderDimensions: function( element ) {
			var i = 0,
				widths = [],
				borders = [
					element.css( "borderTopWidth" ),
					element.css( "borderRightWidth" ),
					element.css( "borderBottomWidth" ),
					element.css( "borderLeftWidth" )
				],
				paddings = [
					element.css( "paddingTop" ),
					element.css( "paddingRight" ),
					element.css( "paddingBottom" ),
					element.css( "paddingLeft" )
				];
	
			for ( ; i < 4; i++ ) {
				widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
				widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
			}
	
			return {
				height: widths[ 0 ] + widths[ 2 ],
				width: widths[ 1 ] + widths[ 3 ]
			};
		},
	
		_proportionallyResize: function() {
	
			if (!this._proportionallyResizeElements.length) {
				return;
			}
	
			var prel,
				i = 0,
				element = this.helper || this.element;
	
			for ( ; i < this._proportionallyResizeElements.length; i++) {
	
				prel = this._proportionallyResizeElements[i];
	
				// TODO: Seems like a bug to cache this.outerDimensions
				// considering that we are in a loop.
				if (!this.outerDimensions) {
					this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
				}
	
				prel.css({
					height: (element.height() - this.outerDimensions.height) || 0,
					width: (element.width() - this.outerDimensions.width) || 0
				});
	
			}
	
		},
	
		_renderProxy: function() {
	
			var el = this.element, o = this.options;
			this.elementOffset = el.offset();
	
			if (this._helper) {
	
				this.helper = this.helper || $("<div style='overflow:hidden;'></div>");
	
				this.helper.addClass(this._helper).css({
					width: this.element.outerWidth() - 1,
					height: this.element.outerHeight() - 1,
					position: "absolute",
					left: this.elementOffset.left + "px",
					top: this.elementOffset.top + "px",
					zIndex: ++o.zIndex //TODO: Don't modify option
				});
	
				this.helper
					.appendTo("body")
					.disableSelection();
	
			} else {
				this.helper = this.element;
			}
	
		},
	
		_change: {
			e: function(event, dx) {
				return { width: this.originalSize.width + dx };
			},
			w: function(event, dx) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { left: sp.left + dx, width: cs.width - dx };
			},
			n: function(event, dx, dy) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { top: sp.top + dy, height: cs.height - dy };
			},
			s: function(event, dx, dy) {
				return { height: this.originalSize.height + dy };
			},
			se: function(event, dx, dy) {
				return $.extend(this._change.s.apply(this, arguments),
					this._change.e.apply(this, [ event, dx, dy ]));
			},
			sw: function(event, dx, dy) {
				return $.extend(this._change.s.apply(this, arguments),
					this._change.w.apply(this, [ event, dx, dy ]));
			},
			ne: function(event, dx, dy) {
				return $.extend(this._change.n.apply(this, arguments),
					this._change.e.apply(this, [ event, dx, dy ]));
			},
			nw: function(event, dx, dy) {
				return $.extend(this._change.n.apply(this, arguments),
					this._change.w.apply(this, [ event, dx, dy ]));
			}
		},
	
		_propagate: function(n, event) {
			$.ui.plugin.call(this, n, [ event, this.ui() ]);
			(n !== "resize" && this._trigger(n, event, this.ui()));
		},
	
		plugins: {},
	
		ui: function() {
			return {
				originalElement: this.originalElement,
				element: this.element,
				helper: this.helper,
				position: this.position,
				size: this.size,
				originalSize: this.originalSize,
				originalPosition: this.originalPosition
			};
		}
	
	});
	
	/*
	 * Resizable Extensions
	 */
	
	$.ui.plugin.add("resizable", "animate", {
	
		stop: function( event ) {
			var that = $(this).resizable( "instance" ),
				o = that.options,
				pr = that._proportionallyResizeElements,
				ista = pr.length && (/textarea/i).test(pr[0].nodeName),
				soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
				soffsetw = ista ? 0 : that.sizeDiff.width,
				style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
				left = (parseInt(that.element.css("left"), 10) +
					(that.position.left - that.originalPosition.left)) || null,
				top = (parseInt(that.element.css("top"), 10) +
					(that.position.top - that.originalPosition.top)) || null;
	
			that.element.animate(
				$.extend(style, top && left ? { top: top, left: left } : {}), {
					duration: o.animateDuration,
					easing: o.animateEasing,
					step: function() {
	
						var data = {
							width: parseInt(that.element.css("width"), 10),
							height: parseInt(that.element.css("height"), 10),
							top: parseInt(that.element.css("top"), 10),
							left: parseInt(that.element.css("left"), 10)
						};
	
						if (pr && pr.length) {
							$(pr[0]).css({ width: data.width, height: data.height });
						}
	
						// propagating resize, and updating values for each animation step
						that._updateCache(data);
						that._propagate("resize", event);
	
					}
				}
			);
		}
	
	});
	
	$.ui.plugin.add( "resizable", "containment", {
	
		start: function() {
			var element, p, co, ch, cw, width, height,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				el = that.element,
				oc = o.containment,
				ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;
	
			if ( !ce ) {
				return;
			}
	
			that.containerElement = $( ce );
	
			if ( /document/.test( oc ) || oc === document ) {
				that.containerOffset = {
					left: 0,
					top: 0
				};
				that.containerPosition = {
					left: 0,
					top: 0
				};
	
				that.parentData = {
					element: $( document ),
					left: 0,
					top: 0,
					width: $( document ).width(),
					height: $( document ).height() || document.body.parentNode.scrollHeight
				};
			} else {
				element = $( ce );
				p = [];
				$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
					p[ i ] = that._num( element.css( "padding" + name ) );
				});
	
				that.containerOffset = element.offset();
				that.containerPosition = element.position();
				that.containerSize = {
					height: ( element.innerHeight() - p[ 3 ] ),
					width: ( element.innerWidth() - p[ 1 ] )
				};
	
				co = that.containerOffset;
				ch = that.containerSize.height;
				cw = that.containerSize.width;
				width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
				height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;
	
				that.parentData = {
					element: ce,
					left: co.left,
					top: co.top,
					width: width,
					height: height
				};
			}
		},
	
		resize: function( event ) {
			var woset, hoset, isParent, isOffsetRelative,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cp = that.position,
				pRatio = that._aspectRatio || event.shiftKey,
				cop = {
					top: 0,
					left: 0
				},
				ce = that.containerElement,
				continueResize = true;
	
			if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
				cop = co;
			}
	
			if ( cp.left < ( that._helper ? co.left : 0 ) ) {
				that.size.width = that.size.width +
					( that._helper ?
						( that.position.left - co.left ) :
						( that.position.left - cop.left ) );
	
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
				that.position.left = o.helper ? co.left : 0;
			}
	
			if ( cp.top < ( that._helper ? co.top : 0 ) ) {
				that.size.height = that.size.height +
					( that._helper ?
						( that.position.top - co.top ) :
						that.position.top );
	
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
				that.position.top = that._helper ? co.top : 0;
			}
	
			isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
			isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );
	
			if ( isParent && isOffsetRelative ) {
				that.offset.left = that.parentData.left + that.position.left;
				that.offset.top = that.parentData.top + that.position.top;
			} else {
				that.offset.left = that.element.offset().left;
				that.offset.top = that.element.offset().top;
			}
	
			woset = Math.abs( that.sizeDiff.width +
				(that._helper ?
					that.offset.left - cop.left :
					(that.offset.left - co.left)) );
	
			hoset = Math.abs( that.sizeDiff.height +
				(that._helper ?
					that.offset.top - cop.top :
					(that.offset.top - co.top)) );
	
			if ( woset + that.size.width >= that.parentData.width ) {
				that.size.width = that.parentData.width - woset;
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( hoset + that.size.height >= that.parentData.height ) {
				that.size.height = that.parentData.height - hoset;
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( !continueResize ) {
				that.position.left = that.prevPosition.left;
				that.position.top = that.prevPosition.top;
				that.size.width = that.prevSize.width;
				that.size.height = that.prevSize.height;
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cop = that.containerPosition,
				ce = that.containerElement,
				helper = $( that.helper ),
				ho = helper.offset(),
				w = helper.outerWidth() - that.sizeDiff.width,
				h = helper.outerHeight() - that.sizeDiff.height;
	
			if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
				$( this ).css({
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				});
			}
	
			if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
				$( this ).css({
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				});
			}
		}
	});
	
	$.ui.plugin.add("resizable", "alsoResize", {
	
		start: function() {
			var that = $(this).resizable( "instance" ),
				o = that.options;
	
			$(o.alsoResize).each(function() {
				var el = $(this);
				el.data("ui-resizable-alsoresize", {
					width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
					left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
				});
			});
		},
	
		resize: function(event, ui) {
			var that = $(this).resizable( "instance" ),
				o = that.options,
				os = that.originalSize,
				op = that.originalPosition,
				delta = {
					height: (that.size.height - os.height) || 0,
					width: (that.size.width - os.width) || 0,
					top: (that.position.top - op.top) || 0,
					left: (that.position.left - op.left) || 0
				};
	
				$(o.alsoResize).each(function() {
					var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
						css = el.parents(ui.originalElement[0]).length ?
								[ "width", "height" ] :
								[ "width", "height", "top", "left" ];
	
					$.each(css, function(i, prop) {
						var sum = (start[prop] || 0) + (delta[prop] || 0);
						if (sum && sum >= 0) {
							style[prop] = sum || null;
						}
					});
	
					el.css(style);
				});
		},
	
		stop: function() {
			$(this).removeData("resizable-alsoresize");
		}
	});
	
	$.ui.plugin.add("resizable", "ghost", {
	
		start: function() {
	
			var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;
	
			that.ghost = that.originalElement.clone();
			that.ghost
				.css({
					opacity: 0.25,
					display: "block",
					position: "relative",
					height: cs.height,
					width: cs.width,
					margin: 0,
					left: 0,
					top: 0
				})
				.addClass("ui-resizable-ghost")
				.addClass(typeof o.ghost === "string" ? o.ghost : "");
	
			that.ghost.appendTo(that.helper);
	
		},
	
		resize: function() {
			var that = $(this).resizable( "instance" );
			if (that.ghost) {
				that.ghost.css({
					position: "relative",
					height: that.size.height,
					width: that.size.width
				});
			}
		},
	
		stop: function() {
			var that = $(this).resizable( "instance" );
			if (that.ghost && that.helper) {
				that.helper.get(0).removeChild(that.ghost.get(0));
			}
		}
	
	});
	
	$.ui.plugin.add("resizable", "grid", {
	
		resize: function() {
			var outerDimensions,
				that = $(this).resizable( "instance" ),
				o = that.options,
				cs = that.size,
				os = that.originalSize,
				op = that.originalPosition,
				a = that.axis,
				grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
				gridX = (grid[0] || 1),
				gridY = (grid[1] || 1),
				ox = Math.round((cs.width - os.width) / gridX) * gridX,
				oy = Math.round((cs.height - os.height) / gridY) * gridY,
				newWidth = os.width + ox,
				newHeight = os.height + oy,
				isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
				isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
				isMinWidth = o.minWidth && (o.minWidth > newWidth),
				isMinHeight = o.minHeight && (o.minHeight > newHeight);
	
			o.grid = grid;
	
			if (isMinWidth) {
				newWidth += gridX;
			}
			if (isMinHeight) {
				newHeight += gridY;
			}
			if (isMaxWidth) {
				newWidth -= gridX;
			}
			if (isMaxHeight) {
				newHeight -= gridY;
			}
	
			if (/^(se|s|e)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
			} else if (/^(ne)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else if (/^(sw)$/.test(a)) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.left = op.left - ox;
			} else {
				if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
					outerDimensions = that._getPaddingPlusBorderDimensions( this );
				}
	
				if ( newHeight - gridY > 0 ) {
					that.size.height = newHeight;
					that.position.top = op.top - oy;
				} else {
					newHeight = gridY - outerDimensions.height;
					that.size.height = newHeight;
					that.position.top = op.top + os.height - newHeight;
				}
				if ( newWidth - gridX > 0 ) {
					that.size.width = newWidth;
					that.position.left = op.left - ox;
				} else {
					newWidth = gridX - outerDimensions.width;
					that.size.width = newWidth;
					that.position.left = op.left + os.width - newWidth;
				}
			}
		}
	
	});
	
	var resizable = $.ui.resizable;
	
	
	/*!
	 * jQuery UI Dialog 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/dialog/
	 */
	
	
	var dialog = $.widget( "ui.dialog", {
		version: "1.11.4",
		options: {
			appendTo: "body",
			autoOpen: true,
			buttons: [],
			closeOnEscape: true,
			closeText: "Close",
			dialogClass: "",
			draggable: true,
			hide: null,
			height: "auto",
			maxHeight: null,
			maxWidth: null,
			minHeight: 150,
			minWidth: 150,
			modal: false,
			position: {
				my: "center",
				at: "center",
				of: window,
				collision: "fit",
				// Ensure the titlebar is always visible
				using: function( pos ) {
					var topOffset = $( this ).css( pos ).offset().top;
					if ( topOffset < 0 ) {
						$( this ).css( "top", pos.top - topOffset );
					}
				}
			},
			resizable: true,
			show: null,
			title: null,
			width: 300,
	
			// callbacks
			beforeClose: null,
			close: null,
			drag: null,
			dragStart: null,
			dragStop: null,
			focus: null,
			open: null,
			resize: null,
			resizeStart: null,
			resizeStop: null
		},
	
		sizeRelatedOptions: {
			buttons: true,
			height: true,
			maxHeight: true,
			maxWidth: true,
			minHeight: true,
			minWidth: true,
			width: true
		},
	
		resizableRelatedOptions: {
			maxHeight: true,
			maxWidth: true,
			minHeight: true,
			minWidth: true
		},
	
		_create: function() {
			this.originalCss = {
				display: this.element[ 0 ].style.display,
				width: this.element[ 0 ].style.width,
				minHeight: this.element[ 0 ].style.minHeight,
				maxHeight: this.element[ 0 ].style.maxHeight,
				height: this.element[ 0 ].style.height
			};
			this.originalPosition = {
				parent: this.element.parent(),
				index: this.element.parent().children().index( this.element )
			};
			this.originalTitle = this.element.attr( "title" );
			this.options.title = this.options.title || this.originalTitle;
	
			this._createWrapper();
	
			this.element
				.show()
				.removeAttr( "title" )
				.addClass( "ui-dialog-content ui-widget-content" )
				.appendTo( this.uiDialog );
	
			this._createTitlebar();
			this._createButtonPane();
	
			if ( this.options.draggable && $.fn.draggable ) {
				this._makeDraggable();
			}
			if ( this.options.resizable && $.fn.resizable ) {
				this._makeResizable();
			}
	
			this._isOpen = false;
	
			this._trackFocus();
		},
	
		_init: function() {
			if ( this.options.autoOpen ) {
				this.open();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
			if ( element && (element.jquery || element.nodeType) ) {
				return $( element );
			}
			return this.document.find( element || "body" ).eq( 0 );
		},
	
		_destroy: function() {
			var next,
				originalPosition = this.originalPosition;
	
			this._untrackInstance();
			this._destroyOverlay();
	
			this.element
				.removeUniqueId()
				.removeClass( "ui-dialog-content ui-widget-content" )
				.css( this.originalCss )
				// Without detaching first, the following becomes really slow
				.detach();
	
			this.uiDialog.stop( true, true ).remove();
	
			if ( this.originalTitle ) {
				this.element.attr( "title", this.originalTitle );
			}
	
			next = originalPosition.parent.children().eq( originalPosition.index );
			// Don't try to place the dialog next to itself (#8613)
			if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
				next.before( this.element );
			} else {
				originalPosition.parent.append( this.element );
			}
		},
	
		widget: function() {
			return this.uiDialog;
		},
	
		disable: $.noop,
		enable: $.noop,
	
		close: function( event ) {
			var activeElement,
				that = this;
	
			if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
				return;
			}
	
			this._isOpen = false;
			this._focusedElement = null;
			this._destroyOverlay();
			this._untrackInstance();
	
			if ( !this.opener.filter( ":focusable" ).focus().length ) {
	
				// support: IE9
				// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
				try {
					activeElement = this.document[ 0 ].activeElement;
	
					// Support: IE9, IE10
					// If the <body> is blurred, IE will switch windows, see #4520
					if ( activeElement && activeElement.nodeName.toLowerCase() !== "body" ) {
	
						// Hiding a focused element doesn't trigger blur in WebKit
						// so in case we have nothing to focus on, explicitly blur the active element
						// https://bugs.webkit.org/show_bug.cgi?id=47182
						$( activeElement ).blur();
					}
				} catch ( error ) {}
			}
	
			this._hide( this.uiDialog, this.options.hide, function() {
				that._trigger( "close", event );
			});
		},
	
		isOpen: function() {
			return this._isOpen;
		},
	
		moveToTop: function() {
			this._moveToTop();
		},
	
		_moveToTop: function( event, silent ) {
			var moved = false,
				zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map(function() {
					return +$( this ).css( "z-index" );
				}).get(),
				zIndexMax = Math.max.apply( null, zIndices );
	
			if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
				this.uiDialog.css( "z-index", zIndexMax + 1 );
				moved = true;
			}
	
			if ( moved && !silent ) {
				this._trigger( "focus", event );
			}
			return moved;
		},
	
		open: function() {
			var that = this;
			if ( this._isOpen ) {
				if ( this._moveToTop() ) {
					this._focusTabbable();
				}
				return;
			}
	
			this._isOpen = true;
			this.opener = $( this.document[ 0 ].activeElement );
	
			this._size();
			this._position();
			this._createOverlay();
			this._moveToTop( null, true );
	
			// Ensure the overlay is moved to the top with the dialog, but only when
			// opening. The overlay shouldn't move after the dialog is open so that
			// modeless dialogs opened after the modal dialog stack properly.
			if ( this.overlay ) {
				this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
			}
	
			this._show( this.uiDialog, this.options.show, function() {
				that._focusTabbable();
				that._trigger( "focus" );
			});
	
			// Track the dialog immediately upon openening in case a focus event
			// somehow occurs outside of the dialog before an element inside the
			// dialog is focused (#10152)
			this._makeFocusTarget();
	
			this._trigger( "open" );
		},
	
		_focusTabbable: function() {
			// Set focus to the first match:
			// 1. An element that was focused previously
			// 2. First element inside the dialog matching [autofocus]
			// 3. Tabbable element inside the content element
			// 4. Tabbable element inside the buttonpane
			// 5. The close button
			// 6. The dialog itself
			var hasFocus = this._focusedElement;
			if ( !hasFocus ) {
				hasFocus = this.element.find( "[autofocus]" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.element.find( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
			}
			if ( !hasFocus.length ) {
				hasFocus = this.uiDialog;
			}
			hasFocus.eq( 0 ).focus();
		},
	
		_keepFocus: function( event ) {
			function checkFocus() {
				var activeElement = this.document[0].activeElement,
					isActive = this.uiDialog[0] === activeElement ||
						$.contains( this.uiDialog[0], activeElement );
				if ( !isActive ) {
					this._focusTabbable();
				}
			}
			event.preventDefault();
			checkFocus.call( this );
			// support: IE
			// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
			// so we check again later
			this._delay( checkFocus );
		},
	
		_createWrapper: function() {
			this.uiDialog = $("<div>")
				.addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
					this.options.dialogClass )
				.hide()
				.attr({
					// Setting tabIndex makes the div focusable
					tabIndex: -1,
					role: "dialog"
				})
				.appendTo( this._appendTo() );
	
			this._on( this.uiDialog, {
				keydown: function( event ) {
					if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
							event.keyCode === $.ui.keyCode.ESCAPE ) {
						event.preventDefault();
						this.close( event );
						return;
					}
	
					// prevent tabbing out of dialogs
					if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
						return;
					}
					var tabbables = this.uiDialog.find( ":tabbable" ),
						first = tabbables.filter( ":first" ),
						last = tabbables.filter( ":last" );
	
					if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
						this._delay(function() {
							first.focus();
						});
						event.preventDefault();
					} else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
						this._delay(function() {
							last.focus();
						});
						event.preventDefault();
					}
				},
				mousedown: function( event ) {
					if ( this._moveToTop( event ) ) {
						this._focusTabbable();
					}
				}
			});
	
			// We assume that any existing aria-describedby attribute means
			// that the dialog content is marked up properly
			// otherwise we brute force the content as the description
			if ( !this.element.find( "[aria-describedby]" ).length ) {
				this.uiDialog.attr({
					"aria-describedby": this.element.uniqueId().attr( "id" )
				});
			}
		},
	
		_createTitlebar: function() {
			var uiDialogTitle;
	
			this.uiDialogTitlebar = $( "<div>" )
				.addClass( "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" )
				.prependTo( this.uiDialog );
			this._on( this.uiDialogTitlebar, {
				mousedown: function( event ) {
					// Don't prevent click on close button (#8838)
					// Focusing a dialog that is partially scrolled out of view
					// causes the browser to scroll it into view, preventing the click event
					if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
						// Dialog isn't getting focus when dragging (#8063)
						this.uiDialog.focus();
					}
				}
			});
	
			// support: IE
			// Use type="button" to prevent enter keypresses in textboxes from closing the
			// dialog in IE (#9312)
			this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
				.button({
					label: this.options.closeText,
					icons: {
						primary: "ui-icon-closethick"
					},
					text: false
				})
				.addClass( "ui-dialog-titlebar-close" )
				.appendTo( this.uiDialogTitlebar );
			this._on( this.uiDialogTitlebarClose, {
				click: function( event ) {
					event.preventDefault();
					this.close( event );
				}
			});
	
			uiDialogTitle = $( "<span>" )
				.uniqueId()
				.addClass( "ui-dialog-title" )
				.prependTo( this.uiDialogTitlebar );
			this._title( uiDialogTitle );
	
			this.uiDialog.attr({
				"aria-labelledby": uiDialogTitle.attr( "id" )
			});
		},
	
		_title: function( title ) {
			if ( !this.options.title ) {
				title.html( "&#160;" );
			}
			title.text( this.options.title );
		},
	
		_createButtonPane: function() {
			this.uiDialogButtonPane = $( "<div>" )
				.addClass( "ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" );
	
			this.uiButtonSet = $( "<div>" )
				.addClass( "ui-dialog-buttonset" )
				.appendTo( this.uiDialogButtonPane );
	
			this._createButtons();
		},
	
		_createButtons: function() {
			var that = this,
				buttons = this.options.buttons;
	
			// if we already have a button pane, remove it
			this.uiDialogButtonPane.remove();
			this.uiButtonSet.empty();
	
			if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
				this.uiDialog.removeClass( "ui-dialog-buttons" );
				return;
			}
	
			$.each( buttons, function( name, props ) {
				var click, buttonOptions;
				props = $.isFunction( props ) ?
					{ click: props, text: name } :
					props;
				// Default to a non-submitting button
				props = $.extend( { type: "button" }, props );
				// Change the context for the click callback to be the main element
				click = props.click;
				props.click = function() {
					click.apply( that.element[ 0 ], arguments );
				};
				buttonOptions = {
					icons: props.icons,
					text: props.showText
				};
				delete props.icons;
				delete props.showText;
				$( "<button></button>", props )
					.button( buttonOptions )
					.appendTo( that.uiButtonSet );
			});
			this.uiDialog.addClass( "ui-dialog-buttons" );
			this.uiDialogButtonPane.appendTo( this.uiDialog );
		},
	
		_makeDraggable: function() {
			var that = this,
				options = this.options;
	
			function filteredUi( ui ) {
				return {
					position: ui.position,
					offset: ui.offset
				};
			}
	
			this.uiDialog.draggable({
				cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
				handle: ".ui-dialog-titlebar",
				containment: "document",
				start: function( event, ui ) {
					$( this ).addClass( "ui-dialog-dragging" );
					that._blockFrames();
					that._trigger( "dragStart", event, filteredUi( ui ) );
				},
				drag: function( event, ui ) {
					that._trigger( "drag", event, filteredUi( ui ) );
				},
				stop: function( event, ui ) {
					var left = ui.offset.left - that.document.scrollLeft(),
						top = ui.offset.top - that.document.scrollTop();
	
					options.position = {
						my: "left top",
						at: "left" + (left >= 0 ? "+" : "") + left + " " +
							"top" + (top >= 0 ? "+" : "") + top,
						of: that.window
					};
					$( this ).removeClass( "ui-dialog-dragging" );
					that._unblockFrames();
					that._trigger( "dragStop", event, filteredUi( ui ) );
				}
			});
		},
	
		_makeResizable: function() {
			var that = this,
				options = this.options,
				handles = options.resizable,
				// .ui-resizable has position: relative defined in the stylesheet
				// but dialogs have to use absolute or fixed positioning
				position = this.uiDialog.css("position"),
				resizeHandles = typeof handles === "string" ?
					handles	:
					"n,e,s,w,se,sw,ne,nw";
	
			function filteredUi( ui ) {
				return {
					originalPosition: ui.originalPosition,
					originalSize: ui.originalSize,
					position: ui.position,
					size: ui.size
				};
			}
	
			this.uiDialog.resizable({
				cancel: ".ui-dialog-content",
				containment: "document",
				alsoResize: this.element,
				maxWidth: options.maxWidth,
				maxHeight: options.maxHeight,
				minWidth: options.minWidth,
				minHeight: this._minHeight(),
				handles: resizeHandles,
				start: function( event, ui ) {
					$( this ).addClass( "ui-dialog-resizing" );
					that._blockFrames();
					that._trigger( "resizeStart", event, filteredUi( ui ) );
				},
				resize: function( event, ui ) {
					that._trigger( "resize", event, filteredUi( ui ) );
				},
				stop: function( event, ui ) {
					var offset = that.uiDialog.offset(),
						left = offset.left - that.document.scrollLeft(),
						top = offset.top - that.document.scrollTop();
	
					options.height = that.uiDialog.height();
					options.width = that.uiDialog.width();
					options.position = {
						my: "left top",
						at: "left" + (left >= 0 ? "+" : "") + left + " " +
							"top" + (top >= 0 ? "+" : "") + top,
						of: that.window
					};
					$( this ).removeClass( "ui-dialog-resizing" );
					that._unblockFrames();
					that._trigger( "resizeStop", event, filteredUi( ui ) );
				}
			})
			.css( "position", position );
		},
	
		_trackFocus: function() {
			this._on( this.widget(), {
				focusin: function( event ) {
					this._makeFocusTarget();
					this._focusedElement = $( event.target );
				}
			});
		},
	
		_makeFocusTarget: function() {
			this._untrackInstance();
			this._trackingInstances().unshift( this );
		},
	
		_untrackInstance: function() {
			var instances = this._trackingInstances(),
				exists = $.inArray( this, instances );
			if ( exists !== -1 ) {
				instances.splice( exists, 1 );
			}
		},
	
		_trackingInstances: function() {
			var instances = this.document.data( "ui-dialog-instances" );
			if ( !instances ) {
				instances = [];
				this.document.data( "ui-dialog-instances", instances );
			}
			return instances;
		},
	
		_minHeight: function() {
			var options = this.options;
	
			return options.height === "auto" ?
				options.minHeight :
				Math.min( options.minHeight, options.height );
		},
	
		_position: function() {
			// Need to show the dialog to get the actual offset in the position plugin
			var isVisible = this.uiDialog.is( ":visible" );
			if ( !isVisible ) {
				this.uiDialog.show();
			}
			this.uiDialog.position( this.options.position );
			if ( !isVisible ) {
				this.uiDialog.hide();
			}
		},
	
		_setOptions: function( options ) {
			var that = this,
				resize = false,
				resizableOptions = {};
	
			$.each( options, function( key, value ) {
				that._setOption( key, value );
	
				if ( key in that.sizeRelatedOptions ) {
					resize = true;
				}
				if ( key in that.resizableRelatedOptions ) {
					resizableOptions[ key ] = value;
				}
			});
	
			if ( resize ) {
				this._size();
				this._position();
			}
			if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
				this.uiDialog.resizable( "option", resizableOptions );
			}
		},
	
		_setOption: function( key, value ) {
			var isDraggable, isResizable,
				uiDialog = this.uiDialog;
	
			if ( key === "dialogClass" ) {
				uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
	
			if ( key === "disabled" ) {
				return;
			}
	
			this._super( key, value );
	
			if ( key === "appendTo" ) {
				this.uiDialog.appendTo( this._appendTo() );
			}
	
			if ( key === "buttons" ) {
				this._createButtons();
			}
	
			if ( key === "closeText" ) {
				this.uiDialogTitlebarClose.button({
					// Ensure that we always pass a string
					label: "" + value
				});
			}
	
			if ( key === "draggable" ) {
				isDraggable = uiDialog.is( ":data(ui-draggable)" );
				if ( isDraggable && !value ) {
					uiDialog.draggable( "destroy" );
				}
	
				if ( !isDraggable && value ) {
					this._makeDraggable();
				}
			}
	
			if ( key === "position" ) {
				this._position();
			}
	
			if ( key === "resizable" ) {
				// currently resizable, becoming non-resizable
				isResizable = uiDialog.is( ":data(ui-resizable)" );
				if ( isResizable && !value ) {
					uiDialog.resizable( "destroy" );
				}
	
				// currently resizable, changing handles
				if ( isResizable && typeof value === "string" ) {
					uiDialog.resizable( "option", "handles", value );
				}
	
				// currently non-resizable, becoming resizable
				if ( !isResizable && value !== false ) {
					this._makeResizable();
				}
			}
	
			if ( key === "title" ) {
				this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
			}
		},
	
		_size: function() {
			// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
			// divs will both have width and height set, so we need to reset them
			var nonContentHeight, minContentHeight, maxContentHeight,
				options = this.options;
	
			// Reset content sizing
			this.element.show().css({
				width: "auto",
				minHeight: 0,
				maxHeight: "none",
				height: 0
			});
	
			if ( options.minWidth > options.width ) {
				options.width = options.minWidth;
			}
	
			// reset wrapper sizing
			// determine the height of all the non-content elements
			nonContentHeight = this.uiDialog.css({
					height: "auto",
					width: options.width
				})
				.outerHeight();
			minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
			maxContentHeight = typeof options.maxHeight === "number" ?
				Math.max( 0, options.maxHeight - nonContentHeight ) :
				"none";
	
			if ( options.height === "auto" ) {
				this.element.css({
					minHeight: minContentHeight,
					maxHeight: maxContentHeight,
					height: "auto"
				});
			} else {
				this.element.height( Math.max( 0, options.height - nonContentHeight ) );
			}
	
			if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
				this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
			}
		},
	
		_blockFrames: function() {
			this.iframeBlocks = this.document.find( "iframe" ).map(function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css({
						position: "absolute",
						width: iframe.outerWidth(),
						height: iframe.outerHeight()
					})
					.appendTo( iframe.parent() )
					.offset( iframe.offset() )[0];
			});
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_allowInteraction: function( event ) {
			if ( $( event.target ).closest( ".ui-dialog" ).length ) {
				return true;
			}
	
			// TODO: Remove hack when datepicker implements
			// the .ui-front logic (#8989)
			return !!$( event.target ).closest( ".ui-datepicker" ).length;
		},
	
		_createOverlay: function() {
			if ( !this.options.modal ) {
				return;
			}
	
			// We use a delay in case the overlay is created from an
			// event that we're going to be cancelling (#2804)
			var isOpening = true;
			this._delay(function() {
				isOpening = false;
			});
	
			if ( !this.document.data( "ui-dialog-overlays" ) ) {
	
				// Prevent use of anchors and inputs
				// Using _on() for an event handler shared across many instances is
				// safe because the dialogs stack and must be closed in reverse order
				this._on( this.document, {
					focusin: function( event ) {
						if ( isOpening ) {
							return;
						}
	
						if ( !this._allowInteraction( event ) ) {
							event.preventDefault();
							this._trackingInstances()[ 0 ]._focusTabbable();
						}
					}
				});
			}
	
			this.overlay = $( "<div>" )
				.addClass( "ui-widget-overlay ui-front" )
				.appendTo( this._appendTo() );
			this._on( this.overlay, {
				mousedown: "_keepFocus"
			});
			this.document.data( "ui-dialog-overlays",
				(this.document.data( "ui-dialog-overlays" ) || 0) + 1 );
		},
	
		_destroyOverlay: function() {
			if ( !this.options.modal ) {
				return;
			}
	
			if ( this.overlay ) {
				var overlays = this.document.data( "ui-dialog-overlays" ) - 1;
	
				if ( !overlays ) {
					this.document
						.unbind( "focusin" )
						.removeData( "ui-dialog-overlays" );
				} else {
					this.document.data( "ui-dialog-overlays", overlays );
				}
	
				this.overlay.remove();
				this.overlay = null;
			}
		}
	});
	
	
	/*!
	 * jQuery UI Droppable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/droppable/
	 */
	
	
	$.widget( "ui.droppable", {
		version: "1.11.4",
		widgetEventPrefix: "drop",
		options: {
			accept: "*",
			activeClass: false,
			addClasses: true,
			greedy: false,
			hoverClass: false,
			scope: "default",
			tolerance: "intersect",
	
			// callbacks
			activate: null,
			deactivate: null,
			drop: null,
			out: null,
			over: null
		},
		_create: function() {
	
			var proportions,
				o = this.options,
				accept = o.accept;
	
			this.isover = false;
			this.isout = true;
	
			this.accept = $.isFunction( accept ) ? accept : function( d ) {
				return d.is( accept );
			};
	
			this.proportions = function( /* valueToWrite */ ) {
				if ( arguments.length ) {
					// Store the droppable's proportions
					proportions = arguments[ 0 ];
				} else {
					// Retrieve or derive the droppable's proportions
					return proportions ?
						proportions :
						proportions = {
							width: this.element[ 0 ].offsetWidth,
							height: this.element[ 0 ].offsetHeight
						};
				}
			};
	
			this._addToManager( o.scope );
	
			o.addClasses && this.element.addClass( "ui-droppable" );
	
		},
	
		_addToManager: function( scope ) {
			// Add the reference and positions to the manager
			$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
			$.ui.ddmanager.droppables[ scope ].push( this );
		},
	
		_splice: function( drop ) {
			var i = 0;
			for ( ; i < drop.length; i++ ) {
				if ( drop[ i ] === this ) {
					drop.splice( i, 1 );
				}
			}
		},
	
		_destroy: function() {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
			this._splice( drop );
	
			this.element.removeClass( "ui-droppable ui-droppable-disabled" );
		},
	
		_setOption: function( key, value ) {
	
			if ( key === "accept" ) {
				this.accept = $.isFunction( value ) ? value : function( d ) {
					return d.is( value );
				};
			} else if ( key === "scope" ) {
				var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
				this._splice( drop );
				this._addToManager( value );
			}
	
			this._super( key, value );
		},
	
		_activate: function( event ) {
			var draggable = $.ui.ddmanager.current;
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
			if ( draggable ){
				this._trigger( "activate", event, this.ui( draggable ) );
			}
		},
	
		_deactivate: function( event ) {
			var draggable = $.ui.ddmanager.current;
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
			if ( draggable ){
				this._trigger( "deactivate", event, this.ui( draggable ) );
			}
		},
	
		_over: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.hoverClass ) {
					this.element.addClass( this.options.hoverClass );
				}
				this._trigger( "over", event, this.ui( draggable ) );
			}
	
		},
	
		_out: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
				this._trigger( "out", event, this.ui( draggable ) );
			}
	
		},
	
		_drop: function( event, custom ) {
	
			var draggable = custom || $.ui.ddmanager.current,
				childrenIntersection = false;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return false;
			}
	
			this.element.find( ":data(ui-droppable)" ).not( ".ui-draggable-dragging" ).each(function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call( inst.element[ 0 ], ( draggable.currentItem || draggable.element ) ) &&
					$.ui.intersect( draggable, $.extend( inst, { offset: inst.element.offset() } ), inst.options.tolerance, event )
				) { childrenIntersection = true; return false; }
			});
			if ( childrenIntersection ) {
				return false;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				if ( this.options.activeClass ) {
					this.element.removeClass( this.options.activeClass );
				}
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
				this._trigger( "drop", event, this.ui( draggable ) );
				return this.element;
			}
	
			return false;
	
		},
	
		ui: function( c ) {
			return {
				draggable: ( c.currentItem || c.element ),
				helper: c.helper,
				position: c.position,
				offset: c.positionAbs
			};
		}
	
	});
	
	$.ui.intersect = (function() {
		function isOverAxis( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		}
	
		return function( draggable, droppable, toleranceMode, event ) {
	
			if ( !droppable.offset ) {
				return false;
			}
	
			var x1 = ( draggable.positionAbs || draggable.position.absolute ).left + draggable.margins.left,
				y1 = ( draggable.positionAbs || draggable.position.absolute ).top + draggable.margins.top,
				x2 = x1 + draggable.helperProportions.width,
				y2 = y1 + draggable.helperProportions.height,
				l = droppable.offset.left,
				t = droppable.offset.top,
				r = l + droppable.proportions().width,
				b = t + droppable.proportions().height;
	
			switch ( toleranceMode ) {
			case "fit":
				return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
			case "intersect":
				return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
					x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
			case "pointer":
				return isOverAxis( event.pageY, t, droppable.proportions().height ) && isOverAxis( event.pageX, l, droppable.proportions().width );
			case "touch":
				return (
					( y1 >= t && y1 <= b ) || // Top edge touching
					( y2 >= t && y2 <= b ) || // Bottom edge touching
					( y1 < t && y2 > b ) // Surrounded vertically
				) && (
					( x1 >= l && x1 <= r ) || // Left edge touching
					( x2 >= l && x2 <= r ) || // Right edge touching
					( x1 < l && x2 > r ) // Surrounded horizontally
				);
			default:
				return false;
			}
		};
	})();
	
	/*
		This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
		current: null,
		droppables: { "default": [] },
		prepareOffsets: function( t, event ) {
	
			var i, j,
				m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
				type = event ? event.type : null, // workaround for #2317
				list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();
	
			droppablesLoop: for ( i = 0; i < m.length; i++ ) {
	
				// No disabled and non-accepted
				if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ], ( t.currentItem || t.element ) ) ) ) {
					continue;
				}
	
				// Filter out elements in the current dragged item
				for ( j = 0; j < list.length; j++ ) {
					if ( list[ j ] === m[ i ].element[ 0 ] ) {
						m[ i ].proportions().height = 0;
						continue droppablesLoop;
					}
				}
	
				m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
				if ( !m[ i ].visible ) {
					continue;
				}
	
				// Activate the droppable if used directly from draggables
				if ( type === "mousedown" ) {
					m[ i ]._activate.call( m[ i ], event );
				}
	
				m[ i ].offset = m[ i ].element.offset();
				m[ i ].proportions({ width: m[ i ].element[ 0 ].offsetWidth, height: m[ i ].element[ 0 ].offsetHeight });
	
			}
	
		},
		drop: function( draggable, event ) {
	
			var dropped = false;
			// Create a copy of the droppables in case the list changes during the drop (#9116)
			$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {
	
				if ( !this.options ) {
					return;
				}
				if ( !this.options.disabled && this.visible && $.ui.intersect( draggable, this, this.options.tolerance, event ) ) {
					dropped = this._drop.call( this, event ) || dropped;
				}
	
				if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
					this.isout = true;
					this.isover = false;
					this._deactivate.call( this, event );
				}
	
			});
			return dropped;
	
		},
		dragStart: function( draggable, event ) {
			// Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
			draggable.element.parentsUntil( "body" ).bind( "scroll.droppable", function() {
				if ( !draggable.options.refreshPositions ) {
					$.ui.ddmanager.prepareOffsets( draggable, event );
				}
			});
		},
		drag: function( draggable, event ) {
	
			// If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
			if ( draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
	
			// Run through all droppables and check their positions based on specific tolerance options
			$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {
	
				if ( this.options.disabled || this.greedyChild || !this.visible ) {
					return;
				}
	
				var parentInstance, scope, parent,
					intersects = $.ui.intersect( draggable, this, this.options.tolerance, event ),
					c = !intersects && this.isover ? "isout" : ( intersects && !this.isover ? "isover" : null );
				if ( !c ) {
					return;
				}
	
				if ( this.options.greedy ) {
					// find droppable parents with same scope
					scope = this.options.scope;
					parent = this.element.parents( ":data(ui-droppable)" ).filter(function() {
						return $( this ).droppable( "instance" ).options.scope === scope;
					});
	
					if ( parent.length ) {
						parentInstance = $( parent[ 0 ] ).droppable( "instance" );
						parentInstance.greedyChild = ( c === "isover" );
					}
				}
	
				// we just moved into a greedy child
				if ( parentInstance && c === "isover" ) {
					parentInstance.isover = false;
					parentInstance.isout = true;
					parentInstance._out.call( parentInstance, event );
				}
	
				this[ c ] = true;
				this[c === "isout" ? "isover" : "isout"] = false;
				this[c === "isover" ? "_over" : "_out"].call( this, event );
	
				// we just moved out of a greedy child
				if ( parentInstance && c === "isout" ) {
					parentInstance.isout = false;
					parentInstance.isover = true;
					parentInstance._over.call( parentInstance, event );
				}
			});
	
		},
		dragStop: function( draggable, event ) {
			draggable.element.parentsUntil( "body" ).unbind( "scroll.droppable" );
			// Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		}
	};
	
	var droppable = $.ui.droppable;
	
	
	/*!
	 * jQuery UI Effects 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/effects-core/
	 */
	
	
	var dataSpace = "ui-effects-",
	
		// Create a local jQuery because jQuery Color relies on it and the
		// global may not exist with AMD and a custom build (#10199)
		jQuery = $;
	
	$.effects = {
		effect: {}
	};
	
	/*!
	 * jQuery Color Animations v2.1.2
	 * https://github.com/jquery/jquery-color
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * Date: Wed Jan 16 08:47:09 2013 -0600
	 */
	(function( jQuery, undefined ) {
	
		var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
	
		// plusequals test for += 100 -= 100
		rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
		// a set of RE's that can match strings and generate color tuples.
		stringParsers = [ {
				re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ],
						execResult[ 3 ],
						execResult[ 4 ]
					];
				}
			}, {
				re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ] * 2.55,
						execResult[ 2 ] * 2.55,
						execResult[ 3 ] * 2.55,
						execResult[ 4 ]
					];
				}
			}, {
				// this regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ], 16 )
					];
				}
			}, {
				// this regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				space: "hsla",
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ] / 100,
						execResult[ 3 ] / 100,
						execResult[ 4 ]
					];
				}
			} ],
	
		// jQuery.Color( )
		color = jQuery.Color = function( color, green, blue, alpha ) {
			return new jQuery.Color.fn.parse( color, green, blue, alpha );
		},
		spaces = {
			rgba: {
				props: {
					red: {
						idx: 0,
						type: "byte"
					},
					green: {
						idx: 1,
						type: "byte"
					},
					blue: {
						idx: 2,
						type: "byte"
					}
				}
			},
	
			hsla: {
				props: {
					hue: {
						idx: 0,
						type: "degrees"
					},
					saturation: {
						idx: 1,
						type: "percent"
					},
					lightness: {
						idx: 2,
						type: "percent"
					}
				}
			}
		},
		propTypes = {
			"byte": {
				floor: true,
				max: 255
			},
			"percent": {
				max: 1
			},
			"degrees": {
				mod: 360,
				floor: true
			}
		},
		support = color.support = {},
	
		// element for support tests
		supportElem = jQuery( "<p>" )[ 0 ],
	
		// colors = jQuery.Color.names
		colors,
	
		// local aliases of functions called often
		each = jQuery.each;
	
	// determine rgba support immediately
	supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
	support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;
	
	// define cache name and alpha properties
	// for rgba and hsla spaces
	each( spaces, function( spaceName, space ) {
		space.cache = "_" + spaceName;
		space.props.alpha = {
			idx: 3,
			type: "percent",
			def: 1
		};
	});
	
	function clamp( value, prop, allowEmpty ) {
		var type = propTypes[ prop.type ] || {};
	
		if ( value == null ) {
			return (allowEmpty || !prop.def) ? null : prop.def;
		}
	
		// ~~ is an short way of doing floor for positive numbers
		value = type.floor ? ~~value : parseFloat( value );
	
		// IE will pass in empty strings as value for alpha,
		// which will hit this case
		if ( isNaN( value ) ) {
			return prop.def;
		}
	
		if ( type.mod ) {
			// we add mod before modding to make sure that negatives values
			// get converted properly: -10 -> 350
			return (value + type.mod) % type.mod;
		}
	
		// for now all property types without mod have min and max
		return 0 > value ? 0 : type.max < value ? type.max : value;
	}
	
	function stringParse( string ) {
		var inst = color(),
			rgba = inst._rgba = [];
	
		string = string.toLowerCase();
	
		each( stringParsers, function( i, parser ) {
			var parsed,
				match = parser.re.exec( string ),
				values = match && parser.parse( match ),
				spaceName = parser.space || "rgba";
	
			if ( values ) {
				parsed = inst[ spaceName ]( values );
	
				// if this was an rgba parse the assignment might happen twice
				// oh well....
				inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
				rgba = inst._rgba = parsed._rgba;
	
				// exit each( stringParsers ) here because we matched
				return false;
			}
		});
	
		// Found a stringParser that handled it
		if ( rgba.length ) {
	
			// if this came from a parsed string, force "transparent" when alpha is 0
			// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
			if ( rgba.join() === "0,0,0,0" ) {
				jQuery.extend( rgba, colors.transparent );
			}
			return inst;
		}
	
		// named colors
		return colors[ string ];
	}
	
	color.fn = jQuery.extend( color.prototype, {
		parse: function( red, green, blue, alpha ) {
			if ( red === undefined ) {
				this._rgba = [ null, null, null, null ];
				return this;
			}
			if ( red.jquery || red.nodeType ) {
				red = jQuery( red ).css( green );
				green = undefined;
			}
	
			var inst = this,
				type = jQuery.type( red ),
				rgba = this._rgba = [];
	
			// more than 1 argument specified - assume ( red, green, blue, alpha )
			if ( green !== undefined ) {
				red = [ red, green, blue, alpha ];
				type = "array";
			}
	
			if ( type === "string" ) {
				return this.parse( stringParse( red ) || colors._default );
			}
	
			if ( type === "array" ) {
				each( spaces.rgba.props, function( key, prop ) {
					rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
				});
				return this;
			}
	
			if ( type === "object" ) {
				if ( red instanceof color ) {
					each( spaces, function( spaceName, space ) {
						if ( red[ space.cache ] ) {
							inst[ space.cache ] = red[ space.cache ].slice();
						}
					});
				} else {
					each( spaces, function( spaceName, space ) {
						var cache = space.cache;
						each( space.props, function( key, prop ) {
	
							// if the cache doesn't exist, and we know how to convert
							if ( !inst[ cache ] && space.to ) {
	
								// if the value was null, we don't need to copy it
								// if the key was alpha, we don't need to copy it either
								if ( key === "alpha" || red[ key ] == null ) {
									return;
								}
								inst[ cache ] = space.to( inst._rgba );
							}
	
							// this is the only case where we allow nulls for ALL properties.
							// call clamp with alwaysAllowEmpty
							inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
						});
	
						// everything defined but alpha?
						if ( inst[ cache ] && jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
							// use the default of 1
							inst[ cache ][ 3 ] = 1;
							if ( space.from ) {
								inst._rgba = space.from( inst[ cache ] );
							}
						}
					});
				}
				return this;
			}
		},
		is: function( compare ) {
			var is = color( compare ),
				same = true,
				inst = this;
	
			each( spaces, function( _, space ) {
				var localCache,
					isCache = is[ space.cache ];
				if (isCache) {
					localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
					each( space.props, function( _, prop ) {
						if ( isCache[ prop.idx ] != null ) {
							same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
							return same;
						}
					});
				}
				return same;
			});
			return same;
		},
		_space: function() {
			var used = [],
				inst = this;
			each( spaces, function( spaceName, space ) {
				if ( inst[ space.cache ] ) {
					used.push( spaceName );
				}
			});
			return used.pop();
		},
		transition: function( other, distance ) {
			var end = color( other ),
				spaceName = end._space(),
				space = spaces[ spaceName ],
				startColor = this.alpha() === 0 ? color( "transparent" ) : this,
				start = startColor[ space.cache ] || space.to( startColor._rgba ),
				result = start.slice();
	
			end = end[ space.cache ];
			each( space.props, function( key, prop ) {
				var index = prop.idx,
					startValue = start[ index ],
					endValue = end[ index ],
					type = propTypes[ prop.type ] || {};
	
				// if null, don't override start value
				if ( endValue === null ) {
					return;
				}
				// if null - use end
				if ( startValue === null ) {
					result[ index ] = endValue;
				} else {
					if ( type.mod ) {
						if ( endValue - startValue > type.mod / 2 ) {
							startValue += type.mod;
						} else if ( startValue - endValue > type.mod / 2 ) {
							startValue -= type.mod;
						}
					}
					result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
				}
			});
			return this[ spaceName ]( result );
		},
		blend: function( opaque ) {
			// if we are already opaque - return ourself
			if ( this._rgba[ 3 ] === 1 ) {
				return this;
			}
	
			var rgb = this._rgba.slice(),
				a = rgb.pop(),
				blend = color( opaque )._rgba;
	
			return color( jQuery.map( rgb, function( v, i ) {
				return ( 1 - a ) * blend[ i ] + a * v;
			}));
		},
		toRgbaString: function() {
			var prefix = "rgba(",
				rgba = jQuery.map( this._rgba, function( v, i ) {
					return v == null ? ( i > 2 ? 1 : 0 ) : v;
				});
	
			if ( rgba[ 3 ] === 1 ) {
				rgba.pop();
				prefix = "rgb(";
			}
	
			return prefix + rgba.join() + ")";
		},
		toHslaString: function() {
			var prefix = "hsla(",
				hsla = jQuery.map( this.hsla(), function( v, i ) {
					if ( v == null ) {
						v = i > 2 ? 1 : 0;
					}
	
					// catch 1 and 2
					if ( i && i < 3 ) {
						v = Math.round( v * 100 ) + "%";
					}
					return v;
				});
	
			if ( hsla[ 3 ] === 1 ) {
				hsla.pop();
				prefix = "hsl(";
			}
			return prefix + hsla.join() + ")";
		},
		toHexString: function( includeAlpha ) {
			var rgba = this._rgba.slice(),
				alpha = rgba.pop();
	
			if ( includeAlpha ) {
				rgba.push( ~~( alpha * 255 ) );
			}
	
			return "#" + jQuery.map( rgba, function( v ) {
	
				// default to 0 when nulls exist
				v = ( v || 0 ).toString( 16 );
				return v.length === 1 ? "0" + v : v;
			}).join("");
		},
		toString: function() {
			return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
		}
	});
	color.fn.parse.prototype = color.fn;
	
	// hsla conversions adapted from:
	// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
	
	function hue2rgb( p, q, h ) {
		h = ( h + 1 ) % 1;
		if ( h * 6 < 1 ) {
			return p + ( q - p ) * h * 6;
		}
		if ( h * 2 < 1) {
			return q;
		}
		if ( h * 3 < 2 ) {
			return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
		}
		return p;
	}
	
	spaces.hsla.to = function( rgba ) {
		if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
			return [ null, null, null, rgba[ 3 ] ];
		}
		var r = rgba[ 0 ] / 255,
			g = rgba[ 1 ] / 255,
			b = rgba[ 2 ] / 255,
			a = rgba[ 3 ],
			max = Math.max( r, g, b ),
			min = Math.min( r, g, b ),
			diff = max - min,
			add = max + min,
			l = add * 0.5,
			h, s;
	
		if ( min === max ) {
			h = 0;
		} else if ( r === max ) {
			h = ( 60 * ( g - b ) / diff ) + 360;
		} else if ( g === max ) {
			h = ( 60 * ( b - r ) / diff ) + 120;
		} else {
			h = ( 60 * ( r - g ) / diff ) + 240;
		}
	
		// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
		// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
		if ( diff === 0 ) {
			s = 0;
		} else if ( l <= 0.5 ) {
			s = diff / add;
		} else {
			s = diff / ( 2 - add );
		}
		return [ Math.round(h) % 360, s, l, a == null ? 1 : a ];
	};
	
	spaces.hsla.from = function( hsla ) {
		if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
			return [ null, null, null, hsla[ 3 ] ];
		}
		var h = hsla[ 0 ] / 360,
			s = hsla[ 1 ],
			l = hsla[ 2 ],
			a = hsla[ 3 ],
			q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
			p = 2 * l - q;
	
		return [
			Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
			Math.round( hue2rgb( p, q, h ) * 255 ),
			Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
			a
		];
	};
	
	each( spaces, function( spaceName, space ) {
		var props = space.props,
			cache = space.cache,
			to = space.to,
			from = space.from;
	
		// makes rgba() and hsla()
		color.fn[ spaceName ] = function( value ) {
	
			// generate a cache for this space if it doesn't exist
			if ( to && !this[ cache ] ) {
				this[ cache ] = to( this._rgba );
			}
			if ( value === undefined ) {
				return this[ cache ].slice();
			}
	
			var ret,
				type = jQuery.type( value ),
				arr = ( type === "array" || type === "object" ) ? value : arguments,
				local = this[ cache ].slice();
	
			each( props, function( key, prop ) {
				var val = arr[ type === "object" ? key : prop.idx ];
				if ( val == null ) {
					val = local[ prop.idx ];
				}
				local[ prop.idx ] = clamp( val, prop );
			});
	
			if ( from ) {
				ret = color( from( local ) );
				ret[ cache ] = local;
				return ret;
			} else {
				return color( local );
			}
		};
	
		// makes red() green() blue() alpha() hue() saturation() lightness()
		each( props, function( key, prop ) {
			// alpha is included in more than one space
			if ( color.fn[ key ] ) {
				return;
			}
			color.fn[ key ] = function( value ) {
				var vtype = jQuery.type( value ),
					fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
					local = this[ fn ](),
					cur = local[ prop.idx ],
					match;
	
				if ( vtype === "undefined" ) {
					return cur;
				}
	
				if ( vtype === "function" ) {
					value = value.call( this, cur );
					vtype = jQuery.type( value );
				}
				if ( value == null && prop.empty ) {
					return this;
				}
				if ( vtype === "string" ) {
					match = rplusequals.exec( value );
					if ( match ) {
						value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
					}
				}
				local[ prop.idx ] = value;
				return this[ fn ]( local );
			};
		});
	});
	
	// add cssHook and .fx.step function for each named hook.
	// accept a space separated string of properties
	color.hook = function( hook ) {
		var hooks = hook.split( " " );
		each( hooks, function( i, hook ) {
			jQuery.cssHooks[ hook ] = {
				set: function( elem, value ) {
					var parsed, curElem,
						backgroundColor = "";
	
					if ( value !== "transparent" && ( jQuery.type( value ) !== "string" || ( parsed = stringParse( value ) ) ) ) {
						value = color( parsed || value );
						if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
							curElem = hook === "backgroundColor" ? elem.parentNode : elem;
							while (
								(backgroundColor === "" || backgroundColor === "transparent") &&
								curElem && curElem.style
							) {
								try {
									backgroundColor = jQuery.css( curElem, "backgroundColor" );
									curElem = curElem.parentNode;
								} catch ( e ) {
								}
							}
	
							value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
								backgroundColor :
								"_default" );
						}
	
						value = value.toRgbaString();
					}
					try {
						elem.style[ hook ] = value;
					} catch ( e ) {
						// wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
					}
				}
			};
			jQuery.fx.step[ hook ] = function( fx ) {
				if ( !fx.colorInit ) {
					fx.start = color( fx.elem, hook );
					fx.end = color( fx.end );
					fx.colorInit = true;
				}
				jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
			};
		});
	
	};
	
	color.hook( stepHooks );
	
	jQuery.cssHooks.borderColor = {
		expand: function( value ) {
			var expanded = {};
	
			each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
				expanded[ "border" + part + "Color" ] = value;
			});
			return expanded;
		}
	};
	
	// Basic color names only.
	// Usage of any of the other color names requires adding yourself or including
	// jquery.color.svg-names.js.
	colors = jQuery.Color.names = {
		// 4.1. Basic color keywords
		aqua: "#00ffff",
		black: "#000000",
		blue: "#0000ff",
		fuchsia: "#ff00ff",
		gray: "#808080",
		green: "#008000",
		lime: "#00ff00",
		maroon: "#800000",
		navy: "#000080",
		olive: "#808000",
		purple: "#800080",
		red: "#ff0000",
		silver: "#c0c0c0",
		teal: "#008080",
		white: "#ffffff",
		yellow: "#ffff00",
	
		// 4.2.3. "transparent" color keyword
		transparent: [ null, null, null, 0 ],
	
		_default: "#ffffff"
	};
	
	})( jQuery );
	
	/******************************************************************************/
	/****************************** CLASS ANIMATIONS ******************************/
	/******************************************************************************/
	(function() {
	
	var classAnimationActions = [ "add", "remove", "toggle" ],
		shorthandStyles = {
			border: 1,
			borderBottom: 1,
			borderColor: 1,
			borderLeft: 1,
			borderRight: 1,
			borderTop: 1,
			borderWidth: 1,
			margin: 1,
			padding: 1
		};
	
	$.each([ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ], function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	});
	
	function getElementStyles( elem ) {
		var key, len,
			style = elem.ownerDocument.defaultView ?
				elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
				elem.currentStyle,
			styles = {};
	
		if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
			len = style.length;
			while ( len-- ) {
				key = style[ len ];
				if ( typeof style[ key ] === "string" ) {
					styles[ $.camelCase( key ) ] = style[ key ];
				}
			}
		// support: Opera, IE <9
		} else {
			for ( key in style ) {
				if ( typeof style[ key ] === "string" ) {
					styles[ key ] = style[ key ];
				}
			}
		}
	
		return styles;
	}
	
	function styleDifference( oldStyle, newStyle ) {
		var diff = {},
			name, value;
	
		for ( name in newStyle ) {
			value = newStyle[ name ];
			if ( oldStyle[ name ] !== value ) {
				if ( !shorthandStyles[ name ] ) {
					if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
						diff[ name ] = value;
					}
				}
			}
		}
	
		return diff;
	}
	
	// support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	$.effects.animateClass = function( value, duration, easing, callback ) {
		var o = $.speed( duration, easing, callback );
	
		return this.queue( function() {
			var animated = $( this ),
				baseClass = animated.attr( "class" ) || "",
				applyClassChange,
				allAnimations = o.children ? animated.find( "*" ).addBack() : animated;
	
			// map the animated objects to store the original styles.
			allAnimations = allAnimations.map(function() {
				var el = $( this );
				return {
					el: el,
					start: getElementStyles( this )
				};
			});
	
			// apply class change
			applyClassChange = function() {
				$.each( classAnimationActions, function(i, action) {
					if ( value[ action ] ) {
						animated[ action + "Class" ]( value[ action ] );
					}
				});
			};
			applyClassChange();
	
			// map all animated objects again - calculate new styles and diff
			allAnimations = allAnimations.map(function() {
				this.end = getElementStyles( this.el[ 0 ] );
				this.diff = styleDifference( this.start, this.end );
				return this;
			});
	
			// apply original class
			animated.attr( "class", baseClass );
	
			// map all animated objects again - this time collecting a promise
			allAnimations = allAnimations.map(function() {
				var styleInfo = this,
					dfd = $.Deferred(),
					opts = $.extend({}, o, {
						queue: false,
						complete: function() {
							dfd.resolve( styleInfo );
						}
					});
	
				this.el.animate( this.diff, opts );
				return dfd.promise();
			});
	
			// once all animations have completed:
			$.when.apply( $, allAnimations.get() ).done(function() {
	
				// set the final class
				applyClassChange();
	
				// for each animated element,
				// clear all css properties that were animated
				$.each( arguments, function() {
					var el = this.el;
					$.each( this.diff, function(key) {
						el.css( key, "" );
					});
				});
	
				// this is guarnteed to be there if you use jQuery.speed()
				// it also handles dequeuing the next anim...
				o.complete.call( animated[ 0 ] );
			});
		});
	};
	
	$.fn.extend({
		addClass: (function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return speed ?
					$.effects.animateClass.call( this,
						{ add: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		})( $.fn.addClass ),
	
		removeClass: (function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return arguments.length > 1 ?
					$.effects.animateClass.call( this,
						{ remove: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		})( $.fn.removeClass ),
	
		toggleClass: (function( orig ) {
			return function( classNames, force, speed, easing, callback ) {
				if ( typeof force === "boolean" || force === undefined ) {
					if ( !speed ) {
						// without speed parameter
						return orig.apply( this, arguments );
					} else {
						return $.effects.animateClass.call( this,
							(force ? { add: classNames } : { remove: classNames }),
							speed, easing, callback );
					}
				} else {
					// without force parameter
					return $.effects.animateClass.call( this,
						{ toggle: classNames }, force, speed, easing );
				}
			};
		})( $.fn.toggleClass ),
	
		switchClass: function( remove, add, speed, easing, callback) {
			return $.effects.animateClass.call( this, {
				add: add,
				remove: remove
			}, speed, easing, callback );
		}
	});
	
	})();
	
	/******************************************************************************/
	/*********************************** EFFECTS **********************************/
	/******************************************************************************/
	
	(function() {
	
	$.extend( $.effects, {
		version: "1.11.4",
	
		// Saves a set of properties in a data storage
		save: function( element, set ) {
			for ( var i = 0; i < set.length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},
	
		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i;
			for ( i = 0; i < set.length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					// support: jQuery 1.6.2
					// http://bugs.jquery.com/ticket/9917
					// jQuery 1.6.2 incorrectly returns undefined for any falsy value.
					// We can't differentiate between "" and 0 here, so we just assume
					// empty string since it's likely to be a more common value...
					if ( val === undefined ) {
						val = "";
					}
					element.css( set[ i ], val );
				}
			}
		},
	
		setMode: function( el, mode ) {
			if (mode === "toggle") {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},
	
		// Translates a [top,left] array into a baseline value
		// this should be a little more flexible in the future to handle a string & hash
		getBaseline: function( origin, original ) {
			var y, x;
			switch ( origin[ 0 ] ) {
				case "top": y = 0; break;
				case "middle": y = 0.5; break;
				case "bottom": y = 1; break;
				default: y = origin[ 0 ] / original.height;
			}
			switch ( origin[ 1 ] ) {
				case "left": x = 0; break;
				case "center": x = 0.5; break;
				case "right": x = 1; break;
				default: x = origin[ 1 ] / original.width;
			}
			return {
				x: x,
				y: y
			};
		},
	
		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {
	
			// if the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" )) {
				return element.parent();
			}
	
			// wrap the element
			var props = {
					width: element.outerWidth(true),
					height: element.outerHeight(true),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css({
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					}),
				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;
	
			// support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				active.id;
			} catch ( e ) {
				active = document.body;
			}
	
			element.wrap( wrapper );
	
			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).focus();
			}
	
			wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element
	
			// transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css({ position: "relative" });
				element.css({ position: "relative" });
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				});
				$.each([ "top", "left", "bottom", "right" ], function(i, pos) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				});
				element.css({
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				});
			}
			element.css(size);
	
			return wrapper.css( props ).show();
		},
	
		removeWrapper: function( element ) {
			var active = document.activeElement;
	
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );
	
				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).focus();
				}
			}
	
			return element;
		},
	
		setTransition: function( element, list, factor, value ) {
			value = value || {};
			$.each( list, function( i, x ) {
				var unit = element.cssUnit( x );
				if ( unit[ 0 ] > 0 ) {
					value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
				}
			});
			return value;
		}
	});
	
	// return an effect options object for the given parameters:
	function _normalizeArguments( effect, options, speed, callback ) {
	
		// allow passing all options as the first parameter
		if ( $.isPlainObject( effect ) ) {
			options = effect;
			effect = effect.effect;
		}
	
		// convert to an object
		effect = { effect: effect };
	
		// catch (effect, null, ...)
		if ( options == null ) {
			options = {};
		}
	
		// catch (effect, callback)
		if ( $.isFunction( options ) ) {
			callback = options;
			speed = null;
			options = {};
		}
	
		// catch (effect, speed, ?)
		if ( typeof options === "number" || $.fx.speeds[ options ] ) {
			callback = speed;
			speed = options;
			options = {};
		}
	
		// catch (effect, options, callback)
		if ( $.isFunction( speed ) ) {
			callback = speed;
			speed = null;
		}
	
		// add options to effect
		if ( options ) {
			$.extend( effect, options );
		}
	
		speed = speed || options.duration;
		effect.duration = $.fx.off ? 0 :
			typeof speed === "number" ? speed :
			speed in $.fx.speeds ? $.fx.speeds[ speed ] :
			$.fx.speeds._default;
	
		effect.complete = callback || options.complete;
	
		return effect;
	}
	
	function standardAnimationOption( option ) {
		// Valid standard speeds (nothing, number, named speed)
		if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
			return true;
		}
	
		// Invalid strings - treat as "normal" speed
		if ( typeof option === "string" && !$.effects.effect[ option ] ) {
			return true;
		}
	
		// Complete callback
		if ( $.isFunction( option ) ) {
			return true;
		}
	
		// Options hash (but not naming an effect)
		if ( typeof option === "object" && !option.effect ) {
			return true;
		}
	
		// Didn't match any standard API
		return false;
	}
	
	$.fn.extend({
		effect: function( /* effect, options, speed, callback */ ) {
			var args = _normalizeArguments.apply( this, arguments ),
				mode = args.mode,
				queue = args.queue,
				effectMethod = $.effects.effect[ args.effect ];
	
			if ( $.fx.off || !effectMethod ) {
				// delegate to the original method (e.g., .show()) if possible
				if ( mode ) {
					return this[ mode ]( args.duration, args.complete );
				} else {
					return this.each( function() {
						if ( args.complete ) {
							args.complete.call( this );
						}
					});
				}
			}
	
			function run( next ) {
				var elem = $( this ),
					complete = args.complete,
					mode = args.mode;
	
				function done() {
					if ( $.isFunction( complete ) ) {
						complete.call( elem[0] );
					}
					if ( $.isFunction( next ) ) {
						next();
					}
				}
	
				// If the element already has the correct final state, delegate to
				// the core methods so the internal tracking of "olddisplay" works.
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[0], args, done );
				}
			}
	
			return queue === false ? this.each( run ) : this.queue( queue || "fx", run );
		},
	
		show: (function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "show";
					return this.effect.call( this, args );
				}
			};
		})( $.fn.show ),
	
		hide: (function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "hide";
					return this.effect.call( this, args );
				}
			};
		})( $.fn.hide ),
	
		toggle: (function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "toggle";
					return this.effect.call( this, args );
				}
			};
		})( $.fn.toggle ),
	
		// helper functions
		cssUnit: function(key) {
			var style = this.css( key ),
				val = [];
	
			$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
				if ( style.indexOf( unit ) > 0 ) {
					val = [ parseFloat( style ), unit ];
				}
			});
			return val;
		}
	});
	
	})();
	
	/******************************************************************************/
	/*********************************** EASING ***********************************/
	/******************************************************************************/
	
	(function() {
	
	// based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
	
	var baseEasings = {};
	
	$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
		baseEasings[ name ] = function( p ) {
			return Math.pow( p, i + 2 );
		};
	});
	
	$.extend( baseEasings, {
		Sine: function( p ) {
			return 1 - Math.cos( p * Math.PI / 2 );
		},
		Circ: function( p ) {
			return 1 - Math.sqrt( 1 - p * p );
		},
		Elastic: function( p ) {
			return p === 0 || p === 1 ? p :
				-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
		},
		Back: function( p ) {
			return p * p * ( 3 * p - 2 );
		},
		Bounce: function( p ) {
			var pow2,
				bounce = 4;
	
			while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
			return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
		}
	});
	
	$.each( baseEasings, function( name, easeIn ) {
		$.easing[ "easeIn" + name ] = easeIn;
		$.easing[ "easeOut" + name ] = function( p ) {
			return 1 - easeIn( 1 - p );
		};
		$.easing[ "easeInOut" + name ] = function( p ) {
			return p < 0.5 ?
				easeIn( p * 2 ) / 2 :
				1 - easeIn( p * -2 + 2 ) / 2;
		};
	});
	
	})();
	
	var effect = $.effects;
	
	
	/*!
	 * jQuery UI Effects Blind 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/blind-effect/
	 */
	
	
	var effectBlind = $.effects.effect.blind = function( o, done ) {
		// Create element
		var el = $( this ),
			rvertical = /up|down|vertical/,
			rpositivemotion = /up|left|vertical|horizontal/,
			props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
			mode = $.effects.setMode( el, o.mode || "hide" ),
			direction = o.direction || "up",
			vertical = rvertical.test( direction ),
			ref = vertical ? "height" : "width",
			ref2 = vertical ? "top" : "left",
			motion = rpositivemotion.test( direction ),
			animation = {},
			show = mode === "show",
			wrapper, distance, margin;
	
		// if already wrapped, the wrapper's properties are my property. #6245
		if ( el.parent().is( ".ui-effects-wrapper" ) ) {
			$.effects.save( el.parent(), props );
		} else {
			$.effects.save( el, props );
		}
		el.show();
		wrapper = $.effects.createWrapper( el ).css({
			overflow: "hidden"
		});
	
		distance = wrapper[ ref ]();
		margin = parseFloat( wrapper.css( ref2 ) ) || 0;
	
		animation[ ref ] = show ? distance : 0;
		if ( !motion ) {
			el
				.css( vertical ? "bottom" : "right", 0 )
				.css( vertical ? "top" : "left", "auto" )
				.css({ position: "absolute" });
	
			animation[ ref2 ] = show ? margin : distance + margin;
		}
	
		// start at 0 if we are showing
		if ( show ) {
			wrapper.css( ref, 0 );
			if ( !motion ) {
				wrapper.css( ref2, margin + distance );
			}
		}
	
		// Animate
		wrapper.animate( animation, {
			duration: o.duration,
			easing: o.easing,
			queue: false,
			complete: function() {
				if ( mode === "hide" ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			}
		});
	};
	
	
	/*!
	 * jQuery UI Effects Bounce 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/bounce-effect/
	 */
	
	
	var effectBounce = $.effects.effect.bounce = function( o, done ) {
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
	
			// defaults:
			mode = $.effects.setMode( el, o.mode || "effect" ),
			hide = mode === "hide",
			show = mode === "show",
			direction = o.direction || "up",
			distance = o.distance,
			times = o.times || 5,
	
			// number of internal animations
			anims = times * 2 + ( show || hide ? 1 : 0 ),
			speed = o.duration / anims,
			easing = o.easing,
	
			// utility:
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			motion = ( direction === "up" || direction === "left" ),
			i,
			upAnim,
			downAnim,
	
			// we will need to re-assemble the queue to stack our animations in place
			queue = el.queue(),
			queuelen = queue.length;
	
		// Avoid touching opacity to prevent clearType and PNG issues in IE
		if ( show || hide ) {
			props.push( "opacity" );
		}
	
		$.effects.save( el, props );
		el.show();
		$.effects.createWrapper( el ); // Create Wrapper
	
		// default distance for the BIGGEST bounce is the outer Distance / 3
		if ( !distance ) {
			distance = el[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
		}
	
		if ( show ) {
			downAnim = { opacity: 1 };
			downAnim[ ref ] = 0;
	
			// if we are showing, force opacity 0 and set the initial position
			// then do the "first" animation
			el.css( "opacity", 0 )
				.css( ref, motion ? -distance * 2 : distance * 2 )
				.animate( downAnim, speed, easing );
		}
	
		// start at the smallest distance if we are hiding
		if ( hide ) {
			distance = distance / Math.pow( 2, times - 1 );
		}
	
		downAnim = {};
		downAnim[ ref ] = 0;
		// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
		for ( i = 0; i < times; i++ ) {
			upAnim = {};
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			el.animate( upAnim, speed, easing )
				.animate( downAnim, speed, easing );
	
			distance = hide ? distance * 2 : distance / 2;
		}
	
		// Last Bounce when Hiding
		if ( hide ) {
			upAnim = { opacity: 0 };
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			el.animate( upAnim, speed, easing );
		}
	
		el.queue(function() {
			if ( hide ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		});
	
		// inject all the animations we just queued to be first in line (after "inprogress")
		if ( queuelen > 1) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
		}
		el.dequeue();
	
	};
	
	
	/*!
	 * jQuery UI Effects Clip 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/clip-effect/
	 */
	
	
	var effectClip = $.effects.effect.clip = function( o, done ) {
		// Create element
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
			mode = $.effects.setMode( el, o.mode || "hide" ),
			show = mode === "show",
			direction = o.direction || "vertical",
			vert = direction === "vertical",
			size = vert ? "height" : "width",
			position = vert ? "top" : "left",
			animation = {},
			wrapper, animate, distance;
	
		// Save & Show
		$.effects.save( el, props );
		el.show();
	
		// Create Wrapper
		wrapper = $.effects.createWrapper( el ).css({
			overflow: "hidden"
		});
		animate = ( el[0].tagName === "IMG" ) ? wrapper : el;
		distance = animate[ size ]();
	
		// Shift
		if ( show ) {
			animate.css( size, 0 );
			animate.css( position, distance / 2 );
		}
	
		// Create Animation Object:
		animation[ size ] = show ? distance : 0;
		animation[ position ] = show ? 0 : distance / 2;
	
		// Animate
		animate.animate( animation, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( !show ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			}
		});
	
	};
	
	
	/*!
	 * jQuery UI Effects Drop 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/drop-effect/
	 */
	
	
	var effectDrop = $.effects.effect.drop = function( o, done ) {
	
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "opacity", "height", "width" ],
			mode = $.effects.setMode( el, o.mode || "hide" ),
			show = mode === "show",
			direction = o.direction || "left",
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			motion = ( direction === "up" || direction === "left" ) ? "pos" : "neg",
			animation = {
				opacity: show ? 1 : 0
			},
			distance;
	
		// Adjust
		$.effects.save( el, props );
		el.show();
		$.effects.createWrapper( el );
	
		distance = o.distance || el[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;
	
		if ( show ) {
			el
				.css( "opacity", 0 )
				.css( ref, motion === "pos" ? -distance : distance );
		}
	
		// Animation
		animation[ ref ] = ( show ?
			( motion === "pos" ? "+=" : "-=" ) :
			( motion === "pos" ? "-=" : "+=" ) ) +
			distance;
	
		// Animate
		el.animate( animation, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( mode === "hide" ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			}
		});
	};
	
	
	/*!
	 * jQuery UI Effects Explode 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/explode-effect/
	 */
	
	
	var effectExplode = $.effects.effect.explode = function( o, done ) {
	
		var rows = o.pieces ? Math.round( Math.sqrt( o.pieces ) ) : 3,
			cells = rows,
			el = $( this ),
			mode = $.effects.setMode( el, o.mode || "hide" ),
			show = mode === "show",
	
			// show and then visibility:hidden the element before calculating offset
			offset = el.show().css( "visibility", "hidden" ).offset(),
	
			// width and height of a piece
			width = Math.ceil( el.outerWidth() / cells ),
			height = Math.ceil( el.outerHeight() / rows ),
			pieces = [],
	
			// loop
			i, j, left, top, mx, my;
	
		// children animate complete:
		function childComplete() {
			pieces.push( this );
			if ( pieces.length === rows * cells ) {
				animComplete();
			}
		}
	
		// clone the element for each row and cell.
		for ( i = 0; i < rows ; i++ ) { // ===>
			top = offset.top + i * height;
			my = i - ( rows - 1 ) / 2 ;
	
			for ( j = 0; j < cells ; j++ ) { // |||
				left = offset.left + j * width;
				mx = j - ( cells - 1 ) / 2 ;
	
				// Create a clone of the now hidden main element that will be absolute positioned
				// within a wrapper div off the -left and -top equal to size of our pieces
				el
					.clone()
					.appendTo( "body" )
					.wrap( "<div></div>" )
					.css({
						position: "absolute",
						visibility: "visible",
						left: -j * width,
						top: -i * height
					})
	
				// select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
					.parent()
					.addClass( "ui-effects-explode" )
					.css({
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					}).animate({
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, o.duration || 500, o.easing, childComplete );
			}
		}
	
		function animComplete() {
			el.css({
				visibility: "visible"
			});
			$( pieces ).remove();
			if ( !show ) {
				el.hide();
			}
			done();
		}
	};
	
	
	/*!
	 * jQuery UI Effects Fade 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/fade-effect/
	 */
	
	
	var effectFade = $.effects.effect.fade = function( o, done ) {
		var el = $( this ),
			mode = $.effects.setMode( el, o.mode || "toggle" );
	
		el.animate({
			opacity: mode
		}, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: done
		});
	};
	
	
	/*!
	 * jQuery UI Effects Fold 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/fold-effect/
	 */
	
	
	var effectFold = $.effects.effect.fold = function( o, done ) {
	
		// Create element
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
			mode = $.effects.setMode( el, o.mode || "hide" ),
			show = mode === "show",
			hide = mode === "hide",
			size = o.size || 15,
			percent = /([0-9]+)%/.exec( size ),
			horizFirst = !!o.horizFirst,
			widthFirst = show !== horizFirst,
			ref = widthFirst ? [ "width", "height" ] : [ "height", "width" ],
			duration = o.duration / 2,
			wrapper, distance,
			animation1 = {},
			animation2 = {};
	
		$.effects.save( el, props );
		el.show();
	
		// Create Wrapper
		wrapper = $.effects.createWrapper( el ).css({
			overflow: "hidden"
		});
		distance = widthFirst ?
			[ wrapper.width(), wrapper.height() ] :
			[ wrapper.height(), wrapper.width() ];
	
		if ( percent ) {
			size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
		}
		if ( show ) {
			wrapper.css( horizFirst ? {
				height: 0,
				width: size
			} : {
				height: size,
				width: 0
			});
		}
	
		// Animation
		animation1[ ref[ 0 ] ] = show ? distance[ 0 ] : size;
		animation2[ ref[ 1 ] ] = show ? distance[ 1 ] : 0;
	
		// Animate
		wrapper
			.animate( animation1, duration, o.easing )
			.animate( animation2, duration, o.easing, function() {
				if ( hide ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			});
	
	};
	
	
	/*!
	 * jQuery UI Effects Highlight 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/highlight-effect/
	 */
	
	
	var effectHighlight = $.effects.effect.highlight = function( o, done ) {
		var elem = $( this ),
			props = [ "backgroundImage", "backgroundColor", "opacity" ],
			mode = $.effects.setMode( elem, o.mode || "show" ),
			animation = {
				backgroundColor: elem.css( "backgroundColor" )
			};
	
		if (mode === "hide") {
			animation.opacity = 0;
		}
	
		$.effects.save( elem, props );
	
		elem
			.show()
			.css({
				backgroundImage: "none",
				backgroundColor: o.color || "#ffff99"
			})
			.animate( animation, {
				queue: false,
				duration: o.duration,
				easing: o.easing,
				complete: function() {
					if ( mode === "hide" ) {
						elem.hide();
					}
					$.effects.restore( elem, props );
					done();
				}
			});
	};
	
	
	/*!
	 * jQuery UI Effects Size 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/size-effect/
	 */
	
	
	var effectSize = $.effects.effect.size = function( o, done ) {
	
		// Create element
		var original, baseline, factor,
			el = $( this ),
			props0 = [ "position", "top", "bottom", "left", "right", "width", "height", "overflow", "opacity" ],
	
			// Always restore
			props1 = [ "position", "top", "bottom", "left", "right", "overflow", "opacity" ],
	
			// Copy for children
			props2 = [ "width", "height", "overflow" ],
			cProps = [ "fontSize" ],
			vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
			hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],
	
			// Set options
			mode = $.effects.setMode( el, o.mode || "effect" ),
			restore = o.restore || mode !== "effect",
			scale = o.scale || "both",
			origin = o.origin || [ "middle", "center" ],
			position = el.css( "position" ),
			props = restore ? props0 : props1,
			zero = {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
	
		if ( mode === "show" ) {
			el.show();
		}
		original = {
			height: el.height(),
			width: el.width(),
			outerHeight: el.outerHeight(),
			outerWidth: el.outerWidth()
		};
	
		if ( o.mode === "toggle" && mode === "show" ) {
			el.from = o.to || zero;
			el.to = o.from || original;
		} else {
			el.from = o.from || ( mode === "show" ? zero : original );
			el.to = o.to || ( mode === "hide" ? zero : original );
		}
	
		// Set scaling factor
		factor = {
			from: {
				y: el.from.height / original.height,
				x: el.from.width / original.width
			},
			to: {
				y: el.to.height / original.height,
				x: el.to.width / original.width
			}
		};
	
		// Scale the css box
		if ( scale === "box" || scale === "both" ) {
	
			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				props = props.concat( vProps );
				el.from = $.effects.setTransition( el, vProps, factor.from.y, el.from );
				el.to = $.effects.setTransition( el, vProps, factor.to.y, el.to );
			}
	
			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				props = props.concat( hProps );
				el.from = $.effects.setTransition( el, hProps, factor.from.x, el.from );
				el.to = $.effects.setTransition( el, hProps, factor.to.x, el.to );
			}
		}
	
		// Scale the content
		if ( scale === "content" || scale === "both" ) {
	
			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				props = props.concat( cProps ).concat( props2 );
				el.from = $.effects.setTransition( el, cProps, factor.from.y, el.from );
				el.to = $.effects.setTransition( el, cProps, factor.to.y, el.to );
			}
		}
	
		$.effects.save( el, props );
		el.show();
		$.effects.createWrapper( el );
		el.css( "overflow", "hidden" ).css( el.from );
	
		// Adjust
		if (origin) { // Calculate baseline shifts
			baseline = $.effects.getBaseline( origin, original );
			el.from.top = ( original.outerHeight - el.outerHeight() ) * baseline.y;
			el.from.left = ( original.outerWidth - el.outerWidth() ) * baseline.x;
			el.to.top = ( original.outerHeight - el.to.outerHeight ) * baseline.y;
			el.to.left = ( original.outerWidth - el.to.outerWidth ) * baseline.x;
		}
		el.css( el.from ); // set top & left
	
		// Animate
		if ( scale === "content" || scale === "both" ) { // Scale the children
	
			// Add margins/font-size
			vProps = vProps.concat([ "marginTop", "marginBottom" ]).concat(cProps);
			hProps = hProps.concat([ "marginLeft", "marginRight" ]);
			props2 = props0.concat(vProps).concat(hProps);
	
			el.find( "*[width]" ).each( function() {
				var child = $( this ),
					c_original = {
						height: child.height(),
						width: child.width(),
						outerHeight: child.outerHeight(),
						outerWidth: child.outerWidth()
					};
				if (restore) {
					$.effects.save(child, props2);
				}
	
				child.from = {
					height: c_original.height * factor.from.y,
					width: c_original.width * factor.from.x,
					outerHeight: c_original.outerHeight * factor.from.y,
					outerWidth: c_original.outerWidth * factor.from.x
				};
				child.to = {
					height: c_original.height * factor.to.y,
					width: c_original.width * factor.to.x,
					outerHeight: c_original.height * factor.to.y,
					outerWidth: c_original.width * factor.to.x
				};
	
				// Vertical props scaling
				if ( factor.from.y !== factor.to.y ) {
					child.from = $.effects.setTransition( child, vProps, factor.from.y, child.from );
					child.to = $.effects.setTransition( child, vProps, factor.to.y, child.to );
				}
	
				// Horizontal props scaling
				if ( factor.from.x !== factor.to.x ) {
					child.from = $.effects.setTransition( child, hProps, factor.from.x, child.from );
					child.to = $.effects.setTransition( child, hProps, factor.to.x, child.to );
				}
	
				// Animate children
				child.css( child.from );
				child.animate( child.to, o.duration, o.easing, function() {
	
					// Restore children
					if ( restore ) {
						$.effects.restore( child, props2 );
					}
				});
			});
		}
	
		// Animate
		el.animate( el.to, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( el.to.opacity === 0 ) {
					el.css( "opacity", el.from.opacity );
				}
				if ( mode === "hide" ) {
					el.hide();
				}
				$.effects.restore( el, props );
				if ( !restore ) {
	
					// we need to calculate our new positioning based on the scaling
					if ( position === "static" ) {
						el.css({
							position: "relative",
							top: el.to.top,
							left: el.to.left
						});
					} else {
						$.each([ "top", "left" ], function( idx, pos ) {
							el.css( pos, function( _, str ) {
								var val = parseInt( str, 10 ),
									toRef = idx ? el.to.left : el.to.top;
	
								// if original was "auto", recalculate the new value from wrapper
								if ( str === "auto" ) {
									return toRef + "px";
								}
	
								return val + toRef + "px";
							});
						});
					}
				}
	
				$.effects.removeWrapper( el );
				done();
			}
		});
	
	};
	
	
	/*!
	 * jQuery UI Effects Scale 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/scale-effect/
	 */
	
	
	var effectScale = $.effects.effect.scale = function( o, done ) {
	
		// Create element
		var el = $( this ),
			options = $.extend( true, {}, o ),
			mode = $.effects.setMode( el, o.mode || "effect" ),
			percent = parseInt( o.percent, 10 ) ||
				( parseInt( o.percent, 10 ) === 0 ? 0 : ( mode === "hide" ? 0 : 100 ) ),
			direction = o.direction || "both",
			origin = o.origin,
			original = {
				height: el.height(),
				width: el.width(),
				outerHeight: el.outerHeight(),
				outerWidth: el.outerWidth()
			},
			factor = {
				y: direction !== "horizontal" ? (percent / 100) : 1,
				x: direction !== "vertical" ? (percent / 100) : 1
			};
	
		// We are going to pass this effect to the size effect:
		options.effect = "size";
		options.queue = false;
		options.complete = done;
	
		// Set default origin and restore for show/hide
		if ( mode !== "effect" ) {
			options.origin = origin || [ "middle", "center" ];
			options.restore = true;
		}
	
		options.from = o.from || ( mode === "show" ? {
			height: 0,
			width: 0,
			outerHeight: 0,
			outerWidth: 0
		} : original );
		options.to = {
			height: original.height * factor.y,
			width: original.width * factor.x,
			outerHeight: original.outerHeight * factor.y,
			outerWidth: original.outerWidth * factor.x
		};
	
		// Fade option to support puff
		if ( options.fade ) {
			if ( mode === "show" ) {
				options.from.opacity = 0;
				options.to.opacity = 1;
			}
			if ( mode === "hide" ) {
				options.from.opacity = 1;
				options.to.opacity = 0;
			}
		}
	
		// Animate
		el.effect( options );
	
	};
	
	
	/*!
	 * jQuery UI Effects Puff 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/puff-effect/
	 */
	
	
	var effectPuff = $.effects.effect.puff = function( o, done ) {
		var elem = $( this ),
			mode = $.effects.setMode( elem, o.mode || "hide" ),
			hide = mode === "hide",
			percent = parseInt( o.percent, 10 ) || 150,
			factor = percent / 100,
			original = {
				height: elem.height(),
				width: elem.width(),
				outerHeight: elem.outerHeight(),
				outerWidth: elem.outerWidth()
			};
	
		$.extend( o, {
			effect: "scale",
			queue: false,
			fade: true,
			mode: mode,
			complete: done,
			percent: hide ? percent : 100,
			from: hide ?
				original :
				{
					height: original.height * factor,
					width: original.width * factor,
					outerHeight: original.outerHeight * factor,
					outerWidth: original.outerWidth * factor
				}
		});
	
		elem.effect( o );
	};
	
	
	/*!
	 * jQuery UI Effects Pulsate 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/pulsate-effect/
	 */
	
	
	var effectPulsate = $.effects.effect.pulsate = function( o, done ) {
		var elem = $( this ),
			mode = $.effects.setMode( elem, o.mode || "show" ),
			show = mode === "show",
			hide = mode === "hide",
			showhide = ( show || mode === "hide" ),
	
			// showing or hiding leaves of the "last" animation
			anims = ( ( o.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
			duration = o.duration / anims,
			animateTo = 0,
			queue = elem.queue(),
			queuelen = queue.length,
			i;
	
		if ( show || !elem.is(":visible")) {
			elem.css( "opacity", 0 ).show();
			animateTo = 1;
		}
	
		// anims - 1 opacity "toggles"
		for ( i = 1; i < anims; i++ ) {
			elem.animate({
				opacity: animateTo
			}, duration, o.easing );
			animateTo = 1 - animateTo;
		}
	
		elem.animate({
			opacity: animateTo
		}, duration, o.easing);
	
		elem.queue(function() {
			if ( hide ) {
				elem.hide();
			}
			done();
		});
	
		// We just queued up "anims" animations, we need to put them next in the queue
		if ( queuelen > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
		}
		elem.dequeue();
	};
	
	
	/*!
	 * jQuery UI Effects Shake 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/shake-effect/
	 */
	
	
	var effectShake = $.effects.effect.shake = function( o, done ) {
	
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
			mode = $.effects.setMode( el, o.mode || "effect" ),
			direction = o.direction || "left",
			distance = o.distance || 20,
			times = o.times || 3,
			anims = times * 2 + 1,
			speed = Math.round( o.duration / anims ),
			ref = (direction === "up" || direction === "down") ? "top" : "left",
			positiveMotion = (direction === "up" || direction === "left"),
			animation = {},
			animation1 = {},
			animation2 = {},
			i,
	
			// we will need to re-assemble the queue to stack our animations in place
			queue = el.queue(),
			queuelen = queue.length;
	
		$.effects.save( el, props );
		el.show();
		$.effects.createWrapper( el );
	
		// Animation
		animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
		animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
		animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;
	
		// Animate
		el.animate( animation, speed, o.easing );
	
		// Shakes
		for ( i = 1; i < times; i++ ) {
			el.animate( animation1, speed, o.easing ).animate( animation2, speed, o.easing );
		}
		el
			.animate( animation1, speed, o.easing )
			.animate( animation, speed / 2, o.easing )
			.queue(function() {
				if ( mode === "hide" ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			});
	
		// inject all the animations we just queued to be first in line (after "inprogress")
		if ( queuelen > 1) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
		}
		el.dequeue();
	
	};
	
	
	/*!
	 * jQuery UI Effects Slide 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/slide-effect/
	 */
	
	
	var effectSlide = $.effects.effect.slide = function( o, done ) {
	
		// Create element
		var el = $( this ),
			props = [ "position", "top", "bottom", "left", "right", "width", "height" ],
			mode = $.effects.setMode( el, o.mode || "show" ),
			show = mode === "show",
			direction = o.direction || "left",
			ref = (direction === "up" || direction === "down") ? "top" : "left",
			positiveMotion = (direction === "up" || direction === "left"),
			distance,
			animation = {};
	
		// Adjust
		$.effects.save( el, props );
		el.show();
		distance = o.distance || el[ ref === "top" ? "outerHeight" : "outerWidth" ]( true );
	
		$.effects.createWrapper( el ).css({
			overflow: "hidden"
		});
	
		if ( show ) {
			el.css( ref, positiveMotion ? (isNaN(distance) ? "-" + distance : -distance) : distance );
		}
	
		// Animation
		animation[ ref ] = ( show ?
			( positiveMotion ? "+=" : "-=") :
			( positiveMotion ? "-=" : "+=")) +
			distance;
	
		// Animate
		el.animate( animation, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( mode === "hide" ) {
					el.hide();
				}
				$.effects.restore( el, props );
				$.effects.removeWrapper( el );
				done();
			}
		});
	};
	
	
	/*!
	 * jQuery UI Effects Transfer 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/transfer-effect/
	 */
	
	
	var effectTransfer = $.effects.effect.transfer = function( o, done ) {
		var elem = $( this ),
			target = $( o.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $("body"),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = elem.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" )
				.appendTo( document.body )
				.addClass( o.className )
				.css({
					top: startPosition.top - fixTop,
					left: startPosition.left - fixLeft,
					height: elem.innerHeight(),
					width: elem.innerWidth(),
					position: targetFixed ? "fixed" : "absolute"
				})
				.animate( animation, o.duration, o.easing, function() {
					transfer.remove();
					done();
				});
	};
	
	
	/*!
	 * jQuery UI Progressbar 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/progressbar/
	 */
	
	
	var progressbar = $.widget( "ui.progressbar", {
		version: "1.11.4",
		options: {
			max: 100,
			value: 0,
	
			change: null,
			complete: null
		},
	
		min: 0,
	
		_create: function() {
			// Constrain initial value
			this.oldValue = this.options.value = this._constrainedValue();
	
			this.element
				.addClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
				.attr({
					// Only set static values, aria-valuenow and aria-valuemax are
					// set inside _refreshValue()
					role: "progressbar",
					"aria-valuemin": this.min
				});
	
			this.valueDiv = $( "<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>" )
				.appendTo( this.element );
	
			this._refreshValue();
		},
	
		_destroy: function() {
			this.element
				.removeClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
				.removeAttr( "role" )
				.removeAttr( "aria-valuemin" )
				.removeAttr( "aria-valuemax" )
				.removeAttr( "aria-valuenow" );
	
			this.valueDiv.remove();
		},
	
		value: function( newValue ) {
			if ( newValue === undefined ) {
				return this.options.value;
			}
	
			this.options.value = this._constrainedValue( newValue );
			this._refreshValue();
		},
	
		_constrainedValue: function( newValue ) {
			if ( newValue === undefined ) {
				newValue = this.options.value;
			}
	
			this.indeterminate = newValue === false;
	
			// sanitize value
			if ( typeof newValue !== "number" ) {
				newValue = 0;
			}
	
			return this.indeterminate ? false :
				Math.min( this.options.max, Math.max( this.min, newValue ) );
		},
	
		_setOptions: function( options ) {
			// Ensure "value" option is set after other values (like max)
			var value = options.value;
			delete options.value;
	
			this._super( options );
	
			this.options.value = this._constrainedValue( value );
			this._refreshValue();
		},
	
		_setOption: function( key, value ) {
			if ( key === "max" ) {
				// Don't allow a max less than min
				value = Math.max( this.min, value );
			}
			if ( key === "disabled" ) {
				this.element
					.toggleClass( "ui-state-disabled", !!value )
					.attr( "aria-disabled", value );
			}
			this._super( key, value );
		},
	
		_percentage: function() {
			return this.indeterminate ? 100 : 100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
		},
	
		_refreshValue: function() {
			var value = this.options.value,
				percentage = this._percentage();
	
			this.valueDiv
				.toggle( this.indeterminate || value > this.min )
				.toggleClass( "ui-corner-right", value === this.options.max )
				.width( percentage.toFixed(0) + "%" );
	
			this.element.toggleClass( "ui-progressbar-indeterminate", this.indeterminate );
	
			if ( this.indeterminate ) {
				this.element.removeAttr( "aria-valuenow" );
				if ( !this.overlayDiv ) {
					this.overlayDiv = $( "<div class='ui-progressbar-overlay'></div>" ).appendTo( this.valueDiv );
				}
			} else {
				this.element.attr({
					"aria-valuemax": this.options.max,
					"aria-valuenow": value
				});
				if ( this.overlayDiv ) {
					this.overlayDiv.remove();
					this.overlayDiv = null;
				}
			}
	
			if ( this.oldValue !== value ) {
				this.oldValue = value;
				this._trigger( "change" );
			}
			if ( value === this.options.max ) {
				this._trigger( "complete" );
			}
		}
	});
	
	
	/*!
	 * jQuery UI Selectable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/selectable/
	 */
	
	
	var selectable = $.widget("ui.selectable", $.ui.mouse, {
		version: "1.11.4",
		options: {
			appendTo: "body",
			autoRefresh: true,
			distance: 0,
			filter: "*",
			tolerance: "touch",
	
			// callbacks
			selected: null,
			selecting: null,
			start: null,
			stop: null,
			unselected: null,
			unselecting: null
		},
		_create: function() {
			var selectees,
				that = this;
	
			this.element.addClass("ui-selectable");
	
			this.dragged = false;
	
			// cache selectee children based on filter
			this.refresh = function() {
				selectees = $(that.options.filter, that.element[0]);
				selectees.addClass("ui-selectee");
				selectees.each(function() {
					var $this = $(this),
						pos = $this.offset();
					$.data(this, "selectable-item", {
						element: this,
						$element: $this,
						left: pos.left,
						top: pos.top,
						right: pos.left + $this.outerWidth(),
						bottom: pos.top + $this.outerHeight(),
						startselected: false,
						selected: $this.hasClass("ui-selected"),
						selecting: $this.hasClass("ui-selecting"),
						unselecting: $this.hasClass("ui-unselecting")
					});
				});
			};
			this.refresh();
	
			this.selectees = selectees.addClass("ui-selectee");
	
			this._mouseInit();
	
			this.helper = $("<div class='ui-selectable-helper'></div>");
		},
	
		_destroy: function() {
			this.selectees
				.removeClass("ui-selectee")
				.removeData("selectable-item");
			this.element
				.removeClass("ui-selectable ui-selectable-disabled");
			this._mouseDestroy();
		},
	
		_mouseStart: function(event) {
			var that = this,
				options = this.options;
	
			this.opos = [ event.pageX, event.pageY ];
	
			if (this.options.disabled) {
				return;
			}
	
			this.selectees = $(options.filter, this.element[0]);
	
			this._trigger("start", event);
	
			$(options.appendTo).append(this.helper);
			// position helper (lasso)
			this.helper.css({
				"left": event.pageX,
				"top": event.pageY,
				"width": 0,
				"height": 0
			});
	
			if (options.autoRefresh) {
				this.refresh();
			}
	
			this.selectees.filter(".ui-selected").each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.startselected = true;
				if (!event.metaKey && !event.ctrlKey) {
					selectee.$element.removeClass("ui-selected");
					selectee.selected = false;
					selectee.$element.addClass("ui-unselecting");
					selectee.unselecting = true;
					// selectable UNSELECTING callback
					that._trigger("unselecting", event, {
						unselecting: selectee.element
					});
				}
			});
	
			$(event.target).parents().addBack().each(function() {
				var doSelect,
					selectee = $.data(this, "selectable-item");
				if (selectee) {
					doSelect = (!event.metaKey && !event.ctrlKey) || !selectee.$element.hasClass("ui-selected");
					selectee.$element
						.removeClass(doSelect ? "ui-unselecting" : "ui-selected")
						.addClass(doSelect ? "ui-selecting" : "ui-unselecting");
					selectee.unselecting = !doSelect;
					selectee.selecting = doSelect;
					selectee.selected = doSelect;
					// selectable (UN)SELECTING callback
					if (doSelect) {
						that._trigger("selecting", event, {
							selecting: selectee.element
						});
					} else {
						that._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
					return false;
				}
			});
	
		},
	
		_mouseDrag: function(event) {
	
			this.dragged = true;
	
			if (this.options.disabled) {
				return;
			}
	
			var tmp,
				that = this,
				options = this.options,
				x1 = this.opos[0],
				y1 = this.opos[1],
				x2 = event.pageX,
				y2 = event.pageY;
	
			if (x1 > x2) { tmp = x2; x2 = x1; x1 = tmp; }
			if (y1 > y2) { tmp = y2; y2 = y1; y1 = tmp; }
			this.helper.css({ left: x1, top: y1, width: x2 - x1, height: y2 - y1 });
	
			this.selectees.each(function() {
				var selectee = $.data(this, "selectable-item"),
					hit = false;
	
				//prevent helper from being selected if appendTo: selectable
				if (!selectee || selectee.element === that.element[0]) {
					return;
				}
	
				if (options.tolerance === "touch") {
					hit = ( !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1) );
				} else if (options.tolerance === "fit") {
					hit = (selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2);
				}
	
				if (hit) {
					// SELECT
					if (selectee.selected) {
						selectee.$element.removeClass("ui-selected");
						selectee.selected = false;
					}
					if (selectee.unselecting) {
						selectee.$element.removeClass("ui-unselecting");
						selectee.unselecting = false;
					}
					if (!selectee.selecting) {
						selectee.$element.addClass("ui-selecting");
						selectee.selecting = true;
						// selectable SELECTING callback
						that._trigger("selecting", event, {
							selecting: selectee.element
						});
					}
				} else {
					// UNSELECT
					if (selectee.selecting) {
						if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
							selectee.$element.removeClass("ui-selecting");
							selectee.selecting = false;
							selectee.$element.addClass("ui-selected");
							selectee.selected = true;
						} else {
							selectee.$element.removeClass("ui-selecting");
							selectee.selecting = false;
							if (selectee.startselected) {
								selectee.$element.addClass("ui-unselecting");
								selectee.unselecting = true;
							}
							// selectable UNSELECTING callback
							that._trigger("unselecting", event, {
								unselecting: selectee.element
							});
						}
					}
					if (selectee.selected) {
						if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
							selectee.$element.removeClass("ui-selected");
							selectee.selected = false;
	
							selectee.$element.addClass("ui-unselecting");
							selectee.unselecting = true;
							// selectable UNSELECTING callback
							that._trigger("unselecting", event, {
								unselecting: selectee.element
							});
						}
					}
				}
			});
	
			return false;
		},
	
		_mouseStop: function(event) {
			var that = this;
	
			this.dragged = false;
	
			$(".ui-unselecting", this.element[0]).each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.$element.removeClass("ui-unselecting");
				selectee.unselecting = false;
				selectee.startselected = false;
				that._trigger("unselected", event, {
					unselected: selectee.element
				});
			});
			$(".ui-selecting", this.element[0]).each(function() {
				var selectee = $.data(this, "selectable-item");
				selectee.$element.removeClass("ui-selecting").addClass("ui-selected");
				selectee.selecting = false;
				selectee.selected = true;
				selectee.startselected = true;
				that._trigger("selected", event, {
					selected: selectee.element
				});
			});
			this._trigger("stop", event);
	
			this.helper.remove();
	
			return false;
		}
	
	});
	
	
	/*!
	 * jQuery UI Selectmenu 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/selectmenu
	 */
	
	
	var selectmenu = $.widget( "ui.selectmenu", {
		version: "1.11.4",
		defaultElement: "<select>",
		options: {
			appendTo: null,
			disabled: null,
			icons: {
				button: "ui-icon-triangle-1-s"
			},
			position: {
				my: "left top",
				at: "left bottom",
				collision: "none"
			},
			width: null,
	
			// callbacks
			change: null,
			close: null,
			focus: null,
			open: null,
			select: null
		},
	
		_create: function() {
			var selectmenuId = this.element.uniqueId().attr( "id" );
			this.ids = {
				element: selectmenuId,
				button: selectmenuId + "-button",
				menu: selectmenuId + "-menu"
			};
	
			this._drawButton();
			this._drawMenu();
	
			if ( this.options.disabled ) {
				this.disable();
			}
		},
	
		_drawButton: function() {
			var that = this;
	
			// Associate existing label with the new button
			this.label = $( "label[for='" + this.ids.element + "']" ).attr( "for", this.ids.button );
			this._on( this.label, {
				click: function( event ) {
					this.button.focus();
					event.preventDefault();
				}
			});
	
			// Hide original select element
			this.element.hide();
	
			// Create button
			this.button = $( "<span>", {
				"class": "ui-selectmenu-button ui-widget ui-state-default ui-corner-all",
				tabindex: this.options.disabled ? -1 : 0,
				id: this.ids.button,
				role: "combobox",
				"aria-expanded": "false",
				"aria-autocomplete": "list",
				"aria-owns": this.ids.menu,
				"aria-haspopup": "true"
			})
				.insertAfter( this.element );
	
			$( "<span>", {
				"class": "ui-icon " + this.options.icons.button
			})
				.prependTo( this.button );
	
			this.buttonText = $( "<span>", {
				"class": "ui-selectmenu-text"
			})
				.appendTo( this.button );
	
			this._setText( this.buttonText, this.element.find( "option:selected" ).text() );
			this._resizeButton();
	
			this._on( this.button, this._buttonEvents );
			this.button.one( "focusin", function() {
	
				// Delay rendering the menu items until the button receives focus.
				// The menu may have already been rendered via a programmatic open.
				if ( !that.menuItems ) {
					that._refreshMenu();
				}
			});
			this._hoverable( this.button );
			this._focusable( this.button );
		},
	
		_drawMenu: function() {
			var that = this;
	
			// Create menu
			this.menu = $( "<ul>", {
				"aria-hidden": "true",
				"aria-labelledby": this.ids.button,
				id: this.ids.menu
			});
	
			// Wrap menu
			this.menuWrap = $( "<div>", {
				"class": "ui-selectmenu-menu ui-front"
			})
				.append( this.menu )
				.appendTo( this._appendTo() );
	
			// Initialize menu widget
			this.menuInstance = this.menu
				.menu({
					role: "listbox",
					select: function( event, ui ) {
						event.preventDefault();
	
						// support: IE8
						// If the item was selected via a click, the text selection
						// will be destroyed in IE
						that._setSelection();
	
						that._select( ui.item.data( "ui-selectmenu-item" ), event );
					},
					focus: function( event, ui ) {
						var item = ui.item.data( "ui-selectmenu-item" );
	
						// Prevent inital focus from firing and check if its a newly focused item
						if ( that.focusIndex != null && item.index !== that.focusIndex ) {
							that._trigger( "focus", event, { item: item } );
							if ( !that.isOpen ) {
								that._select( item, event );
							}
						}
						that.focusIndex = item.index;
	
						that.button.attr( "aria-activedescendant",
							that.menuItems.eq( item.index ).attr( "id" ) );
					}
				})
				.menu( "instance" );
	
			// Adjust menu styles to dropdown
			this.menu
				.addClass( "ui-corner-bottom" )
				.removeClass( "ui-corner-all" );
	
			// Don't close the menu on mouseleave
			this.menuInstance._off( this.menu, "mouseleave" );
	
			// Cancel the menu's collapseAll on document click
			this.menuInstance._closeOnDocumentClick = function() {
				return false;
			};
	
			// Selects often contain empty items, but never contain dividers
			this.menuInstance._isDivider = function() {
				return false;
			};
		},
	
		refresh: function() {
			this._refreshMenu();
			this._setText( this.buttonText, this._getSelectedItem().text() );
			if ( !this.options.width ) {
				this._resizeButton();
			}
		},
	
		_refreshMenu: function() {
			this.menu.empty();
	
			var item,
				options = this.element.find( "option" );
	
			if ( !options.length ) {
				return;
			}
	
			this._parseOptions( options );
			this._renderMenu( this.menu, this.items );
	
			this.menuInstance.refresh();
			this.menuItems = this.menu.find( "li" ).not( ".ui-selectmenu-optgroup" );
	
			item = this._getSelectedItem();
	
			// Update the menu to have the correct item focused
			this.menuInstance.focus( null, item );
			this._setAria( item.data( "ui-selectmenu-item" ) );
	
			// Set disabled state
			this._setOption( "disabled", this.element.prop( "disabled" ) );
		},
	
		open: function( event ) {
			if ( this.options.disabled ) {
				return;
			}
	
			// If this is the first time the menu is being opened, render the items
			if ( !this.menuItems ) {
				this._refreshMenu();
			} else {
	
				// Menu clears focus on close, reset focus to selected item
				this.menu.find( ".ui-state-focus" ).removeClass( "ui-state-focus" );
				this.menuInstance.focus( null, this._getSelectedItem() );
			}
	
			this.isOpen = true;
			this._toggleAttr();
			this._resizeMenu();
			this._position();
	
			this._on( this.document, this._documentClick );
	
			this._trigger( "open", event );
		},
	
		_position: function() {
			this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
		},
	
		close: function( event ) {
			if ( !this.isOpen ) {
				return;
			}
	
			this.isOpen = false;
			this._toggleAttr();
	
			this.range = null;
			this._off( this.document );
	
			this._trigger( "close", event );
		},
	
		widget: function() {
			return this.button;
		},
	
		menuWidget: function() {
			return this.menu;
		},
	
		_renderMenu: function( ul, items ) {
			var that = this,
				currentOptgroup = "";
	
			$.each( items, function( index, item ) {
				if ( item.optgroup !== currentOptgroup ) {
					$( "<li>", {
						"class": "ui-selectmenu-optgroup ui-menu-divider" +
							( item.element.parent( "optgroup" ).prop( "disabled" ) ?
								" ui-state-disabled" :
								"" ),
						text: item.optgroup
					})
						.appendTo( ul );
	
					currentOptgroup = item.optgroup;
				}
	
				that._renderItemData( ul, item );
			});
		},
	
		_renderItemData: function( ul, item ) {
			return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
		},
	
		_renderItem: function( ul, item ) {
			var li = $( "<li>" );
	
			if ( item.disabled ) {
				li.addClass( "ui-state-disabled" );
			}
			this._setText( li, item.label );
	
			return li.appendTo( ul );
		},
	
		_setText: function( element, value ) {
			if ( value ) {
				element.text( value );
			} else {
				element.html( "&#160;" );
			}
		},
	
		_move: function( direction, event ) {
			var item, next,
				filter = ".ui-menu-item";
	
			if ( this.isOpen ) {
				item = this.menuItems.eq( this.focusIndex );
			} else {
				item = this.menuItems.eq( this.element[ 0 ].selectedIndex );
				filter += ":not(.ui-state-disabled)";
			}
	
			if ( direction === "first" || direction === "last" ) {
				next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
			} else {
				next = item[ direction + "All" ]( filter ).eq( 0 );
			}
	
			if ( next.length ) {
				this.menuInstance.focus( event, next );
			}
		},
	
		_getSelectedItem: function() {
			return this.menuItems.eq( this.element[ 0 ].selectedIndex );
		},
	
		_toggle: function( event ) {
			this[ this.isOpen ? "close" : "open" ]( event );
		},
	
		_setSelection: function() {
			var selection;
	
			if ( !this.range ) {
				return;
			}
	
			if ( window.getSelection ) {
				selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange( this.range );
	
			// support: IE8
			} else {
				this.range.select();
			}
	
			// support: IE
			// Setting the text selection kills the button focus in IE, but
			// restoring the focus doesn't kill the selection.
			this.button.focus();
		},
	
		_documentClick: {
			mousedown: function( event ) {
				if ( !this.isOpen ) {
					return;
				}
	
				if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" + this.ids.button ).length ) {
					this.close( event );
				}
			}
		},
	
		_buttonEvents: {
	
			// Prevent text selection from being reset when interacting with the selectmenu (#10144)
			mousedown: function() {
				var selection;
	
				if ( window.getSelection ) {
					selection = window.getSelection();
					if ( selection.rangeCount ) {
						this.range = selection.getRangeAt( 0 );
					}
	
				// support: IE8
				} else {
					this.range = document.selection.createRange();
				}
			},
	
			click: function( event ) {
				this._setSelection();
				this._toggle( event );
			},
	
			keydown: function( event ) {
				var preventDefault = true;
				switch ( event.keyCode ) {
					case $.ui.keyCode.TAB:
					case $.ui.keyCode.ESCAPE:
						this.close( event );
						preventDefault = false;
						break;
					case $.ui.keyCode.ENTER:
						if ( this.isOpen ) {
							this._selectFocusedItem( event );
						}
						break;
					case $.ui.keyCode.UP:
						if ( event.altKey ) {
							this._toggle( event );
						} else {
							this._move( "prev", event );
						}
						break;
					case $.ui.keyCode.DOWN:
						if ( event.altKey ) {
							this._toggle( event );
						} else {
							this._move( "next", event );
						}
						break;
					case $.ui.keyCode.SPACE:
						if ( this.isOpen ) {
							this._selectFocusedItem( event );
						} else {
							this._toggle( event );
						}
						break;
					case $.ui.keyCode.LEFT:
						this._move( "prev", event );
						break;
					case $.ui.keyCode.RIGHT:
						this._move( "next", event );
						break;
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.PAGE_UP:
						this._move( "first", event );
						break;
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_DOWN:
						this._move( "last", event );
						break;
					default:
						this.menu.trigger( event );
						preventDefault = false;
				}
	
				if ( preventDefault ) {
					event.preventDefault();
				}
			}
		},
	
		_selectFocusedItem: function( event ) {
			var item = this.menuItems.eq( this.focusIndex );
			if ( !item.hasClass( "ui-state-disabled" ) ) {
				this._select( item.data( "ui-selectmenu-item" ), event );
			}
		},
	
		_select: function( item, event ) {
			var oldIndex = this.element[ 0 ].selectedIndex;
	
			// Change native select element
			this.element[ 0 ].selectedIndex = item.index;
			this._setText( this.buttonText, item.label );
			this._setAria( item );
			this._trigger( "select", event, { item: item } );
	
			if ( item.index !== oldIndex ) {
				this._trigger( "change", event, { item: item } );
			}
	
			this.close( event );
		},
	
		_setAria: function( item ) {
			var id = this.menuItems.eq( item.index ).attr( "id" );
	
			this.button.attr({
				"aria-labelledby": id,
				"aria-activedescendant": id
			});
			this.menu.attr( "aria-activedescendant", id );
		},
	
		_setOption: function( key, value ) {
			if ( key === "icons" ) {
				this.button.find( "span.ui-icon" )
					.removeClass( this.options.icons.button )
					.addClass( value.button );
			}
	
			this._super( key, value );
	
			if ( key === "appendTo" ) {
				this.menuWrap.appendTo( this._appendTo() );
			}
	
			if ( key === "disabled" ) {
				this.menuInstance.option( "disabled", value );
				this.button
					.toggleClass( "ui-state-disabled", value )
					.attr( "aria-disabled", value );
	
				this.element.prop( "disabled", value );
				if ( value ) {
					this.button.attr( "tabindex", -1 );
					this.close();
				} else {
					this.button.attr( "tabindex", 0 );
				}
			}
	
			if ( key === "width" ) {
				this._resizeButton();
			}
		},
	
		_appendTo: function() {
			var element = this.options.appendTo;
	
			if ( element ) {
				element = element.jquery || element.nodeType ?
					$( element ) :
					this.document.find( element ).eq( 0 );
			}
	
			if ( !element || !element[ 0 ] ) {
				element = this.element.closest( ".ui-front" );
			}
	
			if ( !element.length ) {
				element = this.document[ 0 ].body;
			}
	
			return element;
		},
	
		_toggleAttr: function() {
			this.button
				.toggleClass( "ui-corner-top", this.isOpen )
				.toggleClass( "ui-corner-all", !this.isOpen )
				.attr( "aria-expanded", this.isOpen );
			this.menuWrap.toggleClass( "ui-selectmenu-open", this.isOpen );
			this.menu.attr( "aria-hidden", !this.isOpen );
		},
	
		_resizeButton: function() {
			var width = this.options.width;
	
			if ( !width ) {
				width = this.element.show().outerWidth();
				this.element.hide();
			}
	
			this.button.outerWidth( width );
		},
	
		_resizeMenu: function() {
			this.menu.outerWidth( Math.max(
				this.button.outerWidth(),
	
				// support: IE10
				// IE10 wraps long text (possibly a rounding bug)
				// so we add 1px to avoid the wrapping
				this.menu.width( "" ).outerWidth() + 1
			) );
		},
	
		_getCreateOptions: function() {
			return { disabled: this.element.prop( "disabled" ) };
		},
	
		_parseOptions: function( options ) {
			var data = [];
			options.each(function( index, item ) {
				var option = $( item ),
					optgroup = option.parent( "optgroup" );
				data.push({
					element: option,
					index: index,
					value: option.val(),
					label: option.text(),
					optgroup: optgroup.attr( "label" ) || "",
					disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
				});
			});
			this.items = data;
		},
	
		_destroy: function() {
			this.menuWrap.remove();
			this.button.remove();
			this.element.show();
			this.element.removeUniqueId();
			this.label.attr( "for", this.ids.element );
		}
	});
	
	
	/*!
	 * jQuery UI Slider 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/slider/
	 */
	
	
	var slider = $.widget( "ui.slider", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "slide",
	
		options: {
			animate: false,
			distance: 0,
			max: 100,
			min: 0,
			orientation: "horizontal",
			range: false,
			step: 1,
			value: 0,
			values: null,
	
			// callbacks
			change: null,
			slide: null,
			start: null,
			stop: null
		},
	
		// number of pages in a slider
		// (how many times can you page up/down to go through the whole range)
		numPages: 5,
	
		_create: function() {
			this._keySliding = false;
			this._mouseSliding = false;
			this._animateOff = true;
			this._handleIndex = null;
			this._detectOrientation();
			this._mouseInit();
			this._calculateNewMax();
	
			this.element
				.addClass( "ui-slider" +
					" ui-slider-" + this.orientation +
					" ui-widget" +
					" ui-widget-content" +
					" ui-corner-all");
	
			this._refresh();
			this._setOption( "disabled", this.options.disabled );
	
			this._animateOff = false;
		},
	
		_refresh: function() {
			this._createRange();
			this._createHandles();
			this._setupEvents();
			this._refreshValue();
		},
	
		_createHandles: function() {
			var i, handleCount,
				options = this.options,
				existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
				handle = "<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>",
				handles = [];
	
			handleCount = ( options.values && options.values.length ) || 1;
	
			if ( existingHandles.length > handleCount ) {
				existingHandles.slice( handleCount ).remove();
				existingHandles = existingHandles.slice( 0, handleCount );
			}
	
			for ( i = existingHandles.length; i < handleCount; i++ ) {
				handles.push( handle );
			}
	
			this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );
	
			this.handle = this.handles.eq( 0 );
	
			this.handles.each(function( i ) {
				$( this ).data( "ui-slider-handle-index", i );
			});
		},
	
		_createRange: function() {
			var options = this.options,
				classes = "";
	
			if ( options.range ) {
				if ( options.range === true ) {
					if ( !options.values ) {
						options.values = [ this._valueMin(), this._valueMin() ];
					} else if ( options.values.length && options.values.length !== 2 ) {
						options.values = [ options.values[0], options.values[0] ];
					} else if ( $.isArray( options.values ) ) {
						options.values = options.values.slice(0);
					}
				}
	
				if ( !this.range || !this.range.length ) {
					this.range = $( "<div></div>" )
						.appendTo( this.element );
	
					classes = "ui-slider-range" +
					// note: this isn't the most fittingly semantic framework class for this element,
					// but worked best visually with a variety of themes
					" ui-widget-header ui-corner-all";
				} else {
					this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
						// Handle range switching from true to min/max
						.css({
							"left": "",
							"bottom": ""
						});
				}
	
				this.range.addClass( classes +
					( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
			} else {
				if ( this.range ) {
					this.range.remove();
				}
				this.range = null;
			}
		},
	
		_setupEvents: function() {
			this._off( this.handles );
			this._on( this.handles, this._handleEvents );
			this._hoverable( this.handles );
			this._focusable( this.handles );
		},
	
		_destroy: function() {
			this.handles.remove();
			if ( this.range ) {
				this.range.remove();
			}
	
			this.element
				.removeClass( "ui-slider" +
					" ui-slider-horizontal" +
					" ui-slider-vertical" +
					" ui-widget" +
					" ui-widget-content" +
					" ui-corner-all" );
	
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
				that = this,
				o = this.options;
	
			if ( o.disabled ) {
				return false;
			}
	
			this.elementSize = {
				width: this.element.outerWidth(),
				height: this.element.outerHeight()
			};
			this.elementOffset = this.element.offset();
	
			position = { x: event.pageX, y: event.pageY };
			normValue = this._normValueFromMouse( position );
			distance = this._valueMax() - this._valueMin() + 1;
			this.handles.each(function( i ) {
				var thisDistance = Math.abs( normValue - that.values(i) );
				if (( distance > thisDistance ) ||
					( distance === thisDistance &&
						(i === that._lastChangedValue || that.values(i) === o.min ))) {
					distance = thisDistance;
					closestHandle = $( this );
					index = i;
				}
			});
	
			allowed = this._start( event, index );
			if ( allowed === false ) {
				return false;
			}
			this._mouseSliding = true;
	
			this._handleIndex = index;
	
			closestHandle
				.addClass( "ui-state-active" )
				.focus();
	
			offset = closestHandle.offset();
			mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
			this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
				left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
				top: event.pageY - offset.top -
					( closestHandle.height() / 2 ) -
					( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
					( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
					( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
			};
	
			if ( !this.handles.hasClass( "ui-state-hover" ) ) {
				this._slide( event, index, normValue );
			}
			this._animateOff = true;
			return true;
		},
	
		_mouseStart: function() {
			return true;
		},
	
		_mouseDrag: function( event ) {
			var position = { x: event.pageX, y: event.pageY },
				normValue = this._normValueFromMouse( position );
	
			this._slide( event, this._handleIndex, normValue );
	
			return false;
		},
	
		_mouseStop: function( event ) {
			this.handles.removeClass( "ui-state-active" );
			this._mouseSliding = false;
	
			this._stop( event, this._handleIndex );
			this._change( event, this._handleIndex );
	
			this._handleIndex = null;
			this._clickOffset = null;
			this._animateOff = false;
	
			return false;
		},
	
		_detectOrientation: function() {
			this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
		},
	
		_normValueFromMouse: function( position ) {
			var pixelTotal,
				pixelMouse,
				percentMouse,
				valueTotal,
				valueMouse;
	
			if ( this.orientation === "horizontal" ) {
				pixelTotal = this.elementSize.width;
				pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
			} else {
				pixelTotal = this.elementSize.height;
				pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
			}
	
			percentMouse = ( pixelMouse / pixelTotal );
			if ( percentMouse > 1 ) {
				percentMouse = 1;
			}
			if ( percentMouse < 0 ) {
				percentMouse = 0;
			}
			if ( this.orientation === "vertical" ) {
				percentMouse = 1 - percentMouse;
			}
	
			valueTotal = this._valueMax() - this._valueMin();
			valueMouse = this._valueMin() + percentMouse * valueTotal;
	
			return this._trimAlignValue( valueMouse );
		},
	
		_start: function( event, index ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}
			return this._trigger( "start", event, uiHash );
		},
	
		_slide: function( event, index, newVal ) {
			var otherVal,
				newValues,
				allowed;
	
			if ( this.options.values && this.options.values.length ) {
				otherVal = this.values( index ? 0 : 1 );
	
				if ( ( this.options.values.length === 2 && this.options.range === true ) &&
						( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
					) {
					newVal = otherVal;
				}
	
				if ( newVal !== this.values( index ) ) {
					newValues = this.values();
					newValues[ index ] = newVal;
					// A slide can be canceled by returning false from the slide callback
					allowed = this._trigger( "slide", event, {
						handle: this.handles[ index ],
						value: newVal,
						values: newValues
					} );
					otherVal = this.values( index ? 0 : 1 );
					if ( allowed !== false ) {
						this.values( index, newVal );
					}
				}
			} else {
				if ( newVal !== this.value() ) {
					// A slide can be canceled by returning false from the slide callback
					allowed = this._trigger( "slide", event, {
						handle: this.handles[ index ],
						value: newVal
					} );
					if ( allowed !== false ) {
						this.value( newVal );
					}
				}
			}
		},
	
		_stop: function( event, index ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}
	
			this._trigger( "stop", event, uiHash );
		},
	
		_change: function( event, index ) {
			if ( !this._keySliding && !this._mouseSliding ) {
				var uiHash = {
					handle: this.handles[ index ],
					value: this.value()
				};
				if ( this.options.values && this.options.values.length ) {
					uiHash.value = this.values( index );
					uiHash.values = this.values();
				}
	
				//store the last changed value index for reference when handles overlap
				this._lastChangedValue = index;
	
				this._trigger( "change", event, uiHash );
			}
		},
	
		value: function( newValue ) {
			if ( arguments.length ) {
				this.options.value = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, 0 );
				return;
			}
	
			return this._value();
		},
	
		values: function( index, newValue ) {
			var vals,
				newValues,
				i;
	
			if ( arguments.length > 1 ) {
				this.options.values[ index ] = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, index );
				return;
			}
	
			if ( arguments.length ) {
				if ( $.isArray( arguments[ 0 ] ) ) {
					vals = this.options.values;
					newValues = arguments[ 0 ];
					for ( i = 0; i < vals.length; i += 1 ) {
						vals[ i ] = this._trimAlignValue( newValues[ i ] );
						this._change( null, i );
					}
					this._refreshValue();
				} else {
					if ( this.options.values && this.options.values.length ) {
						return this._values( index );
					} else {
						return this.value();
					}
				}
			} else {
				return this._values();
			}
		},
	
		_setOption: function( key, value ) {
			var i,
				valsLength = 0;
	
			if ( key === "range" && this.options.range === true ) {
				if ( value === "min" ) {
					this.options.value = this._values( 0 );
					this.options.values = null;
				} else if ( value === "max" ) {
					this.options.value = this._values( this.options.values.length - 1 );
					this.options.values = null;
				}
			}
	
			if ( $.isArray( this.options.values ) ) {
				valsLength = this.options.values.length;
			}
	
			if ( key === "disabled" ) {
				this.element.toggleClass( "ui-state-disabled", !!value );
			}
	
			this._super( key, value );
	
			switch ( key ) {
				case "orientation":
					this._detectOrientation();
					this.element
						.removeClass( "ui-slider-horizontal ui-slider-vertical" )
						.addClass( "ui-slider-" + this.orientation );
					this._refreshValue();
	
					// Reset positioning from previous orientation
					this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
					break;
				case "value":
					this._animateOff = true;
					this._refreshValue();
					this._change( null, 0 );
					this._animateOff = false;
					break;
				case "values":
					this._animateOff = true;
					this._refreshValue();
					for ( i = 0; i < valsLength; i += 1 ) {
						this._change( null, i );
					}
					this._animateOff = false;
					break;
				case "step":
				case "min":
				case "max":
					this._animateOff = true;
					this._calculateNewMax();
					this._refreshValue();
					this._animateOff = false;
					break;
				case "range":
					this._animateOff = true;
					this._refresh();
					this._animateOff = false;
					break;
			}
		},
	
		//internal value getter
		// _value() returns value trimmed by min and max, aligned by step
		_value: function() {
			var val = this.options.value;
			val = this._trimAlignValue( val );
	
			return val;
		},
	
		//internal values getter
		// _values() returns array of values trimmed by min and max, aligned by step
		// _values( index ) returns single value trimmed by min and max, aligned by step
		_values: function( index ) {
			var val,
				vals,
				i;
	
			if ( arguments.length ) {
				val = this.options.values[ index ];
				val = this._trimAlignValue( val );
	
				return val;
			} else if ( this.options.values && this.options.values.length ) {
				// .slice() creates a copy of the array
				// this copy gets trimmed by min and max and then returned
				vals = this.options.values.slice();
				for ( i = 0; i < vals.length; i += 1) {
					vals[ i ] = this._trimAlignValue( vals[ i ] );
				}
	
				return vals;
			} else {
				return [];
			}
		},
	
		// returns the step-aligned value that val is closest to, between (inclusive) min and max
		_trimAlignValue: function( val ) {
			if ( val <= this._valueMin() ) {
				return this._valueMin();
			}
			if ( val >= this._valueMax() ) {
				return this._valueMax();
			}
			var step = ( this.options.step > 0 ) ? this.options.step : 1,
				valModStep = (val - this._valueMin()) % step,
				alignValue = val - valModStep;
	
			if ( Math.abs(valModStep) * 2 >= step ) {
				alignValue += ( valModStep > 0 ) ? step : ( -step );
			}
	
			// Since JavaScript has problems with large floats, round
			// the final value to 5 digits after the decimal point (see #4124)
			return parseFloat( alignValue.toFixed(5) );
		},
	
		_calculateNewMax: function() {
			var max = this.options.max,
				min = this._valueMin(),
				step = this.options.step,
				aboveMin = Math.floor( ( +( max - min ).toFixed( this._precision() ) ) / step ) * step;
			max = aboveMin + min;
			this.max = parseFloat( max.toFixed( this._precision() ) );
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_valueMin: function() {
			return this.options.min;
		},
	
		_valueMax: function() {
			return this.max;
		},
	
		_refreshValue: function() {
			var lastValPercent, valPercent, value, valueMin, valueMax,
				oRange = this.options.range,
				o = this.options,
				that = this,
				animate = ( !this._animateOff ) ? o.animate : false,
				_set = {};
	
			if ( this.options.values && this.options.values.length ) {
				this.handles.each(function( i ) {
					valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
					_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
					$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
					if ( that.options.range === true ) {
						if ( that.orientation === "horizontal" ) {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
							}
						} else {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
							}
						}
					}
					lastValPercent = valPercent;
				});
			} else {
				value = this.value();
				valueMin = this._valueMin();
				valueMax = this._valueMax();
				valPercent = ( valueMax !== valueMin ) ?
						( value - valueMin ) / ( valueMax - valueMin ) * 100 :
						0;
				_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
	
				if ( oRange === "min" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
				}
				if ( oRange === "max" && this.orientation === "horizontal" ) {
					this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
				}
				if ( oRange === "min" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
				}
				if ( oRange === "max" && this.orientation === "vertical" ) {
					this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
				}
			}
		},
	
		_handleEvents: {
			keydown: function( event ) {
				var allowed, curVal, newVal, step,
					index = $( event.target ).data( "ui-slider-handle-index" );
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						event.preventDefault();
						if ( !this._keySliding ) {
							this._keySliding = true;
							$( event.target ).addClass( "ui-state-active" );
							allowed = this._start( event, index );
							if ( allowed === false ) {
								return;
							}
						}
						break;
				}
	
				step = this.options.step;
				if ( this.options.values && this.options.values.length ) {
					curVal = newVal = this.values( index );
				} else {
					curVal = newVal = this.value();
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
						newVal = this._valueMin();
						break;
					case $.ui.keyCode.END:
						newVal = this._valueMax();
						break;
					case $.ui.keyCode.PAGE_UP:
						newVal = this._trimAlignValue(
							curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
						);
						break;
					case $.ui.keyCode.PAGE_DOWN:
						newVal = this._trimAlignValue(
							curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
						break;
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
						if ( curVal === this._valueMax() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal + step );
						break;
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						if ( curVal === this._valueMin() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal - step );
						break;
				}
	
				this._slide( event, index, newVal );
			},
			keyup: function( event ) {
				var index = $( event.target ).data( "ui-slider-handle-index" );
	
				if ( this._keySliding ) {
					this._keySliding = false;
					this._stop( event, index );
					this._change( event, index );
					$( event.target ).removeClass( "ui-state-active" );
				}
			}
		}
	});
	
	
	/*!
	 * jQuery UI Sortable 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/sortable/
	 */
	
	
	var sortable = $.widget("ui.sortable", $.ui.mouse, {
		version: "1.11.4",
		widgetEventPrefix: "sort",
		ready: false,
		options: {
			appendTo: "parent",
			axis: false,
			connectWith: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			dropOnEmpty: true,
			forcePlaceholderSize: false,
			forceHelperSize: false,
			grid: false,
			handle: false,
			helper: "original",
			items: "> *",
			opacity: false,
			placeholder: false,
			revert: false,
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			scope: "default",
			tolerance: "intersect",
			zIndex: 1000,
	
			// callbacks
			activate: null,
			beforeStop: null,
			change: null,
			deactivate: null,
			out: null,
			over: null,
			receive: null,
			remove: null,
			sort: null,
			start: null,
			stop: null,
			update: null
		},
	
		_isOverAxis: function( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		},
	
		_isFloating: function( item ) {
			return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
		},
	
		_create: function() {
			this.containerCache = {};
			this.element.addClass("ui-sortable");
	
			//Get the items
			this.refresh();
	
			//Let's determine the parent's offset
			this.offset = this.element.offset();
	
			//Initialize mouse events for interaction
			this._mouseInit();
	
			this._setHandleClassName();
	
			//We're ready to go
			this.ready = true;
	
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			if ( key === "handle" ) {
				this._setHandleClassName();
			}
		},
	
		_setHandleClassName: function() {
			this.element.find( ".ui-sortable-handle" ).removeClass( "ui-sortable-handle" );
			$.each( this.items, function() {
				( this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) : this.item )
					.addClass( "ui-sortable-handle" );
			});
		},
	
		_destroy: function() {
			this.element
				.removeClass( "ui-sortable ui-sortable-disabled" )
				.find( ".ui-sortable-handle" )
					.removeClass( "ui-sortable-handle" );
			this._mouseDestroy();
	
			for ( var i = this.items.length - 1; i >= 0; i-- ) {
				this.items[i].item.removeData(this.widgetName + "-item");
			}
	
			return this;
		},
	
		_mouseCapture: function(event, overrideHandle) {
			var currentItem = null,
				validHandle = false,
				that = this;
	
			if (this.reverting) {
				return false;
			}
	
			if(this.options.disabled || this.options.type === "static") {
				return false;
			}
	
			//We have to refresh the items data once first
			this._refreshItems(event);
	
			//Find out if the clicked node (or one of its parents) is a actual item in this.items
			$(event.target).parents().each(function() {
				if($.data(this, that.widgetName + "-item") === that) {
					currentItem = $(this);
					return false;
				}
			});
			if($.data(event.target, that.widgetName + "-item") === that) {
				currentItem = $(event.target);
			}
	
			if(!currentItem) {
				return false;
			}
			if(this.options.handle && !overrideHandle) {
				$(this.options.handle, currentItem).find("*").addBack().each(function() {
					if(this === event.target) {
						validHandle = true;
					}
				});
				if(!validHandle) {
					return false;
				}
			}
	
			this.currentItem = currentItem;
			this._removeCurrentsFromItems();
			return true;
	
		},
	
		_mouseStart: function(event, overrideHandle, noActivation) {
	
			var i, body,
				o = this.options;
	
			this.currentContainer = this;
	
			//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
			this.refreshPositions();
	
			//Create and append the visible helper
			this.helper = this._createHelper(event);
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Get the next scrolling parent
			this.scrollParent = this.helper.scrollParent();
	
			//The element's absolute position on the page minus margins
			this.offset = this.currentItem.offset();
			this.offset = {
				top: this.offset.top - this.margins.top,
				left: this.offset.left - this.margins.left
			};
	
			$.extend(this.offset, {
				click: { //Where the click happened, relative to the element
					left: event.pageX - this.offset.left,
					top: event.pageY - this.offset.top
				},
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
			});
	
			// Only after we got the offset, we can change the helper's position to absolute
			// TODO: Still need to figure out a way to make relative sorting possible
			this.helper.css("position", "absolute");
			this.cssPosition = this.helper.css("position");
	
			//Generate the original position
			this.originalPosition = this._generatePosition(event);
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));
	
			//Cache the former DOM position
			this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };
	
			//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
			if(this.helper[0] !== this.currentItem[0]) {
				this.currentItem.hide();
			}
	
			//Create the placeholder
			this._createPlaceholder();
	
			//Set a containment if given in the options
			if(o.containment) {
				this._setContainment();
			}
	
			if( o.cursor && o.cursor !== "auto" ) { // cursor option
				body = this.document.find( "body" );
	
				// support: IE
				this.storedCursor = body.css( "cursor" );
				body.css( "cursor", o.cursor );
	
				this.storedStylesheet = $( "<style>*{ cursor: "+o.cursor+" !important; }</style>" ).appendTo( body );
			}
	
			if(o.opacity) { // opacity option
				if (this.helper.css("opacity")) {
					this._storedOpacity = this.helper.css("opacity");
				}
				this.helper.css("opacity", o.opacity);
			}
	
			if(o.zIndex) { // zIndex option
				if (this.helper.css("zIndex")) {
					this._storedZIndex = this.helper.css("zIndex");
				}
				this.helper.css("zIndex", o.zIndex);
			}
	
			//Prepare scrolling
			if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
				this.overflowOffset = this.scrollParent.offset();
			}
	
			//Call callbacks
			this._trigger("start", event, this._uiHash());
	
			//Recache the helper size
			if(!this._preserveHelperProportions) {
				this._cacheHelperProportions();
			}
	
	
			//Post "activate" events to possible containers
			if( !noActivation ) {
				for ( i = this.containers.length - 1; i >= 0; i-- ) {
					this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
				}
			}
	
			//Prepare possible droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.current = this;
			}
	
			if ($.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
	
			this.dragging = true;
	
			this.helper.addClass("ui-sortable-helper");
			this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
			return true;
	
		},
	
		_mouseDrag: function(event) {
			var i, item, itemElement, intersection,
				o = this.options,
				scrolled = false;
	
			//Compute the helpers position
			this.position = this._generatePosition(event);
			this.positionAbs = this._convertPositionTo("absolute");
	
			if (!this.lastPositionAbs) {
				this.lastPositionAbs = this.positionAbs;
			}
	
			//Do scrolling
			if(this.options.scroll) {
				if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
	
					if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
					} else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
						this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
					}
	
					if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
					} else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
						this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
					}
	
				} else {
	
					if(event.pageY - this.document.scrollTop() < o.scrollSensitivity) {
						scrolled = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed);
					} else if(this.window.height() - (event.pageY - this.document.scrollTop()) < o.scrollSensitivity) {
						scrolled = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed);
					}
	
					if(event.pageX - this.document.scrollLeft() < o.scrollSensitivity) {
						scrolled = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed);
					} else if(this.window.width() - (event.pageX - this.document.scrollLeft()) < o.scrollSensitivity) {
						scrolled = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed);
					}
	
				}
	
				if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
					$.ui.ddmanager.prepareOffsets(this, event);
				}
			}
	
			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo("absolute");
	
			//Set the helper position
			if(!this.options.axis || this.options.axis !== "y") {
				this.helper[0].style.left = this.position.left+"px";
			}
			if(!this.options.axis || this.options.axis !== "x") {
				this.helper[0].style.top = this.position.top+"px";
			}
	
			//Rearrange
			for (i = this.items.length - 1; i >= 0; i--) {
	
				//Cache variables and intersection, continue if no intersection
				item = this.items[i];
				itemElement = item.item[0];
				intersection = this._intersectsWithPointer(item);
				if (!intersection) {
					continue;
				}
	
				// Only put the placeholder inside the current Container, skip all
				// items from other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this, moving items in "sub-sortables" can cause
				// the placeholder to jitter between the outer and inner container.
				if (item.instance !== this.currentContainer) {
					continue;
				}
	
				// cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if (itemElement !== this.currentItem[0] &&
					this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
					!$.contains(this.placeholder[0], itemElement) &&
					(this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
				) {
	
					this.direction = intersection === 1 ? "down" : "up";
	
					if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
						this._rearrange(event, item);
					} else {
						break;
					}
	
					this._trigger("change", event, this._uiHash());
					break;
				}
			}
	
			//Post events to containers
			this._contactContainers(event);
	
			//Interconnect with droppables
			if($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}
	
			//Call callbacks
			this._trigger("sort", event, this._uiHash());
	
			this.lastPositionAbs = this.positionAbs;
			return false;
	
		},
	
		_mouseStop: function(event, noPropagation) {
	
			if(!event) {
				return;
			}
	
			//If we are using droppables, inform the manager about the drop
			if ($.ui.ddmanager && !this.options.dropBehaviour) {
				$.ui.ddmanager.drop(this, event);
			}
	
			if(this.options.revert) {
				var that = this,
					cur = this.placeholder.offset(),
					axis = this.options.axis,
					animation = {};
	
				if ( !axis || axis === "x" ) {
					animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft);
				}
				if ( !axis || axis === "y" ) {
					animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop);
				}
				this.reverting = true;
				$(this.helper).animate( animation, parseInt(this.options.revert, 10) || 500, function() {
					that._clear(event);
				});
			} else {
				this._clear(event, noPropagation);
			}
	
			return false;
	
		},
	
		cancel: function() {
	
			if(this.dragging) {
	
				this._mouseUp({ target: null });
	
				if(this.options.helper === "original") {
					this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
				} else {
					this.currentItem.show();
				}
	
				//Post deactivating events to containers
				for (var i = this.containers.length - 1; i >= 0; i--){
					this.containers[i]._trigger("deactivate", null, this._uiHash(this));
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", null, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			if (this.placeholder) {
				//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
				if(this.placeholder[0].parentNode) {
					this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
				}
				if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
					this.helper.remove();
				}
	
				$.extend(this, {
					helper: null,
					dragging: false,
					reverting: false,
					_noFinalSort: null
				});
	
				if(this.domPosition.prev) {
					$(this.domPosition.prev).after(this.currentItem);
				} else {
					$(this.domPosition.parent).prepend(this.currentItem);
				}
			}
	
			return this;
	
		},
	
		serialize: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				str = [];
			o = o || {};
	
			$(items).each(function() {
				var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
				if (res) {
					str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
				}
			});
	
			if(!str.length && o.key) {
				str.push(o.key + "=");
			}
	
			return str.join("&");
	
		},
	
		toArray: function(o) {
	
			var items = this._getItemsAsjQuery(o && o.connected),
				ret = [];
	
			o = o || {};
	
			items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
			return ret;
	
		},
	
		/* Be careful with the following core functions */
		_intersectsWith: function(item) {
	
			var x1 = this.positionAbs.left,
				x2 = x1 + this.helperProportions.width,
				y1 = this.positionAbs.top,
				y2 = y1 + this.helperProportions.height,
				l = item.left,
				r = l + item.width,
				t = item.top,
				b = t + item.height,
				dyClick = this.offset.click.top,
				dxClick = this.offset.click.left,
				isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t && ( y1 + dyClick ) < b ),
				isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l && ( x1 + dxClick ) < r ),
				isOverElement = isOverElementHeight && isOverElementWidth;
	
			if ( this.options.tolerance === "pointer" ||
				this.options.forcePointerForContainers ||
				(this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
			) {
				return isOverElement;
			} else {
	
				return (l < x1 + (this.helperProportions.width / 2) && // Right Half
					x2 - (this.helperProportions.width / 2) < r && // Left Half
					t < y1 + (this.helperProportions.height / 2) && // Bottom Half
					y2 - (this.helperProportions.height / 2) < b ); // Top Half
	
			}
		},
	
		_intersectsWithPointer: function(item) {
	
			var isOverElementHeight = (this.options.axis === "x") || this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
				isOverElementWidth = (this.options.axis === "y") || this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
				isOverElement = isOverElementHeight && isOverElementWidth,
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (!isOverElement) {
				return false;
			}
	
			return this.floating ?
				( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
				: ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );
	
		},
	
		_intersectsWithSides: function(item) {
	
			var isOverBottomHalf = this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
				isOverRightHalf = this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();
	
			if (this.floating && horizontalDirection) {
				return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
			} else {
				return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
			}
	
		},
	
		_getDragVerticalDirection: function() {
			var delta = this.positionAbs.top - this.lastPositionAbs.top;
			return delta !== 0 && (delta > 0 ? "down" : "up");
		},
	
		_getDragHorizontalDirection: function() {
			var delta = this.positionAbs.left - this.lastPositionAbs.left;
			return delta !== 0 && (delta > 0 ? "right" : "left");
		},
	
		refresh: function(event) {
			this._refreshItems(event);
			this._setHandleClassName();
			this.refreshPositions();
			return this;
		},
	
		_connectWith: function() {
			var options = this.options;
			return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
		},
	
		_getItemsAsjQuery: function(connected) {
	
			var i, j, cur, inst,
				items = [],
				queries = [],
				connectWith = this._connectWith();
	
			if(connectWith && connected) {
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i], this.document[0]);
					for ( j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
						}
					}
				}
			}
	
			queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);
	
			function addItems() {
				items.push( this );
			}
			for (i = queries.length - 1; i >= 0; i--){
				queries[i][0].each( addItems );
			}
	
			return $(items);
	
		},
	
		_removeCurrentsFromItems: function() {
	
			var list = this.currentItem.find(":data(" + this.widgetName + "-item)");
	
			this.items = $.grep(this.items, function (item) {
				for (var j=0; j < list.length; j++) {
					if(list[j] === item.item[0]) {
						return false;
					}
				}
				return true;
			});
	
		},
	
		_refreshItems: function(event) {
	
			this.items = [];
			this.containers = [this];
	
			var i, j, cur, inst, targetData, _queries, item, queriesLength,
				items = this.items,
				queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
				connectWith = this._connectWith();
	
			if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
				for (i = connectWith.length - 1; i >= 0; i--){
					cur = $(connectWith[i], this.document[0]);
					for (j = cur.length - 1; j >= 0; j--){
						inst = $.data(cur[j], this.widgetFullName);
						if(inst && inst !== this && !inst.options.disabled) {
							queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
							this.containers.push(inst);
						}
					}
				}
			}
	
			for (i = queries.length - 1; i >= 0; i--) {
				targetData = queries[i][1];
				_queries = queries[i][0];
	
				for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
					item = $(_queries[j]);
	
					item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)
	
					items.push({
						item: item,
						instance: targetData,
						width: 0, height: 0,
						left: 0, top: 0
					});
				}
			}
	
		},
	
		refreshPositions: function(fast) {
	
			// Determine whether items are being displayed horizontally
			this.floating = this.items.length ?
				this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
				false;
	
			//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
			if(this.offsetParent && this.helper) {
				this.offset.parent = this._getParentOffset();
			}
	
			var i, item, t, p;
	
			for (i = this.items.length - 1; i >= 0; i--){
				item = this.items[i];
	
				//We ignore calculating positions of all connected containers when we're not over them
				if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
					continue;
				}
	
				t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;
	
				if (!fast) {
					item.width = t.outerWidth();
					item.height = t.outerHeight();
				}
	
				p = t.offset();
				item.left = p.left;
				item.top = p.top;
			}
	
			if(this.options.custom && this.options.custom.refreshContainers) {
				this.options.custom.refreshContainers.call(this);
			} else {
				for (i = this.containers.length - 1; i >= 0; i--){
					p = this.containers[i].element.offset();
					this.containers[i].containerCache.left = p.left;
					this.containers[i].containerCache.top = p.top;
					this.containers[i].containerCache.width = this.containers[i].element.outerWidth();
					this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
				}
			}
	
			return this;
		},
	
		_createPlaceholder: function(that) {
			that = that || this;
			var className,
				o = that.options;
	
			if(!o.placeholder || o.placeholder.constructor === String) {
				className = o.placeholder;
				o.placeholder = {
					element: function() {
	
						var nodeName = that.currentItem[0].nodeName.toLowerCase(),
							element = $( "<" + nodeName + ">", that.document[0] )
								.addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
								.removeClass("ui-sortable-helper");
	
						if ( nodeName === "tbody" ) {
							that._createTrPlaceholder(
								that.currentItem.find( "tr" ).eq( 0 ),
								$( "<tr>", that.document[ 0 ] ).appendTo( element )
							);
						} else if ( nodeName === "tr" ) {
							that._createTrPlaceholder( that.currentItem, element );
						} else if ( nodeName === "img" ) {
							element.attr( "src", that.currentItem.attr( "src" ) );
						}
	
						if ( !className ) {
							element.css( "visibility", "hidden" );
						}
	
						return element;
					},
					update: function(container, p) {
	
						// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
						// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
						if(className && !o.forcePlaceholderSize) {
							return;
						}
	
						//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
						if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
						if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
					}
				};
			}
	
			//Create the placeholder
			that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));
	
			//Append it after the actual current item
			that.currentItem.after(that.placeholder);
	
			//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
			o.placeholder.update(that, that.placeholder);
	
		},
	
		_createTrPlaceholder: function( sourceTr, targetTr ) {
			var that = this;
	
			sourceTr.children().each(function() {
				$( "<td>&#160;</td>", that.document[ 0 ] )
					.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
					.appendTo( targetTr );
			});
		},
	
		_contactContainers: function(event) {
			var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom, floating, axis,
				innermostContainer = null,
				innermostIndex = null;
	
			// get innermost container that intersects with item
			for (i = this.containers.length - 1; i >= 0; i--) {
	
				// never consider a container that's located within the item itself
				if($.contains(this.currentItem[0], this.containers[i].element[0])) {
					continue;
				}
	
				if(this._intersectsWith(this.containers[i].containerCache)) {
	
					// if we've already found a container and it's more "inner" than this, then continue
					if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
						continue;
					}
	
					innermostContainer = this.containers[i];
					innermostIndex = i;
	
				} else {
					// container doesn't intersect. trigger "out" event if necessary
					if(this.containers[i].containerCache.over) {
						this.containers[i]._trigger("out", event, this._uiHash(this));
						this.containers[i].containerCache.over = 0;
					}
				}
	
			}
	
			// if no intersecting containers found, return
			if(!innermostContainer) {
				return;
			}
	
			// move the item into the container if it's not there already
			if(this.containers.length === 1) {
				if (!this.containers[innermostIndex].containerCache.over) {
					this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
					this.containers[innermostIndex].containerCache.over = 1;
				}
			} else {
	
				//When entering a new container, we will find the item with the least distance and append our item near it
				dist = 10000;
				itemWithLeastDistance = null;
				floating = innermostContainer.floating || this._isFloating(this.currentItem);
				posProperty = floating ? "left" : "top";
				sizeProperty = floating ? "width" : "height";
				axis = floating ? "clientX" : "clientY";
	
				for (j = this.items.length - 1; j >= 0; j--) {
					if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
						continue;
					}
					if(this.items[j].item[0] === this.currentItem[0]) {
						continue;
					}
	
					cur = this.items[j].item.offset()[posProperty];
					nearBottom = false;
					if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
						nearBottom = true;
					}
	
					if ( Math.abs( event[ axis ] - cur ) < dist ) {
						dist = Math.abs( event[ axis ] - cur );
						itemWithLeastDistance = this.items[ j ];
						this.direction = nearBottom ? "up": "down";
					}
				}
	
				//Check if dropOnEmpty is enabled
				if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
					return;
				}
	
				if(this.currentContainer === this.containers[innermostIndex]) {
					if ( !this.currentContainer.containerCache.over ) {
						this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
						this.currentContainer.containerCache.over = 1;
					}
					return;
				}
	
				itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
				this._trigger("change", event, this._uiHash());
				this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
				this.currentContainer = this.containers[innermostIndex];
	
				//Update the placeholder
				this.options.placeholder.update(this.currentContainer, this.placeholder);
	
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			}
	
	
		},
	
		_createHelper: function(event) {
	
			var o = this.options,
				helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);
	
			//Add the helper to the DOM if that didn't happen already
			if(!helper.parents("body").length) {
				$(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
			}
	
			if(helper[0] === this.currentItem[0]) {
				this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
			}
	
			if(!helper[0].style.width || o.forceHelperSize) {
				helper.width(this.currentItem.width());
			}
			if(!helper[0].style.height || o.forceHelperSize) {
				helper.height(this.currentItem.height());
			}
	
			return helper;
	
		},
	
		_adjustOffsetFromHelper: function(obj) {
			if (typeof obj === "string") {
				obj = obj.split(" ");
			}
			if ($.isArray(obj)) {
				obj = {left: +obj[0], top: +obj[1] || 0};
			}
			if ("left" in obj) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ("right" in obj) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ("top" in obj) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ("bottom" in obj) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_getParentOffset: function() {
	
	
			//Get the offsetParent and cache its position
			this.offsetParent = this.helper.offsetParent();
			var po = this.offsetParent.offset();
	
			// This is a special case where we need to modify a offset calculated on start, since the following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
			//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
			if(this.cssPosition === "absolute" && this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			// This needs to be actually done for all browsers, since pageX/pageY includes this information
			// with an ugly IE fix
			if( this.offsetParent[0] === this.document[0].body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
				left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
			};
	
		},
	
		_getRelativeOffset: function() {
	
			if(this.cssPosition === "relative") {
				var p = this.currentItem.position();
				return {
					top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
					left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
				};
			} else {
				return { top: 0, left: 0 };
			}
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
				top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var ce, co, over,
				o = this.options;
			if(o.containment === "parent") {
				o.containment = this.helper[0].parentNode;
			}
			if(o.containment === "document" || o.containment === "window") {
				this.containment = [
					0 - this.offset.relative.left - this.offset.parent.left,
					0 - this.offset.relative.top - this.offset.parent.top,
					o.containment === "document" ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left,
					(o.containment === "document" ? this.document.width() : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
				];
			}
	
			if(!(/^(document|window|parent)$/).test(o.containment)) {
				ce = $(o.containment)[0];
				co = $(o.containment).offset();
				over = ($(ce).css("overflow") !== "hidden");
	
				this.containment = [
					co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
					co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
					co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
					co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
				];
			}
	
		},
	
		_convertPositionTo: function(d, pos) {
	
			if(!pos) {
				pos = this.position;
			}
			var mod = d === "absolute" ? 1 : -1,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
				scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			return {
				top: (
					pos.top	+																// The absolute mouse position
					this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
				),
				left: (
					pos.left +																// The absolute mouse position
					this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
				)
			};
	
		},
	
		_generatePosition: function(event) {
	
			var top, left,
				o = this.options,
				pageX = event.pageX,
				pageY = event.pageY,
				scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
	
			// This is another very weird special case that only happens for relative elements:
			// 1. If the css position is relative
			// 2. and the scroll parent is the document or similar to the offset parent
			// we have to refresh the relative offset during the scroll so there are no jumps
			if(this.cssPosition === "relative" && !(this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0])) {
				this.offset.relative = this._getRelativeOffset();
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			if(this.originalPosition) { //If we are not dragging yet, we won't check for options
	
				if(this.containment) {
					if(event.pageX - this.offset.click.left < this.containment[0]) {
						pageX = this.containment[0] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top < this.containment[1]) {
						pageY = this.containment[1] + this.offset.click.top;
					}
					if(event.pageX - this.offset.click.left > this.containment[2]) {
						pageX = this.containment[2] + this.offset.click.left;
					}
					if(event.pageY - this.offset.click.top > this.containment[3]) {
						pageY = this.containment[3] + this.offset.click.top;
					}
				}
	
				if(o.grid) {
					top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
					pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;
	
					left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
					pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
				}
	
			}
	
			return {
				top: (
					pageY -																// The absolute mouse position
					this.offset.click.top -													// Click offset (relative to the element)
					this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
				),
				left: (
					pageX -																// The absolute mouse position
					this.offset.click.left -												// Click offset (relative to the element)
					this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
					( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
				)
			};
	
		},
	
		_rearrange: function(event, i, a, hardRefresh) {
	
			a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));
	
			//Various things done here to improve the performance:
			// 1. we create a setTimeout, that calls refreshPositions
			// 2. on the instance, we have a counter variable, that get's higher after every append
			// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
			// 4. this lets only the last addition to the timeout stack through
			this.counter = this.counter ? ++this.counter : 1;
			var counter = this.counter;
	
			this._delay(function() {
				if(counter === this.counter) {
					this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
				}
			});
	
		},
	
		_clear: function(event, noPropagation) {
	
			this.reverting = false;
			// We delay all events that have to be triggered to after the point where the placeholder has been removed and
			// everything else normalized again
			var i,
				delayedTriggers = [];
	
			// We first have to update the dom position of the actual currentItem
			// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
			if(!this._noFinalSort && this.currentItem.parent().length) {
				this.placeholder.before(this.currentItem);
			}
			this._noFinalSort = null;
	
			if(this.helper[0] === this.currentItem[0]) {
				for(i in this._storedCSS) {
					if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
						this._storedCSS[i] = "";
					}
				}
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			} else {
				this.currentItem.show();
			}
	
			if(this.fromOutside && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
			}
			if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
			}
	
			// Check if the items Container has Changed and trigger appropriate
			// events.
			if (this !== this.currentContainer) {
				if(!noPropagation) {
					delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
					delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
					delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
				}
			}
	
	
			//Post events to containers
			function delayEvent( type, instance, container ) {
				return function( event ) {
					container._trigger( type, event, instance._uiHash( instance ) );
				};
			}
			for (i = this.containers.length - 1; i >= 0; i--){
				if (!noPropagation) {
					delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
				}
				if(this.containers[i].containerCache.over) {
					delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
					this.containers[i].containerCache.over = 0;
				}
			}
	
			//Do what was originally in plugins
			if ( this.storedCursor ) {
				this.document.find( "body" ).css( "cursor", this.storedCursor );
				this.storedStylesheet.remove();
			}
			if(this._storedOpacity) {
				this.helper.css("opacity", this._storedOpacity);
			}
			if(this._storedZIndex) {
				this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
			}
	
			this.dragging = false;
	
			if(!noPropagation) {
				this._trigger("beforeStop", event, this._uiHash());
			}
	
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
	
			if ( !this.cancelHelperRemoval ) {
				if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
					this.helper.remove();
				}
				this.helper = null;
			}
	
			if(!noPropagation) {
				for (i=0; i < delayedTriggers.length; i++) {
					delayedTriggers[i].call(this, event);
				} //Trigger all delayed events
				this._trigger("stop", event, this._uiHash());
			}
	
			this.fromOutside = false;
			return !this.cancelHelperRemoval;
	
		},
	
		_trigger: function() {
			if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
				this.cancel();
			}
		},
	
		_uiHash: function(_inst) {
			var inst = _inst || this;
			return {
				helper: inst.helper,
				placeholder: inst.placeholder || $([]),
				position: inst.position,
				originalPosition: inst.originalPosition,
				offset: inst.positionAbs,
				item: inst.currentItem,
				sender: _inst ? _inst.element : null
			};
		}
	
	});
	
	
	/*!
	 * jQuery UI Spinner 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/spinner/
	 */
	
	
	function spinner_modifier( fn ) {
		return function() {
			var previous = this.element.val();
			fn.apply( this, arguments );
			this._refresh();
			if ( previous !== this.element.val() ) {
				this._trigger( "change" );
			}
		};
	}
	
	var spinner = $.widget( "ui.spinner", {
		version: "1.11.4",
		defaultElement: "<input>",
		widgetEventPrefix: "spin",
		options: {
			culture: null,
			icons: {
				down: "ui-icon-triangle-1-s",
				up: "ui-icon-triangle-1-n"
			},
			incremental: true,
			max: null,
			min: null,
			numberFormat: null,
			page: 10,
			step: 1,
	
			change: null,
			spin: null,
			start: null,
			stop: null
		},
	
		_create: function() {
			// handle string values that need to be parsed
			this._setOption( "max", this.options.max );
			this._setOption( "min", this.options.min );
			this._setOption( "step", this.options.step );
	
			// Only format if there is a value, prevents the field from being marked
			// as invalid in Firefox, see #9573.
			if ( this.value() !== "" ) {
				// Format the value, but don't constrain.
				this._value( this.element.val(), true );
			}
	
			this._draw();
			this._on( this._events );
			this._refresh();
	
			// turning off autocomplete prevents the browser from remembering the
			// value when navigating through history, so we re-enable autocomplete
			// if the page is unloaded before the widget is destroyed. #7790
			this._on( this.window, {
				beforeunload: function() {
					this.element.removeAttr( "autocomplete" );
				}
			});
		},
	
		_getCreateOptions: function() {
			var options = {},
				element = this.element;
	
			$.each( [ "min", "max", "step" ], function( i, option ) {
				var value = element.attr( option );
				if ( value !== undefined && value.length ) {
					options[ option ] = value;
				}
			});
	
			return options;
		},
	
		_events: {
			keydown: function( event ) {
				if ( this._start( event ) && this._keydown( event ) ) {
					event.preventDefault();
				}
			},
			keyup: "_stop",
			focus: function() {
				this.previous = this.element.val();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}
	
				this._stop();
				this._refresh();
				if ( this.previous !== this.element.val() ) {
					this._trigger( "change", event );
				}
			},
			mousewheel: function( event, delta ) {
				if ( !delta ) {
					return;
				}
				if ( !this.spinning && !this._start( event ) ) {
					return false;
				}
	
				this._spin( (delta > 0 ? 1 : -1) * this.options.step, event );
				clearTimeout( this.mousewheelTimer );
				this.mousewheelTimer = this._delay(function() {
					if ( this.spinning ) {
						this._stop( event );
					}
				}, 100 );
				event.preventDefault();
			},
			"mousedown .ui-spinner-button": function( event ) {
				var previous;
	
				// We never want the buttons to have focus; whenever the user is
				// interacting with the spinner, the focus should be on the input.
				// If the input is focused then this.previous is properly set from
				// when the input first received focus. If the input is not focused
				// then we need to set this.previous based on the value before spinning.
				previous = this.element[0] === this.document[0].activeElement ?
					this.previous : this.element.val();
				function checkFocus() {
					var isActive = this.element[0] === this.document[0].activeElement;
					if ( !isActive ) {
						this.element.focus();
						this.previous = previous;
						// support: IE
						// IE sets focus asynchronously, so we need to check if focus
						// moved off of the input because the user clicked on the button.
						this._delay(function() {
							this.previous = previous;
						});
					}
				}
	
				// ensure focus is on (or stays on) the text field
				event.preventDefault();
				checkFocus.call( this );
	
				// support: IE
				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				// and check (again) if focus moved off of the input.
				this.cancelBlur = true;
				this._delay(function() {
					delete this.cancelBlur;
					checkFocus.call( this );
				});
	
				if ( this._start( event ) === false ) {
					return;
				}
	
				this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
			},
			"mouseup .ui-spinner-button": "_stop",
			"mouseenter .ui-spinner-button": function( event ) {
				// button will add ui-state-active if mouse was down while mouseleave and kept down
				if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
					return;
				}
	
				if ( this._start( event ) === false ) {
					return false;
				}
				this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
			},
			// TODO: do we really want to consider this a stop?
			// shouldn't we just stop the repeater and wait until mouseup before
			// we trigger the stop event?
			"mouseleave .ui-spinner-button": "_stop"
		},
	
		_draw: function() {
			var uiSpinner = this.uiSpinner = this.element
				.addClass( "ui-spinner-input" )
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()
					// add buttons
					.append( this._buttonHtml() );
	
			this.element.attr( "role", "spinbutton" );
	
			// button bindings
			this.buttons = uiSpinner.find( ".ui-spinner-button" )
				.attr( "tabIndex", -1 )
				.button()
				.removeClass( "ui-corner-all" );
	
			// IE 6 doesn't understand height: 50% for the buttons
			// unless the wrapper has an explicit height
			if ( this.buttons.height() > Math.ceil( uiSpinner.height() * 0.5 ) &&
					uiSpinner.height() > 0 ) {
				uiSpinner.height( uiSpinner.height() );
			}
	
			// disable spinner if element was already disabled
			if ( this.options.disabled ) {
				this.disable();
			}
		},
	
		_keydown: function( event ) {
			var options = this.options,
				keyCode = $.ui.keyCode;
	
			switch ( event.keyCode ) {
			case keyCode.UP:
				this._repeat( null, 1, event );
				return true;
			case keyCode.DOWN:
				this._repeat( null, -1, event );
				return true;
			case keyCode.PAGE_UP:
				this._repeat( null, options.page, event );
				return true;
			case keyCode.PAGE_DOWN:
				this._repeat( null, -options.page, event );
				return true;
			}
	
			return false;
		},
	
		_uiSpinnerHtml: function() {
			return "<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>";
		},
	
		_buttonHtml: function() {
			return "" +
				"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'>" +
					"<span class='ui-icon " + this.options.icons.up + "'>&#9650;</span>" +
				"</a>" +
				"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>" +
					"<span class='ui-icon " + this.options.icons.down + "'>&#9660;</span>" +
				"</a>";
		},
	
		_start: function( event ) {
			if ( !this.spinning && this._trigger( "start", event ) === false ) {
				return false;
			}
	
			if ( !this.counter ) {
				this.counter = 1;
			}
			this.spinning = true;
			return true;
		},
	
		_repeat: function( i, steps, event ) {
			i = i || 500;
	
			clearTimeout( this.timer );
			this.timer = this._delay(function() {
				this._repeat( 40, steps, event );
			}, i );
	
			this._spin( steps * this.options.step, event );
		},
	
		_spin: function( step, event ) {
			var value = this.value() || 0;
	
			if ( !this.counter ) {
				this.counter = 1;
			}
	
			value = this._adjustValue( value + step * this._increment( this.counter ) );
	
			if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false) {
				this._value( value );
				this.counter++;
			}
		},
	
		_increment: function( i ) {
			var incremental = this.options.incremental;
	
			if ( incremental ) {
				return $.isFunction( incremental ) ?
					incremental( i ) :
					Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
			}
	
			return 1;
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_adjustValue: function( value ) {
			var base, aboveMin,
				options = this.options;
	
			// make sure we're at a valid step
			// - find out where we are relative to the base (min or 0)
			base = options.min !== null ? options.min : 0;
			aboveMin = value - base;
			// - round to the nearest step
			aboveMin = Math.round(aboveMin / options.step) * options.step;
			// - rounding is based on 0, so adjust back to our base
			value = base + aboveMin;
	
			// fix precision from bad JS floating point math
			value = parseFloat( value.toFixed( this._precision() ) );
	
			// clamp the value
			if ( options.max !== null && value > options.max) {
				return options.max;
			}
			if ( options.min !== null && value < options.min ) {
				return options.min;
			}
	
			return value;
		},
	
		_stop: function( event ) {
			if ( !this.spinning ) {
				return;
			}
	
			clearTimeout( this.timer );
			clearTimeout( this.mousewheelTimer );
			this.counter = 0;
			this.spinning = false;
			this._trigger( "stop", event );
		},
	
		_setOption: function( key, value ) {
			if ( key === "culture" || key === "numberFormat" ) {
				var prevValue = this._parse( this.element.val() );
				this.options[ key ] = value;
				this.element.val( this._format( prevValue ) );
				return;
			}
	
			if ( key === "max" || key === "min" || key === "step" ) {
				if ( typeof value === "string" ) {
					value = this._parse( value );
				}
			}
			if ( key === "icons" ) {
				this.buttons.first().find( ".ui-icon" )
					.removeClass( this.options.icons.up )
					.addClass( value.up );
				this.buttons.last().find( ".ui-icon" )
					.removeClass( this.options.icons.down )
					.addClass( value.down );
			}
	
			this._super( key, value );
	
			if ( key === "disabled" ) {
				this.widget().toggleClass( "ui-state-disabled", !!value );
				this.element.prop( "disabled", !!value );
				this.buttons.button( value ? "disable" : "enable" );
			}
		},
	
		_setOptions: spinner_modifier(function( options ) {
			this._super( options );
		}),
	
		_parse: function( val ) {
			if ( typeof val === "string" && val !== "" ) {
				val = window.Globalize && this.options.numberFormat ?
					Globalize.parseFloat( val, 10, this.options.culture ) : +val;
			}
			return val === "" || isNaN( val ) ? null : val;
		},
	
		_format: function( value ) {
			if ( value === "" ) {
				return "";
			}
			return window.Globalize && this.options.numberFormat ?
				Globalize.format( value, this.options.numberFormat, this.options.culture ) :
				value;
		},
	
		_refresh: function() {
			this.element.attr({
				"aria-valuemin": this.options.min,
				"aria-valuemax": this.options.max,
				// TODO: what should we do with values that can't be parsed?
				"aria-valuenow": this._parse( this.element.val() )
			});
		},
	
		isValid: function() {
			var value = this.value();
	
			// null is invalid
			if ( value === null ) {
				return false;
			}
	
			// if value gets adjusted, it's invalid
			return value === this._adjustValue( value );
		},
	
		// update the value without triggering change
		_value: function( value, allowAny ) {
			var parsed;
			if ( value !== "" ) {
				parsed = this._parse( value );
				if ( parsed !== null ) {
					if ( !allowAny ) {
						parsed = this._adjustValue( parsed );
					}
					value = this._format( parsed );
				}
			}
			this.element.val( value );
			this._refresh();
		},
	
		_destroy: function() {
			this.element
				.removeClass( "ui-spinner-input" )
				.prop( "disabled", false )
				.removeAttr( "autocomplete" )
				.removeAttr( "role" )
				.removeAttr( "aria-valuemin" )
				.removeAttr( "aria-valuemax" )
				.removeAttr( "aria-valuenow" );
			this.uiSpinner.replaceWith( this.element );
		},
	
		stepUp: spinner_modifier(function( steps ) {
			this._stepUp( steps );
		}),
		_stepUp: function( steps ) {
			if ( this._start() ) {
				this._spin( (steps || 1) * this.options.step );
				this._stop();
			}
		},
	
		stepDown: spinner_modifier(function( steps ) {
			this._stepDown( steps );
		}),
		_stepDown: function( steps ) {
			if ( this._start() ) {
				this._spin( (steps || 1) * -this.options.step );
				this._stop();
			}
		},
	
		pageUp: spinner_modifier(function( pages ) {
			this._stepUp( (pages || 1) * this.options.page );
		}),
	
		pageDown: spinner_modifier(function( pages ) {
			this._stepDown( (pages || 1) * this.options.page );
		}),
	
		value: function( newVal ) {
			if ( !arguments.length ) {
				return this._parse( this.element.val() );
			}
			spinner_modifier( this._value ).call( this, newVal );
		},
	
		widget: function() {
			return this.uiSpinner;
		}
	});
	
	
	/*!
	 * jQuery UI Tabs 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/tabs/
	 */
	
	
	var tabs = $.widget( "ui.tabs", {
		version: "1.11.4",
		delay: 300,
		options: {
			active: null,
			collapsible: false,
			event: "click",
			heightStyle: "content",
			hide: null,
			show: null,
	
			// callbacks
			activate: null,
			beforeActivate: null,
			beforeLoad: null,
			load: null
		},
	
		_isLocal: (function() {
			var rhash = /#.*$/;
	
			return function( anchor ) {
				var anchorUrl, locationUrl;
	
				// support: IE7
				// IE7 doesn't normalize the href property when set via script (#9317)
				anchor = anchor.cloneNode( false );
	
				anchorUrl = anchor.href.replace( rhash, "" );
				locationUrl = location.href.replace( rhash, "" );
	
				// decoding may throw an error if the URL isn't UTF-8 (#9518)
				try {
					anchorUrl = decodeURIComponent( anchorUrl );
				} catch ( error ) {}
				try {
					locationUrl = decodeURIComponent( locationUrl );
				} catch ( error ) {}
	
				return anchor.hash.length > 1 && anchorUrl === locationUrl;
			};
		})(),
	
		_create: function() {
			var that = this,
				options = this.options;
	
			this.running = false;
	
			this.element
				.addClass( "ui-tabs ui-widget ui-widget-content ui-corner-all" )
				.toggleClass( "ui-tabs-collapsible", options.collapsible );
	
			this._processTabs();
			options.active = this._initialActive();
	
			// Take disabling tabs via class attribute from HTML
			// into account and update option properly.
			if ( $.isArray( options.disabled ) ) {
				options.disabled = $.unique( options.disabled.concat(
					$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
						return that.tabs.index( li );
					})
				) ).sort();
			}
	
			// check for length avoids error when initializing empty list
			if ( this.options.active !== false && this.anchors.length ) {
				this.active = this._findActive( options.active );
			} else {
				this.active = $();
			}
	
			this._refresh();
	
			if ( this.active.length ) {
				this.load( options.active );
			}
		},
	
		_initialActive: function() {
			var active = this.options.active,
				collapsible = this.options.collapsible,
				locationHash = location.hash.substring( 1 );
	
			if ( active === null ) {
				// check the fragment identifier in the URL
				if ( locationHash ) {
					this.tabs.each(function( i, tab ) {
						if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
							active = i;
							return false;
						}
					});
				}
	
				// check for a tab marked active via a class
				if ( active === null ) {
					active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
				}
	
				// no active tab, set to false
				if ( active === null || active === -1 ) {
					active = this.tabs.length ? 0 : false;
				}
			}
	
			// handle numbers: negative, out of range
			if ( active !== false ) {
				active = this.tabs.index( this.tabs.eq( active ) );
				if ( active === -1 ) {
					active = collapsible ? false : 0;
				}
			}
	
			// don't allow collapsible: false and active: false
			if ( !collapsible && active === false && this.anchors.length ) {
				active = 0;
			}
	
			return active;
		},
	
		_getCreateEventData: function() {
			return {
				tab: this.active,
				panel: !this.active.length ? $() : this._getPanelForTab( this.active )
			};
		},
	
		_tabKeydown: function( event ) {
			var focusedTab = $( this.document[0].activeElement ).closest( "li" ),
				selectedIndex = this.tabs.index( focusedTab ),
				goingForward = true;
	
			if ( this._handlePageNav( event ) ) {
				return;
			}
	
			switch ( event.keyCode ) {
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
					selectedIndex++;
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.LEFT:
					goingForward = false;
					selectedIndex--;
					break;
				case $.ui.keyCode.END:
					selectedIndex = this.anchors.length - 1;
					break;
				case $.ui.keyCode.HOME:
					selectedIndex = 0;
					break;
				case $.ui.keyCode.SPACE:
					// Activate only, no collapsing
					event.preventDefault();
					clearTimeout( this.activating );
					this._activate( selectedIndex );
					return;
				case $.ui.keyCode.ENTER:
					// Toggle (cancel delayed activation, allow collapsing)
					event.preventDefault();
					clearTimeout( this.activating );
					// Determine if we should collapse or activate
					this._activate( selectedIndex === this.options.active ? false : selectedIndex );
					return;
				default:
					return;
			}
	
			// Focus the appropriate tab, based on which key was pressed
			event.preventDefault();
			clearTimeout( this.activating );
			selectedIndex = this._focusNextTab( selectedIndex, goingForward );
	
			// Navigating with control/command key will prevent automatic activation
			if ( !event.ctrlKey && !event.metaKey ) {
	
				// Update aria-selected immediately so that AT think the tab is already selected.
				// Otherwise AT may confuse the user by stating that they need to activate the tab,
				// but the tab will already be activated by the time the announcement finishes.
				focusedTab.attr( "aria-selected", "false" );
				this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );
	
				this.activating = this._delay(function() {
					this.option( "active", selectedIndex );
				}, this.delay );
			}
		},
	
		_panelKeydown: function( event ) {
			if ( this._handlePageNav( event ) ) {
				return;
			}
	
			// Ctrl+up moves focus to the current tab
			if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
				event.preventDefault();
				this.active.focus();
			}
		},
	
		// Alt+page up/down moves focus to the previous/next tab (and activates)
		_handlePageNav: function( event ) {
			if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
				this._activate( this._focusNextTab( this.options.active - 1, false ) );
				return true;
			}
			if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
				this._activate( this._focusNextTab( this.options.active + 1, true ) );
				return true;
			}
		},
	
		_findNextTab: function( index, goingForward ) {
			var lastTabIndex = this.tabs.length - 1;
	
			function constrain() {
				if ( index > lastTabIndex ) {
					index = 0;
				}
				if ( index < 0 ) {
					index = lastTabIndex;
				}
				return index;
			}
	
			while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
				index = goingForward ? index + 1 : index - 1;
			}
	
			return index;
		},
	
		_focusNextTab: function( index, goingForward ) {
			index = this._findNextTab( index, goingForward );
			this.tabs.eq( index ).focus();
			return index;
		},
	
		_setOption: function( key, value ) {
			if ( key === "active" ) {
				// _activate() will handle invalid values and update this.options
				this._activate( value );
				return;
			}
	
			if ( key === "disabled" ) {
				// don't use the widget factory's disabled handling
				this._setupDisabled( value );
				return;
			}
	
			this._super( key, value);
	
			if ( key === "collapsible" ) {
				this.element.toggleClass( "ui-tabs-collapsible", value );
				// Setting collapsible: false while collapsed; open first panel
				if ( !value && this.options.active === false ) {
					this._activate( 0 );
				}
			}
	
			if ( key === "event" ) {
				this._setupEvents( value );
			}
	
			if ( key === "heightStyle" ) {
				this._setupHeightStyle( value );
			}
		},
	
		_sanitizeSelector: function( hash ) {
			return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
		},
	
		refresh: function() {
			var options = this.options,
				lis = this.tablist.children( ":has(a[href])" );
	
			// get disabled tabs from class attribute from HTML
			// this will get converted to a boolean if needed in _refresh()
			options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
				return lis.index( tab );
			});
	
			this._processTabs();
	
			// was collapsed or no tabs
			if ( options.active === false || !this.anchors.length ) {
				options.active = false;
				this.active = $();
			// was active, but active tab is gone
			} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {
				// all remaining tabs are disabled
				if ( this.tabs.length === options.disabled.length ) {
					options.active = false;
					this.active = $();
				// activate previous tab
				} else {
					this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
				}
			// was active, active tab still exists
			} else {
				// make sure active index is correct
				options.active = this.tabs.index( this.active );
			}
	
			this._refresh();
		},
	
		_refresh: function() {
			this._setupDisabled( this.options.disabled );
			this._setupEvents( this.options.event );
			this._setupHeightStyle( this.options.heightStyle );
	
			this.tabs.not( this.active ).attr({
				"aria-selected": "false",
				"aria-expanded": "false",
				tabIndex: -1
			});
			this.panels.not( this._getPanelForTab( this.active ) )
				.hide()
				.attr({
					"aria-hidden": "true"
				});
	
			// Make sure one tab is in the tab order
			if ( !this.active.length ) {
				this.tabs.eq( 0 ).attr( "tabIndex", 0 );
			} else {
				this.active
					.addClass( "ui-tabs-active ui-state-active" )
					.attr({
						"aria-selected": "true",
						"aria-expanded": "true",
						tabIndex: 0
					});
				this._getPanelForTab( this.active )
					.show()
					.attr({
						"aria-hidden": "false"
					});
			}
		},
	
		_processTabs: function() {
			var that = this,
				prevTabs = this.tabs,
				prevAnchors = this.anchors,
				prevPanels = this.panels;
	
			this.tablist = this._getList()
				.addClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
				.attr( "role", "tablist" )
	
				// Prevent users from focusing disabled tabs via click
				.delegate( "> li", "mousedown" + this.eventNamespace, function( event ) {
					if ( $( this ).is( ".ui-state-disabled" ) ) {
						event.preventDefault();
					}
				})
	
				// support: IE <9
				// Preventing the default action in mousedown doesn't prevent IE
				// from focusing the element, so if the anchor gets focused, blur.
				// We don't have to worry about focusing the previously focused
				// element since clicking on a non-focusable element should focus
				// the body anyway.
				.delegate( ".ui-tabs-anchor", "focus" + this.eventNamespace, function() {
					if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
						this.blur();
					}
				});
	
			this.tabs = this.tablist.find( "> li:has(a[href])" )
				.addClass( "ui-state-default ui-corner-top" )
				.attr({
					role: "tab",
					tabIndex: -1
				});
	
			this.anchors = this.tabs.map(function() {
					return $( "a", this )[ 0 ];
				})
				.addClass( "ui-tabs-anchor" )
				.attr({
					role: "presentation",
					tabIndex: -1
				});
	
			this.panels = $();
	
			this.anchors.each(function( i, anchor ) {
				var selector, panel, panelId,
					anchorId = $( anchor ).uniqueId().attr( "id" ),
					tab = $( anchor ).closest( "li" ),
					originalAriaControls = tab.attr( "aria-controls" );
	
				// inline tab
				if ( that._isLocal( anchor ) ) {
					selector = anchor.hash;
					panelId = selector.substring( 1 );
					panel = that.element.find( that._sanitizeSelector( selector ) );
				// remote tab
				} else {
					// If the tab doesn't already have aria-controls,
					// generate an id by using a throw-away element
					panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
					selector = "#" + panelId;
					panel = that.element.find( selector );
					if ( !panel.length ) {
						panel = that._createPanel( panelId );
						panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
					}
					panel.attr( "aria-live", "polite" );
				}
	
				if ( panel.length) {
					that.panels = that.panels.add( panel );
				}
				if ( originalAriaControls ) {
					tab.data( "ui-tabs-aria-controls", originalAriaControls );
				}
				tab.attr({
					"aria-controls": panelId,
					"aria-labelledby": anchorId
				});
				panel.attr( "aria-labelledby", anchorId );
			});
	
			this.panels
				.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
				.attr( "role", "tabpanel" );
	
			// Avoid memory leaks (#10056)
			if ( prevTabs ) {
				this._off( prevTabs.not( this.tabs ) );
				this._off( prevAnchors.not( this.anchors ) );
				this._off( prevPanels.not( this.panels ) );
			}
		},
	
		// allow overriding how to find the list for rare usage scenarios (#7715)
		_getList: function() {
			return this.tablist || this.element.find( "ol,ul" ).eq( 0 );
		},
	
		_createPanel: function( id ) {
			return $( "<div>" )
				.attr( "id", id )
				.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
				.data( "ui-tabs-destroy", true );
		},
	
		_setupDisabled: function( disabled ) {
			if ( $.isArray( disabled ) ) {
				if ( !disabled.length ) {
					disabled = false;
				} else if ( disabled.length === this.anchors.length ) {
					disabled = true;
				}
			}
	
			// disable tabs
			for ( var i = 0, li; ( li = this.tabs[ i ] ); i++ ) {
				if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
					$( li )
						.addClass( "ui-state-disabled" )
						.attr( "aria-disabled", "true" );
				} else {
					$( li )
						.removeClass( "ui-state-disabled" )
						.removeAttr( "aria-disabled" );
				}
			}
	
			this.options.disabled = disabled;
		},
	
		_setupEvents: function( event ) {
			var events = {};
			if ( event ) {
				$.each( event.split(" "), function( index, eventName ) {
					events[ eventName ] = "_eventHandler";
				});
			}
	
			this._off( this.anchors.add( this.tabs ).add( this.panels ) );
			// Always prevent the default action, even when disabled
			this._on( true, this.anchors, {
				click: function( event ) {
					event.preventDefault();
				}
			});
			this._on( this.anchors, events );
			this._on( this.tabs, { keydown: "_tabKeydown" } );
			this._on( this.panels, { keydown: "_panelKeydown" } );
	
			this._focusable( this.tabs );
			this._hoverable( this.tabs );
		},
	
		_setupHeightStyle: function( heightStyle ) {
			var maxHeight,
				parent = this.element.parent();
	
			if ( heightStyle === "fill" ) {
				maxHeight = parent.height();
				maxHeight -= this.element.outerHeight() - this.element.height();
	
				this.element.siblings( ":visible" ).each(function() {
					var elem = $( this ),
						position = elem.css( "position" );
	
					if ( position === "absolute" || position === "fixed" ) {
						return;
					}
					maxHeight -= elem.outerHeight( true );
				});
	
				this.element.children().not( this.panels ).each(function() {
					maxHeight -= $( this ).outerHeight( true );
				});
	
				this.panels.each(function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				})
				.css( "overflow", "auto" );
			} else if ( heightStyle === "auto" ) {
				maxHeight = 0;
				this.panels.each(function() {
					maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
				}).height( maxHeight );
			}
		},
	
		_eventHandler: function( event ) {
			var options = this.options,
				active = this.active,
				anchor = $( event.currentTarget ),
				tab = anchor.closest( "li" ),
				clickedIsActive = tab[ 0 ] === active[ 0 ],
				collapsing = clickedIsActive && options.collapsible,
				toShow = collapsing ? $() : this._getPanelForTab( tab ),
				toHide = !active.length ? $() : this._getPanelForTab( active ),
				eventData = {
					oldTab: active,
					oldPanel: toHide,
					newTab: collapsing ? $() : tab,
					newPanel: toShow
				};
	
			event.preventDefault();
	
			if ( tab.hasClass( "ui-state-disabled" ) ||
					// tab is already loading
					tab.hasClass( "ui-tabs-loading" ) ||
					// can't switch durning an animation
					this.running ||
					// click on active header, but not collapsible
					( clickedIsActive && !options.collapsible ) ||
					// allow canceling activation
					( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
				return;
			}
	
			options.active = collapsing ? false : this.tabs.index( tab );
	
			this.active = clickedIsActive ? $() : tab;
			if ( this.xhr ) {
				this.xhr.abort();
			}
	
			if ( !toHide.length && !toShow.length ) {
				$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
			}
	
			if ( toShow.length ) {
				this.load( this.tabs.index( tab ), event );
			}
			this._toggle( event, eventData );
		},
	
		// handles show/hide for selecting tabs
		_toggle: function( event, eventData ) {
			var that = this,
				toShow = eventData.newPanel,
				toHide = eventData.oldPanel;
	
			this.running = true;
	
			function complete() {
				that.running = false;
				that._trigger( "activate", event, eventData );
			}
	
			function show() {
				eventData.newTab.closest( "li" ).addClass( "ui-tabs-active ui-state-active" );
	
				if ( toShow.length && that.options.show ) {
					that._show( toShow, that.options.show, complete );
				} else {
					toShow.show();
					complete();
				}
			}
	
			// start out by hiding, then showing, then completing
			if ( toHide.length && this.options.hide ) {
				this._hide( toHide, this.options.hide, function() {
					eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
					show();
				});
			} else {
				eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
				toHide.hide();
				show();
			}
	
			toHide.attr( "aria-hidden", "true" );
			eventData.oldTab.attr({
				"aria-selected": "false",
				"aria-expanded": "false"
			});
			// If we're switching tabs, remove the old tab from the tab order.
			// If we're opening from collapsed state, remove the previous tab from the tab order.
			// If we're collapsing, then keep the collapsing tab in the tab order.
			if ( toShow.length && toHide.length ) {
				eventData.oldTab.attr( "tabIndex", -1 );
			} else if ( toShow.length ) {
				this.tabs.filter(function() {
					return $( this ).attr( "tabIndex" ) === 0;
				})
				.attr( "tabIndex", -1 );
			}
	
			toShow.attr( "aria-hidden", "false" );
			eventData.newTab.attr({
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			});
		},
	
		_activate: function( index ) {
			var anchor,
				active = this._findActive( index );
	
			// trying to activate the already active panel
			if ( active[ 0 ] === this.active[ 0 ] ) {
				return;
			}
	
			// trying to collapse, simulate a click on the current active header
			if ( !active.length ) {
				active = this.active;
			}
	
			anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
			this._eventHandler({
				target: anchor,
				currentTarget: anchor,
				preventDefault: $.noop
			});
		},
	
		_findActive: function( index ) {
			return index === false ? $() : this.tabs.eq( index );
		},
	
		_getIndex: function( index ) {
			// meta-function to give users option to provide a href string instead of a numerical index.
			if ( typeof index === "string" ) {
				index = this.anchors.index( this.anchors.filter( "[href$='" + index + "']" ) );
			}
	
			return index;
		},
	
		_destroy: function() {
			if ( this.xhr ) {
				this.xhr.abort();
			}
	
			this.element.removeClass( "ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible" );
	
			this.tablist
				.removeClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
				.removeAttr( "role" );
	
			this.anchors
				.removeClass( "ui-tabs-anchor" )
				.removeAttr( "role" )
				.removeAttr( "tabIndex" )
				.removeUniqueId();
	
			this.tablist.unbind( this.eventNamespace );
	
			this.tabs.add( this.panels ).each(function() {
				if ( $.data( this, "ui-tabs-destroy" ) ) {
					$( this ).remove();
				} else {
					$( this )
						.removeClass( "ui-state-default ui-state-active ui-state-disabled " +
							"ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel" )
						.removeAttr( "tabIndex" )
						.removeAttr( "aria-live" )
						.removeAttr( "aria-busy" )
						.removeAttr( "aria-selected" )
						.removeAttr( "aria-labelledby" )
						.removeAttr( "aria-hidden" )
						.removeAttr( "aria-expanded" )
						.removeAttr( "role" );
				}
			});
	
			this.tabs.each(function() {
				var li = $( this ),
					prev = li.data( "ui-tabs-aria-controls" );
				if ( prev ) {
					li
						.attr( "aria-controls", prev )
						.removeData( "ui-tabs-aria-controls" );
				} else {
					li.removeAttr( "aria-controls" );
				}
			});
	
			this.panels.show();
	
			if ( this.options.heightStyle !== "content" ) {
				this.panels.css( "height", "" );
			}
		},
	
		enable: function( index ) {
			var disabled = this.options.disabled;
			if ( disabled === false ) {
				return;
			}
	
			if ( index === undefined ) {
				disabled = false;
			} else {
				index = this._getIndex( index );
				if ( $.isArray( disabled ) ) {
					disabled = $.map( disabled, function( num ) {
						return num !== index ? num : null;
					});
				} else {
					disabled = $.map( this.tabs, function( li, num ) {
						return num !== index ? num : null;
					});
				}
			}
			this._setupDisabled( disabled );
		},
	
		disable: function( index ) {
			var disabled = this.options.disabled;
			if ( disabled === true ) {
				return;
			}
	
			if ( index === undefined ) {
				disabled = true;
			} else {
				index = this._getIndex( index );
				if ( $.inArray( index, disabled ) !== -1 ) {
					return;
				}
				if ( $.isArray( disabled ) ) {
					disabled = $.merge( [ index ], disabled ).sort();
				} else {
					disabled = [ index ];
				}
			}
			this._setupDisabled( disabled );
		},
	
		load: function( index, event ) {
			index = this._getIndex( index );
			var that = this,
				tab = this.tabs.eq( index ),
				anchor = tab.find( ".ui-tabs-anchor" ),
				panel = this._getPanelForTab( tab ),
				eventData = {
					tab: tab,
					panel: panel
				},
				complete = function( jqXHR, status ) {
					if ( status === "abort" ) {
						that.panels.stop( false, true );
					}
	
					tab.removeClass( "ui-tabs-loading" );
					panel.removeAttr( "aria-busy" );
	
					if ( jqXHR === that.xhr ) {
						delete that.xhr;
					}
				};
	
			// not remote
			if ( this._isLocal( anchor[ 0 ] ) ) {
				return;
			}
	
			this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );
	
			// support: jQuery <1.8
			// jQuery <1.8 returns false if the request is canceled in beforeSend,
			// but as of 1.8, $.ajax() always returns a jqXHR object.
			if ( this.xhr && this.xhr.statusText !== "canceled" ) {
				tab.addClass( "ui-tabs-loading" );
				panel.attr( "aria-busy", "true" );
	
				this.xhr
					.done(function( response, status, jqXHR ) {
						// support: jQuery <1.8
						// http://bugs.jquery.com/ticket/11778
						setTimeout(function() {
							panel.html( response );
							that._trigger( "load", event, eventData );
	
							complete( jqXHR, status );
						}, 1 );
					})
					.fail(function( jqXHR, status ) {
						// support: jQuery <1.8
						// http://bugs.jquery.com/ticket/11778
						setTimeout(function() {
							complete( jqXHR, status );
						}, 1 );
					});
			}
		},
	
		_ajaxSettings: function( anchor, event, eventData ) {
			var that = this;
			return {
				url: anchor.attr( "href" ),
				beforeSend: function( jqXHR, settings ) {
					return that._trigger( "beforeLoad", event,
						$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
				}
			};
		},
	
		_getPanelForTab: function( tab ) {
			var id = $( tab ).attr( "aria-controls" );
			return this.element.find( this._sanitizeSelector( "#" + id ) );
		}
	});
	
	
	/*!
	 * jQuery UI Tooltip 1.11.4
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/tooltip/
	 */
	
	
	var tooltip = $.widget( "ui.tooltip", {
		version: "1.11.4",
		options: {
			content: function() {
				// support: IE<9, Opera in jQuery <1.7
				// .text() can't accept undefined, so coerce to a string
				var title = $( this ).attr( "title" ) || "";
				// Escape title, since we're going from an attribute to raw HTML
				return $( "<a>" ).text( title ).html();
			},
			hide: true,
			// Disabled elements have inconsistent behavior across browsers (#8661)
			items: "[title]:not([disabled])",
			position: {
				my: "left top+15",
				at: "left bottom",
				collision: "flipfit flip"
			},
			show: true,
			tooltipClass: null,
			track: false,
	
			// callbacks
			close: null,
			open: null
		},
	
		_addDescribedBy: function( elem, id ) {
			var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
			describedby.push( id );
			elem
				.data( "ui-tooltip-id", id )
				.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
		},
	
		_removeDescribedBy: function( elem ) {
			var id = elem.data( "ui-tooltip-id" ),
				describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
				index = $.inArray( id, describedby );
	
			if ( index !== -1 ) {
				describedby.splice( index, 1 );
			}
	
			elem.removeData( "ui-tooltip-id" );
			describedby = $.trim( describedby.join( " " ) );
			if ( describedby ) {
				elem.attr( "aria-describedby", describedby );
			} else {
				elem.removeAttr( "aria-describedby" );
			}
		},
	
		_create: function() {
			this._on({
				mouseover: "open",
				focusin: "open"
			});
	
			// IDs of generated tooltips, needed for destroy
			this.tooltips = {};
	
			// IDs of parent tooltips where we removed the title attribute
			this.parents = {};
	
			if ( this.options.disabled ) {
				this._disable();
			}
	
			// Append the aria-live region so tooltips announce correctly
			this.liveRegion = $( "<div>" )
				.attr({
					role: "log",
					"aria-live": "assertive",
					"aria-relevant": "additions"
				})
				.addClass( "ui-helper-hidden-accessible" )
				.appendTo( this.document[ 0 ].body );
		},
	
		_setOption: function( key, value ) {
			var that = this;
	
			if ( key === "disabled" ) {
				this[ value ? "_disable" : "_enable" ]();
				this.options[ key ] = value;
				// disable element style changes
				return;
			}
	
			this._super( key, value );
	
			if ( key === "content" ) {
				$.each( this.tooltips, function( id, tooltipData ) {
					that._updateContent( tooltipData.element );
				});
			}
		},
	
		_disable: function() {
			var that = this;
	
			// close open tooltips
			$.each( this.tooltips, function( id, tooltipData ) {
				var event = $.Event( "blur" );
				event.target = event.currentTarget = tooltipData.element[ 0 ];
				that.close( event, true );
			});
	
			// remove title attributes to prevent native tooltips
			this.element.find( this.options.items ).addBack().each(function() {
				var element = $( this );
				if ( element.is( "[title]" ) ) {
					element
						.data( "ui-tooltip-title", element.attr( "title" ) )
						.removeAttr( "title" );
				}
			});
		},
	
		_enable: function() {
			// restore title attributes
			this.element.find( this.options.items ).addBack().each(function() {
				var element = $( this );
				if ( element.data( "ui-tooltip-title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
			});
		},
	
		open: function( event ) {
			var that = this,
				target = $( event ? event.target : this.element )
					// we need closest here due to mouseover bubbling,
					// but always pointing at the same event target
					.closest( this.options.items );
	
			// No element to show a tooltip for or the tooltip is already open
			if ( !target.length || target.data( "ui-tooltip-id" ) ) {
				return;
			}
	
			if ( target.attr( "title" ) ) {
				target.data( "ui-tooltip-title", target.attr( "title" ) );
			}
	
			target.data( "ui-tooltip-open", true );
	
			// kill parent tooltips, custom or native, for hover
			if ( event && event.type === "mouseover" ) {
				target.parents().each(function() {
					var parent = $( this ),
						blurEvent;
					if ( parent.data( "ui-tooltip-open" ) ) {
						blurEvent = $.Event( "blur" );
						blurEvent.target = blurEvent.currentTarget = this;
						that.close( blurEvent, true );
					}
					if ( parent.attr( "title" ) ) {
						parent.uniqueId();
						that.parents[ this.id ] = {
							element: this,
							title: parent.attr( "title" )
						};
						parent.attr( "title", "" );
					}
				});
			}
	
			this._registerCloseHandlers( event, target );
			this._updateContent( target, event );
		},
	
		_updateContent: function( target, event ) {
			var content,
				contentOption = this.options.content,
				that = this,
				eventType = event ? event.type : null;
	
			if ( typeof contentOption === "string" ) {
				return this._open( event, target, contentOption );
			}
	
			content = contentOption.call( target[0], function( response ) {
	
				// IE may instantly serve a cached response for ajax requests
				// delay this call to _open so the other call to _open runs first
				that._delay(function() {
	
					// Ignore async response if tooltip was closed already
					if ( !target.data( "ui-tooltip-open" ) ) {
						return;
					}
	
					// jQuery creates a special event for focusin when it doesn't
					// exist natively. To improve performance, the native event
					// object is reused and the type is changed. Therefore, we can't
					// rely on the type being correct after the event finished
					// bubbling, so we set it back to the previous value. (#8740)
					if ( event ) {
						event.type = eventType;
					}
					this._open( event, target, response );
				});
			});
			if ( content ) {
				this._open( event, target, content );
			}
		},
	
		_open: function( event, target, content ) {
			var tooltipData, tooltip, delayedShow, a11yContent,
				positionOption = $.extend( {}, this.options.position );
	
			if ( !content ) {
				return;
			}
	
			// Content can be updated multiple times. If the tooltip already
			// exists, then just update the content and bail.
			tooltipData = this._find( target );
			if ( tooltipData ) {
				tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
				return;
			}
	
			// if we have a title, clear it to prevent the native tooltip
			// we have to check first to avoid defining a title if none exists
			// (we don't want to cause an element to start matching [title])
			//
			// We use removeAttr only for key events, to allow IE to export the correct
			// accessible attributes. For mouse events, set to empty string to avoid
			// native tooltip showing up (happens only when removing inside mouseover).
			if ( target.is( "[title]" ) ) {
				if ( event && event.type === "mouseover" ) {
					target.attr( "title", "" );
				} else {
					target.removeAttr( "title" );
				}
			}
	
			tooltipData = this._tooltip( target );
			tooltip = tooltipData.tooltip;
			this._addDescribedBy( target, tooltip.attr( "id" ) );
			tooltip.find( ".ui-tooltip-content" ).html( content );
	
			// Support: Voiceover on OS X, JAWS on IE <= 9
			// JAWS announces deletions even when aria-relevant="additions"
			// Voiceover will sometimes re-read the entire log region's contents from the beginning
			this.liveRegion.children().hide();
			if ( content.clone ) {
				a11yContent = content.clone();
				a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
			} else {
				a11yContent = content;
			}
			$( "<div>" ).html( a11yContent ).appendTo( this.liveRegion );
	
			function position( event ) {
				positionOption.of = event;
				if ( tooltip.is( ":hidden" ) ) {
					return;
				}
				tooltip.position( positionOption );
			}
			if ( this.options.track && event && /^mouse/.test( event.type ) ) {
				this._on( this.document, {
					mousemove: position
				});
				// trigger once to override element-relative positioning
				position( event );
			} else {
				tooltip.position( $.extend({
					of: target
				}, this.options.position ) );
			}
	
			tooltip.hide();
	
			this._show( tooltip, this.options.show );
			// Handle tracking tooltips that are shown with a delay (#8644). As soon
			// as the tooltip is visible, position the tooltip using the most recent
			// event.
			if ( this.options.show && this.options.show.delay ) {
				delayedShow = this.delayedShow = setInterval(function() {
					if ( tooltip.is( ":visible" ) ) {
						position( positionOption.of );
						clearInterval( delayedShow );
					}
				}, $.fx.interval );
			}
	
			this._trigger( "open", event, { tooltip: tooltip } );
		},
	
		_registerCloseHandlers: function( event, target ) {
			var events = {
				keyup: function( event ) {
					if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
						var fakeEvent = $.Event(event);
						fakeEvent.currentTarget = target[0];
						this.close( fakeEvent, true );
					}
				}
			};
	
			// Only bind remove handler for delegated targets. Non-delegated
			// tooltips will handle this in destroy.
			if ( target[ 0 ] !== this.element[ 0 ] ) {
				events.remove = function() {
					this._removeTooltip( this._find( target ).tooltip );
				};
			}
	
			if ( !event || event.type === "mouseover" ) {
				events.mouseleave = "close";
			}
			if ( !event || event.type === "focusin" ) {
				events.focusout = "close";
			}
			this._on( true, target, events );
		},
	
		close: function( event ) {
			var tooltip,
				that = this,
				target = $( event ? event.currentTarget : this.element ),
				tooltipData = this._find( target );
	
			// The tooltip may already be closed
			if ( !tooltipData ) {
	
				// We set ui-tooltip-open immediately upon open (in open()), but only set the
				// additional data once there's actually content to show (in _open()). So even if the
				// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
				// the period between open() and _open().
				target.removeData( "ui-tooltip-open" );
				return;
			}
	
			tooltip = tooltipData.tooltip;
	
			// disabling closes the tooltip, so we need to track when we're closing
			// to avoid an infinite loop in case the tooltip becomes disabled on close
			if ( tooltipData.closing ) {
				return;
			}
	
			// Clear the interval for delayed tracking tooltips
			clearInterval( this.delayedShow );
	
			// only set title if we had one before (see comment in _open())
			// If the title attribute has changed since open(), don't restore
			if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
				target.attr( "title", target.data( "ui-tooltip-title" ) );
			}
	
			this._removeDescribedBy( target );
	
			tooltipData.hiding = true;
			tooltip.stop( true );
			this._hide( tooltip, this.options.hide, function() {
				that._removeTooltip( $( this ) );
			});
	
			target.removeData( "ui-tooltip-open" );
			this._off( target, "mouseleave focusout keyup" );
	
			// Remove 'remove' binding only on delegated targets
			if ( target[ 0 ] !== this.element[ 0 ] ) {
				this._off( target, "remove" );
			}
			this._off( this.document, "mousemove" );
	
			if ( event && event.type === "mouseleave" ) {
				$.each( this.parents, function( id, parent ) {
					$( parent.element ).attr( "title", parent.title );
					delete that.parents[ id ];
				});
			}
	
			tooltipData.closing = true;
			this._trigger( "close", event, { tooltip: tooltip } );
			if ( !tooltipData.hiding ) {
				tooltipData.closing = false;
			}
		},
	
		_tooltip: function( element ) {
			var tooltip = $( "<div>" )
					.attr( "role", "tooltip" )
					.addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
						( this.options.tooltipClass || "" ) ),
				id = tooltip.uniqueId().attr( "id" );
	
			$( "<div>" )
				.addClass( "ui-tooltip-content" )
				.appendTo( tooltip );
	
			tooltip.appendTo( this.document[0].body );
	
			return this.tooltips[ id ] = {
				element: element,
				tooltip: tooltip
			};
		},
	
		_find: function( target ) {
			var id = target.data( "ui-tooltip-id" );
			return id ? this.tooltips[ id ] : null;
		},
	
		_removeTooltip: function( tooltip ) {
			tooltip.remove();
			delete this.tooltips[ tooltip.attr( "id" ) ];
		},
	
		_destroy: function() {
			var that = this;
	
			// close open tooltips
			$.each( this.tooltips, function( id, tooltipData ) {
				// Delegate to close method to handle common cleanup
				var event = $.Event( "blur" ),
					element = tooltipData.element;
				event.target = event.currentTarget = element[ 0 ];
				that.close( event, true );
	
				// Remove immediately; destroying an open tooltip doesn't use the
				// hide animation
				$( "#" + id ).remove();
	
				// Restore the title
				if ( element.data( "ui-tooltip-title" ) ) {
					// If the title attribute has changed since open(), don't restore
					if ( !element.attr( "title" ) ) {
						element.attr( "title", element.data( "ui-tooltip-title" ) );
					}
					element.removeData( "ui-tooltip-title" );
				}
			});
			this.liveRegion.remove();
		}
	});
	
	
	
	}));

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(21);
	var Stream = __webpack_require__(173);
	var _extends = __webpack_require__(10);
	var _assertThisInitialized = __webpack_require__(19);
	var decodeB64ToUint8Array = __webpack_require__(23);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var Stream__default = /*#__PURE__*/_interopDefaultLegacy(Stream);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	/**
	 * A stream that buffers string input and generates a `data` event for each
	 * line.
	 *
	 * @class LineStream
	 * @extends Stream
	 */
	
	var LineStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](LineStream, _Stream);
	
	  function LineStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.buffer = '';
	    return _this;
	  }
	  /**
	   * Add new data to be parsed.
	   *
	   * @param {string} data the text to process
	   */
	
	
	  var _proto = LineStream.prototype;
	
	  _proto.push = function push(data) {
	    var nextNewline;
	    this.buffer += data;
	    nextNewline = this.buffer.indexOf('\n');
	
	    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
	      this.trigger('data', this.buffer.substring(0, nextNewline));
	      this.buffer = this.buffer.substring(nextNewline + 1);
	    }
	  };
	
	  return LineStream;
	}(Stream__default['default']);
	
	var TAB = String.fromCharCode(0x09);
	
	var parseByterange = function parseByterange(byterangeString) {
	  // optionally match and capture 0+ digits before `@`
	  // optionally match and capture 0+ digits after `@`
	  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
	  var result = {};
	
	  if (match[1]) {
	    result.length = parseInt(match[1], 10);
	  }
	
	  if (match[2]) {
	    result.offset = parseInt(match[2], 10);
	  }
	
	  return result;
	};
	/**
	 * "forgiving" attribute list psuedo-grammar:
	 * attributes -> keyvalue (',' keyvalue)*
	 * keyvalue   -> key '=' value
	 * key        -> [^=]*
	 * value      -> '"' [^"]* '"' | [^,]*
	 */
	
	
	var attributeSeparator = function attributeSeparator() {
	  var key = '[^=]*';
	  var value = '"[^"]*"|[^,]*';
	  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
	  return new RegExp('(?:^|,)(' + keyvalue + ')');
	};
	/**
	 * Parse attributes from a line given the separator
	 *
	 * @param {string} attributes the attribute line to parse
	 */
	
	
	var parseAttributes = function parseAttributes(attributes) {
	  // split the string using attributes as the separator
	  var attrs = attributes.split(attributeSeparator());
	  var result = {};
	  var i = attrs.length;
	  var attr;
	
	  while (i--) {
	    // filter out unmatched portions of the string
	    if (attrs[i] === '') {
	      continue;
	    } // split the key and value
	
	
	    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
	
	    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
	    result[attr[0]] = attr[1];
	  }
	
	  return result;
	};
	/**
	 * A line-level M3U8 parser event stream. It expects to receive input one
	 * line at a time and performs a context-free parse of its contents. A stream
	 * interpretation of a manifest can be useful if the manifest is expected to
	 * be too large to fit comfortably into memory or the entirety of the input
	 * is not immediately available. Otherwise, it's probably much easier to work
	 * with a regular `Parser` object.
	 *
	 * Produces `data` events with an object that captures the parser's
	 * interpretation of the input. That object has a property `tag` that is one
	 * of `uri`, `comment`, or `tag`. URIs only have a single additional
	 * property, `line`, which captures the entirety of the input without
	 * interpretation. Comments similarly have a single additional property
	 * `text` which is the input without the leading `#`.
	 *
	 * Tags always have a property `tagType` which is the lower-cased version of
	 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
	 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
	 * tags are given the tag type `unknown` and a single additional property
	 * `data` with the remainder of the input.
	 *
	 * @class ParseStream
	 * @extends Stream
	 */
	
	
	var ParseStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](ParseStream, _Stream);
	
	  function ParseStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.customParsers = [];
	    _this.tagMappers = [];
	    return _this;
	  }
	  /**
	   * Parses an additional line of input.
	   *
	   * @param {string} line a single line of an M3U8 file to parse
	   */
	
	
	  var _proto = ParseStream.prototype;
	
	  _proto.push = function push(line) {
	    var _this2 = this;
	
	    var match;
	    var event; // strip whitespace
	
	    line = line.trim();
	
	    if (line.length === 0) {
	      // ignore empty lines
	      return;
	    } // URIs
	
	
	    if (line[0] !== '#') {
	      this.trigger('data', {
	        type: 'uri',
	        uri: line
	      });
	      return;
	    } // map tags
	
	
	    var newLines = this.tagMappers.reduce(function (acc, mapper) {
	      var mappedLine = mapper(line); // skip if unchanged
	
	      if (mappedLine === line) {
	        return acc;
	      }
	
	      return acc.concat([mappedLine]);
	    }, [line]);
	    newLines.forEach(function (newLine) {
	      for (var i = 0; i < _this2.customParsers.length; i++) {
	        if (_this2.customParsers[i].call(_this2, newLine)) {
	          return;
	        }
	      } // Comments
	
	
	      if (newLine.indexOf('#EXT') !== 0) {
	        _this2.trigger('data', {
	          type: 'comment',
	          text: newLine.slice(1)
	        });
	
	        return;
	      } // strip off any carriage returns here so the regex matching
	      // doesn't have to account for them.
	
	
	      newLine = newLine.replace('\r', ''); // Tags
	
	      match = /^#EXTM3U/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'm3u'
	        });
	
	        return;
	      }
	
	      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'inf'
	        };
	
	        if (match[1]) {
	          event.duration = parseFloat(match[1]);
	        }
	
	        if (match[2]) {
	          event.title = match[2];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'targetduration'
	        };
	
	        if (match[1]) {
	          event.duration = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'version'
	        };
	
	        if (match[1]) {
	          event.version = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'discontinuity-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'playlist-type'
	        };
	
	        if (match[1]) {
	          event.playlistType = match[1];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = _extends__default['default'](parseByterange(match[1]), {
	          type: 'tag',
	          tagType: 'byterange'
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'allow-cache'
	        };
	
	        if (match[1]) {
	          event.allowed = !/NO/.test(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'map'
	        };
	
	        if (match[1]) {
	          var attributes = parseAttributes(match[1]);
	
	          if (attributes.URI) {
	            event.uri = attributes.URI;
	          }
	
	          if (attributes.BYTERANGE) {
	            event.byterange = parseByterange(attributes.BYTERANGE);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'stream-inf'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	
	          if (event.attributes.RESOLUTION) {
	            var split = event.attributes.RESOLUTION.split('x');
	            var resolution = {};
	
	            if (split[0]) {
	              resolution.width = parseInt(split[0], 10);
	            }
	
	            if (split[1]) {
	              resolution.height = parseInt(split[1], 10);
	            }
	
	            event.attributes.RESOLUTION = resolution;
	          }
	
	          if (event.attributes.BANDWIDTH) {
	            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
	          }
	
	          if (event.attributes['FRAME-RATE']) {
	            event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
	          }
	
	          if (event.attributes['PROGRAM-ID']) {
	            event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ENDLIST/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'endlist'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'discontinuity'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'program-date-time'
	        };
	
	        if (match[1]) {
	          event.dateTimeString = match[1];
	          event.dateTimeObject = new Date(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'key'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]); // parse the IV string into a Uint32Array
	
	          if (event.attributes.IV) {
	            if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
	              event.attributes.IV = event.attributes.IV.substring(2);
	            }
	
	            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
	            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
	            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
	            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
	            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
	            event.attributes.IV = new Uint32Array(event.attributes.IV);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'start'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	          event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
	          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out-cont'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-in'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'skip'
	        };
	        event.attributes = parseAttributes(match[1]);
	
	        if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) {
	          event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
	        }
	
	        if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) {
	          event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split(TAB);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['DURATION'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['INDEPENDENT', 'GAP'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        if (event.attributes.hasOwnProperty('BYTERANGE')) {
	          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'server-control'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['CAN-SKIP-UNTIL', 'PART-HOLD-BACK', 'HOLD-BACK'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['CAN-SKIP-DATERANGES', 'CAN-BLOCK-RELOAD'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part-inf'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['PART-TARGET'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'preload-hint'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['BYTERANGE-START', 'BYTERANGE-LENGTH'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	            var subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
	            event.attributes.byterange = event.attributes.byterange || {};
	            event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
	
	            delete event.attributes[key];
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'rendition-report'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['LAST-MSN', 'LAST-PART'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      } // unknown tag type
	
	
	      _this2.trigger('data', {
	        type: 'tag',
	        data: newLine.slice(4)
	      });
	    });
	  }
	  /**
	   * Add a parser for custom headers
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.customType   the custom type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(_ref) {
	    var _this3 = this;
	
	    var expression = _ref.expression,
	        customType = _ref.customType,
	        dataParser = _ref.dataParser,
	        segment = _ref.segment;
	
	    if (typeof dataParser !== 'function') {
	      dataParser = function dataParser(line) {
	        return line;
	      };
	    }
	
	    this.customParsers.push(function (line) {
	      var match = expression.exec(line);
	
	      if (match) {
	        _this3.trigger('data', {
	          type: 'custom',
	          data: dataParser(line),
	          customType: customType,
	          segment: segment
	        });
	
	        return true;
	      }
	    });
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(_ref2) {
	    var expression = _ref2.expression,
	        map = _ref2.map;
	
	    var mapFn = function mapFn(line) {
	      if (expression.test(line)) {
	        return map(line);
	      }
	
	      return line;
	    };
	
	    this.tagMappers.push(mapFn);
	  };
	
	  return ParseStream;
	}(Stream__default['default']);
	
	var camelCase = function camelCase(str) {
	  return str.toLowerCase().replace(/-(\w)/g, function (a) {
	    return a[1].toUpperCase();
	  });
	};
	
	var camelCaseKeys = function camelCaseKeys(attributes) {
	  var result = {};
	  Object.keys(attributes).forEach(function (key) {
	    result[camelCase(key)] = attributes[key];
	  });
	  return result;
	}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
	// we need this helper because defaults are based upon targetDuration and
	// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
	// target durations are set.
	
	
	var setHoldBack = function setHoldBack(manifest) {
	  var serverControl = manifest.serverControl,
	      targetDuration = manifest.targetDuration,
	      partTargetDuration = manifest.partTargetDuration;
	
	  if (!serverControl) {
	    return;
	  }
	
	  var tag = '#EXT-X-SERVER-CONTROL';
	  var hb = 'holdBack';
	  var phb = 'partHoldBack';
	  var minTargetDuration = targetDuration && targetDuration * 3;
	  var minPartDuration = partTargetDuration && partTargetDuration * 2;
	
	  if (targetDuration && !serverControl.hasOwnProperty(hb)) {
	    serverControl[hb] = minTargetDuration;
	    this.trigger('info', {
	      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
	    });
	  }
	
	  if (minTargetDuration && serverControl[hb] < minTargetDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping HOLD-BACK (" + serverControl[hb] + ") to targetDuration * 3 (" + minTargetDuration + ")"
	    });
	    serverControl[hb] = minTargetDuration;
	  } // default no part hold back to part target duration * 3
	
	
	  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
	    serverControl[phb] = partTargetDuration * 3;
	    this.trigger('info', {
	      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
	    });
	  } // if part hold back is too small default it to part target duration * 2
	
	
	  if (partTargetDuration && serverControl[phb] < minPartDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
	    });
	    serverControl[phb] = minPartDuration;
	  }
	};
	/**
	 * A parser for M3U8 files. The current interpretation of the input is
	 * exposed as a property `manifest` on parser objects. It's just two lines to
	 * create and parse a manifest once you have the contents available as a string:
	 *
	 * ```js
	 * var parser = new m3u8.Parser();
	 * parser.push(xhr.responseText);
	 * ```
	 *
	 * New input can later be applied to update the manifest object by calling
	 * `push` again.
	 *
	 * The parser attempts to create a usable manifest object even if the
	 * underlying input is somewhat nonsensical. It emits `info` and `warning`
	 * events during the parse if it encounters input that seems invalid or
	 * requires some property of the manifest object to be defaulted.
	 *
	 * @class Parser
	 * @extends Stream
	 */
	
	
	var Parser = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](Parser, _Stream);
	
	  function Parser() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.lineStream = new LineStream();
	    _this.parseStream = new ParseStream();
	
	    _this.lineStream.pipe(_this.parseStream);
	    /* eslint-disable consistent-this */
	
	
	    var self = _assertThisInitialized__default['default'](_this);
	    /* eslint-enable consistent-this */
	
	
	    var uris = [];
	    var currentUri = {}; // if specified, the active EXT-X-MAP definition
	
	    var currentMap; // if specified, the active decryption key
	
	    var _key;
	
	    var hasParts = false;
	
	    var noop = function noop() {};
	
	    var defaultMediaGroups = {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
	    // used in MPDs with Widevine encrypted streams.
	
	    var widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities
	
	    var currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
	
	    _this.manifest = {
	      allowCache: true,
	      discontinuityStarts: [],
	      segments: []
	    }; // keep track of the last seen segment's byte range end, as segments are not required
	    // to provide the offset, in which case it defaults to the next byte after the
	    // previous segment
	
	    var lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
	
	    var lastPartByterangeEnd = 0;
	
	    _this.on('end', function () {
	      // only add preloadSegment if we don't yet have a uri for it.
	      // and we actually have parts/preloadHints
	      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
	        return;
	      }
	
	      if (!currentUri.map && currentMap) {
	        currentUri.map = currentMap;
	      }
	
	      if (!currentUri.key && _key) {
	        currentUri.key = _key;
	      }
	
	      if (!currentUri.timeline && typeof currentTimeline === 'number') {
	        currentUri.timeline = currentTimeline;
	      }
	
	      _this.manifest.preloadSegment = currentUri;
	    }); // update the manifest with the m3u8 entry from the parse stream
	
	
	    _this.parseStream.on('data', function (entry) {
	      var mediaGroup;
	      var rendition;
	      ({
	        tag: function tag() {
	          // switch based on the tag type
	          (({
	            version: function version() {
	              if (entry.version) {
	                this.manifest.version = entry.version;
	              }
	            },
	            'allow-cache': function allowCache() {
	              this.manifest.allowCache = entry.allowed;
	
	              if (!('allowed' in entry)) {
	                this.trigger('info', {
	                  message: 'defaulting allowCache to YES'
	                });
	                this.manifest.allowCache = true;
	              }
	            },
	            byterange: function byterange() {
	              var byterange = {};
	
	              if ('length' in entry) {
	                currentUri.byterange = byterange;
	                byterange.length = entry.length;
	
	                if (!('offset' in entry)) {
	                  /*
	                   * From the latest spec (as of this writing):
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
	                   *
	                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
	                   *
	                   * "If o [offset] is not present, the sub-range begins at the next byte
	                   * following the sub-range of the previous media segment."
	                   */
	                  entry.offset = lastByterangeEnd;
	                }
	              }
	
	              if ('offset' in entry) {
	                currentUri.byterange = byterange;
	                byterange.offset = entry.offset;
	              }
	
	              lastByterangeEnd = byterange.offset + byterange.length;
	            },
	            endlist: function endlist() {
	              this.manifest.endList = true;
	            },
	            inf: function inf() {
	              if (!('mediaSequence' in this.manifest)) {
	                this.manifest.mediaSequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting media sequence to zero'
	                });
	              }
	
	              if (!('discontinuitySequence' in this.manifest)) {
	                this.manifest.discontinuitySequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting discontinuity sequence to zero'
	                });
	              }
	
	              if (entry.duration > 0) {
	                currentUri.duration = entry.duration;
	              }
	
	              if (entry.duration === 0) {
	                currentUri.duration = 0.01;
	                this.trigger('info', {
	                  message: 'updating zero segment duration to a small value'
	                });
	              }
	
	              this.manifest.segments = uris;
	            },
	            key: function key() {
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without attribute list'
	                });
	                return;
	              } // clear the active encryption key
	
	
	              if (entry.attributes.METHOD === 'NONE') {
	                _key = null;
	                return;
	              }
	
	              if (!entry.attributes.URI) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without URI'
	                });
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.apple.fps.1_0'] = {
	                  attributes: entry.attributes
	                };
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.microsoft.playready'] = {
	                  uri: entry.attributes.URI
	                };
	                return;
	              } // check if the content is encrypted for Widevine
	              // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
	
	
	              if (entry.attributes.KEYFORMAT === widevineUuid) {
	                var VALID_METHODS = ['SAMPLE-AES', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'];
	
	                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
	                  this.trigger('warn', {
	                    message: 'invalid key method provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') {
	                  this.trigger('warn', {
	                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
	                  });
	                }
	
	                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
	                  this.trigger('warn', {
	                    message: 'invalid key URI provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
	                  this.trigger('warn', {
	                    message: 'invalid key ID provided for Widevine'
	                  });
	                  return;
	                } // if Widevine key attributes are valid, store them as `contentProtection`
	                // on the manifest to emulate Widevine tag structure in a DASH mpd
	
	
	                this.manifest.contentProtection = this.manifest.contentProtection || {};
	                this.manifest.contentProtection['com.widevine.alpha'] = {
	                  attributes: {
	                    schemeIdUri: entry.attributes.KEYFORMAT,
	                    // remove '0x' from the key id string
	                    keyId: entry.attributes.KEYID.substring(2)
	                  },
	                  // decode the base64-encoded PSSH box
	                  pssh: decodeB64ToUint8Array__default['default'](entry.attributes.URI.split(',')[1])
	                };
	                return;
	              }
	
	              if (!entry.attributes.METHOD) {
	                this.trigger('warn', {
	                  message: 'defaulting key method to AES-128'
	                });
	              } // setup an encryption key for upcoming segments
	
	
	              _key = {
	                method: entry.attributes.METHOD || 'AES-128',
	                uri: entry.attributes.URI
	              };
	
	              if (typeof entry.attributes.IV !== 'undefined') {
	                _key.iv = entry.attributes.IV;
	              }
	            },
	            'media-sequence': function mediaSequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid media sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.mediaSequence = entry.number;
	            },
	            'discontinuity-sequence': function discontinuitySequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.discontinuitySequence = entry.number;
	              currentTimeline = entry.number;
	            },
	            'playlist-type': function playlistType() {
	              if (!/VOD|EVENT/.test(entry.playlistType)) {
	                this.trigger('warn', {
	                  message: 'ignoring unknown playlist type: ' + entry.playlist
	                });
	                return;
	              }
	
	              this.manifest.playlistType = entry.playlistType;
	            },
	            map: function map() {
	              currentMap = {};
	
	              if (entry.uri) {
	                currentMap.uri = entry.uri;
	              }
	
	              if (entry.byterange) {
	                currentMap.byterange = entry.byterange;
	              }
	
	              if (_key) {
	                currentMap.key = _key;
	              }
	            },
	            'stream-inf': function streamInf() {
	              this.manifest.playlists = uris;
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring empty stream-inf attributes'
	                });
	                return;
	              }
	
	              if (!currentUri.attributes) {
	                currentUri.attributes = {};
	              }
	
	              _extends__default['default'](currentUri.attributes, entry.attributes);
	            },
	            media: function media() {
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
	                this.trigger('warn', {
	                  message: 'ignoring incomplete or missing media group'
	                });
	                return;
	              } // find the media group, creating defaults as necessary
	
	
	              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
	              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
	              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata
	
	              rendition = {
	                default: /yes/i.test(entry.attributes.DEFAULT)
	              };
	
	              if (rendition.default) {
	                rendition.autoselect = true;
	              } else {
	                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
	              }
	
	              if (entry.attributes.LANGUAGE) {
	                rendition.language = entry.attributes.LANGUAGE;
	              }
	
	              if (entry.attributes.URI) {
	                rendition.uri = entry.attributes.URI;
	              }
	
	              if (entry.attributes['INSTREAM-ID']) {
	                rendition.instreamId = entry.attributes['INSTREAM-ID'];
	              }
	
	              if (entry.attributes.CHARACTERISTICS) {
	                rendition.characteristics = entry.attributes.CHARACTERISTICS;
	              }
	
	              if (entry.attributes.FORCED) {
	                rendition.forced = /yes/i.test(entry.attributes.FORCED);
	              } // insert the new rendition
	
	
	              mediaGroup[entry.attributes.NAME] = rendition;
	            },
	            discontinuity: function discontinuity() {
	              currentTimeline += 1;
	              currentUri.discontinuity = true;
	              this.manifest.discontinuityStarts.push(uris.length);
	            },
	            'program-date-time': function programDateTime() {
	              if (typeof this.manifest.dateTimeString === 'undefined') {
	                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
	                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
	                // to the manifest object
	                // TODO: Consider removing this in future major version
	                this.manifest.dateTimeString = entry.dateTimeString;
	                this.manifest.dateTimeObject = entry.dateTimeObject;
	              }
	
	              currentUri.dateTimeString = entry.dateTimeString;
	              currentUri.dateTimeObject = entry.dateTimeObject;
	            },
	            targetduration: function targetduration() {
	              if (!isFinite(entry.duration) || entry.duration < 0) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid target duration: ' + entry.duration
	                });
	                return;
	              }
	
	              this.manifest.targetDuration = entry.duration;
	              setHoldBack.call(this, this.manifest);
	            },
	            start: function start() {
	              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
	                this.trigger('warn', {
	                  message: 'ignoring start declaration without appropriate attribute list'
	                });
	                return;
	              }
	
	              this.manifest.start = {
	                timeOffset: entry.attributes['TIME-OFFSET'],
	                precise: entry.attributes.PRECISE
	              };
	            },
	            'cue-out': function cueOut() {
	              currentUri.cueOut = entry.data;
	            },
	            'cue-out-cont': function cueOutCont() {
	              currentUri.cueOutCont = entry.data;
	            },
	            'cue-in': function cueIn() {
	              currentUri.cueIn = entry.data;
	            },
	            'skip': function skip() {
	              this.manifest.skip = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, ['SKIPPED-SEGMENTS']);
	            },
	            'part': function part() {
	              var _this2 = this;
	
	              hasParts = true; // parts are always specifed before a segment
	
	              var segmentIndex = this.manifest.segments.length;
	              var part = camelCaseKeys(entry.attributes);
	              currentUri.parts = currentUri.parts || [];
	              currentUri.parts.push(part);
	
	              if (part.byterange) {
	                if (!part.byterange.hasOwnProperty('offset')) {
	                  part.byterange.offset = lastPartByterangeEnd;
	                }
	
	                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
	              }
	
	              var partIndex = currentUri.parts.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ['URI', 'DURATION']);
	
	              if (this.manifest.renditionReports) {
	                this.manifest.renditionReports.forEach(function (r, i) {
	                  if (!r.hasOwnProperty('lastPart')) {
	                    _this2.trigger('warn', {
	                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
	                    });
	                  }
	                });
	              }
	            },
	            'server-control': function serverControl() {
	              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
	
	              if (!attrs.hasOwnProperty('canBlockReload')) {
	                attrs.canBlockReload = false;
	                this.trigger('info', {
	                  message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
	                });
	              }
	
	              setHoldBack.call(this, this.manifest);
	
	              if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) {
	                this.trigger('warn', {
	                  message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
	                });
	              }
	            },
	            'preload-hint': function preloadHint() {
	              // parts are always specifed before a segment
	              var segmentIndex = this.manifest.segments.length;
	              var hint = camelCaseKeys(entry.attributes);
	              var isPart = hint.type && hint.type === 'PART';
	              currentUri.preloadHints = currentUri.preloadHints || [];
	              currentUri.preloadHints.push(hint);
	
	              if (hint.byterange) {
	                if (!hint.byterange.hasOwnProperty('offset')) {
	                  // use last part byterange end or zero if not a part.
	                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
	
	                  if (isPart) {
	                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
	                  }
	                }
	              }
	
	              var index = currentUri.preloadHints.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ['TYPE', 'URI']);
	
	              if (!hint.type) {
	                return;
	              } // search through all preload hints except for the current one for
	              // a duplicate type.
	
	
	              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
	                var otherHint = currentUri.preloadHints[i];
	
	                if (!otherHint.type) {
	                  continue;
	                }
	
	                if (otherHint.type === hint.type) {
	                  this.trigger('warn', {
	                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
	                  });
	                }
	              }
	            },
	            'rendition-report': function renditionReport() {
	              var report = camelCaseKeys(entry.attributes);
	              this.manifest.renditionReports = this.manifest.renditionReports || [];
	              this.manifest.renditionReports.push(report);
	              var index = this.manifest.renditionReports.length - 1;
	              var required = ['LAST-MSN', 'URI'];
	
	              if (hasParts) {
	                required.push('LAST-PART');
	              }
	
	              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
	            },
	            'part-inf': function partInf() {
	              this.manifest.partInf = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, ['PART-TARGET']);
	
	              if (this.manifest.partInf.partTarget) {
	                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
	              }
	
	              setHoldBack.call(this, this.manifest);
	            }
	          })[entry.tagType] || noop).call(self);
	        },
	        uri: function uri() {
	          currentUri.uri = entry.uri;
	          uris.push(currentUri); // if no explicit duration was declared, use the target duration
	
	          if (this.manifest.targetDuration && !('duration' in currentUri)) {
	            this.trigger('warn', {
	              message: 'defaulting segment duration to the target duration'
	            });
	            currentUri.duration = this.manifest.targetDuration;
	          } // annotate with encryption information, if necessary
	
	
	          if (_key) {
	            currentUri.key = _key;
	          }
	
	          currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
	
	          if (currentMap) {
	            currentUri.map = currentMap;
	          } // reset the last byterange end as it needs to be 0 between parts
	
	
	          lastPartByterangeEnd = 0; // prepare for the next URI
	
	          currentUri = {};
	        },
	        comment: function comment() {// comments are not important for playback
	        },
	        custom: function custom() {
	          // if this is segment-level data attach the output to the segment
	          if (entry.segment) {
	            currentUri.custom = currentUri.custom || {};
	            currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
	          } else {
	            this.manifest.custom = this.manifest.custom || {};
	            this.manifest.custom[entry.customType] = entry.data;
	          }
	        }
	      })[entry.type].call(self);
	    });
	
	    return _this;
	  }
	
	  var _proto = Parser.prototype;
	
	  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
	    var missing = [];
	    required.forEach(function (key) {
	      if (!attributes.hasOwnProperty(key)) {
	        missing.push(key);
	      }
	    });
	
	    if (missing.length) {
	      this.trigger('warn', {
	        message: identifier + " lacks required attribute(s): " + missing.join(', ')
	      });
	    }
	  }
	  /**
	   * Parse the input string and update the manifest object.
	   *
	   * @param {string} chunk a potentially incomplete portion of the manifest
	   */
	  ;
	
	  _proto.push = function push(chunk) {
	    this.lineStream.push(chunk);
	  }
	  /**
	   * Flush any remaining input. This can be handy if the last line of an M3U8
	   * manifest did not contain a trailing newline but the file has been
	   * completely received.
	   */
	  ;
	
	  _proto.end = function end() {
	    // flush any buffered input
	    this.lineStream.push('\n');
	    this.trigger('end');
	  }
	  /**
	   * Add an additional parser for non-standard tags
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.type         the type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(options) {
	    this.parseStream.addParser(options);
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(options) {
	    this.parseStream.addTagMapper(options);
	  };
	
	  return Parser;
	}(Stream__default['default']);
	
	exports.LineStream = LineStream;
	exports.ParseStream = ParseStream;
	exports.Parser = Parser;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 32,
		"./af.js": 32,
		"./ar": 37,
		"./ar-ly": 33,
		"./ar-ly.js": 33,
		"./ar-ma": 34,
		"./ar-ma.js": 34,
		"./ar-sa": 35,
		"./ar-sa.js": 35,
		"./ar-tn": 36,
		"./ar-tn.js": 36,
		"./ar.js": 37,
		"./az": 38,
		"./az.js": 38,
		"./be": 39,
		"./be.js": 39,
		"./bg": 40,
		"./bg.js": 40,
		"./bn": 41,
		"./bn.js": 41,
		"./bo": 42,
		"./bo.js": 42,
		"./br": 43,
		"./br.js": 43,
		"./bs": 44,
		"./bs.js": 44,
		"./ca": 45,
		"./ca.js": 45,
		"./cs": 46,
		"./cs.js": 46,
		"./cv": 47,
		"./cv.js": 47,
		"./cy": 48,
		"./cy.js": 48,
		"./da": 49,
		"./da.js": 49,
		"./de": 51,
		"./de-at": 50,
		"./de-at.js": 50,
		"./de.js": 51,
		"./dv": 52,
		"./dv.js": 52,
		"./el": 53,
		"./el.js": 53,
		"./en-au": 54,
		"./en-au.js": 54,
		"./en-ca": 55,
		"./en-ca.js": 55,
		"./en-gb": 56,
		"./en-gb.js": 56,
		"./en-ie": 57,
		"./en-ie.js": 57,
		"./en-nz": 58,
		"./en-nz.js": 58,
		"./eo": 59,
		"./eo.js": 59,
		"./es": 61,
		"./es-do": 60,
		"./es-do.js": 60,
		"./es.js": 61,
		"./et": 62,
		"./et.js": 62,
		"./eu": 63,
		"./eu.js": 63,
		"./fa": 64,
		"./fa.js": 64,
		"./fi": 65,
		"./fi.js": 65,
		"./fo": 66,
		"./fo.js": 66,
		"./fr": 69,
		"./fr-ca": 67,
		"./fr-ca.js": 67,
		"./fr-ch": 68,
		"./fr-ch.js": 68,
		"./fr.js": 69,
		"./fy": 70,
		"./fy.js": 70,
		"./gd": 71,
		"./gd.js": 71,
		"./gl": 72,
		"./gl.js": 72,
		"./he": 73,
		"./he.js": 73,
		"./hi": 74,
		"./hi.js": 74,
		"./hr": 75,
		"./hr.js": 75,
		"./hu": 76,
		"./hu.js": 76,
		"./hy-am": 77,
		"./hy-am.js": 77,
		"./id": 78,
		"./id.js": 78,
		"./is": 79,
		"./is.js": 79,
		"./it": 80,
		"./it.js": 80,
		"./ja": 81,
		"./ja.js": 81,
		"./jv": 82,
		"./jv.js": 82,
		"./ka": 83,
		"./ka.js": 83,
		"./kk": 84,
		"./kk.js": 84,
		"./km": 85,
		"./km.js": 85,
		"./ko": 86,
		"./ko.js": 86,
		"./ky": 87,
		"./ky.js": 87,
		"./lb": 88,
		"./lb.js": 88,
		"./lo": 89,
		"./lo.js": 89,
		"./lt": 90,
		"./lt.js": 90,
		"./lv": 91,
		"./lv.js": 91,
		"./me": 92,
		"./me.js": 92,
		"./mi": 93,
		"./mi.js": 93,
		"./mk": 94,
		"./mk.js": 94,
		"./ml": 95,
		"./ml.js": 95,
		"./mr": 96,
		"./mr.js": 96,
		"./ms": 98,
		"./ms-my": 97,
		"./ms-my.js": 97,
		"./ms.js": 98,
		"./my": 99,
		"./my.js": 99,
		"./nb": 100,
		"./nb.js": 100,
		"./ne": 101,
		"./ne.js": 101,
		"./nl": 102,
		"./nl.js": 102,
		"./nn": 103,
		"./nn.js": 103,
		"./pa-in": 104,
		"./pa-in.js": 104,
		"./pl": 105,
		"./pl.js": 105,
		"./pt": 107,
		"./pt-br": 106,
		"./pt-br.js": 106,
		"./pt.js": 107,
		"./ro": 108,
		"./ro.js": 108,
		"./ru": 109,
		"./ru.js": 109,
		"./se": 110,
		"./se.js": 110,
		"./si": 111,
		"./si.js": 111,
		"./sk": 112,
		"./sk.js": 112,
		"./sl": 113,
		"./sl.js": 113,
		"./sq": 114,
		"./sq.js": 114,
		"./sr": 116,
		"./sr-cyrl": 115,
		"./sr-cyrl.js": 115,
		"./sr.js": 116,
		"./ss": 117,
		"./ss.js": 117,
		"./sv": 118,
		"./sv.js": 118,
		"./sw": 119,
		"./sw.js": 119,
		"./ta": 120,
		"./ta.js": 120,
		"./te": 121,
		"./te.js": 121,
		"./th": 122,
		"./th.js": 122,
		"./tl-ph": 123,
		"./tl-ph.js": 123,
		"./tlh": 124,
		"./tlh.js": 124,
		"./tr": 125,
		"./tr.js": 125,
		"./tzl": 126,
		"./tzl.js": 126,
		"./tzm": 128,
		"./tzm-latn": 127,
		"./tzm-latn.js": 127,
		"./tzm.js": 128,
		"./uk": 129,
		"./uk.js": 129,
		"./uz": 130,
		"./uz.js": 130,
		"./vi": 131,
		"./vi.js": 131,
		"./x-pseudo": 132,
		"./x-pseudo.js": 132,
		"./zh-cn": 133,
		"./zh-cn.js": 133,
		"./zh-hk": 134,
		"./zh-hk.js": 134,
		"./zh-tw": 135,
		"./zh-tw.js": 135
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 203;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var resolveUrl = __webpack_require__(25);
	var window = __webpack_require__(2);
	var mediaGroups = __webpack_require__(168);
	var decodeB64ToUint8Array = __webpack_require__(23);
	var xmldom = __webpack_require__(178);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(resolveUrl);
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	var version = "0.22.1";
	
	var isObject = function isObject(obj) {
	  return !!obj && typeof obj === 'object';
	};
	
	var merge = function merge() {
	  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
	    objects[_key] = arguments[_key];
	  }
	
	  return objects.reduce(function (result, source) {
	    if (typeof source !== 'object') {
	      return result;
	    }
	
	    Object.keys(source).forEach(function (key) {
	      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
	        result[key] = result[key].concat(source[key]);
	      } else if (isObject(result[key]) && isObject(source[key])) {
	        result[key] = merge(result[key], source[key]);
	      } else {
	        result[key] = source[key];
	      }
	    });
	    return result;
	  }, {});
	};
	var values = function values(o) {
	  return Object.keys(o).map(function (k) {
	    return o[k];
	  });
	};
	
	var range = function range(start, end) {
	  var result = [];
	
	  for (var i = start; i < end; i++) {
	    result.push(i);
	  }
	
	  return result;
	};
	var flatten = function flatten(lists) {
	  return lists.reduce(function (x, y) {
	    return x.concat(y);
	  }, []);
	};
	var from = function from(list) {
	  if (!list.length) {
	    return [];
	  }
	
	  var result = [];
	
	  for (var i = 0; i < list.length; i++) {
	    result.push(list[i]);
	  }
	
	  return result;
	};
	var findIndexes = function findIndexes(l, key) {
	  return l.reduce(function (a, e, i) {
	    if (e[key]) {
	      a.push(i);
	    }
	
	    return a;
	  }, []);
	};
	/**
	 * Returns the first index that satisfies the matching function, or -1 if not found.
	 *
	 * Only necessary because of IE11 support.
	 *
	 * @param {Array} list - the list to search through
	 * @param {Function} matchingFunction - the matching function
	 *
	 * @return {number} the matching index or -1 if not found
	 */
	
	var findIndex = function findIndex(list, matchingFunction) {
	  for (var i = 0; i < list.length; i++) {
	    if (matchingFunction(list[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Returns a union of the included lists provided each element can be identified by a key.
	 *
	 * @param {Array} list - list of lists to get the union of
	 * @param {Function} keyFunction - the function to use as a key for each element
	 *
	 * @return {Array} the union of the arrays
	 */
	
	var union = function union(lists, keyFunction) {
	  return values(lists.reduce(function (acc, list) {
	    list.forEach(function (el) {
	      acc[keyFunction(el)] = el;
	    });
	    return acc;
	  }, {}));
	};
	
	var errors = {
	  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
	  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
	  DASH_INVALID_XML: 'DASH_INVALID_XML',
	  NO_BASE_URL: 'NO_BASE_URL',
	  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
	  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
	  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
	};
	
	/**
	 * @typedef {Object} SingleUri
	 * @property {string} uri - relative location of segment
	 * @property {string} resolvedUri - resolved location of segment
	 * @property {Object} byterange - Object containing information on how to make byte range
	 *   requests following byte-range-spec per RFC2616.
	 * @property {String} byterange.length - length of range request
	 * @property {String} byterange.offset - byte offset of range request
	 *
	 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
	 */
	
	/**
	 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
	 * that conforms to how m3u8-parser is structured
	 *
	 * @see https://github.com/videojs/m3u8-parser
	 *
	 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
	 * @param {string} source - source url for segment
	 * @param {string} range - optional range used for range calls,
	 *   follows  RFC 2616, Clause 14.35.1
	 * @return {SingleUri} full segment information transformed into a format similar
	 *   to m3u8-parser
	 */
	
	var urlTypeToSegment = function urlTypeToSegment(_ref) {
	  var _ref$baseUrl = _ref.baseUrl,
	      baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
	      _ref$source = _ref.source,
	      source = _ref$source === void 0 ? '' : _ref$source,
	      _ref$range = _ref.range,
	      range = _ref$range === void 0 ? '' : _ref$range,
	      _ref$indexRange = _ref.indexRange,
	      indexRange = _ref$indexRange === void 0 ? '' : _ref$indexRange;
	  var segment = {
	    uri: source,
	    resolvedUri: resolveUrl__default['default'](baseUrl || '', source)
	  };
	
	  if (range || indexRange) {
	    var rangeStr = range ? range : indexRange;
	    var ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible
	
	    var startRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[0]) : parseInt(ranges[0], 10);
	    var endRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
	
	    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') {
	      startRange = Number(startRange);
	    }
	
	    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') {
	      endRange = Number(endRange);
	    }
	
	    var length;
	
	    if (typeof endRange === 'bigint' || typeof startRange === 'bigint') {
	      length = window__default['default'].BigInt(endRange) - window__default['default'].BigInt(startRange) + window__default['default'].BigInt(1);
	    } else {
	      length = endRange - startRange + 1;
	    }
	
	    if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) {
	      length = Number(length);
	    } // byterange should be inclusive according to
	    // RFC 2616, Clause 14.35.1
	
	
	    segment.byterange = {
	      length: length,
	      offset: startRange
	    };
	  }
	
	  return segment;
	};
	var byteRangeToString = function byteRangeToString(byterange) {
	  // `endRange` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var endRange;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    endRange = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    endRange = byterange.offset + byterange.length - 1;
	  }
	
	  return byterange.offset + "-" + endRange;
	};
	
	/**
	 * parse the end number attribue that can be a string
	 * number, or undefined.
	 *
	 * @param {string|number|undefined} endNumber
	 *        The end number attribute.
	 *
	 * @return {number|null}
	 *          The result of parsing the end number.
	 */
	
	var parseEndNumber = function parseEndNumber(endNumber) {
	  if (endNumber && typeof endNumber !== 'number') {
	    endNumber = parseInt(endNumber, 10);
	  }
	
	  if (isNaN(endNumber)) {
	    return null;
	  }
	
	  return endNumber;
	};
	/**
	 * Functions for calculating the range of available segments in static and dynamic
	 * manifests.
	 */
	
	
	var segmentRange = {
	  /**
	   * Returns the entire range of available segments for a static MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  static: function _static(attributes) {
	    var duration = attributes.duration,
	        _attributes$timescale = attributes.timescale,
	        timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	        sourceDuration = attributes.sourceDuration,
	        periodDuration = attributes.periodDuration;
	    var endNumber = parseEndNumber(attributes.endNumber);
	    var segmentDuration = duration / timescale;
	
	    if (typeof endNumber === 'number') {
	      return {
	        start: 0,
	        end: endNumber
	      };
	    }
	
	    if (typeof periodDuration === 'number') {
	      return {
	        start: 0,
	        end: periodDuration / segmentDuration
	      };
	    }
	
	    return {
	      start: 0,
	      end: sourceDuration / segmentDuration
	    };
	  },
	
	  /**
	   * Returns the current live window range of available segments for a dynamic MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  dynamic: function dynamic(attributes) {
	    var NOW = attributes.NOW,
	        clientOffset = attributes.clientOffset,
	        availabilityStartTime = attributes.availabilityStartTime,
	        _attributes$timescale2 = attributes.timescale,
	        timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	        duration = attributes.duration,
	        _attributes$periodSta = attributes.periodStart,
	        periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	        _attributes$minimumUp = attributes.minimumUpdatePeriod,
	        minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp,
	        _attributes$timeShift = attributes.timeShiftBufferDepth,
	        timeShiftBufferDepth = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
	    var endNumber = parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
	    // after retrieving UTC server time.
	
	    var now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
	    // Convert the period start time to EPOCH.
	
	    var periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
	
	    var periodEndWC = now + minimumUpdatePeriod;
	    var periodDuration = periodEndWC - periodStartWC;
	    var segmentCount = Math.ceil(periodDuration * timescale / duration);
	    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
	    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
	    return {
	      start: Math.max(0, availableStart),
	      end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
	    };
	  }
	};
	/**
	 * Maps a range of numbers to objects with information needed to build the corresponding
	 * segment list
	 *
	 * @name toSegmentsCallback
	 * @function
	 * @param {number} number
	 *        Number of the segment
	 * @param {number} index
	 *        Index of the number in the range list
	 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
	 *         Object with segment timing and duration info
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping a range of numbers to
	 * information needed to build the segment list.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {toSegmentsCallback}
	 *         Callback map function
	 */
	
	var toSegments = function toSegments(attributes) {
	  return function (number) {
	    var duration = attributes.duration,
	        _attributes$timescale3 = attributes.timescale,
	        timescale = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3,
	        periodStart = attributes.periodStart,
	        _attributes$startNumb = attributes.startNumber,
	        startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
	    return {
	      number: startNumber + number,
	      duration: duration / timescale,
	      timeline: periodStart,
	      time: number * duration
	    };
	  };
	};
	/**
	 * Returns a list of objects containing segment timing and duration info used for
	 * building the list of segments. This uses the @duration attribute specified
	 * in the MPD manifest to derive the range of segments.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseByDuration = function parseByDuration(attributes) {
	  var type = attributes.type,
	      duration = attributes.duration,
	      _attributes$timescale4 = attributes.timescale,
	      timescale = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4,
	      periodDuration = attributes.periodDuration,
	      sourceDuration = attributes.sourceDuration;
	
	  var _segmentRange$type = segmentRange[type](attributes),
	      start = _segmentRange$type.start,
	      end = _segmentRange$type.end;
	
	  var segments = range(start, end).map(toSegments(attributes));
	
	  if (type === 'static') {
	    var index = segments.length - 1; // section is either a period or the full source
	
	    var sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration
	
	    segments[index].duration = sectionDuration - duration / timescale * index;
	  }
	
	  return segments;
	};
	
	/**
	 * Translates SegmentBase into a set of segments.
	 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @return {Object.<Array>} list of segments
	 */
	
	var segmentsFromBase = function segmentsFromBase(attributes) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$indexRang = attributes.indexRange,
	      indexRange = _attributes$indexRang === void 0 ? '' : _attributes$indexRang,
	      periodStart = attributes.periodStart,
	      presentationTime = attributes.presentationTime,
	      _attributes$number = attributes.number,
	      number = _attributes$number === void 0 ? 0 : _attributes$number,
	      duration = attributes.duration; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
	
	  if (!baseUrl) {
	    throw new Error(errors.NO_BASE_URL);
	  }
	
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: baseUrl,
	    indexRange: indexRange
	  });
	  segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
	  // (since SegmentBase is only for one total segment)
	
	  if (duration) {
	    var segmentTimeInfo = parseByDuration(attributes);
	
	    if (segmentTimeInfo.length) {
	      segment.duration = segmentTimeInfo[0].duration;
	      segment.timeline = segmentTimeInfo[0].timeline;
	    }
	  } else if (sourceDuration) {
	    segment.duration = sourceDuration;
	    segment.timeline = periodStart;
	  } // If presentation time is provided, these segments are being generated by SIDX
	  // references, and should use the time provided. For the general case of SegmentBase,
	  // there should only be one segment in the period, so its presentation time is the same
	  // as its period start.
	
	
	  segment.presentationTime = presentationTime || periodStart;
	  segment.number = number;
	  return [segment];
	};
	/**
	 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
	 * according to the sidx information given.
	 *
	 * playlist.sidx has metadadata about the sidx where-as the sidx param
	 * is the parsed sidx box itself.
	 *
	 * @param {Object} playlist the playlist to update the sidx information for
	 * @param {Object} sidx the parsed sidx box
	 * @return {Object} the playlist object with the updated sidx information
	 */
	
	var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
	  // Retain init segment information
	  var initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
	
	  var sourceDuration = playlist.sidx.duration; // Retain source timeline
	
	  var timeline = playlist.timeline || 0;
	  var sidxByteRange = playlist.sidx.byterange;
	  var sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
	
	  var timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
	
	  var mediaReferences = sidx.references.filter(function (r) {
	    return r.referenceType !== 1;
	  });
	  var segments = [];
	  var type = playlist.endList ? 'static' : 'dynamic';
	  var periodStart = playlist.sidx.timeline;
	  var presentationTime = periodStart;
	  var number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
	
	  var startIndex; // eslint-disable-next-line
	
	  if (typeof sidx.firstOffset === 'bigint') {
	    startIndex = window__default['default'].BigInt(sidxEnd) + sidx.firstOffset;
	  } else {
	    startIndex = sidxEnd + sidx.firstOffset;
	  }
	
	  for (var i = 0; i < mediaReferences.length; i++) {
	    var reference = sidx.references[i]; // size of the referenced (sub)segment
	
	    var size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
	    // this will be converted to seconds when generating segments
	
	    var duration = reference.subsegmentDuration; // should be an inclusive range
	
	    var endIndex = void 0; // eslint-disable-next-line
	
	    if (typeof startIndex === 'bigint') {
	      endIndex = startIndex + window__default['default'].BigInt(size) - window__default['default'].BigInt(1);
	    } else {
	      endIndex = startIndex + size - 1;
	    }
	
	    var indexRange = startIndex + "-" + endIndex;
	    var attributes = {
	      baseUrl: baseUrl,
	      timescale: timescale,
	      timeline: timeline,
	      periodStart: periodStart,
	      presentationTime: presentationTime,
	      number: number,
	      duration: duration,
	      sourceDuration: sourceDuration,
	      indexRange: indexRange,
	      type: type
	    };
	    var segment = segmentsFromBase(attributes)[0];
	
	    if (initSegment) {
	      segment.map = initSegment;
	    }
	
	    segments.push(segment);
	
	    if (typeof startIndex === 'bigint') {
	      startIndex += window__default['default'].BigInt(size);
	    } else {
	      startIndex += size;
	    }
	
	    presentationTime += duration / timescale;
	    number++;
	  }
	
	  playlist.segments = segments;
	  return playlist;
	};
	
	var SUPPORTED_MEDIA_TYPES = ['AUDIO', 'SUBTITLES']; // allow one 60fps frame as leniency (arbitrarily chosen)
	
	var TIME_FUDGE = 1 / 60;
	/**
	 * Given a list of timelineStarts, combines, dedupes, and sorts them.
	 *
	 * @param {TimelineStart[]} timelineStarts - list of timeline starts
	 *
	 * @return {TimelineStart[]} the combined and deduped timeline starts
	 */
	
	var getUniqueTimelineStarts = function getUniqueTimelineStarts(timelineStarts) {
	  return union(timelineStarts, function (_ref) {
	    var timeline = _ref.timeline;
	    return timeline;
	  }).sort(function (a, b) {
	    return a.timeline > b.timeline ? 1 : -1;
	  });
	};
	/**
	 * Finds the playlist with the matching NAME attribute.
	 *
	 * @param {Array} playlists - playlists to search through
	 * @param {string} name - the NAME attribute to search for
	 *
	 * @return {Object|null} the matching playlist object, or null
	 */
	
	var findPlaylistWithName = function findPlaylistWithName(playlists, name) {
	  for (var i = 0; i < playlists.length; i++) {
	    if (playlists[i].attributes.NAME === name) {
	      return playlists[i];
	    }
	  }
	
	  return null;
	};
	/**
	 * Gets a flattened array of media group playlists.
	 *
	 * @param {Object} manifest - the main manifest object
	 *
	 * @return {Array} the media group playlists
	 */
	
	var getMediaGroupPlaylists = function getMediaGroupPlaylists(manifest) {
	  var mediaGroupPlaylists = [];
	  mediaGroups.forEachMediaGroup(manifest, SUPPORTED_MEDIA_TYPES, function (properties, type, group, label) {
	    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
	  });
	  return mediaGroupPlaylists;
	};
	/**
	 * Updates the playlist's media sequence numbers.
	 *
	 * @param {Object} config - options object
	 * @param {Object} config.playlist - the playlist to update
	 * @param {number} config.mediaSequence - the mediaSequence number to start with
	 */
	
	var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      mediaSequence = _ref2.mediaSequence;
	  playlist.mediaSequence = mediaSequence;
	  playlist.segments.forEach(function (segment, index) {
	    segment.number = playlist.mediaSequence + index;
	  });
	};
	/**
	 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
	 * and a complete list of timeline starts.
	 *
	 * If no matching playlist is found, only the discontinuity sequence number of the playlist
	 * will be updated.
	 *
	 * Since early available timelines are not supported, at least one segment must be present.
	 *
	 * @param {Object} config - options object
	 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
	 * @param {Object[]} newPlaylists - the new playlists to update
	 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
	 */
	
	var updateSequenceNumbers = function updateSequenceNumbers(_ref3) {
	  var oldPlaylists = _ref3.oldPlaylists,
	      newPlaylists = _ref3.newPlaylists,
	      timelineStarts = _ref3.timelineStarts;
	  newPlaylists.forEach(function (playlist) {
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref4) {
	      var timeline = _ref4.timeline;
	      return timeline === playlist.timeline;
	    }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
	    // (see ISO_23009-1-2012 5.3.5.2).
	    //
	    // If the same Representation existed in a prior Period, it will retain the same NAME.
	
	    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
	
	    if (!oldPlaylist) {
	      // Since this is a new playlist, the media sequence values can start from 0 without
	      // consequence.
	      return;
	    } // TODO better support for live SIDX
	    //
	    // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
	    // This is evident by a playlist only having a single SIDX reference. In a multiperiod
	    // playlist there would need to be multiple SIDX references. In addition, live SIDX is
	    // not supported when the SIDX properties change on refreshes.
	    //
	    // In the future, if support needs to be added, the merging logic here can be called
	    // after SIDX references are resolved. For now, exit early to prevent exceptions being
	    // thrown due to undefined references.
	
	
	    if (playlist.sidx) {
	      return;
	    } // Since we don't yet support early available timelines, we don't need to support
	    // playlists with no segments.
	
	
	    var firstNewSegment = playlist.segments[0];
	    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function (oldSegment) {
	      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
	    }); // No matching segment from the old playlist means the entire playlist was refreshed.
	    // In this case the media sequence should account for this update, and the new segments
	    // should be marked as discontinuous from the prior content, since the last prior
	    // timeline was removed.
	
	    if (oldMatchingSegmentIndex === -1) {
	      updateMediaSequenceForPlaylist({
	        playlist: playlist,
	        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
	      });
	      playlist.segments[0].discontinuity = true;
	      playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
	      //
	      // If the new playlist's timeline is the same as the last seen segment's timeline,
	      // then a discontinuity can be added to identify that there's potentially missing
	      // content. If there's no missing content, the discontinuity should still be rather
	      // harmless. It's possible that if segment durations are accurate enough, that the
	      // existence of a gap can be determined using the presentation times and durations,
	      // but if the segment timing info is off, it may introduce more problems than simply
	      // adding the discontinuity.
	      //
	      // If the new playlist's timeline is different from the last seen segment's timeline,
	      // then a discontinuity can be added to identify that this is the first seen segment
	      // of a new timeline. However, the logic at the start of this function that
	      // determined the disconinuity sequence by timeline index is now off by one (the
	      // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
	      // we added it), so the disconinuity sequence must be decremented.
	      //
	      // A period may also have a duration of zero, so the case of no segments is handled
	      // here even though we don't yet support early available periods.
	
	      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
	        playlist.discontinuitySequence--;
	      }
	
	      return;
	    } // If the first segment matched with a prior segment on a discontinuity (it's matching
	    // on the first segment of a period), then the discontinuitySequence shouldn't be the
	    // timeline's matching one, but instead should be the one prior, and the first segment
	    // of the new manifest should be marked with a discontinuity.
	    //
	    // The reason for this special case is that discontinuity sequence shows how many
	    // discontinuities have fallen off of the playlist, and discontinuities are marked on
	    // the first segment of a new "timeline." Because of this, while DASH will retain that
	    // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
	    // sequence, and that first segment is an indicator, but can be removed before that
	    // timeline is gone.
	
	
	    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
	
	    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
	      firstNewSegment.discontinuity = true;
	      playlist.discontinuityStarts.unshift(0);
	      playlist.discontinuitySequence--;
	    }
	
	    updateMediaSequenceForPlaylist({
	      playlist: playlist,
	      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
	    });
	  });
	};
	/**
	 * Given an old parsed manifest object and a new parsed manifest object, updates the
	 * sequence and timing values within the new manifest to ensure that it lines up with the
	 * old.
	 *
	 * @param {Array} oldManifest - the old main manifest object
	 * @param {Array} newManifest - the new main manifest object
	 *
	 * @return {Object} the updated new manifest object
	 */
	
	var positionManifestOnTimeline = function positionManifestOnTimeline(_ref5) {
	  var oldManifest = _ref5.oldManifest,
	      newManifest = _ref5.newManifest;
	  // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
	  //
	  // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
	  //
	  // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
	  //
	  // Because of this change, and the difficulty of supporting periods with changing start
	  // times, periods with changing start times are not supported. This makes the logic much
	  // simpler, since periods with the same start time can be considerred the same period
	  // across refreshes.
	  //
	  // To give an example as to the difficulty of handling periods where the start time may
	  // change, if a single period manifest is refreshed with another manifest with a single
	  // period, and both the start and end times are increased, then the only way to determine
	  // if it's a new period or an old one that has changed is to look through the segments of
	  // each playlist and determine the presentation time bounds to find a match. In addition,
	  // if the period start changed to exceed the old period end, then there would be no
	  // match, and it would not be possible to determine whether the refreshed period is a new
	  // one or the old one.
	  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
	  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
	  // there's a "memory leak" in that it will never stop growing, in reality, only a couple
	  // of properties are saved for each seen Period. Even long running live streams won't
	  // generate too many Periods, unless the stream is watched for decades. In the future,
	  // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
	  // but it may not become an issue, and the additional info can be useful for debugging.
	
	  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
	  updateSequenceNumbers({
	    oldPlaylists: oldPlaylists,
	    newPlaylists: newPlaylists,
	    timelineStarts: newManifest.timelineStarts
	  });
	  return newManifest;
	};
	
	var generateSidxKey = function generateSidxKey(sidx) {
	  return sidx && sidx.uri + '-' + byteRangeToString(sidx.byterange);
	};
	
	var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists(playlists) {
	  var mergedPlaylists = values(playlists.reduce(function (acc, playlist) {
	    // assuming playlist IDs are the same across periods
	    // TODO: handle multiperiod where representation sets are not the same
	    // across periods
	    var name = playlist.attributes.id + (playlist.attributes.lang || '');
	
	    if (!acc[name]) {
	      // First Period
	      acc[name] = playlist;
	      acc[name].attributes.timelineStarts = [];
	    } else {
	      // Subsequent Periods
	      if (playlist.segments) {
	        var _acc$name$segments;
	
	        // first segment of subsequent periods signal a discontinuity
	        if (playlist.segments[0]) {
	          playlist.segments[0].discontinuity = true;
	        }
	
	        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
	      } // bubble up contentProtection, this assumes all DRM content
	      // has the same contentProtection
	
	
	      if (playlist.attributes.contentProtection) {
	        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
	      }
	    }
	
	    acc[name].attributes.timelineStarts.push({
	      // Although they represent the same number, it's important to have both to make it
	      // compatible with HLS potentially having a similar attribute.
	      start: playlist.attributes.periodStart,
	      timeline: playlist.attributes.periodStart
	    });
	    return acc;
	  }, {}));
	  return mergedPlaylists.map(function (playlist) {
	    playlist.discontinuityStarts = findIndexes(playlist.segments || [], 'discontinuity');
	    return playlist;
	  });
	};
	
	var addSidxSegmentsToPlaylist = function addSidxSegmentsToPlaylist(playlist, sidxMapping) {
	  var sidxKey = generateSidxKey(playlist.sidx);
	  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
	
	  if (sidxMatch) {
	    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
	  }
	
	  return playlist;
	};
	var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (!Object.keys(sidxMapping).length) {
	    return playlists;
	  }
	
	  for (var i in playlists) {
	    playlists[i] = addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
	  }
	
	  return playlists;
	};
	var formatAudioPlaylist = function formatAudioPlaylist(_ref, isAudioOnly) {
	  var _attributes;
	
	  var attributes = _ref.attributes,
	      segments = _ref.segments,
	      sidx = _ref.sidx,
	      mediaSequence = _ref.mediaSequence,
	      discontinuitySequence = _ref.discontinuitySequence,
	      discontinuityStarts = _ref.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes = {
	      NAME: attributes.id,
	      BANDWIDTH: attributes.bandwidth,
	      CODECS: attributes.codecs
	    }, _attributes['PROGRAM-ID'] = 1, _attributes),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuitySequence: discontinuitySequence,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  if (isAudioOnly) {
	    playlist.attributes.AUDIO = 'audio';
	    playlist.attributes.SUBTITLES = 'subs';
	  }
	
	  return playlist;
	};
	var formatVttPlaylist = function formatVttPlaylist(_ref2) {
	  var _m3u8Attributes;
	
	  var attributes = _ref2.attributes,
	      segments = _ref2.segments,
	      mediaSequence = _ref2.mediaSequence,
	      discontinuityStarts = _ref2.discontinuityStarts,
	      discontinuitySequence = _ref2.discontinuitySequence;
	
	  if (typeof segments === 'undefined') {
	    // vtt tracks may use single file in BaseURL
	    segments = [{
	      uri: attributes.baseUrl,
	      timeline: attributes.periodStart,
	      resolvedUri: attributes.baseUrl || '',
	      duration: attributes.sourceDuration,
	      number: 0
	    }]; // targetDuration should be the same duration as the only segment
	
	    attributes.duration = attributes.sourceDuration;
	  }
	
	  var m3u8Attributes = (_m3u8Attributes = {
	    NAME: attributes.id,
	    BANDWIDTH: attributes.bandwidth
	  }, _m3u8Attributes['PROGRAM-ID'] = 1, _m3u8Attributes);
	
	  if (attributes.codecs) {
	    m3u8Attributes.CODECS = attributes.codecs;
	  }
	
	  return {
	    attributes: m3u8Attributes,
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: attributes.baseUrl || '',
	    targetDuration: attributes.duration,
	    timelineStarts: attributes.timelineStarts,
	    discontinuityStarts: discontinuityStarts,
	    discontinuitySequence: discontinuitySequence,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	};
	var organizeAudioPlaylists = function organizeAudioPlaylists(playlists, sidxMapping, isAudioOnly) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (isAudioOnly === void 0) {
	    isAudioOnly = false;
	  }
	
	  var mainPlaylist;
	  var formattedPlaylists = playlists.reduce(function (a, playlist) {
	    var role = playlist.attributes.role && playlist.attributes.role.value || '';
	    var language = playlist.attributes.lang || '';
	    var label = playlist.attributes.label || 'main';
	
	    if (language && !playlist.attributes.label) {
	      var roleLabel = role ? " (" + role + ")" : '';
	      label = "" + playlist.attributes.lang + roleLabel;
	    }
	
	    if (!a[label]) {
	      a[label] = {
	        language: language,
	        autoselect: true,
	        default: role === 'main',
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    var formatted = addSidxSegmentsToPlaylist(formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
	    a[label].playlists.push(formatted);
	
	    if (typeof mainPlaylist === 'undefined' && role === 'main') {
	      mainPlaylist = playlist;
	      mainPlaylist.default = true;
	    }
	
	    return a;
	  }, {}); // if no playlists have role "main", mark the first as main
	
	  if (!mainPlaylist) {
	    var firstLabel = Object.keys(formattedPlaylists)[0];
	    formattedPlaylists[firstLabel].default = true;
	  }
	
	  return formattedPlaylists;
	};
	var organizeVttPlaylists = function organizeVttPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  return playlists.reduce(function (a, playlist) {
	    var label = playlist.attributes.lang || 'text';
	
	    if (!a[label]) {
	      a[label] = {
	        language: label,
	        default: false,
	        autoselect: false,
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    a[label].playlists.push(addSidxSegmentsToPlaylist(formatVttPlaylist(playlist), sidxMapping));
	    return a;
	  }, {});
	};
	
	var organizeCaptionServices = function organizeCaptionServices(captionServices) {
	  return captionServices.reduce(function (svcObj, svc) {
	    if (!svc) {
	      return svcObj;
	    }
	
	    svc.forEach(function (service) {
	      var channel = service.channel,
	          language = service.language;
	      svcObj[language] = {
	        autoselect: false,
	        default: false,
	        instreamId: channel,
	        language: language
	      };
	
	      if (service.hasOwnProperty('aspectRatio')) {
	        svcObj[language].aspectRatio = service.aspectRatio;
	      }
	
	      if (service.hasOwnProperty('easyReader')) {
	        svcObj[language].easyReader = service.easyReader;
	      }
	
	      if (service.hasOwnProperty('3D')) {
	        svcObj[language]['3D'] = service['3D'];
	      }
	    });
	    return svcObj;
	  }, {});
	};
	
	var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
	  var _attributes2;
	
	  var attributes = _ref3.attributes,
	      segments = _ref3.segments,
	      sidx = _ref3.sidx,
	      discontinuityStarts = _ref3.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes2 = {
	      NAME: attributes.id,
	      AUDIO: 'audio',
	      SUBTITLES: 'subs',
	      RESOLUTION: {
	        width: attributes.width,
	        height: attributes.height
	      },
	      CODECS: attributes.codecs,
	      BANDWIDTH: attributes.bandwidth
	    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    segments: segments
	  };
	
	  if (attributes.frameRate) {
	    playlist.attributes['FRAME-RATE'] = attributes.frameRate;
	  }
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  return playlist;
	};
	
	var videoOnly = function videoOnly(_ref4) {
	  var attributes = _ref4.attributes;
	  return attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
	};
	
	var audioOnly = function audioOnly(_ref5) {
	  var attributes = _ref5.attributes;
	  return attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
	};
	
	var vttOnly = function vttOnly(_ref6) {
	  var attributes = _ref6.attributes;
	  return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
	};
	/**
	 * Contains start and timeline properties denoting a timeline start. For DASH, these will
	 * be the same number.
	 *
	 * @typedef {Object} TimelineStart
	 * @property {number} start - the start time of the timeline
	 * @property {number} timeline - the timeline number
	 */
	
	/**
	 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
	 *
	 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
	 * DASH specific attribute used in constructing segment URI's from templates. However, from
	 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
	 * value, which should start at the original media sequence value (or 0) and increment by 1
	 * for each segment thereafter. Since DASH's `startNumber` values are independent per
	 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
	 * from a 0 mediaSequence value and increment from there.
	 *
	 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
	 * debugging and making sense of the manifest.
	 *
	 * For live playlists, to account for values increasing in manifests when periods are
	 * removed on refreshes, merging logic should be used to update the numbers to their
	 * appropriate values (to ensure they're sequential and increasing).
	 *
	 * @param {Object[]} playlists - the playlists to update
	 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
	 */
	
	
	var addMediaSequenceValues = function addMediaSequenceValues(playlists, timelineStarts) {
	  // increment all segments sequentially
	  playlists.forEach(function (playlist) {
	    playlist.mediaSequence = 0;
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref7) {
	      var timeline = _ref7.timeline;
	      return timeline === playlist.timeline;
	    });
	
	    if (!playlist.segments) {
	      return;
	    }
	
	    playlist.segments.forEach(function (segment, index) {
	      segment.number = index;
	    });
	  });
	};
	/**
	 * Given a media group object, flattens all playlists within the media group into a single
	 * array.
	 *
	 * @param {Object} mediaGroupObject - the media group object
	 *
	 * @return {Object[]}
	 *         The media group playlists
	 */
	
	var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists(mediaGroupObject) {
	  if (!mediaGroupObject) {
	    return [];
	  }
	
	  return Object.keys(mediaGroupObject).reduce(function (acc, label) {
	    var labelContents = mediaGroupObject[label];
	    return acc.concat(labelContents.playlists);
	  }, []);
	};
	var toM3u8 = function toM3u8(_ref8) {
	  var _mediaGroups;
	
	  var dashPlaylists = _ref8.dashPlaylists,
	      locations = _ref8.locations,
	      _ref8$sidxMapping = _ref8.sidxMapping,
	      sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping,
	      previousManifest = _ref8.previousManifest;
	
	  if (!dashPlaylists.length) {
	    return {};
	  } // grab all main manifest attributes
	
	
	  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
	      duration = _dashPlaylists$0$attr.sourceDuration,
	      type = _dashPlaylists$0$attr.type,
	      suggestedPresentationDelay = _dashPlaylists$0$attr.suggestedPresentationDelay,
	      minimumUpdatePeriod = _dashPlaylists$0$attr.minimumUpdatePeriod;
	  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
	  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
	  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
	  var captions = dashPlaylists.map(function (playlist) {
	    return playlist.attributes.captionServices;
	  }).filter(Boolean);
	  var manifest = {
	    allowCache: true,
	    discontinuityStarts: [],
	    segments: [],
	    endList: true,
	    mediaGroups: (_mediaGroups = {
	      AUDIO: {},
	      VIDEO: {}
	    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
	    uri: '',
	    duration: duration,
	    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
	  };
	
	  if (minimumUpdatePeriod >= 0) {
	    manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
	  }
	
	  if (locations) {
	    manifest.locations = locations;
	  }
	
	  if (type === 'dynamic') {
	    manifest.suggestedPresentationDelay = suggestedPresentationDelay;
	  }
	
	  var isAudioOnly = manifest.playlists.length === 0;
	  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
	  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
	  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
	  var playlistTimelineStarts = formattedPlaylists.map(function (_ref9) {
	    var timelineStarts = _ref9.timelineStarts;
	    return timelineStarts;
	  });
	  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
	  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
	
	  if (organizedAudioGroup) {
	    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
	  }
	
	  if (organizedVttGroup) {
	    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
	  }
	
	  if (captions.length) {
	    manifest.mediaGroups['CLOSED-CAPTIONS'].cc = organizeCaptionServices(captions);
	  }
	
	  if (previousManifest) {
	    return positionManifestOnTimeline({
	      oldManifest: previousManifest,
	      newManifest: manifest
	    });
	  }
	
	  return manifest;
	};
	
	/**
	 * Calculates the R (repetition) value for a live stream (for the final segment
	 * in a manifest where the r value is negative 1)
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {number} time
	 *        current time (typically the total time up until the final segment)
	 * @param {number} duration
	 *        duration property for the given <S />
	 *
	 * @return {number}
	 *        R value to reach the end of the given period
	 */
	var getLiveRValue = function getLiveRValue(attributes, time, duration) {
	  var NOW = attributes.NOW,
	      clientOffset = attributes.clientOffset,
	      availabilityStartTime = attributes.availabilityStartTime,
	      _attributes$timescale = attributes.timescale,
	      timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	      _attributes$periodSta = attributes.periodStart,
	      periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	      _attributes$minimumUp = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
	  var now = (NOW + clientOffset) / 1000;
	  var periodStartWC = availabilityStartTime + periodStart;
	  var periodEndWC = now + minimumUpdatePeriod;
	  var periodDuration = periodEndWC - periodStartWC;
	  return Math.ceil((periodDuration * timescale - time) / duration);
	};
	/**
	 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
	 * timing and duration
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	
	var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
	  var type = attributes.type,
	      _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2,
	      _attributes$media = attributes.media,
	      media = _attributes$media === void 0 ? '' : _attributes$media,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$timescale2 = attributes.timescale,
	      timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	      _attributes$startNumb = attributes.startNumber,
	      startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb,
	      timeline = attributes.periodStart;
	  var segments = [];
	  var time = -1;
	
	  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
	    var S = segmentTimeline[sIndex];
	    var duration = S.d;
	    var repeat = S.r || 0;
	    var segmentTime = S.t || 0;
	
	    if (time < 0) {
	      // first segment
	      time = segmentTime;
	    }
	
	    if (segmentTime && segmentTime > time) {
	      // discontinuity
	      // TODO: How to handle this type of discontinuity
	      // timeline++ here would treat it like HLS discontuity and content would
	      // get appended without gap
	      // E.G.
	      //  <S t="0" d="1" />
	      //  <S d="1" />
	      //  <S d="1" />
	      //  <S t="5" d="1" />
	      // would have $Time$ values of [0, 1, 2, 5]
	      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
	      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
	      // does the value of sourceDuration consider this when calculating arbitrary
	      // negative @r repeat value?
	      // E.G. Same elements as above with this added at the end
	      //  <S d="1" r="-1" />
	      //  with a sourceDuration of 10
	      // Would the 2 gaps be included in the time duration calculations resulting in
	      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
	      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
	      time = segmentTime;
	    }
	
	    var count = void 0;
	
	    if (repeat < 0) {
	      var nextS = sIndex + 1;
	
	      if (nextS === segmentTimeline.length) {
	        // last segment
	        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
	          count = getLiveRValue(attributes, time, duration);
	        } else {
	          // TODO: This may be incorrect depending on conclusion of TODO above
	          count = (sourceDuration * timescale - time) / duration;
	        }
	      } else {
	        count = (segmentTimeline[nextS].t - time) / duration;
	      }
	    } else {
	      count = repeat + 1;
	    }
	
	    var end = startNumber + segments.length + count;
	    var number = startNumber + segments.length;
	
	    while (number < end) {
	      segments.push({
	        number: number,
	        duration: duration / timescale,
	        time: time,
	        timeline: timeline
	      });
	      time += duration;
	      number++;
	    }
	  }
	
	  return segments;
	};
	
	var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
	/**
	 * Replaces template identifiers with corresponding values. To be used as the callback
	 * for String.prototype.replace
	 *
	 * @name replaceCallback
	 * @function
	 * @param {string} match
	 *        Entire match of identifier
	 * @param {string} identifier
	 *        Name of matched identifier
	 * @param {string} format
	 *        Format tag string. Its presence indicates that padding is expected
	 * @param {string} width
	 *        Desired length of the replaced value. Values less than this width shall be left
	 *        zero padded
	 * @return {string}
	 *         Replacement for the matched identifier
	 */
	
	/**
	 * Returns a function to be used as a callback for String.prototype.replace to replace
	 * template identifiers
	 *
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {replaceCallback}
	 *         Callback to be used with String.prototype.replace to replace identifiers
	 */
	
	var identifierReplacement = function identifierReplacement(values) {
	  return function (match, identifier, format, width) {
	    if (match === '$$') {
	      // escape sequence
	      return '$';
	    }
	
	    if (typeof values[identifier] === 'undefined') {
	      return match;
	    }
	
	    var value = '' + values[identifier];
	
	    if (identifier === 'RepresentationID') {
	      // Format tag shall not be present with RepresentationID
	      return value;
	    }
	
	    if (!format) {
	      width = 1;
	    } else {
	      width = parseInt(width, 10);
	    }
	
	    if (value.length >= width) {
	      return value;
	    }
	
	    return "" + new Array(width - value.length + 1).join('0') + value;
	  };
	};
	/**
	 * Constructs a segment url from a template string
	 *
	 * @param {string} url
	 *        Template string to construct url from
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {string}
	 *         Segment url with identifiers replaced
	 */
	
	var constructTemplateUrl = function constructTemplateUrl(url, values) {
	  return url.replace(identifierPattern, identifierReplacement(values));
	};
	/**
	 * Generates a list of objects containing timing and duration information about each
	 * segment needed to generate segment uris and the complete segment object
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
	  if (!attributes.duration && !segmentTimeline) {
	    // if neither @duration or SegmentTimeline are present, then there shall be exactly
	    // one media segment
	    return [{
	      number: attributes.startNumber || 1,
	      duration: attributes.sourceDuration,
	      time: 0,
	      timeline: attributes.periodStart
	    }];
	  }
	
	  if (attributes.duration) {
	    return parseByDuration(attributes);
	  }
	
	  return parseByTimeline(attributes, segmentTimeline);
	};
	/**
	 * Generates a list of segments using information provided by the SegmentTemplate element
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object[]}
	 *         List of segment objects
	 */
	
	var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
	  var templateValues = {
	    RepresentationID: attributes.id,
	    Bandwidth: attributes.bandwidth || 0
	  };
	  var _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {
	    sourceURL: '',
	    range: ''
	  } : _attributes$initializ;
	  var mapSegment = urlTypeToSegment({
	    baseUrl: attributes.baseUrl,
	    source: constructTemplateUrl(initialization.sourceURL, templateValues),
	    range: initialization.range
	  });
	  var segments = parseTemplateInfo(attributes, segmentTimeline);
	  return segments.map(function (segment) {
	    templateValues.Number = segment.number;
	    templateValues.Time = segment.time;
	    var uri = constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
	    // - if timescale isn't present on any level, default to 1.
	
	    var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	    var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	    var presentationTime = // Even if the @t attribute is not specified for the segment, segment.time is
	    // calculated in mpd-parser prior to this, so it's assumed to be available.
	    attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
	    var map = {
	      uri: uri,
	      timeline: segment.timeline,
	      duration: segment.duration,
	      resolvedUri: resolveUrl__default['default'](attributes.baseUrl || '', uri),
	      map: mapSegment,
	      number: segment.number,
	      presentationTime: presentationTime
	    };
	    return map;
	  });
	};
	
	/**
	 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
	 * to an object that matches the output of a segment in videojs/mpd-parser
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object} segmentUrl
	 *   <SegmentURL> node to translate into a segment object
	 * @return {Object} translated segment object
	 */
	
	var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: segmentUrl.media,
	    range: segmentUrl.mediaRange
	  });
	  segment.map = initSegment;
	  return segment;
	};
	/**
	 * Generates a list of segments using information provided by the SegmentList element
	 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object.<Array>} list of segments
	 */
	
	
	var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
	  var duration = attributes.duration,
	      _attributes$segmentUr = attributes.segmentUrls,
	      segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr,
	      periodStart = attributes.periodStart; // Per spec (5.3.9.2.1) no way to determine segment duration OR
	  // if both SegmentTimeline and @duration are defined, it is outside of spec.
	
	  if (!duration && !segmentTimeline || duration && segmentTimeline) {
	    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
	  }
	
	  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
	    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
	  });
	  var segmentTimeInfo;
	
	  if (duration) {
	    segmentTimeInfo = parseByDuration(attributes);
	  }
	
	  if (segmentTimeline) {
	    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
	  }
	
	  var segments = segmentTimeInfo.map(function (segmentTime, index) {
	    if (segmentUrlMap[index]) {
	      var segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
	      // - if timescale isn't present on any level, default to 1.
	
	      var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	      var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	      segment.timeline = segmentTime.timeline;
	      segment.duration = segmentTime.duration;
	      segment.number = segmentTime.number;
	      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
	      return segment;
	    } // Since we're mapping we should get rid of any blank segments (in case
	    // the given SegmentTimeline is handling for more elements than we have
	    // SegmentURLs for).
	
	  }).filter(function (segment) {
	    return segment;
	  });
	  return segments;
	};
	
	var generateSegments = function generateSegments(_ref) {
	  var attributes = _ref.attributes,
	      segmentInfo = _ref.segmentInfo;
	  var segmentAttributes;
	  var segmentsFn;
	
	  if (segmentInfo.template) {
	    segmentsFn = segmentsFromTemplate;
	    segmentAttributes = merge(attributes, segmentInfo.template);
	  } else if (segmentInfo.base) {
	    segmentsFn = segmentsFromBase;
	    segmentAttributes = merge(attributes, segmentInfo.base);
	  } else if (segmentInfo.list) {
	    segmentsFn = segmentsFromList;
	    segmentAttributes = merge(attributes, segmentInfo.list);
	  }
	
	  var segmentsInfo = {
	    attributes: attributes
	  };
	
	  if (!segmentsFn) {
	    return segmentsInfo;
	  }
	
	  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
	  // must be in seconds. Since we've generated the segment list, we no longer need
	  // @duration to be in @timescale units, so we can convert it here.
	
	  if (segmentAttributes.duration) {
	    var _segmentAttributes = segmentAttributes,
	        duration = _segmentAttributes.duration,
	        _segmentAttributes$ti = _segmentAttributes.timescale,
	        timescale = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
	    segmentAttributes.duration = duration / timescale;
	  } else if (segments.length) {
	    // if there is no @duration attribute, use the largest segment duration as
	    // as target duration
	    segmentAttributes.duration = segments.reduce(function (max, segment) {
	      return Math.max(max, Math.ceil(segment.duration));
	    }, 0);
	  } else {
	    segmentAttributes.duration = 0;
	  }
	
	  segmentsInfo.attributes = segmentAttributes;
	  segmentsInfo.segments = segments; // This is a sidx box without actual segment information
	
	  if (segmentInfo.base && segmentAttributes.indexRange) {
	    segmentsInfo.sidx = segments[0];
	    segmentsInfo.segments = [];
	  }
	
	  return segmentsInfo;
	};
	var toPlaylists = function toPlaylists(representations) {
	  return representations.map(generateSegments);
	};
	
	var findChildren = function findChildren(element, name) {
	  return from(element.childNodes).filter(function (_ref) {
	    var tagName = _ref.tagName;
	    return tagName === name;
	  });
	};
	var getContent = function getContent(element) {
	  return element.textContent.trim();
	};
	
	/**
	 * Converts the provided string that may contain a division operation to a number.
	 *
	 * @param {string} value - the provided string value
	 *
	 * @return {number} the parsed string value
	 */
	var parseDivisionValue = function parseDivisionValue(value) {
	  return parseFloat(value.split('/').reduce(function (prev, current) {
	    return prev / current;
	  }));
	};
	
	var parseDuration = function parseDuration(str) {
	  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
	  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
	  var SECONDS_IN_DAY = 24 * 60 * 60;
	  var SECONDS_IN_HOUR = 60 * 60;
	  var SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
	
	  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
	  var match = durationRegex.exec(str);
	
	  if (!match) {
	    return 0;
	  }
	
	  var _match$slice = match.slice(1),
	      year = _match$slice[0],
	      month = _match$slice[1],
	      day = _match$slice[2],
	      hour = _match$slice[3],
	      minute = _match$slice[4],
	      second = _match$slice[5];
	
	  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
	};
	var parseDate = function parseDate(str) {
	  // Date format without timezone according to ISO 8601
	  // YYY-MM-DDThh:mm:ss.ssssss
	  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
	  // expressed by ending with 'Z'
	
	  if (dateRegex.test(str)) {
	    str += 'Z';
	  }
	
	  return Date.parse(str);
	};
	
	var parsers = {
	  /**
	   * Specifies the duration of the entire Media Presentation. Format is a duration string
	   * as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  mediaPresentationDuration: function mediaPresentationDuration(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the Segment availability start time for all Segments referred to in this
	   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
	   * time. Format is a date string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The date as seconds from unix epoch
	   */
	  availabilityStartTime: function availabilityStartTime(value) {
	    return parseDate(value) / 1000;
	  },
	
	  /**
	   * Specifies the smallest period between potential changes to the MPD. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the suggested presentation delay. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * specifices the type of mpd. Can be either "static" or "dynamic"
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   *
	   * @return {string}
	   *         The type as a string
	   */
	  type: function type(value) {
	    return value;
	  },
	
	  /**
	   * Specifies the duration of the smallest time shifting buffer for any Representation
	   * in the MPD. Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
	   * Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  start: function start(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the width of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed width
	   */
	  width: function width(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the height of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed height
	   */
	  height: function height(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the bitrate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed bandwidth
	   */
	  bandwidth: function bandwidth(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the frame rate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed frame rate
	   */
	  frameRate: function frameRate(value) {
	    return parseDivisionValue(value);
	  },
	
	  /**
	   * Specifies the number of the first Media Segment in this Representation in the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  startNumber: function startNumber(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the timescale in units per seconds
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed timescale
	   */
	  timescale: function timescale(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the presentationTimeOffset.
	   *
	   * @param {string} value
	   *        value of the attribute as a string
	   *
	   * @return {number}
	   *         The parsed presentationTimeOffset
	   */
	  presentationTimeOffset: function presentationTimeOffset(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the constant approximate Segment duration
	   * NOTE: The <Period> element also contains an @duration attribute. This duration
	   *       specifies the duration of the Period. This attribute is currently not
	   *       supported by the rest of the parser, however we still check for it to prevent
	   *       errors.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  duration: function duration(value) {
	    var parsedValue = parseInt(value, 10);
	
	    if (isNaN(parsedValue)) {
	      return parseDuration(value);
	    }
	
	    return parsedValue;
	  },
	
	  /**
	   * Specifies the Segment duration, in units of the value of the @timescale.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  d: function d(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the MPD start time, in @timescale units, the first Segment in the series
	   * starts relative to the beginning of the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed time
	   */
	  t: function t(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the repeat count of the number of following contiguous Segments with the
	   * same duration expressed by the value of @d
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  r: function r(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Default parser for all other attributes. Acts as a no-op and just returns the value
	   * as a string
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {string}
	   *         Unparsed value
	   */
	  DEFAULT: function DEFAULT(value) {
	    return value;
	  }
	};
	/**
	 * Gets all the attributes and values of the provided node, parses attributes with known
	 * types, and returns an object with attribute names mapped to values.
	 *
	 * @param {Node} el
	 *        The node to parse attributes from
	 * @return {Object}
	 *         Object with all attributes of el parsed
	 */
	
	var parseAttributes = function parseAttributes(el) {
	  if (!(el && el.attributes)) {
	    return {};
	  }
	
	  return from(el.attributes).reduce(function (a, e) {
	    var parseFn = parsers[e.name] || parsers.DEFAULT;
	    a[e.name] = parseFn(e.value);
	    return a;
	  }, {});
	};
	
	var keySystemsMap = {
	  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
	  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
	  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
	  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
	};
	/**
	 * Builds a list of urls that is the product of the reference urls and BaseURL values
	 *
	 * @param {string[]} referenceUrls
	 *        List of reference urls to resolve to
	 * @param {Node[]} baseUrlElements
	 *        List of BaseURL nodes from the mpd
	 * @return {string[]}
	 *         List of resolved urls
	 */
	
	var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
	  if (!baseUrlElements.length) {
	    return referenceUrls;
	  }
	
	  return flatten(referenceUrls.map(function (reference) {
	    return baseUrlElements.map(function (baseUrlElement) {
	      return resolveUrl__default['default'](reference, getContent(baseUrlElement));
	    });
	  }));
	};
	/**
	 * Contains all Segment information for its containing AdaptationSet
	 *
	 * @typedef {Object} SegmentInformation
	 * @property {Object|undefined} template
	 *           Contains the attributes for the SegmentTemplate node
	 * @property {Object[]|undefined} segmentTimeline
	 *           Contains a list of atrributes for each S node within the SegmentTimeline node
	 * @property {Object|undefined} list
	 *           Contains the attributes for the SegmentList node
	 * @property {Object|undefined} base
	 *           Contains the attributes for the SegmentBase node
	 */
	
	/**
	 * Returns all available Segment information contained within the AdaptationSet node
	 *
	 * @param {Node} adaptationSet
	 *        The AdaptationSet node to get Segment information from
	 * @return {SegmentInformation}
	 *         The Segment information contained within the provided AdaptationSet
	 */
	
	var getSegmentInformation = function getSegmentInformation(adaptationSet) {
	  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
	  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
	  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
	    return merge({
	      tag: 'SegmentURL'
	    }, parseAttributes(s));
	  });
	  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
	  var segmentTimelineParentNode = segmentList || segmentTemplate;
	  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
	  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
	  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
	  // @initialization and an <Initialization> node.  @initialization can be templated,
	  // while the node can have a url and range specified.  If the <SegmentTemplate> has
	  // both @initialization and an <Initialization> subelement we opt to override with
	  // the node, as this interaction is not defined in the spec.
	
	  var template = segmentTemplate && parseAttributes(segmentTemplate);
	
	  if (template && segmentInitialization) {
	    template.initialization = segmentInitialization && parseAttributes(segmentInitialization);
	  } else if (template && template.initialization) {
	    // If it is @initialization we convert it to an object since this is the format that
	    // later functions will rely on for the initialization segment.  This is only valid
	    // for <SegmentTemplate>
	    template.initialization = {
	      sourceURL: template.initialization
	    };
	  }
	
	  var segmentInfo = {
	    template: template,
	    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
	      return parseAttributes(s);
	    }),
	    list: segmentList && merge(parseAttributes(segmentList), {
	      segmentUrls: segmentUrls,
	      initialization: parseAttributes(segmentInitialization)
	    }),
	    base: segmentBase && merge(parseAttributes(segmentBase), {
	      initialization: parseAttributes(segmentInitialization)
	    })
	  };
	  Object.keys(segmentInfo).forEach(function (key) {
	    if (!segmentInfo[key]) {
	      delete segmentInfo[key];
	    }
	  });
	  return segmentInfo;
	};
	/**
	 * Contains Segment information and attributes needed to construct a Playlist object
	 * from a Representation
	 *
	 * @typedef {Object} RepresentationInformation
	 * @property {SegmentInformation} segmentInfo
	 *           Segment information for this Representation
	 * @property {Object} attributes
	 *           Inherited attributes for this Representation
	 */
	
	/**
	 * Maps a Representation node to an object containing Segment information and attributes
	 *
	 * @name inheritBaseUrlsCallback
	 * @function
	 * @param {Node} representation
	 *        Representation node from the mpd
	 * @return {RepresentationInformation}
	 *         Representation information needed to construct a Playlist object
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Representation nodes to
	 * Segment information and attributes using inherited BaseURL nodes.
	 *
	 * @param {Object} adaptationSetAttributes
	 *        Contains attributes inherited by the AdaptationSet
	 * @param {string[]} adaptationSetBaseUrls
	 *        Contains list of resolved base urls inherited by the AdaptationSet
	 * @param {SegmentInformation} adaptationSetSegmentInfo
	 *        Contains Segment information for the AdaptationSet
	 * @return {inheritBaseUrlsCallback}
	 *         Callback map function
	 */
	
	var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
	  return function (representation) {
	    var repBaseUrlElements = findChildren(representation, 'BaseURL');
	    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
	    var attributes = merge(adaptationSetAttributes, parseAttributes(representation));
	    var representationSegmentInfo = getSegmentInformation(representation);
	    return repBaseUrls.map(function (baseUrl) {
	      return {
	        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
	        attributes: merge(attributes, {
	          baseUrl: baseUrl
	        })
	      };
	    });
	  };
	};
	/**
	 * Tranforms a series of content protection nodes to
	 * an object containing pssh data by key system
	 *
	 * @param {Node[]} contentProtectionNodes
	 *        Content protection nodes
	 * @return {Object}
	 *        Object containing pssh data by key system
	 */
	
	var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
	  return contentProtectionNodes.reduce(function (acc, node) {
	    var attributes = parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
	    // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
	    // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
	    // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
	
	    if (attributes.schemeIdUri) {
	      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
	    }
	
	    var keySystem = keySystemsMap[attributes.schemeIdUri];
	
	    if (keySystem) {
	      acc[keySystem] = {
	        attributes: attributes
	      };
	      var psshNode = findChildren(node, 'cenc:pssh')[0];
	
	      if (psshNode) {
	        var pssh = getContent(psshNode);
	        acc[keySystem].pssh = pssh && decodeB64ToUint8Array__default['default'](pssh);
	      }
	    }
	
	    return acc;
	  }, {});
	}; // defined in ANSI_SCTE 214-1 2016
	
	
	var parseCaptionServiceMetadata = function parseCaptionServiceMetadata(service) {
	  // 608 captions
	  if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
	    var values = typeof service.value !== 'string' ? [] : service.value.split(';');
	    return values.map(function (value) {
	      var channel;
	      var language; // default language to value
	
	      language = value;
	
	      if (/^CC\d=/.test(value)) {
	        var _value$split = value.split('=');
	
	        channel = _value$split[0];
	        language = _value$split[1];
	      } else if (/^CC\d$/.test(value)) {
	        channel = value;
	      }
	
	      return {
	        channel: channel,
	        language: language
	      };
	    });
	  } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
	    var _values = typeof service.value !== 'string' ? [] : service.value.split(';');
	
	    return _values.map(function (value) {
	      var flags = {
	        // service or channel number 1-63
	        'channel': undefined,
	        // language is a 3ALPHA per ISO 639.2/B
	        // field is required
	        'language': undefined,
	        // BIT 1/0 or ?
	        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
	        'aspectRatio': 1,
	        // BIT 1/0
	        // easy reader flag indicated the text is tailed to the needs of beginning readers
	        // default 0, or off
	        'easyReader': 0,
	        // BIT 1/0
	        // If 3d metadata is present (CEA-708.1) then 1
	        // default 0
	        '3D': 0
	      };
	
	      if (/=/.test(value)) {
	        var _value$split2 = value.split('='),
	            channel = _value$split2[0],
	            _value$split2$ = _value$split2[1],
	            opts = _value$split2$ === void 0 ? '' : _value$split2$;
	
	        flags.channel = channel;
	        flags.language = value;
	        opts.split(',').forEach(function (opt) {
	          var _opt$split = opt.split(':'),
	              name = _opt$split[0],
	              val = _opt$split[1];
	
	          if (name === 'lang') {
	            flags.language = val; // er for easyReadery
	          } else if (name === 'er') {
	            flags.easyReader = Number(val); // war for wide aspect ratio
	          } else if (name === 'war') {
	            flags.aspectRatio = Number(val);
	          } else if (name === '3D') {
	            flags['3D'] = Number(val);
	          }
	        });
	      } else {
	        flags.language = value;
	      }
	
	      if (flags.channel) {
	        flags.channel = 'SERVICE' + flags.channel;
	      }
	
	      return flags;
	    });
	  }
	};
	/**
	 * Maps an AdaptationSet node to a list of Representation information objects
	 *
	 * @name toRepresentationsCallback
	 * @function
	 * @param {Node} adaptationSet
	 *        AdaptationSet node from the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} periodAttributes
	 *        Contains attributes inherited by the Period
	 * @param {string[]} periodBaseUrls
	 *        Contains list of resolved base urls inherited by the Period
	 * @param {string[]} periodSegmentInfo
	 *        Contains Segment Information at the period level
	 * @return {toRepresentationsCallback}
	 *         Callback map function
	 */
	
	var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
	  return function (adaptationSet) {
	    var adaptationSetAttributes = parseAttributes(adaptationSet);
	    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
	    var role = findChildren(adaptationSet, 'Role')[0];
	    var roleAttributes = {
	      role: parseAttributes(role)
	    };
	    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
	    var accessibility = findChildren(adaptationSet, 'Accessibility')[0];
	    var captionServices = parseCaptionServiceMetadata(parseAttributes(accessibility));
	
	    if (captionServices) {
	      attrs = merge(attrs, {
	        captionServices: captionServices
	      });
	    }
	
	    var label = findChildren(adaptationSet, 'Label')[0];
	
	    if (label && label.childNodes.length) {
	      var labelVal = label.childNodes[0].nodeValue.trim();
	      attrs = merge(attrs, {
	        label: labelVal
	      });
	    }
	
	    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
	
	    if (Object.keys(contentProtection).length) {
	      attrs = merge(attrs, {
	        contentProtection: contentProtection
	      });
	    }
	
	    var segmentInfo = getSegmentInformation(adaptationSet);
	    var representations = findChildren(adaptationSet, 'Representation');
	    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
	    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
	  };
	};
	/**
	 * Contains all period information for mapping nodes onto adaptation sets.
	 *
	 * @typedef {Object} PeriodInformation
	 * @property {Node} period.node
	 *           Period node from the mpd
	 * @property {Object} period.attributes
	 *           Parsed period attributes from node plus any added
	 */
	
	/**
	 * Maps a PeriodInformation object to a list of Representation information objects for all
	 * AdaptationSet nodes contained within the Period.
	 *
	 * @name toAdaptationSetsCallback
	 * @function
	 * @param {PeriodInformation} period
	 *        Period object containing necessary period information
	 * @param {number} periodStart
	 *        Start time of the Period within the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} mpdAttributes
	 *        Contains attributes inherited by the mpd
	 * @param {string[]} mpdBaseUrls
	 *        Contains list of resolved base urls inherited by the mpd
	 * @return {toAdaptationSetsCallback}
	 *         Callback map function
	 */
	
	var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
	  return function (period, index) {
	    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, 'BaseURL'));
	    var periodAttributes = merge(mpdAttributes, {
	      periodStart: period.attributes.start
	    });
	
	    if (typeof period.attributes.duration === 'number') {
	      periodAttributes.periodDuration = period.attributes.duration;
	    }
	
	    var adaptationSets = findChildren(period.node, 'AdaptationSet');
	    var periodSegmentInfo = getSegmentInformation(period.node);
	    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
	  };
	};
	/**
	 * Gets Period@start property for a given period.
	 *
	 * @param {Object} options
	 *        Options object
	 * @param {Object} options.attributes
	 *        Period attributes
	 * @param {Object} [options.priorPeriodAttributes]
	 *        Prior period attributes (if prior period is available)
	 * @param {string} options.mpdType
	 *        The MPD@type these periods came from
	 * @return {number|null}
	 *         The period start, or null if it's an early available period or error
	 */
	
	var getPeriodStart = function getPeriodStart(_ref) {
	  var attributes = _ref.attributes,
	      priorPeriodAttributes = _ref.priorPeriodAttributes,
	      mpdType = _ref.mpdType;
	
	  // Summary of period start time calculation from DASH spec section 5.3.2.1
	  //
	  // A period's start is the first period's start + time elapsed after playing all
	  // prior periods to this one. Periods continue one after the other in time (without
	  // gaps) until the end of the presentation.
	  //
	  // The value of Period@start should be:
	  // 1. if Period@start is present: value of Period@start
	  // 2. if previous period exists and it has @duration: previous Period@start +
	  //    previous Period@duration
	  // 3. if this is first period and MPD@type is 'static': 0
	  // 4. in all other cases, consider the period an "early available period" (note: not
	  //    currently supported)
	  // (1)
	  if (typeof attributes.start === 'number') {
	    return attributes.start;
	  } // (2)
	
	
	  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') {
	    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
	  } // (3)
	
	
	  if (!priorPeriodAttributes && mpdType === 'static') {
	    return 0;
	  } // (4)
	  // There is currently no logic for calculating the Period@start value if there is
	  // no Period@start or prior Period@start and Period@duration available. This is not made
	  // explicit by the DASH interop guidelines or the DASH spec, however, since there's
	  // nothing about any other resolution strategies, it's implied. Thus, this case should
	  // be considered an early available period, or error, and null should suffice for both
	  // of those cases.
	
	
	  return null;
	};
	/**
	 * Traverses the mpd xml tree to generate a list of Representation information objects
	 * that have inherited attributes from parent nodes
	 *
	 * @param {Node} mpd
	 *        The root node of the mpd
	 * @param {Object} options
	 *        Available options for inheritAttributes
	 * @param {string} options.manifestUri
	 *        The uri source of the mpd
	 * @param {number} options.NOW
	 *        Current time per DASH IOP.  Default is current time in ms since epoch
	 * @param {number} options.clientOffset
	 *        Client time difference from NOW (in milliseconds)
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representation information
	 */
	
	var inheritAttributes = function inheritAttributes(mpd, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$manifestUri = _options.manifestUri,
	      manifestUri = _options$manifestUri === void 0 ? '' : _options$manifestUri,
	      _options$NOW = _options.NOW,
	      NOW = _options$NOW === void 0 ? Date.now() : _options$NOW,
	      _options$clientOffset = _options.clientOffset,
	      clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
	  var periodNodes = findChildren(mpd, 'Period');
	
	  if (!periodNodes.length) {
	    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
	  }
	
	  var locations = findChildren(mpd, 'Location');
	  var mpdAttributes = parseAttributes(mpd);
	  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL')); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
	
	  mpdAttributes.type = mpdAttributes.type || 'static';
	  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
	  mpdAttributes.NOW = NOW;
	  mpdAttributes.clientOffset = clientOffset;
	
	  if (locations.length) {
	    mpdAttributes.locations = locations.map(getContent);
	  }
	
	  var periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
	  // adding properties that require looking at prior periods is to parse attributes and add
	  // missing ones before toAdaptationSets is called. If more such properties are added, it
	  // may be better to refactor toAdaptationSets.
	
	  periodNodes.forEach(function (node, index) {
	    var attributes = parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
	    // for this period.
	
	    var priorPeriod = periods[index - 1];
	    attributes.start = getPeriodStart({
	      attributes: attributes,
	      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
	      mpdType: mpdAttributes.type
	    });
	    periods.push({
	      node: node,
	      attributes: attributes
	    });
	  });
	  return {
	    locations: mpdAttributes.locations,
	    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
	  };
	};
	
	var stringToMpdXml = function stringToMpdXml(manifestString) {
	  if (manifestString === '') {
	    throw new Error(errors.DASH_EMPTY_MANIFEST);
	  }
	
	  var parser = new xmldom.DOMParser();
	  var xml;
	  var mpd;
	
	  try {
	    xml = parser.parseFromString(manifestString, 'application/xml');
	    mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
	  } catch (e) {// ie 11 throwsw on invalid xml
	  }
	
	  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
	    throw new Error(errors.DASH_INVALID_XML);
	  }
	
	  return mpd;
	};
	
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} mpd
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
	  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
	
	  if (!UTCTimingNode) {
	    return null;
	  }
	
	  var attributes = parseAttributes(UTCTimingNode);
	
	  switch (attributes.schemeIdUri) {
	    case 'urn:mpeg:dash:utc:http-head:2014':
	    case 'urn:mpeg:dash:utc:http-head:2012':
	      attributes.method = 'HEAD';
	      break;
	
	    case 'urn:mpeg:dash:utc:http-xsdate:2014':
	    case 'urn:mpeg:dash:utc:http-iso:2014':
	    case 'urn:mpeg:dash:utc:http-xsdate:2012':
	    case 'urn:mpeg:dash:utc:http-iso:2012':
	      attributes.method = 'GET';
	      break;
	
	    case 'urn:mpeg:dash:utc:direct:2014':
	    case 'urn:mpeg:dash:utc:direct:2012':
	      attributes.method = 'DIRECT';
	      attributes.value = Date.parse(attributes.value);
	      break;
	
	    case 'urn:mpeg:dash:utc:http-ntp:2014':
	    case 'urn:mpeg:dash:utc:ntp:2014':
	    case 'urn:mpeg:dash:utc:sntp:2014':
	    default:
	      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
	  }
	
	  return attributes;
	};
	
	var VERSION = version;
	/*
	 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
	 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
	 *
	 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
	 * parsed DASH manifest will have its media sequence and discontinuity sequence values
	 * updated to reflect its position relative to the prior manifest.
	 *
	 * @param {string} manifestString - the DASH manifest as a string
	 * @param {options} [options] - any options
	 *
	 * @return {Object} the manifest object
	 */
	
	var parse = function parse(manifestString, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
	  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
	  return toM3u8({
	    dashPlaylists: playlists,
	    locations: parsedManifestInfo.locations,
	    sidxMapping: options.sidxMapping,
	    previousManifest: options.previousManifest
	  });
	};
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} manifestString
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	
	var parseUTCTiming = function parseUTCTiming(manifestString) {
	  return parseUTCTimingScheme(stringToMpdXml(manifestString));
	};
	
	exports.VERSION = VERSION;
	exports.addSidxSegmentsToPlaylist = addSidxSegmentsToPlaylist$1;
	exports.generateSidxKey = generateSidxKey;
	exports.inheritAttributes = inheritAttributes;
	exports.parse = parse;
	exports.parseUTCTiming = parseUTCTiming;
	exports.stringToMpdXml = stringToMpdXml;
	exports.toM3u8 = toM3u8;
	exports.toPlaylists = toPlaylists;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var getUint64 = __webpack_require__(207).getUint64;
	
	var parseSidx = function(data) {
	  var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	      result = {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        references: [],
	        referenceId: view.getUint32(4),
	        timescale: view.getUint32(8)
	      },
	    i = 12;
	
	  if (result.version === 0) {
	    result.earliestPresentationTime = view.getUint32(i);
	    result.firstOffset = view.getUint32(i + 4);
	    i += 8;
	  } else {
	    // read 64 bits
	    result.earliestPresentationTime = getUint64(data.subarray(i));
	    result.firstOffset = getUint64(data.subarray(i + 8));
	    i += 16;
	  }
	
	  i += 2; // reserved
	
	  var referenceCount = view.getUint16(i);
	
	  i += 2; // start of references
	
	  for (; referenceCount > 0; i += 12, referenceCount--) {
	    result.references.push({
	      referenceType: (data[i] & 0x80) >>> 7,
	      referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	      subsegmentDuration: view.getUint32(i + 4),
	      startsWithSap: !!(data[i + 8] & 0x80),
	      sapType: (data[i + 8] & 0x70) >>> 4,
	      sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	    });
	  }
	
	  return result;
	};
	
	
	module.exports = parseSidx;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) Brightcove
	 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	 */
	var
	  ONE_SECOND_IN_TS = 90000, // 90kHz clock
	  secondsToVideoTs,
	  secondsToAudioTs,
	  videoTsToSeconds,
	  audioTsToSeconds,
	  audioTsToVideoTs,
	  videoTsToAudioTs,
	  metadataTsToSeconds;
	
	secondsToVideoTs = function(seconds) {
	  return seconds * ONE_SECOND_IN_TS;
	};
	
	secondsToAudioTs = function(seconds, sampleRate) {
	  return seconds * sampleRate;
	};
	
	videoTsToSeconds = function(timestamp) {
	  return timestamp / ONE_SECOND_IN_TS;
	};
	
	audioTsToSeconds = function(timestamp, sampleRate) {
	  return timestamp / sampleRate;
	};
	
	audioTsToVideoTs = function(timestamp, sampleRate) {
	  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	};
	
	videoTsToAudioTs = function(timestamp, sampleRate) {
	  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	};
	
	/**
	 * Adjust ID3 tag or caption timing information by the timeline pts values
	 * (if keepOriginalTimestamps is false) and convert to seconds
	 */
	metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
	  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	};
	
	module.exports = {
	  ONE_SECOND_IN_TS: ONE_SECOND_IN_TS,
	  secondsToVideoTs: secondsToVideoTs,
	  secondsToAudioTs: secondsToAudioTs,
	  videoTsToSeconds: videoTsToSeconds,
	  audioTsToSeconds: audioTsToSeconds,
	  audioTsToVideoTs: audioTsToVideoTs,
	  videoTsToAudioTs: videoTsToAudioTs,
	  metadataTsToSeconds: metadataTsToSeconds
	};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	var MAX_UINT32 = Math.pow(2, 32);
	
	var getUint64 = function(uint8) {
	  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	  var value;
	
	  if (dv.getBigUint64) {
	    value = dv.getBigUint64(0);
	
	    if (value < Number.MAX_SAFE_INTEGER) {
	      return Number(value);
	    }
	
	    return value;
	  }
	
	  return (dv.getUint32(0) * MAX_UINT32) + dv.getUint32(4);
	};
	
	module.exports = {
	  getUint64: getUint64,
	  MAX_UINT32: MAX_UINT32
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/*! ngStorage 0.3.0 | Copyright (c) 2013 Gias Kay Lee | MIT License */"use strict";!function(){function a(a){return["$rootScope","$window",function(b,c){for(var d,e,f,g=c[a]||(console.warn("This browser does not support Web Storage!"),{}),h={$default:function(a){for(var b in a)angular.isDefined(h[b])||(h[b]=a[b]);return h},$reset:function(a){for(var b in h)"$"===b[0]||delete h[b];return h.$default(a)}},i=0;i<g.length;i++)(f=g.key(i))&&"ngStorage-"===f.slice(0,10)&&(h[f.slice(10)]=angular.fromJson(g.getItem(f)));return d=angular.copy(h),b.$watch(function(){e||(e=setTimeout(function(){if(e=null,!angular.equals(h,d)){angular.forEach(h,function(a,b){angular.isDefined(a)&&"$"!==b[0]&&g.setItem("ngStorage-"+b,angular.toJson(a)),delete d[b]});for(var a in d)g.removeItem("ngStorage-"+a);d=angular.copy(h)}},100))}),"localStorage"===a&&c.addEventListener&&c.addEventListener("storage",function(a){"ngStorage-"===a.key.slice(0,10)&&(a.newValue?h[a.key.slice(10)]=angular.fromJson(a.newValue):delete h[a.key.slice(10)],d=angular.copy(h),b.$apply())}),h}]}angular.module("ngStorage",[]).factory("$localStorage",a("localStorage")).factory("$sessionStorage",a("sessionStorage"))}();

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	angular.module('oi.select', []);
	angular.module('oi.select')
	
	.provider('oiSelect', function() {
	    return {
	        options: {
	            debounce:       500,
	            searchFilter:   'oiSelectCloseIcon',
	            dropdownFilter: 'oiSelectHighlight',
	            listFilter:     'oiSelectAscSort',
	            groupFilter:    'oiSelectGroup',
	            editItem:       false,
	            newItem:        false,
	            closeList:      true,
	            saveTrigger:    'enter tab blur',
	            minlength:      0
	        },
	        version: {
	            full: '0.2.22',
	            major: 0,
	            minor: 2,
	            dot: 22
	        },
	        $get: function() {
	            return {
	                options: this.options,
	                version: this.version
	            };
	        }
	    };
	})
	
	.factory('oiSelectEscape', function() {
	    var rEscapableCharacters = /[-\/\\^$*+?.()|[\]{}]/g;  // cache escape + match String
	    var sEscapeMatch = '\\$&';
	
	    return function(string) {
	        return String(string).replace(rEscapableCharacters, sEscapeMatch);
	    };
	})
	
	.factory('oiSelectEditItem', function() {
	    return function(removedItem, lastQuery, getLabel, itemIsCorrected) {
	        return itemIsCorrected ? '' : getLabel(removedItem);
	    };
	})
	
	.factory('oiUtils', ['$document', '$timeout', function($document, $timeout) {
	    /**
	     * Check to see if a DOM element is a descendant of another DOM element.
	     *
	     * @param {DOM element} container
	     * @param {DOM element} contained
	     * @param {string} class name of element in container
	     * @returns {boolean}
	     */
	    function contains(container, contained, className) {
	        var current = contained;
	
	        while (current && current.ownerDocument && current.nodeType !== 11) {
	            if (className) {
	                if (current === container) {
	                    return false;
	                }
	                if (current.className.indexOf(className) >= 0) { //current.classList.contains(className) doesn't work in IE9
	                    return true;
	                }
	            } else {
	                if (current === container) {
	                    return true;
	                }
	            }
	            current = current.parentNode;
	        }
	
	        return false;
	    }
	
	    /**
	     * Simulate focus/blur events of the inner input element to the outer element
	     *
	     * @param {element} outer element
	     * @param {element} inner input element
	     * @returns {function} deregistration function for listeners.
	     */
	    function bindFocusBlur(element, inputElement) {
	        var isFocused, isMousedown, isBlur;
	
	        $document[0].addEventListener('click', clickHandler, true);
	        element[0].addEventListener('mousedown', mousedownHandler, true);
	        element[0].addEventListener('blur', blurHandler, true);
	        inputElement.on('focus', focusHandler);
	
	        function blurHandler(event) {
	            if (event && event.target.nodeName !== 'INPUT') return; //for IE
	
	            isBlur = false;
	            isFocused = false;
	
	            if (isMousedown) {
	                isBlur = true;
	                return;
	            }
	
	            $timeout(function () {
	                element.triggerHandler('blur'); //conflict with current live cycle (case: multiple=none + tab)
	            });
	        }
	
	        function focusHandler() {
	            if (!isFocused) {
	                isFocused = true;
	
	                $timeout(function () {
	                    element.triggerHandler('focus'); //conflict with current live cycle (case: multiple=none + tab)
	                });
	            }
	        }
	
	        function mousedownHandler() {
	            isMousedown = true;
	        }
	
	        function clickHandler(event) {
	            isMousedown = false;
	
	            var activeElement = event.target;
	            var isSelectElement = contains(element[0], activeElement);
	
	            if (isBlur && !isSelectElement) {
	                blurHandler();
	            }
	
	            if (isSelectElement && activeElement.nodeName !== 'INPUT') {
	                $timeout(function () {
	                    inputElement[0].focus();
	                });
	            }
	
	            if (!isSelectElement && isFocused) {
	                isFocused = false;
	            }
	        }
	
	        return function () {
	            $document[0].removeEventListener('click', clickHandler, true);
	            element[0].removeEventListener('mousedown', mousedownHandler, true);
	            element[0].removeEventListener('blur', blurHandler, true);
	            inputElement.off('focus', focusHandler);
	        }
	    }
	
	    /**
	     * Sets the selected item in the dropdown menu
	     * of available options.
	     *
	     * @param {object} list
	     * @param {object} item
	     */
	    function scrollActiveOption(list, item) {
	        var y, height_menu, height_item, scroll, scroll_top, scroll_bottom;
	
	        if (item) {
	            height_menu = list.offsetHeight;
	            height_item = getWidthOrHeight(item, 'height', 'margin'); //outerHeight(true);
	            scroll = list.scrollTop || 0;
	            y = getOffset(item).top - getOffset(list).top + scroll;
	            scroll_top = y;
	            scroll_bottom = y - height_menu + height_item;
	
	            //TODO Make animation
	            if (y + height_item > height_menu + scroll) {
	                list.scrollTop = scroll_bottom;
	            } else if (y < scroll) {
	                list.scrollTop = scroll_top;
	            }
	        }
	    }
	
	    // Used for matching numbers
	    var core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	    var rnumnonpx = new RegExp("^(" + core_pnum + ")(?!px)[a-z%]+$", "i");
	
	    function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
	        var i = extra === (isBorderBox ? 'border' : 'content') ?
	                // If we already have the right measurement, avoid augmentation
	                4 :
	                // Otherwise initialize for horizontal or vertical properties
	                name === 'width' ? 1 : 0,
	
	            val = 0,
	            cssExpand = ['Top', 'Right', 'Bottom', 'Left'];
	
	        //TODO Use angular.element.css instead of getStyleValue after https://github.com/caitp/angular.js/commit/92bbb5e225253ebddd38ef5735d66ffef76b6a14 will be applied
	        function getStyleValue(name) {
	            return parseFloat(styles[name]);
	        }
	
	        for (; i < 4; i += 2) {
	            // both box models exclude margin, so add it if we want it
	            if (extra === 'margin') {
	                val += getStyleValue(extra + cssExpand[i]);
	            }
	
	            if (isBorderBox) {
	                // border-box includes padding, so remove it if we want content
	                if (extra === 'content') {
	                    val -= getStyleValue('padding' + cssExpand[i]);
	                }
	
	                // at this point, extra isn't border nor margin, so remove border
	                if (extra !== 'margin') {
	                    val -= getStyleValue('border' + cssExpand[i] + 'Width');
	                }
	            } else {
	                val += getStyleValue('padding' + cssExpand[i]);
	
	                // at this point, extra isn't content nor padding, so add border
	                if (extra !== 'padding') {
	                    val += getStyleValue('border' + cssExpand[i] + 'Width');
	                }
	            }
	        }
	
	        return val;
	    }
	
	    function getOffset(elem) {
	        var docElem, win,
	            box = elem.getBoundingClientRect(),
	            doc = elem && elem.ownerDocument;
	
	        if (!doc) {
	            return;
	        }
	
	        docElem = doc.documentElement;
	        win = getWindow(doc);
	
	        return {
	            top: box.top + win.pageYOffset - docElem.clientTop,
	            left: box.left + win.pageXOffset - docElem.clientLeft
	        };
	    }
	
	    function getWindow(elem) {
	        return elem != null && elem === elem.window ? elem : elem.nodeType === 9 && elem.defaultView;
	    }
	
	    function getWidthOrHeight(elem, name, extra) {
	
	        // Start with offset property, which is equivalent to the border-box value
	        var valueIsBorderBox = true,
	            val = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
	            styles = window.getComputedStyle(elem, null),
	
	        //TODO Make isBorderBox after https://github.com/caitp/angular.js/commit/92bbb5e225253ebddd38ef5735d66ffef76b6a14 will be applied
	            isBorderBox = false; //jQuery.support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
	        // some non-html elements return undefined for offsetWidth, so check for null/undefined
	        // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	        // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	        if (val <= 0 || val == null) {
	            // Fall back to computed then uncomputed css if necessary
	            val = styles[name];
	
	            if (val < 0 || val == null) {
	                val = elem.style[name];
	            }
	
	            // Computed unit is not pixels. Stop here and return.
	            if (rnumnonpx.test(val)) {
	                return val;
	            }
	
	            // we need the check for style in case a browser which returns unreliable values
	            // for getComputedStyle silently falls back to the reliable elem.style
	            //valueIsBorderBox = isBorderBox && ( jQuery.support.boxSizingReliable || val === elem.style[ name ] );
	
	            // Normalize "", auto, and prepare for extra
	            val = parseFloat(val) || 0;
	        }
	
	        // use the active box-sizing model to add/subtract irrelevant styles
	        return val + augmentWidthOrHeight(elem, name, extra || ( isBorderBox ? "border" : "content" ), valueIsBorderBox, styles);
	    }
	
	    function groupsIsEmpty(groups) {
	        for (var k in groups) {
	            if (groups.hasOwnProperty(k) && groups[k].length) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    //lodash _.intersection + filter + invert
	    function intersection(xArr, yArr, xFilter, yFilter, invert) {
	        var i, j, n, filteredX, filteredY, out = invert ? [].concat(xArr) : [];
	
	        for (i = 0, n = xArr.length; i < xArr.length; i++) {
	            filteredX = xFilter ? xFilter(xArr[i]) : xArr[i];
	
	            for (j = 0; j < yArr.length; j++) {
	                filteredY = yFilter ? yFilter(yArr[j]) : yArr[j];
	
	                if (angular.equals(filteredX, filteredY, xArr, yArr, i, j)) {
	                    invert ? out.splice(i + out.length - n, 1) : out.push(yArr[j]);
	                    break;
	                }
	            }
	        }
	        return out;
	    }
	
	    function getValue(valueName, item, scope, getter) {
	        var locals = {};
	
	        //'name.subname' -> {name: {subname: item}} -> locals'
	        valueName.split('.').reduce(function (previousValue, currentItem, index, arr) {
	            return previousValue[currentItem] = index < arr.length - 1 ? {} : item;
	        }, locals);
	
	        return getter(scope, locals);
	    }
	
	    return {
	        contains: contains,
	        bindFocusBlur: bindFocusBlur,
	        scrollActiveOption: scrollActiveOption,
	        groupsIsEmpty: groupsIsEmpty,
	        getValue: getValue,
	        intersection: intersection
	    }
	}]);
	
	angular.module('oi.select')
	
	.directive('oiSelect', ['$document', '$q', '$timeout', '$parse', '$interpolate', '$injector', '$filter', '$animate', 'oiUtils', 'oiSelect', function($document, $q, $timeout, $parse, $interpolate, $injector, $filter, $animate, oiUtils, oiSelect) {
	    var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	    var VALUES_REGEXP     = /([^\(\)\s\|\s]*)\s*(\(.*\))?\s*(\|?\s*.+)?/;
	
	    return {
	        restrict: 'AE',
	        templateUrl: 'src/template.html',
	        require: 'ngModel',
	        scope: {},
	        compile: function (element, attrs) {
	            var optionsExp = attrs.oiOptions,
	                match = optionsExp ? optionsExp.match(NG_OPTIONS_REGEXP) : ['', 'i', '', '', '', 'i', '', '', ''];
	
	            if (!match) {
	                throw new Error("Expected expression in form of '_select_ (as _label_)? for (_key_,)?_value_ in _collection_'");
	            }
	
	            var selectAsName          = / as /.test(match[0]) && match[1],    //item.modelValue
	                displayName           = match[2] || match[1],                 //item.label
	                valueName             = match[5] || match[7],                 //item (value)
	                keyName               = match[6],                             //(key)
	                groupByName           = match[3] || '',                       //item.groupName
	                disableWhenName       = match[4] || '',                       //item.disableWhenName
	                trackByName           = match[9] || displayName,              //item.id
	                valueMatches          = match[8].match(VALUES_REGEXP),        //collection
	                valueTitle            = valueName,
	                keyTitle              = keyName;
	
	            if (keyName) { //convert object data sources format to array data sources format
	                valueName             = 'i';
	                selectAsName          = valueName + '.' + (selectAsName || valueTitle);
	                trackByName           = valueName + '.' + keyName;
	                displayName           = valueName + '.' + displayName;
	                keyName               = valueName + '.' + keyName;
	                groupByName           = groupByName     ? valueName + '.' + groupByName: undefined;
	                disableWhenName       = disableWhenName ? valueName + '.' + disableWhenName: undefined;
	            }
	
	            var valuesName            = valueMatches[1],                      //collection
	                filteredValuesName    = valuesName + (valueMatches[3] || ''), //collection | filter
	                valuesFnName          = valuesName + (valueMatches[2] || ''); //collection()
	
	            var selectAsFn            = selectAsName && $parse(selectAsName),
	                displayFn             = $parse(displayName),
	                groupByFn             = $parse(groupByName),
	                disableWhenFn         = $parse(disableWhenName),
	                filteredValuesFn      = $parse(filteredValuesName),
	                valuesFn              = $parse(valuesFnName),
	                trackByFn             = $parse(trackByName);
	
	            var multiplePlaceholderFn = $interpolate(attrs.multiplePlaceholder || ''),
	                listPlaceholderFn     = $interpolate(attrs.listPlaceholder || ''),
	                placeholderFn         = $interpolate(attrs.placeholder || ''),
	                optionsFn             = $parse(attrs.oiSelectOptions),
	                isOldAngular          = angular.version.major <= 1 && angular.version.minor <= 3;
	
	            var keyUpDownWerePressed,
	                matchesWereReset,
	                timeoutPromise,
	                lastQuery,
	                removedItem,
	                multiple,
	                multipleLimit,
	                newItemFn;
	
	            return function(scope, element, attrs, ctrl) {
	                // Override the standard $isEmpty because an empty array means the input is empty.
	                ctrl.$isEmpty = function(value) { return !exists(value) };
	
	                var inputElement        = element.find('input'),
	                    listElement         = angular.element(element[0].querySelector('.select-dropdown')),
	                    placeholder         = placeholderFn(scope),
	                    multiplePlaceholder = multiplePlaceholderFn(scope),
	                    listPlaceholder     = listPlaceholderFn(scope),
	                    elementOptions      = optionsFn(scope.$parent) || {},
	                    options             = angular.extend({cleanModel: elementOptions.newItem === 'prompt'}, oiSelect.options, elementOptions),
	                    editItem            = options.editItem,
	                    editItemIsCorrected = editItem === 'correct',
	                    waitTime            = 0;
	
	                if (editItem === true || editItem === 'correct') {
	                    editItem = 'oiSelectEditItem';
	                }
	                var editItemFn   = editItem ? $injector.get(editItem) : angular.noop,
	                    removeItemFn = $parse(options.removeItemFn);
	
	                match = options.searchFilter.split(':');
	                var searchFilter = $filter(match[0]),
	                    searchFilterOptionsFn = $parse(match[1]);
	
	                match = options.dropdownFilter.split(':');
	                var dropdownFilter = $filter(match[0]),
	                    dropdownFilterOptionsFn = $parse(match[1]);
	
	                match = options.listFilter.split(':');
	                var listFilter = $filter(match[0]),
	                    listFilterOptionsFn = $parse(match[1]);
	
	                match = options.groupFilter.split(':');
	                var groupFilter = $filter(match[0]),
	                    groupFilterOptionsFn = $parse(match[1]);
	
	                if (options.newItemFn) {
	                    newItemFn = $parse(options.newItemFn);
	
	                } else {
	                    newItemFn = function(scope, locals) {
	                        return (optionsFn(locals) || {}).newItemModel || locals.$query;
	                    };
	                }
	
	                if (options.cleanModel && (!editItem || editItemIsCorrected)) {
	                    element.addClass('cleanMode');
	                }
	
	                var unbindFocusBlur = oiUtils.bindFocusBlur(element, inputElement);
	
	                if (angular.isDefined(attrs.autofocus)) {
	                    $timeout(function() {
	                        inputElement[0].focus();
	                    });
	                }
	
	                if (angular.isDefined(attrs.readonly)) {
	                    inputElement.attr('readonly', true)
	                }
	
	                if (angular.isDefined(attrs.tabindex)) {
	                    inputElement.attr('tabindex', attrs.tabindex);
	                    element[0].removeAttribute('tabindex');
	                }
	
	                if (options.maxlength) {
	                    inputElement.attr('maxlength', options.maxlength);
	                }
	
	                attrs.$observe('disabled', function(value) {
	                    inputElement.prop('disabled', value);
	
	                    //hide empty string with input
	                    if (multiple && ctrl.$modelValue && ctrl.$modelValue.length) {
	                        scope.inputHide = value;
	                    }
	                });
	
	                scope.$on('$destroy', unbindFocusBlur);
	
	                scope.$parent.$watch(attrs.multipleLimit, function(value) {
	                     multipleLimit = Number(value) || Infinity;
	                });
	
	                scope.$parent.$watch(attrs.multiple, function(multipleValue) {
	                    multiple = multipleValue === undefined ? angular.isDefined(attrs.multiple) : multipleValue;
	
	                    element[multiple ? 'addClass' : 'removeClass']('multiple');
	                });
	
	                function valueChangedManually() { //case: clean model; prompt + editItem: 'correct'; initial value = defined/undefined
	                    if (editItemIsCorrected) {
	                        element.removeClass('cleanMode');
	                    }
	                    editItemIsCorrected = false;
	                }
	
	                scope.$parent.$watch(attrs.ngModel, function(value, oldValue) {
	                    var output = compact(value),
	                        promise = $q.when(output);
	
	                    modifyPlaceholder();
	
	                    if (exists(oldValue) && value !== oldValue) {
	                        valueChangedManually();
	                    }
	
	                    if (!multiple) {
	                        restoreInput();
	                    }
	
	                    if (selectAsFn && exists(value)) {
	                        promise = getMatches(null, value)
	                            .then(function(collection) {
	                                return oiUtils.intersection(output, collection, null, selectAs);
	                            });
	                        timeoutPromise = null; //`resetMatches` should not cancel the `promise`
	                    }
	
	                    if (multiple && attrs.disabled && !exists(value)) { //case: multiple, disabled=true + remove all items
	                        scope.inputHide = false;
	                    }
	
	                    promise.then(function(collection) {
	                        scope.output = collection;
	
	                        if (collection.length !== output.length) {
	                            scope.removeItem(collection.length); //if newItem was not created
	                        }
	                    });
	                });
	
	                scope.$watch('query', function(inputValue, oldValue) {
	                    //terminated symbol
	                    if (saveOn(inputValue.slice(0, -1), inputValue.slice(-1))) return;
	
	                    //length less then minlength
	                    if (String(inputValue).length < options.minlength) return;
	                    
	                    //We don't get matches if nothing added into matches list
	                    if (inputValue !== oldValue && (!scope.oldQuery || inputValue) && !matchesWereReset) {
	                        listElement[0].scrollTop = 0;
	
	                        if (inputValue) {
	                            getMatches(inputValue);
	                            scope.oldQuery = null;
	                        } else if (multiple) {
	                            resetMatches();
	                            matchesWereReset = true;
	                        }
	                    }
	                    matchesWereReset = false;
	                });
	
	                scope.$watch('groups', function(groups) {
	                    if (oiUtils.groupsIsEmpty(groups)) {
	                        scope.isOpen = false;
	
	                    } else if (!scope.isOpen && !attrs.disabled) {
	                        scope.isOpen = true;
	                        scope.isFocused = true;
	                    }
	                });
	
	                scope.$watch('isFocused', function(isFocused) {
	                    $animate[isFocused ? 'addClass' : 'removeClass'](element, 'focused', !isOldAngular && {
	                        tempClasses: 'focused-animate'
	                    });
	                });
	
	                scope.$watch('isOpen', function(isOpen) {
	                    $animate[isOpen ? 'addClass' : 'removeClass'](element, 'open', !isOldAngular && {
	                        tempClasses: 'open-animate'
	                    });
	                });
	
	                scope.$watch('isEmptyList', function(isEmptyList) {
	                    $animate[isEmptyList ? 'addClass' : 'removeClass'](element, 'emptyList', !isOldAngular && {
	                        tempClasses: 'emptyList-animate'
	                    });
	                });
	
	                scope.$watch('showLoader', function(isLoading) {
	                    $animate[isLoading ? 'addClass' : 'removeClass'](element, 'loading', !isOldAngular && {
	                        tempClasses: 'loading-animate'
	                    });
	                });
	
	                scope.addItem = function addItem(option) {
	                    lastQuery = scope.query;
	
	                    //duplicate
	                    if (multiple && oiUtils.intersection(scope.output, [option], trackBy, trackBy).length) return;
	
	                    //limit is reached
	                    if (scope.output.length >= multipleLimit) {
	                        blinkClass('limited');
	
	                        return;
	                    }
	
	                    var optionGroup = scope.groups[getGroupName(option)] = scope.groups[getGroupName(option)] || [];
	                    var modelOption = selectAsFn ? selectAs(option) : option;
	
	                    optionGroup.splice(optionGroup.indexOf(option), 1);
	
	                    if (multiple) {
	                        ctrl.$setViewValue(angular.isArray(ctrl.$modelValue) ? ctrl.$modelValue.concat(modelOption) : [modelOption]);
	
	                    } else {
	                        ctrl.$setViewValue(modelOption);
	                        restoreInput();
	                    }
	
	                    if (oiUtils.groupsIsEmpty(scope.groups)) {
	                        scope.groups = {}; //it is necessary for groups watcher
	                    }
	
	                    if (!multiple && !options.closeList) {
	                        resetMatches({query: true});
	                    }
	
	                    valueChangedManually();
	
	                    scope.oldQuery = scope.oldQuery || scope.query;
	                    scope.query = '';
	                    scope.backspaceFocus = false;
	                };
	
	                scope.removeItem = function removeItem(position) {
	                    if (attrs.disabled || multiple && position < 0) return;
	
	                    removedItem = multiple ? ctrl.$modelValue[position] : ctrl.$modelValue;
	
	                    $q.when(removeItemFn(scope.$parent, {$item: removedItem}))
	                        .then(function() {
	                            if (!multiple && !scope.inputHide) return;
	
	                            if (multiple) {
	                                ctrl.$modelValue.splice(position, 1);
	                                ctrl.$setViewValue([].concat(ctrl.$modelValue));
	
	                            } else  {
	                                cleanInput();
	
	                                if (options.cleanModel) {
	                                    ctrl.$setViewValue(undefined);
	                                }
	                            }
	
	                            if (multiple || !scope.backspaceFocus) {
	                                scope.query = editItemFn(removedItem, lastQuery, getLabel, editItemIsCorrected, element) || '';
	                            }
	
	                            if (multiple && options.closeList) {
	                                resetMatches({query: true});
	                            }
	                        })
	                };
	
	                scope.setSelection = function(index) {
	                    if (!keyUpDownWerePressed && scope.selectorPosition !== index) {
	                        setOption(listElement, index);
	                    } else {
	                        keyUpDownWerePressed = false;
	                    }
	                };
	
	                scope.keyUp = function keyUp(event) { //scope.query is actual
	                    switch (event.keyCode) {
	                        case 8: /* backspace */
	                            if (!scope.query.length && (!multiple || !scope.output.length)) {
	                                resetMatches();
	                            }
	                    }
	                };
	
	                scope.keyDown = function keyDown(event) {
	                    var top    = 0,
	                        bottom = scope.order.length - 1;
	
	                    switch (event.keyCode) {
	                        case 38: /* up */
	                            scope.selectorPosition = angular.isNumber(scope.selectorPosition) ? scope.selectorPosition : top;
	                            setOption(listElement, scope.selectorPosition === top ? bottom : scope.selectorPosition - 1);
	                            keyUpDownWerePressed = true;
	                            break;
	
	                        case 40: /* down */
	                            scope.selectorPosition = angular.isNumber(scope.selectorPosition) ? scope.selectorPosition : top - 1;
	                            setOption(listElement, scope.selectorPosition === bottom ? top : scope.selectorPosition + 1);
	                            keyUpDownWerePressed = true;
	                            if (!scope.query.length && !scope.isOpen) {
	                                getMatches();
	                            }
	                            if (scope.inputHide) {
	                                cleanInput();
	                            }
	
	                            break;
	
	                        case 37: /* left */
	                        case 39: /* right */
	                            break;
	
	                        case 9: /* tab */
	                            saveOn('tab');
	                            break;
	
	                        case 13: /* enter */
	                            saveOn('enter');
	                            event.preventDefault(); // Prevent the event from bubbling up as it might otherwise cause a form submission
	                            break;
	
	                        case 32: /* space */
	                            saveOn('space');
	                            break;
	
	                        case 27: /* esc */
	                            if (!multiple) {
	                                restoreInput();
	
	                                if (options.cleanModel) {
	                                    ctrl.$setViewValue(removedItem);
	                                }
	                            }
	                            resetMatches();
	                            break;
	
	                        case 8: /* backspace */
	                            if (!scope.query.length) {
	                                if (!multiple || editItem) {
	                                    scope.backspaceFocus = true;
	                                }
	                                if (scope.backspaceFocus && scope.output && (!multiple || scope.output.length)) { //prevent restoring last deleted option
	                                    scope.removeItem(scope.output.length - 1);
	
	                                    if (editItem) {
	                                        event.preventDefault();
	                                    }
	                                    break;
	                                }
	                                scope.backspaceFocus = !scope.backspaceFocus;
	                                break;
	                            }
	                        default: /* any key */
	                            if (scope.inputHide) {
	                                cleanInput();
	                            }
	                            scope.backspaceFocus = false;
	                            return false; //preventDefaults
	                    }
	                };
	
	                scope.getSearchLabel = function(item) {
	                    var label = getLabel(item);
	
	                    return searchFilter(label, scope.oldQuery || scope.query, item, searchFilterOptionsFn(scope.$parent), element);
	                };
	
	                scope.getDropdownLabel = function(item) {
	                    var label = getLabel(item);
	
	                    return dropdownFilter(label, scope.oldQuery || scope.query, item, dropdownFilterOptionsFn(scope.$parent), element);
	                };
	
	                scope.getGroupLabel = function(group, items) {
	                    return groupFilter(group, scope.oldQuery || scope.query, items, groupFilterOptionsFn(scope.$parent), element);
	                };
	
	                scope.getDisableWhen = getDisableWhen;
	
	
	                resetMatches();
	
	                element[0].addEventListener('click', click, true); //triggered before add or delete item event
	                scope.$on('$destroy', function() {
	                  element[0].removeEventListener('click', click, true);
	                });
	                element.on('focus', focus);
	                element.on('blur', blur);
	
	                function blinkClass(name, delay) {
	                    delay = delay || 150;
	
	                    element.addClass(name);
	
	                    $timeout(function() {
	                        element.removeClass(name);
	                    }, delay);
	                }
	
	                function cleanInput() {
	                    scope.listItemHide = true;
	                    scope.inputHide = false;
	                }
	
	                function restoreInput() {
	                    var modelExists = exists(ctrl.$modelValue);
	                    scope.listItemHide = !modelExists;
	                    scope.inputHide = modelExists;
	                }
	
	                function click(event) {
	                    //query length less then minlength
	                    if (scope.query.length < options.minlength) return;
	                    
	                    //option is disabled
	                    if (oiUtils.contains(element[0], event.target, 'disabled')) return;
	
	                    //limit is reached
	                    if (scope.output.length >= multipleLimit && oiUtils.contains(element[0], event.target, 'select-dropdown')) return;
	
	                    if (scope.inputHide) {
	                        scope.removeItem(0); //because click on border (not on chosen item) doesn't remove chosen element
	                    }
	
	                    if (scope.isOpen && options.closeList && (event.target.nodeName !== 'INPUT' || !scope.query.length)) { //do not reset if you are editing the query
	                        resetMatches({query: options.editItem && !editItemIsCorrected});
	                        scope.$evalAsync();
	                    } else {
	                        getMatches(scope.query);
	                    }
	                }
	
	                function focus(event) {
	                    if (scope.isFocused) return;
	
	                    scope.isFocused = true;
	
	                    if (attrs.disabled) return;
	
	                    scope.backspaceFocus = false;
	                }
	
	
	                function blur(event) {
	                    scope.isFocused = false;
	
	                    if (!multiple) {
	                        restoreInput();
	                    }
	
	                    if (!saveOn('blur')) {
	                        resetMatches();
	                    }
	                    scope.$evalAsync();
	                }
	
	                function saveOn(query, triggerName) {
	                    if (!triggerName) {
	                        triggerName = query;
	                        query = scope.query;
	                    }
	
	                    var isTriggered    = options.saveTrigger.split(' ').indexOf(triggerName) + 1,
	                        isNewItem      = options.newItem && query,
	                        selectedOrder  = triggerName !== 'blur' ? scope.order[scope.selectorPosition] : null, //do not save selected element in dropdown list on blur
	                        itemPromise;
	
	                    if (isTriggered && (isNewItem || selectedOrder && !getDisableWhen(selectedOrder))) {
	                        scope.showLoader = true;
	                        itemPromise = $q.when(!scope.isEmptyList && selectedOrder || newItemFn(scope.$parent, {$query: query}));
	
	                        itemPromise
	                            .then(function(data) {
	                                if (data === undefined) {
	                                   return $q.reject();
	                                }
	
	                                scope.addItem(data);
	
	                                var bottom = scope.order.length - 1;
	
	                                if (scope.selectorPosition === bottom) {
	                                    setOption(listElement, 0); //TODO optimise when list will be closed
	                                }
	                                options.newItemFn && !selectedOrder || $timeout(angular.noop); //TODO $applyAsync work since Angular 1.3
	                                resetMatches();
	                            })
	                            .catch(function() {
	                                blinkClass('invalid-item');
	                                scope.showLoader = false;
	                            });
	
	                        return true;
	                    }
	                }
	
	                function modifyPlaceholder() {
	                    var currentPlaceholder = multiple && exists(ctrl.$modelValue) ? multiplePlaceholder : placeholder;
	                    inputElement.attr('placeholder', currentPlaceholder);
	                }
	
	                function trackBy(item) {
	                    return oiUtils.getValue(valueName, item, scope.$parent, trackByFn);
	                }
	
	                function selectAs(item) {
	                    return oiUtils.getValue(valueName, item, scope.$parent, selectAsFn);
	                }
	
	                function getLabel(item) {
	                    return oiUtils.getValue(valueName, item, scope.$parent, displayFn);
	                }
	
	                function getDisableWhen(item) {
	                    return scope.isEmptyList || oiUtils.getValue(valueName, item, scope.$parent, disableWhenFn);
	                }
	
	                function getGroupName(option) {
	                    return oiUtils.getValue(valueName, option, scope.$parent, groupByFn) || '';
	                }
	
	                function filter(list) {
	                    return oiUtils.getValue(valuesName, list, scope.$parent, filteredValuesFn);
	                }
	
	                function compact(value) {
	                    value = value instanceof Array ? value : value ? [value]: [];
	
	                    return value.filter(function(item) {
	                        return item !== undefined && (item instanceof Array && item.length || selectAsFn || getLabel(item));
	                    });
	                }
	
	                function exists(value) {
	                    return !!compact(value).length;
	                }
	
	                function getMatches(query, selectedAs) {
	                    scope.isEmptyList = false;
	
	                    if (timeoutPromise && waitTime) {
	                        $timeout.cancel(timeoutPromise); //cancel previous timeout
	                    }
	
	                    timeoutPromise = $timeout(function() {
	                        var values = valuesFn(scope.$parent, {$query: query, $selectedAs: selectedAs}) || '';
	
	                        scope.selectorPosition = options.newItem === 'prompt' ? false : 0;
	
	                        if (!query && !selectedAs) {
	                            scope.oldQuery = null;
	                        }
	
	                        if (values.$promise && !values.$resolved || angular.isFunction(values.then)) {
	                            waitTime = options.debounce;
	                        }
	
	                        scope.showLoader = true;
	
	                        return $q.when(values.$promise || values)
	                            .then(function(values) {
	
	                                scope.groups = {};
	
	                                if (values && keyName) {
	                                    //convert object data sources format to array data sources format
	                                    var arr = [];
	
	                                    angular.forEach(values, function (value, key) {
	                                        if (key.toString().charAt(0) !== '$') {
	                                            var item = {};
	
	                                            item[keyTitle] = key;
	                                            item[valueTitle] = value;
	                                            arr.push(item);
	                                        }
	                                    });
	
	                                    values = arr;
	                                }
	
	                                if (values && !selectedAs) {
	                                    var outputValues = multiple ? scope.output : [];
	                                    var filteredList = listFilter(values, query, getLabel, listFilterOptionsFn(scope.$parent), element);
	                                    var withoutIntersection = oiUtils.intersection(filteredList, outputValues, trackBy, trackBy, true);
	                                    var filteredOutput = filter(withoutIntersection);
	
	                                    //add element with placeholder to empty list
	                                    if (!filteredOutput.length) {
	                                        scope.isEmptyList = true;
	
	                                        if (listPlaceholder) {
	                                            var context = {};
	
	                                            displayFn.assign(context, listPlaceholder);
	                                            filteredOutput = [context[valueName]]
	                                        }
	                                    }
	
	                                    scope.groups = group(filteredOutput);
	                                }
	                                updateGroupPos();
	
	                                return values;
	                            })
	                            .finally(function(){
	                                scope.showLoader = false;
	
	                                if (options.closeList && !options.cleanModel) { //case: prompt
	                                    $timeout(function() {
	                                        setOption(listElement, 0);
	                                    });
	                                }
	                            });
	                    }, waitTime);
	
	                    return timeoutPromise;
	                }
	
	                function updateGroupPos() {
	                    var i, key, value, collectionKeys = [], groupCount = 0;
	
	                    scope.order = [];
	                    scope.groupPos = {};
	
	                    for (key in scope.groups) {
	                        if (scope.groups.hasOwnProperty(key) && key.charAt(0) != '$') {
	                            collectionKeys.push(key);
	                        }
	                    }
	
	                    if (isOldAngular) {
	                        collectionKeys.sort(); //TODO: Think of a way which does not depend on the order in which Angular displays objects by ngRepeat
	                    }
	
	                    for (i = 0; i < collectionKeys.length; i++) {
	                        key = collectionKeys[i];
	                        value = scope.groups[key];
	
	                        scope.order = scope.order.concat(value);
	                        scope.groupPos[key] = groupCount;
	                        groupCount += value.length
	                    }
	                }
	
	                function resetMatches(options) {
	                    options = options || {};
	
	                    scope.oldQuery = null;
	                    scope.backspaceFocus = false; // clears focus on any chosen item for del
	                    scope.groups = {};
	                    scope.order = [];
	                    scope.showLoader = false;
	                    scope.isOpen = false;
	                    waitTime = 0;
	
	                    if (!options.query)   {
	                        scope.query = '';
	                    }
	
	                    if (timeoutPromise) {
	                        $timeout.cancel(timeoutPromise);//cancel previous timeout
	                    }
	                }
	
	                function setOption(listElement, position) {
	                    scope.selectorPosition = position;
	                    oiUtils.scrollActiveOption(listElement[0], listElement.find('li')[position]);
	                }
	
	                function group(input) {
	                    var optionGroups = {'':[]},
	                        optionGroupName,
	                        optionGroup;
	
	                    for (var i = 0; i < input.length; i++) {
	                        optionGroupName = getGroupName(input[i]);
	
	                        if (!(optionGroup = optionGroups[optionGroupName])) {
	                            optionGroup = optionGroups[optionGroupName] = [];
	                        }
	                        optionGroup.push(input[i]);
	                    }
	
	                    return optionGroups;
	                }
	            }
	        }
	    }
	}]);
	
	angular.module('oi.select')
	
	.filter('oiSelectGroup', ['$sce', function($sce) {
	    return function(label) {
	        return $sce.trustAsHtml(label);
	    };
	}])
	
	.filter('oiSelectCloseIcon', ['$sce', function($sce) {
	    return function(label) {
	        var closeIcon = '<span class="close select-search-list-item_selection-remove">×</span>';
	
	        return $sce.trustAsHtml(label + closeIcon);
	    };
	}])
	
	.filter('oiSelectHighlight', ['$sce', 'oiSelectEscape', function($sce, oiSelectEscape) {
	    return function(label, query) {
	        var html;
	
	        if (query.length > 0 || angular.isNumber(query)) {
	            label = label.toString();
	            query = oiSelectEscape(query);
	
	            html = label.replace(new RegExp(query, 'gi'), '<strong>$&</strong>');
	        } else {
	            html = label;
	        }
	
	        return $sce.trustAsHtml(html);
	    };
	}])
	
	.filter('oiSelectAscSort', ['oiSelectEscape', function(oiSelectEscape) {
	    function ascSort(input, query, getLabel, options) {
	        var i, j, isFound, output, output1 = [], output2 = [], output3 = [], output4 = [];
	
	        if (query) {
	            query = oiSelectEscape(query).toLocaleLowerCase();
	
	            for (i = 0, isFound = false; i < input.length; i++) {
	                isFound = getLabel(input[i]).toLocaleLowerCase().match(new RegExp(query));
	
	                if (!isFound && options && (options.length || options.fields)) {
	                    for (j = 0; j < options.length; j++) {
	                        if (isFound) break;
	
	                        isFound = String(input[i][options[j]]).toLocaleLowerCase().match(new RegExp(query));
	                    }
	                }
	
	                if (isFound) {
	                    output1.push(input[i]);
	                }
	            }
	            for (i = 0; i < output1.length; i++) {
	                if (getLabel(output1[i]).toLocaleLowerCase().match(new RegExp('^' + query))) {
	                    output2.push(output1[i]);
	                } else {
	                    output3.push(output1[i]);
	                }
	            }
	            output = output2.concat(output3);
	
	            if (options && (options === true || options.all)) {
	                inputLabel: for (i = 0; i < input.length; i++) {
	                    for (j = 0; j < output.length; j++) {
	                        if (input[i] === output[j]) {
	                            continue inputLabel;
	                        }
	                    }
	                    output4.push(input[i]);
	                }
	                output = output.concat(output4);
	            }
	        } else {
	            output = [].concat(input);
	        }
	
	        return output;
	    }
	
	    return ascSort;
	}])
	
	.filter('none', function() {
	    return function(input) {
	        return input;
	    };
	});
	angular.module("oi.select").run(["$templateCache", function($templateCache) {$templateCache.put("src/template.html","<div class=select-search><ul class=select-search-list><li class=\"btn btn-default btn-xs select-search-list-item select-search-list-item_selection\" ng-hide=listItemHide ng-repeat=\"item in output track by $index\" ng-class=\"{focused: backspaceFocus && $last}\" ng-click=removeItem($index) ng-bind-html=getSearchLabel(item)></li><li class=\"select-search-list-item select-search-list-item_input\" ng-class=\"{\'select-search-list-item_hide\': inputHide}\"><input autocomplete=off ng-model=query ng-keyup=keyUp($event) ng-keydown=keyDown($event)></li><li class=\"select-search-list-item select-search-list-item_loader\" ng-show=showLoader></li></ul></div><div class=select-dropdown ng-show=isOpen><ul ng-if=isOpen class=select-dropdown-optgroup ng-repeat=\"(group, options) in groups\"><div class=select-dropdown-optgroup-header ng-if=\"group && options.length\" ng-bind-html=\"getGroupLabel(group, options)\"></div><li class=select-dropdown-optgroup-option ng-init=\"isDisabled = getDisableWhen(option)\" ng-repeat=\"option in options\" ng-class=\"{\'active\': selectorPosition === groupPos[group] + $index, \'disabled\': isDisabled, \'ungroup\': !group}\" ng-click=\"isDisabled || addItem(option)\" ng-mouseenter=\"setSelection(groupPos[group] + $index)\" ng-bind-html=getDropdownLabel(option)></li></ul></div>");}]);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(209);
	module.exports = 'oi.select';

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define */
	(function (root, factory) {
	  
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.owaspPasswordStrengthTest = factory();
	  }
	
	  }(this, function () {
	
	    var owasp = {};
	
	    // These are configuration settings that will be used when testing password
	    // strength
	    owasp.configs = {
	      allowPassphrases       : true,
	      maxLength              : 128,
	      minLength              : 10,
	      minPhraseLength        : 20,
	      minOptionalTestsToPass : 4,
	    };
	
	    // This method makes it more convenient to set config parameters
	    owasp.config = function(params) {
	      for (var prop in params) {
	        if (params.hasOwnProperty(prop) && this.configs.hasOwnProperty(prop)) {
	          this.configs[prop] = params[prop];
	        }
	      }
	    };
	
	    // This is an object containing the tests to run against all passwords.
	    owasp.tests = {
	
	      // An array of required tests. A password *must* pass these tests in order
	      // to be considered strong.
	      required: [
	
	        // enforce a minimum length
	        function(password) {
	          if (password.length < owasp.configs.minLength) {
	            return 'The password must be at least ' + owasp.configs.minLength + ' characters long.';
	          }
	        },
	
	        // enforce a maximum length
	        function(password) {
	          if (password.length > owasp.configs.maxLength) {
	            return 'The password must be fewer than ' + owasp.configs.maxLength + ' characters.';
	          }
	        },
	
	        // forbid repeating characters
	        function(password) {
	          if (/(.)\1{2,}/.test(password)) {
	            return 'The password may not contain sequences of three or more repeated characters.';
	          }
	        },
	
	      ],
	
	      // An array of optional tests. These tests are "optional" in two senses:
	      //
	      // 1. Passphrases (passwords whose length exceeds
	      //    this.configs.minPhraseLength) are not obligated to pass these tests
	      //    provided that this.configs.allowPassphrases is set to Boolean true
	      //    (which it is by default).
	      //
	      // 2. A password need only to pass this.configs.minOptionalTestsToPass
	      //    number of these optional tests in order to be considered strong.
	      optional: [
	
	        // require at least one lowercase letter
	        function(password) {
	          if (!/[a-z]/.test(password)) {
	            return 'The password must contain at least one lowercase letter.';
	          }
	        },
	
	        // require at least one uppercase letter
	        function(password) {
	          if (!/[A-Z]/.test(password)) {
	            return 'The password must contain at least one uppercase letter.';
	          }
	        },
	
	        // require at least one number
	        function(password) {
	          if (!/[0-9]/.test(password)) {
	            return 'The password must contain at least one number.';
	          }
	        },
	
	        // require at least one special character
	        function(password) {
	          if (!/[^A-Za-z0-9]/.test(password)) {
	            return 'The password must contain at least one special character.';
	          }
	        },
	
	      ],
	    };
	
	    // This method tests password strength
	    owasp.test = function(password) {
	
	      // create an object to store the test results
	      var result = {
	        errors              : [],
	        failedTests         : [],
	        passedTests         : [],
	        requiredTestErrors  : [],
	        optionalTestErrors  : [],
	        isPassphrase        : false,
	        strong              : true,
	        optionalTestsPassed : 0,
	      };
	
	      // Always submit the password/passphrase to the required tests
	      var i = 0;
	      this.tests.required.forEach(function(test) {
	        var err = test(password);
	        if (typeof err === 'string') {
	          result.strong = false;
	          result.errors.push(err);
	          result.requiredTestErrors.push(err);
	          result.failedTests.push(i);
	        } else {
	          result.passedTests.push(i);
	        }
	        i++;
	      });
	
	      // If configured to allow passphrases, and if the password is of a
	      // sufficient length to consider it a passphrase, exempt it from the
	      // optional tests.
	      if (
	        this.configs.allowPassphrases === true &&
	        password.length >= this.configs.minPhraseLength
	      ) {
	        result.isPassphrase = true;
	      }
	
	      if (!result.isPassphrase) {
	        var j = this.tests.required.length;
	        this.tests.optional.forEach(function(test) {
	          var err = test(password);
	          if (typeof err === 'string') {
	            result.errors.push(err);
	            result.optionalTestErrors.push(err);
	            result.failedTests.push(j);
	          } else {
	            result.optionalTestsPassed++;
	            result.passedTests.push(j);
	          }
	          j++;
	        });
	      }
	
	      // If the password is not a passphrase, assert that it has passed a
	      // sufficient number of the optional tests, per the configuration
	      if (
	        !result.isPassphrase &&
	        result.optionalTestsPassed < this.configs.minOptionalTestsToPass
	      ) {
	        result.strong = false;
	      }
	
	      // return the result
	      return result;
	    };
	
	    return owasp;
	  }
	));


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    var args = Array.prototype.slice.call(arr);
	
	    return new Promise(function (resolve, reject) {
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15).setImmediate))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	var canPromise = __webpack_require__(215)
	
	var QRCode = __webpack_require__(228)
	var CanvasRenderer = __webpack_require__(232)
	var SvgRenderer = __webpack_require__(233)
	
	function renderCanvas (renderFunc, canvas, text, opts, cb) {
	  var args = [].slice.call(arguments, 1)
	  var argsNum = args.length
	  var isLastArgCb = typeof args[argsNum - 1] === 'function'
	
	  if (!isLastArgCb && !canPromise()) {
	    throw new Error('Callback required as last argument')
	  }
	
	  if (isLastArgCb) {
	    if (argsNum < 2) {
	      throw new Error('Too few arguments provided')
	    }
	
	    if (argsNum === 2) {
	      cb = text
	      text = canvas
	      canvas = opts = undefined
	    } else if (argsNum === 3) {
	      if (canvas.getContext && typeof cb === 'undefined') {
	        cb = opts
	        opts = undefined
	      } else {
	        cb = opts
	        opts = text
	        text = canvas
	        canvas = undefined
	      }
	    }
	  } else {
	    if (argsNum < 1) {
	      throw new Error('Too few arguments provided')
	    }
	
	    if (argsNum === 1) {
	      text = canvas
	      canvas = opts = undefined
	    } else if (argsNum === 2 && !canvas.getContext) {
	      opts = text
	      text = canvas
	      canvas = undefined
	    }
	
	    return new Promise(function (resolve, reject) {
	      try {
	        var data = QRCode.create(text, opts)
	        resolve(renderFunc(data, canvas, opts))
	      } catch (e) {
	        reject(e)
	      }
	    })
	  }
	
	  try {
	    var data = QRCode.create(text, opts)
	    cb(null, renderFunc(data, canvas, opts))
	  } catch (e) {
	    cb(e)
	  }
	}
	
	exports.create = QRCode.create
	exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
	exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)
	
	// only svg for now.
	exports.toString = renderCanvas.bind(null, function (data, _, opts) {
	  return SvgRenderer.render(data, opts)
	})


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	// can-promise has a crash in some versions of react native that dont have
	// standard global objects
	// https://github.com/soldair/node-qrcode/issues/157
	
	module.exports = function () {
	  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
	}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Alignment pattern are fixed reference pattern in defined positions
	 * in a matrix symbology, which enables the decode software to re-synchronise
	 * the coordinate mapping of the image modules in the event of moderate amounts
	 * of distortion of the image.
	 *
	 * Alignment patterns are present only in QR Code symbols of version 2 or larger
	 * and their number depends on the symbol version.
	 */
	
	var getSymbolSize = __webpack_require__(5).getSymbolSize
	
	/**
	 * Calculate the row/column coordinates of the center module of each alignment pattern
	 * for the specified QR Code version.
	 *
	 * The alignment patterns are positioned symmetrically on either side of the diagonal
	 * running from the top left corner of the symbol to the bottom right corner.
	 *
	 * Since positions are simmetrical only half of the coordinates are returned.
	 * Each item of the array will represent in turn the x and y coordinate.
	 * @see {@link getPositions}
	 *
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of coordinate
	 */
	exports.getRowColCoords = function getRowColCoords (version) {
	  if (version === 1) return []
	
	  var posCount = Math.floor(version / 7) + 2
	  var size = getSymbolSize(version)
	  var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
	  var positions = [size - 7] // Last coord is always (size - 7)
	
	  for (var i = 1; i < posCount - 1; i++) {
	    positions[i] = positions[i - 1] - intervals
	  }
	
	  positions.push(6) // First coord is always 6
	
	  return positions.reverse()
	}
	
	/**
	 * Returns an array containing the positions of each alignment pattern.
	 * Each array's element represent the center point of the pattern as (x, y) coordinates
	 *
	 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
	 * and filtering out the items that overlaps with finder pattern
	 *
	 * @example
	 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
	 * The alignment patterns, therefore, are to be centered on (row, column)
	 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
	 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
	 * and are not therefore used for alignment patterns.
	 *
	 * var pos = getPositions(7)
	 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
	 *
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of coordinates
	 */
	exports.getPositions = function getPositions (version) {
	  var coords = []
	  var pos = exports.getRowColCoords(version)
	  var posLength = pos.length
	
	  for (var i = 0; i < posLength; i++) {
	    for (var j = 0; j < posLength; j++) {
	      // Skip if position is occupied by finder patterns
	      if ((i === 0 && j === 0) ||             // top-left
	          (i === 0 && j === posLength - 1) || // bottom-left
	          (i === posLength - 1 && j === 0)) { // top-right
	        continue
	      }
	
	      coords.push([pos[i], pos[j]])
	    }
	  }
	
	  return coords
	}


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(4)
	
	/**
	 * Array of characters available in alphanumeric mode
	 *
	 * As per QR Code specification, to each character
	 * is assigned a value from 0 to 44 which in this case coincides
	 * with the array index
	 *
	 * @type {Array}
	 */
	var ALPHA_NUM_CHARS = [
	  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
	  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
	  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
	]
	
	function AlphanumericData (data) {
	  this.mode = Mode.ALPHANUMERIC
	  this.data = data
	}
	
	AlphanumericData.getBitsLength = function getBitsLength (length) {
	  return 11 * Math.floor(length / 2) + 6 * (length % 2)
	}
	
	AlphanumericData.prototype.getLength = function getLength () {
	  return this.data.length
	}
	
	AlphanumericData.prototype.getBitsLength = function getBitsLength () {
	  return AlphanumericData.getBitsLength(this.data.length)
	}
	
	AlphanumericData.prototype.write = function write (bitBuffer) {
	  var i
	
	  // Input data characters are divided into groups of two characters
	  // and encoded as 11-bit binary codes.
	  for (i = 0; i + 2 <= this.data.length; i += 2) {
	    // The character value of the first character is multiplied by 45
	    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45
	
	    // The character value of the second digit is added to the product
	    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])
	
	    // The sum is then stored as 11-bit binary number
	    bitBuffer.put(value, 11)
	  }
	
	  // If the number of input data characters is not a multiple of two,
	  // the character value of the final character is encoded as a 6-bit binary number.
	  if (this.data.length % 2) {
	    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
	  }
	}
	
	module.exports = AlphanumericData


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	function BitBuffer () {
	  this.buffer = []
	  this.length = 0
	}
	
	BitBuffer.prototype = {
	
	  get: function (index) {
	    var bufIndex = Math.floor(index / 8)
	    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
	  },
	
	  put: function (num, length) {
	    for (var i = 0; i < length; i++) {
	      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
	    }
	  },
	
	  getLengthInBits: function () {
	    return this.length
	  },
	
	  putBit: function (bit) {
	    var bufIndex = Math.floor(this.length / 8)
	    if (this.buffer.length <= bufIndex) {
	      this.buffer.push(0)
	    }
	
	    if (bit) {
	      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
	    }
	
	    this.length++
	  }
	}
	
	module.exports = BitBuffer


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	
	/**
	 * Helper class to handle QR Code symbol modules
	 *
	 * @param {Number} size Symbol size
	 */
	function BitMatrix (size) {
	  if (!size || size < 1) {
	    throw new Error('BitMatrix size must be defined and greater than 0')
	  }
	
	  this.size = size
	  this.data = BufferUtil.alloc(size * size)
	  this.reservedBit = BufferUtil.alloc(size * size)
	}
	
	/**
	 * Set bit value at specified location
	 * If reserved flag is set, this bit will be ignored during masking process
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 * @param {Boolean} reserved
	 */
	BitMatrix.prototype.set = function (row, col, value, reserved) {
	  var index = row * this.size + col
	  this.data[index] = value
	  if (reserved) this.reservedBit[index] = true
	}
	
	/**
	 * Returns bit value at specified location
	 *
	 * @param  {Number}  row
	 * @param  {Number}  col
	 * @return {Boolean}
	 */
	BitMatrix.prototype.get = function (row, col) {
	  return this.data[row * this.size + col]
	}
	
	/**
	 * Applies xor operator at specified location
	 * (used during masking process)
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 */
	BitMatrix.prototype.xor = function (row, col, value) {
	  this.data[row * this.size + col] ^= value
	}
	
	/**
	 * Check if bit at specified location is reserved
	 *
	 * @param {Number}   row
	 * @param {Number}   col
	 * @return {Boolean}
	 */
	BitMatrix.prototype.isReserved = function (row, col) {
	  return this.reservedBit[row * this.size + col]
	}
	
	module.exports = BitMatrix


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	var Mode = __webpack_require__(4)
	
	function ByteData (data) {
	  this.mode = Mode.BYTE
	  this.data = BufferUtil.from(data)
	}
	
	ByteData.getBitsLength = function getBitsLength (length) {
	  return length * 8
	}
	
	ByteData.prototype.getLength = function getLength () {
	  return this.data.length
	}
	
	ByteData.prototype.getBitsLength = function getBitsLength () {
	  return ByteData.getBitsLength(this.data.length)
	}
	
	ByteData.prototype.write = function (bitBuffer) {
	  for (var i = 0, l = this.data.length; i < l; i++) {
	    bitBuffer.put(this.data[i], 8)
	  }
	}
	
	module.exports = ByteData


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var getSymbolSize = __webpack_require__(5).getSymbolSize
	var FINDER_PATTERN_SIZE = 7
	
	/**
	 * Returns an array containing the positions of each finder pattern.
	 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
	 *
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of coordinates
	 */
	exports.getPositions = function getPositions (version) {
	  var size = getSymbolSize(version)
	
	  return [
	    // top-left
	    [0, 0],
	    // top-right
	    [size - FINDER_PATTERN_SIZE, 0],
	    // bottom-left
	    [0, size - FINDER_PATTERN_SIZE]
	  ]
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(5)
	
	var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
	var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
	var G15_BCH = Utils.getBCHDigit(G15)
	
	/**
	 * Returns format information with relative error correction bits
	 *
	 * The format information is a 15-bit sequence containing 5 data bits,
	 * with 10 error correction bits calculated using the (15, 5) BCH code.
	 *
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @param  {Number} mask                 Mask pattern
	 * @return {Number}                      Encoded format information bits
	 */
	exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
	  var data = ((errorCorrectionLevel.bit << 3) | mask)
	  var d = data << 10
	
	  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
	    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
	  }
	
	  // xor final data with mask pattern in order to ensure that
	  // no combination of Error Correction Level and data mask pattern
	  // will result in an all-zero data string
	  return ((data << 10) | d) ^ G15_MASK
	}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	
	var EXP_TABLE = BufferUtil.alloc(512)
	var LOG_TABLE = BufferUtil.alloc(256)
	/**
	 * Precompute the log and anti-log tables for faster computation later
	 *
	 * For each possible value in the galois field 2^8, we will pre-compute
	 * the logarithm and anti-logarithm (exponential) of this value
	 *
	 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
	 */
	;(function initTables () {
	  var x = 1
	  for (var i = 0; i < 255; i++) {
	    EXP_TABLE[i] = x
	    LOG_TABLE[x] = i
	
	    x <<= 1 // multiply by 2
	
	    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
	    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
	    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
	      x ^= 0x11D
	    }
	  }
	
	  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
	  // stay inside the bounds (because we will mainly use this table for the multiplication of
	  // two GF numbers, no more).
	  // @see {@link mul}
	  for (i = 255; i < 512; i++) {
	    EXP_TABLE[i] = EXP_TABLE[i - 255]
	  }
	}())
	
	/**
	 * Returns log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	exports.log = function log (n) {
	  if (n < 1) throw new Error('log(' + n + ')')
	  return LOG_TABLE[n]
	}
	
	/**
	 * Returns anti-log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	exports.exp = function exp (n) {
	  return EXP_TABLE[n]
	}
	
	/**
	 * Multiplies two number inside Galois Field
	 *
	 * @param  {Number} x
	 * @param  {Number} y
	 * @return {Number}
	 */
	exports.mul = function mul (x, y) {
	  if (x === 0 || y === 0) return 0
	
	  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
	  // @see {@link initTables}
	  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
	}


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(4)
	var Utils = __webpack_require__(5)
	
	function KanjiData (data) {
	  this.mode = Mode.KANJI
	  this.data = data
	}
	
	KanjiData.getBitsLength = function getBitsLength (length) {
	  return length * 13
	}
	
	KanjiData.prototype.getLength = function getLength () {
	  return this.data.length
	}
	
	KanjiData.prototype.getBitsLength = function getBitsLength () {
	  return KanjiData.getBitsLength(this.data.length)
	}
	
	KanjiData.prototype.write = function (bitBuffer) {
	  var i
	
	  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
	  // These byte values are shifted from the JIS X 0208 values.
	  // JIS X 0208 gives details of the shift coded representation.
	  for (i = 0; i < this.data.length; i++) {
	    var value = Utils.toSJIS(this.data[i])
	
	    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
	    if (value >= 0x8140 && value <= 0x9FFC) {
	      // Subtract 0x8140 from Shift JIS value
	      value -= 0x8140
	
	    // For characters with Shift JIS values from 0xE040 to 0xEBBF
	    } else if (value >= 0xE040 && value <= 0xEBBF) {
	      // Subtract 0xC140 from Shift JIS value
	      value -= 0xC140
	    } else {
	      throw new Error(
	        'Invalid SJIS character: ' + this.data[i] + '\n' +
	        'Make sure your charset is UTF-8')
	    }
	
	    // Multiply most significant byte of result by 0xC0
	    // and add least significant byte to product
	    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)
	
	    // Convert result to a 13-bit binary string
	    bitBuffer.put(value, 13)
	  }
	}
	
	module.exports = KanjiData


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	/**
	 * Data mask pattern reference
	 * @type {Object}
	 */
	exports.Patterns = {
	  PATTERN000: 0,
	  PATTERN001: 1,
	  PATTERN010: 2,
	  PATTERN011: 3,
	  PATTERN100: 4,
	  PATTERN101: 5,
	  PATTERN110: 6,
	  PATTERN111: 7
	}
	
	/**
	 * Weighted penalty scores for the undesirable features
	 * @type {Object}
	 */
	var PenaltyScores = {
	  N1: 3,
	  N2: 3,
	  N3: 40,
	  N4: 10
	}
	
	/**
	 * Check if mask pattern value is valid
	 *
	 * @param  {Number}  mask    Mask pattern
	 * @return {Boolean}         true if valid, false otherwise
	 */
	exports.isValid = function isValid (mask) {
	  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
	}
	
	/**
	 * Returns mask pattern from a value.
	 * If value is not valid, returns undefined
	 *
	 * @param  {Number|String} value        Mask pattern value
	 * @return {Number}                     Valid mask pattern or undefined
	 */
	exports.from = function from (value) {
	  return exports.isValid(value) ? parseInt(value, 10) : undefined
	}
	
	/**
	* Find adjacent modules in row/column with the same color
	* and assign a penalty value.
	*
	* Points: N1 + i
	* i is the amount by which the number of adjacent modules of the same color exceeds 5
	*/
	exports.getPenaltyN1 = function getPenaltyN1 (data) {
	  var size = data.size
	  var points = 0
	  var sameCountCol = 0
	  var sameCountRow = 0
	  var lastCol = null
	  var lastRow = null
	
	  for (var row = 0; row < size; row++) {
	    sameCountCol = sameCountRow = 0
	    lastCol = lastRow = null
	
	    for (var col = 0; col < size; col++) {
	      var module = data.get(row, col)
	      if (module === lastCol) {
	        sameCountCol++
	      } else {
	        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
	        lastCol = module
	        sameCountCol = 1
	      }
	
	      module = data.get(col, row)
	      if (module === lastRow) {
	        sameCountRow++
	      } else {
	        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
	        lastRow = module
	        sameCountRow = 1
	      }
	    }
	
	    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
	    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
	  }
	
	  return points
	}
	
	/**
	 * Find 2x2 blocks with the same color and assign a penalty value
	 *
	 * Points: N2 * (m - 1) * (n - 1)
	 */
	exports.getPenaltyN2 = function getPenaltyN2 (data) {
	  var size = data.size
	  var points = 0
	
	  for (var row = 0; row < size - 1; row++) {
	    for (var col = 0; col < size - 1; col++) {
	      var last = data.get(row, col) +
	        data.get(row, col + 1) +
	        data.get(row + 1, col) +
	        data.get(row + 1, col + 1)
	
	      if (last === 4 || last === 0) points++
	    }
	  }
	
	  return points * PenaltyScores.N2
	}
	
	/**
	 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
	 * preceded or followed by light area 4 modules wide
	 *
	 * Points: N3 * number of pattern found
	 */
	exports.getPenaltyN3 = function getPenaltyN3 (data) {
	  var size = data.size
	  var points = 0
	  var bitsCol = 0
	  var bitsRow = 0
	
	  for (var row = 0; row < size; row++) {
	    bitsCol = bitsRow = 0
	    for (var col = 0; col < size; col++) {
	      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
	      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++
	
	      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
	      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
	    }
	  }
	
	  return points * PenaltyScores.N3
	}
	
	/**
	 * Calculate proportion of dark modules in entire symbol
	 *
	 * Points: N4 * k
	 *
	 * k is the rating of the deviation of the proportion of dark modules
	 * in the symbol from 50% in steps of 5%
	 */
	exports.getPenaltyN4 = function getPenaltyN4 (data) {
	  var darkCount = 0
	  var modulesCount = data.data.length
	
	  for (var i = 0; i < modulesCount; i++) darkCount += data.data[i]
	
	  var k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)
	
	  return k * PenaltyScores.N4
	}
	
	/**
	 * Return mask value at given position
	 *
	 * @param  {Number} maskPattern Pattern reference value
	 * @param  {Number} i           Row
	 * @param  {Number} j           Column
	 * @return {Boolean}            Mask value
	 */
	function getMaskAt (maskPattern, i, j) {
	  switch (maskPattern) {
	    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
	    case exports.Patterns.PATTERN001: return i % 2 === 0
	    case exports.Patterns.PATTERN010: return j % 3 === 0
	    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
	    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
	    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
	    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
	    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0
	
	    default: throw new Error('bad maskPattern:' + maskPattern)
	  }
	}
	
	/**
	 * Apply a mask pattern to a BitMatrix
	 *
	 * @param  {Number}    pattern Pattern reference number
	 * @param  {BitMatrix} data    BitMatrix data
	 */
	exports.applyMask = function applyMask (pattern, data) {
	  var size = data.size
	
	  for (var col = 0; col < size; col++) {
	    for (var row = 0; row < size; row++) {
	      if (data.isReserved(row, col)) continue
	      data.xor(row, col, getMaskAt(pattern, row, col))
	    }
	  }
	}
	
	/**
	 * Returns the best mask pattern for data
	 *
	 * @param  {BitMatrix} data
	 * @return {Number} Mask pattern reference number
	 */
	exports.getBestMask = function getBestMask (data, setupFormatFunc) {
	  var numPatterns = Object.keys(exports.Patterns).length
	  var bestPattern = 0
	  var lowerPenalty = Infinity
	
	  for (var p = 0; p < numPatterns; p++) {
	    setupFormatFunc(p)
	    exports.applyMask(p, data)
	
	    // Calculate penalty
	    var penalty =
	      exports.getPenaltyN1(data) +
	      exports.getPenaltyN2(data) +
	      exports.getPenaltyN3(data) +
	      exports.getPenaltyN4(data)
	
	    // Undo previously applied mask
	    exports.applyMask(p, data)
	
	    if (penalty < lowerPenalty) {
	      lowerPenalty = penalty
	      bestPattern = p
	    }
	  }
	
	  return bestPattern
	}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(4)
	
	function NumericData (data) {
	  this.mode = Mode.NUMERIC
	  this.data = data.toString()
	}
	
	NumericData.getBitsLength = function getBitsLength (length) {
	  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
	}
	
	NumericData.prototype.getLength = function getLength () {
	  return this.data.length
	}
	
	NumericData.prototype.getBitsLength = function getBitsLength () {
	  return NumericData.getBitsLength(this.data.length)
	}
	
	NumericData.prototype.write = function write (bitBuffer) {
	  var i, group, value
	
	  // The input data string is divided into groups of three digits,
	  // and each group is converted to its 10-bit binary equivalent.
	  for (i = 0; i + 3 <= this.data.length; i += 3) {
	    group = this.data.substr(i, 3)
	    value = parseInt(group, 10)
	
	    bitBuffer.put(value, 10)
	  }
	
	  // If the number of input digits is not an exact multiple of three,
	  // the final one or two digits are converted to 4 or 7 bits respectively.
	  var remainingNum = this.data.length - i
	  if (remainingNum > 0) {
	    group = this.data.substr(i)
	    value = parseInt(group, 10)
	
	    bitBuffer.put(value, remainingNum * 3 + 1)
	  }
	}
	
	module.exports = NumericData


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	var GF = __webpack_require__(223)
	
	/**
	 * Multiplies two polynomials inside Galois Field
	 *
	 * @param  {Buffer} p1 Polynomial
	 * @param  {Buffer} p2 Polynomial
	 * @return {Buffer}    Product of p1 and p2
	 */
	exports.mul = function mul (p1, p2) {
	  var coeff = BufferUtil.alloc(p1.length + p2.length - 1)
	
	  for (var i = 0; i < p1.length; i++) {
	    for (var j = 0; j < p2.length; j++) {
	      coeff[i + j] ^= GF.mul(p1[i], p2[j])
	    }
	  }
	
	  return coeff
	}
	
	/**
	 * Calculate the remainder of polynomials division
	 *
	 * @param  {Buffer} divident Polynomial
	 * @param  {Buffer} divisor  Polynomial
	 * @return {Buffer}          Remainder
	 */
	exports.mod = function mod (divident, divisor) {
	  var result = BufferUtil.from(divident)
	
	  while ((result.length - divisor.length) >= 0) {
	    var coeff = result[0]
	
	    for (var i = 0; i < divisor.length; i++) {
	      result[i] ^= GF.mul(divisor[i], coeff)
	    }
	
	    // remove all zeros from buffer head
	    var offset = 0
	    while (offset < result.length && result[offset] === 0) offset++
	    result = result.slice(offset)
	  }
	
	  return result
	}
	
	/**
	 * Generate an irreducible generator polynomial of specified degree
	 * (used by Reed-Solomon encoder)
	 *
	 * @param  {Number} degree Degree of the generator polynomial
	 * @return {Buffer}        Buffer containing polynomial coefficients
	 */
	exports.generateECPolynomial = function generateECPolynomial (degree) {
	  var poly = BufferUtil.from([1])
	  for (var i = 0; i < degree; i++) {
	    poly = exports.mul(poly, [1, GF.exp(i)])
	  }
	
	  return poly
	}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	var Utils = __webpack_require__(5)
	var ECLevel = __webpack_require__(13)
	var BitBuffer = __webpack_require__(218)
	var BitMatrix = __webpack_require__(219)
	var AlignmentPattern = __webpack_require__(216)
	var FinderPattern = __webpack_require__(221)
	var MaskPattern = __webpack_require__(225)
	var ECCode = __webpack_require__(136)
	var ReedSolomonEncoder = __webpack_require__(229)
	var Version = __webpack_require__(231)
	var FormatInfo = __webpack_require__(222)
	var Mode = __webpack_require__(4)
	var Segments = __webpack_require__(230)
	var isArray = __webpack_require__(14)
	
	/**
	 * QRCode for JavaScript
	 *
	 * modified by Ryan Day for nodejs support
	 * Copyright (c) 2011 Ryan Day
	 *
	 * Licensed under the MIT license:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	*/
	
	/**
	 * Add finder patterns bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupFinderPattern (matrix, version) {
	  var size = matrix.size
	  var pos = FinderPattern.getPositions(version)
	
	  for (var i = 0; i < pos.length; i++) {
	    var row = pos[i][0]
	    var col = pos[i][1]
	
	    for (var r = -1; r <= 7; r++) {
	      if (row + r <= -1 || size <= row + r) continue
	
	      for (var c = -1; c <= 7; c++) {
	        if (col + c <= -1 || size <= col + c) continue
	
	        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
	          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
	          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
	          matrix.set(row + r, col + c, true, true)
	        } else {
	          matrix.set(row + r, col + c, false, true)
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Add timing pattern bits to matrix
	 *
	 * Note: this function must be called before {@link setupAlignmentPattern}
	 *
	 * @param  {BitMatrix} matrix Modules matrix
	 */
	function setupTimingPattern (matrix) {
	  var size = matrix.size
	
	  for (var r = 8; r < size - 8; r++) {
	    var value = r % 2 === 0
	    matrix.set(r, 6, value, true)
	    matrix.set(6, r, value, true)
	  }
	}
	
	/**
	 * Add alignment patterns bits to matrix
	 *
	 * Note: this function must be called after {@link setupTimingPattern}
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupAlignmentPattern (matrix, version) {
	  var pos = AlignmentPattern.getPositions(version)
	
	  for (var i = 0; i < pos.length; i++) {
	    var row = pos[i][0]
	    var col = pos[i][1]
	
	    for (var r = -2; r <= 2; r++) {
	      for (var c = -2; c <= 2; c++) {
	        if (r === -2 || r === 2 || c === -2 || c === 2 ||
	          (r === 0 && c === 0)) {
	          matrix.set(row + r, col + c, true, true)
	        } else {
	          matrix.set(row + r, col + c, false, true)
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Add version info bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupVersionInfo (matrix, version) {
	  var size = matrix.size
	  var bits = Version.getEncodedBits(version)
	  var row, col, mod
	
	  for (var i = 0; i < 18; i++) {
	    row = Math.floor(i / 3)
	    col = i % 3 + size - 8 - 3
	    mod = ((bits >> i) & 1) === 1
	
	    matrix.set(row, col, mod, true)
	    matrix.set(col, row, mod, true)
	  }
	}
	
	/**
	 * Add format info bits to matrix
	 *
	 * @param  {BitMatrix} matrix               Modules matrix
	 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
	 * @param  {Number}    maskPattern          Mask pattern reference value
	 */
	function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
	  var size = matrix.size
	  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
	  var i, mod
	
	  for (i = 0; i < 15; i++) {
	    mod = ((bits >> i) & 1) === 1
	
	    // vertical
	    if (i < 6) {
	      matrix.set(i, 8, mod, true)
	    } else if (i < 8) {
	      matrix.set(i + 1, 8, mod, true)
	    } else {
	      matrix.set(size - 15 + i, 8, mod, true)
	    }
	
	    // horizontal
	    if (i < 8) {
	      matrix.set(8, size - i - 1, mod, true)
	    } else if (i < 9) {
	      matrix.set(8, 15 - i - 1 + 1, mod, true)
	    } else {
	      matrix.set(8, 15 - i - 1, mod, true)
	    }
	  }
	
	  // fixed module
	  matrix.set(size - 8, 8, 1, true)
	}
	
	/**
	 * Add encoded data bits to matrix
	 *
	 * @param  {BitMatrix} matrix Modules matrix
	 * @param  {Buffer}    data   Data codewords
	 */
	function setupData (matrix, data) {
	  var size = matrix.size
	  var inc = -1
	  var row = size - 1
	  var bitIndex = 7
	  var byteIndex = 0
	
	  for (var col = size - 1; col > 0; col -= 2) {
	    if (col === 6) col--
	
	    while (true) {
	      for (var c = 0; c < 2; c++) {
	        if (!matrix.isReserved(row, col - c)) {
	          var dark = false
	
	          if (byteIndex < data.length) {
	            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
	          }
	
	          matrix.set(row, col - c, dark)
	          bitIndex--
	
	          if (bitIndex === -1) {
	            byteIndex++
	            bitIndex = 7
	          }
	        }
	      }
	
	      row += inc
	
	      if (row < 0 || size <= row) {
	        row -= inc
	        inc = -inc
	        break
	      }
	    }
	  }
	}
	
	/**
	 * Create encoded codewords from data input
	 *
	 * @param  {Number}   version              QR Code version
	 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
	 * @param  {ByteData} data                 Data input
	 * @return {Buffer}                        Buffer containing encoded codewords
	 */
	function createData (version, errorCorrectionLevel, segments) {
	  // Prepare data buffer
	  var buffer = new BitBuffer()
	
	  segments.forEach(function (data) {
	    // prefix data with mode indicator (4 bits)
	    buffer.put(data.mode.bit, 4)
	
	    // Prefix data with character count indicator.
	    // The character count indicator is a string of bits that represents the
	    // number of characters that are being encoded.
	    // The character count indicator must be placed after the mode indicator
	    // and must be a certain number of bits long, depending on the QR version
	    // and data mode
	    // @see {@link Mode.getCharCountIndicator}.
	    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))
	
	    // add binary data sequence to buffer
	    data.write(buffer)
	  })
	
	  // Calculate required number of bits
	  var totalCodewords = Utils.getSymbolTotalCodewords(version)
	  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
	  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8
	
	  // Add a terminator.
	  // If the bit string is shorter than the total number of required bits,
	  // a terminator of up to four 0s must be added to the right side of the string.
	  // If the bit string is more than four bits shorter than the required number of bits,
	  // add four 0s to the end.
	  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
	    buffer.put(0, 4)
	  }
	
	  // If the bit string is fewer than four bits shorter, add only the number of 0s that
	  // are needed to reach the required number of bits.
	
	  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
	  // pad the string on the right with 0s to make the string's length a multiple of 8.
	  while (buffer.getLengthInBits() % 8 !== 0) {
	    buffer.putBit(0)
	  }
	
	  // Add pad bytes if the string is still shorter than the total number of required bits.
	  // Extend the buffer to fill the data capacity of the symbol corresponding to
	  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
	  // and 00010001 (0x11) alternately.
	  var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
	  for (var i = 0; i < remainingByte; i++) {
	    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
	  }
	
	  return createCodewords(buffer, version, errorCorrectionLevel)
	}
	
	/**
	 * Encode input data with Reed-Solomon and return codewords with
	 * relative error correction bits
	 *
	 * @param  {BitBuffer} bitBuffer            Data to encode
	 * @param  {Number}    version              QR Code version
	 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
	 * @return {Buffer}                         Buffer containing encoded codewords
	 */
	function createCodewords (bitBuffer, version, errorCorrectionLevel) {
	  // Total codewords for this QR code version (Data + Error correction)
	  var totalCodewords = Utils.getSymbolTotalCodewords(version)
	
	  // Total number of error correction codewords
	  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
	
	  // Total number of data codewords
	  var dataTotalCodewords = totalCodewords - ecTotalCodewords
	
	  // Total number of blocks
	  var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)
	
	  // Calculate how many blocks each group should contain
	  var blocksInGroup2 = totalCodewords % ecTotalBlocks
	  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2
	
	  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)
	
	  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
	  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1
	
	  // Number of EC codewords is the same for both groups
	  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1
	
	  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
	  var rs = new ReedSolomonEncoder(ecCount)
	
	  var offset = 0
	  var dcData = new Array(ecTotalBlocks)
	  var ecData = new Array(ecTotalBlocks)
	  var maxDataSize = 0
	  var buffer = BufferUtil.from(bitBuffer.buffer)
	
	  // Divide the buffer into the required number of blocks
	  for (var b = 0; b < ecTotalBlocks; b++) {
	    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2
	
	    // extract a block of data from buffer
	    dcData[b] = buffer.slice(offset, offset + dataSize)
	
	    // Calculate EC codewords for this data block
	    ecData[b] = rs.encode(dcData[b])
	
	    offset += dataSize
	    maxDataSize = Math.max(maxDataSize, dataSize)
	  }
	
	  // Create final data
	  // Interleave the data and error correction codewords from each block
	  var data = BufferUtil.alloc(totalCodewords)
	  var index = 0
	  var i, r
	
	  // Add data codewords
	  for (i = 0; i < maxDataSize; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      if (i < dcData[r].length) {
	        data[index++] = dcData[r][i]
	      }
	    }
	  }
	
	  // Apped EC codewords
	  for (i = 0; i < ecCount; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      data[index++] = ecData[r][i]
	    }
	  }
	
	  return data
	}
	
	/**
	 * Build QR Code symbol
	 *
	 * @param  {String} data                 Input string
	 * @param  {Number} version              QR Code version
	 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
	 * @param  {MaskPattern} maskPattern     Mask pattern
	 * @return {Object}                      Object containing symbol data
	 */
	function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
	  var segments
	
	  if (isArray(data)) {
	    segments = Segments.fromArray(data)
	  } else if (typeof data === 'string') {
	    var estimatedVersion = version
	
	    if (!estimatedVersion) {
	      var rawSegments = Segments.rawSplit(data)
	
	      // Estimate best version that can contain raw splitted segments
	      estimatedVersion = Version.getBestVersionForData(rawSegments,
	        errorCorrectionLevel)
	    }
	
	    // Build optimized segments
	    // If estimated version is undefined, try with the highest version
	    segments = Segments.fromString(data, estimatedVersion || 40)
	  } else {
	    throw new Error('Invalid data')
	  }
	
	  // Get the min version that can contain data
	  var bestVersion = Version.getBestVersionForData(segments,
	      errorCorrectionLevel)
	
	  // If no version is found, data cannot be stored
	  if (!bestVersion) {
	    throw new Error('The amount of data is too big to be stored in a QR Code')
	  }
	
	  // If not specified, use min version as default
	  if (!version) {
	    version = bestVersion
	
	  // Check if the specified version can contain the data
	  } else if (version < bestVersion) {
	    throw new Error('\n' +
	      'The chosen QR Code version cannot contain this amount of data.\n' +
	      'Minimum version required to store current data is: ' + bestVersion + '.\n'
	    )
	  }
	
	  var dataBits = createData(version, errorCorrectionLevel, segments)
	
	  // Allocate matrix buffer
	  var moduleCount = Utils.getSymbolSize(version)
	  var modules = new BitMatrix(moduleCount)
	
	  // Add function modules
	  setupFinderPattern(modules, version)
	  setupTimingPattern(modules)
	  setupAlignmentPattern(modules, version)
	
	  // Add temporary dummy bits for format info just to set them as reserved.
	  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
	  // since the masking operation must be performed only on the encoding region.
	  // These blocks will be replaced with correct values later in code.
	  setupFormatInfo(modules, errorCorrectionLevel, 0)
	
	  if (version >= 7) {
	    setupVersionInfo(modules, version)
	  }
	
	  // Add data codewords
	  setupData(modules, dataBits)
	
	  if (isNaN(maskPattern)) {
	    // Find best mask pattern
	    maskPattern = MaskPattern.getBestMask(modules,
	      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
	  }
	
	  // Apply mask pattern
	  MaskPattern.applyMask(maskPattern, modules)
	
	  // Replace format info bits with correct values
	  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)
	
	  return {
	    modules: modules,
	    version: version,
	    errorCorrectionLevel: errorCorrectionLevel,
	    maskPattern: maskPattern,
	    segments: segments
	  }
	}
	
	/**
	 * QR Code
	 *
	 * @param {String | Array} data                 Input data
	 * @param {Object} options                      Optional configurations
	 * @param {Number} options.version              QR Code version
	 * @param {String} options.errorCorrectionLevel Error correction level
	 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
	 */
	exports.create = function create (data, options) {
	  if (typeof data === 'undefined' || data === '') {
	    throw new Error('No input text')
	  }
	
	  var errorCorrectionLevel = ECLevel.M
	  var version
	  var mask
	
	  if (typeof options !== 'undefined') {
	    // Use higher error correction level as default
	    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
	    version = Version.from(options.version)
	    mask = MaskPattern.from(options.maskPattern)
	
	    if (options.toSJISFunc) {
	      Utils.setToSJISFunction(options.toSJISFunc)
	    }
	  }
	
	  return createSymbol(data, version, errorCorrectionLevel, mask)
	}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var BufferUtil = __webpack_require__(6)
	var Polynomial = __webpack_require__(227)
	var Buffer = __webpack_require__(234).Buffer
	
	function ReedSolomonEncoder (degree) {
	  this.genPoly = undefined
	  this.degree = degree
	
	  if (this.degree) this.initialize(this.degree)
	}
	
	/**
	 * Initialize the encoder.
	 * The input param should correspond to the number of error correction codewords.
	 *
	 * @param  {Number} degree
	 */
	ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
	  // create an irreducible generator polynomial
	  this.degree = degree
	  this.genPoly = Polynomial.generateECPolynomial(this.degree)
	}
	
	/**
	 * Encodes a chunk of data
	 *
	 * @param  {Buffer} data Buffer containing input data
	 * @return {Buffer}      Buffer containing encoded data
	 */
	ReedSolomonEncoder.prototype.encode = function encode (data) {
	  if (!this.genPoly) {
	    throw new Error('Encoder not initialized')
	  }
	
	  // Calculate EC for this data block
	  // extends data size to data+genPoly size
	  var pad = BufferUtil.alloc(this.degree)
	  var paddedData = Buffer.concat([data, pad], data.length + this.degree)
	
	  // The error correction codewords are the remainder after dividing the data codewords
	  // by a generator polynomial
	  var remainder = Polynomial.mod(paddedData, this.genPoly)
	
	  // return EC data blocks (last n byte, where n is the degree of genPoly)
	  // If coefficients number in remainder are less than genPoly degree,
	  // pad with 0s to the left to reach the needed number of coefficients
	  var start = this.degree - remainder.length
	  if (start > 0) {
	    var buff = BufferUtil.alloc(this.degree)
	    remainder.copy(buff, start)
	
	    return buff
	  }
	
	  return remainder
	}
	
	module.exports = ReedSolomonEncoder


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(4)
	var NumericData = __webpack_require__(226)
	var AlphanumericData = __webpack_require__(217)
	var ByteData = __webpack_require__(220)
	var KanjiData = __webpack_require__(224)
	var Regex = __webpack_require__(137)
	var Utils = __webpack_require__(5)
	var dijkstra = __webpack_require__(195)
	
	/**
	 * Returns UTF8 byte length
	 *
	 * @param  {String} str Input string
	 * @return {Number}     Number of byte
	 */
	function getStringByteLength (str) {
	  return unescape(encodeURIComponent(str)).length
	}
	
	/**
	 * Get a list of segments of the specified mode
	 * from a string
	 *
	 * @param  {Mode}   mode Segment mode
	 * @param  {String} str  String to process
	 * @return {Array}       Array of object with segments data
	 */
	function getSegments (regex, mode, str) {
	  var segments = []
	  var result
	
	  while ((result = regex.exec(str)) !== null) {
	    segments.push({
	      data: result[0],
	      index: result.index,
	      mode: mode,
	      length: result[0].length
	    })
	  }
	
	  return segments
	}
	
	/**
	 * Extracts a series of segments with the appropriate
	 * modes from a string
	 *
	 * @param  {String} dataStr Input string
	 * @return {Array}          Array of object with segments data
	 */
	function getSegmentsFromString (dataStr) {
	  var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
	  var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
	  var byteSegs
	  var kanjiSegs
	
	  if (Utils.isKanjiModeEnabled()) {
	    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
	    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
	  } else {
	    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
	    kanjiSegs = []
	  }
	
	  var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)
	
	  return segs
	    .sort(function (s1, s2) {
	      return s1.index - s2.index
	    })
	    .map(function (obj) {
	      return {
	        data: obj.data,
	        mode: obj.mode,
	        length: obj.length
	      }
	    })
	}
	
	/**
	 * Returns how many bits are needed to encode a string of
	 * specified length with the specified mode
	 *
	 * @param  {Number} length String length
	 * @param  {Mode} mode     Segment mode
	 * @return {Number}        Bit length
	 */
	function getSegmentBitsLength (length, mode) {
	  switch (mode) {
	    case Mode.NUMERIC:
	      return NumericData.getBitsLength(length)
	    case Mode.ALPHANUMERIC:
	      return AlphanumericData.getBitsLength(length)
	    case Mode.KANJI:
	      return KanjiData.getBitsLength(length)
	    case Mode.BYTE:
	      return ByteData.getBitsLength(length)
	  }
	}
	
	/**
	 * Merges adjacent segments which have the same mode
	 *
	 * @param  {Array} segs Array of object with segments data
	 * @return {Array}      Array of object with segments data
	 */
	function mergeSegments (segs) {
	  return segs.reduce(function (acc, curr) {
	    var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
	    if (prevSeg && prevSeg.mode === curr.mode) {
	      acc[acc.length - 1].data += curr.data
	      return acc
	    }
	
	    acc.push(curr)
	    return acc
	  }, [])
	}
	
	/**
	 * Generates a list of all possible nodes combination which
	 * will be used to build a segments graph.
	 *
	 * Nodes are divided by groups. Each group will contain a list of all the modes
	 * in which is possible to encode the given text.
	 *
	 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
	 * The group for '12345' will contain then 3 objects, one for each
	 * possible encoding mode.
	 *
	 * Each node represents a possible segment.
	 *
	 * @param  {Array} segs Array of object with segments data
	 * @return {Array}      Array of object with segments data
	 */
	function buildNodes (segs) {
	  var nodes = []
	  for (var i = 0; i < segs.length; i++) {
	    var seg = segs[i]
	
	    switch (seg.mode) {
	      case Mode.NUMERIC:
	        nodes.push([seg,
	          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
	          { data: seg.data, mode: Mode.BYTE, length: seg.length }
	        ])
	        break
	      case Mode.ALPHANUMERIC:
	        nodes.push([seg,
	          { data: seg.data, mode: Mode.BYTE, length: seg.length }
	        ])
	        break
	      case Mode.KANJI:
	        nodes.push([seg,
	          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
	        ])
	        break
	      case Mode.BYTE:
	        nodes.push([
	          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
	        ])
	    }
	  }
	
	  return nodes
	}
	
	/**
	 * Builds a graph from a list of nodes.
	 * All segments in each node group will be connected with all the segments of
	 * the next group and so on.
	 *
	 * At each connection will be assigned a weight depending on the
	 * segment's byte length.
	 *
	 * @param  {Array} nodes    Array of object with segments data
	 * @param  {Number} version QR Code version
	 * @return {Object}         Graph of all possible segments
	 */
	function buildGraph (nodes, version) {
	  var table = {}
	  var graph = {'start': {}}
	  var prevNodeIds = ['start']
	
	  for (var i = 0; i < nodes.length; i++) {
	    var nodeGroup = nodes[i]
	    var currentNodeIds = []
	
	    for (var j = 0; j < nodeGroup.length; j++) {
	      var node = nodeGroup[j]
	      var key = '' + i + j
	
	      currentNodeIds.push(key)
	      table[key] = { node: node, lastCount: 0 }
	      graph[key] = {}
	
	      for (var n = 0; n < prevNodeIds.length; n++) {
	        var prevNodeId = prevNodeIds[n]
	
	        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
	          graph[prevNodeId][key] =
	            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
	            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)
	
	          table[prevNodeId].lastCount += node.length
	        } else {
	          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length
	
	          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
	            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
	        }
	      }
	    }
	
	    prevNodeIds = currentNodeIds
	  }
	
	  for (n = 0; n < prevNodeIds.length; n++) {
	    graph[prevNodeIds[n]]['end'] = 0
	  }
	
	  return { map: graph, table: table }
	}
	
	/**
	 * Builds a segment from a specified data and mode.
	 * If a mode is not specified, the more suitable will be used.
	 *
	 * @param  {String} data             Input data
	 * @param  {Mode | String} modesHint Data mode
	 * @return {Segment}                 Segment
	 */
	function buildSingleSegment (data, modesHint) {
	  var mode
	  var bestMode = Mode.getBestModeForData(data)
	
	  mode = Mode.from(modesHint, bestMode)
	
	  // Make sure data can be encoded
	  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
	    throw new Error('"' + data + '"' +
	      ' cannot be encoded with mode ' + Mode.toString(mode) +
	      '.\n Suggested mode is: ' + Mode.toString(bestMode))
	  }
	
	  // Use Mode.BYTE if Kanji support is disabled
	  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
	    mode = Mode.BYTE
	  }
	
	  switch (mode) {
	    case Mode.NUMERIC:
	      return new NumericData(data)
	
	    case Mode.ALPHANUMERIC:
	      return new AlphanumericData(data)
	
	    case Mode.KANJI:
	      return new KanjiData(data)
	
	    case Mode.BYTE:
	      return new ByteData(data)
	  }
	}
	
	/**
	 * Builds a list of segments from an array.
	 * Array can contain Strings or Objects with segment's info.
	 *
	 * For each item which is a string, will be generated a segment with the given
	 * string and the more appropriate encoding mode.
	 *
	 * For each item which is an object, will be generated a segment with the given
	 * data and mode.
	 * Objects must contain at least the property "data".
	 * If property "mode" is not present, the more suitable mode will be used.
	 *
	 * @param  {Array} array Array of objects with segments data
	 * @return {Array}       Array of Segments
	 */
	exports.fromArray = function fromArray (array) {
	  return array.reduce(function (acc, seg) {
	    if (typeof seg === 'string') {
	      acc.push(buildSingleSegment(seg, null))
	    } else if (seg.data) {
	      acc.push(buildSingleSegment(seg.data, seg.mode))
	    }
	
	    return acc
	  }, [])
	}
	
	/**
	 * Builds an optimized sequence of segments from a string,
	 * which will produce the shortest possible bitstream.
	 *
	 * @param  {String} data    Input string
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of segments
	 */
	exports.fromString = function fromString (data, version) {
	  var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())
	
	  var nodes = buildNodes(segs)
	  var graph = buildGraph(nodes, version)
	  var path = dijkstra.find_path(graph.map, 'start', 'end')
	
	  var optimizedSegs = []
	  for (var i = 1; i < path.length - 1; i++) {
	    optimizedSegs.push(graph.table[path[i]].node)
	  }
	
	  return exports.fromArray(mergeSegments(optimizedSegs))
	}
	
	/**
	 * Splits a string in various segments with the modes which
	 * best represent their content.
	 * The produced segments are far from being optimized.
	 * The output of this function is only used to estimate a QR Code version
	 * which may contain the data.
	 *
	 * @param  {string} data Input string
	 * @return {Array}       Array of segments
	 */
	exports.rawSplit = function rawSplit (data) {
	  return exports.fromArray(
	    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
	  )
	}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(5)
	var ECCode = __webpack_require__(136)
	var ECLevel = __webpack_require__(13)
	var Mode = __webpack_require__(4)
	var VersionCheck = __webpack_require__(138)
	var isArray = __webpack_require__(14)
	
	// Generator polynomial used to encode version information
	var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
	var G18_BCH = Utils.getBCHDigit(G18)
	
	function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
	  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
	    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
	      return currentVersion
	    }
	  }
	
	  return undefined
	}
	
	function getReservedBitsCount (mode, version) {
	  // Character count indicator + mode indicator bits
	  return Mode.getCharCountIndicator(mode, version) + 4
	}
	
	function getTotalBitsFromDataArray (segments, version) {
	  var totalBits = 0
	
	  segments.forEach(function (data) {
	    var reservedBits = getReservedBitsCount(data.mode, version)
	    totalBits += reservedBits + data.getBitsLength()
	  })
	
	  return totalBits
	}
	
	function getBestVersionForMixedData (segments, errorCorrectionLevel) {
	  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
	    var length = getTotalBitsFromDataArray(segments, currentVersion)
	    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
	      return currentVersion
	    }
	  }
	
	  return undefined
	}
	
	/**
	 * Returns version number from a value.
	 * If value is not a valid version, returns defaultValue
	 *
	 * @param  {Number|String} value        QR Code version
	 * @param  {Number}        defaultValue Fallback value
	 * @return {Number}                     QR Code version number
	 */
	exports.from = function from (value, defaultValue) {
	  if (VersionCheck.isValid(value)) {
	    return parseInt(value, 10)
	  }
	
	  return defaultValue
	}
	
	/**
	 * Returns how much data can be stored with the specified QR code version
	 * and error correction level
	 *
	 * @param  {Number} version              QR Code version (1-40)
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @param  {Mode}   mode                 Data mode
	 * @return {Number}                      Quantity of storable data
	 */
	exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
	  if (!VersionCheck.isValid(version)) {
	    throw new Error('Invalid QR Code version')
	  }
	
	  // Use Byte mode as default
	  if (typeof mode === 'undefined') mode = Mode.BYTE
	
	  // Total codewords for this QR code version (Data + Error correction)
	  var totalCodewords = Utils.getSymbolTotalCodewords(version)
	
	  // Total number of error correction codewords
	  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
	
	  // Total number of data codewords
	  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8
	
	  if (mode === Mode.MIXED) return dataTotalCodewordsBits
	
	  var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)
	
	  // Return max number of storable codewords
	  switch (mode) {
	    case Mode.NUMERIC:
	      return Math.floor((usableBits / 10) * 3)
	
	    case Mode.ALPHANUMERIC:
	      return Math.floor((usableBits / 11) * 2)
	
	    case Mode.KANJI:
	      return Math.floor(usableBits / 13)
	
	    case Mode.BYTE:
	    default:
	      return Math.floor(usableBits / 8)
	  }
	}
	
	/**
	 * Returns the minimum version needed to contain the amount of data
	 *
	 * @param  {Segment} data                    Segment of data
	 * @param  {Number} [errorCorrectionLevel=H] Error correction level
	 * @param  {Mode} mode                       Data mode
	 * @return {Number}                          QR Code version
	 */
	exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
	  var seg
	
	  var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)
	
	  if (isArray(data)) {
	    if (data.length > 1) {
	      return getBestVersionForMixedData(data, ecl)
	    }
	
	    if (data.length === 0) {
	      return 1
	    }
	
	    seg = data[0]
	  } else {
	    seg = data
	  }
	
	  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
	}
	
	/**
	 * Returns version information with relative error correction bits
	 *
	 * The version information is included in QR Code symbols of version 7 or larger.
	 * It consists of an 18-bit sequence containing 6 data bits,
	 * with 12 error correction bits calculated using the (18, 6) Golay code.
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         Encoded version info bits
	 */
	exports.getEncodedBits = function getEncodedBits (version) {
	  if (!VersionCheck.isValid(version) || version < 7) {
	    throw new Error('Invalid QR Code version')
	  }
	
	  var d = version << 12
	
	  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
	    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
	  }
	
	  return (version << 12) | d
	}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(139)
	
	function clearCanvas (ctx, canvas, size) {
	  ctx.clearRect(0, 0, canvas.width, canvas.height)
	
	  if (!canvas.style) canvas.style = {}
	  canvas.height = size
	  canvas.width = size
	  canvas.style.height = size + 'px'
	  canvas.style.width = size + 'px'
	}
	
	function getCanvasElement () {
	  try {
	    return document.createElement('canvas')
	  } catch (e) {
	    throw new Error('You need to specify a canvas element')
	  }
	}
	
	exports.render = function render (qrData, canvas, options) {
	  var opts = options
	  var canvasEl = canvas
	
	  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
	    opts = canvas
	    canvas = undefined
	  }
	
	  if (!canvas) {
	    canvasEl = getCanvasElement()
	  }
	
	  opts = Utils.getOptions(opts)
	  var size = Utils.getImageWidth(qrData.modules.size, opts)
	
	  var ctx = canvasEl.getContext('2d')
	  var image = ctx.createImageData(size, size)
	  Utils.qrToImageData(image.data, qrData, opts)
	
	  clearCanvas(ctx, canvasEl, size)
	  ctx.putImageData(image, 0, 0)
	
	  return canvasEl
	}
	
	exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
	  var opts = options
	
	  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
	    opts = canvas
	    canvas = undefined
	  }
	
	  if (!opts) opts = {}
	
	  var canvasEl = exports.render(qrData, canvas, opts)
	
	  var type = opts.type || 'image/png'
	  var rendererOpts = opts.rendererOpts || {}
	
	  return canvasEl.toDataURL(type, rendererOpts.quality)
	}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(139)
	
	function getColorAttrib (color, attrib) {
	  var alpha = color.a / 255
	  var str = attrib + '="' + color.hex + '"'
	
	  return alpha < 1
	    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
	    : str
	}
	
	function svgCmd (cmd, x, y) {
	  var str = cmd + x
	  if (typeof y !== 'undefined') str += ' ' + y
	
	  return str
	}
	
	function qrToPath (data, size, margin) {
	  var path = ''
	  var moveBy = 0
	  var newRow = false
	  var lineLength = 0
	
	  for (var i = 0; i < data.length; i++) {
	    var col = Math.floor(i % size)
	    var row = Math.floor(i / size)
	
	    if (!col && !newRow) newRow = true
	
	    if (data[i]) {
	      lineLength++
	
	      if (!(i > 0 && col > 0 && data[i - 1])) {
	        path += newRow
	          ? svgCmd('M', col + margin, 0.5 + row + margin)
	          : svgCmd('m', moveBy, 0)
	
	        moveBy = 0
	        newRow = false
	      }
	
	      if (!(col + 1 < size && data[i + 1])) {
	        path += svgCmd('h', lineLength)
	        lineLength = 0
	      }
	    } else {
	      moveBy++
	    }
	  }
	
	  return path
	}
	
	exports.render = function render (qrData, options, cb) {
	  var opts = Utils.getOptions(options)
	  var size = qrData.modules.size
	  var data = qrData.modules.data
	  var qrcodesize = size + opts.margin * 2
	
	  var bg = !opts.color.light.a
	    ? ''
	    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
	      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'
	
	  var path =
	    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
	    ' d="' + qrToPath(data, size, opts.margin) + '"/>'
	
	  var viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'
	
	  var width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '
	
	  var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'
	
	  if (typeof cb === 'function') {
	    cb(null, svgTag)
	  }
	
	  return svgTag
	}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(28)
	var ieee754 = __webpack_require__(31)
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
	    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayView(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof SharedArrayBuffer !== 'undefined' &&
	      (isInstance(value, SharedArrayBuffer) ||
	      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpreted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayView (arrayView) {
	  if (isInstance(arrayView, Uint8Array)) {
	    var copy = new Uint8Array(arrayView)
	    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
	  }
	  return fromArrayLike(arrayView)
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      if (pos + buf.length > buffer.length) {
	        Buffer.from(buf).copy(buffer, pos)
	      } else {
	        Uint8Array.prototype.set.call(
	          buffer,
	          buf,
	          pos
	        )
	      }
	    } else if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    } else {
	      buf.copy(buffer, pos)
	    }
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return asciiWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF)
	      ? 4
	      : (firstByte > 0xDF)
	          ? 3
	          : (firstByte > 0xBF)
	              ? 2
	              : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += hexSliceLookupTable[buf[i]]
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
	  for (var i = 0; i < bytes.length - 1; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUintLE =
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUintBE =
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUint8 =
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUint16LE =
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUint16BE =
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUint32LE =
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUint32BE =
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUintLE =
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUintBE =
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUint8 =
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUint16LE =
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint16BE =
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint32LE =
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUint32BE =
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	// Create lookup table for `toString('hex')`
	// See: https://github.com/feross/buffer/issues/219
	var hexSliceLookupTable = (function () {
	  var alphabet = '0123456789abcdef'
	  var table = new Array(256)
	  for (var i = 0; i < 16; ++i) {
	    var i16 = i * 16
	    for (var j = 0; j < 16; ++j) {
	      table[i16 + j] = alphabet[i] + alphabet[j]
	    }
	  }
	  return table
	})()
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11).Buffer))

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ai-modal-editor-content\">\r\n    <div class=\"ai-modal-editor-left-column\" ng-if=\"twoColumns\">\r\n        <h2 class=\"fw-semi-bold title\">Original text</h2>\r\n        <div class=\"ai-modal-editor-left-column-text\">\r\n            <tinymce-basic editor-text=\"originalText\" custom-link=\"true\" parent-obj=\"{}\" order=\"2\" ai-editor=\"true\" editor-modal=\"true\" ng-if=\"originalText.content || originalText.content==''\"></tinymce-basic>\r\n        </div>\r\n    </div>\r\n    <div class=\"ai-modal-editor-right-column\">\r\n        <h2 ng-if=\"twoColumns\" class=\"fw-semi-bold title\">AI suggestion</h2>\r\n        <div class=\"ai-modal-editor-right-column-text\">\r\n            <tinymce-basic editor-text=\"aiSuggestion\" custom-link=\"true\" parent-obj=\"{}\" order=\"1\" ai-editor=\"true\" editor-modal=\"true\" ng-if=\"aiSuggestion.content\"></tinymce-basic>\r\n        </div>\r\n    </div>\r\n</div>  "

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay ai-modal\">\r\n    <div class=\"modal--media-dialog\">\r\n        <div class=\"modal--media-wrapper\">\r\n            <div class=\"modal--media-header\">\r\n                <h2>AI {{name}}</h2>\r\n                <div \r\n                    ng-click=\"!loading && cancelAiModal()\" \r\n                    ng-escape=\"cancelAiModal()\" \r\n                    parametar=\"modal\" \r\n                    class=\"btn btn-danger\" \r\n                    ng-class=\"{disabled: loading}\" \r\n                    ng-disabled=\"loading\">\r\n                    Cancel\r\n                </div>\r\n            </div>\r\n            <div class=\"modal--media-content set-image-modal\" ng-class=\"{'two-columns': twoColumns}\">\r\n                <!-- Loading animation -->\r\n                <div class=\"ai-loading-spinner\" ng-if=\"loading\">\r\n                    <div class=\"spinner\"></div>\r\n                    <div>Loading AI results...</div>\r\n                </div>\r\n                <ai-recommendations-dir\r\n                    funcionality=\"funcionality\" \r\n                    multiple=\"multiple\"\r\n                    display-type=\"displayType\"\r\n                    display-type-obj=\"displayTypeObj\"\r\n                    result-from-ai=\"resultFromAi\"\r\n                    selected-suggestion=\"selectedSuggestion\"\r\n                    ng-if=\"!loading && !tryAgain && !editor\"\r\n                ></ai-recommendations-dir>\r\n                <ai-editor-dir\r\n                    two-columns=\"twoColumns\"\r\n                    funcionality=\"funcionality\"\r\n                    text=\"text\"\r\n                    result-from-ai=\"resultFromAi\"\r\n                    selected-suggestion=\"selectedSuggestion\"\r\n                    diff-text=\"diffText\"\r\n                    ng-if=\"!loading && !tryAgain && editor\"\r\n                ></ai-editor-dir>\r\n                <!-- Recommendations list -->\r\n                <!-- <div class=\"ai-recommendations-list\"\r\n                    ng-if=\"!loading && !tryAgain\"\r\n                    ng-class=\"{'inline': displayType === 'inline', 'block': displayType === 'block'}\">\r\n                    <div\r\n                        ng-repeat=\"recommendation in recommendations\"\r\n                        ng-class=\"{\r\n                            'ai-recommendation': true,\r\n                            'active': isActive(recommendation),\r\n                            'inactive': !isActive(recommendation),\r\n                            'inline': displayType === 'inline',\r\n                            'block': displayType === 'block'\r\n                        }\"\r\n                        ng-click=\"toggleRecommendation(recommendation)\">\r\n                        {{ displayTypeObj ? recommendation.name : recommendation }}\r\n                    </div>\r\n                </div>\r\n                <div class=\"ai-recommendations-legend\" ng-if=\"!loading && !tryAgain\">\r\n                    <span class=\"legend-item\">\r\n                        <span class=\"legend-circle selected\"></span>\r\n                        <span>{{name}} selected (applied)</span>\r\n                    </span>\r\n                    <span class=\"legend-item\">\r\n                        <span class=\"legend-circle\"></span>\r\n                        <span>{{name}} not selected (not applied)</span>\r\n                    </span>\r\n                </div> -->\r\n                <div class=\"ai-modal-error\" ng-if=\"tryAgain\">\r\n                    <span>{{errorMessage}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"action\">\r\n                <a class=\"btn btn-primary\" ng-click=\"applyAiHandler()\" ng-class=\"{disabled: loading || !selectedSuggestion.value.length}\" ng-disabled=\"loading || !selectedSuggestion.value.length\" ng-if=\"!tryAgain\"><span ng-if=\"!edit\">Apply</span><span ng-if=\"edit\">Update</span></a>\r\n                <a class=\"btn btn-danger\" ng-click=\"cancelAiModal()\" ng-class=\"{disabled: loading}\" ng-disabled=\"loading\" ng-if=\"!tryAgain && !edit\">Reject</a>\r\n                <a class=\"btn btn-black btn-ai\" ng-click=\"tryAgainHandler()\" ng-if=\"tryAgain\">Try again</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n  "

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ai-modal-content\">\r\n    <!-- Recommendations list -->\r\n    <div class=\"ai-recommendations-list\"\r\n        ng-class=\"{'inline': displayType === 'inline', 'block': displayType === 'block'}\">\r\n        <div\r\n            ng-repeat=\"recommendation in recommendations\"\r\n            ng-class=\"{\r\n                'ai-recommendation': true,\r\n                'active': isActive(recommendation),\r\n                'inactive': !isActive(recommendation),\r\n                'inline': displayType === 'inline',\r\n                'block': displayType === 'block'\r\n            }\"\r\n            ng-click=\"toggleRecommendation(recommendation)\">\r\n            {{ displayTypeObj ? recommendation.name : recommendation }}\r\n        </div>\r\n    </div>\r\n    <div class=\"ai-recommendations-legend\">\r\n        <span class=\"legend-item\">\r\n            <span class=\"legend-circle selected\"></span>\r\n            <span>{{name}} selected (applied)</span>\r\n        </span>\r\n        <span class=\"legend-item\">\r\n            <span class=\"legend-circle\"></span>\r\n            <span>{{name}} not selected (not applied)</span>\r\n        </span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"approvals-wrapper\">\r\n    <div class=\"form-group\">\r\n        <label>Title</label> \r\n        <input ng-model=\"title\" class=\"form-control\" placeholder=\"Enter title here\" ng-class=\"{'error-border':titleRequired}\" ng-focus=\"titleRequired = false\">\r\n    </div>\r\n    <div class=\"form-group\" ng-if=\"loadUrlforDropzone\">\r\n        <form class=\"dropzone\" options=\"dzOptionsApproval\" callbacks=\"dzCallbacksApproval\" methods=\"dzMethodsApproval\" ng-dropzone></form>\r\n    </div>\r\n    <ul class=\"list-approvals\" ng-show=\"!bulk\">\r\n        <li ng-repeat=\"approval in approvals\">\r\n            <span><img src=\"images/download.svg\" alt=\"Download\" title=\"Download Approval\" ng-click=\"downloadApproval(approval)\"></span>\r\n            <span ng-click=\"downloadApproval(approval)\" class=\"clickable fw-semi-bold\" title=\"Download Approval\">{{approval.title}}</span>\r\n            <span class=\"remove-from-list\" ng-click=\"removeApproval(approval,$index)\" title=\"Remove Approval\">&Cross;</span>\r\n        </li>\r\n    </ul>\r\n</div>"

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay add-to-exchange dictionary\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n         <h2>Add to {{typeAddToExchange.charAt(0).toUpperCase() + typeAddToExchange.slice(1)}} Exchange</h2>\r\n         <div ng-click=\"closeAddPostToExchangeModal()\" ng-escape = \"closeAddPostToExchangeModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content set-image-modal\">\r\n            <div class=\"checkbox checkbox-primary\" ng-repeat=\"item in sharedCategory\" ng-class=\"{'disabled': item.disabled}\">\r\n                <input type=\"checkbox\" ng-model=\"item.checked\" id=\"checkbox_{{item['_id']}}\" ng-disabled=\"item.disabled\"><label for=\"checkbox_{{item['_id']}}\">{{item.name}}</label>\r\n            </div>\r\n            <div class=\"action\">\r\n            <a class=\"btn btn-primary\" ng-click=\"addPostToExchange(typeAddToExchange,typeAddToExchangePostId)\">Add</a>\r\n            </div>\r\n            <div class=\"modal-overlay\" ng-if=\"!loaded\" ng-click=\"$event.stopPropagation();\"></div>\r\n        </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = "<ul ng-show=\"open\">\r\n    <li ng-repeat=\"category in categories\" ng-class=\"{'checkedEditPost': parent.categorychecked[category._id] && (!category.children || !category.children.length==0)}\" ng-show=\"category.visible\"> \r\n        <div class=\"checkbox checkbox-primary\" ng-class=\"{'acordion-checkbox': category.children && category.children.length > 0, 'open': category.open, 'selected-child': parent.parentCategoriesChecked[category._id]}\">\r\n            <input type=\"checkbox\" ng-model=\"parent.categorychecked[category._id]\" ng-click = \"updateSelection(category._id, parent.categorychecked[category._id], category, $event)\" id=\"{{category._id}}\">\r\n            <label for=\"{{category._id}}\">{{category.name}}</label>\r\n        </div>\r\n        <category-accordion ng-if=\"category.children && category.children.length>0\" parent=\"parent\" categories=\"category.children\" parent-category=\"category\" open=\"category.open\"></category-accordion>\r\n    </li>\r\n</ul>"

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "<ul ng-attr-id=\"{{ type + 'scroll' }}\">\r\n    <li ng-repeat=\"item in list\" ng-class=\"{['checkedEditPost'+ type]: itemChecked.item[item._id]}\"> \r\n        <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"itemChecked.item[item._id]\" ng-click = \"updateSelection(item._id, itemChecked.item[item._id], item)\" id=\"{{item._id}}\">\r\n            <label for=\"{{item._id}}\">{{item.name}}</label>\r\n        </div>\r\n    </li>\r\n</ul>"

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"single-post--widget widget keywords\">\r\n    <header class=\"bb overflow-hidden\" ng-style=\"{'border-bottom': isCollapsed ? 'none' : '1px solid #ccc'}\">\r\n      <h5 class=\"fw-semi-bold pull-left\" style=\"line-height: 34px;\">Keywords</h5>\r\n      <button type=\"button\" \r\n              class=\"btn btn-default pull-right\" \r\n              ng-click=\"isCollapsed = !isCollapsed\" style=\"outline: none!important;\">\r\n        <i class=\"fa\" \r\n           ng-class=\"{'fa-minus': !isCollapsed, 'fa-plus': isCollapsed}\">\r\n        </i>\r\n      </button>\r\n    </header>\r\n    <div class=\"widget-body\" ng-show=\"!isCollapsed\">\r\n        <!-- Google Suggestions Search -->\r\n        <div class=\"search-wrapper\">\r\n            <div class=\"input-group\">\r\n                <input type=\"text\" \r\n                       class=\"form-control\" \r\n                       ng-model=\"newKeyword\" \r\n                       placeholder=\"Search for keywords\"\r\n                       ng-keypress=\"($event.keyCode === 13) ? searchGoogleSuggestions() : null\">\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" \r\n                            class=\"btn btn-primary\" \r\n                            ng-click=\"searchGoogleSuggestions()\">Search</button>\r\n                </span>\r\n            </div>\r\n            <!-- Error message for Google suggestions -->\r\n            <div class=\"required-error animate-show\" ng-show=\"suggestionsError\">\r\n                {{suggestionsError}}\r\n            </div>\r\n        </div>\r\n        <div class=\"keywords-empty\" ng-if=\"keyWordsList.length === 0\">\r\n            <p>No keywords</p>\r\n        </div>\r\n        <div class=\"keywords-container\" ng-if=\"keyWordsList.length > 0\">\r\n            <!-- Keywords List Header -->\r\n            <div class=\"keywords-header\">\r\n                <div class=\"keyword-label\">Keyword</div>\r\n                <div class=\"counts-label\">\r\n                    <span class=\"count-label\">H1</span>\r\n                    <span class=\"count-label\">H2</span>\r\n                    <span class=\"count-label\">P</span>\r\n                    <span class=\"action-label tooltip-trigger\">\r\n                        i\r\n                        <div class=\"keywords-tooltip\">\r\n                            <h4>Kratko uputstvo za korišćenje ključnih fraza:</h4>\r\n                            \r\n                            <h5>Glavna ključna fraza</h5>\r\n                            <ul>\r\n                                <li>U naslovu (H1): 1 put. (Obavezno i u page title, ako se razlikuju page title i naslov, onda možemo i samo u page title)</li>\r\n                                <li>U tekstu: minimumalno 2-3 puta u sadržaju. Najbolja praksa iskoristiti je u prvoj rečenici prvog pasusa. Boldovanje barem jednom u tekstu te fraze poželjno.</li>\r\n                                <li>Ako upisujemo odvojeni naslov, preporuka je da se nađe i u meta description sadržaju</li>\r\n                                <li>Po mogućnosti koristiti i u međunaslovima za bolju optimizaciju.</li>\r\n                            </ul>\r\n\r\n                            <h5>Dodatne ključne fraze</h5>\r\n                            <ul>\r\n                                <li>Rasporedite ih ravnomerno kroz tekst, koristiti ih barem jednom u tekstu.</li>\r\n                                <li>Po mogućnosti koristiti i u međunaslovima.</li>\r\n                            </ul>\r\n\r\n                            <h5>Uklanjanje fraza</h5>\r\n                            <ul>\r\n                                <li>Svaku unetu ili predloženu frazu možete ukloniti klikom na X pored nje.</li>\r\n                            </ul>\r\n                        </div>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Keywords List -->\r\n            <div class=\"keywords-list\">\r\n                <div class=\"keyword-item\" ng-repeat=\"keyword in keyWordsList\">\r\n                    <div class=\"keyword-controls\">\r\n                        <input type=\"radio\" \r\n                            ng-model=\"keyword.isMain\"\r\n                            ng-value=\"true\"\r\n                            ng-checked=\"keyword.isMain\"\r\n                            ng-click=\"setMainKeyword(keyword)\"\r\n                            name=\"mainKeyword\">\r\n                        <span class=\"keyword-name\">{{keyword.name}}</span>\r\n                    </div>\r\n                    <div class=\"keyword-counts\">\r\n                        <span class=\"count h1-count\" \r\n                            ng-class=\"{\r\n                                'danger': isMainKeyword(keyword) && keyword.counts.h1 === 0,\r\n                                'success': (isMainKeyword(keyword) && keyword.counts.h1 > 0) || \r\n                                            (!isMainKeyword(keyword) && keyword.counts.h1 > 0),\r\n                                'default': !isMainKeyword(keyword) && keyword.counts.h1 === 0\r\n                            }\">\r\n                            {{keyword.counts.h1}}\r\n                        </span>\r\n                        <span class=\"count h2h3-count\" \r\n                            ng-class=\"{\r\n                                'success': keyword.counts.h2h3 > 0,\r\n                                'default': keyword.counts.h2h3 === 0\r\n                            }\">\r\n                            {{keyword.counts.h2h3}}\r\n                        </span>\r\n                        <span class=\"count p-count\" \r\n                            ng-class=\"{\r\n                                'danger': isMainKeyword(keyword) && keyword.counts.p < 1,\r\n                                'default': (isMainKeyword(keyword) && keyword.counts.p === 1) || \r\n                                            (!isMainKeyword(keyword) && keyword.counts.p < 1),\r\n                                'success': (isMainKeyword(keyword) && keyword.counts.p > 1) ||\r\n                                            (!isMainKeyword(keyword) && keyword.counts.p >= 1)\r\n                            }\">\r\n                            {{keyword.counts.p}}\r\n                        </span>\r\n                        <button ng-click=\"removeKeyword($index)\" class=\"remove-btn\" title=\"Remove keyword\">×</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"clear-all-keywords-container\">\r\n                <div class=\"clear-all-keywords\" ng-click=\"clearAllKeywords()\">Clear all</div>\r\n            </div>\r\n        </div>\r\n        <!-- Manual Keyword Add -->\r\n        <div class=\"search-wrapper\">\r\n            <div class=\"input-group\">\r\n                <input type=\"text\" \r\n                       class=\"form-control\" \r\n                       ng-model=\"manualKeyword\" \r\n                       placeholder=\"Add keyword\"\r\n                       ng-keypress=\"($event.keyCode === 13) ? addManualKeyword() : null\">\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" \r\n                            class=\"btn btn-info\" \r\n                            ng-click=\"addManualKeyword()\">Add</button>\r\n                </span>\r\n            </div>\r\n            <!-- Error messages for manual keyword -->\r\n            <div class=\"required-error animate-show\" ng-show=\"manualError\">\r\n                {{manualError}}\r\n            </div>\r\n            <div class=\"required-error animate-show\" ng-show=\"existKeyword\">\r\n                Keyword already exists\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>"

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"notifications-wrapper\" ng-show=\"obj.notifications.length > 0\">\r\n\t<div ng-repeat=\"notification in obj.notifications track by notification.id\" class= \"notification-item {{notification.type}} animated\" ng-class=\"{'fadeInLeft':!notification.animation,'fadeInLeftAndShake':notification.animation}\">\r\n        <div class=\"notification-header\">\r\n            <span ng-show=\"notification.headerText\">{{notification.headerText}}</span>\r\n            <div class=\"close-notification\" ng-click=\"closeNotification(notification.id)\">&#10761;</div>\r\n        </div> \r\n        <div class=\"notification-content\">\r\n            {{notification.contentText}}\r\n        </div>\r\n        <a class=\"btn btn-{{notification.type}}\" data-ui-sref=\"{{notification.btnFunc}}\" ng-click=\"closeNotification(notification.id)\" ng-if=\"notification.btnFunc\">{{notification.btnText}}</a>\r\n    </div>\r\n</div>"

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-all-post-sortable-wrapper\">\r\n    <div class=\"status-filter\">\r\n        <div class=\"search search-title\">\r\n            <label>Search Title/ID</label>\r\n            <div class=\"relative-position\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"Search...\" ng-model=\"searchTitle\" ng-keypress=\"searchPress($event)\" ng-change=\"searchTitleOrIdChange()\">\r\n                <div class=\"remove remove-large clickable clickable-danger\" ng-show=\"removeTitleShow\" ng-click=\"searchTitle='';removeTitleShow=false; searchTitleOrIdChange()\"><span>×</span></div>\r\n            </div>\r\n        </div>\r\n        <div class=\"select-option\" ng-show=\"searchCategories\">\r\n            <label>Select category</label>\r\n            <select ng-model=\"selectedCategory.value\" ng-change=\"switchCategories()\" class=\"form-control\">\r\n                <option value=\"all\">All categories</option>\r\n                <option ng-repeat= \"category in categoriesTreeSelect\" value=\"{{category._id}}\" class=\"level{{category.ancestors.length}}\" ng-bind=\"category.name\" ng-if=\"category.visible\"></option>\r\n            </select>\r\n        </div>\r\n        <div class=\"search search-wrapper search-tag\" ng-show=\"searchTags\">\r\n            <label>Search tag</label>\r\n            <div class=\"relative-position\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"searchTag\" auto-complete-dir enter-tag= \"\" type-dir=\"'insertTagRecomendedNews'\" placeholder=\"Search...\" datachangelabel=\"\" datachangeid = \"\" ng-change=\"searchTagChange()\">\r\n                <div class=\"remove remove-large clickable clickable-danger\" ng-show=\"removeTagShow\" ng-click=\"searchTag='';removeTagShow=false; searchTagChange()\"><span>×</span></div>\r\n            </div> \r\n        </div>\r\n    </div>\r\n    <div class=\"sortable-grid\">\r\n        <table>\r\n            <tbody ui-sortable=\"sortableOptions\" ng-model=\"allPosts\" class=\"sortable-grid__wrapper sortableFrom\" ng-show=\"!emptyTable\">\r\n                <tr ng-repeat=\"item in allPosts track by $index\">\r\n                    <td class=\"document_id text-center\">\r\n                        <span>{{item.id}}</span>\r\n                    </td>\r\n                    <td ng-if=\"sortableDataName=='focusData'\" style=\"display: none;\"></td>\r\n                    <td class=\"title-cell\">\r\n                        <div class=\"title\">\r\n                            <span>{{item.title}}</span>\r\n                        </div>\r\n                    </td>\r\n                    <td class=\"text-center align-middle\" ng-if=\"sortableDataName!='prFocusNews'\">\r\n                        <a class=\"btn btn-primary\" ng-click=\"addToSortable(item)\">Add</a>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n            <tbody ng-show=\"emptyTable\">\r\n                <tr>\r\n                    <td colspan=\"2\" ng-if=\"sortableDataName=='prFocusNews'\">No result. Try again.</td>\r\n                    <td colspan=\"3\" ng-if=\"sortableDataName!='prFocusNews'\">No result. Try again.</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <div class=\"load-more text-center\" ng-show=\"loadMoreShow\">\r\n            <a ng-click=\"loadMore()\" class=\"btn btn-primary\">Load More</a>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay blog-modal\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n            <h2>Insert Live Blog</h2>\r\n            <div ng-click=\"parentObj.cancelBlogModal()\" ng-escape = \"parentObj.cancelBlogModal()\" parametar=\"modal\" class=\"btn btn-danger\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content set-image-modal\">\r\n          <div class=\"input-field search-post-dir search-wrapper form-group\">\r\n            <input type=\"text\" placeholder=\"Search live blog ...\" ng-model=\"searchBlogData\" class=\"form-control\" ng-keyup=\"search()\" ng-keypress=\"searchPress($event,'star')\" ng-class=\"{'error-border':requiredBlog}\" ng-focus=\"requiredBlog=false\">\r\n            <ul class=\"autocomplete-result\" ng-if=\"!hiddenResult\">\r\n              <li ng-show=\"!hasResult\">No result.</li>\r\n              <li ng-repeat=\"blog in blogArray\" ng-click=\"chooseSearchData(blog)\" ng-show=\"hasResult\">({{blog._id}}) - {{blog.title}}</li>\r\n              <li ng-show=\"hasResult && loadMore\" class=\"text-center\"><a class=\"btn btn-default\" ng-click=\"readMore()\">Load more</a></li>\r\n            </ul>\r\n            <div class=\"btn btn-primary add-button\" ng-click = \"insertBlog()\">Insert Blog</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay poll-modal\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n            <h2>Insert polls</h2>\r\n            <div ng-click=\"parentObj.cancelPollModal()\" ng-escape = \"parentObj.cancelPollModal()\" parametar=\"modal\" class=\"btn btn-danger\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content set-image-modal\">\r\n          <div class=\"input-field search-wrapper form-group\">\r\n            <!-- <label>Choose which poll you would like to add:</label>\r\n            <select ng-model=\"selectedPollAction.value\" class=\"form-control\">\r\n              <option value=\"default\">Select poll:</option>\r\n              <option value=\"{{poll._id}}\" ng-repeat=\"poll in polls\">{{poll.date | date:'medium'}}&nbsp;&nbsp;&nbsp;{{poll.title}}</option>\r\n            </select> -->\r\n            <input type=\"text\" placeholder=\"Search poll ...\" ng-model=\"searchPollData\" class=\"form-control search-autocomplete\" ng-keyup=\"search()\" ng-keypress=\"searchPress($event,'star')\">\r\n            <ul class=\"autocomplete-result\" ng-if=\"!hiddenResult\">\r\n              <li ng-show=\"!hasResult\">No result.</li>\r\n              <li ng-repeat=\"poll in pollArray\" ng-click=\"chooseSearchData(poll)\" ng-show=\"hasResult\">({{poll._id}}) - {{poll.title}}</li>\r\n              <li ng-show=\"hasResult && loadMore\" class=\"text-center\"><a class=\"btn btn-default\" ng-click=\"readMore()\">Load more</a></li>\r\n            </ul>\r\n            <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredPoll\">Choose poll</div>\r\n          </div>\r\n          <div class=\"form-group\" ng-show=\"pollResultDisplay\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"pollResult\"><label ng-click=\"pollResult=!pollResult\">Result</label>\r\n            </div>\r\n          </div>\r\n          <!-- <div class=\"form-group poll-align\">\r\n            <label>Select Poll Align</label>\r\n              <select ng-model=\"selectedPollAlignAction.value\" ng-change=\"switchPollAlignAction(selectedPollAlignAction.value)\" class=\"form-control\">\r\n              <option value=\"1\">Vertical</option>\r\n              <option value=\"2\">Horizontal</option>\r\n            </select>\r\n          </div> -->\r\n          <div class=\"action\">\r\n            <a class=\"btn btn-primary\" ng-click=\"insertPoll()\">Insert Poll</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"input-field search-wrapper form-group search-post-dir\" ng-class=\"{'no-btn':noAddBtn}\">\r\n    <input type=\"text\" placeholder=\"Search post ...\" ng-model=\"searchPostsData\" class=\"form-control\" id=\"search-post\" ng-keyup=\"search()\" ng-keypress=\"searchPress($event,'star')\" ng-class=\"{'readonly':disableInput}\" ng-readonly=\"disableInput\">\r\n    <div class=\"clickable clickable-danger remove\" ng-if=\"disableInput\" ng-click=\"enableInput()\"><span>&times;</span></div>\r\n    <ul class=\"autocomplete-result\" ng-if=\"!hiddenResult\">\r\n      <li ng-show=\"!hasResult\">No result.</li>\r\n      <li ng-repeat=\"post in postResult\" ng-click=\"chooseSearchData(post)\" ng-show=\"hasResult\">({{post._id}}) - {{post._source.post_date}} - {{post._source.post_title}}</li>\r\n      <li ng-show=\"hasResult && loadMore\" class=\"text-center\"><a class=\"btn btn-default\" ng-click=\"readMore()\">Load more</a></li>\r\n    </ul>\r\n    <div class=\"btn btn-primary add-button\" ng-click = \"addSearchPost(searchObj)\" ng-show=\"!noAddBtn\">Add Post</div>\r\n</div>"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay poll-modal\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n            <h2>Insert rating</h2>\r\n            <div ng-click=\"parentObj.cancelRatingModal()\" ng-escape = \"parentObj.cancelRatingModal()\" parametar=\"modal\" class=\"btn btn-danger\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content set-image-modal\">\r\n          <div class=\"input-field search-wrapper form-group\">\r\n            <input type=\"text\" placeholder=\"Search rating ...\" ng-model=\"searchRatingData\" class=\"form-control search-autocomplete\" ng-keyup=\"search()\" ng-keypress=\"searchPress($event,'star')\">\r\n            <ul class=\"autocomplete-result\" ng-if=\"!hiddenResult\">\r\n              <li ng-show=\"!hasResult\">No result.</li>\r\n              <li ng-repeat=\"rating in ratingArray\" ng-click=\"chooseSearchData(rating)\" ng-show=\"hasResult\">({{rating._id}}) - {{rating.title}}</li>\r\n              <li ng-show=\"hasResult && loadMore\" class=\"text-center\"><a class=\"btn btn-default\" ng-click=\"readMore()\">Load more</a></li>\r\n            </ul>\r\n            <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredRating\">Choose rating</div>\r\n          </div>\r\n          <div class=\"form-group\" ng-show=\"ratingResultDisplay\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"ratingResult\"><label ng-click=\"ratingResult=!ratingResult\">Result</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"action\">\r\n            <a class=\"btn btn-primary\" ng-click=\"insertRating()\">Insert Rating</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"tinymce-basic-wrapper\" id=\"tinymce-basic-{{order}}\">\r\n  <div class=\"change-preview-wrapper\" ng-if=\"photo || textModePermision\">\r\n    <a ng-click=\"addMediatoEditor()\" class=\"btn grey-btn add-media-editor\" ng-if=\"photo\">Insert Photo</a>\r\n    <ul class=\"editor-tabs-wrapper\" ng-if=\"textModePermision\">\r\n      <li>\r\n        <a class=\"active visual\" ng-click=\"editorChangePreviw($event, 'visual')\">Visual</a>\r\n      </li>\r\n      <li>\r\n        <a ng-click=\"editorChangePreviw($event, 'text')\" class=\"text\">Text</a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <form method=\"post\"  class=\"post-editor\" ng-controller=\"tinymceBasicController as tinymceBasic\" ng-if=\"tinymceModel || tinymceModel==''\">\r\n    <textarea  ui-tinymce=\"tinymceOptions\" ng-model=\"tinymceModel\"></textarea>\r\n  </form>\r\n  <set-featured-image-modal ng-if=\"mediaModal\" current-post-obj=\"imageModalObj\" attach-to-post=\"attachToPost\"></set-featured-image-modal>\r\n  <edit-image-modal ng-if=\"editImageModalObj.editImagefromEditor\" current-post-obj=\"editImageModalObj\"></edit-image-modal>\r\n  <set-featured-video ng-if=\"videoModalShow\" current-post-obj=\"videoModalObj\" scheduled=\"true\"></set-featured-video>\r\n  <search-poll-dir ng-if=\"pollModalShow\" parent-obj=\"pollModalObj\" poll-result-display=\"pollResultDisplay\"></search-poll-dir> \r\n  <search-rating-dir ng-if=\"ratingModalShow\" parent-obj=\"ratingModalObj\" rating-result-display=\"ratingResultDisplay\"></search-rating-dir>\r\n  <search-blog-modal-dir ng-if=\"blogModalShow\" parent-obj=\"blogModalObj\"></search-blog-modal-dir> \r\n  <script type=\"text/ng-template\" id=\"editor.html\">\r\n    <textarea class=\"editor-plain-text hidden\" ng-model=\"editorText.content\" ng-paste=\"pasteText($event);\"></textarea>\r\n  </script>\r\n</div>"

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"upload-photo-wrapper\">\r\n    <div class=\"upload-type-wrapper\">\r\n        <select ng-model=\"selectedPhotoQuality.value\" class=\"form-control\">\r\n        <option value=\"medium\">Medium</option>\r\n        <option value=\"high\">High</option>\r\n        </select>\r\n        <label for=\"\">Photo quality:&nbsp;</label>\r\n    </div>\r\n    <form class=\"dropzone\" options=\"dzOptions\" callbacks=\"dzCallbacks\" methods=\"dzMethods\" ng-dropzone ng-if=\"firstBound\"></form>\r\n    <div class=\"form-group\">\r\n        <label>Title</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"upload_title\">\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <label>Signature</label> \r\n        <input type=\"text\" class=\"form-control\" ng-model=\"upload_signature\">\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <label>Gallery title</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"upload_gallery_title\">\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label>Description</label>\r\n      <textarea ng-model=\"upload_description\" class=\"form-control\"></textarea>\r\n    </div>\r\n    <div class=\"form-group\">\r\n        <label>Author Url</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"upload_signature_url\">\r\n      </div>\r\n    <div class=\"form-group\">\r\n        <div class=\"form-group checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"photoRestriction\"  id=\"photo-restriction\" ng-change=\"addPhotoRestriction()\">\r\n            <label for=\"photo-restriction\" ng-if=\"!photoRestriction\">Add Restrictions</label>\r\n            <label for=\"photo-restriction\" ng-if=\"photoRestriction\">Remove Restrictions</label>\r\n        </div>\r\n        <div ng-class=\"{'slideInFadeDown animated' : photoRestriction}\" class=\"overflow-hidden\" ng-show = \"photoRestriction\">\r\n          <div class=\"input-group-no-border form-group\">\r\n            <label for=\"\">Maximum utilization&nbsp;</label>\r\n            <input type=\"text\" class=\"form-control inline-block\" ng-model=\"numberOfUses\" ng-keypress=\"onlyNumber($event)\">\r\n          </div>\r\n          <div class=\"form-group range-picker range-picker-restriction\" >\r\n            <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Restrictions date range\" ranges=\"ranges\" ng-change = \"changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n          </div>\r\n          <!-- <form class=\"dropzone\" options=\"dzOptionsRestriction\" callbacks=\"dzCallbacksRestriction\" methods=\"dzMethodsRestriction\" ng-dropzone></form> -->\r\n        </div>\r\n    </div>\r\n    <div class=\"form-group\" ng-if=\"!fromPost && !addToMediaLibrary\">\r\n        <a ng-click=\"saveAttachments()\" class=\"pull-right btn btn-primary\">Save Photos</a>\r\n    </div>\r\n</div>"

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = "<!--\r\n  Main sidebar seen on the left. may be static or collapsing depending on selected state.\r\n\r\n    * Collapsing - navigation automatically collapse when mouse leaves it and expand when enters.\r\n    * Static - stays always open.\r\n-->\r\n<nav sn-navigation> </nav>\r\n<!-- This is the white navigation bar seen on the top. A bit enhanced BS navbar. See .page-controls in _base.scss. -->\r\n<nav class=\"page-controls navbar navbar-default\"  navigation-template></nav>\r\n\r\n<!-- <aside sn-chat-sidebar></aside> -->\r\n\r\n<div class=\"content-wrap\">\r\n  <!-- main page content. the place to put widgets in. usually consists of .row > .col-md-* > .widget.  -->\r\n  <main id=\"content\" class=\"content\" role=\"main\" data-ui-view>\r\n  \r\n  </main>\r\n\r\n</div>\r\n<div class=\"alert-wrapper\" ng-class=\"{'show':alert.show}\">\r\n\t<div ng-repeat=\"alert in alerts\" class= \"alert alert-{{alert.type}} animated\" ng-class=\"{'fadeIn':alert.show, 'fadeOut':!alert.show}\">\r\n    <div class=\"image-wrapper\">\r\n    </div>\r\n    <div class=\"alert-content\">\r\n      <span class=\"alert-type\">\r\n        <strong>{{alert.title}}</strong>\r\n      </span>\r\n      <span style=\"white-space: pre-line;\">{{alert.message}}</span>\r\n    </div>\r\n    <div class=\"close-alert\" ng-show=\"alert.close\" ng-click=\"closeAlert(alert.id)\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"center-alert warning-alert\">\r\n  <div class=\"alert-wrapper\" ng-if=\"warningAlert.show\">\r\n    <div class= \"alert alert-{{warningAlert.type}} animated\" ng-class=\"{'fadeIn':warningAlert.show, 'fadeOut':!warningAlert.show}\">\r\n      <div class=\"alert-title\">{{warningAlert.title}}</div>\r\n      <div class=\"alert-content\">\r\n        <span ng-bind-html=\"warningAlert.message\"></span>\r\n      </div>\r\n      <div class=\"close-alert\" ng-click=\"warningAlert.closeAlert()\">&times;</div>\r\n      <div class=\"alert-actions\">\r\n        <div class=\"btn btn-primary\" ng-click=\"warningAlert.warningCallback();warningAlert.closeAlert('confirm')\">Confirm</div>\r\n        <div class=\"btn btn-danger\" ng-click=\"warningAlert.closeAlert()\">Cancel</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div> \r\n<div class=\"alert-wrapper-overlay\" ng-if=\"alertShow || warningAlert.show\"></div>\r\n<div ng-show=\"!hasLoaded\" class=\"loader-wrapper\" ng-class=\"{'modal-show':modalShow}\">\r\n\t<div class=\"image-wrapper\">\r\n  \t\t<img src=\"images/ajax-loader.svg\" alt=\"Loader\">\r\n\t</div>\r\n</div>\r\n<notification-center-dir obj=\"vma\"></notification-center-dir>\r\n<div class=\"event-stream-error\" ng-if=\"eventStreamError && !offlineError\">\r\n  Heads up: The locking system is temporarily unavailable. You can keep working, but some safeguards are off — please take extra care to avoid overwriting others’ changes.\r\n</div>"

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\r\n  <!-- .navbar-header contains links seen on xs & sm screens -->\r\n  <div class=\"navbar-header\">\r\n    <ul class=\"nav navbar-nav\">\r\n      <li>\r\n        <a class=\"visible-sm visible-xs hamburger\" title=\"Show/hide sidebar\" ng-click=\"vma.toggleNav()\" data-placement=\"bottom\" data-tooltip>\r\n          <span class=\"rounded rounded-lg bg-gray text-white hidden-lg-up\"><i class=\"fa fa-bars fa-lg\"></i></span>\r\n        </a>\r\n        <!-- span class=\"margin-top\" id=\"cpu\"><i class=\"fa fa-tachometer\" aria-hidden=\"true\"></i><p>{{vma.socketData.cpu}}</p></span>\r\n        <span class=\"margin-top\" id=\"mem\"><i class=\"fa fa-database\" aria-hidden=\"true\"></i><p>{{vma.socketData.mem}}</p></span> -->\r\n      <!--   <span class=\"margin-top\" id=\"mem\"><i class=\"fa fa-male\" aria-hidden=\"true\"></i><p>{{vma.socketAnaliticsData}}</p></span> -->\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <!-- <div class=\"collapse navbar-collapse realtime-block\" ng-if=\"role_id !=='comments-moderator'\">\r\n    <ul class=\"nav navbar-nav navbar-right\">\r\n      <li class=\"dropdown\" data-dropdown>\r\n        <a href class=\"dropdown-toggle\" data-dropdown-toggle>\r\n          <span class=\"margin-top\" id=\"analytic\"><i class=\"fa fa-male\" aria-hidden=\"true\"></i><p></p></span>\r\n        </a>\r\n        <ul class=\"dropdown-menu dropdown-menu-left\" ng-show=\"vma.socketData.ispArray && vma.socketData.ispArray.length>0\">\r\n          <li ng-repeat=\"isp in vma.socketData.ispArray | sortingCount: 'descending': 'count'\">{{vma.getIspTitle(isp.name)}} : <span>{{isp.count}}</span></li>\r\n        </ul>\r\n        <ul class=\"dropdown-menu dropdown-menu-left\" ng-show=\"!vma.socketData.ispArray || vma.socketData.ispArray.length==0\">\r\n          <li>No Data</li>\r\n        </ul>\r\n      </li>\r\n    </ul>\r\n  </div> -->\r\n  <!-- <div class=\"navbar-focus-block pull-left flex-display gap-10\" ng-click=\"vma.focusTakeover()\" ng-class=\"{'active': vma.focusLocked.locked && vma.focusLocked.userId == vma.userId && $state.current.name == 'app.allfocus'}\" ng-if=\"role_id !=='comments-moderator'\">\r\n    <svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" ng-class=\"{'locked': vma.focusLocked.locked,'current': vma.focusLocked.locked && vma.focusLocked.userId == vma.userId}\">\r\n      <circle cx=\"11\" cy=\"11\" r=\"4\"  stroke=\"#777777\" stroke-width=\"2\"/>\r\n      <path d=\"M1.4762 6.23822V2.4287C1.4762 1.90271 1.90259 1.47632 2.42858 1.47632L6.2381 1.47632\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n      <path d=\"M20.5238 15.7618L20.5238 19.5713C20.5238 20.0973 20.0974 20.5237 19.5714 20.5237L15.7619 20.5237\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n      <path d=\"M6.2381 20.5237L2.42858 20.5237C1.90259 20.5237 1.4762 20.0973 1.4762 19.5713L1.4762 15.7618\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n      <path d=\"M15.7619 1.47632L19.5714 1.47632C20.0974 1.47632 20.5238 1.90271 20.5238 2.4287L20.5238 6.23822\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n    </svg>\r\n    <div class=\"navbar-focus-block-text\">\r\n      <strong>Focus</strong><strong ng-if=\"vma.focusLocked.locked\">:&nbsp;{{vma.focusLocked.name}}</strong>\r\n    </div>\r\n  </div> -->\r\n  <div class=\"collapse navbar-collapse user-block\">\r\n    <ul class=\"nav navbar-nav navbar-right\">\r\n      <li class=\"dropdown\" data-dropdown>\r\n        <a href class=\"dropdown-toggle\" data-dropdown-toggle>\r\n          <span class=\"thumb-sm avatar pull-left\">\r\n            <img class=\"img-circle\" src=\"{{vma.avatar}}\" alt=\"Name\">\r\n          </span>\r\n          &nbsp;\r\n          <span class=\"user-block-name\"><strong>{{vma.name}}</strong></span>\r\n        </a>\r\n        <ul class=\"dropdown-menu\">\r\n          <li><a data-ui-sref=\"app.profile\"><i class=\"glyphicon glyphicon-user\"></i> &nbsp; Edit your profile</a></li>\r\n          <li class=\"divider\"></li>\r\n          <li><a ng-click=\"vma.logout()\"><i class=\"fa fa-sign-out\"></i> &nbsp; Log Out</a></li>\r\n        </ul>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <!-- <div class=\"collapse navbar-collapse pull-right notification-block\" ng-if=\"role_id !=='comments-moderator'\">\r\n    <ul class=\"nav navbar-nav navbar-right\">\r\n      <li class=\"dropdown\" data-dropdown>\r\n        <a href class=\"dropdown-toggle\" data-dropdown-toggle title=\"Dodeljene vesti\" ng-class=\"{'notification-highlights': vma.notificationNews.assigned.length > 0}\">\r\n          <span class=\"pull-left assigned_icon-wrapper\">\r\n            <img src=\"images/assigned_icon.svg\" alt=\"Assigned icon\">\r\n          </span>\r\n         <strong>{{vma.notificationNews.assigned.length}}</strong>\r\n        </a>\r\n        <div class=\"dropdown-menu\">\r\n          <ul ng-show=\"vma.notificationNews.assigned.length == 0\">\r\n            <li class=\"nowrap\">Nema dodeljenih vesti</li>  \r\n          </ul>\r\n          <ul ng-show=\"vma.notificationNews.assigned.length > 0\">\r\n            <li ng-repeat=\"item in vma.notificationNews.assigned\" >\r\n              <a data-ui-sref=\"app.allposts({id:item._id})\">\r\n                <div class=\"title\"><span class=\"fw-bold\">{{item.title}}</span></div>\r\n                <div class=\"time\"><span class=\"fw-bold\">{{item.date | date:'MMM d, y H:mm'}}</span></div>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </div> -->\r\n  <!-- <div class=\"notification-block pull-right\">\r\n    <div class=\"notification-block-inner\">\r\n      <a data-ui-sref=\"app.agency_allnews\" class=\"clickable\" title=\"Nove vesti\" ng-class=\"{'notification-highlights': vma.notificationNews.newAgenciesNews > 0}\">\r\n        <span class=\"pull-left notification_icon-wrapper\">\r\n          <img src=\"images/notification_icon.svg\" alt=\"Notification icon\">\r\n        </span>\r\n        <strong>{{vma.notificationNews.newAgenciesNews}}</strong>\r\n      </a>\r\n    </div>\r\n  </div> -->\r\n  <!-- <div class=\"collapse navbar-collapse pull-right notification-block notification-block-small\" ng-if=\"role_id !=='comments-moderator'\">\r\n    <ul class=\"nav navbar-nav navbar-left\">\r\n      <li class=\"dropdown\" data-dropdown>\r\n        <a href class=\"dropdown-toggle\" data-dropdown-toggle title=\"Nove vesti\" ng-class=\"{'notification-highlights': vma.notificationNews.newTotalCount > 0}\">\r\n          <span class=\"pull-left notification_icon-wrapper\">\r\n            <img src=\"images/notification_icon.svg\" alt=\"Notification icon\">\r\n          </span>\r\n         <strong>{{vma.notificationNews.newTotalCount}}</strong>\r\n        </a>\r\n        <div class=\"dropdown-menu\">\r\n          <ul ng-show=\"vma.notificationNews.newTotalCount == 0\">\r\n            <li class=\"nowrap\">Nema novih vesti</li>  \r\n          </ul>\r\n          <ul ng-show=\"vma.notificationNews.newTotalCount > 0\">\r\n            <li ng-repeat=\"(key,value) in vma.notificationNews.new\" ng-show=\"value>0\">\r\n              <a data-ui-sref=\"app.{{key}}_allnews\" class=\"default-color\">\r\n                <div class=\"capitalize nowrap\">{{key}}:&nbsp;<span class=\"fw-bold\">{{value}}</span></div>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </div> -->\r\n</div>\r\n"

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "<nav id=\"sidebar\" role=\"navigation\" class=\"sidebar\" ng-class=\"{'sidebar-show':vma.sidebarshow}\">\r\n  <div class=\"js-sidebar-content\">\r\n    <header class=\"logo\">\r\n      <a href=\"/\" title=\"{{app.name}}\"></a><span>v{{app.version}}</span>\r\n    </header>\r\n    <ul class=\"sidebar-nav\">\r\n      <li ng-repeat=\"menu in navigation\" ng-class=\"{'active': vma.currentstate.includes($index)}\"><a class=\"collapsed\" ng-click = \"vma.subCategoryOpen($index)\"><span class=\"icon\"><i class=\"fa fa-{{menu.classname}}\"></i></span>{{menu.label}}<i class=\"toggle fa fa-angle-down\"></i></a>\r\n        <ul>\r\n          <li ng-repeat=\"submenu in menu.items\" ui-sref-active=\"active\">\r\n            <a data-ui-sref=\"app.{{submenu.state}}\" ng-click=\"vma.currentStateHandler($event, submenu.state)\" class=\"{{submenu.state}}\">\r\n              <svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"submenu.state == 'allfocus'\" ng-class=\"{'locked': vma.focusLocked.locked,'current': vma.focusLocked.locked && vma.focusLocked.userId == vma.userId}\">\r\n                <circle cx=\"11\" cy=\"11\" r=\"4\"  stroke=\"#777777\" stroke-width=\"2\"/>\r\n                <path d=\"M1.4762 6.23822V2.4287C1.4762 1.90271 1.90259 1.47632 2.42858 1.47632L6.2381 1.47632\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n                <path d=\"M20.5238 15.7618L20.5238 19.5713C20.5238 20.0973 20.0974 20.5237 19.5714 20.5237L15.7619 20.5237\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n                <path d=\"M6.2381 20.5237L2.42858 20.5237C1.90259 20.5237 1.4762 20.0973 1.4762 19.5713L1.4762 15.7618\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n                <path d=\"M15.7619 1.47632L19.5714 1.47632C20.0974 1.47632 20.5238 1.90271 20.5238 2.4287L20.5238 6.23822\" stroke=\"#777777\" stroke-width=\"2\"/>\r\n              </svg>\r\n              {{submenu.label}}\r\n            </a></li>\r\n        </ul>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</nav>\r\n"

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget ads-txt-wrapper\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Ads.txt</span></h1>\r\n  <div class=\"form-group\">\r\n    <textarea ng-model=\"vmat.adsTxt\" plceholder=\"Ads.txt\" class=\"form-control\"></textarea>\r\n  </div>  \r\n  <a ng-click=\"vmat.saveChanges()\" class=\"btn btn-primary pull-right\">Save Changes</a>\r\n</section>"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget related-video-box overflow banner-slider\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Banner Slider</span></h1>\r\n  <div class=\"form-group position-relative\">\r\n    <label>Banner Slider Title</label>\r\n    <input type=\"text\" placeholder=\"Banner slider title\" ng-model=\"vmbs.bannerSliderTitle\" class=\"form-control\" ng-class=\"{'error-border':vmbs.requiredTitle}\" ng-focus = \"vmbs.requiredTitle = false\">\r\n    <div class=\"required-error animate-show ng-hide\" ng-show=\"vmbs.requiredTitle\">Banner slider title is required</div> \r\n  </div>\r\n    <div class=\"sortable-grid\">\r\n      <table>\r\n        <thead>\r\n          <tr>\r\n          <th class=\"text-center\" style=\"width:280px;\">Images</th>\r\n          <th>Url</th>\r\n          <th>&nbsp;</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody sortable-dir ng-model=\"vmbs.widgetItems\" class=\"sortable-grid__wrapper\" type=\"customWidget\" ng-show=\"vmbs.widgetItems.length > 0\" type=\"noOrder\">\r\n          <tr ng-repeat=\"item in vmbs.widgetItems\">\r\n            <td class=\"text-center sortable-grid_image\">\r\n                <div class=\"dropzone-wrapper\">\r\n                  <form class=\"dropzone\" options=\"vmbs.dropzone[item.id].dzOptions\" callbacks=\"vmbs.dropzone[item.id].dzCallbacks\" methods=\"vmbs.dropzone[item.id].dzMethods\" ng-dropzone></form>\r\n                  <div class=\"required-error animate-show ng-hide\" ng-show=\"vmbs.requiredField.images.incorect[item.id]\">Incorect file name</div>\r\n                </div>\r\n                <div class=\"media-image-wrapper\">\r\n                  <div class=\"media-image-item\">\r\n                    <label>des</label>\r\n                    <div class=\"media-image\" ng-click=\"vmbs.addImage(item)\" ng-class=\"{'error-border':vmbs.requiredField.images.des[item.id]}\">\r\n                      <img ng-src=\"{{item.images.des}}\" class=\"img-responsive\" ng-if=\"item.images.des\">\r\n                      <div class=\"clickable clickable-danger remove\" ng-click=\"vmbs.removeImage(item,'des')\" ng-if=\"item.images.des\">×</div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"media-image-item\">\r\n                    <label>mob</label>\r\n                    <div class=\"media-image\" ng-click=\"vmbs.addImage(item)\" ng-class=\"{'error-border':vmbs.requiredField.images.mob[item.id]}\">\r\n                      <img ng-src=\"{{item.images.mob}}\" class=\"img-responsive\" ng-if=\"item.images.mob\">\r\n                      <div class=\"clickable clickable-danger remove\" ng-click=\"vmbs.removeImage(item,'mob')\" ng-if=\"item.images.mob\">×</div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n            </td>\r\n            <td class=\"title-cell\">\r\n\r\n              <div class=\"position-relative\">\r\n                <label>Url</label>\r\n                <input type=\"text\" placeholder=\"Url\" ng-model=\"item.url\" class=\"form-control\" ng-class=\"{'error-border':vmbs.requiredField.url[item.id]}\" ng-focus = \"vmbs.requiredField.url[item.id] = false\">\r\n                <div class=\"required-error animate-show ng-hide\" ng-show=\"vmbs.requiredField.url[item.id]\">Url is required</div>    \r\n              </div>\r\n            </td>\r\n            <td class=\"clickable clickable-danger remove\" ng-click=\"vmbs.removeItem($index)\"><span>×</span></td>\r\n          </tr>\r\n        </tbody>\r\n        <tbody ng-show=\"vmbs.widgetItems.length == 0\">\r\n          <tr>\r\n            <td colspan=\"3\" class=\"colspan\">No items.</td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <a ng-click=\"vmbs.addItem()\" class=\"btn btn-primary pull-left\">Add Item</a>\r\n    <a ng-click=\"vmbs.saveChanges()\" class=\"btn btn-primary pull-right\">Save All Changes</a>\r\n</section>\r\n<set-widget-image-modal ng-if=\"vmbs.mediaModal\" current-post-obj=\"vmbs\"></set-widget-image-modal>"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"widget-body\">\r\n    <div class=\"form-group\">\r\n        <select style=\"max-width:200px;width:100%\" ng-model=\"selectedCategory.value\" ng-change=\"switchCategories(selectedCategory.value)\" class=\"form-control\">\r\n        <option value=\"default\">Select</option>                         <!-- categoriesCopy.length-1 izbacen je uncategorized -->\r\n        <option value=\"all\" ng-disabled=\"checkedItems.length == categoriesCopy.length-1\">Select all</option>\r\n        <option value=\"none\" ng-disabled=\"checkedItems.length == 0\">Remove all</option>\r\n        <option ng-repeat= \"category in categoriesCopy | filter:{_id :'!uncategorized'}\" value=\"{{category._id}}\" ng-bind=\"category.name\" ng-disabled=\"category.selected\"></option>\r\n        </select>\r\n    </div>\r\n    <div class=\"form-group\" style=\"max-width:300px;width:100%\">\r\n        <ads-category-accordion ng-if=\"checkedItems && checkedItems.length>0\" categories=\"checkedItems\" open=\"true\" remove-item=\"removeItem\"></ads-category-accordion>\r\n        <div class=\"no-items-select\" ng-if=\"!checkedItems || checkedItems.length == 0\">\r\n            <p>No items selected.</p>\r\n        </div>\r\n    </div>\r\n    <div class=\"search-wrapper\" style=\"max-width:300px;width:100%\">\r\n        <label for=\"search-input\">Post ID</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"addPostId\" placeholder=\"Enter Post ID\" ng-keypress=\"keyPressOnlyNumberAndDot($event)\" ng-class=\"{'error-border':postIdRequired}\" ng-focus=\"postIdRequired = false;\" ng-enter=\"addPostIdHandler(addPostId)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addPostIdHandler(addPostId)\">Add</button></span></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"existPostId\">Post ID alredy exists</div>\r\n        <ul class=\"list-added\">\r\n          <li ng-repeat=\"postId in ad.post_ids track by $index\"><span class=\"remove-from-list\" ng-click=\"removeFromPostList($index)\">x</span>{{postId}}</li>\r\n        </ul>\r\n    </div>\r\n</div>"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "<ul ng-show=\"open\">\r\n    <li ng-repeat=\"category in categories | filter:{_id :'!uncategorized'}\"> \r\n        <div class=\"ads-accordion-item-wrapper\">\r\n            <div class=\"checkbox checkbox-primary acordion-checkbox\" ng-class=\"{'open': category.open, 'disabled-checkbox':category.disabled, 'selected-child': hasCheckedDescendant(category)}\" ng-if=\"category.children && category.children.length > 0\">\r\n                <input type=\"checkbox\" ng-model=\"category.open\" id=\"category-open-{{category._id}}\">\r\n                <label for=\"category-open-{{category._id}}\" ng-if=\"!category.disabled\"></label>\r\n                <label for=\"category-open-{{category._id}}\" ng-if=\"category.disabled\">{{category.name}}</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary\" ng-if=\"!category.disabled\">\r\n                <input type=\"checkbox\" ng-model=\"category.checked\" id=\"category-checked-{{category._id}}\">\r\n                <label for=\"category-checked-{{category._id}}\">{{category.name}}</label>\r\n            </div>\r\n            <div class=\"clickable clickable-danger remove pull-right\" ng-click=\"removeItem(category._id)\" ng-if=\"category.ancestors.length==0\"><span>&times;</span></div> \r\n        </div>\r\n        <ads-category-accordion ng-if=\"category.children && category.children.length>0\" categories=\"category.children\" open=\"category.open\"></ads-category-accordion>\r\n    </li>\r\n</ul>"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget ads-settings-wrapper\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Ads Settings</span></h1>\r\n  <a class=\"btn btn-primary pull-right margin-bottom-20\" ng-click=\"vmas.save()\">Save Settings</a>\r\n  <section class=\"single-post--widget widget publish full-branding-settings-widget margin-bottom-20\" ng-repeat=\"ad in vmas.positions track by ad.id\" ng-if=\"vmas.positions.length>0\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">{{ad.name}}</h5>\r\n    </header>\r\n    <ad-item ad=\"ad\" categories=\"vmas.categories\" ng-if=\"ad && vmas.categories\"></ad-item>\r\n  </section>\r\n  <section class=\"single-post--widget widget publish margin-bottom-20\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Video Autoplay</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmas.video_autoplay\" id=\"video-autolay\"><label for=\"video-autolay\">ON</label>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <section class=\"single-post--widget widget publish margin-bottom-20\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Midas Display</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmas.midas_display\" id=\"midas-display\"><label for=\"midas-display\">ON</label>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <a class=\"btn btn-primary pull-right\" ng-click=\"vmas.save()\">Save Settings</a>\r\n</section>"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n    <ai-configuration-dir \r\n        ng-if=\"vmaac.configurationEdit\" \r\n        parent=\"vmaac\">\r\n    </ai-configuration-dir>\r\n\r\n    <div ng-if=\"!vmaac.configurationEdit\">\r\n        <h1 class=\"page-title\">\r\n            <span ng-show=\"!vmaac.myPosts\">All&nbsp;</span>\r\n            <span class=\"fw-semi-bold\">Configurations</span>&nbsp;\r\n            <a data-ui-sref=\"app.ai_create_config\" class=\"btn btn-primary\">Create Configuration</a>\r\n        </h1>\r\n\r\n        <div class=\"ai-all-configurations\">\r\n            <!-- Status Filter Section -->\r\n            <div class=\"status-filter\">\r\n                <ul>\r\n                    <li>\r\n                        <a ng-click=\"vmaac.changeStatus($event, 'all')\" \r\n                           class=\"clickable\" \r\n                           ng-class=\"{'active':vmaac.status =='all'}\">All</a> |\r\n                    </li>\r\n                    <li>\r\n                        <a ng-click=\"vmaac.changeStatus($event, 'active')\" \r\n                           class=\"clickable\" \r\n                           ng-class=\"{'active':vmaac.status =='active'}\">Active</a> |\r\n                    </li>\r\n                    <li>\r\n                        <a ng-click=\"vmaac.changeStatus($event, 'inactive')\" \r\n                           class=\"clickable\" \r\n                           ng-class=\"{'active':vmaac.status =='inactive'}\">Inactive</a>\r\n                    </li>\r\n                </ul>\r\n                <div class=\"search\">\r\n                    <input type=\"search\" \r\n                           class=\"form-control\" \r\n                           placeholder=\"Search by name ...\"\r\n                           id=\"search-input\" \r\n                           ng-model=\"vmaac.searchData.name\" \r\n                           ng-change=\"vmaac.changeSearch(vmaac.searchData)\">\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Table Filter Section -->\r\n            <div class=\"table-filter\">\r\n                <select ng-model=\"vmaac.selectedFunctionality.value\" \r\n                        ng-change=\"vmaac.switchFunctionality(vmaac.selectedFunctionality.value)\" \r\n                        class=\"form-control\">\r\n                    <option value=\"all\">View all functionality</option>\r\n                    <option ng-repeat=\"functionality in vmaac.functionalityList\" \r\n                            value=\"{{functionality._id}}\" \r\n                            ng-bind=\"functionality.name\">\r\n                    </option>\r\n                </select>\r\n                <a ng-click=\"vmaac.clearAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n            </div>\r\n            <!-- Items Count -->\r\n            <!-- <div class=\"italic\">\r\n                Number of items: <span class=\"fw-semi-bold\">{{vmaac.dataConfigurations.length}}</span>\r\n            </div> -->\r\n            <!-- Table Section -->\r\n            <div class=\"widget-body table-wrapper\">\r\n                <table ng-table=\"vmaac.tableParams\" \r\n                       class=\"table table-condensed table-bordered table-striped posts-table\">\r\n                    <tr ng-repeat=\"post in $data\" \r\n                        edit=\"post\" \r\n                        quick-edit \r\n                        category=\"vmaac.categoriesTreeInput\">\r\n                        <td data-title=\"'Name'\" class=\"ng-table--title\">\r\n                            <div class=\"title\">\r\n                                <span class=\"fw-semi-bold clickable\" ng-click=\"vmaac.editConfiguration(post._id)\">{{post.name}}</span>\r\n                            </div>\r\n                            <div class=\"title-actions\">\r\n                                <ul>\r\n                                  <li><span class=\"clickable\" ng-click=\"vmaac.editConfiguration(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                                  <li ng-if=\"!post.active\"><span class=\"clickable clickable-danger\" ng-click=\"vmaac.deleteConfiguration(post)\">Delete</span></li>\r\n                                </ul>\r\n                              </div>\r\n                        </td>\r\n                        <td data-title=\"'Functionality'\" class=\"ng-table--default\">\r\n                            <span>{{post.functionality}}</span>\r\n                        </td>\r\n                        <td data-title=\"'AI Provider'\" class=\"ng-table--default\">\r\n                            <span>{{post.aiProvider}}</span>\r\n                        </td>\r\n                        <td data-title=\"'Model'\" class=\"ng-table--default\">\r\n                            <span>{{post.model}}</span>\r\n                        </td>\r\n                        <td data-title=\"'Created At'\" class=\"ng-table--date\">\r\n                            <span>{{post.createdAt | date:'MMM dd, y HH:mm'}}</span>\r\n                        </td>\r\n                        <td data-title=\"'Temperature'\" class=\"ng-table--default text-center\">\r\n                            <span class=\"fw-semi-bold\">{{post.temperature}}</span>\r\n                        </td>   \r\n                        <td data-title=\"'Feedback'\" class=\"ng-table--default text-center\">\r\n                            <span class=\"fw-semi-bold success\">{{post.positive_feedback}}</span>\r\n                            <span>/</span>\r\n                            <span class=\"fw-semi-bold danger\">{{post.negative_feedback}}</span>\r\n                        </td>\r\n                        <td data-title=\"'Status'\" class=\"ng-table--status\">\r\n                            <span ng-show=\"post.active\" class=\"label label-success\">Active</span>\r\n                            <span ng-show=\"!post.active\" class=\"label label-danger\">Inactive</span>\r\n                        </td>\r\n                    </tr>\r\n                </table>\r\n\r\n                <!-- Empty Table Message -->\r\n                <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n                    <p>No result. Try again.</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>\r\n  \r\n  \r\n  \r\n  \r\n  "

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit\">\r\n\r\n    <div class=\"ai-configuration\">\r\n        <h1 ng-if=\"!vmaic.newConfiguration\" class=\"page-title\">Edit <span class=\"fw-semi-bold\">Configuration</span>&nbsp;<a data-ui-sref=\"app.ai_create_config\" class=\"btn btn-primary\">New Configuration</a><a ng-click=\"closeEditConfiguration()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditConfiguration()\" parametar=\"page\">&times;</a></h1>\r\n        <h1 ng-if=\"vmaic.newConfiguration\"class=\"page-title\">Add New <span class=\"fw-semi-bold\">Configuration</span></h1>\r\n        <div class=\"form-group\">\r\n          <label for=\"normal-field\" class=\"control-label\">Name:&nbsp;</label>\r\n            <input type=\"text\" \r\n                     id=\"normal-field\" \r\n                     class=\"form-control middle-align inline-block auto-width\" \r\n                     placeholder=\"Enter name\" \r\n                     ng-model=\"vmaic.configuration.name\"\r\n                     ng-readonly=\"!vmaic.newConfiguration\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label for=\"normal-field\" class=\"control-label\">AI functionality:&nbsp;</label>\r\n            <select ng-model=\"vmaic.selectedAiFunctionality.value\" class=\"form-control middle-align inline-block auto-width\" ng-class=\"{'readonly': !vmaic.newConfiguration}\">\r\n               <option value=\"none\" ng-disabled=\"!vmaic.newConfiguration\">Choose functionality</option>\r\n               <option ng-repeat=\"functionality in vmaic.functionalityList\" ng-bind=\"functionality.name\" value=\"{{functionality._id}}\" ng-disabled=\"!vmaic.newConfiguration\"></option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label for=\"normal-field\" class=\"control-label\">AI provider:&nbsp;</label>\r\n            <select ng-model=\"vmaic.selectedAiProvider.value\" ng-change=\"vmaic.switchAiProvider(vmaic.selectedAiProvider.value)\" class=\"form-control middle-align inline-block auto-width\">\r\n                <option value=\"none\">Choose provider</option>\r\n                <option ng-repeat=\"provider in vmaic.providerList\" ng-bind=\"provider.name\" value=\"{{provider.name}}\"></option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-group flex-display\">\r\n            <label for=\"normal-field\" class=\"control-label margin-bottom-0\">AI provider model:&nbsp;</label>\r\n            <select ng-model=\"vmaic.selectedAiModel.value\" class=\"form-control middle-align inline-block auto-width\">\r\n                <option value=\"none\">Choose model</option>\r\n                <option ng-repeat=\"model in vmaic.modelList\" ng-bind=\"model.name\" value=\"{{model.name}}\"></option>\r\n            </select>\r\n            <div class=\"input-group flex-display margin-left-10\">\r\n                <input type=\"text\" class=\"form-control auto-width\" ng-model=\"vmaic.newModelName\" placeholder=\"Add new model..\" ng-keypress=\"($event.keyCode === 13) ? vmaic.addNewModel() : null\" ng-class=\"{'error-border': vmaic.newModelNameRequired}\" ng-focus=\"vmaic.newModelNameRequired = false\">\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmaic.addNewModel()\">Add</button>\r\n                </span>\r\n            </div>\r\n        </div>\r\n        <div class=\"form-group input-group-no-border\">\r\n            <label for=\"search-input\">Ai temperature:&nbsp;</label>\r\n            <div class=\"input-group middle-align inline-block\"><input type=\"text\" class=\"form-control\" ng-model=\"vmaic.configuration.temperature\" ng-keypress=\"vmaic.keyPressOnlyNumberAndDot($event)\"></div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label for=\"normal-field\" class=\"control-label\">Messages:&nbsp;</label>\r\n            <div ng-repeat=\"message in vmaic.configuration.extraSettings.messages track by $index\" class=\"messages-wrapper form-group position-relative\">\r\n                <label for=\"normal-field\" class=\"control-label fw-semi-bold\">{{$index+1}}.</label>\r\n                <div class=\"margin-bottom-10\">\r\n                    <label for=\"normal-field\" class=\"control-label\">role:&nbsp;</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"message.role\" placeholder=\"Enter role...\">\r\n                </div>\r\n                <div class=\"margin-bottom-10\">\r\n                    <label for=\"normal-field\" class=\"control-label\">vars:&nbsp;</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"message.conditionVars\" placeholder=\"Enter vars...\">\r\n                </div>\r\n                <div class=\"margin-bottom-10\">\r\n                    <label for=\"normal-field\" class=\"control-label\">content:&nbsp;</label>\r\n                    <textarea type=\"text\" class=\"form-control textarea-md\" ng-model=\"message.content\" placeholder=\"Enter content...\"></textarea>\r\n                </div>\r\n                <a ng-click=\"vmaic.removeMessage(message)\" class=\"clickable-danger remove-item fw-semi-bold\">&times;</a>\r\n            </div>\r\n            <div class=\"overflow-hidden\">\r\n                <div class=\"pull-left italic margin-top-5\" ng-if=\"vmaic.configuration.extraSettings.messages.length == 0\">\r\n                    <label for=\"normal-field\" class=\"control-label\">No messages added yet.</label>\r\n                </div>\r\n                <a ng-click=\"vmaic.addNewMessage()\" class=\"btn btn-primary pull-right\">Add new message</a>\r\n            </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmaic.configuration.active\" id=\"active\" ng-disabled=\"!vmaic.newConfiguration && vmaic.initialStatus\"><label for=\"active\">Active</label>\r\n            </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <a ng-click=\"vmaic.updateConfiguration()\" class=\"btn btn-primary\"><span ng-show=\"vmaic.newConfiguration\">Create</span><span ng-show=\"!vmaic.newConfiguration\">Update</span> Configuration</a>\r\n        </div>\r\n    </div> \r\n  </section>\r\n  "

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n    <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Approvals</span></h1>\r\n    <div class=\"all-approvals\">\r\n       <div class=\"status-filter\">\r\n         <ul>\r\n           <li><a ng-click=\"vmaa.changeStatus('all')\" class=\"clickable\" ng-class=\"{'active':vmaa.status =='all'}\">All</a> |</li>\r\n           <li><a ng-click=\"vmaa.changeStatus('post')\" class=\"clickable\" ng-class=\"{'active':vmaa.status == 'post'}\">Post</a> |</li>\r\n           <li><a ng-click=\"vmaa.changeStatus('photo')\" class=\"clickable\" ng-class=\"{'active':vmaa.status == 'photo'}\">Photo</a> |</li>\r\n           <li><a ng-click=\"vmaa.changeStatus('video')\" class=\"clickable\" ng-class=\"{'active':vmaa.status == 'video'}\">Video</a></li>\r\n         </ul>\r\n         <div class=\"search\"><div class=\"input-group\"><input type=\"search\" placeholder=\"Enter Title or Document Id ...\" class=\"form-control\" id=\"search-input\" ng-model=\"vmaa.searchData\" ng-change=\"vmaa.changeSearch(vmaa.searchData)\" ng-enter=\"vmaa.search(vmaa.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmaa.search(vmaa.searchData);\">Search</button></span></div></div>\r\n       </div>\r\n       <div class=\"table-filter\">\r\n        <div class=\"form-group range-picker margin-top-0\">\r\n            <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmaa.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n        </div>\r\n        <select ng-model=\"vmaa.selectedUserFilter.value\" ng-change=\"vmaa.switchUserFilter(vmaa.selectedUserFilter.value)\" class=\"form-control\">\r\n           <option value=\"all\">View all authors</option>\r\n           <option ng-repeat= \"author in vmaa.usersList\" value=\"{{author._id}}\">{{author.display_name}} ({{author._id}})</option>\r\n        </select>\r\n        <a ng-click=\"vmaa.mediaFilters()\" class=\"btn btn-primary\">Filter</a>\r\n        <a ng-click=\"vmaa.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n       </div>\r\n       <div class=\"widget-body table-wrapper\">\r\n         <table ng-table=\"vmaa.tableParams\" class=\"table table-condensed table-bordered table-striped\">\r\n           <tr ng-repeat=\"approval in $data\" quick-edit edit=\"post\" class=\"post-row\">\r\n            <td data-title=\"'Title'\" class=\"ng-table--title\">\r\n              <div class=\"title\">\r\n                <span class=\"fw-semi-bold\">{{approval.title}}</span> \r\n              </div>\r\n              <!-- <div class=\"title-actions\">\r\n                <ul>\r\n                  <li><span class=\"clickable clickable-danger\" ng-click=\"vmaa.deleteApproval(approval._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                </ul>\r\n              </div> -->\r\n           </td>\r\n            <td data-title=\"'Author'\" class=\"ng-table--author\">\r\n                <span ng-click=\"vmaa.userApproval(approval.user._id)\" class=\"clickable\">{{approval.user.display_name}}</span>\r\n            </td>\r\n            <td data-title=\"'date'\" class=\"ng-table--date\">\r\n                 <span ng-click=\"\">{{approval.date | date:'medium'}}</span>\r\n            </td>\r\n            <td data-title=\"'Type'\" class=\"ng-table--id text-transfomr-ca\">\r\n                <span ng-click=\"vmaa.typeApproval(approval.type)\" class=\"clickable\">{{approval.type}}</span>\r\n            </td>\r\n            <td data-title=\"'document id'\" class=\"ng-table--document_id\">\r\n                <ul>\r\n                    <li ng-repeat = \"id in approval.document_ids\" class=\"clickable inline\"><a ng-href=\"{{vmaa.getUiSref(approval,id)}}\">{{id}}</a><span class=\"coma\">,&nbsp;</span></li>\r\n                </ul>    \r\n            </td>\r\n            <td data-title=\"'approval'\" class=\"ng-table--approval\">\r\n               <img src=\"images/download.svg\" alt=\"\" title = \"Download\" ng-if=\"approval.url\" ng-click=\"vmaa.downloadApproval(approval)\">\r\n            </td>\r\n           </tr>\r\n         </table>\r\n        <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n           <p>No result. Try again.</p>\r\n        </div>\r\n        </div> \r\n    </div>\r\n</section>\r\n   "

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  \r\n  <h1 class=\"page-title\">All <span ng-if=\"!vmac.commentsType\" class=\"fw-semi-bold\">Post </span><span ng-if=\"vmac.commentsType\" class=\"fw-semi-bold\">Video </span>Comments</h1>\r\n\r\n  <div class=\"all-posts all-comments\">\r\n  <div class=\"status-filter\">\r\n    <ul>\r\n      <li><a ng-click=\"vmac.changeStatus($event, 'pending')\" ng-class=\"{'active':vmac.status =='pending'}\" class=\"clickable\">Pending</a> |</li>\r\n      <li><a ng-click=\"vmac.changeStatus($event, 'approved')\" ng-class=\"{'active':vmac.status =='approved'}\" class=\"clickable\">Approved</a> |</li>\r\n      <li><a ng-click=\"vmac.changeStatus($event, 'spam')\" ng-class=\"{'active':vmac.status =='spam'}\" class=\"clickable\">Spam</a> |</li>\r\n      <li><a ng-click=\"vmac.changeStatus($event, 'trashed')\" ng-class=\"{'active':vmac.status =='trashed'}\" class=\"clickable\">Trash</a></li>\r\n    </ul>\r\n    <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmac.searchData\" ng-keypress=\"vmac.changeSearch($event)\" ng-enter=\"vmac.searchComment(vmac.searchData);\" ng-attr-placeholder=\"{{vmac.commentsType? 'Enter Video ID':'Enter Post ID'}}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmac.searchComment(vmac.searchData);\">Search</button></span></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"table-filter\">\r\n    <div class=\"bulk-actions\">\r\n      <select ng-model=\"vmac.selectedBulkAction.value\" ng-change=\"vmac.switchBulkAction(vmac.selectedBulkAction.value)\" class=\"form-control\">\r\n        <option value=\"default\">Bulk Actions</option>\r\n        <option value=\"pending\" ng-if=\"vmac.statusApproved\">Unapproved</option>\r\n        <option value=\"approved\" ng-if=\"!vmac.statusApproved && !vmac.statusTrash\">Approved</option>\r\n        <option value=\"spam\" ng-if=\"!vmac.statusTrash\">Mark as Spam</option>\r\n        <option value=\"pending\" ng-if=\"vmac.statusTrash\">Restore</option>\r\n        <option value=\"delete\" ng-if=\"vmac.statusTrash\">Delete</option>\r\n        <option value=\"trashed\" ng-if=\"!vmac.statusTrash\">Move to Trash</option>\r\n      </select>\r\n      <a ng-click=\"vmac.bulkAction(vmac.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n    </div>\r\n    <!-- <div class=\"form-group clear-both float-left margin-bottom-0\" ng-if=\"!vmac.commentsType\">\r\n      <label for=\"\" class=\"float-left margin-bottom-0\">Priority:&nbsp;</label>\r\n      <select ng-model=\"vmac.selectedPriorityFilter.value\" ng-change=\"vmac.switchPriorityFilter(vmap.selectedPriorityFilter.value)\" class=\"form-control\">\r\n        <option value=\"all\">All</option>\r\n        <option value=\"0\">Low</option>\r\n        <option value=\"1\">Medium</option>\r\n        <option value=\"2\">High</option>\r\n      </select>\r\n    </div> -->\r\n  </div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmac.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\">\r\n          <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmac.checkboxes.items[post.comment_ID]\" ng-change=\"vmac.checkedPost(post.comment_ID,vmac.checkboxes.items[post.comment_ID])\"/><label></label>\r\n            </div>\r\n          </td>\r\n          <td header=\"'ng-table/headers/priority.html'\" class=\"text-center\" ng-if=\"!vmac.commentsType\">\r\n            <span class=\"comment-priority\" ng-class=\"[(post.document.comments_priority && post.document.comments_priority>0)? 'comments-priority-' + post.document.comments_priority:'']\">!</span>\r\n          </td>\r\n          <td data-title=\"'Author'\" class=\"ng-table--author comments_author\">\r\n            <div class=\"fw-semi-bold\" ng-bind-html=\"post.comment_author\"></div>\r\n            <div>{{post.comment_author_email}}</div>\r\n            <div>{{post.comment_author_IP}}</div>\r\n            <div ng-show=\"post.document.moderator_guide\" class=\"moderator_guide_text\">\r\n              <label>Moderator's guide:</label> \r\n              <span class=\"fw-semi-bold\">{{post.document.moderator_guide}}</span>\r\n            </div>   \r\n          </td>\r\n          <td data-title=\"'Comment'\" class=\"ng-table--title comment_title\">\r\n            <div class=\"title\">\r\n              <div>Submited on {{post.timestamp*1000 | date:'MM dd, y HH:mm'}} <span ng-if=\"vmac.parrent[post.comment_ID]\">| in reply to <span class=\"italic\">{{post.parrent.comment_author}}</span>\r\n              <div class=\"italic\">\"{{post.parrent.comment_content}}\"</div>\r\n              </span></div>\r\n              <div class=\"fw-semi-bold\" ng-bind-html=\"post.comment_content\"></div>\r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li ng-if=\"!vmac.statusApproved && !vmac.statusTrash\"><span class=\"clickable\" ng-click = \"vmac.updateStatusPost(post.comment_ID, 'approved');\">Approve</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"vmac.statusTrash\"><span class=\"clickable\" ng-click = \"vmac.updateStatusPost(post.comment_ID, 'pending');\">Restore</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"vmac.statusApproved\"><span class=\"clickable\" ng-click = \"vmac.updateStatusPost(post.comment_ID, 'pending');\">Unapprove</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"!vmac.statusTrash\"><span class=\"clickable clickable-danger\" ng-click=\"vmac.updateStatusPost(post.comment_ID,'spam');\">Spam</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"!vmac.statusTrash\"><span class=\"clickable clickable-danger\" ng-click=\"vmac.updateStatusPost(post.comment_ID,'trashed');\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"vmac.statusTrash && vmac.adminPermisions\"><span class=\"clickable clickable-danger\" ng-click=\"vmac.updateStatusPost(post.comment_ID, 'delete');\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'In response To'\" class=\"ng-table--comments-post\">\r\n            <div class=\"fw-semi-bold clickable\" ng-if=\"role_id!='comments-moderator'\" ng-click=\"vmac.goToPost(post.document.id)\">{{post.document.title}}</div>\r\n            <div class=\"fw-semi-bold\" ng-if=\"role_id=='comments-moderator'\">{{post.document.title}}</div>\r\n            <a ng-href=\"{{post.document.url}}\" class=\"clickable\" target=\"_blank\">View <span ng-if=\"!vmac.commentsType\">Post</span><span ng-if=\"vmac.commentsType\">Video</span></a>\r\n            <a class=\"clickable\" ng-click=\"vmac.searchComment(post.document.id)\">See all comments</a>  \r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmac.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\" /><label></label>\r\n        </div>\r\n      </script>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/priority.html\">\r\n        <span class=\"comment-priority\">!</span>\r\n      </script>\r\n  </div>\r\n</div>\r\n<search-comments ng-if=\"vmac.serchCommentsModalShow\" obj=\"vmac\"><search-comments>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Comments (<span ng-if=\"!obj.commentsType\">Post</span><span ng-if=\"obj.commentsType\">Video</span> ID = {{obj.commentPostId}}) <span class=\"comment-priority\" ng-class=\"[(commentsPriority>0)? 'comments-priority-' + commentsPriority:'']\">!</span></h2>\r\n       <div ng-click=\"obj.closeSearchComment()\" ng-escape=\"obj.closeSearchComment()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content\">\r\n        <div class=\"search-comment-modal\">\r\n        <div class=\"status-filter\">\r\n          <ul>\r\n            <li><a ng-click=\"changeStatus($event, 'pending')\" ng-class=\"{'active':status =='pending'}\" class=\"clickable\">Pending</a> |</li>\r\n            <li><a ng-click=\"changeStatus($event, 'approved')\" ng-class=\"{'active':status =='approved'}\" class=\"clickable\">Approved</a> |</li>\r\n            <li><a ng-click=\"changeStatus($event, 'spam')\" ng-class=\"{'active':status =='spam'}\" class=\"clickable\">Spam</a> |</li>\r\n            <li><a ng-click=\"changeStatus($event, 'trashed')\" ng-class=\"{'active':status =='trashed'}\" class=\"clickable\">Trash</a></li>\r\n          </ul>\r\n          <div class=\"search\" ng-if=\"vmac.statusApproved\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmac.searchData\" ng-keypress=\"vmac.changeSearch($event)\" ng-enter=\"vmac.searchComment(vmac.searchData);\" placeholder=\"Enter post ID\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmac.searchComment(vmac.searchData);\">Search</button></span></div>\r\n          </div>\r\n        </div> \r\n        <table class=\"table table-condensed table-bordered table-striped ng-table posts-table\" ng-show=\"!emptyTable\">\r\n        <tr ng-repeat=\"post in postComments\">\r\n        <td data-title=\"'Author'\" class=\"ng-table--author comments_author\">\r\n              <div class=\"fw-semi-bold\" ng-bind-html=\"post.data.comment_author\"></div>\r\n              <div>{{post.data.comment_author_email}}</div>\r\n              <div>{{post.data.comment_author_IP}}</div>\r\n              <div ng-show=\"moderator_guide\" class=\"moderator_guide_text\">\r\n                <label>Moderator's guide:</label> \r\n                <span class=\"fw-semi-bold\">{{moderator_guide}}</span>\r\n              </div>    \r\n          </td>\r\n        <td data-title=\"'Comment'\" class=\"ng-table--title comment_title\">\r\n          <div class=\"title\">\r\n            <div class=\"fw-semi-bold mobile-width\">{{post.data.comment_author}}</div>\r\n            <div class = \"mobile-width\">{{post.data.comment_author_email}}</div>\r\n            <div class = \"mobile-width\">{{post.data.comment_author_IP}}</div>\r\n            <hr class = \"mobile-width\"> \r\n            <div>Submited on {{post.timestamp*1000 | date:'MMM d, y H:mm'}}</div>\r\n            <div ng-bind-html=\"post.data.comment_content\"></div>\r\n          </div>\r\n          <div class=\"title-actions\">\r\n            <ul>\r\n              <li ng-if=\"status=='pending'\"><span class=\"clickable\" ng-click = \"updateStatusPost(post.data.comment_ID, 'approved')\">Approve</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"status=='trashed' || status=='spam'\"><span class=\"clickable\" ng-click = \"updateStatusPost(post.data.comment_ID, 'pending')\">Restore</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"status=='approved'\"><span class=\"clickable\" ng-click = \"updateStatusPost(post.data.comment_ID, 'pending')\">Unapprove</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"status!='trashed' && status!='spam'\"><span class=\"clickable clickable-danger\" ng-click=\"updateStatusPost(post.data.comment_ID,'spam')\">Spam</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"status!='trashed'\"><span class=\"clickable clickable-danger\" ng-click=\"updateStatusPost(post.data.comment_ID,'trashed')\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"status=='trashed' && adminPermisions\"><span class=\"clickable clickable-danger\" ng-click=\"updateStatusPost(post.data.comment_ID, 'delete')\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n            </ul>\r\n          </div>\r\n        </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget highlight-words\">\r\n    <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Highlight Words</span></h1>   \r\n    <div class=\"highlight-words\">\r\n        <a ng-click=\"vmhwc.saveChanges()\" class=\"btn btn-primary pull-right\">Save Changes</a>\r\n        <div class=\"form-group\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmhwc.highlightWordsCheckbox\" id=\"highlight-words-checkbox\"><label for=\"highlight-words-checkbox\">Highlighting</label>\r\n            </div>\r\n        </div>\r\n        <div class=\"table-actions\">\r\n            <div class=\"form-group search-wrapper\">\r\n                <div class=\"input-group\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vmhwc.newHighlightWord\" ng-enter=\"vmhwc.addNewHighlightWord(vmhwc.newHighlightWord)\">\r\n                    <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmhwc.addNewHighlightWord(vmhwc.newHighlightWord)\">Add new word</button></span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group search\">\r\n                <input placeholder=\"Search highlight words ...\" type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmhwc.searchData\" ng-change=\"vmhwc.changeSearch(vmhwc.searchData)\">\r\n            </div>\r\n        </div>\r\n        <div class=\"highlight-words-list-wrapper\">\r\n            <ul class=\"highlight-words-list\" ng-repeat=\"column in vmhwc.highlightWordsArrayPrepared\" ng-show=\"!vmhwc.noSerachResult && vmhwc.highlightWordsArray && vmhwc.highlightWordsArray.length>0\">\r\n                <li ng-repeat=\"item in column track by item.index\"><span class=\"text-center\">{{item.index}}</span><span>{{item.word}}</span><span ng-click=\"vmhwc.removeWord(item.index)\" class=\"text-center clickable clickable-danger\">x</span></li>\r\n            </ul>\r\n            <div class=\"empty-table\" ng-show=\"vmhwc.noSerachResult\">\r\n                <p>No search result.</p>\r\n            </div> \r\n            <div class=\"empty-table\" ng-show=\"!vmhwc.highlightWordsArray || vmhwc.highlightWordsArray.length==0\">\r\n                <p>No highlight words.</p>\r\n            </div> \r\n        </div>\r\n        <a ng-click=\"vmhwc.saveChanges()\" class=\"btn btn-primary pull-right\">Save Changes</a>\r\n    </div>\r\n  </section>"

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget dashboard\">\r\n\t<h1 class=\"page-title\"><span class=\"fw-semi-bold\">dashboard</span></h1>\r\n  <section class=\"single-post--widget widget publish websites-script-version\" ng-if=\"vmd.superPermisions\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Websites script version</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"form-group input-group-no-border\">\r\n        <label>Eklinika.Telegraf.rs&nbsp;</label>\r\n        <div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmd.config.www_script_version\" ng-keypress=\"vmd.keyPressOnlyNumberAndDot($event)\" ng-class=\"{'error-border':vmd.www_script_versionRequired}\" ng-focus=\"vmd.www_script_versionRequired = false;\"></div>\r\n      </div>\r\n    </div>\r\n    <footer class=\"bg-body-light bt\">\r\n        <a href=\"\" class=\"btn btn-primary\" ng-click=\"vmd.scriptVersionUpdate()\">Save</a>\r\n    </footer>\r\n  </section>\r\n  <!-- <section class=\"single-post--widget widget publish black-theme\" ng-if=\"vmd.adminPermisions\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Black Theme</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmd.blackTheme\" id=\"black-theme\" ng-change=\"vmd.blackThemeChange(vmd.blackTheme)\"><label for=\"black-theme\">ON</label>\r\n      </div>\r\n      <div class=\"range-picker\" ng-if=\"vmd.blackTheme\">\r\n        <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmd.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n    </div>\r\n    </div>\r\n    <footer class=\"bg-body-light bt\">\r\n      <a href=\"\" class=\"btn btn-primary\" ng-click=\"vmd.blackThemeUpdate()\">Save</a>\r\n  </footer> -->\r\n  <!-- </section> -->\r\n\t<!-- <section class=\"single-post--widget widget publish\" ng-if=\"vmd.adminPermisions\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Refresh latest posts</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <a class=\"btn btn-primary\" ng-click=\"vmd.refreshLatestPost()\">Refresh</a>\r\n    </div>\r\n  </section>\r\n  <section class=\"single-post--widget widget publish\" ng-if=\"vmd.adminPermisions\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Mobile</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <a class=\"btn btn-primary\" ng-click=\"vmd.refreshMobile()\">Refresh</a>\r\n    </div>\r\n  </section> -->\r\n  <section class=\"single-post--widget widget publish\" ng-if=\"vmd.adminPermisions\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\">Third-party scripts</h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmd.thirdparty\" id=\"third-party\" ng-change=\"vmd.thirdpartyChange()\"><label for=\"third-party\">ON</label>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</section>\r\n\r\n<!-- <section class=\"widget\">\r\n  <h2 class=\"real-time-analitics-title\">Real-time Analytics</h2>\r\n  <div class=\"isp-chart-wrapper isp-chart-lazy\" ng-repeat=\"isp in vmd.config.isp.labels\"  id=\"{{isp}}\">\r\n    <h3 class=\"isp-chart-title\">{{vmd.getIspTitle(isp)}}</h3>\r\n    <div class=\"isp-chart isp-chart-{{isp}}\">\r\n      <hc-chart options=\"vmd.chartOptions[isp]\" ng-if=\"vmd.loadAnalytics[isp]\" class=\"hc-chart\" id=\"hc-chart-{{isp}}\"></hc-chart>\r\n      <div class=\"lazy-loading\" ng-show=\"!vmd.loadAnalytics[isp]\">\r\n        <div class=\"image-wrapper\">\r\n          <img src=\"images/ajax-loader.svg\" alt=\"Loding\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"hc-chart-zoom-wrapper\" ng-if=\"vmd.config.isp.zoom.length>0 && vmd.loadAnalytics[isp]\">\r\n      <ul>\r\n        <li ng-repeat=\"zoom in vmd.config.isp.zoom\" ng-click=\"vmd.redrawChart($event, zoom, isp)\"><a ng-class=\"(zoom=='30m')? 'active':false\">{{zoom}}</a></li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</section> -->\r\n"

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"sign-in-form form-signin\">\r\n    <h2 class=\"form-signin-heading\"><div class=\"login-logo\"></div><div>Dashboard</div></h2>\r\n    <form class=\"\" novalidate  name=\"userForm\">\r\n        <div class=\"form-group\">\r\n            <label>User name</label>\r\n            <br>\r\n            <input type=\"text\" class=\"form-control\" placeholder = \"User name\" ng-model=\"vml.userName\" name=\"username\" ng-class=\"{'weak':!signIn}\" required>\r\n            <p ng-show=\"submitted && userForm.username.$error.required\" class=\"help-block\">You name is required.</p>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label>Password</label>\r\n            <br>\r\n            <input type=\"password\" class=\"form-control\" placeholder = \"Password\" ng-model=\"vml.password\" name=\"password\" ng-class=\"{'weak':!signIn}\" required>\r\n            <p ng-show=\"submitted && userForm.password.$error.required\" class=\"help-block\">Your password is required.</p>\r\n        </div>\r\n        <button class=\"btn btn-default\" type=\"submit\" ng-click=\"submit($event)\">Sign In</button>\r\n    </form>\r\n</div>\r\n<div class=\"alert-wrapper login\" ng-class=\"{'show':alert.show}\">\r\n\t<div ng-repeat=\"alert in alerts\" class= \"alert alert-{{alert.type}} animated\" ng-class=\"{'fadeIn':alert.show, 'fadeOut':!alert.show}\">\r\n    <div class=\"image-wrapper\">\r\n    </div>\r\n    <div class=\"alert-content\">\r\n      <span class=\"alert-type\">\r\n        <strong>{{alert.title}}</strong>\r\n      </span>\r\n      <span style=\"white-space: pre-line;\">{{alert.message}}</span>\r\n    </div>\r\n    <div class=\"close-alert\" ng-show=\"alert.close\" ng-click=\"closeAlert(alert.id)\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"alert-wrapper-overlay\" ng-if=\"alertShow\"></div>\r\n</div>\r\n\r\n\r\n\r\n"

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget all-logs\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">logs</span></h1>\r\n    <div class=\"table-filter\">\r\n      <div class=\"bulk-actions\">\r\n        <select ng-model=\"vmlg.selectedUser.value\" ng-change=\"vmlg.switchUser(vmlg.selectedUser.value)\" class=\"form-control\">\r\n          <option value=\"default\">Select user</option>\r\n          <option value=\"{{user.email}}\" ng-repeat=\"user in vmlg.allUsers\">{{user.display_name}} ({{user._id}})</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"form-group range-picker\" >\r\n          <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmlg.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n      </div>\r\n      <select ng-model=\"vmlg.selectedMethod.value\" ng-change=\"vmlg.switchMethod(vmlg.selectedMethod.value)\" class=\"form-control\">\r\n        <option value=\"default\">Select method</option>\r\n        <option value=\"PUT\">PUT</option>\r\n        <option value=\"POST\">POST</option>\r\n        <option value=\"DELETE\">DELETE</option>\r\n      </select>\r\n      <div class=\"input-field\">\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"vmlg.bodyLog\" placeholder=\"Various\" ng-enter=\"vmlg.postFilter()\">\r\n      </div>\r\n      <div class=\"input-field\">\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"vmlg.pathLog\" placeholder=\"Path\" ng-enter=\"vmlg.postFilter()\">\r\n      </div>\r\n      <a ng-click=\"vmlg.postFilter()\" class=\"btn btn-primary\">Filter</a>\r\n      <a ng-click=\"vmlg.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n </div>\r\n     <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmlg.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\" ng-click=\"vmlg.logModalOpen(post)\">\r\n          <td data-title=\"'Method'\" class=\"ng-table--method\">\r\n            <div class=\"fw-semi-bold\">{{post._source.method}}</div>\r\n          </td>\r\n          <td data-title=\"'Path'\" class=\"ng-table--path\">\r\n            <div class=\"fw-semi-bold\">{{post._source.path}}</div>\r\n          </td>\r\n          <td data-title=\"'User'\" class=\"ng-table--user\">\r\n            <div class=\"fw-semi-bold\">{{post._source.user}}</div>  \r\n          </td>\r\n          <td data-title=\"'Date'\" class=\"ng-table--date\">\r\n            <span >{{post._source.uts | date:'MMM d, y H:mm:ss'}}</span>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <single-log ng-if=\"vmlg.logModalShow\" obj=\"vmlg\"></single-log>\r\n</section>\r\n"

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Log ( {{obj.logObj._id}} )</h2>\r\n       <div ng-click=\"obj.closeLogs()\" ng-escape=\"obj.closeLogs()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content\">\r\n        <div class=\"search-comment-modal\">\r\n          <div class=\"logs-table\">\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">Method:</span> {{obj.logObj._source.method}}</div>\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">Path:</span> {{obj.logObj._source.path}}</div>\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">User:</span> {{obj.logObj._source.user}}</div>\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">Date:</span> {{obj.logObj._source.uts | date:'MMM d, y H:mm:ss:sss'}}</div>\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">Body:</span> {{obj.logObj._source.body}}</div>\r\n            <div class=\"logs\"><span class=\"fw-semi-bold\">Header:</span> {{obj.logObj._source.header}}</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <h1 class=\"page-title\">Telegraf <span class=\"fw-semi-bold\">Focus News</span></h1>\r\n  <div class=\"microsites-page-wrapper\">\r\n    <search-post-dir parent-obj=\"vmmfn\"></search-post-dir>\r\n    <table class=\"table table-bordered margin-bottom-10\">\r\n      <thead>\r\n        <tr>\r\n        <th class=\"text-center\">ID</th>\r\n        <th>Image/Title</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody ng-show=\"vmmfn.macrositesFocusNewsObj._id\">\r\n        <tr\">\r\n          <td class=\"ng-table--id\">\r\n            <span class=\"margin-bottom-10 inline\">{{vmmfn.macrositesFocusNewsObj._id}}</span>\r\n          </td>\r\n          <td class=\"ng-table--title\">\r\n            <div class=\"media-image\">\r\n              <img ng-src=\"{{vmmfn.macrositesFocusNewsObj.image}}\" alt=\"{{vmmfn.macrositesFocusNewsObj.title}}\">\r\n            </div>\r\n            <div class=\"title-wrapp\">\r\n              <div class=\"title fw-semi-bold\">{{vmmfn.macrositesFocusNewsObj.title}}</div>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n      <tbody ng-show=\"!vmmfn.macrositesFocusNewsObj._id\">\r\n        <tr>\r\n          <td colspan=\"2\">No post.</td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n    <a ng-click=\"vmmfn.saveFocusNews()\" class=\"btn btn-primary pull-right\">Save changes</a>\r\n  </div>\r\n  </section>\r\n  \r\n  \r\n  \r\n  \r\n  \r\n  "

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Find post to attach media</h2>\r\n       <div ng-click=\"currentPostObj.cancelAttachToPostModal()\" ng-escape=\"currentPostObj.cancelAttachToPostModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content attach-to-post-modal\">\r\n        <div class=\"form-group search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"searchData\" ng-change=\"changeSearch(searchData)\" ng-enter=\"search(searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"search(searchData);\">Search</button></span></div></div>\r\n        <div class=\"table-wrapper\">\r\n          <table ng-table=\"tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n            <tr ng-repeat=\"post in $data\" edit=\"post\" ng-click=\"selectRow(post._id)\">\r\n              <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n                <div class=\"checkbox checkbox-primary\">\r\n                  <input type=\"checkbox\" ng-model=\"checkboxes.item[post._id]\" ng-click=\"updateSelection(post._id,checkboxes.item[post._id]); $event.stopPropagation();\"/><label></label>\r\n                </div>\r\n              </td>\r\n              <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">{{post._id}}</td>\r\n              <td data-title=\"'Title'\" sortable=\"'title'\" class=\"ng-table--title\">\r\n                <div class=\"title\">\r\n                  <span class=\"fw-semi-bold\">{{post.title}}</span>\r\n                </div>   \r\n              </td>\r\n              <td data-title=\"'Date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n                <span >{{post.date | date:'MMM d, y H:mm'}}</span>\r\n              </td>\r\n              <td data-title=\"'Status'\" class=\"ng-table--status\">\r\n                <span class=\"post-status\">{{post.status}}</span>\r\n              </td>\r\n            </tr>\r\n          </table>\r\n        </div>\r\n        <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n          <p>No result. Try again.</p>\r\n        </div>\r\n        <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            &nbsp;&nbsp;\r\n          </div>\r\n        </script>\r\n      </div>\r\n      <div class=\"library-modal-action\">\r\n          <a class=\"btn btn-primary pull-right\" ng-click=\"selectPostToAttachMedia()\">Select Post</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit-media\">\r\n  <h1 class=\"page-title\">Edit <span class=\"fw-semi-bold\">Photo</span>&nbsp;<a data-ui-sref=\"app.newmedia\" class=\"btn btn-primary\">New Photo</a><a ng-click=\"$root.closeEditMedia()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditMedia()\" parametar=\"page\">&times;</a></h1>\r\n    \r\n  <div class=\"form-group\"> \r\n    <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Enter title here\" ng-model=\"editMediaCurrent.title\">\r\n    <div class=\"required-error animate-show\" ng-show=\"titleRequired\">Title required</div>\r\n  </div>\r\n  <div class=\"single-post--columns-wraper\">\r\n    <div class=\"single-post--left-col\">\r\n      <div class=\"form-group\">\r\n        <div class=\"img-wrapper\">\r\n          <img ng-src=\"{{mainImage}}\" alt=\"{{editMediaCurrent.title}}\" class=\"main-image\">\r\n          <div class=\"forbiden-placeholder\" ng-if=\"editMediaCurrent.restrictions.locked\" title=\"Photo is locked\"></div>\r\n        </div>\r\n      </div>\r\n      <!-- <div class=\"form-group\">\r\n        <a href=\"\" class=\"btn btn-default\">Edit Image</a>\r\n      </div> -->\r\n      <div class=\"editing-details\">\r\n        <div class=\"form-group\">\r\n          <label>Signature</label> \r\n          <textarea ng-model=\"editMediaCurrent.signature\" class=\"form-control\"></textarea>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>Alternative Text</label>\r\n          <input type=\"text\"class=\"form-control\" ng-model=\"editMediaCurrent.image_alt\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label>Gallery title</label>\r\n            <textarea ng-model=\"editMediaCurrent.gallery_title\" class=\"form-control\"></textarea>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>Description</label>\r\n          <textarea ng-model=\"editMediaCurrent.description\" class=\"form-control\"></textarea>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>Author Url</label> \r\n          <input ng-model=\"editMediaCurrent.meta.signature_url\" class=\"form-control\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <div class=\"form-group checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"photoRestriction\"  id=\"photo-restriction\" ng-change=\"addPhotoRestriction()\">\r\n            <label for=\"photo-restriction\" ng-if=\"!photoRestriction\">Add Restrictions</label>\r\n            <label for=\"photo-restriction\" ng-if=\"photoRestriction\">Remove Restrictions</label>\r\n          </div>\r\n          <div ng-class=\"{'slideInFadeDown animated' : photoRestriction || approvalUrl}\" class=\"overflow-hidden form-group\" ng-if = \"photoRestriction\">\r\n            <div class=\"input-group-no-border form-group\">\r\n              <label for=\"\">Maximum utilization&nbsp;</label>\r\n              <input type=\"text\" class=\"form-control inline-block\" ng-model=\"numberOfUses.max\" ng-change = \"changeMaxUtilization()\" ng-blur = \"blurMaxUtilization()\" ng-class=\"{'error-border':numberOfUsesError}\" ng-keypress=\"onlyNumber($event)\">\r\n              <label class=\"required-error animate-show\" ng-show=\"numberOfUsesError\">Minimum number of utilization is {{numberOfUses.count}}</label>\r\n            </div>\r\n            <div class=\"form-group\" ng-show=\"numberOfUses.max || numberOfUses.count\">\r\n              <label for=\"\">Current utilization:&nbsp;</label>\r\n              <span class=\"fw-semi-bold\">{{numberOfUses.count}}</span>\r\n            </div>\r\n            <div class=\"form-group\" ng-show=\"numberOfUses.count > 0 && arrayOfPostsImageIncluded.length > 0\">\r\n              <label for=\"\">Included in posts:&nbsp;</label>\r\n                <span ng-repeat=\"post in arrayOfPostsImageIncluded\">\r\n                  <a class=\"clickable\" ng-href=\"#/posts/all?id={{post}}\">{{post}}</a><span ng-show=\"$index !=arrayOfPostsImageIncluded.length - 1\">,&nbsp;</span>\r\n                </span>\r\n            </div>\r\n            <div class=\"form-group range-picker range-picker-restriction\" >\r\n              <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Restrictions date range\" ranges=\"ranges\" ng-change = \"changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <section class=\"single-post--widget widget widget-approvals\" ng-if=\"editMediaCurrent\">\r\n          <header class=\"bb\">\r\n              <h5 class=\"fw-semi-bold\">Approvals</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <add-approval-dir parent=\"editMediaCurrent\" type=\"'photo'\"></add-approval-dir>\r\n          </div>\r\n        </section>\r\n        <!-- <div class=\"form-group\" ng-if=\"!approvalUrl && !approvalRemoved\">\r\n          <form class=\"dropzone\" options=\"media.dzOptionsRestriction\" callbacks=\"media.dzCallbacksRestriction\" methods=\"media.dzMethodsRestriction\" ng-dropzone ></form>\r\n        </div> -->\r\n        <!-- <div class=\"form-group\" ng-show=\"approvalRemoved\"> \r\n         <div class=\"alert alert-warning\">To remove an approval document click on update button</div>        \r\n        </div>\r\n        <div class=\"form-group\" ng-show=\"approvalUrl\">\r\n          <a ng-click=\"getPdf()\" class=\"btn btn-success\" ng-show=\"!approvalRemoved\">Download approval</a>\r\n          <a ng-click=\"removePdf()\" class=\"btn btn-danger\" ng-show=\"!approvalRemoved\">Remove approval</a>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n    <div class=\"single-post--right-col\">\r\n      <section class=\"single-post--widget widget publish\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Save</h5>\r\n        </header>\r\n        <div class=\"widget-body\">\r\n          <ul>\r\n            <li><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>&nbsp;Uploaded on: <span class=\"fw-semi-bold\">{{editMediaCurrent.date | date:'MMM d, y HH:mm'}}</span></li>\r\n            <li>File URL: <div>\r\n              <textarea ng-model=\"editMediaCurrent.file\" class=\"readonly form-control url-field\" readonly></textarea>\r\n            </div></li>\r\n            <!-- <li>File name: <span class=\"fw-semi-bold\"></span></li> -->\r\n            <li>File type: <span class=\"fw-semi-bold\">{{editMediaCurrent.mime}}</span></li>\r\n            <li>Dimensions: <span class=\"fw-semi-bold\">{{editMediaCurrent.meta.width}}x{{editMediaCurrent.meta.height}}</span></li>\r\n            <li class=\"download-image-wapper\">Download:<img width=\"30\" height=\"30\" src=\"images/download.png\" alt=\"Download images\" class=\"margin-left-10 clickable\" ng-click=\"downloadImage(editMediaCurrent)\" title=\"Download image\"></li>\r\n            <li>Photo status:&nbsp;\r\n              <div class=\"clickable lock-wrapper\">\r\n                  <img src=\"images/lock.svg\" alt=\"lock-image\" title = \"Unlock image\" ng-if=\"editMediaCurrent.status == 'lock'\" ng-click=\"changeMediaStatus(editMediaCurrent._id,'publish')\">\r\n                  <img src=\"images/unlock.svg\" alt=\"unlock-image\" title = \"Lock image\" ng-if=\"editMediaCurrent.status == 'publish'\" ng-click=\"changeMediaStatus(editMediaCurrent._id,'lock')\">\r\n              </div>\r\n            </li>\r\n            <li><div class=\"clickable\" ng-click=\"media.purgeCache(editMediaCurrent.filepath)\">Purge Cache</div></li>\r\n          </ul>\r\n          <!-- <div class=\"form-group\">\r\n              <div class=\"clickable clickable-success\" ng-click=\"unlockMedia(editMediaCurrent.file)\" ng-if=\"imageLocked\">Unlock media</div>\r\n            </div> -->\r\n        </div>\r\n        <footer class=\"bg-body-light bt\"><a class=\"clickable-danger\" ng-click=\"deleteMedia()\">Delete Permanently</a><button type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"updateMedia()\">Update</button></footer>\r\n      </section>\r\n      <section class=\"single-post--widget widget tags\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Tags</h5>\r\n        </header>\r\n        <div class=\"widget-body categories\">\r\n          <div class=\"form-group search-wrapper\">\r\n            <label for=\"search-input\">Add tag</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"searchtagfocus\" ng-keypress=\"searchPress($event)\" ng-enter=\"addNewTag(searchtagfocus)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addNewTag(searchtagfocus)\">Add</button></span></div>\r\n            <div class=\"required-error animate-show\" ng-show=\"newTagRequired\">New tag required</div>\r\n            <div class=\"required-error animate-show\" ng-show=\"existTag\">Tag alredy exist</div>\r\n            <ul class=\"list-tags\">\r\n              <li ng-repeat=\"tag in editMediaCurrent.tags\"><span class=\"remove-from-list\" ng-click=\"removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </section>\r\n      <section class=\"single-post--widget widget tags\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Crop thumbnail</h5>\r\n        </header>\r\n        <div class=\"widget-body\">\r\n          <div class=\"form-group \">\r\n              <a class=\"btn btn-primary pull-right\" ng-click=\"media.openCropModal(editMediaCurrent)\">Crop</a>\r\n          </div>\r\n        </div>\r\n      </section>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"template.html\">\r\n    <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n      <li ng-show=\"!showResult\">No result.</li>\r\n      <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.slug, tag._id)\" ng-show=\"showResult\">{{tag.slug}}</li>\r\n    </ul>\r\n  </script>\r\n</section>"

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n <media-edit-dir ng-if=\"vml.editMediaShow\" media=\"vml\"></media-edit-dir>\r\n <div ng-if=\"!vml.editMediaShow\">\r\n  <h1 class=\"page-title\">Photo <span class=\"fw-semi-bold\">Library</span>&nbsp;<a data-ui-sref=\"app.newmedia\" class=\"btn btn-primary\">Add New</a></h1>\r\n\r\n  <div class=\"media-library\">\r\n    <div class=\"status-filter\">\r\n      <ul>\r\n        <li><a ng-click=\"vml.changeStatus($event,'all')\" class=\"clickable\" ng-class=\"{'active':vml.status =='all'}\">All</a> |</li>\r\n        <li><a ng-click=\"vml.changeStatus($event, 0)\" class=\"clickable\" ng-class=\"{'active':vml.status == 0}\">Unattached</a></li>\r\n      </ul>\r\n      <div class=\"search\">\r\n        <div class=\"type-all checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" type=\"text\" ng-model=\"vml.checkedTypeSearch\" id=\"search-type-all\">\r\n          <label for=\"search-type-all\">Search in all fields</label>\r\n        </div>\r\n        <div class=\"search-wrapper\">\r\n          <div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vml.searchData\" ng-change=\"vml.changeSearch(vml.searchData)\" ng-enter=\"vml.search(vml.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vml.search(vml.searchData);\">Search</button></span></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"table-filter\">\r\n      <div class=\"change-preview\">\r\n        <a ng-click=\"vml.showGrid=false;vml.selectedImage = -1;\"><i class=\"fa fa-table\" aria-hidden=\"true\" ng-class=\"{'active':!vml.showGrid}\"></i></a>\r\n        <a ng-click=\"vml.showGrid=true;vml.getGrid();vml.selectedImage = -1;\"><i class=\"fa fa-th\" aria-hidden=\"true\" ng-class=\"{'active':vml.showGrid}\"></i></a>\r\n      </div>\r\n      <div class=\"bulk-actions\">\r\n        <select ng-model=\"vml.selectedBulkAction.value\" ng-change=\"vml.switchBulkAction(vml.selectedBulkAction.value)\" class=\"form-control\">\r\n          <option value=\"default\">Bulk Actions</option>\r\n          <option value=\"edit\">Edit</option>\r\n          <option value=\"addRestrictions\">Add Restrictions</option>\r\n          <option value=\"removeRestrictions\">Remove Restrictions</option>\r\n          <option value=\"uploadApprovalRestrictions\">Upload Approval</option>\r\n          <option value=\"attach\">Attach</option>\r\n          <option value=\"detach\">Detach</option>\r\n          <option value=\"lock\">Lock</option>\r\n          <option value=\"publish\">Unlock</option>\r\n          <option value=\"delete\">Delete</option>\r\n        </select>\r\n        <a ng-click=\"vml.bulkAction(vml.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n      </div>\r\n      <div class=\"bulk-actions-edit\" ng-show=\"!vml.hiddenBulkEdit\">\r\n        <div class=\"bulk-action-edit--wrapper\">\r\n          <div class=\"bulk-actions-edit--title\" ng-class=\"{'add-restrictions-bulk-title':vml.addRestrictions}\">\r\n            <h2 class=\"fw-semi-bold\" ng-if=\"!vml.addRestrictions\">Bulk Edit</h2>\r\n            <h2 class=\"fw-semi-bold\" ng-if=\"vml.addRestrictions\">Add Restrictions</h2>\r\n            <ul>\r\n            <li ng-repeat=\"editPost in vml.checkedPostsEdit\"><span ng-click=\"vml.removeEditPost(editPost._id)\" class=\"remove-from-list\" title=\"Remove from bulk edit\">X</span>{{editPost.title}}</li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"bulk-actions-edit--other\" ng-if=\"!vml.addRestrictions\">\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <h3>Title</h3>\r\n              <textarea class=\"form-control\" placeholder=\"Enter title here\" ng-model=\"vml.bulkTitle\"></textarea>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <h3>Signature</h3>\r\n              <textarea class=\"form-control\" placeholder=\"Enter signature here\" ng-model=\"vml.bulkSignature\"></textarea>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <h3>Gallery title</h3>\r\n              <textarea class=\"form-control\" placeholder=\"Enter gallery title here\" ng-model=\"vml.bulkGalleryTitle\"></textarea>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <h3>Description</h3>\r\n              <textarea class=\"form-control\" placeholder=\"Enter description here\" ng-model=\"vml.bulkDescription\"></textarea>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <h3>Author Url</h3>\r\n              <textarea class=\"form-control\" placeholder=\"Enter Author Url here\" ng-model=\"vml.bulkSignatureUrl\"></textarea>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vml.lockPhoto\" class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" id=\"lockCheck\"><label for=\"lockCheck\">Lock photo</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__button\">\r\n              <a class=\"btn btn-primary\" ng-click=\"vml.updateBulkAction()\">Update</a>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__button\">\r\n              <a ng-click=\"vml.cancelBulkEdit()\"class=\"btn btn-danger\">Cancel</a>\r\n            </div>       \r\n          </div>\r\n          <div class=\"bulk-actions-edit--other add-restrictions-bulk-other\" ng-if=\"vml.addRestrictions\">\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <div class=\"input-group-no-border form-group\">\r\n                <h3>Maximum utilization&nbsp;</h3>\r\n                <input type=\"text\" class=\"form-control inline-block\" ng-model=\"vml.numberOfUsesRestrictions\" ng-keypress=\"vml.onlyNumber($event)\">\r\n              </div>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__row\">\r\n              <div class=\"form-group range-picker range-picker-restriction\" >\r\n                <input type=\"daterange\" input ng-model=\"vml.myDateRangeRestrictions\" class=\"form-control\" placeholder=\"Restrictions date range\" ranges=\"ranges\" ng-change = \"vml.changeDateRestrictions(vml.myDateRangeRestrictions)\" ng-keydown=\"customDate($event)\"/>\r\n              </div>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__button\">\r\n              <a class=\"btn btn-primary\" ng-click=\"vml.updateBulkAction()\">Update</a>\r\n            </div>\r\n            <div class=\"bulk-actions-edit--other__button\">\r\n              <a ng-click=\"vml.cancelBulkEdit()\"class=\"btn btn-danger\">Cancel</a>\r\n            </div>       \r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group range-picker\" >\r\n          <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vml.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n      </div>\r\n      <select ng-model=\"vml.selectedAuthorFilter.value\" ng-change=\"vml.switchAuthorFilter(vml.selectedAuthorFilter.value)\" class=\"form-control\">\r\n        <option value=\"all\">View all authors</option>\r\n        <option ng-repeat= \"author in vml.authorList\" value=\"{{author._id}}\">{{author.display_name}} ({{author._id}})</option>\r\n      </select>\r\n      <a ng-click=\"vml.mediaFilters()\" class=\"btn btn-primary\">Filter</a>\r\n      <a ng-click=\"vml.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n    </div>\r\n\r\n    <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vml.tableParams\" class=\"table table-condensed table-bordered table-striped\" ng-show=\"!vml.showGrid\">\r\n        <tr ng-repeat=\"post in $data\" quick-edit edit=\"post\" class=\"post-row\">\r\n        <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vml.checkboxes.items[post._id]\" ng-change=\"vml.checkedPost(vml.checkboxes.items[post._id], post)\"/><label></label>\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">\r\n          <div>\r\n            <a ng-href=\"http://109.94.103.252:8080/webtest?url={{post.file}}\" target=\"_blank\" class=\"clickable\">{{post._id}}</a> \r\n          </div>\r\n        </td>\r\n        <td data-title=\"'file'\" sortable=\"'file'\" class=\"ng-table--title\">\r\n          <div class=\"media-image\">\r\n            <a ng-click=\"vml.editMedia(post._id)\">\r\n              <img ng-src=\"{{post.thumbs['140x105']}}\" alt=\"\" class=\"img-responsive\">\r\n              <div class=\"forbiden-placeholder\" ng-if=\"post.restrictions.locked\" title=\"Photo is locked\"></div>\r\n            </a>\r\n          </div>\r\n          <div class=\"title-wrapp\">\r\n            <div class=\"title\">\r\n\r\n              <span class=\"clickable fw-semi-bold\" ng-click=\"vml.editMedia(post._id)\">{{post.title}}</span> \r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vml.editMedia(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable\" ng-click=\"vml.purgeCache(post.filepath)\">Purge Cache</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable clickable-danger\" ng-click=\"vml.deletePosts(post._id)\">Delete Permanently</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable\" ng-click=\"vml.openCropModal(post)\">Crop Thumbnail</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'author'\" class=\"ng-table--author\" sortable=\"'author'\">\r\n            <span ng-click=\"vml.authorPosts(post.author._id)\" class=\"clickable\">{{post.author.display_name}}</span>\r\n          \r\n        </td>\r\n        <td data-title=\"'uploaded to'\" sortable=\"'uploaded-to'\" class=\"ng-table--uploaded-to\">\r\n            <span ng-click=\"vml.uploadeToPost(post.uploaded_to._id)\" class=\"clickable\">{{post.uploaded_to.title}}</span><div ng-if=\"post.uploaded_to == 0 || post.uploaded_to == null\">(Unattached)<a class=\"attach-action clickable\" ng-click=\"vml.attachToPost(post._id)\">Attach</a></div><div ng-if=\"post.uploaded_to != 0 && post.uploaded_to != null\"><a class=\"attach-action clickable\" ng-click=\"vml.detach(post._id)\">Detach</a></div>\r\n          \r\n        </td>\r\n        <td data-title=\"'date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n            <span ng-click=\"\">{{post.date | date:'medium'}}</span>\r\n          \r\n        </td>\r\n        <td data-title=\"'signature'\" sortable=\"'signature'\" class=\"ng-table--signature\">\r\n              <span ng-click=\"\">{{post.signature}}</span>\r\n            \r\n        </td>\r\n        <td data-title=\"'Status'\" class=\"ng-table--status\">\r\n          <div class=\"clickable lock-wrapper\">\r\n              <img src=\"images/lock.svg\" alt=\"lock-image\" title = \"Unlock image\" ng-if=\"post.status == 'lock'\" ng-click=\"vml.changeMediaStatus(post._id,'publish')\">\r\n              <img src=\"images/unlock.svg\" alt=\"unlock-image\" title = \"Lock image\" ng-if=\"post.status == 'publish'\" ng-click=\"vml.changeMediaStatus(post._id,'lock')\">\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'Download'\" class=\"ng-table--status\">\r\n          <div class=\"clickable download-image-wapper\">\r\n            <img width=\"30\" height=\"30\" src=\"images/download.png\" alt=\"Download images\" ng-click=\"vml.downloadImage(post)\" title=\"Download image\">\r\n          </div>\r\n        </td>\r\n        <!-- <td data-title=\"'approval'\" class=\"ng-table--approval\">\r\n          <img src=\"images/download.svg\" alt=\"\" title = \"Download\" ng-if=\"post.approval_url\" ng-click=\"vml.getPdf(post)\">\r\n        </td> -->\r\n        </tr>\r\n      </table>\r\n      <div class=\"grid-wrapper\" ng-show=\"vml.showGrid\">\r\n        <ul class=\"grid\">\r\n          <li ng-repeat=\"media in vml.data_grid\">\r\n            <div class=\"img-wrapp clickable\" ng-class=\"{'active': $index==vml.selectedImage}\" ng-click=\"vml.editMediaModal($index,media._id)\">\r\n              <img ng-src=\"{{media.thumbs['254x191']}}\" alt=\"\">\r\n              <div class=\"forbiden-placeholder\" ng-if=\"media.restrictions.locked\" title=\"Photo is locked\"></div>\r\n            </div>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vml.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n        </div>\r\n      </script>\r\n    \r\n    </div> \r\n  </div>\r\n  <upload-approval-restrictions-modal ng-if = \"vml.uploadApprovalRestrictionsModal\" current-post-obj=\"vml\"></upload-approval-restrictions-modal>\r\n  <attach-to-post-modal ng-if = \"vml.attachToPostModalShow\" current-post-obj=\"vml\"></attach-to-post-modal>\r\n  <media-edit-modal media=\"vml\" ng-if =\"vml.editMediaModalShow\"></media-edit-modal>\r\n  </div>\r\n  <crop-image-modal ng-if=\"vml.cropModalShow\" current-post-obj=\"vml.mediaItemToCrop\" crop=\"'thumbs'\"></crop-image-modal>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay media-modal\">\r\n    <div class=\"modal--media-dialog\" id=\"modalMediaEdit\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n          \t<h2>Attachment Details</h2>\r\n          \t<div class=\"before\" ng-click=\"beforeImage()\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></div>\r\n          \t<div class=\"after\" ng-click=\"afterImage()\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></div>\r\n          \t<div ng-click=\"media.cancelMediaModal();resetMediaSelected()\" ng-escape=\"media.cancelMediaModal();resetMediaSelected()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content media-modal\">\r\n        \t<div class=\"left-column\">\r\n\t\t\t\t\t\t<div class=\"img-wrapper\">\r\n\t\t\t\t\t\t\t<div class=\"forbiden-placeholder\" ng-if=\"mediaSelected.restrictions.locked\" title=\"Photo is locked\"></div>\r\n\t\t\t\t\t\t\t<img ng-src=\"{{mediaSelected.thumbs['830x0']}}\" alt=\"mediaSelected.title\" lazy-loading class=\"spinner-show\">\r\n            \t<div class=\"lazy-loading\">\r\n                <div class=\"image-wrapper\">\r\n                  <img src=\"images/ajax-loader.svg\" alt=\"\">\r\n                </div>\r\n              </div>\r\n\t\t\t\t\t\t</div>\r\n            <!-- <div class=\"edit-link\"> -->\r\n              <!-- <a href=\"\" class=\"btn btn-default\">Edit Image</a> -->\r\n            <!-- </div> -->\r\n        \t</div>\r\n        \t<div class=\"right-column\">\r\n          \t<div class=\"image-details\">\r\n            \t\t<!-- <p class=\"name\">File name</p> -->\r\n            \t\t<p class=\"type\">File type: <span class=\"fw-semi-bold\">{{mediaSelected.mime}}</span></p>\r\n            \t\t<p class=\"uploaded-on\">Uploaded on: <span class=\"fw-semi-bold\">{{mediaSelected.date | date:'MMM d, y HH:mm'}}</span></p>\r\n            \t\t<!-- <p class=\"file-size\">File size:</p> -->\r\n            \t\t<p class=\"dimensions\">Dimensions: <span class=\"fw-semi-bold\">{{mediaSelected.meta.width}}x{{mediaSelected.meta.height}}</span></p>\r\n          \t</div>\r\n          \t<div class=\"editing-details\">\r\n            \t\t<div class=\"form-group\">\r\n                  <textarea ng-model=\"mediaSelected.file\" class=\"readonly form-control url-field\" readonly></textarea>\r\n                  <label>Url</label> \r\n            \t\t</div>\r\n            \t\t<div class=\"form-group\">\r\n                  <input type=\"text\" ng-model=\"mediaSelected.title\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n              \t  <label>Title</label> \r\n            \t\t</div>\r\n            \t\t<div class=\"form-group\">\r\n                  <input ng-model=\"mediaSelected.signature\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n              \t  <label>Signature</label> \r\n            \t\t</div>\r\n                <div class=\"form-group\">\r\n                  <input ng-model=\"mediaSelected.image_alt\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n                  <label>Alt text</label> \r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<div class=\"post-row\">\r\n\t\t\t\t\t\t\t<!-- <textarea name=\"\" id=\"\" cols=\"30\" rows=\"3\" ng-model=\"mediaSelected.gallery_title\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\" character-count=\"\" limit-character=\"200\" exceed-name=\"'galleryTitle'\"></textarea> -->\r\n\t\t\t\t\t\t\t<textarea name=\"\" id=\"\" cols=\"30\" rows=\"3\" ng-model=\"mediaSelected.gallery_title\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\"></textarea>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<label>Gallery title</label> \r\n\t\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<div class=\"post-row\">\r\n\t\t\t\t\t\t<!-- <textarea name=\"\" id=\"\" cols=\"30\" rows=\"3\" ng-model=\"mediaSelected.description\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\" character-count=\"\" limit-character=\"200\" exceed-name=\"decription\"></textarea> -->\r\n\t\t\t\t\t\t<textarea name=\"\" id=\"\" cols=\"30\" rows=\"3\" ng-model=\"mediaSelected.description\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\"></textarea>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<label>Description</label> \r\n            \t\t</div>\r\n            \t\t<div class=\"form-group\">\r\n                  <span class=\"fw-semi-bold\">{{mediaSelected.author.display_name}}</span>\r\n                  <label>Uploaded By:</label>  \r\n                </div>\r\n            \t\t<div class=\"form-group\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"mediaSelected.meta.signature_url\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n              \t  <label>Author URL</label>\r\n            \t\t</div>\r\n            \t\t<div class=\"form-group\">\r\n                  <span>{{mediaSelected.uploaded_to.title}}</span>\r\n                  <label>Uploaded To:</label> \r\n                </div>\r\n          \t\t</div>\r\n          \t\t<div class=\"edit-actions form-group\">\r\n            \t\t\t<a class=\"clickable\" ng-click=\"media.cancelMediaModal();resetMediaSelected();media.editMedia(media_id);media.showGrid = true\">Edit</a> | <a class=\"clickable\" ng-click=\"media.purgeCache(mediaSelected.filepath)\">Purge Cache</a> | <a class=\"clickable-danger\" ng-click=\"deleteMedia()\">Delete Permanently</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"form-group\">Photo status:&nbsp;\r\n\t\t\t\t\t\t\t\t<div class=\"clickable lock-wrapper\">\r\n\t\t\t\t\t\t\t\t\t\t<img src=\"images/lock.svg\" alt=\"lock-image\" title = \"Unlock image\" ng-if=\"mediaSelected.status == 'lock'\" ng-click=\"changeMediaStatus(mediaSelected._id,'publish')\">\r\n\t\t\t\t\t\t\t\t\t\t<img src=\"images/unlock.svg\" alt=\"unlock-image\" title = \"Lock image\" ng-if=\"mediaSelected.status == 'publish'\" ng-click=\"changeMediaStatus(mediaSelected._id,'lock')\">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n        \t\t</div>\r\n        \t</div>\r\n      \t</div>\r\n        <div class=\"library-modal-action\">\r\n          <!-- <a class=\"btn btn-primary pull-right\" ng-click=\"updateMedia()\">Update</a> -->\r\n      </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Upload approvals</h2>\r\n       <div ng-click=\"currentPostObj.cancelUploadApprovalRestrictionsModal()\" ng-escape=\"currentPostObj.cancelUploadApprovalRestrictionsModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content attach-to-post-modal restrictions-modal\" ng-if=\"idsForApproval.length>0\">\r\n        <add-approval-dir type=\"'photo'\" bulk=\"true\"></add-approval-dir>\r\n      </div>\r\n      <!-- <div class=\"library-modal-action\">\r\n          <a class=\"btn btn-primary pull-right\" ng-click=\"saveAttachments()\">Save approval</a>\r\n      </div> -->\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget upload_image\">\r\n    <h1 class=\"page-title\">Upload <span class=\"fw-semi-bold\">New Photo</span></h1>\r\n    <media-edit-modal media=\"vmnm\" ng-if =\"vmnm.editMediaModalShow\"></media-edit-modal>\r\n    <upload-photo-ml parent-obj =\"vmnm\"></upload-photo-ml>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n    <h1 class=\"page-title\">Related <span class=\"fw-semi-bold\">Galleries</span></h1>\r\n    <div class=\"related-galleries\">\r\n      <div class=\"tabs-wrapper\">\r\n        <div  class=\"bulk-actions\">\r\n          <select ng-model=\"vmrg.selectedCategoryAction.value\" ng-change=\"vmrg.switchCategoryAction(vmrg.selectedCategoryAction.value)\" class=\"form-control\">\r\n            <option value=\"{{category._id}}\" ng-repeat=\"category in vmrg.allCategories\">{{category.name}}</option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n      <div class=\"sortable-grid\">\r\n      <!-- <div class=\"number-focus-news pull-right\">{{vmnt.numberFocusnewsTicker}} items</div> -->\r\n        <table>\r\n          <thead>\r\n            <tr>\r\n            <th class=\"text-center\">Id</th>\r\n            <th>Title</th>\r\n            <th class=\"text-center\">Gallery</th>\r\n            <th class=\"text-center\">Order</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody sortable-dir ng-model=\"vmrg.allPosts\" class=\"sortable-grid__wrapper\" ng-show=\"vmrg.allPosts.length>0\">\r\n            <tr ng-repeat=\"item in vmrg.allPosts\" ng-class=\"{'limit': $index == vmrg.limitPosts - 1 && vmrg.allPosts.length>vmrg.limitPosts}\">\r\n              <td class=\"sortable-id\">{{item.post_id['_id']}}</td>\r\n              <td class=\"title-cell\">\r\n                <!-- <div>{{item.post_id.title}}</div> -->\r\n                <div class=\"post_title\">Post title: <span>({{item.post_id.title}}</span></div>\r\n                <label>Custom title</label>\r\n                <textarea ng-model=\"item.custom_title\" class=\"form-control\"></textarea>\r\n                <div class=\"clickable clickable-danger\" ng-click=\"vmrg.removeFromPopularPosts($index)\">Remove post</div>\r\n              </td>\r\n              <td class=\"selected-gallery\">\r\n                <select ng-model=\"item.gallery_number\" class=\"form-control\" convert-to-number>\r\n                  <option value=\"{{$index+1}}\" ng-repeat=\"i in item.galleriesArray track by $index\">{{ $index+1 }}</option>\r\n                </select>\r\n              </td>\r\n              <td class=\"order-cell text-center\">{{item.order}}</td>\r\n            </tr>\r\n          </tbody>\r\n          <tbody ng-show=\"vmrg.allPosts.length==0\">\r\n            <tr>\r\n              <td colspan=\"4\">No posts for <span class=\"fw-semi-bold\">\"{{vmrg.selectedCategoryAction.value}}\"</span>.</td>\r\n            </tr>\r\n          </tbody>\r\n          <tfoot>\r\n          <tr>\r\n            <td class=\"text-center\">Id</td>\r\n            <td>Title</td>\r\n            <td class=\"text-center\">Gallery</td>\r\n            <td class=\"text-center\">Order</td>\r\n          </tr>\r\n          </tfoot>\r\n          </table>\r\n        </div>\r\n        <a ng-click=\"vmrg.allPostSave(vmrg.selectedCategoryAction.value)\" class=\"btn btn-primary pull-right\">Save changes</a>\r\n    </div>\r\n  </section>\r\n  \r\n  \r\n  \r\n  \r\n  \r\n  "

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	module.exports = "<ul>\r\n    <li ng-repeat=\"item in list\">\r\n        <div class=\"checkbox checkbox-primary\" ng-if=\"type=='category'\">\r\n            <input type=\"checkbox\" ng-model=\"itemChecked[item._id]\" ng-click = \"updateSelection(item._id, itemChecked[item._id], item.name, item)\" id=\"{{item._id}}\">\r\n            <label for=\"{{item._id}}\">{{item.name}}</label>\r\n        </div> \r\n        <div class=\"checkbox checkbox-primary\" ng-if=\"type=='page'\">\r\n            <input type=\"checkbox\" ng-model=\"itemChecked[item.slug]\" ng-click = \"updateSelection(item.slug, itemChecked[item.slug], item.title, item)\" id=\"{{item.slug}}\">\r\n            <label for=\"{{item.slug}}\">{{item.title}}</label>\r\n        </div>\r\n        <checked-list-menu-dir list=\"item.children\" type=\"type\" ng-if=\"item.children && item.children.length>0\" item-checked=\"itemChecked\" menu=\"menu\"></checked-list-menu-dir>\r\n    </li>\r\n</ul>"

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"single-post--widget widget categories\">\r\n    <header class=\"bb\">\r\n      <h5 class=\"fw-semi-bold\"><span ng-if=\"type=='category'\">Categories</span><span ng-if=\"type=='page'\">Pages</span></h5>\r\n    </header>\r\n    <div class=\"widget-body\">\r\n      <div class=\"search\">\r\n        <input type=\"search\" placeholder=\"Search {{type}} ...\" class=\"form-control\" id=\"search-input\" ng-model=\"searchData.name\" ng-change=\"changeSearch()\" ng-show=\"type=='category'\">\r\n        <input type=\"search\" placeholder=\"Search {{type}} ...\" class=\"form-control\" id=\"search-input\" ng-model=\"searchData.title\" ng-change=\"changeSearch()\" ng-show=\"type=='page'\">\r\n      </div>\r\n      <div class=\"tab-content\">\r\n        <div class=\"tab-pane active clearfix categories-tree\">\r\n          <checked-list-menu-dir item-checked=\"itemChecked\" list=\"filteredList\" type=\"type\" menu=\"menu\" ng-if=\"list && list.length>0\"></checked-list-menu-dir>\r\n        </div>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"checkedRequired\">Choose <span ng-if=\"type=='category'\">category</span><span ng-if=\"type=='page'\">page</span></div>\r\n    </div>\r\n    <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"addNavigationItem()\">Add to Menu</a></footer>\r\n  </section>"

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n\r\n  <h1 class=\"page-title\">Edit <span class=\"fw-semi-bold\">Menus</span></h1>\r\n  <div class=\"menus\">\r\n    <div class=\"table-filter\">\r\n      <label>Select menu:&nbsp;</label>\r\n      <select ng-model=\"vmm.selectedMenuAction.value\" ng-change=\"vmm.switchMenuction(vmm.selectedMenuAction.value)\" class=\"form-control\">\r\n        <option value=\"create-new\">--create new menu--</option>\r\n        <option  ng-repeat = \"menuOption in vmm.menuOptions\" value=\"{{menuOption}}\">{{menuOption}}</option>\r\n      </select>\r\n      <a ng-click=\"vmm.changeNavigationsOptions(vmm.selectedMenuAction.value)\" class=\"btn btn-primary\">Select</a>\r\n      <span>&nbsp;&nbsp;or&nbsp;&nbsp;</span>\r\n      <a class=\"btn btn-primary\" ng-click = \"vmm.createNewMenu()\">New Menu</a>\r\n    </div>\r\n    <div class=\"menus__wrapper\">\r\n      <div class=\"menus__left-col\">\r\n        <checked-widget-dir type=\"'category'\" list=\"vmm.categories\"  parent-obj=\"vmm\" ng-if=\"vmm.categories && vmm.categories.length>0\"></checked-widget-dir>\r\n        <!-- <section class=\"single-post--widget widget categories\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Categories</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"clearfix\">\r\n              <ul class=\"nav nav-tabs pull-left\">\r\n                <li class=\"active\"><a>All Categories</a></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"tab-content\">\r\n              <div class=\"tab-pane active clearfix categories-tree\">\r\n                <checked-list-menu-dir item-checked=\"vmm.checkedObj\" list=\"vmm.categories\" type=\"'category'\" menu=\"vmm.checkedListMenuObj\" ng-if=\"vmm.categories && vmm.categories.length>0\"></checked-list-menu-dir>\r\n              </div>\r\n            </div>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmm.categoryRequired\">Choose category.</div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"vmm.addNavigationItem('category')\">Add to Menu</a></footer>\r\n        </section> -->\r\n        <section class=\"single-post--widget widget categories\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Tags</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n              <div class=\"input-field search-wrapper\">\r\n                  <input type=\"text\" class=\"form-control search-autocomplete\" ng-model=\"vmm.tag\" auto-complete-dir datachangelabel=\"\" datachangeid = \"\" type-dir=\"'menu'\"  placeholder=\"Search tag\">\r\n              </div>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmm.tagRequired\">Choose tag.</div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"vmm.addNavigationItem('post_tag')\">Add to Menu</a></footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget categories\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Single post</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"form-group\">\r\n              <search-post-dir parent-obj=\"vmm\" no-add-btn=\"true\"></search-post-dir>\r\n              <div class=\"required-error animate-show\" ng-show=\"vmm.singlePostRequired\">Post is required.</div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label>Label</label>\r\n              <input type=\"text\"  class=\"form-control\" ng-model=\"vmm.singlePostLabel\" placeholder=\"Enter label\">\r\n              <div class=\"required-error animate-show\" ng-show=\"vmm.singlePostLabelRequired\">Label is required.</div>\r\n            </div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"vmm.addNavigationItem('post')\">Add to Menu</a></footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget categories\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Custom link</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"form-group\">\r\n              <label>Url</label>\r\n              <input type=\"text\"  class=\"form-control\" ng-model=\"vmm.linkUrl\" placeholder=\"Enter url\">\r\n              <div class=\"required-error animate-show\" ng-show=\"vmm.linkUrlRequired\">Url required.</div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label>label</label>\r\n              <input type=\"text\"  class=\"form-control\" ng-model=\"vmm.linkText\" placeholder=\"Enter label\">\r\n              <div class=\"required-error animate-show\" ng-show=\"vmm.linkTextRequired\">Url text required.</div>\r\n            </div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"vmm.addNavigationItem('custom')\">Add to Menu</a></footer>\r\n        </section>\r\n        <checked-widget-dir type=\"'page'\" list=\"vmm.pages\" parent-obj=\"vmm\" ng-if=\"vmm.pages && vmm.pages.length>0\"></checked-widget-dir>\r\n        <!-- <section class=\"single-post--widget widget categories\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Pages</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"clearfix\">\r\n              <ul class=\"nav nav-tabs pull-left\">\r\n                <li class=\"active\"><a>All Pages</a></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"tab-content\">\r\n              <div class=\"tab-pane active clearfix categories-tree\">\r\n                <checked-list-menu-dir item-checked=\"{}\" list=\"vmm.pages\" type=\"'page'\" menu=\"vmm.checkedListMenuObj\" ng-if=\"vmm.pages && vmm.pages.length>0\"></checked-list-menu-dir>\r\n              </div>\r\n            </div>    \r\n            <div class=\"required-error animate-show\" ng-show=\"vmm.pageRequired\">Choose page.</div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"btn btn-default pull-right\" ng-click=\"vmm.addNavigationItem('page')\">Add to Menu</a></footer>\r\n        </section> -->\r\n        \r\n        \r\n      </div>\r\n      <div class=\"menus__right-col\">\r\n      <div class=\"menus__name-wrapper\">\r\n        <label ng-if=\"vmm.newMenu\">Menu Name</label>\r\n        <div class=\"form-group\" ng-if=\"vmm.newMenu\">\r\n          <select ng-model=\"vmm.selectedMenuType.value\" ng-change=\"vmm.switchMenuTypeAction(vmm.selectedMenuType.value)\" class=\"form-control title-type\">\r\n            <option value=\"desk\">desk</option>\r\n            <option value=\"mob\">mob</option>\r\n            <option value=\"app\">app</option>\r\n          </select>\r\n          <input type=\"text\" ng-model=\"vmm.createMenuName\" placeholder=\"Enter menu name here\" class=\"form-control title-slug\" ng-class=\"{'error-border':vmm.menuNameRequired}\" ng-focus=\"vmm.menuNameRequired=false\">\r\n          <input type=\"text\" ng-model=\"vmm.createMenuVer\" class=\"form-control title-ver\" placeholder=\"Enter ver\" ng-keypress=\"vmm.isNumberKey($event)\" ng-class=\"{'error-border':vmm.menuVersionRequired}\" ng-focus=\"vmm.menuVersionRequired=false\">\r\n          <div class=\"required-error animate-show\" ng-show=\"vmm.menuExist\">Menu alredy exist.</div>\r\n          <div class=\"form-group margin-top-10\">\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.font_color\" id=\"font_color\"><label for=\"font_color\">Font color</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.background_color\" id=\"background_color\"><label for=\"background_color\">Background color</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.border_color\" id=\"border_color\"><label for=\"border_color\">Border color</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.pin\" id=\"pin\"><label for=\"pin\">Pin</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.live_mode\" id=\"live_mode\"><label for=\"live_mode\">Live mode</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary margin-right-10\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.image\" id=\"image\" ng-change=\"vmm.navigationOptionsChange(vmm.navigationOptions.image,'image')\"><label for=\"image\">Image</label>\r\n            </div>\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmm.navigationOptions.hamburger_image\" id=\"hamburger_image\" ng-change=\"vmm.navigationOptionsChange(vmm.navigationOptions.image,'hamburger_image')\"><label for=\"hamburger_image\">Hamburger image</label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <a class=\"btn btn-primary pull-right\" ng-click=\"vmm.saveMenu('create')\" ng-if=\"vmm.newMenu\">Create Menu</a>\r\n        <a class=\"btn btn-primary pull-right\" ng-click=\"vmm.saveMenu()\" ng-if=\"!vmm.newMenu\">Save Menu</a>\r\n        <!-- <a ng-click=\"vmm.previewMenu()\" class=\"btn btn-primary pull-right margin-right-10\" ng-if=\"vmm.mainNavigation\">Preview</a> -->\r\n      </div>\r\n        <div ui-tree = \"vmm.treeOptions\" data-drag-enabled=\"tree.enabled\" class=\"menu-sortable-wrapp\">\r\n          <ol ui-tree-nodes=\"\" ng-model=\"vmm.navigationValue\">\r\n            <li ng-repeat=\"node in vmm.navigationValue\" ui-tree-node ng-include=\"'nodes_renderer.html'\" collapsed=\"{{node.children.length>0}}\"></li>\r\n          </ol>\r\n        </div>\r\n        <a class=\"clickable-danger\" ng-click=\"vmm.deleteMenu()\" ng-if=\"!vmm.newMenu && vmm.superAdminPermisions\">Delete Menu</a>\r\n        <a class=\"btn btn-primary pull-right\" ng-click=\"vmm.saveMenu('create')\" ng-if=\"vmm.newMenu\">Create Menu</a>\r\n        <a class=\"btn btn-primary pull-right\" ng-click=\"vmm.saveMenu()\" ng-if=\"!vmm.newMenu\">Save Menu</a>\r\n        <!-- <a ng-click=\"vmm.previewMenu()\" class=\"btn btn-primary pull-right margin-right-10\" ng-if=\"vmm.mainNavigation\">Preview</a> -->\r\n        <script type=\"text/ng-template\" id=\"nodes_renderer.html\">\r\n        <div ui-tree-handle class=\"tree-node tree-node-content\" ng-class=\"{'open':vmm.openItem[node._id]}\">\r\n          <a class=\"btn btn-danger btn-xs colapsed-btn\" ng-if=\"node.children && node.children.length > 0\" data-nodrag=\"\" ng-click=\"vmm.toggleNavigationItemChildren(this)\" ng-class=\"{'btn-danger-inverse':vmm.openItem[node._id]}\"><span class=\"glyphicon glyphicon-chevron-right\" ng-class=\"{\r\n          'glyphicon-chevron-right': collapsed,\r\n          'glyphicon-chevron-down': !collapsed\r\n          }\"></span></a>\r\n          <span class=\"title\">{{node.title}}</span>\r\n          <span class=\"navigation-item-type\"> ({{node.type}})</span>\r\n          <svg ng-if=\"node.pin\" width=\"14\" height=\"20\" viewBox=\"0 0 14 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.1825 0.182501C2.24065 0.124499 2.30966 0.0785261 2.38559 0.0472115C2.46151 0.0158969 2.54287 -0.000145687 2.625 9.96867e-07H11.375C11.5408 9.96867e-07 11.6997 0.065849 11.8169 0.183059C11.9342 0.30027 12 0.459241 12 0.625001C12 1.475 11.5725 2.0925 11.1925 2.47375C11.035 2.63 10.88 2.75375 10.75 2.84625V8.385L10.8475 8.445C11.1012 8.60375 11.4425 8.8375 11.7863 9.13875C12.45 9.71875 13.25 10.6588 13.25 11.875C13.25 12.0408 13.1842 12.1997 13.0669 12.3169C12.9497 12.4342 12.7908 12.5 12.625 12.5H7.625V18.125C7.625 18.47 7.345 20 7 20C6.655 20 6.375 18.47 6.375 18.125V12.5H1.375C1.20924 12.5 1.05027 12.4342 0.933058 12.3169C0.815848 12.1997 0.75 12.0408 0.75 11.875C0.75 10.6588 1.55 9.71875 2.2125 9.13875C2.53618 8.85834 2.88328 8.60617 3.25 8.385V2.84625C3.09313 2.73366 2.94519 2.60912 2.8075 2.47375C2.4275 2.0925 2 1.47375 2 0.625001C1.99985 0.54287 2.0159 0.461515 2.04721 0.385588C2.07853 0.309661 2.1245 0.24065 2.1825 0.182501ZM4.155 1.94125L4.1575 1.9425C4.26053 1.99471 4.34707 2.07444 4.40753 2.17285C4.46799 2.27126 4.5 2.3845 4.5 2.5V8.75C4.5 8.86597 4.46772 8.97966 4.4068 9.07834C4.34587 9.17702 4.25868 9.25679 4.155 9.30875H4.1525L4.1375 9.3175L4.07 9.355C3.70183 9.56115 3.35548 9.80406 3.03625 10.08C2.63875 10.4275 2.305 10.825 2.13 11.25H11.87C11.695 10.825 11.3612 10.4275 10.9637 10.08C10.625 9.78712 10.2558 9.53148 9.8625 9.3175L9.8475 9.31H9.845C9.74113 9.25795 9.65382 9.17798 9.59288 9.07906C9.53193 8.98014 9.49977 8.86619 9.5 8.75V2.5C9.49953 2.37914 9.53411 2.26073 9.59956 2.15912C9.66501 2.05751 9.75851 1.97705 9.86875 1.9275C10.0284 1.8331 10.1758 1.71932 10.3075 1.58875C10.4075 1.48875 10.5012 1.37625 10.575 1.25H3.425C3.50083 1.375 3.59 1.48792 3.6925 1.58875C3.83077 1.72576 3.98623 1.84425 4.155 1.94125Z\"/></svg>\r\n          <svg ng-if=\"node.live\" width=\"20\" height=\"20\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4zm0-4C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z\"></path><circle cx=\"16\" cy=\"16\" r=\"8.5\"></circle></svg>\r\n          <a class=\"btn btn-danger btn-xs colapsed-item\" data-nodrag=\"\" ng-click=\"vmm.toggleNavigationItem(node)\" ng-class=\"{'btn-danger-inverse':vmm.openItem[node._id]}\"><span class=\"glyphicon glyphicon-pencil\" ng-class=\"{\r\n          'glyphicon-pencil': !vmm.openItem[node._id],\r\n          'glyphicon-remove': vmm.openItem[node._id]\r\n          }\"></span></a>\r\n          <span data-nodrag=\"\" ng-show=\"!vmm.openItem[node._id]\" ng-click=\"vmm.toggleNavigationItem(node)\" class=\"pull-right edit-content\">Edit</span>\r\n          <span data-nodrag=\"\" ng-show=\"vmm.openItem[node._id]\" ng-click=\"vmm.toggleNavigationItem(node)\" class=\"pull-right close-content\">Close</span>  \r\n        </div>\r\n        <div class=\"navigation-item-content\" ng-class=\"{'show': vmm.openItem[node._id]}\">\r\n          <div class=\"form-group\" ng-show = \"node.type=='custom'\"> \r\n            <label>Url</label>\r\n            <input class=\"form-control\" ng-model=\"node.url\" placeholder=\"Enter navigation url\">\r\n          </div>\r\n          <div class=\"form-group\"> \r\n            <label>Navigation Label</label>\r\n            <input class=\"form-control\" ng-model=\"node.title\" placeholder=\"Enter navigation label\">\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.font_color\">\r\n              <a class=\"edit-text-content\" ng-click=\"vmm.addColor(node, 'font')\">Edit font color</a>\r\n              <div class=\"color-picker-wrapper-outer\" ng-class=\"{'fadeIn animated' : node.color.font}\" ng-if=\"node.color.font\">\r\n                <color-picker ng-model=\"node.color.font\"></color-picker>\r\n              </div>\r\n              <a class=\"edit-text-content clickable-danger\" ng-class=\"{'fadeIn animated' : node.color.font}\" ng-click=\"vmm.removeColor(node, 'font')\" ng-if=\"node.color.font\">Remove</a>\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.background_color\">\r\n              <a class=\"edit-text-content\" ng-click=\"vmm.addColor(node, 'background')\">Edit background color</a>\r\n              <div class=\"color-picker-wrapper-outer\" ng-class=\"{'fadeIn animated' : node.color.background}\" ng-if=\"node.color.background\">\r\n                <color-picker ng-model=\"node.color.background\"></color-picker>\r\n              </div>\r\n              <a class=\"edit-text-content clickable-danger\" ng-class=\"{'fadeIn animated' : node.color.background}\" ng-click=\"vmm.removeColor(node, 'background')\" ng-if=\"node.color.background\">Remove</a>\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.border_color\">\r\n            <a class=\"edit-text-content\" ng-click=\"vmm.addColor(node, 'border')\">Edit border color</a>\r\n            <div class=\"color-picker-wrapper-outer\" ng-class=\"{'fadeIn animated' : node.color.border}\" ng-if=\"node.color.border\">\r\n              <color-picker ng-model=\"node.color.border\"></color-picker>\r\n            </div>\r\n            <a class=\"edit-text-content clickable-danger\" ng-class=\"{'fadeIn animated' : node.color.border}\" ng-click=\"vmm.removeColor(node, 'border')\" ng-if=\"node.color.border\">Remove</a>\r\n        </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.pin\">\r\n            <a class=\"edit-text-content no-clickable\">Pin item</a>\r\n            <div class=\"icon-wrapper\" ng-click=\"node.pin =! node.pin\">\r\n              <div class=\"pin_icon-wrapper\" ng-class=\"{'active':node.pin}\">\r\n                <svg width=\"14\" height=\"20\" viewBox=\"0 0 14 20\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                  <path d=\"M2.1825 0.182501C2.24065 0.124499 2.30966 0.0785261 2.38559 0.0472115C2.46151 0.0158969 2.54287 -0.000145687 2.625 9.96867e-07H11.375C11.5408 9.96867e-07 11.6997 0.065849 11.8169 0.183059C11.9342 0.30027 12 0.459241 12 0.625001C12 1.475 11.5725 2.0925 11.1925 2.47375C11.035 2.63 10.88 2.75375 10.75 2.84625V8.385L10.8475 8.445C11.1012 8.60375 11.4425 8.8375 11.7863 9.13875C12.45 9.71875 13.25 10.6588 13.25 11.875C13.25 12.0408 13.1842 12.1997 13.0669 12.3169C12.9497 12.4342 12.7908 12.5 12.625 12.5H7.625V18.125C7.625 18.47 7.345 20 7 20C6.655 20 6.375 18.47 6.375 18.125V12.5H1.375C1.20924 12.5 1.05027 12.4342 0.933058 12.3169C0.815848 12.1997 0.75 12.0408 0.75 11.875C0.75 10.6588 1.55 9.71875 2.2125 9.13875C2.53618 8.85834 2.88328 8.60617 3.25 8.385V2.84625C3.09313 2.73366 2.94519 2.60912 2.8075 2.47375C2.4275 2.0925 2 1.47375 2 0.625001C1.99985 0.54287 2.0159 0.461515 2.04721 0.385588C2.07853 0.309661 2.1245 0.24065 2.1825 0.182501ZM4.155 1.94125L4.1575 1.9425C4.26053 1.99471 4.34707 2.07444 4.40753 2.17285C4.46799 2.27126 4.5 2.3845 4.5 2.5V8.75C4.5 8.86597 4.46772 8.97966 4.4068 9.07834C4.34587 9.17702 4.25868 9.25679 4.155 9.30875H4.1525L4.1375 9.3175L4.07 9.355C3.70183 9.56115 3.35548 9.80406 3.03625 10.08C2.63875 10.4275 2.305 10.825 2.13 11.25H11.87C11.695 10.825 11.3612 10.4275 10.9637 10.08C10.625 9.78712 10.2558 9.53148 9.8625 9.3175L9.8475 9.31H9.845C9.74113 9.25795 9.65382 9.17798 9.59288 9.07906C9.53193 8.98014 9.49977 8.86619 9.5 8.75V2.5C9.49953 2.37914 9.53411 2.26073 9.59956 2.15912C9.66501 2.05751 9.75851 1.97705 9.86875 1.9275C10.0284 1.8331 10.1758 1.71932 10.3075 1.58875C10.4075 1.48875 10.5012 1.37625 10.575 1.25H3.425C3.50083 1.375 3.59 1.48792 3.6925 1.58875C3.83077 1.72576 3.98623 1.84425 4.155 1.94125Z\"/>\r\n                </svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.live_mode\">\r\n            <a class=\"edit-text-content no-clickable\">Turn on live mode</a>\r\n            <div class=\"icon-wrapper\" ng-click=\"node.live =! node.live\">\r\n              <div class=\"live_icon-wrapper\" ng-class=\"{'active':node.live}\">\r\n                <svg width=\"20\" height=\"20\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4zm0-4C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z\"></path><circle cx=\"16\" cy=\"16\" r=\"8.5\"></circle></svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.image && vmm.openItem[node._id]\">\r\n            <a class=\"edit-text-content no-clickable\">Add image</a>\r\n            <div class=\"dropzone-wrapper\" ng-class=\"{'has-image':node.image}\">\r\n              <form class=\"dropzone\" options=\"vmm.dropzone[node._id].image.dzOptions\" callbacks=\"vmm.dropzone[node._id].image.dzCallbacks\" methods=\"vmm.dropzone[node._id].image.dzMethods\" ng-dropzone></form>\r\n            </div>\r\n            <a class=\"edit-text-content clickable-default margin-right-5\" href=\"{{node.image.url}}\" target=\"_blank\" ng-if=\"node.image\" ng-class=\"{'fadeIn animated' : node.image}\">View image</a>\r\n            <a class=\"edit-text-content clickable-danger\" ng-if=\"node.image\" ng-class=\"{'fadeIn animated' : node.image}\" ng-click=\"vmm.removeImage(node, 'image')\">Remove</a>\r\n          </div>\r\n          <div class=\"form-group margin-bottom-10\" ng-if=\"vmm.navigationOptions.hamburger_image && vmm.openItem[node._id]\">\r\n            <a class=\"edit-text-content no-clickable\">Add hamburger image</a>\r\n            <div class=\"dropzone-wrapper\" ng-class=\"{'has-image':node.hamburger_image}\">\r\n              <form class=\"dropzone\" options=\"vmm.dropzone[node._id].hamburger_image.dzOptions\" callbacks=\"vmm.dropzone[node._id].hamburger_image.dzCallbacks\" methods=\"vmm.dropzone[node._id].hamburger_image.dzMethods\" ng-dropzone></form>\r\n            </div>\r\n            <a class=\"edit-text-content clickable-default margin-right-5\" href=\"{{node.hamburger_image.url}}\" target=\"_blank\" ng-if=\"node.hamburger_image\" ng-class=\"{'fadeIn animated' : node.hamburger_image}\">View image</a>\r\n            <a class=\"edit-text-content clickable-danger\" ng-if=\"node.hamburger_image\" ng-class=\"{'fadeIn animated' : node.hamburger_image}\" ng-click=\"vmm.removeImage(node, 'hamburger_image')\">Remove</a>\r\n          </div>\r\n          <!-- <div class=\"form-group\">\r\n            <label for=\"\">\r\n              <a class=\"clickable\" ng-click=\"vmm.addColor(node, 'hover')\" ng-if=\"!node.color.hover\">Set hover font color</a>\r\n              <a class=\"clickable-danger\" ng-click=\"vmm.removeColor(node, 'hover')\" ng-if=\"node.color.hover\">Set default hover font color</a>\r\n            </label>\r\n            <div ng-class=\"{'slideInFadeDown animated' : node.color.hover}\" ng-if=\"node.color.hover\">\r\n              <color-picker \r\n              ng-model=\"node.color.hover\"\r\n              ></color-picker>\r\n            </div>\r\n          </div> -->\r\n          <a ng-click=\"vmm.removeItem(this)\" class=\"btn btn-dark pull-right btn-action\" ng-if=\"node.type!='default'\">Remove item</a>\r\n          <a ng-click=\"vmm.cancelEditItem(node)\" class=\"btn btn-danger pull-left btn-action margin-right-10\">Cancel changes</a>\r\n          <!-- <a ng-click=\"vmm.previewMenu(node)\" class=\"btn btn-primary btn-action pull-left\" ng-if=\"vmm.mainNavigation\">Preview</a> -->\r\n        </div>\r\n        <ol ui-tree-nodes=\"\" ng-model=\"node.children\" ng-class=\"{hidden: collapsed}\">\r\n          <li ng-repeat=\"node in node.children\" ui-tree-node ng-include=\"'nodes_renderer.html'\">\r\n          </li>\r\n        </ol>\r\n      </script>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"template.html\">\r\n    <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n       <li ng-show=\"!showResult\">No result.</li>\r\n       <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.name, tag._id, tag.url)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})</li>\r\n   </ul>\r\n   </script>\r\n</section>\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  \r\n  <h1 class=\"page-title\" ng-if=\"vman.type !='eklinika'\">All <span class=\"fw-semi-bold\">Push Notifications</span></h1>\r\n  <h1 class=\"page-title\" ng-if=\"vman.type =='eklinika'\"><span class=\"fw-semi-bold\">Eklinika Push Notifications</span></h1>\r\n  <div class=\"all-notifications\">\r\n    <div ng-if=\"vman.type =='eklinika'\" class=\"form-group overflow-hidden\">\r\n      <div class=\"form-group position-relative\">\r\n        <label>Eklinika URL</label>\r\n        <textarea class=\"form-control textarea-md\" placeholder=\"Enter URL here\" ng-model=\"vman.eklinikaUrl\" ng-class=\"{'error-border':vman.eklinikaUrlRequired}\" ng-focus=\"vman.eklinikaUrlRequired = false\" ng-enter=\"vman.addToPushNotificationByURL(vman.eklinikaUrl)\"></textarea>\r\n      </div>\r\n      <a ng-click=\"vman.addToOtherByURL({'param1':'pushnotifications','param2':'eklinika'},vman.eklinikaUrl,'eklinika',vman.addToPushNotificationByUrlSuccessFunc, vman)\" class=\"btn btn-primary pull-left\">Add to Notifications</a>\r\n    </div>\r\n    <div class=\"status-filter\">\r\n      <div class=\"search\">\r\n        <div class=\"input-group\">\r\n          <input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vman.searchData\"  placeholder=\"Search post ID\" ng-keypress=\"vman.keyPressOnlyNumberAndEnter($event, vman.search, vman.searchData)\" ng-change = \"vman.changeSearch(vman.searchData)\"> \r\n          <span class=\"input-group-btn\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"vman.search(vman.searchData);\">Search</button>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"widget-body table-wrapper\">\r\n        <table ng-table=\"vman.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n          <tr ng-repeat=\"post in $data\">\r\n            <td data-title=\"'#'\" class=\"ng-table--id\">\r\n              <span>{{post.document_id}}</span>\r\n              <img src=\"images/play-button.svg\" alt=\"video\" title = \"Telegraf.tv\" ng-if=\"post.type == 'video'\">\r\n            </td>\r\n            <td data-title=\"'Title'\" class=\"ng-table--title\">\r\n              <div class=\"title\">\r\n                Title:&nbsp;<span class=\"fw-semi-bold\">{{post.title}}</span>\r\n                <span ng-click=\"post.edit_title = post.title;post.edit_titleShow=true\" class=\"edit-pencil-wrapper\" ng-show=\"(post.web_status == 'pending' || post.android_status == 'pending' || post.ios_status == 'pending') && !post.edit_titleShow\">\r\n                  <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <textarea class = \"form-control\" ng-show=\"post.edit_titleShow\" type=\"text\" ng-model=\"post.edit_title\"></textarea>\r\n                <a ng-click=\"vman.saveEditTitle(post,'title')\" ng-show=\"post.edit_titleShow\" class=\"btn btn-primary\">Save</a>\r\n                <a ng-click=\"post.edit_title = '';post.edit_titleShow = false\" ng-show=\"post.edit_titleShow\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n              <div class=\"title\">\r\n                Super Title:&nbsp;<span class=\"fw-semi-bold\">{{post.supertitle}}</span>\r\n                <span ng-click=\"post.edit_supertitle = post.supertitle;post.edit_supertitleShow=true\" class=\"edit-pencil-wrapper\" ng-show=\"(post.web_status == 'pending' || post.android_status == 'pending' || post.ios_status == 'pending') && !post.edit_supertitleShow\">\r\n                  <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <textarea class = \"form-control\" ng-show=\"post.edit_supertitleShow\" type=\"text\" ng-model=\"post.edit_supertitle\"></textarea>\r\n                <a ng-click=\"vman.saveEditTitle(post,'supertitle')\" ng-show=\"post.edit_supertitleShow\" class=\"btn btn-primary\">Save</a>\r\n                <a ng-click=\"post.edit_supertitle = '';post.edit_supertitleShow = false\" ng-show=\"post.edit_supertitleShow\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n              <div class=\"title-actions\">\r\n                <ul>\r\n                  <li>\r\n                    <span class=\"clickable clickable-danger\" ng-click=\"vman.deleteNotification(post._id)\">Remove from notifications</span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </td>\r\n            <td data-title=\"'Added date'\" class=\"ng-table--date\">\r\n                <span>{{post.timestamp*1000 | date:'MMM d, y H:mm'}}</span>\r\n            </td>\r\n            <td data-title=\"'Web status'\" class=\"ng-table--status\">\r\n              <div ng-class=\"{'sending':post.web_status == 'sending', 'sent': post.web_status == 'sent', 'pending': post.web_status == 'pending', 'failed':post.web_status == 'failed'}\">{{post.web_status}}</div>\r\n              <div ng-if=\"post.web_status == 'sent'\">{{post.send_web_timestamp*1000 | date:'MMM d, y H:mm'}}</div> \r\n              <div ng-if=\"post.web_status == 'pending'\"><a class=\"clickable\" ng-click=\"vman.sendNotification('web',post.type,post._id,post.document_id, post.in_post)\">Send Notification</a></div>  \r\n              <div class=\"dropdown history-data\" data-dropdown ng-show=\"post.history && (post.history.web.length >1 && post.web_status == 'sent' || post.web_status == 'pending' && post.history.web.length>0)\">\r\n                <span class=\"dropdown-toggle clickable-default\" data-dropdown-toggle><i class=\"fa fa-calendar\" aria-hidden=\"true\" title=\"History Data\"></i></span>\r\n                <ul class=\"dropdown-menu\">\r\n                  <li ng-repeat=\"item in post.history.web.slice(0,-1)\" ng-show=\"post.web_status == 'sent'\">\r\n                      <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                      <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                      <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                  <li ng-repeat=\"item in post.history.web\" ng-show=\"post.web_status == 'pending'\">\r\n                    <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                    <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                    <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"reload-action\" ng-if=\"post.web_status == 'sent'\">\r\n                <img ng-click=\"vman.reloadNotification(post,'web')\" src=\"images/reload.png\" alt=\"Reload Notification\" title=\"Reload Web Notification\" width=\"24px\" height=\"24px\">\r\n              </div>\r\n            </td>\r\n            <td data-title=\"'Android status'\" class=\"ng-table--status\">\r\n              <div ng-class=\"{'sending':post.android_status == 'sending', 'sent': post.android_status == 'sent', 'pending': post.android_status == 'pending', 'failed':post.android_status == 'failed'}\">{{post.android_status}}</div>\r\n              <div ng-if=\"post.android_status == 'sent'\">{{post.send_android_timestamp*1000 | date:'MMM d, y H:mm'}}</div> \r\n              <div ng-if=\"post.android_status == 'pending'\"><a class=\"clickable\" ng-click=\"vman.sendNotification('android',post.type,post._id,post.document_id,post.in_post)\">Send Notification</a></div>  \r\n              <div class=\"dropdown\" data-dropdown ng-if=\"post.analytics.android.display && vman.adminPermisions\">\r\n                <span class=\"dropdown-toggle clickable-default\" data-dropdown-toggle><i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i></span>\r\n                <ul class=\"dropdown-menu\">\r\n                  <li ng-if=\"post.analytics.android.took || post.analytics.android.took == 0\">Took: <strong>{{post.analytics.android.took}}</strong></li>\r\n                  <li ng-if=\"post.analytics.android.sent || post.analytics.android.sent == 0\">Sent: <strong>{{post.analytics.android.sent}}</strong></li>\r\n                  <li ng-if=\"(post.analytics.android.sent || post.analytics.android.sent == 0) && post.analytics.android.took\">Success rate: <strong>{{(post.analytics.android.sent / post.analytics.android.took) | decimalsPersentage:2}}%</strong></li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"dropdown history-data\" data-dropdown ng-show=\"post.history && (post.history.android.length >1 && post.android_status == 'sent' || post.android_status == 'pending' && post.history.android.length>0)\">\r\n                <span class=\"dropdown-toggle clickable-default\" data-dropdown-toggle><i class=\"fa fa-calendar\" aria-hidden=\"true\" title=\"History Data\"></i></span>\r\n                <ul class=\"dropdown-menu\">\r\n                  <li ng-repeat=\"item in post.history.android.slice(0,-1)\" ng-show=\"post.android_status == 'sent'\">\r\n                      <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                      <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                      <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                  <li ng-repeat=\"item in post.history.android\" ng-show=\"post.android_status == 'pending'\">\r\n                    <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                    <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                    <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"reload-action\" ng-if=\"post.android_status == 'sent'\">\r\n                <img ng-click=\"vman.reloadNotification(post,'android')\" src=\"images/reload.png\" alt=\"Reload Notification\" title=\"Reload Android Notification\" width=\"24px\" height=\"24px\">\r\n              </div>\r\n            </td>\r\n            <td data-title=\"'IOS status'\" class=\"ng-table--status\">\r\n              <div ng-class=\"{'sending':post.ios_status == 'sending', 'sent': post.ios_status == 'sent', 'pending': post.ios_status == 'pending', 'failed':post.ios_status == 'failed'}\">{{post.ios_status}}</div>\r\n              <div ng-if=\"post.ios_status == 'sent'\">{{post.send_ios_timestamp*1000 | date:'MMM d, y H:mm'}}</div>\r\n              <div ng-if=\"post.ios_status == 'pending'\"><a class=\"clickable\" ng-click=\"vman.sendNotification('ios',post.type,post._id,post.document_id, post.in_post)\">Send Notification</a></div>  \r\n              <div class=\"dropdown\" data-dropdown ng-if=\"post.analytics.ios.display && vman.adminPermisions\">\r\n                <span class=\"dropdown-toggle clickable-default\" data-dropdown-toggle><i class=\"fa fa-bar-chart\" aria-hidden=\"true\"></i></span>\r\n                <ul class=\"dropdown-menu\">\r\n                  <li ng-if=\"post.analytics.ios.took || post.analytics.ios.took == 0\">Took: <strong>{{post.analytics.ios.took}}</strong></li>\r\n                  <li ng-if=\"post.analytics.ios.sent || post.analytics.ios.sent == 0\">Sent: <strong>{{post.analytics.ios.sent}}</strong></li>\r\n                  <li ng-if=\"(post.analytics.ios.sent || post.analytics.ios.sent==0) && post.analytics.ios.took\">Success rate: <strong>{{(post.analytics.ios.sent / post.analytics.ios.took) | decimalsPersentage:2}}%</strong></li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"dropdown history-data\" data-dropdown ng-show=\"post.history && (post.history.ios.length >1 && post.ios_status == 'sent' || post.ios_status == 'pending' && post.history.ios.length>0)\">\r\n                <span class=\"dropdown-toggle clickable-default\" data-dropdown-toggle><i class=\"fa fa-calendar\" aria-hidden=\"true\" title=\"History Data\"></i></span>\r\n                <ul class=\"dropdown-menu\">\r\n                  <li ng-repeat=\"item in post.history.ios.slice(0,-1)\" ng-show=\"post.ios_status == 'sent'\">\r\n                      <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                      <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                      <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                  <li ng-repeat=\"item in post.history.ios\" ng-show=\"post.ios_status == 'pending'\">\r\n                    <div>Title: <span class=\"fw-bold\">{{item.title}}</span></div>\r\n                    <div>Super Title: <span class=\"fw-bold\">{{item.supertitle}}</span></div>\r\n                    <div>Push Date: <span class=\"fw-bold\">{{item.timestamp*1000 | date:'MMM d, y H:mm'}}</span></div>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"reload-action\" ng-if=\"post.ios_status == 'sent'\">\r\n                <img ng-click=\"vman.reloadNotification(post,'ios')\" src=\"images/reload.png\" alt=\"Reload Notification\" title=\"Reload IOS Notification\" width=\"24px\" height=\"24px\">\r\n              </div>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n          <p>No result. Try again.</p>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  \r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Notification Settings</span></h1>\r\n\r\n  <div class=\"notification-settings\">\r\n    <section class=\"single-post--widget widget\">\r\n      <header class=\"bb\">\r\n        <h5 class=\"fw-semi-bold\">Web notification</h5>\r\n      </header>\r\n      <div class=\"widget-body\">\r\n        <div class=\"form-group input-group-no-border\">\r\n          <label for=\"search-input\">Request permission frequency (in days):&nbsp;</label>\r\n          <div class=\"input-group\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"vmns.webPushNotificationFrequencyRequest\" ng-keypress=\"vmns.keyPressOnlyNumber($event)\" ng-blur = \"vmns.saveNotificationSettings()\" ng-class=\"{'error-border':!vmns.webPushNotificationFrequencyRequest || vmns.webPushNotificationFrequencyRequest == '0'}\" ng-focus =\"vmns.focusWpnfr(vmns.webPushNotificationFrequencyRequest)\">\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group input-group-no-border\">\r\n          <label for=\"search-input\">Time to leave (in hours):&nbsp;</label>\r\n          <div class=\"input-group\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"vmns.ttl\" ng-keypress=\"vmns.keyPressOnlyNumber($event)\" ng-blur = \"vmns.saveNotificationSettings()\" ng-class=\"{'error-border':!vmns.ttl || vmns.ttl == '0'}\" ng-focus =\"vmns.focusTtl(vmns.ttl)\">\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>Push notification workers</label>\r\n          <select ng-model=\"vmns.selectedPusher.value\" ng-change=\"vmns.switchPusher(vmns.selectedPusher.value)\" class=\"form-control\">\r\n            <option value=\"ms\">Mainstream</option>\r\n            <option value=\"do\">Digitalocean</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>Push notification category</label>\r\n          <select ng-model=\"vmns.selectedCategory.value\" ng-change=\"vmns.switchCategories(vmns.selectedCategory.value)\" class=\"form-control\" ng-class=\"{'error-border':vmns.selectedCategoryArray.length == 0}\">\r\n            <option value=\"default\">Choose category</option>\r\n            <option ng-repeat= \"category in vmns.categories | filter:{_id :'!uncategorized'}\" value=\"{{category._id}}\" ng-bind=\"category.name\" ng-disabled=\"category.selected\"></option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <table class=\"table table-bordered table-striped\">\r\n            <tbody sortable-dir ng-model=\"vmns.selectedCategoryArray\" class=\"sortable-grid__wrapper\">\r\n              <tr ng-repeat=\"category in vmns.selectedCategoryArray\">\r\n                <td class=\"title-cell\">\r\n                  <span>{{category.name}}</span>\r\n                </td>\r\n                <td class=\"clickable clickable-danger remove\" ng-click=\"vmns.removeCategory(category._id)\"><span>&times;</span></td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          </div>\r\n        </div>\r\n        <footer class=\"bg-body-light bt\">\r\n          <div  class=\"pull-right\">\r\n            <button class=\"btn btn-primary\" ng-click=\"vmns.saveWebSettings()\">Save</button>\r\n          </div>\r\n        </footer>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <page-dir ng-if=\"vmapg.editPostShow\" parent=\"vmapg\"></page-dir>\r\n  <div ng-if=\"!vmapg.editPostShow\">\r\n  <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Pages</span>&nbsp;<a data-ui-sref=\"app.newpage\" class=\"btn btn-primary\">New Page</a></h1>\r\n\r\n  <div class=\"all-pages\">\r\n  <div class=\"status-filter\">\r\n    <ul>\r\n      <li><a ng-click=\"vmapg.changeStatus($event,'all')\" class=\"clickable\" ng-class=\"{'active':vmapg.status =='all'}\">All</a> |</li>\r\n      <li><a ng-click=\"vmapg.changeStatus($event, 'publish')\" class=\"clickable\" ng-class=\"{'active':vmapg.status =='publish'}\">Published</a> |</li>\r\n      <li><a ng-click=\"vmapg.changeStatus($event, 'pending')\" class=\"clickable\" ng-class=\"{'active':vmapg.status =='pending'}\">Pending</a> |</li>\r\n      <li><a ng-click=\"vmapg.changeStatus($event, 'draft')\" class=\"clickable\" ng-class=\"{'active':vmapg.status =='draft'}\">Draft</a> |</li>\r\n      <li><a ng-click=\"vmapg.changeStatus($event, 'trash')\" class=\"clickable\" ng-class=\"{'active':vmapg.status =='trash'}\">Trash</a></li>\r\n    </ul>\r\n    <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmapg.searchData\" ng-change=\"vmapg.changeSearch(vmapg.searchData)\" ng-enter=\"vmapg.search(vmapg.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmapg.search(vmapg.searchData);\">Search</button></span></div></div>\r\n  </div>\r\n  <div class=\"table-filter\">\r\n    <div class=\"bulk-actions\">\r\n      <select ng-model=\"vmapg.selectedBulkAction.value\" ng-change=\"vmapg.switchBulkAction(vmapg.selectedBulkAction.value)\" class=\"form-control\">\r\n        <option value=\"default\">Bulk Actions</option>\r\n        <option value=\"trash\" ng-if=\"!vmapg.statusTrash\">Trash</option>\r\n        <option value=\"delete\" ng-if=\"vmapg.statusTrash\">Delete</option>\r\n      </select>\r\n      <a ng-click=\"vmapg.bulkAction(vmapg.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n    </div>\r\n    <div class=\"form-group range-picker\" >\r\n        <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmapg.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n    </div>\r\n    <a ng-click=\"vmapg.pageFilter()\" class=\"btn btn-primary\">Filter</a>\r\n    <a ng-click=\"vmapg.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n    \r\n  </div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmapg.tableParams\" class=\"table table-condensed table-bordered table-striped pages-table\">\r\n        <tr ng-repeat=\"post in $data\" quick-edit edit=\"post\" class=\"post-row\">\r\n        <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmapg.checkboxes.items[post._id]\" ng-change=\"vmapg.checkedPost(post._id, vmapg.checkboxes.items[post._id])\"/><label></label>\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">{{post._id}}</td>\r\n        <td data-title=\"'title'\" sortable=\"'title'\" class=\"ng-table--title\">\r\n          <div class=\"title\">\r\n            <span ng-if=\"post.status!='trash'\"class=\"clickable fw-semi-bold\" ng-click=\"vmapg.editPost(post._id)\">{{post.title}}</span>\r\n            <span ng-if=\"post.status=='trash'\" class=\"fw-semi-bold\">{{post.title}}</span>\r\n          </div>\r\n          <div class=\"title-actions\">\r\n            <ul>\r\n              <li ng-if=\"post.status!='trash'\"><span class=\"clickable\" ng-click=\"vmapg.editPost(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status!='trash'\"><span class=\"clickable clickable-danger\" ng-click=\"vmapg.updateStatusPost(post._id,'trash');vmapg.tableParams.reload();\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status=='trash'\"><span class=\"clickable\" ng-click = \"vmapg.updateStatusPost(post._id, 'draft');vmap.tableParams.reload();\">Restore</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status=='trash'\"><span class=\"clickable clickable-danger\" ng-click=\"vmapg.deletePosts(post._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <!-- <li ng-if=\"!vmapg.statusTrash\"><span class=\"clickable\">View</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n            </ul>\r\n          </div>\r\n        </td>\r\n          <td data-title=\"'author'\" class=\"ng-table--author\">\r\n              <span ng-click=\"vmapg.authorPosts(post.author._id)\" class=\"clickable\">{{post.author.display_name}}</span>\r\n          </td>\r\n          <td data-title=\"'date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n              <span ng-click=\"\">{{post.date | date:'MMM d, y H:mm'}}</span>\r\n            \r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmapg.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\" /><label></label></div>\r\n    </script>\r\n  </div>\r\n</div>\r\n</div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\" ng-class=\"{'edit':!vmpg.newPost}\">\r\n  <h1 ng-if=\"!vmpg.newPost\"class=\"page-title\">Edit <span class=\"fw-semi-bold\">Page</span>&nbsp;<a data-ui-sref=\"app.newpage\" class=\"btn btn-primary\">New Page</a><a ng-click=\"closeEditPage()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditPage()\" parametar=\"page\">&times;</a></h1>\r\n  <h1 ng-if=\"vmpg.newPost\"class=\"page-title\">Add New <span class=\"fw-semi-bold\">Page</span></h1>\r\n  <div class=\"single-post\" ng-class=\"{'edit-post':!vmpg.newPost, 'new-post':vmpg.newPost}\"> \r\n    <div class=\"form-group\"> \r\n      <label>Page title:</label>\r\n      <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Enter title here\" ng-model=\"vmpg.dataPost.title\">\r\n      <div class=\"required-error animate-show\" ng-show=\"vmpg.titleRequired\">Title is required</div>\r\n    </div> \r\n    <p ng-cloak ng-show=\"!vmpg.newPost\" class=\"permalink\">Permalink: <span class=\"fw-semi-bold\">{{vmpg.config.baseHref}}/{{vmpg.substringUri}}</span><span class=\"edit-slug fw-semi-bold\" ng-class=\"{'show-edit':!vmpg.editSlugShow, 'hidden-edit':vmpg.editSlugShow}\">{{vmpg.postSlug}}</span><input class = \"form-control\" ng-class=\"{'show-edit':vmpg.editSlugShow, 'hidden-edit':!vmpg.editSlugShow}\" type=\"text\" ng-model=\"vmpg.postSlug\" ng-style=\"{'width':vmpg.postSlug.length*8 + 'px','min-width':'100px' ,'max-width':'100%'}\"><a ng-click=\"vmpg.editSlug(vmpg.postSlug)\" ng-class=\"{'show-edit':!vmpg.editSlugShow, 'hidden-edit':vmpg.editSlugShow}\" class=\"btn btn-primary\">Edit</a><!-- <a ng-class=\"{'show-edit':!vmpg.editSlugShow, 'hidden-edit':vmpg.editSlugShow}\" class=\"btn btn-info\">View Page</a> --><a ng-click=\"vmpg.updateSlug()\" ng-class=\"{'show-edit':vmpg.editSlugShow, 'hidden-edit':!vmpg.editSlugShow}\" class=\"btn btn-primary\">Ok</a><a ng-click=\"vmpg.cancelSlug()\" ng-class=\"{'show-edit':vmpg.editSlugShow, 'hidden-edit':!vmpg.editSlugShow}\" class=\"btn btn-danger\">Cancel</a></p>\r\n    <div class=\"single-post--columns-wraper\">\r\n      <div class=\"single-post--left-col\">\r\n        <div class=\"change-preview-wrapper\" id=\"change-preview-wrapper\">\r\n          <a ng-click=\"vmpg.addMediatoEditor()\" class=\"btn grey-btn add-media-editor\">Add Media</a>\r\n          <ul class=\"editor-tabs-wrapper\">\r\n            <li>\r\n              <a class=\"active visual\" ng-click=\"vmpg.editorChangePreviw($event, 'visual')\">Visual</a>\r\n            </li>\r\n            <li>\r\n              <a ng-click=\"vmpg.editorChangePreviw($event, 'text')\" class=\"text\">Text</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <form method=\"post\" data-ng-controller = \"postEditorCtrl as vmeditorP\" class=\"post-editor\" obj-post=\"vmpg\" type-data=\"'page'\">\r\n        <textarea ui-tinymce=\"vmeditorP.tinymceOptions\" data-ng-model=\"vmpg.tinymceModel\"></textarea>\r\n        </form>\r\n      </div>    \r\n        \r\n      <div class=\"single-post--right-col\">\r\n        <section class=\"single-post--widget widget publish\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Publish</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <!-- <a ng-click=\"\" class=\"btn btn-default preview\" ng-if=\"!vmpg.newPost\">Preview Changes</a> -->\r\n            <a ng-click = \"vmpg.updateorSavePost()\" class=\"btn btn-default\" ng-show=\"vmpg.dataPost.status == 'pending' || vmpg.dataPost.status == 'draft'\" ng-cloak>Save</a>    \r\n            <ul>\r\n              <li><i class=\"fa fa-key\" aria-hidden=\"true\"></i>&nbsp;Status: <span class=\"fw-semi-bold status\">{{vmpg.dataPost.status}}</span> <span class=\"clickable\" ng-click=\"vmpg.editPostStatus()\">Edit</span>\r\n                <div class=\"editable\" ng-if=\"vmpg.editPostStatusShow\">\r\n                  <select ng-model=\"vmpg.selectedPostStatus.value\" class=\"form-control\">\r\n                    <option value=\"publish\" ng-show=\"!vmpg.newPost && vmpg.editPublish\">Published</option>\r\n                    <option value=\"pending\">Pending Review</option>\r\n                    <option value=\"draft\">Draft</option>      \r\n                  </select>\r\n                  <a ng-click=\"vmpg.changePostStatus()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmpg.cancelEditPostStatus()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n              <!-- <li><i class=\"fa fa-eye\" aria-hidden=\"true\"></i>&nbsp;Visibility: <span class=\"fw-semi-bold\">Public</span> <span class=\"clickable\">Edit</span></li> -->\r\n              <!-- <li><i class=\"fa fa-recycle\" aria-hidden=\"true\"></i>&nbsp;<span class=\"clickable\">Browse revisions</span></li> -->\r\n              <li><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i><span ng-if=\"vmpg.editPublish && !vmpg.scheduledPost\" ng-cloak><span>&nbsp;Published on</span> <span class=\"fw-semi-bold\">{{vmpg.dataPost.date}}</span></span>\r\n              <span ng-if=\"vmpg.scheduledPost\"><span>&nbsp;Schedule for:</span> <span class=\"fw-semi-bold\">{{vmpg.dataPost.date}}</span></span>\r\n              <span ng-if=\"!vmpg.editPublish && !vmpg.scheduledPost\" ng-cloak><span>&nbsp;Publish</span> <span class=\"fw-semi-bold\">immediately</span></span> <span class=\"clickable\" ng-click=\"vmpg.editPostTime()\">Edit</span>\r\n              <div class=\"date-edit\" ng-if=\"vmpg.editPostDateShow\">\r\n                <select ng-model=\"vmpg.selectedPostMont.value\" class=\"form-control\">\r\n                  <option value=\"1\">1-Jan</option>\r\n                  <option value=\"2\">2-Feb</option>\r\n                  <option value=\"3\">3-Mar</option>\r\n                  <option value=\"4\">4-Apr</option>\r\n                  <option value=\"5\">5-May</option>\r\n                  <option value=\"6\">6-Jun</option>\r\n                  <option value=\"7\">7-Jul</option>\r\n                  <option value=\"8\">8-Aug</option>\r\n                  <option value=\"9\">9-Sep</option>\r\n                  <option value=\"10\">10-Oct</option>\r\n                  <option value=\"11\">11-Nov</option>\r\n                  <option value=\"12\">12-Dec</option>      \r\n                </select>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmpg.postDay\">\r\n                <span>,</span>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmpg.postYear\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmpg.postHours\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmpg.postMinutes\">\r\n                <a ng-click=\"vmpg.setPublishedDate()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmpg.cancelEditPostDate()\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\">\r\n            <a ng-click=\"vmpg.trashPost()\" class=\"clickable-danger\">Move to Trash</a>\r\n            <div ng-if=\"(!vmpg.newPost && vmpg.editPublish) && !vmpg.scheduledPost\" class=\"pull-right\">\r\n              <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vmpg.updateorSavePost()\">Update</button>\r\n            </div>\r\n            <div ng-if=\"(vmpg.newPost || !vmpg.editPublish) && !vmpg.scheduledPost\" class=\"pull-right\">\r\n              <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vmpg.publishPost()\">Publish</button>\r\n            </div>\r\n            <div ng-show=\"vmpg.scheduledPost\" class=\"pull-right\">\r\n              <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"vmpg.publishPost()\">Schedule</button>\r\n            </div>\r\n          </footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget f-image\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Featured Image</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n         <!--  <div class=\"featured\"></div> -->\r\n           <a class=\"clickable\" ng-show=\"!vmpg.hasFeaturedImage\" ng-click=\"vmpg.openSetFeaturedImage()\">Set featured image</a>\r\n           <a ng-show=\"vmpg.hasFeaturedImage\" ng-click=\"vmpg.openSetFeaturedImage()\"><img ng-src=\"{{vmpg.featured_img_obj.thumbs['830x0']}}\"  alt=\"\" class=\"img-responsive\"></a>\r\n         \r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a class=\"clickable-danger\" ng-click=\"vmpg.removeFeaturedImage()\">Remove featured Image</a><button type=\"submit\" class=\"btn btn-primary pull-right\" ng-show=\"vmpg.hasFeaturedImage\" ng-click=\"vmpg.openCropModal()\">Crop Featured image</button></footer>\r\n        </section>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <crop-image-modal ng-if=\"vmpg.cropModalShow\" current-post-obj=\"vmpg\"></crop-image-modal>\r\n  <edit-image-modal ng-if=\"vmpg.editImagefromEditor\" current-post-obj=\"vmpg\"></edit-image-modal>\r\n  <set-featured-image-modal ng-if=\"vmpg.mediaModal\" current-post-obj=\"vmpg\"></set-featured-image-modal>\r\n  <script type=\"text/ng-template\" id=\"editor.html\">\r\n  <textarea class=\"editor-plain-text hidden\" ng-model=\"vmpg.textEditorContent\" ng-keyup=\"vmeditorP.textAreaAdjust($event);\"></textarea>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"modal.html\">\r\n  <div class=\"modal--overlay tinymce-modal\" ng-class=\"{'video-modal':!vmeditorP.pollModalShow}\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n        <h2 ng-if=\"vmeditorP.pollModalShow\">Insert polls</h2>\r\n        <h2 ng-if=\"vmeditorP.tnowModalShow\">Insert tnow video</h2>\r\n        <h2 ng-if=\"vmeditorP.videoModalShow\">Insert video</h2>\r\n       <div ng-click=\"vmeditorP.cancelTinymceModal()\" class=\"btn btn-danger\">Cancel</div>\r\n      </div>\r\n      \r\n      <div class=\"modal--media-content set-image-modal\">\r\n        <div ng-if=\"vmeditorP.pollModalShow\">\r\n          <div class=\"form-group\">\r\n            <label>Choose which poll you would like to add:</label>\r\n            <select ng-model=\"vmeditorP.selectedPollAction.value\" class=\"form-control\">\r\n              <option value=\"default\">Select poll:</option>\r\n              <option value=\"{{poll._id}}\" ng-repeat=\"poll in vmeditorP.polls\">{{poll.date | date:'medium'}}&nbsp;&nbsp;&nbsp;{{poll.title}}</option>\r\n            </select>\r\n          <div class=\"required-error animate-show ng-hide\" ng-show=\"!vmeditorP.requiredPoll\">Choose poll</div>\r\n          </div>\r\n          <div class=\"form-group poll-align\">\r\n            <label>Select Poll Align</label>\r\n              <select ng-model=\"vmeditorP.selectedPollAlignAction.value\" ng-change=\"vmeditorP.switchPollAlignAction(vmeditorP.selectedPollAlignAction.value)\" class=\"form-control\">\r\n              <option value=\"1\">Vertical</option>\r\n              <option value=\"2\">Horizontal</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vmeditorP.tnowModalShow\"> \r\n          <div class=\"form-group\">\r\n            <label>Tnow video ID</label>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"vmeditorP.tnowVideoId\">\r\n          <div class=\"required-error animate-show ng-hide\" ng-show=\"!vmeditorP.requiredTnowId\">Choose tnow ID</div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vmeditorP.videoModalShow\">\r\n          <div class=\"form-group\">\r\n            <label>Service:</label>\r\n            <select ng-model=\"vmeditorP.selectedTypeVideo.value\" ng-change=\"vmeditorP.switchTypeVideo(vmeditorP.selectedTypeVideo.value)\" class=\"form-control\">\r\n              <option value=\"default\">Choose video service</option>\r\n              <option value=\"youtube\">Youtube</option>\r\n              <option value=\"fbvideo\">Facebook</option>\r\n              <option value=\"vimeo\">Vimeo</option>\r\n              <option value=\"dailymotion\">Dailymotion</option>\r\n              <option value=\"tinypic\">TinyPic</option>\r\n            </select>\r\n          <div class=\"required-error animate-show ng-hide\" ng-show=\"!vmeditorP.requiredVideoType\">Choose video service</div>\r\n          </div>\r\n          <div class=\"form-group poll-align\">\r\n            <label>Video ID</label>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"vmeditorP.videoId\">\r\n            <div class=\"required-error animate-show ng-hide\" ng-show=\"!vmeditorP.requiredVideoId\">Choose video ID</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"action\">\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertPoll()\" ng-if=\"vmeditorP.pollModalShow\">Insert Poll</a>\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertTnowVideo()\" ng-if=\"vmeditorP.tnowModalShow\">Insert tnow video</a>\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertVideo()\" ng-if=\"vmeditorP.videoModalShow\">Insert video</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n  </script>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <poll-dir ng-if=\"vmapl.editPollShow\" parent=\"vmapl\"></poll-dir>\r\n  <div ng-if=\"!vmapl.editPollShow\">\r\n  <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Polls</span>&nbsp;<a data-ui-sref=\"app.newpoll\" class=\"btn btn-primary\">New Poll</a></h1>\r\n\r\n  <div class=\"all-polls\">\r\n    <div class=\"status-filter\">\r\n      <ul>\r\n        <li><a ng-click=\"vmapl.changeStatus($event, 'all')\" class=\"clickable\" ng-class=\"{'active':vmapl.status =='all'}\">All</a> |</li>\r\n        <li><a ng-click=\"vmapl.changeStatus($event, 'publish')\" class=\"clickable\" ng-class=\"{'active':vmapl.status =='publish'}\">Publish</a> |</li>\r\n        <li><a ng-click=\"vmapl.changeStatus($event, 'finish')\" class=\"clickable\" ng-class=\"{'active':vmapl.status =='finish'}\">Finish</a> |</li>\r\n        <li><a ng-click=\"vmapl.changeStatus($event, 'trash')\" class=\"clickable\" ng-class=\"{'active':vmapl.status =='trash'}\">Trash</a></li>\r\n      </div>\r\n    </div>\r\n  <div class=\"table-filter\">\r\n    <div class=\"bulk-actions\">\r\n      <select ng-model=\"vmapl.selectedBulkAction.value\" ng-change=\"vmapl.switchBulkAction(vmapl.selectedBulkAction.value)\" class=\"form-control\">\r\n        <option value=\"default\">Bulk Actions</option>\r\n        <option value=\"delete\">Delete</option>\r\n      </select>\r\n      <a ng-click=\"vmapl.bulkAction(vmapl.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n    </div>\r\n    <div class=\"form-group range-picker\" >\r\n        <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmapl.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n    </div>\r\n    <a ng-click=\"vmapl.postFilter()\" class=\"btn btn-primary\">Filter</a>\r\n    <a ng-click=\"vmapl.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n    <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmapl.searchData\" ng-change=\"vmapl.changeSearch(vmapl.searchData)\" ng-enter=\"vmapl.search(vmapl.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmapl.search(vmapl.searchData);\">Search</button></span></div></div>\r\n  </div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmapl.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\" edit=\"post\">\r\n          <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmapl.checkboxes.items[post._id]\" ng-change=\"vmapl.checkedPost(post._id, vmapl.checkboxes.items[post._id])\"/><label></label>\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">{{post._id}}</td>\r\n          <td data-title=\"'Title'\" sortable=\"'title'\" class=\"ng-table--title\">\r\n            <div class=\"title\">\r\n              <span class=\"clickable fw-semi-bold\" ng-click=\"vmapl.editPoll(post._id)\">{{post.title}}</span> \r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vmapl.editPoll(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable clickable-danger\" ng-click = \"vmapl.updateStatus(post, 'publish')\">Publish</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='publish'\"><span class=\"clickable clickable-danger\" ng-click = \"vmapl.updateStatus(post, 'finish')\">Finish</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='publish'\"><span class=\"clickable clickable-danger\" ng-click = \"vmapl.updateStatus(post, 'trash')\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable clickable-danger\" ng-click = \"vmapl.deletePoll(post._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n            <span ng-click=\"\">{{post.date | date:'MMM d, y H:mm'}}</span>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmapl.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\" /><label></label>\r\n      </div>\r\n    </script>\r\n    \r\n  </div>\r\n  </div>\r\n</div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\" ng-class=\"{'edit-post':!vmpl.newPost, 'new-post':vmpl.newPost}\">\r\n  <h1 ng-if=\"!vmpl.newPoll\"class=\"page-title\">Edit <span class=\"fw-semi-bold\">Poll</span>&nbsp;<a data-ui-sref=\"app.newpoll\" class=\"btn btn-primary\">New Poll</a><a ng-click=\"closeEditPoll()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditPoll()\" parametar=\"page\">&times;</a></h1>\r\n  <h1 ng-if=\"vmpl.newPoll\"class=\"page-title\">Add New <span class=\"fw-semi-bold\">Poll</span></h1>\r\n  <div class=\"single-post poll\">\r\n    <div class=\"single-post--columns-wraper\">\r\n      <div class=\"single-post--left-col\">\r\n        <div class=\"form-group title-wrapper\"> \r\n          <h5 class=\"fw-bold\">Poll title</h5>\r\n          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Enter title here\" ng-model=\"vmpl.dataPoll.title\">\r\n          <div class=\"required-error animate-show\" ng-show=\"vmpl.titleRequired\">Poll title is required</div>\r\n        </div> \r\n        <div class=\"choices-wrapper form-group\">\r\n          <h5 class=\"fw-bold\">Poll questions</h5>\r\n          <div data-ng-repeat=\"choice in vmpl.choices\" class=\"form-group\">\r\n            <div class=\"input-field\">\r\n            <input type=\"text\" ng-model=\"choice.text\" name=\"\" placeholder=\"Enter poll question text\" class=\"form-control\">\r\n            </div>\r\n            <div class=\"input-group-no-border\">\r\n              <input type=\"text\" ng-model=\"choice.counter\" class=\"form-control\">\r\n            </div>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmpl.textQuestionRequired\">Text question is required</div>\r\n          </div>\r\n          <button class=\"btn btn-danger pull-right margin-left-10\" ng-click=\"vmpl.removeChoice()\" ng-if=\"vmpl.newPoll\">Remove choice</button>\r\n          <button class=\"btn btn-primary pull-right\" ng-click=\"vmpl.addNewChoice()\" ng-if=\"vmpl.newPoll\">Add choice</button>\r\n        </div>\r\n        <tinymce-basic editor-text=\"vmpl.dataPoll\" order=\"1\" options=\"tag,tolatin\" photo=\"true\" parent-obj=\"vmpl\" update=\"vmpl.update\" ng-if=\"vmpl.dataPoll.content || vmpl.dataPoll.content==''\"></tinymce-basic>\r\n      </div>\r\n      <div class=\"single-post--right-col\">\r\n        <section class=\"single-post--widget widget publish\">\r\n          <header class=\"bb bg-body-light\">\r\n            <h5 class=\"fw-bold\">Poll Publish</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <ul>\r\n              <li ng-if=\"!vmpl.newPoll\"><i class=\"fa fa-key\" aria-hidden=\"true\"></i><span class=\"fw-semi-bold\">&nbsp;Status:&nbsp;</span><span class=\"fw-bold status\" ng-class=\"{'success':vmpl.dataPoll.status=='publish','danger':vmpl.dataPoll.status=='finish'}\" ng-show=\"vmpl.dataPoll.status\">{{vmpl.dataPoll.status}}&nbsp;</span><span class=\"clickable\" ng-click=\"vmpl.editPollStatus()\">-&nbsp;Edit</span>\r\n                <div class=\"editable\" ng-if=\"vmpl.editPollStatusShow\">\r\n                  <select ng-model=\"vmpl.selectedPollStatus.value\" class=\"form-control\">\r\n                    <option value=\"publish\">Publish</option>\r\n                    <option value=\"finish\">Finish</option>\r\n                    <option value=\"trash\">Trash</option>\r\n                  </select>\r\n                  <a ng-click=\"vmpl.changePollStatus()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmpl.cancelEditPollStatus()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n              <li>\r\n                <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\r\n                <span class=\"fw-semi-bold\">&nbsp;Poll active until:&nbsp;</span><span class=\"fw-bold\" ng-show=\"vmpl.dataPoll.expire_date\">{{vmpl.dataPoll.expire_date}}&nbsp;</span>\r\n                <span class=\"clickable\" ng-click=\"vmpl.editPollDate()\">-&nbsp;Edit</span>\r\n                <div class=\"date-edit\" ng-if=\"vmpl.editPollDateShow\">\r\n                  <select ng-model=\"vmpl.selectedPollMonth.value\" class=\"form-control\">\r\n                    <option value=\"1\">1-Jan</option>\r\n                    <option value=\"2\">2-Feb</option>\r\n                    <option value=\"3\">3-Mar</option>\r\n                    <option value=\"4\">4-Apr</option>\r\n                    <option value=\"5\">5-May</option>\r\n                    <option value=\"6\">6-Jun</option>\r\n                    <option value=\"7\">7-Jul</option>\r\n                    <option value=\"8\">8-Aug</option>\r\n                    <option value=\"9\">9-Sep</option>\r\n                    <option value=\"10\">10-Oct</option>\r\n                    <option value=\"11\">11-Nov</option>\r\n                    <option value=\"12\">12-Dec</option>      \r\n                  </select>\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmpl.pollDay\" ng-keypress=\"vmpl.keyPressOnlyNumber($event)\">\r\n                  <span>,</span>\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmpl.pollYear\" ng-keypress=\"vmpl.keyPressOnlyNumber($event)\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmpl.pollHours\" ng-keypress=\"vmpl.keyPressOnlyNumber($event)\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmpl.pollMinutes\" ng-keypress=\"vmpl.keyPressOnlyNumber($event)\">\r\n                  <a ng-click=\"vmpl.setPollDate()\"class=\"btn btn-primary\">Ok</a>\r\n                    <a ng-click=\"vmpl.cancelEditPollDate()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <footer class=\"bt\">\r\n            <a ng-click=\"vmpl.trashPoll()\" class=\"clickable-danger\">Move to Trash</a>\r\n            <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-click = \"vmpl.updatePoll()\" ng-if=\"!vmpl.newPoll\">Update</button>\r\n            <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-click = \"vmpl.publishPoll()\" ng-if=\"vmpl.newPoll\">Publish</button>\r\n          </footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget f-image\" ng-class=\"{'error-border':vmpl.featuredImageRequired}\">\r\n          <header class=\"bb bg-body-light\">\r\n            <h5 class=\"fw-bold\">Featured Image</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <a class=\"clickable fw-semi-bold\" ng-show=\"!vmpl.hasFeaturedImage\" ng-click=\"vmpl.openSetFeaturedImage()\"><img width=\"24\" height=\"24\" src=\"images/transparent.svg\" alt=\"Featured image\">&nbsp;&nbsp;Set featured image</a>\r\n            <a ng-show=\"vmpl.hasFeaturedImage\" ng-click=\"vmpl.openSetFeaturedImage()\"><img ng-src=\"{{vmpl.featured_img_obj.thumbs['620x350']}}\"  alt=\"Feature image\" class=\"img-responsive\" lazy-loading class=\"spinner-show\">\r\n              <div class=\"lazy-loading\">\r\n                <div class=\"image-wrapper\">\r\n                  <img src=\"images/ajax-loader.svg\" alt=\"\">\r\n                </div>\r\n              </div>\r\n            </a>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmpl.featuredImageRequired\">Featured image is required</div>\r\n          </div>\r\n          <footer class=\"bt\">\r\n            <a class=\"clickable-danger fw-semi-bold\" ng-click=\"vmpl.removeFeaturedImage()\"><img width=\"24\" height=\"24\" src=\"images/remove.svg\" alt=\"Remove featured image\">&nbsp;&nbsp;Remove featured Image</a>\r\n          </footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget choice\">\r\n          <header class=\"bb bg-body-light\">\r\n            <h5 class=\"fw-bold\">Multiple choice</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmpl.dataPoll.multiple\" id=\"select-multiple\"><label for=\"select-multiple\" class=\"fw-semi-bold\">&nbsp;Select multiple</label>\r\n            </div>\r\n            <div class=\"input-group-no-border margin-top-10\" ng-show=\"vmpl.dataPoll.multiple\">\r\n              <div class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmpl.dataPoll.max_choices\" ng-keypress=\"vmpl.keyPressOnlyNumber($event)\" ng-focus=\"vmpl.maxChoicesInvalid = false\" ng-class=\"{'error-border': vmpl.maxChoicesInvalid}\">\r\n              </div>\r\n              <label for=\"search-input\" class=\"fw-semi-bold\">&nbsp;Add max choice</label>\r\n            </div>\r\n          </div>\r\n        </section>\r\n        <section class=\"single-post--widget widget ads\">\r\n          <header class=\"bb bg-body-light\">\r\n            <h5 class=\"fw-bold\">Ads</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmpl.dataPoll.ads\" id=\"ads-on\"><label for=\"ads-on\" class=\"fw-semi-bold\">&nbsp;Ads on</label>\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<set-featured-image-modal ng-if=\"vmpl.mediaModal\" current-post-obj=\"vmpl\"></set-featured-image-modal>\r\n<script type=\"text/ng-template\" id=\"insertTag.html\">\r\n  <div class=\"modal--overlay editor-insert-tag\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n         <h2>Insert Tag</h2>\r\n         <div ng-click=\"cancelInsertTagModal()\" ng-escape = \"cancelInsertTagModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content\">\r\n          <div class=\"search-wrapper\">\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"searchTag\" auto-complete-dir enter-tag= \"addNewTag()\" type-dir=\"'insertTag'\" placeholder=\"Search tag ...\" datachangelabel=\"\" datachangeid = \"\" id=\"editor-input-tag\"> \r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>  \r\n</script>\r\n<script type=\"text/ng-template\" id=\"template.html\">\r\n  <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n     <li ng-show=\"!showResult\">No result.</li>\r\n     <li ng-repeat=\"tag in tagsTree | sortingCount: 'descending': 'count' track by tag['_id']\" ng-click=\"chooseSearchData(tag.name, tag._id, tag.url)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}}&nbsp;<span class=\"danger-color fw-semi-bold\" ng-if=\"tag.count || tag.count == 0\">[{{tag.count}}]</span></li>\r\n  </ul>\r\n</script>\r\n<!-- <script type=\"text/ng-template\" id=\"insertEmbedCode.html\">\r\n  <div class=\"modal--overlay editor-insert-embedcode\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n         <h2>Embed code</h2>\r\n         <div ng-click=\"cancelInsertEmbedCodeModal()\" ng-escape = \"cancelInsertEmbedCodeModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content\">\r\n          <textarea type=\"text\" rows=\"10\" class=\"form-control margin-bottom-20\" ng-model=\"embedCode\" placeholder=\"Insert embed code ...\" id=\"insert-embedcode\"></textarea>\r\n          <a class=\"btn btn-primary\" ng-click=\"insertEmbedCode()\">Insert</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>  \r\n</script> -->\r\n<!-- <script type=\"text/ng-template\" id=\"insertPost.html\">\r\n  <div class=\"modal--overlay editor-insert-post\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n         <h2>Insert Post</h2>\r\n         <div ng-click=\"cancelInsertPostModal()\" ng-escape = \"cancelInsertPostModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content\">\r\n          <search-post-dir parent-obj=\"postFromSearchObj\"></search-post-dir>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>  \r\n</script> -->\r\n<!-- <script type=\"text/ng-template\" id=\"modal.html\">\r\n  <div class=\"modal--overlay tinymce-modal\" ng-class=\"{'video-modal':!pollModalShow}\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n          <h2 ng-show=\"quoteModalShow\">Add quote</h2>\r\n          <h2 ng-show=\"videoModalShow\">Insert video</h2>\r\n          <h2 ng-show=\"questionModalShow\">Add question</h2>\r\n        <div ng-click=\"cancelTinymceModal()\" ng-escape = \"cancelTinymceModal()\" class=\"btn btn-danger\">Cancel</div>\r\n        </div>\r\n        \r\n        <div class=\"modal--media-content set-image-modal\">\r\n          <div ng-show=\"questionModalShow\">\r\n            <div class=\"form-group poll-align\">\r\n              <label>Insert question </label>\r\n              <textarea type=\"text\" rows=\"5\" class=\"form-control\" ng-model=\"questionText\" placeholder=\"Insert question text ...\"><textarea/>\r\n                <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredQuestionText\">Question text is required</div>\r\n            </div>\r\n          </div>\r\n          <div ng-show=\"quoteModalShow\">\r\n            <div class=\"form-group poll-align\">\r\n              <label>Select Quote Align</label>\r\n                <select ng-model=\"selectedQuoteAlignAction.value\" ng-change=\"switchQuoteAlignAction(selectedQuoteAlignAction.value)\" class=\"form-control\">\r\n                  <option value=\"left\">Left</option>\r\n                <option value=\"center\">Center</option>\r\n              </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label>Quote text</label>\r\n                <textarea type=\"text\" rows=\"5\" class=\"form-control\" ng-model=\"quoteText\" placeholder=\"Insert quote text ...\"></textarea>\r\n                <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredQuoteText\">Insert quote text</div>\r\n            </div>\r\n          </div>\r\n          <div ng-show=\"videoModalShow\">\r\n            <div class=\"form-group\">\r\n              <label>Service:</label>\r\n              <select ng-model=\"selectedTypeVideo.value\" ng-change=\"switchTypeVideo(selectedTypeVideo.value)\" class=\"form-control\">\r\n                <option value=\"default\">Choose video service</option>\r\n                <option value=\"youtube\">Youtube</option>\r\n                <option value=\"fbvideo\">Facebook</option>\r\n                <option value=\"vimeo\">Vimeo</option>\r\n                <option value=\"dailymotion\">Dailymotion</option>\r\n                <option value=\"tinypic\">TinyPic</option>\r\n              </select>\r\n            <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredVideoType\">Choose video service</div>\r\n            </div>\r\n            <div class=\"form-group poll-align\">\r\n              <label>Video ID</label>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"videoId\">\r\n              <div class=\"required-error animate-show ng-hide\" ng-show=\"requiredVideoId\">Choose video ID</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"action\">\r\n            <a class=\"btn btn-primary\" ng-click=\"insertVideo()\" ng-show=\"videoModalShow\">Insert video</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"insertQuote()\" ng-show=\"quoteModalShow\">Insert quote</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"insertQuestion()\" ng-show=\"questionModalShow\">Insert question</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</script> -->\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n\r\n  <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Popular posts</span></h1>\r\n  <div class=\"popular-posts\">\r\n    <div class=\"tabs-wrapper\">\r\n      <!-- <ul>\r\n        <li ng-repeat=\"category in vmpp.categoriesTabs\"><a ng-click = \"vmpp.changePopularPostsTab($event, category._id)\" ng-class=\"{'active':$index==0}\" class=\"btn-primary\">{{category.name}}</a></li>\r\n      </ul> -->\r\n      <div  class=\"bulk-actions\">\r\n        <select ng-model=\"vmpp.selectedCategoryAction.value\" ng-change=\"vmpp.switchCategoryAction(vmpp.selectedCategoryAction.value)\" class=\"form-control\">\r\n          <option value=\"naslovna\">Naslovna</option>\r\n          <option value=\"{{category._id}}\" ng-repeat=\"category in vmpp.categoriesTabs\">{{category.name}}</option>\r\n        </select>\r\n      </div>\r\n      <search-post-dir parent-obj=\"vmpp\"></search-post-dir>\r\n    </div>\r\n    <div class=\"sortable-grid\">\r\n    <!-- <div class=\"number-focus-news pull-right\">{{vmnt.numberFocusnewsTicker}} items</div> -->\r\n      <table>\r\n        <thead>\r\n          <tr>\r\n          <th class=\"text-center\">Id</th>\r\n          <th>Title</th>\r\n          <th class=\"text-center\">Order</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody sortable-dir ng-model=\"vmpp.popularposts\" class=\"sortable-grid__wrapper\" ng-show=\"vmpp.hasPopularPosts\">\r\n          <tr ng-repeat=\"item in vmpp.popularposts\">\r\n            <td>{{item.id}}</td>\r\n            <td class=\"title-cell\">\r\n              <div>{{item.title}}</div>\r\n              <div class=\"clickable clickable-danger hover-attr\" ng-click=\"vmpp.removeFromPopularPosts($index)\">Remove from popular posts</div>\r\n            </td>\r\n            <td class=\"order-cell text-center\">{{item.order}}</td>\r\n          </tr>\r\n        </tbody>\r\n        <tbody ng-show=\"!vmpp.hasPopularPosts\">\r\n          <tr>\r\n            <td colspan=\"3\">No popular posts for <span class=\"fw-semi-bold\">\"{{vmpp.defaultTab}}\"</span> category.</td>\r\n          </tr>\r\n        </tbody>\r\n        <tfoot>\r\n        <tr>\r\n          <td class=\"text-center\">Id</td>\r\n          <td>Title</td>\r\n          <td class=\"text-center\">Order</td>\r\n        </tr>\r\n        </tfoot>\r\n        </table>\r\n      </div>\r\n      <a ng-click=\"vmpp.addGoogleAnalytics()\" class=\"btn btn-primary pull-left\">Get GA data</a>\r\n      <a ng-click=\"vmpp.addGoolePostsToPopularPosts()\" class=\"btn btn-primary pull-left\" ng-show=\"vmpp.hasPosts\">Add all to popular posts</a>\r\n      <a ng-click=\"vmpp.popularPostSave(vmpp.selectedCategoryAction.value)\" class=\"btn btn-primary pull-right\">Save</a>\r\n      <div class=\"sortable-grid\" >\r\n      <div ng-show=\"vmpp.hasPosts\">\r\n      <h3 class=\"title\">Popular posts from Google Analytics</h3>\r\n      <table>\r\n        <thead>\r\n          <tr>\r\n          <th class=\"text-center\">Id</th>\r\n          <th>Title</th>\r\n          <th class=\"text-center\">Views</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"item in vmpp.popularpostsGoogle\">\r\n            <td class=\"order-cell text-center\">{{item.id}}</td>\r\n            <td class=\"title-cell\">\r\n              <div>{{item.title}}</div>\r\n              <div class=\"clickable hover-attr\" ng-click =\"vmpp.addPost(item)\">Add to popular post</div>\r\n            </td>\r\n            <td class=\"text-center\">{{item.views}}</td>\r\n          </tr>\r\n        </tbody>\r\n        <tfoot>\r\n        <tr>\r\n          <td class=\"text-center\">id</td>\r\n          <td>Title</td>\r\n          <td class=\"text-center\">Views</td>\r\n        </tr>\r\n        </tfoot>\r\n      </table>\r\n      </div>\r\n      <div ng-show=\"vmpp.noResult\" class=\"empty-row\">\r\n        No results at Google analytics.\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <post-dir ng-if=\"vmap.editPostShow\" parent=\"vmap\" parentPost=\"vmap.post_id\" my-post=\"vmap.myPosts\"></post-dir>\r\n  <div ng-if=\"!vmap.editPostShow\">\r\n  <h1 class=\"page-title\"><span ng-show=\"!vmap.myPosts\">All&nbsp;</span><span ng-show=\"vmap.myPosts\">My&nbsp;</span><span class=\"fw-semi-bold\">Posts</span>&nbsp;<a data-ui-sref=\"app.newpost\" class=\"btn btn-primary\">New Post</a></h1>\r\n\r\n  <div class=\"all-posts\">\r\n  <div class=\"status-filter\">\r\n    <ul>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'all')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='all'}\">All</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'publish')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='publish'}\">Published</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'pending')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='pending'}\">Pending</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'draft')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='draft'}\">Draft</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'unlisted')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='unlisted'}\">Unlisted</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'schedule')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='schedule'}\">Scheduled</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'trash')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='trash'}\">Trash</a> |</li>\r\n      <li><a ng-click=\"vmap.changeStatus($event, 'assigned')\" class=\"clickable\" ng-class=\"{'active':vmap.status =='assigned'}\">Assigned</a></li>\r\n      <!-- <li><a ng-click=\"vmap.getApi('deskplus')\" class=\"clickable\" ng-class=\"{'active':vmap.api =='deskplus'}\">Deskplus</a></li> -->\r\n    </ul>\r\n    <div class=\"search\" ng-if=\"!vmap.api\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmap.searchData\" ng-change=\"vmap.changeSearch(vmap.searchData)\" ng-enter=\"vmap.search(vmap.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmap.search(vmap.searchData);\">Search</button></span></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"table-filter\">\r\n    <div class=\"bulk-actions\" ng-if=\"vmap.permisions\">\r\n      <select ng-model=\"vmap.selectedBulkAction.value\" ng-change=\"vmap.switchBulkAction(vmap.selectedBulkAction.value)\" class=\"form-control\">\r\n        <option value=\"default\">Bulk Actions</option>\r\n        <option value=\"edit\" ng-if=\"!vmap.api\">Edit</option>\r\n        <option value=\"trash\" ng-if=\"!vmap.statusTrash && !vmap.api\">Trash</option>\r\n        <option value=\"delete\" ng-if=\"vmap.statusTrash && !vmap.api\">Delete</option>\r\n        <option value=\"deskplus\" ng-if=\"vmap.api\">Save to Draft</option>\r\n      </select>\r\n      <a ng-click=\"vmap.bulkAction(vmap.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n    </div>\r\n    <div class=\"form-group range-picker\" ng-if=\"!vmap.api\">\r\n        <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmap.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n    </div>\r\n    <select ng-model=\"vmap.selectedCategory.value\" ng-change=\"vmap.switchCategories(vmap.selectedCategory.value)\" class=\"form-control\" ng-if=\"!vmap.api\">\r\n      <option value=\"all\">View all categories</option>\r\n      <option ng-repeat= \"category in vmap.categoriesTreeSelect\" value=\"{{category._id}}\" class=\"level{{category.ancestors.length}}\" ng-bind=\"category.name\"></option>\r\n    </select>\r\n    <select ng-model=\"vmap.selectedAuthorFilter.value\" ng-change=\"vmap.switchAuthorFilter(vmap.selectedAuthorFilter.value)\" class=\"form-control\" ng-if=\"!vmap.api\" ng-show=\"!vmap.myPosts\">\r\n      <option value=\"all\">View all authors</option>\r\n      <option ng-repeat= \"author in vmap.authorList\" value=\"{{author._id}}\">{{author.display_name}} ({{author._id}})</option>\r\n    </select>\r\n    <a ng-click=\"vmap.postFilter()\" class=\"btn btn-primary\" ng-if=\"!vmap.api\">Filter</a>\r\n    <a ng-click=\"vmap.resetAllFilters()\" class=\"btn btn-info\" ng-if=\"!vmap.api\">Clear all Filters</a>\r\n    \r\n    <div class=\"bulk-actions-edit\" ng-show=\"!vmap.hiddenBulkEdit\" ng-if=\"!vmap.api\">\r\n      <div class=\"bulk-action-edit--wrapper\">\r\n        <div class=\"bulk-actions-edit--title\">\r\n          <h2 class=\"fw-semi-bold\">Bulk Edit</h2>\r\n          <ul>\r\n          <li ng-repeat=\"editPost in vmap.checkedPostsEdit\"><span ng-click=\"vmap.removeEditPost(editPost._id)\" class=\"remove-from-list\" title=\"Remove from bulk edit\">X</span>{{editPost.title}}</li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"categories-tree\">\r\n        <h3>Categories</h3>\r\n          <ul>\r\n            <li ng-repeat=\"categoryInput in vmap.categoriesTreeInput\" class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmap.categorychecked.item[categoryInput._id]\" ng-click = \"vmap.updateSelection(categoryInput._id, vmap.categorychecked.item[categoryInput._id], categoryInput, $event)\" id=\"bulk-category-{{categoryInput._id}}\"><label for=\"bulk-category-{{categoryInput._id}}\">{{categoryInput.name}}</label>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other\">\r\n        <!-- <div class=\"form-group search-wrapper\">\r\n          <h3>Tags</h3>\r\n          <div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmap.searchtagfocus\" auto-complete-dir datachangelabel=\"\" datachangeid = \"\" enter-tag= \"vmap.addNewTag()\" type-dir=\"'post'\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmap.addNewTag()\">Add tag</button></span></div>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmap.existTag\">Tag alredy exist</div>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmap.newTagRequired\">New tag required</div>\r\n            <ul class=\"list-tags\">\r\n              <li ng-repeat=\"tag in vmap.bulkTags\"><span class=\"remove-from-list\" ng-click=\"vmap.removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n            </ul>\r\n         </div> -->\r\n          <div class=\"bulk-actions-edit--other__row\">\r\n            <h3>Comments</h3>\r\n            <select ng-model=\"vmap.selectedBulkActionComments.value\" ng-change=\"vmap.switchBulkActionComments(vmap.selectedBulkActionComments.value)\" class=\"form-control\">\r\n              <option value=\"default\">-No Change-</option>\r\n              <option value=\"allow\">Allow</option>\r\n              <option value=\"do-not-allow\">Do not allow</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"bulk-actions-edit--other__row\">\r\n            <h3>Status</h3>\r\n            <select ng-model=\"vmap.selectedBulkActionStatus.value\" ng-change=\"vmap.switchBulkActionStatus(vmap.selectedBulkActionStatus.value)\" class=\"form-control\">\r\n              <option value=\"default\">-No Change-</option>\r\n              <option value=\"publish\">Published</option>\r\n             <!--  <option value=\"private\">Private</option> -->\r\n              <option value=\"pending\">Pending Review</option>\r\n              <option value=\"draft\">Draft</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"bulk-actions-edit--other__button\">\r\n            <a class=\"btn btn-primary\" ng-click=\"vmap.updateBulkAction()\">Update</a>\r\n          </div>\r\n          <div class=\"bulk-actions-edit--other__button\">\r\n            <a ng-click=\"vmap.cancelBulkEdit()\"class=\"btn btn-danger\">Cancel</a>\r\n          </div>       \r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"italic\">Number of items: <span class=\"fw-semi-bold\">{{vmap.numberOfItems}}</span></div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmap.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\" edit=\"post\" quick-edit category=\"vmap.categoriesTreeInput\">\r\n        <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n          <div class=\"checkbox checkbox-primary\" ng-if=\"!vmap.postLocked[post._id]\">\r\n            <input type=\"checkbox\" ng-model=\"vmap.checkboxes.items[post._id]\" ng-change=\"vmap.checkedPost(vmap.checkboxes.items[post._id],post)\"/><label></label>\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">\r\n          <span>{{post._id}}</span>\r\n          <div class=\"live-badge\" ng-show=\"post.meta.options.display_live\" ng-class=\"post.category.ancestors[0]\"></div>\r\n        </td>\r\n        <td data-title=\"'Title'\" sortable=\"'title'\" class=\"ng-table--title\">\r\n          <div class=\"title\">\r\n            <span ng-if=\"post.status!='trash' && !vmap.api\" class=\"fw-semi-bold\" ng-class=\"{'clickable':!vmap.postLocked[post._id],'not-clickable': vmap.postLocked[post._id]}\" ng-click=\"vmap.editPost(post._id)\">{{post.title}}</span>\r\n            <span ng-if=\"post.status=='trash' || vmap.api\" class=\"fw-semi-bold\">{{post.title}}</span>\r\n          </div>\r\n          <div ng-if=\"vmap.postLocked[post._id] && !vmap.api\">\r\n            <p class=\"danger\" ng-class=\"{'success': vmap.postLocked[post._id].personal_message}\">{{vmap.postLocked[post._id].personal_message || vmap.postLocked[post._id].message}}</p>\r\n            <div class=\"title-actions\" ng-if=\"!vmap.postLocked[post._id].personal_message\">\r\n              <ul>\r\n                <li ng-if=\"!vmap.statusTrash && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.previewPost(post)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status!='trash' && post.status !='publish' && post.preview\"><span class=\"clickable\" ng-click=\"vmap.previewPost(post)\">Preview</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'focus'},{'document_id':post._id,'type':'post','title':post.title})\">Add to Focus</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther('focusvreme',post._id)\">Add to Focus Weather</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.addToOther('newsticker',post._id)\">Add to News Ticker</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.addToOther({'param1':'pushnotifications'},{'document_id':post._id,'type':'post'})\">Add to Push Notifications</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-warning\" ng-click=\"vmap.removeFromOther({'param1':'pushnotifications','param2': 'post','param3': post._id})\">Remove from Push Notifications</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'intext-galleries','param2':post._id})\">Add to Related Galleries</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'posts','param2':'social','param3':post._id})\">Add to SMP</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-warning\" ng-click=\"vmap.removeFromOther({'param1':'posts','param2':'social',param3:post._id})\">Remove from SMP</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n                <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"addToExchange('blic',post._id)\">Add to Blic exchange</span><span class=\"divider-bar\">&nbsp;|</span></li> -->                \r\n                <li ng-if= \"vmap.takeoverPermisions\"><span class=\"clickable clickable-info\" ng-click=\"vmap.takeover(post._id)\">Takeover</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"title-actions\" ng-if=\"vmap.postLocked[post._id].personal_message\">\r\n              <li><span class=\"clickable clickable-info\" ng-click=\"vmap.takeover(post._id)\">Takeover</span></li>\r\n            </div>\r\n          </div>\r\n          <div class=\"title-actions\" ng-if=\"!vmap.postLocked[post._id] && !vmap.api\">\r\n            <ul>\r\n              <!-- <li ng-if=\"!vmap.statusTrash\"><span class=\"clickable\">Post Revisions</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <li ng-if=\"post.status=='trash' && vmap.permisions\"><span class=\"clickable\" ng-click = \"vmap.updateStatusPost(post._id, 'publish');vmap.tableReloadFunction(vmap.tableParams.page());\">Publish this post</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status=='trash' && vmap.permisions\"><span class=\"clickable\" ng-click = \"vmap.updateStatusPost(post._id, 'draft');vmap.tableReloadFunction(vmap.tableParams.page());\">Save to draft</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status!='trash'\"><span class=\"clickable\" ng-click=\"vmap.editPost(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <!-- <li ng-if=\"post.status!='trash' && vmap.permisions\"><span class=\"clickable\" ng-click=\"post.quickEdit()\">Quick Edit</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <li ng-if=\"post.status!='trash' && vmap.permisions\"><span class=\"clickable clickable-danger\" ng-click=\"vmap.updateStatusPost(post._id,'trash');vmap.tableReloadFunction(vmap.tableParams.page());\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status=='trash' && vmap.superPermisions\"><span class=\"clickable clickable-danger\" ng-click=\"vmap.deletePosts(post._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"!vmap.statusTrash && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.previewPost(post)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li ng-if=\"post.status!='trash' && post.status !='publish' && post.preview\"><span class=\"clickable\" ng-click=\"vmap.previewPost(post)\">Preview</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'focus'},{'document_id':post._id,'type':'post','title':post.title})\">Add to Focus</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.addToOther('focusvreme',post._id)\">Add to Focus Weather</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmap.addToOther('newsticker',post._id)\">Add to News Ticker</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'pushnotifications'},{'document_id':post._id,'type':'post'})\">Add to Push Notifications</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-warning\" ng-click=\"vmap.removeFromOther({'param1':'pushnotifications','param2': 'post','param3': post._id})\">Remove from Push Notifications</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'intext-galleries','param2':post._id})\">Add to Related Galleries</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmap.addToOther({'param1':'posts','param2':'social','param3':post._id})\">Add to SMP</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-warning\" ng-click=\"vmap.removeFromOther({'param1':'posts','param2':'social',param3:post._id})\">Remove from SMP</span><span class=\"divider-bar\">&nbsp;|</span></li>                 -->\r\n              <!-- <li ng-if= \"vmap.permisions && post.status =='publish'\"><span class=\"clickable clickable-success\" ng-click=\"addToExchange('blic',post._id)\">Add to Blic exchange</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n            </ul>\r\n          </div>\r\n          <div ng-if=\"vmap.api\">\r\n            <ul>\r\n              <li><span class=\"clickable clickable-success fw-semi-bold\" ng-click=\"vmap.getFromApi('deskplus',post._id)\">Save to draft</span></li>\r\n            </ul>\r\n          </div>\r\n        </td>\r\n          <td data-title=\"'Author'\" class=\"ng-table--author\">\r\n              <span ng-click=\"vmap.authorPosts(post.author._id)\" class=\"clickable\" ng-class=\"{'editHidden':$index==vmap.selectedAuthor}\" ng-if=\"!vmap.api\">{{post.author.display_name}}</span>\r\n              <span ng-if=\"vmap.api\">{{post.author.display_name}}</span>\r\n          </td>\r\n          <td data-title=\"'comments'\" sortable=\"'comment_count'\" class=\"ng-table--comment_count\" ng-if=\"!vmap.api\">\r\n              <span class=\"comment-count\" ng-click=\"vmap.searchComment(post)\" ng-class=\"[(post.comments_priority && post.comments_priority>0)?'comments-priority-' + post.comments_priority:'']\">{{post.comment_count}}</span>\r\n          </td>\r\n          <td data-title=\"'Date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n              <span ng-click=\"\">{{post.date | date:'MMM dd, y HH:mm'}}</span>\r\n              <span ng-if=\"post.status=='publish'\" class=\"fw-semi-bold\">Published</span>\r\n              <span ng-if=\"post.status=='trash'\" class=\"fw-semi-bold\">Trashed</span>\r\n              <span ng-if=\"post.status=='pending'\" class=\"fw-semi-bold\">Pending</span>\r\n              <span ng-if=\"post.status=='schedule'\" class=\"fw-semi-bold\">Scheduled</span>\r\n              <span ng-if=\"post.status=='unlisted'\" class=\"fw-semi-bold\">Unlisted</span>\r\n              <span ng-if=\"post.status=='draft'\" class=\"fw-semi-bold\">Draft</span>\r\n          </td>\r\n          <td header=\"'ng-table/headers/stats.html'\" class=\"ng-table--stats\">\r\n              <div class=\"stats-indicators\">\r\n                  <span class=\"status-circle\" ng-class=\"{'status-red': post.editor_character_count < 800, 'status-green': post.editor_character_count >= 800, 'status-no-value': !post.editor_character_count}\"></span>\r\n                  <span class=\"divider\">/</span>\r\n                  <span class=\"status-circle\" ng-class=\"{'status-red': !post.keywords || post.keywords.length === 0, 'status-green': post.keywords && post.keywords.length > 0}\"></span>\r\n              </div>\r\n          </td>\r\n          <td data-title=\"'Categories'\" class=\"ng-table--categories\">\r\n            <span ng-click=\"vmap.categoryPosts(post.category._id)\" class=\"clickable\" ng-if=\"!vmap.api\">{{post.category.name}}</span>\r\n            <span ng-if=\"vmap.api\">{{post.category.name}}</span>\r\n           \r\n            <!-- <span ng-click=\"vmap.editCategory(post.category._id)\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></span> -->\r\n              \r\n          </td>\r\n          <td data-title=\"'Tags'\" class=\"ng-table--tags\">\r\n              <ul>\r\n                <li ng-repeat = \"tags in post.tags\" class=\"clickable inline\" ng-click=\"vmap.tagPosts(tags)\" ng-if=\"!vmap.api\">{{tags}}<span class=\"coma\">,&nbsp;</span></li>\r\n                <li ng-repeat = \"tags in post.tags\" class=\"inline\" ng-if=\"vmap.api\">{{tags}}<span class=\"coma\">,&nbsp;</span></li>\r\n              </ul>   \r\n          </td>\r\n          <td data-title=\"'Order'\" class=\"ng-table--order\" sortable=\"'order'\">\r\n            <div class=\"input-group input-group-no-border\">\r\n             <input type=\"text\" ng-model=\"post.order\" class=\"form-control\" ng-change=\"vmap.changeOrder()\" ng-blur=\"vmap.outOrderFocus(post._id,post.order)\" ng-enter=\"vmap.outOrderFocus(post._id,post.order)\" ng-if=\"!vmap.api\" ng-readonly=\"vmap.postLocked[post._id]\" ng-class=\"{'readonly': vmap.postLocked[post._id]}\">\r\n             <input type=\"text\" ng-model=\"post.order\" class=\"form-control\" ng-if=\"vmap.api\" class=\"readonly\" readonly>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n    <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmap.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n      </div>\r\n    </script>\r\n    <script type=\"text/ng-template\" id=\"ng-table/headers/stats.html\">\r\n      <div class=\"stats-indicators-header\">\r\n        <i class=\"fa fa-font\" aria-hidden=\"true\" title=\"Character count\"></i>\r\n        <span class=\"divider\">/</span>\r\n        <i class=\"fa fa-bookmark\" aria-hidden=\"true\" title=\"Keywords\"></i>\r\n      </div>\r\n    </script>\r\n    <script type=\"text/ng-template\" id=\"template.html\">\r\n    <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n      <li ng-show=\"!showResult\">No result.</li>\r\n      <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.name, tag._id)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})</li>\r\n    </ul>\r\n  </script>\r\n    <!--<script type=\"text/ng-template\" id=\"quickedit.html\">\r\n        <tr class=\"quick-edit-row\" id=\"quick-edit\"> \r\n            <td colspan=\"9\" class=\"quick-edit\">\r\n\r\n               <div class=\"bulk-actions-edit\">\r\n      <div class=\"bulk-actions-edit--title\">\r\n        <h2 class=\"fw-semi-bold\">Quick Edit</h2>\r\n          <div class=\"form-group\">\r\n            <label for=\"normal-field\" class=\"control-label\">Title</label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"edit.title\">\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"edit.slug\"> \r\n          </div>\r\n      </div>\r\n      <div class=\"categories-tree\">\r\n      <h3>Categories</h3>\r\n        <ul id=\"categoryscrollQuickEdit\">\r\n          <li ng-repeat=\"categoryInput in AllCategories\" class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\" ng-class=\"{'checked': categorychecked.item[categoryInput._id]}\"><div class=\"checkbox checkbox-primary\"><input id=\"category_{{categoryInput._id}}\" type=\"checkbox\" ng-model=\" categorychecked.item[categoryInput._id]\" ng-click=\"updateSelection(categoryInput._id, categorychecked.item[categoryInput._id])\"><label for=\"category_{{categoryInput._id}}\">{{categoryInput.name}}</label></div>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"bulk-actions-edit--other\">\r\n        <div class=\"bulk-actions-edit--other__row input-group input-group-no-border\">\r\n          <h3>Order</h3>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"edit.order\">\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other__row\">\r\n        <h3>Tags</h3>\r\n        <div class=\"form-group search-wrapper\">\r\n          <div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"searchtagfocus\" auto-complete-dir datachangelabel=\"\" datachangeid = \"\" enter-tag= \"addNewTag()\"> <span class=\"input-group-btn\" type-dir=\"'post'\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addNewTag()\">Add</button></span></div>\r\n          <div class=\"required-error animate-show\" ng-if=\"newTagRequired\" ng-cloak>New tag required</div>\r\n          <div class=\"required-error animate-show\" ng-show=\"existTag\">Tag alredy exist</div>\r\n          <ul class=\"list-tags\">\r\n            <li ng-repeat=\"tag in edit.tags\"><span class=\"remove-from-list\" ng-click=\"removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n          </ul>\r\n       </div>\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other__row\">\r\n          <h3>Status</h3>\r\n          <select ng-model=\"selectedBulkActionStatus.value\" ng-change=\"switchBulkActionStatus(selectedBulkActionStatus.value)\" class=\"form-control\">\r\n            <option value=\"publish\">Published</option>\r\n            <option value=\"pending\">Pending Review</option>\r\n            <option value=\"draft\">Draft</option>\r\n            <option value=\"trash\">Trash</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other__row\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"allowcomments\"><label>Allow comments</label>\r\n            </div>\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other__button\">\r\n          <a class=\"btn btn-primary\" ng-click=\"quickEditPost($event)\">Update</a>\r\n        </div>\r\n        <div class=\"bulk-actions-edit--other__button\">\r\n          <a ng-click=\"cancelQuickEdit($event)\"class=\"btn btn-danger\">Cancel</a>\r\n        </div>       \r\n      </div>\r\n    </div>\r\n            </td>\r\n            \r\n        </tr>\r\n    </script>-->\r\n  </div>\r\n<!-- <div class=\"modal--overlay\" ng-show=\"vmap.editCategoryShow\" category-modal>\r\n  <div class=\"modal--Category-dialog\" id=\"modalCategoryEdit\">\r\n    <div class=\"modal--Category-header\">\r\n    <span class=\"btn btn-primary\">Save</span><span ng-click=\"vmap.cancelCategoryModal()\" class=\"btn btn-danger\">Cancel</span>\r\n    </div>\r\n    <ul>\r\n      <li ng-repeat=\"categoryInput in vmap.categoriesTreeInput\" class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\"><input type=\"checkbox\" ng-model=\"vmap.categorychecked.item[categoryInput._id]\" ng-click = \"vmap.updateSelection(categoryInput._id)\" ng-class=\"{'checked': vmap.categorychecked.item[categoryInput._id]}\">{{categoryInput.name}}\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div> -->\r\n</div>\r\n</div>\r\n<search-comments ng-if=\"vmap.serchCommentsModalShow\" obj=\"vmap\"></search-comments>\r\n<add-post-to-exchange ng-if=\"addPostToExchangeModal\"></add-post-to-exchange>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <category-edit-dir ng-if=\"vmc.categoryEdit\" parent=\"vmc\"></category-edit-dir>\r\n  <div>\r\n    <div class=\"categories-posts\">\r\n      <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Categories</span></h1>\r\n   \r\n    <div class=\"categories-posts--left-column\">\r\n      <h4 class=\"fw-semi-bold\">Add New Category</h3>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter category name\" ng-model=\"vmc.categoryName\"></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmc.nameRequired\">Category name is required.</div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter category slug\" ng-model=\"vmc.categorySlug\" ng-keypress=\"vmc.keyPressSlugify()\" ng-change=\"vmc.categorySlugValidate(vmc.categorySlug)\" ng-class=\"{'error-border':!vmc.slugValid}\"></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"!vmc.slugValid\" ng-cloak>Invalid category slug</div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"normal-field\" class=\"control-label\">Parent</label>\r\n         <select ng-model=\"vmc.selectedCategory.value\" ng-change=\"vmc.switchCategories(vmc.selectedCategory.value)\" class=\"form-control\">\r\n        <option value=\"none\">None</option>\r\n        <option ng-repeat= \"categorySelect in vmc.categoriesTreeSelect\" value=\"{{categorySelect._id}}\" class=\"level{{categorySelect.ancestors.length}}\" ng-bind=\"categorySelect.name\"></option>\r\n      </select>\r\n        <div class=\"input-description\">Categories, unlike tags, can have a hierarchy. You might have a Jazz category, and under that have children categories for Bebop and Big Band. Totally optional.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmc.categoryDescription\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <a class=\"btn btn-primary\" ng-click=\"vmc.addNewCategory()\" ng-disabled=\"!vmc.slugValid\">Add New Category</a>\r\n      </div>\r\n    </div>\r\n    <div class=\"categories-posts--right-column\">\r\n      <div class=\"table-filter\">\r\n        <div class=\"bulk-actions\" bulk-delete-dir objdata=\"vmc\" state1=\"'categories'\" ids=\"vmc.checkedPostsEdit\" success-update-func=\"vmc.updateBulkDeleteSuccess\" ng-if=\"vmc\">\r\n          <select ng-model=\"vmc.selectedBulkAction.value\" ng-change=\"vmc.switchBulkAction(vmc.selectedBulkAction.value)\" class=\"form-control\">\r\n            <option value=\"default\">Bulk Actions</option>\r\n            <option value=\"delete\">Delete</option>      \r\n          </select>\r\n          <a ng-click=\"vmc.bulkAction(vmc.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n        </div>\r\n        <div class=\"form-group search\">\r\n          <input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmc.searchData.name\"  ng-change=\"vmc.changeSearch(vmc.searchData)\">\r\n        </div>\r\n      </div>\r\n      <div class=\"widget-body table-wrapper\">\r\n        <table ng-table=\"vmc.tableParams\" class=\"table table-condensed table-bordered table-striped categories-table\">\r\n          <tr ng-repeat=\"category in $data\">\r\n          <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmc.checkboxes.items[category._id]\" ng-change=\"vmc.checkedPost(category._id, vmc.checkboxes.items[category._id])\"/><label></label>\r\n          </div>\r\n          </td>\r\n          <!-- <td data-title=\"'#'\" class=\"posts-table--id\" sortable=\"'post_id'\">{{post.post_id}}</td> -->\r\n          <td data-title=\"'Name'\" sortable=\"'name'\" class=\"ng-table--title\" quick-edit-dir objdata=\"category\" state1=\"'categories'\" visible=\"true\" description=\"true\" name=\"true\" success-update-func=\"vmc.getCategories\">\r\n            <div class=\"title level{{category.ancestors.length}}\">\r\n              <span class=\"clickable fw-semi-bold category-name\" ng-class=\"{'editHidden':category._id==vmc.selectedName}\" ng-click=\"vmc.editCategory(category._id)\">{{category.name}}</span>\r\n              \r\n              <div ng-class=\"{'editShow':category._id==vmc.selectedName}\" class=\"title-edit\">\r\n                <h5>QUICK EDIT</h5>\r\n                <div class=\"form-group\">\r\n                  <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n                  <input type=\"text\" ng-model=\"category.name\" class=\"form-control\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n                  <textarea type=\"text\" ng-model=\"category.description\" class=\"form-control\"></textarea>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <div class=\"checkbox checkbox-primary\">\r\n                    <input type=\"checkbox\" ng-model=\"category.visible\" id=\"visibility_{{category._id}}\"><label for=\"visibility_{{category._id}}\">Visible</label>\r\n                  </div>\r\n                </div>\r\n                <a ng-click=\"category.updateQuickEdit();vmc.cancelQuickEdit();\" class=\"btn btn-primary\">Update Category</a> \r\n                <a ng-click=\"category.cancelQuickEdit();vmc.cancelQuickEdit()\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n            </div>\r\n            <div class=\"title-actions\" ng-class=\"{'editHidden':category._id==vmc.selectedName}\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vmc.editCategory(category._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable\" ng-click=\"vmc.quickEdit(category._id);category.quickEdit()\">Quick Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <delete-item-dir ng-if=\"!category.count\" ele-id=\"category._id\" state1=\"'categories'\" success-delete-func=\"vmc.getCategories\"></delete-item-dir>\r\n                <li><span ng-click=\"vmc.goToAllPosts(category._id)\" class=\"clickable\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n            <td data-title=\"'Description'\" sortable=\"'description'\" class=\"ng-table--description\">\r\n                <span>{{category.description}}</span>\r\n            </td>\r\n            <td data-title=\"'Slug'\" sortable=\"'slug'\" class=\"ng-table--slug\">\r\n                <span>{{category._id}}</span>\r\n            </td>\r\n            <td data-title=\"'Count'\" sortable=\"'count'\" class=\"ng-table--count\">\r\n                <span  ng-click=\"vmc.goToAllPosts(category._id)\" class=\"clickable\">{{category.count}}</span>\r\n            </td>\r\n            <td data-title=\"'Visible'\" class=\"ng-table--visibility\">\r\n              <span class=\"success\" ng-if=\"category.visible\">Visible</span>\r\n              <span class=\"danger\" ng-if=\"!category.visible\">Hidden</span>\r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n          <p>No result. Try again.</p>\r\n        </div> \r\n        <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmc.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n          </div>\r\n        </script>\r\n      </div>\r\n    </div>\r\n    \r\n    </div>\r\n  </div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit\">\r\n\r\n  <div class=\"category-edit\">\r\n    <h1 class=\"page-title\">Edit<span class=\"fw-semi-bold\">&nbsp;Category</span><a ng-click=\"closeEditCategory()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditCategory()\" parametar=\"page\">&times;</a></h1> \r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"\" ng-model=\"vmce.category.name\"></div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control readonly\" placeholder=\"\"ng-model=\"vmce.category._id\" readonly></div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"normal-field\" class=\"control-label\">Parent</label>\r\n        <select ng-model=\"vmce.selectedCategory.value\" ng-change=\"vmce.switchCategories(vmce.selectedCategory.value)\" class=\"form-control readonly\">\r\n          <option value=\"none\" disabled>None</option>\r\n          <option ng-repeat=\"category in parent.categoriesTreeSelect\" ng-bind=\"category.name\" class=\"level0\" value=\"{{category._id}}\" disabled></option>\r\n        </select>\r\n        <div class=\"input-description\">Categories, unlike tags, can have a hierarchy. You might have a Jazz category, and under that have children categories for Bebop and Big Band. Totally optional.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmce.category.description\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmce.category.visible\" id=\"visibility\"><label for=\"visibility\">Visible</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" quick-edit-dir objdata=\"vmce.category\" state1=\"'categories'\" visible=\"true\" description=\"true\" name=\"true\" success-update-func=\"parent.getCategories\" ng-if=\"vmce.category\">\r\n        <a ng-click=\"vmce.category.updateQuickEdit()\" class=\"btn btn-primary\">Update Category</a>\r\n      </div>\r\n  </div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n    \t <h2 ng-if=\"!cropthumbs\">Crop featured image</h2>\r\n       <h2 ng-if=\"cropthumbs\">Crop thumbnail</h2>\r\n    \t <div ng-click=\"currentPostObj.cancelCropModal()\" ng-escape = \"currentPostObj.cancelCropModal()\" class=\"btn btn-danger\" parametar=\"modal\">Close</div>\r\n      </div>\r\n      <div class=\"modal--media-content crop-image-modal\">\r\n        <div class=\"column-wrapper\">\r\n          <div class=\"left-column\">\r\n            <div class=\"crop-image-wrapper-outer\">\r\n              <p class=\"text-center fw-semi-bold\">Raw: {{currentPostObj.featured_img_obj.meta.width}} pixel x {{currentPostObj.featured_img_obj.meta.height}} pixel</p>\r\n              <div class=\"crop-image-wrapper\">\r\n              <croppie-dir src=\"currentPostObj.featured_img_obj.file\" ng-model=\"croppedImage\" post-obj=\"currentPostObj\">\r\n              </croppie-dir>\r\n              </div>\r\n              <div class=\"action\">\r\n                <a class=\"btn btn-primary\" ng-click=\"cropImage()\">Crop and Save image</a>\r\n              </div>\r\n            </div>\r\n            \r\n          </div>\r\n          <div class=\"right-column\">\r\n            <div class=\"selected-image\">\r\n              <span>Selected crop area:&nbsp;</span>\r\n              <span class=\"fw-semi-bold\">{{selectedImage}}</span>\r\n            </div>\r\n            <div ng-repeat= \"thumb in thumbsArray\" ng-click = \"setCropArea($index,thumb.width,thumb.height,currentPostObj.featured_img_obj.thumbs[thumb.width+'x'+thumb.height])\" class=\"thumbs-wrap\" ng-class=\"{'active':index==$index}\">\r\n              <div >\r\n                <p class=\"fw-semi-bold\">img-{{thumb.width}}x{{thumb.height}} <span>&nbsp; - {{thumb.description}}</span><p>\r\n                <p>Dimensions: {{thumb.width}} pixel x {{thumb.height}} pixel</p>\r\n                <img ng-src=\"{{currentPostObj.featured_img_obj.thumbs[thumb.width+'x'+thumb.height]}}\" alt=\"\">\r\n            </div>\r\n            \r\n          </div>\r\n        </div>\r\n      </div>\r\n  \t</div>\r\n  </div>\r\n</div>\r\n<script type=\"text/ng-template\" id=\"loader.html\">\r\n  <div class=\"lazy-loading\" ng-show=\"loaderImageShow\">\r\n    <div class=\"image-wrapper\">\r\n        <img src=\"images/ajax-loader.svg\" alt=\"\">\r\n      </div>\r\n  </div>\r\n</script>"

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay dictionary\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Add to Dictionary</h2>\r\n       <div ng-click=\"currentPostObj.closeDictionaryModal()\" ng-escape = \"currentPostObj.closeDictionaryModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content set-image-modal\">\r\n        <div class=\"form-group\">\r\n          Add word <span class=\"clickable clickable-success fw-semi-bold\">\"{{currentPostObj.misspelledWord}}\"</span> to dictionary.\r\n        </div>\r\n      <div class=\"action\">\r\n        <a class=\"btn btn-primary\" ng-click=\"addToDictionary()\">Add word</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n "

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay edit-image\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n    \t <h2>Image details</h2>\r\n    \t <div ng-click=\"currentPostObj.cancelImageModal();resetMediaSelected()\" ng-escape = \"currentPostObj.cancelImageModal();resetMediaSelected()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content set-image-modal\">\r\n        <div class=\"left-column\">\r\n          <div class=\"form-group\">\r\n            <label>Caption</label>\r\n            <textarea ng-model=\"editImageObj.signature\" class=\"form-control\" ng-class=\"{'error-border':!editImageObj.signature && editImageObj._id}\" ng-cloak></textarea>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label>Align</label>\r\n            <ul class=\"tab-buttons\">\r\n              <li><a ng-click=\"changeAlignStatus($event, 'alignleft')\" class=\"btn btn-default\" ng-class=\"{'active':activeClassAlign.alignleft}\">Left</a></li>\r\n              <li><a ng-click=\"changeAlignStatus($event, 'aligncenter')\" class=\"btn btn-default\" ng-class=\"{'active':activeClassAlign.aligncenter}\">Center</a></li>\r\n              <li><a ng-click=\"changeAlignStatus($event, 'alignright')\" class=\"btn btn-default\" ng-class=\"{'active':activeClassAlign.alignright}\">Right</a></li>\r\n              <li><a ng-click=\"changeAlignStatus($event, 'alignnone')\" class=\"btn btn-default\" ng-class=\"{'active':activeClassAlign.alignnone}\">None</a></li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label for=\"search-input\">Link to:</label>\r\n            <select ng-model=\"selectedLink.value\" ng-change=\"changeLink(selectedLink.value)\" class=\"form-control\">\r\n              <option value=\"none\">None</option>\r\n              <option value=\"url\">Custom Url</option>      \r\n            </select>\r\n          </div>\r\n          <div class=\"form-group\" ng-show=\"customUrlShow\">\r\n            <input type=\"text\" class=\"form-control custom-url\" ng-model=\"editImageObj.link_to\" >\r\n          </div>\r\n          <div class=\"form-group\" ng-show=\"customUrlShow\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"editImageObj.target_blank\"><label>Open link in a new window/tab</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\">Photo status:&nbsp;\r\n            <div class=\"clickable lock-wrapper\">\r\n                <img src=\"images/lock.svg\" alt=\"lock-image\" title = \"Unlock image\" ng-if=\"editImageObj.status == 'lock'\" ng-click=\"changeMediaStatus(editImageObj._id,'publish')\">\r\n                <img src=\"images/unlock.svg\" alt=\"unlock-image\" title = \"Lock image\" ng-if=\"editImageObj.status == 'publish'\" ng-click=\"changeMediaStatus(editImageObj._id,'lock')\">\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <a ng-click=\"deleteMedia(editImageObj._id)\" class=\"clickable clickable-danger\">Delete permanently</a>\r\n          </div>\r\n        </div>\r\n        <div class=\"right-column\">\r\n        <div class=\"image-wrapper\">\r\n          <img ng-src=\"{{editImageObj.thumbs['830x0']}}\" alt=\"\">\r\n        </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"action\">\r\n        <a class=\"btn btn-primary\" ng-click=\"updateImage()\">Update image</a>\r\n      </div>\r\n  \t</div>\r\n  </div>\r\n</div>\r\n\r\n "

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\" ng-class=\"{'edit':!vmp.newPost}\">\r\n  <h1 ng-if=\"!vmp.newPost\" class=\"page-title\">Edit <span class=\"fw-semi-bold\">Post</span>&nbsp;<a data-ui-sref=\"app.newpost\" class=\"btn btn-primary\">New Post</a><a ng-click=\"closeEditPost()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditPost()\" parametar=\"page\">&times;</a></h1>\r\n  <h1 ng-if=\"vmp.newPost\"class=\"page-title\">Add New <span class=\"fw-semi-bold\">Post</span></h1>\r\n  <div class=\"single-post\" ng-class=\"{'edit-post':!vmp.newPost, 'new-post':vmp.newPost}\">\r\n    <div class=\"form-group title-wrapper\"> \r\n      <label>Post title (&lt;h1&gt;):</label>\r\n      <div class=\"character-count-wrapper\">\r\n        <div class=\"photo-video-wrapper\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmp.photoBadge\" id=\"photoBadge\"><label for=\"photoBadge\">Photo</label>\r\n          </div>\r\n          <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmp.videoBadge\" id=\"videoBadge\"><label for=\"videoBadge\">Video</label>\r\n          </div>\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmp.liveBadge\" id=\"liveBadge\"><label for=\"liveBadge\">Live</label>\r\n          </div>\r\n          <button class=\"btn btn-black btn-ai\" ng-click=\"vmp.openAiModal('title-suggestion')\" ng-if=\"vmp.aitoolsEnabled.includes('title-suggestion')\">AI Title</button>\r\n        </div>\r\n        <textarea type=\"text\" class=\"form-control input-lg textarea-lg\" placeholder=\"Enter title here\" ng-model=\"vmp.dataPost.title\" ng-class=\"{'error-border':vmp.titleRequired || vmp.titleSpellInCorect || vmp.titleExceed}\" ng-blur = \"vmp.focusOutTitle(vmp.dataPost.title)\" ng-focus=\"vmp.focusInTitle(vmp.dataPost.title)\" id=\"postTitle\" character-count=\"p\" limit-character=\"100\" category=\"{{vmp.category}}\" exceed-name=\"title\"></textarea>\r\n      </div>\r\n      <!-- <div class=\"fake-textarea\" ng-if = \"vmp.titleSpellInCorect\" ng-bind-html=\"vmp.spelledTitle\" ng-click=\"vmp.focusOnTitle()\"></div> -->\r\n      <!-- <div ng-if = \"vmp.titleSpellInCorect\" ng-bind-html=\"vmp.spelledTitle\"></div> -->\r\n      <div class=\"required-error animate-show\" ng-show=\"vmp.titleRequired\">Title is required</div>\r\n      <div ng-show=\"vmp.titleSpellInCorect\" class=\"animate-show\">\r\n        <span>Misspelled words:&nbsp;</span>\r\n        <ul class=\"inline-block\">\r\n          <li ng-repeat=\"word in vmp.spelledArray track by $index\" class=\"inline-block clickable clickable-danger\" ng-click=\"vmp.openDictionaryModal(word)\">{{word}}<span ng-if=\"$index!=vmp.spelledArray.length-1\">,&nbsp;</span></li>\r\n        </ul>\r\n      </div>\r\n    </div> \r\n    <div class=\"form-group page-title-wrapper\">\r\n      <label>Page title (&lt;title&gt;):</label>\r\n      <div class=\"character-count-wrapper\">\r\n        <div class=\"photo-video-wrapper\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmp.pageTitleEnable\" id=\"pageTitleEnable\"><label for=\"pageTitleEnable\">Custom page title</label>\r\n          </div>\r\n          <button class=\"btn btn-black btn-ai\" ng-click=\"vmp.openAiModal('page-title-suggestion')\" ng-if=\"vmp.aitoolsEnabled.includes('page-title-suggestion')\">AI Page Title</button>\r\n        </div>\r\n        <textarea class=\"form-control textarea-md\" placeholder=\"Enter page title here\" ng-model=\"vmp.dataPost.page_title\" ng-class=\"{'error-border':vmp.pageTitleRequired}\" ng-focus=\"vmp.pageTitleRequired=false\" character-count=\"p\" limit-character=\"60\" warning-limit-character=\"10\" stop-typing = \"70\" ng-readonly=\"!vmp.pageTitleEnable\"></textarea>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmp.pageTitleRequired\">Page title required</div>\r\n    </div>\r\n    <p ng-cloak ng-show=\"!vmp.newPost\" class=\"permalink margin-bottom-20\">Permalink: <span class=\"fw-semi-bold\">{{vmp.substringUri}}</span><span class=\"edit-slug fw-semi-bold\" ng-class=\"{'show-edit':!vmp.editSlugShow, 'hidden-edit':vmp.editSlugShow}\" ng-click=\"vmp.editSlugShow=true\">{{vmp.postSlug}}</span><input class = \"form-control\" ng-class=\"{'show-edit':vmp.editSlugShow, 'hidden-edit':!vmp.editSlugShow,'error-border':alerts.length>0 && vmp.editSlugShow}\" type=\"text\" ng-model=\"vmp.postSlug\" ng-style=\"{'width':vmp.postSlug.length*8 + 'px','min-width':'100px' ,'max-width':'100%'}\"><a ng-click=\"vmp.editSlug(vmp.postSlug)\" ng-class=\"{'show-edit':!vmp.editSlugShow, 'hidden-edit':vmp.editSlugShow}\" class=\"btn btn-primary\">Edit</a><a ng-class=\"{'show-edit':!vmp.editSlugShow, 'hidden-edit':vmp.editSlugShow}\" class=\"btn btn-info\" ng-click=\"vmp.previewPost()\" target=\"_blank\" ng-show=\"vmp.dataPost.status=='publish'\">View Post</a><a ng-class=\"{'show-edit':!vmp.editSlugShow, 'hidden-edit':vmp.editSlugShow}\" class=\"btn btn-info\" ng-click=\"vmp.previewPost()\" target=\"_blank\" ng-show=\"vmp.dataPost.status!='publish' && vmp.dataPost.preview\">Preview Post</a><a ng-click=\"vmp.updateSlug()\" ng-class=\"{'show-edit':vmp.editSlugShow, 'hidden-edit':!vmp.editSlugShow}\" class=\"btn btn-primary\">Ok</a><a ng-click=\"vmp.cancelSlug()\" ng-class=\"{'show-edit':vmp.editSlugShow, 'hidden-edit':!vmp.editSlugShow}\" class=\"btn btn-danger\">Cancel</a></p>\r\n    <!-- <div ng-cloak ng-show=\"!vmp.newPost\">\r\n      <div class=\"form-group overflow-hidden inline-block\">\r\n        <ul class=\"background-white post-row normalize\" style=\"z-index:1\">\r\n          <li class=\"inline-block\">\r\n            <a class=\"btn btn-info\" ng-click=\"vmp.changePreviewQrCode($event, 'web')\"><span ng-show=\"vmp.dataPost.status!='publish' && vmp.dataPost.preview\">Preview</span><span ng-show=\"vmp.dataPost.status=='publish'\">View</span> Mobile Web</a>\r\n          </li>\r\n          <li class=\"inline-block\">\r\n            <a class=\"btn btn-info\" ng-click=\"vmp.changePreviewQrCode($event,'app')\"><span ng-show=\"vmp.dataPost.status!='publish' && vmp.dataPost.preview\">Preview</span><span ng-show=\"vmp.dataPost.status=='publish'\">View</span> Mobile App</a>\r\n          </li>\r\n        </ul>\r\n        <div class=\"qrcode-wrapper\" class=\"overflow-hidden post-row\" style=\"z-index:0\" ng-show = \"vmp.qrLoad\" ng-class=\"{'slideInDown animated' : vmp.qrLoad}\">\r\n          <div class=\"lazy-loading\" ng-show=\"!vmp.qrLoaded\">\r\n            <div class=\"image-wrapper\">\r\n              <img src=\"images/ajax-loader.svg\" alt=\"\">\r\n            </div>\r\n          </div>\r\n          <canvas id=\"canvas-qr\" ng-show=\"vmp.qrLoaded\"></canvas>\r\n        </div>\r\n      </div>\r\n    </div> -->\r\n    <div class=\"form-group\">\r\n      <label>Meta description:</label>\r\n      <div class=\"character-count-wrapper\">\r\n        <div class=\"photo-video-wrapper\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmp.description_custom\" id=\"customMetaDescription\"><label for=\"customMetaDescription\">Custom meta description</label>\r\n          </div>\r\n        </div>\r\n        <textarea type=\"text\" class=\"form-control textarea-md\" ng-show=\"vmp.description_custom\" placeholder=\"Enter meta description here\" ng-model=\"vmp.description_text\" ng-class=\"{'error-border':vmp.metaDescriptionRequired}\" character-count=\"\" limit-character=\"160\" limit-character-min=\"25\" decode=\"true\" ng-readonly=\"!vmp.description_custom\"></textarea>\r\n        <div class=\"highlighted-text-wrapper textarea-md readonly\" ng-show=\"!vmp.description_custom\" ng-class=\"{'error-border':vmp.metaDescriptionRequired}\">\r\n          <highlighted-char text=\"vmp.description_text\" decode=\"true\" limit-character=\"160\" limit-character-min=\"25\"></highlighted-char>\r\n        </div>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmp.metaDescriptionRequired\">Meta description is required</div>\r\n      </div>\r\n    <div class=\"single-post--columns-wraper\">\r\n      <div class=\"single-post--left-col\">\r\n        <div class=\"change-preview-wrapper\" id=\"change-preview-wrapper\">\r\n          <a ng-click=\"vmp.addMediatoEditor()\" class=\"btn grey-btn add-media-editor\">Insert Photo</a>\r\n          <ul class=\"editor-tabs-wrapper\" ng-if=\"vmp.textModePermision\">\r\n            <li>\r\n              <a class=\"active visual\" ng-click=\"vmp.editorChangePreviw($event, 'visual')\">Visual</a>\r\n            </li>\r\n            <li>\r\n              <a ng-click=\"vmp.editorChangePreviw($event, 'text')\" class=\"text\">Text</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <form method=\"post\"  class=\"post-editor\" data-ng-controller = \"postEditorCtrl as vmeditorP\" obj-post=\"vmp\" type-data=\"'post'\">\r\n        <textarea  ui-tinymce=\"vmeditorP.tinymceOptions\" ng-model=\"vmp.tinymceModel\"></textarea>\r\n        </form>\r\n        <section class=\"single-post--widget widget systems-data padding-bottom-0\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Sistemski podaci</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">Prikaz slike:</label>\r\n                <select ng-model=\"vmp.selectedPictureDemonstrate.value\" ng-change=\"vmp.changePictureDemonstrate(vmp.selectedPictureDemonstrate.value)\" class=\"form-control\">\r\n                  <option value=\"yes\">Da</option>\r\n                  <option value=\"no\">Ne</option>      \r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">Prikaz vremena izmene vesti:</label>\r\n                <select ng-model=\"vmp.selectedDateDemonstrate.value\" ng-change=\"vmp.changeDateDemonstrate(vmp.selectedDateDemonstrate.value)\" class=\"form-control\">\r\n                  <option value=\"yes\">Da</option>\r\n                  <option value=\"no\">Ne</option>      \r\n                </select>\r\n            </div>\r\n            <!-- <div class=\"form-group\">\r\n              <label for=\"search-input\">Prikaz \"in-text\" banera:</label>\r\n                <select ng-model=\"vmp.selectedBannerDemonstrate.value\" ng-change=\"vmp.changeBannerDemonstrate(vmp.selectedBannerDemonstrate.value)\" class=\"form-control\">\r\n                  <option value=\"yes\">Da</option>\r\n                  <option value=\"no\">Ne</option>      \r\n                </select>\r\n            </div> -->\r\n            <!-- <div class=\"form-group\">\r\n              <label for=\"search-input\">Horizontalni prikaz \"Preporuka za vas\" bloka:</label>\r\n                <select ng-model=\"vmp.selectedRelatedDemonstrate.value\" ng-change=\"vmp.changeRelatedDemonstrate(vmp.selectedRelatedDemonstrate.value)\" class=\"form-control\">\r\n                  <option value=\"yes\">Da</option>\r\n                  <option value=\"no\">Ne</option>      \r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">\"Preporuka za vas\" blok postaviti na kraj teksta:</label>\r\n                <select ng-model=\"vmp.selectedRelatedDemonstratePositionBottom.value\" ng-change=\"vmp.changeRelatedDemonstratePositionBottom(vmp.selectedRelatedDemonstratePositionBottom.value)\" class=\"form-control\">\r\n                  <option value=\"yes\">Da</option>\r\n                  <option value=\"no\">Ne</option>      \r\n                </select>\r\n            </div> -->\r\n            <!-- <div class=\"form-group\">\r\n              <label for=\"search-input\">Mobile title:</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"Enter mobile title here\" ng-model=\"vmp.mobileTitle\">\r\n            </div> -->\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">Facebook title:</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"Enter facebook title here\" ng-model=\"vmp.facebookTitle\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label>Subtitle:</label>\r\n              <textarea class=\"form-control textarea-md\" placeholder=\"Enter subtitle here\" ng-model=\"vmp.dataPost.subtitle\"></textarea>\r\n              <!-- <div class=\"required-error animate-show\" ng-show=\"vmp.subtitleRequired\">Subtitle required</div> -->\r\n            </div>\r\n            <div class=\"flex-display-desktop gap-15\">\r\n              <div class=\"form-group flex-display gap-15\">\r\n                <div class=\"input-group-no-border flex-display\">\r\n                  <label class=\"margin-right-0 margin-bottom-0\">Custom shares:&nbsp;</label>\r\n                  <div class=\"input-group\"><input type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=\"vmp.dataPost.meta.custom_shares\" ng-keypress=\"vmp.keyPressOnlyNumber($event)\"></div>\r\n                </div>\r\n                <div class=\"flex-display\">\r\n                  <label class=\"margin-right-0 margin-bottom-0\">Shares:&nbsp;</label>\r\n                  <span class=\"fw-semi-bold success\">{{vmp.dataPost.meta.shares}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group flex-display gap-15\">\r\n                <div class=\"flex-display\">\r\n                  <label class=\"margin-right-0 margin-bottom-0\">Mobile shares:&nbsp;</label>\r\n                  <span class=\"fw-semi-bold success\">{{vmp.dataPost.meta.mobile_shares}}</span>\r\n                </div>\r\n                <div class=\"flex-display\">\r\n                  <label class=\"margin-right-0 margin-bottom-0\">Total shares:&nbsp;</label>\r\n                  <span class=\"fw-semi-bold success\">{{vmp.dataPost.total_shares}}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- <div class=\"form-group\">    \r\n              <label for=\"search-input\">Push notification title:</label>\r\n              <div class=\"character-count-wrapper\">\r\n                <textarea type=\"text\" class=\"form-control textarea-md\" placeholder=\"Enter title here\" ng-model=\"vmp.pushNotificationTitle\" character-count=\"\"></textarea>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">    \r\n              <label for=\"search-input\">Push notification super title:</label>\r\n              <div class=\"character-count-wrapper\">\r\n                <textarea type=\"text\" class=\"form-control textarea-md\" placeholder=\"Enter super title here\" ng-model=\"vmp.pushNotificationSuperTitle\" character-count=\"\"></textarea>\r\n              </div>\r\n            </div> -->\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">PR tekst:</label>\r\n              <select ng-model=\"vmp.selectedPrDemonstrate.value\" ng-change=\"vmp.changePrDemonstrate(vmp.selectedPrDemonstrate.value)\" class=\"form-control\">\r\n                <option value=\"yes\">Da</option>\r\n                <option value=\"no\">Ne</option>      \r\n              </select>\r\n            </div>\r\n            <!-- <div class=\"form-group\">    \r\n              <label for=\"search-input\">PR text-title</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"Enter title here\" ng-model=\"vmp.prTextTitle\">\r\n            </div> -->\r\n            <!-- <div class=\"form-group\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmp.displayByComtrade\"><label ng-click=\"vmp.displayByComtrade=!vmp.displayByComtrade\">Display \"By Comtrade\" logo</label>\r\n              </div>\r\n            </div> -->\r\n            <div class=\"form-group\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmp.copyright\"><label ng-click=\"vmp.copyright=!vmp.copyright\">Copyright</label>\r\n              </div>\r\n            </div>\r\n            <h5 class=\"fw-semi-bold\">Authors</h5>\r\n            <hr>\r\n            <!-- <div class=\"form-group\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmp.displayWriters\"><label ng-click=\"vmp.displayWriters=!vmp.displayWriters\">Display author</label>\r\n              </div>\r\n            </div> -->\r\n            <!-- <div class=\"form-group\" ng-if=\"vmp.assignedPost\">\r\n              <label for=\"assign-to\">Reassign to:</label>\r\n              <select ng-model=\"vmp.assignTo.value\" ng-change=\"vmp.changeAssignTo(vmp.assignTo.value)\" class=\"form-control align-middle\">\r\n                <option ng-repeat= \"author in vmp.allAuthors\" value=\"{{author._id}}\">{{author.display_name}}</option>      \r\n              </select>\r\n              <a ng-click=\"vmp.assignToFunc()\" class=\"btn btn-primary\" ng-class=\"{'disabled':vmp.assignTo.value == vmp.dataPost.author}\">Confirm</a>\r\n            </div> -->\r\n            <div class=\"form-group\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmp.displayWriterInitials\"><label ng-click=\"vmp.displayWriterInitials=!vmp.displayWriterInitials\">Display Author Initials</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\" ng-class=\"{'error-border':vmp.writersRequired, 'disabled-select':!vmp.displayWriters}\">\r\n              <oi-select oi-options=\"item.display_name for item in vmp.allAuthors track by item.email\"\r\n                ng-model=\"vmp.writers\"\r\n                multiple\r\n                multiple-placeholder=\"Add author\"\r\n                placeholder=\"Select author\"\r\n                oi-select-options=\"{\r\n                    searchFilter: 'oiSelectSearchFilter',\r\n                    dropdownFilter: 'oiSelectDropdownFilter'\r\n                }\"></oi-select>\r\n            </div>\r\n          </div>\r\n        </section>\r\n        <!-- <section class=\"single-post--widget widget\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Recommended News (\"Preporučujemo\")</h5>\r\n          </header>\r\n          <div class=\"widget-body padding-bottom-0 padding-top-15\">\r\n            <div class=\"recommended-item\" ng-repeat=\"news in vmp.recommendedNews\">\r\n              <label for=\"recommended-item_{{news.id}}\">Post ID - {{news.id}}</label>\r\n              <textarea type=\"text\" class=\"form-control readonly\" ng-model=\"news.title\" readonly id=\"recommended-item_{{news._id}}\"></textarea>\r\n            </div>\r\n            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vmp.recommendedNewsModalShow = true\"><span ng-if=\"vmp.recommendedNews && vmp.recommendedNews.length>0\">Add/Edit</span><span ng-if=\"!vmp.recommendedNews || vmp.recommendedNews.length==0\">Add</span> Recommended News</button>\r\n          </div>\r\n        </section> -->\r\n        <!-- <section class=\"single-post--widget widget\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Recommended Poll</h5>\r\n          </header>\r\n          <div class=\"widget-body padding-bottom-0 padding-top-15\">\r\n            <div class=\"recommended-item\" ng-show=\"vmp.recommendedPollObj\">\r\n              <label for=\"recommended-item_{{vmp.recommendedPollObj._id}}\">Poll ID - {{vmp.recommendedPollObj._id}}</label>\r\n              <textarea type=\"text\" class=\"form-control readonly\" ng-model=\"vmp.recommendedPollObj.title\" readonly id=\"recommended-item_{{vmp.recommendedPollObj._id}}\"></textarea>\r\n            </div>\r\n            <button ng-show=\"!vmp.recommendedPollObj\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"vmp.addRecommendedPoll()\"><span>Add Recommended Poll</span>\r\n            <button ng-show=\"vmp.recommendedPollObj\" type=\"submit\" class=\"btn btn-danger\" ng-click=\"vmp.removeRecommendedPoll()\"><span>Remove Recommended Poll</span>\r\n          </div>\r\n        </section> -->\r\n        <!-- <section class=\"single-post--widget widget\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Bonus Video <span ng-if=\"vmp.featuredVideoObj\">(Video ID = {{vmp.featuredVideoObj._id}})</span></h5>\r\n          </header>\r\n          <div class=\"widget-body padding-bottom-0 padding-top-15\">\r\n            <div class=\"video-block-wrapper\">\r\n              <div ng-if=\"vmp.featuredVideoAdded\" class=\"video-wrapper-outer\">\r\n                <div class=\"video-wrapper\" ng-show = \"vmp.featuredVideoLoaded\">\r\n                  <video\r\n                      id=\"featured-video\"\r\n                      class=\"video-js\"\r\n                      controls\r\n                      preload=\"auto\"\r\n                      poster=\"\">\r\n                    <p class=\"vjs-no-js\">\r\n                      To view this video please enable JavaScript, and consider upgrading to a\r\n                      web browser that\r\n                      <a href=\"http://videojs.com/html5-video-support/\" target=\"_blank\">\r\n                        supports HTML5 video\r\n                      </a>\r\n                    </p>\r\n                  </video>\r\n                  <div class=\"duration\" ng-show=\"vmp.featuredVideoObj.duration && vmp.featuredVideoObjDurationFlag\">{{vmp.featuredVideoObj.formated_duration}}</div>\r\n                </div>\r\n                <div class=\"video-loader-wrapper\" ng-show = \"!vmp.featuredVideoLoaded\">\r\n                  <img src=\"images/pending-animation.svg\">\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"!vmp.featuredVideoAdded\" class=\"set-featured-video-placeholder-wrapper\" ng-click=\"vmp.setFeaturedVideo()\">\r\n                <div class=\"set-featured-video-placeholder-inner\">\r\n                  <div class=\"set-featured-video-placeholder\">\r\n                    <img src=\"images/placeholder.svg\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"set-featured-video-actions\">\r\n                <a ng-click=\"vmp.setFeaturedVideo()\" class=\"btn btn-primary\">Add Video</a>\r\n                <a ng-click=\"vmp.removeFeaturedVideo()\" class=\"btn btn-danger\">Remove Video</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </section> -->\r\n        <section class=\"single-post--widget widget\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">FB Image</h5>\r\n          </header>\r\n          <div class=\"widget-body padding-bottom-0 padding-top-15\">\r\n            <div class=\"btn btn-primary\" ng-show=\"!vmp.shareImageObj._id\" ng-click=\"vmp.openSetShareImage()\">Set image</div>\r\n            <div ng-show=\"vmp.shareImageObj._id\" class=\"position-relative share-image-wrapper\">\r\n              <img ng-src=\"{{vmp.shareImageObj.thumbs['1200x630']}}\"  alt=\"Share image\" class=\"img-responsive\" ng-click=\"vmp.openSetShareImage()\">\r\n              <div class=\"clickable clickable-danger remove\" ng-click=\"vmp.removeShareImage()\"><span>&times;</span></div>\r\n            </div>\r\n          </div>\r\n        </section>\r\n        <section class=\"single-post--widget widget tags\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Discussion</h5>\r\n          </header>\r\n          <div class=\"widget-body disccusion\">\r\n            <!-- <div class=\"form-group\">\r\n              <div class=\"checkbox checkbox-primary\">\r\n                <input type=\"checkbox\" ng-model=\"vmp.allowcomments\"><label>Allow comments</label>\r\n              </div>\r\n            </div> -->\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">Comments priority</label>\r\n              <select ng-model=\"vmp.commentsPriority.value\" class=\"form-control\" ng-disabled=\"vmp.dataPost.focus\">\r\n                <option value=\"0\">Low</option>\r\n                <option value=\"1\">Medium</option>\r\n                <option value=\"2\">High</option>      \r\n              </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label>Moderator's guide</label>\r\n              <textarea class=\"form-control textarea-md\" placeholder=\"Enter moderator's guide here\" ng-model=\"vmp.dataPost.moderator_guide\"></textarea>\r\n            </div>\r\n          </div>\r\n        </section>\r\n        <section class=\"single-post--widget widget widget-approvals\" ng-if=\"vmp.dataPost._id && !vmp.newPost\">\r\n          <header class=\"bb\">\r\n              <h5 class=\"fw-semi-bold\">Approvals</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <add-approval-dir parent=\"vmp.dataPost\" type=\"'post'\"></add-approval-dir>\r\n          </div>\r\n        </section> \r\n      </div>\r\n      <div class=\"single-post--right-col\">\r\n        <section class=\"single-post--widget widget publish\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Publish</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <a ng-click=\"vmp.previewPost('preview')\" target=\"_blank\" class=\"btn btn-default preview\" ng-if=\"!vmp.newPost && vmp.dataPost.preview\">Preview Changes</a>\r\n            <a ng-click = \"vmp.updateorSavePost()\" ng-show=\"vmp.dataPost.status == 'pending' || vmp.dataPost.status == 'draft' || vmp.assignedPost\" class=\"btn btn-default\">Save</a>\r\n            <ul>\r\n              <li><i class=\"fa fa-key\" aria-hidden=\"true\"></i>&nbsp;Status: <span class=\"fw-semi-bold status\">{{vmp.dataPost.status}}</span> <span class=\"clickable\" ng-click=\"vmp.editPostStatus()\" ng-if=\"vmp.permissionsOwnPost\">Edit</span>\r\n                <div class=\"editable\" ng-if=\"vmp.editPostStatusShow\">\r\n                  <select ng-model=\"vmp.selectedPostStatus.value\" class=\"form-control\">\r\n                    <option value=\"publish\" ng-show=\"!vmp.newPost && vmp.editPublish\">Published</option>\r\n                    <option value=\"schedule\" ng-show=\"vmp.setScheduledPost\">Scheduled</option>\r\n                    <option value=\"assigned\" ng-if=\"vmp.assignedPost\">Assigned</option>\r\n                    <option value=\"pending\">Pending Review</option>\r\n                    <option value=\"draft\">Draft</option>\r\n                    <option value=\"unlisted\" ng-if=\"vmp.permissions\">Unlisted</option>      \r\n                  </select>\r\n                  <a ng-click=\"vmp.changePostStatus()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmp.cancelEditPostStatus()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n              <!-- <li><i class=\"fa fa-eye\" aria-hidden=\"true\"></i>&nbsp;Visibility: <span class=\"fw-semi-bold\">Public</span> <span class=\"clickable\">Edit</span></li> -->\r\n              <li><i class=\"fa fa-recycle\" aria-hidden=\"true\"></i>&nbsp;Revisions:<span class=\"clickable\" ng-click=\"vmp.openRevisionsModal()\"> Browse</span></li>\r\n              <li><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\r\n              <span ng-if=\"vmp.editPublish && !vmp.scheduledPost\"><span>&nbsp;Published on:</span> <span class=\"fw-semi-bold\">{{vmp.dataPost.date}}</span></span>\r\n              <span ng-if=\"vmp.scheduledPost\"><span>&nbsp;Schedule for:</span> <span class=\"fw-semi-bold\">{{vmp.dataPost.date}}</span></span>\r\n              <span ng-if=\"!vmp.editPublish && vmp.permisions && !vmp.scheduledPost && !vmp.pastPost\" ng-cloak><span>&nbsp;Publish</span> <span class=\"fw-semi-bold\">immediately</span></span>\r\n              <span ng-if=\"!vmp.editPublish && vmp.permisions && !vmp.scheduledPost && vmp.pastPost\" ng-cloak><span>&nbsp;Publish on</span> <span class=\"fw-semi-bold\"><span class=\"fw-semi-bold\">{{vmp.dataPost.date}}</span></span></span> \r\n              <span ng-if=\"vmp.permissionsOwnPost && !vmp.permisions && !vmp.scheduledPost && vmp.newPost\" ng-cloak><span>&nbsp;Save</span> <span class=\"fw-semi-bold\">immediately</span></span> \r\n              <span class=\"clickable\" ng-click=\"vmp.editPostTime()\" ng-if=\"vmp.permissionsOwnPost\">Edit</span>\r\n              <div class=\"date-edit\" ng-if=\"vmp.editPostDateShow\">\r\n                <select ng-model=\"vmp.selectedPostMont.value\" class=\"form-control\">\r\n                  <option value=\"1\">1-Jan</option>\r\n                  <option value=\"2\">2-Feb</option>\r\n                  <option value=\"3\">3-Mar</option>\r\n                  <option value=\"4\">4-Apr</option>\r\n                  <option value=\"5\">5-May</option>\r\n                  <option value=\"6\">6-Jun</option>\r\n                  <option value=\"7\">7-Jul</option>\r\n                  <option value=\"8\">8-Aug</option>\r\n                  <option value=\"9\">9-Sep</option>\r\n                  <option value=\"10\">10-Oct</option>\r\n                  <option value=\"11\">11-Nov</option>\r\n                  <option value=\"12\">12-Dec</option>      \r\n                </select>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmp.postDay\">\r\n                <span>,</span>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmp.postYear\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmp.postHours\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vmp.postMinutes\">\r\n                <a ng-click=\"vmp.setPublishedDate()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmp.cancelEditPostDate()\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n              </li>\r\n              <li ng-if=\"vmp.editPublish\">\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther({'param1':'focus'},{'document_id':vmp.postId,'type':'post','title':vmp.dataPost.title})\">Add to Focus</div> -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther('focusvreme',vmp.postId)\">Add to Focus Weather</div> -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther('newsticker',vmp.postId)\">Add to News Ticker</div>   -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther({'param1':'pushnotifications'},{'document_id':vmp.postId,'type':'post'})\">Add to Push Notifications</div> -->\r\n                <!-- <div class=\"clickable clickable-warning\" ng-click=\"$parent.vmap.removeFromOther({'param1':'pushnotifications','param2': 'post','param3': vmp.postId})\">Remove from Push Notifications</div> -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther({'param1':'intext-galleries','param2':vmp.postId})\">Add to Related Galleries</div> -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"vmp.addToOther({'param1':'posts','param2':'social','param3':vmp.postId})\">Add to SMP</div> -->\r\n                <!-- <div class=\"clickable clickable-warning\" ng-click=\"$parent.vmap.removeFromOther({'param1':'posts','param2':'social',param3:vmp.postId})\">Remove from SMP</div> -->\r\n                <!-- <div class=\"clickable clickable-success\" ng-click=\"$parent.addToExchange('blic',vmp.postId)\">Add to Blic exchange</div> -->\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\"><a ng-click=\"vmp.trashPost()\" class=\"clickable-danger\" ng-if = \"vmp.permisions\">Move to Trash</a>\r\n            <div ng-show=\"(!vmp.newPost && vmp.editPublish) && !vmp.scheduledPost && vmp.permisions\"  class=\"pull-right\">  \r\n              <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"vmp.updateorSavePost()\">Update</button>\r\n            </div>\r\n            <div ng-show=\"vmp.permissionsOwnPost && !vmp.permisions && !vmp.newPost\"  class=\"pull-right\">  \r\n              <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"vmp.updateorSavePost()\">Update</button>\r\n            </div>\r\n            <div ng-show=\"(vmp.newPost || !vmp.editPublish) && !vmp.scheduledPost && vmp.permisions\" class=\"pull-right\">\r\n              <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"vmp.publishPost()\">Publish</button>\r\n            </div>\r\n            <div ng-show=\"vmp.scheduledPost && vmp.permisions\" class=\"pull-right\">\r\n              <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"vmp.publishPost()\">Schedule</button>\r\n            </div>\r\n          </footer>\r\n        </section>\r\n        <keywords-dir parent=\"vmp\" key-words-list=\"vmp.dataPost.keywords\" content=\"vmp.tinymceModel\" post-title=\"vmp.dataPost.title\" update=\"vmp.updateKeywords\"></keywords-dir>\r\n        <section class=\"single-post--widget widget categories\" ng-class=\"{'error-border':vmp.categoryRequired}\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Categories</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n          <div class=\"clearfix\">\r\n            <ul class=\"nav nav-tabs pull-left\"> <!-- remove pull-left to get a cool effect too -->\r\n              <li class=\"active\"><a>All Categories</a></li>\r\n            </ul>\r\n            </div>\r\n          <div class=\"tab-content\">\r\n              <div class=\"tab-pane active clearfix categories-tree\">\r\n                <div id=\"categoryscroll\" class=\"acordion-categories\">\r\n                  <category-accordion ng-if=\"vmp.categories && vmp.categories.length>0\" parent=\"vmp\" categories=\"vmp.categories\" open=\"true\"></category-accordion>\r\n                </div>\r\n              </div>\r\n              </div>\r\n              <div class=\"required-error animate-show\" ng-show=\"vmp.categoryRequired\">Category is required</div>\r\n          </div>\r\n          <!-- <footer class=\"bg-body-light bt\"><a href=\"\" class=\"clickable\">+ Add New Category</a></footer> -->\r\n        </section>\r\n        <section class=\"single-post--widget widget f-image\" ng-class=\"{'error-border':vmp.featuredImageRequired}\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Featured Image</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n          <!--  <div class=\"featured\"></div> -->\r\n            <a class=\"clickable\" ng-show=\"!vmp.hasFeaturedImage\" ng-click=\"vmp.openSetFeaturedImage()\">Set featured image</a>\r\n            <a ng-show=\"vmp.hasFeaturedImage\" ng-click=\"vmp.openSetFeaturedImage()\"><img ng-src=\"{{vmp.featured_img_obj.thumbs['620x350']}}\"  alt=\"\" class=\"img-responsive\" lazy-loading class=\"spinner-show\">\r\n              <div class=\"lazy-loading\">\r\n                <div class=\"image-wrapper\">\r\n                  <img src=\"images/ajax-loader.svg\" alt=\"\">\r\n                </div>\r\n              </div>\r\n            </a>\r\n            <div class=\"required-error animate-show\" ng-show=\"vmp.featuredImageRequired\">Featured image is required</div>\r\n          </div>\r\n          <footer class=\"bg-body-light bt\">\r\n            <a class=\"clickable-danger\" ng-click=\"vmp.removeFeaturedImage()\">Remove featured Image</a>\r\n            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vmp.openCropModal()\" ng-show=\"vmp.hasFeaturedImage\" style=\"float: none!important\">Crop Featured image</button>\r\n            <ul style=\"margin:10px 0\">\r\n              <li ng-show=\"vmp.hasFeaturedImage\">Photo status:&nbsp;\r\n                  <div class=\"clickable lock-wrapper\">\r\n                      <img src=\"images/lock.svg\" alt=\"lock-image\" title = \"Unlock image\" ng-if=\"vmp.featured_img_obj.status == 'lock'\" ng-click=\"vmp.changeMediaStatus(vmp.featured_img_obj._id,'publish')\">\r\n                      <img src=\"images/unlock.svg\" alt=\"unlock-image\" title = \"Lock image\" ng-if=\"vmp.featured_img_obj.status == 'publish'\" ng-click=\"vmp.changeMediaStatus(vmp.featured_img_obj._id,'lock')\">\r\n                  </div>\r\n              </li>\r\n            </ul>\r\n          </footer>\r\n        </section>\r\n        <section class=\"single-post--widget widget tags\">\r\n          <header class=\"bb overflow\">\r\n            <h5 class=\"fw-semi-bold pull-left\" ng-style=\"vmp.aitoolsEnabled.includes('tags-suggestion') ? {'line-height': '34px'} : {}\">Tags</h5>\r\n            <button class=\"btn btn-black btn-ai pull-right\" ng-click=\"vmp.openAiModal('tags-suggestion')\" ng-if=\"vmp.aitoolsEnabled.includes('tags-suggestion')\">AI Tags</button>\r\n          </header>\r\n          <div class=\"widget-body categories\">\r\n            <div class=\"form-group search-wrapper\">\r\n              <label for=\"search-input\">Add tag</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmp.searchtagfocus\" auto-complete-dir enter-tag= \"vmp.addNewTag()\"  datachangelabel=\"\" datachangeid = \"\" type-dir=\"'post'\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmp.addNewTag()\">Add</button></span></div>\r\n              <div class=\"required-error animate-show\" ng-show=\"vmp.newTagRequired\">New tag is required</div>\r\n              <div class=\"required-error animate-show\" ng-show=\"vmp.existTag\">Tag alredy exists</div>\r\n              <ul class=\"list-tags\">\r\n                <li ng-repeat=\"tag in vmp.dataPost.tags\"><span class=\"remove-from-list\" ng-click=\"vmp.removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </section>\r\n        <section class=\"single-post--widget widget share-on-telegraf-x\" ng-if=\"vmp.editPublish\">\r\n          <header class=\"bb overflow has-btn-header\">\r\n            <h5 class=\"fw-semi-bold pull-left\">Share on Telegraf X</h5>\r\n            <button class=\"btn btn-primary pull-right\" ng-click=\"vmp.shareOnX()\" ng-disabled=\"vmp.shareOnXRemainingPosts <= 0\">Share</button>\r\n          </header>\r\n          <div class=\"widget-body categories\">\r\n            <label for=\"search-input\">Remaining posts: <span class=\"fw-semi-bold text-success\" ng-class=\"{'text-danger':vmp.shareOnXRemainingPosts <= 0}\">{{vmp.shareOnXRemainingPosts}}</span></label>\r\n          </div>\r\n        </section>\r\n        <section class=\"single-post--widget widget attributes\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Attributes</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n          <div class=\"input-group-no-border margin-bottom-20\"><label>Order</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmp.dataPost.order\" ng-keypress=\"vmp.keyPressOnlyNumber($event)\"></div></div>\r\n          <div class=\"input-group-no-border\"><label>Fixed position</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmp.dataPost.fixed_position\" ng-keypress=\"vmp.keyPressOnlyNumber($event)\" ng-class=\"{'error-border':vmp.fixedPositionValidate}\"></div></div>\r\n          </div>\r\n        </section>\r\n        \r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ai-modal-dir\r\n    parent=\"vmp\"\r\n    strip-html=\"vmp.aiToolsObj.stripHtml\"\r\n    funcionality=\"vmp.aiToolsObj.funcionality\" \r\n    name=\"vmp.aiToolsObj.name\"\r\n    text=\"vmp.tinymceModel\" \r\n    multiple=\"vmp.aiToolsObj.multiple\"\r\n    display-type=\"vmp.aiToolsObj.displayType\"\r\n    display-type-obj=\"vmp.aiToolsObj.displayTypeObj\"\r\n    editor=\"vmp.aiToolsObj.editor\"\r\n    two-columns=\"vmp.aiToolsObj.twoColumns\"\r\n    diff-text=\"vmp.aiToolsObj.diffText\"\r\n    on-submit=\"vmp.updateAiResult(funcionality, selectedSuggestion)\"\r\n    edit=\"vmp.aiToolsObj.edit\"\r\n    ng-if=\"vmp.showAiModal\">\r\n  </ai-modal-dir>\r\n  <revisions-modal ng-if=\"vmp.revisionsModalShow\" current-post-obj=\"vmp\"></revisions-modal>\r\n  <crop-image-modal ng-if=\"vmp.cropModalShow\" current-post-obj=\"vmp\" crop=\"'featured'\"></crop-image-modal>\r\n  <add-to-dictionary-modal ng-if=\"vmp.dictionaryModalShow\" current-post-obj=\"vmp\"></add-to-dictionary-modal>\r\n  <edit-image-modal ng-if=\"vmp.editImagefromEditor\" current-post-obj=\"vmp\"></edit-image-modal>\r\n  <set-featured-image-modal ng-if=\"vmp.mediaModal\" current-post-obj=\"vmp\" attach-to-post=\"true\"></set-featured-image-modal>\r\n  <recommended-news-modal ng-if=\"vmp.recommendedNewsModalShow\" current-post-obj=\"vmp\"></recommended-news-modal>\r\n  <set-featured-video ng-if=\"vmp.videoModalShow || vmp.setFeaturedVideoModal\" current-post-obj=\"vmp\" scheduled=\"true\"></set-featured-video>\r\n  <search-poll-dir ng-if=\"vmp.pollModalShow\" parent-obj=\"vmp\" post_id=\"vmp.postId\" poll-result-display=\"vmp.pollResultDisplay\"></search-poll-dir>\r\n  <search-rating-dir ng-if=\"vmp.ratingModalShow\" parent-obj=\"vmp\" post_id=\"vmp.postId\" rating-result-display=\"vmp.ratingResultDisplay\"></search-rating-dir>\r\n  <search-blog-modal-dir ng-if=\"vmp.blogModalShow\" parent-obj=\"vmp\" post_id=\"vmp.postId\"></search-blog-modal-dir>\r\n  <script type=\"text/ng-template\" id=\"editor.html\">\r\n  <textarea class=\"editor-plain-text hidden\" ng-model=\"vmp.textEditorContent\" ng-paste=\"vmeditorP.pasteText($event);\"></textarea>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"modal.html\">\r\n  <div class=\"modal--overlay tinymce-modal\" ng-class=\"{'video-modal':!vmeditorP.pollModalShow}\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n        <h2 ng-if=\"vmeditorP.quoteModalShow\">Add quote</h2>\r\n        <h2 ng-if=\"vmeditorP.videoModalShow\">Insert video</h2>\r\n        <h2 ng-if=\"vmeditorP.questionModalShow\">Add question</h2>\r\n       <div ng-click=\"vmeditorP.cancelTinymceModal()\" ng-escape = \"vmeditorP.cancelTinymceModal()\" class=\"btn btn-danger\">Cancel</div>\r\n      </div>\r\n      \r\n      <div class=\"modal--media-content set-image-modal\">\r\n        <div ng-if=\"vmeditorP.questionModalShow\">\r\n          <div class=\"form-group poll-align\">\r\n            <label>Insert question </label>\r\n            <textarea type=\"text\" rows=\"5\" class=\"form-control\" ng-model=\"vmeditorP.questionText\" placeholder=\"Insert question text ...\"><textarea/>\r\n              <div class=\"required-error animate-show ng-hide\" ng-show=\"vmeditorP.requiredQuestionText\">Question text is required</div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vmeditorP.quoteModalShow\">\r\n          <div class=\"form-group poll-align\">\r\n            <label>Select Quote Align</label>\r\n              <select ng-model=\"vmeditorP.selectedQuoteAlignAction.value\" ng-change=\"vmeditorP.switchQuoteAlignAction(vmeditorP.selectedQuoteAlignAction.value)\" class=\"form-control\">\r\n                <option value=\"left\">Left</option>\r\n              <option value=\"center\">Center</option>\r\n              <!-- <option value=\"right\">Right</option> -->\r\n            </select>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label>Quote text</label>\r\n              <textarea type=\"text\" rows=\"5\" class=\"form-control\" ng-model=\"vmeditorP.quoteText\" placeholder=\"Insert quote text ...\"></textarea>\r\n              <div class=\"required-error animate-show ng-hide\" ng-show=\"vmeditorP.requiredQuoteText\">Insert quote text</div>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vmeditorP.videoModalShow\">\r\n          <div class=\"form-group\">\r\n            <label>Service:</label>\r\n            <select ng-model=\"vmeditorP.selectedTypeVideo.value\" ng-change=\"vmeditorP.switchTypeVideo(vmeditorP.selectedTypeVideo.value)\" class=\"form-control\">\r\n              <option value=\"default\">Choose video service</option>\r\n              <option value=\"youtube\">Youtube</option>\r\n              <option value=\"fbvideo\">Facebook</option>\r\n              <option value=\"vimeo\">Vimeo</option>\r\n              <option value=\"dailymotion\">Dailymotion</option>\r\n              <option value=\"tinypic\">TinyPic</option>\r\n            </select>\r\n          <div class=\"required-error animate-show ng-hide\" ng-show=\"vmeditorP.requiredVideoType\">Choose video service</div>\r\n          </div>\r\n          <div class=\"form-group poll-align\">\r\n            <label>Video ID</label>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"vmeditorP.videoId\">\r\n            <div class=\"required-error animate-show ng-hide\" ng-show=\"vmeditorP.requiredVideoId\">Choose video ID</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"action\">\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertVideo()\" ng-if=\"vmeditorP.videoModalShow\">Insert video</a>\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertQuote()\" ng-if=\"vmeditorP.quoteModalShow\">Insert quote</a>\r\n          <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertQuestion()\" ng-if=\"vmeditorP.questionModalShow\">Insert question</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"template.html\">\r\n   <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n      <li ng-show=\"!showResult\">No result.</li>\r\n      <li ng-repeat=\"tag in tagsTree | sortingCount: 'descending': 'count' track by tag['_id']\" ng-click=\"chooseSearchData(tag.name, tag._id, tag.url)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}}&nbsp;<span class=\"danger-color fw-semi-bold\" ng-if=\"tag.count || tag.count == 0\">[{{tag.count}}]</span></li>\r\n  </ul>\r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"insertTag.html\">\r\n    <div class=\"modal--overlay editor-insert-tag\">\r\n      <div class=\"modal--media-dialog\">\r\n        <div class=\"modal--media-wrapper\">\r\n          <div class=\"modal--media-header\">\r\n           <h2>Insert Tag</h2>\r\n           <div ng-click=\"vmeditorP.cancelInsertTagModal()\" ng-escape = \"vmeditorP.cancelInsertTagModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n          </div>\r\n          <div class=\"modal--media-content\">\r\n            <div class=\"search-wrapper\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"vmeditorP.searchTag\" auto-complete-dir enter-tag= \"vmeditorP.addNewTag()\" type-dir=\"'insertTag'\" placeholder=\"Search tag ...\" datachangelabel=\"\" datachangeid = \"\" id=\"editor-input-tag\"> \r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>  \r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"insertPost.html\">\r\n    <div class=\"modal--overlay editor-insert-post\">\r\n      <div class=\"modal--media-dialog\">\r\n        <div class=\"modal--media-wrapper\">\r\n          <div class=\"modal--media-header\">\r\n           <h2>Insert Post</h2>\r\n           <div ng-click=\"vmeditorP.cancelInsertPostModal()\" ng-escape = \"vmeditorP.cancelInsertPostModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n          </div>\r\n          <div class=\"modal--media-content\">\r\n            <search-post-dir parent-obj=\"vmeditorP\"></search-post-dir>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>  \r\n  </script>\r\n  <script type=\"text/ng-template\" id=\"insertEmbedCode.html\">\r\n    <div class=\"modal--overlay editor-insert-embedcode\">\r\n      <div class=\"modal--media-dialog\">\r\n        <div class=\"modal--media-wrapper\">\r\n          <div class=\"modal--media-header\">\r\n           <h2>Embed code</h2>\r\n           <div ng-click=\"vmeditorP.cancelInsertEmbedCodeModal()\" ng-escape = \"vmeditorP.cancelInsertEmbedCodeModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n          </div>\r\n          <div class=\"modal--media-content\">\r\n            <textarea type=\"text\" rows=\"10\" class=\"form-control margin-bottom-20\" ng-model=\"vmeditorP.embedCode\" placeholder=\"Insert embed code ...\" id=\"insert-embedcode\"></textarea>\r\n            <a class=\"btn btn-primary\" ng-click=\"vmeditorP.insertEmbedCode()\">Insert</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>  \r\n  </script>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay recommended-news-modal\">\r\n    <div class=\"modal--media-dialog\">\r\n      <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n         <h2>Add/Edit Recommended <span>News</span></h2>\r\n         <div ng-click=\"cancelRecommendedNewsModal()\" ng-escape=\"cancelRecommendedNewsModal()\" class=\"btn btn-danger\" parametar=\"modal\">Close</div>\r\n        </div>\r\n        <div class=\"modal--media-content\">\r\n            <div class=\"left-column\">\r\n                <search-all-post-sortable-dir parent-obj=\"currentPostObj\" sortable-data-name=\"'recommendedNews'\" search-categories=\"true\" search-tags=\"true\"></search-all-post-sortable-dir>\r\n            </div>\r\n            <div class=\"right-column\">\r\n                <div class=\"sortable-grid\">\r\n                    <h4>Recommended news</h4>\r\n                    <table>\r\n                        <tbody ui-sortable=\"sortableRecomemendedOptions\" ng-model=\"currentPostObj.recommendedNews\" class=\"sortable-grid__wrapper sortable-container\">\r\n                            <tr ng-repeat=\"item in currentPostObj.recommendedNews track by $index\" ng-show=\"currentPostObj.recommendedNews.length>0\">\r\n                                <td class=\"document_id text-center\">\r\n                                   <span>{{item['id']}}</span>\r\n                                </td>\r\n                                <td class=\"title-cell\">\r\n                                    <div>{{item.title}}</div>\r\n                                </td>\r\n                                <td class=\"clickable clickable-danger remove remove-large\" ng-click=\"removeItem($index)\"><span>×</span></td>\r\n                            </tr>\r\n                            <tr ng-show=\"currentPostObj.recommendedNews.length==0\">\r\n                                <td colspan=\"3\">No posts.</td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n            </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2>Post revisions</h2>\r\n    \t <div ng-click=\"currentPostObj.cancelRevisionsModal()\" ng-escape = \"currentPostObj.cancelRevisionsModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content revisions\">\r\n        <div class=\"column-wrapper\" ng-if=\"loadRevisions\">\r\n          <div class=\"revisions-controls\">\r\n            <div class=\"form-group\">\r\n              <label for=\"search-input\">Choose revisions</label>\r\n              <select ng-model=\"selectedRevisions.value\" ng-change=\"changeRevisions(selectedRevisions.value)\" class=\"form-control\">\r\n                <option ng-repeat=\"revision in revisions\" value=\"{{$index}}\">{{revision.date_modified | date:'MMM dd, y HH:mm'}} - {{revision.author.display_name}}</option>      \r\n              </select>\r\n              <a class=\"btn btn-primary pull-right\" ng-click=\"restorePost()\">Restore post</a>\r\n            </div>\r\n          </div>\r\n          <div class=\"left column\">\r\n            <div class=\"form-group header\">\r\n              <p>Revision by <span class=\"fw-semi-bold\">{{revisionAuthor}}</span></h3>\r\n              <p>Date: <span class=\"fw-semi-bold\">{{revisionDate | date:'MMM dd, y HH:mm'}}</span></p>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Title</h3>\r\n              <pre>{{leftTitle}}</pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Subtitle</h3>\r\n              <pre>{{leftSubtitle}}</pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Content</h3>\r\n              <pre>{{leftContent}}</pre>\r\n            </div>\r\n          </div>\r\n          <div class=\"middle column\">\r\n            <div class=\"form-group header\">\r\n              <h3>Current Post</h3>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Title</h3>\r\n              <pre>{{rightTitle}}</pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Subtitle</h3>\r\n              <pre>{{rightSubtitle}}</pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Content</h3>\r\n              <pre>{{rightContent}}</pre>\r\n            </div>\r\n          </div>\r\n          <div class=\"right column\">\r\n            <div class=\"form-group header\">\r\n              <h3>Diff</h3>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Title</h3>\r\n              <pre processing-diff left-obj=\"leftTitle\" right-obj=\"rightTitle\" options=\"options\" class=\"textdiff\"></pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Subtitle</h3>\r\n              <pre processing-diff left-obj=\"leftSubtitle\" right-obj=\"rightSubtitle\" options=\"options\" class=\"textdiff\"></pre>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <h3>Content</h3>\r\n              <pre processing-diff left-obj=\"leftContent\" right-obj=\"rightContent\" options=\"options\" class=\"textdiff\"></pre>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"column-wrapper\" ng-if=\"!loadRevisions\">\r\n          <p>No Revisions. Try later.</p>\r\n        </div>\r\n      </div>\r\n  \t</div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = "<!-- <div class=\"modal--overlay\" ng-class=\"{'has-sidebar':!currentPostObj.setFeaturedImage}\"> -->\r\n  <div class=\"modal--overlay\">\r\n  <div class=\"modal--media-dialog\">\r\n    <!-- <div class=\"modal--sidebar\" ng-show=\"currentPostObj.insertMediatoEditor\">\r\n      <ul class=\"status-filter\">  \r\n        <li><a class=\"clickable active\" ng-click=\"changeMediaAction($event, 'insert-media')\">Insert Media</a></li>\r\n        <li><a class=\"clickable\" ng-click=\"changeMediaAction($event, 'set-featured-image')\">Set Featured Image</a></li>\r\n      </ul>\r\n    </div> -->\r\n    <div class=\"modal--media-wrapper\">\r\n        <div class=\"modal--media-header\">\r\n      \t  <h2 ng-show=\"currentPostObj.setFeaturedImage\">Set Featured Image</h2>\r\n          <h2 ng-show=\"currentPostObj.setShareImage\">Set FB Image</h2>\r\n          <h2 ng-show=\"currentPostObj.insertMediatoEditor && !checkedInsertToGallery\">Insert Photo</h2>\r\n          <h2 ng-show=\"currentPostObj.insertGallery && !currentPostObj.updateGallery || checkedInsertToGallery\">Insert Gallery</h2>\r\n          <h2 ng-show=\"currentPostObj.insertGallery && currentPostObj.updateGallery\">Update Gallery</h2>\r\n      \t<div ng-click=\"currentPostObj.cancelImageModal()\" ng-escape=\"currentPostObj.cancelImageModal()\" parametar=\"modal\" class=\"btn btn-danger\">Cancel</div>\r\n        </div>\r\n        <div class=\"modal--media-content set-image-modal\" ng-class=\"{'insert-media':currentPostObj.insertMediatoEditor || currentPostObj.insertGallery}\">\r\n          <div class=\"clearfix\">\r\n            <ul id=\"tabs1\" class=\"nav nav-tabs pull-left\"> <!-- remove pull-left to get a cool effect too -->\r\n              <li ng-class=\"{'active':!currentPostObj.mediaLibrary}\"><a ng-click=\"currentPostObj.mediaLibrary = false\" class=\"fw-semi-bold\">Upload Photos</a></li>\r\n              <li ng-class=\"{'active':currentPostObj.mediaLibrary}\"><a ng-click=\"currentPostObj.mediaLibrary = true\" class=\"fw-semi-bold\">Photo Library</a></li>\r\n            </ul>\r\n          </div>\r\n          <div id=\"tabs1c\" class=\"tab-content\">\r\n            <div class=\"tab-pane upload_image insert-media-restriction\" ng-show=\"!currentPostObj.mediaLibrary\" ng-class=\"{'active':!currentPostObj.mediaLibrary}\">\r\n              <upload-photo-ml parent-obj =\"currentPostObj\" from-post=\"attachToPost\" add-to-media-library=\"true\"></upload-photo-ml>\r\n            </div>\r\n            <div class=\"tab-pane active clearfix\" ng-show=\"currentPostObj.mediaLibrary\" ng-class=\"{'active':currentPostObj.mediaLibrary}\">\r\n              <div class=\"left-column\">\r\n                <div class=\"form-group select_option\" ng-show=\"attachToPost\">\r\n                  <select ng-model=\"selectedAttachments.value\" ng-change=\"changeAttachments(selectedAttachments.value)\" class=\"form-control\">\r\n                      <option value=\"all\">All photos</option>\r\n                      <option value=\"{{currentPostObj.postId}}\">Uploaded to this post</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"slide-show checkbox checkbox-primary\" ng-show=\"!currentPostObj.insertGallery && !currentPostObj.setFeaturedImage && !currentPostObj.setShareImage && currentPostObj.galleryInPhoto\">\r\n                  <input type=\"checkbox\" ng-model=\"checkedInsertToGallery\">\r\n                  <label ng-click=\"checkedInsertToGallery = !checkedInsertToGallery\">Gallery</label>\r\n                </div>\r\n                <div class=\"slide-show checkbox checkbox-primary\" ng-show=\"(currentPostObj.insertMediatoEditor || currentPostObj.insertGallery) && selectedAttachments.value !='all'\">\r\n                  <input type=\"checkbox\" ng-model=\"selectAllImages\" ng-click=\"selectAllImagesFunction(selectAllImages)\">\r\n                  <label ng-click=\"selectAllImages = !selectAllImages;selectAllImagesFunction(selectAllImages);\">Select all images</label>\r\n                </div>\r\n                <div class=\"type-all checkbox checkbox-primary\">\r\n                  <input type=\"checkbox\" ng-model=\"checkedTypeSearch\" id=\"search-type-all\">\r\n                  <label for=\"search-type-all\">Search all</label>\r\n                </div>\r\n                <div class=\"form-group search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"searchDataImage\" ng-enter=\"search(searchDataImage)\" ng-change=\"searchEmpty(searchDataImage);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"search(searchDataImage);\">Search</button></span></div></div>\r\n                <div class=\"grid-wrapper\" ng-show=\"selectedAttachments.value =='all'\">\r\n                  <ul class=\"grid\" on-scroll-load on-scroll-loading=\"onScrollLoading\" search-data = \"searchDataImage\" type-search=\"checkedTypeSearch\" selected-attachment=\"selectedAttachments.value\" current-load = \"mediaItems\" featured-img=\"currentPostObj.featured_img_id\" page-number=\"pageNumber\" app-state=\"'attachments'\" category=\"null\" max-pages=\"maxPages\">\r\n                    <li ng-repeat=\"media in mediaItems track by media._id\" >\r\n                      <div class=\"img-wrapp clickable\" ng-click=\"chooseImage(media, $index)\" ng-class=\"{'active':media._id==selectedImage && !currentPostObj.insertMediatoEditor && !currentPostObj.insertGallery && !media.restrictions.locked && media.status!='lock','multi-select':(currentPostObj.insertMediatoEditor || currentPostObj.insertGallery) && multiSelect[media._id] && !media.restrictions.locked && media.status!='lock'}\">\r\n                        <img ng-src=\"{{media.thumbs['254x191']}}\" alt=\"{{media.title}}\">\r\n                        <div class=\"forbiden-placeholder\" ng-if=\"media.restrictions.locked || media.status=='lock'\" title=\"Photo is locked\"></div>\r\n                        <!-- <div class=\"public-relations-badge\" ng-if=\"media.tags.includes('pr')\" title=\"Public relations\"></div> -->\r\n                      </div>\r\n                    </li>\r\n                    <li ng-show=\"onScrollLoading\">\r\n                      <div class=\"lazy-loading-on-scroll\">\r\n                        <div class=\"lazy-loading\">\r\n                          <div class=\"image-wrapper\">\r\n                            <img src=\"images/ajax-loader.svg\" alt=\"Loding\">\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </li>\r\n                  </ul>\r\n                  <div class=\"empty-media\" ng-show=\"emptyTable\">\r\n                    <p>No result. Try again.</p>\r\n                  </div>\r\n                </div>\r\n                <div class=\"grid-wrapper\" ng-show=\"selectedAttachments.value !='all'\">\r\n                  <ul class=\"grid sortable-upload-attachments\" sortable-gallery-dir ng-model=\"mediaItems\">\r\n                    <li ng-repeat=\"media in mediaItems track by media._id\">\r\n                      <div class=\"img-wrapp clickable\" ng-click=\"chooseImage(media, $index)\" ng-class=\"{'active':media._id==selectedImage && !currentPostObj.insertMediatoEditor && !currentPostObj.insertGallery && !media.restrictions.locked && media.status!='lock','multi-select':(currentPostObj.insertMediatoEditor || currentPostObj.insertGallery) && multiSelect[media._id] && !media.restrictions.locked && media.status!='lock'}\">\r\n                        <img ng-src=\"{{media.thumbs['254x191']}}\" alt=\"{{media.title}}\">\r\n                        <div class=\"forbiden-placeholder\" ng-if=\"media.restrictions.locked || media.status=='lock'\" title=\"Photo is locked\"></div>\r\n                        <!-- <div class=\"public-relations-badge\" ng-if=\"media.tags.includes('pr')\" title=\"Public relations\"></div> -->\r\n                      </div>\r\n                    </li>\r\n                  </ul>\r\n                  <div class=\"empty-media\" ng-show=\"emptyTable\">\r\n                    <p>No result. Try again.</p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"right-column\" ng-cloak>\r\n                <div class=\"gallery-details\" ng-show=\"currentPostObj.insertGallery || checkedInsertToGallery\">\r\n                  <h5 class=\"fw-semi-bold\">Gallery Details</h3>\r\n                  <div class=\"form-group\">\r\n                    <label>Title</label>\r\n                    <textarea ng-model=\"gallery_title\" class=\"form-control\"></textarea>\r\n                  </div>\r\n                  <div class=\"form-group checkbox checkbox-primary\">\r\n                    <input type=\"checkbox\" ng-model=\"slideShowUnsafe\" id=\"gallery-safe\">\r\n                    <label for=\"gallery-safe\">Unsafe</label>\r\n                  </div>\r\n                </div>\r\n                <div class=\"image-details-wrapper\" ng-show=\"!unselectAll\">\r\n                  <div class=\"image-details\">\r\n                    <h5 class=\"fw-semi-bold\">Photo Details (ID = <span class=\"fw-semi-bold\">{{selectedImageObj._id}}</span>)</h3>\r\n                    <div class=\"image-thumbnail\"><img ng-src=\"{{selectedImageObj.thumbs['193x110']}}\" alt=\"\"></div>\r\n                      <!-- <p class=\"name\">File name</p> -->\r\n                      \r\n                      <p class=\"dimensions\"><span class=\"fw-semi-bold\">{{selectedImageObj.meta.width}}x{{selectedImageObj.meta.height}}</span></p>\r\n                      <p class=\"uploaded-on\"><span class=\"fw-semi-bold\">{{selectedImageObj.date | date:'medium'}}</span></p>\r\n                      <!-- <a class=\"clickable\">Edit Image</a>&nbsp; -->\r\n                      <a class=\"clickable-danger\" ng-click=\"deleteMedia(selectedImageObj)\" ng-show=\"!currentPostObj.insertGallery && !checkedInsertToGallery\">Delete Permanently</a>\r\n                  </div>\r\n                  <div class=\"editing-details\">\r\n                    <div class=\"form-group\">\r\n                      <textarea ng-model=\"selectedImageObj.file\" class=\"readonly form-control url-field\" readonly></textarea>\r\n                      <label>URL</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <input type=\"text\" ng-model=\"selectedImageObj.title\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n                      <label>Title</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <textarea ng-model=\"selectedImageObj.signature\" class=\"form-control textarea-middle\" ng-change=\"changeField()\" ng-blur=\"outFocus()\" ng-class=\"{'error-border':!selectedImageObj.signature}\"></textarea>\r\n                      <label>Signature</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <textarea ng-model=\"selectedImageObj.gallery_title\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\"></textarea>\r\n                      <label>Gallery title</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <textarea ng-model=\"selectedImageObj.description\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\"></textarea>\r\n                      <label>Description</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <input type=\"text\" class=\"form-control\" ng-model=\"selectedImageObj.meta.signature_url\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n                      <label>Author URL</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <input ng-model=\"selectedImageObj.image_alt\" class=\"form-control\" ng-change=\"changeField()\" ng-blur=\"outFocus()\">\r\n                      <label>Alt text</label> \r\n                    </div>\r\n                  </div>\r\n                  <div class=\"attachment-display\" ng-show=\"currentPostObj.insertMediatoEditor && !checkedInsertToGallery\">\r\n                    <div class=\"form-group\">\r\n                      <select ng-model=\"selectedAlign.value\" ng-change=\"changeAlign(selectedAlign.value)\" class=\"form-control\">\r\n                        <option value=\"alignleft\">Left</option>\r\n                        <option value=\"aligncenter\">Center</option>\r\n                        <option value=\"alignright\">Right</option>      \r\n                        <option value=\"alignnone\">None</option>\r\n                      </select>\r\n                      <label for=\"search-input\">Alignment:</label>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <select ng-model=\"selectedLink.value\" ng-change=\"changeLink(selectedLink.value)\" class=\"form-control\">\r\n                        <option value=\"none\">None</option>\r\n                        <option value=\"url\">Custom Url</option>      \r\n                      </select>\r\n                      <input type=\"text\" class=\"form-control custom-url\" ng-model=\"selectedImageObj.link_to\" ng-if=\"customUrlShow\">\r\n                      <label for=\"search-input\">Link to:</label>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                \r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"action\">\r\n            <a ng-click=\"currentPostObj.saveAttachments()\" class=\"btn btn-primary\" ng-show=\"!currentPostObj.mediaLibrary\">Save Photo</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"setFeaturedImage();currentPostObj.cancelImageModal()\" ng-show=\"currentPostObj.setFeaturedImage  && currentPostObj.mediaLibrary\">Set Featured Image</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"setShareImage();currentPostObj.cancelImageModal()\" ng-show=\"currentPostObj.setShareImage\">Set FB Image</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"insertMediaToEditor();\" ng-show=\"currentPostObj.insertMediatoEditor && currentPostObj.mediaLibrary && !checkedInsertToGallery\">Insert Photo</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"insertGallery();\" ng-show=\"(currentPostObj.mediaLibrary && currentPostObj.insertGallery && !currentPostObj.updateGallery) || (currentPostObj.mediaLibrary && checkedInsertToGallery)\">Insert Gallery</a>\r\n            <a class=\"btn btn-primary\" ng-click=\"insertGallery();\" ng-show=\"currentPostObj.mediaLibrary && currentPostObj.insertGallery && currentPostObj.updateGallery\">Update Gallery</a>\r\n            <!--  <a class=\"btn btn-primary\" ng-click=\"reorderImage()\" ng-if=\"selectedAttachments.value !='all' && currentPostObj.mediaLibrary\">Reorder images</a> -->\r\n            <div class=\"selected-photo-area\" ng-if=\"attachToPostArray.length > 0 && currentPostObj.mediaLibrary && (currentPostObj.insertMediatoEditor || currentPostObj.insertGallery)\">\r\n              <ul ng-style=\"{'width':attachToPostArray.length*74 + 'px'}\" sortable-gallery-hor-dir ng-model=\"attachToPostArray\">\r\n                <li ng-repeat=\"media in attachToPostArray\">\r\n                  <div class=\"img-wrapp clickable\">\r\n                      <img ng-src=\"{{media.thumbs['70x70']}}\" alt=\"\">\r\n                      <div class=\"remove-selected-image\" ng-click=\"removeSelectedImage(media)\"></div>\r\n                    </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n    \t</div>\r\n\t  </div>\r\n  </div>\r\n</div>\r\n "

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit\">\r\n\r\n  <div class=\"tag-edit\">\r\n    <h1 class=\"page-title\">Edit<span class=\"fw-semi-bold\">&nbsp;Tag</span><a ng-click=\"closeEditTag()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditTag()\" parametar=\"page\">&times;</a></h1> \r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"\" ng-model=\"vmte.tag.name\"></div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control readonly\" placeholder=\"\" ng-model=\"vmte.tag._id\" readonly>\r\n        </div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmte.tag.description\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmte.tag.unsafe\" id=\"unsafe\"><label for=\"unsafe\">Unsafe</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" quick-edit-dir objdata=\"vmte.tag\" state1=\"'tags'\" description=\"true\" name=\"true\" unsafe=\"true\" success-update-func=\"parent.reloadTable\" ng-if=\"vmte.tag\">\r\n        <a ng-click=\"vmte.tag.updateQuickEdit()\" class=\"btn btn-primary\">Update Tag</a>\r\n      </div>\r\n      <div class=\"merge-tags clearfix\" ng-if=\"vmte.superPermisions && vmte.tag._id\">\r\n        <section class=\"single-post--widget widget tags\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Merge tags into current tag (<span class=\"fw-bold\">{{vmte.tag._id}})</span></h5>\r\n          </header>\r\n          <div class=\"widget-body categories\">\r\n            <div class=\"search-wrapper\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"vmte.searchtagfocus\" auto-complete-dir enter-tag= \"vmte.addNewTag()\"  datachangelabel=\"\" datachangeid = \"\" type-dir=\"'mergeTag'\" placeholder=\"Search tag ...\" current-tag=\"vmte.tag._id\"> \r\n              <div class=\"required-error animate-show\" ng-show=\"vmte.existTag\">Tag alredy exists</div>\r\n              <ul class=\"list-tags\">\r\n                <li ng-repeat=\"tag in vmte.mergeTagsArr\"><span class=\"remove-from-list\" ng-click=\"vmte.removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n                <li ng-if=\"vmte.mergeTagsArr.length>0\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmte.mergeTags()\">Merge <span ng-if=\"vmte.mergeTagsArr.length==1\">tag</span><span ng-if=\"vmte.mergeTagsArr.length > 1\">all tags</span></button></li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n  </div> \r\n  <script type=\"text/ng-template\" id=\"template.html\">\r\n    <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n       <li ng-show=\"!showResult\">No result.</li>\r\n       <li ng-repeat=\"tag in tagsTree | removeCurrentId:currentTag\" ng-click=\"chooseSearchData(tag.name, tag._id)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})&nbsp;<span class=\"danger-color fw-semi-bold\" ng-if=\"tag.count || tag.count == 0\">[{{tag.count}}]</span></li>\r\n   </ul>\r\n   </script>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <tag-edit-dir ng-if=\"vmt.tagEdit\" parent=\"vmt\"></tag-edit-dir>\r\n  <div>\r\n  <div class=\"tags-posts\">\r\n    <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Tags</span></h1>\r\n \r\n  <div class=\"tags-posts--left-column\">\r\n    <h4 class=\"fw-semi-bold\">Add New Tag</h3>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter tag name\" ng-model=\"vmt.tagName\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmt.nameRequired\">Tag name is required.</div>\r\n      <div class=\"input-description\">The name is how it appears on your site.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter tag slug\" ng-model=\"vmt.tagSlug\"></div>\r\n      <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n      <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmt.tagDescription\"></textarea>\r\n      <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <a href=\"\" class=\"btn btn-primary\" ng-click=\"vmt.addNewTag()\">Add New Tag</a>\r\n    </div>\r\n  </div>\r\n  <div class=\"tags-posts--right-column\">\r\n    <div class=\"table-filter\">\r\n      <div class=\"bulk-actions\" bulk-delete-dir objdata=\"vmt\" state1=\"'tags'\" ids=\"vmt.checkedPostsEdit\" success-update-func=\"vmt.updateBulkDeleteSuccess\" ng-if=\"vmt\">\r\n        <select ng-model=\"vmt.selectedBulkAction.value\" ng-change=\"vmt.switchBulkAction(vmt.selectedBulkAction.value)\" class=\"form-control\">\r\n          <option value=\"default\">Bulk Actions</option>\r\n          <option value=\"delete\">Delete</option>      \r\n        </select>\r\n        <a ng-click=\"vmt.bulkAction(vmt.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n      </div>\r\n      <div class=\"form-group search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmt.searchData\" ng-enter=\"vmt.search(vmt.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmt.search(vmt.searchData);\">Search Tags</button></span></div></div>\r\n    </div>\r\n    <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmt.tableParams\" class=\"table table-condensed table-bordered table-striped tags-table\">\r\n        <tr ng-repeat=\"tag in $data\">\r\n        <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmt.checkboxes.items[tag._id]\" ng-change=\"vmt.checkedPost(tag._id, vmt.checkboxes.items[tag._id])\"/><label></label>\r\n          </div>\r\n        </td>\r\n        <!-- <td data-title=\"'#'\" class=\"posts-table--id\" sortable=\"'post_id'\">{{post.post_id}}</td> -->\r\n        <td data-title=\"'Name'\" sortable=\"'name'\" class=\"ng-table--title\" quick-edit-dir objdata=\"tag\" state1=\"'tags'\" description=\"true\" name=\"true\" unsafe=\"true\" success-update-func=\"vmt.reloadTable\">\r\n          <div class=\"title\">\r\n            <span class=\"clickable fw-semi-bold\" ng-class=\"{'editHidden':tag._id==vmt.selectedName}\" ng-click=\"vmt.editTag(tag._id)\">{{tag.name}}</span>\r\n            <div ng-class=\"{'editShow':tag._id==vmt.selectedName}\" class=\"title-edit\">\r\n              <h5>QUICK EDIT</h5>\r\n              <div class=\"form-group\">\r\n                <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n                <input type=\"text\" ng-model=\"tag.name\" class=\"form-control\">\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n                <input type=\"text\" ng-model=\"tag.description\" class=\"form-control\">\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <div class=\"checkbox checkbox-primary\">\r\n                  <input type=\"checkbox\" ng-model=\"tag.unsafe\" id=\"unsafe_{{tag._id}}\"><label for=\"unsafe_{{tag._id}}\">Unsafe</label>\r\n                </div>\r\n              </div>\r\n              <a ng-click=\"tag.updateQuickEdit();vmt.cancelQuickEdit();\" class=\"btn btn-primary\">Update Tag</a> \r\n              <a ng-click=\"tag.cancelQuickEdit();vmt.cancelQuickEdit();\" class=\"btn btn-danger\">Cancel</a>\r\n            </div>\r\n          </div>\r\n          <div class=\"title-actions\" ng-class=\"{'editHidden':tag._id==vmt.selectedName}\" >\r\n            <ul>\r\n              <li><span class=\"clickable\" ng-click=\"vmt.editTag(tag._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li><span class=\"clickable\" ng-click=\"vmt.quickEdit(tag._id);tag.quickEdit()\">Quick Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <delete-item-dir ng-if=\"!tag.count\" ele-id=\"tag._id\" state1=\"'tags'\" success-delete-func=\"vmt.reloadTable\"></delete-item-dir>\r\n              <li><span class=\"clickable\" ng-click=\"vmt.goToAllPosts(tag._id)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n            </ul>\r\n          </div>\r\n        </td>\r\n          <!-- <td data-title=\"'Description'\" sortable=\"'description'\" class=\"ng-table--description\">\r\n              <span>{{tag.description}}</span>\r\n          </td> -->\r\n          <td data-title=\"'Slug'\" sortable=\"'slug'\" class=\"ng-table--slug\">\r\n              <span style=\"word-break: break-word;\">{{tag._id}}</span>\r\n           \r\n          </td>\r\n          <td data-title=\"'Count'\" sortable=\"'count'\" class=\"ng-table--count\">\r\n              <span  ng-click=\"vmt.goToAllPosts(tag._id)\" class=\"clickable\">{{tag.count}}</span>\r\n            \r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div> \r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmt.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n          </div>\r\n      </script>\r\n    </div>\r\n  </div>\r\n  \r\n  </div>\r\n</div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n\r\n    <div class=\"usElection-wrapper overflow-hidden\">\r\n        <h1 class=\"page-title\"><span class=\"fw-semi-bold\">US&nbsp;Elections</span></h1> \r\n        <div class=\"usElection-content pull-left\">\r\n            <a ng-click=\"vmue.saveChanges()\" class=\"btn btn-primary pull-right clear-both margin-bottom-10\">Save changes</a>\r\n            <div class=\"form-group pull-left clear-both widget-url-field\">\r\n                <label>Widget url</label>\r\n                <input type=\"text\" ng-model=\"vmue.widgetUrl\" placeholder=\"Enter widget url\" class=\"form-control\">\r\n            </div>\r\n            <table class=\"table table-bordered margin-bottom-10 clear-both pull-left\">\r\n                <thead>\r\n                    <tr>\r\n                    <th class=\"text-center\">No.</th>\r\n                    <th>State</th>\r\n                    <th class=\"text-center\">No result</th>\r\n                    <th class=\"text-center\">Trump</th>\r\n                    <th class=\"text-center\">Harris</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <tr>\r\n                        <td colspan=\"3\" class=\"align-middle\"><div class=\"title fw-semi-bold\">Total electoral votes</div></td>\r\n                        <td class=\"text-center\">\r\n                            <div class=\"input-group input-group-no-border\">\r\n                                <input type=\"text\" ng-model=\"vmue.dt_total\" class=\"form-control\" ng-keypress=\"vmue.keyPressOnlyNumber($event)\" ng-focus=\"vmue.dtTotalRequied = false\" ng-class=\"{'error-border':vmue.dtTotalRequied}\">\r\n                            </div>\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                            <div class=\"input-group input-group-no-border\">\r\n                                <input type=\"text\" ng-model=\"vmue.kh_total\" class=\"form-control\" ng-keypress=\"vmue.keyPressOnlyNumber($event)\" ng-focus=\"vmue.khTotalRequied = false\" ng-class=\"{'error-border':vmue.khTotalRequied}\">\r\n                            </div>\r\n                        </td>\r\n                    </tr>\r\n                    <tr ng-repeat=\"item in vmue.usElectionArray track by item.id\">\r\n                        <td class=\"order-cell text-center align-middle\"><span class=\"fw-semi-bold\">{{$index + 1}}</span></td>\r\n                        <td class=\"ng-table--title align-middle\">\r\n                            <div class=\"title fw-semi-bold\">{{item.name}}</div>\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                            <div class=\"checkbox checkbox-default\">\r\n                                <input type=\"radio\" ng-model=\"vmue.checkboxes[item.id]\" value=\"\"/><label></label>\r\n                            </div> \r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                            <div class=\"checkbox checkbox-dt\">\r\n                                <input type=\"radio\" ng-model=\"vmue.checkboxes[item.id]\" value=\"dt\"/><label></label>\r\n                            </div> \r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                            <div class=\"checkbox checkbox-kh\">\r\n                                <input type=\"radio\" ng-model=\"vmue.checkboxes[item.id]\" value=\"kh\"/><label></label>\r\n                            </div> \r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n            <a ng-click=\"vmue.saveChanges()\" class=\"btn btn-primary pull-right clear-both\">Save changes</a>    \r\n        </div>   \r\n    </div>\r\n  </section>"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <rating-dir ng-if=\"vmratings.editRatingShow\" parent=\"vmratings\"></rating-dir>\r\n  <div ng-if=\"!vmratings.editRatingShow\">\r\n  <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Ratings</span>&nbsp;<a data-ui-sref=\"app.newrating\" class=\"btn btn-primary\">New Rating</a></h1>\r\n\r\n  <div class=\"all-votes\">\r\n    <div class=\"status-filter\">\r\n      <ul>\r\n        <li><a ng-click=\"vmratings.changeStatus($event, 'all')\" class=\"clickable\" ng-class=\"{'active':vmratings.status =='all'}\">All</a> |</li>\r\n        <li><a ng-click=\"vmratings.changeStatus($event, 'publish')\" class=\"clickable\" ng-class=\"{'active':vmratings.status =='publish'}\">Publish</a> |</li>\r\n        <li><a ng-click=\"vmratings.changeStatus($event, 'finish')\" class=\"clickable\" ng-class=\"{'active':vmratings.status =='finish'}\">Finish</a> |</li>\r\n        <li><a ng-click=\"vmratings.changeStatus($event, 'trash')\" class=\"clickable\" ng-class=\"{'active':vmratings.status =='trash'}\">Trash</a></li>\r\n      </div>\r\n    </div>\r\n  <div class=\"table-filter\">\r\n    <div class=\"bulk-actions\">\r\n      <select ng-model=\"vmratings.selectedBulkAction.value\" ng-change=\"vmratings.switchBulkAction(vmratings.selectedBulkAction.value)\" class=\"form-control\">\r\n        <option value=\"default\">Bulk Actions</option>\r\n        <option value=\"delete\">Delete</option>\r\n      </select>\r\n      <a ng-click=\"vmratings.bulkAction(vmratings.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n    </div>\r\n    <div class=\"form-group range-picker\" >\r\n        <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmratings.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n    </div>\r\n    <a ng-click=\"vmratings.postFilter()\" class=\"btn btn-primary\">Filter</a>\r\n    <a ng-click=\"vmratings.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n    <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmratings.searchData\" ng-change=\"vmratings.changeSearch(vmratings.searchData)\" ng-enter=\"vmratings.search(vmratings.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmratings.search(vmratings.searchData);\">Search</button></span></div></div>\r\n  </div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmratings.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\" edit=\"post\">\r\n          <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n            <div class=\"checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"vmratings.checkboxes.items[post._id]\" ng-change=\"vmratings.checkedPost(post._id, vmratings.checkboxes.items[post._id])\"/><label></label>\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">{{post._id}}</td>\r\n          <td data-title=\"'Title'\" sortable=\"'title'\" class=\"ng-table--title\">\r\n            <div class=\"title\">\r\n              <span class=\"clickable fw-semi-bold\" ng-click=\"vmratings.editRating(post._id)\">{{post.title}}</span> \r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vmratings.editRating(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable clickable-danger\" ng-click = \"vmratings.updateStatus(post, 'publish')\">Publish</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='publish'\"><span class=\"clickable clickable-danger\" ng-click = \"vmratings.updateStatus(post, 'finish')\">Finish</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='publish'\"><span class=\"clickable clickable-danger\" ng-click = \"vmratings.updateStatus(post, 'trash')\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable clickable-danger\" ng-click = \"vmratings.deleteRating(post._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'Status'\" sortable=\"'status'\" class=\"ng-table--status\">\r\n            <span>{{post.status}}</span>\r\n          </td>\r\n          <td data-title=\"'date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n            <span>{{post.date | date:'MMM d, y H:mm'}}</span>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmratings.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\" /><label></label>\r\n      </div>\r\n    </script>\r\n    \r\n  </div>\r\n  </div>\r\n</div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\" ng-class=\"{'edit-post':!vmrating.newRating, 'new-post':vmrating.newRating}\">\r\n  <h1 ng-if=\"!vmrating.newRating\"class=\"page-title\">Edit <span class=\"fw-semi-bold\">Rating</span>&nbsp;<a data-ui-sref=\"app.newrating\" class=\"btn btn-primary\">New Rating</a><a ng-click=\"closeEditRating()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditRating()\" parametar=\"page\">&times;</a></h1>\r\n  <h1 ng-if=\"vmrating.newRating\"class=\"page-title\">Add New <span class=\"fw-semi-bold\">Rating</span></h1>\r\n  <div class=\"single-post rating\">\r\n    <div class=\"single-post--columns-wraper\">\r\n      <div class=\"single-post--left-col\">\r\n        <div class=\"form-group title-wrapper\"> \r\n          <label class=\"fw-bold\">Add new title</label>\r\n          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Enter title here\" ng-model=\"vmrating.dataRating.title\" ng-class=\"{'error-border':vmrating.titleRequired}\" ng-focus=\"vmrating.titleRequired = false\">\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label class=\"fw-bold\">Choose type</label>\r\n          <select ng-model=\"vmrating.selectedType.value\" class=\"form-control auto-width\" ng-change=\"vmrating.changeType()\">\r\n            <option value=\"football\">Football</option>\r\n            <option value=\"basketball\">Basketball</option>\r\n            <option value=\"other\">Other</option>\r\n          </select>\r\n        </div> \r\n        <div class=\"form-group\" ng-if=\"vmrating.newRating\">\r\n          <label class=\"fw-bold\">Upload image</label>\r\n          <form class=\"dropzone\" options=\"vmrating.dzOptions\" callbacks=\"vmrating.dzCallbacks\" methods=\"vmrating.dzMethods\" ng-dropzone ng-class=\"{'uploadedFile' : vmrating.uploaded || vmrating.pendingUpload, 'error-border':vmrating.uploadRequired}\"></form>\r\n        </div>\r\n        <div class=\"sortable-grid-flex\">\r\n          <div class=\"sortable-grid-flex-header\">\r\n            <div class=\"sortable-grid-flex-header-item item-index\">Order</div>\r\n            <div class=\"sortable-grid-flex-header-item item-name\">Name</div>\r\n            <div class=\"sortable-grid-flex-header-item item-number\" ng-if=\"vmrating.selectedType.value !== 'other'\">Number</div>\r\n            <div class=\"sortable-grid-flex-header-item item-action\">Action</div>\r\n          </div>\r\n          <div class=\"sortable-grid-flex-body\" ui-sortable=\"vmrating.sortableOptions\" ng-model=\"vmrating.choices\" class=\"sortable-grid__wrapper\" ng-if=\"vmrating.choices.length > 0\">\r\n            <div class=\"sortable-grid-flex-item-wrapper\" ng-repeat=\"choice in vmrating.choices track by $index\">\r\n              <div class=\"sortable-grid-flex-item item-index\">\r\n                <span class=\"fw-semi-bold\">{{$index + 1}}</span>\r\n              </div>\r\n              <div class=\"sortable-grid-flex-item item-name\">\r\n                <div class=\"input-field focus-input\" ng-class=\"{'disabled-input':!vmrating.editChoiceShow[choice._id]}\">\r\n                  <input type=\"text\" ng-model=\"choice.name\" placeholder=\"Add name\" class=\"form-control\" ng-class=\"{'error-border':vmrating.required[choice._id].name}\" ng-focus=\"vmrating.required[choice._id].name = false\">\r\n                </div>\r\n              </div>\r\n              <div class=\"sortable-grid-flex-item item-number\" ng-if=\"vmrating.selectedType.value !== 'other'\">\r\n                <div class=\"input-field focus-input\" ng-class=\"{'disabled-input':!vmrating.editChoiceShow[choice._id]}\">\r\n                  <input type=\"text\" ng-model=\"choice.number\" placeholder=\"Add number\" class=\"form-control\" ng-keypress=\"vmrating.keyPressOnlyNumber($event)\" ng-class=\"{'error-border':vmrating.required[choice._id].number || vmrating.required[choice._id].duplicateNumber}\" ng-focus=\"vmrating.required[choice._id].number = false\">\r\n                </div>\r\n              </div>\r\n              <div class=\"sortable-grid-flex-item item-action\">\r\n                <button ng-click=\"vmrating.editOrSaveChoice(choice)\" class=\"action-btn action-btn-primary\">   \r\n                  <i class=\"fa fa-pencil\" aria-hidden=\"true\" ng-if=\"!vmrating.editChoiceShow[choice._id]\" title=\"Edit\"></i>\r\n                  <i class=\"fa fa-save\" aria-hidden=\"true\" ng-if=\"vmrating.editChoiceShow[choice._id]\" title=\"Save\"></i>\r\n                </button>\r\n                <button ng-click=\"vmrating.deleteOrCancelEditChoice(choice)\" class=\"action-btn action-btn-danger\">\r\n                  <i class=\"fa fa-trash\" aria-hidden=\"true\" ng-if=\"!vmrating.editChoiceShow[choice._id]\" title=\"Delete\"></i>\r\n                  <i class=\"fa fa-times\" aria-hidden=\"true\" ng-if=\"vmrating.editChoiceShow[choice._id]\" title=\"Cancel\"></i> \r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sortable-grid-flex-body\" ng-if=\"vmrating.choices.length === 0\">\r\n            <div class=\"text-center no-items-found\" ng-if=\"vmrating.selectedType.value !== 'other'\">No rating items</div>\r\n            <div class=\"text-center no-items-found\" ng-if=\"vmrating.selectedType.value === 'other'\">No rating items</div>\r\n          </div>\r\n          <div class=\"btn-choice btn-choice-success pull-left margin-top-5\" ng-click=\"vmrating.addNewChoice()\">Add new <span class=\"fw-semi-bold\">+</span></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"single-post--right-col\">\r\n        <section class=\"single-post--widget widget publish\">\r\n          <header class=\"bb bg-body-light\">\r\n            <h5 class=\"fw-bold\">Rating Publish</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n            <ul>\r\n              <li ng-if=\"!vmrating.newRating\"><i class=\"fa fa-key\" aria-hidden=\"true\"></i><span class=\"fw-semi-bold\">&nbsp;Status:&nbsp;</span><span class=\"fw-bold status\" ng-class=\"{'success':vmrating.dataRating.status=='publish','danger':vmrating.dataRating.status=='finish'}\" ng-show=\"vmrating.dataRating.status\">{{vmrating.dataRating.status}}&nbsp;</span><span class=\"clickable\" ng-click=\"vmrating.editRatingStatus()\">-&nbsp;Edit</span>\r\n                <div class=\"editable\" ng-if=\"vmrating.editRatingStatusShow\">\r\n                  <select ng-model=\"vmrating.selectedRatingStatus.value\" class=\"form-control\">\r\n                    <option value=\"publish\">Publish</option>\r\n                    <option value=\"finish\">Finish</option>\r\n                    <option value=\"trash\">Trash</option>\r\n                  </select>\r\n                  <a ng-click=\"vmrating.changeRatingStatus()\"class=\"btn btn-primary\">Ok</a>\r\n                  <a ng-click=\"vmrating.cancelEditRatingStatus()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n              <li>\r\n                <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\r\n                <span class=\"fw-semi-bold\">&nbsp;Rating active until:&nbsp;</span><span class=\"fw-bold\" ng-show=\"vmrating.dataRating.expire_date\">{{vmrating.dataRating.expire_date}}&nbsp;</span>\r\n                <span class=\"clickable\" ng-click=\"vmrating.editRatingDate()\">-&nbsp;Edit</span>\r\n                <div class=\"date-edit\" ng-if=\"vmrating.editRatingDateShow\">\r\n                  <select ng-model=\"vmrating.selectedRatingMonth.value\" class=\"form-control\">\r\n                    <option value=\"1\">1-Jan</option>\r\n                    <option value=\"2\">2-Feb</option>\r\n                    <option value=\"3\">3-Mar</option>\r\n                    <option value=\"4\">4-Apr</option>\r\n                    <option value=\"5\">5-May</option>\r\n                    <option value=\"6\">6-Jun</option>\r\n                    <option value=\"7\">7-Jul</option>\r\n                    <option value=\"8\">8-Aug</option>\r\n                    <option value=\"9\">9-Sep</option>\r\n                    <option value=\"10\">10-Oct</option>\r\n                    <option value=\"11\">11-Nov</option>\r\n                    <option value=\"12\">12-Dec</option>      \r\n                  </select>\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmrating.ratingDay\" ng-keypress=\"vmrating.keyPressOnlyNumber($event)\">\r\n                  <span>,</span>\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmrating.ratingYear\" ng-keypress=\"vmrating.keyPressOnlyNumber($event)\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmrating.ratingHours\" ng-keypress=\"vmrating.keyPressOnlyNumber($event)\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vmrating.ratingMinutes\" ng-keypress=\"vmrating.keyPressOnlyNumber($event)\">\r\n                  <a ng-click=\"vmrating.setRatingDate()\"class=\"btn btn-primary\">Ok</a>\r\n                    <a ng-click=\"vmrating.cancelEditRatingDate()\" class=\"btn btn-danger\">Cancel</a>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <footer class=\"bt\">\r\n            <a ng-click=\"vmrating.trashRating()\" class=\"clickable-danger\" ng-if=\"!vmrating.newRating\">Move to Trash</a>\r\n            <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-click = \"vmrating.updateRating()\" ng-if=\"!vmrating.newRating\">Update</button>\r\n            <button type=\"submit\" class=\"btn btn-primary pull-right\" ng-click = \"vmrating.publishRating()\" ng-if=\"vmrating.newRating\">Publish</button>\r\n          </footer>\r\n        </section>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <user-edit-dir ng-if=\"vmau.editUserShow\" parent=\"vmau\" parentPost=\"vmau._id\"></user-edit-dir>\r\n  <div ng-if=\"!vmau.editUserShow\">\r\n  <h1 class=\"page-title\">All <span class=\"fw-semi-bold\">Users</span>&nbsp;<a data-ui-sref=\"app.newuser\" class=\"btn btn-primary\">New User</a></h1>\r\n\r\n  <div class=\"all-users\">\r\n  <div class=\"status-filter\">\r\n    <ul>\r\n      <li><a ng-click=\"vmau.changeStatus($event,'all')\" class=\"clickable\" ng-class=\"{'active':vmau.role =='all'}\">All</a> |</li>\r\n      <li ng-repeat=\"role in vmau.roles\"><a ng-click=\"vmau.changeStatus($event,role._id)\" class=\"clickable\" ng-class=\"{'active':vmau.role==role._id}\">{{role.name}}</a> |</li>\r\n    </ul>\r\n    <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmau.searchData\" ng-change=\"vmau.changeSearch(vmau.searchData)\" ng-enter=\"vmau.search(vmau.searchData)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmau.search(vmau.searchData);\">Search</button></span></div></div>\r\n  </div>\r\n  <div class=\"table-filter\">\r\n    <select ng-model=\"vmau.selectedStatus.value\" ng-change=\"vmau.switchStatusFilter(vmau.selectedStatus.value)\" class=\"form-control\">\r\n      <option value=\"all\">Select user status</option>\r\n      <option value=\"1\">Active</option>\r\n      <option value=\"0\">Inactive</option>\r\n    </select>\r\n    <a ng-click=\"vmau.postFilter()\" class=\"btn btn-primary\">Filter</a>\r\n    <a ng-click=\"vmau.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n  </div>\r\n  <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmau.tableParams\" class=\"table table-condensed table-bordered table-striped posts-table\">\r\n        <tr ng-repeat=\"post in $data\" edit=\"post\">\r\n        <td data-title=\"'#'\" class=\"ng-table--id\" sortable=\"'post_id'\">{{post._id}}</td>\r\n        <td data-title=\"'name'\" sortable=\"'first_name'\" class=\"ng-table--author\">\r\n            <span ng-click=\"vmau.editUser(post._id)\" class=\"clickable\">{{post.display_name}}</span>\r\n        </td>\r\n        <td data-title=\"'email'\" sortable=\"'email'\" class=\"ng-table--title\">\r\n          <div class=\"media-image\">\r\n            <a ng-click=\"vmau.editUser(post._id)\">\r\n              <img ng-src=\"{{post.avatar}}\" alt=\"{{post.display_name}}\" class=\"img-responsive\">\r\n            </a>\r\n          </div>\r\n          <div class=\"title-wrapp\">\r\n            <div class=\"title\">\r\n              <span class=\"clickable fw-semi-bold\" ng-click=\"vmau.editUser(post._id)\">{{post.email}}</span>\r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vmau.editUser(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable\" ng-click=\"vmau.authorPosts(post._id)\">View user posts</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </td>\r\n  \r\n        <td data-title=\"'role'\" sortable=\"'role'\"class=\"posts-table--date\">\r\n            <span ng-click=\"\">{{post.role}}</span>  \r\n        </td>\r\n        <td data-title=\"'status'\" sortable=\"'status'\" class=\"posts-table--status\">\r\n            <span ng-if=\"post.status==1\" class='success'>Active</span>\r\n            <span ng-if=\"post.status==0\" class='danger'>Inactive</span>\r\n        </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>   \r\n  </div>\r\n\r\n  </div>\r\n</div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit-user\">\r\n  <h1 class=\"page-title\">Edit <span class=\"fw-semi-bold\">User</span>&nbsp;<a data-ui-sref=\"app.newuser\" class=\"btn btn-primary\">New User</a><a ng-click=\"closeEditUser()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"closeEditUser()\" parametar=\"page\">&times;</a></h1>\r\n    <div class=\"single-user\">\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Email</label>\r\n        <input type=\"text\" class=\"form-control readonly\" ng-model=\"dataUser.email\" readonly>\r\n        <div class=\"input-description\">Usernames cannot be changed.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Role:</label>\r\n          <select ng-model=\"selectedRole.value\" ng-change=\"switchRole(selectedRole.value)\" class=\"form-control\">\r\n            <option ng-repeat= \"role in roles\" value=\"{{role._id}}\">{{role.name}}</option>\r\n          </select>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Position:</label>\r\n          <select ng-model=\"selectedPosition.value\" class=\"form-control\">\r\n            <option value=\"Novinar\">Novinar</option>\r\n            <option value=\"Urednik\">Urednik</option>\r\n            <option value=\"Glavni i odgovorni urednik\">Glavni i odgovorni urednik</option>\r\n            <option value=\"none\">&nbsp;</option>\r\n          </select>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">First Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.first_name\">\r\n        <div class=\"required-error animate-show\" ng-show=\"firstnameRequired\">First name is required.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"search-input\">Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.last_name\">\r\n        <div class=\"required-error animate-show\" ng-show=\"lastnameRequired\">Last name is required.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Biography</label>\r\n         <textarea type=\"text\" class=\"form-control\" ng-model=\"dataUser.bio\"></textarea>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Facebook profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.social.fb\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">X profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.social.x\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Linkedin profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.social.ld\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Instagram profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.social.ig\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Url</label>\r\n         <input type=\"text\" class=\"form-control readonly\" ng-model=\"dataUser.url\" >\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">New Password</label>\r\n        <div><input type=\"password\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter new password\" ng-model=\"password\" ng-keyup = \"checkPassword(password)\" ng-class=\"{'strong':passwordStrong, 'weak':passwordWeak}\" ng-blur = \"passwordStrong = false; passwordWeak = false\" ng-focus=\"checkPassword(password)\"></div>\r\n        <div class=\"custom-tooltip\" ng-class=\"{'show': passwordWeak}\">\r\n          <div ng-repeat=\"error in checkPasswordObj.errors\">{{error}}</div>\r\n        </div>\r\n        <div class=\"required-error animate-show\" ng-show=\"passwordRequired\">Password is required.</div>\r\n        <div class=\"required-error animate-show\" ng-show=\"passwordWeakRequired\">Password is weak.</div>\r\n        <div class=\"input-description\">If you would like to change the password type a new one. Otherwise leave this blank.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Repeat New Password</label>\r\n        <div><input type=\"password\" class=\"form-control\" placeholder=\"Enter repeated password\" ng-model=\"repeatedpassword\"></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"repeatpasswordRequired\">Repeated Password is required.</div>\r\n        <div class=\"required-error animate-show\" ng-show=\"matchedpassword\">Your password and repeated password do not match.</div>\r\n        <div class=\"input-description\">Type your new password again.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Active user</label>\r\n        <select ng-model=\"selectedStatus.value\" class=\"form-control\">\r\n          <option value=\"1\">Yes</option>\r\n          <option value=\"0\">No</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"form-group ai-functionality\" ng-show=\"functionalityList.length > 0\">\r\n        <label>AI Functionality:</label>\r\n        <div class=\"checkbox checkbox-primary\" ng-repeat=\"item in functionalityList\">\r\n          <input type=\"checkbox\" ng-model=\"item.checked\" id=\"functionality-{{item._id}}\"><label for=\"functionality-{{item._id}}\">{{item.name}}</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-show=\"functionalityList.length > 0\">\r\n        <label for=\"search-input\">Gemini API Key</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"dataUser.gemini_api_key\">\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <a class=\"btn btn-primary\" ng-click=\"updateUser()\">Update User</a>\r\n    </div>\r\n</section>"

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <h1 class=\"page-title\">New <span class=\"fw-semi-bold\">User</span></h1>\r\n  <div class=\"single-user\">\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Email (required)</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter email\" ng-model=\"vmu.email\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.emailRequired\">Email is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">First Name</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter first\" ng-model=\"vmu.firstname\">\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.firstnameRequired\">First name is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Last Name</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter last name\" ng-model=\"vmu.lastname\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.lastnameRequired\">Last name is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Password (required)</label>\r\n      <div><input type=\"password\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter password\" ng-model=\"vmu.password\" ng-keyup = \"vmu.checkPassword(vmu.password)\" ng-class=\"{'strong':vmu.passwordStrong, 'weak':vmu.passwordWeak}\" ng-blur = \"vmu.passwordStrong = false; vmu.passwordWeak = false\" ng-focus=\"vmu.checkPassword(vmu.password)\"></div>\r\n      <div class=\"custom-tooltip\" ng-class=\"{'show': vmu.passwordWeak}\">\r\n        <div ng-repeat=\"error in vmu.checkPasswordObj.errors\">{{error}}</div>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.passwordRequired\">Password is required.</div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.passwordWeakRequired\">Password is weak.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Repeat Password (required)</label>\r\n      <div><input type=\"password\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter repeated password\" ng-model=\"vmu.repeatedpassword\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.repeatpasswordRequired\">Repeated Password is required.</div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmu.matchedpassword\">Your password and repeated password do not match.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n     <label for=\"search-input\">Role:</label>\r\n    <select ng-model=\"vmu.selectedRole.value\" ng-change=\"vmu.switchRole(vmu.selectedRole.value)\" class=\"form-control\">\r\n      <option value=\"default\">Change role to...</option>\r\n      <option ng-repeat=\"role in vmu.roles\" value=\"{{role._id}}\">{{role.name}}</option>\r\n    </select>\r\n    <div class=\"required-error animate-show\" ng-show=\"vmu.roleRequired\">Choose role.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"search-input\">Active user</label>\r\n      <select ng-model=\"vmu.selectedStatus.value\" class=\"form-control\">\r\n        <option value=\"1\">Yes</option>\r\n        <option value=\"0\">No</option>\r\n      </select>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <a class=\"btn btn-primary\" ng-click=\"vmu.addNewUser()\">Add New User</a>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit-user\">\r\n  <h1 class=\"page-title\">Your <span class=\"fw-semi-bold\">Profile</span></h1>  \r\n <div class=\"single-user\">\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Email</label>\r\n        <input type=\"text\" class=\"form-control readonly\" ng-model=\"vmup.dataUser.email\" readonly>\r\n        <div class=\"input-description\">Usernames cannot be changed.</div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"vmup.permisions\">\r\n        <label for=\"search-input\">Role:</label>\r\n          <select ng-model=\"vmup.selectedRole.value\" ng-change=\"vmup.switchRole(vmup.selectedRole.value)\" class=\"form-control\">\r\n            <option ng-repeat= \"role in vmup.roles\" value=\"{{role._id}}\">{{role.name}}</option>\r\n          </select>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"vmup.permisions\">\r\n        <label for=\"search-input\">Position:</label>\r\n          <select ng-model=\"vmup.selectedPosition.value\" class=\"form-control\">\r\n            <option value=\"Novinar\">Novinar</option>\r\n            <option value=\"Urednik\">Urednik</option>\r\n            <option value=\"Glavni i odgovorni urednik\">Glavni i odgovorni urednik</option>\r\n            <option value=\"none\">&nbsp;</option>\r\n          </select>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"!vmup.permisions\">\r\n        <label for=\"search-input\">Role:</label>\r\n        <label class=\"readonly\">{{vmup.roleName}}</label>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">First Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.first_name\">\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.firstnameRequired\">First name is required.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"search-input\">Last Name</label>\r\n        <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.last_name\">\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.lastnameRequired\">Last name is required.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Biography</label>\r\n         <textarea type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.bio\"></textarea>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Facebook profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.social.fb\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">X profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.social.x\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Linkedin profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.social.ld\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Instagram profile</label>\r\n         <input type=\"text\" class=\"form-control\" ng-model=\"vmup.dataUser.social.ig\">\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Url</label>\r\n         <input type=\"text\" class=\"form-control readonly\" ng-model=\"vmup.dataUser.url\" >\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">New Password</label>\r\n        <div><input type=\"password\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter new password\" ng-model=\"vmup.password\" ng-keyup = \"vmup.checkPassword(vmup.password)\" ng-class=\"{'strong':vmup.passwordStrong, 'weak':vmup.passwordWeak}\" ng-blur = \"vmup.passwordStrong = false; vmup.passwordWeak = false\" ng-focus=\"vmup.checkPassword(vmup.password)\"></div>\r\n        <div class=\"custom-tooltip\" ng-class=\"{'show': vmup.passwordWeak}\">\r\n          <div ng-repeat=\"error in vmup.checkPasswordObj.errors\">{{error}}</div>\r\n        </div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.passwordRequired\">Password is required.</div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.passwordWeakRequired\">Password is weak.</div>\r\n        <div class=\"input-description\">If you would like to change the password type a new one. Otherwise leave this blank.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"search-input\">Repeat New Password</label>\r\n        <div><input type=\"password\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter repeated password\" ng-model=\"vmup.repeatedpassword\"></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.repeatpasswordRequired\">Repeated Password is required.</div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmup.matchedpassword\">Your password and repeated password do not match.</div>\r\n        <div class=\"input-description\">Type your new password again.</div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"vmup.permisions\">\r\n        <label for=\"search-input\">Active user:</label>\r\n        <select ng-model=\"vmup.selectedStatus.value\" class=\"form-control\">\r\n          <option value=\"1\">Yes</option>\r\n          <option value=\"0\">No</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"!vmup.permisions\">\r\n        <label for=\"search-input\">Active user:</label>\r\n        <label class=\"readonly\">{{vmup.status}}</label>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <a class=\"btn btn-primary\" ng-click=\"vmup.updateUser()\">Update User</a>\r\n    </div>\r\n</section>"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Livestream</span></h1>\r\n  \t<div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Title</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter title here\" ng-model=\"vmls.title\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmls.titleRequired\">Title is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">URL</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter URL here\" ng-model=\"vmls.url\">\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmls.urlRequired\">URL is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Image Src</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter Image Src here\" ng-model=\"vmls.imageSrc\">\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmls.imgRequired\">Image Src is required.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n    \t<div class=\"checkbox checkbox-primary\">\r\n      \t\t<input type=\"checkbox\" ng-model=\"vmls.active\"><label>Livestream active</label>\r\n    \t</div>\r\n    </div>\r\n    <div>\r\n    <a ng-click=\"vmls.saveLivestream()\" class=\"btn btn-primary pull-right\">Save</a>\r\n  </div>\r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget upload_video\">\r\n    <h1 class=\"page-title\">Upload <span class=\"fw-semi-bold\">New Video</span></h1>\r\n    <div class=\"checkbox checkbox-primary\">\r\n      <input type=\"checkbox\" ng-model=\"vmnvm.breaking\" id=\"breaking\"><label for=\"breaking\">Breaking</label>\r\n    </div>\r\n    <uppy-dashboard\r\n      parent-obj=\"vmnvm\"\r\n      upload-url=\"vmnvm.config.mediaoutcast.upload_url\"\r\n      get-video-url=\"vmnvm.config.mediaoutcast.get_video_url\"\r\n      authorization=\"vmnvm.config.mediaoutcast.authorization\">\r\n    </uppy-dashboard>\r\n      <!-- <form class=\"dropzone\" options=\"vmnvm.dzOptions\" callbacks=\"vmnvm.dzCallbacks\" methods=\"vmnvm.dzMethods\" ng-dropzone ng-class=\"{'uploadedVideo' : vmnvm.uploaded, 'error-border':vmnvm.uploadVideoRequired}\"></form> -->\r\n   <div class=\"form-group overflow-hidden\" ng-show = \"vmnvm.uploaded\" ng-class=\"{'slideInDown animated' : vmnvm.uploaded}\">\r\n     <label><span ng-show=\"vmnvm.thumbsLoaded.all\">Thumbnails</span><span ng-show=\"!vmnvm.thumbsLoaded.all\">Generating thumbnails (this can last up to 1 minute)</span></label>\r\n     <ul class=\"grid-wrapper\" ng-class=\"{'error-border':vmnvm.thumbRequired}\">\r\n       <li ng-repeat=\"thumb in vmnvm.thumbs\" ng-class=\"{'uploadedThumb': vmnvm.uploadedThumb,'portrait':vmnvm.orientation=='portrait'}\">\r\n         <div class=\"img-wrapp clickable\" ng-class=\"{'active': $index==vmnvm.selectedImage}\" ng-click=\"vmnvm.chooseImage($index)\">\r\n           <div class=\"loader-thumb\" ng-show=\"!vmnvm.thumbsLoaded[$index]\">\r\n             <img src=\"images/pending-animation.svg\" alt=\"\">\r\n           </div>\r\n           <img ng-src=\"{{thumb}}\" alt=\"\" ng-class=\"{'thumb-uploading':!vmnvm.thumbsLoaded[$index]}\" index=\"{{$index}}\">\r\n         </div>\r\n       </li>\r\n       <li ng-class=\"{'uploadedThumb': vmnvm.uploadedThumb,'portrait':vmnvm.orientation=='portrait'}\">\r\n         <div class=\"img-wrapp\">\r\n           <form class=\"dropzone\" options=\"vmnvm.dzOptionsThumb\" callbacks=\"vmnvm.dzCallbacksThumb\" methods=\"vmnvm.dzMethodsThumb\" ng-dropzone></form>\r\n         </div>\r\n       </li>\r\n     </ul>\r\n     <div class=\"required-error animate-show float-left\" ng-show=\"vmnvm.thumbRequired\">Thumb is required</div>\r\n   </div>\r\n      <div class=\"form-group\">\r\n     <label>Title</label>\r\n     <div class=\"character-count-wrapper\">\r\n       <textarea class=\"form-control\" ng-model=\"vmnvm.upload_title\" ng-class=\"{'error-border':vmnvm.titleRequired || vmnvm.titleExceed}\" character-count=\"nvm\" limit-character=\"100\" exceed-name=\"title\"></textarea>\r\n     </div>\r\n     <div class=\"required-error animate-show\" ng-show=\"vmnvm.titleRequired\">Title is required</div>\r\n     </div>\r\n   <div class=\"form-group\">\r\n     <label>Subtitle</label> \r\n     <textarea ng-model=\"vmnvm.upload_subtitle\" class=\"form-control\"></textarea>\r\n   </div>\t\r\n   <div class=\"form-group\">\r\n     <label>Categories</label>\r\n     <div class=\"widget-body\">\r\n     <div class=\"tab-content\">\r\n         <div class=\"tab-pane active clearfix categories-tree\">\r\n           <ul ng-class=\"{'error-border':vmnvm.categoryRequired}\">\r\n             <li ng-repeat=\"categoryInput in vmnvm.categoriesTreeInput\"  class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\" ng-class=\"{'checkedEditPost': vmnvm.categorychecked.item[categoryInput._id]}\"> <div class=\"checkbox checkbox-primary\"><input type=\"checkbox\" ng-model=\"vmnvm.categorychecked.item[categoryInput._id]\" id=\"{{categoryInput._id}}\" ng-click = \"vmnvm.updateSelection(categoryInput._id, vmnvm.categorychecked.item[categoryInput._id])\"><label for=\"{{categoryInput._id}}\">{{categoryInput.name}}</label></div>\r\n             </li>\r\n           </ul>\r\n         </div>\r\n         </div>\r\n         <div class=\"required-error animate-show\" ng-show=\"vmnvm.categoryRequired\">Category is required</div>\r\n     </div>\r\n   </div>\r\n   <div class=\"form-group search-wrapper\">\r\n     <label for=\"search-input\">Add tag</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmnvm.searchtagfocus\" auto-complete-dir enter-tag= \"vmnvm.addNewTag()\"  datachangelabel=\"\" datachangeid = \"\" type-dir=\"'video'\" ng-class=\"{'error-border':vmnvm.tagsRequired}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmnvm.addNewTag()\">Add</button></span></div>\r\n     <div class=\"required-error animate-show\" ng-show=\"vmnvm.newTagRequired\">New tag is required</div>\r\n     <div class=\"required-error animate-show\" ng-show=\"vmnvm.existTag\">Tag alredy exists</div>\r\n     <ul class=\"list-tags\">\r\n       <li ng-repeat=\"tag in vmnvm.tags\"><span class=\"remove-from-list\" ng-click=\"vmnvm.removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n     </ul>\r\n     <div class=\"required-error animate-show\" ng-show=\"vmnvm.tagsRequired\">Tag is required</div>\r\n   </div>\r\n   <div class=\"form-group\">\r\n     <label>Video safe</label>\r\n     <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"safety in vmnvm.addSafety\">\r\n       <input type=\"checkbox\" name=\"safety\" ng-model=\"vmnvm.checkedItems[safety._id]\"  id=\"{{safety._id}}\" ng-click=\"vmnvm.updateSafety(safety._id, vmnvm.checkedItems[safety._id])\" >\r\n       <label for=\"{{safety._id}}\" >{{safety.label}}</label>\r\n     </div>\r\n     <div class=\"required-error animate-show\" ng-show=\"vmnvm.videoSafeRequired\">Video safety is required</div>\r\n   </div>\r\n   <div class=\"form-group overflow-hidden\" ng-show = \"vmnvm.uploaded\" ng-class=\"{'slideInDown animated' : vmnvm.uploaded}\">\r\n     <label>Video allowance</label>\r\n     <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"allow in vmnvm.geoAllowance\">\r\n         <input type=\"checkbox\" ng-model=\"vmnvm.allowCheckedItems[allow._id]\"  id=\"{{allow._id}}\" ng-click=\"vmnvm.updateAllowance(allow._id)\" >\r\n         <label for=\"{{allow._id}}\">{{allow.label}}</label>\r\n     </div>\r\n   </div>\r\n   <div class=\"form-group\">\r\n     <label>Signature</label> \r\n     <textarea ng-model=\"vmnvm.upload_signature\" class=\"form-control\"></textarea>\r\n   </div>\r\n   <div class=\"form-group overflow-hidden\">\r\n     <a ng-click=\"vmnvm.saveVideos()\" class=\"pull-right btn btn-primary\">Save Videos</a>\r\n   </div>\r\n</section>\r\n<script type=\"text/ng-template\" id=\"template.html\">\r\n  <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n     <li ng-show=\"!showResult\">No result.</li>\r\n     <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.name, tag._id)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})</li>\r\n </ul>\r\n</script>\r\n\r\n\r\n\r\n"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget upload_video\">\r\n     <h1 class=\"page-title\">Upload <span class=\"fw-semi-bold\">New Video</span></h1>\r\n     <!-- <div class=\"upload-type-wrapper\">\r\n        <select ng-model=\"vmnv.selectedTranscoding.value\" class=\"form-control\">\r\n         <option value=\"v1.1\">Bitmovin</option>\r\n         <option value=\"v1.0\">Providus</option>\r\n        </select>\r\n        <label for=\"\">Transcoding:&nbsp;</label>\r\n    </div> -->\r\n    <div class=\"upload-type-wrapper\">\r\n        <select ng-model=\"vmnv.selectedVideoQuality.value\" class=\"form-control\">\r\n        <option value=\"medium\">Medium</option>\r\n        <option value=\"high\">High</option>\r\n        </select>\r\n        <label for=\"\">Video quality:&nbsp;</label>\r\n    </div>\r\n   \t<form class=\"dropzone\" options=\"vmnv.dzOptions\" callbacks=\"vmnv.dzCallbacks\" methods=\"vmnv.dzMethods\" ng-dropzone ng-class=\"{'uploadedVideo' : vmnv.uploaded, 'error-border':vmnv.uploadVideoRequired}\">\r\n    </form>\r\n    <div class=\"form-group overflow-hidden\" ng-show = \"vmnv.uploaded\" ng-class=\"{'slideInDown animated' : vmnv.uploaded}\">\r\n      <label><span ng-show=\"vmnv.thumbsLoaded.all\">Thumbnails</span><span ng-show=\"!vmnv.thumbsLoaded.all\">Generating thumbnails (this can last up to 1 minute)</span></label>\r\n      <ul class=\"grid-wrapper\" ng-class=\"{'error-border':vmnv.thumbRequired}\">\r\n        <li ng-repeat=\"thumb in vmnv.thumbs\" ng-class=\"{'uploadedThumb': vmnv.uploadedThumb}\">\r\n          <div class=\"img-wrapp clickable\" ng-class=\"{'active': $index==vmnv.selectedImage}\" ng-click=\"vmnv.chooseImage($index)\">\r\n            <div class=\"loader-thumb\" ng-show=\"!vmnv.thumbsLoaded[$index]\">\r\n              <img src=\"images/pending-animation.svg\" alt=\"\">\r\n            </div>\r\n            <img ng-src=\"{{thumb}}\" alt=\"\" class=\"thumb_upload\" index=\"{{$index}}\">\r\n          </div>\r\n        </li>\r\n        <li ng-class=\"{'uploadedThumb': vmnv.uploadedThumb}\">\r\n          <div class=\"img-wrapp\">\r\n            <form class=\"dropzone\" options=\"vmnv.dzOptionsThumb\" callbacks=\"vmnv.dzCallbacksThumb\" methods=\"vmnv.dzMethodsThumb\" ng-dropzone></form>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <div class=\"required-error animate-show float-left\" ng-show=\"vmnv.thumbRequired\">Thumb is required</div>\r\n    </div>\r\n   \t<div class=\"form-group\">\r\n      <label>Title</label>\r\n      <div class=\"character-count-wrapper\">\r\n        <textarea class=\"form-control\" ng-model=\"vmnv.upload_title\" ng-class=\"{'error-border':vmnv.titleRequired || vmnv.titleExceed}\" character-count=\"nv\" limit-character=\"100\" exceed-name=\"title\"></textarea>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmnv.titleRequired\">Title is required</div>\r\n  \t</div>\r\n    <div class=\"form-group\">\r\n      <label>Subtitle</label> \r\n      <textarea ng-model=\"vmnv.upload_subtitle\" class=\"form-control\"></textarea>\r\n    </div>\t\r\n    <div class=\"form-group\">\r\n      <label>Categories</label>\r\n      <div class=\"widget-body\">\r\n      <div class=\"tab-content\">\r\n          <div class=\"tab-pane active clearfix categories-tree\">\r\n            <ul ng-class=\"{'error-border':vmnv.categoryRequired}\">\r\n              <li ng-repeat=\"categoryInput in vmnv.categoriesTreeInput\"  class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\" ng-class=\"{'checkedEditPost': vmnv.categorychecked.item[categoryInput._id]}\"> <div class=\"checkbox checkbox-primary\"><input type=\"checkbox\" ng-model=\"vmnv.categorychecked.item[categoryInput._id]\" id=\"{{categoryInput._id}}\" ng-click = \"vmnv.updateSelection(categoryInput._id, vmnv.categorychecked.item[categoryInput._id])\"><label for=\"{{categoryInput._id}}\">{{categoryInput.name}}</label></div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          </div>\r\n          <div class=\"required-error animate-show\" ng-show=\"vmnv.categoryRequired\">Category is required</div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group search-wrapper\">\r\n      <label for=\"search-input\">Add tag</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vmnv.searchtagfocus\" auto-complete-dir enter-tag= \"vmnv.addNewTag()\"  datachangelabel=\"\" datachangeid = \"\" type-dir=\"'video'\" ng-class=\"{'error-border':vmnv.tagsRequired}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmnv.addNewTag()\">Add</button></span></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmnv.newTagRequired\">New tag is required</div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmnv.existTag\">Tag alredy exists</div>\r\n      <ul class=\"list-tags\">\r\n        <li ng-repeat=\"tag in vmnv.tags\"><span class=\"remove-from-list\" ng-click=\"vmnv.removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n      </ul>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmnv.tagsRequired\">Tag is required</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label>Video safe</label>\r\n      <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"safety in vmnv.addSafety\">\r\n        <input type=\"checkbox\" name=\"safety\" ng-model=\"vmnv.checkedItems[safety._id]\"  id=\"{{safety._id}}\" ng-click=\"vmnv.updateSafety(safety._id, vmnv.checkedItems[safety._id])\" >\r\n        <label for=\"{{safety._id}}\" >{{safety.label}}</label>\r\n      </div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmnv.videoSafeRequired\">Video safety is required</div>\r\n    </div>\r\n    <div class=\"form-group overflow-hidden\" ng-show = \"vmnv.uploaded\" ng-class=\"{'slideInDown animated' : vmnv.uploaded}\">\r\n      <label>Video allowance</label>\r\n      <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"allow in vmnv.geoAllowance\">\r\n          <input type=\"checkbox\" ng-model=\"vmnv.allowCheckedItems[allow._id]\"  id=\"{{allow._id}}\" ng-click=\"vmnv.updateAllowance(allow._id)\" >\r\n          <label for=\"{{allow._id}}\">{{allow.label}}</label>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label>Signature</label> \r\n      <textarea ng-model=\"vmnv.upload_signature\" class=\"form-control\"></textarea>\r\n    </div>\r\n    <div class=\"form-group overflow-hidden\">\r\n      <a ng-click=\"vmnv.saveVideos()\" class=\"pull-right btn btn-primary\">Save Videos</a>\r\n    </div>\r\n</section>\r\n<script type=\"text/ng-template\" id=\"template.html\">\r\n   <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n      <li ng-show=\"!showResult\">No result.</li>\r\n      <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.name, tag._id)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})</li>\r\n  </ul>\r\n</script>\r\n\r\n\r\n\r\n"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"uppy-upload-wrapper form-group\">\r\n    <div id=\"uppyDashboard\"></div>\r\n    <div class=\"transcoding-wrapper\" ng-show=\"transcoding\">\r\n        <h3 ng-if=\"!transcodingComplete\">Transcoding: {{transcodingProgress}}%</h3>\r\n        <h3 ng-if=\"transcodingComplete\">Transcoding Complete</h3>\r\n        <div class=\"transcoding-progress\" ng-class=\"{'complete':transcodingComplete}\">\r\n            <div class=\"transcoding-progress-bar\" ng-style=\"{'width':transcodingProgress + '%'}\"></div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget related-video-box overflow\">\r\n  <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Related Video Box</span></h1>\r\n  <a ng-click=\"vmrvb.saveChanges()\" class=\"btn btn-primary pull-right\">Save All Changes</a>\r\n  <div ng-repeat=\"widget in vmrvb.allWidgets\" class=\"form-group overflow widget-item\">\r\n    <label for=\"widget.category_name\"><span class=\"fw-semi-bold\">{{widget.category_name}}</span> - related video box</label>\r\n    <div class=\"sortable-grid position-relative\">\r\n      <table ng-class=\"{'error-border':vmrvb.minimumItem.ids[widget.category_id] || vmrvb.duplicateVideo.ids[widget.category_id]}\">\r\n        <thead>\r\n          <tr>\r\n          <th class=\"text-center mobileHiddenTable\">Id</th>\r\n          <th class=\"text-center\">Video Thumb</th>\r\n          <th>Title</th>\r\n          <th>&nbsp;</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody sortable-dir ng-model=\"widget.videos\" class=\"sortable-grid__wrapper\" ng-show=\"widget.videos.length > 0\" type=\"videoBox\">\r\n          <tr ng-repeat=\"video in widget.videos\">\r\n            <td class=\"text-center sortable-grid_id mobileHiddenTable\">{{video.video_obj._id}}</td>\r\n            <td class=\"text-center sortable-grid_image\">\r\n                <div class=\"media-image\">\r\n                  <img ng-src=\"{{vmrvb.thumbConvert(video.video_obj.image)}}\" class=\"img-responsive\" ng-if=\"video.video_obj.image\">\r\n                  <div class=\"duration\" ng-if=\"video.video_obj.duration\">{{vmrvb.durationFormated(video.video_obj.duration)}}</div>\r\n                </div>\r\n            </td>\r\n            <td class=\"title-cell\">\r\n              <div>{{video.video_obj.title}}</div>\r\n            </td>\r\n            <td class=\"clickable clickable-danger remove\" ng-click=\"vmrvb.removeVideoFromWidget(widget.category_id,video.video_obj._id)\"><span>×</span></td>\r\n          </tr>\r\n        </tbody>\r\n        <tbody ng-show=\"widget.videos.length == 0\">\r\n          <tr>\r\n            <td colspan=\"4\" class=\"colspan\">No videos.</td>\r\n          </tr>\r\n        </tbody>\r\n        <tfoot>\r\n        <tr>\r\n          <td class=\"text-center mobileHiddenTable\">Id</td>\r\n          <th class=\"text-center\">Video Thumb</th>\r\n          <th>Title</th>\r\n          <th>&nbsp;</th>\r\n        </tr>\r\n        </tfoot>\r\n      </table>\r\n      <div class=\"required-error animate-show ng-hide\" ng-show=\"vmrvb.minimumItem.ids[widget.category_id]\">Minimum number of videos is {{vmrvb.minimumItem.number}}.</div>\r\n      <div class=\"required-error animate-show ng-hide\" ng-show=\"vmrvb.duplicateVideo.ids[widget.category_id]\">Video alredy exist.</div>\r\n    </div>\r\n    <a ng-click=\"vmrvb.addVideo(widget.category_id)\" class=\"btn btn-primary pull-left\">Add to {{widget.category_name}}</a>\r\n  </div>\r\n  <a ng-click=\"vmrvb.saveChanges()\" class=\"btn btn-primary pull-right\">Save All Changes</a>\r\n</section>\r\n<set-featured-video ng-if=\"vmrvb.videoModalShow\" current-post-obj=\"vmrvb\"></set-featured-video>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <video-category-edit-dir ng-if=\"vmvc.categoryEdit\" parent=\"vmvc\"></video-category-edit-dir>\r\n  <div>\r\n    <div class=\"categories-posts\">\r\n      <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Categories</span></h1>\r\n   \r\n    <div class=\"categories-posts--left-column\">\r\n      <h4 class=\"fw-semi-bold\">Add New Category</h3>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter category name\" ng-model=\"vmvc.categoryName\"></div>\r\n        <div class=\"required-error animate-show\" ng-show=\"vmvc.nameRequired\">Category name is required.</div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter category slug\" ng-model=\"vmvc.categorySlug\"></div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"normal-field\" class=\"control-label\">Parent</label>\r\n         <select ng-model=\"vmvc.selectedCategory.value\" ng-change=\"vmvc.switchCategories(vmvc.selectedCategory.value)\" class=\"form-control\">\r\n        <option value=\"none\">None</option>\r\n        <option ng-repeat= \"categorySelect in vmvc.categoriesTreeSelect\" value=\"{{categorySelect._id}}\" class=\"level{{categorySelect.ancestors.length}}\" ng-bind=\"categorySelect.name\"></option>\r\n      </select>\r\n        <div class=\"input-description\">Categories, unlike tags, can have a hierarchy. You might have a Jazz category, and under that have children categories for Bebop and Big Band. Totally optional.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmvc.categoryDescription\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <a class=\"btn btn-primary\" ng-click=\"vmvc.addNewCategory()\">Add New Category</a>\r\n      </div>\r\n    </div>\r\n    <div class=\"categories-posts--right-column\">\r\n      <div class=\"table-filter\">\r\n        <div class=\"bulk-actions\" bulk-delete-dir objdata=\"vmvc\" state1=\"'video-categories'\" ids=\"vmvc.checkedPostsEdit\" success-update-func=\"vmvc.updateBulkDeleteSuccess\" ng-if=\"vmvc\">\r\n          <select ng-model=\"vmvc.selectedBulkAction.value\" ng-change=\"vmvc.switchBulkAction(vmvc.selectedBulkAction.value)\" class=\"form-control\">\r\n            <option value=\"default\">Bulk Actions</option>\r\n            <option value=\"delete\">Delete</option>      \r\n          </select>\r\n          <a ng-click=\"vmvc.bulkAction(vmvc.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n        </div>\r\n        <div class=\"form-group search\">\r\n          <input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmvc.searchData.name\"  ng-change=\"vmvc.changeSearch(vmvc.searchData)\">\r\n        </div>\r\n      </div>\r\n      <div class=\"widget-body table-wrapper\">\r\n        <table ng-table=\"vmvc.tableParams\" class=\"table table-condensed table-bordered table-striped categories-table\">\r\n          <tr ng-repeat=\"category in $data\">\r\n          <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n          <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"vmvc.checkboxes.items[category._id]\" ng-change=\"vmvc.checkedPost(category._id, vmvc.checkboxes.items[category._id])\"/><label></label>\r\n          </div>\r\n          </td>\r\n          <!-- <td data-title=\"'#'\" class=\"posts-table--id\" sortable=\"'post_id'\">{{post.post_id}}</td> -->\r\n          <td data-title=\"'Name'\" sortable=\"'name'\" class=\"ng-table--title\" quick-edit-dir objdata=\"category\" state1=\"'video-categories'\" description=\"true\" name=\"true\" success-update-func=\"vmvc.getCategories\">\r\n            <div class=\"title level{{category.ancestors.length}}\">\r\n              <span class=\"clickable fw-semi-bold category-name\" ng-class=\"{'editHidden':category._id==vmvc.selectedName}\" ng-click=\"vmvc.editCategory(category._id)\">{{category.name}}</span>\r\n              \r\n              <div ng-class=\"{'editShow':category._id==vmvc.selectedName}\" class=\"title-edit\">\r\n                <h5>QUICK EDIT</h5>\r\n                <div class=\"form-group\">\r\n                  <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n                  <input type=\"text\" ng-model=\"category.name\" class=\"form-control\">\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n                  <input type=\"text\" ng-model=\"category.description\" class=\"form-control\">\r\n                </div>\r\n                <a ng-click=\"category.updateQuickEdit();vmvc.cancelQuickEdit();\" class=\"btn btn-primary\">Update Category</a> \r\n                <a ng-click=\"category.cancelQuickEdit();vmvc.cancelQuickEdit()\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n            </div>\r\n            <div class=\"title-actions\" ng-class=\"{'editHidden':category._id==vmvc.selectedName}\">\r\n              <ul>\r\n                <li><span class=\"clickable\" ng-click=\"vmvc.editCategory(category._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li><span class=\"clickable\" ng-click=\"vmvc.quickEdit(category._id);category.quickEdit()\">Quick Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <delete-item-dir ng-if=\"!category.count\" ele-id=\"category._id\" state1=\"'video-categories'\" success-delete-func=\"vmvc.getCategories\"></delete-item-dir>\r\n                <li><span class=\"clickable\" ng-click=\"vmvc.goToAllPosts(category._id)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              </ul>\r\n            </div>\r\n          </td>\r\n            <td data-title=\"'Description'\" sortable=\"'description'\" class=\"ng-table--description\">\r\n                <span>{{category.description}}</span>\r\n            </td>\r\n            <td data-title=\"'Slug'\" sortable=\"'slug'\" class=\"ng-table--slug\">\r\n                <span>{{category._id}}</span>\r\n             \r\n            </td>\r\n            <td data-title=\"'Count'\" sortable=\"'count'\" class=\"ng-table--count\">\r\n                <span  ng-click=\"vmvc.goToAllPosts(category._id)\" class=\"clickable\">{{category.count}}</span>\r\n              \r\n            </td>\r\n          </tr>\r\n        </table>\r\n        <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n          <p>No result. Try again.</p>\r\n        </div> \r\n        <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmvc.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n          </div>\r\n        </script>\r\n      </div>\r\n    </div>\r\n    \r\n    </div>\r\n  </div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit\">\r\n\r\n  <div class=\"category-edit\">\r\n    <h1 class=\"page-title\">Edit<span class=\"fw-semi-bold\">&nbsp;Category</span><a ng-click=\"closeEditVideoCategory()\" class=\"clickable-danger close-edit fw-semi-bold\">&times;</a></h1> \r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"\" ng-model=\"vmvce.category.name\"></div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control readonly\" placeholder=\"\"ng-model=\"vmvce.category._id\" readonly></div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n       <label for=\"normal-field\" class=\"control-label\">Parent</label>\r\n        <select ng-model=\"vmvce.selectedCategory.value\" ng-change=\"vmvce.switchCategories(vmvce.selectedCategory.value)\" class=\"form-control readonly\">\r\n          <option value=\"none\" disabled>None</option>\r\n          <option ng-repeat=\"category in vmvce.categoriesTreeSelect\" ng-bind=\"category.name\" class=\"level0\" value=\"{{category._id}}\" disabled></option>\r\n        </select>\r\n        <div class=\"input-description\">Categories, unlike tags, can have a hierarchy. You might have a Jazz category, and under that have children categories for Bebop and Big Band. Totally optional.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmvce.category.description\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\" quick-edit-dir objdata=\"vmvce.category\" state1=\"'video-categories'\" description=\"true\" name=\"true\" success-update-func=\"parent.getCategories\" ng-if=\"vmvce.category\">\r\n        <a ng-click=\"vmvce.category.updateQuickEdit()\" class=\"btn btn-primary\">Update Category</a>\r\n      </div>\r\n  </div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit\">\r\n\r\n  <div class=\"tag-edit\">\r\n    <h1 class=\"page-title\">Edit<span class=\"fw-semi-bold\">&nbsp;Tag</span><a ng-click=\"closeEditVideoTag()\" class=\"clickable-danger close-edit fw-semi-bold\">&times;</a></h1> \r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"\" ng-model=\"vmvte.tag.name\"></div>\r\n        <div class=\"input-description\">The name is how it appears on your site.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n        <div><input type=\"text\" id=\"normal-field\" class=\"form-control readonly\" placeholder=\"\" ng-model=\"vmvte.tag._id\" readonly>\r\n        </div>\r\n        <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n        <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmvte.tag.description\"></textarea>\r\n        <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n      </div>\r\n      <div class=\"form-group\" quick-edit-dir objdata=\"vmvte.tag\" state1=\"'video-tags'\" description=\"true\" name=\"true\" success-update-func=\"parent.reloadTable\" ng-if=\"vmvte.tag\">\r\n        <a ng-click=\"vmvte.tag.updateQuickEdit()\" class=\"btn btn-primary\">Update Tag</a>\r\n      </div>\r\n  </div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n  <video-tag-edit-dir ng-if=\"vmvt.tagEdit\" parent=\"vmvt\"></video-tag-edit-dir>\r\n  <div ng-if=\"!vmvt.tagEdit\">\r\n  <div class=\"tags-posts\">\r\n    <h1 class=\"page-title\"><span class=\"fw-semi-bold\">Tags</span></h1>\r\n \r\n  <div class=\"tags-posts--left-column\">\r\n    <h4 class=\"fw-semi-bold\">Add New Tag</h3>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter tag name\" ng-model=\"vmvt.tagName\"></div>\r\n      <div class=\"required-error animate-show\" ng-show=\"vmvt.nameRequired\">Tag name is required.</div>\r\n      <div class=\"input-description\">The name is how it appears on your site.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Slug</label>\r\n      <div><input type=\"text\" id=\"normal-field\" class=\"form-control\" placeholder=\"Enter tag slug\" ng-model=\"vmvt.tagSlug\"></div>\r\n      <div class=\"input-description\">The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n      <textarea rows=\"4\" class=\"form-control\" id=\"default-textarea\" ng-model=\"vmvt.tagDescription\"></textarea>\r\n      <div class=\"input-description\">The description is not prominent by default; however, some themes may show it.</div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <a href=\"\" class=\"btn btn-primary\" ng-click=\"vmvt.addNewTag()\">Add New Tag</a>\r\n    </div>\r\n  </div>\r\n  <div class=\"tags-posts--right-column\">\r\n    <div class=\"table-filter\">\r\n      <div class=\"bulk-actions\" bulk-delete-dir objdata=\"vmvt\" state1=\"'video-tags'\" ids=\"vmvt.checkedPostsEdit\" success-update-func=\"vmvt.updateBulkDeleteSuccess\" ng-if=\"vmvt\">\r\n        <select ng-model=\"vmvt.selectedBulkAction.value\" ng-change=\"vmvt.switchBulkAction(vmvt.selectedBulkAction.value)\" class=\"form-control\">\r\n          <option value=\"default\">Bulk Actions</option>\r\n          <option value=\"delete\">Delete</option>      \r\n        </select>\r\n        <a ng-click=\"vmvt.bulkAction(vmvt.selectedBulkAction.value)\" class=\"btn btn-primary\">Apply</a>\r\n      </div>\r\n      <div class=\"form-group search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmvt.searchData\" ng-enter=\"vmvt.search(vmvt.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmvt.search(vmvt.searchData);\">Search Tags</button></span></div></div>\r\n    </div>\r\n    <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmvt.tableParams\" class=\"table table-condensed table-bordered table-striped tags-table\">\r\n        <tr ng-repeat=\"tag in $data\">\r\n        <td header=\"'ng-table/headers/checkbox.html'\" class=\"ng-table--check\">\r\n        <div class=\"checkbox checkbox-primary\">\r\n          <input type=\"checkbox\" ng-model=\"vmvt.checkboxes.items[tag._id]\" ng-change=\"vmvt.checkedPost(tag._id, vmvt.checkboxes.items[tag._id])\"/><label></label>\r\n          </div>\r\n        </td>\r\n        <!-- <td data-title=\"'#'\" class=\"posts-table--id\" sortable=\"'post_id'\">{{post.post_id}}</td> -->\r\n        <td data-title=\"'Name'\" sortable=\"'name'\" class=\"ng-table--title\" quick-edit-dir objdata=\"tag\" state1=\"'video-tags'\" description=\"true\" name=\"true\" success-update-func=\"vmvt.reloadTable\">\r\n          <div class=\"title\">\r\n            <span class=\"clickable fw-semi-bold\" ng-class=\"{'editHidden':tag._id==vmvt.selectedName}\" ng-click=\"vmvt.editTag(tag._id)\">{{tag.name}}</span>\r\n            <div ng-class=\"{'editShow':tag._id==vmvt.selectedName}\" class=\"title-edit\">\r\n              <h5>QUICK EDIT</h5>\r\n              <div class=\"form-group\">\r\n                <label for=\"normal-field\" class=\"control-label\">Name</label>\r\n                <input type=\"text\" ng-model=\"tag.name\" class=\"form-control\">\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label for=\"normal-field\" class=\"control-label\">Description</label>\r\n                <input type=\"text\" ng-model=\"tag.description\" class=\"form-control\">\r\n              </div>\r\n              <a ng-click=\"tag.updateQuickEdit();vmvt.cancelQuickEdit();\" class=\"btn btn-primary\">Update Tag</a> \r\n              <a ng-click=\"tag.cancelQuickEdit();vmvt.cancelQuickEdit();\" class=\"btn btn-danger\">Cancel</a>\r\n            </div>\r\n          </div>\r\n          <div class=\"title-actions\" ng-class=\"{'editHidden':tag._id==vmvt.selectedName}\" >\r\n            <ul>\r\n              <li><span class=\"clickable\" ng-click=\"vmvt.editTag(tag._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <li><span class=\"clickable\" ng-click=\"vmvt.quickEdit(tag._id);tag.quickEdit()\">Quick Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n              <delete-item-dir ng-if=\"!tag.count\" ele-id=\"tag._id\" state1=\"'video-tags'\" success-delete-func=\"vmvt.reloadTable\"></delete-item-dir>\r\n              <li><span class=\"clickable\" ng-click=\"vmvt.goToAllPosts(tag._id)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n            </ul>\r\n          </div>\r\n        </td>\r\n          <td data-title=\"'Description'\" sortable=\"'description'\" class=\"ng-table--description\">\r\n              <span>{{tag.description}}</span>\r\n          </td>\r\n          <td data-title=\"'Slug'\" sortable=\"'slug'\" class=\"ng-table--slug\">\r\n              <span>{{tag._id}}</span>\r\n           \r\n          </td>\r\n          <!-- <td data-title=\"'Count'\" sortable=\"'count'\" class=\"ng-table--count\">\r\n              <span  ng-click=\"vmvt.goToAllPosts(tag._id)\" class=\"clickable\">{{tag.count}}</span>\r\n            \r\n          </td> -->\r\n        </tr>\r\n      </table>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div> \r\n      <script type=\"text/ng-template\" id=\"ng-table/headers/checkbox.html\">\r\n      <div class=\"checkbox checkbox-primary\">\r\n        <input type=\"checkbox\" ng-model=\"vmvt.checkboxes.checked\" id=\"select_all\" name=\"filter-checkbox\" value=\"\"/><label></label>\r\n          </div>\r\n      </script>\r\n    </div>\r\n  </div>\r\n  \r\n  </div>\r\n</div> \r\n</section>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget\">\r\n <video-edit-dir ng-if =\"vmav.editVideoShow\" media=\"vmav\"></video-edit-dir>\r\n <div ng-if=\"!vmav.editVideoShow\">\r\n  <h1 class=\"page-title\">Video <span class=\"fw-semi-bold\">Library</span>&nbsp;<a data-ui-sref=\"app.newvideo_mediaoutcast\" class=\"btn btn-primary\">Add New Video</a></h1>\r\n\r\n  <div class=\"all-videos\">\r\n    <div class=\"status-filter\">\r\n      <ul>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'all')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='all'}\">All</a> |</li>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'publish')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='publish'}\">Published</a> |</li>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'pending')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='pending'}\">Pending</a> |</li>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'draft')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='draft'}\">Draft</a> |</li>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'schedule')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='schedule'}\">Scheduled</a> |</li>\r\n        <li><a ng-click=\"vmav.changeStatus($event, 'trash')\" class=\"clickable\" ng-class=\"{'active':vmav.status =='trash'}\">Trash</a></li>\r\n      </ul>\r\n      <div class=\"search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control\" id=\"search-input\" ng-model=\"vmav.searchData\" ng-change=\"vmav.changeSearch(vmav.searchData)\" ng-enter=\"vmav.search(vmav.searchData);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmav.search(vmav.searchData);\">Search</button></span></div>\r\n      </div>    \r\n    </div>\r\n    <div class=\"table-filter\">\r\n      <div class=\"change-preview\">\r\n        <a ng-click=\"vmav.showGrid=false;vmav.selectedImage = -1;\"><i class=\"fa fa-table\" aria-hidden=\"true\" ng-class=\"{'active':!vmav.showGrid}\"></i></a>\r\n        <a ng-click=\"vmav.showGrid=true;vmav.getGrid();vmav.selectedImage = -1;\"><i class=\"fa fa-th\" aria-hidden=\"true\" ng-class=\"{'active':vmav.showGrid}\"></i></a>\r\n      </div>\r\n      <select ng-model=\"vmav.selectedCategory.value\" ng-change=\"vmav.switchCategories(vmav.selectedCategory.value)\" class=\"form-control\">\r\n        <option value=\"all\">View all categories</option>\r\n        <option ng-repeat= \"category in vmav.categoriesTreeSelect\" value=\"{{category._id}}\" class=\"level{{category.ancestors.length}}\" ng-bind=\"category.name\"></option>\r\n      </select>\r\n      <div class=\"form-group range-picker\">\r\n          <input type=\"daterange\" input ng-model=\"myDateRange\" class=\"form-control\" placeholder=\"Enter a date range\" ranges=\"ranges\" ng-change = \"vmav.changeDate(myDateRange)\" ng-keydown=\"customDate($event)\"/>\r\n      </div>\r\n      <select ng-model=\"vmav.selectedAuthorFilter.value\" ng-change=\"vmav.switchAuthorFilter(vmav.selectedAuthorFilter.value)\" class=\"form-control\">\r\n        <option value=\"all\">View all authors</option>\r\n        <option ng-repeat= \"author in vmav.authorList\" value=\"{{author._id}}\">{{author.display_name}} ({{author._id}})</option>\r\n      </select>\r\n      <a ng-click=\"vmav.mediaFilters()\" class=\"btn btn-primary\">Filter</a>\r\n      <a ng-click=\"vmav.resetAllFilters()\" class=\"btn btn-info\">Clear all Filters</a>\r\n      \r\n    </div>\r\n\r\n    <div class=\"widget-body table-wrapper\">\r\n      <table ng-table=\"vmav.tableParams\" class=\"table table-condensed table-bordered table-striped\" ng-show=\"!vmav.showGrid\">\r\n        <tr ng-repeat=\"post in $data\" quick-edit edit=\"post\" class=\"post-row\">\r\n        <td data-title=\"'#'\" class=\"ng-table--id\">{{post._id}}</td>\r\n        <td data-title=\"'file'\" class=\"ng-table--title\">\r\n          <div class=\"media-image\">\r\n            <a ng-click=\"vmav.editVideo(post._id)\" ng-show=\"post.status!='trash' && post.status!='auto-draft'\">\r\n              <img ng-src=\"{{post.imageThumb}}\" class=\"img-responsive\">\r\n            </a>\r\n            <div class=\"duration\" ng-if=\"post.duration\">{{post.formated_duration}}</div>\r\n            <a ng-show=\"post.status =='trash' || post.status=='auto-draft'\" class=\"not-clickable\">\r\n              <img ng-src=\"{{(post.imageThumb)? post.imageThumb: 'images/placeholder.svg' }}\"  class=\"img-responsive\">\r\n            </a>\r\n            <div class=\"duration\" ng-if=\"post.duration\">{{post.formated_duration}}</div>\r\n          </div>\r\n          <div class=\"title-wrapp\">\r\n            <div class=\"title\">\r\n              <span ng-if=\"post.status!='trash' && post.status!='auto-draft'\" class=\"fw-semi-bold clickable\"  ng-click=\"vmav.editVideo(post._id)\">{{post.title}}</span>\r\n              <span ng-if=\"post.status=='trash' || post.status=='auto-draft'\" class=\"fw-semi-bold\">{{post.title}}</span>\r\n            </div>\r\n            <div class=\"title-actions\">\r\n              <ul>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable\" ng-click = \"vmav.updateStatusPost(post._id, 'publish')\">Publish this video</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash'\"><span class=\"clickable\" ng-click = \"vmav.updateStatusPost(post._id, 'draft')\">Save to draft</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status!='trash' && post.status!='auto-draft'\"><span class=\"clickable\" ng-click=\"vmav.editVideo(post._id)\">Edit</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if= \"post.status=='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmav.addToOther({'param1':'focus'},{'document_id':post._id,'type':'video','title':post.title})\">Add to Focus</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if= \"post.status=='publish'\"><span class=\"clickable clickable-success\" ng-click=\"vmav.addToOther({'param1':'pushnotifications'},{'document_id':post._id,'type':'video'})\">Add to Push Notifications</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status!='trash' && post.status!='auto-draft'\"><span class=\"clickable clickable-danger\" ng-click=\"vmav.updateStatusPost(post._id,'trash')\">Trash</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <li ng-if=\"post.status=='trash' || post.status=='auto-draft'\"><span class=\"clickable clickable-danger\" ng-click=\"vmav.deletePosts(post._id)\">Delete</span><span class=\"divider-bar\">&nbsp;|</span></li>\r\n                <!-- <li ng-if=\"post.status =='publish'\"><span class=\"clickable\" ng-click=\"vmav.previewPost(post)\">View</span><span class=\"divider-bar\">&nbsp;|</span></li> -->\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td data-title=\"'author'\" class=\"ng-table--author\">\r\n            <span ng-click=\"vmav.authorPosts(post.author._id)\" class=\"clickable\">{{post.author.display_name}}</span>\r\n          \r\n        </td>\r\n        <td data-title=\"'comments'\" class=\"ng-table--comment_count\">\r\n          <span class=\"comment-count\" ng-click=\"vmav.searchComment(post.comment_count, post._id)\">{{post.comment_count}}</span>\r\n        \r\n        </td>\r\n         <td data-title=\"'Categories'\" class=\"ng-table--categories\">\r\n            <span ng-click=\"vmav.categoryPosts(post.category._id)\" class=\"clickable\">{{post.category.name}}</span>\r\n          </td>\r\n           <td data-title=\"'Tags'\" class=\"ng-table--tags\">\r\n              <ul ng-class=\"{'editHidden':$index==vmav.selectedTags}\">\r\n                <li ng-repeat = \"tags in post.tags\" class=\"clickable inline\" ng-click=\"vmav.tagPosts(tags)\">{{tags}}<span class=\"coma\">,&nbsp;</span></li>\r\n                </li>\r\n              </ul>          \r\n          </td>\r\n          <td data-title=\"'date'\" sortable=\"'date'\" class=\"ng-table--date\">\r\n              <span ng-click=\"\">{{post.date | date:'MMM dd, y HH:mm'}}</span>\r\n          </td>\r\n          <!-- <td data-title=\"'signature'\" class=\"ng-table--signature\">\r\n              <span ng-click=\"\">{{post.signature}}</span>\r\n            \r\n          </td> -->\r\n          <td data-title=\"'Order'\" class=\"ng-table--order\">\r\n            <div class=\"input-group input-group-no-border\">\r\n             <input type=\"text\" ng-model=\"post.order\" class=\"form-control\" ng-change=\"vmav.changeOrder()\" ng-blur=\"vmav.outOrderFocus(post._id,post.order)\" ng-enter=\"vmav.outOrderFocus(post._id,post.order)\">\r\n            </div>\r\n          </td>\r\n          <td data-title=\"'transcoding status'\" class=\"ng-table--transcode text-center\">\r\n            <img src=\"images/pending-animation.svg\" alt=\"\" title = \"In progress...\" ng-if=\"post.transcoding_status == 0\">\r\n            <img src=\"images/check.svg\" alt=\"\" title = \"Success\" ng-if=\"post.transcoding_status == 1\">\r\n            <img src=\"images/cancel.svg\" alt=\"\" title = \"Failed\" ng-if=\"post.transcoding_status == -1\">\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <div class=\"grid-wrapper\" ng-show=\"vmav.showGrid\">\r\n        <ul class=\"grid\">\r\n          <li ng-repeat=\"media in vmav.data_grid\">\r\n            <div class=\"img-wrapp clickable\" ng-click=\"vmav.editVideo(media._id)\" :ng-style=\"{'background-image':'url('+ media.imageThumb +')'}\">\r\n              <!-- <img ng-src=\"{{media.imageThumb}}\" alt=\"\"> -->\r\n            </div>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"empty-table\" ng-show=\"emptyTable\">\r\n        <p>No result. Try again.</p>\r\n      </div>\r\n    </div> \r\n  </div>\r\n  </div>\r\n</section>\r\n<search-comments ng-if=\"vmav.serchCommentsModalShow\" obj=\"vmav\"></search-comments>\r\n\r\n\r\n\r\n\r\n"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"widget edit-media video_edit\">\r\n  <h1 class=\"page-title\">Edit <span class=\"fw-semi-bold\">Video</span>&nbsp;<a ng-click=\"$root.closeEditVideo()\" class=\"clickable-danger close-edit fw-semi-bold\" ng-escape=\"$root.closeEditVideo\" parametar=\"page\">&times;</a></h1>\r\n    \r\n  <div class=\"form-group\" >\r\n    <label for=\"\">Video title</label> \r\n    <div class=\"character-count-wrapper\">\r\n      <textarea type=\"text\" class=\"form-control input-lg textarea-lg\" placeholder=\"Enter title here\" ng-model=\"editMediaCurrent.title\" ng-class=\"{'error-border':titleRequired || titleExceed}\" character-count=\"\" limit-character=\"100\" exceed-name=\"title\"></textarea>\r\n    </div>\r\n    <div class=\"required-error animate-show\" ng-show=\"titleRequired\">Title required</div>\r\n  </div>\r\n  <p ng-cloak class=\"permalink\">Permalink: \r\n    <span class=\"fw-semi-bold\">{{config.baseHrefVideo}}/{{substringUri}}</span>\r\n    <span class=\"edit-slug fw-semi-bold\" ng-class=\"{'show-edit':!editSlugShow, 'hidden-edit':editSlugShow}\" ng-click=\"editSlugShow=true\">{{postSlug}}</span>\r\n    <input class = \"form-control\" ng-class=\"{'show-edit':editSlugShow, 'hidden-edit':!editSlugShow}\" type=\"text\" ng-model=\"postSlug\" ng-style=\"{'width':postSlug.length*8 + 'px','min-width':'100px' ,'max-width':'100%'}\">\r\n    <a ng-click=\"editSlug(postSlug)\" ng-class=\"{'show-edit':!editSlugShow, 'hidden-edit':editSlugShow}\" class=\"btn btn-primary\">Edit</a>\r\n    <!-- <a ng-class=\"{'show-edit':!editSlugShow, 'hidden-edit':editSlugShow}\" class=\"btn btn-info\" ng-click=\"previewPost()\" target=\"_blank\" ng-show=\"editMediaCurrent.status=='publish'\">View Post</a> -->\r\n    <!-- <a ng-class=\"{'show-edit':!editSlugShow, 'hidden-edit':editSlugShow}\" class=\"btn btn-info\" ng-click=\"previewPost()\" target=\"_blank\" ng-show=\"editMediaCurrent.status!='publish' && editMediaCurrent.preview\">Preview Post</a> -->\r\n    <a ng-click=\"updateSlug()\" ng-class=\"{'show-edit':editSlugShow, 'hidden-edit':!editSlugShow}\" class=\"btn btn-primary\">Ok</a><a ng-click=\"cancelSlug()\" ng-class=\"{'show-edit':editSlugShow, 'hidden-edit':!editSlugShow}\" class=\"btn btn-danger\">Cancel</a>\r\n  </p>\r\n  <div class=\"form-group\">\r\n    <label>Subtitle</label> \r\n    <textarea ng-model=\"editMediaCurrent.subtitle\" class=\"form-control textarea-lg\"></textarea>\r\n  </div>\r\n  <div class=\"single-post--columns-wraper\">\r\n    <div class=\"single-post--left-col\">\r\n      <div class=\"form-group\">\r\n        <div class=\"video-wrapper-outer\" ng-class=\"{'portrait':editMediaCurrent.orientation=='portrait'}\">\r\n          <div class=\"video-wrapper\" ng-if = \"videoGet\">\r\n            <div ng-show=\"videoLoaded\">\r\n              <video\r\n                  id=\"my-player\"\r\n                  class=\"video-js\"\r\n                  controls\r\n                  preload=\"auto\"\r\n                  poster=\"\">\r\n                <p class=\"vjs-no-js\">\r\n                  To view this video please enable JavaScript, and consider upgrading to a\r\n                  web browser that\r\n                  <a href=\"http://videojs.com/html5-video-support/\" target=\"_blank\">\r\n                    supports HTML5 video\r\n                  </a>\r\n                </p>\r\n              </video>\r\n              <div class=\"duration\" ng-if=\"editMediaCurrent.duration && durationFlag\">{{editMediaCurrent.formated_duration}}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"video-loader-wrapper\" ng-if = \"!videoLoaded\">\r\n            <img src=\"images/pending-animation.svg\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group upload_video overflow-hidden\" ng-if=\"videoGet\">\r\n        <label>Choose thumbnail</label>\r\n        <ul class=\"grid-wrapper\" ng-cloak>\r\n          <li ng-repeat=\"thumb in thumbs\" ng-class=\"{'uploadedThumb': uploadedThumb, 'portrait':editMediaCurrent.orientation=='portrait'}\">\r\n            <div class=\"img-wrapp clickable\" ng-class=\"{'active': $index==selectedImage}\" ng-click=\"chooseImage($index)\">\r\n              <img ng-src=\"{{thumb}}\" alt=\"\">\r\n            </div>\r\n          </li>\r\n          <li ng-class=\"{'uploadedThumb': uploadedThumb, 'portrait':editMediaCurrent.orientation=='portrait'}\">\r\n            <div class=\"img-wrapp\">\r\n              <form  class=\"dropzone\" options=\"dzOptionsThumb\" callbacks=\"dzCallbacksThumb\" methods=\"dzMethodsThumb\" ng-dropzone ng-cloak></form>\r\n            </div>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <!-- <div class=\"form-group\">\r\n        <a href=\"\" class=\"btn btn-default\">Edit Image</a>\r\n      </div> -->\r\n      <div class=\"form-group\">\r\n        <label>Video safe</label>\r\n        <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"safety in addSafety\">\r\n          <input type=\"checkbox\" name=\"safety\"  ng-model=\"checkedItems[safety._id]\" id=\"{{safety._id}}\" ng-click=\"updateSafety(safety._id, checkedItems[safety._id])\" >\r\n          <label for=\"{{safety._id}}\" >{{safety.label}}</label>\r\n        </div>\r\n        <div class=\"required-error animate-show\" ng-show=\"videoSafeRequired\">Video safety is required</div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Video allowance</label>\r\n        <div class=\"form-group checkbox checkbox-primary\" ng-repeat=\"allow in geoAllowance\">\r\n            <input type=\"checkbox\" ng-model=\"allowCheckedItems[allow._id]\"  id=\"{{allow._id}}\" ng-click=\"updateAllowance(allow._id)\" >\r\n            <label for=\"{{allow._id}}\">{{allow.label}}</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Signature</label> \r\n        <textarea ng-model=\"editMediaCurrent.signature\" class=\"form-control\"></textarea>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Moderator's guide</label>\r\n        <textarea class=\"form-control textarea-md\" placeholder=\"Enter moderator's guide here\" ng-model=\"editMediaCurrent.moderator_guide\"></textarea>\r\n      </div>\r\n      <section class=\"single-post--widget widget widget-approvals\" ng-if=\"editMediaCurrent\">\r\n        <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Approvals</h5>\r\n        </header>\r\n        <div class=\"widget-body\">\r\n          <add-approval-dir parent=\"editMediaCurrent\" type=\"'video'\"></add-approval-dir>\r\n        </div>\r\n      </section> \r\n    </div>\r\n    <div class=\"single-post--right-col\">\r\n      <section class=\"single-post--widget widget publish\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Publish</h5>\r\n        </header>\r\n        <div class=\"widget-body\">\r\n          <!-- <a ng-click=\"previewPost('preview')\" target=\"_blank\" class=\"btn btn-default preview\" ng-if=\"editMediaCurrent.preview\">Preview Changes</a> -->\r\n          <a ng-click = \"updateorSavePost()\" ng-show=\"editMediaCurrent.status == 'pending' || editMediaCurrent.status == 'draft'\" class=\"btn btn-default\">Save</a>\r\n          <ul>\r\n            <li><i class=\"fa fa-key\" aria-hidden=\"true\"></i>&nbsp;Status: <span class=\"fw-semi-bold status\">{{editMediaCurrent.status}}</span> <span class=\"clickable\" ng-click=\"editPostStatus()\">Edit</span>\r\n              <div class=\"editable\" ng-if=\"editPostStatusShow\">\r\n                <select ng-model=\"selectedPostStatus.value\" class=\"form-control\">\r\n                  <option value=\"publish\" ng-show=\"editPublish\">Published</option>\r\n                  <option value=\"schedule\" ng-show=\"setScheduledPost\">Scheduled</option>\r\n                  <option value=\"pending\">Pending Review</option>\r\n                  <option value=\"draft\">Draft</option>      \r\n                </select>\r\n                <a ng-click=\"changePostStatus()\"class=\"btn btn-primary\">Ok</a>\r\n                <a ng-click=\"cancelEditPostStatus()\" class=\"btn btn-danger\">Cancel</a>\r\n              </div>\r\n            </li>\r\n            <li><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\r\n            <span ng-if=\"editPublish && !scheduledPost\"><span>&nbsp;Published on:</span> <span class=\"fw-semi-bold\">{{editMediaCurrent.date}}</span></span>\r\n            <span ng-if=\"scheduledPost\"><span>&nbsp;Schedule for:</span> <span class=\"fw-semi-bold\">{{editMediaCurrent.date}}</span></span>\r\n            <span ng-if=\"!editPublish && !scheduledPost && !pastPost\" ng-cloak><span>&nbsp;Publish</span> <span class=\"fw-semi-bold\">immediately</span></span>\r\n            <span ng-if=\"!editPublish && !scheduledPost && pastPost\" ng-cloak><span>&nbsp;Publish on</span> <span class=\"fw-semi-bold\"><span class=\"fw-semi-bold\">{{editMediaCurrent.date}}</span></span></span>\r\n            <span class=\"clickable\" ng-click=\"editPostTime()\">Edit</span>\r\n            <div class=\"date-edit\" ng-show=\"editPostDateShow\">\r\n              <select ng-model=\"selectedPostMont.value\" class=\"form-control\">\r\n                <option value=\"1\">1-Jan</option>\r\n                <option value=\"2\">2-Feb</option>\r\n                <option value=\"3\">3-Mar</option>\r\n                <option value=\"4\">4-Apr</option>\r\n                <option value=\"5\">5-May</option>\r\n                <option value=\"6\">6-Jun</option>\r\n                <option value=\"7\">7-Jul</option>\r\n                <option value=\"8\">8-Aug</option>\r\n                <option value=\"9\">9-Sep</option>\r\n                <option value=\"10\">10-Oct</option>\r\n                <option value=\"11\">11-Nov</option>\r\n                <option value=\"12\">12-Dec</option>      \r\n              </select>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"postDay\">\r\n              <span>,</span>\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"postYear\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"postHours\">\r\n              <input type=\"text\" class=\"form-control\" ng-model=\"postMinutes\">\r\n              <a ng-click=\"setPublishedDate()\"class=\"btn btn-primary\">Ok</a>\r\n              <a ng-click=\"cancelEditPostDate()\" class=\"btn btn-danger\">Cancel</a>\r\n            </div>\r\n            </li>\r\n            <li>File URL: <div>\r\n              <textarea type=\"text\" ng-model=\"editMediaCurrent.video_file\" class=\"readonly form-control full-width url-field\" readonly></textarea>\r\n            </div></li>\r\n            <li ng-if=\"editMediaCurrent.filename\">\r\n              Filename:<span class=\"fw-semi-bold\"> {{editMediaCurrent.filename}}</span>\r\n            </li>\r\n            <li>Transcoding status:&nbsp;\r\n             <img src=\"images/pending-animation.svg\" alt=\"\" title = \"In progress...\" ng-if=\"editMediaCurrent.transcoding_status == 0\">\r\n            <img src=\"images/check.svg\" alt=\"\" title = \"Success\" ng-if=\"editMediaCurrent.transcoding_status==1\">\r\n            <img src=\"images/cancel.svg\" alt=\"\" title = \"Failed\" ng-if=\"editMediaCurrent.transcoding_status == -1\"> \r\n            <!-- <span class=\"fw-semi-bold\" ng-class=\"{'success':editMediaCurrent.transcoding_status ==1,'danger':editMediaCurrent.transcoding_status ==-1}\">{{transcodingText}}</span> -->\r\n            </li>\r\n          </ul>\r\n          <div class=\"form-group\" ng-if=\"editMediaCurrent.status=='publish'\">\r\n            <div class=\"clickable clickable-success\" ng-click=\"addToOther({'param1':'focus'},{'document_id':editMediaCurrent._id,'type':'video','title':editMediaCurrent.title})\">Add to Focus</div>\r\n            <div class=\"clickable clickable-success\" ng-click=\"addToOther({'param1':'pushnotifications'},{'document_id':editMediaCurrent._id,'type':'video'})\">Add to Push Notifications</div>\r\n          </div>\r\n        </div>\r\n        <footer class=\"bg-body-light bt\"><a ng-click=\"trashPost()\" class=\"clickable-danger\">Move to Trash</a>\r\n          <div ng-show=\"editPublish && !scheduledPost\"  class=\"pull-right\">  \r\n            <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"updateorSavePost()\">Update</button>\r\n          </div>\r\n          <div ng-show=\"!editPublish && !scheduledPost\" class=\"pull-right\">\r\n            <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"publishPost()\">Publish</button>\r\n          </div>\r\n          <div ng-show=\"scheduledPost\" class=\"pull-right\">\r\n            <button type=\"submit\" class=\"btn btn-primary\"  ng-click=\"publishPost()\">Schedule</button>\r\n          </div>\r\n        </footer>\r\n      </section>\r\n      <section class=\"single-post--widget widget categories\" ng-class=\"{'error-border':categoryRequired}\">\r\n          <header class=\"bb\">\r\n            <h5 class=\"fw-semi-bold\">Categories</h5>\r\n          </header>\r\n          <div class=\"widget-body\">\r\n          <div class=\"clearfix\">\r\n            <ul class=\"nav nav-tabs pull-left\"> <!-- remove pull-left to get a cool effect too -->\r\n              <li class=\"active\"><a>All Categories</a></li>\r\n            </ul>\r\n            </div>\r\n          <div class=\"tab-content\">\r\n              <div class=\"tab-pane active clearfix categories-tree\">\r\n                <ul id=\"categoryscroll\">\r\n                  <li ng-repeat=\"categoryInput in categoriesTreeInput\"  class=\"level{{categoryInput.ancestors.length}}\" ng-style =\"{'padding-left':categoryInput.ancestors.length*15 + 'px'}\" ng-class=\"{'checkedEditPost': categorychecked.item[categoryInput._id]}\"> <div class=\"checkbox checkbox-primary\"><input type=\"checkbox\" ng-model=\"categorychecked.item[categoryInput._id]\" ng-click = \"updateSelection(categoryInput._id, categorychecked.item[categoryInput._id])\" id=\"{{categoryInput._id}}\"><label for=\"{{categoryInput._id}}\">{{categoryInput.name}}</label></div>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              </div>\r\n              <div class=\"required-error animate-show\" ng-show=\"categoryRequired\">Category is required</div>\r\n          </div>\r\n          <!-- <footer class=\"bg-body-light bt\"><a href=\"\" class=\"clickable\">+ Add New Category</a></footer> -->\r\n        </section>\r\n      <section class=\"single-post--widget widget tags\" ng-class=\"{'error-border':newTagRequired}\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Tags</h5>\r\n        </header>\r\n        <div class=\"widget-body categories\">\r\n          <div class=\"form-group search-wrapper\">\r\n            <label for=\"search-input\">Add tag</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"searchtagfocus\" auto-complete-dir type-dir=\"'video'\" datachangelabel=\"\" datachangeid = \"\" enter-tag= \"addNewTag()\" ng-class=\"{'error-border':newTagRequired}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addNewTag()\">Add</button></span></div>\r\n            <div class=\"required-error animate-show\" ng-show=\"newTagRequired\">Tag is required</div>\r\n            <div class=\"required-error animate-show\" ng-show=\"existTag\">Tag alredy exist</div>\r\n            <ul class=\"list-tags\">\r\n              <li ng-repeat=\"tag in editMediaCurrent.tags\"><span class=\"remove-from-list\" ng-click=\"removeFromTagsList($index)\">x</span>{{tag}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </section>\r\n      <section class=\"single-post--widget widget attributes\">\r\n        <header class=\"bb\">\r\n          <h5 class=\"fw-semi-bold\">Attributes</h5>\r\n        </header>\r\n        <div class=\"widget-body\">\r\n        <div class=\"input-group-no-border\"><label for=\"search-input\">Order</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"editMediaCurrent.order\"></div></div>\r\n       \r\n        </div>\r\n      </section>\r\n    </div>\r\n  </div>\r\n  <script type=\"text/ng-template\" id=\"template.html\">\r\n    <ul class=\"autocomplete-result\" ng-show=\"showDropdown\">\r\n        <li ng-show=\"!showResult\">No result.</li>\r\n        <li ng-repeat=\"tag in tagsTree\" ng-click=\"chooseSearchData(tag.name, tag._id)\" ng-show=\"showResult\" ng-class=\"{'active':tag.active}\">{{tag.name}} ({{tag._id}})</li>\r\n    </ul>\r\n  </script>\r\n</section>"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal--overlay video-modal\">\r\n  <div class=\"modal--media-dialog\">\r\n    <div class=\"modal--media-wrapper\">\r\n      <div class=\"modal--media-header\">\r\n       <h2 ng-if=\"!currentPostObj.insertVideoToEditorModal\">Add Video</h2>\r\n       <h2 ng-if=\"currentPostObj.insertVideoToEditorModal\">Insert Telegraf TV Video</h2>\r\n       <div ng-click=\"currentPostObj.cancelVideoModal()\" ng-escape=\"currentPostObj.cancelVideoModal()\" class=\"btn btn-danger\" parametar=\"modal\">Cancel</div>\r\n      </div>\r\n      <div class=\"modal--media-content set-image-modal\">\r\n      <div class=\"modal-video-wrapper\">\r\n        <div class=\"left-column\">\r\n          <div class=\"form-group search\"><div class=\"input-group\"><input type=\"search\" class=\"form-control full-width\" id=\"search-input\" ng-model=\"searchDataVideo\" ng-enter=\"search(searchDataVideo)\" ng-change=\"searchEmpty(searchDataVideo);\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"search(searchDataVideo);\">Search</button></span></div></div>\r\n          <select ng-model=\"selectedCategory.value\" ng-change=\"switchCategories(selectedCategory.value)\" class=\"form-control\">\r\n              <option value=\"all\">View all categories</option>\r\n              <option ng-repeat= \"category in categoriesTreeSelect\" value=\"{{category._id}}\" class=\"level{{category.ancestors.length}}\" ng-bind=\"category.name\"></option>\r\n            </select>\r\n            <a ng-click=\"resetAllFilters()\" class=\"btn btn-info vertical-top\">Clear all Filters</a>\r\n          <div class=\"grid-wrapper\">\r\n            <ul class=\"grid\" on-scroll-load on-scroll-loading=\"onScrollLoading\" scheduled=\"scheduled\" search-data = \"searchDataVideo\" type-search=\"\" selected-attachment=\"\" current-load = \"videoItems\" featured-img=\"\" page-number=\"pageNumber\" app-state = \"'videos'\" category=\"selectedCategory.value\" max-pages=\"maxPages\">\r\n              <li ng-repeat=\"video in videoItems\" >\r\n                <div class=\"img-wrapp clickable ribon-wrapper\" ng-click=\"chooseVideo($index, video)\" ng-class=\"{'active':$index==selectedVideo}\" :ng-style=\"{'background-image':'url('+ video.thumb +')'}\">\r\n                  <!-- <img ng-src=\"{{video.thumb}}\" alt=\"{{video.title}}\"> -->\r\n                  <div class=\"ribon ribon-success\" ng-if=\"video.tags.includes('pr')\" title=\"Public relations\"><div class=\"ribon-inner\"><p>PR</p></div></div>\r\n                  <div class=\"ribon ribon-primary\" ng-if=\"video.status=='schedule'\" title=\"Scheduled video\"><div class=\"ribon-inner\"><i class=\"fa fa-calendar\"></i><span ng-if=\"video.tags.includes('pr')\">PR</span><p>{{video.date | date:'dd.MM.y. HH:mm'}}</p></div></div>\r\n                </div>\r\n              </li>\r\n              <li ng-show=\"onScrollLoading\">\r\n                <div class=\"lazy-loading-on-scroll\">\r\n                  <div class=\"lazy-loading\">\r\n                    <div class=\"image-wrapper\">\r\n                      <img src=\"images/ajax-loader.svg\" alt=\"Loding\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n            <div class=\"empty-media\" ng-show=\"emptyTable\">\r\n              <p>No result. Try again.</p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"right-column\">\r\n          <div class=\"video-wrapper-outer\">\r\n            <div class=\"video-wrapper\" ng-if = \"videoGet && videoItems.length>0\">\r\n              <div ng-show=\"videoLoaded \">\r\n                <video\r\n                    id=\"my-player-directive\"\r\n                    class=\"video-js\"\r\n                    controls\r\n                    preload=\"auto\"\r\n                    poster=\"\">\r\n                  <p class=\"vjs-no-js\">\r\n                    To view this video please enable JavaScript, and consider upgrading to a\r\n                    web browser that\r\n                    <a href=\"http://videojs.com/html5-video-support/\" target=\"_blank\">\r\n                      supports HTML5 video\r\n                    </a>\r\n                  </p>\r\n                </video>\r\n                <div class=\"duration\" ng-if=\"selectedVideoObj.duration && durationFlag\">{{selectedVideoObj.formated_duration}}</div>\r\n              </div>\r\n            </div>\r\n            <div class=\"video-loader-wrapper\" ng-if = \"!videoLoaded && videoItems.length>0\">\r\n              <img src=\"images/pending-animation.svg\">\r\n            </div>\r\n          </div>\r\n          <div class=\"editing-details video-details\" ng-if=\"videoItems.length>0\">\r\n            <div class=\"form-group\">\r\n              <input type=\"text\" class=\"fw-semi-bold readonly form-control\" ng-model=\"selectedVideoObj.dateFormated\"> \r\n                <label>Uploaded on:</label>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <textarea type=\"text\"ng-model=\"selectedVideoObj.file_video\" class=\"readonly form-control\" readonly></textarea>\r\n              <label>URL</label>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <textarea type=\"text\" ng-model=\"selectedVideoObj.title\" class=\"form-control readonly\" readonly></textarea>\r\n              <label>Title</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"edit-actions video-actions\" ng-if=\"videoItems.length>0\" ng-show=\"currentPostObj.insertVideoToEditorModal\">\r\n            <div class=\"form-group checkbox checkbox-primary\">\r\n              <input type=\"checkbox\" ng-model=\"videoDetails.showVideoTitle\" id=\"show-video\">\r\n              <label for=\"show-video\">Show video title</label>\r\n            </div>\r\n            <div ng-class=\"{'slideInFadeDown animated' : videoDetails.showVideoTitle}\" class=\"overflow-hidden\" ng-show = \"videoDetails.showVideoTitle\">\r\n              <div class=\"form-group\">\r\n                <textarea type=\"text\" ng-model=\"videoDetails.customVideoTitle\" class=\"form-control\"></textarea>\r\n                <label>Title</label>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <select ng-model=\"videoDetails.videoTitlePosition.value\" class=\"form-control\">\r\n                  <option value=\"top\">Top</option>\r\n                  <option value=\"bottom\">Bottom</option>\r\n                </select>\r\n                <label>Position</label>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"action\">\r\n        <!-- <a class=\"btn btn-primary\" ng-click=\"setFeaturedVideo()\" ng-if=\"!currentPostObj.addCategory && !currentPostObj.insertVideoToEditorModal && !currentPostObj.setFeaturedVideoModal\">Set Featured video</a> -->\r\n        <a class=\"btn btn-primary\" ng-click=\"setFeaturedVideo()\" ng-if=\"currentPostObj.addCategory || currentPostObj.setFeaturedVideoModal\">Add Video</a>\r\n        <a class=\"btn btn-primary\" ng-click=\"insertVideoToEditor()\" ng-if=\"currentPostObj.insertVideoToEditorModal\">Insert Video</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports = SafeParseTuple
	
	function SafeParseTuple(obj, reviver) {
	    var json
	    var error = null
	
	    try {
	        json = JSON.parse(obj, reviver)
	    } catch (err) {
	        error = err
	    }
	
	    return [error, json]
	}


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(212)))

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	var map = {
	    // latin
	    'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
	    'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
	    'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
	    'Õ': 'O', 'Ö': 'O', 'Ő': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U',
	    'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH', 'ß': 'ss', 'à': 'a', 'á': 'a',
	    'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
	    'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
	    'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
	    'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
	    'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ẞ': 'SS',
	    // serbian latin
	    'š': 's', 'đ': 'dj', 'ž': 'z', 'č': 'c', 'ć': 'c',
	    // greek
	    'α': 'a', 'β': 'b', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'h', 'θ': '8',
	    'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': '3', 'ο': 'o', 'π': 'p',
	    'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'w',
	    'ά': 'a', 'έ': 'e', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ή': 'h', 'ώ': 'w', 'ς': 's',
	    'ϊ': 'i', 'ΰ': 'y', 'ϋ': 'y', 'ΐ': 'i',
	    'Α': 'A', 'Β': 'B', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Θ': '8',
	    'Ι': 'I', 'Κ': 'K', 'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': '3', 'Ο': 'O', 'Π': 'P',
	    'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y', 'Φ': 'F', 'Χ': 'X', 'Ψ': 'PS', 'Ω': 'W',
	    'Ά': 'A', 'Έ': 'E', 'Ί': 'I', 'Ό': 'O', 'Ύ': 'Y', 'Ή': 'H', 'Ώ': 'W', 'Ϊ': 'I',
	    'Ϋ': 'Y',
	    // turkish
	    'ş': 's', 'Ş': 'S', 'ı': 'i', 'İ': 'I', 'ç': 'c', 'Ç': 'C', 'ü': 'u', 'Ü': 'U',
	    'ö': 'o', 'Ö': 'O', 'ğ': 'g', 'Ğ': 'G',
	
	    // ukranian
	    'Є': 'Ye', 'І': 'I', 'Ї': 'Yi', 'Ґ': 'G', 'є': 'ye', 'і': 'i', 'ї': 'yi', 'ґ': 'g',
	    // czech
	    'č': 'c', 'ď': 'd', 'ě': 'e', 'ň': 'n', 'ř': 'r', 'š': 's', 'ť': 't', 'ů': 'u',
	    'ž': 'z', 'Č': 'C', 'Ď': 'D', 'Ě': 'E', 'Ň': 'N', 'Ř': 'R', 'Š': 'S', 'Ť': 'T',
	    'Ů': 'U', 'Ž': 'Z',
	    // polish
	    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z',
	    'ż': 'z', 'Ą': 'A', 'Ć': 'C', 'Ę': 'e', 'Ł': 'L', 'Ń': 'N', 'Ś': 'S',
	    'Ź': 'Z', 'Ż': 'Z',
	    // latvian
	    'ā': 'a', 'č': 'c', 'ē': 'e', 'ģ': 'g', 'ī': 'i', 'ķ': 'k', 'ļ': 'l', 'ņ': 'n',
	    'š': 's', 'ū': 'u', 'ž': 'z', 'Ā': 'A', 'Č': 'C', 'Ē': 'E', 'Ģ': 'G', 'Ī': 'i',
	    'Ķ': 'k', 'Ļ': 'L', 'Ņ': 'N', 'Š': 'S', 'Ū': 'u', 'Ž': 'Z',
	    // serbian cyrilic
	    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'ђ': 'dj', 'е': 'e', 'ж': 'z',
	    'з': 'z', 'и': 'i', 'ј': 'j', 'к': 'k', 'л': 'l', 'љ': 'lj', 'м': 'm', 'н': 'n',
	    'њ': 'nj', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'ћ': 'c', 'у': 'u',
	    'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'c', 'џ': 'dz', 'ш': 's',
	    // currency
	  /*'€': 'euro', '₢': 'cruzeiro', '₣': 'french franc', '£': 'pound',
	   '₤': 'lira', '₥': 'mill', '₦': 'naira', '₧': 'peseta', '₨': 'rupee',
	   '₩': 'won', '₪': 'new shequel', '₫': 'dong', '₭': 'kip', '₮': 'tugrik',
	   '₯': 'drachma', '₰': 'penny', '₱': 'peso', '₲': 'guarani', '₳': 'austral',
	   '₴': 'hryvnia', '₵': 'cedi', '¢': 'cent', '¥': 'yen', '元': 'yuan',
	   '円': 'yen', '﷼': 'rial', '₠': 'ecu', '¤': 'currency', '฿': 'baht',
	   '$': 'dollar',
	   // symbols
	   '©': '(c)', 'œ': 'oe', 'Œ': 'OE', '∑': 'sum', '®': '(r)', '†': '+',
	   '“': '"', '”': '"', '‘': "'", '’': "'", '∂': 'd', 'ƒ': 'f', '™': 'tm',
	   '℠': 'sm', '…': '...', '˚': 'o', 'º': 'o', 'ª': 'a', '•': '*',
	   '∆': 'delta', '∞': 'infinity', '♥': 'love', '&': 'and', '|': 'or',
	   '<': 'less', '>': 'greater'*/
	}
	
	exports = module.exports = function (string, replacement, dot) {
	    string = string.toLowerCase();
	
	    return string.split('').reduce(function (result, char) {
	        if (map[char]) {
	            char = map[char]
	        }
	        // allowed
	        //char = char.replace(/[^\w\s$\*_\+~\.\(\)'"!\-:@]/g, '')
	        if(typeof dot !== 'undefined') {
	            char = char.replace(/[^\w\s$\.\-]/g, '');
	        } else {
	            char = char.replace(/[^\w\s$\-]/g, '');
	        }
	
	        result += char
	        return result
	    }, '')
	    // trim leading/trailing spaces
	        .replace(/^\s+|\s+$/g, '')
	        // convert spaces
	        .replace(/[-\s]+/g, replacement || '-')
	        // remove trailing separator
	        .replace('#{replacement}$', '')
	}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(140)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(193);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(140)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./custom-tinymce.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./custom-tinymce.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	(function () {
	var anchor = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var isValidId = function (id) {
	      return /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id);
	    };
	    var getId = function (editor) {
	      var selectedNode = editor.selection.getNode();
	      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
	      return isAnchor ? selectedNode.id || selectedNode.name : '';
	    };
	    var insert = function (editor, id) {
	      var selectedNode = editor.selection.getNode();
	      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
	      if (isAnchor) {
	        selectedNode.removeAttribute('name');
	        selectedNode.id = id;
	        editor.undoManager.add();
	      } else {
	        editor.focus();
	        editor.selection.collapse(true);
	        editor.execCommand('mceInsertContent', false, editor.dom.createHTML('a', { id: id }));
	      }
	    };
	    var Anchor = {
	      isValidId: isValidId,
	      getId: getId,
	      insert: insert
	    };
	
	    var insertAnchor = function (editor, newId) {
	      if (!Anchor.isValidId(newId)) {
	        editor.windowManager.alert('Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.');
	        return true;
	      } else {
	        Anchor.insert(editor, newId);
	        return false;
	      }
	    };
	    var open = function (editor) {
	      var currentId = Anchor.getId(editor);
	      editor.windowManager.open({
	        title: 'Anchor',
	        body: {
	          type: 'textbox',
	          name: 'id',
	          size: 40,
	          label: 'Id',
	          value: currentId
	        },
	        onsubmit: function (e) {
	          var newId = e.data.id;
	          if (insertAnchor(editor, newId)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	    var Dialog = { open: open };
	
	    var register = function (editor) {
	      editor.addCommand('mceAnchor', function () {
	        Dialog.open(editor);
	      });
	    };
	    var Commands = { register: register };
	
	    var isAnchorNode = function (node) {
	      return !node.attr('href') && (node.attr('id') || node.attr('name')) && !node.firstChild;
	    };
	    var setContentEditable = function (state) {
	      return function (nodes) {
	        for (var i = 0; i < nodes.length; i++) {
	          if (isAnchorNode(nodes[i])) {
	            nodes[i].attr('contenteditable', state);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('PreInit', function () {
	        editor.parser.addNodeFilter('a', setContentEditable('false'));
	        editor.serializer.addNodeFilter('a', setContentEditable(null));
	      });
	    };
	    var FilterContent = { setup: setup };
	
	    var register$1 = function (editor) {
	      editor.addButton('anchor', {
	        icon: 'anchor',
	        tooltip: 'Anchor',
	        cmd: 'mceAnchor',
	        stateSelector: 'a:not([href])'
	      });
	      editor.addMenuItem('anchor', {
	        icon: 'anchor',
	        text: 'Anchor',
	        context: 'insert',
	        cmd: 'mceAnchor'
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('anchor', function (editor) {
	      FilterContent.setup(editor);
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	(function () {
	var autoresize = (function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var getAutoResizeMinHeight = function (editor) {
	      return parseInt(editor.getParam('autoresize_min_height', editor.getElement().offsetHeight), 10);
	    };
	    var getAutoResizeMaxHeight = function (editor) {
	      return parseInt(editor.getParam('autoresize_max_height', 0), 10);
	    };
	    var getAutoResizeOverflowPadding = function (editor) {
	      return editor.getParam('autoresize_overflow_padding', 1);
	    };
	    var getAutoResizeBottomMargin = function (editor) {
	      return editor.getParam('autoresize_bottom_margin', 50);
	    };
	    var shouldAutoResizeOnInit = function (editor) {
	      return editor.getParam('autoresize_on_init', true);
	    };
	    var Settings = {
	      getAutoResizeMinHeight: getAutoResizeMinHeight,
	      getAutoResizeMaxHeight: getAutoResizeMaxHeight,
	      getAutoResizeOverflowPadding: getAutoResizeOverflowPadding,
	      getAutoResizeBottomMargin: getAutoResizeBottomMargin,
	      shouldAutoResizeOnInit: shouldAutoResizeOnInit
	    };
	
	    var isFullscreen = function (editor) {
	      return editor.plugins.fullscreen && editor.plugins.fullscreen.isFullscreen();
	    };
	    var wait = function (editor, oldSize, times, interval, callback) {
	      global$2.setEditorTimeout(editor, function () {
	        resize(editor, oldSize);
	        if (times--) {
	          wait(editor, oldSize, times, interval, callback);
	        } else if (callback) {
	          callback();
	        }
	      }, interval);
	    };
	    var toggleScrolling = function (editor, state) {
	      var body = editor.getBody();
	      if (body) {
	        body.style.overflowY = state ? '' : 'hidden';
	        if (!state) {
	          body.scrollTop = 0;
	        }
	      }
	    };
	    var resize = function (editor, oldSize) {
	      var deltaSize, doc, body, resizeHeight, myHeight;
	      var marginTop, marginBottom, paddingTop, paddingBottom, borderTop, borderBottom;
	      var dom = editor.dom;
	      doc = editor.getDoc();
	      if (!doc) {
	        return;
	      }
	      if (isFullscreen(editor)) {
	        toggleScrolling(editor, true);
	        return;
	      }
	      body = doc.body;
	      resizeHeight = Settings.getAutoResizeMinHeight(editor);
	      marginTop = dom.getStyle(body, 'margin-top', true);
	      marginBottom = dom.getStyle(body, 'margin-bottom', true);
	      paddingTop = dom.getStyle(body, 'padding-top', true);
	      paddingBottom = dom.getStyle(body, 'padding-bottom', true);
	      borderTop = dom.getStyle(body, 'border-top-width', true);
	      borderBottom = dom.getStyle(body, 'border-bottom-width', true);
	      myHeight = body.offsetHeight + parseInt(marginTop, 10) + parseInt(marginBottom, 10) + parseInt(paddingTop, 10) + parseInt(paddingBottom, 10) + parseInt(borderTop, 10) + parseInt(borderBottom, 10);
	      if (isNaN(myHeight) || myHeight <= 0) {
	        myHeight = global$1.ie ? body.scrollHeight : global$1.webkit && body.clientHeight === 0 ? 0 : body.offsetHeight;
	      }
	      if (myHeight > Settings.getAutoResizeMinHeight(editor)) {
	        resizeHeight = myHeight;
	      }
	      var maxHeight = Settings.getAutoResizeMaxHeight(editor);
	      if (maxHeight && myHeight > maxHeight) {
	        resizeHeight = maxHeight;
	        toggleScrolling(editor, true);
	      } else {
	        toggleScrolling(editor, false);
	      }
	      if (resizeHeight !== oldSize.get()) {
	        deltaSize = resizeHeight - oldSize.get();
	        dom.setStyle(editor.iframeElement, 'height', resizeHeight + 'px');
	        oldSize.set(resizeHeight);
	        if (global$1.webkit && deltaSize < 0) {
	          resize(editor, oldSize);
	        }
	      }
	    };
	    var setup = function (editor, oldSize) {
	      editor.on('init', function () {
	        var overflowPadding, bottomMargin;
	        var dom = editor.dom;
	        overflowPadding = Settings.getAutoResizeOverflowPadding(editor);
	        bottomMargin = Settings.getAutoResizeBottomMargin(editor);
	        if (overflowPadding !== false) {
	          dom.setStyles(editor.getBody(), {
	            paddingLeft: overflowPadding,
	            paddingRight: overflowPadding
	          });
	        }
	        if (bottomMargin !== false) {
	          dom.setStyles(editor.getBody(), { paddingBottom: bottomMargin });
	        }
	      });
	      editor.on('nodechange setcontent keyup FullscreenStateChanged', function (e) {
	        resize(editor, oldSize);
	      });
	      if (Settings.shouldAutoResizeOnInit(editor)) {
	        editor.on('init', function () {
	          wait(editor, oldSize, 20, 100, function () {
	            wait(editor, oldSize, 5, 1000);
	          });
	        });
	      }
	    };
	    var Resize = {
	      setup: setup,
	      resize: resize
	    };
	
	    var register = function (editor, oldSize) {
	      editor.addCommand('mceAutoResize', function () {
	        Resize.resize(editor, oldSize);
	      });
	    };
	    var Commands = { register: register };
	
	    global.add('autoresize', function (editor) {
	      if (!editor.inline) {
	        var oldSize = Cell(0);
	        Commands.register(editor, oldSize);
	        Resize.setup(editor, oldSize);
	      }
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	(function () {
	var fullscreen = (function (domGlobals) {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var get = function (fullscreenState) {
	      return {
	        isFullscreen: function () {
	          return fullscreenState.get() !== null;
	        }
	      };
	    };
	    var Api = { get: get };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var fireFullscreenStateChanged = function (editor, state) {
	      editor.fire('FullscreenStateChanged', { state: state });
	    };
	    var Events = { fireFullscreenStateChanged: fireFullscreenStateChanged };
	
	    var DOM = global$1.DOM;
	    var getWindowSize = function () {
	      var w;
	      var h;
	      var win = domGlobals.window;
	      var doc = domGlobals.document;
	      var body = doc.body;
	      if (body.offsetWidth) {
	        w = body.offsetWidth;
	        h = body.offsetHeight;
	      }
	      if (win.innerWidth && win.innerHeight) {
	        w = win.innerWidth;
	        h = win.innerHeight;
	      }
	      return {
	        w: w,
	        h: h
	      };
	    };
	    var getScrollPos = function () {
	      var vp = DOM.getViewPort();
	      return {
	        x: vp.x,
	        y: vp.y
	      };
	    };
	    var setScrollPos = function (pos) {
	      domGlobals.window.scrollTo(pos.x, pos.y);
	    };
	    var toggleFullscreen = function (editor, fullscreenState) {
	      var body = domGlobals.document.body;
	      var documentElement = domGlobals.document.documentElement;
	      var editorContainerStyle;
	      var editorContainer, iframe, iframeStyle;
	      var fullscreenInfo = fullscreenState.get();
	      var resize = function () {
	        DOM.setStyle(iframe, 'height', getWindowSize().h - (editorContainer.clientHeight - iframe.clientHeight));
	      };
	      var removeResize = function () {
	        DOM.unbind(domGlobals.window, 'resize', resize);
	      };
	      editorContainer = editor.getContainer();
	      editorContainerStyle = editorContainer.style;
	      iframe = editor.getContentAreaContainer().firstChild;
	      iframeStyle = iframe.style;
	      if (!fullscreenInfo) {
	        var newFullScreenInfo = {
	          scrollPos: getScrollPos(),
	          containerWidth: editorContainerStyle.width,
	          containerHeight: editorContainerStyle.height,
	          iframeWidth: iframeStyle.width,
	          iframeHeight: iframeStyle.height,
	          resizeHandler: resize,
	          removeHandler: removeResize
	        };
	        iframeStyle.width = iframeStyle.height = '100%';
	        editorContainerStyle.width = editorContainerStyle.height = '';
	        DOM.addClass(body, 'mce-fullscreen');
	        DOM.addClass(documentElement, 'mce-fullscreen');
	        DOM.addClass(editorContainer, 'mce-fullscreen');
	        DOM.bind(domGlobals.window, 'resize', resize);
	        editor.on('remove', removeResize);
	        resize();
	        fullscreenState.set(newFullScreenInfo);
	        Events.fireFullscreenStateChanged(editor, true);
	      } else {
	        iframeStyle.width = fullscreenInfo.iframeWidth;
	        iframeStyle.height = fullscreenInfo.iframeHeight;
	        if (fullscreenInfo.containerWidth) {
	          editorContainerStyle.width = fullscreenInfo.containerWidth;
	        }
	        if (fullscreenInfo.containerHeight) {
	          editorContainerStyle.height = fullscreenInfo.containerHeight;
	        }
	        DOM.removeClass(body, 'mce-fullscreen');
	        DOM.removeClass(documentElement, 'mce-fullscreen');
	        DOM.removeClass(editorContainer, 'mce-fullscreen');
	        setScrollPos(fullscreenInfo.scrollPos);
	        DOM.unbind(domGlobals.window, 'resize', fullscreenInfo.resizeHandler);
	        editor.off('remove', fullscreenInfo.removeHandler);
	        fullscreenState.set(null);
	        Events.fireFullscreenStateChanged(editor, false);
	      }
	    };
	    var Actions = { toggleFullscreen: toggleFullscreen };
	
	    var register = function (editor, fullscreenState) {
	      editor.addCommand('mceFullScreen', function () {
	        Actions.toggleFullscreen(editor, fullscreenState);
	      });
	    };
	    var Commands = { register: register };
	
	    var postRender = function (editor) {
	      return function (e) {
	        var ctrl = e.control;
	        editor.on('FullscreenStateChanged', function (e) {
	          ctrl.active(e.state);
	        });
	      };
	    };
	    var register$1 = function (editor) {
	      editor.addMenuItem('fullscreen', {
	        text: 'Fullscreen',
	        shortcut: 'Ctrl+Shift+F',
	        selectable: true,
	        cmd: 'mceFullScreen',
	        onPostRender: postRender(editor),
	        context: 'view'
	      });
	      editor.addButton('fullscreen', {
	        active: false,
	        tooltip: 'Fullscreen',
	        cmd: 'mceFullScreen',
	        onPostRender: postRender(editor)
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('fullscreen', function (editor) {
	      var fullscreenState = Cell(null);
	      if (editor.settings.inline) {
	        return Api.get(fullscreenState);
	      }
	      Commands.register(editor, fullscreenState);
	      Buttons.register(editor);
	      editor.addShortcut('Ctrl+Shift+F', '', 'mceFullScreen');
	      return Api.get(fullscreenState);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	(function () {
	var hr = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var register = function (editor) {
	      editor.addCommand('InsertHorizontalRule', function () {
	        editor.execCommand('mceInsertContent', false, '<hr />');
	      });
	    };
	    var Commands = { register: register };
	
	    var register$1 = function (editor) {
	      editor.addButton('hr', {
	        icon: 'hr',
	        tooltip: 'Horizontal line',
	        cmd: 'InsertHorizontalRule'
	      });
	      editor.addMenuItem('hr', {
	        icon: 'hr',
	        text: 'Horizontal line',
	        cmd: 'InsertHorizontalRule',
	        context: 'insert'
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('hr', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	(function () {
	var image = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasDimensions = function (editor) {
	      return editor.settings.image_dimensions === false ? false : true;
	    };
	    var hasAdvTab = function (editor) {
	      return editor.settings.image_advtab === true ? true : false;
	    };
	    var getPrependUrl = function (editor) {
	      return editor.getParam('image_prepend_url', '');
	    };
	    var getClassList = function (editor) {
	      return editor.getParam('image_class_list');
	    };
	    var hasDescription = function (editor) {
	      return editor.settings.image_description === false ? false : true;
	    };
	    var hasImageTitle = function (editor) {
	      return editor.settings.image_title === true ? true : false;
	    };
	    var hasImageCaption = function (editor) {
	      return editor.settings.image_caption === true ? true : false;
	    };
	    var getImageList = function (editor) {
	      return editor.getParam('image_list', false);
	    };
	    var hasUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', false);
	    };
	    var hasUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', false);
	    };
	    var getUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url');
	    };
	    var getUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler');
	    };
	    var getUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path');
	    };
	    var getUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials');
	    };
	    var Settings = {
	      hasDimensions: hasDimensions,
	      hasAdvTab: hasAdvTab,
	      getPrependUrl: getPrependUrl,
	      getClassList: getClassList,
	      hasDescription: hasDescription,
	      hasImageTitle: hasImageTitle,
	      hasImageCaption: hasImageCaption,
	      getImageList: getImageList,
	      hasUploadUrl: hasUploadUrl,
	      hasUploadHandler: hasUploadHandler,
	      getUploadUrl: getUploadUrl,
	      getUploadHandler: getUploadHandler,
	      getUploadBasePath: getUploadBasePath,
	      getUploadCredentials: getUploadCredentials
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    function FileReader () {
	      var f = Global$1.getOrDie('FileReader');
	      return new f();
	    }
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var parseIntAndGetMax = function (val1, val2) {
	      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
	    };
	    var getImageSize = function (url, callback) {
	      var img = domGlobals.document.createElement('img');
	      function done(width, height) {
	        if (img.parentNode) {
	          img.parentNode.removeChild(img);
	        }
	        callback({
	          width: width,
	          height: height
	        });
	      }
	      img.onload = function () {
	        var width = parseIntAndGetMax(img.width, img.clientWidth);
	        var height = parseIntAndGetMax(img.height, img.clientHeight);
	        done(width, height);
	      };
	      img.onerror = function () {
	        done(0, 0);
	      };
	      var style = img.style;
	      style.visibility = 'hidden';
	      style.position = 'fixed';
	      style.bottom = style.left = '0px';
	      style.width = style.height = 'auto';
	      domGlobals.document.body.appendChild(img);
	      img.src = url;
	    };
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      function appendItems(values, output) {
	        output = output || [];
	        global$2.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	            itemCallback(menuItem);
	          }
	          output.push(menuItem);
	        });
	        return output;
	      }
	      return appendItems(inputList, startItems || []);
	    };
	    var removePixelSuffix = function (value) {
	      if (value) {
	        value = value.replace(/px$/, '');
	      }
	      return value;
	    };
	    var addPixelSuffix = function (value) {
	      if (value.length > 0 && /^[0-9]+$/.test(value)) {
	        value += 'px';
	      }
	      return value;
	    };
	    var mergeMargins = function (css) {
	      if (css.margin) {
	        var splitMargin = css.margin.split(' ');
	        switch (splitMargin.length) {
	        case 1:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[0];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[0];
	          break;
	        case 2:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 3:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 4:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[3];
	        }
	        delete css.margin;
	      }
	      return css;
	    };
	    var createImageList = function (editor, callback) {
	      var imageList = Settings.getImageList(editor);
	      if (typeof imageList === 'string') {
	        global$3.send({
	          url: imageList,
	          success: function (text) {
	            callback(JSON.parse(text));
	          }
	        });
	      } else if (typeof imageList === 'function') {
	        imageList(callback);
	      } else {
	        callback(imageList);
	      }
	    };
	    var waitLoadImage = function (editor, data, imgElm) {
	      function selectImage() {
	        imgElm.onload = imgElm.onerror = null;
	        if (editor.selection) {
	          editor.selection.select(imgElm);
	          editor.nodeChanged();
	        }
	      }
	      imgElm.onload = function () {
	        if (!data.width && !data.height && Settings.hasDimensions(editor)) {
	          editor.dom.setAttribs(imgElm, {
	            width: imgElm.clientWidth,
	            height: imgElm.clientHeight
	          });
	        }
	        selectImage();
	      };
	      imgElm.onerror = selectImage;
	    };
	    var blobToDataUri = function (blob) {
	      return new global$1(function (resolve, reject) {
	        var reader = FileReader();
	        reader.onload = function () {
	          resolve(reader.result);
	        };
	        reader.onerror = function () {
	          reject(reader.error.message);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var Utils = {
	      getImageSize: getImageSize,
	      buildListItems: buildListItems,
	      removePixelSuffix: removePixelSuffix,
	      addPixelSuffix: addPixelSuffix,
	      mergeMargins: mergeMargins,
	      createImageList: createImageList,
	      waitLoadImage: waitLoadImage,
	      blobToDataUri: blobToDataUri
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var shallow = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow);
	
	    var DOM = global$4.DOM;
	    var getHspace = function (image) {
	      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
	        return Utils.removePixelSuffix(image.style.marginLeft);
	      } else {
	        return '';
	      }
	    };
	    var getVspace = function (image) {
	      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
	        return Utils.removePixelSuffix(image.style.marginTop);
	      } else {
	        return '';
	      }
	    };
	    var getBorder = function (image) {
	      if (image.style.borderWidth) {
	        return Utils.removePixelSuffix(image.style.borderWidth);
	      } else {
	        return '';
	      }
	    };
	    var getAttrib = function (image, name) {
	      if (image.hasAttribute(name)) {
	        return image.getAttribute(name);
	      } else {
	        return '';
	      }
	    };
	    var getStyle = function (image, name) {
	      return image.style[name] ? image.style[name] : '';
	    };
	    var hasCaption = function (image) {
	      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
	    };
	    var setAttrib = function (image, name, value) {
	      image.setAttribute(name, value);
	    };
	    var wrapInFigure = function (image) {
	      var figureElm = DOM.create('figure', { class: 'image' });
	      DOM.insertAfter(figureElm, image);
	      figureElm.appendChild(image);
	      figureElm.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
	      figureElm.contentEditable = 'false';
	    };
	    var removeFigure = function (image) {
	      var figureElm = image.parentNode;
	      DOM.insertAfter(image, figureElm);
	      DOM.remove(figureElm);
	    };
	    var toggleCaption = function (image) {
	      if (hasCaption(image)) {
	        removeFigure(image);
	      } else {
	        wrapInFigure(image);
	      }
	    };
	    var normalizeStyle = function (image, normalizeCss) {
	      var attrValue = image.getAttribute('style');
	      var value = normalizeCss(attrValue !== null ? attrValue : '');
	      if (value.length > 0) {
	        image.setAttribute('style', value);
	        image.setAttribute('data-mce-style', value);
	      } else {
	        image.removeAttribute('style');
	      }
	    };
	    var setSize = function (name, normalizeCss) {
	      return function (image, name, value) {
	        if (image.style[name]) {
	          image.style[name] = Utils.addPixelSuffix(value);
	          normalizeStyle(image, normalizeCss);
	        } else {
	          setAttrib(image, name, value);
	        }
	      };
	    };
	    var getSize = function (image, name) {
	      if (image.style[name]) {
	        return Utils.removePixelSuffix(image.style[name]);
	      } else {
	        return getAttrib(image, name);
	      }
	    };
	    var setHspace = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.marginLeft = pxValue;
	      image.style.marginRight = pxValue;
	    };
	    var setVspace = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.marginTop = pxValue;
	      image.style.marginBottom = pxValue;
	    };
	    var setBorder = function (image, value) {
	      var pxValue = Utils.addPixelSuffix(value);
	      image.style.borderWidth = pxValue;
	    };
	    var setBorderStyle = function (image, value) {
	      image.style.borderStyle = value;
	    };
	    var getBorderStyle = function (image) {
	      return getStyle(image, 'borderStyle');
	    };
	    var isFigure = function (elm) {
	      return elm.nodeName === 'FIGURE';
	    };
	    var defaultData = function () {
	      return {
	        src: '',
	        alt: '',
	        title: '',
	        width: '',
	        height: '',
	        class: '',
	        style: '',
	        caption: false,
	        hspace: '',
	        vspace: '',
	        border: '',
	        borderStyle: ''
	      };
	    };
	    var getStyleValue = function (normalizeCss, data) {
	      var image = domGlobals.document.createElement('img');
	      setAttrib(image, 'style', data.style);
	      if (getHspace(image) || data.hspace !== '') {
	        setHspace(image, data.hspace);
	      }
	      if (getVspace(image) || data.vspace !== '') {
	        setVspace(image, data.vspace);
	      }
	      if (getBorder(image) || data.border !== '') {
	        setBorder(image, data.border);
	      }
	      if (getBorderStyle(image) || data.borderStyle !== '') {
	        setBorderStyle(image, data.borderStyle);
	      }
	      return normalizeCss(image.getAttribute('style'));
	    };
	    var create = function (normalizeCss, data) {
	      var image = domGlobals.document.createElement('img');
	      write(normalizeCss, merge(data, { caption: false }), image);
	      setAttrib(image, 'alt', data.alt);
	      if (data.caption) {
	        var figure = DOM.create('figure', { class: 'image' });
	        figure.appendChild(image);
	        figure.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
	        figure.contentEditable = 'false';
	        return figure;
	      } else {
	        return image;
	      }
	    };
	    var read = function (normalizeCss, image) {
	      return {
	        src: getAttrib(image, 'src'),
	        alt: getAttrib(image, 'alt'),
	        title: getAttrib(image, 'title'),
	        width: getSize(image, 'width'),
	        height: getSize(image, 'height'),
	        class: getAttrib(image, 'class'),
	        style: normalizeCss(getAttrib(image, 'style')),
	        caption: hasCaption(image),
	        hspace: getHspace(image),
	        vspace: getVspace(image),
	        border: getBorder(image),
	        borderStyle: getStyle(image, 'borderStyle')
	      };
	    };
	    var updateProp = function (image, oldData, newData, name, set) {
	      if (newData[name] !== oldData[name]) {
	        set(image, name, newData[name]);
	      }
	    };
	    var normalized = function (set, normalizeCss) {
	      return function (image, name, value) {
	        set(image, value);
	        normalizeStyle(image, normalizeCss);
	      };
	    };
	    var write = function (normalizeCss, newData, image) {
	      var oldData = read(normalizeCss, image);
	      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
	        return toggleCaption(image);
	      });
	      updateProp(image, oldData, newData, 'src', setAttrib);
	      updateProp(image, oldData, newData, 'alt', setAttrib);
	      updateProp(image, oldData, newData, 'title', setAttrib);
	      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
	      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
	      updateProp(image, oldData, newData, 'class', setAttrib);
	      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
	        return setAttrib(image, 'style', value);
	      }, normalizeCss));
	      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
	      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
	      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
	      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
	    };
	
	    var normalizeCss = function (editor, cssText) {
	      var css = editor.dom.styles.parse(cssText);
	      var mergedCss = Utils.mergeMargins(css);
	      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
	      return editor.dom.styles.serialize(compressed);
	    };
	    var getSelectedImage = function (editor) {
	      var imgElm = editor.selection.getNode();
	      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
	      if (figureElm) {
	        return editor.dom.select('img', figureElm)[0];
	      }
	      if (imgElm && (imgElm.nodeName !== 'IMG' || imgElm.getAttribute('data-mce-object') || imgElm.getAttribute('data-mce-placeholder'))) {
	        return null;
	      }
	      return imgElm;
	    };
	    var splitTextBlock = function (editor, figure) {
	      var dom = editor.dom;
	      var textBlock = dom.getParent(figure.parentNode, function (node) {
	        return editor.schema.getTextBlockElements()[node.nodeName];
	      }, editor.getBody());
	      if (textBlock) {
	        return dom.split(textBlock, figure);
	      } else {
	        return figure;
	      }
	    };
	    var readImageDataFromSelection = function (editor) {
	      var image = getSelectedImage(editor);
	      return image ? read(function (css) {
	        return normalizeCss(editor, css);
	      }, image) : defaultData();
	    };
	    var insertImageAtCaret = function (editor, data) {
	      var elm = create(function (css) {
	        return normalizeCss(editor, css);
	      }, data);
	      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
	      editor.focus();
	      editor.selection.setContent(elm.outerHTML);
	      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
	      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
	      if (isFigure(insertedElm)) {
	        var figure = splitTextBlock(editor, insertedElm);
	        editor.selection.select(figure);
	      } else {
	        editor.selection.select(insertedElm);
	      }
	    };
	    var syncSrcAttr = function (editor, image) {
	      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
	    };
	    var deleteImage = function (editor, image) {
	      if (image) {
	        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
	        editor.dom.remove(elm);
	        editor.focus();
	        editor.nodeChanged();
	        if (editor.dom.isEmpty(editor.getBody())) {
	          editor.setContent('');
	          editor.selection.setCursorLocation();
	        }
	      }
	    };
	    var writeImageDataToSelection = function (editor, data) {
	      var image = getSelectedImage(editor);
	      write(function (css) {
	        return normalizeCss(editor, css);
	      }, data, image);
	      syncSrcAttr(editor, image);
	      if (isFigure(image.parentNode)) {
	        var figure = image.parentNode;
	        splitTextBlock(editor, figure);
	        editor.selection.select(image.parentNode);
	      } else {
	        editor.selection.select(image);
	        Utils.waitLoadImage(editor, data, image);
	      }
	    };
	    var insertOrUpdateImage = function (editor, data) {
	      var image = getSelectedImage(editor);
	      if (image) {
	        if (data.src) {
	          writeImageDataToSelection(editor, data);
	        } else {
	          deleteImage(editor, image);
	        }
	      } else if (data.src) {
	        insertImageAtCaret(editor, data);
	      }
	    };
	
	    var updateVSpaceHSpaceBorder = function (editor) {
	      return function (evt) {
	        var dom = editor.dom;
	        var rootControl = evt.control.rootControl;
	        if (!Settings.hasAdvTab(editor)) {
	          return;
	        }
	        var data = rootControl.toJSON();
	        var css = dom.parseStyle(data.style);
	        rootControl.find('#vspace').value('');
	        rootControl.find('#hspace').value('');
	        css = Utils.mergeMargins(css);
	        if (css['margin-top'] && css['margin-bottom'] || css['margin-right'] && css['margin-left']) {
	          if (css['margin-top'] === css['margin-bottom']) {
	            rootControl.find('#vspace').value(Utils.removePixelSuffix(css['margin-top']));
	          } else {
	            rootControl.find('#vspace').value('');
	          }
	          if (css['margin-right'] === css['margin-left']) {
	            rootControl.find('#hspace').value(Utils.removePixelSuffix(css['margin-right']));
	          } else {
	            rootControl.find('#hspace').value('');
	          }
	        }
	        if (css['border-width']) {
	          rootControl.find('#border').value(Utils.removePixelSuffix(css['border-width']));
	        } else {
	          rootControl.find('#border').value('');
	        }
	        if (css['border-style']) {
	          rootControl.find('#borderStyle').value(css['border-style']);
	        } else {
	          rootControl.find('#borderStyle').value('');
	        }
	        rootControl.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
	      };
	    };
	    var updateStyle = function (editor, win) {
	      win.find('#style').each(function (ctrl) {
	        var value = getStyleValue(function (css) {
	          return normalizeCss(editor, css);
	        }, merge(defaultData(), win.toJSON()));
	        ctrl.value(value);
	      });
	    };
	    var makeTab = function (editor) {
	      return {
	        title: 'Advanced',
	        type: 'form',
	        pack: 'start',
	        items: [
	          {
	            label: 'Style',
	            name: 'style',
	            type: 'textbox',
	            onchange: updateVSpaceHSpaceBorder(editor)
	          },
	          {
	            type: 'form',
	            layout: 'grid',
	            packV: 'start',
	            columns: 2,
	            padding: 0,
	            defaults: {
	              type: 'textbox',
	              maxWidth: 50,
	              onchange: function (evt) {
	                updateStyle(editor, evt.control.rootControl);
	              }
	            },
	            items: [
	              {
	                label: 'Vertical space',
	                name: 'vspace'
	              },
	              {
	                label: 'Border width',
	                name: 'border'
	              },
	              {
	                label: 'Horizontal space',
	                name: 'hspace'
	              },
	              {
	                label: 'Border style',
	                type: 'listbox',
	                name: 'borderStyle',
	                width: 90,
	                maxWidth: 90,
	                onselect: function (evt) {
	                  updateStyle(editor, evt.control.rootControl);
	                },
	                values: [
	                  {
	                    text: 'Select...',
	                    value: ''
	                  },
	                  {
	                    text: 'Solid',
	                    value: 'solid'
	                  },
	                  {
	                    text: 'Dotted',
	                    value: 'dotted'
	                  },
	                  {
	                    text: 'Dashed',
	                    value: 'dashed'
	                  },
	                  {
	                    text: 'Double',
	                    value: 'double'
	                  },
	                  {
	                    text: 'Groove',
	                    value: 'groove'
	                  },
	                  {
	                    text: 'Ridge',
	                    value: 'ridge'
	                  },
	                  {
	                    text: 'Inset',
	                    value: 'inset'
	                  },
	                  {
	                    text: 'Outset',
	                    value: 'outset'
	                  },
	                  {
	                    text: 'None',
	                    value: 'none'
	                  },
	                  {
	                    text: 'Hidden',
	                    value: 'hidden'
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      };
	    };
	    var AdvTab = { makeTab: makeTab };
	
	    var doSyncSize = function (widthCtrl, heightCtrl) {
	      widthCtrl.state.set('oldVal', widthCtrl.value());
	      heightCtrl.state.set('oldVal', heightCtrl.value());
	    };
	    var doSizeControls = function (win, f) {
	      var widthCtrl = win.find('#width')[0];
	      var heightCtrl = win.find('#height')[0];
	      var constrained = win.find('#constrain')[0];
	      if (widthCtrl && heightCtrl && constrained) {
	        f(widthCtrl, heightCtrl, constrained.checked());
	      }
	    };
	    var doUpdateSize = function (widthCtrl, heightCtrl, isContrained) {
	      var oldWidth = widthCtrl.state.get('oldVal');
	      var oldHeight = heightCtrl.state.get('oldVal');
	      var newWidth = widthCtrl.value();
	      var newHeight = heightCtrl.value();
	      if (isContrained && oldWidth && oldHeight && newWidth && newHeight) {
	        if (newWidth !== oldWidth) {
	          newHeight = Math.round(newWidth / oldWidth * newHeight);
	          if (!isNaN(newHeight)) {
	            heightCtrl.value(newHeight);
	          }
	        } else {
	          newWidth = Math.round(newHeight / oldHeight * newWidth);
	          if (!isNaN(newWidth)) {
	            widthCtrl.value(newWidth);
	          }
	        }
	      }
	      doSyncSize(widthCtrl, heightCtrl);
	    };
	    var syncSize = function (win) {
	      doSizeControls(win, doSyncSize);
	    };
	    var updateSize = function (win) {
	      doSizeControls(win, doUpdateSize);
	    };
	    var createUi = function () {
	      var recalcSize = function (evt) {
	        updateSize(evt.control.rootControl);
	      };
	      return {
	        type: 'container',
	        label: 'Dimensions',
	        layout: 'flex',
	        align: 'center',
	        spacing: 5,
	        items: [
	          {
	            name: 'width',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Width'
	          },
	          {
	            type: 'label',
	            text: 'x'
	          },
	          {
	            name: 'height',
	            type: 'textbox',
	            maxLength: 5,
	            size: 5,
	            onchange: recalcSize,
	            ariaLabel: 'Height'
	          },
	          {
	            name: 'constrain',
	            type: 'checkbox',
	            checked: true,
	            text: 'Constrain proportions'
	          }
	        ]
	      };
	    };
	    var SizeManager = {
	      createUi: createUi,
	      syncSize: syncSize,
	      updateSize: updateSize
	    };
	
	    var onSrcChange = function (evt, editor) {
	      var srcURL, prependURL, absoluteURLPattern;
	      var meta = evt.meta || {};
	      var control = evt.control;
	      var rootControl = control.rootControl;
	      var imageListCtrl = rootControl.find('#image-list')[0];
	      if (imageListCtrl) {
	        imageListCtrl.value(editor.convertURL(control.value(), 'src'));
	      }
	      global$2.each(meta, function (value, key) {
	        rootControl.find('#' + key).value(value);
	      });
	      if (!meta.width && !meta.height) {
	        srcURL = editor.convertURL(control.value(), 'src');
	        prependURL = Settings.getPrependUrl(editor);
	        absoluteURLPattern = new RegExp('^(?:[a-z]+:)?//', 'i');
	        if (prependURL && !absoluteURLPattern.test(srcURL) && srcURL.substring(0, prependURL.length) !== prependURL) {
	          srcURL = prependURL + srcURL;
	        }
	        control.value(srcURL);
	        Utils.getImageSize(editor.documentBaseURI.toAbsolute(control.value()), function (data) {
	          if (data.width && data.height && Settings.hasDimensions(editor)) {
	            rootControl.find('#width').value(data.width);
	            rootControl.find('#height').value(data.height);
	            SizeManager.syncSize(rootControl);
	          }
	        });
	      }
	    };
	    var onBeforeCall = function (evt) {
	      evt.meta = evt.control.rootControl.toJSON();
	    };
	    var getGeneralItems = function (editor, imageListCtrl) {
	      var generalFormItems = [
	        {
	          name: 'src',
	          type: 'filepicker',
	          filetype: 'image',
	          label: 'Source',
	          autofocus: true,
	          onchange: function (evt) {
	            onSrcChange(evt, editor);
	          },
	          onbeforecall: onBeforeCall
	        },
	        imageListCtrl
	      ];
	      if (Settings.hasDescription(editor)) {
	        generalFormItems.push({
	          name: 'alt',
	          type: 'textbox',
	          label: 'Image description'
	        });
	      }
	      if (Settings.hasImageTitle(editor)) {
	        generalFormItems.push({
	          name: 'title',
	          type: 'textbox',
	          label: 'Image Title'
	        });
	      }
	      if (Settings.hasDimensions(editor)) {
	        generalFormItems.push(SizeManager.createUi());
	      }
	      if (Settings.getClassList(editor)) {
	        generalFormItems.push({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: Utils.buildListItems(Settings.getClassList(editor), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  inline: 'img',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        });
	      }
	      if (Settings.hasImageCaption(editor)) {
	        generalFormItems.push({
	          name: 'caption',
	          type: 'checkbox',
	          label: 'Caption'
	        });
	      }
	      return generalFormItems;
	    };
	    var makeTab$1 = function (editor, imageListCtrl) {
	      return {
	        title: 'General',
	        type: 'form',
	        items: getGeneralItems(editor, imageListCtrl)
	      };
	    };
	    var MainTab = {
	      makeTab: makeTab$1,
	      getGeneralItems: getGeneralItems
	    };
	
	    var url = function () {
	      return Global$1.getOrDie('URL');
	    };
	    var createObjectURL = function (blob) {
	      return url().createObjectURL(blob);
	    };
	    var revokeObjectURL = function (u) {
	      url().revokeObjectURL(u);
	    };
	    var URL = {
	      createObjectURL: createObjectURL,
	      revokeObjectURL: revokeObjectURL
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.ui.Factory');
	
	    function XMLHttpRequest () {
	      var f = Global$1.getOrDie('XMLHttpRequest');
	      return new f();
	    }
	
	    var noop = function () {
	    };
	    var pathJoin = function (path1, path2) {
	      if (path1) {
	        return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	      }
	      return path2;
	    };
	    function Uploader (settings) {
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr, formData;
	        xhr = XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          var json;
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        formData = new domGlobals.FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var uploadBlob = function (blobInfo, handler) {
	        return new global$1(function (resolve, reject) {
	          try {
	            handler(blobInfo, resolve, reject, noop);
	          } catch (ex) {
	            reject(ex.message);
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var upload = function (blobInfo) {
	        return !settings.url && isDefaultHandler(settings.handler) ? global$1.reject('Upload url missing from the settings.') : uploadBlob(blobInfo, settings.handler);
	      };
	      settings = global$2.extend({
	        credentials: false,
	        handler: defaultHandler
	      }, settings);
	      return { upload: upload };
	    }
	
	    var onFileInput = function (editor) {
	      return function (evt) {
	        var Throbber = global$5.get('Throbber');
	        var rootControl = evt.control.rootControl;
	        var throbber = new Throbber(rootControl.getEl());
	        var file = evt.control.value();
	        var blobUri = URL.createObjectURL(file);
	        var uploader = Uploader({
	          url: Settings.getUploadUrl(editor),
	          basePath: Settings.getUploadBasePath(editor),
	          credentials: Settings.getUploadCredentials(editor),
	          handler: Settings.getUploadHandler(editor)
	        });
	        var finalize = function () {
	          throbber.hide();
	          URL.revokeObjectURL(blobUri);
	        };
	        throbber.show();
	        return Utils.blobToDataUri(file).then(function (dataUrl) {
	          var blobInfo = editor.editorUpload.blobCache.create({
	            blob: file,
	            blobUri: blobUri,
	            name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
	            base64: dataUrl.split(',')[1]
	          });
	          return uploader.upload(blobInfo).then(function (url) {
	            var src = rootControl.find('#src');
	            src.value(url);
	            rootControl.find('tabpanel')[0].activateTab(0);
	            src.fire('change');
	            finalize();
	            return url;
	          });
	        }).catch(function (err) {
	          editor.windowManager.alert(err);
	          finalize();
	        });
	      };
	    };
	    var acceptExts = '.jpg,.jpeg,.png,.gif';
	    var makeTab$2 = function (editor) {
	      return {
	        title: 'Upload',
	        type: 'form',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        padding: '20 20 20 20',
	        items: [
	          {
	            type: 'container',
	            layout: 'flex',
	            direction: 'column',
	            align: 'center',
	            spacing: 10,
	            items: [
	              {
	                text: 'Browse for an image',
	                type: 'browsebutton',
	                accept: acceptExts,
	                onchange: onFileInput(editor)
	              },
	              {
	                text: 'OR',
	                type: 'label'
	              }
	            ]
	          },
	          {
	            text: 'Drop an image here',
	            type: 'dropzone',
	            accept: acceptExts,
	            height: 100,
	            onchange: onFileInput(editor)
	          }
	        ]
	      };
	    };
	    var UploadTab = { makeTab: makeTab$2 };
	
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	
	    var submitForm = function (editor, evt) {
	      var win = evt.control.getRoot();
	      SizeManager.updateSize(win);
	      editor.undoManager.transact(function () {
	        var data = merge(readImageDataFromSelection(editor), win.toJSON());
	        insertOrUpdateImage(editor, data);
	      });
	      editor.editorUpload.uploadImagesAuto();
	    };
	    function Dialog (editor) {
	      function showDialog(imageList) {
	        var data = readImageDataFromSelection(editor);
	        var win, imageListCtrl;
	        if (imageList) {
	          imageListCtrl = {
	            type: 'listbox',
	            label: 'Image list',
	            name: 'image-list',
	            values: Utils.buildListItems(imageList, function (item) {
	              item.value = editor.convertURL(item.value || item.url, 'src');
	            }, [{
	                text: 'None',
	                value: ''
	              }]),
	            value: data.src && editor.convertURL(data.src, 'src'),
	            onselect: function (e) {
	              var altCtrl = win.find('#alt');
	              if (!altCtrl.value() || e.lastControl && altCtrl.value() === e.lastControl.text()) {
	                altCtrl.value(e.control.text());
	              }
	              win.find('#src').value(e.control.value()).fire('change');
	            },
	            onPostRender: function () {
	              imageListCtrl = this;
	            }
	          };
	        }
	        if (Settings.hasAdvTab(editor) || Settings.hasUploadUrl(editor) || Settings.hasUploadHandler(editor)) {
	          var body = [MainTab.makeTab(editor, imageListCtrl)];
	          if (Settings.hasAdvTab(editor)) {
	            body.push(AdvTab.makeTab(editor));
	          }
	          if (Settings.hasUploadUrl(editor) || Settings.hasUploadHandler(editor)) {
	            body.push(UploadTab.makeTab(editor));
	          }
	          win = editor.windowManager.open({
	            title: 'Insert/edit image',
	            data: data,
	            bodyType: 'tabpanel',
	            body: body,
	            onSubmit: curry(submitForm, editor)
	          });
	        } else {
	          win = editor.windowManager.open({
	            title: 'Insert/edit image',
	            data: data,
	            body: MainTab.getGeneralItems(editor, imageListCtrl),
	            onSubmit: curry(submitForm, editor)
	          });
	        }
	        SizeManager.syncSize(win);
	      }
	      function open() {
	        Utils.createImageList(editor, showDialog);
	      }
	      return { open: open };
	    }
	
	    var register = function (editor) {
	      editor.addCommand('mceImage', Dialog(editor).open);
	    };
	    var Commands = { register: register };
	
	    var hasImageClass = function (node) {
	      var className = node.attr('class');
	      return className && /\bimage\b/.test(className);
	    };
	    var toggleContentEditableState = function (state) {
	      return function (nodes) {
	        var i = nodes.length, node;
	        var toggleContentEditable = function (node) {
	          node.attr('contenteditable', state ? 'true' : null);
	        };
	        while (i--) {
	          node = nodes[i];
	          if (hasImageClass(node)) {
	            node.attr('contenteditable', state ? 'false' : null);
	            global$2.each(node.getAll('figcaption'), toggleContentEditable);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('preInit', function () {
	        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
	        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
	      });
	    };
	    var FilterContent = { setup: setup };
	
	    var register$1 = function (editor) {
	      editor.addButton('image', {
	        icon: 'image',
	        tooltip: 'Insert/edit image',
	        onclick: Dialog(editor).open,
	        stateSelector: 'img:not([data-mce-object],[data-mce-placeholder]),figure.image'
	      });
	      editor.addMenuItem('image', {
	        icon: 'image',
	        text: 'Image',
	        onclick: Dialog(editor).open,
	        context: 'insert',
	        prependToContext: true
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('image', function (editor) {
	      FilterContent.setup(editor);
	      Buttons.register(editor);
	      Commands.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	(function () {
	var link = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var assumeExternalTargets = function (editorSettings) {
	      return typeof editorSettings.link_assume_external_targets === 'boolean' ? editorSettings.link_assume_external_targets : false;
	    };
	    var hasContextToolbar = function (editorSettings) {
	      return typeof editorSettings.link_context_toolbar === 'boolean' ? editorSettings.link_context_toolbar : false;
	    };
	    var getLinkList = function (editorSettings) {
	      return editorSettings.link_list;
	    };
	    var hasDefaultLinkTarget = function (editorSettings) {
	      return typeof editorSettings.default_link_target === 'string';
	    };
	    var getDefaultLinkTarget = function (editorSettings) {
	      return editorSettings.default_link_target;
	    };
	    var getTargetList = function (editorSettings) {
	      return editorSettings.target_list;
	    };
	    var setTargetList = function (editor, list) {
	      editor.settings.target_list = list;
	    };
	    var shouldShowTargetList = function (editorSettings) {
	      return getTargetList(editorSettings) !== false;
	    };
	    var getRelList = function (editorSettings) {
	      return editorSettings.rel_list;
	    };
	    var hasRelList = function (editorSettings) {
	      return getRelList(editorSettings) !== undefined;
	    };
	    var getLinkClassList = function (editorSettings) {
	      return editorSettings.link_class_list;
	    };
	    var hasLinkClassList = function (editorSettings) {
	      return getLinkClassList(editorSettings) !== undefined;
	    };
	    var shouldShowLinkTitle = function (editorSettings) {
	      return editorSettings.link_title !== false;
	    };
	    var allowUnsafeLinkTarget = function (editorSettings) {
	      return typeof editorSettings.allow_unsafe_link_target === 'boolean' ? editorSettings.allow_unsafe_link_target : false;
	    };
	    var Settings = {
	      assumeExternalTargets: assumeExternalTargets,
	      hasContextToolbar: hasContextToolbar,
	      getLinkList: getLinkList,
	      hasDefaultLinkTarget: hasDefaultLinkTarget,
	      getDefaultLinkTarget: getDefaultLinkTarget,
	      getTargetList: getTargetList,
	      setTargetList: setTargetList,
	      shouldShowTargetList: shouldShowTargetList,
	      getRelList: getRelList,
	      hasRelList: hasRelList,
	      getLinkClassList: getLinkClassList,
	      hasLinkClassList: hasLinkClassList,
	      shouldShowLinkTitle: shouldShowLinkTitle,
	      allowUnsafeLinkTarget: allowUnsafeLinkTarget
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var appendClickRemove = function (link, evt) {
	      domGlobals.document.body.appendChild(link);
	      link.dispatchEvent(evt);
	      domGlobals.document.body.removeChild(link);
	    };
	    var open = function (url) {
	      if (!global$3.ie || global$3.ie > 10) {
	        var link = domGlobals.document.createElement('a');
	        link.target = '_blank';
	        link.href = url;
	        link.rel = 'noreferrer noopener';
	        var evt = domGlobals.document.createEvent('MouseEvents');
	        evt.initMouseEvent('click', true, true, domGlobals.window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	        appendClickRemove(link, evt);
	      } else {
	        var win = domGlobals.window.open('', '_blank');
	        if (win) {
	          win.opener = null;
	          var doc = win.document;
	          doc.open();
	          doc.write('<meta http-equiv="refresh" content="0; url=' + global$2.DOM.encode(url) + '">');
	          doc.close();
	        }
	      }
	    };
	    var OpenUrl = { open: open };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var toggleTargetRules = function (rel, isUnsafe) {
	      var rules = ['noopener'];
	      var newRel = rel ? rel.split(/\s+/) : [];
	      var toString = function (rel) {
	        return global$4.trim(rel.sort().join(' '));
	      };
	      var addTargetRules = function (rel) {
	        rel = removeTargetRules(rel);
	        return rel.length ? rel.concat(rules) : rules;
	      };
	      var removeTargetRules = function (rel) {
	        return rel.filter(function (val) {
	          return global$4.inArray(rules, val) === -1;
	        });
	      };
	      newRel = isUnsafe ? addTargetRules(newRel) : removeTargetRules(newRel);
	      return newRel.length ? toString(newRel) : null;
	    };
	    var trimCaretContainers = function (text) {
	      return text.replace(/\uFEFF/g, '');
	    };
	    var getAnchorElement = function (editor, selectedElm) {
	      selectedElm = selectedElm || editor.selection.getNode();
	      if (isImageFigure(selectedElm)) {
	        return editor.dom.select('a[href]', selectedElm)[0];
	      } else {
	        return editor.dom.getParent(selectedElm, 'a[href]');
	      }
	    };
	    var getAnchorText = function (selection, anchorElm) {
	      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
	      return trimCaretContainers(text);
	    };
	    var isLink = function (elm) {
	      return elm && elm.nodeName === 'A' && elm.href;
	    };
	    var hasLinks = function (elements) {
	      return global$4.grep(elements, isLink).length > 0;
	    };
	    var isOnlyTextSelected = function (html) {
	      if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') === -1)) {
	        return false;
	      }
	      return true;
	    };
	    var isImageFigure = function (node) {
	      return node && node.nodeName === 'FIGURE' && /\bimage\b/i.test(node.className);
	    };
	    var link = function (editor, attachState) {
	      return function (data) {
	        editor.undoManager.transact(function () {
	          var selectedElm = editor.selection.getNode();
	          var anchorElm = getAnchorElement(editor, selectedElm);
	          var linkAttrs = {
	            href: data.href,
	            target: data.target ? data.target : null,
	            rel: data.rel ? data.rel : null,
	            class: data.class ? data.class : null,
	            title: data.title ? data.title : null
	          };
	          if (!Settings.hasRelList(editor.settings) && Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	            linkAttrs.rel = toggleTargetRules(linkAttrs.rel, linkAttrs.target === '_blank');
	          }
	          if (data.href === attachState.href) {
	            attachState.attach();
	            attachState = {};
	          }
	          if (anchorElm) {
	            editor.focus();
	            if (data.hasOwnProperty('text')) {
	              if ('innerText' in anchorElm) {
	                anchorElm.innerText = data.text;
	              } else {
	                anchorElm.textContent = data.text;
	              }
	            }
	            editor.dom.setAttribs(anchorElm, linkAttrs);
	            editor.selection.select(anchorElm);
	            editor.undoManager.add();
	          } else {
	            if (isImageFigure(selectedElm)) {
	              linkImageFigure(editor, selectedElm, linkAttrs);
	            } else if (data.hasOwnProperty('text')) {
	              editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(data.text)));
	            } else {
	              editor.execCommand('mceInsertLink', false, linkAttrs);
	            }
	          }
	        });
	      };
	    };
	    var unlink = function (editor) {
	      return function () {
	        editor.undoManager.transact(function () {
	          var node = editor.selection.getNode();
	          if (isImageFigure(node)) {
	            unlinkImageFigure(editor, node);
	          } else {
	            editor.execCommand('unlink');
	          }
	        });
	      };
	    };
	    var unlinkImageFigure = function (editor, fig) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.getParents(img, 'a[href]', fig)[0];
	        if (a) {
	          a.parentNode.insertBefore(img, a);
	          editor.dom.remove(a);
	        }
	      }
	    };
	    var linkImageFigure = function (editor, fig, attrs) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.create('a', attrs);
	        img.parentNode.insertBefore(a, img);
	        a.appendChild(img);
	      }
	    };
	    var Utils = {
	      link: link,
	      unlink: unlink,
	      isLink: isLink,
	      hasLinks: hasLinks,
	      isOnlyTextSelected: isOnlyTextSelected,
	      getAnchorElement: getAnchorElement,
	      getAnchorText: getAnchorText,
	      toggleTargetRules: toggleTargetRules
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var attachState = {};
	    var createLinkList = function (editor, callback) {
	      var linkList = Settings.getLinkList(editor.settings);
	      if (typeof linkList === 'string') {
	        global$6.send({
	          url: linkList,
	          success: function (text) {
	            callback(editor, JSON.parse(text));
	          }
	        });
	      } else if (typeof linkList === 'function') {
	        linkList(function (list) {
	          callback(editor, list);
	        });
	      } else {
	        callback(editor, linkList);
	      }
	    };
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      var appendItems = function (values, output) {
	        output = output || [];
	        global$4.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	            if (itemCallback) {
	              itemCallback(menuItem);
	            }
	          }
	          output.push(menuItem);
	        });
	        return output;
	      };
	      return appendItems(inputList, startItems || []);
	    };
	    var delayedConfirm = function (editor, message, callback) {
	      var rng = editor.selection.getRng();
	      global$5.setEditorTimeout(editor, function () {
	        editor.windowManager.confirm(message, function (state) {
	          editor.selection.setRng(rng);
	          callback(state);
	        });
	      });
	    };
	    var showDialog = function (editor, linkList) {
	      var data = {};
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var anchorElm, initialText;
	      var win, onlyText, textListCtrl, linkListCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;
	      var linkListChangeHandler = function (e) {
	        var textCtrl = win.find('#text');
	        if (!textCtrl.value() || e.lastControl && textCtrl.value() === e.lastControl.text()) {
	          textCtrl.value(e.control.text());
	        }
	        win.find('#href').value(e.control.value());
	      };
	      var buildAnchorListControl = function (url) {
	        var anchorList = [];
	        global$4.each(editor.dom.select('a:not([href])'), function (anchor) {
	          var id = anchor.name || anchor.id;
	          if (id) {
	            anchorList.push({
	              text: id,
	              value: '#' + id,
	              selected: url.indexOf('#' + id) !== -1
	            });
	          }
	        });
	        if (anchorList.length) {
	          anchorList.unshift({
	            text: 'None',
	            value: ''
	          });
	          return {
	            name: 'anchor',
	            type: 'listbox',
	            label: 'Anchors',
	            values: anchorList,
	            onselect: linkListChangeHandler
	          };
	        }
	      };
	      var updateText = function () {
	        if (!initialText && onlyText && !data.text) {
	          this.parent().parent().find('#text')[0].value(this.value());
	        }
	      };
	      var urlChange = function (e) {
	        var meta = e.meta || {};
	        if (linkListCtrl) {
	          linkListCtrl.value(editor.convertURL(this.value(), 'href'));
	        }
	        global$4.each(e.meta, function (value, key) {
	          var inp = win.find('#' + key);
	          if (key === 'text') {
	            if (initialText.length === 0) {
	              inp.value(value);
	              data.text = value;
	            }
	          } else {
	            inp.value(value);
	          }
	        });
	        if (meta.attach) {
	          attachState = {
	            href: this.value(),
	            attach: meta.attach
	          };
	        }
	        if (!meta.text) {
	          updateText.call(this);
	        }
	      };
	      var onBeforeCall = function (e) {
	        e.meta = win.toJSON();
	      };
	      onlyText = Utils.isOnlyTextSelected(selection.getContent());
	      anchorElm = Utils.getAnchorElement(editor);
	      data.text = initialText = Utils.getAnchorText(editor.selection, anchorElm);
	      data.href = anchorElm ? dom.getAttrib(anchorElm, 'href') : '';
	      if (anchorElm) {
	        data.target = dom.getAttrib(anchorElm, 'target');
	      } else if (Settings.hasDefaultLinkTarget(editor.settings)) {
	        data.target = Settings.getDefaultLinkTarget(editor.settings);
	      }
	      if (value = dom.getAttrib(anchorElm, 'rel')) {
	        data.rel = value;
	      }
	      if (value = dom.getAttrib(anchorElm, 'class')) {
	        data.class = value;
	      }
	      if (value = dom.getAttrib(anchorElm, 'title')) {
	        data.title = value;
	      }
	      if (onlyText) {
	        textListCtrl = {
	          name: 'text',
	          type: 'textbox',
	          size: 40,
	          label: 'Text to display',
	          onchange: function () {
	            data.text = this.value();
	          }
	        };
	      }
	      if (linkList) {
	        linkListCtrl = {
	          type: 'listbox',
	          label: 'Link list',
	          values: buildListItems(linkList, function (item) {
	            item.value = editor.convertURL(item.value || item.url, 'href');
	          }, [{
	              text: 'None',
	              value: ''
	            }]),
	          onselect: linkListChangeHandler,
	          value: editor.convertURL(data.href, 'href'),
	          onPostRender: function () {
	            linkListCtrl = this;
	          }
	        };
	      }
	      if (Settings.shouldShowTargetList(editor.settings)) {
	        if (Settings.getTargetList(editor.settings) === undefined) {
	          Settings.setTargetList(editor, [
	            {
	              text: 'None',
	              value: ''
	            },
	            {
	              text: 'New window',
	              value: '_blank'
	            }
	          ]);
	        }
	        targetListCtrl = {
	          name: 'target',
	          type: 'listbox',
	          label: 'Target',
	          values: buildListItems(Settings.getTargetList(editor.settings))
	        };
	      }
	      if (Settings.hasRelList(editor.settings)) {
	        relListCtrl = {
	          name: 'rel',
	          type: 'listbox',
	          label: 'Rel',
	          values: buildListItems(Settings.getRelList(editor.settings), function (item) {
	            if (Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	              item.value = Utils.toggleTargetRules(item.value, data.target === '_blank');
	            }
	          })
	        };
	      }
	      if (Settings.hasLinkClassList(editor.settings)) {
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: buildListItems(Settings.getLinkClassList(editor.settings), function (item) {
	            if (item.value) {
	              item.textStyle = function () {
	                return editor.formatter.getCssText({
	                  inline: 'a',
	                  classes: [item.value]
	                });
	              };
	            }
	          })
	        };
	      }
	      if (Settings.shouldShowLinkTitle(editor.settings)) {
	        linkTitleCtrl = {
	          name: 'title',
	          type: 'textbox',
	          label: 'Title',
	          value: data.title
	        };
	      }
	      win = editor.windowManager.open({
	        title: 'Insert link',
	        data: data,
	        body: [
	          {
	            name: 'href',
	            type: 'filepicker',
	            filetype: 'file',
	            size: 40,
	            autofocus: true,
	            label: 'Url',
	            onchange: urlChange,
	            onkeyup: updateText,
	            onpaste: updateText,
	            onbeforecall: onBeforeCall
	          },
	          textListCtrl,
	          linkTitleCtrl,
	          buildAnchorListControl(data.href),
	          linkListCtrl,
	          relListCtrl,
	          targetListCtrl,
	          classListCtrl
	        ],
	        onSubmit: function (e) {
	          var assumeExternalTargets = Settings.assumeExternalTargets(editor.settings);
	          var insertLink = Utils.link(editor, attachState);
	          var removeLink = Utils.unlink(editor);
	          var resultData = global$4.extend({}, data, e.data);
	          var href = resultData.href;
	          if (!href) {
	            removeLink();
	            return;
	          }
	          if (!onlyText || resultData.text === initialText) {
	            delete resultData.text;
	          }
	          if (href.indexOf('@') > 0 && href.indexOf('//') === -1 && href.indexOf('mailto:') === -1) {
	            delayedConfirm(editor, 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?', function (state) {
	              if (state) {
	                resultData.href = 'mailto:' + href;
	              }
	              insertLink(resultData);
	            });
	            return;
	          }
	          if (assumeExternalTargets === true && !/^\w+:/i.test(href) || assumeExternalTargets === false && /^\s*www[\.|\d\.]/i.test(href)) {
	            delayedConfirm(editor, 'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?', function (state) {
	              if (state) {
	                resultData.href = 'http://' + href;
	              }
	              insertLink(resultData);
	            });
	            return;
	          }
	          insertLink(resultData);
	        }
	      });
	    };
	    var open$1 = function (editor) {
	      createLinkList(editor, showDialog);
	    };
	    var Dialog = { open: open$1 };
	
	    var getLink = function (editor, elm) {
	      return editor.dom.getParent(elm, 'a[href]');
	    };
	    var getSelectedLink = function (editor) {
	      return getLink(editor, editor.selection.getStart());
	    };
	    var getHref = function (elm) {
	      var href = elm.getAttribute('data-mce-href');
	      return href ? href : elm.getAttribute('href');
	    };
	    var isContextMenuVisible = function (editor) {
	      var contextmenu = editor.plugins.contextmenu;
	      return contextmenu ? contextmenu.isContextMenuVisible() : false;
	    };
	    var hasOnlyAltModifier = function (e) {
	      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
	    };
	    var gotoLink = function (editor, a) {
	      if (a) {
	        var href = getHref(a);
	        if (/^#/.test(href)) {
	          var targetEl = editor.$(href);
	          if (targetEl.length) {
	            editor.selection.scrollIntoView(targetEl[0], true);
	          }
	        } else {
	          OpenUrl.open(a.href);
	        }
	      }
	    };
	    var openDialog = function (editor) {
	      return function () {
	        Dialog.open(editor);
	      };
	    };
	    var gotoSelectedLink = function (editor) {
	      return function () {
	        gotoLink(editor, getSelectedLink(editor));
	      };
	    };
	    var leftClickedOnAHref = function (editor) {
	      return function (elm) {
	        var sel, rng, node;
	        if (Settings.hasContextToolbar(editor.settings) && !isContextMenuVisible(editor) && Utils.isLink(elm)) {
	          sel = editor.selection;
	          rng = sel.getRng();
	          node = rng.startContainer;
	          if (node.nodeType === 3 && sel.isCollapsed() && rng.startOffset > 0 && rng.startOffset < node.data.length) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var setupGotoLinks = function (editor) {
	      editor.on('click', function (e) {
	        var link = getLink(editor, e.target);
	        if (link && global$1.metaKeyPressed(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	      editor.on('keydown', function (e) {
	        var link = getSelectedLink(editor);
	        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	    };
	    var toggleActiveState = function (editor) {
	      return function () {
	        var self = this;
	        editor.on('nodechange', function (e) {
	          self.active(!editor.readonly && !!Utils.getAnchorElement(editor, e.element));
	        });
	      };
	    };
	    var toggleViewLinkState = function (editor) {
	      return function () {
	        var self = this;
	        var toggleVisibility = function (e) {
	          if (Utils.hasLinks(e.parents)) {
	            self.show();
	          } else {
	            self.hide();
	          }
	        };
	        if (!Utils.hasLinks(editor.dom.getParents(editor.selection.getStart()))) {
	          self.hide();
	        }
	        editor.on('nodechange', toggleVisibility);
	        self.on('remove', function () {
	          editor.off('nodechange', toggleVisibility);
	        });
	      };
	    };
	    var Actions = {
	      openDialog: openDialog,
	      gotoSelectedLink: gotoSelectedLink,
	      leftClickedOnAHref: leftClickedOnAHref,
	      setupGotoLinks: setupGotoLinks,
	      toggleActiveState: toggleActiveState,
	      toggleViewLinkState: toggleViewLinkState
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceLink', Actions.openDialog(editor));
	    };
	    var Commands = { register: register };
	
	    var setup = function (editor) {
	      editor.addShortcut('Meta+K', '', Actions.openDialog(editor));
	    };
	    var Keyboard = { setup: setup };
	
	    var setupButtons = function (editor) {
	      editor.addButton('link', {
	        active: false,
	        icon: 'link',
	        tooltip: 'Insert/edit link',
	        onclick: Actions.openDialog(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	      editor.addButton('unlink', {
	        active: false,
	        icon: 'unlink',
	        tooltip: 'Remove link',
	        onclick: Utils.unlink(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	      if (editor.addContextToolbar) {
	        editor.addButton('openlink', {
	          icon: 'newtab',
	          tooltip: 'Open link',
	          onclick: Actions.gotoSelectedLink(editor)
	        });
	      }
	    };
	    var setupMenuItems = function (editor) {
	      editor.addMenuItem('openlink', {
	        text: 'Open link',
	        icon: 'newtab',
	        onclick: Actions.gotoSelectedLink(editor),
	        onPostRender: Actions.toggleViewLinkState(editor),
	        prependToContext: true
	      });
	      editor.addMenuItem('link', {
	        icon: 'link',
	        text: 'Link',
	        shortcut: 'Meta+K',
	        onclick: Actions.openDialog(editor),
	        stateSelector: 'a[href]',
	        context: 'insert',
	        prependToContext: true
	      });
	      editor.addMenuItem('unlink', {
	        icon: 'unlink',
	        text: 'Remove link',
	        onclick: Utils.unlink(editor),
	        stateSelector: 'a[href]'
	      });
	    };
	    var setupContextToolbars = function (editor) {
	      if (editor.addContextToolbar) {
	        editor.addContextToolbar(Actions.leftClickedOnAHref(editor), 'openlink | link unlink');
	      }
	    };
	    var Controls = {
	      setupButtons: setupButtons,
	      setupMenuItems: setupMenuItems,
	      setupContextToolbars: setupContextToolbars
	    };
	
	    global.add('link', function (editor) {
	      Controls.setupButtons(editor);
	      Controls.setupMenuItems(editor);
	      Controls.setupContextToolbars(editor);
	      Actions.setupGotoLinks(editor);
	      Commands.register(editor);
	      Keyboard.setup(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	(function () {
	var lists = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.BookmarkManager');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var isTextNode = function (node) {
	      return node && node.nodeType === 3;
	    };
	    var isListNode = function (node) {
	      return node && /^(OL|UL|DL)$/.test(node.nodeName);
	    };
	    var isOlUlNode = function (node) {
	      return node && /^(OL|UL)$/.test(node.nodeName);
	    };
	    var isListItemNode = function (node) {
	      return node && /^(LI|DT|DD)$/.test(node.nodeName);
	    };
	    var isDlItemNode = function (node) {
	      return node && /^(DT|DD)$/.test(node.nodeName);
	    };
	    var isTableCellNode = function (node) {
	      return node && /^(TH|TD)$/.test(node.nodeName);
	    };
	    var isBr = function (node) {
	      return node && node.nodeName === 'BR';
	    };
	    var isFirstChild = function (node) {
	      return node.parentNode.firstChild === node;
	    };
	    var isLastChild = function (node) {
	      return node.parentNode.lastChild === node;
	    };
	    var isTextBlock = function (editor, node) {
	      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
	    };
	    var isBlock = function (node, blockElements) {
	      return node && node.nodeName in blockElements;
	    };
	    var isBogusBr = function (dom, node) {
	      if (!isBr(node)) {
	        return false;
	      }
	      if (dom.isBlock(node.nextSibling) && !isBr(node.previousSibling)) {
	        return true;
	      }
	      return false;
	    };
	    var isEmpty = function (dom, elm, keepBookmarks) {
	      var empty = dom.isEmpty(elm);
	      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
	        return false;
	      }
	      return empty;
	    };
	    var isChildOfBody = function (dom, elm) {
	      return dom.isChildOf(elm, dom.getRoot());
	    };
	    var NodeType = {
	      isTextNode: isTextNode,
	      isListNode: isListNode,
	      isOlUlNode: isOlUlNode,
	      isDlItemNode: isDlItemNode,
	      isListItemNode: isListItemNode,
	      isTableCellNode: isTableCellNode,
	      isBr: isBr,
	      isFirstChild: isFirstChild,
	      isLastChild: isLastChild,
	      isTextBlock: isTextBlock,
	      isBlock: isBlock,
	      isBogusBr: isBogusBr,
	      isEmpty: isEmpty,
	      isChildOfBody: isChildOfBody
	    };
	
	    var getNormalizedPoint = function (container, offset) {
	      if (NodeType.isTextNode(container)) {
	        return {
	          container: container,
	          offset: offset
	        };
	      }
	      var node = global$1.getNode(container, offset);
	      if (NodeType.isTextNode(node)) {
	        return {
	          container: node,
	          offset: offset >= container.childNodes.length ? node.data.length : 0
	        };
	      } else if (node.previousSibling && NodeType.isTextNode(node.previousSibling)) {
	        return {
	          container: node.previousSibling,
	          offset: node.previousSibling.data.length
	        };
	      } else if (node.nextSibling && NodeType.isTextNode(node.nextSibling)) {
	        return {
	          container: node.nextSibling,
	          offset: 0
	        };
	      }
	      return {
	        container: container,
	        offset: offset
	      };
	    };
	    var normalizeRange = function (rng) {
	      var outRng = rng.cloneRange();
	      var rangeStart = getNormalizedPoint(rng.startContainer, rng.startOffset);
	      outRng.setStart(rangeStart.container, rangeStart.offset);
	      var rangeEnd = getNormalizedPoint(rng.endContainer, rng.endOffset);
	      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
	      return outRng;
	    };
	    var Range = {
	      getNormalizedPoint: getNormalizedPoint,
	      normalizeRange: normalizeRange
	    };
	
	    var DOM = global$6.DOM;
	    var createBookmark = function (rng) {
	      var bookmark = {};
	      var setupEndPoint = function (start) {
	        var offsetNode, container, offset;
	        container = rng[start ? 'startContainer' : 'endContainer'];
	        offset = rng[start ? 'startOffset' : 'endOffset'];
	        if (container.nodeType === 1) {
	          offsetNode = DOM.create('span', { 'data-mce-type': 'bookmark' });
	          if (container.hasChildNodes()) {
	            offset = Math.min(offset, container.childNodes.length - 1);
	            if (start) {
	              container.insertBefore(offsetNode, container.childNodes[offset]);
	            } else {
	              DOM.insertAfter(offsetNode, container.childNodes[offset]);
	            }
	          } else {
	            container.appendChild(offsetNode);
	          }
	          container = offsetNode;
	          offset = 0;
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      };
	      setupEndPoint(true);
	      if (!rng.collapsed) {
	        setupEndPoint();
	      }
	      return bookmark;
	    };
	    var resolveBookmark = function (bookmark) {
	      function restoreEndPoint(start) {
	        var container, offset, node;
	        var nodeIndex = function (container) {
	          var node = container.parentNode.firstChild, idx = 0;
	          while (node) {
	            if (node === container) {
	              return idx;
	            }
	            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
	              idx++;
	            }
	            node = node.nextSibling;
	          }
	          return -1;
	        };
	        container = node = bookmark[start ? 'startContainer' : 'endContainer'];
	        offset = bookmark[start ? 'startOffset' : 'endOffset'];
	        if (!container) {
	          return;
	        }
	        if (container.nodeType === 1) {
	          offset = nodeIndex(container);
	          container = container.parentNode;
	          DOM.remove(node);
	          if (!container.hasChildNodes() && DOM.isBlock(container)) {
	            container.appendChild(DOM.create('br'));
	          }
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      }
	      restoreEndPoint(true);
	      restoreEndPoint();
	      var rng = DOM.createRng();
	      rng.setStart(bookmark.startContainer, bookmark.startOffset);
	      if (bookmark.endContainer) {
	        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
	      }
	      return Range.normalizeRange(rng);
	    };
	    var Bookmark = {
	      createBookmark: createBookmark,
	      resolveBookmark: resolveBookmark
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var not = function (f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return !f.apply(null, args);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isBoolean = isType('boolean');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]);
	        var r = [];
	        var group = [];
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var htmlElement = function (scope) {
	      return Global$1.getOrDie('HTMLElement', scope);
	    };
	    var isPrototypeOf = function (x) {
	      var scope = resolve('ownerDocument.defaultView', x);
	      return htmlElement(scope).prototype.isPrototypeOf(x);
	    };
	    var HTMLElement = { isPrototypeOf: isPrototypeOf };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var getParentList = function (editor) {
	      var selectionStart = editor.selection.getStart(true);
	      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
	    };
	    var isParentListSelected = function (parentList, selectedBlocks) {
	      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
	    };
	    var findSubLists = function (parentList) {
	      return global$5.grep(parentList.querySelectorAll('ol,ul,dl'), function (elm) {
	        return NodeType.isListNode(elm);
	      });
	    };
	    var getSelectedSubLists = function (editor) {
	      var parentList = getParentList(editor);
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      if (isParentListSelected(parentList, selectedBlocks)) {
	        return findSubLists(parentList);
	      } else {
	        return global$5.grep(selectedBlocks, function (elm) {
	          return NodeType.isListNode(elm) && parentList !== elm;
	        });
	      }
	    };
	    var findParentListItemsNodes = function (editor, elms) {
	      var listItemsElms = global$5.map(elms, function (elm) {
	        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
	        return parentLi ? parentLi : elm;
	      });
	      return global$7.unique(listItemsElms);
	    };
	    var getSelectedListItems = function (editor) {
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      return global$5.grep(findParentListItemsNodes(editor, selectedBlocks), function (block) {
	        return NodeType.isListItemNode(block);
	      });
	    };
	    var getSelectedDlItems = function (editor) {
	      return filter(getSelectedListItems(editor), NodeType.isDlItemNode);
	    };
	    var getClosestListRootElm = function (editor, elm) {
	      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
	      var root = parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
	      return root;
	    };
	    var findLastParentListNode = function (editor, elm) {
	      var parentLists = editor.dom.getParents(elm, 'ol,ul', getClosestListRootElm(editor, elm));
	      return last(parentLists);
	    };
	    var getSelectedLists = function (editor) {
	      var firstList = findLastParentListNode(editor, editor.selection.getStart());
	      var subsequentLists = filter(editor.selection.getSelectedBlocks(), NodeType.isOlUlNode);
	      return firstList.toArray().concat(subsequentLists);
	    };
	    var getSelectedListRoots = function (editor) {
	      var selectedLists = getSelectedLists(editor);
	      return getUniqueListRoots(editor, selectedLists);
	    };
	    var getUniqueListRoots = function (editor, lists) {
	      var listRoots = map(lists, function (list) {
	        return findLastParentListNode(editor, list).getOr(list);
	      });
	      return global$7.unique(listRoots);
	    };
	    var isList = function (editor) {
	      var list = getParentList(editor);
	      return HTMLElement.isPrototypeOf(list);
	    };
	    var Selection = {
	      isList: isList,
	      getParentList: getParentList,
	      getSelectedSubLists: getSelectedSubLists,
	      getSelectedListItems: getSelectedListItems,
	      getClosestListRootElm: getClosestListRootElm,
	      getSelectedDlItems: getSelectedDlItems,
	      getSelectedListRoots: getSelectedListRoots
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Option.some(f(oa.getOrDie(), ob.getOrDie())) : Option.none();
	    };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || domGlobals.document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom());
	      });
	      return Element.fromDom(fragment);
	    };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var keys = Object.keys;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var ELEMENT$1 = ELEMENT;
	    var is = function (element, selector) {
	      var dom = element.dom();
	      if (dom.nodeType !== ELEMENT$1) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$1 = browser.isIE() ? ieContains : regularContains;
	    var is$1 = is;
	
	    var parent = function (element) {
	      return Option.from(element.dom().parentNode).map(Element.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom().childNodes, Element.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom().childNodes;
	      return Option.from(cs[index]).map(Element.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	    var spot = Immutable('element', 'offset');
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var remove = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        domGlobals.console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var clone = function (element) {
	      return foldl(element.dom().attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        domGlobals.console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var set = function (element, property, value) {
	      var dom = element.dom();
	      internalSet(dom, property, value);
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return Element.fromDom(original.dom().cloneNode(isDeep));
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = Element.fromTag(tag);
	      var attributes = clone(original);
	      setAll(nu, attributes);
	      return nu;
	    };
	    var mutate = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      before(original, nu);
	      var children$1 = children(original);
	      append$1(nu, children$1);
	      remove(original);
	      return nu;
	    };
	
	    var joinSegment = function (parent, child) {
	      append(parent.item, child.list);
	    };
	    var joinSegments = function (segments) {
	      for (var i = 1; i < segments.length; i++) {
	        joinSegment(segments[i - 1], segments[i]);
	      }
	    };
	    var appendSegments = function (head$1, tail) {
	      lift2(last(head$1), head(tail), joinSegment);
	    };
	    var createSegment = function (scope, listType) {
	      var segment = {
	        list: Element.fromTag(listType, scope),
	        item: Element.fromTag('li', scope)
	      };
	      append(segment.list, segment.item);
	      return segment;
	    };
	    var createSegments = function (scope, entry, size) {
	      var segments = [];
	      for (var i = 0; i < size; i++) {
	        segments.push(createSegment(scope, entry.listType));
	      }
	      return segments;
	    };
	    var populateSegments = function (segments, entry) {
	      for (var i = 0; i < segments.length - 1; i++) {
	        set(segments[i].item, 'list-style-type', 'none');
	      }
	      last(segments).each(function (segment) {
	        setAll(segment.list, entry.listAttributes);
	        setAll(segment.item, entry.itemAttributes);
	        append$1(segment.item, entry.content);
	      });
	    };
	    var normalizeSegment = function (segment, entry) {
	      if (name(segment.list) !== entry.listType) {
	        segment.list = mutate(segment.list, entry.listType);
	      }
	      setAll(segment.list, entry.listAttributes);
	    };
	    var createItem = function (scope, attr, content) {
	      var item = Element.fromTag('li', scope);
	      setAll(item, attr);
	      append$1(item, content);
	      return item;
	    };
	    var appendItem = function (segment, item) {
	      append(segment.list, item);
	      segment.item = item;
	    };
	    var writeShallow = function (scope, cast, entry) {
	      var newCast = cast.slice(0, entry.depth);
	      last(newCast).each(function (segment) {
	        var item = createItem(scope, entry.itemAttributes, entry.content);
	        appendItem(segment, item);
	        normalizeSegment(segment, entry);
	      });
	      return newCast;
	    };
	    var writeDeep = function (scope, cast, entry) {
	      var segments = createSegments(scope, entry, entry.depth - cast.length);
	      joinSegments(segments);
	      populateSegments(segments, entry);
	      appendSegments(cast, segments);
	      return cast.concat(segments);
	    };
	    var composeList = function (scope, entries) {
	      var cast = foldl(entries, function (cast, entry) {
	        return entry.depth > cast.length ? writeDeep(scope, cast, entry) : writeShallow(scope, cast, entry);
	      }, []);
	      return head(cast).map(function (segment) {
	        return segment.list;
	      });
	    };
	
	    var isList$1 = function (el) {
	      return is$1(el, 'OL,UL');
	    };
	    var hasFirstChildList = function (el) {
	      return firstChild(el).map(isList$1).getOr(false);
	    };
	    var hasLastChildList = function (el) {
	      return lastChild(el).map(isList$1).getOr(false);
	    };
	
	    var isIndented = function (entry) {
	      return entry.depth > 0;
	    };
	    var isSelected = function (entry) {
	      return entry.isSelected;
	    };
	    var cloneItemContent = function (li) {
	      var children$1 = children(li);
	      var content = hasLastChildList(li) ? children$1.slice(0, -1) : children$1;
	      return map(content, deep);
	    };
	    var createEntry = function (li, depth, isSelected) {
	      return parent(li).filter(isElement).map(function (list) {
	        return {
	          depth: depth,
	          isSelected: isSelected,
	          content: cloneItemContent(li),
	          itemAttributes: clone(li),
	          listAttributes: clone(list),
	          listType: name(list)
	        };
	      });
	    };
	
	    var indentEntry = function (indentation, entry) {
	      switch (indentation) {
	      case 'Indent':
	        entry.depth++;
	        break;
	      case 'Outdent':
	        entry.depth--;
	        break;
	      case 'Flatten':
	        entry.depth = 0;
	      }
	    };
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var shallow = function (old, nu) {
	      return nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) {
	          objects[i] = arguments[i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var merge = baseMerge(shallow);
	
	    var cloneListProperties = function (target, source) {
	      target.listType = source.listType;
	      target.listAttributes = merge({}, source.listAttributes);
	    };
	    var previousSiblingEntry = function (entries, start) {
	      var depth = entries[start].depth;
	      for (var i = start - 1; i >= 0; i--) {
	        if (entries[i].depth === depth) {
	          return Option.some(entries[i]);
	        }
	        if (entries[i].depth < depth) {
	          break;
	        }
	      }
	      return Option.none();
	    };
	    var normalizeEntries = function (entries) {
	      each(entries, function (entry, i) {
	        previousSiblingEntry(entries, i).each(function (matchingEntry) {
	          cloneListProperties(entry, matchingEntry);
	        });
	      });
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var parseItem = function (depth, itemSelection, selectionState, item) {
	      return firstChild(item).filter(isList$1).fold(function () {
	        itemSelection.each(function (selection) {
	          if (eq(selection.start, item)) {
	            selectionState.set(true);
	          }
	        });
	        var currentItemEntry = createEntry(item, depth, selectionState.get());
	        itemSelection.each(function (selection) {
	          if (eq(selection.end, item)) {
	            selectionState.set(false);
	          }
	        });
	        var childListEntries = lastChild(item).filter(isList$1).map(function (list) {
	          return parseList(depth, itemSelection, selectionState, list);
	        }).getOr([]);
	        return currentItemEntry.toArray().concat(childListEntries);
	      }, function (list) {
	        return parseList(depth, itemSelection, selectionState, list);
	      });
	    };
	    var parseList = function (depth, itemSelection, selectionState, list) {
	      return bind(children(list), function (element) {
	        var parser = isList$1(element) ? parseList : parseItem;
	        var newDepth = depth + 1;
	        return parser(newDepth, itemSelection, selectionState, element);
	      });
	    };
	    var parseLists = function (lists, itemSelection) {
	      var selectionState = Cell(false);
	      var initialDepth = 0;
	      return map(lists, function (list) {
	        return {
	          sourceList: list,
	          entries: parseList(initialDepth, itemSelection, selectionState, list)
	        };
	      });
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var createTextBlock = function (editor, contentNode) {
	      var dom = editor.dom;
	      var blockElements = editor.schema.getBlockElements();
	      var fragment = dom.createFragment();
	      var node, textBlock, blockName, hasContentNode;
	      if (editor.settings.forced_root_block) {
	        blockName = editor.settings.forced_root_block;
	      }
	      if (blockName) {
	        textBlock = dom.create(blockName);
	        if (textBlock.tagName === editor.settings.forced_root_block) {
	          dom.setAttribs(textBlock, editor.settings.forced_root_block_attrs);
	        }
	        if (!NodeType.isBlock(contentNode.firstChild, blockElements)) {
	          fragment.appendChild(textBlock);
	        }
	      }
	      if (contentNode) {
	        while (node = contentNode.firstChild) {
	          var nodeName = node.nodeName;
	          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
	            hasContentNode = true;
	          }
	          if (NodeType.isBlock(node, blockElements)) {
	            fragment.appendChild(node);
	            textBlock = null;
	          } else {
	            if (blockName) {
	              if (!textBlock) {
	                textBlock = dom.create(blockName);
	                fragment.appendChild(textBlock);
	              }
	              textBlock.appendChild(node);
	            } else {
	              fragment.appendChild(node);
	            }
	          }
	        }
	      }
	      if (!editor.settings.forced_root_block) {
	        fragment.appendChild(dom.create('br'));
	      } else {
	        if (!hasContentNode && (!global$8.ie || global$8.ie > 10)) {
	          textBlock.appendChild(dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      return fragment;
	    };
	
	    var outdentedComposer = function (editor, entries) {
	      return map(entries, function (entry) {
	        var content = fromElements(entry.content);
	        return Element.fromDom(createTextBlock(editor, content.dom()));
	      });
	    };
	    var indentedComposer = function (editor, entries) {
	      normalizeEntries(entries);
	      return composeList(editor.contentDocument, entries).toArray();
	    };
	    var composeEntries = function (editor, entries) {
	      return bind(groupBy(entries, isIndented), function (entries) {
	        var groupIsIndented = head(entries).map(isIndented).getOr(false);
	        return groupIsIndented ? indentedComposer(editor, entries) : outdentedComposer(editor, entries);
	      });
	    };
	    var indentSelectedEntries = function (entries, indentation) {
	      each(filter(entries, isSelected), function (entry) {
	        return indentEntry(indentation, entry);
	      });
	    };
	    var getItemSelection = function (editor) {
	      var selectedListItems = map(Selection.getSelectedListItems(editor), Element.fromDom);
	      return lift2(find(selectedListItems, not(hasFirstChildList)), find(reverse(selectedListItems), not(hasFirstChildList)), function (start, end) {
	        return {
	          start: start,
	          end: end
	        };
	      });
	    };
	    var listsIndentation = function (editor, lists, indentation) {
	      var entrySets = parseLists(lists, getItemSelection(editor));
	      each(entrySets, function (entrySet) {
	        indentSelectedEntries(entrySet.entries, indentation);
	        before$1(entrySet.sourceList, composeEntries(editor, entrySet.entries));
	        remove(entrySet.sourceList);
	      });
	    };
	
	    var DOM$1 = global$6.DOM;
	    var splitList = function (editor, ul, li) {
	      var tmpRng, fragment, bookmarks, node, newBlock;
	      var removeAndKeepBookmarks = function (targetNode) {
	        global$5.each(bookmarks, function (node) {
	          targetNode.parentNode.insertBefore(node, li.parentNode);
	        });
	        DOM$1.remove(targetNode);
	      };
	      bookmarks = DOM$1.select('span[data-mce-type="bookmark"]', ul);
	      newBlock = createTextBlock(editor, li);
	      tmpRng = DOM$1.createRng();
	      tmpRng.setStartAfter(li);
	      tmpRng.setEndAfter(ul);
	      fragment = tmpRng.extractContents();
	      for (node = fragment.firstChild; node; node = node.firstChild) {
	        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
	          DOM$1.remove(node);
	          break;
	        }
	      }
	      if (!editor.dom.isEmpty(fragment)) {
	        DOM$1.insertAfter(fragment, ul);
	      }
	      DOM$1.insertAfter(newBlock, ul);
	      if (NodeType.isEmpty(editor.dom, li.parentNode)) {
	        removeAndKeepBookmarks(li.parentNode);
	      }
	      DOM$1.remove(li);
	      if (NodeType.isEmpty(editor.dom, ul)) {
	        DOM$1.remove(ul);
	      }
	    };
	    var SplitList = { splitList: splitList };
	
	    var outdentDlItem = function (editor, item) {
	      if (is$1(item, 'dd')) {
	        mutate(item, 'dt');
	      } else if (is$1(item, 'dt')) {
	        parent(item).each(function (dl) {
	          return SplitList.splitList(editor, dl.dom(), item.dom());
	        });
	      }
	    };
	    var indentDlItem = function (item) {
	      if (is$1(item, 'dt')) {
	        mutate(item, 'dd');
	      }
	    };
	    var dlIndentation = function (editor, indentation, dlItems) {
	      if (indentation === 'Indent') {
	        each(dlItems, indentDlItem);
	      } else {
	        each(dlItems, function (item) {
	          return outdentDlItem(editor, item);
	        });
	      }
	    };
	
	    var selectionIndentation = function (editor, indentation) {
	      var lists = map(Selection.getSelectedListRoots(editor), Element.fromDom);
	      var dlItems = map(Selection.getSelectedDlItems(editor), Element.fromDom);
	      var isHandled = false;
	      if (lists.length || dlItems.length) {
	        var bookmark = editor.selection.getBookmark();
	        listsIndentation(editor, lists, indentation);
	        dlIndentation(editor, indentation, dlItems);
	        editor.selection.moveToBookmark(bookmark);
	        editor.selection.setRng(Range.normalizeRange(editor.selection.getRng()));
	        editor.nodeChanged();
	        isHandled = true;
	      }
	      return isHandled;
	    };
	    var indentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Indent');
	    };
	    var outdentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Outdent');
	    };
	    var flattenListSelection = function (editor) {
	      return selectionIndentation(editor, 'Flatten');
	    };
	
	    var updateListStyle = function (dom, el, detail) {
	      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
	      dom.setStyle(el, 'list-style-type', type);
	    };
	    var setAttribs = function (elm, attrs) {
	      global$5.each(attrs, function (value, key) {
	        elm.setAttribute(key, value);
	      });
	    };
	    var updateListAttrs = function (dom, el, detail) {
	      setAttribs(el, detail['list-attributes']);
	      global$5.each(dom.select('li', el), function (li) {
	        setAttribs(li, detail['list-item-attributes']);
	      });
	    };
	    var updateListWithDetails = function (dom, el, detail) {
	      updateListStyle(dom, el, detail);
	      updateListAttrs(dom, el, detail);
	    };
	    var removeStyles = function (dom, element, styles) {
	      global$5.each(styles, function (style) {
	        var _a;
	        return dom.setStyle(element, (_a = {}, _a[style] = '', _a));
	      });
	    };
	    var getEndPointNode = function (editor, rng, start, root) {
	      var container, offset;
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (container.nodeType === 1) {
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	      }
	      if (!start && NodeType.isBr(container.nextSibling)) {
	        container = container.nextSibling;
	      }
	      while (container.parentNode !== root) {
	        if (NodeType.isTextBlock(editor, container)) {
	          return container;
	        }
	        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
	          return container;
	        }
	        container = container.parentNode;
	      }
	      return container;
	    };
	    var getSelectedTextBlocks = function (editor, rng, root) {
	      var textBlocks = [], dom = editor.dom;
	      var startNode = getEndPointNode(editor, rng, true, root);
	      var endNode = getEndPointNode(editor, rng, false, root);
	      var block;
	      var siblings = [];
	      for (var node = startNode; node; node = node.nextSibling) {
	        siblings.push(node);
	        if (node === endNode) {
	          break;
	        }
	      }
	      global$5.each(siblings, function (node) {
	        if (NodeType.isTextBlock(editor, node)) {
	          textBlocks.push(node);
	          block = null;
	          return;
	        }
	        if (dom.isBlock(node) || NodeType.isBr(node)) {
	          if (NodeType.isBr(node)) {
	            dom.remove(node);
	          }
	          block = null;
	          return;
	        }
	        var nextSibling = node.nextSibling;
	        if (global$4.isBookmarkNode(node)) {
	          if (NodeType.isTextBlock(editor, nextSibling) || !nextSibling && node.parentNode === root) {
	            block = null;
	            return;
	          }
	        }
	        if (!block) {
	          block = dom.create('p');
	          node.parentNode.insertBefore(block, node);
	          textBlocks.push(block);
	        }
	        block.appendChild(node);
	      });
	      return textBlocks;
	    };
	    var hasCompatibleStyle = function (dom, sib, detail) {
	      var sibStyle = dom.getStyle(sib, 'list-style-type');
	      var detailStyle = detail ? detail['list-style-type'] : '';
	      detailStyle = detailStyle === null ? '' : detailStyle;
	      return sibStyle === detailStyle;
	    };
	    var applyList = function (editor, listName, detail) {
	      if (detail === void 0) {
	        detail = {};
	      }
	      var rng = editor.selection.getRng(true);
	      var bookmark;
	      var listItemName = 'LI';
	      var root = Selection.getClosestListRootElm(editor, editor.selection.getStart(true));
	      var dom = editor.dom;
	      if (dom.getContentEditable(editor.selection.getNode()) === 'false') {
	        return;
	      }
	      listName = listName.toUpperCase();
	      if (listName === 'DL') {
	        listItemName = 'DT';
	      }
	      bookmark = Bookmark.createBookmark(rng);
	      global$5.each(getSelectedTextBlocks(editor, rng, root), function (block) {
	        var listBlock, sibling;
	        sibling = block.previousSibling;
	        if (sibling && NodeType.isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
	          listBlock = sibling;
	          block = dom.rename(block, listItemName);
	          sibling.appendChild(block);
	        } else {
	          listBlock = dom.create(listName);
	          block.parentNode.insertBefore(listBlock, block);
	          listBlock.appendChild(block);
	          block = dom.rename(block, listItemName);
	        }
	        removeStyles(dom, block, [
	          'margin',
	          'margin-right',
	          'margin-bottom',
	          'margin-left',
	          'margin-top',
	          'padding',
	          'padding-right',
	          'padding-bottom',
	          'padding-left',
	          'padding-top'
	        ]);
	        updateListWithDetails(dom, listBlock, detail);
	        mergeWithAdjacentLists(editor.dom, listBlock);
	      });
	      editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	    };
	    var isValidLists = function (list1, list2) {
	      return list1 && list2 && NodeType.isListNode(list1) && list1.nodeName === list2.nodeName;
	    };
	    var hasSameListStyle = function (dom, list1, list2) {
	      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
	      var style = dom.getStyle(list2, 'list-style-type', true);
	      return targetStyle === style;
	    };
	    var hasSameClasses = function (elm1, elm2) {
	      return elm1.className === elm2.className;
	    };
	    var shouldMerge = function (dom, list1, list2) {
	      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
	    };
	    var mergeWithAdjacentLists = function (dom, listBlock) {
	      var sibling, node;
	      sibling = listBlock.nextSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.firstChild) {
	          listBlock.appendChild(node);
	        }
	        dom.remove(sibling);
	      }
	      sibling = listBlock.previousSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.lastChild) {
	          listBlock.insertBefore(node, listBlock.firstChild);
	        }
	        dom.remove(sibling);
	      }
	    };
	    var updateList = function (dom, list, listName, detail) {
	      if (list.nodeName !== listName) {
	        var newList = dom.rename(list, listName);
	        updateListWithDetails(dom, newList, detail);
	      } else {
	        updateListWithDetails(dom, list, detail);
	      }
	    };
	    var toggleMultipleLists = function (editor, parentList, lists, listName, detail) {
	      if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	        flattenListSelection(editor);
	      } else {
	        var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	        global$5.each([parentList].concat(lists), function (elm) {
	          updateList(editor.dom, elm, listName, detail);
	        });
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	    var hasListStyleDetail = function (detail) {
	      return 'list-style-type' in detail;
	    };
	    var toggleSingleList = function (editor, parentList, listName, detail) {
	      if (parentList === editor.getBody()) {
	        return;
	      }
	      if (parentList) {
	        if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	          flattenListSelection(editor);
	        } else {
	          var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	          updateListWithDetails(editor.dom, parentList, detail);
	          mergeWithAdjacentLists(editor.dom, editor.dom.rename(parentList, listName));
	          editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	        }
	      } else {
	        applyList(editor, listName, detail);
	      }
	    };
	    var toggleList = function (editor, listName, detail) {
	      var parentList = Selection.getParentList(editor);
	      var selectedSubLists = Selection.getSelectedSubLists(editor);
	      detail = detail ? detail : {};
	      if (parentList && selectedSubLists.length > 0) {
	        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
	      } else {
	        toggleSingleList(editor, parentList, listName, detail);
	      }
	    };
	    var ToggleList = {
	      toggleList: toggleList,
	      mergeWithAdjacentLists: mergeWithAdjacentLists
	    };
	
	    var DOM$2 = global$6.DOM;
	    var normalizeList = function (dom, ul) {
	      var sibling;
	      var parentNode = ul.parentNode;
	      if (parentNode.nodeName === 'LI' && parentNode.firstChild === ul) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	          if (NodeType.isEmpty(dom, parentNode)) {
	            DOM$2.remove(parentNode);
	          }
	        } else {
	          DOM$2.setStyle(parentNode, 'listStyleType', 'none');
	        }
	      }
	      if (NodeType.isListNode(parentNode)) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	        }
	      }
	    };
	    var normalizeLists = function (dom, element) {
	      global$5.each(global$5.grep(dom.select('ol,ul', element)), function (ul) {
	        normalizeList(dom, ul);
	      });
	    };
	    var NormalizeLists = {
	      normalizeList: normalizeList,
	      normalizeLists: normalizeLists
	    };
	
	    var findNextCaretContainer = function (editor, rng, isForward, root) {
	      var node = rng.startContainer;
	      var offset = rng.startOffset;
	      var nonEmptyBlocks, walker;
	      if (node.nodeType === 3 && (isForward ? offset < node.data.length : offset > 0)) {
	        return node;
	      }
	      nonEmptyBlocks = editor.schema.getNonEmptyElements();
	      if (node.nodeType === 1) {
	        node = global$1.getNode(node, offset);
	      }
	      walker = new global$2(node, root);
	      if (isForward) {
	        if (NodeType.isBogusBr(editor.dom, node)) {
	          walker.next();
	        }
	      }
	      while (node = walker[isForward ? 'next' : 'prev2']()) {
	        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
	          return node;
	        }
	        if (nonEmptyBlocks[node.nodeName]) {
	          return node;
	        }
	        if (node.nodeType === 3 && node.data.length > 0) {
	          return node;
	        }
	      }
	    };
	    var hasOnlyOneBlockChild = function (dom, elm) {
	      var childNodes = elm.childNodes;
	      return childNodes.length === 1 && !NodeType.isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
	    };
	    var unwrapSingleBlockChild = function (dom, elm) {
	      if (hasOnlyOneBlockChild(dom, elm)) {
	        dom.remove(elm.firstChild, true);
	      }
	    };
	    var moveChildren = function (dom, fromElm, toElm) {
	      var node, targetElm;
	      targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
	      unwrapSingleBlockChild(dom, fromElm);
	      if (!NodeType.isEmpty(dom, fromElm, true)) {
	        while (node = fromElm.firstChild) {
	          targetElm.appendChild(node);
	        }
	      }
	    };
	    var mergeLiElements = function (dom, fromElm, toElm) {
	      var node, listNode;
	      var ul = fromElm.parentNode;
	      if (!NodeType.isChildOfBody(dom, fromElm) || !NodeType.isChildOfBody(dom, toElm)) {
	        return;
	      }
	      if (NodeType.isListNode(toElm.lastChild)) {
	        listNode = toElm.lastChild;
	      }
	      if (ul === toElm.lastChild) {
	        if (NodeType.isBr(ul.previousSibling)) {
	          dom.remove(ul.previousSibling);
	        }
	      }
	      node = toElm.lastChild;
	      if (node && NodeType.isBr(node) && fromElm.hasChildNodes()) {
	        dom.remove(node);
	      }
	      if (NodeType.isEmpty(dom, toElm, true)) {
	        dom.$(toElm).empty();
	      }
	      moveChildren(dom, fromElm, toElm);
	      if (listNode) {
	        toElm.appendChild(listNode);
	      }
	      var contains = contains$1(Element.fromDom(toElm), Element.fromDom(fromElm));
	      var nestedLists = contains ? dom.getParents(fromElm, NodeType.isListNode, toElm) : [];
	      dom.remove(fromElm);
	      each(nestedLists, function (list) {
	        if (NodeType.isEmpty(dom, list) && list !== dom.getRoot()) {
	          dom.remove(list);
	        }
	      });
	    };
	    var mergeIntoEmptyLi = function (editor, fromLi, toLi) {
	      editor.dom.$(toLi).empty();
	      mergeLiElements(editor.dom, fromLi, toLi);
	      editor.selection.setCursorLocation(toLi);
	    };
	    var mergeForward = function (editor, rng, fromLi, toLi) {
	      var dom = editor.dom;
	      if (dom.isEmpty(toLi)) {
	        mergeIntoEmptyLi(editor, fromLi, toLi);
	      } else {
	        var bookmark = Bookmark.createBookmark(rng);
	        mergeLiElements(dom, fromLi, toLi);
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	    var mergeBackward = function (editor, rng, fromLi, toLi) {
	      var bookmark = Bookmark.createBookmark(rng);
	      mergeLiElements(editor.dom, fromLi, toLi);
	      var resolvedBookmark = Bookmark.resolveBookmark(bookmark);
	      editor.selection.setRng(resolvedBookmark);
	    };
	    var backspaceDeleteFromListToListCaret = function (editor, isForward) {
	      var dom = editor.dom, selection = editor.selection;
	      var selectionStartElm = selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var li = dom.getParent(selection.getStart(), 'LI', root);
	      var ul, rng, otherLi;
	      if (li) {
	        ul = li.parentNode;
	        if (ul === editor.getBody() && NodeType.isEmpty(dom, ul)) {
	          return true;
	        }
	        rng = Range.normalizeRange(selection.getRng(true));
	        otherLi = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	        if (otherLi && otherLi !== li) {
	          if (isForward) {
	            mergeForward(editor, rng, otherLi, li);
	          } else {
	            mergeBackward(editor, rng, li, otherLi);
	          }
	          return true;
	        } else if (!otherLi) {
	          if (!isForward) {
	            flattenListSelection(editor);
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var removeBlock = function (dom, block, root) {
	      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
	      dom.remove(block);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        dom.remove(parentBlock);
	      }
	    };
	    var backspaceDeleteIntoListCaret = function (editor, isForward) {
	      var dom = editor.dom;
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
	      if (block && dom.isEmpty(block)) {
	        var rng = Range.normalizeRange(editor.selection.getRng(true));
	        var otherLi_1 = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	        if (otherLi_1) {
	          editor.undoManager.transact(function () {
	            removeBlock(dom, block, root);
	            ToggleList.mergeWithAdjacentLists(dom, otherLi_1.parentNode);
	            editor.selection.select(otherLi_1, true);
	            editor.selection.collapse(isForward);
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var backspaceDeleteCaret = function (editor, isForward) {
	      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
	    };
	    var backspaceDeleteRange = function (editor) {
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
	      if (startListParent || Selection.getSelectedListItems(editor).length > 0) {
	        editor.undoManager.transact(function () {
	          editor.execCommand('Delete');
	          NormalizeLists.normalizeLists(editor.dom, editor.getBody());
	        });
	        return true;
	      }
	      return false;
	    };
	    var backspaceDelete = function (editor, isForward) {
	      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
	    };
	    var setup = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode === global$3.BACKSPACE) {
	          if (backspaceDelete(editor, false)) {
	            e.preventDefault();
	          }
	        } else if (e.keyCode === global$3.DELETE) {
	          if (backspaceDelete(editor, true)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	    var Delete = {
	      setup: setup,
	      backspaceDelete: backspaceDelete
	    };
	
	    var get = function (editor) {
	      return {
	        backspaceDelete: function (isForward) {
	          Delete.backspaceDelete(editor, isForward);
	        }
	      };
	    };
	    var Api = { get: get };
	
	    var queryListCommandState = function (editor, listName) {
	      return function () {
	        var parentList = editor.dom.getParent(editor.selection.getStart(), 'UL,OL,DL');
	        return parentList && parentList.nodeName === listName;
	      };
	    };
	    var register = function (editor) {
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command.toLowerCase();
	        if (cmd === 'indent') {
	          indentListSelection(editor);
	        } else if (cmd === 'outdent') {
	          outdentListSelection(editor);
	        }
	      });
	      editor.addCommand('InsertUnorderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'UL', detail);
	      });
	      editor.addCommand('InsertOrderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'OL', detail);
	      });
	      editor.addCommand('InsertDefinitionList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'DL', detail);
	      });
	      editor.addCommand('RemoveList', function () {
	        flattenListSelection(editor);
	      });
	      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
	      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
	      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
	    };
	    var Commands = { register: register };
	
	    var shouldIndentOnTab = function (editor) {
	      return editor.getParam('lists_indent_on_tab', true);
	    };
	    var Settings = { shouldIndentOnTab: shouldIndentOnTab };
	
	    var setupTabKey = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode !== global$3.TAB || global$3.metaKeyPressed(e)) {
	          return;
	        }
	        editor.undoManager.transact(function () {
	          if (e.shiftKey ? outdentListSelection(editor) : indentListSelection(editor)) {
	            e.preventDefault();
	          }
	        });
	      });
	    };
	    var setup$1 = function (editor) {
	      if (Settings.shouldIndentOnTab(editor)) {
	        setupTabKey(editor);
	      }
	      Delete.setup(editor);
	    };
	    var Keyboard = { setup: setup$1 };
	
	    var findIndex = function (list, predicate) {
	      for (var index = 0; index < list.length; index++) {
	        var element = list[index];
	        if (predicate(element)) {
	          return index;
	        }
	      }
	      return -1;
	    };
	    var listState = function (editor, listName) {
	      return function (e) {
	        var ctrl = e.control;
	        editor.on('NodeChange', function (e) {
	          var tableCellIndex = findIndex(e.parents, NodeType.isTableCellNode);
	          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
	          var lists = global$5.grep(parents, NodeType.isListNode);
	          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
	        });
	      };
	    };
	    var register$1 = function (editor) {
	      var hasPlugin = function (editor, plugin) {
	        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
	        return global$5.inArray(plugins.split(/[ ,]/), plugin) !== -1;
	      };
	      if (!hasPlugin(editor, 'advlist')) {
	        editor.addButton('numlist', {
	          active: false,
	          title: 'Numbered list',
	          cmd: 'InsertOrderedList',
	          onPostRender: listState(editor, 'OL')
	        });
	        editor.addButton('bullist', {
	          active: false,
	          title: 'Bullet list',
	          cmd: 'InsertUnorderedList',
	          onPostRender: listState(editor, 'UL')
	        });
	      }
	      editor.addButton('indent', {
	        icon: 'indent',
	        title: 'Increase indent',
	        cmd: 'Indent'
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('lists', function (editor) {
	      Keyboard.setup(editor);
	      Buttons.register(editor);
	      Commands.register(editor);
	      return Api.get(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {(function () {
	var paste = (function (domGlobals) {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      var clone = function () {
	        return Cell(get());
	      };
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasProPlugin = function (editor) {
	      if (/(^|[ ,])powerpaste([, ]|$)/.test(editor.settings.plugins) && global$1.get('powerpaste')) {
	        if (typeof domGlobals.window.console !== 'undefined' && domGlobals.window.console.log) {
	          domGlobals.window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var DetectProPlugin = { hasProPlugin: hasProPlugin };
	
	    var get = function (clipboard, quirks) {
	      return {
	        clipboard: clipboard,
	        quirks: quirks
	      };
	    };
	    var Api = { get: get };
	
	    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
	      return editor.fire('PastePreProcess', {
	        content: html,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
	      return editor.fire('PastePostProcess', {
	        node: node,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePlainTextToggle = function (editor, state) {
	      return editor.fire('PastePlainTextToggle', { state: state });
	    };
	    var firePaste = function (editor, ieFake) {
	      return editor.fire('paste', { ieFake: ieFake });
	    };
	    var Events = {
	      firePastePreProcess: firePastePreProcess,
	      firePastePostProcess: firePastePostProcess,
	      firePastePlainTextToggle: firePastePlainTextToggle,
	      firePaste: firePaste
	    };
	
	    var shouldPlainTextInform = function (editor) {
	      return editor.getParam('paste_plaintext_inform', true);
	    };
	    var shouldBlockDrop = function (editor) {
	      return editor.getParam('paste_block_drop', false);
	    };
	    var shouldPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false);
	    };
	    var shouldFilterDrop = function (editor) {
	      return editor.getParam('paste_filter_drop', true);
	    };
	    var getPreProcess = function (editor) {
	      return editor.getParam('paste_preprocess');
	    };
	    var getPostProcess = function (editor) {
	      return editor.getParam('paste_postprocess');
	    };
	    var getWebkitStyles = function (editor) {
	      return editor.getParam('paste_webkit_styles');
	    };
	    var shouldRemoveWebKitStyles = function (editor) {
	      return editor.getParam('paste_remove_styles_if_webkit', true);
	    };
	    var shouldMergeFormats = function (editor) {
	      return editor.getParam('paste_merge_formats', true);
	    };
	    var isSmartPasteEnabled = function (editor) {
	      return editor.getParam('smart_paste', true);
	    };
	    var isPasteAsTextEnabled = function (editor) {
	      return editor.getParam('paste_as_text', false);
	    };
	    var getRetainStyleProps = function (editor) {
	      return editor.getParam('paste_retain_style_properties');
	    };
	    var getWordValidElements = function (editor) {
	      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
	      return editor.getParam('paste_word_valid_elements', defaultValidElements);
	    };
	    var shouldConvertWordFakeLists = function (editor) {
	      return editor.getParam('paste_convert_word_fake_lists', true);
	    };
	    var shouldUseDefaultFilters = function (editor) {
	      return editor.getParam('paste_enable_default_filters', true);
	    };
	    var Settings = {
	      shouldPlainTextInform: shouldPlainTextInform,
	      shouldBlockDrop: shouldBlockDrop,
	      shouldPasteDataImages: shouldPasteDataImages,
	      shouldFilterDrop: shouldFilterDrop,
	      getPreProcess: getPreProcess,
	      getPostProcess: getPostProcess,
	      getWebkitStyles: getWebkitStyles,
	      shouldRemoveWebKitStyles: shouldRemoveWebKitStyles,
	      shouldMergeFormats: shouldMergeFormats,
	      isSmartPasteEnabled: isSmartPasteEnabled,
	      isPasteAsTextEnabled: isPasteAsTextEnabled,
	      getRetainStyleProps: getRetainStyleProps,
	      getWordValidElements: getWordValidElements,
	      shouldConvertWordFakeLists: shouldConvertWordFakeLists,
	      shouldUseDefaultFilters: shouldUseDefaultFilters
	    };
	
	    var shouldInformUserAboutPlainText = function (editor, userIsInformedState) {
	      return userIsInformedState.get() === false && Settings.shouldPlainTextInform(editor);
	    };
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        text: editor.translate(message),
	        type: 'info'
	      });
	    };
	    var togglePlainTextPaste = function (editor, clipboard, userIsInformedState) {
	      if (clipboard.pasteFormat.get() === 'text') {
	        clipboard.pasteFormat.set('html');
	        Events.firePastePlainTextToggle(editor, false);
	      } else {
	        clipboard.pasteFormat.set('text');
	        Events.firePastePlainTextToggle(editor, true);
	        if (shouldInformUserAboutPlainText(editor, userIsInformedState)) {
	          displayNotification(editor, 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.');
	          userIsInformedState.set(true);
	        }
	      }
	      editor.focus();
	    };
	    var Actions = { togglePlainTextPaste: togglePlainTextPaste };
	
	    var register = function (editor, clipboard, userIsInformedState) {
	      editor.addCommand('mceTogglePlainTextPaste', function () {
	        Actions.togglePlainTextPaste(editor, clipboard, userIsInformedState);
	      });
	      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
	        if (value.content) {
	          clipboard.pasteHtml(value.content, value.internal);
	        }
	        if (value.text) {
	          clipboard.pasteText(value.text);
	        }
	      });
	    };
	    var Commands = { register: register };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var internalMimeType = 'x-tinymce/html';
	    var internalMark = '<!-- ' + internalMimeType + ' -->';
	    var mark = function (html) {
	      return internalMark + html;
	    };
	    var unmark = function (html) {
	      return html.replace(internalMark, '');
	    };
	    var isMarked = function (html) {
	      return html.indexOf(internalMark) !== -1;
	    };
	    var InternalHtml = {
	      mark: mark,
	      unmark: unmark,
	      isMarked: isMarked,
	      internalHtmlMime: function () {
	        return internalMimeType;
	      }
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var isPlainText = function (text) {
	      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
	    };
	    var toBRs = function (text) {
	      return text.replace(/\r?\n/g, '<br>');
	    };
	    var openContainer = function (rootTag, rootAttrs) {
	      var key;
	      var attrs = [];
	      var tag = '<' + rootTag;
	      if (typeof rootAttrs === 'object') {
	        for (key in rootAttrs) {
	          if (rootAttrs.hasOwnProperty(key)) {
	            attrs.push(key + '="' + global$6.encodeAllRaw(rootAttrs[key]) + '"');
	          }
	        }
	        if (attrs.length) {
	          tag += ' ' + attrs.join(' ');
	        }
	      }
	      return tag + '>';
	    };
	    var toBlockElements = function (text, rootTag, rootAttrs) {
	      var blocks = text.split(/\n\n/);
	      var tagOpen = openContainer(rootTag, rootAttrs);
	      var tagClose = '</' + rootTag + '>';
	      var paragraphs = global$4.map(blocks, function (p) {
	        return p.split(/\n/).join('<br />');
	      });
	      var stitch = function (p) {
	        return tagOpen + p + tagClose;
	      };
	      return paragraphs.length === 1 ? paragraphs[0] : global$4.map(paragraphs, stitch).join('');
	    };
	    var convert = function (text, rootTag, rootAttrs) {
	      return rootTag ? toBlockElements(text, rootTag, rootAttrs) : toBRs(text);
	    };
	    var Newlines = {
	      isPlainText: isPlainText,
	      convert: convert,
	      toBRs: toBRs,
	      toBlockElements: toBlockElements
	    };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.DomParser');
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Serializer');
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    function filter(content, items) {
	      global$4.each(items, function (v) {
	        if (v.constructor === RegExp) {
	          content = content.replace(v, '');
	        } else {
	          content = content.replace(v[0], v[1]);
	        }
	      });
	      return content;
	    }
	    function innerText(html) {
	      var schema = global$a();
	      var domParser = global$7({}, schema);
	      var text = '';
	      var shortEndedElements = schema.getShortEndedElements();
	      var ignoreElements = global$4.makeMap('script noscript style textarea video audio iframe object', ' ');
	      var blockElements = schema.getBlockElements();
	      function walk(node) {
	        var name = node.name, currentNode = node;
	        if (name === 'br') {
	          text += '\n';
	          return;
	        }
	        if (name === 'wbr') {
	          return;
	        }
	        if (shortEndedElements[name]) {
	          text += ' ';
	        }
	        if (ignoreElements[name]) {
	          text += ' ';
	          return;
	        }
	        if (node.type === 3) {
	          text += node.value;
	        }
	        if (!node.shortEnded) {
	          if (node = node.firstChild) {
	            do {
	              walk(node);
	            } while (node = node.next);
	          }
	        }
	        if (blockElements[name] && currentNode.next) {
	          text += '\n';
	          if (name === 'p') {
	            text += '\n';
	          }
	        }
	      }
	      html = filter(html, [/<!\[[^\]]+\]>/g]);
	      walk(domParser.parse(html));
	      return text;
	    }
	    function trimHtml(html) {
	      function trimSpaces(all, s1, s2) {
	        if (!s1 && !s2) {
	          return ' ';
	        }
	        return '\xA0';
	      }
	      html = filter(html, [
	        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
	        /<!--StartFragment-->|<!--EndFragment-->/g,
	        [
	          /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
	          trimSpaces
	        ],
	        /<br class="Apple-interchange-newline">/g,
	        /<br>$/i
	      ]);
	      return html;
	    }
	    function createIdGenerator(prefix) {
	      var count = 0;
	      return function () {
	        return prefix + count++;
	      };
	    }
	    var isMsEdge = function () {
	      return domGlobals.navigator.userAgent.indexOf(' Edge/') !== -1;
	    };
	    var Utils = {
	      filter: filter,
	      innerText: innerText,
	      trimHtml: trimHtml,
	      createIdGenerator: createIdGenerator,
	      isMsEdge: isMsEdge
	    };
	
	    function isWordContent(content) {
	      return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content);
	    }
	    function isNumericList(text) {
	      var found, patterns;
	      patterns = [
	        /^[IVXLMCD]{1,2}\.[ \u00a0]/,
	        /^[ivxlmcd]{1,2}\.[ \u00a0]/,
	        /^[a-z]{1,2}[\.\)][ \u00a0]/,
	        /^[A-Z]{1,2}[\.\)][ \u00a0]/,
	        /^[0-9]+\.[ \u00a0]/,
	        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
	        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
	      ];
	      text = text.replace(/^[\u00a0 ]+/, '');
	      global$4.each(patterns, function (pattern) {
	        if (pattern.test(text)) {
	          found = true;
	          return false;
	        }
	      });
	      return found;
	    }
	    function isBulletList(text) {
	      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
	    }
	    function convertFakeListsToProperLists(node) {
	      var currentListNode, prevListNode, lastLevel = 1;
	      function getText(node) {
	        var txt = '';
	        if (node.type === 3) {
	          return node.value;
	        }
	        if (node = node.firstChild) {
	          do {
	            txt += getText(node);
	          } while (node = node.next);
	        }
	        return txt;
	      }
	      function trimListStart(node, regExp) {
	        if (node.type === 3) {
	          if (regExp.test(node.value)) {
	            node.value = node.value.replace(regExp, '');
	            return false;
	          }
	        }
	        if (node = node.firstChild) {
	          do {
	            if (!trimListStart(node, regExp)) {
	              return false;
	            }
	          } while (node = node.next);
	        }
	        return true;
	      }
	      function removeIgnoredNodes(node) {
	        if (node._listIgnore) {
	          node.remove();
	          return;
	        }
	        if (node = node.firstChild) {
	          do {
	            removeIgnoredNodes(node);
	          } while (node = node.next);
	        }
	      }
	      function convertParagraphToLi(paragraphNode, listName, start) {
	        var level = paragraphNode._listLevel || lastLevel;
	        if (level !== lastLevel) {
	          if (level < lastLevel) {
	            if (currentListNode) {
	              currentListNode = currentListNode.parent.parent;
	            }
	          } else {
	            prevListNode = currentListNode;
	            currentListNode = null;
	          }
	        }
	        if (!currentListNode || currentListNode.name !== listName) {
	          prevListNode = prevListNode || currentListNode;
	          currentListNode = new global$9(listName, 1);
	          if (start > 1) {
	            currentListNode.attr('start', '' + start);
	          }
	          paragraphNode.wrap(currentListNode);
	        } else {
	          currentListNode.append(paragraphNode);
	        }
	        paragraphNode.name = 'li';
	        if (level > lastLevel && prevListNode) {
	          prevListNode.lastChild.append(currentListNode);
	        }
	        lastLevel = level;
	        removeIgnoredNodes(paragraphNode);
	        trimListStart(paragraphNode, /^\u00a0+/);
	        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
	        trimListStart(paragraphNode, /^\u00a0+/);
	      }
	      var elements = [];
	      var child = node.firstChild;
	      while (typeof child !== 'undefined' && child !== null) {
	        elements.push(child);
	        child = child.walk();
	        if (child !== null) {
	          while (typeof child !== 'undefined' && child.parent !== node) {
	            child = child.walk();
	          }
	        }
	      }
	      for (var i = 0; i < elements.length; i++) {
	        node = elements[i];
	        if (node.name === 'p' && node.firstChild) {
	          var nodeText = getText(node);
	          if (isBulletList(nodeText)) {
	            convertParagraphToLi(node, 'ul');
	            continue;
	          }
	          if (isNumericList(nodeText)) {
	            var matches = /([0-9]+)\./.exec(nodeText);
	            var start = 1;
	            if (matches) {
	              start = parseInt(matches[1], 10);
	            }
	            convertParagraphToLi(node, 'ol', start);
	            continue;
	          }
	          if (node._listLevel) {
	            convertParagraphToLi(node, 'ul', 1);
	            continue;
	          }
	          currentListNode = null;
	        } else {
	          prevListNode = currentListNode;
	          currentListNode = null;
	        }
	      }
	    }
	    function filterStyles(editor, validStyles, node, styleValue) {
	      var outputStyles = {}, matches;
	      var styles = editor.dom.parseStyle(styleValue);
	      global$4.each(styles, function (value, name) {
	        switch (name) {
	        case 'mso-list':
	          matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
	          if (matches) {
	            node._listLevel = parseInt(matches[1], 10);
	          }
	          if (/Ignore/i.test(value) && node.firstChild) {
	            node._listIgnore = true;
	            node.firstChild._listIgnore = true;
	          }
	          break;
	        case 'horiz-align':
	          name = 'text-align';
	          break;
	        case 'vert-align':
	          name = 'vertical-align';
	          break;
	        case 'font-color':
	        case 'mso-foreground':
	          name = 'color';
	          break;
	        case 'mso-background':
	        case 'mso-highlight':
	          name = 'background';
	          break;
	        case 'font-weight':
	        case 'font-style':
	          if (value !== 'normal') {
	            outputStyles[name] = value;
	          }
	          return;
	        case 'mso-element':
	          if (/^(comment|comment-list)$/i.test(value)) {
	            node.remove();
	            return;
	          }
	          break;
	        }
	        if (name.indexOf('mso-comment') === 0) {
	          node.remove();
	          return;
	        }
	        if (name.indexOf('mso-') === 0) {
	          return;
	        }
	        if (Settings.getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
	          outputStyles[name] = value;
	        }
	      });
	      if (/(bold)/i.test(outputStyles['font-weight'])) {
	        delete outputStyles['font-weight'];
	        node.wrap(new global$9('b', 1));
	      }
	      if (/(italic)/i.test(outputStyles['font-style'])) {
	        delete outputStyles['font-style'];
	        node.wrap(new global$9('i', 1));
	      }
	      outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
	      if (outputStyles) {
	        return outputStyles;
	      }
	      return null;
	    }
	    var filterWordContent = function (editor, content) {
	      var retainStyleProperties, validStyles;
	      retainStyleProperties = Settings.getRetainStyleProps(editor);
	      if (retainStyleProperties) {
	        validStyles = global$4.makeMap(retainStyleProperties.split(/[, ]/));
	      }
	      content = Utils.filter(content, [
	        /<br class="?Apple-interchange-newline"?>/gi,
	        /<b[^>]+id="?docs-internal-[^>]*>/gi,
	        /<!--[\s\S]+?-->/gi,
	        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	        [
	          /<(\/?)s>/gi,
	          '<$1strike>'
	        ],
	        [
	          /&nbsp;/gi,
	          '\xA0'
	        ],
	        [
	          /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
	          function (str, spaces) {
	            return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join('\xA0') : '';
	          }
	        ]
	      ]);
	      var validElements = Settings.getWordValidElements(editor);
	      var schema = global$a({
	        valid_elements: validElements,
	        valid_children: '-li[p]'
	      });
	      global$4.each(schema.elements, function (rule) {
	        if (!rule.attributes.class) {
	          rule.attributes.class = {};
	          rule.attributesOrder.push('class');
	        }
	        if (!rule.attributes.style) {
	          rule.attributes.style = {};
	          rule.attributesOrder.push('style');
	        }
	      });
	      var domParser = global$7({}, schema);
	      domParser.addAttributeFilter('style', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
	          if (node.name === 'span' && node.parent && !node.attributes.length) {
	            node.unwrap();
	          }
	        }
	      });
	      domParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, className;
	        while (i--) {
	          node = nodes[i];
	          className = node.attr('class');
	          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
	            node.remove();
	          }
	          node.attr('class', null);
	        }
	      });
	      domParser.addNodeFilter('del', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].remove();
	        }
	      });
	      domParser.addNodeFilter('a', function (nodes) {
	        var i = nodes.length, node, href, name;
	        while (i--) {
	          node = nodes[i];
	          href = node.attr('href');
	          name = node.attr('name');
	          if (href && href.indexOf('#_msocom_') !== -1) {
	            node.remove();
	            continue;
	          }
	          if (href && href.indexOf('file://') === 0) {
	            href = href.split('#')[1];
	            if (href) {
	              href = '#' + href;
	            }
	          }
	          if (!href && !name) {
	            node.unwrap();
	          } else {
	            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
	              node.unwrap();
	              continue;
	            }
	            node.attr({
	              href: href,
	              name: name
	            });
	          }
	        }
	      });
	      var rootNode = domParser.parse(content);
	      if (Settings.shouldConvertWordFakeLists(editor)) {
	        convertFakeListsToProperLists(rootNode);
	      }
	      content = global$8({ validate: editor.settings.validate }, schema).serialize(rootNode);
	      return content;
	    };
	    var preProcess = function (editor, content) {
	      return Settings.shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
	    };
	    var WordFilter = {
	      preProcess: preProcess,
	      isWordContent: isWordContent
	    };
	
	    var preProcess$1 = function (editor, html) {
	      var parser = global$7({}, editor.schema);
	      parser.addNodeFilter('meta', function (nodes) {
	        global$4.each(nodes, function (node) {
	          return node.remove();
	        });
	      });
	      var fragment = parser.parse(html, {
	        forced_root_block: false,
	        isRootContent: true
	      });
	      return global$8({ validate: editor.settings.validate }, editor.schema).serialize(fragment);
	    };
	    var processResult = function (content, cancelled) {
	      return {
	        content: content,
	        cancelled: cancelled
	      };
	    };
	    var postProcessFilter = function (editor, html, internal, isWordHtml) {
	      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
	      var postProcessArgs = Events.firePastePostProcess(editor, tempBody, internal, isWordHtml);
	      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
	    };
	    var filterContent = function (editor, content, internal, isWordHtml) {
	      var preProcessArgs = Events.firePastePreProcess(editor, content, internal, isWordHtml);
	      var filteredContent = preProcess$1(editor, preProcessArgs.content);
	      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
	        return postProcessFilter(editor, filteredContent, internal, isWordHtml);
	      } else {
	        return processResult(filteredContent, preProcessArgs.isDefaultPrevented());
	      }
	    };
	    var process = function (editor, html, internal) {
	      var isWordHtml = WordFilter.isWordContent(html);
	      var content = isWordHtml ? WordFilter.preProcess(editor, html) : html;
	      return filterContent(editor, content, internal, isWordHtml);
	    };
	    var ProcessFilters = { process: process };
	
	    var pasteHtml = function (editor, html) {
	      editor.insertContent(html, {
	        merge: Settings.shouldMergeFormats(editor),
	        paste: true
	      });
	      return true;
	    };
	    var isAbsoluteUrl = function (url) {
	      return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
	    };
	    var isImageUrl = function (url) {
	      return isAbsoluteUrl(url) && /.(gif|jpe?g|png)$/.test(url);
	    };
	    var createImage = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.insertContent('<img src="' + url + '">');
	      });
	      return true;
	    };
	    var createLink = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.execCommand('mceInsertLink', false, url);
	      });
	      return true;
	    };
	    var linkSelection = function (editor, html, pasteHtmlFn) {
	      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
	    };
	    var insertImage = function (editor, html, pasteHtmlFn) {
	      return isImageUrl(html) ? createImage(editor, html, pasteHtmlFn) : false;
	    };
	    var smartInsertContent = function (editor, html) {
	      global$4.each([
	        linkSelection,
	        insertImage,
	        pasteHtml
	      ], function (action) {
	        return action(editor, html, pasteHtml) !== true;
	      });
	    };
	    var insertContent = function (editor, html) {
	      if (Settings.isSmartPasteEnabled(editor) === false) {
	        pasteHtml(editor, html);
	      } else {
	        smartInsertContent(editor, html);
	      }
	    };
	    var SmartPaste = {
	      isImageUrl: isImageUrl,
	      isAbsoluteUrl: isAbsoluteUrl,
	      insertContent: insertContent
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isFunction = isType('function');
	
	    var nativeSlice = Array.prototype.slice;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter$1 = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var exports$1 = {}, module = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module, undefined));
	    var Promise = module.exports.boltExport;
	
	    var nu = function (baseFn) {
	      var data = Option.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        data = Option.some(x);
	        run(callbacks);
	        callbacks = [];
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          domGlobals.setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      domGlobals.setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$1 = function (baseFn) {
	      return make(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$1,
	      pure: pure$1
	    };
	
	    var par = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par$1 = function (futures) {
	      return par(futures, Future.nu);
	    };
	    var traverse = function (array, fn) {
	      return par$1(map(array, fn));
	    };
	    var mapM = traverse;
	
	    var value = function () {
	      var subject = Cell(Option.none());
	      var clear = function () {
	        subject.set(Option.none());
	      };
	      var set = function (s) {
	        subject.set(Option.some(s));
	      };
	      var on = function (f) {
	        subject.get().each(f);
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var pasteHtml$1 = function (editor, html, internalFlag) {
	      var internal = internalFlag ? internalFlag : InternalHtml.isMarked(html);
	      var args = ProcessFilters.process(editor, InternalHtml.unmark(html), internal);
	      if (args.cancelled === false) {
	        SmartPaste.insertContent(editor, args.content);
	      }
	    };
	    var pasteText = function (editor, text) {
	      text = editor.dom.encode(text).replace(/\r\n/g, '\n');
	      text = Newlines.convert(text, editor.settings.forced_root_block, editor.settings.forced_root_block_attrs);
	      pasteHtml$1(editor, text, false);
	    };
	    var getDataTransferItems = function (dataTransfer) {
	      var items = {};
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      if (dataTransfer) {
	        if (dataTransfer.getData) {
	          var legacyText = dataTransfer.getData('Text');
	          if (legacyText && legacyText.length > 0) {
	            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
	              items['text/plain'] = legacyText;
	            }
	          }
	        }
	        if (dataTransfer.types) {
	          for (var i = 0; i < dataTransfer.types.length; i++) {
	            var contentType = dataTransfer.types[i];
	            try {
	              items[contentType] = dataTransfer.getData(contentType);
	            } catch (ex) {
	              items[contentType] = '';
	            }
	          }
	        }
	      }
	      return items;
	    };
	    var getClipboardContent = function (editor, clipboardEvent) {
	      var content = getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
	      return Utils.isMsEdge() ? global$4.extend(content, { 'text/html': '' }) : content;
	    };
	    var hasContentType = function (clipboardContent, mimeType) {
	      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
	    };
	    var hasHtmlOrText = function (content) {
	      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
	    };
	    var getBase64FromUri = function (uri) {
	      var idx;
	      idx = uri.indexOf(',');
	      if (idx !== -1) {
	        return uri.substr(idx + 1);
	      }
	      return null;
	    };
	    var isValidDataUriImage = function (settings, imgElm) {
	      return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
	    };
	    var extractFilename = function (editor, str) {
	      var m = str.match(/([\s\S]+?)\.(?:jpeg|jpg|png|gif)$/i);
	      return m ? editor.dom.encode(m[1]) : null;
	    };
	    var uniqueId = Utils.createIdGenerator('mceclip');
	    var pasteImage = function (editor, imageItem) {
	      var base64 = getBase64FromUri(imageItem.uri);
	      var id = uniqueId();
	      var name = editor.settings.images_reuse_filename && imageItem.blob.name ? extractFilename(editor, imageItem.blob.name) : id;
	      var img = new domGlobals.Image();
	      img.src = imageItem.uri;
	      if (isValidDataUriImage(editor.settings, img)) {
	        var blobCache = editor.editorUpload.blobCache;
	        var blobInfo = void 0, existingBlobInfo = void 0;
	        existingBlobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.base64() === base64;
	        });
	        if (!existingBlobInfo) {
	          blobInfo = blobCache.create(id, imageItem.blob, base64, name);
	          blobCache.add(blobInfo);
	        } else {
	          blobInfo = existingBlobInfo;
	        }
	        pasteHtml$1(editor, '<img src="' + blobInfo.blobUri() + '">', false);
	      } else {
	        pasteHtml$1(editor, '<img src="' + imageItem.uri + '">', false);
	      }
	    };
	    var isClipboardEvent = function (event) {
	      return event.type === 'paste';
	    };
	    var readBlobsAsDataUris = function (items) {
	      return mapM(items, function (item) {
	        return Future.nu(function (resolve) {
	          var blob = item.getAsFile ? item.getAsFile() : item;
	          var reader = new window.FileReader();
	          reader.onload = function () {
	            resolve({
	              blob: blob,
	              uri: reader.result
	            });
	          };
	          reader.readAsDataURL(blob);
	        });
	      });
	    };
	    var getImagesFromDataTransfer = function (dataTransfer) {
	      var items = dataTransfer.items ? map(from$1(dataTransfer.items), function (item) {
	        return item.getAsFile();
	      }) : [];
	      var files = dataTransfer.files ? from$1(dataTransfer.files) : [];
	      var images = filter$1(items.length > 0 ? items : files, function (file) {
	        return /^image\/(jpeg|png|gif|bmp)$/.test(file.type);
	      });
	      return images;
	    };
	    var pasteImageData = function (editor, e, rng) {
	      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
	      if (editor.settings.paste_data_images && dataTransfer) {
	        var images = getImagesFromDataTransfer(dataTransfer);
	        if (images.length > 0) {
	          e.preventDefault();
	          readBlobsAsDataUris(images).get(function (blobResults) {
	            if (rng) {
	              editor.selection.setRng(rng);
	            }
	            each(blobResults, function (result) {
	              pasteImage(editor, result);
	            });
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var isBrokenAndroidClipboardEvent = function (e) {
	      var clipboardData = e.clipboardData;
	      return domGlobals.navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
	    };
	    var isKeyboardPasteEvent = function (e) {
	      return global$5.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
	    };
	    var registerEventHandlers = function (editor, pasteBin, pasteFormat) {
	      var keyboardPasteEvent = value();
	      var keyboardPastePlainTextState;
	      editor.on('keydown', function (e) {
	        function removePasteBinOnKeyUp(e) {
	          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	            pasteBin.remove();
	          }
	        }
	        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
	          if (keyboardPastePlainTextState && global$2.webkit && domGlobals.navigator.userAgent.indexOf('Version/') !== -1) {
	            return;
	          }
	          e.stopImmediatePropagation();
	          keyboardPasteEvent.set(e);
	          window.setTimeout(function () {
	            keyboardPasteEvent.clear();
	          }, 100);
	          if (global$2.ie && keyboardPastePlainTextState) {
	            e.preventDefault();
	            Events.firePaste(editor, true);
	            return;
	          }
	          pasteBin.remove();
	          pasteBin.create();
	          editor.once('keyup', removePasteBinOnKeyUp);
	          editor.once('paste', function () {
	            editor.off('keyup', removePasteBinOnKeyUp);
	          });
	        }
	      });
	      function insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
	        var content, isPlainTextHtml;
	        if (hasContentType(clipboardContent, 'text/html')) {
	          content = clipboardContent['text/html'];
	        } else {
	          content = pasteBin.getHtml();
	          internal = internal ? internal : InternalHtml.isMarked(content);
	          if (pasteBin.isDefaultContent(content)) {
	            plainTextMode = true;
	          }
	        }
	        content = Utils.trimHtml(content);
	        pasteBin.remove();
	        isPlainTextHtml = internal === false && Newlines.isPlainText(content);
	        if (!content.length || isPlainTextHtml) {
	          plainTextMode = true;
	        }
	        if (plainTextMode) {
	          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
	            content = clipboardContent['text/plain'];
	          } else {
	            content = Utils.innerText(content);
	          }
	        }
	        if (pasteBin.isDefaultContent(content)) {
	          if (!isKeyBoardPaste) {
	            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
	          }
	          return;
	        }
	        if (plainTextMode) {
	          pasteText(editor, content);
	        } else {
	          pasteHtml$1(editor, content, internal);
	        }
	      }
	      var getLastRng = function () {
	        return pasteBin.getLastRng() || editor.selection.getRng();
	      };
	      editor.on('paste', function (e) {
	        var isKeyBoardPaste = keyboardPasteEvent.isSet();
	        var clipboardContent = getClipboardContent(editor, e);
	        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
	        var internal = hasContentType(clipboardContent, InternalHtml.internalHtmlMime());
	        keyboardPastePlainTextState = false;
	        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
	          pasteBin.remove();
	          return;
	        }
	        if (!hasHtmlOrText(clipboardContent) && pasteImageData(editor, e, getLastRng())) {
	          pasteBin.remove();
	          return;
	        }
	        if (!isKeyBoardPaste) {
	          e.preventDefault();
	        }
	        if (global$2.ie && (!isKeyBoardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
	          pasteBin.create();
	          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
	            e.stopPropagation();
	          });
	          editor.getDoc().execCommand('Paste', false, null);
	          clipboardContent['text/html'] = pasteBin.getHtml();
	        }
	        if (hasContentType(clipboardContent, 'text/html')) {
	          e.preventDefault();
	          if (!internal) {
	            internal = InternalHtml.isMarked(clipboardContent['text/html']);
	          }
	          insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	        } else {
	          global$3.setEditorTimeout(editor, function () {
	            insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	          }, 0);
	        }
	      });
	    };
	    var registerEventsAndFilters = function (editor, pasteBin, pasteFormat) {
	      registerEventHandlers(editor, pasteBin, pasteFormat);
	      var src;
	      editor.parser.addNodeFilter('img', function (nodes, name, args) {
	        var isPasteInsert = function (args) {
	          return args.data && args.data.paste === true;
	        };
	        var remove = function (node) {
	          if (!node.attr('data-mce-object') && src !== global$2.transparentSrc) {
	            node.remove();
	          }
	        };
	        var isWebKitFakeUrl = function (src) {
	          return src.indexOf('webkit-fake-url') === 0;
	        };
	        var isDataUri = function (src) {
	          return src.indexOf('data:') === 0;
	        };
	        if (!editor.settings.paste_data_images && isPasteInsert(args)) {
	          var i = nodes.length;
	          while (i--) {
	            src = nodes[i].attributes.map.src;
	            if (!src) {
	              continue;
	            }
	            if (isWebKitFakeUrl(src)) {
	              remove(nodes[i]);
	            } else if (!editor.settings.allow_html_data_urls && isDataUri(src)) {
	              remove(nodes[i]);
	            }
	          }
	        }
	      });
	    };
	
	    var getPasteBinParent = function (editor) {
	      return global$2.ie && editor.inline ? domGlobals.document.body : editor.getBody();
	    };
	    var isExternalPasteBin = function (editor) {
	      return getPasteBinParent(editor) !== editor.getBody();
	    };
	    var delegatePasteEvents = function (editor, pasteBinElm, pasteBinDefaultContent) {
	      if (isExternalPasteBin(editor)) {
	        editor.dom.bind(pasteBinElm, 'paste keyup', function (e) {
	          if (!isDefault(editor, pasteBinDefaultContent)) {
	            editor.fire('paste');
	          }
	        });
	      }
	    };
	    var create = function (editor, lastRngCell, pasteBinDefaultContent) {
	      var dom = editor.dom, body = editor.getBody();
	      var pasteBinElm;
	      lastRngCell.set(editor.selection.getRng());
	      pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
	        'id': 'mcepastebin',
	        'class': 'mce-pastebin',
	        'contentEditable': true,
	        'data-mce-bogus': 'all',
	        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
	      }, pasteBinDefaultContent);
	      if (global$2.ie || global$2.gecko) {
	        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
	      }
	      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
	        e.stopPropagation();
	      });
	      delegatePasteEvents(editor, pasteBinElm, pasteBinDefaultContent);
	      pasteBinElm.focus();
	      editor.selection.select(pasteBinElm, true);
	    };
	    var remove = function (editor, lastRngCell) {
	      if (getEl(editor)) {
	        var pasteBinClone = void 0;
	        var lastRng = lastRngCell.get();
	        while (pasteBinClone = editor.dom.get('mcepastebin')) {
	          editor.dom.remove(pasteBinClone);
	          editor.dom.unbind(pasteBinClone);
	        }
	        if (lastRng) {
	          editor.selection.setRng(lastRng);
	        }
	      }
	      lastRngCell.set(null);
	    };
	    var getEl = function (editor) {
	      return editor.dom.get('mcepastebin');
	    };
	    var getHtml = function (editor) {
	      var pasteBinElm, pasteBinClones, i, dirtyWrappers, cleanWrapper;
	      var copyAndRemove = function (toElm, fromElm) {
	        toElm.appendChild(fromElm);
	        editor.dom.remove(fromElm, true);
	      };
	      pasteBinClones = global$4.grep(getPasteBinParent(editor).childNodes, function (elm) {
	        return elm.id === 'mcepastebin';
	      });
	      pasteBinElm = pasteBinClones.shift();
	      global$4.each(pasteBinClones, function (pasteBinClone) {
	        copyAndRemove(pasteBinElm, pasteBinClone);
	      });
	      dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
	      for (i = dirtyWrappers.length - 1; i >= 0; i--) {
	        cleanWrapper = editor.dom.create('div');
	        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
	        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
	      }
	      return pasteBinElm ? pasteBinElm.innerHTML : '';
	    };
	    var getLastRng = function (lastRng) {
	      return lastRng.get();
	    };
	    var isDefaultContent = function (pasteBinDefaultContent, content) {
	      return content === pasteBinDefaultContent;
	    };
	    var isPasteBin = function (elm) {
	      return elm && elm.id === 'mcepastebin';
	    };
	    var isDefault = function (editor, pasteBinDefaultContent) {
	      var pasteBinElm = getEl(editor);
	      return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
	    };
	    var PasteBin = function (editor) {
	      var lastRng = Cell(null);
	      var pasteBinDefaultContent = '%MCEPASTEBIN%';
	      return {
	        create: function () {
	          return create(editor, lastRng, pasteBinDefaultContent);
	        },
	        remove: function () {
	          return remove(editor, lastRng);
	        },
	        getEl: function () {
	          return getEl(editor);
	        },
	        getHtml: function () {
	          return getHtml(editor);
	        },
	        getLastRng: function () {
	          return getLastRng(lastRng);
	        },
	        isDefault: function () {
	          return isDefault(editor, pasteBinDefaultContent);
	        },
	        isDefaultContent: function (content) {
	          return isDefaultContent(pasteBinDefaultContent, content);
	        }
	      };
	    };
	
	    var Clipboard = function (editor, pasteFormat) {
	      var pasteBin = PasteBin(editor);
	      editor.on('preInit', function () {
	        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
	      });
	      return {
	        pasteFormat: pasteFormat,
	        pasteHtml: function (html, internalFlag) {
	          return pasteHtml$1(editor, html, internalFlag);
	        },
	        pasteText: function (text) {
	          return pasteText(editor, text);
	        },
	        pasteImageData: function (e, rng) {
	          return pasteImageData(editor, e, rng);
	        },
	        getDataTransferItems: getDataTransferItems,
	        hasHtmlOrText: hasHtmlOrText,
	        hasContentType: hasContentType
	      };
	    };
	
	    var noop$1 = function () {
	    };
	    var hasWorkingClipboardApi = function (clipboardData) {
	      return global$2.iOS === false && clipboardData !== undefined && typeof clipboardData.setData === 'function' && Utils.isMsEdge() !== true;
	    };
	    var setHtml5Clipboard = function (clipboardData, html, text) {
	      if (hasWorkingClipboardApi(clipboardData)) {
	        try {
	          clipboardData.clearData();
	          clipboardData.setData('text/html', html);
	          clipboardData.setData('text/plain', text);
	          clipboardData.setData(InternalHtml.internalHtmlMime(), html);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    };
	    var setClipboardData = function (evt, data, fallback, done) {
	      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
	        evt.preventDefault();
	        done();
	      } else {
	        fallback(data.html, done);
	      }
	    };
	    var fallback = function (editor) {
	      return function (html, done) {
	        var markedHtml = InternalHtml.mark(html);
	        var outer = editor.dom.create('div', {
	          'contenteditable': 'false',
	          'data-mce-bogus': 'all'
	        });
	        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
	        editor.dom.setStyles(outer, {
	          position: 'fixed',
	          top: '0',
	          left: '-3000px',
	          width: '1000px',
	          overflow: 'hidden'
	        });
	        outer.appendChild(inner);
	        editor.dom.add(editor.getBody(), outer);
	        var range = editor.selection.getRng();
	        inner.focus();
	        var offscreenRange = editor.dom.createRng();
	        offscreenRange.selectNodeContents(inner);
	        editor.selection.setRng(offscreenRange);
	        setTimeout(function () {
	          editor.selection.setRng(range);
	          outer.parentNode.removeChild(outer);
	          done();
	        }, 0);
	      };
	    };
	    var getData = function (editor) {
	      return {
	        html: editor.selection.getContent({ contextual: true }),
	        text: editor.selection.getContent({ format: 'text' })
	      };
	    };
	    var isTableSelection = function (editor) {
	      return !!editor.dom.getParent(editor.selection.getStart(), 'td[data-mce-selected],th[data-mce-selected]', editor.getBody());
	    };
	    var hasSelectedContent = function (editor) {
	      return !editor.selection.isCollapsed() || isTableSelection(editor);
	    };
	    var cut = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), function () {
	            setTimeout(function () {
	              editor.execCommand('Delete');
	            }, 0);
	          });
	        }
	      };
	    };
	    var copy = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), noop$1);
	        }
	      };
	    };
	    var register$1 = function (editor) {
	      editor.on('cut', cut(editor));
	      editor.on('copy', copy(editor));
	    };
	    var CutCopy = { register: register$1 };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var getCaretRangeFromEvent = function (editor, e) {
	      return global$b.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
	    };
	    var isPlainTextFileUrl = function (content) {
	      var plainTextContent = content['text/plain'];
	      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
	    };
	    var setFocusedRange = function (editor, rng) {
	      editor.focus();
	      editor.selection.setRng(rng);
	    };
	    var setup = function (editor, clipboard, draggingInternallyState) {
	      if (Settings.shouldBlockDrop(editor)) {
	        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        });
	      }
	      if (!Settings.shouldPasteDataImages(editor)) {
	        editor.on('drop', function (e) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
	            e.preventDefault();
	          }
	        });
	      }
	      editor.on('drop', function (e) {
	        var dropContent, rng;
	        rng = getCaretRangeFromEvent(editor, e);
	        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
	          return;
	        }
	        dropContent = clipboard.getDataTransferItems(e.dataTransfer);
	        var internal = clipboard.hasContentType(dropContent, InternalHtml.internalHtmlMime());
	        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
	          return;
	        }
	        if (rng && Settings.shouldFilterDrop(editor)) {
	          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	          if (content_1) {
	            e.preventDefault();
	            global$3.setEditorTimeout(editor, function () {
	              editor.undoManager.transact(function () {
	                if (dropContent['mce-internal']) {
	                  editor.execCommand('Delete');
	                }
	                setFocusedRange(editor, rng);
	                content_1 = Utils.trimHtml(content_1);
	                if (!dropContent['text/html']) {
	                  clipboard.pasteText(content_1);
	                } else {
	                  clipboard.pasteHtml(content_1, internal);
	                }
	              });
	            });
	          }
	        }
	      });
	      editor.on('dragstart', function (e) {
	        draggingInternallyState.set(true);
	      });
	      editor.on('dragover dragend', function (e) {
	        if (Settings.shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
	          e.preventDefault();
	          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
	        }
	        if (e.type === 'dragend') {
	          draggingInternallyState.set(false);
	        }
	      });
	    };
	    var DragDrop = { setup: setup };
	
	    var setup$1 = function (editor) {
	      var plugin = editor.plugins.paste;
	      var preProcess = Settings.getPreProcess(editor);
	      if (preProcess) {
	        editor.on('PastePreProcess', function (e) {
	          preProcess.call(plugin, plugin, e);
	        });
	      }
	      var postProcess = Settings.getPostProcess(editor);
	      if (postProcess) {
	        editor.on('PastePostProcess', function (e) {
	          postProcess.call(plugin, plugin, e);
	        });
	      }
	    };
	    var PrePostProcess = { setup: setup$1 };
	
	    function addPreProcessFilter(editor, filterFunc) {
	      editor.on('PastePreProcess', function (e) {
	        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
	      });
	    }
	    function addPostProcessFilter(editor, filterFunc) {
	      editor.on('PastePostProcess', function (e) {
	        filterFunc(editor, e.node);
	      });
	    }
	    function removeExplorerBrElementsAfterBlocks(editor, html) {
	      if (!WordFilter.isWordContent(html)) {
	        return html;
	      }
	      var blockElements = [];
	      global$4.each(editor.schema.getBlockElements(), function (block, blockName) {
	        blockElements.push(blockName);
	      });
	      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
	      html = Utils.filter(html, [[
	          explorerBlocksRegExp,
	          '$1'
	        ]]);
	      html = Utils.filter(html, [
	        [
	          /<br><br>/g,
	          '<BR><BR>'
	        ],
	        [
	          /<br>/g,
	          ' '
	        ],
	        [
	          /<BR><BR>/g,
	          '<br>'
	        ]
	      ]);
	      return html;
	    }
	    function removeWebKitStyles(editor, content, internal, isWordHtml) {
	      if (isWordHtml || internal) {
	        return content;
	      }
	      var webKitStylesSetting = Settings.getWebkitStyles(editor);
	      var webKitStyles;
	      if (Settings.shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
	        return content;
	      }
	      if (webKitStylesSetting) {
	        webKitStyles = webKitStylesSetting.split(/[, ]/);
	      }
	      if (webKitStyles) {
	        var dom_1 = editor.dom, node_1 = editor.selection.getNode();
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
	          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
	          var outputStyles = {};
	          if (webKitStyles === 'none') {
	            return before + after;
	          }
	          for (var i = 0; i < webKitStyles.length; i++) {
	            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
	            if (/color/.test(webKitStyles[i])) {
	              inputValue = dom_1.toHex(inputValue);
	              currentValue = dom_1.toHex(currentValue);
	            }
	            if (currentValue !== inputValue) {
	              outputStyles[webKitStyles[i]] = inputValue;
	            }
	          }
	          outputStyles = dom_1.serializeStyle(outputStyles, 'span');
	          if (outputStyles) {
	            return before + ' style="' + outputStyles + '"' + after;
	          }
	          return before + after;
	        });
	      } else {
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
	      }
	      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
	        return before + ' style="' + value + '"' + after;
	      });
	      return content;
	    }
	    function removeUnderlineAndFontInAnchor(editor, root) {
	      editor.$('a', root).find('font,u').each(function (i, node) {
	        editor.dom.remove(node, true);
	      });
	    }
	    var setup$2 = function (editor) {
	      if (global$2.webkit) {
	        addPreProcessFilter(editor, removeWebKitStyles);
	      }
	      if (global$2.ie) {
	        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
	        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
	      }
	    };
	    var Quirks = { setup: setup$2 };
	
	    var stateChange = function (editor, clipboard, e) {
	      var ctrl = e.control;
	      ctrl.active(clipboard.pasteFormat.get() === 'text');
	      editor.on('PastePlainTextToggle', function (e) {
	        ctrl.active(e.state);
	      });
	    };
	    var register$2 = function (editor, clipboard) {
	      var postRender = curry(stateChange, editor, clipboard);
	      editor.addButton('pastetext', {
	        active: false,
	        icon: 'pastetext',
	        tooltip: 'Paste as text',
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	      editor.addMenuItem('pastetext', {
	        text: 'Paste as text',
	        selectable: true,
	        active: clipboard.pasteFormat,
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	    };
	    var Buttons = { register: register$2 };
	
	    global$1.add('paste', function (editor) {
	      if (DetectProPlugin.hasProPlugin(editor) === false) {
	        var userIsInformedState = Cell(false);
	        var draggingInternallyState = Cell(false);
	        var pasteFormat = Cell(Settings.isPasteAsTextEnabled(editor) ? 'text' : 'html');
	        var clipboard = Clipboard(editor, pasteFormat);
	        var quirks = Quirks.setup(editor);
	        Buttons.register(editor, clipboard);
	        Commands.register(editor, clipboard, userIsInformedState);
	        PrePostProcess.setup(editor);
	        CutCopy.register(editor);
	        DragDrop.setup(editor, clipboard, draggingInternallyState);
	        return Api.get(clipboard, quirks);
	      }
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}(window));
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	(function () {
	var textcolor = (function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var getCurrentColor = function (editor, format) {
	      var color;
	      editor.dom.getParents(editor.selection.getStart(), function (elm) {
	        var value;
	        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
	          color = color ? color : value;
	        }
	      });
	      return color;
	    };
	    var mapColors = function (colorMap) {
	      var i;
	      var colors = [];
	      for (i = 0; i < colorMap.length; i += 2) {
	        colors.push({
	          text: colorMap[i + 1],
	          color: '#' + colorMap[i]
	        });
	      }
	      return colors;
	    };
	    var applyFormat = function (editor, format, value) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.apply(format, { value: value });
	        editor.nodeChanged();
	      });
	    };
	    var removeFormat = function (editor, format) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.remove(format, { value: null }, null, true);
	        editor.nodeChanged();
	      });
	    };
	    var TextColor = {
	      getCurrentColor: getCurrentColor,
	      mapColors: mapColors,
	      applyFormat: applyFormat,
	      removeFormat: removeFormat
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceApplyTextcolor', function (format, value) {
	        TextColor.applyFormat(editor, format, value);
	      });
	      editor.addCommand('mceRemoveTextcolor', function (format) {
	        TextColor.removeFormat(editor, format);
	      });
	    };
	    var Commands = { register: register };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var defaultColorMap = [
	      '000000',
	      'Black',
	      '993300',
	      'Burnt orange',
	      '333300',
	      'Dark olive',
	      '003300',
	      'Dark green',
	      '003366',
	      'Dark azure',
	      '000080',
	      'Navy Blue',
	      '333399',
	      'Indigo',
	      '333333',
	      'Very dark gray',
	      '800000',
	      'Maroon',
	      'FF6600',
	      'Orange',
	      '808000',
	      'Olive',
	      '008000',
	      'Green',
	      '008080',
	      'Teal',
	      '0000FF',
	      'Blue',
	      '666699',
	      'Grayish blue',
	      '808080',
	      'Gray',
	      'FF0000',
	      'Red',
	      'FF9900',
	      'Amber',
	      '99CC00',
	      'Yellow green',
	      '339966',
	      'Sea green',
	      '33CCCC',
	      'Turquoise',
	      '3366FF',
	      'Royal blue',
	      '800080',
	      'Purple',
	      '999999',
	      'Medium gray',
	      'FF00FF',
	      'Magenta',
	      'FFCC00',
	      'Gold',
	      'FFFF00',
	      'Yellow',
	      '00FF00',
	      'Lime',
	      '00FFFF',
	      'Aqua',
	      '00CCFF',
	      'Sky blue',
	      '993366',
	      'Red violet',
	      'FFFFFF',
	      'White',
	      'FF99CC',
	      'Pink',
	      'FFCC99',
	      'Peach',
	      'FFFF99',
	      'Light yellow',
	      'CCFFCC',
	      'Pale green',
	      'CCFFFF',
	      'Pale cyan',
	      '99CCFF',
	      'Light sky blue',
	      'CC99FF',
	      'Plum'
	    ];
	    var getTextColorMap = function (editor) {
	      return editor.getParam('textcolor_map', defaultColorMap);
	    };
	    var getForeColorMap = function (editor) {
	      return editor.getParam('forecolor_map', getTextColorMap(editor));
	    };
	    var getBackColorMap = function (editor) {
	      return editor.getParam('backcolor_map', getTextColorMap(editor));
	    };
	    var getTextColorRows = function (editor) {
	      return editor.getParam('textcolor_rows', 5);
	    };
	    var getTextColorCols = function (editor) {
	      return editor.getParam('textcolor_cols', 8);
	    };
	    var getForeColorRows = function (editor) {
	      return editor.getParam('forecolor_rows', getTextColorRows(editor));
	    };
	    var getBackColorRows = function (editor) {
	      return editor.getParam('backcolor_rows', getTextColorRows(editor));
	    };
	    var getForeColorCols = function (editor) {
	      return editor.getParam('forecolor_cols', getTextColorCols(editor));
	    };
	    var getBackColorCols = function (editor) {
	      return editor.getParam('backcolor_cols', getTextColorCols(editor));
	    };
	    var getColorPickerCallback = function (editor) {
	      return editor.getParam('color_picker_callback', null);
	    };
	    var hasColorPicker = function (editor) {
	      return typeof getColorPickerCallback(editor) === 'function';
	    };
	    var Settings = {
	      getForeColorMap: getForeColorMap,
	      getBackColorMap: getBackColorMap,
	      getForeColorRows: getForeColorRows,
	      getBackColorRows: getBackColorRows,
	      getForeColorCols: getForeColorCols,
	      getBackColorCols: getBackColorCols,
	      getColorPickerCallback: getColorPickerCallback,
	      hasColorPicker: hasColorPicker
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var getHtml = function (cols, rows, colorMap, hasColorPicker) {
	      var colors, color, html, last, x, y, i, count = 0;
	      var id = global$1.DOM.uniqueId('mcearia');
	      var getColorCellHtml = function (color, title) {
	        var isNoColor = color === 'transparent';
	        return '<td class="mce-grid-cell' + (isNoColor ? ' mce-colorbtn-trans' : '') + '">' + '<div id="' + id + '-' + count++ + '"' + ' data-mce-color="' + (color ? color : '') + '"' + ' role="option"' + ' tabIndex="-1"' + ' style="' + (color ? 'background-color: ' + color : '') + '"' + ' title="' + global$3.translate(title) + '">' + (isNoColor ? '&#215;' : '') + '</div>' + '</td>';
	      };
	      colors = TextColor.mapColors(colorMap);
	      colors.push({
	        text: global$3.translate('No color'),
	        color: 'transparent'
	      });
	      html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
	      last = colors.length - 1;
	      for (y = 0; y < rows; y++) {
	        html += '<tr>';
	        for (x = 0; x < cols; x++) {
	          i = y * cols + x;
	          if (i > last) {
	            html += '<td></td>';
	          } else {
	            color = colors[i];
	            html += getColorCellHtml(color.color, color.text);
	          }
	        }
	        html += '</tr>';
	      }
	      if (hasColorPicker) {
	        html += '<tr>' + '<td colspan="' + cols + '" class="mce-custom-color-btn">' + '<div id="' + id + '-c" class="mce-widget mce-btn mce-btn-small mce-btn-flat" ' + 'role="button" tabindex="-1" aria-labelledby="' + id + '-c" style="width: 100%">' + '<button type="button" role="presentation" tabindex="-1">' + global$3.translate('Custom...') + '</button>' + '</div>' + '</td>' + '</tr>';
	        html += '<tr>';
	        for (x = 0; x < cols; x++) {
	          html += getColorCellHtml('', 'Custom color');
	        }
	        html += '</tr>';
	      }
	      html += '</tbody></table>';
	      return html;
	    };
	    var ColorPickerHtml = { getHtml: getHtml };
	
	    var setDivColor = function setDivColor(div, value) {
	      div.style.background = value;
	      div.setAttribute('data-mce-color', value);
	    };
	    var onButtonClick = function (editor) {
	      return function (e) {
	        var ctrl = e.control;
	        if (ctrl._color) {
	          editor.execCommand('mceApplyTextcolor', ctrl.settings.format, ctrl._color);
	        } else {
	          editor.execCommand('mceRemoveTextcolor', ctrl.settings.format);
	        }
	      };
	    };
	    var onPanelClick = function (editor, cols) {
	      return function (e) {
	        var buttonCtrl = this.parent();
	        var value;
	        var currentColor = TextColor.getCurrentColor(editor, buttonCtrl.settings.format);
	        var selectColor = function (value) {
	          editor.execCommand('mceApplyTextcolor', buttonCtrl.settings.format, value);
	          buttonCtrl.hidePanel();
	          buttonCtrl.color(value);
	        };
	        var resetColor = function () {
	          editor.execCommand('mceRemoveTextcolor', buttonCtrl.settings.format);
	          buttonCtrl.hidePanel();
	          buttonCtrl.resetColor();
	        };
	        if (global$1.DOM.getParent(e.target, '.mce-custom-color-btn')) {
	          buttonCtrl.hidePanel();
	          var colorPickerCallback = Settings.getColorPickerCallback(editor);
	          colorPickerCallback.call(editor, function (value) {
	            var tableElm = buttonCtrl.panel.getEl().getElementsByTagName('table')[0];
	            var customColorCells, div, i;
	            customColorCells = global$2.map(tableElm.rows[tableElm.rows.length - 1].childNodes, function (elm) {
	              return elm.firstChild;
	            });
	            for (i = 0; i < customColorCells.length; i++) {
	              div = customColorCells[i];
	              if (!div.getAttribute('data-mce-color')) {
	                break;
	              }
	            }
	            if (i === cols) {
	              for (i = 0; i < cols - 1; i++) {
	                setDivColor(customColorCells[i], customColorCells[i + 1].getAttribute('data-mce-color'));
	              }
	            }
	            setDivColor(div, value);
	            selectColor(value);
	          }, currentColor);
	        }
	        value = e.target.getAttribute('data-mce-color');
	        if (value) {
	          if (this.lastId) {
	            global$1.DOM.get(this.lastId).setAttribute('aria-selected', 'false');
	          }
	          e.target.setAttribute('aria-selected', true);
	          this.lastId = e.target.id;
	          if (value === 'transparent') {
	            resetColor();
	          } else {
	            selectColor(value);
	          }
	        } else if (value !== null) {
	          buttonCtrl.hidePanel();
	        }
	      };
	    };
	    var renderColorPicker = function (editor, foreColor) {
	      return function () {
	        var cols = foreColor ? Settings.getForeColorCols(editor) : Settings.getBackColorCols(editor);
	        var rows = foreColor ? Settings.getForeColorRows(editor) : Settings.getBackColorRows(editor);
	        var colorMap = foreColor ? Settings.getForeColorMap(editor) : Settings.getBackColorMap(editor);
	        var hasColorPicker = Settings.hasColorPicker(editor);
	        return ColorPickerHtml.getHtml(cols, rows, colorMap, hasColorPicker);
	      };
	    };
	    var register$1 = function (editor) {
	      editor.addButton('forecolor', {
	        type: 'colorbutton',
	        tooltip: 'Text color',
	        format: 'forecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, true),
	          onclick: onPanelClick(editor, Settings.getForeColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	      editor.addButton('backcolor', {
	        type: 'colorbutton',
	        tooltip: 'Background color',
	        format: 'hilitecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, false),
	          onclick: onPanelClick(editor, Settings.getBackColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	    };
	    var Buttons = { register: register$1 };
	
	    global.add('textcolor', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	    function Plugin () {
	    }
	
	    return Plugin;
	
	}());
	})();


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	(function () {
	var modern = (function (domGlobals) {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.ThemeManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.EditorManager');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var isBrandingEnabled = function (editor) {
	      return editor.getParam('branding', true, 'boolean');
	    };
	    var hasMenubar = function (editor) {
	      return getMenubar(editor) !== false;
	    };
	    var getMenubar = function (editor) {
	      return editor.getParam('menubar');
	    };
	    var hasStatusbar = function (editor) {
	      return editor.getParam('statusbar', true, 'boolean');
	    };
	    var getToolbarSize = function (editor) {
	      return editor.getParam('toolbar_items_size');
	    };
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly', false, 'boolean');
	    };
	    var getFixedToolbarContainer = function (editor) {
	      return editor.getParam('fixed_toolbar_container');
	    };
	    var getInlineToolbarPositionHandler = function (editor) {
	      return editor.getParam('inline_toolbar_position_handler');
	    };
	    var getMenu = function (editor) {
	      return editor.getParam('menu');
	    };
	    var getRemovedMenuItems = function (editor) {
	      return editor.getParam('removed_menuitems', '');
	    };
	    var getMinWidth = function (editor) {
	      return editor.getParam('min_width', 100, 'number');
	    };
	    var getMinHeight = function (editor) {
	      return editor.getParam('min_height', 100, 'number');
	    };
	    var getMaxWidth = function (editor) {
	      return editor.getParam('max_width', 65535, 'number');
	    };
	    var getMaxHeight = function (editor) {
	      return editor.getParam('max_height', 65535, 'number');
	    };
	    var isSkinDisabled = function (editor) {
	      return editor.settings.skin === false;
	    };
	    var isInline = function (editor) {
	      return editor.getParam('inline', false, 'boolean');
	    };
	    var getResize = function (editor) {
	      var resize = editor.getParam('resize', 'vertical');
	      if (resize === false) {
	        return 'none';
	      } else if (resize === 'both') {
	        return 'both';
	      } else {
	        return 'vertical';
	      }
	    };
	    var getSkinUrl = function (editor) {
	      var settings = editor.settings;
	      var skin = settings.skin;
	      var skinUrl = settings.skin_url;
	      if (skin !== false) {
	        var skinName = skin ? skin : 'lightgray';
	        if (skinUrl) {
	          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
	        } else {
	          skinUrl = global$1.baseURL + '/skins/' + skinName;
	        }
	      }
	      return skinUrl;
	    };
	    var getIndexedToolbars = function (settings, defaultToolbar) {
	      var toolbars = [];
	      for (var i = 1; i < 10; i++) {
	        var toolbar = settings['toolbar' + i];
	        if (!toolbar) {
	          break;
	        }
	        toolbars.push(toolbar);
	      }
	      var mainToolbar = settings.toolbar ? [settings.toolbar] : [defaultToolbar];
	      return toolbars.length > 0 ? toolbars : mainToolbar;
	    };
	    var getToolbars = function (editor) {
	      var toolbar = editor.getParam('toolbar');
	      var defaultToolbar = 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image';
	      if (toolbar === false) {
	        return [];
	      } else if (global$2.isArray(toolbar)) {
	        return global$2.grep(toolbar, function (toolbar) {
	          return toolbar.length > 0;
	        });
	      } else {
	        return getIndexedToolbars(editor.settings, defaultToolbar);
	      }
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.ui.Factory');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var fireSkinLoaded = function (editor) {
	      return editor.fire('SkinLoaded');
	    };
	    var fireResizeEditor = function (editor) {
	      return editor.fire('ResizeEditor');
	    };
	    var fireBeforeRenderUI = function (editor) {
	      return editor.fire('BeforeRenderUI');
	    };
	    var Events = {
	      fireSkinLoaded: fireSkinLoaded,
	      fireResizeEditor: fireResizeEditor,
	      fireBeforeRenderUI: fireBeforeRenderUI
	    };
	
	    var focus = function (panel, type) {
	      return function () {
	        var item = panel.find(type)[0];
	        if (item) {
	          item.focus(true);
	        }
	      };
	    };
	    var addKeys = function (editor, panel) {
	      editor.shortcuts.add('Alt+F9', '', focus(panel, 'menubar'));
	      editor.shortcuts.add('Alt+F10,F10', '', focus(panel, 'toolbar'));
	      editor.shortcuts.add('Alt+F11', '', focus(panel, 'elementpath'));
	      panel.on('cancel', function () {
	        editor.focus();
	      });
	    };
	    var A11y = { addKeys: addKeys };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.geom.Rect');
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      if (Object.freeze) {
	        Object.freeze(me);
	      }
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Option = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var getUiContainerDelta = function (ctrl) {
	      var uiContainer = getUiContainer(ctrl);
	      if (uiContainer && global$3.DOM.getStyle(uiContainer, 'position', true) !== 'static') {
	        var containerPos = global$3.DOM.getPos(uiContainer);
	        var dx = uiContainer.scrollLeft - containerPos.x;
	        var dy = uiContainer.scrollTop - containerPos.y;
	        return Option.some({
	          x: dx,
	          y: dy
	        });
	      } else {
	        return Option.none();
	      }
	    };
	    var setUiContainer = function (editor, ctrl) {
	      var uiContainer = global$3.DOM.select(editor.settings.ui_container)[0];
	      ctrl.getRoot().uiContainer = uiContainer;
	    };
	    var getUiContainer = function (ctrl) {
	      return ctrl ? ctrl.getRoot().uiContainer : null;
	    };
	    var inheritUiContainer = function (fromCtrl, toCtrl) {
	      return toCtrl.uiContainer = getUiContainer(fromCtrl);
	    };
	    var UiContainer = {
	      getUiContainerDelta: getUiContainerDelta,
	      setUiContainer: setUiContainer,
	      getUiContainer: getUiContainer,
	      inheritUiContainer: inheritUiContainer
	    };
	
	    var createToolbar = function (editor, items, size) {
	      var toolbarItems = [];
	      var buttonGroup;
	      if (!items) {
	        return;
	      }
	      global$2.each(items.split(/[ ,]/), function (item) {
	        var itemName;
	        var bindSelectorChanged = function () {
	          var selection = editor.selection;
	          if (item.settings.stateSelector) {
	            selection.selectorChanged(item.settings.stateSelector, function (state) {
	              item.active(state);
	            }, true);
	          }
	          if (item.settings.disabledStateSelector) {
	            selection.selectorChanged(item.settings.disabledStateSelector, function (state) {
	              item.disabled(state);
	            });
	          }
	        };
	        if (item === '|') {
	          buttonGroup = null;
	        } else {
	          if (!buttonGroup) {
	            buttonGroup = {
	              type: 'buttongroup',
	              items: []
	            };
	            toolbarItems.push(buttonGroup);
	          }
	          if (editor.buttons[item]) {
	            itemName = item;
	            item = editor.buttons[itemName];
	            if (typeof item === 'function') {
	              item = item();
	            }
	            item.type = item.type || 'button';
	            item.size = size;
	            item = global$4.create(item);
	            buttonGroup.items.push(item);
	            if (editor.initialized) {
	              bindSelectorChanged();
	            } else {
	              editor.on('init', bindSelectorChanged);
	            }
	          }
	        }
	      });
	      return {
	        type: 'toolbar',
	        layout: 'flow',
	        items: toolbarItems
	      };
	    };
	    var createToolbars = function (editor, size) {
	      var toolbars = [];
	      var addToolbar = function (items) {
	        if (items) {
	          toolbars.push(createToolbar(editor, items, size));
	        }
	      };
	      global$2.each(getToolbars(editor), function (toolbar) {
	        addToolbar(toolbar);
	      });
	      if (toolbars.length) {
	        return {
	          type: 'panel',
	          layout: 'stack',
	          classes: 'toolbar-grp',
	          ariaRoot: true,
	          ariaRemember: true,
	          items: toolbars
	        };
	      }
	    };
	    var Toolbar = {
	      createToolbar: createToolbar,
	      createToolbars: createToolbars
	    };
	
	    var DOM = global$3.DOM;
	    var toClientRect = function (geomRect) {
	      return {
	        left: geomRect.x,
	        top: geomRect.y,
	        width: geomRect.w,
	        height: geomRect.h,
	        right: geomRect.x + geomRect.w,
	        bottom: geomRect.y + geomRect.h
	      };
	    };
	    var hideAllFloatingPanels = function (editor) {
	      global$2.each(editor.contextToolbars, function (toolbar) {
	        if (toolbar.panel) {
	          toolbar.panel.hide();
	        }
	      });
	    };
	    var movePanelTo = function (panel, pos) {
	      panel.moveTo(pos.left, pos.top);
	    };
	    var togglePositionClass = function (panel, relPos, predicate) {
	      relPos = relPos ? relPos.substr(0, 2) : '';
	      global$2.each({
	        t: 'down',
	        b: 'up'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
	      });
	      global$2.each({
	        l: 'left',
	        r: 'right'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
	      });
	    };
	    var userConstrain = function (handler, x, y, elementRect, contentAreaRect, panelRect) {
	      panelRect = toClientRect({
	        x: x,
	        y: y,
	        w: panelRect.w,
	        h: panelRect.h
	      });
	      if (handler) {
	        panelRect = handler({
	          elementRect: toClientRect(elementRect),
	          contentAreaRect: toClientRect(contentAreaRect),
	          panelRect: panelRect
	        });
	      }
	      return panelRect;
	    };
	    var addContextualToolbars = function (editor) {
	      var scrollContainer;
	      var getContextToolbars = function () {
	        return editor.contextToolbars || [];
	      };
	      var getElementRect = function (elm) {
	        var pos, targetRect, root;
	        pos = DOM.getPos(editor.getContentAreaContainer());
	        targetRect = editor.dom.getRect(elm);
	        root = editor.dom.getRoot();
	        if (root.nodeName === 'BODY') {
	          targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
	          targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
	        }
	        targetRect.x += pos.x;
	        targetRect.y += pos.y;
	        return targetRect;
	      };
	      var reposition = function (match, shouldShow) {
	        var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
	        var handler = getInlineToolbarPositionHandler(editor);
	        if (editor.removed) {
	          return;
	        }
	        if (!match || !match.toolbar.panel) {
	          hideAllFloatingPanels(editor);
	          return;
	        }
	        testPositions = [
	          'bc-tc',
	          'tc-bc',
	          'tl-bl',
	          'bl-tl',
	          'tr-br',
	          'br-tr'
	        ];
	        panel = match.toolbar.panel;
	        if (shouldShow) {
	          panel.show();
	        }
	        elementRect = getElementRect(match.element);
	        panelRect = DOM.getRect(panel.getEl());
	        contentAreaRect = DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
	        var delta = UiContainer.getUiContainerDelta(panel).getOr({
	          x: 0,
	          y: 0
	        });
	        elementRect.x += delta.x;
	        elementRect.y += delta.y;
	        panelRect.x += delta.x;
	        panelRect.y += delta.y;
	        contentAreaRect.x += delta.x;
	        contentAreaRect.y += delta.y;
	        smallElementWidthThreshold = 25;
	        if (DOM.getStyle(match.element, 'display', true) !== 'inline') {
	          var clientRect = match.element.getBoundingClientRect();
	          elementRect.w = clientRect.width;
	          elementRect.h = clientRect.height;
	        }
	        if (!editor.inline) {
	          contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
	        }
	        if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
	          elementRect = global$6.inflate(elementRect, 0, 8);
	        }
	        relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
	        elementRect = global$6.clamp(elementRect, contentAreaRect);
	        if (relPos) {
	          relRect = global$6.relativePosition(panelRect, elementRect, relPos);
	          movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	        } else {
	          contentAreaRect.h += panelRect.h;
	          elementRect = global$6.intersect(contentAreaRect, elementRect);
	          if (elementRect) {
	            relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, [
	              'bc-tc',
	              'bl-tl',
	              'br-tr'
	            ]);
	            if (relPos) {
	              relRect = global$6.relativePosition(panelRect, elementRect, relPos);
	              movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	            } else {
	              movePanelTo(panel, userConstrain(handler, elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
	            }
	          } else {
	            panel.hide();
	          }
	        }
	        togglePositionClass(panel, relPos, function (pos1, pos2) {
	          return pos1 === pos2;
	        });
	      };
	      var repositionHandler = function (show) {
	        return function () {
	          var execute = function () {
	            if (editor.selection) {
	              reposition(findFrontMostMatch(editor.selection.getNode()), show);
	            }
	          };
	          global$7.requestAnimationFrame(execute);
	        };
	      };
	      var bindScrollEvent = function (panel) {
	        if (!scrollContainer) {
	          var reposition_1 = repositionHandler(true);
	          var uiContainer_1 = UiContainer.getUiContainer(panel);
	          scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
	          DOM.bind(scrollContainer, 'scroll', reposition_1);
	          DOM.bind(uiContainer_1, 'scroll', reposition_1);
	          editor.on('remove', function () {
	            DOM.unbind(scrollContainer, 'scroll', reposition_1);
	            DOM.unbind(uiContainer_1, 'scroll', reposition_1);
	          });
	        }
	      };
	      var showContextToolbar = function (match) {
	        var panel;
	        if (match.toolbar.panel) {
	          match.toolbar.panel.show();
	          reposition(match);
	          return;
	        }
	        panel = global$4.create({
	          type: 'floatpanel',
	          role: 'dialog',
	          classes: 'tinymce tinymce-inline arrow',
	          ariaLabel: 'Inline toolbar',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: true,
	          fixed: true,
	          border: 1,
	          items: Toolbar.createToolbar(editor, match.toolbar.items),
	          oncancel: function () {
	            editor.focus();
	          }
	        });
	        UiContainer.setUiContainer(editor, panel);
	        bindScrollEvent(panel);
	        match.toolbar.panel = panel;
	        panel.renderTo().reflow();
	        reposition(match);
	      };
	      var hideAllContextToolbars = function () {
	        global$2.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.hide();
	          }
	        });
	      };
	      var findFrontMostMatch = function (targetElm) {
	        var i, y, parentsAndSelf;
	        var toolbars = getContextToolbars();
	        parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
	        for (i = parentsAndSelf.length - 1; i >= 0; i--) {
	          for (y = toolbars.length - 1; y >= 0; y--) {
	            if (toolbars[y].predicate(parentsAndSelf[i])) {
	              return {
	                toolbar: toolbars[y],
	                element: parentsAndSelf[i]
	              };
	            }
	          }
	        }
	        return null;
	      };
	      editor.on('click keyup setContent ObjectResized', function (e) {
	        if (e.type === 'setcontent' && !e.selection) {
	          return;
	        }
	        global$7.setEditorTimeout(editor, function () {
	          var match;
	          match = findFrontMostMatch(editor.selection.getNode());
	          if (match) {
	            hideAllContextToolbars();
	            showContextToolbar(match);
	          } else {
	            hideAllContextToolbars();
	          }
	        });
	      });
	      editor.on('blur hide contextmenu', hideAllContextToolbars);
	      editor.on('ObjectResizeStart', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.hide();
	        }
	      });
	      editor.on('ResizeEditor ResizeWindow', repositionHandler(true));
	      editor.on('nodeChange', repositionHandler(false));
	      editor.on('remove', function () {
	        global$2.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.remove();
	          }
	        });
	        editor.contextToolbars = {};
	      });
	      editor.shortcuts.add('ctrl+F9', '', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.items()[0].focus();
	        }
	      });
	    };
	    var ContextToolbars = { addContextualToolbars: addContextualToolbars };
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isArray = isType('array');
	    var isFunction = isType('function');
	    var isNumber = isType('number');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Option.some(i);
	        }
	      }
	      return Option.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var defaultMenus = {
	      file: {
	        title: 'File',
	        items: 'newdocument restoredraft | preview | print'
	      },
	      edit: {
	        title: 'Edit',
	        items: 'undo redo | cut copy paste pastetext | selectall'
	      },
	      view: {
	        title: 'View',
	        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen'
	      },
	      insert: {
	        title: 'Insert',
	        items: 'image link media template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
	      },
	      format: {
	        title: 'Format',
	        items: 'bold italic underline strikethrough superscript subscript codeformat | blockformats align | removeformat'
	      },
	      tools: {
	        title: 'Tools',
	        items: 'spellchecker spellcheckerlanguage | a11ycheck code'
	      },
	      table: { title: 'Table' },
	      help: { title: 'Help' }
	    };
	    var delimiterMenuNamePair = function () {
	      return {
	        name: '|',
	        item: { text: '|' }
	      };
	    };
	    var createMenuNameItemPair = function (name, item) {
	      var menuItem = item ? {
	        name: name,
	        item: item
	      } : null;
	      return name === '|' ? delimiterMenuNamePair() : menuItem;
	    };
	    var hasItemName = function (namedMenuItems, name) {
	      return findIndex(namedMenuItems, function (namedMenuItem) {
	        return namedMenuItem.name === name;
	      }).isSome();
	    };
	    var isSeparator = function (namedMenuItem) {
	      return namedMenuItem && namedMenuItem.item.text === '|';
	    };
	    var cleanupMenu = function (namedMenuItems, removedMenuItems) {
	      var menuItemsPass1 = filter(namedMenuItems, function (namedMenuItem) {
	        return removedMenuItems.hasOwnProperty(namedMenuItem.name) === false;
	      });
	      var menuItemsPass2 = filter(menuItemsPass1, function (namedMenuItem, i) {
	        return !isSeparator(namedMenuItem) || !isSeparator(menuItemsPass1[i - 1]);
	      });
	      return filter(menuItemsPass2, function (namedMenuItem, i) {
	        return !isSeparator(namedMenuItem) || i > 0 && i < menuItemsPass2.length - 1;
	      });
	    };
	    var createMenu = function (editorMenuItems, menus, removedMenuItems, context) {
	      var menuButton, menu, namedMenuItems, isUserDefined;
	      if (menus) {
	        menu = menus[context];
	        isUserDefined = true;
	      } else {
	        menu = defaultMenus[context];
	      }
	      if (menu) {
	        menuButton = { text: menu.title };
	        namedMenuItems = [];
	        global$2.each((menu.items || '').split(/[ ,]/), function (name) {
	          var namedMenuItem = createMenuNameItemPair(name, editorMenuItems[name]);
	          if (namedMenuItem) {
	            namedMenuItems.push(namedMenuItem);
	          }
	        });
	        if (!isUserDefined) {
	          global$2.each(editorMenuItems, function (item, name) {
	            if (item.context === context && !hasItemName(namedMenuItems, name)) {
	              if (item.separator === 'before') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	              if (item.prependToContext) {
	                namedMenuItems.unshift(createMenuNameItemPair(name, item));
	              } else {
	                namedMenuItems.push(createMenuNameItemPair(name, item));
	              }
	              if (item.separator === 'after') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	            }
	          });
	        }
	        menuButton.menu = map(cleanupMenu(namedMenuItems, removedMenuItems), function (menuItem) {
	          return menuItem.item;
	        });
	        if (!menuButton.menu.length) {
	          return null;
	        }
	      }
	      return menuButton;
	    };
	    var getDefaultMenubar = function (editor) {
	      var name;
	      var defaultMenuBar = [];
	      var menu = getMenu(editor);
	      if (menu) {
	        for (name in menu) {
	          defaultMenuBar.push(name);
	        }
	      } else {
	        for (name in defaultMenus) {
	          defaultMenuBar.push(name);
	        }
	      }
	      return defaultMenuBar;
	    };
	    var createMenuButtons = function (editor) {
	      var menuButtons = [];
	      var defaultMenuBar = getDefaultMenubar(editor);
	      var removedMenuItems = global$2.makeMap(getRemovedMenuItems(editor).split(/[ ,]/));
	      var menubar = getMenubar(editor);
	      var enabledMenuNames = typeof menubar === 'string' ? menubar.split(/[ ,]/) : defaultMenuBar;
	      for (var i = 0; i < enabledMenuNames.length; i++) {
	        var menuItems = enabledMenuNames[i];
	        var menu = createMenu(editor.menuItems, getMenu(editor), removedMenuItems, menuItems);
	        if (menu) {
	          menuButtons.push(menu);
	        }
	      }
	      return menuButtons;
	    };
	    var Menubar = { createMenuButtons: createMenuButtons };
	
	    var DOM$1 = global$3.DOM;
	    var getSize = function (elm) {
	      return {
	        width: elm.clientWidth,
	        height: elm.clientHeight
	      };
	    };
	    var resizeTo = function (editor, width, height) {
	      var containerElm, iframeElm, containerSize, iframeSize;
	      containerElm = editor.getContainer();
	      iframeElm = editor.getContentAreaContainer().firstChild;
	      containerSize = getSize(containerElm);
	      iframeSize = getSize(iframeElm);
	      if (width !== null) {
	        width = Math.max(getMinWidth(editor), width);
	        width = Math.min(getMaxWidth(editor), width);
	        DOM$1.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
	        DOM$1.setStyle(iframeElm, 'width', width);
	      }
	      height = Math.max(getMinHeight(editor), height);
	      height = Math.min(getMaxHeight(editor), height);
	      DOM$1.setStyle(iframeElm, 'height', height);
	      Events.fireResizeEditor(editor);
	    };
	    var resizeBy = function (editor, dw, dh) {
	      var elm = editor.getContentAreaContainer();
	      resizeTo(editor, elm.clientWidth + dw, elm.clientHeight + dh);
	    };
	    var Resize = {
	      resizeTo: resizeTo,
	      resizeBy: resizeBy
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var api = function (elm) {
	      return {
	        element: function () {
	          return elm;
	        }
	      };
	    };
	    var trigger = function (sidebar, panel, callbackName) {
	      var callback = sidebar.settings[callbackName];
	      if (callback) {
	        callback(api(panel.getEl('body')));
	      }
	    };
	    var hidePanels = function (name, container, sidebars) {
	      global$2.each(sidebars, function (sidebar) {
	        var panel = container.items().filter('#' + sidebar.name)[0];
	        if (panel && panel.visible() && sidebar.name !== name) {
	          trigger(sidebar, panel, 'onhide');
	          panel.visible(false);
	        }
	      });
	    };
	    var deactivateButtons = function (toolbar) {
	      toolbar.items().each(function (ctrl) {
	        ctrl.active(false);
	      });
	    };
	    var findSidebar = function (sidebars, name) {
	      return global$2.grep(sidebars, function (sidebar) {
	        return sidebar.name === name;
	      })[0];
	    };
	    var showPanel = function (editor, name, sidebars) {
	      return function (e) {
	        var btnCtrl = e.control;
	        var container = btnCtrl.parents().filter('panel')[0];
	        var panel = container.find('#' + name)[0];
	        var sidebar = findSidebar(sidebars, name);
	        hidePanels(name, container, sidebars);
	        deactivateButtons(btnCtrl.parent());
	        if (panel && panel.visible()) {
	          trigger(sidebar, panel, 'onhide');
	          panel.hide();
	          btnCtrl.active(false);
	        } else {
	          if (panel) {
	            panel.show();
	            trigger(sidebar, panel, 'onshow');
	          } else {
	            panel = global$4.create({
	              type: 'container',
	              name: name,
	              layout: 'stack',
	              classes: 'sidebar-panel',
	              html: ''
	            });
	            container.prepend(panel);
	            trigger(sidebar, panel, 'onrender');
	            trigger(sidebar, panel, 'onshow');
	          }
	          btnCtrl.active(true);
	        }
	        Events.fireResizeEditor(editor);
	      };
	    };
	    var isModernBrowser = function () {
	      return !global$8.ie || global$8.ie >= 11;
	    };
	    var hasSidebar = function (editor) {
	      return isModernBrowser() && editor.sidebars ? editor.sidebars.length > 0 : false;
	    };
	    var createSidebar = function (editor) {
	      var buttons = global$2.map(editor.sidebars, function (sidebar) {
	        var settings = sidebar.settings;
	        return {
	          type: 'button',
	          icon: settings.icon,
	          image: settings.image,
	          tooltip: settings.tooltip,
	          onclick: showPanel(editor, sidebar.name, editor.sidebars)
	        };
	      });
	      return {
	        type: 'panel',
	        name: 'sidebar',
	        layout: 'stack',
	        classes: 'sidebar',
	        items: [{
	            type: 'toolbar',
	            layout: 'stack',
	            classes: 'sidebar-toolbar',
	            items: buttons
	          }]
	      };
	    };
	    var Sidebar = {
	      hasSidebar: hasSidebar,
	      createSidebar: createSidebar
	    };
	
	    var fireSkinLoaded$1 = function (editor) {
	      var done = function () {
	        editor._skinLoaded = true;
	        Events.fireSkinLoaded(editor);
	      };
	      return function () {
	        if (editor.initialized) {
	          done();
	        } else {
	          editor.on('init', done);
	        }
	      };
	    };
	    var SkinLoaded = { fireSkinLoaded: fireSkinLoaded$1 };
	
	    var DOM$2 = global$3.DOM;
	    var switchMode = function (panel) {
	      return function (e) {
	        panel.find('*').disabled(e.mode === 'readonly');
	      };
	    };
	    var editArea = function (border) {
	      return {
	        type: 'panel',
	        name: 'iframe',
	        layout: 'stack',
	        classes: 'edit-area',
	        border: border,
	        html: ''
	      };
	    };
	    var editAreaContainer = function (editor) {
	      return {
	        type: 'panel',
	        layout: 'stack',
	        classes: 'edit-aria-container',
	        border: '1 0 0 0',
	        items: [
	          editArea('0'),
	          Sidebar.createSidebar(editor)
	        ]
	      };
	    };
	    var render = function (editor, theme, args) {
	      var panel, resizeHandleCtrl, startSize;
	      if (isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM$2.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	      panel = theme.panel = global$4.create({
	        type: 'panel',
	        role: 'application',
	        classes: 'tinymce',
	        style: 'visibility: hidden',
	        layout: 'stack',
	        border: 1,
	        items: [
	          {
	            type: 'container',
	            classes: 'top-part',
	            items: [
	              hasMenubar(editor) === false ? null : {
	                type: 'menubar',
	                border: '0 0 1 0',
	                items: Menubar.createMenuButtons(editor)
	              },
	              Toolbar.createToolbars(editor, getToolbarSize(editor))
	            ]
	          },
	          Sidebar.hasSidebar(editor) ? editAreaContainer(editor) : editArea('1 0 0 0')
	        ]
	      });
	      UiContainer.setUiContainer(editor, panel);
	      if (getResize(editor) !== 'none') {
	        resizeHandleCtrl = {
	          type: 'resizehandle',
	          direction: getResize(editor),
	          onResizeStart: function () {
	            var elm = editor.getContentAreaContainer().firstChild;
	            startSize = {
	              width: elm.clientWidth,
	              height: elm.clientHeight
	            };
	          },
	          onResize: function (e) {
	            if (getResize(editor) === 'both') {
	              Resize.resizeTo(editor, startSize.width + e.deltaX, startSize.height + e.deltaY);
	            } else {
	              Resize.resizeTo(editor, null, startSize.height + e.deltaY);
	            }
	          }
	        };
	      }
	      if (hasStatusbar(editor)) {
	        var linkHtml = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce" rel="noopener" target="_blank" role="presentation" tabindex="-1">Tiny</a>';
	        var html = global$5.translate([
	          'Powered by {0}',
	          linkHtml
	        ]);
	        var brandingLabel = isBrandingEnabled(editor) ? {
	          type: 'label',
	          classes: 'branding',
	          html: ' ' + html
	        } : null;
	        panel.add({
	          type: 'panel',
	          name: 'statusbar',
	          classes: 'statusbar',
	          layout: 'flow',
	          border: '1 0 0 0',
	          ariaRoot: true,
	          items: [
	            {
	              type: 'elementpath',
	              editor: editor
	            },
	            resizeHandleCtrl,
	            brandingLabel
	          ]
	        });
	      }
	      Events.fireBeforeRenderUI(editor);
	      editor.on('SwitchMode', switchMode(panel));
	      panel.renderBefore(args.targetNode).reflow();
	      if (isReadOnly(editor)) {
	        editor.setMode('readonly');
	      }
	      if (args.width) {
	        DOM$2.setStyle(panel.getEl(), 'width', args.width);
	      }
	      editor.on('remove', function () {
	        panel.remove();
	        panel = null;
	      });
	      A11y.addKeys(editor, panel);
	      ContextToolbars.addContextualToolbars(editor);
	      return {
	        iframeContainer: panel.find('#iframe')[0].getEl(),
	        editorContainer: panel.getEl()
	      };
	    };
	    var Iframe = { render: render };
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var count = 0;
	    var funcs = {
	      id: function () {
	        return 'mceu_' + count++;
	      },
	      create: function (name, attrs, children) {
	        var elm = domGlobals.document.createElement(name);
	        global$3.DOM.setAttribs(elm, attrs);
	        if (typeof children === 'string') {
	          elm.innerHTML = children;
	        } else {
	          global$2.each(children, function (child) {
	            if (child.nodeType) {
	              elm.appendChild(child);
	            }
	          });
	        }
	        return elm;
	      },
	      createFragment: function (html) {
	        return global$3.DOM.createFragment(html);
	      },
	      getWindowSize: function () {
	        return global$3.DOM.getViewPort();
	      },
	      getSize: function (elm) {
	        var width, height;
	        if (elm.getBoundingClientRect) {
	          var rect = elm.getBoundingClientRect();
	          width = Math.max(rect.width || rect.right - rect.left, elm.offsetWidth);
	          height = Math.max(rect.height || rect.bottom - rect.bottom, elm.offsetHeight);
	        } else {
	          width = elm.offsetWidth;
	          height = elm.offsetHeight;
	        }
	        return {
	          width: width,
	          height: height
	        };
	      },
	      getPos: function (elm, root) {
	        return global$3.DOM.getPos(elm, root || funcs.getContainer());
	      },
	      getContainer: function () {
	        return global$8.container ? global$8.container : domGlobals.document.body;
	      },
	      getViewPort: function (win) {
	        return global$3.DOM.getViewPort(win);
	      },
	      get: function (id) {
	        return domGlobals.document.getElementById(id);
	      },
	      addClass: function (elm, cls) {
	        return global$3.DOM.addClass(elm, cls);
	      },
	      removeClass: function (elm, cls) {
	        return global$3.DOM.removeClass(elm, cls);
	      },
	      hasClass: function (elm, cls) {
	        return global$3.DOM.hasClass(elm, cls);
	      },
	      toggleClass: function (elm, cls, state) {
	        return global$3.DOM.toggleClass(elm, cls, state);
	      },
	      css: function (elm, name, value) {
	        return global$3.DOM.setStyle(elm, name, value);
	      },
	      getRuntimeStyle: function (elm, name) {
	        return global$3.DOM.getStyle(elm, name, true);
	      },
	      on: function (target, name, callback, scope) {
	        return global$3.DOM.bind(target, name, callback, scope);
	      },
	      off: function (target, name, callback) {
	        return global$3.DOM.unbind(target, name, callback);
	      },
	      fire: function (target, name, args) {
	        return global$3.DOM.fire(target, name, args);
	      },
	      innerHtml: function (elm, html) {
	        global$3.DOM.setHTML(elm, html);
	      }
	    };
	
	    var isStatic = function (elm) {
	      return funcs.getRuntimeStyle(elm, 'position') === 'static';
	    };
	    var isFixed = function (ctrl) {
	      return ctrl.state.get('fixed');
	    };
	    function calculateRelativePosition(ctrl, targetElm, rel) {
	      var ctrlElm, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
	      viewport = getWindowViewPort();
	      pos = funcs.getPos(targetElm, UiContainer.getUiContainer(ctrl));
	      x = pos.x;
	      y = pos.y;
	      if (isFixed(ctrl) && isStatic(domGlobals.document.body)) {
	        x -= viewport.x;
	        y -= viewport.y;
	      }
	      ctrlElm = ctrl.getEl();
	      size = funcs.getSize(ctrlElm);
	      selfW = size.width;
	      selfH = size.height;
	      size = funcs.getSize(targetElm);
	      targetW = size.width;
	      targetH = size.height;
	      rel = (rel || '').split('');
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	      if (rel[0] === 'c') {
	        y += Math.round(targetH / 2);
	      }
	      if (rel[1] === 'c') {
	        x += Math.round(targetW / 2);
	      }
	      if (rel[3] === 'b') {
	        y -= selfH;
	      }
	      if (rel[4] === 'r') {
	        x -= selfW;
	      }
	      if (rel[3] === 'c') {
	        y -= Math.round(selfH / 2);
	      }
	      if (rel[4] === 'c') {
	        x -= Math.round(selfW / 2);
	      }
	      return {
	        x: x,
	        y: y,
	        w: selfW,
	        h: selfH
	      };
	    }
	    var getUiContainerViewPort = function (customUiContainer) {
	      return {
	        x: 0,
	        y: 0,
	        w: customUiContainer.scrollWidth - 1,
	        h: customUiContainer.scrollHeight - 1
	      };
	    };
	    var getWindowViewPort = function () {
	      var win = domGlobals.window;
	      var x = Math.max(win.pageXOffset, domGlobals.document.body.scrollLeft, domGlobals.document.documentElement.scrollLeft);
	      var y = Math.max(win.pageYOffset, domGlobals.document.body.scrollTop, domGlobals.document.documentElement.scrollTop);
	      var w = win.innerWidth || domGlobals.document.documentElement.clientWidth;
	      var h = win.innerHeight || domGlobals.document.documentElement.clientHeight;
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var getViewPortRect = function (ctrl) {
	      var customUiContainer = UiContainer.getUiContainer(ctrl);
	      return customUiContainer && !isFixed(ctrl) ? getUiContainerViewPort(customUiContainer) : getWindowViewPort();
	    };
	    var Movable = {
	      testMoveRel: function (elm, rels) {
	        var viewPortRect = getViewPortRect(this);
	        for (var i = 0; i < rels.length; i++) {
	          var pos = calculateRelativePosition(this, elm, rels[i]);
	          if (isFixed(this)) {
	            if (pos.x > 0 && pos.x + pos.w < viewPortRect.w && pos.y > 0 && pos.y + pos.h < viewPortRect.h) {
	              return rels[i];
	            }
	          } else {
	            if (pos.x > viewPortRect.x && pos.x + pos.w < viewPortRect.w + viewPortRect.x && pos.y > viewPortRect.y && pos.y + pos.h < viewPortRect.h + viewPortRect.y) {
	              return rels[i];
	            }
	          }
	        }
	        return rels[0];
	      },
	      moveRel: function (elm, rel) {
	        if (typeof rel !== 'string') {
	          rel = this.testMoveRel(elm, rel);
	        }
	        var pos = calculateRelativePosition(this, elm, rel);
	        return this.moveTo(pos.x, pos.y);
	      },
	      moveBy: function (dx, dy) {
	        var self = this, rect = self.layoutRect();
	        self.moveTo(rect.x + dx, rect.y + dy);
	        return self;
	      },
	      moveTo: function (x, y) {
	        var self = this;
	        function constrain(value, max, size) {
	          if (value < 0) {
	            return 0;
	          }
	          if (value + size > max) {
	            value = max - size;
	            return value < 0 ? 0 : value;
	          }
	          return value;
	        }
	        if (self.settings.constrainToViewport) {
	          var viewPortRect = getViewPortRect(this);
	          var layoutRect = self.layoutRect();
	          x = constrain(x, viewPortRect.w + viewPortRect.x, layoutRect.w);
	          y = constrain(y, viewPortRect.h + viewPortRect.y, layoutRect.h);
	        }
	        var uiContainer = UiContainer.getUiContainer(self);
	        if (uiContainer && isStatic(uiContainer) && !isFixed(self)) {
	          x -= uiContainer.scrollLeft;
	          y -= uiContainer.scrollTop;
	        }
	        if (uiContainer) {
	          x += 1;
	          y += 1;
	        }
	        if (self.state.get('rendered')) {
	          self.layoutRect({
	            x: x,
	            y: y
	          }).repaint();
	        } else {
	          self.settings.x = x;
	          self.settings.y = y;
	        }
	        self.fire('move', {
	          x: x,
	          y: y
	        });
	        return self;
	      }
	    };
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.util.Class');
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.util.EventDispatcher');
	
	    var BoxUtils = {
	      parseBox: function (value) {
	        var len;
	        var radix = 10;
	        if (!value) {
	          return;
	        }
	        if (typeof value === 'number') {
	          value = value || 0;
	          return {
	            top: value,
	            left: value,
	            bottom: value,
	            right: value
	          };
	        }
	        value = value.split(' ');
	        len = value.length;
	        if (len === 1) {
	          value[1] = value[2] = value[3] = value[0];
	        } else if (len === 2) {
	          value[2] = value[0];
	          value[3] = value[1];
	        } else if (len === 3) {
	          value[3] = value[1];
	        }
	        return {
	          top: parseInt(value[0], radix) || 0,
	          right: parseInt(value[1], radix) || 0,
	          bottom: parseInt(value[2], radix) || 0,
	          left: parseInt(value[3], radix) || 0
	        };
	      },
	      measureBox: function (elm, prefix) {
	        function getStyle(name) {
	          var defaultView = elm.ownerDocument.defaultView;
	          if (defaultView) {
	            var computedStyle = defaultView.getComputedStyle(elm, null);
	            if (computedStyle) {
	              name = name.replace(/[A-Z]/g, function (a) {
	                return '-' + a;
	              });
	              return computedStyle.getPropertyValue(name);
	            } else {
	              return null;
	            }
	          }
	          return elm.currentStyle[name];
	        }
	        function getSide(name) {
	          var val = parseFloat(getStyle(name));
	          return isNaN(val) ? 0 : val;
	        }
	        return {
	          top: getSide(prefix + 'TopWidth'),
	          right: getSide(prefix + 'RightWidth'),
	          bottom: getSide(prefix + 'BottomWidth'),
	          left: getSide(prefix + 'LeftWidth')
	        };
	      }
	    };
	
	    function noop$1() {
	    }
	    function ClassList(onchange) {
	      this.cls = [];
	      this.cls._map = {};
	      this.onchange = onchange || noop$1;
	      this.prefix = '';
	    }
	    global$2.extend(ClassList.prototype, {
	      add: function (cls) {
	        if (cls && !this.contains(cls)) {
	          this.cls._map[cls] = true;
	          this.cls.push(cls);
	          this._change();
	        }
	        return this;
	      },
	      remove: function (cls) {
	        if (this.contains(cls)) {
	          var i = void 0;
	          for (i = 0; i < this.cls.length; i++) {
	            if (this.cls[i] === cls) {
	              break;
	            }
	          }
	          this.cls.splice(i, 1);
	          delete this.cls._map[cls];
	          this._change();
	        }
	        return this;
	      },
	      toggle: function (cls, state) {
	        var curState = this.contains(cls);
	        if (curState !== state) {
	          if (curState) {
	            this.remove(cls);
	          } else {
	            this.add(cls);
	          }
	          this._change();
	        }
	        return this;
	      },
	      contains: function (cls) {
	        return !!this.cls._map[cls];
	      },
	      _change: function () {
	        delete this.clsValue;
	        this.onchange.call(this);
	      }
	    });
	    ClassList.prototype.toString = function () {
	      var value;
	      if (this.clsValue) {
	        return this.clsValue;
	      }
	      value = '';
	      for (var i = 0; i < this.cls.length; i++) {
	        if (i > 0) {
	          value += ' ';
	        }
	        value += this.prefix + this.cls[i];
	      }
	      return value;
	    };
	
	    function unique(array) {
	      var uniqueItems = [];
	      var i = array.length, item;
	      while (i--) {
	        item = array[i];
	        if (!item.__checked) {
	          uniqueItems.push(item);
	          item.__checked = 1;
	        }
	      }
	      i = uniqueItems.length;
	      while (i--) {
	        delete uniqueItems[i].__checked;
	      }
	      return uniqueItems;
	    }
	    var expression = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
	    var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g;
	    var whiteSpace = /^\s*|\s*$/g;
	    var Collection;
	    var Selector = global$a.extend({
	      init: function (selector) {
	        var match = this.match;
	        function compileNameFilter(name) {
	          if (name) {
	            name = name.toLowerCase();
	            return function (item) {
	              return name === '*' || item.type === name;
	            };
	          }
	        }
	        function compileIdFilter(id) {
	          if (id) {
	            return function (item) {
	              return item._name === id;
	            };
	          }
	        }
	        function compileClassesFilter(classes) {
	          if (classes) {
	            classes = classes.split('.');
	            return function (item) {
	              var i = classes.length;
	              while (i--) {
	                if (!item.classes.contains(classes[i])) {
	                  return false;
	                }
	              }
	              return true;
	            };
	          }
	        }
	        function compileAttrFilter(name, cmp, check) {
	          if (name) {
	            return function (item) {
	              var value = item[name] ? item[name]() : '';
	              return !cmp ? !!check : cmp === '=' ? value === check : cmp === '*=' ? value.indexOf(check) >= 0 : cmp === '~=' ? (' ' + value + ' ').indexOf(' ' + check + ' ') >= 0 : cmp === '!=' ? value !== check : cmp === '^=' ? value.indexOf(check) === 0 : cmp === '$=' ? value.substr(value.length - check.length) === check : false;
	            };
	          }
	        }
	        function compilePsuedoFilter(name) {
	          var notSelectors;
	          if (name) {
	            name = /(?:not\((.+)\))|(.+)/i.exec(name);
	            if (!name[1]) {
	              name = name[2];
	              return function (item, index, length) {
	                return name === 'first' ? index === 0 : name === 'last' ? index === length - 1 : name === 'even' ? index % 2 === 0 : name === 'odd' ? index % 2 === 1 : item[name] ? item[name]() : false;
	              };
	            }
	            notSelectors = parseChunks(name[1], []);
	            return function (item) {
	              return !match(item, notSelectors);
	            };
	          }
	        }
	        function compile(selector, filters, direct) {
	          var parts;
	          function add(filter) {
	            if (filter) {
	              filters.push(filter);
	            }
	          }
	          parts = expression.exec(selector.replace(whiteSpace, ''));
	          add(compileNameFilter(parts[1]));
	          add(compileIdFilter(parts[2]));
	          add(compileClassesFilter(parts[3]));
	          add(compileAttrFilter(parts[4], parts[5], parts[6]));
	          add(compilePsuedoFilter(parts[7]));
	          filters.pseudo = !!parts[7];
	          filters.direct = direct;
	          return filters;
	        }
	        function parseChunks(selector, selectors) {
	          var parts = [];
	          var extra, matches, i;
	          do {
	            chunker.exec('');
	            matches = chunker.exec(selector);
	            if (matches) {
	              selector = matches[3];
	              parts.push(matches[1]);
	              if (matches[2]) {
	                extra = matches[3];
	                break;
	              }
	            }
	          } while (matches);
	          if (extra) {
	            parseChunks(extra, selectors);
	          }
	          selector = [];
	          for (i = 0; i < parts.length; i++) {
	            if (parts[i] !== '>') {
	              selector.push(compile(parts[i], [], parts[i - 1] === '>'));
	            }
	          }
	          selectors.push(selector);
	          return selectors;
	        }
	        this._selectors = parseChunks(selector, []);
	      },
	      match: function (control, selectors) {
	        var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
	        selectors = selectors || this._selectors;
	        for (i = 0, l = selectors.length; i < l; i++) {
	          selector = selectors[i];
	          sl = selector.length;
	          item = control;
	          count = 0;
	          for (si = sl - 1; si >= 0; si--) {
	            filters = selector[si];
	            while (item) {
	              if (filters.pseudo) {
	                siblings = item.parent().items();
	                index = length = siblings.length;
	                while (index--) {
	                  if (siblings[index] === item) {
	                    break;
	                  }
	                }
	              }
	              for (fi = 0, fl = filters.length; fi < fl; fi++) {
	                if (!filters[fi](item, index, length)) {
	                  fi = fl + 1;
	                  break;
	                }
	              }
	              if (fi === fl) {
	                count++;
	                break;
	              } else {
	                if (si === sl - 1) {
	                  break;
	                }
	              }
	              item = item.parent();
	            }
	          }
	          if (count === sl) {
	            return true;
	          }
	        }
	        return false;
	      },
	      find: function (container) {
	        var matches = [], i, l;
	        var selectors = this._selectors;
	        function collect(items, selector, index) {
	          var i, l, fi, fl, item;
	          var filters = selector[index];
	          for (i = 0, l = items.length; i < l; i++) {
	            item = items[i];
	            for (fi = 0, fl = filters.length; fi < fl; fi++) {
	              if (!filters[fi](item, i, l)) {
	                fi = fl + 1;
	                break;
	              }
	            }
	            if (fi === fl) {
	              if (index === selector.length - 1) {
	                matches.push(item);
	              } else {
	                if (item.items) {
	                  collect(item.items(), selector, index + 1);
	                }
	              }
	            } else if (filters.direct) {
	              return;
	            }
	            if (item.items) {
	              collect(item.items(), selector, index);
	            }
	          }
	        }
	        if (container.items) {
	          for (i = 0, l = selectors.length; i < l; i++) {
	            collect(container.items(), selectors[i], 0);
	          }
	          if (l > 1) {
	            matches = unique(matches);
	          }
	        }
	        if (!Collection) {
	          Collection = Selector.Collection;
	        }
	        return new Collection(matches);
	      }
	    });
	
	    var Collection$1, proto;
	    var push = Array.prototype.push, slice = Array.prototype.slice;
	    proto = {
	      length: 0,
	      init: function (items) {
	        if (items) {
	          this.add(items);
	        }
	      },
	      add: function (items) {
	        var self = this;
	        if (!global$2.isArray(items)) {
	          if (items instanceof Collection$1) {
	            self.add(items.toArray());
	          } else {
	            push.call(self, items);
	          }
	        } else {
	          push.apply(self, items);
	        }
	        return self;
	      },
	      set: function (items) {
	        var self = this;
	        var len = self.length;
	        var i;
	        self.length = 0;
	        self.add(items);
	        for (i = self.length; i < len; i++) {
	          delete self[i];
	        }
	        return self;
	      },
	      filter: function (selector) {
	        var self = this;
	        var i, l;
	        var matches = [];
	        var item, match;
	        if (typeof selector === 'string') {
	          selector = new Selector(selector);
	          match = function (item) {
	            return selector.match(item);
	          };
	        } else {
	          match = selector;
	        }
	        for (i = 0, l = self.length; i < l; i++) {
	          item = self[i];
	          if (match(item)) {
	            matches.push(item);
	          }
	        }
	        return new Collection$1(matches);
	      },
	      slice: function () {
	        return new Collection$1(slice.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      each: function (callback) {
	        global$2.each(this, callback);
	        return this;
	      },
	      toArray: function () {
	        return global$2.toArray(this);
	      },
	      indexOf: function (ctrl) {
	        var self = this;
	        var i = self.length;
	        while (i--) {
	          if (self[i] === ctrl) {
	            break;
	          }
	        }
	        return i;
	      },
	      reverse: function () {
	        return new Collection$1(global$2.toArray(this).reverse());
	      },
	      hasClass: function (cls) {
	        return this[0] ? this[0].classes.contains(cls) : false;
	      },
	      prop: function (name, value) {
	        var self = this;
	        var item;
	        if (value !== undefined) {
	          self.each(function (item) {
	            if (item[name]) {
	              item[name](value);
	            }
	          });
	          return self;
	        }
	        item = self[0];
	        if (item && item[name]) {
	          return item[name]();
	        }
	      },
	      exec: function (name) {
	        var self = this, args = global$2.toArray(arguments).slice(1);
	        self.each(function (item) {
	          if (item[name]) {
	            item[name].apply(item, args);
	          }
	        });
	        return self;
	      },
	      remove: function () {
	        var i = this.length;
	        while (i--) {
	          this[i].remove();
	        }
	        return this;
	      },
	      addClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.add(cls);
	        });
	      },
	      removeClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.remove(cls);
	        });
	      }
	    };
	    global$2.each('fire on off show hide append prepend before after reflow'.split(' '), function (name) {
	      proto[name] = function () {
	        var args = global$2.toArray(arguments);
	        this.each(function (ctrl) {
	          if (name in ctrl) {
	            ctrl[name].apply(ctrl, args);
	          }
	        });
	        return this;
	      };
	    });
	    global$2.each('text name disabled active selected checked visible parent value data'.split(' '), function (name) {
	      proto[name] = function (value) {
	        return this.prop(name, value);
	      };
	    });
	    Collection$1 = global$a.extend(proto);
	    Selector.Collection = Collection$1;
	    var Collection$2 = Collection$1;
	
	    var Binding = function (settings) {
	      this.create = settings.create;
	    };
	    Binding.create = function (model, name) {
	      return new Binding({
	        create: function (otherModel, otherName) {
	          var bindings;
	          var fromSelfToOther = function (e) {
	            otherModel.set(otherName, e.value);
	          };
	          var fromOtherToSelf = function (e) {
	            model.set(name, e.value);
	          };
	          otherModel.on('change:' + otherName, fromOtherToSelf);
	          model.on('change:' + name, fromSelfToOther);
	          bindings = otherModel._bindings;
	          if (!bindings) {
	            bindings = otherModel._bindings = [];
	            otherModel.on('destroy', function () {
	              var i = bindings.length;
	              while (i--) {
	                bindings[i]();
	              }
	            });
	          }
	          bindings.push(function () {
	            model.off('change:' + name, fromSelfToOther);
	          });
	          return model.get(name);
	        }
	      });
	    };
	
	    var global$c = tinymce.util.Tools.resolve('tinymce.util.Observable');
	
	    function isNode(node) {
	      return node.nodeType > 0;
	    }
	    function isEqual(a, b) {
	      var k, checked;
	      if (a === b) {
	        return true;
	      }
	      if (a === null || b === null) {
	        return a === b;
	      }
	      if (typeof a !== 'object' || typeof b !== 'object') {
	        return a === b;
	      }
	      if (global$2.isArray(b)) {
	        if (a.length !== b.length) {
	          return false;
	        }
	        k = a.length;
	        while (k--) {
	          if (!isEqual(a[k], b[k])) {
	            return false;
	          }
	        }
	      }
	      if (isNode(a) || isNode(b)) {
	        return a === b;
	      }
	      checked = {};
	      for (k in b) {
	        if (!isEqual(a[k], b[k])) {
	          return false;
	        }
	        checked[k] = true;
	      }
	      for (k in a) {
	        if (!checked[k] && !isEqual(a[k], b[k])) {
	          return false;
	        }
	      }
	      return true;
	    }
	    var ObservableObject = global$a.extend({
	      Mixins: [global$c],
	      init: function (data) {
	        var name, value;
	        data = data || {};
	        for (name in data) {
	          value = data[name];
	          if (value instanceof Binding) {
	            data[name] = value.create(this, name);
	          }
	        }
	        this.data = data;
	      },
	      set: function (name, value) {
	        var key, args;
	        var oldValue = this.data[name];
	        if (value instanceof Binding) {
	          value = value.create(this, name);
	        }
	        if (typeof name === 'object') {
	          for (key in name) {
	            this.set(key, name[key]);
	          }
	          return this;
	        }
	        if (!isEqual(oldValue, value)) {
	          this.data[name] = value;
	          args = {
	            target: this,
	            name: name,
	            value: value,
	            oldValue: oldValue
	          };
	          this.fire('change:' + name, args);
	          this.fire('change', args);
	        }
	        return this;
	      },
	      get: function (name) {
	        return this.data[name];
	      },
	      has: function (name) {
	        return name in this.data;
	      },
	      bind: function (name) {
	        return Binding.create(this, name);
	      },
	      destroy: function () {
	        this.fire('destroy');
	      }
	    });
	
	    var dirtyCtrls = {}, animationFrameRequested;
	    var ReflowQueue = {
	      add: function (ctrl) {
	        var parent = ctrl.parent();
	        if (parent) {
	          if (!parent._layout || parent._layout.isNative()) {
	            return;
	          }
	          if (!dirtyCtrls[parent._id]) {
	            dirtyCtrls[parent._id] = parent;
	          }
	          if (!animationFrameRequested) {
	            animationFrameRequested = true;
	            global$7.requestAnimationFrame(function () {
	              var id, ctrl;
	              animationFrameRequested = false;
	              for (id in dirtyCtrls) {
	                ctrl = dirtyCtrls[id];
	                if (ctrl.state.get('rendered')) {
	                  ctrl.reflow();
	                }
	              }
	              dirtyCtrls = {};
	            }, domGlobals.document.body);
	          }
	        }
	      },
	      remove: function (ctrl) {
	        if (dirtyCtrls[ctrl._id]) {
	          delete dirtyCtrls[ctrl._id];
	        }
	      }
	    };
	
	    var hasMouseWheelEventSupport = 'onmousewheel' in domGlobals.document;
	    var hasWheelEventSupport = false;
	    var classPrefix = 'mce-';
	    var Control, idCounter = 0;
	    var proto$1 = {
	      Statics: { classPrefix: classPrefix },
	      isRtl: function () {
	        return Control.rtl;
	      },
	      classPrefix: classPrefix,
	      init: function (settings) {
	        var self = this;
	        var classes, defaultClasses;
	        function applyClasses(classes) {
	          var i;
	          classes = classes.split(' ');
	          for (i = 0; i < classes.length; i++) {
	            self.classes.add(classes[i]);
	          }
	        }
	        self.settings = settings = global$2.extend({}, self.Defaults, settings);
	        self._id = settings.id || 'mceu_' + idCounter++;
	        self._aria = { role: settings.role };
	        self._elmCache = {};
	        self.$ = global$9;
	        self.state = new ObservableObject({
	          visible: true,
	          active: false,
	          disabled: false,
	          value: ''
	        });
	        self.data = new ObservableObject(settings.data);
	        self.classes = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl().className = this.toString();
	          }
	        });
	        self.classes.prefix = self.classPrefix;
	        classes = settings.classes;
	        if (classes) {
	          if (self.Defaults) {
	            defaultClasses = self.Defaults.classes;
	            if (defaultClasses && classes !== defaultClasses) {
	              applyClasses(defaultClasses);
	            }
	          }
	          applyClasses(classes);
	        }
	        global$2.each('title text name visible disabled active value'.split(' '), function (name) {
	          if (name in settings) {
	            self[name](settings[name]);
	          }
	        });
	        self.on('click', function () {
	          if (self.disabled()) {
	            return false;
	          }
	        });
	        self.settings = settings;
	        self.borderBox = BoxUtils.parseBox(settings.border);
	        self.paddingBox = BoxUtils.parseBox(settings.padding);
	        self.marginBox = BoxUtils.parseBox(settings.margin);
	        if (settings.hidden) {
	          self.hide();
	        }
	      },
	      Properties: 'parent,name',
	      getContainerElm: function () {
	        var uiContainer = UiContainer.getUiContainer(this);
	        return uiContainer ? uiContainer : funcs.getContainer();
	      },
	      getParentCtrl: function (elm) {
	        var ctrl;
	        var lookup = this.getRoot().controlIdLookup;
	        while (elm && lookup) {
	          ctrl = lookup[elm.id];
	          if (ctrl) {
	            break;
	          }
	          elm = elm.parentNode;
	        }
	        return ctrl;
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var settings = self.settings;
	        var borderBox, layoutRect;
	        var elm = self.getEl();
	        var width, height, minWidth, minHeight, autoResize;
	        var startMinWidth, startMinHeight, initialSize;
	        borderBox = self.borderBox = self.borderBox || BoxUtils.measureBox(elm, 'border');
	        self.paddingBox = self.paddingBox || BoxUtils.measureBox(elm, 'padding');
	        self.marginBox = self.marginBox || BoxUtils.measureBox(elm, 'margin');
	        initialSize = funcs.getSize(elm);
	        startMinWidth = settings.minWidth;
	        startMinHeight = settings.minHeight;
	        minWidth = startMinWidth || initialSize.width;
	        minHeight = startMinHeight || initialSize.height;
	        width = settings.width;
	        height = settings.height;
	        autoResize = settings.autoResize;
	        autoResize = typeof autoResize !== 'undefined' ? autoResize : !width && !height;
	        width = width || minWidth;
	        height = height || minHeight;
	        var deltaW = borderBox.left + borderBox.right;
	        var deltaH = borderBox.top + borderBox.bottom;
	        var maxW = settings.maxWidth || 65535;
	        var maxH = settings.maxHeight || 65535;
	        self._layoutRect = layoutRect = {
	          x: settings.x || 0,
	          y: settings.y || 0,
	          w: width,
	          h: height,
	          deltaW: deltaW,
	          deltaH: deltaH,
	          contentW: width - deltaW,
	          contentH: height - deltaH,
	          innerW: width - deltaW,
	          innerH: height - deltaH,
	          startMinWidth: startMinWidth || 0,
	          startMinHeight: startMinHeight || 0,
	          minW: Math.min(minWidth, maxW),
	          minH: Math.min(minHeight, maxH),
	          maxW: maxW,
	          maxH: maxH,
	          autoResize: autoResize,
	          scrollW: 0
	        };
	        self._lastLayoutRect = {};
	        return layoutRect;
	      },
	      layoutRect: function (newRect) {
	        var self = this;
	        var curRect = self._layoutRect, lastLayoutRect, size, deltaWidth, deltaHeight, repaintControls;
	        if (!curRect) {
	          curRect = self.initLayoutRect();
	        }
	        if (newRect) {
	          deltaWidth = curRect.deltaW;
	          deltaHeight = curRect.deltaH;
	          if (newRect.x !== undefined) {
	            curRect.x = newRect.x;
	          }
	          if (newRect.y !== undefined) {
	            curRect.y = newRect.y;
	          }
	          if (newRect.minW !== undefined) {
	            curRect.minW = newRect.minW;
	          }
	          if (newRect.minH !== undefined) {
	            curRect.minH = newRect.minH;
	          }
	          size = newRect.w;
	          if (size !== undefined) {
	            size = size < curRect.minW ? curRect.minW : size;
	            size = size > curRect.maxW ? curRect.maxW : size;
	            curRect.w = size;
	            curRect.innerW = size - deltaWidth;
	          }
	          size = newRect.h;
	          if (size !== undefined) {
	            size = size < curRect.minH ? curRect.minH : size;
	            size = size > curRect.maxH ? curRect.maxH : size;
	            curRect.h = size;
	            curRect.innerH = size - deltaHeight;
	          }
	          size = newRect.innerW;
	          if (size !== undefined) {
	            size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
	            size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
	            curRect.innerW = size;
	            curRect.w = size + deltaWidth;
	          }
	          size = newRect.innerH;
	          if (size !== undefined) {
	            size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
	            size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
	            curRect.innerH = size;
	            curRect.h = size + deltaHeight;
	          }
	          if (newRect.contentW !== undefined) {
	            curRect.contentW = newRect.contentW;
	          }
	          if (newRect.contentH !== undefined) {
	            curRect.contentH = newRect.contentH;
	          }
	          lastLayoutRect = self._lastLayoutRect;
	          if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y || lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
	            repaintControls = Control.repaintControls;
	            if (repaintControls) {
	              if (repaintControls.map && !repaintControls.map[self._id]) {
	                repaintControls.push(self);
	                repaintControls.map[self._id] = true;
	              }
	            }
	            lastLayoutRect.x = curRect.x;
	            lastLayoutRect.y = curRect.y;
	            lastLayoutRect.w = curRect.w;
	            lastLayoutRect.h = curRect.h;
	          }
	          return self;
	        }
	        return curRect;
	      },
	      repaint: function () {
	        var self = this;
	        var style, bodyStyle, bodyElm, rect, borderBox;
	        var borderW, borderH, lastRepaintRect, round, value;
	        round = !domGlobals.document.createRange ? Math.round : function (value) {
	          return value;
	        };
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right;
	        borderH = borderBox.top + borderBox.bottom;
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = round(rect.x) + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = round(rect.y) + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	        if (rect.w !== lastRepaintRect.w) {
	          value = round(rect.w - borderW);
	          style.width = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	        if (rect.h !== lastRepaintRect.h) {
	          value = round(rect.h - borderH);
	          style.height = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	        if (self._hasBody && rect.innerW !== lastRepaintRect.innerW) {
	          value = round(rect.innerW);
	          bodyElm = self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyElm.style;
	            bodyStyle.width = (value >= 0 ? value : 0) + 'px';
	          }
	          lastRepaintRect.innerW = rect.innerW;
	        }
	        if (self._hasBody && rect.innerH !== lastRepaintRect.innerH) {
	          value = round(rect.innerH);
	          bodyElm = bodyElm || self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyStyle || bodyElm.style;
	            bodyStyle.height = (value >= 0 ? value : 0) + 'px';
	          }
	          lastRepaintRect.innerH = rect.innerH;
	        }
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	      },
	      updateLayoutRect: function () {
	        var self = this;
	        self.parent()._lastRect = null;
	        funcs.css(self.getEl(), {
	          width: '',
	          height: ''
	        });
	        self._layoutRect = self._lastRepaintRect = self._lastLayoutRect = null;
	        self.initLayoutRect();
	      },
	      on: function (name, callback) {
	        var self = this;
	        function resolveCallbackName(name) {
	          var callback, scope;
	          if (typeof name !== 'string') {
	            return name;
	          }
	          return function (e) {
	            if (!callback) {
	              self.parentsAndSelf().each(function (ctrl) {
	                var callbacks = ctrl.settings.callbacks;
	                if (callbacks && (callback = callbacks[name])) {
	                  scope = ctrl;
	                  return false;
	                }
	              });
	            }
	            if (!callback) {
	              e.action = name;
	              this.fire('execute', e);
	              return;
	            }
	            return callback.call(scope, e);
	          };
	        }
	        getEventDispatcher(self).on(name, resolveCallbackName(callback));
	        return self;
	      },
	      off: function (name, callback) {
	        getEventDispatcher(this).off(name, callback);
	        return this;
	      },
	      fire: function (name, args, bubble) {
	        var self = this;
	        args = args || {};
	        if (!args.control) {
	          args.control = self;
	        }
	        args = getEventDispatcher(self).fire(name, args);
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	        return args;
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      },
	      parents: function (selector) {
	        var self = this;
	        var ctrl, parents = new Collection$2();
	        for (ctrl = self.parent(); ctrl; ctrl = ctrl.parent()) {
	          parents.add(ctrl);
	        }
	        if (selector) {
	          parents = parents.filter(selector);
	        }
	        return parents;
	      },
	      parentsAndSelf: function (selector) {
	        return new Collection$2(this).add(this.parents(selector));
	      },
	      next: function () {
	        var parentControls = this.parent().items();
	        return parentControls[parentControls.indexOf(this) + 1];
	      },
	      prev: function () {
	        var parentControls = this.parent().items();
	        return parentControls[parentControls.indexOf(this) - 1];
	      },
	      innerHtml: function (html) {
	        this.$el.html(html);
	        return this;
	      },
	      getEl: function (suffix) {
	        var id = suffix ? this._id + '-' + suffix : this._id;
	        if (!this._elmCache[id]) {
	          this._elmCache[id] = global$9('#' + id)[0];
	        }
	        return this._elmCache[id];
	      },
	      show: function () {
	        return this.visible(true);
	      },
	      hide: function () {
	        return this.visible(false);
	      },
	      focus: function () {
	        try {
	          this.getEl().focus();
	        } catch (ex) {
	        }
	        return this;
	      },
	      blur: function () {
	        this.getEl().blur();
	        return this;
	      },
	      aria: function (name, value) {
	        var self = this, elm = self.getEl(self.ariaTarget);
	        if (typeof value === 'undefined') {
	          return self._aria[name];
	        }
	        self._aria[name] = value;
	        if (self.state.get('rendered')) {
	          elm.setAttribute(name === 'role' ? name : 'aria-' + name, value);
	        }
	        return self;
	      },
	      encode: function (text, translate) {
	        if (translate !== false) {
	          text = this.translate(text);
	        }
	        return (text || '').replace(/[&<>"]/g, function (match) {
	          return '&#' + match.charCodeAt(0) + ';';
	        });
	      },
	      translate: function (text) {
	        return Control.translate ? Control.translate(text) : text;
	      },
	      before: function (items) {
	        var self = this, parent = self.parent();
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self), true);
	        }
	        return self;
	      },
	      after: function (items) {
	        var self = this, parent = self.parent();
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self));
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var elm = self.getEl();
	        var parent = self.parent();
	        var newItems, i;
	        if (self.items) {
	          var controls = self.items().toArray();
	          i = controls.length;
	          while (i--) {
	            controls[i].remove();
	          }
	        }
	        if (parent && parent.items) {
	          newItems = [];
	          parent.items().each(function (item) {
	            if (item !== self) {
	              newItems.push(item);
	            }
	          });
	          parent.items().set(newItems);
	          parent._lastRect = null;
	        }
	        if (self._eventsRoot && self._eventsRoot === self) {
	          global$9(elm).off();
	        }
	        var lookup = self.getRoot().controlIdLookup;
	        if (lookup) {
	          delete lookup[self._id];
	        }
	        if (elm && elm.parentNode) {
	          elm.parentNode.removeChild(elm);
	        }
	        self.state.set('rendered', false);
	        self.state.destroy();
	        self.fire('remove');
	        return self;
	      },
	      renderBefore: function (elm) {
	        global$9(elm).before(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	      renderTo: function (elm) {
	        global$9(elm || this.getContainerElm()).append(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	      preRender: function () {
	      },
	      render: function () {
	      },
	      renderHtml: function () {
	        return '<div id="' + this._id + '" class="' + this.classes + '"></div>';
	      },
	      postRender: function () {
	        var self = this;
	        var settings = self.settings;
	        var elm, box, parent, name, parentEventsRoot;
	        self.$el = global$9(self.getEl());
	        self.state.set('rendered', true);
	        for (name in settings) {
	          if (name.indexOf('on') === 0) {
	            self.on(name.substr(2), settings[name]);
	          }
	        }
	        if (self._eventsRoot) {
	          for (parent = self.parent(); !parentEventsRoot && parent; parent = parent.parent()) {
	            parentEventsRoot = parent._eventsRoot;
	          }
	          if (parentEventsRoot) {
	            for (name in parentEventsRoot._nativeEvents) {
	              self._nativeEvents[name] = true;
	            }
	          }
	        }
	        bindPendingEvents(self);
	        if (settings.style) {
	          elm = self.getEl();
	          if (elm) {
	            elm.setAttribute('style', settings.style);
	            elm.style.cssText = settings.style;
	          }
	        }
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	        var root = self.getRoot();
	        if (!root.controlIdLookup) {
	          root.controlIdLookup = {};
	        }
	        root.controlIdLookup[self._id] = self;
	        for (var key in self._aria) {
	          self.aria(key, self._aria[key]);
	        }
	        if (self.state.get('visible') === false) {
	          self.getEl().style.display = 'none';
	        }
	        self.bindStates();
	        self.state.on('change:visible', function (e) {
	          var state = e.value;
	          var parentCtrl;
	          if (self.state.get('rendered')) {
	            self.getEl().style.display = state === false ? 'none' : '';
	            self.getEl().getBoundingClientRect();
	          }
	          parentCtrl = self.parent();
	          if (parentCtrl) {
	            parentCtrl._lastRect = null;
	          }
	          self.fire(state ? 'show' : 'hide');
	          ReflowQueue.add(self);
	        });
	        self.fire('postrender', {}, false);
	      },
	      bindStates: function () {
	      },
	      scrollIntoView: function (align) {
	        function getOffset(elm, rootElm) {
	          var x, y, parent = elm;
	          x = y = 0;
	          while (parent && parent !== rootElm && parent.nodeType) {
	            x += parent.offsetLeft || 0;
	            y += parent.offsetTop || 0;
	            parent = parent.offsetParent;
	          }
	          return {
	            x: x,
	            y: y
	          };
	        }
	        var elm = this.getEl(), parentElm = elm.parentNode;
	        var x, y, width, height, parentWidth, parentHeight;
	        var pos = getOffset(elm, parentElm);
	        x = pos.x;
	        y = pos.y;
	        width = elm.offsetWidth;
	        height = elm.offsetHeight;
	        parentWidth = parentElm.clientWidth;
	        parentHeight = parentElm.clientHeight;
	        if (align === 'end') {
	          x -= parentWidth - width;
	          y -= parentHeight - height;
	        } else if (align === 'center') {
	          x -= parentWidth / 2 - width / 2;
	          y -= parentHeight / 2 - height / 2;
	        }
	        parentElm.scrollLeft = x;
	        parentElm.scrollTop = y;
	        return this;
	      },
	      getRoot: function () {
	        var ctrl = this, rootControl;
	        var parents = [];
	        while (ctrl) {
	          if (ctrl.rootControl) {
	            rootControl = ctrl.rootControl;
	            break;
	          }
	          parents.push(ctrl);
	          rootControl = ctrl;
	          ctrl = ctrl.parent();
	        }
	        if (!rootControl) {
	          rootControl = this;
	        }
	        var i = parents.length;
	        while (i--) {
	          parents[i].rootControl = rootControl;
	        }
	        return rootControl;
	      },
	      reflow: function () {
	        ReflowQueue.remove(this);
	        var parent = this.parent();
	        if (parent && parent._layout && !parent._layout.isNative()) {
	          parent.reflow();
	        }
	        return this;
	      }
	    };
	    global$2.each('text title visible disabled active value'.split(' '), function (name) {
	      proto$1[name] = function (value) {
	        if (arguments.length === 0) {
	          return this.state.get(name);
	        }
	        if (typeof value !== 'undefined') {
	          this.state.set(name, value);
	        }
	        return this;
	      };
	    });
	    Control = global$a.extend(proto$1);
	    function getEventDispatcher(obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new global$b({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (state && global$b.isNative(name)) {
	              if (!obj._nativeEvents) {
	                obj._nativeEvents = {};
	              }
	              obj._nativeEvents[name] = true;
	              if (obj.state.get('rendered')) {
	                bindPendingEvents(obj);
	              }
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    }
	    function bindPendingEvents(eventCtrl) {
	      var i, l, parents, eventRootCtrl, nativeEvents, name;
	      function delegate(e) {
	        var control = eventCtrl.getParentCtrl(e.target);
	        if (control) {
	          control.fire(e.type, e);
	        }
	      }
	      function mouseLeaveHandler() {
	        var ctrl = eventRootCtrl._lastHoverCtrl;
	        if (ctrl) {
	          ctrl.fire('mouseleave', { target: ctrl.getEl() });
	          ctrl.parents().each(function (ctrl) {
	            ctrl.fire('mouseleave', { target: ctrl.getEl() });
	          });
	          eventRootCtrl._lastHoverCtrl = null;
	        }
	      }
	      function mouseEnterHandler(e) {
	        var ctrl = eventCtrl.getParentCtrl(e.target), lastCtrl = eventRootCtrl._lastHoverCtrl, idx = 0, i, parents, lastParents;
	        if (ctrl !== lastCtrl) {
	          eventRootCtrl._lastHoverCtrl = ctrl;
	          parents = ctrl.parents().toArray().reverse();
	          parents.push(ctrl);
	          if (lastCtrl) {
	            lastParents = lastCtrl.parents().toArray().reverse();
	            lastParents.push(lastCtrl);
	            for (idx = 0; idx < lastParents.length; idx++) {
	              if (parents[idx] !== lastParents[idx]) {
	                break;
	              }
	            }
	            for (i = lastParents.length - 1; i >= idx; i--) {
	              lastCtrl = lastParents[i];
	              lastCtrl.fire('mouseleave', { target: lastCtrl.getEl() });
	            }
	          }
	          for (i = idx; i < parents.length; i++) {
	            ctrl = parents[i];
	            ctrl.fire('mouseenter', { target: ctrl.getEl() });
	          }
	        }
	      }
	      function fixWheelEvent(e) {
	        e.preventDefault();
	        if (e.type === 'mousewheel') {
	          e.deltaY = -1 / 40 * e.wheelDelta;
	          if (e.wheelDeltaX) {
	            e.deltaX = -1 / 40 * e.wheelDeltaX;
	          }
	        } else {
	          e.deltaX = 0;
	          e.deltaY = e.detail;
	        }
	        e = eventCtrl.fire('wheel', e);
	      }
	      nativeEvents = eventCtrl._nativeEvents;
	      if (nativeEvents) {
	        parents = eventCtrl.parents().toArray();
	        parents.unshift(eventCtrl);
	        for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
	          eventRootCtrl = parents[i]._eventsRoot;
	        }
	        if (!eventRootCtrl) {
	          eventRootCtrl = parents[parents.length - 1] || eventCtrl;
	        }
	        eventCtrl._eventsRoot = eventRootCtrl;
	        for (l = i, i = 0; i < l; i++) {
	          parents[i]._eventsRoot = eventRootCtrl;
	        }
	        var eventRootDelegates = eventRootCtrl._delegates;
	        if (!eventRootDelegates) {
	          eventRootDelegates = eventRootCtrl._delegates = {};
	        }
	        for (name in nativeEvents) {
	          if (!nativeEvents) {
	            return false;
	          }
	          if (name === 'wheel' && !hasWheelEventSupport) {
	            if (hasMouseWheelEventSupport) {
	              global$9(eventCtrl.getEl()).on('mousewheel', fixWheelEvent);
	            } else {
	              global$9(eventCtrl.getEl()).on('DOMMouseScroll', fixWheelEvent);
	            }
	            continue;
	          }
	          if (name === 'mouseenter' || name === 'mouseleave') {
	            if (!eventRootCtrl._hasMouseEnter) {
	              global$9(eventRootCtrl.getEl()).on('mouseleave', mouseLeaveHandler).on('mouseover', mouseEnterHandler);
	              eventRootCtrl._hasMouseEnter = 1;
	            }
	          } else if (!eventRootDelegates[name]) {
	            global$9(eventRootCtrl.getEl()).on(name, delegate);
	            eventRootDelegates[name] = true;
	          }
	          nativeEvents[name] = false;
	        }
	      }
	    }
	    var Control$1 = Control;
	
	    var hasTabstopData = function (elm) {
	      return elm.getAttribute('data-mce-tabstop') ? true : false;
	    };
	    function KeyboardNavigation (settings) {
	      var root = settings.root;
	      var focusedElement, focusedControl;
	      function isElement(node) {
	        return node && node.nodeType === 1;
	      }
	      try {
	        focusedElement = domGlobals.document.activeElement;
	      } catch (ex) {
	        focusedElement = domGlobals.document.body;
	      }
	      focusedControl = root.getParentCtrl(focusedElement);
	      function getRole(elm) {
	        elm = elm || focusedElement;
	        if (isElement(elm)) {
	          return elm.getAttribute('role');
	        }
	        return null;
	      }
	      function getParentRole(elm) {
	        var role, parent = elm || focusedElement;
	        while (parent = parent.parentNode) {
	          if (role = getRole(parent)) {
	            return role;
	          }
	        }
	      }
	      function getAriaProp(name) {
	        var elm = focusedElement;
	        if (isElement(elm)) {
	          return elm.getAttribute('aria-' + name);
	        }
	      }
	      function isTextInputElement(elm) {
	        var tagName = elm.tagName.toUpperCase();
	        return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
	      }
	      function canFocus(elm) {
	        if (isTextInputElement(elm) && !elm.hidden) {
	          return true;
	        }
	        if (hasTabstopData(elm)) {
	          return true;
	        }
	        if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(elm))) {
	          return true;
	        }
	        return false;
	      }
	      function getFocusElements(elm) {
	        var elements = [];
	        function collect(elm) {
	          if (elm.nodeType !== 1 || elm.style.display === 'none' || elm.disabled) {
	            return;
	          }
	          if (canFocus(elm)) {
	            elements.push(elm);
	          }
	          for (var i = 0; i < elm.childNodes.length; i++) {
	            collect(elm.childNodes[i]);
	          }
	        }
	        collect(elm || root.getEl());
	        return elements;
	      }
	      function getNavigationRoot(targetControl) {
	        var navigationRoot, controls;
	        targetControl = targetControl || focusedControl;
	        controls = targetControl.parents().toArray();
	        controls.unshift(targetControl);
	        for (var i = 0; i < controls.length; i++) {
	          navigationRoot = controls[i];
	          if (navigationRoot.settings.ariaRoot) {
	            break;
	          }
	        }
	        return navigationRoot;
	      }
	      function focusFirst(targetControl) {
	        var navigationRoot = getNavigationRoot(targetControl);
	        var focusElements = getFocusElements(navigationRoot.getEl());
	        if (navigationRoot.settings.ariaRemember && 'lastAriaIndex' in navigationRoot) {
	          moveFocusToIndex(navigationRoot.lastAriaIndex, focusElements);
	        } else {
	          moveFocusToIndex(0, focusElements);
	        }
	      }
	      function moveFocusToIndex(idx, elements) {
	        if (idx < 0) {
	          idx = elements.length - 1;
	        } else if (idx >= elements.length) {
	          idx = 0;
	        }
	        if (elements[idx]) {
	          elements[idx].focus();
	        }
	        return idx;
	      }
	      function moveFocus(dir, elements) {
	        var idx = -1;
	        var navigationRoot = getNavigationRoot();
	        elements = elements || getFocusElements(navigationRoot.getEl());
	        for (var i = 0; i < elements.length; i++) {
	          if (elements[i] === focusedElement) {
	            idx = i;
	          }
	        }
	        idx += dir;
	        navigationRoot.lastAriaIndex = moveFocusToIndex(idx, elements);
	      }
	      function left() {
	        var parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          moveFocus(-1, getFocusElements(focusedElement.parentNode));
	        } else if (focusedControl.parent().submenu) {
	          cancel();
	        } else {
	          moveFocus(-1);
	        }
	      }
	      function right() {
	        var role = getRole(), parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          moveFocus(1, getFocusElements(focusedElement.parentNode));
	        } else if (role === 'menuitem' && parentRole === 'menu' && getAriaProp('haspopup')) {
	          enter();
	        } else {
	          moveFocus(1);
	        }
	      }
	      function up() {
	        moveFocus(-1);
	      }
	      function down() {
	        var role = getRole(), parentRole = getParentRole();
	        if (role === 'menuitem' && parentRole === 'menubar') {
	          enter();
	        } else if (role === 'button' && getAriaProp('haspopup')) {
	          enter({ key: 'down' });
	        } else {
	          moveFocus(1);
	        }
	      }
	      function tab(e) {
	        var parentRole = getParentRole();
	        if (parentRole === 'tablist') {
	          var elm = getFocusElements(focusedControl.getEl('body'))[0];
	          if (elm) {
	            elm.focus();
	          }
	        } else {
	          moveFocus(e.shiftKey ? -1 : 1);
	        }
	      }
	      function cancel() {
	        focusedControl.fire('cancel');
	      }
	      function enter(aria) {
	        aria = aria || {};
	        focusedControl.fire('click', {
	          target: focusedElement,
	          aria: aria
	        });
	      }
	      root.on('keydown', function (e) {
	        function handleNonTabOrEscEvent(e, handler) {
	          if (isTextInputElement(focusedElement) || hasTabstopData(focusedElement)) {
	            return;
	          }
	          if (getRole(focusedElement) === 'slider') {
	            return;
	          }
	          if (handler(e) !== false) {
	            e.preventDefault();
	          }
	        }
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        switch (e.keyCode) {
	        case 37:
	          handleNonTabOrEscEvent(e, left);
	          break;
	        case 39:
	          handleNonTabOrEscEvent(e, right);
	          break;
	        case 38:
	          handleNonTabOrEscEvent(e, up);
	          break;
	        case 40:
	          handleNonTabOrEscEvent(e, down);
	          break;
	        case 27:
	          cancel();
	          break;
	        case 14:
	        case 13:
	        case 32:
	          handleNonTabOrEscEvent(e, enter);
	          break;
	        case 9:
	          tab(e);
	          e.preventDefault();
	          break;
	        }
	      });
	      root.on('focusin', function (e) {
	        focusedElement = e.target;
	        focusedControl = e.control;
	      });
	      return { focusFirst: focusFirst };
	    }
	
	    var selectorCache = {};
	    var Container = Control$1.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        if (settings.fixed) {
	          self.state.set('fixed', true);
	        }
	        self._items = new Collection$2();
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	        self.bodyClasses = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl('body').className = this.toString();
	          }
	        });
	        self.bodyClasses.prefix = self.classPrefix;
	        self.classes.add('container');
	        self.bodyClasses.add('container-body');
	        if (settings.containerCls) {
	          self.classes.add(settings.containerCls);
	        }
	        self._layout = global$4.create((settings.layout || '') + 'layout');
	        if (self.settings.items) {
	          self.add(self.settings.items);
	        } else {
	          self.add(self.render());
	        }
	        self._hasBody = true;
	      },
	      items: function () {
	        return this._items;
	      },
	      find: function (selector) {
	        selector = selectorCache[selector] = selectorCache[selector] || new Selector(selector);
	        return selector.find(this);
	      },
	      add: function (items) {
	        var self = this;
	        self.items().add(self.create(items)).parent(self);
	        return self;
	      },
	      focus: function (keyboard) {
	        var self = this;
	        var focusCtrl, keyboardNav, items;
	        if (keyboard) {
	          keyboardNav = self.keyboardNav || self.parents().eq(-1)[0].keyboardNav;
	          if (keyboardNav) {
	            keyboardNav.focusFirst(self);
	            return;
	          }
	        }
	        items = self.find('*');
	        if (self.statusbar) {
	          items.add(self.statusbar.items());
	        }
	        items.each(function (ctrl) {
	          if (ctrl.settings.autofocus) {
	            focusCtrl = null;
	            return false;
	          }
	          if (ctrl.canFocus) {
	            focusCtrl = focusCtrl || ctrl;
	          }
	        });
	        if (focusCtrl) {
	          focusCtrl.focus();
	        }
	        return self;
	      },
	      replace: function (oldItem, newItem) {
	        var ctrlElm;
	        var items = this.items();
	        var i = items.length;
	        while (i--) {
	          if (items[i] === oldItem) {
	            items[i] = newItem;
	            break;
	          }
	        }
	        if (i >= 0) {
	          ctrlElm = newItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	          ctrlElm = oldItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	        }
	        newItem.parent(this);
	      },
	      create: function (items) {
	        var self = this;
	        var settings;
	        var ctrlItems = [];
	        if (!global$2.isArray(items)) {
	          items = [items];
	        }
	        global$2.each(items, function (item) {
	          if (item) {
	            if (!(item instanceof Control$1)) {
	              if (typeof item === 'string') {
	                item = { type: item };
	              }
	              settings = global$2.extend({}, self.settings.defaults, item);
	              item.type = settings.type = settings.type || item.type || self.settings.defaultType || (settings.defaults ? settings.defaults.type : null);
	              item = global$4.create(settings);
	            }
	            ctrlItems.push(item);
	          }
	        });
	        return ctrlItems;
	      },
	      renderNew: function () {
	        var self = this;
	        self.items().each(function (ctrl, index) {
	          var containerElm;
	          ctrl.parent(self);
	          if (!ctrl.state.get('rendered')) {
	            containerElm = self.getEl('body');
	            if (containerElm.hasChildNodes() && index <= containerElm.childNodes.length - 1) {
	              global$9(containerElm.childNodes[index]).before(ctrl.renderHtml());
	            } else {
	              global$9(containerElm).append(ctrl.renderHtml());
	            }
	            ctrl.postRender();
	            ReflowQueue.add(ctrl);
	          }
	        });
	        self._layout.applyClasses(self.items().filter(':visible'));
	        self._lastRect = null;
	        return self;
	      },
	      append: function (items) {
	        return this.add(items).renderNew();
	      },
	      prepend: function (items) {
	        var self = this;
	        self.items().set(self.create(items).concat(self.items().toArray()));
	        return self.renderNew();
	      },
	      insert: function (items, index, before) {
	        var self = this;
	        var curItems, beforeItems, afterItems;
	        items = self.create(items);
	        curItems = self.items();
	        if (!before && index < curItems.length - 1) {
	          index += 1;
	        }
	        if (index >= 0 && index < curItems.length) {
	          beforeItems = curItems.slice(0, index).toArray();
	          afterItems = curItems.slice(index).toArray();
	          curItems.set(beforeItems.concat(items, afterItems));
	        }
	        return self.renderNew();
	      },
	      fromJSON: function (data) {
	        var self = this;
	        for (var name in data) {
	          self.find('#' + name).value(data[name]);
	        }
	        return self;
	      },
	      toJSON: function () {
	        var self = this, data = {};
	        self.find('*').each(function (ctrl) {
	          var name = ctrl.name(), value = ctrl.value();
	          if (name && typeof value !== 'undefined') {
	            data[name] = value;
	          }
	        });
	        return data;
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, role = this.settings.role;
	        self.preRender();
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        var box;
	        self.items().exec('postRender');
	        self._super();
	        self._layout.postRender(self);
	        self.state.set('rendered', true);
	        if (self.settings.style) {
	          self.$el.css(self.settings.style);
	        }
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	        if (!self.parent()) {
	          self.keyboardNav = KeyboardNavigation({ root: self });
	        }
	        return self;
	      },
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	        self._layout.recalc(self);
	        return layoutRect;
	      },
	      recalc: function () {
	        var self = this;
	        var rect = self._layoutRect;
	        var lastRect = self._lastRect;
	        if (!lastRect || lastRect.w !== rect.w || lastRect.h !== rect.h) {
	          self._layout.recalc(self);
	          rect = self.layoutRect();
	          self._lastRect = {
	            x: rect.x,
	            y: rect.y,
	            w: rect.w,
	            h: rect.h
	          };
	          return true;
	        }
	      },
	      reflow: function () {
	        var i;
	        ReflowQueue.remove(this);
	        if (this.visible()) {
	          Control$1.repaintControls = [];
	          Control$1.repaintControls.map = {};
	          this.recalc();
	          i = Control$1.repaintControls.length;
	          while (i--) {
	            Control$1.repaintControls[i].repaint();
	          }
	          if (this.settings.layout !== 'flow' && this.settings.layout !== 'stack') {
	            this.repaint();
	          }
	          Control$1.repaintControls = [];
	        }
	        return this;
	      }
	    });
	
	    function getDocumentSize(doc) {
	      var documentElement, body, scrollWidth, clientWidth;
	      var offsetWidth, scrollHeight, clientHeight, offsetHeight;
	      var max = Math.max;
	      documentElement = doc.documentElement;
	      body = doc.body;
	      scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
	      clientWidth = max(documentElement.clientWidth, body.clientWidth);
	      offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	      scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
	      clientHeight = max(documentElement.clientHeight, body.clientHeight);
	      offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	      return {
	        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
	        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
	      };
	    }
	    function updateWithTouchData(e) {
	      var keys, i;
	      if (e.changedTouches) {
	        keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
	        for (i = 0; i < keys.length; i++) {
	          e[keys[i]] = e.changedTouches[0][keys[i]];
	        }
	      }
	    }
	    function DragHelper (id, settings) {
	      var $eventOverlay;
	      var doc = settings.document || domGlobals.document;
	      var downButton;
	      var start, stop, drag, startX, startY;
	      settings = settings || {};
	      var handleElement = doc.getElementById(settings.handle || id);
	      start = function (e) {
	        var docSize = getDocumentSize(doc);
	        var handleElm, cursor;
	        updateWithTouchData(e);
	        e.preventDefault();
	        downButton = e.button;
	        handleElm = handleElement;
	        startX = e.screenX;
	        startY = e.screenY;
	        if (domGlobals.window.getComputedStyle) {
	          cursor = domGlobals.window.getComputedStyle(handleElm, null).getPropertyValue('cursor');
	        } else {
	          cursor = handleElm.runtimeStyle.cursor;
	        }
	        $eventOverlay = global$9('<div></div>').css({
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          width: docSize.width,
	          height: docSize.height,
	          zIndex: 2147483647,
	          opacity: 0.0001,
	          cursor: cursor
	        }).appendTo(doc.body);
	        global$9(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
	        settings.start(e);
	      };
	      drag = function (e) {
	        updateWithTouchData(e);
	        if (e.button !== downButton) {
	          return stop(e);
	        }
	        e.deltaX = e.screenX - startX;
	        e.deltaY = e.screenY - startY;
	        e.preventDefault();
	        settings.drag(e);
	      };
	      stop = function (e) {
	        updateWithTouchData(e);
	        global$9(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
	        $eventOverlay.remove();
	        if (settings.stop) {
	          settings.stop(e);
	        }
	      };
	      this.destroy = function () {
	        global$9(handleElement).off();
	      };
	      global$9(handleElement).on('mousedown touchstart', start);
	    }
	
	    var Scrollable = {
	      init: function () {
	        var self = this;
	        self.on('repaint', self.renderScroll);
	      },
	      renderScroll: function () {
	        var self = this, margin = 2;
	        function repaintScroll() {
	          var hasScrollH, hasScrollV, bodyElm;
	          function repaintAxis(axisName, posName, sizeName, contentSizeName, hasScroll, ax) {
	            var containerElm, scrollBarElm, scrollThumbElm;
	            var containerSize, scrollSize, ratio, rect;
	            var posNameLower, sizeNameLower;
	            scrollBarElm = self.getEl('scroll' + axisName);
	            if (scrollBarElm) {
	              posNameLower = posName.toLowerCase();
	              sizeNameLower = sizeName.toLowerCase();
	              global$9(self.getEl('absend')).css(posNameLower, self.layoutRect()[contentSizeName] - 1);
	              if (!hasScroll) {
	                global$9(scrollBarElm).css('display', 'none');
	                return;
	              }
	              global$9(scrollBarElm).css('display', 'block');
	              containerElm = self.getEl('body');
	              scrollThumbElm = self.getEl('scroll' + axisName + 't');
	              containerSize = containerElm['client' + sizeName] - margin * 2;
	              containerSize -= hasScrollH && hasScrollV ? scrollBarElm['client' + ax] : 0;
	              scrollSize = containerElm['scroll' + sizeName];
	              ratio = containerSize / scrollSize;
	              rect = {};
	              rect[posNameLower] = containerElm['offset' + posName] + margin;
	              rect[sizeNameLower] = containerSize;
	              global$9(scrollBarElm).css(rect);
	              rect = {};
	              rect[posNameLower] = containerElm['scroll' + posName] * ratio;
	              rect[sizeNameLower] = containerSize * ratio;
	              global$9(scrollThumbElm).css(rect);
	            }
	          }
	          bodyElm = self.getEl('body');
	          hasScrollH = bodyElm.scrollWidth > bodyElm.clientWidth;
	          hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
	          repaintAxis('h', 'Left', 'Width', 'contentW', hasScrollH, 'Height');
	          repaintAxis('v', 'Top', 'Height', 'contentH', hasScrollV, 'Width');
	        }
	        function addScroll() {
	          function addScrollAxis(axisName, posName, sizeName, deltaPosName, ax) {
	            var scrollStart;
	            var axisId = self._id + '-scroll' + axisName, prefix = self.classPrefix;
	            global$9(self.getEl()).append('<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + axisName + '">' + '<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' + '</div>');
	            self.draghelper = new DragHelper(axisId + 't', {
	              start: function () {
	                scrollStart = self.getEl('body')['scroll' + posName];
	                global$9('#' + axisId).addClass(prefix + 'active');
	              },
	              drag: function (e) {
	                var ratio, hasScrollH, hasScrollV, containerSize;
	                var layoutRect = self.layoutRect();
	                hasScrollH = layoutRect.contentW > layoutRect.innerW;
	                hasScrollV = layoutRect.contentH > layoutRect.innerH;
	                containerSize = self.getEl('body')['client' + sizeName] - margin * 2;
	                containerSize -= hasScrollH && hasScrollV ? self.getEl('scroll' + axisName)['client' + ax] : 0;
	                ratio = containerSize / self.getEl('body')['scroll' + sizeName];
	                self.getEl('body')['scroll' + posName] = scrollStart + e['delta' + deltaPosName] / ratio;
	              },
	              stop: function () {
	                global$9('#' + axisId).removeClass(prefix + 'active');
	              }
	            });
	          }
	          self.classes.add('scroll');
	          addScrollAxis('v', 'Top', 'Height', 'Y', 'Width');
	          addScrollAxis('h', 'Left', 'Width', 'X', 'Height');
	        }
	        if (self.settings.autoScroll) {
	          if (!self._hasScroll) {
	            self._hasScroll = true;
	            addScroll();
	            self.on('wheel', function (e) {
	              var bodyEl = self.getEl('body');
	              bodyEl.scrollLeft += (e.deltaX || 0) * 10;
	              bodyEl.scrollTop += e.deltaY * 10;
	              repaintScroll();
	            });
	            global$9(self.getEl('body')).on('scroll', repaintScroll);
	          }
	          repaintScroll();
	        }
	      }
	    };
	
	    var Panel = Container.extend({
	      Defaults: {
	        layout: 'fit',
	        containerCls: 'panel'
	      },
	      Mixins: [Scrollable],
	      renderHtml: function () {
	        var self = this;
	        var layout = self._layout;
	        var innerHtml = self.settings.html;
	        self.preRender();
	        layout.preRender(self);
	        if (typeof innerHtml === 'undefined') {
	          innerHtml = '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>';
	        } else {
	          if (typeof innerHtml === 'function') {
	            innerHtml = innerHtml.call(self);
	          }
	          self._hasBody = false;
	        }
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1" role="group">' + (self._preBodyHtml || '') + innerHtml + '</div>';
	      }
	    });
	
	    var Resizable = {
	      resizeToContent: function () {
	        this._layoutRect.autoResize = true;
	        this._lastRect = null;
	        this.reflow();
	      },
	      resizeTo: function (w, h) {
	        if (w <= 1 || h <= 1) {
	          var rect = funcs.getWindowSize();
	          w = w <= 1 ? w * rect.w : w;
	          h = h <= 1 ? h * rect.h : h;
	        }
	        this._layoutRect.autoResize = false;
	        return this.layoutRect({
	          minW: w,
	          minH: h,
	          w: w,
	          h: h
	        }).reflow();
	      },
	      resizeBy: function (dw, dh) {
	        var self = this, rect = self.layoutRect();
	        return self.resizeTo(rect.w + dw, rect.h + dh);
	      }
	    };
	
	    var documentClickHandler, documentScrollHandler, windowResizeHandler;
	    var visiblePanels = [];
	    var zOrder = [];
	    var hasModal;
	    function isChildOf(ctrl, parent) {
	      while (ctrl) {
	        if (ctrl === parent) {
	          return true;
	        }
	        ctrl = ctrl.parent();
	      }
	    }
	    function skipOrHidePanels(e) {
	      var i = visiblePanels.length;
	      while (i--) {
	        var panel = visiblePanels[i], clickCtrl = panel.getParentCtrl(e.target);
	        if (panel.settings.autohide) {
	          if (clickCtrl) {
	            if (isChildOf(clickCtrl, panel) || panel.parent() === clickCtrl) {
	              continue;
	            }
	          }
	          e = panel.fire('autohide', { target: e.target });
	          if (!e.isDefaultPrevented()) {
	            panel.hide();
	          }
	        }
	      }
	    }
	    function bindDocumentClickHandler() {
	      if (!documentClickHandler) {
	        documentClickHandler = function (e) {
	          if (e.button === 2) {
	            return;
	          }
	          skipOrHidePanels(e);
	        };
	        global$9(domGlobals.document).on('click touchstart', documentClickHandler);
	      }
	    }
	    function bindDocumentScrollHandler() {
	      if (!documentScrollHandler) {
	        documentScrollHandler = function () {
	          var i;
	          i = visiblePanels.length;
	          while (i--) {
	            repositionPanel(visiblePanels[i]);
	          }
	        };
	        global$9(domGlobals.window).on('scroll', documentScrollHandler);
	      }
	    }
	    function bindWindowResizeHandler() {
	      if (!windowResizeHandler) {
	        var docElm_1 = domGlobals.document.documentElement;
	        var clientWidth_1 = docElm_1.clientWidth, clientHeight_1 = docElm_1.clientHeight;
	        windowResizeHandler = function () {
	          if (!domGlobals.document.all || clientWidth_1 !== docElm_1.clientWidth || clientHeight_1 !== docElm_1.clientHeight) {
	            clientWidth_1 = docElm_1.clientWidth;
	            clientHeight_1 = docElm_1.clientHeight;
	            FloatPanel.hideAll();
	          }
	        };
	        global$9(domGlobals.window).on('resize', windowResizeHandler);
	      }
	    }
	    function repositionPanel(panel) {
	      var scrollY = funcs.getViewPort().y;
	      function toggleFixedChildPanels(fixed, deltaY) {
	        var parent;
	        for (var i = 0; i < visiblePanels.length; i++) {
	          if (visiblePanels[i] !== panel) {
	            parent = visiblePanels[i].parent();
	            while (parent && (parent = parent.parent())) {
	              if (parent === panel) {
	                visiblePanels[i].fixed(fixed).moveBy(0, deltaY).repaint();
	              }
	            }
	          }
	        }
	      }
	      if (panel.settings.autofix) {
	        if (!panel.state.get('fixed')) {
	          panel._autoFixY = panel.layoutRect().y;
	          if (panel._autoFixY < scrollY) {
	            panel.fixed(true).layoutRect({ y: 0 }).repaint();
	            toggleFixedChildPanels(true, scrollY - panel._autoFixY);
	          }
	        } else {
	          if (panel._autoFixY > scrollY) {
	            panel.fixed(false).layoutRect({ y: panel._autoFixY }).repaint();
	            toggleFixedChildPanels(false, panel._autoFixY - scrollY);
	          }
	        }
	      }
	    }
	    function addRemove(add, ctrl) {
	      var i, zIndex = FloatPanel.zIndex || 65535, topModal;
	      if (add) {
	        zOrder.push(ctrl);
	      } else {
	        i = zOrder.length;
	        while (i--) {
	          if (zOrder[i] === ctrl) {
	            zOrder.splice(i, 1);
	          }
	        }
	      }
	      if (zOrder.length) {
	        for (i = 0; i < zOrder.length; i++) {
	          if (zOrder[i].modal) {
	            zIndex++;
	            topModal = zOrder[i];
	          }
	          zOrder[i].getEl().style.zIndex = zIndex;
	          zOrder[i].zIndex = zIndex;
	          zIndex++;
	        }
	      }
	      var modalBlockEl = global$9('#' + ctrl.classPrefix + 'modal-block', ctrl.getContainerElm())[0];
	      if (topModal) {
	        global$9(modalBlockEl).css('z-index', topModal.zIndex - 1);
	      } else if (modalBlockEl) {
	        modalBlockEl.parentNode.removeChild(modalBlockEl);
	        hasModal = false;
	      }
	      FloatPanel.currentZIndex = zIndex;
	    }
	    var FloatPanel = Panel.extend({
	      Mixins: [
	        Movable,
	        Resizable
	      ],
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self._eventsRoot = self;
	        self.classes.add('floatpanel');
	        if (settings.autohide) {
	          bindDocumentClickHandler();
	          bindWindowResizeHandler();
	          visiblePanels.push(self);
	        }
	        if (settings.autofix) {
	          bindDocumentScrollHandler();
	          self.on('move', function () {
	            repositionPanel(this);
	          });
	        }
	        self.on('postrender show', function (e) {
	          if (e.control === self) {
	            var $modalBlockEl_1;
	            var prefix_1 = self.classPrefix;
	            if (self.modal && !hasModal) {
	              $modalBlockEl_1 = global$9('#' + prefix_1 + 'modal-block', self.getContainerElm());
	              if (!$modalBlockEl_1[0]) {
	                $modalBlockEl_1 = global$9('<div id="' + prefix_1 + 'modal-block" class="' + prefix_1 + 'reset ' + prefix_1 + 'fade"></div>').appendTo(self.getContainerElm());
	              }
	              global$7.setTimeout(function () {
	                $modalBlockEl_1.addClass(prefix_1 + 'in');
	                global$9(self.getEl()).addClass(prefix_1 + 'in');
	              });
	              hasModal = true;
	            }
	            addRemove(true, self);
	          }
	        });
	        self.on('show', function () {
	          self.parents().each(function (ctrl) {
	            if (ctrl.state.get('fixed')) {
	              self.fixed(true);
	              return false;
	            }
	          });
	        });
	        if (settings.popover) {
	          self._preBodyHtml = '<div class="' + self.classPrefix + 'arrow"></div>';
	          self.classes.add('popover').add('bottom').add(self.isRtl() ? 'end' : 'start');
	        }
	        self.aria('label', settings.ariaLabel);
	        self.aria('labelledby', self._id);
	        self.aria('describedby', self.describedBy || self._id + '-none');
	      },
	      fixed: function (state) {
	        var self = this;
	        if (self.state.get('fixed') !== state) {
	          if (self.state.get('rendered')) {
	            var viewport = funcs.getViewPort();
	            if (state) {
	              self.layoutRect().y -= viewport.y;
	            } else {
	              self.layoutRect().y += viewport.y;
	            }
	          }
	          self.classes.toggle('fixed', state);
	          self.state.set('fixed', state);
	        }
	        return self;
	      },
	      show: function () {
	        var self = this;
	        var i;
	        var state = self._super();
	        i = visiblePanels.length;
	        while (i--) {
	          if (visiblePanels[i] === self) {
	            break;
	          }
	        }
	        if (i === -1) {
	          visiblePanels.push(self);
	        }
	        return state;
	      },
	      hide: function () {
	        removeVisiblePanel(this);
	        addRemove(false, this);
	        return this._super();
	      },
	      hideAll: function () {
	        FloatPanel.hideAll();
	      },
	      close: function () {
	        var self = this;
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	          addRemove(false, self);
	        }
	        return self;
	      },
	      remove: function () {
	        removeVisiblePanel(this);
	        this._super();
	      },
	      postRender: function () {
	        var self = this;
	        if (self.settings.bodyRole) {
	          this.getEl('body').setAttribute('role', self.settings.bodyRole);
	        }
	        return self._super();
	      }
	    });
	    FloatPanel.hideAll = function () {
	      var i = visiblePanels.length;
	      while (i--) {
	        var panel = visiblePanels[i];
	        if (panel && panel.settings.autohide) {
	          panel.hide();
	          visiblePanels.splice(i, 1);
	        }
	      }
	    };
	    function removeVisiblePanel(panel) {
	      var i;
	      i = visiblePanels.length;
	      while (i--) {
	        if (visiblePanels[i] === panel) {
	          visiblePanels.splice(i, 1);
	        }
	      }
	      i = zOrder.length;
	      while (i--) {
	        if (zOrder[i] === panel) {
	          zOrder.splice(i, 1);
	        }
	      }
	    }
	
	    var isFixed$1 = function (inlineToolbarContainer, editor) {
	      return !!(inlineToolbarContainer && !editor.settings.ui_container);
	    };
	    var render$1 = function (editor, theme, args) {
	      var panel, inlineToolbarContainer;
	      var DOM = global$3.DOM;
	      var fixedToolbarContainer = getFixedToolbarContainer(editor);
	      if (fixedToolbarContainer) {
	        inlineToolbarContainer = DOM.select(fixedToolbarContainer)[0];
	      }
	      var reposition = function () {
	        if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
	          var scrollContainer = editor.selection.getScrollContainer(), body = editor.getBody();
	          var deltaX = 0, deltaY = 0;
	          if (scrollContainer) {
	            var bodyPos = DOM.getPos(body), scrollContainerPos = DOM.getPos(scrollContainer);
	            deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
	            deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
	          }
	          panel.fixed(false).moveRel(body, editor.rtl ? [
	            'tr-br',
	            'br-tr'
	          ] : [
	            'tl-bl',
	            'bl-tl',
	            'tr-br'
	          ]).moveBy(deltaX, deltaY);
	        }
	      };
	      var show = function () {
	        if (panel) {
	          panel.show();
	          reposition();
	          DOM.addClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	      var hide = function () {
	        if (panel) {
	          panel.hide();
	          FloatPanel.hideAll();
	          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	      var render = function () {
	        if (panel) {
	          if (!panel.visible()) {
	            show();
	          }
	          return;
	        }
	        panel = theme.panel = global$4.create({
	          type: inlineToolbarContainer ? 'panel' : 'floatpanel',
	          role: 'application',
	          classes: 'tinymce tinymce-inline',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: true,
	          fixed: isFixed$1(inlineToolbarContainer, editor),
	          border: 1,
	          items: [
	            hasMenubar(editor) === false ? null : {
	              type: 'menubar',
	              border: '0 0 1 0',
	              items: Menubar.createMenuButtons(editor)
	            },
	            Toolbar.createToolbars(editor, getToolbarSize(editor))
	          ]
	        });
	        UiContainer.setUiContainer(editor, panel);
	        Events.fireBeforeRenderUI(editor);
	        if (inlineToolbarContainer) {
	          panel.renderTo(inlineToolbarContainer).reflow();
	        } else {
	          panel.renderTo().reflow();
	        }
	        A11y.addKeys(editor, panel);
	        show();
	        ContextToolbars.addContextualToolbars(editor);
	        editor.on('nodeChange', reposition);
	        editor.on('ResizeWindow', reposition);
	        editor.on('activate', show);
	        editor.on('deactivate', hide);
	        editor.nodeChanged();
	      };
	      editor.settings.content_editable = true;
	      editor.on('focus', function () {
	        if (isSkinDisabled(editor) === false && args.skinUiCss) {
	          DOM.styleSheetLoader.load(args.skinUiCss, render, render);
	        } else {
	          render();
	        }
	      });
	      editor.on('blur hide', hide);
	      editor.on('remove', function () {
	        if (panel) {
	          panel.remove();
	          panel = null;
	        }
	      });
	      if (isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	      return {};
	    };
	    var Inline = { render: render$1 };
	
	    function Throbber (elm, inline) {
	      var self = this;
	      var state;
	      var classPrefix = Control$1.classPrefix;
	      var timer;
	      self.show = function (time, callback) {
	        function render() {
	          if (state) {
	            global$9(elm).append('<div class="' + classPrefix + 'throbber' + (inline ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>');
	            if (callback) {
	              callback();
	            }
	          }
	        }
	        self.hide();
	        state = true;
	        if (time) {
	          timer = global$7.setTimeout(render, time);
	        } else {
	          render();
	        }
	        return self;
	      };
	      self.hide = function () {
	        var child = elm.lastChild;
	        global$7.clearTimeout(timer);
	        if (child && child.className.indexOf('throbber') !== -1) {
	          child.parentNode.removeChild(child);
	        }
	        state = false;
	        return self;
	      };
	    }
	
	    var setup = function (editor, theme) {
	      var throbber;
	      editor.on('ProgressState', function (e) {
	        throbber = throbber || new Throbber(theme.panel.getEl('body'));
	        if (e.state) {
	          throbber.show(e.time);
	        } else {
	          throbber.hide();
	        }
	      });
	    };
	    var ProgressState = { setup: setup };
	
	    var renderUI = function (editor, theme, args) {
	      var skinUrl = getSkinUrl(editor);
	      if (skinUrl) {
	        args.skinUiCss = skinUrl + '/skin.min.css';
	        editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
	      }
	      ProgressState.setup(editor, theme);
	      return isInline(editor) ? Inline.render(editor, theme, args) : Iframe.render(editor, theme, args);
	    };
	    var Render = { renderUI: renderUI };
	
	    var Tooltip = Control$1.extend({
	      Mixins: [Movable],
	      Defaults: { classes: 'widget tooltip tooltip-n' },
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        return '<div id="' + self._id + '" class="' + self.classes + '" role="presentation">' + '<div class="' + prefix + 'tooltip-arrow"></div>' + '<div class="' + prefix + 'tooltip-inner">' + self.encode(self.state.get('text')) + '</div>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl().lastChild.innerHTML = self.encode(e.value);
	        });
	        return self._super();
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	        style.zIndex = 65535 + 65535;
	      }
	    });
	
	    var Widget = Control$1.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        self.canFocus = true;
	        if (settings.tooltip && Widget.tooltips !== false) {
	          self.on('mouseenter', function (e) {
	            var tooltip = self.tooltip().moveTo(-65535);
	            if (e.control === self) {
	              var rel = tooltip.text(settings.tooltip).show().testMoveRel(self.getEl(), [
	                'bc-tc',
	                'bc-tl',
	                'bc-tr'
	              ]);
	              tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
	              tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
	              tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
	              tooltip.moveRel(self.getEl(), rel);
	            } else {
	              tooltip.hide();
	            }
	          });
	          self.on('mouseleave mousedown click', function () {
	            self.tooltip().remove();
	            self._tooltip = null;
	          });
	        }
	        self.aria('label', settings.ariaLabel || settings.tooltip);
	      },
	      tooltip: function () {
	        if (!this._tooltip) {
	          this._tooltip = new Tooltip({ type: 'tooltip' });
	          UiContainer.inheritUiContainer(this, this._tooltip);
	          this._tooltip.renderTo();
	        }
	        return this._tooltip;
	      },
	      postRender: function () {
	        var self = this, settings = self.settings;
	        self._super();
	        if (!self.parent() && (settings.width || settings.height)) {
	          self.initLayoutRect();
	          self.repaint();
	        }
	        if (settings.autofocus) {
	          self.focus();
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        function disable(state) {
	          self.aria('disabled', state);
	          self.classes.toggle('disabled', state);
	        }
	        function active(state) {
	          self.aria('pressed', state);
	          self.classes.toggle('active', state);
	        }
	        self.state.on('change:disabled', function (e) {
	          disable(e.value);
	        });
	        self.state.on('change:active', function (e) {
	          active(e.value);
	        });
	        if (self.state.get('disabled')) {
	          disable(true);
	        }
	        if (self.state.get('active')) {
	          active(true);
	        }
	        return self._super();
	      },
	      remove: function () {
	        this._super();
	        if (this._tooltip) {
	          this._tooltip.remove();
	          this._tooltip = null;
	        }
	      }
	    });
	
	    var Progress = Widget.extend({
	      Defaults: { value: 0 },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('progress');
	        if (!self.settings.filter) {
	          self.settings.filter = function (value) {
	            return Math.round(value);
	          };
	        }
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = this.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div class="' + prefix + 'bar-container">' + '<div class="' + prefix + 'bar"></div>' + '</div>' + '<div class="' + prefix + 'text">0%</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.value(self.settings.value);
	        return self;
	      },
	      bindStates: function () {
	        var self = this;
	        function setValue(value) {
	          value = self.settings.filter(value);
	          self.getEl().lastChild.innerHTML = value + '%';
	          self.getEl().firstChild.firstChild.style.width = value + '%';
	        }
	        self.state.on('change:value', function (e) {
	          setValue(e.value);
	        });
	        setValue(self.state.get('value'));
	        return self._super();
	      }
	    });
	
	    var updateLiveRegion = function (ctx, text) {
	      ctx.getEl().lastChild.textContent = text + (ctx.progressBar ? ' ' + ctx.progressBar.value() + '%' : '');
	    };
	    var Notification = Control$1.extend({
	      Mixins: [Movable],
	      Defaults: { classes: 'widget notification' },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.maxWidth = settings.maxWidth;
	        if (settings.text) {
	          self.text(settings.text);
	        }
	        if (settings.icon) {
	          self.icon = settings.icon;
	        }
	        if (settings.color) {
	          self.color = settings.color;
	        }
	        if (settings.type) {
	          self.classes.add('notification-' + settings.type);
	        }
	        if (settings.timeout && (settings.timeout < 0 || settings.timeout > 0) && !settings.closeButton) {
	          self.closeButton = false;
	        } else {
	          self.classes.add('has-close');
	          self.closeButton = true;
	        }
	        if (settings.progressBar) {
	          self.progressBar = new Progress();
	        }
	        self.on('click', function (e) {
	          if (e.target.className.indexOf(self.classPrefix + 'close') !== -1) {
	            self.close();
	          }
	        });
	      },
	      renderHtml: function () {
	        var self = this;
	        var prefix = self.classPrefix;
	        var icon = '', closeButton = '', progressBar = '', notificationStyle = '';
	        if (self.icon) {
	          icon = '<i class="' + prefix + 'ico' + ' ' + prefix + 'i-' + self.icon + '"></i>';
	        }
	        notificationStyle = ' style="max-width: ' + self.maxWidth + 'px;' + (self.color ? 'background-color: ' + self.color + ';"' : '"');
	        if (self.closeButton) {
	          closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">\xD7</button>';
	        }
	        if (self.progressBar) {
	          progressBar = self.progressBar.renderHtml();
	        }
	        return '<div id="' + self._id + '" class="' + self.classes + '"' + notificationStyle + ' role="presentation">' + icon + '<div class="' + prefix + 'notification-inner">' + self.state.get('text') + '</div>' + progressBar + closeButton + '<div style="clip: rect(1px, 1px, 1px, 1px);height: 1px;overflow: hidden;position: absolute;width: 1px;"' + ' aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        global$7.setTimeout(function () {
	          self.$el.addClass(self.classPrefix + 'in');
	          updateLiveRegion(self, self.state.get('text'));
	        }, 100);
	        return self._super();
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl().firstChild.innerHTML = e.value;
	          updateLiveRegion(self, e.value);
	        });
	        if (self.progressBar) {
	          self.progressBar.bindStates();
	          self.progressBar.state.on('change:value', function (e) {
	            updateLiveRegion(self, self.state.get('text'));
	          });
	        }
	        return self._super();
	      },
	      close: function () {
	        var self = this;
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	        }
	        return self;
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	        style.zIndex = 65535 - 1;
	      }
	    });
	
	    function NotificationManagerImpl (editor) {
	      var getEditorContainer = function (editor) {
	        return editor.inline ? editor.getElement() : editor.getContentAreaContainer();
	      };
	      var getContainerWidth = function () {
	        var container = getEditorContainer(editor);
	        return funcs.getSize(container).width;
	      };
	      var prePositionNotifications = function (notifications) {
	        each(notifications, function (notification) {
	          notification.moveTo(0, 0);
	        });
	      };
	      var positionNotifications = function (notifications) {
	        if (notifications.length > 0) {
	          var firstItem = notifications.slice(0, 1)[0];
	          var container = getEditorContainer(editor);
	          firstItem.moveRel(container, 'tc-tc');
	          each(notifications, function (notification, index) {
	            if (index > 0) {
	              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
	            }
	          });
	        }
	      };
	      var reposition = function (notifications) {
	        prePositionNotifications(notifications);
	        positionNotifications(notifications);
	      };
	      var open = function (args, closeCallback) {
	        var extendedArgs = global$2.extend(args, { maxWidth: getContainerWidth() });
	        var notif = new Notification(extendedArgs);
	        notif.args = extendedArgs;
	        if (extendedArgs.timeout > 0) {
	          notif.timer = setTimeout(function () {
	            notif.close();
	            closeCallback();
	          }, extendedArgs.timeout);
	        }
	        notif.on('close', function () {
	          closeCallback();
	        });
	        notif.renderTo();
	        return notif;
	      };
	      var close = function (notification) {
	        notification.close();
	      };
	      var getArgs = function (notification) {
	        return notification.args;
	      };
	      return {
	        open: open,
	        close: close,
	        reposition: reposition,
	        getArgs: getArgs
	      };
	    }
	
	    var windows = [];
	    var oldMetaValue = '';
	    function toggleFullScreenState(state) {
	      var noScaleMetaValue = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0';
	      var viewport = global$9('meta[name=viewport]')[0], contentValue;
	      if (global$8.overrideViewPort === false) {
	        return;
	      }
	      if (!viewport) {
	        viewport = domGlobals.document.createElement('meta');
	        viewport.setAttribute('name', 'viewport');
	        domGlobals.document.getElementsByTagName('head')[0].appendChild(viewport);
	      }
	      contentValue = viewport.getAttribute('content');
	      if (contentValue && typeof oldMetaValue !== 'undefined') {
	        oldMetaValue = contentValue;
	      }
	      viewport.setAttribute('content', state ? noScaleMetaValue : oldMetaValue);
	    }
	    function toggleBodyFullScreenClasses(classPrefix, state) {
	      if (checkFullscreenWindows() && state === false) {
	        global$9([
	          domGlobals.document.documentElement,
	          domGlobals.document.body
	        ]).removeClass(classPrefix + 'fullscreen');
	      }
	    }
	    function checkFullscreenWindows() {
	      for (var i = 0; i < windows.length; i++) {
	        if (windows[i]._fullscreen) {
	          return true;
	        }
	      }
	      return false;
	    }
	    function handleWindowResize() {
	      if (!global$8.desktop) {
	        var lastSize_1 = {
	          w: domGlobals.window.innerWidth,
	          h: domGlobals.window.innerHeight
	        };
	        global$7.setInterval(function () {
	          var w = domGlobals.window.innerWidth, h = domGlobals.window.innerHeight;
	          if (lastSize_1.w !== w || lastSize_1.h !== h) {
	            lastSize_1 = {
	              w: w,
	              h: h
	            };
	            global$9(domGlobals.window).trigger('resize');
	          }
	        }, 100);
	      }
	      function reposition() {
	        var i;
	        var rect = funcs.getWindowSize();
	        var layoutRect;
	        for (i = 0; i < windows.length; i++) {
	          layoutRect = windows[i].layoutRect();
	          windows[i].moveTo(windows[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2), windows[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2));
	        }
	      }
	      global$9(domGlobals.window).on('resize', reposition);
	    }
	    var Window = FloatPanel.extend({
	      modal: true,
	      Defaults: {
	        border: 1,
	        layout: 'flex',
	        containerCls: 'panel',
	        role: 'dialog',
	        callbacks: {
	          submit: function () {
	            this.fire('submit', { data: this.toJSON() });
	          },
	          close: function () {
	            this.close();
	          }
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	        self.classes.add('window');
	        self.bodyClasses.add('window-body');
	        self.state.set('fixed', true);
	        if (settings.buttons) {
	          self.statusbar = new Panel({
	            layout: 'flex',
	            border: '1 0 0 0',
	            spacing: 3,
	            padding: 10,
	            align: 'center',
	            pack: self.isRtl() ? 'start' : 'end',
	            defaults: { type: 'button' },
	            items: settings.buttons
	          });
	          self.statusbar.classes.add('foot');
	          self.statusbar.parent(self);
	        }
	        self.on('click', function (e) {
	          var closeClass = self.classPrefix + 'close';
	          if (funcs.hasClass(e.target, closeClass) || funcs.hasClass(e.target.parentNode, closeClass)) {
	            self.close();
	          }
	        });
	        self.on('cancel', function () {
	          self.close();
	        });
	        self.on('move', function (e) {
	          if (e.control === self) {
	            FloatPanel.hideAll();
	          }
	        });
	        self.aria('describedby', self.describedBy || self._id + '-none');
	        self.aria('label', settings.title);
	        self._fullscreen = false;
	      },
	      recalc: function () {
	        var self = this;
	        var statusbar = self.statusbar;
	        var layoutRect, width, x, needsRecalc;
	        if (self._fullscreen) {
	          self.layoutRect(funcs.getWindowSize());
	          self.layoutRect().contentH = self.layoutRect().innerH;
	        }
	        self._super();
	        layoutRect = self.layoutRect();
	        if (self.settings.title && !self._fullscreen) {
	          width = layoutRect.headerW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width / 2);
	            self.layoutRect({
	              w: width,
	              x: x
	            });
	            needsRecalc = true;
	          }
	        }
	        if (statusbar) {
	          statusbar.layoutRect({ w: self.layoutRect().innerW }).recalc();
	          width = statusbar.layoutRect().minW + layoutRect.deltaW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width - layoutRect.w);
	            self.layoutRect({
	              w: width,
	              x: x
	            });
	            needsRecalc = true;
	          }
	        }
	        if (needsRecalc) {
	          self.recalc();
	        }
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var layoutRect = self._super();
	        var deltaH = 0, headEl;
	        if (self.settings.title && !self._fullscreen) {
	          headEl = self.getEl('head');
	          var size = funcs.getSize(headEl);
	          layoutRect.headerW = size.width;
	          layoutRect.headerH = size.height;
	          deltaH += layoutRect.headerH;
	        }
	        if (self.statusbar) {
	          deltaH += self.statusbar.layoutRect().h;
	        }
	        layoutRect.deltaH += deltaH;
	        layoutRect.minH += deltaH;
	        layoutRect.h += deltaH;
	        var rect = funcs.getWindowSize();
	        layoutRect.x = self.settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2);
	        layoutRect.y = self.settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2);
	        return layoutRect;
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, id = self._id, prefix = self.classPrefix;
	        var settings = self.settings;
	        var headerHtml = '', footerHtml = '', html = settings.html;
	        self.preRender();
	        layout.preRender(self);
	        if (settings.title) {
	          headerHtml = '<div id="' + id + '-head" class="' + prefix + 'window-head">' + '<div id="' + id + '-title" class="' + prefix + 'title">' + self.encode(settings.title) + '</div>' + '<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' + '<button type="button" class="' + prefix + 'close" aria-hidden="true">' + '<i class="mce-ico mce-i-remove"></i>' + '</button>' + '</div>';
	        }
	        if (settings.url) {
	          html = '<iframe src="' + settings.url + '" tabindex="-1"></iframe>';
	        }
	        if (typeof html === 'undefined') {
	          html = layout.renderHtml(self);
	        }
	        if (self.statusbar) {
	          footerHtml = self.statusbar.renderHtml();
	        }
	        return '<div id="' + id + '" class="' + self.classes + '" hidefocus="1">' + '<div class="' + self.classPrefix + 'reset" role="application">' + headerHtml + '<div id="' + id + '-body" class="' + self.bodyClasses + '">' + html + '</div>' + footerHtml + '</div>' + '</div>';
	      },
	      fullscreen: function (state) {
	        var self = this;
	        var documentElement = domGlobals.document.documentElement;
	        var slowRendering;
	        var prefix = self.classPrefix;
	        var layoutRect;
	        if (state !== self._fullscreen) {
	          global$9(domGlobals.window).on('resize', function () {
	            var time;
	            if (self._fullscreen) {
	              if (!slowRendering) {
	                time = new Date().getTime();
	                var rect = funcs.getWindowSize();
	                self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	                if (new Date().getTime() - time > 50) {
	                  slowRendering = true;
	                }
	              } else {
	                if (!self._timer) {
	                  self._timer = global$7.setTimeout(function () {
	                    var rect = funcs.getWindowSize();
	                    self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	                    self._timer = 0;
	                  }, 50);
	                }
	              }
	            }
	          });
	          layoutRect = self.layoutRect();
	          self._fullscreen = state;
	          if (!state) {
	            self.borderBox = BoxUtils.parseBox(self.settings.border);
	            self.getEl('head').style.display = '';
	            layoutRect.deltaH += layoutRect.headerH;
	            global$9([
	              documentElement,
	              domGlobals.document.body
	            ]).removeClass(prefix + 'fullscreen');
	            self.classes.remove('fullscreen');
	            self.moveTo(self._initial.x, self._initial.y).resizeTo(self._initial.w, self._initial.h);
	          } else {
	            self._initial = {
	              x: layoutRect.x,
	              y: layoutRect.y,
	              w: layoutRect.w,
	              h: layoutRect.h
	            };
	            self.borderBox = BoxUtils.parseBox('0');
	            self.getEl('head').style.display = 'none';
	            layoutRect.deltaH -= layoutRect.headerH + 2;
	            global$9([
	              documentElement,
	              domGlobals.document.body
	            ]).addClass(prefix + 'fullscreen');
	            self.classes.add('fullscreen');
	            var rect = funcs.getWindowSize();
	            self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	          }
	        }
	        return self.reflow();
	      },
	      postRender: function () {
	        var self = this;
	        var startPos;
	        setTimeout(function () {
	          self.classes.add('in');
	          self.fire('open');
	        }, 0);
	        self._super();
	        if (self.statusbar) {
	          self.statusbar.postRender();
	        }
	        self.focus();
	        this.dragHelper = new DragHelper(self._id + '-dragh', {
	          start: function () {
	            startPos = {
	              x: self.layoutRect().x,
	              y: self.layoutRect().y
	            };
	          },
	          drag: function (e) {
	            self.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY);
	          }
	        });
	        self.on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            self.close();
	          }
	        });
	        windows.push(self);
	        toggleFullScreenState(true);
	      },
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	      remove: function () {
	        var self = this;
	        var i;
	        self.dragHelper.destroy();
	        self._super();
	        if (self.statusbar) {
	          this.statusbar.remove();
	        }
	        toggleBodyFullScreenClasses(self.classPrefix, false);
	        i = windows.length;
	        while (i--) {
	          if (windows[i] === self) {
	            windows.splice(i, 1);
	          }
	        }
	        toggleFullScreenState(windows.length > 0);
	      },
	      getContentWindow: function () {
	        var ifr = this.getEl().getElementsByTagName('iframe')[0];
	        return ifr ? ifr.contentWindow : null;
	      }
	    });
	    handleWindowResize();
	
	    var MessageBox = Window.extend({
	      init: function (settings) {
	        settings = {
	          border: 1,
	          padding: 20,
	          layout: 'flex',
	          pack: 'center',
	          align: 'center',
	          containerCls: 'panel',
	          autoScroll: true,
	          buttons: {
	            type: 'button',
	            text: 'Ok',
	            action: 'ok'
	          },
	          items: {
	            type: 'label',
	            multiline: true,
	            maxWidth: 500,
	            maxHeight: 200
	          }
	        };
	        this._super(settings);
	      },
	      Statics: {
	        OK: 1,
	        OK_CANCEL: 2,
	        YES_NO: 3,
	        YES_NO_CANCEL: 4,
	        msgBox: function (settings) {
	          var buttons;
	          var callback = settings.callback || function () {
	          };
	          function createButton(text, status, primary) {
	            return {
	              type: 'button',
	              text: text,
	              subtype: primary ? 'primary' : '',
	              onClick: function (e) {
	                e.control.parents()[1].close();
	                callback(status);
	              }
	            };
	          }
	          switch (settings.buttons) {
	          case MessageBox.OK_CANCEL:
	            buttons = [
	              createButton('Ok', true, true),
	              createButton('Cancel', false)
	            ];
	            break;
	          case MessageBox.YES_NO:
	          case MessageBox.YES_NO_CANCEL:
	            buttons = [
	              createButton('Yes', 1, true),
	              createButton('No', 0)
	            ];
	            if (settings.buttons === MessageBox.YES_NO_CANCEL) {
	              buttons.push(createButton('Cancel', -1));
	            }
	            break;
	          default:
	            buttons = [createButton('Ok', true, true)];
	            break;
	          }
	          return new Window({
	            padding: 20,
	            x: settings.x,
	            y: settings.y,
	            minWidth: 300,
	            minHeight: 100,
	            layout: 'flex',
	            pack: 'center',
	            align: 'center',
	            buttons: buttons,
	            title: settings.title,
	            role: 'alertdialog',
	            items: {
	              type: 'label',
	              multiline: true,
	              maxWidth: 500,
	              maxHeight: 200,
	              text: settings.text
	            },
	            onPostRender: function () {
	              this.aria('describedby', this.items()[0]._id);
	            },
	            onClose: settings.onClose,
	            onCancel: function () {
	              callback(false);
	            }
	          }).renderTo(domGlobals.document.body).reflow();
	        },
	        alert: function (settings, callback) {
	          if (typeof settings === 'string') {
	            settings = { text: settings };
	          }
	          settings.callback = callback;
	          return MessageBox.msgBox(settings);
	        },
	        confirm: function (settings, callback) {
	          if (typeof settings === 'string') {
	            settings = { text: settings };
	          }
	          settings.callback = callback;
	          settings.buttons = MessageBox.OK_CANCEL;
	          return MessageBox.msgBox(settings);
	        }
	      }
	    });
	
	    function WindowManagerImpl (editor) {
	      var open = function (args, params, closeCallback) {
	        var win;
	        args.title = args.title || ' ';
	        args.url = args.url || args.file;
	        if (args.url) {
	          args.width = parseInt(args.width || 320, 10);
	          args.height = parseInt(args.height || 240, 10);
	        }
	        if (args.body) {
	          args.items = {
	            defaults: args.defaults,
	            type: args.bodyType || 'form',
	            items: args.body,
	            data: args.data,
	            callbacks: args.commands
	          };
	        }
	        if (!args.url && !args.buttons) {
	          args.buttons = [
	            {
	              text: 'Ok',
	              subtype: 'primary',
	              onclick: function () {
	                win.find('form')[0].submit();
	              }
	            },
	            {
	              text: 'Cancel',
	              onclick: function () {
	                win.close();
	              }
	            }
	          ];
	        }
	        win = new Window(args);
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        if (args.data) {
	          win.on('postRender', function () {
	            this.find('*').each(function (ctrl) {
	              var name = ctrl.name();
	              if (name in args.data) {
	                ctrl.value(args.data[name]);
	              }
	            });
	          });
	        }
	        win.features = args || {};
	        win.params = params || {};
	        win = win.renderTo(domGlobals.document.body).reflow();
	        return win;
	      };
	      var alert = function (message, choiceCallback, closeCallback) {
	        var win;
	        win = MessageBox.alert(message, function () {
	          choiceCallback();
	        });
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        return win;
	      };
	      var confirm = function (message, choiceCallback, closeCallback) {
	        var win;
	        win = MessageBox.confirm(message, function (state) {
	          choiceCallback(state);
	        });
	        win.on('close', function () {
	          closeCallback(win);
	        });
	        return win;
	      };
	      var close = function (window) {
	        window.close();
	      };
	      var getParams = function (window) {
	        return window.params;
	      };
	      var setParams = function (window, params) {
	        window.params = params;
	      };
	      return {
	        open: open,
	        alert: alert,
	        confirm: confirm,
	        close: close,
	        getParams: getParams,
	        setParams: setParams
	      };
	    }
	
	    var get = function (editor) {
	      var renderUI = function (args) {
	        return Render.renderUI(editor, this, args);
	      };
	      var resizeTo = function (w, h) {
	        return Resize.resizeTo(editor, w, h);
	      };
	      var resizeBy = function (dw, dh) {
	        return Resize.resizeBy(editor, dw, dh);
	      };
	      var getNotificationManagerImpl = function () {
	        return NotificationManagerImpl(editor);
	      };
	      var getWindowManagerImpl = function () {
	        return WindowManagerImpl();
	      };
	      return {
	        renderUI: renderUI,
	        resizeTo: resizeTo,
	        resizeBy: resizeBy,
	        getNotificationManagerImpl: getNotificationManagerImpl,
	        getWindowManagerImpl: getWindowManagerImpl
	      };
	    };
	    var ThemeApi = { get: get };
	
	    var Layout = global$a.extend({
	      Defaults: {
	        firstControlClass: 'first',
	        lastControlClass: 'last'
	      },
	      init: function (settings) {
	        this.settings = global$2.extend({}, this.Defaults, settings);
	      },
	      preRender: function (container) {
	        container.bodyClasses.add(this.settings.containerClass);
	      },
	      applyClasses: function (items) {
	        var self = this;
	        var settings = self.settings;
	        var firstClass, lastClass, firstItem, lastItem;
	        firstClass = settings.firstControlClass;
	        lastClass = settings.lastControlClass;
	        items.each(function (item) {
	          item.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
	          if (item.visible()) {
	            if (!firstItem) {
	              firstItem = item;
	            }
	            lastItem = item;
	          }
	        });
	        if (firstItem) {
	          firstItem.classes.add(firstClass);
	        }
	        if (lastItem) {
	          lastItem.classes.add(lastClass);
	        }
	      },
	      renderHtml: function (container) {
	        var self = this;
	        var html = '';
	        self.applyClasses(container.items());
	        container.items().each(function (item) {
	          html += item.renderHtml();
	        });
	        return html;
	      },
	      recalc: function () {
	      },
	      postRender: function () {
	      },
	      isNative: function () {
	        return false;
	      }
	    });
	
	    var AbsoluteLayout = Layout.extend({
	      Defaults: {
	        containerClass: 'abs-layout',
	        controlClass: 'abs-layout-item'
	      },
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          var settings = ctrl.settings;
	          ctrl.layoutRect({
	            x: settings.x,
	            y: settings.y,
	            w: settings.w,
	            h: settings.h
	          });
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	      renderHtml: function (container) {
	        return '<div id="' + container._id + '-absend" class="' + container.classPrefix + 'abs-end"></div>' + this._super(container);
	      }
	    });
	
	    var Button = Widget.extend({
	      Defaults: {
	        classes: 'widget btn',
	        role: 'button'
	      },
	      init: function (settings) {
	        var self = this;
	        var size;
	        self._super(settings);
	        settings = self.settings;
	        size = self.settings.size;
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	        self.on('touchstart', function (e) {
	          self.fire('click', e);
	          e.preventDefault();
	        });
	        if (settings.subtype) {
	          self.classes.add(settings.subtype);
	        }
	        if (size) {
	          self.classes.add('btn-' + size);
	        }
	        if (settings.icon) {
	          self.icon(settings.icon);
	        }
	      },
	      icon: function (icon) {
	        if (!arguments.length) {
	          return this.state.get('icon');
	        }
	        this.state.set('icon', icon);
	        return this;
	      },
	      repaint: function () {
	        var btnElm = this.getEl().firstChild;
	        var btnStyle;
	        if (btnElm) {
	          btnStyle = btnElm.style;
	          btnStyle.width = btnStyle.height = '100%';
	        }
	        this._super();
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.state.get('icon'), image;
	        var text = self.state.get('text');
	        var textHtml = '';
	        var ariaPressed;
	        var settings = self.settings;
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        icon = icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1"' + ariaPressed + '>' + '<button id="' + id + '-button" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this, $ = self.$, textCls = self.classPrefix + 'txt';
	        function setButtonText(text) {
	          var $span = $('span.' + textCls, self.getEl());
	          if (text) {
	            if (!$span[0]) {
	              $('button:first', self.getEl()).append('<span class="' + textCls + '"></span>');
	              $span = $('span.' + textCls, self.getEl());
	            }
	            $span.html(self.encode(text));
	          } else {
	            $span.remove();
	          }
	          self.classes.toggle('btn-has-text', !!text);
	        }
	        self.state.on('change:text', function (e) {
	          setButtonText(e.value);
	        });
	        self.state.on('change:icon', function (e) {
	          var icon = e.value;
	          var prefix = self.classPrefix;
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	          var btnElm = self.getEl().firstChild;
	          var iconElm = btnElm.getElementsByTagName('i')[0];
	          if (icon) {
	            if (!iconElm || iconElm !== btnElm.firstChild) {
	              iconElm = domGlobals.document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	          setButtonText(self.state.get('text'));
	        });
	        return self._super();
	      }
	    });
	
	    var BrowseButton = Button.extend({
	      init: function (settings) {
	        var self = this;
	        settings = global$2.extend({
	          text: 'Browse...',
	          multiple: false,
	          accept: null
	        }, settings);
	        self._super(settings);
	        self.classes.add('browsebutton');
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	      postRender: function () {
	        var self = this;
	        var input = funcs.create('input', {
	          type: 'file',
	          id: self._id + '-browse',
	          accept: self.settings.accept
	        });
	        self._super();
	        global$9(input).on('change', function (e) {
	          var files = e.target.files;
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	          e.preventDefault();
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	        global$9(input).on('click', function (e) {
	          e.stopPropagation();
	        });
	        global$9(self.getEl('button')).on('click touchstart', function (e) {
	          e.stopPropagation();
	          input.click();
	          e.preventDefault();
	        });
	        self.getEl().appendChild(input);
	      },
	      remove: function () {
	        global$9(this.getEl('button')).off();
	        global$9(this.getEl('input')).off();
	        this._super();
	      }
	    });
	
	    var ButtonGroup = Container.extend({
	      Defaults: {
	        defaultType: 'button',
	        role: 'group'
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout;
	        self.classes.add('btn-group');
	        self.preRender();
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      }
	    });
	
	    var Checkbox = Widget.extend({
	      Defaults: {
	        classes: 'checkbox',
	        role: 'checkbox',
	        checked: false
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	        self.on('click', function (e) {
	          e.preventDefault();
	          if (!self.disabled()) {
	            self.checked(!self.checked());
	          }
	        });
	        self.checked(self.settings.checked);
	      },
	      checked: function (state) {
	        if (!arguments.length) {
	          return this.state.get('checked');
	        }
	        this.state.set('checked', state);
	        return this;
	      },
	      value: function (state) {
	        if (!arguments.length) {
	          return this.checked();
	        }
	        return this.checked(state);
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' + '<span id="' + id + '-al" class="' + prefix + 'label">' + self.encode(self.state.get('text')) + '</span>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        function checked(state) {
	          self.classes.toggle('checked', state);
	          self.aria('checked', state);
	        }
	        self.state.on('change:text', function (e) {
	          self.getEl('al').firstChild.data = self.translate(e.value);
	        });
	        self.state.on('change:checked change:value', function (e) {
	          self.fire('change');
	          checked(e.value);
	        });
	        self.state.on('change:icon', function (e) {
	          var icon = e.value;
	          var prefix = self.classPrefix;
	          if (typeof icon === 'undefined') {
	            return self.settings.icon;
	          }
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	          var btnElm = self.getEl().firstChild;
	          var iconElm = btnElm.getElementsByTagName('i')[0];
	          if (icon) {
	            if (!iconElm || iconElm !== btnElm.firstChild) {
	              iconElm = domGlobals.document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	        });
	        if (self.state.get('checked')) {
	          checked(true);
	        }
	        return self._super();
	      }
	    });
	
	    var global$d = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var ComboBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('combobox');
	        self.subinput = true;
	        self.ariaTarget = 'inp';
	        settings.menu = settings.menu || settings.values;
	        if (settings.menu) {
	          settings.icon = 'caret';
	        }
	        self.on('click', function (e) {
	          var elm = e.target;
	          var root = self.getEl();
	          if (!global$9.contains(root, elm) && elm !== root) {
	            return;
	          }
	          while (elm && elm !== root) {
	            if (elm.id && elm.id.indexOf('-open') !== -1) {
	              self.fire('action');
	              if (settings.menu) {
	                self.showMenu();
	                if (e.aria) {
	                  self.menu.items()[0].focus();
	                }
	              }
	            }
	            elm = elm.parentNode;
	          }
	        });
	        self.on('keydown', function (e) {
	          var rootControl;
	          if (e.keyCode === 13 && e.target.nodeName === 'INPUT') {
	            e.preventDefault();
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	        self.on('keyup', function (e) {
	          if (e.target.nodeName === 'INPUT') {
	            var oldValue = self.state.get('value');
	            var newValue = e.target.value;
	            if (newValue !== oldValue) {
	              self.state.set('value', newValue);
	              self.fire('autocomplete', e);
	            }
	          }
	        });
	        self.on('mouseover', function (e) {
	          var tooltip = self.tooltip().moveTo(-65535);
	          if (self.statusLevel() && e.target.className.indexOf(self.classPrefix + 'status') !== -1) {
	            var statusMessage = self.statusMessage() || 'Ok';
	            var rel = tooltip.text(statusMessage).show().testMoveRel(e.target, [
	              'bc-tc',
	              'bc-tl',
	              'bc-tr'
	            ]);
	            tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
	            tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
	            tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
	            tooltip.moveRel(e.target, rel);
	          }
	        });
	      },
	      statusLevel: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusLevel', value);
	        }
	        return this.state.get('statusLevel');
	      },
	      statusMessage: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusMessage', value);
	        }
	        return this.state.get('statusMessage');
	      },
	      showMenu: function () {
	        var self = this;
	        var settings = self.settings;
	        var menu;
	        if (!self.menu) {
	          menu = settings.menu || [];
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	          }
	          self.menu = global$4.create(menu).parent(self).renderTo(self.getContainerElm());
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control === self.menu) {
	              self.focus();
	            }
	          });
	          self.menu.on('show hide', function (e) {
	            e.control.items().each(function (ctrl) {
	              ctrl.active(ctrl.value() === self.value());
	            });
	          }).fire('show');
	          self.menu.on('select', function (e) {
	            self.value(e.control.value());
	          });
	          self.on('focusin', function (e) {
	            if (e.target.tagName.toUpperCase() === 'INPUT') {
	              self.menu.hide();
	            }
	          });
	          self.aria('expanded', true);
	        }
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	      },
	      focus: function () {
	        this.getEl('inp').focus();
	      },
	      repaint: function () {
	        var self = this, elm = self.getEl(), openElm = self.getEl('open'), rect = self.layoutRect();
	        var width, lineHeight, innerPadding = 0;
	        var inputElm = elm.firstChild;
	        if (self.statusLevel() && self.statusLevel() !== 'none') {
	          innerPadding = parseInt(funcs.getRuntimeStyle(inputElm, 'padding-right'), 10) - parseInt(funcs.getRuntimeStyle(inputElm, 'padding-left'), 10);
	        }
	        if (openElm) {
	          width = rect.w - funcs.getSize(openElm).width - 10;
	        } else {
	          width = rect.w - 10;
	        }
	        var doc = domGlobals.document;
	        if (doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          lineHeight = self.layoutRect().h - 2 + 'px';
	        }
	        global$9(inputElm).css({
	          width: width - innerPadding,
	          lineHeight: lineHeight
	        });
	        self._super();
	        return self;
	      },
	      postRender: function () {
	        var self = this;
	        global$9(this.getEl('inp')).on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	        return self._super();
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix;
	        var value = self.state.get('value') || '';
	        var icon, text, openBtnHtml = '', extraAttrs = '', statusHtml = '';
	        if ('spellcheck' in settings) {
	          extraAttrs += ' spellcheck="' + settings.spellcheck + '"';
	        }
	        if (settings.maxLength) {
	          extraAttrs += ' maxlength="' + settings.maxLength + '"';
	        }
	        if (settings.size) {
	          extraAttrs += ' size="' + settings.size + '"';
	        }
	        if (settings.subtype) {
	          extraAttrs += ' type="' + settings.subtype + '"';
	        }
	        statusHtml = '<i id="' + id + '-status" class="mce-status mce-ico" style="display: none"></i>';
	        if (self.disabled()) {
	          extraAttrs += ' disabled="disabled"';
	        }
	        icon = settings.icon;
	        if (icon && icon !== 'caret') {
	          icon = prefix + 'ico ' + prefix + 'i-' + settings.icon;
	        }
	        text = self.state.get('text');
	        if (icon || text) {
	          openBtnHtml = '<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' + '<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' + (icon !== 'caret' ? '<i class="' + icon + '"></i>' : '<i class="' + prefix + 'caret"></i>') + (text ? (icon ? ' ' : '') + text : '') + '</button>' + '</div>';
	          self.classes.add('has-open');
	        }
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' + self.encode(value, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' + self.encode(settings.placeholder) + '" />' + statusHtml + openBtnHtml + '</div>';
	      },
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl('inp').value);
	        }
	        return this.state.get('value');
	      },
	      showAutoComplete: function (items, term) {
	        var self = this;
	        if (items.length === 0) {
	          self.hideMenu();
	          return;
	        }
	        var insert = function (value, title) {
	          return function () {
	            self.fire('selectitem', {
	              title: title,
	              value: value
	            });
	          };
	        };
	        if (self.menu) {
	          self.menu.items().remove();
	        } else {
	          self.menu = global$4.create({
	            type: 'menu',
	            classes: 'combobox-menu',
	            layout: 'flow'
	          }).parent(self).renderTo();
	        }
	        global$2.each(items, function (item) {
	          self.menu.add({
	            text: item.title,
	            url: item.previewUrl,
	            match: term,
	            classes: 'menu-item-ellipsis',
	            onclick: insert(item.value, item.title)
	          });
	        });
	        self.menu.renderNew();
	        self.hideMenu();
	        self.menu.on('cancel', function (e) {
	          if (e.control.parent() === self.menu) {
	            e.stopPropagation();
	            self.focus();
	            self.hideMenu();
	          }
	        });
	        self.menu.on('select', function () {
	          self.focus();
	        });
	        var maxW = self.layoutRect().w;
	        self.menu.layoutRect({
	          w: maxW,
	          minW: 0,
	          maxW: maxW
	        });
	        self.menu.repaint();
	        self.menu.reflow();
	        self.menu.show();
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	      },
	      hideMenu: function () {
	        if (this.menu) {
	          this.menu.hide();
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.getEl('inp').value !== e.value) {
	            self.getEl('inp').value = e.value;
	          }
	        });
	        self.state.on('change:disabled', function (e) {
	          self.getEl('inp').disabled = e.value;
	        });
	        self.state.on('change:statusLevel', function (e) {
	          var statusIconElm = self.getEl('status');
	          var prefix = self.classPrefix, value = e.value;
	          funcs.css(statusIconElm, 'display', value === 'none' ? 'none' : '');
	          funcs.toggleClass(statusIconElm, prefix + 'i-checkmark', value === 'ok');
	          funcs.toggleClass(statusIconElm, prefix + 'i-warning', value === 'warn');
	          funcs.toggleClass(statusIconElm, prefix + 'i-error', value === 'error');
	          self.classes.toggle('has-status', value !== 'none');
	          self.repaint();
	        });
	        funcs.on(self.getEl('status'), 'mouseleave', function () {
	          self.tooltip().hide();
	        });
	        self.on('cancel', function (e) {
	          if (self.menu && self.menu.visible()) {
	            e.stopPropagation();
	            self.hideMenu();
	          }
	        });
	        var focusIdx = function (idx, menu) {
	          if (menu && menu.items().length > 0) {
	            menu.items().eq(idx)[0].focus();
	          }
	        };
	        self.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          if (e.target.nodeName === 'INPUT') {
	            if (keyCode === global$d.DOWN) {
	              e.preventDefault();
	              self.fire('autocomplete');
	              focusIdx(0, self.menu);
	            } else if (keyCode === global$d.UP) {
	              e.preventDefault();
	              focusIdx(-1, self.menu);
	            }
	          }
	        });
	        return self._super();
	      },
	      remove: function () {
	        global$9(this.getEl('inp')).off();
	        if (this.menu) {
	          this.menu.remove();
	        }
	        this._super();
	      }
	    });
	
	    var ColorBox = ComboBox.extend({
	      init: function (settings) {
	        var self = this;
	        settings.spellcheck = false;
	        if (settings.onaction) {
	          settings.icon = 'none';
	        }
	        self._super(settings);
	        self.classes.add('colorbox');
	        self.on('change keyup postrender', function () {
	          self.repaintColor(self.value());
	        });
	      },
	      repaintColor: function (value) {
	        var openElm = this.getEl('open');
	        var elm = openElm ? openElm.getElementsByTagName('i')[0] : null;
	        if (elm) {
	          try {
	            elm.style.background = value;
	          } catch (ex) {
	          }
	        }
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.state.get('rendered')) {
	            self.repaintColor(e.value);
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var PanelButton = Button.extend({
	      showPanel: function () {
	        var self = this, settings = self.settings;
	        self.classes.add('opened');
	        if (!self.panel) {
	          var panelSettings = settings.panel;
	          if (panelSettings.type) {
	            panelSettings = {
	              layout: 'grid',
	              items: panelSettings
	            };
	          }
	          panelSettings.role = panelSettings.role || 'dialog';
	          panelSettings.popover = true;
	          panelSettings.autohide = true;
	          panelSettings.ariaRoot = true;
	          self.panel = new FloatPanel(panelSettings).on('hide', function () {
	            self.classes.remove('opened');
	          }).on('cancel', function (e) {
	            e.stopPropagation();
	            self.focus();
	            self.hidePanel();
	          }).parent(self).renderTo(self.getContainerElm());
	          self.panel.fire('show');
	          self.panel.reflow();
	        } else {
	          self.panel.show();
	        }
	        var rtlRels = [
	          'bc-tc',
	          'bc-tl',
	          'bc-tr'
	        ];
	        var ltrRels = [
	          'bc-tc',
	          'bc-tr',
	          'bc-tl',
	          'tc-bc',
	          'tc-br',
	          'tc-bl'
	        ];
	        var rel = self.panel.testMoveRel(self.getEl(), settings.popoverAlign || (self.isRtl() ? rtlRels : ltrRels));
	        self.panel.classes.toggle('start', rel.substr(-1) === 'l');
	        self.panel.classes.toggle('end', rel.substr(-1) === 'r');
	        var isTop = rel.substr(0, 1) === 't';
	        self.panel.classes.toggle('bottom', !isTop);
	        self.panel.classes.toggle('top', isTop);
	        self.panel.moveRel(self.getEl(), rel);
	      },
	      hidePanel: function () {
	        var self = this;
	        if (self.panel) {
	          self.panel.hide();
	        }
	      },
	      postRender: function () {
	        var self = this;
	        self.aria('haspopup', true);
	        self.on('click', function (e) {
	          if (e.control === self) {
	            if (self.panel && self.panel.visible()) {
	              self.hidePanel();
	            } else {
	              self.showPanel();
	              self.panel.focus(!!e.aria);
	            }
	          }
	        });
	        return self._super();
	      },
	      remove: function () {
	        if (this.panel) {
	          this.panel.remove();
	          this.panel = null;
	        }
	        return this._super();
	      }
	    });
	
	    var DOM$3 = global$3.DOM;
	    var ColorButton = PanelButton.extend({
	      init: function (settings) {
	        this._super(settings);
	        this.classes.add('splitbtn');
	        this.classes.add('colorbutton');
	      },
	      color: function (color) {
	        if (color) {
	          this._color = color;
	          this.getEl('preview').style.backgroundColor = color;
	          return this;
	        }
	        return this._color;
	      },
	      resetColor: function () {
	        this._color = null;
	        this.getEl('preview').style.backgroundColor = null;
	        return this;
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix, text = self.state.get('text');
	        var icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	        var image = self.settings.image ? ' style="background-image: url(\'' + self.settings.image + '\')"' : '';
	        var textHtml = '';
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        return '<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1" aria-haspopup="true">' + '<button role="presentation" hidefocus="1" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + '<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	        self.on('click', function (e) {
	          if (e.aria && e.aria.key === 'down') {
	            return;
	          }
	          if (e.control === self && !DOM$3.getParent(e.target, '.' + self.classPrefix + 'open')) {
	            e.stopImmediatePropagation();
	            onClickHandler.call(self, e);
	          }
	        });
	        delete self.settings.onclick;
	        return self._super();
	      }
	    });
	
	    var global$e = tinymce.util.Tools.resolve('tinymce.util.Color');
	
	    var ColorPicker = Widget.extend({
	      Defaults: { classes: 'widget colorpicker' },
	      init: function (settings) {
	        this._super(settings);
	      },
	      postRender: function () {
	        var self = this;
	        var color = self.color();
	        var hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
	        hueRootElm = self.getEl('h');
	        huePointElm = self.getEl('hp');
	        svRootElm = self.getEl('sv');
	        svPointElm = self.getEl('svp');
	        function getPos(elm, event) {
	          var pos = funcs.getPos(elm);
	          var x, y;
	          x = event.pageX - pos.x;
	          y = event.pageY - pos.y;
	          x = Math.max(0, Math.min(x / elm.clientWidth, 1));
	          y = Math.max(0, Math.min(y / elm.clientHeight, 1));
	          return {
	            x: x,
	            y: y
	          };
	        }
	        function updateColor(hsv, hueUpdate) {
	          var hue = (360 - hsv.h) / 360;
	          funcs.css(huePointElm, { top: hue * 100 + '%' });
	          if (!hueUpdate) {
	            funcs.css(svPointElm, {
	              left: hsv.s + '%',
	              top: 100 - hsv.v + '%'
	            });
	          }
	          svRootElm.style.background = global$e({
	            s: 100,
	            v: 100,
	            h: hsv.h
	          }).toHex();
	          self.color().parse({
	            s: hsv.s,
	            v: hsv.v,
	            h: hsv.h
	          });
	        }
	        function updateSaturationAndValue(e) {
	          var pos;
	          pos = getPos(svRootElm, e);
	          hsv.s = pos.x * 100;
	          hsv.v = (1 - pos.y) * 100;
	          updateColor(hsv);
	          self.fire('change');
	        }
	        function updateHue(e) {
	          var pos;
	          pos = getPos(hueRootElm, e);
	          hsv = color.toHsv();
	          hsv.h = (1 - pos.y) * 360;
	          updateColor(hsv, true);
	          self.fire('change');
	        }
	        self._repaint = function () {
	          hsv = color.toHsv();
	          updateColor(hsv);
	        };
	        self._super();
	        self._svdraghelper = new DragHelper(self._id + '-sv', {
	          start: updateSaturationAndValue,
	          drag: updateSaturationAndValue
	        });
	        self._hdraghelper = new DragHelper(self._id + '-h', {
	          start: updateHue,
	          drag: updateHue
	        });
	        self._repaint();
	      },
	      rgb: function () {
	        return this.color().toRgb();
	      },
	      value: function (value) {
	        var self = this;
	        if (arguments.length) {
	          self.color().parse(value);
	          if (self._rendered) {
	            self._repaint();
	          }
	        } else {
	          return self.color().toHex();
	        }
	      },
	      color: function () {
	        if (!this._color) {
	          this._color = global$e();
	        }
	        return this._color;
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var prefix = self.classPrefix;
	        var hueHtml;
	        var stops = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';
	        function getOldIeFallbackHtml() {
	          var i, l, html = '', gradientPrefix, stopsList;
	          gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
	          stopsList = stops.split(',');
	          for (i = 0, l = stopsList.length - 1; i < l; i++) {
	            html += '<div class="' + prefix + 'colorpicker-h-chunk" style="' + 'height:' + 100 / l + '%;' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' + '-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' + '"></div>';
	          }
	          return html;
	        }
	        var gradientCssText = 'background: -ms-linear-gradient(top,' + stops + ');' + 'background: linear-gradient(to bottom,' + stops + ');';
	        hueHtml = '<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + gradientCssText + '">' + getOldIeFallbackHtml() + '<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' + '</div>';
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' + '<div class="' + prefix + 'colorpicker-overlay1">' + '<div class="' + prefix + 'colorpicker-overlay2">' + '<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' + '<div class="' + prefix + 'colorpicker-selector2"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + hueHtml + '</div>';
	      }
	    });
	
	    var DropZone = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        settings = global$2.extend({
	          height: 100,
	          text: 'Drop an image here',
	          multiple: false,
	          accept: null
	        }, settings);
	        self._super(settings);
	        self.classes.add('dropzone');
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	      renderHtml: function () {
	        var self = this;
	        var attrs, elm;
	        var cfg = self.settings;
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	        elm = funcs.create('div', attrs, '<span>' + this.translate(cfg.text) + '</span>');
	        if (cfg.height) {
	          funcs.css(elm, 'height', cfg.height + 'px');
	        }
	        if (cfg.width) {
	          funcs.css(elm, 'width', cfg.width + 'px');
	        }
	        elm.className = self.classes;
	        return elm.outerHTML;
	      },
	      postRender: function () {
	        var self = this;
	        var toggleDragClass = function (e) {
	          e.preventDefault();
	          self.classes.toggle('dragenter');
	          self.getEl().className = self.classes;
	        };
	        var filter = function (files) {
	          var accept = self.settings.accept;
	          if (typeof accept !== 'string') {
	            return files;
	          }
	          var re = new RegExp('(' + accept.split(/\s*,\s*/).join('|') + ')$', 'i');
	          return global$2.grep(files, function (file) {
	            return re.test(file.name);
	          });
	        };
	        self._super();
	        self.$el.on('dragover', function (e) {
	          e.preventDefault();
	        });
	        self.$el.on('dragenter', toggleDragClass);
	        self.$el.on('dragleave', toggleDragClass);
	        self.$el.on('drop', function (e) {
	          e.preventDefault();
	          if (self.state.get('disabled')) {
	            return;
	          }
	          var files = filter(e.dataTransfer.files);
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	      },
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	
	    var Path = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        if (!settings.delimiter) {
	          settings.delimiter = '\xBB';
	        }
	        self._super(settings);
	        self.classes.add('path');
	        self.canFocus = true;
	        self.on('click', function (e) {
	          var index;
	          var target = e.target;
	          if (index = target.getAttribute('data-index')) {
	            self.fire('select', {
	              value: self.row()[index],
	              index: index
	            });
	          }
	        });
	        self.row(self.settings.row);
	      },
	      focus: function () {
	        var self = this;
	        self.getEl().firstChild.focus();
	        return self;
	      },
	      row: function (row) {
	        if (!arguments.length) {
	          return this.state.get('row');
	        }
	        this.state.set('row', row);
	        return this;
	      },
	      renderHtml: function () {
	        var self = this;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + self._getDataPathHtml(self.state.get('row')) + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:row', function (e) {
	          self.innerHtml(self._getDataPathHtml(e.value));
	        });
	        return self._super();
	      },
	      _getDataPathHtml: function (data) {
	        var self = this;
	        var parts = data || [];
	        var i, l, html = '';
	        var prefix = self.classPrefix;
	        for (i = 0, l = parts.length; i < l; i++) {
	          html += (i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + self.settings.delimiter + ' </div>' : '') + '<div role="button" class="' + prefix + 'path-item' + (i === l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' + i + '" tabindex="-1" id="' + self._id + '-' + i + '" aria-level="' + (i + 1) + '">' + parts[i].name + '</div>';
	        }
	        if (!html) {
	          html = '<div class="' + prefix + 'path-item">\xA0</div>';
	        }
	        return html;
	      }
	    });
	
	    var ElementPath = Path.extend({
	      postRender: function () {
	        var self = this, editor = self.settings.editor;
	        function isHidden(elm) {
	          if (elm.nodeType === 1) {
	            if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
	              return true;
	            }
	            if (elm.getAttribute('data-mce-type') === 'bookmark') {
	              return true;
	            }
	          }
	          return false;
	        }
	        if (editor.settings.elementpath !== false) {
	          self.on('select', function (e) {
	            editor.focus();
	            editor.selection.select(this.row()[e.index].element);
	            editor.nodeChanged();
	          });
	          editor.on('nodeChange', function (e) {
	            var outParents = [];
	            var parents = e.parents;
	            var i = parents.length;
	            while (i--) {
	              if (parents[i].nodeType === 1 && !isHidden(parents[i])) {
	                var args = editor.fire('ResolveName', {
	                  name: parents[i].nodeName.toLowerCase(),
	                  target: parents[i]
	                });
	                if (!args.isDefaultPrevented()) {
	                  outParents.push({
	                    name: args.name,
	                    element: parents[i]
	                  });
	                }
	                if (args.isPropagationStopped()) {
	                  break;
	                }
	              }
	            }
	            self.row(outParents);
	          });
	        }
	        return self._super();
	      }
	    });
	
	    var FormItem = Container.extend({
	      Defaults: {
	        layout: 'flex',
	        align: 'center',
	        defaults: { flex: 1 }
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	        self.classes.add('formitem');
	        layout.preRender(self);
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<div id="' + self._id + '-title" class="' + prefix + 'title">' + self.settings.title + '</div>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
	      }
	    });
	
	    var Form = Container.extend({
	      Defaults: {
	        containerCls: 'form',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: 15,
	        labelGap: 30,
	        spacing: 10,
	        callbacks: {
	          submit: function () {
	            this.submit();
	          }
	        }
	      },
	      preRender: function () {
	        var self = this, items = self.items();
	        if (!self.settings.formItemDefaults) {
	          self.settings.formItemDefaults = {
	            layout: 'flex',
	            autoResize: 'overflow',
	            defaults: { flex: 1 }
	          };
	        }
	        items.each(function (ctrl) {
	          var formItem;
	          var label = ctrl.settings.label;
	          if (label) {
	            formItem = new FormItem(global$2.extend({
	              items: {
	                type: 'label',
	                id: ctrl._id + '-l',
	                text: label,
	                flex: 0,
	                forId: ctrl._id,
	                disabled: ctrl.disabled()
	              }
	            }, self.settings.formItemDefaults));
	            formItem.type = 'formitem';
	            ctrl.aria('labelledby', ctrl._id + '-l');
	            if (typeof ctrl.settings.flex === 'undefined') {
	              ctrl.settings.flex = 1;
	            }
	            self.replace(ctrl, formItem);
	            formItem.add(ctrl);
	          }
	        });
	      },
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.fromJSON(self.settings.data);
	      },
	      bindStates: function () {
	        var self = this;
	        self._super();
	        function recalcLabels() {
	          var maxLabelWidth = 0;
	          var labels = [];
	          var i, labelGap, items;
	          if (self.settings.labelGapCalc === false) {
	            return;
	          }
	          if (self.settings.labelGapCalc === 'children') {
	            items = self.find('formitem');
	          } else {
	            items = self.items();
	          }
	          items.filter('formitem').each(function (item) {
	            var labelCtrl = item.items()[0], labelWidth = labelCtrl.getEl().clientWidth;
	            maxLabelWidth = labelWidth > maxLabelWidth ? labelWidth : maxLabelWidth;
	            labels.push(labelCtrl);
	          });
	          labelGap = self.settings.labelGap || 0;
	          i = labels.length;
	          while (i--) {
	            labels[i].settings.minWidth = maxLabelWidth + labelGap;
	          }
	        }
	        self.on('show', recalcLabels);
	        recalcLabels();
	      }
	    });
	
	    var FieldSet = Form.extend({
	      Defaults: {
	        containerCls: 'fieldset',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: '25 15 5 15',
	        labelGap: 30,
	        spacing: 10,
	        border: 1
	      },
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	        self.preRender();
	        layout.preRender(self);
	        return '<fieldset id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<legend id="' + self._id + '-title" class="' + prefix + 'fieldset-title">' + self.settings.title + '</legend>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</fieldset>';
	      }
	    });
	
	    var unique$1 = 0;
	    var generate = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique$1++;
	      return prefix + '_' + random + unique$1 + String(time);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || domGlobals.document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        domGlobals.console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || domGlobals.document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: constant(node) };
	    };
	    var fromPoint = function (docElm, x, y) {
	      var doc = docElm.dom();
	      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
	    };
	    var Element = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var ATTRIBUTE = domGlobals.Node.ATTRIBUTE_NODE;
	    var CDATA_SECTION = domGlobals.Node.CDATA_SECTION_NODE;
	    var COMMENT = domGlobals.Node.COMMENT_NODE;
	    var DOCUMENT = domGlobals.Node.DOCUMENT_NODE;
	    var DOCUMENT_TYPE = domGlobals.Node.DOCUMENT_TYPE_NODE;
	    var DOCUMENT_FRAGMENT = domGlobals.Node.DOCUMENT_FRAGMENT_NODE;
	    var ELEMENT = domGlobals.Node.ELEMENT_NODE;
	    var TEXT = domGlobals.Node.TEXT_NODE;
	    var PROCESSING_INSTRUCTION = domGlobals.Node.PROCESSING_INSTRUCTION_NODE;
	    var ENTITY_REFERENCE = domGlobals.Node.ENTITY_REFERENCE_NODE;
	    var ENTITY = domGlobals.Node.ENTITY_NODE;
	    var NOTATION = domGlobals.Node.NOTATION_NODE;
	
	    var Global = typeof domGlobals.window !== 'undefined' ? domGlobals.window : Function('return this;')();
	
	    var path = function (parts, scope) {
	      var o = scope !== undefined && scope !== null ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
	        o = o[parts[i]];
	      }
	      return o;
	    };
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    var unsafe = function (name, scope) {
	      return resolve(name, scope);
	    };
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	      if (actual === undefined || actual === null) {
	        throw new Error(name + ' not available on this browser');
	      }
	      return actual;
	    };
	    var Global$1 = { getOrDie: getOrDie };
	
	    var Immutable = function () {
	      var fields = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        fields[_i] = arguments[_i];
	      }
	      return function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        if (fields.length !== values.length) {
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	        }
	        var struct = {};
	        each(fields, function (name, i) {
	          struct[name] = constant(values[i]);
	        });
	        return struct;
	      };
	    };
	
	    var node = function () {
	      var f = Global$1.getOrDie('Node');
	      return f;
	    };
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	    var Node = {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows$1 = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows$1, current),
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows$1),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd)
	    };
	
	    var DeviceType = function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview)
	      };
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var detect$2 = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var detect$3 = cached(function () {
	      var userAgent = domGlobals.navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	    var PlatformDetection$1 = { detect: detect$3 };
	
	    var ELEMENT$1 = ELEMENT;
	    var DOCUMENT$1 = DOCUMENT;
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT$1 && dom.nodeType !== DOCUMENT$1 || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? domGlobals.document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom();
	      var d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	    var browser = PlatformDetection$1.detect().browser;
	    var contains$1 = browser.isIE() ? ieContains : regularContains;
	
	    var spot = Immutable('element', 'offset');
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var trim = global$2.trim;
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (node && node.nodeType === 1) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var create = function (type, title, url, level, attach) {
	      return {
	        type: type,
	        title: title,
	        url: url,
	        level: level,
	        attach: attach
	      };
	    };
	    var isChildOfContentEditableTrue = function (node) {
	      while (node = node.parentNode) {
	        var value = node.contentEditable;
	        if (value && value !== 'inherit') {
	          return isContentEditableTrue(node);
	        }
	      }
	      return false;
	    };
	    var select = function (selector, root) {
	      return map(descendants(Element.fromDom(root), selector), function (element) {
	        return element.dom();
	      });
	    };
	    var getElementText = function (elm) {
	      return elm.innerText || elm.textContent;
	    };
	    var getOrGenerateId = function (elm) {
	      return elm.id ? elm.id : generate('h');
	    };
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName === 'A' && (elm.id || elm.name);
	    };
	    var isValidAnchor = function (elm) {
	      return isAnchor(elm) && isEditable(elm);
	    };
	    var isHeader = function (elm) {
	      return elm && /^(H[1-6])$/.test(elm.nodeName);
	    };
	    var isEditable = function (elm) {
	      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
	    };
	    var isValidHeader = function (elm) {
	      return isHeader(elm) && isEditable(elm);
	    };
	    var getLevel = function (elm) {
	      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
	    };
	    var headerTarget = function (elm) {
	      var headerId = getOrGenerateId(elm);
	      var attach = function () {
	        elm.id = headerId;
	      };
	      return create('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
	    };
	    var anchorTarget = function (elm) {
	      var anchorId = elm.id || elm.name;
	      var anchorText = getElementText(elm);
	      return create('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
	    };
	    var getHeaderTargets = function (elms) {
	      return map(filter(elms, isValidHeader), headerTarget);
	    };
	    var getAnchorTargets = function (elms) {
	      return map(filter(elms, isValidAnchor), anchorTarget);
	    };
	    var getTargetElements = function (elm) {
	      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
	      return elms;
	    };
	    var hasTitle = function (target) {
	      return trim(target.title).length > 0;
	    };
	    var find$2 = function (elm) {
	      var elms = getTargetElements(elm);
	      return filter(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
	    };
	    var LinkTargets = { find: find$2 };
	
	    var getActiveEditor = function () {
	      return window.tinymce ? window.tinymce.activeEditor : global$1.activeEditor;
	    };
	    var history = {};
	    var HISTORY_LENGTH = 5;
	    var clearHistory = function () {
	      history = {};
	    };
	    var toMenuItem = function (target) {
	      return {
	        title: target.title,
	        value: {
	          title: { raw: target.title },
	          url: target.url,
	          attach: target.attach
	        }
	      };
	    };
	    var toMenuItems = function (targets) {
	      return global$2.map(targets, toMenuItem);
	    };
	    var staticMenuItem = function (title, url) {
	      return {
	        title: title,
	        value: {
	          title: title,
	          url: url,
	          attach: noop
	        }
	      };
	    };
	    var isUniqueUrl = function (url, targets) {
	      var foundTarget = exists(targets, function (target) {
	        return target.url === url;
	      });
	      return !foundTarget;
	    };
	    var getSetting = function (editorSettings, name, defaultValue) {
	      var value = name in editorSettings ? editorSettings[name] : defaultValue;
	      return value === false ? null : value;
	    };
	    var createMenuItems = function (term, targets, fileType, editorSettings) {
	      var separator = { title: '-' };
	      var fromHistoryMenuItems = function (history) {
	        var historyItems = history.hasOwnProperty(fileType) ? history[fileType] : [];
	        var uniqueHistory = filter(historyItems, function (url) {
	          return isUniqueUrl(url, targets);
	        });
	        return global$2.map(uniqueHistory, function (url) {
	          return {
	            title: url,
	            value: {
	              title: url,
	              url: url,
	              attach: noop
	            }
	          };
	        });
	      };
	      var fromMenuItems = function (type) {
	        var filteredTargets = filter(targets, function (target) {
	          return target.type === type;
	        });
	        return toMenuItems(filteredTargets);
	      };
	      var anchorMenuItems = function () {
	        var anchorMenuItems = fromMenuItems('anchor');
	        var topAnchor = getSetting(editorSettings, 'anchor_top', '#top');
	        var bottomAchor = getSetting(editorSettings, 'anchor_bottom', '#bottom');
	        if (topAnchor !== null) {
	          anchorMenuItems.unshift(staticMenuItem('<top>', topAnchor));
	        }
	        if (bottomAchor !== null) {
	          anchorMenuItems.push(staticMenuItem('<bottom>', bottomAchor));
	        }
	        return anchorMenuItems;
	      };
	      var join = function (items) {
	        return foldl(items, function (a, b) {
	          var bothEmpty = a.length === 0 || b.length === 0;
	          return bothEmpty ? a.concat(b) : a.concat(separator, b);
	        }, []);
	      };
	      if (editorSettings.typeahead_urls === false) {
	        return [];
	      }
	      return fileType === 'file' ? join([
	        filterByQuery(term, fromHistoryMenuItems(history)),
	        filterByQuery(term, fromMenuItems('header')),
	        filterByQuery(term, anchorMenuItems())
	      ]) : filterByQuery(term, fromHistoryMenuItems(history));
	    };
	    var addToHistory = function (url, fileType) {
	      var items = history[fileType];
	      if (!/^https?/.test(url)) {
	        return;
	      }
	      if (items) {
	        if (indexOf(items, url).isNone()) {
	          history[fileType] = items.slice(0, HISTORY_LENGTH).concat(url);
	        }
	      } else {
	        history[fileType] = [url];
	      }
	    };
	    var filterByQuery = function (term, menuItems) {
	      var lowerCaseTerm = term.toLowerCase();
	      var result = global$2.grep(menuItems, function (item) {
	        return item.title.toLowerCase().indexOf(lowerCaseTerm) !== -1;
	      });
	      return result.length === 1 && result[0].title === term ? [] : result;
	    };
	    var getTitle = function (linkDetails) {
	      var title = linkDetails.title;
	      return title.raw ? title.raw : title;
	    };
	    var setupAutoCompleteHandler = function (ctrl, editorSettings, bodyElm, fileType) {
	      var autocomplete = function (term) {
	        var linkTargets = LinkTargets.find(bodyElm);
	        var menuItems = createMenuItems(term, linkTargets, fileType, editorSettings);
	        ctrl.showAutoComplete(menuItems, term);
	      };
	      ctrl.on('autocomplete', function () {
	        autocomplete(ctrl.value());
	      });
	      ctrl.on('selectitem', function (e) {
	        var linkDetails = e.value;
	        ctrl.value(linkDetails.url);
	        var title = getTitle(linkDetails);
	        if (fileType === 'image') {
	          ctrl.fire('change', {
	            meta: {
	              alt: title,
	              attach: linkDetails.attach
	            }
	          });
	        } else {
	          ctrl.fire('change', {
	            meta: {
	              text: title,
	              attach: linkDetails.attach
	            }
	          });
	        }
	        ctrl.focus();
	      });
	      ctrl.on('click', function (e) {
	        if (ctrl.value().length === 0 && e.target.nodeName === 'INPUT') {
	          autocomplete('');
	        }
	      });
	      ctrl.on('PostRender', function () {
	        ctrl.getRoot().on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            addToHistory(ctrl.value(), fileType);
	          }
	        });
	      });
	    };
	    var statusToUiState = function (result) {
	      var status = result.status, message = result.message;
	      if (status === 'valid') {
	        return {
	          status: 'ok',
	          message: message
	        };
	      } else if (status === 'unknown') {
	        return {
	          status: 'warn',
	          message: message
	        };
	      } else if (status === 'invalid') {
	        return {
	          status: 'warn',
	          message: message
	        };
	      } else {
	        return {
	          status: 'none',
	          message: ''
	        };
	      }
	    };
	    var setupLinkValidatorHandler = function (ctrl, editorSettings, fileType) {
	      var validatorHandler = editorSettings.filepicker_validator_handler;
	      if (validatorHandler) {
	        var validateUrl_1 = function (url) {
	          if (url.length === 0) {
	            ctrl.statusLevel('none');
	            return;
	          }
	          validatorHandler({
	            url: url,
	            type: fileType
	          }, function (result) {
	            var uiState = statusToUiState(result);
	            ctrl.statusMessage(uiState.message);
	            ctrl.statusLevel(uiState.status);
	          });
	        };
	        ctrl.state.on('change:value', function (e) {
	          validateUrl_1(e.value);
	        });
	      }
	    };
	    var FilePicker = ComboBox.extend({
	      Statics: { clearHistory: clearHistory },
	      init: function (settings) {
	        var self = this, editor = getActiveEditor(), editorSettings = editor.settings;
	        var actionCallback, fileBrowserCallback, fileBrowserCallbackTypes;
	        var fileType = settings.filetype;
	        settings.spellcheck = false;
	        fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
	        if (fileBrowserCallbackTypes) {
	          fileBrowserCallbackTypes = global$2.makeMap(fileBrowserCallbackTypes, /[, ]/);
	        }
	        if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType]) {
	          fileBrowserCallback = editorSettings.file_picker_callback;
	          if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	            actionCallback = function () {
	              var meta = self.fire('beforecall').meta;
	              meta = global$2.extend({ filetype: fileType }, meta);
	              fileBrowserCallback.call(editor, function (value, meta) {
	                self.value(value).fire('change', { meta: meta });
	              }, self.value(), meta);
	            };
	          } else {
	            fileBrowserCallback = editorSettings.file_browser_callback;
	            if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	              actionCallback = function () {
	                fileBrowserCallback(self.getEl('inp').id, self.value(), fileType, window);
	              };
	            }
	          }
	        }
	        if (actionCallback) {
	          settings.icon = 'browse';
	          settings.onaction = actionCallback;
	        }
	        self._super(settings);
	        self.classes.add('filepicker');
	        setupAutoCompleteHandler(self, editorSettings, editor.getBody(), fileType);
	        setupLinkValidatorHandler(self, editorSettings, fileType);
	      }
	    });
	
	    var FitLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var contLayoutRect = container.layoutRect(), paddingBox = container.paddingBox;
	        container.items().filter(':visible').each(function (ctrl) {
	          ctrl.layoutRect({
	            x: paddingBox.left,
	            y: paddingBox.top,
	            w: contLayoutRect.innerW - paddingBox.right - paddingBox.left,
	            h: contLayoutRect.innerH - paddingBox.top - paddingBox.bottom
	          });
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      }
	    });
	
	    var FlexLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
	        var ctrl, ctrlLayoutRect, ctrlSettings, flex;
	        var maxSizeItems = [];
	        var size, maxSize, ratio, rect, pos, maxAlignEndPos;
	        var sizeName, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
	        var alignAxisName, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
	        var alignDeltaSizeName, alignContentSizeName;
	        var max = Math.max, min = Math.min;
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        contPaddingBox = container.paddingBox;
	        contSettings = container.settings;
	        direction = container.isRtl() ? contSettings.direction || 'row-reversed' : contSettings.direction;
	        align = contSettings.align;
	        pack = container.isRtl() ? contSettings.pack || 'end' : contSettings.pack;
	        spacing = contSettings.spacing || 0;
	        if (direction === 'row-reversed' || direction === 'column-reverse') {
	          items = items.set(items.toArray().reverse());
	          direction = direction.split('-')[0];
	        }
	        if (direction === 'column') {
	          posName = 'y';
	          sizeName = 'h';
	          minSizeName = 'minH';
	          maxSizeName = 'maxH';
	          innerSizeName = 'innerH';
	          beforeName = 'top';
	          deltaSizeName = 'deltaH';
	          contentSizeName = 'contentH';
	          alignBeforeName = 'left';
	          alignSizeName = 'w';
	          alignAxisName = 'x';
	          alignInnerSizeName = 'innerW';
	          alignMinSizeName = 'minW';
	          alignAfterName = 'right';
	          alignDeltaSizeName = 'deltaW';
	          alignContentSizeName = 'contentW';
	        } else {
	          posName = 'x';
	          sizeName = 'w';
	          minSizeName = 'minW';
	          maxSizeName = 'maxW';
	          innerSizeName = 'innerW';
	          beforeName = 'left';
	          deltaSizeName = 'deltaW';
	          contentSizeName = 'contentW';
	          alignBeforeName = 'top';
	          alignSizeName = 'h';
	          alignAxisName = 'y';
	          alignInnerSizeName = 'innerH';
	          alignMinSizeName = 'minH';
	          alignAfterName = 'bottom';
	          alignDeltaSizeName = 'deltaH';
	          alignContentSizeName = 'contentH';
	        }
	        availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
	        maxAlignEndPos = totalFlex = 0;
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          ctrlSettings = ctrl.settings;
	          flex = ctrlSettings.flex;
	          availableSpace -= i < l - 1 ? spacing : 0;
	          if (flex > 0) {
	            totalFlex += flex;
	            if (ctrlLayoutRect[maxSizeName]) {
	              maxSizeItems.push(ctrl);
	            }
	            ctrlLayoutRect.flex = flex;
	          }
	          availableSpace -= ctrlLayoutRect[minSizeName];
	          size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
	          if (size > maxAlignEndPos) {
	            maxAlignEndPos = size;
	          }
	        }
	        rect = {};
	        if (availableSpace < 0) {
	          rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        } else {
	          rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        }
	        rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[alignDeltaSizeName];
	        rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
	        rect[alignContentSizeName] = maxAlignEndPos;
	        rect.minW = min(rect.minW, contLayoutRect.maxW);
	        rect.minH = min(rect.minH, contLayoutRect.maxH);
	        rect.minW = max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = max(rect.minH, contLayoutRect.startMinHeight);
	        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	          container.layoutRect(rect);
	          this.recalc(container);
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	          return;
	        }
	        ratio = availableSpace / totalFlex;
	        for (i = 0, l = maxSizeItems.length; i < l; i++) {
	          ctrl = maxSizeItems[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          maxSize = ctrlLayoutRect[maxSizeName];
	          size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
	          if (size > maxSize) {
	            availableSpace -= ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName];
	            totalFlex -= ctrlLayoutRect.flex;
	            ctrlLayoutRect.flex = 0;
	            ctrlLayoutRect.maxFlexSize = maxSize;
	          } else {
	            ctrlLayoutRect.maxFlexSize = 0;
	          }
	        }
	        ratio = availableSpace / totalFlex;
	        pos = contPaddingBox[beforeName];
	        rect = {};
	        if (totalFlex === 0) {
	          if (pack === 'end') {
	            pos = availableSpace + contPaddingBox[beforeName];
	          } else if (pack === 'center') {
	            pos = Math.round(contLayoutRect[innerSizeName] / 2 - (contLayoutRect[innerSizeName] - availableSpace) / 2) + contPaddingBox[beforeName];
	            if (pos < 0) {
	              pos = contPaddingBox[beforeName];
	            }
	          } else if (pack === 'justify') {
	            pos = contPaddingBox[beforeName];
	            spacing = Math.floor(availableSpace / (items.length - 1));
	          }
	        }
	        rect[alignAxisName] = contPaddingBox[alignBeforeName];
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
	          if (align === 'center') {
	            rect[alignAxisName] = Math.round(contLayoutRect[alignInnerSizeName] / 2 - ctrlLayoutRect[alignSizeName] / 2);
	          } else if (align === 'stretch') {
	            rect[alignSizeName] = max(ctrlLayoutRect[alignMinSizeName] || 0, contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]);
	            rect[alignAxisName] = contPaddingBox[alignBeforeName];
	          } else if (align === 'end') {
	            rect[alignAxisName] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top;
	          }
	          if (ctrlLayoutRect.flex > 0) {
	            size += ctrlLayoutRect.flex * ratio;
	          }
	          rect[sizeName] = size;
	          rect[posName] = pos;
	          ctrl.layoutRect(rect);
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	          pos += size + spacing;
	        }
	      }
	    });
	
	    var FlowLayout = Layout.extend({
	      Defaults: {
	        containerClass: 'flow-layout',
	        controlClass: 'flow-layout-item',
	        endClass: 'break'
	      },
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	      isNative: function () {
	        return true;
	      }
	    });
	
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	
	    var toggleFormat = function (editor, fmt) {
	      return function () {
	        editor.execCommand('mceToggleFormat', false, fmt);
	      };
	    };
	    var addFormatChangedListener = function (editor, name, changed) {
	      var handler = function (state) {
	        changed(state, name);
	      };
	      if (editor.formatter) {
	        editor.formatter.formatChanged(name, handler);
	      } else {
	        editor.on('init', function () {
	          editor.formatter.formatChanged(name, handler);
	        });
	      }
	    };
	    var postRenderFormatToggle = function (editor, name) {
	      return function (e) {
	        addFormatChangedListener(editor, name, function (state) {
	          e.control.active(state);
	        });
	      };
	    };
	
	    var register = function (editor) {
	      var alignFormats = [
	        'alignleft',
	        'aligncenter',
	        'alignright',
	        'alignjustify'
	      ];
	      var defaultAlign = 'alignleft';
	      var alignMenuItems = [
	        {
	          text: 'Left',
	          icon: 'alignleft',
	          onclick: toggleFormat(editor, 'alignleft')
	        },
	        {
	          text: 'Center',
	          icon: 'aligncenter',
	          onclick: toggleFormat(editor, 'aligncenter')
	        },
	        {
	          text: 'Right',
	          icon: 'alignright',
	          onclick: toggleFormat(editor, 'alignright')
	        },
	        {
	          text: 'Justify',
	          icon: 'alignjustify',
	          onclick: toggleFormat(editor, 'alignjustify')
	        }
	      ];
	      editor.addMenuItem('align', {
	        text: 'Align',
	        menu: alignMenuItems
	      });
	      editor.addButton('align', {
	        type: 'menubutton',
	        icon: defaultAlign,
	        menu: alignMenuItems,
	        onShowMenu: function (e) {
	          var menu = e.control.menu;
	          global$2.each(alignFormats, function (formatName, idx) {
	            menu.items().eq(idx).each(function (item) {
	              return item.active(editor.formatter.match(formatName));
	            });
	          });
	        },
	        onPostRender: function (e) {
	          var ctrl = e.control;
	          global$2.each(alignFormats, function (formatName, idx) {
	            addFormatChangedListener(editor, formatName, function (state) {
	              ctrl.icon(defaultAlign);
	              if (state) {
	                ctrl.icon(formatName);
	              }
	            });
	          });
	        }
	      });
	      global$2.each({
	        alignleft: [
	          'Align left',
	          'JustifyLeft'
	        ],
	        aligncenter: [
	          'Align center',
	          'JustifyCenter'
	        ],
	        alignright: [
	          'Align right',
	          'JustifyRight'
	        ],
	        alignjustify: [
	          'Justify',
	          'JustifyFull'
	        ],
	        alignnone: [
	          'No alignment',
	          'JustifyNone'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: postRenderFormatToggle(editor, name)
	        });
	      });
	    };
	    var Align = { register: register };
	
	    var getFirstFont = function (fontFamily) {
	      return fontFamily ? fontFamily.split(',')[0] : '';
	    };
	    var findMatchingValue = function (items, fontFamily) {
	      var font = fontFamily ? fontFamily.toLowerCase() : '';
	      var value;
	      global$2.each(items, function (item) {
	        if (item.value.toLowerCase() === font) {
	          value = item.value;
	        }
	      });
	      global$2.each(items, function (item) {
	        if (!value && getFirstFont(item.value).toLowerCase() === getFirstFont(font).toLowerCase()) {
	          value = item.value;
	        }
	      });
	      return value;
	    };
	    var createFontNameListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	        self.state.set('value', null);
	        editor.on('init nodeChange', function (e) {
	          var fontFamily = editor.queryCommandValue('FontName');
	          var match = findMatchingValue(items, fontFamily);
	          self.value(match ? match : null);
	          if (!match && fontFamily) {
	            self.text(getFirstFont(fontFamily));
	          }
	        });
	      };
	    };
	    var createFormats = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	      return formats;
	    };
	    var getFontItems = function (editor) {
	      var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
	      var fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
	      return global$2.map(fonts, function (font) {
	        return {
	          text: { raw: font[0] },
	          value: font[1],
	          textStyle: font[1].indexOf('dings') === -1 ? 'font-family:' + font[1] : ''
	        };
	      });
	    };
	    var registerButtons = function (editor) {
	      editor.addButton('fontselect', function () {
	        var items = getFontItems(editor);
	        return {
	          type: 'listbox',
	          text: 'Font Family',
	          tooltip: 'Font Family',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontNameListBoxChangeHandler(editor, items),
	          onselect: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontName', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	    var register$1 = function (editor) {
	      registerButtons(editor);
	    };
	    var FontSelect = { register: register$1 };
	
	    var round = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      }
	      return fontSize;
	    };
	    var findMatchingValue$1 = function (items, pt, px) {
	      var value;
	      global$2.each(items, function (item) {
	        if (item.value === px) {
	          value = px;
	        } else if (item.value === pt) {
	          value = pt;
	        }
	      });
	      return value;
	    };
	    var createFontSizeListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	        editor.on('init nodeChange', function (e) {
	          var px, pt, precision, match;
	          px = editor.queryCommandValue('FontSize');
	          if (px) {
	            for (precision = 3; !match && precision >= 0; precision--) {
	              pt = toPt(px, precision);
	              match = findMatchingValue$1(items, pt, px);
	            }
	          }
	          self.value(match ? match : null);
	          if (!match) {
	            self.text(pt);
	          }
	        });
	      };
	    };
	    var getFontSizeItems = function (editor) {
	      var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
	      var fontsizeFormats = editor.settings.fontsize_formats || defaultFontsizeFormats;
	      return global$2.map(fontsizeFormats.split(' '), function (item) {
	        var text = item, value = item;
	        var values = item.split('=');
	        if (values.length > 1) {
	          text = values[0];
	          value = values[1];
	        }
	        return {
	          text: text,
	          value: value
	        };
	      });
	    };
	    var registerButtons$1 = function (editor) {
	      editor.addButton('fontsizeselect', function () {
	        var items = getFontSizeItems(editor);
	        return {
	          type: 'listbox',
	          text: 'Font Sizes',
	          tooltip: 'Font Sizes',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontSizeListBoxChangeHandler(editor, items),
	          onclick: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontSize', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	    var register$2 = function (editor) {
	      registerButtons$1(editor);
	    };
	    var FontSizeSelect = { register: register$2 };
	
	    var hideMenuObjects = function (editor, menu) {
	      var count = menu.length;
	      global$2.each(menu, function (item) {
	        if (item.menu) {
	          item.hidden = hideMenuObjects(editor, item.menu) === 0;
	        }
	        var formatName = item.format;
	        if (formatName) {
	          item.hidden = !editor.formatter.canApply(formatName);
	        }
	        if (item.hidden) {
	          count--;
	        }
	      });
	      return count;
	    };
	    var hideFormatMenuItems = function (editor, menu) {
	      var count = menu.items().length;
	      menu.items().each(function (item) {
	        if (item.menu) {
	          item.visible(hideFormatMenuItems(editor, item.menu) > 0);
	        }
	        if (!item.menu && item.settings.menu) {
	          item.visible(hideMenuObjects(editor, item.settings.menu) > 0);
	        }
	        var formatName = item.settings.format;
	        if (formatName) {
	          item.visible(editor.formatter.canApply(formatName));
	        }
	        if (!item.visible()) {
	          count--;
	        }
	      });
	      return count;
	    };
	    var createFormatMenu = function (editor) {
	      var count = 0;
	      var newFormats = [];
	      var defaultStyleFormats = [
	        {
	          title: 'Headings',
	          items: [
	            {
	              title: 'Heading 1',
	              format: 'h1'
	            },
	            {
	              title: 'Heading 2',
	              format: 'h2'
	            },
	            {
	              title: 'Heading 3',
	              format: 'h3'
	            },
	            {
	              title: 'Heading 4',
	              format: 'h4'
	            },
	            {
	              title: 'Heading 5',
	              format: 'h5'
	            },
	            {
	              title: 'Heading 6',
	              format: 'h6'
	            }
	          ]
	        },
	        {
	          title: 'Inline',
	          items: [
	            {
	              title: 'Bold',
	              icon: 'bold',
	              format: 'bold'
	            },
	            {
	              title: 'Italic',
	              icon: 'italic',
	              format: 'italic'
	            },
	            {
	              title: 'Underline',
	              icon: 'underline',
	              format: 'underline'
	            },
	            {
	              title: 'Strikethrough',
	              icon: 'strikethrough',
	              format: 'strikethrough'
	            },
	            {
	              title: 'Superscript',
	              icon: 'superscript',
	              format: 'superscript'
	            },
	            {
	              title: 'Subscript',
	              icon: 'subscript',
	              format: 'subscript'
	            },
	            {
	              title: 'Code',
	              icon: 'code',
	              format: 'code'
	            }
	          ]
	        },
	        {
	          title: 'Blocks',
	          items: [
	            {
	              title: 'Paragraph',
	              format: 'p'
	            },
	            {
	              title: 'Blockquote',
	              format: 'blockquote'
	            },
	            {
	              title: 'Div',
	              format: 'div'
	            },
	            {
	              title: 'Pre',
	              format: 'pre'
	            }
	          ]
	        },
	        {
	          title: 'Alignment',
	          items: [
	            {
	              title: 'Left',
	              icon: 'alignleft',
	              format: 'alignleft'
	            },
	            {
	              title: 'Center',
	              icon: 'aligncenter',
	              format: 'aligncenter'
	            },
	            {
	              title: 'Right',
	              icon: 'alignright',
	              format: 'alignright'
	            },
	            {
	              title: 'Justify',
	              icon: 'alignjustify',
	              format: 'alignjustify'
	            }
	          ]
	        }
	      ];
	      var createMenu = function (formats) {
	        var menu = [];
	        if (!formats) {
	          return;
	        }
	        global$2.each(formats, function (format) {
	          var menuItem = {
	            text: format.title,
	            icon: format.icon
	          };
	          if (format.items) {
	            menuItem.menu = createMenu(format.items);
	          } else {
	            var formatName = format.format || 'custom' + count++;
	            if (!format.format) {
	              format.name = formatName;
	              newFormats.push(format);
	            }
	            menuItem.format = formatName;
	            menuItem.cmd = format.cmd;
	          }
	          menu.push(menuItem);
	        });
	        return menu;
	      };
	      var createStylesMenu = function () {
	        var menu;
	        if (editor.settings.style_formats_merge) {
	          if (editor.settings.style_formats) {
	            menu = createMenu(defaultStyleFormats.concat(editor.settings.style_formats));
	          } else {
	            menu = createMenu(defaultStyleFormats);
	          }
	        } else {
	          menu = createMenu(editor.settings.style_formats || defaultStyleFormats);
	        }
	        return menu;
	      };
	      editor.on('init', function () {
	        global$2.each(newFormats, function (format) {
	          editor.formatter.register(format.name, format);
	        });
	      });
	      return {
	        type: 'menu',
	        items: createStylesMenu(),
	        onPostRender: function (e) {
	          editor.fire('renderFormatsMenu', { control: e.control });
	        },
	        itemDefaults: {
	          preview: true,
	          textStyle: function () {
	            if (this.settings.format) {
	              return editor.formatter.getCssText(this.settings.format);
	            }
	          },
	          onPostRender: function () {
	            var self = this;
	            self.parent().on('show', function () {
	              var formatName, command;
	              formatName = self.settings.format;
	              if (formatName) {
	                self.disabled(!editor.formatter.canApply(formatName));
	                self.active(editor.formatter.match(formatName));
	              }
	              command = self.settings.cmd;
	              if (command) {
	                self.active(editor.queryCommandState(command));
	              }
	            });
	          },
	          onclick: function () {
	            if (this.settings.format) {
	              toggleFormat(editor, this.settings.format)();
	            }
	            if (this.settings.cmd) {
	              editor.execCommand(this.settings.cmd);
	            }
	          }
	        }
	      };
	    };
	    var registerMenuItems = function (editor, formatMenu) {
	      editor.addMenuItem('formats', {
	        text: 'Formats',
	        menu: formatMenu
	      });
	    };
	    var registerButtons$2 = function (editor, formatMenu) {
	      editor.addButton('styleselect', {
	        type: 'menubutton',
	        text: 'Formats',
	        menu: formatMenu,
	        onShowMenu: function () {
	          if (editor.settings.style_formats_autohide) {
	            hideFormatMenuItems(editor, this.menu);
	          }
	        }
	      });
	    };
	    var register$3 = function (editor) {
	      var formatMenu = createFormatMenu(editor);
	      registerMenuItems(editor, formatMenu);
	      registerButtons$2(editor, formatMenu);
	    };
	    var Formats = { register: register$3 };
	
	    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
	    var createFormats$1 = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	      return formats;
	    };
	    var createListBoxChangeHandler = function (editor, items, formatName) {
	      return function () {
	        var self = this;
	        editor.on('nodeChange', function (e) {
	          var formatter = editor.formatter;
	          var value = null;
	          global$2.each(e.parents, function (node) {
	            global$2.each(items, function (item) {
	              if (formatName) {
	                if (formatter.matchNode(node, formatName, { value: item.value })) {
	                  value = item.value;
	                }
	              } else {
	                if (formatter.matchNode(node, item.value)) {
	                  value = item.value;
	                }
	              }
	              if (value) {
	                return false;
	              }
	            });
	            if (value) {
	              return false;
	            }
	          });
	          self.value(value);
	        });
	      };
	    };
	    var lazyFormatSelectBoxItems = function (editor, blocks) {
	      return function () {
	        var items = [];
	        global$2.each(blocks, function (block) {
	          items.push({
	            text: block[0],
	            value: block[1],
	            textStyle: function () {
	              return editor.formatter.getCssText(block[1]);
	            }
	          });
	        });
	        return {
	          type: 'listbox',
	          text: blocks[0][0],
	          values: items,
	          fixedWidth: true,
	          onselect: function (e) {
	            if (e.control) {
	              var fmt = e.control.value();
	              toggleFormat(editor, fmt)();
	            }
	          },
	          onPostRender: createListBoxChangeHandler(editor, items)
	        };
	      };
	    };
	    var buildMenuItems = function (editor, blocks) {
	      return global$2.map(blocks, function (block) {
	        return {
	          text: block[0],
	          onclick: toggleFormat(editor, block[1]),
	          textStyle: function () {
	            return editor.formatter.getCssText(block[1]);
	          }
	        };
	      });
	    };
	    var register$4 = function (editor) {
	      var blocks = createFormats$1(editor.settings.block_formats || defaultBlocks);
	      editor.addMenuItem('blockformats', {
	        text: 'Blocks',
	        menu: buildMenuItems(editor, blocks)
	      });
	      editor.addButton('formatselect', lazyFormatSelectBoxItems(editor, blocks));
	    };
	    var FormatSelect = { register: register$4 };
	
	    var createCustomMenuItems = function (editor, names) {
	      var items, nameList;
	      if (typeof names === 'string') {
	        nameList = names.split(' ');
	      } else if (global$2.isArray(names)) {
	        return flatten(global$2.map(names, function (names) {
	          return createCustomMenuItems(editor, names);
	        }));
	      }
	      items = global$2.grep(nameList, function (name) {
	        return name === '|' || name in editor.menuItems;
	      });
	      return global$2.map(items, function (name) {
	        return name === '|' ? { text: '-' } : editor.menuItems[name];
	      });
	    };
	    var isSeparator$1 = function (menuItem) {
	      return menuItem && menuItem.text === '-';
	    };
	    var trimMenuItems = function (menuItems) {
	      var menuItems2 = filter(menuItems, function (menuItem, i) {
	        return !isSeparator$1(menuItem) || !isSeparator$1(menuItems[i - 1]);
	      });
	      return filter(menuItems2, function (menuItem, i) {
	        return !isSeparator$1(menuItem) || i > 0 && i < menuItems2.length - 1;
	      });
	    };
	    var createContextMenuItems = function (editor, context) {
	      var outputMenuItems = [{ text: '-' }];
	      var menuItems = global$2.grep(editor.menuItems, function (menuItem) {
	        return menuItem.context === context;
	      });
	      global$2.each(menuItems, function (menuItem) {
	        if (menuItem.separator === 'before') {
	          outputMenuItems.push({ text: '|' });
	        }
	        if (menuItem.prependToContext) {
	          outputMenuItems.unshift(menuItem);
	        } else {
	          outputMenuItems.push(menuItem);
	        }
	        if (menuItem.separator === 'after') {
	          outputMenuItems.push({ text: '|' });
	        }
	      });
	      return outputMenuItems;
	    };
	    var createInsertMenu = function (editor) {
	      var insertButtonItems = editor.settings.insert_button_items;
	      if (insertButtonItems) {
	        return trimMenuItems(createCustomMenuItems(editor, insertButtonItems));
	      } else {
	        return trimMenuItems(createContextMenuItems(editor, 'insert'));
	      }
	    };
	    var registerButtons$3 = function (editor) {
	      editor.addButton('insert', {
	        type: 'menubutton',
	        icon: 'insert',
	        menu: [],
	        oncreatemenu: function () {
	          this.menu.add(createInsertMenu(editor));
	          this.menu.renderNew();
	        }
	      });
	    };
	    var register$5 = function (editor) {
	      registerButtons$3(editor);
	    };
	    var InsertButton = { register: register$5 };
	
	    var registerFormatButtons = function (editor) {
	      global$2.each({
	        bold: 'Bold',
	        italic: 'Italic',
	        underline: 'Underline',
	        strikethrough: 'Strikethrough',
	        subscript: 'Subscript',
	        superscript: 'Superscript'
	      }, function (text, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: text,
	          onPostRender: postRenderFormatToggle(editor, name),
	          onclick: toggleFormat(editor, name)
	        });
	      });
	    };
	    var registerCommandButtons = function (editor) {
	      global$2.each({
	        outdent: [
	          'Decrease indent',
	          'Outdent'
	        ],
	        indent: [
	          'Increase indent',
	          'Indent'
	        ],
	        cut: [
	          'Cut',
	          'Cut'
	        ],
	        copy: [
	          'Copy',
	          'Copy'
	        ],
	        paste: [
	          'Paste',
	          'Paste'
	        ],
	        help: [
	          'Help',
	          'mceHelp'
	        ],
	        selectall: [
	          'Select all',
	          'SelectAll'
	        ],
	        visualaid: [
	          'Visual aids',
	          'mceToggleVisualAid'
	        ],
	        newdocument: [
	          'New document',
	          'mceNewDocument'
	        ],
	        removeformat: [
	          'Clear formatting',
	          'RemoveFormat'
	        ],
	        remove: [
	          'Remove',
	          'Delete'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          tooltip: item[0],
	          cmd: item[1]
	        });
	      });
	    };
	    var registerCommandToggleButtons = function (editor) {
	      global$2.each({
	        blockquote: [
	          'Blockquote',
	          'mceBlockQuote'
	        ],
	        subscript: [
	          'Subscript',
	          'Subscript'
	        ],
	        superscript: [
	          'Superscript',
	          'Superscript'
	        ]
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: postRenderFormatToggle(editor, name)
	        });
	      });
	    };
	    var registerButtons$4 = function (editor) {
	      registerFormatButtons(editor);
	      registerCommandButtons(editor);
	      registerCommandToggleButtons(editor);
	    };
	    var registerMenuItems$1 = function (editor) {
	      global$2.each({
	        bold: [
	          'Bold',
	          'Bold',
	          'Meta+B'
	        ],
	        italic: [
	          'Italic',
	          'Italic',
	          'Meta+I'
	        ],
	        underline: [
	          'Underline',
	          'Underline',
	          'Meta+U'
	        ],
	        strikethrough: [
	          'Strikethrough',
	          'Strikethrough'
	        ],
	        subscript: [
	          'Subscript',
	          'Subscript'
	        ],
	        superscript: [
	          'Superscript',
	          'Superscript'
	        ],
	        removeformat: [
	          'Clear formatting',
	          'RemoveFormat'
	        ],
	        newdocument: [
	          'New document',
	          'mceNewDocument'
	        ],
	        cut: [
	          'Cut',
	          'Cut',
	          'Meta+X'
	        ],
	        copy: [
	          'Copy',
	          'Copy',
	          'Meta+C'
	        ],
	        paste: [
	          'Paste',
	          'Paste',
	          'Meta+V'
	        ],
	        selectall: [
	          'Select all',
	          'SelectAll',
	          'Meta+A'
	        ]
	      }, function (item, name) {
	        editor.addMenuItem(name, {
	          text: item[0],
	          icon: name,
	          shortcut: item[2],
	          cmd: item[1]
	        });
	      });
	      editor.addMenuItem('codeformat', {
	        text: 'Code',
	        icon: 'code',
	        onclick: toggleFormat(editor, 'code')
	      });
	    };
	    var register$6 = function (editor) {
	      registerButtons$4(editor);
	      registerMenuItems$1(editor);
	    };
	    var SimpleControls = { register: register$6 };
	
	    var toggleUndoRedoState = function (editor, type) {
	      return function () {
	        var self = this;
	        var checkState = function () {
	          var typeFn = type === 'redo' ? 'hasRedo' : 'hasUndo';
	          return editor.undoManager ? editor.undoManager[typeFn]() : false;
	        };
	        self.disabled(!checkState());
	        editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function () {
	          self.disabled(editor.readonly || !checkState());
	        });
	      };
	    };
	    var registerMenuItems$2 = function (editor) {
	      editor.addMenuItem('undo', {
	        text: 'Undo',
	        icon: 'undo',
	        shortcut: 'Meta+Z',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	      editor.addMenuItem('redo', {
	        text: 'Redo',
	        icon: 'redo',
	        shortcut: 'Meta+Y',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	    var registerButtons$5 = function (editor) {
	      editor.addButton('undo', {
	        tooltip: 'Undo',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	      editor.addButton('redo', {
	        tooltip: 'Redo',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	    var register$7 = function (editor) {
	      registerMenuItems$2(editor);
	      registerButtons$5(editor);
	    };
	    var UndoRedo = { register: register$7 };
	
	    var toggleVisualAidState = function (editor) {
	      return function () {
	        var self = this;
	        editor.on('VisualAid', function (e) {
	          self.active(e.hasVisual);
	        });
	        self.active(editor.hasVisual);
	      };
	    };
	    var registerMenuItems$3 = function (editor) {
	      editor.addMenuItem('visualaid', {
	        text: 'Visual aids',
	        selectable: true,
	        onPostRender: toggleVisualAidState(editor),
	        cmd: 'mceToggleVisualAid'
	      });
	    };
	    var register$8 = function (editor) {
	      registerMenuItems$3(editor);
	    };
	    var VisualAid = { register: register$8 };
	
	    var setupEnvironment = function () {
	      Widget.tooltips = !global$8.iOS;
	      Control$1.translate = function (text) {
	        return global$1.translate(text);
	      };
	    };
	    var setupUiContainer = function (editor) {
	      if (editor.settings.ui_container) {
	        global$8.container = descendant(Element.fromDom(domGlobals.document.body), editor.settings.ui_container).fold(constant(null), function (elm) {
	          return elm.dom();
	        });
	      }
	    };
	    var setupRtlMode = function (editor) {
	      if (editor.rtl) {
	        Control$1.rtl = true;
	      }
	    };
	    var setupHideFloatPanels = function (editor) {
	      editor.on('mousedown progressstate', function () {
	        FloatPanel.hideAll();
	      });
	    };
	    var setup$1 = function (editor) {
	      setupRtlMode(editor);
	      setupHideFloatPanels(editor);
	      setupUiContainer(editor);
	      setupEnvironment();
	      FormatSelect.register(editor);
	      Align.register(editor);
	      SimpleControls.register(editor);
	      UndoRedo.register(editor);
	      FontSizeSelect.register(editor);
	      FontSelect.register(editor);
	      Formats.register(editor);
	      VisualAid.register(editor);
	      InsertButton.register(editor);
	    };
	    var FormatControls = { setup: setup$1 };
	
	    var GridLayout = AbsoluteLayout.extend({
	      recalc: function (container) {
	        var settings, rows, cols, items, contLayoutRect, width, height, rect, ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY;
	        var colWidths = [];
	        var rowHeights = [];
	        var ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
	        settings = container.settings;
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        cols = settings.columns || Math.ceil(Math.sqrt(items.length));
	        rows = Math.ceil(items.length / cols);
	        spacingH = settings.spacingH || settings.spacing || 0;
	        spacingV = settings.spacingV || settings.spacing || 0;
	        alignH = settings.alignH || settings.align;
	        alignV = settings.alignV || settings.align;
	        contPaddingBox = container.paddingBox;
	        reverseRows = 'reverseRows' in settings ? settings.reverseRows : container.isRtl();
	        if (alignH && typeof alignH === 'string') {
	          alignH = [alignH];
	        }
	        if (alignV && typeof alignV === 'string') {
	          alignV = [alignV];
	        }
	        for (x = 0; x < cols; x++) {
	          colWidths.push(0);
	        }
	        for (y = 0; y < rows; y++) {
	          rowHeights.push(0);
	        }
	        for (y = 0; y < rows; y++) {
	          for (x = 0; x < cols; x++) {
	            ctrl = items[y * cols + x];
	            if (!ctrl) {
	              break;
	            }
	            ctrlLayoutRect = ctrl.layoutRect();
	            ctrlMinWidth = ctrlLayoutRect.minW;
	            ctrlMinHeight = ctrlLayoutRect.minH;
	            colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
	            rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y];
	          }
	        }
	        availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
	        for (maxX = 0, x = 0; x < cols; x++) {
	          maxX += colWidths[x] + (x > 0 ? spacingH : 0);
	          availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x];
	        }
	        availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
	        for (maxY = 0, y = 0; y < rows; y++) {
	          maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
	          availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y];
	        }
	        maxX += contPaddingBox.left + contPaddingBox.right;
	        maxY += contPaddingBox.top + contPaddingBox.bottom;
	        rect = {};
	        rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
	        rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
	        rect.contentW = rect.minW - contLayoutRect.deltaW;
	        rect.contentH = rect.minH - contLayoutRect.deltaH;
	        rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
	        rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
	        rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
	        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	          container.layoutRect(rect);
	          this.recalc(container);
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	          return;
	        }
	        if (contLayoutRect.autoResize) {
	          rect = container.layoutRect(rect);
	          rect.contentW = rect.minW - contLayoutRect.deltaW;
	          rect.contentH = rect.minH - contLayoutRect.deltaH;
	        }
	        var flexV;
	        if (settings.packV === 'start') {
	          flexV = 0;
	        } else {
	          flexV = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0;
	        }
	        var totalFlex = 0;
	        var flexWidths = settings.flexWidths;
	        if (flexWidths) {
	          for (x = 0; x < flexWidths.length; x++) {
	            totalFlex += flexWidths[x];
	          }
	        } else {
	          totalFlex = cols;
	        }
	        var ratio = availableWidth / totalFlex;
	        for (x = 0; x < cols; x++) {
	          colWidths[x] += flexWidths ? flexWidths[x] * ratio : ratio;
	        }
	        posY = contPaddingBox.top;
	        for (y = 0; y < rows; y++) {
	          posX = contPaddingBox.left;
	          height = rowHeights[y] + flexV;
	          for (x = 0; x < cols; x++) {
	            if (reverseRows) {
	              idx = y * cols + cols - 1 - x;
	            } else {
	              idx = y * cols + x;
	            }
	            ctrl = items[idx];
	            if (!ctrl) {
	              break;
	            }
	            ctrlSettings = ctrl.settings;
	            ctrlLayoutRect = ctrl.layoutRect();
	            width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
	            ctrlLayoutRect.x = posX;
	            ctrlLayoutRect.y = posY;
	            align = ctrlSettings.alignH || (alignH ? alignH[x] || alignH[0] : null);
	            if (align === 'center') {
	              ctrlLayoutRect.x = posX + width / 2 - ctrlLayoutRect.w / 2;
	            } else if (align === 'right') {
	              ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w;
	            } else if (align === 'stretch') {
	              ctrlLayoutRect.w = width;
	            }
	            align = ctrlSettings.alignV || (alignV ? alignV[x] || alignV[0] : null);
	            if (align === 'center') {
	              ctrlLayoutRect.y = posY + height / 2 - ctrlLayoutRect.h / 2;
	            } else if (align === 'bottom') {
	              ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h;
	            } else if (align === 'stretch') {
	              ctrlLayoutRect.h = height;
	            }
	            ctrl.layoutRect(ctrlLayoutRect);
	            posX += width + spacingH;
	            if (ctrl.recalc) {
	              ctrl.recalc();
	            }
	          }
	          posY += height + spacingV;
	        }
	      }
	    });
	
	    var Iframe$1 = Widget.extend({
	      renderHtml: function () {
	        var self = this;
	        self.classes.add('iframe');
	        self.canFocus = false;
	        return '<iframe id="' + self._id + '" class="' + self.classes + '" tabindex="-1" src="' + (self.settings.url || 'javascript:\'\'') + '" frameborder="0"></iframe>';
	      },
	      src: function (src) {
	        this.getEl().src = src;
	      },
	      html: function (html, callback) {
	        var self = this, body = this.getEl().contentWindow.document.body;
	        if (!body) {
	          global$7.setTimeout(function () {
	            self.html(html);
	          });
	        } else {
	          body.innerHTML = html;
	          if (callback) {
	            callback();
	          }
	        }
	        return this;
	      }
	    });
	
	    var InfoBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('widget').add('infobox');
	        self.canFocus = false;
	      },
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	      help: function (state) {
	        this.state.set('help', state);
	      },
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + self.encode(self.state.get('text')) + '<button role="button" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' + '</button>' + '</div>' + '</div>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.getEl('body').firstChild.data = self.encode(e.value);
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        self.state.on('change:help', function (e) {
	          self.classes.toggle('has-help', e.value);
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var Label = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('widget').add('label');
	        self.canFocus = false;
	        if (settings.multiline) {
	          self.classes.add('autoscroll');
	        }
	        if (settings.strong) {
	          self.classes.add('strong');
	        }
	      },
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	        if (self.settings.multiline) {
	          var size = funcs.getSize(self.getEl());
	          if (size.width > layoutRect.maxW) {
	            layoutRect.minW = layoutRect.maxW;
	            self.classes.add('multiline');
	          }
	          self.getEl().style.width = layoutRect.minW + 'px';
	          layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, funcs.getSize(self.getEl()).height);
	        }
	        return layoutRect;
	      },
	      repaint: function () {
	        var self = this;
	        if (!self.settings.multiline) {
	          self.getEl().style.lineHeight = self.layoutRect().h + 'px';
	        }
	        return self._super();
	      },
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	      renderHtml: function () {
	        var self = this;
	        var targetCtrl, forName, forId = self.settings.forId;
	        var text = self.settings.html ? self.settings.html : self.encode(self.state.get('text'));
	        if (!forId && (forName = self.settings.forName)) {
	          targetCtrl = self.getRoot().find('#' + forName)[0];
	          if (targetCtrl) {
	            forId = targetCtrl._id;
	          }
	        }
	        if (forId) {
	          return '<label id="' + self._id + '" class="' + self.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' + text + '</label>';
	        }
	        return '<span id="' + self._id + '" class="' + self.classes + '">' + text + '</span>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:text', function (e) {
	          self.innerHtml(self.encode(e.value));
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var Toolbar$1 = Container.extend({
	      Defaults: {
	        role: 'toolbar',
	        layout: 'flow'
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('toolbar');
	      },
	      postRender: function () {
	        var self = this;
	        self.items().each(function (ctrl) {
	          ctrl.classes.add('toolbar-item');
	        });
	        return self._super();
	      }
	    });
	
	    var MenuBar = Toolbar$1.extend({
	      Defaults: {
	        role: 'menubar',
	        containerCls: 'menubar',
	        ariaRoot: true,
	        defaults: { type: 'menubutton' }
	      }
	    });
	
	    function isChildOf$1(node, parent) {
	      while (node) {
	        if (parent === node) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    }
	    var MenuButton = Button.extend({
	      init: function (settings) {
	        var self = this;
	        self._renderOpen = true;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('menubtn');
	        if (settings.fixedWidth) {
	          self.classes.add('fixed-width');
	        }
	        self.aria('haspopup', true);
	        self.state.set('menu', settings.menu || self.render());
	      },
	      showMenu: function (toggle) {
	        var self = this;
	        var menu;
	        if (self.menu && self.menu.visible() && toggle !== false) {
	          return self.hideMenu();
	        }
	        if (!self.menu) {
	          menu = self.state.get('menu') || [];
	          self.classes.add('opened');
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              animate: true,
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	            menu.animate = true;
	          }
	          if (!menu.renderTo) {
	            self.menu = global$4.create(menu).parent(self).renderTo();
	          } else {
	            self.menu = menu.parent(self).show().renderTo();
	          }
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control.parent() === self.menu) {
	              e.stopPropagation();
	              self.focus();
	              self.hideMenu();
	            }
	          });
	          self.menu.on('select', function () {
	            self.focus();
	          });
	          self.menu.on('show hide', function (e) {
	            if (e.type === 'hide' && e.control.parent() === self) {
	              self.classes.remove('opened-under');
	            }
	            if (e.control === self.menu) {
	              self.activeMenu(e.type === 'show');
	              self.classes.toggle('opened', e.type === 'show');
	            }
	            self.aria('expanded', e.type === 'show');
	          }).fire('show');
	        }
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.repaint();
	        self.menu.moveRel(self.getEl(), self.isRtl() ? [
	          'br-tr',
	          'tr-br'
	        ] : [
	          'bl-tl',
	          'tl-bl'
	        ]);
	        var menuLayoutRect = self.menu.layoutRect();
	        var selfBottom = self.$el.offset().top + self.layoutRect().h;
	        if (selfBottom > menuLayoutRect.y && selfBottom < menuLayoutRect.y + menuLayoutRect.h) {
	          self.classes.add('opened-under');
	        }
	        self.fire('showmenu');
	      },
	      hideMenu: function () {
	        var self = this;
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	          self.menu.hide();
	        }
	      },
	      activeMenu: function (state) {
	        this.classes.toggle('active', state);
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.settings.icon, image;
	        var text = self.state.get('text');
	        var textHtml = '';
	        image = self.settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        self.aria('role', self.parent() instanceof MenuBar ? 'menuitem' : 'button');
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1" aria-labelledby="' + id + '">' + '<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self.on('click', function (e) {
	          if (e.control === self && isChildOf$1(e.target, self.getEl())) {
	            self.focus();
	            self.showMenu(!e.aria);
	            if (e.aria) {
	              self.menu.items().filter(':visible')[0].focus();
	            }
	          }
	        });
	        self.on('mouseenter', function (e) {
	          var overCtrl = e.control;
	          var parent = self.parent();
	          var hasVisibleSiblingMenu;
	          if (overCtrl && parent && overCtrl instanceof MenuButton && overCtrl.parent() === parent) {
	            parent.items().filter('MenuButton').each(function (ctrl) {
	              if (ctrl.hideMenu && ctrl !== overCtrl) {
	                if (ctrl.menu && ctrl.menu.visible()) {
	                  hasVisibleSiblingMenu = true;
	                }
	                ctrl.hideMenu();
	              }
	            });
	            if (hasVisibleSiblingMenu) {
	              overCtrl.focus();
	              overCtrl.showMenu();
	            }
	          }
	        });
	        return self._super();
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:menu', function () {
	          if (self.menu) {
	            self.menu.remove();
	          }
	          self.menu = null;
	        });
	        return self._super();
	      },
	      remove: function () {
	        this._super();
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	
	    var Menu = FloatPanel.extend({
	      Defaults: {
	        defaultType: 'menuitem',
	        border: 1,
	        layout: 'stack',
	        role: 'application',
	        bodyRole: 'menu',
	        ariaRoot: true
	      },
	      init: function (settings) {
	        var self = this;
	        settings.autohide = true;
	        settings.constrainToViewport = true;
	        if (typeof settings.items === 'function') {
	          settings.itemsFactory = settings.items;
	          settings.items = [];
	        }
	        if (settings.itemDefaults) {
	          var items = settings.items;
	          var i = items.length;
	          while (i--) {
	            items[i] = global$2.extend({}, settings.itemDefaults, items[i]);
	          }
	        }
	        self._super(settings);
	        self.classes.add('menu');
	        if (settings.animate && global$8.ie !== 11) {
	          self.classes.add('animate');
	        }
	      },
	      repaint: function () {
	        this.classes.toggle('menu-align', true);
	        this._super();
	        this.getEl().style.height = '';
	        this.getEl('body').style.height = '';
	        return this;
	      },
	      cancel: function () {
	        var self = this;
	        self.hideAll();
	        self.fire('select');
	      },
	      load: function () {
	        var self = this;
	        var time, factory;
	        function hideThrobber() {
	          if (self.throbber) {
	            self.throbber.hide();
	            self.throbber = null;
	          }
	        }
	        factory = self.settings.itemsFactory;
	        if (!factory) {
	          return;
	        }
	        if (!self.throbber) {
	          self.throbber = new Throbber(self.getEl('body'), true);
	          if (self.items().length === 0) {
	            self.throbber.show();
	            self.fire('loading');
	          } else {
	            self.throbber.show(100, function () {
	              self.items().remove();
	              self.fire('loading');
	            });
	          }
	          self.on('hide close', hideThrobber);
	        }
	        self.requestTime = time = new Date().getTime();
	        self.settings.itemsFactory(function (items) {
	          if (items.length === 0) {
	            self.hide();
	            return;
	          }
	          if (self.requestTime !== time) {
	            return;
	          }
	          self.getEl().style.width = '';
	          self.getEl('body').style.width = '';
	          hideThrobber();
	          self.items().remove();
	          self.getEl('body').innerHTML = '';
	          self.add(items);
	          self.renderNew();
	          self.fire('loaded');
	        });
	      },
	      hideAll: function () {
	        var self = this;
	        this.find('menuitem').exec('hideMenu');
	        return self._super();
	      },
	      preRender: function () {
	        var self = this;
	        self.items().each(function (ctrl) {
	          var settings = ctrl.settings;
	          if (settings.icon || settings.image || settings.selectable) {
	            self._hasIcons = true;
	            return false;
	          }
	        });
	        if (self.settings.itemsFactory) {
	          self.on('postrender', function () {
	            if (self.settings.itemsFactory) {
	              self.load();
	            }
	          });
	        }
	        self.on('show hide', function (e) {
	          if (e.control === self) {
	            if (e.type === 'show') {
	              global$7.setTimeout(function () {
	                self.classes.add('in');
	              }, 0);
	            } else {
	              self.classes.remove('in');
	            }
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var ListBox = MenuButton.extend({
	      init: function (settings) {
	        var self = this;
	        var values, selected, selectedText, lastItemCtrl;
	        function setSelected(menuValues) {
	          for (var i = 0; i < menuValues.length; i++) {
	            selected = menuValues[i].selected || settings.value === menuValues[i].value;
	            if (selected) {
	              selectedText = selectedText || menuValues[i].text;
	              self.state.set('value', menuValues[i].value);
	              return true;
	            }
	            if (menuValues[i].menu) {
	              if (setSelected(menuValues[i].menu)) {
	                return true;
	              }
	            }
	          }
	        }
	        self._super(settings);
	        settings = self.settings;
	        self._values = values = settings.values;
	        if (values) {
	          if (typeof settings.value !== 'undefined') {
	            setSelected(values);
	          }
	          if (!selected && values.length > 0) {
	            selectedText = values[0].text;
	            self.state.set('value', values[0].value);
	          }
	          self.state.set('menu', values);
	        }
	        self.state.set('text', settings.text || selectedText);
	        self.classes.add('listbox');
	        self.on('select', function (e) {
	          var ctrl = e.control;
	          if (lastItemCtrl) {
	            e.lastControl = lastItemCtrl;
	          }
	          if (settings.multiple) {
	            ctrl.active(!ctrl.active());
	          } else {
	            self.value(e.control.value());
	          }
	          lastItemCtrl = ctrl;
	        });
	      },
	      value: function (value) {
	        if (arguments.length === 0) {
	          return this.state.get('value');
	        }
	        if (typeof value === 'undefined') {
	          return this;
	        }
	        function valueExists(values) {
	          return exists(values, function (a) {
	            return a.menu ? valueExists(a.menu) : a.value === value;
	          });
	        }
	        if (this.settings.values) {
	          if (valueExists(this.settings.values)) {
	            this.state.set('value', value);
	          } else if (value === null) {
	            this.state.set('value', null);
	          }
	        } else {
	          this.state.set('value', value);
	        }
	        return this;
	      },
	      bindStates: function () {
	        var self = this;
	        function activateMenuItemsByValue(menu, value) {
	          if (menu instanceof Menu) {
	            menu.items().each(function (ctrl) {
	              if (!ctrl.hasMenus()) {
	                ctrl.active(ctrl.value() === value);
	              }
	            });
	          }
	        }
	        function getSelectedItem(menuValues, value) {
	          var selectedItem;
	          if (!menuValues) {
	            return;
	          }
	          for (var i = 0; i < menuValues.length; i++) {
	            if (menuValues[i].value === value) {
	              return menuValues[i];
	            }
	            if (menuValues[i].menu) {
	              selectedItem = getSelectedItem(menuValues[i].menu, value);
	              if (selectedItem) {
	                return selectedItem;
	              }
	            }
	          }
	        }
	        self.on('show', function (e) {
	          activateMenuItemsByValue(e.control, self.value());
	        });
	        self.state.on('change:value', function (e) {
	          var selectedItem = getSelectedItem(self.state.get('menu'), e.value);
	          if (selectedItem) {
	            self.text(selectedItem.text);
	          } else {
	            self.text(self.settings.text);
	          }
	        });
	        return self._super();
	      }
	    });
	
	    var toggleTextStyle = function (ctrl, state) {
	      var textStyle = ctrl._textStyle;
	      if (textStyle) {
	        var textElm = ctrl.getEl('text');
	        textElm.setAttribute('style', textStyle);
	        if (state) {
	          textElm.style.color = '';
	          textElm.style.backgroundColor = '';
	        }
	      }
	    };
	    var MenuItem = Widget.extend({
	      Defaults: {
	        border: 0,
	        role: 'menuitem'
	      },
	      init: function (settings) {
	        var self = this;
	        var text;
	        self._super(settings);
	        settings = self.settings;
	        self.classes.add('menu-item');
	        if (settings.menu) {
	          self.classes.add('menu-item-expand');
	        }
	        if (settings.preview) {
	          self.classes.add('menu-item-preview');
	        }
	        text = self.state.get('text');
	        if (text === '-' || text === '|') {
	          self.classes.add('menu-item-sep');
	          self.aria('role', 'separator');
	          self.state.set('text', '-');
	        }
	        if (settings.selectable) {
	          self.aria('role', 'menuitemcheckbox');
	          self.classes.add('menu-item-checkbox');
	          settings.icon = 'selected';
	        }
	        if (!settings.preview && !settings.selectable) {
	          self.classes.add('menu-item-normal');
	        }
	        self.on('mousedown', function (e) {
	          e.preventDefault();
	        });
	        if (settings.menu && !settings.ariaHideMenu) {
	          self.aria('haspopup', true);
	        }
	      },
	      hasMenus: function () {
	        return !!this.settings.menu;
	      },
	      showMenu: function () {
	        var self = this;
	        var settings = self.settings;
	        var menu;
	        var parent = self.parent();
	        parent.items().each(function (ctrl) {
	          if (ctrl !== self) {
	            ctrl.hideMenu();
	          }
	        });
	        if (settings.menu) {
	          menu = self.menu;
	          if (!menu) {
	            menu = settings.menu;
	            if (menu.length) {
	              menu = {
	                type: 'menu',
	                items: menu
	              };
	            } else {
	              menu.type = menu.type || 'menu';
	            }
	            if (parent.settings.itemDefaults) {
	              menu.itemDefaults = parent.settings.itemDefaults;
	            }
	            menu = self.menu = global$4.create(menu).parent(self).renderTo();
	            menu.reflow();
	            menu.on('cancel', function (e) {
	              e.stopPropagation();
	              self.focus();
	              menu.hide();
	            });
	            menu.on('show hide', function (e) {
	              if (e.control.items) {
	                e.control.items().each(function (ctrl) {
	                  ctrl.active(ctrl.settings.selected);
	                });
	              }
	            }).fire('show');
	            menu.on('hide', function (e) {
	              if (e.control === menu) {
	                self.classes.remove('selected');
	              }
	            });
	            menu.submenu = true;
	          } else {
	            menu.show();
	          }
	          menu._parentMenu = parent;
	          menu.classes.add('menu-sub');
	          var rel = menu.testMoveRel(self.getEl(), self.isRtl() ? [
	            'tl-tr',
	            'bl-br',
	            'tr-tl',
	            'br-bl'
	          ] : [
	            'tr-tl',
	            'br-bl',
	            'tl-tr',
	            'bl-br'
	          ]);
	          menu.moveRel(self.getEl(), rel);
	          menu.rel = rel;
	          rel = 'menu-sub-' + rel;
	          menu.classes.remove(menu._lastRel).add(rel);
	          menu._lastRel = rel;
	          self.classes.add('selected');
	          self.aria('expanded', true);
	        }
	      },
	      hideMenu: function () {
	        var self = this;
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	          self.menu.hide();
	          self.aria('expanded', false);
	        }
	        return self;
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var settings = self.settings;
	        var prefix = self.classPrefix;
	        var text = self.state.get('text');
	        var icon = self.settings.icon, image = '', shortcut = settings.shortcut;
	        var url = self.encode(settings.url), iconHtml = '';
	        function convertShortcut(shortcut) {
	          var i, value, replace = {};
	          if (global$8.mac) {
	            replace = {
	              alt: '&#x2325;',
	              ctrl: '&#x2318;',
	              shift: '&#x21E7;',
	              meta: '&#x2318;'
	            };
	          } else {
	            replace = { meta: 'Ctrl' };
	          }
	          shortcut = shortcut.split('+');
	          for (i = 0; i < shortcut.length; i++) {
	            value = replace[shortcut[i].toLowerCase()];
	            if (value) {
	              shortcut[i] = value;
	            }
	          }
	          return shortcut.join('+');
	        }
	        function escapeRegExp(str) {
	          return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        }
	        function markMatches(text) {
	          var match = settings.match || '';
	          return match ? text.replace(new RegExp(escapeRegExp(match), 'gi'), function (match) {
	            return '!mce~match[' + match + ']mce~match!';
	          }) : text;
	        }
	        function boldMatches(text) {
	          return text.replace(new RegExp(escapeRegExp('!mce~match['), 'g'), '<b>').replace(new RegExp(escapeRegExp(']mce~match!'), 'g'), '</b>');
	        }
	        if (icon) {
	          self.parent().classes.add('menu-has-icons');
	        }
	        if (settings.image) {
	          image = ' style="background-image: url(\'' + settings.image + '\')"';
	        }
	        if (shortcut) {
	          shortcut = convertShortcut(shortcut);
	        }
	        icon = prefix + 'ico ' + prefix + 'i-' + (self.settings.icon || 'none');
	        iconHtml = text !== '-' ? '<i class="' + icon + '"' + image + '></i>\xA0' : '';
	        text = boldMatches(self.encode(markMatches(text)));
	        url = boldMatches(self.encode(markMatches(url)));
	        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1">' + iconHtml + (text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') + (shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') + (settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') + (url ? '<div class="' + prefix + 'menu-item-link">' + url + '</div>' : '') + '</div>';
	      },
	      postRender: function () {
	        var self = this, settings = self.settings;
	        var textStyle = settings.textStyle;
	        if (typeof textStyle === 'function') {
	          textStyle = textStyle.call(this);
	        }
	        if (textStyle) {
	          var textElm = self.getEl('text');
	          if (textElm) {
	            textElm.setAttribute('style', textStyle);
	            self._textStyle = textStyle;
	          }
	        }
	        self.on('mouseenter click', function (e) {
	          if (e.control === self) {
	            if (!settings.menu && e.type === 'click') {
	              self.fire('select');
	              global$7.requestAnimationFrame(function () {
	                self.parent().hideAll();
	              });
	            } else {
	              self.showMenu();
	              if (e.aria) {
	                self.menu.focus(true);
	              }
	            }
	          }
	        });
	        self._super();
	        return self;
	      },
	      hover: function () {
	        var self = this;
	        self.parent().items().each(function (ctrl) {
	          ctrl.classes.remove('selected');
	        });
	        self.classes.toggle('selected', true);
	        return self;
	      },
	      active: function (state) {
	        toggleTextStyle(this, state);
	        if (typeof state !== 'undefined') {
	          this.aria('checked', state);
	        }
	        return this._super(state);
	      },
	      remove: function () {
	        this._super();
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	
	    var Radio = Checkbox.extend({
	      Defaults: {
	        classes: 'radio',
	        role: 'radio'
	      }
	    });
	
	    var ResizeHandle = Widget.extend({
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	        self.classes.add('resizehandle');
	        if (self.settings.direction === 'both') {
	          self.classes.add('resizehandle-both');
	        }
	        self.canFocus = false;
	        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.resizeDragHelper = new DragHelper(this._id, {
	          start: function () {
	            self.fire('ResizeStart');
	          },
	          drag: function (e) {
	            if (self.settings.direction !== 'both') {
	              e.deltaX = 0;
	            }
	            self.fire('Resize', e);
	          },
	          stop: function () {
	            self.fire('ResizeEnd');
	          }
	        });
	      },
	      remove: function () {
	        if (this.resizeDragHelper) {
	          this.resizeDragHelper.destroy();
	        }
	        return this._super();
	      }
	    });
	
	    function createOptions(options) {
	      var strOptions = '';
	      if (options) {
	        for (var i = 0; i < options.length; i++) {
	          strOptions += '<option value="' + options[i] + '">' + options[i] + '</option>';
	        }
	      }
	      return strOptions;
	    }
	    var SelectBox = Widget.extend({
	      Defaults: {
	        classes: 'selectbox',
	        role: 'selectbox',
	        options: []
	      },
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        if (self.settings.size) {
	          self.size = self.settings.size;
	        }
	        if (self.settings.options) {
	          self._options = self.settings.options;
	        }
	        self.on('keydown', function (e) {
	          var rootControl;
	          if (e.keyCode === 13) {
	            e.preventDefault();
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	      },
	      options: function (state) {
	        if (!arguments.length) {
	          return this.state.get('options');
	        }
	        this.state.set('options', state);
	        return this;
	      },
	      renderHtml: function () {
	        var self = this;
	        var options, size = '';
	        options = createOptions(self._options);
	        if (self.size) {
	          size = ' size = "' + self.size + '"';
	        }
	        return '<select id="' + self._id + '" class="' + self.classes + '"' + size + '>' + options + '</select>';
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:options', function (e) {
	          self.getEl().innerHTML = createOptions(e.value);
	        });
	        return self._super();
	      }
	    });
	
	    function constrain(value, minVal, maxVal) {
	      if (value < minVal) {
	        value = minVal;
	      }
	      if (value > maxVal) {
	        value = maxVal;
	      }
	      return value;
	    }
	    function setAriaProp(el, name, value) {
	      el.setAttribute('aria-' + name, value);
	    }
	    function updateSliderHandle(ctrl, value) {
	      var maxHandlePos, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
	      if (ctrl.settings.orientation === 'v') {
	        stylePosName = 'top';
	        sizeName = 'height';
	        shortSizeName = 'h';
	      } else {
	        stylePosName = 'left';
	        sizeName = 'width';
	        shortSizeName = 'w';
	      }
	      handleEl = ctrl.getEl('handle');
	      maxHandlePos = (ctrl.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
	      styleValue = maxHandlePos * ((value - ctrl._minValue) / (ctrl._maxValue - ctrl._minValue)) + 'px';
	      handleEl.style[stylePosName] = styleValue;
	      handleEl.style.height = ctrl.layoutRect().h + 'px';
	      setAriaProp(handleEl, 'valuenow', value);
	      setAriaProp(handleEl, 'valuetext', '' + ctrl.settings.previewFilter(value));
	      setAriaProp(handleEl, 'valuemin', ctrl._minValue);
	      setAriaProp(handleEl, 'valuemax', ctrl._maxValue);
	    }
	    var Slider = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        if (!settings.previewFilter) {
	          settings.previewFilter = function (value) {
	            return Math.round(value * 100) / 100;
	          };
	        }
	        self._super(settings);
	        self.classes.add('slider');
	        if (settings.orientation === 'v') {
	          self.classes.add('vertical');
	        }
	        self._minValue = isNumber(settings.minValue) ? settings.minValue : 0;
	        self._maxValue = isNumber(settings.maxValue) ? settings.maxValue : 100;
	        self._initValue = self.state.get('value');
	      },
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' + '</div>';
	      },
	      reset: function () {
	        this.value(this._initValue).repaint();
	      },
	      postRender: function () {
	        var self = this;
	        var minValue, maxValue, screenCordName, stylePosName, sizeName, shortSizeName;
	        function toFraction(min, max, val) {
	          return (val + min) / (max - min);
	        }
	        function fromFraction(min, max, val) {
	          return val * (max - min) - min;
	        }
	        function handleKeyboard(minValue, maxValue) {
	          function alter(delta) {
	            var value;
	            value = self.value();
	            value = fromFraction(minValue, maxValue, toFraction(minValue, maxValue, value) + delta * 0.05);
	            value = constrain(value, minValue, maxValue);
	            self.value(value);
	            self.fire('dragstart', { value: value });
	            self.fire('drag', { value: value });
	            self.fire('dragend', { value: value });
	          }
	          self.on('keydown', function (e) {
	            switch (e.keyCode) {
	            case 37:
	            case 38:
	              alter(-1);
	              break;
	            case 39:
	            case 40:
	              alter(1);
	              break;
	            }
	          });
	        }
	        function handleDrag(minValue, maxValue, handleEl) {
	          var startPos, startHandlePos, maxHandlePos, handlePos, value;
	          self._dragHelper = new DragHelper(self._id, {
	            handle: self._id + '-handle',
	            start: function (e) {
	              startPos = e[screenCordName];
	              startHandlePos = parseInt(self.getEl('handle').style[stylePosName], 10);
	              maxHandlePos = (self.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
	              self.fire('dragstart', { value: value });
	            },
	            drag: function (e) {
	              var delta = e[screenCordName] - startPos;
	              handlePos = constrain(startHandlePos + delta, 0, maxHandlePos);
	              handleEl.style[stylePosName] = handlePos + 'px';
	              value = minValue + handlePos / maxHandlePos * (maxValue - minValue);
	              self.value(value);
	              self.tooltip().text('' + self.settings.previewFilter(value)).show().moveRel(handleEl, 'bc tc');
	              self.fire('drag', { value: value });
	            },
	            stop: function () {
	              self.tooltip().hide();
	              self.fire('dragend', { value: value });
	            }
	          });
	        }
	        minValue = self._minValue;
	        maxValue = self._maxValue;
	        if (self.settings.orientation === 'v') {
	          screenCordName = 'screenY';
	          stylePosName = 'top';
	          sizeName = 'height';
	          shortSizeName = 'h';
	        } else {
	          screenCordName = 'screenX';
	          stylePosName = 'left';
	          sizeName = 'width';
	          shortSizeName = 'w';
	        }
	        self._super();
	        handleKeyboard(minValue, maxValue);
	        handleDrag(minValue, maxValue, self.getEl('handle'));
	      },
	      repaint: function () {
	        this._super();
	        updateSliderHandle(this, this.value());
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          updateSliderHandle(self, e.value);
	        });
	        return self._super();
	      }
	    });
	
	    var Spacer = Widget.extend({
	      renderHtml: function () {
	        var self = this;
	        self.classes.add('spacer');
	        self.canFocus = false;
	        return '<div id="' + self._id + '" class="' + self.classes + '"></div>';
	      }
	    });
	
	    var SplitButton = MenuButton.extend({
	      Defaults: {
	        classes: 'widget btn splitbtn',
	        role: 'button'
	      },
	      repaint: function () {
	        var self = this;
	        var elm = self.getEl();
	        var rect = self.layoutRect();
	        var mainButtonElm, menuButtonElm;
	        self._super();
	        mainButtonElm = elm.firstChild;
	        menuButtonElm = elm.lastChild;
	        global$9(mainButtonElm).css({
	          width: rect.w - funcs.getSize(menuButtonElm).width,
	          height: rect.h - 2
	        });
	        global$9(menuButtonElm).css({ height: rect.h - 2 });
	        return self;
	      },
	      activeMenu: function (state) {
	        var self = this;
	        global$9(self.getEl().lastChild).toggleClass(self.classPrefix + 'active', state);
	      },
	      renderHtml: function () {
	        var self = this;
	        var id = self._id;
	        var prefix = self.classPrefix;
	        var image;
	        var icon = self.state.get('icon');
	        var text = self.state.get('text');
	        var settings = self.settings;
	        var textHtml = '', ariaPressed;
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	          if (typeof image !== 'string') {
	            image = domGlobals.window.getSelection ? image[0] : image[1];
	          }
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	        icon = settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	        return '<div id="' + id + '" class="' + self.classes + '" role="button"' + ariaPressed + ' tabindex="-1">' + '<button type="button" hidefocus="1" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + (self._menuBtnText ? (icon ? '\xA0' : '') + self._menuBtnText : '') + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
	      },
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	        self.on('click', function (e) {
	          var node = e.target;
	          if (e.control === this) {
	            while (node) {
	              if (e.aria && e.aria.key !== 'down' || node.nodeName === 'BUTTON' && node.className.indexOf('open') === -1) {
	                e.stopImmediatePropagation();
	                if (onClickHandler) {
	                  onClickHandler.call(this, e);
	                }
	                return;
	              }
	              node = node.parentNode;
	            }
	          }
	        });
	        delete self.settings.onclick;
	        return self._super();
	      }
	    });
	
	    var StackLayout = FlowLayout.extend({
	      Defaults: {
	        containerClass: 'stack-layout',
	        controlClass: 'stack-layout-item',
	        endClass: 'break'
	      },
	      isNative: function () {
	        return true;
	      }
	    });
	
	    var TabPanel = Panel.extend({
	      Defaults: {
	        layout: 'absolute',
	        defaults: { type: 'panel' }
	      },
	      activateTab: function (idx) {
	        var activeTabElm;
	        if (this.activeTabId) {
	          activeTabElm = this.getEl(this.activeTabId);
	          global$9(activeTabElm).removeClass(this.classPrefix + 'active');
	          activeTabElm.setAttribute('aria-selected', 'false');
	        }
	        this.activeTabId = 't' + idx;
	        activeTabElm = this.getEl('t' + idx);
	        activeTabElm.setAttribute('aria-selected', 'true');
	        global$9(activeTabElm).addClass(this.classPrefix + 'active');
	        this.items()[idx].show().fire('showtab');
	        this.reflow();
	        this.items().each(function (item, i) {
	          if (idx !== i) {
	            item.hide();
	          }
	        });
	      },
	      renderHtml: function () {
	        var self = this;
	        var layout = self._layout;
	        var tabsHtml = '';
	        var prefix = self.classPrefix;
	        self.preRender();
	        layout.preRender(self);
	        self.items().each(function (ctrl, i) {
	          var id = self._id + '-t' + i;
	          ctrl.aria('role', 'tabpanel');
	          ctrl.aria('labelledby', id);
	          tabsHtml += '<div id="' + id + '" class="' + prefix + 'tab" ' + 'unselectable="on" role="tab" aria-controls="' + ctrl._id + '" aria-selected="false" tabIndex="-1">' + self.encode(ctrl.settings.title) + '</div>';
	        });
	        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + '<div id="' + self._id + '-head" class="' + prefix + 'tabs" role="tablist">' + tabsHtml + '</div>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>' + '</div>';
	      },
	      postRender: function () {
	        var self = this;
	        self._super();
	        self.settings.activeTab = self.settings.activeTab || 0;
	        self.activateTab(self.settings.activeTab);
	        this.on('click', function (e) {
	          var targetParent = e.target.parentNode;
	          if (targetParent && targetParent.id === self._id + '-head') {
	            var i = targetParent.childNodes.length;
	            while (i--) {
	              if (targetParent.childNodes[i] === e.target) {
	                self.activateTab(i);
	              }
	            }
	          }
	        });
	      },
	      initLayoutRect: function () {
	        var self = this;
	        var rect, minW, minH;
	        minW = funcs.getSize(self.getEl('head')).width;
	        minW = minW < 0 ? 0 : minW;
	        minH = 0;
	        self.items().each(function (item) {
	          minW = Math.max(minW, item.layoutRect().minW);
	          minH = Math.max(minH, item.layoutRect().minH);
	        });
	        self.items().each(function (ctrl) {
	          ctrl.settings.x = 0;
	          ctrl.settings.y = 0;
	          ctrl.settings.w = minW;
	          ctrl.settings.h = minH;
	          ctrl.layoutRect({
	            x: 0,
	            y: 0,
	            w: minW,
	            h: minH
	          });
	        });
	        var headH = funcs.getSize(self.getEl('head')).height;
	        self.settings.minWidth = minW;
	        self.settings.minHeight = minH + headH;
	        rect = self._super();
	        rect.deltaH += headH;
	        rect.innerH = rect.h - rect.deltaH;
	        return rect;
	      }
	    });
	
	    var TextBox = Widget.extend({
	      init: function (settings) {
	        var self = this;
	        self._super(settings);
	        self.classes.add('textbox');
	        if (settings.multiline) {
	          self.classes.add('multiline');
	        } else {
	          self.on('keydown', function (e) {
	            var rootControl;
	            if (e.keyCode === 13) {
	              e.preventDefault();
	              self.parents().reverse().each(function (ctrl) {
	                if (ctrl.toJSON) {
	                  rootControl = ctrl;
	                  return false;
	                }
	              });
	              self.fire('submit', { data: rootControl.toJSON() });
	            }
	          });
	          self.on('keyup', function (e) {
	            self.state.set('value', e.target.value);
	          });
	        }
	      },
	      repaint: function () {
	        var self = this;
	        var style, rect, borderBox, borderW, borderH = 0, lastRepaintRect;
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	        var doc = domGlobals.document;
	        if (!self.settings.multiline && doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          style.lineHeight = rect.h - borderH + 'px';
	        }
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right + 8;
	        borderH = borderBox.top + borderBox.bottom + (self.settings.multiline ? 8 : 0);
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = rect.x + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = rect.y + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	        if (rect.w !== lastRepaintRect.w) {
	          style.width = rect.w - borderW + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	        if (rect.h !== lastRepaintRect.h) {
	          style.height = rect.h - borderH + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	        return self;
	      },
	      renderHtml: function () {
	        var self = this;
	        var settings = self.settings;
	        var attrs, elm;
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	        global$2.each([
	          'rows',
	          'spellcheck',
	          'maxLength',
	          'size',
	          'readonly',
	          'min',
	          'max',
	          'step',
	          'list',
	          'pattern',
	          'placeholder',
	          'required',
	          'multiple'
	        ], function (name) {
	          attrs[name] = settings[name];
	        });
	        if (self.disabled()) {
	          attrs.disabled = 'disabled';
	        }
	        if (settings.subtype) {
	          attrs.type = settings.subtype;
	        }
	        elm = funcs.create(settings.multiline ? 'textarea' : 'input', attrs);
	        elm.value = self.state.get('value');
	        elm.className = self.classes.toString();
	        return elm.outerHTML;
	      },
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl().value);
	        }
	        return this.state.get('value');
	      },
	      postRender: function () {
	        var self = this;
	        self.getEl().value = self.state.get('value');
	        self._super();
	        self.$el.on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	      },
	      bindStates: function () {
	        var self = this;
	        self.state.on('change:value', function (e) {
	          if (self.getEl().value !== e.value) {
	            self.getEl().value = e.value;
	          }
	        });
	        self.state.on('change:disabled', function (e) {
	          self.getEl().disabled = e.value;
	        });
	        return self._super();
	      },
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	
	    var getApi = function () {
	      return {
	        Selector: Selector,
	        Collection: Collection$2,
	        ReflowQueue: ReflowQueue,
	        Control: Control$1,
	        Factory: global$4,
	        KeyboardNavigation: KeyboardNavigation,
	        Container: Container,
	        DragHelper: DragHelper,
	        Scrollable: Scrollable,
	        Panel: Panel,
	        Movable: Movable,
	        Resizable: Resizable,
	        FloatPanel: FloatPanel,
	        Window: Window,
	        MessageBox: MessageBox,
	        Tooltip: Tooltip,
	        Widget: Widget,
	        Progress: Progress,
	        Notification: Notification,
	        Layout: Layout,
	        AbsoluteLayout: AbsoluteLayout,
	        Button: Button,
	        ButtonGroup: ButtonGroup,
	        Checkbox: Checkbox,
	        ComboBox: ComboBox,
	        ColorBox: ColorBox,
	        PanelButton: PanelButton,
	        ColorButton: ColorButton,
	        ColorPicker: ColorPicker,
	        Path: Path,
	        ElementPath: ElementPath,
	        FormItem: FormItem,
	        Form: Form,
	        FieldSet: FieldSet,
	        FilePicker: FilePicker,
	        FitLayout: FitLayout,
	        FlexLayout: FlexLayout,
	        FlowLayout: FlowLayout,
	        FormatControls: FormatControls,
	        GridLayout: GridLayout,
	        Iframe: Iframe$1,
	        InfoBox: InfoBox,
	        Label: Label,
	        Toolbar: Toolbar$1,
	        MenuBar: MenuBar,
	        MenuButton: MenuButton,
	        MenuItem: MenuItem,
	        Throbber: Throbber,
	        Menu: Menu,
	        ListBox: ListBox,
	        Radio: Radio,
	        ResizeHandle: ResizeHandle,
	        SelectBox: SelectBox,
	        Slider: Slider,
	        Spacer: Spacer,
	        SplitButton: SplitButton,
	        StackLayout: StackLayout,
	        TabPanel: TabPanel,
	        TextBox: TextBox,
	        DropZone: DropZone,
	        BrowseButton: BrowseButton
	      };
	    };
	    var appendTo = function (target) {
	      if (target.ui) {
	        global$2.each(getApi(), function (ref, key) {
	          target.ui[key] = ref;
	        });
	      } else {
	        target.ui = getApi();
	      }
	    };
	    var registerToFactory = function () {
	      global$2.each(getApi(), function (ref, key) {
	        global$4.add(key, ref);
	      });
	    };
	    var Api = {
	      appendTo: appendTo,
	      registerToFactory: registerToFactory
	    };
	
	    Api.registerToFactory();
	    Api.appendTo(window.tinymce ? window.tinymce : {});
	    global.add('modern', function (editor) {
	      FormatControls.setup(editor);
	      return ThemeApi.get(editor);
	    });
	    function Theme () {
	    }
	
	    return Theme;
	
	}(window));
	})();


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 339 */
338,
/* 340 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIiA+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8bWV0YWRhdGE+PC9tZXRhZGF0YT4NCjxkZWZzPg0KPGZvbnQgaWQ9ImZvbnRhd2Vzb21lcmVndWxhciIgaG9yaXotYWR2LXg9IjE1MzYiID4NCjxmb250LWZhY2UgdW5pdHMtcGVyLWVtPSIxNzkyIiBhc2NlbnQ9IjE1MzYiIGRlc2NlbnQ9Ii0yNTYiIC8+DQo8bWlzc2luZy1nbHlwaCBob3Jpei1hZHYteD0iNDQ4IiAvPg0KPGdseXBoIHVuaWNvZGU9IiAiICBob3Jpei1hZHYteD0iNDQ4IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDA5OyIgaG9yaXotYWR2LXg9IjQ0OCIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhMDsiIGhvcml6LWFkdi14PSI0NDgiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTg7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhOTsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGFlOyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YjQ7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hjNjsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGQ4OyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAwMDsiIGhvcml6LWFkdi14PSI3NjgiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAwMTsiIGhvcml6LWFkdi14PSIxNTM3IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDI7IiBob3Jpei1hZHYteD0iNzY4IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDM7IiBob3Jpei1hZHYteD0iMTUzNyIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA0OyIgaG9yaXotYWR2LXg9IjUxMiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA1OyIgaG9yaXotYWR2LXg9IjM4NCIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA2OyIgaG9yaXotYWR2LXg9IjI1NiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA3OyIgaG9yaXotYWR2LXg9IjI1NiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA4OyIgaG9yaXotYWR2LXg9IjE5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA5OyIgaG9yaXotYWR2LXg9IjMwNyIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDBhOyIgaG9yaXotYWR2LXg9Ijg1IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMmY7IiBob3Jpei1hZHYteD0iMzA3IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNWY7IiBob3Jpei1hZHYteD0iMzg0IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIxMjI7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMjFlOyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjI2MDsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDI1ZmM7IiBob3Jpei1hZHYteD0iNTAwIiBkPSJNMCAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDAwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNjk5IDEzNTBxMCAtMzUgLTQzIC03OGwtNjMyIC02MzJ2LTc2OGgzMjBxMjYgMCA0NSAtMTl0MTkgLTQ1dC0xOSAtNDV0LTQ1IC0xOWgtODk2cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMzIwdjc2OGwtNjMyIDYzMnEtNDMgNDMgLTQzIDc4cTAgMjMgMTggMzYuNXQzOCAxNy41dDQzIDRoMTQwOHEyMyAwIDQzIC00dDM4IC0xNy41dDE4IC0zNi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDAxOyIgZD0iTTE1MzYgMTMxMnYtMTEyMHEwIC01MCAtMzQgLTg5dC04NiAtNjAuNXQtMTAzLjUgLTMydC05Ni41IC0xMC41dC05Ni41IDEwLjV0LTEwMy41IDMydC04NiA2MC41dC0zNCA4OXQzNCA4OXQ4NiA2MC41dDEwMy41IDMydDk2LjUgMTAuNXExMDUgMCAxOTIgLTM5djUzN2wtNzY4IC0yMzd2LTcwOXEwIC01MCAtMzQgLTg5dC04NiAtNjAuNXQtMTAzLjUgLTMydC05Ni41IC0xMC41dC05Ni41IDEwLjV0LTEwMy41IDMydC04NiA2MC41dC0zNCA4OSB0MzQgODl0ODYgNjAuNXQxMDMuNSAzMnQ5Ni41IDEwLjVxMTA1IDAgMTkyIC0zOXY5NjdxMCAzMSAxOSA1Ni41dDQ5IDM1LjVsODMyIDI1NnExMiA0IDI4IDRxNDAgMCA2OCAtMjh0MjggLTY4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDAyOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xMTUyIDcwNHEwIDE4NSAtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41dDMxNi41IDEzMS41dDEzMS41IDMxNi41ek0xNjY0IC0xMjhxMCAtNTIgLTM4IC05MHQtOTAgLTM4cS01NCAwIC05MCAzOGwtMzQzIDM0MnEtMTc5IC0xMjQgLTM5OSAtMTI0cS0xNDMgMCAtMjczLjUgNTUuNXQtMjI1IDE1MHQtMTUwIDIyNXQtNTUuNSAyNzMuNSB0NTUuNSAyNzMuNXQxNTAgMjI1dDIyNSAxNTB0MjczLjUgNTUuNXQyNzMuNSAtNTUuNXQyMjUgLTE1MHQxNTAgLTIyNXQ1NS41IC0yNzMuNXEwIC0yMjAgLTEyNCAtMzk5bDM0MyAtMzQzcTM3IC0zNyAzNyAtOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMDM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE2NjQgMzJ2NzY4cS0zMiAtMzYgLTY5IC02NnEtMjY4IC0yMDYgLTQyNiAtMzM4cS01MSAtNDMgLTgzIC02N3QtODYuNSAtNDguNXQtMTAyLjUgLTI0LjVoLTFoLTFxLTQ4IDAgLTEwMi41IDI0LjV0LTg2LjUgNDguNXQtODMgNjdxLTE1OCAxMzIgLTQyNiAzMzhxLTM3IDMwIC02OSA2NnYtNzY4cTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTQ3MnExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xNjY0IDEwODN2MTF2MTMuNXQtMC41IDEzIHQtMyAxMi41dC01LjUgOXQtOSA3LjV0LTE0IDIuNWgtMTQ3MnEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjVxMCAtMTY4IDE0NyAtMjg0cTE5MyAtMTUyIDQwMSAtMzE3cTYgLTUgMzUgLTI5LjV0NDYgLTM3LjV0NDQuNSAtMzEuNXQ1MC41IC0yNy41dDQzIC05aDFoMXEyMCAwIDQzIDl0NTAuNSAyNy41dDQ0LjUgMzEuNXQ0NiAzNy41dDM1IDI5LjVxMjA4IDE2NSA0MDEgMzE3cTU0IDQzIDEwMC41IDExNS41dDQ2LjUgMTMxLjV6IE0xNzkyIDExMjB2LTEwODhxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE0NzJxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjEwODhxMCA2NiA0NyAxMTN0MTEzIDQ3aDE0NzJxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMDQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTg5NiAtMTI4cS0yNiAwIC00NCAxOGwtNjI0IDYwMnEtMTAgOCAtMjcuNSAyNnQtNTUuNSA2NS41dC02OCA5Ny41dC01My41IDEyMXQtMjMuNSAxMzhxMCAyMjAgMTI3IDM0NHQzNTEgMTI0cTYyIDAgMTI2LjUgLTIxLjV0MTIwIC01OHQ5NS41IC02OC41dDc2IC02OHEzNiAzNiA3NiA2OHQ5NS41IDY4LjV0MTIwIDU4dDEyNi41IDIxLjVxMjI0IDAgMzUxIC0xMjR0MTI3IC0zNDRxMCAtMjIxIC0yMjkgLTQ1MGwtNjIzIC02MDAgcS0xOCAtMTggLTQ0IC0xOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAwNTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTY2NCA4ODlxMCAtMjIgLTI2IC00OGwtMzYzIC0zNTRsODYgLTUwMHExIC03IDEgLTIwcTAgLTIxIC0xMC41IC0zNS41dC0zMC41IC0xNC41cS0xOSAwIC00MCAxMmwtNDQ5IDIzNmwtNDQ5IC0yMzZxLTIyIC0xMiAtNDAgLTEycS0yMSAwIC0zMS41IDE0LjV0LTEwLjUgMzUuNXEwIDYgMiAyMGw4NiA1MDBsLTM2NCAzNTRxLTI1IDI3IC0yNSA0OHEwIDM3IDU2IDQ2bDUwMiA3M2wyMjUgNDU1cTE5IDQxIDQ5IDQxdDQ5IC00MWwyMjUgLTQ1NSBsNTAyIC03M3E1NiAtOSA1NiAtNDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMDY7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTExMzcgNTMybDMwNiAyOTdsLTQyMiA2MmwtMTg5IDM4MmwtMTg5IC0zODJsLTQyMiAtNjJsMzA2IC0yOTdsLTczIC00MjFsMzc4IDE5OWwzNzcgLTE5OXpNMTY2NCA4ODlxMCAtMjIgLTI2IC00OGwtMzYzIC0zNTRsODYgLTUwMHExIC03IDEgLTIwcTAgLTUwIC00MSAtNTBxLTE5IDAgLTQwIDEybC00NDkgMjM2bC00NDkgLTIzNnEtMjIgLTEyIC00MCAtMTJxLTIxIDAgLTMxLjUgMTQuNXQtMTAuNSAzNS41cTAgNiAyIDIwbDg2IDUwMCBsLTM2NCAzNTRxLTI1IDI3IC0yNSA0OHEwIDM3IDU2IDQ2bDUwMiA3M2wyMjUgNDU1cTE5IDQxIDQ5IDQxdDQ5IC00MWwyMjUgLTQ1NWw1MDIgLTczcTU2IC05IDU2IC00NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAwNzsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTQwOCAxMzFxMCAtMTIwIC03MyAtMTg5LjV0LTE5NCAtNjkuNWgtODc0cS0xMjEgMCAtMTk0IDY5LjV0LTczIDE4OS41cTAgNTMgMy41IDEwMy41dDE0IDEwOXQyNi41IDEwOC41dDQzIDk3LjV0NjIgODF0ODUuNSA1My41dDExMS41IDIwcTkgMCA0MiAtMjEuNXQ3NC41IC00OHQxMDggLTQ4dDEzMy41IC0yMS41dDEzMy41IDIxLjV0MTA4IDQ4dDc0LjUgNDh0NDIgMjEuNXE2MSAwIDExMS41IC0yMHQ4NS41IC01My41dDYyIC04MSB0NDMgLTk3LjV0MjYuNSAtMTA4LjV0MTQgLTEwOXQzLjUgLTEwMy41ek0xMDg4IDEwMjRxMCAtMTU5IC0xMTIuNSAtMjcxLjV0LTI3MS41IC0xMTIuNXQtMjcxLjUgMTEyLjV0LTExMi41IDI3MS41dDExMi41IDI3MS41dDI3MS41IDExMi41dDI3MS41IC0xMTIuNXQxMTIuNSAtMjcxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMDg7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTM4NCAtNjR2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV6TTM4NCAzMjB2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV6TTM4NCA3MDR2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4IHEtMjYgMCAtNDUgLTE5dC0xOSAtNDV2LTEyOHEwIC0yNiAxOSAtNDV0NDUgLTE5aDEyOHEyNiAwIDQ1IDE5dDE5IDQ1ek0xNDA4IC02NHY1MTJxMCAyNiAtMTkgNDV0LTQ1IDE5aC03NjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di01MTJxMCAtMjYgMTkgLTQ1dDQ1IC0xOWg3NjhxMjYgMCA0NSAxOXQxOSA0NXpNMzg0IDEwODh2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NSB0NDUgLTE5aDEyOHEyNiAwIDQ1IDE5dDE5IDQ1ek0xNzkyIC02NHYxMjhxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0xMjhxMCAtMjYgMTkgLTQ1dDQ1IC0xOWgxMjhxMjYgMCA0NSAxOXQxOSA0NXpNMTQwOCA3MDR2NTEycTAgMjYgLTE5IDQ1dC00NSAxOWgtNzY4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtNTEycTAgLTI2IDE5IC00NXQ0NSAtMTloNzY4cTI2IDAgNDUgMTl0MTkgNDV6TTE3OTIgMzIwdjEyOCBxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0xMjhxMCAtMjYgMTkgLTQ1dDQ1IC0xOWgxMjhxMjYgMCA0NSAxOXQxOSA0NXpNMTc5MiA3MDR2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV6TTE3OTIgMTA4OHYxMjhxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOSB0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV6TTE5MjAgMTI0OHYtMTM0NHEwIC02NiAtNDcgLTExM3QtMTEzIC00N2gtMTYwMHEtNjYgMCAtMTEzIDQ3dC00NyAxMTN2MTM0NHEwIDY2IDQ3IDExM3QxMTMgNDdoMTYwMHE2NiAwIDExMyAtNDd0NDcgLTExM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAwOTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNzY4IDUxMnYtMzg0cTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtNTEycS01MiAwIC05MCAzOHQtMzggOTB2Mzg0cTAgNTIgMzggOTB0OTAgMzhoNTEycTUyIDAgOTAgLTM4dDM4IC05MHpNNzY4IDEyODB2LTM4NHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTUxMnEtNTIgMCAtOTAgMzh0LTM4IDkwdjM4NHEwIDUyIDM4IDkwdDkwIDM4aDUxMnE1MiAwIDkwIC0zOHQzOCAtOTB6TTE2NjQgNTEydi0zODRxMCAtNTIgLTM4IC05MHQtOTAgLTM4IGgtNTEycS01MiAwIC05MCAzOHQtMzggOTB2Mzg0cTAgNTIgMzggOTB0OTAgMzhoNTEycTUyIDAgOTAgLTM4dDM4IC05MHpNMTY2NCAxMjgwdi0zODRxMCAtNTIgLTM4IC05MHQtOTAgLTM4aC01MTJxLTUyIDAgLTkwIDM4dC0zOCA5MHYzODRxMCA1MiAzOCA5MHQ5MCAzOGg1MTJxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDBhOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik01MTIgMjg4di0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek01MTIgODAwdi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek0xMTUyIDI4OHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMzIwIHEtNDAgMCAtNjggMjh0LTI4IDY4djE5MnEwIDQwIDI4IDY4dDY4IDI4aDMyMHE0MCAwIDY4IC0yOHQyOCAtNjh6TTUxMiAxMzEydi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek0xMTUyIDgwMHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMzIwcS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjggaDMyMHE0MCAwIDY4IC0yOHQyOCAtNjh6TTE3OTIgMjg4di0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek0xMTUyIDEzMTJ2LTE5MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTMyMHEtNDAgMCAtNjggMjh0LTI4IDY4djE5MnEwIDQwIDI4IDY4dDY4IDI4aDMyMHE0MCAwIDY4IC0yOHQyOCAtNjh6TTE3OTIgODAwdi0xOTIgcTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMzIwcS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjhoMzIwcTQwIDAgNjggLTI4dDI4IC02OHpNMTc5MiAxMzEydi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDBiOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik01MTIgMjg4di0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek01MTIgODAwdi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek0xNzkyIDI4OHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtOTYwIHEtNDAgMCAtNjggMjh0LTI4IDY4djE5MnEwIDQwIDI4IDY4dDY4IDI4aDk2MHE0MCAwIDY4IC0yOHQyOCAtNjh6TTUxMiAxMzEydi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgzMjBxNDAgMCA2OCAtMjh0MjggLTY4ek0xNzkyIDgwMHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtOTYwcS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjggaDk2MHE0MCAwIDY4IC0yOHQyOCAtNjh6TTE3OTIgMTMxMnYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtOTYwcS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjhoOTYwcTQwIDAgNjggLTI4dDI4IC02OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAwYzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY3MSA5NzBxMCAtNDAgLTI4IC02OGwtNzI0IC03MjRsLTEzNiAtMTM2cS0yOCAtMjggLTY4IC0yOHQtNjggMjhsLTEzNiAxMzZsLTM2MiAzNjJxLTI4IDI4IC0yOCA2OHQyOCA2OGwxMzYgMTM2cTI4IDI4IDY4IDI4dDY4IC0yOGwyOTQgLTI5NWw2NTYgNjU3cTI4IDI4IDY4IDI4dDY4IC0yOGwxMzYgLTEzNnEyOCAtMjggMjggLTY4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDBkOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0xMjk4IDIxNHEwIC00MCAtMjggLTY4bC0xMzYgLTEzNnEtMjggLTI4IC02OCAtMjh0LTY4IDI4bC0yOTQgMjk0bC0yOTQgLTI5NHEtMjggLTI4IC02OCAtMjh0LTY4IDI4bC0xMzYgMTM2cS0yOCAyOCAtMjggNjh0MjggNjhsMjk0IDI5NGwtMjk0IDI5NHEtMjggMjggLTI4IDY4dDI4IDY4bDEzNiAxMzZxMjggMjggNjggMjh0NjggLTI4bDI5NCAtMjk0bDI5NCAyOTRxMjggMjggNjggMjh0NjggLTI4bDEzNiAtMTM2cTI4IC0yOCAyOCAtNjggdC0yOCAtNjhsLTI5NCAtMjk0bDI5NCAtMjk0cTI4IC0yOCAyOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMGU7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTEwMjQgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTIyNHYtMjI0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYyMjRoLTIyNHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoMjI0djIyNHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXYtMjI0aDIyNCBxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xMTUyIDcwNHEwIDE4NSAtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41dDMxNi41IDEzMS41dDEzMS41IDMxNi41ek0xNjY0IC0xMjhxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjVxLTU0IDAgLTkwIDM4bC0zNDMgMzQycS0xNzkgLTEyNCAtMzk5IC0xMjRxLTE0MyAwIC0yNzMuNSA1NS41IHQtMjI1IDE1MHQtMTUwIDIyNXQtNTUuNSAyNzMuNXQ1NS41IDI3My41dDE1MCAyMjV0MjI1IDE1MHQyNzMuNSA1NS41dDI3My41IC01NS41dDIyNSAtMTUwdDE1MCAtMjI1dDU1LjUgLTI3My41cTAgLTIyMCAtMTI0IC0zOTlsMzQzIC0zNDNxMzcgLTM3IDM3IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAxMDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTAyNCA3MzZ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNTc2cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg1NzZxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xMTUyIDcwNHEwIDE4NSAtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41dDMxNi41IDEzMS41dDEzMS41IDMxNi41eiBNMTY2NCAtMTI4cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41cS01NCAwIC05MCAzOGwtMzQzIDM0MnEtMTc5IC0xMjQgLTM5OSAtMTI0cS0xNDMgMCAtMjczLjUgNTUuNXQtMjI1IDE1MHQtMTUwIDIyNXQtNTUuNSAyNzMuNXQ1NS41IDI3My41dDE1MCAyMjV0MjI1IDE1MHQyNzMuNSA1NS41dDI3My41IC01NS41dDIyNSAtMTUwdDE1MCAtMjI1dDU1LjUgLTI3My41cTAgLTIyMCAtMTI0IC0zOTlsMzQzIC0zNDNxMzcgLTM3IDM3IC05MHogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMTE7IiBkPSJNMTUzNiA2NDBxMCAtMTU2IC02MSAtMjk4dC0xNjQgLTI0NXQtMjQ1IC0xNjR0LTI5OCAtNjF0LTI5OCA2MXQtMjQ1IDE2NHQtMTY0IDI0NXQtNjEgMjk4cTAgMTgyIDgwLjUgMzQzdDIyNi41IDI3MHE0MyAzMiA5NS41IDI1dDgzLjUgLTUwcTMyIC00MiAyNC41IC05NC41dC00OS41IC04NC41cS05OCAtNzQgLTE1MS41IC0xODF0LTUzLjUgLTIyOHEwIC0xMDQgNDAuNSAtMTk4LjV0MTA5LjUgLTE2My41dDE2My41IC0xMDkuNSB0MTk4LjUgLTQwLjV0MTk4LjUgNDAuNXQxNjMuNSAxMDkuNXQxMDkuNSAxNjMuNXQ0MC41IDE5OC41cTAgMTIxIC01My41IDIyOHQtMTUxLjUgMTgxcS00MiAzMiAtNDkuNSA4NC41dDI0LjUgOTQuNXEzMSA0MyA4NCA1MHQ5NSAtMjVxMTQ2IC0xMDkgMjI2LjUgLTI3MHQ4MC41IC0zNDN6TTg5NiAxNDA4di02NDBxMCAtNTIgLTM4IC05MHQtOTAgLTM4dC05MCAzOHQtMzggOTB2NjQwcTAgNTIgMzggOTB0OTAgMzh0OTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAxMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMjU2IDk2di0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3pNNjQwIDIyNHYtMzIwcTAgLTE0IC05IC0yM3QtMjMgLTloLTE5MnEtMTQgMCAtMjMgOXQtOSAyM3YzMjBxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN6TTEwMjQgNDgwdi01NzZxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzIHY1NzZxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN6TTE0MDggODY0di05NjBxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzdjk2MHEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3pNMTc5MiAxMzc2di0xNDcycTAgLTE0IC05IC0yM3QtMjMgLTloLTE5MnEtMTQgMCAtMjMgOXQtOSAyM3YxNDcycTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDEzOyIgZD0iTTEwMjQgNjQwcTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXQ3NSAtMTgxdDE4MSAtNzV0MTgxIDc1dDc1IDE4MXpNMTUzNiA3NDl2LTIyMnEwIC0xMiAtOCAtMjN0LTIwIC0xM2wtMTg1IC0yOHEtMTkgLTU0IC0zOSAtOTFxMzUgLTUwIDEwNyAtMTM4cTEwIC0xMiAxMCAtMjV0LTkgLTIzcS0yNyAtMzcgLTk5IC0xMDh0LTk0IC03MXEtMTIgMCAtMjYgOWwtMTM4IDEwOHEtNDQgLTIzIC05MSAtMzggcS0xNiAtMTM2IC0yOSAtMTg2cS03IC0yOCAtMzYgLTI4aC0yMjJxLTE0IDAgLTI0LjUgOC41dC0xMS41IDIxLjVsLTI4IDE4NHEtNDkgMTYgLTkwIDM3bC0xNDEgLTEwN3EtMTAgLTkgLTI1IC05cS0xNCAwIC0yNSAxMXEtMTI2IDExNCAtMTY1IDE2OHEtNyAxMCAtNyAyM3EwIDEyIDggMjNxMTUgMjEgNTEgNjYuNXQ1NCA3MC41cS0yNyA1MCAtNDEgOTlsLTE4MyAyN3EtMTMgMiAtMjEgMTIuNXQtOCAyMy41djIyMnEwIDEyIDggMjN0MTkgMTMgbDE4NiAyOHExNCA0NiAzOSA5MnEtNDAgNTcgLTEwNyAxMzhxLTEwIDEyIC0xMCAyNHEwIDEwIDkgMjNxMjYgMzYgOTguNSAxMDcuNXQ5NC41IDcxLjVxMTMgMCAyNiAtMTBsMTM4IC0xMDdxNDQgMjMgOTEgMzhxMTYgMTM2IDI5IDE4NnE3IDI4IDM2IDI4aDIyMnExNCAwIDI0LjUgLTguNXQxMS41IC0yMS41bDI4IC0xODRxNDkgLTE2IDkwIC0zN2wxNDIgMTA3cTkgOSAyNCA5cTEzIDAgMjUgLTEwcTEyOSAtMTE5IDE2NSAtMTcwcTcgLTggNyAtMjIgcTAgLTEyIC04IC0yM3EtMTUgLTIxIC01MSAtNjYuNXQtNTQgLTcwLjVxMjYgLTUwIDQxIC05OGwxODMgLTI4cTEzIC0yIDIxIC0xMi41dDggLTIzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMTQ7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTUxMiA4MDB2LTU3NnEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3Y1NzZxMCAxNCA5IDIzdDIzIDloNjRxMTQgMCAyMyAtOXQ5IC0yM3pNNzY4IDgwMHYtNTc2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjU3NnEwIDE0IDkgMjN0MjMgOWg2NHExNCAwIDIzIC05dDkgLTIzek0xMDI0IDgwMHYtNTc2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjU3NiBxMCAxNCA5IDIzdDIzIDloNjRxMTQgMCAyMyAtOXQ5IC0yM3pNMTE1MiA3NnY5NDhoLTg5NnYtOTQ4cTAgLTIyIDcgLTQwLjV0MTQuNSAtMjd0MTAuNSAtOC41aDgzMnEzIDAgMTAuNSA4LjV0MTQuNSAyN3Q3IDQwLjV6TTQ4MCAxMTUyaDQ0OGwtNDggMTE3cS03IDkgLTE3IDExaC0zMTdxLTEwIC0yIC0xNyAtMTF6TTE0MDggMTEyMHYtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ2LTk0OHEwIC04MyAtNDcgLTE0My41dC0xMTMgLTYwLjVoLTgzMiBxLTY2IDAgLTExMyA1OC41dC00NyAxNDEuNXY5NTJoLTk2cS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDMwOWw3MCAxNjdxMTUgMzcgNTQgNjN0NzkgMjZoMzIwcTQwIDAgNzkgLTI2dDU0IC02M2w3MCAtMTY3aDMwOXExNCAwIDIzIC05dDkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDE1OyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNDA4IDU0NHYtNDgwcTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMzg0djM4NGgtMjU2di0zODRoLTM4NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djQ4MHEwIDEgMC41IDN0MC41IDNsNTc1IDQ3NGw1NzUgLTQ3NHExIC0yIDEgLTZ6TTE2MzEgNjEzbC02MiAtNzRxLTggLTkgLTIxIC0xMWgtM3EtMTMgMCAtMjEgN2wtNjkyIDU3N2wtNjkyIC01NzdxLTEyIC04IC0yNCAtN3EtMTMgMiAtMjEgMTFsLTYyIDc0cS04IDEwIC03IDIzLjV0MTEgMjEuNSBsNzE5IDU5OXEzMiAyNiA3NiAyNnQ3NiAtMjZsMjQ0IC0yMDR2MTk1cTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzdi00MDhsMjE5IC0xODJxMTAgLTggMTEgLTIxLjV0LTcgLTIzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMTY7IiBkPSJNMTQ2OCAxMTU2cTI4IC0yOCA0OCAtNzZ0MjAgLTg4di0xMTUycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTM0NHEtNDAgMCAtNjggMjh0LTI4IDY4djE2MDBxMCA0MCAyOCA2OHQ2OCAyOGg4OTZxNDAgMCA4OCAtMjB0NzYgLTQ4ek0xMDI0IDE0MDB2LTM3NmgzNzZxLTEwIDI5IC0yMiA0MWwtMzEzIDMxM3EtMTIgMTIgLTQxIDIyek0xNDA4IC0xMjh2MTAyNGgtNDE2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC03Njh2LTE1MzZoMTI4MHogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMTc7IiBkPSJNODk2IDk5MnYtNDQ4cTAgLTE0IC05IC0yM3QtMjMgLTloLTMyMHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWgyMjR2MzUycTAgMTQgOSAyM3QyMyA5aDY0cTE0IDAgMjMgLTl0OSAtMjN6TTEzMTIgNjQwcTAgMTQ4IC03MyAyNzN0LTE5OCAxOTh0LTI3MyA3M3QtMjczIC03M3QtMTk4IC0xOTh0LTczIC0yNzN0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczdDI3MyA3M3QxOTggMTk4dDczIDI3M3pNMTUzNiA2NDAgcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDE4OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xMTExIDU0MHY0bC0yNCAzMjBxLTEgMTMgLTExIDIyLjV0LTIzIDkuNWgtMTg2cS0xMyAwIC0yMyAtOS41dC0xMSAtMjIuNWwtMjQgLTMyMHYtNHEtMSAtMTIgOCAtMjB0MjEgLThoMjQ0cTEyIDAgMjEgOHQ4IDIwek0xODcwIDczcTAgLTczIC00NiAtNzNoLTcwNHExMyAwIDIyIDkuNXQ4IDIyLjVsLTIwIDI1NnEtMSAxMyAtMTEgMjIuNXQtMjMgOS41aC0yNzJxLTEzIDAgLTIzIC05LjV0LTExIC0yMi41bC0yMCAtMjU2IHEtMSAtMTMgOCAtMjIuNXQyMiAtOS41aC03MDRxLTQ2IDAgLTQ2IDczcTAgNTQgMjYgMTE2bDQxNyAxMDQ0cTggMTkgMjYgMzN0MzggMTRoMzM5cS0xMyAwIC0yMyAtOS41dC0xMSAtMjIuNWwtMTUgLTE5MnEtMSAtMTQgOCAtMjN0MjIgLTloMTY2cTEzIDAgMjIgOXQ4IDIzbC0xNSAxOTJxLTEgMTMgLTExIDIyLjV0LTIzIDkuNWgzMzlxMjAgMCAzOCAtMTR0MjYgLTMzbDQxNyAtMTA0NHEyNiAtNjIgMjYgLTExNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAxOTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTI4MCAxOTJxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1ek0xNTM2IDE5MnEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE2NjQgNDE2di0zMjBxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xNDcycS00MCAwIC02OCAyOHQtMjggNjh2MzIwcTAgNDAgMjggNjh0NjggMjhoNDY1bDEzNSAtMTM2IHE1OCAtNTYgMTM2IC01NnQxMzYgNTZsMTM2IDEzNmg0NjRxNDAgMCA2OCAtMjh0MjggLTY4ek0xMzM5IDk4NXExNyAtNDEgLTE0IC03MGwtNDQ4IC00NDhxLTE4IC0xOSAtNDUgLTE5dC00NSAxOWwtNDQ4IDQ0OHEtMzEgMjkgLTE0IDcwcTE3IDM5IDU5IDM5aDI1NnY0NDhxMCAyNiAxOSA0NXQ0NSAxOWgyNTZxMjYgMCA0NSAtMTl0MTkgLTQ1di00NDhoMjU2cTQyIDAgNTkgLTM5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDFhOyIgZD0iTTExMjAgNjA4cTAgLTEyIC0xMCAtMjRsLTMxOSAtMzE5cS0xMSAtOSAtMjMgLTl0LTIzIDlsLTMyMCAzMjBxLTE1IDE2IC03IDM1cTggMjAgMzAgMjBoMTkydjM1MnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtMzUyaDE5MnExNCAwIDIzIC05dDkgLTIzek03NjggMTE4NHEtMTQ4IDAgLTI3MyAtNzN0LTE5OCAtMTk4dC03MyAtMjczdDczIC0yNzN0MTk4IC0xOTh0MjczIC03M3QyNzMgNzN0MTk4IDE5OHQ3MyAyNzMgdC03MyAyNzN0LTE5OCAxOTh0LTI3MyA3M3pNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMWI7IiBkPSJNMTExOCA2NjBxLTggLTIwIC0zMCAtMjBoLTE5MnYtMzUycTAgLTE0IC05IC0yM3QtMjMgLTloLTE5MnEtMTQgMCAtMjMgOXQtOSAyM3YzNTJoLTE5MnEtMTQgMCAtMjMgOXQtOSAyM3EwIDEyIDEwIDI0bDMxOSAzMTlxMTEgOSAyMyA5dDIzIC05bDMyMCAtMzIwcTE1IC0xNiA3IC0zNXpNNzY4IDExODRxLTE0OCAwIC0yNzMgLTczdC0xOTggLTE5OHQtNzMgLTI3M3Q3MyAtMjczdDE5OCAtMTk4dDI3MyAtNzN0MjczIDczdDE5OCAxOTggdDczIDI3M3QtNzMgMjczdC0xOTggMTk4dC0yNzMgNzN6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDFjOyIgZD0iTTEwMjMgNTc2aDMxNnEtMSAzIC0yLjUgOHQtMi41IDhsLTIxMiA0OTZoLTcwOGwtMjEyIC00OTZxLTEgLTIgLTIuNSAtOHQtMi41IC04aDMxNmw5NSAtMTkyaDMyMHpNMTUzNiA1NDZ2LTQ4MnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE0MDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXY0ODJxMCA2MiAyNSAxMjNsMjM4IDU1MnExMCAyNSAzNi41IDQydDUyLjUgMTdoODMycTI2IDAgNTIuNSAtMTd0MzYuNSAtNDJsMjM4IC01NTIgcTI1IC02MSAyNSAtMTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDFkOyIgZD0iTTExODQgNjQwcTAgLTM3IC0zMiAtNTVsLTU0NCAtMzIwcS0xNSAtOSAtMzIgLTlxLTE2IDAgLTMyIDhxLTMyIDE5IC0zMiA1NnY2NDBxMCAzNyAzMiA1NnEzMyAxOCA2NCAtMWw1NDQgLTMyMHEzMiAtMTggMzIgLTU1ek0xMzEyIDY0MHEwIDE0OCAtNzMgMjczdC0xOTggMTk4dC0yNzMgNzN0LTI3MyAtNzN0LTE5OCAtMTk4dC03MyAtMjczdDczIC0yNzN0MTk4IC0xOTh0MjczIC03M3QyNzMgNzN0MTk4IDE5OHQ3MyAyNzN6TTE1MzYgNjQwIHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAxZTsiIGQ9Ik0xNTM2IDEyODB2LTQ0OHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTQ0OHEtNDIgMCAtNTkgNDBxLTE3IDM5IDE0IDY5bDEzOCAxMzhxLTE0OCAxMzcgLTM0OSAxMzdxLTEwNCAwIC0xOTguNSAtNDAuNXQtMTYzLjUgLTEwOS41dC0xMDkuNSAtMTYzLjV0LTQwLjUgLTE5OC41dDQwLjUgLTE5OC41dDEwOS41IC0xNjMuNXQxNjMuNSAtMTA5LjV0MTk4LjUgLTQwLjVxMTE5IDAgMjI1IDUydDE3OSAxNDdxNyAxMCAyMyAxMnExNCAwIDI1IC05IGwxMzcgLTEzOHE5IC04IDkuNSAtMjAuNXQtNy41IC0yMi41cS0xMDkgLTEzMiAtMjY0IC0yMDQuNXQtMzI3IC03Mi41cS0xNTYgMCAtMjk4IDYxdC0yNDUgMTY0dC0xNjQgMjQ1dC02MSAyOTh0NjEgMjk4dDE2NCAyNDV0MjQ1IDE2NHQyOTggNjFxMTQ3IDAgMjg0LjUgLTU1LjV0MjQ0LjUgLTE1Ni41bDEzMCAxMjlxMjkgMzEgNzAgMTRxMzkgLTE3IDM5IC01OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAyMTsiIGQ9Ik0xNTExIDQ4MHEwIC01IC0xIC03cS02NCAtMjY4IC0yNjggLTQzNC41dC00NzggLTE2Ni41cS0xNDYgMCAtMjgyLjUgNTV0LTI0My41IDE1N2wtMTI5IC0xMjlxLTE5IC0xOSAtNDUgLTE5dC00NSAxOXQtMTkgNDV2NDQ4cTAgMjYgMTkgNDV0NDUgMTloNDQ4cTI2IDAgNDUgLTE5dDE5IC00NXQtMTkgLTQ1bC0xMzcgLTEzN3E3MSAtNjYgMTYxIC0xMDJ0MTg3IC0zNnExMzQgMCAyNTAgNjV0MTg2IDE3OXExMSAxNyA1MyAxMTcgcTggMjMgMzAgMjNoMTkycTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMTUzNiAxMjgwdi00NDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC00NDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NWwxMzggMTM4cS0xNDggMTM3IC0zNDkgMTM3cS0xMzQgMCAtMjUwIC02NXQtMTg2IC0xNzlxLTExIC0xNyAtNTMgLTExN3EtOCAtMjMgLTMwIC0yM2gtMTk5cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2N3E2NSAyNjggMjcwIDQzNC41dDQ4MCAxNjYuNSBxMTQ2IDAgMjg0IC01NS41dDI0NSAtMTU2LjVsMTMwIDEyOXExOSAxOSA0NSAxOXQ0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDIyOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0zODQgMzUydi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTM4NCA2MDh2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTM4NCA4NjR2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMTUzNiAzNTJ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtOTYwcS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg5NjBxMTMgMCAyMi41IC05LjV0OS41IC0yMi41eiBNMTUzNiA2MDh2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtOTYwcS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg5NjBxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNTM2IDg2NHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC05NjBxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDk2MHExMyAwIDIyLjUgLTkuNSB0OS41IC0yMi41ek0xNjY0IDE2MHY4MzJxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xNDcycS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtODMycTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTQ3MnExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xNzkyIDEyNDh2LTEwODhxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE0NzJxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjEwODhxMCA2NiA0NyAxMTN0MTEzIDQ3aDE0NzJxNjYgMCAxMTMgLTQ3IHQ0NyAtMTEzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDIzOyIgaG9yaXotYWR2LXg9IjExNTIiIGQ9Ik0zMjAgNzY4aDUxMnYxOTJxMCAxMDYgLTc1IDE4MXQtMTgxIDc1dC0xODEgLTc1dC03NSAtMTgxdi0xOTJ6TTExNTIgNjcydi01NzZxMCAtNDAgLTI4IC02OHQtNjggLTI4aC05NjBxLTQwIDAgLTY4IDI4dC0yOCA2OHY1NzZxMCA0MCAyOCA2OHQ2OCAyOGgzMnYxOTJxMCAxODQgMTMyIDMxNnQzMTYgMTMydDMxNiAtMTMydDEzMiAtMzE2di0xOTJoMzJxNDAgMCA2OCAtMjh0MjggLTY4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDI0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0zMjAgMTI4MHEwIC03MiAtNjQgLTExMHYtMTI2NnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTI2NnEtNjQgMzggLTY0IDExMHEwIDUzIDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xNzkyIDEyMTZ2LTc2M3EwIC0yNSAtMTIuNSAtMzguNXQtMzkuNSAtMjcuNXEtMjE1IC0xMTYgLTM2OSAtMTE2cS02MSAwIC0xMjMuNSAyMnQtMTA4LjUgNDggdC0xMTUuNSA0OHQtMTQyLjUgMjJxLTE5MiAwIC00NjQgLTE0NnEtMTcgLTkgLTMzIC05cS0yNiAwIC00NSAxOXQtMTkgNDV2NzQycTAgMzIgMzEgNTVxMjEgMTQgNzkgNDNxMjM2IDEyMCA0MjEgMTIwcTEwNyAwIDIwMCAtMjl0MjE5IC04OHEzOCAtMTkgODggLTE5cTU0IDAgMTE3LjUgMjF0MTEwIDQ3dDg4IDQ3dDU0LjUgMjFxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDI1OyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNjY0IDY1MHEwIC0xNjYgLTYwIC0zMTRsLTIwIC00OWwtMTg1IC0zM3EtMjIgLTgzIC05MC41IC0xMzYuNXQtMTU2LjUgLTUzLjV2LTMycTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjU3NnEwIDE0IDkgMjN0MjMgOWg2NHExNCAwIDIzIC05dDkgLTIzdi0zMnE3MSAwIDEzMCAtMzUuNXQ5MyAtOTUuNWw2OCAxMnEyOSA5NSAyOSAxOTNxMCAxNDggLTg4IDI3OXQtMjM2LjUgMjA5dC0zMTUuNSA3OCB0LTMxNS41IC03OHQtMjM2LjUgLTIwOXQtODggLTI3OXEwIC05OCAyOSAtMTkzbDY4IC0xMnEzNCA2MCA5MyA5NS41dDEzMCAzNS41djMycTAgMTQgOSAyM3QyMyA5aDY0cTE0IDAgMjMgLTl0OSAtMjN2LTU3NnEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YzMnEtODggMCAtMTU2LjUgNTMuNXQtOTAuNSAxMzYuNWwtMTg1IDMzbC0yMCA0OXEtNjAgMTQ4IC02MCAzMTRxMCAxNTEgNjcgMjkxdDE3OSAyNDIuNSB0MjY2IDE2My41dDMyMCA2MXQzMjAgLTYxdDI2NiAtMTYzLjV0MTc5IC0yNDIuNXQ2NyAtMjkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDI2OyIgaG9yaXotYWR2LXg9Ijc2OCIgZD0iTTc2OCAxMTg0di0xMDg4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTlsLTMzMyAzMzNoLTI2MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djM4NHEwIDI2IDE5IDQ1dDQ1IDE5aDI2MmwzMzMgMzMzcTE5IDE5IDQ1IDE5dDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMjc7IiBob3Jpei1hZHYteD0iMTE1MiIgZD0iTTc2OCAxMTg0di0xMDg4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTlsLTMzMyAzMzNoLTI2MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djM4NHEwIDI2IDE5IDQ1dDQ1IDE5aDI2MmwzMzMgMzMzcTE5IDE5IDQ1IDE5dDQ1IC0xOXQxOSAtNDV6TTExNTIgNjQwcTAgLTc2IC00Mi41IC0xNDEuNXQtMTEyLjUgLTkzLjVxLTEwIC01IC0yNSAtNXEtMjYgMCAtNDUgMTguNXQtMTkgNDUuNXEwIDIxIDEyIDM1LjV0MjkgMjV0MzQgMjN0MjkgMzUuNSB0MTIgNTd0LTEyIDU3dC0yOSAzNS41dC0zNCAyM3QtMjkgMjV0LTEyIDM1LjVxMCAyNyAxOSA0NS41dDQ1IDE4LjVxMTUgMCAyNSAtNXE3MCAtMjcgMTEyLjUgLTkzdDQyLjUgLTE0MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAyODsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNzY4IDExODR2LTEwODhxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOWwtMzMzIDMzM2gtMjYycS0yNiAwIC00NSAxOXQtMTkgNDV2Mzg0cTAgMjYgMTkgNDV0NDUgMTloMjYybDMzMyAzMzNxMTkgMTkgNDUgMTl0NDUgLTE5dDE5IC00NXpNMTE1MiA2NDBxMCAtNzYgLTQyLjUgLTE0MS41dC0xMTIuNSAtOTMuNXEtMTAgLTUgLTI1IC01cS0yNiAwIC00NSAxOC41dC0xOSA0NS41cTAgMjEgMTIgMzUuNXQyOSAyNXQzNCAyM3QyOSAzNS41IHQxMiA1N3QtMTIgNTd0LTI5IDM1LjV0LTM0IDIzdC0yOSAyNXQtMTIgMzUuNXEwIDI3IDE5IDQ1LjV0NDUgMTguNXExNSAwIDI1IC01cTcwIC0yNyAxMTIuNSAtOTN0NDIuNSAtMTQyek0xNDA4IDY0MHEwIC0xNTMgLTg1IC0yODIuNXQtMjI1IC0xODguNXEtMTMgLTUgLTI1IC01cS0yNyAwIC00NiAxOXQtMTkgNDVxMCAzOSAzOSA1OXE1NiAyOSA3NiA0NHE3NCA1NCAxMTUuNSAxMzUuNXQ0MS41IDE3My41dC00MS41IDE3My41IHQtMTE1LjUgMTM1LjVxLTIwIDE1IC03NiA0NHEtMzkgMjAgLTM5IDU5cTAgMjYgMTkgNDV0NDUgMTlxMTMgMCAyNiAtNXExNDAgLTU5IDIyNSAtMTg4LjV0ODUgLTI4Mi41ek0xNjY0IDY0MHEwIC0yMzAgLTEyNyAtNDIyLjV0LTMzOCAtMjgzLjVxLTEzIC01IC0yNiAtNXEtMjYgMCAtNDUgMTl0LTE5IDQ1cTAgMzYgMzkgNTlxNyA0IDIyLjUgMTAuNXQyMi41IDEwLjVxNDYgMjUgODIgNTFxMTIzIDkxIDE5MiAyMjd0NjkgMjg5dC02OSAyODkgdC0xOTIgMjI3cS0zNiAyNiAtODIgNTFxLTcgNCAtMjIuNSAxMC41dC0yMi41IDEwLjVxLTM5IDIzIC0zOSA1OXEwIDI2IDE5IDQ1dDQ1IDE5cTEzIDAgMjYgLTVxMjExIC05MSAzMzggLTI4My41dDEyNyAtNDIyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMjk7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTM4NCAzODR2LTEyOGgtMTI4djEyOGgxMjh6TTM4NCAxMTUydi0xMjhoLTEyOHYxMjhoMTI4ek0xMTUyIDExNTJ2LTEyOGgtMTI4djEyOGgxMjh6TTEyOCAxMjloMzg0djM4M2gtMzg0di0zODN6TTEyOCA4OTZoMzg0djM4NGgtMzg0di0zODR6TTg5NiA4OTZoMzg0djM4NGgtMzg0di0zODR6TTY0MCA2NDB2LTY0MGgtNjQwdjY0MGg2NDB6TTExNTIgMTI4di0xMjhoLTEyOHYxMjhoMTI4ek0xNDA4IDEyOHYtMTI4aC0xMjh2MTI4aDEyOHogTTE0MDggNjQwdi0zODRoLTM4NHYxMjhoLTEyOHYtMzg0aC0xMjh2NjQwaDM4NHYtMTI4aDEyOHYxMjhoMTI4ek02NDAgMTQwOHYtNjQwaC02NDB2NjQwaDY0MHpNMTQwOCAxNDA4di02NDBoLTY0MHY2NDBoNjQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDJhOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik02MyAwaC02M3YxNDA4aDYzdi0xNDA4ek0xMjYgMWgtMzJ2MTQwN2gzMnYtMTQwN3pNMjIwIDFoLTMxdjE0MDdoMzF2LTE0MDd6TTM3NyAxaC0zMXYxNDA3aDMxdi0xNDA3ek01MzQgMWgtNjJ2MTQwN2g2MnYtMTQwN3pNNjYwIDFoLTMxdjE0MDdoMzF2LTE0MDd6TTcyMyAxaC0zMXYxNDA3aDMxdi0xNDA3ek03ODYgMWgtMzF2MTQwN2gzMXYtMTQwN3pNOTQzIDFoLTYzdjE0MDdoNjN2LTE0MDd6TTExMDAgMWgtNjN2MTQwN2g2M3YtMTQwN3ogTTEyMjYgMWgtNjN2MTQwN2g2M3YtMTQwN3pNMTM1MiAxaC02M3YxNDA3aDYzdi0xNDA3ek0xNDQ2IDFoLTYzdjE0MDdoNjN2LTE0MDd6TTE2MzUgMWgtOTR2MTQwN2g5NHYtMTQwN3pNMTY5OCAxaC0zMnYxNDA3aDMydi0xNDA3ek0xNzkyIDBoLTYzdjE0MDhoNjN2LTE0MDh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMmI7IiBkPSJNNDQ4IDEwODhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE1MTUgNTEycTAgLTUzIC0zNyAtOTBsLTQ5MSAtNDkycS0zOSAtMzcgLTkxIC0zN3EtNTMgMCAtOTAgMzdsLTcxNSA3MTZxLTM4IDM3IC02NC41IDEwMXQtMjYuNSAxMTd2NDE2cTAgNTIgMzggOTB0OTAgMzhoNDE2cTUzIDAgMTE3IC0yNi41dDEwMiAtNjQuNSBsNzE1IC03MTRxMzcgLTM5IDM3IC05MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAyYzsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNNDQ4IDEwODhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE1MTUgNTEycTAgLTUzIC0zNyAtOTBsLTQ5MSAtNDkycS0zOSAtMzcgLTkxIC0zN3EtNTMgMCAtOTAgMzdsLTcxNSA3MTZxLTM4IDM3IC02NC41IDEwMXQtMjYuNSAxMTd2NDE2cTAgNTIgMzggOTB0OTAgMzhoNDE2cTUzIDAgMTE3IC0yNi41dDEwMiAtNjQuNSBsNzE1IC03MTRxMzcgLTM5IDM3IC05MXpNMTg5OSA1MTJxMCAtNTMgLTM3IC05MGwtNDkxIC00OTJxLTM5IC0zNyAtOTEgLTM3cS0zNiAwIC01OSAxNHQtNTMgNDVsNDcwIDQ3MHEzNyAzNyAzNyA5MHEwIDUyIC0zNyA5MWwtNzE1IDcxNHEtMzggMzggLTEwMiA2NC41dC0xMTcgMjYuNWgyMjRxNTMgMCAxMTcgLTI2LjV0MTAyIC02NC41bDcxNSAtNzE0cTM3IC0zOSAzNyAtOTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwMmQ7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE2MzkgMTA1OHE0MCAtNTcgMTggLTEyOWwtMjc1IC05MDZxLTE5IC02NCAtNzYuNSAtMTA3LjV0LTEyMi41IC00My41aC05MjNxLTc3IDAgLTE0OC41IDUzLjV0LTk5LjUgMTMxLjVxLTI0IDY3IC0yIDEyN3EwIDQgMyAyN3Q0IDM3cTEgOCAtMyAyMS41dC0zIDE5LjVxMiAxMSA4IDIxdDE2LjUgMjMuNXQxNi41IDIzLjVxMjMgMzggNDUgOTEuNXQzMCA5MS41cTMgMTAgMC41IDMwdC0wLjUgMjhxMyAxMSAxNyAyOHQxNyAyMyBxMjEgMzYgNDIgOTJ0MjUgOTBxMSA5IC0yLjUgMzJ0MC41IDI4cTQgMTMgMjIgMzAuNXQyMiAyMi41cTE5IDI2IDQyLjUgODQuNXQyNy41IDk2LjVxMSA4IC0zIDI1LjV0LTIgMjYuNXEyIDggOSAxOHQxOCAyM3QxNyAyMXE4IDEyIDE2LjUgMzAuNXQxNSAzNXQxNiAzNnQxOS41IDMydDI2LjUgMjMuNXQzNiAxMS41dDQ3LjUgLTUuNWwtMSAtM3EzOCA5IDUxIDloNzYxcTc0IDAgMTE0IC01NnQxOCAtMTMwbC0yNzQgLTkwNiBxLTM2IC0xMTkgLTcxLjUgLTE1My41dC0xMjguNSAtMzQuNWgtODY5cS0yNyAwIC0zOCAtMTVxLTExIC0xNiAtMSAtNDNxMjQgLTcwIDE0NCAtNzBoOTIzcTI5IDAgNTYgMTUuNXQzNSA0MS41bDMwMCA5ODdxNyAyMiA1IDU3cTM4IC0xNSA1OSAtNDN6TTU3NSAxMDU2cS00IC0xMyAyIC0yMi41dDIwIC05LjVoNjA4cTEzIDAgMjUuNSA5LjV0MTYuNSAyMi41bDIxIDY0cTQgMTMgLTIgMjIuNXQtMjAgOS41aC02MDhxLTEzIDAgLTI1LjUgLTkuNSB0LTE2LjUgLTIyLjV6TTQ5MiA4MDBxLTQgLTEzIDIgLTIyLjV0MjAgLTkuNWg2MDhxMTMgMCAyNS41IDkuNXQxNi41IDIyLjVsMjEgNjRxNCAxMyAtMiAyMi41dC0yMCA5LjVoLTYwOHEtMTMgMCAtMjUuNSAtOS41dC0xNi41IC0yMi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDJlOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMTY0IDE0MDhxMjMgMCA0NCAtOXEzMyAtMTMgNTIuNSAtNDF0MTkuNSAtNjJ2LTEyODlxMCAtMzQgLTE5LjUgLTYydC01Mi41IC00MXEtMTkgLTggLTQ0IC04cS00OCAwIC04MyAzMmwtNDQxIDQyNGwtNDQxIC00MjRxLTM2IC0zMyAtODMgLTMzcS0yMyAwIC00NCA5cS0zMyAxMyAtNTIuNSA0MXQtMTkuNSA2MnYxMjg5cTAgMzQgMTkuNSA2MnQ1Mi41IDQxcTIxIDkgNDQgOWgxMDQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDJmOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0zODQgMGg4OTZ2MjU2aC04OTZ2LTI1NnpNMzg0IDY0MGg4OTZ2Mzg0aC0xNjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjBoLTY0MHYtNjQwek0xNTM2IDU3NnEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE2NjQgNTc2di00MTZxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0yMjR2LTE2MHEwIC00MCAtMjggLTY4dC02OCAtMjhoLTk2MHEtNDAgMCAtNjggMjh0LTI4IDY4IHYxNjBoLTIyNHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djQxNnEwIDc5IDU2LjUgMTM1LjV0MTM1LjUgNTYuNWg2NHY1NDRxMCA0MCAyOCA2OHQ2OCAyOGg2NzJxNDAgMCA4OCAtMjB0NzYgLTQ4bDE1MiAtMTUycTI4IC0yOCA0OCAtNzZ0MjAgLTg4di0yNTZoNjRxNzkgMCAxMzUuNSAtNTYuNXQ1Ni41IC0xMzUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzMDsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNOTYwIDg2NHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXQtODQuNSAtMjAzLjV0LTIwMy41IC04NC41dC0yMDMuNSA4NC41dC04NC41IDIwMy41dDg0LjUgMjAzLjV0MjAzLjUgODQuNXpNMTY2NCAxMjgwcTEwNiAwIDE4MSAtNzV0NzUgLTE4MXYtODk2cTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NWgtMTQwOHEtMTA2IDAgLTE4MSA3NXQtNzUgMTgxdjg5NnEwIDEwNiA3NSAxODF0MTgxIDc1aDIyNGw1MSAxMzYgcTE5IDQ5IDY5LjUgODQuNXQxMDMuNSAzNS41aDUxMnE1MyAwIDEwMy41IC0zNS41dDY5LjUgLTg0LjVsNTEgLTEzNmgyMjR6TTk2MCAxMjhxMTg1IDAgMzE2LjUgMTMxLjV0MTMxLjUgMzE2LjV0LTEzMS41IDMxNi41dC0zMTYuNSAxMzEuNXQtMzE2LjUgLTEzMS41dC0xMzEuNSAtMzE2LjV0MTMxLjUgLTMxNi41dDMxNi41IC0xMzEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzMTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNzI1IDk3N2wtMTcwIC00NTBxMzMgMCAxMzYuNSAtMnQxNjAuNSAtMnExOSAwIDU3IDJxLTg3IDI1MyAtMTg0IDQ1MnpNMCAtMTI4bDIgNzlxMjMgNyA1NiAxMi41dDU3IDEwLjV0NDkuNSAxNC41dDQ0LjUgMjl0MzEgNTAuNWwyMzcgNjE2bDI4MCA3MjRoNzVoNTNxOCAtMTQgMTEgLTIxbDIwNSAtNDgwcTMzIC03OCAxMDYgLTI1Ny41dDExNCAtMjc0LjVxMTUgLTM0IDU4IC0xNDQuNXQ3MiAtMTY4LjVxMjAgLTQ1IDM1IC01NyBxMTkgLTE1IDg4IC0yOS41dDg0IC0yMC41cTYgLTM4IDYgLTU3cTAgLTQgLTAuNSAtMTN0LTAuNSAtMTNxLTYzIDAgLTE5MCA4dC0xOTEgOHEtNzYgMCAtMjE1IC03dC0xNzggLThxMCA0MyA0IDc4bDEzMSAyOHExIDAgMTIuNSAyLjV0MTUuNSAzLjV0MTQuNSA0LjV0MTUgNi41dDExIDh0OSAxMXQyLjUgMTRxMCAxNiAtMzEgOTYuNXQtNzIgMTc3LjV0LTQyIDEwMGwtNDUwIDJxLTI2IC01OCAtNzYuNSAtMTk1LjV0LTUwLjUgLTE2Mi41IHEwIC0yMiAxNCAtMzcuNXQ0My41IC0yNC41dDQ4LjUgLTEzLjV0NTcgLTguNXQ0MSAtNHExIC0xOSAxIC01OHEwIC05IC0yIC0yN3EtNTggMCAtMTc0LjUgMTB0LTE3NC41IDEwcS04IDAgLTI2LjUgLTR0LTIxLjUgLTRxLTgwIC0xNCAtMTg4IC0xNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzMjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNNTU1IDE1cTc0IC0zMiAxNDAgLTMycTM3NiAwIDM3NiAzMzVxMCAxMTQgLTQxIDE4MHEtMjcgNDQgLTYxLjUgNzR0LTY3LjUgNDYuNXQtODAuNSAyNXQtODQgMTAuNXQtOTQuNSAycS03MyAwIC0xMDEgLTEwcTAgLTUzIC0wLjUgLTE1OXQtMC41IC0xNThxMCAtOCAtMSAtNjcuNXQtMC41IC05Ni41dDQuNSAtODMuNXQxMiAtNjYuNXpNNTQxIDc2MXE0MiAtNyAxMDkgLTdxODIgMCAxNDMgMTN0MTEwIDQ0LjV0NzQuNSA4OS41dDI1LjUgMTQyIHEwIDcwIC0yOSAxMjIuNXQtNzkgODJ0LTEwOCA0My41dC0xMjQgMTRxLTUwIDAgLTEzMCAtMTNxMCAtNTAgNCAtMTUxdDQgLTE1MnEwIC0yNyAtMC41IC04MHQtMC41IC03OXEwIC00NiAxIC02OXpNMCAtMTI4bDIgOTRxMTUgNCA4NSAxNnQxMDYgMjdxNyAxMiAxMi41IDI3dDguNSAzMy41dDUuNSAzMi41dDMgMzcuNXQwLjUgMzR2MzUuNXYzMHEwIDk4MiAtMjIgMTAyNXEtNCA4IC0yMiAxNC41dC00NC41IDExdC00OS41IDd0LTQ4LjUgNC41IHQtMzAuNSAzbC00IDgzcTk4IDIgMzQwIDExLjV0MzczIDkuNXEyMyAwIDY4LjUgLTAuNXQ2Ny41IC0wLjVxNzAgMCAxMzYuNSAtMTN0MTI4LjUgLTQydDEwOCAtNzF0NzQgLTEwNC41dDI4IC0xMzcuNXEwIC01MiAtMTYuNSAtOTUuNXQtMzkgLTcydC02NC41IC01Ny41dC03MyAtNDV0LTg0IC00MHExNTQgLTM1IDI1Ni41IC0xMzR0MTAyLjUgLTI0OHEwIC0xMDAgLTM1IC0xNzkuNXQtOTMuNSAtMTMwLjV0LTEzOCAtODUuNXQtMTYzLjUgLTQ4LjUgdC0xNzYgLTE0cS00NCAwIC0xMzIgM3QtMTMyIDNxLTEwNiAwIC0zMDcgLTExdC0yMzEgLTEyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDMzOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik0wIC0xMjZsMTcgODVxNiAyIDgxLjUgMjEuNXQxMTEuNSAzNy41cTI4IDM1IDQxIDEwMXExIDcgNjIgMjg5dDExNCA1NDMuNXQ1MiAyOTYuNXYyNXEtMjQgMTMgLTU0LjUgMTguNXQtNjkuNSA4dC01OCA1LjVsMTkgMTAzcTMzIC0yIDEyMCAtNi41dDE0OS41IC03dDEyMC41IC0yLjVxNDggMCA5OC41IDIuNXQxMjEgN3Q5OC41IDYuNXEtNSAtMzkgLTE5IC04OXEtMzAgLTEwIC0xMDEuNSAtMjguNXQtMTA4LjUgLTMzLjUgcS04IC0xOSAtMTQgLTQyLjV0LTkgLTQwdC03LjUgLTQ1LjV0LTYuNSAtNDJxLTI3IC0xNDggLTg3LjUgLTQxOS41dC03Ny41IC0zNTUuNXEtMiAtOSAtMTMgLTU4dC0yMCAtOTB0LTE2IC04My41dC02IC01Ny41bDEgLTE4cTE3IC00IDE4NSAtMzFxLTMgLTQ0IC0xNiAtOTlxLTExIDAgLTMyLjUgLTEuNXQtMzIuNSAtMS41cS0yOSAwIC04NyAxMHQtODYgMTBxLTEzOCAyIC0yMDYgMnEtNTEgMCAtMTQzIC05dC0xMjEgLTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDM0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzQ0IDEyOHEzMyAwIDQyIC0xOC41dC0xMSAtNDQuNWwtMTI2IC0xNjJxLTIwIC0yNiAtNDkgLTI2dC00OSAyNmwtMTI2IDE2MnEtMjAgMjYgLTExIDQ0LjV0NDIgMTguNWg4MHYxMDI0aC04MHEtMzMgMCAtNDIgMTguNXQxMSA0NC41bDEyNiAxNjJxMjAgMjYgNDkgMjZ0NDkgLTI2bDEyNiAtMTYycTIwIC0yNiAxMSAtNDQuNXQtNDIgLTE4LjVoLTgwdi0xMDI0aDgwek04MSAxNDA3bDU0IC0yN3ExMiAtNSAyMTEgLTVxNDQgMCAxMzIgMiB0MTMyIDJxMzYgMCAxMDcuNSAtMC41dDEwNy41IC0wLjVoMjkzcTYgMCAyMSAtMC41dDIwLjUgMHQxNiAzdDE3LjUgOXQxNSAxNy41bDQyIDFxNCAwIDE0IC0wLjV0MTQgLTAuNXEyIC0xMTIgMiAtMzM2cTAgLTgwIC01IC0xMDlxLTM5IC0xNCAtNjggLTE4cS0yNSA0NCAtNTQgMTI4cS0zIDkgLTExIDQ4dC0xNC41IDczLjV0LTcuNSAzNS41cS02IDggLTEyIDEyLjV0LTE1LjUgNnQtMTMgMi41dC0xOCAwLjV0LTE2LjUgLTAuNSBxLTE3IDAgLTY2LjUgMC41dC03NC41IDAuNXQtNjQgLTJ0LTcxIC02cS05IC04MSAtOCAtMTM2cTAgLTk0IDIgLTM4OHQyIC00NTVxMCAtMTYgLTIuNSAtNzEuNXQwIC05MS41dDEyLjUgLTY5cTQwIC0yMSAxMjQgLTQyLjV0MTIwIC0zNy41cTUgLTQwIDUgLTUwcTAgLTE0IC0zIC0yOWwtMzQgLTFxLTc2IC0yIC0yMTggOHQtMjA3IDEwcS01MCAwIC0xNTEgLTl0LTE1MiAtOXEtMyA1MSAtMyA1MnY5cTE3IDI3IDYxLjUgNDN0OTguNSAyOXQ3OCAyNyBxMTkgNDIgMTkgMzgzcTAgMTAxIC0zIDMwM3QtMyAzMDN2MTE3cTAgMiAwLjUgMTUuNXQwLjUgMjV0LTEgMjUuNXQtMyAyNHQtNSAxNHEtMTEgMTIgLTE2MiAxMnEtMzMgMCAtOTMgLTEydC04MCAtMjZxLTE5IC0xMyAtMzQgLTcyLjV0LTMxLjUgLTExMXQtNDIuNSAtNTMuNXEtNDIgMjYgLTU2IDQ0djM4M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzNTsiIGQ9Ik04MSAxNDA3bDU0IC0yN3ExMiAtNSAyMTEgLTVxNDQgMCAxMzIgMnQxMzIgMnE3MCAwIDI0Ni41IDF0MzA0LjUgMC41dDI0NyAtNC41cTMzIC0xIDU2IDMxbDQyIDFxNCAwIDE0IC0wLjV0MTQgLTAuNXEyIC0xMTIgMiAtMzM2cTAgLTgwIC01IC0xMDlxLTM5IC0xNCAtNjggLTE4cS0yNSA0NCAtNTQgMTI4cS0zIDkgLTExIDQ3LjV0LTE1IDczLjV0LTcgMzZxLTEwIDEzIC0yNyAxOXEtNSAyIC02NiAycS0zMCAwIC05MyAxdC0xMDMgMSB0LTk0IC0ydC05NiAtN3EtOSAtODEgLTggLTEzNmwxIC0xNTJ2NTJxMCAtNTUgMSAtMTU0dDEuNSAtMTgwdDAuNSAtMTUzcTAgLTE2IC0yLjUgLTcxLjV0MCAtOTEuNXQxMi41IC02OXE0MCAtMjEgMTI0IC00Mi41dDEyMCAtMzcuNXE1IC00MCA1IC01MHEwIC0xNCAtMyAtMjlsLTM0IC0xcS03NiAtMiAtMjE4IDh0LTIwNyAxMHEtNTAgMCAtMTUxIC05dC0xNTIgLTlxLTMgNTEgLTMgNTJ2OXExNyAyNyA2MS41IDQzdDk4LjUgMjl0NzggMjcgcTcgMTYgMTEuNSA3NHQ2IDE0NS41dDEuNSAxNTV0LTAuNSAxNTMuNXQtMC41IDg5cTAgNyAtMi41IDIxLjV0LTIuNSAyMi41cTAgNyAwLjUgNDR0MSA3M3QwIDc2LjV0LTMgNjcuNXQtNi41IDMycS0xMSAxMiAtMTYyIDEycS00MSAwIC0xNjMgLTEzLjV0LTEzOCAtMjQuNXEtMTkgLTEyIC0zNCAtNzEuNXQtMzEuNSAtMTExLjV0LTQyLjUgLTU0cS00MiAyNiAtNTYgNDR2Mzgzek0xMzEwIDEyNXExMiAwIDQyIC0xOS41dDU3LjUgLTQxLjUgdDU5LjUgLTQ5dDM2IC0zMHEyNiAtMjEgMjYgLTQ5dC0yNiAtNDlxLTQgLTMgLTM2IC0zMHQtNTkuNSAtNDl0LTU3LjUgLTQxLjV0LTQyIC0xOS41cS0xMyAwIC0yMC41IDEwLjV0LTEwIDI4LjV0LTIuNSAzMy41dDEuNSAzM3QxLjUgMTkuNWgtMTAyNHEwIC0yIDEuNSAtMTkuNXQxLjUgLTMzdC0yLjUgLTMzLjV0LTEwIC0yOC41dC0yMC41IC0xMC41cS0xMiAwIC00MiAxOS41dC01Ny41IDQxLjV0LTU5LjUgNDl0LTM2IDMwcS0yNiAyMSAtMjYgNDkgdDI2IDQ5cTQgMyAzNiAzMHQ1OS41IDQ5dDU3LjUgNDEuNXQ0MiAxOS41cTEzIDAgMjAuNSAtMTAuNXQxMCAtMjguNXQyLjUgLTMzLjV0LTEuNSAtMzN0LTEuNSAtMTkuNWgxMDI0cTAgMiAtMS41IDE5LjV0LTEuNSAzM3QyLjUgMzMuNXQxMCAyOC41dDIwLjUgMTAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzNjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiAxOTJ2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE2NjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxNjY0cTI2IDAgNDUgLTE5dDE5IC00NXpNMTQwOCA1NzZ2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEyODBxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxMjgwcTI2IDAgNDUgLTE5dDE5IC00NXpNMTY2NCA5NjB2LTEyOHEwIC0yNiAtMTkgLTQ1IHQtNDUgLTE5aC0xNTM2cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMTUzNnEyNiAwIDQ1IC0xOXQxOSAtNDV6TTEyODAgMTM0NHYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTE1MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDExNTJxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDM3OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDE5MnYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTY2NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDE2NjRxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xNDA4IDU3NnYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtODk2cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloODk2cTI2IDAgNDUgLTE5dDE5IC00NXpNMTY2NCA5NjB2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTkgaC0xNDA4cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMTQwOHEyNiAwIDQ1IC0xOXQxOSAtNDV6TTEyODAgMTM0NHYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtNjQwcS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloNjQwcTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjAzODsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiAxOTJ2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE2NjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxNjY0cTI2IDAgNDUgLTE5dDE5IC00NXpNMTc5MiA1NzZ2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEyODBxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxMjgwcTI2IDAgNDUgLTE5dDE5IC00NXpNMTc5MiA5NjB2LTEyOHEwIC0yNiAtMTkgLTQ1IHQtNDUgLTE5aC0xNTM2cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMTUzNnEyNiAwIDQ1IC0xOXQxOSAtNDV6TTE3OTIgMTM0NHYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTE1MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDExNTJxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDM5OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDE5MnYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTY2NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDE2NjRxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xNzkyIDU3NnYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTY2NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDE2NjRxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xNzkyIDk2MHYtMTI4cTAgLTI2IC0xOSAtNDUgdC00NSAtMTloLTE2NjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxNjY0cTI2IDAgNDUgLTE5dDE5IC00NXpNMTc5MiAxMzQ0di0xMjhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNjY0cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMTY2NHEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwM2E7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTI1NiAyMjR2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTE5MnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE5MnExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTI1NiA2MDh2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTE5MnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE5MnExMyAwIDIyLjUgLTkuNSB0OS41IC0yMi41ek0yNTYgOTkydi0xOTJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0xOTJxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxOTJxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNzkyIDIyNHYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTM0NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDEzNDQgcTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMjU2IDEzNzZ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTE5MnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE5MnExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTE3OTIgNjA4di0xOTJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0xMzQ0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTkycTAgMTMgOS41IDIyLjUgdDIyLjUgOS41aDEzNDRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNzkyIDk5MnYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTM0NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDEzNDRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNzkyIDEzNzZ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEzNDRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTIgcTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoMTM0NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwM2I7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTM4NCA5OTJ2LTU3NnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVxLTE0IDAgLTIzIDlsLTI4OCAyODhxLTkgOSAtOSAyM3Q5IDIzbDI4OCAyODhxOSA5IDIzIDlxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNzkyIDIyNHYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTcyOHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE3MjhxMTMgMCAyMi41IC05LjUgdDkuNSAtMjIuNXpNMTc5MiA2MDh2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEwODhxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMDg4cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMTc5MiA5OTJ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEwODhxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMDg4IHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTE3OTIgMTM3NnYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTcyOHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE3MjhxMTMgMCAyMi41IC05LjV0OS41IC0yMi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDNjOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0zNTIgNzA0cTAgLTE0IC05IC0yM2wtMjg4IC0yODhxLTkgLTkgLTIzIC05cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NTc2cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVxMTQgMCAyMyAtOWwyODggLTI4OHE5IC05IDkgLTIzek0xNzkyIDIyNHYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTcyOHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE3MjhxMTMgMCAyMi41IC05LjUgdDkuNSAtMjIuNXpNMTc5MiA2MDh2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEwODhxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMDg4cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMTc5MiA5OTJ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEwODhxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMDg4IHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTE3OTIgMTM3NnYtMTkycTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtMTcyOHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDE3MjhxMTMgMCAyMi41IC05LjV0OS41IC0yMi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDNkOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDExODR2LTEwODhxMCAtNDIgLTM5IC01OXEtMTMgLTUgLTI1IC01cS0yNyAwIC00NSAxOWwtNDAzIDQwM3YtMTY2cTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC03MDRxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djcwNHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoNzA0cTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41di0xNjVsNDAzIDQwMnExOCAxOSA0NSAxOXExMiAwIDI1IC01IHEzOSAtMTcgMzkgLTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDNlOyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik02NDAgOTYwcTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMTY2NCA1NzZ2LTQ0OGgtMTQwOHYxOTJsMzIwIDMyMGwxNjAgLTE2MGw1MTIgNTEyek0xNzYwIDEyODBoLTE2MDBxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di0xMjE2cTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTYwMHExMyAwIDIyLjUgOS41dDkuNSAyMi41djEyMTYgcTAgMTMgLTkuNSAyMi41dC0yMi41IDkuNXpNMTkyMCAxMjQ4di0xMjE2cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xNjAwcS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMjE2cTAgNjYgNDcgMTEzdDExMyA0N2gxNjAwcTY2IDAgMTEzIC00N3Q0NyAtMTEzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDQwOyIgZD0iTTM2MyAwbDkxIDkxbC0yMzUgMjM1bC05MSAtOTF2LTEwN2gxMjh2LTEyOGgxMDd6TTg4NiA5MjhxMCAyMiAtMjIgMjJxLTEwIDAgLTE3IC03bC01NDIgLTU0MnEtNyAtNyAtNyAtMTdxMCAtMjIgMjIgLTIycTEwIDAgMTcgN2w1NDIgNTQycTcgNyA3IDE3ek04MzIgMTEyMGw0MTYgLTQxNmwtODMyIC04MzJoLTQxNnY0MTZ6TTE1MTUgMTAyNHEwIC01MyAtMzcgLTkwbC0xNjYgLTE2NmwtNDE2IDQxNmwxNjYgMTY1cTM2IDM4IDkwIDM4IHE1MyAwIDkxIC0zOGwyMzUgLTIzNHEzNyAtMzkgMzcgLTkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDQxOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik03NjggODk2cTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXQ3NSAtMTgxdDE4MSAtNzV0MTgxIDc1dDc1IDE4MXpNMTAyNCA4OTZxMCAtMTA5IC0zMyAtMTc5bC0zNjQgLTc3NHEtMTYgLTMzIC00Ny41IC01MnQtNjcuNSAtMTl0LTY3LjUgMTl0LTQ2LjUgNTJsLTM2NSA3NzRxLTMzIDcwIC0zMyAxNzlxMCAyMTIgMTUwIDM2MnQzNjIgMTUwdDM2MiAtMTUwdDE1MCAtMzYyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDQyOyIgZD0iTTc2OCA5NnYxMDg4cS0xNDggMCAtMjczIC03M3QtMTk4IC0xOTh0LTczIC0yNzN0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA0MzsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNNTEyIDM4NHEwIDM2IC0yMCA2OXEtMSAxIC0xNS41IDIyLjV0LTI1LjUgMzh0LTI1IDQ0dC0yMSA1MC41cS00IDE2IC0yMSAxNnQtMjEgLTE2cS03IC0yMyAtMjEgLTUwLjV0LTI1IC00NHQtMjUuNSAtMzh0LTE1LjUgLTIyLjVxLTIwIC0zMyAtMjAgLTY5cTAgLTUzIDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek0xMDI0IDUxMnEwIC0yMTIgLTE1MCAtMzYydC0zNjIgLTE1MHQtMzYyIDE1MHQtMTUwIDM2MiBxMCAxNDUgODEgMjc1cTYgOSA2Mi41IDkwLjV0MTAxIDE1MXQ5OS41IDE3OHQ4MyAyMDEuNXE5IDMwIDM0IDQ3dDUxIDE3dDUxLjUgLTE3dDMzLjUgLTQ3cTI4IC05MyA4MyAtMjAxLjV0OTkuNSAtMTc4dDEwMSAtMTUxdDYyLjUgLTkwLjVxODEgLTEyNyA4MSAtMjc1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDQ0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04ODggMzUybDExNiAxMTZsLTE1MiAxNTJsLTExNiAtMTE2di01Nmg5NnYtOTZoNTZ6TTEzMjggMTA3MnEtMTYgMTYgLTMzIC0xbC0zNTAgLTM1MHEtMTcgLTE3IC0xIC0zM3QzMyAxbDM1MCAzNTBxMTcgMTcgMSAzM3pNMTQwOCA0Nzh2LTE5MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtODMycS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY4MzJxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDgzMiBxNjMgMCAxMTcgLTI1cTE1IC03IDE4IC0yM3EzIC0xNyAtOSAtMjlsLTQ5IC00OXEtMTQgLTE0IC0zMiAtOHEtMjMgNiAtNDUgNmgtODMycS02NiAwIC0xMTMgLTQ3dC00NyAtMTEzdi04MzJxMCAtNjYgNDcgLTExM3QxMTMgLTQ3aDgzMnE2NiAwIDExMyA0N3Q0NyAxMTN2MTI2cTAgMTMgOSAyMmw2NCA2NHExNSAxNSAzNSA3dDIwIC0yOXpNMTMxMiAxMjE2bDI4OCAtMjg4bC02NzIgLTY3MmgtMjg4djI4OHpNMTc1NiAxMDg0bC05MiAtOTIgbC0yODggMjg4bDkyIDkycTI4IDI4IDY4IDI4dDY4IC0yOGwxNTIgLTE1MnEyOCAtMjggMjggLTY4dC0yOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNDU7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE0MDggNTQ3di0yNTlxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTgzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2ODMycTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWgyNTV2MHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjVxMCAtMjcgLTI2IC0zMnEtNzcgLTI2IC0xMzMgLTYwcS0xMCAtNCAtMTYgLTRoLTExMnEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3YtODMycTAgLTY2IDQ3IC0xMTN0MTEzIC00N2g4MzIgcTY2IDAgMTEzIDQ3dDQ3IDExM3YyMTRxMCAxOSAxOCAyOXEyOCAxMyA1NCAzN3ExNiAxNiAzNSA4cTIxIC05IDIxIC0yOXpNMTY0NSAxMDQzbC0zODQgLTM4NHEtMTggLTE5IC00NSAtMTlxLTEyIDAgLTI1IDVxLTM5IDE3IC0zOSA1OXYxOTJoLTE2MHEtMzIzIDAgLTQzOCAtMTMxcS0xMTkgLTEzNyAtNzQgLTQ3M3EzIC0yMyAtMjAgLTM0cS04IC0yIC0xMiAtMnEtMTYgMCAtMjYgMTNxLTEwIDE0IC0yMSAzMXQtMzkuNSA2OC41dC00OS41IDk5LjUgdC0zOC41IDExNHQtMTcuNSAxMjJxMCA0OSAzLjUgOTF0MTQgOTB0MjggODh0NDcgODEuNXQ2OC41IDc0dDk0LjUgNjEuNXQxMjQuNSA0OC41dDE1OS41IDMwLjV0MTk2LjUgMTFoMTYwdjE5MnEwIDQyIDM5IDU5cTEzIDUgMjUgNXEyNiAwIDQ1IC0xOWwzODQgLTM4NHExOSAtMTkgMTkgLTQ1dC0xOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNDY7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE0MDggNjA2di0zMThxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTgzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2ODMycTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg4MzJxNjMgMCAxMTcgLTI1cTE1IC03IDE4IC0yM3EzIC0xNyAtOSAtMjlsLTQ5IC00OXEtMTAgLTEwIC0yMyAtMTBxLTMgMCAtOSAycS0yMyA2IC00NSA2aC04MzJxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTN2LTgzMiBxMCAtNjYgNDcgLTExM3QxMTMgLTQ3aDgzMnE2NiAwIDExMyA0N3Q0NyAxMTN2MjU0cTAgMTMgOSAyMmw2NCA2NHExMCAxMCAyMyAxMHE2IDAgMTIgLTNxMjAgLTggMjAgLTI5ek0xNjM5IDEwOTVsLTgxNCAtODE0cS0yNCAtMjQgLTU3IC0yNHQtNTcgMjRsLTQzMCA0MzBxLTI0IDI0IC0yNCA1N3QyNCA1N2wxMTAgMTEwcTI0IDI0IDU3IDI0dDU3IC0yNGwyNjMgLTI2M2w2NDcgNjQ3cTI0IDI0IDU3IDI0dDU3IC0yNGwxMTAgLTExMCBxMjQgLTI0IDI0IC01N3QtMjQgLTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDQ3OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDY0MHEwIC0yNiAtMTkgLTQ1bC0yNTYgLTI1NnEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5dC0xOSA0NXYxMjhoLTM4NHYtMzg0aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV0LTE5IC00NWwtMjU2IC0yNTZxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtMjU2IDI1NnEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5aDEyOHYzODRoLTM4NHYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTlsLTI1NiAyNTZxLTE5IDE5IC0xOSA0NSB0MTkgNDVsMjU2IDI1NnExOSAxOSA0NSAxOXQ0NSAtMTl0MTkgLTQ1di0xMjhoMzg0djM4NGgtMTI4cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDVsMjU2IDI1NnExOSAxOSA0NSAxOXQ0NSAtMTlsMjU2IC0yNTZxMTkgLTE5IDE5IC00NXQtMTkgLTQ1dC00NSAtMTloLTEyOHYtMzg0aDM4NHYxMjhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsMjU2IC0yNTZxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA0ODsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNOTc5IDEzOTVxMTkgMTkgMzIgMTN0MTMgLTMydi0xNDcycTAgLTI2IC0xMyAtMzJ0LTMyIDEzbC03MTAgNzEwcS05IDkgLTEzIDE5di02NzhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxNDA4cTAgMjYgMTkgNDV0NDUgMTloMTI4cTI2IDAgNDUgLTE5dDE5IC00NXYtNjc4cTQgMTEgMTMgMTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNDk7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE3NDcgMTM5NXExOSAxOSAzMiAxM3QxMyAtMzJ2LTE0NzJxMCAtMjYgLTEzIC0zMnQtMzIgMTNsLTcxMCA3MTBxLTkgOSAtMTMgMTl2LTcxMHEwIC0yNiAtMTMgLTMydC0zMiAxM2wtNzEwIDcxMHEtOSA5IC0xMyAxOXYtNjc4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTI4cS0yNiAwIC00NSAxOXQtMTkgNDV2MTQwOHEwIDI2IDE5IDQ1dDQ1IDE5aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTY3OHE0IDExIDEzIDE5bDcxMCA3MTAgcTE5IDE5IDMyIDEzdDEzIC0zMnYtNzEwcTQgMTEgMTMgMTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNGE7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE2MTkgMTM5NXExOSAxOSAzMiAxM3QxMyAtMzJ2LTE0NzJxMCAtMjYgLTEzIC0zMnQtMzIgMTNsLTcxMCA3MTBxLTggOSAtMTMgMTl2LTcxMHEwIC0yNiAtMTMgLTMydC0zMiAxM2wtNzEwIDcxMHEtMTkgMTkgLTE5IDQ1dDE5IDQ1bDcxMCA3MTBxMTkgMTkgMzIgMTN0MTMgLTMydi03MTBxNSAxMSAxMyAxOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA0YjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTM4NCA2MDlsLTEzMjggLTczOHEtMjMgLTEzIC0zOS41IC0zdC0xNi41IDM2djE0NzJxMCAyNiAxNi41IDM2dDM5LjUgLTNsMTMyOCAtNzM4cTIzIC0xMyAyMyAtMzF0LTIzIC0zMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA0YzsiIGQ9Ik0xNTM2IDEzNDR2LTE0MDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC01MTJxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxNDA4cTAgMjYgMTkgNDV0NDUgMTloNTEycTI2IDAgNDUgLTE5dDE5IC00NXpNNjQwIDEzNDR2LTE0MDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC01MTJxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxNDA4cTAgMjYgMTkgNDV0NDUgMTloNTEycTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA0ZDsiIGQ9Ik0xNTM2IDEzNDR2LTE0MDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNDA4cS0yNiAwIC00NSAxOXQtMTkgNDV2MTQwOHEwIDI2IDE5IDQ1dDQ1IDE5aDE0MDhxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDRlOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik00NSAtMTE1cS0xOSAtMTkgLTMyIC0xM3QtMTMgMzJ2MTQ3MnEwIDI2IDEzIDMydDMyIC0xM2w3MTAgLTcxMHE4IC04IDEzIC0xOXY3MTBxMCAyNiAxMyAzMnQzMiAtMTNsNzEwIC03MTBxMTkgLTE5IDE5IC00NXQtMTkgLTQ1bC03MTAgLTcxMHEtMTkgLTE5IC0zMiAtMTN0LTEzIDMydjcxMHEtNSAtMTAgLTEzIC0xOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1MDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNDUgLTExNXEtMTkgLTE5IC0zMiAtMTN0LTEzIDMydjE0NzJxMCAyNiAxMyAzMnQzMiAtMTNsNzEwIC03MTBxOCAtOCAxMyAtMTl2NzEwcTAgMjYgMTMgMzJ0MzIgLTEzbDcxMCAtNzEwcTggLTggMTMgLTE5djY3OHEwIDI2IDE5IDQ1dDQ1IDE5aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTE0MDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXY2NzhxLTUgLTEwIC0xMyAtMTlsLTcxMCAtNzEwIHEtMTkgLTE5IC0zMiAtMTN0LTEzIDMydjcxMHEtNSAtMTAgLTEzIC0xOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1MTsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNNDUgLTExNXEtMTkgLTE5IC0zMiAtMTN0LTEzIDMydjE0NzJxMCAyNiAxMyAzMnQzMiAtMTNsNzEwIC03MTBxOCAtOCAxMyAtMTl2Njc4cTAgMjYgMTkgNDV0NDUgMTloMTI4cTI2IDAgNDUgLTE5dDE5IC00NXYtMTQwOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEyOHEtMjYgMCAtNDUgMTl0LTE5IDQ1djY3OHEtNSAtMTAgLTEzIC0xOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1MjsiIGhvcml6LWFkdi14PSIxNTM4IiBkPSJNMTQgNTU3bDcxMCA3MTBxMTkgMTkgNDUgMTl0NDUgLTE5bDcxMCAtNzEwcTE5IC0xOSAxMyAtMzJ0LTMyIC0xM2gtMTQ3MnEtMjYgMCAtMzIgMTN0MTMgMzJ6TTE0NzMgMGgtMTQwOHEtMjYgMCAtNDUgMTl0LTE5IDQ1djI1NnEwIDI2IDE5IDQ1dDQ1IDE5aDE0MDhxMjYgMCA0NSAtMTl0MTkgLTQ1di0yNTZxMCAtMjYgLTE5IC00NXQtNDUgLTE5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDUzOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMTcxIDEyMzVsLTUzMSAtNTMxbDUzMSAtNTMxcTE5IC0xOSAxOSAtNDV0LTE5IC00NWwtMTY2IC0xNjZxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtNzQyIDc0MnEtMTkgMTkgLTE5IDQ1dDE5IDQ1bDc0MiA3NDJxMTkgMTkgNDUgMTl0NDUgLTE5bDE2NiAtMTY2cTE5IC0xOSAxOSAtNDV0LTE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1NDsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTEwNyA2NTlsLTc0MiAtNzQycS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTE2NiAxNjZxLTE5IDE5IC0xOSA0NXQxOSA0NWw1MzEgNTMxbC01MzEgNTMxcS0xOSAxOSAtMTkgNDV0MTkgNDVsMTY2IDE2NnExOSAxOSA0NSAxOXQ0NSAtMTlsNzQyIC03NDJxMTkgLTE5IDE5IC00NXQtMTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDU1OyIgZD0iTTEyMTYgNTc2djEyOHEwIDI2IC0xOSA0NXQtNDUgMTloLTI1NnYyNTZxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0yNTZoLTI1NnEtMjYgMCAtNDUgLTE5dC0xOSAtNDV2LTEyOHEwIC0yNiAxOSAtNDV0NDUgLTE5aDI1NnYtMjU2cTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV2MjU2aDI1NnEyNiAwIDQ1IDE5dDE5IDQ1ek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjUgdC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNTY7IiBkPSJNMTIxNiA1NzZ2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtNzY4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloNzY4cTI2IDAgNDUgMTl0MTkgNDV6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNSB0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1NzsiIGQ9Ik0xMTQ5IDQxNHEwIDI2IC0xOSA0NWwtMTgxIDE4MWwxODEgMTgxcTE5IDE5IDE5IDQ1cTAgMjcgLTE5IDQ2bC05MCA5MHEtMTkgMTkgLTQ2IDE5cS0yNiAwIC00NSAtMTlsLTE4MSAtMTgxbC0xODEgMTgxcS0xOSAxOSAtNDUgMTlxLTI3IDAgLTQ2IC0xOWwtOTAgLTkwcS0xOSAtMTkgLTE5IC00NnEwIC0yNiAxOSAtNDVsMTgxIC0xODFsLTE4MSAtMTgxcS0xOSAtMTkgLTE5IC00NXEwIC0yNyAxOSAtNDZsOTAgLTkwcTE5IC0xOSA0NiAtMTkgcTI2IDAgNDUgMTlsMTgxIDE4MWwxODEgLTE4MXExOSAtMTkgNDUgLTE5cTI3IDAgNDYgMTlsOTAgOTBxMTkgMTkgMTkgNDZ6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDU4OyIgZD0iTTEyODQgODAycTAgMjggLTE4IDQ2bC05MSA5MHEtMTkgMTkgLTQ1IDE5dC00NSAtMTlsLTQwOCAtNDA3bC0yMjYgMjI2cS0xOSAxOSAtNDUgMTl0LTQ1IC0xOWwtOTEgLTkwcS0xOCAtMTggLTE4IC00NnEwIC0yNyAxOCAtNDVsMzYyIC0zNjJxMTkgLTE5IDQ1IC0xOXEyNyAwIDQ2IDE5bDU0MyA1NDNxMTggMTggMTggNDV6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDMgdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1OTsiIGQ9Ik04OTYgMTYwdjE5MnEwIDE0IC05IDIzdC0yMyA5aC0xOTJxLTE0IDAgLTIzIC05dC05IC0yM3YtMTkycTAgLTE0IDkgLTIzdDIzIC05aDE5MnExNCAwIDIzIDl0OSAyM3pNMTE1MiA4MzJxMCA4OCAtNTUuNSAxNjN0LTEzOC41IDExNnQtMTcwIDQxcS0yNDMgMCAtMzcxIC0yMTNxLTE1IC0yNCA4IC00MmwxMzIgLTEwMHE3IC02IDE5IC02cTE2IDAgMjUgMTJxNTMgNjggODYgOTJxMzQgMjQgODYgMjRxNDggMCA4NS41IC0yNnQzNy41IC01OSBxMCAtMzggLTIwIC02MXQtNjggLTQ1cS02MyAtMjggLTExNS41IC04Ni41dC01Mi41IC0xMjUuNXYtMzZxMCAtMTQgOSAtMjN0MjMgLTloMTkycTE0IDAgMjMgOXQ5IDIzcTAgMTkgMjEuNSA0OS41dDU0LjUgNDkuNXEzMiAxOCA0OSAyOC41dDQ2IDM1dDQ0LjUgNDh0MjggNjAuNXQxMi41IDgxek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNSB0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNWE7IiBkPSJNMTAyNCAxNjB2MTYwcTAgMTQgLTkgMjN0LTIzIDloLTk2djUxMnEwIDE0IC05IDIzdC0yMyA5aC0zMjBxLTE0IDAgLTIzIC05dC05IC0yM3YtMTYwcTAgLTE0IDkgLTIzdDIzIC05aDk2di0zMjBoLTk2cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTE2MHEwIC0xNCA5IC0yM3QyMyAtOWg0NDhxMTQgMCAyMyA5dDkgMjN6TTg5NiAxMDU2djE2MHEwIDE0IC05IDIzdC0yMyA5aC0xOTJxLTE0IDAgLTIzIC05dC05IC0yM3YtMTYwcTAgLTE0IDkgLTIzIHQyMyAtOWgxOTJxMTQgMCAyMyA5dDkgMjN6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDViOyIgZD0iTTExOTcgNTEyaC0xMDlxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxMDlxLTMyIDEwOCAtMTEyLjUgMTg4LjV0LTE4OC41IDExMi41di0xMDlxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMDlxLTEwOCAtMzIgLTE4OC41IC0xMTIuNXQtMTEyLjUgLTE4OC41aDEwOXEyNiAwIDQ1IC0xOXQxOSAtNDV2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEwOSBxMzIgLTEwOCAxMTIuNSAtMTg4LjV0MTg4LjUgLTExMi41djEwOXEwIDI2IDE5IDQ1dDQ1IDE5aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTEwOXExMDggMzIgMTg4LjUgMTEyLjV0MTEyLjUgMTg4LjV6TTE1MzYgNzA0di0xMjhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNDNxLTM3IC0xNjEgLTE1NC41IC0yNzguNXQtMjc4LjUgLTE1NC41di0xNDNxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxNDMgcS0xNjEgMzcgLTI3OC41IDE1NC41dC0xNTQuNSAyNzguNWgtMTQzcS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMTQzcTM3IDE2MSAxNTQuNSAyNzguNXQyNzguNSAxNTQuNXYxNDNxMCAyNiAxOSA0NXQ0NSAxOWgxMjhxMjYgMCA0NSAtMTl0MTkgLTQ1di0xNDNxMTYxIC0zNyAyNzguNSAtMTU0LjV0MTU0LjUgLTI3OC41aDE0M3EyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNWM7IiBkPSJNMTA5NyA0NTdsLTE0NiAtMTQ2cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTEzNyAxMzdsLTEzNyAtMTM3cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTE0NiAxNDZxLTEwIDEwIC0xMCAyM3QxMCAyM2wxMzcgMTM3bC0xMzcgMTM3cS0xMCAxMCAtMTAgMjN0MTAgMjNsMTQ2IDE0NnExMCAxMCAyMyAxMHQyMyAtMTBsMTM3IC0xMzdsMTM3IDEzN3ExMCAxMCAyMyAxMHQyMyAtMTBsMTQ2IC0xNDZxMTAgLTEwIDEwIC0yM3QtMTAgLTIzIGwtMTM3IC0xMzdsMTM3IC0xMzdxMTAgLTEwIDEwIC0yM3QtMTAgLTIzek0xMzEyIDY0MHEwIDE0OCAtNzMgMjczdC0xOTggMTk4dC0yNzMgNzN0LTI3MyAtNzN0LTE5OCAtMTk4dC03MyAtMjczdDczIC0yNzN0MTk4IC0xOTh0MjczIC03M3QyNzMgNzN0MTk4IDE5OHQ3MyAyNzN6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjUgdDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA1ZDsiIGQ9Ik0xMTcxIDcyM2wtNDIyIC00MjJxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtMjk0IDI5NHEtMTkgMTkgLTE5IDQ1dDE5IDQ1bDEwMiAxMDJxMTkgMTkgNDUgMTl0NDUgLTE5bDE0NyAtMTQ3bDI3NSAyNzVxMTkgMTkgNDUgMTl0NDUgLTE5bDEwMiAtMTAycTE5IC0xOSAxOSAtNDV0LTE5IC00NXpNMTMxMiA2NDBxMCAxNDggLTczIDI3M3QtMTk4IDE5OHQtMjczIDczdC0yNzMgLTczdC0xOTggLTE5OHQtNzMgLTI3M3Q3MyAtMjczdDE5OCAtMTk4IHQyNzMgLTczdDI3MyA3M3QxOTggMTk4dDczIDI3M3pNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNWU7IiBkPSJNMTMxMiA2NDNxMCAxNjEgLTg3IDI5NWwtNzU0IC03NTNxMTM3IC04OSAyOTcgLTg5cTExMSAwIDIxMS41IDQzLjV0MTczLjUgMTE2LjV0MTE2IDE3NC41dDQzIDIxMi41ek0zMTMgMzQ0bDc1NSA3NTRxLTEzNSA5MSAtMzAwIDkxcS0xNDggMCAtMjczIC03M3QtMTk4IC0xOTl0LTczIC0yNzRxMCAtMTYyIDg5IC0yOTl6TTE1MzYgNjQzcTAgLTE1NyAtNjEgLTMwMHQtMTYzLjUgLTI0NnQtMjQ1IC0xNjR0LTI5OC41IC02MXQtMjk4LjUgNjEgdC0yNDUgMTY0dC0xNjMuNSAyNDZ0LTYxIDMwMHQ2MSAyOTkuNXQxNjMuNSAyNDUuNXQyNDUgMTY0dDI5OC41IDYxdDI5OC41IC02MXQyNDUgLTE2NHQxNjMuNSAtMjQ1LjV0NjEgLTI5OS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDYwOyIgZD0iTTE1MzYgNjQwdi0xMjhxMCAtNTMgLTMyLjUgLTkwLjV0LTg0LjUgLTM3LjVoLTcwNGwyOTMgLTI5NHEzOCAtMzYgMzggLTkwdC0zOCAtOTBsLTc1IC03NnEtMzcgLTM3IC05MCAtMzdxLTUyIDAgLTkxIDM3bC02NTEgNjUycS0zNyAzNyAtMzcgOTBxMCA1MiAzNyA5MWw2NTEgNjUwcTM4IDM4IDkxIDM4cTUyIDAgOTAgLTM4bDc1IC03NHEzOCAtMzggMzggLTkxdC0zOCAtOTFsLTI5MyAtMjkzaDcwNHE1MiAwIDg0LjUgLTM3LjUgdDMyLjUgLTkwLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNjE7IiBkPSJNMTQ3MiA1NzZxMCAtNTQgLTM3IC05MWwtNjUxIC02NTFxLTM5IC0zNyAtOTEgLTM3cS01MSAwIC05MCAzN2wtNzUgNzVxLTM4IDM4IC0zOCA5MXQzOCA5MWwyOTMgMjkzaC03MDRxLTUyIDAgLTg0LjUgMzcuNXQtMzIuNSA5MC41djEyOHEwIDUzIDMyLjUgOTAuNXQ4NC41IDM3LjVoNzA0bC0yOTMgMjk0cS0zOCAzNiAtMzggOTB0MzggOTBsNzUgNzVxMzggMzggOTAgMzhxNTMgMCA5MSAtMzhsNjUxIC02NTFxMzcgLTM1IDM3IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2MjsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTYxMSA1NjVxMCAtNTEgLTM3IC05MGwtNzUgLTc1cS0zOCAtMzggLTkxIC0zOHEtNTQgMCAtOTAgMzhsLTI5NCAyOTN2LTcwNHEwIC01MiAtMzcuNSAtODQuNXQtOTAuNSAtMzIuNWgtMTI4cS01MyAwIC05MC41IDMyLjV0LTM3LjUgODQuNXY3MDRsLTI5NCAtMjkzcS0zNiAtMzggLTkwIC0zOHQtOTAgMzhsLTc1IDc1cS0zOCAzOCAtMzggOTBxMCA1MyAzOCA5MWw2NTEgNjUxcTM1IDM3IDkwIDM3cTU0IDAgOTEgLTM3bDY1MSAtNjUxIHEzNyAtMzkgMzcgLTkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDYzOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNjExIDcwNHEwIC01MyAtMzcgLTkwbC02NTEgLTY1MnEtMzkgLTM3IC05MSAtMzdxLTUzIDAgLTkwIDM3bC02NTEgNjUycS0zOCAzNiAtMzggOTBxMCA1MyAzOCA5MWw3NCA3NXEzOSAzNyA5MSAzN3E1MyAwIDkwIC0zN2wyOTQgLTI5NHY3MDRxMCA1MiAzOCA5MHQ5MCAzOGgxMjhxNTIgMCA5MCAtMzh0MzggLTkwdi03MDRsMjk0IDI5NHEzNyAzNyA5MCAzN3E1MiAwIDkxIC0zN2w3NSAtNzVxMzcgLTM5IDM3IC05MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2NDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiA4OTZxMCAtMjYgLTE5IC00NWwtNTEyIC01MTJxLTE5IC0xOSAtNDUgLTE5dC00NSAxOXQtMTkgNDV2MjU2aC0yMjRxLTk4IDAgLTE3NS41IC02dC0xNTQgLTIxLjV0LTEzMyAtNDIuNXQtMTA1LjUgLTY5LjV0LTgwIC0xMDF0LTQ4LjUgLTEzOC41dC0xNy41IC0xODFxMCAtNTUgNSAtMTIzcTAgLTYgMi41IC0yMy41dDIuNSAtMjYuNXEwIC0xNSAtOC41IC0yNXQtMjMuNSAtMTBxLTE2IDAgLTI4IDE3cS03IDkgLTEzIDIyIHQtMTMuNSAzMHQtMTAuNSAyNHEtMTI3IDI4NSAtMTI3IDQ1MXEwIDE5OSA1MyAzMzNxMTYyIDQwMyA4NzUgNDAzaDIyNHYyNTZxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsNTEyIC01MTJxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2NTsiIGQ9Ik03NTUgNDgwcTAgLTEzIC0xMCAtMjNsLTMzMiAtMzMybDE0NCAtMTQ0cTE5IC0xOSAxOSAtNDV0LTE5IC00NXQtNDUgLTE5aC00NDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXY0NDhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsMTQ0IC0xNDRsMzMyIDMzMnExMCAxMCAyMyAxMHQyMyAtMTBsMTE0IC0xMTRxMTAgLTEwIDEwIC0yM3pNMTUzNiAxMzQ0di00NDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOWwtMTQ0IDE0NGwtMzMyIC0zMzIgcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTExNCAxMTRxLTEwIDEwIC0xMCAyM3QxMCAyM2wzMzIgMzMybC0xNDQgMTQ0cS0xOSAxOSAtMTkgNDV0MTkgNDV0NDUgMTloNDQ4cTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2NjsiIGQ9Ik03NjggNTc2di00NDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOWwtMTQ0IDE0NGwtMzMyIC0zMzJxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtMTE0IDExNHEtMTAgMTAgLTEwIDIzdDEwIDIzbDMzMiAzMzJsLTE0NCAxNDRxLTE5IDE5IC0xOSA0NXQxOSA0NXQ0NSAxOWg0NDhxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xNTIzIDEyNDhxMCAtMTMgLTEwIC0yM2wtMzMyIC0zMzJsMTQ0IC0xNDRxMTkgLTE5IDE5IC00NXQtMTkgLTQ1IHQtNDUgLTE5aC00NDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXY0NDhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsMTQ0IC0xNDRsMzMyIDMzMnExMCAxMCAyMyAxMHQyMyAtMTBsMTE0IC0xMTRxMTAgLTEwIDEwIC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2NzsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTQwOCA4MDB2LTE5MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTQxNnYtNDE2cTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTkycS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC00MTZxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGg0MTZ2NDE2cTAgNDAgMjggNjh0NjggMjhoMTkycTQwIDAgNjggLTI4dDI4IC02OHYtNDE2aDQxNnE0MCAwIDY4IC0yOHQyOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNjg7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTE0MDggODAwdi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMjE2cS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjhoMTIxNnE0MCAwIDY4IC0yOHQyOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNjk7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE0ODIgNDg2cTQ2IC0yNiA1OS41IC03Ny41dC0xMi41IC05Ny41bC02NCAtMTEwcS0yNiAtNDYgLTc3LjUgLTU5LjV0LTk3LjUgMTIuNWwtMjY2IDE1M3YtMzA3cTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMTI4cS01MiAwIC05MCAzOHQtMzggOTB2MzA3bC0yNjYgLTE1M3EtNDYgLTI2IC05Ny41IC0xMi41dC03Ny41IDU5LjVsLTY0IDExMHEtMjYgNDYgLTEyLjUgOTcuNXQ1OS41IDc3LjVsMjY2IDE1NGwtMjY2IDE1NCBxLTQ2IDI2IC01OS41IDc3LjV0MTIuNSA5Ny41bDY0IDExMHEyNiA0NiA3Ny41IDU5LjV0OTcuNSAtMTIuNWwyNjYgLTE1M3YzMDdxMCA1MiAzOCA5MHQ5MCAzOGgxMjhxNTIgMCA5MCAtMzh0MzggLTkwdi0zMDdsMjY2IDE1M3E0NiAyNiA5Ny41IDEyLjV0NzcuNSAtNTkuNWw2NCAtMTEwcTI2IC00NiAxMi41IC05Ny41dC01OS41IC03Ny41bC0yNjYgLTE1NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA2YTsiIGQ9Ik03NjggMTQwOHEyMDkgMCAzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41dC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzek04OTYgMTYxdjE5MHEwIDE0IC05IDIzLjV0LTIyIDkuNWgtMTkycS0xMyAwIC0yMyAtMTB0LTEwIC0yM3YtMTkwcTAgLTEzIDEwIC0yM3QyMyAtMTBoMTkyIHExMyAwIDIyIDkuNXQ5IDIzLjV6TTg5NCA1MDVsMTggNjIxcTAgMTIgLTEwIDE4cS0xMCA4IC0yNCA4aC0yMjBxLTE0IDAgLTI0IC04cS0xMCAtNiAtMTAgLTE4bDE3IC02MjFxMCAtMTAgMTAgLTE3LjV0MjQgLTcuNWgxODVxMTQgMCAyMy41IDcuNXQxMC41IDE3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNmI7IiBkPSJNOTI4IDE4MHY1NnY0Njh2MTkyaC0zMjB2LTE5MnYtNDY4di01NnEwIC0yNSAxOCAtMzguNXQ0NiAtMTMuNWgxOTJxMjggMCA0NiAxMy41dDE4IDM4LjV6TTQ3MiAxMDI0aDE5NWwtMTI2IDE2MXEtMjYgMzEgLTY5IDMxcS00MCAwIC02OCAtMjh0LTI4IC02OHQyOCAtNjh0NjggLTI4ek0xMTYwIDExMjBxMCA0MCAtMjggNjh0LTY4IDI4cS00MyAwIC02OSAtMzFsLTEyNSAtMTYxaDE5NHE0MCAwIDY4IDI4dDI4IDY4ek0xNTM2IDg2NHYtMzIwIHEwIC0xNCAtOSAtMjN0LTIzIC05aC05NnYtNDE2cTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTA4OHEtNDAgMCAtNjggMjh0LTI4IDY4djQxNmgtOTZxLTE0IDAgLTIzIDl0LTkgMjN2MzIwcTAgMTQgOSAyM3QyMyA5aDQ0MHEtOTMgMCAtMTU4LjUgNjUuNXQtNjUuNSAxNTguNXQ2NS41IDE1OC41dDE1OC41IDY1LjVxMTA3IDAgMTY4IC03N2wxMjggLTE2NWwxMjggMTY1cTYxIDc3IDE2OCA3N3E5MyAwIDE1OC41IC02NS41dDY1LjUgLTE1OC41IHQtNjUuNSAtMTU4LjV0LTE1OC41IC02NS41aDQ0MHExNCAwIDIzIC05dDkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDZjOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMjgwIDgzMnEwIDI2IC0xOSA0NXQtNDUgMTlxLTE3MiAwIC0zMTggLTQ5LjV0LTI1OS41IC0xMzR0LTIzNS41IC0yMTkuNXEtMTkgLTIxIC0xOSAtNDVxMCAtMjYgMTkgLTQ1dDQ1IC0xOXEyNCAwIDQ1IDE5cTI3IDI0IDc0IDcxdDY3IDY2cTEzNyAxMjQgMjY4LjUgMTc2dDMxMy41IDUycTI2IDAgNDUgMTl0MTkgNDV6TTE3OTIgMTAzMHEwIC05NSAtMjAgLTE5M3EtNDYgLTIyNCAtMTg0LjUgLTM4M3QtMzU3LjUgLTI2OCBxLTIxNCAtMTA4IC00MzggLTEwOHEtMTQ4IDAgLTI4NiA0N3EtMTUgNSAtODggNDJ0LTk2IDM3cS0xNiAwIC0zOS41IC0zMnQtNDUgLTcwdC01Mi41IC03MHQtNjAgLTMycS0zMCAwIC01MSAxMXQtMzEgMjR0LTI3IDQycS0yIDQgLTYgMTF0LTUuNSAxMHQtMyA5LjV0LTEuNSAxMy41cTAgMzUgMzEgNzMuNXQ2OCA2NS41dDY4IDU2dDMxIDQ4cTAgNCAtMTQgMzh0LTE2IDQ0cS05IDUxIC05IDEwNHEwIDExNSA0My41IDIyMHQxMTkgMTg0LjUgdDE3MC41IDEzOXQyMDQgOTUuNXE1NSAxOCAxNDUgMjUuNXQxNzkuNSA5dDE3OC41IDZ0MTYzLjUgMjR0MTEzLjUgNTYuNWwyOS41IDI5LjV0MjkuNSAyOHQyNyAyMHQzNi41IDE2dDQzLjUgNC41cTM5IDAgNzAuNSAtNDZ0NDcuNSAtMTEydDI0IC0xMjR0OCAtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNmQ7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTE0MDggLTE2MHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0xMzQ0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMzQ0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMTE1MiA4OTZxMCAtNzggLTI0LjUgLTE0NHQtNjQgLTExMi41dC04Ny41IC04OHQtOTYgLTc3LjV0LTg3LjUgLTcydC02NCAtODEuNXQtMjQuNSAtOTYuNXEwIC05NiA2NyAtMjI0bC00IDFsMSAtMSBxLTkwIDQxIC0xNjAgODN0LTEzOC41IDEwMHQtMTEzLjUgMTIyLjV0LTcyLjUgMTUwLjV0LTI3LjUgMTg0cTAgNzggMjQuNSAxNDR0NjQgMTEyLjV0ODcuNSA4OHQ5NiA3Ny41dDg3LjUgNzJ0NjQgODEuNXQyNC41IDk2LjVxMCA5NCAtNjYgMjI0bDMgLTFsLTEgMXE5MCAtNDEgMTYwIC04M3QxMzguNSAtMTAwdDExMy41IC0xMjIuNXQ3Mi41IC0xNTAuNXQyNy41IC0xODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNmU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE2NjQgNTc2cS0xNTIgMjM2IC0zODEgMzUzcTYxIC0xMDQgNjEgLTIyNXEwIC0xODUgLTEzMS41IC0zMTYuNXQtMzE2LjUgLTEzMS41dC0zMTYuNSAxMzEuNXQtMTMxLjUgMzE2LjVxMCAxMjEgNjEgMjI1cS0yMjkgLTExNyAtMzgxIC0zNTNxMTMzIC0yMDUgMzMzLjUgLTMyNi41dDQzNC41IC0xMjEuNXQ0MzQuNSAxMjEuNXQzMzMuNSAzMjYuNXpNOTQ0IDk2MHEwIDIwIC0xNCAzNHQtMzQgMTRxLTEyNSAwIC0yMTQuNSAtODkuNSB0LTg5LjUgLTIxNC41cTAgLTIwIDE0IC0zNHQzNCAtMTR0MzQgMTR0MTQgMzRxMCA4NiA2MSAxNDd0MTQ3IDYxcTIwIDAgMzQgMTR0MTQgMzR6TTE3OTIgNTc2cTAgLTM0IC0yMCAtNjlxLTE0MCAtMjMwIC0zNzYuNSAtMzY4LjV0LTQ5OS41IC0xMzguNXQtNDk5LjUgMTM5dC0zNzYuNSAzNjhxLTIwIDM1IC0yMCA2OXQyMCA2OXExNDAgMjI5IDM3Ni41IDM2OHQ0OTkuNSAxMzl0NDk5LjUgLTEzOXQzNzYuNSAtMzY4cTIwIC0zNSAyMCAtNjl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNzA7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTU1NSAyMDFsNzggMTQxcS04NyA2MyAtMTM2IDE1OXQtNDkgMjAzcTAgMTIxIDYxIDIyNXEtMjI5IC0xMTcgLTM4MSAtMzUzcTE2NyAtMjU4IDQyNyAtMzc1ek05NDQgOTYwcTAgMjAgLTE0IDM0dC0zNCAxNHEtMTI1IDAgLTIxNC41IC04OS41dC04OS41IC0yMTQuNXEwIC0yMCAxNCAtMzR0MzQgLTE0dDM0IDE0dDE0IDM0cTAgODYgNjEgMTQ3dDE0NyA2MXEyMCAwIDM0IDE0dDE0IDM0ek0xMzA3IDExNTFxMCAtNyAtMSAtOSBxLTEwNSAtMTg4IC0zMTUgLTU2NnQtMzE2IC01NjdsLTQ5IC04OXEtMTAgLTE2IC0yOCAtMTZxLTEyIDAgLTEzNCA3MHEtMTYgMTAgLTE2IDI4cTAgMTIgNDQgODdxLTE0MyA2NSAtMjYzLjUgMTczdC0yMDguNSAyNDVxLTIwIDMxIC0yMCA2OXQyMCA2OXExNTMgMjM1IDM4MCAzNzF0NDk2IDEzNnE4OSAwIDE4MCAtMTdsNTQgOTdxMTAgMTYgMjggMTZxNSAwIDE4IC02dDMxIC0xNS41dDMzIC0xOC41dDMxLjUgLTE4LjV0MTkuNSAtMTEuNSBxMTYgLTEwIDE2IC0yN3pNMTM0NCA3MDRxMCAtMTM5IC03OSAtMjUzLjV0LTIwOSAtMTY0LjVsMjgwIDUwMnE4IC00NSA4IC04NHpNMTc5MiA1NzZxMCAtMzUgLTIwIC02OXEtMzkgLTY0IC0xMDkgLTE0NXEtMTUwIC0xNzIgLTM0Ny41IC0yNjd0LTQxOS41IC05NWw3NCAxMzJxMjEyIDE4IDM5Mi41IDEzN3QzMDEuNSAzMDdxLTExNSAxNzkgLTI4MiAyOTRsNjMgMTEycTk1IC02NCAxODIuNSAtMTUzdDE0NC41IC0xODRxMjAgLTM0IDIwIC02OXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNzE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEwMjQgMTYxdjE5MHEwIDE0IC05LjUgMjMuNXQtMjIuNSA5LjVoLTE5MnEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIzLjV2LTE5MHEwIC0xNCA5LjUgLTIzLjV0MjIuNSAtOS41aDE5MnExMyAwIDIyLjUgOS41dDkuNSAyMy41ek0xMDIyIDUzNWwxOCA0NTlxMCAxMiAtMTAgMTlxLTEzIDExIC0yNCAxMWgtMjIwcS0xMSAwIC0yNCAtMTFxLTEwIC03IC0xMCAtMjFsMTcgLTQ1N3EwIC0xMCAxMCAtMTYuNXQyNCAtNi41aDE4NSBxMTQgMCAyMy41IDYuNXQxMC41IDE2LjV6TTEwMDggMTQ2OWw3NjggLTE0MDhxMzUgLTYzIC0yIC0xMjZxLTE3IC0yOSAtNDYuNSAtNDZ0LTYzLjUgLTE3aC0xNTM2cS0zNCAwIC02My41IDE3dC00Ni41IDQ2cS0zNyA2MyAtMiAxMjZsNzY4IDE0MDhxMTcgMzEgNDcgNDl0NjUgMTh0NjUgLTE4dDQ3IC00OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3MjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTM3NiAxMzc2cTQ0IC01MiAxMiAtMTQ4dC0xMDggLTE3MmwtMTYxIC0xNjFsMTYwIC02OTZxNSAtMTkgLTEyIC0zM2wtMTI4IC05NnEtNyAtNiAtMTkgLTZxLTQgMCAtNyAxcS0xNSAzIC0yMSAxNmwtMjc5IDUwOGwtMjU5IC0yNTlsNTMgLTE5NHE1IC0xNyAtOCAtMzFsLTk2IC05NnEtOSAtOSAtMjMgLTloLTJxLTE1IDIgLTI0IDEzbC0xODkgMjUybC0yNTIgMTg5cS0xMSA3IC0xMyAyM3EtMSAxMyA5IDI1bDk2IDk3cTkgOSAyMyA5IHE2IDAgOCAtMWwxOTQgLTUzbDI1OSAyNTlsLTUwOCAyNzlxLTE0IDggLTE3IDI0cS0yIDE2IDkgMjdsMTI4IDEyOHExNCAxMyAzMCA4bDY2NSAtMTU5bDE2MCAxNjBxNzYgNzYgMTcyIDEwOHQxNDggLTEyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDczOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xMjggLTEyOGgyODh2Mjg4aC0yODh2LTI4OHpNNDgwIC0xMjhoMzIwdjI4OGgtMzIwdi0yODh6TTEyOCAyMjRoMjg4djMyMGgtMjg4di0zMjB6TTQ4MCAyMjRoMzIwdjMyMGgtMzIwdi0zMjB6TTEyOCA2MDhoMjg4djI4OGgtMjg4di0yODh6TTg2NCAtMTI4aDMyMHYyODhoLTMyMHYtMjg4ek00ODAgNjA4aDMyMHYyODhoLTMyMHYtMjg4ek0xMjQ4IC0xMjhoMjg4djI4OGgtMjg4di0yODh6TTg2NCAyMjRoMzIwdjMyMGgtMzIwdi0zMjB6IE01MTIgMTA4OHYyODhxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC02NHEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTI4OHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDY0cTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTEyNDggMjI0aDI4OHYzMjBoLTI4OHYtMzIwek04NjQgNjA4aDMyMHYyODhoLTMyMHYtMjg4ek0xMjQ4IDYwOGgyODh2Mjg4aC0yODh2LTI4OHpNMTI4MCAxMDg4djI4OHEwIDEzIC05LjUgMjIuNXQtMjIuNSA5LjVoLTY0IHEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTI4OHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDY0cTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE2NjQgMTE1MnYtMTI4MHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTE0MDhxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMjgwcTAgNTIgMzggOTB0OTAgMzhoMTI4djk2cTAgNjYgNDcgMTEzdDExMyA0N2g2NHE2NiAwIDExMyAtNDd0NDcgLTExM3YtOTZoMzg0djk2cTAgNjYgNDcgMTEzdDExMyA0NyBoNjRxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTk2aDEyOHE1MiAwIDkwIC0zOHQzOCAtOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwNzQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTY2NiAxMDU1cS02MCAtOTIgLTEzNyAtMjczcS0yMiA0NSAtMzcgNzIuNXQtNDAuNSA2My41dC01MSA1Ni41dC02MyAzNXQtODEuNSAxNC41aC0yMjRxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDIyNHEyNTAgMCA0MTAgLTIyNXpNMTc5MiAyNTZxMCAtMTQgLTkgLTIzbC0zMjAgLTMyMHEtOSAtOSAtMjMgLTlxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxLTMyIDAgLTg1IC0wLjV0LTgxIC0xdC03MyAxIHQtNzEgNXQtNjQgMTAuNXQtNjMgMTguNXQtNTggMjguNXQtNTkgNDB0LTU1IDUzLjV0LTU2IDY5LjVxNTkgOTMgMTM2IDI3M3EyMiAtNDUgMzcgLTcyLjV0NDAuNSAtNjMuNXQ1MSAtNTYuNXQ2MyAtMzV0ODEuNSAtMTQuNWgyNTZ2MTkycTAgMTQgOSAyM3QyMyA5cTEyIDAgMjQgLTEwbDMxOSAtMzE5cTkgLTkgOSAtMjN6TTE3OTIgMTE1MnEwIC0xNCAtOSAtMjNsLTMyMCAtMzIwcS05IC05IC0yMyAtOXEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41IHYxOTJoLTI1NnEtNDggMCAtODcgLTE1dC02OSAtNDV0LTUxIC02MS41dC00NSAtNzcuNXEtMzIgLTYyIC03OCAtMTcxcS0yOSAtNjYgLTQ5LjUgLTExMXQtNTQgLTEwNXQtNjQgLTEwMHQtNzQgLTgzdC05MCAtNjguNXQtMTA2LjUgLTQydC0xMjggLTE2LjVoLTIyNHEtMTQgMCAtMjMgOXQtOSAyM3YxOTJxMCAxNCA5IDIzdDIzIDloMjI0cTQ4IDAgODcgMTV0NjkgNDV0NTEgNjEuNXQ0NSA3Ny41cTMyIDYyIDc4IDE3MXEyOSA2NiA0OS41IDExMSB0NTQgMTA1dDY0IDEwMHQ3NCA4M3Q5MCA2OC41dDEwNi41IDQydDEyOCAxNi41aDI1NnYxOTJxMCAxNCA5IDIzdDIzIDlxMTIgMCAyNCAtMTBsMzE5IC0zMTlxOSAtOSA5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3NTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiA2NDBxMCAtMTc0IC0xMjAgLTMyMS41dC0zMjYgLTIzM3QtNDUwIC04NS41cS03MCAwIC0xNDUgOHEtMTk4IC0xNzUgLTQ2MCAtMjQycS00OSAtMTQgLTExNCAtMjJxLTE3IC0yIC0zMC41IDl0LTE3LjUgMjl2MXEtMyA0IC0wLjUgMTJ0MiAxMHQ0LjUgOS41bDYgOXQ3IDguNXQ4IDlxNyA4IDMxIDM0LjV0MzQuNSAzOHQzMSAzOS41dDMyLjUgNTF0MjcgNTl0MjYgNzZxLTE1NyA4OSAtMjQ3LjUgMjIwdC05MC41IDI4MSBxMCAxMzAgNzEgMjQ4LjV0MTkxIDIwNC41dDI4NiAxMzYuNXQzNDggNTAuNXEyNDQgMCA0NTAgLTg1LjV0MzI2IC0yMzN0MTIwIC0zMjEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3NjsiIGQ9Ik0xNTM2IDcwNHYtMTI4cTAgLTIwMSAtOTguNSAtMzYydC0yNzQgLTI1MS41dC0zOTUuNSAtOTAuNXQtMzk1LjUgOTAuNXQtMjc0IDI1MS41dC05OC41IDM2MnYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgzODRxMjYgMCA0NSAtMTl0MTkgLTQ1di0xMjhxMCAtNTIgMjMuNSAtOTB0NTMuNSAtNTd0NzEgLTMwdDY0IC0xM3Q0NCAtMnQ0NCAydDY0IDEzdDcxIDMwdDUzLjUgNTd0MjMuNSA5MHYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgzODQgcTI2IDAgNDUgLTE5dDE5IC00NXpNNTEyIDEzNDR2LTM4NHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTM4NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djM4NHEwIDI2IDE5IDQ1dDQ1IDE5aDM4NHEyNiAwIDQ1IC0xOXQxOSAtNDV6TTE1MzYgMTM0NHYtMzg0cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMzg0cS0yNiAwIC00NSAxOXQtMTkgNDV2Mzg0cTAgMjYgMTkgNDV0NDUgMTloMzg0cTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3NzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY4MyAyMDVsLTE2NiAtMTY1cS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTUzMSA1MzFsLTUzMSAtNTMxcS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTE2NiAxNjVxLTE5IDE5IC0xOSA0NS41dDE5IDQ1LjVsNzQyIDc0MXExOSAxOSA0NSAxOXQ0NSAtMTlsNzQyIC03NDFxMTkgLTE5IDE5IC00NS41dC0xOSAtNDUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3ODsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY4MyA3MjhsLTc0MiAtNzQxcS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTc0MiA3NDFxLTE5IDE5IC0xOSA0NS41dDE5IDQ1LjVsMTY2IDE2NXExOSAxOSA0NSAxOXQ0NSAtMTlsNTMxIC01MzFsNTMxIDUzMXExOSAxOSA0NSAxOXQ0NSAtMTlsMTY2IC0xNjVxMTkgLTE5IDE5IC00NS41dC0xOSAtNDUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA3OTsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNMTI4MCAzMnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTk2MHEtOCAwIC0xMy41IDJ0LTkgN3QtNS41IDh0LTMgMTEuNXQtMSAxMS41djEzdjExdjE2MHY0MTZoLTE5MnEtMjYgMCAtNDUgMTl0LTE5IDQ1cTAgMjQgMTUgNDFsMzIwIDM4NHExOSAyMiA0OSAyMnQ0OSAtMjJsMzIwIC0zODRxMTUgLTE3IDE1IC00MXEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE5MnYtMzg0aDU3NnExNiAwIDI1IC0xMWwxNjAgLTE5MnE3IC0xMSA3IC0yMSB6TTE5MjAgNDQ4cTAgLTI0IC0xNSAtNDFsLTMyMCAtMzg0cS0yMCAtMjMgLTQ5IC0yM3QtNDkgMjNsLTMyMCAzODRxLTE1IDE3IC0xNSA0MXEwIDI2IDE5IDQ1dDQ1IDE5aDE5MnYzODRoLTU3NnEtMTYgMCAtMjUgMTJsLTE2MCAxOTJxLTcgOSAtNyAyMHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDk2MHE4IDAgMTMuNSAtMnQ5IC03dDUuNSAtOHQzIC0xMS41dDEgLTExLjV2LTEzdi0xMXYtMTYwdi00MTZoMTkycTI2IDAgNDUgLTE5dDE5IC00NXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwN2E7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTY0MCAwcTAgLTUyIC0zOCAtOTB0LTkwIC0zOHQtOTAgMzh0LTM4IDkwdDM4IDkwdDkwIDM4dDkwIC0zOHQzOCAtOTB6TTE1MzYgMHEwIC01MiAtMzggLTkwdC05MCAtMzh0LTkwIDM4dC0zOCA5MHQzOCA5MHQ5MCAzOHQ5MCAtMzh0MzggLTkwek0xNjY0IDEwODh2LTUxMnEwIC0yNCAtMTYuNSAtNDIuNXQtNDAuNSAtMjEuNWwtMTA0NCAtMTIycTEzIC02MCAxMyAtNzBxMCAtMTYgLTI0IC02NGg5MjBxMjYgMCA0NSAtMTl0MTkgLTQ1IHQtMTkgLTQ1dC00NSAtMTloLTEwMjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXEwIDExIDggMzEuNXQxNiAzNnQyMS41IDQwdDE1LjUgMjkuNWwtMTc3IDgyM2gtMjA0cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMjU2cTE2IDAgMjguNSAtNi41dDE5LjUgLTE1LjV0MTMgLTI0LjV0OCAtMjZ0NS41IC0yOS41dDQuNSAtMjZoMTIwMXEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwN2I7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE2NjQgOTI4di03MDRxMCAtOTIgLTY2IC0xNTh0LTE1OCAtNjZoLTEyMTZxLTkyIDAgLTE1OCA2NnQtNjYgMTU4djk2MHEwIDkyIDY2IDE1OHQxNTggNjZoMzIwcTkyIDAgMTU4IC02NnQ2NiAtMTU4di0zMmg2NzJxOTIgMCAxNTggLTY2dDY2IC0xNTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwN2M7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTE4NzkgNTg0cTAgLTMxIC0zMSAtNjZsLTMzNiAtMzk2cS00MyAtNTEgLTEyMC41IC04Ni41dC0xNDMuNSAtMzUuNWgtMTA4OHEtMzQgMCAtNjAuNSAxM3QtMjYuNSA0M3EwIDMxIDMxIDY2bDMzNiAzOTZxNDMgNTEgMTIwLjUgODYuNXQxNDMuNSAzNS41aDEwODhxMzQgMCA2MC41IC0xM3QyNi41IC00M3pNMTUzNiA5Mjh2LTE2MGgtODMycS05NCAwIC0xOTcgLTQ3LjV0LTE2NCAtMTE5LjVsLTMzNyAtMzk2bC01IC02cTAgNCAtMC41IDEyLjUgdC0wLjUgMTIuNXY5NjBxMCA5MiA2NiAxNTh0MTU4IDY2aDMyMHE5MiAwIDE1OCAtNjZ0NjYgLTE1OHYtMzJoNTQ0cTkyIDAgMTU4IC02NnQ2NiAtMTU4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDdkOyIgaG9yaXotYWR2LXg9Ijc2OCIgZD0iTTcwNCAxMjE2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTI4di0xMDI0aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV0LTE5IC00NWwtMjU2IC0yNTZxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtMjU2IDI1NnEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5aDEyOHYxMDI0aC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NWwyNTYgMjU2cTE5IDE5IDQ1IDE5dDQ1IC0xOWwyNTYgLTI1NnExOSAtMTkgMTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDdlOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDY0MHEwIC0yNiAtMTkgLTQ1bC0yNTYgLTI1NnEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5dC0xOSA0NXYxMjhoLTEwMjR2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTl0LTQ1IDE5bC0yNTYgMjU2cS0xOSAxOSAtMTkgNDV0MTkgNDVsMjU2IDI1NnExOSAxOSA0NSAxOXQ0NSAtMTl0MTkgLTQ1di0xMjhoMTAyNHYxMjhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsMjU2IC0yNTZxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA4MDsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNNjQwIDY0MHYtNTEyaC0yNTZ2NTEyaDI1NnpNMTAyNCAxMTUydi0xMDI0aC0yNTZ2MTAyNGgyNTZ6TTIwNDggMHYtMTI4aC0yMDQ4djE1MzZoMTI4di0xNDA4aDE5MjB6TTE0MDggODk2di03NjhoLTI1NnY3NjhoMjU2ek0xNzkyIDEyODB2LTExNTJoLTI1NnYxMTUyaDI1NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA4MTsiIGQ9Ik0xMjgwIDkyNnEtNTYgLTI1IC0xMjEgLTM0cTY4IDQwIDkzIDExN3EtNjUgLTM4IC0xMzQgLTUxcS02MSA2NiAtMTUzIDY2cS04NyAwIC0xNDguNSAtNjEuNXQtNjEuNSAtMTQ4LjVxMCAtMjkgNSAtNDhxLTEyOSA3IC0yNDIgNjV0LTE5MiAxNTVxLTI5IC01MCAtMjkgLTEwNnEwIC0xMTQgOTEgLTE3NXEtNDcgMSAtMTAwIDI2di0ycTAgLTc1IDUwIC0xMzMuNXQxMjMgLTcyLjVxLTI5IC04IC01MSAtOHEtMTMgMCAtMzkgNCBxMjEgLTYzIDc0LjUgLTEwNHQxMjEuNSAtNDJxLTExNiAtOTAgLTI2MSAtOTBxLTI2IDAgLTUwIDNxMTQ4IC05NCAzMjIgLTk0cTExMiAwIDIxMCAzNS41dDE2OCA5NXQxMjAuNSAxMzd0NzUgMTYydDI0LjUgMTY4LjVxMCAxOCAtMSAyN3E2MyA0NSAxMDUgMTA5ek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNSB0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwODI7IiBkPSJNMTI0OCAxNDA4cTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41di05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTE4OHY1OTVoMTk5bDMwIDIzMmgtMjI5djE0OHEwIDU2IDIzLjUgODR0OTEuNSAyOGwxMjIgMXYyMDdxLTYzIDkgLTE3OCA5cS0xMzYgMCAtMjE3LjUgLTgwdC04MS41IC0yMjZ2LTE3MWgtMjAwdi0yMzJoMjAwdi01OTVoLTUzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwIHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDgzOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik05MjggNzA0cTAgMTQgLTkgMjN0LTIzIDlxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTNxMCAtMTQgOSAtMjN0MjMgLTl0MjMgOXQ5IDIzcTAgNDAgMjggNjh0NjggMjhxMTQgMCAyMyA5dDkgMjN6TTExNTIgNTc0cTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXQtMTgxIDc1dC03NSAxODF0NzUgMTgxdDE4MSA3NXQxODEgLTc1dDc1IC0xODF6TTEyOCAwaDE1MzZ2MTI4aC0xNTM2di0xMjh6TTEyODAgNTc0cTAgMTU5IC0xMTIuNSAyNzEuNSB0LTI3MS41IDExMi41dC0yNzEuNSAtMTEyLjV0LTExMi41IC0yNzEuNXQxMTIuNSAtMjcxLjV0MjcxLjUgLTExMi41dDI3MS41IDExMi41dDExMi41IDI3MS41ek0yNTYgMTIxNmgzODR2MTI4aC0zODR2LTEyOHpNMTI4IDEwMjRoMTUzNnYxMTh2MTM4aC04MjhsLTY0IC0xMjhoLTY0NHYtMTI4ek0xNzkyIDEyODB2LTEyODBxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjVoLTE1MzZxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41djEyODAgcTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNWgxNTM2cTUzIDAgOTAuNSAtMzcuNXQzNy41IC05MC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDg0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04MzIgMTAyNHEwIDgwIC01NiAxMzZ0LTEzNiA1NnQtMTM2IC01NnQtNTYgLTEzNnEwIC00MiAxOSAtODNxLTQxIDE5IC04MyAxOXEtODAgMCAtMTM2IC01NnQtNTYgLTEzNnQ1NiAtMTM2dDEzNiAtNTZ0MTM2IDU2dDU2IDEzNnEwIDQyIC0xOSA4M3E0MSAtMTkgODMgLTE5cTgwIDAgMTM2IDU2dDU2IDEzNnpNMTY4MyAzMjBxMCAtMTcgLTQ5IC02NnQtNjYgLTQ5cS05IDAgLTI4LjUgMTZ0LTM2LjUgMzN0LTM4LjUgNDB0LTI0LjUgMjYgbC05NiAtOTZsMjIwIC0yMjBxMjggLTI4IDI4IC02OHEwIC00MiAtMzkgLTgxdC04MSAtMzlxLTQwIDAgLTY4IDI4bC02NzEgNjcxcS0xNzYgLTEzMSAtMzY1IC0xMzFxLTE2MyAwIC0yNjUuNSAxMDIuNXQtMTAyLjUgMjY1LjVxMCAxNjAgOTUgMzEzdDI0OCAyNDh0MzEzIDk1cTE2MyAwIDI2NS41IC0xMDIuNXQxMDIuNSAtMjY1LjVxMCAtMTg5IC0xMzEgLTM2NWwzNTUgLTM1NWw5NiA5NnEtMyAzIC0yNiAyNC41dC00MCAzOC41dC0zMyAzNi41IHQtMTYgMjguNXEwIDE3IDQ5IDY2dDY2IDQ5cTEzIDAgMjMgLTEwcTYgLTYgNDYgLTQ0LjV0ODIgLTc5LjV0ODYuNSAtODZ0NzMgLTc4dDI4LjUgLTQxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDg1OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik04OTYgNjQwcTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXQ3NSAtMTgxdDE4MSAtNzV0MTgxIDc1dDc1IDE4MXpNMTY2NCAxMjhxMCA1MiAtMzggOTB0LTkwIDM4dC05MCAtMzh0LTM4IC05MHEwIC01MyAzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNMTY2NCAxMTUycTAgNTIgLTM4IDkwdC05MCAzOHQtOTAgLTM4dC0zOCAtOTBxMCAtNTMgMzcuNSAtOTAuNXQ5MC41IC0zNy41IHQ5MC41IDM3LjV0MzcuNSA5MC41ek0xMjgwIDczMXYtMTg1cTAgLTEwIC03IC0xOS41dC0xNiAtMTAuNWwtMTU1IC0yNHEtMTEgLTM1IC0zMiAtNzZxMzQgLTQ4IDkwIC0xMTVxNyAtMTAgNyAtMjBxMCAtMTIgLTcgLTE5cS0yMyAtMzAgLTgyLjUgLTg5LjV0LTc4LjUgLTU5LjVxLTExIDAgLTIxIDdsLTExNSA5MHEtMzcgLTE5IC03NyAtMzFxLTExIC0xMDggLTIzIC0xNTVxLTcgLTI0IC0zMCAtMjRoLTE4NnEtMTEgMCAtMjAgNy41dC0xMCAxNy41IGwtMjMgMTUzcS0zNCAxMCAtNzUgMzFsLTExOCAtODlxLTcgLTcgLTIwIC03cS0xMSAwIC0yMSA4cS0xNDQgMTMzIC0xNDQgMTYwcTAgOSA3IDE5cTEwIDE0IDQxIDUzdDQ3IDYxcS0yMyA0NCAtMzUgODJsLTE1MiAyNHEtMTAgMSAtMTcgOS41dC03IDE5LjV2MTg1cTAgMTAgNyAxOS41dDE2IDEwLjVsMTU1IDI0cTExIDM1IDMyIDc2cS0zNCA0OCAtOTAgMTE1cS03IDExIC03IDIwcTAgMTIgNyAyMHEyMiAzMCA4MiA4OXQ3OSA1OXExMSAwIDIxIC03IGwxMTUgLTkwcTM0IDE4IDc3IDMycTExIDEwOCAyMyAxNTRxNyAyNCAzMCAyNGgxODZxMTEgMCAyMCAtNy41dDEwIC0xNy41bDIzIC0xNTNxMzQgLTEwIDc1IC0zMWwxMTggODlxOCA3IDIwIDdxMTEgMCAyMSAtOHExNDQgLTEzMyAxNDQgLTE2MHEwIC05IC03IC0xOXEtMTIgLTE2IC00MiAtNTR0LTQ1IC02MHEyMyAtNDggMzQgLTgybDE1MiAtMjNxMTAgLTIgMTcgLTEwLjV0NyAtMTkuNXpNMTkyMCAxOTh2LTE0MHEwIC0xNiAtMTQ5IC0zMSBxLTEyIC0yNyAtMzAgLTUycTUxIC0xMTMgNTEgLTEzOHEwIC00IC00IC03cS0xMjIgLTcxIC0xMjQgLTcxcS04IDAgLTQ2IDQ3dC01MiA2OHEtMjAgLTIgLTMwIC0ydC0zMCAycS0xNCAtMjEgLTUyIC02OHQtNDYgLTQ3cS0yIDAgLTEyNCA3MXEtNCAzIC00IDdxMCAyNSA1MSAxMzhxLTE4IDI1IC0zMCA1MnEtMTQ5IDE1IC0xNDkgMzF2MTQwcTAgMTYgMTQ5IDMxcTEzIDI5IDMwIDUycS01MSAxMTMgLTUxIDEzOHEwIDQgNCA3cTQgMiAzNSAyMCB0NTkgMzR0MzAgMTZxOCAwIDQ2IC00Ni41dDUyIC02Ny41cTIwIDIgMzAgMnQzMCAtMnE1MSA3MSA5MiAxMTJsNiAycTQgMCAxMjQgLTcwcTQgLTMgNCAtN3EwIC0yNSAtNTEgLTEzOHExNyAtMjMgMzAgLTUycTE0OSAtMTUgMTQ5IC0zMXpNMTkyMCAxMjIydi0xNDBxMCAtMTYgLTE0OSAtMzFxLTEyIC0yNyAtMzAgLTUycTUxIC0xMTMgNTEgLTEzOHEwIC00IC00IC03cS0xMjIgLTcxIC0xMjQgLTcxcS04IDAgLTQ2IDQ3dC01MiA2OCBxLTIwIC0yIC0zMCAtMnQtMzAgMnEtMTQgLTIxIC01MiAtNjh0LTQ2IC00N3EtMiAwIC0xMjQgNzFxLTQgMyAtNCA3cTAgMjUgNTEgMTM4cS0xOCAyNSAtMzAgNTJxLTE0OSAxNSAtMTQ5IDMxdjE0MHEwIDE2IDE0OSAzMXExMyAyOSAzMCA1MnEtNTEgMTEzIC01MSAxMzhxMCA0IDQgN3E0IDIgMzUgMjB0NTkgMzR0MzAgMTZxOCAwIDQ2IC00Ni41dDUyIC02Ny41cTIwIDIgMzAgMnQzMCAtMnE1MSA3MSA5MiAxMTJsNiAycTQgMCAxMjQgLTcwIHE0IC0zIDQgLTdxMCAtMjUgLTUxIC0xMzhxMTcgLTIzIDMwIC01MnExNDkgLTE1IDE0OSAtMzF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwODY7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE0MDggNzY4cTAgLTEzOSAtOTQgLTI1N3QtMjU2LjUgLTE4Ni41dC0zNTMuNSAtNjguNXEtODYgMCAtMTc2IDE2cS0xMjQgLTg4IC0yNzggLTEyOHEtMzYgLTkgLTg2IC0xNmgtM3EtMTEgMCAtMjAuNSA4dC0xMS41IDIxcS0xIDMgLTEgNi41dDAuNSA2LjV0MiA2bDIuNSA1dDMuNSA1LjV0NCA1dDQuNSA1dDQgNC41cTUgNiAyMyAyNXQyNiAyOS41dDIyLjUgMjl0MjUgMzguNXQyMC41IDQ0cS0xMjQgNzIgLTE5NSAxNzd0LTcxIDIyNCBxMCAxMzkgOTQgMjU3dDI1Ni41IDE4Ni41dDM1My41IDY4LjV0MzUzLjUgLTY4LjV0MjU2LjUgLTE4Ni41dDk0IC0yNTd6TTE3OTIgNTEycTAgLTEyMCAtNzEgLTIyNC41dC0xOTUgLTE3Ni41cTEwIC0yNCAyMC41IC00NHQyNSAtMzguNXQyMi41IC0yOXQyNiAtMjkuNXQyMyAtMjVxMSAtMSA0IC00LjV0NC41IC01dDQgLTV0My41IC01LjVsMi41IC01dDIgLTZ0MC41IC02LjV0LTEgLTYuNXEtMyAtMTQgLTEzIC0yMnQtMjIgLTcgcS01MCA3IC04NiAxNnEtMTU0IDQwIC0yNzggMTI4cS05MCAtMTYgLTE3NiAtMTZxLTI3MSAwIC00NzIgMTMycTU4IC00IDg4IC00cTE2MSAwIDMwOSA0NXQyNjQgMTI5cTEyNSA5MiAxOTIgMjEydDY3IDI1NHEwIDc3IC0yMyAxNTJxMTI5IC03MSAyMDQgLTE3OHQ3NSAtMjMweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDg3OyIgZD0iTTI1NiAxOTJxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1ek0xNDA4IDc2OHEwIDUxIC0zOSA4OS41dC04OSAzOC41aC0zNTJxMCA1OCA0OCAxNTkuNXQ0OCAxNjAuNXEwIDk4IC0zMiAxNDV0LTEyOCA0N3EtMjYgLTI2IC0zOCAtODV0LTMwLjUgLTEyNS41dC01OS41IC0xMDkuNXEtMjIgLTIzIC03NyAtOTFxLTQgLTUgLTIzIC0zMHQtMzEuNSAtNDF0LTM0LjUgLTQyLjUgdC00MCAtNDR0LTM4LjUgLTM1LjV0LTQwIC0yN3QtMzUuNSAtOWgtMzJ2LTY0MGgzMnExMyAwIDMxLjUgLTN0MzMgLTYuNXQzOCAtMTF0MzUgLTExLjV0MzUuNSAtMTIuNXQyOSAtMTAuNXEyMTEgLTczIDM0MiAtNzNoMTIxcTE5MiAwIDE5MiAxNjdxMCAyNiAtNSA1NnEzMCAxNiA0Ny41IDUyLjV0MTcuNSA3My41dC0xOCA2OXE1MyA1MCA1MyAxMTlxMCAyNSAtMTAgNTUuNXQtMjUgNDcuNXEzMiAxIDUzLjUgNDd0MjEuNSA4MXpNMTUzNiA3NjkgcTAgLTg5IC00OSAtMTYzcTkgLTMzIDkgLTY5cTAgLTc3IC0zOCAtMTQ0cTMgLTIxIDMgLTQzcTAgLTEwMSAtNjAgLTE3OHExIC0xMzkgLTg1IC0yMTkuNXQtMjI3IC04MC41aC0zNmgtOTNxLTk2IDAgLTE4OS41IDIyLjV0LTIxNi41IDY1LjVxLTExNiA0MCAtMTM4IDQwaC0yODhxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41djY0MHEwIDUzIDM3LjUgOTAuNXQ5MC41IDM3LjVoMjc0cTM2IDI0IDEzNyAxNTVxNTggNzUgMTA3IDEyOCBxMjQgMjUgMzUuNSA4NS41dDMwLjUgMTI2LjV0NjIgMTA4cTM5IDM3IDkwIDM3cTg0IDAgMTUxIC0zMi41dDEwMiAtMTAxLjV0MzUgLTE4NnEwIC05MyAtNDggLTE5MmgxNzZxMTA0IDAgMTgwIC03NnQ3NiAtMTc5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDg4OyIgZD0iTTI1NiAxMDg4cTAgMjYgLTE5IDQ1dC00NSAxOXQtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXpNMTQwOCA1MTJxMCAzNSAtMjEuNSA4MXQtNTMuNSA0N3ExNSAxNyAyNSA0Ny41dDEwIDU1LjVxMCA2OSAtNTMgMTE5cTE4IDMyIDE4IDY5dC0xNy41IDczLjV0LTQ3LjUgNTIuNXE1IDMwIDUgNTZxMCA4NSAtNDkgMTI2dC0xMzYgNDFoLTEyOHEtMTMxIDAgLTM0MiAtNzNxLTUgLTIgLTI5IC0xMC41IHQtMzUuNSAtMTIuNXQtMzUgLTExLjV0LTM4IC0xMXQtMzMgLTYuNXQtMzEuNSAtM2gtMzJ2LTY0MGgzMnExNiAwIDM1LjUgLTl0NDAgLTI3dDM4LjUgLTM1LjV0NDAgLTQ0dDM0LjUgLTQyLjV0MzEuNSAtNDF0MjMgLTMwcTU1IC02OCA3NyAtOTFxNDEgLTQzIDU5LjUgLTEwOS41dDMwLjUgLTEyNS41dDM4IC04NXE5NiAwIDEyOCA0N3QzMiAxNDVxMCA1OSAtNDggMTYwLjV0LTQ4IDE1OS41aDM1MnE1MCAwIDg5IDM4LjV0MzkgODkuNXogTTE1MzYgNTExcTAgLTEwMyAtNzYgLTE3OXQtMTgwIC03NmgtMTc2cTQ4IC05OSA0OCAtMTkycTAgLTExOCAtMzUgLTE4NnEtMzUgLTY5IC0xMDIgLTEwMS41dC0xNTEgLTMyLjVxLTUxIDAgLTkwIDM3cS0zNCAzMyAtNTQgODJ0LTI1LjUgOTAuNXQtMTcuNSA4NC41dC0zMSA2NHEtNDggNTAgLTEwNyAxMjdxLTEwMSAxMzEgLTEzNyAxNTVoLTI3NHEtNTMgMCAtOTAuNSAzNy41dC0zNy41IDkwLjV2NjQwcTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNSBoMjg4cTIyIDAgMTM4IDQwcTEyOCA0NCAyMjMgNjZ0MjAwIDIyaDExMnExNDAgMCAyMjYuNSAtNzl0ODUuNSAtMjE2di01cTYwIC03NyA2MCAtMTc4cTAgLTIyIC0zIC00M3EzOCAtNjcgMzggLTE0NHEwIC0zNiAtOSAtNjlxNDkgLTc0IDQ5IC0xNjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwODk7IiBob3Jpei1hZHYteD0iODk2IiBkPSJNODMyIDE1MDR2LTEzMzlsLTQ0OSAtMjM2cS0yMiAtMTIgLTQwIC0xMnEtMjEgMCAtMzEuNSAxNC41dC0xMC41IDM1LjVxMCA2IDIgMjBsODYgNTAwbC0zNjQgMzU0cS0yNSAyNyAtMjUgNDhxMCAzNyA1NiA0Nmw1MDIgNzNsMjI1IDQ1NXExOSA0MSA0OSA0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA4YTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY2NCA5NDBxMCA4MSAtMjEuNSAxNDN0LTU1IDk4LjV0LTgxLjUgNTkuNXQtOTQgMzF0LTk4IDh0LTExMiAtMjUuNXQtMTEwLjUgLTY0dC04Ni41IC03MnQtNjAgLTYxLjVxLTE4IC0yMiAtNDkgLTIydC00OSAyMnEtMjQgMjggLTYwIDYxLjV0LTg2LjUgNzJ0LTExMC41IDY0dC0xMTIgMjUuNXQtOTggLTh0LTk0IC0zMXQtODEuNSAtNTkuNXQtNTUgLTk4LjV0LTIxLjUgLTE0M3EwIC0xNjggMTg3IC0zNTVsNTgxIC01NjBsNTgwIDU1OSBxMTg4IDE4OCAxODggMzU2ek0xNzkyIDk0MHEwIC0yMjEgLTIyOSAtNDUwbC02MjMgLTYwMHEtMTggLTE4IC00NCAtMTh0LTQ0IDE4bC02MjQgNjAycS0xMCA4IC0yNy41IDI2dC01NS41IDY1LjV0LTY4IDk3LjV0LTUzLjUgMTIxdC0yMy41IDEzOHEwIDIyMCAxMjcgMzQ0dDM1MSAxMjRxNjIgMCAxMjYuNSAtMjEuNXQxMjAgLTU4dDk1LjUgLTY4LjV0NzYgLTY4cTM2IDM2IDc2IDY4dDk1LjUgNjguNXQxMjAgNTh0MTI2LjUgMjEuNSBxMjI0IDAgMzUxIC0xMjR0MTI3IC0zNDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOGI7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTY0MCA5NnEwIC00IDEgLTIwdDAuNSAtMjYuNXQtMyAtMjMuNXQtMTAgLTE5LjV0LTIwLjUgLTYuNWgtMzIwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY3MDRxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDMyMHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjVxMCAtNCAxIC0yMHQwLjUgLTI2LjV0LTMgLTIzLjV0LTEwIC0xOS41dC0yMC41IC02LjVoLTMyMHEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3YtNzA0IHEwIC02NiA0NyAtMTEzdDExMyAtNDdoMjg4aDExaDEzdDExLjUgLTF0MTEuNSAtM3Q4IC01LjV0NyAtOXQyIC0xMy41ek0xNTY4IDY0MHEwIC0yNiAtMTkgLTQ1bC01NDQgLTU0NHEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5dC0xOSA0NXYyODhoLTQ0OHEtMjYgMCAtNDUgMTl0LTE5IDQ1djM4NHEwIDI2IDE5IDQ1dDQ1IDE5aDQ0OHYyODhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsNTQ0IC01NDRxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA4YzsiIGQ9Ik0yMzcgMTIyaDIzMXY2OTRoLTIzMXYtNjk0ek00ODMgMTAzMHEtMSA1MiAtMzYgODZ0LTkzIDM0dC05NC41IC0zNHQtMzYuNSAtODZxMCAtNTEgMzUuNSAtODUuNXQ5Mi41IC0zNC41aDFxNTkgMCA5NSAzNC41dDM2IDg1LjV6TTEwNjggMTIyaDIzMXYzOThxMCAxNTQgLTczIDIzM3QtMTkzIDc5cS0xMzYgMCAtMjA5IC0xMTdoMnYxMDFoLTIzMXEzIC02NiAwIC02OTRoMjMxdjM4OHEwIDM4IDcgNTZxMTUgMzUgNDUgNTkuNXQ3NCAyNC41IHExMTYgMCAxMTYgLTE1N3YtMzcxek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA4ZDsiIGhvcml6LWFkdi14PSIxMTUyIiBkPSJNNDgwIDY3MnY0NDhxMCAxNCAtOSAyM3QtMjMgOXQtMjMgLTl0LTkgLTIzdi00NDhxMCAtMTQgOSAtMjN0MjMgLTl0MjMgOXQ5IDIzek0xMTUyIDMyMHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTQyOWwtNTEgLTQ4M3EtMiAtMTIgLTEwLjUgLTIwLjV0LTIwLjUgLTguNWgtMXEtMjcgMCAtMzIgMjdsLTc2IDQ4NWgtNDA0cS0yNiAwIC00NSAxOXQtMTkgNDVxMCAxMjMgNzguNSAyMjEuNXQxNzcuNSA5OC41djUxMnEtNTIgMCAtOTAgMzggdC0zOCA5MHQzOCA5MHQ5MCAzOGg2NDBxNTIgMCA5MCAtMzh0MzggLTkwdC0zOCAtOTB0LTkwIC0zOHYtNTEycTk5IDAgMTc3LjUgLTk4LjV0NzguNSAtMjIxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOGU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE0MDggNjA4di0zMjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTgzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2ODMycTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg3MDRxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNzA0cS02NiAwIC0xMTMgLTQ3dC00NyAtMTEzdi04MzJxMCAtNjYgNDcgLTExM3QxMTMgLTQ3aDgzMnE2NiAwIDExMyA0N3Q0NyAxMTN2MzIwIHEwIDE0IDkgMjN0MjMgOWg2NHExNCAwIDIzIC05dDkgLTIzek0xNzkyIDE0NzJ2LTUxMnEwIC0yNiAtMTkgLTQ1dC00NSAtMTl0LTQ1IDE5bC0xNzYgMTc2bC02NTIgLTY1MnEtMTAgLTEwIC0yMyAtMTB0LTIzIDEwbC0xMTQgMTE0cS0xMCAxMCAtMTAgMjN0MTAgMjNsNjUyIDY1MmwtMTc2IDE3NnEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5aDUxMnEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOTA7IiBkPSJNMTE4NCA2NDBxMCAtMjYgLTE5IC00NWwtNTQ0IC01NDRxLTE5IC0xOSAtNDUgLTE5dC00NSAxOXQtMTkgNDV2Mjg4aC00NDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYzODRxMCAyNiAxOSA0NXQ0NSAxOWg0NDh2Mjg4cTAgMjYgMTkgNDV0NDUgMTl0NDUgLTE5bDU0NCAtNTQ0cTE5IC0xOSAxOSAtNDV6TTE1MzYgOTkydi03MDRxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTMyMHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41IHEwIDQgLTEgMjB0LTAuNSAyNi41dDMgMjMuNXQxMCAxOS41dDIwLjUgNi41aDMyMHE2NiAwIDExMyA0N3Q0NyAxMTN2NzA0cTAgNjYgLTQ3IDExM3QtMTEzIDQ3aC0yODhoLTExaC0xM3QtMTEuNSAxdC0xMS41IDN0LTggNS41dC03IDl0LTIgMTMuNXEwIDQgLTEgMjB0LTAuNSAyNi41dDMgMjMuNXQxMCAxOS41dDIwLjUgNi41aDMyMHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA5MTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNDU4IDY1M3EtNzQgMTYyIC03NCAzNzFoLTI1NnYtOTZxMCAtNzggOTQuNSAtMTYydDIzNS41IC0xMTN6TTE1MzYgOTI4djk2aC0yNTZxMCAtMjA5IC03NCAtMzcxcTE0MSAyOSAyMzUuNSAxMTN0OTQuNSAxNjJ6TTE2NjQgMTA1NnYtMTI4cTAgLTcxIC00MS41IC0xNDN0LTExMiAtMTMwdC0xNzMgLTk3LjV0LTIxNS41IC00NC41cS00MiAtNTQgLTk1IC05NXEtMzggLTM0IC01Mi41IC03Mi41dC0xNC41IC04OS41cTAgLTU0IDMwLjUgLTkxIHQ5Ny41IC0zN3E3NSAwIDEzMy41IC00NS41dDU4LjUgLTExNC41di02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC04MzJxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCA2OSA1OC41IDExNC41dDEzMy41IDQ1LjVxNjcgMCA5Ny41IDM3dDMwLjUgOTFxMCA1MSAtMTQuNSA4OS41dC01Mi41IDcyLjVxLTUzIDQxIC05NSA5NXEtMTEzIDUgLTIxNS41IDQ0LjV0LTE3MyA5Ny41dC0xMTIgMTMwdC00MS41IDE0M3YxMjhxMCA0MCAyOCA2OHQ2OCAyOGgyODh2OTYgcTAgNjYgNDcgMTEzdDExMyA0N2g1NzZxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTk2aDI4OHE0MCAwIDY4IC0yOHQyOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOTI7IiBkPSJNNTE5IDMzNnE0IDYgLTMgMTNxLTkgNyAtMTQgMnEtNCAtNiAzIC0xM3E5IC03IDE0IC0yek00OTEgMzc3cS01IDcgLTEyIDRxLTYgLTQgMCAtMTJxNyAtOCAxMiAtNXE2IDQgMCAxM3pNNDUwIDQxN3EyIDQgLTUgOHEtNyAyIC04IC0ycS0zIC01IDQgLThxOCAtMiA5IDJ6TTQ3MSAzOTRxMiAxIDEuNSA0LjV0LTMuNSA1LjVxLTYgNyAtMTAgM3QxIC0xMXE2IC02IDExIC0yek01NTcgMzE5cTIgNyAtOSAxMXEtOSAzIC0xMyAtNCBxLTIgLTcgOSAtMTFxOSAtMyAxMyA0ek01OTkgMzE2cTAgOCAtMTIgOHEtMTAgMCAtMTAgLTh0MTEgLTh0MTEgOHpNNjM4IDMyM3EtMiA3IC0xMyA1dC05IC05cTIgLTggMTIgLTZ0MTAgMTB6TTEyODAgNjQwcTAgMjEyIC0xNTAgMzYydC0zNjIgMTUwdC0zNjIgLTE1MHQtMTUwIC0zNjJxMCAtMTY3IDk4IC0zMDAuNXQyNTIgLTE4NS41cTE4IC0zIDI2LjUgNXQ4LjUgMjBxMCA1MiAtMSA5NXEtNiAtMSAtMTUuNSAtMi41dC0zNS41IC0ydC00OCA0IHQtNDMuNSAyMHQtMjkuNSA0MS41cS0yMyA1OSAtNTcgNzRxLTIgMSAtNC41IDMuNWwtOCA4dC03IDkuNXQ0IDcuNXQxOS41IDMuNXE2IDAgMTUgLTJ0MzAgLTE1LjV0MzMgLTM1LjVxMTYgLTI4IDM3LjUgLTQydDQzLjUgLTE0dDM4IDMuNXQzMCA5LjVxNyA0NyAzMyA2OXEtNDkgNiAtODYgMTguNXQtNzMgMzl0LTU1LjUgNzZ0LTE5LjUgMTE5LjVxMCA3OSA1MyAxMzdxLTI0IDYyIDUgMTM2cTE5IDYgNTQuNSAtNy41dDYwLjUgLTI5LjVsMjYgLTE2IHE1OCAxNyAxMjggMTd0MTI4IC0xN3ExMSA3IDI4LjUgMTh0NTUuNSAyNnQ1NyA5cTI5IC03NCA1IC0xMzZxNTMgLTU4IDUzIC0xMzdxMCAtNTcgLTE0IC0xMDAuNXQtMzUuNSAtNzB0LTUzLjUgLTQ0LjV0LTYyLjUgLTI2dC02OC41IC0xMnEzNSAtMzEgMzUgLTk1cTAgLTQwIC0wLjUgLTg5dC0wLjUgLTUxcTAgLTEyIDguNSAtMjB0MjYuNSAtNXExNTQgNTIgMjUyIDE4NS41dDk4IDMwMC41ek0xNTM2IDExMjB2LTk2MCBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOTM7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTEyODAgNjRxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1ek0xNTM2IDY0cTAgMjYgLTE5IDQ1dC00NSAxOXQtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXpNMTY2NCAyODh2LTMyMHEwIC00MCAtMjggLTY4dC02OCAtMjhoLTE0NzJxLTQwIDAgLTY4IDI4dC0yOCA2OHYzMjBxMCA0MCAyOCA2OHQ2OCAyOGg0MjdxMjEgLTU2IDcwLjUgLTkyIHQxMTAuNSAtMzZoMjU2cTYxIDAgMTEwLjUgMzZ0NzAuNSA5Mmg0MjdxNDAgMCA2OCAtMjh0MjggLTY4ek0xMzM5IDkzNnEtMTcgLTQwIC01OSAtNDBoLTI1NnYtNDQ4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMjU2cS0yNiAwIC00NSAxOXQtMTkgNDV2NDQ4aC0yNTZxLTQyIDAgLTU5IDQwcS0xNyAzOSAxNCA2OWw0NDggNDQ4cTE4IDE5IDQ1IDE5dDQ1IC0xOWw0NDggLTQ0OHEzMSAtMzAgMTQgLTY5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDk0OyIgZD0iTTE0MDcgNzEwcTAgNDQgLTcgMTEzLjV0LTE4IDk2LjVxLTEyIDMwIC0xNyA0NHQtOSAzNi41dC00IDQ4LjVxMCAyMyA1IDY4LjV0NSA2Ny41cTAgMzcgLTEwIDU1cS00IDEgLTEzIDFxLTE5IDAgLTU4IC00LjV0LTU5IC00LjVxLTYwIDAgLTE3NiAyNHQtMTc1IDI0cS00MyAwIC05NC41IC0xMS41dC04NSAtMjMuNXQtODkuNSAtMzRxLTEzNyAtNTQgLTIwMiAtMTAzcS05NiAtNzMgLTE1OS41IC0xODkuNXQtODggLTIzNnQtMjQuNSAtMjQ4LjUgcTAgLTQwIDEyLjUgLTEyMHQxMi41IC0xMjFxMCAtMjMgLTExIC02Ni41dC0xMSAtNjUuNXQxMiAtMzYuNXQzNCAtMTQuNXEyNCAwIDcyLjUgMTF0NzMuNSAxMXE1NyAwIDE2OS41IC0xNS41dDE2OS41IC0xNS41cTE4MSAwIDI4NCAzNnExMjkgNDUgMjM1LjUgMTUyLjV0MTY2IDI0NS41dDU5LjUgMjc1ek0xNTM1IDcxMnEwIC0xNjUgLTcwIC0zMjcuNXQtMTk2IC0yODh0LTI4MSAtMTgwLjVxLTEyNCAtNDQgLTMyNiAtNDQgcS01NyAwIC0xNzAgMTQuNXQtMTY5IDE0LjVxLTI0IDAgLTcyLjUgLTE0LjV0LTczLjUgLTE0LjVxLTczIDAgLTEyMy41IDU1LjV0LTUwLjUgMTI4LjVxMCAyNCAxMSA2OHQxMSA2N3EwIDQwIC0xMi41IDEyMC41dC0xMi41IDEyMS41cTAgMTExIDE4IDIxNy41dDU0LjUgMjA5LjV0MTAwLjUgMTk0dDE1MCAxNTZxNzggNTkgMjMyIDEyMHExOTQgNzggMzE2IDc4cTYwIDAgMTc1LjUgLTI0dDE3My41IC0yNHExOSAwIDU3IDV0NTggNSBxODEgMCAxMTggLTUwLjV0MzcgLTEzNC41cTAgLTIzIC01IC02OHQtNSAtNjhxMCAtMTAgMSAtMTguNXQzIC0xN3Q0IC0xMy41dDYuNSAtMTZ0Ni41IC0xN3ExNiAtNDAgMjUgLTExOC41dDkgLTEzNi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDk1OyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0xNDA4IDI5NnEwIC0yNyAtMTAgLTcwLjV0LTIxIC02OC41cS0yMSAtNTAgLTEyMiAtMTA2cS05NCAtNTEgLTE4NiAtNTFxLTI3IDAgLTUyLjUgMy41dC01Ny41IDEyLjV0LTQ3LjUgMTQuNXQtNTUuNSAyMC41dC00OSAxOHEtOTggMzUgLTE3NSA4M3EtMTI4IDc5IC0yNjQuNSAyMTUuNXQtMjE1LjUgMjY0LjVxLTQ4IDc3IC04MyAxNzVxLTMgOSAtMTggNDl0LTIwLjUgNTUuNXQtMTQuNSA0Ny41dC0xMi41IDU3LjV0LTMuNSA1Mi41IHEwIDkyIDUxIDE4NnE1NiAxMDEgMTA2IDEyMnEyNSAxMSA2OC41IDIxdDcwLjUgMTBxMTQgMCAyMSAtM3ExOCAtNiA1MyAtNzZxMTEgLTE5IDMwIC01NHQzNSAtNjMuNXQzMSAtNTMuNXEzIC00IDE3LjUgLTI1dDIxLjUgLTM1LjV0NyAtMjguNXEwIC0yMCAtMjguNSAtNTB0LTYyIC01NXQtNjIgLTUzdC0yOC41IC00NnEwIC05IDUgLTIyLjV0OC41IC0yMC41dDE0IC0yNHQxMS41IC0xOXE3NiAtMTM3IDE3NCAtMjM1dDIzNSAtMTc0IHEyIC0xIDE5IC0xMS41dDI0IC0xNHQyMC41IC04LjV0MjIuNSAtNXExOCAwIDQ2IDI4LjV0NTMgNjJ0NTUgNjJ0NTAgMjguNXExNCAwIDI4LjUgLTd0MzUuNSAtMjEuNXQyNSAtMTcuNXEyNSAtMTUgNTMuNSAtMzF0NjMuNSAtMzV0NTQgLTMwcTcwIC0zNSA3NiAtNTNxMyAtNyAzIC0yMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA5NjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTEyMCAxMjgwaC04MzJxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTN2LTgzMnEwIC02NiA0NyAtMTEzdDExMyAtNDdoODMycTY2IDAgMTEzIDQ3dDQ3IDExM3Y4MzJxMCA2NiAtNDcgMTEzdC0xMTMgNDd6TTE0MDggMTEyMHYtODMycTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC04MzJxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djgzMnEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoODMyIHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA5NzsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTE1MiAxMjgwaC0xMDI0di0xMjQybDQyMyA0MDZsODkgODVsODkgLTg1bDQyMyAtNDA2djEyNDJ6TTExNjQgMTQwOHEyMyAwIDQ0IC05cTMzIC0xMyA1Mi41IC00MXQxOS41IC02MnYtMTI4OXEwIC0zNCAtMTkuNSAtNjJ0LTUyLjUgLTQxcS0xOSAtOCAtNDQgLThxLTQ4IDAgLTgzIDMybC00NDEgNDI0bC00NDEgLTQyNHEtMzYgLTMzIC04MyAtMzNxLTIzIDAgLTQ0IDlxLTMzIDEzIC01Mi41IDQxdC0xOS41IDYydjEyODkgcTAgMzQgMTkuNSA2MnQ1Mi41IDQxcTIxIDkgNDQgOWgxMDQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDk4OyIgZD0iTTEyODAgMzQzcTAgMTEgLTIgMTZxLTMgOCAtMzguNSAyOS41dC04OC41IDQ5LjVsLTUzIDI5cS01IDMgLTE5IDEzdC0yNSAxNXQtMjEgNXEtMTggMCAtNDcgLTMyLjV0LTU3IC02NS41dC00NCAtMzNxLTcgMCAtMTYuNSAzLjV0LTE1LjUgNi41dC0xNyA5LjV0LTE0IDguNXEtOTkgNTUgLTE3MC41IDEyNi41dC0xMjYuNSAxNzAuNXEtMiAzIC04LjUgMTR0LTkuNSAxN3QtNi41IDE1LjV0LTMuNSAxNi41cTAgMTMgMjAuNSAzMy41dDQ1IDM4LjUgdDQ1IDM5LjV0MjAuNSAzNi41cTAgMTAgLTUgMjF0LTE1IDI1dC0xMyAxOXEtMyA2IC0xNSAyOC41dC0yNSA0NS41dC0yNi41IDQ3LjV0LTI1IDQwLjV0LTE2LjUgMTh0LTE2IDJxLTQ4IDAgLTEwMSAtMjJxLTQ2IC0yMSAtODAgLTk0LjV0LTM0IC0xMzAuNXEwIC0xNiAyLjUgLTM0dDUgLTMwLjV0OSAtMzN0MTAgLTI5LjV0MTIuNSAtMzN0MTEgLTMwcTYwIC0xNjQgMjE2LjUgLTMyMC41dDMyMC41IC0yMTYuNXE2IC0yIDMwIC0xMXQzMyAtMTIuNSB0MjkuNSAtMTB0MzMgLTl0MzAuNSAtNXQzNCAtMi41cTU3IDAgMTMwLjUgMzR0OTQuNSA4MHEyMiA1MyAyMiAxMDF6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDk5OyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNjIwIDExMjhxLTY3IC05OCAtMTYyIC0xNjdxMSAtMTQgMSAtNDJxMCAtMTMwIC0zOCAtMjU5LjV0LTExNS41IC0yNDguNXQtMTg0LjUgLTIxMC41dC0yNTggLTE0NnQtMzIzIC01NC41cS0yNzEgMCAtNDk2IDE0NXEzNSAtNCA3OCAtNHEyMjUgMCA0MDEgMTM4cS0xMDUgMiAtMTg4IDY0LjV0LTExNCAxNTkuNXEzMyAtNSA2MSAtNXE0MyAwIDg1IDExcS0xMTIgMjMgLTE4NS41IDExMS41dC03My41IDIwNS41djRxNjggLTM4IDE0NiAtNDEgcS02NiA0NCAtMTA1IDExNXQtMzkgMTU0cTAgODggNDQgMTYzcTEyMSAtMTQ5IDI5NC41IC0yMzguNXQzNzEuNSAtOTkuNXEtOCAzOCAtOCA3NHEwIDEzNCA5NC41IDIyOC41dDIyOC41IDk0LjVxMTQwIDAgMjM2IC0xMDJxMTA5IDIxIDIwNSA3OHEtMzcgLTExNSAtMTQyIC0xNzhxOTMgMTAgMTg2IDUweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDlhOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik05NTkgMTUyNHYtMjY0aC0xNTdxLTg2IDAgLTExNiAtMzZ0LTMwIC0xMDh2LTE4OWgyOTNsLTM5IC0yOTZoLTI1NHYtNzU5aC0zMDZ2NzU5aC0yNTV2Mjk2aDI1NXYyMThxMCAxODYgMTA0IDI4OC41dDI3NyAxMDIuNXExNDcgMCAyMjggLTEyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMDliOyIgZD0iTTc2OCAxNDA4cTIwOSAwIDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjVxMCAtMjUxIC0xNDYuNSAtNDUxLjV0LTM3OC41IC0yNzcuNXEtMjcgLTUgLTQwIDd0LTEzIDMwcTAgMyAwLjUgNzYuNXQwLjUgMTM0LjVxMCA5NyAtNTIgMTQycTU3IDYgMTAyLjUgMTh0OTQgMzl0ODEgNjYuNXQ1MyAxMDV0MjAuNSAxNTAuNXEwIDExOSAtNzkgMjA2cTM3IDkxIC04IDIwNHEtMjggOSAtODEgLTExdC05MiAtNDRsLTM4IC0yNCBxLTkzIDI2IC0xOTIgMjZ0LTE5MiAtMjZxLTE2IDExIC00Mi41IDI3dC04My41IDM4LjV0LTg1IDEzLjVxLTQ1IC0xMTMgLTggLTIwNHEtNzkgLTg3IC03OSAtMjA2cTAgLTg1IDIwLjUgLTE1MHQ1Mi41IC0xMDV0ODAuNSAtNjd0OTQgLTM5dDEwMi41IC0xOHEtMzkgLTM2IC00OSAtMTAzcS0yMSAtMTAgLTQ1IC0xNXQtNTcgLTV0LTY1LjUgMjEuNXQtNTUuNSA2Mi41cS0xOSAzMiAtNDguNSA1MnQtNDkuNSAyNGwtMjAgM3EtMjEgMCAtMjkgLTQuNSB0LTUgLTExLjV0OSAtMTR0MTMgLTEybDcgLTVxMjIgLTEwIDQzLjUgLTM4dDMxLjUgLTUxbDEwIC0yM3ExMyAtMzggNDQgLTYxLjV0NjcgLTMwdDY5LjUgLTd0NTUuNSAzLjVsMjMgNHEwIC0zOCAwLjUgLTg4LjV0MC41IC01NC41cTAgLTE4IC0xMyAtMzB0LTQwIC03cS0yMzIgNzcgLTM3OC41IDI3Ny41dC0xNDYuNSA0NTEuNXEwIDIwOSAxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzek0yOTEgMzA1cTMgNyAtNyAxMiBxLTEwIDMgLTEzIC0ycS0zIC03IDcgLTEycTkgLTYgMTMgMnpNMzIyIDI3MXE3IDUgLTIgMTZxLTEwIDkgLTE2IDNxLTcgLTUgMiAtMTZxMTAgLTEwIDE2IC0zek0zNTIgMjI2cTkgNyAwIDE5cS04IDEzIC0xNyA2cS05IC01IDAgLTE4dDE3IC03ek0zOTQgMTg0cTggOCAtNCAxOXEtMTIgMTIgLTIwIDNxLTkgLTggNCAtMTlxMTIgLTEyIDIwIC0zek00NTEgMTU5cTMgMTEgLTEzIDE2cS0xNSA0IC0xOSAtN3QxMyAtMTVxMTUgLTYgMTkgNnogTTUxNCAxNTRxMCAxMyAtMTcgMTFxLTE2IDAgLTE2IC0xMXEwIC0xMyAxNyAtMTFxMTYgMCAxNiAxMXpNNTcyIDE2NHEtMiAxMSAtMTggOXEtMTYgLTMgLTE0IC0xNXQxOCAtOHQxNCAxNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA5YzsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTY2NCA5NjB2LTI1NnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTY0cS0yNiAwIC00NSAxOXQtMTkgNDV2MjU2cTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXYtMTkyaDk2cTQwIDAgNjggLTI4dDI4IC02OHYtNTc2cTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtOTYwcS00MCAwIC02OCAyOHQtMjggNjh2NTc2cTAgNDAgMjggNjh0NjggMjhoNjcydjE5MnEwIDE4NSAxMzEuNSAzMTYuNXQzMTYuNSAxMzEuNSB0MzE2LjUgLTEzMS41dDEzMS41IC0zMTYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA5ZDsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNMTc2MCAxNDA4cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi0xMjE2cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xNjAwcS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMjE2cTAgNjYgNDcgMTEzdDExMyA0N2gxNjAwek0xNjAgMTI4MHEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTIyNGgxNjY0djIyNHEwIDEzIC05LjUgMjIuNXQtMjIuNSA5LjVoLTE2MDB6TTE3NjAgMHExMyAwIDIyLjUgOS41dDkuNSAyMi41djYwOGgtMTY2NHYtNjA4IHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDE2MDB6TTI1NiAxMjh2MTI4aDI1NnYtMTI4aC0yNTZ6TTY0MCAxMjh2MTI4aDM4NHYtMTI4aC0zODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwOWU7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTM4NCAxOTJxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2dDU2IDEzNnQxMzYgNTZ0MTM2IC01NnQ1NiAtMTM2ek04OTYgNjlxMiAtMjggLTE3IC00OHEtMTggLTIxIC00NyAtMjFoLTEzNXEtMjUgMCAtNDMgMTYuNXQtMjAgNDEuNXEtMjIgMjI5IC0xODQuNSAzOTEuNXQtMzkxLjUgMTg0LjVxLTI1IDIgLTQxLjUgMjB0LTE2LjUgNDN2MTM1cTAgMjkgMjEgNDdxMTcgMTcgNDMgMTdoNXExNjAgLTEzIDMwNiAtODAuNSB0MjU5IC0xODEuNXExMTQgLTExMyAxODEuNSAtMjU5dDgwLjUgLTMwNnpNMTQwOCA2N3EyIC0yNyAtMTggLTQ3cS0xOCAtMjAgLTQ2IC0yMGgtMTQzcS0yNiAwIC00NC41IDE3LjV0LTE5LjUgNDIuNXEtMTIgMjE1IC0xMDEgNDA4LjV0LTIzMS41IDMzNnQtMzM2IDIzMS41dC00MDguNSAxMDJxLTI1IDEgLTQyLjUgMTkuNXQtMTcuNSA0My41djE0M3EwIDI4IDIwIDQ2cTE4IDE4IDQ0IDE4aDNxMjYyIC0xMyA1MDEuNSAtMTIwdDQyNS41IC0yOTQgcTE4NyAtMTg2IDI5NCAtNDI1LjV0MTIwIC01MDEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhMDsiIGQ9Ik0xMDQwIDMyMHEwIC0zMyAtMjMuNSAtNTYuNXQtNTYuNSAtMjMuNXQtNTYuNSAyMy41dC0yMy41IDU2LjV0MjMuNSA1Ni41dDU2LjUgMjMuNXQ1Ni41IC0yMy41dDIzLjUgLTU2LjV6TTEyOTYgMzIwcTAgLTMzIC0yMy41IC01Ni41dC01Ni41IC0yMy41dC01Ni41IDIzLjV0LTIzLjUgNTYuNXQyMy41IDU2LjV0NTYuNSAyMy41dDU2LjUgLTIzLjV0MjMuNSAtNTYuNXpNMTQwOCAxNjB2MzIwcTAgMTMgLTkuNSAyMi41dC0yMi41IDkuNSBoLTEyMTZxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di0zMjBxMCAtMTMgOS41IC0yMi41dDIyLjUgLTkuNWgxMjE2cTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE3OCA2NDBoMTE4MGwtMTU3IDQ4MnEtNCAxMyAtMTYgMjEuNXQtMjYgOC41aC03ODJxLTE0IDAgLTI2IC04LjV0LTE2IC0yMS41ek0xNTM2IDQ4MHYtMzIwcTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xMjE2cS02NiAwIC0xMTMgNDd0LTQ3IDExM3YzMjBxMCAyNSAxNiA3NSBsMTk3IDYwNnExNyA1MyA2MyA4NnQxMDEgMzNoNzgycTU1IDAgMTAxIC0zM3Q2MyAtODZsMTk3IC02MDZxMTYgLTUwIDE2IC03NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhMTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY2NCA4OTZxNTMgMCA5MC41IC0zNy41dDM3LjUgLTkwLjV0LTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV2LTM4NHEwIC01MiAtMzggLTkwdC05MCAtMzhxLTQxNyAzNDcgLTgxMiAzODBxLTU4IC0xOSAtOTEgLTY2dC0zMSAtMTAwLjV0NDAgLTkyLjVxLTIwIC0zMyAtMjMgLTY1LjV0NiAtNTh0MzMuNSAtNTV0NDggLTUwdDYxLjUgLTUwLjVxLTI5IC01OCAtMTExLjUgLTgzdC0xNjguNSAtMTEuNXQtMTMyIDU1LjVxLTcgMjMgLTI5LjUgODcuNSB0LTMyIDk0LjV0LTIzIDg5dC0xNSAxMDF0My41IDk4LjV0MjIgMTEwLjVoLTEyMnEtNjYgMCAtMTEzIDQ3dC00NyAxMTN2MTkycTAgNjYgNDcgMTEzdDExMyA0N2g0ODBxNDM1IDAgODk2IDM4NHE1MiAwIDkwIC0zOHQzOCAtOTB2LTM4NHpNMTUzNiAyOTJ2OTU0cS0zOTQgLTMwMiAtNzY4IC0zNDN2LTI3MHEzNzcgLTQyIDc2OCAtMzQxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGEyOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik05MTIgLTE2MHEwIDE2IC0xNiAxNnEtNTkgMCAtMTAxLjUgNDIuNXQtNDIuNSAxMDEuNXEwIDE2IC0xNiAxNnQtMTYgLTE2cTAgLTczIDUxLjUgLTEyNC41dDEyNC41IC01MS41cTE2IDAgMTYgMTZ6TTI0NiAxMjhoMTMwMHEtMjY2IDMwMCAtMjY2IDgzMnEwIDUxIC0yNCAxMDV0LTY5IDEwM3QtMTIxLjUgODAuNXQtMTY5LjUgMzEuNXQtMTY5LjUgLTMxLjV0LTEyMS41IC04MC41dC02OSAtMTAzdC0yNCAtMTA1cTAgLTUzMiAtMjY2IC04MzJ6IE0xNzI4IDEyOHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTQ0OHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MSA3NXQtNzUgMTgxaC00NDhxLTUyIDAgLTkwIDM4dC0zOCA5MHE1MCA0MiA5MSA4OHQ4NSAxMTkuNXQ3NC41IDE1OC41dDUwIDIwNnQxOS41IDI2MHEwIDE1MiAxMTcgMjgyLjV0MzA3IDE1OC41cS04IDE5IC04IDM5cTAgNDAgMjggNjh0NjggMjh0NjggLTI4dDI4IC02OHEwIC0yMCAtOCAtMzlxMTkwIC0yOCAzMDcgLTE1OC41IHQxMTcgLTI4Mi41cTAgLTEzOSAxOS41IC0yNjB0NTAgLTIwNnQ3NC41IC0xNTguNXQ4NSAtMTE5LjV0OTEgLTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGEzOyIgZD0iTTEzNzYgNjQwbDEzOCAtMTM1cTMwIC0yOCAyMCAtNzBxLTEyIC00MSAtNTIgLTUxbC0xODggLTQ4bDUzIC0xODZxMTIgLTQxIC0xOSAtNzBxLTI5IC0zMSAtNzAgLTE5bC0xODYgNTNsLTQ4IC0xODhxLTEwIC00MCAtNTEgLTUycS0xMiAtMiAtMTkgLTJxLTMxIDAgLTUxIDIybC0xMzUgMTM4bC0xMzUgLTEzOHEtMjggLTMwIC03MCAtMjBxLTQxIDExIC01MSA1MmwtNDggMTg4bC0xODYgLTUzcS00MSAtMTIgLTcwIDE5cS0zMSAyOSAtMTkgNzAgbDUzIDE4NmwtMTg4IDQ4cS00MCAxMCAtNTIgNTFxLTEwIDQyIDIwIDcwbDEzOCAxMzVsLTEzOCAxMzVxLTMwIDI4IC0yMCA3MHExMiA0MSA1MiA1MWwxODggNDhsLTUzIDE4NnEtMTIgNDEgMTkgNzBxMjkgMzEgNzAgMTlsMTg2IC01M2w0OCAxODhxMTAgNDEgNTEgNTFxNDEgMTIgNzAgLTE5bDEzNSAtMTM5bDEzNSAxMzlxMjkgMzAgNzAgMTlxNDEgLTEwIDUxIC01MWw0OCAtMTg4bDE4NiA1M3E0MSAxMiA3MCAtMTlxMzEgLTI5IDE5IC03MCBsLTUzIC0xODZsMTg4IC00OHE0MCAtMTAgNTIgLTUxcTEwIC00MiAtMjAgLTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGE0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0yNTYgMTkycTAgMjYgLTE5IDQ1dC00NSAxOXQtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXpNMTY2NCA3NjhxMCA1MSAtMzkgODkuNXQtODkgMzguNWgtNTc2cTAgMjAgMTUgNDguNXQzMyA1NXQzMyA2OHQxNSA4NC41cTAgNjcgLTQ0LjUgOTcuNXQtMTE1LjUgMzAuNXEtMjQgMCAtOTAgLTEzOXEtMjQgLTQ0IC0zNyAtNjVxLTQwIC02NCAtMTEyIC0xNDVxLTcxIC04MSAtMTAxIC0xMDYgcS02OSAtNTcgLTE0MCAtNTdoLTMydi02NDBoMzJxNzIgMCAxNjcgLTMydDE5My41IC02NHQxNzkuNSAtMzJxMTg5IDAgMTg5IDE2N3EwIDI2IC01IDU2cTMwIDE2IDQ3LjUgNTIuNXQxNy41IDczLjV0LTE4IDY5cTUzIDUwIDUzIDExOXEwIDI1IC0xMCA1NS41dC0yNSA0Ny41aDMzMXE1MiAwIDkwIDM4dDM4IDkwek0xNzkyIDc2OXEwIC0xMDUgLTc1LjUgLTE4MXQtMTgwLjUgLTc2aC0xNjlxLTQgLTYyIC0zNyAtMTE5cTMgLTIxIDMgLTQzIHEwIC0xMDEgLTYwIC0xNzhxMSAtMTM5IC04NSAtMjE5LjV0LTIyNyAtODAuNXEtMTMzIDAgLTMyMiA2OXEtMTY0IDU5IC0yMjMgNTloLTI4OHEtNTMgMCAtOTAuNSAzNy41dC0zNy41IDkwLjV2NjQwcTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNWgyODhxMTAgMCAyMS41IDQuNXQyMy41IDE0dDIyLjUgMTh0MjQgMjIuNXQyMC41IDIxLjV0MTkgMjEuNXQxNCAxN3E2NSA3NCAxMDAgMTI5cTEzIDIxIDMzIDYydDM3IDcydDQwLjUgNjN0NTUgNDkuNSB0NjkuNSAxNy41cTEyNSAwIDIwNi41IC02N3Q4MS41IC0xODlxMCAtNjggLTIyIC0xMjhoMzc0cTEwNCAwIDE4MCAtNzZ0NzYgLTE3OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhNTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTM3NiAxMjhoMzJ2NjQwaC0zMnEtMzUgMCAtNjcuNSAxMnQtNjIuNSAzN3QtNTAgNDZ0LTQ5IDU0cS0yIDMgLTMuNSA0LjV0LTQgNC41dC00LjUgNXEtNzIgODEgLTExMiAxNDVxLTE0IDIyIC0zOCA2OHEtMSAzIC0xMC41IDIyLjV0LTE4LjUgMzZ0LTIwIDM1LjV0LTIxLjUgMzAuNXQtMTguNSAxMS41cS03MSAwIC0xMTUuNSAtMzAuNXQtNDQuNSAtOTcuNXEwIC00MyAxNSAtODQuNXQzMyAtNjh0MzMgLTU1dDE1IC00OC41aC01NzYgcS01MCAwIC04OSAtMzguNXQtMzkgLTg5LjVxMCAtNTIgMzggLTkwdDkwIC0zOGgzMzFxLTE1IC0xNyAtMjUgLTQ3LjV0LTEwIC01NS41cTAgLTY5IDUzIC0xMTlxLTE4IC0zMiAtMTggLTY5dDE3LjUgLTczLjV0NDcuNSAtNTIuNXEtNCAtMjQgLTQgLTU2cTAgLTg1IDQ4LjUgLTEyNnQxMzUuNSAtNDFxODQgMCAxODMgMzJ0MTk0IDY0dDE2NyAzMnpNMTY2NCAxOTJxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDUgdDQ1IC0xOXQ0NSAxOXQxOSA0NXpNMTc5MiA3Njh2LTY0MHEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNWgtMjg4cS01OSAwIC0yMjMgLTU5cS0xOTAgLTY5IC0zMTcgLTY5cS0xNDIgMCAtMjMwIDc3LjV0LTg3IDIxNy41bDEgNXEtNjEgNzYgLTYxIDE3OHEwIDIyIDMgNDNxLTMzIDU3IC0zNyAxMTloLTE2OXEtMTA1IDAgLTE4MC41IDc2dC03NS41IDE4MXEwIDEwMyA3NiAxNzl0MTgwIDc2aDM3NHEtMjIgNjAgLTIyIDEyOCBxMCAxMjIgODEuNSAxODl0MjA2LjUgNjdxMzggMCA2OS41IC0xNy41dDU1IC00OS41dDQwLjUgLTYzdDM3IC03MnQzMyAtNjJxMzUgLTU1IDEwMCAtMTI5cTIgLTMgMTQgLTE3dDE5IC0yMS41dDIwLjUgLTIxLjV0MjQgLTIyLjV0MjIuNSAtMTh0MjMuNSAtMTR0MjEuNSAtNC41aDI4OHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhNjsiIGQ9Ik0xMjgwIC02NHEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE0MDggNzAwcTAgMTg5IC0xNjcgMTg5cS0yNiAwIC01NiAtNXEtMTYgMzAgLTUyLjUgNDcuNXQtNzMuNSAxNy41dC02OSAtMThxLTUwIDUzIC0xMTkgNTNxLTI1IDAgLTU1LjUgLTEwdC00Ny41IC0yNXYzMzFxMCA1MiAtMzggOTB0LTkwIDM4cS01MSAwIC04OS41IC0zOXQtMzguNSAtODl2LTU3NiBxLTIwIDAgLTQ4LjUgMTV0LTU1IDMzdC02OCAzM3QtODQuNSAxNXEtNjcgMCAtOTcuNSAtNDQuNXQtMzAuNSAtMTE1LjVxMCAtMjQgMTM5IC05MHE0NCAtMjQgNjUgLTM3cTY0IC00MCAxNDUgLTExMnE4MSAtNzEgMTA2IC0xMDFxNTcgLTY5IDU3IC0xNDB2LTMyaDY0MHYzMnEwIDcyIDMyIDE2N3Q2NCAxOTMuNXQzMiAxNzkuNXpNMTUzNiA3MDVxMCAtMTMzIC02OSAtMzIycS01OSAtMTY0IC01OSAtMjIzdi0yODhxMCAtNTMgLTM3LjUgLTkwLjUgdC05MC41IC0zNy41aC02NDBxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41djI4OHEwIDEwIC00LjUgMjEuNXQtMTQgMjMuNXQtMTggMjIuNXQtMjIuNSAyNHQtMjEuNSAyMC41dC0yMS41IDE5dC0xNyAxNHEtNzQgNjUgLTEyOSAxMDBxLTIxIDEzIC02MiAzM3QtNzIgMzd0LTYzIDQwLjV0LTQ5LjUgNTV0LTE3LjUgNjkuNXEwIDEyNSA2NyAyMDYuNXQxODkgODEuNXE2OCAwIDEyOCAtMjJ2Mzc0cTAgMTA0IDc2IDE4MHQxNzkgNzYgcTEwNSAwIDE4MSAtNzUuNXQ3NiAtMTgwLjV2LTE2OXE2MiAtNCAxMTkgLTM3cTIxIDMgNDMgM3ExMDEgMCAxNzggLTYwcTEzOSAxIDIxOS41IC04NXQ4MC41IC0yMjd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYTc7IiBkPSJNMTQwOCA1NzZxMCA4NCAtMzIgMTgzdC02NCAxOTR0LTMyIDE2N3YzMmgtNjQwdi0zMnEwIC0zNSAtMTIgLTY3LjV0LTM3IC02Mi41dC00NiAtNTB0LTU0IC00OXEtOSAtOCAtMTQgLTEycS04MSAtNzIgLTE0NSAtMTEycS0yMiAtMTQgLTY4IC0zOHEtMyAtMSAtMjIuNSAtMTAuNXQtMzYgLTE4LjV0LTM1LjUgLTIwdC0zMC41IC0yMS41dC0xMS41IC0xOC41cTAgLTcxIDMwLjUgLTExNS41dDk3LjUgLTQ0LjVxNDMgMCA4NC41IDE1dDY4IDMzIHQ1NSAzM3Q0OC41IDE1di01NzZxMCAtNTAgMzguNSAtODl0ODkuNSAtMzlxNTIgMCA5MCAzOHQzOCA5MHYzMzFxNDYgLTM1IDEwMyAtMzVxNjkgMCAxMTkgNTNxMzIgLTE4IDY5IC0xOHQ3My41IDE3LjV0NTIuNSA0Ny41cTI0IC00IDU2IC00cTg1IDAgMTI2IDQ4LjV0NDEgMTM1LjV6TTEyODAgMTM0NHEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE1MzYgNTgwIHEwIC0xNDIgLTc3LjUgLTIzMHQtMjE3LjUgLTg3bC01IDFxLTc2IC02MSAtMTc4IC02MXEtMjIgMCAtNDMgM3EtNTQgLTMwIC0xMTkgLTM3di0xNjlxMCAtMTA1IC03NiAtMTgwLjV0LTE4MSAtNzUuNXEtMTAzIDAgLTE3OSA3NnQtNzYgMTgwdjM3NHEtNTQgLTIyIC0xMjggLTIycS0xMjEgMCAtMTg4LjUgODEuNXQtNjcuNSAyMDYuNXEwIDM4IDE3LjUgNjkuNXQ0OS41IDU1dDYzIDQwLjV0NzIgMzd0NjIgMzNxNTUgMzUgMTI5IDEwMCBxMyAyIDE3IDE0dDIxLjUgMTl0MjEuNSAyMC41dDIyLjUgMjR0MTggMjIuNXQxNCAyMy41dDQuNSAyMS41djI4OHEwIDUzIDM3LjUgOTAuNXQ5MC41IDM3LjVoNjQwcTUzIDAgOTAuNSAtMzcuNXQzNy41IC05MC41di0yODhxMCAtNTkgNTkgLTIyM3E2OSAtMTkwIDY5IC0zMTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYTg7IiBkPSJNMTI4MCA1NzZ2MTI4cTAgMjYgLTE5IDQ1dC00NSAxOWgtNTAybDE4OSAxODlxMTkgMTkgMTkgNDV0LTE5IDQ1bC05MSA5MXEtMTggMTggLTQ1IDE4dC00NSAtMThsLTM2MiAtMzYybC05MSAtOTFxLTE4IC0xOCAtMTggLTQ1dDE4IC00NWw5MSAtOTFsMzYyIC0zNjJxMTggLTE4IDQ1IC0xOHQ0NSAxOGw5MSA5MXExOCAxOCAxOCA0NXQtMTggNDVsLTE4OSAxODloNTAycTI2IDAgNDUgMTl0MTkgNDV6TTE1MzYgNjQwIHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhOTsiIGQ9Ik0xMjg1IDY0MHEwIDI3IC0xOCA0NWwtOTEgOTFsLTM2MiAzNjJxLTE4IDE4IC00NSAxOHQtNDUgLTE4bC05MSAtOTFxLTE4IC0xOCAtMTggLTQ1dDE4IC00NWwxODkgLTE4OWgtNTAycS0yNiAwIC00NSAtMTl0LTE5IC00NXYtMTI4cTAgLTI2IDE5IC00NXQ0NSAtMTloNTAybC0xODkgLTE4OXEtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDkxIC05MXExOCAtMTggNDUgLTE4dDQ1IDE4bDM2MiAzNjJsOTEgOTFxMTggMTggMTggNDV6TTE1MzYgNjQwIHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhYTsiIGQ9Ik0xMjg0IDY0MXEwIDI3IC0xOCA0NWwtMzYyIDM2MmwtOTEgOTFxLTE4IDE4IC00NSAxOHQtNDUgLTE4bC05MSAtOTFsLTM2MiAtMzYycS0xOCAtMTggLTE4IC00NXQxOCAtNDVsOTEgLTkxcTE4IC0xOCA0NSAtMTh0NDUgMThsMTg5IDE4OXYtNTAycTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV2NTAybDE4OSAtMTg5cTE5IC0xOSA0NSAtMTl0NDUgMTlsOTEgOTFxMTggMTggMTggNDV6TTE1MzYgNjQwIHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhYjsiIGQ9Ik0xMjg0IDYzOXEwIDI3IC0xOCA0NWwtOTEgOTFxLTE4IDE4IC00NSAxOHQtNDUgLTE4bC0xODkgLTE4OXY1MDJxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di01MDJsLTE4OSAxODlxLTE5IDE5IC00NSAxOXQtNDUgLTE5bC05MSAtOTFxLTE4IC0xOCAtMTggLTQ1dDE4IC00NWwzNjIgLTM2Mmw5MSAtOTFxMTggLTE4IDQ1IC0xOHQ0NSAxOGw5MSA5MWwzNjIgMzYycTE4IDE4IDE4IDQ1ek0xNTM2IDY0MCBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYWM7IiBkPSJNNzY4IDE0MDhxMjA5IDAgMzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXQtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3pNMTA0MiA4ODdxLTIgLTEgLTkuNSAtOS41dC0xMy41IC05LjVxMiAwIDQuNSA1dDUgMTF0My41IDdxNiA3IDIyIDE1cTE0IDYgNTIgMTJxMzQgOCA1MSAtMTEgcS0yIDIgOS41IDEzdDE0LjUgMTJxMyAyIDE1IDQuNXQxNSA3LjVsMiAyMnEtMTIgLTEgLTE3LjUgN3QtNi41IDIxcTAgLTIgLTYgLThxMCA3IC00LjUgOHQtMTEuNSAtMXQtOSAtMXEtMTAgMyAtMTUgNy41dC04IDE2LjV0LTQgMTVxLTIgNSAtOS41IDEwLjV0LTkuNSAxMC41cS0xIDIgLTIuNSA1LjV0LTMgNi41dC00IDUuNXQtNS41IDIuNXQtNyAtNXQtNy41IC0xMHQtNC41IC01cS0zIDIgLTYgMS41dC00LjUgLTF0LTQuNSAtM3QtNSAtMy41IHEtMyAtMiAtOC41IC0zdC04LjUgLTJxMTUgNSAtMSAxMXEtMTAgNCAtMTYgM3E5IDQgNy41IDEydC04LjUgMTRoNXEtMSA0IC04LjUgOC41dC0xNy41IDguNXQtMTMgNnEtOCA1IC0zNCA5LjV0LTMzIDAuNXEtNSAtNiAtNC41IC0xMC41dDQgLTE0dDMuNSAtMTIuNXExIC02IC01LjUgLTEzdC02LjUgLTEycTAgLTcgMTQgLTE1LjV0MTAgLTIxLjVxLTMgLTggLTE2IC0xNnQtMTYgLTEycS01IC04IC0xLjUgLTE4LjV0MTAuNSAtMTYuNSBxMiAtMiAxLjUgLTR0LTMuNSAtNC41dC01LjUgLTR0LTYuNSAtMy41bC0zIC0ycS0xMSAtNSAtMjAuNSA2dC0xMy41IDI2cS03IDI1IC0xNiAzMHEtMjMgOCAtMjkgLTFxLTUgMTMgLTQxIDI2cS0yNSA5IC01OCA0cTYgMSAwIDE1cS03IDE1IC0xOSAxMnEzIDYgNCAxNy41dDEgMTMuNXEzIDEzIDEyIDIzcTEgMSA3IDguNXQ5LjUgMTMuNXQwLjUgNnEzNSAtNCA1MCAxMXE1IDUgMTEuNSAxN3QxMC41IDE3cTkgNiAxNCA1LjV0MTQuNSAtNS41IHQxNC41IC01cTE0IC0xIDE1LjUgMTF0LTcuNSAyMHExMiAtMSAzIDE3cS01IDcgLTggOXEtMTIgNCAtMjcgLTVxLTggLTQgMiAtOHEtMSAxIC05LjUgLTEwLjV0LTE2LjUgLTE3LjV0LTE2IDVxLTEgMSAtNS41IDEzLjV0LTkuNSAxMy41cS04IDAgLTE2IC0xNXEzIDggLTExIDE1dC0yNCA4cTE5IDEyIC04IDI3cS03IDQgLTIwLjUgNXQtMTkuNSAtNHEtNSAtNyAtNS41IC0xMS41dDUgLTh0MTAuNSAtNS41dDExLjUgLTR0OC41IC0zIHExNCAtMTAgOCAtMTRxLTIgLTEgLTguNSAtMy41dC0xMS41IC00LjV0LTYgLTRxLTMgLTQgMCAtMTR0LTIgLTE0cS01IDUgLTkgMTcuNXQtNyAxNi41cTcgLTkgLTI1IC02bC0xMCAxcS00IDAgLTE2IC0ydC0yMC41IC0xdC0xMy41IDhxLTQgOCAwIDIwcTEgNCA0IDJxLTQgMyAtMTEgOS41dC0xMCA4LjVxLTQ2IC0xNSAtOTQgLTQxcTYgLTEgMTIgMXE1IDIgMTMgNi41dDEwIDUuNXEzNCAxNCA0MiA3bDUgNXExNCAtMTYgMjAgLTI1IHEtNyA0IC0zMCAxcS0yMCAtNiAtMjIgLTEycTcgLTEyIDUgLTE4cS00IDMgLTExLjUgMTB0LTE0LjUgMTF0LTE1IDVxLTE2IDAgLTIyIC0xcS0xNDYgLTgwIC0yMzUgLTIyMnE3IC03IDEyIC04cTQgLTEgNSAtOXQyLjUgLTExdDExLjUgM3E5IC04IDMgLTE5cTEgMSA0NCAtMjdxMTkgLTE3IDIxIC0yMXEzIC0xMSAtMTAgLTE4cS0xIDIgLTkgOXQtOSA0cS0zIC01IDAuNSAtMTguNXQxMC41IC0xMi41cS03IDAgLTkuNSAtMTZ0LTIuNSAtMzUuNSB0LTEgLTIzLjVsMiAtMXEtMyAtMTIgNS41IC0zNC41dDIxLjUgLTE5LjVxLTEzIC0zIDIwIC00M3E2IC04IDggLTlxMyAtMiAxMiAtNy41dDE1IC0xMHQxMCAtMTAuNXE0IC01IDEwIC0yMi41dDE0IC0yMy41cS0yIC02IDkuNSAtMjB0MTAuNSAtMjNxLTEgMCAtMi41IC0xdC0yLjUgLTFxMyAtNyAxNS41IC0xNHQxNS41IC0xM3ExIC0zIDIgLTEwdDMgLTExdDggLTJxMiAyMCAtMjQgNjJxLTE1IDI1IC0xNyAyOXEtMyA1IC01LjUgMTUuNSB0LTQuNSAxNC41cTIgMCA2IC0xLjV0OC41IC0zLjV0Ny41IC00dDIgLTNxLTMgLTcgMiAtMTcuNXQxMiAtMTguNXQxNyAtMTl0MTIgLTEzcTYgLTYgMTQgLTE5LjV0MCAtMTMuNXE5IDAgMjAgLTEwdDE3IC0yMHE1IC04IDggLTI2dDUgLTI0cTIgLTcgOC41IC0xMy41dDEyLjUgLTkuNWwxNiAtOHQxMyAtN3E1IC0yIDE4LjUgLTEwLjV0MjEuNSAtMTEuNXExMCAtNCAxNiAtNHQxNC41IDIuNXQxMy41IDMuNXExNSAyIDI5IC0xNXQyMSAtMjEgcTM2IC0xOSA1NSAtMTFxLTIgLTEgMC41IC03LjV0OCAtMTUuNXQ5IC0xNC41dDUuNSAtOC41cTUgLTYgMTggLTE1dDE4IC0xNXE2IDQgNyA5cS0zIC04IDcgLTIwdDE4IC0xMHExNCAzIDE0IDMycS0zMSAtMTUgLTQ5IDE4cTAgMSAtMi41IDUuNXQtNCA4LjV0LTIuNSA4LjV0MCA3LjV0NSAzcTkgMCAxMCAzLjV0LTIgMTIuNXQtNCAxM3EtMSA4IC0xMSAyMHQtMTIgMTVxLTUgLTkgLTE2IC04dC0xNiA5cTAgLTEgLTEuNSAtNS41dC0xLjUgLTYuNSBxLTEzIDAgLTE1IDFxMSAzIDIuNSAxNy41dDMuNSAyMi41cTEgNCA1LjUgMTJ0Ny41IDE0LjV0NCAxMi41dC00LjUgOS41dC0xNy41IDIuNXEtMTkgLTEgLTI2IC0yMHEtMSAtMyAtMyAtMTAuNXQtNSAtMTEuNXQtOSAtN3EtNyAtMyAtMjQgLTJ0LTI0IDVxLTEzIDggLTIyLjUgMjl0LTkuNSAzN3EwIDEwIDIuNSAyNi41dDMgMjV0LTUuNSAyNC41cTMgMiA5IDkuNXQxMCAxMC41cTIgMSA0LjUgMS41dDQuNSAwdDQgMS41dDMgNnEtMSAxIC00IDMgcS0zIDMgLTQgM3E3IC0zIDI4LjUgMS41dDI3LjUgLTEuNXExNSAtMTEgMjIgMnEwIDEgLTIuNSA5LjV0LTAuNSAxMy41cTUgLTI3IDI5IC05cTMgLTMgMTUuNSAtNXQxNy41IC01cTMgLTIgNyAtNS41dDUuNSAtNC41dDUgMC41dDguNSA2LjVxMTAgLTE0IDEyIC0yNHExMSAtNDAgMTkgLTQ0cTcgLTMgMTEgLTJ0NC41IDkuNXQwIDE0dC0xLjUgMTIuNWwtMSA4djE4bC0xIDhxLTE1IDMgLTE4LjUgMTJ0MS41IDE4LjV0MTUgMTguNXExIDEgOCAzLjUgdDE1LjUgNi41dDEyLjUgOHEyMSAxOSAxNSAzNXE3IDAgMTEgOXEtMSAwIC01IDN0LTcuNSA1dC00LjUgMnE5IDUgMiAxNnE1IDMgNy41IDExdDcuNSAxMHE5IC0xMiAyMSAtMnE3IDggMSAxNnE1IDcgMjAuNSAxMC41dDE4LjUgOS41cTcgLTIgOCAydDEgMTJ0MyAxMnE0IDUgMTUgOXQxMyA1bDE3IDExcTMgNCAwIDRxMTggLTIgMzEgMTFxMTAgMTEgLTYgMjBxMyA2IC0zIDkuNXQtMTUgNS41cTMgMSAxMS41IDAuNXQxMC41IDEuNSBxMTUgMTAgLTcgMTZxLTE3IDUgLTQzIC0xMnpNODc5IDEwcTIwNiAzNiAzNTEgMTg5cS0zIDMgLTEyLjUgNC41dC0xMi41IDMuNXEtMTggNyAtMjQgOHExIDcgLTIuNSAxM3QtOCA5dC0xMi41IDh0LTExIDdxLTIgMiAtNyA2dC03IDUuNXQtNy41IDQuNXQtOC41IDJ0LTEwIC0xbC0zIC0xcS0zIC0xIC01LjUgLTIuNXQtNS41IC0zdC00IC0zdDAgLTIuNXEtMjEgMTcgLTM2IDIycS01IDEgLTExIDUuNXQtMTAuNSA3dC0xMCAxLjV0LTExLjUgLTcgcS01IC01IC02IC0xNXQtMiAtMTNxLTcgNSAwIDE3LjV0MiAxOC41cS0zIDYgLTEwLjUgNC41dC0xMiAtNC41dC0xMS41IC04LjV0LTkgLTYuNXQtOC41IC01LjV0LTguNSAtNy41cS0zIC00IC02IC0xMnQtNSAtMTFxLTIgNCAtMTEuNSA2LjV0LTkuNSA1LjVxMiAtMTAgNCAtMzV0NSAtMzhxNyAtMzEgLTEyIC00OHEtMjcgLTI1IC0yOSAtNDBxLTQgLTIyIDEyIC0yNnEwIC03IC04IC0yMC41dC03IC0yMS41cTAgLTYgMiAtMTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYWQ7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTM4NCA2NHEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTEwMjggNDg0bC02ODIgLTY4MnEtMzcgLTM3IC05MCAtMzdxLTUyIDAgLTkxIDM3bC0xMDYgMTA4cS0zOCAzNiAtMzggOTBxMCA1MyAzOCA5MWw2ODEgNjgxcTM5IC05OCAxMTQuNSAtMTczLjV0MTczLjUgLTExNC41ek0xNjYyIDkxOXEwIC0zOSAtMjMgLTEwNnEtNDcgLTEzNCAtMTY0LjUgLTIxNy41IHQtMjU4LjUgLTgzLjVxLTE4NSAwIC0zMTYuNSAxMzEuNXQtMTMxLjUgMzE2LjV0MTMxLjUgMzE2LjV0MzE2LjUgMTMxLjVxNTggMCAxMjEuNSAtMTYuNXQxMDcuNSAtNDYuNXExNiAtMTEgMTYgLTI4dC0xNiAtMjhsLTI5MyAtMTY5di0yMjRsMTkzIC0xMDdxNSAzIDc5IDQ4LjV0MTM1LjUgODF0NzAuNSAzNS41cTE1IDAgMjMuNSAtMTB0OC41IC0yNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBhZTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTAyNCAxMjhoNjQwdjEyOGgtNjQwdi0xMjh6TTY0MCA2NDBoMTAyNHYxMjhoLTEwMjR2LTEyOHpNMTI4MCAxMTUyaDM4NHYxMjhoLTM4NHYtMTI4ek0xNzkyIDMyMHYtMjU2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTY2NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djI1NnEwIDI2IDE5IDQ1dDQ1IDE5aDE2NjRxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xNzkyIDgzMnYtMjU2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTY2NHEtMjYgMCAtNDUgMTkgdC0xOSA0NXYyNTZxMCAyNiAxOSA0NXQ0NSAxOWgxNjY0cTI2IDAgNDUgLTE5dDE5IC00NXpNMTc5MiAxMzQ0di0yNTZxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNjY0cS0yNiAwIC00NSAxOXQtMTkgNDV2MjU2cTAgMjYgMTkgNDV0NDUgMTloMTY2NHEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYjA7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTE0MDMgMTI0MXExNyAtNDEgLTE0IC03MGwtNDkzIC00OTN2LTc0MnEwIC00MiAtMzkgLTU5cS0xMyAtNSAtMjUgLTVxLTI3IDAgLTQ1IDE5bC0yNTYgMjU2cS0xOSAxOSAtMTkgNDV2NDg2bC00OTMgNDkzcS0zMSAyOSAtMTQgNzBxMTcgMzkgNTkgMzloMTI4MHE0MiAwIDU5IC0zOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBiMTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNjQwIDEyODBoNTEydjEyOGgtNTEydi0xMjh6TTE3OTIgNjQwdi00ODBxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE0NzJxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjQ4MGg2NzJ2LTE2MHEwIC0yNiAxOSAtNDV0NDUgLTE5aDMyMHEyNiAwIDQ1IDE5dDE5IDQ1djE2MGg2NzJ6TTEwMjQgNjQwdi0xMjhoLTI1NnYxMjhoMjU2ek0xNzkyIDExMjB2LTM4NGgtMTc5MnYzODRxMCA2NiA0NyAxMTN0MTEzIDQ3aDM1MnYxNjBxMCA0MCAyOCA2OCB0NjggMjhoNTc2cTQwIDAgNjggLTI4dDI4IC02OHYtMTYwaDM1MnE2NiAwIDExMyAtNDd0NDcgLTExM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBiMjsiIGQ9Ik0xMjgzIDk5NWwtMzU1IC0zNTVsMzU1IC0zNTVsMTQ0IDE0NHEyOSAzMSA3MCAxNHEzOSAtMTcgMzkgLTU5di00NDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC00NDhxLTQyIDAgLTU5IDQwcS0xNyAzOSAxNCA2OWwxNDQgMTQ0bC0zNTUgMzU1bC0zNTUgLTM1NWwxNDQgLTE0NHEzMSAtMzAgMTQgLTY5cS0xNyAtNDAgLTU5IC00MGgtNDQ4cS0yNiAwIC00NSAxOXQtMTkgNDV2NDQ4cTAgNDIgNDAgNTlxMzkgMTcgNjkgLTE0bDE0NCAtMTQ0IGwzNTUgMzU1bC0zNTUgMzU1bC0xNDQgLTE0NHEtMTkgLTE5IC00NSAtMTlxLTEyIDAgLTI0IDVxLTQwIDE3IC00MCA1OXY0NDhxMCAyNiAxOSA0NXQ0NSAxOWg0NDhxNDIgMCA1OSAtNDBxMTcgLTM5IC0xNCAtNjlsLTE0NCAtMTQ0bDM1NSAtMzU1bDM1NSAzNTVsLTE0NCAxNDRxLTMxIDMwIC0xNCA2OXExNyA0MCA1OSA0MGg0NDhxMjYgMCA0NSAtMTl0MTkgLTQ1di00NDhxMCAtNDIgLTM5IC01OXEtMTMgLTUgLTI1IC01cS0yNiAwIC00NSAxOXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYzA7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTU5MyA2NDBxLTE2MiAtNSAtMjY1IC0xMjhoLTEzNHEtODIgMCAtMTM4IDQwLjV0LTU2IDExOC41cTAgMzUzIDEyNCAzNTNxNiAwIDQzLjUgLTIxdDk3LjUgLTQyLjV0MTE5IC0yMS41cTY3IDAgMTMzIDIzcS01IC0zNyAtNSAtNjZxMCAtMTM5IDgxIC0yNTZ6TTE2NjQgM3EwIC0xMjAgLTczIC0xODkuNXQtMTk0IC02OS41aC04NzRxLTEyMSAwIC0xOTQgNjkuNXQtNzMgMTg5LjVxMCA1MyAzLjUgMTAzLjV0MTQgMTA5dDI2LjUgMTA4LjUgdDQzIDk3LjV0NjIgODF0ODUuNSA1My41dDExMS41IDIwcTEwIDAgNDMgLTIxLjV0NzMgLTQ4dDEwNyAtNDh0MTM1IC0yMS41dDEzNSAyMS41dDEwNyA0OHQ3MyA0OHQ0MyAyMS41cTYxIDAgMTExLjUgLTIwdDg1LjUgLTUzLjV0NjIgLTgxdDQzIC05Ny41dDI2LjUgLTEwOC41dDE0IC0xMDl0My41IC0xMDMuNXpNNjQwIDEyODBxMCAtMTA2IC03NSAtMTgxdC0xODEgLTc1dC0xODEgNzV0LTc1IDE4MXQ3NSAxODF0MTgxIDc1dDE4MSAtNzUgdDc1IC0xODF6TTEzNDQgODk2cTAgLTE1OSAtMTEyLjUgLTI3MS41dC0yNzEuNSAtMTEyLjV0LTI3MS41IDExMi41dC0xMTIuNSAyNzEuNXQxMTIuNSAyNzEuNXQyNzEuNSAxMTIuNXQyNzEuNSAtMTEyLjV0MTEyLjUgLTI3MS41ek0xOTIwIDY3MXEwIC03OCAtNTYgLTExOC41dC0xMzggLTQwLjVoLTEzNHEtMTAzIDEyMyAtMjY1IDEyOHE4MSAxMTcgODEgMjU2cTAgMjkgLTUgNjZxNjYgLTIzIDEzMyAtMjNxNTkgMCAxMTkgMjEuNXQ5Ny41IDQyLjUgdDQzLjUgMjFxMTI0IDAgMTI0IC0zNTN6TTE3OTIgMTI4MHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MSA3NXQtNzUgMTgxdDc1IDE4MXQxODEgNzV0MTgxIC03NXQ3NSAtMTgxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGMxOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNDU2IDMyMHEwIDQwIC0yOCA2OGwtMjA4IDIwOHEtMjggMjggLTY4IDI4cS00MiAwIC03MiAtMzJxMyAtMyAxOSAtMTguNXQyMS41IC0yMS41dDE1IC0xOXQxMyAtMjUuNXQzLjUgLTI3LjVxMCAtNDAgLTI4IC02OHQtNjggLTI4cS0xNSAwIC0yNy41IDMuNXQtMjUuNSAxM3QtMTkgMTV0LTIxLjUgMjEuNXQtMTguNSAxOXEtMzMgLTMxIC0zMyAtNzNxMCAtNDAgMjggLTY4bDIwNiAtMjA3cTI3IC0yNyA2OCAtMjdxNDAgMCA2OCAyNiBsMTQ3IDE0NnEyOCAyOCAyOCA2N3pNNzUzIDEwMjVxMCA0MCAtMjggNjhsLTIwNiAyMDdxLTI4IDI4IC02OCAyOHEtMzkgMCAtNjggLTI3bC0xNDcgLTE0NnEtMjggLTI4IC0yOCAtNjdxMCAtNDAgMjggLTY4bDIwOCAtMjA4cTI3IC0yNyA2OCAtMjdxNDIgMCA3MiAzMXEtMyAzIC0xOSAxOC41dC0yMS41IDIxLjV0LTE1IDE5dC0xMyAyNS41dC0zLjUgMjcuNXEwIDQwIDI4IDY4dDY4IDI4cTE1IDAgMjcuNSAtMy41dDI1LjUgLTEzdDE5IC0xNSB0MjEuNSAtMjEuNXQxOC41IC0xOXEzMyAzMSAzMyA3M3pNMTY0OCAzMjBxMCAtMTIwIC04NSAtMjAzbC0xNDcgLTE0NnEtODMgLTgzIC0yMDMgLTgzcS0xMjEgMCAtMjA0IDg1bC0yMDYgMjA3cS04MyA4MyAtODMgMjAzcTAgMTIzIDg4IDIwOWwtODggODhxLTg2IC04OCAtMjA4IC04OHEtMTIwIDAgLTIwNCA4NGwtMjA4IDIwOHEtODQgODQgLTg0IDIwNHQ4NSAyMDNsMTQ3IDE0NnE4MyA4MyAyMDMgODNxMTIxIDAgMjA0IC04NWwyMDYgLTIwNyBxODMgLTgzIDgzIC0yMDNxMCAtMTIzIC04OCAtMjA5bDg4IC04OHE4NiA4OCAyMDggODhxMTIwIDAgMjA0IC04NGwyMDggLTIwOHE4NCAtODQgODQgLTIwNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjMjsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNMTkyMCAzODRxMCAtMTU5IC0xMTIuNSAtMjcxLjV0LTI3MS41IC0xMTIuNWgtMTA4OHEtMTg1IDAgLTMxNi41IDEzMS41dC0xMzEuNSAzMTYuNXEwIDEzMiA3MSAyNDEuNXQxODcgMTYzLjVxLTIgMjggLTIgNDNxMCAyMTIgMTUwIDM2MnQzNjIgMTUwcTE1OCAwIDI4Ni41IC04OHQxODcuNSAtMjMwcTcwIDYyIDE2NiA2MnExMDYgMCAxODEgLTc1dDc1IC0xODFxMCAtNzUgLTQxIC0xMzhxMTI5IC0zMCAyMTMgLTEzNC41dDg0IC0yMzkuNXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYzM7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE1MjcgODhxNTYgLTg5IDIxLjUgLTE1Mi41dC0xNDAuNSAtNjMuNWgtMTE1MnEtMTA2IDAgLTE0MC41IDYzLjV0MjEuNSAxNTIuNWw1MDMgNzkzdjM5OWgtNjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NXQ0NSAxOWg1MTJxMjYgMCA0NSAtMTl0MTkgLTQ1dC0xOSAtNDV0LTQ1IC0xOWgtNjR2LTM5OXpNNzQ4IDgxM2wtMjcyIC00MjloNzEybC0yNzIgNDI5bC0yMCAzMXYzN3YzOTloLTEyOHYtMzk5di0zN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjNDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNOTYwIDY0MHEyNiAwIDQ1IC0xOXQxOSAtNDV0LTE5IC00NXQtNDUgLTE5dC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTl6TTEyNjAgNTc2bDUwNyAtMzk4cTI4IC0yMCAyNSAtNTZxLTUgLTM1IC0zNSAtNTFsLTEyOCAtNjRxLTEzIC03IC0yOSAtN3EtMTcgMCAtMzEgOGwtNjkwIDM4N2wtMTEwIC02NnEtOCAtNCAtMTIgLTVxMTQgLTQ5IDEwIC05N3EtNyAtNzcgLTU2IC0xNDcuNXQtMTMyIC0xMjMuNXEtMTMyIC04NCAtMjc3IC04NCBxLTEzNiAwIC0yMjIgNzhxLTkwIDg0IC03OSAyMDdxNyA3NiA1NiAxNDd0MTMxIDEyNHExMzIgODQgMjc4IDg0cTgzIDAgMTUxIC0zMXE5IDEzIDIyIDIybDEyMiA3M2wtMTIyIDczcS0xMyA5IC0yMiAyMnEtNjggLTMxIC0xNTEgLTMxcS0xNDYgMCAtMjc4IDg0cS04MiA1MyAtMTMxIDEyNHQtNTYgMTQ3cS01IDU5IDE1LjUgMTEzdDYzLjUgOTNxODUgNzkgMjIyIDc5cTE0NSAwIDI3NyAtODRxODMgLTUyIDEzMiAtMTIzdDU2IC0xNDggcTQgLTQ4IC0xMCAtOTdxNCAtMSAxMiAtNWwxMTAgLTY2bDY5MCAzODdxMTQgOCAzMSA4cTE2IDAgMjkgLTdsMTI4IC02NHEzMCAtMTYgMzUgLTUxcTMgLTM2IC0yNSAtNTZ6TTU3OSA4MzZxNDYgNDIgMjEgMTA4dC0xMDYgMTE3cS05MiA1OSAtMTkyIDU5cS03NCAwIC0xMTMgLTM2cS00NiAtNDIgLTIxIC0xMDh0MTA2IC0xMTdxOTIgLTU5IDE5MiAtNTlxNzQgMCAxMTMgMzZ6TTQ5NCA5MXE4MSA1MSAxMDYgMTE3dC0yMSAxMDggcS0zOSAzNiAtMTEzIDM2cS0xMDAgMCAtMTkyIC01OXEtODEgLTUxIC0xMDYgLTExN3QyMSAtMTA4cTM5IC0zNiAxMTMgLTM2cTEwMCAwIDE5MiA1OXpNNjcyIDcwNGw5NiAtNTh2MTFxMCAzNiAzMyA1NmwxNCA4bC03OSA0N2wtMjYgLTI2cS0zIC0zIC0xMCAtMTF0LTEyIC0xMnEtMiAtMiAtNCAtMy41dC0zIC0yLjV6TTg5NiA0ODBsOTYgLTMybDczNiA1NzZsLTEyOCA2NGwtNzY4IC00MzF2LTExM2wtMTYwIC05Nmw5IC04cTIgLTIgNyAtNiBxNCAtNCAxMSAtMTJ0MTEgLTEybDI2IC0yNnpNMTYwMCA2NGwxMjggNjRsLTUyMCA0MDhsLTE3NyAtMTM4cS0yIC0zIC0xMyAtN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjNTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY5NiAxMTUycTQwIDAgNjggLTI4dDI4IC02OHYtMTIxNnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTk2MHEtNDAgMCAtNjggMjh0LTI4IDY4djI4OGgtNTQ0cS00MCAwIC02OCAyOHQtMjggNjh2NjcycTAgNDAgMjAgODh0NDggNzZsNDA4IDQwOHEyOCAyOCA3NiA0OHQ4OCAyMGg0MTZxNDAgMCA2OCAtMjh0MjggLTY4di0zMjhxNjggNDAgMTI4IDQwaDQxNnpNMTE1MiA5MzlsLTI5OSAtMjk5aDI5OXYyOTl6TTUxMiAxMzIzbC0yOTkgLTI5OSBoMjk5djI5OXpNNzA4IDY3NmwzMTYgMzE2djQxNmgtMzg0di00MTZxMCAtNDAgLTI4IC02OHQtNjggLTI4aC00MTZ2LTY0MGg1MTJ2MjU2cTAgNDAgMjAgODh0NDggNzZ6TTE2NjQgLTEyOHYxMTUyaC0zODR2LTQxNnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTQxNnYtNjQwaDg5NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjNjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTQwNCAxNTFxMCAtMTE3IC03OSAtMTk2dC0xOTYgLTc5cS0xMzUgMCAtMjM1IDEwMGwtNzc3IDc3NnEtMTEzIDExNSAtMTEzIDI3MXEwIDE1OSAxMTAgMjcwdDI2OSAxMTFxMTU4IDAgMjczIC0xMTNsNjA1IC02MDZxMTAgLTEwIDEwIC0yMnEwIC0xNiAtMzAuNSAtNDYuNXQtNDYuNSAtMzAuNXEtMTMgMCAtMjMgMTBsLTYwNiA2MDdxLTc5IDc3IC0xODEgNzdxLTEwNiAwIC0xNzkgLTc1dC03MyAtMTgxcTAgLTEwNSA3NiAtMTgxIGw3NzYgLTc3N3E2MyAtNjMgMTQ1IC02M3E2NCAwIDEwNiA0MnQ0MiAxMDZxMCA4MiAtNjMgMTQ1bC01ODEgNTgxcS0yNiAyNCAtNjAgMjRxLTI5IDAgLTQ4IC0xOXQtMTkgLTQ4cTAgLTMyIDI1IC01OWw0MTAgLTQxMHExMCAtMTAgMTAgLTIycTAgLTE2IC0zMSAtNDd0LTQ3IC0zMXEtMTIgMCAtMjIgMTBsLTQxMCA0MTBxLTYzIDYxIC02MyAxNDlxMCA4MiA1NyAxMzl0MTM5IDU3cTg4IDAgMTQ5IC02M2w1ODEgLTU4MXExMDAgLTk4IDEwMCAtMjM1IHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjNzsiIGQ9Ik0zODQgMGg3Njh2Mzg0aC03Njh2LTM4NHpNMTI4MCAwaDEyOHY4OTZxMCAxNCAtMTAgMzguNXQtMjAgMzQuNWwtMjgxIDI4MXEtMTAgMTAgLTM0IDIwdC0zOSAxMHYtNDE2cTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtNTc2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC0xMjh2LTEyODBoMTI4djQxNnEwIDQwIDI4IDY4dDY4IDI4aDgzMnE0MCAwIDY4IC0yOHQyOCAtNjh2LTQxNnpNODk2IDkyOHYzMjBxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41IGgtMTkycS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtMzIwcTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTkycTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE1MzYgODk2di05MjhxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTM0NHEwIDQwIDI4IDY4dDY4IDI4aDkyOHE0MCAwIDg4IC0yMHQ3NiAtNDhsMjgwIC0yODBxMjggLTI4IDQ4IC03NnQyMCAtODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYzg7IiBkPSJNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwYzk7IiBkPSJNMTUzNiAxOTJ2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE0MDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXpNMTUzNiA3MDR2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE0MDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWgxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXpNMTUzNiAxMjE2di0xMjhxMCAtMjYgLTE5IC00NSB0LTQ1IC0xOWgtMTQwOHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDE0MDhxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGNhOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0zODQgMTI4cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMzg0IDY0MHEwIC04MCAtNTYgLTEzNnQtMTM2IC01NnQtMTM2IDU2dC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6TTE3OTIgMjI0di0xOTJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0xMjE2cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTkycTAgMTMgOS41IDIyLjUgdDIyLjUgOS41aDEyMTZxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0zODQgMTE1MnEwIC04MCAtNTYgLTEzNnQtMTM2IC01NnQtMTM2IDU2dC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6TTE3OTIgNzM2di0xOTJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0xMjE2cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTkycTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoMTIxNnExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE0xNzkyIDEyNDh2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEyMTZxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMjE2cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjYjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMzgxIC04NHEwIC04MCAtNTQuNSAtMTI2dC0xMzUuNSAtNDZxLTEwNiAwIC0xNzIgNjZsNTcgODhxNDkgLTQ1IDEwNiAtNDVxMjkgMCA1MC41IDE0LjV0MjEuNSA0Mi41cTAgNjQgLTEwNSA1NmwtMjYgNTZxOCAxMCAzMi41IDQzLjV0NDIuNSA1NHQzNyAzOC41djFxLTE2IDAgLTQ4LjUgLTF0LTQ4LjUgLTF2LTUzaC0xMDZ2MTUyaDMzM3YtODhsLTk1IC0xMTVxNTEgLTEyIDgxIC00OXQzMCAtODh6TTM4MyA1NDN2LTE1OWgtMzYyIHEtNiAzNiAtNiA1NHEwIDUxIDIzLjUgOTN0NTYuNSA2OHQ2NiA0Ny41dDU2LjUgNDMuNXQyMy41IDQ1cTAgMjUgLTE0LjUgMzguNXQtMzkuNSAxMy41cS00NiAwIC04MSAtNThsLTg1IDU5cTI0IDUxIDcxLjUgNzkuNXQxMDUuNSAyOC41cTczIDAgMTIzIC00MS41dDUwIC0xMTIuNXEwIC01MCAtMzQgLTkxLjV0LTc1IC02NC41dC03NS41IC01MC41dC0zNS41IC01Mi41aDEyN3Y2MGgxMDV6TTE3OTIgMjI0di0xOTJxMCAtMTMgLTkuNSAtMjIuNSB0LTIyLjUgLTkuNWgtMTIxNnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDE0IDkgMjN0MjMgOWgxMjE2cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMzg0IDExMjN2LTk5aC0zMzV2OTloMTA3cTAgNDEgMC41IDEyMnQwLjUgMTIxdjEyaC0ycS04IC0xNyAtNTAgLTU0bC03MSA3NmwxMzYgMTI3aDEwNnYtNDA0aDEwOHpNMTc5MiA3MzZ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEyMTZxLTEzIDAgLTIyLjUgOS41IHQtOS41IDIyLjV2MTkycTAgMTQgOSAyM3QyMyA5aDEyMTZxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xNzkyIDEyNDh2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEyMTZxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxMjE2cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjYzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc2MCA2NDBxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTcyOHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWgxNzI4ek00ODMgNzA0cS0yOCAzNSAtNTEgODBxLTQ4IDk3IC00OCAxODhxMCAxODEgMTM0IDMwOXExMzMgMTI3IDM5MyAxMjdxNTAgMCAxNjcgLTE5cTY2IC0xMiAxNzcgLTQ4cTEwIC0zOCAyMSAtMTE4cTE0IC0xMjMgMTQgLTE4M3EwIC0xOCAtNSAtNDVsLTEyIC0zbC04NCA2IGwtMTQgMnEtNTAgMTQ5IC0xMDMgMjA1cS04OCA5MSAtMjEwIDkxcS0xMTQgMCAtMTgyIC01OXEtNjcgLTU4IC02NyAtMTQ2cTAgLTczIDY2IC0xNDB0Mjc5IC0xMjlxNjkgLTIwIDE3MyAtNjZxNTggLTI4IDk1IC01MmgtNzQzek05OTAgNDQ4aDQxMXE3IC0zOSA3IC05MnEwIC0xMTEgLTQxIC0yMTJxLTIzIC01NSAtNzEgLTEwNHEtMzcgLTM1IC0xMDkgLTgxcS04MCAtNDggLTE1MyAtNjZxLTgwIC0yMSAtMjAzIC0yMXEtMTE0IDAgLTE5NSAyMyBsLTE0MCA0MHEtNTcgMTYgLTcyIDI4cS04IDggLTggMjJ2MTNxMCAxMDggLTIgMTU2cS0xIDMwIDAgNjhsMiAzN3Y0NGwxMDIgMnExNSAtMzQgMzAgLTcxdDIyLjUgLTU2dDEyLjUgLTI3cTM1IC01NyA4MCAtOTRxNDMgLTM2IDEwNSAtNTdxNTkgLTIyIDEzMiAtMjJxNjQgMCAxMzkgMjdxNzcgMjYgMTIyIDg2cTQ3IDYxIDQ3IDEyOXEwIDg0IC04MSAxNTdxLTM0IDI5IC0xMzcgNzF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwY2Q7IiBkPSJNNDggMTMxM3EtMzcgMiAtNDUgNGwtMyA4OHExMyAxIDQwIDFxNjAgMCAxMTIgLTRxMTMyIC03IDE2NiAtN3E4NiAwIDE2OCAzcTExNiA0IDE0NiA1cTU2IDAgODYgMmwtMSAtMTRsMiAtNjR2LTlxLTYwIC05IC0xMjQgLTlxLTYwIDAgLTc5IC0yNXEtMTMgLTE0IC0xMyAtMTMycTAgLTEzIDAuNSAtMzIuNXQwLjUgLTI1LjVsMSAtMjI5bDE0IC0yODBxNiAtMTI0IDUxIC0yMDJxMzUgLTU5IDk2IC05MnE4OCAtNDcgMTc3IC00NyBxMTA0IDAgMTkxIDI4cTU2IDE4IDk5IDUxcTQ4IDM2IDY1IDY0cTM2IDU2IDUzIDExNHEyMSA3MyAyMSAyMjlxMCA3OSAtMy41IDEyOHQtMTEgMTIyLjV0LTEzLjUgMTU5LjVsLTQgNTlxLTUgNjcgLTI0IDg4cS0zNCAzNSAtNzcgMzRsLTEwMCAtMmwtMTQgM2wyIDg2aDg0bDIwNSAtMTBxNzYgLTMgMTk2IDEwbDE4IC0ycTYgLTM4IDYgLTUxcTAgLTcgLTQgLTMxcS00NSAtMTIgLTg0IC0xM3EtNzMgLTExIC03OSAtMTdxLTE1IC0xNSAtMTUgLTQxIHEwIC03IDEuNSAtMjd0MS41IC0zMXE4IC0xOSAyMiAtMzk2cTYgLTE5NSAtMTUgLTMwNHEtMTUgLTc2IC00MSAtMTIycS0zOCAtNjUgLTExMiAtMTIzcS03NSAtNTcgLTE4MiAtODlxLTEwOSAtMzMgLTI1NSAtMzNxLTE2NyAwIC0yODQgNDZxLTExOSA0NyAtMTc5IDEyMnEtNjEgNzYgLTgzIDE5NXEtMTYgODAgLTE2IDIzN3YzMzNxMCAxODggLTE3IDIxM3EtMjUgMzYgLTE0NyAzOXpNMTUzNiAtOTZ2NjRxMCAxNCAtOSAyM3QtMjMgOWgtMTQ3MiBxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloMTQ3MnExNCAwIDIzIDl0OSAyM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBjZTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNTEyIDE2MHYxOTJxMCAxNCAtOSAyM3QtMjMgOWgtMzIwcS0xNCAwIC0yMyAtOXQtOSAtMjN2LTE5MnEwIC0xNCA5IC0yM3QyMyAtOWgzMjBxMTQgMCAyMyA5dDkgMjN6TTUxMiA1NDR2MTkycTAgMTQgLTkgMjN0LTIzIDloLTMyMHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMzIwcTE0IDAgMjMgOXQ5IDIzek0xMDI0IDE2MHYxOTJxMCAxNCAtOSAyM3QtMjMgOWgtMzIwcS0xNCAwIC0yMyAtOXQtOSAtMjMgdi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMzIwcTE0IDAgMjMgOXQ5IDIzek01MTIgOTI4djE5MnEwIDE0IC05IDIzdC0yMyA5aC0zMjBxLTE0IDAgLTIzIC05dC05IC0yM3YtMTkycTAgLTE0IDkgLTIzdDIzIC05aDMyMHExNCAwIDIzIDl0OSAyM3pNMTAyNCA1NDR2MTkycTAgMTQgLTkgMjN0LTIzIDloLTMyMHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMzIwcTE0IDAgMjMgOXQ5IDIzek0xNTM2IDE2MHYxOTIgcTAgMTQgLTkgMjN0LTIzIDloLTMyMHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMzIwcTE0IDAgMjMgOXQ5IDIzek0xMDI0IDkyOHYxOTJxMCAxNCAtOSAyM3QtMjMgOWgtMzIwcS0xNCAwIC0yMyAtOXQtOSAtMjN2LTE5MnEwIC0xNCA5IC0yM3QyMyAtOWgzMjBxMTQgMCAyMyA5dDkgMjN6TTE1MzYgNTQ0djE5MnEwIDE0IC05IDIzdC0yMyA5aC0zMjBxLTE0IDAgLTIzIC05dC05IC0yM3YtMTkyIHEwIC0xNCA5IC0yM3QyMyAtOWgzMjBxMTQgMCAyMyA5dDkgMjN6TTE1MzYgOTI4djE5MnEwIDE0IC05IDIzdC0yMyA5aC0zMjBxLTE0IDAgLTIzIC05dC05IC0yM3YtMTkycTAgLTE0IDkgLTIzdDIzIC05aDMyMHExNCAwIDIzIDl0OSAyM3pNMTY2NCAxMjQ4di0xMDg4cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xMzQ0cS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMDg4cTAgNjYgNDcgMTEzdDExMyA0N2gxMzQ0cTY2IDAgMTEzIC00N3Q0NyAtMTEzIHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkMDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTE5MCA5NTVsMjkzIDI5M2wtMTA3IDEwN2wtMjkzIC0yOTN6TTE2MzcgMTI0OHEwIC0yNyAtMTggLTQ1bC0xMjg2IC0xMjg2cS0xOCAtMTggLTQ1IC0xOHQtNDUgMThsLTE5OCAxOThxLTE4IDE4IC0xOCA0NXQxOCA0NWwxMjg2IDEyODZxMTggMTggNDUgMTh0NDUgLTE4bDE5OCAtMTk4cTE4IC0xOCAxOCAtNDV6TTI4NiAxNDM4bDk4IC0zMGwtOTggLTMwbC0zMCAtOThsLTMwIDk4bC05OCAzMGw5OCAzMGwzMCA5OHpNNjM2IDEyNzYgbDE5NiAtNjBsLTE5NiAtNjBsLTYwIC0xOTZsLTYwIDE5NmwtMTk2IDYwbDE5NiA2MGw2MCAxOTZ6TTE1NjYgNzk4bDk4IC0zMGwtOTggLTMwbC0zMCAtOThsLTMwIDk4bC05OCAzMGw5OCAzMGwzMCA5OHpNOTI2IDE0MzhsOTggLTMwbC05OCAtMzBsLTMwIC05OGwtMzAgOThsLTk4IDMwbDk4IDMwbDMwIDk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGQxOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik02NDAgMTI4cTAgNTIgLTM4IDkwdC05MCAzOHQtOTAgLTM4dC0zOCAtOTB0MzggLTkwdDkwIC0zOHQ5MCAzOHQzOCA5MHpNMjU2IDY0MGgzODR2MjU2aC0xNThxLTEzIDAgLTIyIC05bC0xOTUgLTE5NXEtOSAtOSAtOSAtMjJ2LTMwek0xNTM2IDEyOHEwIDUyIC0zOCA5MHQtOTAgMzh0LTkwIC0zOHQtMzggLTkwdDM4IC05MHQ5MCAtMzh0OTAgMzh0MzggOTB6TTE3OTIgMTIxNnYtMTAyNHEwIC0xNSAtNCAtMjYuNXQtMTMuNSAtMTguNSB0LTE2LjUgLTExLjV0LTIzLjUgLTZ0LTIyLjUgLTJ0LTI1LjUgMHQtMjIuNSAwLjVxMCAtMTA2IC03NSAtMTgxdC0xODEgLTc1dC0xODEgNzV0LTc1IDE4MWgtMzg0cTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXQtMTgxIDc1dC03NSAxODFoLTY0cS0zIDAgLTIyLjUgLTAuNXQtMjUuNSAwdC0yMi41IDJ0LTIzLjUgNnQtMTYuNSAxMS41dC0xMy41IDE4LjV0LTQgMjYuNXEwIDI2IDE5IDQ1dDQ1IDE5djMyMHEwIDggLTAuNSAzNXQwIDM4IHQyLjUgMzQuNXQ2LjUgMzd0MTQgMzAuNXQyMi41IDMwbDE5OCAxOThxMTkgMTkgNTAuNSAzMnQ1OC41IDEzaDE2MHYxOTJxMCAyNiAxOSA0NXQ0NSAxOWgxMDI0cTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkMjsiIGQ9Ik0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3EtMTExIDAgLTIxOCAzMnE1OSA5MyA3OCAxNjRxOSAzNCA1NCAyMTFxMjAgLTM5IDczIC02Ny41dDExNCAtMjguNXExMjEgMCAyMTYgNjguNXQxNDcgMTg4LjV0NTIgMjcwcTAgMTE0IC01OS41IDIxNHQtMTcyLjUgMTYzdC0yNTUgNjNxLTEwNSAwIC0xOTYgLTI5dC0xNTQuNSAtNzd0LTEwOSAtMTEwLjV0LTY3IC0xMjkuNXQtMjEuNSAtMTM0IHEwIC0xMDQgNDAgLTE4M3QxMTcgLTExMXEzMCAtMTIgMzggMjBxMiA3IDggMzF0OCAzMHE2IDIzIC0xMSA0M3EtNTEgNjEgLTUxIDE1MXEwIDE1MSAxMDQuNSAyNTkuNXQyNzMuNSAxMDguNXExNTEgMCAyMzUuNSAtODJ0ODQuNSAtMjEzcTAgLTE3MCAtNjguNSAtMjg5dC0xNzUuNSAtMTE5cS02MSAwIC05OCA0My41dC0yMyAxMDQuNXE4IDM1IDI2LjUgOTMuNXQzMCAxMDN0MTEuNSA3NS41cTAgNTAgLTI3IDgzdC03NyAzMyBxLTYyIDAgLTEwNSAtNTd0LTQzIC0xNDJxMCAtNzMgMjUgLTEyMmwtOTkgLTQxOHEtMTcgLTcwIC0xMyAtMTc3cS0yMDYgOTEgLTMzMyAyODF0LTEyNyA0MjNxMCAyMDkgMTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGQzOyIgZD0iTTEyNDggMTQwOHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC03MjVxODUgMTIyIDEwOCAyMTBxOSAzNCA1MyAyMDlxMjEgLTM5IDczLjUgLTY3dDExMi41IC0yOHExODEgMCAyOTUuNSAxNDcuNXQxMTQuNSAzNzMuNXEwIDg0IC0zNSAxNjIuNXQtOTYuNSAxMzl0LTE1Mi41IDk3dC0xOTcgMzYuNXEtMTA0IDAgLTE5NC41IC0yOC41dC0xNTMgLTc2LjUgdC0xMDcuNSAtMTA5LjV0LTY2LjUgLTEyOHQtMjEuNSAtMTMyLjVxMCAtMTAyIDM5LjUgLTE4MHQxMTYuNSAtMTEwcTEzIC01IDIzLjUgMHQxNC41IDE5cTEwIDQ0IDE1IDYxcTYgMjMgLTExIDQycS01MCA2MiAtNTAgMTUwcTAgMTUwIDEwMy41IDI1Ni41dDI3MC41IDEwNi41cTE0OSAwIDIzMi41IC04MXQ4My41IC0yMTBxMCAtMTY4IC02Ny41IC0yODZ0LTE3My41IC0xMThxLTYwIDAgLTk3IDQzLjV0LTIzIDEwMy41cTggMzQgMjYuNSA5Mi41IHQyOS41IDEwMnQxMSA3NC41cTAgNDkgLTI2LjUgODEuNXQtNzUuNSAzMi41cS02MSAwIC0xMDMuNSAtNTYuNXQtNDIuNSAtMTM5LjVxMCAtNzIgMjQgLTEyMWwtOTggLTQxNHEtMjQgLTEwMCAtNyAtMjU0aC0xODNxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGQ0OyIgZD0iTTkxNyA2MzFxMCAyNiAtNiA2NGgtMzYydi0xMzJoMjE3cS0zIC0yNCAtMTYuNSAtNTB0LTM3LjUgLTUzdC02Ni41IC00NC41dC05Ni41IC0xNy41cS05OSAwIC0xNjkgNzF0LTcwIDE3MXQ3MCAxNzF0MTY5IDcxcTkyIDAgMTUzIC01OWwxMDQgMTAxcS0xMDggMTAwIC0yNTcgMTAwcS0xNjAgMCAtMjcyIC0xMTIuNXQtMTEyIC0yNzEuNXQxMTIgLTI3MS41dDI3MiAtMTEyLjVxMTY1IDAgMjY2LjUgMTA1dDEwMS41IDI3MHpNMTI2MiA1ODUgaDEwOXYxMTBoLTEwOXYxMTBoLTExMHYtMTEwaC0xMTB2LTExMGgxMTB2LTExMGgxMTB2MTEwek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkNTsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMTQzNyA2MjNxMCAtMjA4IC04NyAtMzcwLjV0LTI0OCAtMjU0dC0zNjkgLTkxLjVxLTE0OSAwIC0yODUgNTh0LTIzNCAxNTZ0LTE1NiAyMzR0LTU4IDI4NXQ1OCAyODV0MTU2IDIzNHQyMzQgMTU2dDI4NSA1OHEyODYgMCA0OTEgLTE5MmwtMTk5IC0xOTFxLTExNyAxMTMgLTI5MiAxMTNxLTEyMyAwIC0yMjcuNSAtNjJ0LTE2NS41IC0xNjguNXQtNjEgLTIzMi41dDYxIC0yMzIuNXQxNjUuNSAtMTY4LjV0MjI3LjUgLTYyIHE4MyAwIDE1Mi41IDIzdDExNC41IDU3LjV0NzguNSA3OC41dDQ5IDgzdDIxLjUgNzRoLTQxNnYyNTJoNjkycTEyIC02MyAxMiAtMTIyek0yMzA0IDc0NXYtMjEwaC0yMDl2LTIwOWgtMjEwdjIwOWgtMjA5djIxMGgyMDl2MjA5aDIxMHYtMjA5aDIwOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkNjsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNNzY4IDM4NGgzODR2OTZoLTEyOHY0NDhoLTExNGwtMTQ4IC0xMzdsNzcgLTgwcTQyIDM3IDU1IDU3aDJ2LTI4OGgtMTI4di05NnpNMTI4MCA2NDBxMCAtNzAgLTIxIC0xNDJ0LTU5LjUgLTEzNHQtMTAxLjUgLTEwMXQtMTM4IC0zOXQtMTM4IDM5dC0xMDEuNSAxMDF0LTU5LjUgMTM0dC0yMSAxNDJ0MjEgMTQydDU5LjUgMTM0dDEwMS41IDEwMXQxMzggMzl0MTM4IC0zOXQxMDEuNSAtMTAxdDU5LjUgLTEzNHQyMSAtMTQyek0xNzkyIDM4NCB2NTEycS0xMDYgMCAtMTgxIDc1dC03NSAxODFoLTExNTJxMCAtMTA2IC03NSAtMTgxdC0xODEgLTc1di01MTJxMTA2IDAgMTgxIC03NXQ3NSAtMTgxaDExNTJxMCAxMDYgNzUgMTgxdDE4MSA3NXpNMTkyMCAxMjE2di0xMTUycTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTc5MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djExNTJxMCAyNiAxOSA0NXQ0NSAxOWgxNzkycTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkNzsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNMTAyNCA4MzJxMCAtMjYgLTE5IC00NWwtNDQ4IC00NDhxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtNDQ4IDQ0OHEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5aDg5NnEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZDg7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTEwMjQgMzIwcTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtODk2cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDVsNDQ4IDQ0OHExOSAxOSA0NSAxOXQ0NSAtMTlsNDQ4IC00NDhxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkOTsiIGhvcml6LWFkdi14PSI2NDAiIGQ9Ik02NDAgMTA4OHYtODk2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTlsLTQ0OCA0NDhxLTE5IDE5IC0xOSA0NXQxOSA0NWw0NDggNDQ4cTE5IDE5IDQ1IDE5dDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZGE7IiBob3Jpei1hZHYteD0iNjQwIiBkPSJNNTc2IDY0MHEwIC0yNiAtMTkgLTQ1bC00NDggLTQ0OHEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5dC0xOSA0NXY4OTZxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTlsNDQ4IC00NDhxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkYjsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTYwIDBoNjA4djExNTJoLTY0MHYtMTEyMHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41ek0xNTM2IDMydjExMjBoLTY0MHYtMTE1Mmg2MDhxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXpNMTY2NCAxMjQ4di0xMjE2cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xMzQ0cS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMjE2cTAgNjYgNDcgMTEzdDExMyA0N2gxMzQ0cTY2IDAgMTEzIC00N3Q0NyAtMTEzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGRjOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik0xMDI0IDQ0OHEwIC0yNiAtMTkgLTQ1bC00NDggLTQ0OHEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC00NDggNDQ4cS0xOSAxOSAtMTkgNDV0MTkgNDV0NDUgMTloODk2cTI2IDAgNDUgLTE5dDE5IC00NXpNMTAyNCA4MzJxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC04OTZxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NWw0NDggNDQ4cTE5IDE5IDQ1IDE5dDQ1IC0xOWw0NDggLTQ0OHExOSAtMTkgMTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGRkOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik0xMDI0IDQ0OHEwIC0yNiAtMTkgLTQ1bC00NDggLTQ0OHEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC00NDggNDQ4cS0xOSAxOSAtMTkgNDV0MTkgNDV0NDUgMTloODk2cTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBkZTsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNMTAyNCA4MzJxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC04OTZxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NWw0NDggNDQ4cTE5IDE5IDQ1IDE5dDQ1IC0xOWw0NDggLTQ0OHExOSAtMTkgMTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGUwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDgyNnYtNzk0cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xNDcycS02NiAwIC0xMTMgNDd0LTQ3IDExM3Y3OTRxNDQgLTQ5IDEwMSAtODdxMzYyIC0yNDYgNDk3IC0zNDVxNTcgLTQyIDkyLjUgLTY1LjV0OTQuNSAtNDh0MTEwIC0yNC41aDFoMXE1MSAwIDExMCAyNC41dDk0LjUgNDh0OTIuNSA2NS41cTE3MCAxMjMgNDk4IDM0NXE1NyAzOSAxMDAgODd6TTE3OTIgMTEyMHEwIC03OSAtNDkgLTE1MXQtMTIyIC0xMjMgcS0zNzYgLTI2MSAtNDY4IC0zMjVxLTEwIC03IC00Mi41IC0zMC41dC01NCAtMzh0LTUyIC0zMi41dC01Ny41IC0yN3QtNTAgLTloLTFoLTFxLTIzIDAgLTUwIDl0LTU3LjUgMjd0LTUyIDMyLjV0LTU0IDM4dC00Mi41IDMwLjVxLTkxIDY0IC0yNjIgMTgyLjV0LTIwNSAxNDIuNXEtNjIgNDIgLTExNyAxMTUuNXQtNTUgMTM2LjVxMCA3OCA0MS41IDEzMHQxMTguNSA1MmgxNDcycTY1IDAgMTEyLjUgLTQ3dDQ3LjUgLTExM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBlMTsiIGQ9Ik0zNDkgOTExdi05OTFoLTMzMHY5OTFoMzMwek0zNzAgMTIxN3ExIC03MyAtNTAuNSAtMTIydC0xMzUuNSAtNDloLTJxLTgyIDAgLTEzMiA0OXQtNTAgMTIycTAgNzQgNTEuNSAxMjIuNXQxMzQuNSA0OC41dDEzMyAtNDguNXQ1MSAtMTIyLjV6TTE1MzYgNDg4di01NjhoLTMyOXY1MzBxMCAxMDUgLTQwLjUgMTY0LjV0LTEyNi41IDU5LjVxLTYzIDAgLTEwNS41IC0zNC41dC02My41IC04NS41cS0xMSAtMzAgLTExIC04MXYtNTUzaC0zMjkgcTIgMzk5IDIgNjQ3dC0xIDI5NmwtMSA0OGgzMjl2LTE0NGgtMnEyMCAzMiA0MSA1NnQ1Ni41IDUydDg3IDQzLjV0MTE0LjUgMTUuNXExNzEgMCAyNzUgLTExMy41dDEwNCAtMzMyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZTI7IiBkPSJNMTUzNiA2NDBxMCAtMTU2IC02MSAtMjk4dC0xNjQgLTI0NXQtMjQ1IC0xNjR0LTI5OCAtNjFxLTE3MiAwIC0zMjcgNzIuNXQtMjY0IDIwNC41cS03IDEwIC02LjUgMjIuNXQ4LjUgMjAuNWwxMzcgMTM4cTEwIDkgMjUgOXExNiAtMiAyMyAtMTJxNzMgLTk1IDE3OSAtMTQ3dDIyNSAtNTJxMTA0IDAgMTk4LjUgNDAuNXQxNjMuNSAxMDkuNXQxMDkuNSAxNjMuNXQ0MC41IDE5OC41dC00MC41IDE5OC41dC0xMDkuNSAxNjMuNSB0LTE2My41IDEwOS41dC0xOTguNSA0MC41cS05OCAwIC0xODggLTM1LjV0LTE2MCAtMTAxLjVsMTM3IC0xMzhxMzEgLTMwIDE0IC02OXEtMTcgLTQwIC01OSAtNDBoLTQ0OHEtMjYgMCAtNDUgMTl0LTE5IDQ1djQ0OHEwIDQyIDQwIDU5cTM5IDE3IDY5IC0xNGwxMzAgLTEyOXExMDcgMTAxIDI0NC41IDE1Ni41dDI4NC41IDU1LjVxMTU2IDAgMjk4IC02MXQyNDUgLTE2NHQxNjQgLTI0NXQ2MSAtMjk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGUzOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzcxIDBxMCAtNTMgLTM3IC05MGwtMTA3IC0xMDhxLTM5IC0zNyAtOTEgLTM3cS01MyAwIC05MCAzN2wtMzYzIDM2NHEtMzggMzYgLTM4IDkwcTAgNTMgNDMgOTZsLTI1NiAyNTZsLTEyNiAtMTI2cS0xNCAtMTQgLTM0IC0xNHQtMzQgMTRxMiAtMiAxMi41IC0xMnQxMi41IC0xM3QxMCAtMTEuNXQxMCAtMTMuNXQ2IC0xMy41dDUuNSAtMTYuNXQxLjUgLTE4cTAgLTM4IC0yOCAtNjhxLTMgLTMgLTE2LjUgLTE4dC0xOSAtMjAuNSB0LTE4LjUgLTE2LjV0LTIyIC0xNS41dC0yMiAtOXQtMjYgLTQuNXEtNDAgMCAtNjggMjhsLTQwOCA0MDhxLTI4IDI4IC0yOCA2OHEwIDEzIDQuNSAyNnQ5IDIydDE1LjUgMjJ0MTYuNSAxOC41dDIwLjUgMTl0MTggMTYuNXEzMCAyOCA2OCAyOHExMCAwIDE4IC0xLjV0MTYuNSAtNS41dDEzLjUgLTZ0MTMuNSAtMTB0MTEuNSAtMTB0MTMgLTEyLjV0MTIgLTEyLjVxLTE0IDE0IC0xNCAzNHQxNCAzNGwzNDggMzQ4cTE0IDE0IDM0IDE0dDM0IC0xNCBxLTIgMiAtMTIuNSAxMnQtMTIuNSAxM3QtMTAgMTEuNXQtMTAgMTMuNXQtNiAxMy41dC01LjUgMTYuNXQtMS41IDE4cTAgMzggMjggNjhxMyAzIDE2LjUgMTh0MTkgMjAuNXQxOC41IDE2LjV0MjIgMTUuNXQyMiA5dDI2IDQuNXE0MCAwIDY4IC0yOGw0MDggLTQwOHEyOCAtMjggMjggLTY4cTAgLTEzIC00LjUgLTI2dC05IC0yMnQtMTUuNSAtMjJ0LTE2LjUgLTE4LjV0LTIwLjUgLTE5dC0xOCAtMTYuNXEtMzAgLTI4IC02OCAtMjggcS0xMCAwIC0xOCAxLjV0LTE2LjUgNS41dC0xMy41IDZ0LTEzLjUgMTB0LTExLjUgMTB0LTEzIDEyLjV0LTEyIDEyLjVxMTQgLTE0IDE0IC0zNHQtMTQgLTM0bC0xMjYgLTEyNmwyNTYgLTI1NnE0MyA0MyA5NiA0M3E1MiAwIDkxIC0zN2wzNjMgLTM2M3EzNyAtMzkgMzcgLTkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGU0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0zODQgMzg0cTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek01NzYgODMycTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek0xMDA0IDM1MWwxMDEgMzgycTYgMjYgLTcuNSA0OC41dC0zOC41IDI5LjUgdC00OCAtNi41dC0zMCAtMzkuNWwtMTAxIC0zODJxLTYwIC01IC0xMDcgLTQzLjV0LTYzIC05OC41cS0yMCAtNzcgMjAgLTE0NnQxMTcgLTg5dDE0NiAyMHQ4OSAxMTdxMTYgNjAgLTYgMTE3dC03MiA5MXpNMTY2NCAzODRxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTEwMjQgMTAyNHEwIDUzIC0zNy41IDkwLjUgdC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE0NzIgODMycTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek0xNzkyIDM4NHEwIC0yNjEgLTE0MSAtNDgzcS0xOSAtMjkgLTU0IC0yOWgtMTQwMnEtMzUgMCAtNTQgMjkgcS0xNDEgMjIxIC0xNDEgNDgzcTAgMTgyIDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxdDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBlNTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNODk2IDExNTJxLTIwNCAwIC0zODEuNSAtNjkuNXQtMjgyIC0xODcuNXQtMTA0LjUgLTI1NXEwIC0xMTIgNzEuNSAtMjEzLjV0MjAxLjUgLTE3NS41bDg3IC01MGwtMjcgLTk2cS0yNCAtOTEgLTcwIC0xNzJxMTUyIDYzIDI3NSAxNzFsNDMgMzhsNTcgLTZxNjkgLTggMTMwIC04cTIwNCAwIDM4MS41IDY5LjV0MjgyIDE4Ny41dDEwNC41IDI1NXQtMTA0LjUgMjU1dC0yODIgMTg3LjV0LTM4MS41IDY5LjV6TTE3OTIgNjQwIHEwIC0xNzQgLTEyMCAtMzIxLjV0LTMyNiAtMjMzdC00NTAgLTg1LjVxLTcwIDAgLTE0NSA4cS0xOTggLTE3NSAtNDYwIC0yNDJxLTQ5IC0xNCAtMTE0IC0yMmgtNXEtMTUgMCAtMjcgMTAuNXQtMTYgMjcuNXYxcS0zIDQgLTAuNSAxMnQyIDEwdDQuNSA5LjVsNiA5dDcgOC41dDggOXE3IDggMzEgMzQuNXQzNC41IDM4dDMxIDM5LjV0MzIuNSA1MXQyNyA1OXQyNiA3NnEtMTU3IDg5IC0yNDcuNSAyMjB0LTkwLjUgMjgxcTAgMTc0IDEyMCAzMjEuNSB0MzI2IDIzM3Q0NTAgODUuNXQ0NTAgLTg1LjV0MzI2IC0yMzN0MTIwIC0zMjEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBlNjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNzA0IDExNTJxLTE1MyAwIC0yODYgLTUydC0yMTEuNSAtMTQxdC03OC41IC0xOTFxMCAtODIgNTMgLTE1OHQxNDkgLTEzMmw5NyAtNTZsLTM1IC04NHEzNCAyMCA2MiAzOWw0NCAzMWw1MyAtMTBxNzggLTE0IDE1MyAtMTRxMTUzIDAgMjg2IDUydDIxMS41IDE0MXQ3OC41IDE5MXQtNzguNSAxOTF0LTIxMS41IDE0MXQtMjg2IDUyek03MDQgMTI4MHExOTEgMCAzNTMuNSAtNjguNXQyNTYuNSAtMTg2LjV0OTQgLTI1N3QtOTQgLTI1NyB0LTI1Ni41IC0xODYuNXQtMzUzLjUgLTY4LjVxLTg2IDAgLTE3NiAxNnEtMTI0IC04OCAtMjc4IC0xMjhxLTM2IC05IC04NiAtMTZoLTNxLTExIDAgLTIwLjUgOHQtMTEuNSAyMXEtMSAzIC0xIDYuNXQwLjUgNi41dDIgNmwyLjUgNXQzLjUgNS41dDQgNXQ0LjUgNXQ0IDQuNXE1IDYgMjMgMjV0MjYgMjkuNXQyMi41IDI5dDI1IDM4LjV0MjAuNSA0NHEtMTI0IDcyIC0xOTUgMTc3dC03MSAyMjRxMCAxMzkgOTQgMjU3dDI1Ni41IDE4Ni41IHQzNTMuNSA2OC41ek0xNTI2IDExMXExMCAtMjQgMjAuNSAtNDR0MjUgLTM4LjV0MjIuNSAtMjl0MjYgLTI5LjV0MjMgLTI1cTEgLTEgNCAtNC41dDQuNSAtNXQ0IC01dDMuNSAtNS41bDIuNSAtNXQyIC02dDAuNSAtNi41dC0xIC02LjVxLTMgLTE0IC0xMyAtMjJ0LTIyIC03cS01MCA3IC04NiAxNnEtMTU0IDQwIC0yNzggMTI4cS05MCAtMTYgLTE3NiAtMTZxLTI3MSAwIC00NzIgMTMycTU4IC00IDg4IC00cTE2MSAwIDMwOSA0NXQyNjQgMTI5IHExMjUgOTIgMTkyIDIxMnQ2NyAyNTRxMCA3NyAtMjMgMTUycTEyOSAtNzEgMjA0IC0xNzh0NzUgLTIzMHEwIC0xMjAgLTcxIC0yMjQuNXQtMTk1IC0xNzYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBlNzsiIGhvcml6LWFkdi14PSI4OTYiIGQ9Ik04ODUgOTcwcTE4IC0yMCA3IC00NGwtNTQwIC0xMTU3cS0xMyAtMjUgLTQyIC0yNXEtNCAwIC0xNCAycS0xNyA1IC0yNS41IDE5dC00LjUgMzBsMTk3IDgwOGwtNDA2IC0xMDFxLTQgLTEgLTEyIC0xcS0xOCAwIC0zMSAxMXEtMTggMTUgLTEzIDM5bDIwMSA4MjVxNCAxNCAxNiAyM3QyOCA5aDMyOHExOSAwIDMyIC0xMi41dDEzIC0yOS41cTAgLTggLTUgLTE4bC0xNzEgLTQ2M2wzOTYgOThxOCAyIDEyIDJxMTkgMCAzNCAtMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZTg7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE3OTIgMjg4di0zMjBxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYzMjBxMCA0MCAyOCA2OHQ2OCAyOGg5NnYxOTJoLTUxMnYtMTkyaDk2cTQwIDAgNjggLTI4dDI4IC02OHYtMzIwcTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMzIwcS00MCAwIC02OCAyOHQtMjggNjh2MzIwcTAgNDAgMjggNjh0NjggMjhoOTZ2MTkyaC01MTJ2LTE5Mmg5NnE0MCAwIDY4IC0yOHQyOCAtNjh2LTMyMCBxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0zMjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYzMjBxMCA0MCAyOCA2OHQ2OCAyOGg5NnYxOTJxMCA1MiAzOCA5MHQ5MCAzOGg1MTJ2MTkyaC05NnEtNDAgMCAtNjggMjh0LTI4IDY4djMyMHEwIDQwIDI4IDY4dDY4IDI4aDMyMHE0MCAwIDY4IC0yOHQyOCAtNjh2LTMyMHEwIC00MCAtMjggLTY4dC02OCAtMjhoLTk2di0xOTJoNTEycTUyIDAgOTAgLTM4dDM4IC05MHYtMTkyaDk2cTQwIDAgNjggLTI4dDI4IC02OCB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZTk7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTg5NiA3MDh2LTU4MHEwIC0xMDQgLTc2IC0xODB0LTE4MCAtNzZ0LTE4MCA3NnQtNzYgMTgwcTAgMjYgMTkgNDV0NDUgMTl0NDUgLTE5dDE5IC00NXEwIC01MCAzOSAtODl0ODkgLTM5dDg5IDM5dDM5IDg5djU4MHEzMyAxMSA2NCAxMXQ2NCAtMTF6TTE2NjQgNjgxcTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNXEtMTEgMCAtMjMgMTBxLTQ5IDQ2IC05MyA2OXQtMTAyIDIzcS02OCAwIC0xMjggLTM3dC0xMDMgLTk3IHEtNyAtMTAgLTE3LjUgLTI4dC0xNC41IC0yNHEtMTEgLTE3IC0yOCAtMTdxLTE4IDAgLTI5IDE3cS00IDYgLTE0LjUgMjR0LTE3LjUgMjhxLTQzIDYwIC0xMDIuNSA5N3QtMTI3LjUgMzd0LTEyNy41IC0zN3QtMTAyLjUgLTk3cS03IC0xMCAtMTcuNSAtMjh0LTE0LjUgLTI0cS0xMSAtMTcgLTI5IC0xN3EtMTcgMCAtMjggMTdxLTQgNiAtMTQuNSAyNHQtMTcuNSAyOHEtNDMgNjAgLTEwMyA5N3QtMTI4IDM3cS01OCAwIC0xMDIgLTIzdC05MyAtNjkgcS0xMiAtMTAgLTIzIC0xMHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41cTAgNSAxIDdxNDUgMTgzIDE3Mi41IDMxOS41dDI5OCAyMDQuNXQzNjAuNSA2OHExNDAgMCAyNzQuNSAtNDB0MjQ2LjUgLTExMy41dDE5NC41IC0xODd0MTE1LjUgLTI1MS41cTEgLTIgMSAtN3pNODk2IDE0MDh2LTk4cS00MiAyIC02NCAydC02NCAtMnY5OHEwIDI2IDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZWE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTc2OCAtMTI4aDg5NnY2NDBoLTQxNnEtNDAgMCAtNjggMjh0LTI4IDY4djQxNmgtMzg0di0xMTUyek0xMDI0IDEzMTJ2NjRxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC03MDRxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di02NHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDcwNHExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xMjgwIDY0MGgyOTlsLTI5OSAyOTl2LTI5OXpNMTc5MiA1MTJ2LTY3MnEwIC00MCAtMjggLTY4dC02OCAtMjggaC05NjBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjBoLTU0NHEtNDAgMCAtNjggMjh0LTI4IDY4djEzNDRxMCA0MCAyOCA2OHQ2OCAyOGgxMDg4cTQwIDAgNjggLTI4dDI4IC02OHYtMzI4cTIxIC0xMyAzNiAtMjhsNDA4IC00MDhxMjggLTI4IDQ4IC03NnQyMCAtODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZWI7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTczNiA5NjBxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41dC0yMi41IDkuNXQtOS41IDIyLjVxMCA0NiAtNTQgNzF0LTEwNiAyNXEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41dDkuNSAyMi41dDIyLjUgOS41cTUwIDAgOTkuNSAtMTZ0ODcgLTU0dDM3LjUgLTkwek04OTYgOTYwcTAgNzIgLTM0LjUgMTM0dC05MCAxMDEuNXQtMTIzIDYydC0xMzYuNSAyMi41dC0xMzYuNSAtMjIuNXQtMTIzIC02MnQtOTAgLTEwMS41dC0zNC41IC0xMzQgcTAgLTEwMSA2OCAtMTgwcTEwIC0xMSAzMC41IC0zM3QzMC41IC0zM3ExMjggLTE1MyAxNDEgLTI5OGgyMjhxMTMgMTQ1IDE0MSAyOThxMTAgMTEgMzAuNSAzM3QzMC41IDMzcTY4IDc5IDY4IDE4MHpNMTAyNCA5NjBxMCAtMTU1IC0xMDMgLTI2OHEtNDUgLTQ5IC03NC41IC04N3QtNTkuNSAtOTUuNXQtMzQgLTEwNy41cTQ3IC0yOCA0NyAtODJxMCAtMzcgLTI1IC02NHEyNSAtMjcgMjUgLTY0cTAgLTUyIC00NSAtODFxMTMgLTIzIDEzIC00NyBxMCAtNDYgLTMxLjUgLTcxdC03Ny41IC0yNXEtMjAgLTQ0IC02MCAtNzB0LTg3IC0yNnQtODcgMjZ0LTYwIDcwcS00NiAwIC03Ny41IDI1dC0zMS41IDcxcTAgMjQgMTMgNDdxLTQ1IDI5IC00NSA4MXEwIDM3IDI1IDY0cS0yNSAyNyAtMjUgNjRxMCA1NCA0NyA4MnEtNCA1MCAtMzQgMTA3LjV0LTU5LjUgOTUuNXQtNzQuNSA4N3EtMTAzIDExMyAtMTAzIDI2OHEwIDk5IDQ0LjUgMTg0LjV0MTE3IDE0MnQxNjQgODl0MTg2LjUgMzIuNSB0MTg2LjUgLTMyLjV0MTY0IC04OXQxMTcgLTE0MnQ0NC41IC0xODQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBlYzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiAzNTJ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTEzNzZ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVxLTEyIDAgLTI0IDEwbC0zMTkgMzIwcS05IDkgLTkgMjJxMCAxNCA5IDIzbDMyMCAzMjBxOSA5IDIzIDlxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0xOTJoMTM3NnExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTE3OTIgODk2cTAgLTE0IC05IC0yM2wtMzIwIC0zMjBxLTkgLTkgLTIzIC05IHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MmgtMTM3NnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDEzNzZ2MTkycTAgMTQgOSAyM3QyMyA5cTEyIDAgMjQgLTEwbDMxOSAtMzE5cTkgLTkgOSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZWQ7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTEyODAgNjA4cTAgMTQgLTkgMjN0LTIzIDloLTIyNHYzNTJxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xOTJxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di0zNTJoLTIyNHEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjVxMCAtMTQgOSAtMjNsMzUyIC0zNTJxOSAtOSAyMyAtOXQyMyA5bDM1MSAzNTFxMTAgMTIgMTAgMjR6TTE5MjAgMzg0cTAgLTE1OSAtMTEyLjUgLTI3MS41dC0yNzEuNSAtMTEyLjVoLTEwODggcS0xODUgMCAtMzE2LjUgMTMxLjV0LTEzMS41IDMxNi41cTAgMTMwIDcwIDI0MHQxODggMTY1cS0yIDMwIC0yIDQzcTAgMjEyIDE1MCAzNjJ0MzYyIDE1MHExNTYgMCAyODUuNSAtODd0MTg4LjUgLTIzMXE3MSA2MiAxNjYgNjJxMTA2IDAgMTgxIC03NXQ3NSAtMTgxcTAgLTc2IC00MSAtMTM4cTEzMCAtMzEgMjEzLjUgLTEzNS41dDgzLjUgLTIzOC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGVlOyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xMjgwIDY3MnEwIDE0IC05IDIzbC0zNTIgMzUycS05IDkgLTIzIDl0LTIzIC05bC0zNTEgLTM1MXEtMTAgLTEyIC0xMCAtMjRxMCAtMTQgOSAtMjN0MjMgLTloMjI0di0zNTJxMCAtMTMgOS41IC0yMi41dDIyLjUgLTkuNWgxOTJxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXYzNTJoMjI0cTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE5MjAgMzg0cTAgLTE1OSAtMTEyLjUgLTI3MS41dC0yNzEuNSAtMTEyLjVoLTEwODggcS0xODUgMCAtMzE2LjUgMTMxLjV0LTEzMS41IDMxNi41cTAgMTMwIDcwIDI0MHQxODggMTY1cS0yIDMwIC0yIDQzcTAgMjEyIDE1MCAzNjJ0MzYyIDE1MHExNTYgMCAyODUuNSAtODd0MTg4LjUgLTIzMXE3MSA2MiAxNjYgNjJxMTA2IDAgMTgxIC03NXQ3NSAtMTgxcTAgLTc2IC00MSAtMTM4cTEzMCAtMzEgMjEzLjUgLTEzNS41dDgzLjUgLTIzOC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGYwOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0zODQgMTkycTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV6TTE0MDggMTMxcTAgLTEyMSAtNzMgLTE5MHQtMTk0IC02OWgtODc0cS0xMjEgMCAtMTk0IDY5dC03MyAxOTBxMCA2OCA1LjUgMTMxdDI0IDEzOHQ0Ny41IDEzMi41dDgxIDEwM3QxMjAgNjAuNXEtMjIgLTUyIC0yMiAtMTIwdi0yMDNxLTU4IC0yMCAtOTMgLTcwdC0zNSAtMTExcTAgLTgwIDU2IC0xMzZ0MTM2IC01NiB0MTM2IDU2dDU2IDEzNnEwIDYxIC0zNS41IDExMXQtOTIuNSA3MHYyMDNxMCA2MiAyNSA5M3ExMzIgLTEwNCAyOTUgLTEwNHQyOTUgMTA0cTI1IC0zMSAyNSAtOTN2LTY0cS0xMDYgMCAtMTgxIC03NXQtNzUgLTE4MXYtODlxLTMyIC0yOSAtMzIgLTcxcTAgLTQwIDI4IC02OHQ2OCAtMjh0NjggMjh0MjggNjhxMCA0MiAtMzIgNzF2ODlxMCA1MiAzOCA5MHQ5MCAzOHQ5MCAtMzh0MzggLTkwdi04OXEtMzIgLTI5IC0zMiAtNzFxMCAtNDAgMjggLTY4IHQ2OCAtMjh0NjggMjh0MjggNjhxMCA0MiAtMzIgNzF2ODlxMCA2OCAtMzQuNSAxMjcuNXQtOTMuNSA5My41cTAgMTAgMC41IDQyLjV0MCA0OHQtMi41IDQxLjV0LTcgNDd0LTEzIDQwcTY4IC0xNSAxMjAgLTYwLjV0ODEgLTEwM3Q0Ny41IC0xMzIuNXQyNCAtMTM4dDUuNSAtMTMxek0xMDg4IDEwMjRxMCAtMTU5IC0xMTIuNSAtMjcxLjV0LTI3MS41IC0xMTIuNXQtMjcxLjUgMTEyLjV0LTExMi41IDI3MS41dDExMi41IDI3MS41dDI3MS41IDExMi41IHQyNzEuNSAtMTEyLjV0MTEyLjUgLTI3MS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGYxOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0xMjgwIDgzMnEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE0MDggODMycTAgLTYyIC0zNS41IC0xMTF0LTkyLjUgLTcwdi0zOTVxMCAtMTU5IC0xMzEuNSAtMjcxLjV0LTMxNi41IC0xMTIuNXQtMzE2LjUgMTEyLjV0LTEzMS41IDI3MS41djEzMnEtMTY0IDIwIC0yNzQgMTI4dC0xMTAgMjUydjUxMnEwIDI2IDE5IDQ1dDQ1IDE5cTYgMCAxNiAtMnExNyAzMCA0NyA0OCB0NjUgMThxNTMgMCA5MC41IC0zNy41dDM3LjUgLTkwLjV0LTM3LjUgLTkwLjV0LTkwLjUgLTM3LjVxLTMzIDAgLTY0IDE4di00MDJxMCAtMTA2IDk0IC0xODF0MjI2IC03NXQyMjYgNzV0OTQgMTgxdjQwMnEtMzEgLTE4IC02NCAtMThxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjVxMzUgMCA2NSAtMTh0NDcgLTQ4cTEwIDIgMTYgMnEyNiAwIDQ1IC0xOXQxOSAtNDV2LTUxMnEwIC0xNDQgLTExMCAtMjUyIHQtMjc0IC0xMjh2LTEzMnEwIC0xMDYgOTQgLTE4MXQyMjYgLTc1dDIyNiA3NXQ5NCAxODF2Mzk1cS01NyAyMSAtOTIuNSA3MHQtMzUuNSAxMTFxMCA4MCA1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBmMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNjQwIDExNTJoNTEydjEyOGgtNTEydi0xMjh6TTI4OCAxMTUydi0xMjgwaC02NHEtOTIgMCAtMTU4IDY2dC02NiAxNTh2ODMycTAgOTIgNjYgMTU4dDE1OCA2Nmg2NHpNMTQwOCAxMTUydi0xMjgwaC0xMDI0djEyODBoMTI4djE2MHEwIDQwIDI4IDY4dDY4IDI4aDU3NnE0MCAwIDY4IC0yOHQyOCAtNjh2LTE2MGgxMjh6TTE3OTIgOTI4di04MzJxMCAtOTIgLTY2IC0xNTh0LTE1OCAtNjZoLTY0djEyODBoNjRxOTIgMCAxNTggLTY2IHQ2NiAtMTU4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGYzOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik05MTIgLTE2MHEwIDE2IC0xNiAxNnEtNTkgMCAtMTAxLjUgNDIuNXQtNDIuNSAxMDEuNXEwIDE2IC0xNiAxNnQtMTYgLTE2cTAgLTczIDUxLjUgLTEyNC41dDEyNC41IC01MS41cTE2IDAgMTYgMTZ6TTE3MjggMTI4cTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtNDQ4cTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXQtMTgxIDc1dC03NSAxODFoLTQ0OHEtNTIgMCAtOTAgMzh0LTM4IDkwcTUwIDQyIDkxIDg4dDg1IDExOS41dDc0LjUgMTU4LjUgdDUwIDIwNnQxOS41IDI2MHEwIDE1MiAxMTcgMjgyLjV0MzA3IDE1OC41cS04IDE5IC04IDM5cTAgNDAgMjggNjh0NjggMjh0NjggLTI4dDI4IC02OHEwIC0yMCAtOCAtMzlxMTkwIC0yOCAzMDcgLTE1OC41dDExNyAtMjgyLjVxMCAtMTM5IDE5LjUgLTI2MHQ1MCAtMjA2dDc0LjUgLTE1OC41dDg1IC0xMTkuNXQ5MSAtODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZjQ7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTE2NjQgODk2cTAgODAgLTU2IDEzNnQtMTM2IDU2aC02NHYtMzg0aDY0cTgwIDAgMTM2IDU2dDU2IDEzNnpNMCAxMjhoMTc5MnEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzVoLTEyODBxLTEwNiAwIC0xODEgNzV0LTc1IDE4MXpNMTg1NiA4OTZxMCAtMTU5IC0xMTIuNSAtMjcxLjV0LTI3MS41IC0xMTIuNWgtNjR2LTMycTAgLTkyIC02NiAtMTU4dC0xNTggLTY2aC03MDRxLTkyIDAgLTE1OCA2NnQtNjYgMTU4djczNnEwIDI2IDE5IDQ1IHQ0NSAxOWgxMTUycTE1OSAwIDI3MS41IC0xMTIuNXQxMTIuNSAtMjcxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZjU7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTY0MCAxNDcydi02NDBxMCAtNjEgLTM1LjUgLTExMXQtOTIuNSAtNzB2LTc3OXEwIC01MiAtMzggLTkwdC05MCAtMzhoLTEyOHEtNTIgMCAtOTAgMzh0LTM4IDkwdjc3OXEtNTcgMjAgLTkyLjUgNzB0LTM1LjUgMTExdjY0MHEwIDI2IDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV2LTQxNnEwIC0yNiAxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1djQxNnEwIDI2IDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV2LTQxNnEwIC0yNiAxOSAtNDUgdDQ1IC0xOXQ0NSAxOXQxOSA0NXY0MTZxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTl0MTkgLTQ1ek0xNDA4IDE0NzJ2LTE2MDBxMCAtNTIgLTM4IC05MHQtOTAgLTM4aC0xMjhxLTUyIDAgLTkwIDM4dC0zOCA5MHY1MTJoLTIyNHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djgwMHEwIDEzMiA5NCAyMjZ0MjI2IDk0aDI1NnEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZjY7IiBkPSJNMTQ2OCAxMTU2cTI4IC0yOCA0OCAtNzZ0MjAgLTg4di0xMTUycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTM0NHEtNDAgMCAtNjggMjh0LTI4IDY4djE2MDBxMCA0MCAyOCA2OHQ2OCAyOGg4OTZxNDAgMCA4OCAtMjB0NzYgLTQ4ek0xMDI0IDE0MDB2LTM3NmgzNzZxLTEwIDI5IC0yMiA0MWwtMzEzIDMxM3EtMTIgMTIgLTQxIDIyek0xNDA4IC0xMjh2MTAyNGgtNDE2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC03Njh2LTE1MzZoMTI4MHogTTM4NCA3MzZxMCAxNCA5IDIzdDIzIDloNzA0cTE0IDAgMjMgLTl0OSAtMjN2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTcwNHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHpNMTEyMCA1MTJxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNzA0cS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDcwNHpNMTEyMCAyNTZxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNzA0IHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg3MDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZjc7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTM4NCAyMjR2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMzg0IDQ4MHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41eiBNNjQwIDQ4MHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0zODQgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE0xMTUyIDIyNHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek04OTYgNDgwdi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE02NDAgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTM4NCA5OTJ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTExNTIgNDgwdi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTg5NiA3MzZ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTY0MCA5OTJ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMzg0IDEyNDh2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTExNTIgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTg5NiA5OTJ2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTY0MCAxMjQ4di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTExNTIgOTkydi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE04OTYgMTI0OHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0xMTUyIDEyNDh2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXogTTg5NiAtMTI4aDM4NHYxNTM2aC0xMTUydi0xNTM2aDM4NHYyMjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgzMjBxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0yMjR6TTE0MDggMTQ3MnYtMTY2NHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEyODBxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxNjY0cTAgMjYgMTkgNDV0NDUgMTloMTI4MHEyNiAwIDQ1IC0xOXQxOSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYwZjg7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTM4NCAyMjR2LTY0cTAgLTEzIC05LjUgLTIyLjV0LTIyLjUgLTkuNWgtNjRxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXY2NHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDY0cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXpNMzg0IDQ4MHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41eiBNNjQwIDQ4MHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek0zODQgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE0xMTUyIDIyNHYtNjRxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC02NHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djY0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjRxMTMgMCAyMi41IC05LjV0OS41IC0yMi41ek04OTYgNDgwdi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE02NDAgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTExNTIgNDgwdi02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE04OTYgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTExNTIgNzM2di02NHEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTY0cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2NjRxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg2NHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6IE04OTYgLTEyOGgzODR2MTE1MmgtMjU2di0zMnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTQ0OHEtNDAgMCAtNjggMjh0LTI4IDY4djMyaC0yNTZ2LTExNTJoMzg0djIyNHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDMyMHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV2LTIyNHpNODk2IDEwNTZ2MzIwcTAgMTMgLTkuNSAyMi41dC0yMi41IDkuNWgtNjRxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di05NmgtMTI4djk2cTAgMTMgLTkuNSAyMi41IHQtMjIuNSA5LjVoLTY0cS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtMzIwcTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoNjRxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXY5NmgxMjh2LTk2cTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoNjRxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXpNMTQwOCAxMDg4di0xMjgwcTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTI4MHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyODBxMCAyNiAxOSA0NXQ0NSAxOWgzMjAgdjI4OHEwIDQwIDI4IDY4dDY4IDI4aDQ0OHE0MCAwIDY4IC0yOHQyOCAtNjh2LTI4OGgzMjBxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGY5OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik02NDAgMTI4cTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek0yNTYgNjQwaDM4NHYyNTZoLTE1OHEtMTQgLTIgLTIyIC05bC0xOTUgLTE5NXEtNyAtMTIgLTkgLTIydi0zMHpNMTUzNiAxMjhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41IHQ5MC41IDM3LjV0MzcuNSA5MC41ek0xNjY0IDgwMHYxOTJxMCAxNCAtOSAyM3QtMjMgOWgtMjI0djIyNHEwIDE0IC05IDIzdC0yMyA5aC0xOTJxLTE0IDAgLTIzIC05dC05IC0yM3YtMjI0aC0yMjRxLTE0IDAgLTIzIC05dC05IC0yM3YtMTkycTAgLTE0IDkgLTIzdDIzIC05aDIyNHYtMjI0cTAgLTE0IDkgLTIzdDIzIC05aDE5MnExNCAwIDIzIDl0OSAyM3YyMjRoMjI0cTE0IDAgMjMgOXQ5IDIzek0xOTIwIDEzNDR2LTExNTIgcTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTkycTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXQtMTgxIDc1dC03NSAxODFoLTM4NHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MSA3NXQtNzUgMTgxaC0xMjhxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NXQ0NSAxOXY0MTZxMCAyNiAxMyA1OHQzMiA1MWwxOTggMTk4cTE5IDE5IDUxIDMydDU4IDEzaDE2MHYzMjBxMCAyNiAxOSA0NXQ0NSAxOWgxMTUycTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBmYTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTI4MCA0MTZ2MTkycTAgMTQgLTkgMjN0LTIzIDloLTIyNHYyMjRxMCAxNCAtOSAyM3QtMjMgOWgtMTkycS0xNCAwIC0yMyAtOXQtOSAtMjN2LTIyNGgtMjI0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTE5MnEwIC0xNCA5IC0yM3QyMyAtOWgyMjR2LTIyNHEwIC0xNCA5IC0yM3QyMyAtOWgxOTJxMTQgMCAyMyA5dDkgMjN2MjI0aDIyNHExNCAwIDIzIDl0OSAyM3pNNjQwIDExNTJoNTEydjEyOGgtNTEydi0xMjh6TTI1NiAxMTUydi0xMjgwaC0zMiBxLTkyIDAgLTE1OCA2NnQtNjYgMTU4djgzMnEwIDkyIDY2IDE1OHQxNTggNjZoMzJ6TTE0NDAgMTE1MnYtMTI4MGgtMTA4OHYxMjgwaDE2MHYxNjBxMCA0MCAyOCA2OHQ2OCAyOGg1NzZxNDAgMCA2OCAtMjh0MjggLTY4di0xNjBoMTYwek0xNzkyIDkyOHYtODMycTAgLTkyIC02NiAtMTU4dC0xNTggLTY2aC0zMnYxMjgwaDMycTkyIDAgMTU4IC02NnQ2NiAtMTU4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGZiOyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xOTIwIDU3NnEtMSAtMzIgLTI4OCAtOTZsLTM1MiAtMzJsLTIyNCAtNjRoLTY0bC0yOTMgLTM1Mmg2OXEyNiAwIDQ1IC00LjV0MTkgLTExLjV0LTE5IC0xMS41dC00NSAtNC41aC05NmgtMTYwaC02NHYzMmg2NHY0MTZoLTE2MGwtMTkyIC0yMjRoLTk2bC0zMiAzMnYxOTJoMzJ2MzJoMTI4djhsLTE5MiAyNHYxMjhsMTkyIDI0djhoLTEyOHYzMmgtMzJ2MTkybDMyIDMyaDk2bDE5MiAtMjI0aDE2MHY0MTZoLTY0djMyaDY0aDE2MGg5NiBxMjYgMCA0NSAtNC41dDE5IC0xMS41dC0xOSAtMTEuNXQtNDUgLTQuNWgtNjlsMjkzIC0zNTJoNjRsMjI0IC02NGwzNTIgLTMycTI2MSAtNTggMjg3IC05M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBmYzsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNjQwIDY0MHYzODRoLTI1NnYtMjU2cTAgLTUzIDM3LjUgLTkwLjV0OTAuNSAtMzcuNWgxMjh6TTE2NjQgMTkydi0xOTJoLTExNTJ2MTkybDEyOCAxOTJoLTEyOHEtMTU5IDAgLTI3MS41IDExMi41dC0xMTIuNSAyNzEuNXYzMjBsLTY0IDY0bDMyIDEyOGg0ODBsMzIgMTI4aDk2MGwzMiAtMTkybC02NCAtMzJ2LTgwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjBmZDsiIGQ9Ik0xMjgwIDE5MnY4OTZxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0zMjBoLTUxMnYzMjBxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di04OTZxMCAtMjYgMTkgLTQ1dDQ1IC0xOWgxMjhxMjYgMCA0NSAxOXQxOSA0NXYzMjBoNTEydi0zMjBxMCAtMjYgMTkgLTQ1dDQ1IC0xOWgxMjhxMjYgMCA0NSAxOXQxOSA0NXpNMTUzNiAxMTIwdi05NjAgcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMGZlOyIgZD0iTTEyODAgNTc2djEyOHEwIDI2IC0xOSA0NXQtNDUgMTloLTMyMHYzMjBxMCAyNiAtMTkgNDV0LTQ1IDE5aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0zMjBoLTMyMHEtMjYgMCAtNDUgLTE5dC0xOSAtNDV2LTEyOHEwIC0yNiAxOSAtNDV0NDUgLTE5aDMyMHYtMzIwcTAgLTI2IDE5IC00NXQ0NSAtMTloMTI4cTI2IDAgNDUgMTl0MTkgNDV2MzIwaDMyMHEyNiAwIDQ1IDE5dDE5IDQ1ek0xNTM2IDExMjB2LTk2MCBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMDA7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTYyNyAxNjBxMCAtMTMgLTEwIC0yM2wtNTAgLTUwcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTQ2NiA0NjZxLTEwIDEwIC0xMCAyM3QxMCAyM2w0NjYgNDY2cTEwIDEwIDIzIDEwdDIzIC0xMGw1MCAtNTBxMTAgLTEwIDEwIC0yM3QtMTAgLTIzbC0zOTMgLTM5M2wzOTMgLTM5M3ExMCAtMTAgMTAgLTIzek0xMDExIDE2MHEwIC0xMyAtMTAgLTIzbC01MCAtNTBxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtNDY2IDQ2NnEtMTAgMTAgLTEwIDIzIHQxMCAyM2w0NjYgNDY2cTEwIDEwIDIzIDEwdDIzIC0xMGw1MCAtNTBxMTAgLTEwIDEwIC0yM3QtMTAgLTIzbC0zOTMgLTM5M2wzOTMgLTM5M3ExMCAtMTAgMTAgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTAxOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik01OTUgNTc2cTAgLTEzIC0xMCAtMjNsLTQ2NiAtNDY2cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTUwIDUwcS0xMCAxMCAtMTAgMjN0MTAgMjNsMzkzIDM5M2wtMzkzIDM5M3EtMTAgMTAgLTEwIDIzdDEwIDIzbDUwIDUwcTEwIDEwIDIzIDEwdDIzIC0xMGw0NjYgLTQ2NnExMCAtMTAgMTAgLTIzek05NzkgNTc2cTAgLTEzIC0xMCAtMjNsLTQ2NiAtNDY2cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTUwIDUwcS0xMCAxMCAtMTAgMjN0MTAgMjMgbDM5MyAzOTNsLTM5MyAzOTNxLTEwIDEwIC0xMCAyM3QxMCAyM2w1MCA1MHExMCAxMCAyMyAxMHQyMyAtMTBsNDY2IC00NjZxMTAgLTEwIDEwIC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwMjsiIGhvcml6LWFkdi14PSIxMTUyIiBkPSJNMTA3NSAyMjRxMCAtMTMgLTEwIC0yM2wtNTAgLTUwcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTM5MyAzOTNsLTM5MyAtMzkzcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTUwIDUwcS0xMCAxMCAtMTAgMjN0MTAgMjNsNDY2IDQ2NnExMCAxMCAyMyAxMHQyMyAtMTBsNDY2IC00NjZxMTAgLTEwIDEwIC0yM3pNMTA3NSA2MDhxMCAtMTMgLTEwIC0yM2wtNTAgLTUwcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTM5MyAzOTNsLTM5MyAtMzkzIHEtMTAgLTEwIC0yMyAtMTB0LTIzIDEwbC01MCA1MHEtMTAgMTAgLTEwIDIzdDEwIDIzbDQ2NiA0NjZxMTAgMTAgMjMgMTB0MjMgLTEwbDQ2NiAtNDY2cTEwIC0xMCAxMCAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMDM7IiBob3Jpei1hZHYteD0iMTE1MiIgZD0iTTEwNzUgNjcycTAgLTEzIC0xMCAtMjNsLTQ2NiAtNDY2cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTQ2NiA0NjZxLTEwIDEwIC0xMCAyM3QxMCAyM2w1MCA1MHExMCAxMCAyMyAxMHQyMyAtMTBsMzkzIC0zOTNsMzkzIDM5M3ExMCAxMCAyMyAxMHQyMyAtMTBsNTAgLTUwcTEwIC0xMCAxMCAtMjN6TTEwNzUgMTA1NnEwIC0xMyAtMTAgLTIzbC00NjYgLTQ2NnEtMTAgLTEwIC0yMyAtMTB0LTIzIDEwbC00NjYgNDY2cS0xMCAxMCAtMTAgMjMgdDEwIDIzbDUwIDUwcTEwIDEwIDIzIDEwdDIzIC0xMGwzOTMgLTM5M2wzOTMgMzkzcTEwIDEwIDIzIDEwdDIzIC0xMGw1MCAtNTBxMTAgLTEwIDEwIC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwNDsiIGhvcml6LWFkdi14PSI2NDAiIGQ9Ik02MjcgOTkycTAgLTEzIC0xMCAtMjNsLTM5MyAtMzkzbDM5MyAtMzkzcTEwIC0xMCAxMCAtMjN0LTEwIC0yM2wtNTAgLTUwcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTQ2NiA0NjZxLTEwIDEwIC0xMCAyM3QxMCAyM2w0NjYgNDY2cTEwIDEwIDIzIDEwdDIzIC0xMGw1MCAtNTBxMTAgLTEwIDEwIC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwNTsiIGhvcml6LWFkdi14PSI2NDAiIGQ9Ik01OTUgNTc2cTAgLTEzIC0xMCAtMjNsLTQ2NiAtNDY2cS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTUwIDUwcS0xMCAxMCAtMTAgMjN0MTAgMjNsMzkzIDM5M2wtMzkzIDM5M3EtMTAgMTAgLTEwIDIzdDEwIDIzbDUwIDUwcTEwIDEwIDIzIDEwdDIzIC0xMGw0NjYgLTQ2NnExMCAtMTAgMTAgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTA2OyIgaG9yaXotYWR2LXg9IjExNTIiIGQ9Ik0xMDc1IDM1MnEwIC0xMyAtMTAgLTIzbC01MCAtNTBxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtMzkzIDM5M2wtMzkzIC0zOTNxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtNTAgNTBxLTEwIDEwIC0xMCAyM3QxMCAyM2w0NjYgNDY2cTEwIDEwIDIzIDEwdDIzIC0xMGw0NjYgLTQ2NnExMCAtMTAgMTAgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTA3OyIgaG9yaXotYWR2LXg9IjExNTIiIGQ9Ik0xMDc1IDgwMHEwIC0xMyAtMTAgLTIzbC00NjYgLTQ2NnEtMTAgLTEwIC0yMyAtMTB0LTIzIDEwbC00NjYgNDY2cS0xMCAxMCAtMTAgMjN0MTAgMjNsNTAgNTBxMTAgMTAgMjMgMTB0MjMgLTEwbDM5MyAtMzkzbDM5MyAzOTNxMTAgMTAgMjMgMTB0MjMgLTEwbDUwIC01MHExMCAtMTAgMTAgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTA4OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xNzkyIDU0NHY4MzJxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xNjAwcS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtODMycTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTYwMHExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xOTIwIDEzNzZ2LTEwODhxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTU0NHEwIC0zNyAxNiAtNzcuNXQzMiAtNzF0MTYgLTQzLjVxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC01MTJxLTI2IDAgLTQ1IDE5IHQtMTkgNDVxMCAxNCAxNiA0NHQzMiA3MHQxNiA3OGgtNTQ0cS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMDg4cTAgNjYgNDcgMTEzdDExMyA0N2gxNjAwcTY2IDAgMTEzIC00N3Q0NyAtMTEzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTA5OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik00MTYgMjU2cS02NiAwIC0xMTMgNDd0LTQ3IDExM3Y3MDRxMCA2NiA0NyAxMTN0MTEzIDQ3aDEwODhxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTcwNHEwIC02NiAtNDcgLTExM3QtMTEzIC00N2gtMTA4OHpNMzg0IDExMjB2LTcwNHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDEwODhxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXY3MDRxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xMDg4cS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXogTTE3NjAgMTkyaDE2MHYtOTZxMCAtNDAgLTQ3IC02OHQtMTEzIC0yOGgtMTYwMHEtNjYgMCAtMTEzIDI4dC00NyA2OHY5NmgxNjBoMTYwMHpNMTA0MCA5NnExNiAwIDE2IDE2dC0xNiAxNmgtMTYwcS0xNiAwIC0xNiAtMTZ0MTYgLTE2aDE2MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwYTsiIGhvcml6LWFkdi14PSIxMTUyIiBkPSJNNjQwIDEyOHEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTEwMjQgMjg4djk2MHEwIDEzIC05LjUgMjIuNXQtMjIuNSA5LjVoLTgzMnEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTk2MHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDgzMnExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xMTUyIDEyNDh2LTEwODhxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTgzMiBxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjEwODhxMCA2NiA0NyAxMTN0MTEzIDQ3aDgzMnE2NiAwIDExMyAtNDd0NDcgLTExM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwYjsiIGhvcml6LWFkdi14PSI3NjgiIGQ9Ik00NjQgMTI4cTAgMzMgLTIzLjUgNTYuNXQtNTYuNSAyMy41dC01Ni41IC0yMy41dC0yMy41IC01Ni41dDIzLjUgLTU2LjV0NTYuNSAtMjMuNXQ1Ni41IDIzLjV0MjMuNSA1Ni41ek02NzIgMjg4djcwNHEwIDEzIC05LjUgMjIuNXQtMjIuNSA5LjVoLTUxMnEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTcwNHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDUxMnExMyAwIDIyLjUgOS41dDkuNSAyMi41ek00ODAgMTEzNiBxMCAxNiAtMTYgMTZoLTE2MHEtMTYgMCAtMTYgLTE2dDE2IC0xNmgxNjBxMTYgMCAxNiAxNnpNNzY4IDExNTJ2LTEwMjRxMCAtNTIgLTM4IC05MHQtOTAgLTM4aC01MTJxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMDI0cTAgNTIgMzggOTB0OTAgMzhoNTEycTUyIDAgOTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwYzsiIGQ9Ik03NjggMTE4NHEtMTQ4IDAgLTI3MyAtNzN0LTE5OCAtMTk4dC03MyAtMjczdDczIC0yNzN0MTk4IC0xOTh0MjczIC03M3QyNzMgNzN0MTk4IDE5OHQ3MyAyNzN0LTczIDI3M3QtMTk4IDE5OHQtMjczIDczek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwMyB0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMGQ7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTc2OCA1NzZ2LTM4NHEwIC04MCAtNTYgLTEzNnQtMTM2IC01NmgtMzg0cS04MCAwIC0xMzYgNTZ0LTU2IDEzNnY3MDRxMCAxMDQgNDAuNSAxOTguNXQxMDkuNSAxNjMuNXQxNjMuNSAxMDkuNXQxOTguNSA0MC41aDY0cTI2IDAgNDUgLTE5dDE5IC00NXYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtNjRxLTEwNiAwIC0xODEgLTc1dC03NSAtMTgxdi0zMnEwIC00MCAyOCAtNjh0NjggLTI4aDIyNHE4MCAwIDEzNiAtNTZ0NTYgLTEzNnogTTE2NjQgNTc2di0zODRxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZoLTM4NHEtODAgMCAtMTM2IDU2dC01NiAxMzZ2NzA0cTAgMTA0IDQwLjUgMTk4LjV0MTA5LjUgMTYzLjV0MTYzLjUgMTA5LjV0MTk4LjUgNDAuNWg2NHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTEyOHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTY0cS0xMDYgMCAtMTgxIC03NXQtNzUgLTE4MXYtMzJxMCAtNDAgMjggLTY4dDY4IC0yOGgyMjRxODAgMCAxMzYgLTU2dDU2IC0xMzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMGU7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTc2OCAxMjE2di03MDRxMCAtMTA0IC00MC41IC0xOTguNXQtMTA5LjUgLTE2My41dC0xNjMuNSAtMTA5LjV0LTE5OC41IC00MC41aC02NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDY0cTEwNiAwIDE4MSA3NXQ3NSAxODF2MzJxMCA0MCAtMjggNjh0LTY4IDI4aC0yMjRxLTgwIDAgLTEzNiA1NnQtNTYgMTM2djM4NHEwIDgwIDU2IDEzNnQxMzYgNTZoMzg0cTgwIDAgMTM2IC01NnQ1NiAtMTM2ek0xNjY0IDEyMTYgdi03MDRxMCAtMTA0IC00MC41IC0xOTguNXQtMTA5LjUgLTE2My41dC0xNjMuNSAtMTA5LjV0LTE5OC41IC00MC41aC02NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDY0cTEwNiAwIDE4MSA3NXQ3NSAxODF2MzJxMCA0MCAtMjggNjh0LTY4IDI4aC0yMjRxLTgwIDAgLTEzNiA1NnQtNTYgMTM2djM4NHEwIDgwIDU2IDEzNnQxMzYgNTZoMzg0cTgwIDAgMTM2IC01NnQ1NiAtMTM2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTEwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik01MjYgMTQycTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41cS01MiAwIC05MCAzOHQtMzggOTBxMCA1MyAzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTAyNCAtNjRxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0zMjAgNjQwcTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41IHQtOTAuNSAzNy41dC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTE1MjIgMTQycTAgLTUyIC0zOCAtOTB0LTkwIC0zOHEtNTMgMCAtOTAuNSAzNy41dC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTU1OCAxMTM4cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3dC0xMTMgNDd0LTQ3IDExM3Q0NyAxMTN0MTEzIDQ3dDExMyAtNDd0NDcgLTExM3ogTTE3MjggNjQwcTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41dC05MC41IDM3LjV0LTM3LjUgOTAuNXQzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTA4OCAxMzQ0cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMTYxOCAxMTM4cTAgLTkzIC02NiAtMTU4LjV0LTE1OCAtNjUuNXEtOTMgMCAtMTU4LjUgNjUuNXQtNjUuNSAxNTguNSBxMCA5MiA2NS41IDE1OHQxNTguNSA2NnE5MiAwIDE1OCAtNjZ0NjYgLTE1OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExMTsiIGQ9Ik0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MiA0MTZxMCAtMTY2IC0xMjcgLTQ1MXEtMyAtNyAtMTAuNSAtMjR0LTEzLjUgLTMwdC0xMyAtMjJxLTEyIC0xNyAtMjggLTE3cS0xNSAwIC0yMy41IDEwdC04LjUgMjVxMCA5IDIuNSAyNi41dDIuNSAyMy41cTUgNjggNSAxMjNxMCAxMDEgLTE3LjUgMTgxdC00OC41IDEzOC41dC04MCAxMDF0LTEwNS41IDY5LjV0LTEzMyA0Mi41dC0xNTQgMjEuNXQtMTc1LjUgNmgtMjI0di0yNTZxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOSBsLTUxMiA1MTJxLTE5IDE5IC0xOSA0NXQxOSA0NWw1MTIgNTEycTE5IDE5IDQ1IDE5dDQ1IC0xOXQxOSAtNDV2LTI1NmgyMjRxNzEzIDAgODc1IC00MDNxNTMgLTEzNCA1MyAtMzMzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTEzOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik02NDAgMzIwcTAgLTQwIC0xMi41IC04MnQtNDMgLTc2dC03Mi41IC0zNHQtNzIuNSAzNHQtNDMgNzZ0LTEyLjUgODJ0MTIuNSA4MnQ0MyA3NnQ3Mi41IDM0dDcyLjUgLTM0dDQzIC03NnQxMi41IC04MnpNMTI4MCAzMjBxMCAtNDAgLTEyLjUgLTgydC00MyAtNzZ0LTcyLjUgLTM0dC03Mi41IDM0dC00MyA3NnQtMTIuNSA4MnQxMi41IDgydDQzIDc2dDcyLjUgMzR0NzIuNSAtMzR0NDMgLTc2dDEyLjUgLTgyek0xNDQwIDMyMCBxMCAxMjAgLTY5IDIwNHQtMTg3IDg0cS00MSAwIC0xOTUgLTIxcS03MSAtMTEgLTE1NyAtMTF0LTE1NyAxMXEtMTUyIDIxIC0xOTUgMjFxLTExOCAwIC0xODcgLTg0dC02OSAtMjA0cTAgLTg4IDMyIC0xNTMuNXQ4MSAtMTAzdDEyMiAtNjB0MTQwIC0yOS41dDE0OSAtN2gxNjhxODIgMCAxNDkgN3QxNDAgMjkuNXQxMjIgNjB0ODEgMTAzdDMyIDE1My41ek0xNjY0IDQ5NnEwIC0yMDcgLTYxIC0zMzFxLTM4IC03NyAtMTA1LjUgLTEzM3QtMTQxIC04NiB0LTE3MCAtNDcuNXQtMTcxLjUgLTIydC0xNjcgLTQuNXEtNzggMCAtMTQyIDN0LTE0Ny41IDEyLjV0LTE1Mi41IDMwdC0xMzcgNTEuNXQtMTIxIDgxdC04NiAxMTVxLTYyIDEyMyAtNjIgMzMxcTAgMjM3IDEzNiAzOTZxLTI3IDgyIC0yNyAxNzBxMCAxMTYgNTEgMjE4cTEwOCAwIDE5MCAtMzkuNXQxODkgLTEyMy41cTE0NyAzNSAzMDkgMzVxMTQ4IDAgMjgwIC0zMnExMDUgODIgMTg3IDEyMXQxODkgMzlxNTEgLTEwMiA1MSAtMjE4IHEwIC04NyAtMjcgLTE2OHExMzYgLTE2MCAxMzYgLTM5OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExNDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTUzNiAyMjR2NzA0cTAgNDAgLTI4IDY4dC02OCAyOGgtNzA0cS00MCAwIC02OCAyOHQtMjggNjh2NjRxMCA0MCAtMjggNjh0LTY4IDI4aC0zMjBxLTQwIDAgLTY4IC0yOHQtMjggLTY4di05NjBxMCAtNDAgMjggLTY4dDY4IC0yOGgxMjE2cTQwIDAgNjggMjh0MjggNjh6TTE2NjQgOTI4di03MDRxMCAtOTIgLTY2IC0xNTh0LTE1OCAtNjZoLTEyMTZxLTkyIDAgLTE1OCA2NnQtNjYgMTU4djk2MHEwIDkyIDY2IDE1OHQxNTggNjZoMzIwIHE5MiAwIDE1OCAtNjZ0NjYgLTE1OHYtMzJoNjcycTkyIDAgMTU4IC02NnQ2NiAtMTU4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTE1OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xNzgxIDYwNXEwIDM1IC01MyAzNWgtMTA4OHEtNDAgMCAtODUuNSAtMjEuNXQtNzEuNSAtNTIuNWwtMjk0IC0zNjNxLTE4IC0yNCAtMTggLTQwcTAgLTM1IDUzIC0zNWgxMDg4cTQwIDAgODYgMjJ0NzEgNTNsMjk0IDM2M3ExOCAyMiAxOCAzOXpNNjQwIDc2OGg3Njh2MTYwcTAgNDAgLTI4IDY4dC02OCAyOGgtNTc2cS00MCAwIC02OCAyOHQtMjggNjh2NjRxMCA0MCAtMjggNjh0LTY4IDI4aC0zMjBxLTQwIDAgLTY4IC0yOHQtMjggLTY4IHYtODUzbDI1NiAzMTVxNDQgNTMgMTE2IDg3LjV0MTQwIDM0LjV6TTE5MDkgNjA1cTAgLTYyIC00NiAtMTIwbC0yOTUgLTM2M3EtNDMgLTUzIC0xMTYgLTg3LjV0LTE0MCAtMzQuNWgtMTA4OHEtOTIgMCAtMTU4IDY2dC02NiAxNTh2OTYwcTAgOTIgNjYgMTU4dDE1OCA2NmgzMjBxOTIgMCAxNTggLTY2dDY2IC0xNTh2LTMyaDU0NHE5MiAwIDE1OCAtNjZ0NjYgLTE1OHYtMTYwaDE5MnE1NCAwIDk5IC0yNC41dDY3IC03MC41cTE1IC0zMiAxNSAtNjh6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTE2OyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExNzsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMTg7IiBkPSJNMTEzNCA0NjFxLTM3IC0xMjEgLTEzOCAtMTk1dC0yMjggLTc0dC0yMjggNzR0LTEzOCAxOTVxLTggMjUgNCA0OC41dDM4IDMxLjVxMjUgOCA0OC41IC00dDMxLjUgLTM4cTI1IC04MCA5Mi41IC0xMjkuNXQxNTEuNSAtNDkuNXQxNTEuNSA0OS41dDkyLjUgMTI5LjVxOCAyNiAzMiAzOHQ0OSA0dDM3IC0zMS41dDQgLTQ4LjV6TTY0MCA4OTZxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41IHQzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTE1MiA4OTZxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xNDA4IDY0MHEwIDEzMCAtNTEgMjQ4LjV0LTEzNi41IDIwNHQtMjA0IDEzNi41dC0yNDguNSA1MXQtMjQ4LjUgLTUxdC0yMDQgLTEzNi41dC0xMzYuNSAtMjA0dC01MSAtMjQ4LjUgdDUxIC0yNDguNXQxMzYuNSAtMjA0dDIwNCAtMTM2LjV0MjQ4LjUgLTUxdDI0OC41IDUxdDIwNCAxMzYuNXQxMzYuNSAyMDR0NTEgMjQ4LjV6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTE5OyIgZD0iTTExMzQgMzA3cTggLTI1IC00IC00OC41dC0zNyAtMzEuNXQtNDkgNHQtMzIgMzhxLTI1IDgwIC05Mi41IDEyOS41dC0xNTEuNSA0OS41dC0xNTEuNSAtNDkuNXQtOTIuNSAtMTI5LjVxLTggLTI2IC0zMS41IC0zOHQtNDguNSAtNHEtMjYgOCAtMzggMzEuNXQtNCA0OC41cTM3IDEyMSAxMzggMTk1dDIyOCA3NHQyMjggLTc0dDEzOCAtMTk1ek02NDAgODk2cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41dC05MC41IDM3LjUgdC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTExNTIgODk2cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41dC05MC41IDM3LjV0LTM3LjUgOTAuNXQzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTQwOCA2NDBxMCAxMzAgLTUxIDI0OC41dC0xMzYuNSAyMDR0LTIwNCAxMzYuNXQtMjQ4LjUgNTF0LTI0OC41IC01MXQtMjA0IC0xMzYuNXQtMTM2LjUgLTIwNCB0LTUxIC0yNDguNXQ1MSAtMjQ4LjV0MTM2LjUgLTIwNHQyMDQgLTEzNi41dDI0OC41IC01MXQyNDguNSA1MXQyMDQgMTM2LjV0MTM2LjUgMjA0dDUxIDI0OC41ek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExYTsiIGQ9Ik0xMTUyIDQ0OHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTY0MHEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5aDY0MHEyNiAwIDQ1IC0xOXQxOSAtNDV6TTY0MCA4OTZxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xMTUyIDg5NnEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNXQtOTAuNSAzNy41IHQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xNDA4IDY0MHEwIDEzMCAtNTEgMjQ4LjV0LTEzNi41IDIwNHQtMjA0IDEzNi41dC0yNDguNSA1MXQtMjQ4LjUgLTUxdC0yMDQgLTEzNi41dC0xMzYuNSAtMjA0dC01MSAtMjQ4LjV0NTEgLTI0OC41dDEzNi41IC0yMDR0MjA0IC0xMzYuNXQyNDguNSAtNTF0MjQ4LjUgNTF0MjA0IDEzNi41dDEzNi41IDIwNHQ1MSAyNDguNXpNMTUzNiA2NDAgcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTFiOyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik04MzIgNDQ4djEyOHEwIDE0IC05IDIzdC0yMyA5aC0xOTJ2MTkycTAgMTQgLTkgMjN0LTIzIDloLTEyOHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xOTJoLTE5MnEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xMjhxMCAtMTQgOSAtMjN0MjMgLTloMTkydi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMTI4cTE0IDAgMjMgOXQ5IDIzdjE5MmgxOTJxMTQgMCAyMyA5dDkgMjN6TTE0MDggMzg0cTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41IHQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNMTY2NCA2NDBxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE5MjAgNTEycTAgLTIxMiAtMTUwIC0zNjJ0LTM2MiAtMTUwcS0xOTIgMCAtMzM4IDEyOGgtMjIwcS0xNDYgLTEyOCAtMzM4IC0xMjhxLTIxMiAwIC0zNjIgMTUwIHQtMTUwIDM2MnQxNTAgMzYydDM2MiAxNTBoODk2cTIxMiAwIDM2MiAtMTUwdDE1MCAtMzYyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTFjOyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0zODQgMzY4di05NnEwIC0xNiAtMTYgLTE2aC05NnEtMTYgMCAtMTYgMTZ2OTZxMCAxNiAxNiAxNmg5NnExNiAwIDE2IC0xNnpNNTEyIDYyNHYtOTZxMCAtMTYgLTE2IC0xNmgtMjI0cS0xNiAwIC0xNiAxNnY5NnEwIDE2IDE2IDE2aDIyNHExNiAwIDE2IC0xNnpNMzg0IDg4MHYtOTZxMCAtMTYgLTE2IC0xNmgtOTZxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTZoOTZxMTYgMCAxNiAtMTZ6TTE0MDggMzY4di05NnEwIC0xNiAtMTYgLTE2IGgtODY0cS0xNiAwIC0xNiAxNnY5NnEwIDE2IDE2IDE2aDg2NHExNiAwIDE2IC0xNnpNNzY4IDYyNHYtOTZxMCAtMTYgLTE2IC0xNmgtOTZxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTZoOTZxMTYgMCAxNiAtMTZ6TTY0MCA4ODB2LTk2cTAgLTE2IC0xNiAtMTZoLTk2cS0xNiAwIC0xNiAxNnY5NnEwIDE2IDE2IDE2aDk2cTE2IDAgMTYgLTE2ek0xMDI0IDYyNHYtOTZxMCAtMTYgLTE2IC0xNmgtOTZxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTYgaDk2cTE2IDAgMTYgLTE2ek04OTYgODgwdi05NnEwIC0xNiAtMTYgLTE2aC05NnEtMTYgMCAtMTYgMTZ2OTZxMCAxNiAxNiAxNmg5NnExNiAwIDE2IC0xNnpNMTI4MCA2MjR2LTk2cTAgLTE2IC0xNiAtMTZoLTk2cS0xNiAwIC0xNiAxNnY5NnEwIDE2IDE2IDE2aDk2cTE2IDAgMTYgLTE2ek0xNjY0IDM2OHYtOTZxMCAtMTYgLTE2IC0xNmgtOTZxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTZoOTZxMTYgMCAxNiAtMTZ6TTExNTIgODgwdi05NiBxMCAtMTYgLTE2IC0xNmgtOTZxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTZoOTZxMTYgMCAxNiAtMTZ6TTE0MDggODgwdi05NnEwIC0xNiAtMTYgLTE2aC05NnEtMTYgMCAtMTYgMTZ2OTZxMCAxNiAxNiAxNmg5NnExNiAwIDE2IC0xNnpNMTY2NCA4ODB2LTM1MnEwIC0xNiAtMTYgLTE2aC0yMjRxLTE2IDAgLTE2IDE2djk2cTAgMTYgMTYgMTZoMTEydjI0MHEwIDE2IDE2IDE2aDk2cTE2IDAgMTYgLTE2ek0xNzkyIDEyOHY4OTZoLTE2NjR2LTg5NiBoMTY2NHpNMTkyMCAxMDI0di04OTZxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjVoLTE2NjRxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41djg5NnEwIDUzIDM3LjUgOTAuNXQ5MC41IDM3LjVoMTY2NHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjExZDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTY2NCA0OTF2NjE2cS0xNjkgLTkxIC0zMDYgLTkxcS04MiAwIC0xNDUgMzJxLTEwMCA0OSAtMTg0IDc2LjV0LTE3OCAyNy41cS0xNzMgMCAtNDAzIC0xMjd2LTU5OXEyNDUgMTEzIDQzMyAxMTNxNTUgMCAxMDMuNSAtNy41dDk4IC0yNnQ3NyAtMzF0ODIuNSAtMzkuNWwyOCAtMTRxNDQgLTIyIDEwMSAtMjJxMTIwIDAgMjkzIDkyek0zMjAgMTI4MHEwIC0zNSAtMTcuNSAtNjR0LTQ2LjUgLTQ2di0xMjY2cTAgLTE0IC05IC0yM3QtMjMgLTkgaC02NHEtMTQgMCAtMjMgOXQtOSAyM3YxMjY2cS0yOSAxNyAtNDYuNSA0NnQtMTcuNSA2NHEwIDUzIDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xNzkyIDEyMTZ2LTc2M3EwIC0zOSAtMzUgLTU3cS0xMCAtNSAtMTcgLTlxLTIxOCAtMTE2IC0zNjkgLTExNnEtODggMCAtMTU4IDM1bC0yOCAxNHEtNjQgMzMgLTk5IDQ4dC05MSAyOXQtMTE0IDE0cS0xMDIgMCAtMjM1LjUgLTQ0dC0yMjguNSAtMTAyIHEtMTUgLTkgLTMzIC05cS0xNiAwIC0zMiA4cS0zMiAxOSAtMzIgNTZ2NzQycTAgMzUgMzEgNTVxMzUgMjEgNzguNSA0Mi41dDExNCA1MnQxNTIuNSA0OS41dDE1NSAxOXExMTIgMCAyMDkgLTMxdDIwOSAtODZxMzggLTE5IDg5IC0xOXExMjIgMCAzMTAgMTEycTIyIDEyIDMxIDE3cTMxIDE2IDYyIC0ycTMxIC0yMCAzMSAtNTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMWU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTgzMiA1MzZ2MTkycS0xODEgLTE2IC0zODQgLTExN3YtMTg1cTIwNSA5NiAzODQgMTEwek04MzIgOTU0djE5N3EtMTcyIC04IC0zODQgLTEyNnYtMTg5cTIxNSAxMTEgMzg0IDExOHpNMTY2NCA0OTF2MTg0cS0yMzUgLTExNiAtMzg0IC03MXYyMjRxLTIwIDYgLTM5IDE1cS01IDMgLTMzIDE3dC0zNC41IDE3dC0zMS41IDE1dC0zNC41IDE1LjV0LTMyLjUgMTN0LTM2IDEyLjV0LTM1IDguNXQtMzkuNSA3LjV0LTM5LjUgNHQtNDQgMiBxLTIzIDAgLTQ5IC0zdi0yMjJoMTlxMTAyIDAgMTkyLjUgLTI5dDE5Ny41IC04MnExOSAtOSAzOSAtMTV2LTE4OHE0MiAtMTcgOTEgLTE3cTEyMCAwIDI5MyA5MnpNMTY2NCA5MTh2MTg5cS0xNjkgLTkxIC0zMDYgLTkxcS00NSAwIC03OCA4di0xOTZxMTQ4IC00MiAzODQgOTB6TTMyMCAxMjgwcTAgLTM1IC0xNy41IC02NHQtNDYuNSAtNDZ2LTEyNjZxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjRxLTE0IDAgLTIzIDl0LTkgMjN2MTI2NiBxLTI5IDE3IC00Ni41IDQ2dC0xNy41IDY0cTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTE3OTIgMTIxNnYtNzYzcTAgLTM5IC0zNSAtNTdxLTEwIC01IC0xNyAtOXEtMjE4IC0xMTYgLTM2OSAtMTE2cS04OCAwIC0xNTggMzVsLTI4IDE0cS02NCAzMyAtOTkgNDh0LTkxIDI5dC0xMTQgMTRxLTEwMiAwIC0yMzUuNSAtNDR0LTIyOC41IC0xMDJxLTE1IC05IC0zMyAtOXEtMTYgMCAtMzIgOCBxLTMyIDE5IC0zMiA1NnY3NDJxMCAzNSAzMSA1NXEzNSAyMSA3OC41IDQyLjV0MTE0IDUydDE1Mi41IDQ5LjV0MTU1IDE5cTExMiAwIDIwOSAtMzF0MjA5IC04NnEzOCAtMTkgODkgLTE5cTEyMiAwIDMxMCAxMTJxMjIgMTIgMzEgMTdxMzEgMTYgNjIgLTJxMzEgLTIwIDMxIC01NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyMDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNTg1IDU1M2wtNDY2IC00NjZxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtNTAgNTBxLTEwIDEwIC0xMCAyM3QxMCAyM2wzOTMgMzkzbC0zOTMgMzkzcS0xMCAxMCAtMTAgMjN0MTAgMjNsNTAgNTBxMTAgMTAgMjMgMTB0MjMgLTEwbDQ2NiAtNDY2cTEwIC0xMCAxMCAtMjN0LTEwIC0yM3pNMTY2NCA5NnYtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTYwcS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDk2MHExNCAwIDIzIC05IHQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyMTsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNNjE3IDEzN2wtNTAgLTUwcS0xMCAtMTAgLTIzIC0xMHQtMjMgMTBsLTQ2NiA0NjZxLTEwIDEwIC0xMCAyM3QxMCAyM2w0NjYgNDY2cTEwIDEwIDIzIDEwdDIzIC0xMGw1MCAtNTBxMTAgLTEwIDEwIC0yM3QtMTAgLTIzbC0zOTMgLTM5M2wzOTMgLTM5M3ExMCAtMTAgMTAgLTIzdC0xMCAtMjN6TTEyMDggMTIwNGwtMzczIC0xMjkxcS00IC0xMyAtMTUuNSAtMTkuNXQtMjMuNSAtMi41bC02MiAxN3EtMTMgNCAtMTkuNSAxNS41dC0yLjUgMjQuNSBsMzczIDEyOTFxNCAxMyAxNS41IDE5LjV0MjMuNSAyLjVsNjIgLTE3cTEzIC00IDE5LjUgLTE1LjV0Mi41IC0yNC41ek0xODY1IDU1M2wtNDY2IC00NjZxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtNTAgNTBxLTEwIDEwIC0xMCAyM3QxMCAyM2wzOTMgMzkzbC0zOTMgMzkzcS0xMCAxMCAtMTAgMjN0MTAgMjNsNTAgNTBxMTAgMTAgMjMgMTB0MjMgLTEwbDQ2NiAtNDY2cTEwIC0xMCAxMCAtMjN0LTEwIC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNjQwIDQ1NHYtNzBxMCAtNDIgLTM5IC01OXEtMTMgLTUgLTI1IC01cS0yNyAwIC00NSAxOWwtNTEyIDUxMnEtMTkgMTkgLTE5IDQ1dDE5IDQ1bDUxMiA1MTJxMjkgMzEgNzAgMTRxMzkgLTE3IDM5IC01OXYtNjlsLTM5NyAtMzk4cS0xOSAtMTkgLTE5IC00NXQxOSAtNDV6TTE3OTIgNDE2cTAgLTU4IC0xNyAtMTMzLjV0LTM4LjUgLTEzOHQtNDggLTEyNXQtNDAuNSAtOTAuNWwtMjAgLTQwcS04IC0xNyAtMjggLTE3cS02IDAgLTkgMSBxLTI1IDggLTIzIDM0cTQzIDQwMCAtMTA2IDU2NXEtNjQgNzEgLTE3MC41IDExMC41dC0yNjcuNSA1Mi41di0yNTFxMCAtNDIgLTM5IC01OXEtMTMgLTUgLTI1IC01cS0yNyAwIC00NSAxOWwtNTEyIDUxMnEtMTkgMTkgLTE5IDQ1dDE5IDQ1bDUxMiA1MTJxMjkgMzEgNzAgMTRxMzkgLTE3IDM5IC01OXYtMjYycTQxMSAtMjggNTk5IC0yMjFxMTY5IC0xNzMgMTY5IC01MDl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMjM7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTExODYgNTc5bDI1NyAyNTBsLTM1NiA1MmwtNjYgMTBsLTMwIDYwbC0xNTkgMzIydi05NjNsNTkgLTMxbDMxOCAtMTY4bC02MCAzNTVsLTEyIDY2ek0xNjM4IDg0MWwtMzYzIC0zNTRsODYgLTUwMHE1IC0zMyAtNiAtNTEuNXQtMzQgLTE4LjVxLTE3IDAgLTQwIDEybC00NDkgMjM2bC00NDkgLTIzNnEtMjMgLTEyIC00MCAtMTJxLTIzIDAgLTM0IDE4LjV0LTYgNTEuNWw4NiA1MDBsLTM2NCAzNTRxLTMyIDMyIC0yMyA1OS41dDU0IDM0LjUgbDUwMiA3M2wyMjUgNDU1cTIwIDQxIDQ5IDQxcTI4IDAgNDkgLTQxbDIyNSAtNDU1bDUwMiAtNzNxNDUgLTcgNTQgLTM0LjV0LTI0IC01OS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTI0OyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0xNDAxIDExODdsLTY0MCAtMTI4MHEtMTcgLTM1IC01NyAtMzVxLTUgMCAtMTUgMnEtMjIgNSAtMzUuNSAyMi41dC0xMy41IDM5LjV2NTc2aC01NzZxLTIyIDAgLTM5LjUgMTMuNXQtMjIuNSAzNS41dDQgNDJ0MjkgMzBsMTI4MCA2NDBxMTMgNyAyOSA3cTI3IDAgNDUgLTE5cTE1IC0xNCAxOC41IC0zNC41dC02LjUgLTM5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMjU7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTU1NyAyNTZoNTk1djU5NXpNNTEyIDMwMWw1OTUgNTk1aC01OTV2LTU5NXpNMTY2NCAyMjR2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0yMjR2LTIyNHEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MjI0aC04NjRxLTE0IDAgLTIzIDl0LTkgMjN2ODY0aC0yMjRxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDIyNHYyMjRxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjMgdi0yMjRoODUxbDI0NiAyNDdxMTAgOSAyMyA5dDIzIC05cTkgLTEwIDkgLTIzdC05IC0yM2wtMjQ3IC0yNDZ2LTg1MWgyMjRxMTQgMCAyMyAtOXQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyNjsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNMjg4IDY0cTAgNDAgLTI4IDY4dC02OCAyOHQtNjggLTI4dC0yOCAtNjh0MjggLTY4dDY4IC0yOHQ2OCAyOHQyOCA2OHpNMjg4IDEyMTZxMCA0MCAtMjggNjh0LTY4IDI4dC02OCAtMjh0LTI4IC02OHQyOCAtNjh0NjggLTI4dDY4IDI4dDI4IDY4ek05MjggMTA4OHEwIDQwIC0yOCA2OHQtNjggMjh0LTY4IC0yOHQtMjggLTY4dDI4IC02OHQ2OCAtMjh0NjggMjh0MjggNjh6TTEwMjQgMTA4OHEwIC01MiAtMjYgLTk2LjV0LTcwIC02OS41IHEtMiAtMjg3IC0yMjYgLTQxNHEtNjggLTM4IC0yMDMgLTgxcS0xMjggLTQwIC0xNjkuNSAtNzF0LTQxLjUgLTEwMHYtMjZxNDQgLTI1IDcwIC02OS41dDI2IC05Ni41cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnEwIDUyIDI2IDk2LjV0NzAgNjkuNXY4MjBxLTQ0IDI1IC03MCA2OS41dC0yNiA5Ni41cTAgODAgNTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZxMCAtNTIgLTI2IC05Ni41dC03MCAtNjkuNXYtNDk3IHE1NCAyNiAxNTQgNTdxNTUgMTcgODcuNSAyOS41dDcwLjUgMzF0NTkgMzkuNXQ0MC41IDUxdDI4IDY5LjV0OC41IDkxLjVxLTQ0IDI1IC03MCA2OS41dC0yNiA5Ni41cTAgODAgNTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMjc7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTQzOSAyNjVsLTI1NiAtMjU2cS0xMCAtOSAtMjMgLTlxLTEyIDAgLTIzIDlxLTkgMTAgLTkgMjN0OSAyM2wyNTYgMjU2cTEwIDkgMjMgOXQyMyAtOXE5IC0xMCA5IC0yM3QtOSAtMjN6TTYwOCAyMjR2LTMyMHEwIC0xNCAtOSAtMjN0LTIzIC05dC0yMyA5dC05IDIzdjMyMHEwIDE0IDkgMjN0MjMgOXQyMyAtOXQ5IC0yM3pNMzg0IDQ0OHEwIC0xNCAtOSAtMjN0LTIzIC05aC0zMjBxLTE0IDAgLTIzIDl0LTkgMjN0OSAyM3QyMyA5aDMyMCBxMTQgMCAyMyAtOXQ5IC0yM3pNMTY0OCAzMjBxMCAtMTIwIC04NSAtMjAzbC0xNDcgLTE0NnEtODMgLTgzIC0yMDMgLTgzcS0xMjEgMCAtMjA0IDg1bC0zMzQgMzM1cS0yMSAyMSAtNDIgNTZsMjM5IDE4bDI3MyAtMjc0cTI3IC0yNyA2OCAtMjcuNXQ2OCAyNi41bDE0NyAxNDZxMjggMjggMjggNjdxMCA0MCAtMjggNjhsLTI3NCAyNzVsMTggMjM5cTM1IC0yMSA1NiAtNDJsMzM2IC0zMzZxODQgLTg2IDg0IC0yMDR6TTEwMzEgMTA0NGwtMjM5IC0xOCBsLTI3MyAyNzRxLTI4IDI4IC02OCAyOHEtMzkgMCAtNjggLTI3bC0xNDcgLTE0NnEtMjggLTI4IC0yOCAtNjdxMCAtNDAgMjggLTY4bDI3NCAtMjc0bC0xOCAtMjQwcS0zNSAyMSAtNTYgNDJsLTMzNiAzMzZxLTg0IDg2IC04NCAyMDRxMCAxMjAgODUgMjAzbDE0NyAxNDZxODMgODMgMjAzIDgzcTEyMSAwIDIwNCAtODVsMzM0IC0zMzVxMjEgLTIxIDQyIC01NnpNMTY2NCA5NjBxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMzIwcS0xNCAwIC0yMyA5IHQtOSAyM3Q5IDIzdDIzIDloMzIwcTE0IDAgMjMgLTl0OSAtMjN6TTExMjAgMTUwNHYtMzIwcTAgLTE0IC05IC0yM3QtMjMgLTl0LTIzIDl0LTkgMjN2MzIwcTAgMTQgOSAyM3QyMyA5dDIzIC05dDkgLTIzek0xNTI3IDEzNTNsLTI1NiAtMjU2cS0xMSAtOSAtMjMgLTl0LTIzIDlxLTkgMTAgLTkgMjN0OSAyM2wyNTYgMjU2cTEwIDkgMjMgOXQyMyAtOXE5IC0xMCA5IC0yM3QtOSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMjg7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTcwNCAyODB2LTI0MHEwIC0xNiAtMTIgLTI4dC0yOCAtMTJoLTI0MHEtMTYgMCAtMjggMTJ0LTEyIDI4djI0MHEwIDE2IDEyIDI4dDI4IDEyaDI0MHExNiAwIDI4IC0xMnQxMiAtMjh6TTEwMjAgODgwcTAgLTU0IC0xNS41IC0xMDF0LTM1IC03Ni41dC01NSAtNTkuNXQtNTcuNSAtNDMuNXQtNjEgLTM1LjVxLTQxIC0yMyAtNjguNSAtNjV0LTI3LjUgLTY3cTAgLTE3IC0xMiAtMzIuNXQtMjggLTE1LjVoLTI0MHEtMTUgMCAtMjUuNSAxOC41IHQtMTAuNSAzNy41djQ1cTAgODMgNjUgMTU2LjV0MTQzIDEwOC41cTU5IDI3IDg0IDU2dDI1IDc2cTAgNDIgLTQ2LjUgNzR0LTEwNy41IDMycS02NSAwIC0xMDggLTI5cS0zNSAtMjUgLTEwNyAtMTE1cS0xMyAtMTYgLTMxIC0xNnEtMTIgMCAtMjUgOGwtMTY0IDEyNXEtMTMgMTAgLTE1LjUgMjV0NS41IDI4cTE2MCAyNjYgNDY0IDI2NnE4MCAwIDE2MSAtMzF0MTQ2IC04M3QxMDYgLTEyNy41dDQxIC0xNTguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyOTsiIGhvcml6LWFkdi14PSI2NDAiIGQ9Ik02NDAgMTkydi0xMjhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC01MTJxLTI2IDAgLTQ1IDE5dC0xOSA0NXYxMjhxMCAyNiAxOSA0NXQ0NSAxOWg2NHYzODRoLTY0cS0yNiAwIC00NSAxOXQtMTkgNDV2MTI4cTAgMjYgMTkgNDV0NDUgMTloMzg0cTI2IDAgNDUgLTE5dDE5IC00NXYtNTc2aDY0cTI2IDAgNDUgLTE5dDE5IC00NXpNNTEyIDEzNDR2LTE5MnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTI1NnEtMjYgMCAtNDUgMTl0LTE5IDQ1djE5MiBxMCAyNiAxOSA0NXQ0NSAxOWgyNTZxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTJhOyIgaG9yaXotYWR2LXg9IjY0MCIgZD0iTTUxMiAyODh2LTIyNHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTI1NnEtMjYgMCAtNDUgMTl0LTE5IDQ1djIyNHEwIDI2IDE5IDQ1dDQ1IDE5aDI1NnEyNiAwIDQ1IC0xOXQxOSAtNDV6TTU0MiAxMzQ0bC0yOCAtNzY4cS0xIC0yNiAtMjAuNSAtNDV0LTQ1LjUgLTE5aC0yNTZxLTI2IDAgLTQ1LjUgMTl0LTIwLjUgNDVsLTI4IDc2OHEtMSAyNiAxNy41IDQ1dDQ0LjUgMTloMzIwcTI2IDAgNDQuNSAtMTl0MTcuNSAtNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMmI7IiBkPSJNODk3IDE2N3YtMTY3aC0yNDhsLTE1OSAyNTJsLTI0IDQycS04IDkgLTExIDIxaC0zbC05IC0yMXEtMTAgLTIwIC0yNSAtNDRsLTE1NSAtMjUwaC0yNTh2MTY3aDEyOGwxOTcgMjkxbC0xODUgMjcyaC0xMzd2MTY4aDI3NmwxMzkgLTIyOHEyIC00IDIzIC00MnE4IC05IDExIC0yMWgzcTMgOSAxMSAyMWwyNSA0MmwxNDAgMjI4aDI1N3YtMTY4aC0xMjVsLTE4NCAtMjY3bDIwNCAtMjk2aDEwOXpNMTUzNCA4NDZ2LTIwNmgtNTE0bC0zIDI3IHEtNCAyOCAtNCA0NnEwIDY0IDI2IDExN3Q2NSA4Ni41dDg0IDY1dDg0IDU0LjV0NjUgNTR0MjYgNjRxMCAzOCAtMjkuNSA2Mi41dC03MC41IDI0LjVxLTUxIDAgLTk3IC0zOXEtMTQgLTExIC0zNiAtMzhsLTEwNSA5MnEyNiAzNyA2MyA2NnE4MyA2NSAxODggNjVxMTEwIDAgMTc4IC01OS41dDY4IC0xNTguNXEwIC01NiAtMjQuNSAtMTAzdC02MiAtNzYuNXQtODEuNSAtNTguNXQtODIgLTUwLjV0LTY1LjUgLTUxLjV0LTMwLjUgLTYzaDIzMnY4MCBoMTI2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTJjOyIgZD0iTTg5NyAxNjd2LTE2N2gtMjQ4bC0xNTkgMjUybC0yNCA0MnEtOCA5IC0xMSAyMWgtM2wtOSAtMjFxLTEwIC0yMCAtMjUgLTQ0bC0xNTUgLTI1MGgtMjU4djE2N2gxMjhsMTk3IDI5MWwtMTg1IDI3MmgtMTM3djE2OGgyNzZsMTM5IC0yMjhxMiAtNCAyMyAtNDJxOCAtOSAxMSAtMjFoM3EzIDkgMTEgMjFsMjUgNDJsMTQwIDIyOGgyNTd2LTE2OGgtMTI1bC0xODQgLTI2N2wyMDQgLTI5NmgxMDl6TTE1MzYgLTUwdi0yMDZoLTUxNGwtNCAyNyBxLTMgNDUgLTMgNDZxMCA2NCAyNiAxMTd0NjUgODYuNXQ4NCA2NXQ4NCA1NC41dDY1IDU0dDI2IDY0cTAgMzggLTI5LjUgNjIuNXQtNzAuNSAyNC41cS01MSAwIC05NyAtMzlxLTE0IC0xMSAtMzYgLTM4bC0xMDUgOTJxMjYgMzcgNjMgNjZxODAgNjUgMTg4IDY1cTExMCAwIDE3OCAtNTkuNXQ2OCAtMTU4LjVxMCAtNjYgLTM0LjUgLTExOC41dC04NCAtODZ0LTk5LjUgLTYyLjV0LTg3IC02M3QtNDEgLTczaDIzMnY4MGgxMjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMmQ7IiBob3Jpei1hZHYteD0iMTkyMCIgZD0iTTg5NiAxMjhsMzM2IDM4NGgtNzY4bC0zMzYgLTM4NGg3Njh6TTE5MDkgMTIwNXExNSAtMzQgOS41IC03MS41dC0zMC41IC02NS41bC04OTYgLTEwMjRxLTM4IC00NCAtOTYgLTQ0aC03NjhxLTM4IDAgLTY5LjUgMjAuNXQtNDcuNSA1NC41cS0xNSAzNCAtOS41IDcxLjV0MzAuNSA2NS41bDg5NiAxMDI0cTM4IDQ0IDk2IDQ0aDc2OHEzOCAwIDY5LjUgLTIwLjV0NDcuNSAtNTQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEyZTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTY2NCA0MzhxMCAtODEgLTQ0LjUgLTEzNXQtMTIzLjUgLTU0cS00MSAwIC03Ny41IDE3LjV0LTU5IDM4dC01Ni41IDM4dC03MSAxNy41cS0xMTAgMCAtMTEwIC0xMjRxMCAtMzkgMTYgLTExNXQxNSAtMTE1di01cS0yMiAwIC0zMyAtMXEtMzQgLTMgLTk3LjUgLTExLjV0LTExNS41IC0xMy41dC05OCAtNXEtNjEgMCAtMTAzIDI2LjV0LTQyIDgzLjVxMCAzNyAxNy41IDcxdDM4IDU2LjV0MzggNTl0MTcuNSA3Ny41cTAgNzkgLTU0IDEyMy41IHQtMTM1IDQ0LjVxLTg0IDAgLTE0MyAtNDUuNXQtNTkgLTEyNy41cTAgLTQzIDE1IC04M3QzMy41IC02NC41dDMzLjUgLTUzdDE1IC01MC41cTAgLTQ1IC00NiAtODlxLTM3IC0zNSAtMTE3IC0zNXEtOTUgMCAtMjQ1IDI0cS05IDIgLTI3LjUgNHQtMjcuNSA0bC0xMyAycS0xIDAgLTMgMXEtMiAwIC0yIDF2MTAyNHEyIC0xIDE3LjUgLTMuNXQzNCAtNXQyMS41IC0zLjVxMTUwIC0yNCAyNDUgLTI0cTgwIDAgMTE3IDM1cTQ2IDQ0IDQ2IDg5IHEwIDIyIC0xNSA1MC41dC0zMy41IDUzdC0zMy41IDY0LjV0LTE1IDgzcTAgODIgNTkgMTI3LjV0MTQ0IDQ1LjVxODAgMCAxMzQgLTQ0LjV0NTQgLTEyMy41cTAgLTQxIC0xNy41IC03Ny41dC0zOCAtNTl0LTM4IC01Ni41dC0xNy41IC03MXEwIC01NyA0MiAtODMuNXQxMDMgLTI2LjVxNjQgMCAxODAgMTV0MTYzIDE3di0ycS0xIC0yIC0zLjUgLTE3LjV0LTUgLTM0dC0zLjUgLTIxLjVxLTI0IC0xNTAgLTI0IC0yNDVxMCAtODAgMzUgLTExNyBxNDQgLTQ2IDg5IC00NnEyMiAwIDUwLjUgMTV0NTMgMzMuNXQ2NC41IDMzLjV0ODMgMTVxODIgMCAxMjcuNSAtNTl0NDUuNSAtMTQzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTMwOyIgaG9yaXotYWR2LXg9IjExNTIiIGQ9Ik0xMTUyIDgzMnYtMTI4cTAgLTIyMSAtMTQ3LjUgLTM4NC41dC0zNjQuNSAtMTg3LjV2LTEzMmgyNTZxMjYgMCA0NSAtMTl0MTkgLTQ1dC0xOSAtNDV0LTQ1IC0xOWgtNjQwcS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMjU2djEzMnEtMjE3IDI0IC0zNjQuNSAxODcuNXQtMTQ3LjUgMzg0LjV2MTI4cTAgMjYgMTkgNDV0NDUgMTl0NDUgLTE5dDE5IC00NXYtMTI4cTAgLTE4NSAxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41IHQzMTYuNSAxMzEuNXQxMzEuNSAzMTYuNXYxMjhxMCAyNiAxOSA0NXQ0NSAxOXQ0NSAtMTl0MTkgLTQ1ek04OTYgMTIxNnYtNTEycTAgLTEzMiAtOTQgLTIyNnQtMjI2IC05NHQtMjI2IDk0dC05NCAyMjZ2NTEycTAgMTMyIDk0IDIyNnQyMjYgOTR0MjI2IC05NHQ5NCAtMjI2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTMxOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0yNzEgNTkxbC0xMDEgLTEwMXEtNDIgMTAzIC00MiAyMTR2MTI4cTAgMjYgMTkgNDV0NDUgMTl0NDUgLTE5dDE5IC00NXYtMTI4cTAgLTUzIDE1IC0xMTN6TTEzODUgMTE5M2wtMzYxIC0zNjF2LTEyOHEwIC0xMzIgLTk0IC0yMjZ0LTIyNiAtOTRxLTU1IDAgLTEwOSAxOWwtOTYgLTk2cTk3IC01MSAyMDUgLTUxcTE4NSAwIDMxNi41IDEzMS41dDEzMS41IDMxNi41djEyOHEwIDI2IDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV2LTEyOCBxMCAtMjIxIC0xNDcuNSAtMzg0LjV0LTM2NC41IC0xODcuNXYtMTMyaDI1NnEyNiAwIDQ1IC0xOXQxOSAtNDV0LTE5IC00NXQtNDUgLTE5aC02NDBxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NXQ0NSAxOWgyNTZ2MTMycS0xMjUgMTMgLTIzNSA4MWwtMjU0IC0yNTRxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtODIgODJxLTEwIDEwIC0xMCAyM3QxMCAyM2wxMjM0IDEyMzRxMTAgMTAgMjMgMTB0MjMgLTEwbDgyIC04MnExMCAtMTAgMTAgLTIzIHQtMTAgLTIzek0xMDA1IDEzMjVsLTYyMSAtNjIxdjUxMnEwIDEzMiA5NCAyMjZ0MjI2IDk0cTEwMiAwIDE4NC41IC01OXQxMTYuNSAtMTUyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTMyOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMDg4IDU3NnY2NDBoLTQ0OHYtMTEzN3ExMTkgNjMgMjEzIDEzN3EyMzUgMTg0IDIzNSAzNjB6TTEyODAgMTM0NHYtNzY4cTAgLTg2IC0zMy41IC0xNzAuNXQtODMgLTE1MHQtMTE4IC0xMjcuNXQtMTI2LjUgLTEwM3QtMTIxIC03Ny41dC04OS41IC00OS41dC00Mi41IC0yMHEtMTIgLTYgLTI2IC02dC0yNiA2cS0xNiA3IC00Mi41IDIwdC04OS41IDQ5LjV0LTEyMSA3Ny41dC0xMjYuNSAxMDN0LTExOCAxMjcuNXQtODMgMTUwIHQtMzMuNSAxNzAuNXY3NjhxMCAyNiAxOSA0NXQ0NSAxOWgxMTUycTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzMzsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTI4IC0xMjhoMTQwOHYxMDI0aC0xNDA4di0xMDI0ek01MTIgMTA4OHYyODhxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtMjg4cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek0xMjgwIDEwODh2Mjg4cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTI4OHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNMTY2NCAxMTUydi0xMjgwIHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTE0MDhxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMjgwcTAgNTIgMzggOTB0OTAgMzhoMTI4djk2cTAgNjYgNDcgMTEzdDExMyA0N2g2NHE2NiAwIDExMyAtNDd0NDcgLTExM3YtOTZoMzg0djk2cTAgNjYgNDcgMTEzdDExMyA0N2g2NHE2NiAwIDExMyAtNDd0NDcgLTExM3YtOTZoMTI4cTUyIDAgOTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzNDsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNNTEyIDEzNDRxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1ek0xNDA4IDEzNzZ2LTMyMHEwIC0xNiAtMTIgLTI1cS04IC03IC0yMCAtN3EtNCAwIC03IDFsLTQ0OCA5NnEtMTEgMiAtMTggMTF0LTcgMjBoLTI1NnYtMTAycTExMSAtMjMgMTgzLjUgLTExMXQ3Mi41IC0yMDN2LTgwMHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTUxMnEtMjYgMCAtNDUgMTl0LTE5IDQ1djgwMCBxMCAxMDYgNjIuNSAxOTAuNXQxNjEuNSAxMTQuNXYxMTFoLTMycS01OSAwIC0xMTUgLTIzLjV0LTkxLjUgLTUzdC02NiAtNjYuNXQtNDAuNSAtNTMuNXQtMTQgLTI0LjVxLTE3IC0zNSAtNTcgLTM1cS0xNiAwIC0yOSA3cS0yMyAxMiAtMzEuNSAzN3QzLjUgNDlxNSAxMCAxNC41IDI2dDM3LjUgNTMuNXQ2MC41IDcwdDg1IDY3dDEwOC41IDUyLjVxLTI1IDQyIC0yNSA4NnEwIDY2IDQ3IDExM3QxMTMgNDd0MTEzIC00N3Q0NyAtMTEzIHEwIC0zMyAtMTQgLTY0aDMwMnEwIDExIDcgMjB0MTggMTFsNDQ4IDk2cTMgMSA3IDFxMTIgMCAyMCAtN3ExMiAtOSAxMiAtMjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMzU7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE0NDAgMTA4OHEwIDQwIC0yOCA2OHQtNjggMjh0LTY4IC0yOHQtMjggLTY4dDI4IC02OHQ2OCAtMjh0NjggMjh0MjggNjh6TTE2NjQgMTM3NnEwIC0yNDkgLTc1LjUgLTQzMC41dC0yNTMuNSAtMzYwLjVxLTgxIC04MCAtMTk1IC0xNzZsLTIwIC0zNzlxLTIgLTE2IC0xNiAtMjZsLTM4NCAtMjI0cS03IC00IC0xNiAtNHEtMTIgMCAtMjMgOWwtNjQgNjRxLTEzIDE0IC04IDMybDg1IDI3NmwtMjgxIDI4MWwtMjc2IC04NXEtMyAtMSAtOSAtMSBxLTE0IDAgLTIzIDlsLTY0IDY0cS0xNyAxOSAtNSAzOWwyMjQgMzg0cTEwIDE0IDI2IDE2bDM3OSAyMHE5NiAxMTQgMTc2IDE5NXExODggMTg3IDM1OCAyNTh0NDMxIDcxcTE0IDAgMjQgLTkuNXQxMCAtMjIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzNjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc0NSA3NjNsLTE2NCAtNzYzaC0zMzRsMTc4IDgzMnExMyA1NiAtMTUgODhxLTI3IDMzIC04MyAzM2gtMTY5bC0yMDQgLTk1M2gtMzM0bDIwNCA5NTNoLTI4NmwtMjA0IC05NTNoLTMzNGwyMDQgOTUzbC0xNTMgMzI3aDEyNzZxMTAxIDAgMTg5LjUgLTQwLjV0MTQ3LjUgLTExMy41cTYwIC03MyA4MSAtMTY4LjV0MCAtMTk0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxMzc7IiBkPSJNOTA5IDE0MWwxMDIgMTAycTE5IDE5IDE5IDQ1dC0xOSA0NWwtMzA3IDMwN2wzMDcgMzA3cTE5IDE5IDE5IDQ1dC0xOSA0NWwtMTAyIDEwMnEtMTkgMTkgLTQ1IDE5dC00NSAtMTlsLTQ1NCAtNDU0cS0xOSAtMTkgLTE5IC00NXQxOSAtNDVsNDU0IC00NTRxMTkgLTE5IDQ1IC0xOXQ0NSAxOXpNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjUgdC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTM4OyIgZD0iTTcxNyAxNDFsNDU0IDQ1NHExOSAxOSAxOSA0NXQtMTkgNDVsLTQ1NCA0NTRxLTE5IDE5IC00NSAxOXQtNDUgLTE5bC0xMDIgLTEwMnEtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDMwNyAtMzA3bC0zMDcgLTMwN3EtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDEwMiAtMTAycTE5IC0xOSA0NSAtMTl0NDUgMTl6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41IHQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzOTsiIGQ9Ik0xMTY1IDM5N2wxMDIgMTAycTE5IDE5IDE5IDQ1dC0xOSA0NWwtNDU0IDQ1NHEtMTkgMTkgLTQ1IDE5dC00NSAtMTlsLTQ1NCAtNDU0cS0xOSAtMTkgLTE5IC00NXQxOSAtNDVsMTAyIC0xMDJxMTkgLTE5IDQ1IC0xOXQ0NSAxOWwzMDcgMzA3bDMwNyAtMzA3cTE5IC0xOSA0NSAtMTl0NDUgMTl6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41IHQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzYTsiIGQ9Ik04MTMgMjM3bDQ1NCA0NTRxMTkgMTkgMTkgNDV0LTE5IDQ1bC0xMDIgMTAycS0xOSAxOSAtNDUgMTl0LTQ1IC0xOWwtMzA3IC0zMDdsLTMwNyAzMDdxLTE5IDE5IC00NSAxOXQtNDUgLTE5bC0xMDIgLTEwMnEtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDQ1NCAtNDU0cTE5IC0xOSA0NSAtMTl0NDUgMTl6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41IHQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzYjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTEzMCA5MzlsMTYgMTc1aC04ODRsNDcgLTUzNGg2MTJsLTIyIC0yMjhsLTE5NyAtNTNsLTE5NiA1M2wtMTMgMTQwaC0xNzVsMjIgLTI3OGwzNjIgLTEwMGg0djFsMzU5IDk5bDUwIDU0NGgtNjQ0bC0xNSAxODFoNjc0ek0wIDE0MDhoMTQwOGwtMTI4IC0xNDM4bC01NzggLTE2MmwtNTc0IDE2MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzYzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMjc1IDE0MDhoMTUwNWwtMjY2IC0xMzMzbC04MDQgLTI2N2wtNjk4IDI2N2w3MSAzNTZoMjk3bC0yOSAtMTQ3bDQyMiAtMTYxbDQ4NiAxNjFsNjggMzM5aC0xMjA4bDU4IDI5N2gxMjA5bDM4IDE5MWgtMTIwOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzZDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNOTYwIDEyODBxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXQxOSAtNDV0NDUgLTE5dDQ1IDE5dDE5IDQ1ek0xNzkyIDM1MnYtMzUycTAgLTIyIC0yMCAtMzBxLTggLTIgLTEyIC0ycS0xMyAwIC0yMyA5bC05MyA5M3EtMTE5IC0xNDMgLTMxOC41IC0yMjYuNXQtNDI5LjUgLTgzLjV0LTQyOS41IDgzLjV0LTMxOC41IDIyNi41bC05MyAtOTNxLTkgLTkgLTIzIC05cS00IDAgLTEyIDJxLTIwIDggLTIwIDMwdjM1MiBxMCAxNCA5IDIzdDIzIDloMzUycTIyIDAgMzAgLTIwcTggLTE5IC03IC0zNWwtMTAwIC0xMDBxNjcgLTkxIDE4OS41IC0xNTMuNXQyNzEuNSAtODIuNXY2NDdoLTE5MnEtMjYgMCAtNDUgMTl0LTE5IDQ1djEyOHEwIDI2IDE5IDQ1dDQ1IDE5aDE5MnYxNjNxLTU4IDM0IC05MyA5Mi41dC0zNSAxMjguNXEwIDEwNiA3NSAxODF0MTgxIDc1dDE4MSAtNzV0NzUgLTE4MXEwIC03MCAtMzUgLTEyOC41dC05MyAtOTIuNXYtMTYzaDE5MnEyNiAwIDQ1IC0xOSB0MTkgLTQ1di0xMjhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xOTJ2LTY0N3ExNDkgMjAgMjcxLjUgODIuNXQxODkuNSAxNTMuNWwtMTAwIDEwMHEtMTUgMTYgLTcgMzVxOCAyMCAzMCAyMGgzNTJxMTQgMCAyMyAtOXQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjEzZTsiIGhvcml6LWFkdi14PSIxMTUyIiBkPSJNMTA1NiA3NjhxNDAgMCA2OCAtMjh0MjggLTY4di01NzZxMCAtNDAgLTI4IC02OHQtNjggLTI4aC05NjBxLTQwIDAgLTY4IDI4dC0yOCA2OHY1NzZxMCA0MCAyOCA2OHQ2OCAyOGgzMnYzMjBxMCAxODUgMTMxLjUgMzE2LjV0MzE2LjUgMTMxLjV0MzE2LjUgLTEzMS41dDEzMS41IC0zMTYuNXEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTY0cS0yNiAwIC00NSAxOXQtMTkgNDVxMCAxMDYgLTc1IDE4MXQtMTgxIDc1dC0xODEgLTc1dC03NSAtMTgxIHYtMzIwaDczNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0MDsiIGQ9Ik0xMDI0IDY0MHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MSA3NXQtNzUgMTgxdDc1IDE4MXQxODEgNzV0MTgxIC03NXQ3NSAtMTgxek0xMTUyIDY0MHEwIDE1OSAtMTEyLjUgMjcxLjV0LTI3MS41IDExMi41dC0yNzEuNSAtMTEyLjV0LTExMi41IC0yNzEuNXQxMTIuNSAtMjcxLjV0MjcxLjUgLTExMi41dDI3MS41IDExMi41dDExMi41IDI3MS41ek0xMjgwIDY0MHEwIC0yMTIgLTE1MCAtMzYydC0zNjIgLTE1MHQtMzYyIDE1MCB0LTE1MCAzNjJ0MTUwIDM2MnQzNjIgMTUwdDM2MiAtMTUwdDE1MCAtMzYyek0xNDA4IDY0MHEwIDEzMCAtNTEgMjQ4LjV0LTEzNi41IDIwNHQtMjA0IDEzNi41dC0yNDguNSA1MXQtMjQ4LjUgLTUxdC0yMDQgLTEzNi41dC0xMzYuNSAtMjA0dC01MSAtMjQ4LjV0NTEgLTI0OC41dDEzNi41IC0yMDR0MjA0IC0xMzYuNXQyNDguNSAtNTF0MjQ4LjUgNTF0MjA0IDEzNi41dDEzNi41IDIwNHQ1MSAyNDguNXpNMTUzNiA2NDAgcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTQxOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0zODQgODAwdi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xOTJxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgxOTJxNDAgMCA2OCAtMjh0MjggLTY4ek04OTYgODAwdi0xOTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xOTJxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgxOTJxNDAgMCA2OCAtMjh0MjggLTY4ek0xNDA4IDgwMHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTkyIHEtNDAgMCAtNjggMjh0LTI4IDY4djE5MnEwIDQwIDI4IDY4dDY4IDI4aDE5MnE0MCAwIDY4IC0yOHQyOCAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNDI7IiBob3Jpei1hZHYteD0iMzg0IiBkPSJNMzg0IDI4OHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTkycS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjhoMTkycTQwIDAgNjggLTI4dDI4IC02OHpNMzg0IDgwMHYtMTkycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTkycS00MCAwIC02OCAyOHQtMjggNjh2MTkycTAgNDAgMjggNjh0NjggMjhoMTkycTQwIDAgNjggLTI4dDI4IC02OHpNMzg0IDEzMTJ2LTE5MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTE5MiBxLTQwIDAgLTY4IDI4dC0yOCA2OHYxOTJxMCA0MCAyOCA2OHQ2OCAyOGgxOTJxNDAgMCA2OCAtMjh0MjggLTY4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTQzOyIgZD0iTTUxMiAyNTZxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTg2MyAxNjJxLTEzIDIzMiAtMTc3IDM5NnQtMzk2IDE3N3EtMTQgMSAtMjQgLTl0LTEwIC0yM3YtMTI4cTAgLTEzIDguNSAtMjJ0MjEuNSAtMTBxMTU0IC0xMSAyNjQgLTEyMXQxMjEgLTI2NHExIC0xMyAxMCAtMjEuNXQyMiAtOC41aDEyOHExMyAwIDIzIDEwIHQ5IDI0ek0xMjQ3IDE2MXEtNSAxNTQgLTU2IDI5Ny41dC0xMzkuNSAyNjB0LTIwNSAyMDV0LTI2MCAxMzkuNXQtMjk3LjUgNTZxLTE0IDEgLTIzIC05cS0xMCAtMTAgLTEwIC0yM3YtMTI4cTAgLTEzIDkgLTIydDIyIC0xMHEyMDQgLTcgMzc4IC0xMTEuNXQyNzguNSAtMjc4LjV0MTExLjUgLTM3OHExIC0xMyAxMCAtMjJ0MjIgLTloMTI4cTEzIDAgMjMgMTBxMTEgOSA5IDIzek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41IHQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNDQ7IiBkPSJNNzY4IDE0MDhxMjA5IDAgMzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXQtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3pNMTE1MiA1ODVxMzIgMTggMzIgNTV0LTMyIDU1bC01NDQgMzIwcS0zMSAxOSAtNjQgMXEtMzIgLTE5IC0zMiAtNTZ2LTY0MHEwIC0zNyAzMiAtNTYgcTE2IC04IDMyIC04cTE3IDAgMzIgOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0NTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTAyNCAxMDg0bDMxNiAtMzE2bC01NzIgLTU3MmwtMzE2IDMxNnpNODEzIDEwNWw2MTggNjE4cTE5IDE5IDE5IDQ1dC0xOSA0NWwtMzYyIDM2MnEtMTggMTggLTQ1IDE4dC00NSAtMThsLTYxOCAtNjE4cS0xOSAtMTkgLTE5IC00NXQxOSAtNDVsMzYyIC0zNjJxMTggLTE4IDQ1IC0xOHQ0NSAxOHpNMTcwMiA3NDJsLTkwNyAtOTA4cS0zNyAtMzcgLTkwLjUgLTM3dC05MC41IDM3bC0xMjYgMTI2cTU2IDU2IDU2IDEzNnQtNTYgMTM2IHQtMTM2IDU2dC0xMzYgLTU2bC0xMjUgMTI2cS0zNyAzNyAtMzcgOTAuNXQzNyA5MC41bDkwNyA5MDZxMzcgMzcgOTAuNSAzN3Q5MC41IC0zN2wxMjUgLTEyNXEtNTYgLTU2IC01NiAtMTM2dDU2IC0xMzZ0MTM2IC01NnQxMzYgNTZsMTI2IC0xMjVxMzcgLTM3IDM3IC05MC41dC0zNyAtOTAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0NjsiIGQ9Ik0xMjgwIDU3NnYxMjhxMCAyNiAtMTkgNDV0LTQ1IDE5aC04OTZxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0xMjhxMCAtMjYgMTkgLTQ1dDQ1IC0xOWg4OTZxMjYgMCA0NSAxOXQxOSA0NXpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjUgdDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTQ3OyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0xMTUyIDczNnYtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtODMycS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDgzMnExNCAwIDIzIC05dDkgLTIzek0xMjgwIDI4OHY4MzJxMCA2NiAtNDcgMTEzdC0xMTMgNDdoLTgzMnEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3YtODMycTAgLTY2IDQ3IC0xMTN0MTEzIC00N2g4MzJxNjYgMCAxMTMgNDd0NDcgMTEzek0xNDA4IDExMjB2LTgzMnEwIC0xMTkgLTg0LjUgLTIwMy41IHQtMjAzLjUgLTg0LjVoLTgzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2ODMycTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg4MzJxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNDg7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTEwMTggOTMzcS0xOCAtMzcgLTU4IC0zN2gtMTkydi04NjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNzA0cS0yMSAwIC0yOSAxOHEtOCAyMCA0IDM1bDE2MCAxOTJxOSAxMSAyNSAxMWgzMjB2NjQwaC0xOTJxLTQwIDAgLTU4IDM3cS0xNyAzNyA5IDY4bDMyMCAzODRxMTggMjIgNDkgMjJ0NDkgLTIybDMyMCAtMzg0cTI3IC0zMiA5IC02OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0OTsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNMzIgMTI4MGg3MDRxMTMgMCAyMi41IC05LjV0OS41IC0yMy41di04NjNoMTkycTQwIDAgNTggLTM3dC05IC02OWwtMzIwIC0zODRxLTE4IC0yMiAtNDkgLTIydC00OSAyMmwtMzIwIDM4NHEtMjYgMzEgLTkgNjlxMTggMzcgNTggMzdoMTkydjY0MGgtMzIwcS0xNCAwIC0yNSAxMWwtMTYwIDE5MnEtMTMgMTQgLTQgMzRxOSAxOSAyOSAxOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0YTsiIGQ9Ik02ODUgMjM3bDYxNCA2MTRxMTkgMTkgMTkgNDV0LTE5IDQ1bC0xMDIgMTAycS0xOSAxOSAtNDUgMTl0LTQ1IC0xOWwtNDY3IC00NjdsLTIxMSAyMTFxLTE5IDE5IC00NSAxOXQtNDUgLTE5bC0xMDIgLTEwMnEtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDM1OCAtMzU4cTE5IC0xOSA0NSAtMTl0NDUgMTl6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41IHQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE0YjsiIGQ9Ik00MDQgNDI4bDE1MiAtMTUybC01MiAtNTJoLTU2djk2aC05NnY1NnpNODE4IDgxOHExNCAtMTMgLTMgLTMwbC0yOTEgLTI5MXEtMTcgLTE3IC0zMCAtM3EtMTQgMTMgMyAzMGwyOTEgMjkxcTE3IDE3IDMwIDN6TTU0NCAxMjhsNTQ0IDU0NGwtMjg4IDI4OGwtNTQ0IC01NDR2LTI4OGgyODh6TTExNTIgNzM2bDkyIDkycTI4IDI4IDI4IDY4dC0yOCA2OGwtMTUyIDE1MnEtMjggMjggLTY4IDI4dC02OCAtMjhsLTkyIC05MnpNMTUzNiAxMTIwIHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTRjOyIgZD0iTTEyODAgNjA4djQ4MHEwIDI2IC0xOSA0NXQtNDUgMTloLTQ4MHEtNDIgMCAtNTkgLTM5cS0xNyAtNDEgMTQgLTcwbDE0NCAtMTQ0bC01MzQgLTUzNHEtMTkgLTE5IC0xOSAtNDV0MTkgLTQ1bDEwMiAtMTAycTE5IC0xOSA0NSAtMTl0NDUgMTlsNTM0IDUzNGwxNDQgLTE0NHExOCAtMTkgNDUgLTE5cTEyIDAgMjUgNXEzOSAxNyAzOSA1OXpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MCBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTRkOyIgZD0iTTEwMDUgNDM1bDM1MiAzNTJxMTkgMTkgMTkgNDV0LTE5IDQ1bC0zNTIgMzUycS0zMCAzMSAtNjkgMTRxLTQwIC0xNyAtNDAgLTU5di0xNjBxLTExOSAwIC0yMTYgLTE5LjV0LTE2Mi41IC01MXQtMTE0IC03OXQtNzYuNSAtOTUuNXQtNDQuNSAtMTA5dC0yMS41IC0xMTEuNXQtNSAtMTEwLjVxMCAtMTgxIDE2NyAtNDA0cTEwIC0xMiAyNSAtMTJxNyAwIDEzIDNxMjIgOSAxOSAzM3EtNDQgMzU0IDYyIDQ3M3E0NiA1MiAxMzAgNzUuNSB0MjI0IDIzLjV2LTE2MHEwIC00MiA0MCAtNTlxMTIgLTUgMjQgLTVxMjYgMCA0NSAxOXpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNGU7IiBkPSJNNjQwIDQ0OGwyNTYgMTI4bC0yNTYgMTI4di0yNTZ6TTEwMjQgMTAzOXYtNTQybC01MTIgLTI1NnY1NDJ6TTEzMTIgNjQwcTAgMTQ4IC03MyAyNzN0LTE5OCAxOTh0LTI3MyA3M3QtMjczIC03M3QtMTk4IC0xOTh0LTczIC0yNzN0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczdDI3MyA3M3QxOTggMTk4dDczIDI3M3pNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwMyB0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTUwOyIgZD0iTTExNDUgODYxcTE4IC0zNSAtNSAtNjZsLTMyMCAtNDQ4cS0xOSAtMjcgLTUyIC0yN3QtNTIgMjdsLTMyMCA0NDhxLTIzIDMxIC01IDY2cTE3IDM1IDU3IDM1aDY0MHE0MCAwIDU3IC0zNXpNMTI4MCAxNjB2OTYwcTAgMTMgLTkuNSAyMi41dC0yMi41IDkuNWgtOTYwcS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtOTYwcTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoOTYwcTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE1MzYgMTEyMCB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE1MTsiIGQ9Ik0xMTQ1IDQxOXEtMTcgLTM1IC01NyAtMzVoLTY0MHEtNDAgMCAtNTcgMzVxLTE4IDM1IDUgNjZsMzIwIDQ0OHExOSAyNyA1MiAyN3Q1MiAtMjdsMzIwIC00NDhxMjMgLTMxIDUgLTY2ek0xMjgwIDE2MHY5NjBxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC05NjBxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di05NjBxMCAtMTMgOS41IC0yMi41dDIyLjUgLTkuNWg5NjBxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXpNMTUzNiAxMTIwdi05NjAgcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTUyOyIgZD0iTTEwODggNjQwcTAgLTMzIC0yNyAtNTJsLTQ0OCAtMzIwcS0zMSAtMjMgLTY2IC01cS0zNSAxNyAtMzUgNTd2NjQwcTAgNDAgMzUgNTdxMzUgMTggNjYgLTVsNDQ4IC0zMjBxMjcgLTE5IDI3IC01MnpNMTI4MCAxNjB2OTYwcTAgMTQgLTkgMjN0LTIzIDloLTk2MHEtMTQgMCAtMjMgLTl0LTkgLTIzdi05NjBxMCAtMTQgOSAtMjN0MjMgLTloOTYwcTE0IDAgMjMgOXQ5IDIzek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41IHQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNTM7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTk3NiAyMjlsMzUgLTE1OXEzIC0xMiAtMyAtMjIuNXQtMTcgLTE0LjVsLTUgLTFxLTQgLTIgLTEwLjUgLTMuNXQtMTYgLTQuNXQtMjEuNSAtNS41dC0yNS41IC01dC0zMCAtNXQtMzMuNSAtNC41dC0zNi41IC0zdC0zOC41IC0xcS0yMzQgMCAtNDA5IDEzMC41dC0yMzggMzUxLjVoLTk1cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTEzcTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoNjZxLTIgNTcgMSAxMDVoLTY3cS0xNCAwIC0yMyA5IHQtOSAyM3YxMTRxMCAxNCA5IDIzdDIzIDloOThxNjcgMjEwIDI0My41IDMzOHQ0MDAuNSAxMjhxMTAyIDAgMTk0IC0yM3ExMSAtMyAyMCAtMTVxNiAtMTEgMyAtMjRsLTQzIC0xNTlxLTMgLTEzIC0xNCAtMTkuNXQtMjQgLTIuNWwtNCAxcS00IDEgLTExLjUgMi41bC0xNy41IDMuNXQtMjIuNSAzLjV0LTI2IDN0LTI5IDIuNXQtMjkuNSAxcS0xMjYgMCAtMjI2IC02NHQtMTUwIC0xNzZoNDY4cTE2IDAgMjUgLTEycTEwIC0xMiA3IC0yNiBsLTI0IC0xMTRxLTUgLTI2IC0zMiAtMjZoLTQ4OHEtMyAtMzcgMCAtMTA1aDQ1OXExNSAwIDI1IC0xMnE5IC0xMiA2IC0yN2wtMjQgLTExMnEtMiAtMTEgLTExIC0xOC41dC0yMCAtNy41aC0zODdxNDggLTExNyAxNDkuNSAtMTg1LjV0MjI4LjUgLTY4LjVxMTggMCAzNiAxLjV0MzMuNSAzLjV0MjkuNSA0LjV0MjQuNSA1dDE4LjUgNC41bDEyIDNsNSAycTEzIDUgMjYgLTJxMTIgLTcgMTUgLTIxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTU0OyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik0xMDIwIDM5OXYtMzY3cTAgLTE0IC05IC0yM3QtMjMgLTloLTk1NnEtMTQgMCAtMjMgOXQtOSAyM3YxNTBxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWg5N3YzODNoLTk1cS0xNCAwIC0yMyA5LjV0LTkgMjIuNXYxMzFxMCAxNCA5IDIzdDIzIDloOTV2MjIzcTAgMTcxIDEyMy41IDI4MnQzMTQuNSAxMTFxMTg1IDAgMzM1IC0xMjVxOSAtOCAxMCAtMjAuNXQtNyAtMjIuNWwtMTAzIC0xMjdxLTkgLTExIC0yMiAtMTJxLTEzIC0yIC0yMyA3IHEtNSA1IC0yNiAxOXQtNjkgMzJ0LTkzIDE4cS04NSAwIC0xMzcgLTQ3dC01MiAtMTIzdi0yMTVoMzA1cTEzIDAgMjIuNSAtOXQ5LjUgLTIzdi0xMzFxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0zMDV2LTM3OWg0MTR2MTgxcTAgMTMgOSAyMi41dDIzIDkuNWgxNjJxMTQgMCAyMyAtOS41dDkgLTIyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNTU7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTk3OCAzNTFxMCAtMTUzIC05OS41IC0yNjMuNXQtMjU4LjUgLTEzNi41di0xNzVxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTM1cS0xMyAwIC0yMi41IDkuNXQtOS41IDIyLjV2MTc1cS02NiA5IC0xMjcuNSAzMXQtMTAxLjUgNDQuNXQtNzQgNDh0LTQ2LjUgMzcuNXQtMTcuNSAxOHEtMTcgMjEgLTIgNDFsMTAzIDEzNXE3IDEwIDIzIDEycTE1IDIgMjQgLTlsMiAtMnExMTMgLTk5IDI0MyAtMTI1cTM3IC04IDc0IC04cTgxIDAgMTQyLjUgNDMgdDYxLjUgMTIycTAgMjggLTE1IDUzdC0zMy41IDQydC01OC41IDM3LjV0LTY2IDMydC04MCAzMi41cS0zOSAxNiAtNjEuNSAyNXQtNjEuNSAyNi41dC02Mi41IDMxdC01Ni41IDM1LjV0LTUzLjUgNDIuNXQtNDMuNSA0OXQtMzUuNSA1OHQtMjEgNjYuNXQtOC41IDc4cTAgMTM4IDk4IDI0MnQyNTUgMTM0djE4MHEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDEzNXExNCAwIDIzIC05dDkgLTIzdi0xNzZxNTcgLTYgMTEwLjUgLTIzdDg3IC0zMy41IHQ2My41IC0zNy41dDM5IC0yOXQxNSAtMTRxMTcgLTE4IDUgLTM4bC04MSAtMTQ2cS04IC0xNSAtMjMgLTE2cS0xNCAtMyAtMjcgN3EtMyAzIC0xNC41IDEydC0zOSAyNi41dC01OC41IDMydC03NC41IDI2dC04NS41IDExLjVxLTk1IDAgLTE1NSAtNDN0LTYwIC0xMTFxMCAtMjYgOC41IC00OHQyOS41IC00MS41dDM5LjUgLTMzdDU2IC0zMXQ2MC41IC0yN3Q3MCAtMjcuNXE1MyAtMjAgODEgLTMxLjV0NzYgLTM1dDc1LjUgLTQyLjV0NjIgLTUwIHQ1MyAtNjMuNXQzMS41IC03Ni41dDEzIC05NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE1NjsiIGhvcml6LWFkdi14PSI4OTgiIGQ9Ik04OTggMTA2NnYtMTAycTAgLTE0IC05IC0yM3QtMjMgLTloLTE2OHEtMjMgLTE0NCAtMTI5IC0yMzR0LTI3NiAtMTEwcTE2NyAtMTc4IDQ1OSAtNTM2cTE0IC0xNiA0IC0zNHEtOCAtMTggLTI5IC0xOGgtMTk1cS0xNiAwIC0yNSAxMnEtMzA2IDM2NyAtNDk4IDU3MXEtOSA5IC05IDIydjEyN3EwIDEzIDkuNSAyMi41dDIyLjUgOS41aDExMnExMzIgMCAyMTIuNSA0M3QxMDIuNSAxMjVoLTQyN3EtMTQgMCAtMjMgOXQtOSAyM3YxMDIgcTAgMTQgOSAyM3QyMyA5aDQxM3EtNTcgMTEzIC0yNjggMTEzaC0xNDVxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxMzNxMCAxNCA5IDIzdDIzIDloODMycTE0IDAgMjMgLTl0OSAtMjN2LTEwMnEwIC0xNCAtOSAtMjN0LTIzIC05aC0yMzNxNDcgLTYxIDY0IC0xNDRoMTcxcTE0IDAgMjMgLTl0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNTc7IiBob3Jpei1hZHYteD0iMTAyNyIgZD0iTTYwMyAwaC0xNzJxLTEzIDAgLTIyLjUgOXQtOS41IDIzdjMzMGgtMjg4cS0xMyAwIC0yMi41IDl0LTkuNSAyM3YxMDNxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgyODh2ODVoLTI4OHEtMTMgMCAtMjIuNSA5dC05LjUgMjN2MTA0cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoMjE0bC0zMjEgNTc4cS04IDE2IDAgMzJxMTAgMTYgMjggMTZoMTk0cTE5IDAgMjkgLTE4bDIxNSAtNDI1cTE5IC0zOCA1NiAtMTI1cTEwIDI0IDMwLjUgNjh0MjcuNSA2MSBsMTkxIDQyMHE4IDE5IDI5IDE5aDE5MXExNyAwIDI3IC0xNnE5IC0xNCAxIC0zMWwtMzEzIC01NzloMjE1cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXYtMTA0cTAgLTE0IC05LjUgLTIzdC0yMi41IC05aC0yOTB2LTg1aDI5MHExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV2LTEwM3EwIC0xNCAtOS41IC0yM3QtMjIuNSAtOWgtMjkwdi0zMzBxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTU4OyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMDQzIDk3MXEwIDEwMCAtNjUgMTYydC0xNzEgNjJoLTMyMHYtNDQ4aDMyMHExMDYgMCAxNzEgNjJ0NjUgMTYyek0xMjgwIDk3MXEwIC0xOTMgLTEyNi41IC0zMTV0LTMyNi41IC0xMjJoLTM0MHYtMTE4aDUwNXExNCAwIDIzIC05dDkgLTIzdi0xMjhxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNTA1di0xOTJxMCAtMTQgLTkuNSAtMjN0LTIyLjUgLTloLTE2N3EtMTQgMCAtMjMgOXQtOSAyM3YxOTJoLTIyNHEtMTQgMCAtMjMgOXQtOSAyM3YxMjggcTAgMTQgOSAyM3QyMyA5aDIyNHYxMThoLTIyNHEtMTQgMCAtMjMgOXQtOSAyM3YxNDlxMCAxMyA5IDIyLjV0MjMgOS41aDIyNHY2MjlxMCAxNCA5IDIzdDIzIDloNTM5cTIwMCAwIDMyNi41IC0xMjJ0MTI2LjUgLTMxNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE1OTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNTE0IDM0MWw4MSAyOTloLTE1OWw3NSAtMzAwcTEgLTEgMSAtM3QxIC0zcTAgMSAwLjUgMy41dDAuNSAzLjV6TTYzMCA3NjhsMzUgMTI4aC0yOTJsMzIgLTEyOGgyMjV6TTgyMiA3NjhoMTM5bC0zNSAxMjhoLTcwek0xMjcxIDM0MGw3OCAzMDBoLTE2Mmw4MSAtMjk5cTAgLTEgMC41IC0zLjV0MS41IC0zLjVxMCAxIDAuNSAzdDAuNSAzek0xMzgyIDc2OGwzMyAxMjhoLTI5N2wzNCAtMTI4aDIzMHpNMTc5MiA3MzZ2LTY0cTAgLTE0IC05IC0yMyB0LTIzIC05aC0yMTNsLTE2NCAtNjE2cS03IC0yNCAtMzEgLTI0aC0xNTlxLTI0IDAgLTMxIDI0bC0xNjYgNjE2aC0yMDlsLTE2NyAtNjE2cS03IC0yNCAtMzEgLTI0aC0xNTlxLTExIDAgLTE5LjUgN3QtMTAuNSAxN2wtMTYwIDYxNmgtMjA4cS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDE3NWwtMzMgMTI4aC0xNDJxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloMTA5bC04OSAzNDRxLTUgMTUgNSAyOCBxMTAgMTIgMjYgMTJoMTM3cTI2IDAgMzEgLTI0bDkwIC0zNjBoMzU5bDk3IDM2MHE3IDI0IDMxIDI0aDEyNnEyNCAwIDMxIC0yNGw5OCAtMzYwaDM2NWw5MyAzNjBxNSAyNCAzMSAyNGgxMzdxMTYgMCAyNiAtMTJxMTAgLTEzIDUgLTI4bC05MSAtMzQ0aDExMXExNCAwIDIzIC05dDkgLTIzdi02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC0xNDVsLTM0IC0xMjhoMTc5cTE0IDAgMjMgLTl0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNWE7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTExNjcgODk2cTE4IC0xODIgLTEzMSAtMjU4cTExNyAtMjggMTc1IC0xMDN0NDUgLTIxNHEtNyAtNzEgLTMyLjUgLTEyNXQtNjQuNSAtODl0LTk3IC01OC41dC0xMjEuNSAtMzQuNXQtMTQ1LjUgLTE1di0yNTVoLTE1NHYyNTFxLTgwIDAgLTEyMiAxdi0yNTJoLTE1NHYyNTVxLTE4IDAgLTU0IDAuNXQtNTUgMC41aC0yMDBsMzEgMTgzaDExMXE1MCAwIDU4IDUxdjQwMmgxNnEtNiAxIC0xNiAxdjI4N3EtMTMgNjggLTg5IDY4aC0xMTF2MTY0IGwyMTIgLTFxNjQgMCA5NyAxdjI1MmgxNTR2LTI0N3E4MiAyIDEyMiAydjI0NWgxNTR2LTI1MnE3OSAtNyAxNDAgLTIyLjV0MTEzIC00NXQ4Mi41IC03OHQzNi41IC0xMTQuNXpNOTUyIDM1MXEwIDM2IC0xNSA2NHQtMzcgNDZ0LTU3LjUgMzAuNXQtNjUuNSAxOC41dC03NCA5dC02OSAzdC02NC41IC0xdC00Ny41IC0xdi0zMzhxOCAwIDM3IC0wLjV0NDggLTAuNXQ1MyAxLjV0NTguNSA0dDU3IDguNXQ1NS41IDE0dDQ3LjUgMjF0MzkuNSAzMCB0MjQuNSA0MHQ5LjUgNTF6TTg4MSA4MjdxMCAzMyAtMTIuNSA1OC41dC0zMC41IDQydC00OCAyOHQtNTUgMTYuNXQtNjEuNSA4dC01OCAyLjV0LTU0IC0xdC0zOS41IC0wLjV2LTMwN3E1IDAgMzQuNSAtMC41dDQ2LjUgMHQ1MCAydDU1IDUuNXQ1MS41IDExdDQ4LjUgMTguNXQzNyAyN3QyNyAzOC41dDkgNTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNWI7IiBkPSJNMTAyNCAxMDI0djQ3MnEyMiAtMTQgMzYgLTI4bDQwOCAtNDA4cTE0IC0xNCAyOCAtMzZoLTQ3MnpNODk2IDk5MnEwIC00MCAyOCAtNjh0NjggLTI4aDU0NHYtMTA1NnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTEzNDRxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjAwcTAgNDAgMjggNjh0NjggMjhoODAwdi01NDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNWM7IiBkPSJNMTQ2OCAxMDYwcTE0IC0xNCAyOCAtMzZoLTQ3MnY0NzJxMjIgLTE0IDM2IC0yOHpNOTkyIDg5Nmg1NDR2LTEwNTZxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTYwMHEwIDQwIDI4IDY4dDY4IDI4aDgwMHYtNTQ0cTAgLTQwIDI4IC02OHQ2OCAtMjh6TTExNTIgMTYwdjY0cTAgMTQgLTkgMjN0LTIzIDloLTcwNHEtMTQgMCAtMjMgLTl0LTkgLTIzdi02NHEwIC0xNCA5IC0yM3QyMyAtOWg3MDQgcTE0IDAgMjMgOXQ5IDIzek0xMTUyIDQxNnY2NHEwIDE0IC05IDIzdC0yMyA5aC03MDRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNzA0cTE0IDAgMjMgOXQ5IDIzek0xMTUyIDY3MnY2NHEwIDE0IC05IDIzdC0yMyA5aC03MDRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNzA0cTE0IDAgMjMgOXQ5IDIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTVkOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xMTkxIDExMjhoMTc3bC03MiAyMThsLTEyIDQ3cS0yIDE2IC0yIDIwaC00bC0zIC0yMHEwIC0xIC0zLjUgLTE4dC03LjUgLTI5ek03MzYgOTZxMCAtMTIgLTEwIC0yNGwtMzE5IC0zMTlxLTEwIC05IC0yMyAtOXEtMTIgMCAtMjMgOWwtMzIwIDMyMHEtMTUgMTYgLTcgMzVxOCAyMCAzMCAyMGgxOTJ2MTM3NnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtMTM3NmgxOTJxMTQgMCAyMyAtOXQ5IC0yM3pNMTU3MiAtMjMgdi0yMzNoLTU4NHY5MGwzNjkgNTI5cTEyIDE4IDIxIDI3bDExIDl2M3EtMiAwIC02LjUgLTAuNXQtNy41IC0wLjVxLTEyIC0zIC0zMCAtM2gtMjMydi0xMTVoLTEyMHYyMjloNTY3di04OWwtMzY5IC01MzBxLTYgLTggLTIxIC0yNmwtMTEgLTExdi0ybDE0IDJxOSAyIDMwIDJoMjQ4djExOWgxMjF6TTE2NjEgODc0di0xMDZoLTI4OHYxMDZoNzVsLTQ3IDE0NGgtMjQzbC00NyAtMTQ0aDc1di0xMDZoLTI4N3YxMDZoNzBsMjMwIDY2MmgxNjIgbDIzMCAtNjYyaDcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTVlOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xMTkxIDEwNGgxNzdsLTcyIDIxOGwtMTIgNDdxLTIgMTYgLTIgMjBoLTRsLTMgLTIwcTAgLTEgLTMuNSAtMTh0LTcuNSAtMjl6TTczNiA5NnEwIC0xMiAtMTAgLTI0bC0zMTkgLTMxOXEtMTAgLTkgLTIzIC05cS0xMiAwIC0yMyA5bC0zMjAgMzIwcS0xNSAxNiAtNyAzNXE4IDIwIDMwIDIwaDE5MnYxMzc2cTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzdi0xMzc2aDE5MnExNCAwIDIzIC05dDkgLTIzek0xNjYxIC0xNTAgdi0xMDZoLTI4OHYxMDZoNzVsLTQ3IDE0NGgtMjQzbC00NyAtMTQ0aDc1di0xMDZoLTI4N3YxMDZoNzBsMjMwIDY2MmgxNjJsMjMwIC02NjJoNzB6TTE1NzIgMTAwMXYtMjMzaC01ODR2OTBsMzY5IDUyOXExMiAxOCAyMSAyN2wxMSA5djNxLTIgMCAtNi41IC0wLjV0LTcuNSAtMC41cS0xMiAtMyAtMzAgLTNoLTIzMnYtMTE1aC0xMjB2MjI5aDU2N3YtODlsLTM2OSAtNTMwcS02IC04IC0yMSAtMjZsLTExIC0xMHYtM2wxNCAzcTkgMSAzMCAxaDI0OCB2MTE5aDEyMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2MDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNzM2IDk2cTAgLTEyIC0xMCAtMjRsLTMxOSAtMzE5cS0xMCAtOSAtMjMgLTlxLTEyIDAgLTIzIDlsLTMyMCAzMjBxLTE1IDE2IC03IDM1cTggMjAgMzAgMjBoMTkydjEzNzZxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN2LTEzNzZoMTkycTE0IDAgMjMgLTl0OSAtMjN6TTE3OTIgLTMydi0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtODMycS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWg4MzIgcTE0IDAgMjMgLTl0OSAtMjN6TTE2MDAgNDgwdi0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjQwcS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWg2NDBxMTQgMCAyMyAtOXQ5IC0yM3pNMTQwOCA5OTJ2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC00NDhxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDQ0OHExNCAwIDIzIC05dDkgLTIzek0xMjE2IDE1MDR2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0yNTYgcS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWgyNTZxMTQgMCAyMyAtOXQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2MTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTIxNiAtMzJ2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0yNTZxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDI1NnExNCAwIDIzIC05dDkgLTIzek03MzYgOTZxMCAtMTIgLTEwIC0yNGwtMzE5IC0zMTlxLTEwIC05IC0yMyAtOXEtMTIgMCAtMjMgOWwtMzIwIDMyMHEtMTUgMTYgLTcgMzVxOCAyMCAzMCAyMGgxOTJ2MTM3NnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtMTM3NmgxOTIgcTE0IDAgMjMgLTl0OSAtMjN6TTE0MDggNDgwdi0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNDQ4cS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWg0NDhxMTQgMCAyMyAtOXQ5IC0yM3pNMTYwMCA5OTJ2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC02NDBxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDY0MHExNCAwIDIzIC05dDkgLTIzek0xNzkyIDE1MDR2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC04MzIgcS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWg4MzJxMTQgMCAyMyAtOXQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2MjsiIGQ9Ik0xMzQ2IDIyM3EwIDYzIC00NCAxMTZ0LTEwMyA1M3EtNTIgMCAtODMgLTM3dC0zMSAtOTR0MzYuNSAtOTV0MTA0LjUgLTM4cTUwIDAgODUgMjd0MzUgNjh6TTczNiA5NnEwIC0xMiAtMTAgLTI0bC0zMTkgLTMxOXEtMTAgLTkgLTIzIC05cS0xMiAwIC0yMyA5bC0zMjAgMzIwcS0xNSAxNiAtNyAzNXE4IDIwIDMwIDIwaDE5MnYxMzc2cTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzdi0xMzc2aDE5MnExNCAwIDIzIC05dDkgLTIzIHpNMTQ4NiAxNjVxMCAtNjIgLTEzIC0xMjEuNXQtNDEgLTExNHQtNjggLTk1LjV0LTk4LjUgLTY1LjV0LTEyNy41IC0yNC41cS02MiAwIC0xMDggMTZxLTI0IDggLTQyIDE1bDM5IDExM3ExNSAtNyAzMSAtMTFxMzcgLTEzIDc1IC0xM3E4NCAwIDEzNC41IDU4LjV0NjYuNSAxNDUuNWgtMnEtMjEgLTIzIC02MS41IC0zN3QtODQuNSAtMTRxLTEwNiAwIC0xNzMgNzEuNXQtNjcgMTcyLjVxMCAxMDUgNzIgMTc4dDE4MSA3M3ExMjMgMCAyMDUgLTk0LjUgdDgyIC0yNTIuNXpNMTQ1NiA4ODJ2LTExNGgtNDY5djExNGgxNjd2NDMycTAgNyAwLjUgMTl0MC41IDE3djE2aC0ybC03IC0xMnEtOCAtMTMgLTI2IC0zMWwtNjIgLTU4bC04MiA4NmwxOTIgMTg1aDEyM3YtNjU0aDE2NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2MzsiIGQ9Ik0xMzQ2IDEyNDdxMCA2MyAtNDQgMTE2dC0xMDMgNTNxLTUyIDAgLTgzIC0zN3QtMzEgLTk0dDM2LjUgLTk1dDEwNC41IC0zOHE1MCAwIDg1IDI3dDM1IDY4ek03MzYgOTZxMCAtMTIgLTEwIC0yNGwtMzE5IC0zMTlxLTEwIC05IC0yMyAtOXEtMTIgMCAtMjMgOWwtMzIwIDMyMHEtMTUgMTYgLTcgMzVxOCAyMCAzMCAyMGgxOTJ2MTM3NnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtMTM3NmgxOTJxMTQgMCAyMyAtOSB0OSAtMjN6TTE0NTYgLTE0MnYtMTE0aC00Njl2MTE0aDE2N3Y0MzJxMCA3IDAuNSAxOXQwLjUgMTd2MTZoLTJsLTcgLTEycS04IC0xMyAtMjYgLTMxbC02MiAtNThsLTgyIDg2bDE5MiAxODVoMTIzdi02NTRoMTY1ek0xNDg2IDExODlxMCAtNjIgLTEzIC0xMjEuNXQtNDEgLTExNHQtNjggLTk1LjV0LTk4LjUgLTY1LjV0LTEyNy41IC0yNC41cS02MiAwIC0xMDggMTZxLTI0IDggLTQyIDE1bDM5IDExM3ExNSAtNyAzMSAtMTFxMzcgLTEzIDc1IC0xMyBxODQgMCAxMzQuNSA1OC41dDY2LjUgMTQ1LjVoLTJxLTIxIC0yMyAtNjEuNSAtMzd0LTg0LjUgLTE0cS0xMDYgMCAtMTczIDcxLjV0LTY3IDE3Mi41cTAgMTA1IDcyIDE3OHQxODEgNzNxMTIzIDAgMjA1IC05NC41dDgyIC0yNTIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2NDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMjU2IDE5MnEwIDI2IC0xOSA0NXQtNDUgMTlxLTI3IDAgLTQ1LjUgLTE5dC0xOC41IC00NXEwIC0yNyAxOC41IC00NS41dDQ1LjUgLTE4LjVxMjYgMCA0NSAxOC41dDE5IDQ1LjV6TTQxNiA3MDR2LTY0MHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTI4OHEtMjYgMCAtNDUgMTl0LTE5IDQ1djY0MHEwIDI2IDE5IDQ1dDQ1IDE5aDI4OHEyNiAwIDQ1IC0xOXQxOSAtNDV6TTE2MDAgNzA0cTAgLTg2IC01NSAtMTQ5cTE1IC00NCAxNSAtNzYgcTMgLTc2IC00MyAtMTM3cTE3IC01NiAwIC0xMTdxLTE1IC01NyAtNTQgLTk0cTkgLTExMiAtNDkgLTE4MXEtNjQgLTc2IC0xOTcgLTc4aC0zNmgtNzZoLTE3cS02NiAwIC0xNDQgMTUuNXQtMTIxLjUgMjl0LTEyMC41IDM5LjVxLTEyMyA0MyAtMTU4IDQ0cS0yNiAxIC00NSAxOS41dC0xOSA0NC41djY0MXEwIDI1IDE4IDQzLjV0NDMgMjAuNXEyNCAyIDc2IDU5dDEwMSAxMjFxNjggODcgMTAxIDEyMHExOCAxOCAzMSA0OHQxNy41IDQ4LjUgdDEzLjUgNjAuNXE3IDM5IDEyLjUgNjF0MTkuNSA1MnQzNCA1MHExOSAxOSA0NSAxOXE0NiAwIDgyLjUgLTEwLjV0NjAgLTI2dDQwIC00MC41dDI0IC00NXQxMiAtNTB0NSAtNDV0MC41IC0zOXEwIC0zOCAtOS41IC03NnQtMTkgLTYwdC0yNy41IC01NnEtMyAtNiAtMTAgLTE4dC0xMSAtMjJ0LTggLTI0aDI3N3E3OCAwIDEzNSAtNTd0NTcgLTEzNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2NTsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMjU2IDk2MHEwIC0yNiAtMTkgLTQ1dC00NSAtMTlxLTI3IDAgLTQ1LjUgMTl0LTE4LjUgNDVxMCAyNyAxOC41IDQ1LjV0NDUuNSAxOC41cTI2IDAgNDUgLTE4LjV0MTkgLTQ1LjV6TTQxNiA0NDh2NjQwcTAgMjYgLTE5IDQ1dC00NSAxOWgtMjg4cS0yNiAwIC00NSAtMTl0LTE5IC00NXYtNjQwcTAgLTI2IDE5IC00NXQ0NSAtMTloMjg4cTI2IDAgNDUgMTl0MTkgNDV6TTE1NDUgNTk3cTU1IC02MSA1NSAtMTQ5cS0xIC03OCAtNTcuNSAtMTM1IHQtMTM0LjUgLTU3aC0yNzdxNCAtMTQgOCAtMjR0MTEgLTIydDEwIC0xOHExOCAtMzcgMjcgLTU3dDE5IC01OC41dDEwIC03Ni41cTAgLTI0IC0wLjUgLTM5dC01IC00NXQtMTIgLTUwdC0yNCAtNDV0LTQwIC00MC41dC02MCAtMjZ0LTgyLjUgLTEwLjVxLTI2IDAgLTQ1IDE5cS0yMCAyMCAtMzQgNTB0LTE5LjUgNTJ0LTEyLjUgNjFxLTkgNDIgLTEzLjUgNjAuNXQtMTcuNSA0OC41dC0zMSA0OHEtMzMgMzMgLTEwMSAxMjBxLTQ5IDY0IC0xMDEgMTIxIHQtNzYgNTlxLTI1IDIgLTQzIDIwLjV0LTE4IDQzLjV2NjQxcTAgMjYgMTkgNDQuNXQ0NSAxOS41cTM1IDEgMTU4IDQ0cTc3IDI2IDEyMC41IDM5LjV0MTIxLjUgMjl0MTQ0IDE1LjVoMTdoNzZoMzZxMTMzIC0yIDE5NyAtNzhxNTggLTY5IDQ5IC0xODFxMzkgLTM3IDU0IC05NHExNyAtNjEgMCAtMTE3cTQ2IC02MSA0MyAtMTM3cTAgLTMyIC0xNSAtNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNjY7IiBkPSJNOTE5IDIzM3YxNTdxMCA1MCAtMjkgNTBxLTE3IDAgLTMzIC0xNnYtMjI0cTE2IC0xNiAzMyAtMTZxMjkgMCAyOSA0OXpNMTEwMyAzNTVoNjZ2MzRxMCA1MSAtMzMgNTF0LTMzIC01MXYtMzR6TTUzMiA2MjF2LTcwaC04MHYtNDIzaC03NHY0MjNoLTc4djcwaDIzMnpNNzMzIDQ5NXYtMzY3aC02N3Y0MHEtMzkgLTQ1IC03NiAtNDVxLTMzIDAgLTQyIDI4cS02IDE2IC02IDU0djI5MGg2NnYtMjcwcTAgLTI0IDEgLTI2cTEgLTE1IDE1IC0xNSBxMjAgMCA0MiAzMXYyODBoNjd6TTk4NSAzODR2LTE0NnEwIC01MiAtNyAtNzNxLTEyIC00MiAtNTMgLTQycS0zNSAwIC02OCA0MXYtMzZoLTY3djQ5M2g2N3YtMTYxcTMyIDQwIDY4IDQwcTQxIDAgNTMgLTQycTcgLTIxIDcgLTc0ek0xMjM2IDI1NXYtOXEwIC0yOSAtMiAtNDNxLTMgLTIyIC0xNSAtNDBxLTI3IC00MCAtODAgLTQwcS01MiAwIC04MSAzOHEtMjEgMjcgLTIxIDg2djEyOXEwIDU5IDIwIDg2cTI5IDM4IDgwIDM4dDc4IC0zOCBxMjEgLTI4IDIxIC04NnYtNzZoLTEzM3YtNjVxMCAtNTEgMzQgLTUxcTI0IDAgMzAgMjZxMCAxIDAuNSA3dDAuNSAxNi41djIxLjVoNjh6TTc4NSAxMDc5di0xNTZxMCAtNTEgLTMyIC01MXQtMzIgNTF2MTU2cTAgNTIgMzIgNTJ0MzIgLTUyek0xMzE4IDM2NnEwIDE3NyAtMTkgMjYwcS0xMCA0NCAtNDMgNzMuNXQtNzYgMzQuNXEtMTM2IDE1IC00MTIgMTVxLTI3NSAwIC00MTEgLTE1cS00NCAtNSAtNzYuNSAtMzQuNXQtNDIuNSAtNzMuNSBxLTIwIC04NyAtMjAgLTI2MHEwIC0xNzYgMjAgLTI2MHExMCAtNDMgNDIuNSAtNzN0NzUuNSAtMzVxMTM3IC0xNSA0MTIgLTE1dDQxMiAxNXE0MyA1IDc1LjUgMzV0NDIuNSA3M3EyMCA4NCAyMCAyNjB6TTU2MyAxMDE3bDkwIDI5NmgtNzVsLTUxIC0xOTVsLTUzIDE5NWgtNzhsMjQgLTY5dDIzIC02OXEzNSAtMTAzIDQ2IC0xNTh2LTIwMWg3NHYyMDF6TTg1MiA5MzZ2MTMwcTAgNTggLTIxIDg3cS0yOSAzOCAtNzggMzhxLTUxIDAgLTc4IC0zOCBxLTIxIC0yOSAtMjEgLTg3di0xMzBxMCAtNTggMjEgLTg3cTI3IC0zOCA3OCAtMzhxNDkgMCA3OCAzOHEyMSAyNyAyMSA4N3pNMTAzMyA4MTZoNjd2MzcwaC02N3YtMjgzcS0yMiAtMzEgLTQyIC0zMXEtMTUgMCAtMTYgMTZxLTEgMiAtMSAyNnYyNzJoLTY3di0yOTNxMCAtMzcgNiAtNTVxMTEgLTI3IDQzIC0yN3EzNiAwIDc3IDQ1di00MHpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MCBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTY3OyIgZD0iTTk3MSAyOTJ2LTIxMXEwIC02NyAtMzkgLTY3cS0yMyAwIC00NSAyMnYzMDFxMjIgMjIgNDUgMjJxMzkgMCAzOSAtNjd6TTEzMDkgMjkxdi00NmgtOTB2NDZxMCA2OCA0NSA2OHQ0NSAtNjh6TTM0MyA1MDloMTA3djk0aC0zMTJ2LTk0aDEwNXYtNTY5aDEwMHY1Njl6TTYzMSAtNjBoODl2NDk0aC04OXYtMzc4cS0zMCAtNDIgLTU3IC00MnEtMTggMCAtMjEgMjFxLTEgMyAtMSAzNXYzNjRoLTg5di0zOTFxMCAtNDkgOCAtNzMgcTEyIC0zNyA1OCAtMzdxNDggMCAxMDIgNjF2LTU0ek0xMDYwIDg4djE5N3EwIDczIC05IDk5cS0xNyA1NiAtNzEgNTZxLTUwIDAgLTkzIC01NHYyMTdoLTg5di02NjNoODl2NDhxNDUgLTU1IDkzIC01NXE1NCAwIDcxIDU1cTkgMjcgOSAxMDB6TTEzOTggOTh2MTNoLTkxcTAgLTUxIC0yIC02MXEtNyAtMzYgLTQwIC0zNnEtNDYgMCAtNDYgNjl2ODdoMTc5djEwM3EwIDc5IC0yNyAxMTZxLTM5IDUxIC0xMDYgNTFxLTY4IDAgLTEwNyAtNTEgcS0yOCAtMzcgLTI4IC0xMTZ2LTE3M3EwIC03OSAyOSAtMTE2cTM5IC01MSAxMDggLTUxcTcyIDAgMTA4IDUzcTE4IDI3IDIxIDU0cTIgOSAyIDU4ek03OTAgMTAxMXYyMTBxMCA2OSAtNDMgNjl0LTQzIC02OXYtMjEwcTAgLTcwIDQzIC03MHQ0MyA3MHpNMTUwOSAyNjBxMCAtMjM0IC0yNiAtMzUwcS0xNCAtNTkgLTU4IC05OXQtMTAyIC00NnEtMTg0IC0yMSAtNTU1IC0yMXQtNTU1IDIxcS01OCA2IC0xMDIuNSA0NnQtNTcuNSA5OSBxLTI2IDExMiAtMjYgMzUwcTAgMjM0IDI2IDM1MHExNCA1OSA1OCA5OXQxMDMgNDdxMTgzIDIwIDU1NCAyMHQ1NTUgLTIwcTU4IC03IDEwMi41IC00N3Q1Ny41IC05OXEyNiAtMTEyIDI2IC0zNTB6TTUxMSAxNTM2aDEwMmwtMTIxIC0zOTl2LTI3MWgtMTAwdjI3MXEtMTQgNzQgLTYxIDIxMnEtMzcgMTAzIC02NSAxODdoMTA2bDcxIC0yNjN6TTg4MSAxMjAzdi0xNzVxMCAtODEgLTI4IC0xMThxLTM3IC01MSAtMTA2IC01MXEtNjcgMCAtMTA1IDUxIHEtMjggMzggLTI4IDExOHYxNzVxMCA4MCAyOCAxMTdxMzggNTEgMTA1IDUxcTY5IDAgMTA2IC01MXEyOCAtMzcgMjggLTExN3pNMTIxNiAxMzY1di00OTloLTkxdjU1cS01MyAtNjIgLTEwMyAtNjJxLTQ2IDAgLTU5IDM3cS04IDI0IC04IDc1djM5NGg5MXYtMzY3cTAgLTMzIDEgLTM1cTMgLTIyIDIxIC0yMnEyNyAwIDU3IDQzdjM4MWg5MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2ODsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNNTk3IDg2OXEtMTAgLTE4IC0yNTcgLTQ1NnEtMjcgLTQ2IC02NSAtNDZoLTIzOXEtMjEgMCAtMzEgMTd0MCAzNmwyNTMgNDQ4cTEgMCAwIDFsLTE2MSAyNzlxLTEyIDIyIC0xIDM3cTkgMTUgMzIgMTVoMjM5cTQwIDAgNjYgLTQ1ek0xNDAzIDE1MTFxMTEgLTE2IDAgLTM3bC01MjggLTkzNHYtMWwzMzYgLTYxNXExMSAtMjAgMSAtMzdxLTEwIC0xNSAtMzIgLTE1aC0yMzlxLTQyIDAgLTY2IDQ1bC0zMzkgNjIycTE4IDMyIDUzMSA5NDIgcTI1IDQ1IDY0IDQ1aDI0MXEyMiAwIDMxIC0xNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE2OTsiIGQ9Ik02ODUgNzcxcTAgMSAtMTI2IDIyMnEtMjEgMzQgLTUyIDM0aC0xODRxLTE4IDAgLTI2IC0xMXEtNyAtMTIgMSAtMjlsMTI1IC0yMTZ2LTFsLTE5NiAtMzQ2cS05IC0xNCAwIC0yOHE4IC0xMyAyNCAtMTNoMTg1cTMxIDAgNTAgMzZ6TTEzMDkgMTI2OHEtNyAxMiAtMjQgMTJoLTE4N3EtMzAgMCAtNDkgLTM1bC00MTEgLTcyOXExIC0yIDI2MiAtNDgxcTIwIC0zNSA1MiAtMzVoMTg0cTE4IDAgMjUgMTJxOCAxMyAtMSAyOGwtMjYwIDQ3NnYxIGw0MDkgNzIzcTggMTYgMCAyOHpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNmE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEyODAgNjQwcTAgMzcgLTMwIDU0bC01MTIgMzIwcS0zMSAyMCAtNjUgMnEtMzMgLTE4IC0zMyAtNTZ2LTY0MHEwIC0zOCAzMyAtNTZxMTYgLTggMzEgLThxMjAgMCAzNCAxMGw1MTIgMzIwcTMwIDE3IDMwIDU0ek0xNzkyIDY0MHEwIC05NiAtMSAtMTUwdC04LjUgLTEzNi41dC0yMi41IC0xNDcuNXEtMTYgLTczIC02OSAtMTIzdC0xMjQgLTU4cS0yMjIgLTI1IC02NzEgLTI1dC02NzEgMjVxLTcxIDggLTEyNC41IDU4dC02OS41IDEyMyBxLTE0IDY1IC0yMS41IDE0Ny41dC04LjUgMTM2LjV0LTEgMTUwdDEgMTUwdDguNSAxMzYuNXQyMi41IDE0Ny41cTE2IDczIDY5IDEyM3QxMjQgNThxMjIyIDI1IDY3MSAyNXQ2NzEgLTI1cTcxIC04IDEyNC41IC01OHQ2OS41IC0xMjNxMTQgLTY1IDIxLjUgLTE0Ny41dDguNSAtMTM2LjV0MSAtMTUweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTZiOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik00MDIgODI5bDQ5NCAtMzA1bC0zNDIgLTI4NWwtNDkwIDMxOXpNMTM4OCAyNzR2LTEwOGwtNDkwIC0yOTN2LTFsLTEgMWwtMSAtMXYxbC00ODkgMjkzdjEwOGwxNDcgLTk2bDM0MiAyODR2MmwxIC0xbDEgMXYtMmwzNDMgLTI4NHpNNTU0IDE0MThsMzQyIC0yODVsLTQ5NCAtMzA0bC0zMzggMjcwek0xMzkwIDgyOWwzMzggLTI3MWwtNDg5IC0zMTlsLTM0MyAyODV6TTEyMzkgMTQxOGw0ODkgLTMxOWwtMzM4IC0yNzBsLTQ5NCAzMDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNmM7IiBkPSJNMTI4OSAtOTZoLTExMTh2NDgwaC0xNjB2LTY0MGgxNDM4djY0MGgtMTYwdi00ODB6TTM0NyA0MjhsMzMgMTU3bDc4MyAtMTY1bC0zMyAtMTU2ek00NTAgODAybDY3IDE0Nmw3MjUgLTMzOWwtNjcgLTE0NXpNNjUxIDExNThsMTAyIDEyM2w2MTQgLTUxM2wtMTAyIC0xMjN6TTEwNDggMTUzNmw0NzcgLTY0MWwtMTI4IC05NmwtNDc3IDY0MXpNMzMwIDY1djE1OWg4MDB2LTE1OWgtODAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTZkOyIgZD0iTTEwMjQgNjQwcTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXQ3NSAtMTgxdDE4MSAtNzV0MTgxIDc1dDc1IDE4MXpNMTE2MiA2NDBxMCAtMTY0IC0xMTUgLTI3OXQtMjc5IC0xMTV0LTI3OSAxMTV0LTExNSAyNzl0MTE1IDI3OXQyNzkgMTE1dDI3OSAtMTE1dDExNSAtMjc5ek0xMjcwIDEwNTBxMCAtMzggLTI3IC02NXQtNjUgLTI3dC02NSAyN3QtMjcgNjV0MjcgNjV0NjUgMjd0NjUgLTI3dDI3IC02NXpNNzY4IDEyNzAgcS03IDAgLTc2LjUgMC41dC0xMDUuNSAwdC05Ni41IC0zdC0xMDMgLTEwdC03MS41IC0xOC41cS01MCAtMjAgLTg4IC01OHQtNTggLTg4cS0xMSAtMjkgLTE4LjUgLTcxLjV0LTEwIC0xMDN0LTMgLTk2LjV0MCAtMTA1LjV0MC41IC03Ni41dC0wLjUgLTc2LjV0MCAtMTA1LjV0MyAtOTYuNXQxMCAtMTAzdDE4LjUgLTcxLjVxMjAgLTUwIDU4IC04OHQ4OCAtNThxMjkgLTExIDcxLjUgLTE4LjV0MTAzIC0xMHQ5Ni41IC0zdDEwNS41IDB0NzYuNSAwLjUgdDc2LjUgLTAuNXQxMDUuNSAwdDk2LjUgM3QxMDMgMTB0NzEuNSAxOC41cTUwIDIwIDg4IDU4dDU4IDg4cTExIDI5IDE4LjUgNzEuNXQxMCAxMDN0MyA5Ni41dDAgMTA1LjV0LTAuNSA3Ni41dDAuNSA3Ni41dDAgMTA1LjV0LTMgOTYuNXQtMTAgMTAzdC0xOC41IDcxLjVxLTIwIDUwIC01OCA4OHQtODggNThxLTI5IDExIC03MS41IDE4LjV0LTEwMyAxMHQtOTYuNSAzdC0xMDUuNSAwdC03Ni41IC0wLjV6TTE1MzYgNjQwcTAgLTIyOSAtNSAtMzE3IHEtMTAgLTIwOCAtMTI0IC0zMjJ0LTMyMiAtMTI0cS04OCAtNSAtMzE3IC01dC0zMTcgNXEtMjA4IDEwIC0zMjIgMTI0dC0xMjQgMzIycS01IDg4IC01IDMxN3Q1IDMxN3ExMCAyMDggMTI0IDMyMnQzMjIgMTI0cTg4IDUgMzE3IDV0MzE3IC01cTIwOCAtMTAgMzIyIC0xMjR0MTI0IC0zMjJxNSAtODggNSAtMzE3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTZlOyIgZD0iTTEyNDggMTQwOHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwek02OTggNjQwcTAgODggLTYyIDE1MHQtMTUwIDYydC0xNTAgLTYydC02MiAtMTUwdDYyIC0xNTB0MTUwIC02MnQxNTAgNjJ0NjIgMTUwek0xMjYyIDY0MHEwIDg4IC02MiAxNTAgdC0xNTAgNjJ0LTE1MCAtNjJ0LTYyIC0xNTB0NjIgLTE1MHQxNTAgLTYydDE1MCA2MnQ2MiAxNTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNzA7IiBkPSJNNzY4IDkxNGwyMDEgLTMwNmgtNDAyek0xMTMzIDM4NGg5NGwtNDU5IDY5MWwtNDU5IC02OTFoOTRsMTA0IDE2MGg1MjJ6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTcxOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik04MTUgNjc3cTggLTYzIC01MC41IC0xMDF0LTExMS41IC02cS0zOSAxNyAtNTMuNSA1OHQtMC41IDgydDUyIDU4cTM2IDE4IDcyLjUgMTJ0NjQgLTM1LjV0MjcuNSAtNjcuNXpNOTI2IDY5OHEtMTQgMTA3IC0xMTMgMTY0dC0xOTcgMTNxLTYzIC0yOCAtMTAwLjUgLTg4LjV0LTM0LjUgLTEyOS41cTQgLTkxIDc3LjUgLTE1NXQxNjUuNSAtNTZxOTEgOCAxNTIgODR0NTAgMTY4ek0xMTY1IDEyNDBxLTIwIDI3IC01NiA0NC41dC01OCAyMiB0LTcxIDEyLjVxLTI5MSA0NyAtNTY2IC0ycS00MyAtNyAtNjYgLTEydC01NSAtMjJ0LTUwIC00M3EzMCAtMjggNzYgLTQ1LjV0NzMuNSAtMjJ0ODcuNSAtMTEuNXEyMjggLTI5IDQ0OCAtMXE2MyA4IDg5LjUgMTJ0NzIuNSAyMS41dDc1IDQ2LjV6TTEyMjIgMjA1cS04IC0yNiAtMTUuNSAtNzYuNXQtMTQgLTg0dC0yOC41IC03MHQtNTggLTU2LjVxLTg2IC00OCAtMTg5LjUgLTcxLjV0LTIwMiAtMjJ0LTIwMS41IDE4LjVxLTQ2IDggLTgxLjUgMTggdC03Ni41IDI3dC03MyA0My41dC01MiA2MS41cS0yNSA5NiAtNTcgMjkybDYgMTZsMTggOXEyMjMgLTE0OCA1MDYuNSAtMTQ4dDUwNy41IDE0OHEyMSAtNiAyNCAtMjN0LTUgLTQ1dC04IC0zN3pNMTQwMyAxMTY2cS0yNiAtMTY3IC0xMTEgLTY1NXEtNSAtMzAgLTI3IC01NnQtNDMuNSAtNDB0LTU0LjUgLTMxcS0yNTIgLTEyNiAtNjEwIC04OHEtMjQ4IDI3IC0zOTQgMTM5cS0xNSAxMiAtMjUuNSAyNi41dC0xNyAzNXQtOSAzNHQtNiAzOS41IHQtNS41IDM1cS05IDUwIC0yNi41IDE1MHQtMjggMTYxLjV0LTIzLjUgMTQ3LjV0LTIyIDE1OHEzIDI2IDE3LjUgNDguNXQzMS41IDM3LjV0NDUgMzB0NDYgMjIuNXQ0OCAxOC41cTEyNSA0NiAzMTMgNjRxMzc5IDM3IDY3NiAtNTBxMTU1IC00NiAyMTUgLTEyMnExNiAtMjAgMTYuNSAtNTF0LTUuNSAtNTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNzI7IiBkPSJNODQ4IDY2NnEwIDQzIC00MSA2NnQtNzcgMXEtNDMgLTIwIC00Mi41IC03Mi41dDQzLjUgLTcwLjVxMzkgLTIzIDgxIDR0MzYgNzJ6TTkyOCA2ODJxOCAtNjYgLTM2IC0xMjF0LTExMCAtNjF0LTExOSA0MHQtNTYgMTEzcS0yIDQ5IDI1LjUgOTN0NzIuNSA2NHE3MCAzMSAxNDEuNSAtMTB0ODEuNSAtMTE4ek0xMTAwIDEwNzNxLTIwIC0yMSAtNTMuNSAtMzR0LTUzIC0xNnQtNjMuNSAtOHEtMTU1IC0yMCAtMzI0IDBxLTQ0IDYgLTYzIDkuNSB0LTUyLjUgMTZ0LTU0LjUgMzIuNXExMyAxOSAzNiAzMXQ0MCAxNS41dDQ3IDguNXExOTggMzUgNDA4IDFxMzMgLTUgNTEgLTguNXQ0MyAtMTZ0MzkgLTMxLjV6TTExNDIgMzI3cTAgNyA1LjUgMjYuNXQzIDMydC0xNy41IDE2LjVxLTE2MSAtMTA2IC0zNjUgLTEwNnQtMzY2IDEwNmwtMTIgLTZsLTUgLTEycTI2IC0xNTQgNDEgLTIxMHE0NyAtODEgMjA0IC0xMDhxMjQ5IC00NiA0MjggNTNxMzQgMTkgNDkgNTEuNXQyMi41IDg1LjV0MTIuNSA3MXogTTEyNzIgMTAyMHE5IDUzIC04IDc1cS00MyA1NSAtMTU1IDg4cS0yMTYgNjMgLTQ4NyAzNnEtMTMyIC0xMiAtMjI2IC00NnEtMzggLTE1IC01OS41IC0yNXQtNDcgLTM0dC0yOS41IC01NHE4IC02OCAxOSAtMTM4dDI5IC0xNzF0MjQgLTEzN3ExIC01IDUgLTMxdDcgLTM2dDEyIC0yN3QyMiAtMjhxMTA1IC04MCAyODQgLTEwMHEyNTkgLTI4IDQ0MCA2M3EyNCAxMyAzOS41IDIzdDMxIDI5dDE5LjUgNDBxNDggMjY3IDgwIDQ3M3pNMTUzNiAxMTIwIHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTczOyIgaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik05NDQgMjA3bDgwIC0yMzdxLTIzIC0zNSAtMTExIC02NnQtMTc3IC0zMnEtMTA0IC0yIC0xOTAuNSAyNnQtMTQyLjUgNzR0LTk1IDEwNnQtNTUuNSAxMjB0LTE2LjUgMTE4djU0NGgtMTY4djIxNXE3MiAyNiAxMjkgNjkuNXQ5MSA5MHQ1OCAxMDJ0MzQgOTl0MTUgODguNXExIDUgNC41IDguNXQ3LjUgMy41aDI0NHYtNDI0aDMzM3YtMjUyaC0zMzR2LTUxOHEwIC0zMCA2LjUgLTU2dDIyLjUgLTUyLjV0NDkuNSAtNDEuNXQ4MS41IC0xNCBxNzggMiAxMzQgMjl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNzQ7IiBkPSJNMTEzNiA3NWwtNjIgMTgzcS00NCAtMjIgLTEwMyAtMjJxLTM2IC0xIC02MiAxMC41dC0zOC41IDMxLjV0LTE3LjUgNDAuNXQtNSA0My41djM5OGgyNTd2MTk0aC0yNTZ2MzI2aC0xODhxLTggMCAtOSAtMTBxLTUgLTQ0IC0xNy41IC04N3QtMzkgLTk1dC03NyAtOTV0LTExOC41IC02OHYtMTY1aDEzMHYtNDE4cTAgLTU3IDIxLjUgLTExNXQ2NSAtMTExdDEyMSAtODUuNXQxNzYuNSAtMzAuNXE2OSAxIDEzNi41IDI1dDg1LjUgNTB6IE0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE3NTsiIGhvcml6LWFkdi14PSI3NjgiIGQ9Ik03NjUgMjM3cTggLTE5IC01IC0zNWwtMzUwIC0zODRxLTEwIC0xMCAtMjMgLTEwcS0xNCAwIC0yNCAxMGwtMzU1IDM4NHEtMTMgMTYgLTUgMzVxOSAxOSAyOSAxOWgyMjR2MTI0OHEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtMTI0OGgyMjRxMjEgMCAyOSAtMTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNzY7IiBob3Jpei1hZHYteD0iNzY4IiBkPSJNNzY1IDEwNDNxLTkgLTE5IC0yOSAtMTloLTIyNHYtMTI0OHEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MTI0OGgtMjI0cS0yMSAwIC0yOSAxOXQ1IDM1bDM1MCAzODRxMTAgMTAgMjMgMTBxMTQgMCAyNCAtMTBsMzU1IC0zODRxMTMgLTE2IDUgLTM1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTc3OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDczNnYtMTkycTAgLTE0IC05IC0yM3QtMjMgLTloLTEyNDh2LTIyNHEwIC0yMSAtMTkgLTI5dC0zNSA1bC0zODQgMzUwcS0xMCAxMCAtMTAgMjNxMCAxNCAxMCAyNGwzODQgMzU0cTE2IDE0IDM1IDZxMTkgLTkgMTkgLTI5di0yMjRoMTI0OHExNCAwIDIzIC05dDkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTc4OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzI4IDY0M3EwIC0xNCAtMTAgLTI0bC0zODQgLTM1NHEtMTYgLTE0IC0zNSAtNnEtMTkgOSAtMTkgMjl2MjI0aC0xMjQ4cS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWgxMjQ4djIyNHEwIDIxIDE5IDI5dDM1IC01bDM4NCAtMzUwcTEwIC0xMCAxMCAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxNzk7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTEzOTMgMzIxcS0zOSAtMTI1IC0xMjMgLTI1MHEtMTI5IC0xOTYgLTI1NyAtMTk2cS00OSAwIC0xNDAgMzJxLTg2IDMyIC0xNTEgMzJxLTYxIDAgLTE0MiAtMzNxLTgxIC0zNCAtMTMyIC0zNHEtMTUyIDAgLTMwMSAyNTlxLTE0NyAyNjEgLTE0NyA1MDNxMCAyMjggMTEzIDM3NHExMTIgMTQ0IDI4NCAxNDRxNzIgMCAxNzcgLTMwcTEwNCAtMzAgMTM4IC0zMHE0NSAwIDE0MyAzNHExMDIgMzQgMTczIDM0cTExOSAwIDIxMyAtNjUgcTUyIC0zNiAxMDQgLTEwMHEtNzkgLTY3IC0xMTQgLTExOHEtNjUgLTk0IC02NSAtMjA3cTAgLTEyNCA2OSAtMjIzdDE1OCAtMTI2ek0xMDE3IDE0OTRxMCAtNjEgLTI5IC0xMzZxLTMwIC03NSAtOTMgLTEzOHEtNTQgLTU0IC0xMDggLTcycS0zNyAtMTEgLTEwNCAtMTdxMyAxNDkgNzggMjU3cTc0IDEwNyAyNTAgMTQ4cTEgLTMgMi41IC0xMXQyLjUgLTExcTAgLTQgMC41IC0xMHQwLjUgLTEweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTdhOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik02ODIgNTMwdi02NTFsLTY4MiA5NHY1NTdoNjgyek02ODIgMTI3M3YtNjU5aC02ODJ2NTY1ek0xNjY0IDUzMHYtNzg2bC05MDcgMTI1djY2MWg5MDd6TTE2NjQgMTQwOHYtNzk0aC05MDd2NjY5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTdiOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik00OTMgMTA1M3ExNiAwIDI3LjUgMTEuNXQxMS41IDI3LjV0LTExLjUgMjcuNXQtMjcuNSAxMS41dC0yNyAtMTEuNXQtMTEgLTI3LjV0MTEgLTI3LjV0MjcgLTExLjV6TTkxNSAxMDUzcTE2IDAgMjcgMTEuNXQxMSAyNy41dC0xMSAyNy41dC0yNyAxMS41dC0yNy41IC0xMS41dC0xMS41IC0yNy41dDExLjUgLTI3LjV0MjcuNSAtMTEuNXpNMTAzIDg2OXE0MiAwIDcyIC0zMHQzMCAtNzJ2LTQzMHEwIC00MyAtMjkuNSAtNzN0LTcyLjUgLTMwIHQtNzMgMzB0LTMwIDczdjQzMHEwIDQyIDMwIDcydDczIDMwek0xMTYzIDg1MHYtNjY2cTAgLTQ2IC0zMiAtNzh0LTc3IC0zMmgtNzV2LTIyN3EwIC00MyAtMzAgLTczdC03MyAtMzB0LTczIDMwdC0zMCA3M3YyMjdoLTEzOHYtMjI3cTAgLTQzIC0zMCAtNzN0LTczIC0zMHEtNDIgMCAtNzIgMzB0LTMwIDczbC0xIDIyN2gtNzRxLTQ2IDAgLTc4IDMydC0zMiA3OHY2NjZoOTE4ek05MzEgMTI1NXExMDcgLTU1IDE3MSAtMTUzLjV0NjQgLTIxNS41IGgtOTI1cTAgMTE3IDY0IDIxNS41dDE3MiAxNTMuNWwtNzEgMTMxcS03IDEzIDUgMjBxMTMgNiAyMCAtNmw3MiAtMTMycTk1IDQyIDIwMSA0MnQyMDEgLTQybDcyIDEzMnE3IDEyIDIwIDZxMTIgLTcgNSAtMjB6TTE0MDggNzY3di00MzBxMCAtNDMgLTMwIC03M3QtNzMgLTMwcS00MiAwIC03MiAzMHQtMzAgNzN2NDMwcTAgNDMgMzAgNzIuNXQ3MiAyOS41cTQzIDAgNzMgLTI5LjV0MzAgLTcyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxN2M7IiBkPSJNNjYzIDExMjVxLTExIC0xIC0xNS41IC0xMC41dC04LjUgLTkuNXEtNSAtMSAtNSA1cTAgMTIgMTkgMTVoMTB6TTc1MCAxMTExcS00IC0xIC0xMS41IDYuNXQtMTcuNSA0LjVxMjQgMTEgMzIgLTJxMyAtNiAtMyAtOXpNMzk5IDY4NHEtNCAxIC02IC0zdC00LjUgLTEyLjV0LTUuNSAtMTMuNXQtMTAgLTEzcS03IC0xMCAtMSAtMTJxNCAtMSAxMi41IDd0MTIuNSAxOHExIDMgMiA3dDIgNnQxLjUgNC41dDAuNSA0djN0LTEgMi41dC0zIDJ6IE0xMjU0IDMyNXEwIDE4IC01NSA0MnE0IDE1IDcuNSAyNy41dDUgMjZ0MyAyMS41dDAuNSAyMi41dC0xIDE5LjV0LTMuNSAyMnQtNCAyMC41dC01IDI1dC01LjUgMjYuNXEtMTAgNDggLTQ3IDEwM3QtNzIgNzVxMjQgLTIwIDU3IC04M3E4NyAtMTYyIDU0IC0yNzhxLTExIC00MCAtNTAgLTQycS0zMSAtNCAtMzguNSAxOC41dC04IDgzLjV0LTExLjUgMTA3cS05IDM5IC0xOS41IDY5dC0xOS41IDQ1LjV0LTE1LjUgMjQuNXQtMTMgMTV0LTcuNSA3IHEtMTQgNjIgLTMxIDEwM3QtMjkuNSA1NnQtMjMuNSAzM3QtMTUgNDBxLTQgMjEgNiA1My41dDQuNSA0OS41dC00NC41IDI1cS0xNSAzIC00NC41IDE4dC0zNS41IDE2cS04IDEgLTExIDI2dDggNTF0MzYgMjdxMzcgMyA1MSAtMzB0NCAtNThxLTExIC0xOSAtMiAtMjYuNXQzMCAtMC41cTEzIDQgMTMgMzZ2MzdxLTUgMzAgLTEzLjUgNTB0LTIxIDMwLjV0LTIzLjUgMTV0LTI3IDcuNXEtMTA3IC04IC04OSAtMTM0cTAgLTE1IC0xIC0xNSBxLTkgOSAtMjkuNSAxMC41dC0zMyAtMC41dC0xNS41IDVxMSA1NyAtMTYgOTB0LTQ1IDM0cS0yNyAxIC00MS41IC0yNy41dC0xNi41IC01OS41cS0xIC0xNSAzLjUgLTM3dDEzIC0zNy41dDE1LjUgLTEzLjVxMTAgMyAxNiAxNHE0IDkgLTcgOHEtNyAwIC0xNS41IDE0LjV0LTkuNSAzMy41cS0xIDIyIDkgMzd0MzQgMTRxMTcgMCAyNyAtMjF0OS41IC0zOXQtMS41IC0yMnEtMjIgLTE1IC0zMSAtMjlxLTggLTEyIC0yNy41IC0yMy41IHQtMjAuNSAtMTIuNXEtMTMgLTE0IC0xNS41IC0yN3Q3LjUgLTE4cTE0IC04IDI1IC0xOS41dDE2IC0xOXQxOC41IC0xM3QzNS41IC02LjVxNDcgLTIgMTAyIDE1cTIgMSAyMyA3dDM0LjUgMTAuNXQyOS41IDEzdDIxIDE3LjVxOSAxNCAyMCA4cTUgLTMgNi41IC04LjV0LTMgLTEydC0xNi41IC05LjVxLTIwIC02IC01Ni41IC0yMS41dC00NS41IC0xOS41cS00NCAtMTkgLTcwIC0yM3EtMjUgLTUgLTc5IDJxLTEwIDIgLTkgLTJ0MTcgLTE5IHEyNSAtMjMgNjcgLTIycTE3IDEgMzYgN3QzNiAxNHQzMy41IDE3LjV0MzAgMTd0MjQuNSAxMnQxNy41IDIuNXQ4LjUgLTExcTAgLTIgLTEgLTQuNXQtNCAtNXQtNiAtNC41dC04LjUgLTV0LTkgLTQuNXQtMTAgLTV0LTkuNSAtNC41cS0yOCAtMTQgLTY3LjUgLTQ0dC02Ni41IC00M3QtNDkgLTFxLTIxIDExIC02MyA3M3EtMjIgMzEgLTI1IDIycS0xIC0zIC0xIC0xMHEwIC0yNSAtMTUgLTU2LjV0LTI5LjUgLTU1LjV0LTIxIC01OHQxMS41IC02MyBxLTIzIC02IC02Mi41IC05MHQtNDcuNSAtMTQxcS0yIC0xOCAtMS41IC02OXQtNS41IC01OXEtOCAtMjQgLTI5IC0zcS0zMiAzMSAtMzYgOTRxLTIgMjggNCA1NnE0IDE5IC0xIDE4bC00IC01cS0zNiAtNjUgMTAgLTE2NnE1IC0xMiAyNSAtMjh0MjQgLTIwcTIwIC0yMyAxMDQgLTkwLjV0OTMgLTc2LjVxMTYgLTE1IDE3LjUgLTM4dC0xNCAtNDN0LTQ1LjUgLTIzcTggLTE1IDI5IC00NC41dDI4IC01NHQ3IC03MC41cTQ2IDI0IDcgOTIgcS00IDggLTEwLjUgMTZ0LTkuNSAxMnQtMiA2cTMgNSAxMyA5LjV0MjAgLTIuNXE0NiAtNTIgMTY2IC0zNnExMzMgMTUgMTc3IDg3cTIzIDM4IDM0IDMwcTEyIC02IDEwIC01MnEtMSAtMjUgLTIzIC05MnEtOSAtMjMgLTYgLTM3LjV0MjQgLTE1LjVxMyAxOSAxNC41IDc3dDEzLjUgOTBxMiAyMSAtNi41IDczLjV0LTcuNSA5N3QyMyA3MC41cTE1IDE4IDUxIDE4cTEgMzcgMzQuNSA1M3Q3Mi41IDEwLjV0NjAgLTIyLjV6TTYyNiAxMTUyIHEzIDE3IC0yLjUgMzB0LTExLjUgMTVxLTkgMiAtOSAtN3EyIC01IDUgLTZxMTAgMCA3IC0xNXEtMyAtMjAgOCAtMjBxMyAwIDMgM3pNMTA0NSA5NTVxLTIgOCAtNi41IDExLjV0LTEzIDV0LTE0LjUgNS41cS01IDMgLTkuNSA4dC03IDh0LTUuNSA2LjV0LTQgNHQtNCAtMS41cS0xNCAtMTYgNyAtNDMuNXQzOSAtMzEuNXE5IC0xIDE0LjUgOHQzLjUgMjB6TTg2NyAxMTY4cTAgMTEgLTUgMTkuNXQtMTEgMTIuNXQtOSAzcS0xNCAtMSAtNyAtN2w0IC0yIHExNCAtNCAxOCAtMzFxMCAtMyA4IDJ6TTkyMSAxNDAxcTAgMiAtMi41IDV0LTkgN3QtOS41IDZxLTE1IDE1IC0yNCAxNXEtOSAtMSAtMTEuNSAtNy41dC0xIC0xM3QtMC41IC0xMi41cS0xIC00IC02IC0xMC41dC02IC05dDMgLTguNXE0IC0zIDggMHQxMSA5dDE1IDlxMSAxIDkgMXQxNSAydDkgN3pNMTQ4NiA2MHEyMCAtMTIgMzEgLTI0LjV0MTIgLTI0dC0yLjUgLTIyLjV0LTE1LjUgLTIydC0yMy41IC0xOS41dC0zMCAtMTguNSB0LTMxLjUgLTE2LjV0LTMyIC0xNS41dC0yNyAtMTNxLTM4IC0xOSAtODUuNSAtNTZ0LTc1LjUgLTY0cS0xNyAtMTYgLTY4IC0xOS41dC04OSAxNC41cS0xOCA5IC0yOS41IDIzLjV0LTE2LjUgMjUuNXQtMjIgMTkuNXQtNDcgOS41cS00NCAxIC0xMzAgMXEtMTkgMCAtNTcgLTEuNXQtNTggLTIuNXEtNDQgLTEgLTc5LjUgLTE1dC01My41IC0zMHQtNDMuNSAtMjguNXQtNTMuNSAtMTEuNXEtMjkgMSAtMTExIDMxdC0xNDYgNDNxLTE5IDQgLTUxIDkuNSB0LTUwIDl0LTM5LjUgOS41dC0zMy41IDE0LjV0LTE3IDE5LjVxLTEwIDIzIDcgNjYuNXQxOCA1NC41cTEgMTYgLTQgNDB0LTEwIDQyLjV0LTQuNSAzNi41dDEwLjUgMjdxMTQgMTIgNTcgMTR0NjAgMTJxMzAgMTggNDIgMzV0MTIgNTFxMjEgLTczIC0zMiAtMTA2cS0zMiAtMjAgLTgzIC0xNXEtMzQgMyAtNDMgLTEwcS0xMyAtMTUgNSAtNTdxMiAtNiA4IC0xOHQ4LjUgLTE4dDQuNSAtMTd0MSAtMjJxMCAtMTUgLTE3IC00OXQtMTQgLTQ4IHEzIC0xNyAzNyAtMjZxMjAgLTYgODQuNSAtMTguNXQ5OS41IC0yMC41cTI0IC02IDc0IC0yMnQ4Mi41IC0yM3Q1NS41IC00cTQzIDYgNjQuNSAyOHQyMyA0OHQtNy41IDU4LjV0LTE5IDUydC0yMCAzNi41cS0xMjEgMTkwIC0xNjkgMjQycS02OCA3NCAtMTEzIDQwcS0xMSAtOSAtMTUgMTVxLTMgMTYgLTIgMzhxMSAyOSAxMCA1MnQyNCA0N3QyMiA0MnE4IDIxIDI2LjUgNzJ0MjkuNSA3OHQzMCA2MXQzOSA1NHExMTAgMTQzIDEyNCAxOTUgcS0xMiAxMTIgLTE2IDMxMHEtMiA5MCAyNCAxNTEuNXQxMDYgMTA0LjVxMzkgMjEgMTA0IDIxcTUzIDEgMTA2IC0xMy41dDg5IC00MS41cTU3IC00MiA5MS41IC0xMjEuNXQyOS41IC0xNDcuNXEtNSAtOTUgMzAgLTIxNHEzNCAtMTEzIDEzMyAtMjE4cTU1IC01OSA5OS41IC0xNjN0NTkuNSAtMTkxcTggLTQ5IDUgLTg0LjV0LTEyIC01NS41dC0yMCAtMjJxLTEwIC0yIC0yMy41IC0xOXQtMjcgLTM1LjV0LTQwLjUgLTMzLjV0LTYxIC0xNCBxLTE4IDEgLTMxLjUgNXQtMjIuNSAxMy41dC0xMy41IDE1LjV0LTExLjUgMjAuNXQtOSAxOS41cS0yMiAzNyAtNDEgMzB0LTI4IC00OXQ3IC05N3EyMCAtNzAgMSAtMTk1cS0xMCAtNjUgMTggLTEwMC41dDczIC0zM3Q4NSAzNS41cTU5IDQ5IDg5LjUgNjYuNXQxMDMuNSA0Mi41cTUzIDE4IDc3IDM2LjV0MTguNSAzNC41dC0yNSAyOC41dC01MS41IDIzLjVxLTMzIDExIC00OS41IDQ4dC0xNSA3Mi41dDE1LjUgNDcuNXExIC0zMSA4IC01Ni41IHQxNC41IC00MC41dDIwLjUgLTI4LjV0MjEgLTE5dDIxLjUgLTEzdDE2LjUgLTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE3ZDsiIGQ9Ik0xMDI0IDM2cS00MiAyNDEgLTE0MCA0OThoLTJsLTIgLTFxLTE2IC02IC00MyAtMTYuNXQtMTAxIC00OXQtMTM3IC04MnQtMTMxIC0xMTQuNXQtMTAzIC0xNDhsLTE1IDExcTE4NCAtMTUwIDQxOCAtMTUwcTEzMiAwIDI1NiA1MnpNODM5IDY0M3EtMjEgNDkgLTUzIDExMXEtMzExIC05MyAtNjczIC05M3EtMSAtNyAtMSAtMjFxMCAtMTI0IDQ0IC0yMzYuNXQxMjQgLTIwMS41cTUwIDg5IDEyMy41IDE2Ni41dDE0Mi41IDEyNC41dDEzMC41IDgxIHQ5OS41IDQ4bDM3IDEzcTQgMSAxMyAzLjV0MTMgNC41ek03MzIgODU1cS0xMjAgMjEzIC0yNDQgMzc4cS0xMzggLTY1IC0yMzQgLTE4NnQtMTI4IC0yNzJxMzAyIDAgNjA2IDgwek0xNDE2IDUzNnEtMjEwIDYwIC00MDkgMjlxODcgLTIzOSAxMjggLTQ2OXExMTEgNzUgMTg1IDE4OS41dDk2IDI1MC41ek02MTEgMTI3N3EtMSAwIC0yIC0xcTEgMSAyIDF6TTEyMDEgMTEzMnEtMTg1IDE2NCAtNDMzIDE2NHEtNzYgMCAtMTU1IC0xOSBxMTMxIC0xNzAgMjQ2IC0zODJxNjkgMjYgMTMwIDYwLjV0OTYuNSA2MS41dDY1LjUgNTd0MzcuNSA0MC41ek0xNDI0IDY0N3EtMyAyMzIgLTE0OSA0MTBsLTEgLTFxLTkgLTEyIC0xOSAtMjQuNXQtNDMuNSAtNDQuNXQtNzEgLTYwLjV0LTEwMCAtNjV0LTEzMS41IC02NC41cTI1IC01MyA0NCAtOTVxMiAtNiA2LjUgLTE3LjV0Ny41IC0xNi41cTM2IDUgNzQuNSA3dDczLjUgMnQ2OSAtMS41dDY0IC00dDU2LjUgLTUuNXQ0OCAtNi41dDM2LjUgLTYgdDI1IC00LjV6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTdlOyIgZD0iTTExNzMgNDczcTAgNTAgLTE5LjUgOTEuNXQtNDguNSA2OC41dC03MyA0OXQtODIuNSAzNHQtODcuNSAyM2wtMTA0IDI0cS0zMCA3IC00NCAxMC41dC0zNSAxMS41dC0zMCAxNnQtMTYuNSAyMXQtNy41IDMwcTAgNzcgMTQ0IDc3cTQzIDAgNzcgLTEydDU0IC0yOC41dDM4IC0zMy41dDQwIC0yOXQ0OCAtMTJxNDcgMCA3NS41IDMydDI4LjUgNzdxMCA1NSAtNTYgOTkuNXQtMTQyIDY3LjV0LTE4MiAyM3EtNjggMCAtMTMyIC0xNS41IHQtMTE5LjUgLTQ3dC04OSAtODd0LTMzLjUgLTEyOC41cTAgLTYxIDE5IC0xMDYuNXQ1NiAtNzUuNXQ4MCAtNDguNXQxMDMgLTMyLjVsMTQ2IC0zNnE5MCAtMjIgMTEyIC0zNnEzMiAtMjAgMzIgLTYwcTAgLTM5IC00MCAtNjQuNXQtMTA1IC0yNS41cS01MSAwIC05MS41IDE2dC02NSAzOC41dC00NS41IDQ1dC00NiAzOC41dC01NCAxNnEtNTAgMCAtNzUuNSAtMzB0LTI1LjUgLTc1cTAgLTkyIDEyMiAtMTU3LjV0MjkxIC02NS41IHE3MyAwIDE0MCAxOC41dDEyMi41IDUzLjV0ODguNSA5My41dDMzIDEzMS41ek0xNTM2IDI1NnEwIC0xNTkgLTExMi41IC0yNzEuNXQtMjcxLjUgLTExMi41cS0xMzAgMCAtMjM0IDgwcS03NyAtMTYgLTE1MCAtMTZxLTE0MyAwIC0yNzMuNSA1NS41dC0yMjUgMTUwdC0xNTAgMjI1dC01NS41IDI3My41cTAgNzMgMTYgMTUwcS04MCAxMDQgLTgwIDIzNHEwIDE1OSAxMTIuNSAyNzEuNXQyNzEuNSAxMTIuNXExMzAgMCAyMzQgLTgwIHE3NyAxNiAxNTAgMTZxMTQzIDAgMjczLjUgLTU1LjV0MjI1IC0xNTB0MTUwIC0yMjV0NTUuNSAtMjczLjVxMCAtNzMgLTE2IC0xNTBxODAgLTEwNCA4MCAtMjM0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTgwOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMDAwIDExMDJsMzcgMTk0cTUgMjMgLTkgNDB0LTM1IDE3aC03MTJxLTIzIDAgLTM4LjUgLTE3dC0xNS41IC0zN3YtMTEwMXEwIC03IDYgLTFsMjkxIDM1MnEyMyAyNiAzOCAzMy41dDQ4IDcuNWgyMzlxMjIgMCAzNyAxNC41dDE4IDI5LjVxMjQgMTMwIDM3IDE5MXE0IDIxIC0xMS41IDQwdC0zNi41IDE5aC0yOTRxLTI5IDAgLTQ4IDE5dC0xOSA0OHY0MnEwIDI5IDE5IDQ3LjV0NDggMTguNWgzNDZxMTggMCAzNSAxMy41dDIwIDI5LjV6IE0xMjI3IDEzMjRxLTE1IC03MyAtNTMuNSAtMjY2LjV0LTY5LjUgLTM1MHQtMzUgLTE3My41cS02IC0yMiAtOSAtMzIuNXQtMTQgLTMyLjV0LTI0LjUgLTMzdC0zOC41IC0yMXQtNTggLTEwaC0yNzFxLTEzIDAgLTIyIC0xMHEtOCAtOSAtNDI2IC00OTRxLTIyIC0yNSAtNTguNSAtMjguNXQtNDguNSA1LjVxLTU1IDIyIC01NSA5OHYxNDEwcTAgNTUgMzggMTAyLjV0MTIwIDQ3LjVoODg4cTk1IDAgMTI3IC01M3QxMCAtMTU5ek0xMjI3IDEzMjQgbC0xNTggLTc5MHE0IDE3IDM1IDE3My41dDY5LjUgMzUwdDUzLjUgMjY2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxODE7IiBkPSJNNzA0IDE5MnYxMDI0cTAgMTQgLTkgMjN0LTIzIDloLTQ4MHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xMDI0cTAgLTE0IDkgLTIzdDIzIC05aDQ4MHExNCAwIDIzIDl0OSAyM3pNMTM3NiA1NzZ2NjQwcTAgMTQgLTkgMjN0LTIzIDloLTQ4MHEtMTQgMCAtMjMgLTl0LTkgLTIzdi02NDBxMCAtMTQgOSAtMjN0MjMgLTloNDgwcTE0IDAgMjMgOXQ5IDIzek0xNTM2IDEzNDR2LTE0MDhxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNDA4IHEtMjYgMCAtNDUgMTl0LTE5IDQ1djE0MDhxMCAyNiAxOSA0NXQ0NSAxOWgxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4MjsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTI4MCA0ODBxMCAtNDAgLTI4IC02OHQtNjggLTI4cS01MSAwIC04MCA0M2wtMjI3IDM0MWgtNDV2LTEzMmwyNDcgLTQxMXE5IC0xNSA5IC0zM3EwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE5MnYtMjcycTAgLTQ2IC0zMyAtNzl0LTc5IC0zM2gtMTYwcS00NiAwIC03OSAzM3QtMzMgNzl2MjcyaC0xOTJxLTI2IDAgLTQ1IDE5dC0xOSA0NXEwIDE4IDkgMzNsMjQ3IDQxMXYxMzJoLTQ1bC0yMjcgLTM0MXEtMjkgLTQzIC04MCAtNDMgcS00MCAwIC02OCAyOHQtMjggNjhxMCAyOSAxNiA1M2wyNTYgMzg0cTczIDEwNyAxNzYgMTA3aDM4NHExMDMgMCAxNzYgLTEwN2wyNTYgLTM4NHExNiAtMjQgMTYgLTUzek04NjQgMTI4MHEwIC05MyAtNjUuNSAtMTU4LjV0LTE1OC41IC02NS41dC0xNTguNSA2NS41dC02NS41IDE1OC41dDY1LjUgMTU4LjV0MTU4LjUgNjUuNXQxNTguNSAtNjUuNXQ2NS41IC0xNTguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4MzsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNMTAyNCA4MzJ2LTQxNnEwIC00MCAtMjggLTY4dC02OCAtMjh0LTY4IDI4dC0yOCA2OHYzNTJoLTY0di05MTJxMCAtNDYgLTMzIC03OXQtNzkgLTMzdC03OSAzM3QtMzMgNzl2NDY0aC02NHYtNDY0cTAgLTQ2IC0zMyAtNzl0LTc5IC0zM3QtNzkgMzN0LTMzIDc5djkxMmgtNjR2LTM1MnEwIC00MCAtMjggLTY4dC02OCAtMjh0LTY4IDI4dC0yOCA2OHY0MTZxMCA4MCA1NiAxMzZ0MTM2IDU2aDY0MHE4MCAwIDEzNiAtNTZ0NTYgLTEzNnogTTczNiAxMjgwcTAgLTkzIC02NS41IC0xNTguNXQtMTU4LjUgLTY1LjV0LTE1OC41IDY1LjV0LTY1LjUgMTU4LjV0NjUuNSAxNTguNXQxNTguNSA2NS41dDE1OC41IC02NS41dDY1LjUgLTE1OC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTg0OyIgZD0iTTc3MyAyMzRsMzUwIDQ3M3ExNiAyMiAyNC41IDU5dC02IDg1dC02MS41IDc5cS00MCAyNiAtODMgMjUuNXQtNzMuNSAtMTcuNXQtNTQuNSAtNDVxLTM2IC00MCAtOTYgLTQwcS01OSAwIC05NSA0MHEtMjQgMjggLTU0LjUgNDV0LTczLjUgMTcuNXQtODQgLTI1LjVxLTQ2IC0zMSAtNjAuNSAtNzl0LTYgLTg1dDI0LjUgLTU5ek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzIHQtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxODU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE0NzIgNjQwcTAgMTE3IC00NS41IDIyMy41dC0xMjMgMTg0dC0xODQgMTIzdC0yMjMuNSA0NS41dC0yMjMuNSAtNDUuNXQtMTg0IC0xMjN0LTEyMyAtMTg0dC00NS41IC0yMjMuNXQ0NS41IC0yMjMuNXQxMjMgLTE4NHQxODQgLTEyM3QyMjMuNSAtNDUuNXQyMjMuNSA0NS41dDE4NCAxMjN0MTIzIDE4NHQ0NS41IDIyMy41ek0xNzQ4IDM2M3EtNCAtMTUgLTIwIC0yMGwtMjkyIC05NnYtMzA2cTAgLTE2IC0xMyAtMjZxLTE1IC0xMCAtMjkgLTQgbC0yOTIgOTRsLTE4MCAtMjQ4cS0xMCAtMTMgLTI2IC0xM3QtMjYgMTNsLTE4MCAyNDhsLTI5MiAtOTRxLTE0IC02IC0yOSA0cS0xMyAxMCAtMTMgMjZ2MzA2bC0yOTIgOTZxLTE2IDUgLTIwIDIwcS01IDE3IDQgMjlsMTgwIDI0OGwtMTgwIDI0OHEtOSAxMyAtNCAyOXE0IDE1IDIwIDIwbDI5MiA5NnYzMDZxMCAxNiAxMyAyNnExNSAxMCAyOSA0bDI5MiAtOTRsMTgwIDI0OHE5IDEyIDI2IDEydDI2IC0xMmwxODAgLTI0OGwyOTIgOTQgcTE0IDYgMjkgLTRxMTMgLTEwIDEzIC0yNnYtMzA2bDI5MiAtOTZxMTYgLTUgMjAgLTIwcTUgLTE2IC00IC0yOWwtMTgwIC0yNDhsMTgwIC0yNDhxOSAtMTIgNCAtMjl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxODY7IiBkPSJNMTI2MiAyMzNxLTU0IC05IC0xMTAgLTlxLTE4MiAwIC0zMzcgOTB0LTI0NSAyNDV0LTkwIDMzN3EwIDE5MiAxMDQgMzU3cS0yMDEgLTYwIC0zMjguNSAtMjI5dC0xMjcuNSAtMzg0cTAgLTEzMCA1MSAtMjQ4LjV0MTM2LjUgLTIwNHQyMDQgLTEzNi41dDI0OC41IC01MXExNDQgMCAyNzMuNSA2MS41dDIyMC41IDE3MS41ek0xNDY1IDMxOHEtOTQgLTIwMyAtMjgzLjUgLTMyNC41dC00MTMuNSAtMTIxLjVxLTE1NiAwIC0yOTggNjEgdC0yNDUgMTY0dC0xNjQgMjQ1dC02MSAyOThxMCAxNTMgNTcuNSAyOTIuNXQxNTYgMjQxLjV0MjM1LjUgMTY0LjV0MjkwIDY4LjVxNDQgMiA2MSAtMzlxMTggLTQxIC0xNSAtNzJxLTg2IC03OCAtMTMxLjUgLTE4MS41dC00NS41IC0yMTguNXEwIC0xNDggNzMgLTI3M3QxOTggLTE5OHQyNzMgLTczcTExOCAwIDIyOCA1MXE0MSAxOCA3MiAtMTNxMTQgLTE0IDE3LjUgLTM0dC00LjUgLTM4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTg3OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMDg4IDcwNHEwIDI2IC0xOSA0NXQtNDUgMTloLTI1NnEtMjYgMCAtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1dDQ1IC0xOWgyNTZxMjYgMCA0NSAxOXQxOSA0NXpNMTY2NCA4OTZ2LTk2MHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTE0MDhxLTI2IDAgLTQ1IDE5dC0xOSA0NXY5NjBxMCAyNiAxOSA0NXQ0NSAxOWgxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXpNMTcyOCAxMzQ0di0yNTZxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNTM2IHEtMjYgMCAtNDUgMTl0LTE5IDQ1djI1NnEwIDI2IDE5IDQ1dDQ1IDE5aDE1MzZxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTg4OyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xNjMyIDU3NnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTIyNHEwIC0xNzEgLTY3IC0yOTBsMjA4IC0yMDlxMTkgLTE5IDE5IC00NXQtMTkgLTQ1cS0xOCAtMTkgLTQ1IC0xOXQtNDUgMTlsLTE5OCAxOTdxLTUgLTUgLTE1IC0xM3QtNDIgLTI4LjV0LTY1IC0zNi41dC04MiAtMjl0LTk3IC0xM3Y4OTZoLTEyOHYtODk2cS01MSAwIC0xMDEuNSAxMy41dC04NyAzM3QtNjYgMzl0LTQzLjUgMzIuNWwtMTUgMTRsLTE4MyAtMjA3IHEtMjAgLTIxIC00OCAtMjFxLTI0IDAgLTQzIDE2cS0xOSAxOCAtMjAuNSA0NC41dDE1LjUgNDYuNWwyMDIgMjI3cS01OCAxMTQgLTU4IDI3NGgtMjI0cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMjI0djI5NGwtMTczIDE3M3EtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5dDQ1IC0xOWwxNzMgLTE3M2g4NDRsMTczIDE3M3ExOSAxOSA0NSAxOXQ0NSAtMTl0MTkgLTQ1dC0xOSAtNDVsLTE3MyAtMTczdi0yOTRoMjI0cTI2IDAgNDUgLTE5IHQxOSAtNDV6TTExNTIgMTE1MmgtNjQwcTAgMTMzIDkzLjUgMjI2LjV0MjI2LjUgOTMuNXQyMjYuNSAtOTMuNXQ5My41IC0yMjYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4OTsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNMTkxNyAxMDE2cTIzIC02NCAtMTUwIC0yOTRxLTI0IC0zMiAtNjUgLTg1cS03OCAtMTAwIC05MCAtMTMxcS0xNyAtNDEgMTQgLTgxcTE3IC0yMSA4MSAtODJoMWwxIC0xbDEgLTFsMiAtMnExNDEgLTEzMSAxOTEgLTIyMXEzIC01IDYuNSAtMTIuNXQ3IC0yNi41dC0wLjUgLTM0dC0yNSAtMjcuNXQtNTkgLTEyLjVsLTI1NiAtNHEtMjQgLTUgLTU2IDV0LTUyIDIybC0yMCAxMnEtMzAgMjEgLTcwIDY0dC02OC41IDc3LjV0LTYxIDU4IHQtNTYuNSAxNS41cS0zIC0xIC04IC0zLjV0LTE3IC0xNC41dC0yMS41IC0yOS41dC0xNyAtNTJ0LTYuNSAtNzcuNXEwIC0xNSAtMy41IC0yNy41dC03LjUgLTE4LjVsLTQgLTVxLTE4IC0xOSAtNTMgLTIyaC0xMTVxLTcxIC00IC0xNDYgMTYuNXQtMTMxLjUgNTN0LTEwMyA2NnQtNzAuNSA1Ny41bC0yNSAyNHEtMTAgMTAgLTI3LjUgMzB0LTcxLjUgOTF0LTEwNiAxNTF0LTEyMi41IDIxMXQtMTMwLjUgMjcycS02IDE2IC02IDI3dDMgMTZsNCA2IHExNSAxOSA1NyAxOWwyNzQgMnExMiAtMiAyMyAtNi41dDE2IC04LjVsNSAtM3ExNiAtMTEgMjQgLTMycTIwIC01MCA0NiAtMTAzLjV0NDEgLTgxLjVsMTYgLTI5cTI5IC02MCA1NiAtMTA0dDQ4LjUgLTY4LjV0NDEuNSAtMzguNXQzNCAtMTR0MjcgNXEyIDEgNSA1dDEyIDIydDEzLjUgNDd0OS41IDgxdDAgMTI1cS0yIDQwIC05IDczdC0xNCA0NmwtNiAxMnEtMjUgMzQgLTg1IDQzcS0xMyAyIDUgMjRxMTcgMTkgMzggMzBxNTMgMjYgMjM5IDI0IHE4MiAtMSAxMzUgLTEzcTIwIC01IDMzLjUgLTEzLjV0MjAuNSAtMjR0MTAuNSAtMzJ0My41IC00NS41dC0xIC01NXQtMi41IC03MC41dC0xLjUgLTgyLjVxMCAtMTEgLTEgLTQydC0wLjUgLTQ4dDMuNSAtNDAuNXQxMS41IC0zOXQyMi41IC0yNC41cTggLTIgMTcgLTR0MjYgMTF0MzggMzQuNXQ1MiA2N3Q2OCAxMDcuNXE2MCAxMDQgMTA3IDIyNXE0IDEwIDEwIDE3LjV0MTEgMTAuNWw0IDNsNSAyLjV0MTMgM3QyMCAwLjVsMjg4IDIgcTM5IDUgNjQgLTIuNXQzMSAtMTYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4YTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNjc1IDI1MnEyMSAzNCAxMSA2OXQtNDUgNTBxLTM0IDE0IC03MyAxdC02MCAtNDZxLTIyIC0zNCAtMTMgLTY4LjV0NDMgLTUwLjV0NzQuNSAtMi41dDYyLjUgNDcuNXpNNzY5IDM3M3E4IDEzIDMuNSAyNi41dC0xNy41IDE4LjVxLTE0IDUgLTI4LjUgLTAuNXQtMjEuNSAtMTguNXEtMTcgLTMxIDEzIC00NXExNCAtNSAyOSAwLjV0MjIgMTguNXpNOTQzIDI2NnEtNDUgLTEwMiAtMTU4IC0xNTB0LTIyNCAtMTIgcS0xMDcgMzQgLTE0Ny41IDEyNi41dDYuNSAxODcuNXE0NyA5MyAxNTEuNSAxMzl0MjEwLjUgMTlxMTExIC0yOSAxNTguNSAtMTE5LjV0Mi41IC0xOTAuNXpNMTI1NSA0MjZxLTkgOTYgLTg5IDE3MHQtMjA4LjUgMTA5dC0yNzQuNSAyMXEtMjIzIC0yMyAtMzY5LjUgLTE0MS41dC0xMzIuNSAtMjY0LjVxOSAtOTYgODkgLTE3MHQyMDguNSAtMTA5dDI3NC41IC0yMXEyMjMgMjMgMzY5LjUgMTQxLjV0MTMyLjUgMjY0LjV6TTE1NjMgNDIyIHEwIC02OCAtMzcgLTEzOS41dC0xMDkgLTEzN3QtMTY4LjUgLTExNy41dC0yMjYgLTgzdC0yNzAuNSAtMzF0LTI3NSAzMy41dC0yNDAuNSA5M3QtMTcxLjUgMTUxdC02NSAxOTkuNXEwIDExNSA2OS41IDI0NXQxOTcuNSAyNThxMTY5IDE2OSAzNDEuNSAyMzZ0MjQ2LjUgLTdxNjUgLTY0IDIwIC0yMDlxLTQgLTE0IC0xIC0yMHQxMCAtN3QxNC41IDAuNXQxMy41IDMuNWw2IDJxMTM5IDU5IDI0NiA1OXQxNTMgLTYxcTQ1IC02MyAwIC0xNzggcS0yIC0xMyAtNC41IC0yMHQ0LjUgLTEyLjV0MTIgLTcuNXQxNyAtNnE1NyAtMTggMTAzIC00N3Q4MCAtODEuNXQzNCAtMTE2LjV6TTE0ODkgMTA0NnE0MiAtNDcgNTQuNSAtMTA4LjV0LTYuNSAtMTE3LjVxLTggLTIzIC0yOS41IC0zNHQtNDQuNSAtNHEtMjMgOCAtMzQgMjkuNXQtNCA0NC41cTIwIDYzIC0yNCAxMTF0LTEwNyAzNXEtMjQgLTUgLTQ1IDh0LTI1IDM3cS01IDI0IDggNDQuNXQzNyAyNS41cTYwIDEzIDExOSAtNS41dDEwMSAtNjUuNXogTTE2NzAgMTIwOXE4NyAtOTYgMTEyLjUgLTIyMi41dC0xMy41IC0yNDEuNXEtOSAtMjcgLTM0IC00MHQtNTIgLTR0LTQwIDM0dC01IDUycTI4IDgyIDEwIDE3MnQtODAgMTU4cS02MiA2OSAtMTQ4IDk1LjV0LTE3MyA4LjVxLTI4IC02IC01MiA5LjV0LTMwIDQzLjV0OS41IDUxLjV0NDMuNSAyOS41cTEyMyAyNiAyNDQgLTExLjV0MjA4IC0xMzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4YjsiIGQ9Ik0xMTMzIC0zNHEtMTcxIC05NCAtMzY4IC05NHEtMTk2IDAgLTM2NyA5NHExMzggODcgMjM1LjUgMjExdDEzMS41IDI2OHEzNSAtMTQ0IDEzMi41IC0yNjh0MjM1LjUgLTIxMXpNNjM4IDEzOTR2LTQ4NXEwIC0yNTIgLTEyNi41IC00NTkuNXQtMzMwLjUgLTMwNi41cS0xODEgMjE1IC0xODEgNDk1cTAgMTg3IDgzLjUgMzQ5LjV0MjI5LjUgMjY5LjV0MzI1IDEzN3pNMTUzNiA2MzhxMCAtMjgwIC0xODEgLTQ5NSBxLTIwNCA5OSAtMzMwLjUgMzA2LjV0LTEyNi41IDQ1OS41djQ4NXExNzkgLTMwIDMyNSAtMTM3dDIyOS41IC0yNjkuNXQ4My41IC0zNDkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE4YzsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTQwMiA0MzNxLTMyIC04MCAtNzYgLTEzOHQtOTEgLTg4LjV0LTk5IC00Ni41dC0xMDEuNSAtMTQuNXQtOTYuNSA4LjV0LTg2LjUgMjJ0LTY5LjUgMjcuNXQtNDYgMjIuNWwtMTcgMTBxLTExMyAtMjI4IC0yODkuNSAtMzU5LjV0LTM4NC41IC0xMzIuNXEtMTkgMCAtMzIgMTN0LTEzIDMydDEzIDMxLjV0MzIgMTIuNXExNzMgMSAzMjIuNSAxMDcuNXQyNTEuNSAyOTQuNXEtMzYgLTE0IC03MiAtMjN0LTgzIC0xM3QtOTEgMi41dC05MyAyOC41IHQtOTIgNTl0LTg0LjUgMTAwdC03NC41IDE0NnExMTQgNDcgMjE0IDU3dDE2Ny41IC03LjV0MTI0LjUgLTU2LjV0ODguNSAtNzd0NTYuNSAtODJxNTMgMTMxIDc5IDI5MXEtNyAtMSAtMTggLTIuNXQtNDYuNSAtMi41dC02OS41IDAuNXQtODEuNSAxMHQtODguNSAyM3QtODQgNDIuNXQtNzUgNjV0LTU0LjUgOTQuNXQtMjguNSAxMjcuNXE3MCAyOCAxMzMuNSAzNi41dDExMi41IC0xdDkyIC0zMHQ3My41IC01MHQ1NiAtNjF0NDIgLTYzdDI3LjUgLTU2IHQxNiAtMzkuNWw0IC0xNnExMiAxMjIgMTIgMTk1cS04IDYgLTIxLjUgMTZ0LTQ5IDQ0LjV0LTYzLjUgNzEuNXQtNTQgOTN0LTMzIDExMi41dDEyIDEyN3Q3MCAxMzguNXE3MyAtMjUgMTI3LjUgLTYxLjV0ODQuNSAtNzYuNXQ0OCAtODV0MjAuNSAtODl0LTAuNSAtODUuNXQtMTMgLTc2LjV0LTE5IC02MnQtMTcgLTQybC03IC0xNXExIC01IDEgLTUwLjV0LTEgLTcxLjVxMyA3IDEwIDE4LjV0MzAuNSA0M3Q1MC41IDU4dDcxIDU1LjV0OTEuNSA0NC41IHQxMTIgMTQuNXQxMzIuNSAtMjRxLTIgLTc4IC0yMS41IC0xNDEuNXQtNTAgLTEwNC41dC02OS41IC03MS41dC04MS41IC00NS41dC04NC41IC0yNHQtODAgLTkuNXQtNjcuNSAxdC00Ni41IDQuNWwtMTcgM3EtMjMgLTE0NyAtNzMgLTI4M3E2IDcgMTggMTguNXQ0OS41IDQxdDc3LjUgNTIuNXQ5OS41IDQydDExNy41IDIwdDEyOSAtMjMuNXQxMzcgLTc3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOGQ7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTEyNTkgMjgzdi02NnEwIC04NSAtNTcuNSAtMTQ0LjV0LTEzOC41IC01OS41aC01N2wtMjYwIC0yNjl2MjY5aC01MjlxLTgxIDAgLTEzOC41IDU5LjV0LTU3LjUgMTQ0LjV2NjZoMTIzOHpNMTI1OSA2MDl2LTI1NWgtMTIzOHYyNTVoMTIzOHpNMTI1OSA5Mzd2LTI1NWgtMTIzOHYyNTVoMTIzOHpNMTI1OSAxMDc3di02N2gtMTIzOHY2N3EwIDg0IDU3LjUgMTQzLjV0MTM4LjUgNTkuNWg4NDZxODEgMCAxMzguNSAtNTkuNXQ1Ny41IC0xNDMuNXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOGU7IiBkPSJNMTE1MiA2NDBxMCAtMTQgLTkgLTIzbC0zMjAgLTMyMHEtOSAtOSAtMjMgLTlxLTEzIDAgLTIyLjUgOS41dC05LjUgMjIuNXYxOTJoLTM1MnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDM1MnYxOTJxMCAxNCA5IDIzdDIzIDlxMTIgMCAyNCAtMTBsMzE5IC0zMTlxOSAtOSA5IC0yM3pNMTMxMiA2NDBxMCAxNDggLTczIDI3M3QtMTk4IDE5OHQtMjczIDczdC0yNzMgLTczdC0xOTggLTE5OCB0LTczIC0yNzN0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczdDI3MyA3M3QxOTggMTk4dDczIDI3M3pNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOTA7IiBkPSJNMTE1MiA3MzZ2LTE5MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTM1MnYtMTkycTAgLTE0IC05IC0yM3QtMjMgLTlxLTEyIDAgLTI0IDEwbC0zMTkgMzE5cS05IDkgLTkgMjN0OSAyM2wzMjAgMzIwcTkgOSAyMyA5cTEzIDAgMjIuNSAtOS41dDkuNSAtMjIuNXYtMTkyaDM1MnExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTEzMTIgNjQwcTAgMTQ4IC03MyAyNzN0LTE5OCAxOTh0LTI3MyA3M3QtMjczIC03M3QtMTk4IC0xOTggdC03MyAtMjczdDczIC0yNzN0MTk4IC0xOTh0MjczIC03M3QyNzMgNzN0MTk4IDE5OHQ3MyAyNzN6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTkxOyIgZD0iTTEwMjQgOTYwdi02NDBxMCAtMjYgLTE5IC00NXQtNDUgLTE5cS0yMCAwIC0zNyAxMmwtNDQ4IDMyMHEtMjcgMTkgLTI3IDUydDI3IDUybDQ0OCAzMjBxMTcgMTIgMzcgMTJxMjYgMCA0NSAtMTl0MTkgLTQ1ek0xMjgwIDE2MHY5NjBxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC05NjBxLTEzIDAgLTIyLjUgLTkuNXQtOS41IC0yMi41di05NjBxMCAtMTMgOS41IC0yMi41dDIyLjUgLTkuNWg5NjBxMTMgMCAyMi41IDkuNXQ5LjUgMjIuNXogTTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTkyOyIgZD0iTTEwMjQgNjQwcTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXQtMTgxIDc1dC03NSAxODF0NzUgMTgxdDE4MSA3NXQxODEgLTc1dDc1IC0xODF6TTc2OCAxMTg0cS0xNDggMCAtMjczIC03M3QtMTk4IC0xOTh0LTczIC0yNzN0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczdDI3MyA3M3QxOTggMTk4dDczIDI3M3QtNzMgMjczdC0xOTggMTk4dC0yNzMgNzN6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41IHQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE5MzsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTAyMyAzNDlsMTAyIC0yMDRxLTU4IC0xNzkgLTIxMCAtMjkwdC0zMzkgLTExMXEtMTU2IDAgLTI4OC41IDc3LjV0LTIxMCAyMTB0LTc3LjUgMjg4LjVxMCAxODEgMTA0LjUgMzMwdDI3NC41IDIxMWwxNyAtMTMxcS0xMjIgLTU0IC0xOTUgLTE2NS41dC03MyAtMjQ0LjVxMCAtMTg1IDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjVxMTI2IDAgMjMyLjUgNjV0MTY1IDE3NS41dDQ5LjUgMjM2LjV6TTE1NzEgMjQ5bDU4IC0xMTRsLTI1NiAtMTI4IHEtMTMgLTcgLTI5IC03cS00MCAwIC01NyAzNWwtMjM5IDQ3N2gtNDcycS0yNCAwIC00Mi41IDE2LjV0LTIxLjUgNDAuNWwtOTYgNzc5cS0yIDE2IDYgNDJxMTQgNTEgNTcgODIuNXQ5NyAzMS41cTY2IDAgMTEzIC00N3Q0NyAtMTEzcTAgLTY5IC01MiAtMTE3LjV0LTEyMCAtNDEuNWwzNyAtMjg5aDQyM3YtMTI4aC00MDdsMTYgLTEyOGg0NTVxNDAgMCA1NyAtMzVsMjI4IC00NTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOTQ7IiBkPSJNMTI5MiA4OThxMTAgMjE2IC0xNjEgMjIycS0yMzEgOCAtMzEyIC0yNjFxNDQgMTkgODIgMTlxODUgMCA3NCAtOTZxLTQgLTU3IC03NCAtMTY3dC0xMDUgLTExMHEtNDMgMCAtODIgMTY5cS0xMyA1NCAtNDUgMjU1cS0zMCAxODkgLTE2MCAxNzdxLTU5IC03IC0xNjQgLTEwMGwtODEgLTcybC04MSAtNzJsNTIgLTY3cTc2IDUyIDg3IDUycTU3IDAgMTA3IC0xNzlxMTUgLTU1IDQ1IC0xNjQuNXQ0NSAtMTY0LjVxNjggLTE3OSAxNjQgLTE3OSBxMTU3IDAgMzgzIDI5NHEyMjAgMjgzIDIyNiA0NDR6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTk1OyIgaG9yaXotYWR2LXg9IjExNTIiIGQ9Ik0xMTUyIDcwNHEwIC0xOTEgLTk0LjUgLTM1M3QtMjU2LjUgLTI1Ni41dC0zNTMgLTk0LjVoLTE2MHEtMTQgMCAtMjMgOXQtOSAyM3Y2MTFsLTIxNSAtNjZxLTMgLTEgLTkgLTFxLTEwIDAgLTE5IDZxLTEzIDEwIC0xMyAyNnYxMjhxMCAyMyAyMyAzMWwyMzMgNzF2OTNsLTIxNSAtNjZxLTMgLTEgLTkgLTFxLTEwIDAgLTE5IDZxLTEzIDEwIC0xMyAyNnYxMjhxMCAyMyAyMyAzMWwyMzMgNzF2MjUwcTAgMTQgOSAyM3QyMyA5aDE2MCBxMTQgMCAyMyAtOXQ5IC0yM3YtMTgxbDM3NSAxMTZxMTUgNSAyOCAtNXQxMyAtMjZ2LTEyOHEwIC0yMyAtMjMgLTMxbC0zOTMgLTEyMXYtOTNsMzc1IDExNnExNSA1IDI4IC01dDEzIC0yNnYtMTI4cTAgLTIzIC0yMyAtMzFsLTM5MyAtMTIxdi00ODdxMTg4IDEzIDMxOCAxNTF0MTMwIDMyOHEwIDE0IDkgMjN0MjMgOWgxNjBxMTQgMCAyMyAtOXQ5IC0yM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE5NjsiIGhvcml6LWFkdi14PSIxNDA4IiBkPSJNMTE1MiA3MzZ2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTM1MnYtMzUycTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjM1MmgtMzUycS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDM1MnYzNTJxMCAxNCA5IDIzdDIzIDloNjRxMTQgMCAyMyAtOXQ5IC0yM3YtMzUyaDM1MnExNCAwIDIzIC05dDkgLTIzek0xMjgwIDI4OHY4MzJxMCA2NiAtNDcgMTEzdC0xMTMgNDdoLTgzMiBxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTN2LTgzMnEwIC02NiA0NyAtMTEzdDExMyAtNDdoODMycTY2IDAgMTEzIDQ3dDQ3IDExM3pNMTQwOCAxMTIwdi04MzJxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTgzMnEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2ODMycTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg4MzJxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOTc7IiBob3Jpei1hZHYteD0iMjE3NiIgZD0iTTYyMCA0MTZxLTExMCAtNjQgLTI2OCAtNjRoLTEyOHY2NGgtNjRxLTEzIDAgLTIyLjUgMjMuNXQtOS41IDU2LjVxMCAyNCA3IDQ5cS01OCAyIC05Ni41IDEwLjV0LTM4LjUgMjAuNXQzOC41IDIwLjV0OTYuNSAxMC41cS03IDI1IC03IDQ5cTAgMzMgOS41IDU2LjV0MjIuNSAyMy41aDY0djY0aDEyOHExNTggMCAyNjggLTY0aDExMTNxNDIgLTcgMTA2LjUgLTE4dDgwLjUgLTE0cTg5IC0xNSAxNTAgLTQwLjV0ODMuNSAtNDcuNXQyMi41IC00MCB0LTIyLjUgLTQwdC04My41IC00Ny41dC0xNTAgLTQwLjVxLTE2IC0zIC04MC41IC0xNHQtMTA2LjUgLTE4aC0xMTEzek0xNzM5IDY2OHE1MyAtMzYgNTMgLTkydC01MyAtOTJsODEgLTMwcTY4IDQ4IDY4IDEyMnQtNjggMTIyek02MjUgNDAwaDEwMTVxLTIxNyAtMzggLTQ1NiAtODBxLTU3IDAgLTExMyAtMjR0LTgzIC00OGwtMjggLTI0bC0yODggLTI4OHEtMjYgLTI2IC03MC41IC00NXQtODkuNSAtMTloLTk2bC05MyA0NjRoMjkgcTE1NyAwIDI3MyA2NHpNMzUyIDgxNmgtMjlsOTMgNDY0aDk2cTQ2IDAgOTAgLTE5dDcwIC00NWwyODggLTI4OHE0IC00IDExIC0xMC41dDMwLjUgLTIzdDQ4LjUgLTI5dDYxLjUgLTIzdDcyLjUgLTEwLjVsNDU2IC04MGgtMTAxNXEtMTE2IDY0IC0yNzMgNjR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOTg7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTE1MTkgNzYwcTYyIDAgMTAzLjUgLTQwLjV0NDEuNSAtMTAxLjVxMCAtOTcgLTkzIC0xMzBsLTE3MiAtNTlsNTYgLTE2N3E3IC0yMSA3IC00N3EwIC01OSAtNDIgLTEwMnQtMTAxIC00M3EtNDcgMCAtODUuNSAyN3QtNTMuNSA3MmwtNTUgMTY1bC0zMTAgLTEwNmw1NSAtMTY0cTggLTI0IDggLTQ3cTAgLTU5IC00MiAtMTAydC0xMDIgLTQzcS00NyAwIC04NSAyN3QtNTMgNzJsLTU1IDE2M2wtMTUzIC01M3EtMjkgLTkgLTUwIC05IHEtNjEgMCAtMTAxLjUgNDB0LTQwLjUgMTAxcTAgNDcgMjcuNSA4NXQ3MS41IDUzbDE1NiA1M2wtMTA1IDMxM2wtMTU2IC01NHEtMjYgLTggLTQ4IC04cS02MCAwIC0xMDEgNDAuNXQtNDEgMTAwLjVxMCA0NyAyNy41IDg1dDcxLjUgNTNsMTU3IDUzbC01MyAxNTlxLTggMjQgLTggNDdxMCA2MCA0MiAxMDIuNXQxMDIgNDIuNXE0NyAwIDg1IC0yN3Q1MyAtNzJsNTQgLTE2MGwzMTAgMTA1bC01NCAxNjBxLTggMjQgLTggNDdxMCA1OSA0Mi41IDEwMiB0MTAxLjUgNDNxNDcgMCA4NS41IC0yNy41dDUzLjUgLTcxLjVsNTMgLTE2MWwxNjIgNTVxMjEgNiA0MyA2cTYwIDAgMTAyLjUgLTM5LjV0NDIuNSAtOTguNXEwIC00NSAtMzAgLTgxLjV0LTc0IC01MS41bC0xNTcgLTU0bDEwNSAtMzE2bDE2NCA1NnEyNCA4IDQ2IDh6TTcyNSA0OThsMzEwIDEwNWwtMTA1IDMxNWwtMzEwIC0xMDd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOTk7IiBkPSJNMTI0OCAxNDA4cTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41di05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjB6TTEyODAgMzUydjQzNnEtMzEgLTM1IC02NCAtNTVxLTM0IC0yMiAtMTMyLjUgLTg1dC0xNTEuNSAtOTlxLTk4IC02OSAtMTY0IC02OXYwdjBxLTY2IDAgLTE2NCA2OSBxLTQ2IDMyIC0xNDEuNSA5Mi41dC0xNDIuNSA5Mi41cS0xMiA4IC0zMyAyN3QtMzEgMjd2LTQzNnEwIC00MCAyOCAtNjh0NjggLTI4aDgzMnE0MCAwIDY4IDI4dDI4IDY4ek0xMjgwIDkyNXEwIDQxIC0yNy41IDcwdC02OC41IDI5aC04MzJxLTQwIDAgLTY4IC0yOHQtMjggLTY4cTAgLTM3IDMwLjUgLTc2LjV0NjcuNSAtNjQuNXE0NyAtMzIgMTM3LjUgLTg5dDEyOS41IC04M3EzIC0yIDE3IC0xMS41dDIxIC0xNHQyMSAtMTN0MjMuNSAtMTMgdDIxLjUgLTkuNXQyMi41IC03LjV0MjAuNSAtMi41dDIwLjUgMi41dDIyLjUgNy41dDIxLjUgOS41dDIzLjUgMTN0MjEgMTN0MjEgMTR0MTcgMTEuNWwyNjcgMTc0cTM1IDIzIDY2LjUgNjIuNXQzMS41IDczLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOWE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEyNyA2NDBxMCAxNjMgNjcgMzEzbDM2NyAtMTAwNXEtMTk2IDk1IC0zMTUgMjgxdC0xMTkgNDExek0xNDE1IDY3OXEwIC0xOSAtMi41IC0zOC41dC0xMCAtNDkuNXQtMTEuNSAtNDR0LTE3LjUgLTU5dC0xNy41IC01OGwtNzYgLTI1NmwtMjc4IDgyNnE0NiAzIDg4IDhxMTkgMiAyNiAxOC41dC0yLjUgMzF0LTI4LjUgMTMuNWwtMjA1IC0xMHEtNzUgMSAtMjAyIDEwcS0xMiAxIC0yMC41IC01dC0xMS41IC0xNXQtMS41IC0xOC41dDkgLTE2LjUgdDE5LjUgLThsODAgLThsMTIwIC0zMjhsLTE2OCAtNTA0bC0yODAgODMycTQ2IDMgODggOHExOSAyIDI2IDE4LjV0LTIuNSAzMXQtMjguNSAxMy41bC0yMDUgLTEwcS03IDAgLTIzIDAuNXQtMjYgMC41cTEwNSAxNjAgMjc0LjUgMjUzLjV0MzY3LjUgOTMuNXExNDcgMCAyODAuNSAtNTN0MjM4LjUgLTE0OWgtMTBxLTU1IDAgLTkyIC00MC41dC0zNyAtOTUuNXEwIC0xMiAyIC0yNHQ0IC0yMS41dDggLTIzdDkgLTIxdDEyIC0yMi41dDEyLjUgLTIxIHQxNC41IC0yNHQxNCAtMjNxNjMgLTEwNyA2MyAtMjEyek05MDkgNTczbDIzNyAtNjQ3cTEgLTYgNSAtMTFxLTEyNiAtNDQgLTI1NSAtNDRxLTExMiAwIC0yMTcgMzJ6TTE1NzAgMTAwOXE5NSAtMTc0IDk1IC0zNjlxMCAtMjA5IC0xMDQgLTM4NS41dC0yNzkgLTI3OC41bDIzNSA2NzhxNTkgMTY5IDU5IDI3NnEwIDQyIC02IDc5ek04OTYgMTUzNnExODIgMCAzNDggLTcxdDI4NiAtMTkxdDE5MSAtMjg2dDcxIC0zNDh0LTcxIC0zNDh0LTE5MSAtMjg2IHQtMjg2IC0xOTF0LTM0OCAtNzF0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxek04OTYgLTIxNXExNzMgMCAzMzEuNSA2OHQyNzMgMTgyLjV0MTgyLjUgMjczdDY4IDMzMS41dC02OCAzMzEuNXQtMTgyLjUgMjczdC0yNzMgMTgyLjV0LTMzMS41IDY4dC0zMzEuNSAtNjh0LTI3MyAtMTgyLjV0LTE4Mi41IC0yNzN0LTY4IC0zMzEuNXQ2OCAtMzMxLjV0MTgyLjUgLTI3MyB0MjczIC0xODIuNXQzMzEuNSAtNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOWI7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEwODYgMTUzNnYtMTUzNmwtMjcyIC0xMjhxLTIyOCAyMCAtNDE0IDEwMnQtMjkzIDIwOC41dC0xMDcgMjcyLjVxMCAxNDAgMTAwLjUgMjYzLjV0Mjc1IDIwNS41dDM5MS41IDEwOHYtMTcycS0yMTcgLTM4IC0zNTYuNSAtMTUwdC0xMzkuNSAtMjU1cTAgLTE1MiAxNTQuNSAtMjY3dDM4OC41IC0xNDV2MTM2MHpNMTc1NSA5NTRsMzcgLTM5MGwtNTI1IDExNGwxNDcgODNxLTExOSA3MCAtMjgwIDk5djE3MnEyNzcgLTMzIDQ4MSAtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMTljOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik05NjAgMTUzNmw5NjAgLTM4NHYtMTI4aC0xMjhxMCAtMjYgLTIwLjUgLTQ1dC00OC41IC0xOWgtMTUyNnEtMjggMCAtNDguNSAxOXQtMjAuNSA0NWgtMTI4djEyOHpNMjU2IDg5NmgyNTZ2LTc2OGgxMjh2NzY4aDI1NnYtNzY4aDEyOHY3NjhoMjU2di03NjhoMTI4djc2OGgyNTZ2LTc2OGg1OXEyOCAwIDQ4LjUgLTE5dDIwLjUgLTQ1di02NGgtMTY2NHY2NHEwIDI2IDIwLjUgNDV0NDguNSAxOWg1OXY3Njh6TTE4NTEgLTY0IHEyOCAwIDQ4LjUgLTE5dDIwLjUgLTQ1di0xMjhoLTE5MjB2MTI4cTAgMjYgMjAuNSA0NXQ0OC41IDE5aDE3ODJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOWQ7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTE3NzQgNzAwbDE4IC0zMTZxNCAtNjkgLTgyIC0xMjh0LTIzNSAtOTMuNXQtMzIzIC0zNC41dC0zMjMgMzQuNXQtMjM1IDkzLjV0LTgyIDEyOGwxOCAzMTZsNTc0IC0xODFxMjIgLTcgNDggLTd0NDggN3pNMjMwNCAxMDI0cTAgLTIzIC0yMiAtMzFsLTExMjAgLTM1MnEtNCAtMSAtMTAgLTF0LTEwIDFsLTY1MiAyMDZxLTQzIC0zNCAtNzEgLTExMS41dC0zNCAtMTc4LjVxNjMgLTM2IDYzIC0xMDlxMCAtNjkgLTU4IC0xMDdsNTggLTQzMyBxMiAtMTQgLTggLTI1cS05IC0xMSAtMjQgLTExaC0xOTJxLTE1IDAgLTI0IDExcS0xMCAxMSAtOCAyNWw1OCA0MzNxLTU4IDM4IC01OCAxMDdxMCA3MyA2NSAxMTFxMTEgMjA3IDk4IDMzMGwtMzMzIDEwNHEtMjIgOCAtMjIgMzF0MjIgMzFsMTEyMCAzNTJxNCAxIDEwIDF0MTAgLTFsMTEyMCAtMzUycTIyIC04IDIyIC0zMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjE5ZTsiIGQ9Ik04NTkgNTc5bDEzIC03MDdxLTYyIDExIC0xMDUgMTFxLTQxIDAgLTEwNSAtMTFsMTMgNzA3cS00MCA2OSAtMTY4LjUgMjk1LjV0LTIxNi41IDM3NC41dC0xODEgMjg3cTU4IC0xNSAxMDggLTE1cTQzIDAgMTExIDE1cTYzIC0xMTEgMTMzLjUgLTIyOS41dDE2NyAtMjc2LjV0MTM4LjUgLTIyN3EzNyA2MSAxMDkuNSAxNzcuNXQxMTcuNSAxOTB0MTA1IDE3NnQxMDcgMTg5LjVxNTQgLTE0IDEwNyAtMTRxNTYgMCAxMTQgMTR2MCBxLTI4IC0zOSAtNjAgLTg4LjV0LTQ5LjUgLTc4LjV0LTU2LjUgLTk2dC00OSAtODRxLTE0NiAtMjQ4IC0zNTMgLTYxMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhMDsiIGQ9Ik03NjggNzUwaDcyNXExMiAtNjcgMTIgLTEyOHEwIC0yMTcgLTkxIC0zODcuNXQtMjU5LjUgLTI2Ni41dC0zODYuNSAtOTZxLTE1NyAwIC0yOTkgNjAuNXQtMjQ1IDE2My41dC0xNjMuNSAyNDV0LTYwLjUgMjk5dDYwLjUgMjk5dDE2My41IDI0NXQyNDUgMTYzLjV0Mjk5IDYwLjVxMzAwIDAgNTE1IC0yMDFsLTIwOSAtMjAxcS0xMjMgMTE5IC0zMDYgMTE5cS0xMjkgMCAtMjM4LjUgLTY1dC0xNzMuNSAtMTc2LjV0LTY0IC0yNDMuNSB0NjQgLTI0My41dDE3My41IC0xNzYuNXQyMzguNSAtNjVxODcgMCAxNjAgMjR0MTIwIDYwdDgyIDgydDUxLjUgODd0MjIuNSA3OGgtNDM2djI2NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhMTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTA5NSAzNjlxMTYgLTE2IDAgLTMxcS02MiAtNjIgLTE5OSAtNjJ0LTE5OSA2MnEtMTYgMTUgMCAzMXE2IDYgMTUgNnQxNSAtNnE0OCAtNDkgMTY5IC00OXExMjAgMCAxNjkgNDlxNiA2IDE1IDZ0MTUgLTZ6TTc4OCA1NTBxMCAtMzcgLTI2IC02M3QtNjMgLTI2dC02My41IDI2dC0yNi41IDYzcTAgMzggMjYuNSA2NHQ2My41IDI2dDYzIC0yNi41dDI2IC02My41ek0xMTgzIDU1MHEwIC0zNyAtMjYuNSAtNjN0LTYzLjUgLTI2dC02MyAyNiB0LTI2IDYzdDI2IDYzLjV0NjMgMjYuNXQ2My41IC0yNnQyNi41IC02NHpNMTQzNCA2NzBxMCA0OSAtMzUgODR0LTg1IDM1dC04NiAtMzZxLTEzMCA5MCAtMzExIDk2bDYzIDI4M2wyMDAgLTQ1cTAgLTM3IDI2IC02M3Q2MyAtMjZ0NjMuNSAyNi41dDI2LjUgNjMuNXQtMjYuNSA2My41dC02My41IDI2LjVxLTU0IDAgLTgwIC01MGwtMjIxIDQ5cS0xOSA1IC0yNSAtMTZsLTY5IC0zMTJxLTE4MCAtNyAtMzA5IC05N3EtMzUgMzcgLTg3IDM3IHEtNTAgMCAtODUgLTM1dC0zNSAtODRxMCAtMzUgMTguNSAtNjR0NDkuNSAtNDRxLTYgLTI3IC02IC01NnEwIC0xNDIgMTQwIC0yNDN0MzM3IC0xMDFxMTk4IDAgMzM4IDEwMXQxNDAgMjQzcTAgMzIgLTcgNTdxMzAgMTUgNDggNDMuNXQxOCA2My41ek0xNzkyIDY0MHEwIC0xODIgLTcxIC0zNDh0LTE5MSAtMjg2dC0yODYgLTE5MXQtMzQ4IC03MXQtMzQ4IDcxdC0yODYgMTkxdC0xOTEgMjg2dC03MSAzNDh0NzEgMzQ4dDE5MSAyODZ0Mjg2IDE5MSB0MzQ4IDcxdDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhMjsiIGQ9Ik05MzkgNDA3cTEzIC0xMyAwIC0yNnEtNTMgLTUzIC0xNzEgLTUzdC0xNzEgNTNxLTEzIDEzIDAgMjZxNSA2IDEzIDZ0MTMgLTZxNDIgLTQyIDE0NSAtNDJ0MTQ1IDQycTUgNiAxMyA2dDEzIC02ek02NzYgNTYzcTAgLTMxIC0yMyAtNTR0LTU0IC0yM3QtNTQgMjN0LTIzIDU0cTAgMzIgMjIuNSA1NC41dDU0LjUgMjIuNXQ1NC41IC0yMi41dDIyLjUgLTU0LjV6TTEwMTQgNTYzcTAgLTMxIC0yMyAtNTR0LTU0IC0yM3QtNTQgMjN0LTIzIDU0IHEwIDMyIDIyLjUgNTQuNXQ1NC41IDIyLjV0NTQuNSAtMjIuNXQyMi41IC01NC41ek0xMjI5IDY2NnEwIDQyIC0zMCA3MnQtNzMgMzBxLTQyIDAgLTczIC0zMXEtMTEzIDc4IC0yNjcgODJsNTQgMjQzbDE3MSAtMzlxMSAtMzIgMjMuNSAtNTR0NTMuNSAtMjJxMzIgMCA1NC41IDIyLjV0MjIuNSA1NC41dC0yMi41IDU0LjV0LTU0LjUgMjIuNXEtNDggMCAtNjkgLTQzbC0xODkgNDJxLTE3IDUgLTIxIC0xM2wtNjAgLTI2OHEtMTU0IC02IC0yNjUgLTgzIHEtMzAgMzIgLTc0IDMycS00MyAwIC03MyAtMzB0LTMwIC03MnEwIC0zMCAxNiAtNTV0NDIgLTM4cS01IC0yNSAtNSAtNDhxMCAtMTIyIDEyMCAtMjA4LjV0Mjg5IC04Ni41cTE3MCAwIDI5MCA4Ni41dDEyMCAyMDguNXEwIDI1IC02IDQ5cTI1IDEzIDQwLjUgMzcuNXQxNS41IDU0LjV6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MCBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhMzsiIGQ9Ik04NjYgNjk3bDkwIDI3djYycTAgNzkgLTU4IDEzNXQtMTM4IDU2dC0xMzggLTU1LjV0LTU4IC0xMzQuNXYtMjgzcTAgLTIwIC0xNCAtMzMuNXQtMzMgLTEzLjV0LTMyLjUgMTMuNXQtMTMuNSAzMy41djEyMGgtMTUxdi0xMjJxMCAtODIgNTcuNSAtMTM5dDEzOS41IC01N3E4MSAwIDEzOC41IDU2LjV0NTcuNSAxMzYuNXYyODBxMCAxOSAxMy41IDMzdDMzLjUgMTRxMTkgMCAzMi41IC0xNHQxMy41IC0zM3YtNTR6TTExOTkgNTAydjEyMmgtMTUwIHYtMTI2cTAgLTIwIC0xMy41IC0zMy41dC0zMy41IC0xMy41cS0xOSAwIC0zMi41IDE0dC0xMy41IDMzdjEyM2wtOTAgLTI2bC02MCAyOHYtMTIzcTAgLTgwIDU4IC0xMzd0MTM5IC01N3QxMzguNSA1N3Q1Ny41IDEzOXpNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzIHQzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWE0OyIgaG9yaXotYWR2LXg9IjE5MjAiIGQ9Ik0xMDYyIDgyNHYxMThxMCA0MiAtMzAgNzJ0LTcyIDMwdC03MiAtMzB0LTMwIC03MnYtNjEycTAgLTE3NSAtMTI2IC0yOTl0LTMwMyAtMTI0cS0xNzggMCAtMzAzLjUgMTI1LjV0LTEyNS41IDMwMy41djI2NmgzMjh2LTI2MnEwIC00MyAzMCAtNzIuNXQ3MiAtMjkuNXQ3MiAyOS41dDMwIDcyLjV2NjIwcTAgMTcxIDEyNi41IDI5MnQzMDEuNSAxMjFxMTc2IDAgMzAyIC0xMjJ0MTI2IC0yOTR2LTEzNmwtMTk1IC01OHpNMTU5MiA2MDJoMzI4IHYtMjY2cTAgLTE3OCAtMTI1LjUgLTMwMy41dC0zMDMuNSAtMTI1LjVxLTE3NyAwIC0zMDMgMTI0LjV0LTEyNiAzMDAuNXYyNjhsMTMxIC02MWwxOTUgNTh2LTI3MHEwIC00MiAzMCAtNzEuNXQ3MiAtMjkuNXQ3MiAyOS41dDMwIDcxLjV2Mjc1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWE1OyIgZD0iTTE0NzIgMTYwdjQ4MGgtNzA0djcwNGgtNDgwcS05MyAwIC0xNTguNSAtNjUuNXQtNjUuNSAtMTU4LjV2LTQ4MGg3MDR2LTcwNGg0ODBxOTMgMCAxNTguNSA2NS41dDY1LjUgMTU4LjV6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41IHQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhNjsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMzI4IDEyNTRoMjA0di05ODNoLTUzMnY2OTdoMzI4djI4NnpNMzI4IDQzNXYzNjloLTEyM3YtMzY5aDEyM3pNNjE0IDk2OHYtNjk3aDIwNXY2OTdoLTIwNXpNNjE0IDEyNTR2LTIwNGgyMDV2MjA0aC0yMDV6TTkwMSA5NjhoNTMzdi05NDJoLTUzM3YxNjNoMzI4djgyaC0zMjh2Njk3ek0xMjI5IDQzNXYzNjloLTEyM3YtMzY5aDEyM3pNMTUxNiA5NjhoNTMydi05NDJoLTUzMnYxNjNoMzI3djgyaC0zMjd2Njk3ek0xODQzIDQzNXYzNjloLTEyMyB2LTM2OWgxMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYTc7IiBkPSJNMTA0NiA1MTZxMCAtNjQgLTM4IC0xMDl0LTkxIC00NXEtNDMgMCAtNzAgMTV2Mjc3cTI4IDE3IDcwIDE3cTUzIDAgOTEgLTQ1LjV0MzggLTEwOS41ek03MDMgOTQ0cTAgLTY0IC0zOCAtMTA5LjV0LTkxIC00NS41cS00MyAwIC03MCAxNXYyNzdxMjggMTcgNzAgMTdxNTMgMCA5MSAtNDV0MzggLTEwOXpNMTI2NSA1MTNxMCAxMzQgLTg4IDIyOXQtMjEzIDk1cS0yMCAwIC0zOSAtM3EtMjMgLTc4IC03OCAtMTM2cS04NyAtOTUgLTIxMSAtMTAxIHYtNjM2bDIxMSA0MXYyMDZxNTEgLTE5IDExNyAtMTlxMTI1IDAgMjEzIDk1dDg4IDIyOXpNOTIyIDk0MHEwIDEzNCAtODguNSAyMjl0LTIxMy41IDk1cS03NCAwIC0xNDEgLTM2aC0xODZ2LTg0MGwyMTEgNDF2MjA2cTU1IC0xOSAxMTYgLTE5cTEyNSAwIDIxMy41IDk1dDg4LjUgMjI5ek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjAgcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYTg7IiBob3Jpei1hZHYteD0iMjAzOCIgZD0iTTEyMjIgNjA3cTc1IDMgMTQzLjUgLTIwLjV0MTE4IC01OC41dDEwMSAtOTQuNXQ4NCAtMTA4dDc1LjUgLTEyMC41cTMzIC01NiA3OC41IC0xMDl0NzUuNSAtODAuNXQ5OSAtODguNXEtNDggLTMwIC0xMDguNSAtNTcuNXQtMTM4LjUgLTU5dC0xMTQgLTQ3LjVxLTQ0IDM3IC03NCAxMTV0LTQzLjUgMTY0LjV0LTMzIDE4MC41dC00Mi41IDE2OC41dC03Mi41IDEyM3QtMTIyLjUgNDguNWwtMTAgLTJsLTYgLTRxNCAtNSAxMyAtMTQgcTYgLTUgMjggLTIzLjV0MjUuNSAtMjJ0MTkgLTE4dDE4IC0yMC41dDExLjUgLTIxdDEwLjUgLTI3LjV0NC41IC0zMXQ0IC00MC41bDEgLTMzcTEgLTI2IC0yLjUgLTU3LjV0LTcuNSAtNTJ0LTEyLjUgLTU4LjV0LTExLjUgLTUzcS0zNSAxIC0xMDEgLTkuNXQtOTggLTEwLjVxLTM5IDAgLTcyIDEwcS0yIDE2IC0yIDQ3cTAgNzQgMyA5NnEyIDEzIDMxLjUgNDEuNXQ1NyA1OXQyNi41IDUxLjVxLTI0IDIgLTQzIC0yNCBxLTM2IC01MyAtMTExLjUgLTk5LjV0LTEzNi41IC00Ni41cS0yNSAwIC03NS41IDYzdC0xMDYuNSAxMzkuNXQtODQgOTYuNXEtNiA0IC0yNyAzMHEtNDgyIC0xMTIgLTUxMyAtMTEycS0xNiAwIC0yOCAxMXQtMTIgMjdxMCAxNSA4LjUgMjYuNXQyMi41IDE0LjVsNDg2IDEwNnEtOCAxNCAtOCAyNXQ1LjUgMTcuNXQxNiAxMS41dDIwIDd0MjMgNC41dDE4LjUgNC41cTQgMSAxNS41IDcuNXQxNy41IDYuNXExNSAwIDI4IC0xNnQyMCAtMzMgcTE2MyAzNyAxNzIgMzdxMTcgMCAyOS41IC0xMXQxMi41IC0yOHEwIC0xNSAtOC41IC0yNnQtMjMuNSAtMTRsLTE4MiAtNDBsLTEgLTE2cS0xIC0yNiA4MS41IC0xMTcuNXQxMDQuNSAtOTEuNXE0NyAwIDExOSA4MHQ3MiAxMjlxMCAzNiAtMjMuNSA1M3QtNTEgMTguNXQtNTEgMTEuNXQtMjMuNSAzNHEwIDE2IDEwIDM0bC02OCAxOXE0MyA0NCA0MyAxMTdxMCAyNiAtNSA1OHE4MiAxNiAxNDQgMTZxNDQgMCA3MS41IC0xLjV0NDguNSAtOC41IHQzMSAtMTMuNXQyMC41IC0yNC41dDE1LjUgLTMzLjV0MTcgLTQ3LjV0MjQgLTYwbDUwIDI1cS0zIC00MCAtMjMgLTYwdC00Mi41IC0yMXQtNDAgLTYuNXQtMTYuNSAtMjAuNXpNMTI4MiA4NDJxLTUgNSAtMTMuNSAxNS41dC0xMiAxNC41dC0xMC41IDExLjV0LTEwIDEwLjVsLTggOHQtOC41IDcuNXQtOCA1dC04LjUgNC41cS03IDMgLTE0LjUgNXQtMjAuNSAyLjV0LTIyIDAuNWgtMzIuNWgtMzcuNXEtMTI2IDAgLTIxNyAtNDMgcTE2IDMwIDM2IDQ2LjV0NTQgMjkuNXQ2NS41IDM2dDQ2IDM2LjV0NTAgNTV0NDMuNSA1MC41cTEyIC05IDI4IC0zMS41dDMyIC0zNi41dDM4IC0xM2wxMiAxdi03NmwyMiAtMXEyNDcgOTUgMzcxIDE5MHEyOCAyMSA1MCAzOXQ0Mi41IDM3LjV0MzMgMzF0MjkuNSAzNHQyNCAzMXQyNC41IDM3dDIzIDM4dDI3IDQ3LjV0MjkuNSA1M2w3IDlxLTIgLTUzIC00MyAtMTM5cS03OSAtMTY1IC0yMDUgLTI2NHQtMzA2IC0xNDJxLTE0IC0zIC00MiAtNy41IHQtNTAgLTkuNXQtMzkgLTE0cTMgLTE5IDI0LjUgLTQ2dDIxLjUgLTM0cTAgLTExIC0yNiAtMzB6TTEwNjEgLTc5cTM5IDI2IDEzMS41IDQ3LjV0MTQ2LjUgMjEuNXE5IDAgMjIuNSAtMTUuNXQyOCAtNDIuNXQyNiAtNTB0MjQgLTUxdDE0LjUgLTMzcS0xMjEgLTQ1IC0yNDQgLTQ1cS02MSAwIC0xMjUgMTF6TTgyMiA1NjhsNDggMTJsMTA5IC0xNzdsLTczIC00OHpNMTMyMyA1MXEzIC0xNSAzIC0xNnEwIC03IC0xNy41IC0xNC41dC00NiAtMTMgdC01NCAtOS41dC01My41IC03LjV0LTMyIC00LjVsLTcgNDNxMjEgMiA2MC41IDguNXQ3MiAxMHQ2MC41IDMuNWgxNHpNODY2IDY3OWwtOTYgLTIwbC02IDE3cTEwIDEgMzIuNSA3dDM0LjUgNnExOSAwIDM1IC0xMHpNMTA2MSA0NWgzMWwxMCAtODNsLTQxIC0xMnY5NXpNMTk1MCAxNTM1djF2LTF6TTE5NTAgMTUzNWwtMSAtNWwtMiAtMmwxIDN6TTE5NTAgMTUzNWwxIDF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYTk7IiBkPSJNMTE2NyAtNTBxLTUgMTkgLTI0IDVxLTMwIC0yMiAtODcgLTM5dC0xMzEgLTE3cS0xMjkgMCAtMTkzIDQ5cS01IDQgLTEzIDRxLTExIDAgLTI2IC0xMnEtNyAtNiAtNy41IC0xNnQ3LjUgLTIwcTM0IC0zMiA4Ny41IC00NnQxMDIuNSAtMTIuNXQ5OSA0LjVxNDEgNCA4NC41IDIwLjV0NjUgMzB0MjguNSAyMC41cTEyIDEyIDcgMjl6TTExMjggNjVxLTE5IDQ3IC0zOSA2MXEtMjMgMTUgLTc2IDE1cS00NyAwIC03MSAtMTAgcS0yOSAtMTIgLTc4IC01NnEtMjYgLTI0IC0xMiAtNDRxOSAtOCAxNy41IC00LjV0MzEuNSAyMy41cTMgMiAxMC41IDguNXQxMC41IDguNXQxMCA3dDExLjUgN3QxMi41IDV0MTUgNC41dDE2LjUgMi41dDIwLjUgMXEyNyAwIDQ0LjUgLTcuNXQyMyAtMTQuNXQxMy41IC0yMnExMCAtMTcgMTIuNSAtMjB0MTIuNSAxcTIzIDEyIDE0IDM0ek0xNDgzIDM0NnEwIDIyIC01IDQ0LjV0LTE2LjUgNDV0LTM0IDM2LjV0LTUyLjUgMTQgcS0zMyAwIC05NyAtNDEuNXQtMTI5IC04My41dC0xMDEgLTQycS0yNyAtMSAtNjMuNSAxOXQtNzYgNDl0LTgzLjUgNTh0LTEwMCA0OXQtMTExIDE5cS0xMTUgLTEgLTE5NyAtNzguNXQtODQgLTE3OC41cS0yIC0xMTIgNzQgLTE2NHEyOSAtMjAgNjIuNSAtMjguNXQxMDMuNSAtOC41cTU3IDAgMTMyIDMyLjV0MTM0IDcxdDEyMCA3MC41dDkzIDMxcTI2IC0xIDY1IC0zMS41dDcxLjUgLTY3dDY4IC02Ny41dDU1LjUgLTMycTM1IC0zIDU4LjUgMTQgdDU1LjUgNjNxMjggNDEgNDIuNSAxMDF0MTQuNSAxMDZ6TTE1MzYgNTA2cTAgLTE2NCAtNjIgLTMwNC41dC0xNjYgLTIzNnQtMjQyLjUgLTE0OS41dC0yOTAuNSAtNTR0LTI5MyA1Ny41dC0yNDcuNSAxNTd0LTE3MC41IDI0MS41dC02NCAzMDJxMCA4OSAxOS41IDE3Mi41dDQ5IDE0NS41dDcwLjUgMTE4LjV0NzguNSA5NHQ3OC41IDY5LjV0NjQuNSA0Ni41dDQyLjUgMjQuNXExNCA4IDUxIDI2LjV0NTQuNSAyOC41dDQ4IDMwdDYwLjUgNDQgcTM2IDI4IDU4IDcyLjV0MzAgMTI1LjVxMTI5IC0xNTUgMTg2IC0xOTNxNDQgLTI5IDEzMCAtNjh0MTI5IC02NnEyMSAtMTMgMzkgLTI1dDYwLjUgLTQ2LjV0NzYgLTcwLjV0NzUgLTk1dDY5IC0xMjJ0NDcgLTE0OC41dDE5LjUgLTE3Ny41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWFhOyIgZD0iTTEwNzAgNDYzbC0xNjAgLTE2MGwtMTUxIC0xNTJsLTMwIC0zMHEtNjUgLTY0IC0xNTEuNSAtODd0LTE3MS41IC0ycS0xNiAtNzAgLTcyIC0xMTV0LTEyOSAtNDVxLTg1IDAgLTE0NSA2MC41dC02MCAxNDUuNXEwIDcyIDQ0LjUgMTI4dDExMy41IDcycS0yMiA4NiAxIDE3M3Q4OCAxNTJsMTIgMTJsMTUxIC0xNTJsLTExIC0xMXEtMzcgLTM3IC0zNyAtODl0MzcgLTkwcTM3IC0zNyA4OSAtMzd0ODkgMzdsMzAgMzBsMTUxIDE1MmwxNjEgMTYweiBNNzI5IDExNDVsMTIgLTEybC0xNTIgLTE1MmwtMTIgMTJxLTM3IDM3IC04OSAzN3QtODkgLTM3dC0zNyAtODkuNXQzNyAtODkuNWwyOSAtMjlsMTUyIC0xNTJsMTYwIC0xNjBsLTE1MSAtMTUybC0xNjEgMTYwbC0xNTEgMTUybC0zMCAzMHEtNjggNjcgLTkwIDE1OS41dDUgMTc5LjVxLTcwIDE1IC0xMTUgNzF0LTQ1IDEyOXEwIDg1IDYwIDE0NS41dDE0NSA2MC41cTc2IDAgMTMzLjUgLTQ5dDY5LjUgLTEyM3E4NCAyMCAxNjkuNSAtMy41IHQxNDkuNSAtODcuNXpNMTUzNiA3OHEwIC04NSAtNjAgLTE0NS41dC0xNDUgLTYwLjVxLTc0IDAgLTEzMSA0N3QtNzEgMTE4cS04NiAtMjggLTE3OS41IC02dC0xNjEuNSA5MGwtMTEgMTJsMTUxIDE1MmwxMiAtMTJxMzcgLTM3IDg5IC0zN3Q4OSAzN3QzNyA4OXQtMzcgODlsLTMwIDMwbC0xNTIgMTUybC0xNjAgMTYwbDE1MiAxNTJsMTYwIC0xNjBsMTUyIC0xNTJsMjkgLTMwcTY0IC02NCA4Ny41IC0xNTAuNXQyLjUgLTE3MS41IHE3NiAtMTEgMTI2LjUgLTY4LjV0NTAuNSAtMTM0LjV6TTE1MzQgMTIwMnEwIC03NyAtNTEgLTEzNXQtMTI3IC02OXEyNiAtODUgMyAtMTc2LjV0LTkwIC0xNTguNWwtMTIgLTEybC0xNTEgMTUybDEyIDEycTM3IDM3IDM3IDg5dC0zNyA4OXQtODkgMzd0LTg5IC0zN2wtMzAgLTMwbC0xNTIgLTE1MmwtMTYwIC0xNjBsLTE1MiAxNTJsMTYxIDE2MGwxNTIgMTUybDI5IDMwcTY3IDY3IDE1OSA4OS41dDE3OCAtMy41cTExIDc1IDY4LjUgMTI2IHQxMzUuNSA1MXE4NSAwIDE0NSAtNjAuNXQ2MCAtMTQ1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYWI7IiBkPSJNNjU0IDQ1OHEtMSAtMyAtMTIuNSAwLjV0LTMxLjUgMTEuNWwtMjAgOXEtNDQgMjAgLTg3IDQ5cS03IDUgLTQxIDMxLjV0LTM4IDI4LjVxLTY3IC0xMDMgLTEzNCAtMTgxcS04MSAtOTUgLTEwNSAtMTEwcS00IC0yIC0xOS41IC00dC0xOC41IDBxNiA0IDgyIDkycTIxIDI0IDg1LjUgMTE1dDc4LjUgMTE4cTE3IDMwIDUxIDk4LjV0MzYgNzcuNXEtOCAxIC0xMTAgLTMzcS04IC0yIC0yNy41IC03LjV0LTM0LjUgLTkuNXQtMTcgLTUgcS0yIC0yIC0yIC0xMC41dC0xIC05LjVxLTUgLTEwIC0zMSAtMTVxLTIzIC03IC00NyAwcS0xOCA0IC0yOCAyMXEtNCA2IC01IDIzcTYgMiAyNC41IDV0MjkuNSA2cTU4IDE2IDEwNSAzMnExMDAgMzUgMTAyIDM1cTEwIDIgNDMgMTkuNXQ0NCAyMS41cTkgMyAyMS41IDh0MTQuNSA1LjV0NiAtMC41cTIgLTEyIC0xIC0zM3EwIC0yIC0xMi41IC0yN3QtMjYuNSAtNTMuNXQtMTcgLTMzLjVxLTI1IC01MCAtNzcgLTEzMWw2NCAtMjggcTEyIC02IDc0LjUgLTMydDY3LjUgLTI4cTQgLTEgMTAuNSAtMjUuNXQ0LjUgLTMwLjV6TTQ0OSA5NDRxMyAtMTUgLTQgLTI4cS0xMiAtMjMgLTUwIC0zOHEtMzAgLTEyIC02MCAtMTJxLTI2IDMgLTQ5IDI2cS0xNCAxNSAtMTggNDFsMSAzcTMgLTMgMTkuNSAtNXQyNi41IDB0NTggMTZxMzYgMTIgNTUgMTRxMTcgMCAyMSAtMTd6TTExNDcgODE1bDYzIC0yMjdsLTEzOSA0MnpNMzkgMTVsNjk0IDIzMnYxMDMybC02OTQgLTIzM3YtMTAzMXogTTEyODAgMzMybDEwMiAtMzFsLTE4MSA2NTdsLTEwMCAzMWwtMjE2IC01MzZsMTAyIC0zMWw0NSAxMTBsMjExIC02NXpNNzc3IDEyOTRsNTczIC0xODR2Mzgwek0xMDg4IC0yOWwxNTggLTEzbC01NCAtMTYwbC00MCA2NnEtMTMwIC04MyAtMjc2IC0xMDhxLTU4IC0xMiAtOTEgLTEyaC04NHEtNzkgMCAtMTk5LjUgMzl0LTE4My41IDg1cS04IDcgLTggMTZxMCA4IDUgMTMuNXQxMyA1LjVxNCAwIDE4IC03LjV0MzAuNSAtMTYuNXQyMC41IC0xMSBxNzMgLTM3IDE1OS41IC02MS41dDE1Ny41IC0yNC41cTk1IDAgMTY3IDE0LjV0MTU3IDUwLjVxMTUgNyAzMC41IDE1LjV0MzQgMTl0MjguNSAxNi41ek0xNTM2IDEwNTB2LTEwNzlsLTc3NCAyNDZxLTE0IC02IC0zNzUgLTEyNy41dC0zNjggLTEyMS41cS0xMyAwIC0xOCAxM3EwIDEgLTEgM3YxMDc4cTMgOSA0IDEwcTUgNiAyMCAxMXExMDYgMzUgMTQ5IDUwdjM4NGw1NTggLTE5OHEyIDAgMTYwLjUgNTV0MzE2IDEwOC41dDE2MS41IDUzLjUgcTIwIDAgMjAgLTIxdi00MTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYWM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTI4OCAxMTUycTY2IDAgMTEzIC00N3Q0NyAtMTEzdi0xMDg4cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xMjhxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjEwODhxMCA2NiA0NyAxMTN0MTEzIDQ3aDEyOHpNMTY2NCA5ODlxNTggLTM0IDkzIC05M3QzNSAtMTI4di03NjhxMCAtMTA2IC03NSAtMTgxdC0xODEgLTc1aC04NjRxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjE1MzZxMCA0MCAyOCA2OHQ2OCAyOGg2NzJxNDAgMCA4OCAtMjB0NzYgLTQ4IGwxNTIgLTE1MnEyOCAtMjggNDggLTc2dDIwIC04OHYtMTYzek05MjggMHYxMjhxMCAxNCAtOSAyM3QtMjMgOWgtMTI4cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTEyOHEwIC0xNCA5IC0yM3QyMyAtOWgxMjhxMTQgMCAyMyA5dDkgMjN6TTkyOCAyNTZ2MTI4cTAgMTQgLTkgMjN0LTIzIDloLTEyOHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xMjhxMCAtMTQgOSAtMjN0MjMgLTloMTI4cTE0IDAgMjMgOXQ5IDIzek05MjggNTEydjEyOHEwIDE0IC05IDIzIHQtMjMgOWgtMTI4cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTEyOHEwIC0xNCA5IC0yM3QyMyAtOWgxMjhxMTQgMCAyMyA5dDkgMjN6TTExODQgMHYxMjhxMCAxNCAtOSAyM3QtMjMgOWgtMTI4cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTEyOHEwIC0xNCA5IC0yM3QyMyAtOWgxMjhxMTQgMCAyMyA5dDkgMjN6TTExODQgMjU2djEyOHEwIDE0IC05IDIzdC0yMyA5aC0xMjhxLTE0IDAgLTIzIC05dC05IC0yM3YtMTI4cTAgLTE0IDkgLTIzdDIzIC05aDEyOCBxMTQgMCAyMyA5dDkgMjN6TTExODQgNTEydjEyOHEwIDE0IC05IDIzdC0yMyA5aC0xMjhxLTE0IDAgLTIzIC05dC05IC0yM3YtMTI4cTAgLTE0IDkgLTIzdDIzIC05aDEyOHExNCAwIDIzIDl0OSAyM3pNMTQ0MCAwdjEyOHEwIDE0IC05IDIzdC0yMyA5aC0xMjhxLTE0IDAgLTIzIC05dC05IC0yM3YtMTI4cTAgLTE0IDkgLTIzdDIzIC05aDEyOHExNCAwIDIzIDl0OSAyM3pNMTQ0MCAyNTZ2MTI4cTAgMTQgLTkgMjN0LTIzIDloLTEyOCBxLTE0IDAgLTIzIC05dC05IC0yM3YtMTI4cTAgLTE0IDkgLTIzdDIzIC05aDEyOHExNCAwIDIzIDl0OSAyM3pNMTQ0MCA1MTJ2MTI4cTAgMTQgLTkgMjN0LTIzIDloLTEyOHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0xMjhxMCAtMTQgOSAtMjN0MjMgLTloMTI4cTE0IDAgMjMgOXQ5IDIzek0xNTM2IDg5NnYyNTZoLTE2MHEtNDAgMCAtNjggMjh0LTI4IDY4djE2MGgtNjQwdi01MTJoODk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWFkOyIgZD0iTTEzNDQgMTUzNnEyNiAwIDQ1IC0xOXQxOSAtNDV2LTE2NjRxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xMjgwcS0yNiAwIC00NSAxOXQtMTkgNDV2MTY2NHEwIDI2IDE5IDQ1dDQ1IDE5aDEyODB6TTUxMiAxMjQ4di02NHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3Y2NHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzek01MTIgOTkydi02NHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDkgdDkgMjN2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3pNNTEyIDczNnYtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3pNNTEyIDQ4MHYtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3pNMzg0IDE2MHY2NCBxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTM4NCA0MTZ2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTM4NCA2NzJ2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjQgcTE0IDAgMjMgOXQ5IDIzek0zODQgOTI4djY0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTY0cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek0zODQgMTE4NHY2NHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi02NHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNODk2IC05NnYxOTJxMCAxNCAtOSAyM3QtMjMgOWgtMzIwcS0xNCAwIC0yMyAtOSB0LTkgLTIzdi0xOTJxMCAtMTQgOSAtMjN0MjMgLTloMzIwcTE0IDAgMjMgOXQ5IDIzek04OTYgNDE2djY0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTY0cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek04OTYgNjcydjY0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTY0cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek04OTYgOTI4djY0IHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi02NHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNODk2IDExODR2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTExNTIgMTYwdjY0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTY0cTAgLTE0IDkgLTIzdDIzIC05aDY0IHExNCAwIDIzIDl0OSAyM3pNMTE1MiA0MTZ2NjRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTExNTIgNjcydjY0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTY0cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek0xMTUyIDkyOHY2NHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTkgdC05IC0yM3YtNjRxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTExNTIgMTE4NHY2NHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi02NHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFhZTsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTE4OCA5ODhsLTI5MiAtMjkydi04MjRxMCAtNDYgLTMzIC03OXQtNzkgLTMzdC03OSAzM3QtMzMgNzl2Mzg0aC02NHYtMzg0cTAgLTQ2IC0zMyAtNzl0LTc5IC0zM3QtNzkgMzN0LTMzIDc5djgyNGwtMjkyIDI5MnEtMjggMjggLTI4IDY4dDI4IDY4dDY4IDI4dDY4IC0yOGwyMjggLTIyOGgzNjhsMjI4IDIyOHEyOCAyOCA2OCAyOHQ2OCAtMjh0MjggLTY4dC0yOCAtNjh6TTg2NCAxMTUycTAgLTkzIC02NS41IC0xNTguNSB0LTE1OC41IC02NS41dC0xNTguNSA2NS41dC02NS41IDE1OC41dDY1LjUgMTU4LjV0MTU4LjUgNjUuNXQxNTguNSAtNjUuNXQ2NS41IC0xNTguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiMDsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNNzgwIDEwNjRxMCAtNjAgLTE5IC0xMTMuNXQtNjMgLTkyLjV0LTEwNSAtMzlxLTc2IDAgLTEzOCA1Ny41dC05MiAxMzUuNXQtMzAgMTUxcTAgNjAgMTkgMTEzLjV0NjMgOTIuNXQxMDUgMzlxNzcgMCAxMzguNSAtNTcuNXQ5MS41IC0xMzV0MzAgLTE1MS41ek00MzggNTgxcTAgLTgwIC00MiAtMTM5dC0xMTkgLTU5cS03NiAwIC0xNDEuNSA1NS41dC0xMDAuNSAxMzMuNXQtMzUgMTUycTAgODAgNDIgMTM5LjV0MTE5IDU5LjUgcTc2IDAgMTQxLjUgLTU1LjV0MTAwLjUgLTEzNHQzNSAtMTUyLjV6TTgzMiA2MDhxMTE4IDAgMjU1IC05Ny41dDIyOSAtMjM3dDkyIC0yNTQuNXEwIC00NiAtMTcgLTc2LjV0LTQ4LjUgLTQ1dC02NC41IC0yMHQtNzYgLTUuNXEtNjggMCAtMTg3LjUgNDV0LTE4Mi41IDQ1cS02NiAwIC0xOTIuNSAtNDQuNXQtMjAwLjUgLTQ0LjVxLTE4MyAwIC0xODMgMTQ2cTAgODYgNTYgMTkxLjV0MTM5LjUgMTkyLjV0MTg3LjUgMTQ2dDE5MyA1OXpNMTA3MSA4MTkgcS02MSAwIC0xMDUgMzl0LTYzIDkyLjV0LTE5IDExMy41cTAgNzQgMzAgMTUxLjV0OTEuNSAxMzV0MTM4LjUgNTcuNXE2MSAwIDEwNSAtMzl0NjMgLTkyLjV0MTkgLTExMy41cTAgLTczIC0zMCAtMTUxdC05MiAtMTM1LjV0LTEzOCAtNTcuNXpNMTUwMyA5MjNxNzcgMCAxMTkgLTU5LjV0NDIgLTEzOS41cTAgLTc0IC0zNSAtMTUydC0xMDAuNSAtMTMzLjV0LTE0MS41IC01NS41cS03NyAwIC0xMTkgNTl0LTQyIDEzOXEwIDc0IDM1IDE1Mi41IHQxMDAuNSAxMzR0MTQxLjUgNTUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiMTsiIGhvcml6LWFkdi14PSI3NjgiIGQ9Ik03MDQgMTAwOHEwIC0xNDUgLTU3IC0yNDMuNXQtMTUyIC0xMzUuNWw0NSAtODIxcTIgLTI2IC0xNiAtNDV0LTQ0IC0xOWgtMTkycS0yNiAwIC00NCAxOXQtMTYgNDVsNDUgODIxcS05NSAzNyAtMTUyIDEzNS41dC01NyAyNDMuNXEwIDEyOCA0Mi41IDI0OS41dDExNy41IDIwMHQxNjAgNzguNXQxNjAgLTc4LjV0MTE3LjUgLTIwMHQ0Mi41IC0yNDkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNODk2IC05M2w2NDAgMzQ5djYzNmwtNjQwIC0yMzN2LTc1MnpNODMyIDc3Mmw2OTggMjU0bC02OTggMjU0bC02OTggLTI1NHpNMTY2NCAxMDI0di03NjhxMCAtMzUgLTE4IC02NXQtNDkgLTQ3bC03MDQgLTM4NHEtMjggLTE2IC02MSAtMTZ0LTYxIDE2bC03MDQgMzg0cS0zMSAxNyAtNDkgNDd0LTE4IDY1djc2OHEwIDQwIDIzIDczdDYxIDQ3bDcwNCAyNTZxMjIgOCA0NCA4dDQ0IC04bDcwNCAtMjU2cTM4IC0xNCA2MSAtNDd0MjMgLTczeiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiMzsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNNjQwIC05NmwzODQgMTkydjMxNGwtMzg0IC0xNjR2LTM0MnpNNTc2IDM1OGw0MDQgMTczbC00MDQgMTczbC00MDQgLTE3M3pNMTY2NCAtOTZsMzg0IDE5MnYzMTRsLTM4NCAtMTY0di0zNDJ6TTE2MDAgMzU4bDQwNCAxNzNsLTQwNCAxNzNsLTQwNCAtMTczek0xMTUyIDY1MWwzODQgMTY1djI2NmwtMzg0IC0xNjR2LTI2N3pNMTA4OCAxMDMwbDQ0MSAxODlsLTQ0MSAxODlsLTQ0MSAtMTg5ek0yMTc2IDUxMnYtNDE2cTAgLTM2IC0xOSAtNjcgdC01MiAtNDdsLTQ0OCAtMjI0cS0yNSAtMTQgLTU3IC0xNHQtNTcgMTRsLTQ0OCAyMjRxLTUgMiAtNyA0cS0yIC0yIC03IC00bC00NDggLTIyNHEtMjUgLTE0IC01NyAtMTR0LTU3IDE0bC00NDggMjI0cS0zMyAxNiAtNTIgNDd0LTE5IDY3djQxNnEwIDM4IDIxLjUgNzB0NTYuNSA0OGw0MzQgMTg2djQwMHEwIDM4IDIxLjUgNzB0NTYuNSA0OGw0NDggMTkycTIzIDEwIDUwIDEwdDUwIC0xMGw0NDggLTE5MnEzNSAtMTYgNTYuNSAtNDh0MjEuNSAtNzAgdi00MDBsNDM0IC0xODZxMzYgLTE2IDU3IC00OHQyMSAtNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYjQ7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTE4NDggMTE5N2gtNTExdi0xMjRoNTExdjEyNHpNMTU5NiA3NzFxLTkwIDAgLTE0NiAtNTIuNXQtNjIgLTE0Mi41aDQwOHEtMTggMTk1IC0yMDAgMTk1ek0xNjEyIDE4NnE2MyAwIDEyMiAzMnQ3NiA4N2gyMjFxLTEwMCAtMzA3IC00MjcgLTMwN3EtMjE0IDAgLTM0MC41IDEzMnQtMTI2LjUgMzQ3cTAgMjA4IDEzMC41IDM0NS41dDMzNi41IDEzNy41cTEzOCAwIDI0MC41IC02OHQxNTMgLTE3OXQ1MC41IC0yNDhxMCAtMTcgLTIgLTQ3aC02NTggcTAgLTExMSA1Ny41IC0xNzEuNXQxNjYuNSAtNjAuNXpNMjc3IDIzNmgyOTZxMjA1IDAgMjA1IDE2N3EwIDE4MCAtMTk5IDE4MGgtMzAydi0zNDd6TTI3NyA3NzNoMjgxcTc4IDAgMTIzLjUgMzYuNXQ0NS41IDExMy41cTAgMTQ0IC0xOTAgMTQ0aC0yNjB2LTI5NHpNMCAxMjgyaDU5NHE4NyAwIDE1NSAtMTR0MTI2LjUgLTQ3LjV0OTAgLTk2LjV0MzEuNSAtMTU0cTAgLTE4MSAtMTcyIC0yNjNxMTE0IC0zMiAxNzIgLTExNXQ1OCAtMjA0IHEwIC03NSAtMjQuNSAtMTM2LjV0LTY2IC0xMDMuNXQtOTguNSAtNzF0LTEyMSAtNDJ0LTEzNCAtMTNoLTYxMXYxMjYweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWI1OyIgZD0iTTEyNDggMTQwOHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwek00OTkgMTA0MWgtMzcxdi03ODdoMzgycTExNyAwIDE5NyA1Ny41dDgwIDE3MC41cTAgMTU4IC0xNDMgMjAwcTEwNyA1MiAxMDcgMTY0cTAgNTcgLTE5LjUgOTYuNSB0LTU2LjUgNjAuNXQtNzkgMjkuNXQtOTcgOC41ek00NzcgNzIzaC0xNzZ2MTg0aDE2M3ExMTkgMCAxMTkgLTkwcTAgLTk0IC0xMDYgLTk0ek00ODYgMzg4aC0xODV2MjE3aDE4OXExMjQgMCAxMjQgLTExM3EwIC0xMDQgLTEyOCAtMTA0ek0xMTM2IDM1NnEtNjggMCAtMTA0IDM4dC0zNiAxMDdoNDExcTEgMTAgMSAzMHEwIDEzMiAtNzQuNSAyMjAuNXQtMjAzLjUgODguNXEtMTI4IDAgLTIxMCAtODZ0LTgyIC0yMTZxMCAtMTM1IDc5IC0yMTcgdDIxMyAtODJxMjA1IDAgMjY3IDE5MWgtMTM4cS0xMSAtMzQgLTQ3LjUgLTU0dC03NS41IC0yMHpNMTEyNiA3MjJxMTEzIDAgMTI0IC0xMjJoLTI1NHE0IDU2IDM5IDg5dDkxIDMzek05NjQgOTg4aDMxOXYtNzdoLTMxOXY3N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiNjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTU4MiA5NTRxMCAtMTAxIC03MS41IC0xNzIuNXQtMTcyLjUgLTcxLjV0LTE3Mi41IDcxLjV0LTcxLjUgMTcyLjV0NzEuNSAxNzIuNXQxNzIuNSA3MS41dDE3Mi41IC03MS41dDcxLjUgLTE3Mi41ek04MTIgMjEycTAgMTA0IC03MyAxNzd0LTE3NyA3M3EtMjcgMCAtNTQgLTZsMTA0IC00MnE3NyAtMzEgMTA5LjUgLTEwNi41dDEuNSAtMTUxLjVxLTMxIC03NyAtMTA3IC0xMDl0LTE1MiAtMXEtMjEgOCAtNjIgMjQuNXQtNjEgMjQuNSBxMzIgLTYwIDkxIC05Ni41dDEzMCAtMzYuNXExMDQgMCAxNzcgNzN0NzMgMTc3ek0xNjQyIDk1M3EwIDEyNiAtODkuNSAyMTUuNXQtMjE1LjUgODkuNXEtMTI3IDAgLTIxNi41IC04OS41dC04OS41IC0yMTUuNXEwIC0xMjcgODkuNSAtMjE2dDIxNi41IC04OXExMjYgMCAyMTUuNSA4OXQ4OS41IDIxNnpNMTc5MiA5NTNxMCAtMTg5IC0xMzMuNSAtMzIydC0zMjEuNSAtMTMzbC00MzcgLTMxOXEtMTIgLTEyOSAtMTA5IC0yMTh0LTIyOSAtODkgcS0xMjEgMCAtMjE0IDc2dC0xMTggMTkybC0yMzAgOTJ2NDI5bDM4OSAtMTU3cTc5IDQ4IDE3MyA0OHExMyAwIDM1IC0ybDI4NCA0MDdxMiAxODcgMTM1LjUgMzE5dDMyMC41IDEzMnExODggMCAzMjEuNSAtMTMzLjV0MTMzLjUgLTMyMS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWI3OyIgZD0iTTEyNDIgODg5cTAgODAgLTU3IDEzNi41dC0xMzcgNTYuNXQtMTM2LjUgLTU3dC01Ni41IC0xMzZxMCAtODAgNTYuNSAtMTM2LjV0MTM2LjUgLTU2LjV0MTM3IDU2LjV0NTcgMTM2LjV6TTYzMiAzMDFxMCAtODMgLTU4IC0xNDAuNXQtMTQwIC01Ny41cS01NiAwIC0xMDMgMjl0LTcyIDc3cTUyIC0yMCA5OCAtNDBxNjAgLTI0IDEyMCAxLjV0ODUgODYuNXEyNCA2MCAtMS41IDEyMHQtODYuNSA4NGwtODIgMzNxMjIgNSA0MiA1IHE4MiAwIDE0MCAtNTcuNXQ1OCAtMTQwLjV6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djE1M2wxNzIgLTY5cTIwIC05MiA5My41IC0xNTJ0MTY4LjUgLTYwcTEwNCAwIDE4MSA3MHQ4NyAxNzNsMzQ1IDI1MnExNTAgMCAyNTUuNSAxMDUuNXQxMDUuNSAyNTQuNXEwIDE1MCAtMTA1LjUgMjU1LjV0LTI1NS41IDEwNS41IHEtMTQ4IDAgLTI1MyAtMTA0LjV0LTEwNyAtMjUyLjVsLTIyNSAtMzIycS05IDEgLTI4IDFxLTc1IDAgLTEzNyAtMzdsLTI5NyAxMTl2NDY4cTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6TTEyODkgODg3cTAgLTEwMCAtNzEgLTE3MC41dC0xNzEgLTcwLjV0LTE3MC41IDcwLjV0LTcwLjUgMTcwLjV0NzAuNSAxNzF0MTcwLjUgNzFxMTAxIDAgMTcxLjUgLTcwLjV0NzAuNSAtMTcxLjV6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWI4OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04MzYgMzY3bC0xNSAtMzY4bC0yIC0yMmwtNDIwIDI5cS0zNiAzIC02NyAzMS41dC00NyA2NS41cS0xMSAyNyAtMTQuNSA1NXQ0IDY1dDEyIDU1dDIxLjUgNjR0MTkgNTNxNzggLTEyIDUwOSAtMjh6TTQ0OSA5NTNsMTgwIC0zNzlsLTE0NyA5MnEtNjMgLTcyIC0xMTEuNSAtMTQ0LjV0LTcyLjUgLTEyNXQtMzkuNSAtOTQuNXQtMTguNSAtNjNsLTQgLTIxbC0xOTAgMzU3cS0xNyAyNiAtMTggNTZ0NiA0N2w4IDE4cTM1IDYzIDExNCAxODggbC0xNDAgODZ6TTE2ODAgNDM2bC0xODggLTM1OXEtMTIgLTI5IC0zNi41IC00Ni41dC00My41IC0yMC41bC0xOCAtNHEtNzEgLTcgLTIxOSAtMTJsOCAtMTY0bC0yMzAgMzY3bDIxMSAzNjJsNyAtMTczcTE3MCAtMTYgMjgzIC01dDE3MCAzM3pNODk1IDEzNjBxLTQ3IC02MyAtMjY1IC00MzVsLTMxNyAxODdsLTE5IDEybDIyNSAzNTZxMjAgMzEgNjAgNDV0ODAgMTBxMjQgLTIgNDguNSAtMTJ0NDIgLTIxdDQxLjUgLTMzdDM2IC0zNC41IHQzNiAtMzkuNXQzMiAtMzV6TTE1NTAgMTA1M2wyMTIgLTM2M3ExOCAtMzcgMTIuNSAtNzZ0LTI3LjUgLTc0cS0xMyAtMjAgLTMzIC0zN3QtMzggLTI4dC00OC41IC0yMnQtNDcgLTE2dC01MS41IC0xNHQtNDYgLTEycS0zNCA3MiAtMjY1IDQzNmwzMTMgMTk1ek0xNDA3IDEyNzlsMTQyIDgzbC0yMjAgLTM3M2wtNDE5IDIwbDE1MSA4NnEtMzQgODkgLTc1IDE2NnQtNzUuNSAxMjMuNXQtNjQuNSA4MHQtNDcgNDYuNWwtMTcgMTNsNDA1IC0xIHEzMSAzIDU4IC0xMC41dDM5IC0yOC41bDExIC0xNXEzOSAtNjEgMTEyIC0xOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYjk7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTQ4MCA0NDhxMCA2NiAtNDcgMTEzdC0xMTMgNDd0LTExMyAtNDd0LTQ3IC0xMTN0NDcgLTExM3QxMTMgLTQ3dDExMyA0N3Q0NyAxMTN6TTUxNiA3NjhoMTAxNmwtODkgMzU3cS0yIDggLTE0IDE3LjV0LTIxIDkuNWgtNzY4cS05IDAgLTIxIC05LjV0LTE0IC0xNy41ek0xODg4IDQ0OHEwIDY2IC00NyAxMTN0LTExMyA0N3QtMTEzIC00N3QtNDcgLTExM3Q0NyAtMTEzdDExMyAtNDd0MTEzIDQ3dDQ3IDExM3pNMjA0OCA1NDR2LTM4NCBxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ2LTEyOHEwIC04MCAtNTYgLTEzNnQtMTM2IC01NnQtMTM2IDU2dC01NiAxMzZ2MTI4aC0xMDI0di0xMjhxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2djEyOGgtOTZxLTE0IDAgLTIzIDl0LTkgMjN2Mzg0cTAgOTMgNjUuNSAxNTguNXQxNTguNSA2NS41aDI4bDEwNSA0MTlxMjMgOTQgMTA0IDE1Ny41dDE3OSA2My41aDc2OHE5OCAwIDE3OSAtNjMuNXQxMDQgLTE1Ny41IGwxMDUgLTQxOWgyOHE5MyAwIDE1OC41IC02NS41dDY1LjUgLTE1OC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWJhOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xODI0IDY0MHE5MyAwIDE1OC41IC02NS41dDY1LjUgLTE1OC41di0zODRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ2LTY0cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnY2NGgtMTAyNHYtNjRxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2djY0aC05NnEtMTQgMCAtMjMgOXQtOSAyM3YzODRxMCA5MyA2NS41IDE1OC41dDE1OC41IDY1LjVoMjhsMTA1IDQxOXEyMyA5NCAxMDQgMTU3LjUgdDE3OSA2My41aDEyOHYyMjRxMCAxNCA5IDIzdDIzIDloNDQ4cTE0IDAgMjMgLTl0OSAtMjN2LTIyNGgxMjhxOTggMCAxNzkgLTYzLjV0MTA0IC0xNTcuNWwxMDUgLTQxOWgyOHpNMzIwIDE2MHE2NiAwIDExMyA0N3Q0NyAxMTN0LTQ3IDExM3QtMTEzIDQ3dC0xMTMgLTQ3dC00NyAtMTEzdDQ3IC0xMTN0MTEzIC00N3pNNTE2IDY0MGgxMDE2bC04OSAzNTdxLTIgOCAtMTQgMTcuNXQtMjEgOS41aC03NjhxLTkgMCAtMjEgLTkuNXQtMTQgLTE3LjV6IE0xNzI4IDE2MHE2NiAwIDExMyA0N3Q0NyAxMTN0LTQ3IDExM3QtMTEzIDQ3dC0xMTMgLTQ3dC00NyAtMTEzdDQ3IC0xMTN0MTEzIC00N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiYjsiIGQ9Ik0xNTA0IDY0cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtNDYycTEgLTE3IDYgLTg3LjV0NSAtMTA4LjVxMCAtMjUgLTE4IC00Mi41dC00MyAtMTcuNWgtMzIwcS0yNSAwIC00MyAxNy41dC0xOCA0Mi41cTAgMzggNSAxMDguNXQ2IDg3LjVoLTQ2MnEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1bDQwMiA0MDNoLTIyOXEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1bDQwMiA0MDNoLTE5N3EtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1bDM4NCAzODQgcTE5IDE5IDQ1IDE5dDQ1IC0xOWwzODQgLTM4NHExOSAtMTkgMTkgLTQ1dC0xOSAtNDV0LTQ1IC0xOWgtMTk3bDQwMiAtNDAzcTE5IC0xOSAxOSAtNDV0LTE5IC00NXQtNDUgLTE5aC0yMjlsNDAyIC00MDNxMTkgLTE5IDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiYzsiIGQ9Ik0xMTI3IDMyNnEwIDMyIC0zMCA1MXEtMTkzIDExNSAtNDQ3IDExNXEtMTMzIDAgLTI4NyAtMzRxLTQyIC05IC00MiAtNTJxMCAtMjAgMTMuNSAtMzQuNXQzNS41IC0xNC41cTUgMCAzNyA4cTEzMiAyNyAyNDMgMjdxMjI2IDAgMzk3IC0xMDNxMTkgLTExIDMzIC0xMXExOSAwIDMzIDEzLjV0MTQgMzQuNXpNMTIyMyA1NDFxMCA0MCAtMzUgNjFxLTIzNyAxNDEgLTU0OCAxNDFxLTE1MyAwIC0zMDMgLTQycS00OCAtMTMgLTQ4IC02NCBxMCAtMjUgMTcuNSAtNDIuNXQ0Mi41IC0xNy41cTcgMCAzNyA4cTEyMiAzMyAyNTEgMzNxMjc5IDAgNDg4IC0xMjRxMjQgLTEzIDM4IC0xM3EyNSAwIDQyLjUgMTcuNXQxNy41IDQyLjV6TTEzMzEgNzg5cTAgNDcgLTQwIDcwcS0xMjYgNzMgLTI5MyAxMTAuNXQtMzQzIDM3LjVxLTIwNCAwIC0zNjQgLTQ3cS0yMyAtNyAtMzguNSAtMjUuNXQtMTUuNSAtNDguNXEwIC0zMSAyMC41IC01MnQ1MS41IC0yMXExMSAwIDQwIDhxMTMzIDM3IDMwNyAzNyBxMTU5IDAgMzA5LjUgLTM0dDI1My41IC05NXEyMSAtMTIgNDAgLTEycTI5IDAgNTAuNSAyMC41dDIxLjUgNTEuNXpNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYmQ7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTEwMjQgMTIzM2wtMzAzIC01ODJsMjQgLTMxaDI3OXYtNDE1aC01MDdsLTQ0IC0zMGwtMTQyIC0yNzNsLTMwIC0zMGgtMzAxdjMwM2wzMDMgNTgzbC0yNCAzMGgtMjc5djQxNWg1MDdsNDQgMzBsMTQyIDI3M2wzMCAzMGgzMDF2LTMwM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFiZTsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNNzg0IDE2NGwxNiAyNDFsLTE2IDUyM3EtMSAxMCAtNy41IDE3dC0xNi41IDdxLTkgMCAtMTYgLTd0LTcgLTE3bC0xNCAtNTIzbDE0IC0yNDFxMSAtMTAgNy41IC0xNi41dDE1LjUgLTYuNXEyMiAwIDI0IDIzek0xMDgwIDE5M2wxMSAyMTFsLTEyIDU4NnEwIDE2IC0xMyAyNHEtOCA1IC0xNiA1dC0xNiAtNXEtMTMgLTggLTEzIC0yNGwtMSAtNmwtMTAgLTU3OXEwIC0xIDExIC0yMzZ2LTFxMCAtMTAgNiAtMTdxOSAtMTEgMjMgLTExIHExMSAwIDIwIDlxOSA3IDkgMjB6TTM1IDUzM2wyMCAtMTI4bC0yMCAtMTI2cS0yIC05IC05IC05dC05IDlsLTE3IDEyNmwxNyAxMjhxMiA5IDkgOXQ5IC05ek0xMjEgNjEybDI2IC0yMDdsLTI2IC0yMDNxLTIgLTkgLTEwIC05cS05IDAgLTkgMTBsLTIzIDIwMmwyMyAyMDdxMCA5IDkgOXE4IDAgMTAgLTl6TTQwMSAxNTl6TTIxMyA2NTBsMjUgLTI0NWwtMjUgLTIzN3EwIC0xMSAtMTEgLTExcS0xMCAwIC0xMiAxMWwtMjEgMjM3bDIxIDI0NSBxMiAxMiAxMiAxMnExMSAwIDExIC0xMnpNMzA3IDY1N2wyMyAtMjUybC0yMyAtMjQ0cS0yIC0xMyAtMTQgLTEzcS0xMyAwIC0xMyAxM2wtMjEgMjQ0bDIxIDI1MnEwIDEzIDEzIDEzcTEyIDAgMTQgLTEzek00MDEgNjM5bDIxIC0yMzRsLTIxIC0yNDZxLTIgLTE2IC0xNiAtMTZxLTYgMCAtMTAuNSA0LjV0LTQuNSAxMS41bC0yMCAyNDZsMjAgMjM0cTAgNiA0LjUgMTAuNXQxMC41IDQuNXExNCAwIDE2IC0xNXpNNzg0IDE2NHpNNDk1IDc4NSBsMjEgLTM4MGwtMjEgLTI0NnEwIC03IC01IC0xMi41dC0xMiAtNS41cS0xNiAwIC0xOCAxOGwtMTggMjQ2bDE4IDM4MHEyIDE4IDE4IDE4cTcgMCAxMiAtNS41dDUgLTEyLjV6TTU4OSA4NzFsMTkgLTQ2OGwtMTkgLTI0NHEwIC04IC01LjUgLTEzLjV0LTEzLjUgLTUuNXEtMTggMCAtMjAgMTlsLTE2IDI0NGwxNiA0NjhxMiAxOSAyMCAxOXE4IDAgMTMuNSAtNS41dDUuNSAtMTMuNXpNNjg3IDkxMWwxOCAtNTA2bC0xOCAtMjQyIHEtMiAtMjEgLTIyIC0yMXEtMTkgMCAtMjEgMjFsLTE2IDI0MmwxNiA1MDZxMCA5IDYuNSAxNS41dDE0LjUgNi41cTkgMCAxNSAtNi41dDcgLTE1LjV6TTEwNzkgMTY5djB2MHpNODgxIDkxNWwxNSAtNTEwbC0xNSAtMjM5cTAgLTEwIC03LjUgLTE3LjV0LTE3LjUgLTcuNXQtMTcgN3QtOCAxOGwtMTQgMjM5bDE0IDUxMHEwIDExIDcuNSAxOHQxNy41IDd0MTcuNSAtN3Q3LjUgLTE4ek05ODAgODk2bDE0IC00OTJsLTE0IC0yMzZxMCAtMTEgLTggLTE5IHQtMTkgLTh0LTE5IDh0LTkgMTlsLTEyIDIzNmwxMiA0OTJxMSAxMiA5IDIwdDE5IDh0MTguNSAtOHQ4LjUgLTIwek0xMTkyIDQwNGwtMTQgLTIzMXYwcTAgLTEzIC05IC0yMnQtMjIgLTl0LTIyIDl0LTEwIDIybC02IDExNGwtNiAxMTdsMTIgNjM2djNxMiAxNSAxMiAyNHE5IDcgMjAgN3E4IDAgMTUgLTVxMTQgLTggMTYgLTI2ek0yMzA0IDQyM3EwIC0xMTcgLTgzIC0xOTkuNXQtMjAwIC04Mi41aC03ODZxLTEzIDIgLTIyIDExdC05IDIydjg5OSBxMCAyMyAyOCAzM3E4NSAzNCAxODEgMzRxMTk1IDAgMzM4IC0xMzEuNXQxNjAgLTMyMy41cTUzIDIyIDExMCAyMnExMTcgMCAyMDAgLTgzdDgzIC0yMDF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYzA7IiBkPSJNNzY4IDc2OHEyMzcgMCA0NDMgNDN0MzI1IDEyN3YtMTcwcTAgLTY5IC0xMDMgLTEyOHQtMjgwIC05My41dC0zODUgLTM0LjV0LTM4NSAzNC41dC0yODAgOTMuNXQtMTAzIDEyOHYxNzBxMTE5IC04NCAzMjUgLTEyN3Q0NDMgLTQzek03NjggMHEyMzcgMCA0NDMgNDN0MzI1IDEyN3YtMTcwcTAgLTY5IC0xMDMgLTEyOHQtMjgwIC05My41dC0zODUgLTM0LjV0LTM4NSAzNC41dC0yODAgOTMuNXQtMTAzIDEyOHYxNzBxMTE5IC04NCAzMjUgLTEyNyB0NDQzIC00M3pNNzY4IDM4NHEyMzcgMCA0NDMgNDN0MzI1IDEyN3YtMTcwcTAgLTY5IC0xMDMgLTEyOHQtMjgwIC05My41dC0zODUgLTM0LjV0LTM4NSAzNC41dC0yODAgOTMuNXQtMTAzIDEyOHYxNzBxMTE5IC04NCAzMjUgLTEyN3Q0NDMgLTQzek03NjggMTUzNnEyMDggMCAzODUgLTM0LjV0MjgwIC05My41dDEwMyAtMTI4di0xMjhxMCAtNjkgLTEwMyAtMTI4dC0yODAgLTkzLjV0LTM4NSAtMzQuNXQtMzg1IDM0LjV0LTI4MCA5My41IHQtMTAzIDEyOHYxMjhxMCA2OSAxMDMgMTI4dDI4MCA5My41dDM4NSAzNC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWMxOyIgZD0iTTE0NjggMTE1NnEyOCAtMjggNDggLTc2dDIwIC04OHYtMTE1MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTEzNDRxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjAwcTAgNDAgMjggNjh0NjggMjhoODk2cTQwIDAgODggLTIwdDc2IC00OHpNMTAyNCAxNDAwdi0zNzZoMzc2cS0xMCAyOSAtMjIgNDFsLTMxMyAzMTNxLTEyIDEyIC00MSAyMnpNMTQwOCAtMTI4djEwMjRoLTQxNnEtNDAgMCAtNjggMjh0LTI4IDY4djQxNmgtNzY4di0xNTM2aDEyODB6IE04OTQgNDY1cTMzIC0yNiA4NCAtNTZxNTkgNyAxMTcgN3ExNDcgMCAxNzcgLTQ5cTE2IC0yMiAyIC01MnEwIC0xIC0xIC0ybC0yIC0ydi0xcS02IC0zOCAtNzEgLTM4cS00OCAwIC0xMTUgMjB0LTEzMCA1M3EtMjIxIC0yNCAtMzkyIC04M3EtMTUzIC0yNjIgLTI0MiAtMjYycS0xNSAwIC0yOCA3bC0yNCAxMnEtMSAxIC02IDVxLTEwIDEwIC02IDM2cTkgNDAgNTYgOTEuNXQxMzIgOTYuNXExNCA5IDIzIC02cTIgLTIgMiAtNHE1MiA4NSAxMDcgMTk3IHE2OCAxMzYgMTA0IDI2MnEtMjQgODIgLTMwLjUgMTU5LjV0Ni41IDEyNy41cTExIDQwIDQyIDQwaDIxaDFxMjMgMCAzNSAtMTVxMTggLTIxIDkgLTY4cS0yIC02IC00IC04cTEgLTMgMSAtOHYtMzBxLTIgLTEyMyAtMTQgLTE5MnE1NSAtMTY0IDE0NiAtMjM4ek0zMTggNTRxNTIgMjQgMTM3IDE1OHEtNTEgLTQwIC04Ny41IC04NHQtNDkuNSAtNzR6TTcxNiA5NzRxLTE1IC00MiAtMiAtMTMycTEgNyA3IDQ0cTAgMyA3IDQzcTEgNCA0IDggcS0xIDEgLTEgMnQtMC41IDEuNXQtMC41IDEuNXEtMSAyMiAtMTMgMzZxMCAtMSAtMSAtMnYtMnpNNTkyIDMxM3ExMzUgNTQgMjg0IDgxcS0yIDEgLTEzIDkuNXQtMTYgMTMuNXEtNzYgNjcgLTEyNyAxNzZxLTI3IC04NiAtODMgLTE5N3EtMzAgLTU2IC00NSAtODN6TTEyMzggMzI5cS0yNCAyNCAtMTQwIDI0cTc2IC0yOCAxMjQgLTI4cTE0IDAgMTggMXEwIDEgLTIgM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjMjsiIGQ9Ik0xNDY4IDExNTZxMjggLTI4IDQ4IC03NnQyMCAtODh2LTExNTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTYwMHEwIDQwIDI4IDY4dDY4IDI4aDg5NnE0MCAwIDg4IC0yMHQ3NiAtNDh6TTEwMjQgMTQwMHYtMzc2aDM3NnEtMTAgMjkgLTIyIDQxbC0zMTMgMzEzcS0xMiAxMiAtNDEgMjJ6TTE0MDggLTEyOHYxMDI0aC00MTZxLTQwIDAgLTY4IDI4dC0yOCA2OHY0MTZoLTc2OHYtMTUzNmgxMjgweiBNMjMzIDc2OHYtMTA3aDcwbDE2NCAtNjYxaDE1OWwxMjggNDg1cTcgMjAgMTAgNDZxMiAxNiAyIDI0aDRsMyAtMjRxMSAtMyAzLjUgLTIwdDUuNSAtMjZsMTI4IC00ODVoMTU5bDE2NCA2NjFoNzB2MTA3aC0zMDB2LTEwN2g5MGwtOTkgLTQzOHEtNSAtMjAgLTcgLTQ2bC0yIC0yMWgtNGwtMyAyMXEtMSA1IC00IDIxdC01IDI1bC0xNDQgNTQ1aC0xMTRsLTE0NCAtNTQ1cS0yIC05IC00LjUgLTI0LjV0LTMuNSAtMjEuNWwtNCAtMjFoLTRsLTIgMjEgcS0yIDI2IC03IDQ2bC05OSA0MzhoOTB2MTA3aC0zMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYzM7IiBkPSJNMTQ2OCAxMTU2cTI4IC0yOCA0OCAtNzZ0MjAgLTg4di0xMTUycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTM0NHEtNDAgMCAtNjggMjh0LTI4IDY4djE2MDBxMCA0MCAyOCA2OHQ2OCAyOGg4OTZxNDAgMCA4OCAtMjB0NzYgLTQ4ek0xMDI0IDE0MDB2LTM3NmgzNzZxLTEwIDI5IC0yMiA0MWwtMzEzIDMxM3EtMTIgMTIgLTQxIDIyek0xNDA4IC0xMjh2MTAyNGgtNDE2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC03Njh2LTE1MzZoMTI4MHogTTQyOSAxMDZ2LTEwNmgyODF2MTA2aC03NWwxMDMgMTYxcTUgNyAxMCAxNi41dDcuNSAxMy41dDMuNSA0aDJxMSAtNCA1IC0xMHEyIC00IDQuNSAtNy41dDYgLTh0Ni41IC04LjVsMTA3IC0xNjFoLTc2di0xMDZoMjkxdjEwNmgtNjhsLTE5MiAyNzNsMTk1IDI4Mmg2N3YxMDdoLTI3OXYtMTA3aDc0bC0xMDMgLTE1OXEtNCAtNyAtMTAgLTE2LjV0LTkgLTEzLjVsLTIgLTNoLTJxLTEgNCAtNSAxMHEtNiAxMSAtMTcgMjNsLTEwNiAxNTloNzZ2MTA3IGgtMjkwdi0xMDdoNjhsMTg5IC0yNzJsLTE5NCAtMjgzaC02OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjNDsiIGQ9Ik0xNDY4IDExNTZxMjggLTI4IDQ4IC03NnQyMCAtODh2LTExNTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTYwMHEwIDQwIDI4IDY4dDY4IDI4aDg5NnE0MCAwIDg4IC0yMHQ3NiAtNDh6TTEwMjQgMTQwMHYtMzc2aDM3NnEtMTAgMjkgLTIyIDQxbC0zMTMgMzEzcS0xMiAxMiAtNDEgMjJ6TTE0MDggLTEyOHYxMDI0aC00MTZxLTQwIDAgLTY4IDI4dC0yOCA2OHY0MTZoLTc2OHYtMTUzNmgxMjgweiBNNDE2IDEwNnYtMTA2aDMyN3YxMDZoLTkzdjE2N2gxMzdxNzYgMCAxMTggMTVxNjcgMjMgMTA2LjUgODd0MzkuNSAxNDZxMCA4MSAtMzcgMTQxdC0xMDAgODdxLTQ4IDE5IC0xMzAgMTloLTM2OHYtMTA3aDkydi01NTVoLTkyek03NjkgMzg2aC0xMTl2MjY4aDEyMHE1MiAwIDgzIC0xOHE1NiAtMzMgNTYgLTExNXEwIC04OSAtNjIgLTEyMHEtMzEgLTE1IC03OCAtMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYzU7IiBkPSJNMTQ2OCAxMTU2cTI4IC0yOCA0OCAtNzZ0MjAgLTg4di0xMTUycTAgLTQwIC0yOCAtNjh0LTY4IC0yOGgtMTM0NHEtNDAgMCAtNjggMjh0LTI4IDY4djE2MDBxMCA0MCAyOCA2OHQ2OCAyOGg4OTZxNDAgMCA4OCAtMjB0NzYgLTQ4ek0xMDI0IDE0MDB2LTM3NmgzNzZxLTEwIDI5IC0yMiA0MWwtMzEzIDMxM3EtMTIgMTIgLTQxIDIyek0xNDA4IC0xMjh2MTAyNGgtNDE2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC03Njh2LTE1MzZoMTI4MHogTTEyODAgMzIwdi0zMjBoLTEwMjR2MTkybDE5MiAxOTJsMTI4IC0xMjhsMzg0IDM4NHpNNDQ4IDUxMnEtODAgMCAtMTM2IDU2dC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ0LTU2IC0xMzZ0LTEzNiAtNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxYzY7IiBkPSJNNjQwIDExNTJ2MTI4aC0xMjh2LTEyOGgxMjh6TTc2OCAxMDI0djEyOGgtMTI4di0xMjhoMTI4ek02NDAgODk2djEyOGgtMTI4di0xMjhoMTI4ek03NjggNzY4djEyOGgtMTI4di0xMjhoMTI4ek0xNDY4IDExNTZxMjggLTI4IDQ4IC03NnQyMCAtODh2LTExNTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTYwMHEwIDQwIDI4IDY4dDY4IDI4aDg5NnE0MCAwIDg4IC0yMHQ3NiAtNDh6TTEwMjQgMTQwMCB2LTM3NmgzNzZxLTEwIDI5IC0yMiA0MWwtMzEzIDMxM3EtMTIgMTIgLTQxIDIyek0xNDA4IC0xMjh2MTAyNGgtNDE2cS00MCAwIC02OCAyOHQtMjggNjh2NDE2aC0xMjh2LTEyOGgtMTI4djEyOGgtNTEydi0xNTM2aDEyODB6TTc4MSA1OTNsMTA3IC0zNDlxOCAtMjcgOCAtNTJxMCAtODMgLTcyLjUgLTEzNy41dC0xODMuNSAtNTQuNXQtMTgzLjUgNTQuNXQtNzIuNSAxMzcuNXEwIDI1IDggNTJxMjEgNjMgMTIwIDM5NnYxMjhoMTI4di0xMjhoNzkgcTIyIDAgMzkgLTEzdDIzIC0zNHpNNjQwIDEyOHE1MyAwIDkwLjUgMTl0MzcuNSA0NXQtMzcuNSA0NXQtOTAuNSAxOXQtOTAuNSAtMTl0LTM3LjUgLTQ1dDM3LjUgLTQ1dDkwLjUgLTE5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWM3OyIgZD0iTTE0NjggMTE1NnEyOCAtMjggNDggLTc2dDIwIC04OHYtMTE1MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTEzNDRxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjAwcTAgNDAgMjggNjh0NjggMjhoODk2cTQwIDAgODggLTIwdDc2IC00OHpNMTAyNCAxNDAwdi0zNzZoMzc2cS0xMCAyOSAtMjIgNDFsLTMxMyAzMTNxLTEyIDEyIC00MSAyMnpNMTQwOCAtMTI4djEwMjRoLTQxNnEtNDAgMCAtNjggMjh0LTI4IDY4djQxNmgtNzY4di0xNTM2aDEyODB6IE02MjAgNjg2cTIwIC04IDIwIC0zMHYtNTQ0cTAgLTIyIC0yMCAtMzBxLTggLTIgLTEyIC0ycS0xMiAwIC0yMyA5bC0xNjYgMTY3aC0xMzFxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDEzMWwxNjYgMTY3cTE2IDE1IDM1IDd6TTEwMzcgLTNxMzEgMCA1MCAyNHExMjkgMTU5IDEyOSAzNjN0LTEyOSAzNjNxLTE2IDIxIC00MyAyNHQtNDcgLTE0cS0yMSAtMTcgLTIzLjUgLTQzLjV0MTQuNSAtNDcuNSBxMTAwIC0xMjMgMTAwIC0yODJ0LTEwMCAtMjgycS0xNyAtMjEgLTE0LjUgLTQ3LjV0MjMuNSAtNDIuNXExOCAtMTUgNDAgLTE1ek04MjYgMTQ1cTI3IDAgNDcgMjBxODcgOTMgODcgMjE5dC04NyAyMTlxLTE4IDE5IC00NSAyMHQtNDYgLTE3dC0yMCAtNDQuNXQxOCAtNDYuNXE1MiAtNTcgNTIgLTEzMXQtNTIgLTEzMXEtMTkgLTIwIC0xOCAtNDYuNXQyMCAtNDQuNXEyMCAtMTcgNDQgLTE3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWM4OyIgZD0iTTE0NjggMTE1NnEyOCAtMjggNDggLTc2dDIwIC04OHYtMTE1MnEwIC00MCAtMjggLTY4dC02OCAtMjhoLTEzNDRxLTQwIDAgLTY4IDI4dC0yOCA2OHYxNjAwcTAgNDAgMjggNjh0NjggMjhoODk2cTQwIDAgODggLTIwdDc2IC00OHpNMTAyNCAxNDAwdi0zNzZoMzc2cS0xMCAyOSAtMjIgNDFsLTMxMyAzMTNxLTEyIDEyIC00MSAyMnpNMTQwOCAtMTI4djEwMjRoLTQxNnEtNDAgMCAtNjggMjh0LTI4IDY4djQxNmgtNzY4di0xNTM2aDEyODB6IE03NjggNzY4cTUyIDAgOTAgLTM4dDM4IC05MHYtMzg0cTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMzg0cS01MiAwIC05MCAzOHQtMzggOTB2Mzg0cTAgNTIgMzggOTB0OTAgMzhoMzg0ek0xMjYwIDc2NnEyMCAtOCAyMCAtMzB2LTU3NnEwIC0yMiAtMjAgLTMwcS04IC0yIC0xMiAtMnEtMTQgMCAtMjMgOWwtMjY1IDI2NnY5MGwyNjUgMjY2cTkgOSAyMyA5cTQgMCAxMiAtMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjOTsiIGQ9Ik0xNDY4IDExNTZxMjggLTI4IDQ4IC03NnQyMCAtODh2LTExNTJxMCAtNDAgLTI4IC02OHQtNjggLTI4aC0xMzQ0cS00MCAwIC02OCAyOHQtMjggNjh2MTYwMHEwIDQwIDI4IDY4dDY4IDI4aDg5NnE0MCAwIDg4IC0yMHQ3NiAtNDh6TTEwMjQgMTQwMHYtMzc2aDM3NnEtMTAgMjkgLTIyIDQxbC0zMTMgMzEzcS0xMiAxMiAtNDEgMjJ6TTE0MDggLTEyOHYxMDI0aC00MTZxLTQwIDAgLTY4IDI4dC0yOCA2OHY0MTZoLTc2OHYtMTUzNmgxMjgweiBNNDgwIDc2OHE4IDExIDIxIDEyLjV0MjQgLTYuNWw1MSAtMzhxMTEgLTggMTIuNSAtMjF0LTYuNSAtMjRsLTE4MiAtMjQzbDE4MiAtMjQzcTggLTExIDYuNSAtMjR0LTEyLjUgLTIxbC01MSAtMzhxLTExIC04IC0yNCAtNi41dC0yMSAxMi41bC0yMjYgMzAxcS0xNCAxOSAwIDM4ek0xMjgyIDQ2N3ExNCAtMTkgMCAtMzhsLTIyNiAtMzAxcS04IC0xMSAtMjEgLTEyLjV0LTI0IDYuNWwtNTEgMzhxLTExIDggLTEyLjUgMjF0Ni41IDI0bDE4MiAyNDMgbC0xODIgMjQzcS04IDExIC02LjUgMjR0MTIuNSAyMWw1MSAzOHExMSA4IDI0IDYuNXQyMSAtMTIuNXpNNjYyIDZxLTEzIDIgLTIwLjUgMTN0LTUuNSAyNGwxMzggODMxcTIgMTMgMTMgMjAuNXQyNCA1LjVsNjMgLTEwcTEzIC0yIDIwLjUgLTEzdDUuNSAtMjRsLTEzOCAtODMxcS0yIC0xMyAtMTMgLTIwLjV0LTI0IC01LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxY2E7IiBkPSJNMTQ5NyA3MDl2LTE5OHEtMTAxIC0yMyAtMTk4IC0yM3EtNjUgLTEzNiAtMTY1LjUgLTI3MXQtMTgxLjUgLTIxNS41dC0xMjggLTEwNi41cS04MCAtNDUgLTE2MiAzcS0yOCAxNyAtNjAuNSA0My41dC04NSA4My41dC0xMDIuNSAxMjguNXQtMTA3LjUgMTg0dC0xMDUuNSAyNDR0LTkxLjUgMzE0LjV0LTcwLjUgMzkwaDI4M3EyNiAtMjE4IDcwIC0zOTguNXQxMDQuNSAtMzE3dDEyMS41IC0yMzUuNXQxNDAgLTE5NXExNjkgMTY5IDI4NyA0MDYgcS0xNDIgNzIgLTIyMyAyMjB0LTgxIDMzM3EwIDE5MiAxMDQgMzE0LjV0Mjg0IDEyMi41cTE3OCAwIDI3MyAtMTA1LjV0OTUgLTI5Ny41cTAgLTE1OSAtNTggLTI4NnEtNyAtMSAtMTkuNSAtM3QtNDYgLTJ0LTYzIDZ0LTYyIDI1LjV0LTUwLjUgNTEuNXEzMSAxMDMgMzEgMTg0cTAgODcgLTI5IDEzMnQtNzkgNDVxLTUzIDAgLTg1IC00OS41dC0zMiAtMTQwLjVxMCAtMTg2IDEwNSAtMjkzLjV0MjY3IC0xMDcuNXE2MiAwIDEyMSAxNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjYjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMjE2IDM2N2w2MDMgLTQwMnYzNTlsLTMzNCAyMjN6TTE1NCA1MTFsMTkzIDEyOWwtMTkzIDEyOXYtMjU4ek05NzMgLTM1bDYwMyA0MDJsLTI2OSAxODBsLTMzNCAtMjIzdi0zNTl6TTg5NiA0NThsMjcyIDE4MmwtMjcyIDE4MmwtMjcyIC0xODJ6TTQ4NSA3MzNsMzM0IDIyM3YzNTlsLTYwMyAtNDAyek0xNDQ1IDY0MGwxOTMgLTEyOXYyNTh6TTEzMDcgNzMzbDI2OSAxODBsLTYwMyA0MDJ2LTM1OXpNMTc5MiA5MTN2LTU0NiBxMCAtNDEgLTM0IC02NGwtODE5IC01NDZxLTIxIC0xMyAtNDMgLTEzdC00MyAxM2wtODE5IDU0NnEtMzQgMjMgLTM0IDY0djU0NnEwIDQxIDM0IDY0bDgxOSA1NDZxMjEgMTMgNDMgMTN0NDMgLTEzbDgxOSAtNTQ2cTM0IC0yMyAzNCAtNjR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxY2M7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTE4MDAgNzY0cTExMSAtNDYgMTc5LjUgLTE0NS41dDY4LjUgLTIyMS41cTAgLTE2NCAtMTE4IC0yODAuNXQtMjg1IC0xMTYuNXEtNCAwIC0xMS41IDAuNXQtMTAuNSAwLjVoLTEyMDloLTFoLTJoLTVxLTE3MCAxMCAtMjg4IDEyNS41dC0xMTggMjgwLjVxMCAxMTAgNTUgMjAzdDE0NyAxNDdxLTEyIDM5IC0xMiA4MnEwIDExNSA4MiAxOTZ0MTk5IDgxcTk1IDAgMTcyIC01OHE3NSAxNTQgMjIyLjUgMjQ4dDMyNi41IDk0IHExNjYgMCAzMDYgLTgwLjV0MjIxLjUgLTIxOC41dDgxLjUgLTMwMXEwIC02IC0wLjUgLTE4dC0wLjUgLTE4ek00NjggNDk4cTAgLTEyMiA4NCAtMTkzdDIwOCAtNzFxMTM3IDAgMjQwIDk5cS0xNiAyMCAtNDcuNSA1Ni41dC00My41IDUwLjVxLTY3IC02NSAtMTQ0IC02NXEtNTUgMCAtOTMuNSAzMy41dC0zOC41IDg3LjVxMCA1MyAzOC41IDg3dDkxLjUgMzRxNDQgMCA4NC41IC0yMXQ3MyAtNTV0NjUgLTc1dDY5IC04MnQ3NyAtNzV0OTcgLTU1IHQxMjEuNSAtMjFxMTIxIDAgMjA0LjUgNzEuNXQ4My41IDE5MC41cTAgMTIxIC04NCAxOTJ0LTIwNyA3MXEtMTQzIDAgLTI0MSAtOTdxMTQgLTE2IDI5LjUgLTM0dDM0LjUgLTQwdDI5IC0zNHE2NiA2NCAxNDIgNjRxNTIgMCA5MiAtMzN0NDAgLTg0cTAgLTU3IC0zNyAtOTEuNXQtOTQgLTM0LjVxLTQzIDAgLTgyLjUgMjF0LTcyIDU1dC02NS41IDc1dC02OS41IDgydC03Ny41IDc1dC05Ni41IDU1dC0xMTguNSAyMXEtMTIyIDAgLTIwNyAtNzAuNSB0LTg1IC0xODkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjZDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNODk2IDE1MzZxMTgyIDAgMzQ4IC03MXQyODYgLTE5MXQxOTEgLTI4NnQ3MSAtMzQ4dC03MSAtMzQ4dC0xOTEgLTI4NnQtMjg2IC0xOTF0LTM0OCAtNzF0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxek04OTYgMTQwOHEtMTkwIDAgLTM2MSAtOTBsMTk0IC0xOTRxODIgMjggMTY3IDI4dDE2NyAtMjhsMTk0IDE5NHEtMTcxIDkwIC0zNjEgOTB6TTIxOCAyNzlsMTk0IDE5NCBxLTI4IDgyIC0yOCAxNjd0MjggMTY3bC0xOTQgMTk0cS05MCAtMTcxIC05MCAtMzYxdDkwIC0zNjF6TTg5NiAtMTI4cTE5MCAwIDM2MSA5MGwtMTk0IDE5NHEtODIgLTI4IC0xNjcgLTI4dC0xNjcgMjhsLTE5NCAtMTk0cTE3MSAtOTAgMzYxIC05MHpNODk2IDI1NnExNTkgMCAyNzEuNSAxMTIuNXQxMTIuNSAyNzEuNXQtMTEyLjUgMjcxLjV0LTI3MS41IDExMi41dC0yNzEuNSAtMTEyLjV0LTExMi41IC0yNzEuNXQxMTIuNSAtMjcxLjUgdDI3MS41IC0xMTIuNXpNMTM4MCA0NzNsMTk0IC0xOTRxOTAgMTcxIDkwIDM2MXQtOTAgMzYxbC0xOTQgLTE5NHEyOCAtODIgMjggLTE2N3QtMjggLTE2N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFjZTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc2MCA2NDBxMCAtMTc2IC02OC41IC0zMzZ0LTE4NCAtMjc1LjV0LTI3NS41IC0xODR0LTMzNiAtNjguNXQtMzM2IDY4LjV0LTI3NS41IDE4NHQtMTg0IDI3NS41dC02OC41IDMzNnEwIDIxMyA5NyAzOTguNXQyNjUgMzA1LjV0Mzc0IDE1MXYtMjI4cS0yMjEgLTQ1IC0zNjYuNSAtMjIxdC0xNDUuNSAtNDA2cTAgLTEzMCA1MSAtMjQ4LjV0MTM2LjUgLTIwNHQyMDQgLTEzNi41dDI0OC41IC01MXQyNDguNSA1MXQyMDQgMTM2LjUgdDEzNi41IDIwNHQ1MSAyNDguNXEwIDIzMCAtMTQ1LjUgNDA2dC0zNjYuNSAyMjF2MjI4cTIwNiAtMzEgMzc0IC0xNTF0MjY1IC0zMDUuNXQ5NyAtMzk4LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDA7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE5IDY2MnE4IDIxNyAxMTYgNDA2dDMwNSAzMThoNXEwIC0xIC0xIC0zcS04IC04IC0yOCAtMzMuNXQtNTIgLTc2LjV0LTYwIC0xMTAuNXQtNDQuNSAtMTM1LjV0LTE0IC0xNTAuNXQzOSAtMTU3LjV0MTA4LjUgLTE1NHE1MCAtNTAgMTAyIC02OS41dDkwLjUgLTExLjV0NjkuNSAyMy41dDQ3IDMyLjVsMTYgMTZxMzkgNTEgNTMgMTE2LjV0Ni41IDEyMi41dC0yMSAxMDd0LTI2LjUgODBsLTE0IDI5cS0xMCAyNSAtMzAuNSA0OS41dC00MyA0MSB0LTQzLjUgMjkuNXQtMzUgMTlsLTEzIDZsMTA0IDExNXEzOSAtMTcgNzggLTUydDU5IC02MWwxOSAtMjdxMSA0OCAtMTguNSAxMDMuNXQtNDAuNSA4Ny41bC0yMCAzMWwxNjEgMTgzbDE2MCAtMTgxcS0zMyAtNDYgLTUyLjUgLTEwMi41dC0yMi41IC05MC41bC00IC0zM3EyMiAzNyA2MS41IDcyLjV0NjcuNSA1Mi41bDI4IDE3bDEwMyAtMTE1cS00NCAtMTQgLTg1IC01MHQtNjAgLTY1bC0xOSAtMjlxLTMxIC01NiAtNDggLTEzMy41dC03IC0xNzAgdDU3IC0xNTYuNXEzMyAtNDUgNzcuNSAtNjAuNXQ4NSAtNS41dDc2IDI2LjV0NTcuNSAzMy41bDIxIDE2cTYwIDUzIDk2LjUgMTE1dDQ4LjUgMTIxLjV0MTAgMTIxLjV0LTE4IDExOHQtMzcgMTA3LjV0LTQ1LjUgOTN0LTQ1IDcydC0zNC41IDQ3LjVsLTEzIDE3cS0xNCAxMyAtNyAxM2wxMCAtM3E0MCAtMjkgNjIuNSAtNDZ0NjIgLTUwdDY0IC01OHQ1OC41IC02NXQ1NS41IC03N3Q0NS41IC04OHQzOCAtMTAzdDIzLjUgLTExN3QxMC41IC0xMzYgcTMgLTI1OSAtMTA4IC00NjV0LTMxMiAtMzIxdC00NTYgLTExNXEtMTg1IDAgLTM1MSA3NHQtMjgzLjUgMTk4dC0xODQgMjkzdC02MC41IDM1M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFkMTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNODc0IC0xMDJ2LTY2cS0yMDggNiAtMzg1IDEwOS41dC0yODMgMjc1LjVsNTggMzRxMjkgLTQ5IDczIC05OWw2NSA1N3ExNDggLTE2OCAzNjggLTIxMmwtMTcgLTg2cTY1IC0xMiAxMjEgLTEzek0yNzYgNDI4bC04MyAtMjhxMjIgLTYwIDQ5IC0xMTJsLTU3IC0zM3EtOTggMTgwIC05OCAzODV0OTggMzg1bDU3IC0zM3EtMzAgLTU2IC00OSAtMTEybDgyIC0yOHEtMzUgLTEwMCAtMzUgLTIxMnEwIC0xMDkgMzYgLTIxMnpNMTUyOCAyNTEgbDU4IC0zNHEtMTA2IC0xNzIgLTI4MyAtMjc1LjV0LTM4NSAtMTA5LjV2NjZxNTYgMSAxMjEgMTNsLTE3IDg2cTIyMCA0NCAzNjggMjEybDY1IC01N3E0NCA1MCA3MyA5OXpNMTM3NyA4MDVsLTIzMyAtODBxMTQgLTQyIDE0IC04NXQtMTQgLTg1bDIzMiAtODBxLTMxIC05MiAtOTggLTE2OWwtMTg1IDE2MnEtNTcgLTY3IC0xNDcgLTg1bDQ4IC0yNDFxLTUyIC0xMCAtOTggLTEwdC05OCAxMGw0OCAyNDFxLTkwIDE4IC0xNDcgODVsLTE4NSAtMTYyIHEtNjcgNzcgLTk4IDE2OWwyMzIgODBxLTE0IDQyIC0xNCA4NXQxNCA4NWwtMjMzIDgwcTMzIDkzIDk5IDE2OWwxODUgLTE2MnE1OSA2OCAxNDcgODZsLTQ4IDI0MHE0NCAxMCA5OCAxMHQ5OCAtMTBsLTQ4IC0yNDBxODggLTE4IDE0NyAtODZsMTg1IDE2MnE2NiAtNzYgOTkgLTE2OXpNODc0IDE0NDh2LTY2cS02NSAtMiAtMTIxIC0xM2wxNyAtODZxLTIyMCAtNDIgLTM2OCAtMjExbC02NSA1NnEtMzggLTQyIC03MyAtOThsLTU3IDMzIHExMDYgMTcyIDI4MiAyNzUuNXQzODUgMTA5LjV6TTE3MDUgNjQwcTAgLTIwNSAtOTggLTM4NWwtNTcgMzNxMjcgNTIgNDkgMTEybC04MyAyOHEzNiAxMDMgMzYgMjEycTAgMTEyIC0zNSAyMTJsODIgMjhxLTE5IDU2IC00OSAxMTJsNTcgMzNxOTggLTE4MCA5OCAtMzg1ek0xNTg1IDEwNjNsLTU3IC0zM3EtMzUgNTYgLTczIDk4bC02NSAtNTZxLTE0OCAxNjkgLTM2OCAyMTFsMTcgODZxLTU2IDExIC0xMjEgMTN2NjZxMjA5IC02IDM4NSAtMTA5LjUgdDI4MiAtMjc1LjV6TTE3NDggNjQwcTAgMTczIC02Ny41IDMzMXQtMTgxLjUgMjcydC0yNzIgMTgxLjV0LTMzMSA2Ny41dC0zMzEgLTY3LjV0LTI3MiAtMTgxLjV0LTE4MS41IC0yNzJ0LTY3LjUgLTMzMXQ2Ny41IC0zMzF0MTgxLjUgLTI3MnQyNzIgLTE4MS41dDMzMSAtNjcuNXQzMzEgNjcuNXQyNzIgMTgxLjV0MTgxLjUgMjcydDY3LjUgMzMxek0xNzkyIDY0MHEwIC0xODIgLTcxIC0zNDh0LTE5MSAtMjg2dC0yODYgLTE5MXQtMzQ4IC03MSB0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxdDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFkMjsiIGQ9Ik01ODIgMjI4cTAgLTY2IC05MyAtNjZxLTEwNyAwIC0xMDcgNjNxMCA2NCA5OCA2NHExMDIgMCAxMDIgLTYxek01NDYgNjk0cTAgLTg1IC03NCAtODVxLTc3IDAgLTc3IDg0cTAgOTAgNzcgOTBxMzYgMCA1NSAtMjUuNXQxOSAtNjMuNXpNNzEyIDc2OXYxMjVxLTc4IC0yOSAtMTM1IC0yOXEtNTAgMjkgLTExMCAyOXEtODYgMCAtMTQ1IC01N3QtNTkgLTE0M3EwIC01MCAyOS41IC0xMDJ0NzMuNSAtNjd2LTNxLTM4IC0xNyAtMzggLTg1IHEwIC01MyA0MSAtNzd2LTNxLTExMyAtMzcgLTExMyAtMTM5cTAgLTQ1IDIwIC03OC41dDU0IC01MXQ3MiAtMjUuNXQ4MSAtOHEyMjQgMCAyMjQgMTg4cTAgNjcgLTQ4IDk5dC0xMjYgNDZxLTI3IDUgLTUxLjUgMjAuNXQtMjQuNSAzOS41cTAgNDQgNDkgNTJxNzcgMTUgMTIyIDcwdDQ1IDEzNHEwIDI0IC0xMCA1MnEzNyA5IDQ5IDEzek03NzEgMzUwaDEzN3EtMiAyNyAtMiA4MnYzODdxMCA0NiAyIDY5aC0xMzdxMyAtMjMgMyAtNzF2LTM5MiBxMCAtNTAgLTMgLTc1ek0xMjgwIDM2NnYxMjFxLTMwIC0yMSAtNjggLTIxcS01MyAwIC01MyA4MnYyMjVoNTJxOSAwIDI2LjUgLTF0MjYuNSAtMXYxMTdoLTEwNXEwIDgyIDMgMTAyaC0xNDBxNCAtMjQgNCAtNTV2LTQ3aC02MHYtMTE3cTM2IDMgMzcgM3EzIDAgMTEgLTAuNXQxMiAtMC41di0yaC0ydi0yMTdxMCAtMzcgMi41IC02NHQxMS41IC01Ni41dDI0LjUgLTQ4LjV0NDMuNSAtMzF0NjYgLTEycTY0IDAgMTA4IDI0ek05MjQgMTA3MiBxMCAzNiAtMjQgNjMuNXQtNjAgMjcuNXQtNjAuNSAtMjd0LTI0LjUgLTY0cTAgLTM2IDI1IC02Mi41dDYwIC0yNi41dDU5LjUgMjd0MjQuNSA2MnpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTU5NSAyMnEwIDEwMCAtMTY1IDEwMHEtMTU4IDAgLTE1OCAtMTA0cTAgLTEwMSAxNzIgLTEwMXExNTEgMCAxNTEgMTA1ek01MzYgNzc3cTAgNjEgLTMwIDEwMnQtODkgNDFxLTEyNCAwIC0xMjQgLTE0NXEwIC0xMzUgMTI0IC0xMzVxMTE5IDAgMTE5IDEzN3pNODA1IDExMDF2LTIwMnEtMzYgLTEyIC03OSAtMjJxMTYgLTQzIDE2IC04NHEwIC0xMjcgLTczIC0yMTYuNXQtMTk3IC0xMTIuNXEtNDAgLTggLTU5LjUgLTI3dC0xOS41IC01OCBxMCAtMzEgMjIuNSAtNTEuNXQ1OCAtMzJ0NzguNSAtMjJ0ODYgLTI1LjV0NzguNSAtMzcuNXQ1OCAtNjR0MjIuNSAtOTguNXEwIC0zMDQgLTM2MyAtMzA0cS02OSAwIC0xMzAgMTIuNXQtMTE2IDQxdC04Ny41IDgydC0zMi41IDEyNy41cTAgMTY1IDE4MiAyMjV2NHEtNjcgNDEgLTY3IDEyNnEwIDEwOSA2MyAxMzd2NHEtNzIgMjQgLTExOS41IDEwOC41dC00Ny41IDE2NS41cTAgMTM5IDk1IDIzMS41dDIzNSA5Mi41cTk2IDAgMTc4IC00NyBxOTggMCAyMTggNDd6TTExMjMgMjIwaC0yMjJxNCA0NSA0IDEzNHY2MDlxMCA5NCAtNCAxMjhoMjIycS00IC0zMyAtNCAtMTI0di02MTNxMCAtODkgNCAtMTM0ek0xNzI0IDQ0MnYtMTk2cS03MSAtMzkgLTE3NCAtMzlxLTYyIDAgLTEwNyAyMHQtNzAgNTB0LTM5LjUgNzh0LTE4LjUgOTJ0LTQgMTAzdjM1MWgydjRxLTcgMCAtMTkgMXQtMTggMXEtMjEgMCAtNTkgLTZ2MTkwaDk2djc2cTAgNTQgLTYgODloMjI3cS02IC00MSAtNiAtMTY1aDE3MSB2LTE5MHEtMTUgMCAtNDMuNSAydC00Mi41IDJoLTg1di0zNjVxMCAtMTMxIDg3IC0xMzFxNjEgMCAxMDkgMzN6TTExNDggMTM4OXEwIC01OCAtMzkgLTEwMS41dC05NiAtNDMuNXEtNTggMCAtOTggNDMuNXQtNDAgMTAxLjVxMCA1OSAzOS41IDEwM3Q5OC41IDQ0cTU4IDAgOTYuNSAtNDQuNXQzOC41IC0xMDIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFkNDsiIGQ9Ik04MDkgNTMybDI2NiA0OTloLTExMmwtMTU3IC0zMTJxLTI0IC00OCAtNDQgLTkybC00MiA5MmwtMTU1IDMxMmgtMTIwbDI2MyAtNDkzdi0zMjRoMTAxdjMxOHpNMTUzNiAxMTIwdi05NjBxMCAtMTE5IC04NC41IC0yMDMuNXQtMjAzLjUgLTg0LjVoLTk2MHEtMTE5IDAgLTIwMy41IDg0LjV0LTg0LjUgMjAzLjV2OTYwcTAgMTE5IDg0LjUgMjAzLjV0MjAzLjUgODQuNWg5NjBxMTE5IDAgMjAzLjUgLTg0LjV0ODQuNSAtMjAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDU7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTg0MiA5NjRxMCAtODAgLTU3IC0xMzYuNXQtMTM2IC01Ni41cS02MCAwIC0xMTEgMzVxLTYyIC02NyAtMTE1IC0xNDZxLTI0NyAtMzcxIC0yMDIgLTg1OXExIC0yMiAtMTIuNSAtMzguNXQtMzQuNSAtMTguNWgtNXEtMjAgMCAtMzUgMTMuNXQtMTcgMzMuNXEtMTQgMTI2IC0zLjUgMjQ3LjV0MjkuNSAyMTd0NTQgMTg2dDY5IDE1NS41dDc0IDEyNXE2MSA5MCAxMzIgMTY1cS0xNiAzNSAtMTYgNzdxMCA4MCA1Ni41IDEzNi41dDEzNi41IDU2LjUgdDEzNi41IC01Ni41dDU2LjUgLTEzNi41ek0xMjIzIDk1M3EwIC0xNTggLTc4IC0yOTJ0LTIxMi41IC0yMTJ0LTI5Mi41IC03OHEtNjQgMCAtMTMxIDE0cS0yMSA1IC0zMi41IDIzLjV0LTYuNSAzOS41cTUgMjAgMjMgMzEuNXQzOSA3LjVxNTEgLTEzIDEwOCAtMTNxOTcgMCAxODYgMzh0MTUzIDEwMnQxMDIgMTUzdDM4IDE4NnQtMzggMTg2dC0xMDIgMTUzdC0xNTMgMTAydC0xODYgMzh0LTE4NiAtMzh0LTE1MyAtMTAydC0xMDIgLTE1MyB0LTM4IC0xODZxMCAtMTE0IDUyIC0yMThxMTAgLTIwIDMuNSAtNDB0LTI1LjUgLTMwdC0zOS41IC0zdC0zMC41IDI2cS02NCAxMjMgLTY0IDI2NXEwIDExOSA0Ni41IDIyN3QxMjQuNSAxODZ0MTg2IDEyNHQyMjYgNDZxMTU4IDAgMjkyLjUgLTc4dDIxMi41IC0yMTIuNXQ3OCAtMjkyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDY7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTI3MCA3MzBxLTggMTkgLTggNTJxMCAyMCAxMSA0OXQyNCA0NXEtMSAyMiA3LjUgNTN0MjIuNSA0M3EwIDEzOSA5Mi41IDI4OC41dDIxNy41IDIwOS41cTEzOSA2NiAzMjQgNjZxMTMzIDAgMjY2IC01NXE0OSAtMjEgOTAgLTQ4dDcxIC01NnQ1NSAtNjh0NDIgLTc0dDMyLjUgLTg0LjV0MjUuNSAtODkuNXQyMiAtOThsMSAtNXE1NSAtODMgNTUgLTE1MHEwIC0xNCAtOSAtNDB0LTkgLTM4cTAgLTEgMS41IC0zLjV0My41IC01dDIgLTMuNSBxNzcgLTExNCAxMjAuNSAtMjE0LjV0NDMuNSAtMjA4LjVxMCAtNDMgLTE5LjUgLTEwMHQtNTUuNSAtNTdxLTkgMCAtMTkuNSA3LjV0LTE5IDE3LjV0LTE5IDI2dC0xNiAyNi41dC0xMy41IDI2dC05IDE3LjVxLTEgMSAtMyAxbC01IC00cS01OSAtMTU0IC0xMzIgLTIyM3EyMCAtMjAgNjEuNSAtMzguNXQ2OSAtNDEuNXQzNS41IC02NXEtMiAtNCAtNCAtMTZ0LTcgLTE4cS02NCAtOTcgLTMwMiAtOTdxLTUzIDAgLTExMC41IDl0LTk4IDIwIHQtMTA0LjUgMzBxLTE1IDUgLTIzIDdxLTE0IDQgLTQ2IDQuNXQtNDAgMS41cS00MSAtNDUgLTEyNy41IC02NXQtMTY4LjUgLTIwcS0zNSAwIC02OSAxLjV0LTkzIDl0LTEwMSAyMC41dC03NC41IDQwdC0zMi41IDY0cTAgNDAgMTAgNTkuNXQ0MSA0OC41cTExIDIgNDAuNSAxM3Q0OS41IDEycTQgMCAxNCAycTIgMiAyIDRsLTIgM3EtNDggMTEgLTEwOCAxMDUuNXQtNzMgMTU2LjVsLTUgM3EtNCAwIC0xMiAtMjBxLTE4IC00MSAtNTQuNSAtNzQuNSB0LTc3LjUgLTM3LjVoLTFxLTQgMCAtNiA0LjV0LTUgNS41cS0yMyA1NCAtMjMgMTAwcTAgMjc1IDI1MiA0NjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDc7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTU4MCAxMDc1cTAgNDEgLTI1IDY2dC02NiAyNXEtNDMgMCAtNzYgLTI1LjV0LTMzIC02NS41cTAgLTM5IDMzIC02NC41dDc2IC0yNS41cTQxIDAgNjYgMjQuNXQyNSA2NS41ek0xMzIzIDU2OHEwIDI4IC0yNS41IDUwdC02NS41IDIycS0yNyAwIC00OS41IC0yMi41dC0yMi41IC00OS41cTAgLTI4IDIyLjUgLTUwLjV0NDkuNSAtMjIuNXE0MCAwIDY1LjUgMjJ0MjUuNSA1MXpNMTA4NyAxMDc1cTAgNDEgLTI0LjUgNjZ0LTY1LjUgMjUgcS00MyAwIC03NiAtMjUuNXQtMzMgLTY1LjVxMCAtMzkgMzMgLTY0LjV0NzYgLTI1LjVxNDEgMCA2NS41IDI0LjV0MjQuNSA2NS41ek0xNzIyIDU2OHEwIDI4IC0yNiA1MHQtNjUgMjJxLTI3IDAgLTQ5LjUgLTIyLjV0LTIyLjUgLTQ5LjVxMCAtMjggMjIuNSAtNTAuNXQ0OS41IC0yMi41cTM5IDAgNjUgMjJ0MjYgNTF6TTE0NTYgOTY1cS0zMSA0IC03MCA0cS0xNjkgMCAtMzExIC03N3QtMjIzLjUgLTIwOC41dC04MS41IC0yODcuNSBxMCAtNzggMjMgLTE1MnEtMzUgLTMgLTY4IC0zcS0yNiAwIC01MCAxLjV0LTU1IDYuNXQtNDQuNSA3dC01NC41IDEwLjV0LTUwIDEwLjVsLTI1MyAtMTI3bDcyIDIxOHEtMjkwIDIwMyAtMjkwIDQ5MHEwIDE2OSA5Ny41IDMxMXQyNjQgMjIzLjV0MzYzLjUgODEuNXExNzYgMCAzMzIuNSAtNjZ0MjYyIC0xODIuNXQxMzYuNSAtMjYwLjV6TTIwNDggNDA0cTAgLTExNyAtNjguNSAtMjIzLjV0LTE4NS41IC0xOTMuNWw1NSAtMTgxbC0xOTkgMTA5IHEtMTUwIC0zNyAtMjE4IC0zN3EtMTY5IDAgLTMxMSA3MC41dC0yMjMuNSAxOTEuNXQtODEuNSAyNjR0ODEuNSAyNjR0MjIzLjUgMTkxLjV0MzExIDcwLjVxMTYxIDAgMzAzIC03MC41dDIyNy41IC0xOTJ0ODUuNSAtMjYzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZDg7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE3NjQgMTUyNXEzMyAtMjQgMjcgLTY0bC0yNTYgLTE1MzZxLTUgLTI5IC0zMiAtNDVxLTE0IC04IC0zMSAtOHEtMTEgMCAtMjQgNWwtNDUzIDE4NWwtMjQyIC0yOTVxLTE4IC0yMyAtNDkgLTIzcS0xMyAwIC0yMiA0cS0xOSA3IC0zMC41IDIzLjV0LTExLjUgMzYuNXYzNDlsODY0IDEwNTlsLTEwNjkgLTkyNWwtMzk1IDE2MnEtMzcgMTQgLTQwIDU1cS0yIDQwIDMyIDU5bDE2NjQgOTYwcTE1IDkgMzIgOXEyMCAwIDM2IC0xMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFkOTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc2NCAxNTI1cTMzIC0yNCAyNyAtNjRsLTI1NiAtMTUzNnEtNSAtMjkgLTMyIC00NXEtMTQgLTggLTMxIC04cS0xMSAwIC0yNCA1bC01MjcgMjE1bC0yOTggLTMyN3EtMTggLTIxIC00NyAtMjFxLTE0IDAgLTIzIDRxLTE5IDcgLTMwIDIzLjV0LTExIDM2LjV2NDUybC00NzIgMTkzcS0zNyAxNCAtNDAgNTVxLTMgMzkgMzIgNTlsMTY2NCA5NjBxMzUgMjEgNjggLTJ6TTE0MjIgMjZsMjIxIDEzMjNsLTE0MzQgLTgyN2wzMzYgLTEzNyBsODYzIDYzOWwtNDc4IC03OTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZGE7IiBkPSJNMTUzNiA2NDBxMCAtMTU2IC02MSAtMjk4dC0xNjQgLTI0NXQtMjQ1IC0xNjR0LTI5OCAtNjFxLTE3MiAwIC0zMjcgNzIuNXQtMjY0IDIwNC41cS03IDEwIC02LjUgMjIuNXQ4LjUgMjAuNWwxMzcgMTM4cTEwIDkgMjUgOXExNiAtMiAyMyAtMTJxNzMgLTk1IDE3OSAtMTQ3dDIyNSAtNTJxMTA0IDAgMTk4LjUgNDAuNXQxNjMuNSAxMDkuNXQxMDkuNSAxNjMuNXQ0MC41IDE5OC41dC00MC41IDE5OC41dC0xMDkuNSAxNjMuNSB0LTE2My41IDEwOS41dC0xOTguNSA0MC41cS05OCAwIC0xODggLTM1LjV0LTE2MCAtMTAxLjVsMTM3IC0xMzhxMzEgLTMwIDE0IC02OXEtMTcgLTQwIC01OSAtNDBoLTQ0OHEtMjYgMCAtNDUgMTl0LTE5IDQ1djQ0OHEwIDQyIDQwIDU5cTM5IDE3IDY5IC0xNGwxMzAgLTEyOXExMDcgMTAxIDI0NC41IDE1Ni41dDI4NC41IDU1LjVxMTU2IDAgMjk4IC02MXQyNDUgLTE2NHQxNjQgLTI0NXQ2MSAtMjk4ek04OTYgOTI4di00NDhxMCAtMTQgLTkgLTIzIHQtMjMgLTloLTMyMHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWgyMjR2MzUycTAgMTQgOSAyM3QyMyA5aDY0cTE0IDAgMjMgLTl0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZGI7IiBkPSJNNzY4IDEyODBxLTEzMCAwIC0yNDguNSAtNTF0LTIwNCAtMTM2LjV0LTEzNi41IC0yMDR0LTUxIC0yNDguNXQ1MSAtMjQ4LjV0MTM2LjUgLTIwNHQyMDQgLTEzNi41dDI0OC41IC01MXQyNDguNSA1MXQyMDQgMTM2LjV0MTM2LjUgMjA0dDUxIDI0OC41dC01MSAyNDguNXQtMTM2LjUgMjA0dC0yMDQgMTM2LjV0LTI0OC41IDUxek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzIHQtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjV0Mjc5LjUgMjc5LjV0Mzg1LjUgMTAzdDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZGM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE2ODIgLTEyOHEtNDQgMCAtMTMyLjUgMy41dC0xMzMuNSAzLjVxLTQ0IDAgLTEzMiAtMy41dC0xMzIgLTMuNXEtMjQgMCAtMzcgMjAuNXQtMTMgNDUuNXEwIDMxIDE3IDQ2dDM5IDE3dDUxIDd0NDUgMTVxMzMgMjEgMzMgMTQwbC0xIDM5MXEwIDIxIC0xIDMxcS0xMyA0IC01MCA0aC02NzVxLTM4IDAgLTUxIC00cS0xIC0xMCAtMSAtMzFsLTEgLTM3MXEwIC0xNDIgMzcgLTE2NHExNiAtMTAgNDggLTEzdDU3IC0zLjV0NDUgLTE1IHQyMCAtNDUuNXEwIC0yNiAtMTIuNSAtNDh0LTM2LjUgLTIycS00NyAwIC0xMzkuNSAzLjV0LTEzOC41IDMuNXEtNDMgMCAtMTI4IC0zLjV0LTEyNyAtMy41cS0yMyAwIC0zNS41IDIxdC0xMi41IDQ1cTAgMzAgMTUuNSA0NXQzNiAxNy41dDQ3LjUgNy41dDQyIDE1cTMzIDIzIDMzIDE0M2wtMSA1N3Y4MTNxMCAzIDAuNSAyNnQwIDM2LjV0LTEuNSAzOC41dC0zLjUgNDJ0LTYuNSAzNi41dC0xMSAzMS41dC0xNiAxOHEtMTUgMTAgLTQ1IDEydC01MyAyIHQtNDEgMTR0LTE4IDQ1cTAgMjYgMTIgNDh0MzYgMjJxNDYgMCAxMzguNSAtMy41dDEzOC41IC0zLjVxNDIgMCAxMjYuNSAzLjV0MTI2LjUgMy41cTI1IDAgMzcuNSAtMjJ0MTIuNSAtNDhxMCAtMzAgLTE3IC00My41dC0zOC41IC0xNC41dC00OS41IC00dC00MyAtMTNxLTM1IC0yMSAtMzUgLTE2MGwxIC0zMjBxMCAtMjEgMSAtMzJxMTMgLTMgMzkgLTNoNjk5cTI1IDAgMzggM3ExIDExIDEgMzJsMSAzMjBxMCAxMzkgLTM1IDE2MCBxLTE4IDExIC01OC41IDEyLjV0LTY2IDEzdC0yNS41IDQ5LjVxMCAyNiAxMi41IDQ4dDM3LjUgMjJxNDQgMCAxMzIgLTMuNXQxMzIgLTMuNXE0MyAwIDEyOSAzLjV0MTI5IDMuNXEyNSAwIDM3LjUgLTIydDEyLjUgLTQ4cTAgLTMwIC0xNy41IC00NHQtNDAgLTE0LjV0LTUxLjUgLTN0LTQ0IC0xMi41cS0zNSAtMjMgLTM1IC0xNjFsMSAtOTQzcTAgLTExOSAzNCAtMTQwcTE2IC0xMCA0NiAtMTMuNXQ1My41IC00LjV0NDEuNSAtMTUuNXQxOCAtNDQuNSBxMCAtMjYgLTEyIC00OHQtMzYgLTIyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWRkOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMjc4IDEzNDd2LTczcTAgLTI5IC0xOC41IC02MXQtNDIuNSAtMzJxLTUwIDAgLTU0IC0xcS0yNiAtNiAtMzIgLTMxcS0zIC0xMSAtMyAtNjR2LTExNTJxMCAtMjUgLTE4IC00M3QtNDMgLTE4aC0xMDhxLTI1IDAgLTQzIDE4dC0xOCA0M3YxMjE4aC0xNDN2LTEyMThxMCAtMjUgLTE3LjUgLTQzdC00My41IC0xOGgtMTA4cS0yNiAwIC00My41IDE4dC0xNy41IDQzdjQ5NnEtMTQ3IDEyIC0yNDUgNTlxLTEyNiA1OCAtMTkyIDE3OSBxLTY0IDExNyAtNjQgMjU5cTAgMTY2IDg4IDI4NnE4OCAxMTggMjA5IDE1OXExMTEgMzcgNDE3IDM3aDQ3OXEyNSAwIDQzIC0xOHQxOCAtNDN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZGU7IiBkPSJNMzUyIDEyOHYtMTI4aC0zNTJ2MTI4aDM1MnpNNzA0IDI1NnEyNiAwIDQ1IC0xOXQxOSAtNDV2LTI1NnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTI1NnEtMjYgMCAtNDUgMTl0LTE5IDQ1djI1NnEwIDI2IDE5IDQ1dDQ1IDE5aDI1NnpNODY0IDY0MHYtMTI4aC04NjR2MTI4aDg2NHpNMjI0IDExNTJ2LTEyOGgtMjI0djEyOGgyMjR6TTE1MzYgMTI4di0xMjhoLTczNnYxMjhoNzM2ek01NzYgMTI4MHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTI1NiBxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0yNTZxLTI2IDAgLTQ1IDE5dC0xOSA0NXYyNTZxMCAyNiAxOSA0NXQ0NSAxOWgyNTZ6TTEyMTYgNzY4cTI2IDAgNDUgLTE5dDE5IC00NXYtMjU2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMjU2cS0yNiAwIC00NSAxOXQtMTkgNDV2MjU2cTAgMjYgMTkgNDV0NDUgMTloMjU2ek0xNTM2IDY0MHYtMTI4aC0yMjR2MTI4aDIyNHpNMTUzNiAxMTUydi0xMjhoLTg2NHYxMjhoODY0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWUwOyIgZD0iTTEyMTYgNTEycTEzMyAwIDIyNi41IC05My41dDkzLjUgLTIyNi41dC05My41IC0yMjYuNXQtMjI2LjUgLTkzLjV0LTIyNi41IDkzLjV0LTkzLjUgMjI2LjVxMCAxMiAyIDM0bC0zNjAgMTgwcS05MiAtODYgLTIxOCAtODZxLTEzMyAwIC0yMjYuNSA5My41dC05My41IDIyNi41dDkzLjUgMjI2LjV0MjI2LjUgOTMuNXExMjYgMCAyMTggLTg2bDM2MCAxODBxLTIgMjIgLTIgMzRxMCAxMzMgOTMuNSAyMjYuNXQyMjYuNSA5My41IHQyMjYuNSAtOTMuNXQ5My41IC0yMjYuNXQtOTMuNSAtMjI2LjV0LTIyNi41IC05My41cS0xMjYgMCAtMjE4IDg2bC0zNjAgLTE4MHEyIC0yMiAyIC0zNHQtMiAtMzRsMzYwIC0xODBxOTIgODYgMjE4IDg2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWUxOyIgZD0iTTEyODAgMzQxcTAgODggLTYyLjUgMTUxdC0xNTAuNSA2M3EtODQgMCAtMTQ1IC01OGwtMjQxIDEyMHEyIDE2IDIgMjN0LTIgMjNsMjQxIDEyMHE2MSAtNTggMTQ1IC01OHE4OCAwIDE1MC41IDYzdDYyLjUgMTUxdC02Mi41IDE1MC41dC0xNTAuNSA2Mi41dC0xNTEgLTYyLjV0LTYzIC0xNTAuNXEwIC03IDIgLTIzbC0yNDEgLTEyMHEtNjIgNTcgLTE0NSA1N3EtODggMCAtMTUwLjUgLTYyLjV0LTYyLjUgLTE1MC41dDYyLjUgLTE1MC41IHQxNTAuNSAtNjIuNXE4MyAwIDE0NSA1N2wyNDEgLTEyMHEtMiAtMTYgLTIgLTIzcTAgLTg4IDYzIC0xNTAuNXQxNTEgLTYyLjV0MTUwLjUgNjIuNXQ2Mi41IDE1MC41ek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFlMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNTcxIDk0N3EtMTAgMjUgLTM0IDM1dC00OSAwcS0xMDggLTQ0IC0xOTEgLTEyN3QtMTI3IC0xOTFxLTEwIC0yNSAwIC00OXQzNSAtMzRxMTMgLTUgMjQgLTVxNDIgMCA2MCA0MHEzNCA4NCA5OC41IDE0OC41dDE0OC41IDk4LjVxMjUgMTEgMzUgMzV0MCA0OXpNMTUxMyAxMzAzbDQ2IC00NmwtMjQ0IC0yNDNsNjggLTY4cTE5IC0xOSAxOSAtNDUuNXQtMTkgLTQ1LjVsLTY0IC02NHE4OSAtMTYxIDg5IC0zNDNxMCAtMTQzIC01NS41IC0yNzMuNSB0LTE1MCAtMjI1dC0yMjUgLTE1MHQtMjczLjUgLTU1LjV0LTI3My41IDU1LjV0LTIyNSAxNTB0LTE1MCAyMjV0LTU1LjUgMjczLjV0NTUuNSAyNzMuNXQxNTAgMjI1dDIyNSAxNTB0MjczLjUgNTUuNXExODIgMCAzNDMgLTg5bDY0IDY0cTE5IDE5IDQ1LjUgMTl0NDUuNSAtMTlsNjggLTY4ek0xNTIxIDEzNTlxLTEwIC0xMCAtMjIgLTEwcS0xMyAwIC0yMyAxMGwtOTEgOTBxLTkgMTAgLTkgMjN0OSAyM3ExMCA5IDIzIDl0MjMgLTlsOTAgLTkxIHExMCAtOSAxMCAtMjIuNXQtMTAgLTIyLjV6TTE3NTEgMTEyOXEtMTEgLTkgLTIzIC05dC0yMyA5bC05MCA5MXEtMTAgOSAtMTAgMjIuNXQxMCAyMi41cTkgMTAgMjIuNSAxMHQyMi41IC0xMGw5MSAtOTBxOSAtMTAgOSAtMjN0LTkgLTIzek0xNzkyIDEzMTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZxLTE0IDAgLTIzIDl0LTkgMjN0OSAyM3QyMyA5aDk2cTE0IDAgMjMgLTl0OSAtMjN6TTE2MDAgMTUwNHYtOTZxMCAtMTQgLTkgLTIzdC0yMyAtOSB0LTIzIDl0LTkgMjN2OTZxMCAxNCA5IDIzdDIzIDl0MjMgLTl0OSAtMjN6TTE3NTEgMTQ0OWwtOTEgLTkwcS0xMCAtMTAgLTIyIC0xMHEtMTMgMCAtMjMgMTBxLTEwIDkgLTEwIDIyLjV0MTAgMjIuNWw5MCA5MXExMCA5IDIzIDl0MjMgLTlxOSAtMTAgOSAtMjN0LTkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWUzOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik02MDkgNzIwbDI4NyAyMDhsMjg3IC0yMDhsLTEwOSAtMzM2aC0zNTV6TTg5NiAxNTM2cTE4MiAwIDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHQtNzEgLTM0OHQtMTkxIC0yODZ0LTI4NiAtMTkxdC0zNDggLTcxdC0zNDggNzF0LTI4NiAxOTF0LTE5MSAyODZ0LTcxIDM0OHQ3MSAzNDh0MTkxIDI4NnQyODYgMTkxdDM0OCA3MXpNMTUxNSAxODZxMTQ5IDIwMyAxNDkgNDU0djNsLTEwMiAtODlsLTI0MCAyMjRsNjMgMzIzIGwxMzQgLTEycS0xNTAgMjA2IC0zODkgMjgybDUzIC0xMjRsLTI4NyAtMTU5bC0yODcgMTU5bDUzIDEyNHEtMjM5IC03NiAtMzg5IC0yODJsMTM1IDEybDYyIC0zMjNsLTI0MCAtMjI0bC0xMDIgODl2LTNxMCAtMjUxIDE0OSAtNDU0bDMwIDEzMmwzMjYgLTQwbDEzOSAtMjk4bC0xMTYgLTY5cTExNyAtMzkgMjQwIC0zOXQyNDAgMzlsLTExNiA2OWwxMzkgMjk4bDMyNiA0MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFlNDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNDQ4IDIyNHYtMTkycTAgLTE0IC05IC0yM3QtMjMgLTloLTE5MnEtMTQgMCAtMjMgOXQtOSAyM3YxOTJxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN6TTI1NiA2MDh2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzek04MzIgMjI0di0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzIHYxOTJxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN6TTY0MCA2MDh2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzek02NiA3NjhxLTI4IDAgLTQ3IDE5dC0xOSA0NnYxMjloNTE0di0xMjlxMCAtMjcgLTE5IC00NnQtNDYgLTE5aC0zODN6TTEyMTYgMjI0di0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkyIHEtMTQgMCAtMjMgOXQtOSAyM3YxOTJxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN6TTEwMjQgNjA4di0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3pNMTYwMCAyMjR2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzIHpNMTQwOCA2MDh2LTE5MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJxLTE0IDAgLTIzIDl0LTkgMjN2MTkycTAgMTQgOSAyM3QyMyA5aDE5MnExNCAwIDIzIC05dDkgLTIzek0xNzkyIDEwMTZ2LTEzaC01MTR2MTBxMCAxMDQgLTM4MiAxMDJxLTM4MiAtMSAtMzgyIC0xMDJ2LTEwaC01MTR2MTNxMCAxNyA4LjUgNDN0MzQgNjR0NjUuNSA3NS41dDExMC41IDc2dDE2MCA2Ny41dDIyNCA0Ny41dDI5My41IDE4LjV0MjkzIC0xOC41dDIyNCAtNDcuNSB0MTYwLjUgLTY3LjV0MTEwLjUgLTc2dDY1LjUgLTc1LjV0MzQgLTY0dDguNSAtNDN6TTE3OTIgNjA4di0xOTJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTkycS0xNCAwIC0yMyA5dC05IDIzdjE5MnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3pNMTc5MiA5NjJ2LTEyOXEwIC0yNyAtMTkgLTQ2dC00NiAtMTloLTM4NHEtMjcgMCAtNDYgMTl0LTE5IDQ2djEyOWg1MTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZTU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTcwNCAxMjE2di03NjhxMCAtMjYgLTE5IC00NXQtNDUgLTE5di01NzZxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC01MTJxLTI2IDAgLTQ1IDE5dC0xOSA0NXY1MTJsMjQ5IDg3M3E3IDIzIDMxIDIzaDQyNHpNMTAyNCAxMjE2di03MDRoLTI1NnY3MDRoMjU2ek0xNzkyIDMyMHYtNTEycTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtNTEycS0yNiAwIC00NSAxOXQtMTkgNDV2NTc2cS0yNiAwIC00NSAxOXQtMTkgNDV2NzY4aDQyNHEyNCAwIDMxIC0yM3ogTTczNiAxNTA0di0yMjRoLTM1MnYyMjRxMCAxNCA5IDIzdDIzIDloMjg4cTE0IDAgMjMgLTl0OSAtMjN6TTE0MDggMTUwNHYtMjI0aC0zNTJ2MjI0cTAgMTQgOSAyM3QyMyA5aDI4OHExNCAwIDIzIC05dDkgLTIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWU2OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzU1IDEwODNxMzcgLTM3IDM3IC05MHQtMzcgLTkxbC00MDEgLTQwMGwxNTAgLTE1MGwtMTYwIC0xNjBxLTE2MyAtMTYzIC0zODkuNSAtMTg2LjV0LTQxMS41IDEwMC41bC0zNjIgLTM2MmgtMTgxdjE4MWwzNjIgMzYycS0xMjQgMTg1IC0xMDAuNSA0MTEuNXQxODYuNSAzODkuNWwxNjAgMTYwbDE1MCAtMTUwbDQwMCA0MDFxMzggMzcgOTEgMzd0OTAgLTM3dDM3IC05MC41dC0zNyAtOTAuNWwtNDAwIC00MDFsMjM0IC0yMzRsNDAxIDQwMCBxMzggMzcgOTEgMzd0OTAgLTM3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWU3OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04NzMgNzk2cTAgLTgzIC02My41IC0xNDIuNXQtMTUyLjUgLTU5LjV0LTE1Mi41IDU5LjV0LTYzLjUgMTQyLjVxMCA4NCA2My41IDE0M3QxNTIuNSA1OXQxNTIuNSAtNTl0NjMuNSAtMTQzek0xMzc1IDc5NnEwIC04MyAtNjMgLTE0Mi41dC0xNTMgLTU5LjVxLTg5IDAgLTE1Mi41IDU5LjV0LTYzLjUgMTQyLjVxMCA4NCA2My41IDE0M3QxNTIuNSA1OXE5MCAwIDE1MyAtNTl0NjMgLTE0M3pNMTYwMCA2MTZ2NjY3cTAgODcgLTMyIDEyMy41IHQtMTExIDM2LjVoLTExMTJxLTgzIDAgLTExMi41IC0zNHQtMjkuNSAtMTI2di02NzNxNDMgLTIzIDg4LjUgLTQwdDgxIC0yOHQ4MSAtMTguNXQ3MSAtMTF0NzAgLTR0NTguNSAtMC41dDU2LjUgMnQ0NC41IDJxNjggMSA5NSAtMjdxNiAtNiAxMCAtOXEyNiAtMjUgNjEgLTUxcTcgOTEgMTE4IDg3cTUgMCAzNi41IC0xLjV0NDMgLTJ0NDUuNSAtMXQ1MyAxdDU0LjUgNC41dDYxIDguNXQ2MiAxMy41dDY3IDE5LjV0NjcuNSAyN3Q3MiAzNC41eiBNMTc2MyA2MjFxLTEyMSAtMTQ5IC0zNzIgLTI1MnE4NCAtMjg1IC0yMyAtNDY1cS02NiAtMTEzIC0xODMgLTE0OHEtMTA0IC0zMiAtMTgyIDE1cS04NiA1MSAtODIgMTY0bC0xIDMyNnYxcS04IDIgLTI0LjUgNnQtMjMuNSA1bC0xIC0zMzhxNCAtMTE0IC04MyAtMTY0cS03OSAtNDcgLTE4MyAtMTVxLTExNyAzNiAtMTgyIDE1MHEtMTA1IDE4MCAtMjIgNDYzcS0yNTEgMTAzIC0zNzIgMjUycS0yNSAzNyAtNCA2M3Q2MCAtMXEzIC0yIDExIC03IHQxMSAtOHY2OTRxMCA3MiA0NyAxMjN0MTE0IDUxaDEyNTdxNjcgMCAxMTQgLTUxdDQ3IC0xMjN2LTY5NGwyMSAxNXEzOSAyNyA2MCAxdC00IC02M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFlODsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNODk2IDExMDJ2LTQzNGgtMTQ1djQzNGgxNDV6TTEyOTQgMTEwMnYtNDM0aC0xNDV2NDM0aDE0NXpNMTI5NCAzNDJsMjUzIDI1NHY3OTVoLTExOTR2LTEwNDloMzI2di0yMTdsMjE3IDIxN2gzOTh6TTE2OTIgMTUzNnYtMTAxM2wtNDM0IC00MzRoLTMyNmwtMjE3IC0yMTdoLTIxN3YyMTdoLTM5OHYxMTU4bDEwOSAyODloMTQ4M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFlOTsiIGQ9Ik03NzMgMjE3di0xMjdxLTEgLTI5MiAtNiAtMzA1cS0xMiAtMzIgLTUxIC00MHEtNTQgLTkgLTE4MS41IDM4dC0xNjIuNSA4OXEtMTMgMTUgLTE3IDM2cS0xIDEyIDQgMjZxNCAxMCAzNCA0N3QxODEgMjE2cTEgMCA2MCA3MHExNSAxOSAzOS41IDI0LjV0NDkuNSAtMy41cTI0IC0xMCAzNy41IC0yOXQxMi41IC00MnpNNjI0IDQ2OHEtMyAtNTUgLTUyIC03MGwtMTIwIC0zOXEtMjc1IC04OCAtMjkyIC04OHEtMzUgMiAtNTQgMzYgcS0xMiAyNSAtMTcgNzVxLTggNzYgMSAxNjYuNXQzMCAxMjQuNXQ1NiAzMnExMyAwIDIwMiAtNzdxNzAgLTI5IDExNSAtNDdsODQgLTM0cTIzIC05IDM1LjUgLTMwLjV0MTEuNSAtNDguNXpNMTQ1MCAxNzFxLTcgLTU0IC05MS41IC0xNjF0LTEzNS41IC0xMjdxLTM3IC0xNCAtNjMgN3EtMTQgMTAgLTE4NCAyODdsLTQ3IDc3cS0xNCAyMSAtMTEuNSA0NnQxOS41IDQ2cTM1IDQzIDgzIDI2cTEgLTEgMTE5IC00MHEyMDMgLTY2IDI0MiAtNzkuNSB0NDcgLTIwLjVxMjggLTIyIDIyIC02MXpNNzc4IDgwM3E1IC0xMDIgLTU0IC0xMjJxLTU4IC0xNyAtMTE0IDcxbC0zNzggNTk4cS04IDM1IDE5IDYycTQxIDQzIDIwNy41IDg5LjV0MjI0LjUgMzEuNXE0MCAtMTAgNDkgLTQ1cTMgLTE4IDIyIC0zMDUuNXQyNCAtMzc5LjV6TTE0NDAgNjk1cTMgLTM5IC0yNiAtNTlxLTE1IC0xMCAtMzI5IC04NnEtNjcgLTE1IC05MSAtMjNsMSAycS0yMyAtNiAtNDYgNHQtMzcgMzJxLTMwIDQ3IDAgODcgcTEgMSA3NSAxMDJxMTI1IDE3MSAxNTAgMjA0dDM0IDM5cTI4IDE5IDY1IDJxNDggLTIzIDEyMyAtMTMzLjV0ODEgLTE2Ny41di0zeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWVhOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xMDI0IDEwMjRoLTM4NHYtMzg0aDM4NHYzODR6TTExNTIgMzg0di0xMjhoLTY0MHYxMjhoNjQwek0xMTUyIDExNTJ2LTY0MGgtNjQwdjY0MGg2NDB6TTE3OTIgMzg0di0xMjhoLTUxMnYxMjhoNTEyek0xNzkyIDY0MHYtMTI4aC01MTJ2MTI4aDUxMnpNMTc5MiA4OTZ2LTEyOGgtNTEydjEyOGg1MTJ6TTE3OTIgMTE1MnYtMTI4aC01MTJ2MTI4aDUxMnpNMjU2IDE5MnY5NjBoLTEyOHYtOTYwcTAgLTI2IDE5IC00NXQ0NSAtMTl0NDUgMTkgdDE5IDQ1ek0xOTIwIDE5MnYxMDg4aC0xNTM2di0xMDg4cTAgLTMzIC0xMSAtNjRoMTQ4M3EyNiAwIDQ1IDE5dDE5IDQ1ek0yMDQ4IDE0MDh2LTEyMTZxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZoLTE2NjRxLTgwIDAgLTEzNiA1NnQtNTYgMTM2djEwODhoMjU2djEyOGgxNzkyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWViOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xMDI0IDEzcS0yMCAwIC05MyA3My41dC03MyA5My41cTAgMzIgNjIuNSA1NHQxMDMuNSAyMnQxMDMuNSAtMjJ0NjIuNSAtNTRxMCAtMjAgLTczIC05My41dC05MyAtNzMuNXpNMTI5NCAyODRxLTIgMCAtNDAgMjV0LTEwMS41IDUwdC0xMjguNSAyNXQtMTI4LjUgLTI1dC0xMDEgLTUwdC00MC41IC0yNXEtMTggMCAtOTMuNSA3NXQtNzUuNSA5M3EwIDEzIDEwIDIzcTc4IDc3IDE5NiAxMjF0MjMzIDQ0dDIzMyAtNDR0MTk2IC0xMjEgcTEwIC0xMCAxMCAtMjNxMCAtMTggLTc1LjUgLTkzdC05My41IC03NXpNMTU2NyA1NTZxLTExIDAgLTIzIDhxLTEzNiAxMDUgLTI1MiAxNTQuNXQtMjY4IDQ5LjVxLTg1IDAgLTE3MC41IC0yMnQtMTQ5IC01M3QtMTEzLjUgLTYydC03OSAtNTN0LTMxIC0yMnEtMTcgMCAtOTIgNzV0LTc1IDkzcTAgMTIgMTAgMjJxMTMyIDEzMiAzMjAgMjA1dDM4MCA3M3QzODAgLTczdDMyMCAtMjA1cTEwIC0xMCAxMCAtMjJxMCAtMTggLTc1IC05M3QtOTIgLTc1eiBNMTgzOCA4MjdxLTExIDAgLTIyIDlxLTE3OSAxNTcgLTM3MS41IDIzNi41dC00MjAuNSA3OS41dC00MjAuNSAtNzkuNXQtMzcxLjUgLTIzNi41cS0xMSAtOSAtMjIgLTlxLTE3IDAgLTkyLjUgNzV0LTc1LjUgOTNxMCAxMyAxMCAyM3ExODcgMTg2IDQ0NSAyODh0NTI3IDEwMnQ1MjcgLTEwMnQ0NDUgLTI4OHExMCAtMTAgMTAgLTIzcTAgLTE4IC03NS41IC05M3QtOTIuNSAtNzV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZWM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTM4NCAwcTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek03NjggMHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNMzg0IDM4NHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNSB0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTExNTIgMHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNNzY4IDM4NHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41IHQzNy41IDkwLjV6TTM4NCA3NjhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTExNTIgMzg0cTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek03NjggNzY4cTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41IHQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNMTUzNiAwdjM4NHEwIDUyIC0zOCA5MHQtOTAgMzh0LTkwIC0zOHQtMzggLTkwdi0zODRxMCAtNTIgMzggLTkwdDkwIC0zOHQ5MCAzOHQzOCA5MHpNMTE1MiA3NjhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6IE0xNTM2IDEwODh2MjU2cTAgMjYgLTE5IDQ1dC00NSAxOWgtMTI4MHEtMjYgMCAtNDUgLTE5dC0xOSAtNDV2LTI1NnEwIC0yNiAxOSAtNDV0NDUgLTE5aDEyODBxMjYgMCA0NSAxOXQxOSA0NXpNMTUzNiA3NjhxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE2NjQgMTQwOHYtMTUzNnEwIC01MiAtMzggLTkwdC05MCAtMzggaC0xNDA4cS01MiAwIC05MCAzOHQtMzggOTB2MTUzNnEwIDUyIDM4IDkwdDkwIDM4aDE0MDhxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWVkOyIgZD0iTTE1MTkgODkwcTE4IC04NCAtNCAtMjA0cS04NyAtNDQ0IC01NjUgLTQ0NGgtNDRxLTI1IDAgLTQ0IC0xNi41dC0yNCAtNDIuNWwtNCAtMTlsLTU1IC0zNDZsLTIgLTE1cS01IC0yNiAtMjQuNSAtNDIuNXQtNDQuNSAtMTYuNWgtMjUxcS0yMSAwIC0zMyAxNXQtOSAzNnE5IDU2IDI2LjUgMTY4dDI2LjUgMTY4dDI3IDE2Ny41dDI3IDE2Ny41cTUgMzcgNDMgMzdoMTMxcTEzMyAtMiAyMzYgMjFxMTc1IDM5IDI4NyAxNDRxMTAyIDk1IDE1NSAyNDYgcTI0IDcwIDM1IDEzM3ExIDYgMi41IDcuNXQzLjUgMXQ2IC0zLjVxNzkgLTU5IDk4IC0xNjJ6TTEzNDcgMTE3MnEwIC0xMDcgLTQ2IC0yMzZxLTgwIC0yMzMgLTMwMiAtMzE1cS0xMTMgLTQwIC0yNTIgLTQycTAgLTEgLTkwIC0xbC05MCAxcS0xMDAgMCAtMTE4IC05NnEtMiAtOCAtODUgLTUzMHEtMSAtMTAgLTEyIC0xMGgtMjk1cS0yMiAwIC0zNi41IDE2LjV0LTExLjUgMzguNWwyMzIgMTQ3MXE1IDI5IDI3LjUgNDh0NTEuNSAxOWg1OTggcTM0IDAgOTcuNSAtMTN0MTExLjUgLTMycTEwNyAtNDEgMTYzLjUgLTEyM3Q1Ni41IC0xOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZWU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTQ0MSA4NjRxMzIgMCA1MiAtMjZxMjY2IC0zNjQgMzYyIC03NzRoLTQ0NnEtMTI3IDQ0MSAtMzY3IDc0OXEtMTIgMTYgLTMgMzMuNXQyOSAxNy41aDM3M3pNMTAwMCA1MDdxLTQ5IC0xOTkgLTEyNSAtMzkzcS03OSAzMTAgLTI1NiA1OTRxNDAgMjIxIDQ0IDQ0OXEyMTEgLTM0MCAzMzcgLTY1MHpNMTA5OSAxMjE2cTIzNSAtMzI0IDM4NC41IC02OTguNXQxODQuNSAtNzczLjVoLTQ1MXEtNDEgNjY1IC01NTMgMTQ3Mmg0MzV6TTE3OTIgNjQwIHEwIC00MjQgLTEwMSAtODEycS02NyA1NjAgLTM1OSAxMDgzcS0yNSAzMDEgLTEwNiA1ODRxLTQgMTYgNS41IDI4LjV0MjUuNSAxMi41aDM1OXEyMSAwIDM4LjUgLTEzdDIyLjUgLTMzcTExNSAtNDA5IDExNSAtODUweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWYwOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik0xOTc1IDU0NmgtMTM4cTE0IDM3IDY2IDE3OWwzIDlxNCAxMCAxMCAyNnQ5IDI2bDEyIC01NXpNNTMxIDYxMWwtNTggMjk1cS0xMSA1NCAtNzUgNTRoLTI2OGwtMiAtMTNxMzExIC03OSA0MDMgLTMzNnpNNzEwIDk2MGwtMTYyIC00MzhsLTE3IDg5cS0yNiA3MCAtODUgMTI5LjV0LTEzMSA4OC41bDEzNSAtNTEwaDE3NWwyNjEgNjQxaC0xNzZ6TTg0OSAzMThoMTY2bDEwNCA2NDJoLTE2NnpNMTYxNyA5NDRxLTY5IDI3IC0xNDkgMjcgcS0xMjMgMCAtMjAxIC01OXQtNzkgLTE1M3EtMSAtMTAyIDE0NSAtMTc0cTQ4IC0yMyA2NyAtNDF0MTkgLTM5cTAgLTMwIC0zMCAtNDZ0LTY5IC0xNnEtODYgMCAtMTU2IDMzbC0yMiAxMWwtMjMgLTE0NHE3NCAtMzQgMTg1IC0zNHExMzAgLTEgMjA4LjUgNTl0ODAuNSAxNjBxMCAxMDYgLTE0MCAxNzRxLTQ5IDI1IC03MSA0MnQtMjIgMzhxMCAyMiAyNC41IDM4LjV0NzAuNSAxNi41cTcwIDEgMTI0IC0yNGwxNSAtOHpNMjA0MiA5NjBoLTEyOCBxLTY1IDAgLTg3IC01NGwtMjQ2IC01ODhoMTc0bDM1IDk2aDIxMnE1IC0yMiAyMCAtOTZoMTU0ek0yMzA0IDEyODB2LTEyODBxMCAtNTIgLTM4IC05MHQtOTAgLTM4aC0yMDQ4cS01MiAwIC05MCAzOHQtMzggOTB2MTI4MHEwIDUyIDM4IDkwdDkwIDM4aDIwNDhxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWYxOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik02NzEgNjAzaC0xM3EtNDcgMCAtNDcgLTMycTAgLTIyIDIwIC0yMnExNyAwIDI4IDE1dDEyIDM5ek0xMDY2IDYzOWg2MnYzcTEgNCAwLjUgNi41dC0xIDd0LTIgOHQtNC41IDYuNXQtNy41IDV0LTExLjUgMnEtMjggMCAtMzYgLTM4ek0xNjA2IDYwM2gtMTJxLTQ4IDAgLTQ4IC0zMnEwIC0yMiAyMCAtMjJxMTcgMCAyOCAxNXQxMiAzOXpNMTkyNSA2MjlxMCA0MSAtMzAgNDFxLTE5IDAgLTMxIC0yMHQtMTIgLTUxcTAgLTQyIDI4IC00MiBxMjAgMCAzMi41IDIwdDEyLjUgNTJ6TTQ4MCA3NzBoODdsLTQ0IC0yNjJoLTU2bDMyIDIwMWwtNzEgLTIwMWgtMzlsLTQgMjAwbC0zNCAtMjAwaC01M2w0NCAyNjJoODFsMiAtMTYzek03MzMgNjYzcTAgLTYgLTQgLTQycS0xNiAtMTAxIC0xNyAtMTEzaC00N2wxIDIycS0yMCAtMjYgLTU4IC0yNnEtMjMgMCAtMzcuNSAxNnQtMTQuNSA0MnEwIDM5IDI2IDYwLjV0NzMgMjEuNXExNCAwIDIzIC0xcTAgMyAwLjUgNS41dDEgNC41dDAuNSAzIHEwIDIwIC0zNiAyMHEtMjkgMCAtNTkgLTEwcTAgNCA3IDQ4cTM4IDExIDY3IDExcTc0IDAgNzQgLTYyek04ODkgNzIxbC04IC00OXEtMjIgMyAtNDEgM3EtMjcgMCAtMjcgLTE3cTAgLTggNC41IC0xMnQyMS41IC0xMXE0MCAtMTkgNDAgLTYwcTAgLTcyIC04NyAtNzFxLTM0IDAgLTU4IDZxMCAyIDcgNDlxMjkgLTggNTEgLThxMzIgMCAzMiAxOXEwIDcgLTQuNSAxMS41dC0yMS41IDEyLjVxLTQzIDIwIC00MyA1OXEwIDcyIDg0IDcyIHEzMCAwIDUwIC00ek05NzcgNzIxaDI4bC03IC01MmgtMjlxLTIgLTE3IC02LjUgLTQwLjV0LTcgLTM4LjV0LTIuNSAtMThxMCAtMTYgMTkgLTE2cTggMCAxNiAybC04IC00N3EtMjEgLTcgLTQwIC03cS00MyAwIC00NSA0N3EwIDEyIDggNTZxMyAyMCAyNSAxNDZoNTV6TTExODAgNjQ4cTAgLTIzIC03IC01MmgtMTExcS0zIC0yMiAxMCAtMzN0MzggLTExcTMwIDAgNTggMTRsLTkgLTU0cS0zMCAtOCAtNTcgLThxLTk1IDAgLTk1IDk1IHEwIDU1IDI3LjUgOTAuNXQ2OS41IDM1LjVxMzUgMCA1NS41IC0yMXQyMC41IC01NnpNMTMxOSA3MjJxLTEzIC0yMyAtMjIgLTYycS0yMiAyIC0zMSAtMjR0LTI1IC0xMjhoLTU2bDMgMTRxMjIgMTMwIDI5IDE5OWg1MWwtMyAtMzNxMTQgMjEgMjUuNSAyOS41dDI4LjUgNC41ek0xNTA2IDc2M2wtOSAtNTdxLTI4IDE0IC01MCAxNHEtMzEgMCAtNTEgLTI3LjV0LTIwIC03MC41cTAgLTMwIDEzLjUgLTQ3dDM4LjUgLTE3cTIxIDAgNDggMTMgbC0xMCAtNTlxLTI4IC04IC01MCAtOHEtNDUgMCAtNzEuNSAzMC41dC0yNi41IDgyLjVxMCA3MCAzNS41IDExNC41dDkxLjUgNDQuNXEyNiAwIDYxIC0xM3pNMTY2OCA2NjNxMCAtMTggLTQgLTQycS0xMyAtNzkgLTE3IC0xMTNoLTQ2bDEgMjJxLTIwIC0yNiAtNTkgLTI2cS0yMyAwIC0zNyAxNnQtMTQgNDJxMCAzOSAyNS41IDYwLjV0NzIuNSAyMS41cTE1IDAgMjMgLTFxMiA3IDIgMTNxMCAyMCAtMzYgMjBxLTI5IDAgLTU5IC0xMHEwIDQgOCA0OCBxMzggMTEgNjcgMTFxNzMgMCA3MyAtNjJ6TTE4MDkgNzIycS0xNCAtMjQgLTIxIC02MnEtMjMgMiAtMzEuNSAtMjN0LTI1LjUgLTEyOWgtNTZsMyAxNHExOSAxMDQgMjkgMTk5aDUycTAgLTExIC00IC0zM3ExNSAyMSAyNi41IDI5LjV0MjcuNSA0LjV6TTE5NTAgNzcwaDU2bC00MyAtMjYyaC01M2wzIDE5cS0yMyAtMjMgLTUyIC0yM3EtMzEgMCAtNDkuNSAyNHQtMTguNSA2NHEwIDUzIDI3LjUgOTJ0NjQuNSAzOXEzMSAwIDUzIC0yOXogTTIwNjEgNjQwcTAgMTQ4IC03Mi41IDI3M3QtMTk4IDE5OHQtMjczLjUgNzNxLTE4MSAwIC0zMjggLTExMHExMjcgLTExNiAxNzEgLTI4NGgtNTBxLTQ0IDE1MCAtMTU4IDI1M3EtMTE0IC0xMDMgLTE1OCAtMjUzaC01MHE0NCAxNjggMTcxIDI4NHEtMTQ3IDExMCAtMzI4IDExMHEtMTQ4IDAgLTI3My41IC03M3QtMTk4IC0xOTh0LTcyLjUgLTI3M3Q3Mi41IC0yNzN0MTk4IC0xOTh0MjczLjUgLTczcTE4MSAwIDMyOCAxMTAgcS0xMjAgMTExIC0xNjUgMjY0aDUwcTQ2IC0xMzggMTUyIC0yMzNxMTA2IDk1IDE1MiAyMzNoNTBxLTQ1IC0xNTMgLTE2NSAtMjY0cTE0NyAtMTEwIDMyOCAtMTEwcTE0OCAwIDI3My41IDczdDE5OCAxOTh0NzIuNSAyNzN6TTIzMDQgMTI4MHYtMTI4MHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTIwNDhxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMjgwcTAgNTIgMzggOTB0OTAgMzhoMjA0OHE1MiAwIDkwIC0zOHQzOCAtOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZjI7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTMxMyA3NTlxMCAtNTEgLTM2IC04NHEtMjkgLTI2IC04OSAtMjZoLTE3djIyMGgxN3E2MSAwIDg5IC0yN3EzNiAtMzEgMzYgLTgzek0yMDg5IDgyNHEwIC01MiAtNjQgLTUyaC0xOXYxMDFoMjBxNjMgMCA2MyAtNDl6TTM4MCA3NTlxMCA3NCAtNTAgMTIwLjV0LTEyOSA0Ni41aC05NXYtMzMzaDk1cTc0IDAgMTE5IDM4cTYwIDUxIDYwIDEyOHpNNDEwIDU5M2g2NXYzMzNoLTY1di0zMzN6TTczMCA2OTRxMCA0MCAtMjAuNSA2MnQtNzUuNSA0MiBxLTI5IDEwIC0zOS41IDE5dC0xMC41IDIzcTAgMTYgMTMuNSAyNi41dDM0LjUgMTAuNXEyOSAwIDUzIC0yN2wzNCA0NHEtNDEgMzcgLTk4IDM3cS00NCAwIC03NCAtMjcuNXQtMzAgLTY3LjVxMCAtMzUgMTggLTU1LjV0NjQgLTM2LjVxMzcgLTEzIDQ1IC0xOXExOSAtMTIgMTkgLTM0cTAgLTIwIC0xNCAtMzMuNXQtMzYgLTEzLjVxLTQ4IDAgLTcxIDQ0bC00MiAtNDBxNDQgLTY0IDExNSAtNjRxNTEgMCA4MyAzMC41dDMyIDc5LjV6TTEwMDggNjA0IHY3N3EtMzcgLTM3IC03OCAtMzdxLTQ5IDAgLTgwLjUgMzIuNXQtMzEuNSA4Mi41cTAgNDggMzEuNSA4MS41dDc3LjUgMzMuNXE0MyAwIDgxIC0zOHY3N3EtNDAgMjAgLTgwIDIwcS03NCAwIC0xMjUuNSAtNTAuNXQtNTEuNSAtMTIzLjV0NTEgLTEyMy41dDEyNSAtNTAuNXE0MiAwIDgxIDE5ek0yMjQwIDB2NTI3cS02NSAtNDAgLTE0NC41IC04NHQtMjM3LjUgLTExN3QtMzI5LjUgLTEzNy41dC00MTcuNSAtMTM0LjV0LTUwNCAtMTE4aDE1NjkgcTI2IDAgNDUgMTl0MTkgNDV6TTEzODkgNzU3cTAgNzUgLTUzIDEyOHQtMTI4IDUzdC0xMjggLTUzdC01MyAtMTI4dDUzIC0xMjh0MTI4IC01M3QxMjggNTN0NTMgMTI4ek0xNTQxIDU4NGwxNDQgMzQyaC03MWwtOTAgLTIyNGwtODkgMjI0aC03MWwxNDIgLTM0MmgzNXpNMTcxNCA1OTNoMTg0djU2aC0xMTl2OTBoMTE1djU2aC0xMTV2NzRoMTE5djU3aC0xODR2LTMzM3pNMjEwNSA1OTNoODBsLTEwNSAxNDBxNzYgMTYgNzYgOTRxMCA0NyAtMzEgNzMgdC04NyAyNmgtOTd2LTMzM2g2NXYxMzNoOXpNMjMwNCAxMjc0di0xMjY4cTAgLTU2IC0zOC41IC05NXQtOTMuNSAtMzloLTIwNDBxLTU1IDAgLTkzLjUgMzl0LTM4LjUgOTV2MTI2OHEwIDU2IDM4LjUgOTV0OTMuNSAzOWgyMDQwcTU1IDAgOTMuNSAtMzl0MzguNSAtOTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZjM7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTExOSA4NTRoODlsLTQ1IDEwOHpNNzQwIDMyOGw3NCA3OWwtNzAgNzloLTE2M3YtNDloMTQydi01NWgtMTQydi01NGgxNTl6TTg5OCA0MDZsOTkgLTExMHYyMTd6TTExODYgNDUzcTAgMzMgLTQwIDMzaC04NHYtNjloODNxNDEgMCA0MSAzNnpNMTQ3NSA0NTdxMCAyOSAtNDIgMjloLTgydi02MWg4MXE0MyAwIDQzIDMyek0xMTk3IDkyM3EwIDI5IC00MiAyOWgtODJ2LTYwaDgxcTQzIDAgNDMgMzF6TTE2NTYgODU0aDg5bC00NCAxMDh6IE02OTkgMTAwOXYtMjcxaC02NnYyMTJsLTk0IC0yMTJoLTU3bC05NCAyMTJ2LTIxMmgtMTMybC0yNSA2MGgtMTM1bC0yNSAtNjBoLTcwbDExNiAyNzFoOTZsMTEwIC0yNTd2MjU3aDEwNmw4NSAtMTg0bDc3IDE4NGgxMDh6TTEyNTUgNDUzcTAgLTIwIC01LjUgLTM1dC0xNCAtMjV0LTIyLjUgLTE2LjV0LTI2IC0xMHQtMzEuNSAtNC41dC0zMS41IC0xdC0zMi41IDAuNXQtMjkuNSAwLjV2LTkxaC0xMjZsLTgwIDkwbC04MyAtOTBoLTI1NnYyNzFoMjYwIGw4MCAtODlsODIgODloMjA3cTEwOSAwIDEwOSAtODl6TTk2NCA3OTR2LTU2aC0yMTd2MjcxaDIxN3YtNTdoLTE1MnYtNDloMTQ4di01NWgtMTQ4di01NGgxNTJ6TTIzMDQgMjM1di0yMjlxMCAtNTUgLTM4LjUgLTk0LjV0LTkzLjUgLTM5LjVoLTIwNDBxLTU1IDAgLTkzLjUgMzkuNXQtMzguNSA5NC41djY3OGgxMTFsMjUgNjFoNTVsMjUgLTYxaDIxOHY0NmwxOSAtNDZoMTEzbDIwIDQ3di00N2g1NDF2OTlsMTAgMXExMCAwIDEwIC0xNHYtODZoMjc5IHYyM3EyMyAtMTIgNTUgLTE4dDUyLjUgLTYuNXQ2MyAwLjV0NTEuNSAxbDI1IDYxaDU2bDI1IC02MWgyMjd2NThsMzQgLTU4aDE4MnYzNzhoLTE4MHYtNDRsLTI1IDQ0aC0xODV2LTQ0bC0yMyA0NGgtMjQ5cS02OSAwIC0xMDkgLTIydjIyaC0xNzJ2LTIycS0yNCAyMiAtNzMgMjJoLTYyOGwtNDMgLTk3bC00MyA5N2gtMTk4di00NGwtMjIgNDRoLTE2OWwtNzggLTE3OXYzOTFxMCA1NSAzOC41IDk0LjV0OTMuNSAzOS41aDIwNDAgcTU1IDAgOTMuNSAtMzkuNXQzOC41IC05NC41di02NzhoLTEyMHEtNTEgMCAtODEgLTIydjIyaC0xNzdxLTU1IDAgLTc4IC0yMnYyMmgtMzE2di0yMnEtMzEgMjIgLTg3IDIyaC0yMDl2LTIycS0yMyAyMiAtOTEgMjJoLTIzNGwtNTQgLTU4bC01MCA1OGgtMzQ5di0zNzhoMzQzbDU1IDU5bDUyIC01OWgyMTF2ODloMjFxNTkgMCA5MCAxM3YtMTAyaDE3NHY5OWg4cTggMCAxMCAtMnQyIC0xMHYtODdoNTI5cTU3IDAgODggMjR2LTI0aDE2OCBxNjAgMCA5NSAxN3pNMTU0NiA0NjlxMCAtMjMgLTEyIC00M3QtMzQgLTI5cTI1IC05IDM0IC0yNnQ5IC00NnYtNTRoLTY1djQ1cTAgMzMgLTEyIDQzLjV0LTQ2IDEwLjVoLTY5di05OWgtNjV2MjcxaDE1NHE0OCAwIDc3IC0xNXQyOSAtNTh6TTEyNjkgOTM2cTAgLTI0IC0xMi41IC00NHQtMzMuNSAtMjlxMjYgLTkgMzQuNSAtMjUuNXQ4LjUgLTQ2LjV2LTUzaC02NXEwIDkgMC41IDI2LjV0MCAyNXQtMyAxOC41dC04LjUgMTZ0LTE3LjUgOC41IHQtMjkuNSAzLjVoLTcwdi05OGgtNjR2MjcxbDE1MyAtMXE0OSAwIDc4IC0xNC41dDI5IC01Ny41ek0xNzk4IDMyN3YtNTZoLTIxNnYyNzFoMjE2di01NmgtMTUxdi00OWgxNDh2LTU1aC0xNDh2LTU0ek0xMzcyIDEwMDl2LTI3MWgtNjZ2MjcxaDY2ek0yMDY1IDM1N3EwIC04NiAtMTAyIC04NmgtMTI2djU4aDEyNnEzNCAwIDM0IDI1cTAgMTYgLTE3IDIxdC00MS41IDV0LTQ5LjUgMy41dC00MiAyMi41dC0xNyA1NXEwIDM5IDI2IDYwdDY2IDIxIGgxMzB2LTU3aC0xMTlxLTM2IDAgLTM2IC0yNXEwIC0xNiAxNy41IC0yMC41dDQyIC00dDQ5IC0yLjV0NDIgLTIxLjV0MTcuNSAtNTQuNXpNMjMwNCA0MDd2LTEwMXEtMjQgLTM1IC04OCAtMzVoLTEyNXY1OGgxMjVxMzMgMCAzMyAyNXEwIDEzIC0xMi41IDE5dC0zMSA1LjV0LTQwIDJ0LTQwIDh0LTMxIDI0dC0xMi41IDQ4LjVxMCAzOSAyNi41IDYwdDY2LjUgMjFoMTI5di01N2gtMTE4cS0zNiAwIC0zNiAtMjVxMCAtMjAgMjkgLTIydDY4LjUgLTUgdDU2LjUgLTI2ek0yMTM5IDEwMDh2LTI3MGgtOTJsLTEyMiAyMDN2LTIwM2gtMTMybC0yNiA2MGgtMTM0bC0yNSAtNjBoLTc1cS0xMjkgMCAtMTI5IDEzM3EwIDEzOCAxMzMgMTM4aDYzdi01OXEtNyAwIC0yOCAxdC0yOC41IDAuNXQtMjMgLTJ0LTIxLjUgLTYuNXQtMTQuNSAtMTMuNXQtMTEuNSAtMjN0LTMgLTMzLjVxMCAtMzggMTMuNSAtNTh0NDkuNSAtMjBoMjlsOTIgMjEzaDk3bDEwOSAtMjU2djI1Nmg5OWwxMTQgLTE4OHYxODhoNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZjQ7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTc0NSA2MzBxMCAtMzcgLTI1LjUgLTYxLjV0LTYyLjUgLTI0LjVxLTI5IDAgLTQ2LjUgMTZ0LTE3LjUgNDRxMCAzNyAyNSA2Mi41dDYyIDI1LjVxMjggMCA0Ni41IC0xNi41dDE4LjUgLTQ1LjV6TTE1MzAgNzc5cTAgLTQyIC0yMiAtNTd0LTY2IC0xNWwtMzIgLTFsMTcgMTA3cTIgMTEgMTMgMTFoMThxMjIgMCAzNSAtMnQyNSAtMTIuNXQxMiAtMzAuNXpNMTg4MSA2MzBxMCAtMzYgLTI1LjUgLTYxdC02MS41IC0yNXEtMjkgMCAtNDcgMTYgdC0xOCA0NHEwIDM3IDI1IDYyLjV0NjIgMjUuNXEyOCAwIDQ2LjUgLTE2LjV0MTguNSAtNDUuNXpNNTEzIDgwMXEwIDU5IC0zOC41IDg1LjV0LTEwMC41IDI2LjVoLTE2MHEtMTkgMCAtMjEgLTE5bC02NSAtNDA4cS0xIC02IDMgLTExdDEwIC01aDc2cTIwIDAgMjIgMTlsMTggMTEwcTEgOCA3IDEzdDE1IDYuNXQxNyAxLjV0MTkgLTF0MTQgLTFxODYgMCAxMzUgNDguNXQ0OSAxMzQuNXpNODIyIDQ4OWw0MSAyNjFxMSA2IC0zIDExdC0xMCA1aC03NiBxLTE0IDAgLTE3IC0zM3EtMjcgNDAgLTk1IDQwcS03MiAwIC0xMjIuNSAtNTR0LTUwLjUgLTEyN3EwIC01OSAzNC41IC05NHQ5Mi41IC0zNXEyOCAwIDU4IDEydDQ4IDMycS00IC0xMiAtNCAtMjFxMCAtMTYgMTMgLTE2aDY5cTE5IDAgMjIgMTl6TTEyNjkgNzUycTAgNSAtNCA5LjV0LTkgNC41aC03N3EtMTEgMCAtMTggLTEwbC0xMDYgLTE1NmwtNDQgMTUwcS01IDE2IC0yMiAxNmgtNzVxLTUgMCAtOSAtNC41dC00IC05LjVxMCAtMiAxOS41IC01OSB0NDIgLTEyM3QyMy41IC03MHEtODIgLTExMiAtODIgLTEyMHEwIC0xMyAxMyAtMTNoNzdxMTEgMCAxOCAxMGwyNTUgMzY4cTIgMiAyIDd6TTE2NDkgODAxcTAgNTkgLTM4LjUgODUuNXQtMTAwLjUgMjYuNWgtMTU5cS0yMCAwIC0yMiAtMTlsLTY1IC00MDhxLTEgLTYgMyAtMTF0MTAgLTVoODJxMTIgMCAxNiAxM2wxOCAxMTZxMSA4IDcgMTN0MTUgNi41dDE3IDEuNXQxOSAtMXQxNCAtMXE4NiAwIDEzNSA0OC41dDQ5IDEzNC41ek0xOTU4IDQ4OSBsNDEgMjYxcTEgNiAtMyAxMXQtMTAgNWgtNzZxLTE0IDAgLTE3IC0zM3EtMjYgNDAgLTk1IDQwcS03MiAwIC0xMjIuNSAtNTR0LTUwLjUgLTEyN3EwIC01OSAzNC41IC05NHQ5Mi41IC0zNXEyOSAwIDU5IDEydDQ3IDMycTAgLTEgLTIgLTl0LTIgLTEycTAgLTE2IDEzIC0xNmg2OXExOSAwIDIyIDE5ek0yMTc2IDg5OHYxcTAgMTQgLTEzIDE0aC03NHEtMTEgMCAtMTMgLTExbC02NSAtNDE2bC0xIC0ycTAgLTUgNCAtOS41dDEwIC00LjVoNjYgcTE5IDAgMjEgMTl6TTM5MiA3NjRxLTUgLTM1IC0yNiAtNDZ0LTYwIC0xMWwtMzMgLTFsMTcgMTA3cTIgMTEgMTMgMTFoMTlxNDAgMCA1OCAtMTEuNXQxMiAtNDguNXpNMjMwNCAxMjgwdi0xMjgwcTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMjA0OHEtNTIgMCAtOTAgMzh0LTM4IDkwdjEyODBxMCA1MiAzOCA5MHQ5MCAzOGgyMDQ4cTUyIDAgOTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFmNTsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMTU5NyA2MzNxMCAtNjkgLTIxIC0xMDZxLTE5IC0zNSAtNTIgLTM1cS0yMyAwIC00MSA5djIyNHEyOSAzMCA1NyAzMHE1NyAwIDU3IC0xMjJ6TTIwMzUgNjY5aC0xMTBxNiA5OCA1NiA5OHE1MSAwIDU0IC05OHpNNDc2IDUzNHEwIDU5IC0zMyA5MS41dC0xMDEgNTcuNXEtMzYgMTMgLTUyIDI0dC0xNiAyNXEwIDI2IDM4IDI2cTU4IDAgMTI0IC0zM2wxOCAxMTJxLTY3IDMyIC0xNDkgMzJxLTc3IDAgLTEyMyAtMzhxLTQ4IC0zOSAtNDggLTEwOSBxMCAtNTggMzIuNSAtOTAuNXQ5OS41IC01Ni41cTM5IC0xNCA1NC41IC0yNS41dDE1LjUgLTI3LjVxMCAtMzEgLTQ4IC0zMXEtMjkgMCAtNzAgMTIuNXQtNzIgMzAuNWwtMTggLTExM3E3MiAtNDEgMTY4IC00MXE4MSAwIDEyOSAzN3E1MSA0MSA1MSAxMTd6TTc3MSA3NDlsMTkgMTExaC05NnYxMzVsLTEyOSAtMjFsLTE4IC0xMTRsLTQ2IC04bC0xNyAtMTAzaDYydi0yMTlxMCAtODQgNDQgLTEyMHEzOCAtMzAgMTExIC0zMHEzMiAwIDc5IDExdjExOCBxLTMyIC03IC00NCAtN3EtNDIgMCAtNDIgNTB2MTk3aDc3ek0xMDg3IDcyNHYxMzlxLTE1IDMgLTI4IDNxLTMyIDAgLTU1LjUgLTE2dC0zMy41IC00NmwtMTAgNTZoLTEzMXYtNDcxaDE1MHYzMDZxMjYgMzEgODIgMzFxMTYgMCAyNiAtMnpNMTEyNCAzODloMTUwdjQ3MWgtMTUwdi00NzF6TTE3NDYgNjM4cTAgMTIyIC00NSAxNzlxLTQwIDUyIC0xMTEgNTJxLTY0IDAgLTExNyAtNTZsLTggNDdoLTEzMnYtNjQ1bDE1MCAyNXYxNTEgcTM2IC0xMSA2OCAtMTFxODMgMCAxMzQgNTZxNjEgNjUgNjEgMjAyek0xMjc4IDk4NnEwIDMzIC0yMyA1NnQtNTYgMjN0LTU2IC0yM3QtMjMgLTU2dDIzIC01Ni41dDU2IC0yMy41dDU2IDIzLjV0MjMgNTYuNXpNMjE3NiA2MjlxMCAxMTMgLTQ4IDE3NnEtNTAgNjQgLTE0NCA2NHEtOTYgMCAtMTUxLjUgLTY2dC01NS41IC0xODBxMCAtMTI4IDYzIC0xODhxNTUgLTU1IDE2MSAtNTVxMTAxIDAgMTYwIDQwbC0xNiAxMDNxLTU3IC0zMSAtMTI4IC0zMSBxLTQzIDAgLTYzIDE5cS0yMyAxOSAtMjggNjZoMjQ4cTIgMTQgMiA1MnpNMjMwNCAxMjgwdi0xMjgwcTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMjA0OHEtNTIgMCAtOTAgMzh0LTM4IDkwdjEyODBxMCA1MiAzOCA5MHQ5MCAzOGgyMDQ4cTUyIDAgOTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFmNjsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMTU1OCA2ODRxNjEgLTM1NiAyOTggLTU1NnEwIC01MiAtMzggLTkwdC05MCAtMzhoLTQ0OHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MC41IDc0LjV0LTc1LjUgMTgwLjV6TTEwMjQgLTE3NnExNiAwIDE2IDE2dC0xNiAxNnEtNTkgMCAtMTAxLjUgNDIuNXQtNDIuNSAxMDEuNXEwIDE2IC0xNiAxNnQtMTYgLTE2cTAgLTczIDUxLjUgLTEyNC41dDEyNC41IC01MS41ek0yMDI2IDE0MjRxOCAtMTAgNy41IC0yMy41dC0xMC41IC0yMi41IGwtMTg3MiAtMTYyMnEtMTAgLTggLTIzLjUgLTd0LTIxLjUgMTFsLTg0IDk2cS04IDEwIC03LjUgMjMuNXQxMC41IDIxLjVsMTg2IDE2MXEtMTkgMzIgLTE5IDY2cTUwIDQyIDkxIDg4dDg1IDExOS41dDc0LjUgMTU4LjV0NTAgMjA2dDE5LjUgMjYwcTAgMTUyIDExNyAyODIuNXQzMDcgMTU4LjVxLTggMTkgLTggMzlxMCA0MCAyOCA2OHQ2OCAyOHQ2OCAtMjh0MjggLTY4cTAgLTIwIC04IC0zOXExMjQgLTE4IDIxOSAtODIuNXQxNDggLTE1Ny41IGw0MTggMzYzcTEwIDggMjMuNSA3dDIxLjUgLTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWY3OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xMDQwIC0xNjBxMCAxNiAtMTYgMTZxLTU5IDAgLTEwMS41IDQyLjV0LTQyLjUgMTAxLjVxMCAxNiAtMTYgMTZ0LTE2IC0xNnEwIC03MyA1MS41IC0xMjQuNXQxMjQuNSAtNTEuNXExNiAwIDE2IDE2ek01MDMgMzE1bDg3NyA3NjBxLTQyIDg4IC0xMzIuNSAxNDYuNXQtMjIzLjUgNTguNXEtOTMgMCAtMTY5LjUgLTMxLjV0LTEyMS41IC04MC41dC02OSAtMTAzdC0yNCAtMTA1cTAgLTM4NCAtMTM3IC02NDV6TTE4NTYgMTI4IHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTQ0OHEwIC0xMDYgLTc1IC0xODF0LTE4MSAtNzV0LTE4MC41IDc0LjV0LTc1LjUgMTgwLjVsMTQ5IDEyOWg3NTdxLTE2NiAxODcgLTIyNyA0NTlsMTExIDk3cTYxIC0zNTYgMjk4IC01NTZ6TTE5NDIgMTUyMGw4NCAtOTZxOCAtMTAgNy41IC0yMy41dC0xMC41IC0yMi41bC0xODcyIC0xNjIycS0xMCAtOCAtMjMuNSAtN3QtMjEuNSAxMWwtODQgOTZxLTggMTAgLTcuNSAyMy41dDEwLjUgMjEuNWwxODYgMTYxIHEtMTkgMzIgLTE5IDY2cTUwIDQyIDkxIDg4dDg1IDExOS41dDc0LjUgMTU4LjV0NTAgMjA2dDE5LjUgMjYwcTAgMTUyIDExNyAyODIuNXQzMDcgMTU4LjVxLTggMTkgLTggMzlxMCA0MCAyOCA2OHQ2OCAyOHQ2OCAtMjh0MjggLTY4cTAgLTIwIC04IC0zOXExMjQgLTE4IDIxOSAtODIuNXQxNDggLTE1Ny41bDQxOCAzNjNxMTAgOCAyMy41IDd0MjEuNSAtMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZjg7IiBob3Jpei1hZHYteD0iMTQwOCIgZD0iTTUxMiAxNjB2NzA0cTAgMTQgLTkgMjN0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTcwNHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNNzY4IDE2MHY3MDRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNzA0cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek0xMDI0IDE2MHY3MDRxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtNzA0IHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNNDgwIDExNTJoNDQ4bC00OCAxMTdxLTcgOSAtMTcgMTFoLTMxN3EtMTAgLTIgLTE3IC0xMXpNMTQwOCAxMTIwdi02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC05NnYtOTQ4cTAgLTgzIC00NyAtMTQzLjV0LTExMyAtNjAuNWgtODMycS02NiAwIC0xMTMgNTguNXQtNDcgMTQxLjV2OTUyaC05NnEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWgzMDlsNzAgMTY3IHExNSAzNyA1NCA2M3Q3OSAyNmgzMjBxNDAgMCA3OSAtMjZ0NTQgLTYzbDcwIC0xNjdoMzA5cTE0IDAgMjMgLTl0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZjk7IiBkPSJNMTE1MCA0NjJ2LTEwOXEwIC01MCAtMzYuNSAtODl0LTk0IC02MC41dC0xMTggLTMyLjV0LTExNy41IC0xMXEtMjA1IDAgLTM0Mi41IDEzOXQtMTM3LjUgMzQ2cTAgMjAzIDEzNiAzMzl0MzM5IDEzNnEzNCAwIDc1LjUgLTQuNXQ5MyAtMTh0OTIuNSAtMzR0NjkgLTU2LjV0MjggLTgxdi0xMDlxMCAtMTYgLTE2IC0xNmgtMTE4cS0xNiAwIC0xNiAxNnY3MHEwIDQzIC02NS41IDY3LjV0LTEzNy41IDI0LjVxLTE0MCAwIC0yMjguNSAtOTEuNSB0LTg4LjUgLTIzNy41cTAgLTE1MSA5MS41IC0yNDkuNXQyMzMuNSAtOTguNXE2OCAwIDEzOCAyNHQ3MCA2NnY3MHEwIDcgNC41IDExLjV0MTAuNSA0LjVoMTE5cTYgMCAxMSAtNC41dDUgLTExLjV6TTc2OCAxMjgwcS0xMzAgMCAtMjQ4LjUgLTUxdC0yMDQgLTEzNi41dC0xMzYuNSAtMjA0dC01MSAtMjQ4LjV0NTEgLTI0OC41dDEzNi41IC0yMDR0MjA0IC0xMzYuNXQyNDguNSAtNTF0MjQ4LjUgNTF0MjA0IDEzNi41dDEzNi41IDIwNHQ1MSAyNDguNSB0LTUxIDI0OC41dC0xMzYuNSAyMDR0LTIwNCAxMzYuNXQtMjQ4LjUgNTF6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMWZhOyIgZD0iTTk3MiA3NjFxMCAxMDggLTUzLjUgMTY5dC0xNDcuNSA2MXEtNjMgMCAtMTI0IC0zMC41dC0xMTAgLTg0LjV0LTc5LjUgLTEzN3QtMzAuNSAtMTgwcTAgLTExMiA1My41IC0xNzN0MTUwLjUgLTYxcTk2IDAgMTc2IDY2LjV0MTIyLjUgMTY2dDQyLjUgMjAzLjV6TTE1MzYgNjQwcTAgLTExMSAtMzcgLTE5N3QtOTguNSAtMTM1dC0xMzEuNSAtNzQuNXQtMTQ1IC0yNy41cS02IDAgLTE1LjUgLTAuNXQtMTYuNSAtMC41cS05NSAwIC0xNDIgNTMgcS0yOCAzMyAtMzMgODNxLTUyIC02NiAtMTMxLjUgLTExMHQtMTczLjUgLTQ0cS0xNjEgMCAtMjQ5LjUgOTUuNXQtODguNSAyNjkuNXEwIDE1NyA2NiAyOTB0MTc5IDIxMC41dDI0NiA3Ny41cTg3IDAgMTU1IC0zNS41dDEwNiAtOTkuNWwyIDE5bDExIDU2cTEgNiA1LjUgMTJ0OS41IDZoMTE4cTUgMCAxMyAtMTFxNSAtNSAzIC0xNmwtMTIwIC02MTRxLTUgLTI0IC01IC00OHEwIC0zOSAxMi41IC01MnQ0NC41IC0xM3EyOCAxIDU3IDUuNXQ3MyAyNCB0NzcgNTB0NTcgODkuNXQyNCAxMzdxMCAyOTIgLTE3NCA0NjZ0LTQ2NiAxNzRxLTEzMCAwIC0yNDguNSAtNTF0LTIwNCAtMTM2LjV0LTEzNi41IC0yMDR0LTUxIC0yNDguNXQ1MSAtMjQ4LjV0MTM2LjUgLTIwNHQyMDQgLTEzNi41dDI0OC41IC01MXEyMjggMCA0MDUgMTQ0cTExIDkgMjQgOHQyMSAtMTJsNDEgLTQ5cTggLTEyIDcgLTI0cS0yIC0xMyAtMTIgLTIycS0xMDIgLTgzIC0yMjcuNSAtMTI4dC0yNTguNSAtNDVxLTE1NiAwIC0yOTggNjEgdC0yNDUgMTY0dC0xNjQgMjQ1dC02MSAyOTh0NjEgMjk4dDE2NCAyNDV0MjQ1IDE2NHQyOTggNjFxMzQ0IDAgNTU2IC0yMTJ0MjEyIC01NTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZmI7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE2OTggMTQ0MnE5NCAtOTQgOTQgLTIyNi41dC05NCAtMjI1LjVsLTIyNSAtMjIzbDEwNCAtMTA0cTEwIC0xMCAxMCAtMjN0LTEwIC0yM2wtMjEwIC0yMTBxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtMTA1IDEwNWwtNjAzIC02MDNxLTM3IC0zNyAtOTAgLTM3aC0yMDNsLTI1NiAtMTI4bC02NCA2NGwxMjggMjU2djIwM3EwIDUzIDM3IDkwbDYwMyA2MDNsLTEwNSAxMDVxLTEwIDEwIC0xMCAyM3QxMCAyM2wyMTAgMjEwcTEwIDEwIDIzIDEwIHQyMyAtMTBsMTA0IC0xMDRsMjIzIDIyNXE5MyA5NCAyMjUuNSA5NHQyMjYuNSAtOTR6TTUxMiA2NGw1NzYgNTc2bC0xOTIgMTkybC01NzYgLTU3NnYtMTkyaDE5MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFmYzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTYxNSAxNTM2cTcwIDAgMTIyLjUgLTQ2LjV0NTIuNSAtMTE2LjVxMCAtNjMgLTQ1IC0xNTFxLTMzMiAtNjI5IC00NjUgLTc1MnEtOTcgLTkxIC0yMTggLTkxcS0xMjYgMCAtMjE2LjUgOTIuNXQtOTAuNSAyMTkuNXEwIDEyOCA5MiAyMTJsNjM4IDU3OXE1OSA1NCAxMzAgNTR6TTcwNiA1MDJxMzkgLTc2IDEwNi41IC0xMzB0MTUwLjUgLTc2bDEgLTcxcTQgLTIxMyAtMTI5LjUgLTM0N3QtMzQ4LjUgLTEzNHEtMTIzIDAgLTIxOCA0Ni41IHQtMTUyLjUgMTI3LjV0LTg2LjUgMTgzdC0yOSAyMjBxNyAtNSA0MSAtMzB0NjIgLTQ0LjV0NTkgLTM2LjV0NDYgLTE3cTQxIDAgNTUgMzdxMjUgNjYgNTcuNSAxMTIuNXQ2OS41IDc2dDg4IDQ3LjV0MTAzIDI1LjV0MTI1IDEwLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxZmQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE3OTIgMTI4di0zODRoLTE3OTJ2Mzg0cTQ1IDAgODUgMTR0NTkgMjcuNXQ0NyAzNy41cTMwIDI3IDUxLjUgMzh0NTYuNSAxMXQ1NS41IC0xMXQ1Mi41IC0zOHEyOSAtMjUgNDcgLTM4dDU4IC0yN3Q4NiAtMTRxNDUgMCA4NSAxNC41dDU4IDI3dDQ4IDM3LjVxMjEgMTkgMzIuNSAyN3QzMSAxNXQ0My41IDdxMzUgMCA1Ni41IC0xMXQ1MS41IC0zOHEyOCAtMjQgNDcgLTM3LjV0NTkgLTI3LjV0ODUgLTE0dDg1IDE0dDU5IDI3LjV0NDcgMzcuNSBxMzAgMjcgNTEuNSAzOHQ1Ni41IDExcTM0IDAgNTUuNSAtMTF0NTEuNSAtMzhxMjggLTI0IDQ3IC0zNy41dDU5IC0yNy41dDg1IC0xNHpNMTc5MiA0NDh2LTE5MnEtMzUgMCAtNTUuNSAxMXQtNTIuNSAzOHEtMjkgMjUgLTQ3IDM4dC01OCAyN3QtODUgMTRxLTQ2IDAgLTg2IC0xNHQtNTggLTI3dC00NyAtMzhxLTIyIC0xOSAtMzMgLTI3dC0zMSAtMTV0LTQ0IC03cS0zNSAwIC01Ni41IDExdC01MS41IDM4cS0yOSAyNSAtNDcgMzh0LTU4IDI3IHQtODYgMTRxLTQ1IDAgLTg1IC0xNC41dC01OCAtMjd0LTQ4IC0zNy41cS0yMSAtMTkgLTMyLjUgLTI3dC0zMSAtMTV0LTQzLjUgLTdxLTM1IDAgLTU2LjUgMTF0LTUxLjUgMzhxLTI4IDI0IC00NyAzNy41dC01OSAyNy41dC04NSAxNHEtNDYgMCAtODYgLTE0dC01OCAtMjd0LTQ3IC0zOHEtMzAgLTI3IC01MS41IC0zOHQtNTYuNSAtMTF2MTkycTAgODAgNTYgMTM2dDEzNiA1Nmg2NHY0NDhoMjU2di00NDhoMjU2djQ0OGgyNTZ2LTQ0OGgyNTZ2NDQ4IGgyNTZ2LTQ0OGg2NHE4MCAwIDEzNiAtNTZ0NTYgLTEzNnpNNTEyIDEzMTJxMCAtNzcgLTM2IC0xMTguNXQtOTIgLTQxLjVxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41cTAgMjkgOS41IDUxdDIzLjUgMzR0MzEgMjh0MzEgMzEuNXQyMy41IDQ0LjV0OS41IDY3cTM4IDAgODMgLTc0dDQ1IC0xNTB6TTEwMjQgMTMxMnEwIC03NyAtMzYgLTExOC41dC05MiAtNDEuNXEtNTMgMCAtOTAuNSAzNy41dC0zNy41IDkwLjVxMCAyOSA5LjUgNTEgdDIzLjUgMzR0MzEgMjh0MzEgMzEuNXQyMy41IDQ0LjV0OS41IDY3cTM4IDAgODMgLTc0dDQ1IC0xNTB6TTE1MzYgMTMxMnEwIC03NyAtMzYgLTExOC41dC05MiAtNDEuNXEtNTMgMCAtOTAuNSAzNy41dC0zNy41IDkwLjVxMCAyOSA5LjUgNTF0MjMuNSAzNHQzMSAyOHQzMSAzMS41dDIzLjUgNDQuNXQ5LjUgNjdxMzggMCA4MyAtNzR0NDUgLTE1MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjFmZTsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMjA0OCAwdi0xMjhoLTIwNDh2MTUzNmgxMjh2LTE0MDhoMTkyMHpNMTY2NCAxMDI0bDI1NiAtODk2aC0xNjY0djU3Nmw0NDggNTc2bDU3NiAtNTc2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjAwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik03NjggNjQ2bDU0NiAtNTQ2cS0xMDYgLTEwOCAtMjQ3LjUgLTE2OHQtMjk4LjUgLTYwcS0yMDkgMCAtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN2LTc2MnpNOTU1IDY0MGg3NzNxMCAtMTU3IC02MCAtMjk4LjV0LTE2OCAtMjQ3LjV6TTE2NjQgNzY4aC03Njh2NzY4cTIwOSAwIDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMDE7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTIwNDggMHYtMTI4aC0yMDQ4djE1MzZoMTI4di0xNDA4aDE5MjB6TTE5MjAgMTI0OHYtNDM1cTAgLTIxIC0xOS41IC0yOS41dC0zNS41IDcuNWwtMTIxIDEyMWwtNjMzIC02MzNxLTEwIC0xMCAtMjMgLTEwdC0yMyAxMGwtMjMzIDIzM2wtNDE2IC00MTZsLTE5MiAxOTJsNTg1IDU4NXExMCAxMCAyMyAxMHQyMyAtMTBsMjMzIC0yMzNsNDY0IDQ2NGwtMTIxIDEyMXEtMTYgMTYgLTcuNSAzNS41dDI5LjUgMTkuNWg0MzVxMTQgMCAyMyAtOSB0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMDI7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEyOTIgODMycTAgLTYgMTAgLTQxcTEwIC0yOSAyNSAtNDkuNXQ0MSAtMzR0NDQgLTIwdDU1IC0xNi41cTMyNSAtOTEgMzI1IC0zMzJxMCAtMTQ2IC0xMDUuNSAtMjQyLjV0LTI1NC41IC05Ni41cS01OSAwIC0xMTEuNSAxOC41dC05MS41IDQ1LjV0LTc3IDc0LjV0LTYzIDg3LjV0LTUzLjUgMTAzLjV0LTQzLjUgMTAzdC0zOS41IDEwNi41dC0zNS41IDk1cS0zMiA4MSAtNjEuNSAxMzMuNXQtNzMuNSA5Ni41dC0xMDQgNjR0LTE0MiAyMCBxLTk2IDAgLTE4MyAtNTUuNXQtMTM4IC0xNDQuNXQtNTEgLTE4NXEwIC0xNjAgMTA2LjUgLTI3OS41dDI2My41IC0xMTkuNXExNzcgMCAyNTggOTVxNTYgNjMgODMgMTE2bDg0IC0xNTJxLTE1IC0zNCAtNDQgLTcwbDEgLTFxLTEzMSAtMTUyIC0zODggLTE1MnEtMTQ3IDAgLTI2OS41IDc5dC0xOTAuNSAyMDcuNXQtNjggMjc0LjVxMCAxMDUgNDMuNSAyMDZ0MTE2IDE3Ni41dDE3MiAxMjEuNXQyMDQuNSA0NnE4NyAwIDE1OSAtMTl0MTIzLjUgLTUwIHQ5NSAtODB0NzIuNSAtOTl0NTguNSAtMTE3dDUwLjUgLTEyNC41dDUwIC0xMzAuNXQ1NSAtMTI3cTk2IC0yMDAgMjMzIC0yMDBxODEgMCAxMzguNSA0OC41dDU3LjUgMTI4LjVxMCA0MiAtMTkgNzJ0LTUwLjUgNDZ0LTcyLjUgMzEuNXQtODQuNSAyN3QtODcuNSAzNHQtODEgNTJ0LTY1IDgydC0zOSAxMjIuNXEtMyAxNiAtMyAzM3EwIDExMCA4Ny41IDE5MnQxOTguNSA3OHE3OCAtMyAxMjAuNSAtMTQuNXQ5MC41IC01My41aC0xIHExMiAtMTEgMjMgLTI0LjV0MjYgLTM2dDE5IC0yNy41bC0xMjkgLTk5cS0yNiA0OSAtNTQgNzB2MXEtMjMgMjEgLTk3IDIxcS00OSAwIC04NCAtMzN0LTM1IC04M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIwMzsiIGQ9Ik0xNDMyIDQ4NHEwIDE3MyAtMjM0IDIzOXEtMzUgMTAgLTUzIDE2LjV0LTM4IDI1dC0yOSA0Ni41cTAgMiAtMiA4LjV0LTMgMTJ0LTEgNy41cTAgMzYgMjQuNSA1OS41dDYwLjUgMjMuNXE1NCAwIDcxIC0xNWgtMXEyMCAtMTUgMzkgLTUxbDkzIDcxcS0zOSA1NCAtNDkgNjRxLTMzIDI5IC02Ny41IDM5dC04NS41IDEwcS04MCAwIC0xNDIgLTU3LjV0LTYyIC0xMzcuNXEwIC03IDIgLTIzcTE2IC05NiA2NC41IC0xNDB0MTQ4LjUgLTczIHEyOSAtOCA0OSAtMTUuNXQ0NSAtMjEuNXQzOC41IC0zNC41dDEzLjUgLTQ2LjV2LTVxMSAtNTggLTQwLjUgLTkzdC0xMDAuNSAtMzVxLTk3IDAgLTE2NyAxNDRxLTIzIDQ3IC01MS41IDEyMS41dC00OCAxMjUuNXQtNTQgMTEwLjV0LTc0IDk1LjV0LTEwMy41IDYwLjV0LTE0NyAyNC41cS0xMDEgMCAtMTkyIC01NnQtMTQ0IC0xNDh0LTUwIC0xOTJ2LTFxNCAtMTA4IDUwLjUgLTE5OXQxMzMuNSAtMTQ3LjV0MTk2IC01Ni41cTE4NiAwIDI3OSAxMTAgcTIwIDI3IDMxIDUxbC02MCAxMDlxLTQyIC04MCAtOTkgLTExNnQtMTQ2IC0zNnEtMTE1IDAgLTE5MSA4N3QtNzYgMjA0cTAgMTA1IDgyIDE4OXQxODYgODRxMTEyIDAgMTcwIC01My41dDEwNCAtMTcyLjVxOCAtMjEgMjUuNSAtNjguNXQyOC41IC03Ni41dDMxLjUgLTc0LjV0MzguNSAtNzR0NDUuNSAtNjIuNXQ1NS41IC01My41dDY2IC0zM3Q4MCAtMTMuNXExMDcgMCAxODMgNjkuNXQ3NiAxNzQuNXpNMTUzNiAxMTIwdi05NjAgcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41dDg0LjUgLTIwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjA0OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xMTUyIDY0MHEwIDEwNCAtNDAuNSAxOTguNXQtMTA5LjUgMTYzLjV0LTE2My41IDEwOS41dC0xOTguNSA0MC41dC0xOTguNSAtNDAuNXQtMTYzLjUgLTEwOS41dC0xMDkuNSAtMTYzLjV0LTQwLjUgLTE5OC41dDQwLjUgLTE5OC41dDEwOS41IC0xNjMuNXQxNjMuNSAtMTA5LjV0MTk4LjUgLTQwLjV0MTk4LjUgNDAuNXQxNjMuNSAxMDkuNXQxMDkuNSAxNjMuNXQ0MC41IDE5OC41ek0xOTIwIDY0MHEwIDEwNCAtNDAuNSAxOTguNSB0LTEwOS41IDE2My41dC0xNjMuNSAxMDkuNXQtMTk4LjUgNDAuNWgtMzg2cTExOSAtOTAgMTg4LjUgLTIyNHQ2OS41IC0yODh0LTY5LjUgLTI4OHQtMTg4LjUgLTIyNGgzODZxMTA0IDAgMTk4LjUgNDAuNXQxNjMuNSAxMDkuNXQxMDkuNSAxNjMuNXQ0MC41IDE5OC41ek0yMDQ4IDY0MHEwIC0xMzAgLTUxIC0yNDguNXQtMTM2LjUgLTIwNHQtMjA0IC0xMzYuNXQtMjQ4LjUgLTUxaC03NjhxLTEzMCAwIC0yNDguNSA1MXQtMjA0IDEzNi41IHQtMTM2LjUgMjA0dC01MSAyNDguNXQ1MSAyNDguNXQxMzYuNSAyMDR0MjA0IDEzNi41dDI0OC41IDUxaDc2OHExMzAgMCAyNDguNSAtNTF0MjA0IC0xMzYuNXQxMzYuNSAtMjA0dDUxIC0yNDguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIwNTsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMCA2NDBxMCAxMzAgNTEgMjQ4LjV0MTM2LjUgMjA0dDIwNCAxMzYuNXQyNDguNSA1MWg3NjhxMTMwIDAgMjQ4LjUgLTUxdDIwNCAtMTM2LjV0MTM2LjUgLTIwNHQ1MSAtMjQ4LjV0LTUxIC0yNDguNXQtMTM2LjUgLTIwNHQtMjA0IC0xMzYuNXQtMjQ4LjUgLTUxaC03NjhxLTEzMCAwIC0yNDguNSA1MXQtMjA0IDEzNi41dC0xMzYuNSAyMDR0LTUxIDI0OC41ek0xNDA4IDEyOHExMDQgMCAxOTguNSA0MC41dDE2My41IDEwOS41IHQxMDkuNSAxNjMuNXQ0MC41IDE5OC41dC00MC41IDE5OC41dC0xMDkuNSAxNjMuNXQtMTYzLjUgMTA5LjV0LTE5OC41IDQwLjV0LTE5OC41IC00MC41dC0xNjMuNSAtMTA5LjV0LTEwOS41IC0xNjMuNXQtNDAuNSAtMTk4LjV0NDAuNSAtMTk4LjV0MTA5LjUgLTE2My41dDE2My41IC0xMDkuNXQxOTguNSAtNDAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIwNjsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNNzYyIDM4NGgtMzE0cS00MCAwIC01Ny41IDM1dDYuNSA2N2wxODggMjUxcS02NSAzMSAtMTM3IDMxcS0xMzIgMCAtMjI2IC05NHQtOTQgLTIyNnQ5NCAtMjI2dDIyNiAtOTRxMTE1IDAgMjAzIDcyLjV0MTExIDE4My41ek01NzYgNTEyaDE4NnEtMTggODUgLTc1IDE0OHpNMTA1NiA1MTJsMjg4IDM4NGgtNDgwbC05OSAtMTMycTEwNSAtMTAzIDEyNiAtMjUyaDE2NXpNMjE3NiA0NDhxMCAxMzIgLTk0IDIyNnQtMjI2IDk0IHEtNjAgMCAtMTIxIC0yNGwxNzQgLTI2MHExNSAtMjMgMTAgLTQ5dC0yNyAtNDBxLTE1IC0xMSAtMzYgLTExcS0zNSAwIC01MyAyOWwtMTc0IDI2MHEtOTMgLTk1IC05MyAtMjI1cTAgLTEzMiA5NCAtMjI2dDIyNiAtOTR0MjI2IDk0dDk0IDIyNnpNMjMwNCA0NDhxMCAtMTg1IC0xMzEuNSAtMzE2LjV0LTMxNi41IC0xMzEuNXQtMzE2LjUgMTMxLjV0LTEzMS41IDMxNi41cTAgOTcgMzkuNSAxODMuNXQxMDkuNSAxNDkuNWwtNjUgOThsLTM1MyAtNDY5IHEtMTggLTI2IC01MSAtMjZoLTE5N3EtMjMgLTE2NCAtMTQ5IC0yNzR0LTI5NCAtMTEwcS0xODUgMCAtMzE2LjUgMTMxLjV0LTEzMS41IDMxNi41dDEzMS41IDMxNi41dDMxNi41IDEzMS41cTExNCAwIDIxNSAtNTVsMTM3IDE4M2gtMjI0cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMzg0di0xMjhoNDM1bC04NSAxMjhoLTIyMnEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5aDI1NnEzMyAwIDUzIC0yOGwyNjcgLTQwMCBxOTEgNDQgMTkyIDQ0cTE4NSAwIDMxNi41IC0xMzEuNXQxMzEuNSAtMzE2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMDc7IiBkPSJNMzg0IDMyMHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXQzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXpNMTQwOCAzMjBxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTEzNjIgNzE2bC03MiAzODRxLTUgMjMgLTIyLjUgMzcuNXQtNDAuNSAxNC41IGgtOTE4cS0yMyAwIC00MC41IC0xNC41dC0yMi41IC0zNy41bC03MiAtMzg0cS01IC0zMCAxNCAtNTN0NDkgLTIzaDEwNjJxMzAgMCA0OSAyM3QxNCA1M3pNMTEzNiAxMzI4cTAgMjAgLTE0IDM0dC0zNCAxNGgtNjQwcS0yMCAwIC0zNCAtMTR0LTE0IC0zNHQxNCAtMzR0MzQgLTE0aDY0MHEyMCAwIDM0IDE0dDE0IDM0ek0xNTM2IDYwM3YtNjAzaC0xMjh2LTEyOHEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNXQtOTAuNSAzNy41IHQtMzcuNSA5MC41djEyOGgtNzY4di0xMjhxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41djEyOGgtMTI4djYwM3EwIDExMiAyNSAyMjNsMTAzIDQ1NHE5IDc4IDk3LjUgMTM3dDIzMCA4OXQzMTIuNSAzMHQzMTIuNSAtMzB0MjMwIC04OXQ5Ny41IC0xMzdsMTA1IC00NTRxMjMgLTEwMiAyMyAtMjIzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjA4OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xNDYzIDcwNHEwIC0zNSAtMjUgLTYwLjV0LTYxIC0yNS41aC03MDJxLTM2IDAgLTYxIDI1LjV0LTI1IDYwLjV0MjUgNjAuNXQ2MSAyNS41aDcwMnEzNiAwIDYxIC0yNS41dDI1IC02MC41ek0xNjc3IDcwNHEwIDg2IC0yMyAxNzBoLTk4MnEtMzYgMCAtNjEgMjV0LTI1IDYwcTAgMzYgMjUgNjF0NjEgMjVoOTA4cS04OCAxNDMgLTIzNSAyMjd0LTMyMCA4NHEtMTc3IDAgLTMyNy41IC04Ny41dC0yMzggLTIzNy41dC04Ny41IC0zMjcgcTAgLTg2IDIzIC0xNzBoOTgycTM2IDAgNjEgLTI1dDI1IC02MHEwIC0zNiAtMjUgLTYxdC02MSAtMjVoLTkwOHE4OCAtMTQzIDIzNS41IC0yMjd0MzIwLjUgLTg0cTEzMiAwIDI1MyA1MS41dDIwOCAxMzl0MTM5IDIwOHQ1MiAyNTMuNXpNMjA0OCA5NTlxMCAtMzUgLTI1IC02MHQtNjEgLTI1aC0xMzFxMTcgLTg1IDE3IC0xNzBxMCAtMTY3IC02NS41IC0zMTkuNXQtMTc1LjUgLTI2M3QtMjYyLjUgLTE3NnQtMzE5LjUgLTY1LjUgcS0yNDYgMCAtNDQ4LjUgMTMzdC0zMDEuNSAzNTBoLTE4OXEtMzYgMCAtNjEgMjV0LTI1IDYxcTAgMzUgMjUgNjB0NjEgMjVoMTMycS0xNyA4NSAtMTcgMTcwcTAgMTY3IDY1LjUgMzE5LjV0MTc1LjUgMjYzdDI2Mi41IDE3NnQzMjAuNSA2NS41cTI0NSAwIDQ0Ny41IC0xMzN0MzAxLjUgLTM1MGgxODhxMzYgMCA2MSAtMjV0MjUgLTYxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjA5OyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik05NTMgMTE1OGwtMTE0IC0zMjhsMTE3IC0yMXExNjUgNDUxIDE2NSA1MThxMCA1NiAtMzggNTZxLTU3IDAgLTEzMCAtMjI1ek02NTQgNDcxbDMzIC04OHEzNyA0MiA3MSA2N2wtMzMgNS41dC0zOC41IDd0LTMyLjUgOC41ek0zNjIgMTM2N3EwIC05OCAxNTkgLTUyMXExOCAxMCA0OSAxMHExNSAwIDc1IC01bC0xMjEgMzUxcS03NSAyMjAgLTEyMyAyMjBxLTE5IDAgLTI5IC0xNy41dC0xMCAtMzcuNXpNMjgzIDYwOHEwIC0zNiA1MS41IC0xMTkgdDExNy41IC0xNTN0MTAwIC03MHExNCAwIDI1LjUgMTN0MTEuNSAyN3EwIDI0IC0zMiAxMDJxLTEzIDMyIC0zMiA3MnQtNDcuNSA4OXQtNjEuNSA4MXQtNjIgMzJxLTIwIDAgLTQ1LjUgLTI3dC0yNS41IC00N3pNMTI1IDI3M3EwIC00MSAyNSAtMTA0cTU5IC0xNDUgMTgzLjUgLTIyN3QyODEuNSAtODJxMjI3IDAgMzgyIDE3MHExNTIgMTY5IDE1MiA0MjdxMCA0MyAtMSA2N3QtMTEuNSA2MnQtMzAuNSA1NnEtNTYgNDkgLTIxMS41IDc1LjUgdC0yNzAuNSAyNi41cS0zNyAwIC00OSAtMTFxLTEyIC01IC0xMiAtMzVxMCAtMzQgMjEuNSAtNjB0NTUuNSAtNDB0NzcuNSAtMjMuNXQ4Ny41IC0xMS41dDg1IC00dDcwIDBoMjNxMjQgMCA0MCAtMTlxMTUgLTE5IDE5IC01NXEtMjggLTI4IC05NiAtNTRxLTYxIC0yMiAtOTMgLTQ2cS02NCAtNDYgLTEwOC41IC0xMTR0LTQ0LjUgLTEzN3EwIC0zMSAxOC41IC04OC41dDE4LjUgLTg3LjVsLTMgLTEycS00IC0xMiAtNCAtMTQgcS0xMzcgMTAgLTE0NiAyMTZxLTggLTIgLTQxIC0ycTIgLTcgMiAtMjFxMCAtNTMgLTQwLjUgLTg5LjV0LTk0LjUgLTM2LjVxLTgyIDAgLTE2Ni41IDc4dC04NC41IDE1OXEwIDM0IDMzIDY3cTUyIC02NCA2MCAtNzZxNzcgLTEwNCAxMzMgLTEwNHExMiAwIDI2LjUgOC41dDE0LjUgMjAuNXEwIDM0IC04Ny41IDE0NXQtMTE2LjUgMTExcS00MyAwIC03MCAtNDQuNXQtMjcgLTkwLjV6TTExIDI2NHEwIDEwMSA0Mi41IDE2M3QxMzYuNSA4OCBxLTI4IDc0IC0yOCAxMDRxMCA2MiA2MSAxMjN0MTIyIDYxcTI5IDAgNzAgLTE1cS0xNjMgNDYyIC0xNjMgNTY3cTAgODAgNDEgMTMwLjV0MTE5IDUwLjVxMTMxIDAgMzI1IC01ODFxNiAtMTcgOCAtMjNxNiAxNiAyOSA3OS41dDQzLjUgMTE4LjV0NTQgMTI3LjV0NjQuNSAxMjN0NzAuNSA4Ni41dDc2LjUgMzZxNzEgMCAxMTIgLTQ5dDQxIC0xMjJxMCAtMTA4IC0xNTkgLTU1MHE2MSAtMTUgMTAwLjUgLTQ2dDU4LjUgLTc4dDI2IC05My41IHQ3IC0xMTAuNXEwIC0xNTAgLTQ3IC0yODB0LTEzMiAtMjI1dC0yMTEgLTE1MHQtMjc4IC01NXEtMTExIDAgLTIyMyA0MnEtMTQ5IDU3IC0yNTggMTkxLjV0LTEwOSAyODYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIwYTsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNNzg1IDUyOGgyMDdxLTE0IC0xNTggLTk4LjUgLTI0OC41dC0yMTQuNSAtOTAuNXEtMTYyIDAgLTI1NC41IDExNnQtOTIuNSAzMTZxMCAxOTQgOTMgMzExLjV0MjMzIDExNy41cTE0OCAwIDIzMiAtODd0OTcgLTI0N2gtMjAzcS01IDY0IC0zNS41IDk5dC04MS41IDM1cS01NyAwIC04OC41IC02MC41dC0zMS41IC0xNzcuNXEwIC00OCA1IC04NHQxOCAtNjkuNXQ0MCAtNTEuNXQ2NiAtMThxOTUgMCAxMDkgMTM5ek0xNDk3IDUyOGgyMDYgcS0xNCAtMTU4IC05OCAtMjQ4LjV0LTIxNCAtOTAuNXEtMTYyIDAgLTI1NC41IDExNnQtOTIuNSAzMTZxMCAxOTQgOTMgMzExLjV0MjMzIDExNy41cTE0OCAwIDIzMiAtODd0OTcgLTI0N2gtMjA0cS00IDY0IC0zNSA5OXQtODEgMzVxLTU3IDAgLTg4LjUgLTYwLjV0LTMxLjUgLTE3Ny41cTAgLTQ4IDUgLTg0dDE4IC02OS41dDM5LjUgLTUxLjV0NjUuNSAtMThxNDkgMCA3Ni41IDM4dDMzLjUgMTAxek0xODU2IDY0N3EwIDIwNyAtMTUuNSAzMDcgdC02MC41IDE2MXEtNiA4IC0xMy41IDE0dC0yMS41IDE1dC0xNiAxMXEtODYgNjMgLTY5NyA2M3EtNjI1IDAgLTcxMCAtNjNxLTUgLTQgLTE3LjUgLTExLjV0LTIxIC0xNHQtMTQuNSAtMTQuNXEtNDUgLTYwIC02MCAtMTU5LjV0LTE1IC0zMDguNXEwIC0yMDggMTUgLTMwNy41dDYwIC0xNjAuNXE2IC04IDE1IC0xNXQyMC41IC0xNHQxNy41IC0xMnE0NCAtMzMgMjM5LjUgLTQ5dDQ3MC41IC0xNnE2MTAgMCA2OTcgNjVxNSA0IDE3IDExdDIwLjUgMTQgdDEzLjUgMTZxNDYgNjAgNjEgMTU5dDE1IDMwOXpNMjA0OCAxNDA4di0xNTM2aC0yMDQ4djE1MzZoMjA0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIwYjsiIGQ9Ik05OTIgOTEydi00OTZxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTYwcS0xNCAwIC0yMyA5dC05IDIzdjQ5NnEwIDExMiAtODAgMTkydC0xOTIgODBoLTI3MnYtMTE1MnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xNjBxLTE0IDAgLTIzIDl0LTkgMjN2MTM0NHEwIDE0IDkgMjN0MjMgOWg0NjRxMTM1IDAgMjQ5IC02Ni41dDE4MC41IC0xODAuNXQ2Ni41IC0yNDl6TTEzNzYgMTM3NnYtODgwcTAgLTEzNSAtNjYuNSAtMjQ5dC0xODAuNSAtMTgwLjUgdC0yNDkgLTY2LjVoLTQ2NHEtMTQgMCAtMjMgOXQtOSAyM3Y5NjBxMCAxNCA5IDIzdDIzIDloMTYwcTE0IDAgMjMgLTl0OSAtMjN2LTc2OGgyNzJxMTEyIDAgMTkyIDgwdDgwIDE5MnY4ODBxMCAxNCA5IDIzdDIzIDloMTYwcTE0IDAgMjMgLTl0OSAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMGM7IiBkPSJNMTMxMSA2OTR2LTExNHEwIC0yNCAtMTMuNSAtMzh0LTM3LjUgLTE0aC0yMDJxLTI0IDAgLTM4IDE0dC0xNCAzOHYxMTRxMCAyNCAxNCAzOHQzOCAxNGgyMDJxMjQgMCAzNy41IC0xNHQxMy41IC0zOHpNODIxIDQ2NHYyNTBxMCA1MyAtMzIuNSA4NS41dC04NS41IDMyLjVoLTEzM3EtNjggMCAtOTYgLTUycS0yOCA1MiAtOTYgNTJoLTEzMHEtNTMgMCAtODUuNSAtMzIuNXQtMzIuNSAtODUuNXYtMjUwcTAgLTIyIDIxIC0yMmg1NSBxMjIgMCAyMiAyMnYyMzBxMCAyNCAxMy41IDM4dDM4LjUgMTRoOTRxMjQgMCAzOCAtMTR0MTQgLTM4di0yMzBxMCAtMjIgMjEgLTIyaDU0cTIyIDAgMjIgMjJ2MjMwcTAgMjQgMTQgMzh0MzggMTRoOTdxMjQgMCAzNy41IC0xNHQxMy41IC0zOHYtMjMwcTAgLTIyIDIyIC0yMmg1NXEyMSAwIDIxIDIyek0xNDEwIDU2MHYxNTRxMCA1MyAtMzMgODUuNXQtODYgMzIuNWgtMjY0cS01MyAwIC04NiAtMzIuNXQtMzMgLTg1LjV2LTQxMCBxMCAtMjEgMjIgLTIxaDU1cTIxIDAgMjEgMjF2MTgwcTMxIC00MiA5NCAtNDJoMTkxcTUzIDAgODYgMzIuNXQzMyA4NS41ek0xNTM2IDExNzZ2LTEwNzJxMCAtOTYgLTY4IC0xNjR0LTE2NCAtNjhoLTEwNzJxLTk2IDAgLTE2NCA2OHQtNjggMTY0djEwNzJxMCA5NiA2OCAxNjR0MTY0IDY4aDEwNzJxOTYgMCAxNjQgLTY4dDY4IC0xNjR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMGQ7IiBkPSJNOTE1IDQ1MGgtMjk0bDE0NyA1NTF6TTEwMDEgMTI4aDMxMWwtMzI0IDEwMjRoLTQ0MGwtMzI0IC0xMDI0aDMxMWwzODMgMzE0ek0xNTM2IDExMjB2LTk2MHEwIC0xMTggLTg1IC0yMDN0LTIwMyAtODVoLTk2MHEtMTE4IDAgLTIwMyA4NXQtODUgMjAzdjk2MHEwIDExOCA4NSAyMDN0MjAzIDg1aDk2MHExMTggMCAyMDMgLTg1dDg1IC0yMDN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMGU7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTIwNDggNjQxcTAgLTIxIC0xMyAtMzYuNXQtMzMgLTE5LjVsLTIwNSAtMzU2cTMgLTkgMyAtMThxMCAtMjAgLTEyLjUgLTM1LjV0LTMyLjUgLTE5LjVsLTE5MyAtMzM3cTMgLTggMyAtMTZxMCAtMjMgLTE2LjUgLTQwdC00MC41IC0xN3EtMjUgMCAtNDEgMThoLTQwMHEtMTcgLTIwIC00MyAtMjB0LTQzIDIwaC0zOTlxLTE3IC0yMCAtNDMgLTIwcS0yMyAwIC00MCAxNi41dC0xNyA0MC41cTAgOCA0IDIwbC0xOTMgMzM1IHEtMjAgNCAtMzIuNSAxOS41dC0xMi41IDM1LjVxMCA5IDMgMThsLTIwNiAzNTZxLTIwIDUgLTMyLjUgMjAuNXQtMTIuNSAzNS41cTAgMjEgMTMuNSAzNi41dDMzLjUgMTkuNWwxOTkgMzQ0cTAgMSAtMC41IDN0LTAuNSAzcTAgMzYgMzQgNTFsMjA5IDM2M3EtNCAxMCAtNCAxOHEwIDI0IDE3IDQwLjV0NDAgMTYuNXEyNiAwIDQ0IC0yMWgzOTZxMTYgMjEgNDMgMjF0NDMgLTIxaDM5OHExOCAyMSA0NCAyMXEyMyAwIDQwIC0xNi41dDE3IC00MC41IHEwIC02IC00IC0xOGwyMDcgLTM1OHEyMyAtMSAzOSAtMTcuNXQxNiAtMzguNXEwIC0xMyAtNyAtMjdsMTg3IC0zMjRxMTkgLTQgMzEuNSAtMTkuNXQxMi41IC0zNS41ek0xMDYzIC0xNThoMzg5bC0zNDIgMzU0aC0xNDNsLTM0MiAtMzU0aDM2MHExOCAxNiAzOSAxNnQzOSAtMTZ6TTExMiA2NTRxMSAtNCAxIC0xM3EwIC0xMCAtMiAtMTVsMjA4IC0zNjBxMiAwIDQuNSAtMXQ1LjUgLTIuNWw1IC0yLjVsMTg4IDE5OXYzNDdsLTE4NyAxOTQgcS0xMyAtOCAtMjkgLTEwek05ODYgMTQzOGgtMzg4bDE5MCAtMjAwbDU1NCAyMDBoLTI4MHEtMTYgLTE2IC0zOCAtMTZ0LTM4IDE2ek0xNjg5IDIyNnExIDYgNSAxMWwtNjQgNjhsLTE3IC03OWg3NnpNMTU4MyAyMjZsMjIgMTA1bC0yNTIgMjY2bC0yOTYgLTMwN2w2MyAtNjRoNDYzek0xNDk1IC0xNDJsMTYgMjhsNjUgMzEwaC00MjdsMzMzIC0zNDNxOCA0IDEzIDV6TTU3OCAtMTU4aDVsMzQyIDM1NGgtMzczdi0zMzVsNCAtNnExNCAtNSAyMiAtMTMgek01NTIgMjI2aDQwMmw2NCA2NmwtMzA5IDMyMWwtMTU3IC0xNjZ2LTIyMXpNMzU5IDIyNmgxNjN2MTg5bC0xNjggLTE3N3E0IC04IDUgLTEyek0zNTggMTA1MXEwIC0xIDAuNSAtMnQwLjUgLTJxMCAtMTYgLTggLTI5bDE3MSAtMTc3djI2OXpNNTUyIDExMjF2LTMxMWwxNTMgLTE1N2wyOTcgMzE0bC0yMjMgMjM2ek01NTYgMTQyNWwtNCAtOHYtMjY0bDIwNSA3NGwtMTkxIDIwMXEtNiAtMiAtMTAgLTN6TTE0NDcgMTQzOGgtMTZsLTYyMSAtMjI0IGwyMTMgLTIyNXpNMTAyMyA5NDZsLTI5NyAtMzE1bDMxMSAtMzE5bDI5NiAzMDd6TTY4OCA2MzRsLTEzNiAxNDF2LTI4NHpNMTAzOCAyNzBsLTQyIC00NGg4NXpNMTM3NCA2MThsMjM4IC0yNTFsMTMyIDYyNGwtMyA1bC0xIDF6TTE3MTggMTAxOHEtOCAxMyAtOCAyOXYybC0yMTYgMzc2cS01IDEgLTEzIDVsLTQzNyAtNDYzbDMxMCAtMzI3ek01MjIgMTE0MnYyMjNsLTE2MyAtMjgyek01MjIgMTk2aC0xNjNsMTYzIC0yODN2Mjgzek0xNjA3IDE5NiBsLTQ4IC0yMjdsMTMwIDIyN2gtODJ6TTE3MjkgMjY2bDIwNyAzNjFxLTIgMTAgLTIgMTRxMCAxIDMgMTZsLTE3MSAyOTZsLTEyOSAtNjEybDc3IC04MnE1IDMgMTUgN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxMDsiIGQ9Ik0wIDg1NnEwIDEzMSA5MS41IDIyNi41dDIyMi41IDk1LjVoNzQybDM1MiAzNTh2LTE0NzBxMCAtMTMyIC05MS41IC0yMjd0LTIyMi41IC05NWgtNzgwcS0xMzEgMCAtMjIyLjUgOTV0LTkxLjUgMjI3djc5MHpNMTIzMiAxMDJsLTE3NiAxODB2NDI1cTAgNDYgLTMyIDc5dC03OCAzM2gtNDg0cS00NiAwIC03OCAtMzN0LTMyIC03OXYtNDkycTAgLTQ2IDMyLjUgLTc5LjV0NzcuNSAtMzMuNWg3NzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMTE7IiBkPSJNOTM0IDEzODZxLTMxNyAtMTIxIC01NTYgLTM2Mi41dC0zNTggLTU2MC41cS0yMCA4OSAtMjAgMTc2cTAgMjA4IDEwMi41IDM4NC41dDI3OC41IDI3OXQzODQgMTAyLjVxODIgMCAxNjkgLTE5ek0xMjAzIDEyNjdxOTMgLTY1IDE2NCAtMTU1cS0zODkgLTExMyAtNjc0LjUgLTQwMC41dC0zOTYuNSAtNjc2LjVxLTkzIDcyIC0xNTUgMTYycTExMiAzODYgMzk1IDY3MXQ2NjcgMzk5ek00NzAgLTY3cTExNSAzNTYgMzc5LjUgNjIydDYxOS41IDM4NCBxNDAgLTkyIDU0IC0xOTVxLTI5MiAtMTIwIC01MTYgLTM0NXQtMzQzIC01MThxLTEwMyAxNCAtMTk0IDUyek0xNTM2IC0xMjVxLTE5MyA1MCAtMzY3IDExNXEtMTM1IC04NCAtMjkwIC0xMDdxMTA5IDIwNSAyNzQgMzcwLjV0MzY5IDI3NS41cS0yMSAtMTUyIC0xMDEgLTI4NHE2NSAtMTc1IDExNSAtMzcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjEyOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xODkzIDExNDRsMTU1IC0xMjcycS0xMzEgMCAtMjU3IDU3cS0yMDAgOTEgLTM5MyA5MXEtMjI2IDAgLTM3NCAtMTQ4cS0xNDggMTQ4IC0zNzQgMTQ4cS0xOTMgMCAtMzkzIC05MXEtMTI4IC01NyAtMjUyIC01N2gtNWwxNTUgMTI3MnEyMjQgMTI3IDQ4MiAxMjdxMjMzIDAgMzg3IC0xMDZxMTU0IDEwNiAzODcgMTA2cTI1OCAwIDQ4MiAtMTI3ek0xMzk4IDE1N3ExMjkgMCAyMzIgLTI4LjV0MjYwIC05My41bC0xMjQgMTAyMSBxLTE3MSA3OCAtMzY4IDc4cS0yMjQgMCAtMzc0IC0xNDFxLTE1MCAxNDEgLTM3NCAxNDFxLTE5NyAwIC0zNjggLTc4bC0xMjQgLTEwMjFxMTA1IDQzIDE2NS41IDY1dDE0OC41IDM5LjV0MTc4IDE3LjVxMjAyIDAgMzc0IC0xMDhxMTcyIDEwOCAzNzQgMTA4ek0xNDM4IDE5MWwtNTUgOTA3cS0yMTEgLTQgLTM1OSAtMTU1cS0xNTIgMTU1IC0zNzQgMTU1cS0xNzYgMCAtMzM2IC02NmwtMTE0IC05NDFxMTI0IDUxIDIyOC41IDc2dDIyMS41IDI1IHEyMDkgMCAzNzQgLTEwMnExNzIgMTA3IDM3NCAxMDJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMTM7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTE1MDAgMTY1djczM3EwIDIxIC0xNSAzNnQtMzUgMTVoLTkzcS0yMCAwIC0zNSAtMTV0LTE1IC0zNnYtNzMzcTAgLTIwIDE1IC0zNXQzNSAtMTVoOTNxMjAgMCAzNSAxNXQxNSAzNXpNMTIxNiAxNjV2NTMxcTAgMjAgLTE1IDM1dC0zNSAxNWgtMTAxcS0yMCAwIC0zNSAtMTV0LTE1IC0zNXYtNTMxcTAgLTIwIDE1IC0zNXQzNSAtMTVoMTAxcTIwIDAgMzUgMTV0MTUgMzV6TTkyNCAxNjV2NDI5cTAgMjAgLTE1IDM1dC0zNSAxNWgtMTAxIHEtMjAgMCAtMzUgLTE1dC0xNSAtMzV2LTQyOXEwIC0yMCAxNSAtMzV0MzUgLTE1aDEwMXEyMCAwIDM1IDE1dDE1IDM1ek02MzIgMTY1djM2MnEwIDIwIC0xNSAzNXQtMzUgMTVoLTEwMXEtMjAgMCAtMzUgLTE1dC0xNSAtMzV2LTM2MnEwIC0yMCAxNSAtMzV0MzUgLTE1aDEwMXEyMCAwIDM1IDE1dDE1IDM1ek0yMDQ4IDMxMXEwIC0xNjYgLTExOCAtMjg0dC0yODQgLTExOGgtMTI0NHEtMTY2IDAgLTI4NCAxMTh0LTExOCAyODQgcTAgMTE2IDYzIDIxNC41dDE2OCAxNDguNXEtMTAgMzQgLTEwIDczcTAgMTEzIDgwLjUgMTkzLjV0MTkzLjUgODAuNXExMDIgMCAxODAgLTY3cTQ1IDE4MyAxOTQgMzAwdDMzOCAxMTdxMTQ5IDAgMjc1IC03My41dDE5OS41IC0xOTkuNXQ3My41IC0yNzVxMCAtNjYgLTE0IC0xMjJxMTM1IC0zMyAyMjEgLTE0Mi41dDg2IC0yNDcuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxNDsiIGQ9Ik0wIDE1MzZoMTUzNnYtMTM5MmwtNzc2IC0zMzhsLTc2MCAzMzh2MTM5MnpNMTQzNiAyMDl2OTI2aC0xMzM2di05MjZsNjYxIC0yOTR6TTE0MzYgMTIzNXYyMDFoLTEzMzZ2LTIwMWgxMzM2ek0xODEgOTM3di0xMTVoLTM3djExNWgzN3pNMTgxIDc4OXYtMTE1aC0zN3YxMTVoMzd6TTE4MSA2NDF2LTExNWgtMzd2MTE1aDM3ek0xODEgNDkzdi0xMTVoLTM3djExNWgzN3pNMTgxIDM0NXYtMTE1aC0zN3YxMTVoMzd6TTIwNyAyMDJsMTUgMzQgbDEwNSAtNDdsLTE1IC0zM3pNMzQzIDE0MmwxNSAzNGwxMDUgLTQ2bC0xNSAtMzR6TTQ3OCA4MmwxNSAzNGwxMDUgLTQ2bC0xNSAtMzR6TTYxNCAyM2wxNSAzM2wxMDQgLTQ2bC0xNSAtMzR6TTc5NyAxMGwxMDUgNDZsMTUgLTMzbC0xMDUgLTQ3ek05MzIgNzBsMTA1IDQ2bDE1IC0zNGwtMTA1IC00NnpNMTA2OCAxMzBsMTA1IDQ2bDE1IC0zNGwtMTA1IC00NnpNMTIwMyAxODlsMTA1IDQ3bDE1IC0zNGwtMTA1IC00NnpNMjU5IDEzODl2LTM2aC0xMTQgdjM2aDExNHpNNDIxIDEzODl2LTM2aC0xMTV2MzZoMTE1ek01ODMgMTM4OXYtMzZoLTExNXYzNmgxMTV6TTc0NCAxMzg5di0zNmgtMTE0djM2aDExNHpNOTA2IDEzODl2LTM2aC0xMTR2MzZoMTE0ek0xMDY4IDEzODl2LTM2aC0xMTV2MzZoMTE1ek0xMjMwIDEzODl2LTM2aC0xMTV2MzZoMTE1ek0xMzkxIDEzODl2LTM2aC0xMTR2MzZoMTE0ek0xODEgMTA0OXYtNzloLTM3djExNWgxMTV2LTM2aC03OHpNNDIxIDEwODV2LTM2aC0xMTV2MzZoMTE1eiBNNTgzIDEwODV2LTM2aC0xMTV2MzZoMTE1ek03NDQgMTA4NXYtMzZoLTExNHYzNmgxMTR6TTkwNiAxMDg1di0zNmgtMTE0djM2aDExNHpNMTA2OCAxMDg1di0zNmgtMTE1djM2aDExNXpNMTIzMCAxMDg1di0zNmgtMTE1djM2aDExNXpNMTM1NSA5NzB2NzloLTc4djM2aDExNXYtMTE1aC0zN3pNMTM1NSA4MjJ2MTE1aDM3di0xMTVoLTM3ek0xMzU1IDY3NHYxMTVoMzd2LTExNWgtMzd6TTEzNTUgNTI2djExNWgzN3YtMTE1aC0zN3pNMTM1NSAzNzggdjExNWgzN3YtMTE1aC0zN3pNMTM1NSAyMzB2MTE1aDM3di0xMTVoLTM3ek03NjAgMjY1cS0xMjkgMCAtMjIxIDkxLjV0LTkyIDIyMS41cTAgMTI5IDkyIDIyMXQyMjEgOTJxMTMwIDAgMjIxLjUgLTkydDkxLjUgLTIyMXEwIC0xMzAgLTkxLjUgLTIyMS41dC0yMjEuNSAtOTEuNXpNNTk1IDY0NnEwIC0zNiAxOS41IC01Ni41dDQ5LjUgLTI1dDY0IC03dDY0IC0ydDQ5LjUgLTl0MTkuNSAtMzAuNXEwIC00OSAtMTEyIC00OXEtOTcgMCAtMTIzIDUxIGgtM2wtMzEgLTYzcTY3IC00MiAxNjIgLTQycTI5IDAgNTYuNSA1dDU1LjUgMTZ0NDUuNSAzM3QxNy41IDUzcTAgNDYgLTI3LjUgNjkuNXQtNjcuNSAyN3QtNzkuNSAzdC02NyA1dC0yNy41IDI1LjVxMCAyMSAyMC41IDMzdDQwLjUgMTV0NDEgM3EzNCAwIDcwLjUgLTExdDUxLjUgLTM0aDNsMzAgNThxLTMgMSAtMjEgOC41dC0yMi41IDl0LTE5LjUgN3QtMjIgN3QtMjAgNC41dC0yNCA0dC0yMyAxcS0yOSAwIC01Ni41IC01dC01NCAtMTYuNSB0LTQzIC0zNHQtMTYuNSAtNTMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxNTsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNODYzIDUwNHEwIDExMiAtNzkuNSAxOTEuNXQtMTkxLjUgNzkuNXQtMTkxIC03OS41dC03OSAtMTkxLjV0NzkgLTE5MXQxOTEgLTc5dDE5MS41IDc5dDc5LjUgMTkxek0xNzI2IDUwNXEwIDExMiAtNzkgMTkxdC0xOTEgNzl0LTE5MS41IC03OXQtNzkuNSAtMTkxcTAgLTExMyA3OS41IC0xOTJ0MTkxLjUgLTc5dDE5MSA3OS41dDc5IDE5MS41ek0yMDQ4IDEzMTR2LTEzNDhxMCAtNDQgLTMxLjUgLTc1LjV0LTc2LjUgLTMxLjVoLTE4MzIgcS00NSAwIC03Ni41IDMxLjV0LTMxLjUgNzUuNXYxMzQ4cTAgNDQgMzEuNSA3NS41dDc2LjUgMzEuNWg0MzFxNDQgMCA3NiAtMzEuNXQzMiAtNzUuNXYtMTYxaDc1NHYxNjFxMCA0NCAzMiA3NS41dDc2IDMxLjVoNDMxcTQ1IDAgNzYuNSAtMzEuNXQzMS41IC03NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjE2OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xNDMwIDk1M3pNMTY5MCA3NDlxMTQ4IDAgMjUzIC05OC41dDEwNSAtMjQ0LjVxMCAtMTU3IC0xMDkgLTI2MS41dC0yNjcgLTEwNC41cS04NSAwIC0xNjIgMjcuNXQtMTM4IDczLjV0LTExOCAxMDZ0LTEwOSAxMjYuNXQtMTAzLjUgMTMyLjV0LTEwOC41IDEyNnQtMTE3IDEwNnQtMTM2IDczLjV0LTE1OSAyNy41cS0xNTQgMCAtMjUxLjUgLTkxLjV0LTk3LjUgLTI0NC41cTAgLTE1NyAxMDQgLTI1MHQyNjMgLTkzcTEwMCAwIDIwOCAzNy41IHQxOTMgOTguNXE1IDQgMjEgMTguNXQzMCAyNHQyMiA5LjVxMTQgMCAyNC41IC0xMC41dDEwLjUgLTI0LjVxMCAtMjQgLTYwIC03N3EtMTAxIC04OCAtMjM0LjUgLTE0MnQtMjYwLjUgLTU0cS0xMzMgMCAtMjQ1LjUgNTh0LTE4MCAxNjV0LTY3LjUgMjQxcTAgMjA1IDE0MS41IDM0MXQzNDcuNSAxMzZxMTIwIDAgMjI2LjUgLTQzLjV0MTg1LjUgLTExM3QxNTEuNSAtMTUzdDEzOSAtMTY3LjV0MTMzLjUgLTE1My41dDE0OS41IC0xMTMgdDE3Mi41IC00My41cTEwMiAwIDE2OC41IDYxLjV0NjYuNSAxNjIuNXEwIDk1IC02NC41IDE1OXQtMTU5LjUgNjRxLTMwIDAgLTgxLjUgLTE4LjV0LTY4LjUgLTE4LjVxLTIwIDAgLTM1LjUgMTV0LTE1LjUgMzVxMCAxOCA4LjUgNTd0OC41IDU5cTAgMTU5IC0xMDcuNSAyNjN0LTI2Ni41IDEwNHEtNTggMCAtMTExLjUgLTE4LjV0LTg0IC00MC41dC01NS41IC00MC41dC0zMyAtMTguNXEtMTUgMCAtMjUuNSAxMC41dC0xMC41IDI1LjUgcTAgMTkgMjUgNDZxNTkgNjcgMTQ3IDEwMy41dDE4MiAzNi41cTE5MSAwIDMxOCAtMTI1LjV0MTI3IC0zMTUuNXEwIC0zNyAtNCAtNjZxNTcgMTUgMTE1IDE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjE3OyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0xMjE2IDgzMnEwIDI2IC0xOSA0NXQtNDUgMTloLTEyOHYxMjhxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXYtMTI4aC0xMjhxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1dDE5IC00NXQ0NSAtMTloMTI4di0xMjhxMCAtMjYgMTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXYxMjhoMTI4cTI2IDAgNDUgMTl0MTkgNDV6TTY0MCAwcTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41dC05MC41IDM3LjV0LTM3LjUgOTAuNSB0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTE1MzYgMHEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNXQtOTAuNSAzNy41dC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTE2NjQgMTA4OHYtNTEycTAgLTI0IC0xNiAtNDIuNXQtNDEgLTIxLjVsLTEwNDQgLTEyMnExIC03IDQuNSAtMjEuNXQ2IC0yNi41dDIuNSAtMjJxMCAtMTYgLTI0IC02NGg5MjAgcTI2IDAgNDUgLTE5dDE5IC00NXQtMTkgLTQ1dC00NSAtMTloLTEwMjRxLTI2IDAgLTQ1IDE5dC0xOSA0NXEwIDE0IDExIDM5LjV0MjkuNSA1OS41dDIwLjUgMzhsLTE3NyA4MjNoLTIwNHEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5aDI1NnExNiAwIDI4LjUgLTYuNXQyMCAtMTUuNXQxMyAtMjQuNXQ3LjUgLTI2LjV0NS41IC0yOS41dDQuNSAtMjUuNWgxMjAxcTI2IDAgNDUgLTE5dDE5IC00NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxODsiIGhvcml6LWFkdi14PSIxNjY0IiBkPSJNMTI4MCA4MzJxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTlsLTE0NyAtMTQ2djI5M3EwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1di0yOTNsLTE0NyAxNDZxLTE5IDE5IC00NSAxOXQtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1bDI1NiAtMjU2cTE5IC0xOSA0NSAtMTl0NDUgMTlsMjU2IDI1NnExOSAxOSAxOSA0NXpNNjQwIDBxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41IHQzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTUzNiAwcTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41dC05MC41IDM3LjV0LTM3LjUgOTAuNXQzNy41IDkwLjV0OTAuNSAzNy41dDkwLjUgLTM3LjV0MzcuNSAtOTAuNXpNMTY2NCAxMDg4di01MTJxMCAtMjQgLTE2IC00Mi41dC00MSAtMjEuNWwtMTA0NCAtMTIycTEgLTcgNC41IC0yMS41dDYgLTI2LjV0Mi41IC0yMnEwIC0xNiAtMjQgLTY0aDkyMCBxMjYgMCA0NSAtMTl0MTkgLTQ1dC0xOSAtNDV0LTQ1IC0xOWgtMTAyNHEtMjYgMCAtNDUgMTl0LTE5IDQ1cTAgMTQgMTEgMzkuNXQyOS41IDU5LjV0MjAuNSAzOGwtMTc3IDgyM2gtMjA0cS0yNiAwIC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTloMjU2cTE2IDAgMjguNSAtNi41dDIwIC0xNS41dDEzIC0yNC41dDcuNSAtMjYuNXQ1LjUgLTI5LjV0NC41IC0yNS41aDEyMDFxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjE5OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0yMTIgNzY4bDYyMyAtNjY1bC0zMDAgNjY1aC0zMjN6TTEwMjQgLTRsMzQ5IDc3MmgtNjk4ek01MzggODk2bDIwNCAzODRoLTI2MmwtMjg4IC0zODRoMzQ2ek0xMjEzIDEwM2w2MjMgNjY1aC0zMjN6TTY4MyA4OTZoNjgybC0yMDQgMzg0aC0yNzR6TTE1MTAgODk2aDM0NmwtMjg4IDM4NGgtMjYyek0xNjUxIDEzODJsMzg0IC01MTJxMTQgLTE4IDEzIC00MS41dC0xNyAtNDAuNWwtOTYwIC0xMDI0cS0xOCAtMjAgLTQ3IC0yMHQtNDcgMjAgbC05NjAgMTAyNHEtMTYgMTcgLTE3IDQwLjV0MTMgNDEuNWwzODQgNTEycTE4IDI2IDUxIDI2aDExNTJxMzMgMCA1MSAtMjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMWE7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTE4MTEgLTE5cTE5IDE5IDQ1IDE5dDQ1IC0xOWwxMjggLTEyOGwtOTAgLTkwbC04MyA4M2wtODMgLTgzcS0xOCAtMTkgLTQ1IC0xOXQtNDUgMTlsLTgzIDgzbC04MyAtODNxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtODMgODNsLTgzIC04M3EtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC04MyA4M2wtODMgLTgzcS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTgzIDgzbC04MyAtODNxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtODMgODNsLTgzIC04MyBxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtODMgODNsLTgzIC04M3EtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC0xMjggMTI4bDkwIDkwbDgzIC04M2w4MyA4M3ExOSAxOSA0NSAxOXQ0NSAtMTlsODMgLTgzbDgzIDgzcTE5IDE5IDQ1IDE5dDQ1IC0xOWw4MyAtODNsODMgODNxMTkgMTkgNDUgMTl0NDUgLTE5bDgzIC04M2w4MyA4M3ExOSAxOSA0NSAxOXQ0NSAtMTlsODMgLTgzbDgzIDgzcTE5IDE5IDQ1IDE5dDQ1IC0xOWw4MyAtODNsODMgODMgcTE5IDE5IDQ1IDE5dDQ1IC0xOWw4MyAtODN6TTIzNyAxOXEtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC0xMjggMTI4bDkwIDkwbDgzIC04Mmw4MyA4MnExOSAxOSA0NSAxOXQ0NSAtMTlsODMgLTgybDY0IDY0djI5M2wtMjEwIDMxNHEtMTcgMjYgLTcgNTYuNXQ0MCA0MC41bDE3NyA1OHYyOTloMTI4djEyOGgyNTZ2MTI4aDI1NnYtMTI4aDI1NnYtMTI4aDEyOHYtMjk5bDE3NyAtNThxMzAgLTEwIDQwIC00MC41dC03IC01Ni41bC0yMTAgLTMxNCB2LTI5M2wxOSAxOHExOSAxOSA0NSAxOXQ0NSAtMTlsODMgLTgybDgzIDgycTE5IDE5IDQ1IDE5dDQ1IC0xOWwxMjggLTEyOGwtOTAgLTkwbC04MyA4M2wtODMgLTgzcS0xOCAtMTkgLTQ1IC0xOXQtNDUgMTlsLTgzIDgzbC04MyAtODNxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtODMgODNsLTgzIC04M3EtMTkgLTE5IC00NSAtMTl0LTQ1IDE5bC04MyA4M2wtODMgLTgzcS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTgzIDgzbC04MyAtODMgcS0xOSAtMTkgLTQ1IC0xOXQtNDUgMTlsLTgzIDgzbC04MyAtODNxLTE5IC0xOSAtNDUgLTE5dC00NSAxOWwtODMgODN6TTY0MCAxMTUydi0xMjhsMzg0IDEyOGwzODQgLTEyOHYxMjhoLTEyOHYxMjhoLTUxMnYtMTI4aC0xMjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMWI7IiBkPSJNNTc2IDBsOTYgNDQ4bC05NiAxMjhsLTEyOCA2NHpNODMyIDBsMTI4IDY0MGwtMTI4IC02NGwtOTYgLTEyOHpNOTkyIDEwMTBxLTIgNCAtNCA2cS0xMCA4IC05NiA4cS03MCAwIC0xNjcgLTE5cS03IC0yIC0yMSAtMnQtMjEgMnEtOTcgMTkgLTE2NyAxOXEtODYgMCAtOTYgLThxLTIgLTIgLTQgLTZxMiAtMTggNCAtMjdxMiAtMyA3LjUgLTYuNXQ3LjUgLTEwLjVxMiAtNCA3LjUgLTIwLjV0NyAtMjAuNXQ3LjUgLTE3dDguNSAtMTd0OSAtMTQgdDEyIC0xMy41dDE0IC05LjV0MTcuNSAtOHQyMC41IC00dDI0LjUgLTJxMzYgMCA1OSAxMi41dDMyLjUgMzB0MTQuNSAzNC41dDExLjUgMjkuNXQxNy41IDEyLjVoMTJxMTEgMCAxNy41IC0xMi41dDExLjUgLTI5LjV0MTQuNSAtMzQuNXQzMi41IC0zMHQ1OSAtMTIuNXExMyAwIDI0LjUgMnQyMC41IDR0MTcuNSA4dDE0IDkuNXQxMiAxMy41dDkgMTR0OC41IDE3dDcuNSAxN3Q3IDIwLjV0Ny41IDIwLjVxMiA3IDcuNSAxMC41dDcuNSA2LjUgcTIgOSA0IDI3ek0xNDA4IDEzMXEwIC0xMjEgLTczIC0xOTB0LTE5NCAtNjloLTg3NHEtMTIxIDAgLTE5NCA2OXQtNzMgMTkwcTAgNjEgNC41IDExOHQxOSAxMjUuNXQzNy41IDEyMy41dDYzLjUgMTAzLjV0OTMuNSA3NC41bC05MCAyMjBoMjE0cS0yMiA2NCAtMjIgMTI4cTAgMTIgMiAzMnEtMTk0IDQwIC0xOTQgOTZxMCA1NyAyMTAgOTlxMTcgNjIgNTEuNSAxMzR0NzAuNSAxMTRxMzIgMzcgNzYgMzdxMzAgMCA4NCAtMzF0ODQgLTMxdDg0IDMxIHQ4NCAzMXE0NCAwIDc2IC0zN3EzNiAtNDIgNzAuNSAtMTE0dDUxLjUgLTEzNHEyMTAgLTQyIDIxMCAtOTlxMCAtNTYgLTE5NCAtOTZxNyAtODEgLTIwIC0xNjBoMjE0bC04MiAtMjI1cTYzIC0zMyAxMDcuNSAtOTYuNXQ2NS41IC0xNDMuNXQyOSAtMTUxLjV0OCAtMTQ4LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMWM7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTIzMDEgNTAwcTEyIC0xMDMgLTIyIC0xOTguNXQtOTkgLTE2My41dC0xNTguNSAtMTA2dC0xOTYuNSAtMzFxLTE2MSAxMSAtMjc5LjUgMTI1dC0xMzQuNSAyNzRxLTEyIDExMSAyNy41IDIxMC41dDExOC41IDE3MC41bC03MSAxMDdxLTk2IC04MCAtMTUxIC0xOTR0LTU1IC0yNDRxMCAtMjcgLTE4LjUgLTQ2LjV0LTQ1LjUgLTE5LjVoLTI1NmgtNjlxLTIzIC0xNjQgLTE0OSAtMjc0dC0yOTQgLTExMHEtMTg1IDAgLTMxNi41IDEzMS41IHQtMTMxLjUgMzE2LjV0MTMxLjUgMzE2LjV0MzE2LjUgMTMxLjVxNzYgMCAxNTIgLTI3bDI0IDQ1cS0xMjMgMTEwIC0zMDQgMTEwaC02NHEtMjYgMCAtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5aDEyOHE3OCAwIDE0NSAtMTMuNXQxMTYuNSAtMzguNXQ3MS41IC0zOS41dDUxIC0zNi41aDUxMmgxMTVsLTg1IDEyOGgtMjIycS0zMCAwIC00OSAyMi41dC0xNCA1Mi41cTQgMjMgMjMgMzh0NDMgMTVoMjUzcTMzIDAgNTMgLTI4bDcwIC0xMDUgbDExNCAxMTRxMTkgMTkgNDYgMTloMTAxcTI2IDAgNDUgLTE5dDE5IC00NXYtMTI4cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTc5bDExNSAtMTcycTEzMSA2MyAyNzUgMzZxMTQzIC0yNiAyNDQgLTEzNC41dDExOCAtMjUzLjV6TTQ0OCAxMjhxMTE1IDAgMjAzIDcyLjV0MTExIDE4My41aC0zMTRxLTM1IDAgLTU1IDMxcS0xOCAzMiAtMSA2M2wxNDcgMjc3cS00NyAxMyAtOTEgMTNxLTEzMiAwIC0yMjYgLTk0dC05NCAtMjI2dDk0IC0yMjYgdDIyNiAtOTR6TTE4NTYgMTI4cTEzMiAwIDIyNiA5NHQ5NCAyMjZ0LTk0IDIyNnQtMjI2IDk0cS02MCAwIC0xMjEgLTI0bDE3NCAtMjYwcTE1IC0yMyAxMCAtNDl0LTI3IC00MHEtMTUgLTExIC0zNiAtMTFxLTM1IDAgLTUzIDI5bC0xNzQgMjYwcS05MyAtOTUgLTkzIC0yMjVxMCAtMTMyIDk0IC0yMjZ0MjI2IC05NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxZDsiIGQ9Ik0xNDA4IDBxMCAtNjMgLTYxLjUgLTExMy41dC0xNjQgLTgxdC0yMjUgLTQ2dC0yNTMuNSAtMTUuNXQtMjUzLjUgMTUuNXQtMjI1IDQ2dC0xNjQgODF0LTYxLjUgMTEzLjVxMCA0OSAzMyA4OC41dDkxIDY2LjV0MTE4IDQ0LjV0MTMxIDI5LjVxMjYgNSA0OCAtMTAuNXQyNiAtNDEuNXE1IC0yNiAtMTAuNSAtNDh0LTQxLjUgLTI2cS01OCAtMTAgLTEwNiAtMjMuNXQtNzYuNSAtMjUuNXQtNDguNSAtMjMuNXQtMjcuNSAtMTkuNXQtOC41IC0xMiBxMyAtMTEgMjcgLTI2LjV0NzMgLTMzdDExNCAtMzIuNXQxNjAuNSAtMjV0MjAxLjUgLTEwdDIwMS41IDEwdDE2MC41IDI1dDExNCAzM3Q3MyAzMy41dDI3IDI3LjVxLTEgNCAtOC41IDExdC0yNy41IDE5dC00OC41IDIzLjV0LTc2LjUgMjV0LTEwNiAyMy41cS0yNiA0IC00MS41IDI2dC0xMC41IDQ4cTQgMjYgMjYgNDEuNXQ0OCAxMC41cTcxIC0xMiAxMzEgLTI5LjV0MTE4IC00NC41dDkxIC02Ni41dDMzIC04OC41ek0xMDI0IDg5NnYtMzg0IHEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTY0di0zODRxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0yNTZxLTI2IDAgLTQ1IDE5dC0xOSA0NXYzODRoLTY0cS0yNiAwIC00NSAxOXQtMTkgNDV2Mzg0cTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNWgzODRxNTMgMCA5MC41IC0zNy41dDM3LjUgLTkwLjV6TTkyOCAxMjgwcTAgLTkzIC02NS41IC0xNTguNXQtMTU4LjUgLTY1LjV0LTE1OC41IDY1LjV0LTY1LjUgMTU4LjV0NjUuNSAxNTguNXQxNTguNSA2NS41IHQxNTguNSAtNjUuNXQ2NS41IC0xNTguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIxZTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTI4MCA1MTJoMzA1cS01IC02IC0xMCAtMTAuNXQtOSAtNy41bC0zIC00bC02MjMgLTYwMHEtMTggLTE4IC00NCAtMTh0LTQ0IDE4bC02MjQgNjAycS01IDIgLTIxIDIwaDM2OXEyMiAwIDM5LjUgMTMuNXQyMi41IDM0LjVsNzAgMjgxbDE5MCAtNjY3cTYgLTIwIDIzIC0zM3QzOSAtMTNxMjEgMCAzOCAxM3QyMyAzM2wxNDYgNDg1bDU2IC0xMTJxMTggLTM1IDU3IC0zNXpNMTc5MiA5NDBxMCAtMTQ1IC0xMDMgLTMwMGgtMzY5bC0xMTEgMjIxIHEtOCAxNyAtMjUuNSAyN3QtMzYuNSA4cS00NSAtNSAtNTYgLTQ2bC0xMjkgLTQzMGwtMTk2IDY4NnEtNiAyMCAtMjMuNSAzM3QtMzkuNSAxM3QtMzkgLTEzLjV0LTIyIC0zNC41bC0xMTYgLTQ2NGgtNDIzcS0xMDMgMTU1IC0xMDMgMzAwcTAgMjIwIDEyNyAzNDR0MzUxIDEyNHE2MiAwIDEyNi41IC0yMS41dDEyMCAtNTh0OTUuNSAtNjguNXQ3NiAtNjhxMzYgMzYgNzYgNjh0OTUuNSA2OC41dDEyMCA1OHQxMjYuNSAyMS41cTIyNCAwIDM1MSAtMTI0IHQxMjcgLTM0NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIyMTsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTE1MiA5NjBxMCAtMjIxIC0xNDcuNSAtMzg0LjV0LTM2NC41IC0xODcuNXYtMjYwaDIyNHExNCAwIDIzIC05dDkgLTIzdi02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC0yMjR2LTIyNHEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YyMjRoLTIyNHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWgyMjR2MjYwcS0xNTAgMTYgLTI3MS41IDEwM3QtMTg2IDIyNHQtNTIuNSAyOTIgcTExIDEzNCA4MC41IDI0OXQxODIgMTg4dDI0NS41IDg4cTE3MCAxOSAzMTkgLTU0dDIzNiAtMjEydDg3IC0zMDZ6TTEyOCA5NjBxMCAtMTg1IDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjV0MzE2LjUgMTMxLjV0MTMxLjUgMzE2LjV0LTEzMS41IDMxNi41dC0zMTYuNSAxMzEuNXQtMzE2LjUgLTEzMS41dC0xMzEuNSAtMzE2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMjI7IiBkPSJNMTQ3MiAxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXYtNDE2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjI2MmwtMzgyIC0zODNxMTI2IC0xNTYgMTI2IC0zNTlxMCAtMTE3IC00NS41IC0yMjMuNXQtMTIzIC0xODR0LTE4NCAtMTIzdC0yMjMuNSAtNDUuNXQtMjIzLjUgNDUuNXQtMTg0IDEyM3QtMTIzIDE4NHQtNDUuNSAyMjMuNXQ0NS41IDIyMy41dDEyMyAxODR0MTg0IDEyM3QyMjMuNSA0NS41IHEyMDMgMCAzNTkgLTEyNmwzODIgMzgyaC0yNjFxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloNDE2ek01NzYgMHExODUgMCAzMTYuNSAxMzEuNXQxMzEuNSAzMTYuNXQtMTMxLjUgMzE2LjV0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjIzOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik04MzAgMTIyMHExNDUgLTcyIDIzMy41IC0yMTAuNXQ4OC41IC0zMDUuNXEwIC0yMjEgLTE0Ny41IC0zODQuNXQtMzY0LjUgLTE4Ny41di0xMzJoOTZxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ2LTk2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjk2aC05NnEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg5NnYxMzJxLTIxNyAyNCAtMzY0LjUgMTg3LjUgdC0xNDcuNSAzODQuNXEwIDE2NyA4OC41IDMwNS41dDIzMy41IDIxMC41cS0xNjUgOTYgLTIyOCAyNzNxLTYgMTYgMy41IDI5LjV0MjYuNSAxMy41aDY5cTIxIDAgMjkgLTIwcTQ0IC0xMDYgMTQwIC0xNzF0MjE0IC02NXQyMTQgNjV0MTQwIDE3MXE4IDIwIDM3IDIwaDYxcTE3IDAgMjYuNSAtMTMuNXQzLjUgLTI5LjVxLTYzIC0xNzcgLTIyOCAtMjczek01NzYgMjU2cTE4NSAwIDMxNi41IDEzMS41dDEzMS41IDMxNi41dC0xMzEuNSAzMTYuNSB0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjI0OyIgZD0iTTEwMjQgMTUwNHEwIDE0IDkgMjN0MjMgOWgyODhxMjYgMCA0NSAtMTl0MTkgLTQ1di0yODhxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjRxLTE0IDAgLTIzIDl0LTkgMjN2MTM0bC0yNTQgLTI1NXExMjYgLTE1OCAxMjYgLTM1OXEwIC0yMjEgLTE0Ny41IC0zODQuNXQtMzY0LjUgLTE4Ny41di0xMzJoOTZxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ2LTk2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0IHEtMTQgMCAtMjMgOXQtOSAyM3Y5NmgtOTZxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloOTZ2MTMycS0xNDkgMTYgLTI3MC41IDEwM3QtMTg2LjUgMjIzLjV0LTUzIDI5MS41cTE2IDIwNCAxNjAgMzUzLjV0MzQ3IDE3Mi41cTExOCAxNCAyMjggLTE5dDE5OCAtMTAzbDI1NSAyNTRoLTEzNHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHpNNTc2IDI1NnExODUgMCAzMTYuNSAxMzEuNXQxMzEuNSAzMTYuNXQtMTMxLjUgMzE2LjUgdC0zMTYuNSAxMzEuNXQtMzE2LjUgLTEzMS41dC0xMzEuNSAtMzE2LjV0MTMxLjUgLTMxNi41dDMxNi41IC0xMzEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIyNTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTI4MCAxNTA0cTAgMTQgOSAyM3QyMyA5aDI4OHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTI4OHEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YxMzRsLTI1NCAtMjU1cTEyNiAtMTU4IDEyNiAtMzU5cTAgLTIyMSAtMTQ3LjUgLTM4NC41dC0zNjQuNSAtMTg3LjV2LTEzMmg5NnExNCAwIDIzIC05dDkgLTIzdi02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC05NnYtOTZxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjQgcS0xNCAwIC0yMyA5dC05IDIzdjk2aC05NnEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg5NnYxMzJxLTIxNyAyNCAtMzY0LjUgMTg3LjV0LTE0Ny41IDM4NC41cTAgMjAxIDEyNiAzNTlsLTUyIDUzbC0xMDEgLTExMXEtOSAtMTAgLTIyIC0xMC41dC0yMyA3LjVsLTQ4IDQ0cS0xMCA4IC0xMC41IDIxLjV0OC41IDIzLjVsMTA1IDExNWwtMTExIDExMnYtMTM0cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5IHQtOSAyM3YyODhxMCAyNiAxOSA0NXQ0NSAxOWgyODhxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTMzbDEwNiAtMTA3bDg2IDk0cTkgMTAgMjIgMTAuNXQyMyAtNy41bDQ4IC00NHExMCAtOCAxMC41IC0yMS41dC04LjUgLTIzLjVsLTkwIC05OWw1NyAtNTZxMTU4IDEyNiAzNTkgMTI2dDM1OSAtMTI2bDI1NSAyNTRoLTEzNHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHpNODMyIDI1NnExODUgMCAzMTYuNSAxMzEuNSB0MTMxLjUgMzE2LjV0LTEzMS41IDMxNi41dC0zMTYuNSAxMzEuNXQtMzE2LjUgLTEzMS41dC0xMzEuNSAtMzE2LjV0MTMxLjUgLTMxNi41dDMxNi41IC0xMzEuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIyNjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTc5MCAxMDA3cTEyIC0xNTUgLTUyLjUgLTI5MnQtMTg2IC0yMjR0LTI3MS41IC0xMDN2LTI2MGgyMjRxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMjI0di0yMjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjRxLTE0IDAgLTIzIDl0LTkgMjN2MjI0aC01MTJ2LTIyNHEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YyMjRoLTIyNHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjMgdDIzIDloMjI0djI2MHEtMTUwIDE2IC0yNzEuNSAxMDN0LTE4NiAyMjR0LTUyLjUgMjkycTE3IDIwNiAxNjQuNSAzNTYuNXQzNTIuNSAxNjkuNXEyMDYgMjEgMzc3IC05NHExNzEgMTE1IDM3NyA5NHEyMDUgLTE5IDM1Mi41IC0xNjkuNXQxNjQuNSAtMzU2LjV6TTg5NiA2NDdxMTI4IDEzMSAxMjggMzEzdC0xMjggMzEzcS0xMjggLTEzMSAtMTI4IC0zMTN0MTI4IC0zMTN6TTU3NiA1MTJxMTE1IDAgMjE4IDU3cS0xNTQgMTY1IC0xNTQgMzkxIHEwIDIyNCAxNTQgMzkxcS0xMDMgNTcgLTIxOCA1N3EtMTg1IDAgLTMxNi41IC0xMzEuNXQtMTMxLjUgLTMxNi41dDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjV6TTExNTIgMTI4djI2MHEtMTM3IDE1IC0yNTYgOTRxLTExOSAtNzkgLTI1NiAtOTR2LTI2MGg1MTJ6TTEyMTYgNTEycTE4NSAwIDMxNi41IDEzMS41dDEzMS41IDMxNi41dC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjVxLTExNSAwIC0yMTggLTU3cTE1NCAtMTY3IDE1NCAtMzkxIHEwIC0yMjYgLTE1NCAtMzkxcTEwMyAtNTcgMjE4IC01N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIyNzsiIGhvcml6LWFkdi14PSIxOTIwIiBkPSJNMTUzNiAxMTIwcTAgMTQgOSAyM3QyMyA5aDI4OHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTI4OHEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YxMzRsLTI1NCAtMjU1cTc2IC05NSAxMDcuNSAtMjE0dDkuNSAtMjQ3cS0zMSAtMTgyIC0xNjYgLTMxMnQtMzE4IC0xNTZxLTIxMCAtMjkgLTM4NC41IDgwdC0yNDEuNSAzMDBxLTExNyA2IC0yMjEgNTcuNXQtMTc3LjUgMTMzdC0xMTMuNSAxOTIuNXQtMzIgMjMwIHE5IDEzNSA3OCAyNTJ0MTgyIDE5MS41dDI0OCA4OS41cTExOCAxNCAyMjcuNSAtMTl0MTk4LjUgLTEwM2wyNTUgMjU0aC0xMzRxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloMjg4cTI2IDAgNDUgLTE5dDE5IC00NXYtMjg4cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjEzNGwtMjU0IC0yNTVxNTkgLTc0IDkzIC0xNjlxMTgyIC05IDMyOCAtMTI0bDI1NSAyNTRoLTEzNHEtMTQgMCAtMjMgOSB0LTkgMjN2NjR6TTEwMjQgNzA0cTAgMjAgLTQgNThxLTE2MiAtMjUgLTI3MSAtMTUwdC0xMDkgLTI5MnEwIC0yMCA0IC01OHExNjIgMjUgMjcxIDE1MHQxMDkgMjkyek0xMjggNzA0cTAgLTE2OCAxMTEgLTI5NHQyNzYgLTE0OXEtMyAyOSAtMyA1OXEwIDIxMCAxMzUgMzY5LjV0MzM4IDE5Ni41cS01MyAxMjAgLTE2My41IDE5M3QtMjQ1LjUgNzNxLTE4NSAwIC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXpNMTA4OCAtMTI4IHExODUgMCAzMTYuNSAxMzEuNXQxMzEuNSAzMTYuNXEwIDE2OCAtMTExIDI5NHQtMjc2IDE0OXEzIC0yOSAzIC01OXEwIC0yMTAgLTEzNSAtMzY5LjV0LTMzOCAtMTk2LjVxNTMgLTEyMCAxNjMuNSAtMTkzdDI0NS41IC03M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIyODsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMTY2NCAxNTA0cTAgMTQgOSAyM3QyMyA5aDI4OHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTI4OHEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YxMzRsLTI1NCAtMjU1cTc2IC05NSAxMDcuNSAtMjE0dDkuNSAtMjQ3cS0zMiAtMTgwIC0xNjQuNSAtMzEwdC0zMTMuNSAtMTU3cS0yMjMgLTM0IC00MDkgOTBxLTExNyAtNzggLTI1NiAtOTN2LTEzMmg5NnExNCAwIDIzIC05dDkgLTIzdi02NHEwIC0xNCAtOSAtMjMgdC0yMyAtOWgtOTZ2LTk2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjk2aC05NnEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg5NnYxMzJxLTE1NSAxNyAtMjc5LjUgMTA5LjV0LTE4NyAyMzcuNXQtMzkuNSAzMDdxMjUgMTg3IDE1OS41IDMyMi41dDMyMC41IDE2NC41cTIyNCAzNCA0MTAgLTkwcTE0NiA5NyAzMjAgOTdxMjAxIDAgMzU5IC0xMjZsMjU1IDI1NGgtMTM0cS0xNCAwIC0yMyA5IHQtOSAyM3Y2NHpNODk2IDM5MXExMjggMTMxIDEyOCAzMTN0LTEyOCAzMTNxLTEyOCAtMTMxIC0xMjggLTMxM3QxMjggLTMxM3pNMTI4IDcwNHEwIC0xODUgMTMxLjUgLTMxNi41dDMxNi41IC0xMzEuNXExMTcgMCAyMTggNTdxLTE1NCAxNjcgLTE1NCAzOTF0MTU0IDM5MXEtMTAxIDU3IC0yMTggNTdxLTE4NSAwIC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXpNMTIxNiAyNTZxMTg1IDAgMzE2LjUgMTMxLjV0MTMxLjUgMzE2LjUgdC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjVxLTExNyAwIC0yMTggLTU3cTE1NCAtMTY3IDE1NCAtMzkxdC0xNTQgLTM5MXExMDEgLTU3IDIxOCAtNTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMjk7IiBkPSJNMTQ3MiAxNDA4cTI2IDAgNDUgLTE5dDE5IC00NXYtNDE2cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjI2MmwtMjEzIC0yMTRsMTQwIC0xNDBxOSAtMTAgOSAtMjN0LTkgLTIybC00NiAtNDZxLTkgLTkgLTIyIC05dC0yMyA5bC0xNDAgMTQxbC03OCAtNzlxMTI2IC0xNTYgMTI2IC0zNTlxMCAtMTE3IC00NS41IC0yMjMuNXQtMTIzIC0xODR0LTE4NCAtMTIzdC0yMjMuNSAtNDUuNXQtMjIzLjUgNDUuNSB0LTE4NCAxMjN0LTEyMyAxODR0LTQ1LjUgMjIzLjV0NDUuNSAyMjMuNXQxMjMgMTg0dDE4NCAxMjN0MjIzLjUgNDUuNXEyMDMgMCAzNTkgLTEyNmw3OCA3OGwtMTcyIDE3MnEtOSAxMCAtOSAyM3Q5IDIybDQ2IDQ2cTkgOSAyMiA5dDIzIC05bDE3MiAtMTcybDIxMyAyMTNoLTI2MXEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg0MTZ6TTU3NiAwcTE4NSAwIDMxNi41IDEzMS41dDEzMS41IDMxNi41dC0xMzEuNSAzMTYuNSB0LTMxNi41IDEzMS41dC0zMTYuNSAtMTMxLjV0LTEzMS41IC0zMTYuNXQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjJhOyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik02NDAgODkycTIxNyAtMjQgMzY0LjUgLTE4Ny41dDE0Ny41IC0zODQuNXEwIC0xNjcgLTg3IC0zMDZ0LTIzNiAtMjEydC0zMTkgLTU0cS0xMzMgMTUgLTI0NS41IDg4dC0xODIgMTg4dC04MC41IDI0OXEtMTIgMTU1IDUyLjUgMjkydDE4NiAyMjR0MjcxLjUgMTAzdjEzMmgtMTYwcS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDE2MHYxNjVsLTkyIC05MnEtMTAgLTkgLTIzIC05dC0yMiA5bC00NiA0NnEtOSA5IC05IDIyIHQ5IDIzbDIwMiAyMDFxMTkgMTkgNDUgMTl0NDUgLTE5bDIwMiAtMjAxcTkgLTEwIDkgLTIzdC05IC0yMmwtNDYgLTQ2cS05IC05IC0yMiAtOXQtMjMgOWwtOTIgOTJ2LTE2NWgxNjBxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTYwdi0xMzJ6TTU3NiAtMTI4cTE4NSAwIDMxNi41IDEzMS41dDEzMS41IDMxNi41dC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjV0LTMxNi41IC0xMzEuNXQtMTMxLjUgLTMxNi41IHQxMzEuNSAtMzE2LjV0MzE2LjUgLTEzMS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjJiOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xOTAxIDYyMXExOSAtMTkgMTkgLTQ1dC0xOSAtNDVsLTI5NCAtMjk0cS05IC0xMCAtMjIuNSAtMTB0LTIyLjUgMTBsLTQ1IDQ1cS0xMCA5IC0xMCAyMi41dDEwIDIyLjVsMTg1IDE4NWgtMjk0di0yMjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNjRxLTE0IDAgLTIzIDl0LTkgMjN2MjI0aC0xMzJxLTI0IC0yMTcgLTE4Ny41IC0zNjQuNXQtMzg0LjUgLTE0Ny41cS0xNjcgMCAtMzA2IDg3dC0yMTIgMjM2dC01NCAzMTlxMTUgMTMzIDg4IDI0NS41IHQxODggMTgydDI0OSA4MC41cTE1NSAxMiAyOTIgLTUyLjV0MjI0IC0xODZ0MTAzIC0yNzEuNWgxMzJ2MjI0cTAgMTQgOSAyM3QyMyA5aDY0cTE0IDAgMjMgLTl0OSAtMjN2LTIyNGgyOTRsLTE4NSAxODVxLTEwIDkgLTEwIDIyLjV0MTAgMjIuNWw0NSA0NXE5IDEwIDIyLjUgMTB0MjIuNSAtMTB6TTU3NiAxMjhxMTg1IDAgMzE2LjUgMTMxLjV0MTMxLjUgMzE2LjV0LTEzMS41IDMxNi41dC0zMTYuNSAxMzEuNXQtMzE2LjUgLTEzMS41IHQtMTMxLjUgLTMxNi41dDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMmM7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTExNTIgOTYwcTAgLTIyMSAtMTQ3LjUgLTM4NC41dC0zNjQuNSAtMTg3LjV2LTYxMnEwIC0xNCAtOSAtMjN0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3Y2MTJxLTIxNyAyNCAtMzY0LjUgMTg3LjV0LTE0Ny41IDM4NC41cTAgMTE3IDQ1LjUgMjIzLjV0MTIzIDE4NHQxODQgMTIzdDIyMy41IDQ1LjV0MjIzLjUgLTQ1LjV0MTg0IC0xMjN0MTIzIC0xODR0NDUuNSAtMjIzLjV6TTU3NiA1MTJxMTg1IDAgMzE2LjUgMTMxLjUgdDEzMS41IDMxNi41dC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjV0LTMxNi41IC0xMzEuNXQtMTMxLjUgLTMxNi41dDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMmQ7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTEwMjQgNTc2cTAgMTg1IC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjV0LTMxNi41IC0xMzEuNXQtMTMxLjUgLTMxNi41dDEzMS41IC0zMTYuNXQzMTYuNSAtMTMxLjV0MzE2LjUgMTMxLjV0MTMxLjUgMzE2LjV6TTExNTIgNTc2cTAgLTExNyAtNDUuNSAtMjIzLjV0LTEyMyAtMTg0dC0xODQgLTEyM3QtMjIzLjUgLTQ1LjV0LTIyMy41IDQ1LjV0LTE4NCAxMjN0LTEyMyAxODR0LTQ1LjUgMjIzLjV0NDUuNSAyMjMuNXQxMjMgMTg0dDE4NCAxMjMgdDIyMy41IDQ1LjV0MjIzLjUgLTQ1LjV0MTg0IC0xMjN0MTIzIC0xODR0NDUuNSAtMjIzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMmU7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjJmOyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIzMDsiIGQ9Ik0xNDUxIDE0MDhxMzUgMCA2MCAtMjV0MjUgLTYwdi0xMzY2cTAgLTM1IC0yNSAtNjB0LTYwIC0yNWgtMzkxdjU5NWgxOTlsMzAgMjMyaC0yMjl2MTQ4cTAgNTYgMjMuNSA4NHQ5MS41IDI4bDEyMiAxdjIwN3EtNjMgOSAtMTc4IDlxLTEzNiAwIC0yMTcuNSAtODB0LTgxLjUgLTIyNnYtMTcxaC0yMDB2LTIzMmgyMDB2LTU5NWgtNzM1cS0zNSAwIC02MCAyNXQtMjUgNjB2MTM2NnEwIDM1IDI1IDYwdDYwIDI1aDEzNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMzE7IiBob3Jpei1hZHYteD0iMTI4MCIgZD0iTTAgOTM5cTAgMTA4IDM3LjUgMjAzLjV0MTAzLjUgMTY2LjV0MTUyIDEyM3QxODUgNzh0MjAyIDI2cTE1OCAwIDI5NCAtNjYuNXQyMjEgLTE5My41dDg1IC0yODdxMCAtOTYgLTE5IC0xODh0LTYwIC0xNzd0LTEwMCAtMTQ5LjV0LTE0NSAtMTAzdC0xODkgLTM4LjVxLTY4IDAgLTEzNSAzMnQtOTYgODhxLTEwIC0zOSAtMjggLTExMi41dC0yMy41IC05NXQtMjAuNSAtNzF0LTI2IC03MXQtMzIgLTYyLjV0LTQ2IC03Ny41dC02MiAtODYuNSBsLTE0IC01bC05IDEwcS0xNSAxNTcgLTE1IDE4OHEwIDkyIDIxLjUgMjA2LjV0NjYuNSAyODcuNXQ1MiAyMDNxLTMyIDY1IC0zMiAxNjlxMCA4MyA1MiAxNTZ0MTMyIDczcTYxIDAgOTUgLTQwLjV0MzQgLTEwMi41cTAgLTY2IC00NCAtMTkxdC00NCAtMTg3cTAgLTYzIDQ1IC0xMDQuNXQxMDkgLTQxLjVxNTUgMCAxMDIgMjV0NzguNSA2OHQ1NiA5NXQzOCAxMTAuNXQyMCAxMTF0Ni41IDk5LjVxMCAxNzMgLTEwOS41IDI2OS41dC0yODUuNSA5Ni41IHEtMjAwIDAgLTMzNCAtMTI5LjV0LTEzNCAtMzI4LjVxMCAtNDQgMTIuNSAtODV0MjcgLTY1dDI3IC00NS41dDEyLjUgLTMwLjVxMCAtMjggLTE1IC03M3QtMzcgLTQ1cS0yIDAgLTE3IDNxLTUxIDE1IC05MC41IDU2dC02MSA5NC41dC0zMi41IDEwOHQtMTEgMTA2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMzI7IiBkPSJNOTg1IDU2MnExMyAwIDk3LjUgLTQ0dDg5LjUgLTUzcTIgLTUgMiAtMTVxMCAtMzMgLTE3IC03NnEtMTYgLTM5IC03MSAtNjUuNXQtMTAyIC0yNi41cS01NyAwIC0xOTAgNjJxLTk4IDQ1IC0xNzAgMTE4dC0xNDggMTg1cS03MiAxMDcgLTcxIDE5NHY4cTMgOTEgNzQgMTU4cTI0IDIyIDUyIDIycTYgMCAxOCAtMS41dDE5IC0xLjVxMTkgMCAyNi41IC02LjV0MTUuNSAtMjcuNXE4IC0yMCAzMyAtODh0MjUgLTc1cTAgLTIxIC0zNC41IC01Ny41IHQtMzQuNSAtNDYuNXEwIC03IDUgLTE1cTM0IC03MyAxMDIgLTEzN3E1NiAtNTMgMTUxIC0xMDFxMTIgLTcgMjIgLTdxMTUgMCA1NCA0OC41dDUyIDQ4LjV6TTc4MiAzMnExMjcgMCAyNDMuNSA1MHQyMDAuNSAxMzR0MTM0IDIwMC41dDUwIDI0My41dC01MCAyNDMuNXQtMTM0IDIwMC41dC0yMDAuNSAxMzR0LTI0My41IDUwdC0yNDMuNSAtNTB0LTIwMC41IC0xMzR0LTEzNCAtMjAwLjV0LTUwIC0yNDMuNXEwIC0yMDMgMTIwIC0zNjhsLTc5IC0yMzMgbDI0MiA3N3ExNTggLTEwNCAzNDUgLTEwNHpNNzgyIDE0MTRxMTUzIDAgMjkyLjUgLTYwdDI0MC41IC0xNjF0MTYxIC0yNDAuNXQ2MCAtMjkyLjV0LTYwIC0yOTIuNXQtMTYxIC0yNDAuNXQtMjQwLjUgLTE2MXQtMjkyLjUgLTYwcS0xOTUgMCAtMzY1IDk0bC00MTcgLTEzNGwxMzYgNDA1cS0xMDggMTc4IC0xMDggMzg5cTAgMTUzIDYwIDI5Mi41dDE2MSAyNDAuNXQyNDAuNSAxNjF0MjkyLjUgNjB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMzM7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEyOCAxMjhoMTAyNHYxMjhoLTEwMjR2LTEyOHpNMTI4IDY0MGgxMDI0djEyOGgtMTAyNHYtMTI4ek0xNjk2IDE5MnEwIDQwIC0yOCA2OHQtNjggMjh0LTY4IC0yOHQtMjggLTY4dDI4IC02OHQ2OCAtMjh0NjggMjh0MjggNjh6TTEyOCAxMTUyaDEwMjR2MTI4aC0xMDI0di0xMjh6TTE2OTYgNzA0cTAgNDAgLTI4IDY4dC02OCAyOHQtNjggLTI4dC0yOCAtNjh0MjggLTY4dDY4IC0yOHQ2OCAyOHQyOCA2OHpNMTY5NiAxMjE2IHEwIDQwIC0yOCA2OHQtNjggMjh0LTY4IC0yOHQtMjggLTY4dDI4IC02OHQ2OCAtMjh0NjggMjh0MjggNjh6TTE3OTIgMzg0di0zODRoLTE3OTJ2Mzg0aDE3OTJ6TTE3OTIgODk2di0zODRoLTE3OTJ2Mzg0aDE3OTJ6TTE3OTIgMTQwOHYtMzg0aC0xNzkydjM4NGgxNzkyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjM0OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik03MDQgNjQwcS0xNTkgMCAtMjcxLjUgMTEyLjV0LTExMi41IDI3MS41dDExMi41IDI3MS41dDI3MS41IDExMi41dDI3MS41IC0xMTIuNXQxMTIuNSAtMjcxLjV0LTExMi41IC0yNzEuNXQtMjcxLjUgLTExMi41ek0xNjY0IDUxMmgzNTJxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0xOTJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41aC0zNTJ2LTM1MnEwIC0xMyAtOS41IC0yMi41dC0yMi41IC05LjVoLTE5MnEtMTMgMCAtMjIuNSA5LjUgdC05LjUgMjIuNXYzNTJoLTM1MnEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE5MnEwIDEzIDkuNSAyMi41dDIyLjUgOS41aDM1MnYzNTJxMCAxMyA5LjUgMjIuNXQyMi41IDkuNWgxOTJxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0zNTJ6TTkyOCAyODhxMCAtNTIgMzggLTkwdDkwIC0zOGgyNTZ2LTIzOHEtNjggLTUwIC0xNzEgLTUwaC04NzRxLTEyMSAwIC0xOTQgNjl0LTczIDE5MHEwIDUzIDMuNSAxMDMuNXQxNCAxMDl0MjYuNSAxMDguNSB0NDMgOTcuNXQ2MiA4MXQ4NS41IDUzLjV0MTExLjUgMjBxMTkgMCAzOSAtMTdxNzkgLTYxIDE1NC41IC05MS41dDE2NC41IC0zMC41dDE2NC41IDMwLjV0MTU0LjUgOTEuNXEyMCAxNyAzOSAxN3ExMzIgMCAyMTcgLTk2aC0yMjNxLTUyIDAgLTkwIC0zOHQtMzggLTkwdi0xOTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMzU7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTcwNCA2NDBxLTE1OSAwIC0yNzEuNSAxMTIuNXQtMTEyLjUgMjcxLjV0MTEyLjUgMjcxLjV0MjcxLjUgMTEyLjV0MjcxLjUgLTExMi41dDExMi41IC0yNzEuNXQtMTEyLjUgLTI3MS41dC0yNzEuNSAtMTEyLjV6TTE3ODEgMzIwbDI0OSAtMjQ5cTkgLTkgOSAtMjNxMCAtMTMgLTkgLTIybC0xMzYgLTEzNnEtOSAtOSAtMjIgLTlxLTE0IDAgLTIzIDlsLTI0OSAyNDlsLTI0OSAtMjQ5cS05IC05IC0yMyAtOXEtMTMgMCAtMjIgOWwtMTM2IDEzNiBxLTkgOSAtOSAyMnEwIDE0IDkgMjNsMjQ5IDI0OWwtMjQ5IDI0OXEtOSA5IC05IDIzcTAgMTMgOSAyMmwxMzYgMTM2cTkgOSAyMiA5cTE0IDAgMjMgLTlsMjQ5IC0yNDlsMjQ5IDI0OXE5IDkgMjMgOXExMyAwIDIyIC05bDEzNiAtMTM2cTkgLTkgOSAtMjJxMCAtMTQgLTkgLTIzek0xMjgzIDMyMGwtMTgxIC0xODFxLTM3IC0zNyAtMzcgLTkxcTAgLTUzIDM3IC05MGw4MyAtODNxLTIxIC0zIC00NCAtM2gtODc0cS0xMjEgMCAtMTk0IDY5IHQtNzMgMTkwcTAgNTMgMy41IDEwMy41dDE0IDEwOXQyNi41IDEwOC41dDQzIDk3LjV0NjIgODF0ODUuNSA1My41dDExMS41IDIwcTE5IDAgMzkgLTE3cTE1NCAtMTIyIDMxOSAtMTIydDMxOSAxMjJxMjAgMTcgMzkgMTdxMjggMCA1NyAtNnEtMjggLTI3IC00MSAtNTB0LTEzIC01NnEwIC01NCAzNyAtOTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyMzY7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTI1NiA1MTJoMTcyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTQ0OGgtMjU2djI1NmgtMTUzNnYtMjU2aC0yNTZ2MTIxNnEwIDI2IDE5IDQ1dDQ1IDE5aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTcwNHpNODMyIDgzMnEwIDEwNiAtNzUgMTgxdC0xODEgNzV0LTE4MSAtNzV0LTc1IC0xODF0NzUgLTE4MXQxODEgLTc1dDE4MSA3NXQ3NSAxODF6TTIwNDggNTc2djY0cTAgMTU5IC0xMTIuNSAyNzEuNXQtMjcxLjUgMTEyLjVoLTcwNCBxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di0zODRoMTE1MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIzNzsiIGQ9Ik0xNTM2IDE1MzZsLTE5MiAtNDQ4aDE5MnYtMTkyaC0yNzRsLTU1IC0xMjhoMzI5di0xOTJoLTQxMWwtMzU3IC04MzJsLTM1NyA4MzJoLTQxMXYxOTJoMzI5bC01NSAxMjhoLTI3NHYxOTJoMTkybC0xOTIgNDQ4aDI1NmwzMjMgLTc2OGgzNzhsMzIzIDc2OGgyNTZ6TTc2OCAzMjBsMTA4IDI1NmgtMjE2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjM4OyIgZD0iTTEwODggMTUzNnExODUgMCAzMTYuNSAtOTMuNXQxMzEuNSAtMjI2LjV2LTg5NnEwIC0xMzAgLTEyNS41IC0yMjJ0LTMwNS41IC05N2wyMTMgLTIwMnExNiAtMTUgOCAtMzV0LTMwIC0yMGgtMTA1NnEtMjIgMCAtMzAgMjB0OCAzNWwyMTMgMjAycS0xODAgNSAtMzA1LjUgOTd0LTEyNS41IDIyMnY4OTZxMCAxMzMgMTMxLjUgMjI2LjV0MzE2LjUgOTMuNWg2NDB6TTc2OCAxOTJxODAgMCAxMzYgNTZ0NTYgMTM2dC01NiAxMzZ0LTEzNiA1NiB0LTEzNiAtNTZ0LTU2IC0xMzZ0NTYgLTEzNnQxMzYgLTU2ek0xMzQ0IDc2OHY1MTJoLTExNTJ2LTUxMmgxMTUyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjM5OyIgZD0iTTEwODggMTUzNnExODUgMCAzMTYuNSAtOTMuNXQxMzEuNSAtMjI2LjV2LTg5NnEwIC0xMzAgLTEyNS41IC0yMjJ0LTMwNS41IC05N2wyMTMgLTIwMnExNiAtMTUgOCAtMzV0LTMwIC0yMGgtMTA1NnEtMjIgMCAtMzAgMjB0OCAzNWwyMTMgMjAycS0xODAgNSAtMzA1LjUgOTd0LTEyNS41IDIyMnY4OTZxMCAxMzMgMTMxLjUgMjI2LjV0MzE2LjUgOTMuNWg2NDB6TTI4OCAyMjRxNjYgMCAxMTMgNDd0NDcgMTEzdC00NyAxMTN0LTExMyA0NyB0LTExMyAtNDd0LTQ3IC0xMTN0NDcgLTExM3QxMTMgLTQ3ek03MDQgNzY4djUxMmgtNTQ0di01MTJoNTQ0ek0xMjQ4IDIyNHE2NiAwIDExMyA0N3Q0NyAxMTN0LTQ3IDExM3QtMTEzIDQ3dC0xMTMgLTQ3dC00NyAtMTEzdDQ3IC0xMTN0MTEzIC00N3pNMTQwOCA3Njh2NTEyaC01NzZ2LTUxMmg1NzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyM2E7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTU5NyAxMTE1di0xMTczcTAgLTI1IC0xMi41IC00Mi41dC0zNi41IC0xNy41cS0xNyAwIC0zMyA4bC00NjUgMjMzcS0yMSAxMCAtMzUuNSAzMy41dC0xNC41IDQ2LjV2MTE0MHEwIDIwIDEwIDM0dDI5IDE0cTE0IDAgNDQgLTE1bDUxMSAtMjU2cTMgLTMgMyAtNXpNNjYxIDEwMTRsNTM0IC04NjZsLTUzNCAyNjZ2NjAwek0xNzkyIDk5NnYtMTA1NHEwIC0yNSAtMTQgLTQwLjV0LTM4IC0xNS41dC00NyAxM2wtNDQxIDIyMHpNMTc4OSAxMTE2IHEwIC0zIC0yNTYuNSAtNDE5LjV0LTMwMC41IC00ODcuNWwtMzkwIDYzNGwzMjQgNTI3cTE3IDI4IDUyIDI4cTE0IDAgMjYgLTZsNTQxIC0yNzBxNCAtMiA0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjNiOyIgZD0iTTgwOSA1MzJsMjY2IDQ5OWgtMTEybC0xNTcgLTMxMnEtMjQgLTQ4IC00NCAtOTJsLTQyIDkybC0xNTUgMzEyaC0xMjBsMjYzIC00OTN2LTMyNGgxMDF2MzE4ek0xNTM2IDE0MDh2LTE1MzZoLTE1MzZ2MTUzNmgxNTM2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjNjOyIgaG9yaXotYWR2LXg9IjIyOTYiIGQ9Ik00NzggLTEzOXEtOCAtMTYgLTI3IC0zNC41dC0zNyAtMjUuNXEtMjUgLTkgLTUxLjUgMy41dC0yOC41IDMxLjVxLTEgMjIgNDAgNTV0NjggMzhxMjMgNCAzNCAtMjEuNXQyIC00Ni41ek0xODE5IC0xMzlxNyAtMTYgMjYgLTM0LjV0MzggLTI1LjVxMjUgLTkgNTEuNSAzLjV0MjcuNSAzMS41cTIgMjIgLTM5LjUgNTV0LTY4LjUgMzhxLTIyIDQgLTMzIC0yMS41dC0yIC00Ni41ek0xODY3IC0zMHExMyAtMjcgNTYuNSAtNTkuNXQ3Ny41IC00MS41IHE0NSAtMTMgODIgNC41dDM3IDUwLjVxMCA0NiAtNjcuNSAxMDAuNXQtMTE1LjUgNTkuNXEtNDAgNSAtNjMuNSAtMzcuNXQtNi41IC03Ni41ek00MjggLTMwcS0xMyAtMjcgLTU2IC01OS41dC03NyAtNDEuNXEtNDUgLTEzIC04MiA0LjV0LTM3IDUwLjVxMCA0NiA2Ny41IDEwMC41dDExNS41IDU5LjVxNDAgNSA2MyAtMzcuNXQ2IC03Ni41ek0xMTU4IDEwOTRoMXEtNDEgMCAtNzYgLTE1cTI3IC04IDQ0IC0zMC41dDE3IC00OS41IHEwIC0zNSAtMjcgLTYwdC02NSAtMjVxLTUyIDAgLTgwIDQzcS01IC0yMyAtNSAtNDJxMCAtNzQgNTYgLTEyNi41dDEzNSAtNTIuNXE4MCAwIDEzNiA1Mi41dDU2IDEyNi41dC01NiAxMjYuNXQtMTM2IDUyLjV6TTE0NjIgMTMxMnEtOTkgMTA5IC0yMjAuNSAxMzEuNXQtMjQ1LjUgLTQ0LjVxMjcgNjAgODIuNSA5Ni41dDExOCAzOS41dDEyMS41IC0xN3Q5OS41IC03NC41dDQ0LjUgLTEzMS41ek0yMjEyIDczcTggLTExIC0xMSAtNDIgcTcgLTIzIDcgLTQwcTEgLTU2IC00NC41IC0xMTIuNXQtMTA5LjUgLTkxLjV0LTExOCAtMzdxLTQ4IC0yIC05MiAyMS41dC02NiA2NS41cS02ODcgLTI1IC0xMjU5IDBxLTIzIC00MSAtNjYuNSAtNjV0LTkyLjUgLTIycS04NiAzIC0xNzkuNSA4MC41dC05Mi41IDE2MC41cTIgMjIgNyA0MHEtMTkgMzEgLTExIDQycTYgMTAgMzEgMXExNCAyMiA0MSA1MXEtNyAyOSAyIDM4cTExIDEwIDM5IC00cTI5IDIwIDU5IDM0cTAgMjkgMTMgMzcgcTIzIDEyIDUxIC0xNnEzNSA1IDYxIC0ycTE4IC00IDM4IC0xOXY3M3EtMTEgMCAtMTggMnEtNTMgMTAgLTk3IDQ0LjV0LTU1IDg3LjVxLTkgMzggMCA4MXExNSA2MiA5MyA5NXEyIDE3IDE5IDM1LjV0MzYgMjMuNXQzMyAtNy41dDE5IC0zMC41aDEzcTQ2IC01IDYwIC0yM3EzIC0zIDUgLTdxMTAgMSAzMC41IDMuNXQzMC41IDMuNXEtMTUgMTEgLTMwIDE3cS0yMyA0MCAtOTEgNDNxMCA2IDEgMTBxLTYyIDIgLTExOC41IDE4LjV0LTg0LjUgNDcuNSBxLTMyIDM2IC00Mi41IDkydC0yLjUgMTEycTE2IDEyNiA5MCAxNzlxMjMgMTYgNTIgNC41dDMyIC00MC41cTAgLTEgMS41IC0xNHQyLjUgLTIxdDMgLTIwdDUuNSAtMTl0OC41IC0xMHEyNyAtMTQgNzYgLTEycTQ4IDQ2IDk4IDc0cS00MCA0IC0xNjIgLTE0bDQ3IDQ2cTYxIDU4IDE2MyAxMTFxMTQ1IDczIDI4MiA4NnEtMjAgOCAtNDEgMTUuNXQtNDcgMTR0LTQyLjUgMTAuNXQtNDcuNSAxMXQtNDMgMTBxNTk1IDEyNiA5MDQgLTEzOSBxOTggLTg0IDE1OCAtMjIycTg1IC0xMCAxMjEgOWgxcTUgMyA4LjUgMTB0NS41IDE5dDMgMTkuNXQzIDIxLjVsMSAxNHEzIDI4IDMyIDQwdDUyIC01cTczIC01MiA5MSAtMTc4cTcgLTU3IC0zLjUgLTExM3QtNDIuNSAtOTFxLTI4IC0zMiAtODMuNSAtNDguNXQtMTE1LjUgLTE4LjV2LTEwcS03MSAtMiAtOTUgLTQzcS0xNCAtNSAtMzEgLTE3cTExIC0xIDMyIC0zLjV0MzAgLTMuNXExIDQgNSA4cTE2IDE4IDYwIDIzaDEzcTUgMTggMTkgMzB0MzMgOCB0MzYgLTIzdDE5IC0zNnE3OSAtMzIgOTMgLTk1cTkgLTQwIDEgLTgxcS0xMiAtNTMgLTU2IC04OHQtOTcgLTQ0cS0xMCAtMiAtMTcgLTJxMCAtNDkgLTEgLTczcTIwIDE1IDM4IDE5cTI2IDcgNjEgMnEyOCAyOCA1MSAxNnExNCAtOSAxNCAtMzdxMzMgLTE2IDU5IC0zNHEyNyAxMyAzOCA0cTEwIC0xMCAyIC0zOHEyOCAtMzAgNDEgLTUxcTIzIDggMzEgLTF6TTE5MzcgMTAyNXEwIC0yOSAtOSAtNTRxODIgLTMyIDExMiAtMTMyIHE0IDM3IC05LjUgOTguNXQtNDEuNSA5MC41cS0yMCAxOSAtMzYgMTd0LTE2IC0yMHpNMTg1OSA5MjVxMzUgLTQyIDQ3LjUgLTEwOC41dC0wLjUgLTEyNC41cTY3IDEzIDk3IDQ1cTEzIDE0IDE4IDI4cS0zIDY0IC0zMSAxMTQuNXQtNzkgNjYuNXEtMTUgLTE1IC01MiAtMjF6TTE4MjIgOTIxcS0zMCAwIC00NCAxcTQyIC0xMTUgNTMgLTIzOXEyMSAwIDQzIDNxMTYgNjggMSAxMzV0LTUzIDEwMHpNMjU4IDgzOXEzMCAxMDAgMTEyIDEzMiBxLTkgMjUgLTkgNTRxMCAxOCAtMTYuNSAyMHQtMzUuNSAtMTdxLTI4IC0yOSAtNDEuNSAtOTAuNXQtOS41IC05OC41ek0yOTQgNzM3cTI5IC0zMSA5NyAtNDVxLTEzIDU4IC0wLjUgMTI0LjV0NDcuNSAxMDguNXYwcS0zNyA2IC01MiAyMXEtNTEgLTE2IC03OC41IC02NnQtMzEuNSAtMTE1cTkgLTE3IDE4IC0yOHpNNDcxIDY4M3ExNCAxMjQgNzMgMjM1cS0xOSAtNCAtNTUgLTE4bC00NSAtMTl2MXEtNDYgLTg5IC0yMCAtMTk2cTI1IC0zIDQ3IC0zeiBNMTQzNCA2NDRxOCAtMzggMTYuNSAtMTA4LjV0MTEuNSAtODkuNXEzIC0xOCA5LjUgLTIxLjV0MjMuNSA0LjVxNDAgMjAgNjIgODUuNXQyMyAxMjUuNXEtMjQgMiAtMTQ2IDR6TTExNTIgMTI4NXEtMTE2IDAgLTE5OSAtODIuNXQtODMgLTE5OC41cTAgLTExNyA4MyAtMTk5LjV0MTk5IC04Mi41dDE5OSA4Mi41dDgzIDE5OS41cTAgMTE2IC04MyAxOTguNXQtMTk5IDgyLjV6TTEzODAgNjQ2cS0xMDYgMiAtMjExIDB2MXEtMSAtMjcgMi41IC04NiB0MTMuNSAtNjZxMjkgLTE0IDkzLjUgLTE0LjV0OTUuNSAxMC41cTkgMyAxMSAzOXQtMC41IDY5LjV0LTQuNSA0Ni41ek0xMTEyIDQ0N3E4IDQgOS41IDQ4dC0wLjUgODh0LTQgNjN2MXEtMjEyIC0zIC0yMTQgLTNxLTQgLTIwIC03IC02MnQwIC04M3QxNCAtNDZxMzQgLTE1IDEwMSAtMTZ0MTAxIDEwek03MTggNjM2cS0xNiAtNTkgNC41IC0xMTguNXQ3Ny41IC04NC41cTE1IC04IDI0IC01dDEyIDIxcTMgMTYgOCA5MHQxMCAxMDMgcS02OSAtMiAtMTM2IC02ek01OTEgNTEwcTMgLTIzIC0zNCAtMzZxMTMyIC0xNDEgMjcxLjUgLTI0MHQzMDUuNSAtMTU0cTE3MiA0OSAzMTAuNSAxNDZ0MjkzLjUgMjUwcS0zMyAxMyAtMzAgMzRsMyA5djF2LTFxLTE3IDIgLTUwIDUuNXQtNDggNC41cS0yNiAtOTAgLTgyIC0xMzJxLTUxIC0zOCAtODIgMXEtNSA2IC05IDE0cS03IDEzIC0xNyA2MnEtMiAtNSAtNSAtOXQtNy41IC03dC04IC01LjV0LTkuNSAtNGwtMTAgLTIuNXQtMTIgLTIgbC0xMiAtMS41dC0xMy41IC0xdC0xMy41IC0wLjVxLTEwNiAtOSAtMTYzIDExcS00IC0xNyAtMTAgLTI2LjV0LTIxIC0xNXQtMjMgLTd0LTM2IC0zLjVxLTIgMCAtMyAtMC41dC0zIC0wLjVoLTNxLTE3OSAtMTcgLTIwMyA0MHEtMiAtNjMgLTU2IC01NHEtNDcgOCAtOTEgNTRxLTEyIDEzIC0yMCAyNnEtMTcgMjkgLTI2IDY1cS01OCAtNiAtODcgLTEwcTEgLTIgNCAtMTB6TTUwNyAtMTE4cTMgMTQgMyAzMHEtMTcgNzEgLTUxIDEzMHQtNzMgNzAgcS00MSAxMiAtMTAxLjUgLTE0LjV0LTEwNC41IC04MHQtMzkgLTEwNy41cTM1IC01MyAxMDAgLTkzdDExOSAtNDJxNTEgLTIgOTQgMjh0NTMgNzl6TTUxMCA1M3EyMyAtNjMgMjcgLTExOXExOTUgMTEzIDM5MiAxNzRxLTk4IDUyIC0xODAuNSAxMjB0LTE3OS41IDE2NXEtNiAtNCAtMjkgLTEzcTAgLTIgLTEgLTV0LTEgLTRxMzEgLTE4IDIyIC0zN3EtMTIgLTIzIC01NiAtMzRxLTEwIC0xMyAtMjkgLTI0aC0xcS0yIC04MyAxIC0xNTAgcTE5IC0zNCAzNSAtNzN6TTU3OSAtMTEzcTUzMiAtMjEgMTE0NSAwcS0yNTQgMTQ3IC00MjggMTk2cS03NiAtMzUgLTE1NiAtNTdxLTggLTMgLTE2IDBxLTY1IDIxIC0xMjkgNDlxLTIwOCAtNjAgLTQxNiAtMTg4aC0xdi0xcTEgMCAxIDF6TTE3NjMgLTY3cTQgNTQgMjggMTIwcTE0IDM4IDMzIDcxbC0xIC0xcTMgNzcgMyAxNTNxLTE1IDggLTMwIDI1cS00MiA5IC01NiAzM3EtOSAyMCAyMiAzOHEtMiA0IC0yIDlxLTE2IDQgLTI4IDEyIHEtMjA0IC0xOTAgLTM4MyAtMjg0cTE5OCAtNTkgNDE0IC0xNzZ6TTIxNTUgLTkwcTUgNTQgLTM5IDEwNy41dC0xMDQgODB0LTEwMiAxNC41cS0zOCAtMTEgLTcyLjUgLTcwLjV0LTUxLjUgLTEyOS41cTAgLTE2IDMgLTMwcTEwIC00OSA1MyAtNzl0OTQgLTI4cTU0IDIgMTE5IDQydDEwMCA5M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjIzZDsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMTUyNCAtMjVxMCAtNjggLTQ4IC0xMTZ0LTExNiAtNDh0LTExNi41IDQ4dC00OC41IDExNnQ0OC41IDExNi41dDExNi41IDQ4LjV0MTE2IC00OC41dDQ4IC0xMTYuNXpNNzc1IC0yNXEwIC02OCAtNDguNSAtMTE2dC0xMTYuNSAtNDh0LTExNiA0OHQtNDggMTE2dDQ4IDExNi41dDExNiA0OC41dDExNi41IC00OC41dDQ4LjUgLTExNi41ek0wIDE0NjlxNTcgLTYwIDExMC41IC0xMDQuNXQxMjEgLTgydDEzNiAtNjN0MTY2IC00NS41IHQyMDAgLTMxLjV0MjUwIC0xOC41dDMwNCAtOS41dDM3Mi41IC0yLjVxMTM5IDAgMjQ0LjUgLTV0MTgxIC0xNi41dDEyNCAtMjcuNXQ3MSAtMzkuNXQyNCAtNTEuNXQtMTkuNSAtNjR0LTU2LjUgLTc2LjV0LTg5LjUgLTkxdC0xMTYgLTEwNC41dC0xMzkgLTExOXEtMTg1IC0xNTcgLTI4NiAtMjQ3cTI5IDUxIDc2LjUgMTA5dDk0IDEwNS41dDk0LjUgOTguNXQ4MyA5MS41dDU0IDgwLjV0MTMgNzB0LTQ1LjUgNTUuNXQtMTE2LjUgNDF0LTIwNCAyMy41IHQtMzA0IDVxLTE2OCAtMiAtMzE0IDZ0LTI1NiAyM3QtMjA0LjUgNDF0LTE1OS41IDUxLjV0LTEyMi41IDYyLjV0LTkxLjUgNjYuNXQtNjggNzEuNXQtNTAuNSA2OS41dC00MCA2OHQtMzYuNSA1OS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjNlOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04OTYgMTQ3MnEtMTY5IDAgLTMyMyAtNjZ0LTI2NS41IC0xNzcuNXQtMTc3LjUgLTI2NS41dC02NiAtMzIzdDY2IC0zMjN0MTc3LjUgLTI2NS41dDI2NS41IC0xNzcuNXQzMjMgLTY2dDMyMyA2NnQyNjUuNSAxNzcuNXQxNzcuNSAyNjUuNXQ2NiAzMjN0LTY2IDMyM3QtMTc3LjUgMjY1LjV0LTI2NS41IDE3Ny41dC0zMjMgNjZ6TTg5NiAxNTM2cTE4MiAwIDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHQtNzEgLTM0OCB0LTE5MSAtMjg2dC0yODYgLTE5MXQtMzQ4IC03MXQtMzQ4IDcxdC0yODYgMTkxdC0xOTEgMjg2dC03MSAzNDh0NzEgMzQ4dDE5MSAyODZ0Mjg2IDE5MXQzNDggNzF6TTQ5NiA3MDRxMTYgMCAxNiAtMTZ2LTQ4MHEwIC0xNiAtMTYgLTE2aC0zMnEtMTYgMCAtMTYgMTZ2NDgwcTAgMTYgMTYgMTZoMzJ6TTg5NiA2NDBxNTMgMCA5MC41IC0zNy41dDM3LjUgLTkwLjVxMCAtMzUgLTE3LjUgLTY0dC00Ni41IC00NnYtMTE0cTAgLTE0IC05IC0yMyB0LTIzIC05aC02NHEtMTQgMCAtMjMgOXQtOSAyM3YxMTRxLTI5IDE3IC00Ni41IDQ2dC0xNy41IDY0cTAgNTMgMzcuNSA5MC41dDkwLjUgMzcuNXpNODk2IDE0MDhxMjA5IDAgMzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXQtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3pNNTQ0IDkyOHYtOTYgcTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzdjk2cTAgOTMgNjUuNSAxNTguNXQxNTguNSA2NS41dDE1OC41IC02NS41dDY1LjUgLTE1OC41di05NnEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3Y5NnEwIDE0NiAtMTAzIDI0OXQtMjQ5IDEwM3QtMjQ5IC0xMDN0LTEwMyAtMjQ5ek0xNDA4IDE5MnY1MTJxMCAyNiAtMTkgNDV0LTQ1IDE5aC04OTZxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1di01MTIgcTAgLTI2IDE5IC00NXQ0NSAtMTloODk2cTI2IDAgNDUgMTl0MTkgNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNDA7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTE5MjAgMTAyNHYtNzY4aC0xNjY0djc2OGgxNjY0ek0yMDQ4IDQ0OGgxMjh2Mzg0aC0xMjh2Mjg4cTAgMTQgLTkgMjN0LTIzIDloLTE4NTZxLTE0IDAgLTIzIC05dC05IC0yM3YtOTYwcTAgLTE0IDkgLTIzdDIzIC05aDE4NTZxMTQgMCAyMyA5dDkgMjN2Mjg4ek0yMzA0IDgzMnYtMzg0cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41di0xNjBxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE4NTZxLTY2IDAgLTExMyA0N3QtNDcgMTEzIHY5NjBxMCA2NiA0NyAxMTN0MTEzIDQ3aDE4NTZxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTE2MHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0MTsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMjU2IDI1NnY3NjhoMTI4MHYtNzY4aC0xMjgwek0yMTc2IDk2MHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXYtMzg0cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41di0xNjBxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE4NTZxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjk2MHEwIDY2IDQ3IDExM3QxMTMgNDdoMTg1NnE2NiAwIDExMyAtNDd0NDcgLTExM3YtMTYwek0yMTc2IDQ0OHYzODRoLTEyOHYyODhxMCAxNCAtOSAyM3QtMjMgOSBoLTE4NTZxLTE0IDAgLTIzIC05dC05IC0yM3YtOTYwcTAgLTE0IDkgLTIzdDIzIC05aDE4NTZxMTQgMCAyMyA5dDkgMjN2Mjg4aDEyOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0MjsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMjU2IDI1NnY3NjhoODk2di03NjhoLTg5NnpNMjE3NiA5NjBxNTMgMCA5MC41IC0zNy41dDM3LjUgLTkwLjV2LTM4NHEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNXYtMTYwcTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xODU2cS02NiAwIC0xMTMgNDd0LTQ3IDExM3Y5NjBxMCA2NiA0NyAxMTN0MTEzIDQ3aDE4NTZxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTE2MHpNMjE3NiA0NDh2Mzg0aC0xMjh2Mjg4cTAgMTQgLTkgMjN0LTIzIDkgaC0xODU2cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTk2MHEwIC0xNCA5IC0yM3QyMyAtOWgxODU2cTE0IDAgMjMgOXQ5IDIzdjI4OGgxMjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNDM7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTI1NiAyNTZ2NzY4aDUxMnYtNzY4aC01MTJ6TTIxNzYgOTYwcTUzIDAgOTAuNSAtMzcuNXQzNy41IC05MC41di0zODRxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV2LTE2MHEwIC02NiAtNDcgLTExM3QtMTEzIC00N2gtMTg1NnEtNjYgMCAtMTEzIDQ3dC00NyAxMTN2OTYwcTAgNjYgNDcgMTEzdDExMyA0N2gxODU2cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi0xNjB6TTIxNzYgNDQ4djM4NGgtMTI4djI4OHEwIDE0IC05IDIzdC0yMyA5IGgtMTg1NnEtMTQgMCAtMjMgLTl0LTkgLTIzdi05NjBxMCAtMTQgOSAtMjN0MjMgLTloMTg1NnExNCAwIDIzIDl0OSAyM3YyODhoMTI4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjQ0OyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik0yMTc2IDk2MHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXYtMzg0cTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41di0xNjBxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE4NTZxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjk2MHEwIDY2IDQ3IDExM3QxMTMgNDdoMTg1NnE2NiAwIDExMyAtNDd0NDcgLTExM3YtMTYwek0yMTc2IDQ0OHYzODRoLTEyOHYyODhxMCAxNCAtOSAyM3QtMjMgOWgtMTg1NnEtMTQgMCAtMjMgLTl0LTkgLTIzIHYtOTYwcTAgLTE0IDkgLTIzdDIzIC05aDE4NTZxMTQgMCAyMyA5dDkgMjN2Mjg4aDEyOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0NTsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNMTEzMyA0OTNxMzEgLTMwIDE0IC02OXEtMTcgLTQwIC01OSAtNDBoLTM4MmwyMDEgLTQ3NnExMCAtMjUgMCAtNDl0LTM0IC0zNWwtMTc3IC03NXEtMjUgLTEwIC00OSAwdC0zNSAzNGwtMTkxIDQ1MmwtMzEyIC0zMTJxLTE5IC0xOSAtNDUgLTE5cS0xMiAwIC0yNCA1cS00MCAxNyAtNDAgNTl2MTUwNHEwIDQyIDQwIDU5cTEyIDUgMjQgNXEyNyAwIDQ1IC0xOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0NjsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNODMyIDE0MDhxLTMyMCAwIC0zMjAgLTIyNHYtNDE2aDEyOHYtMTI4aC0xMjh2LTU0NHEwIC0yMjQgMzIwIC0yMjRoNjR2LTEyOGgtNjRxLTI3MiAwIC0zODQgMTQ2cS0xMTIgLTE0NiAtMzg0IC0xNDZoLTY0djEyOGg2NHEzMjAgMCAzMjAgMjI0djU0NGgtMTI4djEyOGgxMjh2NDE2cTAgMjI0IC0zMjAgMjI0aC02NHYxMjhoNjRxMjcyIDAgMzg0IC0xNDZxMTEyIDE0NiAzODQgMTQ2aDY0di0xMjhoLTY0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjQ3OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0yMDQ4IDExNTJoLTEyOHYtMTAyNGgxMjh2LTM4NGgtMzg0djEyOGgtMTI4MHYtMTI4aC0zODR2Mzg0aDEyOHYxMDI0aC0xMjh2Mzg0aDM4NHYtMTI4aDEyODB2MTI4aDM4NHYtMzg0ek0xNzkyIDE0MDh2LTEyOGgxMjh2MTI4aC0xMjh6TTEyOCAxNDA4di0xMjhoMTI4djEyOGgtMTI4ek0yNTYgLTEyOHYxMjhoLTEyOHYtMTI4aDEyOHpNMTY2NCAwdjEyOGgxMjh2MTAyNGgtMTI4djEyOGgtMTI4MHYtMTI4aC0xMjh2LTEwMjRoMTI4di0xMjggaDEyODB6TTE5MjAgLTEyOHYxMjhoLTEyOHYtMTI4aDEyOHpNMTI4MCA4OTZoMzg0di03NjhoLTg5NnYyNTZoLTM4NHY3NjhoODk2di0yNTZ6TTUxMiA1MTJoNjQwdjUxMmgtNjQwdi01MTJ6TTE1MzYgMjU2djUxMmgtMjU2di0zODRoLTM4NHYtMTI4aDY0MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0ODsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMjMwNCA3NjhoLTEyOHYtNjQwaDEyOHYtMzg0aC0zODR2MTI4aC04OTZ2LTEyOGgtMzg0djM4NGgxMjh2MTI4aC0zODR2LTEyOGgtMzg0djM4NGgxMjh2NjQwaC0xMjh2Mzg0aDM4NHYtMTI4aDg5NnYxMjhoMzg0di0zODRoLTEyOHYtMTI4aDM4NHYxMjhoMzg0di0zODR6TTIwNDggMTAyNHYtMTI4aDEyOHYxMjhoLTEyOHpNMTQwOCAxNDA4di0xMjhoMTI4djEyOGgtMTI4ek0xMjggMTQwOHYtMTI4aDEyOHYxMjhoLTEyOHpNMjU2IDI1NiB2MTI4aC0xMjh2LTEyOGgxMjh6TTE1MzYgMzg0aC0xMjh2LTEyOGgxMjh2MTI4ek0zODQgMzg0aDg5NnYxMjhoMTI4djY0MGgtMTI4djEyOGgtODk2di0xMjhoLTEyOHYtNjQwaDEyOHYtMTI4ek04OTYgLTEyOHYxMjhoLTEyOHYtMTI4aDEyOHpNMjE3NiAtMTI4djEyOGgtMTI4di0xMjhoMTI4ek0yMDQ4IDEyOHY2NDBoLTEyOHYxMjhoLTM4NHYtMzg0aDEyOHYtMzg0aC0zODR2MTI4aC0zODR2LTEyOGgxMjh2LTEyOGg4OTZ2MTI4aDEyOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI0OTsiIGQ9Ik0xMDI0IDI4OHYtNDE2aC05MjhxLTQwIDAgLTY4IDI4dC0yOCA2OHYxMzQ0cTAgNDAgMjggNjh0NjggMjhoMTM0NHE0MCAwIDY4IC0yOHQyOCAtNjh2LTkyOGgtNDE2cS00MCAwIC02OCAtMjh0LTI4IC02OHpNMTE1MiAyNTZoMzgxcS0xNSAtODIgLTY1IC0xMzJsLTE4NCAtMTg0cS01MCAtNTAgLTEzMiAtNjV2MzgxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjRhOyIgZD0iTTE0MDAgMjU2aC0yNDh2LTI0OHEyOSAxMCA0MSAyMmwxODUgMTg1cTEyIDEyIDIyIDQxek0xMTIwIDM4NGgyODh2ODk2aC0xMjgwdi0xMjgwaDg5NnYyODhxMCA0MCAyOCA2OHQ2OCAyOHpNMTUzNiAxMzEydi0xMDI0cTAgLTQwIC0yMCAtODh0LTQ4IC03NmwtMTg0IC0xODRxLTI4IC0yOCAtNzYgLTQ4dC04OCAtMjBoLTEwMjRxLTQwIDAgLTY4IDI4dC0yOCA2OHYxMzQ0cTAgNDAgMjggNjh0NjggMjhoMTM0NHE0MCAwIDY4IC0yOHQyOCAtNjggeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjRiOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik0xOTUxIDUzOHEwIC0yNiAtMTUuNSAtNDQuNXQtMzguNSAtMjMuNXEtOCAtMiAtMTggLTJoLTE1M3YxNDBoMTUzcTEwIDAgMTggLTJxMjMgLTUgMzguNSAtMjMuNXQxNS41IC00NC41ek0xOTMzIDc1MXEwIC0yNSAtMTUgLTQydC0zOCAtMjFxLTMgLTEgLTE1IC0xaC0xMzl2MTI5aDEzOXEzIDAgOC41IC0wLjV0Ni41IC0wLjVxMjMgLTQgMzggLTIxLjV0MTUgLTQyLjV6TTcyOCA1ODd2MzA4aC0yMjh2LTMwOHEwIC01OCAtMzggLTk0LjUgdC0xMDUgLTM2LjVxLTEwOCAwIC0yMjkgNTl2LTExMnE1MyAtMTUgMTIxIC0yM3QxMDkgLTlsNDIgLTFxMzI4IDAgMzI4IDIxN3pNMTQ0MiA0MDN2MTEzcS05OSAtNTIgLTIwMCAtNTlxLTEwOCAtOCAtMTY5IDQxdC02MSAxNDJ0NjEgMTQydDE2OSA0MXExMDEgLTcgMjAwIC01OHYxMTJxLTQ4IDEyIC0xMDAgMTkuNXQtODAgOS41bC0yOCAycS0xMjcgNiAtMjE4LjUgLTE0dC0xNDAuNSAtNjB0LTcxIC04OHQtMjIgLTEwNnQyMiAtMTA2dDcxIC04OCB0MTQwLjUgLTYwdDIxOC41IC0xNHExMDEgNCAyMDggMzF6TTIxNzYgNTE4cTAgNTQgLTQzIDg4LjV0LTEwOSAzOS41djNxNTcgOCA4OSA0MS41dDMyIDc5LjVxMCA1NSAtNDEgODh0LTEwNyAzNnEtMyAwIC0xMiAwLjV0LTE0IDAuNWgtNDU1di01MTBoNDkxcTc0IDAgMTIxLjUgMzYuNXQ0Ny41IDk2LjV6TTIzMDQgMTI4MHYtMTI4MHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTIwNDhxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMjgwcTAgNTIgMzggOTAgdDkwIDM4aDIwNDhxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjRjOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik04NTggMjk1djY5M3EtMTA2IC00MSAtMTcyIC0xMzUuNXQtNjYgLTIxMS41dDY2IC0yMTEuNXQxNzIgLTEzNC41ek0xMzYyIDY0MXEwIDExNyAtNjYgMjExLjV0LTE3MiAxMzUuNXYtNjk0cTEwNiA0MSAxNzIgMTM1LjV0NjYgMjExLjV6TTE1NzcgNjQxcTAgLTE1OSAtNzguNSAtMjk0dC0yMTMuNSAtMjEzLjV0LTI5NCAtNzguNXEtMTE5IDAgLTIyNy41IDQ2LjV0LTE4NyAxMjV0LTEyNSAxODd0LTQ2LjUgMjI3LjVxMCAxNTkgNzguNSAyOTQgdDIxMy41IDIxMy41dDI5NCA3OC41dDI5NCAtNzguNXQyMTMuNSAtMjEzLjV0NzguNSAtMjk0ek0xOTYwIDYzNHEwIDEzOSAtNTUuNSAyNjEuNXQtMTQ3LjUgMjA1LjV0LTIxMy41IDEzMXQtMjUyLjUgNDhoLTMwMXEtMTc2IDAgLTMyMy41IC04MXQtMjM1IC0yMzB0LTg3LjUgLTMzNXEwIC0xNzEgODcgLTMxNy41dDIzNiAtMjMxLjV0MzIzIC04NWgzMDFxMTI5IDAgMjUxLjUgNTAuNXQyMTQuNSAxMzV0MTQ3LjUgMjAyLjV0NTUuNSAyNDZ6IE0yMzA0IDEyODB2LTEyODBxMCAtNTIgLTM4IC05MHQtOTAgLTM4aC0yMDQ4cS01MiAwIC05MCAzOHQtMzggOTB2MTI4MHEwIDUyIDM4IDkwdDkwIDM4aDIwNDhxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjRkOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNjY0IC05NnYxMDg4cTAgMTMgLTkuNSAyMi41dC0yMi41IDkuNWgtMTA4OHEtMTMgMCAtMjIuNSAtOS41dC05LjUgLTIyLjV2LTEwODhxMCAtMTMgOS41IC0yMi41dDIyLjUgLTkuNWgxMDg4cTEzIDAgMjIuNSA5LjV0OS41IDIyLjV6TTE3OTIgOTkydi0xMDg4cTAgLTY2IC00NyAtMTEzdC0xMTMgLTQ3aC0xMDg4cS02NiAwIC0xMTMgNDd0LTQ3IDExM3YxMDg4cTAgNjYgNDcgMTEzdDExMyA0N2gxMDg4cTY2IDAgMTEzIC00N3Q0NyAtMTEzIHpNMTQwOCAxMzc2di0xNjBoLTEyOHYxNjBxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xMDg4cS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtMTA4OHEwIC0xMyA5LjUgLTIyLjV0MjIuNSAtOS41aDE2MHYtMTI4aC0xNjBxLTY2IDAgLTExMyA0N3QtNDcgMTEzdjEwODhxMCA2NiA0NyAxMTN0MTEzIDQ3aDEwODhxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNGU7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTE3MjggMTA4OGwtMzg0IC03MDRoNzY4ek00NDggMTA4OGwtMzg0IC03MDRoNzY4ek0xMjY5IDEyODBxLTE0IC00MCAtNDUuNSAtNzEuNXQtNzEuNSAtNDUuNXYtMTI5MWg2MDhxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTM0NHEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg2MDh2MTI5MXEtNDAgMTQgLTcxLjUgNDUuNXQtNDUuNSA3MS41aC00OTFxLTE0IDAgLTIzIDl0LTkgMjN2NjQgcTAgMTQgOSAyM3QyMyA5aDQ5MXEyMSA1NyA3MCA5Mi41dDExMSAzNS41dDExMSAtMzUuNXQ3MCAtOTIuNWg0OTFxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNDkxek0xMDg4IDEyNjRxMzMgMCA1Ni41IDIzLjV0MjMuNSA1Ni41dC0yMy41IDU2LjV0LTU2LjUgMjMuNXQtNTYuNSAtMjMuNXQtMjMuNSAtNTYuNXQyMy41IC01Ni41dDU2LjUgLTIzLjV6TTIxNzYgMzg0cTAgLTczIC00Ni41IC0xMzF0LTExNy41IC05MSB0LTE0NC41IC00OS41dC0xMzkuNSAtMTYuNXQtMTM5LjUgMTYuNXQtMTQ0LjUgNDkuNXQtMTE3LjUgOTF0LTQ2LjUgMTMxcTAgMTEgMzUgODF0OTIgMTc0LjV0MTA3IDE5NS41dDEwMiAxODR0NTYgMTAwcTE4IDMzIDU2IDMzdDU2IC0zM3E0IC03IDU2IC0xMDB0MTAyIC0xODR0MTA3IC0xOTUuNXQ5MiAtMTc0LjV0MzUgLTgxek04OTYgMzg0cTAgLTczIC00Ni41IC0xMzF0LTExNy41IC05MXQtMTQ0LjUgLTQ5LjV0LTEzOS41IC0xNi41IHQtMTM5LjUgMTYuNXQtMTQ0LjUgNDkuNXQtMTE3LjUgOTF0LTQ2LjUgMTMxcTAgMTEgMzUgODF0OTIgMTc0LjV0MTA3IDE5NS41dDEwMiAxODR0NTYgMTAwcTE4IDMzIDU2IDMzdDU2IC0zM3E0IC03IDU2IC0xMDB0MTAyIC0xODR0MTA3IC0xOTUuNXQ5MiAtMTc0LjV0MzUgLTgxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjUwOyIgZD0iTTE0MDggMTQwOHEwIC0yNjEgLTEwNi41IC00NjEuNXQtMjY2LjUgLTMwNi41cTE2MCAtMTA2IDI2Ni41IC0zMDYuNXQxMDYuNSAtNDYxLjVoOTZxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTQ3MnEtMTQgMCAtMjMgOXQtOSAyM3Y2NHEwIDE0IDkgMjN0MjMgOWg5NnEwIDI2MSAxMDYuNSA0NjEuNXQyNjYuNSAzMDYuNXEtMTYwIDEwNiAtMjY2LjUgMzA2LjV0LTEwNi41IDQ2MS41aC05NnEtMTQgMCAtMjMgOSB0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloMTQ3MnExNCAwIDIzIC05dDkgLTIzdi02NHEwIC0xNCAtOSAtMjN0LTIzIC05aC05NnpNODc0IDcwMHE3NyAyOSAxNDkgOTIuNXQxMjkuNSAxNTIuNXQ5Mi41IDIxMHQzNSAyNTNoLTEwMjRxMCAtMTMyIDM1IC0yNTN0OTIuNSAtMjEwdDEyOS41IC0xNTIuNXQxNDkgLTkyLjVxMTkgLTcgMzAuNSAtMjMuNXQxMS41IC0zNi41dC0xMS41IC0zNi41dC0zMC41IC0yMy41cS03NyAtMjkgLTE0OSAtOTIuNSB0LTEyOS41IC0xNTIuNXQtOTIuNSAtMjEwdC0zNSAtMjUzaDEwMjRxMCAxMzIgLTM1IDI1M3QtOTIuNSAyMTB0LTEyOS41IDE1Mi41dC0xNDkgOTIuNXEtMTkgNyAtMzAuNSAyMy41dC0xMS41IDM2LjV0MTEuNSAzNi41dDMwLjUgMjMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1MTsiIGQ9Ik0xNDA4IDE0MDhxMCAtMjYxIC0xMDYuNSAtNDYxLjV0LTI2Ni41IC0zMDYuNXExNjAgLTEwNiAyNjYuNSAtMzA2LjV0MTA2LjUgLTQ2MS41aDk2cTE0IDAgMjMgLTl0OSAtMjN2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTE0NzJxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloOTZxMCAyNjEgMTA2LjUgNDYxLjV0MjY2LjUgMzA2LjVxLTE2MCAxMDYgLTI2Ni41IDMwNi41dC0xMDYuNSA0NjEuNWgtOTZxLTE0IDAgLTIzIDkgdC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDE0NzJxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ6TTEyODAgMTQwOGgtMTAyNHEwIC02NiA5IC0xMjhoMTAwNnE5IDYxIDkgMTI4ek0xMjgwIC0xMjhxMCAxMzAgLTM0IDI0OS41dC05MC41IDIwOHQtMTI2LjUgMTUydC0xNDYgOTQuNWgtMjMwcS03NiAtMzEgLTE0NiAtOTQuNXQtMTI2LjUgLTE1MnQtOTAuNSAtMjA4dC0zNCAtMjQ5LjVoMTAyNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1MjsiIGQ9Ik0xNDA4IDE0MDhxMCAtMjYxIC0xMDYuNSAtNDYxLjV0LTI2Ni41IC0zMDYuNXExNjAgLTEwNiAyNjYuNSAtMzA2LjV0MTA2LjUgLTQ2MS41aDk2cTE0IDAgMjMgLTl0OSAtMjN2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTE0NzJxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloOTZxMCAyNjEgMTA2LjUgNDYxLjV0MjY2LjUgMzA2LjVxLTE2MCAxMDYgLTI2Ni41IDMwNi41dC0xMDYuNSA0NjEuNWgtOTZxLTE0IDAgLTIzIDkgdC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDE0NzJxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ6TTEyODAgMTQwOGgtMTAyNHEwIC0yMDYgODUgLTM4NGg4NTRxODUgMTc4IDg1IDM4NHpNMTIyMyAxOTJxLTU0IDE0MSAtMTQ1LjUgMjQxLjV0LTE5NC41IDE0Mi41aC0yMzBxLTEwMyAtNDIgLTE5NC41IC0xNDIuNXQtMTQ1LjUgLTI0MS41aDkxMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1MzsiIGQ9Ik0xNDA4IDE0MDhxMCAtMjYxIC0xMDYuNSAtNDYxLjV0LTI2Ni41IC0zMDYuNXExNjAgLTEwNiAyNjYuNSAtMzA2LjV0MTA2LjUgLTQ2MS41aDk2cTE0IDAgMjMgLTl0OSAtMjN2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTE0NzJxLTE0IDAgLTIzIDl0LTkgMjN2NjRxMCAxNCA5IDIzdDIzIDloOTZxMCAyNjEgMTA2LjUgNDYxLjV0MjY2LjUgMzA2LjVxLTE2MCAxMDYgLTI2Ni41IDMwNi41dC0xMDYuNSA0NjEuNWgtOTZxLTE0IDAgLTIzIDkgdC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDE0NzJxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtOTZ6TTg3NCA3MDBxNzcgMjkgMTQ5IDkyLjV0MTI5LjUgMTUyLjV0OTIuNSAyMTB0MzUgMjUzaC0xMDI0cTAgLTEzMiAzNSAtMjUzdDkyLjUgLTIxMHQxMjkuNSAtMTUyLjV0MTQ5IC05Mi41cTE5IC03IDMwLjUgLTIzLjV0MTEuNSAtMzYuNXQtMTEuNSAtMzYuNXQtMzAuNSAtMjMuNXEtMTM3IC01MSAtMjQ0IC0xOTYgaDcwMHEtMTA3IDE0NSAtMjQ0IDE5NnEtMTkgNyAtMzAuNSAyMy41dC0xMS41IDM2LjV0MTEuNSAzNi41dDMwLjUgMjMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1NDsiIGQ9Ik0xNTA0IC02NHExNCAwIDIzIC05dDkgLTIzdi0xMjhxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTQ3MnEtMTQgMCAtMjMgOXQtOSAyM3YxMjhxMCAxNCA5IDIzdDIzIDloMTQ3MnpNMTMwIDBxMyA1NSAxNiAxMDd0MzAgOTV0NDYgODd0NTMuNSA3NnQ2NC41IDY5LjV0NjYgNjB0NzAuNSA1NXQ2Ni41IDQ3LjV0NjUgNDNxLTQzIDI4IC02NSA0M3QtNjYuNSA0Ny41dC03MC41IDU1dC02NiA2MHQtNjQuNSA2OS41dC01My41IDc2dC00NiA4NyB0LTMwIDk1dC0xNiAxMDdoMTI3NnEtMyAtNTUgLTE2IC0xMDd0LTMwIC05NXQtNDYgLTg3dC01My41IC03NnQtNjQuNSAtNjkuNXQtNjYgLTYwdC03MC41IC01NXQtNjYuNSAtNDcuNXQtNjUgLTQzcTQzIC0yOCA2NSAtNDN0NjYuNSAtNDcuNXQ3MC41IC01NXQ2NiAtNjB0NjQuNSAtNjkuNXQ1My41IC03NnQ0NiAtODd0MzAgLTk1dDE2IC0xMDdoLTEyNzZ6TTE1MDQgMTUzNnExNCAwIDIzIC05dDkgLTIzdi0xMjhxMCAtMTQgLTkgLTIzdC0yMyAtOSBoLTE0NzJxLTE0IDAgLTIzIDl0LTkgMjN2MTI4cTAgMTQgOSAyM3QyMyA5aDE0NzJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNTU7IiBkPSJNNzY4IDExNTJxLTUzIDAgLTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV2LTEyOGgtMzJ2OTNxMCA0OCAtMzIgODEuNXQtODAgMzMuNXEtNDYgMCAtNzkgLTMzdC0zMyAtNzl2LTQyOWwtMzIgMzB2MTcycTAgNDggLTMyIDgxLjV0LTgwIDMzLjVxLTQ2IDAgLTc5IC0zM3QtMzMgLTc5di0yMjRxMCAtNDcgMzUgLTgybDMxMCAtMjk2cTM5IC0zOSAzOSAtMTAycTAgLTI2IDE5IC00NXQ0NSAtMTloNjQwcTI2IDAgNDUgMTl0MTkgNDV2MjUgcTAgNDEgMTAgNzdsMTA4IDQzNnExMCAzNiAxMCA3N3YyNDZxMCA0OCAtMzIgODEuNXQtODAgMzMuNXEtNDYgMCAtNzkgLTMzdC0zMyAtNzl2LTMyaC0zMnYxMjVxMCA0MCAtMjUgNzIuNXQtNjQgNDAuNXEtMTQgMiAtMjMgMnEtNDYgMCAtNzkgLTMzdC0zMyAtNzl2LTEyOGgtMzJ2MTIycTAgNTEgLTMyLjUgODkuNXQtODIuNSA0My41cS01IDEgLTEzIDF6TTc2OCAxMjgwcTg0IDAgMTQ5IC01MHE1NyAzNCAxMjMgMzRxNTkgMCAxMTEgLTI3IHQ4NiAtNzZxMjcgNyA1OSA3cTEwMCAwIDE3MCAtNzEuNXQ3MCAtMTcxLjV2LTI0NnEwIC01MSAtMTMgLTEwOGwtMTA5IC00MzZxLTYgLTI0IC02IC03MXEwIC04MCAtNTYgLTEzNnQtMTM2IC01NmgtNjQwcS04NCAwIC0xMzggNTguNXQtNTQgMTQyLjVsLTMwOCAyOTZxLTc2IDczIC03NiAxNzV2MjI0cTAgOTkgNzAuNSAxNjkuNXQxNjkuNSA3MC41cTExIDAgMTYgLTFxNiA5NSA3NS41IDE2MHQxNjQuNSA2NXE1MiAwIDk4IC0yMSBxNzIgNjkgMTc0IDY5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjU2OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04ODAgMTQwOHEtNDYgMCAtNzkgLTMzdC0zMyAtNzl2LTY1NmgtMzJ2NTI4cTAgNDYgLTMzIDc5dC03OSAzM3QtNzkgLTMzdC0zMyAtNzl2LTUyOHYtMjU2bC0xNTQgMjA1cS0zOCA1MSAtMTAyIDUxcS01MyAwIC05MC41IC0zNy41dC0zNy41IC05MC41cTAgLTQzIDI2IC03N2wzODQgLTUxMnEzOCAtNTEgMTAyIC01MWg2ODhxMzQgMCA2MSAyMnQzNCA1Nmw3NiA0MDVxNSAzMiA1IDU5djQ5OHEwIDQ2IC0zMyA3OXQtNzkgMzN0LTc5IC0zMyB0LTMzIC03OXYtMjcyaC0zMnY1MjhxMCA0NiAtMzMgNzl0LTc5IDMzdC03OSAtMzN0LTMzIC03OXYtNTI4aC0zMnY2NTZxMCA0NiAtMzMgNzl0LTc5IDMzek04ODAgMTUzNnE2OCAwIDEyNS41IC0zNS41dDg4LjUgLTk2LjVxMTkgNCA0MiA0cTk5IDAgMTY5LjUgLTcwLjV0NzAuNSAtMTY5LjV2LTE3cTEwNSA2IDE4MC41IC02NHQ3NS41IC0xNzV2LTQ5OHEwIC00MCAtOCAtODNsLTc2IC00MDRxLTE0IC03OSAtNzYuNSAtMTMxdC0xNDMuNSAtNTIgaC02ODhxLTYwIDAgLTExNC41IDI3LjV0LTkwLjUgNzQuNWwtMzg0IDUxMnEtNTEgNjggLTUxIDE1NHEwIDEwNiA3NSAxODF0MTgxIDc1cTc4IDAgMTI4IC0zNHY0MzRxMCA5OSA3MC41IDE2OS41dDE2OS41IDcwLjVxMjMgMCA0MiAtNHEzMSA2MSA4OC41IDk2LjV0MTI1LjUgMzUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1NzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTA3MyAtMTI4aC0xNzdxLTE2MyAwIC0yMjYgMTQxcS0yMyA0OSAtMjMgMTAydjVxLTYyIDMwIC05OC41IDg4LjV0LTM2LjUgMTI3LjVxMCAzOCA1IDQ4aC0yNjFxLTEwNiAwIC0xODEgNzV0LTc1IDE4MXQ3NSAxODF0MTgxIDc1aDExM2wtNDQgMTdxLTc0IDI4IC0xMTkuNSA5My41dC00NS41IDE0NS41cTAgMTA2IDc1IDE4MXQxODEgNzVxNDYgMCA5MSAtMTdsNjI4IC0yMzloNDAxcTEwNiAwIDE4MSAtNzV0NzUgLTE4MXYtNjY4IHEwIC04OCAtNTQgLTE1Ny41dC0xNDAgLTkwLjVsLTMzOSAtODVxLTkyIC0yMyAtMTg2IC0yM3pNMTAyNCA1ODNsLTE1NSAtNzFsLTE2MyAtNzRxLTMwIC0xNCAtNDggLTQxLjV0LTE4IC02MC41cTAgLTQ2IDMzIC03OXQ3OSAtMzNxMjYgMCA0NiAxMGwzMzggMTU0cS00OSAxMCAtODAuNSA1MHQtMzEuNSA5MHY1NXpNMTM0NCAyNzJxMCA0NiAtMzMgNzl0LTc5IDMzcS0yNiAwIC00NiAtMTBsLTI5MCAtMTMycS0yOCAtMTMgLTM3IC0xNyB0LTMwLjUgLTE3dC0yOS41IC0yMy41dC0xNiAtMjl0LTggLTQwLjVxMCAtNTAgMzEuNSAtODJ0ODEuNSAtMzJxMjAgMCAzOCA5bDM1MiAxNjBxMzAgMTQgNDggNDEuNXQxOCA2MC41ek0xMTEyIDEwMjRsLTY1MCAyNDhxLTI0IDggLTQ2IDhxLTUzIDAgLTkwLjUgLTM3LjV0LTM3LjUgLTkwLjVxMCAtNDAgMjIuNSAtNzN0NTkuNSAtNDdsNTI2IC0yMDB2LTY0aC02NDBxLTUzIDAgLTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNSB0OTAuNSAtMzcuNWg1MzVsMjMzIDEwNnYxOThxMCA2MyA0NiAxMDZsMTExIDEwMmgtNjl6TTEwNzMgMHE4MiAwIDE1NSAxOWwzMzkgODVxNDMgMTEgNzAgNDUuNXQyNyA3OC41djY2OHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNWgtMzA4bC0xMzYgLTEyNnEtMzYgLTMzIC0zNiAtODJ2LTI5NnEwIC00NiAzMyAtNzd0NzkgLTMxdDc5IDM1dDMzIDgxdjIwOGgzMnYtMjA4cTAgLTcwIC01NyAtMTE0cTUyIC04IDg2LjUgLTQ4LjV0MzQuNSAtOTMuNSBxMCAtNDIgLTIzIC03OHQtNjEgLTUzbC0zMTAgLTE0MWg5MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1ODsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNMTE1MSAxNTM2cTYxIDAgMTE2IC0yOHQ5MSAtNzdsNTcyIC03ODFxMTE4IC0xNTkgMTE4IC0zNTl2LTM1NXEwIC04MCAtNTYgLTEzNnQtMTM2IC01NmgtMzg0cS04MCAwIC0xMzYgNTZ0LTU2IDEzNnYxNzdsLTI4NiAxNDNoLTU0NnEtODAgMCAtMTM2IDU2dC01NiAxMzZ2MzJxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDQyMGw0MiAxMjhoLTY4NnEtMTAwIDAgLTE3My41IDY3LjV0LTgxLjUgMTY2LjVxLTY1IDc5IC02NSAxODJ2MzIgcTAgODAgNTYgMTM2dDEzNiA1Nmg5NTl6TTE5MjAgLTY0djM1NXEwIDE1NyAtOTMgMjg0bC01NzMgNzgxcS0zOSA1MiAtMTAzIDUyaC05NTlxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1cTAgLTMyIDEuNSAtNDkuNXQ5LjUgLTQwLjV0MjUgLTQzcTEwIDMxIDM1LjUgNTB0NTYuNSAxOWg4MzJ2LTMyaC04MzJxLTI2IDAgLTQ1IC0xOXQtMTkgLTQ1cTAgLTQ0IDMgLTU4cTggLTQ0IDQ0IC03M3Q4MSAtMjloNjQwaDkxcTQwIDAgNjggLTI4dDI4IC02OCBxMCAtMTUgLTUgLTMwbC02NCAtMTkycS0xMCAtMjkgLTM1IC00Ny41dC01NiAtMTguNWgtNDQzcS02NiAwIC0xMTMgLTQ3dC00NyAtMTEzdi0zMnEwIC0yNiAxOSAtNDV0NDUgLTE5aDU2MXExNiAwIDI5IC03bDMxNyAtMTU4cTI0IC0xMyAzOC41IC0zNnQxNC41IC01MHYtMTk3cTAgLTI2IDE5IC00NXQ0NSAtMTloMzg0cTI2IDAgNDUgMTl0MTkgNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNTk7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTgxNiAxNDA4cS00OCAwIC03OS41IC0zNHQtMzEuNSAtODJxMCAtMTQgMyAtMjhsMTUwIC02MjRoLTI2bC0xMTYgNDgycS05IDM4IC0zOS41IDYydC02OS41IDI0cS00NyAwIC03OSAtMzR0LTMyIC04MXEwIC0xMSA0IC0yOXEzIC0xMyAzOSAtMTYxdDY4IC0yODJ0MzIgLTEzOHYtMjI3bC0zMDcgMjMwcS0zNCAyNiAtNzcgMjZxLTUyIDAgLTg5LjUgLTM2LjV0LTM3LjUgLTg4LjVxMCAtNjcgNTYgLTExMGw1MDcgLTM3OSBxMzQgLTI2IDc2IC0yNmg2OTRxMzMgMCA1OSAyMC41dDM0IDUyLjVsMTAwIDQwMXE4IDMwIDEwIDg4dDkgODZsMTE2IDQ3OHEzIDEyIDMgMjZxMCA0NiAtMzMgNzl0LTgwIDMzcS0zOCAwIC02OSAtMjUuNXQtNDAgLTYyLjVsLTk5IC00MDhoLTI2bDEzMiA1NDdxMyAxNCAzIDI4cTAgNDcgLTMyIDgwdC04MCAzM3EtMzggMCAtNjguNSAtMjR0LTM5LjUgLTYybC0xNDUgLTYwMmgtMTI3bC0xNjQgNjgycS05IDM4IC0zOS41IDYydC02OC41IDI0eiBNMTQ2MSAtMjU2aC02OTRxLTg1IDAgLTE1MyA1MWwtNTA3IDM4MHEtNTAgMzggLTc4LjUgOTR0LTI4LjUgMTE4cTAgMTA1IDc1IDE3OXQxODAgNzRxMjUgMCA0OS41IC01LjV0NDEuNSAtMTF0NDEgLTIwLjV0MzUgLTIzdDM4LjUgLTI5LjV0MzcuNSAtMjguNWwtMTIzIDUxMnEtNyAzNSAtNyA1OXEwIDkzIDYwIDE2MnQxNTIgNzlxMTQgODcgODAuNSAxNDQuNXQxNTUuNSA1Ny41cTgzIDAgMTQ4IC01MS41dDg1IC0xMzIuNWwxMDMgLTQyOCBsODMgMzQ4cTIwIDgxIDg1IDEzMi41dDE0OCA1MS41cTg3IDAgMTUyLjUgLTU0dDgyLjUgLTEzOXE5MyAtMTAgMTU1IC03OHQ2MiAtMTYxcTAgLTMwIC03IC01N2wtMTE2IC00NzdxLTUgLTIyIC01IC02N3EwIC01MSAtMTMgLTEwOGwtMTAxIC00MDFxLTE5IC03NSAtNzkuNSAtMTIyLjV0LTEzNy41IC00Ny41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjVhOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik02NDAgMTQwOHEtNTMgMCAtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXYtNTEydi0zODRsLTE1MSAyMDJxLTQxIDU0IC0xMDcgNTRxLTUyIDAgLTg5IC0zOHQtMzcgLTkwcTAgLTQzIDI2IC03N2wzODQgLTUxMnEzOCAtNTEgMTAyIC01MWg3MThxMjIgMCAzOS41IDEzLjV0MjIuNSAzNC41bDkyIDM2OHEyNCA5NiAyNCAxOTR2MjE3cTAgNDEgLTI4IDcxdC02OCAzMHQtNjggLTI4dC0yOCAtNjhoLTMydjYxcTAgNDggLTMyIDgxLjV0LTgwIDMzLjUgcS00NiAwIC03OSAtMzN0LTMzIC03OXYtNjRoLTMydjkwcTAgNTUgLTM3IDk0LjV0LTkxIDM5LjVxLTUzIDAgLTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV2LTk2aC0zMnY1NzBxMCA1NSAtMzcgOTQuNXQtOTEgMzkuNXpNNjQwIDE1MzZxMTA3IDAgMTgxLjUgLTc3LjV0NzQuNSAtMTg0LjV2LTIyMHEyMiAyIDMyIDJxOTkgMCAxNzMgLTY5cTQ3IDIxIDk5IDIxcTExMyAwIDE4NCAtODdxMjcgNyA1NiA3cTk0IDAgMTU5IC02Ny41dDY1IC0xNjEuNSB2LTIxN3EwIC0xMTYgLTI4IC0yMjVsLTkyIC0zNjhxLTE2IC02NCAtNjggLTEwNC41dC0xMTggLTQwLjVoLTcxOHEtNjAgMCAtMTE0LjUgMjcuNXQtOTAuNSA3NC41bC0zODQgNTEycS01MSA2OCAtNTEgMTU0cTAgMTA1IDc0LjUgMTgwLjV0MTc5LjUgNzUuNXE3MSAwIDEzMCAtMzV2NTQ3cTAgMTA2IDc1IDE4MXQxODEgNzV6TTc2OCAxMjh2Mzg0aC0zMnYtMzg0aDMyek0xMDI0IDEyOHYzODRoLTMydi0zODRoMzJ6TTEyODAgMTI4djM4NGgtMzIgdi0zODRoMzJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNWI7IiBkPSJNMTI4OCA4ODlxNjAgMCAxMDcgLTIzcTE0MSAtNjMgMTQxIC0yMjZ2LTE3N3EwIC05NCAtMjMgLTE4NmwtODUgLTMzOXEtMjEgLTg2IC05MC41IC0xNDB0LTE1Ny41IC01NGgtNjY4cS0xMDYgMCAtMTgxIDc1dC03NSAxODF2NDAxbC0yMzkgNjI4cS0xNyA0NSAtMTcgOTFxMCAxMDYgNzUgMTgxdDE4MSA3NXE4MCAwIDE0NS41IC00NS41dDkzLjUgLTExOS41bDE3IC00NHYxMTNxMCAxMDYgNzUgMTgxdDE4MSA3NXQxODEgLTc1dDc1IC0xODEgdi0yNjFxMjcgNSA0OCA1cTY5IDAgMTI3LjUgLTM2LjV0ODguNSAtOTguNXpNMTA3MiA4OTZxLTMzIDAgLTYwLjUgLTE4dC00MS41IC00OGwtNzQgLTE2M2wtNzEgLTE1NWg1NXE1MCAwIDkwIC0zMS41dDUwIC04MC41bDE1NCAzMzhxMTAgMjAgMTAgNDZxMCA0NiAtMzMgNzl0LTc5IDMzek0xMjkzIDc2MXEtMjIgMCAtNDAuNSAtOHQtMjkgLTE2dC0yMy41IC0yOS41dC0xNyAtMzAuNXQtMTcgLTM3bC0xMzIgLTI5MHEtMTAgLTIwIC0xMCAtNDYgcTAgLTQ2IDMzIC03OXQ3OSAtMzNxMzMgMCA2MC41IDE4dDQxLjUgNDhsMTYwIDM1MnE5IDE4IDkgMzhxMCA1MCAtMzIgODEuNXQtODIgMzEuNXpNMTI4IDExMjBxMCAtMjIgOCAtNDZsMjQ4IC02NTB2LTY5bDEwMiAxMTFxNDMgNDYgMTA2IDQ2aDE5OGwxMDYgMjMzdjUzNXEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNXQtOTAuNSAtMzcuNXQtMzcuNSAtOTAuNXYtNjQwaC02NGwtMjAwIDUyNnEtMTQgMzcgLTQ3IDU5LjV0LTczIDIyLjUgcS01MyAwIC05MC41IC0zNy41dC0zNy41IC05MC41ek0xMTgwIC0xMjhxNDQgMCA3OC41IDI3dDQ1LjUgNzBsODUgMzM5cTE5IDczIDE5IDE1NXY5MWwtMTQxIC0zMTBxLTE3IC0zOCAtNTMgLTYxdC03OCAtMjNxLTUzIDAgLTkzLjUgMzQuNXQtNDguNSA4Ni41cS00NCAtNTcgLTExNCAtNTdoLTIwOHYzMmgyMDhxNDYgMCA4MSAzM3QzNSA3OXQtMzEgNzl0LTc3IDMzaC0yOTZxLTQ5IDAgLTgyIC0zNmwtMTI2IC0xMzZ2LTMwOCBxMCAtNTMgMzcuNSAtOTAuNXQ5MC41IC0zNy41aDY2OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1YzsiIGhvcml6LWFkdi14PSIxOTczIiBkPSJNODU3IDk5MnYtMTE3cTAgLTEzIC05LjUgLTIydC0yMi41IC05aC0yOTh2LTgxMnEwIC0xMyAtOSAtMjIuNXQtMjIgLTkuNWgtMTM1cS0xMyAwIC0yMi41IDl0LTkuNSAyM3Y4MTJoLTI5N3EtMTMgMCAtMjIuNSA5dC05LjUgMjJ2MTE3cTAgMTQgOSAyM3QyMyA5aDc5M3ExMyAwIDIyLjUgLTkuNXQ5LjUgLTIyLjV6TTE4OTUgOTk1bDc3IC05NjFxMSAtMTMgLTggLTI0cS0xMCAtMTAgLTIzIC0xMGgtMTM0cS0xMiAwIC0yMSA4LjUgdC0xMCAyMC41bC00NiA1ODhsLTE4OSAtNDI1cS04IC0xOSAtMjkgLTE5aC0xMjBxLTIwIDAgLTI5IDE5bC0xODggNDI3bC00NSAtNTkwcS0xIC0xMiAtMTAgLTIwLjV0LTIxIC04LjVoLTEzNXEtMTMgMCAtMjMgMTBxLTkgMTAgLTkgMjRsNzggOTYxcTEgMTIgMTAgMjAuNXQyMSA4LjVoMTQycTIwIDAgMjkgLTE5bDIyMCAtNTIwcTEwIC0yNCAyMCAtNTFxMyA3IDkuNSAyNC41dDEwLjUgMjYuNWwyMjEgNTIwcTkgMTkgMjkgMTloMTQxIHExMyAwIDIyIC04LjV0MTAgLTIwLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNWQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEwNDIgODMzcTAgODggLTYwIDEyMXEtMzMgMTggLTExNyAxOGgtMTIzdi0yODFoMTYycTY2IDAgMTAyIDM3dDM2IDEwNXpNMTA5NCA1NDhsMjA1IC0zNzNxOCAtMTcgLTEgLTMxcS04IC0xNiAtMjcgLTE2aC0xNTJxLTIwIDAgLTI4IDE3bC0xOTQgMzY1aC0xNTV2LTM1MHEwIC0xNCAtOSAtMjN0LTIzIC05aC0xMzRxLTE0IDAgLTIzIDl0LTkgMjN2OTYwcTAgMTQgOSAyM3QyMyA5aDI5NHExMjggMCAxOTAgLTI0cTg1IC0zMSAxMzQgLTEwOSB0NDkgLTE4MHEwIC05MiAtNDIuNSAtMTY1LjV0LTExNS41IC0xMDkuNXE2IC0xMCA5IC0xNnpNODk2IDEzNzZxLTE1MCAwIC0yODYgLTU4LjV0LTIzNC41IC0xNTd0LTE1NyAtMjM0LjV0LTU4LjUgLTI4NnQ1OC41IC0yODZ0MTU3IC0yMzQuNXQyMzQuNSAtMTU3dDI4NiAtNTguNXQyODYgNTguNXQyMzQuNSAxNTd0MTU3IDIzNC41dDU4LjUgMjg2dC01OC41IDI4NnQtMTU3IDIzNC41dC0yMzQuNSAxNTd0LTI4NiA1OC41ek0xNzkyIDY0MCBxMCAtMTgyIC03MSAtMzQ4dC0xOTEgLTI4NnQtMjg2IC0xOTF0LTM0OCAtNzF0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxdDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI1ZTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNjA1IDMwM3ExNTMgMCAyNTcgMTA0cTE0IDE4IDMgMzZsLTQ1IDgycS02IDEzIC0yNCAxN3EtMTYgMiAtMjcgLTExbC00IC0zcS00IC00IC0xMS41IC0xMHQtMTcuNSAtMTN0LTIzLjUgLTE0LjV0LTI4LjUgLTEzLjV0LTMzLjUgLTkuNXQtMzcuNSAtMy41cS03NiAwIC0xMjUgNTB0LTQ5IDEyN3EwIDc2IDQ4IDEyNS41dDEyMiA0OS41cTM3IDAgNzEuNSAtMTR0NTAuNSAtMjhsMTYgLTE0cTExIC0xMSAyNiAtMTBxMTYgMiAyNCAxNGw1MyA3OCBxMTMgMjAgLTIgMzlxLTMgNCAtMTEgMTJ0LTMwIDIzLjV0LTQ4LjUgMjh0LTY3LjUgMjIuNXQtODYgMTBxLTE0OCAwIC0yNDYgLTk2LjV0LTk4IC0yNDAuNXEwIC0xNDYgOTcgLTI0MS41dDI0NyAtOTUuNXpNMTIzNSAzMDNxMTUzIDAgMjU3IDEwNHExNCAxOCA0IDM2bC00NSA4MnEtOCAxNCAtMjUgMTdxLTE2IDIgLTI3IC0xMWwtNCAtM3EtNCAtNCAtMTEuNSAtMTB0LTE3LjUgLTEzdC0yMy41IC0xNC41dC0yOC41IC0xMy41dC0zMy41IC05LjUgdC0zNy41IC0zLjVxLTc2IDAgLTEyNSA1MHQtNDkgMTI3cTAgNzYgNDggMTI1LjV0MTIyIDQ5LjVxMzcgMCA3MS41IC0xNHQ1MC41IC0yOGwxNiAtMTRxMTEgLTExIDI2IC0xMHExNiAyIDI0IDE0bDUzIDc4cTEzIDIwIC0yIDM5cS0zIDQgLTExIDEydC0zMCAyMy41dC00OC41IDI4dC02Ny41IDIyLjV0LTg2IDEwcS0xNDcgMCAtMjQ1LjUgLTk2LjV0LTk4LjUgLTI0MC41cTAgLTE0NiA5NyAtMjQxLjV0MjQ3IC05NS41ek04OTYgMTM3NiBxLTE1MCAwIC0yODYgLTU4LjV0LTIzNC41IC0xNTd0LTE1NyAtMjM0LjV0LTU4LjUgLTI4NnQ1OC41IC0yODZ0MTU3IC0yMzQuNXQyMzQuNSAtMTU3dDI4NiAtNTguNXQyODYgNTguNXQyMzQuNSAxNTd0MTU3IDIzNC41dDU4LjUgMjg2dC01OC41IDI4NnQtMTU3IDIzNC41dC0yMzQuNSAxNTd0LTI4NiA1OC41ek04OTYgMTUzNnExODIgMCAzNDggLTcxdDI4NiAtMTkxdDE5MSAtMjg2dDcxIC0zNDh0LTcxIC0zNDh0LTE5MSAtMjg2dC0yODYgLTE5MSB0LTM0OCAtNzF0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjYwOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik03MzYgNzM2bDM4NCAtMzg0bC0zODQgLTM4NGwtNjcyIDY3Mmw2NzIgNjcybDE2OCAtMTY4bC05NiAtOTZsLTcyIDcybC00ODAgLTQ4MGw0ODAgLTQ4MGwxOTMgMTkzbC0yODkgMjg3ek0xMzEyIDEzMTJsNjcyIC02NzJsLTY3MiAtNjcybC0xNjggMTY4bDk2IDk2bDcyIC03Mmw0ODAgNDgwbC00ODAgNDgwbC0xOTMgLTE5M2wyODkgLTI4N2wtOTYgLTk2bC0zODQgMzg0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjYxOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik03MTcgMTgybDI3MSAyNzFsLTI3OSAyNzlsLTg4IC04OGwxOTIgLTE5MWwtOTYgLTk2bC0yNzkgMjc5bDI3OSAyNzlsNDAgLTQwbDg3IDg3bC0xMjcgMTI4bC00NTQgLTQ1NHpNMTA3NSAxOTBsNDU0IDQ1NGwtNDU0IDQ1NGwtMjcxIC0yNzFsMjc5IC0yNzlsODggODhsLTE5MiAxOTFsOTYgOTZsMjc5IC0yNzlsLTI3OSAtMjc5bC00MCA0MGwtODcgLTg4ek0xNzkyIDY0MHEwIC0xODIgLTcxIC0zNDh0LTE5MSAtMjg2dC0yODYgLTE5MSB0LTM0OCAtNzF0LTM0OCA3MXQtMjg2IDE5MXQtMTkxIDI4NnQtNzEgMzQ4dDcxIDM0OHQxOTEgMjg2dDI4NiAxOTF0MzQ4IDcxdDM0OCAtNzF0Mjg2IC0xOTF0MTkxIC0yODZ0NzEgLTM0OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI2MjsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNNjUxIDUzOXEwIC0zOSAtMjcuNSAtNjYuNXQtNjUuNSAtMjcuNXEtMzkgMCAtNjYuNSAyNy41dC0yNy41IDY2LjVxMCAzOCAyNy41IDY1LjV0NjYuNSAyNy41cTM4IDAgNjUuNSAtMjcuNXQyNy41IC02NS41ek0xODA1IDU0MHEwIC0zOSAtMjcuNSAtNjYuNXQtNjYuNSAtMjcuNXQtNjYuNSAyNy41dC0yNy41IDY2LjV0MjcuNSA2NnQ2Ni41IDI3dDY2LjUgLTI3dDI3LjUgLTY2ek03NjUgNTM5cTAgNzkgLTU2LjUgMTM2dC0xMzYuNSA1NyB0LTEzNi41IC01Ni41dC01Ni41IC0xMzYuNXQ1Ni41IC0xMzYuNXQxMzYuNSAtNTYuNXQxMzYuNSA1Ni41dDU2LjUgMTM2LjV6TTE5MTggNTQwcTAgODAgLTU2LjUgMTM2LjV0LTEzNi41IDU2LjVxLTc5IDAgLTEzNiAtNTYuNXQtNTcgLTEzNi41dDU2LjUgLTEzNi41dDEzNi41IC01Ni41dDEzNi41IDU2LjV0NTYuNSAxMzYuNXpNODUwIDUzOXEwIC0xMTYgLTgxLjUgLTE5Ny41dC0xOTYuNSAtODEuNXEtMTE2IDAgLTE5Ny41IDgydC04MS41IDE5NyB0ODIgMTk2LjV0MTk3IDgxLjV0MTk2LjUgLTgxLjV0ODEuNSAtMTk2LjV6TTIwMDQgNTQwcTAgLTExNSAtODEuNSAtMTk2LjV0LTE5Ny41IC04MS41cS0xMTUgMCAtMTk2LjUgODEuNXQtODEuNSAxOTYuNXQ4MS41IDE5Ni41dDE5Ni41IDgxLjVxMTE2IDAgMTk3LjUgLTgxLjV0ODEuNSAtMTk2LjV6TTEwNDAgNTM3cTAgMTkxIC0xMzUuNSAzMjYuNXQtMzI2LjUgMTM1LjVxLTEyNSAwIC0yMzEgLTYydC0xNjggLTE2OC41dC02MiAtMjMxLjUgdDYyIC0yMzEuNXQxNjggLTE2OC41dDIzMSAtNjJxMTkxIDAgMzI2LjUgMTM1LjV0MTM1LjUgMzI2LjV6TTE3MDggMTExMHEtMjU0IDExMSAtNTU2IDExMXEtMzE5IDAgLTU3MyAtMTEwcTExNyAwIDIyMyAtNDUuNXQxODIuNSAtMTIyLjV0MTIyIC0xODN0NDUuNSAtMjIzcTAgMTE1IDQzLjUgMjE5LjV0MTE4IDE4MC41dDE3Ny41IDEyM3QyMTcgNTB6TTIxODcgNTM3cTAgMTkxIC0xMzUgMzI2LjV0LTMyNiAxMzUuNXQtMzI2LjUgLTEzNS41IHQtMTM1LjUgLTMyNi41dDEzNS41IC0zMjYuNXQzMjYuNSAtMTM1LjV0MzI2IDEzNS41dDEzNSAzMjYuNXpNMTkyMSAxMTAzaDM4M3EtNDQgLTUxIC03NSAtMTE0LjV0LTQwIC0xMTQuNXExMTAgLTE1MSAxMTAgLTMzN3EwIC0xNTYgLTc3IC0yODh0LTIwOSAtMjA4LjV0LTI4NyAtNzYuNXEtMTMzIDAgLTI0OSA1NnQtMTk2IDE1NXEtNDcgLTU2IC0xMjkgLTE3OXEtMTEgMjIgLTUzLjUgODIuNXQtNzQuNSA5Ny41IHEtODAgLTk5IC0xOTYuNSAtMTU1LjV0LTI0OS41IC01Ni41cS0xNTUgMCAtMjg3IDc2LjV0LTIwOSAyMDguNXQtNzcgMjg4cTAgMTg2IDExMCAzMzdxLTkgNTEgLTQwIDExNC41dC03NSAxMTQuNWgzNjVxMTQ5IDEwMCAzNTUgMTU2LjV0NDMyIDU2LjVxMjI0IDAgNDIxIC01NnQzNDggLTE1N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI2MzsiIGhvcml6LWFkdi14PSIxMjgwIiBkPSJNNjQwIDYyOXEtMTg4IDAgLTMyMSAxMzN0LTEzMyAzMjBxMCAxODggMTMzIDMyMXQzMjEgMTMzdDMyMSAtMTMzdDEzMyAtMzIxcTAgLTE4NyAtMTMzIC0zMjB0LTMyMSAtMTMzek02NDAgMTMwNnEtOTIgMCAtMTU3LjUgLTY1LjV0LTY1LjUgLTE1OC41cTAgLTkyIDY1LjUgLTE1Ny41dDE1Ny41IC02NS41dDE1Ny41IDY1LjV0NjUuNSAxNTcuNXEwIDkzIC02NS41IDE1OC41dC0xNTcuNSA2NS41ek0xMTYzIDU3NHExMyAtMjcgMTUgLTQ5LjUgdC00LjUgLTQwLjV0LTI2LjUgLTM4LjV0LTQyLjUgLTM3dC02MS41IC00MS41cS0xMTUgLTczIC0zMTUgLTk0bDczIC03MmwyNjcgLTI2N3EzMCAtMzEgMzAgLTc0dC0zMCAtNzNsLTEyIC0xM3EtMzEgLTMwIC03NCAtMzB0LTc0IDMwcS02NyA2OCAtMjY3IDI2OGwtMjY3IC0yNjhxLTMxIC0zMCAtNzQgLTMwdC03MyAzMGwtMTIgMTNxLTMxIDMwIC0zMSA3M3QzMSA3NGwyNjcgMjY3bDcyIDcycS0yMDMgMjEgLTMxNyA5NCBxLTM5IDI1IC02MS41IDQxLjV0LTQyLjUgMzd0LTI2LjUgMzguNXQtNC41IDQwLjV0MTUgNDkuNXExMCAyMCAyOCAzNXQ0MiAyMnQ1NiAtMnQ2NSAtMzVxNSAtNCAxNSAtMTF0NDMgLTI0LjV0NjkgLTMwLjV0OTIgLTI0dDExMyAtMTFxOTEgMCAxNzQgMjUuNXQxMjAgNTAuNWwzOCAyNXEzMyAyNiA2NSAzNXQ1NiAydDQyIC0yMnQyOCAtMzV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNjQ7IiBkPSJNOTI3IDk1NnEwIC02NiAtNDYuNSAtMTEyLjV0LTExMi41IC00Ni41dC0xMTIuNSA0Ni41dC00Ni41IDExMi41dDQ2LjUgMTEyLjV0MTEyLjUgNDYuNXQxMTIuNSAtNDYuNXQ0Ni41IC0xMTIuNXpNMTE0MSA1OTNxLTEwIDIwIC0yOCAzMnQtNDcuNSA5LjV0LTYwLjUgLTI3LjVxLTEwIC04IC0yOSAtMjB0LTgxIC0zMnQtMTI3IC0yMHQtMTI0IDE4dC04NiAzNmwtMjcgMThxLTMxIDI1IC02MC41IDI3LjV0LTQ3LjUgLTkuNXQtMjggLTMyIHEtMjIgLTQ1IC0yIC03NC41dDg3IC03My41cTgzIC01MyAyMjYgLTY3bC01MSAtNTJxLTE0MiAtMTQyIC0xOTEgLTE5MHEtMjIgLTIyIC0yMiAtNTIuNXQyMiAtNTIuNWw5IC05cTIyIC0yMiA1Mi41IC0yMnQ1Mi41IDIybDE5MSAxOTFxMTE0IC0xMTUgMTkxIC0xOTFxMjIgLTIyIDUyLjUgLTIydDUyLjUgMjJsOSA5cTIyIDIyIDIyIDUyLjV0LTIyIDUyLjVsLTE5MSAxOTBsLTUyIDUycTE0MSAxNCAyMjUgNjdxNjcgNDQgODcgNzMuNXQtMiA3NC41IHpNMTA5MiA5NTZxMCAxMzQgLTk1IDIyOXQtMjI5IDk1dC0yMjkgLTk1dC05NSAtMjI5dDk1IC0yMjl0MjI5IC05NXQyMjkgOTV0OTUgMjI5ek0xNTM2IDExMjB2LTk2MHEwIC0xMTkgLTg0LjUgLTIwMy41dC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI2NTsiIGhvcml6LWFkdi14PSIxNzIwIiBkPSJNMTU2NSAxNDA4cTY1IDAgMTEwIC00NS41dDQ1IC0xMTAuNXYtNTE5cTAgLTE3NiAtNjggLTMzNnQtMTgyLjUgLTI3NXQtMjc0IC0xODIuNXQtMzM0LjUgLTY3LjVxLTE3NiAwIC0zMzUuNSA2Ny41dC0yNzQuNSAxODIuNXQtMTgzIDI3NXQtNjggMzM2djUxOXEwIDY0IDQ2IDExMHQxMTAgNDZoMTQwOXpNODYxIDM0NHE0NyAwIDgyIDMzbDQwNCAzODhxMzcgMzUgMzcgODVxMCA0OSAtMzQuNSA4My41dC04My41IDM0LjVxLTQ3IDAgLTgyIC0zMyBsLTMyMyAtMzEwbC0zMjMgMzEwcS0zNSAzMyAtODEgMzNxLTQ5IDAgLTgzLjUgLTM0LjV0LTM0LjUgLTgzLjVxMCAtNTEgMzYgLTg1bDQwNSAtMzg4cTMzIC0zMyA4MSAtMzN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNjY7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTE0OTQgLTEwM2wtMjk1IDY5NXEtMjUgLTQ5IC0xNTguNSAtMzA1LjV0LTE5OC41IC0zODkuNXEtMSAtMSAtMjcuNSAtMC41dC0yNi41IDEuNXEtODIgMTkzIC0yNTUuNSA1ODd0LTI1OS41IDU5NnEtMjEgNTAgLTY2LjUgMTA3LjV0LTEwMy41IDEwMC41dC0xMDIgNDNxMCA1IC0wLjUgMjR0LTAuNSAyN2g1ODN2LTUwcS0zOSAtMiAtNzkuNSAtMTZ0LTY2LjUgLTQzdC0xMCAtNjRxMjYgLTU5IDIxNi41IC00OTl0MjM1LjUgLTU0MCBxMzEgNjEgMTQwIDI2Ni41dDEzMSAyNDcuNXEtMTkgMzkgLTEyNiAyODF0LTEzNiAyOTVxLTM4IDY5IC0yMDEgNzF2NTBsNTEzIC0xdi00N3EtNjAgLTIgLTkzLjUgLTI1dC0xMi41IC02OXEzMyAtNzAgODcgLTE4OS41dDg2IC0xODcuNXExMTAgMjE0IDE3MyAzNjNxMjQgNTUgLTEwIDc5LjV0LTEyOSAyNi41cTEgNyAxIDI1djI0cTY0IDAgMTcwLjUgMC41dDE4MCAxdDkyLjUgMC41di00OXEtNjIgLTIgLTExOSAtMzN0LTkwIC04MSBsLTIxMyAtNDQycTEzIC0zMyAxMjcuNSAtMjkwdDEyMS41IC0yNzRsNDQxIDEwMTdxLTE0IDM4IC00OS41IDYyLjV0LTY1IDMxLjV0LTU1LjUgOHY1MGw0NjAgLTRsMSAtMmwtMSAtNDRxLTEzOSAtNCAtMjAxIC0xNDVxLTUyNiAtMTIxNiAtNTU5IC0xMjkxaC00OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI2NzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNOTQ5IDY0M3EwIC0yNiAtMTYuNSAtNDV0LTQxLjUgLTE5cS0yNiAwIC00NSAxNi41dC0xOSA0MS41cTAgMjYgMTcgNDV0NDIgMTl0NDQgLTE2LjV0MTkgLTQxLjV6TTk2NCA1ODVsMzUwIDU4MXEtOSAtOCAtNjcuNSAtNjIuNXQtMTI1LjUgLTExNi41dC0xMzYuNSAtMTI3dC0xMTcgLTExMC41dC01MC41IC01MS41bC0zNDkgLTU4MHE3IDcgNjcgNjJ0MTI2IDExNi41dDEzNiAxMjd0MTE3IDExMXQ1MCA1MC41ek0xNjExIDY0MCBxMCAtMjAxIC0xMDQgLTM3MXEtMyAyIC0xNyAxMXQtMjYuNSAxNi41dC0xNi41IDcuNXEtMTMgMCAtMTMgLTEzcTAgLTEwIDU5IC00NHEtNzQgLTExMiAtMTg0LjUgLTE5MC41dC0yNDEuNSAtMTEwLjVsLTE2IDY3cS0xIDEwIC0xNSAxMHEtNSAwIC04IC01LjV0LTIgLTkuNWwxNiAtNjhxLTcyIC0xNSAtMTQ2IC0xNXEtMTk5IDAgLTM3MiAxMDVxMSAyIDEzIDIwLjV0MjEuNSAzMy41dDkuNSAxOXEwIDEzIC0xMyAxM3EtNiAwIC0xNyAtMTQuNSB0LTIyLjUgLTM0LjV0LTEzLjUgLTIzcS0xMTMgNzUgLTE5MiAxODcuNXQtMTEwIDI0NC41bDY5IDE1cTEwIDMgMTAgMTVxMCA1IC01LjUgOHQtMTAuNSAybC02OCAtMTVxLTE0IDcyIC0xNCAxMzlxMCAyMDYgMTA5IDM3OXEyIC0xIDE4LjUgLTEydDMwIC0xOXQxNy41IC04cTEzIDAgMTMgMTJxMCA2IC0xMi41IDE1LjV0LTMyLjUgMjEuNWwtMjAgMTJxNzcgMTEyIDE4OSAxODl0MjQ0IDEwN2wxNSAtNjdxMiAtMTAgMTUgLTEwcTUgMCA4IDUuNSB0MiAxMC41bC0xNSA2NnE3MSAxMyAxMzQgMTNxMjA0IDAgMzc5IC0xMDlxLTM5IC01NiAtMzkgLTY1cTAgLTEzIDEyIC0xM3ExMSAwIDQ4IDY0cTExMSAtNzUgMTg3LjUgLTE4NnQxMDcuNSAtMjQxbC01NiAtMTJxLTEwIC0yIC0xMCAtMTZxMCAtNSA1LjUgLTh0OS41IC0ybDU3IDEzcTE0IC03MiAxNCAtMTQwek0xNjk2IDY0MHEwIDE2MyAtNjMuNSAzMTF0LTE3MC41IDI1NXQtMjU1IDE3MC41dC0zMTEgNjMuNXQtMzExIC02My41IHQtMjU1IC0xNzAuNXQtMTcwLjUgLTI1NXQtNjMuNSAtMzExdDYzLjUgLTMxMXQxNzAuNSAtMjU1dDI1NSAtMTcwLjV0MzExIC02My41dDMxMSA2My41dDI1NSAxNzAuNXQxNzAuNSAyNTV0NjMuNSAzMTF6TTE3OTIgNjQwcTAgLTE4MiAtNzEgLTM0OHQtMTkxIC0yODZ0LTI4NiAtMTkxdC0zNDggLTcxdC0zNDggNzF0LTI4NiAxOTF0LTE5MSAyODZ0LTcxIDM0OHQ3MSAzNDh0MTkxIDI4NnQyODYgMTkxdDM0OCA3MXQzNDggLTcxdDI4NiAtMTkxIHQxOTEgLTI4NnQ3MSAtMzQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjY4OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04OTMgMTUzNnEyNDAgMiA0NTEgLTEyMHEyMzIgLTEzNCAzNTIgLTM3MmwtNzQyIDM5cS0xNjAgOSAtMjk0IC03NC41dC0xODUgLTIyOS41bC0yNzYgNDI0cTEyOCAxNTkgMzExIDI0NS41dDM4MyA4Ny41ek0xNDYgMTEzMWwzMzcgLTY2M3E3MiAtMTQzIDIxMSAtMjE3dDI5MyAtNDVsLTIzMCAtNDUxcS0yMTIgMzMgLTM4NSAxNTcuNXQtMjcyLjUgMzE2dC05OS41IDQxMS41cTAgMjY3IDE0NiA0OTF6TTE3MzIgOTYyIHE1OCAtMTUwIDU5LjUgLTMxMC41dC00OC41IC0zMDZ0LTE1MyAtMjcydC0yNDYgLTIwOS41cS0yMzAgLTEzMyAtNDk4IC0xMTlsNDA1IDYyM3E4OCAxMzEgODIuNSAyOTAuNXQtMTA2LjUgMjc3LjV6TTg5NiA5NDJxMTI1IDAgMjEzLjUgLTg4LjV0ODguNSAtMjEzLjV0LTg4LjUgLTIxMy41dC0yMTMuNSAtODguNXQtMjEzLjUgODguNXQtODguNSAyMTMuNXQ4OC41IDIxMy41dDIxMy41IDg4LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNjk7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTkwMyAtMjU2cS0yODMgMCAtNTA0LjUgMTUwLjV0LTMyOS41IDM5OC41cS01OCAxMzEgLTY3IDMwMXQyNiAzMzIuNXQxMTEgMzEydDE3OSAyNDIuNWwtMTEgLTI4MXExMSAxNCA2OCAxNS41dDcwIC0xNS41cTQyIDgxIDE2MC41IDEzOHQyMzQuNSA1OXEtNTQgLTQ1IC0xMTkuNSAtMTQ4LjV0LTU4LjUgLTE2My41cTI1IC04IDYyLjUgLTEzLjV0NjMgLTcuNXQ2OCAtNHQ1MC41IC0zcTE1IC01IDkuNSAtNDUuNXQtMzAuNSAtNzUuNSBxLTUgLTcgLTE2LjUgLTE4LjV0LTU2LjUgLTM1LjV0LTEwMSAtMzRsMTUgLTE4OWwtMTM5IDY3cS0xOCAtNDMgLTcuNSAtODEuNXQzNiAtNjYuNXQ2NS41IC00MS41dDgxIC02LjVxNTEgOSA5OCAzNC41dDgzLjUgNDV0NzMuNSAxNy41cTYxIC00IDg5LjUgLTMzdDE5LjUgLTY1cS0xIC0yIC0yLjUgLTUuNXQtOC41IC0xMi41dC0xOCAtMTUuNXQtMzEuNSAtMTAuNXQtNDYuNSAtMXEtNjAgLTk1IC0xNDQuNSAtMTM1LjV0LTIwOS41IC0yOS41IHE3NCAtNjEgMTYyLjUgLTgyLjV0MTY4LjUgLTZ0MTU0LjUgNTJ0MTI4IDg3LjV0ODAuNSAxMDRxNDMgOTEgMzkgMTkyLjV0LTM3LjUgMTg4LjV0LTc4LjUgMTI1cTg3IC0zOCAxMzcgLTc5LjV0NzcgLTExMi41cTE1IDE3MCAtNTcuNSAzNDN0LTIwOS41IDI4NHEyNjUgLTc3IDQxMiAtMjc5LjV0MTUxIC01MTcuNXEyIC0xMjcgLTQwLjUgLTI1NXQtMTIzLjUgLTIzOHQtMTg5IC0xOTZ0LTI0Ny41IC0xMzUuNXQtMjg4LjUgLTQ5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNmE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE0OTMgMTMwOHEtMTY1IDExMCAtMzU5IDExMHEtMTU1IDAgLTI5MyAtNzN0LTI0MCAtMjAwcS03NSAtOTMgLTExOS41IC0yMTh0LTQ4LjUgLTI2NnYtNDJxNCAtMTQxIDQ4LjUgLTI2NnQxMTkuNSAtMjE4cTEwMiAtMTI3IDI0MCAtMjAwdDI5MyAtNzNxMTk0IDAgMzU5IDExMHEtMTIxIC0xMDggLTI3NC41IC0xNjh0LTMyMi41IC02MHEtMjkgMCAtNDMgMXEtMTc1IDggLTMzMyA4MnQtMjcyIDE5M3QtMTgxIDI4MXQtNjcgMzM5IHEwIDE4MiA3MSAzNDh0MTkxIDI4NnQyODYgMTkxdDM0OCA3MWgzcTE2OCAtMSAzMjAuNSAtNjAuNXQyNzMuNSAtMTY3LjV6TTE3OTIgNjQwcTAgLTE5MiAtNzcgLTM2Mi41dC0yMTMgLTI5Ni41cS0xMDQgLTYzIC0yMjIgLTYzcS0xMzcgMCAtMjU1IDg0cTE1NCA1NiAyNTMuNSAyMzN0OTkuNSA0MDVxMCAyMjcgLTk5IDQwNHQtMjUzIDIzNHExMTkgODMgMjU0IDgzcTExOSAwIDIyNiAtNjVxMTM1IC0xMjUgMjEwLjUgLTI5NXQ3NS41IC0zNjF6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjZiOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDU5OXEwIC01NiAtNyAtMTA0aC0xMTUxcTAgLTE0NiAxMDkuNSAtMjQ0LjV0MjU3LjUgLTk4LjVxOTkgMCAxODUuNSA0Ni41dDEzNi41IDEzMC41aDQyM3EtNTYgLTE1OSAtMTcwLjUgLTI4MXQtMjY3LjUgLTE4OC41dC0zMjEgLTY2LjVxLTE4NyAwIC0zNTYgODNxLTIyOCAtMTE2IC0zOTQgLTExNnEtMjM3IDAgLTIzNyAyNjNxMCAxMTUgNDUgMjc1cTE3IDYwIDEwOSAyMjlxMTk5IDM2MCA0NzUgNjA2IHEtMTg0IC03OSAtNDI3IC0zNTRxNjMgMjc0IDI4My41IDQ0OS41dDUwMS41IDE3NS41cTMwIDAgNDUgLTFxMjU1IDExNyA0MzMgMTE3cTY0IDAgMTE2IC0xM3Q5NC41IC00MC41dDY2LjUgLTc2LjV0MjQgLTExNXEwIC0xMTYgLTc1IC0yODZxMTAxIC0xODIgMTAxIC0zOTB6TTE3MjIgMTIzOXEwIDgzIC01MyAxMzJ0LTEzNyA0OXEtMTA4IDAgLTI1NCAtNzBxMTIxIC00NyAyMjIuNSAtMTMxLjV0MTcwLjUgLTE5NS41cTUxIDEzNSA1MSAyMTZ6IE0xMjggMnEwIC04NiA0OC41IC0xMzIuNXQxMzQuNSAtNDYuNXExMTUgMCAyNjYgODNxLTEyMiA3MiAtMjEzLjUgMTgzdC0xMzcuNSAyNDVxLTk4IC0yMDUgLTk4IC0zMzJ6TTYzMiA3MTVoNzI4cS01IDE0MiAtMTEzIDIzN3QtMjUxIDk1cS0xNDQgMCAtMjUxLjUgLTk1dC0xMTIuNSAtMjM3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjZjOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xNzkyIDI4OHY5NjBxMCAxMyAtOS41IDIyLjV0LTIyLjUgOS41aC0xNjAwcS0xMyAwIC0yMi41IC05LjV0LTkuNSAtMjIuNXYtOTYwcTAgLTEzIDkuNSAtMjIuNXQyMi41IC05LjVoMTYwMHExMyAwIDIyLjUgOS41dDkuNSAyMi41ek0xOTIwIDEyNDh2LTk2MHEwIC02NiAtNDcgLTExM3QtMTEzIC00N2gtNzM2di0xMjhoMzUycTE0IDAgMjMgLTl0OSAtMjN2LTY0cTAgLTE0IC05IC0yM3QtMjMgLTloLTgzMnEtMTQgMCAtMjMgOXQtOSAyMyB2NjRxMCAxNCA5IDIzdDIzIDloMzUydjEyOGgtNzM2cS02NiAwIC0xMTMgNDd0LTQ3IDExM3Y5NjBxMCA2NiA0NyAxMTN0MTEzIDQ3aDE2MDBxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNmQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEzOCAxNDA4aDE5N3EtNzAgLTY0IC0xMjYgLTE0OXEtMzYgLTU2IC01OSAtMTE1dC0zMCAtMTI1LjV0LTguNSAtMTIwdDEwLjUgLTEzMnQyMSAtMTI2dDI4IC0xMzYuNXE0IC0xOSA2IC0yOHE1MSAtMjM4IDgxIC0zMjlxNTcgLTE3MSAxNTIgLTI3NWgtMjcycS00OCAwIC04MiAzNHQtMzQgODJ2MTMwNHEwIDQ4IDM0IDgydDgyIDM0ek0xMzQ2IDE0MDhoMzA4cTQ4IDAgODIgLTM0dDM0IC04MnYtMTMwNHEwIC00OCAtMzQgLTgydC04MiAtMzQgaC0xNzhxMjEyIDIxMCAxOTYgNTY1bC00NjkgLTEwMXEtMiAtNDUgLTEyIC04MnQtMzEgLTcydC01OS41IC01OS41dC05My41IC0zNi41cS0xMjMgLTI2IC0xOTkgNDBxLTMyIDI3IC01MyA2MXQtNTEuNSAxMjl0LTY0LjUgMjU4cS0zNSAxNjMgLTQ1LjUgMjYzdC01LjUgMTM5dDIzIDc3cTIwIDQxIDYyLjUgNzN0MTAyLjUgNDVxNDUgMTIgODMuNSA2LjV0NjcgLTE3dDU0IC0zNXQ0MyAtNDh0MzQuNSAtNTYuNWw0NjggMTAwIHEtNjggMTc1IC0xODAgMjg3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjZlOyIgZD0iTTE0MDEgLTExbC02IC02cS0xMTMgLTExNCAtMjU5IC0xNzVxLTE1NCAtNjQgLTMxNyAtNjRxLTE2NSAwIC0zMTcgNjRxLTE0OCA2MyAtMjU5IDE3NXEtMTEzIDExMiAtMTc1IDI1OHEtNDIgMTAzIC01NCAxODlxLTQgMjggNDggMzZxNTEgOCA1NiAtMjBxMSAtMSAxIC00cTE4IC05MCA0NiAtMTU5cTUwIC0xMjQgMTUyIC0yMjZxOTggLTk4IDIyNiAtMTUycTEzMiAtNTYgMjc2IC01NnExNDMgMCAyNzYgNTZxMTI4IDU1IDIyNSAxNTJsNiA2IHExMCAxMCAyNSA2cTEyIC0zIDMzIC0yMnEzNiAtMzcgMTcgLTU4ek05MjkgNjA0bC02NiAtNjZsNjMgLTYzcTIxIC0yMSAtNyAtNDlxLTE3IC0xNyAtMzIgLTE3cS0xMCAwIC0xOSAxMGwtNjIgNjFsLTY2IC02NnEtNSAtNSAtMTUgLTVxLTE1IDAgLTMxIDE2bC0yIDJxLTE4IDE1IC0xOCAyOXEwIDcgOCAxN2w2NiA2NWwtNjYgNjZxLTE2IDE2IDE0IDQ1cTE4IDE4IDMxIDE4cTYgMCAxMyAtNWw2NSAtNjZsNjUgNjVxMTggMTcgNDggLTEzIHEyNyAtMjcgMTEgLTQ0ek0xNDAwIDU0N3EwIC0xMTggLTQ2IC0yMjhxLTQ1IC0xMDUgLTEyNiAtMTg2cS04MCAtODAgLTE4NyAtMTI2dC0yMjggLTQ2dC0yMjggNDZ0LTE4NyAxMjZxLTgyIDgyIC0xMjUgMTg2cS0xNSAzMiAtMTUgNDBoLTFxLTkgMjcgNDMgNDRxNTAgMTYgNjAgLTEycTM3IC05OSA5NyAtMTY3aDF2MzM5djJxMyAxMzYgMTAyIDIzMnExMDUgMTAzIDI1MyAxMDNxMTQ3IDAgMjUxIC0xMDN0MTA0IC0yNDkgcTAgLTE0NyAtMTA0LjUgLTI1MXQtMjUwLjUgLTEwNHEtNTggMCAtMTEyIDE2cS0yOCAxMSAtMTMgNjFxMTYgNTEgNDQgNDNsMTQgLTNxMTQgLTMgMzIuNSAtNnQzMC41IC0zcTEwNCAwIDE3NiA3MS41dDcyIDE3NC41cTAgMTAxIC03MiAxNzFxLTcxIDcxIC0xNzUgNzFxLTEwNyAwIC0xNzggLTgwcS02NCAtNzIgLTY0IC0xNjB2LTQxM3ExMTAgLTY3IDI0MiAtNjdxOTYgMCAxODUgMzYuNXQxNTYgMTAzLjV0MTAzLjUgMTU1dDM2LjUgMTgzIHEwIDE5OCAtMTQxIDMzOXEtMTQwIDE0MCAtMzM5IDE0MHEtMjAwIDAgLTM0MCAtMTQwcS01MyAtNTMgLTc3IC04N2wtMiAtMnEtOCAtMTEgLTEzIC0xNS41dC0yMS41IC05LjV0LTM4LjUgM3EtMjEgNSAtMzYuNSAxNi41dC0xNS41IDI2LjV2NjgwcTAgMTUgMTAuNSAyNi41dDI3LjUgMTEuNWg4NzdxMzAgMCAzMCAtNTV0LTMwIC01NWgtODExdi00ODNoMXE0MCA0MiAxMDIgODR0MTA4IDYxcTEwOSA0NiAyMzEgNDZxMTIxIDAgMjI4IC00NiB0MTg3IC0xMjZxODEgLTgxIDEyNiAtMTg2cTQ2IC0xMTIgNDYgLTIyOXpNMTM2OSAxMTI4cTkgLTggOSAtMTh0LTUuNSAtMTh0LTE2LjUgLTIxcS0yNiAtMjYgLTM5IC0yNnEtOSAwIC0xNiA3cS0xMDYgOTEgLTIwNyAxMzNxLTEyOCA1NiAtMjc2IDU2cS0xMzMgMCAtMjYyIC00OXEtMjcgLTEwIC00NSAzN3EtOSAyNSAtOCAzOHEzIDE2IDE2IDIwcTEzMCA1NyAyOTkgNTdxMTY0IDAgMzE2IC02NHExMzcgLTU4IDIzNSAtMTUyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjcwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNTUxIDYwcTE1IDYgMjYgM3QxMSAtMTcuNXQtMTUgLTMzLjVxLTEzIC0xNiAtNDQgLTQzLjV0LTk1LjUgLTY4dC0xNDEgLTc0dC0xODggLTU4dC0yMjkuNSAtMjQuNXEtMTE5IDAgLTIzOCAzMXQtMjA5IDc2LjV0LTE3Mi41IDEwNHQtMTMyLjUgMTA1dC04NCA4Ny41cS04IDkgLTEwIDE2LjV0MSAxMnQ4IDd0MTEuNSAydDExLjUgLTQuNXExOTIgLTExNyAzMDAgLTE2NnEzODkgLTE3NiA3OTkgLTkwcTE5MCA0MCAzOTEgMTM1eiBNMTc1OCAxNzVxMTEgLTE2IDIuNSAtNjkuNXQtMjguNSAtMTAyLjVxLTM0IC04MyAtODUgLTEyNHEtMTcgLTE0IC0yNiAtOXQwIDI0cTIxIDQ1IDQ0LjUgMTIxLjV0Ni41IDk4LjVxLTUgNyAtMTUuNSAxMS41dC0yNyA2dC0yOS41IDIuNXQtMzUgMHQtMzEuNSAtMnQtMzEgLTN0LTIyLjUgLTJxLTYgLTEgLTEzIC0xLjV0LTExIC0xdC04LjUgLTF0LTcgLTAuNWgtNS41aC00LjV0LTMgMC41dC0yIDEuNWwtMS41IDNxLTYgMTYgNDcgNDB0MTAzIDMwIHE0NiA3IDEwOCAxdDc2IC0yNHpNMTM2NCA2MThxMCAtMzEgMTMuNSAtNjR0MzIgLTU4dDM3LjUgLTQ2dDMzIC0zMmwxMyAtMTFsLTIyNyAtMjI0cS00MCAzNyAtNzkgNzUuNXQtNTggNTguNWwtMTkgMjBxLTExIDExIC0yNSAzM3EtMzggLTU5IC05Ny41IC0xMDIuNXQtMTI3LjUgLTYzLjV0LTE0MCAtMjN0LTEzNy41IDIxdC0xMTcuNSA2NS41dC04MyAxMTN0LTMxIDE2Mi41cTAgODQgMjggMTU0dDcyIDExNi41dDEwNi41IDgzdDEyMi41IDU3IHQxMzAgMzQuNXQxMTkuNSAxOC41dDk5LjUgNi41djEyN3EwIDY1IC0yMSA5N3EtMzQgNTMgLTEyMSA1M3EtNiAwIC0xNi41IC0xdC00MC41IC0xMnQtNTYgLTI5LjV0LTU2IC01OS41dC00OCAtOTZsLTI5NCAyN3EwIDYwIDIyIDExOXQ2NyAxMTN0MTA4IDk1dDE1MS41IDY1LjV0MTkwLjUgMjQuNXExMDAgMCAxODEgLTI1dDEyOS41IC02MS41dDgxIC04M3Q0NSAtODZ0MTIuNSAtNzMuNXYtNTg5ek02OTIgNTk3cTAgLTg2IDcwIC0xMzMgcTY2IC00NCAxMzkgLTIycTg0IDI1IDExNCAxMjNxMTQgNDUgMTQgMTAxdjE2MnEtNTkgLTIgLTExMSAtMTJ0LTEwNi41IC0zMy41dC04NyAtNzF0LTMyLjUgLTExNC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjcxOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNTM2IDEyODBxNTIgMCA5MCAtMzh0MzggLTkwdi0xMjgwcTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMTQwOHEtNTIgMCAtOTAgMzh0LTM4IDkwdjEyODBxMCA1MiAzOCA5MHQ5MCAzOGgxMjh2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi05NmgzODR2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi05NmgxMjh6TTExNTIgMTM3NnYtMjg4cTAgLTE0IDkgLTIzdDIzIC05IGg2NHExNCAwIDIzIDl0OSAyM3YyODhxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3pNMzg0IDEzNzZ2LTI4OHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3YyODhxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3pNMTUzNiAtMTI4djEwMjRoLTE0MDh2LTEwMjRoMTQwOHpNODk2IDQ0OGgyMjRxMTQgMCAyMyAtOXQ5IC0yM3YtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMjI0IHYtMjI0cTAgLTE0IC05IC0yM3QtMjMgLTloLTY0cS0xNCAwIC0yMyA5dC05IDIzdjIyNGgtMjI0cS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDIyNHYyMjRxMCAxNCA5IDIzdDIzIDloNjRxMTQgMCAyMyAtOXQ5IC0yM3YtMjI0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjcyOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMTUyIDQxNnYtNjRxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNTc2cS0xNCAwIC0yMyA5dC05IDIzdjY0cTAgMTQgOSAyM3QyMyA5aDU3NnExNCAwIDIzIC05dDkgLTIzek0xMjggLTEyOGgxNDA4djEwMjRoLTE0MDh2LTEwMjR6TTUxMiAxMDg4djI4OHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0yODhxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTEyODAgMTA4OHYyODhxMCAxNCAtOSAyMyB0LTIzIDloLTY0cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTI4OHEwIC0xNCA5IC0yM3QyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNMTY2NCAxMTUydi0xMjgwcTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMTQwOHEtNTIgMCAtOTAgMzh0LTM4IDkwdjEyODBxMCA1MiAzOCA5MHQ5MCAzOGgxMjh2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi05NmgzODR2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00NyB0NDcgLTExM3YtOTZoMTI4cTUyIDAgOTAgLTM4dDM4IC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI3MzsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTExMSAxNTFsLTQ2IC00NnEtOSAtOSAtMjIgLTl0LTIzIDlsLTE4OCAxODlsLTE4OCAtMTg5cS0xMCAtOSAtMjMgLTl0LTIyIDlsLTQ2IDQ2cS05IDkgLTkgMjJ0OSAyM2wxODkgMTg4bC0xODkgMTg4cS05IDEwIC05IDIzdDkgMjJsNDYgNDZxOSA5IDIyIDl0MjMgLTlsMTg4IC0xODhsMTg4IDE4OHExMCA5IDIzIDl0MjIgLTlsNDYgLTQ2cTkgLTkgOSAtMjJ0LTkgLTIzbC0xODggLTE4OGwxODggLTE4OHE5IC0xMCA5IC0yM3QtOSAtMjJ6IE0xMjggLTEyOGgxNDA4djEwMjRoLTE0MDh2LTEwMjR6TTUxMiAxMDg4djI4OHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0yODhxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTEyODAgMTA4OHYyODhxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtMjg4cTAgLTE0IDkgLTIzdDIzIC05aDY0cTE0IDAgMjMgOXQ5IDIzek0xNjY0IDExNTJ2LTEyODAgcTAgLTUyIC0zOCAtOTB0LTkwIC0zOGgtMTQwOHEtNTIgMCAtOTAgMzh0LTM4IDkwdjEyODBxMCA1MiAzOCA5MHQ5MCAzOGgxMjh2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi05NmgzODR2OTZxMCA2NiA0NyAxMTN0MTEzIDQ3aDY0cTY2IDAgMTEzIC00N3Q0NyAtMTEzdi05NmgxMjhxNTIgMCA5MCAtMzh0MzggLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjc0OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMzAzIDU3MmwtNTEyIC01MTJxLTEwIC05IC0yMyAtOXQtMjMgOWwtMjg4IDI4OHEtOSAxMCAtOSAyM3Q5IDIybDQ2IDQ2cTkgOSAyMiA5dDIzIC05bDIyMCAtMjIwbDQ0NCA0NDRxMTAgOSAyMyA5dDIyIC05bDQ2IC00NnE5IC05IDkgLTIydC05IC0yM3pNMTI4IC0xMjhoMTQwOHYxMDI0aC0xNDA4di0xMDI0ek01MTIgMTA4OHYyODhxMCAxNCAtOSAyM3QtMjMgOWgtNjRxLTE0IDAgLTIzIC05dC05IC0yM3YtMjg4cTAgLTE0IDkgLTIzIHQyMyAtOWg2NHExNCAwIDIzIDl0OSAyM3pNMTI4MCAxMDg4djI4OHEwIDE0IC05IDIzdC0yMyA5aC02NHEtMTQgMCAtMjMgLTl0LTkgLTIzdi0yODhxMCAtMTQgOSAtMjN0MjMgLTloNjRxMTQgMCAyMyA5dDkgMjN6TTE2NjQgMTE1MnYtMTI4MHEwIC01MiAtMzggLTkwdC05MCAtMzhoLTE0MDhxLTUyIDAgLTkwIDM4dC0zOCA5MHYxMjgwcTAgNTIgMzggOTB0OTAgMzhoMTI4djk2cTAgNjYgNDcgMTEzdDExMyA0N2g2NHE2NiAwIDExMyAtNDcgdDQ3IC0xMTN2LTk2aDM4NHY5NnEwIDY2IDQ3IDExM3QxMTMgNDdoNjRxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTk2aDEyOHE1MiAwIDkwIC0zOHQzOCAtOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNzU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTQ0OCAxNTM2cTI2IDAgNDUgLTE5dDE5IC00NXYtODkxbDUzNiA0MjlxMTcgMTQgNDAgMTRxMjYgMCA0NSAtMTl0MTkgLTQ1di0zNzlsNTM2IDQyOXExNyAxNCA0MCAxNHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTExNTJxMCAtMjYgLTE5IC00NXQtNDUgLTE5aC0xNjY0cS0yNiAwIC00NSAxOXQtMTkgNDV2MTY2NHEwIDI2IDE5IDQ1dDQ1IDE5aDM4NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI3NjsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNNTEyIDQ0OHE2NiAwIDEyOCAxNXYtNjU1cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTI4cS0yNiAwIC00NSAxOXQtMTkgNDV2NjU1cTYxIC0xNSAxMjggLTE1ek01MTIgMTUzNnEyMTIgMCAzNjIgLTE1MHQxNTAgLTM2MnQtMTUwIC0zNjJ0LTM2MiAtMTUwdC0zNjIgMTUwdC0xNTAgMzYydDE1MCAzNjJ0MzYyIDE1MHpNNTEyIDEzMTJxMTQgMCAyMyA5dDkgMjN0LTkgMjN0LTIzIDlxLTE0NiAwIC0yNDkgLTEwM3QtMTAzIC0yNDkgcTAgLTE0IDkgLTIzdDIzIC05dDIzIDl0OSAyM3EwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyNzc7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE3NDUgMTIzOXExMCAtMTAgMTAgLTIzdC0xMCAtMjNsLTE0MSAtMTQxcS0yOCAtMjggLTY4IC0yOGgtMTM0NHEtMjYgMCAtNDUgMTl0LTE5IDQ1djI1NnEwIDI2IDE5IDQ1dDQ1IDE5aDU3NnY2NHEwIDI2IDE5IDQ1dDQ1IDE5aDEyOHEyNiAwIDQ1IC0xOXQxOSAtNDV2LTY0aDUxMnE0MCAwIDY4IC0yOHpNNzY4IDMyMGgyNTZ2LTUxMnEwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTEyOHEtMjYgMCAtNDUgMTl0LTE5IDQ1djUxMnpNMTYwMCA3NjggcTI2IDAgNDUgLTE5dDE5IC00NXYtMjU2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOWgtMTM0NHEtNDAgMCAtNjggMjhsLTE0MSAxNDFxLTEwIDEwIC0xMCAyM3QxMCAyM2wxNDEgMTQxcTI4IDI4IDY4IDI4aDUxMnYxOTJoMjU2di0xOTJoNTc2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjc4OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0yMDIwIDE1MjVxMjggLTIwIDI4IC01M3YtMTQwOHEwIC0yMCAtMTEgLTM2dC0yOSAtMjNsLTY0MCAtMjU2cS0yNCAtMTEgLTQ4IDBsLTYxNiAyNDZsLTYxNiAtMjQ2cS0xMCAtNSAtMjQgLTVxLTE5IDAgLTM2IDExcS0yOCAyMCAtMjggNTN2MTQwOHEwIDIwIDExIDM2dDI5IDIzbDY0MCAyNTZxMjQgMTEgNDggMGw2MTYgLTI0Nmw2MTYgMjQ2cTMyIDEzIDYwIC02ek03MzYgMTM5MHYtMTI3MGw1NzYgLTIzMHYxMjcwek0xMjggMTE3MyB2LTEyNzBsNTQ0IDIxN3YxMjcwek0xOTIwIDEwN3YxMjcwbC01NDQgLTIxN3YtMTI3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI3OTsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNNTEyIDE1MzZxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0xNDcycTAgLTIwIC0xNyAtMjhsLTQ4MCAtMjU2cS03IC00IC0xNSAtNHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE0NzJxMCAyMCAxNyAyOGw0ODAgMjU2cTcgNCAxNSA0ek0xNzYwIDE1MzZxMTMgMCAyMi41IC05LjV0OS41IC0yMi41di0xNDcycTAgLTIwIC0xNyAtMjhsLTQ4MCAtMjU2cS03IC00IC0xNSAtNHEtMTMgMCAtMjIuNSA5LjV0LTkuNSAyMi41djE0NzIgcTAgMjAgMTcgMjhsNDgwIDI1NnE3IDQgMTUgNHpNNjQwIDE1MzZxOCAwIDE0IC0zbDUxMiAtMjU2cTE4IC0xMCAxOCAtMjl2LTE0NzJxMCAtMTMgLTkuNSAtMjIuNXQtMjIuNSAtOS41cS04IDAgLTE0IDNsLTUxMiAyNTZxLTE4IDEwIC0xOCAyOXYxNDcycTAgMTMgOS41IDIyLjV0MjIuNSA5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyN2E7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTY0MCA2NDBxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTEwMjQgNjQwcTAgNTMgLTM3LjUgOTAuNXQtOTAuNSAzNy41dC05MC41IC0zNy41dC0zNy41IC05MC41dDM3LjUgLTkwLjV0OTAuNSAtMzcuNXQ5MC41IDM3LjV0MzcuNSA5MC41ek0xNDA4IDY0MHEwIDUzIC0zNy41IDkwLjV0LTkwLjUgMzcuNSB0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6TTE3OTIgNjQwcTAgLTE3NCAtMTIwIC0zMjEuNXQtMzI2IC0yMzN0LTQ1MCAtODUuNXEtMTEwIDAgLTIxMSAxOHEtMTczIC0xNzMgLTQzNSAtMjI5cS01MiAtMTAgLTg2IC0xM3EtMTIgLTEgLTIyIDZ0LTEzIDE4cS00IDE1IDIwIDM3cTUgNSAyMy41IDIxLjV0MjUuNSAyMy41dDIzLjUgMjUuNXQyNCAzMS41dDIwLjUgMzcgdDIwIDQ4dDE0LjUgNTcuNXQxMi41IDcyLjVxLTE0NiA5MCAtMjI5LjUgMjE2LjV0LTgzLjUgMjY5LjVxMCAxNzQgMTIwIDMyMS41dDMyNiAyMzN0NDUwIDg1LjV0NDUwIC04NS41dDMyNiAtMjMzdDEyMCAtMzIxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyN2I7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTY0MCA2NDBxMCAtNTMgLTM3LjUgLTkwLjV0LTkwLjUgLTM3LjV0LTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjV0OTAuNSAtMzcuNXQzNy41IC05MC41ek0xMDI0IDY0MHEwIC01MyAtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNXQtOTAuNSAzNy41dC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTE0MDggNjQwcTAgLTUzIC0zNy41IC05MC41dC05MC41IC0zNy41IHQtOTAuNSAzNy41dC0zNy41IDkwLjV0MzcuNSA5MC41dDkwLjUgMzcuNXQ5MC41IC0zNy41dDM3LjUgLTkwLjV6TTg5NiAxMTUycS0yMDQgMCAtMzgxLjUgLTY5LjV0LTI4MiAtMTg3LjV0LTEwNC41IC0yNTVxMCAtMTEyIDcxLjUgLTIxMy41dDIwMS41IC0xNzUuNWw4NyAtNTBsLTI3IC05NnEtMjQgLTkxIC03MCAtMTcycTE1MiA2MyAyNzUgMTcxbDQzIDM4bDU3IC02cTY5IC04IDEzMCAtOHEyMDQgMCAzODEuNSA2OS41dDI4MiAxODcuNSB0MTA0LjUgMjU1dC0xMDQuNSAyNTV0LTI4MiAxODcuNXQtMzgxLjUgNjkuNXpNMTc5MiA2NDBxMCAtMTc0IC0xMjAgLTMyMS41dC0zMjYgLTIzM3QtNDUwIC04NS41cS03MCAwIC0xNDUgOHEtMTk4IC0xNzUgLTQ2MCAtMjQycS00OSAtMTQgLTExNCAtMjJoLTVxLTE1IDAgLTI3IDEwLjV0LTE2IDI3LjV2MXEtMyA0IC0wLjUgMTJ0MiAxMHQ0LjUgOS41bDYgOXQ3IDguNXQ4IDlxNyA4IDMxIDM0LjV0MzQuNSAzOHQzMSAzOS41dDMyLjUgNTEgdDI3IDU5dDI2IDc2cS0xNTcgODkgLTI0Ny41IDIyMHQtOTAuNSAyODFxMCAxMzAgNzEgMjQ4LjV0MTkxIDIwNC41dDI4NiAxMzYuNXQzNDggNTAuNXQzNDggLTUwLjV0Mjg2IC0xMzYuNXQxOTEgLTIwNC41dDcxIC0yNDguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI3YzsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNNTEyIDM0NWw1MTIgMjk1di01OTFsLTUxMiAtMjk2djU5MnpNMCA2NDB2LTU5MWw1MTIgMjk2ek01MTIgMTUyN3YtNTkxbC01MTIgLTI5NnY1OTF6TTUxMiA5MzZsNTEyIDI5NXYtNTkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjdkOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzA5IDEwMThxLTEwIC0yMzYgLTMzMiAtNjUxcS0zMzMgLTQzMSAtNTYyIC00MzFxLTE0MiAwIC0yNDAgMjYzcS00NCAxNjAgLTEzMiA0ODJxLTcyIDI2MiAtMTU3IDI2MnEtMTggMCAtMTI3IC03NmwtNzcgOThxMjQgMjEgMTA4IDk2LjV0MTMwIDExNS41cTE1NiAxMzggMjQxIDE0NnE5NSA5IDE1MyAtNTUuNXQ4MSAtMjAzLjVxNDQgLTI4NyA2NiAtMzczcTU1IC0yNDkgMTIwIC0yNDlxNTEgMCAxNTQgMTYxcTEwMSAxNjEgMTA5IDI0NiBxMTMgMTM5IC0xMDkgMTM5cS01NyAwIC0xMjEgLTI2cTEyMCAzOTMgNDU5IDM4MnEyNTEgLTggMjM2IC0zMjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyN2U7IiBkPSJNMCAxNDA4aDE1MzZ2LTE1MzZoLTE1MzZ2MTUzNnpNMTA4NSAyOTNsLTIyMSA2MzFsMjIxIDI5N2gtNjM0bDIyMSAtMjk3bC0yMjEgLTYzMWwzMTcgLTMwNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI4MDsiIGQ9Ik0wIDE0MDhoMTUzNnYtMTUzNmgtMTUzNnYxNTM2ek05MDggMTA4OGwtMTIgLTMzbDc1IC04M2wtMzEgLTExNGwyNSAtMjVsMTA3IDU3bDEwNyAtNTdsMjUgMjVsLTMxIDExNGw3NSA4M2wtMTIgMzNoLTk1bC01MyA5NmgtMzJsLTUzIC05NmgtOTV6TTY0MSA5MjVxMzIgMCA0NC41IC0xNnQxMS41IC02M2wxNzQgMjFxMCA1NSAtMTcuNSA5Mi41dC01MC41IDU2dC02OSAyNS41dC04NSA3cS0xMzMgMCAtMTk5IC01Ny41dC02NiAtMTgyLjV2LTcyIGgtOTZ2LTEyOGg3NnEyMCAwIDIwIC04di0zODJxMCAtMTQgLTUgLTIwdC0xOCAtN2wtNzMgLTd2LTg4aDQ0OHY4NmwtMTQ5IDE0cS02IDEgLTguNSAxLjV0LTMuNSAyLjV0LTAuNSA0dDEgN3QwLjUgMTB2Mzg3aDE5MWwzOCAxMjhoLTIzMXEtNiAwIC0yIDZ0NCA5djgwcTAgMjcgMS41IDQwLjV0Ny41IDI4dDE5LjUgMjB0MzYuNSA1LjV6TTEyNDggOTZ2ODZsLTU0IDlxLTcgMSAtOS41IDIuNXQtMi41IDN0MSA3LjV0MSAxMnY1MjBoLTI3NSBsLTIzIC0xMDFsODMgLTIycTIzIC03IDIzIC0yN3YtMzcwcTAgLTE0IC02IC0xOC41dC0yMCAtNi41bC03MCAtOXYtODZoMzUyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjgxOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzkyIDY5MHEwIC01OCAtMjkuNSAtMTA1LjV0LTc5LjUgLTcyLjVxMTIgLTQ2IDEyIC05NnEwIC0xNTUgLTEwNi41IC0yODd0LTI5MC41IC0yMDguNXQtNDAwIC03Ni41dC0zOTkuNSA3Ni41dC0yOTAgMjA4LjV0LTEwNi41IDI4N3EwIDQ3IDExIDk0cS01MSAyNSAtODIgNzMuNXQtMzEgMTA2LjVxMCA4MiA1OCAxNDAuNXQxNDEgNTguNXE4NSAwIDE0NSAtNjNxMjE4IDE1MiA1MTUgMTYybDExNiA1MjFxMyAxMyAxNSAyMXQyNiA1IGwzNjkgLTgxcTE4IDM3IDU0IDU5LjV0NzkgMjIuNXE2MiAwIDEwNiAtNDMuNXQ0NCAtMTA1LjV0LTQ0IC0xMDZ0LTEwNiAtNDR0LTEwNS41IDQzLjV0LTQzLjUgMTA1LjVsLTMzNCA3NGwtMTA0IC00NzJxMzAwIC05IDUxOSAtMTYwcTU4IDYxIDE0MyA2MXE4MyAwIDE0MSAtNTguNXQ1OCAtMTQwLjV6TTQxOCA0OTFxMCAtNjIgNDMuNSAtMTA2dDEwNS41IC00NHQxMDYgNDR0NDQgMTA2dC00NCAxMDUuNXQtMTA2IDQzLjVxLTYxIDAgLTEwNSAtNDQgdC00NCAtMTA1ek0xMjI4IDEzNnExMSAxMSAxMSAyNnQtMTEgMjZxLTEwIDEwIC0yNSAxMHQtMjYgLTEwcS00MSAtNDIgLTEyMSAtNjJ0LTE2MCAtMjB0LTE2MCAyMHQtMTIxIDYycS0xMSAxMCAtMjYgMTB0LTI1IC0xMHEtMTEgLTEwIC0xMSAtMjUuNXQxMSAtMjYuNXE0MyAtNDMgMTE4LjUgLTY4dDEyMi41IC0yOS41dDkxIC00LjV0OTEgNC41dDEyMi41IDI5LjV0MTE4LjUgNjh6TTEyMjUgMzQxcTYyIDAgMTA1LjUgNDR0NDMuNSAxMDYgcTAgNjEgLTQ0IDEwNXQtMTA1IDQ0cS02MiAwIC0xMDYgLTQzLjV0LTQ0IC0xMDUuNXQ0NCAtMTA2dDEwNiAtNDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyODI7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTY5IDc0MWgxcTE2IDEyNiA1OC41IDI0MS41dDExNSAyMTd0MTY3LjUgMTc2dDIyMy41IDExNy41dDI3Ni41IDQzcTIzMSAwIDQxNCAtMTA1LjV0Mjk0IC0zMDMuNXExMDQgLTE4NyAxMDQgLTQ0MnYtMTg4aC0xMTI1cTEgLTExMSA1My41IC0xOTIuNXQxMzYuNSAtMTIyLjV0MTg5LjUgLTU3dDIxMyAtM3QyMDggNDYuNXQxNzMuNSA4NC41di0zNzdxLTkyIC01NSAtMjI5LjUgLTkydC0zMTIuNSAtMzh0LTMxNiA1MyBxLTE4OSA3MyAtMzExLjUgMjQ5dC0xMjQuNSAzNzJxLTMgMjQyIDExMSA0MTJ0MzI1IDI2OHEtNDggLTYwIC03OCAtMTI1LjV0LTQ2IC0xNTkuNWg2MzVxOCA3NyAtOCAxNDB0LTQ3IDEwMS41dC03MC41IDY2LjV0LTgwLjUgNDF0LTc1IDIwLjV0LTU2IDguNWwtMjIgMXEtMTM1IC01IC0yNTkuNSAtNDQuNXQtMjIzLjUgLTEwNC41dC0xNzYgLTE0MC41dC0xMzggLTE2My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjgzOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik0wIDMydjYwOGgyMzA0di02MDhxMCAtNjYgLTQ3IC0xMTN0LTExMyAtNDdoLTE5ODRxLTY2IDAgLTExMyA0N3QtNDcgMTEzek02NDAgMjU2di0xMjhoMzg0djEyOGgtMzg0ek0yNTYgMjU2di0xMjhoMjU2djEyOGgtMjU2ek0yMTQ0IDE0MDhxNjYgMCAxMTMgLTQ3dDQ3IC0xMTN2LTIyNGgtMjMwNHYyMjRxMCA2NiA0NyAxMTN0MTEzIDQ3aDE5ODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyODQ7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE1NDkgODU3cTU1IDAgODUuNSAtMjguNXQzMC41IC04My41dC0zNCAtODJ0LTkxIC0yN2gtMTM2di0xNzdoLTI1djM5OGgxNzB6TTE3MTAgMjY3bC00IC0xMWwtNSAtMTBxLTExMyAtMjMwIC0zMzAuNSAtMzY2dC00NzQuNSAtMTM2cS0xODIgMCAtMzQ4IDcxdC0yODYgMTkxdC0xOTEgMjg2dC03MSAzNDh0NzEgMzQ4dDE5MSAyODZ0Mjg2IDE5MXQzNDggNzFxMjQ0IDAgNDU0LjUgLTEyNHQzMjkuNSAtMzM4bDIgLTRsOCAtMTYgcS0zMCAtMTUgLTEzNi41IC02OC41dC0xNjMuNSAtODQuNXEtNiAtMyAtNDc5IC0yNjhxMzg0IC0xODMgNzk5IC0zNjZ6TTg5NiAtMjM0cTI1MCAwIDQ2Mi41IDEzMi41dDMyMi41IDM1Ny41bC0yODcgMTI5cS03MiAtMTQwIC0yMDYgLTIyMnQtMjkyIC04MnEtMTUxIDAgLTI4MCA3NXQtMjA0IDIwNHQtNzUgMjgwdDc1IDI4MHQyMDQgMjA0dDI4MCA3NXQyODAgLTczLjV0MjA0IC0yMDQuNWwyODAgMTQzcS0xMTYgMjA4IC0zMjEgMzI5IHQtNDQzIDEyMXEtMTE5IDAgLTIzMi41IC0zMS41dC0yMDkgLTg3LjV0LTE3Ni41IC0xMzd0LTEzNyAtMTc2LjV0LTg3LjUgLTIwOXQtMzEuNSAtMjMyLjV0MzEuNSAtMjMyLjV0ODcuNSAtMjA5dDEzNyAtMTc2LjV0MTc2LjUgLTEzN3QyMDkgLTg3LjV0MjMyLjUgLTMxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyODU7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTE0MjcgODI3bC02MTQgMzg2bDkyIDE1MWg4NTV6TTQwNSA1NjJsLTE4NCAxMTZ2ODU4bDExODMgLTc0M3pNMTQyNCA2OTdsMTQ3IC05NXYtODU4bC01MzIgMzM1ek0xMzg3IDcxOGwtNTAwIC04MDJoLTg1NWwzNTYgNTcxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjg2OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik02NDAgNTI4djIyNHEwIDE2IC0xNiAxNmgtOTZxLTE2IDAgLTE2IC0xNnYtMjI0cTAgLTE2IDE2IC0xNmg5NnExNiAwIDE2IDE2ek0xMTUyIDUyOHYyMjRxMCAxNiAtMTYgMTZoLTk2cS0xNiAwIC0xNiAtMTZ2LTIyNHEwIC0xNiAxNiAtMTZoOTZxMTYgMCAxNiAxNnpNMTY2NCA0OTZ2LTc1MmgtNjQwdjMyMHEwIDgwIC01NiAxMzZ0LTEzNiA1NnQtMTM2IC01NnQtNTYgLTEzNnYtMzIwaC02NDB2NzUycTAgMTYgMTYgMTZoOTYgcTE2IDAgMTYgLTE2di0xMTJoMTI4djYyNHEwIDE2IDE2IDE2aDk2cTE2IDAgMTYgLTE2di0xMTJoMTI4djExMnEwIDE2IDE2IDE2aDk2cTE2IDAgMTYgLTE2di0xMTJoMTI4djExMnEwIDYgMi41IDkuNXQ4LjUgNXQ5LjUgMnQxMS41IDB0OSAtMC41djM5MXEtMzIgMTUgLTMyIDUwcTAgMjMgMTYuNSAzOXQzOC41IDE2dDM4LjUgLTE2dDE2LjUgLTM5cTAgLTM1IC0zMiAtNTB2LTE3cTQ1IDEwIDgzIDEwcTIxIDAgNTkuNSAtNy41dDU0LjUgLTcuNSBxMTcgMCA0NyA3LjV0MzcgNy41cTE2IDAgMTYgLTE2di0yMTBxMCAtMTUgLTM1IC0yMS41dC02MiAtNi41cS0xOCAwIC01NC41IDcuNXQtNTUuNSA3LjVxLTQwIDAgLTkwIC0xMnYtMTMzcTEgMCA5IDAuNXQxMS41IDB0OS41IC0ydDguNSAtNXQyLjUgLTkuNXYtMTEyaDEyOHYxMTJxMCAxNiAxNiAxNmg5NnExNiAwIDE2IC0xNnYtMTEyaDEyOHYxMTJxMCAxNiAxNiAxNmg5NnExNiAwIDE2IC0xNnYtNjI0aDEyOHYxMTJxMCAxNiAxNiAxNmg5NiBxMTYgMCAxNiAtMTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyODc7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTIyODggNzMxcTE2IC04IDE2IC0yN3QtMTYgLTI3bC0zMjAgLTE5MnEtOCAtNSAtMTYgLTVxLTkgMCAtMTYgNHEtMTYgMTAgLTE2IDI4djEyOGgtODU4cTM3IC01OCA4MyAtMTY1cTE2IC0zNyAyNC41IC01NXQyNCAtNDl0MjcgLTQ3dDI3IC0zNHQzMS41IC0yNnQzMyAtOGg5NnY5NnEwIDE0IDkgMjN0MjMgOWgzMjBxMTQgMCAyMyAtOXQ5IC0yM3YtMzIwcTAgLTE0IC05IC0yM3QtMjMgLTloLTMyMHEtMTQgMCAtMjMgOXQtOSAyM3Y5NmgtOTYgcS0zMiAwIC02MSAxMHQtNTEgMjMuNXQtNDUgNDAuNXQtMzcgNDZ0LTMzLjUgNTd0LTI4LjUgNTcuNXQtMjggNjAuNXEtMjMgNTMgLTM3IDgxLjV0LTM2IDY1dC00NC41IDUzLjV0LTQ2LjUgMTdoLTM2MHEtMjIgLTg0IC05MSAtMTM4dC0xNTcgLTU0cS0xMDYgMCAtMTgxIDc1dC03NSAxODF0NzUgMTgxdDE4MSA3NXE4OCAwIDE1NyAtNTR0OTEgLTEzOGgxMDRxMjQgMCA0Ni41IDE3dDQ0LjUgNTMuNXQzNiA2NXQzNyA4MS41cTE5IDQxIDI4IDYwLjUgdDI4LjUgNTcuNXQzMy41IDU3dDM3IDQ2dDQ1IDQwLjV0NTEgMjMuNXQ2MSAxMGgxMDdxMjEgNTcgNzAgOTIuNXQxMTEgMzUuNXE4MCAwIDEzNiAtNTZ0NTYgLTEzNnQtNTYgLTEzNnQtMTM2IC01NnEtNjIgMCAtMTExIDM1LjV0LTcwIDkyLjVoLTEwN3EtMTcgMCAtMzMgLTh0LTMxLjUgLTI2dC0yNyAtMzR0LTI3IC00N3QtMjQgLTQ5dC0yNC41IC01NXEtNDYgLTEwNyAtODMgLTE2NWgxMTE0djEyOHEwIDE4IDE2IDI4dDMyIC0xeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjg4OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMTUwIDc3NHEwIC01NiAtMzkuNSAtOTV0LTk1LjUgLTM5aC0yNTN2MjY5aDI1M3E1NiAwIDk1LjUgLTM5LjV0MzkuNSAtOTUuNXpNMTMyOSA3NzRxMCAxMzAgLTkxLjUgMjIydC0yMjIuNSA5MmgtNDMzdi04OTZoMTgwdjI2OWgyNTNxMTMwIDAgMjIyIDkxLjV0OTIgMjIxLjV6TTE3OTIgNjQwcTAgLTE4MiAtNzEgLTM0OHQtMTkxIC0yODZ0LTI4NiAtMTkxdC0zNDggLTcxdC0zNDggNzF0LTI4NiAxOTF0LTE5MSAyODZ0LTcxIDM0OCB0NzEgMzQ4dDE5MSAyODZ0Mjg2IDE5MXQzNDggNzF0MzQ4IC03MXQyODYgLTE5MXQxOTEgLTI4NnQ3MSAtMzQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjg5OyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik0xNjQ1IDQzOHEwIDU5IC0zNCAxMDYuNXQtODcgNjguNXEtNyAtNDUgLTIzIC05MnEtNyAtMjQgLTI3LjUgLTM4dC00NC41IC0xNHEtMTIgMCAtMjQgM3EtMzEgMTAgLTQ1IDM4LjV0LTQgNTguNXEyMyA3MSAyMyAxNDNxMCAxMjMgLTYxIDIyNy41dC0xNjYgMTY1LjV0LTIyOCA2MXEtMTM0IDAgLTI0NyAtNzN0LTE2NyAtMTk0cTEwOCAtMjggMTg4IC0xMDZxMjIgLTIzIDIyIC01NXQtMjIgLTU0dC01NCAtMjJ0LTU1IDIyIHEtNzUgNzUgLTE4MCA3NXEtMTA2IDAgLTE4MSAtNzQuNXQtNzUgLTE4MC41dDc1IC0xODAuNXQxODEgLTc0LjVoMTA0NnE3OSAwIDEzNC41IDU1LjV0NTUuNSAxMzMuNXpNMTc5OCA0MzhxMCAtMTQyIC0xMDAuNSAtMjQydC0yNDIuNSAtMTAwaC0xMDQ2cS0xNjkgMCAtMjg5IDExOS41dC0xMjAgMjg4LjVxMCAxNTMgMTAwIDI2N3QyNDkgMTM2cTYyIDE4NCAyMjEgMjk4dDM1NCAxMTRxMjM1IDAgNDA4LjUgLTE1OC41dDE5Ni41IC0zODkuNSBxMTE2IC0yNSAxOTIuNSAtMTE4LjV0NzYuNSAtMjE0LjV6TTIwNDggNDM4cTAgLTE3NSAtOTcgLTMxOXEtMjMgLTMzIC02NCAtMzNxLTI0IDAgLTQzIDEzcS0yNiAxNyAtMzIgNDguNXQxMiA1Ny41cTcxIDEwNCA3MSAyMzN0LTcxIDIzM3EtMTggMjYgLTEyIDU3dDMyIDQ5dDU3LjUgMTEuNXQ0OS41IC0zMi41cTk3IC0xNDIgOTcgLTMxOHpNMjMwNCA0MzhxMCAtMjQ0IC0xMzQgLTQ0M3EtMjMgLTM0IC02NCAtMzRxLTIzIDAgLTQyIDEzIHEtMjYgMTggLTMyLjUgNDl0MTEuNSA1N3ExMDggMTY0IDEwOCAzNThxMCAxOTUgLTEwOCAzNTdxLTE4IDI2IC0xMS41IDU3LjV0MzIuNSA0OC41cTI2IDE4IDU3IDEydDQ5IC0zM3ExMzQgLTE5OCAxMzQgLTQ0MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI4YTsiIGQ9Ik0xNTAwIC0xM3EwIC04OSAtNjMgLTE1Mi41dC0xNTMgLTYzLjV0LTE1My41IDYzLjV0LTYzLjUgMTUyLjVxMCA5MCA2My41IDE1My41dDE1My41IDYzLjV0MTUzIC02My41dDYzIC0xNTMuNXpNMTI2NyAyNjhxLTExNSAtMTUgLTE5Mi41IC0xMDIuNXQtNzcuNSAtMjA1LjVxMCAtNzQgMzMgLTEzOHEtMTQ2IC03OCAtMzc5IC03OHEtMTA5IDAgLTIwMSAyMXQtMTUzLjUgNTQuNXQtMTEwLjUgNzYuNXQtNzYgODV0LTQ0LjUgODMgdC0yMy41IDY2LjV0LTYgMzkuNXEwIDE5IDQuNSA0Mi41dDE4LjUgNTZ0MzYuNSA1OHQ2NCA0My41dDk0LjUgMTh0OTQgLTE3LjV0NjMgLTQxdDM1LjUgLTUzdDE3LjUgLTQ5dDQgLTMzLjVxMCAtMzQgLTIzIC04MXEyOCAtMjcgODIgLTQydDkzIC0xN2w0MCAtMXExMTUgMCAxOTAgNTF0NzUgMTMzcTAgMjYgLTkgNDguNXQtMzEuNSA0NC41dC00OS41IDQxdC03NCA0NHQtOTMuNSA0Ny41dC0xMTkuNSA1Ni41cS0yOCAxMyAtNDMgMjAgcS0xMTYgNTUgLTE4NyAxMDB0LTEyMi41IDEwMnQtNzIgMTI1LjV0LTIwLjUgMTYyLjVxMCA3OCAyMC41IDE1MHQ2NiAxMzcuNXQxMTIuNSAxMTR0MTY2LjUgNzd0MjIxLjUgMjguNXExMjAgMCAyMjAgLTI2dDE2NC41IC02N3QxMDkuNSAtOTR0NjQgLTEwNS41dDE5IC0xMDMuNXEwIC00NiAtMTUgLTgyLjV0LTM2LjUgLTU4dC00OC41IC0zNnQtNDkgLTE5LjV0LTM5IC01aC04aC0zMnQtMzkgNXQtNDQgMTR0LTQxIDI4dC0zNyA0NnQtMjQgNzAuNSB0LTEwIDk3LjVxLTE1IDE2IC01OSAyNS41dC04MSAxMC41bC0zNyAxcS02OCAwIC0xMTcuNSAtMzF0LTcwLjUgLTcwdC0yMSAtNzZxMCAtMjQgNSAtNDN0MjQgLTQ2dDUzIC01MXQ5NyAtNTMuNXQxNTAgLTU4LjVxNzYgLTI1IDEzOC41IC01My41dDEwOSAtNTUuNXQ4MyAtNTl0NjAuNSAtNTkuNXQ0MSAtNjIuNXQyNi41IC02MnQxNC41IC02My41dDYgLTYydDEgLTYyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOGI7IiBkPSJNNzA0IDM1MnY1NzZxMCAxNCAtOSAyM3QtMjMgOWgtMjU2cS0xNCAwIC0yMyAtOXQtOSAtMjN2LTU3NnEwIC0xNCA5IC0yM3QyMyAtOWgyNTZxMTQgMCAyMyA5dDkgMjN6TTExNTIgMzUydjU3NnEwIDE0IC05IDIzdC0yMyA5aC0yNTZxLTE0IDAgLTIzIC05dC05IC0yM3YtNTc2cTAgLTE0IDkgLTIzdDIzIC05aDI1NnExNCAwIDIzIDl0OSAyM3pNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDMgdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjhjOyIgZD0iTTc2OCAxNDA4cTIwOSAwIDM4NS41IC0xMDN0Mjc5LjUgLTI3OS41dDEwMyAtMzg1LjV0LTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN6TTc2OCA5NnExNDggMCAyNzMgNzN0MTk4IDE5OHQ3MyAyNzN0LTczIDI3M3QtMTk4IDE5OHQtMjczIDczdC0yNzMgLTczdC0xOTggLTE5OHQtNzMgLTI3MyB0NzMgLTI3M3QxOTggLTE5OHQyNzMgLTczek04NjQgMzIwcS0xNCAwIC0yMyA5dC05IDIzdjU3NnEwIDE0IDkgMjN0MjMgOWgxOTJxMTQgMCAyMyAtOXQ5IC0yM3YtNTc2cTAgLTE0IC05IC0yM3QtMjMgLTloLTE5MnpNNDgwIDMyMHEtMTQgMCAtMjMgOXQtOSAyM3Y1NzZxMCAxNCA5IDIzdDIzIDloMTkycTE0IDAgMjMgLTl0OSAtMjN2LTU3NnEwIC0xNCAtOSAtMjN0LTIzIC05aC0xOTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOGQ7IiBkPSJNMTA4OCAzNTJ2NTc2cTAgMTQgLTkgMjN0LTIzIDloLTU3NnEtMTQgMCAtMjMgLTl0LTkgLTIzdi01NzZxMCAtMTQgOSAtMjN0MjMgLTloNTc2cTE0IDAgMjMgOXQ5IDIzek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjUgdDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOGU7IiBkPSJNNzY4IDE0MDhxMjA5IDAgMzg1LjUgLTEwM3QyNzkuNSAtMjc5LjV0MTAzIC0zODUuNXQtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3pNNzY4IDk2cTE0OCAwIDI3MyA3M3QxOTggMTk4dDczIDI3M3QtNzMgMjczdC0xOTggMTk4dC0yNzMgNzN0LTI3MyAtNzN0LTE5OCAtMTk4dC03MyAtMjczIHQ3MyAtMjczdDE5OCAtMTk4dDI3MyAtNzN6TTQ4MCAzMjBxLTE0IDAgLTIzIDl0LTkgMjN2NTc2cTAgMTQgOSAyM3QyMyA5aDU3NnExNCAwIDIzIC05dDkgLTIzdi01NzZxMCAtMTQgLTkgLTIzdC0yMyAtOWgtNTc2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjkwOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xNzU3IDEyOGwzNSAtMzEzcTMgLTI4IC0xNiAtNTBxLTE5IC0yMSAtNDggLTIxaC0xNjY0cS0yOSAwIC00OCAyMXEtMTkgMjIgLTE2IDUwbDM1IDMxM2gxNzIyek0xNjY0IDk2N2w4NiAtNzc1aC0xNzA4bDg2IDc3NXEzIDI0IDIxIDQwLjV0NDMgMTYuNWgyNTZ2LTEyOHEwIC01MyAzNy41IC05MC41dDkwLjUgLTM3LjV0OTAuNSAzNy41dDM3LjUgOTAuNXYxMjhoMzg0di0xMjhxMCAtNTMgMzcuNSAtOTAuNXQ5MC41IC0zNy41IHQ5MC41IDM3LjV0MzcuNSA5MC41djEyOGgyNTZxMjUgMCA0MyAtMTYuNXQyMSAtNDAuNXpNMTI4MCAxMTUydi0yNTZxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOXQtMTkgNDV2MjU2cTAgMTA2IC03NSAxODF0LTE4MSA3NXQtMTgxIC03NXQtNzUgLTE4MXYtMjU2cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1djI1NnEwIDE1OSAxMTIuNSAyNzEuNXQyNzEuNSAxMTIuNXQyNzEuNSAtMTEyLjV0MTEyLjUgLTI3MS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjkxOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik0xOTIwIDc2OHE1MyAwIDkwLjUgLTM3LjV0MzcuNSAtOTAuNXQtMzcuNSAtOTAuNXQtOTAuNSAtMzcuNWgtMTVsLTExNSAtNjYycS04IC00NiAtNDQgLTc2dC04MiAtMzBoLTEyODBxLTQ2IDAgLTgyIDMwdC00NCA3NmwtMTE1IDY2MmgtMTVxLTUzIDAgLTkwLjUgMzcuNXQtMzcuNSA5MC41dDM3LjUgOTAuNXQ5MC41IDM3LjVoMTc5MnpNNDg1IC0zMnEyNiAyIDQzLjUgMjIuNXQxNS41IDQ2LjVsLTMyIDQxNnEtMiAyNiAtMjIuNSA0My41IHQtNDYuNSAxNS41dC00My41IC0yMi41dC0xNS41IC00Ni41bDMyIC00MTZxMiAtMjUgMjAuNSAtNDJ0NDMuNSAtMTdoNXpNODk2IDMydjQxNnEwIDI2IC0xOSA0NXQtNDUgMTl0LTQ1IC0xOXQtMTkgLTQ1di00MTZxMCAtMjYgMTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXpNMTI4MCAzMnY0MTZxMCAyNiAtMTkgNDV0LTQ1IDE5dC00NSAtMTl0LTE5IC00NXYtNDE2cTAgLTI2IDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDV6TTE2MzIgMjdsMzIgNDE2IHEyIDI2IC0xNS41IDQ2LjV0LTQzLjUgMjIuNXQtNDYuNSAtMTUuNXQtMjIuNSAtNDMuNWwtMzIgLTQxNnEtMiAtMjYgMTUuNSAtNDYuNXQ0My41IC0yMi41aDVxMjUgMCA0My41IDE3dDIwLjUgNDJ6TTQ3NiAxMjQ0bC05MyAtNDEyaC0xMzJsMTAxIDQ0MXExOSA4OCA4OSAxNDMuNXQxNjAgNTUuNWgxNjdxMCAyNiAxOSA0NXQ0NSAxOWgzODRxMjYgMCA0NSAtMTl0MTkgLTQ1aDE2N3E5MCAwIDE2MCAtNTUuNXQ4OSAtMTQzLjVsMTAxIC00NDEgaC0xMzJsLTkzIDQxMnEtMTEgNDQgLTQ1LjUgNzJ0LTc5LjUgMjhoLTE2N3EwIC0yNiAtMTkgLTQ1dC00NSAtMTloLTM4NHEtMjYgMCAtNDUgMTl0LTE5IDQ1aC0xNjdxLTQ1IDAgLTc5LjUgLTI4dC00NS41IC03MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI5MjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNOTkxIDUxMmw2NCAyNTZoLTI1NGwtNjQgLTI1NmgyNTR6TTE3NTkgMTAxNmwtNTYgLTIyNHEtNyAtMjQgLTMxIC0yNGgtMzI3bC02NCAtMjU2aDMxMXExNSAwIDI1IC0xMnExMCAtMTQgNiAtMjhsLTU2IC0yMjRxLTUgLTI0IC0zMSAtMjRoLTMyN2wtODEgLTMyOHEtNyAtMjQgLTMxIC0yNGgtMjI0cS0xNiAwIC0yNiAxMnEtOSAxMiAtNiAyOGw3OCAzMTJoLTI1NGwtODEgLTMyOHEtNyAtMjQgLTMxIC0yNGgtMjI1cS0xNSAwIC0yNSAxMiBxLTkgMTIgLTYgMjhsNzggMzEyaC0zMTFxLTE1IDAgLTI1IDEycS05IDEyIC02IDI4bDU2IDIyNHE3IDI0IDMxIDI0aDMyN2w2NCAyNTZoLTMxMXEtMTUgMCAtMjUgMTJxLTEwIDE0IC02IDI4bDU2IDIyNHE1IDI0IDMxIDI0aDMyN2w4MSAzMjhxNyAyNCAzMiAyNGgyMjRxMTUgMCAyNSAtMTJxOSAtMTIgNiAtMjhsLTc4IC0zMTJoMjU0bDgxIDMyOHE3IDI0IDMyIDI0aDIyNHExNSAwIDI1IC0xMnE5IC0xMiA2IC0yOGwtNzggLTMxMmgzMTEgcTE1IDAgMjUgLTEycTkgLTEyIDYgLTI4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjkzOyIgZD0iTTg0MSA0ODNsMTQ4IC0xNDhsLTE0OSAtMTQ5ek04NDAgMTA5NGwxNDkgLTE0OWwtMTQ4IC0xNDh6TTcxMCAtMTMwbDQ2NCA0NjRsLTMwNiAzMDZsMzA2IDMwNmwtNDY0IDQ2NHYtNjExbC0yNTUgMjU1bC05MyAtOTNsMzIwIC0zMjFsLTMyMCAtMzIxbDkzIC05M2wyNTUgMjU1di02MTF6TTE0MjkgNjQwcTAgLTIwOSAtMzIgLTM2NS41dC04Ny41IC0yNTd0LTE0MC41IC0xNjIuNXQtMTgxLjUgLTg2LjV0LTIxOS41IC0yNC41IHQtMjE5LjUgMjQuNXQtMTgxLjUgODYuNXQtMTQwLjUgMTYyLjV0LTg3LjUgMjU3dC0zMiAzNjUuNXQzMiAzNjUuNXQ4Ny41IDI1N3QxNDAuNSAxNjIuNXQxODEuNSA4Ni41dDIxOS41IDI0LjV0MjE5LjUgLTI0LjV0MTgxLjUgLTg2LjV0MTQwLjUgLTE2Mi41dDg3LjUgLTI1N3QzMiAtMzY1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOTQ7IiBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTU5NiAxMTNsMTczIDE3MmwtMTczIDE3MnYtMzQ0ek01OTYgODIzbDE3MyAxNzJsLTE3MyAxNzJ2LTM0NHpNNjI4IDY0MGwzNTYgLTM1NmwtNTM5IC01NDB2NzExbC0yOTcgLTI5NmwtMTA4IDEwOGwzNzIgMzczbC0zNzIgMzczbDEwOCAxMDhsMjk3IC0yOTZ2NzExbDUzOSAtNTQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjk1OyIgZD0iTTEyODAgMjU2cTAgNTIgLTM4IDkwdC05MCAzOHQtOTAgLTM4dC0zOCAtOTB0MzggLTkwdDkwIC0zOHQ5MCAzOHQzOCA5MHpNNTEyIDEwMjRxMCA1MiAtMzggOTB0LTkwIDM4dC05MCAtMzh0LTM4IC05MHQzOCAtOTB0OTAgLTM4dDkwIDM4dDM4IDkwek0xNTM2IDI1NnEwIC0xNTkgLTExMi41IC0yNzEuNXQtMjcxLjUgLTExMi41dC0yNzEuNSAxMTIuNXQtMTEyLjUgMjcxLjV0MTEyLjUgMjcxLjV0MjcxLjUgMTEyLjV0MjcxLjUgLTExMi41IHQxMTIuNSAtMjcxLjV6TTE0NDAgMTM0NHEwIC0yMCAtMTMgLTM4bC0xMDU2IC0xNDA4cS0xOSAtMjYgLTUxIC0yNmgtMTYwcS0yNiAwIC00NSAxOXQtMTkgNDVxMCAyMCAxMyAzOGwxMDU2IDE0MDhxMTkgMjYgNTEgMjZoMTYwcTI2IDAgNDUgLTE5dDE5IC00NXpNNzY4IDEwMjRxMCAtMTU5IC0xMTIuNSAtMjcxLjV0LTI3MS41IC0xMTIuNXQtMjcxLjUgMTEyLjV0LTExMi41IDI3MS41dDExMi41IDI3MS41dDI3MS41IDExMi41IHQyNzEuNSAtMTEyLjV0MTEyLjUgLTI3MS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjk2OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik0xMDQgODMwbDc5MiAtMTAxNWwtODY4IDYzMHEtMTggMTMgLTI1IDM0LjV0MCA0Mi41bDEwMSAzMDh2MHpNNTY2IDgzMGg2NjBsLTMzMCAtMTAxNXYwek0zNjggMTQ0MmwxOTggLTYxMmgtNDYybDE5OCA2MTJxOCAyMyAzMyAyM3QzMyAtMjN6TTE2ODggODMwbDEwMSAtMzA4cTcgLTIxIDAgLTQyLjV0LTI1IC0zNC41bC04NjggLTYzMGw3OTIgMTAxNXYwek0xNjg4IDgzMGgtNDYybDE5OCA2MTJxOCAyMyAzMyAyM3QzMyAtMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOTc7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTM4NCA3MDRoMTYwdjIyNGgtMTYwdi0yMjR6TTEyMjEgMzcydjkycS0xMDQgLTM2IC0yNDMgLTM4cS0xMzUgLTEgLTI1OS41IDQ2LjV0LTIyMC41IDEyMi41bDEgLTk2cTg4IC04MCAyMTIgLTEyOC41dDI3MiAtNDcuNXExMjkgMCAyMzggNDl6TTY0MCA3MDRoNjQwdjIyNGgtNjQwdi0yMjR6TTE3OTIgNzM2cTAgLTE4NyAtOTkgLTM1MnE4OSAtMTAyIDg5IC0yMjlxMCAtMTU3IC0xMjkuNSAtMjY4dC0zMTMuNSAtMTExIHEtMTIyIDAgLTIyNSA1Mi41dC0xNjEgMTQwLjVxLTE5IC0xIC01NyAtMXQtNTcgMXEtNTggLTg4IC0xNjEgLTE0MC41dC0yMjUgLTUyLjVxLTE4NCAwIC0zMTMuNSAxMTF0LTEyOS41IDI2OHEwIDEyNyA4OSAyMjlxLTk5IDE2NSAtOTkgMzUycTAgMjA5IDEyMCAzODUuNXQzMjYuNSAyNzkuNXQ0NDkuNSAxMDN0NDQ5LjUgLTEwM3QzMjYuNSAtMjc5LjV0MTIwIC0zODUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjI5ODsiIGQ9Ik01MTUgNjI1di0xMjhoLTI1MnYxMjhoMjUyek01MTUgODgwdi0xMjdoLTI1MnYxMjdoMjUyek0xMjczIDM2OXYtMTI4aC0zNDF2MTI4aDM0MXpNMTI3MyA2MjV2LTEyOGgtNjcydjEyOGg2NzJ6TTEyNzMgODgwdi0xMjdoLTY3MnYxMjdoNjcyek0xNDA4IDIwdjEyNDBxMCA4IC02IDE0dC0xNCA2aC0zMmwtMzc4IC0yNTZsLTIxMCAxNzFsLTIxMCAtMTcxbC0zNzggMjU2aC0zMnEtOCAwIC0xNCAtNnQtNiAtMTR2LTEyNDBxMCAtOCA2IC0xNCB0MTQgLTZoMTI0MHE4IDAgMTQgNnQ2IDE0ek01NTMgMTEzMGwxODUgMTUwaC00MDZ6TTk4MyAxMTMwbDIyMSAxNTBoLTQwNnpNMTUzNiAxMjYwdi0xMjQwcTAgLTYyIC00MyAtMTA1dC0xMDUgLTQzaC0xMjQwcS02MiAwIC0xMDUgNDN0LTQzIDEwNXYxMjQwcTAgNjIgNDMgMTA1dDEwNSA0M2gxMjQwcTYyIDAgMTA1IC00M3Q0MyAtMTA1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjk5OyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04OTYgNzIwcS0xMDQgMTk2IC0xNjAgMjc4cS0xMzkgMjAyIC0zNDcgMzE4cS0zNCAxOSAtNzAgMzZxLTg5IDQwIC05NCAzMnQzNCAtMzhsMzkgLTMxcTYyIC00MyAxMTIuNSAtOTMuNXQ5NC41IC0xMTYuNXQ3MC41IC0xMTN0NzAuNSAtMTMxcTkgLTE3IDEzIC0yNXE0NCAtODQgODQgLTE1M3Q5OCAtMTU0dDExNS41IC0xNTB0MTMxIC0xMjMuNXQxNDguNSAtOTAuNXExNTMgLTY2IDE1NCAtNjBxMSAzIC00OSAzN3EtNTMgMzYgLTgxIDU3IHEtNzcgNTggLTE3OSAyMTF0LTE4NSAzMTB6TTU0OSAxNzdxLTc2IDYwIC0xMzIuNSAxMjV0LTk4IDE0My41dC03MSAxNTQuNXQtNTguNSAxODZ0LTUyIDIwOXQtNjAuNSAyNTJ0LTc2LjUgMjg5cTI3MyAwIDQ5Ny41IC0zNnQzNzkgLTkydDI3MSAtMTQ0LjV0MTg1LjUgLTE3Mi41dDExMCAtMTk4LjV0NTYgLTE5OS41dDEyLjUgLTE5OC41dC05LjUgLTE3M3QtMjAgLTE0My41dC0xMyAtMTA3bDMyMyAtMzI3aC0xMDRsLTI4MSAyODUgcS0yMiAtMiAtOTEuNSAtMTR0LTEyMS41IC0xOXQtMTM4IC02dC0xNjAuNSAxN3QtMTY3LjUgNTl0LTE3OSAxMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyOWE7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTEzNzQgODc5cS02IDI2IC0yOC41IDM5LjV0LTQ4LjUgNy41cS0yNjEgLTYyIC00MDEgLTYydC00MDEgNjJxLTI2IDYgLTQ4LjUgLTcuNXQtMjguNSAtMzkuNXQ3LjUgLTQ4LjV0MzkuNSAtMjguNXExOTQgLTQ2IDMwMyAtNThxLTIgLTE1OCAtMTUuNSAtMjY5dC0yNi41IC0xNTUuNXQtNDEgLTExNS41bC05IC0yMXEtMTAgLTI1IDEgLTQ5dDM2IC0zNHE5IC00IDIzIC00cTQ0IDAgNjAgNDFsOCAyMHE1NCAxMzkgNzEgMjU5aDQyIHExNyAtMTIwIDcxIC0yNTlsOCAtMjBxMTYgLTQxIDYwIC00MXExNCAwIDIzIDRxMjUgMTAgMzYgMzR0MSA0OWwtOSAyMXEtMjggNzEgLTQxIDExNS41dC0yNi41IDE1NS41dC0xNS41IDI2OXExMDkgMTIgMzAzIDU4cTI2IDYgMzkuNSAyOC41dDcuNSA0OC41ek0xMDI0IDEwMjRxMCA1MyAtMzcuNSA5MC41dC05MC41IDM3LjV0LTkwLjUgLTM3LjV0LTM3LjUgLTkwLjV0MzcuNSAtOTAuNXQ5MC41IC0zNy41dDkwLjUgMzcuNXQzNy41IDkwLjV6IE0xNjAwIDY0MHEwIC0xNDMgLTU1LjUgLTI3My41dC0xNTAgLTIyNXQtMjI1IC0xNTB0LTI3My41IC01NS41dC0yNzMuNSA1NS41dC0yMjUgMTUwdC0xNTAgMjI1dC01NS41IDI3My41dDU1LjUgMjczLjV0MTUwIDIyNXQyMjUgMTUwdDI3My41IDU1LjV0MjczLjUgLTU1LjV0MjI1IC0xNTB0MTUwIC0yMjV0NTUuNSAtMjczLjV6TTg5NiAxNDA4cS0xNTYgMCAtMjk4IC02MXQtMjQ1IC0xNjR0LTE2NCAtMjQ1dC02MSAtMjk4dDYxIC0yOTggdDE2NCAtMjQ1dDI0NSAtMTY0dDI5OCAtNjF0Mjk4IDYxdDI0NSAxNjR0MTY0IDI0NXQ2MSAyOTh0LTYxIDI5OHQtMTY0IDI0NXQtMjQ1IDE2NHQtMjk4IDYxek0xNzkyIDY0MHEwIC0xODIgLTcxIC0zNDh0LTE5MSAtMjg2dC0yODYgLTE5MXQtMzQ4IC03MXQtMzQ4IDcxdC0yODYgMTkxdC0xOTEgMjg2dC03MSAzNDh0NzEgMzQ4dDE5MSAyODZ0Mjg2IDE5MXQzNDggNzF0MzQ4IC03MXQyODYgLTE5MXQxOTEgLTI4NnQ3MSAtMzQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjliOyIgZD0iTTE0MzggNzIzcTM0IC0zNSAyOSAtODJsLTQ0IC01NTFxLTQgLTQyIC0zNC41IC03MHQtNzEuNSAtMjhxLTYgMCAtOSAxcS00NCAzIC03Mi41IDM2LjV0LTI1LjUgNzcuNWwzNSA0MjlsLTE0MyAtOHE1NSAtMTEzIDU1IC0yNDBxMCAtMjE2IC0xNDggLTM3MmwtMTM3IDEzN3E5MSAxMDEgOTEgMjM1cTAgMTQ1IC0xMDIuNSAyNDh0LTI0Ny41IDEwM3EtMTM0IDAgLTIzNiAtOTJsLTEzNyAxMzhxMTIwIDExNCAyODQgMTQxbDI2NCAzMDAgbC0xNDkgODdsLTE4MSAtMTYxcS0zMyAtMzAgLTc3IC0yNy41dC03MyAzNS41dC0yNi41IDc3dDM0LjUgNzNsMjM5IDIxM3EyNiAyMyA2MCAyNi41dDY0IC0xNC41bDQ4OCAtMjgzcTM2IC0yMSA0OCAtNjhxMTcgLTY3IC0yNiAtMTE3bC0yMDUgLTIzMmwzNzEgMjBxNDkgMyA4MyAtMzJ6TTEyNDAgMTE4MHEtNzQgMCAtMTI2IDUydC01MiAxMjZ0NTIgMTI2dDEyNiA1MnQxMjYuNSAtNTJ0NTIuNSAtMTI2dC01Mi41IC0xMjZ0LTEyNi41IC01MnogTTYxMyAtNjJxMTA2IDAgMTk2IDYxbDEzOSAtMTM5cS0xNDYgLTExNiAtMzM1IC0xMTZxLTE0OCAwIC0yNzMuNSA3M3QtMTk4LjUgMTk4dC03MyAyNzNxMCAxODggMTE2IDMzNmwxMzkgLTEzOXEtNjAgLTg4IC02MCAtMTk3cTAgLTE0NSAxMDIuNSAtMjQ3LjV0MjQ3LjUgLTEwMi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjljOyIgZD0iTTg4MCAzMzZ2LTE2MHEwIC0xNCAtOSAtMjN0LTIzIC05aC0xNjBxLTE0IDAgLTIzIDl0LTkgMjN2MTYwcTAgMTQgOSAyM3QyMyA5aDE2MHExNCAwIDIzIC05dDkgLTIzek0xMTM2IDgzMnEwIC01MCAtMTUgLTkwdC00NS41IC02OXQtNTIgLTQ0dC01OS41IC0zNnEtMzIgLTE4IC00Ni41IC0yOHQtMjYgLTI0dC0xMS41IC0yOXYtMzJxMCAtMTQgLTkgLTIzdC0yMyAtOWgtMTYwcS0xNCAwIC0yMyA5dC05IDIzdjY4cTAgMzUgMTAuNSA2NC41IHQyNCA0Ny41dDM5IDM1LjV0NDEgMjUuNXQ0NC41IDIxcTUzIDI1IDc1IDQzdDIyIDQ5cTAgNDIgLTQzLjUgNzEuNXQtOTUuNSAyOS41cS01NiAwIC05NSAtMjdxLTI5IC0yMCAtODAgLTgzcS05IC0xMiAtMjUgLTEycS0xMSAwIC0xOSA2bC0xMDggODJxLTEwIDcgLTEyIDIwdDUgMjNxMTIyIDE5MiAzNDkgMTkycTEyOSAwIDIzOC41IC04OS41dDEwOS41IC0yMTQuNXpNNzY4IDEyODBxLTEzMCAwIC0yNDguNSAtNTF0LTIwNCAtMTM2LjUgdC0xMzYuNSAtMjA0dC01MSAtMjQ4LjV0NTEgLTI0OC41dDEzNi41IC0yMDR0MjA0IC0xMzYuNXQyNDguNSAtNTF0MjQ4LjUgNTF0MjA0IDEzNi41dDEzNi41IDIwNHQ1MSAyNDguNXQtNTEgMjQ4LjV0LTEzNi41IDIwNHQtMjA0IDEzNi41dC0yNDguNSA1MXpNMTUzNiA2NDBxMCAtMjA5IC0xMDMgLTM4NS41dC0yNzkuNSAtMjc5LjV0LTM4NS41IC0xMDN0LTM4NS41IDEwM3QtMjc5LjUgMjc5LjV0LTEwMyAzODUuNXQxMDMgMzg1LjUgdDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjlkOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik0zNjYgMTIyNXEtNjQgMCAtMTEwIDQ1LjV0LTQ2IDExMC41cTAgNjQgNDYgMTA5LjV0MTEwIDQ1LjV0MTA5LjUgLTQ1LjV0NDUuNSAtMTA5LjVxMCAtNjUgLTQ1LjUgLTExMC41dC0xMDkuNSAtNDUuNXpNOTE3IDU4M3EwIC01MCAtMzAgLTY3LjV0LTYzLjUgLTYuNXQtNDcuNSAzNGwtMzY3IDQzOHEtNyAxMiAtMTQgMTUuNXQtMTEgMS41bC0zIC0zcS03IC04IDQgLTIxbDEyMiAtMTM5bDEgLTM1NGwtMTYxIC00NTcgcS02NyAtMTkyIC05MiAtMjM0cS0xNiAtMjYgLTI4IC0zMnEtNTAgLTI2IC0xMDMgLTFxLTI5IDEzIC00MS41IDQzdC05LjUgNTdxMiAxNyAxOTcgNjE4bDUgNDE2bC04NSAtMTY0bDM1IC0yMjJxNCAtMjQgLTEgLTQydC0xNCAtMjcuNXQtMTkgLTE2dC0xNyAtNy41bC03IC0ycS0xOSAtMyAtMzQuNSAzdC0yNCAxNnQtMTQgMjJ0LTcuNSAxOS41dC0yIDkuNWwtNDYgMjk5bDIxMSAzODFxMjMgMzQgMTEzIDM0cTc1IDAgMTA3IC00MGw0MjQgLTUyMSBxNyAtNSAxNCAtMTdsMyAtM2wtMSAtMXE3IC0xMyA3IC0yOXpNNTE0IDQzM3E0MyAtMTEzIDg4LjUgLTIyNXQ2OS41IC0xNjhsMjQgLTU1cTM2IC05MyA0MiAtMTI1cTExIC03MCAtMzYgLTk3cS0zNSAtMjIgLTY2IC0xNnQtNTEgMjJ0LTI5IDM1aC0xcS02IDE2IC04IDI1bC0xMjQgMzUxek0xMzM4IC0xNTlxMzEgLTQ5IDMxIC01N3EwIC01IC0zIC03cS05IC01IC0xNC41IDAuNXQtMTUuNSAyNnQtMTYgMzAuNXEtMTE0IDE3MiAtNDIzIDY2MSBxMyAtMSA3IDF0NyA0bDMgMnExMSA5IDExIDE3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjllOyIgaG9yaXotYWR2LXg9IjIzMDQiIGQ9Ik01MDQgNTQyaDE3MWwtMSAyNjV6TTE1MzAgNjQxcTAgODcgLTUwLjUgMTQwdC0xNDYuNSA1M2gtNTR2LTM4OGg1MnE5MSAwIDE0NSA1N3Q1NCAxMzh6TTk1NiAxMDE4bDEgLTc1NnEwIC0xNCAtOS41IC0yNHQtMjMuNSAtMTBoLTIxNnEtMTQgMCAtMjMuNSAxMHQtOS41IDI0djYyaC0yOTFsLTU1IC04MXEtMTAgLTE1IC0yOCAtMTVoLTI2N3EtMjEgMCAtMzAuNSAxOHQzLjUgMzVsNTU2IDc1N3E5IDE0IDI3IDE0aDMzMnExNCAwIDI0IC0xMCB0MTAgLTI0ek0xNzgzIDY0MXEwIC0xOTMgLTEyNS41IC0zMDN0LTMyNC41IC0xMTBoLTI3MHEtMTQgMCAtMjQgMTB0LTEwIDI0djc1NnEwIDE0IDEwIDI0dDI0IDEwaDI2OHEyMDAgMCAzMjYgLTEwOXQxMjYgLTMwMnpNMTkzOSA2NDBxMCAtMTEgLTAuNSAtMjl0LTggLTcxLjV0LTIxLjUgLTEwMnQtNDQuNSAtMTA4dC03My41IC0xMDIuNWgtNTFxMzggNDUgNjYuNSAxMDQuNXQ0MS41IDExMnQyMSA5OHQ5IDcyLjVsMSAyN3EwIDggLTAuNSAyMi41IHQtNy41IDYwdC0yMCA5MS41dC00MSAxMTEuNXQtNjYgMTI0LjVoNDNxNDEgLTQ3IDcyIC0xMDd0NDUuNSAtMTExLjV0MjMgLTk2dDEwLjUgLTcwLjV6TTIxMjMgNjQwcTAgLTExIC0wLjUgLTI5dC04IC03MS41dC0yMS41IC0xMDJ0LTQ1IC0xMDh0LTc0IC0xMDIuNWgtNTFxMzggNDUgNjYuNSAxMDQuNXQ0MS41IDExMnQyMSA5OHQ5IDcyLjVsMSAyN3EwIDggLTAuNSAyMi41dC03LjUgNjB0LTE5LjUgOTEuNXQtNDAuNSAxMTEuNXQtNjYgMTI0LjUgaDQzcTQxIC00NyA3MiAtMTA3dDQ1LjUgLTExMS41dDIzIC05NnQxMC41IC03MC41ek0yMzA0IDY0MHEwIC0xMSAtMC41IC0yOXQtOCAtNzEuNXQtMjEuNSAtMTAydC00NC41IC0xMDh0LTczLjUgLTEwMi41aC01MXEzOCA0NSA2NiAxMDQuNXQ0MSAxMTJ0MjEgOTh0OSA3Mi41bDEgMjdxMCA4IC0wLjUgMjIuNXQtNy41IDYwdC0xOS41IDkxLjV0LTQwLjUgMTExLjV0LTY2IDEyNC41aDQzcTQxIC00NyA3MiAtMTA3dDQ1LjUgLTExMS41dDIzIC05NiB0OS41IC03MC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmEwOyIgaG9yaXotYWR2LXg9IjE0MDgiIGQ9Ik02MTcgLTE1M3EwIDExIC0xMyA1OHQtMzEgMTA3dC0yMCA2OXEtMSA0IC01IDI2LjV0LTguNSAzNnQtMTMuNSAyMS41cS0xNSAxNCAtNTEgMTRxLTIzIDAgLTcwIC01LjV0LTcxIC01LjVxLTM0IDAgLTQ3IDExcS02IDUgLTExIDE1LjV0LTcuNSAyMHQtNi41IDI0dC01IDE4LjVxLTM3IDEyOCAtMzcgMjU1dDM3IDI1NXExIDQgNSAxOC41dDYuNSAyNHQ3LjUgMjB0MTEgMTUuNXExMyAxMSA0NyAxMXEyNCAwIDcxIC01LjV0NzAgLTUuNSBxMzYgMCA1MSAxNHE5IDggMTMuNSAyMS41dDguNSAzNnQ1IDI2LjVxMiA5IDIwIDY5dDMxIDEwN3QxMyA1OHEwIDIyIC00My41IDUyLjV0LTc1LjUgNDIuNXEtMjAgOCAtNDUgOHEtMzQgMCAtOTggLTE4cS01NyAtMTcgLTk2LjUgLTQwLjV0LTcxIC02NnQtNDYgLTcwdC00NS41IC05NC41cS02IC0xMiAtOSAtMTlxLTQ5IC0xMDcgLTY4IC0yMTZ0LTE5IC0yNDR0MTkgLTI0NHQ2OCAtMjE2cTU2IC0xMjIgODMgLTE2MXE2MyAtOTEgMTc5IC0xMjcgbDYgLTJxNjQgLTE4IDk4IC0xOHEyNSAwIDQ1IDhxMzIgMTIgNzUuNSA0Mi41dDQzLjUgNTIuNXpNNzc2IDc2MHEtMjYgMCAtNDUgMTl0LTE5IDQ1LjV0MTkgNDUuNXEzNyAzNyAzNyA5MHEwIDUyIC0zNyA5MXEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5dDQ1IC0xOXE3NSAtNzUgNzUgLTE4MXQtNzUgLTE4MXEtMjEgLTE5IC00NSAtMTl6TTk1NyA1NzlxLTI3IDAgLTQ1IDE5cS0xOSAxOSAtMTkgNDV0MTkgNDVxMTEyIDExNCAxMTIgMjcyIHQtMTEyIDI3MnEtMTkgMTkgLTE5IDQ1dDE5IDQ1dDQ1IDE5dDQ1IC0xOXExNTAgLTE1MCAxNTAgLTM2MnQtMTUwIC0zNjJxLTE4IC0xOSAtNDUgLTE5ek0xMTM4IDM5OHEtMjcgMCAtNDUgMTlxLTE5IDE5IC0xOSA0NXQxOSA0NXE5MCA5MSAxMzguNSAyMDh0NDguNSAyNDV0LTQ4LjUgMjQ1dC0xMzguNSAyMDhxLTE5IDE5IC0xOSA0NXQxOSA0NXQ0NSAxOXQ0NSAtMTlxMTA5IC0xMDkgMTY3IC0yNDl0NTggLTI5NHQtNTggLTI5NHQtMTY3IC0yNDkgcS0xOCAtMTkgLTQ1IC0xOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhMTsiIGhvcml6LWFkdi14PSIyMTc2IiBkPSJNMTkyIDM1MnEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3Q0NyAtMTEzdDExMyAtNDd0MTEzIDQ3dDQ3IDExM3QtNDcgMTEzdC0xMTMgNDd6TTcwNCAzNTJxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTN0NDcgLTExM3QxMTMgLTQ3dDExMyA0N3Q0NyAxMTN0LTQ3IDExM3QtMTEzIDQ3ek03MDQgODY0cS02NiAwIC0xMTMgLTQ3dC00NyAtMTEzdDQ3IC0xMTN0MTEzIC00N3QxMTMgNDd0NDcgMTEzdC00NyAxMTN0LTExMyA0N3pNMTQ3MiAzNTIgcS02NiAwIC0xMTMgLTQ3dC00NyAtMTEzdDQ3IC0xMTN0MTEzIC00N3QxMTMgNDd0NDcgMTEzdC00NyAxMTN0LTExMyA0N3pNMTk4NCAzNTJxLTY2IDAgLTExMyAtNDd0LTQ3IC0xMTN0NDcgLTExM3QxMTMgLTQ3dDExMyA0N3Q0NyAxMTN0LTQ3IDExM3QtMTEzIDQ3ek0xNDcyIDg2NHEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3Q0NyAtMTEzdDExMyAtNDd0MTEzIDQ3dDQ3IDExM3QtNDcgMTEzdC0xMTMgNDd6TTE5ODQgODY0IHEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3Q0NyAtMTEzdDExMyAtNDd0MTEzIDQ3dDQ3IDExM3QtNDcgMTEzdC0xMTMgNDd6TTE5ODQgMTM3NnEtNjYgMCAtMTEzIC00N3QtNDcgLTExM3Q0NyAtMTEzdDExMyAtNDd0MTEzIDQ3dDQ3IDExM3QtNDcgMTEzdC0xMTMgNDd6TTM4NCAxOTJxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2dDU2IDEzNnQxMzYgNTZ0MTM2IC01NnQ1NiAtMTM2ek04OTYgMTkycTAgLTgwIC01NiAtMTM2IHQtMTM2IC01NnQtMTM2IDU2dC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6TTM4NCA3MDRxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2dDU2IDEzNnQxMzYgNTZ0MTM2IC01NnQ1NiAtMTM2ek04OTYgNzA0cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMzg0IDEyMTZxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTYgdC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMTY2NCAxOTJxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2dDU2IDEzNnQxMzYgNTZ0MTM2IC01NnQ1NiAtMTM2ek04OTYgMTIxNnEwIC04MCAtNTYgLTEzNnQtMTM2IC01NnQtMTM2IDU2dC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6TTIxNzYgMTkycTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTYgdC01NiAxMzZ0NTYgMTM2dDEzNiA1NnQxMzYgLTU2dDU2IC0xMzZ6TTE2NjQgNzA0cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMjE3NiA3MDRxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2dDU2IDEzNnQxMzYgNTZ0MTM2IC01NnQ1NiAtMTM2ek0xNjY0IDEyMTZxMCAtODAgLTU2IC0xMzZ0LTEzNiAtNTZ0LTEzNiA1NnQtNTYgMTM2IHQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnpNMjE3NiAxMjE2cTAgLTgwIC01NiAtMTM2dC0xMzYgLTU2dC0xMzYgNTZ0LTU2IDEzNnQ1NiAxMzZ0MTM2IDU2dDEzNiAtNTZ0NTYgLTEzNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhMjsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTI4IC0xOTJxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTl0NDUgLTE5dDE5IC00NXpNMzIwIDBxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOXQtMTkgNDV0MTkgNDV0NDUgMTl0NDUgLTE5dDE5IC00NXpNMzY1IDM2NWwyNTYgLTI1NmwtOTAgLTkwbC0yNTYgMjU2ek03MDQgMzg0cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1dDE5IDQ1dDQ1IDE5dDQ1IC0xOXQxOSAtNDV6IE0xNDExIDcwNHEwIC01OSAtMTEuNSAtMTA4LjV0LTM3LjUgLTkzLjV0LTQ0IC02Ny41dC01MyAtNjQuNXEtMzEgLTM1IC00NS41IC01NHQtMzMuNSAtNTB0LTI2LjUgLTY0dC03LjUgLTc0cTAgLTE1OSAtMTEyLjUgLTI3MS41dC0yNzEuNSAtMTEyLjVxLTI2IDAgLTQ1IDE5dC0xOSA0NXQxOSA0NXQ0NSAxOXExMDYgMCAxODEgNzV0NzUgMTgxcTAgNTcgMTEuNSAxMDUuNXQzNyA5MXQ0My41IDY2LjV0NTIgNjNxNDAgNDYgNTkuNSA3MiB0MzcuNSA3NC41dDE4IDEwMy41cTAgMTg1IC0xMzEuNSAzMTYuNXQtMzE2LjUgMTMxLjV0LTMxNi41IC0xMzEuNXQtMTMxLjUgLTMxNi41cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1cTAgMTE3IDQ1LjUgMjIzLjV0MTIzIDE4NHQxODQgMTIzdDIyMy41IDQ1LjV0MjIzLjUgLTQ1LjV0MTg0IC0xMjN0MTIzIC0xODR0NDUuNSAtMjIzLjV6TTg5NiA1NzZxMCAtMjYgLTE5IC00NXQtNDUgLTE5dC00NSAxOXQtMTkgNDV0MTkgNDUgdDQ1IDE5dDQ1IC0xOXQxOSAtNDV6TTExODQgNzA0cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1cTAgOTMgLTY1LjUgMTU4LjV0LTE1OC41IDY1LjVxLTkyIDAgLTE1OCAtNjUuNXQtNjYgLTE1OC41cTAgLTI2IC0xOSAtNDV0LTQ1IC0xOXQtNDUgMTl0LTE5IDQ1cTAgMTQ2IDEwMyAyNDl0MjQ5IDEwM3QyNDkgLTEwM3QxMDMgLTI0OXpNMTU3OCA5OTNxMTAgLTI1IC0xIC00OXQtMzYgLTM0cS05IC00IC0yMyAtNCBxLTE5IDAgLTM1LjUgMTF0LTIzLjUgMzBxLTY4IDE3OCAtMjI0IDI5NXEtMjEgMTYgLTI1IDQydDEyIDQ3cTE3IDIxIDQzIDI1dDQ3IC0xMnExODMgLTEzNyAyNjYgLTM1MXpNMTc4OCAxMDc0cTkgLTI1IC0xLjUgLTQ5dC0zNS41IC0zNHEtMTEgLTQgLTIzIC00cS00NCAwIC02MCA0MXEtOTIgMjM4IC0yOTcgMzkzcS0yMiAxNiAtMjUuNSA0MnQxMi41IDQ3cTE2IDIyIDQyIDI1LjV0NDcgLTEyLjVxMjM1IC0xNzUgMzQxIC00NDl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYTM7IiBob3Jpei1hZHYteD0iMjMwNCIgZD0iTTEwMzIgNTc2cS01OSAyIC04NCA1NXEtMTcgMzQgLTQ4IDUzLjV0LTY4IDE5LjVxLTUzIDAgLTkwLjUgLTM3LjV0LTM3LjUgLTkwLjVxMCAtNTYgMzYgLTg5bDEwIC04cTM0IC0zMSA4MiAtMzFxMzcgMCA2OCAxOS41dDQ4IDUzLjVxMjUgNTMgODQgNTV6TTE2MDAgNzA0cTAgNTYgLTM2IDg5bC0xMCA4cS0zNCAzMSAtODIgMzFxLTM3IDAgLTY4IC0xOS41dC00OCAtNTMuNXEtMjUgLTUzIC04NCAtNTVxNTkgLTIgODQgLTU1IHExNyAtMzQgNDggLTUzLjV0NjggLTE5LjVxNTMgMCA5MC41IDM3LjV0MzcuNSA5MC41ek0xMTc0IDkyNXEtMTcgLTM1IC01NSAtNDh0LTczIDRxLTYyIDMxIC0xMzQgMzFxLTUxIDAgLTk5IC0xN3EzIDAgOS41IDAuNXQ5LjUgMC41cTkyIDAgMTcwLjUgLTUwdDExOC41IC0xMzNxMTcgLTM2IDMuNSAtNzMuNXQtNDkuNSAtNTQuNXEtMTggLTkgLTM5IC05cTIxIDAgMzkgLTlxMzYgLTE3IDQ5LjUgLTU0LjV0LTMuNSAtNzMuNSBxLTQwIC04MyAtMTE4LjUgLTEzM3QtMTcwLjUgLTUwaC02cS0xNiAyIC00NCA0bC0yOTAgMjdsLTIzOSAtMTIwcS0xNCAtNyAtMjkgLTdxLTQwIDAgLTU3IDM1bC0xNjAgMzIwcS0xMSAyMyAtNCA0Ny41dDI5IDM3LjVsMjA5IDExOWwxNDggMjY3cTE3IDE1NSA5MS41IDI5MS41dDE5NS41IDIzNi41cTMxIDI1IDcwLjUgMjEuNXQ2NC41IC0zNC41dDIxLjUgLTcwdC0zNC41IC02NXEtNzAgLTU5IC0xMTcgLTEyOHExMjMgODQgMjY3IDEwMSBxNDAgNSA3MS41IC0xOXQzNS41IC02NHE1IC00MCAtMTkgLTcxLjV0LTY0IC0zNS41cS04NCAtMTAgLTE1OSAtNTVxNDYgMTAgOTkgMTBxMTE1IDAgMjE4IC01MHEzNiAtMTggNDkgLTU1LjV0LTUgLTczLjV6TTIxMzcgMTA4NWwxNjAgLTMyMHExMSAtMjMgNCAtNDcuNXQtMjkgLTM3LjVsLTIwOSAtMTE5bC0xNDggLTI2N3EtMTcgLTE1NSAtOTEuNSAtMjkxLjV0LTE5NS41IC0yMzYuNXEtMjYgLTIyIC02MSAtMjJxLTQ1IDAgLTc0IDM1IHEtMjUgMzEgLTIxLjUgNzB0MzQuNSA2NXE3MCA1OSAxMTcgMTI4cS0xMjMgLTg0IC0yNjcgLTEwMXEtNCAtMSAtMTIgLTFxLTM2IDAgLTYzLjUgMjR0LTMxLjUgNjBxLTUgNDAgMTkgNzEuNXQ2NCAzNS41cTg0IDEwIDE1OSA1NXEtNDYgLTEwIC05OSAtMTBxLTExNSAwIC0yMTggNTBxLTM2IDE4IC00OSA1NS41dDUgNzMuNXExNyAzNSA1NSA0OHQ3MyAtNHE2MiAtMzEgMTM0IC0zMXE1MSAwIDk5IDE3cS0zIDAgLTkuNSAtMC41dC05LjUgLTAuNSBxLTkyIDAgLTE3MC41IDUwdC0xMTguNSAxMzNxLTE3IDM2IC0zLjUgNzMuNXQ0OS41IDU0LjVxMTggOSAzOSA5cS0yMSAwIC0zOSA5cS0zNiAxNyAtNDkuNSA1NC41dDMuNSA3My41cTQwIDgzIDExOC41IDEzM3QxNzAuNSA1MGg2aDFxMTQgLTIgNDIgLTRsMjkxIC0yN2wyMzkgMTIwcTE0IDcgMjkgN3E0MCAwIDU3IC0zNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhNDsiIGhvcml6LWFkdi14PSIxNzkyIiBkPSJNMTA1NiA3MDRxMCAtMjYgMTkgLTQ1dDQ1IC0xOXQ0NSAxOXQxOSA0NXEwIDE0NiAtMTAzIDI0OXQtMjQ5IDEwM3QtMjQ5IC0xMDN0LTEwMyAtMjQ5cTAgLTI2IDE5IC00NXQ0NSAtMTl0NDUgMTl0MTkgNDVxMCA5MyA2NiAxNTguNXQxNTggNjUuNXQxNTggLTY1LjV0NjYgLTE1OC41ek04MzUgMTI4MHEtMTE3IDAgLTIyMy41IC00NS41dC0xODQgLTEyM3QtMTIzIC0xODR0LTQ1LjUgLTIyMy41cTAgLTI2IDE5IC00NXQ0NSAtMTl0NDUgMTkgdDE5IDQ1cTAgMTg1IDEzMS41IDMxNi41dDMxNi41IDEzMS41dDMxNi41IC0xMzEuNXQxMzEuNSAtMzE2LjVxMCAtNTUgLTE4IC0xMDMuNXQtMzcuNSAtNzQuNXQtNTkuNSAtNzJxLTM0IC0zOSAtNTIgLTYzdC00My41IC02Ni41dC0zNyAtOTF0LTExLjUgLTEwNS41cTAgLTEwNiAtNzUgLTE4MXQtMTgxIC03NXEtMjYgMCAtNDUgLTE5dC0xOSAtNDV0MTkgLTQ1dDQ1IC0xOXExNTkgMCAyNzEuNSAxMTIuNXQxMTIuNSAyNzEuNXEwIDQxIDcuNSA3NCB0MjYuNSA2NHQzMy41IDUwdDQ1LjUgNTRxMzUgNDEgNTMgNjQuNXQ0NCA2Ny41dDM3LjUgOTMuNXQxMS41IDEwOC41cTAgMTE3IC00NS41IDIyMy41dC0xMjMgMTg0dC0xODQgMTIzdC0yMjMuNSA0NS41ek01OTEgNTYxbDIyNiAtMjI2bC01NzkgLTU3OXEtMTIgLTEyIC0yOSAtMTJ0LTI5IDEybC0xNjggMTY4cS0xMiAxMiAtMTIgMjl0MTIgMjl6TTE2MTIgMTUyNGwxNjggLTE2OHExMiAtMTIgMTIgLTI5dC0xMiAtMzBsLTIzMyAtMjMzIGwtMjYgLTI1bC03MSAtNzFxLTY2IDE1MyAtMTk1IDI1OGw5MSA5MWwyMDcgMjA3cTEzIDEyIDMwIDEydDI5IC0xMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhNTsiIGQ9Ik04NjYgMTAyMXEwIC0yNyAtMTMgLTk0cS0xMSAtNTAgLTMxLjUgLTE1MHQtMzAuNSAtMTUwcS0yIC0xMSAtNC41IC0xMi41dC0xMy41IC0yLjVxLTIwIC0yIC0zMSAtMnEtNTggMCAtODQgNDkuNXQtMjYgMTEzLjVxMCA4OCAzNSAxNzR0MTAzIDEyNHEyOCAxNCA1MSAxNHEyOCAwIDM2LjUgLTE2LjV0OC41IC00Ny41ek0xMzUyIDU5N3EwIDE0IC0zOSA3NS41dC01MiA2Ni41cS0yMSA4IC0zNCA4cS05MSAwIC0yMjYgLTc3bC0yIDIgcTMgMjIgMjcuNSAxMzV0MjQuNSAxNzhxMCAyMzMgLTI0MiAyMzNxLTI0IDAgLTY4IC02cS05NCAtMTcgLTE2OC41IC04OS41dC0xMTEuNSAtMTY2LjV0LTM3IC0xODlxMCAtMTQ2IDgwLjUgLTIyNXQyMjcuNSAtNzlxMjUgMCAyNSAtM3QtMSAtNXEtNCAtMzQgLTI2IC0xMTdxLTE0IC01MiAtNTEuNSAtMTAxdC04Mi41IC00OXEtNDIgMCAtNDIgNDdxMCAyNCAxMC41IDQ3LjV0MjUgMzkuNXQyOS41IDI4LjV0MjYgMjB0MTEgOC41cTAgMyAtNyAxMCBxLTI0IDIyIC01OC41IDM2LjV0LTY1LjUgMTQuNXEtMzUgMCAtNjMuNSAtMzR0LTQxIC03NXQtMTIuNSAtNzVxMCAtODggNTEuNSAtMTQydDEzOC41IC01NHE4MiAwIDE1NSA1M3QxMTcuNSAxMjZ0NjUuNSAxNTNxNiAyMiAxNS41IDY2LjV0MTQuNSA2Ni41cTMgMTIgMTQgMThxMTE4IDYwIDIyNyA2MHE0OCAwIDEyNyAtMThxMSAtMSA0IC0xcTUgMCA5LjUgNC41dDQuNSA4LjV6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjUgdC0yMDMuNSAtODQuNWgtOTYwcS0xMTkgMCAtMjAzLjUgODQuNXQtODQuNSAyMDMuNXY5NjBxMCAxMTkgODQuNSAyMDMuNXQyMDMuNSA4NC41aDk2MHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhNjsiIGhvcml6LWFkdi14PSIxNTM1IiBkPSJNNzQ0IDEyMzFxMCAyNCAtMiAzOC41dC04LjUgMzB0LTIxIDIzdC0zNy41IDcuNXEtMzkgMCAtNzggLTIzcS0xMDUgLTU4IC0xNTkgLTE5MC41dC01NCAtMjY5LjVxMCAtNDQgOC41IC04NS41dDI2LjUgLTgwLjV0NTIuNSAtNjIuNXQ4MS41IC0yMy41cTQgMCAxOCAtMC41dDIwIDB0MTYgM3QxNSA4LjV0NyAxNnExNiA3NyA0OCAyMzEuNXQ0OCAyMzEuNXExOSA5MSAxOSAxNDZ6TTE0OTggNTc1cTAgLTcgLTcuNSAtMTMuNXQtMTUuNSAtNi41IGwtNiAxcS0yMiAzIC02MiAxMXQtNzIgMTIuNXQtNjMgNC41cS0xNjcgMCAtMzUxIC05M3EtMTUgLTggLTIxIC0yN3EtMTAgLTM2IC0yNC41IC0xMDUuNXQtMjIuNSAtMTAwLjVxLTIzIC05MSAtNzAgLTE3OS41dC0xMTIuNSAtMTY0LjV0LTE1NC41IC0xMjN0LTE4NSAtNDdxLTEzNSAwIC0yMTQuNSA4My41dC03OS41IDIxOS41cTAgNTMgMTkuNSAxMTd0NjMgMTE2LjV0OTcuNSA1Mi41cTM4IDAgMTIwIC0zMy41dDgzIC02MS41IHEwIC0xIC0xNi41IC0xMi41dC0zOS41IC0zMXQtNDYgLTQ0LjV0LTM5IC02MXQtMTYgLTc0cTAgLTMzIDE2LjUgLTUzdDQ4LjUgLTIwcTQ1IDAgODUgMzEuNXQ2Ni41IDc4dDQ4IDEwNS41dDMyLjUgMTA3dDE2IDkwdjlxMCAyIC0zLjUgMy41dC04LjUgMS41aC0xMHQtMTAgLTAuNXQtNiAtMC41cS0yMjcgMCAtMzUyIDEyMi41dC0xMjUgMzQ4LjVxMCAxMDggMzQuNSAyMjF0OTYgMjEwdDE1NiAxNjcuNXQyMDQuNSA4OS41cTUyIDkgMTA2IDkgcTM3NCAwIDM3NCAtMzYwcTAgLTk4IC0zOCAtMjczdC00MyAtMjExbDMgLTNxMTAxIDU3IDE4Mi41IDg4dDE2Ny41IDMxcTIyIDAgNTMgLTEzcTE5IC03IDgwIC0xMDIuNXQ2MSAtMTE2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYTc7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTgzMSA4NjNxMzIgMCA1OSAtMThsMjIyIC0xNDhxNjEgLTQwIDExMCAtOTdsMTQ2IC0xNzBxNDAgLTQ2IDI5IC0xMDZsLTcyIC00MTNxLTYgLTMyIC0yOS41IC01My41dC01NS41IC0yNS41bC01MjcgLTU2bC0zNTIgLTMyaC05cS0zOSAwIC02Ny41IDI4dC0yOC41IDY4cTAgMzcgMjcgNjR0NjUgMzJsMjYwIDMyaC00NDhxLTQxIDAgLTY5LjUgMzB0LTI2LjUgNzFxMiAzOSAzMiA2NXQ2OSAyNmw0NDIgMWwtNTIxIDY0cS00MSA1IC02NiAzNyB0LTE5IDczcTYgMzUgMzQuNSA1Ny41dDY1LjUgMjIuNWgxMGw0ODEgLTYwbC0zNTEgOTRxLTM4IDEwIC02MiA0MS41dC0xOCA2OC41cTYgMzYgMzMgNTguNXQ2MiAyMi41cTYgMCAyMCAtMmw0NDggLTk2bDIxNyAtMzdxMSAwIDMgLTAuNXQzIC0wLjVxMjMgMCAzMC41IDIzdC0xMi41IDM2bC0xODYgMTI1cS0zNSAyMyAtNDIgNjMuNXQxOCA3My41cTI3IDM4IDc2IDM4ek03NjEgNjYxbDE4NiAtMTI1bC0yMTggMzdsLTUgMmwtMzYgMzggbC0yMzggMjYycS0xIDEgLTIuNSAzLjV0LTIuNSAzLjVxLTI0IDMxIC0xOC41IDcwdDM3LjUgNjRxMzEgMjMgNjggMTcuNXQ2NCAtMzMuNWwxNDIgLTE0N2wtNCAtNHQtNSAtNHEtMzIgLTQ1IC0yMyAtOTl0NTUgLTg1ek0xNjQ4IDExMTVsMTUgLTI2NnE0IC03MyAtMTEgLTE0N2wtNDggLTIxOXEtMTIgLTU5IC02NyAtODdsLTEwNiAtNTRxMiA2MiAtMzkgMTA5bC0xNDYgMTcwcS01MyA2MSAtMTE3IDEwM2wtMjIyIDE0OHEtMzQgMjMgLTc2IDIzIHEtNTEgMCAtODggLTM3bC0yMzUgMzEycS0yNSAzMyAtMTggNzMuNXQ0MSA2My41cTMzIDIyIDcxLjUgMTR0NjIuNSAtNDBsMjY2IC0zNTJsLTI2MiA0NTVxLTIxIDM1IC0xMC41IDc1dDQ3LjUgNTlxMzUgMTggNzIuNSA2dDU3LjUgLTQ2bDI0MSAtNDIwbC0xMzYgMzM3cS0xNSAzNSAtNC41IDc0dDQ0LjUgNTZxMzcgMTkgNzYgNnQ1NiAtNTFsMTkzIC00MTVsMTAxIC0xOTZxOCAtMTUgMjMgLTE3LjV0MjcgNy41dDExIDI2bC0xMiAyMjQgcS0yIDQxIDI2IDcxdDY5IDMxcTM5IDAgNjcgLTI4LjV0MzAgLTY3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYTg7IiBob3Jpei1hZHYteD0iMTc5MiIgZD0iTTMzNSAxODBxLTIgMCAtNiAycS04NiA1NyAtMTY4LjUgMTQ1dC0xMzkuNSAxODBxLTIxIDMwIC0yMSA2OXEwIDkgMiAxOXQ0IDE4dDcgMTh0OC41IDE2dDEwLjUgMTd0MTAgMTV0MTIgMTUuNXQxMSAxNC41cTE4NCAyNTEgNDUyIDM2NXEtMTEwIDE5OCAtMTEwIDIxMXEwIDE5IDE3IDI5cTExNiA2NCAxMjggNjRxMTggMCAyOCAtMTZsMTI0IC0yMjlxOTIgMTkgMTkyIDE5cTI2NiAwIDQ5Ny41IC0xMzcuNXQzNzguNSAtMzY5LjUgcTIwIC0zMSAyMCAtNjl0LTIwIC02OXEtOTEgLTE0MiAtMjE4LjUgLTI1My41dC0yNzguNSAtMTc1LjVxMTEwIC0xOTggMTEwIC0yMTFxMCAtMjAgLTE3IC0yOXEtMTE2IC02NCAtMTI3IC02NHEtMTkgMCAtMjkgMTZsLTEyNCAyMjlsLTY0IDExOWwtNDQ0IDgyMGw3IDdxLTU4IC0yNCAtOTkgLTQ3cTMgLTUgMTI3IC0yMzR0MjQzIC00NDl0MTE5IC0yMjNxMCAtNyAtOSAtOXEtMTMgLTMgLTcyIC0zcS01NyAwIC02MCA3bC00NTYgODQxIHEtMzkgLTI4IC04MiAtNjhxMjQgLTQzIDIxNCAtMzkzLjV0MTkwIC0zNTQuNXEwIC0xMCAtMTEgLTEwcS0xNCAwIC04Mi41IDIydC03Mi41IDI4bC0xMDYgMTk3bC0yMjQgNDEzcS00NCAtNTMgLTc4IC0xMDZxMiAtMyAxOCAtMjV0MjMgLTM0bDE3NiAtMzI3cTAgLTEwIC0xMCAtMTB6TTExNjUgMjgybDQ5IC05MXEyNzMgMTExIDQ1MCAzODVxLTE4MCAyNzcgLTQ1OSAzODlxNjcgLTY0IDEwMyAtMTQ4LjV0MzYgLTE3Ni41IHEwIC0xMDYgLTQ3IC0yMDAuNXQtMTMyIC0xNTcuNXpNODQ4IDg5NnEwIC0yMCAxNCAtMzR0MzQgLTE0cTg2IDAgMTQ3IC02MXQ2MSAtMTQ3cTAgLTIwIDE0IC0zNHQzNCAtMTR0MzQgMTR0MTQgMzRxMCAxMjYgLTg5IDIxNXQtMjE1IDg5cS0yMCAwIC0zNCAtMTR0LTE0IC0zNHpNMTIxNCA5NjFsLTkgNGw3IC03eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmE5OyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik0xMDUwIDQzMHEwIC0yMTUgLTE0NyAtMzc0cS0xNDggLTE2MSAtMzc4IC0xNjFxLTIzMiAwIC0zNzggMTYxcS0xNDcgMTU5IC0xNDcgMzc0cTAgMTQ3IDY4IDI3MC41dDE4OSAxOTYuNXQyNjggNzNxOTYgMCAxODIgLTMxcS0zMiAtNjIgLTM5IC0xMjZxLTY2IDI4IC0xNDMgMjhxLTE2NyAwIC0yODAuNSAtMTIzdC0xMTMuNSAtMjkxcTAgLTE3MCAxMTIuNSAtMjg4LjV0MjgxLjUgLTExOC41dDI4MSAxMTguNXQxMTIgMjg4LjUgcTAgODkgLTMyIDE2NnE2NiAxMyAxMjMgNDlxNDEgLTk4IDQxIC0yMTJ6TTg0NiA2MTlxMCAtMTkyIC03OS41IC0zNDV0LTIzOC41IC0yNTNsLTE0IC0xcS0yOSAwIC02MiA1cTgzIDMyIDE0Ni41IDEwMi41dDk5LjUgMTU0LjV0NTguNSAxODl0MzAgMTkyLjV0Ny41IDE3OC41cTAgNjkgLTMgMTAzcTU1IC0xNjAgNTUgLTMyNnpNNzkxIDk0N3YtMnEtNzMgMjE0IC0yMDYgNDQwcTg4IC01OSAxNDIuNSAtMTg2LjV0NjMuNSAtMjUxLjV6IE0xMDM1IDc0NHEtODMgMCAtMTYwIDc1cTIxOCAxMjAgMjkwIDI0N3ExOSAzNyAyMSA1NnEtNDIgLTk0IC0xMzkuNSAtMTY2LjV0LTIwNC41IC05Ny41cS0zNSA1NCAtMzUgMTEzcTAgMzcgMTcgNzl0NDMgNjhxNDYgNDQgMTU3IDc0cTU5IDE2IDEwNiA1OC41dDc0IDEwMC41cTc0IC0xMDUgNzQgLTI1M3EwIC0xMDkgLTI0IC0xNzBxLTMyIC03NyAtODguNSAtMTMwLjV0LTEzMC41IC01My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmFhOyIgZD0iTTEwNTAgNDk1cTAgNzggLTI4IDE0N3EtNDEgLTI1IC04NSAtMzRxMjIgLTUwIDIyIC0xMTRxMCAtMTE3IC03NyAtMTk4LjV0LTE5MyAtODEuNXQtMTkzLjUgODEuNXQtNzcuNSAxOTguNXEwIDExNSA3OCAxOTkuNXQxOTMgODQuNXE1MyAwIDk4IC0xOXE0IDQzIDI3IDg3cS02MCAyMSAtMTI1IDIxcS0xNTQgMCAtMjU3LjUgLTEwOC41dC0xMDMuNSAtMjYzLjV0MTAzLjUgLTI2MXQyNTcuNSAtMTA2dDI1Ny41IDEwNi41dDEwMy41IDI2MC41eiBNODcyIDg1MHEyIC0yNCAyIC03MXEwIC02MyAtNSAtMTIzdC0yMC41IC0xMzIuNXQtNDAuNSAtMTMwdC02OC41IC0xMDZ0LTEwMC41IC03MC41cTIxIC0zIDQyIC0zaDEwcTIxOSAxMzkgMjE5IDQxMXEwIDExNiAtMzggMjI1ek04NzIgODUwcS00IDgwIC00NCAxNzEuNXQtOTggMTMwLjVxOTIgLTE1NiAxNDIgLTMwMnpNMTIwNyA5NTVxMCAxMDIgLTUxIDE3NHEtNDEgLTg2IC0xMjQgLTEwOXEtNjkgLTE5IC0xMDkgLTUzLjV0LTQwIC05OS41IHEwIC00MCAyNCAtNzdxNzQgMTcgMTQwLjUgNjd0OTUuNSAxMTVxLTQgLTUyIC03NC41IC0xMTEuNXQtMTM4LjUgLTk3LjVxNTIgLTUyIDExMCAtNTJxNTEgMCA5MCAzN3Q2MCA5MHExNyA0MyAxNyAxMTd6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwcTExOSAwIDIwMy41IC04NC41IHQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhYjsiIGQ9Ik0xMjc5IDM4OHEwIDIyIC0yMiAyN3EtNjcgMTUgLTExOCA1OXQtODAgMTA4cS03IDE5IC03IDI1cTAgMTUgMTkuNSAyNnQ0MyAxN3Q0MyAyMC41dDE5LjUgMzYuNXEwIDE5IC0xOC41IDMxLjV0LTM4LjUgMTIuNXEtMTIgMCAtMzIgLTh0LTMxIC04cS00IDAgLTEyIDJxNSA5NSA1IDExNHEwIDc5IC0xNyAxMTRxLTM2IDc4IC0xMDMgMTIxLjV0LTE1MiA0My41cS0xOTkgMCAtMjc1IC0xNjVxLTE3IC0zNSAtMTcgLTExNHEwIC0xOSA1IC0xMTQgcS00IC0yIC0xNCAtMnEtMTIgMCAtMzIgNy41dC0zMCA3LjVxLTIxIDAgLTM4LjUgLTEydC0xNy41IC0zMnEwIC0yMSAxOS41IC0zNS41dDQzIC0yMC41dDQzIC0xN3QxOS41IC0yNnEwIC02IC03IC0yNXEtNjQgLTEzOCAtMTk4IC0xNjdxLTIyIC01IC0yMiAtMjdxMCAtNDYgMTM3IC02OHEyIC01IDYgLTI2dDExLjUgLTMwLjV0MjMuNSAtOS41cTEyIDAgMzcuNSA0LjV0MzkuNSA0LjVxMzUgMCA2NyAtMTV0NTQgLTMyLjV0NTcuNSAtMzIuNSB0NzYuNSAtMTVxNDMgMCA3OSAxNXQ1Ny41IDMyLjV0NTMuNSAzMi41dDY3IDE1cTE0IDAgMzkuNSAtNHQzOC41IC00cTE2IDAgMjMgMTB0MTEgMzB0NiAyNXExMzcgMjIgMTM3IDY4ek0xNTM2IDY0MHEwIC0yMDkgLTEwMyAtMzg1LjV0LTI3OS41IC0yNzkuNXQtMzg1LjUgLTEwM3QtMzg1LjUgMTAzdC0yNzkuNSAyNzkuNXQtMTAzIDM4NS41dDEwMyAzODUuNXQyNzkuNSAyNzkuNXQzODUuNSAxMDN0Mzg1LjUgLTEwM3QyNzkuNSAtMjc5LjUgdDEwMyAtMzg1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYWM7IiBob3Jpei1hZHYteD0iMTY2NCIgZD0iTTg0OCAxNDA4cTEzNCAxIDI0MC41IC02OC41dDE2My41IC0xOTIuNXEyNyAtNTggMjcgLTE3OXEwIC00NyAtOSAtMTkxcTE0IC03IDI4IC03cTE4IDAgNTEgMTMuNXQ1MSAxMy41cTI5IDAgNTYgLTE4dDI3IC00NnEwIC0zMiAtMzEuNSAtNTR0LTY5IC0zMS41dC02OSAtMjl0LTMxLjUgLTQ3LjVxMCAtMTUgMTIgLTQzcTM3IC04MiAxMDIuNSAtMTUwdDE0NC41IC0xMDFxMjggLTEyIDgwIC0yM3EyOCAtNiAyOCAtMzUgcTAgLTcwIC0yMTkgLTEwM3EtNyAtMTEgLTExIC0zOXQtMTQgLTQ2LjV0LTMzIC0xOC41cS0yMCAwIC02MiA2LjV0LTY0IDYuNXEtMzcgMCAtNjIgLTVxLTMyIC01IC02MyAtMjIuNXQtNTggLTM4dC01OCAtNDAuNXQtNzYgLTMzLjV0LTk5IC0xMy41cS01MiAwIC05Ni41IDEzLjV0LTc1IDMzLjV0LTU3LjUgNDAuNXQtNTggMzh0LTYyIDIyLjVxLTI2IDUgLTYzIDVxLTI0IDAgLTY1LjUgLTcuNXQtNTguNSAtNy41cS0yNSAwIC0zNSAxOC41IHQtMTQgNDcuNXQtMTEgNDBxLTIxOSAzMyAtMjE5IDEwM3EwIDI5IDI4IDM1cTUyIDExIDgwIDIzcTc4IDMyIDE0NC41IDEwMXQxMDIuNSAxNTBxMTIgMjggMTIgNDNxMCAyOCAtMzEuNSA0Ny41dC02OS41IDI5LjV0LTY5LjUgMzEuNXQtMzEuNSA1Mi41cTAgMjcgMjYgNDUuNXQ1NSAxOC41cTE1IDAgNDggLTEzdDUzIC0xM3ExOCAwIDMyIDdxLTkgMTQyIC05IDE5MHEwIDEyMiAyNyAxODBxNjQgMTM3IDE3MiAxOTh0MjY0IDYzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmFkOyIgZD0iTTEyODAgMzg4cTAgMjIgLTIyIDI3cS02NyAxNCAtMTE4IDU4dC04MCAxMDlxLTcgMTQgLTcgMjVxMCAxNSAxOS41IDI2dDQyLjUgMTd0NDIuNSAyMC41dDE5LjUgMzYuNXEwIDE5IC0xOC41IDMxLjV0LTM4LjUgMTIuNXEtMTEgMCAtMzEgLTh0LTMyIC04cS00IDAgLTEyIDJxNSA2MyA1IDExNXEwIDc4IC0xNyAxMTRxLTM2IDc4IC0xMDIuNSAxMjEuNXQtMTUyLjUgNDMuNXEtMTk4IDAgLTI3NSAtMTY1cS0xOCAtMzggLTE4IC0xMTUgcTAgLTM4IDYgLTExNHEtMTAgLTIgLTE1IC0ycS0xMSAwIC0zMS41IDh0LTMwLjUgOHEtMjAgMCAtMzcuNSAtMTIuNXQtMTcuNSAtMzIuNXEwIC0yMSAxOS41IC0zNS41dDQyLjUgLTIwLjV0NDIuNSAtMTd0MTkuNSAtMjZxMCAtMTEgLTcgLTI1cS02NCAtMTM4IC0xOTggLTE2N3EtMjIgLTUgLTIyIC0yN3EwIC00NyAxMzggLTY5cTIgLTUgNiAtMjZ0MTEgLTMwLjV0MjMgLTkuNXExMyAwIDM4LjUgNXQzOC41IDVxMzUgMCA2Ny41IC0xNSB0NTQuNSAtMzIuNXQ1Ny41IC0zMi41dDc2LjUgLTE1cTQzIDAgNzkgMTV0NTcuNSAzMi41dDU0IDMyLjV0NjcuNSAxNXExMyAwIDM5IC00LjV0MzkgLTQuNXExNSAwIDIyLjUgOS41dDExLjUgMzF0NSAyNC41cTEzOCAyMiAxMzggNjl6TTE1MzYgMTEyMHYtOTYwcTAgLTExOSAtODQuNSAtMjAzLjV0LTIwMy41IC04NC41aC05NjBxLTExOSAwIC0yMDMuNSA4NC41dC04NC41IDIwMy41djk2MHEwIDExOSA4NC41IDIwMy41dDIwMy41IDg0LjVoOTYwIHExMTkgMCAyMDMuNSAtODQuNXQ4NC41IC0yMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJhZTsiIGhvcml6LWFkdi14PSIyMzA0IiBkPSJNMjMwNCAxNTM2cS02OSAtNDYgLTEyNSAtOTJ0LTg5IC04MXQtNTkuNSAtNzEuNXQtMzcuNSAtNTcuNXQtMjIgLTQ0LjV0LTE0IC0yOS41cS0xMCAtMTggLTM1LjUgLTEzNi41dC00OC41IC0xNjQuNXEtMTUgLTI5IC01MCAtNjAuNXQtNjcuNSAtNTAuNXQtNzIuNSAtNDF0LTQ4IC0yOHEtNDcgLTMxIC0xNTEgLTIzMXEtMzQxIDE0IC02MzAgLTE1OHEtOTIgLTUzIC0zMDMgLTE3OXE0NyAxNiA4NiAzMXQ1NSAyMmwxNSA3IHE3MSAyNyAxNjMgNjQuNXQxMzMuNSA1My41dDEwOCAzNC41dDE0Mi41IDMxLjVxMTg2IDMxIDQ2NSAtN3ExIDAgMTAgLTNxMTEgLTYgMTQgLTE3dC0zIC0yMmwtMTk0IC0zNDVxLTE1IC0yOSAtNDcgLTIycS0xMjggMjQgLTM1NCAyNHEtMTQ2IDAgLTQwMiAtNDQuNXQtMzkyIC00Ni41cS04MiAtMSAtMTQ5IDEzdC0xMDcgMzd0LTYxIDQwdC0zMyAzNGwtMSAxdjJxMCA2IDYgNnExMzggMCAzNzEgNTVxMTkyIDM2NiAzNzQuNSA1MjR0MzgzLjUgMTU4IHE1IDAgMTQuNSAtMC41dDM4IC01dDU1IC0xMnQ2MS41IC0yNC41dDYzIC0zOS41dDU0IC01OXQ0MCAtODIuNWwxMDIgMTc3cTIgNCAyMSA0Mi41dDQ0LjUgODYuNXQ2MSAxMDkuNXQ4NCAxMzMuNXQxMDAuNSAxMzdxNjYgODIgMTI4IDE0MS41dDEyMS41IDk2LjV0OTIuNSA1My41dDg4IDM5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYjA7IiBkPSJNMTMyMiA2NDBxMCAtNDUgLTUgLTc2bC0yMzYgMTRsMjI0IC03OHEtMTkgLTczIC01OCAtMTQxbC0yMTQgMTAzbDE3NyAtMTU4cS00NCAtNjEgLTEwNyAtMTA4bC0xNTcgMTc4bDEwMyAtMjE1cS02MSAtMzcgLTE0MCAtNTlsLTc5IDIyOGwxNCAtMjQwcS0zOCAtNiAtNzYgLTZ0LTc2IDZsMTQgMjM4bC03OCAtMjI2cS03NCAxOSAtMTQwIDU5bDEwMyAyMTVsLTE1NyAtMTc4cS01OSA0MyAtMTA4IDEwOGwxNzggMTU4bC0yMTQgLTEwNCBxLTM5IDY5IC01OCAxNDFsMjI0IDc5bC0yMzcgLTE0cS01IDQyIC01IDc2cTAgMzUgNSA3N2wyMzggLTE0bC0yMjUgNzlxMTkgNzMgNTggMTQwbDIxNCAtMTA0bC0xNzcgMTU5cTQ2IDYxIDEwNyAxMDhsMTU4IC0xNzhsLTEwMyAyMTVxNjcgMzkgMTQwIDU4bDc3IC0yMjRsLTEzIDIzNnEzNiA2IDc1IDZxMzggMCA3NiAtNmwtMTQgLTIzN2w3OCAyMjVxNzQgLTE5IDE0MCAtNTlsLTEwMyAtMjE0bDE1OCAxNzhxNjEgLTQ3IDEwNyAtMTA4IGwtMTc3IC0xNTlsMjEzIDEwNHEzNyAtNjIgNTggLTE0MWwtMjI0IC03OGwyMzcgMTRxNSAtMzEgNSAtNzd6TTEzNTIgNjQwcTAgMTYwIC03OC41IDI5NS41dC0yMTMgMjE0dC0yOTIuNSA3OC41cS0xMTkgMCAtMjI3IC00Ni41dC0xODYuNSAtMTI1dC0xMjQuNSAtMTg3LjV0LTQ2IC0yMjlxMCAtMTE5IDQ2IC0yMjh0MTI0LjUgLTE4Ny41dDE4Ni41IC0xMjV0MjI3IC00Ni41cTE1OCAwIDI5Mi41IDc4LjV0MjEzIDIxNHQ3OC41IDI5NC41eiBNMTQyNSAxMDIzdi03NjZsLTY1NyAtMzgzbC02NTcgMzgzdjc2Nmw2NTcgMzgzek03NjggLTE4M2w3MDggNDEydjgyM2wtNzA4IDQxMWwtNzA4IC00MTF2LTgyM3pNMTUzNiAxMDg4di04OTZsLTc2OCAtNDQ4bC03NjggNDQ4djg5Nmw3NjggNDQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmIxOyIgaG9yaXotYWR2LXg9IjE2NjQiIGQ9Ik0zMzkgMTMxOGg2OTFsLTI2IC03MmgtNjY1cS0xMTAgMCAtMTg4LjUgLTc5dC03OC41IC0xODl2LTc3MXEwIC05NSA2MC41IC0xNjkuNXQxNTMuNSAtOTMuNXEyMyAtNSA5OCAtNXYtNzJoLTQ1cS0xNDAgMCAtMjM5LjUgMTAwdC05OS41IDI0MHY3NzFxMCAxNDAgOTkuNSAyNDB0MjM5LjUgMTAwek0xMTkwIDE1MzZoMjQ3bC00ODIgLTEyOTRxLTIzIC02MSAtNDAuNSAtMTAzLjV0LTQ1IC05OHQtNTQgLTkzLjV0LTY0LjUgLTc4LjUgdC03OS41IC02NXQtOTUuNSAtNDF0LTExNiAtMTguNXYxOTVxMTYzIDI2IDIyMCAxODJxMjAgNTIgMjAgMTA1cTAgNTQgLTIwIDEwNmwtMjg1IDczM2gyMjhsMTg3IC01ODV6TTE2NjQgOTc4di0xMTExaC03OTVxMzcgNTUgNDUgNzNoNjc4djEwMzhxMCA4NSAtNDkuNSAxNTV0LTEyOS41IDk5bDI1IDY3cTEwMSAtMzQgMTYzLjUgLTEyMy41dDYyLjUgLTE5Ny41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmIyOyIgaG9yaXotYWR2LXg9IjE3OTIiIGQ9Ik04NTIgMTIyN3EwIC0yOSAtMTcgLTUyLjV0LTQ1IC0yMy41dC00NSAyMy41dC0xNyA1Mi41dDE3IDUyLjV0NDUgMjMuNXQ0NSAtMjMuNXQxNyAtNTIuNXpNNjg4IC0xNDl2MTE0cTAgMzAgLTIwLjUgNTEuNXQtNTAuNSAyMS41dC01MCAtMjEuNXQtMjAgLTUxLjV2LTExNHEwIC0zMCAyMC41IC01MnQ0OS41IC0yMnEzMCAwIDUwLjUgMjJ0MjAuNSA1MnpNODYwIC0xNDl2MTE0cTAgMzAgLTIwIDUxLjV0LTUwIDIxLjV0LTUwLjUgLTIxLjUgdC0yMC41IC01MS41di0xMTRxMCAtMzAgMjAuNSAtNTJ0NTAuNSAtMjJxMjkgMCA0OS41IDIydDIwLjUgNTJ6TTEwMzQgLTE0OXYxMTRxMCAzMCAtMjAuNSA1MS41dC01MC41IDIxLjV0LTUwLjUgLTIxLjV0LTIwLjUgLTUxLjV2LTExNHEwIC0zMCAyMC41IC01MnQ1MC41IC0yMnQ1MC41IDIydDIwLjUgNTJ6TTEyMDggLTE0OXYxMTRxMCAzMCAtMjAuNSA1MS41dC01MC41IDIxLjV0LTUwLjUgLTIxLjV0LTIwLjUgLTUxLjV2LTExNCBxMCAtMzAgMjAuNSAtNTJ0NTAuNSAtMjJ0NTAuNSAyMnQyMC41IDUyek0xNDc2IDUzNXEtODQgLTE2MCAtMjMyIC0yNTkuNXQtMzIzIC05OS41cS0xMjMgMCAtMjI5LjUgNTEuNXQtMTc4LjUgMTM3dC0xMTMgMTk3LjV0LTQxIDIzMnEwIDg4IDIxIDE3NHEtMTA0IC0xNzUgLTEwNCAtMzkwcTAgLTE2MiA2NSAtMzEydDE4NSAtMjUxcTMwIDU3IDkxIDU3cTU2IDAgODYgLTUwcTMyIDUwIDg3IDUwcTU2IDAgODYgLTUwcTMyIDUwIDg3IDUwdDg3IC01MCBxMzAgNTAgODYgNTBxMjggMCA1Mi41IC0xNS41dDM3LjUgLTQwLjVxMTEyIDk0IDE3NyAyMzEuNXQ3MyAyODcuNXpNMTMyNiA1NjRxMCA3NSAtNzIgNzVxLTE3IDAgLTQ3IC02cS05NSAtMTkgLTE0OSAtMTlxLTIyNiAwIC0yMjYgMjQzcTAgODYgMzAgMjA0cS04MyAtMTI3IC04MyAtMjc1cTAgLTE1MCA4OSAtMjYwLjV0MjM1IC0xMTAuNXExMTEgMCAyMTAgNzBxMTMgNDggMTMgNzl6TTg4NCAxMjIzcTAgNTAgLTMyIDg5LjV0LTgxIDM5LjUgdC04MSAtMzkuNXQtMzIgLTg5LjVxMCAtNTEgMzEuNSAtOTAuNXQ4MS41IC0zOS41dDgxLjUgMzkuNXQzMS41IDkwLjV6TTE1MTMgODg0cTAgOTYgLTM3LjUgMTc5dC0xMTMgMTM3dC0xNzMuNSA1NHEtNzcgMCAtMTQ5IC0zNXQtMTI3IC05NHEtNDggLTE1OSAtNDggLTI2OHEwIC0xMDQgNDUuNSAtMTU3dDE0Ny41IC01M3E1MyAwIDE0MiAxOXEzNiA2IDUzIDZxNTEgMCA3Ny41IC0yOHQyNi41IC04MHEwIC0yNiAtNCAtNDYgcTc1IDY4IDExNy41IDE2NS41dDQyLjUgMjAwLjV6TTE3OTIgNjY3cTAgLTExMSAtMzMuNSAtMjQ5LjV0LTkzLjUgLTIwNC41cS01OCAtNjQgLTE5NSAtMTQyLjV0LTIyOCAtMTA0LjVsLTQgLTF2LTExNHEwIC00MyAtMjkuNSAtNzV0LTcyLjUgLTMycS01NiAwIC04NiA1MHEtMzIgLTUwIC04NyAtNTB0LTg3IDUwcS0zMCAtNTAgLTg2IC01MHEtNTUgMCAtODcgNTBxLTMwIC01MCAtODYgLTUwcS00NyAwIC03NSAzMy41dC0yOCA4MS41IHEtOTAgLTY4IC0xOTggLTY4cS0xMTggMCAtMjExIDgwcTU0IDEgMTA2IDIwcS0xMTMgMzEgLTE4MiAxMjdxMzIgLTcgNzEgLTdxODkgMCAxNjQgNDZxLTE5MiAxOTIgLTI0MCAzMDZxLTI0IDU2IC0yNCAxNjBxMCA1NyA5IDEyNS41dDMxLjUgMTQ2LjV0NTUgMTQxdDg2LjUgMTA1dDEyMCA0MnE1OSAwIDgxIC01MnExOSAyOSA0MiA1NHEyIDMgMTIgMTN0MTMgMTZxMTAgMTUgMjMgMzh0MjUgNDJ0MjggMzlxODcgMTExIDIxMS41IDE3NyB0MjYwLjUgNjZxMzUgMCA2MiAtNHE1OSA2NCAxNDYgNjRxODMgMCAxNDAgLTU3cTUgLTUgNSAtMTJxMCAtNSAtNiAtMTMuNXQtMTIuNSAtMTZ0LTE2IC0xN2wtMTAuNSAtMTAuNXExNyAtNiAzNiAtMTh0MTkgLTI0cTAgLTYgLTE2IC0yNXExNTcgLTEzOCAxOTcgLTM3OHEyNSAzMCA2MCAzMHE0NSAwIDEwMCAtNDlxOTAgLTgwIDkwIC0yNzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYjM7IiBkPSJNOTE3IDYzMXEwIDMzIC02IDY0aC0zNjJ2LTEzMmgyMTdxLTEyIC03NiAtNzQuNSAtMTIwLjV0LTE0Mi41IC00NC41cS05OSAwIC0xNjkgNzEuNXQtNzAgMTcwLjV0NzAgMTcwLjV0MTY5IDcxLjVxOTMgMCAxNTMgLTU5bDEwNCAxMDFxLTEwOCAxMDAgLTI1NyAxMDBxLTE2MCAwIC0yNzIgLTExMi41dC0xMTIgLTI3MS41dDExMiAtMjcxLjV0MjcyIC0xMTIuNXExNjUgMCAyNjYuNSAxMDV0MTAxLjUgMjcwek0xMjYyIDU4NWgxMDl2MTEwIGgtMTA5djExMGgtMTEwdi0xMTBoLTExMHYtMTEwaDExMHYtMTEwaDExMHYxMTB6TTE1MzYgNjQwcTAgLTIwOSAtMTAzIC0zODUuNXQtMjc5LjUgLTI3OS41dC0zODUuNSAtMTAzdC0zODUuNSAxMDN0LTI3OS41IDI3OS41dC0xMDMgMzg1LjV0MTAzIDM4NS41dDI3OS41IDI3OS41dDM4NS41IDEwM3QzODUuNSAtMTAzdDI3OS41IC0yNzkuNXQxMDMgLTM4NS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmI0OyIgZD0iTTE1MzYgMTAyNHYtODM5cTAgLTQ4IC00OSAtNjJxLTE3NCAtNTIgLTMzOCAtNTJxLTczIDAgLTIxNS41IDI5LjV0LTIyNy41IDI5LjVxLTE2NCAwIC0zNzAgLTQ4di0zMzhoLTE2MHYxMzY4cS02MyAyNSAtMTAxIDgxdC0zOCAxMjRxMCA5MSA2NCAxNTV0MTU1IDY0dDE1NSAtNjR0NjQgLTE1NXEwIC02OCAtMzggLTEyNHQtMTAxIC04MXYtNjhxMTkwIDQ0IDM0MyA0NHE5OSAwIDE5OCAtMTVxMTQgLTIgMTExLjUgLTIyLjV0MTQ5LjUgLTIwLjUgcTc3IDAgMTY1IDE4cTExIDIgODAgMjF0ODkgMTlxMjYgMCA0NSAtMTl0MTkgLTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmI1OyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJiNjsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYjc7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmI4OyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJiOTsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYmE7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmJiOyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjJiYzsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYyYmQ7IiBob3Jpei1hZHYteD0iMTc5MiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMmJlOyIgaG9yaXotYWR2LXg9IjE3OTIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjUwMDsiIGhvcml6LWFkdi14PSIxNzkyIiAvPg0KPC9mb250Pg0KPC9kZWZzPjwvc3ZnPiA="

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,d09GRgABAAAAAWEsAA4AAAACVNwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABRAAAABwAAAAcauc6LkdERUYAAAFgAAAAHwAAACAC0gAET1MvMgAAAYAAAAA+AAAAYIg2eiNjbWFwAAABwAAAAX4AAAMCnS901Gdhc3AAAANAAAAACAAAAAj//wADZ2x5ZgAAA0gAAUM2AAId5B2Yz4BoZWFkAAFGgAAAADIAAAA2DtcA42hoZWEAAUa0AAAAHwAAACQPAwqbaG10eAABRtQAAALfAAAKgFQoF6hsb2NhAAFJtAAABqoAAAqYAo9ETG1heHAAAVBgAAAAHwAAACADDgIcbmFtZQABUIAAAAGnAAADfDGvhB1wb3N0AAFSKAAADvsAABlMFcc8A3dlYmYAAWEkAAAABgAAAAaqsFc0AAAAAQAAAADMPaLPAAAAAMtPPDAAAAAA01pbLnjaY2BkYGDgA2IJBhBgYmBkYGRaAiRZwDwGAAtuANkAeNpjYGbzYZzAwMrAwtLDYszAwNAGoZmKGRgYuxjwgILKomIGBwaFrwxsDP+BfDYGRpAwI5ISBQZGAMeeCFUAAHjazZK/S5txEMbvjdFaxdyprdUq6ZtAVxVxDgH3kMGlQ2MG55DBOeQvCPkLQoYO7RKCOEgHceoojiIYA6LW/rD3nL815ttXA0ILXTqIB/ccDzzcB44joi7q9AR5gZLXCpx378NeM5hLlKRumiWfqvSJarRCX2jL7/On/IVYPB6NZ9+2NKJRTWhKM5rTgpa0ojVd1g1t6LG2EUEUk0gghQxyKKCECmpYwwYaOEbbIha1hKUsYzkrWMkqVrO1M3IuoN9RPz5Q6Q8qqWhMk5rWrOa1qGWtal3XdVObqiAIfEwjiTSyyKOIMqqoYx2baEKNTCxmSUtb1vJWtLJVrX5HdXtu0b1379y8m3Mzzf7dw93VxvnOzc7n7TcyIeMyJqPySkbkpbyQYRmSQQlLl4TEE2LHbb7lFt/wNV/xJV/wOZ/xKZ+wMVj5F//kH/ydv/ERf+VDPuD9gQ+dyz9+eT30gPZCgYT+DnRe4ynUs57R3u7Xz/vG/pkI/9fe327CwIgAAAAAAAH//wACeNq8vQmAVNWVMPzuvW+pverVq62rq6urutbuhu6m1qbXotnpZkdAQGxRFMEFFQRxoRSigriBItGorUaULDNmMV9ixKlsOlkkJiFm85uvTWKSiZpxTH4ToevxnXtfVXV10y06888HXe/dfT333nPOPec8DnNbOY7YRHhwEsdlg3KQyEF5GBXU3FY8tFUInNoqcqc4+g9xVf+mUf8FZzjxKSHP1YHHISE5mHA5xFCwIZrKJIMyiqZTPSgZTPiR+FRz8U6U80aj3pE8faJc8c7mcNwt5N3xsDAnBNFFLpqKwh/h8M7mkLtWp6tldUIdHNTRDB7ZYcENLTjVg5MJtyyM9aYyWZRJJlwiN2vTZWsu2zQLXlMvX1Uc6436Sc5ki7cLgdNDiUXNTmfzokvgFcM17xY7qwPIK/VJA+L4dg6zNuShDRIXhK7buAD9IehqQwzBIxzFNnsmHOBddicMg4vPqx+q96gfIgldS6SBVCasHvvKG/eqp49fffVxJCA/Eo5ffRNaFcGQAElaYjWfGoiilTeNprj6uHr63je+oh6L0NnhzuQlTuA4L9fNLeS4iCxKvGTBzTACKBaNRGOywwVjnZG7cAuBORCdDrfL7ec7caKHZDPZHpSVtclJy3R6YKDygYj6t8eSuSvbEGq7Mpd8TP1bJKCYhYJZQYJo0p3KmZVD33pN7GjItjgQcrRkGzrE176VuSC/vu9Urm/9+j6h0Lc+QLiw/8Te5rZp09qa957wh4ucWVH4OLbrZZ1BUMzPbjvytDDNG7HbI95pwtNHmu8fPF2guXlahjbHtG95zsdxPAxpC5+GFib82N1DYELpmJKHU/bifYbQQFerOtxz69VLwuElV9/aM6y+Vbw/b8drdOELL7ln5hv/aJ6fC4dz85v/8cb/fqv4rFb2F2HuhrkGDUYVKI7OW0SAJwBoVqFgmo0omYRbEWBMvOqDK5HToTjVXrUXJtSJV6oP1LSjD95UupQ30Qft5AaXV31MNUlmZ53pnXdMdU7Rgv6GNtQ6I/r56JXGRnX6fD1dIrhSt55Crx5FjDC1JCKU2zF5M/hrUEJdc/y4ugYl5qNd6Ab0CmtX4+TNwg7U2INuUW/rUX+hrn3lFWIoNzPxEa2kbQTIhrGv52IAVSUISfUIdPwTdGX5Bc4mBqK2TEDIH7xh5PANByVnIDNnY7e+b/mnbv/U8j5998Y5mYBTUgtvqt9+803Us2fnXXftTG/cfsmFM+PN6Wb4i8+88JLtG8kftfg3Oc5I15RE67VCza1cL7eYu5C7mtvN3cs9zv0zxwnpVLQZNYh1yOHqRADW5/AjORVlUF9aBmh8/CdMf676xi8mlI962c42yYPnot4iRz0EniPcaIxQlVPNV6c6V5mwDD9kC0mEhZSrRKGHJ3IWvZgVrNInPxp+etRJqpOoD5+jwBdOsboFtoh5CvBi9XzS3XrMCNWgcSN2jnjCDaRULjUwkMLsOeom+cliMEe30YEUok/8oyrPyI8mi+HYYmX7z9mwyCGn1qpupLVKHudH/8P+8fVhrj2uFuLt7XGUo89RN85X+4r5yeM+fspqNwowJ32gX1acxVEnmTD0nAmqCgMQmnAu/n+fhY8/qgLEjLAwAmGnucnjqt3/xbEaMxRwdt3AWcQ7+C9zLvDBmSGJDa0IRVO9CE4JPTzqkXiHrzjlTt8S353qYZ+POlAU30f95P0lLMp3J9pM/T6f+it8P3ih3KvO/EWw8we5EMeFHVYkNsT0iJYdTWX1Y8t3OSQ9EuysZPXX6q+1klAUXKXaULRU+q8h9CNjfZVSNHxG2y9CcDbO0ma4WXvQaQlpc9MJ2zI8Eq46BAcRKmFe3GSYF88p5mHFDGjLMKAgo84x+Fh/ejJ8DA+flZM6/1CFpD2/uX8SJK26T1bOzbWdBbUfr/3FAq0V5z5Zq1l7P3ZLS+e+SJdbI5emmBEW+QC0Jp2yZzMut0uULNB6hgHAwRdrQYA/ul12umdrOzTFs3edUH+v/qv6+xO7njjYfHl9wNq0YcvS/cdfO75/6ZYNTdZA/eamg08U8wObBuAP5z9DU+46gXyf+RrquzJgaW66PLDg9Rs2QXLItemG1xcELm9qtgSuVF/CC4psg8Zsg4Z/QgVHHN0XuEgFXDQgician7ZvIj86l5+zWwoWO3ug/CdzD5Yd9mtV5kQ5eL5fZG5M3ejaEfqyEBqE3j/FPAL1jM4HozGuAn8q2iA6XAkKQbA+JZgRB8xICNaoKMF/2mpYrjGJAlI0RlFHwO8hqAXRwYAFnC2HJmEVZwD/Zz2EBe3OAmoNlAFFqy1IgiA/wN3hk4cPn8SHbaZvKI7QPIO+9j6XybJ/SqvNLNX9m8WJfNMa7zZYLcZbYpLOOs9ea/lfZpvN+IKlJj7ToPfe7zKbxya+R281m24Ns8ReKyTGLlrDYXTlv5lc2JeJJFabvIbIPfor3NY7Ez7Z/HWbc4veeG3GYDYZnWtrEtNqsdPM0ra0TF9qMhnM4XsNW6oTG3YkdRYtcZsPO9nZUcJlNRjp5GZyl2l4SPUsC+fwK0D/OvyUbu1BKAijGxQlgUFaBWEJldd0ltG3MIbsDLFb2JzCA03izo/kLVZCcsRqKQ6iQptkUL9jkMjVdsvg+r4RwKcGGeik51gX0RNmkXUOSlvsJFAFRpZJ3EU/+erIAMC8HOEXbNdjrH8QgkcGlt+wfTn5Oqv9mUgqFXnGrq1/LwzYpQLhFLb+Wdeg4yX8K61HriwAWoidDDEKa5S6BlAq7cdO2Q2bCuCnav4M4FyAq+Je3Iv+T4/OTMy64kBxwGQy63p02IB/HFgd+BtbGr8xYBxQAxSxpYguGkY8Qr9Wo3jGAj2W8Iziv+gQ1i8w1OrwKq/3R9+hfVM3fY3yAbS9lU6xAi2Hcwug1jkOgXRLcjAagzNH60VQFl70xdvjp9iZSvLxQd9etNNgUl8xoYvVQUB8OH6vbzB+Ok/jRTi7475Z6p11JjTddMrOw9mOhhjjg1TWpgP27imjmK2275TAhrO1oIAF2fwokOFsGHZT2NphZyewSWg7wrAGDkMHT6m/PHXw4CkUP4WuPaE+rq5XHz9xAl2EnkQXkWG1AjcUFooqpDpYyoEvrE564gSbxwTgS4tge5QB2jmUJi2IkikScYoaneMIAXUTg2BK7UhEBGqnATYGRCG3gW4uLBndOUJ0DJGLX+VBDvMLZgfyILvpbyY7/qClmDPbkQOC1fcg3IHs5mKuxYue0IUdaDmEWCHkKCSxQhK03BHWoSe82McjdjKpBd5kswG9qZgRZQ2Yz8BzfqaHdyg+xaztm2Zwnn6np0xHiBQJtHIRrhswlNJeWH4rY6bd7Ur00tWHXBLFY1A0S1lPGkA45WBC0LhKKMpeRwEcGJKGfnJHx2c67kSvxdvVb8r1as6esau5elluQkCaIUp8cU1HU1ou+ocCo3jfne3wh+XGOjWnKKhQ1xhDBUY35apgxcOFGQ7gqLSrAipOOQnbRQlYepAtylfBCz9oUL9l9BjVglWncxXYwoG/H1Vg5uDBs6AGD5pM6rf0epSzKQ4GNxZ1yI4TVZB2/CzQmaCt2h6nbYYaW4Jigmjytq6vaqEB9UKzUc76049s6gMOdYhtcoN2i8mEevV6tWBDH35EUzGDCYoCmNnKD7agGAkSOLyC7mBkFBqyirYbuxUXOYO6EEEni10n4YW6LkQ5PBj1noKNquYvhrSX5Lxpw19qcI4YCHpPtWETLjyp+hln8rc93The09BQU/xld9UYWblayiGheDg7dGmFGRibSZY9PxQoDltlmy0QCNbjwEcuevz0Arta0OuUCM5HFLuiFn74UaseVdqUrOxFsWgvioYaLBhwtmSCnvcJerBLIl9BMpMJHs5+QO04CqlNsly//4Hvl5GvHSfnSzaLcZ8e6a5Uf/CFUVTtEFK23AYQLnBqzhuNx/z795VQvE0XGrB+v67GsPd+mhK1I9+JXVdvvBUWUTU+E+bmslWAuWBDGBCW0f0aKA84ZhMV5KS8sFOsKxU8pxvZuSBrO5zVf0Q5dZP6l4Pqf2y5VUnR6YKVp+yb+9WLbv/THGMTgKNZqaH9g1DoXinwFbMyAz2MlIPIseU2yIaGBaz+Tf3KVZfeqmhFRFPKvr55t10rX+JWiEKzQ8j+fVqAWUImtBC6pkQpKOom5RdwaBxGmj6Hfzxdmj6HXxnHtVLO4kJphMBkDx7iR5iHMDJjYjckOsU8lBM8hteLBivF/XUCV/GvHx2dJMw9QuvjF1Yzgdka5zUeez1d42m62zureUSUFoTzl1KCLljOFGUluTLRHUA6tBXpAvF2whU2Hz68WR0usv0aQ3Th60in/uPrhXYKl7kSHSFzWQaXlQ0PtruMhg1SrLoFhxo03ixd5xRnBpQ5yRiiUHuOdSjXv7lfKNTU/uLh7pvX3TW/oL4n27zRemfHO9/Y8sIt0URm9wXLzd6owM2LnrbQjvPvR+el+/u3F4WaWsu2KakpB/VRL/5DwG2p29nRqTSlmqLlexZGR/bTFloxIP7OsThqHfxgQaRTGLYa7HTU0+O8gpqVYQxoBAy9KhGYYr7L8Q3XvtWj2Ojc6xtm1T2n/kL9svqL5+pmNVw/dzRu9T7XNxxdtw+jFBpAqeHb8f6jD0wLLt8SGEU+A3O7TBdueACJn/mMeuqBDReauuYGRpHSwJblwWkPHH0IeV7dtetV9U9avwKE44cBh2P7FhyLFdiFg8ZF4KxW1K+op9g+LKKFsFT5odN0haOFEELRzIXaGqTwEuDzrKypE5fGaRNJmdkk1ULYlYJ7wjpQ/rw5Bqs36mlo8NBf1Gs1zJmgYtV+ZI9PiNQ665w1LbNaauBdGxFqGejCfvcNmLO5rD3zuS2fpE1wpJZC2T0N0NuMeBsfBxQeAKLdhmOUIK+k+Ng9Qud97oDZVBuNtTsWLF++wNEei3rN5gPoc+rPzACmMaleagnfuH//jeEWcLLIn338UciqJ9RipxD1xhx11sxTX38qY61zxAD6O7+mptTdayEm7ObNfI13LbKhBLKt9daA1x2GJGs5EyPyKczTe0gj7KwK54YTtx5O/FY45+hadYbSCvyC8EOMVpGD9A3ovoxK4UC7pUNySA46k2mkJZFRHv6RPJBelOygP8LR5xmumOfzeRqt5tm7CP8F+NEgwtFsIwjtRqV8NBbnVRZO+cwQiFlCGkx/HLsbLJ8NZ/cjxjWX+tJJ+ePJkJxU/hu/XvgXCKyvr38U/np6bqmv72V/j/b2wt8t7G99b+/x9etpst5eIX/qVmH3f+lH50U70x8U3mZ7dF0Vj6KEEQEFUaHEkAsVYHPs38xfH1GdsVQ6UkxH0wMpNJTOR/EPI7yRRvaruXREdUQi+EeRfBoNpQbS0WImVsZNH5S2lOpKn6s2QQsF6g/2RBoXSn6MVqA8Cw63+NHrERqXTw9/jPalWKCvHjJBZfgH0bTWbMIZAOe5Adq8gruE2wYQCzSJhdJdsJyzKVi70WwPZss4Sp/jHRAluiXWpVI+SXSzYx7Q8JhLEJm7F2Wio6RclV+8LO5S31WumzGyceG9Po9LRHAmYpNTdE/REQETH3E28Uji+TCvtPJIh7HFJepks+IIxnwoasYfLljiUv8SnnvByCO1RqPBs5M8UpfRoSkSjp5+lzdZ8KC5hneCozgEjk1nhfAN0+eNXJ9btWXRzC6+xaKrFY2OWkN0S9QQ1xkbxPDWBn2LYA4J3u1RXUivc3h1pkgwVuNCItFvXTBy/Y7ZVlvtnHov+Y0rZPVX0Ba1UHFq97kPCaW7YpRwa1wAxgbTM7jQwALOa/6A2xmMxYJKTVtInavODbdqfqdbyOvN7Q2n/t7QbtYF0LPq6iD1C3rw68t7eV7U9iIT0PxdHNeobSaM7xMsg2JWLrGsNQwtVD6eS2BZz1gUFF2A3WcEfkP0roXPa4SoYh7WcJdhs3LNYsBj8FB80HfEF88tvgZxdM9pjw8VNdozpw6alSGKzQwBCT20+BocoMyKI77B+BnumpJsgEYzB7lG6AEVwwA8uoQMjCJQFXZViQ9tI/P/cuzYX46RYYoyncrT53BS2ZjGXHqjkixeNspPJoPHaFI8//DmEZaOwPPOaXPnTrvzdB5V5BhGecsaLrcEZokkAHHKRqF2PqugTkQJNDvMHBVPQJQPKTobAOHnJUD8Ez1COgWHW0QErMZPkpRLSSPFkIh//rngj6cr0VUjP8DuvrZk1PQu8vSndeTV4MFG68o6h1XZbxVRr5obUP8c4/cgt86pNws9y5Da493o64wOEIQ7/r1DFyFLyE/UHh4XR65fLBkNSqweb8InLZIaWKR++sKG/90x1WStE6MKb+dtFtQc8glwBhtMOtsT3ya4Q323xlVvB2otprc7dJYSHc3OLifs8BdxXMSVDMipWAvQXhJ0ziH6EWG4I3QN0zDWZwdb+D18F0rbIG0roiQaJPMTp8NCJAAeeIXYyODmBX1oZ2Pt7L4L53fM9yGMdGLTzGW7NiQ7LtnWl1iiQ8XfY+uBsGQUBeTiw+mWpMBvQL/f417rmvOpm9a1B6eu6Ek//Oqc7Y8/u27Kc1M2q1dZA2jxtX1TuoIyb0ifTOl2LLgAvy55e7etmHN5p8+c+EGydrO3ZWTret5jNfkjvlZnQiCvN+vMeoFHy7GCvB0rbu5PrZreEfCEXn7wkscvne0TXRptytP1OZ3jnCWUxYti6RYcy1LSFELo3YIEPRQxPClHWpQa6OYdovMsiw+FfWa0azPydC9SlOA/3dzRtvFun2Dx3xvRmUQ9rr1Bxi67BSH5WWI2Nhvrtvn2z0p+/ZbzcMwe6pNwChtDNWajQC7DekHQ41jCELEqrcEO8wPFN1foNyw7z2rna6dkiQPby7B6Ctpby90MM5dwWbWbMLqOoU292i0YZYwgiv9TOoAuoR4MsOpi4ClKgI7hWAuhfaD7sNthh/ktAzeUF6bwCzsE7PAZOYUpMUdhnBG5FgzZZfG1oN1xi6MDfvbgkiXVng9/kjG9AnMWvjeMIqLf6LTomngHj4VYXU0dsZmRaFKkOixfnFgU0CNeEAzxZ8MCaRhQfz8DZpHI51/hUUSEeWJ8KLjTofiD3iZLPuJ90gt/EZ4ru0Y4/kwtzC1CgtmI0NbhJXUWfsoK/aLZSKcnGCGeX5pdX/zqE7ar5wWdzba4wWJF2GFPIn1twGtpQudtRA9s3I5r3T4Hb/JYzDsuw1472q2NMWG8gIu4BzlOKY1jmHe7xg1iOkoHhQ1iPUo76BKYZBx7cArwXyZgNnYkERUbopclsHRaYKDTQYfLQW9OYIqigEMTeo8Iqy+YikLepdrYzkEXIW5H0F09sBaDLHT7b1lyRZMewYKbcFwlPUECHTHe+FDj32za2Ap+U1c2x3u9fC7bZTJbBTLCEcFqHh/K01BhN4w5RjwKVA35wjnILGLMC0uzR1LZl5+cN/GQ27b98x1fIFKdTlowb2lGMNUaTTs2sTE/dSY2JUOc7U6SmRJzhutDGIfqw84JAzmN5zqGn8Fu1v479+sSF/V+yCRFxJJUy2kmWSIwxmrUe4r5RK4Ux1Ly8CyMCppceg7n/6N2a+KKJF9qN/MJZUkd5sP/A+2WP6F/bLurR7t6rP/LI/3/pM3ndn/CNn8En278zbF8Dv9EcPNR8efqO+IUM0NrJ3mIEH+KeQRAfE9xk8VM5h6ulIaum8g58teKk58wdOJs7B7+rDHVeND0jiOlSeCi/yZkUC6mRa8O6/UooLeYFQH8H7Ieiqwpp9mTz413j6Yhw1SMgmb30ce5e1bdyQn7WOL7a7wcKh3z3+3jIO0g4wpaoInCsU/aRXzCR0vQREXApeo/QRc1HiOTJ65n88coqHKfyoR1HUKMwyRxMbOp1q5eeWxHMbfj2LEduLDjGDpkrzWZY5RB1CQLCjp0tBxzbMfT6KAiyBVaStJoAQvn51roSFLaJJMAkiqNYCCr2NlQcdQ9jqWN81uHtm4d4reeyqPcEAZs4kPWD5GOxKFqCUjeRhNuLRbUXIElRQEYPDZgPGQJnGZsbL5QklcEnP1tYQsnAoVXw0U4LpiNSc6kE6UAQ0eAngPNAmQ3tE9GgHwgygIGTBBtWfv22jy+3mWQir+V4In9UgYNjRTUQeHtyFF18Gg4k46+HYFUW/JkyEVTGVw01Q/UwZECGsLD6chRNPR0NPrnWAn/5DW5D/dYLocFUX5GlDG9iSaggQ4H1QdsvfN6reqhIJqCnkVTSEmugrtyzsipYDQaJOKcK0+iKerJMTIlCpUYb2D3VGMup7kH6D0TeWDcjdQgn9Nun/B/nn1vqPHqOaEA9A7lvQKlQ2LRBobSO6HxmQi9J6cMSwIEQAIQOOJ2Yc6B6lw+iQc6zweQ5ejf3I859aS6Wj25VLzm/Kt8+kQqqfNddf414lKUDwdRczDrttnc2WAzCobT/f3Pn1ShXyfvv03/1F2/usDf0OC/4Fd3PaXfra1X8R/QTxFgbDrXw82DVmmzyUVhLl1ZpIwFbSr/YqWCDdWXKbA0Ad13ETblEkw4k38jO7cd2TaIuYCsPikHZLR+6bEdIwzKSa43YyXENM1id7tGGBgSADF9zhofRIHioDrMr1unDq/zLQFSHQ1CMe2DuFApp/jjl7RSdhyrkWwyFCOKmhDI+r5bzFCKDb+qDhehKOxbhwLrfFDKksr4szvyZm7NeDnbaQkNnabHU3XPKB3mdina3WU3CgUkUXGxVU+l7XskervCJIOgy0K+3EXujFnxLmw3iFvLvbP7vDbF+a6aZ6t/SD1+3Y6pxK3jbQaDa3pTSHKGOhddvf/5zUOwZXgV2MlxSC2W+6mYawVvA1/u5euKweyx6fToDTUP+0VTYc8+9Tm3EZstDZcN7m2ftmJwyfIZHTEX22AgSarc990w161MalCeaFppF8+eWLqTKdpd/FgJx9HuVmbUYCbi2Dk1mEXR8ceRn3r6POoyj+cqeCMJ3wGvqzx4vfrtsVNpwJWpVGEqDUSHTkJeD/onlsGjfghZaSElvZozsERhPmeWzhnGZqKso7LwAGMrBZ0OsXzK0s2Z8aPKV/RMPilIr7DcCJb7GU5JAY4KqBBz0gcgRoC0MqeCOHZJQKOpkz4gGtFoxOGHP1l6ZWxtVTwAqheUYTwoaHZsnJyVU85kyc8Ur1cpduj5Kkl5vXCdYvKeynlNCn5ZbyiuKePcgHGvMeqq9EWax5c/STUsUSYrVmo7u078suI9q+aOSZoAiU3eYgdry64Sr6tmgrakKjUv12rWCfSpKLQ2QTdhbTC6o8Wzvt4k7Bb2Uo0JPRJZt9ga3XTqNXcw6Bba3Piiot/s8AoFr8MMrjA3Rp7QWjrhxxyqwnhVIK4k9c80AEby1T4hN0r1VFNA0TLslus5qxZxDMU0ppzRvKI2du5K19ylHkqst6I0lQ4dfpkOHQwMHT4YOjpy0GETHVMjfpk5YOTgYfLilw36SvllODmrfLc89rqUVjVRjTqhSlVDN3nt4Dg6OkD4qEFf3Zgxa2JsW8Y3olJ7db1jaxxXEZtvqEFEgghwUstxirYpsNlAVTNC67GMwhiFPeHlqmnBU8tD7C3+QZODinrPwFMbz4fPPMwfFf4AGBOnxy5Ncry0H9GNlD9UfBcrinKUzoQXoPwP4Diq8D8rvlt8lzm1IHjQNFqZa6DMS0tlniWETgtdDkVpeRUohRUOBeBDtAbmgf9aAppwDOzTu0OOavaEgrKmvuOUg5oOTzIoa4o8aRlOiDGSOwXaZTbuZ1j/keZhQmG58aI7uVLM2XlQ89lyTFWyRKV2lVtzdhuq9IAmrLVE8zZPIBNYrqeZ3ZumWhEVFWilUjVWxiyzUvy2Hkns6UomehlvE0Z8TBtuVp5/XlHWKLVe6vDWgvPsELRnXNvQYx+VvBSCTkw6Nm4m40VbC2g4oJWsrW7aSiqzWNU+gbevhXlXN/0WnmvtdrSZVoHr7SPjZSobfHaoWb38t1C13QeEzGGFplswrg3Vsl4d3BzAmMfrjKVaEBAHIhuzklAInMmSBZVTwPmb7eHD48Q/K/Li3NVHV/01b3XvlUw2fTrYkGrrj7f1Xs4im4OBho76GpQf1/qhimA5/qfVh5f93GO/RDTN8nhSwWiLy7d9ZphGK92K3TmtdUH3eGAY7ROlvTrKfZJHQY/xuStASMZ1eYy0H2e3DJaFWQc1SWVwV3UQn9X4IQjkaCw41AJ72ck9Q6UQ+7fGt3cUDlqZ3k9FD6QFxSo8FwuSkhQBon4/cldURHqQxpeB+EpayFcpowdlK2khH5TBf/FKupCuDDxxBVtOVzwRGB+Arot67428/QTzPvF25F4aPy4Ac5PlrgSgKZNnLwWMlckMMQl2TlP6kbSNsRcWREq7kihRJ1ZYuY7MZDKI8w8avIZ9++Bx0EDfhnH+Vz9KKhF9f+JMFX/NR4smny03ra/CvutR6dCYVIDykLqGLu9fK8ql8D6E6CZ/qbLrIwUpfwZ5FBRlKVkWmvfUx2znpzg9Z2d6wqkYYvd1ApOpBKCChmn6MSVtHSGwqmjZN3T19w+uHKnBf73jaSCjhcCuV9Xfqf+q/o4KPMGW0I7qXsV7nri9aD1/1cEfvojfX3tw5IEnUa/6svpbJl3pRx2ojrroOZg7k4Y29MNIlfSG2OxqfLW0xlhj6liIIVYzUsUcikSj/VQEobg9EsF30fuQ/mhU/Q0upGbgfD7dr/46fEV4AOIOMEGF/dHoguhmSNCv4SNpoVCqT+NtsaMXVXhU2kQxilAoRIrbY6lkDMpHkWIuNWNGChfU30D90VQ6iu+K4FwmQpvRDxWgSH8aakdRqB0yFLfTDZ1Lwxj3CzmqQY/KHatgPdrBX+omRVz6oSSq8fRrVhTrCBSF7wplMxFaXfoj2kLbquEW6TPPQ535su53eTBL3argXqWxhUppL9PwhJGiDhQdSOVTAyhKx68/ggsQt42OJ+Xx9Eci6q9hrAcG6FxEoe+xUZyzQOG9RMtRWWqLAIeYo6R73oJjGPpqDyblMr2mUgpqeMMjn75mQ09IEGSrzSSZrGR3+kn8/WGgsjBHgCpTKdmFOFN95rztQxuzs8SQ3uqQ9V44KeuOvnI7OkQxEUjFjTlPW7WWuF2j2Hl5+TEZtVZUxrvo9qIx3f5qUL96n6IJ0kL196EBWPTXEjd1q1+lboMBDdxXkp5F73pZ+opALk0PyeczOVyaAdJ7WYZUtCS/Zz5zt/BX4TqtfZO1Y7J2M5m3CRoySbtxbsKG4EMTNrti60LQ9BNL67ECrJUVUgEgSlFRvdlBprtJdUuo8gjzoKF4OwlMFMrSl+rCUBfRaKhxfGJa7mkm4soXSiWVFUQ12pPST2mmD2OFgy82qvMmiJrazlQ4A3vh7HMLlfZGMlQTTJQE4Qcttd6c97IW9QMG6eoHLZeBv7YFGcCpRSGDtggMpSj1A/QHCL4Koj+tvsrUqJOfhvCrIP7hh8sxKMk0s1+txFSfB5RGmcokOO3lHX+8/j1RUjEaADiqooXgVm3LLm/5+Mt2c8HscMDDju0Gg+UNi8EgOyzfsCjCeDzk9H+8ZFEc5pfMDgVdiq80iTqdaCoeMlit5bstaFeOM3MuoJYXUCxJTgedsrOE9yXZDbPDFU4x5DmZ0HTGqvXBNAqLWT5hp3NSM4WScJEhtRD2FXxhtf07t3ibYebwL9vjzd6bvx1HzwEeBdML06lhU1+/YM+eC7Z05/PdW6gLfd1i/2o7OlkoqFPaa2prycYn6tuXtMNf/RNDFA0rw5SmbbjnhT0Ln356IbzsGp+M0b5OdntBG86LjD8LqCsVywgnKZdZ5DQeIKK6A/TGPEalUjWlT3q7jqnQTg9PjUEIgOR8QX3jd7tgeXmctesd+5D0NS+OOlrUt3/z+vAD+60H3bbW5p46f5NDxjpCehb0+LB+1UMvXZn96le+/GDMEHM0xDyx3oCNRFPRi4/d4fTAmvOsV27ahMQLNwyr377yilZhQW4g5/LW8RbRLIUWZjoUfpYhmb7up4/vCNutRB+LGGKyW79u7zbNLotA+aBWqgkhjL9hcbBNN+ZmDE4BdnB3zM/Tu6TRe7Iz3LTFg4OLp83k0ZoD+9ZkNV8f0XxDFcl1Xlm094Ll8+atTQ7mEWpcse3WL2woh6y/rRRSwiXouPNUvjzIjOREY7Dra/xwUXIBsLO50BjlTIKXo7MQ4Kh0QgbebjF/5K1uTeiq+60jn0L3o5Po/uLzPsfNX/HFfbtWOsgVjgNqrPi+GjvgcBxAv8IW9KsDOPfO9k03fIOqC3/jhk3b33n1r3/F0+O+r9zs8PkcK3epP50V+oP6NnK9FZoVegu51D+/xXRqhyQqj63narhubiZ3HkB+tgWxptrHtzNC21nirkIKKnZBWxxMMI1SyuNXgBZCLp6xn3k4qcPZaCwLiDZuXrRqA/TlGbxvtBfoDnS5um7zNIPdtMs25d7/XO1wfBq9jMznr80Y7II37A8SW+Sx25BHhwqO2JzD6vZ/W3ASXX7Ddc/0XvjP079/d29hC+2nquKrRrv5HxJ+sWg6fr5tDhTbP+OX++oH6t9GNvkim0mxK9igtt31VgJ9MHXvnIbc0i+8tNf+lxe/ct3W3Jcv1ObOBvvTewyeghSiIufckwhySRUJT0QvO/iqu1rYlczGN4zm0q5kJlwoInc2nOIaOuVIiHBy15yuJ2BjUiz0gfaiH5oko1GyqFmD2UyeO5Xv7a1raKijorv14XDpTLpCuILq/MH2bUVKmdsd0yPG+W5GVOSfKgOxbUiPNLdbgCUvDE7JDTwxJMh5ycQTq6j+u1pMC+ZBvQVb9cdHjBgZwC3ibyOi8haCjXmLDX96aKAgDKYKA08U5ymWQRERMxpRi9+WLYN6bBw5LtnMpov0KI0IcutsNmPeLDw+NJCjJ9kZ7Y7ibDnosgT0Yu46jnOXpLgj496o2l9h3pT246p02XFxkXEaIyVyL1hlR8CVRwF1GA2inFpQh8a78TBz5+mTcDREc6tDo2o0kKYSjlhpgdFIlB9InWLa6/n1fbm+9Uh7QYhWbyDHsuVyKDAC5aOC9oZQHEABJvFKDQ+MfJEloRkKVcELTzNjJwI8B+n1wqD2HCjRMbCehWGgYrLcNVSfT2rhq8QUynfY3QiImhYxlsn6+WRQUyNA9kpkEI4CWMKWagkHKrqW7RErqfHDXQtd/mSyf8owU209JYh6tUDvswOb29ekBhJ9qY7azlISqgFdVvWjSc5wbYu6mjyBlrrGmd2rLtg5SytjXGA5F1+/7vmp2XmNdYzFMGLx0VJgfSFEJIu7oaU7dsFXWTzVQVS/RXaUE/i7elt6ruxbs3PJymSQZR4ToiUfvX+B7ZCipoCQwIoSBdjDorF0NBOlZ6CQpaYRehBVopO499RL/jan/2X11LQZci1PBGTAJiy1ORs9fuOjz9/zHhr42t/QZ0iL+ln1V5/X/fNMiw677Ii38VZiwbq0u71lXvx8JB6+7d0vbPz8WJo/ybR4nQ6GFZVPMth//CTRQyon2zm5+d9Tn1DnqU98T9PaaO1a1tLUsqyrVfNS40OqZoWtZJho1IcL+e+rLz3/POr7vsZiTA1EXTzvooQQ5Q9fOpq0OluJP7yGc4pH+QDl5Uakaqsi5TuqQ4w1fBY3+NWny9zdp5W0gt9SlGKtki7zh4fFo+TtMn/4rNs78RDjD5/FDca/hDJoWWkoVNEY00+zQjXcKA9ndIRqWGk2r1pIF+pGY7ReNZ3/ILv1L1/EpbWbOI1aZUY9iA9IfXpXJ3BUh05nlHgMtIQV5ZQuBeWsUW8B52z6IQnnrWrB0eFQCzSsWKBhVN+unAPWOG8QZdGBhtAQoFgyyrtcal72UGEzY8GIDntkNe92IxaE8qaC3jiaRR2s4h/lBU1/uoPad9GkLfjSm2oMSgK9I64Y62NoHpU01jrEu5nUBbPaQX7EXj8Kek6/Y/aQI8yAH9CYNlst/tKPNEa3rcZi4iXEf8kbTTFLH9ofKaicJ0J2dRlsbVSM3WtsrJ8mkCy4zfZ6Z1SKcmN03Rxn3x/VMV5Hfu+607l1e/euQ/DEQ+v2kqEi85MCfQb2Vu7EpVVQjsI1adS+di6XVd2pVBLVkkBSamz50qp69bnmR/pOFxrS9WgJuPhcQ1o9NlJYf6Jb/WcBlSoOwG9efUjdlpzr9deH0AF4o46hC+ep20Re5qsaQ3k5HC6ITLaGY0A0/ip39OIWF2CRjbumrbpm5X+douu16haW5yqXrtr4oZzEkYJWV/nuePxN8dh74QkLHL31HXfLW7rVLdlg0ZV1m8yA4TrpnAVlTQMrKCflsg/nYQTgJ3D/4AAYNQ9VnqLyOyNAcZ3Ow453CmjeIke1sU7T1TjKs2jjcuz0ygAeqiGhbkA36SsaA4TUTXEewCvpi/LpgGKJZc7aFLn2GbNqZszuXrfqRuHW3y6uW9uavmR+ncvsdW6Zte1+r+eBf9r63QMbpwFt3HRsxwiTayKFHcfIYzX6+MKoue/GVXWKtO2iRPu13agG92+36PjeZWgNWT93xyPHVtj1UxEezXVszF1omOqmlC715GQ2RLeKbDrK+OwhZ7JsZSPJD9P8L77if6t11q7e6+586l//tfgODWIiCVA4Xv6nB9rb0Y/1Qwc//6fiF7W6NBJj1B4OxauodlkL11Oi9Kqw9kxZ2iqYDnK2aEC0uQLUTYIAJlK1+rxmdA1oSSrkYW+PW95nMkcjh6n9Tz5fsu038ibVhoNujnw3V7xJzPenT3Hp/v60CE/8ZZ99fR89y+PtOiaWNPLtPKpHPW/SzDzMf+H6/fn8aZZBoE825/PEQ4xOnVuSf6LTzMht2gU6wczSZguOSe4SA02TxEvZwyXrkNmyKqWfJ7mtQ1uVxqYlW0tv8p0Nsj7W0EwG3/Ataor7ihc9d/ypV19CiaGnXt2DLh4kLQ2BDbLZIC5Zcf508tzQ1q1LmhqVraW3yskbAnA4QOZ40yIffnzPq08NocRLrz51/Dn10UHSDIecvMEgLly2pk9jI3BnrFJeeA9mSIZ52c0d505XyXVp/YOeyRVXlY0f50cY+fnkJn6qDPwgJhPEJIOolhxsDrQelj1KxYGoeBAri6o3u2GvgPK1EqBV8n8nM8kzKCKH4Ujo39yvPdW8Rf+I0dnQLknuHYrRcF0kbjRJ7heMduRuaLxeMhsN90mGHpvbdMRgqSR17aRJG5qrk+pMNKmpy+o2QlKcf9BkT/K7sG7A4nA4LAM6vItP2k0PPmiWkzzf016KSDaK/E4+KZsf/KTpS2aMzjAkHACYT5cc6n3fMCjIE2psm2kwmCT/DmmNYrqi1WM1fNrgPF/SfapWb7Asck2JepBsrCQ16k06//XSGrvlipYxSW0DrrYGN5aLwwds1tqaa2p4Mne9E2Pn+rmEB2+t1QYRdW4agcOBCyBqbiOeQ+PcdVby3n8lV0VuhOHCEcY3sokMG2amgGCyU4AJ9/CMRUDvQWBhSoAv+EUKaVRpOSaGAnTFhgEqYe1SE0Evqt/8l5Vrbno4nCBGBQPSjgUiIiFsq3MabrrnRTQb3YJm4657bjI462xhAYlUVxGSOUyJ8MM3rVmp/uf3O/xPoPi2m29333qY3KX++Z19ttVxPVCeRBJFXiJUbMMZiXvm/XTHXe/s21fct/Mn8zzxiDMqIojkRVEiFhuS9PHVtr38mhXr3rt9Yf/c1yt4N9Ob6+KuHLU0g+jtaCpD7+crlBAc4dBTSmJCv3oQHDiURQYr0sFWBvuJzZgO0uh+ShclpZyozgkkoKLRmjka/uiihDo0mBv0eiKNriwfrZkSbozZAgFzpK7V3Sb8bM8NBcEfsqcd1kBzfpo+CtjpF+4OXzD4zRu3udRhun8ie3hjxzSPO9ocS664fU7bc5uOaPZqcD65sOOHnRvWe6//VLN7lpAIpENhezEvSladjOc/4/Xb5i8IJGbXdMtoXfj8BcHwwplO18aFdz0xtTnen8b5dL9nT3+65oa9TZEZ+7dfcPERrmJ/icmSdlOb0VU7WozNdQYcGY1hIlkEbcAEquKH3XQfj6apHis9EMu7HJMapea1KqcPAA3dwSRnZUQrw9UcsDrS9pBf2LAqv+dnQpu7tS5iDgRsscbwlJoon3U1RjxeGE80mFiUP7LpubZQ6PYVyVhD3OhR2jo3htW/sDELuLblX7p864Evoi4S1U/jNf1KlQutQ3J3zexEYMF8m9973rL5WNZZJbGYt4dD6UBCmOVu/tT13vUbOn/YsTBx2ZGLL7h+1uwZkeCG5SudiYV7PNqoxadMeWyfsHCjyzlzYTi4QLM9THKMHgc86SxLvyQ33pKvMHzqe2eb6q1el1TvdTq9oWwhjEqno9hgIXBkAj2ULeGY4+wni/nmmYPrNu3cOM9j77F75m3cuWnd4Mzmb+LZeNaL+beK99snsa1MvrD0pvkttuTCmT6XyzdzYdLWMv+mpc9+s/gabn3xWWpg2T6R6eVRGdUA7CNxistFHC4LrsYznKWAkoxmB/aTym1ZJZl2O4bzGAlWs8okNKlFqZKX8j0QtcItiwaeDCnFYSqEyGyMowK9MgsM8gGn16wJpStm5lnfV8z1rce8ZMSJFM0CiQMl2wYBQHSLw2X9Xw3PpTaogGbMJuUQ7HrsxNZuBKgERYOUTIdcBNzsEHaOR0Hf/eMfP0Bzts2fOx11zsPz/3hw553z8R8J+aNk7ZqyDZ2sRjt34a+9npo1K5WcPXvkGXTPw49t39hXPID2Ru2haY/i66oxTcb3ZrZSjFSeHmmohMxwCdoAYqEmwGKEUT+ZpFwi7Ci1J8MONAzYHfxhoDHV5Uksm1CtMKBe4Y0+enHF5GLq4kfxEGJiHcwemfpPQITWmeRa9FbUe+P3MKfReCr3vQrtRffR2ER2f+s0u77VQv4V64sT3fmNiuNi1oBiriJ7zMyiUaHT54rbtKs/fOA5RRNTxINqoSyEyxKWBXCZIUayjAo0snzsBpDmo1eRo7al3BROJ4FBfaVPqShgOSVNhVCwCVPEUwty8ROBILru2A6qwM5gFrGeqMMlmC2FAZb/8MSgiJLFXBXk4oIGuToNrCu0PpV7N3Pz6V1DGig/VyQddEhwMjkd2umF2KVPeR60+xG2JVM7IiWmUrqKIkY/WHCGO85/5wy34O7j+eV3v3pNUzpa1z2zf7vdMgJTsr1/ZnddNN10zat3L2+PowC0jLI5A/F2fPeTPxlc9OwHgz95su7ZE/m5921bLGQaGxYmMwvWztYsy8xeuyCTXNjQmBEWb7tvbj7ervEv6UWovkpfgVI11CL5FC7B3crdT2VrY1FqDkF7ZjOxkt+dgW6wN/P7qfqGI0tDMohqTjgddnDC+WTB9MYCOsxOY0jIDE/R+ctGs/Q+FOa5B7td9OCxEElT0YaK7OPhGUu8pBfg5xYA/5AEsRVLEiKSzoUREXWCuBYb9Tz8WkyGbuzC2IFv0/QcvvuwXUaikprSrHM3YMFIjBbR3mSyNU8JWCTvtAXzYmlPnTK3xttxoMMYGlDqPGlfc647GkKy/eHvIq56v0BLRAnqlqQWifA6HeGn8TzmBYIVJGFJJ4lzJZ5I8ONtNiu0WMej2Uwt5OQz6v+XIjZTqhkRpK/3dlqRYNRJfK3L55PEVpdYk754zuKOngVirc0my5LLLy7o6Vg8fVU6bOPrc/EN2GQjKWTEd1TvSWWbCQU2d2wf+Gi7fczAZiZLwU27W9eiqCWzEvttMst9n3de3I247oud6PPMeF8TFbykUpdnOGrUDBXsMGeF+ugkxvva581rb8eD8fIyjQOWWlAUNeevnLPCGYDBadwl9JxlaskUF2RXwEwdH4gqqm3sZOIcjrJSOMVe7FkH1gz8aGlZRo2/pkkLamkZaPkJtaC522I0GXQGA69XFjm6/tTZfNnM9n0zBndPq3F5XJ6Laqa/Of35y279+Y78gZFHbvrB9N+2Q9j8ja6a8Pz8ykUPf3tX1x87lAHH0gUGzPN6bLPjl6fcVev3TfW617oidqRvc3tcmWnz//0/bo0PNbpXTalz1Yen/gI57npa/ebp7JS6uqvne1a74080Xv3zE1+b0dm9qM2wcYV7jdsgywaXGH90rCwE1fVzMNoU6HGGvXF0SfElw0XMrixgHX5Mtx5qPpjqbvuJZjaLOjHV0BDyDqNz4/p1tclc/RL9hoV59T8Wt4WI32iXku2JmlW1FskeMkYDVlJnmT5zukFyooHv7sMNllq9vT3R5bDUNfE10+coc0SC4rWrahLtSclu9JNQ22Ik5xdu0C+pzyVr163f6DQ6iAjpptfwTXUWR1ei3a6vtTTgfd8dQE7JAGVb6og1EDWG7FL5HKvYj+XOpZjGD47qh6z/t1EVkh3HBK589tC4odEI7ezW7JeImi1DGWXdSPlIQyb5EQ49c/756BnTpBZNuNNRdPi889TNwpqPtm0yymObTW97qe4WakXUKkVJR75KAoA6BUBymCVooH04t19g5vrOZrVhMjedFnwug72j3SYpJhe5+N4sNotS47RGg4MQj7fWbTC2pVtmCYJZsuMuNP2zYpu9sSZsm37I6Rq3ta0yCrpmXx1xGGb0SaIZZ++9mLhMimRuDDdbDS6fIE5tmRbgXc5D023hmkZ7m/hZ9ZUubJfMgjCrJU2mj+fLTYEzfoWgfbSGcTKwBfEapUrvsbVXN3K52d23i3eXbGtR/mNGXDHzQjTwyOvqT7+g/ueboeY3n7v8aH3Q19y09dCsRX2LptyA1r6sO377gcErByOXX8Bv2jDb4rtNLf7lf115P78f33yRYHR/aTsfJVPuWb66/8GvGKLh249f6px+Xa+Bte3CM3nyL4A7Mf434xAGSYjampG1uzbyL4+u7EKRmKqeOMOdee2Lh4S/qf+YN++4+suiHv8dxX/9wquarvOZZ9i8ruDWwc61hbuO28Xdxt2pSdk4HZwkattRrIen1BocmlYqYt0CKIJb244oqtAQZQDRIPoR5RvBj/QittHBWk+n7Erl2K1+j/HS4zklNTgd2USWxpUFd9Tf/KnWi1LT1140o3FxZKpvcyx6wcsX2NLX+qZGFjfmLlo7PWZwtvXNcCudDofTJpokydVsMJh75s10uZG39k/qb06cRwwGQgz6kKQ3iPAL6/U6vd6e0JlMOr3ZNIPYgMa1zpRtsq0D22x8gEkC/eS0evVCwWMnh7ovmip6Mov3nLdj1dpr9HGPx+s1Bqbqr1m7asd5ty3JeMTwTIOhuTEQ54neYhEEQ7vbHW01I56PbuTtHmEhuv/0T9BFI7slgQhw/HoFo14UjIaoZDJLgjesM5r08LMZBd7Fi5IZG83YacTEoxtz1xEZY5U6Sic9OdZWD8XIAHsR81EvnFOHTx4eHP3AAGDmzN4OKZR1Dag9nkJ7vMri4TeoOZ6K3XRtT6sp2SDjxtkFSjoZ1FF2h8z0Ieiml01TG2pBpzhM9zFNydasiHnFbFY+hOcg4vIIyl3fN6pWC8HDw2blNKeY8WBxyKxQU2l5TSZGKH8/qbtKA9ilMTnpMcK4mpSDCavPZRcqMZgLj8aZmA16TSEYb8WKve6OmjB2qd98qybolL3CEApfc+0d2Iwddt+93ggyfVn9nXrzL2pCDruXIBH9nxe++TrStITV7/kczmDNW2i2C4dr7qizy+Y7rr1GfePJWocjVPMLtAfVfdmMIjX3ArFkfv2bL6jBkp4pV7pbq+caKZbDjbtfc4//rkywbHoZTWiplre19rW29qFW9nq8WmH5dIL/zKO8xzLyvsXD81/SRtr2PXldlliy6+Tv2dBFfVo2+vceGrWWhd5FvzXLsrl4S4lMztUk8Pp0X1+6+GSCnQF7GC+hhUsxaKCUIfy4iAX2QAuCY9qC6LmeyVYsnQco0BCZE2RezFNeykBKvVDd3tHHRx2ifVprtO7pL7RIU5VaYpB3sTqH0VfQq6mBvHq9uh/dQPKM75saQGuDyvotseCMZGejvyNR2+S+tev6Fddk1vdR+6L5gdRImLyg/rRRfb+J8Z1yZziR3qUZAX5nAHGeYnhVA6VpUJCTUy2AGGCnjRE37OMEdIjpHmfPahY9KR/JTjc4cp+t87zAZfOL1wsO9YO2NZ9+4dNr2vgCdCQHC0zNpQYSy1Z3x/78kq59SbvupT/Hulcvey5wXqfNNv8y1IamYEfyig29vRuuSBbfUU+mBuiqG0g1rTv0uffvOoIEn+Kgy8+h+NTTR+56/3OH1rE1jwGfVIWbGX0G1IVoZU8q0i8xmWuJmVenz17GQqXPbEZ71jPzSfTpdmlPmhvyC4P7/QZT/MW0qb6u8YU2Q6NJqnfccYevqdHQ9kJjXb0p/WLcZPDvH5eqse6OO+oax6bB+XHZsItmMzaOZmvyjS260WCqv+suv9EwJk3lG2V0nae5TeP5qUyokKrPSKXbDcohhH2vmp9a5hGKJYZqSZO3jGn0CBTP5LVbn2CFmyocXZQoFvxh//lzPX0ec3zeXP/suYHAvJe+t/R4iYuK+gESH7r8GB9knNRPHf9sZ4mNGjC4Pc5aiwfPCJnjDa290ZufcqHrq5mpjunp5c0zu++a4swtXVozvZjP5aqZqAPpy4/0TNc4qLM7NVagXpF9Vh9ZkHUu68mFbt81q+sIVzU+Wdg5ruO4SFLWcC7MGKHUXhg9ibGTfb0Ntg+KeblFeuHJSPgeNI6WYqRGL9JuYjR6IxnUcBcqj+f2iww9GwwEQjO64nWYCHhe3OJBit3l1M09H0asWEgsGkihfo27yl+0asXLL6FNGsXVn1aHOz/70u57nkOomwT5Y5c/dGQTut711M3R3taGuDk0A3sstU6P24AC6f48znsSTUFCRLw05wLqIBh1d89sXp6e7liYTA1U2KuewHnLcrloaXSLMFidsx85IAxc6nJO7zly+WVHumbtuj2U61nmzC4gMIiyou+vtv9fgi2+PBLUXEMLamD3xJKs3X7KzHyv9gU89p8db4xZL1adfC1CiXrJaN8PZEwSwGEo5lcmP4+OmerUWdCAARrydNqLE0/7ZaPAsUb7vGFXNUxOBrgrPwaEVsCZqx6fFNdF+fNUV40JAjAeEP1v4TUgwkmZEa1pmeK9Llhx1IcrlidgbxLZnQ+7a6UqqSWDtUwCrEqTlFJyuVyRTbtemGjSW6aPznm+RM2X5jozg851ZsENd4yba7Z+OmfjHEDivBLg6vhJwDakQS3pZkNbnKWBql/6aFAtAfZYeqieYUZMJzObKakfSqKjHiH6hQEaMk5Hk8pDq4bjirKWfjvg8Fq7fS3aDE5wHEcfUK3QibQ2j2vKijQ9JFUPQy5wHP9oPU7WNi5FP/5E9SGhURW9UdZEVyKLstVah4LAytYaoxoYlvhBqalo81pkHt+0jRnW+lJjvKMNhdTqpLqapXbFND1NpDWlF1U0a9nHGcJjdTbP6nmlMmQZ36pLWWvtk/SleK52tbLhqgiIasqkDjdizRpjB4Xqkk7QczsblbPbdcnoLE8AA9yZj9KFM6JfYs843QcLkhKaqUQ446OUldKLxGjMIaWiYqxMlFMKPQqrGRJTaisTjSVZlAS0mtNFTwgaBbSYy4KtNDv8l+iPpu5BaXoVGXIx2X84dl2ZmIulEN1RC6I1NNAiM7RAhgG6qEE90SVR+pgShFTCOcPEcCStEHfW5Y5SwQCgIWP0WKe8n6xLyjAMhbbLlYUtRXLDWywxhhB4qLFHxgvKZjRD1gk/VMRiQwmXxjFiNv8oqwGKympxlBh3ZTNpMQYoH2Vgs7x0lERnA72I7SFRxpejcpuUju9BLBS5mKBEyJWhdGk068qyymHXo+3sQYB8pdKQQbupjSWyDYCvZ2hWymWmr0yKTUgmxNjOMEb0HSUZJgIfy5RsP0oW4qbMQmbdMgoJLDx1QUv8DOOjdiHhb7wWC5mFrSIWBCTaLNEGGbsJ8RBsMiJRb8EGg4iwFSNCBFEnISLC4UqMxGoziHoiCcjqILoUvCVk9vHECySphJEo8MSoUP60KIRrgqIomQgmemSSSMgqmHm9QREsRG/SC8Rk1RmQbNMhvaDTEZ9BqZVqRQEZDWZsEbHZADUKgo5IAQPvkQWeR4S3kJY2URRsuEEnWEQJOiRh3mrR2cSD50sCj4E4F1GzgokZ2RCRJGgdJrLZHISW2008b9JhN0IEkRqCMC9ir5ViJVgHuYjB4sCiTad3iYKIsdnkIEKtzmCSBatPCitYMEpY8AqQ0KGz1NsFgjGvxyJCDiy4BGKGccJIL2KjSZEQvfZvkMwKFSgw8Zg2HoYRSc2iVRKw4CE1AoGeCQZs1Ek6RP9ZJYMBWWTeKUo8guHWS4Ig6E2SKNQTCRPehWVC7GaDjZj0RMZWl3z8xP1EIXYRSXobwQbeKEp0qjByWgWT3igKGBaTQKx6C2/GMHdYwTyRlFrM22zoLCUl9XtIRgYTknSiqFOwCwFYuJDNDCCFYej1HiIYqSVawWDACMG4YiSIPOJtIq/XYUHPi3qFiBZBks06G69ziuw+AMbGWiPo9GazXkAWKxHddGKtJt4qeGAsDVTBwg4V6GGE3AB3NciqsyCTFcZM0ksQaOARzCvv4IUaXk8QjyUdDCgMt9ULTdAjiyTY9DwRRZNILDCSS+6RELJBF4zIJ/MwZxaYRhSI8cg0lZC4DmHKMwmJok8PmxnNgx1NNbzg5AnUJjltLizWOgy6sCiZRQOGQeehrw28okNmu5GIdpEXdB5M6qxBpAe4key8zkP0GKAYIABwBZvZBC1QiFVHCOZ1TTZDULZhK0HUhilAI9GLRjOShVo74QmALxEshji4ZKOk0+t1xK7okaDjFZseajISGzYZdDpJEjGMqqBDRh6boQew0hA2iMLIbeFPQz2ALJhoa3UwzRTSCFQAywqLAkBxjQgr14j1hLdBZ4ghYa6Xa6wuXqrVMQ0J5xmneAujm5xUG7KM5etLWrlUhtUPYM7EJjgbx75F4ZAEp1v7HIWGWuHPFVdSPdXN0Sg+FnsIv+FufftuTSGoY/cUm039zbeEB27UW+XSncjvIXnkCqrJio9teAgdiM28/RmNsRT0GxuMx4a3kLVzHVz1Nzk1XY5aOF07gXoJpoOo/DvHt1zH+3mOov5qnudGwEUlCvHHsgbJzPTD30iuzPqiJjD+MJmH0t8C0N83ChyTVXVJFVN3VOmYfSsqIdwo16sKs3B3hlNUhX4ESuCa+F811qlK0cuM23GKF/0BvVvXGBu1hclmjspetrLvlVSNQdBZtjsVcgbZdwjGX7Fi+gUBji99W4VexdOPow+egbI/5Nb3oUGNjYcG+9YLXL7IqQGNpTJEuzYEQ0CVT/J96zWj4OurZU/nUtsslFXgHP0ykJ6dQGXmU4YqBknljxhpdrOsEBTTxoNmZLECUR9FF98HnS5/MOg+9VH10fvoAJU+BnQfuhgCFK/JFKd3aSwNuhgysS9pFbxRZgWM/G7ifP7YuFzUCBjNRVOwulkKWregaLKVHLNzLnPTuOncDG45t5Zx9CmBYtO4CVlqWHvir1iXOHTlr1kz8xFMZokJEUNeXEqBlz552e3Ltt4k9u/snNkn8GM/e23oW3L7nbcv6TOUPns9otnmIytLErIkuHXZ7Zc9uVTom9m5s1+8SROAxACFSxehi5qa3ZG6u4qWST6RLSSYfKFaX/pSdvHxRUtvFLbfVRdxNzehzSyyrKt2n7hVeI8LcjO5y0sWU4AU9vOMbANSbNS4SwaVjb+Uw7JlESHiznCaNr62z8RKdgBKCmSUz+JmLuE532u+eJOfBIyK1B631nhN9SToO1HbGPcd8hVn+E744rG6Qz7fa7WN41OR3ecdWr7zhuUnlq9evXLXzhWvrRjnR7k4lB4g9SZvjTXeLilGcDfFfT+u9R704T+Bw1d70BeDRLX1YxMV33xv+cHl5/14+c4bV65eDSWP9ZbsXOaZfW9OgwuOGmmhZhXpB7G061jJj6T8m4+fLsB2ec82jKacfAyhzjmDmw833vosyj/+Juyhe3+T8VlPoinP3dNzeHN/r/8nQG9cB2vOzHTsg9TqO4O6rCbdX5K4aabHQBDF0nJIdgp/b5+9+XR+8+x29Pdc2bxW1JtT31Hfw/+qvufIrz5/9+7zSQ26tySYds0sdTn6Yn0E3ateE9G2HVSSz5S4Rdw6bjO3k7udOzBq819AjMfI9jiGnFtKS53h7EkmnMvkNBvYN2TYtTTDtqmgcGnSKYMxw0xxM3IimSA9zGwQlEV91OIKFMKsuCMJcsWQU2LG/MGdpbUSjXmGrkCnfUTw58022VJcdJWOB5x4w/K999+5co1R2rBs78Hls/TmXbvM+lnLD+5dtkESGpvP23f/3uUbJEipuwp/2SLbzHm/QHyn17Uklq67ZEFMe7UsTbTEFlyyTnshy2DQsthLLALgSb8YxMOwYw7pAeez8F4ymC/+40vYiLVD0qte6wiHbDlA+fb08Wha28K70ysWrbhx4J70inqzfv58vbl+Rfqegc4rYotXpO5Z2DYN8X1oj07K2UJhx/6mvcnOMH0UO5N7m8LsgYc6jGGHrtVLbIAWoX8P4FxOXXrNoA7zvI33qoUcOrKf8NpdjHZu1HMNXIRL0i9LjLmLKZ2QZY0Vp5xJSiioR0GFHiKlT3SmMhWPOFS+FSoO0y9CIPpJCGpbYFZXXv05ai6y53dRl8qsE2AuTn6pOfmKWQEUKH17AjJDGerX4z9Xf44/r/5c/SzqonpF9KsViIsPjvyDz2s+xtfmz+wVbhJuYpagHWXLGpr1jpKQfklzAzFmU6rK7xyXXrjpse13XDLy92veePyx6/AFhm6b2VB8cvGlmw8OEF3vstyK3uI3vQ110Rr0sKHHZjKol/Zeu2x1N559yUPbH7uE6K77zOP/dk3xSYPJ1m3AFy48vPnygZG/967ILevFsz3RukCteinE9RjQw92rl10LhW0YI+NH9bRna9/4YHJ97Psxo7r9crLM8hqvhzpe785NsTT6QSCO5PMOg/pHQ5tVu5XLw3ATGG41X6UdnK98m5QNv8cXZx8nylumGVCNwVFW7j/NadYiMFd1w6OMsFiBfbVU/ZNv8Ny2+Kqv2PnBsVfk2h0du9vSbB5/YuveY239TeausuD9h4mc7IwvSNQWg3bHFuOyFKMpa7HZyzeH42rnJgk/27I0uzvU/oT3qm/bTuUnCKx2v8ayofs0I8NDFWPK5HfjQ9Bfqywt02G1Mv3Sv3N+WPEDsGtfwd0E2wFbBVltdUixHpxNN4gh9iErOI8UZ5AxXbU7k1gPuyCmzNxk+mxj5MF0MkWxTVGKZZPyOQfh5iuXbu6bPm16XfPlXt20sGKbYduMFl6Y7MLqYbG1r6+1rqYldJ7nwo75l8xaNhvtFv6sjYPdog2U+qUtCOua5t65WXinOqZ6tFYsWde3emqdL6drN8xstCOcPrL6OtMCnHs8bE+uSDVPcdfUdnQmpy+fm1jekq3pUr+ljZnFrpDrL7648cm4SY4M7FavUG+uRIwbV1KlA5XmNrK9dIyQY0RTkMlohmG1j0hQhRp2sFUuB0iwZDG3fCOnKbVQvDmd1SSW3CV7b1QKTGTKyh8yaUb0HZ+77fZPIT6xve9qg9EimFZYEunVu66dNbOv7+ezN3VE3kGPSI3utsi8JfOX3Hjt0gPTrTpKN15q9VuF0NTmns75uf6FU1uXNuD86Lf3cqGpF619Pr9bMYWjS27sstcCTflg+9rOjtXzZ87scbT4PGe4WPrqjdlpoZY2u9Mdt5l0FvMVbf5oZApuWBDVTY+Ena5ab1f3rBXz66r4ohfTWycl2qoZw2V9SmQlt1PUBsTldCtVvdV63KINmRUBaLldWXdlsGh6l+IaHbmY9t06GQZpvG3DtoiOmGu7UnsbVi7b5m/3I9yV61LMCFnEqaHu1edvWtXe3CaHZadkBZpbaWi+xIJXvDqwE2j9qbH5opXoLKLT6o0u6N9y5cFntu/o6nbZ5Bphpd0y+hl1IYjxasRLBGh8S06vr7Fcb46Jb6l/umlRZ7DVZw+Gfe0d8z+zeMOhlZ0znSGEyUoDMeOoWfKYkFG0eqW4UVHv+M6VAy0zOqYHgi2t/QM7ljyKFr5YEz51W3lu7BxnqMhxjP+uwL3c45rViOq+y+P86H/YP76+8d8Ipd8pr/pEfZV7bIzKTR738VNWuym5y+QRBCoWV7FriO6pONVRJ7FMFHrOBFWFoUXVXxil+3DtmUdKNikUpjPZTK18AOGLwkzuu7ViyzTipjtFL0KTvPmjKLJF/Q1usp86Zc/YX7bbBZG+T/3w/zL3HvBtFGn/+M5sUV9Ju2qWbFnFkhwXObYsyd2K7RQnTuL0hCSOScNxAukEEhJECCWhBwidmHbUHBydl3DojnIcPbxwHHdwZ+44Xo6jXeGAxNr8Z2ZXxSUJ9/7/v9/nD7F2dnd2d2Z2duZ55nme73f5crcb/YHzXnyxqQn90X9QjqRvVxL0s+Ta92L4WnRpDF8rvHwNOeleLg2R65peTPcoR6BbSZC1h0RW/jdRDmp6npUd40FjFS8bmmO28EzQLztFkF8kgMmKHxJkWmgMCkUgMiK5gG/pdZC83aB5QcPKLv6gSy3yXn2Ixkop1mQTdEjv5UU1UtwBoxENL4utroGgk0GajBwTAJGwiK43pH9KdpnUEGW08xoaAOwvgf8AoDW83YhxTdUxW5XLh27iTMkgAjkZZmoWiwEPRFi1x2FGBKiIxjHAshFCYcGURUrMoRdV4l/tNGfHmA3YusNhS9yR9WsbRU2lpb/53J/3bfvTlWuePH9xefd0txrqIWeOHLn/hvv3rm2eyqsD9lhNy/yCFWbmTSmDIDqLrNN6lk72/SxUv/ebA5te2dXQu/Pi9r7bPXqPajxntzSfdsMHd1/4wFcLmv1bFxXXtG2a11kt9Uxauxic99cjshUoV7euPLk/UztBJgdTKkcG35NWzj8shjhdPs+uqbCuaXriL5N2PNnf98TO08pnTjdYGS3LmWveuvf6ey/pb8KVs0Wrm+c5ljvMT+XHGW9f6Hs4VAdCf5p727md9b07LmpbfauH1fIVZrvYsvDAe3decN8XC5p8WxcUV0/YOGdKtbR85c3ZYOScbctF5DXsVeq1RngFUqDGHselNmFBJxCJ+qNIxrFGrJGREip9PScd+IB2jZ8XW3H55SuWNPetu35gcHDgntfAojPPPAv9B4R8GRZucwb3OGpj/itfubJx1Uq8+vLONpztLHjRMOkWz393aSh2qYIHbIF5pNgeu4q4dFtID6Pj3qjXFrBiMcwfjUQjVva2n0o/f/t66ZsXt2x5EZiuB+43frX14R1Htm8/smPOZae1F3NIr3pcT6848s6RI+/A9W9Lzz6FM4IyYHpxS+r5jee9N/TeeeGJC2f4h1pbcZ4jR7JriBinQU8VUhVEEyTUpSp7DAcblSBRzxeGtS2wBukUZvkLxuE7Vm/tqBEdR9AnN103vcyA1xXLpu86sGt6mbyBZf0HjiXxd8ckD3wedP5AVhxUGFQ42QtSe7sDFmnw08uvPm/GjPOuljdSGaTwBRL5pRM5zqCggjfAIP2GMmSiZQimASoGQ4lSAiN2JkRCmESfRtIiSIm1GawHpDZSdEK+Vub6lp39MQjJEMEdSGHcgRQgvhKi7JgvX5ugkhCjBBiyzLoKvAHW7HMPYhL59xEzfMpJmGDyyiyDCdoBTJAyy8/CYTiZwgeV5w6PsSmiqIiX+EcGMB/k6Ll1APamkyJ7ZjoJe2Xq7Ox8xySPDRhED9N7LCkyb+RzkeD+mWJk/DnXyFYVRrTT8DYOjmi23+W1xBhtSJ6DHnfKdzfsRsq1NKWU8RTvjh753FxMsRMjkuS+e5udsbthIyS270AMw4dRKp4phyS4oIRYcRWqKHmhvKIe9F9SP/nsCACRsyfXPwCm1Jcv75QuXaKdUN4cs6PpOdZcPkG7WHrA13LWnOlsasIyumHoU+KJ76wO/ntFWVV1dVXZjj+EwPyZV0ekYwlVVVGJIJQUVakSXzrKrm2d0ddD3vkjaDxbR+L/yhWMC5vsros9CsmKvkxRbzV7BVMV8Fr9JNQSLJWeBMvAGXPh7JVn/GQlc5X01Kz5rfOsOukpJPaDTmgpm3xG64Nv01cNeek/gprO5cs7p55++tBH6VegsGbbxIg7kn4fXAW+GT/+as/4uuI/D8fYryVzIg7JLgkFMQRABK+6YZ8eMndwqhHL/Bjkj0Gq+fY3pU9ufUh69UwVUO/VGk2qzne39T23b9asfc/1LX980t68lfnda4F47a2g8E26UHpF+uTN7dfs0Rao92mgdlkfyv42umpy2768lfsLVq3f/iYqY+lxK/c39rcYd8o7DLgWB6m6ORz0yyrHWhgSEs3alS4U5jB6AKusHfEMCS9hQxj/NoMH+7fAWsK7e32w/Di1iy/loZUxMWq6kHbpnILTUFoo9RVqNDadm3YHtSaz1sxZIM+DJWNlBTeOkXUXoMrxKtXaQDSwLhAA2DJWDtCzeGjhUCaTNogu0Nk0GrJSZkC30rnQTdXo5laIHoOeNTorKtUYWXcdp8pRXUI5HA/Zpxizt2LLxrRcfHVWmBNjYYAj2Ym/B+YSLhmRI+MRB0wq2e5jzjC/gyRhQQY6efPdKs5VE1atauoxWbpv3mcxVcDl5Ez6NbKBSr7LrhD9Ry/2i1dgRCuwDnR9cyUgZ6ZBhR75INjlrORdTmk3O71p+r7S7ulNm3g5x2tks1XOl5KO/aGo6CPAPYlvcuU30uOZcUHG3bLh+Y9CghqSfTAsvSomI9KXxExBJgfIhSEIhiNyEaDoLqlPuu3IVbsXuBzhG3eU109sfh2sOHIEzMrD6WKNjlFAXd+AW8Fn4FYmedkXeze8NrWmd/Gs1nVBTn3ZF0D44lc58C6reQzsrp+C0IMP5tYgcPxGA44Yy9UiW4faIH4LJ0FSACfHUEDiH71IelP69239vaf7fYUV0RnTbgLa225L346xEw6fAmGBbfhRyApXMsm+R1fPvrGubq5FLNbyfY++/uhne784BdzCse9PjbSw45wjaHwAxyn6PDSGeWU7rGyAiIusbJxQHOLRKEEHcNDLVkGX/sRQxGjNZuYlqZ9RCwaB/TXjMIEpopN9EFyuZkT6VYvj2I4CyBaa6NJVQGd00PW8UGBWa6Xq5TCf/2Pe8PVQpPQg+XQkOfKYx4jh1j+cQKMcWL0KkqCKqiuVQwt7JYqsyI6511UL5X0SgFjaCzF6X2ldflhiKpXJPcZebVcqcy0+muqqTdXlZJMU0mZnUosUuSjj9I7Rc8yxGnmVEatNXMYUhL3JwIhdMpnJ+AQxCs8a2CQErEGfityOTt749o3B2uCMlTO8LbRXNOj01QsbOs4pV1kZnVnQMVZV+bZLt5FdwUx2z+loWFit1xlEUEkdB/N+fjkwDN7jBWmqrKIMu/6+mD7cd+ONfViEqZkxowZ26IIGURsOT23SlnBmM1eibZqanw6HtaKBhU8B86Xd1/55H4TvLIdwORZKmaxdRY00YhfWQFivbEvxjlos8WZjuZuHE6OQ1XsaSbZ43V1KYobGNFnNhClUBwqUS+9BKmdsqStlUMpqxHNBEi/lgwHgyeLFps9E+eelyTsfkJfpsWnFYETzQW9WriR8MCaqlFpCbJMkvFzRmVDzK5ENFpkpOxKTyZQt2MMti4+BNUMStEXeXOYP+5NHieoA4aDoFNfV4nLVrJg2MHH9JfsuWT+xQztOmzR8YkiibUfyjMrGJqaqoKDS0Bq2dPd0W8KthsqCgiqmqbHyjEXXPPXzp65ZRJOV13ANupunq3bKeTMrK2eeN2XVTF2F7qZrrrkJbWauumVjddfmmsJYwOUK1BbZHeGaitraipqww15Ui4/FCms2d1VvvGXFgxsnTNj4IBn/ZfxZJ4lDIcvUOduQzCVJ3CVMediUwVzAugxpZjg6IBr0eukXGg1IELrIXkyISJAmjw4QpN9eGUkS9KJaoH9alA+zLiYwSqQIvRnASLK0nIWFzOAEEn6iKIkFLs9ZgDK2LEwSyJ7ErsxSAj9IbjyICSl7MSHlMi3MWJsvPxtbm28FdOPkZf0Hxu2+F/byAugldp4BwoI5gKq1TP8usUHv/jDuNrwLKn56dcuB/q6W4iOjyxgijssyTkXWDzeiIEOcsIz4MagV7tDmFfYkZRzgcU1Qfr2eFyTSxqBXlL48QSGpfI50FbWQ6s1ZdNisrwYdR18pASuQwQlwJKYnjjoA/noziGYhMhwN2w+GarEPppvJOnbIpl4mKLtt6AINfR22hkkbBjZMri/YAybtKeg/4KnrrvN09XWR7cRGABituqOvIaCTUoobx++ICXvnufv2ndux68DmxcbajtcsK5u7N2zobl5pea2luK+vuCVxoH9RURn+uMuKFmHcjNxexzafdkJxbZloXLz5wC76t4pDRzbGXG6L6TlJL47UH7OF8ZRg0hKFZpSYfcgXgd6lJyb74pM1Ifnt4ZBhq3yGSBI12bCFyfUyhPTdHwadnNbc5Mdu797iw0B9uNiL0/4ms5ZzBj+8Gx+qn4xah5adDhIty63S1oMff3xwj+W3VxNoDXcJkuIE6SyyerdfQDslbog5wq7+rWUPOXiZdXkLahqF71O2q2JtNiD7RrE5iHSkO0WyrlAKjnok4xElDRBkR2ZgiErKLlCQ2rMkgQ4ySQwct2cJjdLHkLwlez4NDqWW7GGpPahNc3FikRFRYj8+MoxO/MhgsB8V/CXLhglFtveRN00qC7xyp0cdtnwE5yqX3NCdSHT/8I2KOtB/jOo/oEp8fDCxZwlGvMSLMAfp8QMbpGQ6hZ7PaFCf8uD2goOYoSuHh15JtcnSgCobZSp3KdJlbDIGy/A0m83pz+denVxPwP/rJ+fDKeAoFoocR8PE4T3Y1Y5NpZPosxj6Fn8EtA59KFCGiO0lzngDI9M/EN4MiEZv2rPnsGz3leNXRDQbyDi4cwirgXWkkV1l9mJeVKDM8GYwDGYmGGVHWAFHWgXZw9jPQbG8J0t7C/eAc7R66Vd6sIK4N1AYeDgDPcMLcDCTyj8q8Myewt7SY0l8F45Y4TukS4v0oF5/VGAoLA4cpejejNGIH8hZ945TuTSO+s5i2I+2JT1MPU+9Rf2R+hpJUEZQDCpB82ju6uiIfXbEfmAMruqTnQ/8/+z6U+UfWV+MCm7OeFuOwmTC3NJZMS2H2U3l0sfz0vQJjh//v5gfnuD48DJjDFVcNwKQReUzwA9ma/rP0RXPO5b+5xgH//l/MKP0z5OW7Oi1GHh0UBbg8tyB8QrkSb6Zp6jfU9/+3/9K/je9NOuXkddfC0CGc8AfHe5t1Awi1tEY9xFvVoP5P9K7f2zvO441YTQO4rTcC8mpvPIklftl+iZIoFESc+Ek/j/ro6foUUPXMkkPHrA9x5KkX9EpuaC9vVnHKjldmft8ALlCGgwioSOR5TLHttcmasVw6yuBcc2IcyJ5fVkGCX+GRsKafZs1MRkEYpiBNkisszHZNpudhsmym/QaSN7Oq19QQZYiB15D0joxdcv4+Zkk5qtMZey15Ltxii+LCeeAbMVRlvCQhgtVL+i16UNkn/aMug9OwjA2/2Qst9inc8CZQHcj/urBDL6EjF0foqrRt9gpR1Gesuo/Siok2tMYVUzL0mKSSD9M6lhqICctetBBMDB2bb46qRCZwegg2PDYUsEZgMovi+DldDRi9qv8IWwVjIaicWzIjMYjdnQ02ghlX18QsbOM3aZKAuljaWAwIf1+Im7+3oFEYiDV6/EkU6mkx9ObwvtEGJoIAgnMPsE6AUx40P9ID+M1HjAw6El51I6kQ422g2DAo8GaYMLT4KexnJdQ/E841AuJdQKLuVZvNE7aMxT3xr1ITMKY29OiDJoYksmDHyc8YNBDpzwJHG9xnIpOkxKpVOrjgyCRSCZTnqHBYbypmP0kR5k6wu9RhgghOIijkICIH59E5bhrYYY9Nd92m5JtV5gGI2PDwgOChL0A6P8a4Zs4olw/hs91rHJJKblsKflZcqkSI0smE7om5NINvwA2DC8YRHL2dPqfTARJceOwRjuSD1elAcxYB+FmbY3WqZXCWi14ByVqtFppG9gL9o15+BBJkSPoR86yTdqmHfuwzK2GyvXfmXJROd+WHK8uM9ZBOAc/XL7vXvQEclPwDirXWIfhdLmsZG8v2KuUOKwd+zAu13TqCibCzBnWXsM5IoSxDjKRU9V62OEvRxUVPx+cPeZhSi7XIVSuzfntNYJnQhjrICrXCas7xmF4aPTLRTlwwcY4jMci1L/gZvIecak0YCTlMupISu5h/Yb+cuzGIuMb6htwTvaeP7oTnOhtk3tOBwYmQs+R7/kfvEBw5oneCb5nJbrn5lw5f2Tj05UnaE7FDi3LjVUybmo+Uo9sy7e4sxp5bQuI5o0heKnxByIicAli208PejwyUbrHkyYwSRwO5vLQRKYYIr7B07ELWmBWswGPIXxTdzDnjpbnA2IkEet4bBtuafCDPPw5XFYsAioyY4StqUUjoCUCBrJObm3HBkQDQx5/LIUXQgdk6KYBeoPJNGAyAUpGEZVRcOne3AK3ODSHLFb3olkq6w/OyLKOHc3sWTknMGar5S8ZyDgPP1FawEDLjZXDw1tNFhAG5RXlIVwC+o1hjnqMXACybmKXvdFP9HRImqARjKQxAG8TUCTqOJLqKFJH9JvCTTAAxnfVSpS8+lDbtUzGTiJNIK/309M9Hs8QycDg3/z5R4fKQ1EKW20LkI2TWabn67LEtPv3j6KmZQbyiGufGwvrQZnTvYQBKFefFtgIMmTHWSqyfMqfsTPQ1IZuKdm9AZv4yWyW6D9QVzrYvYFOnuAETODDG7phCrsGkKnvQD8SfuXsYxynxiw3D/PUHCTrkXk6n6ro5BloalTBNnSDJC73CU4wqXRiZIkBKfEJjlMELy9xPEHWCzWUmSCj4e+vUYk1kKF0arIRg5noAou8/JqLNxg7h+y1B/lp0dquaf2wWTauX0Y2TJrQBfRPG2rq2dPTs4f5RjG9y6Bmu/cswcyPS/a80D8NZ5T+R5bWZUN6+kp8w2nT6L/jS3vSd8kn5ZAEaZN85Z7hPiM62Y8y00u5kagkim9jXmccxmELLDSGVFDATLE/OFs+3P/Kao54RDQ6nk8b9Sq9yWhmWX/L8o033bIcE9dKlIh1SPTBw1/fGQUDP5H+rPI5NWaLUePnOuKrBrbOixXrccwuyYZ/MJqrdObFWUxZinx31dRCPBPwwBcGtYRpLy9tl5GlfCHZP9JNY8oyWrSoeMbvCzOhjGVMXjfHy+pk8RcmC5rnNhfgH3hTNvnMvrPH3Tz5ock3lp+9L7F8/8Wz75t98f7licHm4CXX/uLAkhnJe/dd2u9tudQVWXf32mvvvG7PmrvXRlyXgr7uuR0dc4f/nHfOfVadznrfOQsvnFbJ85XTLgTqt86bvqHJr+HEcS0rJ+x4+8uDsxduWT1zrt8ze8bqLQtmDQz/ruz4LSjjHv5qTjr6yoxJSBVPJ3LmZ0wcO4pEaRCSc4ksrCD8bCSrksxluZXFXJYhHCEFamUgO9TCBLwXxALe6MiCIcWVzbEv5ZeLWMztNu7b6LFU6WKn9DshyiRKlxSAoHDsMprK4BfiQgOq4mq2Pix9UL6//VgqW26k2aVip9mMcKm/vFi63mHyVxSDtbbHB3JVeRA0Rife1dIgXR+dmKvMkoHqsCfLYaRwkhdSJVQtYRoiJtQggRshuNAtwA1GAvtRpjD08NDkhmjkF/KJys8KvCq9GlA7nAVV6oJL7rukQD2+xiFpZV+aabIvzbTVD34pDX354Gq0BcyXD346kmz9jXOvu+5cdAN0m+4VK7qdDlMVeKtfvpp8+hK+bHXuNmi4HvHdjl03G4Hyk+392OMCfy7/Qd3UjprxSq2qCpwONa6rFP/P6hYpqDJlqqVGt0FVhZr/bd10xHe/HFv5M36IuIv9+Colg8400Tdh0ikF/7OayEZB8MR/VHhFzkMbeZZp/3ErJMwI/64SE+X3hfycDAHhraETAp8S+CQvyBEPmSRMKJVRNtK776b2f7g/9a70Lqh4l06+C1KjrsHJM0h1FA8vgleeTIIKcB/ATObG7LoIHouxHzWeK+dQy6i11DbqQrLyehf1GLHiozqh4QDVI56XDuWlUR703lAa1SJw4jynPH6iNJufNmfTUbwvEoaykTYBU68J/UuaBk3on7LHUKYhJDDSvaZ09jzZgLF3M1uJUvZzW3TbDfiCH9C0Oi36A8HPxCiaYAPJ8U3eb/qbUYekMXaUDZA3yj9pgOQz4fjToST+ww+i8S+lYGnKa3U2qoyaj6W1jG+Qykz4Qgg2ABhhNlSsg5noOOxoymTRI+LE7TUTMYYG9+T9e2e3rryv59Cn3x6On74iHi+sqD/n2Jn+ImLvKvKjvsWm/FrV725YOKkwMWlDw2rp22VGwWTyFPsXXHF354ZfbghGth+2aYqLi8HfYN9iT3X8/PT9G42BAhdvozf6G8zHeGJ/+4e5ARu1t6bZkMAyW/y81124sEGjFgPwU7/FWt4cbImLG/SsSbDg2J9M3VnUg8uoGmoStQl/h5zKGhPJL0qHomio1KDmsJJK2a2oXugkqqvV9v+qWejEE6+98dhD775P//Vv11tEts5QI4adFf4Km90prn5irWgpqz7n0P17K73XHXvof9VW0JEyrXqmFzzykvrs59ZLdU9vqRzkNHQh51CJnI5h6D80RDXcYTNUPbdY/WIZ+Op/15B4bQnJJWT9oERm5ByxfmCzjIw/hZ1jLShomUqBHyKGUBqPWuPGXkWRKvMi73Afrjx+rWoO8yV5fr3CMzp8ec1m0aAZHROl4UB6DGM9ZjHhmrFW27RwonQZY9e3GAwM2Con4BVjVmDv2CtRjPfot+hiM2M3sDo5ke4bu3I53/hnKSvG1AHWDDwNrhDGrSSAdZiQQvaTFLC73ohMVvQEJMoSBBtZ3C4aF5I2iyJn8JVHCzm1haMLYPn1iffuGJ4H3HL4fvDyJIyuosje2BF8orQJRwJMb7hh5846vRmoneDqeybPNBwbkU86WviLQ7KsCo8f4naxg5SWKkV1qERtT5vtLB3SAJFguAYI9xFmPoph4iMkgYusGzB3AiDd2uY+2AhamvTgW+n6+azNbrZLrVIr2tjY+dJ1HqES/PtjS1Gh9WPw70oBth+t1TaBtqHm4vvAijYQlW6X9N6A/osv9AEv5kzyxFWYMmmcVN+pimfxd5PEx5jKAet7fRjwDcjYF+y56aS5lNXaXOmUza8VLCxlMLkEo4q56xjlh6zfBhOuilItTKpEflwGaxPL5hCNJnUExV8DvLIFMGvm8yq+FLKimyOijqPeh9fxiNNLJZyTTqK/Q0wyY6oYGhhmuaDn/Bv1F43mO2LYQVl/h/5686wbdG+eheM7jQbl/vfQIYFSeIyYHJ/KtNw6ijDCZxz7HslcMUWALIARdS+eGeeseOxDYjEbVQ4A7DeV+QefJpsbayvgYMclyTkVtUgbra1QNrGV8QldZSEz2XWQS5inyWYK+e2tXVQgfXx+sLy0ZaKzYFEtVtzRIbo2l5aMzmJzQaCsaaZyUMa7T5JYTp5yUkFqArWUWkNtRZKI8paVpUebxS47xRInl2CewMhmgxRCGF0LjQrY+z9uQ0MDUGXRcuxAFSTeiK1KJAKTdwuQd2sWr1BmHwqeOk5pDXqdRgMo/PoGZM6lwbxoWBbKIDjSo1br18Dsmu26trBQ+krwW0H33PQNX0tfK4A6QEDHpEcUzBwwwwqvzLtN+h/yrcENxymdI/tAoDlOkb4AyCaSF5A7SPIPnIOBcsBMq1+QvnIBGV4HiF9b0aPmwx4BCArkjvTVN1ZUpPlnkwukn1nXyPRRVN4t7xn2MHlM6EUfyhBZ22ySfTuHWb/xiMbnHyXO7go8NJlPQVzwYgfWlANJNA7yA5qKQ5MrQuPiaM9o3T2jsWZp84Ry/xSDoDfcbWDVA2B89527ZwNH5gIHnBLraWxy2exzC8zFAbFyzrV+V0NVWaKo4DSTeqfWbQDalr4bMvo2xN+0G3Nq5aNfyHS9mcnMir9beuQMl5TXgYPORCJDiY0SSZmXRgYjy0JfgKRiHEungsxqYlySg18htRz9uLP8IyMeItKyTh2ig0ocd/7t3YUghHdDoBAEsHU2ADyD+CT+Ybg0yUgTUDQ8alGsxK6lfHi9K2D14wh/P4YN8kYjIu2PegnoQSTWCr1WPy0Cq5c4FDOZNxSS2WxIrE4kSl/w/UGHmqY1WuMtkpR86Zm9wHIZtKIjtLrgcgB2Pv06/Dwt0UztjNNm1DaOi4R52xpnYM6asy6tnrawK05/du+9Q2UavdXiOHov8APTfZ8wQY1eoy/75D7pW+m38N43XYVCor+9NdziDVaHdK4lgaIJ21bU9TQ2lDd5u+X+xmL/MXo3qtOkH1Mn9sR1on9knb5ISww9vE7d6866dOKKlVOZU1TpgzddlWB0jdrWtDd0hLpJfQDSt85nZYw5KoD91m146YX0gCCZu/BqaRJ0pynpEe5bo65gKBlsSFPBVhNK0yhNozTB1mOivmmFQ1TFOB/aMmgrr/F9SMbPPhkXiyBmYwxZq0/FQxnxORtvjAl9lFiBKuAL+aJmjIuBhVsctJwJUiaUSJggxopXDDG+hkz8g5SCRTPHdVZ2BM7yAJvOd35fuHmuf5x/3ay5Z7sD7nCge9kBTUBjABDC4gB9YFl3IIyOnz2vex3KNbc58VkVYFng8FdU2uqru8tnLwZPzsKnzgvdGGKRqKGN1gc6KjvHzVy0eHZ5d3W9rbLC74AMhAAw1IhLlZLUR90jnqbIYkyS8NhFyPdHqaxZlnTidB6k8NdIVtspj5LGs4CHzAIeG5OUPviAQA8qawyA+kD6AC8ZEGBFlDhOHZa+P4x9bulE8iPpGcce2aFyjwNM/kgeImTMRoKMs1qi9hw+vAfiX+xRi2SZzcTHtR3P5uiG2eJogOw5r0KNnlfIURUIqfJxDmyWAJCBz4FxFQ7LYNZINxzeE4/1nr7uGVLeUfXZeZaERvrZWi3zDtlK29PXHt6z+h44c9UZ6+UKRKFbuiG557DYG1Eq4hxWVUOHpEVXOvEt8BbdAdfw7KxvtMyP5JN9G9B3KZotPEvILrP440xCSmzr+VuqfcXeLbuiJn2h3hTdtWXvinbZyQUmYPLYVa1Tn6YfSVPz77/wvNmdTszW5uycfd6F98+XB0JFRqKymBB+PB7avWZvYITHw+j9EVFCinCXTaEWRZPJUfT55Zw96TzHT0x0cZQwLSZ72jB7nrxBR5DElgIeApxBZLq89IxjxCzF4ughwpon/3aRdqOJnDuIZL2unE95QIFyDIRxeNNwZ9p4FKMNKJ81jkXLOkV70ckAgYiBsjc5/RO9Ws/QUkLHH6fWXyNPdjtXeBo3TG62MOZSk8Fu1rNi3YQ1dQU9e3p4EOZ1IEUz6CpWfue9UsqkUYFeKOhW2x/ZPESmJtrTf797fVXjVK/ar9LXOLSeaRMmCmUVuFbeYp0Ae4FKg+tWctzDybbIyjzmWQuWWGnMwEdQe5B6kU3h8sdjJdjgNECEU+C44dFZmyyQl5IqjV6XMLDzpP+RvqA5XpMw6we1JrCjt/swmAtY3sLIUipI/iBd/1h3r3SRSTvIaPBLs4CCeUCTEC0gyUPLplnPXilmeX2OyDoGoL2YI6kcb73oj/YSTGvuyN3So48aCl11978uPfq69Cf8exMztOpnjU1l8FiapRN1Hu/QZPoZ/Acmz+rsfH647wsecKhAPFaLtKoMPj1HIlDyzTv0FatFUXoDRERxNdbiGkQRvCzWwotHrGRegc+CCMpXK+IrGuTM8P0TYqrLz0ePDikg9HaNAvie/3z4BnqcfDt0WxCR3iAFoSeNfD4uFS6aXMw3UD58xameD+KxTISLDHuvGfF85oq82oi5SoKRDQDkFhhZWPD+aOz2MdqANL8m0xAj30HlqHrJL2HkcvKXpBFGvjC4bYw2SJB4ETPpYXHUszAMjV9kI9GA6A0BL80GmH7T0OVVcKXtpRcND9tAPwPOqEmfZ5Tq2GQy/fP0L+kHH05//kk0ern0+UqwAnqeAO8dXX7nnaT/6o8nuH8puHFeDRS9KhbdV/TGvUBkP5b+PfRhetJkMK4I/AR82nFsSgPzTPDYFDS8vSZ9C3Rg5bV33AHmgHHPK21lUsk8HfPyvlV5HKoCHGql0CjsWTew56nKeUqnNZKxbJtbQDwDUEun5FFptUXNGLRLt0kbpVpp47alGp5RW9CI2WtTq40r27+9XhauGyYdePfApAZ55/pv21ca1Wob6OUF5lMyNg0NSAM2NdQsveree69aqoHySYtoWrl4pwVeQqT1u3xbJ2EPyElbfXeRA+lzLTsXrzSJFkH+/onc4B/FrYV9OAkLqYIeQJh6GU+OzMujSAYKzVfODEbwfxOEx+sZXHL8dCk13IYl6/VEWsmh2wY9nMnmoUyU8nciO4gMWwtsSrwTOF0mKSVL/g+dwhACP5dhak8HLR/j6+Hc7KUV6V2ntOaQNRQksifpDIbWKA2RPZX/dLKulLRTCnt9jp2mPZnUmD9ZPxeQw/IaVQ7zKfbzyzHWD8iVAfx2rGQ+37SKclFRbGnN+rtggk1iGyK8CIDIHkEYBiWYuYEctzGCfGI0LyOU3YTBAwbp6c94i9lw84c6IBiSBgs4n139s79KH9/Ma7SC4XWw5IiKnNDqQHG+N6Qcxe/7DEwxAAs6LwDdhzcbzBbDzaD4rz9bzQKtlhxVHZHuft0gaDX0GyN9JHN2O9cI1gsylBNCHqJLjGJGeBS7VRV7PR6TyWwchZafvkGYKoCEKIiBdDIgqjXoXcaOR7nX2FeJLIfepYbNzRZ4kJaXgWOobVWhjARMVr/sNgtSFJrSL0ovgjWwHw3ImG8kfQCN2/1CjL5saGtgbWBX3YaBup2BAH0Z2tmJd3YFmCbpxTTGV8VX1eLc+KpafD28amhLAF00sAHlWxug9wXQRWhnZ2DtsHaRdf2RYcpj+K/KTrJ0ckyPVXlJYbiHKj2Mz7RqjBWFU/hy4UXJIbLKQ8vobTknrmQ+3ykczK7RSzWEDlXOSe/Opz5F4yQqEX2UPZ8qxL7V5SAHUI49wP056l/6qFCawoFWVrVaP6AxgUSqVDA7QUJoQa/cRd8TwKukgsWY0sFkIFAMkjablPSQuQzJwegZFO5tYma9RnEfxBSCZi+REGMe7PKVKi1xSSl0UynlNKNHSileN2DQaFhK5IfumOqR0H1BsjgYgEldireIw2WBkjxZAIRyssCoz/AQXK3M7pX/rYgDWCZanf8Wv4SrFVkA5ZEz3yzSF+e/z9y4z6GR3aq8U7sKO6ITSAXSfhraDBQCI+Nov7jrbqyt6wXv8GbpI7OBNwO/WToGPdJgepBOLiksvLGwu3AJHBjGxvrQjbW9deC/DPgS3oAvSSegB6BvUxqEvUvQFTcWFi7pPdF3X4B9ahVfSxVXnGEJigN5AWFMT20PgYRPfy43BLRdLbj0htCIbt8LkBIRGleE85GWQ/lE1gzL8kuSK0cAx0drMoNOEfDxrLxEEY+FICYvlvdGoZJ9CXrRSxlwh0q3/fLC0+u82nu1RhVnoyv6w/ddXqrXO2FwWHM9hvKjkaAXm0gGQq3Lerevanrij3pa4wDLt9VWDZSZWZga1li58R+iNytQbmJDAWZgRpM3ULwNh1FP4eANHGgjUbQnz61wlNMhSCWTYGb6T8cppJF/RBwT5dxw2YgpOYfhhlGuKhWMDvmjQc0wcqQY2UrMuYJdSoltopSyC+ZSmCy9UfHtNNAEPiG/ieil/mIp4XKBVLHfn/YMcwQdMX6NKJM8XCiDxKnLZC5NJ0vNgh3NEm0iSNi3nrhM4C6/318MUi6XlCiWfvfjy0R8k2Wbb8wOTlmmBL6/X37W7/PtnyM69x15TWnGbZv+giYjMbmCfjO/TET+pP+JytSLRiS7jTMCXuX3UaGsSB2MZ5MxirB0I6GbmEhZDPwhC+GooJxdTuKFZoIrxbRiAyP9tp/W61jGIDpc6AWIn0t3ti7DDdQG6XZcqOXt4PTB1Ut0Go4up20GhjFaClzF/K5XasC7Jo2WdrAuyUHT4DUjkhAcUNBJO8e/dr5QUlxoNTGswaD/y0G9FVOzcCzLMhCwH4mGjQaxfrzAb+KFdwBlR883HMQmWUAzNA2TG/R6fpMz0KHXGzfojFv30gy6EEBWpVL0cXoItUdrzpN2+Eq+jOyCjX84ZAtzbMnMy5lQYXNmJYceQk3ewQui4fRluKbLvnv+mQNIRThDYzBo2bLeynl9oJoEj70Fbhf4O9GLvEq6Buc8gLrY+aLhQl7444N/2Kku0J6vA1DDFpb0dL0v8BcaROmiJ2QgY0DVHqfod5D+sFzmV8+KmNhzsRWDPdnHy7C8eL2VDoXV2DiXXWvC3NxKNRQGSQwnRL/zq4MCf4lBbNvR3VHAmo1nqExGDdy4OxCYtcMd6K6NhSpnVLWNCxeYX7xNNFzCC/Vr25sEzqyfpTbyBtoeb1lQtuwcc1lgWrgqWtcbnxhwgmU3feR8GLfGw5qKyogDPesSLYQ6uMKpnj+zsMY3zm41CX5Xxbj6xqnj9r3tfhxDQz/C+bxlJk6w7DcCWksL/iL7/A5nRcjlFwWLvSrYMmGh8s52o3fWkpHBeaCyKQzBISqUdRiOZwWYYEYOz4R/lwObHVtndgv8ffZ3H7gXlPBatfUFk0Z6E+N7bNhzh02aR9bUbqv/72tw0Wjy/f21yvwg0gbLVvPC1Y9bHpVuNgmCHqx/XWM43yDOny3w6MRG0XARzouSzXMEAmSIRA3Co055/Qp4vwJNku1usshRg1GVkfoqkjQaVyOZbmbNdTgLBxc/hDoFiUsEHnn7G+l5tVor/FLUvi8GtONUz6utz5u1GrX0q/dJn/sD8MlbVBUwVeDPMIjzBL7PIMI2k8kkSAuCCxwLzeBu0cSb08+Jhj5emCcazuAF6UmDqPDdy3pHHdHVccfH/Cj5Jct2xtynk03Joxoj7u7HkVz9YH36Fekh8ANZsFSJhnszZumMrRq6XqHPeOU8KQHukHb96+yRzmvowPWo7Ft5IY9zSE3pkbRTgEbbs1DPEP2izWKvjYlxr90bCfnxAaQEyQdkHZEmPYb20zKDNJ0tbW48pDPvxSsO29pUdHbBQYXt83DWwWkAgC1+6UMPuOMy/yRwcMads9CR9V7pfYLZ/d7dKsdBh+onR+5FW50ZDryN6/Ow90q8OXMRq9Wa9jrZ08AZp6scuxyq5eDMpaxzr0mrZRevx1mu8T2Gxox5oBypzwxm9XoomUymkSotvYd20KFDyaQH9dL0jQ4H7EO/vBb2EVlbXlkGC40GvUO6EfQ55F+9wSjdp2TA+m3dcYr5DLVjhJpCcIZsmOyEZ1RWf9QXsvrNPvQZxZEUZI4E/WbslGiviUcj1hgGP3XTdG2Y8RHg0ZoWDu+gqQHttHDMVcL1W7cYVJEZW86ffXN32c3CFPGV4vU1ahOnNXStfzfhvXl26c0zt/c1H3FXTG5aWDNTrW4IdlRPCFe7xckFJU01neUTVGyjr62iMVgi0MknuwoPXDZ53aQqG3P8GBiijoOnImA/AMUddwMw9B38dkhV3Hh6+raSupICPQelnwKa1ZucvjD43hvx2rUcANIbaHpQ8/bisIyFQfAklBhJbNe3s3KcYN6UzFA2HtzI8+n76kqhJwsL4UHq4G95XurjbZ7SumODGZQHmcMje99S9N1MwW1q95oxkPzwuGyLTTwFNPfIffYwemapje/IL0rdK2PBT4xMMyW8DRc5/WKutBinKu3J6maAHyuJ5U8fqtNODiObl1Bt1GxUowimA/Kr0GQEZOyljPokTzpEq2IxuVWsFWDaAuz5gpkLABI+rDhjVMSsBCG/KoK3YkRk7v3ZFD2mv2PS32ilX2DvCCmFV+JSxH8Fu7p0pJ8GG/UaTJSmFz47B8alqzijjtdYv39HGpxW9c+qadLHkz6981Om73dVJsYCfPpj7gzwk0m0sARu4+iAcNFfT4NmQaOhAb35L4vSX6kFHYRwG31Bf//VV/f3wwPpftn2k1/vWlzvQK7e7AnrDUbUjD5pO/yIet82rHbiCVshW+0/jVVraShXPeb8UU2gRfLXNtR/fQpWGtbL6qlOjBsXOMkrHr5iQP+H+3Bw7CoznvyVBazqJ0lHTpIdSSZXSJGd4xTZQb+9Y9U6D+79H6dIytNdpv7GXP1H1jJwklc/YgXlFPvMsApInrFbAw6MqPOw1si1kydblU1jNQXYdOoGIH2efVPp8+3YCzhAjPzEcn/iPh+wYDjvUDAUl+XQuB9zESqRTvgDwKAFSEbADheYg4RtW9hY29LZUTMpffsJKv2Vs65768SWsEMIGU2B4NxVJmidVdF/8dVn7rjbLZXfC6BKLbTMTu34Y2v/1E1dsflj1Tnesu3M2dUmtWqjijFsXWAvvGrVmv3PwapNm8AjKgdr0huEhvnPpDdRo+oeJx7QubqffJwbUT3xZM3xI+r+dn79XjhJQzBK5Y89MFbth0ZWk42M2R4ZrMiEsg67JPPWZYeNket+LEYWtKlshD+MU2E8ZkCoeonZmMAQYghWKKP4Wi2YCAyq8PISFXS6AgGXMzgQdErExgs8ziAzEDfSYbPZGNI0JC4q6TK33bpg+g6/M1hS4Oir7vAKTo1GpSu0iM5wZ5XXqAGiKNC8mgHWGZuI1QbdE7qyQRvod35rhaerua65PrBhYhcsdjnLAQg44QUFAQg3JRZ4haZAWaiiySJai2tKm9yOYFeFj3NY+E1Ulis9QeLKXAr2YvbljdTgAzYr0YahHTvBEAhjTPgLZepipUlwezTSmDeN/KksJ2qINXGwcYb0N0bN04JgARqjt6oz7BQthTqVRuMUvB3VfY6CkqDTv2P6glvbzF0lFyUaNCGj2Rym6UxLpP8itwFpj4ebF87YxFscXKB0etDhbiqtKbaKlqaKUFmgSfAuSGyCMFAAL3AGACh3uoph18QNgXrUcF0ejDyfWcvQEDtSOdWMWmMldT51OXU79Sj1S8Jlgr3h8SpZBMOpBZDAiP6PsuhPMeJFlOV7M6v4CKEsWHzEqwxWS4YZBg2IxPG1CPitFpS7NlaLeYxwYEYNqCVUdF4PQSRVAC89pJ8h8V4V8hMATGsEk5sSXy0kLskLdxh8w6yUw6+UY9QC3g1FZpPJXPR0W1v6pe6pM8DP2kMBr4ZrA4C32ECrSj/O721v95SM06uOQVrvitYWWS1Fq13Wi3wODkgXJBLQKmrbyi+VvpC+vLRigtZi0U4o3wuDe8tROm04bVokOkPtUfl1U4HXWlQdcVmtrkh1kfWJ9nYCYd3O6dDdwXf5Czx/va3GNGh60BeJfDZJWgTunbRLuqa0stAUBD7pHw5oLAaO9ftrrWXjSsCXd5SWWZ/UFPE2oTToaryg0RUMFjZ0TYg4gd6qo+tujURurU3TP5tT0cgajWxjxYJDj8wtb8LppvK5dCMofeEF+xL7GfFfn7O7oSgYLGogG1cT2CT9pdgEHcAk/T4guCqBevgaLvo60Hj5FxIjm+kfi6kV1E5qL3UL9TDR0zEyIXrXLBJ6amsCEYyha454x3gtmZcXRb0jSl5eIOonHaYZREa92DhmtfGh3RrCeqviPKSLYJhw1Cs8pIeACI3ujgGTI2Km78n9DPe9wBg9lH4tZLfZ7CEw+7TThhrWSq+sWQk8ixa5XQINFqn14fExcEhjjtWUL1pUOT5m1oDZi9GwFn7MFWrvCBUWhSZOQYoKTA/Mnw/fcvILG55OO59uWGRwonTjU/BTkh5yrj53JV8VKOyfDJ4sDExsDxYWBtsnBgrBzMXRmrBBvRjQgssNSv673QYqbR3hcMeBnp70r8BX0sVlVtoD1knnVjsCzT0vdTrrYh+k14yPx11zDBFtycQFZ8wMRCKBmYfQJupyaehfvjNx4juT0gs+39LYzVmtXHfjhq9wWmWxqFCa4aWN0t+Bceq+M+ZKP0x6eBa6Otj9cDe+yWzJEG8JOCJgn3SNF9rKwU7ZhxJz5f6bEnHEP+BkDTou1oQyCjNeFbZmFmVADOCDcJ72O1fwa6tFmwbgDr1OY/+61Em/qtOlvwHdOq3W9nWZQzokQFAQ+ruNXiVIU8M+zFWAXqHRWAlWmqxDp4H0TRazsRKe5aGvrKSGcYqIWU4RvN6DLQhWmrNjL6w4IEeADZC9WAggMdw+yviyy1r8tKBWqXe+qNGoTc8Ui3RcZX7WLUqrkLpt8TwtqNQaaQjcpP79sEVqGnzk0+nNvwXST3jeUELP0vvTISh5/UjBBh8C+N+mS0fj1FAynjnBl6CGmzdBiUUmzJT7Mub2ALnejEFY3RJV7PN6TUYLDynohkajqX/yH4Z2/WHyWhNvhMo+vVvZXzzVDBIWQQimk0FBrQWJA6l190zoXKkuKFCv7Jxwz7rhu5SMX8Wl2H3EPoqZi4vRp81YgTWkiiK9H/2LWzV6pHR/JT0g2dgKyYZ0avu1YD4AYEF6FpgvCdJP2TCYLdml+8EC8Ffpp5JAN0tvSX8GrdIn66TfEx71wLpeUIhZzqRPmN9Kf5beBrz0D+nv0i9AEb1L+oX0DzAeCeA6NLZ8S/xEdKi95PJg3Ga/Gf0F4qwKU4niPxqoNNh7jdUcu3OAvX1gaLaXNnrTC9vhe+3pf62Gq1d/AD5KSv70o7SnFwymkzBZcds9t0LnfunQNfDJHenjO+gd6fN74QVH7zh4cAz/iZnUGXl4+wqIbAaftsQXRLINfnO0zcJhMQC9LDpWY8MSEHqBdJCgz+I3SlOmvLHKlHu5GVcLz6fS059+CqaA2bGuWKxLmsxfNuXceUU1XRadkcUtxxp1lq6aonnnTrnsxKfgWaz2k7cXSrGFb3+iZUkavIrT0EacMsDd8lM+JQ+JJX/kbYefks4afX+SHvZtGgk+x0ifl0g2YjUTZUIoiuSvBdx83iPnnfcIfIRsMvxD8lc0dB8+pvzLfw5EMxDm7xa9bEQDInHvMHcr6tfSWTDWI0WlaE8f1IJjIxEO9ktvDsLH0tMHQPVYccXd7AXsXUgnwFGR7bgvABsXwvFBMfTuwvibRS8RvU0RvecSFvUG7PyMJD6RxDAgOZBGc1ArQCKLG3AiR/ASAugwg89grot4CYv9N+gq9dZoqKgwWNIZX8+/vLx1Gs1cu2Tx9k8sUyqqpY+kL8vDCcG9JN70yYet0SXz1UZDRcn8t146Izx5dsJS4OGEP8L4oJUzPeGcx1aUe4ekm7/fb7QaWBXU+K1ODV3kqytx7zwMdoBxtzSZALyntctjnj3bLOgbzWs3VRSeO3FxUq2+EW53+TXqqmqV1ucs9GtURYVqtX9IcK5q77SMr6LNaosv6u990aS57jrOV0c/fa/kcNcWmncFXRv0ReNctZqaV3Y8NMVZ6XYbdWEhsCDcZWkh+K3yu1KTEbsB6dWElTpIKIRjcRKGTkLsRdw+WILGCgSSqsXaWDCEPhojINyDuGFjmAeB5VRyW7tpdJzB+oYwSrjrnl1SDspDc6eqF+7pp2G8ctJVT1raQxW33F8RbLcawj73y+94S2rqdKzxDqnvTj3rNFbd9sNjPrfxEo25fMNvpb/v6QmWRxi1rYQDak4wrHkM0E84iouZ8aB0mEXu5vKwzbJGsMea287SL2mvXmgpng0arE6OtVg4VYFFdKiQcsCqCtK0KlTA9Pdz+pvrZrnCK8QJ/fBXUVvc2+rS+4yW8e6Oy18tYWstPl23pXCxwRK0Ah2oGTGXAKoDx26hZvVhmx4eVsI0kqaiqD8RZECv1Wu2uFEL0o902x9Z1HdowwzvfVM2dYy3sEDF/AtMlx41eNrHz3jrS38LgHVLzjmnAXredy5Yun5BJauSFg6lj7pro24A8231MvNriPNzYRg1e6PYKQMNfCok1OFntYBR9swNLRWNJbUFWgCOU4fVgC2IrurYXb7glhUTLwF35rfftKdswF46zg6u/CWYpK2Y3ze/4B6pp35L/wQIxjNVw+2Z9PEETKO6Y7Qd29hqOfzWZJDu1Bp4rXSbQa2xKDh/SPEySUmtFiRNosgQu8OxjF8IBdNsCt9T8T3Jwh3HldgumM7ex2oygB58d7DCwIjiMeKEzQwGTQDdXEqaFE4qQKsoOk3umUGvz2DX22XQCxWFSzCiUHBw+DOW86QGCkcWzaWUe8q25eGo95gNJ4WLMKJU8ELUFLfz6vwqoAbK+tRvRO0ZJNGKikqGBW6/j4ZRRWLGcjfR2mRuT5DhRJUJ6uwWG7sxNPeCZPXi+ROaZ82K3Hj9tRs3PDRlTZ+vcvnqydt6amtn+ifskz4ucrfGYoF2etrURwCNZpgJO3e+6PF4fWiH/ccn+692u32+CSWJ9kjPxvNeZrY3T5vWGhN03PXr1o6jTTSjz/rkEwxxWTqggDlgJixMyhY+kJ6P/7jk0FbsngWF9NYeWAn/J30mjKa3DX21E15PnzX0KbyN8D4SvFh2F5nvC5E0OR3pMRRVEyPzE6NsWXkWkzu3DEFJAiGbscpKFghCxM6HAySxhzz2Ri3Grgg4wFtFvgzlw6ixgY88drvHBg57bDaPfehYWVPj/KYmZmaiclrT/KZ9TeVlTWBqOAF/ujY5tCK5brJKb1BNWfbusikqg14FDuDzTWXlTUyRHd9H/vdWU5k0u7ypqRz8tKxJTK8OJ/6M9/4s/ybC8GZwffylrVtfil9oUHH6PWVle/ScypC+PnNVeWMjmkex3PUD4cowUj4kYVlACagGk8HXBAfFj6mYauxcUIUqBYJ43FFxePxuoZtAEAnhWOCR5R281IFOYsmHzHTBmLIkggd5NOrHkYqPDnN2iz+MujEmlOcwdxHW7lQkiMleY+NI0CmZYmk89tN4SgAyNwmaJYLyjICmTxwAwuNVFyxSIwGZDIk2nAW/ByPgZCmaXOyG1hiaYNB4hS4m8ff4ZsQGGyOM9y1IZ8DlsdrsNSoOqa+4Row8U4Vq0ZTPkWAxSyuoxaKcn0cqD3qkDd+gJgbcEBcGEEAVmkAOoUEyJDcEvj9uAiLcR0kB0d3ctMqC74kLiFfOyHpaEJ8kK2mo1nF5dowQCBqVktdG5E5yW9RCuFGVGyvt7GbhDToNw4rsEsaodahp6RaGYWlapeIYMwMgBJCeF2dUNA1VQAO0U/0O7wKvLlRsBDqNVTAYAO8rsDGMRRcyNnJqzlYQKNTqBCRTmAtsprUC0IwroIGv0FUEgcas0nKMTmUGwOIwWwCwadQhYGC1vE3rslXFYZnLw2p0LK3RWzo1Fc6CGJoUTAVl5qDP67IZIOQ4ncpAF86M2axlNhq4iwyCfaYaAk5t9TCQY1imJMyWMpb7NCa62K0u48MhxsAB2qINn3NRhV2nh+iRnJW2Q2iGNmMJaJ+RvoPWcRpIa2laR4O7oMbMsRqWgzRfJmh0j2v1NK+CkGfUdayBNmo0LA2BFjKMmlcDEw/jFhtUOewBZ1AdXFZoXh0U7Fqfu2K+2GWpmFwSKSy6OyEmSsodrNYHABq+tfx8s9thjXoiPo1BgHqWAT6a9lku8DtWTrCXl9OCRXvu+I5KHYMGPsGtUgdsQctZvJ6Btd2hCdH+kvqJLJIRVsQXGZGoodO6XDGf4BI0PLQFBZNF1NadVtrY3Bkdrwt5vF6aB7zRaXIxq4AIOFQVYKR1Bk6aDdRmllVrITBpaTV+3VC6WXAYC1ymIq1PVc6OP8tiab1zSylkKreHQ03Fgh60zHaX2KwTfGraDUBNLaDbCkSjikmw7lKrhlbvMmpoRlXfBkB9sbGiGNI6DSgSbW5QVsIYeb0d8E5WbTfqADQDvcas4TlUEporZkQGSZ8MY7QDoDeJRg2jgSzLcLQK8E1Ova6lWEOrClrHdxRx99ULq9UOa3FrYaEI2Amr9B7GfonGGC6ljY3VYUeH2qSGrEZVazJOCaq5cEG7vQiIWzzWNYucQsCjo8vMTgg1LDBafqlW0Qyt5VQAmuIMEAZ1ZjUAHACMi2a/gJwaGoHBwDEGlqNRswHm6Cv6ArvNZrYYBEac6jKpBE2RDXVj9JIKPQUANBlQt9abdfYFOtP4QIlGz2gFn6/Ta2Fpg7GMc+htOmMHb9ZwBWrOw9NcRe2EkPnntVN9GofJVoQZuFfHOixX1W54+bQd5VZQ5Co72LFs28Y1jW8vqJ5cCqEvgBpdLeqL2AA/Nz5p54TJrLfaX4CqVaDTTZ2sL464XTpjJqYdy2E85UEydJiqoVqo+dgrKBCk/dhoj3nB6GCI8eIZ2i5T+KKRBA0THjaowiMc8KliLJ7b0Q4jBkP4KjKWtIAaN2OPDYsAKFsOoSl23a5L/canP9/TbPVIv5YOgIXdNdfu2xEMMMIZ55y3L+UBYfrDd361YNz664b+jiZ0OPOZ77tmXrh54vbJTcZP6P1AY2mftnNigQg1dMn0SR1N0XK3dvsIHawEX8lZpy+4crruALy2umWpij/v40WLbunp4A2A/c1790z4xw1fNxV//em0v9BnAnDN3eID7zonxpqsku+zR4G+IFHfWRgt4+yoe9FIM2DhK2NhKCrt10L1YN0jTFcBzHccqXHTsu8UZg+GOJ61GBA+eBz3SmfsIC1QJsviCDusjBiHJaIYJlEUMF4cc32oYeH06j53YZlgvLq8o7SkwllVv+Gh3o7k+vbg1PlN+0+zebonRGZVl9UU1UT+dX/nxevbwNqPD+7um955lXTsufWmbmUHsHgHfFAzJ1bh0DlUKpPJaZ7u8Pocicr4onBx6/rO5sVNAb7ExltKQxFPZaWnqXLJhYFJW68++HG3af1zgL2qc3rfbnlHOoZ3iG5egfSG10gsSivVQSKmMvaMOMEUryHUwsE8K2UszmmxSwhx0AWYhC4LeUrHnID+LMAWWtN19mIO+O1u79c2N+0wMMVW6Xd4NRmcJvg+NU5vYTjO5qrxSn83aNRSj61TH++aTZ+zLGG7nWmZzsz4pd3nsxx7DD2g12ksMu5utqJry4oCrq86pZ3Sr8w2a4XNotVIrgKVxtbF7o4v6+8f+twM6sGF1Ig1B1lLGeVpeQpcUmxXJvIyGFQsrtm9gaDzKDGpsOg3xRB77RBFyMQhscQSeyzN5zIFs/yFLMUOEs5G2YoUov1W0Ub8kIYRqtTGxaifVhjWSOw2kuMzMTssVVcaKfpz5XeaoDPVFh4It6WcQc13lX8uipTWmQDVeQZIntEJKJPUe+F/XXjhf4HB0rpyMG+PtMooOIPSN+G2tjAwBZ2CEdyyR3qwvK60yAGSa9dKSQfdiy+4UC4rg8saIJ60iqDrP8FWbrMsphpV112XaFvSRv5QekM3THZvkAZJaeiEJHPb9Q5tICV5WxqPt/TVEsHlAwPdGzaAN3LlkN+jFTMBBlCXDIaCGSY6vNBms5fkL+6woMdkLqoqnd/sKGlqLHE0zx8XLjKbmIUjBpjPwQe2qb3FTiStlJYW+oCzuHeq7coxxogKpFu8yx5H/agTr/oRkjU0INS0gAAaVnCcWihAYqRZ4tYbCGIXTCxjxgPEx5eNE4J4grvDEkdau41NLb7lvc/fu2WxvAHrGZP0ocHISx8+rvVoH5c+5I0G6UMTw2oef1zDMiZQgk6Cksc1Ps3joASdBCXKSajL3QZtoka2V3rTpNVyPd8bDN/3cFqtCdT0skaz/vvvDSZ0FtTIZ/V6+az0JjprMnz/vV7R+37Onk8JqIdSATyu4WGNIyNgpKYkwDHKUCfESoiYjCE5sOMvkcKZr2J1T0qvPt736+OrH/xy99Vowgz2SBcN3oppYTe/BISbKsyCd/7i/UevO/usccW86q+oNrEnU/c0ST99f/eXD67e8cJr/9z+Jii89SZgf30nB8eNK57x1ubrju6PCMV8qYxHxqUUm3S54oFIzPHeUX74o2JTEnnoF3B1/heMzhwlZzjMXfUTGbKPGiLIHMSKCn6Sw80guBue4wNcL5ui2rA3F0U4GVR2m4V0AzQuos/CF4ZVGbrEVqAQNTQCcwh/H8UE1UcB9QFeDATA9Qadg+1vi6IQE15mLYm25eOTkVWdjbzxKUuhQxRp86sNMjzHITFYKx6iuw6JtUHx0KBTmpROPgu0z8LTaoMPbjsi1oqi+BJrGudxYkA3Vyhk4N+ymoSo5c+bBnDFgvKF8m2k30HqomefRR/48eMUUO1kJlMXE58/Ttbj7JFiiKQBiBQ9lgui2ZFG477dQogr8KIPPoKULIJ2g6QWPEviXzddE29hCPoDUbdwX0E6jYUguJA1cbyWh/QSJI9AewDpMKqd9kOOcTP05mJzAssMV9QgpURdFjxOORIWi7u7foKD1jpEI1AxjODfPPnAxqWOAq1/Xd8VTRzNGMuAoLexrEltqTWaimLlpYUGyAkaLQt5FVfQZBDM1uh/zY5aXEi+RzI9Z+bVgq+sJdBUxSCpHHIWLfCEajj6+8SnnujK4nGl1mZUiAtPY41BdwHDWvR66/yJVWrAOvwTy40FHCvSzLgJ7Q6HtvTKAcBdYbKxnIjkTYbWWWvWFhY1LawuZIG6pKGvs7TNoPdpoE3UOSHQs+Zib0PtoqCuxVdVrIGMs3xxS9+5WiNNA/QPskaNzPH7APcdO43SklGvippHraHOR19kVifGMzJJIgXUnsHpRM0aCIMSpMvhjzEeKwkgvReNjDg+VkC7WCF0Y8czbFhHny5RLqEbKECfMaRfykplgBwjh0JYuZVVdHgXNt/OsNqEjllb1BoDX6Qyu3n3E5V/Wr92VlXVkf71y5CWOCAd3/9H6fe8ZgCA/X8EARCcevUvpLT0qfSv93ZflrwfLJo6oZLheCPHXfabcGUlZHmtvn5Jx5a5BaK63I4KZlnY6ihjWKejCcxbEAlpamJOdWFJS8tDCwrH64sLd/xjyDfJyDu9voke1y0GF8vqDMU8q+tZ3Vvie2bZ0iWuoieaeq+bxNu/3C9vruy46sK+lvZtT63bDJjk/RdPTVzD61E3gI3NrZsNvA71qIY1cFnPjjr0dFSG1l4DerpjHGuY2Zve7HIKNa7Zj3dMjApccV0V55yWL19sojSUiHneCS8t0rXdeM0TqjCZcgkwqdBgabYxAnPmgy+9+OC+F3z+F6Rb0q8/cS8oYaJPvJ5+DJTc6+vpWfD91Vd/zzZLriHp9BXvA8ezYOJv0mXSZ++vAAeHwF/cv5GeVTCaKXY7ktXW4rUXGourHKUiSB1oPOYhNh8A9HnFcJrFabYYxKJhFmn+DI/UHDRE4bURHn/KHE6y2z0Le/pW9MxsMpk3SgffFp1O8RAoX10ypWfh8vlzvJteuWRTa0HUqbJN7lg2e36ikpt0/vL5zRGvjWX0atfkulo+GOk8s6mE5SyCWoV0JL4qtnDZBR0w1Dxj3tyuRrPZXsM5pnVv23Il+Fn3lmYPzbsLtNpPpB+AM1gA3jvMC2pDxdRdc6os/hldFRcOABrS5qK6qZsnFZrFcY2trdVG0/ZOzjJx6oaNV3QUdHaftnDOpJjRyC52quyt0YZiaJ9x/uxmt4C+H/raS1X2xnAQViPRxYrkl7+xFPEGt5AYKSJlAdnvHli9ZvwXsGaYlJi/bZ5VLw2lv561mfnNsbLM3+ZZ9IxZm4Grbd426Z/AsG1eG5h0nDoOpqCfy9vb527blidrFiBpqVqJ8RmTftR2ggAtJqkQkGbIMWUC0vtPFqwFrxyDh/TBkwVtDZOLlbIOZ1HNJ1EVTlhWzDWKC5ijUMUMpAMnLeygUkTQihlNZSZV6fhJSztKhpfXTHPFBKeKnqKCTotZDh0zW3Ac7EmCzFLYP0qvhH7pg0Mv/4iYLhX69otzsfTCCZD+FXtu2cnw/pUIeeA5Key/4qe+FMnlViqGozmJSIYlsrgdz65UBAumdjIa0TL4V5yQgmJLg+i1enHElkgfX90gvf3srdJ3txx5wLx9P1A9s+u9rdDVcJwymErNX0uljgDdC9X8/FhbT19HANwrrTGBX5WaPwFLX3/sD7cAza1PgLKWC2N/vOgZ6YfdHzk3JVV+8JHXQetMzkhrT9vE01XSH5NJv1Q/Bh9PLBSk0etTYRdIeVkTL47a5fgqbFcQhVEehnrtg/8zqyI4T8dc7i8PGTzu3Y1rXOtctV26+hpjk7Gj97Y/fXh02Pvc/VtOLf1T7K3/8P7Yr5/Tq5Y6eh3ttY/Ffx9/DASBC5w/zIIGsvwVWAe2QEZWxbJOQq0gmp/OhFIh0aUIyX6sNZMwxyjlJJN8Tjr8/AAvvE9zWo3B/tfMVuDRQbDN6LRL25TNYcCQozD1vHT4OYGHK9oApzUl7erJS7Opo1izfGILa8F75y7NJKQCA7D8HHvr5uK3/QpqtFUJFZIrkx2MslaxHxnTLclslNIAUYB75TiS3lNGeI/KT+50sohvJbZVjfE3Q4Spr1u2vkVlRTgMZDpi7CePeouXSDCKm0wcTW52HK3r5VQ+JKACHpQDOlJD+0UMrQvcTIT1BuG6s25Pok9a1TB9eoNKNCSSt5/FLCq7wLRoe2Xl9kWmC8q4aHRWR8exefR3H3xdv8FVKA06F1X2Li267baipb3hhU7gYfiqms4S8MqQZgsYSCSqvI4CaHaYYYHDW5VIqGy0MVJRUhEx0jbVUMmGEvf468ZLvwmWjXc4sGcneBsMgrexlydj8BZYuxPK94HxQGYTH2P8sWItUbYiIcUyl8wQK7QCOpcMKa6oSMvMJRVwOtQQYjwGAjTLft0yZ+lDdaq5jVXTjXHp1bh6blNVlzF+U5G1eVa84tY1tzptTbPjFbdF5RMxEIup5+HM0TuttqZ5TRW3rbnbMTQEYmukV+H3s5pP9zbea3U2zo9V3tN/t8OOE3dFNd3N6NooqI+pZ+G7RA867E3zYpUDawZwlnjFHXFuZmNlpzEmvVinlo6uAY1rR67XjCOccCN8RIBZIaCvBwoFfUjpsZkOrGBecDUtbDzQAvKdSOjBYq/vpejytrbl4eer9GXautL/h7b3AIyqyv6A373vvXnT25s+k5lMpqYnM5mZ9EwKAUIaoYcWeofQqzA0FRUUlKKCREVU7IoFRTfi6roW1MUt+rfgLrprW3sBMpfv3vcmBWT/ut//+wLz3q2v3HfLOfec8zt0PFgcy+zpDhZX+PIfD9AOtYO3GA1GC49DNFB4qi7WNTl/Ghz1GEzrvYMGpa9Ol/qlqJE4QZiRWVoc9LVY05fYIC/TyYjSCz7x8EFzC9UrSxTsB1jcmwdTw6kp1GKK4vEK5ocCqiUtCH/8GnFfg3BPfF9Sht8T9RLX26KZJqb2Wd5kFtZA/G0hx0cjRVQ6g5dqSIBy/Hi5iVLp3iiO+4nvDhw3bagFi37/b1bKaqR2phF9lpfFq3n+9WEblDoJrVG2rroH/SuVxqXL54ARL90IFHPksQaGUUr0uDdXIcmXgFm/sXMOvXbymw99XtZzB5gPGr/eseNrdBTdhI6SEBgF2kHFx1df/TF6AR1GL5AQTNy5p4efDJYBKR8od7SrLlB0Kc1CdxqQAxlQ6nk1kKKnkJSO96Z2PTO3Y3hMaeHtGqfSy847lVwtYXPSmbYHX3gLHZwJD987LwsWXXTjRuFhzj559ceg4pJn6PPhRNpfT/TFgI71e8kY8caMEsZoYMw6wPti/kCEMTOV6Osz6Lq//BFMfOcd9CmIfEY/4Et+d+PK24HxNeJaNGE4lNx13U+HbPf7T1+/7xMn24qq0JolI+rT7nev69UTF/xFKSk/VUDQA4yeVBf2RIBbF9YN+PXjv7G9wTDdTXcnMh3n5I7MBMBrUqL3f5kj8yzOKJPgwM84IKFQQkTxuEAl8Y37fyKkKPFEl+j18ZyQifbnhF7gTUJHifGsKRRL+cnyEctZo4HjU3qaOJdMttGYr9cfl+TfeuZ+9Bd0CP3lfkYPK01FJqbVdL6LUTLJZdnFkqrSUiiXabo1MjksLa1WjEGPmUxMB85mOuBx9PtBKwbh/6D8cY6D2jwpwrzhyYxbZ3iHDvKjFrUC/6nBI/5BQ/1vrJ0tzZOCDgBQF37/BRcS7I2iTgvgiZCC91OQyDQwm6U3V9IxEiwkoHT0eFVldmZcFUQXHp5YGsquq9r+fJZvZ/uq/GikuNQR9zTLd8HaZIVCAV8YBF4EwWs1mkVf4ier+PTG18eo1YFppVfqfk75smE/EtZQCrjJKBP3vPDI8obTzRx+CoHIw3QWHXPTFPyz8gn00LsH0JmTq1efBI4DIOevb619cuP/JBL/s3HMrkn1bglqhP+urXgH3ddNCoBS4Di5+o9/XLnpQ/Tzh5sKhkxo84l6ZeI8QWxXM6hmQSJhIsqBfkERnuyxhbwpoOUQm6I4TTECTuMP8GbimVtAJsX0FC3hUsYaZnxgwiFvpAhzg94BswSeHUzMYK22Ev27UquV6CUFq1cVSvToVFFDJNIAfhdpKMKh8/XTvZser3qZJPqitvd5yaCjGz1FoXqfSwIsL74ELJzTC2ZeZjyCxVpNZaVGK5EUFkrexhfDfandR65Z1FZY722XAHuuryjSEAkVskb0Mtfuqy/0lGrsaTteeWVHulVT8swlF8Shi7GsNIIXJjKfCu2UkWon0ky+3mYysX2hmNA4/kDMTL7df2gq0WI+8Eu9Jfo+lSryRUSlYrVs1sksVotQXmVebjwXtInnv5ZnZ7kW3xK9D+S6iOylwPisjim/ZZEzJ7s83cZ+fe+RryVWFwhfhCGxF18UX1MiycqS7HHl5Qk1U+fBWeWuZua7QHoOvnp2FqtH30ua0suznCGV1bzmgQfWWC2qQnDm8nyJE88+BEU5lgIQ61NLEV5QVDlJA2wkpahSAbiAkXSgi9Qkp7Yv61rm8Nv3Lm0bvtRu4O1g2x5yai9fdsdSMPxS/uWYvbKlc1EL+thgtxtWrWlbsrgV4MXUwUc/XLPeYHfwa22Ota1LloAHLuVqyBx1J5dgJwrPLWAbiQ8tmsn3OZ0XHppj3b055piYxfjLR5b3PPLoeTAEB5IPPdzzArgeDDn/6CM9m1/AKXTxCqIek9z/0M/nHwVydC67rCwbzr/v2+/vv7r0dvTjo+fPPgyUFaXo26yysqyB/ArB7KB8xD246Nb0MvQx252Mo/SJm2E3OD1xc3zg9+0Cp2H35okoPRnfzKRdrLAnxT+blGI+wT1ahu+jEyzWfQL2DVke3Fbg0QG8UtDGcIQn+BL4n0+H0waGh7yW/AIMWQtufv3119ugMfk5GIKeIgm3QAPOGYyOgcFrmU96MuExnLcYXY/LDIbHgPO119Dfe9rubDskJvYFB4wvmYBvWkB8AlEC203sNgaEtCnwbU4XI/YZUIh7xMgvGHFTYyTb7siKoB9SAbj+4SsMvDk2Zt2pcM0Vdz9yRUPt06diFVfQ5ouUKOsS7Rpg1IHhifHknCwEyufo5tLJkuSWzJM8nIOj3p6ncBD8fHH7yqnMCzLudTyfbqKOU69QJ6n3qH9Q/6Q+pb6kiOZS1Elj1sGshlwe6yGapE7OBUw46heNQIpilRBPD4RFFXRvGJHYJksinvcFjtrcS2FDSQppgwhLAmQCEezczDE1bY7lcYE8mEVcpmCy1AmrgNGMiTtplaizRBRWMZdGkwviJxIou5iZAyKsdKAShvHQJJl8GKdGjBpQBZmXhm2bNqs62z2+fFDB6v3enHJ7IG/aULmEkUlyOBerpyUAAE6qoz1b0gNuSMOyGB6J3r0V1hmdDokROV1ai04NPpEqjLydZcwSjY27U6az6jRPAHCXKf+G/Fi+vC6bbavMiWUZjHKLMkQHcz2ggtVxaomckzGcxqbPV68frw3WVaUNlirT001K00/rHDmZ1gy1R5Et5WBmS89RdXGOjs7+KXAsKrOnma1w9dqKODpbsGAouJ32lISLGc7YUu1Agzok8lwlf8olz6RXA0j+Tabz61dOGVI8N1bhjFVpffsfOL57CmRYGevj0pROq8/ktlVlNuI+Ide6GkyqkgojtEUmrr/ZwNg6TVqNmZ6rNqnkDAuBKl3nM+k0JjqotT3ZVejNoA0WrZ7PGWpL19JqldcVd1iDQajQ/IU1SjUSTMBDmgHZTrctzz5CJst1ALwCTZ5s9AbMuboSvlEji4y+66VsWiaX8VFO0TPSlu2K5hWzuQraq3ykAL2pAZxGIeVANlRxcJlBB5TJdSOUkkIAhCuLPK4ej7F/U2ZMk00kPghYf2o3hOjPko18wWJSUGsWR5mgUsfhTiLolkdBEUGgIep3RCJD9L8EikTUfRZ0vgyptT5ShPud0GVjKf6IuZ7lnUsaNsZZqULDAWnGvKmhzDHZnDKHN5gj+Za0QptapjPTGolaplXzCrtHIZWzcjNol5tzne7EJq99aMvYztjSQxA2ptXWl+xZsSbd1lw92ODJT3ekRda9iT5Hb6JP/pwIlLUNa8vn1Q2eCqc3R7qxJOf+bKN3VO2IWCDEq00ZhZjDMMjTHTTNuO2ccku+WiNX5lgMUs4AVYyckdBQo9boJIwS5Jtycx0jRoJgaWkQgFtndBYZdNVNcQAqhlYCOiMvc9XJQ+ifv5u/9A/A0TXu7nWLh8XT5FKfIWhxjBt+qz+t2a6yDBqyYv191ED8LCdeJdupVXg+0EA1CPTa5Mb8mKs2cxIDJieqaNqMCYUMicFFc/kwD8TyRCwgPP5NoiFogGynx8yEAMunYy4iUXEC2iDhTIL1L9EW1dCBKlhJlGpwRSava6+z+oFR2s6ho1aNG2TKq1buVfh8vtk+597bn1PuU/pmN/jS9nXtvX2vsy7HXt++alTjUuXI++hZq0Y1LFGPfqZOsVco49zXhf+lxfONjTPgzEZbXq0SZzTMFjJu35dW+9RoxdLmUavAG137nPE8Y3376lFDOrWjH6xW7lP4Zvt9pCDUkzs2zCF3xP+ctcfGaPCDrZ7aYMg/v3vU6kmDHTl1QpHZqRs64w+MUixlzE3LFKOerE09byqrNtc2bOZqUTdJxL0YRI2lxlOTqVnUXGobdSfZz/HnCy7mAqIyZyCloxjzk+lQYhAVOfE/wXCYKF/isUDkQoKOp6izSQsSSg8pFROkYbEQaw4An44FZjqAp10zYHX4E5JbCKgu4r6IUJeYX+PBBXSCODtQFNAJGi4xHRvKwZlGHdwBzAZDTjZXx9TWDrcwLlrSaNyo1tVB6UxpwAkhYG1mi17OAIlPUZo/HcprFDIrw0Da6qCtRXHlFSyjeoPmlH6n02ZWM4B2Gwq8vA4+V3Xt+Z/hE8kG5p2Zj0//28zcUygPVqBzt0WDm3aVuke2fFMllUsZh5sZ+sDgyTeM0rh8crC755w6mcepWKIQrZmbDfMgZnTLGAN4heakMkMaG4GzmidrIAOZsZYn7M5tMpABFVKieydnOY7RSXRQQmu1HuhhaDkASiMMlbCh4Q5JEQSF4LRGZdYoabPGhocho1bCXf/ISt78L0b6aTLqgjtdyX+5FlbTZU+Bded0qq6aEVZlcx4nw1OHHvoK07ycDjPSifN//FHynQpAJioDErKgJl5aOM+IJgk2w734CcQubzA1BveEldRV1F7qbupJqrtvp6fPqSt7Mew4oR+ITyZjv/s7EVNd9yvx/7/L8yI4mFsH0sl+ZoIc2NOl9Xvm9nTVTCoOwq5gh2OfI5hMF8CK/uMBUP+3/I6uYHEywSQm1fR7Rb4zY8WgJDV3z6QaCRUsDuLH6AieT/RVA+rLBZH6/1oA7ABUcbALUcQLN9Ghl1Ap2U0V1YLngEXUBsHz30PU76g3qA8xJXYBaIAL5IOqy+z49Tk3FNtd91/G6f/ye/6W/nEpGM//9Xr/Xz4fKyisnBc1Vbr7XQf874fEby3Yf4DUAH9Cv7kWoP77O0kov+2ssM8lwUc0ADb2218LPvorMEaXD55X94GfwP+iWo/6/9XdhP3J+AUt0812CNwfJbtU0Q4M1BfqtTFlDqH3Utp16D1HcavjDOg842gtRl2igt176L2elwXVugRKCKp1xcCL8x1nzuDSH4uadb17KSLeb5ogMRpOZF8iz0O82ZMFU/T1AlLLJxti9MSaAs98ngycQZy++AaUJtgePsG3i0hKYdpM6R9b0biuHB+b1pajIyObGjfXCwdwzQqgfyqjqia77quqmmTDk513vwmGVIz1l69tIsd1YHrTyPrNjeTABMvnNS/dP5Qcb02eal2xaH9D68pFB/JfQJ8uzatIU7SP2zX61IMrTjXPK2+4dSk+Dt2/dPbK1ob9i1a0NhxYRGyvLlCQ+O82ipiJvCllrC4+PH522L1kci702rptXpg7ecmoPUf2jKK/3vmir+dVQRMs4ntxZ+K7Awe+68cE6bU5cuHGBDo2kAtU5AOKSKgprA9hAxVTLAmYSCbi8OlkfbKePed1JeOOGkcy7vLm+WG3KccEu/15E8FEuO7TxQghmKQ85TqU0GpBQlfuoalgjRpQUukFSl0jmo3j+0tFPyT9FtE4i/UJz8GC1DnQGyfPxZLdXkyvioHUA/qEA35KYeHFByg4AYqDm9B8NJ99e0AkRwwfQ4PRYPas343i1rgVxVkI2VTQ7c/2gEfxr9scNYNuTzZ41JvV0Q1KD3U+8MADye29oVV3AfmhzmeffTZZgTq8ldrTavVpiP/IWVvpBV3+uPZpcAM+dsvl3dq4H3U+rY2L8hQkpViI31uG291P5VHVZKfW6KYJMqmfxtRdGLozMONDiT2ScxtMPncoUuRxR9yET/e4fcRTGM4ROiztcXPFCIALPe2dErBPf7hqhe796ejYX5KAPXnN6zNgcuHS81EQfP0P6E/A2jz+OdSDPodtY65eXnX/kmWFI5Yk6pMHmAfWoT/NaX8h+WQ8hl4H0r++CfirP9imcy5aHbr76HNDm274q6N2/fjH29IPrx62dmSpLfUNe/cynXj05+A3GSz46blkJeSFnSeyr0A2GWhPBFOphtSJxWXc0Ug/Og+BFqJDZg8eerhRBkrBTqHtYP3yruvnBRpGNj1858opx55dB+V1Q8CtYPfGxKHbrny98hrF0MLFCsTUzwVV6PmLJWBoZ8+XSxffllXUWdKSpUMnnmqfhB55Z/Hs9MZBcsOWR+7fdNWh32UEwcI1xTVA3tTLZ3G9OPUBgq7a53VA2H819+qeBQhVDgYgDMUMlAcIc0g+HleC6gwBoqUkede/cv31ryS375ptt89uqna59jUa2wzpKwbPpt98bP2Gxx7bsP6xPeiH42iY8sSW1U9bPwFbWyapTARfQPHMcaBgXKT+9eefe3OXJMu1t7Ep7pK6peVD6Q/XP4brP/rohmfRj+j5jY/uWzYBPHCgAIK9zwAp+oG6iG+U4veppZpSKABk65QSOUHBdDmKHzravwlW0ct0+EKp78TR5O19vXvLYpsQxvDdJV2LF3ch7bK24knWorzyVVZLuKLNZGije8Qvcb/hxsmzb5GDcXtOndpz05/gRzJ+WCX6q/iBftrx8vbt02dspzO7Fi9paV2MXj68tLTAYMDXKF9lcbNwgfgxbx40YdV1s3pO7d5z6q2b0HPAtxK8jdNR1/Tt21/esZ2ghV8YLfmKvUCpcL/MxTzyMAH1iOZ8guAVM08mO+aWaQ2giXZrNBYAxNoIYO6M5kkLAAntC/BEI5ElEidOzXJ+nBKjfTGitMZGMUVvous0EE3AY1/BaWQZsDnn6I1VUwpcNPOcDnJST8t1ksRxZSGvH3yT9JNT3JG/lyQD+e+iF/iPDK1BS6GnwFIA976tV5hUQW+Fu16R8U9Qsm7He2ji3oy2QeU6HdjtiioVAbAI3WBKo0t89uIG7wROCUvR1glDds4ZaTSCGbZynb7qitHJz9DNaR6a4dhDYBGY+4DWZKIfrULXPaME010OBhpMOdYoehHt9jV7DBkmk1xPDwHzX/hyBLrWMHrcLRNrVSpA2zWaCrGPxKVinyd7urX9SBG8G7cWISC5vpSBRqPuXuPRXkcguP1I9zAT9QVwetKWSZO2bKJ/HgctsiQls0CWFpKQXt3R2dXZQ+FDh1q/eaJjjvmOqTQ19Q7zHMfEzWA9KTQJnAYzpDwvTVrFKIUwuZ4g7jIT4hHTcglc+s5JGzZMQhM3iza1UjLdhqkyzMM3DeDT/pcHFnGS3SmPVma+12YW9L97KoVLn7j5so+eEFHtEuQFzp4TH3f6gPdm3EIaTGyeSF4iTh4/Lh77X0IEkCWvgtKFZgKbxAboeUaIYnogHfMnp4X3o7xkoDp7sfrIBhBxfxYjb9Z3FH0AEwVC8cie9ttQCMi9VtRt9coBCtn8PNj1sXB8kRwTBNY9wfttL4Jd+Pgx2NVe5Ndt91s9Hqt/u86Pc2/sOyR4HuEKfrRAOAyYa4xUNlUn6MGkQI/EWT5lgh2N4VT3gNR0IZXHqV5hL7GvNCO41wMD1dJmOZ9HW2/JspvY9C2L/n4fr+YdHZ4v0R9v3lPgsXLONRuB+S2L2uqZH1yPHn34tS6zK9OlSNv64EGQO8vIp2W/fil8fH06vzRDlm1Ik9pnKexfBI3bs1Rhq0fqXqfyAF2+eeiwfM7ndGVJfXUVyszxlwiCgOh/Fn8TnlDCxK8aR3OYvw7gUIyPuRkKvWUBZsTm7HCiUyDfgj4F53EY5DJvJZ92oSlO9JUT5MPBTnDQCXROPPZ0+HedjGKWUWq8whIv9OXUEGokNZWaRi3G3Oh2zI8eoO7D/Ogp4i2L9NIMYjNKZmwcxc1I2pajDeZe8P8I2RnMyCeWvTEzUcKJBGJFeLanzZzBI6SHMcHen+FKKe3gCM6RAZ4zCJ6NiFtjU+zSmBgRbcILaZJLlkCeSDDNfTFMrpp4rlCIQT4STdnhC/DLAlFHEihBPkFrMQWpksvUajVQyUwgS6FUSbVSFZArJDK1QiY7/4XBANVQp4PqsTYblMrMZpkU2I5brQo5NBqhXDHJbIZKldGoUnbguFoiMxhkEjXYiD40GuWcFmJWScvJJ/G8QopDOC5VTMVpBh5HVFKZEmx7SaPRYI5ArdYYNNPUaq1JC5RKoDVp/qzW2/RAIlFCuUwh5dSQmXl4ec+/VXrHqI4XgFMXKVl++NA3UCFXq+XJH76Rq4pOwQatlGWlWknyWfA5kHMKGacC8xPrZbL1CVn9G6/K5K+8IcMD8/MfvlQovvxByfZ8r1J936NyffajVsb9+JlEhkxwAdryI6fQ/wjW6RUtKOd7qYL/HrzNK9KR5Fuj8VtwTqZSJXXwMwS/kmvUiq8AUqjVTmT4QqHVKr4AXyi1WiT9p0qvVy1ZDtfRGhnHSvXJm5bfBfUqerNZnoHOdpsO9/sLJH1ahWkGgiBKUeneGJ5qyO58BTD97zFGAJcWo0VRyIN3wf6VJ9FtqAPddnIl2P8r8WOgC0w92Rs/SVOjRx4RdTGOjOw5MiACsgZEmCx8SogxfBqwl8tTNspDTcJjZzmVoK7Gc9Iv9+rMnM5NXCALitZEfAsESRnZwJVwRnG/nIOC3z1izQ6IbYiR7L8Se4MyGBKM7/Fr4wOmLNQASMx4kosJen/+iD9g4GhSNkAuI2H9HjIoi9jjjmAfAnIi2OHYAlbJlegPSjCNGJslKYjc4bLSG51aNQSS6oIrq96/7+ZxGpUFsHJGNmmUWgaLYnVei0qlcBmBWamXEVt4ZQzZi0aFh4KNGhV+HgGeQgnWXbUbmtjGsL3YCVdaljUWqBlmi7C/1oujHHTUoavTlKBEeU7PUMSi7RwFh9ucXKEJc1cA+INuSxk6xykBI7cFZ+XKNBCO6rx6fdutoaDGmC+BNOtcO+gQsluuDI6l12S1cz46yDACWJYJt0hyTtSOyeLaBaMXFSssDgAG9jPxGw3/bd+GNxJAYtz6kTDZWMdhAZKPlmiAh9DltEcg7Dy4telw5FdbeU79oYMJjoYMDVg6cfBQPXq7fRrmDnFcAm9YcgNkAcNgZnFa+29oMToxLzkPfGywaaUWOkOG7HD3vHmowWAzGtl0GXQnP5S5JEajzQCemPeL9x/x296fqP97CBgnkQBDF/CQOC02Aie8Oe6k+UCI8/Svvj/IBdZhs1g5i78yA1mOntcIPHXdL9SiTxtmMUoadypGopjbiD6oe/bEb2iCz+bOvZ3jpYyE4WTM7XPnAh2wzZt3kOMZGl9HeRC3x9fo4169mIHvXyzo//7WFsCcpOhPG1MYBJEReHRkxBKQxF9/53QweOK2xqzaloaqgjZ0wwTArlxV5CqudP22F7xbY060DV9l5+cl/wwsQKl3t41zaS73TllU6DfOODp3JGYGjKgiZfjVV2ASPVQ32fRo7erEtOhveG7Qjbq7SZVEJ6lCEC97n7V3P4Y8b4xqENDRIx4jG/Gkpc7GX38HDwEF1wHBMljQfI7ykTBxbghT5DNMEMVA8qPL/9e3SyQQBbfPk+78YKfUOC3RYso4LvhoYxID/sCvvXEigWewt9CdduuIBQtGWO1VoCmRsCGb4FexT891wLcqoRoFDbbftD4Ye7099jlciEUJQKM2IKKpmbQC1EogRLx55gGSYhBSfr1zYupGyigVhzcThmDzYS046uI3btRGDUZWN326jjXqn7UbxozRR/2QLyriIW/4LTNTntSUPE1cQN4t7BXfrUkOthwE+w4aJTpdxLgWnVhrjGg1Nxkm9kzkoTdiKLmpxBDR6y7Tp8O/dZxeuifE9raagGIZDv36Cih4D0bCkZ5PmkUtQz8Bmew3LV90orcuwEeI37+bvD+QtwO57DLfP0YNI5hJv+nNKonFKCAa78SuVDBZcZs4WvA3BIh6OzFZxOQtJhB4sSzJDPz6x++Q2hRhBS194gkpjQM26d/V+GXV6r9fmo5WqDTwGmhSVaXOv6lF8BX8+ErffYev4MdXArk8/kOnLk1PSvAVaXJpOQ70PI8DmNcJXNjLvoPbi2jlYrJIAkWHPHLM7ZhshGaK+fs8peNBQNSQBm7zse/MmFL9xzvyW9sc1XOmL+0YYwd229jVa1ruXbHjjjePPvpcKWetLavWu0pDkfif7qiEL75kvhp9e7stt0AXWXL9R4ADC994F+1FX73Uce+XQ0DwWPcPp7oPbgCMMpA+a/iY9mnjn/5rSo7PifOahJJjLkqPOVIrwQTggc7HxgIy4OvdaMY8m471YcpEZ0g5AyO8iMg6/w2OR4+ix59/ng7j0Hfo0SagxYvX19eC5uRdzOvPo8eBKnkXHc7oed2YY+x5PSODDuMATgCL0EIw60Pvxo0974FdRz+88oknnpj4IZiFFqKvNgLoPQp2oZuzkx9kmpMfqFQww5wJMzLNMAOT8B+Y+3BWpRS7CvfLdrFPCrt1Hnc2FCQbfcAdRNdejzOBwDQTDYVenG8nG07t3hGEwZTmlydD9IclXbTti7sZDX1+MIDskS8WTlAeWj65aRgIPHYYWO4E5167Z922WdoqZW1TrKkpkjO8unro8MXVq+++Z+31U9Uuv7ymsai1oSS7pbpmaNuiqjVHYE/eH9Yc+hTI/3nXwqejgeyld5Tecvx29MWdEgv6es2OaYah6uraaKQuq66trS7r+pWrd0zRenOU8ZpwySAxbfvFtgci7iaxqIkJPjUvMhjwpnNmgkoGYv6iWECipdLxMSPA6dOjgm9Y1ownYs5kgK/8Uu0fdqMt951oO9J24vw3JxyOE+2wBqwTE15JuXqlp59obz/hkFCX0RJWt5NKuCqpcB/aknxOSAD+j8TK0hP3iZcT9mvSJafZvxIUCNCv3KQnivwUwSdIryRb/oGIidFLTm/7J+pGXaj7n9tOgNaT76P3U35pZ6L33z8JWk/AxMMkc9s/QfzhP4OlX7vO5KKuTzaJbmg3fQI6cs+4vkbbiT44j+e1f+M2nIZ7fFQfCxXi0cgIiiSC+TogRu5kUzNGTDeigiYQIRxJphBQCzbxoql7HoO5nrCp0Ck161N65bz0by+yQBqMF7vZoUNCs5sqtdqAQ2NXqeWZuVlq1exAs4EHAaPh9i53gGZMLQ7HrJw2nndlGPLd44YPNhnLh1qY9KzCTLVKzcmDuS2FddkFDh7QH6CFF46ho59vhXveAWvwSJGGZ67ct/vw4FBA69Jpw5uXTHemWQvdNolkqa7eZi9YlO568vG8xRlu32Cdbql6SFpa8a3H4rkug1unjaxbua5z1ogKnU5Fp2XUhFobZs7eNBgl0fRPbvoZtIn0j9DXlJjPDVKt1ERqPrWa2kbdTPxl+L3E8wH+j5k6Dh/92phZwhGVa2LByEWisUA0Zo7SHDHikhC1HTPugjF/gGhsk25JcvExhC+AL4MnzFSxQNRLafFR1LvEFWKkilCLdAVqgCEMIxrGXKQCT899E902tzQtp/qm93TVyb+PMNlLpk4tcfJtHlZaOhfd9mZxte69m6pz1nyqVv/LVXuspL2gaEJRQXvJsVrXv9TqT901x8rGFuTMzykYW3asBmVVF5Pifk/JXNDBaKeW2E0jvJ423lliKvH4yU2Kq98CHUB11Rn0e3QY/f7MVVedAeWgHZSfeewyA2RmjeSN+zMKQyX35IxWQp2jvMh9FNxy1F1c7JjeuQD9K+P+NyQ1QDk6556SEBzfmjU6q3VC0x21+m/k8m/0tXc0TRCSJjbeUaf/Wi7/Wl93RyP010DF6Kx7i7OK3fe/kbwPzTzqLip3zFrQOd1RXOz2u3HGvVmjFRDfGq+h5MmuGvi08ODlNPO5ATaxWkz9DaLmUEuJZqPPQKTE4RCdOptiEYmnV+XeSND7yYHAixD2g0zHAicSiPJhYfXwEDqHjYi47yFTOOIhacQtAJmEw0YPrkwLwiNREBO91IUprJ84b+pMb0NTk9d/uLkkVD56RVmOP3NxsK4x+3RHs72wsKld7hu8DcJtNDjnxNO9zCObQ1/HlHsBrcVcnN5V7I+jlwuGFIbqC+H0gSKxMzVVcbB71Mj2sO+KtLQlo0OzNbSuLmKhfTNzaz3a47VxNeuy5Eg1C1ssDhmaYo+BzXlmcwFaFZKtNrZ9BJe3GSyu/OU0gO/4omV+C3zXG4v6vJHoiEvwXSVUHZ6Hjgv411phD3M+tZJ45fBkEP8INFmZSICMDMETuoDMwhq17gxBLTlCmIhISo5vDgEP0agPhImavc8ooFpFdOFIhoC4T+D1cU7YSFx96QwprW9xHYQj7rrt/r1l5WXr1q0EKm+2dte6YCB38OjRg3PR7kFrFlY/UVs1ZPJz13W0TQVPfMAwHzBw4uBZle2hNCnkLBKjv0PyD8l9mhL1qDEVya+bS0pbW8pKTdNnz6AnVLTtvAq8/opSnp254TGz1B9wZZqNztwRJehNa8m8hrvKmcxRCxyM5d7h1x7L73kudxycMinDPT5567hHfh8IlneMLQOTGSh5rjHqyVz3HINu3Myol40ZU1o29pd+pWXAQ+PJg/YAXfgXth6ZQN55wGLIunUV4GbAv16kkG4A3+GukDMBFCMeHaevudh3bMkFivkD/kZpAlaQCA7GQSIBI9tefhG3kZijEOtwARtGwJwkmrsisBDZZBaAj4liBSZG6IYlLeXhyshPucBuZPEwURv99XXBisHaxV3g3/vRd7fFa41mlvUawyVTHk00NiYePYFPRXKVP1Men7j/bytuAyrG0LXYU9uCtiOLyQ3thvXf/e7xTeXtwzxZrYvz8MD+fr+a9eE7M6pUdXyasmS2IWhQ82t3rPzb/gn78TqoT62DBKU5pSQbI7AixGpb4iIa62QcA2OKuiIYlB6OYGuaRbSmlEsYQckW9zbRMQzZTxdgYoioQmykiBaopSYV0KmPXXHtsa1bC9vKQxkugxLE9DTTNCbglRl1RoUWYFKrbKhhREwKGTb+78jS4XGNVB2XZj7Q5qlbMbLa4FKUGRg5hAWrVCwj1Q/NBAxDm+G7vNtQqjVVKq8F2eU1MWO0tLl+WmspO6JWXaQELAuW/HF+9hKNId3ogoC5ZZDBl5fFWCRT9CaehQwAuUFaY4v6goE0aAIQQlrxbCVtyKxlZCCaB/heuqsS05snBIxwN6aVhwr4sf3E+0BRN7x8MsBBhvQHYXAGuJiXIIoQZDmivWIWQee0AsVqgnWhzOyamuxM2hoO2nNz7cHwF4ViCry/KEBSAkXoR1fgXnTmTrPHbSuotLfJkkPQBy+AphcfBiWn4KJty2N/2FNHCtwJHPfeDhz3MfK2UDgYCKPJjpxcuyM3B3x1acIR5hZ0dn9zA03LGR3c8O6rwHUvcNy55dNk1fI/j3l8gW/7t8D57fbt34nYJZILuGmcKV/BAu/qo0WIpAjmHQhyloDrIDnjllygWLtap1Chsm/1LpWMN9Md50+h5T4aZkgSGrwi/GAJnqPStFL2GHrHzHBuA5jIeHqm3aHODPJ0t6wfK+EC+xPmSNMvuivovWvqnoAHrAwMvG/yG/QXfZpaxptQ0EfTHknCg159/9xM0EpPRhn9d/8rOmYU7v7759WZAQPdbTynZrN7XtwGN/T846J5p0iYEwj9gb+cyNOGTSm1fUGbH39VE9c7EwlQwcLHZS92SCua7kuoNSfRmf33o1cWcEC6Ta7RckPfXjn72WuGD7/m2dlTj9ZvI+6kUdzmDwacm+YB/sb9wHEyea5Xce+0oIBGO9DLBJtr5xa5VXqNDMonz8bV38RXGVxzjTMQJHqExLP2xhmL1pzch/o0+Tp6ddf69VfshK9QQ61Ah2vzwEWWZJtQj0hZCyT4zPvAzksEhyyFMwcWQk/+QjZYie91At9rK6YnU9pnwiyJZxAiphPACI20weykU9zdwBIB3G4EdRj0um3CI0zg4YjGuZEnoj03mYv4okAevHwJ4bqSXTmP5OY8nGOxZeSUat0AqHzJiX4VAD5tPBS0WvKP5WUfyTJbXZlRjZvgWLFStUxTnue1WPKO5WXdm2W1ZmQXazy4og0+Y8UVPfrhYasVXzL7/myr1ZNbijMztOX5XkuC4zKtLicjlxtXgquMcoaRG9H2HSa5BKS5bDkcl2VxOlm53LyqhM6l8+yhjIBFImccQl6OzWmHErnxWtRtVNC0wgji1+KA2Z/KdABWbr6mZ/hKo5yDaU5bjoAvZLmQYBBu45wUdoRgetKvnO3pCxHFe9FGOJpJsC6QzxJibBLaa51v9V7vsc23eW6cur4mPnbs6kUgBD60etnaoWlxILEqIucTVq/Xypw4X0nO4Gtlfunq5TsOr1qR6fMKfATpU9QAnyNEe7iWGoypHaM74vuFlrA7whs9EXKmL827dM8MlyNuJkEH6oKCe6wUrltXT9fp0xIqmX66P5FO9Idh/PTpni6yUzoARM4PcBxSiUQP/jEX5SBqYCxVTJRvp3zLE20K4jkEtyHB2cMzOV5HfaRzpuN0PDuxmBNio0z31meeQT8+A9G+CetxcOv6CWA2JHBvJIj2QQhmT4AUKfLMVqXp6GiSNfqoSSlWwyELTrxorAp+7b2i/WsUs0ymsLiljJcarte5XUwwhv2FGR9LXTF2ZMU3EH5TMXLsFVc8vB5+UzkCB8aOqPwGrn8YXDGQVEo+vL50lVatXVW6/mFchNOuKrni4StKVmm5sVfQpwfSTVwf76jD37qSaqTGUtMx90BReaIDHMFnnujfy0xw9jQC+kE/IxcmmOohF+CFTWR/kRAx4aVzYCwq9l1h/gykVFcEsbqI61IkwqIZ4CBDgXX+4Ry5wapSZOkzNo600k/lfV/H8/FxBDcV/Z3Asgpwqk/cHucjfN15uVIlHy+TyW3ydvl7CouiXS6X2WXjZel6tQB60qF+UO/Q4/97x5OiclzMJpfRt4QM8pzD860FcjY4cmOGAjyQ910dvmD89ieu770HcBLc13Fxnq8DOamK+Mr2r4SjTEh5Rrh2V+pWev2g3vvjJ0phEpC2ZSgD+fLAx9JueMkWEIgSE2De7A+YWV9MwsV4YhBsjrE8ZwrFArwPTgEu4FqADrC/3ANiFuye+XXVlXu+iqCP0EeRr/ZcVfn1zN1OUH/tsuU/Ll92LaiHb775JnqYSVyGwT0/5NXz9LjToFZ5snHdwYPrGk8q0bOnx9HnX90SRH8ZFAgMAllBSvA9l/Lv3GtPMFTwGEJ2GO6gHqWOk9mh1/N0yhX7JXHwK/m+XqUmD/g/XonMRUUsI4A6VDJ4BXQyukuK6PocfwLRy6Po6rE/COOXTU6ecPgh9Nvhhf+mFkgkEdqENiWRLty6/TGgApVAeXR7a1jXX8ZvRwm7/3S/H9B+76BoyeVSd/ntGzfa/cn/ogq4RiWfDcEMuUpX1DisqdTnK20a1liExvSXGIkviS/cJ/9LYSIYBO2dkhQGWN+8xBM0IyLw600QRAohM+iDdWP7QrDbb/PbEJ6Qz3IW+C8CbytG8Ux+j4XreYfAHIF0AvbbG2K6kzg/KSwVkKLnmJNx2N2TQKlFAS8SlBnETvc7LRfpXOGZHcQXiYEj2kJMAOAFyq+vAmZABJIcOUueaPChRXu67kRlx9Cex8Hcdfl3du0BN/jn4vTOz8BOP9PRMNePOnGR/HVCiWPgRVJkp69hHq76GbjBh9/BekEp+afgc89IlQreiAaiH1zGT6WTxZRNVHBYEDWHnLCSxSNeL1rdxegIkfqn/CTwgtMFJzCn5n+jLhY10XM2PLoB/wc/rm8ft2HDuPb1H8Vbzt8zoix7/ODx4XGOUbDOLmFsHm4RW2Wu8w8OD61oeGn1+ZHzapbPbh7NAKmbA8yYltnLq+eMOL/amhWgtfSkWubT2knGQBbtGLFy5YiRK1aMTJ3Rz/DWMUPrJiQnmzNMGlwTOCS01TaeIObTEoXW7LLsnoX+cXSxJz0/vBjUAygF6MElofx075KjwD5rt6/IDuU0fGLIzJlDkg0aexGZCafjtXB/SlZLcCRwrxLciOn4GLG9N8aADrg5IoLl6cRO6Nq5M3l+NKh/BxPMzejpd95BSxYwzagZPEp+SSmi7ef/+c47zJEeBWrG5yuBW+y/4y4A9gibxFxgNp6xmqkZZJaCpKkFAkrkgAXgzoBEAxjBntGP43ghImIuQBa/gJ8WQDlTHh4I1oXg3MZLvqCexVEWT9gSEWdVUKfBxWgWsMpA9IJHxQCWKd8LyjSFVot9D124Cn2p8/BKVqrP8qierc8dabbSJdy9YZ9NfSRfzeo8BWDFq81SR7KdLSstRldK7ZmgqTQoo/3wVjpNg16qtQBzntrpBA1XhGQOX8EeyTsb0HuqdKlsUpbGqFTLGx6r5xUyuf9MTBMYCzOsocbH62BTmj5Dlo2OR/9iUBvlwNhkDBmzdSBQY+dMcPhMg24sHO2xZ0/UyD365PMvBwzyRo0UYmIkPwhm3Fcj4XXm90sEu35RlpO4yO7BTnkwzUp81eCvJ1B4OgHeMXLRj9CvwgahW2fgLoJycEcYChFpflKw0mAphAmm/h8m8PxFfkniHKVgX8X0XGfr2URrJ6BIpQuYsqMpoR7VJ5MXfj1xulsEEWbi57vdLj/z7nlBT5WJJ3DVLErF/UXAWXDheW04pslSo9ZoiGVgRiVlQRMjyn4CAJiAe+XJII6EBdIbrytCOo+pFxxO4YH1pzOG4K4r2q6YDRs3bNowjNbvlTd/8ckXzfK91AWF8up/7Rt134bppVC3R74FrAIJsGqLfA9SKB5DG1Ax2vCYQqHbK38GMtAGmWfke1U3GtJzctIN60L4b49eJW8aO7ZJrtLvAVrpnGk5lZU5e/RK+ZZdu7bIlThRIztw8OABGSn49GuvPU0KEg04wWZG2MMcKJGqooZRI6hp1DxqLR6cl/iCo/7LM8GEFNHsQtGBaQMx7rQD9K8H0rcgMYzoRoBXhRMST/SwgbHLJtLDGmc34v+ot36vGR6Lj0LSq41F5wTpOYuPkblibfIfvCqc0KsDY5dNTCZAvwQfXhCzugVIapHXQHcJaTR1jiLlJORIPOFdoNivJARPb5CwBwLdHgKPR2ADBAMosilZBgS/N8IEQhQtRFdOBk8AM4C00ESxXm10TJB+pTeNQRk5Vj/LxCAbsJ43WmiZR++Vsf7NW2c91DkzYlEAmmFabs5r/WDxte3t0/VwBFCgd0xp9L/Y3DQ4OmNDwbzF9JqRq1Cd28ajwxqb22ksPt35YbEPmgNzJu+tr5LQgC57bN7GT9uCEIAOafJHudvE/i7Nb+MzD5E5PJBaZ+WUHs/gQcJRmSneDWk/ZvwkHKSjMT2vJykyoKWJZxu/qH+gB8fSDUDegWo2fK3UG+hDhY0tjwSZUx99DrI9qCITUczsGbXoPetwhteCWUYPu5TusGG6dSY4Boq0HnTrH06AKHC8fwbdD65Hx5M8WgxvpgPJbjQWrYMFUAFygV1rtRnQLFEuIhNtRjSUBVMFlaIPeeCJEulhzMzSuG9yjE9wCMSHAR3mPaxgJUJAHYyiejBnCpuIqre4gR91AR9m3+hwLGwyhy/txdyT16iLaEZJK89tKlXE0fcQxIDmDp1txZCrHgKs7/Dsw3DfoNa1+wHYVeAvD4yuN5kbFm06AK8rzCnMq49qQHei2vTjg563Wc0ticain4XuJMVHmOHbIZOny2OrQCCqapmAGsbVr0xDEG5MroebtPYVk2YOMXuNznS34oYMsGr63DprhtHkBlbprdHk0Q5TA33ivHAxVuib2r624fA3tFFeqpBqoeZTm6jd1J3UMerP1BnqO5AGiP8BUboR9YUj0TzGk8H2xouEDVMhh/bEOE+A8/Bhs490YE+sj/oxFxGZEm4y0XUZJwhLhFk1kBEoIiywoPtG5FPmMOch+/CY4RQYQ7LHETYbOA8BeRGSRHoK00x+cg+cy+HPyPXbX3H9t730MaIDHqK/voFcgDx+f0GCEyz4ZPEQNVdPNNYPOxbzB8JEOyQs4YR94kvFXQdV+QadCVxXCQiFJOMc0KAsIClxJ29xGKznxo/JKU4fHGAyIjnDIShitCAfGPzmtKJ8tQwAb5qT86c17JeaeLtMFxyTYeHSTOkyXfZI53wHlwZlLC+VSo18NpTSptiL3CLaZnU6ZE775FiWJ/NalQwzlsWYgAzTavNrMofJFbRbjXa5w5QbGVxse5FRMXnAEDA7wvl4fcc3k/rThm5Xc2adrpjm5UWMxnygODtCm9NcvpjPZVq78/xNj9+4ISeUs2QJPmy48fGbzu8U0lblhvLmzs0L5a4iaWDLRR11fLrJWU4zrAwT3w04HMoMurKCD6Bzf/zjyy8DyZ3FEu8MpcmWbgtkA5plgEHO5CiYQlonlXJ85hAggflSnpNJDYEhTJEu30lrYT6Xr8wxrJ9jTjOZ1FHp5NjgrIA5AItmqjcNcht1vhJ1LNuZoSqTVhTVj1ust7RkpK7PSYSr0xY/DM1Wz56swHR0DjrHmwuCkea0Vwgc8MJl9+yZNWvPPcsWiui/CxfdfM3kydfcvGjhLkY9cMiIPtiFMSOndMLuWA01hppKzaUWU1dQ11C3CF4ACWKq4NTaIARYYiiu63WAzqbkrKSfxXolsb3ebQJCpxLkramuGOndFAI6NVBC1t2/rvoEb+t8LEw0SMUfCAtaSuR2kV9I1kCJN61cp6tweCVfx3lD1dkR01smT27ILXdWV4N4ZizNaDemWTIyS3LKvXk+Ke8wFZizcgaH48DkyyysqsrL9geDDbNmNmQxP1UfRL9H9yIDQhK3zd/zwNw9c+fuAfCGwe3jBu9486mVS5eufApc1TqnsbJ4SrUMuJtiP0tjTU0x7udYE/wp7La9Z3epimYsaZiIHvOHx4GmfwVzDHK9Wmu05/hiQU+mViVRmgz2nGC8IrPJVx0qqPU3GWbsmpF8EmqCY3dtvK7AD39PbjpXCkafPo2OyIrbixtK0GPXaZvzi9BjW6H3vLK4ubmY+R4fCdmq7/t2EFOuasyvOTDd6sdcWws1njpJ/Z06C1ggA15QBaZSFB8OgFjAYyQybp85Yi7KBsZwyCeegHhiwwHiuBzPe0ZPwEPmPl4XNseAQc1k+D04jcMEsTmGqxk9OnIh8uszdNLhBcQcjpjDMUwex0Jkv8IJo72JOo8xQP4TH+xGskYJMa6PFxQy8M9txJ+b/DjBTgfXxT3NSI4CjniMPLRBwjnxTO4RugZ5lJAgxhLSiqJ5tJBoJjsnAx6TIJyJHZggwuWJqMtGYeqOOkHMKOnNkwh79qk8J6B1vc2B52qcmuFXMwI2RExoncjKcbmwuqH+zh07QMW0Z4MjR2QCd1bb8Gz0GTmCV8fl9JhqJpVM2mK9ylq/rGPh3FFNcJ9C57AELJmy9a0jLlCAaW17YwF6/5139t10E/u22LcWWWPWd/nFBpgmlwOzOZ45SmYttv4j44mj1mPms4OC91sKk9dlZ79kurdZ7Iarws5HYmb0e1fxW+a6z6IhdCcYEys6ZSxzPSiVMlBX4rqnPJlrMVn11ZaMQdW3FJSiz61Gm64aYObOrK+P31yI6fe//W3vTTehL2vgTzPXr8/IKAxlFAU3rfR6Cgs9X1niV1zhtvqyfdZIcOMKb2nLTRPWbLFdaR22cWsVl6VxKXUSuzdtwpQF05bQo+cnr2xpKYxFmxe+U+4eFEyrAN+mlfvn56Nv3sZ/5eVAgy4A8NRTybcNToOKg2B8ezvQjBvXUww0Jbhe8q2PYy0tMXi4oiIvLz9/GlCPNiuVAFZUlJaCNTn4z4T/pkzJyXkMXEVKJttNqb/SUnRlWdk41cxpjHSMxXLeHJTJMtKiuW7jNKBxgnssOO52RmQejUnOTQUakJZchu9ajO8K7yUu65PLRpdatXLO7w1klVi1MiDxqWd4Sq0qJWAVPidJNDASWIO+ffXV8vKt15RBQMt1abw/+Gf8Nanjx8n4VPSNTwXmTjx4XI6gFlJbqYPUg5ga+WPKY1NqPwV3aQ8nOLnHFPHAdAGUg6MlBJOD6HwJkiSWjwrJAyyc8RmXoITiGiA4qxcE6GYxIwZ+85UMYg0+UiSU5wyis3vMQIoPaPoFjfBp2JfmCfkcPlqHmTodVOhNNguYHPameUnquXuaKrt4WA2kkkYD1AOlXmuiR08FkUySoqbtdUNmDCp1lOsZ1SAenJCyTQpubg6rG8ZKA7mgTYWj1AWwvqnyoEG4SJuS+eVFbIPIRfB6QC7yvqpBIRSt4eHZoWwWnkmggg96uSUXLesrfIXpDl/YvSrLCeYpGOO93pAQ31EW4dFsiZxfKJXTcMrfASuRu4Pzh5bVWwxKmRYY5TL5/j1aGQuXbGE6pSo56CxOVVEt+2UVoMVE0f1ArUAdkJXxgPeY8O3M4MOLlmKyF9G3FmuoEDUEr8TjMf26jLqWulVch/GCGiHK2Z6osAoL625q2eVSiNXEqYpfWHZjURDzRDR0OGVqKCo9scICjCdfXZjgLvLCCi5YggZSaIuxfkZXyJCk6gcEwUYg/AvMSkmFkXeb9WmOEvDEQkkofPaLmjpvur+0Rl/b1pRXUF0bcBWktbn0QzqGF4QxU9KxUZ+nq8zxD03PT1dmgW0aVXq+XL55j61Ym79nD1yYGxwcj0i37PGmjwhXoJy8mry8GvrhgtCkjkVVsbkzyrQlg7MNZvZneDE3sXqQzyM77Rw99dOyaqvKpLa5O9P9gfrSaovarHVZ9YszfZnAs+gq4xLprP8Z6XUqVnChF63X0unOYpQJQi70EPjrB2tKiorzk2utexXF1eD35M756PPFVfEtSxLlseAsF8/nq+EjF304mlJj3vFbCSWMc4I8pDeTBiL7pgE2VCSMZbLKABOB8iBoZVHiw6mSIW4Wejdp8OJlJmrpElPFl5grj+95ezcAlFZbNip9FhOWAvnPD8vt0pE48DQfahtbEfjsOWlxa7F03XMRcAfOgfej/S8XNc7ds3vuQ+mjyrTaobMkcblddvaIFMo7cIHb0zOyJtx45Ntr9wHWwRuILrqB12+cCObhAqJtYf97mDAd0Ux2T/oePiwDKfeFWtD3djG3n47piab9r74YI77K0ORP9IKsx7dOvLm9gOnufdHd8IfDFYsqQO3IX33Rh1MvBz6HP49dXjV1fhglUFx88Y3PAO0UtJ+5p+O3vngfBjCb6JMFxYh2DfHvJ0yhOhEN6dfiwI2HhlvCsb2+98QB4un1kRAT9ztcxBMKpC4PYzQwnDwNugs4OXpBztGL9OoO0cGBIJQDkXpNcxDEg82aehBR67ugIO5IClX/Q5j+93IZhLLdONzTOGL18hH0U8Jt7vYVFfnu1g/A+s0RtAGJvJ7A8lAi7AmdRiinjIqBGkW9oif4n/Q0mPVDl64ueR19CbSvZoyY1VasXaHdPOS6R57cUXedTLJSIu/5NT0OcHJBqDkbj5s3XgVamT1zSO4CrbY+u/DJXXtfLMiq52QyOvvXND0GyqrVxJep8A6EJRfs11mikJEhzmypLVK9gMZYJXqrNJvwiknK4k6tpdwZwruSOZJATgh4gwPgvCn6tXmTqtZMrZg3paNrFCxqWHvdMAnPTc53sEUHJ93+yJa/bx1ztR8qgIxdwUpZuIq1pjtKx9YUoEPovV5t8TOPKGzSTCmA8pnntwq+7gQfdmAsuAeenb+mYv7hKZ1rtv5Bt+j+qWEIIu5QzdjfPXgAyG8dHOeLJUoFq0jeYrEEbEAWqFjRjKn/Cb1NdIMMKgqVSpVsRDu5JCgGjpNr0Ng+3SZh/8tD9r4ok5bYzxg0gMi8iccMNsATz5EpwTbxByEDAWCU1B2f9NFsufxPcpt8TvIuX+TVC1Q84YPj54hpsz+c2PMijHcnuyXUcfTTxA9n48Q/yYWyiTigXo0IZYW02R9NOhcXynandK2QIKvLTPmw4Ciuz4Gl4NjARHmINirR141VMpKW+jm56OjWKavXPz4Bri/reTpw1QjAoB/+uva5paVcXXGlJlNtrW6YOVtCTayvGpu8du34YxsSI2Ft9PyPjfNNg/+Mvp94x2sr2FAgw1czscyruUhmmI1X4nXUddR+EcE5JGBMkg1MGBbCMCxExHQxzGNWISACq3ICxtXlI4SNIapY7r5/IjsjqhsxkX7B2y8jHHWWym31O5zZ9Znpad7WvNxWr9NoDlg82U6Hv7VdyPJkCJFcj1AkN6/Vm2YyBUmRX9YQcnGVztY48Rgg/ou3dp6nhhRHhvGODAfvb4f/MZIgYg+H3WI3mexWmyPNauW1ahOOO1KJOATi3UKmwyZmXlLOZrWbuls7QTeK9/46aW3TiGGRtBxLuqvUf1Pjf4yIY12Q57CE/nYbiXcEzK7jn5T6mcLTAKDOJkA3jOPguQRD9SQg7nPJ7j6fId3C+qfFKyCFyX7BGxKezcK8m/jHwN+d0dMUzJiLPj7wljjPvPUMza6afyhJvYXnG3hl8oP5q3pnnyR1AH08F95BU3hiu+jZXL3PRpYKMsLIMAsII4sYqJGlQnhejgpoVyevwgPkU9TRDYeSAHhztVZnBI+p9eI7nEZNRp1QqreQWCagT/kh4ihmDNVBKEiC58uI+rSSAPE83AfoIdpP4DULiqrCxDmIiEItEcBOiRTQ44Rmzh8QCEhWKZc7i7w+MOjU7rI5zY2hEmehIr1s7Kq2jgdn/vnAI8OL7SM1aWAzunDjD1eP2fmHOWNumDWmtCyr1NaxbfhSf1XbmLENxQr6oUXNowqA0uRkNtoc5obCejou8aRl2lXy8d/set4Xndy6oeVKx/A5Y4OLHu3o+mpyVWRfhhfsuw2AXXNe2TvBXzl1+pVLd0VfntKaVZ7uMueWzanX6hYeYmhzlsKey04rNAJjzUVrwBhBpk308gJFvdtWHhMmoQMiVodBQITFC55JUOpkSRuZjeKcH+uD9BUGOBe+DH77vs883qCMgYXeqA4Y+IkBuXtQuHUd1E6ZnhYM2cGIsin15pLAoJbEiBlPzKWZiQ8ueHqiQVGetWTc0n2HZncuy5N6TJneWHFj1rx9sy/C9z/zQI1c5XNAlQJ68zUa7+CoPM2wtJXTdoxNk2ocmTa2tP6G/N0zVw4p7HxqOpj/xOKFdsuC1iEPLp9zz7yVxsml40vqAvZr4ccXGwPQKRmoiK0ZvsQrrZcok7qJeg/nxlG9Fk9exAhAi3uJGzOrTCKl4ymeaEFjFK1fee21K8Gm2c9e8xZZ05JU7+pGkxC09FfoPbWj79Fr6Pv24deAuy+hCwbY3FECijxlAeLdYeppANOn8o5Z3r77zOy7N/PoRXcEKHXpXtph50UPI8z7RAUCn4iFogVTRQSxCn/nKqJILdGSsREIY/IeuDmTmRHA6olevuAnjdAL6XgKSSe+u2IBsnySfoNTCK8muG4N49EfSIUIGFk4BM+hl4Iey/HqIVuOH9+y9OE7n9aXgMUgHaVPm2Nk2eNbyise1MhNGqNH/+DE40AKytFZtAOdbamvRgf17hfNPfccQ2cBd2zJjG2C2iFIgMdGfSAqDboNQDF+xjGQqE8/7zqOfj6+86tRVTeBxJZZu38PpMctqMdcpFakAWbypi3HgXBdfKUpD1RNRdm2Q+8BDiwBXOxJf5E/QUTXDtSZM9D2mBN6TjbBmqMukbfyvUBNtESQlcKLfOx6LsV+0hURySAxpTLzvfJTRpRtpg1hPeaeuWYPO4T1Oxm/0/9PhyGZMDgcBpgwgPtJ4SSFDwnrLNkjwA5GA/sjsjlmoBggH4VKkDCnpZlRwpmXBxcGHY6gIzk+eVciMmxYJCEe4fjOReCl5hXl5SuaUelMYV24Gve9n/G6kEfs7ylxyAvfDvPOIsZT2E0QkgQVe7dozek2MUQZGxCGQFQwxH0gIM4fZUAgNL0EVwfPJeyTIW+yxhsKeeFzXiA192SRMH3dWPTuA4+gUw+Z6b+QhJ5lY0HggS3fPjgbLA15N+s2v4feuPtHNG/asyR3C46Dwnt+ALunHfeG4D/qw+H68OjRI0Meb+j6ex5Cbz/SG5710Ddgiyc0atTd6I33NwP5OyGvEAOF729GP74TIjYHigsU80Pq29px/18uYG3TZj2ROQn2xHn41QjOkJnAz0lowXEzsZoTPNoTzWnBkbOuiFhqeMUNCicTCwnYQiJUNx4nRpzsD0g8KZdkmLgzpRYeYZui35hWVKPmTeZKVtCjpokCNRRR7iF9bMnyu/wl6Don7ctQZnnQ6wf1Lk356mEFvKFl1pYMtTld5S+pSTOEb7OWnT3wj1v34e9UjP641KdUZteNGduWpuUsWg3jqKtIj4/z0cw2mdQNh0fb7nUXSZuKlWkPpWVHl4ya5FhTkZZ5Z1vz5hMSKMnLrK1s8Q1uO1jR4ldPOtKzb1Hn7neZK9FTRvBCbXFPZ6s0ywo5jt46FY2Ts2Dye56eH7yHr7OpLc3prVPjUXQgs2rnoSP3Aphd0KgvjChYZ0aRg2cYyPNeh81kybt6kGupU6mE8pOQU0eG7h+e4Y4rZ+uUGR+Mi81YZ2twVq7RgJNzWmckn9FJtBsW7pwxZOrQ+aheUzlpYnwP6nluYVYJUPX7wSPrn42KCvjpFAgPXMw8qdWPLHS+/5gT9ZFNJxjwu9MJuLrwBYnfCxPjTicg6JWAx+QrrXtDfe+mO449fd1N96heZSvCJVVyWzQwGf7lpPqe3vTXmMoQSY8ECmNggStXonHA0ckDyetHsVadJNfpzJXozZIccBXg4dQxrEXH5jm7f6ag9rbH//Xyic8f7IrXr15eMKTWe+2lCY1PvPFyhVSph1VVjEYlLf/DW2/+oUKqVrPu9GpGrZaVv0S/eo5MW73rCtuB2yWNKhO1AVPA4f4Bng6FkS544lWD3sW+1+NhtDdCnxZ8LnZ1oq+FAGbU37zqzFaQ2HrmKlRA4sRPo7azSwjQNyCtUObrzq7zAuA1i9nxrWfA0J4bcC29mhaZd6qrk+4U7SOYAfYRlYKGC3Wp5igrYjhzvUDOOK0363IxX6RPkUXIS+GQX0LRuOyWVywOBz7Ykak6srXO4ajbFKk2xjDpPsniMEZNDssUTNzHjLCpJoJ+jtTgoKvqd5Ga9Vd3nH+z4+qrO5iCjqvhE0vIVcgBnYtUFxVVR86ZTJ+QtE/6zituiVRXR9BMo/FoVjU80F/76oE+/SBemomWndsO3OSf7Bc2dzeid2/8FMTQcTQEHQcxsAHOPbKiJ77iyJEVdPeKI+AEDPTsxdQ/BUrh4f70I6Q7mPuwCpuoUdR0ah7ViWe/tdQm6v9h7ssDmziu/3dmd7W678OWbVmyLMmnfMiSbINlYcxhbMCYy9zmNre5CSEgbhIg4U6AQGgIuSAH+Tb3gUmbhBxQkoaU3E6apEmbpPmmaQq2NfxmZiVbNjTtt9/vHz+wdmdnZ2dnZmfevHnz3udtxeu/fcxB5h5MCx9gHmYeYZ5gnmdeYs4yv2UuiDjALLWWZGO7nw4J+Yl0jaXGqKyIEGAoIVGGGG1zBMhPhGYwUIxZfMQVcwJ8B9BY4msgqPNIBOCwuHC2BCVTcAZZYAFBgwMEeB9e5FjMrCMINMDnF8w6I3nOogvqLKAACLqgR+Jy8haTDLo8Ol7wAYuhAOKOw7o9MuhnDU4DECoB9dSmAJaAlLEaz7PJxrOsIylZi1p0JTq0WGe1ZHBnjcnsBWNyivE1kPE2l2Gx6sEObUALbteTu7+z2IXnDcmdHrAZPXwHehg063M6JwB4EfIS+MLzKi18EK15Ceagr7V58DHAhXU2cye6XAlWavuh0WCotLOFB2PQdg6PlT1h9OaRs8cf5ID0pO0gyP70U+78GQm7Uhvdewn9AX/VrOjN28BXOaOB6/tNLDBLL/NSVAsCna3H8T+uonBD1u8ge3L9UB6uN6Vz6G6ZzIhPj0mllgy90Wh0JEmVYDiXbpTJwAw+3YjTgEbAgUwNmCeXJjlM+J8jSaJEh4DDrFKjF7j0zvNgGjqqZVM5mZxHd0EWvAYmvCyFoPXcOW3HKAlfPXwOkKPzYbQrFQTQQ5wGpz8t4cGqKtDv/o9fPC1l/QACreo0UCnQ60dA+befSNGVIa9DZdtnuegVdBb4NDvRFx/ngW0dEDeFCbcYWAU4VISeBT9/ir7qvBV9CVL++MeBYI6cw986K3p3AyvKSyg+PsGFY+gw6BoU+IMnKKw9vRF+BZqe3tj508anuYuPh70o1Rvul882bjwDZrVXbXrppU2ZvwYPEZxvZPT2F+nORjzubmHk1PM1kcdwDEsYGMy/8Jj9xRd4sQn0jEu84ImWSYAJSgQzez/6DcpYaTwPmi42gBmTBqGbo68smhRqgQF0fCnUgelZavQRCq+czf7u7KNbDy8AQ94y1ffj596E0tDZcWMvgqnnb+s3fnH0LLp58HiwAZZ39AUzoHHFxNmrUAh9qDYW9xtlOQ9qF9616bEYjZAy3D+ojiyh6AbRCw7dIckFhgBmtwM+O5HcsPF4lix4MUMjOm8TqPckS8AizDy8ce25s5/v2/f52XORNfzhNgC/OXToGwDRf6+/cGTNyVfaDhxoe+Xkmjk3PT7+jVOnfgz+ft9dnzx+bMmat5e/feLUG9yqDmnZhH37JpRxV9bNndtxf1k/Njps585hnWxunnP+/Ax2O3fn4arOkb7iWfN4kZ8+gefoCV02CRP/53Lo6667QUgTUEkojbEB/iObcZLRRg/oC5txJgnjA/roxmF+27f3d2Te/+3aOfJfLZ41LB/kvLi/c69666kT8GOTzWaKOklCaCDH6HfkCB4hRzSShufS8AF8vP/+b7+9f9krxRmexb/q//Sf93buryp1fMgQrULmWkgi2peIfsxM1JOZg/oyy2eKGD9TxlQw/ZgBTA2mzyMwhR7HTGKm4lX9PGYRs5RZiSn1OmYzcyuzk9nN7MfU+gRzCY8IIgJy0aPfYSIWXpbev6BFSPwRlz2JP0AwtH7hR+77TMF/ctdC9FlMwg1+rjinRYFibDBgJlt4HqdA7bj9mH2WuEU8fLPFF/RKiPBawnReiUr5u9vPwf3wePu5Ea74v0rNHE06/tnouVkzfI5mzir8uyl27uy3BBiXAtNSYFxC/2LhjmdcS+/tHf/DsKVdGbui29Y/88z6DU8/jd739K3u62mZamXT+09JC5Y6g/XDg9lZpowaDebKM2U2tdWsTAv6HRKmfRd6FDT0Y492TkMf8Fmvv47eW7p0X8LfHRkFDnWGN4P8VA5vRobXUTDZm+Elv0kFGV7u7cxe/9Cp4Ut7xiwdntkjT/znfHqDWFpwS2a2jAcGU5GvMkduzkv3FghAYTQlScyWcqBhFawEyi35cQz+pXj87aSYCDm91rI3MmCLuVklDMeUe9qOHm1j0dG2e+5pA22V+Vcu51dW5oPH8sLwx3AeeCy/Emwj946ShC2Lj3Kl7S/kVVbm8dXk+Ktf4WOMH83C9Ot9fCbYQnwcGEjo3p+nomaCpceJnhSYRDihmOaAX9zkiKt8iw8E+AOA2/fOB0dHH1q9pHn2klV3jTz0m4v3zLg8mrenStWmvjPR39dt/mwrSLmw6tLR3Zu3nBg/a/P6KbbZOmO67g/3lM+rKJZqTMl9Hp98BnFl7LNvvbLnyNvBias2b1o1Mfj0wSPP1VZwaQaTOsnfOH/Ze1vOA+3Y7Q88uH3szTOnRFw2o36Y8Z6LrjyXSWNI6V/T8ZIrTRPjaYl/bqJzn8uMpa2eK/psTANUVawPoEAcBK8jjvfOxc4G6oWAYu/jjxAndSEQZOOyFRtHluMccWBLpBfUxy0NRL8Sda1Fles37ckd3wKBT2LvIkk6Gavb7IKn3xLFJ9pkjYITAHfa6mZ75kIC0UQFbLYVMUkudrWQliTXFhI8O6vaV82xQRxU6dPNLsHdjf1O6i3qrY8Ue5smrm5OPYRZgLk4CP7TOvOMu8SwF792L2Y2DYAh8NFMdO9/XGvDHuAiN9CHeww452uMgeSX8T+vu+hrQuTjibdKJbXHwrcMMtbhMThk0OFysJSxd4lb5tT7BbHldxS/Cxehd8E3YFJ04K1voXbUxkZxzIudL8OH30Lfw0VgPGpD7WAciKihtjOsL9d3hrVQDSJ6BxdxsEx0NjzY2cly1CdF55/gQRoAkVmI0RfoOhmjkWN0BXrIEFtHXEnhOzwX1TB3MsfwBE3E84KHwjX/8iEoGpD+04MrMZGOJdvmOh9xw2kicJnEjwGr6079r14JTC7eT6YZwYA/cmT8yJH6gH7kSBz+pweS6Jfuj2zPT0gVfkdntJ2OiJtBkdM2o+4dQ2JOv/g6EAbEFAbh/iJmaPhnv1+4exO529BgMDSEgQuUWyvk5SCXGFCjS+XyCit6FX2oxzcbfjETzirCU8bHHx/3d9KfWcEwDgNuSYMGgJiTxIyYr0TRzaGMOGgm2lksDkhF4+GusccGPT5CaEViS9SxzcUUyARQ0FOz4BNsLAw3NZGGiDQBBkL5mIFThVRh6sAxcuKnBCrwH6vkVQqd3qLK9BrkKoVSoZIbvJkqi16nUPFKVkFTgXv33NR54KY9sjTvCP/498zw5Xd0AzLtebb5fefb8uyZA3TvvCykvNdQOS5HC1ojYWJKFI7AYg5KDRAapJDTy1hB4BxSq9QoKDku2ZmRnJzhTOY4pWDEkQ5OEFhZ5/Gbbrvtpoolty6cav0oHFYas0rLckK7clyhkCtnVyinrDRrxPDPHOuO3RHbP4hiWlaHOdYWYhWihsT6wE03TKgo1JkgAHd32U3boMXhIxLRIN1rJ909JpzArLqF7DlhDjboEF2IU7F7FghcJ2uXRpXVG56f/avvtMrhwwc1LXSlXGMGdInD6+qSbn6Smk1Fhm2ZnpcGmaWjP7G5ec6dFHUYBy4xpMwkN/9r6cZdd7xx5d2lj1vQq06jXre3IG/TCy/wESB9oafsHfw0+8y2OkHxxbFFrw2aV//FhhRPXEKekr8Qk7qU4jRzJN9msaXOWWLAr7W6T1WmWN+PduxelG5Pxys6IoB/obfYPeYDiI/wbZjHHU5mQodRDe1eKGJOmImSjZoTbBzxFE7BJ6ipHyvKrBI1Trr08mIzBh+5+fzfUfvfz99ctWzVIGsex6dby5vKsjSALZy24cy7ZzZMK2SBJqusqdyaznN51kGrllWhiNsaFk2BcOvV+kHEX9tE/UFVzqxIT6+YWVk0POBU4qxwhvKUJIuWU6Q7bUajLTNdyamTLClynBPOT+kMDGeHI+JwKyLuS5Cfv7YWPCh6joJdfl1SqPaUg8DciXiPHgf+/ilA9HdisJgBnvMIiKtEUOAZgewqOGJ4itASYokgnQFFvJxjo7v1JfroLl4LFpud/MCXJBlmU4ZkT6keemajOxZJnYZ8xfrfSpx5GfwyNG42agutX1SfmVm/aH2oDUFGImO56IN6PRwP9SkmkBydabRajeDLFic4tfvwxzoj5LNRA3zUaE0xocLDuz+6klsTzswM1+ReITwcvMZwEb4T8zM+IhViBJ0v3qu7BHZd2LQ6L4DUOyunzyR7RvjHRdD777d1A6uIwQN/W69UbP9s88Mg59FORuxxZA+Ibf0YPYv7UkJSUZ2I0z4K9Ie3fLVHY9iD/qwXd3XIU4n7ocRmrqfPROotGGZ4Id0ItoAYWIxPLBuj5VutbvoCtGHthMOX/nzp8AR8Wv7m3WAt6qBCy9nxoqGrPP7aSFRbkqD1d7+5XExNHloL1tJs2iPddenSReEIba4Qbcz0JtyEpl9oQr+boRpnmOIQlR0boRqUkgiSeKHZ0O7TuFFFVAP6WjH4Pnr/9O4TlRKDboBJmtf6bWueNK1CZ5BURu/rrgT328HoLw+QVt6U8CgNbkoCgz5+AJgGN53Wphjnbtgw15iiPd3xUUKVaH+gc00VM4TsPccU3uPVIABr/6J+pIsEGEIEXGR8xyvFMcSuPP411t6ofvv/tkGpBfY3V3zUyFzbotZHtyZ8G9xZ8NehXWbLtaOv37iCuBPpDr8Fci3qqoFIr+5oSvxasMsGcx5B2PhP6ka+XdAjdMHzmnpI3eOTQbAL1Tdg79kI/L9uBPyR15bMlFnlhXIgm7OI3sFEyE5ubp47JnZjfNlRsOfof9hKpBu8ftS/SA6kedIU+dKWLbTPx8s1b3LsxvTStWuva0Ui+4FE34mPMqVMiKllGugOjRlKbkQ6HP+EiJAegmdNM4MnSY9EyxZThsRNJ16gIzI5HSjGYWIJRtgSCVKu/9uBBIqBmF7kRgc85y+cPHnhPPB07sWsS+vS2YcOzV5KZ1Z49daVK2+F4WdJLZ6lN9i/HkbfP6rtQYquJ0gXQL7BtHSpyYB+H31jI5i/cSPah34uO/F52wNlYpNjhpzTDB+uQZ0gRhvKHmj7/EQZ4dvANYlA+ttApp6ZzMy/UZ/D7LOEESSZHi8bFKdOV5ceZs/OaYkNKFBCGRVLCLiMZgtuNSZIdr0wXWSIJR/txDYg6dHT6irN6ejHp99Bx/svv7i3Xiq77fOtKz4cR/tPYro+GU/toZGI4e79AP91Rj45wQL1m/6Pt+KGZFtxA+II9COO4JoS+9qU7yNPoU5r2gdnJLOPf7Jy65/3a8QxGE5MNWSKbCmOQ8eM7uT2B+jhwU5Lmu0dUOlatQdd7RQwFyTGoLM4BrehJLa/MQS34USm+RfaEPeZf4swUZccYlPSvkdZvaBbS3pfV5/T4i4X6dWEdvSPJz99bvn268bs4au3WJKB6rm25/Y8+npsVDIRYlKPq7N85qFDM5c/y5aJnY9e9hynuO1+jTpTMtYM01w/WHXPgox7nweatIw1U+lo/FOsG4JFpPuVPQBaHyjr7Op6KPxAWQ8doj4UZT1xzhS6lCWFnrNnsFtj8p/Oo5d2yGReTIR2DOs5nw47JcafuvTL8+p7O+RWnFC2c3jP+XXYKTH+1KV/Ms/CaxydZ8uoz0MzYzJCjm7v6gNBf/dHFkTgI7Ea8Xp2dwsYqw+MvA88j6L3Ht782XYFoSx0E/TYRLEQb+C14BtifSaKN65214Zdk4Se/fgB9Oc9Bs2er7YcBvpHteJnOzFRfOZ1g+F1MaOJJ+iNjkjPeQiv6IQItzZeF4oYLpY6gVxKGKLPJ3JbZovPH98MdcQBm+LfRlhgMKAPZCmyfLn8WfRBjMb/kzIC97NyeT5O3BHurhJcgCuMPhBvPCtSQTwPPQpyutpHjHxWfEvnd9fNq/TbEPmQyEN2gaUxZEWAWd4uNoCwi7Qk+AWxjx8VElqXMojRu6lO+AwyU8V6SfTNXu/EBDbCEftpAnQeY0aZru5MtL0YdLWLj9za3VvxCSTMmdDfHY9PTAJWWWaCP0qdL0h0X31BqlJIQHh9ui5wtZPO4mInuuk125cF1asrl247fu5c1EHi+Eixs/1hZzEc+fW+0lLwO9mxPSe/jj6Cb4xxFjOxd/GEvtWRnTCyLuDM1DFnhtujlhDjKPxSfbBb7C7qgnNUaErBv8XdWy9bu+nUq7OPAu3D7oYVp2ZXb0mTZyps5pxil1qmyR0v2JvrK6obx4eDkyuLUlQfPn4O/ZSclmwzQ41veK6ZPTn/zO3NJZvRsaZnHl4/NFzq2Zs7PbehppiXH0mf+CUYb+vXPHLPiFBVe6hyZPGY5uVzCh45i6Kv5TUU5spSx7OahnkL4nLp1bjttuD1RIggezAiggfVPafr7KDos8tMtRIBrRDF48ERbCIWrBA06+NQXQQTzkCVkNi3rA/xUKddWFC2edquusGAHZSUKkkSDBqptHgAn1FdOkUp17Ss++bBGTMe/Abh06rhPx7FZB1Y3li16g30zcHfPIymbJu/6g1Y3Cjj5Y5cjz+Uv6dl3ljphP5mVmUybhNMNXJBWhP2FwpoeCwTfFr35olvhjbzs0gm6AL65o1Vk7eA/U/8/iDOmfpAiWF0ibg6Bioj9uBWwCuWoMPv0OFfl6lSQljfhcdBfbfQH1H1ZchPYi+tLy2tb09KuBD/7rrKEHVq8otQ8Ja76A3OHg9BMWXUTgSGkOk+du07UuyBXGI5w9jdWoK9B2IsbII2SXwecMS1SKgDcFNcmMT74isYoplKvMdNQS9/RhDsYRg0qQwGFTpmULWqDOgYuQBN9CJqrysBTPVsIhoSTPbAwJkVBuPwO5+4c7jRsGn0pyV1MBIDwUf3XP+0mG+0taTu++LbbvLPXD5jSv8sXQX+p2uqK4nrRgv/oPXzMWMS6kd6ogaIqBIiXp6/pJIOMYJISmU65Ej6K09UwNJBYkXNdlpNynx11/PJqzLZNplKLbt6VaZW4SAJ9IqJmp50uUaaLD0qfAgMOWQ0pKalWl1d9Y1++s8z6Y550hXwu0ay3ZVfvVonSfE6Aq4E/VgRVYIBlFUSVfVjnzDe9RxdGjWAkeD5/RrTjgk5FQLB8IF3Dxx4lx/z2T3RML4kaGFhQMg8xQNDZnL3QPiez3A40o03S+iYmWq7sD6TQ3CYHDLS1z0Ov4+lqi8GPKu1tqLvg6AGzUSH8f+ZoCaIvm9tBQzoD1aD/oiZf1nCoHBrpLWzlSUn0BrF1cLTVbfvaSY21zgJfeYIfcY8Df1UlaLr6UyfPu59E9ebI3x/x68vabXmjjazVnvp1x2YL/uBOjzCOWNa//zmzsiGZ/g3NFlZmjf4Zzawkc3Pt7dS/0bgIoFB6umTSXx3riiNuPH7YcL7mX9Zls9Fv57haBuLRLefYWKFcsNiie5QwcukWNHEi/hezW2YDq2gvkpSKTaMjk4QMZfXREhitsgg8bHucZG5WgbESDg6OUmnRQWmNKNBbQPX2DA0R//MzUsttKBBMDl6LQ+tBtU6p1oJ0zhuQse8ZKf0G3mBhVtmTNVcY9jZnUeBHA7s+Dw5XfUR+yXbeWYQXA01qRL0I+yBQa7pjUHu0PXGHW9neqGNcw+LWnBJzKhrEul9/LWYnXIBU80MZTqBBOhBCnBhOt8XDAIjwGQwH6wET4Cz4DL4GkShEn8+gijmpnhiZp5Iu4m3Yo9bEqRhCoIiEdMQBYSAGfgyhBgIjSe2nVnixkstIQRtAJgx72wWc+Rc1JEzwTcni4vYsURc31r8sWmP7IViNo5MdSFAxD+ekqA39hxe9RltrIUAEbkFikXk5TyZBI4o6AuxxLrLIopUgWAi2qi4xCSRLwRs9A5FCnUahYD4ThNBt8MFtASAkRxJzcgiSfQ0iJdJGR6zpRjXnhc9C1I/UxbcMEXErow8EcSch19ioe1kI7LboJuJ+Rjwl7BuwS8xi/FuHv88folTdPXhklAv0Di9RMAF4CyBzCAeE34TfS0F1vOopU6JR80KGZIMHBDjyHrfzAYIAJ9bDSzi16F6u+Q5zCOYKSqTExfJwlEv7hL6jNNU7CK1EgJ+EVWOeEnEWfEBET7VKJYSfCJ165P9EDSk4DqVCG5Dsh/AkSlmc5lqbEb+kK2FWQXtS1RjxKAXvg6ynSkZAXdJKt8yvL6lpW3639akLLplxQj4o9QggAmRQGGjOToi+lvL2KIxzwPIG6SSZHWKIFOkptlUllSnVW9UCP5GhUymGQYz3Km8yqtmoTxbrtFYqkFocardJNUOsZSzLOQEPqWosDhrdUHFrN23GnNKHCElHAn80/qOzgS8wEEI2HJLjR7PG6mL+g5KUusUOTLAafNUfKo7Aw5Xy6TKRr9cAEa91ZlqUTusKQq5NFVlQX+XNdi4lFSjfZgzWdXfpuLZUp9miE2dozCZtbarL9kaZA5DakpWWrUq2enS+IKc7Dl1H0NmvteazL4v1bGsSpeVB5JQ29f33//1/YG5c4AgT1ufLuN49KOU5eC7kJNIFBlb0F3a7DKNnmXl/ICXWdcmYLn/FDAddrCsrkpjLfWl85wghxKZoJRqpQZubhmntGlTIeTAfyXBQEGeUqqTlaeBEayu2pN9UyPv3BDwjVFZuN+8Mu3EVIkFpsuUeXIDgKxhNDTCmejRunqptF/44kUAuGNcktoAWI0mRy1Lh1rlW//1KmziG1fluAfoWPkYX2DDdq1LkCUbzFU85zMlhBtT+slUTod3Ac+PzkgIc1UaaX6KszjXYhgyZ86+OR8syO/ft0aStaD9I0W6RVe6eCCEBTnJydmFkD080qxPV8hl5rQ0mVxtVKdJlan4m2lqoHyA350bcuhc8mQ9r2c5wAOFJIuVcNCRntlSutavtaQBqzZJzaqhN5XTe8v9NSqpRiVVs2vRP0bdJjew6iSNWp2apCtZW9bitDugHGbzSkDcSOIck6Runb0yK9s/UAaLkjS4F6UqZalavUomT7WZpOxjacn2Ga6b0wzcipzN5Sq7Wh2eqdXIwdI1bPWWohn25DQ9Z0i7eXu6unxzjkSjndFP12/NIg635bh5rMe906AXpMaNfSHceGLZ8hMnli9DbtwTU1bgUaVgB/d/jmtsxM1uHNXAa+C5PiuTpRK9dl8a3GBR7Xw1WPTyQZVJBgAUwPgcPCClqiJeKuGJD0ggM+oMChYCXVmlTOpVqdIycZtEN6m1g1YolP55AX89hH0/qixdXFGybSong5iyGywKlWJk/4zzJtPeIqeZZU2pfSOgIFDldoChdbjzJBn1HM9JX5rcZ0dgnl+pWDlQqy7CZa+n/EJ/GeBfpFx5H+rvuoeGArDhNvUV2zhMkSRCiPfiU6ZX4H9q2jZ16rbo0qnbmpq2RceXzdt662/OAw8ou7z993dOzWdzBs1fM/TZmWlTJjUNdCuHH0KnH0QfffTihqXV1Y6CXPLQVProVL6o77haX5ZFzcst9oLSwSNmzu93ZLxv2ZRZI+r7+tK1LNTaSnxD+owKjojrG8T8VqVT5MxaZjbxdsL09ORDUA97wBgbijEbgnl2PMf7OLpQFLpECUTxBto5fdze2WAS9e1EEGjM8cev3HZJb7xALhs9it76dNOmT0EJaAAlJBRdcD0S8hKt1q7Vgpvn1jrT6PI+zTlCtGqOm0m/Q6M3PreRni+gjy6wTW5rZyQOOM63bvoUvdXrbb+9AW5ydJgWkXe1acO1fme5bgmRFSzRlTv9bG0vo2z0vShKm7Rx4yQxtOfChc7bIUUOpFC2cZsymYi7bqE8HVmH+XTOXk3hp5yUqbdaVbFZiFyNCHgdpldfoYrwArWPr/VPrrrSWjV5cpUQrprsr+UYwsdGW0FEFOZ3inbvx1DEX3uMJGNp4mO1TK8ypXSVKSaL6FUEUzK4rqiYpecZSG2EEkvRq4i4OAxsrfX3KkK0qWcZgf3/ojwsXtb+/1QeiLnR/7PywK7yWPCoZf4nJZH+cinYf+v9RI7EczeL2MuA+tIwxF1KUo8f7phrdAu3gLrH2PC63Jh0OrlQcQadM1iVyqwspTJFD76zebJQJo6uxbfBb/E9XpfDt+XoeIOI78wSOR/B8LebCFqVzujAR7tH4nD6fXa/Dh91JTRsCeA7bBi1RiIgHA6jH1pa0A/hMAhHIqgVn7UtLUAb5iNtqCkSbWuL7NkTaYP2CDhGg2Jzxm0b4t4QciniRR8qNSWYMFQJSUdGKj77HbyJOiv26/xOkwsXhGqz4lJSv7Mxe3VypubrJikesSjSwSDiBDbCM4Dg2RJxigT/OsQzwrGdOBUbIU5Eo7gHX8Ppic9c8SmOAXE/su1E4I8jRJ8IJBRlaA+KQNKLyAMx3BxcMVyn9C75kC/m42Fsz1r1rJvOGa8hSKyl0+RzObqrSrzsOvAP9zO/I5YVXon7ZbSupCb4Tyw6S8RGRNsJ1zrKRNpxJI9/HfgGroLot4FExB9hKdSv+Cz5QXpGMSe69NgRawpItz6i4h3cbrF3kgboXgfq8FqOAbrE0YEvJBYH6bUCx3Q2EfATPpxVSl35gls0xc8UNwA7ahJjS7M6m0oHN+BIDZNobyOh/ocZ4iStEgRccckHod3EIWEPa6FVV9KUzyrRj8DegTt2KTiXlfpMalNWJxN/NWCuyHGKIyzuEMCeVcoew/eacKKsWCHiPo/i2FlJ+Jv2Y0YxM6jlZRcYYaArbPaZeepMBI9JEwGGsLv8BBO7hK4ViTsoN7VmDlLzNb/omZr469Q5rjd3Eu5Jt0jlBw/KpRaVzcIqt29nFcDSMeeLuv7zb/Jvy84Bg+Eb02fOX716/szphc2pqeuenpaXN+3pdTPZmjFVZeGGKlbPozLwlyFTesITlZS4eLgD8o8VZ3BgPeDaQAl6q7ymT4tGC4BjcYkgnfbcNKnga1FqIJRk1Tcta6rPknC3BwbwrLS/N1jFAgRr2EAP7CG+q50I3oGV8TIh0gPUmP/IxJXUBRjqGcxLXVvaOUCNuamVqp7DtQ3B6yynxs/dtAlO2zR3LphwBP14z8r3j0w6gr9xCKhh6qJn/rYR/f5x9P5jj4KcR0H++r8/swg0JtYSeOCT2S/++UX8lx0dkg3eRi+jH3EO76+8B6iPHEF12/9+f9O96L3nTqIPH5750LespCcGFtuDV8O8Jd+Ltl+HsWxydhuxmSlmXzcuVcSg6mglkk0urDJEJld1UFLP4ekAj534vWPH4pFNJFksmhvanXgyCB07Fr8TicXF/KFKCe0meqx+poIZzSwgchgioSNY67ou2W+XxBevvbsuKHxIPAkXl2eJuy1UqTBQbLFxfO8ISSumncxVQkEZ8KS6MgtSLqydzm6wKatSjUx0BvuLadqaaSbwF7p1WFlVUFBVwO2adPveTXtvnzRwyYxmTl+n55pnLBnYwdwolgsT7wTRMBvBWbb/vRuaiFfgl9JQ2aBBZTSgLSDZd06tWVblcFQtq1HsePup5wSHQ3juqbd3KG4YmyjfzGeG4l6rhYJZH1d36HZRpdUH3VCXsIFPb4MQ63fgMW2xEas7NWty4K7t8eIkfOTSsWOXxDahRW7quuZFm8rbhu5aOrCTGbh011CDxWIgV1z8io+gDrRo7ly0CHUkIDPxYDceEbsBn4DQ1Ddt3RM/btr04xPr0gRHlkPoeZkoV82n89H/rIa5wGG0OIj5NPQ4cf3+ZbXaOhkZ+72sevGOuq/qdiyu/vdrUhWqaO+/4a+n16Wnrzv91w09ZcKk7H3+s7KzuLc78Tj4d4o+mh0zuizw9OyvZj8d+PdLfuGJJzrVO1/PyXl9Z8/+NOh/158kgsP9n3WmW+fBF+bd+r/rSL7du31iF0r4DhqmjHh843uRlGBIGvRKPQ61VLBJLYZed/m27pJPY60Z5UX1JePycnPzxpXUF5VnWFmu80ax07qfCuvV1DoZH8LB5jGN4dr8frbUVFu//Npw45jm4I3iiJ5M/KEEvQkGz+Jz8XehO70x1+M6jxjApbaQPSJK43HRg4ZADGxMTOtJDHqKqcdsesAPUoAucVIAYrWLLaIJH4sXR/ZwobeKHpwg4HFbIV4Wy+fLaWyxRy3Dp37FvHRUv7KqPs0ZKfYZO1QLJC310cio+eitup3TFbxk+5QS72AuUuuPTCrsX+VFI22nyLmtwIkueyrJsjc5OxP8OjP7ZxJtvyWrnxRWeSOrfUN5ECnOCBQJd8z42VeG6pIK6luWjwJZNbPapu8EUzaYBnTv8zThb1zEEDAu0ixO0Q4kGcQBGAFtGdws/piFiDPh3NUWAbJEIt7sSWt4QMziT9yiCLBHJ1bZqyZWHXKH/bVEDTcMH88ICHV8lRhv//W2pekGy/Sdc+6U1qlvGRGt77sgE0V8B+YOK9453WJI5yNV3mgL1BLT0OgP15jzvlp/bgZifHkZYL89BfxIbUZ/iCeAu7wvD6rgdk7XSXbMQeqsXDR/eHOwADLVY+YeyABPTN/JVXTh79F9XjeeRYcw04ifX56sr0QxS9Ahqot3oUzzMVUlgZewhP8UIYzIZgztMgJP8XlJVAiwrjgkNW+K4Y4EydYkS++Kdv5CzL9DBfBRs0gi6OG5otPHKy2hGh51zD1wYO7ivCETDsz15sNleAAfmD8GPTLxjsPHbZlVXqsRNBRVgjAJoU9S9blabWWxUQ+abJlfR1ckmf21+S6ojtIVKbR84100v6EGjMwN4CXoW9sySbuXlQzwutEbkZ1Fft62fIBbfuDdA7rUjfVzD+j+emBudEbjdtNoC3xt0BB10OGtkh+S1xdfY3Bgk0pqNbnMxWHZMXWQ1V2R1vqzqtTnwrVza+e+Wpk7q5MxjFYMyIN3+2vXOorQZW9ooPfixYF50hH+nMG6nV19j64HMyk2Hu5JoMvJXQVwdTEr5CN4xDDQleCuRVkugi9LgA1Njhhyks9BNSpiqwIyrEm/tfAEmTkm/FpXsTAT9l3RUo8i9S3o8+gn9S0PrQT35UQbZuyV9mupl7ROiv7GE+7sZ3WzWp3cl86GO1txWDo4H0YmZJXyYXlxOhpQNRmP5SKtClQkpRGFcqtbwpQWdf7tnnPoCPGKcvqOlnr7yociW6cPn22vb7naCqYfWceqStxWu9NrTHfb3dY8dV55aZZG05rmmlxlt7qFoypvyitUgCXi4RHerh+zjNIsXD2Dk41jRJmtuEKuXmMzBMj4FIFLWGdCED8GHNSISVRW5yysW/RYS8hYCogBxhGjXELLyABmCwsr2QPWZbIKT0GYYweH0fmM3JLaUtCRkQOfcpRIZ0g5YRlbVeAOyaZbN7HhQneFbPe6+2QVcEp0yOhqxBeXHZiTXJRRaA7KbxZWTVRvHjdyg3H2SOOGkWM36iatEZbxqpmGm/hIdaFaHd0FPncXVhco9Cp0Gf3E/fEra01J/1y02ZptB7tty1LBJ0q1t8rnQs3QqVYXVBW6o/fDh92FVyM+sMbdEpqzT6GwaXMFyDiTJt0mH7t09gg0CkwcMXv+aPm2SbYU5DTnYwq4qHZKfM+XtK2PIpFMp4hcN6Z2FaIjbqc/YS4QA3jkeijJ89HZoHsyuJ74GWLemMiPyO/uzK4qGSISwAtmJz8xqbS+VJwmhgTwhDEkMG+/WT59SEHJ4kEpaZM3pE7UNldFi0ViuH/OoD4H/mwHdvLH4zkBMSjyRqCuhBLCFBNoaZr2fnbf0qwKMheExweH1/qbYHlweOTwvI/gANNYYevk95ctQLvCI0RSOOdOJ3TOPdAes0MTfwn74i7q6XUqs4F6JEmsol/HxlSY0oGItUoAfc1ChkRDwQhpB7RkqNkYgqU4fZS48VRrMBH9+GB8ChG7NYi1OEvRXzzi2jpAF1caQJZfvLRvwU7LaNP2xuiMuQf+qjswt35jqg4TqxTTgOXPOYLqIYOCxfWYPlU9ZnaZrFLVJnmVF0cfk4U7+kmvzMqtfBVTptrwOXVVlr+WS80boBht2KkbnOMfIc0bePGid2DIiy4XOdbW+tmbLJXHT0+eiB4ZM/8A5pfgsnzv3AMThuQtJsQYdfA1wUzb8cOVRaDBaPVWbdVqc/Wp6BMSzrSBJr2xuBLMNidFVwxY5P0GWgjtjUag2pVf2/6XQC4YWdMwAb3h9g4oKSMzX+Y29Ja/tgsPRvg1xzDJlIc03Vhzp9jMG8wCjfUoCL5XBj5RBzget98gAoca6Ka0QcSGGWdQoff0qq0qA/qDyqBXs8kqA6ceCmRy1RalHnhflJpWGWUv5AO9cqtKLhuGz7cbZR/J5ayK+1hm3KnSs23LVfrOd+nDeXrVcrXeIO+sVCnkOiWsQ2MNBnAy+oRSJ5er2bNKnSF6JSlFcMqg1KCL6zCI62oZk8OUi3YIHtGNQ8ASq4uHdfaEvBGVyQQz7LVRwiRskpBNE07f1zHq5nurBpecl8qkhruM0pcP69WiHrQ7Eho9bXSNJB+9i354ZfnyV4AW5AEtDX1wg50Itl+jQ4/+NOR9tF2n1urAAnQvyYfA4SSl3z1r4t5MORtY/gr6oVd+qLZXRjiUWO98TGuoRyhQHAwUECM/PEnxXTBH6cRlUSXmEIk7GDJcHP9esuuaptceEpx0sFmtyJfotQqO0xhTbC5D3bSmIa4BWq1Co5X6VRpWm+dvyN/325dZJU4qz5fq/kXSva+87Lm+MaP3Xb+BBAqa9foGFQdVLKdUa5TCjKF101PVagWAymFGA6dNTzae3bXnDEmlZv9VKq7oBs0OTDf4hmQcha+1Ca28neqUMDLOInhkIChjPUGLDAj4P2wjhC7aBI892DQY2UHbWfQpPAaPRZvwNWhD9rPA0YQisI0IOskNmoxEp5NEsWTksc+aQITpITsi7/Rg0onfZBFkwBL0yPigJygDHqF314XngQZ909jahL4Blqyx61A5mwdeReXov4EFxwIL+iZrLFt3g0o+RYxRGs/gJOTBCH6kCryKH/1vnN0ZnB1+sBFcvUGnJPLqj2QMn4nLaWBSY54oBzAjcQ+N9PQKEN9Z5WPqZQHqaJf6SqGpCNXPjIV8opq9GlAgNkAguopt0FQSgnFNXoNDTdXTiUSQqHTg5TmFL4Z+qjbjoA7C4fag2xMMetxBbkNwWDA4rNOz+Nhi/MetX1w/fMniY50Dji9ddvy+r45zG44vW3ocX3R+iv77zC3vrlnz7i1n2JMIvYPOouXvHpwwdv8FOAL9iDYQlwpgLQfW5YVkCw+hK4c3f11f0KAYba//ZvNhdOXQQlkoDyzYD+7+vA3cBlPE1wcheXtgMnnn4sWAlqGVvvg4wL+vjqMssBZo1lxqv7SGUyxaOOHQu8uXvn3X5KhAovFnwK/lON86353P3Y2uHGyZXnqz+SbX9MUHgfTu5+7E8TMWt+A+M+sawx2idNFA9IUpaCM+mIzdyjnABojXbsESU37HK9CYcnmQaB15WVEPycZhWkoUi2yA7Yu2oZ+BHKwCcnTgmY0bn9kI8lScKivfs/RcDVDYbMr0Men9z6G/p4/BwXSgGPzmEk9+Fk4izywMO3hj1eCWsgn3u9yOcGEmXA7kz7+Ac/r5hefB4Y2TJm7cOHFS9IGU/MxsR3KNaTDNRWWzVZ9DP9lwYAzJz1ST7MjOzE8x2tR6K6d2Ws2+5GSrXm1LwBETmAATotqq8Z17L5AIapjhLqAhonlkIVpCRkz38IyKL/ExUFIACe8KtW67RGu2XydCvmfSpkmTNgGfPLNPuty9ZsOKlJT0Pplyc1b/kXf4bi8ym2XmCvOZJUPxUWY2nynZOap/1qCX0E8vvQSUcHUi5CmLSE6Toj8bk/hkaVJWpl6fzCcZ8/vk+dUltxfGMlhaJ2b5Uonan9cH6IHyJZIb+Lonzqkoh3gG11sv+ncjCx2qCY3JQczBdxCIXDumGl2sqCSt3/htX6Kzjz2Ozn61bWIYni1wgn2uAUV4/f8ietHpLRqQCfY7+MiEftGrj6PWr7Zu/QqEH4dCeGLHZQcBWiwa4EBvgIBjQJEvA61xxHTU78I0YDbpczwgpjZuv5shmNAlbr/DpIYWM2MhSuoQ9zY/bxI1uKh6XaDEX4xXDDhKYM16C/BCnIB8Jkbg30PvJ6O/9wP+BnRijGnCsjwAB3lGlGit4Jb89A/MhvfS3Mch6Nvf5JhvX1iZVD0FhC/tNYSWOC6pvhTAs+pBfazgLQC2h6I/OmbDp4ui1zYDAM6yxjeKl47h3dJimFru7NO5a0YFOJzjAV/4B8BiUAC93oF/rX5vf7AICpkSAIpgqBgNdESRjr3qLlIDTFXyuJ0d4doEPG05k8QswVztngSKR1afak4AIc5lFAg8Nm5/XEu6KkinW64EEIeiZmN6FSSfSkP4/CDBJsQXBdQDHuF0C+i6gLpyI7qI1DlGJR6YopZH4ozdYzZgn3QkW90ZxTjbybLlW7ZPYdFxYdWmHZPhbc1sajKn6jPk441azBBIgHbwkNceAUkGFR4kcPHR9AFyBV+tXgAdKZwq2Wgc2rZJA1U4nWZQ5VuPeZQK16KD6aVyBVemHr3uPbzIeg5dfm/duvdAFhgIst779AYTDNxodZPiOEbCAdIFazZMkERfEBbevHFC39cfhnqNSp7RcsTeH2dZrZkDXTZOlZbF1n62ScMqyWsH97/wCDBrlRKDUtlyyIbT8VWqBaUyVbj2kw1KSKqgGvwn+vJ1iQWC6/8ZHwVic6uZySDoOIDsrrnc+HMFMmXAzAVZN55JtC6zHmKK4QIB6Mkk+CSYsLC3/PD7r1dFrcfQTz70bQQsjH4MRgwG5kNfvYvuf03y23J2xoU7vkI/gf2NipmotP306fbTEgau3vK9R/bAHvDgPY+g+dE5d+xLQxWOq2DdR0ARPIDOoI+jIzer4aKNoHKF5DR5iIwrSPoX/zrdUbAzHje0giAbImKKIBlDLNX5hILFI7ERQyCCtaHm8DzosQFiFuQlAQsuO8cYzFANOHYr+hINmF+uH3jXbIViiSrnu2WBjUJyrW+0VKNI5i3jSzXb9SZffbZvco2rokyGl0/mbGvfh24ZcvrY/nkpudL++WNnpGh23wowSeHg6Hsvo2+uMSD/ykYwCgwAuZPQn9SsbsQSmP+7vlLM+AF+hFOwFMpf7J87tDRFkPk8kCvPhIJeJWWnjFBU5KbXzPJPePNRt3vkoIfB+EVD0Tz0yrprzEenpvfC8Q/iFsAjh6MqrkT9E89PQWr44SYEj8DP9sHfDRghhVII6P0l0EO9Ber5SydePoy+nVU7juPG1c4CxsMvn7gJnX8oTf0Y+u0XW0jfeIp9EBSB+w5ta15x64pDr716aOXWlfO23smnLtyzblL7zpyd7ZPW7Vk4fxWQ7vseVJ9+ivQksLLzSis6ubZyVCmY9sUfwbSykf1uQadi6xMt/m4/MLmMn6lkBlJ/Nw5x1YrZFlJqXEiibxHUuySsnsGrEwJkRmBwzCwl2eS7ASr3IxquwEEXtZgodqz/cN/0R4rBA6VfogsPPv/QF/d/l6+b+BowPvO3SvAsSLZpmGtPhJtHF9bOHDh31Pw9N705wHf11aljlt65+mnvNHAFXuYv37HrD3BsaeGeVyaNuuenzSOXAWHpsb4Pgeafh6Pv8IQzBSy3BqdVLXv4KfD4yGkDCx5atLVjzZhJIwd/suU8HHL7Sy/FZW0RQfQzQnABbrizabpuz9CfuDnNGFRX6a6lRNzRjNoB3YzopJsRoClqJ5uWknDVZGBnacJOsqfJnu8UdWDiew6RmN6LWC4znhf/jMtlIbvHBh/ZTxOVoPH/2Nuzu8wdAyxP9Po8dLtNdBGNR5XLfdsrA0szvWo2SW/goM9WNgX9UFhdzX0NSvCp8Il3tSgXGnOGBm+us+dUZDhNcr1xdN/8oWU+pw68W81HwqNLV2yed2TKOIPs+wknm6sL+STyYPvXhdXvgOkz84cMLFJaq1KqXzp+/Nwwd3ZYpVRYCorsMx7r8l3D30TlJQOZk8wreFYVRIgQUReaKJATJe6YWRRdxJEgXiGYheutV4Ix0xWLmTdSqOIMmonfSfOx+HQxiytRlR1HpoM4/LHoi0kXQ28TL/EakrRW7DMaieVbDCeGlIE1G7uKSlJTzXY6EHGNFu85dPzEXfsWLQ7lKLkSHw/0qcWzpkU27bpjc2SqRK5RmjKRqarSlKrTyGWhKl6u0UK9tKpKa9OrJEK/fnpbCnjNmz+i/r0f36tvyNUAWUmx3NUXsNPn7Nt78e095YFUjRav9lzK5l2DBzXPGxReuKnpiS01O3e8dm6HPwlK5Q6zKd2kYxfYbJ2XQNYa74LVN71XPyLfmy5TKKwqmTB3ZmTf5vUpekz6VBseuu+uWxWSJRXhcGVLy57ZY1Kl0lTAjh+wZta0QGlpEJeYYw0u2EBLLK+o4rVQoxbk/aq0aXq+qp/OljJkxcI5I+onTqxvaLZLU3Ta1OnVYCTc1jT7wp69F7WKYp+UZSV3zJ45cFD94EY0vX/NlsenvLpzxw5/BlTI5FLeooEPaiwLUVrOKIN3Yv2IOS3gotSoVVmFCTmlRfKCZJWWKwuXkz6Tdo2RfCYh2GMhZhmRsLkCZiOeDpwZXuI+lzovtnCugIugzWAODXd2zO2roVPN5kAR4CZgJph96YQhIdICNUu36vmg+OXxQHFRA0QbawJGaowQqABqVqLRmDWq0PqDn65Y+f2vT8zIkHISuYpvnQ82g0MvgbsUOmOGT6eXmQp0vMlhzTPkAolaKuMlLAuAZG6xdw3alOJyq1V/zBpmMCjU7pXbdm1sDpU23rJqx/RiU8ZYialvSV89+iBv/NrTs2bcO7VfcrRpYFXNKJu6T/OCfn0lkjSDNjiif1FowvJJ2TKNjAfc8qLHx2S9o51XNDJbLTfkHzQLMhYShXLyD0JtoURQgofSq4pzFIo211CjUWHuMzZLUjjyjgmjdkyqyU6VwXX97H5odjUEU/qumN9QVFwzaXhG9OiYgjxz8rT80nuhsWAKkyj/dWI6SLS05iXYhMbRlbttc7tCrhimpT+Gccn3uhZ1TH/BWj1mrEVdWcccaGNCSIileLqW6IApIcxF2iMscx0gi6gNwdSVdOuwNBHy2xQ7irboolZhQrhdT0wPYbh3TjTYo3001NuBj2qxmRLnhGIz0bn711ig/6JBcVtxeFKIiqojxDcUXhUSSXR31dlE/1SRG7YajgHH4mn00Xc4pvW6OovhYTduqLqefcKDORfaJ1zdEGduSpW7fA/F7NAtZuP/WTuMJVbmL7wg2pi/+KJodR6/fuEFWaf9P2uaO2+cXdc1avvftZcRr6OymFKCFSsTQZNirRSz1v+/aiDeghi5VY7axKJ/BMS6dDT9Z80C+yJGJgN2sUFwbjTbaPl/0Bigi+dNi9ERQKfm+ClBOgFarW6YpLPEj27rVaorL2Hc1s7N4BG124rEU4cYj4+iXJEj+Stxa1P79WCXnNwcRz9w0a2SLplRADJVIWr3WbEbPAjy0LuoEb0LGVKdPRf0qfqHQKsmupi8BN6h4cLifZAHHqzDNy/sIelWPoTf7cLf+UM6R7moHg4VQXWLW7o/FkFqiherm5rGgBsIG2mSvC2X70zNaqf2pjAsWqUyWamdLwDRRJWlOGntrVmpO2lKiNuW+wP+6jtTCSAkRQJzW8OpHR9RPX8r2yoChOHkJE1rqyhvlzJ8B9UtJmOZEfeTBSDxuPi41nQgiLkv3hXgdbzOhf8DfBa+SDXro5GkpOhd0bvkaoMOX0J8CZths70jCYY7mqCda4u28X83OtojRrtwjVEofv6ZVxgdPLkE9FJ1qEP+FfezqkP+Pvdze5T7+f0OeaJsWIdL5Y/PNwKQiPqCuDyOG8TEN8PJsCLFhozKoEN2QYpPoE3gvu5x2fGgVAIZvUEllSB8kmBmvT1slOLOY8Bzu1EKSKB3DHuNkRvaMZPOAhzgMc8e36+xC2SYExsbC1N6vWeV+FnU8PRIeAk1xQyGhCDZZybqnlB0oALe7Hn6Ac34aeHMR1B7SYbSyHJJvEvt0FjVGn7PAz+Au8HX4G5YmwDrKf4BL7oPvX9S/0ipnAVqhcbMO9Qua2Fhf8/46B2PAs/Jk0y3v7Sucnspomsv+6D4meyd4OGSTvDcMD9O+PLMgNYNjF0VInJqvzvgJq4l+CD1TUWcw9jADWv2DWpGR96+Y8PYlCTvXTfnlg2oeAtMf/ttMIJUeGDtq6i9qB+vSeJYHsihEgqFpuwkm+LIk92iDvjk9fWObP/21pY3hxQ3TRhROd8tkW7/Fui/RdsfxY0hfay/WorpDKflNJgtlPotpd7BWeOA5MCG707NnHnqO/odZRzD/wP3QAkjZ1SESuvwH0gG9EzMeBH+D+kPD7hxwBM9jS6zK6OnQRZ3lIThcPQ+iaVyw4ZrrZJH+DClQxLAODNYNwuJ99ZQzOpVL65vggEcqefNkkfk6CX0X1/ePi2vcfBo/YKhSQ967x49ZZklzxzs55s9U6paXRZeBUZ2sO3foqloBBCOgSogqZtmujPrNqls/Xb02Zirv/rV6O1WcKtCyvTAwWHJXga1AGANDtyBJUw7w1V8/HF0y8cfgwo8MTDgBFwJstEforeii0wPHxZ4mmDCzKjY8wLF3A56gh7iaJvHK90gUVWOgYIQOyy8hjI5/HjVSbR2fEFnBtENCEHgp3p6fp0DL+RiyUgx2B3K2vTkefOS02uVU/x2PzpgTwaPOqsGF23e1FRnlKtqQOt+CQ8BOOP+k0TKKlPgioDAQ/SdZaRFqR5ICs+1OkYuSS4rS14y0tHUdNxeYArWutRLbxkckaINaiUQGseoAeA4OQ82RpRsfUpKmqLzN2PwOohVSqB0plkwotvVMigbQ+s9g9IfstczgngYJXqGdDPGHtuAicGzuwwhYOGpSggZJ34Xy1HlBkAmFjrFgABeXGTEFqV4vWgU/Q664xDQRoHpU6y8hHaherT7ksIXWjZydN8PQPYyNkkNFusH54YaG9eMRU80g7wPy0ePXNZ+79g1jY2hikYWs/ZymyL72LFj2QqbXKHIvXNy4+Q7zWvGNlaEGuET5VOSvcWH0ZWDB4H0cEFB8tTyhuWVd8mhTKVlR7jycS5jQ0NQluzOiuXoT/QljahJYVPI5TlZWTlyuTxdkVsskxVfIS8bu4b25wHXoOR53C6FRPIQYskWFNFycNhY3KF1EiVm+wggUVANBEfAyxXg1dMAoB29+yUA9v0JLFzU3HEYzHnw9394vWYi+g7du/PFv0P2i98X9tXCm6X20PCGarN569VXD8Ev1/7pzf1jfv/q89deWHS8wW7t70Nbg0NgoAY0/fZHMGpa342Th64dWmrVAMAP33BnvK9S3XoRiT6FYXA3i7ETpDMSI5IuRsknYyZXXcHMDTHiIGYqEsyf/APH2WFTlKiYgwxqwoI5oLa2qsldup2P0r0nJ1NN5yS6cHHqAJ7jGUeXY9FiLh0Sc3TAgWIm6OrySmjnLC7iWknNGW2cRBWsqC7blgxqOX4xGoquPRUX4z71EzixEkptl8okyAMiaHE7eGgh+mww+unonQgdOAAg8AJYC5KWoVnfr/zjmXtbKitb7j3zR3Zc2cLAaXB79AmF/Cv0QzeZvPIep9XMS2fRP56OjgKyz9bvuC+WyYG9G++4+CN9+nuaEW1HO65nWwxrN4ZVEHQAjw6kYxoIHYDfGz00kR3b/uQz3D3GvdFvwUSk7HwIzGD7gA13dn6yjB0fTW6a0nk/GA7XdX4C+8TbLsL/QPd6b8FtR72Vd7m16QrzxFKFarngM77GvGz87O86h6DZp+vyV2wSoXTwMU3cmcCE1FQcsMEez+CzSSeeYUTbpMV/kImfo5GWYy1REt3145WCFtgdeQ57vts0VKvrK2gHpuhrDFnFQCso+cS0UNum7f6LakGYKLShVviDVtsCW/CB/iQCi1fmWzVOi91ucWp0co1G+45GpVFuBoAVJC2xhNFdLVrRDyTty3NFdCyRFasADrPFxlOePw4AJ64ynRlennjyclBlINETFJFoBUOSPiBGnMjsTDofUZcmLiKluHyoVSqVCdrO+11erS7dkm7XNWEunq4HEF5mNtnL87ypHr3BkpqXn4TuMt/WSBR6Gm8zNyfl56VaDHpPqjev3D7PNC1EKh2aZpqns+N8dFqvixtv18IPpW5pK8/J9ZHyea7MkD1T2xTPXK9uMqYE3HWebH9ZTcao+QfePTB/VEZNmT/bU+cOpBjLBuGvMqhMm2kPZbrmlUf0RkVPvQEBj3IH5VeoYgyjJTZCPhrqpfCydnhpNFoK4NMb0fBfRzfArTfSZAm1DAMq9A/APdMZASow5wYbK4TGvI+/iwdzyuXMUGYq9U/skcSxncgelyjHNlvIdOARt/+pdly3Zw/Rj5wNWEQX8eQxrcdNxVeZ2q4oIpKiHIJkQbVf0ArZSUpleqrcsvqdm7d8Hphfb84LW2rnkM/BmYcvOvj67R1/fuiHc/tDIPSbv4AJlmUH26daspMMVqV+0CC9sqRSPxUwWyzZFoNVpZ8/X6+yWkN68FSfKab8gqRUVl5mGzT45rdX77kpdZglnGeu3f/u/kXDbj/314cOfmF+5gv0mz8lP3/TY7scKl2ltRnAZmsoU2W9vRolvZah0oes9738m3utlTq9MgXzG5nXGP4jSicXYhaTzopkrIqYjcQ7Ak/MY4iQjajvpgPqt5TzkK15f1z8RvG/nDnAy1GLMOr51MZabFL+o7W/Xrfu12u/WXrYseebBc/cPC3gVMpS80fObchLkVpS53uylh7Q5wcmT6pJ1Sy7fXZ29oQtr61edW79eLctN5CngxKDtSTTm2rUNLpc1dNz5O7qtWPrbplUU5hhkEPVuHXrxo1ft+6M5rEVQ8LDcvqPGdXgUxsK+vkynQV9POqMghQbBLMarPl57uL8DJUQHL/k1snDdm2cWlbSMHeOz1uTmyaX692BsQGtAYDQMFeSO1DYJy25LBAODgzU+BLt9ET79ut2Fly9rhOddMNWvfoaXZUCfAQ9ryK9/XE3QTqSuwVGsTC41svrNpeATWOhEh1ibd9lLc/YQ0DrxYt7oDW7Ev2pJcohYtewoKfNOzgKstr37GlHl/ERfE/K0NpdKHrgexe849E97V1PDetR9IRwD96WeD28riV7uDcPJ+YAWn+pra5rH7ZX+/zT1gkm2nL+q9ZY2F2f/0ET9NadcjEVDOMyUINnCr0OMHNPtbxFJfmuc7GZCI5Eb3m0jcRwwG6WfOxkDYa0q5E0g4F1SiaNuTpqDJuZDBi6oCIHJjkTbXSXuDGNxkcC1RVBr6WaTSZzKihjB3VeZYUkR6JXTsevrjGiXwpCoeLhez77LGaHR04mil7Uh6khdngxbiquDxzzjoHnLg/rBWpgMdiAzxUvuVkcJV1hQ4Dov7ASMukFAOukOp2xz0B1a4nObG7cAwChz7SUmqXSwd4OxjtYulRDrsFMqxPaYXYJObqSwTHiFKPEDSKxc5MdOkuy8T2nlU92daydtGmmYcf4B0R99gfG7zDM3DRJMSD/AQIJhiPyB7CkBaNzvX37euEBHOxsg9lWcMzq5LKtqCk5I4zDBIahiTZPd9iEw9mck1xkwwzuAzQDPNu4iNxe1IgGgbvzSkm4FPd/B+6Xn9L12XDiPcvJko0xB+sotpip4ImlmqK4Vzi7QqSXUBlTQogCcZsF1tcVIjmwn4ZRmEWlQhJ6NgyCGrmcK+Wt6NkRQlKbVi5jhyEc+kxDQ6+TE04JBoVJmKYEg0YIyW2aWMpYiOQjI6Kqawy40pZ0jVGq1W1J6Bk8vWlBafyMD21JQLwHBpM4dC5+VirFtek8PM/sj9lz6qhFvkXQWQRWxupYokcI8Pin1ph4kFIETrZm3/79+zaCi+gCKEaF1yaBMGqdxFyDvwsvevjsz2cfXhSOB8Af9+1nd+zf1zkVXATF+P/F6BHm2iR0Bp3BD4AWPFZfe31NUdGa10EZHq9lYlgcm1nXGPZyV7kYV9CjC3oMRIpAlCrxCY56BP+zgxnRL9Ef5oNlaMd8kA1TFp86BRaeOhX9b3R39Av4Gro8HywHy+ejy/C16Bei3U1MD4zIarKZIobpkip1SZckFOnPQCRjVLZIJGOEOHOxOzxT11xX1xytoyeu7jMRxW+9qqPNYMc9UMXZ6TnaFLvzFklXx9LkdSg9DvrXatS3405uNep5fHo+Fk1lSuy1QZIo/yyVoGhxSdOIrxjiEsaQDUARIU+BYkBcQshAEQlbmtmkzrv1amEmuAD3oaeiP7yKil+VFvOFMwW1vvNuNoleStlQpwyuUOWaQEmnTDIhejecYYluRm+ZclXR29h/4CtLgiyuDX8JsiNTRHyn+p2A2ph7CBoWRZ/kjWQ5L6pWZoiKlaJLEDJZ4Ln02DF2QPP2rVebQOOVfetRFsU+iEwfh6LPrL5QbqgzlF9Y/QyKjpv+AzgCvgJHfoCtbdF3J2ZCMKW2qX4qALe0tT5/Yta6I5/MaQSgcc4nR9bNOvH82+JkEMd2iMtWxHWWgcnC/IBoE25y+g3US5mj+0e3AYBHoEYtsSkOr8x4/NdLpw+ynZ2d7I/oJBhNVHajTaxHKbWjLe+8g7bYpUqllLssxUu2Z9FcuP1jfPh8TKgjKzRmTIi7HBoDF0cizLV16xBBR2DEcOd95IlrzMmTeExKO7JwHtzkAwcOGLsfG9NDnyWdzEogtpkvSQdEk8di48ieKonBq08eeuxKHE9WyibgBGrohWykuXT7xYzMcXKPJzSz0Z8n4/Lqly3dW3sQgGJ/6tC3UEPd4pF9yr21HjyMzgL/N7c12Hi1SgX6N6M/mbc3n9r/HLz424Y3lhl0WVpbeu7MTZNH6aSjbnt4w3J7lYTNyDSV45G/tu+GI3d99Coo3ja45fSDXz78x5WjRlnQsyANJqmhfQyToPdWQHe3qBd6xgsEzu5yq+k+sxpi+kqVEzAFDfqIqrmvOBgisPjQQ3j82Ijkeq1FmH+hnM/PUOZbUQf6GnVY85Up1pcXwBRrqkxuTpap87TSgC5HF5Bq89SyZLNclmpNgQtetqKnqfATbl/0In7yc9Tx4qJFLwIe2AD/IqpF59AXF1avvgBSQSlIpaFzN1r/jC5JkYRCkpSSfIlXefSTcYNMyYVyLtu4fdWq7cZsTl6YbBo07pOjSq/kOBW1Lu71JhKav/oC+qLXC1HhjVTUcK+vxvT7+VgbD8YxZmoqQ1c/Bgp574lpd+L2xN1e4gVUX5egN+LJzQVFhWojKA7SVQWxPSQ6hGZ+TTWfx1VkS9i8MtZ5R3DfrRPO794y69ZV9wHp/icdjeW8/a/Wahv4OlOpyz0Plmbva27eN6fzg7njt+95cV/HnmXb+56HPw8siL6fUwrY/nngEenidZfvvnXmlt0XJt62JAXkjf2Vja9qTLtkEfToS1NB/+KvjeChZpJN+0sV25ftad/3wr7tjQt2n7/OD/Aw6ieulx9ggiIgqKG4EU6jQ2yQ4l5Ql0ZU08UrKqBAuxpqbdAegpjlTORv2ZaYG2PitpixVeS67WkWemVK8aWn+fPGlpR60nwyrUI6X84Jq/+4/sPvUed3J2fNOvkd4OgZ7O7NFNfHc9SDz4vry20mvTFVQ/f4qp19Mp1aVXJmek6fFGOlUtIgWOWt/wX64+wSs0VP92KlcXt4rrH8OLo+DGGupYnY0MalObgF3MTwDo+tdGBgqR4HXQ2nEM0fOubwIpE1iHid6UAg+IzppEOQ7uFxEqwf6myPqHsAM1Eb8oNHIxP/X2tXAh9FlebrVXVV9Vl9VHf1kb7SV3Xn6E7SVzpn5yAGckI4Ah3CLYcEEJUgoEQFBURFQDwgBPHAa1RwVtFdd1l1BXUWfjvjiaNyzLgwDjjDrOModLHvVXUiQZ3d/f02v65+9V6/qkq//t53vPd9379nIAM2VzUwwv00IyNo1SrwaINVpy6LO6wE/iY5yStTGow0zbr0Kln4N+ZpLW7wFE1DZUroK8xYLD5KFfHWBBWAwtcQ21yEQmWklgvvEXKCUMneydSlM5l0XdZb5uXM4GU1jRNyzd3CbiF5qMBG2ayaqjw9PhXsefxzi4/VAJxQGy1aHOqjt3iC2W9JNQE0T15/ojw53d2Ux6ndrE4BZgi/KJWTOKkKKZ8DZ4EMxxVyMTcagZ1WYDI75LQqqD2XYi3YPGwtknAEGcvFBwF2BHlCtAkCEhQb0gCukBGQ5gjai1JrxsIEH3USrv9Fixn87VlAdM+bmYhlFmffACzzMcMKnyWVBuEbE6vBixQG0MoYicqLh4ULjNHIAPUR8BDQ2qsLo4GUTQcAYGzlgcJQjUOPvwrba35otw63v5zrXz66HeBOoHhyyiJhzXLwblaN7l4zXuvT498wxreFW38L59B/MUZhrsp33az+wuL+hZm8PLkj03NHZWTl/Kk22/+xXdobJQfIC9g4rAdaKLdDsRBD6UpxXgJu5OGYBGJJlOhDXIEUEdXxXPQ7LSbTQyah+QcvthrAQp4lLe1AejdzkFA5D7oJWgASW3S01ABNykCuCUoJGl9og5qFXKHQ+sy9Fo+GUpJy4PcDOamkNB5Lr9mnVSjkAPfZpriN0K5IddQ6XBRRGgiUlufV3kgQaY/V6J4yZAuwfj/CA2xpMR1MGFh22TJU27HjMVSZNmvWNFTtu/HGvodVvSsVsuI8OaNSkSbWIRsQBhBcJKlSMfK8YpliZa+Kq1bLDfrIpGSDmr7uuHDh+HWr+IwPAINcXU3sC8RZP/ymCM6w5f0W9h8QBt1yULUcNewQunccQQ2ZPwDsDxnU1AdF3q+EM2IOdaOYw3lgRNd1ibhHSawWymKEtTUDyuOlWD+k/Luw+7AHsSExDl/ccfHlSjxXXt3+s/2u2u38ufr/VP7c9QCXshrvFQvphe+9si2798c9vnOLGZjxZWIhLPuJGikV2VG1n+yZq4GZvT88AZcKoffHbaMql5g90tXoBbb8uHJRKohRtZ/qKL1yuc2oSxQ2ki2+FZuILcRWY5uhKpAbtcQwiiagwXB0lSQtCdNIIFVChFxDU0+MBBLXG0V7b3js/VKb5O8hLUe6Ob+ESYcUVAmbjSO5Yb/OXINk938pvncBbBq0WH8hVvCz5pjP63IEtCeHkCW+aIc56vMEeZ+EpwD7DOM6ZMX+oAkWd0zvWQeLo8B3FGwS9Tk2n27cZZLr9DHTK8CvMFlV6iJdz79ztE4XM331pLjo8Ii09FB8GZsGsLukClY5pzsS8gZq6kNDJ9GqzKLUrEklfDg2KykhrKD/KQca8al4iegJglJAonLr0aP3IdWOYw/cBB8E/4GN60VV7/xOWIVPz/noEpcxeTbngzEfe1HU53MR9aK2m0AZuiJi5E0OeBFJH0YMC6fLJHdZNKJlotc+lHcB3i/BACIETTZhSCacKGyJTuTw8uCZmE3fLybuIyjJ0x2tgieHfyvxXNIRa0QXhKRn5INorrkS58wkYsoyeaVVX+OPt/iUnhJ/jd6K3zB8Vpn7RJisb/XWNEdLCA3RMxjU5/kMJpPBl6cPDvZQOrvw+deMNqjfo2K4/9iuf+BmV0cZ7WqKrN4SrJWRJcGJLeH4DfN9NmL/SA+bt9hhlfrI5L7klb0Mf+dRgLEDL3oWnsbjHr4lXp4vd/Ge+O25EhdbgcFr07v0YG6Xr0WvUOhbfF1zcTxvJe0FaXOpph+odgL9XCtd026rHDNRD58N/09lsbLM0LJGOIR6CN/sFL6ey3ldUg9Q4hvp4fuZe4+KR2axRqjD9qD9cNFxKuAecaGCyqmIWyHWxJkITbvcPKXE0ABpnhJojwRq8cMxeQiLhwjwyA1O5kYTRPjtUVisO7huAZpCiOBF2BMfH/T4ouYdixAND53UBhwury9mzuzMvnEq+7rao35KrabS8O2s7Zr62zLHNB78UI7ct+bIH5xGUD2oIs2T5KxYmC+ZNCu1SFzWHArV1wS8oUj3nEo4e7Kb0W3hXT1qioLvmrPWax5emDmmvnIN34h1i4hMCN5DykGe2+NBLgA5VYBHqjxSCXAxrl/yUPd60F4HlI9oRuWSotSIecZzzuTRH2dPI2ZroEIItUKjqiLW1Gg32/Xgy3aNSZO5CydKL1iKeh8Y9+g2K5BxTEtxgcnh5GjLGJc3ZZ0/ZcLWqSaKJQnVir6SDkCQioOjAveyeQ1lR8pUBMDnpLufCzD5QopZTcrbcO5U3VlKf/8/zdi6m8I9XbHZEUvEbYWTk+YcjRM83YsXbe3kpnJqqsoAFLh2dAgf1FL9UIc6Tl7GrFBPxcR8dtCiwRFoCxwgFMFjkJBZeekTcRQJr2cEQt2ICAgNDZGExFYguXuJCJtRt96I01LqICfAz8g0DjPPL1ys942JyOxqoxLXpXUsfkErp7jOtGvfQS2ldMjNvXccmHnXED8lEXgc5IfD7nx3cWe8kCNppVIJTn8/ZvXrS2IJsKKVJOY9NplzsatkxywOl9ZcIXy7sairPQIAqVa2gXhbJruP1gBCp5guZ313uzL7H+rdtyE+sLDBDsx8WXMgP1g7fcXMAgVOgG9OLT71xj2sQnhotrDXR6RqNPS/QBoCUP6tJS9i1dgEqMdgCFEVLSMgKxjeOUdIKKcLyjxSDCTeBki/eIIS65jLpOA5ZCDR5ghODDu5u1A+O4oDLFoE1gIUGS/yaZqQthQVQCrZXJ2FI4g6JZKQyGrdeZ9Xl24NqpqpiDv7Z2GPgk8lAkAmpEMpHK/iwWvZb0NlFJXyK8FJ4dFACUUlvBQDDn0CZMCsNb7mZax5pteOk77zgAAWlds1Lu9eaDm5DcQTWpm2RJ1chIe2xtOfewqi/q+sjCe/zQKUwvcmk9/bYvzzBq3J42/X/+s8udMC1Hh5iC8nZhi2B1PPhKuEOe5CWbm7POhPkO6qEB8DaTId8hZX9Spr/b5ifKYfhDW3mMfnB969xY8HAAVI4Gq3mlX2bfC8eDHYJ/x17LhPK+2Jmsgz1QXbzX5Qnj8eat1uYQ847O1kDRaP0APGe9v1rC0gzHpLSxp1J0JVICXxQCeNkbPhrzUd2gNQhfFLwAaQHikoCtFaqxiHAkkTQ7q9FL4tmu+4CAdgA1KVh1IPwXd5UeQuIYIZsEa/2cfifjGFA4YonstxUviz+Xkz6MBlk59ImWQyJc1QBvwgUC/R36g2KNf0zAVKcGyb0Zi5/CBsUrHKNWmhka4IEX87r9BUpgihnC+0gDUqZqNs0YkiD+6mXyRipUC//5fC2YbmXmGJ3Th5lT1oP3CrEUxQ0L/EUy/2OHmFUWdUc3IzcXH52xpWmdb9nhXOnXG1uu79Iv22xqiADf1EjLaYSSEhNBPQ5qWJsfZgYbZBpiyi/g0MxuNEkVp4VXltZikwANOy9NM9i17HK4P2VZONdrvx1gN6GT3sY/agTCAXQi0/ImLpIm4quZ6KTMBM0TlPXTeynBJJjjfiWuDhEQQUz/GmAO+EhhVadENuRxL7RYxUAl2S2bZt//LM1m0bLmybOdlN17ftO30STDjhrk+FfjU0xDjyu9Y2F2uJZHLs+u6+bFfb8WYWL3jzOq/HFl5a2Zs3zuK+Hjz/0dCjjw59tO3bra6atP2vTz1z7twzU9s0vtkth4SjcwHpvuepX7+QGePZsxf/8FTlZeHVlpVr/Wzv/dZEpX+ircipm1SxcHtfddt1w/mzRNlhw0JYGMrTiWJ2D9G9jMqlEkAYGiKCsjtBiGBYNFcJEnokLXiOjIkeByIAIvrGOVXsKmEhs9lDRdwjZ3buuiFeLDNX1T1y7BiIHTuAK11lU1Imk/LTgKyzogfcFg11jem0jFvvkN3TGKuItpv0YOyVwgF83T7GqihL3/TYYzfd8DRbWGT6RHj3/Q9A1hKpXXn/DbM44m6gu7Gv8xV+V+ja5slmdkxd0K+fWxfrD8TGxQu//pFMGP7+HaJfXWx4DuGSho5iG3NiEcUBmyWXHkrC+ULrQShzFS46/KACwfZJonP0du9lruFaB81HeL9RHVTJ5KTed+ekw616UqZUB5UmL/yETt/JbcTlWp06ynjTRdeECpsL014mqtExcnwjAFevhq3jSG13mqW0nNrBsVYdPoPt8LZPecLbwc7AtRajyaHmtBS7yUFyYY4sYBVOrxO+5MYgyYGLV6+DAUwLx+F6OA5oFBISRpjkyCRiEooJusw56DBc8mvKxTpJwyQNm0TqyIMCl5JQRMtywOZE550fpPIUDGOoNzgStS21av8dHfaY/VNabjQbJ3J+q7smUTMtEZtanahx2fyWLr3VKKc/hV3a1/vUta21MYe23mhgFHnpj8kBcPfqipsjW+g8n91dxPJ2rX3Chny1inI05avK/RqS9IaCeXnBkJcktf4KVX6Tg1Kp3ZvGw468sdCV57fR95asqti46ioamPH/SgNXZzcgMYkOwpAOVEG1SAfrJ7/dZqCUaHHNCBUPkQ424XJGp4lqvHUSHdR5NTGNVisHmwA2ajJAImC665BHdY4IamPtPkgEgbZAK66zSkSgYhARRBARKCUiULCFBEeorpoLQPJZhHo14noMKak/8Av6SIquAbUALS6Rov1EULwYHUyF8QiIxWPwZzZg8OuT5mSNDCrVCmzMsvo4xxHKqFnbVNcpjywQnhW+6PlNpF2nveZg1/rW16DOrVBR1Bta98CprQK2YcKdnQVqQG06ewj0vUOyqXhTeYy5Fg9Er5kVq1/TX09h4Z6msQURynAu7KgNFFGuI8xz8Vt1TprOa3H7Na4AQXEqYZ+DtkzFgT3s0QMAqCRYAqqAQuspHhveL2ubuXpL3YT+cflX5MhqgjpzLzZX9G0z0jzk71ccHj5JB6480Ko+5O1XHJA90klu1BHDkV9lTq/0GVjRZ1svuW6Lb2QB+ccTLP/h/qLawfnVHR1MoDXAtI+rnz9YWXrgQ549cY4kz59EHcLVu+c3jIXMnQ9IPXZXh/d/4DfBHs5B4S+7+z8e7OkZ/Lh/N9AMjs0uzS7F78ffylZlq8i3siK+AT5Q7GLaxzbCCyMHPvJzv/sTRZ0/xQY/OlBYt3vBmOYOpsDjLWA6xjYsGEI94MP/SFHnTrLBDw9EqocW1HS0M67wHqAdnD54fGX/cZTRWYs7s7hwG1iLC2Dtd++BXUQS7BTmXXqHyFwaENLgEDEADo34WYpxRiEsgbDP6Jw/DDQohpMt+6OAoWgUEgvnGIiyQJ+fSCK/Sz7pBKALf8mWnb9k8Obp5pbizYcPE198KzjN3mS8tWtxzWMpo1E4/bt/JCZf+r1fjj85p9M67xYy0Lx7yaXsjAdYsvnIZoLYfOT49xeqJy1tHV+aj79p2xWLJ2L4Z9lXwIWLTycNMmbSZkeD5yVsOBd8zpfPiOVjxVgKcsMl2EpsC/afP0QiQDMpkMtOCCXdT1dGnwMql0Y7CVmFwTySdW44FamBRwYZhYywpJRtDbIO0aFEvDrnxDf8iciR4XwkUey9TDuMiCXGuPOiRSJyrGSAF7mvyMkIUYgjiw6XtHXRqEOMXUxZSXNSAzHRU+7xlN8eqgqGHM7Qc8GqUMjpCD0fgmXVcAHUE4WPX1j9wZYJpgW3r3RWlzvdSXgscTvL7aWaZbff26x3zkiccnYd2Lp0jkZoSs9O186txW9qeXB225ZkSeba+FSfPhqXtUwC5oaqCuF8RlZZmLtBEh6R8mmLV0xPxK4f4+anthwqsRiK6xbXV3KsGTcSSptFN+W7Dd68yildKVKtgeQS0A0Grd7i5DTZmYpIpCLy/cTlzsJC53JnUZHz757h7+45PP/ZEyu7J7/w0V7h/XmpMvHPZe0F7EstFPuXySvWbt/xWVMJfqCso6Ms2tEhnJj55OKmyqG+BYtYqjxmMza+uXyp8FV9etAGlhempesbSho7AeuaSYcPLS9fkNq469aJMYeVMFLacMC4dJ0snSJpUq9lAWVRQ/n8J2dp55U2vBXzi14CMT7fFB1xoDXnNDBIZf5o3Bv3mrymqCk6as/tAUrY8Yn6ls45mzfPmV61YPEDe06c2PPEe2BqX98S+AcMV6kQeH++a13r1Pvevq9y3lzkX/Hr/iVixxVXawdINvhz/JIXEewQtUImR+u9+nAugSBCuJFWzMTNBUimFFb6/ONjhdOTHj+6p7Z14OWB1tp/fnjOHObNWFu3apPRFpBhl14tYWKVJcLzZLd1WWNmYCDTuMzaWKTFQwY8EMD+Gz+Sl0MAAHjaY2BkYGBgYexkMQkWiee3+crAzc4AApejovVg9P///xk4GdlAXA4GJgagDgAC/QlkAAB42mNgZGBgY/jPwMDAyfAfCDgZGYAiyIBpNgB68AW0AHjajVZLaxRBEO55dPeMcZPFEFGDsEpComQvvtCLzCEevYg5GBBFxIsogidzavwZ/g/Boz9KxNv69UzVTHXZYQ18VE91dfVXr95UwXwy+CtPjCl+DvAmjwpwxSRLyCIAZoCJ5+9Cngwy7snzxa9evnTxvNiL6wgbdSHdA75A/5FtHJ8xgz101xx94+wdtskhnqsH3120q+h7vHvyE3UXLPMUNrW4368DcanNJGW8PtWdWcld7LvSFODyDTg9L7YMOvJzP8JP+pkNY+7OZG5smve5VbUgu9MeQcQx5LKLNo3KN+dB3G+qIPIw1WSMW0rmaqf9I+TklRO1sSG5L8ZdSs7nIpgdituq2s9Jfoa+IJva/RvbVsI7mF3PeSe05LOmWpbBdCXljXW14or1YTJ3YeCge8aL+EXtOpkTO81V56f4Ro7wtQRmqMHTCHBbAuM331HTvLi0fzune1r1i5hN3uto/mb4XtLZEhxLzgnJ1zFPwBuctxGwLxxxgf2M5xPrCnIvV2/Ky0WefdYVIcn3A9bj3ipi3XyJ2t2rvkJWprY8R8Y8FD12MwL6Ho4h3jNgN/ag6uENHQfde+yGt7iKoHzyPLPdeBZcjkiO75AnHdVh4cNqJd9U2O5kZmWc1WjTqPeYZ78d7D843dNky++D/21u6Xkinvw293G18swk582kX3A92v9/GyMOmDPxXwDb4o5j4vMI60vCTnJ+jP0rLvfmpbgKvMX+C+J9m/y0kActcdeA3WaEDXn/jZKcX1GHfg2OG42Kv1HrRq+pvvS97YRP6vGS+0q8t2WcUdg72iux7ufCqvxZ4atRHHRPNH/M85a+c3ni3m5UD/C+X9MbXvEYe+B7sjf2I+5715/9Mfkf409rchl2m5DXc31B7/h+k9c/U/yetGmv6tj2cnGR7xv4fg+/h6Sv9P8wjvs99P1Y8YyT/9Hersy+o98jm74PW7JHXPqbvx/Xub+/0mt80AB42r2We1iPdxjG7+/LCCEUIYS2tV1YCKGtEMppEVtTCCFkbLLZhJwmm0OrWGjmkDFnFsu5UVtOQ3JuZEJoMSsLv9o+9o+/98+6rvt63/f7nO7nfp7f90r696/F/whvsFoybmCjZM0FeVKFUKkipopTpUr+UmU+7OKkKsmgWKrKebU+oFSyJ656rFTjpFSTbwe+a5GvVrpUm5g6gcAmOaZITq4gVaobLNXzlJyJc34o1U+UGkSCNKkh9Vw4b0RcYzg2TpKaUMt1h9TUEWRIzQZKzf0kN3xehucr4ZI7HN0PSK9FSa+7g1xa9JBaEtMSXq3CAM83YgA2D+p7kKs1fNqQuy29e5LXk+92vgBd2l2S2vPePhoQ0yECZEle8PIij1eO1BHeHXl2gnNne4B+3vT9JngLHX3g5YPNh9q+xPuSpwu8u5C7Kzp2cwbU7gZ3P3J1x787th5898SvJ9oFkDdgi9QL3Xqjc198+hLTD136wbMfM3n7jBQIp0D49aeP/ug/AJ4DFkpB+AWh7UDsg8gZ7ADIOxidQuAYwsxCyT0ErYbQ/1C0HYauw+AQRvwIZjKSmHDmOgouoyYB5jY6XxpDzjHUHAv3sfQ+jlmMp+54OEXCbQK6v0/9idgnUecDfCeTezK7FMUMouhnCrpMo59o8keTYzrn0/GbQc8z4R3D2Sx2dRZzmkOeuV4APecR+5kdQOv51I2F7wI4fUH8wkJpEf6LsS0hJo6e4rB9iebx7EU8Z/Hwiecsgb1MoH4CMYlokkiupWixlJ1dRu9f0WMSO7CcXVgB1xXMcCW1ktmfr8m3Cts3LgDNV2Nfww6uRee19LAOfdfBM4UdWE+ejei7GX22kGsrmm7lexuabqPWdnrczi7tgNtOZrwTjXai8y647+J3sAt+31MrlZ1J5TezG712k3cPufagxw/sTRq804jbi/8+OO17+AL74XGAng/S3yH6PEy+9ALpCHocQauj8MugVgZ6Z6JhJn3+hP5Z7MYxdD7GLhxjrsfp6wT5T1DzFNxPMadf0Pk0cz2N7Qy9nCXPWeafjbbZPM/B9RznOfSVgzbnsZ+n9wvod5G4i+h/iV25BMfLnF2m9hV0uMJeX4XfVWrkwiMXbr/iew0+1+jzOrbrzCEP3W5w/ht63GQ/brLf+XC8hf9tdLmDXwG1Czi/ixb3wH1QiAa/o0ERfT3A9gjNiumpmNgS9rYE+2P4PMZeiial1HwC36fsxTN8bOS0MQsbOcqYXxk6lLFT5ZyV8/z7ocxLC2UqnZSpfEbGbqNMFW9QIFN1EsBeLVfGPlqmekVwSaZmuEwtO8BZbfzrOIJ0GcdIGSd8nGJk6noCfOslyziHydQfKNMgWKahh4zLDplGLoBnY2Ia58k0weZKXFP8uT9Ns3yZ5v4Amxs1XvWTcc+Q4e403JumFc/WgQDebdJk2sKnbayMJzna9ZFp3wLYZDqQp6MroJ9OWTKdI2S8QwG1fcjjUyzTJUmmK+gGuONMd2eZHqCnr4w/zwB4BKBDr1SZ3ltk+kwFfPfDFgj68z0ADkH0FFQqM8hN5h0vgO+71Ai2B/i8h46D0SIEfUPwD6XPIfAYii2MusPhOTxOZgR9joR/OL2MovZo/MfgF0F/Y8k3jv4mYJvI+YfknEL+j4j5mDlOnSvzCX6fMqNpPKPhF71aZgZazcA+o1BmJhxi0GEWvrPRcTZ9zzkgMzdFZh7v87HFkn8BHD5/jkSZRfBYhH0xeZZQL85BJp58CTxZJZNI30vRchnzS6Kf5fBZiV8y+5CcI8M9ZFaxJ6uYB/eQWcO81tLLuiiZFHRazy59S40N8N1A3g0FL7ARnb5D003ou4kZbmYftsBlK99b6WEb9bmfDPeT2c73bua0h/65b0wauqaxB3vJyX1j9sFvP/772e0D7NTB5+DsEHUPM+90+klHix+JOYK2R9EjA70zmU0m3H+mnyxwDH2OYztBz6eI5X4xp9HtDNqepW42MdnYcvA7T48X4HEBjS6yN5fhfwUdr4JcdMhlJtwZ5hr956HDDeJuolU+tlvs0W043qa/O3C4w2+0gDp3qXmX93v8Pu6j43165r4whehVRH9F9FREDw/g/JAcfxDziBp/YitGyxJylsDzMbwfw+svdqWUsyd8P0WrZ/g8g4uNp43aZfRTTv3yAlnqI8t4yrL8ZFWIkVWxUFalCFl2nFfhnf+7rOp2smp4yKrJmYNNVu2Bsurg7wicOKvrL6teoCxnb1n1V8tqwLvLSVmNIkH+f8E/LsKFuQAAeNpjYGRgYFrKJMmgzgACTEDMCIQMDA5gPgMAGf4BLwB42o1RuU4CURQ9M6CCJiQmhhiriTEWFmwag8QGF2wUCRK1MmEZwLAKqKGxsLD2G4zxM6wVOzt/wi+w8Lw7Dx0MhZnMu+du5577HoBZvMMDw+sHcMbfwQaC9BxsIoCexh4s4lZjL5bxqPEEljDQeJK9nxpP4cHwauzDvPGksR9zxrPGM1gxhhoC2DS+NH5B0Ixr/IqImdZ4AJ95o/Ebps07B394sGDeYxsttNFHB+eooErlFnaQxxVsoj2iJkrMW4ghgijWESJOos7PcnV1xbNpbVrVXWJliuxNZpO4llwLDdos/wouyZBnbQqHSCOHfVZtIUEvx9guTpEhzoo3jsX6w3Msk7tUpKotrHG+Urvq0j6eKUMGmxxdYVVblIXLYmVLzqpkxt2V6ikSDaeWaTuunrKeqCIdzigx2hC9NcbyjPaEr8A9flmatMorikrnHjvCMqp83EtVhbPNmwzzG87Pj/SFZNL/K8O8IUdNUzYO44RnwbVdlJURvlWVe1g4IEtfojF9Jpjd4BlF3PUeNbLYVNCSO1BcqR/GI1yQ65wZ9SL1b6FTivkAeNp9VwWU20gSdVWZPTOBZWamMbQ8Xh4HlpnRK9ttW7FsKYKBLDPzHjPsMTMz8+0xM8Me891elSQnk3fvXd6kq7ul39Vd/3eVnMLU//2Hj3MDKUwRYOqB1L2pe1L3px5KPQwEachAFnKQhwIUoQRTMA0zsCp1X+qR1IOwGtbAWtgBdoSdYGfYBXaF3WB32AP2hL1gb9gH9oX9YH84AA6Eg+BgOAQOhcPgcDgCjoSj4Gg4BmahDBWoQg0UGFCHOWjAsXAcHA8nwIlwEpwM89CEdbAeNsBGOAVOhdPgdDgDzoSz4Gw4B86F8+B8uAAuhIvgYrgELoXL4HK4Aq6Eq+BqaME1YEIbOtAFDT3owwAs2ARDsGEEY3DAhc2pmdSTqWnwwIcAQliARViCZdgC18J1cD3cADfCTXAz3AK3wm1wO9wBd8JdcDfcA/fCfXA/PAAPwkPwMDwCj8Jj8DR4OjwDngnPgmfDc+C58Dx4PrwAXggvghfDS+Cl8Di8DF4Or4BXwqvg1fAaeC28Dl4Pb4A3wpvgzfAWeCu8Dd4O74B3wrvg3fAeeC+8D94PH4APwofgw/AR+Ch8DD4On4BPwqfg0/AZ+Cx8Dj4PX4AvwhPwJfgyfAW+Cl+Dr8M34JvwLfg2fAe+C9+D78MP4IfwI/gx/AR+Cj+Dn8Mv4JfwK/g1/AZ+C0/C7+D38Af4I/wJ/gx/gb/C3+Dv8A/4J/wL/g3/gacwhYCIhGnMYBZzmMcCFrGEUziNM7gKV+MaXIs74I64E+6Mu6T2x11xN9wd98A9cS/cG/fBfXE/3B8PwAPxIDwYD8FD8TA8HI/AI/EoPBqPwVksYwWrWEOFBtZxDht4LB6Hx+MJeCKehCfjPDZxHa7HDbgRT8FT8TQ8Hc/AM/EsPBvPwXPxPDwfL8AL8SK8GC/BS/EyvByvwCvxKrwaW3gNmthOPYEd7KLGHvZxgBZuwiHaOMIxOujiZvTQxwBDXMBFXMJl3ILX4nV4Pd6AN+JNeDPegrfibXg73oF34l14N96D9+J9eD8+gA/iQ/gwPoKP4mP4NHw6PgOfic/CZ+Nz8Ln4PHw+vgBfiC/CF+NL8KX4OL4MX46vwFfiq/DV+Bp8Lb4OX49vwDfim/DN+BZ8K74N347vwHfiu/Dd+B58L74P348fwA/ih/DD+BH8KH4MP46fwE/ip/DT+Bn8LH4OP49fwC/iE/gl/DJ+Bb+KX8Ov4zfwm/gt/DZ+B7+L38Pv4w/wh/gj/DH+BH+KP8Of4y/wl/gr/DX+Bn+LT+Lv8Pf4B/wj/gn/jH/Bv+Lf8O/4D/wn/gv/jf/Bp4hTAyERpSlDWcpRngpUpBJN0TTN0CpaTWtoLe1AO9JOtDPtQrvSbrQ77UF70l60N+1D+9J+tD8dQAfSQXQwHUKH0mF0OB1BR9JRdDQdQ7NUpgpVqUaKDKrTHDXoWDqOjqcT6EQ6iU6meWrSOlpPG2gjnUKn0ml0Op1BZ9JZdDadQ+fSeXQ+XUAX0kV0MV1Cl9JldDldQVfSVXQ1tegaMqlNHeqSph71aUAWbaIh2TSiMTnk0mbyyKeAQlqgRVqiZdpC19J1dD3dQDfSTXQz3UK30m10O91Bd9JddDfdQ/fSfXQ/PUAP0kP0MD1Cj6Yey4Vja3Z2flZsZXZ2YsuJrSS2mthaYlVijcTWEzuX2EZi52Nb2RhbFVu1cV2mb5u+nxmFvtXJ+tr0OoO8Hi9o23F1ZsDjIO0HpleUpqVHbrCcDn3tpXuWPcoHg5Zten2NwSAnfcsP0BlmPT1yFnRui+OMWtY4H1knDMjp9bK+1R+bNnWcfibwTH+QHjgjnefVdMu0g3RgjXTac8zuVNdZHNvcken8ZJANXTEZa9x2lkqubS63OpbXsTX7dLUZ5Dzd87Q/yMtWogVtpzNM92yzX+TDdN2BM9Z+ccGxw5Fu8X5KSVccFJJ+6GY3ex2nq3NtM7IUmP00//fTbccZ5qUZmd4w43rWOMh2zJH2zHTPGQf83O5mrcC0rU4p0EtBa6Ct/iAoRv1FqxsMivysP27ZuhdMxd2OHgfaK8UDT16fjvubQj+westpOUvJGnf5vRiX9KN3Z3pmR0vUWgtWVzs51+oEoaezrh53LLs4Mt2W7FV7WbMrC3KEeZ+6awUZf2B6OtMZaI6QEDbtB9pttc3OcNH0utM9k0M4GeUnnbQEPeOaLAIWhuPmeo4n81PR65NBtFIyyOhNuhNMsZ8Fz4lPPj0ZREcouHbot0QYxZE1TrqlWERRP+cMIzu9OdQcEsbJqGCNe04M8zue1mN/4ATTCSxWRYGBca/YNseTrul5zmK0j1LcjXaRj/uhmzyPFBGFSHTE2/GtLbrVC217Kun7I9O2V+uljm2OzK3bSvetHstOmz2+I57O62UWGrNRkE7Hdnw9xVEZW+N+9HqG4znW+Y5p63HX9LKeOe46o1zHGY2Y4+zI7I91UJzEK3S3xlH2x3IPFrUOpvnoritLdvjCTvVYhdqLnZWSgWxhVbLxBe0FFntck4wHjmdtYfmadoEV3+oMZJFg0QpYl3HgRWQi+2g0FSu+xc49h4Z6Oc232c8nW/ang0E4avu8VwncqmQk25VxIUokA9PulaLsEueUnKzLKWLatsZDFmccypwb+gM+1jTfHu1x2mjJ4yiFWOMsO3cHy6W+xR7asQ7i7CBuMjbrgIMr970USTx2NDO5vPGwGL0QO0sOnJ+cNRuvnA3HkkNKLDG+NBLgLnm+T4MuXwpWAwdvnG5r2y51JKw9DmygiwOmMVF31BW15aJe6MYzEpA1sSJb2xS5druZaIFV202F7vYgWYZzuNPW2UWP7/wgE5j+0M9yRuXDFNqepXsd09dFUW58TzJ9zwndtMQywxoJu9m2NjlDUCcMmEqXo2K6kX4sN+2bC7oo8Wm1WahDVpzjsZ4wtNGxOWN41lAHA16wPyiEnJc8XlbzHtq2zrB4rQ6n+bAzLDCNvB++vjNbe1HYV/cdp8+n2ZoDSismMsyhXi5yzHUQnTQfd/mSxp3oEsfdKFZ8bziFj/2073gsNW7iexL1+PJMKltUVCZaS/O+HRZMn/Xf5ZLUdpjjUiJneXNqIu2oonCOD1ivgebcmmdte8y9yRmRc17Rlk20WBbtPOcF5rmvZ6IQtyYVbCoexkrNSSltjbolxgYDx+fg67wfWoEwlhdRicdshwuV1lxhHM7KUimjciJHaIeWzSfo5xnsSt0pmCP2bo47OjvS3aEVlHqyJfaySfPWNdeBQZymerM9vabrhG2R0lgiHulvu5lYf9tNsf62G8u5itvwpRXA/ARR3PZqrqv9IZeNrG26YiKhBFMjpy3nim7jVKLvSG/FzaETJEvH3ZhnPu14zIeJ381w9beXi0kq4MCsXpkCozS0Ig3KuKiXXLmFMbtMoBu/l/FHvJFMj6/WmEZ6kOtzrnPNbp7TXKSLvHxLyJszUSdKLazmbp5jzNXLtNPyxVCINsSv2au25rskAXEyiYtFdH/THc5iBYFIuRxKsmFVpluVeqO0orKU/JBvJF9fy2VZh+24x6/NVafccMsWiZ2lO5oLqCwoYZzZ1m1FH14DS9vdmUmhiXezRkpUi9XEGgotf8AR9TjZaSk8S50uJ6ik2viTj5a1280kCWrllCSoleMoQQ2Cka3SHd+vZlmbnDKLcVZNRMyZiavjDqx3y/Utf0VBWrN1blK00q3qbLUQffrJ+lme5P3ObPtyiMp1nPKjybyt+dKLDONOpNj4efQZEaX16Eq0quVKMS75UUXga8/XWipbLJBtSmHpytt10qFH/bZLod8la+zRJneZvLBNQ2+R2kFHPpN1YeudXR3lobYIwx2Ybb6RrWqlsXbrbMDptB0G2t/5f6fkWNOT6SgHr9luFOWmVrVak0ZNLXM1DdvJQZJBeolpLixNPj22viPBzHVZLPxRzSmdv/QmyYu/sXjc98xRtsfftEOPzC6njnK9PNO2gnYooU9o4Exoe6XYRFOrbIcdbatS0yvGobvyqehq9YpxfMUX+TPXWfRzfE09x+pm+GKES7xNqy21xR8uu1zUnNDzN4fMGH8OsFScbI/Tsq3T0kgBDyyX/FCoNYyc/LixFjS1wz4uDDOL2mo7/MNhzH/8Qr0yE529NTm8zNV2irc0qbl2XHPkkTHTdYIVD2RubmqBP8X5qzTaE8/MzU7HlS2aaDkyVZGmKo1wNaekMaSpSzMnTfSzbWN5fpZjbZZ5piGgRlWGAmoIqCGghoAaAmo00q3abIRoS68iTVWaWrxasywDQ5q6NHPSCKg8K408LQuoLKByTRoljSDKgigLopzsbd1sYgVXEVxFcBXBVQRXEVxFcBXBVcRTVTxVBVEVRFUQ1WR765MF15cTG70h0Gricr1KrJFYWbwma9TEa0281sRrLXog0FoC3SCOlThWsqwSkBKQEpASkBKQEpCSrRqCMARhCMIQhJFsdWP0TEBGnePdi54JqC4P6gKqC6guD+ripi5u6oa83JGeuKkLYk4Qc4IQXdREFzXRRU10URNd1EQXNdFFbU4QDUE0BCGiqDUE0aile5WIRhYF96IHghBRKBYFN2VpKtJUpalJo6QxpKlLMydNI7OgOW1yVyShZC0lklAiCSWSUCIJJZJQIglVFicVcVIRhIhBiRiUiEGJGJSIQYkYlIhBiRiUiEGJGJSIQYkYlKQvVRVEVRBVQYgGVFUQNUHUBFEThFCvhHol1CuhXgn1SqhXNUEoQQjvSnhXwrsS3pXwroR3Jbwr4V0J70p4V8K7Et6V8K4MQRiCENKVIQhDEEx6r8IIbgTBpHNPEEK6EtJVXRB1QQjpSkhXQroS0pWQroR0JaQrIV0J6UpIV0K6EtKVkK6EdCWkKyFdNQQhmUBJJlCSCRST3qvUdSTTytxsYhlnCPWGUG8k+aAypxJryGRdmjlp2J8hWjKEf0P4N4R/Q/g3hH9D+DeEf0P4N4R/Q/g3hH9D+DeEf0P4N4R/Q/g3hH9D+Dcq8bWszCc7nC8ntpLYamKTrc4nW503EltP7FxiJ+vNJ7aZ2HWJXZ/YDbFtJn6bid9m4reZ+G0mfpuJ32bit5n4bSZ+m4nfZuK3mfhtJn6bid/mhv8CmgquagAAAVc0qq8AAA=="

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f108c981ed9611d5cc44f688b9ce80a4.svg";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,d09GRgABAAAAAPV8ABIAAAABo8QAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABlAAAABwAAAAcXdIoWkdERUYAAAGwAAAAHgAAACAD3gADR1BPUwAAAdAAAAAgAAAAIGyRdI9HU1VCAAAB8AAAAb8AAAKKSI+4209TLzIAAAOwAAAAXgAAAGCgzZtdY21hcAAABBAAAAMiAAAEfs0qHI1jdnQgAAAHNAAAADQAAAA0BpEJhmZwZ20AAAdoAAABsQAAAmUPtC+nZ2FzcAAACRwAAAAIAAAACAAAABBnbHlmAAAJJAAAzNUAAV8g7tJpMGhlYWQAANX8AAAAMwAAADb6NK1saGhlYQAA1jAAAAAhAAAAJA2ECS5obXR4AADWVAAABvcAAA68SMFN32xvY2EAAN1MAAAHOgAAB2SpvQNAbWF4cAAA5IgAAAAgAAAAIATnArRuYW1lAADkqAAAAPkAAAHCJU5AnHBvc3QAAOWkAAAPFgAAH3APmSRLcHJlcAAA9LwAAADAAAABO+rQtYYAAAABAAAAAMmJbzEAAAAAyUIU2wAAAADLBqRNeNpjYGRgYOADYgkGEGBiAPKZNwBJFjCPAQAL8QDlAAAAAQAAAAoAHAAeAAFsYXRuAAgABAAAAAD//wAAAAAAAHjaXVJNaxNRFD1vTpM0g4tAkqqxFHFRsijFKmTZlRRSkkwRKV0FgtCiTBNlJkaEfmptq7b18wfEfqlV202LS3+DC7dSiiAiIhKki0J638uAKMOcc9+95368OwMFwMYVfIZyS34Z7YjByju5s0hfdvKCQLOJqKgUiDaEEEZEVFHjt43f+i9iu9fGSuh3y9VxXHIrV10MVrQ9dEPjiFdyfRQ973wfRgUvoCx4Eb6vo3dMxVa/iMF2Qcv00Kc2c9LWX9avxpZPz2GjA13oRi8y6McAChhGMdAOBTwa8IeAPwb8LeAfATcCPmyxSpgZlEpJrxhCfMt3fM9t7kg8hEF8wT4O8FWivUhwgpOc4jRnOMu7vMc53uc8F7jIB3zIR3zKZ3zOF5KbQA+WsYLHeILv0v0nfuE3Guq6qql5tav2rLI1YTWsP6INc0XqK8TRae6cgs2XXOM6N7jJV3zNN9ziqtlaXB4gKUrFOuuyW52/ZPaV0PbRTV1L8rfMPcNHno6J0tRFXKyk7PMkTuG0eM5IpX/0zU/6H1AF5QhnzBcL4YTU7sQ5pHlbZsjCYc1wjrck22FVMEdfMGsmyR4DxINgFwB42mNgZpnMqMPAysDAOovVmIGBUR5CM19kSGN8w8HExM3MxszKwsTE8oCB6b0Dg0I0AwODBhAzGDoGOwMphf9/2eT/iTC0cPQyRSgwMM4HybHYs24DyTEwAwC7Ow9ZAAB42s3SXVBWRRzH8e+e/wPiSz0ogiZ13HNIrDQ1KUhEQCQUU8p84QEUtDDzNVSydEq0lMwUzUqbygbC0tIAx96zZvKipi6aqQvHxsE853DdNONVL885beA4TV10287s/vd/sTufnf0BwsC8EWVWrGbTqf4+ZiVMPcQOUhnBdtWiDqkO1aN+UZGVbRVYZ62vrW+sXuuKKBEZLHHJkb2yTzrkO/lBzsdaUzJsZZfYu+1fx87XQ3WmtrWrc/UUnacLdZEu1w26SW/VLfqYPq5POSlOhpPlaMd1cp1JTr1rualu3B3hjnFtd4I7x13urhz37WV+j4VRlIwiY9O0G1O76jam36zR/aavjOmCMXHNtMuY2qRTvjcmYnts7GJ7h91uTOh0PUprY5qsp+pp10zNxtRpTCf/Yaq7ahr+N1Njvwlj+iOKoiA6F/VEndHhqDqqivKj7PBI2BbuD1vCNWF9uCxMhAvD0uTl5E/JS8ne5MXkhWR3sqvvXF9rX0XfxODHYHyQE7iBE9hBVpAZpAfxIM3/2b/kX/TP+2f8036Xv8Sv9Gf7xf4Mv9DP8wd5jd4Kr8ZLeAu8Kq/My/Xi3rDeEzmb05pj22T7wJ/+z0aqNeSvoviXTmFd3Vn/ccfASSFGiknnINIYzBCGMozruJ446Qw3mc1gJJlkMYrR3MAYsk2qb8JmrEmOg0sONzOOXMZzC7dyGxOYyO1MYjJTuIOp5HEnd5FPAXczjUKmU8QMiimhlJmUMYty7qGC2cyhkrncyzzmU8V93M8CHmAhi1jMEqpJUEMtdSxlGfU0sJwVxt/KszzH87zIK7xBJ29yjLd5i+O8w0ne5RTv0U0XPZzmDB/wPh/yMR9xls/4nC9kJptoZCWrZRZP0EETa6WBLayRR9nDq7KOzdIkG1nF4/KwrJZH1FFZzzqeVK2c4FN28hAbZK0qkw2yivU8JeU8yNPs5ogaqTIlXwqkWEqkUKbziWziS1Uo86RWKmWuPCZbpIytUiSlUsEu9vEM+9nLAQ7yAm28zGHzwpd4naO8xhW1SNWxUVWrhKphm1qqatXiPwFf+f3NAAD+FAAABD8FtgBaADkATgBUAFYAXgBjAHEAwQBmADMAQQBJAFQAYgBmAGsAbwCBAFgAUgBMeNpdUbtOW0EQ3Q0PA4HE2CA52hSzmZAC74U2SCCuLsLIdmM5QtqNXORiXMAHUCBRg/ZrBmgoU6RNg5ALJD6BT4iUmTWJojQ7O7NzzpkzS8qRqndpveepcxZI4W6DZpt+J6TaRYAH0vWNRkbawSMtNjN65bp9v4/BZjTlThpAec9bykNG006gFu25fzI/g+E+/8s8B4OWZpqeWmchPYTAfDNuafA1o1l3/UFfsTpcDQaGFNNU3PXHVMr/luZcbRm2NjOad3AhIj+YBmhqrY1A0586pHo+jmIJcvlsrA0mpqw/yURwYTJd1VQtM752cJ/sLDrYpEpz4AEOsFWegofjowmF9C2JMktDhIPYKjFCxCSHQk45d7I/KVA+koQxb5LSzrhhrYFx5DUwqM3THL7MZlPbW4cwfhFH8N0vxpIOPrKhNkaE2I5YCmACkZBRVb6hxnMviwG51P4zECVgefrtXycCrTs2ES9lbZ1jjBWCnt823/llxd2qXOdFobt3VTVU6ZTmQy9n3+MRT4+F4aCx4M3nfX+jQO0NixsNmgPBkN6N3v/RWnXEVd4LH9lvNbOxFgAAAAABAAH//wAPeNqsvQl8E9X2ADx3ZjJZmqQzWZrubZouYIFCQqkFSisiIkuBWkqpUKFAQVYB2URFRURAREBwAVERURExk1ZARAVxV+T5/IMPl4e414e7TxGa4Tvn3pk0xfre+37fB780k5ubO/eee+7ZzxmO5w5xnGgz7eEEzsx15yIc4QpV0dYSIQJcmG0tJGwpCnPHVdHREhZl1UQKVcHRolpJIde9R0jxK3l+xX9IuCKaxS+OrjDtOTt4qvgVx3Pbz58mA2FcM5fA1XIRCcfl7S0RC4xLwnYcs1lM4lLFQv2tySZylkI1IbElnFCk2hJbmjITLM5C1eptUR1wV1uC4lIlvrSUUy284grbSrv3KOkZCno9gRx3SAhsH1FVNSJpYUZZZUNDg+mtc4c5+Mdzy4UdfKW+vt6wPrh9WAw1C3bOIhaGpSBdn3Bc5eG+vKya4U5SIl2faobbqESEO3bvgXcg8Fq+1F9GOsMf057oj7wc/RHvUQIw/BXukcZlkZFcJAnWGvGmpIZCoYgZ7hexJNjhupkjSWZHYROvpGfk+kIqJ7U0eXzJabm+YLNJpF8JcmYWfmWCrySrzQFfkXB2UTj1uJqitIRT2PwsSkvEbLEVNlWYRWth2CKrSdDqhVZvErZ63dDqldUEaLUrLaqfFIZ7pe7v98kv5zlvoW1/v2O//B0vwqlyE59qdsN96V8J/8JNmqwpFrhIkptsSQluHKrJ4bVDB5n+VehfD/7FPj7aB36VTH8FY6YZ46Qb42Rgn6ZMo2cWtgsVMi/gImUFoZCekZnV7YJ/4YpUBH2x3+2HV0igL6+fvgJufJXAVyWkcKj2ASmpuWoMmVlbU0sytPeHkiLtYE1drXZfTW1NI5leqW0kh4eTu0aQ17Te+BqhzR2ulZHD+IJ2xBUBcHalcFJycdlcAdeNu5MLZxaF00KqKLaEOwUjmSICNzMDgOspCueF1ERotwcjiR5sT3RYAa+LisLW46rf0xL2y2oGKYyI9txgMKimw+Y4PZ3gMpwuq4WwMcmA1t3xvRCQzKUgWouZgNZcadijPEusruTcbrm+0nCiK6wgphdnkpDSjS/u2aukOORN8pnzC5RM4vVIZm+guBtxe5J8ipOQfqS4Z37B9iHvjVl3Z8ULD4989QH/GvXYw689M3Lsicvm3rRwMbnk+jU3rdw/JTdIWrvULqq54UnPwRet5XX9bFpq/y03LX8i6fQ3fGfhxppZ+eRVeVHrZMcNDaNmdwL4mLg551sk0fQ2nGg4sVw+0IsHuIgPsL0px5cLR/UisSWSjAgvIPHwiC3N1kSf4IAzDJeZ3ehlpggkpQclKXYXwE9WFTxycCnJahpcFsBlgax2gUu/q0UNwrtiV1xNVsGXCgBRuxTAh+TM3BT4wKnWi+BTmr+gC37lAQBG7IpUWgoQc/fsFQomAYACOfklnqRQUOmZH8iR3CRkJX/6SoZv5tx95+r7Nq1Zfm9D3fhDE+vH120TCse3HiM/bli98r571tyxCdsPja8T+ZPf/vSPz/7108f7nyfz9z333LmBSPbInlPf/Hjis3/98uFzz5G5ZM5ehlNLzp82rTAdAZwqBDpxIxdJQeqQieQwF8BlQ0gVI0wupjDxOyjq4DHvAljURaYAcMClQ1Y9eMwBJqXwHuyiuJ61CZm5nWS6dAfAQfGlFiDOeJVwCsCmOFdx7TE7AG6diqCZgqSkoBtgiL58M6BLSQjeAgVO3oBFrxLi5BGdKCoBXJZseHNI/4qXHtn87J17yStlNdnjy9cT24pDY+9+auZ7P0zd/9jNx6ZoGXcsLlk/4tqHbrhh2txlZN6ql2dUXX7H4LVPbFt7zTPTtZJBO6/7rVn79dW6K7u8+8LabaOnkC8HTV7A/3347dNH3XN1/fzrAFYEaTURKa3OYpRaJ9MkLBo0GhmQTo6X61SYo7+t0g6QH+G3di6Zo/hHwg4KUbOnRXWyH8kuWC2vyCSQz1dtXj/nnq2k++wND/A9iJW8u3uPFjrPaRnajJ3kNTZmGYz5kTEmZ4xpA2bYNmYoyaXIvDnAwd+yORse2Lx+Num+1bTnGa2H9gf87/0EuYd8Tgg5wsacym8TWiUP5+Q4d4lJCAl5PpPbnEAK3FPdZF3B+jyy0avN//2Gl5pv/FmctGwq2ahNn7qsQNt1OVmiLb+cVMMYs7mzYkDcDeewigtzRWFzSCXmlrApCOwbaRFnsxZGCIeXRLAydms7HuaDqhW4iBiMWG34ndUM3WxWvLRx1kLksozcKsDXvX4loMwm4SoS0Sqr+J3sXRtBwmwdA7QzJMR9z0lcBs6hmbdzVtwpc1GYBwAltagWNhzA3MebBwzzz7cPmQg/cn/u1X7/Bx1jLM/xJXwVQDYHx8BF4Au3W+UI7H4SjmlsebHfO5Z8xHNVVfjbbSBfDIBfmbmiOOnCuNCllvYShi60GELDNhQYUFigc0kBRr6N4l42k4KoBEQxD8bhkzhzbCYhEiIpfPY10ZN47oH/zzt/WsyCM57A+bj+XMSKkwDmwMigFw93MiN4HkrwXEjwgPynwLsLSJtqFZD8exOB/EulFE9DQcSqQA4ffz3v69Nf//yv77/8fkbk2ReefvqFF3byJ8lN5FptmbZWW6rdRW4kC7Rd2vNkBLmCDCAjtDCs43VY105Yl40r5iKisS4QtogFVpdQFBaPqwLQFDsKdiIKPGacDLHBZMw4GWA7AaVniZOYXidrahrsidnaR+Ia0vnsYLHzui2J6V8yfJgDMhDyhmSuUpcik6zA8xACVoRASlFYOq4qjpaIIiHGKcmAfJKClxIiXyqAVk3i4K6kNGxVmqQEu0KJVqiY9OMpJTIXMLrFm4nX751Dlm+/rd+ulXsf77X35EsfbTisrRSctWTTzubtdcu2L7/sgXea1mk/va4tFcfj/OphjziYXyfuWi5SQKVc2KFUnJ/b0tJsTyhIBe5kt8JUO8OJOq7mAiXOlcMZ2ccVVYaNk4vUDE9LRM7AKcsJMOWLcMpiAWPaCYpKcktLw3aXmu2Hd7cSSfJlUE5EeXewF6yhkBSzCyCr5oJ+RCfDXmTkoj+nvvq9sZ/88/OPtz6859jTd85svrbHqB+XvPXxU3eH92kt2tmT5RO7BJseXbdl/NP3XL+hbPCll1/50u479qdKSc33HTkFeFgIezDf9CLstYurZ3gY4XGFMqyQS7DyDpR9Vc7SQgVfNworIMGoFmC5QjBioaTAIsHGWKl4acWNQaZjscIiZUCLBLZBeBoBL0LeAOAGKABySUAyF/LHFre21kdX8IudFs8UMv9SUWp11Giryfwaso10O5J3L+zDWtgHGfAxnbuBi6Qa+0DxRLG2NHtsqU7YB48F9iGD7oMPtI1MJsGWv3x2DhVcnd2cYcdBE6DTH86w6yCnOlzdupEmh1Nx6XIjUX1mQOZEmQpWqWyPbEqE2H0X7AnilRslSkAuEbYB+ODaGU9cffCbz16+9a6+vfmD0a1dt9R+SxzaN7/NfKV8Sknh208/ur+ggH9wfLQ147PXTp0tRB1gGawrADQgGeSiBqYDqBmwMpGeADOQJqpQgSAkB5JEWKKMhK6A0oUUpAtBFO+zAdhuWHAneM9OUVzNokNOkqikE8gADs853HbGymVXbijo88L0OSGkYxIQCa7E07YwJ1m2mWS8WV95xZTfte8Ux9BXZh75+pd3/6mdnznxycbte5o3Nz4zlZ9NMsjyA77aNG2Ltqth0rfvfqpFyZXPzT6y6N2XnjhQt5Gd75mAW1mwbxLQ6ojJoCMqhwfGXESJvUoQO4RSRqtJgMwUItHt8/k6U834K85uMNWgPLQY4OQxHQU45XI9uKk6pNJBlC4CrQ8pRZDBxIH6TjgPj58E11KRmkeb1CwGo3AX/MoBwAqhsJRHxaGk9ByZQqsoHT5LDreQ0zkm+qDkEztzVHaOyTwoNDtBiM4kMbFn8Y7dj9w27aX5+z9fs/XgluixT043Pv/E9jce/HTfA13LF9756F1Prl/zFFm47LWBQ59ccM1DNS9uu3bXFcMP3P7sP96KrLrvkVU3bB51+S5+xcDpo3uX3zd90Z2rmT46G9ZvBzxJBUo0i4sk4OoVs84r8gE9kjMTUE5ONjNKBKBIg8WmyWoOHAJPkMozQHnUNAC26nACqclRmhMUb7JAF66Amhx2lIaTlbCzVM1Hidjs9egSMfCSJJdX5gHJC+gB4NwBJzGggCvvBp+k2X+8fvc/5t+rnTwytbZwcfbvJFm2X/HWrLc/b9y9bfIzU8Y9PnPrAeHUx0S+V/v4De1T7Yb9qTXORDKZ1Iyf8un/7W6u2zhs/jvzjtH1Uj4tdgU+rXChNk4dToTdRj7twiWGLUGdR8M5MLi1ux23Vug77hjl2yOqigI53ZB7CycbGoq7dcN7DQXxwrhXTy7+FpbjzXY2vimILFhIAopXhLdQ7QLA0ZbItPxeTFpxx242NKN/IgouXnZD7cwE0nkGCjDi+/ptUR4jNpDHDsHZ4IAueq3EO1tobn1TKOF3lpEPr9amaw+Op3tPPhEDwuvUFpFqSDwo7JjMVGLRBRR6euCFgwwVmsknVVXkPpR6/nQvKynGe5XAvZqJbTyZSDZereWX4b1Kz58WPMDvskCXnc5F8hHuOXYdz9KRvHYqCivHVVlpaUpVsp2FzbkMQLJMBRPQyNTO8C4rAJ6cfECzXEUV0uE9BXQsb0IpEtb0HEAvSc6CD2FBARILk9dPmJM3O/kMEgBlo5wYZ0oHbCCndNbG4Xv/nnvJ2IsrLsuqGjL5qkH9Hr9j+KoRO3BvTUu6Z7+6a0Dj6JFFvcY0THDmLdkyZnjZosqlmwIF5wJUYONBF+0j7TDtAqmmgruFi3SH9YVDRWpXICSw3wkhtRRAmxUM9ytSk6WWcH6RKuKiL6En6iJgeBfJqhfW1wsOVy96uNCuovaH95xeiqvCmiC6kvO7dg/1pceqawiOVY9StV8p6FQWLtHrzLkIVS04Zqkxciy6KA3OL2CHqhjPm0/w6hSGzw3kiLxX5vygY3mlQDZH4JvsNIKQmXOCrDn7ARnS9OzmMbNB6N02455tP7286p6kgSOnLNuqfXTgK+2RF0glCY176Y6339ce1a7nLbMWcudd8vC5G8OgwXDk/s8i2rMffqGdnjFu0uRDu98ipLPWPXPqNS3Pv0xyH3xdu+e09qL2SG7PiSPIOnLr2rtJHQmkHUFYwj/xiOkAYKWT68Kkt7AQogS+WbJwBMiRhJQZDpRM6bwFgGGHZfcASTgg+AW3X8gvkMz80Ev4inlvR3e/8xOf8HpKIC3bdODsAF6MtvLj+cR+s8ZXMp34KNxvHfCSRC4J8HOKLi/Kom51zAIq6Euit/XhbbPpnsmwUb4goic9tV6gicgATB5q4FLTZBSkLYiVSTKdXtingOACmJnlCptKqbEyO07cCuT5sxW5Mxw0xi39RwEsidrmjc88pv36m7aDgCypVWsvkv7vPv/+e9oJ0559+5c+mSylPnnvWx/WkcGka93K9etvwzN5C9D0fXDWkrhLuIiHSv/WliZXoscCtD0mA+BSfEwPAOE/GQFphcMV4cx2PD+iwoT/npSxm/MBPxTEFYYqtzxJyv5+/MnOD4e177RXyEXEu++BdSe0d7St/MmTpPq5EWNHaA9r72qvazuK6kLUoMUjnE15AGcLJ3MX61C2GlCWcT4KnY8VQGuVqQpggqm5cGoyinwG2OhMCkIAL64zOUpWk3oyU7tJW3XmZ36tdkh7W/vFtEdbrz2i3a2tqONXk96kDOEC9xe+h/sncJcbd7fqdxdB1jMx1DKhCGGPTQTVU6q6WkHGBp2V6am6csoUU/Y6KmRFL+fXR2fxz5n21Ec/qI+uqWc0Eu+LtgAr0IY2XY7e02Ki97TgPW0d3BPUZf2GCRfc8Kjgj17G3xOdgTe75+roPHYv2HtTZ8rPF3GRZEPzM3a82e1JRmHPjfdLMzbfsHoloTZETbaKG+6Yrpu6IqI1GTEiSVHNEiJ0YjLsRVKp6nEDjtu5UlSQQDkLi66/QBnFD0q8BPt2y14y6pMfXuz84jvaSe1p0p9c/NYabRif9n/a79oObS1/4iQZc6B2bK22WXtP26M1lfL8+OjkOrLCgKP4M92/cp0qmBlVCJtCzYKNQlJo270EgCQfDCfIKA0CTFWzoyW2b+gqQE0SANko1EyZ0gpKaXQhv/LsYP5otEds30gx1cH9f9bBqdsBX6bYiEcbqQKOvz0/SFtLf5vAdQX5FOdoLVJ5fXKg4xpzgTYAZkJp2MT4lRmIcwroMrI/p2Bf5eU/N2o7x/bRPMRiOnh2sLY2zYDDDmoH0j0kYUsMDoaZyU4XT61CVA5WBVtpKZtmCZocA8QM893Gl90afZKfcmP06GFYv2UbXxPd1NosiLuiT7ThLp4Zk0GJEcI6HCQDDhGBYqtgAqwxtwHYe7QRz8LZneNjY0kpMJabq9HHMjtCcTP30PHcwAzddM8okJApulGQTywNW5QIb3IgLppdaoKdGgbgq4iQkFiqrw44ADMQBGCJgSSvcnQrL0m89MAUuyX6ySXRkxYLzOisSTo7WKy+7oazB0wDb7j13L4Yfv1G+YBuMwhb9dmZYXYynV0izC5RViWYlRVEEjw2iRzbQUlReRseBlQ6DKgnxOaVX4wIx+bUKEyQrBOntG612GE2PzZvE/afHWxyfbOgdSjQSTzDW3T7zQDDfmM17De2NvuNt2P7jWA17DcqJ1FJG04hO4vZXPz1LeRq0p0ESZ22HWj1UW37bJJMJGIhPtTvtXPal/xJMo6s02YCh9+uTScbyVjtNe1JUk3KSF8yUttl0HWxnNI3F9qb2iicCyiOhZ1LC5J3d4zC2YJI4QE7VRFm7kEsdaGJR9QpvOIR/YGUmJniKGnkbSDZn/nszd8//tuHQAS0sf/3WXQ73/zo3icfxTncom2nMJNBkx/KRZwIMw/AjBodKOBSbUyHhxkoADhFVn064ECdV33A+poEm8NKxatUz59gx5vxzAT+AoCtJ8mwHdpX/qz/BsUPtaW9tO1kMP8fYLkBYOkA7n1VeyxUkwCcdicFp72Ne4PKGXYG0R7v0hlmMiKCA1aQAPIHEhYbLMkJmBG2IBWPsVGR2twDxJ9C/DFAjyUyETdvJWuu11ZoG4nvuXfe+Azg/eZbG97qEm3kb4wu44899sjj96HsDzL9byBn5HLjuUjAoA1yzMqYVxR2HFeTPS3hZHZiskE4ykegAwN5VkiQvRkBFFqzFdXlRpQVAsww4lWaiMOdjd/JrrCL2keY0NqNUIeBzl9yJC+qyJk8yk/Zs7f+u/n9gVvv//QpQt5699m8PTu2Hexz+6NP7Rqu/XJS+7Wg8dLHbr9yZl3PYU0btx+trB266ZaRU6/s3Wf2mkl7j9PzbwPYF1AfcW+mGcZsCmGBOWal46oJyJ2JmgxNApoMTTGTYZu2hLZqm5ih5U0x1Ywff3Ynmhpg/BfhXPMwvsKVcJFEhJekSz9hW0hXPZGchgWZOnyBhlPh0ipQ8oeDAwlh4jtecP4c7sUp3x5/76tG7WPAM+1z3iLsbq18/19fHxEOtFa2al+QDLgvytNbqc0V+JgN18UZRC2hCMUsTuWMwweUKsnXqwQF6Znk2uoMTx+yfnb0kzrTntaMU3OGbBWHIocjoDtzEso0aeQOLpKGY7o91MNM/SQEveO5PrhBOl0UARwgTMhwwaIymP3s5bIfSqj9jJPDaQed0CMsHdxfduSH8dhqCtu6OcPWg2qy7w9TOPXg/peXfj+UdvdAu++gardCewL84J0frsJ2J5zpcOJBU9glh93QPf+Hu6A5AYZt4omEbmX6V6R/Tfh3f9n//bCA9kmUm+REBVpenvh9mLb45Cavz4N9dn3/JW1JlZtSUpPdhREYLXtV9qqA5FRcoGiC4AOnrDQCX7Y1R+DHcZ9g8LZPXIWDt9q9PkE0SYlycko7JzOpcPNWW4Ld7fH6UtM67BLzRhPYuDQ452YnpVQhkin4eqUR3MJ+BLeQoBmJBELTCZeY6lXMyZVn55C8UJKjM8meos2o1l7q5JH7aB/VwPZWlU4YNbzTHcQrLGyVwjMGbRO7AI+cunrM6M/OfUfxF/Gokso0+W1yB29wb3uRLtAg3xOptNHDiqIGShtWQk5rl8wDUX3dTK0P+Xa+NkIbxJ/lD0Tv4udGB0ZFfme0xrhHKdURQLYxx3BVgBtYqf1VAhpiQxpiBozlgWhw7AJRF+5F4OjNJzvJrllayjWwqk+F7Nal0bf5ruiTg7EHUz7VzZA/rLpsLDABnErZqplZlVVR0D0goWLiRyOI31sl1LYeFfa37hDmDDXZxg89+5su2+zWDvB1lHb04GLiPZpUqDrBYlZMLiAdVFIymakuYZAMXajfTXZpe8hg7YB0tv6Pw1f/2Q8kGPDo0A8E+x9IaeQDU5gUCmdUO0BOGnMylonWUU6fEzmOdpUIoeSM4JwEY04+PxXa/SGYzx6YV/WXUln9HxKdUy3fA/aI2XwQy6ygm743gLwzSZuvzeV7CHe3Xiv4WluoHNyq/SZUnh8Ek/ZxaOLizC34oj41Nm0zLF4Uqlp376viCFkpnhAskh/2qBMHU0U/ngP9eFQ5ajYlcQki04VU3qzb/klxCJiAN9ANfn1X6rqBl41/TpKV7geGysOfozy1AfjUBrEKYJnLLeAiLoSizzCIO3i4sFhamoUcnwMVCDPjXLBfqUC1Upl+L2YHg6oMsh/o+y4ZbTqUkblTQWqwOBJ8VGrIyUD12QOsrFS1CDQmKOxQQDREnSi3nMR7jZRAQZyps1cZMTtJA7GeO3rTnfduy2t6pkm9IsVS9fSChyPX3Dh395svfnmY+B8Km6RBm7dW11TvfzXaddc1o7evaZzzujrdkrCYrnMP6P1DJQ/nBTqvWzEiMq4zBT37uM5MvMikHlaCjtgcus4kF9UVvIkt4SSZqn0OOGQB1Ai9SF1gQeF0RbVR50UmugHMDrdHYu4wZESJhJr8mV8wvyBgdjMmBUqM5N0zURTM/Z5Z8sXXv3x83f5e1vS8p/dGmrUtB3dIHm1x7eBRDWO1U9pp7Sftw/G123n5t+N/fEU++DjKztVC2LvlYjWsqYyLuHExTvRk0k1DGSPJUPVQmgMpB1TSsEI1BU6SqR2QmQ1AamuTGWByaMbI4RYS1/drbklbM/WNd9997p6lU59s0c7wKcRJuvaoLfr9m4//KB4bIvkI24VoJwfYurks9BI4ELYKYUIZmw4ik0C9cYINYcvMRB5g5x5qwgybg0aIiQMg7SiidqIUkDSbJCFRoRiUkQTA5czORMnwqgCu+HTVoSAgUQ+sH9GF2i8Xnj61YNcASWq4JMVywzenvp9Kpuzb9eQLkSZeJqnkopqpNy0mK/44vWM/CKROLXj8N6X1k7PM7o9w/R7g6uHSuEZ2JtQEYymAL81eiwvt/lSQY0zcAkvxBo34LqTDGYgiFqqAuRDWoAE50XKtJrgMhS3sBHHOxUyxuAWuDOKnHqESL6I/5/azlRDuxMF/tv7EH3lp3JoZY7fUf6f9Pot/ePu6B1/kfUQkpdqvX4349HRqYV2nDJJL6l44dpThRwYs5piUBfgxgdm6IgmCLlglwlLCfEh1WYAQB0EqUImJYYyHBh+goukMgtyCe+ZWQJjzuPHSg8IcxaYEdIFbcV0gOaNoV0JjVRgawUKooJfx1obH6+p8I4ZfN4Fw57mJQkvvvOo3nk+rSVn5wOSaVp/QgjbGrppHlADenUFyKucOc5ECDqbZxQzyMkK8zAQ0JRhx0muppTmYXYB+x6CtpbkkmV6WSDD3iqJwwnG1p6Ol6aKeCRYQTT2Ux1zkaWmSaEOG0hLuKau9MTIHt0tWu8FlLsisud1wbbkuWNsl0NQbaFWFTXDKyRZ/QZeSMj1Oxw2bh6E8ai6adbIVlG6SXaqUAZ9KEArhMlArvMjcfboLq0SP4PH5vWYWxAQyB5yxPgTt7qIfSRwodKhdZLsN7xbAr+vqhT36rL562tHw9D5k7Km698KDM/v0Gz7uRfUA6E3akVPXkGFk1+2bItqxK++/+Y51G2+/deOha+9J8w4Lzryy4PEZj77qvcx57e0PHpayqot6dl97567nt276lCgNtfxzN61etWz16o2AH3uA5zvh3Hq4kbrMkhCKWHjdvmuRqYuZ0kIvO6+UFuKRRfNjAqj4iOx21AdN1JorU/HGZBhTzEj5slNIgIVzeZU9E03msv2ryNyGVesOPwskTlndUKvNi5byh7ZvfPUTZlfhOXgjaKezgqbXR5fKqW/cYm+JJPDI4p3UFWULqqakFtUBM8H3RKTOOAXewlxEPY3QMdQNnijPCgSyyp0TTTPHB7t17Xn2V7H83CG43/mtmofezw565RVwP8Q+Hg8J1dbgniZ6Tx8ap8KOoGqG+7mSmC5pxjiMRC+unrcxW7ZurRJgO6kqgrtOYlNpuKzvvROXzh9RQmxsQtoyT9iUffb7FetTzBV0ZhzbG+Ek7I0DY0EMTVdqWzsuGg+qsWYg5JwqUfgbZhUFBEPdmrVnotnEFy7Sqsl7C7WJEcnT+qt2jG/QukfX8XnbtBsZvYB7khS4p8Cls3vGzHmwYHy1mfP2TJQ8f5xmv5Ea4ezmYKwGlRuVVLRbwUwjZiQyjhBy1nASKIkBOlgODMTDUcxhMYSpDipIoH6uwDe56B/IQUONGY5VKnBWdAu40E8K/JVDQ4RotRns1UcxzKc71ZUYogVolCAgXJVX6rpjEiFXiMVNcyORhhtufvzhya1PbRHLN44cc2jcpBePAvK9+dD6fa+C7v41cb/+EUVC/WzAulxoMYlZGnBVuAnIaA2TjUtfD9BQm275wjgMmwsXQW3CTmrtEkuNOffytzsU1W5pGknUDwVMbGf7E8H4aynMBWPbDJuXbPCjJD1iR7d2OJhMJgHTT6XO91jMErpaAENKDW6DZhqQSPiSOLqzkPCnPuXOg7a89sPrpr7a3Pzq683Nh3k/sZHO2vvaWe037dgqwj/56blzn5468zvKVUC7h8LckPdfzUXsODcfau4xUGG8AFdk8HxkLJ4gBZhbplO06l4hN0aKO3HPI4JkZz5LH4ZVWIVEJ2P5FHiGLFUQ8CV5U0i8NAWQvPa3j7/+5e/n5pkF8alDj+/VdrwY0TxS4eawdhLkqF+1EweqB9dqDaL1/IdnTpKT751G+MIa7HSvs7gxHBMLUXRB/I3JLyBlx9bgoJOH3Y6YHSkYM4ybjmuwuanE4pRjEkuTZHI62gQWX6hEN8FSeYVOXtFhf/rj0/MlV3WDJC04d/z01KYnX3ty5/7wXt5D3KTr7vv/OEa2Xn/TiySd2L5s+ZAQ+78/PBM7t/xvMH+Zu8ywMBrHD41hESte2KwxH5LMMJaeOZlXmEnWdgGS4pHSZUJAUZv50vtmXDbcPeCK1RGx/JVFE5xXK6eb9bNSDfJSLdw/gLauHGrrEnXeTUWkXGbrcsRsXVkwgbyYrcsme9NzkMdmxWxdOfG2rqwObF35BTS+Ok5spZYuAGr19j2PPL78vkdvu/TIvvDWvIdXLt+yOLzh9kv/+c6HRdOrpo+purZXn1HTh11/V/+6/rWVoxrLi0fNuGL9g1SfPH+aX2waCPLSIo4JsAg9k64EoZxkoXJShFiMeM0IT0kylZti7ilPLGLTYzWEJjTpCk4ayYCmVcGja+h2JU4aRDGqnDA/VkwQBwE35ZFgiJRrh2rr6wcOqr97JYhRXX/T/qiJjrhxkTwi+YHH+Bdx/juBTvBiOeDxkHgpXNKPIzWkuQ2CrhvSkJ/ZdZKFtjTVSePbiYSXiaWlF9jVUND2Z+8EUvXy3oZqlzQNVJM1ZDH/WrRi+8ZXPuFrzx3atFO3VQi7YC4JIIWyyBnMVMHAt7ClzSCi29RCzKjWSFIuTpc6F5KURm3sJLE8mnHXtDvm8qeQS+OYWRxn2gljphGJxaNFXO60UCgELI9G9+PozcRilZU/m9dk5C9x5rXh3/92gXmNP7i/rOd3Q5h5zdLNGTYfVH3JzLx2OOn01bS7G9o9B+EwQbv14P5+uT/uZuY1mZnXFDnsOri/7z9O5xtmseRUn7uwKQX/RuBvnHEsuZTby5ttiR5fmw2LVDh5s8VqS3S5sTk1rUO7lkh9jGjVcFPg6e9p1MUPOmYiEQJZ03aXuaU+aZ/WHRskS5ZBOyZpJ6Z+78uVvF1/bgDYrvp21rfD+Huj0/819BKSxl977hD/weC1g9dFCymsS2D/XqX7F2/P4v/anhWKs2eVkFXa8rlkALlkpraa3D1P26k9wRfxstaLvBX9Mfoe+VJLQxzRPBRHkjHayIlSl1tEyhpWaCCnJQ5fUopY1CmHIS5icik1abld+qIxIr4AKUM/vqTxq2vSpYuu/qpRS+kzYvrQ0oG9Lw1Vll9phyVv1b5uuIVw/NhzygMzenlr5O6TP/Iz25dQB/OIs32hX5hnhOx/s33xy6M7+Q+iC/nV5cITteWttbWxuHR+tWkPnIJajmYYoWoeTi5CJkmjilB1wdyV4+iFRQk7IRjxpFGykWylinEWXTiwQtWdBrIQUWioZNgCUredHtDifqRYkfNAafQqeswEnFifF0lHz7LrZ5Cpq26obZgwZuHaw4/x8gi+YSKpJ4VSnWnaVO3orTd7LZ6lS7QXGycLV23aQkZi8DshrZrE10op1DbVsRhIgByQ1rGaZHH/zmygg2Ctm2CtmbhW6urAtJvMIkBYtmRcaxamB8Ai1TT0ZQYjAl2rkAlrTQxiUCWnJlOswrViWAjKgYmgWLmpYoVLxbyabvieX1CMYh+uVcKlBwatWTxmwoQxS1bv3j9z8VePHW7hJ08h/Zcs9Vg8Ny8jPaZMN9Vt3qRtmzSBHyEe0Z7ZfC+L0+KnigGhDOh+MY1Es5hhZkVo7YJ5InFnGq+FOg0VGjCsEjuzn1CnfjGarXxJMc29AHnS7Bk3ls2YfFP9xdP7dZ9zxXUP3DChxwJ+Tv2stC69yyrG96gYVFoG6L1DW0kGAe9EXQdkOzxhqhkj4ZwdpN0l0LQ7O823szlB8PcypceO+XZmPqb0sHg4OBnuHSwWzpNRliH8TKPgzr4j9jv3Ml33+8C3j5jeBtycqdNTaghNTpWzD9JsKpfYAtyDfhJCzK+WyTy9DurphSOJVlHMdzMFgbrhTqZ4QYumKOvCUAhvadiuRDibh9pA0GJAgyAwMepCm1Mh8QaK8/n3j+yvci67O+v2Kc+//WbzsjtmPWiv2n+Eb/mGFPp37yipDv379Kk/eo+9+J2/Z5Icuo5KkNV7mN4EvJutn990KxD9YMROQ5XFlmbJzNkdhWFvSJXMGJpE0VDEWEYavOqBydOMsZRMjClJ8QHrFlOwQeSwQZRgTRQ1FTNj13bGrkP06AWKQ0qcLMLYt2T2eytnLXn//Vf2PrM58OCqNSvJZm3ywEqhc7U3soLwVaTzO/8cUNN/2y7t/arz3HUPd6dxh0uJTZTFrVwaV8DN4vDUZEkt4bwi1SaxOEDhOGaoYWoaxsEpCgv9S0fWbU6jEaZ7TRZ7ojsplaDchIGnVDvNgt1QPWi5yFP2EhPtYcEeNtAKmI+kJL+4Z0lBiQ+XUuJDg4XZZy5A9dUcb5xYurqubnWfVVMe3HzNyj70euWsTfdPXzX4hRW3v/Di8ttfJAPXTNu0YfaavneNG3dX3zWzN9x7Dbsmb95x8KWVd7z8MqONGAM/CehFEncd80ob/oxmWXFyDlS5MPQaDmGzx0sbTCHVAw3mINXGncfDriBNuLIEIw4n7pcDA5GkYMTpwE9O2UrjcFFRx4BzKnF5PbpPxE19IrBZXmasAlKO/wt1F8kIkqbtJlXa7mu0Z8hIeCWZ9rR+IaS3nq46UqUdJT3gjdor4milGc6SnqWK5JzHVDn6pnsOMP4CI1iAbo4dS/ioaPLxrVGRxjW0CitgjO5cP+5WLtKNStHmlkg6dW6j3b2cStE9AF17yOEs5JA0GqQIpWloUi8muHI1H4ScQmhJDqoVsOyLs6gtK0FOSs/t1K0YIyTDhSznTOjGpOx05VniTilk3yW5QC75k0+5V8yQZaZRx8y1TABBjNjsWDw2/MJJbtmzadvO4NKlb9w9ubam8u3dzzwSuGrFsNvXhhbdfPDu/TU1n702dmtW+T3hqtqK+x8eObH86sqJV5Vc0r/bFSsnX7k6v2jWyPnLK0bkpI4Z0uuyfoUVKxufnnzRjKoV6zKFrEsqB5V3nlvRb8TgoO9agP0Ik08YajrMWTiF68uyycL2ULPZzvXBANkgbdE/Gm5kUxLQK+ZGdia16MHLNNEQ413zjAsyIiu7oqKc3EjfTDO7daqpqcE/aLOcdP60NABoZyJIpcXcEl3z9RjxZKD0RjohLQ8A9Ql1swcchWoI6WcvQwNDbwmmEBQC+hbKFEUtgCclep7pXrtHTA/kdQ9RTbIbC2kNd1KetcjJXH533KqAK5wXCymj8axiICcX9HmXGArmuowoVlM7NclQKia9QerfwtfL2ra/HdW2HR6nku6RCCmKPKUdeTasHY2QTv/cv3BGXsPYux7ZuL56buO059/mP6K/0ra99aq2429HSd1rEe29CP5wN+m2T9XeefZvf/S8susLO/dHCmu7foX0rFLw8wNMr8MZ93MLQSuhEhBQNA8IdBIVDkQkbMzZ4gPC5qPJuHh6EhXmaPGhOGBLAMqVoTRZHC5PLNdWD0ZRUBzKVFTOVUoD7XiqTqGDyaU7mHrFO5jQvyS19y5VPvzI1UMHjJ7pnz/3iwEp1QuuvrZuYFndNbXXXS98MmmKRSwcNqTHFRd/oJUNqm6o79Vv0tgKk1RGbZVV3I1CV+EJTgL+jRHlPsFt1t+qSHE/TesXIr3KNK2MF9PIykJto7apkKyIXepx4k7RybdyJjj9eqS5kR0oWlksGWZ+KYhbBlPSY8kwAzCgzBYewrQ/zUW2/H/L1RPb4XVXwOwtHWB2c5dudoyU7CK1RLpQ03mXbCC0nYPN/mL6hd/SEaZ3BdLVLRjuyvJkMUMkrz3eB7sqrmftnnSxsBNucZ4Svggt7OHOeAK6KK5mxH36VbHyP6E+iKgsg8QdEIyIqULyP6D+Q++v3Tps0HeL//7EtVdNfXXWf8X76P3CtTfcMnxxjraQTNXuI/vGjdnFYh3PSh5RkhqZj/eCvWAbIMAGSOg/gw3gudXCfP4Uzdum+YksrA1YnrVITTS3RbcpbdFtSofZiYal78L0aZ2Hr376ppuefvqmW5+su350zZJFY+oWig/f9vjjt932+I7lV910w7ixN94M0z9/HiQqgvmrcoEwjeOio2UJs2EBx4r5wfx8mKcP7aPsVFuoQmPkUJro3kdkGgMko0Rlog4FEyJvCspSXj2D0KI0mWwJMjOSFZf0a+cL9jh5YNHFP99YP27YjJk9Ft57w52pva7U/k1e4gdXfrf47mGXX1l1yZSls4uqR4/TWmvp3DrzpfwtMLcAZtb5aLAdzC0HJHpLC1XmzMwoJR1Xs1CQRV6aCnNNpAJsog0mmIcTNMxQNhD3s4C0JLjCGaVhlxLxeFNZlo5hjYpLFjTmLekOn8533Dpv4cKFy1ZcM61+xM0Lim59dOm62iv2qw/dzc+v7dcw+srK6tHDLh1ZObB+0ZTK6Uldd9y6lrvQ188VNYvtfP1SzNdPbf5o/EdfP6aIgwJiJiuvWJu6JvfpqeIJefhz3ZWeu0ZTO6HmEZ1U375Stw+5LrAPUUMtMyYnM2dPcjsrEbXXoiDpdBlWoogTvR8d2ImoB78gCb0+q+5m1qLgG/MnrgyZ0CAbZy8aNq6kdGylxnJ752itYpXkAfoziKMFSGjcnIXSPYsDhXEL7A+oGzTo1GYExDdzNNoDM6ytzMZoctAIVJpL3iuEVBL/4zmY8+E3fNakLyZVVP3jbdFFRO3MN9L+PwYKIddZhvPb+NlkgBCSMTeJ45cxWVXzkJVwpXCdYV4Iu0TdTUSlChMtkUBFCVbyBFMu3Aw7CkpChvOvMLNfZdWhceP7P7Fi8YBUbaHt4p71abvn562cNDmBycRD+cFkP43DyeH0UGJbLPE3oV3iL9wgjxmTJfNQ4hrbYE89anJtb72HD0y83Xc986UNBP67FfhvAmi3Bj1xS5SeOKVYjIBOT2Q9mQgtlHIbPXE7O6YnslGoYeCWdXc9+PDatQ/UvffepJkzJ4nzt4V3b3+kadcT2hliWbZ0KZvLIOCVAYNXlriFEuIleextEHBIUqy9TQqBY+LFE2QamV6oLU7TFha2XbL96cNxpmtNe+R8bskPHFCmoXw5x8lmYTh/MroXvgdQmpaw71+i35Nf8XvuOkGi33eG7z8wvQ3fz+fY7z9gvxcGRvfCPAdr84U80Mkz4ewt4CJ+lOPy7aBzAXWzxFL9XC7q88FY7AQAX4LclJoQcBY2Z7HcrKyi5gBLjruIWrzhpJicImrBFkX1plNyovrzKb1OB4RJKQ3ng6JM0wnQgQxnuR9fRkIA60RCncahYDnx0VNFYjr+4E7Dlldcllk1fELdFf22r75xRkXe7I2V+94js5jinzZwxvjZxVdNmJCYd+NDo4aXLRx+w33d0oZ3z35N3MuS4gAeNKfIPM+Vz+VSOF16/g1S1UH7ApBUOmgn1VxGXHtarP0qToxr98bGmcZlxbVnxPqPAZnjAY4/r8H+nKGx5m6M80X5I8yF2hJS3DTotNkp2zHc1ylieoo9lp7iKQrbj4eVYMwcb6fmeB6ohs3IUPFSwhAgbRkq8BIIUAmeXyPMjN7PV0QP8lOiIS3vc2InkUmxrBU9Q+oMwu0WoKf7TG/D/PPpuq7nJYqfNC+AwqeTDk+VrvfC9gXcwI7aAZ5yXLs31n8a58L284eAUFTQ/l3Y+NrFtP9LcMj6xbUvON+L9v8U2vPb2km19iztb0LllY7P+k/DdsD/Ij0XCf2NU3TrvcOokYClYjiCea9oTsH4XzSnpGDwBfqjHcyc4kig2jiy/QSqiiegD8TBSIzZ28KsuTQNwCwzVmokL3UmiltPX8J9KXq4LYdJ29YYy2Iim7Rp/I56PmIkM/E7os0snyn6RL2xD+JvFB976Pg4n66b5hBQeAQZ/LiZHbYvIHkdtcP+HIprT4u1X8U9HNfujY0zDftjvBYBJUDcjvTJXWIlPisxW0kBWVhK7iP399amkk29tWu0aaVkozgNP96HH6fCt/QPy8dj+Q+n4WSkgXwzk/HxsBxSM40kiBQbk24wYMNLA6yoZ9LLXG4ejgWB+ZW9kuCQXRZfOjMChc3oYHewb1OUvZzFZnIlJtEgdEGvL4EJS9QyhBH+OQXmgpJ8t+wjmMwEvA53r4BG/X/z8IxBs1/CxInTD9UMrjswezX/+fI3Mdr/neVHMPh/NYv6X3xf3/uPgh60XZu+aFGfpW+Q2dobT4m2Rm1X68PTaPB/n6cAnjQ2nML/Yn2/SimcL2xfwP3YUTvs17q4dm+s/zS9ncbV0v599XE603Ng5G4kcB6MC4nlbkQ8umug2WbnMBCM5sJ7Y9F2vD1IU6tkPYciCXHdYzecBkpHSRyNhLswi+MM5nFou8gulsdBaAzjACmL68ndps+GRmpi4GJ3gVVnIOFiOo2eLhrrVMAi5ZG3d2U5Q2EzwwcPsPleWMKpJyaxpaE8G7Yral53eO/qetYq+zJzadasWaGKNoZehFNLw92ViNmTpmcU6cKAGdmTnmuATKkgVrBBNx4ZOcUgCx594cDh1SP7ZAy+ZNpVXcNbr36o6JLHL5u7uHLW0vGXDB58yZ23rdsm7nn6wLpVq2dXXFHQpXv/rkMmTr90y1N5mdPzu8+cduX1Q0Yvquk7qXfphN7jJq1aeq4/7B+NYZX8sH8DdHq7gJ7/9u0StyCD66idVP8trt30Zqz9qqfj2w/Hxpn2Vvw4y2L9x/ydnVFolzAmAulOCXeQi+TiGc0KYdGtcHKQhtWGlRDVmHoFm4NJuRhcG4Qvg3JYQG2kyByrMlXgoTW2ujKbSBLsICBXkkwrKXg8rMBUgZ5l1VVpsjlyLcyOpyZibZOQElGSadK3x6WmpaO4cVEu9E7HbJcmLs1Pq1AVucLdS1UhqOjGE5pk37H5JBvNwxipKPt1d0e2cGGwbh4GLmY3nG19c8nKex7Me/ppYqqYfXrf+9FiMnbUrTPHrq/VTjQOeOO+LbuuuX7mky8//9EB/gA/dvMK7QvifyBi0QN53z+m/fLlCK1ncte6zumEW77ksTuNkN4jB44D/BdqHox/BfgPZPyXDKb7QuM36f4Oovt16WNch+0L+nTYTqp/j2un+876TztH28//Ew7jONr/F53/jqL9p0P7t3HtC7TPaP/XgM/a29qB/26m7f+C/l/T8X/R+e9mKifPxxpFoAOlA98fpFdeyRZpYjz1RzL5MwNQIUNmFjK9zgTWHWkWEtyeVGo1zM/GihI+Ka6ihK+ELzAB2S4oSaKEHCtMBHLaxQDNj/5jxkOXiRVHtJ97/Fozp+uGyad6vPXA/WdOHT839YXdTc+/vPO5ZvLBF0ToX84T5wsPDlvfr3TkZUNXVi++V5vxpXZae4+IJ/cf/e2n9Y+9yeBIY6nouRrJztX5GHzFUgqXKrZPr3XcvmBah+2k2hbXTsdn7Vd9F99+ODbONBs7n7OJLAbETXDl4HxwRjHTR7K3GEUevEWg/DAjhng87Aw2W5hE7wpSu4Ve9CEmgrdVu5gtNEePMbmb/eV3VlVpb1I5m//3xIk9aQ0KAeb1iVgqTm3PwykZNyKMYwzc0cbAHW0MXJXRCwks3CQ4Ei0ug4WrEq0H1cbE91hsiS7ThTzc8O5g+Bfl4SUeHy1sYOirGAXWdP34wVOv1bTPn15QM2jc4qmVfFbDPc2HV9ff3fzqIBYQNvWGkpUbfsWQsIY5vRfd/8cb1/OH6n6Pbqw69+mLCxH+NB6F7lct29/H2b5c2L6gscN2Uu2Ma6f7yPpP09tp/ADtP5aN8ynTM2lMGo1rzeYm6tBN1uO5aCi6mYaim4m1kBo8/EZ0q8p7gzS+FQMTbXCocgyAm5AepinAQRHCGclwzky2RFk04tIU838MTJtoNs/V2gembT/0tOaxcNri31/sODTt73/E1kjXztY47XZ97ag7SStiulMN14PKMoxXFcd4Us13cf3N/lj/0boOxvofjfUf/U8Dtv3FU6YDsf51wjKWL6L1Fw6KVaBD9+Qe16tzdQWQYqRRLF8knFZEEzKFYEEsbYTJJRd5aDWPTCaBIKiRfondWQYJlUgyL0JLryOhoCsWSwygty63NCwrkaS0HBoVmJTG1OUCJeJJziylAks4pzQcBPU5N/A/JZigwBILr+pZ0qvkvyWcDLp8Wg9/p4rqiZ3yx/j+c+5J+ZxBs+zV8tWjB1526eUPtUtEYbqBuI/Kmvm6jmGh+0BzOSguD2S4HGL7cEF/kGV3d9Q/xrNY/6xY/1o+ra2/6YjBK0ktqe1w/FHczg7HH6WPT+tU0P4Fev8RRn9TH8kD7ZdTW8pd/AnaX9clXRK33sitEJ+QPNS/vY6LeBFtUtqRvzwRqwqHXSHVDsRYDkbsVJe0O9EV0oliUbqDOsD9NAAzCQMwEZkSgxGPnwbOuEDt9NMoPD/6gwHLMH8H6Dq6yv3pNEbTx4qS5mXCJ3OS74KkkjIM7MEYBSyb9tfJJVoBOdGwZctfp5hMr3rrrapzlguyTAzdnp7fTvr5zYjB/Xt6fpksUiNzcTYFf6z/aM4W1/9orP/oc/H9+Vj/WjKTFMf6H9H7Y3sl6w/n+nvYJ6N/HT+C8VBtCubCxPrX8ZVcXgc2i1FcGx7Hy1Kjforhpakz7X+RjsfHaH+a+0H7D2Z4/Hx8f3+s/+j4/nS9rP/ovfH9s2L9a/nyuP5H9P643gzWX+uDtUCM/sJakkXbL5iPcHd5DJ7iz3T+he10SirbmHdC+xC93UlWsjo9pkO0noOPm8uiG0DkpxFgWK8HA9vUhKRQSCXWFtVkDQabPbITbVgeKxM9XNScgiGLoicYjLho+UUXWlEUVhxAAl5FzS3tgh90EUUpNsp4sMJ/aP92+xU/Lehx9OiU1p2NcNW6UxxcD3j5M77qz+3B8h7iYO1zhBHol2l6fkg6em7T2AowGspJQ9fiSpnG1y/NoLFsMPVUoOeiBaaeSiO8UjEeNo16WNJwFXEx/8gNXKmYk+806LuaYNOtQnAIMUDjT7kkASVt80RyQitoSyl5tWmieAYP3M8sraSW37Z94yv/jL4unqHydgQI0Axqr2F2sKu0e6l9bCO0D6fy4y96+/W0/w/QnkrPKOtfo71F+/8fOvboGf1Fb3+G9v8e+vsozrL+o7W9sf5RirO/6O0PUpy6ROtPxtMz14Xich3PcK0A2gdS3BzK2r9h7S/DOJdSHGfj16Kd0MjbEMvja7Hw/zl5g2W+sHO/ViiltnJmA+zKi7T9Cc3DnzEdkdkczNwwcpSucZC2ls+l56Crrss00TVuhf5UxyFV8ToOjN8H67FA/27snHG3MJ1A64P5LdBeSc/Z2s6xWHbhJKzFgVWQbMzyS/MIwiT0H1NfbP9b6otYrr3ZLvWlHS0r0u2mY+jZvgP202zeBe3DdX3uPFnN1qTTyiI29/4MlhO0PqQTXdNwtlbteBstNu01xhfuIpbzjzLawQ+K9ZeEu76Ko92x8ZGW8dHpev8kySPr48P+fx69mOX50To0DoyAodZai7WFZkxRiCUcD5MgzVDEwqGUmaIPDeHHqbwF6xQ5WPwXAC7PZ6LWcHNGpJEMKNLW8M+1nlrJp10rFEa9R4Z+FT07ni+oYXtlgT+fAH1I4DJZVgot4GNlt6N1So06xTgy6BxwaM2W3RPvL3xl4i380nlCTjRjysBl0R78mpo2e+08w17LLeBOtdFYSpNHMtloPBfDrd8onHrouPW2gVuYu2P0F9aO4LgOxgeetaGj8ckoXb8g0F5Hz8bIoThOny/0Wj3aWloLJxmzXel5cxumQSCKqE3K1pZ4PypLe0AF0qo7UTHENezB7MkIn0Cr9uiVcWS9JiRHs0OJSxU87avkYPEjdDsrxfHlcrSd4/pUDvqpfdEcbW1arYegHZcWz+HafMDVgDMT9LkbgddxSSMpbZGeGXp2UwYrwYdJf1jU04sVTgWnmSW6oIMwLNNJo975pzySJC/LgiumKXFxeU+99l/75ss3Lhheelnf+9bd98LTYvnG0Ve+9npr4+0bUmo8YQHoN2ZkGTZ1SouDurx0zJA3QMcvjun+NVlt8sAWSouDuvxwOK7/0Vj/0fb4/m02/rHE09Y/zuYwtprpmLec/1GKmF4HHTMLaxrSnCEHnDrqUU+GC5Ogn0NqlM+wtTRb7TRr2GqN1cnzemkaKiKEwchTY4wclf5UzDEXMKwJVBks6mt3MDOsVVE5Lw0CD6fFLPNx3ixJL8YTLFHQOn8LGUeCldfw/4rO4adG7+PXRu1DJ7FyPCnENPOSfrO0s9pX/ElyFVmj6J4umdxNxmmvartd4s+yplK7xWlzFuBONvCKEHcvF8lA+uwLYXV8GmrHovWpmbNHsLmrIwPX2xWRqWd8xfwCvUx+V1qZB5NwE0DXLkZDph/Xm0HXq0qp8N7NFbHIWAcYqza7PSgf5GawswNd3KlU+1P9BfB+kV6VDy0cST6X/8J8aqz3cWHCm8kfy3u7943SWcR/8J9RiX81whKtt3xS0ue1+1kq3O49+3c1HxYG82u2r9u8m1lA7lxNfJh8/dVXNPl6xbKbV7HsuH9/9ekfv9//wrG/xejOBopbxTpdazDoDv8bxa1RjK691UbXNlC6VtyOZ87U+mCel94f+ctnHY0PdM1Jx3+03fjQfn4Ri+nB2kS0fy99PkxWpnlctH8Nm89xrqP+pPr8dx31J9X36/01D9Y+io1/PRlI26uhvZbOv4a1c6c7HH/U+W87HH+UbvuwAQ0roPAp0cfPo+0pIIMsNg2E9tH6+K+y/li7iI5foo//Dh0f8712UP47mvHfAVy7WkeJ3Dg9+ziu1lGzw24DOR2lXzjvbYEoYWebx9nWvj5hXOF++GuHs63ElUOKBR+zskikQds6RXuANGJ5pOjhq6MD+f1X82Xx+WkZ3D1Mc6ZZoP89P605Nc0rsHDqVAvLaQDinnw8nE4VCCalO5Ip5cHpJlOPbTKdbnIq89vquWtI+4VkPZJaBuoUdmPGJs3Na8tduzB/DQPkjRw2DO4w8tjWrTMy2bTXa7STejIbKaohpVzMX5cW8+Ndxc2h+8bsgW/G7IRX6Tom7U95xMU6j9gR17841r8mENef8oiLdR6xIa7/0Vj/0XJ8/2Ox/mPi+1M/EOs/pl3/Nj/kWO5EXP82O+fYWr2/1h9rYMX61/E+io87tf5iEcjEAfT7+Y2QLbsh6GPcFmhlSpvZWE/vw7BAvSYfLZmlZ12mYK6A5C8tVa0YKJiZRV1/ESUpg5rXlCRGXv1KJNGdoqdtZNC8I+x6QaBXB5Y0yZ+Tr2cItpnNCioVTBbc/1z7ZME4Y9llfdfvfI3CgdbPonDrzegNYfSJ5v9RuNXpuvbDMdtmnP8W6NPfmF+3vX2YVN/BxfX3xvy90/T+tAYSHadMp4u1RrtQR8cZx+jiL2wc1j/L6E9qQWqI9af62zhdTj8T1z82PtBpW0fjk1Gb2/J6t0tZINcX6bKaNebmjWlCTIy3cvQZEEZl2vb5KHs2PqYX4RC3vL2PFt84NxZrrgF8fja9DdL7XC6SblQ9iCXNeJPT7SznwiuicKKaTS3xiTOu+MSZuJSZWLIMj3FNmbTwMleqKt52qTNuKgsGOigbQkXFFyv7h48evX971eSUMZfPayQp2td33TGqRLvFdUJ09slb/+b+rJqMFVu21Z5r3fyo25DJTksput2/gWsTxagElolhEf54sQuN/IleejwseoQE2vvTvBiqJdCiLYkKyOKqzULdq5yamUzr+ieadGMh58/GnIeQz0lYTERHFRAH7xw5fKrDNm/69P9SSfIr712rXBt2BvZoP/1VQUlmP90nfk3rGE3Q15himE6zxFgoPTqK9YJFerKWsUY0uKcn4RpdQgdrzEqBr2CJpbFCAT4MK6VL9HZcMeCjWwZdLkyyJzSOr+qwcsCG5Dtud929LX/l+xfWD6B1/6QA7Fkq8GBWk7dd3b+0C+v+YeWWhCBuH6r/Cqwn3agCmAw4hkVpXEb+st1zIbnyGrvVrkDgmCuvsds33NpBncCj7jvvcj3+TEp0jlEvEGi3KSD+DLRoBpsvFYLjY2hVO8GMOZa0k31hunVykJaUSqA+fAwQcXlZ6QCafJ0CJFh1yZStcmoSLiIl9c+L4HERvDkWZbuzAZSn3Q39h/kn260VCydUu6Seexe8+bJBa1/7iK+9PqH/3FnuJbePVVrXbqqqfaUDm80o6n8Wz/8Kfz4w7+RcXAqXx3XDaOFEZokJK0U0+i5QpJoxerSIhqamKrSEB8b42xT2qLTsVPo8Kx/J79yNPRLDrbieFW0O4sughydA2j3cKq4yuRCHXSXFvVhEs50vHlC9aELDoqoBfOd5b0Tvfe8Mn3Y0OdfXafDQsn5DK/v2HTZiSu2aLpvLxT3K1Or6+dddPXKq59xgAjyVTyOv9WwcWEee6D9kSP+KIUNfV2Y/Ipc93BOfk0b9X7BWrH/WHfjBQIzX+K9V0MLditSeUku4d5HaCeFweXxNNOSxPRSak4VZDYUKTfD5i0ppgzAVIlVPcFFLemA5e4cvw9KtU9klA9EB5i6E8+jpfynlzX9ZRU3t3RPGKMwr/V/rqf1VYkBJLIj8P1dcW7xowoRF+Bo+tF+/IZV9+lZWdJ/uXxXYPOA/1mITvqmfv2DchOuum8D2YshJe3B9L2fXTcWAjzTuk/LHO3Tf2M+Gj1IaSvnjE3r7jRfo7A+0i9ej/nXaf3+7+IHZWp84vUQS1vo5XS/pE6eXQPvzhp7RJ07PgHYLp+sZfeL1DGHt+RtorgfWEUI7rB35dayKECse5GCVrV3sYWT/sVZQrEJQXGUget8M4RCxoy9N6ENztAvFE8IcyQ/yQSF9tpglFEsTYNnDliR8JBuTEEQWI2SkCST5vAE8baSw3+rODQN2D7x+4ow54gn50siliw7Kk6fNHce1u4ed64pxEnrNQfpMIkf8PdiqEvSncNLCg1grNeSVzIF8Ujhw7vQZcwbuHNQwVJKV+jlzxykHltyM4+eJnwsjTMX/KVfJEstVwidtkDy+UPy8CushlsDcxpuOcglcHw7zOkRzS0S0GRlSNEuUVTsnCq0BoT+Qkz6i1Ezo6aE5mcxGEALYk5Iq57ja2nGJIzLPRE1HRw8ZMvo3JotFTHYSojWpOnNtxaiMC6NAPVahwhcrSN9WfypSkZWTk1WhV57CsNt54kdCnrSM5vlUcDS9R6IuSkH6f5/lQ/7iMJN5xikdMYSe0n5DTOH2B3AorK1c60+wHL+MeIt1NAF92DMQWL0YWu+KSplOhrWConIJejpASSheBSgfMaguJvRrZwauutiQ8GG/0mDNx0xvAq0dFMvURDZJy4eH8MlLJJzKnigk08cHYZkxh9xCJTV7CpqGaJnFJCuunNYDINS86NN3kFl5aIaqmaTZplV3H3FRTkVGt37KUHna8NzKftll2V37usSPZi8N5qR3ueLK667PK07tdNlolsfLAz7dB7huoVWIaS5J24miqaPNiayoqFsvbR4xWZ2UMNPT5YidLsB6v3FB+KxBo+5YsZDY2TscMv/cx5S3ZupvTHZdEj3Bdz1/y/8/+PBXxH3Jn9BB230hOpw/33qneEJLkPwY2XZO4CjNi/aFtudp24JzTaytdaT40fkE05uomZ/rxdFzEvWI+7RJ0lqQHXpwKC3Q2A83y9RRWozC5phkYkWPjYCBTE4snkePN5t2IgkU6CGjUU/PkhmLn7CNsI0ZeWlld6m40n7VlXfmLo4kXtyle3eOb7XDvLbRPCk33tFcFJZDzQn6nnni9yyRxvHYaAnGP5dHzYtdtdpXDB2eM7B0I8lZMbwyGy6AZN1zc64cfG6o8sANOfAO65ymHYiePn8j3DeTw8cB8fYW9jDDdoQAFmWKEYHotAos+FbxOSMChHeJJ/jT0jwYI8PI8bKJsYQfrFaeoJM9gyfzroyLnQtddT0BiYZ8OFkZ9kUtJ5Bik0+YKjVzZjjByagV0LrD7lCzxLKg9QB9jj7rEZ8MjbWmvUktTXavgo9x9tLHONtZVL6agAlGFjhoqheRy+2jte0w08tilUsZuWEJ0jHpLKQ3kOKK8vKKE0M6zfdOCT6C16aZNfBP3r7B1XP/5TWYOh2LXbLFYosmab3P39tR3hXIBP+AvoMkm5zPdaqjfaOvYV9sNw2l7YUXtpPVtL1LTbt2kBWeoO1B+4XjdIb2ApD9fuRi3xj3Nv0bf0Nu98T/5t3zp/kRUjPIzZvoLyZr97ety3TAJeG6dLvsOhr7ktfuWSex50XEiiEbz4ugBdQ5o4B67HkRsWeamPbUn32Cju2BsW+kssCUdj5DCeMxDFsD/VzWFr9APxfG5RGw5yikcdUdPEmhOSXZivb7FGusyukFD1XI0AlQk2BNZhGnKcn4kCkXV/qfnqyAZs///nSF9/j7/9sDFrTtV1+trw2fJwJr6xJb6w76uVusNjc+MwlEsh565W8ky9U9+EHztKG+vIxMrT8+/Ugc3/faSYPPbdPHwOdxwBjd23yH9HMPCr/O8NmnP6s8AWUCWneEGI4ffH6N1cKZDH9PrN5VSH9gGL46C9+39hG2tO7hz9TXm2rr66OL6+sNudZ0BO4VjD1742taq7qo/ROfVKmtgLYe2y/+6aHv9DkuYnJjazPWvjbVnN1prKecrifE6hTp9b/tXE99LTaj/rcZb+IoYiKeTU/aNSsqb2Xp9gIthGLFFfkLrMTvLeO90TPCK9HFe3g++r2wsprfzs+oquej26Pj6w17PL13SZs9jn7uy+JzYf076fNJ/dxF3DWstjF9KGOzN90tOQrDOSGaFC0HVVGi5WksITULGjoDpStkEoSXShDIqE0ZoHVhaX1zTpCWus1nD6XC51Zzala6/qAeyjZz+xCM+srmgGKLtCBNICcXeKjYhygoUIWCuTRfY/adRGrKayzE0nyrtR9eSWh0HdJ+WTWLkH/JnT86wzcknibkx1OF/G9bzq1qbta+OrdbW3nq1B2/qZ+fEbb9Gq3644uPvjXWXknXTmV6bgnQnDX0+fTD2fO62UZbEkOh5hTJh54HWwgtPmFP0DiWunnEx+ooo+XHSs0LzraaZ7HnI/TBsk267RZOI82KzeaWNH77g6/R98O3+LCElrTGNO0b7RPhffK55v/suHBv6zXHPyMntQztdziZfcirxMSe4wxzPQU0xI8VSyheumg8E/oC6cOyU3V7lHRczfC2RDJoLfUMPz4aIsN4NAR6ljHf1AEdHD7qg8DwPR/1QfjwWUs0wh0VX5vMlxrPtVE92bQ+aERysKeEwsHCkoCuXMxD8vBYOb24l6sYE5Xgs8vnrSL3Ll839GFS+DopIWMfeYFsiL79wX7t4/PcOe0fz/6zfsGxc+veIN22Aa157T1t2876Qc+Q+q+AKHXX3tPOfaY9eWDQX+XM/QebMtrrtkigo+JzvmSJTMpjOmT9+dNCNW1fz9pVPVYe/fO0/R7Wrvuzd1CeMy/GcybpPAfaxTLKi7bR/pPlWA1rcQv183fGqow0essbomkEuDuxypYFuEUXUTTKBMTJpAG5IDGoThDRCjGnAB9LmSxgyg8IaqpEBaiCbCx0LvmSXe3CJukjylOIoQ0wq0P7wMmfPrs53EsSM2yDO9flpWUUr3dZynfO+6xlKpnYvPOpPU/u5dPgTOXPWdxzRert2nlNuSthkOtAQx3JJG6t4MS/A9/943cjxnuhlAV8sDO3XK/WmCy1RPJ1CznKU1mZClajyGpbIoaJemMR3rDEJrMzDUSggIPZtID9BsyIeIFMQDy6fA+WIE1QbMmUwaEFOOL0ogEGy1XSqiT5emS9EjNn6U+tyylIISwTSvYH2p4m7N3z86l3vlq3JrxTO/PZ3hdm7rzq+fe1RQumbd+5e+uefZpHCn76xzvP3vlcqpT8xvNvnpoUPcBv6t1tz3Yyo/bRB1dvefl56qPUPMIRsZxLpPX50PIohYDLUGek/TiN01Bo3Ti78ZzXEHGHsMyixJsDPV0ltinEfqNUQ+Qp2owuZaaJfQvF8ugS7fXv+b+d+/E67d35Y0neQi6Wj1IEsMaKII3M6491bViJN6vuMiDhbhTE2QDKbJaCr9dJzWdVftUieM93K649VlnwZQTwYa9Y4NdBn1UlB7C6u+RIbf8MWFpYzag5xGp88kCR454EK8z/6LutNzy/ccKzS7pe+9CVM5dOe27Hpsujn57QWqe+vUt9ec3j92wc24NEDp8pH/PIpOs3d+5bU3rR5OrqeTOuXrNj7pfa2T+O7HjjvVdWvDwqd/g1azj9+dNCNZydXPSL5OjPvGWFsTHZ2J2UY3HQR1EbD0PAhwKn6GULQYQLm4rY07Np7QvFA6iUj3uBj+AMZ9PHDGWVht2g/fDsUGEdPwzlYMHqJcX5xsJZ0R5/yGsU7+nF1Oz6Mx+82zT+wdF592y+azUZOO/OJ7fvfnDozbNWPP/WZyTr077W8vDyLVl51RXTJrxec+O11yxK7zlu2Db6zABttrBM8sDanuWYO8lmMTYwL/bwRpmF6Ce7WiLJ9JEIyXagyZnURZxpZevBMpo/3P1yHqt/mSOHsw+qHusf4aSD+09ffDgH6182wZzdwK3lJn9OtrswAh/jnvsCbfjAl2c9Od6kbL9e/7LdJ/pw6EwZZUpMXWPl7foJJRIcJ79X5Pi2tENzwKhWtTA0dvkz716jRb/ij5zntE9u6X3bbfcv7R0sHz+354Jp7+0jb0/a98wzB14x1ww5rT2pfbF5ztLhGf7eNZf2valm85QeJV08+X9rHyvlMWpAx4VIyUBi8Lh523JHlJYOS6ML5lhp9D+HRQX+FA3VEBcHdW6Y+DSLgNLzhk6LKVIh6ItOzovygUWvUYvGr0QLK1rY9uAHG42JD9uoIICykkkv7eBEzdtCjQaJeMmZSnUino0JLNlulz/bnee3IfFe+MMX5OjpFi3UYCcTyITEaID/yL5nd/gZwU7uIPe2fq7N0WYK9uhQvrmGDCJl2l4GO8qvgD45QYJjFYTQRWKjwYm2Fj1ANTEWoCrHiSjIPaglZ0fDuGmXVHiq8u5bQYoEufXs7bPlarPjYT2nDONEQW46S22vvwJsJMnP5Rj10pkzyS21sCoiVgm0aTSlAJnPpVU6gBI1k8T/h7UvgW+qWNs/c5KcLG3SnCxN9y1dKKWUNrSlICCrbCJWbkVELC2WRZFNqIiKiOCCgAiiIiIiIiIXk7TghgoioiIiLigioldR60Wv4go043/ed+acpAX13u/3/+5XaU5Ok5n3vDPzrs/jzcgU+YiCzmxnMUMIgukU7tt8rRUYZDjISDw5Wukv69ulU/fegf6j+peQ5Qm56ZlJGV269kvZUptqzLqMHjb2f/zqSzrGD1U7X33bmSVFRXFDnOcPJi0kacqVhyLV+vmO427EcVM2j70YM87VcHKNAvfUzAkLzYcQIMnBwYICEjtnJTXgZLu43EByunkVsuzKT/7TYOzd+tNDvcl0eTZdR8ln2lqfydZ6CexjgNEDfeIOpicpJSEfxGW6aI2ETeZ0yYJY7V61JezFI9CbAPUf3mRuokHnRC4bRin7t9Crup4xGmzZEGzDY9GXIrQbirLMXi00WM7bf5Ui8A38OcaYvUzDj4su23XL58zcvG5A0yh5rfMhevpucuOqVa+f6HPbhq03Ta+dUT5r8oHnycZ7DnS05S6duuDlImvNRWMfa6Ajdz1yReNQf37DuMb7H64v697Rk/+a3vtnHMnkXC2J2hkjYM16AaUcuTCwLczChI2Ym15LS8iolmFmMUqFARB7McwXcJoJjJSwgmhGilHjw/BaMKCMEEZssmq0KgJ9sOTHDd8fvbZjSl7x5RMi/64ztHRPq2n99aH4kc7rphuSOBMGnLVBph/lbM9RpQw2cr5gvBoabaqAUs/kTH0AQFIG7QBJgg8SMnCqpJGKh2xGWOKYzzY77AKkB0w1nYwmk2gWCt+Ggl8eO3r81MmRT/SRDYb+943b/dJTzzY9zobkZ+qv0i/pv5l7/ll5+dgX6Ify5p49//3zN/85+q2mawuxNrC/xC1LDCBn62yjcbzOEdDyIcueEgfQ31YnO9PBDnBB3YIUMmhMtoKShh38WaqmKw5i9mNYkK3URhL/6123pg5Y1JFOHrh28aO3JecFait7zF758JMXklY2p+6lo3xJ1LLkntr0nIlXdrpkyAVD7ijrMzA984a9un08H+vMkwE1nXO7a3l0n4UXdvFgtANIBJ2IkG2x82C0BxBx4hDcH8gROQMKIFZ4/YmqJ6aj1lmAOfIikkl20q1//OvTMxNfaQq9uu2iX3+QZZJC/DWv0+On6DGSfurgv795kxS+/j3fPz3MBhmBWN4XC8ZGqwXCp8E4MDLizUJtAdjKGOVvcSNPuMJsD0XV1DOsotulAu6WR9SdVbav0PKsl1fT6inXD72gauqDD6F2Ri5fMM8zMnHzo3KY7+fGnrh+qgXXkJ7yjg9oJ040zw1WRJPdabUUcV6fEixV8Wkc7opbg48KOmOy2y6A9A2wZ43qubHu8W0vPp+SXZeZ8dMPRw6TE/IlkfVvvE8sxDnvkzuu+/oe+go9dFrg9wP+fZLkl2ZK4USC0U9QwGByGcopHC+LHmpviVYkxaQUVLCqmbnL6Bkko2cAUa0EDy+V8kIGXmYnZSjdg6kPKZRlBXNEAlLVoKxy09pZ6UOEHp/KXB1Ao1Og1D1XMvWSxcJqfH1Ew5C33yGpjz9324/r65hdclqeeMueSYunjxotF5Kc37rd9cnco7+65M2kgX79SzM9tTKOdiAfqST747j5n65669vF8/C8OMHmajMOZ+dcH16zA5kTn6DK4URWpthjzpfGC4ZN6jZiTnAlZwswfdBYAzGAZc3PPBnoytwZstAJticbiIcc/TK1qz89r3OXDt06ddhDRk2lk3dVlHXN7Zif16P7xf26baZ1zBHpLgf6dbdcoKZ3r6UJ8oMRA+2waFS+dVhC6aQlZEsE+OU2Uo+pt+KSUqTJvG4CwXiNEKoIK2hXKlB6iAqVEAj6SvTaD5ce3FB47YQFgxvxgi8Ryj/iE3lpkYsXSaNeuXS98rH/Vrhg3whAkY4JH83Guk/ervvsa19ubW/6BT1Zx1zNX+Q8OSXy5dH/2E2vn+6mEtO3Nx9d/S/6G/2W7lJpPvk4HnrEOO+WaSJbC4VQAwIdsMGsAGCAAJx1siwY+TrGRuUg4yjy/mAXptu5b203Az+UsQB0yamG/LnAJO0KJ6dkYZwj2QY+kSPdnyt8Ihdzr2VvlORSkNWzefE+fsFmLzd279PQt3LRjVfPqJ917Y23VPad0LvH9k3Tb/HbChZM2vS8bHuUxN+xmv626sjx+5aQ/nTHHau/+ehBYnroNvrTBkrplxOunHAlSYJz1AB2HPQf87iDNJk2ReMOeH19tLder5efqdfLj/dJMXGKmXqcQruOssTrG3lcQ1qP+7ON3b+a2bqdmD33oBTOEhxcTKwh2QwNxkxLoKk72KUsGBCogxUlQb8GCBc0wT5ZwH4vKOE+mTNYDJcQtqskVOzCZBR7MOwT2OpGYI50DDqlp7CdEio37MXs8cR5+cPoGAc93/Z0fydYQTLP27sFAAoYNllq14JO3GV1uZmVI6qloCiSF2MQj9GUz56SYus1eMSohAQik+VG2kxXP3XvCz93WHqHibaebHremVDsLwA/vYSkZr18xzWNhqrMK6/oOvnqi6i8tVtXw7u7l22gL9J3RvcpoHfSKU8/3ev6xrzK0kTZ+fATcitJv1bSY97suTHfpULET7H1kG0W8VYOVuM+FHJ5uJ/icmtsFMBaLns4vD6pTCFQmudlg3cQKDcC9siyu+9u6JeZmZLccXDjkpFIIzmdnE9S6uJGK5d+R19/I/K5XMxtGXaGmU4i3mAnaRmvqgnGBZAQJo/vy6EkMLs6liHOIJ5gxSVBLzrUYS9WE3rB7Ep2YuFxjgtZgwr4QRy2FGArE1hg0EOAhWuupKIqBMEOJTjYvwXs+Zk64vNLSoO2ckeCN0sDmmRnIFs3HLGG18eUsxVmEDUyAVxnKltd2bJnk6mC/nLxBaGnJt/ZwZh324ynQpfUDbtpwZQZdXOubu1zSSRzCx6Zy2jrxqNf11179VXHjy0lhk2Rvc+FHrjt6NFFq8jkh0jKbfTIf4EP1g7vC2I9bC2cQA4BDSvCxVwoLMlKDYSctpY29emmFLuOhZZREkw7FErlZempadh8CVXhadiSmQayTeWNPYB2gI090HxpT+C+Nq9PL0tMJ3r7Dg/kIYmv4YVIK9n+0jNb1o3t0n3klNmL19IJSOpLk4PPrHtmj2u8a9nCdffe0PqDqUafN9b1kumivnY0zg970E37mCU2hse8Qy5rS5PX5bPE4M5ageA5wQcBPdRgbpuxgxqYPxIwZ5bgYKqQCqdefAJH7rSqWBQrYPoRLRaCKlmSgc3MBe0xXuiUmf8k6fnuoScL1wXZwbzXY7C0/qyQTiTh2dXLD9O36Fr52DEy8rkRY0bQt+kPY+kbNFwyOkCW6r0Lpn3Mz6iQzpWL+pN4MfRRivuKca1If7Qon7NnnMJsmB2irhPMfVLGnhAHBUq2Cl/WY21ptvmTLRryVC50C+NTtsLd+BwdHO8LgjS9x/x6CslLgNRE2WkKeWynHMHEncz6aTIrFncRO06bvIkeN9sjFEssTW+iBwI0TYrZm8iDMxaP9rvGRWJwoaRD/lRkb+pS2pOAlqQQd7YA32XKkm2Tmf7kaWBXPbv0H95/TC95+O7Tp1qP0z302guqL5xd18vw80tv7tzxSVAek9hA4uQAeTMyd8f+/UdMNdQU+YPSqdMf/eejSyWNC9zsZ/JySamQ8Rb1idjHBgm4IAk0G9QEk70omBLg1K56uoRZDYBs6sISUgBVgjilUgbOHRiocTyzKYVU2AzjfFpLKTZT6zNS86LQXfLBCa+cOsNm8mqkxNDtpTd27jgSNG2PzJUXwvjf+kR+L1I8+pGn2dB5b8kJ7Auv4V4HdIW3Wb7OuFgoQ/ZgVb58VRea8bB82zaDx4nl641tKtGDS3ypfhD5F3nlxS2Trl9Fh4k1uvnFyO+yY/l0vjzb9BGRN8T6XKftS7xvkuwV+GvD8DrsS83m/uz6u1gHt0TKxvUM/ZFfI27aIJEXMuMzCEsI4yrZrKJZklPJxKSwBIEanMxG4dPa9bblbJWnMw80GIY10Lw603ZgD4c2R9hP2uffBX5bNeY0vRrDIeIYaln3ZpMXCeNN0ZiZncvajvuJ3cB7X6BcwuoVLKpeu8pZLESrC9eIPE4S788+YCiPlJK81tZT39BXSdGel3Z+SFtM22sjR15++82PRz/y1ONLz64N0PZGeA1zYWN3MBm2Yk+vWxot/FOAClAcZWXsFUIq2tnwLGV8e1SFvtgPaUSqCZwGDnwcqwDZho0+IZ4dk8To4OHUygBfqRwiABACbMQxaeVndvnaVXVnPqw/YvDS6qS3agkx+Eiv05tpCZnO5H3Q+CvdE+nQvu6A2x1KT+Rx7y4kHucIcCbskMkS4FTuCciO4MBlxzFzgUioyWi2cxToUiSrDqi8h5uNjcjTI8F58rAGedi8yFZ5xu2RNQ2Rh+QWeX/kPPlV/OkeccrHI6nwg7lJiAeyMyUPMha5hD/wcLKAD22Oj8tN1k6SfIyxZXuZeQ7bbBqzPZx4VDqhDbMAiydz+XkSp4YIoKrFi7YZtxpO9KVhZKVSB72LAYNWzAUVoCFOk9cIiH851Vd+VPv6159/dvjz99987r6pz1/T/U1i2v8dPUiG0eOUnuw7sXPZP9c8sKZ23YqbVvW+cMTqV5+g/+qrXEC/eONzvRbgV+xNGxHlJTQbRH+8M9Zl0tgIQX0NEqIPApS1OQG7jUN2BFswY1WUXdvkPOYAEQR15ECdRTHUTqi3W1ofZmZe/4YfTK7TQwzb1+84fSKmn7q/ti+w9b+Cr3/YR9gYbcBTbhE9/EZtjHE8OI2bMHhxTLrQg26wamMQT53tqy/fHukpH1kcKWa7KT7niENuifhQz/5oMW7AfbSKR8macmwuB0eLRpqleLEgOEQ0bo4hg40/xngVq7/4UeVyY42ETQYTsGfXS8fNrJIPTIh8Xzim94C6of3YYfSR/BZ5E0on6D8j6yi9qcef1Ifo9TXtazjE+1/j+r5ZOqv+QsPhQTsiP9qzqNVICBuwmc3XBzLFeBDU4aPCqkCsZhAB46QSDq7OibLw8HIjxRq4FA6DxpNFKm1zyMv+NGMy2TCDFhVXj19U1zi4pnbQhFFsVK2bBwzpadh0prX+iev7Z0zIK51yi7B1oC6DzWGBdK7aBbbvmxbE7vvi4P37fd8YBafUtLbtvh/Q9v012raPW5HeJ2VcgnvOYEm0xRlwYTQnmBAXOMHWonF/iC9kegc9TIDW6RZBqWAChA5Moo7Tja32ZRWV+NVG5hxsn0AG1O58vKGBnnn9rY8MC+RA5A36q7+H/MXpIfLcCdskbX2ae6IMereVAR46JmvgL6aOUNLnOPICsBbWwv9rc4djT8ciMB/G/eDS6PeFzHFlutQdQuriy51//eUQp4W6EbtLg0+PHQd/DHws0ScRfRoy6u170TM3rs2Zy0ycZoMX7RstTxXHz1y5rB1OsCpwgqNnLubYy/UTN1t1a2eujTxDUvDEnTiBZOGR+zOzcSJz4cg11Zwx4qlrQOyq7bgvASrPJWL/9ASQ3BtVxsusRrekjy9Jj17LCOiawAcF4oJosM/ewhebO06MD2XVziIg+PxI6pnI79/SAyT7rWdeOkx/MqY2gImIRsHGDY/dEymE6izdtjWOFOPsq52iYohtxuc59/j4ZveXg2IDKmht/b2FvkKKUWBf89HsOyxMFNCtgWzPmc7O0BTwy5KFbjVJhmQLr3RzGXj6sdliTnbZEe0Ao3bKIYioetk5qni1yB7E6aSQxaxRgmG4jkd/gWsoS3Jnl2fLUjYembyEhy26gU/sIQ5S4Wg9bTAm0gP0txH3jSrc8BbpT6ZvpHv3f585NkCqSWAsSSSd/EVjhtNbaNN/6JqXhRz/OGF+1rSf+QjY4SjpWZ9EgSTOT4o0G9NK1W624/y07ErUS3AKL8GL1QzJoo0Oci1uJ6YrgskaMKBBhTIl7JoVcndF6x4N2SqJEu9K7BGsc5NhxEPyyFDaTD+mR2izTOtkO7GdPk1s9LdTv1N2pEQaSTcyUa+CXEZGRkrlo3Qv3UT+Qc4jPUg13cLnm8lssS/E2rs8ytqoGDjAR3OcU1LsqEq49IyHoOgKFhs0pqkIEcNLsYy8zN/KrJ24Kg2UhIC5EzTCxKB3y1kIhlk2AWawbKiNyyQPPbiJHaJjGtg451z46ovEe/LoXnl5xpsPkg1si7wpssDoW7deXvigjp1rrGZnR39e/850za+kSknMYnuRx/CRdddfgql2UwnaaVBrAXDGZRASUkhRU4biZod+lqclmFUScjMnqAB93mB+CgmZlM5vSCHF1PkN8ILj43aJUgUT86fB+Q1adrI9sMloMDEX2MJ8YYviBgo8U4wLzK6BC8wUxQgOsPgX6xKyoCHBmQjyAdzVsN0dL8pe8ypyK31mo1mRDZjnd2HRiuz2uGJK8cmyuwmpd11PP7zy9gfjlKvfvPr1938++tlv4y/bfP1T2x5dc91heYn8ar2/1F3j65ZRQD+if8ybQun3EXqcjCW9m+jJW788tO/Acravwfnnw1qgRKYDE8SO4bTy/Ewok+26vkTcNXxR7BEIR/vKICKNByCTYCqWrwg25lRgi7ZaNOJoUAcgY4SSz0yeotM2FV7tBHtLVnnXQlKubTHbyf7nX2iYuWDWgb30ATKN5NH9dC0Z/cBtd9xBVxt7L7plwiyfOWHO9IefHPvt61eMbbjyYg3/qZzNJaZGGuZgtERrpF1/WiO9XZ4X+dLYu6bVhzpVyHyoYszxuSByhmeRg52OkgI+lKONDyXz/B+m0KI+lJFT7IGXncDzvrHulAfRtfnSMCJeD+8+BbcKzcoYt0ouHHTHSqMct7yudWfds/IoujVp7Mvkd9KxNZOWok91wLAw8kUUdxhz14NwH1ag1p3No71PJf8vPlXgLJ9KIadp0Rzy3njy3hxaSFrnUcd46pCLZE/kB9nJfyIH5YLIYfhh39ufjasSca0naz4VO5WSMA9pRJ8qCXwqeFQF3KfS2HVS7S3hBIw5JgD8RYc/8anSM4DrXQ15gcgwiXPctvWrsnS3igfevRr/XP8Jq/6x8vG1a++/nRTccfOIuy7K27oh/Owrc649+urkpyvrS/03XTf9mpp94xry/NXDVy54sauSsfia+7cWavajD7lu++rxCmzbQ38lPtanAivJzK1TbMAMmXCDNMXw4AIYLPpQlWT7WEVeeNuVxshcY+/W7/cbjp3ZZbC/25otMKd8ppPMd/oaewuXJEfxz9azsbT1neT/0XfafhVpmUuTZdvCCDX2xkd5MnIAHyPmln81bGTf4WQ+O4+cWQJI2Y187XGi8cvK605cuL584DVonhJhAve4/dMX58rn1dF5GZfeOaVAHq2Qo7KTTfALOouO263JNci+xyMNFJUMEuitWZuNqJ3idVOa3Z+I0SxIQ2DdlNkGXVZA/ipQsBJ9lShdByHQQ1ygbl9Auucl9SJVd45NLKXvjqLvubM9TN6fjRv5tCGfDWhv79taW+XWzg09Wst1f6EYn3fv6PMmnNu42WDj9pWlRXv0cS7NvrJwS8B8lnsCy3x7vRyuq4sMN/amfnL0zC45PvJzTE4sphYFvh/6RNvW88vt6vld0Xp+V/t6/u2G+voIovgZPm/N1OqKhuF3XKLvIQvx9UDOicX0aiJ+J9tDFH1flSwQdMTvVMTWqmhba1gxaUXa4ut5bNGvFhp601V1hpaaGl64omFtYF3TGF6rxsZzXPGwPSuJnUmThJ7FcyyJZIEVpQQAJjiYyV4mIguw0Qq9h9oRBSaYi7sjBgS7BBTD5DJEjcKufzueVeyEApgsq6jhl8BlS5S8HgkyVvmSGzLATFt46Ugjcf5e9ytx0B9/qfuZnph4eO/+92T59fcPvSZnnyH5LrKTnu+iH585Qz9yQQLeQTpIf3zwS4IhqP4UGamefvvgLyrMV/Bjs/leLmoFlxlXoU79he8rt/V9XVEfzPU3vi9Trjvr7mVPvDUTnjgcGXy/2ADxN/a9bvB9kdPLxpdXs6rYbXZxqHliv9DOKx7iRUDQblA5l6JNESF8HWyAO7+YGttQt2hxXbi2vn78rmlPPCXvJdfTlXfdMPBC1HTjhX23cr1WUmPXle77yu1937OmbhFlk2f7vmzqGfD/2twNOh88k7myBe2ev/R95fa+7599+d/7vtpYltdFR6M9DRl7gppx/h7wfXHHi9esMAkABDw2onkZXgxNxePeErbFawBROg2XvT1vCPq+WWpb17eQbCG1ZN6hvXRMHam+575Fj9Nmti5pBX3voX8aWlpn3Thj8jiJ24gmF3Kcu5iVqPm+7gC2+aBietje55L08fn0GlJZqyENKR60f8BgTGQySkKWZ1s7XpN2ru/2ejKaDfB1uocMXfIAG98LhvuZ9PgIx86efc24SAvCkcr6OQxj7BvThQTDazM297nHhuVNfzkgNph5OJh1ZNrS+9lgVukjuf66a8YJG6eR2TgpwB2IJaRwMLpk3dNNQk/X2MbTtZ/t6SJIloT0KQRru70C+Qa83gSdYbeSeb1Yg1MAjgL3DPP7z3v41W/lyEp5orq/afK69G6bBvzM/MHjv45Zmzmm/NR7o/bsO+8yXz79jJ6iP9G3MrAf4o8TphNs3Gf7um2QHYG9U/N1LVFf19Xe17VHfV3PWb6u3XxuX7dCLy2UC5ivG9N4zORe62jZ/dZ3/3nn1f8Y6HryWujRR0Ph9Y8+Daflv4mZvkdPAzgMyT8d+VnO/uxM67HPTv3G1xQ7x8CGT9R9Wiu3ITAPGq9KZi2Q70OfVpTr2aKAm1Ae6TDyskgbp26XQmo8N9w9MT5tV04UqDm12TlKIRm0auHeTWRnHfPQDyQtv5f0petuvJN8kPZA48qnzuwib9BKg3HaFPL8dOnvuUfac4kAxjL2+3iY13s3t6nDHolD+rBn89dIy8wfzkWkZb+GtOzPxd4VKKTK9cOvubCj+Hm3CyAtQ+lEqp+5BXEOTyLv2IS6tsSqYK4a9IFr96fAy2cDeLZHYBY4nnfe2w6HuXWhQPNcsOG+PUcBjVnUb5cj9sy/OEbHj5JWW2VYzfQ4FdYfxpzcWlWmjemu3ZkMPal2o96TCu0K9rKwEwXjTGDrD5O37mQ+L6cKK88ueDyhGsDgioWJ5L0l0C3GK77hsJMaSfKPvR7tnt5jRZfn3lfl6ZHF8sfPPjyv86qa7+iPcjKxkrIU3yhvyrsvjTr8U/kYH6x4Da8QbS5e77CJTagQcwDD/pzvhePwiPsuFHUzvyoS0/lEKQuyPAloOXsDAXDfQ8TAHrQi3NVmS5ZX0SJv2eAEhnxwpJUBjXIqJ3+CclsplOUTpJS6JY95KeBYQ3ueb5FMGNkeT9aMu/LJzyR9/7N0DF1H96ZfevfUPEMJSVi9vNushfR3sPXfljNp52Wr6Q5m78+mY3dNnNk45B8Fgn+D2QETsXY1Daqt9dy8dtKYMDcPrYyp0dx8erudSMvNu9rk5u2IFs5z89guo5/QMZl5fSrsuB5aTwpe3X7wdXpfZJu8lSQtXdFt1g2UWUy0M3mXdl760KOPyY7IybFT5g69NJ89M4F5zp5Fi8ZdY1iPetrShkMKzyq8/jVf56/HcJKAX8cx5wxL7tBtFbT5/zInfk77sH1O3HWunDib6cP1dL4wks7s4jlxXltj7mvaL5VDj2YAvrdTAJLFUO6GEBz5zASwgQ2uMTY7vLh/4iHPQcRSseafczQD1G/YoASgyipRDZUAX1iqK+zP78TBA4GovASW2jbJ7Mkp7MKpZ0KKvyraJ8jXnOyFV2isY+WvzB17DJjxc5BXZUnzfz88+Lo+RYPGlFz9aM3x/Y9PaLi26dWPL1k9ofeVJUX9Z17wfgs9+dvUh4cbhz009TQ9Kf9ORpL56f6xub6V9IvddAddPYKcppZqMon02UXSV+Ukj81NowvoJrqc1heVlxeRh/SaOdOz7BmlQg90isgNGG1YYYSA/VYnWJFs33Fi9T3faSSjyiMVasCd6Ga7pdsQSCWBChdv0jCYHcTgn3iwYJySc/GKjQ0HVyrh4NjXPrzq1Yw819MTmHf+8mT67oWPk1TyVuRlOjpMWsgwNjLrYdnRpzqfPqXHdo0n2TkB9S7XiH5HtjMC04r1rw6JNKgIh0PCrQF9urF4xA2HhOrWKsO1BWbXil9S3VoirBx1DEsdjNDVGGN9ZpIRDeRzmkkyW4n8h3SCTmog2ft3vvop/dm4YCTpSXePpFt3v7n3qHHBmQ82bVi7IjqXOlMB8w1TwFZxioovTf9DksK9Bn0azSlWJ2z7KSLB4MQZubRjz4WtGC6YkROLZJwwIxevtY3nNcJSKMWl0fJqZ9vZ5nTmF3VkKZ2BRuJe2rOOTF96/11P0IcM31/8zTcX09vRqv6+dRoaizz/xtaXzbSPzekWYXUhXZe3TYaBWY6hpBREhfOBAZaRwmwWYICDzS+hTPN3M3nKIRNr0GHzc3mQ1cSFzdIuVYBCu9IF5n28QAAjqihI4fmGc5a4GbIhCbXOR2aRjm0q3X5SSBFRn129/GP6Dn3ESOsw49CVTNbL3fbRIJS7LSJXREolwUNoup2d0TnSAjFnbAn1tbE0oVNS9aTDRLMCcFZhnMGPE83hu3wOYsbBRIHnSi0Le7I0+hYoXg95ssREfYJ8kNlqyVUhh8rZ7ti0bbrp+eeHuQFCM2S8m8Qf7vlo1/SKu8rDB1R5UKRZfue5lTcVr7jkuz8kma5jJ0LBN0RJTWTn+vs7R33Az/V0Yo78IAk+D8W0g+3fLugXMeKZbA7w2q3meJuRcKjMeOGfWDhsEoSIzRZmcMkkgWOlk3jR9MChKLAB30qYE1DgIPLMUrluJv1yd93L9BMylKyqHpXuzAFoCjkcGQ4/Budr79d1HcXXkY2dTT/jmeKSztc8YByTzOP/wE8JTpPNzPtZzh5XmA2LVwIFYDgGHI7BnY0tbzayp47svurgsrqlb/+H9Lqug5JcAq4a+ZnGw488kGTecPFtWs5S+YLJx83W9HjBkC3FJQSEhODM9zgsiIehMkvGY+X6wGv83Vzx3dHuSazqh/o7owehv8OKKYn3/nsQ6VE89qgI2b/M5QAEQQdU5BmJj4lyBv3wmbowPTCVBGiePJXcNCcny5kNCi4vYzI9ECnVfgzFJO8fVwUu1ewXrO+HudTy/SksmeNgLiIqDLCizCN14nzsbD7ALO+Jzsf1t/Mx+ZKE3GEe7qjsIVtAuPyZ2jawJ/DK+KML6uZ92nCUvkjeJP4Z6fgYgHrozC7ZEzmBPxCvbyDJtSMWcN1IZnOYadrOvMFs6RifQ5OUkJiR6+PlQpgVMiU7YX2yU84ETaRlGnioQALwRU0Ap2iK8fOS0p49vqvlyTTJGSQ72c3B9J3Pv/Lad2P5VaczqO4MJjiD9p1Bu7PJYU9wF4XZf6OZNamZqOl2B2/6jfkdU2s+IGVSzKZMZLJUoWfa6QpbbNmoApkm3kZtVkMKD3y7e8mVCKqSIbvcfkNn2NGYLHMcxGxwW0ny4pKJj15PhxiH08FzHpk4pm7SiuJ7H/ZPyJlyY3XWijVkE/vfG2uXDDLI2TU1kWOGgXfRQ/Ql8sXKaZFk+euSKRNpumlU5KTsEPUNB5hupPNON1xzCYkiqh3KsHA73HcIAyTQ6JYIhnemYFBtNtk8SZmcVvUcg/fFDl7Bsdvmdxk9r5ZuMjxCN19x02UV8yct7HTTrLz6nMabim5/hFxORpFBN87ooZBZl1xCF5u7Xb2QPktGzRwZ+VzOHDmdbjS00NvIjdGa2elMJ3KlAtAJsMubJYc3HZVC4fVZoTzQbH8CeBVuX4AfUdYyjXkrl6/UXN4fLigoEwUuqwBldTA9KRR60l3TCKYhmTvZzcE0picHvuvDrzINce5k1ibTE6nJ7kzLRHXQf0NlSARSS5NizMkDuXnVYH5VMMEVNlsLUBvYssFDMA/fUFwhk0UPSJxLrKATfncvUpmtWuUDDYY82td4IR1y86MTOt09aUWnZY8yvZg1d3j6iomL0/qWU4l8RbaQx9ieMV8uZNpx0Nj/7pW0knxxT0OkQD5cPKmWppM3xi7qFClgOnJcThX+z2jE686XruZyDkveNNg/BJNNKBfhRGOkbGkJWfPKyjBzxuTs5zuIXwiX6VIH0CVw3Y0mJVdIIg+Ib3LVs+cMLcztdEmfM3MVZtMHDOvow+MXXhaYP3Fhx+vmFtUV3Xhd4e0N85MqOtK7yEIymozCLWYR06obyyfdCko1ZSgkkoZeTTeSQb2uyov8ENUtIlXTiUZF2Yc8ycH+JaFeTG0ugNRfd9CfEojjAX9pNpADslkOwVl2Y65GN44VUQZeB9zfydMSdnQCO8ABQAND2XvdEO/Fi1gJ5zuMBjUpJTu/sHNJea/+F4Ak2EPH1qlOauj8PqAT3fsznTi/KmTtBXCpZd3AWbGpoc4liNbRlJSRi0082WooBf0SH+coboPSAZ5IZX4BwFiCS4JdMIoZehNNPOloEriH2CKDhgdzWar3fHjiGTowWt455M36PpuHXnPL5TedV+hPSQ9MGrjtTXrwsSdb6bGHF79WPWXKhfOGdLpm0IhnLl/1yOLZ8+z2hStIkVb92f1i69DN6oU3T6+xj4wbMlbd+QAUg2ZuenDXs6p14LB7rRb/pBSPOofJ30/XGqpMg6QLpKAUHFCCYreVhOIsbcQ+CMVeydZqJRd7Kfu1dxmXfJGdSb4IJQ+Fr4PZ25WQQvZ4U1JBXEz4diZ8X1pGYXHnrj37DgB42iLokMzOZ4ItVUPAvsikP4Bd6t0XZR6WSnsieYcrVNwZpK82+TJyi1D6rrbSb5/grWQmUTvpG/WML1JOM7+xN8H3zCB7f3DP03fEZoCXz0s+745hM+dccWMPf2F6aqChLzG+Mvea1w6umXNp7fnvjhw4tF/9xR+W3bH09qsne9yTJ11TKxLEfeLSz79DHdl43SVM7gNHdzr+Ylcl7eaJyx9MdPboVdnFLmc2FMj2evD3BV6TSyELeZ8b73Nkrx9vh7MGaMr/aI+z5rO1NLvjEWfNHe1qAZw1d5mAWmN2BaKtpWpwj5DtlULu+CjcYyy4GhYcufOyZagxOhtmzUJ80h9EIj7LmT3GKjtt+e00/fYsoLUq+gEzNs4nna8kWaSU7pd0/IkqZvfHo2V0iZiLU4vPJTGL32PHuXhEfFxU1HswZedmc/GWYWYjDdFhdOhKj12NCcqJKLhcyVE98zBAjkDjn0l/CIBx42tPb92jRJzy9849Gx5/heOMa0Hku4h873s/fvfhqFff/1Dz6+NNu6VEqZhXFoXjRC+c04hhY57JcCayATmMaJ+h64vZ5opKdkDrXXBm4p9CGv6R2+ni4PkjrhzSpWPHDqW9egTo2rGm7a3dvp2z4XvZs/Pe8xNGO7rOXXnmiB5XMFAmt0R2IvDKJkCqlfS+ZDVmFOJbA7FfC/jYDcQ32KfkDb8pd8CwHhnp6WnF/QvoD3OMvSP+Fy659d/kuik3VlhGWcbNbj2i1eaa4qFnQ/ZjX2WdcZOGU2WgELeSc8X1cq6n1GPNFHiAXSBfq+tpFxBYPgSli4yAZB0shM2igyWKFBjOglMtKUCCpeeCCSxri1OalQAg+oorLQqir4MERhMIeYEUAigpULUs61XLvcl80o04iZd0pq/TH+kJ+s7U/3z1zY8/HP/mR+OChie3ehTbpcQ+gSaVV18zvGpg936BC3sVVjL9HkPupdPoOrqeTiF3k6vobrqFXET6Mh2/kIb9tBctH+H/Sd57Rl06u5u3xlky7upVgv/SYyk2jnTyflazNMY4X3ANbDIdVmAldJDqpGBCSXNyvKQai4K5Jc0m/E3j6fZ4sb4hQ9QNAk93hgdAE812lYfgQSB21YebbK7aJHlsiIlggnuy8zUx5cFBYwRRmSAUnwviAi52XwWIDLmNChR5PqkiXu/goV6SSCrom/Rb79DBXvoNfXPqr1+rF12kfvvTz19bK/wXqV+eYlLpRZakDxiQQa+jO+kuOiNjyJB0soxAR/Q/00cMT2cSyiQZZFh6x/wR6XQbx03YYqwzrmbzLpDGafN2sXn7cd4uo07SKrirMwR3deFfz9uvhtm04ajg087TW55hitCnKcMmX4DsAzhtns+Haw7S+NEux7ALXbsPHX7FPaS/56WjE9ctd18wxL3ykXX3eQf28963Vs7+jvjThw1Lpx9/+z39NH3QwHTS4dtXT6YPGpTx865dJzP69k37ke/X5r6WYqlMGiRdRpiFD+ofLAyAOx1MFDFTP4+ZppUFB5eEhphagr1KQuexJd3rPDg9ewWsRcwECvYLhCrZuduNnbuj+VbIqy0DTBKD1JbgIGdoGPv1UmdLeNil7A+lYRezP7yUp93ymapczo3oE8+/wvv3+nV2BM/faQp1Sz7lCHbf2VTVrbu7KNjP2dSn3/nuoqa+8N8wuxhTv8jeYf8E+zJ/qzuzjfpyf2s7+71bVd9+nWNglgJsD26yGZwQsQ0NGwTw/e5OxZXKYHidfCmzwROz/IXn4ZNzdmH7dScR5XVn5hdrUd6sqqpQryFsqV98KXuS56nBke2ivjLij1Tg1s5X+jlDvhryVyKgxZQQPADSibsc4vqyThsQDQxv2PHF/rH3Dxn56JWvfrR9zZ/EhYsnNZTV3jprZvy0ef1G9svr1vv2eem56R2yOlc0xMSMaTP9iD5P15zXs3d30kD6k3wy/BwRY9Nuy8SZKV1LqkuTsxK6D7XQnd3y+yclunwpmbkDqy6ZIM5L02bld6lIOl+qZnt7uBB0KS8QSuBYAVjWlaEBVQQrS0LlTIkqy0GJKjsxXTivJNgjEOpiATo1EryEb6523Fw7MR05nynR+c7QAPbrCKZEA0aAEg0Ywv5wBPcbcti6G9lOiXowJapiSlSaxJQosLOpjHmgRcEezqbuPaqY+rCXMerDrmEHaKCqrDvvAA1UlZZ17xGjN+d3gqgG1IUOUJ8xJ6gFhV2UPqAziSOYzrjTMvLKUWcSCpnOFEBRcbNkVlNzQGWMTGXS2F9WquE+Q0bA4i93BS/k6z7KX4M4JXoumZf+cbwDWP1yG10p0FUFtocYXWm89PFr51ZnVw9deHfzximTr712Y/DWG4ZXZ1bPnfjQJV+9f8v4ujmHviSjhYrYp9+8aoCfaUjVQKEiE+TkZiLdXlxT9Nu3J1r69Ws50fJ7UU3xIkqb6M/0WFUVSTfFWYVKVDGNsNJdlWqlPylRTUrOzBtYNbJB46gx9zUbpXKpn7T1bzIywT4lwfPYJsKUok8lKEWffswu794L3MT+f5OrGSByNdsMCrMlzueBlKaSLr16w6+prmZ/fqduPfHJ/FXOJlTZhz3eiqr/e/YG/FGzv8DPf/7HXA7ZawiMiK94s1t85b7y+P9LZsdUl5q6ZRb7PxHDfda0QUqVCqVRf57hARc8JxBKZ2IvwMh7QSEwGuWC2DvquZ+imNxPKL2ASSkts+pvskCGNrL405xQpqHrCHv5vkqYtP3vE0SmO7UpQr6PerCX3gcVSF7NhtM66IPuEh1MnhtpbgGjAmcOuBRhqzEB4yrADRZmKxVWpWCVim2gVzm5JKLHRtvn6Xf0VdKdpA3oPiGbbqWroo3z65j/8Sp9yhZ5iXxEFolcP/UgZlQiPA10ISxGAOcIekqgTjvsQAp3hxPyWL5YICmXALaFwg5XHCQkLRyG3wK4TJJSBRQFsThS0X0EwyFSI3F9v2R+6pKJr7/9wd5hF4wvOoV5fQcpLh1V8ts3x372RJ4lHyDcCxvnTEkxjjdJzOaR3JUmdx778RlM5jz8KXDPLCQl39H9RaR094g9pLyYHmghpQV0/57qPXKPIc3k/m2Dm8nwYhoMD2mmk5qHbKebi0kN+9wjxtWGB0zr2Of2kYBywaCwOWM62KFai8IGqFCXDGarjmTvSJRSmKnlwExwsw1faW3fULvCQQUhpYU1e0dKS8lzSl5Bhw6dKukgJT+/QwfjD6X+QGFeaefcQFEu8G8YjccNB0xvSF7pWYn3kSrM1rFAOkbQcUB9moQNx1IcDCWRA4yq2CsCR4vb9spXeLTInYMqO11kplVJp0xQNK8knXre3bDbAGCQ7HqTQVaYoWKC/wbdziaXW3UDDq0SPXLYUwuzy3jquA0mF7dX3LLBpKiuzrHIA2YoSDIiiH8ZBBACgFPhF+EDxU+MPW+YVtVQMf7q0b275Q++5+bpxtPVKcW+zOmTrdah3dVKzGWR48Zjclgpl5h9jc/AbtJpL+LYmRoHOUgpDijNeCG0RrXhkL0eCPuQ4xUlWQXskJjXMMG0vWpgbmaKz5WY1D+/W/oE+PwT7POf1T4fBCo+38A2b/b54hlbop/fzsYhJ27WjBTjsfYmhmSRCuku8y7TcsmOu1ql1J/5KbXSFHKZFOxaEipmXlrXYnh2XTtaAekGFv9F7LhhD3hQWTgJU8FJUCXpGTC0rKwMqAcm82xGPWA4a1WJYWVcA7ydXxK8IhDKZG/XlIXzM+Ht/DT2ds4ll8HbfUpC3dk39umOh1U39o092Z55LTd+nWj8AhRlWlko1Qlg3QBWYeZsFhoUl78MC8JzEIqL+UrMfA5Vspv7l0HIqpRd6FUW6sLu6FkW7IK2T/CSslA1u6O2LFjtDI1jHzeFvZqCxnVwdFloKLv5srLgUGdoAnuvgentVKiCgp3CBsheipkZvmpSJjhaodJKdrm4O7s8ZRy7fFHNFYPg8tBh7HL9ZI6KwilH/DzX2PaVoc0r0va9ij9/q+1Hxt5YaLpqwpiZygjTgB69+igN4pUyLMBeDWvzipw0jYeXF5mHBXr2MQ+N23PFdLN4QX7/iz+cGfcavDAPZS/MZN/oiQ1jAlVdzqPxzBq6oqpr6XmGI9pvZxIum9QwpirQ5TzF8cpVV8AvZyxn30aTX5k4Gt6UhI7OM99kek9SELc0TfJLHaVSqUqaJAVNJcFuTN/iWprKDCZLUXPXOCmb7XCEqU33kmD6IeZyhXISW5qSctItRaGUxJZgVlmoB0DTQhLcj0g/cO4GU1zBZHYAlJlwU0CGmkp2uasrGMCUf6LPa853V1T62EFsdlcyM6Ygn1RUBnzwYCoDitlvqmTvsleVPgDedZdXAh9IfuFX1zue6vDO5dXGwdsG+svv6lHtvpAcqXTOsnW4ZGjRiKHsN/KscdFL5e9cnsfeGlR+42xHzYs9v5J7D2NvWTpF3pnfr9rZ8ZJUU0nFpxdWGxecXsA+cU2zYly/9avrF7guuqBifr/WV9gbOyv2yo5ZNt+gtKGVIl9Dl5lmmfuz8yFLeiqmplPr9w9mlCDmtYDo9QCaT5mGuSiqhyDR61V1vsM09msaL5jlNUUCT9CLGH1xggJRQwvwqEDv6sVsW6oazKgKOeI5z2ScyowgzlpuFygCTSarTeWtRjqQQMDgd3MwAbfGsiRn5+QLZIF5S69bgOgCU0c5Jk2bNjl+lI9+eN8aHWtgExRWc7wBc/8pY2on0a8XcuzvZcZVppNSAtOlB4VcoLlLy84CvqmHycWDZNoeZj8gBUp6rFyc0c4uSHMmqcjSHq/XhAetIBebF6PoAP4BcQwVmuLSAD/Bp0I9gg3KE0Jmq6BONPGGK4tDl4JZl0ElMcRKgHcGzVs6C7uDHNr8vfSD+9aIXiFeV479QqaT+uxh/iWiPxhqga6N1gKh99BsTVWRZdzYwvwV+DVaGPT/pRpIr505qw27ZF0D2URHkaLTp39voWMaSPFrL+46RL82Lhh57NhIuhW6i40Lznz4yFMbluE8UrGGzoN1QNdE64Dg8Vmtf1HT9L9WAHnOUQGk1TS1rwCCktZauk6Uifeshzrxu56ga4zPVxML/b068gLUABmfP7NBqwGSNSwHtrulAe9olNkFqq3tCViCgRWr6TqeaEIZWHFgvxqFbiXBgWQ1c2vbwrTJDlkvbLhMUENmG/s3jds7oqrdzLYwpYgkQ6VLQaVPZFAOkAbZNu3qOQPuuGrlv/bPHzVr4ILqEe98fNK0nY655cXKTeU7siMb5GbvhsBzBUtnPPmYhqU/jNnhPqlAmiWeQ6pWzIOlprkCeJZH9qDENKkMAa99TtwwrDzlG/LJ2AHJduUmg2KPA0fSymEzEf863l6FG4mjKpjr2ma0xhncgkAAILEr0HXEaQF3gC/Rm4w15DC7CtWZDcj5I93KtF8/+XrLnIFzRzeemWk2GJ/aNWrg/AHz59KNL4WpRyl6KEiP0RN0172byreU7hg5ZBStM1r/+DjnmcD2uUQhxw6eiHLxKF9IZmYzxTwxBeq2lKiqteFWkYFMpE0vFvwckF+qB2YeUkxnATmP6GE13Rn72djcZTnnZ7v+4rO3y5m10NFKhtDaVsQ9KREcQnbg7EGsC4MYd7NE4sVyl0TO3gGmOiyUOGwLDcdhm0mcFYCd40xsscTHwYV46PBKEB1eUQZvv1qyDkiHyDN0cIO8cawcHhvZMjYyWt7IxuESfbox4xBzZNtOvGAbJxZe2xsdh+v/NA7XBmjsJdfSe+vJ6Rrynxo6oYYq5DTiX0hGdmKwlTejHacSWPNua0uT0+1gpoNqa2k2J+NSNEeXYhqHe0rDzSUN4J7S+J4RJ1ZlYhqCJzs5HifocFxiFXZ1mHQIKKa3RheCPWKWAsIf2TlmFZGgZl6zj+Q9QH/57Z4ZC+btepceob9fc6Vp+9hIs28t/XgP3Uk3ll7VjXQmTmImub7ICF4rbDN8gHWo17XrgQYaHmi1NSdFZ8LL4FNdHONP0jD+dGA/TgCDwH5hs5079y47B0yVADA1mMQsYe85ZiVhgJbD/vHYG1PIeyLvXXHV70R++5m7Lp02a9GKd96qqzH2rqFzUukh+hX9jX7cfXz/34/9+JufYu6LLmPm5nZm943ROWJ4RUQMJFQioFFiwSNHYnNF+7AQr94FO6GNo4vHYfYTepu3Gc1x8arnLMSoANaDnY0a5R9bHzgXbtS1cM7GYkcpzO4aj1jHZ41Z/l/GHLYAPwgytFrPMebAOcfcrit747V15efoy6YlOGjRmw18X7Qv4F258slriMW0lozE/FV/2hd6ttn1r/h1YDkTGG3H2HNxQp9FvKjQt7DdL96CS5G5+hqQnuYPO3ntj1MgzvHeYOYlQ4Ou2cJrLBDF2wSFhQZHgt4ZVBmdIlsXDevlnrdGnpSz59WNjBzYbdoesayXayKrIi40eIxbkO6A18wbXkIOgepYK0/vhk7Qj1O5TLT8YL8P2HY2qFM3KmYYllXFKlLgaGwymC123TyLkbzomCbh6+p6R3umabEmZg17ayPaXX10mSEiI47GfW5wQYeKHfnYmmaJFxyWQiyx7fgomBryNUhmwk3UWLMeBUPq6S+ERla1Nss76FwSXIbCifaJu6V+vO8Tx6JJxtOurFK0dSUw51exlZVxgBgLJOCB51wfjZf9rZcNx+tXC5hE5tcQ11w6kwQX0g9q5oNMFpPzjpEOdOQrtIT0/Yh0vRNxAUqFXDygSwlivWCK3cDOgDgk6DLxUwlOA8SeRfNNM0Jdbt18c6P55oaTANsfJQhDWu2ceJBbnwGvn2sUaJNfLV3bcPq0UKkJNzGFajCuGbtjx1iag1rV2owaZVwj+q2AN4LZnF5pIrd0gu4AZuE1c9NylrmJTABoNGvmptujG81RcgBc9m6P8AXiwVWwqW16qVRDIDpsMDTnM8fYJBddT0eSg420Plxv/LXm9ddrqIt+INfRLpHlct56epPxV44baSpAG7MPz80H4/XKWpAsrgY7Tw/JZWE7nrB2GJYTxQio5QawIkVJf4wAbWTLernX/MhmuQHFB9BJlljZIT4k7yE3jkSuij4Cm8Am+uaNAehvRbqKOA2fIBxn0wCdOHWchNsCVD2KMei6X0g2RPEKrjK01MQiFkCDOccWm4g4VzVtPD4N69OBXHvYHcq7fBO48idwrC/o2m+LL4bsSA440c2WNhCfsB+AWddgqJkwu25u62asF76Te6NQK6z382zA3uPLBI4n2z/NbP+MQ/KMuJh+HjY4mw4pIAbnaj8411mDO3tIiDDQWNeoYQxwD1HgDPD9SalE23A47z6GPUFICPb2ZkO8TZeSQ6/OkbE6J44PBIGV0RqzmHVrjA+E22JcMmQLfWGCJpra05ujcmF6OgXtwuHRbk2tahpJ1OP5k7JEx+BqPwbX344BREHW05063kJNq08IAm1C80msfZ4lmM8kgbGabsU4h8rMQocab0FkuGaTL1VHAc2MrX9O5cRVMLgUHkmxCuAnTwocevE86eADyGQr1HWbOB8ADPQcRiHYTyg/w8Hp175C0u6jP/y6fMaim3Z+SL89fd2VE1pbmThrfI/Qj1+lL9MnwC4sJioxkXxmFyJvI7cNFeiHTZMahXyTRL1/qhVpXJ3GtrimwtB1YdwnmZM6wYySeO7HwjvqQu4kxNmwV+l4T3Y0Dx0Q/wlZ3GfNro1x6MwWc9tuKLji4tNE2tl016Uzrr5tMR1/+eC6yFp4Rqn0E/oZ/YV+wuzD3z4j36RGfkfwCsiJbjG9ZNovFUnl0nop3AEx49gjyrB3AG42rVYOeIMCMNNEnUCId6xhlIZPpxN7XJ0wTgwY4tix1snNjn2Lwd4BvNFSdZviTDTlQ/FRMNkVysCKxQ5QQ5xdFbJnsCeZBcWMAXWbZHMnpwG9TciSyMNh0ZyS6LHBJFhFZT7wDnKYJ7POqQFObK6c5/QBCaE/R5lPBpLCWy9KHTqVGkkmMeVfmTrpuhcf++ezDy+67OohlR3HjVveY/wDr9IP18gvfXbb0tMzF8ofkElkWWptUmQSfYMG46x1pEvzLySB/nbmOfrcqP7eMb6eRR2eI5dspet3DSIZL5B1RwS3yT7jKubPF0kV0kohTyg5yIWQVqZWrmdhipJY3gGCRYmgKJWxGbYYWUL5VjLTkm6gJUDwbrDwWtuEDuzfMtc2xZSoCoGyj8/FEv0OTGL5VaFydno3xzE5lsTIUWSStawcturk6wkPs868VIA0FHmeRJ8gg2789v3q870DzlsfvHLbLcNLt9xz6y2LJo9LGtWhV3Gn3jfPqFmy/OPZcuVFQ4fXDv7HZtlHbCTgutx96tvF789IXN0afm1n821HBrjSHaMcw4qW0Dk3bOkT2HHz4mUcf5PZz4C/mQ/4m2AnQ90c1n/1RRyVfMBRQbt6FsfjZPt/AeI8ni/F4jdj86aNM/naTDqqg0mHDgqb0cA2A3aVPQZVhW/yNmM6zWusnwsQzWcssL3j4UsAywrxW/j3xUK3iO9z/Z++D5FcGutnI5bLLLS/W87ByUo0fBe2r3cRfIMWzjfo0PkGofY/DixcE/IOIfOgsSpa0Ajejl9tIMnd0pTCIpLcQEfXMaMyfenkO2bIn595kSaREzp3QRX6Jlfws5XDmxoCzXZHnGTHFCXbH4KWMnRN4g4FE8oApwAMNxueGzYLO36F/WHnubWQLU6QHEgO/AUGBh6YV5wp5dnls8hmsuVa5gX0oHsm0d2kJ7AbGLJa5/W7kk4hK67sIbWRhRsQCVzcDsKUmqgiANEklKAVnnAo6EYuzaCtLOxIwNwuUOklIPpYArT0gZPuSIiKzXW22PQRxgpvDAnQfXV0HymPEeKuGjqZrKrRxrnMOAttJoEbxgM1sgbB6uTWmoAIRvkoVRpumMXq0D1rq+4oWQk5QfvMJIvJ8im0B9lyVX0VHUEHyaflHZGl8ozIwEgd2iSbI2IMlUxvv0c7qe0Y5P9lDIF2Y6gkd9GFM0h/0mcKXUyGTWGD2Ew3ySWyk1aQNzXvmBynqdpaVeaiHK4S2LkmDJCFHSb9gRAOoKuvYjYuh+DjduiASOJ+scAUDkEEjdlam5caC8EuLLdstqhLIycRu/bMVlzYNg0xFRY3rm1TNcroL8Yni/FZ2ozP9Xfjc/0X4ys0lFNmxtUvr2tdwDcCDdWG297M1jUZMYZTL9AI4tiZnBCncS7ocLsmtwPtDpuOpy5wZp063G4sxg44TE7oYXVryLtqO+RdvknFou821s09G3+Xm+Y6Bu8GpvcQv/FJQyUNDol5nUA3pFW/iCyQqkMhaYjpQHsLVpJqQKRSgYrkao+KxAfWBhlpdl3jWdhIwkKP4iMhTnEyZG2cOk6xPdDsMzkJD5n6bFga6MMn6fNCFAZJkU1YBpISK1Qvp0SCdLkF0+Ug5fgy8Hw4C0Y7kcKoexGO6YQEVUKsCTWD77u1oWFruMYXlSuZQe8155ZwcONBSfR50ntbLN5UdA52gTflU5x2zk7t4+WNPkWfg4JzUCwxc3DpczDzOVjbzMEl5mBXYuYg6KsrtDkgPTc+ALlm6dL6+nvurvFHHwCppAeSr+MAVdckt57cGhvD8UCnki3GN2g2cS/NJMCZRAWzXKaD09mj4HQYTwIaTWERB9TcGDpPhwzBHOJ6Yf+HEzY+MnDOlIYAs+wXTt3xQmS/XHnXna6MPFckPYpdLWn4XVKMT92s8MSREsXviraVagE4ODvi3GLPTJBixtOWX9TMHCZUTiaqK7bBqdt6Yb+tG+jtZMpdN/QfQf1oN/b844TpOLPDM5kNdC+vj4NGXWSHDeUy/zFLTYlnjzg9EMoSxy/vVuP8Sti1zla5CmisyEsI3eoJXt67BslRduoG08GLCILHBJWf2Wo43pMCQboEVwhaYiX0rYJJ7BZApAnlZkFFl8yh3SoDWMVVwUm+eXt7hehv70xM2eCRSD29413Dq62PkYxtJJ4kntnHbFmSNPbpGU2f0efpEwnzF5GZhr2fHf6O/mBY0re4rKpv74Ok9z/pUnp/X7qHfpiRV9uPNJCx8nQv6UjK6Wsom/I/ThjXMZs6Q8qTlghkGhcwmsqcDLk5MyHZxsmmMciVHyuYNK7lEJLIRK8ffEg7R6vVBZMGgsHuiLDNlczjxiEv4su6BJhNAruQxhFY06FkHq0YIRYfoi+lk2yeZRa97yAV1IByJpXliaf37Py09Ud5/8tXLLlmzJqx/6a/yTfPJvXyIxuWr9shf9+nuKzbPOVzotCfvxrx2YmUotEd0kkWMZpn+1/84AOuI+wsOI6c7x2k50UNZTr2c4dTMCqWAvVAqDH5TGNy1DTQmMxAKEdoTGGsYDKjGpODGgONQansUBNcRUk8j+EXetQxRlyZuh4BaGiaGnJ1QCiSUDz4b0w2nrN0KT/nv9EloIf7r7SpPnIw7b9RJvoYGddVvrudPrEzCvQJ5NgkhdNAjsmBkMvcEk7DEGhaqlXw+eUz7cpJSAXtyhHadZYQhXbloHZh3IIJMQURV1MSmRBTuBBB584SYigV2JI6IBm3DYWHKLYhV1pU66DEJgfrQPL/TusAdFEu+EvFq61/8d2/VTwmtqvSSWKLUL5zcCsh14h5hCuf7BH8EwfJWHYd8XIRW/U4x+AZrWHlAz8M5AqnCVtUkFKcnSq0JEtGDVcpmipkm+858oPNRsXiAHAH6BsztckTWtSQYohisxJENj87U9ggfzA/MqSiM+lLqukPf9w+Y9HMNw/RI/SrZZezg6NQ/jAyLJ7uovvoi/RJCAt1JB6ikPjCyFxJyxe2YkxoqjYvYfTYSxD4W+GzUdrGg6KzgfS9Npsmo2JPwMQ9n4y7Taowma03mJii6icNmxbAtWP/UXmUTBaOHNkyl2awDSSnbvsNN19eMmHg0gf+/cWYETy7QjPpv+kPoTMLuo9P6/DjV59/m0I9ut9i6olcF715TSpvvinhgcsksHzBRgDbO66MI/AbEqFaGShNAPIrTKw80h1l+OBVOO1YPh5cMWvB3LOZPjZxv1tj++B8rGy99kYs256Cz1pyBzCqGoPIlWDktoP9EAzMgl4fT2NA5gdBWnT4LW1AsWC6MJ7ZbQF1hR0uQHW5DkNsU0fD0wK8UKfkRH6FaCScF00ncs1N5B2YPBKOpSduaHi0IXC90xYT8YtGnp1Qq8R1NZmImPivtHXY7EGLbnhnP8Z/58i3nz5Kt9FnvRljA8RNcuRekZIof3ox5lGvEGO1SVxK0dC4J4q2yz0GL9dML+99FWi74Cm4AOTVFq+xlgMiucT7NKOj1QOSWrR8ffPNl4675rbrMUycR46c+ZKepH9U1PU8fIT8O3JS59AwLY7l1PmfcgshI2TUzMi+9udZBf60uQRR7f4ir7AXfcFBbfMK0WRC3F8lE8RoXPpozh4DCmb1ylm38URCNhGlZrIt8qs+hiXo710ldB2w5OOxxir+v/L3hIcHMf2o68fz4giazel/z+XxwfERaOPxza1rPAfjCgCmy+kTtgl/D30Sn3Th3/h7wsODZHHU9UN/LwFpib1Vf+rx8YG18fga6xvPgYYLIyMbweMTuqWEcS8bJ+x7NcDVS2fCSdKLqnw8H2TT1QlGhuBHbkAPDcsmbMcwu0KA2sMkCJAiBrMlwa2ltEnbqkv2P+YEHFgrK4qsrEa9i7dEjvaJHLNYTNtPnzYpXP2MI6+78fQO08Abbz3zrJ57Nw1B7s7RgnNScrH9zgr0SlqWORkHLkontZLSuDIMOPCCUmD8jofMgmx2YWYBaiWbTAmJPn3AHM+bD/kcmN6rV163YOY5cL3FvtgW2/vcNoJxP3BUSbnCRkjHPmjkn0Ccvv7cRnhfirnfq90vTZYyY+7frd0vTX4T7/+DMlvjd/y+OyTBa6FwHO5NMVyf/TVOT/b9Mn4exwM9qeGBGpb8wmsJ5zEfLJvZ19Bh3yBqO31M6DasamKWiYeoYAl6rHqHvWgwZrKGJLWdVzuGPLAJQf0DM+vCRshEa+hJdtHQA+WrglSHbfPmcsD55LwrohVbcs8zludEvnvxi1uem0AGk8tW0S930e/ol1O/PvoFUR3yvp5y3eDxRel0Dl3xGd3yHJlJhtLD9A3Sh6RzjnXgMcCa74mCNTyZbf7Y9G6C9ANxx/P0Q5PFHW8p0qwT0cuWxmeUoNlaekFkGvMaYQ+BGXHq51C8SRywbg6oq+B8ymA+ik7HXtloYIPeedmKyaPvv+o7Yp390d0vfzrxsXsffslJjo449n1ax9EFmfQTemoLPXUXifv0+Q/f2cWeFT4T0Al5kdCJB2KeIdMJ+XauE19JMXapV7NL2f0H8X5ul+7W7FJp8mh+P3LV4f2v8fv/+ArvR74FvP8rcX2GpHHbOdiekgS5cJ/AvQ47DDxt1qxafQ47mrG4RBXUEFyKHgDr4FuHwacxpDKlqELmijisVHLq2MQckYNkA6BMFkD/ZedUv/bR2//6+fgDcnnEbZgROUgySAX9kv72e+8ptZsfuv/RGrmytjZy+NDuA0fYODOpxzCZ7SEp0N+VJAksZYfMKaHYOJMcGkB5Kh+ngIaIHWcSh35j45T0cYYcdo05PoYcgo80nni5LZo5etPobe8e/eZGciYy12CPnGF7i+XGz5ceXEZfKsr96LktW0fIPUcNjrxk+PjDlZ839o9yYP6q3K5x2pEaieMmcL6Gcg3vk9QUx9yPz26veNYrYu7freODTk6WorxwuL+Uift3abpkrML9pboNn7bOIydnt+USkHPafh68f67Pg/tiPg85nXC8nwidOqXrWiOOt5Xfv4jfj7xzKI93hTyKOY4E4pyWazinpObhmPvx898V40mPuX+3dn/bz0duUf75Y6Qp0fsRR5l//ph3o7irS/DzD4nPH4n3Y1wSx/9rG3xldv5ivayVyVsvDSXQ5xR1oC1xZ2XK4mJYZZD0DAph6+tN28eeUQT4Pq9PK0e88jIphqbGptHU/Jefjaw1dXXAWzOLfzbXK9N2nOfHYp4/aHplcuE8T4vrq3AsJWKeKYDzmqTF6LXaYGYpAiRls0SS2pUIs4WXHFsinIxR/WRIIcSJJgA2ejvGb+1YsGs3cYzzUBwSIKHJ5HXyuu8kaBhpW70b8OrI0T1JbElx45jRVR2LC+rnRkuLn/154kzvGNeNq+SNMCeXkG+KNEfSy4vFVKBcK6bCODoN1/+HaUhqOC7erZWc/dlUolXJs8eM7lFQXFDXGK1OHq9NBZ6TyMXdiXv2CN6Xq9VbimwcVvZa+Y7t4QmxFC3YrMRU7Hphhw7JCN0I9I5tMnRtxtcuVbe1UQxyePuEnS50nrSL5uySwJ5Gf8gbk7P7b0fKAwYypvF87dJ47QbaPp835nIc6VlZPV2mkNkjGv+kpEKdfUJsvZOF+Ukysj/HI7NNyGyD7m1XiWBGStAxONmZgSOCHCvK7CjdToroVCG3BlJCt5Ejs1Bmx0fLjSi0O0dHUlFaROMBYWPoGTMG+awxmDm+YrsRhEwGjaTvrJFUkpn0IPHTTUIwW0kh3UfmzEShOKrJMZAKza6OnOSJTlmaCniggjewO6/QAxhWFEmzQUX0zVjeQG+LIA3UggIxrcTgM+bkV2o4+FNbz5CCCXRMy+/XPvMWKabfHH6ZbHj7ZXnh6SGH923YKN+0TJw58YidfQHastOZLZyNOp8jzRSZ8kT0IYJpZWJU2S59VBwbNpmNKpkHNaNFe+DYQloLUGEzRTDcDCHeYDyPVWZbASIuuYpLFLltYSK5mPQC37IcfDlRVJLPrcFy1Z81nWQTy0sNRL2ucULT4yfGzvniwBfXPvXo0kf20GFk/rufygvP7KEHV60gR2jms/u2b3/3jTWPr11ErhZ1NieU3opHypSKpOslBMENJgUwSJvAGW5ChVBtU4jcNtg83QnnmMVmleVEfnaznn10CaC/YvZvXhZb34ohHby9eDWUAnxYLohkS6HCHNW1zay4PQjKpqMyBPLLNW9Vn6ofLF83zL4nwVhs44nPp62rVJT6G+6YcktdcNOpvsqUnz7/fiKZsPGR1f8MN8lOkkI6jq29eQ65/cxdoSdXrCUX0KYXXzt2jCQRBy379Hv15NenNRtUKTHtYzOfLbIhTu286cAOmuwsxOnPhn2CzTnvEPBzhPMwI5iXzXZlRUetwAkreeyppaYjpXIoPhlxoqCC1s6TRCGI5wU7uJolxesp4vPWmt0BEc7HzUAx8fwCAD6MgfKrnvb+za98smb5U6vi4mcvmtPYENz4cshqfvPoK6/s3b/5jgnhaabS6kGvPrGkOVPJe/qxp++49z62D2Tu2Lv73S2rax9ZefN9PS9icx7BbK1arKuaJuasasVUhRCjz8Y551j4nPMPtedLwYnmq4LnjE3UjhPNBqpeO8w9R0y00NUk5gk1Z9LZs5UDZcmET5a5y21max4x4qFRjz9bXzt9ktNeOfqKE3WbN1y3+EJPwm2rl01bsvLW6+c+bFT8RStvv3yuT0maPaNuWhdSyh9z3yWLp15ZM7H+ismDBKbjMmMte8Y50Fujiqq8sIo8rarTKlo4AEg2yeeU2dSTrHwZu3hhqYkzNTEhpJWE0/DP0nyc3hXxZF24oKVQkk9z7DLVsGTK4QdvRQy9oIi/tOPWrkbu7NX3PXVvY93cz798G0EXp71wtal09WuPL2nKUvwbH6KvYynIioceRFDF84exedWw8209e45ZgFSMLR3ANJlYEvIJ+FZVIwAMmqBkDmpAU0qwGCQF8/IpPk7UoxUMIMOCL1FE/YLpasiUVQVnH392Ua66dBI7EQ3rsAap6m4Y11g/e83aFRp8oVHhPHWZt1x7BOfQe8pEjk8o+K8V4IPOgSyc1SDqP9nYEzlkq4ODbSfrFX1OhNxDiQNoQ+/63zogaIO1syNo3mkKpdpOOYIZO9lu22QxW91FwQxnU1pGqruoKR3+G2YXY4CB2DUAa0irkprTzJb0DIErZU2NvhL4QFhLmgieXDb3OFPVMIHeYS0834sgBT1sXZpOs70s26BgaLxnWaB/l4GXdJYbb1h0uuGFx5/fQgfkZgyvnlXfVx6T2Hs6GSRnkkvPvPHE3aSQb9Kv7TMcpvQjqtJ3Z3MfwMPW7WHMjwwVUQgbW7epGrkPhu59IjfiRda7oAVpsoAkE0MPdouoUvHB6QKdLTGR/JjjJSuZiIi+J2Pm4nyZHQlT59f983G6lq7NuHTJ1GyI6r8rp0bK6HvLVpOLaNOOvWS53ECn0bqXdTz5QjwztU5Sl0aDpMejfS49Hi1CcHatpNd7zmMTw3BmTk4Ze0BqkeH2socwdfGEObefbnjmyWefbn2PR6rPvPzgvSSLfAVCfuN1Uh0p5VjwSi3aim3Ga42N8ftcesRajNfVfryu6Hhd7cZLzh6vM3az70kwpL2ijs6+se7px4PByBReEh6poAfuvxeE/OJrr+1bBsXhyIdhmsj2tHSoX0nV9nDEx4lje7g3MRUyZV6QbUYsxBJUfyexI8yThP0eXuY8ZEKkAtqMLMZUOKiTgF5GkNE5JA4jaQGQKx5lQ/AcDp8k4HNcUNLnRejD+dtI9acNn/+jYMQbtfRTGiQdiPWnb2iDrNBP6GG6lz4sHz1ORm7rmDvWX0w30DfpG3Q9ZFtqR9EQs1jvEdw5xvnIXXWN8AEh1YLUptAO7nInwdxcFj1yKLDEVG55hFXksFJdwjEChqSw2Qg45eB2gG3vdmlRIwABMLrawQLlGCGlnoXTgtUgNS4h9ucPPJa16vlvaes3h8k8upAc/fk/tJUelVP/SQx39h/V97cvv/yF3F7T/9cIKZB0rvstWKNzuehGtlhb2hbZYg8RL89z6+VvbpPWOwSeN9Ts2LWaHROa27wHJRQXLzpQvGdtOzZjNs2+ackPDc3rX9gOtXqthY+uZMcr21leeH3PWwbsAytk4xuI/DaXi3o4s7GlbVGuGw8RLM9T9fGpJr3B3sRZZOMFFL/VJPjnJTMkueKi42Obixge21ugUG8Vkf5Tz3aUh6FSL7KK7uGnN+4j1wi8Ija+cqbj+WCnIE9rJjSmiERqc2JybpwdSbC1+p00L3QHBN1w2JnZcW1GLuWwG1tZ3D6NsTUTGFtzsMxbAsbWRFfIaOAJV7vZwU/trhWV5cCkBcFkHXepB/HqAExeJTsrd+YbzRu3zHj3NqK+FNj29epXIp9sfLXl1CfvfB+8n56ip+m3ZP69e7OU9K13XvPPsVNHX7164bIHap985P61NVdddBDjI2P/OGEYCXEwcq+eM05lOpMFeRbMGSfrLcDApGWw6sjsombTK2oisX8dLBAHZqUANA0c10w1qAIMWlhKBDebTfpcWeW2EYF26eXGMZd368j82HOlmDVXtk2aWeSZ0xFf/kqB3yWlnZVnTjK26F4426US9TPLI+rCYGuCavuQ3VXVPngAZHRtM9HtJxGbktbmcFZaWpuAlpqGmF3ksHG/aYeWOyFXEBfPiUQOI9c3z52w61KzFuNSks2z2PUuGMuaTeaTkTzGpTRg7G+EuL4D7w+w6z9ArJB5t3C9n9SKMbFMSTJtxvtHcy6mUdI5759NNp7jfrgeH3O/V79/MukdvR9jl6NFzG294Hra0Wa+9cbn+XzpjjbzrTfWxOSWPtfvH2f8PJpbUpbp948zNsbcf1DPXa0yvqHf/5UyT7ufXZ95zvvvF/cPws+P3n9/7P2WIfr9D8R8/jfK7/r9D7S5v06//8GY+1eYnfr9D2r3g3xQ/nB/AZcPm99ILQcHcsLnAH+XT0a+o0sr5vvc+vetNu6Pkdcu/ftWGxef8/6H/uT+h9rcP0q/f03s/WZFv3/Nn9z/8J/c/7B2P84/W5//pZBLbK8npgP6/C/9tO38D7D3vzdt13KH7J3toidlB/KD89whXF8Vk2v8XL9/nPH5aJ4K9WuQuL415v5U/f7LRd6J57Xe0HKT5PJD0VxHMepXB6F3+ucbrahfg8R1Pp7l+PnR++837sD7r8bxRO+/Pzp+YynqYwehdzv0z49DfRwkrsfMF/Wxg9C7HdHxoz4OEtfXReWJ+thB6ON2oY9O/nfwvs7dyPTxN126+PcL2Qb9Acq3E5ejYTr+3TR2fSfK9ydxfQzev5PuIH3x+fH76w18H3icXQe+v3zgBcTrPUQP0g7M9YjcEKk31WnPG3M+AoOajWhLTO7nc/3+cabJ0dwPjqdaPO/mmPsPavcbVpmmxNw/7/8Vd+3xTRX5fuack5NH0zQnzz7oIw1taAOEJoRSoFQK1FIeQimltFBKgVp5lVoeQinIy4KIiIqgILIsolZkkzYCVq8runp98XFdLq4schVdV6ve9XWXRWhP7/xmTtJU2Xv3/nMv/YQkkzlzZub8Zub3/P7C9cnzO3XT+vv/Qf390fXp82P1D/Srfy1S/0C/+rWR+o9G16fPr1R5fqf65oc+Py97fjA/9PmdDT8/ch+Hcp2LzROh37I+Wxo5b8DWNF7Z9zMi9ztDc/kx2/6aJTevPx4tv2n98W9E178Srt/veZyB54En/Px5kPpJkfpV6EhffVh/rH1c9R8oPH4xQbRE6kfTxxnhi0j7Yfp4mcwXR+lvpFLfR8vbSH1OKCDlFUr9Y6w+eR4cpaeRSv9zaX/aSH84Sk8VSv9fDtcXnXR+JrL5VGxUpL7KSeeniM1nHbpp/fEo76b1xz8VXf9KuH50f0j9PUr9n/cnKVK/CjX21afzWcTm83sUnh/RSedz4s/nR+UUfoi0H54fGpdG6W8M63/vxpvYKqF8cGT/z6PzP0Zpp7FfrnSlPrlvWe+3kfavROovELZHtb8nUn+BkBPVn6RI/areYJSt9a1I/areO6C+3EPm4RPVOSNZPxNgXe2Vb6M851wOcblcKeJROlJAP+GFA4IniLA7xNuQVnAHVZHgobn4EodKS/8/ry3lEH+SXmv/xbV9F5Tyc+kFtL76n6ivpvXBJ4PVN4l8LvXz6ZaX8dN6zxtdqJDM2S7ylMl77xo6f8n8WawnsoeGcIoMhE2jh57jgJZBPNm6QBqFe4ww5fpETu1MTlvoHpcyMWY1f2EltlUtlt+sQP3aUkfaQkpbGgoaqrKFMaJoW3ZOnZx8i7RaP3khf7YGO++0yH//kOG+/IR96K/kKY9Grhsjf9lP0N2GxH795Pr6meuzmezOTC5ZvzpmYsq4QQtVRy2z5TfryrDE/JRIW1wJbUsCWxMFrtb7lIEHjNTUpYwdNDsg7BpJ86AK14KMywsMTDM8IRm/mBmck16bXZhSGBc1R5a7sKGqVj5f168PamSM9CHGp0xYODqUzRkI3BA0E2tTUGtUoHI29vWBTKSPvot9M9pNbr4qdmDtoL6prcVD6ix3y1dnK3PMNdI5LojMcTPhSZpEC4pBfhZfpAToBngvoAcEBG+HRqvTkB7EQbh+gCOyXRyoyiPBuSrex2dYM8xOczMuTVqdhG+XHyVvQurKAfhX8vwBKy03zgm+6HtZEYLLzKrItX0NSJJ8MtKMJCmN4dUr4/FEnBFP3h6XF5I3+ZL8Irw14d10HF+QlZnEHyHjGIoIeQBsg15wK29KhtqQaEMGUsjewgMIB3I70zO/mDFp0ozS4uJS7ps5VdXls2qq6b51lOxDZBWSfUiCcxpJNLeuGkn8eXJvNWrs7dK0qd4h97ahRATS4RhUhN5mvk4d6faBBndglC+YTaTgW7zt8XwYBM0idIW0cfYw/GHKUPgYmOALppCawwk53Mq0XqaI1ks0UQMNBEy4yEcXw9V3kI8OBiKQTz7mG4OFkAuJyNXFilqsQ8vbEyGkfbBLovmkEuBLYT4hqlHDKXp2tmQ6neRwDc7JzS+E3ywpkqldL4lhLUlkjqgtkkVpmcH++4ufADxAddPSxgfu23Xgkd3b99dW1pxdWF1TeZR313RfwN89tGvngYd373gEys/WVHLjH7oPCloPLGQFAvfxV99/+OnX33/U+SJefeaFF24UqU5dL8Gnrnz53cVPv/7xTy+8gO/Ejac72ffvP1K+Aw/MH8cC9XfUMZ6YP85No99VzGaEWvDr/NNIRA6EA2pKJiobiiELkqwATTj2RKALz4/tvFldiv1jZXksJyThnW55n/yIm7RTTNrp7N9OgPNCU4T++trB0E6umc/FVlwsy/nYL7/zNF6Cl7oBkGwtO+eP9X7Dfac6RehNoHQm4Dboq0y4MA7iDHiEIJOkHOLd1d0XYCbYHpfD5XGbCB3qCB0Wsh0zaNF0kZ04aNBE3OvB4ySGkZNKSTYvAUyChqPRbADrqFLSNDn6PUPFjJWDs/Y9sPfhx/bUVi2pnzevfkmVwOG3Pun6y2dXvnr59KnfvnjqFORz5Eq4vaqXSF8k0LRTrxHkgUj4GJEivyHq8YJoiCXZerU0REIjgTqynew4AKYiat3tWuqHpAVQHgr/oVUUjzFsNgOcRL7SR+OTfFan1enPcPiH5xpwAt5fs3lzJcSba8RUfvQYbmLPuWnffz/t8rZFeg999hPIfLWQ+UwCm3Asz3JDBRI8FE9a6wmaNQyuTmTZEZMVS9SlGyepJSp2qCGgf0VFLvrJEJBeQUG9BMkA9bFGqS8ZoKjYX1CQTwjrotsxBNswmN++NBFmh9XB9y2bCXe1LF27urGkwpeKL8nNppGT9j598sC4HVxTdeHtNbMWxLvwwQr5qmFP87aDaez5u8l4WlXvIRNKQbMQOB7ZNGDLDOrIm0Dx2sOIMQC1paahmQlKcDOE+CWYAfFIZ1RA4AjRBwfYIPuRJlYdyW9jN2C172fLWyEN93XZ+ervneo5967d99Td9z+1aNW8iuWLquY283vP4wG3Tc8Ltjbu37j15Auty1vWz6+qW8x4iHxCK/AcRCLnKmpzsG6pI1yVhi0h5kBOA3mA+cFOnM/dIu9bgZepqivGd/+Rt7C8Xz76XN+h+as8gPFF7Y1DIOWpJ5gID3VYxIVdBB0yZIm003hQgOkPZFOI4dguuqNmD5RMz2t5S6LDQLNPDEkk35GolxwuZUog81sYDkRNs71FT4sHG7C5DxNE9M2ZXT5u39p1e08sWvjEjh0HF94xZ17trGWWebcNmDSvfHrltMlzePfk9VmeqsLFmzfU7SjKvGtKw87NjbfOmjlpdEWW1lmD14+Y5kiZMbJg6lT23DPIeDer3kLxaCBYiOnZkq6mSMBxgPIAw4llFuMBMPoM5rhiijiumJg7TSaQQAT3NFUK6eLMNp6OOh0irdQoDH8Ko4XUgpEAllyaPKMfMWQc3Vq1Z+p756f4R0x9+CmtJmP9+C0Pz523YP6mtbVV9cLR1iNz2u6U/yL3SpXW588Mz3+ktWrZoqK6bQ2UJhr5IdwB1b8SWh6LIrk+DWJXBLdO6gpyxi4ArqPBzhIzTJg4SiCQPVEQGbekQLVGYoutUuPkGLFo97WqWbOWzSW32VO5+Lpcgw/Pm7Fig3yY3LueyCkW6qd1uxIzHoVZCom9CdcWRGSCY70hnZpm+taBatsUxvkFGybg1rXH0RiUuFhw4ItT0f+1gPkbF8b8pd5V/b32GHhG/fPc33sauKU9+/BqeVcddpcKedU9h6vlz0vlC+QamKNpoH8izz0T3atkdh2o7Qpgb7uRJjqDQDrCarIAaFENsbyhGB0tSCLbsBqS+FCLivBBUKP3eoMOiLMaQLrtEKB/jkzosCMVwjG97YIDygQEZQLZmSHqg1pZrDEs3sMo0SAUn38szsdOv88Pr+GRtDjJ4CdG/yyQ8Xraiubz5N/vTv/moPPxe3fvxAflxfAqmsZnlVnbW8tK/1h68t1/n1BeePREO/lcuurIsBqytkE2fkjh4zPRM6jdiVke23aH4qSYpmZOimAoDam1To4Bj4bsifAxYPKB20TQrOpqN1O8bbMNjiBmWNLQMJawNV2wkG2Tuj0Fk2JpNq2kDBrmm0CeYQYNVs0wKcilhCe2emjgeAbkWIFgXslOdtNYSKDMTMFpktHhTIj4f2N/AWbggJYwCJNfansN3+i5MGTUlfd/94dyruWIK/+rr4qmj/IOm/kZICLLt/Sc5NraOk8c6Tk82v3a+XJZt6RcX2rs4eKoXuWq8DToB9B5yjcUopcpnZT0fiNUqM6hbEAfd8F8OQTFvgZzhLArhtEE0HSyN6QWaYHNF1SrWZpoN2H8Pwhke4NJFrLOUgiJJHF0JpLBq4bOBAdmQpGmSIBZ1Hjak+jRnUSmF7hUFHQQ3jMwkDpaOvOCkprZeGJYBB9ZAZn+XEIyJpYZPVNJjK62Wuw/y49eckIQTpxx4bQ/VTw42bXt3pN/zsJXZU4Q8Fl5YsrXZx7eNWPXrX+Wu7I5Y2nm5LpSbMTe9EHlxTe+La2PH2crvfjjuOr0BByP9YS/2tN7TXVZdZbIJAkoA+Wgg4yiYPBZCkR5wO6j4FOeZCcsdQ/5aDDTjwYBbO0BI2ywEgjn3mgOC7wCMsnHTMalp5FDFlKpJcZAliOV0WyjTPjgTLKz2pOd8XSf9WQBoldiXh4R9iBCVKSArGEgr+E/SzJFgbtuyoUre/CeF59YNC951pR1m9e0LJpVvvzIiU8oz4hf/tV99z36+P33HVx4+4L5dYtrFi4W6p/oTK1I2bJh6/q0soxQ90jKYU87Gjr9xJFTp5/YsGXb+g1bttDzpqn3r/xycr4OICtwsxLRAV4JEnVXlixahvgfdKqBuOzqWEg9z4y3iVSwhJC2ZG97IkWCScRamiImjdkCKTJaDGFcjQyHIQ08FtSSPS8cQBZIgnD5Dl4Xm8wOI/+IXEkZP6dmi8lHTyO/JOaGj11r05K5LU2rtrzxLxV1zyZOUx3ctOee+ncO7J5x66QJnKVsQCa+/sD+R+97Sf6sXD5/z4bPH3zuyWM42X1i6qdH7lhS0wSqK5qP+jiNu0xCqWQ1nWRx8EGk9fmCyZquMChPKME5ADxIEgilmLPoRzMwNO5I+GNcP7QbI6MOcLHMVFzvgGAoPkYMxC4HOR3LXQCACxTTP5nmpiUMGzNrp6RSvOdkiVm4g1lO8slG+LggNkccCGi4HXW7ZGF20URD+ak+wnmvjneKmtr67ssavZB1eNe9jz5xb+uhXHxRLl20oHrxwprXCXVc/bKe77xeojJ+uap7Cld7rD109HhbmzyhvJyrbW7ZtG7DFkIrc7nLqkqyvhzIC7s1DfoxEwkgzdOePmiID1JJi2SZpVGXUyehhEwvmYcAgiWFSb0Msvv4KOaSTaJBVirI4y3RPN5gCfeSj14jBXMfRHiA4TB/MTS0KqCSnuc1BnNiGvglJpuCRglmxkuW28DMwR663MyYiL2qGCnZPdgzjOUMZmE6wNRAukaFs4ssOnsKRyfMIUG2LHJO5zp58meX5i6sD41uXDnrnvr1s1OnV08sH72ienL6vuZdnK7l8sct5YL4WcllUeC6pznWjR41yDXntmmLHVMcIzzekVkDhxf55zZy7/cc5ap7PHj3ez3HuJo35XpYazruc5Wd6oziIVqecsdaPZk2JFJRScl0BKISGasXvMZZDJVK6mpXiRFfDpH6cohRWGtKHCT1CZSYD1NcPORU1JusMDmMyQbvP/zzweo43aVy3NJy+RMyMDUdmKp+2rSeFm4reYXHcf97Pb/mFrxFxgH6SYRUVyAuiCbT4lBd72Vhl1CM7GQlEQ6dOv0kqymHHsukr3hgVdOoQK6z0ZSd8V7YHIjAEtLQAorXkqAD4ORYOGUBvgAeMgpqY2HzhM+R5Hw2E+GrGOqDne4OXK5Dgsg7dd29/7nvwI+t3a/nHC/denpGce3FA49/v/0rrsz764rn1nOmZ1HvfffLPU/Kh/xFd2zOOrjhIaz6EVv9havJuGyEH1lLZHUXP5O73tNB3qdA4jajiJrfhnGnkd/fUb0Dv/PTlN+3099X/x1+95PfO0HW56d/j+iv66gNaSaf39NBfq8kvx9n7fNZyvV6GoFZmqz4dAsGcrYnkL14sbIXJ8NeHPYQE8jzIhuQIES8Z6h7KKMBcLCETVaTCLAQBsmeRpeFM5kBSAoSQ9KMMQGupqSI2izXYdip1T8CGBtOCJ88JjPLt7d256d7z9VoHjyYvy3n7rvx9sfk3mNPdiy6e80T3w523Td/zQsNuOE3eMThTydP/OZzR8JCX88l+ars+/zcqV2H8BQsNm/eLV9l8g0R6wSQD1VIR3ZdxumKSigKBgxRPbAXIkguGNIhcxJ1GPH5AS0vw4FcooXTTueM3QZ+nbwuzz9a1Xx9a16NkPLko0rMFacy0DXmR31pFUQcWTHgIdUvs4IASWdiI5ptSQGaFQrqunfLnDp0bYq67NoJRH13OaGT4i4OQ33hTaTPFKpD76FayKAmhukGRAl0GjyD+zNrIRehQwuMczl3oOcuQerexK3qWctfvHFILubf5udPrO5+rXtiNblPA9cmOLnu/8Fe0MCHuDZqX8jo/YHwipsJH52G2tWUdSYXAZGQpaej8MfqiKxNwzycOOM6NnDJ1T2dK+QveGNFDxITfmrkU6jM3YwPqVIFHbk7yNwzEXi8xfmok6/LC45MQ5ifL8RwDYs4gcbTnFl9snY8sEbaOGvKQEqHDsgBoDdFKyHtkZxx6ZmuKJkzl1Kdqg/PQ2x+amPV3nEFD1RvOv7UxuoHCgr3Vm46vmjJ7JKm/DGrSmYv4Ry5TdMr6u+YPb2JO98aWLr+ruXBe1oDy+9qXhK8Z8Ga2tWrFq5ZsHTZ2poFaxQ/NUG2cJ1Uf52P2s0QH8oRBpBTTiuroCBP0SwHNipWGRkWBArqEexSKgUWnPrwGR1Ktmwri34Qhk/qxBnDsocOXrBgz4OFufJmE05TcXirvlK/49AN7o2XzRAzgzsFp4DImhhE9k1wGNOoIQchjdiJ8QbSPXQbzST7J5X4AHsH5jica9AIkRnkaNXnUToT84LJgDJkHcgYChv4gccDj0UZK5anlOEMpbugs3yksK+sYVlL/rLFG6tHLh27bOOqxzYsyFkzcunGW+6cu6FmRRMrGdaEX6tekTR4VP4tNY3FefnYX92Qkp3XAl9GwdySs42M6xoyk30MFIVxLJNOrJcQMIjbKjWjHXI+WMPkbHaQl50HvRm8XOYGXP2orOVSHpjUgkfJRx7D13s+3jWlGV8uxUWlkOPwaqncSeTnDCzC3tuAMLkn+Nmk0j13CUI9s/uVO/rKYa8FfxLVa2Qf0oKmSkU9KWMUT09tDA2lpNGSismIaVEpariWX4tfzcGvyfk58lG8Fq+Vd3Ifc3/uGdDj4D7ueYyr45ZHcq8L+UI+6HgBPlrIv/EavKhemGz4qtFiqjETTaLy3SSuLlzO74kqnxJVvimq/La+ctXVSLmLtQPXCeciv//lJr/fBr8jGyqTN6vPqv5K+qhFsUQOhzXvJqveh3LRaDSZrP65qAYtQo1kxlqIhLAd7cTnUHsc+Fe3+kIGPTIK7vbsqnsgBx/h/JN0XYGxXrLxdAwdMX/NQCJuiTFdHYOHz7tzoN0bEvRgrQmsgvyOgY2+EKaXBzbBrhKcvJiwQpm6ruCUOq+3Q5fp0LgDW3yhGD2KI3W2egMzPcEyHai+OoaNXHAXtG0mbefk1a4jbQfMxpCJNd9MaOteUEN3IJ3BRH6DVPAdnN5ogz5oqMWIiMJgfQGN+UBbV2CgkZ6dKbaujqEpgzTukMdGe+bxBIb5QkPZFzLCFGNwDKk3hVxS5u2IG5NrcAdG+kIjbLSPo7yBKcZgDXYHFnhD81nZQm9gOtlSAhW+YLGtKziOXDnfGFxCpKLlNpoqsAm7OzZs3HIP9HONpatj/d3bdsB41hhDa1lX13oCd/mCu4At9hCmzpGZlA3SZs10QpgTJxBGeH4x2ZEW16+kclUmxDqMyQvMlALFeYEy0/MpAwfFT5gIVxjANjCugiZCas9fuozuYAAwogblhQOcfXkJXoRXtPY3FAEL7UwHvbZEzp7wO6ndFyhDarrojh0JlHHjSEXKhCtu82YfqMhIseT0993TJ5U1NDS8Ir9P/m/Anlf2tm7auKN106bWTa3kXxY2yD9gwzpslL/Dxo9PLF85dPDoYcury0pyMiqLCocOzPaMvoQl+VssHXAnlLfcUT38h9eWy7/Hw5bTfy64fu2ry/khtIWdOE7+HrfiYQ1ne04/ePCxh/YeOrT39dd/d+P55aLc0PBTA3278T5XMn5mzgSNEDth5Iw5de6Mktr0tPTkGy+yny/Uacrxg/Kd8xf2HHtVfp+Uyb8/e/1p2tXWvvvAmVomn1W3kfOGRymE77GhwCBPyBSDUsCg6fZQpQpwCbw9DEVtgIAdIrBEpF5zlC6gjG/jT3SXySdLj1QWjM0pLhv9h8Hjbp/04pO3dc6/tahwUvH44oncEr6tu7x7tqq+ffooj3/yiAkrS0Z7vONySjdWtD42sltbUDxp7C2TitleVUmYMwvlbZS42xBWoQ0CqAZZtKSgQocFNw141oMGCVyZ27VUc6SNoeqidk4bUR4JYZuyz58ruSD1sGS3Vra14c62tkKLSmcdN856/aqlkO5Rw+He4NvCtzAfFvlZ6ksCfZofVb6mdzYtt5Lyqr5yXCZ/RcvJ4cONAB9apf4SVt77BSn/FfiqKPWr5Hdp/YGk/DbAF1DKy+XeSPlU8J1UymfL/8H6IxfCHCnlIq5UfIvo3KlTI/UrUJFSfw9/jMoDrD9DuAbqz/Ehqf+GqCP8fwuZa7hiUc8bvfv72gKbJlzzj8f0z9VDGBuFi/xu1Q9IT3ZzONIEIqELurD6lz7OWMrCYSJCYpYSVUNESIDUUROJOqAD6RFH5w/Exoq4JQ0rlkLKwA/2HVL9sKKqeilLEIjxIeEcV0voXEtOHrLJw44fCzSuozyUytqlQBBg/1ic67MasBofso6IWRk31S+cMw75l6mGMSdvI+3skkdzpb1bWTvMByDcDv8BTVyntBNuxol3JXhjGu0zskbIU0acmmwofTaftHNAuMhVi46b9YcMWnuz/hywzMz2J/lF4aJhaiBfGvW2j/ALJ4V67rjqZWQk0tkkxd8D8ndDSl2GKisaiZxBU/aKMSzIlOa/tFIwWQor0s5LCXSL5lnqbmZwsgIOPdNEZKr8I1gnTt5et0nJvYt1swc2pS7JEb4oq0vOpVl4aVb3AmPHNtP4QCG6Kd3c9Dv4dyk0uoA/rtDoS1E0Df6gu0BO694uXOxtEjcRurGiJEo5PEPaIr0HKT3WYKWnB4Ye2+xWZ6ZLVGewSRTV3dt3z1uy+O7xd8+Zczc+nu0Z2lJ5u3DRuKOldaNx3syZ814zjiieZVxHsRG5GxeEi/LL5F4adi8zEQLD99KbaYYnUbmXD/KiOjPN0Te9caHFM3jw+KbavluKDcby8aOMi+SoWypjWi1eI2NKJc9QGRMkMjWKTD1h/yBoi4uksjeTZWCzg63MKKZQGYaO3MpiMlKkoDn+FzOA/Wz/jsNOl7Jx95uLY+nDy6q3ChN0BWNHeVKjpwS/V6wpLliaPGNrTLorIxGewWoyL5fVRjIr6SAfpHmCCboumrjERyUFsycS28/i161GmmxVR1NjdQWtIEVDbwM66XnekJCYkk6RIpnOEQXNEJAk0jxBNCcwhPYydetQzpmu5qMH1r3aMHeaa2LBqOTJ9ikx80tct94yKnF6Ql7UpI9ecKfL49q0eMUgz6DN8uGoqSdj2UnG0i6eJeeLFTKOw06k/sVOZLvZTgS7ULtOLzGlEITlRe1HwE1EVm73zlLDvIqKeXHTU671/Dbd523JWOlWvTd78uTZV7EgZU+ZJ/nXZVCa69efCf+r/uCIVVUtdegMkpkp2Pp3iRHqUNyvS0NbfJlDJ2TfGe7SH6XqvDFSRnOkP2qR9CcZNd28P2D9jxMjwYFKtyDETHnuoPYzSdSOGu6sDSZPH2tncXQdgi6OJstIZFatAWQfCpqslAD6db8/ERMajh7GtvSR06s3iUW6sQW1rvBYLhdrSgqWxrsrY5yZBRHaFQmnk45WIGDvk8h4kqjhMQlCmFO8NIcao2RLWOallGxnwG5UErcZqWYBAmFTpa6OmNQUjTuoJ8SdEi+ZQpo4C++gS9NCadnUj5ZH9BFzXPT4+mh5SHZMFDH7owYp5lBqLspj5FxLR0n4otFyIYZtK47ISEzXEusB1QEFRBQi2QRQkFPintRSEOnCmgJQQ/sYT+0anT5s6a2TqvbXlY90y8f1K4obC9bcP3uhkfFjOfIeXEJWvQENRqBa4pQ0W+QWiqWByDQB0cNSbHEA8WlQbkIttuweOUNctRYaRtWLTBseqYbAqf+b9gsIUTspHogftQthzMEOnYA1VM8HN+LJXEHYLRyHQaymRiGdgklipkpqcP5RFeD7y2v1cWnyJWE3zrpeImTtPRQ34HMUxsEQkoQm6q93C8tORvPNAEUJET+pqGBT0aL4SUG2EC1P/aTionPDmCiWJ2em0aQMuuLapUtXr3384d/qT7fjJWdCwVNcDrbiIfIf5G/I33s4B1u+7cZf//g3lgPKRzpmF6rJ2NPZ2P/xgKMHqvbhB0sXxrpmXOEL8YAbR7n3tz2TMV7JHUfa5NvJOOPRFEVratNS1bpBiECtSYQjl6iZQIoHM4EUVnrCzoAohh2oJLVShxijV9Jl+/FYTnFaCkse2O6w+vDORzfmHtr+0lH/8z+2vdV8Wn6Y4y5XYHfTplXFyzbcU/TYc/vWvLBL/pqrYf3Llvfx7wqr0CBUj0BjRSafalC0VKGVAPr/LNpJJ3kUTmNgACzuOEsXoTlAaWiPo6DbcTrSWarh4jMZLrSOLB8nVVsHU9OovoscwAMoO2CPwl/rA2ZwRaNVUOA4V3bZ+3Mv//tnHx0+curCc/ctD63MmfVd89sfPftA4IzcJV//+Pjzg70dv957qOa5h9c/lF8y/taZvz25ozNRtIUOnLsyk9GZXX5aqKHP1ARnseL+pvmZ+xv4aXEa5tiieMGZ/hsvOEvYC87Y5wUHCHjM/42QRYZDMuY6RbWdu3BXd3d1Tyu3zqCxL8oYz1/tTi6Xt+KWcrwXZ/9hMI3B3iLvE3hhPhqAViHq+iaEXd+gX7EKnrRIMQ5hR6UecK9eb+zvARf7z3vADaAecEjxgLNHATBHPOAAuw/Uu1uWPT3/lS8/fXXL/WNGca/0HB5yqOIrHCt/eXX57wqDue53nvt1p8vFPV7T05386RtXrrsHEd50K1nbTrAzoQQFZ+wZ/goZnwhcIqi4tcyz7KbuZB6+vefYaq6S762ZdP0hVTlpr5m0Z1O9ZyTXc9T2TebLKKxBiYRq6xAo8iVyCMV7gilM60o3EAZ3Dj4jSdRKGbB4IU6Z6rqTkAIPEEiXQjGSNZ45WElKCrN4cIcIZoL3rdpqCduvqPmKGlkYZDUyR/lbwXFLtd9NP/3rAx+u3i9/fK6+wr0u7e843qif9PaKdz6rO3l08W9un/fU8sMvcfd+hI375Y/elD+RN3Qmlhvi8GJcXnP7J/92MlS5b+rqd5sYbv5a2SLohTJCF1lou5JbIU3oYshaeqRY/AFalQHKuGDc2XTcybHUOguEKjq9XpogkJB00A2WW6RQQ8AiEflMik9Ucm7TOWAnBuC6x5GhB11phJEWVfH2PuAguy/XJ1kibmf5eHguQw2iig7Jr8AGffTNatFU9p/vXj50/OKRM6K45sYH39R3PPPGM22dgdOcBZvxkJOP3njuA1kuWlrxZsi6ZsTLeADWfd71J4z1f/vTNaTEKZE5gDgZXonL+imqHOIglfLZf4suP6eUE5keT79ZO/wDRGxC/wU8QNRUAAAAeNpjYGRgYGCUnDVNO3hbPL/NVwZ5DgYQOM22xBdG/7769yanPEcSkMvBwAQSBQBRfgwMAHjaY2BkYODo/buCgYFT/vfVfzs55RmAIsiAeS0AmmoGxAAAAHjarZd/aFVlGMefc857zr2tESIrG2OYmMhNZMgaojakGDJExIZIjCE1hshkmIzLkP0RS4YNExmSiMgQW0PEZIhcRMKysURiXcJiSpiFiIhiERJhc7fP89xzLrerY/3Rxpfve9/z/np+v6+bksvCn6sR8YH3QEb9azIYrpDVblhGo6zsCc9Lvzckg/5KaQPNbqfs5Ntu74K0+Ielw7srJ/2LUktfL7gC9oDtYAU4BPaBHrDX5jEebNJ2gmC7rEktYt6USOgk7/6SgXAM7gb8Dq/y+7Lkfdre40Kr0291ko/u8m0SrpcBdzZmxrkO1l0lVcy55EZEUkul0W1GzjXgOHIclLN6ZriR/d8JNhZm3Ig35Jql001ILpiSPrjPdUmfv0PqXYOsdBck5+XllJcvjAS3rJ1LLZCc9rtxG5/TOUE98y/KVv8sOrkgp4MzyHRVFgczslrbwTj7X0OPW70ZuFXlj3U/Rvsa2Aw+MP0xxi1BphFvS3RKulhzc5CVNpuD7rXPSeFx0CMHrG9cmkDGZJmUXNgse0zfo7KC/k3+bdnA/NbwgawDz4MMut+oen8WomxhVm1hdiiD7wqXscWX8C9wGF6UhsQOleBcfcpqi3KYLbCZO43eVO/PQDQhnWaLrn8DG/yM/nfB34D77ohkS3aohPqYMrYoh9rCbH0mllf3rGRkt/3nYPNRbK7ym7+ofrrmZ/Vn9ak5WX0YeWCB69DzOeT8BP4N/gF+WGR5Ez0sh79WfwxmJR+M4KPEiPqpxon6qkLjhTEfxfxezMX+m8b1/E6rHW3vSnbiJW2z63jRruWcapCB1BHk5PwaBzH3xPypxqXGxpxMzFrcVLD5Czb7r6zxrjGnPmb2jeNeY6+S/V7OOSyXEhnCG6zxUE6b/qYKj8wPiQP1xWRM5Xl1rJchT4x4KwxZbxm82rst5+Ber0vWw3XA909Lv8jMxyJP3oDfhon+mWq42434CxnTpP6ncesmC9ejusJ1vx3OFK6HIGrld7bwXSlXKoalxnwLmdR39JyaKy1PahzHedKtl4zFYo62xt5O8hAyqH6iWuKEHMn3/qgRvRDXprcL5LQT5HPs7mfJUROAPofPBNPMHZOsfg++sBjLuUPkTMaZz0Xob1J9qzCLHYrxeAe7npFxi6NzrK1nZ82wh9/1hQeccyy8ZWsEtlcxt1of61e5LZyxMZYXhMP0xTVD7aJy69k1BlJt5P7DjDnCmMOxDs5TF3JFvbBuPtFhuEZe0PWiZvr3osfJeLzO6411GOu2pD/dU/XHmon+dEzYIbl0teTTi2i38G3Q8kTe/SEb0mvgc/im5pej0u/2o8ft6Gg7eVtzQ5tExHAL58sp0FsOuWrCHfDtOMflrdZYnUJ/GasxHbSpMe4K30ap3d8Tp9iIWp4hFnLuIOMfSkvUSXtdcS8D+UX3D35lPj4d17j76tNRn9REt6zG1dk5puJ8qbVvgvyO14adyHJDFqc2Iiv9YUTMzSLzbdNbLjyAvW9IVWoI3XWxBrpFvqXqZ2rrUkxdZJ7aJObnFstAeiW5pZ3vN8gtut+SmNm3lIunuXdk5SfixoE74EHqnmRSY8g9aXZWXTUgf53ZTOs09jadO2mAF4bYytWir27k2SdRfMYWp/lUc6Pm0TPGq/DrunA5Nsde4bfMwybRW+ZjuXQnMl6N8+N0Wb3AR9RO5fnI+DColtURfs2+GfUbtV2JW1n/EOt1SXO4SJoSVh9XP1VfocZrXOfUR81PLhfPVOJ4LfNffMjyQkWdS/JbqT6d5P5RxsleJb0MwGdlcaLfhOeqC+r36nsaJyZ3BSdnTOyi8WI+G9vHnSrqSePLfHyCWKPe4pt7onvwQ2mLqmSLO8G5pmVbSuN1n9SkkDlVxflucQ7Ghd3Y7XfssF96NWclOivpQcdzp0vqRyXPeU8ocus83+fn+e8Pw/Cuub5j20Hi9334K/izuezxf/FT9TeunfPxU3FQwdG7s08c75K0vk1ipm6KD3vbLD+Lv5D2MTqmxP70PpyAOW3pGHq319psmJAWZb3TKwKRFvyy3+DLXe5xJ73PyT113Jv1zcNbyK+mFlZLa3BERuXP2fP+y+w1LqtALWgBerduBo1gmT9r7x99I20ObyLrhN1BN0Y9vIVEetO1xO4C6QinyJHUWfdIdnAPfwm8AppAu96ZtaYzX2vMNrvDdsmy8Jj0+/fElb+dDKOMb7Z7bL1rKiI6XoQU9bdVYXraLe3g9ZhfBGv93YW78KsxtL+du0F7sIS7RvH32oTJrwu4Ch4HB8DRoJG3VDwnAfeZQZG/fyzyTBYMlSHrnZR1vElWKZBnvcrrT0lj8Jj3WL285oZkEfJ+aG/HleTuYeqkvi/RZfL/D4RDy6YAeNp1wn9M0okCAHAekvGMSM04UzNTUER+KWBIgMQZh/gDIlJS8jwfeTzz9cwjU7OOCIE8Mvj+QDTykPtOyMiYY40151xjjjnXnHPNOeecc8455hxzzjXn3vvj/fv2+aBQKOr/dKC8fzOjCehggiRBmzCYEE5YxWRhhBgNxoTxYvZPEU/pT20nchOR02mnuafDWCa2FevFfsKuYGN/1yShk3hJ3qS9M/QzbWc8ODxOgtPiAFwUt3dWeNZ4dhWfhTfgv50TnntwbuLccvLXFFQKPUWTYk0ZT1lK2UlFpVJSR89jz1efD6Wlp7VfIF/QXwhcOCQwCTLCJ8LxD7IfAum49Or04MXki3UXDRmlGbqMQMZqZmmmIjOQuZu5m0XOsmXFL+kuLVzayx7InrvccHn+ciwnLackZzUnfoV3RXIFunKYm5PbmRvKncmN52XkNeeZ8qA8JC9EpBK5xAqigqgh6oh6YpS4TNwgxohHJAwpmZRFIpPYJBcJIQVJ06QoaZm0kY/O78u35kP5nvxAfrgAVWArcBUgBcGC6YJowTLZSobIHnKAHCZHyIvkNfIO+aBQU6gr1BcaCm2FrkKkcIuipmgpHZQ+ipUCUb4XJRalFmUXUYpKi8RFm0V7Rd+pidRUajaVQi2liqm11AZqC3WbGqee0JJoBFoujU7j0SQ0Ja2J1kbrohlpg7QR2jhtijZDm6d9o3PpHnqAHqZH6Iv0NfoO/YCBYuAYFEYpQ8yoZTQwWhmdjAAjzIgwFhlrjB3GARPFxDGlzA5mH9PKhJgeZoAZZkaKc4ufFQ8UO4u9xZPFn4vnSkQlayU7JQcsFAvHSmcRWUwWnyVlqVjNrHZWN8vEsrPcLD8rxEaxu9kmtp3tZvvZIfYse4G9wt5i77OPOXqOgWPjuDgIJ8iZ5kQ5y5wNToxzVEoutV9FX227+oVL5rK5E2UdZX1l1jKozFMWKAuXRcoWeSgelsfjtfGsvBne9jXqteZrwWt7fDZfyJfylfwB/hx/R4ATaAUdgl6BWQAIRgUTgrAgIlgUrAg2hIlCvJAgzBbmC21CSOgWfhLOCOeEB8Lj8vxyerm2vL1cX75bHhdJRV9EX0Wrom1RXHRyPek64bpZnCjmi0M/5v4YrkBV1FWYKwYrNit2b6TfcN4YvRGX1ErGJYc/CX+ySdHSJmmkklcpqVRWNlW2VXbJCDK1bEu2Lzuuaq5qr5qvWqpardqu2qs2V2/WMGv4NdIaVY29xlWzXbNXc1grq1XWOuVouVSukpvlc/Kv8m/ydfm2fE9+KD9RiBRShUJhUyzdTLqpvOm5eaDkKl23km+13nqgwqk6VS7Vger4tuh24Pb27XgdsU5dh9St1W3V4+sJ9dn1tfV19XP1X9VJaoXaql68k32n485UA76ht2GpYb1ht7G1sbNxsXGlcaMx1nigUWmmNJ81c5olzfrdjLvBuydN2qb5nyt+nmnGNtc2h34h/PKlJadl+R+1Wrx2XrukXb0nuue+t9ZKaM1tpbd+bp37VfzrlG7ln5ttnvup93X3p+/vtFPaJ9pX/5X0QPPg6N+mDkyHrmPhIfXh+MPlTnSnpHOg8+C3ht9Cerw+Q5+v79bPPkp8VP3I++ikS9T1rGvucfJj5WOoG93d3pPWM9nzuWeu56S3tFfYq++NPEl/0vDE/STWx++D+jaeip96n+4+Yz6b+V38+7bBYLAaIIPnOe65/vmMEW1UGwPG+Av2C9uLVVOpCTCNmMZNU6YZ07xpybRq2jbF+9X90/3R/uX+jf5Y/5EZY1abp8wz5nnzN/Omec/83YK2JFkIllwL3cKzSCxKS5OlzdJlMVoGLSOWqOXQirbird3W9Zfsl9aX8wPJA4oB9UD0D8kfszauDXmV+Mr9Kj4oG/S+Tn6tfx2xp9nN9kF73KFwaBw6h95hcNgcLgfiCDqmHVHHsmPDEXMcARggGcgCyAAbEAHVgBrQAd2ACbADbsAPhIBZYAFYAXaAIxADJoNZIBlkgyKwGlSDWrAD7AOtIAR6wCA4Cy6AK+AWuA8eQ1goDcqBqBAXqoAUkAbSQXrIANkhDxSAwlAEWoTWoB3oAEbBODgdJsJMmA9LYRXcDLfD3bAJtsNu2A+H4Fl4AV6Bt+B9+NiJdaY5c5zU/0vm1DnNzlHnJ+eMc8EZHyIM5QxJhqxD0aElF9ZV6tK69C79sHhYNqwc7hp2D/uHw/91MqIYCb9Je8N/E3JnuzXu4FvK2/DbyKhyNPanzoP2eMcSx/BjnWPGMWDMOzblJXpVXqP3k/er9/Av3V8TCAFRIBpEh4wgfiSEzCILyBoSQ2LjnvH98X0f3cfzSXxKX5OvzdflM/oGfSO+cV/IN+2L+hZ9a/40P9ev8Rv8i/4V/4Y/5j96R3/X8u7zRM6EbiL4Pv296X34/U4gPVAdcAZmPyR/MHxYmuRNiidbJtsm1z82f2z/2P3R9NH+H3cdMUsAAAABAAADsQCKABYAWAAFAAIAAQACABYAAAEAAc0AAwABeNptkD1uwkAUhD8CRJCCgooiivYAYAWuQARNpBQgegPmR0IYDBGCmpoT5AK5Qk6QOgfhDMyu18hFZM1q3tuZefsMVJhRpFCqAomQ8gJ1VSl/4Imz50VqXDwv8cKX52Ua/Hj+yDN/nv+y5sobS+bCXjgRMcUIoepQbELMhqPmWdVCXcO30OGVttDyrE1T3b7UsXQr5Ri64onc9gxdfqyJAR/qRWKGgfprdrzf0w+6GWtrq9z/ozQ57Uh3iXpprtEbAvemzJV5WjnPUOfS5WQzjGaGrjN3rsi/Nv0TY+1uVC3cRr27Z8CWTyUl+iLta3fPu+3OwQ16+0YLAAAAeNptmAV4G0cWxx9YUkzBMjM3tcCCshaUOOQ0iZsmxbW9ljeRJVcQKjMzMzMzt3dlhiszM95dGW/haaz0O+eL/m92d97v/2Zn99sZIPD//hqAAfg/f3yT+4NAwNAEIQhDBEZBM7RAK7RBO4yGMTAWxsF4mAArwIqwEqwMq8CqsBqsDmvAmrAWrA3rwLqwHqwPG8CGsBFsDJvAprAZbA5bwJYwEbaCDohCDOKQgE5IQgrSkIGtYRvYFraD7WEH2BGyoIEOBpiQg0kwGbpgCkyFaTAdZkA3zISdYBbMhjnQAzvDXNgF5sF82BV2g91hD9gT9gILCS6BQ+EwuA9Oh8/gcDgejoHz4Cq4FBmOhjfgEDgFmzAEx2EYjoSH4B2MwPlwNfwA38OPcDFcB0/AY3A99EIfnAj98BTY8Dg8Cc/B0/AMPAufu6P3IjwPL8ANkIfv4CR4BV6Cl2EQvoSv4ShYAA4shCEoQBEuhBLsDcNQhgrUoAqLYDF8AUtgGSyFfWA/2BfuhIvgANgfDoSD4Cv4Bu7GUdiMLdiKbdgOf8CfOBrH4FgcB38h4HicgCsg4oq4Eq6Mq+CquBqujmvgmrgWro3rwM/wC66L6+H6uAFuiBvhxrgJboqb4ea4BW6JE3Er7IBf4VWMYgzjmMBOTGIK05jBrXEb3Ba3w+1xB/gAPsQdMYsa6migiTmchJOxC6fgVJyG03EG3Ag3YTfOxJ1wFs7GOdiDO+Nc3AV+g9/hI/gY5+F83BV3w91xD9wT90ILe7EP+9HGAczjIDq4ABdiAYewCPdgCYdxbyzDJ/ApVuByrGINF+FiXIJLcRnug/vifrg/HoAH4kF4MB6Ch8Jr8D4eBm/CW/A2vAevw7t4OB6BR+JReDQeg8ficXg8noAn4kl4Mp6Cp+JpeDqegWfiWXg2XInn4Ll4Hp6PF+CFeBFejJfgpXgZXo5X4JV4FV6N1+C1eB1cgNfjDXgj3oQ34y14K96Gt+MdeCfehXfjPXgv3of34wNwBv4D/4kPwjn4ED6Mj+Cj+Bg+jk/gk/gUPo3P4LP4HD6PL+C/8EV8CV/GV/BVfA1fxzfwTXwL38Z38F18D9/HD/BD/Ag/xk/wU/wMP8cv8Ev8Cr/Gb/Bb/A7/jf/B/+L3+AP+iD/hz/gL/oq/4e/4B/6JfxEQEhFTE4UoTBEaRc3UQq3URu00msbQWBpH42kCrUAr0kq0Mq1Cq9JqtDqtQWvSWrQ2rUPr0nq0Pm1AG9JGtDFtQpvSZrQ5bUFb0kTaijooSjGKU4I6KUkpSlOGtqZtaFvajranHWhHypJGOhlkUo4m0WTqoik0labRdJpB3TSTdqJZNJvmUA/tTHNpF5pH82lX2o12pz1oT9qLLOqlPuonmwYoT4Pk0AJaSAUaoiKVaJj2pjJVqEo1WkSLaQktpWW0D+1L+9H+dAAdSAfRwXQIHUqH0eF0BB1JR9HRdAwdS8fR8XQCnUgn0cl0Cp1Kp9HpdAadSWfR2XQOnUvn0fl0AV1IF9HFdAldSpfR5XQFXUlX0dV0DV1L19H1dAPdSDfRzXQL3Uq30e10B91Jd9HddA/dS/fR/fQA/YP+SQ/SQ/QwPUKP0mP0OD1BT9JT9DQ9Q8/Sc/Q8vUD/ohfpJXqZXqFX6TV6nd6gN+ktepveoXfpPXqfPqAP6SP6mD6hT+kz+py+oC/pK/qavqFv6Tv6N/2H/kvf0w/0I/1EP9Mv9Cv9Rr/TH/Qn/cXAyMTMTRziMEd4FDdzC7dyG7fzaB7DY3kcj+cJvAKvyCvxyrwKr8qr8eq8Bq/Ja/HavA6vy+vx+rwBb8gb8ca8CW/Km/HmvAVvyRN5K+7gKMc4zgnu5CSnOM0Z3pq34W15O96ed+AdOcsa62ywyTmexJO5i6fwVJ7G03kGd/NM3oln8Wyewz28M8/lXXgez4eb4RbelXeD2+EOeJh3h1vhNngEDoYH4Qi4hveAR3lP3gvuhwfYgnu5l/u4n20e4DwPssML4CdeyAUe4iKXeJj35jIcyxWuco0X8WJeAmfyUjgbzoJv4TI4Gc6FK+AEOBVOg7t4Ge/D+/J+vD8fwAfyQXwwH8KH8mF8OB/BR/JRfDQfw8fycXw8n8An8kl8Mp/Cp/JpfDqfwWfyWXw2n8Pn8nl8Pl/AF/JFfDFfwpfyZXw5X8FX8lV8NV/D1/J1fD3fwDfyTXwz38K38m18O98RqRWdjo5sh6gRqBYTjYt2imYi2SGrr1wqRqxAw9nesr3IDlu+RLKlfKloL4xYgbbqfU65rzY0ULCXtPaNxC16f6lq9fXZxWpLnwrDRp/lpewPxHDzW9WIKUBbgGYAtH1pMUcS2SqMmGLDDjRsBhltX1onNZjKN5iaNJIrr8K2SX2loSFLGvmGRuvkhjyDI3HT5F6r3DTo/oS7qk6h3w47vkS6pBJHKukKKnGCoesSz06g1DWFnAWtUxoYC0bitqmNrhYu18iXbbtYsIr9Tl94mtVXq9rhgi9t0xqvKzQ0wtOCASr40jTNrb6p4P6EZwT9i0H/GY39i439ZwT9i8EAF63hUqVaLg0P2mwW82wX85FuKb4kxXcHxZd8ae8erBXzVrk2VLBq1fZSYys8K/BQDjzMavRQbvQwK/BQDmR20KviS+vshmGsNAzjnMZs1cZsc4I01WBE5ni3tOrd0p7gltaCW9ojVdWkqp6gqpovoZ6yU8yHat5ve89yFdYaW5EeufU1eWrmNrhd3BDPa4iXjsTh+UGty3xpmT8yjZepMFQoFfOVUPdgqVwMlfzfHv+35v36T3c019GS9bwGaSwVRrJmoJYdjGZ3pWBVBoO4NBK3zW4czUpDw88fi2ZFtUDjqWZrwHE6U5lYJjiii+bizfmytch2U/Q2+7n9yB9zL2ofLJUWWr2l4Aq/T7wj1+ZW22sXSou9g6FqqViqtPc7dtmuOBW/1ZItDA9afthsFUtVu2A7Vps5XHHc0fEPjzKrcr6rJFFb95Dj3dug0dNwcUv3kJ0PLhrnuJcvxwr5rCbNrlqhSZY7EhHhNM13D7HLCc0ZdKMmDxSaag0PW+7TOtTbb9H0Gs2o0S5ORMg00+FZg6XQbCc/ZPEcqxYRFzxz0GHd/T+z4rR1NTgYIxfU2y2WKrzNbizXrpfr1MtdobZ816AYv39Tr1dM3ism1G8XqlZEcjUt80ryTlb9krxkoYV+SYWgpGKNljjus+/Xw+XBUrjiFRMN+cJVtybh8rBbT5/7322GSt4AtzWO7Zi/2WsrNd6dWuPdKam7E/ZtRUfJqETD/qmoP28SHR3+LIx2uBOyHnVGVRRT0cjZhIo6VZRUUUpFaRVl6lFS0ZJ1vqGO1FnRhMobVdmiKltUZYuNeFeOY8pxTPmMqXwx5TOmMsdU5pjKHFeZ4ypzXGWOq7GIK0ZcMeKKEVeMuGLEFSOhGAnFSChGQjESijEyLgnFSChGQjESI+OteiRVj6TqkVQ9kqpHSrlKKS8p5SWlvKRU5pTKnFKZUypzSmVOq8xpVW9aMdKKkVaMtGKkFSOtGGnFSCtGRjEyipFRjIxiZBQjoxgZxcikgrnZOTIWI9nqrKh6ctx/KlJzuCOuooSKOlWUVFFKRWkVZYRffzaiUcXKBN+kiWSHqGKrORHNJORcXTtFk6JSXzItKrxkVlQT1UUNUVM0F2hKPKRGPKhq1LhG1byMZoSfqqv4SImPlPhIiY+U+EiJj5T4SImPlPhIi4+0vFPSMVEZq7SMQ1rGIS38tHDTwk0LNy3ctHDTwk0LN51Tb7aR+Sa5MsKu36f6vcgIuz4G9Tmm+omHjHjIiIeMeMiIh4x4yEjtsnZJZKX2rPCzws8KPyv8rPCzws8KPyv8rPCzws8KX9ZGiazws8LXhK8JX9ZOCVk7JTThyxoqoQlfE74mfE34mvA14WvC14SvCV8Tvi58Xfi68HXh68LXha8LXxe+Lnz59krowteFrwtfF74ufF34hvAN4RvCN4RvCN8QviF8Q/hG/elIJ+pnxIEhDgxxYIgDQxwY4sAUB6Y4MMWBKQ5McWCKA1M4pjgwZQRMGQFT+KbwTeGbwjeFbwo/J/yc8HPCzwk/J/yc8HPCzwk/J/yc8HPCzwk/J/yc8HPCzwX8zo4O0ahoTDQumhDtFE2KpkTTohnRrKgmqosaoqao8KPCjwo/Kvyoz4+agT9Xo4HGTdFceK7/mR9eHMjcYB2z2JfmufVvvObF9Sjol5V8WckXPPGuCi944l3tFE2KpkTTohnRrKgmqosaouI3eOKjpiZ8Tfia8DXha8LXhK8JXxO+JnxN+JrwNeFrwteErwlfE74ufF34uvB14evC14WvC18Xvi58Xfi68HXh68LXha8LXxe+IXxD+IbwDeEbwjeEbwjfEL4hfEP4hvAN4RvCN4RvCN8Qvil8U/im8E3hm8I3hW8K3xS+KXxT+KbwTeGbwjeFbwrfFH5O+LloeF4wcZf6IkeFnhN6Tug5oeeEHjzt0VzCp8Q6gqfE1ahoTDQumhDtFE2KpkTTohnRrKgWaFTyR6MtA06+Vrb73XW7/+r11hHp9lqx3y67i3b3RG+hfe+auzz2NjHKFbs/6BjLhYecor+p4i67i/3N9pI+d3nnXh2c78wFmhJQSgynxHBKDKfEcEoMp8RwKtdUcMpWeNiueIvI/lIx32TWyiXfYzIak88oN5LP3WQ03hkMUjTWIZpstitVZ8iq2v3NpaJtO/nB6mBbdbBsS1xpHXAW1eO2ilthURp+hlgwrKbcjpymNCoaE42L+lXmzOBlnMsFL2tXjaZirVAIdU20CtWWLn+CBKH/dvPCMV0jezheu72r/p4LLvS3O7ywVXYOg8P+3lJwONgv8uLRXWqrx2uGu6YEGevLeq81ymt5wdjGvQL/OrWeXa6V9Ft9S8tOoeD0+dyx/n5Y4y5oQzyuIS57ZLvZnWSOVVriWK3yseIblw+Ieuy9khrirBdPGBkbtQHUcExtD40fOeZtCv3tMrVjNNp3rzIFTZWk3W/W+wcnVdex9QHwzhfsAbfM+oi4E8c91qP//cg0fZR7YyYOF2tDkWV2uTSxVAl7B7ytiMVea5Q/I90gMlCqlX11Z6V3vuIs8c77E9ML/MnpXVB0/AShvD918stPnZa8mhWjvL1r/y43blZ7B/4HE2kvKAAAeNpFzTsOgkAQBmBWcHmJvBYqNWi7jYmFFxAsaIwVJPbegMpEY2KpZxmsjKWH8Ro44rJ2883MP/MgzQXIVcnB2BQ1IbeyzigvpuCVObAtFqdyDJTvCgW0JAWVr8BI0qeiEar0eGs9Se/GS4Ai9L1AH0FnAuYvNupiFg7Ng4CNsJYCA4Qd/0DAEW+Db94hLuZrNauw4+NesJb0kP5C0kV6E8kh0q0kw/basflfY7gQviUjJDtLxsho3rEExj9WiVe4"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIiA+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8bWV0YWRhdGE+DQpUaGlzIGlzIGEgY3VzdG9tIFNWRyB3ZWJmb250IGdlbmVyYXRlZCBieSBGb250IFNxdWlycmVsLg0KQ29weXJpZ2h0ICAgOiBEaWdpdGl6ZWQgZGF0YSBjb3B5cmlnaHQgIDIwMTAyMDExIEdvb2dsZSBDb3Jwb3JhdGlvbg0KRm91bmRyeSAgICAgOiBBc2NlbmRlciBDb3Jwb3JhdGlvbg0KRm91bmRyeSBVUkwgOiBodHRwd3d3YXNjZW5kZXJjb3JwY29tDQo8L21ldGFkYXRhPg0KPGRlZnM+DQo8Zm9udCBpZD0iT3BlblNhbnNSZWd1bGFyIiBob3Jpei1hZHYteD0iMTEzOSIgPg0KPGZvbnQtZmFjZSB1bml0cy1wZXItZW09IjIwNDgiIGFzY2VudD0iMTYzOCIgZGVzY2VudD0iLTQxMCIgLz4NCjxtaXNzaW5nLWdseXBoIGhvcml6LWFkdi14PSI1MzIiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmIwMDsiIGhvcml6LWFkdi14PSIxMzg5IiBkPSJNNzIzIDk2N3Y3NWwxOTYgNjB2NjFxMCA0MDQgMzUzIDQwNHE4NyAwIDIwNCAtMzVsLTQzIC0xMzNxLTk2IDMxIC0xNjQgMzFxLTk0IDAgLTEzOSAtNjIuNXQtNDUgLTIwMC41di03MWgyNzl2LTEyOWgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNMjkgOTY3djc1bDE5NiA2MHY2MXEwIDQwNCAzNTMgNDA0cTg3IDAgMjA0IC0zNWwtNDMgLTEzM3EtOTYgMzEgLTE2NCAzMXEtOTQgMCAtMTM5IC02Mi41dC00NSAtMjAwLjV2LTcxaDI3OXYtMTI5IGgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmIwMTsiIGhvcml6LWFkdi14PSIxMjEyIiBkPSJNMjkgOTY3djc1bDE5NiA2MHY2MXEwIDQwNCAzNTMgNDA0cTg3IDAgMjA0IC0zNWwtNDMgLTEzM3EtOTYgMzEgLTE2NCAzMXEtOTQgMCAtMTM5IC02Mi41dC00NSAtMjAwLjV2LTcxaDI3OXYtMTI5aC0yNzl2LTk2N2gtMTY2djk2N2gtMTk2ek04NTYgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXpNODcwIDB2MTA5NmgxNjYgdi0xMDk2aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGZiMDI7IiBob3Jpei1hZHYteD0iMTIxMiIgZD0iTTI5IDk2N3Y3NWwxOTYgNjB2NjFxMCA0MDQgMzUzIDQwNHE4NyAwIDIwNCAtMzVsLTQzIC0xMzNxLTk2IDMxIC0xNjQgMzFxLTk0IDAgLTEzOSAtNjIuNXQtNDUgLTIwMC41di03MWgyNzl2LTEyOWgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNODcwIDB2MTU1NmgxNjZ2LTE1NTZoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmIwMzsiIGhvcml6LWFkdi14PSIxOTA5IiBkPSJNNzE3IDk2N3Y3NWwxOTYgNjB2NjFxMCA0MDQgMzUzIDQwNHE4NyAwIDIwNCAtMzVsLTQzIC0xMzNxLTk2IDMxIC0xNjQgMzFxLTk0IDAgLTEzOSAtNjIuNXQtNDUgLTIwMC41di03MWgyNzl2LTEyOWgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNMjkgOTY3djc1bDE5NiA2MHY2MXEwIDQwNCAzNTMgNDA0cTg3IDAgMjA0IC0zNWwtNDMgLTEzM3EtOTYgMzEgLTE2NCAzMXEtOTQgMCAtMTM5IC02Mi41dC00NSAtMjAwLjV2LTcxaDI3OXYtMTI5IGgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNMTU1MSAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41ek0xNTY1IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmIwNDsiIGhvcml6LWFkdi14PSIxOTA5IiBkPSJNNzE3IDk2N3Y3NWwxOTYgNjB2NjFxMCA0MDQgMzUzIDQwNHE4NyAwIDIwNCAtMzVsLTQzIC0xMzNxLTk2IDMxIC0xNjQgMzFxLTk0IDAgLTEzOSAtNjIuNXQtNDUgLTIwMC41di03MWgyNzl2LTEyOWgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNMjkgOTY3djc1bDE5NiA2MHY2MXEwIDQwNCAzNTMgNDA0cTg3IDAgMjA0IC0zNWwtNDMgLTEzM3EtOTYgMzEgLTE2NCAzMXEtOTQgMCAtMTM5IC02Mi41dC00NSAtMjAwLjV2LTcxaDI3OXYtMTI5IGgtMjc5di05NjdoLTE2NnY5NjdoLTE5NnpNMTU2NSAwdjE1NTZoMTY2di0xNTU2aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiAiICBob3Jpei1hZHYteD0iNTMyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDA5OyIgaG9yaXotYWR2LXg9IjUzMiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhMDsiIGhvcml6LWFkdi14PSI1MzIiIC8+DQo8Z2x5cGggdW5pY29kZT0iISIgaG9yaXotYWR2LXg9IjU0NyIgZD0iTTE1MiAxMDZxMCAxMzYgMTIwIDEzNnE1OCAwIDg5LjUgLTM1dDMxLjUgLTEwMXEwIC02NCAtMzIgLTk5LjV0LTg5IC0zNS41cS01MiAwIC04NiAzMS41dC0zNCAxMDMuNXpNMTcwIDE0NjJoMjA3bC01MSAtMTA1OWgtMTA1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMjsiIGhvcml6LWFkdi14PSI4MjEiIGQ9Ik0xMzMgMTQ2MmgxODZsLTQwIC01MjhoLTEwNXpNNTAyIDE0NjJoMTg2bC00MSAtNTI4aC0xMDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiMiIGhvcml6LWFkdi14PSIxMzIzIiBkPSJNNTEgNDMwdjEyOWgyODdsNjggMzQwaC0yNzd2MTI3aDI5OWw4MiA0MzZoMTM5bC04MiAtNDM2aDMwNWw4NCA0MzZoMTM0bC04NCAtNDM2aDI2NHYtMTI3aC0yODlsLTY2IC0zNDBoMjgzdi0xMjloLTMwN2wtODQgLTQzMGgtMTM3bDg0IDQzMGgtMzAzbC04MiAtNDMwaC0xMzZsODAgNDMwaC0yNjJ6TTQ3NSA1NTloMzAzbDY2IDM0MGgtMzAzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSIkIiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTEzMSAxNzB2MTU2cTgzIC0zNyAxOTEuNSAtNjAuNXQxOTcuNSAtMjMuNXY0NDBxLTIwNSA2NSAtMjg3LjUgMTUxdC04Mi41IDIyMnEwIDEzMSAxMDEuNSAyMTV0MjY4LjUgMTAydjE4MmgxMjl2LTE4MHExODQgLTUgMzU1IC03NGwtNTIgLTEzMXEtMTQ5IDU5IC0zMDMgNzB2LTQzNHExNTcgLTUwIDIzNSAtOTcuNXQxMTUgLTEwOXQzNyAtMTQ5LjVxMCAtMTM2IC0xMDIgLTIyNC41dC0yODUgLTExMS41di0yMzJoLTEyOXYyMjMgcS0xMTIgMCAtMjE3IDE3LjV0LTE3MiA0OC41ek0zMTkgMTA1N3EwIC03NiA0NSAtMTIydDE1NiAtODd2Mzg3cS05OSAtMTYgLTE1MCAtNjIuNXQtNTEgLTExNS41ek02NDkgMjUycTIxNyAzMCAyMTcgMTg0cTAgNzIgLTQ0LjUgMTE2LjV0LTE3Mi41IDg4LjV2LTM4OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJSIgaG9yaXotYWR2LXg9IjE2ODYiIGQ9Ik0xMDQgMTAyNnEwIDIyNyA3NC41IDM0MnQyMjAuNSAxMTVxMTQ1IDAgMjIzIC0xMTl0NzggLTMzOHEwIC0yMjggLTc2LjUgLTM0NC41dC0yMjQuNSAtMTE2LjVxLTE0MCAwIC0yMTcuNSAxMTl0LTc3LjUgMzQyek0yNDIgMTAyNnEwIC0xNzAgMzcgLTI1NXQxMjAgLTg1cTE2NCAwIDE2NCAzNDBxMCAzMzggLTE2NCAzMzhxLTgzIDAgLTEyMCAtODR0LTM3IC0yNTR6TTM2NSAwbDgxMSAxNDYyaDE0N2wtODExIC0xNDYyaC0xNDd6TTk4NSA0NDAgcTAgMjI3IDc0LjUgMzQydDIyMC41IDExNXExNDIgMCAyMjEuNSAtMTE3LjV0NzkuNSAtMzM5LjVxMCAtMjI3IC03Ni41IC0zNDMuNXQtMjI0LjUgLTExNi41cS0xNDIgMCAtMjE4LjUgMTE5dC03Ni41IDM0MXpNMTEyMiA0NDBxMCAtMTcxIDM3IC0yNTUuNXQxMjEgLTg0LjV0MTI0IDgzLjV0NDAgMjU2LjVxMCAxNzEgLTQwIDI1My41dC0xMjQgODIuNXQtMTIxIC04Mi41dC0zNyAtMjUzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDI2OyIgaG9yaXotYWR2LXg9IjE0OTUiIGQ9Ik0xMTMgMzc5cTAgMTMwIDY5LjUgMjMwdDI0OS41IDIwMnEtODUgOTUgLTExNS41IDE0NHQtNDguNSAxMDJ0LTE4IDExMHEwIDE1MCA5OCAyMzR0MjczIDg0cTE2MiAwIDI1NSAtODMuNXQ5MyAtMjMyLjVxMCAtMTA3IC02OCAtMTk3LjV0LTIyNSAtMTgzLjVsNDA3IC0zOTFxNTYgNjIgODkuNSAxNDUuNXQ1Ni41IDE4Mi41aDE2OHEtNjggLTI4NiAtMjA1IC00MzRsMjk5IC0yOTFoLTIyOWwtMTg1IDE3OHEtMTE4IC0xMDYgLTI0MCAtMTUyIHQtMjcyIC00NnEtMjE1IDAgLTMzMy41IDEwNnQtMTE4LjUgMjkzek0yODUgMzgzcTAgLTExNyA3Ny41IC0xODUuNXQyMDYuNSAtNjguNXEyNDEgMCA0MDAgMTU0bC00MzcgNDI0cS0xMTEgLTY4IC0xNTcgLTExMi41dC02OCAtOTUuNXQtMjIgLTExNnpNNDE0IDExNzFxMCAtNjkgMzYgLTEzMS41dDEyMyAtMTUwLjVxMTI5IDc1IDE3OS41IDEzOC41dDUwLjUgMTQ2LjVxMCA3NyAtNTEuNSAxMjUuNXQtMTM3LjUgNDguNXEtODkgMCAtMTQ0LjUgLTQ4IHQtNTUuNSAtMTI5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSInIiBob3Jpei1hZHYteD0iNDUzIiBkPSJNMTMzIDE0NjJoMTg2bC00MCAtNTI4aC0xMDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IigiIGhvcml6LWFkdi14PSI2MDYiIGQ9Ik04MiA1NjFxMCAyNjUgNzcuNSA0OTZ0MjIzLjUgNDA1aDE2MnEtMTQ0IC0xOTMgLTIxNi41IC00MjR0LTcyLjUgLTQ3NXEwIC0yNDAgNzQgLTQ2OXQyMTMgLTQxOGgtMTYwcS0xNDcgMTcwIC0yMjQgMzk3dC03NyA0ODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IikiIGhvcml6LWFkdi14PSI2MDYiIGQ9Ik02MSAxNDYyaDE2MnExNDcgLTE3NSAyMjQgLTQwNi41dDc3IC00OTQuNXQtNzcuNSAtNDkwdC0yMjMuNSAtMzk1aC0xNjBxMTM5IDE4OCAyMTMgNDE3LjV0NzQgNDY5LjVxMCAyNDQgLTcyLjUgNDc1dC0yMTYuNSA0MjR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IioiIGhvcml6LWFkdi14PSIxMTMwIiBkPSJNODYgMTA5MGwyOSAxODJsMzkxIC0xMTFsLTQzIDM5NWgxOTRsLTQzIC0zOTVsMzk4IDExMWwyNiAtMTgybC0zODEgLTMxbDI0OCAtMzI2bC0xNzIgLTk0bC0xNzYgMzYybC0xNjAgLTM2MmwtMTc2IDk0bDI0MiAzMjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IisiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDY1M3YxMzhoNDEwdjQyOGgxMzl2LTQyOGg0MTJ2LTEzOGgtNDEydi00MjZoLTEzOXY0MjZoLTQxMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iLCIgaG9yaXotYWR2LXg9IjUwMiIgZD0iTTYzIC0yNjRxMjcgMTA0IDU5LjUgMjU3dDQ1LjUgMjQ1aDE4MmwxNSAtMjNxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSItIiBob3Jpei1hZHYteD0iNjU5IiBkPSJNODQgNDczdjE1Mmg0OTF2LTE1MmgtNDkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSIuIiBob3Jpei1hZHYteD0iNTQ1IiBkPSJNMTUyIDEwNnEwIDY3IDMwLjUgMTAxLjV0ODcuNSAzNC41cTU4IDAgOTAuNSAtMzQuNXQzMi41IC0xMDEuNXEwIC02NSAtMzMgLTEwMHQtOTAgLTM1cS01MSAwIC04NC41IDMxLjV0LTMzLjUgMTAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9Ii8iIGhvcml6LWFkdi14PSI3NTIiIGQ9Ik0yMCAwbDU0NSAxNDYyaDE2NmwtNTQ1IC0xNDYyaC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjAiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTAyIDczM3EwIDM4MiAxMTkgNTY3dDM2MyAxODVxMjM4IDAgMzYxLjUgLTE5M3QxMjMuNSAtNTU5cTAgLTM3OSAtMTE5LjUgLTU2NnQtMzY1LjUgLTE4N3EtMjM2IDAgLTM1OSAxOTEuNXQtMTIzIDU2MS41ek0yNzAgNzMzcTAgLTMxOSA3NSAtNDY0LjV0MjM5IC0xNDUuNXExNjYgMCAyNDAuNSAxNDcuNXQ3NC41IDQ2Mi41dC03NC41IDQ2MS41dC0yNDAuNSAxNDYuNXEtMTY0IDAgLTIzOSAtMTQ0LjV0LTc1IC00NjMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iMSIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xODggMTE2M2wzODcgMjk5aDE0MHYtMTQ2MmgtMTYydjEwNDJxMCAxMzAgOCAyNDZxLTIxIC0yMSAtNDcgLTQ0dC0yMzggLTE5NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iMiIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xMDAgMHYxNDNsMzg1IDM4N3ExNzYgMTc4IDIzMiAyNTR0ODQgMTQ4dDI4IDE1NXEwIDExNyAtNzEgMTg1LjV0LTE5NyA2OC41cS05MSAwIC0xNzIuNSAtMzB0LTE4MS41IC0xMDlsLTg4IDExM3EyMDIgMTY4IDQ0MCAxNjhxMjA2IDAgMzIzIC0xMDUuNXQxMTcgLTI4My41cTAgLTEzOSAtNzggLTI3NXQtMjkyIC0zNDRsLTMyMCAtMzEzdi04aDc1MnYtMTU0aC05NjF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjMiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNOTQgNTl2MTU4cTk1IC00NyAyMDIuNSAtNzEuNXQyMDMuNSAtMjQuNXEzNzkgMCAzNzkgMjk3cTAgMjY2IC00MTggMjY2aC0xNDR2MTQzaDE0NnExNzEgMCAyNzEgNzUuNXQxMDAgMjA5LjVxMCAxMDcgLTczLjUgMTY4dC0xOTkuNSA2MXEtOTYgMCAtMTgxIC0yNnQtMTk0IC05NmwtODQgMTEycTkwIDcxIDIwNy41IDExMS41dDI0Ny41IDQwLjVxMjEzIDAgMzMxIC05Ny41dDExOCAtMjY3LjVxMCAtMTQwIC03OC41IC0yMjkgdC0yMjIuNSAtMTE5di04cTE3NiAtMjIgMjYxIC0xMTJ0ODUgLTIzNnEwIC0yMDkgLTE0NSAtMzIxLjV0LTQxMiAtMTEyLjVxLTExNiAwIC0yMTIuNSAxNy41dC0xODcuNSA2MS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSI0IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTQzIDMzNnYxNDVsNjk0IDk4OWgxNzZ2LTk4M2gyMTd2LTE1MWgtMjE3di0zMzZoLTE1OXYzMzZoLTcxMXpNMjA5IDQ4N2g1NDV2NDg2cTAgMTQzIDEwIDMyM2gtOHEtNDggLTk2IC05MCAtMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSI1IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTEzMyA1OXYxNjBxNzAgLTQ1IDE3NCAtNzAuNXQyMDUgLTI1LjVxMTc2IDAgMjczLjUgODN0OTcuNSAyNDBxMCAzMDYgLTM3NSAzMDZxLTk1IDAgLTI1NCAtMjlsLTg2IDU1bDU1IDY4NGg3Mjd2LTE1M2gtNTg1bC0zNyAtNDM5cTExNSAyMyAyMjkgMjNxMjMxIDAgMzYzLjUgLTExNC41dDEzMi41IC0zMTMuNXEwIC0yMjcgLTE0NC41IC0zNTZ0LTM5OC41IC0xMjlxLTI0NyAwIC0zNzcgNzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjYiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTE3IDYyNXEwIDQzMSAxNjcuNSA2NDQuNXQ0OTUuNSAyMTMuNXExMTMgMCAxNzggLTE5di0xNDNxLTc3IDI1IC0xNzYgMjVxLTIzNSAwIC0zNTkgLTE0Ni41dC0xMzYgLTQ2MC41aDEycTExMCAxNzIgMzQ4IDE3MnExOTcgMCAzMTAuNSAtMTE5dDExMy41IC0zMjNxMCAtMjI4IC0xMjQuNSAtMzU4LjV0LTMzNi41IC0xMzAuNXEtMjI3IDAgLTM2MCAxNzAuNXQtMTMzIDQ3NC41ek0yODcgNTA2cTAgLTEwMyA0MCAtMTkydDExMy41IC0xNDEgdDE2Ny41IC01MnExNDIgMCAyMjAuNSA4OS41dDc4LjUgMjU4LjVxMCAxNDUgLTczIDIyOHQtMjE4IDgzcS05MCAwIC0xNjUgLTM3dC0xMTkuNSAtMTAydC00NC41IC0xMzV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjciIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNOTQgMTMwOXYxNTNoOTczdi0xMzNsLTU5OCAtMTMyOWgtMTg0bDYwNiAxMzA5aC03OTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjgiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDM3M3EwIDI1MSAzMDYgMzkxcS0xMzggNzggLTE5OCAxNjguNXQtNjAgMjAyLjVxMCAxNTkgMTE3LjUgMjUzLjV0MzE0LjUgOTQuNXEyMDAgMCAzMTcgLTkzdDExNyAtMjU3cTAgLTEwOCAtNjcgLTE5N3QtMjE0IC0xNjJxMTc4IC04NSAyNTMgLTE3OC41dDc1IC0yMTYuNXEwIC0xODIgLTEyNyAtMjkwLjV0LTM0OCAtMTA4LjVxLTIzNCAwIC0zNjAgMTAyLjV0LTEyNiAyOTAuNXpNMjY4IDM2OXEwIC0xMjAgODMuNSAtMTg3IHQyMzQuNSAtNjdxMTQ5IDAgMjMyIDcwdDgzIDE5MnEwIDk3IC03OCAxNzIuNXQtMjcyIDE0Ni41cS0xNDkgLTY0IC0yMTYgLTE0MS41dC02NyAtMTg1LjV6TTMxNSAxMTI4cTAgLTkyIDU5IC0xNTh0MjE4IC0xMzJxMTQzIDYwIDIwMi41IDEyOXQ1OS41IDE2MXEwIDEwMSAtNzIuNSAxNjAuNXQtMTk5LjUgNTkuNXEtMTI1IDAgLTE5NiAtNjB0LTcxIC0xNjB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjkiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA2IDk5MXEwIDIyOCAxMjcuNSAzNjB0MzM1LjUgMTMycTE0OSAwIDI2MC41IC03Ni41dDE3MS41IC0yMjN0NjAgLTM0NS41cTAgLTg1OCAtNjY0IC04NThxLTExNiAwIC0xODQgMjB2MTQzcTgwIC0yNiAxODIgLTI2cTI0MCAwIDM2Mi41IDE0OC41dDEzMy41IDQ1NS41aC0xMnEtNTUgLTgzIC0xNDYgLTEyNi41dC0yMDUgLTQzLjVxLTE5NCAwIC0zMDggMTE2dC0xMTQgMzI0ek0yNzAgOTkzcTAgLTE0NCA3MiAtMjI2LjV0MjE5IC04Mi41IHE5MSAwIDE2Ny41IDM3dDEyMC41IDEwMXQ0NCAxMzRxMCAxMDUgLTQxIDE5NHQtMTE0LjUgMTQwdC0xNjguNSA1MXEtMTQzIDAgLTIyMSAtOTJ0LTc4IC0yNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IjoiIGhvcml6LWFkdi14PSI1NDUiIGQ9Ik0xNTIgMTA2cTAgNjcgMzAuNSAxMDEuNXQ4Ny41IDM0LjVxNTggMCA5MC41IC0zNC41dDMyLjUgLTEwMS41cTAgLTY1IC0zMyAtMTAwdC05MCAtMzVxLTUxIDAgLTg0LjUgMzEuNXQtMzMuNSAxMDMuNXpNMTUyIDk4OXEwIDEzNSAxMTggMTM1cTEyMyAwIDEyMyAtMTM1cTAgLTY1IC0zMyAtMTAwdC05MCAtMzVxLTUxIDAgLTg0LjUgMzEuNXQtMzMuNSAxMDMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iOyIgaG9yaXotYWR2LXg9IjU0NSIgZD0iTTYzIC0yNjRxMjcgMTA0IDU5LjUgMjU3dDQ1LjUgMjQ1aDE4MmwxNSAtMjNxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTI1ek0xNDcgOTg5cTAgMTM1IDExOSAxMzVxMTIzIDAgMTIzIC0xMzVxMCAtNjUgLTMzIC0xMDB0LTkwIC0zNXEtNTggMCAtODguNSAzNXQtMzAuNSAxMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNjOyIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xMDQgNjY0djk4bDk2MSA0Nzl2LTE0OWwtNzgyIC0zNzFsNzgyIC0zMjh2LTE1MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iPSIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xMTkgNDQ5djEzN2g5MzB2LTEzN2gtOTMwek0xMTkgODU4djEzN2g5MzB2LTEzN2gtOTMweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzZTsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDI0MnYxNTFsNzgzIDMyNmwtNzgzIDM3M3YxNDlsOTYxIC00Nzl2LTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSI/IiBob3Jpei1hZHYteD0iODc5IiBkPSJNMjcgMTM4NHExODkgOTkgMzk1IDk5cTE5MSAwIDI5NyAtOTR0MTA2IC0yNjVxMCAtNzMgLTE5LjUgLTEyOC41dC01Ny41IC0xMDV0LTE2NCAtMTU5LjVxLTEwMSAtODYgLTEzMy41IC0xNDN0LTMyLjUgLTE1MnYtMzNoLTEyOXY1NHEwIDExNyAzNiAxOTIuNXQxMzQgMTU5LjVxMTM2IDExNSAxNzEuNSAxNzN0MzUuNSAxNDBxMCAxMDIgLTY1LjUgMTU3LjV0LTE4OC41IDU1LjVxLTc5IDAgLTE1NCAtMTguNXQtMTcyIC02Ny41ek0yNDAgMTA2IHEwIDEzNiAxMjAgMTM2cTU4IDAgODkuNSAtMzV0MzEuNSAtMTAxcTAgLTY0IC0zMiAtOTkuNXQtODkgLTM1LjVxLTUyIDAgLTg2IDMxLjV0LTM0IDEwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJAIiBob3Jpei1hZHYteD0iMTg0MSIgZD0iTTEyMSA1NzFxMCAyNjAgMTA3IDQ2M3QzMDUgMzE0LjV0NDU0IDExMS41cTIxNSAwIDM4Mi41IC05MC41dDI1OSAtMjU3dDkxLjUgLTM4My41cTAgLTE0MiAtNDQgLTI2MHQtMTI0IC0xODN0LTE4NCAtNjVxLTg2IDAgLTE0NSA1MnQtNzAgMTMzaC04cS00MCAtODcgLTExNC41IC0xMzZ0LTE3Ni41IC00OXEtMTUwIDAgLTIzNC41IDEwMi41dC04NC41IDI3OC41cTAgMjA0IDExOCAzMzEuNXQzMTAgMTI3LjVxNjggMCAxNTQgLTEyLjUgdDE1NSAtMzQuNWwtMjUgLTQ3MHYtMjJxMCAtMTc4IDEzMyAtMTc4cTkxIDAgMTQ4IDEwNy41dDU3IDI3OS41cTAgMTgxIC03NCAzMTd0LTIxMC41IDIwOS41dC0zMTMuNSA3My41cS0yMjMgMCAtMzg4IC05Mi41dC0yNTIgLTI2NHQtODcgLTM5Ni41cTAgLTMwNSAxNjEgLTQ2OXQ0NjQgLTE2NHEyMTAgMCA0MzYgODZ2LTEzM3EtMTkyIC04NCAtNDM2IC04NHEtMzYzIDAgLTU2My41IDE5OS41dC0yMDAuNSA1NTcuNXpNNjg2IDU5OCBxMCAtMjU0IDE5NSAtMjU0cTIwNyAwIDIyNSAzMTNsMTQgMjYxcS03MiAyMCAtMTU3IDIwcS0xMzAgMCAtMjAzLjUgLTkwdC03My41IC0yNTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IkEiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSJCIiBob3Jpei1hZHYteD0iMTMyNyIgZD0iTTIwMSAwdjE0NjJoNDEzcTI5MSAwIDQyMSAtODd0MTMwIC0yNzVxMCAtMTMwIC03Mi41IC0yMTQuNXQtMjExLjUgLTEwOS41di0xMHEzMzMgLTU3IDMzMyAtMzUwcTAgLTE5NiAtMTMyLjUgLTMwNnQtMzcwLjUgLTExMGgtNTEwek0zNzEgMTQ1aDMwNXExNzcgMCAyNjYuNSA2OC41dDg5LjUgMjE0LjVxMCAxMzYgLTkxLjUgMjAwdC0yNzguNSA2NGgtMjkxdi01NDd6TTM3MSA4MzZoMjgwcTE4MCAwIDI1OSA1Ni41dDc5IDE5MC41IHEwIDEyMyAtODggMTc3LjV0LTI4MCA1NC41aC0yNTB2LTQ3OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iQyIgaG9yaXotYWR2LXg9IjEyOTIiIGQ9Ik0xMjUgNzMzcTAgMjI2IDg0LjUgMzk2dDI0NCAyNjJ0Mzc1LjUgOTJxMjMwIDAgNDAyIC04NGwtNzIgLTE0NnEtMTY2IDc4IC0zMzIgNzhxLTI0MSAwIC0zODAuNSAtMTYwLjV0LTEzOS41IC00MzkuNXEwIC0yODcgMTM0LjUgLTQ0My41dDM4My41IC0xNTYuNXExNTMgMCAzNDkgNTV2LTE0OXEtMTUyIC01NyAtMzc1IC01N3EtMzIzIDAgLTQ5OC41IDE5NnQtMTc1LjUgNTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJEIiBob3Jpei1hZHYteD0iMTQ5MyIgZD0iTTIwMSAwdjE0NjJoNDQ4cTM0MSAwIDUzMCAtMTg5dDE4OSAtNTI4cTAgLTM2MiAtMTk2LjUgLTU1My41dC01NjUuNSAtMTkxLjVoLTQwNXpNMzcxIDE0N2gyMDdxMzA0IDAgNDU3IDE0OS41dDE1MyA0NDIuNXEwIDI4NiAtMTQzLjUgNDMxdC00MjYuNSAxNDVoLTI0N3YtMTE2OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iRSIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJGIiBob3Jpei1hZHYteD0iMTA1NyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNTM1aDYwNnYtMTUxaC02MDZ2LTYyNWgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSJHIiBob3Jpei1hZHYteD0iMTQ5MSIgZD0iTTEyNSA3MzFxMCAyMjggOTEuNSAzOTkuNXQyNjMuNSAyNjJ0NDAzIDkwLjVxMjM0IDAgNDM2IC04NmwtNjYgLTE1MHEtMTk4IDg0IC0zODEgODRxLTI2NyAwIC00MTcgLTE1OXQtMTUwIC00NDFxMCAtMjk2IDE0NC41IC00NDl0NDI0LjUgLTE1M3ExNTIgMCAyOTcgMzV2NDUwaC0zMjd2MTUyaDQ5N3YtNzExcS0xMTYgLTM3IC0yMzYgLTU2dC0yNzggLTE5cS0zMzIgMCAtNTE3IDE5Ny41dC0xODUgNTUzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IkgiIGhvcml6LWFkdi14PSIxNTExIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg3NzB2NjIyaDE3MHYtMTQ2MmgtMTcwdjY4OGgtNzcwdi02ODhoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iSSIgaG9yaXotYWR2LXg9IjU3MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IkoiIGhvcml6LWFkdi14PSI1NDciIGQ9Ik0tMTYwIC0yMTNxNzEgLTIwIDE0OCAtMjBxOTkgMCAxNTAuNSA2MHQ1MS41IDE3M3YxNDYyaDE3MHYtMTQ0OHEwIC0xOTAgLTk2IC0yOTQuNXQtMjc2IC0xMDQuNXEtOTQgMCAtMTQ4IDI3djE0NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iSyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNzI1bDY2MyA3MjVoMjAxbC01ODggLTYzNWw2MTAgLTgyN2gtMjAwbC01MzMgNzA5bC0xNTMgLTEzNnYtNTczaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IkwiIGhvcml6LWFkdi14PSIxMDYzIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTEzMDhoNjQ1di0xNTRoLTgxNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iTSIgaG9yaXotYWR2LXg9IjE4NDkiIGQ9Ik0yMDEgMHYxNDYyaDI1Nmw0NjMgLTEyMDZoOGw0NjcgMTIwNmgyNTR2LTE0NjJoLTE3MHY5NDJxMCAxNjIgMTQgMzUyaC04bC01MDAgLTEyOTRoLTEzN2wtNDk2IDEyOTZoLThxMTQgLTE1NCAxNCAtMzY2di05MzBoLTE1N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iTiIgaG9yaXotYWR2LXg9IjE1NDQiIGQ9Ik0yMDEgMHYxNDYyaDE5Mmw3OTcgLTEyMjJoOHEtMiAyOCAtOSAxNzRxLTUgMTE0IC01IDE3N3YzMnY4MzloMTU5di0xNDYyaC0xOTRsLTc5OSAxMjI3aC04cTE2IC0yMTYgMTYgLTM5NnYtODMxaC0xNTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9Ik8iIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iUCIgaG9yaXotYWR2LXg9IjEyMzMiIGQ9Ik0yMDEgMHYxNDYyaDM3OXE1NDggMCA1NDggLTQyNnEwIC0yMjIgLTE1MS41IC0zNDEuNXQtNDMzLjUgLTExOS41aC0xNzJ2LTU3NWgtMTcwek0zNzEgNzIxaDE1M3EyMjYgMCAzMjcgNzN0MTAxIDIzNHEwIDE0NSAtOTUgMjE2dC0yOTYgNzFoLTE5MHYtNTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJRIiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0yODEgLTExMyAtNDY3dC0zMTkgLTI1MmwzNDggLTM2MmgtMjQ3bC0yODUgMzMwbC01NSAtMnEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNSBxLTI0MyAwIC0zNjkuNSAtMTUzLjV0LTEyNi41IC00NDYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iUiIgaG9yaXotYWR2LXg9IjEyNjYiIGQ9Ik0yMDEgMHYxNDYyaDQwMXEyNjkgMCAzOTcuNSAtMTAzdDEyOC41IC0zMTBxMCAtMjkwIC0yOTQgLTM5MmwzOTcgLTY1N2gtMjAxbC0zNTQgNjA4aC0zMDV2LTYwOGgtMTcwek0zNzEgNzU0aDIzM3ExODAgMCAyNjQgNzEuNXQ4NCAyMTQuNXEwIDE0NSAtODUuNSAyMDl0LTI3NC41IDY0aC0yMjF2LTU1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iUyIgaG9yaXotYWR2LXg9IjExMjQiIGQ9Ik0xMDYgNDd2MTY0cTkwIC0zOCAxOTYgLTYwdDIxMCAtMjJxMTcwIDAgMjU2IDY0LjV0ODYgMTc5LjVxMCA3NiAtMzAuNSAxMjQuNXQtMTAyIDg5LjV0LTIxNy41IDkzcS0yMDQgNzMgLTI5MS41IDE3M3QtODcuNSAyNjFxMCAxNjkgMTI3IDI2OXQzMzYgMTAwcTIxOCAwIDQwMSAtODBsLTUzIC0xNDhxLTE4MSA3NiAtMzUyIDc2cS0xMzUgMCAtMjExIC01OHQtNzYgLTE2MXEwIC03NiAyOCAtMTI0LjV0OTQuNSAtODl0MjAzLjUgLTg5LjUgcTIzMCAtODIgMzE2LjUgLTE3NnQ4Ni41IC0yNDRxMCAtMTkzIC0xNDAgLTMwMXQtMzgwIC0xMDhxLTI2MCAwIC00MDAgNjd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IlQiIGhvcml6LWFkdi14PSIxMTMzIiBkPSJNMTggMTMxMXYxNTFoMTA5NnYtMTUxaC00NjN2LTEzMTFoLTE3MHYxMzExaC00NjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IlUiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IlYiIGhvcml6LWFkdi14PSIxMjE5IiBkPSJNMCAxNDYyaDE4MGwzMzYgLTk0NnE1OCAtMTYzIDkyIC0zMTdxMzYgMTYyIDk0IDMyM2wzMzQgOTQwaDE4M2wtNTI3IC0xNDYyaC0xNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IlciIGhvcml6LWFkdi14PSIxODk2IiBkPSJNMjcgMTQ2MmgxODBsMjMxIC05MDNxNDggLTE5MCA3MCAtMzQ0cTI3IDE4MyA4MCAzNThsMjYyIDg4OWgxODBsMjc1IC04OTdxNDggLTE1NSA4MSAtMzUwcTE5IDE0MiA3MiAzNDZsMjMwIDkwMWgxODBsLTM5MSAtMTQ2MmgtMTY4bC0yOTUgOTc5cS0yMSA2NSAtNDcgMTY0dC0yNyAxMTlxLTIyIC0xMzIgLTcwIC0yODlsLTI4NiAtOTczaC0xNjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IlgiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNOCAwbDQ4NiA3NjRsLTQ1MyA2OThoMTg4bDM2MyAtNTc5bDM2NiA1NzloMTgxbC00NTMgLTY5Mmw0ODggLTc3MGgtMTkzbC0zOTMgNjQzbC00MDAgLTY0M2gtMTgweiIgLz4NCjxnbHlwaCB1bmljb2RlPSJZIiBob3Jpei1hZHYteD0iMTE0NyIgZD0iTTAgMTQ2MmgxODZsMzg3IC03MzFsMzkwIDczMWgxODRsLTQ4OCAtODk1di01NjdoLTE3MnY1NTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IloiIGhvcml6LWFkdi14PSIxMTY5IiBkPSJNODIgMHYxMzNsNzc2IDExNzZoLTc1MnYxNTNoOTU5di0xMzNsLTc3NiAtMTE3NWg3OTh2LTE1NGgtMTAwNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iWyIgaG9yaXotYWR2LXg9IjY3NCIgZD0iTTE2NiAtMzI0djE3ODZoNDU3di0xNDFoLTI4OXYtMTUwM2gyODl2LTE0MmgtNDU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJcIiBob3Jpei1hZHYteD0iNzUyIiBkPSJNMjMgMTQ2MmgxNjNsNTQ3IC0xNDYyaC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9Il0iIGhvcml6LWFkdi14PSI2NzQiIGQ9Ik01MSAtMTgyaDI4OXYxNTAzaC0yODl2MTQxaDQ1N3YtMTc4NmgtNDU3djE0MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iXiIgaG9yaXotYWR2LXg9IjExMTAiIGQ9Ik00OSA1NTFsNDM0IDkyMmg5OWw0NzcgLTkyMmgtMTUybC0zNzIgNzQ1bC0zMzQgLTc0NWgtMTUyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSJfIiBob3Jpei1hZHYteD0iOTE4IiBkPSJNLTQgLTE4NGg5MjZ2LTEzMWgtOTI2djEzMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iYCIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik0zOTMgMTU0OHYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iYSIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9ImIiIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTc2IDB2MTU1NmgxNjZ2LTM3OHEwIC0xMjcgLTggLTIyOGg4cTExNiAxNjQgMzQ0IDE2NHEyMTYgMCAzMzUuNSAtMTQ3LjV0MTE5LjUgLTQxNy41dC0xMjAuNSAtNDE5LjV0LTMzNC41IC0xNDkuNXEtMTA3IDAgLTE5NS41IDM5LjV0LTE0OC41IDEyMS41aC0xMmwtMzUgLTE0MWgtMTE5ek0zNDIgNTQ5cTAgLTIzMSA3NyAtMzMwLjV0MjQ3IC05OS41cTE1MyAwIDIyOCAxMTEuNXQ3NSAzMjAuNXEwIDIxNCAtNzUgMzE5dC0yMzIgMTA1IHEtMTcwIDAgLTI0NSAtOTcuNXQtNzUgLTMyOC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJjIiBob3Jpei1hZHYteD0iOTc1IiBkPSJNMTE1IDU0MXEwIDI3NSAxMzIuNSA0MjV0Mzc3LjUgMTUwcTc5IDAgMTU4IC0xN3QxMjQgLTQwbC01MSAtMTQxcS01NSAyMiAtMTIwIDM2LjV0LTExNSAxNC41cS0zMzQgMCAtMzM0IC00MjZxMCAtMjAyIDgxLjUgLTMxMHQyNDEuNSAtMTA4cTEzNyAwIDI4MSA1OXYtMTQ3cS0xMTAgLTU3IC0yNzcgLTU3cS0yMzggMCAtMzY4LjUgMTQ2LjV0LTEzMC41IDQxNC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJkIiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTExNSA1NDVxMCAyNzEgMTIwIDQyMXQzMzQgMTUwcTIyMyAwIDM0MiAtMTYyaDEzbC03IDc5bC00IDc3djQ0NmgxNjZ2LTE1NTZoLTEzNWwtMjIgMTQ3aC05cS0xMTUgLTE2NyAtMzQ0IC0xNjdxLTIxNSAwIC0zMzQuNSAxNDd0LTExOS41IDQxOHpNMjg3IDU0M3EwIC0yMTAgNzcgLTMxN3QyMjYgLTEwN3ExNzAgMCAyNDYuNSA5Mi41dDc2LjUgMjk4LjV2MzVxMCAyMzMgLTc3LjUgMzMyLjV0LTI0Ny41IDk5LjUgcS0xNDYgMCAtMjIzLjUgLTExMy41dC03Ny41IC0zMjAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iZSIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogIiAvPg0KPGdseXBoIHVuaWNvZGU9ImYiIGhvcml6LWFkdi14PSI2OTQiIGQ9Ik0yOSA5Njd2NzVsMTk2IDYwdjYxcTAgNDA0IDM1MyA0MDRxODcgMCAyMDQgLTM1bC00MyAtMTMzcS05NiAzMSAtMTY0IDMxcS05NCAwIC0xMzkgLTYyLjV0LTQ1IC0yMDAuNXYtNzFoMjc5di0xMjloLTI3OXYtOTY3aC0xNjZ2OTY3aC0xOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9ImciIGhvcml6LWFkdi14PSIxMTIyIiBkPSJNMzkgLTE4NnEwIDEwMCA2NCAxNzN0MTgwIDk5cS00MiAxOSAtNzAuNSA1OXQtMjguNSA5M3EwIDYwIDMyIDEwNXQxMDEgODdxLTg1IDM1IC0xMzguNSAxMTl0LTUzLjUgMTkycTAgMTgwIDEwOCAyNzcuNXQzMDYgOTcuNXE4NiAwIDE1NSAtMjBoMzc5di0xMDVsLTIwMyAtMjRxMjggLTM1IDUwIC05MS41dDIyIC0xMjcuNXEwIC0xNjEgLTExMCAtMjU3dC0zMDIgLTk2cS00OSAwIC05MiA4cS0xMDYgLTU2IC0xMDYgLTE0MSBxMCAtNDUgMzcgLTY2LjV0MTI3IC0yMS41aDE5NHExNzggMCAyNzMuNSAtNzV0OTUuNSAtMjE4cTAgLTE4MiAtMTQ2IC0yNzcuNXQtNDI2IC05NS41cS0yMTUgMCAtMzMxLjUgODB0LTExNi41IDIyNnpNMTk5IC0xODRxMCAtODkgNzUgLTEzNXQyMTUgLTQ2cTIwOSAwIDMwOS41IDYyLjV0MTAwLjUgMTY5LjVxMCA4OSAtNTUgMTIzLjV0LTIwNyAzNC41aC0xOTlxLTExMyAwIC0xNzYgLTU0dC02MyAtMTU1ek0yODkgNzQ1cTAgLTExNSA2NSAtMTc0IHQxODEgLTU5cTI0MyAwIDI0MyAyMzZxMCAyNDcgLTI0NiAyNDdxLTExNyAwIC0xODAgLTYzdC02MyAtMTg3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJoIiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE3NiAwdjE1NTZoMTY2di00NzFxMCAtODUgLTggLTE0MWgxMHE0OSA3OSAxMzkuNSAxMjQuNXQyMDYuNSA0NS41cTIwMSAwIDMwMS41IC05NS41dDEwMC41IC0zMDMuNXYtNzE1aC0xNjZ2NzA5cTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTczIDAgLTI1Mi41IC05NHQtNzkuNSAtMzA4di01NzNoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iaSIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE2MiAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41ek0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJqIiBob3Jpei1hZHYteD0iNTE4IiBkPSJNLTExMSAtMzMycTY5IC0yMCAxMzYgLTIwcTc4IDAgMTE0LjUgNDIuNXQzNi41IDEyOS41djEyNzZoMTY2di0xMjY0cTAgLTMyNCAtMjk5IC0zMjRxLTk1IDAgLTE1NCAyNXYxMzV6TTE2MiAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJrIiBob3Jpei1hZHYteD0iMTA3NSIgZD0iTTE3NiAwdjE1NTZoMTY0di04MjVxMCAtNTUgLTggLTE3MGg4cTQzIDYxIDEzMSAxNjBsMzU0IDM3NWgxOTdsLTQ0NCAtNDY3bDQ3NSAtNjI5aC0yMDFsLTM4NyA1MThsLTEyNSAtMTA4di00MTBoLTE2NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0ibCIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE3NiAwdjE1NTZoMTY2di0xNTU2aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9Im0iIGhvcml6LWFkdi14PSIxOTA1IiBkPSJNMTc2IDB2MTA5NmgxMzVsMjcgLTE1MGg4cTQ3IDgwIDEzMi41IDEyNXQxOTEuNSA0NXEyNTcgMCAzMzYgLTE4Nmg4cTQ5IDg2IDE0MiAxMzZ0MjEyIDUwcTE4NiAwIDI3OC41IC05NS41dDkyLjUgLTMwNS41di03MTVoLTE2NnY3MTNxMCAxMzEgLTU2IDE5Ni41dC0xNzQgNjUuNXEtMTU1IDAgLTIyOSAtODl0LTc0IC0yNzR2LTYxMmgtMTY2djcxM3EwIDEzMSAtNTYgMTk2LjV0LTE3NSA2NS41cS0xNTYgMCAtMjI4LjUgLTkzLjUgdC03Mi41IC0zMDYuNXYtNTc1aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9Im4iIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTc2IDB2MTA5NmgxMzVsMjcgLTE1MGg4cTUxIDgxIDE0MyAxMjUuNXQyMDUgNDQuNXExOTggMCAyOTggLTk1LjV0MTAwIC0zMDUuNXYtNzE1aC0xNjZ2NzA5cTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTcyIDAgLTI1MiAtOTN0LTgwIC0zMDd2LTU3NWgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJvIiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0icCIgaG9yaXotYWR2LXg9IjEyNTUiIGQ9Ik0xNzYgLTQ5MnYxNTg4aDEzNWwyMyAtMTUwaDhxNjQgOTAgMTQ5IDEzMHQxOTUgNDBxMjE4IDAgMzM2LjUgLTE0OXQxMTguNSAtNDE4cTAgLTI3MCAtMTIwLjUgLTQxOS41dC0zMzQuNSAtMTQ5LjVxLTEwNyAwIC0xOTUuNSAzOS41dC0xNDguNSAxMjEuNWgtMTJxMTIgLTk2IDEyIC0xODJ2LTQ1MWgtMTY2ek0zNDIgNTQ5cTAgLTIzMSA3NyAtMzMwLjV0MjQ3IC05OS41cTE0MiAwIDIyMi41IDExNXQ4MC41IDMxNyBxMCAyMDUgLTgwLjUgMzE0LjV0LTIyNi41IDEwOS41cS0xNjggMCAtMjQzIC05M3QtNzcgLTI5NnYtMzd6IiAvPg0KPGdseXBoIHVuaWNvZGU9InEiIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTE1IDU0NXEwIDI2OSAxMjAgNDIwdDMzNCAxNTFxMjI1IDAgMzQ2IC0xNzBoOWwyNCAxNTBoMTMxdi0xNTg4aC0xNjZ2NDY5cTAgMTAwIDExIDE3MGgtMTNxLTExNSAtMTY3IC0zNDYgLTE2N3EtMjEyIDAgLTMzMSAxNDl0LTExOSA0MTZ6TTI4NyA1NDNxMCAtMjA3IDc2LjUgLTMxNS41dDIyNi41IC0xMDguNXExNjYgMCAyNDIgODl0ODEgMzAwdjM3cTAgMjMwIC03OCAzMzF0LTI0NyAxMDFxLTE0NiAwIC0yMjMuNSAtMTEzLjUgdC03Ny41IC0zMjAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iciIgaG9yaXotYWR2LXg9IjgzNiIgZD0iTTE3NiAwdjEwOTZoMTM3bDE5IC0yMDNoOHE2MSAxMDcgMTQ3IDE2NXQxODkgNThxNzMgMCAxMzEgLTEybC0yMyAtMTU0cS02OCAxNSAtMTIwIDE1cS0xMzMgMCAtMjI3LjUgLTEwOHQtOTQuNSAtMjY5di01ODhoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0icyIgaG9yaXotYWR2LXg9Ijk3NyIgZD0iTTEwNiA4MjdxMCAxMzQgMTA5IDIxMS41dDI5OSA3Ny41cTE3NyAwIDM0NiAtNzJsLTU5IC0xMzVxLTE2NSA2OCAtMjk5IDY4cS0xMTggMCAtMTc4IC0zN3QtNjAgLTEwMnEwIC00NCAyMi41IC03NXQ3Mi41IC01OXQxOTIgLTgxcTE5NSAtNzEgMjYzLjUgLTE0M3Q2OC41IC0xODFxMCAtMTUzIC0xMTQgLTIzNnQtMzIwIC04M3EtMjE4IDAgLTM0MCA2OXYxNTRxNzkgLTQwIDE2OS41IC02M3QxNzQuNSAtMjNxMTMwIDAgMjAwIDQxLjUgdDcwIDEyNi41cTAgNjQgLTU1LjUgMTA5LjV0LTIxNi41IDEwNy41cS0xNTMgNTcgLTIxNy41IDk5LjV0LTk2IDk2LjV0LTMxLjUgMTI5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJ0IiBob3Jpei1hZHYteD0iNzIzIiBkPSJNMzEgOTY3djgwbDE1NyA2OWw3MCAyMzRoOTZ2LTI1NGgzMTh2LTEyOWgtMzE4di02NDVxMCAtOTkgNDcgLTE1MnQxMjkgLTUzcTQ0IDAgODUgNi41dDY1IDEzLjV2LTEyN3EtMjcgLTEzIC03OS41IC0yMS41dC05NC41IC04LjVxLTMxOCAwIC0zMTggMzM1djY1MmgtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJ1IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE2NCAzNzl2NzE3aDE2OHYtNzExcTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc2aDE2NnYtMTA5NmgtMTM3bC0yNCAxNDdoLTlxLTUxIC04MSAtMTQxLjUgLTEyNHQtMjA2LjUgLTQzcS0yMDAgMCAtMjk5LjUgOTV0LTk5LjUgMzA0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJ2IiBob3Jpei1hZHYteD0iMTAyNiIgZD0iTTAgMTA5NmgxNzhsMjM2IC02NTBxODAgLTIyOCA5NCAtMjk2aDhxMTEgNTMgNjkuNSAyMTkuNXQyNjIuNSA3MjYuNWgxNzhsLTQxNiAtMTA5NmgtMTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJ3IiBob3Jpei1hZHYteD0iMTU5MyIgZD0iTTIzIDEwOTZoMTc0cTEwNiAtNDEzIDE2MS41IC02Mjl0NjMuNSAtMjkxaDhxMTEgNTcgMzUuNSAxNDcuNXQ0Mi41IDE0My41bDIwMSA2MjloMTgwbDE5NiAtNjI5cTU2IC0xNzIgNzYgLTI4OWg4cTQgMzYgMjEuNSAxMTF0MjA4LjUgODA3aDE3MmwtMzAzIC0xMDk2aC0xOTdsLTIwMSA2NDNxLTE5IDU5IC03MSAyNjhoLThxLTQwIC0xNzUgLTcwIC0yNzBsLTIwNyAtNjQxaC0xOTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IngiIGhvcml6LWFkdi14PSIxMDczIiBkPSJNMzkgMGw0MDEgNTYxbC0zODEgNTM1aDE4OWwyODkgLTQyMGwyODggNDIwaDE4N2wtMzgxIC01MzVsNDAxIC01NjFoLTE4OGwtMzA3IDQ0NGwtMzEwIC00NDRoLTE4OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0ieSIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9InoiIGhvcml6LWFkdi14PSI5NTgiIGQ9Ik04MiAwdjExM2w1OTggODU0aC01NjF2MTI5aDc0M3YtMTI5bC01OTAgLTgzOGg2MDV2LTEyOWgtNzk1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSJ7IiBob3Jpei1hZHYteD0iNzc2IiBkPSJNNjEgNDk4djE0MXExMzAgMiAxODggNDh0NTggMTQydjMwNnEwIDE1NSAxMDggMjQxdDI5MCA4NnYtMTM5cS0yMzAgLTYgLTIzMCAtMTk5di0yOTVxMCAtMjE1IC0yMjMgLTI1NHYtMTJxMjIzIC0zOSAyMjMgLTI1NHYtMjk3cTAgLTEwMiA1OC41IC0xNDh0MTcxLjUgLTQ4di0xNDBxLTE5MCAyIC0yOTQgODd0LTEwNCAyMzl2MzAzcTAgMTA0IC02MyAxNDguNXQtMTgzIDQ0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9InwiIGhvcml6LWFkdi14PSIxMTI4IiBkPSJNNDk0IC00OTZ2MjA1MmgxNDF2LTIwNTJoLTE0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0ifSIgaG9yaXotYWR2LXg9Ijc3NiIgZD0iTTcyIC0xODRxMTExIDIgMTY5IDQ4dDU4IDE0OHYyOTdxMCAxMTQgNTUgMTc0dDE2OCA4MHYxMnEtMjIzIDM5IC0yMjMgMjU0djI5NXEwIDE5MyAtMjI3IDE5OXYxMzlxMTg0IDAgMjg5LjUgLTg3dDEwNS41IC0yNDB2LTMwNnEwIC05NyA1OSAtMTQyLjV0MTg5IC00Ny41di0xNDFxLTEyMiAwIC0xODUgLTQ0LjV0LTYzIC0xNDguNXYtMzAzcTAgLTE1MyAtMTAyLjUgLTIzOC41dC0yOTIuNSAtODcuNXYxNDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9In4iIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDU5MnYxNTFxMTAwIDEwOSAyNDQgMTA5cTY4IDAgMTI0LjUgLTE0dDE0NS41IC01MnE2NiAtMjggMTE1IC00MS41dDk2IC0xMy41cTU0IDAgMTE4IDMydDExOCA4OXYtMTUwcS0xMDIgLTExMCAtMjQ0IC0xMTBxLTcyIDAgLTEzNSAxNi41dC0xMzUgNDguNXEtNzUgMzIgLTEyMCA0NHQtOTMgMTJxLTUzIDAgLTExNi41IC0zMy41dC0xMTcuNSAtODcuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTE7IiBob3Jpei1hZHYteD0iNTQ3IiBkPSJNMTUyIDk4M3EwIDYzIDMxLjUgOTl0ODguNSAzNnE1MSAwIDg2IC0zMnQzNSAtMTAzcTAgLTEzNSAtMTIxIC0xMzVxLTYwIDAgLTkwIDM1LjV0LTMwIDk5LjV6TTE2OCAtMzczbDUxIDEwNTdoMTA1bDUxIC0xMDU3aC0yMDd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGEyOyIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xOTAgNzQxcTAgNTA4IDM5NiA1NzB2MTcyaDEzNXYtMTY0cTc1IC0zIDE0NiAtMTkuNXQxMjAgLTM5LjVsLTQ5IC0xNDBxLTEzMyA1MSAtMjQyIDUxcS0xNzIgMCAtMjUzIC0xMDUuNXQtODEgLTMyMi41cTAgLTIxMiA3OS41IC0zMTMuNXQyNDYuNSAtMTAxLjVxMTQxIDAgMjgzIDU5di0xNDdxLTEwNSAtNTQgLTI1MiAtNjB2LTIwMGgtMTMzdjIwNnEtMjAzIDMyIC0yOTkuNSAxNjguNXQtOTYuNSAzODYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTM7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTYzIDB2MTQxcTIwNSA0NyAyMDUgMjkxdjIyM2gtMTk4djEyN2gxOTh2MzE2cTAgMTc4IDExMiAyODAuNXQzMDIgMTAyLjV0MzYwIC04NGwtNjEgLTEzM3EtMTU0IDc3IC0yOTcgNzdxLTEyMyAwIC0xODUuNSAtNjJ0LTYyLjUgLTIwMnYtMjk1aDQyMnYtMTI3aC00MjJ2LTIyMXEwIC0xMDAgLTMyLjUgLTE2OHQtMTA2LjUgLTExMmg3OTV2LTE1NGgtMTAyOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTQ7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTEyMyAxMDkybDk0IDkybDEzNSAtMTMzcTEwNCA3MyAyMzQgNzNxMTI3IDAgMjI5IC03M2wxMzcgMTMzbDk1IC05MmwtMTM0IC0xMzhxNzQgLTExMyA3NCAtMjMxcTAgLTEzMSAtNzQgLTIzNGwxMzEgLTEzNWwtOTIgLTkybC0xMzcgMTMzcS0xMDIgLTcxIC0yMjkgLTcxcS0xMzQgMCAtMjM0IDczbC0xMzUgLTEzM2wtOTIgOTJsMTMzIDEzNnEtNzQgMTA3IC03NCAyMzFxMCAxMjIgNzQgMjI5ek0zMTMgNzIzcTAgLTExMiA3OC41IC0xOTIgdDE5NC41IC04MHQxOTUgNzkuNXQ3OSAxOTIuNXEwIDExNCAtODAgMTk1dC0xOTQgODFxLTExNiAwIC0xOTQuNSAtODJ0LTc4LjUgLTE5NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTU7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTMxIDE0NjJoMTc4bDM3NSAtNzI3bDM3OSA3MjdoMTc0bC00MTYgLTc3MGgyNjJ2LTEyN2gtMzE3di0xNzBoMzE3di0xMjdoLTMxN3YtMjY4aC0xNjR2MjY4aC0zMTZ2MTI3aDMxNnYxNzBoLTMxNnYxMjdoMjU2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhNjsiIGhvcml6LWFkdi14PSIxMTI4IiBkPSJNNDk0IDI4MWgxNDF2LTc3N2gtMTQxdjc3N3pNNDk0IDc4MHY3NzZoMTQxdi03NzZoLTE0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTc7IiBob3Jpei1hZHYteD0iMTA1NyIgZD0iTTEyMyA1N3YxNDhxNzggLTM3IDE3NSAtNTkuNXQxNzkgLTIyLjVxMTM0IDAgMjA0LjUgMzh0NzAuNSAxMDlxMCA0NiAtMjQgNzV0LTc4IDU4dC0xNjkgNzJxLTE0MiA1MiAtMjA5IDk3dC0xMDAgMTAydC0zMyAxMzVxMCA4NiA0MyAxNTQuNXQxMjEgMTA1LjVxLTc0IDQwIC0xMTYgOTUuNXQtNDIgMTQwLjVxMCAxMjEgMTAzLjUgMTkwLjV0MzAwLjUgNjkuNXE5NCAwIDE3My41IC0xNC41dDE3Ni41IC01My41bC01MyAtMTMxIHEtOTggMzkgLTE2NS41IDUyLjV0LTE0My41IDEzLjVxLTExNiAwIC0xNzQgLTI5LjV0LTU4IC05My41cTAgLTYwIDYxLjUgLTEwMnQyMTUuNSAtOTdxMTg2IC02OCAyNjEgLTE0My41dDc1IC0xODIuNXEwIC05MCAtNDEgLTE2MC41dC0xMTUgLTExMS41cTE1MyAtODEgMTUzIC0yMjdxMCAtMTQwIC0xMTcgLTIxNi41dC0zMjkgLTc2LjVxLTIxOCAwIC0zNDYgNjV6TTI4NSA4MjlxMCAtNzcgNjYgLTEyOS41dDIzMyAtMTEzLjVsNDkgLTE5IHExMzcgODAgMTM3IDE5MXEwIDgzIC03My41IDEzOXQtMjU4LjUgMTEzcS02OCAtMTkgLTExMC41IC02OXQtNDIuNSAtMTEyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhODsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMzA5IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTY5MCAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YTk7IiBob3Jpei1hZHYteD0iMTcwNCIgZD0iTTEwMCA3MzFxMCAyMDAgMTAwIDM3NXQyNzUgMjc2dDM3NyAxMDFxMjAwIDAgMzc1IC0xMDB0Mjc2IC0yNzV0MTAxIC0zNzdxMCAtMTk3IC05NyAtMzcwdC0yNzIgLTI3N3QtMzgzIC0xMDRxLTIwNyAwIC0zODIgMTAzLjV0LTI3Mi41IDI3Ni41dC05Ny41IDM3MXpNMjA1IDczMXEwIC0xNzMgODcgLTMyMy41dDIzNy41IC0yMzd0MzIyLjUgLTg2LjVxMTc0IDAgMzIzIDg3dDIzNi41IDIzNS41dDg3LjUgMzI0LjVxMCAxNzQgLTg3IDMyMyB0LTIzNS41IDIzNi41dC0zMjQuNSA4Ny41cS0xNzQgMCAtMzIzIC04N3QtMjM2LjUgLTIzNS41dC04Ny41IC0zMjQuNXpNNDgxIDczMXEwIDIwOSAxMTAuNSAzMzJ0MzAxLjUgMTIzcTEyOCAwIDI0NiAtNjBsLTU4IC0xMThxLTEwOCA1MSAtMTg4IDUxcS0xMjUgMCAtMTkyLjUgLTg3dC02Ny41IC0yNDFxMCAtMTY4IDYzLjUgLTI0OXQxOTQuNSAtODFxODYgMCAyMTEgNDV2LTEyNHEtNDggLTIwIC05OC41IC0zNHQtMTIwLjUgLTE0IHEtMTk0IDAgLTI5OCAxMjAuNXQtMTA0IDMzNi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhYTsiIGhvcml6LWFkdi14PSI3MjUiIGQ9Ik03MCA5ODlxMCAxMDIgNzcgMTU0LjV0MjQyIDU4LjVsMTE3IDR2MzlxMCAxMzMgLTE0OCAxMzNxLTEwMCAwIC0yMDQgLTUxbC00MyA5NnExMTQgNTYgMjQ3IDU2cTEzMCAwIDE5OC41IC01Mi41dDY4LjUgLTE3My41di00NTJoLTkzbC0yNCA4NHEtOTIgLTk3IC0yMzIgLTk3cS05NSAwIC0xNTAuNSA0OS41dC01NS41IDE1MS41ek0xOTMgOTg5cTAgLTEwMCAxMTIgLTEwMHEyMDEgMCAyMDEgMTgwdjQ5bC05OCAtNCBxLTExMiAtNCAtMTYzLjUgLTMyLjV0LTUxLjUgLTkyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGFiOyIgaG9yaXotYWR2LXg9IjEwMTgiIGQ9Ik04MiA1MjR2MjdsMzQyIDQwN2wxMTkgLTY5bC0yODkgLTM1MGwyODkgLTM1MWwtMTE5IC03MXpNNDc3IDUyNHYyN2wzNDQgNDA3bDExNyAtNjlsLTI4NyAtMzUwbDI4NyAtMzUxbC0xMTcgLTcxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhYzsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDY1M3YxMzhoOTYxdi01MjdoLTEzN3YzODloLTgyNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YWQ7IiBob3Jpei1hZHYteD0iNjU5IiBkPSJNODQgNDczdjE1Mmg0OTF2LTE1MmgtNDkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhZTsiIGhvcml6LWFkdi14PSIxNzA0IiBkPSJNMTAwIDczMXEwIDIwMCAxMDAgMzc1dDI3NSAyNzZ0Mzc3IDEwMXEyMDAgMCAzNzUgLTEwMHQyNzYgLTI3NXQxMDEgLTM3N3EwIC0xOTcgLTk3IC0zNzB0LTI3MiAtMjc3dC0zODMgLTEwNHEtMjA3IDAgLTM4MiAxMDMuNXQtMjcyLjUgMjc2LjV0LTk3LjUgMzcxek0yMDUgNzMxcTAgLTE3MyA4NyAtMzIzLjV0MjM3LjUgLTIzN3QzMjIuNSAtODYuNXExNzQgMCAzMjMgODd0MjM2LjUgMjM1LjV0ODcuNSAzMjQuNXEwIDE3NCAtODcgMzIzIHQtMjM1LjUgMjM2LjV0LTMyNC41IDg3LjVxLTE3NCAwIC0zMjMgLTg3dC0yMzYuNSAtMjM1LjV0LTg3LjUgLTMyNC41ek01NzUgMjg1djg5MWgyNjFxMTY2IDAgMjQzLjUgLTY1dDc3LjUgLTE5OHEwIC04MCAtNDIuNSAtMTQxLjV0LTExOS41IC05MS41bDIzOCAtMzk1aC0xNjhsLTIwNyAzNTRoLTEzNXYtMzU0aC0xNDh6TTcyMyA3NjJoMTA4cTgwIDAgMTI4LjUgNDEuNXQ0OC41IDEwNS41cTAgNzUgLTQzIDEwNy41dC0xMzYgMzIuNWgtMTA2IHYtMjg3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hhZjsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNLTYgMTU1NnYxMjdoMTAzNnYtMTI3aC0xMDM2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hiMDsiIGhvcml6LWFkdi14PSI4NzciIGQ9Ik0xMjcgMTE3MXEwIDEzMCA5MC41IDIyMXQyMjAuNSA5MXQyMjEgLTkwLjV0OTEgLTIyMS41cTAgLTg0IC00MSAtMTU1LjV0LTExNCAtMTEzLjV0LTE1NyAtNDJxLTEzMCAwIC0yMjAuNSA5MHQtOTAuNSAyMjF6TTI0MiAxMTcxcTAgLTgyIDU4LjUgLTEzOXQxMzkuNSAtNTdxODAgMCAxMzcuNSA1Ni41dDU3LjUgMTM5LjVxMCA4NCAtNTYuNSAxNDAuNXQtMTM4LjUgNTYuNXEtODMgMCAtMTQwLjUgLTU3dC01Ny41IC0xNDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGIxOyIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xMDQgNjUzdjEzOGg0MTB2NDI4aDEzOXYtNDI4aDQxMnYtMTM4aC00MTJ2LTQyNmgtMTM5djQyNmgtNDEwek0xMDQgMXYxMzhoOTYxdi0xMzhoLTk2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YjI7IiBob3Jpei1hZHYteD0iNzExIiBkPSJNNDkgNTg2djEwNGwyMzYgMjMwcTg5IDg2IDEzMCAxMzQuNXQ1Ny41IDg2LjV0MTYuNSA5MnEwIDY4IC00MCAxMDIuNXQtMTAzIDM0LjVxLTUyIDAgLTEwMSAtMTl0LTExOCAtNjlsLTY2IDg4cTEzMSAxMTEgMjgzIDExMXExMzIgMCAyMDUuNSAtNjV0NzMuNSAtMTc3cTAgLTgwIC00NC41IC0xNTUuNXQtMTkxLjUgLTIxMy41bC0xNzQgLTE2NWg0NDB2LTExOWgtNjA0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hiMzsiIGhvcml6LWFkdi14PSI3MTEiIGQ9Ik0zMyA2MjV2MTIzcTE0NyAtNjggMjcwIC02OHEyMTEgMCAyMTEgMTYycTAgMTQ1IC0yMzEgMTQ1aC0xMTd2MTA3aDExOXExMDMgMCAxNTIuNSAzOS41dDQ5LjUgMTA3LjVxMCA2MSAtNDAgOTV0LTEwNyAzNHEtNjYgMCAtMTIyIC0yMS41dC0xMTIgLTU2LjVsLTY5IDkwcTYzIDQ1IDEzMyA3MnQxNjQgMjdxMTM2IDAgMjE0LjUgLTU5LjV0NzguNSAtMTY2LjVxMCAtODAgLTQxIC0xMzEuNXQtMTA5IC03NC41cTE3NiAtNDcgMTc2IC0yMDkgcTAgLTEyOCAtOTIgLTE5OS41dC0yNjAgLTcxLjVxLTE1MiAwIC0yNjggNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGI0OyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik0zOTMgMTI0MXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YjU7IiBob3Jpei1hZHYteD0iMTI2OCIgZD0iTTE3NiAtNDkydjE1ODhoMTY2di03MTVxMCAtMjYyIDI1NCAtMjYycTE3MSAwIDI1MC41IDk0LjV0NzkuNSAzMDYuNXY1NzZoMTY2di0xMDk2aC0xMzZsLTI2IDE0N2gtMTBxLTExMSAtMTY3IC0zNDAgLTE2N3EtMTUwIDAgLTIzOCA5MmgtMTBxMTAgLTg0IDEwIC0yNDR2LTMyMGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hiNjsiIGhvcml6LWFkdi14PSIxMzQxIiBkPSJNMTEzIDEwNDJxMCAyNjAgMTA5IDM4N3QzNDEgMTI3aDU1N3YtMTgxNmgtMTE0djE3MTJoLTIxM3YtMTcxMmgtMTE1djgxOXEtNjIgLTE4IC0xNDYgLTE4cS0yMTYgMCAtMzE3LjUgMTI1dC0xMDEuNSAzNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGI3OyIgaG9yaXotYWR2LXg9IjU0NSIgZD0iTTE1MiA3MjNxMCA2NiAzMSAxMDAuNXQ4NyAzNC41cTU4IDAgOTAuNSAtMzQuNXQzMi41IC0xMDAuNXEwIC02NSAtMzMgLTEwMHQtOTAgLTM1cS01MSAwIC04NC41IDMxLjV0LTMzLjUgMTAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGI4OyIgaG9yaXotYWR2LXg9IjQ2NSIgZD0iTTM3IC0zNzdxNDUgLTggMTA0IC04cTc5IDAgMTE5LjUgMjB0NDAuNSA3NHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGI5OyIgaG9yaXotYWR2LXg9IjcxMSIgZD0iTTc2IDEyODBsMjYyIDE4MmgxNDN2LTg3NmgtMTMzdjU3OXEwIDkxIDYgMTgxcS0yMiAtMjIgLTQ5IC00NC41dC0xNjIgLTExNy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hiYTsiIGhvcml6LWFkdi14PSI3NjgiIGQ9Ik02NiAxMTM1cTAgMTYzIDg0IDI1My41dDIzNSA5MC41cTE1MiAwIDIzNC41IC05MXQ4Mi41IC0yNTNxMCAtMTY0IC04NS41IC0yNTUuNXQtMjM1LjUgLTkxLjVxLTE0NiAwIC0yMzAuNSA5M3QtODQuNSAyNTR6TTE4OCAxMTM1cTAgLTEyMiA0NS41IC0xODN0MTQ5LjUgLTYxcTEwNSAwIDE1MSA2MXQ0NiAxODNxMCAxMjMgLTQ2IDE4MnQtMTUxIDU5cS0xMDMgMCAtMTQ5IC01OXQtNDYgLTE4MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YmI7IiBob3Jpei1hZHYteD0iMTAxOCIgZD0iTTgwIDE4OGwyODcgMzUxbC0yODcgMzUwbDExNyA2OWwzNDQgLTQwN3YtMjdsLTM0NCAtNDA3ek00NzUgMTg4bDI4NyAzNTFsLTI4NyAzNTBsMTE3IDY5bDM0NCAtNDA3di0yN2wtMzQ0IC00MDd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGJjOyIgaG9yaXotYWR2LXg9IjE1OTciIGQ9Ik0yNTIgMGw5MDMgMTQ2MmgxNDNsLTkwMyAtMTQ2MmgtMTQzek03NSAxMjgwbDI2MiAxODJoMTQzdi04NzZoLTEzM3Y1NzlxMCA5MSA2IDE4MXEtMjIgLTIyIC00OSAtNDQuNXQtMTYyIC0xMTcuNXpNODE3IDIwM3YxMDFsNDA4IDU3OWgxMzl2LTU2M2gxMjV2LTExN2gtMTI1di0yMDJoLTE0NXYyMDJoLTQwMnpNOTU3IDMyMGgyNjJ2MTk1cTAgMTM0IDYgMjA5cS01IC0xMiAtMTcgLTMxLjV0LTI3IC00MS41bC0zMCAtNDYgcS0xNSAtMjIgLTI2IC0zOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YmQ7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTE4NCAwbDkwMyAxNDYyaDE0M2wtOTAzIC0xNDYyaC0xNDN6TTQ2IDEyODBsMjYyIDE4MmgxNDN2LTg3NmgtMTMzdjU3OXEwIDkxIDYgMTgxcS0yMiAtMjIgLTQ5IC00NC41dC0xNjIgLTExNy41ek04OTUgMXYxMDRsMjM2IDIzMHE4OSA4NiAxMzAgMTM0LjV0NTcuNSA4Ni41dDE2LjUgOTJxMCA2OCAtNDAgMTAyLjV0LTEwMyAzNC41cS01MiAwIC0xMDEgLTE5dC0xMTggLTY5bC02NiA4OHExMzEgMTExIDI4MyAxMTEgcTEzMiAwIDIwNS41IC02NXQ3My41IC0xNzdxMCAtODAgLTQ0LjUgLTE1NS41dC0xOTEuNSAtMjEzLjVsLTE3NCAtMTY1aDQ0MHYtMTE5aC02MDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGJlOyIgaG9yaXotYWR2LXg9IjE1OTciIGQ9Ik0yNiA2MjV2MTIzcTE0NyAtNjggMjcwIC02OHEyMTEgMCAyMTEgMTYycTAgMTQ1IC0yMzEgMTQ1aC0xMTd2MTA3aDExOXExMDMgMCAxNTIuNSAzOS41dDQ5LjUgMTA3LjVxMCA2MSAtNDAgOTV0LTEwNyAzNHEtNjYgMCAtMTIyIC0yMS41dC0xMTIgLTU2LjVsLTY5IDkwcTYzIDQ1IDEzMyA3MnQxNjQgMjdxMTM2IDAgMjE0LjUgLTU5LjV0NzguNSAtMTY2LjVxMCAtODAgLTQxIC0xMzEuNXQtMTA5IC03NC41cTE3NiAtNDcgMTc2IC0yMDkgcTAgLTEyOCAtOTIgLTE5OS41dC0yNjAgLTcxLjVxLTE1MiAwIC0yNjggNTZ6TTM0NCAwbDkwMyAxNDYyaDE0M2wtOTAzIC0xNDYyaC0xNDN6TTg5NyAyMDN2MTAxbDQwOCA1NzloMTM5di01NjNoMTI1di0xMTdoLTEyNXYtMjAyaC0xNDV2MjAyaC00MDJ6TTEwMzcgMzIwaDI2MnYxOTVxMCAxMzQgNiAyMDlxLTUgLTEyIC0xNyAtMzEuNXQtMjcgLTQxLjVsLTMwIC00NnEtMTUgLTIyIC0yNiAtMzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGJmOyIgaG9yaXotYWR2LXg9Ijg3OSIgZD0iTTUxIC0zN3EwIDcwIDE3LjUgMTIyLjV0NDkuNSA5N3Q3Ni41IDg1LjV0OTguNSA4OHExMDEgODggMTMzLjUgMTQ2dDMyLjUgMTUxdjMxaDEzMXYtNTFxMCAtMTIyIC0zNy41IC0xOTZ0LTEzNC41IC0xNThxLTEyMSAtMTA2IC0xNTEuNSAtMTQzLjV0LTQzIC03NnQtMTIuNSAtOTQuNXEwIC0xMDAgNjYgLTE1Ni41dDE4OCAtNTYuNXE4MCAwIDE1NSAxOXQxNzMgNjdsNTkgLTEzNXEtMTk3IC05NiAtMzk1IC05NnEtMTkwIDAgLTI5OCA5MyB0LTEwOCAyNjN6TTM5NyA5ODNxMCA2NCAzMyA5OS41dDg4IDM1LjVxNTEgMCA4NiAtMzJ0MzUgLTEwM3EwIC0xMzUgLTEyMSAtMTM1cS01OSAwIC05MCAzNC41dC0zMSAxMDAuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YzA7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMzMxIDE4ODZ2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGMxOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTUyNiAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hjMjsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0zMDMgMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGMzOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTI2OCAxNTc5cTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjUgcS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hjNDsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0zNjQgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzQ1IDE3MzFxMCA1MiAyNi41IDc1IHQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4YzU7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNNDI0IDE1ODVxMCA5OCA2MC41IDE1NS41dDE2MC41IDU3LjVxMTAxIDAgMTYzIC01OS41dDYyIC0xNTEuNXEwIC05OCAtNjEuNSAtMTU3LjV0LTE2My41IC01OS41cS0xMDEgMCAtMTYxIDU4LjV0LTYwIDE1Ni41ek01MjggMTU4NSBxMCAtNTYgMzAgLTg2LjV0ODcgLTMwLjVxNTIgMCA4NC41IDMwLjV0MzIuNSA4Ni41dC0zMyA4Ni41dC04NCAzMC41dC04NCAtMzAuNXQtMzMgLTg2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGM2OyIgaG9yaXotYWR2LXg9IjE3ODgiIGQ9Ik0tMiAwbDY5OCAxNDYyaDk2OXYtMTUxaC01ODB2LTQ3MWg1NDF2LTE1MGgtNTQxdi01MzhoNTgwdi0xNTJoLTc1MHY0NjVoLTUxNGwtMjI3IC00NjVoLTE3NnpNNDY5IDYxOGg0NDZ2NjkzaC0xMTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGM3OyIgaG9yaXotYWR2LXg9IjEyOTIiIGQ9Ik0xMjUgNzMzcTAgMjI2IDg0LjUgMzk2dDI0NCAyNjJ0Mzc1LjUgOTJxMjMwIDAgNDAyIC04NGwtNzIgLTE0NnEtMTY2IDc4IC0zMzIgNzhxLTI0MSAwIC0zODAuNSAtMTYwLjV0LTEzOS41IC00MzkuNXEwIC0yODcgMTM0LjUgLTQ0My41dDM4My41IC0xNTYuNXExNTMgMCAzNDkgNTV2LTE0OXEtMTUyIC01NyAtMzc1IC01N3EtMzIzIDAgLTQ5OC41IDE5NnQtMTc1LjUgNTU3ek01NTEgLTM3N3E0NSAtOCAxMDQgLThxNzkgMCAxMTkuNSAyMCB0NDAuNSA3NHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGM4OyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0zMjAgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Yzk7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTQ1NiAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hjYTsiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUxaC02NDV2LTQ3MWg2MDZ2LTE1MGgtNjA2di01MzhoNjQ1di0xNTJoLTgxNXpNMjYzIDE1Nzl2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hjYjsiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUxaC02NDV2LTQ3MWg2MDZ2LTE1MGgtNjA2di01MzhoNjQ1di0xNTJoLTgxNXpNMzI3IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTcwOCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41IHQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGNjOyIgaG9yaXotYWR2LXg9IjU3MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6TTUgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Y2Q7IiBob3Jpei1hZHYteD0iNTcxIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTE0NjJoLTE3MHpNMTc5IDE1Nzl2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGNlOyIgaG9yaXotYWR2LXg9IjU3MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6TS01NyAxNTc5djIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Y2Y7IiBob3Jpei1hZHYteD0iNTcxIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTE0NjJoLTE3MHpNNSAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek0zODYgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGQwOyIgaG9yaXotYWR2LXg9IjE0NzkiIGQ9Ik00NyA2NDl2MTUwaDE1NHY2NjNoNDM0cTMzNyAwIDUyNyAtMTg3LjV0MTkwIC01MjkuNXEwIC0zNjIgLTE5Ni41IC01NTMuNXQtNTY1LjUgLTE5MS41aC0zODl2NjQ5aC0xNTR6TTM3MSAxNDdoMTkwcTYxMCAwIDYxMCA1OTJxMCA1NzYgLTU2OSA1NzZoLTIzMXYtNTE2aDM3OXYtMTUwaC0zNzl2LTUwMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZDE7IiBob3Jpei1hZHYteD0iMTU0NCIgZD0iTTIwMSAwdjE0NjJoMTkybDc5NyAtMTIyMmg4cS0yIDI4IC05IDE3NHEtNSAxMTQgLTUgMTc3djMydjgzOWgxNTl2LTE0NjJoLTE5NGwtNzk5IDEyMjdoLThxMTYgLTIxNiAxNiAtMzk2di04MzFoLTE1N3pNNDExIDE1NzlxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNSBxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGQyOyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDUgNzMzcTAgLTI5NyAxMjYuNSAtNDUwLjV0MzY3LjUgLTE1My41cTI0MyAwIDM2NyAxNTN0MTI0IDQ1MXEwIDI5NSAtMTIzLjUgNDQ3LjV0LTM2NS41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1My41IHQtMTI2LjUgLTQ0Ni41ek01MTQgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZDM7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTY1OSAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkNDsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNDQ4IDE1Nzl2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkNTsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNDE4IDE1NzlxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDF0LTcwLjUgMTguNXEtNTAgMCAtNzUuNSAtMzB0LTM5LjUgLTkxaC05OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZDY7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTUyMiAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek05MDMgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGQ3OyIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik0xMzMgMTA3NWwxMDAgMTAxbDM1MyAtMzU1bDM1NCAzNTVsOTYgLTk5bC0zNTIgLTM1NGwzNTAgLTM1MmwtOTYgLTk5bC0zNTQgMzUxbC0zNDggLTM1MWwtMTAxIDk5bDM1MCAzNTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGQ4OyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMjA5IDAgMzY2IC05NGw5NyAxMzVsMTIwIC04MGwtMTA2IC0xNDhxMTkyIC0yMDIgMTkyIC01NjVxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0yMzUgMCAtMzgzIDEwMGwtMTAxIC0xNDFsLTEyMCA3OWwxMDggMTU0cS0xNzggMTk4IC0xNzggNTYzek0zMDUgNzMzcTAgLTI2MiAxMDEgLTQxNmw2NjkgOTQzcS0xMDYgNzMgLTI3NCA3MyBxLTI0MyAwIC0zNjkuNSAtMTUzLjV0LTEyNi41IC00NDYuNXpNNTA4IDIxMXExMTUgLTgyIDI5MSAtODJxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjcyIC0xMTAgNDI2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkOTsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTQ2MyAxODg2djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkYTsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTYwMCAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkYjsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTM5MyAxNTc5djIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODYgaC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGRjOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xODYgNTIwdjk0MmgxNzB2LTk1NHEwIC0xODMgMTAwIC0yODF0Mjk0IC05OHExODUgMCAyODUgOTguNXQxMDAgMjgyLjV2OTUyaDE3MHYtOTQ2cTAgLTI1MCAtMTUxIC0zOTN0LTQxNSAtMTQzdC00MDguNSAxNDR0LTE0NC41IDM5NnpNNDYxIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6IE04NDIgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGRkOyIgaG9yaXotYWR2LXg9IjExNDciIGQ9Ik0wIDE0NjJoMTg2bDM4NyAtNzMxbDM5MCA3MzFoMTg0bC00ODggLTg5NXYtNTY3aC0xNzJ2NTU5ek00NDIgMTU3OXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZGU7IiBob3Jpei1hZHYteD0iMTI1MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0yNTZoMjE1cTI4MSAwIDQyMCAtMTAzLjV0MTM5IC0zMTguNXEwIC0yMjcgLTE1MS41IC0zNDZ0LTQzOC41IC0xMTloLTE4NHYtMzE5aC0xNzB6TTM3MSA0NjVoMTY4cTIyNiAwIDMyNyA3MS41dDEwMSAyMzUuNXEwIDE0OSAtOTUgMjE4dC0yOTcgNjloLTIwNHYtNTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hkZjsiIGhvcml6LWFkdi14PSIxMjc0IiBkPSJNMTc2IDB2MTIwMnEwIDE3OCAxMTAgMjcxLjV0MzMyIDkzLjVxMjA2IDAgMzE4LjUgLTc4LjV0MTEyLjUgLTIyMi41cTAgLTEzNSAtMTQzIC0yNTBxLTg4IC03MCAtMTE2IC0xMDMuNXQtMjggLTY2LjVxMCAtMzIgMTMuNSAtNTN0NDkgLTQ5LjV0MTEzLjUgLTc5LjVxMTQwIC05NSAxOTEgLTE3My41dDUxIC0xNzkuNXEwIC0xNjAgLTk3IC0yNDUuNXQtMjc2IC04NS41cS0xODggMCAtMjk1IDY5djE1NHE2MyAtMzkgMTQxIC02Mi41IHQxNTAgLTIzLjVxMjE1IDAgMjE1IDE4MnEwIDc1IC00MS41IDEyOC41dC0xNTEuNSAxMjMuNXEtMTI3IDgyIC0xNzUgMTQzLjV0LTQ4IDE0NS41cTAgNjMgMzQuNSAxMTZ0MTA1LjUgMTA2cTc1IDU3IDEwNyAxMDJ0MzIgOThxMCA4MCAtNjggMTIyLjV0LTE5NSA0Mi41cS0yNzYgMCAtMjc2IC0yMjN2LTEyMDRoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZTA7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMjc5IDE1NDh2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGUxOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTQzNiAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hlMjsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yMjggMTI0MXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGUzOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTE5NyAxMjQxcTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxIHQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hlNDsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yNzkgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjYwIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzUgcTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZTU7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMzU4IDE0NTZxMCA5OCA2MC41IDE1NS41dDE2MC41IDU3LjVxMTAxIDAgMTYzIC01OS41dDYyIC0xNTEuNXEwIC05OCAtNjEuNSAtMTU3LjV0LTE2My41IC01OS41cS0xMDEgMCAtMTYxIDU4LjV0LTYwIDE1Ni41ek00NjIgMTQ1NnEwIC01NiAzMCAtODYuNXQ4NyAtMzAuNXE1MiAwIDg0LjUgMzAuNSB0MzIuNSA4Ni41dC0zMyA4Ni41dC04NCAzMC41dC04NCAtMzAuNXQtMzMgLTg2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGU2OyIgaG9yaXotYWR2LXg9IjE3NTciIGQ9Ik05NCAzMDNxMCAxNjEgMTI0IDI1MC41dDM3OCA5Ny41bDE4NCA2djY4cTAgMTI5IC01OCAxOTAuNXQtMTc3IDYxLjVxLTE0NCAwIC0zMDcgLTg0bC01MiAxMjdxNzQgNDEgMTczLjUgNjcuNXQxOTcuNSAyNi41cTEzMCAwIDIxMi41IC00My41dDEyMy41IC0xMzguNXE1MyA4OCAxMzguNSAxMzZ0MTk1LjUgNDhxMTkyIDAgMzA4IC0xMzMuNXQxMTYgLTM1NS41di0xMDdoLTcwMXE4IC0zOTUgMzIyIC0zOTVxOTEgMCAxNjkuNSAxNy41IHQxNjIuNSA1Ni41di0xNDhxLTg2IC0zOCAtMTYwLjUgLTU0LjV0LTE3NS41IC0xNi41cS0yODkgMCAtNDE0IDIzM3EtODEgLTEyNyAtMTc5LjUgLTE4MHQtMjMyLjUgLTUzcS0xNjMgMCAtMjU1LjUgODV0LTkyLjUgMjM4ek0yNjggMzAxcTAgLTk1IDUzLjUgLTEzOS41dDE0MS41IC00NC41cTE0NSAwIDIyOSA4NC41dDg0IDIzOC41djk5bC0xNTggLTdxLTE4NiAtOCAtMjY4IC02Mi41dC04MiAtMTY4LjV6TTk1NCA2NTNoNTE5IHEwIDE1NiAtNjQgMjQwdC0xODQgODRxLTEyMSAwIC0xOTAuNSAtODN0LTgwLjUgLTI0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZTc7IiBob3Jpei1hZHYteD0iOTc1IiBkPSJNMTE1IDU0MXEwIDI3NSAxMzIuNSA0MjV0Mzc3LjUgMTUwcTc5IDAgMTU4IC0xN3QxMjQgLTQwbC01MSAtMTQxcS01NSAyMiAtMTIwIDM2LjV0LTExNSAxNC41cS0zMzQgMCAtMzM0IC00MjZxMCAtMjAyIDgxLjUgLTMxMHQyNDEuNSAtMTA4cTEzNyAwIDI4MSA1OXYtMTQ3cS0xMTAgLTU3IC0yNzcgLTU3cS0yMzggMCAtMzY4LjUgMTQ2LjV0LTEzMC41IDQxNC41ek0zNjMgLTM3N3E0NSAtOCAxMDQgLThxNzkgMCAxMTkuNSAyMHQ0MC41IDc0IHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGU4OyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTMxOCAxNTQ4djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hlOTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE00NzEgMTI0MXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZWE7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMjU5IDEyNDF2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hlYjsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE0zMTkgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzAwIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hlYzsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2ek0tMzggMTU0OHYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZWQ7IiBob3Jpei1hZHYteD0iNTE4IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnpNMTY5IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGVlOyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE3NiAwdjEwOTZoMTY2di0xMDk2aC0xNjZ6TS03NyAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZWY7IiBob3Jpei1hZHYteD0iNTE4IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnpNLTIwIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTM2MSAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjA7IiBob3Jpei1hZHYteD0iMTIyMSIgZD0iTTExMyA0NzVxMCAyMzAgMTMxLjUgMzYxdDM1MS41IDEzMXEyMjYgMCAzMjYgLTEyMWw4IDRxLTU3IDIxNCAtMjYyIDQwNWwtMjcxIC0xNTVsLTczIDEwOGwyMzMgMTMzcS05MiA2MiAtMTg2IDExMWw2OSAxMTdxMTU2IC03MyAyNTggLTE0OGwyMzggMTM4bDc2IC0xMDdsLTIwNyAtMTE5cTE1MiAtMTQzIDIzNC41IC0zNDJ0ODIuNSAtNDI4cTAgLTI4MSAtMTMwLjUgLTQzMnQtMzc3LjUgLTE1MXEtMjIyIDAgLTM2MS41IDEzNC41IHQtMTM5LjUgMzYwLjV6TTI4MSA0NjlxMCAtMTY3IDg3LjUgLTI1OC41dDI0OS41IC05MS41cTE3NSAwIDI1NS41IDEwMC41dDgwLjUgMjkyLjVxMCAxNDcgLTkwIDIzMnQtMjQ2IDg1cS0zMzcgMCAtMzM3IC0zNjB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYxOyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0xNzYgMHYxMDk2aDEzNWwyNyAtMTUwaDhxNTEgODEgMTQzIDEyNS41dDIwNSA0NC41cTE5OCAwIDI5OCAtOTUuNXQxMDAgLTMwNS41di03MTVoLTE2NnY3MDlxMCAxMzQgLTYxIDIwMHQtMTkxIDY2cS0xNzIgMCAtMjUyIC05M3QtODAgLTMwN3YtNTc1aC0xNjZ6TTI3OCAxMjQxcTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5IHEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmMjsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek0zNDkgMTU0OHYyMSBoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGYzOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNTQ5cTAgLTIxMCA4NCAtMzIwdDI0NyAtMTEwdDI0Ny41IDEwOS41dDg0LjUgMzIwLjVxMCAyMDkgLTg0LjUgMzE3LjV0LTI0OS41IDEwOC41cS0xNjMgMCAtMjQ2IC0xMDd0LTgzIC0zMTl6TTQ3OSAxMjQxdjI1IHE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjQ7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXpNMjgyIDEyNDF2MjMgcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZjU7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXpNMjQ5IDEyNDEgcTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGY2OyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNTQ5cTAgLTIxMCA4NCAtMzIwdDI0NyAtMTEwdDI0Ny41IDEwOS41dDg0LjUgMzIwLjVxMCAyMDkgLTg0LjUgMzE3LjV0LTI0OS41IDEwOC41cS0xNjMgMCAtMjQ2IC0xMDd0LTgzIC0zMTl6TTMzNiAxMzkzIHEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzE3IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmNzsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDY1M3YxMzhoOTYxdi0xMzhoLTk2MXpNNDcxIDM3M3EwIDYwIDI5LjUgOTAuNXQ4My41IDMwLjVxNTIgMCA4MSAtMzEuNXQyOSAtODkuNXEwIC01NyAtMjkuNSAtODl0LTgwLjUgLTMycS01MiAwIC04Mi41IDMxLjV0LTMwLjUgODkuNXpNNDcxIDEwNzFxMCA2MCAyOS41IDkwLjV0ODMuNSAzMC41cTUyIDAgODEgLTMxLjV0MjkgLTg5LjVxMCAtNTcgLTI5LjUgLTg5dC04MC41IC0zMnEtNTIgMCAtODIuNSAzMS41dC0zMC41IDg5LjV6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmODsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTE1NCAwIDI3MCAtNzZsODQgMTE5bDExNyAtNzZsLTk3IC0xMzNxMTI3IC0xNTIgMTI3IC00MDFxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNTQgMCAtMjY2IDY5bC04NCAtMTE3bC0xMTQgNzhsOTQgMTMxcS0xMjkgMTUyIC0xMjkgNDA4ek0yODcgNTQ5cTAgLTE3MSA1MyAtMjczbDQ2NSA2NDZxLTc1IDUzIC0xODkgNTNxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOSB6TTQzNCAxNzBxNzEgLTUxIDE4NCAtNTFxMTYzIDAgMjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDE2NCAtNTEgMjY0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmOTsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTY0IDM3OXY3MTdoMTY4di03MTFxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzZoMTY2di0xMDk2aC0xMzdsLTI0IDE0N2gtOXEtNTEgLTgxIC0xNDEuNSAtMTI0dC0yMDYuNSAtNDNxLTIwMCAwIC0yOTkuNSA5NXQtOTkuNSAzMDR6TTMzMyAxNTQ4djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmYTsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTY0IDM3OXY3MTdoMTY4di03MTFxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzZoMTY2di0xMDk2aC0xMzdsLTI0IDE0N2gtOXEtNTEgLTgxIC0xNDEuNSAtMTI0dC0yMDYuNSAtNDNxLTIwMCAwIC0yOTkuNSA5NXQtOTkuNSAzMDR6TTUwNiAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmYjsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTY0IDM3OXY3MTdoMTY4di03MTFxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzZoMTY2di0xMDk2aC0xMzdsLTI0IDE0N2gtOXEtNTEgLTgxIC0xNDEuNSAtMTI0dC0yMDYuNSAtNDNxLTIwMCAwIC0yOTkuNSA5NXQtOTkuNSAzMDR6TTI4NiAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTkgcS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGZjOyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0xNjQgMzc5djcxN2gxNjh2LTcxMXEwIC0xMzQgNjEgLTIwMHQxOTEgLTY2cTE3MiAwIDI1MS41IDk0dDc5LjUgMzA3djU3NmgxNjZ2LTEwOTZoLTEzN2wtMjQgMTQ3aC05cS01MSAtODEgLTE0MS41IC0xMjR0LTIwNi41IC00M3EtMjAwIDAgLTI5OS41IDk1dC05OS41IDMwNHpNMzQyIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNSBxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek03MjMgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGZkOyIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6TTQxMSAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExIHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmU7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTE3NiAtNDkydjIwNDhoMTY2di00NjZxMCAtNTIgLTYgLTE0Mmg4cTY2IDg5IDE1MSAxMjguNXQxOTEgMzkuNXEyMTUgMCAzMzUgLTE1MHQxMjAgLTQxN3EwIC0yNjggLTEyMC41IC00MTguNXQtMzM0LjUgLTE1MC41cS0yMjIgMCAtMzQ0IDE2MWgtMTJsNCAtMzRxOCAtNzcgOCAtMTQwdi00NTloLTE2NnpNMzQyIDU0OXEwIC0yMzEgNzcgLTMzMC41dDI0NyAtOTkuNXEzMDMgMCAzMDMgNDMycTAgMjE1IC03NCAzMTkuNXQtMjMxIDEwNC41IHEtMTY4IDAgLTI0NCAtOTJ0LTc4IC0yOTN2LTQxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmZjsiIGhvcml6LWFkdi14PSIxMDMyIiBkPSJNMiAxMDk2aDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2ek0yMzQgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41IHQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTYxNSAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTAwOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTM2NCAxNTc5djEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMDE7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMjkwIDEyNDF2MTM3aDYwMHYtMTM3aC02MDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwMjsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0zMzYgMTg0N2gxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTd0LTIyMS41IC03MXEtMTQwIDAgLTIxOCA2OC41dC04NyAxOTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTAzOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTI2NSAxNTA5aDEwNHE2IC00OSAyNi41IC03N3Q1NyAtNDF0MTIxLjUgLTEzcTEwMSAwIDE0OSAzMnQ1OCA5OWgxMDRxLTEwIC0xMjYgLTkzLjUgLTE5N3QtMjIxLjUgLTcxcS0xNDAgMCAtMjE4IDY4LjV0LTg3IDE5OS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMDQ7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNOTY1IC0yNThxMCA3MCA0MyAxMzcuNXQxMTUgMTIwLjVoMTIwcS02OCAtNjYgLTEwMi41IC0xMjAuNXQtMzQuNSAtMTE3LjVxMCAtOTQgOTQgLTk0cTQyIDAgOTcgMTN2LTEwOXEtNjUgLTE4IC0xMjUgLTE4cS0yMDcgMCAtMjA3IDE4OHogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwNTsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek02OTIgLTI1OHEwIDcwIDQzIDEzNy41dDExNSAxMjAuNWgxMjBxLTY4IC02NiAtMTAyLjUgLTEyMC41dC0zNC41IC0xMTcuNXEwIC05NCA5NCAtOTRxNDIgMCA5NyAxM3YtMTA5cS02NSAtMTggLTEyNSAtMThxLTIwNyAwIC0yMDcgMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMDY7IiBob3Jpei1hZHYteD0iMTI5MiIgZD0iTTEyNSA3MzNxMCAyMjYgODQuNSAzOTZ0MjQ0IDI2MnQzNzUuNSA5MnEyMzAgMCA0MDIgLTg0bC03MiAtMTQ2cS0xNjYgNzggLTMzMiA3OHEtMjQxIDAgLTM4MC41IC0xNjAuNXQtMTM5LjUgLTQzOS41cTAgLTI4NyAxMzQuNSAtNDQzLjV0MzgzLjUgLTE1Ni41cTE1MyAwIDM0OSA1NXYtMTQ5cS0xNTIgLTU3IC0zNzUgLTU3cS0zMjMgMCAtNDk4LjUgMTk2dC0xNzUuNSA1NTd6TTY1NyAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1MyBoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTA3OyIgaG9yaXotYWR2LXg9Ijk3NSIgZD0iTTExNSA1NDFxMCAyNzUgMTMyLjUgNDI1dDM3Ny41IDE1MHE3OSAwIDE1OCAtMTd0MTI0IC00MGwtNTEgLTE0MXEtNTUgMjIgLTEyMCAzNi41dC0xMTUgMTQuNXEtMzM0IDAgLTMzNCAtNDI2cTAgLTIwMiA4MS41IC0zMTB0MjQxLjUgLTEwOHExMzcgMCAyODEgNTl2LTE0N3EtMTEwIC01NyAtMjc3IC01N3EtMjM4IDAgLTM2OC41IDE0Ni41dC0xMzAuNSA0MTQuNXpNNDYxIDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjEgcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMDg7IiBob3Jpei1hZHYteD0iMTI5MiIgZD0iTTEyNSA3MzNxMCAyMjYgODQuNSAzOTZ0MjQ0IDI2MnQzNzUuNSA5MnEyMzAgMCA0MDIgLTg0bC03MiAtMTQ2cS0xNjYgNzggLTMzMiA3OHEtMjQxIDAgLTM4MC41IC0xNjAuNXQtMTM5LjUgLTQzOS41cTAgLTI4NyAxMzQuNSAtNDQzLjV0MzgzLjUgLTE1Ni41cTE1MyAwIDM0OSA1NXYtMTQ5cS0xNTIgLTU3IC0zNzUgLTU3cS0zMjMgMCAtNDk4LjUgMTk2dC0xNzUuNSA1NTd6TTQ0MCAxNTc5djIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDUgaDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwOTsiIGhvcml6LWFkdi14PSI5NzUiIGQ9Ik0xMTUgNTQxcTAgMjc1IDEzMi41IDQyNXQzNzcuNSAxNTBxNzkgMCAxNTggLTE3dDEyNCAtNDBsLTUxIC0xNDFxLTU1IDIyIC0xMjAgMzYuNXQtMTE1IDE0LjVxLTMzNCAwIC0zMzQgLTQyNnEwIC0yMDIgODEuNSAtMzEwdDI0MS41IC0xMDhxMTM3IDAgMjgxIDU5di0xNDdxLTExMCAtNTcgLTI3NyAtNTdxLTIzOCAwIC0zNjguNSAxNDYuNXQtMTMwLjUgNDE0LjV6TTIyNCAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2IHEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwYTsiIGhvcml6LWFkdi14PSIxMjkyIiBkPSJNMTI1IDczM3EwIDIyNiA4NC41IDM5NnQyNDQgMjYydDM3NS41IDkycTIzMCAwIDQwMiAtODRsLTcyIC0xNDZxLTE2NiA3OCAtMzMyIDc4cS0yNDEgMCAtMzgwLjUgLTE2MC41dC0xMzkuNSAtNDM5LjVxMCAtMjg3IDEzNC41IC00NDMuNXQzODMuNSAtMTU2LjVxMTUzIDAgMzQ5IDU1di0xNDlxLTE1MiAtNTcgLTM3NSAtNTdxLTMyMyAwIC00OTguNSAxOTZ0LTE3NS41IDU1N3pNNzAxIDE3MzFxMCA1NyAyOCA4My41dDcwIDI2LjUgcTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMGI7IiBob3Jpei1hZHYteD0iOTc1IiBkPSJNMTE1IDU0MXEwIDI3NSAxMzIuNSA0MjV0Mzc3LjUgMTUwcTc5IDAgMTU4IC0xN3QxMjQgLTQwbC01MSAtMTQxcS01NSAyMiAtMTIwIDM2LjV0LTExNSAxNC41cS0zMzQgMCAtMzM0IC00MjZxMCAtMjAyIDgxLjUgLTMxMHQyNDEuNSAtMTA4cTEzNyAwIDI4MSA1OXYtMTQ3cS0xMTAgLTU3IC0yNzcgLTU3cS0yMzggMCAtMzY4LjUgMTQ2LjV0LTEzMC41IDQxNC41ek00OTggMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yNyB0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwYzsiIGhvcml6LWFkdi14PSIxMjkyIiBkPSJNMTI1IDczM3EwIDIyNiA4NC41IDM5NnQyNDQgMjYydDM3NS41IDkycTIzMCAwIDQwMiAtODRsLTcyIC0xNDZxLTE2NiA3OCAtMzMyIDc4cS0yNDEgMCAtMzgwLjUgLTE2MC41dC0xMzkuNSAtNDM5LjVxMCAtMjg3IDEzNC41IC00NDMuNXQzODMuNSAtMTU2LjVxMTUzIDAgMzQ5IDU1di0xNDlxLTE1MiAtNTcgLTM3NSAtNTdxLTMyMyAwIC00OTguNSAxOTZ0LTE3NS41IDU1N3pNNDYxIDE4ODJ2MjVoMTE1cTExNCAtNzQgMjE5IC0xODkgcTEzMCAxMzAgMjIxIDE4OWgxMTl2LTI1bC02NiAtNjhxLTE0NCAtMTQ4IC0xOTAgLTIzNWgtMTY2cS0yMyA0MSAtNzQgMTA0dC0xNzggMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMGQ7IiBob3Jpei1hZHYteD0iOTc1IiBkPSJNMTE1IDU0MXEwIDI3NSAxMzIuNSA0MjV0Mzc3LjUgMTUwcTc5IDAgMTU4IC0xN3QxMjQgLTQwbC01MSAtMTQxcS01NSAyMiAtMTIwIDM2LjV0LTExNSAxNC41cS0zMzQgMCAtMzM0IC00MjZxMCAtMjAyIDgxLjUgLTMxMHQyNDEuNSAtMTA4cTEzNyAwIDI4MSA1OXYtMTQ3cS0xMTAgLTU3IC0yNzcgLTU3cS0yMzggMCAtMzY4LjUgMTQ2LjV0LTEzMC41IDQxNC41ek0yNTUgMTU0NHYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OSBxMTMwIDEzMCAyMjEgMTg5aDExOXYtMjVsLTY2IC02OHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwZTsiIGhvcml6LWFkdi14PSIxNDkzIiBkPSJNMjAxIDB2MTQ2Mmg0NDhxMzQxIDAgNTMwIC0xODl0MTg5IC01MjhxMCAtMzYyIC0xOTYuNSAtNTUzLjV0LTU2NS41IC0xOTEuNWgtNDA1ek0zNzEgMTQ3aDIwN3EzMDQgMCA0NTcgMTQ5LjV0MTUzIDQ0Mi41cTAgMjg2IC0xNDMuNSA0MzF0LTQyNi41IDE0NWgtMjQ3di0xMTY4ek0zNTYgMTg4MnYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NiBxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEwZjsiIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTE1IDU0NXEwIDI3MSAxMjAgNDIxdDMzNCAxNTBxMjIzIDAgMzQyIC0xNjJoMTNsLTcgNzlsLTQgNzd2NDQ2aDE2NnYtMTU1NmgtMTM1bC0yMiAxNDdoLTlxLTExNSAtMTY3IC0zNDQgLTE2N3EtMjE1IDAgLTMzNC41IDE0N3QtMTE5LjUgNDE4ek0yODcgNTQzcTAgLTIxMCA3NyAtMzE3dDIyNiAtMTA3cTE3MCAwIDI0Ni41IDkyLjV0NzYuNSAyOTguNXYzNXEwIDIzMyAtNzcuNSAzMzIuNXQtMjQ3LjUgOTkuNSBxLTE0NiAwIC0yMjMuNSAtMTEzLjV0LTc3LjUgLTMyMC41ek0xMTczIDEyMjl2MjRxMTkgNTUgMzguNSAxMzguNXQyOS41IDE2NC41aDE2OHYtMThxLTExIC01MSAtNTUgLTE0NXQtOTEgLTE2NGgtOTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExMDsiIGhvcml6LWFkdi14PSIxNDc5IiBkPSJNNDcgNjQ5djE1MGgxNTR2NjYzaDQzNHEzMzcgMCA1MjcgLTE4Ny41dDE5MCAtNTI5LjVxMCAtMzYyIC0xOTYuNSAtNTUzLjV0LTU2NS41IC0xOTEuNWgtMzg5djY0OWgtMTU0ek0zNzEgMTQ3aDE5MHE2MTAgMCA2MTAgNTkycTAgNTc2IC01NjkgNTc2aC0yMzF2LTUxNmgzNzl2LTE1MGgtMzc5di01MDJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExMTsiIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTE1IDU0NXEwIDI3MSAxMjAgNDIxdDMzNCAxNTBxMjIzIDAgMzQyIC0xNjJoMTNxLTExIDgzIC0xMSAxNTZ2MTMzaC00NDh2MTI5aDQ0OHYxODRoMTY2di0xODRoMTU2di0xMjloLTE1NnYtMTI0M2gtMTM1bC0yMiAxNDdoLTlxLTExNSAtMTY3IC0zNDQgLTE2N3EtMjE1IDAgLTMzNC41IDE0N3QtMTE5LjUgNDE4ek0yODcgNTQzcTAgLTIxMCA3NyAtMzE3dDIyNiAtMTA3cTE3MCAwIDI0Ni41IDkyLjV0NzYuNSAyOTguNXYzNSBxMCAyMzMgLTc3LjUgMzMyLjV0LTI0Ny41IDk5LjVxLTE0NiAwIC0yMjMuNSAtMTEzLjV0LTc3LjUgLTMyMC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMTI7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTMxOSAxNTc5djEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMTM7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMzExIDEyNDF2MTM3aDYwMHYtMTM3aC02MDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExNDsiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUxaC02NDV2LTQ3MWg2MDZ2LTE1MGgtNjA2di01MzhoNjQ1di0xNTJoLTgxNXpNMzA5IDE4NDdoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExNTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE0yODggMTUwOWgxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTd0LTIyMS41IC03MXEtMTQwIDAgLTIxOCA2OC41dC04NyAxOTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTE2OyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek01MjkgMTcwMnEwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTE3OyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTUwMiAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMTg7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTY2NCAtMjU4cTAgNzAgNDMgMTM3LjV0MTE1IDEyMC41aDEyMHEtNjggLTY2IC0xMDIuNSAtMTIwLjV0LTM0LjUgLTExNy41cTAgLTk0IDk0IC05NHE0MiAwIDk3IDEzdi0xMDlxLTY1IC0xOCAtMTI1IC0xOHEtMjA3IDAgLTIwNyAxODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExOTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE02NTEgLTIyN3EwIDcwIDQzIDEzNy41dDExNSAxMjAuNWgxMjBxLTY4IC02NiAtMTAyLjUgLTEyMC41dC0zNC41IC0xMTcuNXEwIC05NCA5NCAtOTRxNDIgMCA5NyAxM3YtMTA5cS02NSAtMTggLTEyNSAtMThxLTIwNyAwIC0yMDcgMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMWE7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTI4NCAxODgydjI1aDExNXExMTQgLTc0IDIxOSAtMTg5cTEzMCAxMzAgMjIxIDE4OWgxMTl2LTI1bC02NiAtNjhxLTE0NCAtMTQ4IC0xOTAgLTIzNWgtMTY2cS0yMyA0MSAtNzQgMTA0dC0xNzggMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMWI7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMjYzIDE1NDR2MjVoMTE1cTExNCAtNzQgMjE5IC0xODlxMTMwIDEzMCAyMjEgMTg5aDExOXYtMjVsLTY2IC02OHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExYzsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTI1IDczMXEwIDIyOCA5MS41IDM5OS41dDI2My41IDI2MnQ0MDMgOTAuNXEyMzQgMCA0MzYgLTg2bC02NiAtMTUwcS0xOTggODQgLTM4MSA4NHEtMjY3IDAgLTQxNyAtMTU5dC0xNTAgLTQ0MXEwIC0yOTYgMTQ0LjUgLTQ0OXQ0MjQuNSAtMTUzcTE1MiAwIDI5NyAzNXY0NTBoLTMyN3YxNTJoNDk3di03MTFxLTExNiAtMzcgLTIzNiAtNTZ0LTI3OCAtMTlxLTMzMiAwIC01MTcgMTk3LjV0LTE4NSA1NTMuNXpNNTAxIDE1Nzl2MjMgcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTFkOyIgaG9yaXotYWR2LXg9IjExMjIiIGQ9Ik0zOSAtMTg2cTAgMTAwIDY0IDE3M3QxODAgOTlxLTQyIDE5IC03MC41IDU5dC0yOC41IDkzcTAgNjAgMzIgMTA1dDEwMSA4N3EtODUgMzUgLTEzOC41IDExOXQtNTMuNSAxOTJxMCAxODAgMTA4IDI3Ny41dDMwNiA5Ny41cTg2IDAgMTU1IC0yMGgzNzl2LTEwNWwtMjAzIC0yNHEyOCAtMzUgNTAgLTkxLjV0MjIgLTEyNy41cTAgLTE2MSAtMTEwIC0yNTd0LTMwMiAtOTZxLTQ5IDAgLTkyIDhxLTEwNiAtNTYgLTEwNiAtMTQxIHEwIC00NSAzNyAtNjYuNXQxMjcgLTIxLjVoMTk0cTE3OCAwIDI3My41IC03NXQ5NS41IC0yMThxMCAtMTgyIC0xNDYgLTI3Ny41dC00MjYgLTk1LjVxLTIxNSAwIC0zMzEuNSA4MHQtMTE2LjUgMjI2ek0xOTkgLTE4NHEwIC04OSA3NSAtMTM1dDIxNSAtNDZxMjA5IDAgMzA5LjUgNjIuNXQxMDAuNSAxNjkuNXEwIDg5IC01NSAxMjMuNXQtMjA3IDM0LjVoLTE5OXEtMTEzIDAgLTE3NiAtNTR0LTYzIC0xNTV6TTI4OSA3NDVxMCAtMTE1IDY1IC0xNzQgdDE4MSAtNTlxMjQzIDAgMjQzIDIzNnEwIDI0NyAtMjQ2IDI0N3EtMTE3IDAgLTE4MCAtNjN0LTYzIC0xODd6TTIxNCAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTFlOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xMjUgNzMxcTAgMjI4IDkxLjUgMzk5LjV0MjYzLjUgMjYydDQwMyA5MC41cTIzNCAwIDQzNiAtODZsLTY2IC0xNTBxLTE5OCA4NCAtMzgxIDg0cS0yNjcgMCAtNDE3IC0xNTl0LTE1MCAtNDQxcTAgLTI5NiAxNDQuNSAtNDQ5dDQyNC41IC0xNTNxMTUyIDAgMjk3IDM1djQ1MGgtMzI3djE1Mmg0OTd2LTcxMXEtMTE2IC0zNyAtMjM2IC01NnQtMjc4IC0xOXEtMzMyIDAgLTUxNyAxOTcuNXQtMTg1IDU1My41ek01NDkgMTg0N2gxMDQgcTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDExZjsiIGhvcml6LWFkdi14PSIxMTIyIiBkPSJNMzkgLTE4NnEwIDEwMCA2NCAxNzN0MTgwIDk5cS00MiAxOSAtNzAuNSA1OXQtMjguNSA5M3EwIDYwIDMyIDEwNXQxMDEgODdxLTg1IDM1IC0xMzguNSAxMTl0LTUzLjUgMTkycTAgMTgwIDEwOCAyNzcuNXQzMDYgOTcuNXE4NiAwIDE1NSAtMjBoMzc5di0xMDVsLTIwMyAtMjRxMjggLTM1IDUwIC05MS41dDIyIC0xMjcuNXEwIC0xNjEgLTExMCAtMjU3dC0zMDIgLTk2cS00OSAwIC05MiA4cS0xMDYgLTU2IC0xMDYgLTE0MSBxMCAtNDUgMzcgLTY2LjV0MTI3IC0yMS41aDE5NHExNzggMCAyNzMuNSAtNzV0OTUuNSAtMjE4cTAgLTE4MiAtMTQ2IC0yNzcuNXQtNDI2IC05NS41cS0yMTUgMCAtMzMxLjUgODB0LTExNi41IDIyNnpNMTk5IC0xODRxMCAtODkgNzUgLTEzNXQyMTUgLTQ2cTIwOSAwIDMwOS41IDYyLjV0MTAwLjUgMTY5LjVxMCA4OSAtNTUgMTIzLjV0LTIwNyAzNC41aC0xOTlxLTExMyAwIC0xNzYgLTU0dC02MyAtMTU1ek0yODkgNzQ1cTAgLTExNSA2NSAtMTc0IHQxODEgLTU5cTI0MyAwIDI0MyAyMzZxMCAyNDcgLTI0NiAyNDdxLTExNyAwIC0xODAgLTYzdC02MyAtMTg3ek0yNDMgMTUwOWgxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTd0LTIyMS41IC03MXEtMTQwIDAgLTIxOCA2OC41dC04NyAxOTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTIwOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xMjUgNzMxcTAgMjI4IDkxLjUgMzk5LjV0MjYzLjUgMjYydDQwMyA5MC41cTIzNCAwIDQzNiAtODZsLTY2IC0xNTBxLTE5OCA4NCAtMzgxIDg0cS0yNjcgMCAtNDE3IC0xNTl0LTE1MCAtNDQxcTAgLTI5NiAxNDQuNSAtNDQ5dDQyNC41IC0xNTNxMTUyIDAgMjk3IDM1djQ1MGgtMzI3djE1Mmg0OTd2LTcxMXEtMTE2IC0zNyAtMjM2IC01NnQtMjc4IC0xOXEtMzMyIDAgLTUxNyAxOTcuNXQtMTg1IDU1My41ek03NzQgMTczMSBxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEyMTsiIGhvcml6LWFkdi14PSIxMTIyIiBkPSJNMzkgLTE4NnEwIDEwMCA2NCAxNzN0MTgwIDk5cS00MiAxOSAtNzAuNSA1OXQtMjguNSA5M3EwIDYwIDMyIDEwNXQxMDEgODdxLTg1IDM1IC0xMzguNSAxMTl0LTUzLjUgMTkycTAgMTgwIDEwOCAyNzcuNXQzMDYgOTcuNXE4NiAwIDE1NSAtMjBoMzc5di0xMDVsLTIwMyAtMjRxMjggLTM1IDUwIC05MS41dDIyIC0xMjcuNXEwIC0xNjEgLTExMCAtMjU3dC0zMDIgLTk2cS00OSAwIC05MiA4cS0xMDYgLTU2IC0xMDYgLTE0MSBxMCAtNDUgMzcgLTY2LjV0MTI3IC0yMS41aDE5NHExNzggMCAyNzMuNSAtNzV0OTUuNSAtMjE4cTAgLTE4MiAtMTQ2IC0yNzcuNXQtNDI2IC05NS41cS0yMTUgMCAtMzMxLjUgODB0LTExNi41IDIyNnpNMTk5IC0xODRxMCAtODkgNzUgLTEzNXQyMTUgLTQ2cTIwOSAwIDMwOS41IDYyLjV0MTAwLjUgMTY5LjVxMCA4OSAtNTUgMTIzLjV0LTIwNyAzNC41aC0xOTlxLTExMyAwIC0xNzYgLTU0dC02MyAtMTU1ek0yODkgNzQ1cTAgLTExNSA2NSAtMTc0IHQxODEgLTU5cTI0MyAwIDI0MyAyMzZxMCAyNDcgLTI0NiAyNDdxLTExNyAwIC0xODAgLTYzdC02MyAtMTg3ek00NDkgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTIyOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xMjUgNzMxcTAgMjI4IDkxLjUgMzk5LjV0MjYzLjUgMjYydDQwMyA5MC41cTIzNCAwIDQzNiAtODZsLTY2IC0xNTBxLTE5OCA4NCAtMzgxIDg0cS0yNjcgMCAtNDE3IC0xNTl0LTE1MCAtNDQxcTAgLTI5NiAxNDQuNSAtNDQ5dDQyNC41IC0xNTNxMTUyIDAgMjk3IDM1djQ1MGgtMzI3djE1Mmg0OTd2LTcxMXEtMTE2IC0zNyAtMjM2IC01NnQtMjc4IC0xOXEtMzMyIDAgLTUxNyAxOTcuNXQtMTg1IDU1My41ek02NjQgLTQyOCBxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMjM7IiBob3Jpei1hZHYteD0iMTEyMiIgZD0iTTM5IC0xODZxMCAxMDAgNjQgMTczdDE4MCA5OXEtNDIgMTkgLTcwLjUgNTl0LTI4LjUgOTNxMCA2MCAzMiAxMDV0MTAxIDg3cS04NSAzNSAtMTM4LjUgMTE5dC01My41IDE5MnEwIDE4MCAxMDggMjc3LjV0MzA2IDk3LjVxODYgMCAxNTUgLTIwaDM3OXYtMTA1bC0yMDMgLTI0cTI4IC0zNSA1MCAtOTEuNXQyMiAtMTI3LjVxMCAtMTYxIC0xMTAgLTI1N3QtMzAyIC05NnEtNDkgMCAtOTIgOHEtMTA2IC01NiAtMTA2IC0xNDEgcTAgLTQ1IDM3IC02Ni41dDEyNyAtMjEuNWgxOTRxMTc4IDAgMjczLjUgLTc1dDk1LjUgLTIxOHEwIC0xODIgLTE0NiAtMjc3LjV0LTQyNiAtOTUuNXEtMjE1IDAgLTMzMS41IDgwdC0xMTYuNSAyMjZ6TTE5OSAtMTg0cTAgLTg5IDc1IC0xMzV0MjE1IC00NnEyMDkgMCAzMDkuNSA2Mi41dDEwMC41IDE2OS41cTAgODkgLTU1IDEyMy41dC0yMDcgMzQuNWgtMTk5cS0xMTMgMCAtMTc2IC01NHQtNjMgLTE1NXpNMjg5IDc0NXEwIC0xMTUgNjUgLTE3NCB0MTgxIC01OXEyNDMgMCAyNDMgMjM2cTAgMjQ3IC0yNDYgMjQ3cS0xMTcgMCAtMTgwIC02M3QtNjMgLTE4N3pNNDUzIDEyNDF2MTlxMTQgNjEgNjMuNSAxNTYuNXQ5OC41IDE1Mi41aDkydi0yNXEtMjkgLTYxIC01NS41IC0xNTcuNXQtMzIuNSAtMTQ1LjVoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTI0OyIgaG9yaXotYWR2LXg9IjE1MTEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNjIyaDc3MHY2MjJoMTcwdi0xNDYyaC0xNzB2Njg4aC03NzB2LTY4OGgtMTcwek00MTggMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEyNTsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTc2IDB2MTU1NmgxNjZ2LTQ3MXEwIC04NSAtOCAtMTQxaDEwcTQ5IDc5IDEzOS41IDEyNC41dDIwNi41IDQ1LjVxMjAxIDAgMzAxLjUgLTk1LjV0MTAwLjUgLTMwMy41di03MTVoLTE2NnY3MDlxMCAxMzQgLTYxIDIwMHQtMTkxIDY2cS0xNzMgMCAtMjUyLjUgLTk0dC03OS41IC0zMDh2LTU3M2gtMTY2ek0yOTkgMTYzNHYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yMyBoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMjY7IiBob3Jpei1hZHYteD0iMTUxMSIgZD0iTTAgMTA3M3YxNDFoMjAxdjI0OGgxNzB2LTI0OGg3NzB2MjQ4aDE3MHYtMjQ4aDIwMHYtMTQxaC0yMDB2LTEwNzNoLTE3MHY2ODhoLTc3MHYtNjg4aC0xNzB2MTA3M2gtMjAxek0zNzEgODQwaDc3MHYyMzNoLTc3MHYtMjMzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMjc7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTIwIDEyNDN2MTI3aDE1NnYxODZoMTY2di0xODZoNDQ5di0xMjdoLTQ0OXYtMTk2cTAgLTg0IC04IC0xNDBoMTBxNDkgNzkgMTM5LjUgMTI0LjV0MjA2LjUgNDUuNXEyMDEgMCAzMDEuNSAtOTUuNXQxMDAuNSAtMzA1LjV2LTY3NmgtMTY2djY3MHEwIDEzNCAtNjEgMjAwdC0xOTEgNjZxLTE3NCAwIC0yNTMgLTkzdC03OSAtMzA2di01MzdoLTE2NnYxMjQzaC0xNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEyODsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek0tODUgMTU3OXExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OXEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMjk7IiBob3Jpei1hZHYteD0iNTE4IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnpNLTExMiAxMjQxcTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEyYTsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek0tMTMgMTU3OXYxMzdoNjAwdi0xMzdoLTYwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTJiOyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE3NiAwdjEwOTZoMTY2di0xMDk2aC0xNjZ6TS0zOCAxMjQxdjEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMmM7IiBob3Jpei1hZHYteD0iNTcxIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTE0NjJoLTE3MHpNLTI1IDE4NDdoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEyZDsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2ek0tNTIgMTUwOWgxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTd0LTIyMS41IC03MXEtMTQwIDAgLTIxOCA2OC41dC04NyAxOTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTJlOyIgaG9yaXotYWR2LXg9IjU3MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6TTg2IC0yNThxMCA3MCA0MyAxMzcuNXQxMTUgMTIwLjVoMTIwcS02OCAtNjYgLTEwMi41IC0xMjAuNXQtMzQuNSAtMTE3LjVxMCAtOTQgOTQgLTk0cTQyIDAgOTcgMTN2LTEwOXEtNjUgLTE4IC0xMjUgLTE4cS0yMDcgMCAtMjA3IDE4OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTJmOyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE2MiAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41ek0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2ek01MyAtMjU4cTAgNzAgNDMgMTM3LjV0MTE1IDEyMC41aDEyMHEtNjggLTY2IC0xMDIuNSAtMTIwLjV0LTM0LjUgLTExNy41cTAgLTk0IDk0IC05NHE0MiAwIDk3IDEzdi0xMDlxLTY1IC0xOCAtMTI1IC0xOCBxLTIwNyAwIC0yMDcgMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMzA7IiBob3Jpei1hZHYteD0iNTcxIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTE0NjJoLTE3MHpNMTg3IDE3MzFxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzMTsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMzI7IiBob3Jpei1hZHYteD0iMTExOCIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6TTQxMSAtMjEzcTcxIC0yMCAxNDggLTIwcTk5IDAgMTUwLjUgNjB0NTEuNSAxNzN2MTQ2MmgxNzB2LTE0NDhxMCAtMTkwIC05NiAtMjk0LjV0LTI3NiAtMTA0LjVxLTk0IDAgLTE0OCAyN3YxNDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzMzsiIGhvcml6LWFkdi14PSIxMDM2IiBkPSJNMTYyIDEzOTNxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6TTE3NiAwdjEwOTZoMTY2di0xMDk2aC0xNjZ6TTQwNyAtMzMycTY5IC0yMCAxMzYgLTIwcTc4IDAgMTE0LjUgNDIuNXQzNi41IDEyOS41djEyNzZoMTY2di0xMjY0cTAgLTMyNCAtMjk5IC0zMjRxLTk1IDAgLTE1NCAyNXYxMzV6TTY4MCAxMzkzcTAgNTcgMjggODMuNSB0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTM0OyIgaG9yaXotYWR2LXg9IjU0NyIgZD0iTS0xNjAgLTIxM3E3MSAtMjAgMTQ4IC0yMHE5OSAwIDE1MC41IDYwdDUxLjUgMTczdjE0NjJoMTcwdi0xNDQ4cTAgLTE5MCAtOTYgLTI5NC41dC0yNzYgLTEwNC41cS05NCAwIC0xNDggMjd2MTQ1ek0tNjEgMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzNTsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0tMTExIC0zMzJxNjkgLTIwIDEzNiAtMjBxNzggMCAxMTQuNSA0Mi41dDM2LjUgMTI5LjV2MTI3NmgxNjZ2LTEyNjRxMCAtMzI0IC0yOTkgLTMyNHEtOTUgMCAtMTU0IDI1djEzNXpNLTgzIDEyNDF2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMzY7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTIwMSAwdjE0NjJoMTcwdi03MjVsNjYzIDcyNWgyMDFsLTU4OCAtNjM1bDYxMCAtODI3aC0yMDBsLTUzMyA3MDlsLTE1MyAtMTM2di01NzNoLTE3MHpNNTA2IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMzc7IiBob3Jpei1hZHYteD0iMTA3NSIgZD0iTTE3NiAwdjE1NTZoMTY0di04MjVxMCAtNTUgLTggLTE3MGg4cTQzIDYxIDEzMSAxNjBsMzU0IDM3NWgxOTdsLTQ0NCAtNDY3bDQ3NSAtNjI5aC0yMDFsLTM4NyA1MThsLTEyNSAtMTA4di00MTBoLTE2NHpNNDEyIC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxMzg7IiBob3Jpei1hZHYteD0iMTA2MSIgZD0iTTE3NiAwdjEwOTRoMTc4di0yODNxMCAtMTY2IC0xMiAtMjc5bDQ3MyA1NjJoMjA3bC00MTQgLTQ4Mmw0NDMgLTYxMmgtMjAxbC0zNjEgNTA0bC0xMzUgLTExM3YtMzkxaC0xNzh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzOTsiIGhvcml6LWFkdi14PSIxMDYzIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTEzMDhoNjQ1di0xNTRoLTgxNXpNMjM2IDE1Nzl2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzYTsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxNTU2aDE2NnYtMTU1NmgtMTY2ek0xNjMgMTYzNnYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTNiOyIgaG9yaXotYWR2LXg9IjEwNjMiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTMwOGg2NDV2LTE1NGgtODE1ek00MTggLTQyOHEyOCA2NCA1My41IDE1N3QzMi41IDE0NmgxNjh2LTE4cS0xMSAtNTEgLTYwIC0xNDcuNXQtMTA0IC0xNjIuNWgtOTB2MjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDEzYzsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxNTU2aDE2NnYtMTU1NmgtMTY2ek04OSAtNDI4cTI4IDY0IDUzLjUgMTU3dDMyLjUgMTQ2aDE2OHYtMThxLTExIC01MSAtNjAgLTE0Ny41dC0xMDQgLTE2Mi41aC05MHYyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTNkOyIgaG9yaXotYWR2LXg9IjEwNjMiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTMwOGg2NDV2LTE1NGgtODE1ek02NzggMTEzNnYyNHExOSA1NSAzOC41IDEzOC41dDI5LjUgMTY0LjVoMTY4di0xOHEtMTEgLTUxIC01NSAtMTQ1dC05MSAtMTY0aC05MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTNlOyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE3NiAwdjE1NTZoMTY2di0xNTU2aC0xNjZ6TTQzNiAxMjI5djI0cTE5IDU1IDM4LjUgMTM4LjV0MjkuNSAxNjQuNWgxNjh2LTE4cS0xMSAtNTEgLTU1IC0xNDV0LTkxIC0xNjRoLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxM2Y7IiBob3Jpei1hZHYteD0iMTA2MyIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xMzA4aDY0NXYtMTU0aC04MTV6TTY3OCA3MjhxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0MDsiIGhvcml6LWFkdi14PSI2NDMiIGQ9Ik0xNzYgMHYxNTU2aDE2NnYtMTU1NmgtMTY2ek00ODQgNjgxcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNDE7IiBob3Jpei1hZHYteD0iMTA3MSIgZD0iTTI5IDU2M2wxNzIgMTAxdjc5OGgxNzB2LTY5OGwyOTcgMTc0bDY3IC0xMjFsLTM2NCAtMjExdi00NTJoNjQ1di0xNTRoLTgxNXY1MDhsLTEwNSAtNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0MjsiIGhvcml6LWFkdi14PSI1MzUiIGQ9Ik0tNCA2MzdsMTgwIDExOXY4MDBoMTY2di02OTJsMTM3IDk0bDcyIC0xMTJsLTIwOSAtMTQxdi03MDVoLTE2NnY1OTZsLTExMCAtNzJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0MzsiIGhvcml6LWFkdi14PSIxNTQ0IiBkPSJNMjAxIDB2MTQ2MmgxOTJsNzk3IC0xMjIyaDhxLTIgMjggLTkgMTc0cS01IDExNCAtNSAxNzd2MzJ2ODM5aDE1OXYtMTQ2MmgtMTk0bC03OTkgMTIyN2gtOHExNiAtMjE2IDE2IC0zOTZ2LTgzMWgtMTU3ek02NTEgMTU3OXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTQ0OyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0xNzYgMHYxMDk2aDEzNWwyNyAtMTUwaDhxNTEgODEgMTQzIDEyNS41dDIwNSA0NC41cTE5OCAwIDI5OCAtOTUuNXQxMDAgLTMwNS41di03MTVoLTE2NnY3MDlxMCAxMzQgLTYxIDIwMHQtMTkxIDY2cS0xNzIgMCAtMjUyIC05M3QtODAgLTMwN3YtNTc1aC0xNjZ6TTUxNCAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNDU7IiBob3Jpei1hZHYteD0iMTU0NCIgZD0iTTIwMSAwdjE0NjJoMTkybDc5NyAtMTIyMmg4cS0yIDI4IC05IDE3NHEtNSAxMTQgLTUgMTc3djMydjgzOWgxNTl2LTE0NjJoLTE5NGwtNzk5IDEyMjdoLThxMTYgLTIxNiAxNiAtMzk2di04MzFoLTE1N3pNNTc0IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNDY7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE3NiAwdjEwOTZoMTM1bDI3IC0xNTBoOHE1MSA4MSAxNDMgMTI1LjV0MjA1IDQ0LjVxMTk4IDAgMjk4IC05NS41dDEwMCAtMzA1LjV2LTcxNWgtMTY2djcwOXEwIDEzNCAtNjEgMjAwdC0xOTEgNjZxLTE3MiAwIC0yNTIgLTkzdC04MCAtMzA3di01NzVoLTE2NnpNNDU1IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNDc7IiBob3Jpei1hZHYteD0iMTU0NCIgZD0iTTIwMSAwdjE0NjJoMTkybDc5NyAtMTIyMmg4cS0yIDI4IC05IDE3NHEtNSAxMTQgLTUgMTc3djMydjgzOWgxNTl2LTE0NjJoLTE5NGwtNzk5IDEyMjdoLThxMTYgLTIxNiAxNiAtMzk2di04MzFoLTE1N3pNNDM0IDE4ODJ2MjVoMTE1cTExNCAtNzQgMjE5IC0xODlxMTMwIDEzMCAyMjEgMTg5aDExOXYtMjVsLTY2IC02OHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0ODsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTc2IDB2MTA5NmgxMzVsMjcgLTE1MGg4cTUxIDgxIDE0MyAxMjUuNXQyMDUgNDQuNXExOTggMCAyOTggLTk1LjV0MTAwIC0zMDUuNXYtNzE1aC0xNjZ2NzA5cTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTcyIDAgLTI1MiAtOTN0LTgwIC0zMDd2LTU3NWgtMTY2ek0yOTkgMTU0NHYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NiBxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0OTsiIGhvcml6LWFkdi14PSIxMzk1IiBkPSJNMzExIDB2MTA5NmgxMzVsMjcgLTE1MGg4cTUxIDgxIDE0MyAxMjUuNXQyMDUgNDQuNXExOTggMCAyOTggLTk1LjV0MTAwIC0zMDUuNXYtNzE1aC0xNjZ2NzA5cTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTcyIDAgLTI1MiAtOTN0LTgwIC0zMDd2LTU3NWgtMTY2ek0xIDk2MXE3MCAyODUgMTAyIDUwMWgxODJsMTUgLTIycS0yNiAtMTAwIC03NSAtMjMyLjV0LTEwMiAtMjQ2LjVoLTEyMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTRhOyIgaG9yaXotYWR2LXg9IjE1NDQiIGQ9Ik0yMDEgMHYxNDYyaDE5Mmw3OTcgLTEyMDJoOHEtMTQgMTQ5IC0xNCAzNzN2ODI5aDE1OXYtMTQ0OHEwIC0xOTUgLTk2LjUgLTI5N3QtMjc3LjUgLTEwMnEtOTggMCAtMTUyIDI3djE0NXE3MSAtMjAgMTU0IC0yMHExMDUgMCAxNTggNjF0NTMgMTcybC04MzIgMTIyN2gtOHExNiAtMjY0IDE2IC00MjJ2LTgwNWgtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNGI7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE3NiAwdjEwOTZoMTM1bDI3IC0xNTBoMTBxNTIgODIgMTQyIDEyNnQyMDAgNDRxMjAzIDAgMzAyLjUgLTk1LjV0OTkuNSAtMzA1LjV2LTg4M3EwIC0xNTQgLTcwIC0yMzl0LTIxNyAtODVxLTg2IDAgLTE0MSAyNXYxMzVxNjAgLTIwIDEyMiAtMjBxMTQwIDAgMTQwIDE3MnY4ODlxMCAxMzQgLTYxIDIwMHQtMTkxIDY2cS0xNzIgMCAtMjUyIC05M3QtODAgLTMwN3YtNTc1aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0YzsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNTAwIDE1Nzl2MTM3aDYwMHYtMTM3aC02MDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0ZDsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek0zMTkgMTI0MSB2MTM3aDYwMHYtMTM3aC02MDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0ZTsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNDg2IDE4NDdoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE0ZjsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek0zMDcgMTUwOSBoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1MDsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNTA3IDE1Nzl2MjVxMzYgNDggOTEgMTQxdDg2IDE2MmgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjF0LTE0My41IC0xNDZoLTk3ek04NjQgMTU3OXYyNXE0OSA2OCA5OS41IDE1Ni41dDc2LjUgMTQ2LjVoMTg2di0yMXEtMzcgLTYzIC0xMjIuNSAtMTYxdC0xNDMuNSAtMTQ2aC05NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTUxOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNTQ5cTAgLTIxMCA4NCAtMzIwdDI0NyAtMTEwdDI0Ny41IDEwOS41dDg0LjUgMzIwLjVxMCAyMDkgLTg0LjUgMzE3LjV0LTI0OS41IDEwOC41cS0xNjMgMCAtMjQ2IC0xMDd0LTgzIC0zMTl6TTMyMSAxMjQxdjI1IHEzNiA0OCA5MSAxNDF0ODYgMTYyaDE4NnYtMjFxLTM3IC02MyAtMTIyLjUgLTE2MXQtMTQzLjUgLTE0NmgtOTd6TTY3OCAxMjQxdjI1cTQ5IDY4IDk5LjUgMTU2LjV0NzYuNSAxNDYuNWgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjF0LTE0My41IC0xNDZoLTk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNTI7IiBob3Jpei1hZHYteD0iMTg5MCIgZD0iTTEyNSA3MzVxMCAzNjAgMTc0IDU1NXQ0OTQgMTk1cTEwMiAwIDE5MiAtMjNoNzgydi0xNTFoLTU4OXYtNDcxaDU1MXYtMTUwaC01NTF2LTUzOGg1ODl2LTE1MmgtNzY4cS0xMDIgLTIwIC0xOTQgLTIwcS0zMjcgMCAtNTAzLjUgMTk2LjV0LTE3Ni41IDU1OC41ek0zMDUgNzMzcTAgLTI5NyAxMjguNSAtNDUwLjV0Mzc1LjUgLTE1My41cTExMiAwIDE5OSAzM3YxMTQxcS04NyAzMCAtMTk3IDMwcS0yNDkgMCAtMzc3LjUgLTE1Mi41IHQtMTI4LjUgLTQ0Ny41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNTM7IiBob3Jpei1hZHYteD0iMTkyOSIgZD0iTTExMyA1NDlxMCAyNjUgMTMxIDQxNXQzNjYgMTUwcTEzMSAwIDIzMy41IC01OS41dDE2NC41IC0xNzMuNXE1OCAxMTIgMTU0IDE3Mi41dDIyMiA2MC41cTIwMSAwIDMyMCAtMTMyLjV0MTE5IC0zNTguNXYtMTA1aC03MjlxOCAtMzkzIDMzOCAtMzkzcTk0IDAgMTc0LjUgMTcuNXQxNjcuNSA1Ni41di0xNDhxLTg4IC0zOSAtMTY0IC01NXQtMTgwIC0xNnEtMjkzIDAgLTQxOCAyMzVxLTYyIC0xMTYgLTE2Ni41IC0xNzUuNXQtMjQxLjUgLTU5LjUgcS0yMjMgMCAtMzU3IDE1Mi41dC0xMzQgNDE2LjV6TTI4NyA1NDlxMCAtMjExIDc2IC0zMjAuNXQyNDMgLTEwOS41cTE2MyAwIDIzOS41IDEwNi41dDc2LjUgMzE1LjVxMCAyMjEgLTc3LjUgMzI3LjV0LTI0Mi41IDEwNi41cS0xNjYgMCAtMjQwLjUgLTEwOHQtNzQuNSAtMzE4ek0xMDk4IDY1M2g1NDRxMCAxNTggLTY2IDI0MHQtMTk0IDgycS0xMjcgMCAtMTk5LjUgLTgydC04NC41IC0yNDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1NDsiIGhvcml6LWFkdi14PSIxMjY2IiBkPSJNMjAxIDB2MTQ2Mmg0MDFxMjY5IDAgMzk3LjUgLTEwM3QxMjguNSAtMzEwcTAgLTI5MCAtMjk0IC0zOTJsMzk3IC02NTdoLTIwMWwtMzU0IDYwOGgtMzA1di02MDhoLTE3MHpNMzcxIDc1NGgyMzNxMTgwIDAgMjY0IDcxLjV0ODQgMjE0LjVxMCAxNDUgLTg1LjUgMjA5dC0yNzQuNSA2NGgtMjIxdi01NTl6TTUxNCAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTU1OyIgaG9yaXotYWR2LXg9IjgzNiIgZD0iTTE3NiAwdjEwOTZoMTM3bDE5IC0yMDNoOHE2MSAxMDcgMTQ3IDE2NXQxODkgNThxNzMgMCAxMzEgLTEybC0yMyAtMTU0cS02OCAxNSAtMTIwIDE1cS0xMzMgMCAtMjI3LjUgLTEwOHQtOTQuNSAtMjY5di01ODhoLTE2NnpNMzU3IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1NjsiIGhvcml6LWFkdi14PSIxMjY2IiBkPSJNMjAxIDB2MTQ2Mmg0MDFxMjY5IDAgMzk3LjUgLTEwM3QxMjguNSAtMzEwcTAgLTI5MCAtMjk0IC0zOTJsMzk3IC02NTdoLTIwMWwtMzU0IDYwOGgtMzA1di02MDhoLTE3MHpNMzcxIDc1NGgyMzNxMTgwIDAgMjY0IDcxLjV0ODQgMjE0LjVxMCAxNDUgLTg1LjUgMjA5dC0yNzQuNSA2NGgtMjIxdi01NTl6TTQ5NCAtNDI4cTI4IDY0IDUzLjUgMTU3dDMyLjUgMTQ2aDE2OHYtMThxLTExIC01MSAtNjAgLTE0Ny41dC0xMDQgLTE2Mi41aC05MHYyNSB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1NzsiIGhvcml6LWFkdi14PSI4MzYiIGQ9Ik0xNzYgMHYxMDk2aDEzN2wxOSAtMjAzaDhxNjEgMTA3IDE0NyAxNjV0MTg5IDU4cTczIDAgMTMxIC0xMmwtMjMgLTE1NHEtNjggMTUgLTEyMCAxNXEtMTMzIDAgLTIyNy41IC0xMDh0LTk0LjUgLTI2OXYtNTg4aC0xNjZ6TTk2IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNTg7IiBob3Jpei1hZHYteD0iMTI2NiIgZD0iTTIwMSAwdjE0NjJoNDAxcTI2OSAwIDM5Ny41IC0xMDN0MTI4LjUgLTMxMHEwIC0yOTAgLTI5NCAtMzkybDM5NyAtNjU3aC0yMDFsLTM1NCA2MDhoLTMwNXYtNjA4aC0xNzB6TTM3MSA3NTRoMjMzcTE4MCAwIDI2NCA3MS41dDg0IDIxNC41cTAgMTQ1IC04NS41IDIwOXQtMjc0LjUgNjRoLTIyMXYtNTU5ek0yOTUgMTg4MnYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4IHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1OTsiIGhvcml6LWFkdi14PSI4MzYiIGQ9Ik0xNzYgMHYxMDk2aDEzN2wxOSAtMjAzaDhxNjEgMTA3IDE0NyAxNjV0MTg5IDU4cTczIDAgMTMxIC0xMmwtMjMgLTE1NHEtNjggMTUgLTEyMCAxNXEtMTMzIDAgLTIyNy41IC0xMDh0LTk0LjUgLTI2OXYtNTg4aC0xNjZ6TTEzMCAxNTQ0djI1aDExNXExMTQgLTc0IDIxOSAtMTg5cTEzMCAxMzAgMjIxIDE4OWgxMTl2LTI1bC02NiAtNjhxLTE0NCAtMTQ4IC0xOTAgLTIzNWgtMTY2cS0yMyA0MSAtNzQgMTA0dC0xNzggMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNWE7IiBob3Jpei1hZHYteD0iMTEyNCIgZD0iTTEwNiA0N3YxNjRxOTAgLTM4IDE5NiAtNjB0MjEwIC0yMnExNzAgMCAyNTYgNjQuNXQ4NiAxNzkuNXEwIDc2IC0zMC41IDEyNC41dC0xMDIgODkuNXQtMjE3LjUgOTNxLTIwNCA3MyAtMjkxLjUgMTczdC04Ny41IDI2MXEwIDE2OSAxMjcgMjY5dDMzNiAxMDBxMjE4IDAgNDAxIC04MGwtNTMgLTE0OHEtMTgxIDc2IC0zNTIgNzZxLTEzNSAwIC0yMTEgLTU4dC03NiAtMTYxcTAgLTc2IDI4IC0xMjQuNXQ5NC41IC04OXQyMDMuNSAtODkuNSBxMjMwIC04MiAzMTYuNSAtMTc2dDg2LjUgLTI0NHEwIC0xOTMgLTE0MCAtMzAxdC0zODAgLTEwOHEtMjYwIDAgLTQwMCA2N3pNNDczIDE1Nzl2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1YjsiIGhvcml6LWFkdi14PSI5NzciIGQ9Ik0xMDYgODI3cTAgMTM0IDEwOSAyMTEuNXQyOTkgNzcuNXExNzcgMCAzNDYgLTcybC01OSAtMTM1cS0xNjUgNjggLTI5OSA2OHEtMTE4IDAgLTE3OCAtMzd0LTYwIC0xMDJxMCAtNDQgMjIuNSAtNzV0NzIuNSAtNTl0MTkyIC04MXExOTUgLTcxIDI2My41IC0xNDN0NjguNSAtMTgxcTAgLTE1MyAtMTE0IC0yMzZ0LTMyMCAtODNxLTIxOCAwIC0zNDAgNjl2MTU0cTc5IC00MCAxNjkuNSAtNjN0MTc0LjUgLTIzcTEzMCAwIDIwMCA0MS41IHQ3MCAxMjYuNXEwIDY0IC01NS41IDEwOS41dC0yMTYuNSAxMDcuNXEtMTUzIDU3IC0yMTcuNSA5OS41dC05NiA5Ni41dC0zMS41IDEyOXpNMzcxIDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1YzsiIGhvcml6LWFkdi14PSIxMTI0IiBkPSJNMTA2IDQ3djE2NHE5MCAtMzggMTk2IC02MHQyMTAgLTIycTE3MCAwIDI1NiA2NC41dDg2IDE3OS41cTAgNzYgLTMwLjUgMTI0LjV0LTEwMiA4OS41dC0yMTcuNSA5M3EtMjA0IDczIC0yOTEuNSAxNzN0LTg3LjUgMjYxcTAgMTY5IDEyNyAyNjl0MzM2IDEwMHEyMTggMCA0MDEgLTgwbC01MyAtMTQ4cS0xODEgNzYgLTM1MiA3NnEtMTM1IDAgLTIxMSAtNTh0LTc2IC0xNjFxMCAtNzYgMjggLTEyNC41dDk0LjUgLTg5dDIwMy41IC04OS41IHEyMzAgLTgyIDMxNi41IC0xNzZ0ODYuNSAtMjQ0cTAgLTE5MyAtMTQwIC0zMDF0LTM4MCAtMTA4cS0yNjAgMCAtNDAwIDY3ek0yNDYgMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1ZDsiIGhvcml6LWFkdi14PSI5NzciIGQ9Ik0xMDYgODI3cTAgMTM0IDEwOSAyMTEuNXQyOTkgNzcuNXExNzcgMCAzNDYgLTcybC01OSAtMTM1cS0xNjUgNjggLTI5OSA2OHEtMTE4IDAgLTE3OCAtMzd0LTYwIC0xMDJxMCAtNDQgMjIuNSAtNzV0NzIuNSAtNTl0MTkyIC04MXExOTUgLTcxIDI2My41IC0xNDN0NjguNSAtMTgxcTAgLTE1MyAtMTE0IC0yMzZ0LTMyMCAtODNxLTIxOCAwIC0zNDAgNjl2MTU0cTc5IC00MCAxNjkuNSAtNjN0MTc0LjUgLTIzcTEzMCAwIDIwMCA0MS41IHQ3MCAxMjYuNXEwIDY0IC01NS41IDEwOS41dC0yMTYuNSAxMDcuNXEtMTUzIDU3IC0yMTcuNSA5OS41dC05NiA5Ni41dC0zMS41IDEyOXpNMTYzIDEyNDF2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNWU7IiBob3Jpei1hZHYteD0iMTEyNCIgZD0iTTEwNiA0N3YxNjRxOTAgLTM4IDE5NiAtNjB0MjEwIC0yMnExNzAgMCAyNTYgNjQuNXQ4NiAxNzkuNXEwIDc2IC0zMC41IDEyNC41dC0xMDIgODkuNXQtMjE3LjUgOTNxLTIwNCA3MyAtMjkxLjUgMTczdC04Ny41IDI2MXEwIDE2OSAxMjcgMjY5dDMzNiAxMDBxMjE4IDAgNDAxIC04MGwtNTMgLTE0OHEtMTgxIDc2IC0zNTIgNzZxLTEzNSAwIC0yMTEgLTU4dC03NiAtMTYxcTAgLTc2IDI4IC0xMjQuNXQ5NC41IC04OXQyMDMuNSAtODkuNSBxMjMwIC04MiAzMTYuNSAtMTc2dDg2LjUgLTI0NHEwIC0xOTMgLTE0MCAtMzAxdC0zODAgLTEwOHEtMjYwIDAgLTQwMCA2N3pNMzMyIC0zNzdxNDUgLTggMTA0IC04cTc5IDAgMTE5LjUgMjB0NDAuNSA3NHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE1ZjsiIGhvcml6LWFkdi14PSI5NzciIGQ9Ik0xMDYgODI3cTAgMTM0IDEwOSAyMTEuNXQyOTkgNzcuNXExNzcgMCAzNDYgLTcybC01OSAtMTM1cS0xNjUgNjggLTI5OSA2OHEtMTE4IDAgLTE3OCAtMzd0LTYwIC0xMDJxMCAtNDQgMjIuNSAtNzV0NzIuNSAtNTl0MTkyIC04MXExOTUgLTcxIDI2My41IC0xNDN0NjguNSAtMTgxcTAgLTE1MyAtMTE0IC0yMzZ0LTMyMCAtODNxLTIxOCAwIC0zNDAgNjl2MTU0cTc5IC00MCAxNjkuNSAtNjN0MTc0LjUgLTIzcTEzMCAwIDIwMCA0MS41IHQ3MCAxMjYuNXEwIDY0IC01NS41IDEwOS41dC0yMTYuNSAxMDcuNXEtMTUzIDU3IC0yMTcuNSA5OS41dC05NiA5Ni41dC0zMS41IDEyOXpNMjUwIC0zNzdxNDUgLTggMTA0IC04cTc5IDAgMTE5LjUgMjB0NDAuNSA3NHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE2MDsiIGhvcml6LWFkdi14PSIxMTI0IiBkPSJNMTA2IDQ3djE2NHE5MCAtMzggMTk2IC02MHQyMTAgLTIycTE3MCAwIDI1NiA2NC41dDg2IDE3OS41cTAgNzYgLTMwLjUgMTI0LjV0LTEwMiA4OS41dC0yMTcuNSA5M3EtMjA0IDczIC0yOTEuNSAxNzN0LTg3LjUgMjYxcTAgMTY5IDEyNyAyNjl0MzM2IDEwMHEyMTggMCA0MDEgLTgwbC01MyAtMTQ4cS0xODEgNzYgLTM1MiA3NnEtMTM1IDAgLTIxMSAtNTh0LTc2IC0xNjFxMCAtNzYgMjggLTEyNC41dDk0LjUgLTg5dDIwMy41IC04OS41IHEyMzAgLTgyIDMxNi41IC0xNzZ0ODYuNSAtMjQ0cTAgLTE5MyAtMTQwIC0zMDF0LTM4MCAtMTA4cS0yNjAgMCAtNDAwIDY3ek0yNDAgMTg4MnYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NnEtMjMgNDEgLTc0IDEwNHQtMTc4IDE5OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTYxOyIgaG9yaXotYWR2LXg9Ijk3NyIgZD0iTTEwNiA4MjdxMCAxMzQgMTA5IDIxMS41dDI5OSA3Ny41cTE3NyAwIDM0NiAtNzJsLTU5IC0xMzVxLTE2NSA2OCAtMjk5IDY4cS0xMTggMCAtMTc4IC0zN3QtNjAgLTEwMnEwIC00NCAyMi41IC03NXQ3Mi41IC01OXQxOTIgLTgxcTE5NSAtNzEgMjYzLjUgLTE0M3Q2OC41IC0xODFxMCAtMTUzIC0xMTQgLTIzNnQtMzIwIC04M3EtMjE4IDAgLTM0MCA2OXYxNTRxNzkgLTQwIDE2OS41IC02M3QxNzQuNSAtMjNxMTMwIDAgMjAwIDQxLjUgdDcwIDEyNi41cTAgNjQgLTU1LjUgMTA5LjV0LTIxNi41IDEwNy41cS0xNTMgNTcgLTIxNy41IDk5LjV0LTk2IDk2LjV0LTMxLjUgMTI5ek0xNjUgMTU0NHYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NnEtMjMgNDEgLTc0IDEwNHQtMTc4IDE5OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTYyOyIgaG9yaXotYWR2LXg9IjExMzMiIGQ9Ik0xOCAxMzExdjE1MWgxMDk2di0xNTFoLTQ2M3YtMTMxMWgtMTcwdjEzMTFoLTQ2M3pNMzU2IC0zNzdxNDUgLTggMTA0IC04cTc5IDAgMTE5LjUgMjB0NDAuNSA3NHEwIDQzIC0zOS41IDY5LjV0LTE0OC41IDQzLjVsODggMTc4aDExMGwtNTUgLTExNXExODAgLTM5IDE4MCAtMTc0cTAgLTk3IC03Ni41IC0xNTB0LTIyNi41IC01M3EtNTEgMCAtOTYgOXYxMDZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE2MzsiIGhvcml6LWFkdi14PSI3MjMiIGQ9Ik0zMSA5Njd2ODBsMTU3IDY5bDcwIDIzNGg5NnYtMjU0aDMxOHYtMTI5aC0zMTh2LTY0NXEwIC05OSA0NyAtMTUydDEyOSAtNTNxNDQgMCA4NSA2LjV0NjUgMTMuNXYtMTI3cS0yNyAtMTMgLTc5LjUgLTIxLjV0LTk0LjUgLTguNXEtMzE4IDAgLTMxOCAzMzV2NjUyaC0xNTd6TTIzNCAtMzc3cTQ1IC04IDEwNCAtOHE3OSAwIDExOS41IDIwdDQwLjUgNzRxMCA0MyAtMzkuNSA2OS41dC0xNDguNSA0My41bDg4IDE3OGgxMTBsLTU1IC0xMTUgcTE4MCAtMzkgMTgwIC0xNzRxMCAtOTcgLTc2LjUgLTE1MHQtMjI2LjUgLTUzcS01MSAwIC05NiA5djEwNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTY0OyIgaG9yaXotYWR2LXg9IjExMzMiIGQ9Ik0xOCAxMzExdjE1MWgxMDk2di0xNTFoLTQ2M3YtMTMxMWgtMTcwdjEzMTFoLTQ2M3pNMjMyIDE4ODJ2MjVoMTE1cTExNCAtNzQgMjE5IC0xODlxMTMwIDEzMCAyMjEgMTg5aDExOXYtMjVsLTY2IC02OHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE2NTsiIGhvcml6LWFkdi14PSI3MjMiIGQ9Ik0zMSA5Njd2ODBsMTU3IDY5bDcwIDIzNGg5NnYtMjU0aDMxOHYtMTI5aC0zMTh2LTY0NXEwIC05OSA0NyAtMTUydDEyOSAtNTNxNDQgMCA4NSA2LjV0NjUgMTMuNXYtMTI3cS0yNyAtMTMgLTc5LjUgLTIxLjV0LTk0LjUgLTguNXEtMzE4IDAgLTMxOCAzMzV2NjUyaC0xNTd6TTQ5MSAxMjI5djI0cTE5IDU1IDM4LjUgMTM4LjV0MjkuNSAxNjQuNWgxNjh2LTE4cS0xMSAtNTEgLTU1IC0xNDV0LTkxIC0xNjRoLTkweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNjY7IiBob3Jpei1hZHYteD0iMTEzMyIgZD0iTTE4IDEzMTF2MTUxaDEwOTZ2LTE1MWgtNDYzdi00OTZoMzEwdi0xNDFoLTMxMHYtNjc0aC0xNzB2Njc0aC0zMTN2MTQxaDMxM3Y0OTZoLTQ2M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTY3OyIgaG9yaXotYWR2LXg9IjcyMyIgZD0iTTMxIDk2N3Y4MGwxNTcgNjlsNzAgMjM0aDk2di0yNTRoMzE4di0xMjloLTMxOHYtMjU2aDMwMXYtMTI5aC0zMDF2LTI0NHEwIC0yMjEgMTgxIC0yMjFxODUgMCAxNDUgMjB2LTEyN3EtMzIgLTE0IC04NSAtMjJ0LTk1IC04cS0zMTIgMCAtMzEyIDM0OHYyNTRoLTE0MXYxMjloMTQxdjI1NmgtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNjg7IiBob3Jpei1hZHYteD0iMTQ5MSIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDAgLTI4MXQyOTQgLTk4cTE4NSAwIDI4NSA5OC41dDEwMCAyODIuNXY5NTJoMTcwdi05NDZxMCAtMjUwIC0xNTEgLTM5M3QtNDE1IC0xNDN0LTQwOC41IDE0NHQtMTQ0LjUgMzk2ek0zNzUgMTU3OXExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OSBxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDF0LTcwLjUgMTguNXEtNTAgMCAtNzUuNSAtMzB0LTM5LjUgLTkxaC05OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTY5OyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0xNjQgMzc5djcxN2gxNjh2LTcxMXEwIC0xMzQgNjEgLTIwMHQxOTEgLTY2cTE3MiAwIDI1MS41IDk0dDc5LjUgMzA3djU3NmgxNjZ2LTEwOTZoLTEzN2wtMjQgMTQ3aC05cS01MSAtODEgLTE0MS41IC0xMjR0LTIwNi41IC00M3EtMjAwIDAgLTI5OS41IDk1dC05OS41IDMwNHpNMjU1IDEyNDFxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41IHQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE2YTsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTQ0NiAxNTc5djEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNmI7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE2NCAzNzl2NzE3aDE2OHYtNzExcTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc2aDE2NnYtMTA5NmgtMTM3bC0yNCAxNDdoLTlxLTUxIC04MSAtMTQxLjUgLTEyNHQtMjA2LjUgLTQzcS0yMDAgMCAtMjk5LjUgOTV0LTk5LjUgMzA0ek0zMjYgMTI0MXYxMzdoNjAwdi0xMzdoLTYwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTZjOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xODYgNTIwdjk0MmgxNzB2LTk1NHEwIC0xODMgMTAwIC0yODF0Mjk0IC05OHExODUgMCAyODUgOTguNXQxMDAgMjgyLjV2OTUyaDE3MHYtOTQ2cTAgLTI1MCAtMTUxIC0zOTN0LTQxNSAtMTQzdC00MDguNSAxNDR0LTE0NC41IDM5NnpNNDMyIDE4NDdoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNSB0LTg3IDE5OS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNmQ7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE2NCAzNzl2NzE3aDE2OHYtNzExcTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc2aDE2NnYtMTA5NmgtMTM3bC0yNCAxNDdoLTlxLTUxIC04MSAtMTQxLjUgLTEyNHQtMjA2LjUgLTQzcS0yMDAgMCAtMjk5LjUgOTV0LTk5LjUgMzA0ek0zMTEgMTUwOWgxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTcgdC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE2ZTsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTUyMyAxNzk0cTAgOTggNjAuNSAxNTUuNXQxNjAuNSA1Ny41cTEwMSAwIDE2MyAtNTkuNXQ2MiAtMTUxLjVxMCAtOTggLTYxLjUgLTE1Ny41dC0xNjMuNSAtNTkuNXEtMTAxIDAgLTE2MSA1OC41IHQtNjAgMTU2LjV6TTYyNyAxNzk0cTAgLTU2IDMwIC04Ni41dDg3IC0zMC41cTUyIDAgODQuNSAzMC41dDMyLjUgODYuNXQtMzMgODYuNXQtODQgMzAuNXQtODQgLTMwLjV0LTMzIC04Ni41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNmY7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE2NCAzNzl2NzE3aDE2OHYtNzExcTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc2aDE2NnYtMTA5NmgtMTM3bC0yNCAxNDdoLTlxLTUxIC04MSAtMTQxLjUgLTEyNHQtMjA2LjUgLTQzcS0yMDAgMCAtMjk5LjUgOTV0LTk5LjUgMzA0ek00MDIgMTQ1NnEwIDk4IDYwLjUgMTU1LjV0MTYwLjUgNTcuNXExMDEgMCAxNjMgLTU5LjV0NjIgLTE1MS41cTAgLTk4IC02MS41IC0xNTcuNXQtMTYzLjUgLTU5LjUgcS0xMDEgMCAtMTYxIDU4LjV0LTYwIDE1Ni41ek01MDYgMTQ1NnEwIC01NiAzMCAtODYuNXQ4NyAtMzAuNXE1MiAwIDg0LjUgMzAuNXQzMi41IDg2LjV0LTMzIDg2LjV0LTg0IDMwLjV0LTg0IC0zMC41dC0zMyAtODYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTcwOyIgaG9yaXotYWR2LXg9IjE0OTEiIGQ9Ik0xODYgNTIwdjk0MmgxNzB2LTk1NHEwIC0xODMgMTAwIC0yODF0Mjk0IC05OHExODUgMCAyODUgOTguNXQxMDAgMjgyLjV2OTUyaDE3MHYtOTQ2cTAgLTI1MCAtMTUxIC0zOTN0LTQxNSAtMTQzdC00MDguNSAxNDR0LTE0NC41IDM5NnpNNDU2IDE1Nzl2MjVxMzYgNDggOTEgMTQxdDg2IDE2MmgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjF0LTE0My41IC0xNDZoLTk3ek04MTMgMTU3OXYyNXE0OSA2OCA5OS41IDE1Ni41dDc2LjUgMTQ2LjUgaDE4NnYtMjFxLTM3IC02MyAtMTIyLjUgLTE2MXQtMTQzLjUgLTE0NmgtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3MTsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTY0IDM3OXY3MTdoMTY4di03MTFxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzZoMTY2di0xMDk2aC0xMzdsLTI0IDE0N2gtOXEtNTEgLTgxIC0xNDEuNSAtMTI0dC0yMDYuNSAtNDNxLTIwMCAwIC0yOTkuNSA5NXQtOTkuNSAzMDR6TTMzNSAxMjQxdjI1cTM2IDQ4IDkxIDE0MXQ4NiAxNjJoMTg2di0yMXEtMzcgLTYzIC0xMjIuNSAtMTYxdC0xNDMuNSAtMTQ2aC05N3pNNjkyIDEyNDF2MjUgcTQ5IDY4IDk5LjUgMTU2LjV0NzYuNSAxNDYuNWgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjF0LTE0My41IC0xNDZoLTk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNzI7IiBob3Jpei1hZHYteD0iMTQ5MSIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDAgLTI4MXQyOTQgLTk4cTE4NSAwIDI4NSA5OC41dDEwMCAyODIuNXY5NTJoMTcwdi05NDZxMCAtMjUwIC0xNTEgLTM5M3QtNDE1IC0xNDN0LTQwOC41IDE0NHQtMTQ0LjUgMzk2ek01ODIgLTI1OHEwIDcwIDQzIDEzNy41dDExNSAxMjAuNWgxMjBxLTY4IC02NiAtMTAyLjUgLTEyMC41dC0zNC41IC0xMTcuNXEwIC05NCA5NCAtOTRxNDIgMCA5NyAxM3YtMTA5cS02NSAtMTggLTEyNSAtMTggcS0yMDcgMCAtMjA3IDE4OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTczOyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik0xNjQgMzc5djcxN2gxNjh2LTcxMXEwIC0xMzQgNjEgLTIwMHQxOTEgLTY2cTE3MiAwIDI1MS41IDk0dDc5LjUgMzA3djU3NmgxNjZ2LTEwOTZoLTEzN2wtMjQgMTQ3aC05cS01MSAtODEgLTE0MS41IC0xMjR0LTIwNi41IC00M3EtMjAwIDAgLTI5OS41IDk1dC05OS41IDMwNHpNNzkzIC0yNThxMCA3MCA0MyAxMzcuNXQxMTUgMTIwLjVoMTIwcS02OCAtNjYgLTEwMi41IC0xMjAuNXQtMzQuNSAtMTE3LjVxMCAtOTQgOTQgLTk0IHE0MiAwIDk3IDEzdi0xMDlxLTY1IC0xOCAtMTI1IC0xOHEtMjA3IDAgLTIwNyAxODh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3NDsiIGhvcml6LWFkdi14PSIxODk2IiBkPSJNMjcgMTQ2MmgxODBsMjMxIC05MDNxNDggLTE5MCA3MCAtMzQ0cTI3IDE4MyA4MCAzNThsMjYyIDg4OWgxODBsMjc1IC04OTdxNDggLTE1NSA4MSAtMzUwcTE5IDE0MiA3MiAzNDZsMjMwIDkwMWgxODBsLTM5MSAtMTQ2MmgtMTY4bC0yOTUgOTc5cS0yMSA2NSAtNDcgMTY0dC0yNyAxMTlxLTIyIC0xMzIgLTcwIC0yODlsLTI4NiAtOTczaC0xNjh6TTYwOCAxNTc5djIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2IHEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3NTsiIGhvcml6LWFkdi14PSIxNTkzIiBkPSJNMjMgMTA5NmgxNzRxMTA2IC00MTMgMTYxLjUgLTYyOXQ2My41IC0yOTFoOHExMSA1NyAzNS41IDE0Ny41dDQyLjUgMTQzLjVsMjAxIDYyOWgxODBsMTk2IC02MjlxNTYgLTE3MiA3NiAtMjg5aDhxNCAzNiAyMS41IDExMXQyMDguNSA4MDdoMTcybC0zMDMgLTEwOTZoLTE5N2wtMjAxIDY0M3EtMTkgNTkgLTcxIDI2OGgtOHEtNDAgLTE3NSAtNzAgLTI3MGwtMjA3IC02NDFoLTE5MnpNNDYxIDEyNDF2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNSBoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTc2OyIgaG9yaXotYWR2LXg9IjExNDciIGQ9Ik0wIDE0NjJoMTg2bDM4NyAtNzMxbDM5MCA3MzFoMTg0bC00ODggLTg5NXYtNTY3aC0xNzJ2NTU5ek0yMzYgMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3NzsiIGhvcml6LWFkdi14PSIxMDMyIiBkPSJNMiAxMDk2aDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2ek0xODUgMTI0MXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yMyBoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNzg7IiBob3Jpei1hZHYteD0iMTE0NyIgZD0iTTAgMTQ2MmgxODZsMzg3IC03MzFsMzkwIDczMWgxODRsLTQ4OCAtODk1di01NjdoLTE3MnY1NTl6TTI5NCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek02NzUgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNSB0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxNzk7IiBob3Jpei1hZHYteD0iMTE2OSIgZD0iTTgyIDB2MTMzbDc3NiAxMTc2aC03NTJ2MTUzaDk1OXYtMTMzbC03NzYgLTExNzVoNzk4di0xNTRoLTEwMDV6TTQ1OSAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxN2E7IiBob3Jpei1hZHYteD0iOTU4IiBkPSJNODIgMHYxMTNsNTk4IDg1NGgtNTYxdjEyOWg3NDN2LTEyOWwtNTkwIC04MzhoNjA1di0xMjloLTc5NXpNMzY5IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3YjsiIGhvcml6LWFkdi14PSIxMTY5IiBkPSJNODIgMHYxMzNsNzc2IDExNzZoLTc1MnYxNTNoOTU5di0xMzNsLTc3NiAtMTE3NWg3OTh2LTE1NGgtMTAwNXpNNDg2IDE3MzFxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE3YzsiIGhvcml6LWFkdi14PSI5NTgiIGQ9Ik04MiAwdjExM2w1OTggODU0aC01NjF2MTI5aDc0M3YtMTI5bC01OTAgLTgzOGg2MDV2LTEyOWgtNzk1ek0zODUgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTdkOyIgaG9yaXotYWR2LXg9IjExNjkiIGQ9Ik04MiAwdjEzM2w3NzYgMTE3NmgtNzUydjE1M2g5NTl2LTEzM2wtNzc2IC0xMTc1aDc5OHYtMTU0aC0xMDA1ek0yNDkgMTg4MnYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NnEtMjMgNDEgLTc0IDEwNHQtMTc4IDE5OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MTdlOyIgaG9yaXotYWR2LXg9Ijk1OCIgZD0iTTgyIDB2MTEzbDU5OCA4NTRoLTU2MXYxMjloNzQzdi0xMjlsLTU5MCAtODM4aDYwNXYtMTI5aC03OTV6TTE0NiAxNTQ0djI1aDExNXExMTQgLTc0IDIxOSAtMTg5cTEzMCAxMzAgMjIxIDE4OWgxMTl2LTI1bC02NiAtNjhxLTE0NCAtMTQ4IC0xOTAgLTIzNWgtMTY2cS0yMyA0MSAtNzQgMTA0dC0xNzggMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxN2Y7IiBob3Jpei1hZHYteD0iNjU1IiBkPSJNMTc2IDB2MTE4MHEwIDM4NyAzNTkgMzg3cTk2IDAgMTk2IC0zN2wtNDMgLTEzM3EtODcgMzAgLTE2MCAzMHEtOTcgMCAtMTQxLjUgLTYxLjV0LTQ0LjUgLTE4My41di0xMTgyaC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDE5MjsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMTk1IC0zMzRxNzAgLTE4IDEzMSAtMThxOTUgMCAxMzMuNSA1MXQzOC41IDE2NHY5NzNoLTIyMnY3NWwyMjIgNjB2MTM5cTAgMTk1IDgxIDI4NHQyNjMgODlxODUgMCAyMDUgLTQzbC0yMiAtNjRsLTIxIC02NXEtMTAyIDMyIC0xNjIgMzJxLTk4IDAgLTEzOCAtNTIuNXQtNDAgLTE3Ni41di0xNDloMjgydi0xMjloLTI3OHYtOTY5cTAgLTE4NCAtNzkgLTI3MS41dC0yNjEgLTg3LjVxLTY5IDAgLTEzMyAxOXYxMzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFhMDsiIGhvcml6LWFkdi14PSIxNTk3IiBkPSJNMTI1IDczNXEwIDM2MCAxNzYuNSA1NTV0NDk5LjUgMTk1cTMyNSAwIDUwNCAtMjE1cTUwIDEyIDc5IDQ1LjV0NDIuNSA4NC41dDEzLjUgMTU2aDE4MmwxNCAtMjJxLTI5IC0xNTUgLTk0LjUgLTI0MS41dC0xNjkuNSAtMTI1LjVxOTYgLTE3NiA5NiAtNDM0cTAgLTM1NCAtMTc3LjUgLTU1My41dC00OTEuNSAtMTk5LjVxLTMyMyAwIC00OTguNSAxOTYuNXQtMTc1LjUgNTU4LjV6TTMwNSA3MzNxMCAtMjk4IDEyNSAtNDUxdDM2OSAtMTUzIHEyNDMgMCAzNjYgMTUyLjV0MTIzIDQ1MS41cTAgMjk1IC0xMjIuNSA0NDcuNXQtMzY0LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUxLjV0LTEyNi41IC00NDguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWExOyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjE3IDAgMzU0IC0xNDFxNTEgMTUgODAgNDcuNXQ0MiA4MnQxMyAxNTkuNWgxODBsMTUgLTIzcS0zMSAtMTU2IC05MS41IC0yNDMuNXQtMTYyLjUgLTEyNS41cTcxIC0xMzggNzEgLTMyM3EwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTEgNzkgLTMyMC41dDI1MiAtMTA5LjUgcTE3NSAwIDI1My41IDEwOS41dDc4LjUgMzIwLjVxMCAyMTAgLTc5LjUgMzE4dC0yNTQuNSAxMDhxLTE3MyAwIC0yNTEgLTEwOHQtNzggLTMxOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWFmOyIgaG9yaXotYWR2LXg9IjE1NzMiIGQ9Ik0xODYgNTIwdjk0MmgxNzB2LTk1NHEwIC0xODMgMTAyIC0yODF0MzAwIC05OHExODQgMCAyODAuNSA5Ni41dDk2LjUgMjg0LjV2OTUyaDE3MHYtMTk4cTU4IDggOTMgMzl0NTAuNSA4N3QxNS41IDE2NmgxODFsMTQgLTIycS0zMyAtMTgyIC0xMTkgLTI3NHQtMjM1IC0xMTd2LTYyN3EwIC0yNTggLTE0My41IC0zOTd0LTQwNy41IC0xMzlxLTI2OCAwIC00MTggMTQzLjV0LTE1MCAzOTYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWIwOyIgaG9yaXotYWR2LXg9IjEzNjIiIGQ9Ik0xNjQgMzc5djcxNWgxNjh2LTcwOXEwIC0xMzQgNjEgLTIwMHQxOTEgLTY2cTE3MiAwIDI1MS41IDk0dDc5LjUgMzA3djU3NGgxNjZ2LTEyMXE4MiAxMSAxMTkgNzV0MzcgMjE4aDE3OGwxNSAtMjNxLTMyIC0xODYgLTEyMCAtMjgxLjV0LTIyOSAtMTA5LjV2LTg1MmgtMTM3bC0yNCAxNDdoLTlxLTUyIC04MiAtMTQyLjUgLTEyNC41dC0yMDEuNSAtNDIuNXEtMjAzIDAgLTMwMyA5NXQtMTAwIDMwNHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWYwOyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTS0xMTEgLTMzMnE2OSAtMjAgMTM2IC0yMHE3OCAwIDExNC41IDQyLjV0MzYuNSAxMjkuNXYxMjc2aDE2NnYtMTI2NHEwIC0zMjQgLTI5OSAtMzI0cS05NSAwIC0xNTQgMjV2MTM1ek0tNzUgMTU0NHYyNWgxMTVxMTE0IC03NCAyMTkgLTE4OXExMzAgMTMwIDIyMSAxODloMTE5di0yNWwtNjYgLTY4cS0xNDQgLTE0OCAtMTkwIC0yMzVoLTE2NnEtMjMgNDEgLTc0IDEwNHQtMTc4IDE5OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWZhOyIgaG9yaXotYWR2LXg9IjEzMDAiIGQ9Ik0wIDBsNTMyIDEyMzlxLTEwNiA1MiAtMTA2IDE4OHEwIDEwMSA2MSAxNTh0MTYwIDU3cTEwMCAwIDE2Mi41IC01OC41dDYyLjUgLTE1My41cTAgLTEzMyAtMTA0IC0xODlsNTMyIC0xMjQxaC0xNzRsLTE3NiA0MDFoLTYxMGwtMTY2IC00MDFoLTE3NHpNNDAxIDU1NWg0OThsLTE3OCA0MzJxLTI1IDU4IC03MiAyMDNxLTE0IC00OCAtMzggLTExNS41dC0zMyAtOTEuNXpNNTMwIDE0MjdxMCAtNTUgMzAgLTg1LjV0ODcgLTMwLjUgcTUzIDAgODUgMzAuNXQzMiA4NS41cTAgNTcgLTMzIDg3dC04NCAzMHQtODQgLTMwdC0zMyAtODd6TTU1MyAxNjk0djE4cTQ5IDU5IDEwMCAxMzMuNXQ3NCAxMTYuNWgyMDN2LTE2cS0zMiAtNDYgLTExNiAtMTI2LjV0LTE1MCAtMTI1LjVoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWZiOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzcgMzQ4bDE4MCA2djY4cTAgMTMwIC01OS41IDE5MXQtMTkyLjUgNjFxLTk2IDAgLTE3OS41IC0yNnQtMTU0LjUgLTU4bC01NSAxMjdxODQgNDMgMTg4IDY4LjV0MjA1IDI1LjVxMjA5IDAgMzA5LjUgLTg3dDEwMC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDEgcTAgLTkwIDU0LjUgLTEzN3QxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTM1NiAxNDU2cTAgOTggNjAuNSAxNTUuNXQxNjEuNSA1Ny41dDE2MyAtNTkuNXQ2MiAtMTUxLjVxMCAtOTggLTYxLjUgLTE1Ny41dC0xNjMuNSAtNTkuNXEtMTAxIDAgLTE2MS41IDU4dC02MC41IDE1N3pNNDYxIDE0NTZxMCAtNTYgMzAgLTg2LjV0ODcgLTMwLjUgcTUyIDAgODQgMzAuNXQzMiA4Ni41dC0zMi41IDg2LjV0LTgzLjUgMzAuNXQtODQgLTMwLjV0LTMzIC04Ni41ek00NzEgMTc1M3YxNnE0NiA0MiA5OSAxMDJ0NzUgOTFoMjYwdi0xMnEtMjEgLTI0IC0xMDMgLTc2LjV0LTIxMCAtMTIwLjVoLTEyMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWZjOyIgaG9yaXotYWR2LXg9IjE3ODgiIGQ9Ik0tMiAwbDY5OCAxNDYyaDk2OXYtMTUxaC01ODB2LTQ3MWg1NDF2LTE1MGgtNTQxdi01MzhoNTgwdi0xNTJoLTc1MHY0NjVoLTUxNGwtMjI3IC00NjVoLTE3NnpNNDY5IDYxOGg0NDZ2NjkzaC0xMTh6TTk4MSAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZmQ7IiBob3Jpei1hZHYteD0iMTc1NyIgZD0iTTk0IDMwM3EwIDE2MSAxMjQgMjUwLjV0Mzc4IDk3LjVsMTg0IDZ2NjhxMCAxMjkgLTU4IDE5MC41dC0xNzcgNjEuNXEtMTQ0IDAgLTMwNyAtODRsLTUyIDEyN3E3NCA0MSAxNzMuNSA2Ny41dDE5Ny41IDI2LjVxMTMwIDAgMjEyLjUgLTQzLjV0MTIzLjUgLTEzOC41cTUzIDg4IDEzOC41IDEzNnQxOTUuNSA0OHExOTIgMCAzMDggLTEzMy41dDExNiAtMzU1LjV2LTEwN2gtNzAxcTggLTM5NSAzMjIgLTM5NXE5MSAwIDE2OS41IDE3LjUgdDE2Mi41IDU2LjV2LTE0OHEtODYgLTM4IC0xNjAuNSAtNTQuNXQtMTc1LjUgLTE2LjVxLTI4OSAwIC00MTQgMjMzcS04MSAtMTI3IC0xNzkuNSAtMTgwdC0yMzIuNSAtNTNxLTE2MyAwIC0yNTUuNSA4NXQtOTIuNSAyMzh6TTI2OCAzMDFxMCAtOTUgNTMuNSAtMTM5LjV0MTQxLjUgLTQ0LjVxMTQ1IDAgMjI5IDg0LjV0ODQgMjM4LjV2OTlsLTE1OCAtN3EtMTg2IC04IC0yNjggLTYyLjV0LTgyIC0xNjguNXpNOTU0IDY1M2g1MTkgcTAgMTU2IC02NCAyNDB0LTE4NCA4NHEtMTIxIDAgLTE5MC41IC04M3QtODAuNSAtMjQxek03ODIgMTI0MXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWZlOyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMjA5IDAgMzY2IC05NGw5NyAxMzVsMTIwIC04MGwtMTA2IC0xNDhxMTkyIC0yMDIgMTkyIC01NjVxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0yMzUgMCAtMzgzIDEwMGwtMTAxIC0xNDFsLTEyMCA3OWwxMDggMTU0cS0xNzggMTk4IC0xNzggNTYzek0zMDUgNzMzcTAgLTI2MiAxMDEgLTQxNmw2NjkgOTQzcS0xMDYgNzMgLTI3NCA3MyBxLTI0MyAwIC0zNjkuNSAtMTUzLjV0LTEyNi41IC00NDYuNXpNNTA4IDIxMXExMTUgLTgyIDI5MSAtODJxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjcyIC0xMTAgNDI2ek02NzQgMTU3OXYyNXE0OCA2MiAxMDMuNSAxNTB0ODcuNSAxNTNoMjAydi0yMXEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWZmOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMTU0IDAgMjcwIC03Nmw4NCAxMTlsMTE3IC03NmwtOTcgLTEzM3ExMjcgLTE1MiAxMjcgLTQwMXEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE1NCAwIC0yNjYgNjlsLTg0IC0xMTdsLTExNCA3OGw5NCAxMzFxLTEyOSAxNTIgLTEyOSA0MDh6TTI4NyA1NDlxMCAtMTcxIDUzIC0yNzNsNDY1IDY0NnEtNzUgNTMgLTE4OSA1M3EtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5IHpNNDM0IDE3MHE3MSAtNTEgMTg0IC01MXExNjMgMCAyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMTY0IC01MSAyNjR6TTQ3OSAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMTg7IiBob3Jpei1hZHYteD0iMTEyNCIgZD0iTTEwNiA0N3YxNjRxOTAgLTM4IDE5NiAtNjB0MjEwIC0yMnExNzAgMCAyNTYgNjQuNXQ4NiAxNzkuNXEwIDc2IC0zMC41IDEyNC41dC0xMDIgODkuNXQtMjE3LjUgOTNxLTIwNCA3MyAtMjkxLjUgMTczdC04Ny41IDI2MXEwIDE2OSAxMjcgMjY5dDMzNiAxMDBxMjE4IDAgNDAxIC04MGwtNTMgLTE0OHEtMTgxIDc2IC0zNTIgNzZxLTEzNSAwIC0yMTEgLTU4dC03NiAtMTYxcTAgLTc2IDI4IC0xMjQuNXQ5NC41IC04OXQyMDMuNSAtODkuNSBxMjMwIC04MiAzMTYuNSAtMTc2dDg2LjUgLTI0NHEwIC0xOTMgLTE0MCAtMzAxdC0zODAgLTEwOHEtMjYwIDAgLTQwMCA2N3pNMzc1IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMTk7IiBob3Jpei1hZHYteD0iOTc3IiBkPSJNMTA2IDgyN3EwIDEzNCAxMDkgMjExLjV0Mjk5IDc3LjVxMTc3IDAgMzQ2IC03MmwtNTkgLTEzNXEtMTY1IDY4IC0yOTkgNjhxLTExOCAwIC0xNzggLTM3dC02MCAtMTAycTAgLTQ0IDIyLjUgLTc1dDcyLjUgLTU5dDE5MiAtODFxMTk1IC03MSAyNjMuNSAtMTQzdDY4LjUgLTE4MXEwIC0xNTMgLTExNCAtMjM2dC0zMjAgLTgzcS0yMTggMCAtMzQwIDY5djE1NHE3OSAtNDAgMTY5LjUgLTYzdDE3NC41IC0yM3ExMzAgMCAyMDAgNDEuNSB0NzAgMTI2LjVxMCA2NCAtNTUuNSAxMDkuNXQtMjE2LjUgMTA3LjVxLTE1MyA1NyAtMjE3LjUgOTkuNXQtOTYgOTYuNXQtMzEuNSAxMjl6TTI5OCAtNDI4cTI4IDY0IDUzLjUgMTU3dDMyLjUgMTQ2aDE2OHYtMThxLTExIC01MSAtNjAgLTE0Ny41dC0xMDQgLTE2Mi41aC05MHYyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjFhOyIgaG9yaXotYWR2LXg9IjExMzMiIGQ9Ik0xOCAxMzExdjE1MWgxMDk2di0xNTFoLTQ2M3YtMTMxMWgtMTcwdjEzMTFoLTQ2M3pNMzk0IC00MjhxMjggNjQgNTMuNSAxNTd0MzIuNSAxNDZoMTY4di0xOHEtMTEgLTUxIC02MCAtMTQ3LjV0LTEwNCAtMTYyLjVoLTkwdjI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMWI7IiBob3Jpei1hZHYteD0iNzIzIiBkPSJNMzEgOTY3djgwbDE1NyA2OWw3MCAyMzRoOTZ2LTI1NGgzMTh2LTEyOWgtMzE4di02NDVxMCAtOTkgNDcgLTE1MnQxMjkgLTUzcTQ0IDAgODUgNi41dDY1IDEzLjV2LTEyN3EtMjcgLTEzIC03OS41IC0yMS41dC05NC41IC04LjVxLTMxOCAwIC0zMTggMzM1djY1MmgtMTU3ek0yNDMgLTQyOHEyOCA2NCA1My41IDE1N3QzMi41IDE0NmgxNjh2LTE4cS0xMSAtNTEgLTYwIC0xNDcuNXQtMTA0IC0xNjIuNWgtOTB2MjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIzNzsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0tMTExIC0zMzJxNjkgLTIwIDEzNiAtMjBxNzggMCAxMTQuNSA0Mi41dDM2LjUgMTI5LjV2MTI3NmgxNjZ2LTEyNjRxMCAtMzI0IC0yOTkgLTMyNHEtOTUgMCAtMTU0IDI1djEzNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MmJjOyIgaG9yaXotYWR2LXg9IjM0OCIgZD0iTTI1IDk2MXE3MCAyODUgMTAyIDUwMWgxODJsMTUgLTIycS0yNiAtMTAwIC03NSAtMjMyLjV0LTEwMiAtMjQ2LjVoLTEyMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MmM2OyIgaG9yaXotYWR2LXg9IjEyMTIiIGQ9Ik0yNjggMTI0MXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDJjNzsiIGhvcml6LWFkdi14PSIxMjEyIiBkPSJNMjY4IDE1NDR2MjVoMTE1cTExNCAtNzQgMjE5IC0xODlxMTMwIDEzMCAyMjEgMTg5aDExOXYtMjVsLTY2IC02OHEtMTQ0IC0xNDggLTE5MCAtMjM1aC0xNjZxLTIzIDQxIC03NCAxMDR0LTE3OCAxOTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDJjOTsiIGhvcml6LWFkdi14PSIxMjAyIiBkPSJNMzAxIDEyNDF2MTM3aDYwMHYtMTM3aC02MDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDJkODsiIGhvcml6LWFkdi14PSIxMjEyIiBkPSJNMjkzIDE1MDloMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDJkOTsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNjIgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MmRhOyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik0zNjcgMTQ1NnEwIDk4IDYwLjUgMTU1LjV0MTYwLjUgNTcuNXExMDEgMCAxNjMgLTU5LjV0NjIgLTE1MS41cTAgLTk4IC02MS41IC0xNTcuNXQtMTYzLjUgLTU5LjVxLTEwMSAwIC0xNjEgNTguNXQtNjAgMTU2LjV6TTQ3MSAxNDU2cTAgLTU2IDMwIC04Ni41dDg3IC0zMC41cTUyIDAgODQuNSAzMC41dDMyLjUgODYuNXQtMzMgODYuNXQtODQgMzAuNXQtODQgLTMwLjV0LTMzIC04Ni41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyZGI7IiBob3Jpei1hZHYteD0iNDAzIiBkPSJNMzcgLTI1OHEwIDcwIDQzIDEzNy41dDExNSAxMjAuNWgxMjBxLTY4IC02NiAtMTAyLjUgLTEyMC41dC0zNC41IC0xMTcuNXEwIC05NCA5NCAtOTRxNDIgMCA5NyAxM3YtMTA5cS02NSAtMTggLTEyNSAtMThxLTIwNyAwIC0yMDcgMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyZGM7IiBob3Jpei1hZHYteD0iMTIxMiIgZD0iTTI2NCAxMjQxcTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDJkZDsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMjMxIDEyNDF2MjVxMzYgNDggOTEgMTQxdDg2IDE2MmgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjF0LTE0My41IC0xNDZoLTk3ek01ODggMTI0MXYyNXE0OSA2OCA5OS41IDE1Ni41dDc2LjUgMTQ2LjVoMTg2di0yMXEtMzcgLTYzIC0xMjIuNSAtMTYxdC0xNDMuNSAtMTQ2aC05NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MmYzOyIgaG9yaXotYWR2LXg9IjY4MiIgZD0iTTExNyAtMzQwcTAgOTggNjAgMTU2LjV0MTYxIDU4LjV0MTY0IC01OXQ2MyAtMTU0cTAgLTk3IC02Mi41IC0xNTd0LTE2NC41IC02MHEtMTAxIDAgLTE2MSA1OC41dC02MCAxNTYuNXpNMjIxIC0zNDBxMCAtNTYgMzAgLTg2LjV0ODcgLTMwLjVxNTMgMCA4NSAzMC41dDMyIDg2LjVxMCA1NyAtMzMgODd0LTg0IDMwdC04NCAtMzB0LTMzIC04N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzAwOyIgaG9yaXotYWR2LXg9IjAiIGQ9Ik0tOTQxIDE1NDh2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDMwMTsiIGhvcml6LWFkdi14PSIwIiBkPSJNLTc1NSAxMjQxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzMDM7IiBob3Jpei1hZHYteD0iMCIgZD0iTS05OTkgMTI0MXExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OXEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzMDk7IiBob3Jpei1hZHYteD0iMCIgZD0iTS03NjAgMTU2OXYxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzBmOyIgaG9yaXotYWR2LXg9IjAiIGQ9Ik0tMTA1MSAxNTQ4djIxaDE4N3EyOCAtNjEgNzcuNSAtMTQ4dDk4LjUgLTE1NXYtMjVoLTk2cS01NiA0NCAtMTQzIDE0NHQtMTI0IDE2M3pNLTY5NCAxNTQ4djIxaDE4NnEyOCAtNjEgNzcuNSAtMTQ4dDk4LjUgLTE1NXYtMjVoLTk2cS01MiA0MiAtMTQwLjUgMTQzdC0xMjUuNSAxNjR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDMyMzsiIGhvcml6LWFkdi14PSIwIiBkPSJNLTcwOSAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Mzg0OyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik01MDggMTI0MXYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM4NTsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMjgzIDEzOTNxMCA1MiAyNiA3NXQ2NCAyM3E0MSAwIDY1LjUgLTI2dDI0LjUgLTcycTAgLTUwIC0yNy41IC03NC41dC02Mi41IC0yNC41cS0zOCAwIC02NCAyNC41dC0yNiA3NC41ek01MTIgMTM4OXYyNHE2NSAxNjkgOTYgMzAzaDE4OXYtMjBxLTMzIC02NyAtOTMuNSAtMTU2LjV0LTExMS41IC0xNTAuNWgtODB6TTcxOSAxMzkzcTAgNTIgMjYgNzV0NjQgMjNxNDEgMCA2NS41IC0yNnQyNC41IC03MnEwIC01MCAtMjcuNSAtNzQuNSB0LTYyLjUgLTI0LjVxLTM4IDAgLTY0IDI0LjV0LTI2IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM4NjsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0yOCAxMTM2djI5cTI3IDcyIDUzLjUgMTg1LjV0MzguNSAxOTUuNWgxODR2LTIzcS0xOCAtNzQgLTcyLjUgLTE5Mi41dC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Mzg3OyIgaG9yaXotYWR2LXg9IjU0NSIgZD0iTTE1MiA3MjNxMCA2NiAzMSAxMDAuNXQ4NyAzNC41cTU4IDAgOTAuNSAtMzQuNXQzMi41IC0xMDAuNXEwIC02NSAtMzMgLTEwMHQtOTAgLTM1cS01MSAwIC04NC41IDMxLjV0LTMzLjUgMTAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM4ODsiIGhvcml6LWFkdi14PSIxMjY2IiBkPSJNMzI2IDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TS00NCAxMTM2djI5cTI3IDcyIDUzLjUgMTg1LjV0MzguNSAxOTUuNWgxODR2LTIzcS0xOCAtNzQgLTcyLjUgLTE5Mi41dC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Mzg5OyIgaG9yaXotYWR2LXg9IjE2NjEiIGQ9Ik0zNTEgMHYxNDYyaDE3MHYtNjIyaDc3MHY2MjJoMTcwdi0xNDYyaC0xNzB2Njg4aC03NzB2LTY4OGgtMTcwek0tNDQgMTEzNnYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM4YTsiIGhvcml6LWFkdi14PSI3NDEiIGQ9Ik0zNzEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek0tMjggMTEzNnYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM4YzsiIGhvcml6LWFkdi14PSIxNjY1IiBkPSJNMTkzIDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzczIDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNLTI4IDExMzZ2MjlxMjcgNzIgNTMuNSAxODUuNXQzOC41IDE5NS41aDE4NHYtMjNxLTE4IC03NCAtNzIuNSAtMTkyLjV0LTEwMy41IC0xOTQuNWgtMTAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOGU7IiBob3Jpei1hZHYteD0iMTQxMyIgZD0iTTI2NiAxNDYyaDE4NmwzODcgLTczMWwzOTAgNzMxaDE4NGwtNDg4IC04OTV2LTU2N2gtMTcydjU1OXpNLTQ0IDExMzZ2MjlxMjcgNzIgNTMuNSAxODUuNXQzOC41IDE5NS41aDE4NHYtMjNxLTE4IC03NCAtNzIuNSAtMTkyLjV0LTEwMy41IC0xOTQuNWgtMTAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOGY7IiBob3Jpei1hZHYteD0iMTY2NSIgZD0iTTE0MyAwdjE1MmgzNjRxLTE1MSAxMTggLTIzMSAyOTN0LTgwIDM3OHEwIDMxMCAxNzcgNDg2dDQ5MSAxNzZxMzE1IDAgNDkyIC0xNzMuNXQxNzcgLTQ4Ni41cTAgLTIwNyAtNzkgLTM4MHQtMjMwIC0yOTNoMzYzdi0xNTJoLTU4NnYxMzNxMTgzIDEzNCAyNjcuNSAzMDF0ODQuNSAzODlxMCAyNTIgLTEyNC41IDM4MXQtMzY0LjUgMTI5cS0yMzggMCAtMzYzIC0xMjguNXQtMTI1IC0zODEuNXEwIC0yMjUgODYuNSAtMzkxLjUgdDI2Ni41IC0yOTguNXYtMTMzaC01ODZ6TS0yOCAxMTM2djI5cTI3IDcyIDUzLjUgMTg1LjV0MzguNSAxOTUuNWgxODR2LTIzcS0xOCAtNzQgLTcyLjUgLTE5Mi41dC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzkwOyIgaG9yaXotYWR2LXg9IjY5NCIgZD0iTTE2OCAzMTd2Nzc5aDE2NnYtNzc0cTAgLTEwNCAzNi41IC0xNTQuNXQxMjMuNSAtNTAuNXEzNyAwIDg3LjUgNi41dDc3LjUgMTMuNXYtMTI3cS0zMSAtMTMgLTgzLjUgLTIxLjV0LTEwMi41IC04LjVxLTE2MCAwIC0yMzIuNSA4NHQtNzIuNSAyNTN6TS0yMyAxMzkzcTAgNTIgMjYgNzV0NjQgMjNxNDEgMCA2NS41IC0yNnQyNC41IC03MnEwIC01MCAtMjcuNSAtNzQuNXQtNjIuNSAtMjQuNXEtMzggMCAtNjQgMjQuNXQtMjYgNzQuNXogTTIwNiAxMzg5djI0cTY1IDE2OSA5NiAzMDNoMTg5di0yMHEtMzMgLTY3IC05My41IC0xNTYuNXQtMTExLjUgLTE1MC41aC04MHpNNDEzIDEzOTNxMCA1MiAyNiA3NXQ2NCAyM3E0MSAwIDY1LjUgLTI2dDI0LjUgLTcycTAgLTUwIC0yNy41IC03NC41dC02Mi41IC0yNC41cS0zOCAwIC02NCAyNC41dC0yNiA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOTE7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzkyOyIgaG9yaXotYWR2LXg9IjEzMjciIGQ9Ik0yMDEgMHYxNDYyaDQxM3EyOTEgMCA0MjEgLTg3dDEzMCAtMjc1cTAgLTEzMCAtNzIuNSAtMjE0LjV0LTIxMS41IC0xMDkuNXYtMTBxMzMzIC01NyAzMzMgLTM1MHEwIC0xOTYgLTEzMi41IC0zMDZ0LTM3MC41IC0xMTBoLTUxMHpNMzcxIDE0NWgzMDVxMTc3IDAgMjY2LjUgNjguNXQ4OS41IDIxNC41cTAgMTM2IC05MS41IDIwMHQtMjc4LjUgNjRoLTI5MXYtNTQ3ek0zNzEgODM2aDI4MHExODAgMCAyNTkgNTYuNXQ3OSAxOTAuNSBxMCAxMjMgLTg4IDE3Ny41dC0yODAgNTQuNWgtMjUwdi00Nzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM5MzsiIGhvcml6LWFkdi14PSIxMDY1IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1M2gtNjQ1di0xMzA5aC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM5NDsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMzkgMHYxMDRsNDYzIDEzNThoMTY2bDQ2NSAtMTM2MHYtMTAyaC0xMDk0ek0yMjMgMTUyaDcyMWwtMjU4IDc2MXEtNjggMjAyIC0xMDIgMzU1cS02MSAtMjI1IC0xMDEgLTM0NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Mzk1OyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOTY7IiBob3Jpei1hZHYteD0iMTE2OSIgZD0iTTgyIDB2MTMzbDc3NiAxMTc2aC03NTJ2MTUzaDk1OXYtMTMzbC03NzYgLTExNzVoNzk4di0xNTRoLTEwMDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM5NzsiIGhvcml6LWFkdi14PSIxNTExIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg3NzB2NjIyaDE3MHYtMTQ2MmgtMTcwdjY4OGgtNzcwdi02ODhoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4Mzk4OyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDUgNzMzcTAgLTI5NiAxMjUgLTQ1MHQzNjkgLTE1NHEyNDMgMCAzNjcgMTUydDEyNCA0NTJxMCAyOTggLTEyMy41IDQ0OXQtMzY1LjUgMTUxcS0yNDUgMCAtMzcwLjUgLTE1M3QtMTI1LjUgLTQ0N3pNNDgzIDY3MHYxNDkgaDYyOXYtMTQ5aC02Mjl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDM5OTsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOWE7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTIwMSAwdjE0NjJoMTcwdi03MjVsNjYzIDcyNWgyMDFsLTU4OCAtNjM1bDYxMCAtODI3aC0yMDBsLTUzMyA3MDlsLTE1MyAtMTM2di01NzNoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzliOyIgaG9yaXotYWR2LXg9IjEyMzUiIGQ9Ik0wIDBsNTI4IDE0NjJoMTc3bDUzMCAtMTQ2MmgtMTgybC0zMzAgOTI4cS04NyAyNTIgLTEwOSAzNDJxLTMzIC0xMzkgLTEwNCAtMzQwbC0zMjggLTkzMGgtMTgyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOWM7IiBob3Jpei1hZHYteD0iMTg0OSIgZD0iTTIwMSAwdjE0NjJoMjU2bDQ2MyAtMTIwNmg4bDQ2NyAxMjA2aDI1NHYtMTQ2MmgtMTcwdjk0MnEwIDE2MiAxNCAzNTJoLThsLTUwMCAtMTI5NGgtMTM3bC00OTYgMTI5NmgtOHExNCAtMTU0IDE0IC0zNjZ2LTkzMGgtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzOWQ7IiBob3Jpei1hZHYteD0iMTU0NCIgZD0iTTIwMSAwdjE0NjJoMTkybDc5NyAtMTIyMmg4cS0yIDI4IC05IDE3NHEtNSAxMTQgLTUgMTc3djMydjgzOWgxNTl2LTE0NjJoLTE5NGwtNzk5IDEyMjdoLThxMTYgLTIxNiAxNiAtMzk2di04MzFoLTE1N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzllOyIgaG9yaXotYWR2LXg9IjExMzMiIGQ9Ik03MiAwdjE1Mmg5ODl2LTE1MmgtOTg5ek0xMTMgMTMxMXYxNTFoOTA3di0xNTFoLTkwN3pNMTk1IDY5MHYxNTBoNzQzdi0xNTBoLTc0M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MzlmOyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDUgNzMzcTAgLTI5NyAxMjYuNSAtNDUwLjV0MzY3LjUgLTE1My41cTI0MyAwIDM2NyAxNTN0MTI0IDQ1MXEwIDI5NSAtMTIzLjUgNDQ3LjV0LTM2NS41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1My41IHQtMTI2LjUgLTQ0Ni41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYTA7IiBob3Jpei1hZHYteD0iMTQ5MyIgZD0iTTIwMSAwdjE0NjJoMTA5MXYtMTQ2MmgtMTcwdjEzMTFoLTc1MXYtMTMxMWgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYTE7IiBob3Jpei1hZHYteD0iMTIzMyIgZD0iTTIwMSAwdjE0NjJoMzc5cTU0OCAwIDU0OCAtNDI2cTAgLTIyMiAtMTUxLjUgLTM0MS41dC00MzMuNSAtMTE5LjVoLTE3MnYtNTc1aC0xNzB6TTM3MSA3MjFoMTUzcTIyNiAwIDMyNyA3M3QxMDEgMjM0cTAgMTQ1IC05NSAyMTZ0LTI5NiA3MWgtMTkwdi01OTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhMzsiIGhvcml6LWFkdi14PSIxMTYxIiBkPSJNNzQgMHYxNDFsNDgxIDYyM2wtNDY5IDU1NXYxNDNoOTcxdi0xNTNoLTY3NmwtOTYgMmw0NjAgLTU0NWwtNDgxIC02MTRoODUydi0xNTJoLTEwNDJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhNDsiIGhvcml6LWFkdi14PSIxMTMzIiBkPSJNMTggMTMxMXYxNTFoMTA5NnYtMTUxaC00NjN2LTEzMTFoLTE3MHYxMzExaC00NjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhNTsiIGhvcml6LWFkdi14PSIxMTQ3IiBkPSJNMCAxNDYyaDE4NmwzODcgLTczMWwzOTAgNzMxaDE4NGwtNDg4IC04OTV2LTU2N2gtMTcydjU1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2E2OyIgaG9yaXotYWR2LXg9IjE2MzQiIGQ9Ik0xMDYgNzU4cTAgMTU4IDY3LjUgMjgydDE5My41IDE5My41dDI5NyA2OS41aDY3djE4MGgxNzJ2LTE4MGg3MHExNzEgMCAyOTYuNSAtNjh0MTkyIC0xOTJ0NjYuNSAtMjgzcTAgLTE2NiAtNzQuNSAtMjk1LjV0LTIwNCAtMTk0LjV0LTMwNS41IC02NWgtNDF2LTIyNWgtMTcydjIyNWgtNDVxLTE3NiAwIC0zMDUgNjZ0LTIwMiAxOTZ0LTczIDI5MXpNMjgzIDc2MnEwIC0xOTcgMTExIC0zMDUuNXQzMTMgLTEwOC41aDI0djgwOWgtNTcgcS0xODIgMCAtMjg2LjUgLTEwNnQtMTA0LjUgLTI4OXpNOTAzIDM0OGgyNXEyMDEgMCAzMTIuNSAxMDkuNXQxMTEuNSAzMDQuNXEwIDE4NSAtMTAzIDI5MHQtMjg4IDEwNWgtNTh2LTgwOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2E3OyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik04IDBsNDg2IDc2NGwtNDUzIDY5OGgxODhsMzYzIC01NzlsMzY2IDU3OWgxODFsLTQ1MyAtNjkybDQ4OCAtNzcwaC0xOTNsLTM5MyA2NDNsLTQwMCAtNjQzaC0xODB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhODsiIGhvcml6LWFkdi14PSIxNjMwIiBkPSJNMTA5IDk3OXY0ODNoMTc0di00NzlxMCAtMTg4IDEwMy41IC0yODguNXQzMTUuNSAtMTAwLjVoMjd2ODY4aDE3MHYtODY4aDI5cTIxMSAwIDMxNC41IDk5dDEwMy41IDI4NnY0ODNoMTc2di00ODFxMCAtMTY1IC03MiAtMjg4LjV0LTIwMS41IC0xODV0LTMwNC41IC02MS41aC00NXYtNDQ2aC0xNzB2NDQ2aC00NXEtMTc2IDAgLTMwMy41IDYxdC0xOTkuNSAxODQuNXQtNzIgMjg3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhOTsiIGhvcml6LWFkdi14PSIxNjAyIiBkPSJNODAgMHYxNTJoMzY0cS0xNTEgMTE4IC0yMzEgMjkzdC04MCAzNzhxMCAzMTAgMTc3IDQ4NnQ0OTEgMTc2cTMxNSAwIDQ5MiAtMTczLjV0MTc3IC00ODYuNXEwIC0yMDcgLTc5IC0zODB0LTIzMCAtMjkzaDM2M3YtMTUyaC01ODZ2MTMzcTE4MyAxMzQgMjY3LjUgMzAxdDg0LjUgMzg5cTAgMjUyIC0xMjQuNSAzODF0LTM2NC41IDEyOXEtMjM4IDAgLTM2MyAtMTI4LjV0LTEyNSAtMzgxLjVxMCAtMjI1IDg2LjUgLTM5MS41dDI2Ni41IC0yOTguNSB2LTEzM2gtNTg2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYWE7IiBob3Jpei1hZHYteD0iNTcxIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTE0NjJoLTE3MHpNNSAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek0zODYgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhYjsiIGhvcml6LWFkdi14PSIxMTQ3IiBkPSJNMCAxNDYyaDE4NmwzODcgLTczMWwzOTAgNzMxaDE4NGwtNDg4IC04OTV2LTU2N2gtMTcydjU1OXpNMjkyIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTY3MyAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41IHQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhYzsiIGhvcml6LWFkdi14PSIxMjUxIiBkPSJNMTE1IDU0NXEwIDI3NCAxMjIgNDIyLjV0MzQ3IDE0OC41cTEyMSAwIDIwMS41IC00MnQxMzQuNSAtMTI2aDEycTI0IDkyIDY1IDE0OGgxMjlxLTIxIC02NiAtMzUgLTE4OXQtMTQgLTIzOXYtNDM5cTAgLTExNCA4NCAtMTE0cTI5IDAgNjIgMTB2LTExOXEtNDYgLTI2IC0xMTEgLTI2cS04MSAwIC0xMjUuNSA0MC41dC02Mi41IDEyNi41aC0xM3EtNTkgLTg2IC0xNDIuNSAtMTI2LjV0LTIwMS41IC00MC41cS0yMTQgMCAtMzMzIDE0OC41IHQtMTE5IDQxNi41ek0yODcgNTQzcTAgLTIxMiA3My41IC0zMTh0MjMxLjUgLTEwNnExNjkgMCAyNDQgOTcuNXQ3NSAzMTUuNXYxNXEwIDIyOSAtNzYgMzI4LjV0LTI0NSA5OS41cS0zMDMgMCAtMzAzIC00MzJ6TTUzNyAxMjQxdjI5cTI3IDcyIDUzLjUgMTg1LjV0MzguNSAxOTUuNWgxODR2LTIzcS0xOCAtNzQgLTcyLjUgLTE5Mi41dC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2FkOyIgaG9yaXotYWR2LXg9Ijk3MyIgZD0iTTkwIDI5N3EwIDk4IDU1IDE2My41dDE4NSAxMDYuNXYxMXEtOTggMjggLTE1MS41IDkxLjV0LTUzLjUgMTU1LjVxMCAxMzMgMTEyIDIxMnQzMDQgNzlxOTcgMCAxNzkuNSAtMTYuNXQxODIuNSAtNjEuNWwtNjMgLTEzM3EtOTQgNDIgLTE1OSA1NnQtMTQ0IDE0cS0yNTAgMCAtMjUwIC0xNjJxMCAtMTcyIDMxNyAtMTcyaDExMXYtMTQxaC0xNDhxLTMxMSAwIC0zMTEgLTE5NXEwIC05MCA3My41IC0xMzl0MjE5LjUgLTQ5cTg0IDAgMTY3IDE5LjUgdDE4MyA2Ni41di0xNDhxLTEzNyAtNzUgLTM1OCAtNzVxLTIxMCAwIC0zMzAuNSA4NC41dC0xMjAuNSAyMzIuNXpNNDUyIDEyNDF2MjlxMjcgNzIgNTMuNSAxODUuNXQzOC41IDE5NS41aDE4NHYtMjNxLTE4IC03NCAtNzIuNSAtMTkyLjV0LTEwMy41IC0xOTQuNWgtMTAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYWU7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE3NiAwdjEwOTZoMTM1bDI3IC0xNTBoOHE1MSA4MSAxNDMgMTI1LjV0MjA1IDQ0LjVxMTk4IDAgMjk4IC05NS41dDEwMCAtMzA1LjV2LTEyMDdoLTE2NnYxMjAxcTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTcyIDAgLTI1MiAtOTN0LTgwIC0zMDd2LTU3NWgtMTY2ek01NjcgMTI0MXYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNhZjsiIGhvcml6LWFkdi14PSI2OTQiIGQ9Ik0xNjggMzE3djc3OWgxNjZ2LTc3NHEwIC0xMDQgMzYuNSAtMTU0LjV0MTIzLjUgLTUwLjVxMzcgMCA4Ny41IDYuNXQ3Ny41IDEzLjV2LTEyN3EtMzEgLTEzIC04My41IC0yMS41dC0xMDIuNSAtOC41cS0xNjAgMCAtMjMyLjUgODR0LTcyLjUgMjUzek0xOTIgMTI0MXYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNiMDsiIGhvcml6LWFkdi14PSIxMjQ3IiBkPSJNMTY0IDQ5NnY2MDBoMTY2di01OTJxMCAtMTkyIDc5IC0yODkuNXQyMzIgLTk3LjVxMTY3IDAgMjQ3LjUgMTE5dDgwLjUgMzcwcTAgMTMwIC0xNCAyNDJ0LTQ4IDI0OGgxNjZxMzYgLTE0NCA1MCAtMjUxdDE0IC0yNDdxMCAtMzE4IC0xMjkgLTQ2OHQtMzgxIC0xNTBxLTIzMSAwIC0zNDcgMTI1dC0xMTYgMzkxek0zNDIgMTM5M3EwIDUyIDI2IDc1dDY0IDIzcTQxIDAgNjUuNSAtMjZ0MjQuNSAtNzJxMCAtNTAgLTI3LjUgLTc0LjUgdC02Mi41IC0yNC41cS0zOCAwIC02NCAyNC41dC0yNiA3NC41ek01NzEgMTM4OXYyNHE2NSAxNjkgOTYgMzAzaDE4OXYtMjBxLTMzIC02NyAtOTMuNSAtMTU2LjV0LTExMS41IC0xNTAuNWgtODB6TTc3OCAxMzkzcTAgNTIgMjYgNzV0NjQgMjNxNDEgMCA2NS41IC0yNnQyNC41IC03MnEwIC01MCAtMjcuNSAtNzQuNXQtNjIuNSAtMjQuNXEtMzggMCAtNjQgMjQuNXQtMjYgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2IxOyIgaG9yaXotYWR2LXg9IjEyNTEiIGQ9Ik0xMTUgNTQ1cTAgMjc0IDEyMiA0MjIuNXQzNDcgMTQ4LjVxMTIxIDAgMjAxLjUgLTQydDEzNC41IC0xMjZoMTJxMjQgOTIgNjUgMTQ4aDEyOXEtMjEgLTY2IC0zNSAtMTg5dC0xNCAtMjM5di00MzlxMCAtMTE0IDg0IC0xMTRxMjkgMCA2MiAxMHYtMTE5cS00NiAtMjYgLTExMSAtMjZxLTgxIDAgLTEyNS41IDQwLjV0LTYyLjUgMTI2LjVoLTEzcS01OSAtODYgLTE0Mi41IC0xMjYuNXQtMjAxLjUgLTQwLjVxLTIxNCAwIC0zMzMgMTQ4LjUgdC0xMTkgNDE2LjV6TTI4NyA1NDNxMCAtMjEyIDczLjUgLTMxOHQyMzEuNSAtMTA2cTE2OSAwIDI0NCA5Ny41dDc1IDMxNS41djE1cTAgMjI5IC03NiAzMjguNXQtMjQ1IDk5LjVxLTMwMyAwIC0zMDMgLTQzMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2IyOyIgaG9yaXotYWR2LXg9IjEyODYiIGQ9Ik0xNzYgLTQ5MnYxNTg4cTAgMjI1IDEyNi41IDM0OHQzNTYuNSAxMjNxMjIwIDAgMzQ0LjUgLTEwNHQxMjQuNSAtMjg3cTAgLTI5NCAtMzEzIC0zNDV2LThxMzc3IC00MiAzNzcgLTQwOXEwIC0yMDkgLTEzMiAtMzIxLjV0LTM3MCAtMTEyLjVxLTEwOSAwIC0xODkgMTUuNXQtMTU5IDUzLjV2LTU0MWgtMTY2ek0zNDIgMjAzcTkzIC00OSAxNzMuNSAtNjcuNXQxNjYuNSAtMTguNXExNzEgMCAyNTcuNSA3NXQ4Ni41IDIzMnQtOTUgMjM5IHQtMjcyIDgyaC0xMTJ2MTQyaDkycTE1NSAwIDIzNiA3My41dDgxIDIxMC41cTAgMTIzIC03OCAxODkuNXQtMjIxIDY2LjVxLTE1OCAwIC0yMzYuNSAtODZ0LTc4LjUgLTI1MXYtODg3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYjM7IiBob3Jpei1hZHYteD0iMTA0OSIgZD0iTTEwIDEwOTZoMTcybDI0MCAtNTg0cTk0IC0yMzUgMTEzIC0zMzhoOHE1IDMwIDI1LjUgMTAxdDQyIDEzNS41dDI1NS41IDY4NS41aDE3MmwtNDA1IC0xMDY5cS00OCAtMTI0IC03NC41IC0yNzB0LTI2LjUgLTI0OWgtMTgwcTAgOTYgMzIgMjQzdDc1IDI2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2I0OyIgaG9yaXotYWR2LXg9IjExODgiIGQ9Ik0xMTMgNDM4cTAgMTc3IDExMyAzMDcuNXQzMTkgMTkwLjVxLTE0MCA3OCAtMTk4IDE1Ny41dC01OCAxNzguNXEwIDEzMCA5NyAyMDZ0MjYxIDc2cTEwMyAwIDE5Ny41IC0yMi41dDIyMC41IC04NS41bC03MiAtMTM1cS0xMTIgNjIgLTE5MS41IDg0dC0xNjAuNSAyMnEtODUgMCAtMTMzLjUgLTM5LjV0LTQ4LjUgLTEwNS41cTAgLTcxIDUzLjUgLTEyNi41dDIyMC41IC0xNDYuNXEyMTAgLTExNSAyOTguNSAtMjM1LjV0ODguNSAtMjg0LjUgcTAgLTIzNSAtMTM2IC0zNjd0LTM3MiAtMTMycS0yMjcgMCAtMzYzIDEyNHQtMTM2IDMzNHpNMjg3IDQzNHEwIC0xNDQgODkgLTIyOS41dDIzNiAtODUuNXExNjIgMCAyNDkgOTN0ODcgMjY3cTAgMTI4IC02MS41IDIxOS41dC0yMDIuNSAxNjUuNXEtMjA2IC01MyAtMzAxLjUgLTE2MS41dC05NS41IC0yNjguNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2I1OyIgaG9yaXotYWR2LXg9Ijk3MyIgZD0iTTkwIDI5N3EwIDk4IDU1IDE2My41dDE4NSAxMDYuNXYxMXEtOTggMjggLTE1MS41IDkxLjV0LTUzLjUgMTU1LjVxMCAxMzMgMTEyIDIxMnQzMDQgNzlxOTcgMCAxNzkuNSAtMTYuNXQxODIuNSAtNjEuNWwtNjMgLTEzM3EtOTQgNDIgLTE1OSA1NnQtMTQ0IDE0cS0yNTAgMCAtMjUwIC0xNjJxMCAtMTcyIDMxNyAtMTcyaDExMXYtMTQxaC0xNDhxLTMxMSAwIC0zMTEgLTE5NXEwIC05MCA3My41IC0xMzl0MjE5LjUgLTQ5cTg0IDAgMTY3IDE5LjUgdDE4MyA2Ni41di0xNDhxLTEzNyAtNzUgLTM1OCAtNzVxLTIxMCAwIC0zMzAuNSA4NC41dC0xMjAuNSAyMzIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2I2OyIgaG9yaXotYWR2LXg9Ijk4OSIgZD0iTTExNSA0NTlxMCAxMTQgMjkuNSAyMTh0ODUuNSAyMDEuNXQxNTYuNSAyMTJ0MzQyLjUgMzMyLjVxLTQwIC04IC0zMTEgLThoLTI0MnYxNDFoNzUydi0xMjlxLTIxNSAtMTgwIC0zNTkgLTM0MS41dC0yMTMgLTMwNnQtNjkgLTMxMC41cTAgLTk4IDI5LjUgLTE1N3Q5MiAtOTUuNXQyMzQuNSAtNzMuNXExNDkgLTMxIDIxNyAtODUuNXQ2OCAtMTQ1LjVxMCAtMTQ5IC0xMjcgLTMxM2gtMTY2cTEyNSAxNjEgMTI1IDI2OHEwIDU2IC01NS41IDg2LjUgdC0xOTguNSA1Ni41cS0yMDMgMzYgLTI5NyAxNDUuNXQtOTQgMzAzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNiNzsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTc2IDB2MTA5NmgxMzVsMjcgLTE1MGg4cTUxIDgxIDE0MyAxMjUuNXQyMDUgNDQuNXExOTggMCAyOTggLTk1LjV0MTAwIC0zMDUuNXYtMTIwN2gtMTY2djEyMDFxMCAxMzQgLTYxIDIwMHQtMTkxIDY2cS0xNzIgMCAtMjUyIC05M3QtODAgLTMwN3YtNTc1aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNiODsiIGhvcml6LWFkdi14PSIxMjEyIiBkPSJNMTE1IDc4MHEwIDQwNyAxMjIuNSA2MDN0MzY2LjUgMTk2dDM2OSAtMjAyLjV0MTI1IC01OTYuNXEwIC00MDYgLTEyMiAtNjAzdC0zNzIgLTE5N3EtMjQwIDAgLTM2NC41IDIwMS41dC0xMjQuNSA1OTguNXpNMjgzIDczMXE0IC0zMDQgNzkgLTQ1OHQyNDIgLTE1NHExNjQgMCAyNDIgMTUyLjV0ODQgNDU5LjVoLTY0N3pNMjgzIDg3Mmg2NDVxLTExIDI4MSAtODcgNDI0LjV0LTIzNyAxNDMuNXQtMjM2IC0xNDMuNXQtODUgLTQyNC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYjk7IiBob3Jpei1hZHYteD0iNjk0IiBkPSJNMTY4IDMxN3Y3NzloMTY2di03NzRxMCAtMTA0IDM2LjUgLTE1NC41dDEyMy41IC01MC41cTM3IDAgODcuNSA2LjV0NzcuNSAxMy41di0xMjdxLTMxIC0xMyAtODMuNSAtMjEuNXQtMTAyLjUgLTguNXEtMTYwIDAgLTIzMi41IDg0dC03Mi41IDI1M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2JhOyIgaG9yaXotYWR2LXg9IjEwNjEiIGQ9Ik0xNzYgMHYxMDk0aDE3OHYtMjgzcTAgLTE2NiAtMTIgLTI3OWw0NzMgNTYyaDIwN2wtNDE0IC00ODJsNDQzIC02MTJoLTIwMWwtMzYxIDUwNGwtMTM1IC0xMTN2LTM5MWgtMTc4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYmI7IiBob3Jpei1hZHYteD0iMTA5NCIgZD0iTS0xNCAwbDQ3MyAxMDc5bC01OCAxNjJxLTMwIDg1IC01NSAxMjB0LTU4LjUgNTN0LTgyLjUgMThxLTU4IDAgLTExNSAtMTN2MTMzcTY4IDE3IDEzMSAxN3E5MSAwIDE1MS41IC0zMHQxMDQuNSAtOTV0OTggLTIxN2wzNjMgLTEwMTJxMTkgLTQ5IDQwIC03NC41dDU2IC0yNS41cTI3IDAgNjAgMTB2LTEyMXEtNDggLTI0IC0xMDkgLTI0cS03NCAwIC0xMTUuNSAzOHQtNzAuNSAxMjFsLTE1NiA0MzZxLTg0IDI0MCAtMTA2IDMzNmgtOSBxLTI4IC0xMTYgLTExNiAtMzI1bC0yNTQgLTU4NmgtMTcyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYmM7IiBob3Jpei1hZHYteD0iMTI2OCIgZD0iTTE3NiAtNDkydjE1ODhoMTY2di03MTVxMCAtMjYyIDI1NCAtMjYycTE3MSAwIDI1MC41IDk0LjV0NzkuNSAzMDYuNXY1NzZoMTY2di0xMDk2aC0xMzZsLTI2IDE0N2gtMTBxLTExMSAtMTY3IC0zNDAgLTE2N3EtMTUwIDAgLTIzOCA5MmgtMTBxMTAgLTg0IDEwIC0yNDR2LTMyMGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYmQ7IiBob3Jpei1hZHYteD0iMTExMCIgZD0iTTAgMTA5NmgxNzJsMjE5IC01OTBxMjYgLTY3IDY3LjUgLTE4NnQ1Ny41IC0xODFoOHExNzcgMTc1IDI1Ni41IDM5Ny41dDc5LjUgNTU5LjVoMTY2cTAgLTM2MyAtMTAzLjUgLTYxN3QtMzI4LjUgLTQ3OWgtMTg2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYmU7IiBob3Jpei1hZHYteD0iOTczIiBkPSJNMTEzIDQyMHEwIDE0MCA3OSAyNDV0MjA3IDE0NHYxMnEtMjE3IDY0IC0yMTcgMjgxcTAgMTE3IDY5LjUgMTk2dDIzNS41IDEyOXEtMTI4IC0xMiAtMjQzIC0xMmgtNjh2MTQxaDY5OHYtMTMxaC01MXEtMTMwIDAgLTI0MiAtNDB0LTE3NS41IC0xMTJ0LTYzLjUgLTE2N3EwIC0xMTUgODMuNSAtMTY5dDI1OC41IC01NGgxNzB2LTEyOWgtMTc4cS0xNzYgMCAtMjgyLjUgLTg5dC0xMDYuNSAtMjMxcTAgLTgwIDI1IC0xMjl0NzIuNSAtNzkuNSB0MTE1IC00OC41dDE1MS41IC0zNnExNDIgLTI5IDIwOS41IC04NHQ2Ny41IC0xNDVxMCAtNjUgLTI3IC0xMzkuNXQtOTQgLTE3My41aC0xNTZxNTMgNzEgODYgMTQ0LjV0MzMgMTI1LjVxMCA1NSAtNTcuNSA4NS41dC0yMDAuNSA1NS41cS0yMDAgMzQgLTI5OS41IDEzNHQtOTkuNSAyNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNiZjsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYzA7IiBob3Jpei1hZHYteD0iMTMzMSIgZD0iTTI1IDk1NHY3NGwxNDMgNjhoMTEwMHYtMTQyaC0yMTN2LTcwOHEwIC03NCAyNS41IC0xMDEuNXQ2OC41IC0yNy41cTM4IDAgODYgMTh2LTEzMXEtNDMgLTI0IC0xMjcgLTI0cS0yMTkgMCAtMjE5IDI1M3Y3MjFoLTQ3N3YtOTU0aC0xNjZ2OTU0aC0yMjF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNjMTsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTY2IC00OTJ2MTA1NXEwIDI2NiAxMjUuNSA0MDkuNXQzNTkuNSAxNDMuNXEyMTkgMCAzNDUgLTE1MS41dDEyNiAtNDE1LjVxMCAtMjcxIC0xMjggLTQyMHQtMzYxIC0xNDlxLTE3OSAwIC0yOTkgOTRoLThxOCAtNjEgOCAtMjczdi0yOTNoLTE2OHpNMzM0IDIyMXExMjIgLTEwMiAzMDUgLTEwMnExNTkgMCAyMzUgMTA0dDc2IDMyNnEwIDIxNCAtNzIgMzIwdC0yMzUgMTA2cS0xNTggMCAtMjMzLjUgLTEwMy41dC03NS41IC0zMTIuNXYtMzM4eiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2MyOyIgaG9yaXotYWR2LXg9Ijk4NyIgZD0iTTExNSA1MjBxMCAyODYgMTM4IDQ0MXQzODYgMTU1cTc5IDAgMTU4IC0xNi41dDEzMyAtNDAuNWwtNTMgLTE0MXEtMTMwIDUxIC0yNDQgNTFxLTE3NiAwIC0yNjEgLTEwOXQtODUgLTMzOHEwIC0xMzUgMjkuNSAtMjAxdDEwMSAtMTA2dDIzMS41IC03NHExNDggLTMyIDIxMy41IC04NS41dDY1LjUgLTE0My41cTAgLTY2IC0yNyAtMTQydC05NCAtMTcxaC0xNTZxNTQgNzAgODcuNSAxNDR0MzMuNSAxMjRxMCA0MCAtMjUuNSA2My41IHQtODAuNSA0Mi41dC0xNTIgMzdxLTIwNCAzNyAtMzAxLjUgMTY0dC05Ny41IDM0NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2MzOyIgaG9yaXotYWR2LXg9IjEyNTUiIGQ9Ik0xMTUgNTIycTAgNTc0IDU5MiA1NzRoNDk5di0xNDJoLTI2NHExNzggLTE2NyAxNzggLTQ0NnEwIC0xNTcgLTYxLjUgLTI3Ny41dC0xNzYgLTE4NS41dC0yNjguNSAtNjVxLTIzNSAwIC0zNjcgMTQ0dC0xMzIgMzk4ek0yODcgNTIycTAgLTE5NCA4NSAtMjk4LjV0MjQ2IC0xMDQuNXExNTkgMCAyNDQuNSA5OC41dDg1LjUgMjgwLjVxMCAyNzAgLTE3NCA0NTZoLTY1cS0yMjIgMCAtMzIyIC0xMDR0LTEwMCAtMzI4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYzQ7IiBob3Jpei1hZHYteD0iOTY5IiBkPSJNMTggOTU0djc0bDE0OCA2OGg3NDl2LTE0MmgtNDMydi02MThxMCAtMjIzIDIwNSAtMjIzcTQ3IDAgOTYgNi41dDc2IDEzLjV2LTEyNXEtMzUgLTE1IC05MC41IC0yNHQtMTAzLjUgLTlxLTE4MSAwIC0yNjYgODV0LTg1IDI1NXY2MzloLTI5N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2M1OyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xNjQgNDk2djYwMGgxNjZ2LTU5MnEwIC0xOTIgNzkgLTI4OS41dDIzMiAtOTcuNXExNjcgMCAyNDcuNSAxMTl0ODAuNSAzNzBxMCAxMzAgLTE0IDI0MnQtNDggMjQ4aDE2NnEzNiAtMTQ0IDUwIC0yNTF0MTQgLTI0N3EwIC0zMTggLTEyOSAtNDY4dC0zODEgLTE1MHEtMjMxIDAgLTM0NyAxMjV0LTExNiAzOTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNjNjsiIGhvcml6LWFkdi14PSIxNDcwIiBkPSJNMTE1IDU1NXEwIDI5NiAyMDcgNTQ5bDEzMSAtOTBxLTg5IC0xMTcgLTEyOS41IC0yMjl0LTQwLjUgLTIzNnEwIC0zOTUgMzYwIC00MzB2NjIwcTAgMTg3IDgzIDI4MnQyMzIgOTVxMTgwIDAgMjg5IC0xNDYuNXQxMDkgLTM5Ni41cTAgLTE3OCAtNjggLTMwOC41dC0xOTIgLTIwMi41dC0yODkgLTgwdi00NzRoLTE2NHY0NzRxLTI2MCAxMSAtMzk0IDE1Ni41dC0xMzQgNDE2LjV6TTgwNyAxMTlxMTc5IDE2IDI3OCAxMzR0OTkgMzE4IHEwIDE4NSAtNjIgMjk0LjV0LTE2NCAxMDkuNXEtNzMgMCAtMTEyIC02MHQtMzkgLTE3NHYtNjIyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzYzc7IiBob3Jpei1hZHYteD0iMTExOCIgZD0iTS0yMCAtNDkybDQ2NCA4MzZsLTE3MiA0NDRxLTM4IDk5IC03MyAxMzl0LTc4IDQwcS0zNyAwIC02NCAtMTF2MTI5cTQ5IDE3IDEyMSAxN3E1NCAwIDkzIC0yMS41dDcwIC02N3Q3NSAtMTU3LjVsMTQ1IC0zNjlsMzE4IDYwOWgxODBsLTQyOCAtNzcybDE5MCAtNDg0cTQ4IC0xMjIgODkgLTE1OXQxMDQgLTM3cTQ1IDAgOTAgOHYtMTI5cS02MCAtMTUgLTExOSAtMTVxLTExNSAwIC0xODUuNSA1OXQtMTI5LjUgMjE4bC0xNTAgMzg3IGwtMzYyIC02NjRoLTE3OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2M4OyIgaG9yaXotYWR2LXg9IjE1NDIiIGQ9Ik0xNjQgNTUzdjU0M2gxNjZ2LTU0OXEwIC0xOTUgOTAgLTMwNHQyNzQgLTEyMnYxNDMzaDE2NHYtMTQzMXExODggMTUgMjg5LjUgMTMwLjV0MTAxLjUgMzE5LjVxMCAxMjAgLTEzIDIzNy41dC01MCAyODUuNWgxNjZxNjMgLTI3MiA2MyAtNTE2cTAgLTI3NiAtMTQyLjUgLTQyOXQtNDE0LjUgLTE2OXYtNDc0aC0xNjR2NDc0cS0yNjQgOSAtMzk3IDE1NHQtMTMzIDQxN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2M5OyIgaG9yaXotYWR2LXg9IjE1ODMiIGQ9Ik0xMTUgNTMwcTAgMTU2IDI3LjUgMjg0LjV0OTUuNSAyODEuNWgxNzJxLTY4IC0xNTYgLTk2LjUgLTI4My41dC0yOC41IC0yODQuNXEwIC0xOTMgNjAgLTMwMXQxNjcgLTEwOHE5NCAwIDE0Ni41IDcxLjV0NTIuNSAxOTYuNXYzMTFoMTYxdi0zMTFxMCAtMTI4IDUzIC0xOTh0MTQ2IC03MHExMDcgMCAxNjcgMTA4dDYwIDMwMXEwIDE1MSAtMjcuNSAyODF0LTk2LjUgMjg3aDE3MnE2NSAtMTQ2IDkzLjUgLTI3Ny41dDI4LjUgLTI4OC41IHEwIC0yNTIgLTEwMS41IC00MDF0LTI4My41IC0xNDlxLTIyMCAwIC0yODggMTgyaC05cS02NSAtMTgyIC0yODYgLTE4MnEtMTgyIDAgLTI4My41IDE0OHQtMTAxLjUgNDAyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzY2E7IiBob3Jpei1hZHYteD0iNjk0IiBkPSJNMTY4IDMxN3Y3NzloMTY2di03NzRxMCAtMTA0IDM2LjUgLTE1NC41dDEyMy41IC01MC41cTM3IDAgODcuNSA2LjV0NzcuNSAxMy41di0xMjdxLTMxIC0xMyAtODMuNSAtMjEuNXQtMTAyLjUgLTguNXEtMTYwIDAgLTIzMi41IDg0dC03Mi41IDI1M3pNOSAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41eiBNMzkwIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzY2I7IiBob3Jpei1hZHYteD0iMTI0NyIgZD0iTTE2NCA0OTZ2NjAwaDE2NnYtNTkycTAgLTE5MiA3OSAtMjg5LjV0MjMyIC05Ny41cTE2NyAwIDI0Ny41IDExOXQ4MC41IDM3MHEwIDEzMCAtMTQgMjQydC00OCAyNDhoMTY2cTM2IC0xNDQgNTAgLTI1MXQxNCAtMjQ3cTAgLTMxOCAtMTI5IC00Njh0LTM4MSAtMTUwcS0yMzEgMCAtMzQ3IDEyNXQtMTE2IDM5MXpNMzY2IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNSB0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek03NDcgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNjYzsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek01NDEgMTI0MXYyOSBxMjcgNzIgNTMuNSAxODUuNXQzOC41IDE5NS41aDE4NHYtMjNxLTE4IC03NCAtNzIuNSAtMTkyLjV0LTEwMy41IC0xOTQuNWgtMTAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gzY2Q7IiBob3Jpei1hZHYteD0iMTI0NyIgZD0iTTE2NCA0OTZ2NjAwaDE2NnYtNTkycTAgLTE5MiA3OSAtMjg5LjV0MjMyIC05Ny41cTE2NyAwIDI0Ny41IDExOXQ4MC41IDM3MHEwIDEzMCAtMTQgMjQydC00OCAyNDhoMTY2cTM2IC0xNDQgNTAgLTI1MXQxNCAtMjQ3cTAgLTMxOCAtMTI5IC00Njh0LTM4MSAtMTUwcS0yMzEgMCAtMzQ3IDEyNXQtMTE2IDM5MXpNNTQ3IDEyNDF2MjlxMjcgNzIgNTMuNSAxODUuNXQzOC41IDE5NS41aDE4NHYtMjNxLTE4IC03NCAtNzIuNSAtMTkyLjUgdC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2NlOyIgaG9yaXotYWR2LXg9IjE1ODMiIGQ9Ik0xMTUgNTMwcTAgMTU2IDI3LjUgMjg0LjV0OTUuNSAyODEuNWgxNzJxLTY4IC0xNTYgLTk2LjUgLTI4My41dC0yOC41IC0yODQuNXEwIC0xOTMgNjAgLTMwMXQxNjcgLTEwOHE5NCAwIDE0Ni41IDcxLjV0NTIuNSAxOTYuNXYzMTFoMTYxdi0zMTFxMCAtMTI4IDUzIC0xOTh0MTQ2IC03MHExMDcgMCAxNjcgMTA4dDYwIDMwMXEwIDE1MSAtMjcuNSAyODF0LTk2LjUgMjg3aDE3MnE2NSAtMTQ2IDkzLjUgLTI3Ny41dDI4LjUgLTI4OC41IHEwIC0yNTIgLTEwMS41IC00MDF0LTI4My41IC0xNDlxLTIyMCAwIC0yODggMTgyaC05cS02NSAtMTgyIC0yODYgLTE4MnEtMTgyIDAgLTI4My41IDE0OHQtMTAxLjUgNDAyek03MDkgMTI0MXYyOXEyNyA3MiA1My41IDE4NS41dDM4LjUgMTk1LjVoMTg0di0yM3EtMTggLTc0IC03Mi41IC0xOTIuNXQtMTAzLjUgLTE5NC41aC0xMDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNkMTsiIGhvcml6LWFkdi14PSIxMjc0IiBkPSJNMTAgODI1cTgzIDM5IDE3OCAzOXE4OCAwIDEzNC41IC00Ni41dDQ2LjUgLTEzOS41cTAgLTM1IC0xNSAtMTY2cS0xNiAtMTMyIC0xNiAtMTkwcTAgLTIwNyAyMzMgLTIwN3EzNzUgMCAzNzUgNjI0cTAgNjMgLTQgMTA3cS0yMjMgMiAtMzc4LjUgNTQuNXQtMjM1LjUgMTQ2LjV0LTgwIDIyNXEwIDE0NCA5MSAyMjUuNXQyNTkgODEuNXEyMDggMCAzMzYgLTE1My41dDE3MCAtNDUwLjVoMTQzdi0xMjloLTEzN3E0IC00NiA0IC0xMTEgcTAgLTM1MyAtMTQ0IC01NTR0LTQwMyAtMjAxcS0zOTMgMCAtMzkzIDM0NHEwIDU3IDE2IDE4MHExNSAxMjIgMTUgMTQ1cTAgNDcgLTE4IDY0LjV0LTUwIDE3LjVxLTI1IDAgLTUyIC03LjV0LTQyIC0xNi41ek00MTAgMTI3MnEwIC0xNDEgMTM3LjUgLTIxOHQzODYuNSAtNzlxLTI4IDIxMSAtMTE5LjUgMzM5dC0yMTQuNSAxMjhxLTkzIDAgLTE0MS41IC00Ny41dC00OC41IC0xMjIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4M2QyOyIgaG9yaXotYWR2LXg9IjExNTciIGQ9Ik0wIDE0NjJoMTg2bDM4MyAtNzQ1cTEyMiAyOTEgMTkyLjUgNDQ2LjV0MTA5IDIwOS41dDg0LjUgNzh0MTA0IDI0cTQ4IDAgODggLTE1di0xMzVxLTI2IDYgLTU3IDZxLTQwIDAgLTY5LjUgLTI4dC03Mi41IC0xMDguNXQtMTA1IC0yMDYuNXQtMTEyLjUgLTI0NHQtODEuNSAtMjAzdi01NDFoLTE3MnY1NTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDNkNjsiIGhvcml6LWFkdi14PSIxNzIwIiBkPSJNMTggOTU0djc0bDE0MiA2OGgxNDk1di0xNDJoLTI1MHExMTcgLTI1MiAxMTcgLTUwM3EwIC0yNDAgLTEwMCAtMzU1LjV0LTI4NSAtMTE1LjVxLTIyMSAwIC0yODkgMTgyaC04cS02OCAtMTgyIC0yODcgLTE4MnEtMTg2IDAgLTI4NS41IDExNS41dC05OS41IDM1NS41dDEzNSA1MDNoLTI4NXpNMzM4IDQ2MXEwIC0xNzQgNTQgLTI1OHQxNzEgLTg0cTkzIDAgMTQ3IDcxLjV0NTQgMTk2LjV2MTg4aDE2MnYtMTg4cTAgLTEyMiA1My41IC0xOTUgdDE0Ni41IC03M3ExMTcgMCAxNzEuNSA4NC41dDU0LjUgMjU3LjVxMCAyNTQgLTExMSA0OTNoLTc3NHEtNjMgLTEzMiAtOTYgLTI2MXQtMzMgLTIzMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDAwOyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0zNTMgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDAxOyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0zNDggMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzI5IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjUgdC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDAyOyIgaG9yaXotYWR2LXg9IjE1MDMiIGQ9Ik0xOCAxMzExdjE1MWg5NTF2LTE1MWgtNDQ1di00MThoMzk2cTIwNSAwIDMxNS41IC05NS41dDExMC41IC0yNzMuNXYtMTQzcTAgLTE5MCAtOTggLTI5NS41dC0yNzMgLTEwNS41cS05NiAwIC0xNTAgMjJ2MTUwcTU1IC0xOSAxNDYgLTE5cTEwMSAwIDE1MyA2MnQ1MiAxNzR2MTMxcTAgMTI4IC02NS41IDE4NC41dC0yMDUuNSA1Ni41aC0zODF2LTc0MWgtMTcwdjEzMTFoLTMzNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDAzOyIgaG9yaXotYWR2LXg9IjEwNjUiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUzaC02NDV2LTEzMDloLTE3MHpNNDgzIDE1Nzl2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQwNDsiIGhvcml6LWFkdi14PSIxMzA5IiBkPSJNMTI1IDczM3EwIDM1MSAxODguNSA1NTEuNXQ1MjIuNSAyMDAuNXEyMzcgMCA0MTUgLTg4bC03MSAtMTQ4cS0xNjkgODIgLTM0NiA4MnEtMjI2IDAgLTM2MC41IC0xMjV0LTE2NC41IC0zNjZoNzIzdi0xNTBoLTcyN3ExMCAtMjc0IDE0My41IC00MTYuNXQzODIuNSAtMTQyLjVxMTYyIDAgMzYzIDU1di0xNDlxLTE2MSAtNTcgLTM4NyAtNTdxLTMzMiAwIC01MDcgMTk0dC0xNzUgNTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MDU7IiBob3Jpei1hZHYteD0iMTEyNCIgZD0iTTEwNiA0N3YxNjRxOTAgLTM4IDE5NiAtNjB0MjEwIC0yMnExNzAgMCAyNTYgNjQuNXQ4NiAxNzkuNXEwIDc2IC0zMC41IDEyNC41dC0xMDIgODkuNXQtMjE3LjUgOTNxLTIwNCA3MyAtMjkxLjUgMTczdC04Ny41IDI2MXEwIDE2OSAxMjcgMjY5dDMzNiAxMDBxMjE4IDAgNDAxIC04MGwtNTMgLTE0OHEtMTgxIDc2IC0zNTIgNzZxLTEzNSAwIC0yMTEgLTU4dC03NiAtMTYxcTAgLTc2IDI4IC0xMjQuNXQ5NC41IC04OXQyMDMuNSAtODkuNSBxMjMwIC04MiAzMTYuNSAtMTc2dDg2LjUgLTI0NHEwIC0xOTMgLTE0MCAtMzAxdC0zODAgLTEwOHEtMjYwIDAgLTQwMCA2N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDA2OyIgaG9yaXotYWR2LXg9IjU3MSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xNDYyaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQwNzsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek01IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTM4NiAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDA4OyIgaG9yaXotYWR2LXg9IjU0NyIgZD0iTS0xNjAgLTIxM3E3MSAtMjAgMTQ4IC0yMHE5OSAwIDE1MC41IDYwdDUxLjUgMTczdjE0NjJoMTcwdi0xNDQ4cTAgLTE5MCAtOTYgLTI5NC41dC0yNzYgLTEwNC41cS05NCAwIC0xNDggMjd2MTQ1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MDk7IiBob3Jpei1hZHYteD0iMTkwMyIgZD0iTTAgMnYxNDNxNTAgLTI2IDExMyAtMjZxNDggMCA4MC41IDMxdDU0IDgyLjV0NDkgMTc2LjV0NjEuNSAzNDh0OTkgNzA1aDY3OHYtNjI0aDEyMnE1NzAgMCA1NzAgLTQxMnEwIC0yMDYgLTEzNy41IC0zMTZ0LTM5Ny41IC0xMTBoLTMyN3YxMzExaC0zNjVxLTU3IC00NDAgLTk5IC03MDF0LTgyIC0zODYuNXQtMTA5LjUgLTE4NnQtMTc2LjUgLTYwLjVxLTY5IDAgLTEzMyAyNXpNMTEzNSAxNDdoMTMzcTE5OCAwIDI4OS41IDY5LjUgdDkxLjUgMjA5LjVxMCAxMzggLTk2IDIwMHQtMzE2IDYyaC0xMDJ2LTU0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDBhOyIgaG9yaXotYWR2LXg9IjE5NTIiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNjIyaDY0M3Y2MjJoMTcydi02MjRoMTIxcTU2OSAwIDU2OSAtNDEycTAgLTIwNiAtMTM2IC0zMTZ0LTM5NyAtMTEwaC0zMjl2Njg4aC02NDN2LTY4OGgtMTcwek0xMTg2IDE0N2gxMzNxMTk2IDAgMjg4LjUgNjkuNXQ5Mi41IDIwOS41cTAgMTM3IC05Ni41IDE5OS41dC0zMTUuNSA2Mi41aC0xMDJ2LTU0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDBiOyIgaG9yaXotYWR2LXg9IjE1MDMiIGQ9Ik0xOCAxMzExdjE1MWgxMDE0di0xNTFoLTUwOHYtNDE4aDQwMHEyMDUgMCAzMTMuNSAtOTR0MTA4LjUgLTI3NXYtNTI0aC0xNzB2NTAycTAgMTI2IC02Mi41IDE4Mi41dC0yMDIuNSA1Ni41aC0zODd2LTc0MWgtMTcwdjEzMTFoLTMzNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDBjOyIgaG9yaXotYWR2LXg9IjEyNTMiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNzA4bDY1OSA3MDhoMTk1bC02NDcgLTcxMGw2NzUgLTc1MmgtMjA2bC02NzYgNzQxdi03NDFoLTE3MHpNNTU1IDE1Nzl2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQwZDsiIGhvcml6LWFkdi14PSIxNTYxIiBkPSJNMjAzIDB2MTQ2MmgxNTl2LTgxM3EwIC0yMjUgLTE0IC00MDdoOGw4MjAgMTIyMGgxODZ2LTE0NjJoLTE2MHY4MDVxMCAyMDEgMTcgNDIyaC05bC04MjEgLTEyMjdoLTE4NnpNNDk3IDE4ODZ2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQwZTsiIGhvcml6LWFkdi14PSIxMjcyIiBkPSJNMjcgMTQ2MmgxODhsNDMyIC04MzFxMjUgLTQ5IDM5IC05Nmg4cTI4IDg0IDM5IDEwNmwzNTkgODIxaDE4MGwtNDY3IC0xMDQ2cS04NCAtMTg3IC0xNTEuNSAtMjcydC0xNTIgLTEyNC41dC0yMDguNSAtMzkuNXEtMTExIDAgLTE5NSAzMHYxNjZxOTMgLTQzIDE4OSAtNDNxMTEwIDAgMTc2LjUgNTAuNXQxMzIuNSAxODkuNXpNMjg3IDE4ODZoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1NyBxLTEyIC0xNTggLTEwMSAtMjMyLjV0LTI3MyAtNzQuNXEtMTg1IDAgLTI3MCA3MS41dC05NSAyMzUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDBmOyIgaG9yaXotYWR2LXg9IjE0OTMiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTMwOGg3NTF2MTMwOGgxNzB2LTE0NjJoLTQ2NXYtMzgxaC0xNzZ2MzgxaC00NTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxMDsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MTE7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTIwMSAwdjE0NjJoODYydi0xNTFoLTY5MnYtNDczaDIyN3ExOTMgMCAzMTQgLTQ0LjV0MTc5IC0xMzEuNXQ1OCAtMjM2cTAgLTIxOCAtMTI5LjUgLTMyMnQtMzkwLjUgLTEwNGgtNDI4ek0zNzEgMTQ3aDIzOXExOTAgMCAyNzYuNSA2NXQ4Ni41IDIxNHEwIDE0MiAtODggMjAydC0zMDcgNjBoLTIwN3YtNTQxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MTI7IiBob3Jpei1hZHYteD0iMTMyNyIgZD0iTTIwMSAwdjE0NjJoNDEzcTI5MSAwIDQyMSAtODd0MTMwIC0yNzVxMCAtMTMwIC03Mi41IC0yMTQuNXQtMjExLjUgLTEwOS41di0xMHEzMzMgLTU3IDMzMyAtMzUwcTAgLTE5NiAtMTMyLjUgLTMwNnQtMzcwLjUgLTExMGgtNTEwek0zNzEgMTQ1aDMwNXExNzcgMCAyNjYuNSA2OC41dDg5LjUgMjE0LjVxMCAxMzYgLTkxLjUgMjAwdC0yNzguNSA2NGgtMjkxdi01NDd6TTM3MSA4MzZoMjgwcTE4MCAwIDI1OSA1Ni41dDc5IDE5MC41IHEwIDEyMyAtODggMTc3LjV0LTI4MCA1NC41aC0yNTB2LTQ3OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDEzOyIgaG9yaXotYWR2LXg9IjEwNjUiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUzaC02NDV2LTEzMDloLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDE0OyIgaG9yaXotYWR2LXg9IjEzOTkiIGQ9Ik0xNCAxNTRoMTEzcTE1NCAyNTkgMjYzLjUgNjMwdDEyMS41IDY3OGg2NTd2LTEzMDhoMTg1di01MzVoLTE2MnYzODFoLTEwMTZ2LTM4MWgtMTYydjUzNXpNMzA1IDE1NGg2OTR2MTE1NWgtMzMzcS0xOCAtMjQyIC0xMjEgLTU4MS41dC0yNDAgLTU3My41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MTU7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxNjsiIGhvcml6LWFkdi14PSIxNzI5IiBkPSJNMiAwbDU5NiA3NTJsLTU3NSA3MTBoMTkwbDU2OSAtNzA4djcwOGgxNjR2LTcwOGw1NzAgNzA4aDE5MGwtNTc2IC03MDhsNTk0IC03NTRoLTE5NmwtNTgyIDc0MXYtNzQxaC0xNjR2NzQxbC01ODEgLTc0MWgtMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MTc7IiBob3Jpei1hZHYteD0iMTE5MCIgZD0iTTc0IDU5djE1OHE5NiAtNDYgMjA3LjUgLTcxdDIxNC41IC0yNXExOTggMCAyOTkuNSA3NXQxMDEuNSAyMTZxMCAxMzQgLTExMi41IDIwM3QtMzM1LjUgNjloLTIxOHYxNDNoMjA5cTIwNSAwIDMxNy41IDczLjV0MTEyLjUgMjA1LjVxMCAxMDcgLTgxIDE3MXQtMjE4IDY0cS0xMTAgMCAtMTk5IC0yNXQtMjA2IC05OWwtODQgMTE0cTEwMSA3NSAyMjYuNSAxMTMuNXQyNjAuNSAzOC41cTIyNSAwIDM1Mi41IC05OC41dDEyNy41IC0yNjQuNSBxMCAtMTQ0IC05MS41IC0yMzR0LTI1Mi41IC0xMTR2LThxMTgzIC0yNSAyNzcuNSAtMTE1dDk0LjUgLTIzNXEwIC0yMDUgLTE1MyAtMzE5LjV0LTQzMiAtMTE0LjVxLTI1NSAwIC00MTggNzl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxODsiIGhvcml6LWFkdi14PSIxNTYxIiBkPSJNMjAzIDB2MTQ2MmgxNTl2LTgxM3EwIC0yMjUgLTE0IC00MDdoOGw4MjAgMTIyMGgxODZ2LTE0NjJoLTE2MHY4MDVxMCAyMDEgMTcgNDIyaC05bC04MjEgLTEyMjdoLTE4NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDE5OyIgaG9yaXotYWR2LXg9IjE1NjEiIGQ9Ik0yMDMgMHYxNDYyaDE1OXYtODEzcTAgLTIyNSAtMTQgLTQwN2g4bDgyMCAxMjIwaDE4NnYtMTQ2MmgtMTYwdjgwNXEwIDIwMSAxNyA0MjJoLTlsLTgyMSAtMTIyN2gtMTg2ek00NDQgMTg4NmgxNTZxOSAtMTA0IDU0LjUgLTE0NXQxNTguNSAtNDFxMTAzIDAgMTUyLjUgNDR0NjAuNSAxNDJoMTU3cS0xMiAtMTU4IC0xMDEgLTIzMi41dC0yNzMgLTc0LjVxLTE4NSAwIC0yNzAgNzEuNXQtOTUgMjM1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxYTsiIGhvcml6LWFkdi14PSIxMjUzIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTcwOGw2NTkgNzA4aDE5NWwtNjQ3IC03MTBsNjc1IC03NTJoLTIwNmwtNjc2IDc0MXYtNzQxaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxYjsiIGhvcml6LWFkdi14PSIxNDQyIiBkPSJNMCAydjE0M3E1NCAtMjYgMTEzIC0yNnE1MyAwIDkyLjUgNDMuNXQ3MCAxNTF0NzcgNDA4dDEwMi41IDc0MC41aDc4NnYtMTQ2MmgtMTcwdjEzMTFoLTQ3NWwtMzEgLTI0MHEtNjEgLTQ3OSAtMTA3LjUgLTcwMC41dC0xMjIuNSAtMzA4LjV0LTIwMiAtODVxLTc0IDAgLTEzMyAyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDFjOyIgaG9yaXotYWR2LXg9IjE4NDkiIGQ9Ik0yMDEgMHYxNDYyaDI1Nmw0NjMgLTEyMDZoOGw0NjcgMTIwNmgyNTR2LTE0NjJoLTE3MHY5NDJxMCAxNjIgMTQgMzUyaC04bC01MDAgLTEyOTRoLTEzN2wtNDk2IDEyOTZoLThxMTQgLTE1NCAxNCAtMzY2di05MzBoLTE1N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDFkOyIgaG9yaXotYWR2LXg9IjE1MTEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNjIyaDc3MHY2MjJoMTcwdi0xNDYyaC0xNzB2Njg4aC03NzB2LTY4OGgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MWU7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQxZjsiIGhvcml6LWFkdi14PSIxNDkzIiBkPSJNMjAxIDB2MTQ2MmgxMDkxdi0xNDYyaC0xNzB2MTMxMWgtNzUxdi0xMzExaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyMDsiIGhvcml6LWFkdi14PSIxMjMzIiBkPSJNMjAxIDB2MTQ2MmgzNzlxNTQ4IDAgNTQ4IC00MjZxMCAtMjIyIC0xNTEuNSAtMzQxLjV0LTQzMy41IC0xMTkuNWgtMTcydi01NzVoLTE3MHpNMzcxIDcyMWgxNTNxMjI2IDAgMzI3IDczdDEwMSAyMzRxMCAxNDUgLTk1IDIxNnQtMjk2IDcxaC0xOTB2LTU5NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDIxOyIgaG9yaXotYWR2LXg9IjEyOTIiIGQ9Ik0xMjUgNzMzcTAgMjI2IDg0LjUgMzk2dDI0NCAyNjJ0Mzc1LjUgOTJxMjMwIDAgNDAyIC04NGwtNzIgLTE0NnEtMTY2IDc4IC0zMzIgNzhxLTI0MSAwIC0zODAuNSAtMTYwLjV0LTEzOS41IC00MzkuNXEwIC0yODcgMTM0LjUgLTQ0My41dDM4My41IC0xNTYuNXExNTMgMCAzNDkgNTV2LTE0OXEtMTUyIC01NyAtMzc1IC01N3EtMzIzIDAgLTQ5OC41IDE5NnQtMTc1LjUgNTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MjI7IiBob3Jpei1hZHYteD0iMTEzMyIgZD0iTTE4IDEzMTF2MTUxaDEwOTZ2LTE1MWgtNDYzdi0xMzExaC0xNzB2MTMxMWgtNDYzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MjM7IiBob3Jpei1hZHYteD0iMTI3MiIgZD0iTTI3IDE0NjJoMTg4bDQzMiAtODMxcTI1IC00OSAzOSAtOTZoOHEyOCA4NCAzOSAxMDZsMzU5IDgyMWgxODBsLTQ2NyAtMTA0NnEtODQgLTE4NyAtMTUxLjUgLTI3MnQtMTUyIC0xMjQuNXQtMjA4LjUgLTM5LjVxLTExMSAwIC0xOTUgMzB2MTY2cTkzIC00MyAxODkgLTQzcTExMCAwIDE3Ni41IDUwLjV0MTMyLjUgMTg5LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyNDsiIGhvcml6LWFkdi14PSIxNjM0IiBkPSJNMTA2IDc1OHEwIDE1OCA2Ny41IDI4MnQxOTMuNSAxOTMuNXQyOTcgNjkuNWg2N3YxODBoMTcydi0xODBoNzBxMTcxIDAgMjk2LjUgLTY4dDE5MiAtMTkydDY2LjUgLTI4M3EwIC0xNjYgLTc0LjUgLTI5NS41dC0yMDQgLTE5NC41dC0zMDUuNSAtNjVoLTQxdi0yMjVoLTE3MnYyMjVoLTQ1cS0xNzYgMCAtMzA1IDY2dC0yMDIgMTk2dC03MyAyOTF6TTI4MyA3NjJxMCAtMTk3IDExMSAtMzA1LjV0MzEzIC0xMDguNWgyNHY4MDloLTU3IHEtMTgyIDAgLTI4Ni41IC0xMDZ0LTEwNC41IC0yODl6TTkwMyAzNDhoMjVxMjAxIDAgMzEyLjUgMTA5LjV0MTExLjUgMzA0LjVxMCAxODUgLTEwMyAyOTB0LTI4OCAxMDVoLTU4di04MDl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyNTsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNOCAwbDQ4NiA3NjRsLTQ1MyA2OThoMTg4bDM2MyAtNTc5bDM2NiA1NzloMTgxbC00NTMgLTY5Mmw0ODggLTc3MGgtMTkzbC0zOTMgNjQzbC00MDAgLTY0M2gtMTgweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MjY7IiBob3Jpei1hZHYteD0iMTUwOSIgZD0iTTIwMSAwdjE0NjJoMTcwdi0xMzA4aDc1MXYxMzA4aDE3MHYtMTMwOGgxNzJ2LTUzNWgtMTYxdjM4MWgtMTEwMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDI3OyIgaG9yaXotYWR2LXg9IjE0MjMiIGQ9Ik0xNzAgODgxdjU4MWgxNzB2LTU2MXEwIC0xMjEgNjMuNSAtMTc5dDIwNi41IC01OHE5NyAwIDE4NS41IDE0LjV0MjU3LjUgNjkuNXY3MTRoMTcwdi0xNDYyaC0xNzB2NjA0cS0xNDkgLTUzIC0yNDggLTcyLjV0LTIwNSAtMTkuNXEtMjA3IDAgLTMxOC41IDk1dC0xMTEuNSAyNzR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyODsiIGhvcml6LWFkdi14PSIyMTE0IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTEzMDhoNjAwdjEzMDhoMTcwdi0xMzA4aDYwMHYxMzA4aDE3MnYtMTQ2MmgtMTcxMnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDI5OyIgaG9yaXotYWR2LXg9IjIxMTYiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTMwOGg1ODN2MTMwOGgxNzJ2LTEzMDhoNTg0djEzMDhoMTcwdi0xMzA4aDE3MnYtNTM1aC0xNjJ2MzgxaC0xNjg5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MmE7IiBob3Jpei1hZHYteD0iMTQwOSIgZD0iTTE4IDEzMTF2MTUxaDUwNnYtNjI0aDI0NHEyNjEgMCAzOTggLTEwMi41dDEzNyAtMzA5LjVxMCAtMjA2IC0xMjkuNSAtMzE2dC0zNzguNSAtMTEwaC00NDF2MTMxMWgtMzM2ek01MjQgMTQ3aDI1MnExODEgMCAyNjUuNSA2OS41dDg0LjUgMjA5LjVxMCAxMzYgLTg3LjUgMTk5dC0yOTAuNSA2M2gtMjI0di01NDF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyYjsiIGhvcml6LWFkdi14PSIxNzQ3IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyNGgyMzlxMjYxIDAgMzk4IC0xMDIuNXQxMzcgLTMwOS41cTAgLTIwNiAtMTI5LjUgLTMxNnQtMzc4LjUgLTExMGgtNDM2ek0zNzEgMTQ1aDI0N3ExODEgMCAyNjYgNzAuNXQ4NSAyMTAuNXEwIDEzNyAtODkuNSAxOTguNXQtMjg5LjUgNjEuNWgtMjE5di01NDF6TTEzNzYgMHYxNDYyaDE3MHYtMTQ2MmgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MmM7IiBob3Jpei1hZHYteD0iMTMxNyIgZD0iTTIwMSAwdjE0NjJoMTcwdi02MjRoMjkxcTI2NyAwIDQwNy41IC0xMDUuNXQxNDAuNSAtMzA2LjVxMCAtMjAzIC0xMzUuNSAtMzE0LjV0LTM4Ni41IC0xMTEuNWgtNDg3ek0zNzEgMTQ3aDI5OXEzNjQgMCAzNjQgMjc5cTAgMTM1IC05My41IDE5OC41dC0yOTkuNSA2My41aC0yNzB2LTU0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDJkOyIgaG9yaXotYWR2LXg9IjEyOTAiIGQ9Ik02MSAxMzk5cTE3MiA4NCA0MDggODRxMjE3IDAgMzczLjUgLTg4dDIzNy41IC0yNTF0ODEgLTM4NHEwIC0zNzYgLTE4MiAtNTc4dC01MjQgLTIwMnEtMjI3IDAgLTM4MyA1N3YxNDlxODMgLTIxIDE2OSAtMzh0MTg1IC0xN3EyNzEgMCA0MDkgMTQ0LjV0MTQ2IDQxNi41aC03MTl2MTUyaDcxN3EtMjIgMjI5IC0xNTcuNSAzNTh0LTM1NC41IDEyOXEtMTcyIDAgLTMzNCAtNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyZTsiIGhvcml6LWFkdi14PSIyMTUwIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmgzNTZxMjMgMzExIDE5MS41IDQ3OHQ0NTUuNSAxNjdxMzA3IDAgNDc4IC0yMDAuNXQxNzEgLTU1MS41cTAgLTM1NCAtMTcwLjUgLTU1My41dC00NzQuNSAtMTk5LjVxLTMwMSAwIC00NzEuNSAxODMuNXQtMTgxLjUgNTI0LjVoLTM1NHYtNjg4aC0xNzB6TTkwMyA3MzNxMCAtMjk2IDExOSAtNDUwdDM1MCAtMTU0cTIzNCAwIDM1Mi41IDE1M3QxMTguNSA0NTF0LTExNy41IDQ0OXQtMzQ5LjUgMTUxIHEtMjMzIDAgLTM1MyAtMTUyLjV0LTEyMCAtNDQ3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQyZjsiIGhvcml6LWFkdi14PSIxMzAzIiBkPSJNNTEgMGw0MTAgNjM5cS0xNjEgNTEgLTIzNCAxNTQuNXQtNzMgMjYxLjVxMCAxOTYgMTM1LjUgMzAxLjV0NDEwLjUgMTA1LjVoNDAydi0xNDYyaC0xNzB2NjEwaC0yOTdsLTM4MyAtNjEwaC0yMDF6TTMzMiAxMDQ3cTAgLTI5MSAzNzkgLTI5MWgyMjF2NTU5aC0yMjdxLTE4MyAwIC0yNzggLTYzdC05NSAtMjA1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MzA7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDMxOyIgaG9yaXotYWR2LXg9IjEyMjEiIGQ9Ik0xMTkgNjU3cTAgMzYwIDEwNiA1NjEuNXQzMzYgMjUxLjVxMjg2IDYxIDUwNCA5OWwzMSAtMTQ2cS0zNDcgLTU4IC00OTYgLTkycS0xNDUgLTMzIC0yMTcuNSAtMTU2dC03OS41IC0zMzVoMTJxNjIgODQgMTYwIDEzMnQyMDUgNDhxMjAyIDAgMzE1IC0xMzF0MTEzIC0zNjNxMCAtMjU3IC0xMzEgLTQwMS41dC0zNjUgLTE0NC41cS0yMzEgMCAtMzYyIDE3N3QtMTMxIDUwMHpNMjg5IDY1N3EwIC0yNjMgODMgLTQwMC41dDI1NSAtMTM3LjUgcTMwNSAwIDMwNSAzODlxMCAzNzEgLTI3NyAzNzFxLTc2IDAgLTE0Ni41IC0zMS41dC0xMjkgLTgzLjV0LTkwLjUgLTEwN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDMyOyIgaG9yaXotYWR2LXg9IjExNjUiIGQ9Ik0xNzYgMHYxMDk2aDQ4MXE0MDggMCA0MDggLTI3NXEwIC0xMDcgLTYxLjUgLTE2Mi41dC0xNzIuNSAtNzQuNXYtOXExNDAgLTE5IDIwNC41IC04MnQ2NC41IC0xNzRxMCAtMTUzIC0xMTIuNSAtMjM2dC0zMjguNSAtODNoLTQ4M3pNMzQyIDEzOWgzMDVxMjg3IDAgMjg3IDE5MXEwIDg5IC02Ny41IDEyOS41dC0yMjMuNSA0MC41aC0zMDF2LTM2MXpNMzQyIDY0M2gyODFxMTU0IDAgMjE3IDM4dDYzIDEyNHEwIDgwIC02MS41IDExMy41IHQtMTg2LjUgMzMuNWgtMzEzdi0zMDl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQzMzsiIGhvcml6LWFkdi14PSI4NzciIGQ9Ik0xNzYgMHYxMDk2aDY2MHYtMTQyaC00OTR2LTk1NGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MzQ7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTQxIDE0M2g4NnExMzQgMTgyIDIxMCA0Mjd0NzkgNTI2aDU1NXYtOTUzaDE1N3YtNTIyaC0xNjF2Mzc5aC03NjZ2LTM3OWgtMTYwdjUyMnpNMjk5IDE0M2g1MTJ2ODIyaC0yNDZxLTEzIC0yMjIgLTg1LjUgLTQ0OS41dC0xODAuNSAtMzcyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQzNTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0MzY7IiBob3Jpei1hZHYteD0iMTUwNyIgZD0iTTQgMGw0OTYgNTYzbC00NTcgNTMxaDE4Mmw0NTEgLTUzMXY1MzFoMTUzdi01MzFsNDUzIDUzMWgxODJsLTQ1OCAtNTMxbDQ5NyAtNTYzaC0xOTJsLTQ4MiA1NTV2LTU1NWgtMTUzdjU1NWwtNDgxIC01NTVoLTE5MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDM3OyIgaG9yaXotYWR2LXg9Ijk4OSIgZD0iTTY4IDUxdjE1MnExODMgLTg2IDM3MCAtODZxMTQ0IDAgMjE3LjUgNDkuNXQ3My41IDE0Mi41cTAgMTkxIC0zMTEgMTkxaC0xNTJ2MTQxaDExOXEzMTEgMCAzMTEgMTcycTAgMTYyIC0yNTIgMTYycS03NyAwIC0xNDAgLTE0dC0xNjUgLTU2bC01OSAxMzVxMTcwIDc2IDM3MSA3NnExODkgMCAyOTggLTc3LjV0MTA5IC0yMTEuNXEwIC0xODQgLTIwNSAtMjQxdi04cTEyNiAtMzcgMTg0IC0xMDUuNXQ1OCAtMTcxLjUgcTAgLTE1MiAtMTIyLjUgLTIzNi41dC0zMzguNSAtODQuNXEtMjM3IDAgLTM2NiA3MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDM4OyIgaG9yaXotYWR2LXg9IjEyOTgiIGQ9Ik0xNzYgMHYxMDk2aDE1NnYtNjk1bC03IC0xODJsLTMgLTU3bDU5MyA5MzRoMjA3di0xMDk2aC0xNTV2NjcwbDMgMTMybDUgMTMwbC01OTIgLTkzMmgtMjA3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Mzk7IiBob3Jpei1hZHYteD0iMTI5OCIgZD0iTTE3NiAwdjEwOTZoMTU2di02OTVsLTcgLTE4MmwtMyAtNTdsNTkzIDkzNGgyMDd2LTEwOTZoLTE1NXY2NzBsMyAxMzJsNSAxMzBsLTU5MiAtOTMyaC0yMDd6TTI4MCAxNTQ4aDE1NnE5IC0xMDQgNTQuNSAtMTQ1dDE1OC41IC00MXExMDMgMCAxNTIuNSA0NHQ2MC41IDE0MmgxNTdxLTEyIC0xNTggLTEwMSAtMjMyLjV0LTI3MyAtNzQuNXEtMTg1IDAgLTI3MCA3MS41dC05NSAyMzUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDNhOyIgaG9yaXotYWR2LXg9IjEwNjMiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNTMzbDQ3MyA1MzNoMTgybC00NzMgLTUyOWw1MTIgLTU2N2gtMTk0bC01MDAgNTU1di01NTVoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDNiOyIgaG9yaXotYWR2LXg9IjExNjkiIGQ9Ik0xNiAtMnYxMjNxMjIgLTYgNTAgLTZxMTE1IDAgMTgzIDI0M3QxMDMgNzM4aDY0MXYtMTA5NmgtMTY4djk1NGgtMzI5cS0yNyAtMzU2IC03NSAtNTY1dC0xMjQuNSAtMzA2dC0xOTQuNSAtOTdxLTU0IDAgLTg2IDEyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0M2M7IiBob3Jpei1hZHYteD0iMTUwNSIgZD0iTTE3NiAwdjEwOTRoMjAzbDI4NyAtNjk1cTQzIC0xMTAgNzkgLTIzOWwzMSA5M2w0MyAxMThsMjk3IDcyM2gyMTF2LTEwOTRoLTE0N3Y5MDVsLTIwIC01OGwtNTggLTE1M2wtMjgzIC02OTRoLTEzOWwtMjgzIDY5NnEtNTMgMTM0IC03MyAyMDl2LTkwNWgtMTQ4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0M2Q7IiBob3Jpei1hZHYteD0iMTI5OCIgZD0iTTE3NiAwdjEwOTZoMTY2di00NTloNjE0djQ1OWgxNjZ2LTEwOTZoLTE2NnY0OTRoLTYxNHYtNDk0aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQzZTsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0M2Y7IiBob3Jpei1hZHYteD0iMTI3MiIgZD0iTTE3NiAwdjEwOTZoOTIwdi0xMDk2aC0xNjh2OTUyaC01ODZ2LTk1MmgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NDA7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTE3NiAtNDkydjE1ODhoMTM1bDIzIC0xNTBoOHE2NCA5MCAxNDkgMTMwdDE5NSA0MHEyMTggMCAzMzYuNSAtMTQ5dDExOC41IC00MThxMCAtMjcwIC0xMjAuNSAtNDE5LjV0LTMzNC41IC0xNDkuNXEtMTA3IDAgLTE5NS41IDM5LjV0LTE0OC41IDEyMS41aC0xMnExMiAtOTYgMTIgLTE4MnYtNDUxaC0xNjZ6TTM0MiA1NDlxMCAtMjMxIDc3IC0zMzAuNXQyNDcgLTk5LjVxMTQyIDAgMjIyLjUgMTE1dDgwLjUgMzE3IHEwIDIwNSAtODAuNSAzMTQuNXQtMjI2LjUgMTA5LjVxLTE2OCAwIC0yNDMgLTkzdC03NyAtMjk2di0zN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDQxOyIgaG9yaXotYWR2LXg9Ijk3NSIgZD0iTTExNSA1NDFxMCAyNzUgMTMyLjUgNDI1dDM3Ny41IDE1MHE3OSAwIDE1OCAtMTd0MTI0IC00MGwtNTEgLTE0MXEtNTUgMjIgLTEyMCAzNi41dC0xMTUgMTQuNXEtMzM0IDAgLTMzNCAtNDI2cTAgLTIwMiA4MS41IC0zMTB0MjQxLjUgLTEwOHExMzcgMCAyODEgNTl2LTE0N3EtMTEwIC01NyAtMjc3IC01N3EtMjM4IDAgLTM2OC41IDE0Ni41dC0xMzAuNSA0MTQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDQyOyIgaG9yaXotYWR2LXg9Ijk1NiIgZD0iTTQxIDk1NHYxNDJoODc0di0xNDJoLTM1NnYtOTU0aC0xNjZ2OTU0aC0zNTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ0MzsiIGhvcml6LWFkdi14PSIxMDMyIiBkPSJNMiAxMDk2aDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NDQ7IiBob3Jpei1hZHYteD0iMTQ2NCIgZD0iTTExMyA1NDlxMCAyNDkgMTQzLjUgMzk2dDM5OC41IDE2N3Y0NDRoMTU4di00NDRxMjUxIC0yMyAzOTQgLTE3M3QxNDMgLTM5MHEwIC0yNDkgLTE0MS41IC0zOTYuNXQtMzk1LjUgLTE2OC41di00NzZoLTE2NHY0NzZxLTI0OCAxOSAtMzkyIDE3MHQtMTQ0IDM5NXpNMjg3IDU0OXEwIC0xOTIgODggLTMwMXQyODAgLTEyN3Y4NTJxLTE4NSAtMTcgLTI3Ni41IC0xMjAuNXQtOTEuNSAtMzAzLjV6TTgxMyAxMjFxMTkwIDE5IDI3Ny41IDEyOCB0ODcuNSAzMDBxMCAzODMgLTM2NSA0MjJ2LTg1MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDQ1OyIgaG9yaXotYWR2LXg9IjEwNzMiIGQ9Ik0zOSAwbDQwMSA1NjFsLTM4MSA1MzVoMTg5bDI4OSAtNDIwbDI4OCA0MjBoMTg3bC0zODEgLTUzNWw0MDEgLTU2MWgtMTg4bC0zMDcgNDQ0bC0zMTAgLTQ0NGgtMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NDY7IiBob3Jpei1hZHYteD0iMTI4MiIgZD0iTTE3NiAwdjEwOTZoMTY2di05NTNoNTgydjk1M2gxNjZ2LTk1M2gxNTV2LTUyMmgtMTY2djM3OWgtOTAzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NDc7IiBob3Jpei1hZHYteD0iMTI0NSIgZD0iTTE1NiA2ODR2NDEyaDE2NnYtNDAwcTAgLTE5MiAyMTkgLTE5MnE5MSAwIDE3NCAyOHQxODggOTV2NDY5aDE2NnYtMTA5NmgtMTY2djQ5NnEtMTA1IC03MiAtMTk0LjUgLTEwMS41dC0yMDIuNSAtMjkuNXEtMTY0IDAgLTI1NyA4NnQtOTMgMjMzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NDg7IiBob3Jpei1hZHYteD0iMTgyMyIgZD0iTTE3NiAwdjEwOTZoMTY2di05NTNoNDg1djk1M2gxNjZ2LTk1M2g0ODZ2OTUzaDE2OHYtMTA5NmgtMTQ3MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDQ5OyIgaG9yaXotYWR2LXg9IjE4MzciIGQ9Ik0xNzYgMHYxMDk0aDE2NnYtOTUxaDQ4NXY5NTFoMTY2di05NTFoNDg2djk1MWgxNjZ2LTk1MWgxNTd2LTUyMGgtMTY4djM3N2gtMTQ1OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDRhOyIgaG9yaXotYWR2LXg9IjE0MjMiIGQ9Ik00MSA5NTR2MTQyaDUxNnYtNDUzaDMxM3EyMjQgMCAzMzEuNSAtNzd0MTA3LjUgLTIzMnEwIC0xNjYgLTExMS41IC0yNTB0LTMzMS41IC04NGgtNDc1djk1NGgtMzUwek01NTcgMTM5aDMxM3EyNzUgMCAyNzUgMTg1cTAgOTMgLTYyIDEzNC41dC0yMTkgNDEuNWgtMzA3di0zNjF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ0YjsiIGhvcml6LWFkdi14PSIxNTc3IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ1M2gyOTlxMjA5IDAgMzA5LjUgLTc3LjV0MTAwLjUgLTIzMS41cTAgLTE2NSAtMTA2LjUgLTI0OS41dC0zMTMuNSAtODQuNWgtNDU1ek0zNDIgMTM5aDI4MXEyNjQgMCAyNjQgMTg1cTAgOTIgLTYxIDEzNHQtMjA4IDQyaC0yNzZ2LTM2MXpNMTIzNSAwdjEwOTZoMTY2di0xMDk2aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ0YzsiIGhvcml6LWFkdi14PSIxMjEyIiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ1M2gzMzhxNDIwIDAgNDIwIC0zMDlxMCAtMTYyIC0xMDkuNSAtMjQ4dC0zMjAuNSAtODZoLTQ5NHpNMzQyIDEzOWgzMjBxMTMyIDAgMjAyIDQ2dDcwIDEzOXEwIDkxIC02NC41IDEzMy41dC0yMTIuNSA0Mi41aC0zMTV2LTM2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDRkOyIgaG9yaXotYWR2LXg9IjEwMDgiIGQ9Ik01NyAzN3YxNDdxNjAgLTIzIDEzMCAtNDF0MTYxIC0xOHExNzQgMCAyNjguNSA5M3QxMDQuNSAyNzhoLTU1NXYxNDFoNTUzcS0xNiAxNzIgLTEwMC41IDI1MnQtMjQ1LjUgODBxLTEwMyAwIC0yNTQgLTU0bC00NyAxNDBxNTUgMjYgMTM3IDQzLjV0MTYyIDE3LjVxMjU2IDAgMzg5IC0xNDYuNXQxMzMgLTQyMi41cTAgLTI2OSAtMTQ0LjUgLTQxOHQtNDA2LjUgLTE0OXEtMTY3IDAgLTI4NSA1N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDRlOyIgaG9yaXotYWR2LXg9IjE3MDIiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNDU5aDI4OXEyMCAyMjggMTQ2IDM1My41dDMzMyAxMjUuNXEyMjAgMCAzNDguNSAtMTUyLjV0MTI4LjUgLTQxNC41cTAgLTI2OSAtMTI4LjUgLTQxOXQtMzUyLjUgLTE1MHEtMjEzIDAgLTMzOCAxMzMuNXQtMTM5IDM4MC41aC0yODd2LTQ5NGgtMTY2ek04MDEgNTQ5cTAgLTIxMSA3MyAtMzIwLjV0MjM0IC0xMDkuNXExNTggMCAyMzIuNSAxMDYuNXQ3NC41IDMyMy41cTAgMjEwIC03MyAzMTh0LTIzNCAxMDggdC0yMzQgLTEwOHQtNzMgLTMxOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDRmOyIgaG9yaXotYWR2LXg9IjExMzciIGQ9Ik0zNyAwbDMxNSA0NjNxLTEyNyAyOCAtMTk0LjUgMTA4LjV0LTY3LjUgMjAyLjVxMCAxNTAgMTAxIDIzNnQyODIgODZoNDg4di0xMDk2aC0xNjZ2NDM4aC0yNzdsLTI4NyAtNDM4aC0xOTR6TTI1MiA3NzJxMCAtMTkwIDI3NiAtMTkwaDI2N3YzNzBoLTMwMXEtMjQyIDAgLTI0MiAtMTgweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NTA7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMzIwIDE1NDh2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1MTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE0zMTcgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjk4IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NTI7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTIwIDEyNDN2MTI3aDE1NnYxODZoMTY2di0xODZoNDAxdi0xMjdoLTQwMXYtMTk2cTAgLTg0IC04IC0xNDBoMTBxNDkgNzkgMTM5LjUgMTI0LjV0MjA2LjUgNDUuNXEyMDEgMCAzMDEuNSAtOTUuNXQxMDAuNSAtMzA1LjV2LTg0MnEwIC0xNTYgLTY4LjUgLTI0MXQtMjA4LjUgLTg1cS03OSAwIC0xMzEgMjV2MTM3cTU4IC0yMCAxMTMgLTIwcTEyOSAwIDEyOSAxNzB2ODUwcTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTczIDAgLTI1MS41IC05NCB0LTc4LjUgLTMwNXYtNTM3aC0xNjh2MTI0M2gtMTU2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NTM7IiBob3Jpei1hZHYteD0iODc3IiBkPSJNMTc2IDB2MTA5Nmg2NjB2LTE0MmgtNDk0di05NTRoLTE2NnpNMzc4IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1NDsiIGhvcml6LWFkdi14PSIxMDA4IiBkPSJNMTE1IDU0M3EwIDI3NSAxMzcuNSA0MjR0Mzg4LjUgMTQ5cTgyIDAgMTYxIC0xNnQxMzYgLTQxbC00OSAtMTQxcS0xNDMgNTEgLTI1MiA1MXEtMTY0IDAgLTI0OSAtODEuNXQtMTAxIC0yNTAuNWg1NTN2LTE0MWgtNTU1cTkgLTE5MCA5NCAtMjgwLjV0MjUyIC05MC41cTE0MCAwIDI5MSA1OXYtMTQ3cS0xMTYgLTU3IC0yODkgLTU3cS0yNDggMCAtMzgzIDE0NS41dC0xMzUgNDE3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1NTsiIGhvcml6LWFkdi14PSI5NzciIGQ9Ik0xMDYgODI3cTAgMTM0IDEwOSAyMTEuNXQyOTkgNzcuNXExNzcgMCAzNDYgLTcybC01OSAtMTM1cS0xNjUgNjggLTI5OSA2OHEtMTE4IDAgLTE3OCAtMzd0LTYwIC0xMDJxMCAtNDQgMjIuNSAtNzV0NzIuNSAtNTl0MTkyIC04MXExOTUgLTcxIDI2My41IC0xNDN0NjguNSAtMTgxcTAgLTE1MyAtMTE0IC0yMzZ0LTMyMCAtODNxLTIxOCAwIC0zNDAgNjl2MTU0cTc5IC00MCAxNjkuNSAtNjN0MTc0LjUgLTIzcTEzMCAwIDIwMCA0MS41IHQ3MCAxMjYuNXEwIDY0IC01NS41IDEwOS41dC0yMTYuNSAxMDcuNXEtMTUzIDU3IC0yMTcuNSA5OS41dC05NiA5Ni41dC0zMS41IDEyOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDU2OyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTTE2MiAxMzkzcTAgNTcgMjggODMuNXQ3MCAyNi41cTQwIDAgNjkgLTI3dDI5IC04M3QtMjkgLTgzLjV0LTY5IC0yNy41cS00MiAwIC03MCAyNy41dC0yOCA4My41ek0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NTc7IiBob3Jpei1hZHYteD0iNTE4IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnpNLTIwIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTM2MSAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDU4OyIgaG9yaXotYWR2LXg9IjUxOCIgZD0iTS0xMTEgLTMzMnE2OSAtMjAgMTM2IC0yMHE3OCAwIDExNC41IDQyLjV0MzYuNSAxMjkuNXYxMjc2aDE2NnYtMTI2NHEwIC0zMjQgLTI5OSAtMzI0cS05NSAwIC0xNTQgMjV2MTM1ek0xNjIgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDU5OyIgaG9yaXotYWR2LXg9IjE3MTQiIGQ9Ik0xNiAtMnYxMjNxMjIgLTYgNTAgLTZxMTE1IDAgMTgzIDI0M3QxMDMgNzM4aDU5MnYtNDUzaDI0NHEyMTEgMCAzMTIuNSAtNzcuNXQxMDEuNSAtMjMxLjVxMCAtMzM0IC00MzcgLTMzNGgtNDExdjk1NGgtMjU4cS00MCAtNTE4IC0xMzAuNSAtNzQzdC0yNjEuNSAtMjI1cS01NiAwIC04OCAxMnpNOTIyIDEzOWgyMzdxMjc3IDAgMjc3IDE4NXEwIDkxIC02Mi41IDEzMy41dC0yMjAuNSA0Mi41aC0yMzF2LTM2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDVhOyIgaG9yaXotYWR2LXg9IjE4MTUiIGQ9Ik0xNzYgMHYxMDk0aDE3MnYtNDU3aDUwNnY0NTdoMTcwdi00NTNoMjU2cTIxNyAwIDMxOC41IC03Ni41dDEwMS41IC0yMzAuNXEwIC0zMzQgLTQzNCAtMzM0aC00MTZ2NDk0aC01MDJ2LTQ5NGgtMTcyek0xMDIwIDEzOWgyNDBxMjc2IDAgMjc2IDE4NXEwIDkyIC02NCAxMzR0LTIxNyA0MmgtMjM1di0zNjF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1YjsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMjAgMTI0M3YxMjdoMTU2djE4NmgxNjZ2LTE4Nmg0NDl2LTEyN2gtNDQ5di0xOTZxMCAtODQgLTggLTE0MGgxMHE0OSA3OSAxMzkuNSAxMjQuNXQyMDYuNSA0NS41cTIwMSAwIDMwMS41IC05NS41dDEwMC41IC0zMDUuNXYtNjc2aC0xNjZ2NjcwcTAgMTM0IC02MSAyMDB0LTE5MSA2NnEtMTc0IDAgLTI1MyAtOTN0LTc5IC0zMDZ2LTUzN2gtMTY2djEyNDNoLTE1NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDVjOyIgaG9yaXotYWR2LXg9IjEwNjMiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNTMzbDQ3MyA1MzNoMTgybC00NzMgLTUyOWw1MTIgLTU2N2gtMTk0bC01MDAgNTU1di01NTVoLTE2NnpNNDQ0IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1ZDsiIGhvcml6LWFkdi14PSIxMjk4IiBkPSJNMTc2IDB2MTA5NmgxNTZ2LTY5NWwtNyAtMTgybC0zIC01N2w1OTMgOTM0aDIwN3YtMTA5NmgtMTU1djY3MGwzIDEzMmw1IDEzMGwtNTkyIC05MzJoLTIwN3pNMzU3IDE1NDh2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ1ZTsiIGhvcml6LWFkdi14PSIxMDMyIiBkPSJNMiAxMDk2aDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2ek0xNDYgMTU0OGgxNTZxOSAtMTA0IDU0LjUgLTE0NXQxNTguNSAtNDFxMTAzIDAgMTUyLjUgNDR0NjAuNSAxNDJoMTU3IHEtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NWY7IiBob3Jpei1hZHYteD0iMTI3MiIgZD0iTTE3NiAwdjEwOTRoMTY2di05NTFoNTg2djk1MWgxNjZ2LTEwOTRoLTM2OXYtMzc3aC0xNjZ2Mzc3aC0zODN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2MDsiIGhvcml6LWFkdi14PSIyMDcxIiBkPSJNMTMzIDc2NnEwIDMzOSAxMjcuNSA1Mjd0MzU1LjUgMTg4cTE1MyAwIDI3NyAtODBsLTcwIC0xNDZxLTQ1IDMxIC05MS41IDUxLjV0LTEwNi41IDIwLjVxLTE0NyAwIC0yMjkuNSAtMTQ4LjV0LTgyLjUgLTQxNC41cTAgLTMwMSAxMDMuNSAtNDY4dDI5MC41IC0xNjdxMTM5IDAgMjQxIDc2djQ1N2gxNzB2LTQ1N3ExMDIgLTc2IDI0NCAtNzZxMTg3IDAgMjkwIDE2NS41dDEwMyA0NjkuNXEwIDI2NyAtODIuNSA0MTV0LTIyOC41IDE0OCBxLTYwIDAgLTEwNyAtMjAuNXQtOTIgLTUxLjVsLTY5IDE0NnExMjYgODAgMjc2IDgwcTIyOCAwIDM1Ni41IC0xODh0MTI4LjUgLTUyN3EwIC0zNzEgLTE0MS41IC01NzguNXQtMzk2LjUgLTIwNy41cS0xMDggMCAtMTk0IDIyLjV0LTE2OSA3My41aC04cS04MCAtNTAgLTE2NC41IC03M3QtMTkxLjUgLTIzcS0yNTYgMCAtMzk3LjUgMjA1LjV0LTE0MS41IDU4MC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NjE7IiBob3Jpei1hZHYteD0iMTY3NyIgZD0iTTAgMTA5NmgxNzJsMjQ2IC02OTVxMzIgLTkzIDc4IC0yODJoOHExOSA1MyA1NiAxMzQuNXQxNzkgMzczLjVsLTE3MiA0NjloMTc4cTI2NSAtNzY5IDI4Ny41IC04NDF0MzIuNSAtMTE2aDhxMTczIDE4NCAyNDkuNSA0MDEuNXQ3Ni41IDU1NS41aDE2NnEwIC0zNjIgLTk3LjUgLTYxNC41dC0zMTYuNSAtNDgxLjVoLTE4MmwtMTI1IDM0NnEtMzMgOTIgLTM3IDExMXEtMTAgLTI2IC0yMCAtNTEuNXQtMTg5IC00MDUuNWgtMjEzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NjI7IiBob3Jpei1hZHYteD0iMTM4MiIgZD0iTTIzIDExMjZ2MTQ4aDMxOXYyODJoMTcydi0yODJoNDE4di0xNDhoLTQxOHYtMjg4aDIwMXE1NjEgMCA1NjEgLTQxMnEwIC0yMDggLTEzMi41IC0zMTd0LTM5My41IC0xMDloLTQwOHYxMTI2aC0zMTl6TTUxNCAxNDVoMjEzcTE5MiAwIDI4Mi41IDY4LjV0OTAuNSAyMTIuNXEwIDEzOCAtOTMgMTk5dC0zMTEgNjFoLTE4MnYtNTQxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NjM7IiBob3Jpei1hZHYteD0iMTI5NCIgZD0iTTIzIDk1NnYxNDBoMjM1djIyM2gxNjZ2LTIyM2gzNDR2LTE0MGgtMzQ0di0zMTVoMzE5cTQzNyAwIDQzNyAtMzA3cTAgLTE2NiAtMTExLjUgLTI1MHQtMzMxLjUgLTg0aC00Nzl2OTU2aC0yMzV6TTQyNCAxMzloMzA1cTI4NyAwIDI4NyAxODVxMCA5MiAtNjcuNSAxMzR0LTIyMy41IDQyaC0zMDF2LTM2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDY0OyIgaG9yaXotYWR2LXg9IjE4ODIiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNjIyaDM1NnEzMCAzMDcgMjE0LjUgNDc0dDQ4OC41IDE2OXEyMTMgMCAzOTUgLTkybC03MiAtMTQ2cS0xMDAgNDggLTE3OC41IDY3dC0xNTEuNSAxOXEtMjI3IDAgLTM1NyAtMTI1dC0xNjEgLTM2Nmg3MDN2LTE1MGgtNzA3cTggLTI3MyAxNDAuNSAtNDE2dDM3OS41IC0xNDNxMTU0IDAgMzQ4IDU1di0xNDlxLTE1MiAtNTcgLTM3NCAtNTdxLTMxOSAwIC00OTIuNSAxODR0LTE4MS41IDUyNGgtMzUwdi02ODggaC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2NTsiIGhvcml6LWFkdi14PSIxNTA3IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ2MWgyODlxMjQgMjM1IDE1OC41IDM1OHQzNTcuNSAxMjNxODEgMCAxNTggLTE2dDEzMSAtNDFsLTUwIC0xNDFxLTEzOCA1MSAtMjM5IDUxcS0xNjMgMCAtMjQ2LjUgLTgydC05OS41IC0yNTJoNTM2di0xNDFoLTUzOHE5IC0xODggOTMuNSAtMjc4LjV0MjQ4LjUgLTkwLjVxNjEgMCAxMjAuNSAxMXQxNTcuNSA0OHYtMTQ3cS0xMTAgLTU3IC0yNzYgLTU3cS0yMzUgMCAtMzY5IDEzM3QtMTQ1IDM4MWgtMjg3IHYtNDk0aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2NjsiIGhvcml6LWFkdi14PSIxMzg5IiBkPSJNMCAwbDYxNiAxNDYyaDE1OGw2MTUgLTE0NjJoLTE4M2wtMjg2IDY4MmgtMTQ4di02ODJoLTE1NnY2ODJoLTE0OWwtMjg5IC02ODJoLTE3OHpNNTMwIDgzMWgzMzJsLTgyIDIwN3EtNTYgMTQ0IC04NiAyNDRxLTI0IC05OCAtODggLTI2MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDY3OyIgaG9yaXotYWR2LXg9IjExNTUiIGQ9Ik0xMCAwbDQ2NSAxMDk2aDIwNWw0NjUgLTEwOTZoLTE3MmwtMjA3IDQ4OWgtMTEzdi00ODloLTE1MXY0ODloLTExNWwtMjA1IC00ODloLTE3MnpNNDQyIDYyOWgyNzFxLTQzIDEwOCAtNzEgMTc3dC02MiAxNzVoLTlxLTI4IC05MiAtMTI5IC0zNTJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2ODsiIGhvcml6LWFkdi14PSIxODg2IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg0ODFsMjYyIDYyMmgxNThsNjE0IC0xNDYyaC0xODhsLTI4NSA2ODhoLTE0M3YtNjg4aC0xNTR2Njg4aC0xNDdsLTI4NSAtNjg4aC0xODZsMjkwIDY4OGgtNDE3di02ODhoLTE3MHpNMTAzMiA4NDBoMzE4cS0xMTggMzA5IC0xMzIgMzUydC0yNiA5MHEtMTkgLTY3IC0zNi41IC0xMTl0LTEyMy41IC0zMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2OTsiIGhvcml6LWFkdi14PSIxNTY5IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ2MWgzNTBsMTk3IDQ2MWgyMDVsNDYyIC0xMDk2aC0xNzBsLTIwOCA0OTRoLTExM3YtNDk0aC0xNTJ2NDk0aC0xMTBsLTIwOSAtNDk0aC0xNzJsMjA5IDQ5NGgtMjg5di00OTRoLTE2NnpNODU0IDYzNWgyNjhsLTEyOSAzNDZoLThxLTEwIC0zNCAtMjYgLTgxLjV0LTEwNSAtMjY0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2YTsiIGhvcml6LWFkdi14PSIxNDc3IiBkPSJNMjAgMGwxMzYgNDUzcTQ3IDE1OSA5Ni41IDIzMHQxMjQgMTA3LjV0MTkyLjUgNDMuNWwtNDExIDQ5NXYxMzNoMTE2M3YtMTMzbC00MjIgLTQ5NXExMTggLTYgMTk1IC00MnQxMjcgLTEwNS41dDEwMCAtMjMzLjVsMTMzIC00NTNoLTE3NGwtMTM3IDQ1N3EtMzUgMTExIC02OSAxNTl0LTg0LjUgNjd0LTEzOS41IDE5aC0yN3YtNzAyaC0xNzB2NzAyaC0yNnEtOTEgMCAtMTQwLjUgLTE5LjV0LTgyIC02N3QtNjQuNSAtMTU4LjVsLTEzNSAtNDU3IGgtMTg1ek0zNTggMTMwOWwzNzkgLTQ1NWwzNzkgNDU1aC03NTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2YjsiIGhvcml6LWFkdi14PSIxMzE1IiBkPSJNMTIgMGwxMzEgMzM2cTI0IDYxIDQ4IDExMy41dDYwLjUgOTJ0OTEuNSA2NC41dDE0MiAzM2wtMzM1IDM1MnYxMDVoMTAxM3YtMTA1bC0zMzggLTM1MnE4NyAtNyAxNDIuNSAtMzF0OTIgLTY0dDYxIC05Mi41dDE3OS41IC00NTEuNWgtMTcybC0xMzMgMzM2cS0zNCA4NyAtNjMgMTIyLjV0LTcxIDQ5LjV0LTExOCAxNGgtMTB2LTUyMmgtMTUzdjUyMmgtMTFxLTc1IDAgLTExNiAtMTN0LTY5IC00NXQtNjcgLTEyNmwtMTM1IC0zMzhoLTE3MHogTTM2MiA5NTZsMjkzIC0zMTlsMjk1IDMxOWgtNTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NmM7IiBob3Jpei1hZHYteD0iMTk5NSIgZD0iTTIwMSAwdjE0NjJoMTcwdi02MjJoNzI3bC00MDggNDg5djEzM2gxMTYzdi0xMzNsLTQxOSAtNDk4cTEyMCAtNiAxOTYuNSAtNDJ0MTI3IC0xMDh0OTUuNSAtMjI4bDEzNiAtNDUzaC0xNjhsLTEzOCA0NTdxLTMxIDEwNCAtNjYgMTUzLjV0LTg3LjUgNjkuNXQtMTQ3LjUgMjBoLTI0di03MDBoLTE3MnY3MDBoLTI1cS05NCAwIC0xNDQgLTIwdC04MyAtNjcuNXQtNjYgLTE1NS41bC0xMzUgLTQ1N2gtMTc4bDEzNSA0NDZxNTUgMTg0IDExMSAyNDIgaC00MzB2LTY4OGgtMTcwek04OTMgMTMwOWwzNzkgLTQ1N2wzNzkgNDU3aC03NTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ2ZDsiIGhvcml6LWFkdi14PSIxNzMzIiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ1OWg1NjVsLTMzNiAzNTR2MTA1aDEwMTR2LTEwNWwtMzM4IC0zNTRxODggLTcgMTQzLjUgLTMxLjV0OTIgLTYzLjV0NjAuNSAtOTEuNXQxNzkgLTQ1MC41aC0xNzJsLTEzMyAzMzZxLTM0IDg2IC02MyAxMjF0LTcyIDQ5dC0xMTcgMTRoLTEwdi01MjBoLTE1NHY1MjBoLTEwcS03NSAwIC0xMTcgLTEzLjV0LTY5LjUgLTQ1dC02NS41IC0xMjMuNWwtMTM1IC0zMzhoLTE3MGwxMzEgMzM2cTQ3IDEyMCA4NCAxNjAgaC0zMDd2LTQ5NmgtMTY2ek03ODQgOTU2bDI5MyAtMzEzbDI5NSAzMTNoLTU4OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDZlOyIgaG9yaXotYWR2LXg9IjExOTIiIGQ9Ik02MyAtMTM1cTAgMTI2IDEwOC41IDE5MC41dDM0MC41IDczLjVxMjA0IDggMjk0LjUgNzd0OTAuNSAyMTBxMCAyNjggLTQ0OCAyNjhoLTIxOHYxNDNoMjA5cTIwNSAwIDMxNy41IDczLjV0MTEyLjUgMjA1LjVxMCAxMDcgLTgxIDE3MXQtMjE4IDY0cS0xMDYgMCAtMTk5LjUgLTI3LjV0LTIwMy41IC05Ni41bC04NiAxMTRxMTY4IDExNCAzNTggMTQycS01NyA2NiAtMTc0IDE4N2wtNDkgNTJ2MjdoMTIzcTkyIC01OSAyMjMgLTE5NSBxOTIgMTE1IDE1Ny41IDE1OHQxMjkuNSA0M3E1MCAwIDk4IC0xNHYtMTEzcS0yNCAxMCAtNjcgMTBxLTQ0IDAgLTk5LjUgLTQxdC0xMDMuNSAtMTEycTE3OCAtMjMgMjc0LjUgLTExNy41dDk2LjUgLTIzNy41cTAgLTE0MCAtOTUuNSAtMjMydC0yNjUuNSAtMTE4di04cTE4NiAtMjQgMjg3LjUgLTExM3QxMDEuNSAtMjMzcTAgLTIwOCAtMTQxLjUgLTMxNC41dC00MjMuNSAtMTE1LjVxLTEzOCAtNSAtMjA1IC0zMi41dC02NyAtOTAuNSBxMCAtNTUgNDMuNSAtODB0MTMyLjUgLTI1cTk3IDAgMjE3IDdxMTIwIDYgMTkwIDZxMTU1IDAgMjI2IC0zOXYtMTY2cS04MCA1MSAtMjQwIDUxcS02OCAwIC0xNzMgLTV0LTIxMCAtNXEtMTc5IDAgLTI3MSA2Mi41dC05MiAxOTUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDZmOyIgaG9yaXotYWR2LXg9Ijk4OSIgZD0iTTI1IC0xMjVxMCAxMTYgOTUgMTc4LjV0Mjc1IDY1LjVxMzM0IDQgMzM0IDE5NHEwIDk3IC03OCAxNDJ0LTIzNyA0NWgtMTQ4djE0MWgxMTlxMzExIDAgMzExIDE3MnEwIDE2MiAtMjUyIDE2MnEtNzQgMCAtMTQ1LjUgLTE3dC0xNTkuNSAtNTNsLTU5IDEzNXExMjQgNTUgMjUwIDcwcS05MiAxMTcgLTE5NSAyMTV2MjdoMTIzcTc1IC01MiAyMTUgLTE4OXE4OCAxMTAgMTU1IDE1Mi41dDEzMiA0Mi41cTUxIDAgOTYgLTE1di0xMTIgcS0yNCAxMCAtNjUgMTBxLTQ3IDAgLTk4LjUgLTM5LjV0LTk2LjUgLTEwMS41cTEyMiAtMjggMTkyIC05N3Q3MCAtMTc2cTAgLTE4NCAtMjExIC0yNDF2LThxMjQ4IC03MSAyNDggLTI3M3EwIC0xNDggLTEyMSAtMjMydC0zNDYgLTg3cS05MyAtMiAtMTQ3LjUgLTEzLjV0LTc4LjUgLTMyLjV0LTI0IC02NXEwIC00OSAzNy41IC03MC41dDEyNi41IC0yMS41cTg2IDAgMjA4IDVsMTc1IDVxMTI1IDAgMTY0IC0zOXYtMTQzcS0yMSAxOSAtNjMgMzEgdC05NyAxMmwtMTc5IC01cS0xMzAgLTUgLTIyMiAtNXEtMTQ0IDAgLTIyMy41IDU5LjV0LTc5LjUgMTcxLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3MDsiIGhvcml6LWFkdi14PSIxNjMwIiBkPSJNMTA5IDk3OXY0ODNoMTc0di00NzlxMCAtMTg4IDEwMy41IC0yODguNXQzMTUuNSAtMTAwLjVoMjd2ODY4aDE3MHYtODY4aDI5cTIxMSAwIDMxNC41IDk5dDEwMy41IDI4NnY0ODNoMTc2di00ODFxMCAtMTY1IC03MiAtMjg4LjV0LTIwMS41IC0xODV0LTMwNC41IC02MS41aC00NXYtNDQ2aC0xNzB2NDQ2aC00NXEtMTc2IDAgLTMwMy41IDYxdC0xOTkuNSAxODQuNXQtNzIgMjg3LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3MTsiIGhvcml6LWFkdi14PSIxNTQyIiBkPSJNMTY0IDU1M3Y1NDNoMTY2di01NDlxMCAtMTk1IDkwIC0zMDR0Mjc0IC0xMjJ2MTQzM2gxNjR2LTE0MzFxMTg4IDE1IDI4OS41IDEzMC41dDEwMS41IDMxOS41cTAgMTIwIC0xMyAyMzcuNXQtNTAgMjg1LjVoMTY2cTYzIC0yNzIgNjMgLTUxNnEwIC0yNzYgLTE0Mi41IC00Mjl0LTQxNC41IC0xNjl2LTQ3NGgtMTY0djQ3NHEtMjY0IDkgLTM5NyAxNTR0LTEzMyA0MTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3MjsiIGhvcml6LWFkdi14PSIxNTk3IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA3IDY3MHExMyAtMjY3IDEzNy41IC00MDR0MzU0LjUgLTEzN3EyMjkgMCAzNTIuNSAxMzYuNXQxMzYuNSA0MDQuNWgtOTgxek0zMDcgODE5aDk3OXEtMTcgMjU0IC0xMzkgMzg0dC0zNDYgMTMwdC0zNDkuNSAtMTI5IHQtMTQ0LjUgLTM4NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDczOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNDk0cTkgLTE4NiA4OSAtMjgwLjV0MjQyIC05NC41cTE1OCAwIDI0MCA5MnQ5MiAyODNoLTY2M3pNMjg5IDYzNWg2NTlxLTE1IDE2OCAtOTUuNSAyNTR0LTIzNi41IDg2dC0yMzUgLTg2LjV0LTkyIC0yNTMuNXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3NDsiIGhvcml6LWFkdi14PSIxMjgyIiBkPSJNMCAxNDYyaDE4MGwzMzggLTkzOHE3MiAtMTk5IDEwNyAtMzQycTMyIDE0NCAxMDIgMzY3bDE2MiA1MThxNTkgMTkxIDEwMSAyNjd0OTcgMTA4LjV0MTQ0IDMyLjVxNDIgMCAxMjEgLTE5di0xNDFxLTU2IDIwIC0xMDMgMjBxLTU5IDAgLTk4IC01MS41dC05NiAtMjMyLjVsLTMyOCAtMTA1MWgtMTk3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0NzU7IiBob3Jpei1hZHYteD0iMTAzNiIgZD0iTTAgMTA5NmgxNzRsMjI1IC02MTNxMTAwIC0yNjggMTE5IC0zNjhoOHEyMyAxMTggMTA1IDM4NWw5NiAzMDlxMzcgMTIyIDcyLjUgMTgzLjV0ODEgODcuNXQxMjkuNSAyNnE0NSAwIDc1IC0xMHYtMTI3cS0yOSA4IC02NyA4cS00NyAwIC03NiAtNDJ0LTU3IC0xMzRsLTI0OCAtODAxaC0yMzF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3NjsiIGhvcml6LWFkdi14PSIxMjgyIiBkPSJNMCAxNDYyaDE4MGwzMzggLTkzOHE3MiAtMTk5IDEwNyAtMzQycTMyIDE0NCAxMDIgMzY3bDE2MiA1MThxNTkgMTkxIDEwMSAyNjd0OTcgMTA4LjV0MTQ0IDMyLjVxNDIgMCAxMjEgLTE5di0xNDFxLTU2IDIwIC0xMDMgMjBxLTU5IDAgLTk4IC01MS41dC05NiAtMjMyLjVsLTMyOCAtMTA1MWgtMTk3ek0xODggMTg4NnYyMWgxODdxMjggLTYxIDc3LjUgLTE0OHQ5OC41IC0xNTV2LTI1aC05NnEtNTYgNDQgLTE0MyAxNDR0LTEyNCAxNjN6IE01NDUgMTg4NnYyMWgxODZxMjggLTYxIDc3LjUgLTE0OHQ5OC41IC0xNTV2LTI1aC05NnEtNTIgNDIgLTE0MC41IDE0M3QtMTI1LjUgMTY0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Nzc7IiBob3Jpei1hZHYteD0iMTAzNiIgZD0iTTAgMTA5NmgxNzRsMjI1IC02MTNxMTAwIC0yNjggMTE5IC0zNjhoOHEyMyAxMTggMTA1IDM4NWw5NiAzMDlxMzcgMTIyIDcyLjUgMTgzLjV0ODEgODcuNXQxMjkuNSAyNnE0NSAwIDc1IC0xMHYtMTI3cS0yOSA4IC02NyA4cS00NyAwIC03NiAtNDJ0LTU3IC0xMzRsLTI0OCAtODAxaC0yMzF6TTczIDE1NDh2MjFoMTg3cTI4IC02MSA3Ny41IC0xNDh0OTguNSAtMTU1di0yNWgtOTZxLTU2IDQ0IC0xNDMgMTQ0dC0xMjQgMTYzek00MzAgMTU0OCB2MjFoMTg2cTI4IC02MSA3Ny41IC0xNDh0OTguNSAtMTU1di0yNWgtOTZxLTUyIDQyIC0xNDAuNSAxNDN0LTEyNS41IDE2NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDc4OyIgaG9yaXotYWR2LXg9IjI0NzYiIGQ9Ik0xMjUgNzM1cTAgMzU4IDE2MS41IDU1NHQ0NjEuNSAxOTZxMjkxIDAgNDUzLjUgLTIwMHQxNjIuNSAtNTUydC0xNjMuNSAtNTUyLjV0LTQ1NS41IC0yMDAuNXEtMjk3IDAgLTQ1OC41IDE5Ny41dC0xNjEuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTExLjUgLTQ1MC41dDMyOC41IC0xNTMuNXEyMTggMCAzMjguNSAxNTIuNXQxMTAuNSA0NTEuNXEwIDI5NyAtMTEwIDQ0OC41dC0zMjYgMTUxLjVxLTIxOCAwIC0zMzAuNSAtMTUxIHQtMTEyLjUgLTQ0OXpNMTQ0MCAxMDk2aDE3NmwyNDYgLTYyOXE3OCAtMjA3IDk4IC0zMDloOHExMSA0NCA1Mi41IDE2OS41dDI2OS41IDc2OC41aDE3NmwtNDY5IC0xMjQ4cS02OSAtMTgyIC0xNjMgLTI2MXQtMjMwIC03OXEtNzYgMCAtMTUwIDE3djEzM3E1NSAtMTIgMTIxIC0xMnE5NCAwIDE1Mi41IDUxLjV0OTMuNSAxNDAuNWw2MSAxNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3OTsiIGhvcml6LWFkdi14PSIyMTczIiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek0xMTQzIDEwOTYgaDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0N2E7IiBob3Jpei1hZHYteD0iMTY3NyIgZD0iTTEyNSA3MzVxMCAzMDUgMTQ5LjUgNDk5LjV0NDIxLjUgMjM4LjVxMjAgMTA4IDE0NCAxMDhxMTIxIDAgMTQzIC0xMDhxMjY4IC00NCA0MTguNSAtMjQyLjV0MTUwLjUgLTQ5Ny41cTAgLTMwMiAtMTUxLjUgLTUwMC41dC00MTUuNSAtMjQyLjVxLTI2IC0xMTEgLTE0NSAtMTExcS0xMjQgMCAtMTQ0IDExMXEtMjY4IDQxIC00MTkuNSAyMzh0LTE1MS41IDUwN3pNMzA1IDczM3EwIC0yNDQgMTAxIC0zOTYuNXQyOTAgLTE5My41IHExNyA0OCA1My41IDY3dDkwLjUgMTlxMTEwIDAgMTQxIC04NnExODkgNDEgMjkwIDE5My41dDEwMSAzOTYuNXQtMTAxIDM5NS41dC0yOTAgMTkwLjVxLTMxIC04OCAtMTQxIC04OHEtMTEzIDAgLTE0NCA4NnEtMTg5IC0zOSAtMjkwIC0xODkuNXQtMTAxIC0zOTQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDdiOyIgaG9yaXotYWR2LXg9IjEzNDYiIGQ9Ik0xMTUgNTQ5cTAgMjMzIDExMiAzNzd0MzIwIDE4MHE4IDU2IDM5IDc3dDg4IDIxcTU2IDAgODggLTIxLjV0NDEgLTc4LjVxMjAyIC0zOCAzMTUgLTE4NHQxMTMgLTM3MXEwIC0yMzMgLTExMiAtMzc3LjV0LTMxNiAtMTgxLjVxLTkgLTU0IC00MSAtNzYuNXQtODggLTIyLjVxLTU3IDAgLTg3LjUgMjEuNXQtMzkuNSA3Ny41cS0yMDMgMzYgLTMxNy41IDE4M3QtMTE0LjUgMzc2ek0yODcgNTQ5cTAgLTE3NyA2Mi41IC0yODJ0MTk5LjUgLTEzNiBxMTIgNDIgNDIgNTl0ODMgMTdxMTAzIDAgMTI3IC03NHExMzQgMzEgMTk2IDEzNnQ2MiAyODBxMCAzNTIgLTI2MCA0MTRxLTEzIC00MiAtNDMuNSAtNTh0LTgxLjUgLTE2cS01MyAwIC04MyAxNnQtNDIgNjBxLTEzNyAtMzEgLTE5OS41IC0xMzUuNXQtNjIuNSAtMjgwLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3YzsiIGhvcml6LWFkdi14PSIyMDQ2IiBkPSJNMTI1IDc2NnEwIDM0MSAxMjguNSA1Mjh0MzU2LjUgMTg3cTE1NCAwIDI3NSAtODJsLTcwIC0xNDZxLTQzIDMxIC05MCA1Mi41dC0xMDcgMjEuNXEtMTQ4IDAgLTIzMC41IC0xNDcuNXQtODIuNSAtNDE1LjVxMCAtMzAzIDEwNSAtNDY5dDI5MiAtMTY2cTg4IDAgMTczLjUgMzN0MTQ2LjUgOTZxNTUgLTU3IDE0MC41IC05M3QxNzguNSAtMzZxMTg4IDAgMjkzIDE2N3QxMDUgNDY4cTAgMjY3IC04Mi41IDQxNXQtMjI5LjUgMTQ4IHEtNjAgMCAtMTA3LjUgLTIxLjV0LTkwLjUgLTUyLjVsLTcwIDE0NnExMjEgODIgMjc1IDgycTIyOCAwIDM1Ni41IC0xODh0MTI4LjUgLTUyN3EwIC0zNzIgLTE0NCAtNTc5dC00MDMgLTIwN3EtMTA0IDAgLTE4OSAyMHQtMTYxIDY4cS03NSAtNDUgLTE1OC41IC02Ni41dC0xOTMuNSAtMjEuNXEtMjYwIDAgLTQwMi41IDIwNi41dC0xNDIuNSA1NzkuNXpNNzAyIDE4NjZ2MjhxMCAxMDMgNTggMTU4dDE3MCA1NXE1OCAwIDExNCAtMTh0MTE1LjUgLTQwIHQxMjYgLTQwdDE0NC41IC0xOGgxMnYtMTIxaC0xN3EtODQgMCAtMTU1IDE4dC0xMzEgMzkuNXQtMTExIDM5LjV0LTk0IDE4cS00NyAwIC03NyAtMjZ0LTMwIC03N3YtMTZoLTEyNXpNOTE4IDE1NDZ2NzJxMTIwIDQxIDEyMCA5NHEwIDIwIC0xNS41IDI5dC0zMy41IDE3LjV0LTMzLjUgMjEuNXQtMTUuNSA0MXEwIDczIDkyIDczcTU2IDAgODkuNSAtMzR0MzMuNSAtOTFxMCAtMTYyIC0yMzcgLTIyM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDdkOyIgaG9yaXotYWR2LXg9IjE2NTUiIGQ9Ik0xMTUgNTQxcTAgMjc5IDEwMy41IDQyN3QyODkuNSAxNDhxNjIgMCAxMjEuNSAtMTZ0OTkuNSAtNDFsLTU3IC0xMzlxLTg5IDUxIC0xNjAgNTFxLTExNiAwIC0xNzAuNSAtMTA3dC01NC41IC0zMjFxMCAtNDE4IDMwNSAtNDE4cTEyMyAwIDIzNSA4MHE2MiAtNDIgMTE3LjUgLTYxdDEyMi41IC0xOXEzMDEgMCAzMDEgNDE4cTAgMjE0IC01NSAzMjF0LTE3MCAxMDdxLTcxIDAgLTE2MCAtNTFsLTU3IDEzOXE0MCAyNSA5OS41IDQxdDEyMS41IDE2IHExODcgMCAyOTAgLTE0OC41dDEwMyAtNDI2LjVxMCAtMjY3IC0xMjMuNSAtNDE0dC0zNDkuNSAtMTQ3cS0xNDggMCAtMjQyIDY1cS05MiAtNjUgLTIzNSAtNjVxLTIyNSAwIC0zNTAgMTQ1LjV0LTEyNSA0MTUuNXpNNDczIDE1NTZ2MzFxMCAxMDAgNTcuNSAxNTUuNXQxNjkuNSA1NS41cTU4IDAgMTE0LjUgLTE4LjV0MTE1LjUgLTQwdDEyNC41IC00MHQxNDMuNSAtMTguNWgxNHYtMTIwaC0xNnEtODQgMCAtMTU1LjUgMTh0LTEzMS41IDM5IHQtMTEwLjUgMzl0LTkzLjUgMThxLTEwNyAwIC0xMDcgLTEwMnYtMTdoLTEyNXpNNjg4IDEyMzd2NzJxMTE5IDQwIDExOSA5NnEwIDIwIC0xNSAyOC41dC0zMyAxN3QtMzMgMjF0LTE1IDM5LjVxMCA3NCA5MiA3NHE1NiAwIDg5LjUgLTM0dDMzLjUgLTkxcTAgLTE2MSAtMjM4IC0yMjN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ3ZTsiIGhvcml6LWFkdi14PSIyMDE1IiBkPSJNOTQgNzY2cTAgMzQxIDEyOC41IDUyOHQzNTcuNSAxODdxMTUwIDAgMjc2IC04MGwtNzAgLTE0NnEtNDUgMzEgLTkxLjUgNTEuNXQtMTA2LjUgMjAuNXEtMTQ3IDAgLTIyOS41IC0xNDguNXQtODIuNSAtNDE0LjVxMCAtMzAzIDEwNSAtNDY5dDI5NSAtMTY2cTY1IDAgMTMwIDE5dDExNiA1N3Y0NTdoMTcwdi00NTdxMTAyIC03NiAyNDcgLTc2cTE4OCAwIDI5NCAxNjV0MTA2IDQ3MHEwIDI2NyAtODIuNSA0MTV0LTIyOS41IDE0OCBxLTYwIDAgLTEwNi41IC0yMC41dC05MS41IC01MS41bC03MCAxNDZxMTI0IDgwIDI3NyA4MHEyMjggMCAzNTUuNSAtMTg4dDEyNy41IC01MjdxMCAtMzczIC0xNDMgLTU3OS41dC00MDIgLTIwNi41cS0xMTYgMCAtMjAyIDI0dC0xNjIgNzJoLTlxLTc4IC00OSAtMTY0IC03Mi41dC0xOTggLTIzLjVxLTI2MCAwIC00MDIuNSAyMDh0LTE0Mi41IDU3OHpNNTkyIDE3Njl2MjdoODI3di0yN2wtODAgLTE3MmgtMzJsLTUwIDEwM2gtMTg2bC00OSAtMTAzIGgtMzNsLTQ5IDEwM2gtMTg4bC00NyAtMTAzaC0zM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDdmOyIgaG9yaXotYWR2LXg9IjE2NzciIGQ9Ik0wIDEwOTZoMTcybDI0NiAtNjk1cTM5IC0xMTEgODAgLTI4Mmg4cTEyIDM1IDI5LjUgNzUuNXQyMDMuNSA0MzIuNWwtMTcyIDQ2OWgxNzhxMjY1IC03NjkgMjg3LjUgLTg0MXQzMi41IC0xMTZoOHExNzMgMTg0IDI0OS41IDQwMS41dDc2LjUgNTU1LjVoMTY2cTAgLTM2MiAtOTcuNSAtNjE0LjV0LTMxNi41IC00ODEuNWgtMTgybC0xMjUgMzQ2cS0zMyA5MiAtMzcgMTExbC0zOSAtOTVsLTE3MCAtMzYyaC0yMTN6TTM3OSAxNDE3djI3aDgyNyB2LTI3bC04MiAtMTcyaC0zMGwtNTAgMTAzaC0xODhsLTQ5IC0xMDNoLTMxbC00OSAxMDNoLTE4OGwtNTAgLTEwM2gtMzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4MDsiIGhvcml6LWFkdi14PSIxMzA5IiBkPSJNMTI1IDczM3EwIDIyNCA4Ny41IDM5NXQyNTEuNSAyNjN0MzgwIDkycTIzNyAwIDQwNyAtODRsLTcxIC0xNDZxLTE3MSA3OCAtMzQwIDc4cS0yNDUgMCAtMzg5IC0xNjB0LTE0NCAtNDQwcTAgLTI5NCAxMzMgLTQ0NHQzOTEgLTE1MHExMTEgMCAxNjggMjN2LTY1MmgtMTcwdjQ3MmgtMjBxLTMzMSAwIC01MDcuNSAxOTR0LTE3Ni41IDU1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDgxOyIgaG9yaXotYWR2LXg9Ijk5OSIgZD0iTTExNSA1NDFxMCAyNzYgMTM2LjUgNDI1LjV0Mzg3LjUgMTQ5LjVxNzkgMCAxNjEgLTE3dDEzMCAtNDBsLTQ5IC0xNDFxLTE0MiA1MSAtMjQ2IDUxcS0xNzcgMCAtMjYyLjUgLTEwMi41dC04NS41IC0zMjMuNXEwIC0yMjAgODUuNSAtMzIwdDI1Ni41IC0xMDBxNTMgMCA5MyA4LjV0OTcgMzQuNXYtNjU4aC0xNjZ2NDcyaC0yNHEtMjU0IDAgLTM4NCAxNDMuNXQtMTMwIDQxNy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ODI7IiBob3Jpei1hZHYteD0iMTI0NyIgZD0iTTEwNiA1NTFsNjYgMTE1bDI4OSAtMTY4bDIwNSAzNTZsLTI4OSAxNjZsNjcgMTE3bDI4OSAtMTY4bDE4NSAzMTdsMTE4IC02N2wtMTg0IC0zMjBsMjg5IC0xNjZsLTY4IC0xMTVsLTI4NyAxNjZsLTIwNCAtMzU0bDI4NiAtMTY4bC02NSAtMTE1bC0yODkgMTY2bC0xODIgLTMxN2wtMTIxIDY3bDE4MiAzMjJ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4MzsiIGhvcml6LWFkdi14PSIxMTQxIiBkPSJNMjAzIDEyNzJxMCA1MyAyMSA3My41dDc1IDIwLjVoNDQ5cTYgNDYgMjcuNSA3MHQ2OC41IDI0cTUxIDAgNzMuNSAtMjQuNXQyMi41IC03NS41cTAgLTU2IC0yMiAtNzZ0LTc2IC0yMGgtNDUxcS02IC00NSAtMjcgLTcwdC02OSAtMjVxLTUxIDAgLTcxLjUgMjV0LTIwLjUgNzh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4NDsiIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMjQ4IDEyNTd2MTIxaDEycTEyMCAwIDI3MCA1OXExNDkgNTggMjMwIDU4cTExMSAwIDE2OSAtNTUuNXQ1OCAtMTU1LjV2LTMxaC0xMjV2MTdxMCAxMDIgLTEwNiAxMDJxLTQzIDAgLTk0IC0xOHQtMTExLjUgLTM5LjV0LTEzMS41IC0zOS41dC0xNTUgLTE4aC0xNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDg1OyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik00NzkgMTQ2NHEwIDU2IDMzLjUgOTAuNXQ4OS41IDM0LjVxOTIgMCA5MiAtNzZxMCAtMjcgLTE1IC0zOS41dC0zMyAtMjAuNXQtMzMgLTE3dC0xNSAtMjlxMCAtNTQgMTE5IC05NHYtNzRxLTIzOCA2NCAtMjM4IDIyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDg2OyIgaG9yaXotYWR2LXg9IjExODIiIGQ9Ik00ODEgMTIzOXY3NHExMTkgNDAgMTE5IDk0cTAgMjAgLTE1IDI5dC0zMyAxN3QtMzMgMjAuNXQtMTUgMzkuNXEwIDc2IDkyIDc2cTU2IDAgODkuNSAtMzQuNXQzMy41IC05MC41cTAgLTE2MSAtMjM4IC0yMjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4ODsiIGhvcml6LWFkdi14PSIyMDI1IiBkPSJNNDEgNDU5cTUgOTAgNTUuNSAxNDJ0MTUzLjUgNTJxOTIgMCAxNDkuNSAtNTF0NjMuNSAtMTQzaC04MHEtNSA0NSAtMzUgNjYuNXQtOTggMjEuNXEtNzggMCAtMTAzIC0xOS41dC0zMCAtNjguNWgtNzZ6TTIxOSAtNDFxNSA5MCA1NS41IDE0Mi41dDE1My41IDUyLjVxOTIgMCAxNDkuNSAtNTF0NjMuNSAtMTQ0aC04MHEtNSA0NSAtMzUgNjYuNXQtOTggMjEuNXEtNzggMCAtMTAzIC0xOS41dC0zMCAtNjguNWgtNzZ6TTIxOSA5NDYgcTUgOTAgNTUuNSAxNDIuNXQxNTMuNSA1Mi41cTkyIDAgMTQ5LjUgLTUxdDYzLjUgLTE0NGgtODBxLTUgNDUgLTM1IDY2LjV0LTk4IDIxLjVxLTc4IDAgLTEwMyAtMTkuNXQtMzAgLTY4LjVoLTc2ek03OTMgLTMxOXE1IDg5IDU1IDE0MS41dDE1MyA1Mi41cTkyIDAgMTQ5LjUgLTUxdDYzLjUgLTE0M2gtNzlxLTUgNDQgLTM1IDY2dC05OSAyMnEtNzggMCAtMTAzIC0yMC41dC0zMCAtNjcuNWgtNzV6TTc5MyAxMjMxcTExIDE5NCAyMDggMTk0IHE5MyAwIDE0OS41IC01MC41dDYzLjUgLTE0My41aC03OXEtNSA0NCAtMzUgNjZ0LTk5IDIycS03OCAwIC0xMDMgLTIwLjV0LTMwIC02Ny41aC03NXpNMTM3MiAtNDFxNSA5MCA1NS41IDE0Mi41dDE1My41IDUyLjVxOTIgMCAxNDkuNSAtNTF0NjMuNSAtMTQ0aC04MHEtNSA0NSAtMzUgNjYuNXQtOTggMjEuNXEtNzggMCAtMTAzIC0xOS41dC0zMCAtNjguNWgtNzZ6TTEzNzIgOTQ2cTUgOTAgNTUuNSAxNDIuNXQxNTMuNSA1Mi41IHE5MiAwIDE0OS41IC01MXQ2My41IC0xNDRoLTgwcS01IDQ1IC0zNSA2Ni41dC05OCAyMS41cS03OCAwIC0xMDMgLTE5LjV0LTMwIC02OC41aC03NnpNMTU2MyA0NTlxMTEgMTk0IDIwOSAxOTRxOTIgMCAxNDkuNSAtNTJ0NjMuNSAtMTQyaC04MHEtNSA0NCAtMzUgNjZ0LTk4IDIycS03OCAwIC0xMDMuNSAtMjB0LTMwLjUgLTY4aC03NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDg5OyIgaG9yaXotYWR2LXg9IjE5NTgiIGQ9Ik00MSA1NjV2OTdxMjIxIC01MyAzNTAgLTcwdi0xMzlsLTE0IC0xMXEtNjYgMTcgLTE2MS41IDUydC0xNzQuNSA3MXpNMjM4IC01NXExNzcgMTEwIDI5NyAxOThsOTggLTk4bC0yIC0xNnEtMTU1IC04OSAtMzI0IC0xNTJ6TTMyNCAxMjAybDY3IDcwcTEyMyAtMTk4IDE5OSAtMjk3bC05OCAtOThsLTE3IDJxLTgyIDE0MCAtMTUxIDMyM3pNODcwIC0zODVxNTMgMjIxIDcwIDM1MGgxMzlsMTEgLTE0cS0xNyAtNjYgLTUyIC0xNjEuNSB0LTcxIC0xNzQuNWgtOTd6TTg3MCAxMTU1cTE5IDcxIDU1LjUgMTcxdDY3LjUgMTY1aDk3cS01MiAtMjIwIC03MCAtMzUwaC0xMzl6TTEzMjUgMTAxOGwyIDE2cTY3IDM5IDE2MiA4M3QxNjIgNjlsNjkgLTY4cS0xNzcgLTExMCAtMjk3IC0xOTh6TTEzNjYgODZsOTggOThsMTcgLTJxMzkgLTY5IDg0IC0xNjZ0NjcgLTE1N2wtNjcgLTcwcS0zMSA1MCAtOTYgMTQ3LjV0LTEwMyAxNDkuNXpNMTU2NyA1MTJ2MTM5bDE0IDExIHE3MSAtMTkgMTcxIC01NS41dDE2NSAtNjcuNXYtOTdxLTIyMSA1MyAtMzUwIDcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OGE7IiBob3Jpei1hZHYteD0iMTU3NyIgZD0iTTIwMSAwdjE0NjJoMTYxdi04MTVxMCAtMTE4IC0xMCAtMzI0bC00IC04M2g4bDgyMCAxMjIyaDE4NHYtMTMxMGgxODRsLTE0MyAtNTMzaC0xOTdsMTU2IDM4MWgtMTYwdjgwNXEwIDE3NSAxOSA0MjJoLTlsLTgyMyAtMTIyN2gtMTg2ek00MTYgMTg4NmgxNTVxMTAgLTEwOCA1Ni41IC0xNDd0MTU2LjUgLTM5cTEwNSAwIDE1NC41IDQ2LjV0NTguNSAxMzkuNWgxNThxLTEyIC0xNTkgLTEwMi41IC0yMzN0LTI3Mi41IC03NCBxLTE4NiAwIC0yNzAgNzEuNXQtOTQgMjM1LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4YjsiIGhvcml6LWFkdi14PSIxMzE3IiBkPSJNMTc2IDB2MTA5NmgxNTZ2LTY2MnEwIC0xMzYgLTEwIC0yNzJsNTkzIDkzNGgyMDd2LTk1M2gxNzZsLTEyOSAtNTIwaC0xNzJsMTI1IDM3N2gtMTU1djY3MnEwIDE1OCA4IDI2MmwtNTk0IC05MzRoLTIwNXpNMzAzIDE1NDhoMTU2cTcgLTEwMiA1MiAtMTQ0dDE2MSAtNDJxMTAzIDAgMTUzIDQ1dDYwIDE0MWgxNTdxLTEyIC0xNTggLTEwMSAtMjMyLjV0LTI3MyAtNzQuNXEtMTg1IDAgLTI3MCA3MS41dC05NSAyMzUuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDhjOyIgaG9yaXotYWR2LXg9IjEyNTUiIGQ9Ik00NyAxMTI2djE1MGgxNTR2MTg2aDE3MHYtMTg2aDM0MnYtMTUwaC0zNDJ2LTI4OGgxOTJxNTg2IDAgNTg2IC00MTJxMCAtMjEwIC0xMzggLTMxOHQtNDA5IC0xMDhoLTQwMXYxMTI2aC0xNTR6TTM3MSAxNDVoMjIxcTM3OSAwIDM3OSAyODFxMCAxMzIgLTkyIDE5NnQtMjkzIDY0aC0yMTV2LTU0MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDhkOyIgaG9yaXotYWR2LXg9IjEyMTIiIGQ9Ik0yMCAxMTgydjEyOWgxNTZ2MjQ1aDE2NnYtMjQ1aDI5NXYtMTI5aC0yOTV2LTUzOWgzMjBxMjIzIDAgMzMwLjUgLTc3dDEwNy41IC0yMzJxMCAtMTY0IC0xMTIgLTI0OXQtMzMzIC04NWgtNDc5djExODJoLTE1NnpNMzQyIDEzOWgzMDVxMjg3IDAgMjg3IDE4NXEwIDkyIC02NiAxMzR0LTIyNSA0MmgtMzAxdi0zNjF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ4ZTsiIGhvcml6LWFkdi14PSIxMjUxIiBkPSJNMjAxIDB2MTQ2MmgzOTNxMjc0IDAgNDEyLjUgLTEwNy41dDEzOC41IC0zMTguNXEwIC0xMjcgLTU3LjUgLTIyNy41dC0xNjUuNSAtMTU3LjVsMTIwIC0xNTdsLTEwMCAtODRsLTE0OSAxOTJxLTEwMiAtMjcgLTIzOCAtMjdoLTE4NHYtNTc1aC0xNzB6TTM3MSA3MjFoMTY2cTg3IDAgMTYzIDEwbC0xMDggMTQxbDEwOCA4MmwxNDAgLTE3NnExMjcgNzIgMTI3IDI1MHEwIDE0NSAtOTcgMjE2dC0yOTkgNzFoLTIwMHYtNTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OGY7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTE3NiAtNDkydjE1ODhoMTM1bDI1IC0xNTBoOHE2NCA5MCAxNDguNSAxMzB0MTkzLjUgNDBxMjE4IDAgMzM2LjUgLTE0OXQxMTguNSAtNDE4cTAgLTMzOCAtMTgzIC00ODNsMTE1IC0xNTZsLTEwMCAtODBsLTEzMSAxNzRxLTcxIC0yNCAtMTU2IC0yNHEtMTA3IDAgLTE5NS41IDM5LjV0LTE0OC41IDEyMS41aC0xMnExMiAtMTQ4IDEyIC0xODJ2LTQ1MWgtMTY2ek0zNDIgNTQ5cTAgLTIzMSA3NyAtMzMwLjV0MjQ3IC05OS41cTQ3IDAgODggMTIgbC0xMjEgMTU4bDEwNiA4MGwxMjkgLTE3MHExMDEgMTAzIDEwMSAzNTJxMCAyMTUgLTc1IDMxOS41dC0yMzIgMTA0LjVxLTE2OCAwIC0yNDMgLTkzdC03NyAtMjk2di0zN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDkwOyIgaG9yaXotYWR2LXg9IjEwNzkiIGQ9Ik0yMDEgMHYxNDYyaDY2OXYzMDFoMTYydi00NTRoLTY2MXYtMTMwOWgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTE7IiBob3Jpei1hZHYteD0iODc3IiBkPSJNMTc2IDB2MTA5Nmg0OTR2MzIxaDE2NnYtNDUwaC00OTR2LTk2N2gtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTI7IiBob3Jpei1hZHYteD0iMTA3OSIgZD0iTTQ3IDY0OXYxNTBoMTU0djY2M2g4MzF2LTE1M2gtNjYxdi01MTBoNDI0di0xNTBoLTQyNHYtNjQ5aC0xNzB2NjQ5aC0xNTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDQ5MzsiIGhvcml6LWFkdi14PSI4NzciIGQ9Ik0xOCA0ODV2MTI3aDE1OHY0ODRoNjU4di0xNDBoLTQ5MnYtMzQ0aDM0NnYtMTI3aC0zNDZ2LTQ4NWgtMTY2djQ4NWgtMTU4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTQ7IiBob3Jpei1hZHYteD0iMTMxNSIgZD0iTTIwMSAwdjE0NjJoODQxdi0xNTNoLTY3MXYtNTE2cTkwIDEwIDIxMSAxMHEzMjAgMCA0OTAuNSAtMTY5LjV0MTcwLjUgLTQ4My41cTAgLTMxNSAtMTQzIC00ODguNXQtNDAyIC0xNzMuNXEtODMgMCAtMTQ1LjUgMTAuNXQtMTMyLjUgMzguNXYxNTJxMTIzIC00OSAyNjAgLTQ5cTM4MyAwIDM4MyA1MTBxMCAyNDUgLTEyOCAzNzV0LTM3NCAxMzBxLTEwMCAwIC0xOTAgLTEydi02NDNoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDk1OyIgaG9yaXotYWR2LXg9IjEwNzUiIGQ9Ik0xNzYgMHYxMDk2aDY2NnYtMTQyaC01MDB2LTMyOXE4MiAxMiAxNDEgMTJxMjcyIDAgNDAzLjUgLTE0MS41dDEzMS41IC00MzYuNXEwIC0yNjcgLTExNCAtNDE0dC0zMjIgLTE0N3EtMTQ1IDAgLTI0NiA2MHYxNDlxMTE2IC02MyAyMzkgLTYzcTEzMyAwIDIwMSAxMDF0NjggMzE2cTAgMjIzIC04OSAzMjd0LTI3MCAxMDRxLTY5IDAgLTE0MyAtMTd2LTQ3NWgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTY7IiBob3Jpei1hZHYteD0iMTgyMyIgZD0iTTIgMGw1OTYgNzUybC01NzUgNzEwaDE5MGw1NjkgLTcwOHY3MDhoMTY0di03MDhsNTcwIDcwOGgxOTBsLTU3NiAtNzA4bDQ3NCAtNjAwaDE4MHYtNTM1aC0xNjJ2MzgxaC05NGwtNTgyIDc0MXYtNzQxaC0xNjR2NzQxbC01ODEgLTc0MWgtMTk5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTc7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTQgMGw0OTYgNTY1bC00NTcgNTMxaDE4Mmw0NTEgLTUzMXY1MzFoMTUzdi01MzFsNDUzIDUzMWgxODJsLTQ1OCAtNTMxbDM2OCAtNDIyaDE5M3YtNTIwaC0xNjJ2Mzc3aC05NGwtNDgyIDU1N3YtNTU3aC0xNTN2NTU3bC00ODEgLTU1N2gtMTkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OTg7IiBob3Jpei1hZHYteD0iMTE5MCIgZD0iTTc0IDU5djE1OHE5NiAtNDYgMjA3LjUgLTcxdDIxNC41IC0yNXExOTggMCAyOTkuNSA3NXQxMDEuNSAyMTZxMCAxMzQgLTExMi41IDIwM3QtMzM1LjUgNjloLTIxOHYxNDNoMjA5cTIwNSAwIDMxNy41IDczLjV0MTEyLjUgMjA1LjVxMCAxMDcgLTgxIDE3MXQtMjE4IDY0cS0xMTAgMCAtMTk5IC0yNXQtMjA2IC05OWwtODQgMTE0cTEwMSA3NSAyMjYuNSAxMTMuNXQyNjAuNSAzOC41cTIyNSAwIDM1Mi41IC05OC41dDEyNy41IC0yNjQuNSBxMCAtMTQ0IC05MS41IC0yMzR0LTI1Mi41IC0xMTR2LThxMTgzIC0yNSAyNzcuNSAtMTE1dDk0LjUgLTIzNXEwIC0yMDUgLTE1MyAtMzE5LjV0LTQzMiAtMTE0LjVxLTI1NSAwIC00MTggNzl6TTM5MyAtMzIycTMyIC0xMCA4NiAtMTBxMzcgMCA2Mi41IDI0dDI1LjUgNzBxMCAxMDMgLTEzOSAyMzhoMTIzcTE1OCAtMTIwIDE1OCAtMjUycTAgLTkxIC01MSAtMTQyLjV0LTE1MCAtNTEuNXEtNjUgMCAtMTE1IDE2djEwOHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDk5OyIgaG9yaXotYWR2LXg9Ijk4OSIgZD0iTTY4IDUxdjE1MnExODMgLTg2IDM3MCAtODZxMTQ0IDAgMjE3LjUgNDkuNXQ3My41IDE0Mi41cTAgMTkxIC0zMTEgMTkxaC0xNTJ2MTQxaDExOXEzMTEgMCAzMTEgMTcycTAgMTYyIC0yNTIgMTYycS03NyAwIC0xNDAgLTE0dC0xNjUgLTU2bC01OSAxMzVxMTcwIDc2IDM3MSA3NnExODkgMCAyOTggLTc3LjV0MTA5IC0yMTEuNXEwIC0xODQgLTIwNSAtMjQxdi04cTEyNiAtMzcgMTg0IC0xMDUuNXQ1OCAtMTcxLjUgcTAgLTE1MiAtMTIyLjUgLTIzNi41dC0zMzguNSAtODQuNXEtMjM3IDAgLTM2NiA3MXpNMzEzIC0zMjJxMzIgLTEwIDg2IC0xMHEzNyAwIDYyLjUgMjR0MjUuNSA3MHEwIDEwMyAtMTM5IDIzOGgxMjNxMTU4IC0xMjAgMTU4IC0yNTJxMCAtOTEgLTUxIC0xNDIuNXQtMTUwIC01MS41cS02NSAwIC0xMTUgMTZ2MTA4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OWE7IiBob3Jpei1hZHYteD0iMTM1NCIgZD0iTTIwMSAwdjE0NjJoMTcwdi03MjVsNjYzIDcyNWgyMDFsLTU4OCAtNjM1bDUwNCAtNjczaDE3MnYtNTM1aC0xNjJ2MzgxaC0xMDJsLTUzNSA3MDlsLTE1MyAtMTM2di01NzNoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDliOyIgaG9yaXotYWR2LXg9IjExMTYiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNTMzbDQ3MyA1MzNoMTgybC00NzMgLTUyOWwzODMgLTQyNGgxNzh2LTUyMmgtMTU5djM3OWgtODRsLTUwMCA1NTV2LTU1NWgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OWM7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTIwMSAwdjE0NjJoMTcwdi03MzFsMTI1IDEzOXYzNDloMTI1di0yMTFsNDExIDQ1NGgyMDNsLTU4OCAtNjM1bDYxMCAtODI3aC0yMDBsLTQzNiA2MDR2LTMwNWgtMTI1djM4MWwtMTI1IC0xMDd2LTU3M2gtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0OWQ7IiBob3Jpei1hZHYteD0iMTA5MiIgZD0iTTE3NiAwdjEwOTZoMTY2di01MzNsMTE5IDEyMXYzMzBoMTMxdi0yMDVsMjcwIDI4N2gxODJsLTQ1MiAtNDc1di0xMDdsNDkxIC01MTRoLTE5NGwtMjk5IDMxNXYtMjIxaC0xMjl2MzQwbC0xMTkgMTIxdi01NTVoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDllOyIgaG9yaXotYWR2LXg9IjEyNTciIGQ9Ik00NyAxMTMzdjE1MWgxNTR2MTc4aDE3MHYtMTc4aDIyMXYtMTUxaC0yMjF2LTQwMmw2NjEgNzMxaDIwM2wtNTg4IC02MzVsNjEwIC04MjdoLTIwNmwtNTI3IDcwOWwtMTUzIC0xMzR2LTU3NWgtMTcwdjExMzNoLTE1NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NDlmOyIgaG9yaXotYWR2LXg9IjEwNTkiIGQ9Ik0yMCAxMjQzdjEyN2gxNTZ2MTg2aDE2NHYtMTg2aDM4MXYtMTI3aC0zODF2LTUzNmwtMyAtOTFsLTMgLTU1aDhsMTggMjRxNTUgNzQgNzUgOTh0Mzg4IDQxM2gxOTlsLTQ0NCAtNDY3bDQ3MyAtNjI5aC0xOTlsLTM4NyA1MTZsLTEyNSAtMTA2di00MTBoLTE2NHYxMjQzaC0xNTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhMDsiIGhvcml6LWFkdi14PSIxNDExIiBkPSJNMTYgMTMwOXYxNTNoNTA4di03MzFsNjYyIDczMWgyMDNsLTU4OCAtNjM1bDYxMCAtODI3aC0yMDFsLTUzMiA3MDlsLTE1NCAtMTM2di01NzNoLTE3MHYxMzA5aC0zMzh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhMTsiIGhvcml6LWFkdi14PSIxMjYwIiBkPSJNNDEgOTU2djE0MGg1MTR2LTUzM2w0NzUgNTMzaDE4MmwtNDczIC01MzFsNTEyIC01NjVoLTE5NGwtNTAyIDU1NXYtNTU1aC0xNjR2OTU2aC0zNTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhMjsiIGhvcml6LWFkdi14PSIxNTI4IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg3NzB2NjIyaDE3MHYtMTMwOGgxNjJ2LTUzNWgtMTYydjM4MWgtMTcwdjY4OGgtNzcwdi02ODhoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGEzOyIgaG9yaXotYWR2LXg9IjEzMjciIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNDU5aDYxNHY0NTloMTY2di05NTNoMTUwdi01MjBoLTE2NnYzNzdoLTE1MHY0OTRoLTYxNHYtNDk0aC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhNDsiIGhvcml6LWFkdi14PSIxNjY1IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg3Njh2NjIyaDUwOHYtMTUzaC0zMzZ2LTEzMDloLTE3MnY2ODhoLTc2OHYtNjg4aC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhNTsiIGhvcml6LWFkdi14PSIxNTA3IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ1OWg2MTR2NDU5aDUxN3YtMTQwaC0zNTF2LTk1NmgtMTY2djQ5NGgtNjE0di00OTRoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGE2OyIgaG9yaXotYWR2LXg9IjIxODUiIGQ9Ik0yMDEgMHYxNDYyaDEwNDB2LTY3MXE2OCAxMiAxOTMgMTJxMzA2IDAgNDc0LjUgLTE3MnQxNjguNSAtNDg0cTAgLTMxMyAtMTQxLjUgLTQ4NnQtMzk5LjUgLTE3M3EtMTU2IDAgLTI3OSA0OXYxNTJxMTM0IC00OSAyNjEgLTQ5cTM3OCAwIDM3OCA1MTBxMCAyNDIgLTExNSAzNzIuNXQtMzQ3IDEzMC41cS00MiAwIC0xMDUuNSAtMy41dC04Ny41IC04LjV2LTY0MWgtMTcwdjEzMDloLTcwMHYtMTMwOWgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YTc7IiBob3Jpei1hZHYteD0iMTc3MiIgZD0iTTE3NiAwdjEwOTZoODc5di00NzNxNzUgMTQgMTQxIDE0cTI0NiAwIDM3NyAtMTQ4LjV0MTMxIC00MjkuNXEwIC0yNjggLTEwNC41IC00MTQuNXQtMjk2LjUgLTE0Ni41cS0xMzEgMCAtMjI4IDYwdjE0OXExMDkgLTYzIDIxNyAtNjNxMjQwIDAgMjQwIDQxN3EwIDIyMyAtODMgMzI3dC0yNTUgMTA0cS02NyAwIC0xMzkgLTIxdi00NzFoLTE2OHY5NTJoLTU0NXYtOTUyaC0xNjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhODsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDcxNXEwIDM3NiAxNjQuNSA1NzN0NDc4LjUgMTk3cTEyNyAwIDIxOSAtMzVsLTQ3IC0xNDVxLTg0IDI4IC0xNzQgMjhxLTQ2MSAwIC00NjEgLTYxMHEwIC0yODggMTI3LjUgLTQ0MXQzNjIuNSAtMTUzcTU0IDAgMTAwIDEwcS04NiAxMDMgLTEzMiAyNDV0LTQ2IDMwMnEwIDI0NCA5OSAzNzd0Mjc0IDEzM3ExODEgMCAyNzcuNSAtMTMzdDk2LjUgLTM4NXEwIC0xODEgLTY5IC0zMzUuNXQtMTg1IC0yNDAuNXE2NiAtMzAgMTU2IC0zMCBxNzggMCAxMzkgMjJ2LTE1M3EtNTYgLTI1IC0xNDcgLTI1cS0xNzggMCAtMzI2IDEwMHEtMTAyIC0zNiAtMjQ2IC0zNnEtMzEwIDAgLTQ4NS41IDE5Ni41dC0xNzUuNSA1MzguNXpNODk1IDY3NnEwIC0xNDAgNDYuNSAtMjY3dDEyOS41IC0yMTJxMTAyIDY3IDE1OS41IDE5NC41dDU3LjUgMjgwLjVxMCAxNzcgLTUxLjUgMjc5dC0xNDQuNSAxMDJxLTk0IDAgLTE0NS41IC0xMDAuNXQtNTEuNSAtMjc2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRhOTsiIGhvcml6LWFkdi14PSIxMzExIiBkPSJNMTE1IDUzN3EwIDI3NSAxMjQgNDI3dDM1MSAxNTJxOTEgMCAxNjggLTIybC0zNyAtMTM4cS01NCAxOSAtMTMzIDE5cS0xNTYgMCAtMjI4LjUgLTEwNC41dC03Mi41IC0zMzUuNXEwIC0yMDYgODUgLTMxMXQyNDkgLTEwNXEzNyAwIDYzLjUgNC41dDMyLjUgNy41cS0xMzkgMTQ4IC0xMzkgMzczcTAgMTczIDg0IDI2OS41dDIzNSA5Ni41cTE0OCAwIDIyNi41IC05NC41dDc4LjUgLTI3MS41cTAgLTEyNSAtNTMuNSAtMjI5LjUgdC0xNDcuNSAtMTY4LjVxNTIgLTI2IDExOSAtMjZxNjYgMCAxMTUgMTR2LTEzN3EtMzkgLTE0IC0xMjcgLTE0cS0xNDcgMCAtMjc3IDc3cS05NiAtNDAgLTIxOSAtNDBxLTE0OSAwIC0yNjIgNjkuNXQtMTc0IDE5Ni41dC02MSAyOTF6TTc1MCA0OThxMCAtOTQgMzQgLTE3NC41dDk3IC0xMzMuNXE2OCA0NCAxMDkuNSAxMjN0NDEuNSAxODlxMCAyMzUgLTEzNSAyMzVxLTcyIDAgLTEwOS41IC02Mi41dC0zNy41IC0xNzYuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGFhOyIgaG9yaXotYWR2LXg9IjEyOTIiIGQ9Ik0xMjUgNzMzcTAgMjI2IDg0LjUgMzk2dDI0NCAyNjJ0Mzc1LjUgOTJxMjMwIDAgNDAyIC04NGwtNzIgLTE0NnEtMTY2IDc4IC0zMzIgNzhxLTI0MSAwIC0zODAuNSAtMTYwLjV0LTEzOS41IC00MzkuNXEwIC0yODcgMTM0LjUgLTQ0My41dDM4My41IC0xNTYuNXExNTMgMCAzNDkgNTV2LTE0OXEtMTUyIC01NyAtMzc1IC01N3EtMzIzIDAgLTQ5OC41IDE5NnQtMTc1LjUgNTU3ek01OTggLTMyMnEzMiAtMTAgODYgLTEwcTM3IDAgNjIuNSAyNCB0MjUuNSA3MHEwIDEwMyAtMTM5IDIzOGgxMjNxMTU4IC0xMjAgMTU4IC0yNTJxMCAtOTEgLTUxIC0xNDIuNXQtMTUwIC01MS41cS02NSAwIC0xMTUgMTZ2MTA4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YWI7IiBob3Jpei1hZHYteD0iOTc1IiBkPSJNMTE1IDU0MXEwIDI3NSAxMzIuNSA0MjV0Mzc3LjUgMTUwcTc5IDAgMTU4IC0xN3QxMjQgLTQwbC01MSAtMTQxcS01NSAyMiAtMTIwIDM2LjV0LTExNSAxNC41cS0zMzQgMCAtMzM0IC00MjZxMCAtMjAyIDgxLjUgLTMxMHQyNDEuNSAtMTA4cTEzNyAwIDI4MSA1OXYtMTQ3cS0xMTAgLTU3IC0yNzcgLTU3cS0yMzggMCAtMzY4LjUgMTQ2LjV0LTEzMC41IDQxNC41ek00MzYgLTMyMnEzMiAtMTAgODYgLTEwcTM3IDAgNjIuNSAyNHQyNS41IDcwIHEwIDEwMyAtMTM5IDIzOGgxMjNxMTU4IC0xMjAgMTU4IC0yNTJxMCAtOTEgLTUxIC0xNDIuNXQtMTUwIC01MS41cS02NSAwIC0xMTUgMTZ2MTA4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YWM7IiBob3Jpei1hZHYteD0iMTEzMyIgZD0iTTE2IDEzMDl2MTUzaDEwOTh2LTE1M2gtNDYzdi0xMTU1aDE2MnYtNTM1aC0xNjJ2MzgxaC0xNzJ2MTMwOWgtNDYzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YWQ7IiBob3Jpei1hZHYteD0iOTU2IiBkPSJNNDEgOTU2djE0MGg4NzJ2LTE0MGgtMzU0di04MTNoMTUwdi01MjBoLTE2NnYzNzdoLTE1MHY5NTZoLTM1MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGFlOyIgaG9yaXotYWR2LXg9IjExNDciIGQ9Ik0wIDE0NjJoMTg2bDM4NyAtNzMxbDM5MCA3MzFoMTg0bC00ODggLTg5NXYtNTY3aC0xNzJ2NTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YWY7IiBob3Jpei1hZHYteD0iMTAyNiIgZD0iTTAgMTA5NmgxNzJsMjM2IC02MTNxODMgLTIyMiAxMDIgLTMxOWg4cTMzIDEzOCAxMDMgMzE5bDIzMyA2MTNoMTcybC00MzAgLTExMDB2LTQ4OGgtMTY2djQ4OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGIwOyIgaG9yaXotYWR2LXg9IjExNDciIGQ9Ik0wIDE0NjJoMTg2bDM4NyAtNzMxbDM5MCA3MzFoMTg0bC00ODggLTg5NXYtNTloMjk5di0xNTJoLTI5OXYtMzU2aC0xNzJ2MzU2aC0zMDF2MTUyaDMwMXY1MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGIxOyIgaG9yaXotYWR2LXg9IjEwMjYiIGQ9Ik0wIDEwOTZoMTcybDIzNiAtNjEzcTgzIC0yMjIgMTAyIC0zMTloOHEzMyAxMzggMTAzIDMxOWwyMzMgNjEzaDE3MmwtNDI4IC0xMDk2aDI3NHYtMTI5aC0yNzZ2LTM2M2gtMTY2djM2M2gtMjc4djEyOWgyNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRiMjsiIGhvcml6LWFkdi14PSIxMjY4IiBkPSJNOCAwbDQ4NiA3NjRsLTQ1MyA2OThoMTg4bDM2MyAtNTc5bDM2NiA1NzloMTgxbC00NTMgLTY5MmwzODkgLTYxNmgxNjJ2LTUzNWgtMTYydjM4MWgtOTRsLTM5MyA2NDNsLTQwMCAtNjQzaC0xODB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRiMzsiIGhvcml6LWFkdi14PSIxMTEwIiBkPSJNMzkgMGw0MDEgNTYxbC0zODEgNTM1aDE4OWwyODkgLTQyMGwyODggNDIwaDE4N2wtMzgxIC01MzVsMjk5IC00MThoMTQ5di01MjJoLTE2NnYzNzloLTY5bC0zMDcgNDQ0bC0zMTAgLTQ0NGgtMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YjQ7IiBob3Jpei1hZHYteD0iMTc1MSIgZD0iTTE2IDEzMDl2MTUzaDEwNzF2LTE1M2gtNDc1di0xMTU1aDc1MnYxMzA4aDE3MHYtMTMwOGgxNzB2LTUzNWgtMTYydjM4MWgtMTEwMHYxMzA5aC00MjZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRiNTsiIGhvcml6LWFkdi14PSIxNDY4IiBkPSJNNDEgOTU0djE0MGg4NDh2LTE0MGgtMzYxdi04MTFoNTgydjk1MWgxNjZ2LTk1MWgxNTZ2LTUyMGgtMTY2djM3N2gtOTA0djk1NGgtMzIxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YjY7IiBob3Jpei1hZHYteD0iMTQxNyIgZD0iTTE3MCA4ODF2NTgxaDE3MHYtNTYxcTAgLTEyMSA2My41IC0xNzl0MjA2LjUgLTU4cTk3IDAgMTg1LjUgMTQuNXQyNTcuNSA2OS41djcxNGgxNzB2LTEzMDhoMTYxdi01MzVoLTE2MXYzODFoLTE3MHY2MDRxLTE0OSAtNTMgLTI0OCAtNzIuNXQtMjA1IC0xOS41cS0yMDcgMCAtMzE4LjUgOTV0LTExMS41IDI3NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGI3OyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xNTYgNjg0djQxMmgxNjZ2LTQwMHEwIC0xOTIgMjE5IC0xOTJxOTEgMCAxNzQgMjh0MTg4IDk1djQ2OWgxNjZ2LTk1M2gxNTB2LTUyMmgtMTY2djM3OWgtMTUwdjQ5NnEtMTA1IC03MiAtMTk0LjUgLTEwMS41dC0yMDIuNSAtMjkuNXEtMTY0IDAgLTI1NyA4NnQtOTMgMjMzeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Yjg7IiBob3Jpei1hZHYteD0iMTQyMyIgZD0iTTE3MCA4ODF2NTgxaDE3MHYtNTYxcTAgLTExOSA2Ny41IC0xNzh0MjIxLjUgLTU5djM0OGgxMjV2LTM0MnExMzQgMTMgMjk3IDczdjcxOWgxNzJ2LTE0NjJoLTE3MnY2MDBxLTE2OCAtNjUgLTI5NyAtODJ2LTMwNWgtMTI1djI5OXEtNDU5IDAgLTQ1OSAzNjl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRiOTsiIGhvcml6LWFkdi14PSIxMjI5IiBkPSJNMTU2IDY4NHY0MTJoMTY2di00MDBxMCAtMTg2IDIwMCAtMTkydjMwMWgxMTl2LTI5MXExMTMgMjQgMjQ2IDExM3Y0NjloMTY2di0xMDk2aC0xNjZ2NDk2cS0xMjggLTkxIC0yNDYgLTExN3YtMjQ4aC0xMTl2MjM0aC0yMnEtMTYwIDAgLTI1MiA4NXQtOTIgMjM0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YmE7IiBob3Jpei1hZHYteD0iMTQyMyIgZD0iTTIwMSAwdjE0NjJoMTcwdi02MDRxMjU2IDkyIDQ1MiA5MnEyMDcgMCAzMTguNSAtOTUuNXQxMTEuNSAtMjcyLjV2LTU4MmgtMTcwdjU2MXEwIDEyMCAtNjMuNSAxNzl0LTIwNi41IDU5cS0xMDcgMCAtMjAwIC0xN3QtMjQyIC02N3YtNzE1aC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRiYjsiIGhvcml6LWFkdi14PSIxMTk4IiBkPSJNMTc2IDB2MTA5NmgxNjZ2LTQ5OHE5NSA2OSAxODggMTAwdDIwNyAzMXExNjMgMCAyNTggLTg0dDk1IC0yMzV2LTQxMGgtMTY4djM5N3EwIDE5MyAtMjE3IDE5M3EtODggMCAtMTY2IC0yNC41dC0xOTcgLTk4LjV2LTQ2N2gtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YmM7IiBob3Jpei1hZHYteD0iMTcxNiIgZD0iTTYxIDkwM3EwIDczIDI3IDEyN2gxNDVxLTIwIC01MCAtMjAgLTExMHEwIC0xMDMgMTEzIC0xMDNoMzRsNSA0M3EyOSAyOTggMTk1LjUgNDYxLjV0NDQ1LjUgMTYzLjVxMjk3IDAgNDQ1IC0xODkuNXQxNDggLTU1OC41di02OWgtMTA2MHExNCAtMjY0IDE0NC41IC00MDAuNXQzNzcuNSAtMTM2LjVxMTAxIDAgMjAyIDE1LjV0MjQyIDU4LjV2LTE1NnEtMTE0IC0zOSAtMjI0LjUgLTU0dC0yNDAuNSAtMTVxLTMxNCAwIC00ODguNSAxNzggdC0xOTMuNSA1MTBxLTE0MiAwIC0yMTkuNSA1OXQtNzcuNSAxNzZ6TTUzOSA4MTdoODc4cTAgMjY1IC0xMDEuNSAzOTAuNXQtMzExLjUgMTI1LjVxLTIwOSAwIC0zMjkgLTEzMy41dC0xMzYgLTM4Mi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YmQ7IiBob3Jpei1hZHYteD0iMTM1MCIgZD0iTTUxIDc0M3EwIDY5IDI1IDExOWgxNDFxLTIwIC00NyAtMjAgLTEwNnEwIC0xMDMgMTA2IC0xMDNoMjFsNiAzNXEzNCAyMDIgMTU5IDMxNHQzMDggMTEycTIwNyAwIDMyNy41IC0xMzIuNXQxMjAuNSAtMzU4LjV2LTEwNWgtNzU2cTYgLTE5OCA5MiAtMjk1LjV0MjU5IC05Ny41cTEwMSAwIDE4MC41IDE2dDE3Ny41IDU4di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgxIDE0M3QtMTQ0IDM5NSBxLTI2NiA0IC0yNjYgMjI1ek00OTQgNjUzaDU3M3EwIDE1NyAtNzAgMjM5LjV0LTIwNCA4Mi41dC0yMDkuNSAtODJ0LTg5LjUgLTI0MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGJlOyIgaG9yaXotYWR2LXg9IjE3MTYiIGQ9Ik02MSA5MDNxMCA3MyAyNyAxMjdoMTQ1cS0yMCAtNTAgLTIwIC0xMTBxMCAtMTAzIDExMyAtMTAzaDM0bDUgNDNxMjkgMjk4IDE5NS41IDQ2MS41dDQ0NS41IDE2My41cTI5NyAwIDQ0NSAtMTg5LjV0MTQ4IC01NTguNXYtNjloLTEwNjBxMTQgLTI2NCAxNDQuNSAtNDAwLjV0Mzc3LjUgLTEzNi41cTEwMSAwIDIwMiAxNS41dDI0MiA1OC41di0xNTZxLTE3NiAtNjIgLTQxMSAtNjd2LTM2M2gtMTY2djM2OXEtMjU4IDI5IC00MDQuNSAyMDIgdC0xNjUuNSA0NzhxLTE0MiAwIC0yMTkuNSA1OXQtNzcuNSAxNzZ6TTUzOSA4MTdoODc4cTAgMjY1IC0xMDEuNSAzOTAuNXQtMzExLjUgMTI1LjVxLTIwOSAwIC0zMjkgLTEzMy41dC0xMzYgLTM4Mi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YmY7IiBob3Jpei1hZHYteD0iMTM1MCIgZD0iTTUxIDc0M3EwIDY5IDI1IDExOWgxNDFxLTIwIC00NyAtMjAgLTEwNnEwIC0xMDMgMTA2IC0xMDNoMjFsNiAzNXEzNCAyMDIgMTU5IDMxNHQzMDggMTEycTIwNyAwIDMyNy41IC0xMzIuNXQxMjAuNSAtMzU4LjV2LTEwNWgtNzU2cTYgLTE5OCA5MiAtMjk1LjV0MjU5IC05Ny41cTEwMSAwIDE4MC41IDE2dDE3Ny41IDU4di0xNDhxLTE0MiAtNjUgLTMwNyAtNjl2LTM1OWgtMTY2djM2N3EtMTkxIDMxIC0yOTYuNSAxNjcuNXQtMTExLjUgMzYwLjUgcS0yNjYgNCAtMjY2IDIyNXpNNDk0IDY1M2g1NzNxMCAxNTcgLTcwIDIzOS41dC0yMDQgODIuNXQtMjA5LjUgLTgydC04OS41IC0yNDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRjMDsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YzE7IiBob3Jpei1hZHYteD0iMTcyOSIgZD0iTTIgMGw1OTYgNzUybC01NzUgNzEwaDE5MGw1NjkgLTcwOHY3MDhoMTY0di03MDhsNTcwIDcwOGgxOTBsLTU3NiAtNzA4bDU5NCAtNzU0aC0xOTZsLTU4MiA3NDF2LTc0MWgtMTY0djc0MWwtNTgxIC03NDFoLTE5OXpNNDkxIDE4ODhoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGMyOyIgaG9yaXotYWR2LXg9IjE1MDciIGQ9Ik00IDBsNDk2IDU2M2wtNDU3IDUzMWgxODJsNDUxIC01MzF2NTMxaDE1M3YtNTMxbDQ1MyA1MzFoMTgybC00NTggLTUzMWw0OTcgLTU2M2gtMTkybC00ODIgNTU1di01NTVoLTE1M3Y1NTVsLTQ4MSAtNTU1aC0xOTF6TTM4MyAxNTQ4aDE1NnE5IC0xMDQgNTQuNSAtMTQ1dDE1OC41IC00MXExMDMgMCAxNTIuNSA0NHQ2MC41IDE0MmgxNTdxLTEyIC0xNTggLTEwMSAtMjMyLjV0LTI3MyAtNzQuNXEtMTg1IDAgLTI3MCA3MS41dC05NSAyMzUuNXogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRjMzsiIGhvcml6LWFkdi14PSIxNDExIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTcwOGw2NDkgNzA4aDIwNWwtNjM1IC02ODRsMjYgMnEzMzUgMCA1MTIgLTE2Mi41dDE3NyAtNDY3LjVxMCAtMzE0IC0xNDcuNSAtNDg4dC00MTQuNSAtMTc0cS04MiAwIC0xNDQgMTB0LTEzMiAzOXYxNTJxMTIyIC00OSAyNzQgLTQ5cTE4NyAwIDI4NyAxMzQuNXQxMDAgMzc1LjVxMCAyMzIgLTEzOC41IDM1OC41dC0zODMuNSAxMjYuNXEtMTQwIDAgLTIzNSAtMzF2LTYwNGgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YzQ7IiBob3Jpei1hZHYteD0iMTEyNCIgZD0iTTE3NiAwdjEwOTZoMTY0di01MThsNDgzIDUxOGgxODNsLTQ1NyAtNDgycTI1NiAtNCAzODIgLTE0NnQxMjYgLTQwOXEwIC0xNzcgLTU1IC0zMDN0LTE1NyAtMTkydC0yMzUgLTY2cS0xMzYgMCAtMjMxIDYwdjE0NXE0NiAtMjUgMTAwIC00NHQxMjUgLTE5cTEzNSAwIDIxMSAxMDguNXQ3NiAzMDguNXEwIDIxMSAtOTMuNSAzMTQuNXQtMjgzLjUgMTAzLjVxLTgyIDAgLTE3NCAtMjR2LTQ1MWgtMTY0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0YzU7IiBob3Jpei1hZHYteD0iMTQ0NiIgZD0iTTAgMnYxNDNxNTQgLTI2IDExMyAtMjZxNTMgMCA5Mi41IDQzLjV0NzAgMTUxdDc3IDQwOHQxMDIuNSA3NDAuNWg3ODZ2LTEzMDhoMTg0bC0xNDMgLTUzNWgtMTk3bDE1NiAzODFoLTE3MHYxMzExaC00NzVsLTMxIC0yNDBxLTYxIC00NzkgLTEwNy41IC03MDAuNXQtMTIyLjUgLTMwOC41dC0yMDIgLTg1cS03NCAwIC0xMzMgMjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRjNjsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTYgLTJ2MTI3cTIyIC02IDUwIC02cTExMyAwIDE4MS41IDIzNi41dDEwMi41IDczOC41aDY0MXYtOTUxaDE3NmwtMTI5IC01MjBoLTE3MmwxMjUgMzc3aC0xNjZ2OTUyaC0zMzFxLTI4IC0zNjAgLTc1IC01NjZ0LTEyMyAtMzAydC0xOTQgLTk2cS01OCAwIC04NiAxMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGM3OyIgaG9yaXotYWR2LXg9IjE0ODkiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtNjIyaDc3MHY2MjJoMTcwdi0xMzEycTAgLTMxOCAtMTQxIC00OTB0LTQwMiAtMTcycS04MiAwIC0xNDMgOS41dC0xMzggMzkuNXYxNTBxMTIzIC00OSAyNTggLTQ5cTM5NiAwIDM5NiA1MDN2NTQ3aC03NzB2LTY4OGgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Yzg7IiBob3Jpei1hZHYteD0iMTI2MiIgZD0iTTE3NiAwdjEwOTZoMTY2di00NTloNjEydjQ1OWgxNjh2LTEwNDVxMCAtMjY4IC0xMDMuNSAtNDEwLjV0LTI5NS41IC0xNDIuNXEtMTMyIDAgLTIyNSA1OHYxNDlxMTExIC02MSAyMTMgLTYxcTEyNSAwIDE4NCA5OXQ1OSAzMDZ2NDQ1aC02MTJ2LTQ5NGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Yzk7IiBob3Jpei1hZHYteD0iMTUyNiIgZD0iTTIwMSAwdjE0NjJoMTcwdi02MjJoNzcwdjYyMmgxNzB2LTEzMDhoMTg0bC0xNDUgLTUzNWgtMTk3bDE1OCAzODFoLTE3MHY2ODhoLTc3MHYtNjg4aC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRjYTsiIGhvcml6LWFkdi14PSIxMzM3IiBkPSJNMTc2IDB2MTA5NGgxNjZ2LTQ1N2g2MTR2NDU3aDE2NnYtOTUxaDE3NmwtMTI5IC01MjBoLTE3MmwxMjUgMzc3aC0xNjZ2NDk0aC02MTR2LTQ5NGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Y2I7IiBob3Jpei1hZHYteD0iMTQyMyIgZD0iTTE3MCA4ODF2NTgxaDE3MHYtNTYxcTAgLTEyMSA2My41IC0xNzl0MjA2LjUgLTU4cTk3IDAgMTg1LjUgMTQuNXQyNTcuNSA2OS41djcxNGgxNzB2LTE0NjJoLTE3MHYtMzgxaC0xNjJ2NTM1aDE2MnY0NTBxLTE0OSAtNTMgLTI0OCAtNzIuNXQtMjA1IC0xOS41cS0yMDcgMCAtMzE4LjUgOTV0LTExMS41IDI3NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGNjOyIgaG9yaXotYWR2LXg9IjEyNDUiIGQ9Ik0xNTYgNjg0djQxMmgxNjZ2LTQwMHEwIC0xOTIgMjE5IC0xOTJxOTEgMCAxNzQgMjh0MTg4IDk1djQ2OWgxNjZ2LTEwOTZoLTE0OXYtMzc5aC0xNjZ2NTIyaDE0OXYzNTNxLTEwNSAtNzIgLTE5NC41IC0xMDEuNXQtMjAyLjUgLTI5LjVxLTE2NCAwIC0yNTcgODZ0LTkzIDIzM3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGNkOyIgaG9yaXotYWR2LXg9IjE4NTEiIGQ9Ik0yMDEgMHYxNDYyaDI1Nmw0NjUgLTEyMDZoOGw0NjUgMTIwNmgyNTR2LTEzMDhoMTg0bC0xNDMgLTUzNWgtMTk5bDE1OCAzODFoLTE3MHY5NDJxMCAxMzIgMTQgMzUyaC04bC01MDAgLTEyOTRoLTEzN2wtNDk2IDEyOTZoLThsNyAtMTI3cTcgLTE5MiA3IC0yMzl2LTkzMGgtMTU3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0Y2U7IiBob3Jpei1hZHYteD0iMTUwNyIgZD0iTTE3NiAwdjEwOTRoMjAzbDI5NyAtNzIzcTQ1IC0xMTAgNjkgLTIxMWwzMSA5M2w0MyAxMThsMjk3IDcyM2gyMTF2LTk1MWgxNzZsLTEyOSAtNTIwaC0xNzJsMTI1IDM3N2gtMTQ3djkwNWwtMjAgLTU4bC01OCAtMTUzbC0yODMgLTY5NGgtMTM5bC0yODMgNjk2cS01MyAxMzQgLTczIDIwOXYtOTA1aC0xNDh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRjZjsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZDA7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMjc2IDE4ODZoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZDE7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMTk1IDE1NDhoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZDI7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMzcwIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTc1MSAxNzMxcTAgNTIgMjYuNSA3NSB0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRkMzsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yOTYgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjc3IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzUgcTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGQ0OyIgaG9yaXotYWR2LXg9IjE3ODgiIGQ9Ik0tMiAwbDY5OCAxNDYyaDk2OXYtMTUxaC01ODB2LTQ3MWg1NDF2LTE1MGgtNTQxdi01MzhoNTgwdi0xNTJoLTc1MHY0NjVoLTUxNGwtMjI3IC00NjVoLTE3NnpNNDY5IDYxOGg0NDZ2NjkzaC0xMTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRkNTsiIGhvcml6LWFkdi14PSIxNzU3IiBkPSJNOTQgMzAzcTAgMTYxIDEyNCAyNTAuNXQzNzggOTcuNWwxODQgNnY2OHEwIDEyOSAtNTggMTkwLjV0LTE3NyA2MS41cS0xNDQgMCAtMzA3IC04NGwtNTIgMTI3cTc0IDQxIDE3My41IDY3LjV0MTk3LjUgMjYuNXExMzAgMCAyMTIuNSAtNDMuNXQxMjMuNSAtMTM4LjVxNTMgODggMTM4LjUgMTM2dDE5NS41IDQ4cTE5MiAwIDMwOCAtMTMzLjV0MTE2IC0zNTUuNXYtMTA3aC03MDFxOCAtMzk1IDMyMiAtMzk1cTkxIDAgMTY5LjUgMTcuNSB0MTYyLjUgNTYuNXYtMTQ4cS04NiAtMzggLTE2MC41IC01NC41dC0xNzUuNSAtMTYuNXEtMjg5IDAgLTQxNCAyMzNxLTgxIC0xMjcgLTE3OS41IC0xODB0LTIzMi41IC01M3EtMTYzIDAgLTI1NS41IDg1dC05Mi41IDIzOHpNMjY4IDMwMXEwIC05NSA1My41IC0xMzkuNXQxNDEuNSAtNDQuNXExNDUgMCAyMjkgODQuNXQ4NCAyMzguNXY5OWwtMTU4IC03cS0xODYgLTggLTI2OCAtNjIuNXQtODIgLTE2OC41ek05NTQgNjUzaDUxOSBxMCAxNTYgLTY0IDI0MHQtMTg0IDg0cS0xMjEgMCAtMTkwLjUgLTgzdC04MC41IC0yNDF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRkNjsiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUxaC02NDV2LTQ3MWg2MDZ2LTE1MGgtNjA2di01MzhoNjQ1di0xNTJoLTgxNXpNMjM1IDE4ODZoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZDc7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMjMxIDE1NDhoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZDg7IiBob3Jpei1hZHYteD0iMTQ5NSIgZD0iTTExNyA3Mjd2NzBoMTA3MXEtMTcgMjY2IC0xNDguNSA0MDF0LTM3NS41IDEzNXEtMjI3IDAgLTQ1MyAtNzZ2MTU4cTExNSAzOCAyMjAgNTR0MjM5IDE2cTMzMSAwIDUxNC41IC0xOTkuNXQxODMuNSAtNTU2LjVxMCAtMzUwIC0xNzMgLTU0OS41dC00ODIgLTE5OS41cS01OTYgMCAtNTk2IDc0N3pNMjk5IDY0N3EwIC0yNjQgMTAyIC0zOTB0MzEyIC0xMjZ0MzM0LjUgMTM0LjV0MTQwLjUgMzgxLjVoLTg4OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGQ5OyIgaG9yaXotYWR2LXg9IjExNDUiIGQ9Ik0xMDIgNDczdjEwNWg3NTZxLTUgMjA0IC05NC41IDI5Ny41dC0yNTUuNSA5My41cS05OCAwIC0xODAuNSAtMTYuNXQtMTc3LjUgLTU3LjV2MTQ3cTg5IDQwIDE3MCA1N3QxODYgMTdxMjQ1IDAgMzg0LjUgLTE1MHQxMzkuNSAtNDExcTAgLTI2NCAtMTI5LjUgLTQxOS41dC0zNDcuNSAtMTU1LjVxLTIwOCAwIC0zMjkuNSAxMzR0LTEyMS41IDM1OXpNMjgxIDQ0MHEwIC0xNTcgNzAuNSAtMjM5dDIwMy41IC04MnQyMTAgODIuNXQ4OSAyMzguNSBoLTU3M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGRhOyIgaG9yaXotYWR2LXg9IjE0OTUiIGQ9Ik0xMTcgNzI3djcwaDEwNzFxLTE3IDI2NiAtMTQ4LjUgNDAxdC0zNzUuNSAxMzVxLTIyNyAwIC00NTMgLTc2djE1OHExMTUgMzggMjIwIDU0dDIzOSAxNnEzMzEgMCA1MTQuNSAtMTk5LjV0MTgzLjUgLTU1Ni41cTAgLTM1MCAtMTczIC01NDkuNXQtNDgyIC0xOTkuNXEtNTk2IDAgLTU5NiA3NDd6TTI5OSA2NDdxMCAtMjY0IDEwMiAtMzkwdDMxMiAtMTI2dDMzNC41IDEzNC41dDE0MC41IDM4MS41aC04ODl6TTQ1NiAxNzMxIHEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNODM3IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZGI7IiBob3Jpei1hZHYteD0iMTE0NSIgZD0iTTEwMiA0NzN2MTA1aDc1NnEtNSAyMDQgLTk0LjUgMjk3LjV0LTI1NS41IDkzLjVxLTk4IDAgLTE4MC41IC0xNi41dC0xNzcuNSAtNTcuNXYxNDdxODkgNDAgMTcwIDU3dDE4NiAxN3EyNDUgMCAzODQuNSAtMTUwdDEzOS41IC00MTFxMCAtMjY0IC0xMjkuNSAtNDE5LjV0LTM0Ny41IC0xNTUuNXEtMjA4IDAgLTMyOS41IDEzNHQtMTIxLjUgMzU5ek0yODEgNDQwcTAgLTE1NyA3MC41IC0yMzl0MjAzLjUgLTgydDIxMCA4Mi41dDg5IDIzOC41IGgtNTczek0yODcgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjY4IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZGM7IiBob3Jpei1hZHYteD0iMTcyOSIgZD0iTTIgMGw1OTYgNzUybC01NzUgNzEwaDE5MGw1NjkgLTcwOHY3MDhoMTY0di03MDhsNTcwIDcwOGgxOTBsLTU3NiAtNzA4bDU5NCAtNzU0aC0xOTZsLTU4MiA3NDF2LTc0MWgtMTY0djc0MWwtNTgxIC03NDFoLTE5OXpNNTgxIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTk2MiAxNzMxIHEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRkZDsiIGhvcml6LWFkdi14PSIxNTA3IiBkPSJNNCAwbDQ5NiA1NjNsLTQ1NyA1MzFoMTgybDQ1MSAtNTMxdjUzMWgxNTN2LTUzMWw0NTMgNTMxaDE4MmwtNDU4IC01MzFsNDk3IC01NjNoLTE5MmwtNDgyIDU1NXYtNTU1aC0xNTN2NTU1bC00ODEgLTU1NWgtMTkxek00NzEgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNODUyIDEzOTMgcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGRlOyIgaG9yaXotYWR2LXg9IjExOTAiIGQ9Ik03NCA1OXYxNThxOTYgLTQ2IDIwNy41IC03MXQyMTQuNSAtMjVxMTk4IDAgMjk5LjUgNzV0MTAxLjUgMjE2cTAgMTM0IC0xMTIuNSAyMDN0LTMzNS41IDY5aC0yMTh2MTQzaDIwOXEyMDUgMCAzMTcuNSA3My41dDExMi41IDIwNS41cTAgMTA3IC04MSAxNzF0LTIxOCA2NHEtMTEwIDAgLTE5OSAtMjV0LTIwNiAtOTlsLTg0IDExNHExMDEgNzUgMjI2LjUgMTEzLjV0MjYwLjUgMzguNXEyMjUgMCAzNTIuNSAtOTguNXQxMjcuNSAtMjY0LjUgcTAgLTE0NCAtOTEuNSAtMjM0dC0yNTIuNSAtMTE0di04cTE4MyAtMjUgMjc3LjUgLTExNXQ5NC41IC0yMzVxMCAtMjA1IC0xNTMgLTMxOS41dC00MzIgLTExNC41cS0yNTUgMCAtNDE4IDc5ek0yOTYgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjc3IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjMgdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGRmOyIgaG9yaXotYWR2LXg9Ijk4OSIgZD0iTTY4IDUxdjE1MnExODMgLTg2IDM3MCAtODZxMTQ0IDAgMjE3LjUgNDkuNXQ3My41IDE0Mi41cTAgMTkxIC0zMTEgMTkxaC0xNTJ2MTQxaDExOXEzMTEgMCAzMTEgMTcycTAgMTYyIC0yNTIgMTYycS03NyAwIC0xNDAgLTE0dC0xNjUgLTU2bC01OSAxMzVxMTcwIDc2IDM3MSA3NnExODkgMCAyOTggLTc3LjV0MTA5IC0yMTEuNXEwIC0xODQgLTIwNSAtMjQxdi04cTEyNiAtMzcgMTg0IC0xMDUuNXQ1OCAtMTcxLjUgcTAgLTE1MiAtMTIyLjUgLTIzNi41dC0zMzguNSAtODQuNXEtMjM3IDAgLTM2NiA3MXpNMjAxIDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTU4MiAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjUgdC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRlMDsiIGhvcml6LWFkdi14PSIxMTk0IiBkPSJNNzQgNTl2MTU4cTk2IC00NiAyMDcgLTcxdDIxNyAtMjVxMTk5IDAgMzAwIDc2LjV0MTAxIDIyMC41cTAgMTM0IC0xMTIuNSAyMDN0LTMzNS41IDY5aC0xNDB2MTQxbDQ5NCA0NzhoLTY5MHYxNTNoOTAzdi0xMzlsLTUxMCAtNDkycTI3OSAtOSA0MjUgLTExNC41dDE0NiAtMjk4LjVxMCAtMjA2IC0xNTMuNSAtMzIydC00MzEuNSAtMTE2cS0yNTcgMCAtNDIwIDc5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTE7IiBob3Jpei1hZHYteD0iMTAwMSIgZD0iTTI3IC0yNjhxMTgzIC04NiAzODMgLTg2cTE2MSAwIDI1OS41IDk1dDk4LjUgMjU1cTAgMTY0IC0xMDcgMjQ5dC0zMDkgODVoLTEyMXYxMTRsNDUzIDUxMGgtNjMxdjE0Mmg4MjR2LTEyM2wtNDQ5IC01MTBxMTQ5IC03IDI2NCAtNjR0MTc4LjUgLTE1OHQ2My41IC0yMzdxMCAtMjIyIC0xNDggLTM1OXQtMzg3IC0xMzdxLTIzNCAwIC0zNzIgNzB2MTU0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTI7IiBob3Jpei1hZHYteD0iMTU2MSIgZD0iTTIwMyAwdjE0NjJoMTU5di04MTNxMCAtMjI1IC0xNCAtNDA3aDhsODIwIDEyMjBoMTg2di0xNDYyaC0xNjB2ODA1cTAgMjAxIDE3IDQyMmgtOWwtODIxIC0xMjI3aC0xODZ6TTQ4MSAxNTc5djEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTM7IiBob3Jpei1hZHYteD0iMTI5OCIgZD0iTTE3NiAwdjEwOTZoMTU2di02OTVsLTcgLTE4MmwtMyAtNTdsNTkzIDkzNGgyMDd2LTEwOTZoLTE1NXY2NzBsMyAxMzJsNSAxMzBsLTU5MiAtOTMyaC0yMDd6TTM1MCAxMjQxdjEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTQ7IiBob3Jpei1hZHYteD0iMTU2MSIgZD0iTTIwMyAwdjE0NjJoMTU5di04MTNxMCAtMjI1IC0xNCAtNDA3aDhsODIwIDEyMjBoMTg2di0xNDYyaC0xNjB2ODA1cTAgMjAxIDE3IDQyMmgtOWwtODIxIC0xMjI3aC0xODZ6TTQ5OSAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek04ODAgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yMyB0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTU7IiBob3Jpei1hZHYteD0iMTI5OCIgZD0iTTE3NiAwdjEwOTZoMTU2di02OTVsLTcgLTE4MmwtMyAtNTdsNTkzIDkzNGgyMDd2LTEwOTZoLTE1NXY2NzBsMyAxMzJsNSAxMzBsLTU5MiAtOTMyaC0yMDd6TTM3MCAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek03NTEgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NSBxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTY7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTUxOCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek04OTkgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRlNzsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek0zMzggMTM5MyBxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTcxOSAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGU4OyIgaG9yaXotYWR2LXg9IjE1OTciIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDcgNjcwcTEzIC0yNjcgMTM3LjUgLTQwNHQzNTQuNSAtMTM3cTIyOSAwIDM1Mi41IDEzNi41dDEzNi41IDQwNC41aC05ODF6TTMwNyA4MTloOTc5cS0xNyAyNTQgLTEzOSAzODR0LTM0NiAxMzB0LTM0OS41IC0xMjkgdC0xNDQuNSAtMzg1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZTk7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA0OTRxOSAtMTg2IDg5IC0yODAuNXQyNDIgLTk0LjVxMTU4IDAgMjQwIDkydDkyIDI4M2gtNjYzek0yODkgNjM1aDY1OXEtMTUgMTY4IC05NS41IDI1NHQtMjM2LjUgODZ0LTIzNSAtODYuNXQtOTIgLTI1My41eiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGVhOyIgaG9yaXotYWR2LXg9IjE1OTciIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDcgNjcwcTEzIC0yNjcgMTM3LjUgLTQwNHQzNTQuNSAtMTM3cTIyOSAwIDM1Mi41IDEzNi41dDEzNi41IDQwNC41aC05ODF6TTMwNyA4MTloOTc5cS0xNyAyNTQgLTEzOSAzODR0LTM0NiAxMzB0LTM0OS41IC0xMjkgdC0xNDQuNSAtMzg1ek01MTggMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNODk5IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZWI7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA0OTRxOSAtMTg2IDg5IC0yODAuNXQyNDIgLTk0LjVxMTU4IDAgMjQwIDkydDkyIDI4M2gtNjYzek0yODkgNjM1aDY1OXEtMTUgMTY4IC05NS41IDI1NHQtMjM2LjUgODZ0LTIzNSAtODYuNXQtOTIgLTI1My41eiBNMzM2IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTcxNyAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGVjOyIgaG9yaXotYWR2LXg9IjEyOTAiIGQ9Ik02MSAxMzk5cTE3MiA4NCA0MDggODRxMjE3IDAgMzczLjUgLTg4dDIzNy41IC0yNTF0ODEgLTM4NHEwIC0zNzYgLTE4MiAtNTc4dC01MjQgLTIwMnEtMjI3IDAgLTM4MyA1N3YxNDlxODMgLTIxIDE2OSAtMzh0MTg1IC0xN3EyNzEgMCA0MDkgMTQ0LjV0MTQ2IDQxNi41aC03MTl2MTUyaDcxN3EtMjIgMjI5IC0xNTcuNSAzNTh0LTM1NC41IDEyOXEtMTcyIDAgLTMzNCAtNzZ6TTI5MCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzIHEzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNjcxIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZWQ7IiBob3Jpei1hZHYteD0iMTAwOCIgZD0iTTU3IDM3djE0N3E2MCAtMjMgMTMwIC00MXQxNjEgLTE4cTE3NCAwIDI2OC41IDkzdDEwNC41IDI3OGgtNTU1djE0MWg1NTNxLTE2IDE3MiAtMTAwLjUgMjUydC0yNDUuNSA4MHEtMTAzIDAgLTI1NCAtNTRsLTQ3IDE0MHE1NSAyNiAxMzcgNDMuNXQxNjIgMTcuNXEyNTYgMCAzODkgLTE0Ni41dDEzMyAtNDIyLjVxMCAtMjY5IC0xNDQuNSAtNDE4dC00MDYuNSAtMTQ5cS0xNjcgMCAtMjg1IDU3ek0xOTUgMTM5M3EwIDUyIDI2LjUgNzUgdDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTU3NiAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGVlOyIgaG9yaXotYWR2LXg9IjEyNzIiIGQ9Ik0yNyAxNDYyaDE4OGw0MzIgLTgzMXEyNSAtNDkgMzkgLTk2aDhxMjggODQgMzkgMTA2bDM1OSA4MjFoMTgwbC00NjcgLTEwNDZxLTg0IC0xODcgLTE1MS41IC0yNzJ0LTE1MiAtMTI0LjV0LTIwOC41IC0zOS41cS0xMTEgMCAtMTk1IDMwdjE2NnE5MyAtNDMgMTg5IC00M3ExMTAgMCAxNzYuNSA1MC41dDEzMi41IDE4OS41ek0zNDggMTU3OXYxMzdoNjAwdi0xMzdoLTYwMHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGVmOyIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6TTIxOCAxMjQxdjEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZjA7IiBob3Jpei1hZHYteD0iMTI3MiIgZD0iTTI3IDE0NjJoMTg4bDQzMiAtODMxcTI1IC00OSAzOSAtOTZoOHEyOCA4NCAzOSAxMDZsMzU5IDgyMWgxODBsLTQ2NyAtMTA0NnEtODQgLTE4NyAtMTUxLjUgLTI3MnQtMTUyIC0xMjQuNXQtMjA4LjUgLTM5LjVxLTExMSAwIC0xOTUgMzB2MTY2cTkzIC00MyAxODkgLTQzcTExMCAwIDE3Ni41IDUwLjV0MTMyLjUgMTg5LjV6TTM2OCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzUgcTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzQ5IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZjE7IiBob3Jpei1hZHYteD0iMTAzMiIgZD0iTTIgMTA5NmgxNzhsMjQwIC02MjVxNzkgLTIxNCA5OCAtMzA5aDhxMTMgNTEgNTQuNSAxNzQuNXQyNzEuNSA3NTkuNWgxNzhsLTQ3MSAtMTI0OHEtNzAgLTE4NSAtMTYzLjUgLTI2Mi41dC0yMjkuNSAtNzcuNXEtNzYgMCAtMTUwIDE3djEzM3E1NSAtMTIgMTIzIC0xMnExNzEgMCAyNDQgMTkybDYxIDE1NnpNMjM2IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNSB0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek02MTcgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRmMjsiIGhvcml6LWFkdi14PSIxMjcyIiBkPSJNMjcgMTQ2MmgxODhsNDMyIC04MzFxMjUgLTQ5IDM5IC05Nmg4cTI4IDg0IDM5IDEwNmwzNTkgODIxaDE4MGwtNDY3IC0xMDQ2cS04NCAtMTg3IC0xNTEuNSAtMjcydC0xNTIgLTEyNC41dC0yMDguNSAtMzkuNXEtMTExIDAgLTE5NSAzMHYxNjZxOTMgLTQzIDE4OSAtNDNxMTEwIDAgMTc2LjUgNTAuNXQxMzIuNSAxODkuNXpNMzcyIDE1Nzl2MjVxMzYgNDggOTEgMTQxdDg2IDE2MmgxODZ2LTIxcS0zNyAtNjMgLTEyMi41IC0xNjEgdC0xNDMuNSAtMTQ2aC05N3pNNzI5IDE1Nzl2MjVxNDkgNjggOTkuNSAxNTYuNXQ3Ni41IDE0Ni41aDE4NnYtMjFxLTM3IC02MyAtMTIyLjUgLTE2MXQtMTQzLjUgLTE0NmgtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRmMzsiIGhvcml6LWFkdi14PSIxMDMyIiBkPSJNMiAxMDk2aDE3OGwyNDAgLTYyNXE3OSAtMjE0IDk4IC0zMDloOHExMyA1MSA1NC41IDE3NC41dDI3MS41IDc1OS41aDE3OGwtNDcxIC0xMjQ4cS03MCAtMTg1IC0xNjMuNSAtMjYyLjV0LTIyOS41IC03Ny41cS03NiAwIC0xNTAgMTd2MTMzcTU1IC0xMiAxMjMgLTEycTE3MSAwIDI0NCAxOTJsNjEgMTU2ek0yMzUgMTI0MXYyNXEzNiA0OCA5MSAxNDF0ODYgMTYyaDE4NnYtMjFxLTM3IC02MyAtMTIyLjUgLTE2MXQtMTQzLjUgLTE0NmgtOTd6IE01OTIgMTI0MXYyNXE0OSA2OCA5OS41IDE1Ni41dDc2LjUgMTQ2LjVoMTg2di0yMXEtMzcgLTYzIC0xMjIuNSAtMTYxdC0xNDMuNSAtMTQ2aC05NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGY0OyIgaG9yaXotYWR2LXg9IjE0MjMiIGQ9Ik0xNzAgODgxdjU4MWgxNzB2LTU2MXEwIC0xMjEgNjMuNSAtMTc5dDIwNi41IC01OHE5NyAwIDE4NS41IDE0LjV0MjU3LjUgNjkuNXY3MTRoMTcwdi0xNDYyaC0xNzB2NjA0cS0xNDkgLTUzIC0yNDggLTcyLjV0LTIwNSAtMTkuNXEtMjA3IDAgLTMxOC41IDk1dC0xMTEuNSAyNzR6TTQxNSAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjUgcS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXpNNzk2IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZjU7IiBob3Jpei1hZHYteD0iMTI0NSIgZD0iTTE1NiA2ODR2NDEyaDE2NnYtNDAwcTAgLTE5MiAyMTkgLTE5MnE5MSAwIDE3NCAyOHQxODggOTV2NDY5aDE2NnYtMTA5NmgtMTY2djQ5NnEtMTA1IC03MiAtMTk0LjUgLTEwMS41dC0yMDIuNSAtMjkuNXEtMTY0IDAgLTI1NyA4NnQtOTMgMjMzek0zMzIgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NS41IC0yNC41cS0zNyAwIC02My41IDI0LjV0LTI2LjUgNzQuNXogTTcxMyAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGY2OyIgaG9yaXotYWR2LXg9IjEwNzkiIGQ9Ik0yMDEgMHYxNDYyaDgzMXYtMTUzaC02NjF2LTExNTVoMTYxdi01MzVoLTE2MXYzODFoLTE3MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGY3OyIgaG9yaXotYWR2LXg9Ijg3NyIgZD0iTTE3NiAwdjEwOTRoNjU4di0xNDBoLTQ5MnYtODExaDE1MHYtNTIwaC0xNjZ2Mzc3aC0xNTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRmODsiIGhvcml6LWFkdi14PSIxNzQ3IiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyNGgyMzlxMjYxIDAgMzk4IC0xMDIuNXQxMzcgLTMwOS41cTAgLTIwNiAtMTI5LjUgLTMxNnQtMzc4LjUgLTExMGgtNDM2ek0zNzEgMTQ1aDI0N3ExODEgMCAyNjYgNzAuNXQ4NSAyMTAuNXEwIDEzNyAtODkuNSAxOTguNXQtMjg5LjUgNjEuNWgtMjE5di01NDF6TTEzNzYgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek01OTIgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3EzOCAwIDY1LjUgLTIzdDI3LjUgLTc1IHEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTk3MyAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGY5OyIgaG9yaXotYWR2LXg9IjE1NzciIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtNDUzaDI5OXEyMDkgMCAzMDkuNSAtNzcuNXQxMDAuNSAtMjMxLjVxMCAtMTY1IC0xMDYuNSAtMjQ5LjV0LTMxMy41IC04NC41aC00NTV6TTM0MiAxMzloMjgxcTI2NCAwIDI2NCAxODVxMCA5MiAtNjEgMTM0dC0yMDggNDJoLTI3NnYtMzYxek0xMjM1IDB2MTA5NmgxNjZ2LTEwOTZoLTE2NnpNNTA2IDEzOTNxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NSBxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek04ODcgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRmYTsiIGhvcml6LWFkdi14PSIxMDc5IiBkPSJNNDcgNjQ5djE1MGgxNTR2NjYzaDgzMXYtMTUzaC02NjF2LTUxMGg0MjR2LTE1MGgtNDI0di02NDloLTE3MHY2NDloLTE1NHpNMTcyIC0yMzFxNDEgLTE5IDEwMiAtMTlxOTQgMCA5NCAxMDB2MzA0aDE0OHYtMjg5cTAgLTI2MCAtMjI4IC0yNjBxLTU2IDAgLTExNiAyNHYxNDB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDRmYjsiIGhvcml6LWFkdi14PSI4NzciIGQ9Ik0xOCA0ODV2MTI3aDE1OHY0ODRoNjU4di0xNDBoLTQ5MnYtMzQ0aDM0NnYtMTI3aC0zNDZ2LTQ4NWgtMTY2djQ4NWgtMTU4ek0xNDIgLTIzMXE0MSAtMTkgMTAyIC0xOXE5NCAwIDk0IDEwMHYyOTNoMTQ4di0yNzhxMCAtMjYwIC0yMjggLTI2MHEtNTYgMCAtMTE2IDI0djE0MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGZjOyIgaG9yaXotYWR2LXg9IjEyNzIiIGQ9Ik04IDBsNDg2IDc2NGwtNDUzIDY5OGgxODhsMzYzIC01NzlsMzY2IDU3OWgxODFsLTQ1MyAtNjkybDQ4OCAtNzcwaC0xOTNsLTM5MyA2NDNsLTQwMCAtNjQzaC0xODB6TTg4MSAtMjMxcTQxIC0xOSAxMDIgLTE5cTk0IDAgOTQgMTAwdjMwNGgxNDh2LTI4OXEwIC0yNjAgLTIyOCAtMjYwcS01NiAwIC0xMTYgMjR2MTQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZmQ7IiBob3Jpei1hZHYteD0iMTEwNiIgZD0iTTM5IDBsNDAxIDU2MWwtMzgxIDUzNWgxODlsMjg5IC00MjBsMjg4IDQyMGgxODdsLTM4MSAtNTM1bDQwMSAtNTYxaC0xODhsLTMwNyA0NDRsLTMxMCAtNDQ0aC0xODh6TTczMiAtMjMxcTQxIC0xOSAxMDIgLTE5cTk0IDAgOTQgMTAwdjI5M2gxNDh2LTI3OHEwIC0yNjAgLTIyOCAtMjYwcS01NiAwIC0xMTYgMjR2MTQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g0ZmU7IiBob3Jpei1hZHYteD0iMTE4MiIgZD0iTTYgMGw0NDcgNzAwaC0zMjZ2MTUyaDMwN2wtMzkzIDYxMGgxODhsMzYzIC01ODFsMzY0IDU4MWgxODNsLTQwMCAtNjEwaDMxNnYtMTUyaC0zMjZsNDQ1IC03MDBoLTE5M2wtMzkzIDY0M2wtNDAwIC02NDNoLTE4MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NGZmOyIgaG9yaXotYWR2LXg9IjEwNzMiIGQ9Ik0zOSAwbDM1OCA1MDJoLTI4MHYxMjloMjc0bC0zMzIgNDY1aDE4OWwyODkgLTQyMGwyODggNDIwaDE4N2wtMzM0IC00NjVoMjgwdi0xMjloLTI4NmwzNjAgLTUwMmgtMTg4bC0zMDcgNDQ0bC0zMTAgLTQ0NGgtMTg4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MDA7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTEzMSA0MjBxMCAyMTIgMTQ2IDMxNXQ0MzQgMTAzaDE5OHY2MjRoMTcwdi0xNDYyaC00MTNxLTI2NyAwIC00MDEgMTA2LjV0LTEzNCAzMTMuNXpNMzA3IDQyMnEwIC0xNDMgOTEgLTIwOXQyOTQgLTY2aDIxN3Y1NDFoLTE4NnEtMjIyIDAgLTMxOSAtNjJ0LTk3IC0yMDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwMTsiIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTE1IDU0NXEwIDI3MSAxMjAgNDIxdDMzNCAxNTBxMjIzIDAgMzQyIC0xNjJoMTNsLTcgNzlsLTQgNzd2NDQ2aDE2NnYtMTU1NmgtMTM1bC0yMiAxNDdoLTlxLTExNSAtMTY3IC0zNDQgLTE2N3EtMjE1IDAgLTMzNC41IDE0N3QtMTE5LjUgNDE4ek0yODcgNTQzcTAgLTIxMCA3NyAtMzE3dDIyNiAtMTA3cTE3MCAwIDI0Ni41IDkyLjV0NzYuNSAyOTguNXYzNXEwIDIzMyAtNzcuNSAzMzIuNXQtMjQ3LjUgOTkuNSBxLTE0NiAwIC0yMjMuNSAtMTEzLjV0LTc3LjUgLTMyMC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MDI7IiBob3Jpei1hZHYteD0iMTg0MSIgZD0iTTEzMSAzOTlxMCAyMTcgMTQ5IDMyOHQ0MzkgMTExaDE0NXY2MjRoMTcwdi0xMDk3cTAgLTIzNiAyMzAgLTIzNnExMDAgMCAxNjAuNSA2MS41dDYwLjUgMTcxLjV2NDg2aDE3MHYtNDg4cTAgLTE3NCAtMTAzLjUgLTI3N3QtMjg3LjUgLTEwM3EtMTE4IDAgLTE5Ny41IDQxdC0xMzAuNSAxMzFxLTExMyAtMTcwIC0zNDYgLTE3MHEtMjI2IDAgLTM0Mi41IDEwNC41dC0xMTYuNSAzMTIuNXpNMzA3IDM5N3EwIC0yNjggMjg5IC0yNjggcTEyNyAwIDE5Ny41IDU5LjV0NzAuNSAxNzEuNXYzMjZoLTE1MXEtMjEyIDAgLTMwOSAtNjkuNXQtOTcgLTIxOS41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MDM7IiBob3Jpei1hZHYteD0iMTgzNSIgZD0iTTExNSA1NDVxMCAyNjggMTE1LjUgNDE5LjV0MzIyLjUgMTUxLjVxMTA2IDAgMTg1LjUgLTM4LjV0MTQyLjUgLTEyMy41aDEycS0yIDE3IC02IDczdC00IDgzdjQ0NmgxNjZ2LTExNDBxMCAtMTYwIDU0LjUgLTIyOC41dDE3NC41IC02OC41cTExOCAwIDE3MS41IDY2dDUzLjUgMjAydjMxM2gxNjh2LTMyM3EwIC0yMDAgLTEwMCAtMjk4LjV0LTI4OSAtOTguNXEtMTI5IDAgLTIwOCA0NS41dC0xMjIgMTU4LjVoLTggcS03NSAtMTEzIC0xNjcuNSAtMTU4LjV0LTIyMS41IC00NS41cS0yMDggMCAtMzI0IDE0OC41dC0xMTYgNDE2LjV6TTI4NyA1NDNxMCAtMjE0IDY5LjUgLTMxOXQyMTguNSAtMTA1cTE2MiAwIDIzNSA5Mi41dDczIDI5OC41djM1cTAgMjMxIC03NCAzMzEuNXQtMjM2IDEwMC41cS0yODYgMCAtMjg2IC00MzR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwNDsiIGhvcml6LWFkdi14PSIxODUxIiBkPSJNNzggMTMzMXE5MyA3MiAyMTYgMTEydDI1MyA0MHEyMTQgMCAzMzYuNSAtOTh0MTIyLjUgLTI2NXEwIC0xNDEgLTg5IC0yMzIuNXQtMjQ1IC0xMTcuNXYtOHEzNTQgLTUxIDM2MCAtMzU0cTIgLTE1MCA1NiAtMjEzLjV0MTc4IC02My41cTExOSAwIDE3NSA2MC41dDU2IDE5NS41djQ2MWgxNjh2LTQ3MXEwIC0xOTggLTEwNSAtMjk3LjV0LTI5NCAtOTkuNXEtMjAyIDAgLTMwNiAxMDQuNXQtMTA2IDMwNC41cS0yIDE1MCAtMTA0LjUgMjIyLjUgdC0zMTkuNSA3Mi41aC0yMDF2MTQzaDE5M3ExOTIgMCAyOTguNSA3My41dDEwNi41IDIwNS41cTAgMTA4IC03NyAxNzEuNXQtMjA1IDYzLjVxLTEwMyAwIC0xOTEuNSAtMjcuNXQtMTkxLjUgLTk2LjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwNTsiIGhvcml6LWFkdi14PSIxNjQyIiBkPSJNODAgMTA0MHE4NSA0MCAxNjYuNSA1OHQxODUuNSAxOHExODQgMCAyODkuNSAtNzcuNXQxMDUuNSAtMjExLjVxMCAtMTg0IC0xOTIgLTI0MXYtOHE5OSAtMjAgMTYwLjUgLTgxdDY2LjUgLTE2N3E5IC0yMTEgMjI4IC0yMTFxMjIxIDAgMjIxIDI2OHYzMTNoMTY2di0zMjNxMCAtMjAyIC05My41IC0yOTkuNXQtMjg5LjUgLTk3LjVxLTM3OCAwIC0zOTQgMzMzcS01IDk5IC03NS41IDE0M3QtMjE4LjUgNDRoLTE0MHYxNDFoMTExIHEyODkgMCAyODkgMTcycTAgMTYyIC0yNDIgMTYycS03NSAwIC0xNDIuNSAtMTh0LTE0NC41IC01MnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NTA2OyIgaG9yaXotYWR2LXg9IjEyODAiIGQ9Ik03OCAxMzMxcTk3IDc0IDIyNCAxMTN0MjU5IDM5cTIyMCAwIDM0Ni41IC05OHQxMjYuNSAtMjY1cTAgLTE0MCAtOTQuNSAtMjMxLjV0LTI1Ny41IC0xMTYuNXYtOHExODQgLTI1IDI4MS41IC0xMTQuNXQ5Ny41IC0yMzcuNXYtMjU4aDE3MnYtNTM1aC0xNjJ2MzgxaC0xNzJ2NDEycTAgMTMzIC0xMTQuNSAyMDIuNXQtMzQwLjUgNjkuNWgtMjE3djE0M2gyMDlxMjA1IDAgMzE3LjUgNzMuNXQxMTIuNSAyMDUuNXEwIDEwNyAtODIgMTcxIHQtMjE3IDY0cS0xMDUgMCAtMjAyLjUgLTI5dC0yMDIuNSAtOTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwNzsiIGhvcml6LWFkdi14PSIxMDcxIiBkPSJNODAgMTA0MHExNjEgNzQgMzY0IDc0cTE5MSAwIDI5Ny41IC03N3QxMDYuNSAtMjEycTAgLTE4MiAtMjAzIC0yMzl2LTExcTEyNiAtMzcgMTgyIC0xMDUuNXQ1NiAtMTcwLjV2LTE1NmgxNTd2LTUyMGgtMTY2djM3N2gtMTQ5djMwMXEwIDE5OSAtMzA5IDE5OWgtMTUwdjE0MWgxMTdxMzEzIDAgMzEzIDE3MnEwIDgyIC02Ni41IDEyMnQtMTg1LjUgNDBxLTE1MyAwIC0zMDMgLTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MDg7IiBob3Jpei1hZHYteD0iMjAwOSIgZD0iTTAgMnYxNDNxNTAgLTI2IDExMyAtMjZxNDkgMCA4MSAzMXQ1NCA4M3Q1MCAxODF0NjUgMzczLjV0OTIgNjc0LjVoNzUxdi0xMDczcTAgLTEzNyA1NS41IC0xOTcuNXQxNzAuNSAtNjAuNXExMTIgMCAxNjguNSA2MC41dDU2LjUgMTk1LjV2NDYxaDE2OHYtNDcxcTAgLTE5MyAtMTAyLjUgLTI5NXQtMjkwLjUgLTEwMnEtMTk2IDAgLTI5NiAxMDJ0LTEwMCAyOTl2OTMwaC00NDBsLTMxIC0yNDBxLTQzIC0zMzggLTgxIC01NjB0LTc5LjUgLTMyNyB0LTEwNi41IC0xNTZ0LTE2NSAtNTFxLTY5IDAgLTEzMyAyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NTA5OyIgaG9yaXotYWR2LXg9IjE3NDMiIGQ9Ik0xNiAtMnYxMjdxMjIgLTYgNTAgLTZxMTEzIDAgMTgxLjUgMjM2LjV0MTAyLjUgNzM4LjVoNjI1di03MDdxMCAtMTM3IDUyIC0yMDIuNXQxNzEgLTY1LjVxMjEzIDAgMjEzIDI2NnYzMTVoMTY2di0zMjNxMCAtMjAyIC05My41IC0yOTkuNXQtMjgzLjUgLTk3LjVxLTE4OCAwIC0yODkuNSA5OHQtMTAxLjUgMzAxdjU3M2gtMzE1cS0yOCAtMzYwIC03NSAtNTY2dC0xMjMgLTMwMnQtMTk0IC05NnEtNTggMCAtODYgMTB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwYTsiIGhvcml6LWFkdi14PSIyMDczIiBkPSJNMjAxIDB2MTQ2MmgxNzB2LTYyMmg3Mjl2NjIyaDE3MHYtMTA3M3EwIC0xMzcgNTUgLTE5Ny41dDE3MCAtNjAuNXExMTIgMCAxNjguNSA2MC41dDU2LjUgMTk1LjV2NDYxaDE2NnYtNDcxcTAgLTE5MSAtMTAwIC0yOTR0LTI5MSAtMTAzcS0xOTUgMCAtMjk1IDEwMS41dC0xMDAgMjk5LjV2MzA3aC03Mjl2LTY4OGgtMTcweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MGI7IiBob3Jpei1hZHYteD0iMTg3MCIgZD0iTTE3NiAwdjEwOTZoMTY2di00NTloNTkydjQ1OWgxNjZ2LTcwN3EwIC0xMzcgNTMgLTIwMy41dDE3MiAtNjYuNXEyMTMgMCAyMTMgMjY4djMxM2gxNjZ2LTMyM3EwIC0yMDIgLTkzLjUgLTI5OS41dC0yODUuNSAtOTcuNXEtMTg2IDAgLTI4OC41IDk5dC0xMDIuNSAzMDB2MTE1aC01OTJ2LTQ5NGgtMTY2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MGM7IiBob3Jpei1hZHYteD0iMTU0OCIgZD0iTTEyNSA3MzNxMCAyMjkgODkuNSAzOTl0MjYwIDI2MC41dDQwNC41IDkwLjVxMTIwIDAgMjM4LjUgLTI0LjV0MjAxLjUgLTYzLjVsLTY2IC0xNDhxLTkwIDM4IC0xOTcgNjF0LTE5NCAyM3EtMjY3IDAgLTQxMiAtMTU3LjV0LTE0NSAtNDQyLjV0MTMzLjUgLTQ0My41dDM4MC41IC0xNTguNXE0MzYgMCA0MzYgNDcxaC0zODV2MTUyaDU2NHYtODZxMCAtMzUxIC0xNTQgLTUxOC41dC00NjUgLTE2Ny41cS0zMjUgMCAtNTA3LjUgMjAwLjUgdC0xODIuNSA1NTIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NTBkOyIgaG9yaXotYWR2LXg9IjEzMTEiIGQ9Ik0xMTUgNTQ3cTAgMjcwIDE2MS41IDQxOS41dDQ1MC41IDE0OS41cTIxMiAwIDM4NyAtODBsLTU5IC0xMzFxLTE2OCA3NCAtMzM0IDc0cS0yMDUgMCAtMzE5LjUgLTExMXQtMTE0LjUgLTMyMXEwIC0yMDcgMTAyIC0zMTguNXQyOTkgLTExMS41cTE2OSAwIDI1Ni41IDgwdDg3LjUgMjM3aC0zNDJ2MTQxaDUxMHYtNjdxMCAtNTI4IC01MTQgLTUyOHEtMjc0IDAgLTQyMi41IDE0Ny41dC0xNDguNSA0MTkuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4NTBlOyIgaG9yaXotYWR2LXg9IjE0NTQiIGQ9Ik0xNiAxMzA5djE1M2gxMDg0di0xNTNoLTQ2NXYtOTIwcTAgLTEzNyA1OS41IC0xOTguNXQxNzMuNSAtNjEuNXEyMzIgMCAyMzIgMjU2djQ2M2gxNjh2LTQ3MXEwIC0xOTIgLTEwNS41IC0yOTQuNXQtMjk0LjUgLTEwMi41cS0xOTggMCAtMzAwLjUgMTAzdC0xMDIuNSAyOTh2OTI4aC00NDl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUwZjsiIGhvcml6LWFkdi14PSIxMzI1IiBkPSJNNDEgOTU0djE0MGg4NTZ2LTE0MGgtMzQ2di01NjdxMCAtMTM3IDU0LjUgLTIwMi41dDE3Mi41IC02NS41cTIxNSAwIDIxNSAyNjB2MzIxaDE2NnYtMzIzcTAgLTIwMiAtOTQuNSAtMjk5LjV0LTI4Ni41IC05Ny41dC0yOTIuNSAxMDEuNXQtMTAwLjUgMjk3LjV2NTc1aC0zNDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUxMDsiIGhvcml6LWFkdi14PSIxMTk0IiBkPSJNMTExIDM5N3EwIDE1MSAxMDMuNSAyNDd0MjkxLjUgMTE4djhxLTE3MCAyNSAtMjYwIDExNHQtOTAgMjMycTAgMTY5IDEzMiAyNjh0MzU3IDk5cTI1OCAwIDQ2NyAtMTQ0bC05NCAtMTIwcS0xMDUgNjggLTE5NS41IDk0dC0xOTEuNSAyNnEtMTQwIDAgLTIxOS41IC02MS41dC03OS41IC0xNzUuNXEwIC0xMjggMTA0LjUgLTIwMS41dDMwNC41IC03My41aDIxN3YtMTQxaC0yMTNxLTIyMiAwIC0zMzggLTcxdC0xMTYgLTIwOSBxMCAtMTQyIDEwMSAtMjEyLjV0Mjg0IC03MC41cTIzMyAwIDQzMiA5MnYtMTU4cS0xNzUgLTc3IC00MzYgLTc3cS0yNjggMCAtNDE0LjUgMTEwdC0xNDYuNSAzMDd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUxMTsiIGhvcml6LWFkdi14PSI5NzMiIGQ9Ik05MCAyOTdxMCA5OCA1NSAxNjMuNXQxODUgMTA2LjV2MTFxLTk4IDI4IC0xNTEuNSA5MS41dC01My41IDE1NS41cTAgMTMzIDExMiAyMTJ0MzA0IDc5cTk3IDAgMTc5LjUgLTE2LjV0MTgyLjUgLTYxLjVsLTYzIC0xMzNxLTk0IDQyIC0xNTkgNTZ0LTE0NCAxNHEtMjUwIDAgLTI1MCAtMTYycTAgLTE3MiAzMTcgLTE3MmgxMTF2LTE0MWgtMTQ4cS0zMTEgMCAtMzExIC0xOTVxMCAtOTAgNzMuNSAtMTM5dDIxOS41IC00OXE4NCAwIDE2NyAxOS41IHQxODMgNjYuNXYtMTQ4cS0xMzcgLTc1IC0zNTggLTc1cS0yMTAgMCAtMzMwLjUgODQuNXQtMTIwLjUgMjMyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDUxMjsiIGhvcml6LWFkdi14PSIxNDM0IiBkPSJNMCAydjE0M3E1NCAtMjYgMTEzIC0yNnE1MyAwIDkyLjUgNDMuNXQ3MCAxNTF0NzcgNDA4dDEwMi41IDc0MC41aDc4NnYtMTQ2MmgtMTcwdjEzMTFoLTQ3NWwtMzEgLTI0MHEtNjEgLTQ3OSAtMTA3LjUgLTcwMC41dC0xMjIuNSAtMzA4LjV0LTIwMiAtODVxLTc0IDAgLTEzMyAyNXpNMTA0MyAtMjMxcTQxIC0xOSAxMDIgLTE5cTk0IDAgOTQgMTAwdjMwNGgxNDh2LTI4OXEwIC0yNjAgLTIyOCAtMjYwcS01NiAwIC0xMTYgMjR2MTQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3g1MTM7IiBob3Jpei1hZHYteD0iMTE2OSIgZD0iTTE2IC0ydjEyM3EyMiAtNiA1MCAtNnExMTUgMCAxODMgMjQzdDEwMyA3MzhoNjQxdi0xMDk2aC0xNjh2OTU0aC0zMjlxLTI3IC0zNTYgLTc1IC01NjV0LTEyNC41IC0zMDZ0LTE5NC41IC05N3EtNTQgMCAtODYgMTJ6TTc5NSAtMjMxcTQxIC0xOSAxMDIgLTE5cTk0IDAgOTQgMTAwdjI5M2gxNDh2LTI3OHEwIC0yNjAgLTIyOCAtMjYwcS01NiAwIC0xMTYgMjR2MTQweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZTAwOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTQyNiAtMzQwcTAgOTggNjAgMTU2LjV0MTYxIDU4LjV0MTY0IC01OXQ2MyAtMTU0cTAgLTk3IC02Mi41IC0xNTd0LTE2NC41IC02MHEtMTAxIDAgLTE2MSA1OC41dC02MCAxNTYuNXpNNTMwIC0zNDBxMCAtNTYgMzAgLTg2LjUgdDg3IC0zMC41cTUzIDAgODUgMzAuNXQzMiA4Ni41cTAgNTcgLTMzIDg3dC04NCAzMHQtODQgLTMwdC0zMyAtODd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlMDE7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMzE2IC0zNDBxMCA5OCA2MCAxNTYuNXQxNjEgNTguNXQxNjQgLTU5dDYzIC0xNTRxMCAtOTcgLTYyLjUgLTE1N3QtMTY0LjUgLTYwcS0xMDEgMCAtMTYxIDU4LjV0LTYwIDE1Ni41ek00MjAgLTM0MHEwIC01NiAzMCAtODYuNXQ4NyAtMzAuNXE1MyAwIDg1IDMwLjV0MzIgODYuNXEwIDU3IC0zMyA4NyB0LTg0IDMwdC04NCAtMzB0LTMzIC04N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWUzZTsiIGhvcml6LWFkdi14PSIxODQ5IiBkPSJNMjAxIDB2MTQ2MmgyNTZsNDYzIC0xMjA2aDhsNDY3IDEyMDZoMjU0di0xNDYyaC0xNzB2OTQycTAgMTYyIDE0IDM1MmgtOGwtNTAwIC0xMjk0aC0xMzdsLTQ5NiAxMjk2aC04cTE0IC0xNTQgMTQgLTM2NnYtOTMwaC0xNTd6TTgwNSAxNTgxdjI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZTNmOyIgaG9yaXotYWR2LXg9IjE5MDUiIGQ9Ik0xNzYgMHYxMDk2aDEzNWwyNyAtMTUwaDhxNDcgODAgMTMyLjUgMTI1dDE5MS41IDQ1cTI1NyAwIDMzNiAtMTg2aDhxNDkgODYgMTQyIDEzNnQyMTIgNTBxMTg2IDAgMjc4LjUgLTk1LjV0OTIuNSAtMzA1LjV2LTcxNWgtMTY2djcxM3EwIDEzMSAtNTYgMTk2LjV0LTE3NCA2NS41cS0xNTUgMCAtMjI5IC04OXQtNzQgLTI3NHYtNjEyaC0xNjZ2NzEzcTAgMTMxIC01NiAxOTYuNXQtMTc1IDY1LjVxLTE1NiAwIC0yMjguNSAtOTMuNSB0LTcyLjUgLTMwNi41di01NzVoLTE2NnpNODU0IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlODA7IiBob3Jpei1hZHYteD0iMTg5NiIgZD0iTTI3IDE0NjJoMTgwbDIzMSAtOTAzcTQ4IC0xOTAgNzAgLTM0NHEyNyAxODMgODAgMzU4bDI2MiA4ODloMTgwbDI3NSAtODk3cTQ4IC0xNTUgODEgLTM1MHExOSAxNDIgNzIgMzQ2bDIzMCA5MDFoMTgwbC0zOTEgLTE0NjJoLTE2OGwtMjk1IDk3OXEtMjEgNjUgLTQ3IDE2NHQtMjcgMTE5cS0yMiAtMTMyIC03MCAtMjg5bC0yODYgLTk3M2gtMTY4ek02NzIgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwIHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlODE7IiBob3Jpei1hZHYteD0iMTU5MyIgZD0iTTIzIDEwOTZoMTc0cTEwNiAtNDEzIDE2MS41IC02Mjl0NjMuNSAtMjkxaDhxMTEgNTcgMzUuNSAxNDcuNXQ0Mi41IDE0My41bDIwMSA2MjloMTgwbDE5NiAtNjI5cTU2IC0xNzIgNzYgLTI4OWg4cTQgMzYgMjEuNSAxMTF0MjA4LjUgODA3aDE3MmwtMzAzIC0xMDk2aC0xOTdsLTIwMSA2NDNxLTE5IDU5IC03MSAyNjhoLThxLTQwIC0xNzUgLTcwIC0yNzBsLTIwNyAtNjQxaC0xOTJ6TTUwOCAxNTQ4djIxaDIwM3EzMiAtNjkgODkgLTE1OS41IHQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWU4MjsiIGhvcml6LWFkdi14PSIxODk2IiBkPSJNMjcgMTQ2MmgxODBsMjMxIC05MDNxNDggLTE5MCA3MCAtMzQ0cTI3IDE4MyA4MCAzNThsMjYyIDg4OWgxODBsMjc1IC04OTdxNDggLTE1NSA4MSAtMzUwcTE5IDE0MiA3MiAzNDZsMjMwIDkwMWgxODBsLTM5MSAtMTQ2MmgtMTY4bC0yOTUgOTc5cS0yMSA2NSAtNDcgMTY0dC0yNyAxMTlxLTIyIC0xMzIgLTcwIC0yODlsLTI4NiAtOTczaC0xNjh6TTgyNSAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxIHEtNDQgLTY1IC0xMzEgLTE2MHQtMTUxIC0xNDdoLTExMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWU4MzsiIGhvcml6LWFkdi14PSIxNTkzIiBkPSJNMjMgMTA5NmgxNzRxMTA2IC00MTMgMTYxLjUgLTYyOXQ2My41IC0yOTFoOHExMSA1NyAzNS41IDE0Ny41dDQyLjUgMTQzLjVsMjAxIDYyOWgxODBsMTk2IC02MjlxNTYgLTE3MiA3NiAtMjg5aDhxNCAzNiAyMS41IDExMXQyMDguNSA4MDdoMTcybC0zMDMgLTEwOTZoLTE5N2wtMjAxIDY0M3EtMTkgNTkgLTcxIDI2OGgtOHEtNDAgLTE3NSAtNzAgLTI3MGwtMjA3IC02NDFoLTE5MnpNNjc2IDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwIHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZTg0OyIgaG9yaXotYWR2LXg9IjE4OTYiIGQ9Ik0yNyAxNDYyaDE4MGwyMzEgLTkwM3E0OCAtMTkwIDcwIC0zNDRxMjcgMTgzIDgwIDM1OGwyNjIgODg5aDE4MGwyNzUgLTg5N3E0OCAtMTU1IDgxIC0zNTBxMTkgMTQyIDcyIDM0NmwyMzAgOTAxaDE4MGwtMzkxIC0xNDYyaC0xNjhsLTI5NSA5NzlxLTIxIDY1IC00NyAxNjR0LTI3IDExOXEtMjIgLTEzMiAtNzAgLTI4OWwtMjg2IC05NzNoLTE2OHpNNjY1IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NSBxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek0xMDQ2IDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjN0NjQuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZTg1OyIgaG9yaXotYWR2LXg9IjE1OTMiIGQ9Ik0yMyAxMDk2aDE3NHExMDYgLTQxMyAxNjEuNSAtNjI5dDYzLjUgLTI5MWg4cTExIDU3IDM1LjUgMTQ3LjV0NDIuNSAxNDMuNWwyMDEgNjI5aDE4MGwxOTYgLTYyOXE1NiAtMTcyIDc2IC0yODloOHE0IDM2IDIxLjUgMTExdDIwOC41IDgwN2gxNzJsLTMwMyAtMTA5NmgtMTk3bC0yMDEgNjQzcS0xOSA1OSAtNzEgMjY4aC04cS00MCAtMTc1IC03MCAtMjcwbC0yMDcgLTY0MWgtMTkyek01MTYgMTM5M3EwIDUyIDI2LjUgNzV0NjMuNSAyMyBxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTg5NyAxMzkzcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41dC02NC41IC0yNC41dC02My41IDI0LjV0LTI2LjUgNzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhMDsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek01NDggLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYTE7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNNDM2IC0yNDJxMCA1NyAyOS41IDg0dDcxLjUgMjdxNDAgMCA2OSAtMjd0MjkgLTg0cTAgLTU1IC0yOSAtODIuNXQtNjkgLTI3LjVxLTQyIDAgLTcxLjUgMjcuNXQtMjkuNSA4Mi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWEyOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTUxNiAxOTA3djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02IHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhMzsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek00MzAgMTU2OXYxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhNDsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0zNDIgMTU3OXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TTg3MiAxNzc0djI0cTczIDkxIDEyNyAyMDNoMTcyIHYtMjFxLTgzIC0xMTAgLTIwMyAtMjA2aC05NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhNTsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yNjAgMTI0MXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TTc5MCAxNDM2djI0cTczIDkxIDEyNyAyMDNoMTcydi0yMXEtODMgLTExMCAtMjAzIC0yMDZoLTk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWE2OyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTExOSAxOTgwdjIxaDE3MnE1MiAtMTA4IDEyNyAtMjA1di0yMmgtOTVxLTEyMCA5NCAtMjA0IDIwNnpNMzM4IDE1Nzl2MjNsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NnE2NiAtOTQgMjE3IC0yNjB2LTIzaC05NCBxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYTc7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNNDUgMTY0MnYyMWgxNzJxNTIgLTEwOCAxMjcgLTIwNXYtMjJoLTk1cS0xMjAgOTQgLTIwNCAyMDZ6TTI2NCAxMjQxdjIzbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYTg7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMzMwIDE1Nzl2MjVsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NnE2NiAtOTQgMjE3IC0yNjB2LTI1aC05NHEtMTEyIDc1IC0yMTEgMTY2cS0xMTQgLTEwMSAtMjExIC0xNjZoLTk0ek04MzMgMjAzNnY4MHEyNSA2IDgwIDYgcTE5NSAwIDE5NSAtMTM5cTAgLTEwMyAtMTI3IC0xMzJsLTYgLTgxaC04MGwtMTAgMTMxcTU3IDkgODguNSAyNXQzMS41IDU0cTAgMzcgLTI4LjUgNDkuNXQtNzEuNSAxMi41cS00NiAwIC03MiAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhOTsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yNjkgMTI0MXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TTc3MiAxNjk4djgwcTI1IDYgODAgNnExOTUgMCAxOTUgLTEzOXEwIC0xMDMgLTEyNyAtMTMybC02IC04MWgtODAgbC0xMCAxMzFxNTcgOSA4OC41IDI1dDMxLjUgNTRxMCAzNyAtMjguNSA0OS41dC03MS41IDEyLjVxLTQ2IDAgLTcyIC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWFhOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTMzMyAxOTI1cTEzIDEwNiA2My41IDE2Mi41dDEyNS41IDU2LjVxMzcgMCA3My41IC0xNXQ3MCAtMzN0NjQuNSAtMzN0NTggLTE1cTQwIDAgNjEgMjQuNXQzMyA3My41aDkwcS0xMSAtMTA0IC02MC41IC0xNjEuNXQtMTI1LjUgLTU3LjUgcS0zNyAwIC03Mi41IDE1dC02OSAzMy41dC02NSAzMy41dC01OS41IDE1cS00MCAwIC02MSAtMjQuNXQtMzUgLTc0LjVoLTkxek0zNDYgMTU3OXYyM2w1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWFiOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTI0OSAxNTg3cTEzIDEwNiA2My41IDE2Mi41dDEyNS41IDU2LjVxMzcgMCA3My41IC0xNXQ3MCAtMzN0NjQuNSAtMzN0NTggLTE1cTQwIDAgNjEgMjQuNXQzMyA3My41aDkwcS0xMSAtMTA0IC02MC41IC0xNjEuNXQtMTI1LjUgLTU3LjVxLTM3IDAgLTcyLjUgMTV0LTY5IDMzLjV0LTY1IDMzLjUgdC01OS41IDE1cS00MCAwIC02MSAtMjQuNXQtMzUgLTc0LjVoLTkxek0yNjIgMTI0MXYyM2w1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWFjOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTU0OCAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXpNMzExIDE1Nzl2MjNxMTI3IDEzNiAxNzggMjAwIHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVhZDsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek00MzYgLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6TTIyNCAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNSB0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYWU7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMzU3IDE4MzloMTAycTkgLTcyIDQ3IC0xMDAuNXQxNDQgLTI4LjVxOTggMCAxNDEgMzIuNXQ1MSA5Ni41aDEwNXEtMTEgLTEyMCAtODUuNSAtMTkwdC0yMTMuNSAtNzBxLTI3NiAwIC0yOTEgMjYwek01ODYgMTgzOXYyMyBxODAgMTA0IDEyOSAyMDVoMTcydi0yMXEtODYgLTExNCAtMjA1IC0yMDdoLTk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWFmOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTI3NSAxNTAxaDEwMnE5IC03MiA0NyAtMTAwLjV0MTQ0IC0yOC41cTk4IDAgMTQxIDMyLjV0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHpNNTA0IDE1MDF2MjNxODAgMTA0IDEyOSAyMDVoMTcydi0yMXEtODYgLTExNCAtMjA1IC0yMDdoLTk2eiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWViMDsiIGhvcml6LWFkdi14PSIxMjk2IiBkPSJNMCAwbDU3OCAxNDY4aDE0M2w1NzUgLTE0NjhoLTE3NmwtMTgyIDQ2NWgtNTg2bC0xODAgLTQ2NWgtMTcyek00MTIgNjE4aDQ3M2wtMTcwIDQ1M3EtMzMgODYgLTY4IDIxMXEtMjIgLTk2IC02MyAtMjExek0zNTQgMTgzOWgxMDJxOSAtNzIgNDcgLTEwMC41dDE0NCAtMjguNXE5OCAwIDE0MSAzMi41dDUxIDk2LjVoMTA1cS0xMSAtMTIwIC04NS41IC0xOTB0LTIxMy41IC03MHEtMjc2IDAgLTI5MSAyNjB6TTM5OSAyMDQ2djIxaDE3MiBxNTIgLTEwOCAxMjcgLTIwNXYtMjNoLTk0cS0xMTkgOTMgLTIwNSAyMDd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYjE7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMjczIDE1MDFoMTAycTkgLTcyIDQ3IC0xMDAuNXQxNDQgLTI4LjVxOTggMCAxNDEgMzIuNXQ1MSA5Ni41aDEwNXEtMTEgLTEyMCAtODUuNSAtMTkwdC0yMTMuNSAtNzBxLTI3NiAwIC0yOTEgMjYwek0zMTggMTcwOHYyMWgxNzJxNTIgLTEwOCAxMjcgLTIwNXYtMjNoLTk0cS0xMTkgOTMgLTIwNSAyMDd6ICIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWIyOyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTM1NCAxODM5aDEwMnE5IC03MiA0NyAtMTAwLjV0MTQ0IC0yOC41cTk4IDAgMTQxIDMyLjV0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHpNNTE4IDIwNTB2NzhxMjIgOCA4NCA4IHExOTIgMCAxOTIgLTE0MXEwIC0xMDAgLTEyNyAtMTI5bC02IC00MWgtODJsLTEwIDkwcTU3IDkgOTAgMjV0MzMgNTN0LTI4LjUgNTB0LTcyLjUgMTNxLTM3IDAgLTczIC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWIzOyIgZD0iTTk0IDMwM3EwIDMzMiA1MzEgMzQ4bDE4NiA2djY4cTAgMTI5IC01NS41IDE5MC41dC0xNzcuNSA2MS41cS0xMzcgMCAtMzEwIC04NGwtNTEgMTI3cTgxIDQ0IDE3Ny41IDY5dDE5My41IDI1cTE5NiAwIDI5MC41IC04N3Q5NC41IC0yNzl2LTc0OGgtMTIzbC0zMyAxNTZoLThxLTgyIC0xMDMgLTE2My41IC0xMzkuNXQtMjAzLjUgLTM2LjVxLTE2MyAwIC0yNTUuNSA4NHQtOTIuNSAyMzl6TTI2OCAzMDFxMCAtOTAgNTQuNSAtMTM3IHQxNTIuNSAtNDdxMTU1IDAgMjQzLjUgODV0ODguNSAyMzh2OTlsLTE2NiAtN3EtMTk4IC03IC0yODUuNSAtNjEuNXQtODcuNSAtMTY5LjV6TTI4MSAxNTAxaDEwMnE5IC03MiA0NyAtMTAwLjV0MTQ0IC0yOC41cTk4IDAgMTQxIDMyLjV0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHpNNDQ1IDE3MTJ2NzhxMjIgOCA4NCA4cTE5MiAwIDE5MiAtMTQxcTAgLTEwMCAtMTI3IC0xMjlsLTYgLTQxIGgtODJsLTEwIDkwcTU3IDkgOTAgMjV0MzMgNTN0LTI4LjUgNTB0LTcyLjUgMTNxLTM3IDAgLTczIC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWI0OyIgaG9yaXotYWR2LXg9IjEyOTYiIGQ9Ik0wIDBsNTc4IDE0NjhoMTQzbDU3NSAtMTQ2OGgtMTc2bC0xODIgNDY1aC01ODZsLTE4MCAtNDY1aC0xNzJ6TTQxMiA2MThoNDczbC0xNzAgNDUzcS0zMyA4NiAtNjggMjExcS0yMiAtOTYgLTYzIC0yMTF6TTMzMSAxOTIzcTEzIDEwNCA2MyAxNjAuNXQxMjYgNTYuNXEzNyAwIDczLjUgLTE1dDcwIC0zM3Q2NC41IC0zM3Q1OCAtMTVxNDAgMCA2MSAyNC41dDMzIDczLjVoOTBxLTExIC0xMDMgLTYwLjUgLTE2MHQtMTI1LjUgLTU3IHEtMzcgMCAtNzIuNSAxNXQtNjkgMzN0LTY1IDMzdC01OS41IDE1cS00MCAwIC02MSAtMjR0LTM1IC03NGgtOTF6TTM0OCAxODM5aDEwMnE5IC03MiA0NyAtMTAwLjV0MTQ0IC0yOC41cTk4IDAgMTQxIDMyLjV0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWViNTsiIGQ9Ik05NCAzMDNxMCAzMzIgNTMxIDM0OGwxODYgNnY2OHEwIDEyOSAtNTUuNSAxOTAuNXQtMTc3LjUgNjEuNXEtMTM3IDAgLTMxMCAtODRsLTUxIDEyN3E4MSA0NCAxNzcuNSA2OXQxOTMuNSAyNXExOTYgMCAyOTAuNSAtODd0OTQuNSAtMjc5di03NDhoLTEyM2wtMzMgMTU2aC04cS04MiAtMTAzIC0xNjMuNSAtMTM5LjV0LTIwMy41IC0zNi41cS0xNjMgMCAtMjU1LjUgODR0LTkyLjUgMjM5ek0yNjggMzAxcTAgLTkwIDU0LjUgLTEzNyB0MTUyLjUgLTQ3cTE1NSAwIDI0My41IDg1dDg4LjUgMjM4djk5bC0xNjYgLTdxLTE5OCAtNyAtMjg1LjUgLTYxLjV0LTg3LjUgLTE2OS41ek0yNTYgMTU4NXExMyAxMDQgNjMgMTYwLjV0MTI2IDU2LjVxMzcgMCA3My41IC0xNXQ3MCAtMzN0NjQuNSAtMzN0NTggLTE1cTQwIDAgNjEgMjQuNXQzMyA3My41aDkwcS0xMSAtMTAzIC02MC41IC0xNjB0LTEyNS41IC01N3EtMzcgMCAtNzIuNSAxNXQtNjkgMzN0LTY1IDMzdC01OS41IDE1IHEtNDAgMCAtNjEgLTI0dC0zNSAtNzRoLTkxek0yNzMgMTUwMWgxMDJxOSAtNzIgNDcgLTEwMC41dDE0NCAtMjguNXE5OCAwIDE0MSAzMi41dDUxIDk2LjVoMTA1cS0xMSAtMTIwIC04NS41IC0xOTB0LTIxMy41IC03MHEtMjc2IDAgLTI5MSAyNjB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYjY7IiBob3Jpei1hZHYteD0iMTI5NiIgZD0iTTAgMGw1NzggMTQ2OGgxNDNsNTc1IC0xNDY4aC0xNzZsLTE4MiA0NjVoLTU4NmwtMTgwIC00NjVoLTE3MnpNNDEyIDYxOGg0NzNsLTE3MCA0NTNxLTMzIDg2IC02OCAyMTFxLTIyIC05NiAtNjMgLTIxMXpNMzM4IDE4NjVoMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IE01NDggLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYjc7IiBkPSJNOTQgMzAzcTAgMzMyIDUzMSAzNDhsMTg2IDZ2NjhxMCAxMjkgLTU1LjUgMTkwLjV0LTE3Ny41IDYxLjVxLTEzNyAwIC0zMTAgLTg0bC01MSAxMjdxODEgNDQgMTc3LjUgNjl0MTkzLjUgMjVxMTk2IDAgMjkwLjUgLTg3dDk0LjUgLTI3OXYtNzQ4aC0xMjNsLTMzIDE1NmgtOHEtODIgLTEwMyAtMTYzLjUgLTEzOS41dC0yMDMuNSAtMzYuNXEtMTYzIDAgLTI1NS41IDg0dC05Mi41IDIzOXpNMjY4IDMwMXEwIC05MCA1NC41IC0xMzcgdDE1Mi41IC00N3ExNTUgMCAyNDMuNSA4NXQ4OC41IDIzOHY5OWwtMTY2IC03cS0xOTggLTcgLTI4NS41IC02MS41dC04Ny41IC0xNjkuNXpNMjUzIDE1MDloMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6TTQzNiAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3IHQyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYjg7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTUwOCAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWViOTsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE00OTkgLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYmE7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTQ3MyAxOTA3djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWJiOyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTQ2NSAxNTY5djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWJjOyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0yMzYgMTU3OXExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OXEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41IHEtNTAgMCAtNzUuNSAtMzB0LTM5LjUgLTkxaC05OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWViZDsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE0yMTYgMTI0MXExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OXEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWJlOyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0zMDYgMTU3OXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TTgzNiAxNzc0djI0cTczIDkxIDEyNyAyMDNoMTcydi0yMXEtODMgLTExMCAtMjAzIC0yMDZoLTk2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWJmOyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTI4NyAxMjQxdjI1bDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yNWgtOTRxLTExMiA3NSAtMjExIDE2NnEtMTE0IC0xMDEgLTIxMSAtMTY2aC05NHpNODE3IDE0MzZ2MjRxNzMgOTEgMTI3IDIwM2gxNzJ2LTIxcS04MyAtMTEwIC0yMDMgLTIwNmgtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYzA7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTkzIDE5ODB2MjFoMTcycTUyIC0xMDggMTI3IC0yMDV2LTIyaC05NXEtMTIwIDk0IC0yMDQgMjA2ek0zMTIgMTU3OXYyM2w1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWMxOyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTc0IDE2NDJ2MjFoMTcycTUyIC0xMDggMTI3IC0yMDV2LTIyaC05NXEtMTIwIDk0IC0yMDQgMjA2ek0yOTMgMTI0MXYyM2w1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWMyOyIgZD0iTTIwMSAwdjE0NjJoODE1di0xNTFoLTY0NXYtNDcxaDYwNnYtMTUwaC02MDZ2LTUzOGg2NDV2LTE1MmgtODE1ek0zMDMgMTU3OXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TTgwNiAyMDM2djgwcTI1IDYgODAgNnExOTUgMCAxOTUgLTEzOXEwIC0xMDMgLTEyNyAtMTMybC02IC04MWgtODBsLTEwIDEzMSBxNTcgOSA4OC41IDI1dDMxLjUgNTRxMCAzNyAtMjguNSA0OS41dC03MS41IDEyLjVxLTQ2IDAgLTcyIC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWMzOyIgaG9yaXotYWR2LXg9IjExNDkiIGQ9Ik0xMTUgNTM5cTAgMjY1IDEzMC41IDQyMXQzNTAuNSAxNTZxMjA2IDAgMzI2IC0xMzUuNXQxMjAgLTM1Ny41di0xMDVoLTc1NXE1IC0xOTMgOTcuNSAtMjkzdDI2MC41IC0xMDBxMTc3IDAgMzUwIDc0di0xNDhxLTg4IC0zOCAtMTY2LjUgLTU0LjV0LTE4OS41IC0xNi41cS0yNDMgMCAtMzgzLjUgMTQ4dC0xNDAuNSA0MTF6TTI5MSA2NTNoNTczcTAgMTU3IC03MCAyNDAuNXQtMjAwIDgzLjVxLTEzMiAwIC0yMTAuNSAtODZ0LTkyLjUgLTIzOHogTTI3NSAxMjQxdjI1bDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yNWgtOTRxLTExMiA3NSAtMjExIDE2NnEtMTE0IC0xMDEgLTIxMSAtMTY2aC05NHpNNzc4IDE2OTh2ODBxMjUgNiA4MCA2cTE5NSAwIDE5NSAtMTM5cTAgLTEwMyAtMTI3IC0xMzJsLTYgLTgxaC04MGwtMTAgMTMxcTU3IDkgODguNSAyNXQzMS41IDU0cTAgMzcgLTI4LjUgNDkuNXQtNzEuNSAxMi41cS00NiAwIC03MiAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjNDsiIGQ9Ik0yMDEgMHYxNDYyaDgxNXYtMTUxaC02NDV2LTQ3MWg2MDZ2LTE1MGgtNjA2di01MzhoNjQ1di0xNTJoLTgxNXpNMjg4IDE5MjVxMTMgMTA2IDYzLjUgMTYyLjV0MTI1LjUgNTYuNXEzNyAwIDczLjUgLTE1dDcwIC0zM3Q2NC41IC0zM3Q1OCAtMTVxNDAgMCA2MSAyNC41dDMzIDczLjVoOTBxLTExIC0xMDQgLTYwLjUgLTE2MS41dC0xMjUuNSAtNTcuNXEtMzcgMCAtNzIuNSAxNXQtNjkgMzMuNXQtNjUgMzMuNXQtNTkuNSAxNSBxLTQwIDAgLTYxIC0yNC41dC0zNSAtNzQuNWgtOTF6TTMwMSAxNTc5djIzbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYzU7IiBob3Jpei1hZHYteD0iMTE0OSIgZD0iTTExNSA1MzlxMCAyNjUgMTMwLjUgNDIxdDM1MC41IDE1NnEyMDYgMCAzMjYgLTEzNS41dDEyMCAtMzU3LjV2LTEwNWgtNzU1cTUgLTE5MyA5Ny41IC0yOTN0MjYwLjUgLTEwMHExNzcgMCAzNTAgNzR2LTE0OHEtODggLTM4IC0xNjYuNSAtNTQuNXQtMTg5LjUgLTE2LjVxLTI0MyAwIC0zODMuNSAxNDh0LTE0MC41IDQxMXpNMjkxIDY1M2g1NzNxMCAxNTcgLTcwIDI0MC41dC0yMDAgODMuNXEtMTMyIDAgLTIxMC41IC04NnQtOTIuNSAtMjM4eiBNMjY2IDE1ODdxMTMgMTA2IDYzLjUgMTYyLjV0MTI1LjUgNTYuNXEzNyAwIDczLjUgLTE1dDcwIC0zM3Q2NC41IC0zM3Q1OCAtMTVxNDAgMCA2MSAyNC41dDMzIDczLjVoOTBxLTExIC0xMDQgLTYwLjUgLTE2MS41dC0xMjUuNSAtNTcuNXEtMzcgMCAtNzIuNSAxNXQtNjkgMzMuNXQtNjUgMzMuNXQtNTkuNSAxNXEtNDAgMCAtNjEgLTI0LjV0LTM1IC03NC41aC05MXpNMjc5IDEyNDF2MjNsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NiBxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlYzY7IiBkPSJNMjAxIDB2MTQ2Mmg4MTV2LTE1MWgtNjQ1di00NzFoNjA2di0xNTBoLTYwNnYtNTM4aDY0NXYtMTUyaC04MTV6TTUwNSAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXpNMjcwIDE1Nzl2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOSBxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjNzsiIGhvcml6LWFkdi14PSIxMTQ5IiBkPSJNMTE1IDUzOXEwIDI2NSAxMzAuNSA0MjF0MzUwLjUgMTU2cTIwNiAwIDMyNiAtMTM1LjV0MTIwIC0zNTcuNXYtMTA1aC03NTVxNSAtMTkzIDk3LjUgLTI5M3QyNjAuNSAtMTAwcTE3NyAwIDM1MCA3NHYtMTQ4cS04OCAtMzggLTE2Ni41IC01NC41dC0xODkuNSAtMTYuNXEtMjQzIDAgLTM4My41IDE0OHQtMTQwLjUgNDExek0yOTEgNjUzaDU3M3EwIDE1NyAtNzAgMjQwLjV0LTIwMCA4My41cS0xMzIgMCAtMjEwLjUgLTg2dC05Mi41IC0yMzh6IE00OTEgLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6TTI1MyAxMjQxdjIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjODsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek0xNTMgMTkwN3YxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjOTsiIGhvcml6LWFkdi14PSI1MTgiIGQ9Ik0xNzYgMHYxMDk2aDE2NnYtMTA5NmgtMTY2ek0xMjMgMTU2OXYxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjYTsiIGhvcml6LWFkdi14PSI1NzEiIGQ9Ik0yMDEgMHYxNDYyaDE3MHYtMTQ2MmgtMTcwek0xODQgLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlY2I7IiBob3Jpei1hZHYteD0iNTE4IiBkPSJNMTYyIDEzOTNxMCA1NyAyOCA4My41dDcwIDI2LjVxNDAgMCA2OSAtMjd0MjkgLTgzdC0yOSAtODMuNXQtNjkgLTI3LjVxLTQyIDAgLTcwIDI3LjV0LTI4IDgzLjV6TTE3NiAwdjEwOTZoMTY2di0xMDk2aC0xNjZ6TTE1NyAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVjYzsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNjk4IC0yNDJxMCA1NyAyOS41IDg0dDcxLjUgMjdxNDAgMCA2OSAtMjd0MjkgLTg0cTAgLTU1IC0yOSAtODIuNXQtNjkgLTI3LjVxLTQyIDAgLTcxLjUgMjcuNXQtMjkuNSA4Mi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWNkOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNTQ5cTAgLTIxMCA4NCAtMzIwdDI0NyAtMTEwdDI0Ny41IDEwOS41dDg0LjUgMzIwLjVxMCAyMDkgLTg0LjUgMzE3LjV0LTI0OS41IDEwOC41cS0xNjMgMCAtMjQ2IC0xMDd0LTgzIC0zMTl6TTUxNiAtMjQyIHEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlY2U7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTY2MyAxOTA3djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWNmOyIgaG9yaXotYWR2LXg9IjEyMzciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjMwIDAgMzY1LjUgLTE1M3QxMzUuNSAtNDE0cTAgLTI2OCAtMTM1IC00MTguNXQtMzczIC0xNTAuNXEtMTQ3IDAgLTI2MSA2OXQtMTc2IDE5OHQtNjIgMzAyek0yODcgNTQ5cTAgLTIxMCA4NCAtMzIwdDI0NyAtMTEwdDI0Ny41IDEwOS41dDg0LjUgMzIwLjVxMCAyMDkgLTg0LjUgMzE3LjV0LTI0OS41IDEwOC41cS0xNjMgMCAtMjQ2IC0xMDd0LTgzIC0zMTl6TTQ4MSAxNTY5IHYxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVkMDsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNDk0IDE1Nzl2MjVsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NnE2NiAtOTQgMjE3IC0yNjB2LTI1aC05NHEtMTEyIDc1IC0yMTEgMTY2cS0xMTQgLTEwMSAtMjExIC0xNjZoLTk0ek0xMDI0IDE3NzR2MjRxNzMgOTEgMTI3IDIwM2gxNzJ2LTIxcS04MyAtMTEwIC0yMDMgLTIwNmgtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZDE7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXpNMzEyIDEyNDF2MjUgbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yNWgtOTRxLTExMiA3NSAtMjExIDE2NnEtMTE0IC0xMDEgLTIxMSAtMTY2aC05NHpNODQyIDE0MzZ2MjRxNzMgOTEgMTI3IDIwM2gxNzJ2LTIxcS04MyAtMTEwIC0yMDMgLTIwNmgtOTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZDI7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTI3OSAxOTgwdjIxaDE3MnE1MiAtMTA4IDEyNyAtMjA1di0yMmgtOTVxLTEyMCA5NCAtMjA0IDIwNnpNNDk4IDE1Nzl2MjNsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NnE2NiAtOTQgMjE3IC0yNjB2LTIzaC05NHEtOTcgNjUgLTIxMSAxNjZxLTEwNiAtOTYgLTIxMSAtMTY2aC05NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVkMzsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek05NyAxNjQydjIxIGgxNzJxNTIgLTEwOCAxMjcgLTIwNXYtMjJoLTk1cS0xMjAgOTQgLTIwNCAyMDZ6TTMxNiAxMjQxdjIzbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZDQ7IiBob3Jpei1hZHYteD0iMTU5NSIgZD0iTTEyNSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMwNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TTQ5MiAxNTc5djI1bDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yNWgtOTRxLTExMiA3NSAtMjExIDE2NnEtMTE0IC0xMDEgLTIxMSAtMTY2aC05NHpNOTk1IDIwMzZ2ODBxMjUgNiA4MCA2cTE5NSAwIDE5NSAtMTM5cTAgLTEwMyAtMTI3IC0xMzJsLTYgLTgxaC04MGwtMTAgMTMxcTU3IDkgODguNSAyNXQzMS41IDU0cTAgMzcgLTI4LjUgNDkuNXQtNzEuNSAxMi41cS00NiAwIC03MiAtNnogIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZDU7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXpNMzEyIDEyNDF2MjUgbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yNWgtOTRxLTExMiA3NSAtMjExIDE2NnEtMTE0IC0xMDEgLTIxMSAtMTY2aC05NHpNODE1IDE2OTh2ODBxMjUgNiA4MCA2cTE5NSAwIDE5NSAtMTM5cTAgLTEwMyAtMTI3IC0xMzJsLTYgLTgxaC04MGwtMTAgMTMxcTU3IDkgODguNSAyNXQzMS41IDU0cTAgMzcgLTI4LjUgNDkuNXQtNzEuNSAxMi41cS00NiAwIC03MiAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVkNjsiIGhvcml6LWFkdi14PSIxNTk1IiBkPSJNMTI1IDczNXEwIDM1NyAxNzYgNTUzLjV0NTAwIDE5Ni41cTMxNSAwIDQ5MiAtMjAwdDE3NyAtNTUycTAgLTM1MSAtMTc3LjUgLTU1MnQtNDkzLjUgLTIwMXEtMzIzIDAgLTQ5OC41IDE5Ny41dC0xNzUuNSA1NTcuNXpNMzA1IDczM3EwIC0yOTcgMTI2LjUgLTQ1MC41dDM2Ny41IC0xNTMuNXEyNDMgMCAzNjcgMTUzdDEyNCA0NTFxMCAyOTUgLTEyMy41IDQ0Ny41dC0zNjUuNSAxNTIuNXEtMjQzIDAgLTM2OS41IC0xNTMuNSB0LTEyNi41IC00NDYuNXpNNDgxIDE5MjVxMTMgMTA2IDYzLjUgMTYyLjV0MTI1LjUgNTYuNXEzNyAwIDczLjUgLTE1dDcwIC0zM3Q2NC41IC0zM3Q1OCAtMTVxNDAgMCA2MSAyNC41dDMzIDczLjVoOTBxLTExIC0xMDQgLTYwLjUgLTE2MS41dC0xMjUuNSAtNTcuNXEtMzcgMCAtNzIuNSAxNXQtNjkgMzMuNXQtNjUgMzMuNXQtNTkuNSAxNXEtNDAgMCAtNjEgLTI0LjV0LTM1IC03NC41aC05MXpNNDk0IDE1Nzl2MjNsNTMgNjAgcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZDc7IiBob3Jpei1hZHYteD0iMTIzNyIgZD0iTTExNSA1NDlxMCAyNjggMTM0IDQxNy41dDM3MiAxNDkuNXEyMzAgMCAzNjUuNSAtMTUzdDEzNS41IC00MTRxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjEwIDg0IC0zMjB0MjQ3IC0xMTB0MjQ3LjUgMTA5LjV0ODQuNSAzMjAuNXEwIDIwOSAtODQuNSAzMTcuNXQtMjQ5LjUgMTA4LjVxLTE2MyAwIC0yNDYgLTEwN3QtODMgLTMxOXpNMzAxIDE1ODcgcTEzIDEwNiA2My41IDE2Mi41dDEyNS41IDU2LjVxMzcgMCA3My41IC0xNXQ3MCAtMzN0NjQuNSAtMzN0NTggLTE1cTQwIDAgNjEgMjQuNXQzMyA3My41aDkwcS0xMSAtMTA0IC02MC41IC0xNjEuNXQtMTI1LjUgLTU3LjVxLTM3IDAgLTcyLjUgMTV0LTY5IDMzLjV0LTY1IDMzLjV0LTU5LjUgMTVxLTQwIDAgLTYxIC0yNC41dC0zNSAtNzQuNWgtOTF6TTMxNCAxMjQxdjIzbDUzIDYwcTExMiAxMjMgMTY0IDIwMGgxNzZxNjYgLTk0IDIxNyAtMjYwIHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWQ4OyIgaG9yaXotYWR2LXg9IjE1OTUiIGQ9Ik0xMjUgNzM1cTAgMzU3IDE3NiA1NTMuNXQ1MDAgMTk2LjVxMzE1IDAgNDkyIC0yMDB0MTc3IC01NTJxMCAtMzUxIC0xNzcuNSAtNTUydC00OTMuNSAtMjAxcS0zMjMgMCAtNDk4LjUgMTk3LjV0LTE3NS41IDU1Ny41ek0zMDUgNzMzcTAgLTI5NyAxMjYuNSAtNDUwLjV0MzY3LjUgLTE1My41cTI0MyAwIDM2NyAxNTN0MTI0IDQ1MXEwIDI5NSAtMTIzLjUgNDQ3LjV0LTM2NS41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1My41IHQtMTI2LjUgLTQ0Ni41ek02OTggLTI0MnEwIDU3IDI5LjUgODR0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6TTQ2MSAxNTc5djIzcTEyNyAxMzYgMTc4IDIwMHQ3NCAxMDVoMTY2cTIyIC00MiA3Ni41IC0xMDguNXQxNzkuNSAtMTk2LjV2LTIzaC0xMTlxLTg4IDU1IC0yMjEgMTg2cS0xMzYgLTEzNCAtMjE5IC0xODZoLTExNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVkOTsiIGhvcml6LWFkdi14PSIxMjM3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIzMCAwIDM2NS41IC0xNTN0MTM1LjUgLTQxNHEwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTAgODQgLTMyMHQyNDcgLTExMHQyNDcuNSAxMDkuNXQ4NC41IDMyMC41cTAgMjA5IC04NC41IDMxNy41dC0yNDkuNSAxMDguNXEtMTYzIDAgLTI0NiAtMTA3dC04MyAtMzE5ek01MjAgLTI0MiBxMCA1NyAyOS41IDg0dDcxLjUgMjdxNDAgMCA2OSAtMjd0MjkgLTg0cTAgLTU1IC0yOSAtODIuNXQtNjkgLTI3LjVxLTQyIDAgLTcxLjUgMjcuNXQtMjkuNSA4Mi41ek0yODIgMTI0MXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZGE7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTEyNSA3MzVxMCAzNjAgMTc2LjUgNTU1dDQ5OS41IDE5NXEzMjUgMCA1MDQgLTIxNXE1MCAxMiA3OSA0NS41dDQyLjUgODQuNXQxMy41IDE1NmgxODJsMTQgLTIycS0yOSAtMTU1IC05NC41IC0yNDEuNXQtMTY5LjUgLTEyNS41cTk2IC0xNzYgOTYgLTQzNHEwIC0zNTQgLTE3Ny41IC01NTMuNXQtNDkxLjUgLTE5OS41cS0zMjMgMCAtNDk4LjUgMTk2LjV0LTE3NS41IDU1OC41ek0zMDUgNzMzcTAgLTI5OCAxMjUgLTQ1MXQzNjkgLTE1MyBxMjQzIDAgMzY2IDE1Mi41dDEyMyA0NTEuNXEwIDI5NSAtMTIyLjUgNDQ3LjV0LTM2NC41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1MS41dC0xMjYuNSAtNDQ4LjV6TTY5MiAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWRiOyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjE3IDAgMzU0IC0xNDFxNTEgMTUgODAgNDcuNXQ0MiA4MnQxMyAxNTkuNWgxODBsMTUgLTIzcS0zMSAtMTU2IC05MS41IC0yNDMuNXQtMTYyLjUgLTEyNS41cTcxIC0xMzggNzEgLTMyM3EwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTEgNzkgLTMyMC41dDI1MiAtMTA5LjUgcTE3NSAwIDI1My41IDEwOS41dDc4LjUgMzIwLjVxMCAyMTAgLTc5LjUgMzE4dC0yNTQuNSAxMDhxLTE3MyAwIC0yNTEgLTEwOHQtNzggLTMxOHpNNTAyIDEyNDF2MjVxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZGM7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTEyNSA3MzVxMCAzNjAgMTc2LjUgNTU1dDQ5OS41IDE5NXEzMjUgMCA1MDQgLTIxNXE1MCAxMiA3OSA0NS41dDQyLjUgODQuNXQxMy41IDE1NmgxODJsMTQgLTIycS0yOSAtMTU1IC05NC41IC0yNDEuNXQtMTY5LjUgLTEyNS41cTk2IC0xNzYgOTYgLTQzNHEwIC0zNTQgLTE3Ny41IC01NTMuNXQtNDkxLjUgLTE5OS41cS0zMjMgMCAtNDk4LjUgMTk2LjV0LTE3NS41IDU1OC41ek0zMDUgNzMzcTAgLTI5OCAxMjUgLTQ1MXQzNjkgLTE1MyBxMjQzIDAgMzY2IDE1Mi41dDEyMyA0NTEuNXEwIDI5NSAtMTIyLjUgNDQ3LjV0LTM2NC41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1MS41dC0xMjYuNSAtNDQ4LjV6TTUyOCAxODg2djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWRkOyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjE3IDAgMzU0IC0xNDFxNTEgMTUgODAgNDcuNXQ0MiA4MnQxMyAxNTkuNWgxODBsMTUgLTIzcS0zMSAtMTU2IC05MS41IC0yNDMuNXQtMTYyLjUgLTEyNS41cTcxIC0xMzggNzEgLTMyM3EwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTEgNzkgLTMyMC41dDI1MiAtMTA5LjUgcTE3NSAwIDI1My41IDEwOS41dDc4LjUgMzIwLjVxMCAyMTAgLTc5LjUgMzE4dC0yNTQuNSAxMDhxLTE3MyAwIC0yNTEgLTEwOHQtNzggLTMxOHpNMzQ5IDE1NDh2MjFoMjAzcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZGU7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTEyNSA3MzVxMCAzNjAgMTc2LjUgNTU1dDQ5OS41IDE5NXEzMjUgMCA1MDQgLTIxNXE1MCAxMiA3OSA0NS41dDQyLjUgODQuNXQxMy41IDE1NmgxODJsMTQgLTIycS0yOSAtMTU1IC05NC41IC0yNDEuNXQtMTY5LjUgLTEyNS41cTk2IC0xNzYgOTYgLTQzNHEwIC0zNTQgLTE3Ny41IC01NTMuNXQtNDkxLjUgLTE5OS41cS0zMjMgMCAtNDk4LjUgMTk2LjV0LTE3NS41IDU1OC41ek0zMDUgNzMzcTAgLTI5OCAxMjUgLTQ1MXQzNjkgLTE1MyBxMjQzIDAgMzY2IDE1Mi41dDEyMyA0NTEuNXEwIDI5NSAtMTIyLjUgNDQ3LjV0LTM2NC41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1MS41dC0xMjYuNSAtNDQ4LjV6TTY2MyAxOTA3djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWRmOyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjE3IDAgMzU0IC0xNDFxNTEgMTUgODAgNDcuNXQ0MiA4MnQxMyAxNTkuNWgxODBsMTUgLTIzcS0zMSAtMTU2IC05MS41IC0yNDMuNXQtMTYyLjUgLTEyNS41cTcxIC0xMzggNzEgLTMyM3EwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTEgNzkgLTMyMC41dDI1MiAtMTA5LjUgcTE3NSAwIDI1My41IDEwOS41dDc4LjUgMzIwLjVxMCAyMTAgLTc5LjUgMzE4dC0yNTQuNSAxMDhxLTE3MyAwIC0yNTEgLTEwOHQtNzggLTMxOHpNNDgxIDE1Njl2MTAwcTM4IDEwIDEwNyAxMHEyNTYgMCAyNTYgLTE4NHEwIC0xNDAgLTE2NiAtMTc0bC0xMCAtMTEzaC0xMDVsLTEyIDE3NnE4NiAxNCAxMjUgMzl0MzkgNjh0LTMzLjUgNjMuNXQtMTA2LjUgMjAuNXEtNjIgMCAtOTQgLTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTA7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTEyNSA3MzVxMCAzNjAgMTc2LjUgNTU1dDQ5OS41IDE5NXEzMjUgMCA1MDQgLTIxNXE1MCAxMiA3OSA0NS41dDQyLjUgODQuNXQxMy41IDE1NmgxODJsMTQgLTIycS0yOSAtMTU1IC05NC41IC0yNDEuNXQtMTY5LjUgLTEyNS41cTk2IC0xNzYgOTYgLTQzNHEwIC0zNTQgLTE3Ny41IC01NTMuNXQtNDkxLjUgLTE5OS41cS0zMjMgMCAtNDk4LjUgMTk2LjV0LTE3NS41IDU1OC41ek0zMDUgNzMzcTAgLTI5OCAxMjUgLTQ1MXQzNjkgLTE1MyBxMjQzIDAgMzY2IDE1Mi41dDEyMyA0NTEuNXEwIDI5NSAtMTIyLjUgNDQ3LjV0LTM2NC41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1MS41dC0xMjYuNSAtNDQ4LjV6TTQyNCAxNTc5cTEzIDEyMSA3MC41IDE4OS41dDE0OC41IDY4LjVxNDYgMCA4OSAtMTguNXQ4MiAtNDF0NzUgLTQxdDY4IC0xOC41cTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDEgdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWUxOyIgaG9yaXotYWR2LXg9IjEyNDciIGQ9Ik0xMTUgNTQ5cTAgMjY4IDEzNCA0MTcuNXQzNzIgMTQ5LjVxMjE3IDAgMzU0IC0xNDFxNTEgMTUgODAgNDcuNXQ0MiA4MnQxMyAxNTkuNWgxODBsMTUgLTIzcS0zMSAtMTU2IC05MS41IC0yNDMuNXQtMTYyLjUgLTEyNS41cTcxIC0xMzggNzEgLTMyM3EwIC0yNjggLTEzNSAtNDE4LjV0LTM3MyAtMTUwLjVxLTE0NyAwIC0yNjEgNjl0LTE3NiAxOTh0LTYyIDMwMnpNMjg3IDU0OXEwIC0yMTEgNzkgLTMyMC41dDI1MiAtMTA5LjUgcTE3NSAwIDI1My41IDEwOS41dDc4LjUgMzIwLjVxMCAyMTAgLTc5LjUgMzE4dC0yNTQuNSAxMDhxLTE3MyAwIC0yNTEgLTEwOHQtNzggLTMxOHpNMjUzIDEyNDFxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDEgdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTI7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTEyNSA3MzVxMCAzNjAgMTc2LjUgNTU1dDQ5OS41IDE5NXEzMjUgMCA1MDQgLTIxNXE1MCAxMiA3OSA0NS41dDQyLjUgODQuNXQxMy41IDE1NmgxODJsMTQgLTIycS0yOSAtMTU1IC05NC41IC0yNDEuNXQtMTY5LjUgLTEyNS41cTk2IC0xNzYgOTYgLTQzNHEwIC0zNTQgLTE3Ny41IC01NTMuNXQtNDkxLjUgLTE5OS41cS0zMjMgMCAtNDk4LjUgMTk2LjV0LTE3NS41IDU1OC41ek0zMDUgNzMzcTAgLTI5OCAxMjUgLTQ1MXQzNjkgLTE1MyBxMjQzIDAgMzY2IDE1Mi41dDEyMyA0NTEuNXEwIDI5NSAtMTIyLjUgNDQ3LjV0LTM2NC41IDE1Mi41cS0yNDMgMCAtMzY5LjUgLTE1MS41dC0xMjYuNSAtNDQ4LjV6TTY5NCAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVlMzsiIGhvcml6LWFkdi14PSIxMjQ3IiBkPSJNMTE1IDU0OXEwIDI2OCAxMzQgNDE3LjV0MzcyIDE0OS41cTIxNyAwIDM1NCAtMTQxcTUxIDE1IDgwIDQ3LjV0NDIgODJ0MTMgMTU5LjVoMTgwbDE1IC0yM3EtMzEgLTE1NiAtOTEuNSAtMjQzLjV0LTE2Mi41IC0xMjUuNXE3MSAtMTM4IDcxIC0zMjNxMCAtMjY4IC0xMzUgLTQxOC41dC0zNzMgLTE1MC41cS0xNDcgMCAtMjYxIDY5dC0xNzYgMTk4dC02MiAzMDJ6TTI4NyA1NDlxMCAtMjExIDc5IC0zMjAuNXQyNTIgLTEwOS41IHExNzUgMCAyNTMuNSAxMDkuNXQ3OC41IDMyMC41cTAgMjEwIC03OS41IDMxOHQtMjU0LjUgMTA4cS0xNzMgMCAtMjUxIC0xMDh0LTc4IC0zMTh6TTUxNiAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVlNDsiIGhvcml6LWFkdi14PSIxNDkxIiBkPSJNMTg2IDUyMHY5NDJoMTcwdi05NTRxMCAtMTgzIDEwMCAtMjgxdDI5NCAtOThxMTg1IDAgMjg1IDk4LjV0MTAwIDI4Mi41djk1MmgxNzB2LTk0NnEwIC0yNTAgLTE1MSAtMzkzdC00MTUgLTE0M3QtNDA4LjUgMTQ0dC0xNDQuNSAzOTZ6TTY0NSAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVlNTsiIGhvcml6LWFkdi14PSIxMjU3IiBkPSJNMTY0IDM3OXY3MTdoMTY4di03MTFxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzZoMTY2di0xMDk2aC0xMzdsLTI0IDE0N2gtOXEtNTEgLTgxIC0xNDEuNSAtMTI0dC0yMDYuNSAtNDNxLTIwMCAwIC0yOTkuNSA5NXQtOTkuNSAzMDR6TTQ5OSAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjUgdC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTY7IiBob3Jpei1hZHYteD0iMTQ5MSIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDAgLTI4MXQyOTQgLTk4cTE4NSAwIDI4NSA5OC41dDEwMCAyODIuNXY5NTJoMTcwdi05NDZxMCAtMjUwIC0xNTEgLTM5M3QtNDE1IC0xNDN0LTQwOC41IDE0NHQtMTQ0LjUgMzk2ek02MDQgMTkwN3YxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41IHQtMTA2LjUgMjAuNXEtNjIgMCAtOTQgLTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTc7IiBob3Jpei1hZHYteD0iMTI1NyIgZD0iTTE2NCAzNzl2NzE3aDE2OHYtNzExcTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc2aDE2NnYtMTA5NmgtMTM3bC0yNCAxNDdoLTlxLTUxIC04MSAtMTQxLjUgLTEyNHQtMjA2LjUgLTQzcS0yMDAgMCAtMjk5LjUgOTV0LTk5LjUgMzA0ek00NzcgMTU2OXYxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOSB0MzkgNjh0LTMzLjUgNjMuNXQtMTA2LjUgMjAuNXEtNjIgMCAtOTQgLTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTg7IiBob3Jpei1hZHYteD0iMTU3MyIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDIgLTI4MXQzMDAgLTk4cTE4NCAwIDI4MC41IDk2LjV0OTYuNSAyODQuNXY5NTJoMTcwdi0xOThxNTggOCA5MyAzOXQ1MC41IDg3dDE1LjUgMTY2aDE4MWwxNCAtMjJxLTMzIC0xODIgLTExOSAtMjc0dC0yMzUgLTExN3YtNjI3cTAgLTI1OCAtMTQzLjUgLTM5N3QtNDA3LjUgLTEzOXEtMjY4IDAgLTQxOCAxNDMuNXQtMTUwIDM5Ni41ek02MzEgMTU3OXYyNXE0OCA2MiAxMDMuNSAxNTAgdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZTk7IiBob3Jpei1hZHYteD0iMTM2MiIgZD0iTTE2NCAzNzl2NzE1aDE2OHYtNzA5cTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc0aDE2NnYtMTIxcTgyIDExIDExOSA3NXQzNyAyMThoMTc4bDE1IC0yM3EtMzIgLTE4NiAtMTIwIC0yODEuNXQtMjI5IC0xMDkuNXYtODUyaC0xMzdsLTI0IDE0N2gtOXEtNTIgLTgyIC0xNDIuNSAtMTI0LjV0LTIwMS41IC00Mi41cS0yMDMgMCAtMzAzIDk1dC0xMDAgMzA0ek01MTQgMTI0MXYyNSBxNDggNjIgMTAzLjUgMTUwdDg3LjUgMTUzaDIwMnYtMjFxLTQ0IC02NSAtMTMxIC0xNjB0LTE1MSAtMTQ3aC0xMTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZWE7IiBob3Jpei1hZHYteD0iMTU3MyIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDIgLTI4MXQzMDAgLTk4cTE4NCAwIDI4MC41IDk2LjV0OTYuNSAyODQuNXY5NTJoMTcwdi0xOThxNTggOCA5MyAzOXQ1MC41IDg3dDE1LjUgMTY2aDE4MWwxNCAtMjJxLTMzIC0xODIgLTExOSAtMjc0dC0yMzUgLTExN3YtNjI3cTAgLTI1OCAtMTQzLjUgLTM5N3QtNDA3LjUgLTEzOXEtMjY4IDAgLTQxOCAxNDMuNXQtMTUwIDM5Ni41ek00ODMgMTg4NnYyMWgyMDMgcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZWI7IiBob3Jpei1hZHYteD0iMTM2MiIgZD0iTTE2NCAzNzl2NzE1aDE2OHYtNzA5cTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc0aDE2NnYtMTIxcTgyIDExIDExOSA3NXQzNyAyMThoMTc4bDE1IC0yM3EtMzIgLTE4NiAtMTIwIC0yODEuNXQtMjI5IC0xMDkuNXYtODUyaC0xMzdsLTI0IDE0N2gtOXEtNTIgLTgyIC0xNDIuNSAtMTI0LjV0LTIwMS41IC00Mi41cS0yMDMgMCAtMzAzIDk1dC0xMDAgMzA0ek0zMjQgMTU0OHYyMWgyMDMgcTMyIC02OSA4OSAtMTU5LjV0MTAxIC0xNDMuNXYtMjVoLTExMHEtNjUgNTIgLTE1NCAxNDh0LTEyOSAxNTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZWM7IiBob3Jpei1hZHYteD0iMTU3MyIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDIgLTI4MXQzMDAgLTk4cTE4NCAwIDI4MC41IDk2LjV0OTYuNSAyODQuNXY5NTJoMTcwdi0xOThxNTggOCA5MyAzOXQ1MC41IDg3dDE1LjUgMTY2aDE4MWwxNCAtMjJxLTMzIC0xODIgLTExOSAtMjc0dC0yMzUgLTExN3YtNjI3cTAgLTI1OCAtMTQzLjUgLTM5N3QtNDA3LjUgLTEzOXEtMjY4IDAgLTQxOCAxNDMuNXQtMTUwIDM5Ni41ek02MTYgMTkwN3YxMDBxMzggMTAgMTA3IDEwIHEyNTYgMCAyNTYgLTE4NHEwIC0xNDAgLTE2NiAtMTc0bC0xMCAtMTEzaC0xMDVsLTEyIDE3NnE4NiAxNCAxMjUgMzl0MzkgNjh0LTMzLjUgNjMuNXQtMTA2LjUgMjAuNXEtNjIgMCAtOTQgLTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZWQ7IiBob3Jpei1hZHYteD0iMTM2MiIgZD0iTTE2NCAzNzl2NzE1aDE2OHYtNzA5cTAgLTEzNCA2MSAtMjAwdDE5MSAtNjZxMTcyIDAgMjUxLjUgOTR0NzkuNSAzMDd2NTc0aDE2NnYtMTIxcTgyIDExIDExOSA3NXQzNyAyMThoMTc4bDE1IC0yM3EtMzIgLTE4NiAtMTIwIC0yODEuNXQtMjI5IC0xMDkuNXYtODUyaC0xMzdsLTI0IDE0N2gtOXEtNTIgLTgyIC0xNDIuNSAtMTI0LjV0LTIwMS41IC00Mi41cS0yMDMgMCAtMzAzIDk1dC0xMDAgMzA0ek00ODMgMTU2OXYxMDAgcTM4IDEwIDEwNyAxMHEyNTYgMCAyNTYgLTE4NHEwIC0xNDAgLTE2NiAtMTc0bC0xMCAtMTEzaC0xMDVsLTEyIDE3NnE4NiAxNCAxMjUgMzl0MzkgNjh0LTMzLjUgNjMuNXQtMTA2LjUgMjAuNXEtNjIgMCAtOTQgLTZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZWU7IiBob3Jpei1hZHYteD0iMTU3MyIgZD0iTTE4NiA1MjB2OTQyaDE3MHYtOTU0cTAgLTE4MyAxMDIgLTI4MXQzMDAgLTk4cTE4NCAwIDI4MC41IDk2LjV0OTYuNSAyODQuNXY5NTJoMTcwdi0xOThxNTggOCA5MyAzOXQ1MC41IDg3dDE1LjUgMTY2aDE4MWwxNCAtMjJxLTMzIC0xODIgLTExOSAtMjc0dC0yMzUgLTExN3YtNjI3cTAgLTI1OCAtMTQzLjUgLTM5N3QtNDA3LjUgLTEzOXEtMjY4IDAgLTQxOCAxNDMuNXQtMTUwIDM5Ni41ek0zOTEgMTU3OXExMyAxMjEgNzAuNSAxODkuNSB0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDF0LTcwLjUgMTguNXEtNTAgMCAtNzUuNSAtMzB0LTM5LjUgLTkxaC05OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVlZjsiIGhvcml6LWFkdi14PSIxMzYyIiBkPSJNMTY0IDM3OXY3MTVoMTY4di03MDlxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzRoMTY2di0xMjFxODIgMTEgMTE5IDc1dDM3IDIxOGgxNzhsMTUgLTIzcS0zMiAtMTg2IC0xMjAgLTI4MS41dC0yMjkgLTEwOS41di04NTJoLTEzN2wtMjQgMTQ3aC05cS01MiAtODIgLTE0Mi41IC0xMjQuNXQtMjAxLjUgLTQyLjVxLTIwMyAwIC0zMDMgOTV0LTEwMCAzMDR6TTI2MyAxMjQxIHExMyAxMjEgNzAuNSAxODkuNXQxNDguNSA2OC41cTQ2IDAgODkgLTE4LjV0ODIgLTQxdDc1IC00MXQ2OCAtMTguNXE0OSAwIDczIDI5LjV0MzkgOTEuNWg5OXEtMTMgLTEyMSAtNjkuNSAtMTg5LjV0LTE1MC41IC02OC41cS00MyAwIC04NCAxOC41dC04MC41IDQxdC03NiA0MXQtNzAuNSAxOC41cS01MCAwIC03NS41IC0zMHQtMzkuNSAtOTFoLTk4eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWYwOyIgaG9yaXotYWR2LXg9IjE1NzMiIGQ9Ik0xODYgNTIwdjk0MmgxNzB2LTk1NHEwIC0xODMgMTAyIC0yODF0MzAwIC05OHExODQgMCAyODAuNSA5Ni41dDk2LjUgMjg0LjV2OTUyaDE3MHYtMTk4cTU4IDggOTMgMzl0NTAuNSA4N3QxNS41IDE2NmgxODFsMTQgLTIycS0zMyAtMTgyIC0xMTkgLTI3NHQtMjM1IC0xMTd2LTYyN3EwIC0yNTggLTE0My41IC0zOTd0LTQwNy41IC0xMzlxLTI2OCAwIC00MTggMTQzLjV0LTE1MCAzOTYuNXpNNjQ3IC0yNDJxMCA1NyAyOS41IDg0dDcxLjUgMjcgcTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVmMTsiIGhvcml6LWFkdi14PSIxMzYyIiBkPSJNMTY0IDM3OXY3MTVoMTY4di03MDlxMCAtMTM0IDYxIC0yMDB0MTkxIC02NnExNzIgMCAyNTEuNSA5NHQ3OS41IDMwN3Y1NzRoMTY2di0xMjFxODIgMTEgMTE5IDc1dDM3IDIxOGgxNzhsMTUgLTIzcS0zMiAtMTg2IC0xMjAgLTI4MS41dC0yMjkgLTEwOS41di04NTJoLTEzN2wtMjQgMTQ3aC05cS01MiAtODIgLTE0Mi41IC0xMjQuNXQtMjAxLjUgLTQyLjVxLTIwMyAwIC0zMDMgOTV0LTEwMCAzMDR6TTQ5MyAtMjQycTAgNTcgMjkuNSA4NCB0NzEuNSAyN3E0MCAwIDY5IC0yN3QyOSAtODRxMCAtNTUgLTI5IC04Mi41dC02OSAtMjcuNXEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZjI7IiBob3Jpei1hZHYteD0iMTE0NyIgZD0iTTAgMTQ2MmgxODZsMzg3IC03MzFsMzkwIDczMWgxODRsLTQ4OCAtODk1di01NjdoLTE3MnY1NTl6TTI4NSAxODg2djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWYzOyIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6TTIzNCAxNTQ4djIxaDIwM3EzMiAtNjkgODkgLTE1OS41dDEwMSAtMTQzLjV2LTI1aC0xMTBxLTY1IDUyIC0xNTQgMTQ4dC0xMjkgMTU5IHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVmNDsiIGhvcml6LWFkdi14PSIxMTQ3IiBkPSJNMCAxNDYyaDE4NmwzODcgLTczMWwzOTAgNzMxaDE4NGwtNDg4IC04OTV2LTU2N2gtMTcydjU1OXpNNDcxIC0yNDJxMCA1NyAyOS41IDg0dDcxLjUgMjdxNDAgMCA2OSAtMjd0MjkgLTg0cTAgLTU1IC0yOSAtODIuNXQtNjkgLTI3LjVxLTQyIDAgLTcxLjUgMjcuNXQtMjkuNSA4Mi41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWY1OyIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6TTcyOSAtMjQ1cTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41IHEtNDIgMCAtNzEuNSAyNy41dC0yOS41IDgyLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZjY7IiBob3Jpei1hZHYteD0iMTE0NyIgZD0iTTAgMTQ2MmgxODZsMzg3IC03MzFsMzkwIDczMWgxODRsLTQ4OCAtODk1di01NjdoLTE3MnY1NTl6TTQzNCAxOTA3djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1bC0xMiAxNzZxODYgMTQgMTI1IDM5dDM5IDY4dC0zMy41IDYzLjV0LTEwNi41IDIwLjVxLTYyIDAgLTk0IC02eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gxZWY3OyIgaG9yaXotYWR2LXg9IjEwMzIiIGQ9Ik0yIDEwOTZoMTc4bDI0MCAtNjI1cTc5IC0yMTQgOTggLTMwOWg4cTEzIDUxIDU0LjUgMTc0LjV0MjcxLjUgNzU5LjVoMTc4bC00NzEgLTEyNDhxLTcwIC0xODUgLTE2My41IC0yNjIuNXQtMjI5LjUgLTc3LjVxLTc2IDAgLTE1MCAxN3YxMzNxNTUgLTEyIDEyMyAtMTJxMTcxIDAgMjQ0IDE5Mmw2MSAxNTZ6TTM3MCAxNTY5djEwMHEzOCAxMCAxMDcgMTBxMjU2IDAgMjU2IC0xODRxMCAtMTQwIC0xNjYgLTE3NGwtMTAgLTExM2gtMTA1IGwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MWVmODsiIGhvcml6LWFkdi14PSIxMTQ3IiBkPSJNMCAxNDYyaDE4NmwzODcgLTczMWwzOTAgNzMxaDE4NGwtNDg4IC04OTV2LTU2N2gtMTcydjU1OXpNMjAyIDE1NzlxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDF0LTcwLjUgMTguNXEtNTAgMCAtNzUuNSAtMzAgdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFlZjk7IiBob3Jpei1hZHYteD0iMTAzMiIgZD0iTTIgMTA5NmgxNzhsMjQwIC02MjVxNzkgLTIxNCA5OCAtMzA5aDhxMTMgNTEgNTQuNSAxNzQuNXQyNzEuNSA3NTkuNWgxNzhsLTQ3MSAtMTI0OHEtNzAgLTE4NSAtMTYzLjUgLTI2Mi41dC0yMjkuNSAtNzcuNXEtNzYgMCAtMTUwIDE3djEzM3E1NSAtMTIgMTIzIC0xMnExNzEgMCAyNDQgMTkybDYxIDE1NnpNMTQ2IDEyNDFxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjUgcTQ5IDAgNzMgMjkuNXQzOSA5MS41aDk5cS0xMyAtMTIxIC02OS41IC0xODkuNXQtMTUwLjUgLTY4LjVxLTQzIDAgLTg0IDE4LjV0LTgwLjUgNDF0LTc2IDQxdC03MC41IDE4LjVxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDFmNGQ7IiBob3Jpei1hZHYteD0iMTYxOCIgZD0iTTE0NSA3MzVxMCAzNTcgMTc2IDU1My41dDUwMCAxOTYuNXEzMTUgMCA0OTIgLTIwMHQxNzcgLTU1MnEwIC0zNTEgLTE3Ny41IC01NTJ0LTQ5My41IC0yMDFxLTMyMyAwIC00OTguNSAxOTcuNXQtMTc1LjUgNTU3LjV6TTMyNSA3MzNxMCAtMjk3IDEyNi41IC00NTAuNXQzNjcuNSAtMTUzLjVxMjQzIDAgMzY3IDE1M3QxMjQgNDUxcTAgMjk1IC0xMjMuNSA0NDcuNXQtMzY1LjUgMTUyLjVxLTI0MyAwIC0zNjkuNSAtMTUzLjUgdC0xMjYuNSAtNDQ2LjV6TS0yODkgMTI1M3EwIDE2MyAyMzcgMjI0di03MnEtMTIxIC00MSAtMTIxIC05NHEwIC0yMCAxNS41IC0yOS41dDM0IC0xNy41dDM0IC0yMXQxNS41IC00MXEwIC03NCAtOTMgLTc0cS01NSAwIC04OC41IDM0dC0zMy41IDkxek0tOSAxMTM1djI0cTcwIDE4MSA5OCAzMDNoMTg5di0yMHEtNDEgLTc4IC0xMDAuNSAtMTY0dC0xMDguNSAtMTQzaC03OHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAwMDsiIGhvcml6LWFkdi14PSIxMDI0IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDE7IiBob3Jpei1hZHYteD0iMjA0OCIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDAyOyIgaG9yaXotYWR2LXg9IjEwMjQiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAwMzsiIGhvcml6LWFkdi14PSIyMDQ4IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDQ7IiBob3Jpei1hZHYteD0iNjgyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDU7IiBob3Jpei1hZHYteD0iNTEyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDY7IiBob3Jpei1hZHYteD0iMzQyIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMDc7IiBob3Jpei1hZHYteD0iMTE0NSIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA4OyIgaG9yaXotYWR2LXg9IjU0NSIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDA5OyIgaG9yaXotYWR2LXg9IjQxMCIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDBhOyIgaG9yaXotYWR2LXg9IjIwNSIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDBiOyIgaG9yaXotYWR2LXg9IjAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAxMDsiIGhvcml6LWFkdi14PSI2NTkiIGQ9Ik04NCA0NzN2MTUyaDQ5MXYtMTUyaC00OTF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMTE7IiBob3Jpei1hZHYteD0iNjU5IiBkPSJNODQgNDczdjE1Mmg0OTF2LTE1MmgtNDkxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDEyOyIgaG9yaXotYWR2LXg9IjY1OSIgZD0iTTg0IDQ3M3YxNTJoNDkxdi0xNTJoLTQ5MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAxMzsiIGhvcml6LWFkdi14PSIxMDI0IiBkPSJNODIgNDczdjE1Mmg4NjB2LTE1MmgtODYweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDE0OyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik04MiA0NzN2MTUyaDE4ODR2LTE1MmgtMTg4NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAxNTsiIGhvcml6LWFkdi14PSIyMDQ4IiBkPSJNODIgNDczdjE1MmgxODg0di0xNTJoLTE4ODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMTc7IiBob3Jpei1hZHYteD0iODQyIiBkPSJNLTQgLTQ1aDg1MHYtMTM5aC04NTB2MTM5ek0tNCAtMzI0aDg1MHYtMTM5aC04NTB2MTM5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDE4OyIgaG9yaXotYWR2LXg9IjM0OCIgZD0iTTI1IDk4M3EyMiA5MCA3MSAyMjR0MTA1IDI1NWgxMjNxLTY2IC0yNTQgLTEwMyAtNTAxaC0xODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMTk7IiBob3Jpei1hZHYteD0iMzQ4IiBkPSJNMjUgOTYxcTcwIDI4NSAxMDIgNTAxaDE4MmwxNSAtMjJxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTIyeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDFhOyIgaG9yaXotYWR2LXg9IjUwMiIgZD0iTTYzIC0yNjRxMjcgMTA0IDU5LjUgMjU3dDQ1LjUgMjQ1aDE4MmwxNSAtMjNxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTI1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDFiOyIgaG9yaXotYWR2LXg9IjM0OCIgZD0iTTI1IDE0NDBsMTQgMjJoMTg0cTM3IC0yNTEgMTAzIC01MDFoLTEyM3EtNDUgOTQgLTk5LjUgMjM2dC03OC41IDI0M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAxYzsiIGhvcml6LWFkdi14PSI3MTciIGQ9Ik0yNSA5ODNxMjIgOTAgNzEgMjI0dDEwNSAyNTVoMTIzcS02NiAtMjU0IC0xMDMgLTUwMWgtMTg0ek0zOTEgOTgzcTU2IDIxNSAxNzggNDc5aDEyM3EtMzAgLTExNSAtNTkuNSAtMjU5LjV0LTQyLjUgLTI0MS41aC0xODR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMWQ7IiBob3Jpei1hZHYteD0iNzE3IiBkPSJNMjUgOTYxcTcwIDI4NSAxMDIgNTAxaDE4MmwxNSAtMjJxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTIyek0zOTEgOTYxcTI2IDEwMCA1OSAyNTR0NDYgMjQ3aDE4MmwxNCAtMjJxLTI0IC05MSAtNzIgLTIyNHQtMTA0IC0yNTVoLTEyNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAxZTsiIGhvcml6LWFkdi14PSI4MjkiIGQ9Ik0yNSAtMjYzcTcwIDI4NSAxMDIgNTAxaDE4MmwxNSAtMjJxLTI2IC0xMDAgLTc1IC0yMzIuNXQtMTAyIC0yNDYuNWgtMTIyek0zOTEgLTI2M3EyNiAxMDAgNTkgMjU0dDQ2IDI0N2gxODJsMTQgLTIycS0yNCAtOTEgLTcyIC0yMjR0LTEwNCAtMjU1aC0xMjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMjA7IiBob3Jpei1hZHYteD0iMTAyOCIgZD0iTTEyMyA5OTl2MTcwbDMzMiAtMzBsLTQ5IDQxN2gxOTZsLTQ5IC00MTdsMzUyIDMwdi0xNzBsLTM1MiAzMWw0OSAtMTAzMGgtMTk2bDQ5IDEwMzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMjE7IiBob3Jpei1hZHYteD0iMTA0NCIgZD0iTTEyMyAzNTB2MTY4bDM0NiAtMzFsLTQzIDI5OWw0MyAyODNsLTM0NiAtMzF2MTY4bDM0NiAtMzBsLTQ5IDM4MGgxOThsLTQ5IC0zODBsMzUzIDMwdi0xNjhsLTM1MyAzMWw0MyAtMjgzbC00MyAtMjk5bDM1MyAzMXYtMTY4bC0zNTMgMjlsNDkgLTM3OWgtMTk4bDQ5IDM3OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAyMjsiIGhvcml6LWFkdi14PSI3NzAiIGQ9Ik0xNjQgNzQ4cTAgMTIxIDU2LjUgMTg0dDE2NC41IDYzcTEwNSAwIDE2MyAtNjJ0NTggLTE4NXEwIC0xMTkgLTU3LjUgLTE4My41dC0xNjMuNSAtNjQuNXEtMTA3IDAgLTE2NCA2NS41dC01NyAxODIuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjAyNjsiIGhvcml6LWFkdi14PSIxNjA2IiBkPSJNMTUyIDEwNnEwIDY3IDMwLjUgMTAxLjV0ODcuNSAzNC41cTU4IDAgOTAuNSAtMzQuNXQzMi41IC0xMDEuNXEwIC02NSAtMzMgLTEwMHQtOTAgLTM1cS01MSAwIC04NC41IDMxLjV0LTMzLjUgMTAzLjV6TTY4MiAxMDZxMCA2NyAzMC41IDEwMS41dDg3LjUgMzQuNXE1OCAwIDkwLjUgLTM0LjV0MzIuNSAtMTAxLjVxMCAtNjUgLTMzIC0xMDB0LTkwIC0zNXEtNTEgMCAtODQuNSAzMS41dC0zMy41IDEwMy41ek0xMjEzIDEwNiBxMCA2NyAzMC41IDEwMS41dDg3LjUgMzQuNXE1OCAwIDkwLjUgLTM0LjV0MzIuNSAtMTAxLjVxMCAtNjUgLTMzIC0xMDB0LTkwIC0zNXEtNTEgMCAtODQuNSAzMS41dC0zMy41IDEwMy41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDJmOyIgaG9yaXotYWR2LXg9IjQyOSIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDMwOyIgaG9yaXotYWR2LXg9IjI0NjIiIGQ9Ik0xMDAgMTAyNnEwIDQ1NyAzMTIgNDU3cTE1MiAwIDIzNC41IC0xMjB0ODIuNSAtMzM3cTAgLTIzMCAtODAuNSAtMzQ1LjV0LTIzNi41IC0xMTUuNXEtMTQ5IDAgLTIzMC41IDExOXQtODEuNSAzNDJ6TTIzNiAxMDI2cTAgLTE3MCA0MS41IC0yNTV0MTM0LjUgLTg1cTE4MCAwIDE4MCAzNDBxMCAzMzggLTE4MCAzMzhxLTkzIDAgLTEzNC41IC04NHQtNDEuNSAtMjU0ek0zODcgMGw4MTEgMTQ2MmgxNDhsLTgxMSAtMTQ2MmgtMTQ4eiBNMTAwMSA0NDBxMCA0NTcgMzEyIDQ1N3ExNTAgMCAyMzMuNSAtMTE4dDgzLjUgLTMzOXEwIC0yMzAgLTgxIC0zNDV0LTIzNiAtMTE1cS0xNDkgMCAtMjMwLjUgMTE5dC04MS41IDM0MXpNMTEzOSA0NDBxMCAtMTcxIDQwLjUgLTI1NS41dDEzMy41IC04NC41cTkxIDAgMTM1LjUgODMuNXQ0NC41IDI1Ni41cTAgMTcxIC00NC41IDI1My41dC0xMzUuNSA4Mi41cS05MyAwIC0xMzMuNSAtODIuNXQtNDAuNSAtMjUzLjV6TTE3MzUgNDQwIHEwIDQ1NyAzMTEgNDU3cTE1MCAwIDIzMy41IC0xMTh0ODMuNSAtMzM5cTAgLTIzMCAtODEgLTM0NXQtMjM2IC0xMTVxLTE0OCAwIC0yMjkuNSAxMTkuNXQtODEuNSAzNDAuNXpNMTg3MCA0NDBxMCAtMTcxIDQxLjUgLTI1NS41dDEzNC41IC04NC41cTkxIDAgMTM1LjUgODMuNXQ0NC41IDI1Ni41cTAgMTcxIC00NC41IDI1My41dC0xMzUuNSA4Mi41cS05MyAwIC0xMzQuNSAtODIuNXQtNDEuNSAtMjUzLjV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMzI7IiBob3Jpei1hZHYteD0iNDUzIiBkPSJNMTMzIDE0NjJoMTg2bC00MCAtNTI4aC0xMDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwMzM7IiBob3Jpei1hZHYteD0iODA1IiBkPSJNMTMzIDE0NjJoMTg2bC00MCAtNTI4aC0xMDV6TTUwMiAxNDYyaDE4NmwtNDEgLTUyOGgtMTA0eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDM5OyIgaG9yaXotYWR2LXg9IjYyMyIgZD0iTTgyIDUyNHYyN2wzNDIgNDA3bDExOSAtNjlsLTI4OSAtMzUwbDI4OSAtMzUxbC0xMTkgLTcxeiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDNhOyIgaG9yaXotYWR2LXg9IjYyMyIgZD0iTTgwIDE4OGwyODcgMzUxbC0yODcgMzUwbDExNyA2OWwzNDQgLTQwN3YtMjdsLTM0NCAtNDA3eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDNjOyIgaG9yaXotYWR2LXg9Ijk5NSIgZD0iTTE1MiAxMDZxMCAxMzYgMTIwIDEzNnE1OCAwIDg5LjUgLTM1dDMxLjUgLTEwMXEwIC02NCAtMzIgLTk5LjV0LTg5IC0zNS41cS01MiAwIC04NiAzMS41dC0zNCAxMDMuNXpNMTcwIDE0NjJoMjA3bC01MSAtMTA1OWgtMTA1ek02MDEgMTA2cTAgMTM2IDEyMCAxMzZxNTggMCA4OS41IC0zNXQzMS41IC0xMDFxMCAtNjQgLTMyIC05OS41dC04OSAtMzUuNXEtNTIgMCAtODYgMzEuNXQtMzQgMTAzLjV6TTYxOSAxNDYyaDIwN2wtNTEgLTEwNTkgaC0xMDV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNDQ7IiBob3Jpei1hZHYteD0iMjY2IiBkPSJNLTM5MSAwbDkwMyAxNDYyaDE0M2wtOTAzIC0xNDYyaC0xNDN6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNWY7IiBob3Jpei1hZHYteD0iNTM2IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNzA7IiBob3Jpei1hZHYteD0iNzExIiBkPSJNMzkgMTAyNnEwIDQ1MyAzMTUgNDUzcTE1OCAwIDIzNyAtMTE2dDc5IC0zMzdxMCAtNDU3IC0zMTYgLTQ1N3EtMTU4IDAgLTIzNi41IDExOHQtNzguNSAzMzl6TTE3NiAxMDI0cTAgLTE2OCA0MSAtMjUxdDEzNSAtODN0MTM3IDgyLjV0NDMgMjUzLjVxMCAxNzAgLTQzIDI1MnQtMTM3IDgydC0xMzUgLTgyLjV0LTQxIC0yNTMuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjA3NDsiIGhvcml6LWFkdi14PSI3MTEiIGQ9Ik0yMCA3ODh2MTAxbDQwOCA1NzloMTM5di01NjNoMTI1di0xMTdoLTEyNXYtMjAyaC0xNDV2MjAyaC00MDJ6TTE2MCA5MDVoMjYydjE5NXEwIDEzNCA2IDIwOXEtNSAtMTIgLTE3IC0zMS41dC0yNyAtNDEuNWwtMzAgLTQ2cS0xNSAtMjIgLTI2IC0zOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjA3NTsiIGhvcml6LWFkdi14PSI3MTEiIGQ9Ik01OSA2MjF2MTMxcTU2IC0zNCAxMjYgLTUzdDEyNCAtMTlxOTUgMCAxNTAgNDEuNXQ1NSAxMzAuNXEwIDc4IC01NC41IDEyMnQtMTU2LjUgNDRxLTU3IDAgLTk1IC04LjV0LTY5IC0xNi41bC01OSA0MWwzMyA0MTZoNDk1di0xMDRoLTM4MWwtMjAgLTIzMHE2MiAxMiAxMjEgMTJxMTQ1IDAgMjMzIC03MS41dDg4IC0xOTQuNXEwIC0xNDAgLTg1IC0yMTcuNXQtMjUxIC03Ny41cS03NCAwIC0xNDMuNSAxNS41dC0xMTAuNSAzOC41eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMDc2OyIgaG9yaXotYWR2LXg9IjcxMSIgZD0iTTQxIDk2M3EwIDI2MSAxMDkuNSAzODguNXQzMjguNSAxMjcuNXE3NCAwIDEyMyAtMTV2LTExNHEtNTIgMTggLTEzNSAxOHEtMTQxIDAgLTIxNiAtNzYuNXQtODUgLTI0Mi41aDhxMjkgNDMgODUuNSA3Mi41dDE0MS41IDI5LjVxMTI1IDAgMTk5IC03NHQ3NCAtMjAwcTAgLTE0NCAtODMgLTIyNnQtMjI0IC04MnEtMTUzIDAgLTIzOS41IDEwNXQtODYuNSAyODl6TTE3NCA4OTNxMCAtODkgNTMgLTE1MXQxMzggLTYycTgxIDAgMTMwLjUgNDYuNSB0NDkuNSAxNDUuNXEwIDc5IC00NCAxMjQuNXQtMTMwIDQ1LjVxLTg1IDAgLTE0MSAtNDV0LTU2IC0xMDR6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNzc7IiBob3Jpei1hZHYteD0iNzExIiBkPSJNNTcgMTM0NnYxMTZoNTk4di05NGwtMzUyIC03ODJoLTE0MWwzNTAgNzYwaC00NTV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwNzg7IiBob3Jpei1hZHYteD0iNzExIiBkPSJNNTEgODEzcTAgNjkgMzYuNSAxMjd0MTIxLjUgMTA0cS03NCA0NiAtMTAyLjUgOTIuNXQtMjguNSAxMTQuNXEwIDEwMiA3OC41IDE2NXQxOTkuNSA2M3ExMjQgMCAxOTkuNSAtNTl0NzUuNSAtMTYzcTAgLTEzMCAtMTQ4IC0yMDZxMTc2IC03NCAxNzYgLTIzMnEwIC0xMTMgLTgyLjUgLTE4MS41dC0yMjAuNSAtNjguNXEtMTQ2IDAgLTIyNS41IDY0dC03OS41IDE4MHpNMTgyIDgxM3EwIC02MCA0MiAtOTYuNXQxMjggLTM2LjUgcTkwIDAgMTMyIDM2LjV0NDIgOTYuNXEwIDYzIC00Ni41IDEwMi41dC0xMjcuNSA2Ny41bC0yOCAxMHEtNzIgLTM0IC0xMDcgLTc2dC0zNSAtMTA0ek0yMTEgMTI1M3EwIC00NyAzNCAtODIuNXQxMTUgLTY4LjVxMTQwIDU0IDE0MCAxNTFxMCA1NyAtMzkgODd0LTEwNyAzMHQtMTA1LjUgLTMwdC0zNy41IC04N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjA3OTsiIGhvcml6LWFkdi14PSI3MTEiIGQ9Ik0zNSAxMTgwcTAgMTM2IDg0LjUgMjE4LjV0MjIwLjUgODIuNXExNTIgMCAyNDAgLTEwMXQ4OCAtMjg2cTAgLTI3MCAtMTA5IC0zOTcuNXQtMzIxIC0xMjcuNXEtODMgMCAtMTMyIDE1djExNnE0OSAtMjAgMTQyIC0yMHEyNzYgMCAyOTcgMzI2aC0xMHEtMzUgLTUxIC05MyAtNzd0LTEyMyAtMjZxLTEzMSAwIC0yMDcuNSA3M3QtNzYuNSAyMDR6TTE2NCAxMTg4cTAgLTgxIDQyLjUgLTEyOC41dDEyOS41IC00Ny41cTg0IDAgMTQxLjUgNDIuNSB0NTcuNSAxMDQuNXEwIDk3IC01MS41IDE1NHQtMTQzLjUgNTdxLTgxIDAgLTEyOC41IC00Ny41dC00Ny41IC0xMzQuNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjA3ZjsiIGhvcml6LWFkdi14PSI4MDciIGQ9Ik0xMDkgODAxdjY2NWg5NmwxNCAtODhoMTBxNzUgMTAxIDIyMCAxMDFxMjU4IDAgMjU4IC0yNTB2LTQyOGgtMTE5djQyMHEwIDg0IC0zOSAxMTkuNXQtMTE5IDM1LjVxLTExNCAwIC0xNTkuNSAtNTIuNXQtNDUuNSAtMTc0LjV2LTM0OGgtMTE2eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMGEzOyIgaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik05OCAyNjZ2MTI5aDE3NnYxMDY3aDc4NXYtMTUxaC02MTl2LTUzNWg1ODB2LTE1MWgtNTgwdi0yMzBoMzA4di0xMjloLTMwOHYtMjY2aC0xNjZ2MjY2aC0xNzZ6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwYTQ7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTY4IDB2MTQxcTIwNiA0OCAyMDYgMjkxdjM1aC0yMDB2MTI5aDIwMHYxNjZoLTIwMHYxMjloMjAwdjIwN3EwIDE3OCAxMTIgMjgwLjV0MzAyIDEwMi41cTIwMSAwIDM1OSAtODBsLTYwIC0xMzFxLTE1MiA3MSAtMjk5IDcxcS0xMjIgMCAtMTg1IC02Ny41dC02MyAtMTk2LjV2LTE4Nmg0MjB2LTEyOWgtNDIwdi0xNjZoNDIwdi0xMjloLTQyMHYtMzNxMCAtMTAwIC0zMi41IC0xNjh0LTEwNi41IC0xMTJoNzk1di0xNTRoLTEwMjh6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwYTc7IiBob3Jpei1hZHYteD0iMTU2MyIgZD0iTTE1NCAwdjE0NjJoMjYycTI1NiAwIDM4MyAtMTA1LjV0MTI3IC0zMjAuNXEwIC0yMjcgLTEzOC41IC0zNDR0LTQwNC41IC0xMTdoLTY0di01NzVoLTE2NXpNMzE5IDcyMWg1MnEyMDAgMCAyOTIuNSA3Mi41dDkyLjUgMjM0LjVxMCAxNDUgLTg2IDIxNnQtMjY5IDcxaC04MnYtNTk0ek05MjQgNzE3djgwbDE1NyA2OWw2MiAxOTFoOTh2LTIxMWgyMjF2LTEyOWgtMjIxdi00NDFxMCAtNzcgMjYgLTExOHQ5MSAtNDFxMzQgMCA3NyA3dDU0IDExIHYtMTI1cS02MCAtMzAgLTE3MCAtMzBxLTEwOSAwIC0xNzMuNSA2OHQtNjQuNSAyMDZ2NDYzaC0xNTd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwYWI7IiBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTExNSA1NDVxMCAyNzEgMTIwIDQyMXQzMzQgMTUwcTIyMyAwIDM0MiAtMTYyaDEzcS0xMSA4MyAtMTEgMTU2djEzM2gtNDQ4djEyOWg0NDh2MTg0aDE2NnYtMTg0aDE1NnYtMTI5aC0xNTZ2LTEyNDNoLTEzNWwtMjIgMTQ3aC05cS0xMTUgLTE2NyAtMzQ0IC0xNjdxLTIxNSAwIC0zMzQuNSAxNDd0LTExOS41IDQxOHpNMjg3IDU0M3EwIC0yMTAgNzcgLTMxN3QyMjYgLTEwN3ExNzAgMCAyNDYuNSA5Mi41dDc2LjUgMjk4LjV2MzUgcTAgMjMzIC03Ny41IDMzMi41dC0yNDcuNSA5OS41cS0xNDYgMCAtMjIzLjUgLTExMy41dC03Ny41IC0zMjAuNXpNMTc2IC0xODRoOTI2di0xMzFoLTkyNnYxMzF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIwYWM7IiBob3Jpei1hZHYteD0iMTIwOCIgZD0iTTYzIDUwNnYxMjloMTUybC0yIDQydjQ0bDIgODBoLTE1MnYxMjloMTY0cTM5IDI2MSAxODUgNDA3dDM4MyAxNDZxMjAxIDAgMzY2IC05N2wtNzEgLTEzOXEtMTY2IDg2IC0yOTUgODZxLTMxOSAwIC0zOTggLTQwM2g1MTB2LTEyOWgtNTI0bC0yIC01N3YtNjRsMiAtNDVoNDYzdi0xMjloLTQ0N3EzNyAtMTgwIDEzOC41IC0yNzguNXQyNzEuNSAtOTguNXExNTYgMCAzMDkgNjZ2LTE1MHEtMTQ2IC02NSAtMzE3IC02NSBxLTIzNyAwIC0zODEuNSAxMzQuNXQtMTkwLjUgMzkxLjVoLTE2NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjEwNTsiIGhvcml6LWFkdi14PSIxNjg4IiBkPSJNMTQxIDExMjZxMCAxNjggOTQgMjU3LjV0MjY1IDg5LjVxMTA0IDAgMTkyIC0zNWwtMzMgLTEwM3EtODEgMzEgLTE2MSAzMXEtMjI0IDAgLTIyNCAtMjM4cTAgLTIzNSAyMjAgLTIzNXE5OCAwIDE4OCAzM3YtMTAxcS03OCAtMzcgLTE5MyAtMzdxLTE2NiAwIC0yNTcgODguNXQtOTEgMjQ5LjV6TTM1MiAwbDgxMSAxNDYyaDE0OGwtODExIC0xNDYyaC0xNDh6TTkyMCAzMzRxMCAxNTggODMuNSAyNTB0MjMxLjUgOTJxMTQxIDAgMjI2IC05MyB0ODUgLTI0OXEwIC0xNTkgLTg0LjUgLTI1MC41dC0yMzIuNSAtOTEuNXEtMTM5IDAgLTIyNCA5Mi41dC04NSAyNDkuNXpNMTA1NSAzMzRxMCAtMjM4IDE3OCAtMjM4cTE3NiAwIDE3NiAyMzhxMCAyMzUgLTE3NiAyMzVxLTE3OCAwIC0xNzggLTIzNXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjExMzsiIGhvcml6LWFkdi14PSIxMDY1IiBkPSJNMTE5IDUxNnYxMTNxNzggMjEgMTkyIDU5djQ5OHEwIDEzOCA3NSAyMTcuNXQyMTAgNzkuNXExMTcgMCAxODQuNSAtODAuNXQ2Ny41IC0yMTguNXEwIC0xODUgLTEwMyAtMzM3dC0yNzggLTIyNnYtMjgzcTAgLTEwNCA0MSAtMTY1LjV0MTI5IC02MS41cTE3NCAwIDE5MiAyMTNoOTVxLTggLTE2NiAtODQuNSAtMjU1dC0yMTguNSAtODlxLTE1MCAwIC0yMzAgOTAuNXQtODAgMjU5LjV2MjQzcS05NiAtMzUgLTE5MiAtNTd6TTQ2NyA3NDEgcTI1NiAxMzcgMjU2IDQzN3EwIDE5NCAtMTI3IDE5NHEtNjcgMCAtOTggLTQzdC0zMSAtMTUxdi00Mzd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIxMTY7IiBob3Jpei1hZHYteD0iMjA4NyIgZD0iTTIwMSAwdjE0NjJoMTk0bDY4MiAtMTIyMmg4cS0xNCAyNDUgLTE0IDM4M3Y4MzloMTUydi0xNDYyaC0xODdsLTY5MiAxMjI3aC04cTE2IC0yODggMTYgLTM5NnYtODMxaC0xNTF6TTEzNzggNjIxcTAgMTYzIDgwLjUgMjUzLjV0MjI3LjUgOTAuNXExMzkgMCAyMjAgLTkzLjV0ODEgLTI1MC41cTAgLTE2MyAtODAuNSAtMjU1dC0yMjcuNSAtOTJxLTEzOSAwIC0yMjAgOTMuNXQtODEgMjUzLjV6TTE0MjMgMHYxMzVoNTEydi0xMzVoLTUxMnogTTE1MDkgNjIxcTAgLTExNCA0MC41IC0xNzN0MTMzLjUgLTU5cTkxIDAgMTMwLjUgNTguNXQzOS41IDE3My41dC0zOS41IDE3MXQtMTMwLjUgNTZxLTkyIDAgLTEzMyAtNTZ0LTQxIC0xNzF6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIxMjA7IiBob3Jpei1hZHYteD0iMTYyNiIgZD0iTTkyIDc2NnYxMDhxMTA2IC00MCAyMjUgLTQwcTE0OCAwIDE0OCAxMDBxMCAzMyAtMTEuNSA1M3QtMzguNSAzNi41dC0xMTIgNDcuNXEtMTIwIDQ0IC0xNjAuNSA4OS41dC00MC41IDEyMS41cTAgODYgNzEgMTM4LjV0MTgxIDUyLjVxMTI1IDAgMjE3IC0zOWwtMzQgLTk5cS0xMDAgMzcgLTE4MyAzN3EtNjAgMCAtOTcuNSAtMjN0LTM3LjUgLTYzcTAgLTI5IDkgLTQ3dDMwLjUgLTMydDExNi41IC01MHExMjkgLTUwIDE2OSAtOTV0NDAgLTEyMiBxMCAtOTggLTc0LjUgLTE1Mi41dC0xOTguNSAtNTQuNXEtMTQ1IDAgLTIxOSAzM3pNNjg0IDc0MXY3MjFoMTg4bDE5NSAtNTU5bDIwMyA1NTloMTgwdi03MjFoLTEyN3Y0MjBsNiAxMzdoLThsLTIxMSAtNTU3aC0xMDRsLTIwMSA1NTloLThsNiAtMTI5di00MzBoLTExOXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjEyMjsiIGhvcml6LWFkdi14PSIxNTg5IiBkPSJNMzcgMTM1NnYxMDZoNTQzdi0xMDZoLTIxMXYtNjE1aC0xMjN2NjE1aC0yMDl6TTY0NyA3NDF2NzIxaDE4N2wxOTYgLTU1OWwyMDMgNTU5aDE4MHYtNzIxaC0xMjd2NDIwbDYgMTM3aC04bC0yMTEgLTU1N2gtMTA0bC0yMDEgNTU5aC04bDYgLTEyOXYtNDMwaC0xMTl6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIxMjY7IiBob3Jpei1hZHYteD0iMTYwMiIgZD0iTTgwIDB2MTUyaDM2NHEtMTUxIDExOCAtMjMxIDI5M3QtODAgMzc4cTAgMzEwIDE3NyA0ODZ0NDkxIDE3NnEzMTUgMCA0OTIgLTE3My41dDE3NyAtNDg2LjVxMCAtMjA3IC03OSAtMzgwdC0yMzAgLTI5M2gzNjN2LTE1MmgtNTg2djEzM3ExODMgMTM0IDI2Ny41IDMwMXQ4NC41IDM4OXEwIDI1MiAtMTI0LjUgMzgxdC0zNjQuNSAxMjlxLTIzOCAwIC0zNjMgLTEyOC41dC0xMjUgLTM4MS41cTAgLTIyNSA4Ni41IC0zOTEuNXQyNjYuNSAtMjk4LjUgdi0xMzNoLTU4NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjEyZTsiIGhvcml6LWFkdi14PSIxMjY4IiBkPSJNMTAyIDUzMHEwIDE3MSA2OSAyOTguNXQxOTEgMTk3LjV0MjcxIDcwcTE1MiAwIDI3My41IC03MXQxODkgLTIwMC41dDY3LjUgLTI5NC41aC04Mjd2LTM1NnE0OSAtNTMgMTMyIC04OHQxNjUgLTM1cTEzMSAwIDIyMi41IDUyLjV0MTcyLjUgMTgxLjVsNzIgLTQxcS05OCAtMTU1IC0yMDYuNSAtMjE3dC0yNjAuNSAtNjJxLTE1NyAwIC0yNzcuNSA3My41dC0xODcgMjA0dC02Ni41IDI4Ny41ek0zMzYgNjE2aDU5NnYyNzcgcS01MCA1MyAtMTMxLjUgODZ0LTE2OS41IDMzcS0xNzMgMCAtMjk1IC0xMTd2LTI3OXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjE1YjsiIGhvcml6LWFkdi14PSIxNTk3IiBkPSJNMjEzIDBsOTAzIDE0NjJoMTQzbC05MDMgLTE0NjJoLTE0M3pNNzEgMTI4MGwyNjIgMTgyaDE0M3YtODc2aC0xMzN2NTc5cTAgOTEgNiAxODFxLTIyIC0yMiAtNDkgLTQ0LjV0LTE2MiAtMTE3LjV6TTkxNSAyMjRxMCA2OSAzNi41IDEyN3QxMjEuNSAxMDRxLTc0IDQ2IC0xMDIuNSA5Mi41dC0yOC41IDExNC41cTAgMTAyIDc4LjUgMTY1dDE5OS41IDYzcTEyNCAwIDE5OS41IC01OXQ3NS41IC0xNjNxMCAtMTMwIC0xNDggLTIwNiBxMTc2IC03NCAxNzYgLTIzMnEwIC0xMTMgLTgyLjUgLTE4MS41dC0yMjAuNSAtNjguNXEtMTQ2IDAgLTIyNS41IDY0dC03OS41IDE4MHpNMTA0NiAyMjRxMCAtNjAgNDIgLTk2LjV0MTI4IC0zNi41cTkwIDAgMTMyIDM2LjV0NDIgOTYuNXEwIDYzIC00Ni41IDEwMi41dC0xMjcuNSA2Ny41bC0yOCAxMHEtNzIgLTM0IC0xMDcgLTc2dC0zNSAtMTA0ek0xMDc1IDY2NHEwIC00NyAzNCAtODIuNXQxMTUgLTY4LjVxMTQwIDU0IDE0MCAxNTEgcTAgNTcgLTM5IDg3dC0xMDcgMzB0LTEwNS41IC0zMHQtMzcuNSAtODd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIxNWM7IiBob3Jpei1hZHYteD0iMTU5NyIgZD0iTTI4MyAwbDkwMyAxNDYyaDE0M2wtOTAzIC0xNDYyaC0xNDN6TTkzNiAyMjRxMCA2OSAzNi41IDEyN3QxMjEuNSAxMDRxLTc0IDQ2IC0xMDIuNSA5Mi41dC0yOC41IDExNC41cTAgMTAyIDc4LjUgMTY1dDE5OS41IDYzcTEyNCAwIDE5OS41IC01OXQ3NS41IC0xNjNxMCAtMTMwIC0xNDggLTIwNnExNzYgLTc0IDE3NiAtMjMycTAgLTExMyAtODIuNSAtMTgxLjV0LTIyMC41IC02OC41cS0xNDYgMCAtMjI1LjUgNjR0LTc5LjUgMTgweiBNMTA2NyAyMjRxMCAtNjAgNDIgLTk2LjV0MTI4IC0zNi41cTkwIDAgMTMyIDM2LjV0NDIgOTYuNXEwIDYzIC00Ni41IDEwMi41dC0xMjcuNSA2Ny41bC0yOCAxMHEtNzIgLTM0IC0xMDcgLTc2dC0zNSAtMTA0ek0xMDk2IDY2NHEwIC00NyAzNCAtODIuNXQxMTUgLTY4LjVxMTQwIDU0IDE0MCAxNTFxMCA1NyAtMzkgODd0LTEwNyAzMHQtMTA1LjUgLTMwdC0zNy41IC04N3pNMzIgNjI1djEyM3ExNDcgLTY4IDI3MCAtNjhxMjExIDAgMjExIDE2MiBxMCAxNDUgLTIzMSAxNDVoLTExN3YxMDdoMTE5cTEwMyAwIDE1Mi41IDM5LjV0NDkuNSAxMDcuNXEwIDYxIC00MCA5NXQtMTA3IDM0cS02NiAwIC0xMjIgLTIxLjV0LTExMiAtNTYuNWwtNjkgOTBxNjMgNDUgMTMzIDcydDE2NCAyN3ExMzYgMCAyMTQuNSAtNTkuNXQ3OC41IC0xNjYuNXEwIC04MCAtNDEgLTEzMS41dC0xMDkgLTc0LjVxMTc2IC00NyAxNzYgLTIwOXEwIC0xMjggLTkyIC0xOTkuNXQtMjYwIC03MS41cS0xNTIgMCAtMjY4IDU2eiAiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjE1ZDsiIGhvcml6LWFkdi14PSIxNTk3IiBkPSJNMjc3IDBsOTAzIDE0NjJoMTQzbC05MDMgLTE0NjJoLTE0M3pNNzEgNjIxdjEzMXE1NiAtMzQgMTI2IC01M3QxMjQgLTE5cTk1IDAgMTUwIDQxLjV0NTUgMTMwLjVxMCA3OCAtNTQuNSAxMjJ0LTE1Ni41IDQ0cS01NyAwIC05NSAtOC41dC02OSAtMTYuNWwtNTkgNDFsMzMgNDE2aDQ5NXYtMTA0aC0zODFsLTIwIC0yMzBxNjIgMTIgMTIxIDEycTE0NSAwIDIzMyAtNzEuNXQ4OCAtMTk0LjVxMCAtMTQwIC04NSAtMjE3LjV0LTI1MSAtNzcuNSBxLTc0IDAgLTE0My41IDE1LjV0LTExMC41IDM4LjV6TTkzMiAyMjRxMCA2OSAzNi41IDEyN3QxMjEuNSAxMDRxLTc0IDQ2IC0xMDIuNSA5Mi41dC0yOC41IDExNC41cTAgMTAyIDc4LjUgMTY1dDE5OS41IDYzcTEyNCAwIDE5OS41IC01OXQ3NS41IC0xNjNxMCAtMTMwIC0xNDggLTIwNnExNzYgLTc0IDE3NiAtMjMycTAgLTExMyAtODIuNSAtMTgxLjV0LTIyMC41IC02OC41cS0xNDYgMCAtMjI1LjUgNjR0LTc5LjUgMTgwek0xMDYzIDIyNCBxMCAtNjAgNDIgLTk2LjV0MTI4IC0zNi41cTkwIDAgMTMyIDM2LjV0NDIgOTYuNXEwIDYzIC00Ni41IDEwMi41dC0xMjcuNSA2Ny41bC0yOCAxMHEtNzIgLTM0IC0xMDcgLTc2dC0zNSAtMTA0ek0xMDkyIDY2NHEwIC00NyAzNCAtODIuNXQxMTUgLTY4LjVxMTQwIDU0IDE0MCAxNTFxMCA1NyAtMzkgODd0LTEwNyAzMHQtMTA1LjUgLTMwdC0zNy41IC04N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjE1ZTsiIGhvcml6LWFkdi14PSIxNTk3IiBkPSJNMTkxIDBsOTAzIDE0NjJoMTQzbC05MDMgLTE0NjJoLTE0M3pNOTI4IDIyNHEwIDY5IDM2LjUgMTI3dDEyMS41IDEwNHEtNzQgNDYgLTEwMi41IDkyLjV0LTI4LjUgMTE0LjVxMCAxMDIgNzguNSAxNjV0MTk5LjUgNjNxMTI0IDAgMTk5LjUgLTU5dDc1LjUgLTE2M3EwIC0xMzAgLTE0OCAtMjA2cTE3NiAtNzQgMTc2IC0yMzJxMCAtMTEzIC04Mi41IC0xODEuNXQtMjIwLjUgLTY4LjVxLTE0NiAwIC0yMjUuNSA2NHQtNzkuNSAxODB6IE0xMDU5IDIyNHEwIC02MCA0MiAtOTYuNXQxMjggLTM2LjVxOTAgMCAxMzIgMzYuNXQ0MiA5Ni41cTAgNjMgLTQ2LjUgMTAyLjV0LTEyNy41IDY3LjVsLTI4IDEwcS03MiAtMzQgLTEwNyAtNzZ0LTM1IC0xMDR6TTEwODggNjY0cTAgLTQ3IDM0IC04Mi41dDExNSAtNjguNXExNDAgNTQgMTQwIDE1MXEwIDU3IC0zOSA4N3QtMTA3IDMwdC0xMDUuNSAtMzB0LTM3LjUgLTg3ek0xMDYgMTM0NnYxMTZoNTk4di05NGwtMzUyIC03ODJoLTE0MWwzNTAgNzYwIGgtNDU1eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMjAyOyIgaG9yaXotYWR2LXg9IjExOTAiIGQ9Ik0xMDIgMzczcTAgMTY5IDY4IDMyMi41dDE4NCAyMzR0MjY3IDgwLjVxOTcgMCAxNzAgLTQ2LjV0MTE2IC0xMjEuNWw0IDkwcTAgNDA1IC0yODIgNDA1cS02MiAwIC0xMzQgLTIydC0xMjAgLTU1djE1OXE0NyAyMyAxMjQuNSA0MS41dDE1MS41IDE4LjVxMjEwIDAgMzE4IC0xMzh0MTA4IC00MDdxMCAtMjYyIC04My41IC00OTEuNXQtMjIxLjUgLTM0NnQtMzExIC0xMTYuNXEtMTcyIDAgLTI2NS41IDEwMC41dC05My41IDI5Mi41ek0yNzQgMzY5IHEwIC0xMTggNTAuNSAtMTgzdDE0Ni41IC02NXE5NSAwIDE3OCA3MnQxNDMgMjAxLjV0ODIgMjc5LjVxLTI1IDk3IC04OSAxNTF0LTE0NCA1NHEtMTAxIDAgLTE4My41IC02NnQtMTMzIC0xOTF0LTUwLjUgLTI1M3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjIwNjsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMzkgMHYxMDRsNDYzIDEzNThoMTY2bDQ2NSAtMTM2MHYtMTAyaC0xMDk0ek0yMjMgMTUyaDcyMWwtMjU4IDc2MXEtNjggMjAyIC0xMDIgMzU1cS02MSAtMjI1IC0xMDEgLTM0NnoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjIwZjsiIGhvcml6LWFkdi14PSIxNTEzIiBkPSJNMjAxIC00OTZ2MTk1OGgxMTEydi0xOTU4aC0xNzB2MTgwNWgtNzcydi0xODA1aC0xNzB6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIyMTE7IiBob3Jpei1hZHYteD0iMTI5MiIgZD0iTTc2IC0zODlsNjMxIDkyNGwtNjE1IDgxOXYxMDhoMTA4OHYtMTUxaC04NDhsNTc5IC03NzJsLTYwNCAtODgzaDkzOHYtMTUyaC0xMTY5djEwN3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjIxMjsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDY1M3YxMzhoOTYxdi0xMzhoLTk2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjIxYTsiIGhvcml6LWFkdi14PSIxMTI0IiBkPSJNMzcgNzY4djEzNWgyODlsMjM1IC02ODRsNTE0IDE0NjloMTM3bC01ODkgLTE3MDJoLTEyN2wtMjc5IDc4MmgtMTgweiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3gyMjFlOyIgaG9yaXotYWR2LXg9IjE0NDQiIGQ9Ik0xMTkgNzIzcTAgMTM0IDg0IDIyMy41dDIxNSA4OS41cTE4MSAwIDMwMyAtMjE5cTEyNCAyMTUgMzA5IDIxNXExMzMgMCAyMTQgLTg3LjV0ODEgLTIyNS41cTAgLTEzMSAtODMuNSAtMjIzLjV0LTIxMS41IC05Mi41cS05MyAwIC0xNjkuNSA1M3QtMTQxLjUgMTY5cS02MCAtMTA0IC0xMzYuNSAtMTYwLjV0LTE2NC41IC01Ni41cS0xMzEgMCAtMjE1IDg2LjV0LTg0IDIyOC41ek0yNDggNzIxcTAgLTgzIDQ4LjUgLTEzNnQxMjkuNSAtNTMgcTY2IDAgMTIwLjUgNDUuNXQxMDguNSAxNDUuNXEtNTAgOTcgLTEwNC41IDE0My41dC0xMjYuNSA0Ni41cS03NiAwIC0xMjYgLTUyLjV0LTUwIC0xMzkuNXpNNzg4IDcxOXE1MSAtOTcgMTA2IC0xNDR0MTI2IC00N3E3NiAwIDEyNiA1My41dDUwIDEzNy41cTAgODUgLTUwLjUgMTM3LjV0LTEyNy41IDUyLjVxLTY2IDAgLTEyMC41IC00NnQtMTA5LjUgLTE0NHoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjIyYjsiIGhvcml6LWFkdi14PSI3ODYiIGQ9Ik0xMiAtMzM4cTYxIC0yMiAxMTkgLTIycTE4MiAwIDE4MiAyNDN2MTMxMXEwIDM2MiAzMjQgMzYycTc5IDAgMTIzIC0xNnYtMTM3cS00OSAyMiAtMTExIDIycS0xNzYgMCAtMTc2IC0yNDN2LTEzMTFxMCAtMTc2IC04Mi41IC0yNjkuNXQtMjQ1LjUgLTkzLjVxLTc0IDAgLTEzMyAxOXYxMzV6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIyNDg7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTk4IDM5MXYxNTBxMTA4IDExMCAyNTYgMTEwcTY3IDAgMTIzIC0xNHQxNDQgLTUxcTc3IC0zMyAxMjIuNSAtNDUuNXQ5MC41IC0xMi41cTUzIDAgMTE3IDMzdDExOCA5MHYtMTUxcS0xMDEgLTEwOSAtMjU0IC0xMDlxLTY3IDAgLTEyMi41IDE0LjV0LTE0My41IDUxLjVxLTczIDMwIC0xMTguNSA0Mi41dC05NC41IDEyLjVxLTU0IDAgLTExNy41IC0zMnQtMTIwLjUgLTg5ek05OCA3OTd2MTQ5cTEwNiAxMDkgMjU2IDEwOXE2OSAwIDEyNyAtMTYgdDE0MCAtNTBxNjkgLTI5IDExNi41IC00MnQ5Ni41IC0xM3E1NSAwIDExOS41IDMzdDExNS41IDg4di0xNTBxLTEwMCAtMTEwIC0yNTQgLTExMHEtNjkgMCAtMTI4IDE2dC0xMzggNDlxLTg0IDM0IC0xMjYuNSA0NnQtODYuNSAxMnEtNTcgMCAtMTIxIC0zNHQtMTE3IC04N3oiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjI2MDsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDQ0OXYxMzdoMzQwbDEyNyAyNzJoLTQ2N3YxMzdoNTMxbDEzNSAyODdsMTI1IC01N2wtMTA5IC0yMzBoMjc5di0xMzdoLTM0MmwtMTI5IC0yNzJoNDcxdi0xMzdoLTUzNWwtMTMxIC0yODNsLTEyNSA1NWwxMDcgMjI4aC0yNzd6IiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeDIyNjQ7IiBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTEwNCA2NjR2OThsOTYxIDQ3OXYtMTQ5bC03ODIgLTM3MWw3ODIgLTMyOHYtMTUxek0xMDQgMXYxMzhoOTYxdi0xMzhoLTk2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjI2NTsiIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDI0MnYxNTFsNzgzIDMyNmwtNzgzIDM3M3YxNDlsOTYxIC00Nzl2LTk4ek0xMDQgMXYxMzhoOTYxdi0xMzhoLTk2MXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4MjVjYTsiIGhvcml6LWFkdi14PSIxMTk0IiBkPSJNMTExIDczNWw0NTAgNzQwaDcybDQ1MiAtNzQwbC00NTIgLTczNWgtNzJ6TTI4MSA3MzdsMzE3IC01MzJsMzE3IDUzMmwtMzE3IDUzMXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZTAwMDsiIGhvcml6LWFkdi14PSIxMDk1IiBkPSJNMCAxMDk1aDEwOTV2LTEwOTVoLTEwOTV2MTA5NXoiIC8+DQo8Z2x5cGggdW5pY29kZT0iJiN4ZmVmZjsiIGhvcml6LWFkdi14PSIwIiAvPg0KPGdseXBoIHVuaWNvZGU9IiYjeGZmZmM7IiBob3Jpei1hZHYteD0iMjA0OCIgZD0iTTg0IDM5djI3MGgxMTF2LTI3MGgtMTExek04NCAtODBoMTExdi0xOTRoMTkydi0xMDloLTMwM3YzMDN6TTg0IDQzMHYyNzJoMTExdi0yNzJoLTExMXpNODQgODIzdjI3MWgxMTF2LTI3MWgtMTExek04NCAxMjE0djMwNGgzMDN2LTExMWgtMTkydi0xOTNoLTExMXpNMzQwIDYyOXEwIDE0NiA2Ny41IDIyMy41dDE5NC41IDc3LjVxMTI2IDAgMTk0IC03N3Q2OCAtMjI0cTAgLTE0NSAtNjcuNSAtMjIzdC0xOTQuNSAtNzh0LTE5NC41IDc4IHQtNjcuNSAyMjN6TTQ2NyA2MjlxMCAtMTk3IDEzNSAtMTk3dDEzNSAxOTdxMCAxOTYgLTEzNSAxOTZ0LTEzNSAtMTk2ek01MDggLTI3NGgyNzB2LTEwOWgtMjcwdjEwOXpNNTA4IDE0MDd2MTExaDI3MHYtMTExaC0yNzB6TTg5OSAtMjc0aDI3MnYtMTA5aC0yNzJ2MTA5ek04OTkgMTQwN3YxMTFoMjcydi0xMTFoLTI3MnpNOTQ4IDMzNnY1ODZoMTcycTEwOSAwIDE2NSAtMzMuNXQ1NiAtMTE2LjVxMCAtNDkgLTIzIC04MnQtNjcgLTQxdi04IHE2MSAtMTQgODQgLTQ4dDIzIC04N3EwIC04MSAtNTQuNSAtMTI1LjV0LTE0OC41IC00NC41aC0yMDd6TTEwNzEgNDM4aDc0cTQ5IDAgNjcuNSAyMS41dDE4LjUgNTguNXEwIDc0IC05MCA3NGgtNzB2LTE1NHpNMTA3MSA2OTBoNjZxNDYgMCA2NCAxN3QxOCA0OXEwIDM0IC0yMSA0OC41dC02OCAxNC41aC01OXYtMTI5ek0xMjkwIC0yNzRoMjczdi0xMDloLTI3M3YxMDl6TTEyOTAgMTQwN3YxMTFoMjczdi0xMTFoLTI3M3pNMTQxMSAzNDB2MTAyIHE0MyAtOCA2OCAtOHE4NiAwIDg2IDg2djQwMmgxMjV2LTM5OHEwIC05NSAtNTIuNSAtMTQ0LjV0LTE0Ni41IC00OS41cS01MiAwIC04MCAxMHpNMTY4MSAtMjc0aDE5NXYxOTRoMTA5di0zMDNoLTMwNHYxMDl6TTE2ODEgMTQwN3YxMTFoMzA0di0zMDRoLTEwOXYxOTNoLTE5NXpNMTg3NiAzOXYyNzBoMTA5di0yNzBoLTEwOXpNMTg3NiA0MzB2MjcyaDEwOXYtMjcyaC0xMDl6TTE4NzYgODIzdjI3MWgxMDl2LTI3MWgtMTA5eiIgLz4NCjxnbHlwaCB1bmljb2RlPSImI3hmZmZkOyIgaG9yaXotYWR2LXg9IjIwNDgiIGQ9Ik04NCA2MThsOTM4IDkzOGw5NDAgLTkzOGwtOTQwIC05Mzd6TTY4NCAxMDY1bDgyIC0xNzhxMTYwIDgwIDI1MCA4MHE2MyAwIDk0IC0yOXQzMSAtNzZxMCAtNTMgLTI0LjUgLTkwLjV0LTk2LjUgLTkxLjVxLTg0IC02OCAtMTEzLjUgLTEyNHQtMjkuNSAtMTMwdi01OWgyMTB2NDdxMCA1MCAyMiA4Mi41dDg3IDgxLjVxMTAzIDgyIDEzOS41IDE0NXQzNi41IDE1MXEwIDEzNSAtOTMuNSAyMTJ0LTI1OC41IDc3cS03OSAwIC0xNzIgLTI4IHQtMTY0IC03MHpNODUwIDkycTAgLTYzIDM1LjUgLTk5dDEwNS41IC0zNnE2NiAwIDEwMi41IDM2LjV0MzYuNSA5OC41cTAgNjQgLTM2IDEwMC41dC0xMDMgMzYuNXEtNzIgMCAtMTA2LjUgLTM2dC0zNC41IC0xMDF6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIwIiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHpNNjAgMTg4NnYyMWgyMDNxMzIgLTY5IDg5IC0xNTkuNXQxMDEgLTE0My41di0yNWgtMTEwcS02NSA1MiAtMTU0IDE0OHQtMTI5IDE1OXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6TTIzNCAxNTc5djI1cTQ4IDYyIDEwMy41IDE1MHQ4Ny41IDE1M2gyMDJ2LTIxcS00NCAtNjUgLTEzMSAtMTYwdC0xNTEgLTE0N2gtMTExeiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHpNLTEgMTU3OXYyM3ExMjcgMTM2IDE3OCAyMDB0NzQgMTA1aDE2NnEyMiAtNDIgNzYuNSAtMTA4LjV0MTc5LjUgLTE5Ni41di0yM2gtMTE5cS04OCA1NSAtMjIxIDE4NnEtMTM2IC0xMzQgLTIxOSAtMTg2aC0xMTV6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek02MCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek00NDEgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNSB0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHpNLTMwIDE1NzlxMTMgMTIxIDcwLjUgMTg5LjV0MTQ4LjUgNjguNXE0NiAwIDg5IC0xOC41dDgyIC00MXQ3NSAtNDF0NjggLTE4LjVxNDkgMCA3MyAyOS41dDM5IDkxLjVoOTlxLTEzIC0xMjEgLTY5LjUgLTE4OS41dC0xNTAuNSAtNjguNXEtNDMgMCAtODQgMTguNXQtODAuNSA0MXQtNzYgNDF0LTcwLjUgMTguNSBxLTUwIDAgLTc1LjUgLTMwdC0zOS41IC05MWgtOTh6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek00MiAxNTc5djEzN2g2MDB2LTEzN2gtNjAweiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHpNMzAgMTg0N2gxMDRxNiAtNDkgMjYuNSAtNzd0NTcgLTQxdDEyMS41IC0xM3ExMDEgMCAxNDkgMzJ0NTggOTloMTA0cS0xMCAtMTI2IC05My41IC0xOTd0LTIyMS41IC03MXEtMTQwIDAgLTIxOCA2OC41dC04NyAxOTkuNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6TTE0MSAtMjU4cTAgNzAgNDMgMTM3LjV0MTE1IDEyMC41aDEyMHEtNjggLTY2IC0xMDIuNSAtMTIwLjV0LTM0LjUgLTExNy41cTAgLTk0IDk0IC05NHE0MiAwIDk3IDEzdi0xMDlxLTY1IC0xOCAtMTI1IC0xOHEtMjA3IDAgLTIwNyAxODh6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek0yNDIgMTczMXEwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjEyMjkiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek01MjAgLTIxM3E3MSAtMjAgMTQ4IC0yMHE5OSAwIDE1MC41IDYwdDUxLjUgMTczdjE0NjJoMTcwdi0xNDQ4cTAgLTE5MCAtOTYgLTI5NC41dC0yNzYgLTEwNC41cS05NCAwIC0xNDggMjd2MTQ1eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iOTIwIiBkPSJNMzIyIDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6TS0yOCAxMTM2djI5cTI3IDcyIDUzLjUgMTg1LjV0MzguNSAxOTUuNWgxODR2LTIzcS0xOCAtNzQgLTcyLjUgLTE5Mi41dC0xMDMuNSAtMTk0LjVoLTEwMHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek02MCAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzcTM4IDAgNjUuNSAtMjN0MjcuNSAtNzVxMCAtNTAgLTI3LjUgLTc0LjV0LTY1LjUgLTI0LjVxLTM3IDAgLTYzLjUgMjQuNXQtMjYuNSA3NC41ek00NDEgMTczMXEwIDUyIDI2LjUgNzV0NjMuNSAyM3Q2NC41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNSB0LTY0LjUgLTI0LjV0LTYzLjUgMjQuNXQtMjYuNSA3NC41eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6TTYwIDE3MzFxMCA1MiAyNi41IDc1dDYzLjUgMjNxMzggMCA2NS41IC0yM3QyNy41IC03NXEwIC01MCAtMjcuNSAtNzQuNXQtNjUuNSAtMjQuNXEtMzcgMCAtNjMuNSAyNC41dC0yNi41IDc0LjV6TTQ0MSAxNzMxcTAgNTIgMjYuNSA3NXQ2My41IDIzdDY0LjUgLTIzdDI3LjUgLTc1cTAgLTUwIC0yNy41IC03NC41IHQtNjQuNSAtMjQuNXQtNjMuNSAyNC41dC0yNi41IDc0LjV6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMTgyIiBkPSJNMjE5IDE1NDhoMTU2cTkgLTEwNCA1NC41IC0xNDV0MTU4LjUgLTQxcTEwMyAwIDE1Mi41IDQ0dDYwLjUgMTQyaDE1N3EtMTIgLTE1OCAtMTAxIC0yMzIuNXQtMjczIC03NC41cS0xODUgMCAtMjcwIDcxLjV0LTk1IDIzNS41eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTM5MyAxMjI5djI0cTE5IDU1IDM4LjUgMTM4LjV0MjkuNSAxNjQuNWgxNjh2LTE4cS0xMSAtNTEgLTU1IC0xNDV0LTkxIC0xNjRoLTkweiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTAyNCIgZD0iTTM2OSAtNDI4cTI4IDY0IDUzLjUgMTU3dDMyLjUgMTQ2aDE2OHYtMThxLTExIC01MSAtNjAgLTE0Ny41dC0xMDQgLTE2Mi41aC05MHYyNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjEwMjQiIGQ9Ik0zODUgMTI0MXYxOXExNCA2MSA2My41IDE1Ni41dDk4LjUgMTUyLjVoOTJ2LTI1cS0yOSAtNjEgLTU1LjUgLTE1Ny41dC0zMi41IC0xNDUuNWgtMTY2eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iODE5IiBkPSJNMTUyIDEyNTNxMCAxNjMgMjM3IDIyNHYtNzJxLTEyMSAtNDEgLTEyMSAtOTRxMCAtMjAgMTUuNSAtMjkuNXQzNCAtMTcuNXQzNCAtMjF0MTUuNSAtNDFxMCAtNzQgLTkzIC03NHEtNTUgMCAtODguNSAzNHQtMzMuNSA5MXpNNDMyIDExMzV2MjRxNzAgMTgxIDk4IDMwM2gxODl2LTIwcS00MSAtNzggLTEwMC41IC0xNjR0LTEwOC41IC0xNDNoLTc4eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNjgyIiBkPSJNODQgMHY5OGwxNzIgMzV2MTE5NGwtMTcyIDM3djk4aDUxNHYtOThsLTE3MiAtMzd2LTExOTRsMTcyIC0zNXYtOThoLTUxNHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI2ODIiIGQ9Ik04NCAwdjk4bDE3MiAzNXYxMTk0bC0xNzIgMzd2OThoNTE0di05OGwtMTcyIC0zN3YtMTE5NGwxNzIgLTM1di05OGgtNTE0ek0yMDkgMTkwN3YxMDBxMzggMTAgMTA3IDEwcTI1NiAwIDI1NiAtMTg0cTAgLTE0MCAtMTY2IC0xNzRsLTEwIC0xMTNoLTEwNWwtMTIgMTc2cTg2IDE0IDEyNSAzOXQzOSA2OHQtMzMuNSA2My41dC0xMDYuNSAyMC41cS02MiAwIC05NCAtNnoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjY4MiIgZD0iTTg0IDB2OThsMTcyIDM1djExOTRsLTE3MiAzN3Y5OGg1MTR2LTk4bC0xNzIgLTM3di0xMTk0bDE3MiAtMzV2LTk4aC01MTR6TTIzOSAtMjQycTAgNTcgMjkuNSA4NHQ3MS41IDI3cTQwIDAgNjkgLTI3dDI5IC04NHEwIC01NSAtMjkgLTgyLjV0LTY5IC0yNy41cS00MiAwIC03MS41IDI3LjV0LTI5LjUgODIuNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjAiIGQ9Ik0tOTExIDEyNDF2MjVsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NnE2NiAtOTQgMjE3IC0yNjB2LTI1aC05NHEtMTEyIDc1IC0yMTEgMTY2cS0xMTQgLTEwMSAtMjExIC0xNjZoLTk0ek0tMzgxIDE0MzZ2MjRxNzMgOTEgMTI3IDIwM2gxNzJ2LTIxcS04MyAtMTEwIC0yMDMgLTIwNmgtOTZ6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIwIiBkPSJNLTExMjYgMTY0MnYyMWgxNzJxNTIgLTEwOCAxMjcgLTIwNXYtMjJoLTk1cS0xMjAgOTQgLTIwNCAyMDZ6TS05MDcgMTI0MXYyM2w1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjNoLTk0cS05NyA2NSAtMjExIDE2NnEtMTA2IC05NiAtMjExIC0xNjZoLTk0eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMCIgZD0iTS05MTEgMTI0MXYyNWw1MyA2MHExMTIgMTIzIDE2NCAyMDBoMTc2cTY2IC05NCAyMTcgLTI2MHYtMjVoLTk0cS0xMTIgNzUgLTIxMSAxNjZxLTExNCAtMTAxIC0yMTEgLTE2NmgtOTR6TS00MDggMTY5OHY4MHEyNSA2IDgwIDZxMTk1IDAgMTk1IC0xMzlxMCAtMTAzIC0xMjcgLTEzMmwtNiAtODFoLTgwbC0xMCAxMzFxNTcgOSA4OC41IDI1dDMxLjUgNTRxMCAzNyAtMjguNSA0OS41dC03MS41IDEyLjVxLTQ2IDAgLTcyIC02eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMCIgZD0iTS05MjAgMTU4N3ExMyAxMDYgNjMuNSAxNjIuNXQxMjUuNSA1Ni41cTM3IDAgNzMuNSAtMTV0NzAgLTMzdDY0LjUgLTMzdDU4IC0xNXE0MCAwIDYxIDI0LjV0MzMgNzMuNWg5MHEtMTEgLTEwNCAtNjAuNSAtMTYxLjV0LTEyNS41IC01Ny41cS0zNyAwIC03Mi41IDE1dC02OSAzMy41dC02NSAzMy41dC01OS41IDE1cS00MCAwIC02MSAtMjQuNXQtMzUgLTc0LjVoLTkxek0tOTA3IDEyNDF2MjNsNTMgNjBxMTEyIDEyMyAxNjQgMjAwaDE3NiBxNjYgLTk0IDIxNyAtMjYwdi0yM2gtOTRxLTk3IDY1IC0yMTEgMTY2cS0xMDYgLTk2IC0yMTEgLTE2NmgtOTR6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIwIiBkPSJNLTkwMyAxNTAxaDEwMnE5IC03MiA0NyAtMTAwLjV0MTQ0IC0yOC41cTk4IDAgMTQxIDMyLjV0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHpNLTY3NCAxNTAxdjIzcTgwIDEwNCAxMjkgMjA1aDE3MnYtMjFxLTg2IC0xMTQgLTIwNSAtMjA3aC05NnoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjAiIGQ9Ik0tOTAzIDE1MDFoMTAycTkgLTcyIDQ3IC0xMDAuNXQxNDQgLTI4LjVxOTggMCAxNDEgMzIuNXQ1MSA5Ni41aDEwNXEtMTEgLTEyMCAtODUuNSAtMTkwdC0yMTMuNSAtNzBxLTI3NiAwIC0yOTEgMjYwek0tODU4IDE3MDh2MjFoMTcycTUyIC0xMDggMTI3IC0yMDV2LTIzaC05NHEtMTE5IDkzIC0yMDUgMjA3eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMCIgZD0iTS05MDMgMTUwMWgxMDJxOSAtNzIgNDcgLTEwMC41dDE0NCAtMjguNXE5OCAwIDE0MSAzMi41dDUxIDk2LjVoMTA1cS0xMSAtMTIwIC04NS41IC0xOTB0LTIxMy41IC03MHEtMjc2IDAgLTI5MSAyNjB6TS03MzkgMTcxMnY3OHEyMiA4IDg0IDhxMTkyIDAgMTkyIC0xNDFxMCAtMTAwIC0xMjcgLTEyOWwtNiAtNDFoLTgybC0xMCA5MHE1NyA5IDkwIDI1dDMzIDUzdC0yOC41IDUwdC03Mi41IDEzcS0zNyAwIC03MyAtNnoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjAiIGQ9Ik0tOTIwIDE1ODVxMTMgMTA0IDYzIDE2MC41dDEyNiA1Ni41cTM3IDAgNzMuNSAtMTV0NzAgLTMzdDY0LjUgLTMzdDU4IC0xNXE0MCAwIDYxIDI0LjV0MzMgNzMuNWg5MHEtMTEgLTEwMyAtNjAuNSAtMTYwdC0xMjUuNSAtNTdxLTM3IDAgLTcyLjUgMTV0LTY5IDMzdC02NSAzM3QtNTkuNSAxNXEtNDAgMCAtNjEgLTI0dC0zNSAtNzRoLTkxek0tOTAzIDE1MDFoMTAycTkgLTcyIDQ3IC0xMDAuNXQxNDQgLTI4LjVxOTggMCAxNDEgMzIuNSB0NTEgOTYuNWgxMDVxLTExIC0xMjAgLTg1LjUgLTE5MHQtMjEzLjUgLTcwcS0yNzYgMCAtMjkxIDI2MHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjQyMCIgZD0iTTQ5IC0zMjJxMzIgLTEwIDg2IC0xMHEzNyAwIDYyLjUgMjR0MjUuNSA3MHEwIDEwMyAtMTM5IDIzOGgxMjNxMTU4IC0xMjAgMTU4IC0yNTJxMCAtOTEgLTUxIC0xNDIuNXQtMTUwIC01MS41cS02NSAwIC0xMTUgMTZ2MTA4eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iNDIwIiBkPSJNMjUgLTIzMXE0MSAtMTkgMTAyIC0xOXE5NCAwIDk0IDEwMHYzMDRoMTQ4di0yODlxMCAtMjYwIC0yMjggLTI2MHEtNTYgMCAtMTE2IDI0djE0MHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjQyMCIgZD0iTTI1IC0yMzFxNDEgLTE5IDEwMiAtMTlxOTQgMCA5NCAxMDB2MjkzaDE0OHYtMjc4cTAgLTI2MCAtMjI4IC0yNjBxLTU2IDAgLTExNiAyNHYxNDB6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSI4MTMiIGQ9Ik01MiAxMTYzbDM4NyAyOTloMTQwdi0xNDYyaC0xNjJ2MTA0MnEwIDEzMCA4IDI0NnEtMjEgLTIxIC00NyAtNDR0LTIzOCAtMTk1eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTE2MSIgZD0iTTExNSA1NTlxMCAyNzEgMTI0LjUgNDI1LjV0MzQyLjUgMTU0LjVxMjE2IDAgMzQwLjUgLTE1NC41dDEyNC41IC00MjUuNXEwIC0yNjcgLTEyMy41IC00MjN0LTM0NS41IC0xNTZxLTIxNyAwIC0zNDAgMTU0LjV0LTEyMyA0MjQuNXpNMjgzIDU1OXEwIC0yMDggNzcuNSAtMzI0dDIxOS41IC0xMTZxMTQxIDAgMjIwIDExN3Q3OSAzMjNxMCAyMDQgLTc5IDMyMnQtMjIyIDExOHEtMTQxIDAgLTIxOCAtMTE2LjV0LTc3IC0zMjMuNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9Ijc1NiIgZD0iTTQ1IDgyN2wzODMgMjkxaDEzOXYtMTExOGgtMTYxdjU2MXEwIDIzOSA4IDM3OXEtNjcgLTY3IC0xMjkgLTExNWwtMTUwIC0xMTJ6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMDQ0IiBkPSJNNDEgMHYxMzNsNDAxIDMwM3ExNTcgMTE5IDIxMy41IDE3MXQ3OC41IDkzLjV0MjIgMTA2LjVxMCA4NyAtNjkuNSAxMzguNXQtMTg4LjUgNTEuNXEtODggMCAtMTY2IC0zMC41dC0xNzAgLTEwNC41bC05MCAxMDlxMTkyIDE2OCA0MzQgMTY4cTE5OCAwIDMwNyAtODR0MTA5IC0yMzRxMCAtMTE1IC02NSAtMjA4LjV0LTI1MSAtMjIxLjVsLTMyNyAtMjMxbDIgLTZoNzAydi0xNTRoLTk0MnoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjExNzEiIGQ9Ik05NCAtMTI2cTk1IC00NyAyMDIuNSAtNzEuNXQyMDMuNSAtMjQuNXEzNzkgMCAzNzkgMjk3cTAgMjY2IC00MTggMjY2aC0xNDR2MTQzaDE0NnExNzEgMCAyNzEgNzUuNXQxMDAgMjA5LjVxMCAxMDcgLTczLjUgMTY4dC0xOTkuNSA2MXEtOTYgMCAtMTgxIC0yNnQtMTk0IC05NmwtODQgMTEycTkwIDcxIDIwNy41IDExMS41dDI0Ny41IDQwLjVxMjEzIDAgMzMxIC05Ny41dDExOCAtMjY3LjVxMCAtMTQwIC03OC41IC0yMjl0LTIyMi41IC0xMTkgdi04cTE3NiAtMjIgMjYxIC0xMTJ0ODUgLTIzNnEwIC0yMDkgLTE0NSAtMzIxLjV0LTQxMiAtMTEyLjVxLTExNiAwIC0yMTIuNSAxNy41dC0xODcuNSA2MS41djE1OHoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjExNjciIGQ9Ik0yMyAyN3YxMjVsNzAyIDk2NmgxODR2LTk1NmgyMTd2LTEzNWgtMjE3di0zNzFoLTE2OHYzNzFoLTcxOHpNMTg2IDE2Mmg1NjJ2MzQ4cTAgMjE4IDEyIDQ0MGgtMTBxLTQxIC04NiAtMTA5IC0xNzh6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTMzIC0xMjRxNzAgLTQ1IDE3NCAtNzAuNXQyMDUgLTI1LjVxMTc2IDAgMjczLjUgODN0OTcuNSAyNDBxMCAzMDYgLTM3NSAzMDZxLTk0IDAgLTI1NCAtMjlsLTg2IDU1bDU1IDY4NGg3Mjd2LTE1M2gtNTg1bC0zNyAtNDM5cTExNSAyMyAyMjkgMjNxMjMxIDAgMzYzLjUgLTExNC41dDEzMi41IC0zMTMuNXEwIC0yMjcgLTE0NC41IC0zNTZ0LTM5OC41IC0xMjlxLTI0NyAwIC0zNzcgNzl2MTYweiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTExNyA2MjVxMCA0MzEgMTY3LjUgNjQ0LjV0NDk1LjUgMjEzLjVxMTEzIDAgMTc4IC0xOXYtMTQzcS03NyAyNSAtMTc2IDI1cS0yMzUgMCAtMzU5IC0xNDYuNXQtMTM2IC00NjAuNWgxMnExMTAgMTcyIDM0OCAxNzJxMTk3IDAgMzEwLjUgLTExOXQxMTMuNSAtMzIzcTAgLTIyOCAtMTI0LjUgLTM1OC41dC0zMzYuNSAtMTMwLjVxLTIyNyAwIC0zNjAgMTcwLjV0LTEzMyA0NzQuNXpNMjg3IDUwNnEwIC0xMDMgNDAgLTE5MnQxMTMuNSAtMTQxIHQxNjcuNSAtNTJxMTQyIDAgMjIwLjUgODkuNXQ3OC41IDI1OC41cTAgMTQ1IC03MyAyMjh0LTIxOCA4M3EtOTAgMCAtMTY1IC0zN3QtMTE5LjUgLTEwMnQtNDQuNSAtMTM1eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTE3MSIgZD0iTTk0IDk2NnYxNTNoOTczdi0xMzNsLTU5OCAtMTMyOWgtMTg0bDYwNiAxMzA5aC03OTd6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA0IDM3M3EwIDI1MSAzMDYgMzkxcS0xMzggNzggLTE5OCAxNjguNXQtNjAgMjAyLjVxMCAxNTkgMTE3LjUgMjUzLjV0MzE0LjUgOTQuNXEyMDAgMCAzMTcgLTkzdDExNyAtMjU3cTAgLTEwOCAtNjcgLTE5N3QtMjE0IC0xNjJxMTc4IC04NSAyNTMgLTE3OC41dDc1IC0yMTYuNXEwIC0xODIgLTEyNyAtMjkwLjV0LTM0OCAtMTA4LjVxLTIzNCAwIC0zNjAgMTAyLjV0LTEyNiAyOTAuNXpNMjY4IDM2OXEwIC0xMjAgODMuNSAtMTg3IHQyMzQuNSAtNjdxMTQ5IDAgMjMyIDcwdDgzIDE5MnEwIDk3IC03OCAxNzIuNXQtMjcyIDE0Ni41cS0xNDkgLTY0IC0yMTYgLTE0MS41dC02NyAtMTg1LjV6TTMxNSAxMTI4cTAgLTkyIDU5IC0xNTh0MjE4IC0xMzJxMTQzIDYwIDIwMi41IDEyOXQ1OS41IDE2MXEwIDEwMSAtNzIuNSAxNjAuNXQtMTk5LjUgNTkuNXEtMTI1IDAgLTE5NiAtNjB0LTcxIC0xNjB6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMTcxIiBkPSJNMTA2IDY0OHEwIDIyOCAxMjcuNSAzNjB0MzM1LjUgMTMycTE0OSAwIDI2MC41IC03Ni41dDE3MS41IC0yMjN0NjAgLTM0NS41cTAgLTg1OCAtNjY0IC04NThxLTExNiAwIC0xODQgMjB2MTQzcTgwIC0yNiAxODIgLTI2cTI0MCAwIDM2Mi41IDE0OC41dDEzMy41IDQ1NS41aC0xMnEtNTUgLTgzIC0xNDYgLTEyNi41dC0yMDUgLTQzLjVxLTE5NCAwIC0zMDggMTE2dC0xMTQgMzI0ek0yNzAgNjUwcTAgLTE0NCA3MiAtMjI2LjV0MjE5IC04Mi41IHE5MSAwIDE2Ny41IDM3dDEyMC41IDEwMXQ0NCAxMzRxMCAxMDUgLTQxIDE5NHQtMTE0LjUgMTQwdC0xNjguNSA1MXEtMTQzIDAgLTIyMSAtOTJ0LTc4IC0yNTZ6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTEzIDU0N3EwIDI2NCAxMjEuNSA0MTYuNXQzMzIuNSAxNTIuNXEyMjMgMCAzNDYgLTE2NmgxMWwyNCAxNDZoMTMxdi0xMTE2cTAgLTIzNiAtMTE4IC0zNTR0LTM2NyAtMTE4cS0yNDIgMCAtMzkxIDcwdjE1OHE3NSAtNDIgMTgwIC02NXQyMjMgLTIzcTE0MiAwIDIyNC41IDg0LjV0ODIuNSAyMzAuNXY0OXEwIDM2IDkgMTM1aC0xMXEtMTEyIC0xNjcgLTM0MiAtMTY3cS0yMTcgMCAtMzM2LjUgMTUwLjV0LTExOS41IDQxNi41ek0yODcgNTQ1IHEwIC0yMDkgNzUuNSAtMzE3LjV0MjI1LjUgLTEwOC41cTE3MCAwIDI0NS41IDkxLjV0NzkuNSAyOTMuNXY0M3EwIDIyNiAtNzkgMzI4dC0yNTAgMTAycS0xNDQgMCAtMjIwLjUgLTExMnQtNzYuNSAtMzIweiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTExMyA1NDdxMCAyNjQgMTIxLjUgNDE2LjV0MzMyLjUgMTUyLjVxMjIzIDAgMzQ2IC0xNjZoMTFsMjQgMTQ2aDEzMXYtMTExNnEwIC0yMzYgLTExOCAtMzU0dC0zNjcgLTExOHEtMjQyIDAgLTM5MSA3MHYxNThxNzUgLTQyIDE4MCAtNjV0MjIzIC0yM3ExNDIgMCAyMjQuNSA4NC41dDgyLjUgMjMwLjV2NDlxMCAzNiA5IDEzNWgtMTFxLTExMiAtMTY3IC0zNDIgLTE2N3EtMjE3IDAgLTMzNi41IDE1MC41dC0xMTkuNSA0MTYuNXpNMjg3IDU0NSBxMCAtMjA5IDc1LjUgLTMxNy41dDIyNS41IC0xMDguNXExNzAgMCAyNDUuNSA5MS41dDc5LjUgMjkzLjV2NDNxMCAyMjYgLTc5IDMyOHQtMjUwIDEwMnEtMTQ0IDAgLTIyMC41IC0xMTJ0LTc2LjUgLTMyMHpNMjc0IDEyNDF2MjNxMTI3IDEzNiAxNzggMjAwdDc0IDEwNWgxNjZxMjIgLTQyIDc2LjUgLTEwOC41dDE3OS41IC0xOTYuNXYtMjNoLTExOXEtODggNTUgLTIyMSAxODZxLTEzNiAtMTM0IC0yMTkgLTE4NmgtMTE1eiIgLz4NCjxnbHlwaCBob3Jpei1hZHYteD0iMTI1NSIgZD0iTTExMyA1NDdxMCAyNjQgMTIxLjUgNDE2LjV0MzMyLjUgMTUyLjVxMjIzIDAgMzQ2IC0xNjZoMTFsMjQgMTQ2aDEzMXYtMTExNnEwIC0yMzYgLTExOCAtMzU0dC0zNjcgLTExOHEtMjQyIDAgLTM5MSA3MHYxNThxNzUgLTQyIDE4MCAtNjV0MjIzIC0yM3ExNDIgMCAyMjQuNSA4NC41dDgyLjUgMjMwLjV2NDlxMCAzNiA5IDEzNWgtMTFxLTExMiAtMTY3IC0zNDIgLTE2N3EtMjE3IDAgLTMzNi41IDE1MC41dC0xMTkuNSA0MTYuNXpNMjg3IDU0NSBxMCAtMjA5IDc1LjUgLTMxNy41dDIyNS41IC0xMDguNXExNzAgMCAyNDUuNSA5MS41dDc5LjUgMjkzLjV2NDNxMCAyMjYgLTc5IDMyOHQtMjUwIDEwMnEtMTQ0IDAgLTIyMC41IC0xMTJ0LTc2LjUgLTMyMHpNMzA1IDE1MDloMTA0cTYgLTQ5IDI2LjUgLTc3dDU3IC00MXQxMjEuNSAtMTNxMTAxIDAgMTQ5IDMydDU4IDk5aDEwNHEtMTAgLTEyNiAtOTMuNSAtMTk3dC0yMjEuNSAtNzFxLTE0MCAwIC0yMTggNjguNXQtODcgMTk5LjV6IiAvPg0KPGdseXBoIGhvcml6LWFkdi14PSIxMjU1IiBkPSJNMTEzIDU0N3EwIDI2NCAxMjEuNSA0MTYuNXQzMzIuNSAxNTIuNXEyMjMgMCAzNDYgLTE2NmgxMWwyNCAxNDZoMTMxdi0xMTE2cTAgLTIzNiAtMTE4IC0zNTR0LTM2NyAtMTE4cS0yNDIgMCAtMzkxIDcwdjE1OHE3NSAtNDIgMTgwIC02NXQyMjMgLTIzcTE0MiAwIDIyNC41IDg0LjV0ODIuNSAyMzAuNXY0OXEwIDM2IDkgMTM1aC0xMXEtMTEyIC0xNjcgLTM0MiAtMTY3cS0yMTcgMCAtMzM2LjUgMTUwLjV0LTExOS41IDQxNi41ek0yODcgNTQ1IHEwIC0yMDkgNzUuNSAtMzE3LjV0MjI1LjUgLTEwOC41cTE3MCAwIDI0NS41IDkxLjV0NzkuNSAyOTMuNXY0M3EwIDIyNiAtNzkgMzI4dC0yNTAgMTAycS0xNDQgMCAtMjIwLjUgLTExMnQtNzYuNSAtMzIwek01MDQgMTM5M3EwIDU3IDI4IDgzLjV0NzAgMjYuNXE0MCAwIDY5IC0yN3QyOSAtODN0LTI5IC04My41dC02OSAtMjcuNXEtNDIgMCAtNzAgMjcuNXQtMjggODMuNXoiIC8+DQo8Z2x5cGggaG9yaXotYWR2LXg9IjEyNTUiIGQ9Ik0xMTMgNTQ3cTAgMjY0IDEyMS41IDQxNi41dDMzMi41IDE1Mi41cTIyMyAwIDM0NiAtMTY2aDExbDI0IDE0NmgxMzF2LTExMTZxMCAtMjM2IC0xMTggLTM1NHQtMzY3IC0xMThxLTI0MiAwIC0zOTEgNzB2MTU4cTc1IC00MiAxODAgLTY1dDIyMyAtMjNxMTQyIDAgMjI0LjUgODQuNXQ4Mi41IDIzMC41djQ5cTAgMzYgOSAxMzVoLTExcS0xMTIgLTE2NyAtMzQyIC0xNjdxLTIxNyAwIC0zMzYuNSAxNTAuNXQtMTE5LjUgNDE2LjV6TTI4NyA1NDUgcTAgLTIwOSA3NS41IC0zMTcuNXQyMjUuNSAtMTA4LjVxMTcwIDAgMjQ1LjUgOTEuNXQ3OS41IDI5My41djQzcTAgMjI2IC03OSAzMjh0LTI1MCAxMDJxLTE0NCAwIC0yMjAuNSAtMTEydC03Ni41IC0zMjB6TTUwNCAxMjQxdjE5cTE0IDYxIDYzLjUgMTU2LjV0OTguNSAxNTIuNWg5MnYtMjVxLTI5IC02MSAtNTUuNSAtMTU3LjV0LTMyLjUgLTE0NS41aC0xNjZ6IiAvPg0KPC9mb250Pg0KPC9kZWZzPjwvc3ZnPiA="

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,d09GRgABAAAAASdkABIAAAAB/oQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABlAAAABwAAAAcXfNfrkdERUYAAAGwAAAAHgAAACAD3gADR1BPUwAAAdAAAAAgAAAAIGyRdI9HU1VCAAAB8AAAAb8AAAKKSI+4209TLzIAAAOwAAAAXgAAAGCiEJedY21hcAAABBAAAAMiAAAEfs0qHI1jdnQgAAAHNAAAAEgAAABIDq0Rr2ZwZ20AAAd8AAABsQAAAmUPtC+nZ2FzcAAACTAAAAAIAAAACAAAABBnbHlmAAAJOAAA/nQAAbpEET54PmhlYWQAAQesAAAANAAAADb7e7SGaGhlYQABB+AAAAAjAAAAJA7dCW9obXR4AAEIBAAAB1cAAA68gD2vPGxvY2EAAQ9cAAAHRQAAB2RTIcQcbWF4cAABFqQAAAAgAAAAIATnAsZuYW1lAAEWxAAAAQkAAAH8K4dGNnBvc3QAARfQAAAPGQAAH3APjSRLcHJlcAABJuwAAAB1AAAAi66Pg3UAAAABAAAAAMmJbzEAAAAAyWNIlgAAAADLBqfmeNpjYGRgYOADYgkGEGBiAPKZNwBJFjCPAQAL8QDlAAAAAQAAAAoAHAAeAAFsYXRuAAgABAAAAAD//wAAAAAAAHjaXVJNaxNRFD1vTpM0g4tAkqqxFHFRsijFKmTZlRRSkkwRKV0FgtCiTBNlJkaEfmptq7b18wfEfqlV202LS3+DC7dSiiAiIhKki0J638uAKMOcc9+95368OwMFwMYVfIZyS34Z7YjByju5s0hfdvKCQLOJqKgUiDaEEEZEVFHjt43f+i9iu9fGSuh3y9VxXHIrV10MVrQ9dEPjiFdyfRQ973wfRgUvoCx4Eb6vo3dMxVa/iMF2Qcv00Kc2c9LWX9avxpZPz2GjA13oRi8y6McAChhGMdAOBTwa8IeAPwb8LeAfATcCPmyxSpgZlEpJrxhCfMt3fM9t7kg8hEF8wT4O8FWivUhwgpOc4jRnOMu7vMc53uc8F7jIB3zIR3zKZ3zOF5KbQA+WsYLHeILv0v0nfuE3Guq6qql5tav2rLI1YTWsP6INc0XqK8TRae6cgs2XXOM6N7jJV3zNN9ziqtlaXB4gKUrFOuuyW52/ZPaV0PbRTV1L8rfMPcNHno6J0tRFXKyk7PMkTuG0eM5IpX/0zU/6H1AF5QhnzBcL4YTU7sQ5pHlbZsjCYc1wjrck22FVMEdfMGsmyR4DxINgFwB42mNgZlnIFMHAysDAOovVmIGBUR5CM19kSGNiYGBg4mZnY+ZgYWJiecDA9N6BQSEaKKgBxAyGjsHODIoMCv//ssn/E2Fo4ehlilBgYJwPkmMJYt0GpBQYmAGW1A7aAAB42s3SXVBWRRzH8e+e/wPiSz0ogiZ13HNIrDQ1KUhEQCQUU8p84QEUtDDzNVSydEq0lMwUzUqbygbC0tIAx96zZvKipi6aqQvHxsE853DdNONVL885beA4TV10287s/vd/sTufnf0BwsC8EWVWrGbTqf4+ZiVMPcQOUhnBdtWiDqkO1aN+UZGVbRVYZ62vrW+sXuuKKBEZLHHJkb2yTzrkO/lBzsdaUzJsZZfYu+1fx87XQ3WmtrWrc/UUnacLdZEu1w26SW/VLfqYPq5POSlOhpPlaMd1cp1JTr1rualu3B3hjnFtd4I7x13urhz37WV+j4VRlIwiY9O0G1O76jam36zR/aavjOmCMXHNtMuY2qRTvjcmYnts7GJ7h91uTOh0PUprY5qsp+pp10zNxtRpTCf/Yaq7ahr+N1Njvwlj+iOKoiA6F/VEndHhqDqqivKj7PBI2BbuD1vCNWF9uCxMhAvD0uTl5E/JS8ne5MXkhWR3sqvvXF9rX0XfxODHYHyQE7iBE9hBVpAZpAfxIM3/2b/kX/TP+2f8036Xv8Sv9Gf7xf4Mv9DP8wd5jd4Kr8ZLeAu8Kq/My/Xi3rDeEzmb05pj22T7wJ/+z0aqNeSvoviXTmFd3Vn/ccfASSFGiknnINIYzBCGMozruJ446Qw3mc1gJJlkMYrR3MAYsk2qb8JmrEmOg0sONzOOXMZzC7dyGxOYyO1MYjJTuIOp5HEnd5FPAXczjUKmU8QMiimhlJmUMYty7qGC2cyhkrncyzzmU8V93M8CHmAhi1jMEqpJUEMtdSxlGfU0sJwVxt/KszzH87zIK7xBJ29yjLd5i+O8w0ne5RTv0U0XPZzmDB/wPh/yMR9xls/4nC9kJptoZCWrZRZP0EETa6WBLayRR9nDq7KOzdIkG1nF4/KwrJZH1FFZzzqeVK2c4FN28hAbZK0qkw2yivU8JeU8yNPs5ogaqTIlXwqkWEqkUKbziWziS1Uo86RWKmWuPCZbpIytUiSlUsEu9vEM+9nLAQ7yAm28zGHzwpd4naO8xhW1SNWxUVWrhKphm1qqatXiPwFf+f3NAAD+FAAABFIFtgDNALIAwADJAO0A7QD4AKgAhgDoAOEA1QC0AOQA5gC+AN4A1wDqAMcAzwCWALoA0gDcAMQApQCaAIAAiQCCAJ142l1Ru05bQRDdDQ8DgcTYIDnaFLOZkALvhTZIIK4uwsh2YzlC2o1c5GJcwAdQIFGD9msGaChTpE2DkAskPoFPiJSZNYmiNDs7s3POmTNLypGqd2m956lzFkjhboNmm34npNpFgAfS9Y1GRtrBIy02M3rlun2/j8FmNOVOGkB5z1vKQ0bTTqAW7bl/Mj+D4T7/yzwHg5Zmmp5aZyE9hMB8M25p8DWjWXf9QV+xOlwNBoYU01Tc9cdUyv+W5lxtGbY2M5p3cCEiP5gGaGqtjUDTnzqkej6OYgly+WysDSamrD/JRHBhMl3VVC0zvnZwn+wsOtikSnPgAQ6wVZ6Ch+OjCYX0LYkyS0OEg9gqMULEJIdCTjl3sj8pUD6ShDFvktLOuGGtgXHkNTCozdMcvsxmU9tbhzB+EUfw3S/Gkg4+sqE2RoTYjlgKYAKRkFFVvqHGcy+LAbnU/jMQJWB5+u1fJwKtOzYRL2VtnWOMFYKe3zbf+WXF3apc50Whu3dVNVTplOZDL2ff4xFPj4XhoLHgzed9f6NA7Q2LGw2aA8GQ3o3e/9FadcRV3gsf2W81s7EWAAAAAAEAAf//AA942qS9CXwURfY4XtXdc2buI5M7mQxJwBAGMoQQkXDIZQTkDBgCcsmNgBgQERERARERUFRUREREROyeGRAQMYooiNFVV3ZdVl3XdTWC6OKxEEjn/15V92Rg2f3+Pp//7sdOT03RU/Xeq3e/10QgbxEiWQ37iEhM5DoSJZQUxyUDcUrFUSrCvYndU9kclsnJuGQmdqlYllyKgRbHRfZJsdBi0rFTxB10FwTdwbfEG5pzhUXNKw37mqqmSf8kAgm2fCuMht9IIU5STqJ2eK5sCcdFiTjw0S72aKOV+OFhblqsGInbo9jsFRVEsYtuj2yr6NipvHOXSGmq32cM5Rdm0iANjhlZ0WfcwMq+S3dSl3p+/JDJvbrfNPF6+qjYdMkIv/mZuENcou2rlEQF/E1DJC5JxAwbIKX6juBnTXwP/GcFCX62Y6dMGhEj3oj42YDvHv+q6rsnxB2Cq/ln/A+eHSHEUA7PziS5tD+JpgLMov70jEgkEjXB70TNKTa4jxOaarIXxwR3VnabQEQhhsaYL5CW2SZQGjdI7CvRlZOLXxngK6PFaoevqJwXljNOxtPNJBUWmu5SUmmxbCqN+/mAuVT2u5QUgL6NDShB+LpLxsHu0378N/EXWw92X3G2Fm/kDFdMyDB54VfY1YhXeF7Mkm6Gm1RXzJqaAjd+V8zut8EEF7u62dWHV5wTYHPgX6WxfwXPzNSfk6U/JxvnxHL0mbk4LvZ0CSJuyeXGPWdl5+R2uOJ/cs8MJT0D0GtAgHvLg94g/MfBHjEFxSD8F/KG4L/yiDcUcdO0Eep5Fy1aFF10adGeRZcc6jcjqNOpfrwovvj8oj11XzcNa6LbdtKcnXSHWoP/7VT/vlMdR7fhfzBOCFBD95bV0gCjh+SSAlJM5xM5JyxnRhTJ2CgXlkZzJGtxrGdOlqVYzi6V3WE5FJa9ESUFvnUAatqHZfNJJc/cKOe55Ky8k+54Nj8Q2eF4FruLZmfhE7IJPCHPpbQDskqD6Taca+fHpYQjrHLGvz5DPElytku21ctZLtleb4APMSkbgH+w8vFzL8D3KTEDfjTEUvAPzIo5suwAbi9eWyf58KMhlol/8Bk5lz8jnz8jpD+j8PJ/XYwfo/BDeQ/mPRgyOtyeCjm/IgrDeOerIHsNNrsvv5gjjva0SYYUh9eXmZMfKiy+AqeUKFIOYJVUyG53jJrT8toEKpSUEJwtq6sCT3JZDg14O9Cyzl160IgpNWAqLBJzBDjaThoqL/T6Al4H9VbC90XdB5+oHfH0yh8/LFgZeu7e6gduG3JvXdef/lKysuRo8219br75zupb5+/++JquAl3e9YW6F4+7n3/B1ftAb7O6NjL69sG7P/F9+qldXDexHe2RMvbS5ykTB93aHo4uWdtyxtjPcILYiZtkk2LgSftJ1IGnuB1clA6GxqgTz7EEFyXD0BhP8bWT7MVKCtzmd2a3+YZGKndlHMRjJrlAAh6Xkgan0sQ/mVxKDnxqzz+1dyml8KmAfVIqgCg8wGtkR4Wc5o6mSO6KigqltL3bE81v54R7ucAtu4D5pXQAoOW0hwGfWykohb/5HoV44G+GWzGlITC9nT2cLwrIGL00QkVfpBSBF8p3UHrZt+VJ36ydEVu4dMWcffPvvr9Gqnz74pHaIZ1HdRtWPrpMGDcjtmDpqjn75i1d8dbQzqO7jeg8qkKctoMWbXpi/Va1YfOW5hJk7eLElXecnrL8rr81D36ZXvPYpnXPqSc2P/noA3XfT1s+/xt21nq3nDHUGBpIFikknchCjVNmIIzzjI1RM4I3bARAliIglWw4KNlMsihFcFvkUtrDbYq5UYngkMHtAVaW1wbISW7vjppDDgRViifm9KUGYJAoeakAVPg27N5LDCm+Nu1gFEHUpbywTBcfJm+X8ohg8gaLHJTBJDVS2qWcAqx8AQROYSjf2Pvl46O/PrB1f+yD07MHNM7b36CeHjfjk7sPf/rT3DGDHqpSz6+YQI2VG6cP6D5qHB238eTEx++Pf7Zt9bL3x6gH576mntuvNi4f0v/IO9Wz4clLqlYKK2bX3ljXp3f/WQAWkLAgmwSJyaZ8wqUsYWKJyhKjKIGLQgOTqyiJUApxCcT+/WD1kBiAf28leSQqwr+ncgqDoBFgZdMkmWxhbNXloRHidnlDwuALpOVj1TH/tY3UR0cJ11Nz81+b71FfU3+jBraulinqISGsP1fSnyucVEzac02Czq5FeKYY8bhdAt1Mz8Ezf1dV+NdthPtof2pX/62+qu5qfkv9ja33LaFaWm7MJQ5CvOUGb0AsMBV4TSm0iL7Vn04s+OwOutGmrt/VMOWbbbRAWnckSpcWq+sDDSXq493pfPXYI9TKnlNHiZQt7QQ9YiSRSVg2RRRqaJQNpaC2INclVgtoLQRvqWiB1dvCsvWkLJTGLVx4SqVRixW/tphgptWCt1Zg1YqdgdpbFnSDGuMPukPuOro4ThepK+PCwjhdoi6Pq6vpQoDRZvU8rSZniRFgBGuICxKxIOZMXD+yEitgzsweJ3bxRgKCacr0W86Yl6xVz5+l5oB66RSngTA9LAwTVgMNBPE5CpUa8b8kEjAnSABkoylcQn8voYdPnIB/G2z5hg6mPoBDB9KqSCX0KVuSPqWrVXyDyUpUcNyIrtffMqh3j3HDJ/XoPnhqf04D2+Hg7me0SULATWrF4sZLn+F5B72ntuWMNBDOs51kkD4kmoIH2Q0HmfHJgAkWn8nI0AGn1+FS/EgxQDlZ8NcPMkWRUlClC7jh1kQY93J52uCCXIIUyhf4WfSUueAICrU7aGDf629vUb8/8PabZwfXTH5h0rYJO2bSP9Es+o/ffzyjfqjm/kZafli36Ru66VNq+5s6h8H1HKw/zmh4ONAwrFAWI+yMyUKEkbN0UhE5OTMp/OS5V1EKO0CnlQ0gf0WXLNSLRDZ0oIpgYBKNAGKA7q24YABJCDgIiKpz9NK76vGzb2R1qRj8urSIdgeWOGXTnvJwHYPjWdCre4CMyST9uVatpEuNURdCyoKQygrLxpOKF1aSDeDxGgEmGZkInnQ8u7RCtrijRpsXWZzLI9vht0PltFLgDMpUVEkZIh3URP1Bk6cN/ZO8pOukmn4P3jr/zi/r9p4cvPOYely4rV2c7nj2kcX9Rk667qatE4Yf3DLr4JGX1fPmjxiscgGfuMa2ZDqJFuEaQQ2KpuMaPSaQetaidC71qNwOTttJJQSIDXHNR3HCvTOsZMEOrgHiUqQiLvStboWGGGNWcvPgr8et+LPgb7pHTtWkP2C5rHMwVM7+XrYfo8mfQ+EPkEPuiBPjnpHVH1YUzNj+0aSaAY+Nnnbnp4te+/DdXUvXrFJb5K+7/alT2bolp157bMlNYyLdnhvaS3lyyx9zTWnbF6/46HbYn9ByCXDQ23AQaMFDHiBRC1KDOcJsgThJsQiwOQk0dYWYGhWTtRQUPG9YtpxUzLAnn0Yfz557j9OHhetnZpcs1cdMZgkUKQvo0BZUxmx4BaKxd6BxyWS12XVlCGS4hk7BLTth+2I5GhYm1GoLgkBIIaNJKhBD6vHjxcf7fNtXfZqu7ZPb1xwZQbsfFfdfGnBUPQJ3tGzVv6onM5yVAc5GM9vjPsJFqQg4Q5NKcUmNca8lw25HempU3KDGWNyM26UgM+QUl2plFMdMhvlnM5mlYO8guzvIdpficl5wyG6XYnNeILKtA43ZQH9v1evEDI5iC6A4latyqToOTUVeVNg1/gL4K3vx1VfevvueW+4bfUw4XqIaZ4yt3Punh9RfD5/s9vnkHRunLw31Ed75WH3U89G+535dgfgic2Bvs4Ee04EiZ5BoAHeXDbsz4O6sQJGuUMAAu3MZOUUCq8kAKsxwoRHEzhJQohKEVcZcAXsIFQWvW7Ea8FiFsmHtXjhMbjhMstUjmytkg1s2MQUhgwIbAj00lE/EyGUaU2pCZRLnLPqYFrxTV108YHaDer6Xccnxp19d/cOTb3/87aQxQ+/uE43c3LdjDj3cQDfQrA3pb6eqzeqFXe++sk39Yd3P7972wITdU44VXtt/LOBwCdDl04BDI8p/5A1MiIPp2YhyhEkPReSiFuxqCmaRiS4RzjWPKxa3B5utUmPDzqZzwKEHArzGAT8OkBAJo37lR4hlGjTVqgQPbkcGJrBBYoY0Yi5W2gDA0phyqrjh1u2SU/A0XwP314SZstUJvmqTBr8uVMg57r3+THOwqARheQ1qrEQpyXR7UL9yB4u4fuUqYMq8doDx/CapVkAcoGl5QUXTtauBdO6Ym9QTsT9seenO6Yv/8cyJb08vmDR/zYQxjz3w1uBe85eMHzL2dlpL263st2lU7FR00/1Heg9+9fZFb04/9sbYufdOHbOirMt6Yc7wWUXFd98ydMxcTS6VM7opJDNJNE0/FYzbhoyNcUt2mgvoxoJ0UxSWbQm6ydPopi38zbABDxZBq5bz3FGLy1iBZCOm6SSPhzjbIxsr5JBbQcask783hKRSpqvaVgrE7/UlDoaD1i6af+hMN+O8+hf2PvDTU/UNd7yhXoitOFQ7um7b+OphS/vYPir+nVq3fnDwaWpd99PfG9SxauNKcf/02w5tmLVs3A7CzgbK/CZpBsj8ABmUJPVlfzju1AR/WpLgj9mMgO64h4v/dNifjSuFstGtiH5kzB7gSFcoBd6rKQi78WbCoN7ddU1BfBBvbprSH3js06AP4bqMwGOvIbIrHLdqq/GiyIjb+QKAnSp2EwKY+1c03Sj59ybfMhX1pGX6r6nnT9I8VJikQ/rPwVmZT76QMqUz8HvEW0b9FuqfL+5s7i8cENYsot8fUXeqHx9FeNXRPVK2eI75fzK4hgWqohRGXwv6fjSvFah8fgr/1Yk7L40Wd9I98ThdH4txHS3pt8rLLBR+br6wr7lK3PnFURqmo4+oaYsYbra1fCseAfpLIQXkDrAkkezyTY3JPq7CJNTIgVLZ6IqncdsQkGZ0Kbn8PCpF6DAgzOcFiIqKlgLUAHI9cYfPn5nPrJx8EQxFd4B94XD/h3PMqx9E0A1ClbQ8oTNsQ8BOHNi7e9pHJ15+Z+nOabXOo56Zi2feVDBy6KANgxlyb5rc19Bx3svP3HlkYdWCkSterRk0ZGjHfqPLC9g+J7f0M+4yxElX0P7qiVwWjnc0kHS0feFMReLd+If8UrlXOJ7OP7QLozcxHUHQl4GghGviJUw9jFdwGFS4lEL4ZOYerX6aeGr62cxFb6VL7lGv5LguyNn1JJadU9mDuSESdyidlMIKt+c1mytdatextIwBqmMZwDGCGohcWqH06gZsy+zyOwtLNLblaRMslTwaqy9KOsU5NCAa/Zq13CaULwl+F4mUlvthShuhAL7o0oOyoz35N3qAuo/RNk8tPHn/xOk2463y4hUr/7Wu88iq2ltzbhpwd3+15fRJddebNP3isX+eOv2J+u5LQs+5wxa261nWuXr9MPo7WJ77mh4DLVdWT+2ordrxzEOPU/qY1ZWr3nl7Se2KP9/1j5/eUx/9GwiTf1Q/VfMi7frtM488+rNr5l44eytBjgw27AcKd5DNmpYpSpGEvhs3mgm1g54SUYwS2kkUNDZdAXZxKNcPv7AhoQCn6AqwnOKKGVJAx4lZ8HqwvlfTDcxTZMWPUbi2eoqIYk0BbMQFgwVvEtoCNWuu2xANekNiUKRBobDMaFokOqlnxw/t1MyPaQWd3TalfJRhf9MAukmdIUyhW1/tvGYnnNp+sLcTICOdJA0sradJ1InaG4koLlMj25+SBwpBepoTNqikI2MPhmXfScVmbZSzUaIZQNHJ15S4Vee4S5R0kPM6yAQUHfcFdM9R+ONyxdJcebDTdLyKewl1paXntboos33AtSxmFAZpLn4w091sQM5LSOgk3VUKFnHWX0y5gltM+wHrWPflN688OWuh+kf1t8++2vjinXcca/vemie+2mvYt3P7hrdzzFmPz/r8/PFV90yc+vaiObs5/1nZcsYQBL6SRnpy34niBjT6cHdeSTO7rKg0pHOzC3acgbqD1QscgpiYf0Ryg8jSLa2AqQNF48qP4omRM1n5KR3/9893j+vxcM3mc+tfeG7tofjb59XvhCCV6OHva4/kd4yqL38Qf7NPw/W0HfAAwIshF/BiIV4yXtOpASugnXEfO40oXrRvfGHZeZIhwa8h4bFzT+tI8DIkWAH6XoYEMQYGvDehM3utrbpPHnGDdYgwbeNhQEVgzqNO2uaYep+qLl4JdLZW3rnBsE/9Um1U/6XO+svx3bTrsf1vcRgiHS1nsYfp2gmxSBoBSaAvG9gJUQwIRVsYzWS21s3nZH2tElurxX4Box4U/oDWb7Dg0TDjFQlGMpgtCYIhbNma/zpoguWK5uLmb0fQ39up5vFCZrFhX4Nad0LteiKxvmUMnuP5+uC0ti7PbGDLM+PyrAzJFji6Kdoqt5x7h6/SJdN6NFDAMkleWgxXdrVl4aKMxc3fjae/l6i2pbiia08079RprhZoLpvcQ6KZGs0lSC3uT82UgKMEIoofSRE4Sk6C9nK1ZT1y7j62LF8Hh+ytNygBD1gVafWA1zTk2l5fIK2VS/jRG+AgFRWKFb13ZkaxplbfANPKJY1iMUIggnKZR1Y20IU/zflgas2erVtU9bHo9tkzhqiniwXyzNzP7lcvqn8TMqmZ7jvXrtOJ6r2q0vDaoSCd39Cc17aAttHhbljD6GKrpoObzCkRjXdGBYMRIziiVeefIuxWKtV8K6gmA4dUKAhrAW4FF+rs6OtAvy/6L9ERZ09YkCdYYKbyqXNxBhfgrWKKAPaj2RWTzAZksnjFcSuOizFRsliT8RYRg150PDDM/bhU6LL0R/XE2Yea34cdNO8SqpuqhI3Ns/V9CdOY/6aHRk/J/g/mXEL2D2xeXz4uONkVItLEz8JhKz+tHmfuH0LVw+o0YT4820ZuJlEjPtMUkVPCCBwq25l5if4eh/a8p88d5JLFiK4VAI1sBiJAiqTsqhmVKVzDNqKG3bETLUdEw0+jDaEeNozoe7yMFp9VP+rw3dFp6rLj/ibDyqaazz/ScTiFrWeldrbNNg2DimCIRNiiYL82jMC07ldf39ZzH3DE8HOUAnNiog0QEEvBaxSuSfEQEa0BFHTsylQOgTK3EIg6ovmHEFXlNGihQdHEcPX4WnqGZjU/QXupTZceqwN0Ve4QsponXfpOWDe5+bMEjxIXwT4MpG9Cije2Is0YlulJtnLTFQefumRSD+Qni/WiQsQkgqGM8/yo/s4YzsVAA/5OH0KM38LveMk+/jsxk9nhbRPQQWZEkPkYyMAoQt6skXWChz937uNWjgOn2yV76g/W33DhNxw1yA448c56RfReMIAScbDyxXNnOQWYXbIFdAsgAWO9SGKixelhKtxrFKOEDv5Jl7hmL/oK7SC8TG70NnPwpnB5AOcgyFxwIRoSQ0aT2AfkwfWzjcI4Olr96Jt9RWFj85KG+UZLh/2w7+XSkqYqcdrBpy/2lg4v+PLSJqLBwfAFwMFNPtbgbXXrdGO2IBA8DAjcQGZAQLbr1YDw/Lkvk4EAJrSjHk/3fjZq5n5E4MZWGFV+yWGkZXDFjAYzkJYJr/BvYk63A4OueI3CfRKluSqiMBfvTBVkr8lhMDpdWuTtNWqyJn1OqFoYuRZtFRxENNLFU87hBEYAA5CNrjMZS51bT6kn1EvqFKM1LbAbwdOF+nsJ/2qqktb0fWzppQ9BviP/X8t8vJmtPl5dAqRJ3HPJGX7Cx8tdSsk+3rQrfbxMigPf9mo+XmaSCCuP0urPL9LAYTX2V9Rwzz+/4cEvFm955MG/LRVyaQo98IN6Uv03iPWB39Bian3l0Jt0+Ie7DterLzN7BGXnJubr9ZIFGrezRpL1kLglhaCbz6KpJLBwKyDV6lKcsGDDZZT9WZIstbpAcsUsVi8yA7yCLLWkJGkoKe7LdD8SDIleXe1DDWXwt9+rr6gf3zZ/y7jokbpFCw37jh87r/7e/IVw5tkNsydzm36lup3B2kVy0FuNEUjFp8M6E2Gdy+nQyugwTYM1Oi0QwDHJZreiYwaOSQoA3edgXEjOdF8JemIChvRfoa9e+pqa1a/ez/0fKDis5oxRV9MBHA2H6PCPdTRoeNgMeLCTVPKwrmXZI62YSAVM2BwMEzbERIBtyw6YsLsUD2ICtpWWYMsfJWHC7pJT62M2eypgwoFXwITNkarzCo8dCM1srWDOPAsAwWHjWkSq+3LdHGTnFSga9tXZV16+oF766ODiHYt37VxwNyDpjXde+KZz80phQPN+0bFp+fRaxi+KWs5I3UAnakOmkmiI8WdQd92IpVTEUkFYtp9U0gFL6S7FCNvJg+2AQaukw+qiVjGEirgRjIZsZjRE3ak53LkU4qIv1R2jdh/GyWXmpExyrBZ1APMdneNMDwKjFGxTZmWE8oteUVZvGbZ8+uSyxV+vbZCrn3tg9v05PaY+tUD9Sv2k/G8T6qb1nTn8+tuW33Tvu7Nq3xxcNy7cv3uvCXvrPjmLe5IBZ0cAZyZSBbKcsuwYzgGJ1KhIplKeIQMiHU+JJaEXcxUGJLqpHpgaaJwiTNYFDwaqgOtQuUT8Z7G6XP3tRwqqa0PDxYDUCL/5BPAW1Ln8eFq9lKuU3PfpcCLbTWV0AQInJprQWSlxjQoENoYblEBCwVzBxYoDffKy0yW7QLGwu1A445UJZ4eEGQdeBmcrgzN6eoEvomnPgr5wKxAw+p/wvfVjvX/hovW7it778f2u6h8ufv4jXTl8lLji0sLR/abMe26vuPNSH/U3tfmPXF4fBPkxgOkdQ0nUhrojwT1QS6vKQVv1jPouTcd1graBvKBoYBNZwACTTefgxKYxFG/ECzpvpAuqQMGD31dZBCr1u56+pzZLqmrYd2nh1PsGRpeLq1Ejw7WAFWHCeFcWuZdEsxCP3ghfjtmNy8nWlwPqK/tpzETJ4m6XrHBc4HeUu2OsZlIEn6yuuI+7aXxh5ilmio6hQva7FXMmquo+Hl9WSBYQuGQLVFTwpfv4yr2wg0rKtiAWYYyDBk9867Ubh3ejy7/OFUVz1ggvnfJ78zxVLTBKxnA/dWkLgc3tWfXJFw+IN1w68NKh0aeKxcEgu6sOzHhk46V9LKa2HuBewHT2Eo3ba9EcoF2mmmPsxso0b6IIKBMlawVzQIgRL9fK6Byhqun3KN1Arc2fU08LqVerREGIN/8DtLJrm13CkGY5gWNYEjHjmTfhbxkjjFTB2qWyhYXDQMvHk0DRICdwj05GwLtVI9Nd55o5mTLNl2vBV9F/TczVzsAHIlsMeQ+e20xlWN/6288CS2qeJDxzaU7zKaEdg8HncG63MXuxg8ZpTbrEELmViOYhAQnA4k6KhAl0Rh4+ZIGEoKkoKA5r3lUsLgtd2i2sKN4p9fho98UjDTz++616SHQxvjCQaHaooZFFtyPJrlNNDT1yuZVsMHEr2cQsesnQasOI8LshGjFl0iV0T9EX6sdfFKmHjE1y01SF0/EXIEhWMrsFdGCRMtWX0THIDz0oTjl5ArGKQKwC+6RbL/XR359Ktl4AmqEvPjr1sWa7tMxTDwmb2b5GEhZQAnyyrYmlSakEQullG3zy3Ctsg0IH2dgBzTyTdAG9taIEGwTN1ZS0wXIw0MqDdF3BKdrpiyK6B9jfIcXwpHzByPZXIKRLPsNhYgS9isGVpQxIJzGJMjWRMsDiyyItEMYvpa79h9TBQrr4wqUxQrR5MOyhD+xhY8sAgEo2yz2gzLOq/aHMuc0TDwDPh3LETjnqoYceIlTIlj4XNxmDQMt5BKwJzFmw4z+w6DkLKbAAK/untCySGvCHOsA/+i088pFeDxht/s2PpfdQUM6PAzm4VJpCPPCcaRrncyEJphoboxYBM6YEHrJj3rhWM8IG6Erh+8zHSIQXlRdXajZKvBR33GyyOzKYyzY7FT1XDjsKTIsenWOBlUCkPCKGykOJsFxCjRm35tcNEx4qslbGz+zzG7e8uXb72aEDhm2ZMm7gyE01dM77dHzDmFFbLu6R3zlxeMqtT1Fp8+iZm9V/w37CsJ8hRh9oLSFSq3kB3LifDNiPVeBpSlRuo9tfSAHIDkFxUQo0thgzmty4djnHrVjzUNpk4MnzsSiSyW6sqNDMQgdFntgaWywKmRLqGG4jTKtO97eXOs01m6rXb1tzbv3EtW2tPR8ZO3Lko9VPDd02yehTYz1eD88b9dG+99VnjtVUP03rxs98hprWHd+qXmQ0BvgRGwA/AdJdiwU6MTsDN8JCX2m6NYzxIKI4/TwkanFHicnDnIWcVQDI9XiooMlK9BUWjttIrS9tX9Hvrkmbjs2dVLWs10MvvPNnuuIjOvzN7vvL1Ia/z7mzfd6R/n/UaeULgC2oxmQuidoRth5cUkBfUg4uKZ8tyQ+w9buQb2tZrWiuW7XkrxBC3I8U4wnkIKRt7rjJ6HBmMorJCSDFODVfp2I0tWbFBSIo4+FUhrR4ZDLRrPt5Q+xmsz1tYKO6b7/XNHp77bptZ58Z9tyEUTePfHQ0nddAJ78T3TCNTrlwRp5Rc+Lwie3UvHLMbZvVX7nOi7BuAlinA+1M12LVLoO2taChMW7NCGCioNXAKahV383RbGqkoBxQEONSiiuQwfV4xetDEnIFOAlZQa6ABsNC2vphYAkzPikYMumoYbujiWSKcU9Ry/bnYmpM/aBYmDd3wMMTxj836egX1JZ96I89e4x/ia5/l448uH7Fvobc7Dn3FHZ4vX3Bl/TVmRMjFbuBx+SqPnGPMRcskh2gTxDmFmiM+nFXaTzXygz3sjus2IzMQEFzRDOLv0gEEiz1Srr7guwDQ1hyxQySBX2SeMUEYX+6Dz6m4VUkMcniS+e2LbpRff609CTbFsQ4aBhyDiZKoqbsRzDIbsylkG0YjgZmxxyDoR5Cq5bspJhhgWAp+rpn6QPFn8f8b/vb790xf3z3qsq+w1M93xZ8+1XbfRtruqmNvgZRnTGw9t0XQR2qnlgdvfjNG9EAEVtWqj5pIeC3iHQmvcglEi1AWBRjaijsP17J0uJld2nUrn1ETtw1UGC3wx+NIfdm/LWtmXSEqW05RZcBERhQB8vkw2Uu5ToY9sFwB9Qj8oEyrucQPU/q7+UQLXXJneqB1C/IefWx3Jw8b3EUrkkhmFhObqdSHhTT75gSnAmab9QsslhhmVsurpA7eOL29EDXSkzK9eUDbDGAEyiG40UMLMAodwUlLx3mV4L67MPTZNISKLUsykDQSXmssQg16VzKox5JAf8wS6dsTZ2gi9ZsHjh28srfjg8ZQpfm1medPda57Zwe1y2Vn1A/UX848dVnc25/fn/NvNVz76TZ/Xv3uqVsRa+JXT6duqlzybC+t4aHvvzOz77VwWtveusbc9uehVlmV+ryu945uWlLr0Gzbo1ca3N4Zoie/oMGrxr68KAVLLcOdKQq4D0Z5GeNq7vcLDuf8fRUYyJRTcsCSPLj+jh7j7nsPrOWIRFWXDyJTaPyUzxrm5unGS7m6Dr5yymOKTd6xGSXS3bidzExA92JBnY1sms6XqNwTXL4GCtQuRYrCLrDDEanJ3EE6N7kz61ORxMgD10s1lRkF6mo6prsuqRB+tckjQnUyS5MvphEFDAVmR285hEvjV21PrDmh4c9y+YeKZkIgqXpnhdvnDHuqUcGTmyeL2ytKVjZ9LlawvkcwFKoNjSBzuHUZSTzKAtMQwNrJ26SSFqijCPhW07hIJWQpq2gk7sTFmQsoaYpgqQtHJ2WYI4lpwOEz5w+HR7cv6z3kF5l/aRhF/cYJvYZUdal/7DOuC61SfWxddlIGrmTRK06pzIITLUDUzLu0haWHpYNXFm3s9AZD5Mlu/Ic3JTlZi1hBi3VzVqqGNHH4GKQFqw8AmhwM3uSJvmqi2jS4tWmnmXLi6jUqP5eGHu0ppswbGD/Lr1gJ32A4xyUjlwM7t0VMJXzDUV0ml0JNOsgz+s+SQfWkwioKTqT0yp1N7YWwK1UfgkmU6SDUyTXzVNiogOpTmJXO16jcL3MrS1LFSROBbsocZKL8rsEsUUNRhtzV6BJoRg0L2NEMJoiuqcbSWtlp5BEf6AuNZuG1KaPVw0y+prXNtxNm9TM5o30T+PV1UTbpzAZ9imSGxLU9H/EJZ4+dyB5gyxALShU0Cwo7u/GJah7jb4LZ4j+O8Y9wL8LyRGNB3iysll8B/VUI1KJLaLkGxvltFKWFAS/Xwi/X8hoF40LVEOAI6BnMwu+yGKVOOiHiHmcqeZirtuGFQ9PH2Ir3Xbuc05O2S45h5V0ZAI5ZeYgOeGVw7RQS4NRsrLhzphfwdLUzBb4m+pRbGkI63yAdVyUzBYnS1aAw2GKMJXmKgc76Yif2e+3PPrBX/PNN745dcWa1IdOr/MumvV68a2n17nrbnu9ZKI0rOHr03csfHJNzzo86bcULjvfoOYKW4eVrFQ/VYt13glwSyNbNDq0O3SoITFiaqEecE7juWSXwwsLuKwAJLvVDUBiNBtmGrN25npYfv1XwnvjZA4+GwDJ5kQg4ZUDKU0Hkhu9yibmx/ECUKIi2vQ6SK6EBijZHAjD5akPbAysPgM8bsBDc7Nw4wtmPvFQ37mMwbVbfvufVsF2mR53ViqXJl/u79ZV1DRjq7/78pzmq/m7ia57trlKBiFLFxm3jgovHfnrhpYd9X8/O2lCzSNDJo4Zu3EofeI9OvDA98feV/cq39bPWbDqt40zF637jeWwHgc9ZAjgwws213yuRzMVOkHGaG6BMXiFxUVpMk4ytQhGvma0AGU53T4U9pnumNEeyGaqdAD5nNMFZJjtjkoWkYFZpJzytA0VYcjlMrulnA4DeD/z+rptD/1r/d7RVpNn/Jua0bL1VtVnrDz0hw9f+0B95l15wmi1kzhBs1meVZu4Hg37Q5vST/LJLZpXMA2LQxLmZC7sLwX2F2L7S4X9pbICOKQypQ0aCWA0Kl5M3LO6Y5LTlct2k5uGhoGL1dOY3bpdw84QmureSnpVu2DDTxteG2PtGVV3N95o62Eyj9has2br2a1DtkwYM7T60ZvpnD/QKW9Ft1x4m47tet49q6bh0Ilt1Lx63Myn1PMa3xFXw35cZIDGd1qPjg0dNG62DVApQEtIOjrMDS649Aw5lq3HbpMonWu3OoXvGFvZIdKl4z3vFs0A6r5zuu2U4++vqTb4TQfYJvNgDQyiQeav1vRWxYfmSIilQAZgCQHur87RIBmwAcwsYpD7q6NOXwb3Uwe5n9rnjlGbh9lgTo/svtxPzVNAdTd1aoBVdAHRP/nshDv7zlwy9eS+dzYNfOieG8b0njJ9dIcznxwOn6gZ0jdyQ/fr19zylDxCHti7W0m/8m4jJvV65XXYQy3socAwAOyrB0jUh3twaNJdMYMdkl4aNZgxt9kgWoqjApOSGWE5lcXmkd4ZP37i3A7mv0nvgAkIBsXsvuAA24QoFpaJYLZwY4NxHKQiWcAIAjo33Ug0TOjLBg8LTHt7CBETJk8YtewZzEMo61zurfUfXrahMw0UqafvspdG+gwP3Xmdeta1SNx627Dvf482v1NeUBzJjboz/l1RJVyLNIJ5ziulYbC3twgzirn5aNXZjoE5wzOQUGRaiunoMcmM/nADoMzMIiZxNz/cbpfiBFXLlbTpP/7yMReXEo9PGjDoKlNXTKCYGiLiNQr3l8e2Y6IRJSrKf9Eo6EDBMKRiDSAb9uAhY9aphEYFwXutuor71JHP4a1ub89Jsy0+syx36YCHb8uZ1Nh4wG8eFp36wAbq6bG4UhjQvGVt5xW3f/ow/ezinoY7Zj+BcJkMsmcIwMVGOup+dYElxFzhVecBYVuF5jaXNLe5X/c5T/6+3GHKGhGg5U3Nu9QfpWHNu559sGpfO6H64h78nUWgG4yD38kkE3mOC/OZCwmfeVbCZ05daKehhxwMBsrMA91DEUAjjtcVMWkQoBiJykAAkczLveLGJK+44OVOcbCQgou+sAsWY+9imqp6qWh0Dwn/49fmJvVX+JBepr6lNsHK7xq1RR4vzGzeXvZD6ee3CcLFPcL8fscq72nuxv21uwBmI2AvKaDptPrEhYRP/L85w6k3JNJqeuq73x6hudSjRs7/vlX9SKgQ0tU1tK75VPOndLm6hP9GNfDoYfAbAawQ9+uatktgCSDMrWTiRROYZmw2MYcz/KafV+O53ICmCs1S79IDfx4sRh7hYIrzrhtLq+7sGdn+fQ+Lw1jdiRaozUNq/rhu4PXqN65Rc2ul2uYfK7/u+6eJQuVF8sKTXqL7wcVtsKYkP7jufREN/49+8GxhsXpDkfBWQfN6+s+CjaI9uqvZGuX6o1k9JFYZ9oH9f5oASySsDgbdHdkG7uhH1aBtWC48iZXZRVJx1F+I/MifY8GaajkDySPIbfxgOJ7B7rAemJ3Rjec2ch0ohEEBJc10QXbUw4eYFMJMoDRXzJmG6QEBvOJ4GxyPwjXp1EoVUfge75xgOkoGhzOQFmqTMB3/Y4Sd6AzUPj1MnSKofvqB2cvUzYYwgIdxsUqhGzWhoAF1yg+C30kZz/Mjv+tBgd2bi+5cl9otq2bT4uvajR/l6Zd2zx1bXcUpvQYVqe+4Sxz029dH3kq9D6y8bn+fYeqJWUvcxpJdhcPf7pgRCR84033A8V7BtQBjeg5Uz+1GF/Nn6z5+7g7XveLcn03dETc9F1VzTf867wTc71QPCR8DbgrJH0BjYOVKgJTCMJbYyzlh7oAuwto/PL0YMnAiNlI5DnRlfea//spxIGIUUclPuwAyAj7EJJHV9OBVznfF0vPT4GMQr1H4KgkBtoooDONdOiBAlGz2tPRgfisCrhzhLhkn8gkTIiA7R7vFIikrq6gxIQ+F/8oKNVAXhsojeRoKIhpSiunoGWMZ1Le4i63Vg0OptBLA/nHRoodTe+TH4tlrhb5DaNnsu9zGji+W9z7aPufatvtPdx9wolfw4YMjJqsfvvAAo/E5QjepWJwG5/pNgrVcxBWJKBaAobk05rc4zcWyL4KnSZFsGA5OC+MBR9idrXv7Di3FTzZ3kH0uMJYvoGRymS4cPJNzpJjlvDDPH8t5wSvMirl9Lixdx2sUvkoCpakiCsN45wZZZDC5vToNm8wut9d3eb6LH2Ao2ysU0eLWhHMZixGw0jLuqy5ima5zJj/Wc3Ztv5pOpUuunbqxx12DBo7qGLlL6PbmrLSinPTKaw/PCQbzApWgZ3+qrhGs0jjm5wCOgvpa3N7aoEI6Gbe2NqiwSsDgqShU8FoGGklJNv5LqHXPDvPEwb2uGzekWx91DXakMGQPm9y/y5DJPRDuR0D+dzKcIDnkS03+ZET0mFQ83Ztp4CnNccnGbrE3galUTwYBUR/LdGFtRwbvOJCRiXwnIwB8x8X7chh5owHdMfv4ue0MWZlA2pkG3sXBlGFkzigjtgHY/YuZIQwmZOGEKFyTnItyFuhKkik9K0HDhgweOTC6mRT2pnNOb3NHCZIxCyRYNIVbr/FH+ycRTMBK/w70yNJvN4aeLrh7Qt8lEyZtu5mFFFZsbft0yf0PCVWHae/3Urdvt5UcKFv3+7o5dxbnvd3X8PZn+cdJor5yP8Awizyj8f8MCeR1aTSFlcIB9AxGkgLQM3kjLHKpSKlIxNksos3gsvbcggQDMNdjmqrsYQnwwAEY2eIVVOSYN+CBj6l4xeQ1syegn2+T2eNNDVzmsHYZeWV/ilur2gQIwBn2JhR4E6bgYnVG0OQpPFYaeqfN0e6F/zxwaPvodfMPXFNBB+WrctB/y3AhWvJWyXfbd9PiA29Xv1bVoP6w+4mJD1zzEffLraUOKV16AnSYInIX4YKvAI6uJ6zkGrhoSj+JgX7UVbJcaPrpIThsSpEFKIv5aQCDKHK+OyYYXcweTPHETBa7k1tQoPLFHC5fKn5R4I5Z7Hy65IkRwWjmVRTlAdT6ywMmNMMDpiK0EU1F6CouD7QWQRnXLlw6ZfqsSUsXLevefenCpbfMvXPU0rql3bvPXFI75r77xtQukYILl3bvsaxu2aRZt9+yZOHSbt2WLFxyy9zbbmkYc8/dY8fecy/geAbgvAn4fio5zONbwJ+iVp6HGifUb7WjCYWdV5gDXvECxuOSAcexPoUXoiiiE+kgEJb9J5nb3QfYR78gS98NMz1GT0U68MsN7OT4McMSJzrrsV+K4Bc5P3P5nIyfOXkflVQcF/cKotPlTU3KZ/RrGpHV4ObnogeqIOXY6gR0IGZVwP9D5TOC1J2j/hz69L3v11P5fHPT5yH1LChnQfXnsi8ivz716FPCeUwHaDbD7a8YiBKSZKiJhAjL2RFPylKpbv0b9Tut4IlG3KF0yuRpNEq7XfqH9Ccx49I/GU0VtZwTfzWGSHvSlTxOosWa5QiWCLcbK9BuxAoeUIhj7hIbWCTYs6HEhQ0a4iEmamNtQxFzMU+NCCttAZjXArmVuFkiVHEFcy4oFgcamB6lYxf4G3HHfBl5hUhZbT1yEO3NYm5vZrj3Unegbccu+J1Prx9OtjjLE2YnY/fM7sT6YRNnxYmywyIHLXrixTvuGDzlvgWnwpVfHYhu7lO5clD1hBvmLl04fdaU3z86VD92aeWNk2b0HV72+tih/Ytv6HjduomHFuZN7vXgC4O3ZBf3va74+tKu68bXbuk+sO4ZWSzqPqqizezrrru5JGMG4mGXQZAChjOsPq8M6/NkfwSrv9qj9lGq3ekhWJ44wloqeLRoLGAmSYQUJN3TXf16dKzof224ki7V7wyTrxsY7tirKhzR/rJ+G8tbzhgnAk90klxYw3puQ8V9vJsTpojEs9h9PFJik+zwh0etQm3Zp5AWterC9DAXb2zjYjWS8WJuBBXzHidmLl/KMQ8RULXPJmWFCjpGGNMoiQDuOgEq3XvNrjRS2BFxF/LIBQnXGCu5krCSqtznkXhdh8CqrAJJHgRXQpIvP0bHvf8eHXviqLr9w4/UbUcW76BtXn6FFmzbrn7xyk711M7z37z34L19ZtTMW3I2fF/7usVH/yicwn/0rvrs8ffU7R98RGve3al+tXsPDe54gYZeeUk99fKfL/TeWP7EU+qned4tkX9znrpVFMRuhveIB/TRWbwDBlhT8Uwe63OF436tGRareYh7+Qnz8nZMVg4ULORL4fkNfsYtrRitttnTGXT86OCxYbpiJotnJgLuTDpoKQ4JrxQPnxm3jnt87LwyY9GCjYutUun47mOmPzu29JZuU4bNE8/f+8XtU2uaR0yvLL//ziXjn71p4RHYxxAyWfKI3xAjsbMqyQD1mrQ/Q+ialerfnox+RZetVr/fGBfapdLtC9S4um4g3ZNOo3PV59RtA/VeG2IxcNKIXj2pd9mQsJrcmJS8ApDCLyTspGFKdNIIuevEnTFhYbz5M7rw/2fPC+ky2m4P1B3/79RdzKm7mNFztLgE11acB+pR29J4fhn7Lv9/0Hp7rUKxFNv2dIKBNnygzX8Qf6f2gGdb1jUS4rmNWylqB4hN88ht8RzAwYjjCcAiaYy9tvl/OADUHcxzY7JqSEQmrSWr/t8HgE6kdjp0zMhPj+0eM2BEzZjhA/7PA9D8nHib2jT87jZg7vdVX6efDehxQ1e0CYw+qcB4EHAU0PGO/yVlFyFm5hSJ69oZfTt2sHNzSOwmDgbcYCxuMO9IE0/l9Z+WcNylwZrFDLQmWJgH4W3VVDOwDBu9z+h0JkoqnhIj0dxLOiPsQMuTFIpDb69aVV+/avTm0U9MqxowbeoNVdOkZavefnvV6jdGbxrdb9q0flXTpmIdMMGeMUeYXj9Z0xR5JbCcwvRC2VIalQyMfh0WNEuYV9Fk4Xq/4yRKULveey1qd+DX9hSgJqE06rDjJwccCJmUomWAwSheUdzaSAYri/VmMvG4sH4vtpPZqz5IF7BePkKV6DIcJ+kIOew6FbdwyJFwPKBBLgPzcLU+U8yX78F2IWnprJtKUruQFJbE4+RVl97yAq30N6lbiJMGTYOzqH3OjaGuHcdMHtLnsXHzV4dvXbCHzg8KVSu/umXYgMIOnYcs7lJ+5y1959w25uFncI3ThAq2xhBZCnoXrtGllfqG42ICz1aNObZhq83lIMt1yWloezv4R0cYy55RG8HsFwduIzOLuZjzW1tL5KInn3+BziMPevb9PC/aq0l/vbYSN9flss4hofxp99xVM2nDrKyxN8+sqx3f554X7n5w9rTBVe/telCY92z/qr7zVvTpNbnXopo5E2sWZEieib2XbSaUXpI+F79lOXJtWW6deFmOnMGKXX5YAoeBMJcjy5XrUh70YwuWSxPupeYuf+gvfZ4+64i395uduY2CsZuN0jCSQd7l9avckW3WwjeKYItEMPkwI/LfExKccEp04IHGkMKzz7ISKaYtvITpyXN7mAmXyDm4Wp4BK2FKZyVM6ZolRzO46Sa4FbOvokJxoHfC5UaUmPE2NcDdQzjELN3k7GlNVrGYUDkddnqtt3ePeW+VTPnu9P5U641Pj5oVNltyemMMqHniiJJeAy7+kX5+cc/hOZOG3rBNfZv72Xarl6S40QencyDB1EuRda/AY2W2W/BqhcOFlcsu5s+xcPZhccUJa9yI4LOwIAaWctq5fc76XnWJ4OnD/6MSsfsvjULfNYceqhz+5w8kD5XU898bp1zYLEY8GIZqaSGbhAp6RJzhMhE3qROqGf76qD6C4WQP6UWiZpZHQoD4BY3QvUwE2vmxZIkjmM5gsbJEARdLrcEgArHrzk9URMsjJo1Oiw6FO63u13fihtIBPbc/3LOLussxvm2xZef49BHdZtzlZH2zqoR9rL5lPNHLwWRrWGtjhMIXf1nvZPTUub2a37+DQzbUS4qYwcqwRODILBU30dBIESWWQ0IUatUTywoiGEMtB2p+iw7fdvDNSe62/ool0ld/uvQobbjpQV+HIVxH2g46khl0JDvIh8FcR9LUIlgV8gVnayeKVrr18s54qVorCm9r5JRpRFq5SucEn9LDckz/2T76+Zl33zdiy213Pbht7qBbZwydKgXuem/OuvvueXfuhnvWvnr/g6/ytVlJrfiReIrrPeVULPf6aQH/Y6XpG2KfqktpIc19Mv65Ov9TWkvHD1SHpKtD5tEqevtAtSJVHcdp4TFCDEcN+1xF4kBhIyGuQrL4JHGZxJuEt5pfg+8xfpCjfb+Qf38Avid3iA72/Sz4Pmw4jt+LQfi+SLxJLG5+zWUkdRLGdL9Q6wRVqgGeX0BuI9Fs9DWFeDePQBijz1q/CD3ojJFzkEJ5vKMX7zDIOkVkODB90Cq6Azx9MOrLZrUmeR7ZD7B1YxqhHxuWRImRh2swl6sSmCfg2aHndgaYlZFkcYTufXHs+NSj6bPvmDmoYMTQgRtvurHhgz1v0l/H3tS7x/hhXa/vc+e7dT3rbtmwa/hNg4d07D+qvFCZ+7L0wOApfcpGTuqFMOS9CUzzPYWkDUHYXN/STIdp47uTxheQ9xLjK1rH6QhSkxg/YRqQGB9D5ifG55sqE8+ZQWoT44NNJm3cSG/OnM3i6DBuKmD9BLxkLdcdMaU9UQzuxaoXT2lp3OGyYc2vO6I4pEbZXgp8xcZKxHkJWaJgTC8Rt7Pkd3uiRNzzHyXi8GXMbUfn0T5McQQ9p0NytXgoqVo86MWMGm9okbhNvMSqxs8Xq9aJQmbxpX9Xq0NaCF1ORz84jJWQH1PLTvCmCcJyTrcrVR/2C4C9FzKY3CUUs3FWA89g21bDxb8QVv8xvoAsudo44KJH0nhlYv4MUqaPCwvY/Pb8+erf9HFxVdL4gpbnE+PTW8fpiJbKxPh49nw+f0bLDXQYnOsyrecA5mg8w3M0MHnHYeKFD7IYwe5zcUJTMONWSNNaetkz0dGTFZa9J/UaRYa5R889xjBn6yAHOmCmsQNQFnApIvyxuWKCTcRcKbzC4YulOQLwMROv4muCaLM7AmmZl3n8WOTPpMVPIl6tZUE7mkkTTQsQtWUlj6xO6lygzln2mN68YBzNLlG/FeYcE5YmuhgIc9Qa3shAveEYxy+rW2VnoRM/C5QwuLGaTQbPUg5/Mueq4wvABLzKOOD3eNL4gMT4GPJ50nhl4jkzyFHACyUbaa5EpJUkBfs6WmjAQk0WWkQ3LqFdacVS9SgtX6y+px67i0Yk6xL1BC3Dj+8tpmVqw2JaTpjPYnbLLkPcKBE/ySFFZB6PhytBQK0pUQXZFn1aeuYHUxxBBUIvZiq2wqE+P++ZGjN50jH3Q3Z4ohYrz1kLenAGQeYHJnfc5hDTmEFmAkGdUsFccYVlvDcG82GyToRFJq8vQFk+iFfLdCmavWwqlku+ce/CFSvGYb3qW0sWrEwTnh5St/Zv9y2+ceGar+72erY++A0rmRz32LQd9/2F1a0Of0xYOHqg2KfXQXVns9r1TTrs49HlAFNWC8dw0FXD2WAG6yvHFwAZXWUccLYvabwyMX8Gkdk4q19i86/TzvYUdpbwDE9mtWt+skaLGNtaO8ak2FnDiRQ4TqKf3YrI91KvUkevJ3uZkirz9ML0yyvp4TDh1W/jzQ1S7P7E2fHbNQUE/aCRq5XS/hiZ8M1pNaa+P6v3zPHy0YWLFhn2/fL+sV/UX9SPaNMzj86eiLoanCeftM+YSSrIXq0vXi5okuVasFruFMbAFpWvDcttE4XdmA4V0BOvsSyi2+WqlJY7oXQGxhCpJzGDMdKZJ1nrd0yHdrd1e/ZaMnILijtxb7rcHvOsFSewBDngVnwOphGWw05Z6160c3I9claF3MkdtQWymWCmvA+tntCGsRI9habo8iSbci2dzMSj56ravXOv4anU2LHpb4c+ji3oXjVzQOH37+679Z57pi8Ijx42+OYxE4eOG/lJZ/X8NQc29R2gnvGPmiZ98t0HW1e+dN+oXqH2FSOqJ123+1iv49Wjh3Ss6tdzft8b772ud23nXgN+uug7uifAeQ+r/TEGgZ76oFwl1x+4+viCmquO0xHNSeOG3xPjYzzJ42cSz5nRkvyczYn5N3/P+QaMG9dJU0g7Ug7a+T4SzUf9PAfJuSiipINdX1LaWpMkOyJKZyCDHqVxX9cclBLMoc0S9HnvOx4hCXLzIsiT8t08F1/Jvwb9eUUlnRG9QXc01KYT8pPrPPtMDn9qek5XVrnr1kzZdDBllaw81rU5TjJDba7BXPvOXbFrV6freGWTYkqpuLy2yaRhHgs7Et15ikyt7sDkkqeC1mKPB39aO/re9pYej6ZHtk5+6Dms+iiRFs1fEn/1pS+HBx73mUc+N+6Bx89WdRv51PhBN458bLgQzX39j30iU1+mc47TiR+MGrOlrkfVk0v2NVxXd+eIN25aXSfPqPnw9ekTn6OO+8fctlVtWjRz/LWddzNcqD6sLwJc9OP6BV2m40hsYrgewGnj8VbcpSaNL+jUOm5pHacjviStz2E0wOfP+Asfx5zhNDb/F02/uE8fF7OTxhe0dE2MW1rH6Qj1y8RzLrLn8/kz1H8wu2EIrGexsYD1Ar9Z63oTBApqG8YKQdb2HcgkB8gkh3WDiAd46WEJprvkoApu82QWIBHAaff6kQjaailzkjtqMmuJQDqyC1mArKg8lYkcN/MFXpEoOmT52Y3jH2lntC5uGnCq/ZgZy4Y09fv8qQ1q096jp36cOLZ2zeBptWPWVNEV26jn6UH9fnno4WWL2pU/MaDqwaWLGtSGFnXFmydfmzZn4XszJtwx94i2d2kJO3dD+bkr0GF+VipnsBrGcffs1ccXDLjqOB3xS+t4DXs+Hx8jJM1nMOfPmfETP7915IyULe1jfrlM0plolQQBZtIzD116OO5lA0yHk07KrlKsJJBTS1GT03v3JZkt7qT7OnFn854elZW9+l577fX6X2FhPK6qPfsP6NHzhv7CJe2GryfSskOqkTaCVMwG7fl2TQ/BNuUsdTNTSylp1UPaaHpI2yv0kDZMD8m5Qg/Ju0wPiYEaUsjVkKglxVahKyKdWxURnm2rKyJMD2Et8SPz+62lwkurplYvmdzj0eZtqydO32SmB0sGrj00ot1NNz860mhcO+2ZY7TqYPdZ4+smb/mDKu/ptlyQikJCQUj9Qu0TXHH6oZJUhhuWh8hwOZrj/jly1fEF8686Tke4ksYZjvn8GUY2zvPG2Pxa/pwLpDWnmdVdtsEMHqdecmlmtXMsnVlOjbC+Cq0Zv0laR45WGVioieuXfxGSCwRSeQXE0+de5xUQqawCgl39eI3C9WoVEP5EBYS/tQKCYnKxB71gghvEvpPXenoUc5DVejq5myeI3leDnjCNpZ5dkis9k3OmC3nStHy6Y2nE/NQrjzy3qvGxcQ8XmzFvura6emP1sEEjtoxXfWby1fevHvvgAKZOjxk5ZhzmTk+cvpma10++dZv67wR8Gdw5fGc8SRK29zzjqYTNXE0WM52Qy9jVCVlaHWqdv8FUk5g/igxonW80J+aPuqDNV0uw72Bifo3YiZ91GF/K5EMfPi5s53Yp9rFjumjhZTotPt/H6KMfp48wudp80HXf0ueLv7XOpyPeT54/MDF/ND2VmN9gaNLlFR1Nfr3q80eSJxLruSbp+SPfILr9bMhl84u0+bX6fOM4ow/G++O4+LCgsvmaveoxkg16ragB6T0LtJWdPHNBU1GNLG1NYhnuihUzVWwGMFxdpaVRWwo6QW1OSzF79cg1+isSlGKN6g/9Morp2g7WT8/hUpyY3ex1KRb3BUPMasH8QTteYSzm8jpZh2pLB7rPYrU7nC5vsglbmIspvYHU5I6Beg2tlqxgiphCV6ulddBxD5zZ9FqN2eBJVaNBOqSgseCJ0ONq836vadgLYzc8f3brkKcmj6gdtXEknVdPRx/ZdeP02c/v2fP8xe7y1LF/OHBiMyUrRs3c2ERafRWMdttqtDs6gcsmRrtcZ6iWkuYz2m2r0W5JApdtGe3y+aO+TJ4fTswfTfvQssTzm7T5SCscl/2AppcDLvX5NUJYo/V+WP+bmF9Dfybp2vM3J/lORiatp3+SzjPyL620W8vmX6PR+lHux8L6Uza/itO6kDy/JjF/FNmVNN+cmK/vl88fmJg/mn7TOp/tt0obD2o+pG7Y/0+fL66jIe3MX7Ye8ZG61rPB7dJibf372X5R35hn2gXjN2rj/ehqbn8afawHWYDmEtY+IEqcXqzMwizbqMFoxc57Po/Lwr1wPqlR9pfGRQEHYtSB7/pgWYkxyWROYW9MSkuufHFpzWLS/7NlmaEeO5YZ67HHUAMbdGGpMjaQsdbDhBgl2I1PwiseGpPX6MWwcMzswtJlpyuW4rRiHyK84ribjcNMD86M+fT5fhyPperfBnBc7OmiksFoMlusKSB3fP7WvLHk5mde9hIqUSuJDJWjaaCdPhEbAGILxH5f7yvYF/4xLHQJ/xTel3/g65+xFeA+oUtx8/tSya6v4H+7Ln6KLQHF8Q1aTVcP4D+5lGoRUF9uJIJpPU4TCFRQtwDmPNHTBJxHFJDziAYLep3Z+6gAurkA3VzegwrMopjPnWYu5nX7Ycyi0l9DVbnz3LkkcOey2oMrIJsLkM1FeFlzWfqhXqqYwgZz8BqFa5KIxu5WKTms/xmC0Ir3SSm1uTrMZD8mJMppYHtn8Lfm8MatGeyFYm5euajB1BQUsagmz31F9RiVnmmzueB0Ae0TUt8YYR6+cyxN9S3/YZVr0Q0b52XWSEeQd6n7Z4xV3+06rfkJYXH/rsvnf7xaHZI4D+LzzIfGfZtjWm7Uz4M4iOnH3CYZg+9G0eYPYvyOz69uGaXPF04zfsfnVyfNv5Odfz5/VEuHxPNT2fnn80epH7BzG1dLsB+kNt9Ia0ZwGb4DxqvZ+R/Ix/sl1i/sZvyivcYHxzFfH67HKA27oq+kcNW+kimX128ml/xqhb5Y3Is1vdpvqtOkTzGeQkqE8UwTaM/tNeA5qw1NLr5GExkkRHAc+1Bq/uOSZP+xegnsU4o8ig7T7L6T2vO7YZ9ImN+B8zSyTXt+N6y5hfHBjKetG5+oHWX1OQ6yUasIJHotrkIFrBBx6i1BYg6BwkHQuv84/rMsV+9nloK+ZPF/lOESRbSz0KxdL4F0JNfeprTW3mK5TVLt7Q+nK+zlEj2TVHorDVObyt6il5JLbzXaeZjBLazZyy8laKfOtBvGb9LGH6FrONywL6U2H+Azh9POFrUb1vDq88V1Ld6EbJ1seE1/vvgwlVqe157/TdL8h8nyxHreSDwfZdCc5pna/IjR59LmAw1+24zvTbBqfTLt5EUNL2ZJazuMRcQO9q4i7G3t1HCw49wZ3r8HW1vzNN/Wbp8pwJVa27Ciz9+EVxy34ThoYMkYohVgyYu87oLEqGSy8QJ9imLIlpydLmDRlMHO4wGArPKAgYV2TNbPnv7x7kMj1MO1GNA5P2OEUFMnfNe8Z+bTUXVgAz3bEfYIYl5Yb8R3+8iJN5Ykelvx8i8BeLCY1GBWc7pK2HNSqMcGlGJ94t1uGIuilqtsk728BLcJ1/+2zb1UECWTVatnwE1bE0zXbGFNOfUXVZDEZpGdmoQ/7f7+wVtu+mrdD/NGC4sWi3nN88ufXNpcI3giybGM+XosA2yCIQm9oZrpGUO5TTBPmw9n+AtGK520M3wucYarmB42lNPo5Ks+H/SwzxLPn936fBjn84EzSF8wHjSUbGRP6vY66xWqzmC9QtPIkxrfS4uwKlXuMjdFsMbKLV1ZE21C11Br0XNC4dB6hqa5ZH99LJDmB/jDNbmZuj+AFijFPxzQJiyFtrGKHbeN55YT1gCFehTR19rzE3vdMI8w76AbEnhvVEK3GTNKHzulnig+Uz+rpzTq+g+7qNcbSzKfMey7GH/pa+HtpqpjH6afCByX1qinljQHNB4IvLeK1ZAu0jsjEa3TU2tBKyu04XW5+bDv/CtrwTOTqnSFfHx/m+TVy45N7lRedpzq5sUEsCkfvmIDJlkzW6veEyXeDkFzhZdftdb7qfzaDTMHDujedVnRjsuLvq9d3Jz57LbhgbcCh0RnovZbj2sx2Vuq2RqNmq6OPqvVCV9WtblVl17LZG9psu6t+cTMifmj/tw6/0RSnK2WRhLzP03yodV20/qBtpwxDTMAoZAgeYzwVlQO4HBe/fVRRlHrX876veVIjXGr3cu6DJkSvZTwBT+hK2LU2Jc3y4U2Yqb9ggHLATBYDQLJ6rAwgWRB41DJzEKGhuZhZlaScWjHbA2S2tpRNJAUsDbqbUXLva1NRdcPFs7r0WvW87w5MqJa6y5a1evLPvNau4sGtEi2j3cWzZQcuVpfUe7jP8JoMEwqyGoSzcPzlxlRCo3Ye5wXPbTXeo8p5YbGuLNjHlgJilML9RD9lVVKZ2w7xiM8SueQ29PTIlncvsw8V7uOvKWUEmB9FwrzMLMuB9PoYChUUaG07whiuJ2tM5rG5e7k/lhXeOz1TkxFibp/3UBOctdvJC07fpx4w/tLnn1V3at+GBbnzeu7fM6YnRPuPNBx9Y8H/3J2wph1r0yqGbV2lPBt7hufXFcxfQ/d/CEd9Gr9mKmPLXvtg+vm3BPq9EZxm9rafd+9d8ddtOD0nLp7fxs469aOXV9OyGBuf5Zpcb/NCRl/gtHcSM5X/6nrXt2wd6s+H/jqDibjnwbZv5rx1ZGajHcnnr+j9fnAPysSz/+p9fl05H38+dg79SY2v4u2nhlsPtaov87mV/P1nGyd3611PtiNQmL+o4n5qPNN5/OBT3Vj9moXLSYxgo07QBecx9ZfrY0HrrYeOrLl74nnf5L0/JEtt7L5G+D5Rxh8yrXnDGbjtfD8AgPq+aO08Uw2zvqqsueXa/CxsufjO4pCxix9PuhAR4gZ+OpOrQ+rk6ziHYBlO68Fw/7/IOZLS+OUOLAMzOYEI40aGxXBUlqqJaeyZEB3Qg84yk87q1axs6aTcMYFh8hzUCx2rGqy4RXHnQ6tWsVswbYbrQkpLImhPJh4Be/OYrVGXcFbutZQczv1/KofVwhL3qa7GhrU6reblwu8TpgUaDX7QfID70WaaAyIbi1ZLI1abIm3L2LvijihWSZM2bBH2PuRFVcQtwaMLOeknFvKXs2k87L7zvXhWk5uBwPsz6G43cDKbGhjxoRckTfVtrvZm4zd7OW3r/1yHdOAYEIeTjDEgvgnCh+SBG7UnZvHqrkwt8PlDuZdZlp6c7TanVTsQ5aOUoqxB8WSaNgK5mRI6w2AVrrp8v4AXcoLgis7bWvtEdDp59BPRa19AsxhIXv7V6xTwFfbDyRaBWT1/is/Dzy+PyAR9x+j6THoc1/N7Enuix/TKWk+k2ldNZl2KjF/JZNpfH51JPn5NYn5o8iO1vlMpvH5o0jy/DOJ+TdrvlM+f3Ni/s0/tc5/IylvoZYW6PMNJCmWUDtNm6+WYI/gxPwaYR6PMaglaJNp83F8Dxtn/W/Z86/lfIHyHCZW48+eX6PxEW7zXZEXofOXK2MVdMRDJGl+ZSKPYgZxsPmsDyt7TneNry3Vx8Uv2XPGtsY8EvMH6vPB1umUmL+N2eFjNVtnc9L8xPOBjwQS8//V+nw68n6eaywAP1pvzCUBzHLXa/Sx9Y7W+THhD9Oatuq5DR73BdnNcht4WhpN3GnGjFbF7+BV/LKFd+IXW9MVtK4kWjZCz0hlbSr1tIvvrBvfvap73xF+tbHt3o1jsNXe5OkGV/0rxXLWyElNp96UA7jucwD3OYYTJJe8SaLZem8B9j5Dj7ExnpqebbezXq2pKNPzwglHk/ZaDbYPa72SAfvw1xt4o30rHv/t575ibiULfjRgZnRqhp9lRqPWDaNJTCBusFj9GVrZtsEIH1LTMy6vORbwBYK5+PIf1rKbNRn34HuaZbuHv9qRp0X/t06Ejp6llWP9b0V9R1MLDuyaP7Gyqnv/4b7APwq+OV68d30Nh4+4cXb/usOvMhDNjl4aXP9qgOuFxs+0eNlNWjeUDF0LDGodyEHXCVhZRxcMj7m0DuTYHlORfDyT3sgSUdj7EYnDZUy8BiuSF8Cc0ABo1DwD6qqd4mmHBwcMcv5ubqc8nPffG/Z/VrB2RtoTr3edMu+/tO3nPZcM66Qmtp9h+n705idBY+t+zK37Mf/P/SgO12WRC66e6Vv6r62YTt3Wf3TaT+a2Lz+TdvWeTOuzVi0PPHOgov/N/9mbifUzN4UAL9nkES1rwKL3M8emWfq7cS7rZ554S47ePNkOurmt3oBJiNik5oreD9jhIck6d1aQmM3J359D99rsDu0+0UzacmWnc56qb9KBkdzx/OeNuwre+7HdiFrvr9bw+YPLKtSPL/zlLF09YLy44lJdTcXfXnxV3FkfeGhxmvx5oHmL+ova8me279lAj2HAXx5pINF0Pe8GOU1UZBk3uPuI3pHqP9q5AyfSq0D0F3Rd+HVDohRbqOfv4sU0rH38vSIJGGGEK1CPNdnOAHtxRsCRfIoFAwCHn+J9cI/gSRbmEr6A0ILSOy098b5dBBm7vQxonsuApoe9ZmesPPOIa+ncoyWTGtOG3OL/1dz+/Buy1tnmUerrvURY2jxuYKfVpOWP9LOF3lX3p+/5c/qlww13zH5S80/2TfJPjlQRnlLLargcNe0iLpIGJ6ID+avmpbeBWoSuRkeEvfjLU4oFN0YtxT6MyQjxdJ6wlM7eIKhVR8TsuXYHN3c6as2xb7mQxeELWqGvXrbxV735XDGHD3tdePB6sP7GC/9kHNOLH6NwTVaTUlgTBhpPcXi0dgwMpukirz+yu/caU7PyC1haQ65H7sAaOLfDVnZubDhmof4sxnBCNPEydlPitXBFIfaO0ISdVF4GsGe1NQuF46HlU6etGPH0D8Vq9scgcaYUWiR/aidfl7IO117bIXxdUfGDhdRf9ma1IdRx6NS77rr19t4XHXStOl+opTMf6h+ZRl8oLS8v7VRR8a23zYNhR6dlHUGkYzxuLcAce1ljvXNvcvR/drSWr2FvO8Q6hy7heBsNCdcnR55AMmFxtJ2/3hBLoov4pyL+ktVEb+OwXonfB19X69W6S8olblnCtrb7sttc07FLxbUIyYgbrPOM3rw0P2o2/X/UvXd8VNXWPn72mTO9l2SSTNpkUgghhRmSECCEGqp0A1IiBAgRBURERETkIkVpKlJEUEQuIiJOiYCIGEBEROzgRcSGXI0iKnC5tDn89lr7nJlJwHvf9/v+9fPz4TBzMoY5a6+99qrPU47Z4JtgsgMlNEr15/xP4LJjMTZLbyny/wiovflvE+oW/O2eiXPmtmlT2KFDYUG7vKIFWcTRsuHOv8baVjwxYdbMCbWzZtYWtW1b5C0ru2bPXdTKlPtYsdx/oM5CX2cR86X4SZH6+nL0dbZIOcKt6JNhzzB+fq1034afxx4e/Pxu5ntVSDEljXGjMaJKsdzFSTFi+5gYkd6XarKL6OejMR+9L/UutqOfj8Z89D7OnRDY11gbMXAjbkYiRewqhj8aYZ76n8CO/mewUfF6x9J5OYRvFC9nv/HMqBIZVnTHK1K/5jTFPr4QehAUkFwipEY4IeSp3JyRzd7CXLMgjbhRJ9GMDN4yzRIBVUAc+Owc6tjVPPGI63L2ojV9b593l3Ai8dGFLcZ+mFgxbXI3+L2b6e+dhL/Xw4FmM2x5LBzKv5cHYl2CUHYIL19S6gM182STzSu7j5o9deOAoPtyK5XK1e7Bu3q5euwsnEx/72LhhOKSMmZWODqHKs0Kq6P4QIDntDiLr8wSTvj9uCbkIP1evVUaGld3ht6ygErZGFThuKZKh8ObEmAtTFHBF1ZYACBBnuKGvmatAkFmcDK/1McyPD6GtX1QWNhr6LA7zc+kBdfMX638NNNe0bFjxXPPMF+cdBEu8f2UVzk9zBIyEtgEwDSS8GgZh5yKemgqiayi6fA/6QKwtwM7t6mMhbzleD5F+FJxUbUWMQb64m82M4sUh3OYMZNXBvZQBoYVJ03ZwuSVzRCZsgUQnQCnwmX5C5vAp8Buf2wi3e3FPtjt+e2Vu2Ar1816aELr0tLWdCtTH360mM8BlZmVK5a4G8w4DorDq0ilJQ9/2ZGekqH3+BURYLA2KNkoK2X2hjsffH5K/4yU7JLOPUdMFr8duKD3sGm+dLdpaVw1k3Gl8KUwTHmJi+O6cwB6wisb/TpvSM3bqKNhBIwur9S2DvhcIIw4BOAG0wvCcEJqOg7qxgx+mNh83lQe15j3ZBTwGNJUlh0q6Ne1Q0oLr/PxLvvz+3SrSM/22oQvSYon11PcQTydkZtR2hZxOAZRfVtD94GWnihsh+miO8xeCPOB0g4zRnYY7AJfsbQdyKAu81P/yDnd89yMe8+1OQazpL3rW9t9n7ZOnL/V3mm/j/XObQ3vI/NuzEMd6P3/rgPI3oIawOasFX+hAVVzJtYtmjvlntlzStoUtmtXWNBB3Ahn7Lg5D02gi++lSoD2JmwSTogLVW7ozr36J8sVhD8UTtx4A+89cO0Tdu/6c8KXN15TXoJMxjWsvXAk7Bf23PCp1lD96YYM0vJz2JqOfIL5hOdAMBPAIFToLRIJsgYcOYsEBkWK2bMAyBCDUAj7y2+f+uiR+KdsI/oMz1Xx8+x3DN5QPGKzpSSvnOOv++j3NODsr5V6YH4leFxAYw3/LPHC94hlxsiSX1z3/dLyjvkdniB9GunfnRaqDHGrnk3sEOoGf3ViHNLXF4ozw0/dmE3XK/O/2oJmduD6wn6VJZ36d/FVimdi7ADhqa4pvlXV0e+bIs8q66VZZcVxDDJkMg9Jt/hB1ZWNnpU9hRMpO/Ykdf+qCvPrZLGSF3qq6ul3c1AvqB+ilqRGUEsAF9kdC1cC2LcuCUU2TkXlbzBL/awBq0V2pYMGI5s0bAJngl+ERsPOWDO3uEv7/OIuJa3aE+HulDOFi3pM7Nouv6RrSV6HCLxJh6TjQx191gzQRmFO5Bk/5Y1I/+E4MenG6lvN8NJ7VGRKjfKGJYfa4vns0+EfbqyWf6Zy48/yuFXNftaZCsiAP2vFbZJ+9rv0s9tunFX+Rn+WzXlHs59cw38ffl8O/j8dSE6z30c9BhX8vmyyYA77zkr8f8bdOKvIVNXTmIB9g/Hi1zHPuMumgmeU8u5HsKcwqwlvbIQzMsLfJUBCQIULp7wFZyTrkZWou4jQhByWSMSwZ8RLyh1Hrznp9zhM/51c+B6KCdH+OfweLaJ5KnxfHu0Hw/d5WMOBGthaiU8wDRDkb2IUrE9Jxrm9FHWj3GzUjFzQLYEthwR9cirWDJMRb9kEkRyAGKrj/hvToJO6CAsPkKHfiCTFL75+Rrwsnry8ZeWSU7M3LX/6h4cX5pJf8vgcoiX1jeJH4jnx3+Kws6SIaF95t57c/slr+98WA1MPH5b6Y+rw+VpFnrcW3xdgHg7WrVi5i+6p22/ByI0bXiLglsr3Dbdd+TjCm6GUCbgV1AxFB7YlCkx1hEw7O8fEk5kKFRE2/VRlFpxVHcReQKKtmL7ow/b7Hrj+ilwDB75P+t2KojVxfA/JYsWNU/S7TkTOJTX9vrkyOgZdGwS81AA/ssBp5eFXCUwUMM2ovyX98eQq5uaF5+fxy3LD6/MUrfOOHOFXvf8+P/jo0WjNVHmU/pveCO/u48jD9DcuKDDuNLUvKqEIU7lGTh5AygDhrNHlCymw4QZSCUIhyBEAwaFdjdfmxRBTMV1Xs24/+S0KWBFQqmKUnlCBgtoLJvHIH0Qf/ghU/2pvofGaM6Lvq1BmPlzfk/T9UuQg88bwSaMuq6Mk0lxAK+FyqK1+HnF+FAgGpwWZQeeOOiuHTxRP5CjuywuvIR5Rw6/O28t7ecPuo+FL4bNHIrUk/LdLo7lofN8hsrdE5RHqcSRS+/2dxJFu8rGpWGoPnBCCpPtghg8GyC3xZoURwAYBH89v9DbDDE+JooSjFPdfmIZiMxdQXfSb6flrukINR0Cgf5ktIYVZYIUklUmJRWQl65G0wP1QPF6d8meS8DPpcFV0MigEpQp6kOOdSenNGiAZ+gvgLzutVIj0eFFQH40hq1u4LAk+gRcYgiB1VZx2EyEM5GshmUr6Zf4z64c/N4kHT3nPtP7+4h8L56959zty4dCppXP4TSSN9DTU11svHN0t/nOD8vtvrZeOz1mt5A8KP4oe/Zn9jzytAJsm8cxROWPsxO2h+wh4C9O4xiheI+CO1gPCpyPT6atP0bnsMDdp8vnAkAUSk72R1knQYQWMGEr5L+iKkIA+DIxuRILDiW2krMj/17u3SIlJWUMobpXj4iAFL0DTQfLbZQnpXQaG8GhKMmKyG1BMEdjRgOiFvNIWx9LcvFJvssUlJjcRvv1mqsT2hL6Q+RIFN7Sh0tN7j3P42Tttc+ZZtv9zu2XrLs+E3+8pFd8S/0iu/me16cQ5ReXgGWSz2HF0yfSJitLrh7dsI6dFQbxyTexJdn3O8HuR+zQD+PXw/LL5wPT4LV5mfZIE1ltCQ+dUHU5egctu1LFuklQlonVTJanXWuxuJK4x2gJWW5nEFxxwuHHYMqQ0ImsUWq1sno3YoApBwa40ckAAdJw6J5fU1U58k3Q/tvVfc48dI5Pywkvzvvp+05rHPn6oamze0du5G+u/JxPffezKpkZx0SNHjzxKJp/ZuutJ8deXX/i55ojc0zayyQx795h53Ng6kifSF+5X1dHzfxnWc8blsPjdR/2CM3j/aXZfqgdiXw7ef4bdl+a4qB/B/wPvS56MeAXvz6a/fwr6Fxvx8+OvRfirBL9QS+1GPjD9JcAKpPqA3cHv8SJRDkt9tYR0fAHqsZtqZyHYNjt0JMVDh21La72Fi3PjSLXO1hRkn7p8KnUELR25A26Bt7/o/Oq3b9c4WubsH1U0wJKRkpzdcVBDnGrI+lHLXjj33JBn7xzav2rFMDLlc3LnwfqcQTlvvS9u6VaRkWkIJu+uHXJ0/6cvE8OjIyavEsXobNFmVRr1aHNhEtgi8QlAQObwAfpndOZCHqpgIJC4LWHC2SOBQUYGLSRqYJPkOtG9ltsQsjtyYZ4IrkH6OiZHHwftgfa4XKlnTnrFsH8dVtsbgkWbmpbN6O4SWIYnDbhr/dnshFdIQ8AWJagpaylR2FNJE+AjLLmVkiHe65/s+lzcOHvhjG+eG7hs0Ix1OXO6zn/+ellu52Wrh1WNm+URHaqeZ7/ctUn0V7q2z19+em5OafgD/rv0lq8+cXbvmqUDxi1YjzauJ5VbP2EQZ6E2L2jgsaUSaSWsclBBdybgW3A6bHUFugLE1OYlsgIGI1NiV8QgsfOKnnmL1/7c3i44x7iJ63r48Pr2ouMsMQiV4W///mqnT8t5z7XfxDPiH6iTFVQn19G1S+NaQhUTOwg8dLnMhYD5T/x5uFzp9AukI9AtgCf6bRYsDCVQw9AKbikhMExGGJRsa8isiWuBojZ7rLZ6TmlIgLdACKFHXeUkUqv4ZgiSfBPAsRwTqSDcxc1f7xr9Zs2oiuUDhgzvcN/sBxbd2PK3vbUXJ9TO3TBr62Ey7VOSVTF/0+qdxR23tOjQr3vx0BG1J/+2Vby6fEz9sntmHP97YGzBaZA17m269zzUCjB+hmS5T8KkbKy3x7vB57JHmeMSNY0hVSLHGKkQAcEKBQwAIKa+sJsVJuOtAQ4al+zsB1CxVcVUbO2WrOJmJA3tiZo9spx28ZF2/QY1HvrimdsWL5o87d25mfMWrho14eXXXzi1+zjREUWpKm1qn1Wv9g/0HNTz4dAdQzv3G35g4BrGPShOFYapgO2vD4cwqspIR5qEYpNMcGAA+fxMoDDpZf5kIH+0MtSGOBtCfXGIIC+B1VNjwmWp8sBpEjg+Qiuh9rADv4BULyGJJGHcw6dy+U891HP/6qlhdZOrvbeNv1Q3tEvNmoVk3WqSSbzfGnatD4sfiJceGXlvflHv6s59nhp15+w2Lcpadt7dtN8xARB5mvF22LGS/h9Zb0zRg1wiwEFQuyiNjbEpjQ00OVpv0eR4ax6bi79ebs5jc22hsCTKY6PgaujeqVblcWb6BOlQVUWmGKpDACmUqEJcdORvdcfyjyRLbaoQ0idTv4uelvEMqdJpR0cgkJqIfNroENg4/JY6Eu1ws7tVdjeDaappPYrknPEHJ7388+rgzp979Zu+oUL0pfYgh1OenrSFbNz3NVlORp3+bq/oFN9f/+37Mx8kRmLcTMY8O/PsFVwDOMN6ow2aKk2FyiVFv+CTmVOaVlNtko2+cbH+Jm+Jw/ApEkTJ9T8zrIHWzCwv5CBxFL80WvtjrTvj4p49u840uvPtnhkV4oXTvgn8sXBat6xqaM+R+oihH0XFXcW4YA3d0ydVbir7FyX9iZeohPzKQtaf6S6UXeuGey8vYF+Xt/gTGwJGB+L/85YQ4RPpsZKEVxdcqRomxhwuSWV+Vxm3g/BGU2KSDENDmr1n5QOrxEOqtIbUdoyb4YjWYAyJ6OgMOs+JR0sEND0HUpF1fJ1JX9GtXauUXiPWPhs3WZ+Xk5ZZPmzcPaYEF5/UJkP8RMifMeoO3Z6454PXpw/ubqhPmvLIl7/+rcMjHcMnWY5Gwr6j8mHYn8Dt0R5rJOOkOhtuLY404cwGjg25ddoUqV16/gt9Nv1fsHLBBdSxfCDOEpvdx3Nqz7ifu+q0zx7p+VsP8eSlX4VB4RXDdz9HNpJu4orwhX+w/V8lThMs1H4VcjM5mIxy0p1DY3WLD0wy8RfJ45chdQonTT6lWAIt6Xf10O/aGjIVIO8CwDeG5HacrV4wKXLyQewtrWDrPLagW5eN9TsntCwIMLBkgOqd32Tz6yQuFWajS5nNY5jpbp+6CbZxxPhVHdk/bsrrzy4ZXJrNb8k0L/hmNtHVZPZ979yQ+5ffNaT68rTeFROeeoLM3fR9vso1a/iUV3IMu7b1XDBiz7ZNywfUtK54tGrAmoF3T/W2LG3VwS/3MQvj6JoNQpkMofFlHfLUbJE8RKeP7UugqgGSEbAsQWVcvBeinaRCf0KkacMmraLMSrPy/LO4igmg8PQD/ngazbx+wcnwtQtMwBUaUNqumGjEzgVUDuhvUKoccfGx3IfOBHQ4AhqbFXpuuIAugZUSEq0Bgw0PjAogmpb3Meg0UPRAF+MQx0GhffZ3s3U9S9oMuufeaZZZov/gb+8p1kwcsDv8YktPt8RA5uRxZX34qut1ijURX7I3cjmlcK9ImSu73KeSxJxKS6TNQzKpTgkSJy0ynK6M9R4tFn9KQ8hkSaEb3IxXK1yD9E6TPg/gQagn1hQTa80kMa+ZKCwRCD27ngkhiREmK+y2GL4uE1HYYxJh6tJf2179rOGzRb+t+fs0nXPQpv4PVy0eXjWy7tFs+rB3EMNvP3xySAzVP9zjMXEGf3XcAkIWTpnzwk7pjJ+I/MJpEDFEaYXTY9ltEcqVhbEBI8e4W5OsQQvC3FDfJKS1CvF4wgha6010w1gEaq7m1S8QzUvPL6x8aPyodWOHPrC4bvCdl4fWdh6xfhEJvkN6v1q+q3jGD4/UzvK2mzOi/+phgxZU5Jdldf4k0mskiHimuIBx0NRkDQEmRuWVCX8kVKB4KQ0C6RCcTTBJRXYukGi3RogNMn00fgSwQh4OQwt2e+d4Mvhq6nB8wLuyxLPVg558f+bhE+feXbyxrPWbH5HtH5PWm3Ytapj++8t3NJ4UrxPdN6snidc5ea8pTtHvGQ9sydj5r5f3WLyKZcSciGQWi0+/8fxXuH/i6f6Jg/1jlfdPHOvki4uPzuvYJWddLz0T9ReN9sieuZnXaojjAB/MEYP3WbFZdUa5eM4xlW2X77vlS32q5aN4F35/jDPp97dxD0hRF5zdBl5KgCJa5q2agaQMCNTH8JEuX3zyvx/kBgTaxJqD4RYdTzarz8K5M7JnJz74y0xnKLDzrPihePSdD8nIHg/wZeFDE3o2kJPkaPiN8JkGiYNOWS1M5JK4TG4/s3Tw7f0uL5vVN7FwCDFhnLHQFFJ2Era8hFKRJsEGZUfmfj5kj+PEGeN4iz+zQQn9S1onzBDHW0Jx8ZmMZSJBvuOCOwpq3DLZOEZcgiszOiAc75RcSogaTdD/Bg1MaisrhAlMOUudkNFw2jvyzBII4FkWECUgAoMVqN64e9WiR/bflTV+3dQNwRfFLz4ce7p25yf8kzNfGzWlfU8nqT9Memx+fIF4/ZlLbnI+8NbIT/d8LgbeMYgtyDfxv/cxr72y8siYe6jfo6NmY51QTW3CLi6YxDFUxTiJP91v9rHUcbRvs+H5f6dHXJ8U6vq4gHWDuT4prE/dBFiJDDER7qfyaB+Nthj7aC2jflEKvEpF1lzwrlNSo8w7ze9ItDEAdpsAHlFA7SyLuEMKooh1h2jcGusSKcglfmqZvjA/IT93wNB7Z9g9ZJIY/qhS36Ztfn7fqmmzHHkiDAPcSVb362Sud//tGfFffNz182J6ny6mHa5Fz5LK8LNsj8+jerZPZaN69pnEX5HgCxhVULhGNi3cKbKGuW69X2J0TS8lLAxs6N0agwu88fyXt0gevnj+c9ZC78R5yHhwqFAZdU49Uz1jvAFRUgyySuqlpKFemnbklTpjXEIs3YnxpoShk0qwBPagrHbzdHN/mWGbVEsyfxRPfvfJ2dXioX+N+3H8+x+RKeWd+Nrw0VEVtfeqlfdcXZNMl+6YeK/Y8jc71bR/WN+Xee2Vx6htyQG+vCzCctqwQe1eFh0k+hAkMLojjSRPDjudEn9rIqR1khhwoDQcFWDSYN2FQsCUTK2nBY5oejJjd6GlSXch9BNaJIQYA75CY2RUIytpFitFB6zA55poC9jTMc7IouLJYHFGshTRlvpgc7KMqok4pXRYji96ZFO9q37soT8eeWJu/1HJnb5v0UqYNnDebSnfp83/+dlDpR1XjV/xMpkYJI/s2iMu3HZ44WySv+fjxKUvkvxXNy5ftvKSOPO9PeOGvR/JC4YBI4blBbmJ4j+jeUG8v7EZ3hrMstVFZtPGSRg/LI9YF8kjyvdxbfD+ZpZ35L7Hc3cQvV+myuUKGCJfBjLJYhgKPrWLWlKvN6RwpWpwgstfWsgavNsV+rOQw9HfEtZLpWkMtlRBfaclp4XRXEyTF9IfF7KZrkRwuuCTqdJwV0sQeCuk31GAv0GP60Ah4IwbM1jTcHwprEsrIzBdcrhoqdA27FcgTVypi340UcLyZG6UCRfLZs/OxOSJjYbp1CHXEQGdS8miEqr2UlpukDBmxLCxrnTX8uWftb8i/vZ1aM9hYUXO/JZviRe3/n13UmpSqaOET1z7our2fn0G83O251QPKh036o5Wc0l30lZ9NLT9U/HKhZKMoPgvcdGONY8VjRo60NPOwre4ZxLfouvqtRNwT0A+2aY8QM/bp5i/QMXK5gMhpALnAY9cq+yX+glISZpTJzEH7vrz+2+iLt+9b+OfMD2sC1htGnBcbZHAK8ibbbgD2N/MsKJLoUU+KA0LvkpskTwTryce++4/1s449lxNz/L8FnGtx3236b5zM5Q7wmO/JwMfdO7Q1YkbxNPhM3wu89mozqoT0RfKA+Rr8CYArB887kxvxCcKCLkQdbRCr0iKOnIk5xuQ2SCDEeChsTLHGoBOEb8aB5UD8dAArzbaWVmARQxN9l4x3aOsfAzkVcyloBvUzY+Le1f5dc4fznnfPvmRt+SZSWs2j6nOrejYtybZ822qfdqDa0zh3B3oIo175IC4LbR/xIT9Ox4jLRaFPxk5bt7cDU/3LVtKep2rHiF++N9xeWNxdssRg8FP95QT61DPcQzqMMXH8jw2tQRjzAGMcZrXW69MNiJqscAc9FQMXiFkTZDcW3mOYtX59ehDplr8aQ1AXC00hJQpULxLhqsiJCiT02TnA6vtRjPDMGTpR1sqxmL+ZCt6ZIwfwq2IRiCIXimBVtJAjPjzFTvyxEW9r761p+/u12q6VfS5fXhcnKr/qBvcqt+JQWg8elTcvGXlaPH5TclHUkaOH9fZ2aNXuFxojNRj54LMyNQoZjGVDWI6IR9YPwn/0yHXZbVCY73BnAQ9BsjAm8K8fV0jTBZwAYcEgW+24pArm+xSR6cJLJHoRICSUYybnMEt/JyM/uHL7dVrlr8mXq/gu+SGG1SbNi7dM/T1e0XxN95NBLL355EHBn3zwZG0Pq/v7nbUnUFaRucclUdorF0Swd1o1ldwqzoSYF/w0/Bz+Rij7rtxVnWe6oSL83DXJNQ6DoCkktVIh4aiUKhZSd+vo76ZALOz9XpPkpYBvWKSOf14wKzD1DIoRfmXv/8NlUJLj0Y1DSziTNh4Dy7EZ6wl317g1xVA1Tg5/opfZwk44q/sLvefu4ATd2pLSKPWwtRNsiWkT4ZxnPIjv1fhz6hbEe+Mk37mgZ8F6Wej52yQ/hQbzuPVGjA0nfRand7uiItP9uCNpi6dJ9nKpm9QzTqSJGKXdE/IJXRjY64ySyqdVHRo0W3Y4InLKvmLs4f98DsNCn4Q5xGNeKLD4uf3r+4tlC9a9+Lp2fzhuIoniZdcIIbw9r27f7sh/PR9+IY4d+3JJU+8g/YJMIwaqczBkzvBYsogZ7b5qNTt0kYM8koV4BgprCbYhpYkH1bhEWBH9u2k6kUMsB3UNKRmK6eEcZfctKUB0KuROhQ6eMzYOmxvoL8lpLDxrPwumJugF2FBHu7Qz1jxM/RHSQhIBPx1ZovVntSkAmy1S13APuJTuLH0y6RJBSsLEmB5HyZn5vz2cM13/xQ/Ec+Is5eKicsU3OPrNvz4MDXsfn5A2L939+83+HXhcYeWLNqHZ5afnlkOmb8Nc4B6R5zc+8FMFzC2Ke2GiOmKpWmDbmIJAwP76ZnzW4hiSmhmzeIgwQSlOqEBksM72RFnAKZP6kXQUAynH5QOAfnbBBZvAf7KGwL1cGPZ2/TmSKXFbpBz4czERbGDAOI7xrKR++OHnB9jGjrqctSiiW91qxNryO4+rfpWgjWTeoeGoS07LNmyj2X7rzyB9w9J2NBsptFAbdxE9Ux6/zOcIV7KDUDbVylOwp4aPbeJZamCnFoD2qige10ASkTwoPRa6kHRSCNGPbEdSYck01rQQC90WUpK2BxeBM5/DgI1RBdZfn4O3tRhJKFlyCprz9fLqil3tSve4IAlUR87X+wjCFhBICtHNel38RLfmuh/E4+Ik4b+VKXccc0pNF7tLU4iK5r3wdG91xN4AhC/2sHNiuL4G+UDUICmJUcUsT8OfSA48OIjCFUXWT4Zgfs5GixYEbif0L9o9Kk0gk444Eq/PBGURkfM7nAYpQwQ9stJe8OdI+2LnqRYockLnx54zz9/pY9zetYzL206vQLQ+mft2/vLtUOL5x+8qZdPPtPgPZxp1Kb3FqcoixHnxg5TkQbJ/zEJjSGi1pgznd6gAXmIDHRJg5zO6PV6Zf5QnBSyeIGqICYrp5MOfZm8gM1Gys2ARggEwRNskPt9VNjvo9ZcAVNk0VwBgpnXmi+4YidRAfaNFBRJ+0VHJUQDRhNUt4Ac1e6zcXa63IheBs1rKm7HnPt2kq5j+BfES7vnNlZdD1aRRPLnDz8MEM+JU/hqQviXSPdrzvBG8hS8F5Iuhv039R5y5MZyjlN3oXKyci9INRe9yQz2RBOr4rZCvzlShJSV297UXgBa6G48niIW1EQtqEmFjU2xdjRIr005mI1AYwQMtlxIUBstrOwvv8JTqqi1RwtZBZ8CQJs81FTYyVR+ibj3Iil75swKvg/Rh5eSftfFhtX/XBPerFDx/nBfvh7/5IQ9/LFwHv95OB9tqIX6DROpn9OCu4sLZsPhLqgag4kKltasN+izE8HPAfc/F3m5PToAwPAng8G00NeWwkAyPelbYj96NkMp1lsDxAPVCFsgDYCr7dZAXDKGsRLnYmqEjCzSfhBhlZKYlwR3RrZlyOeTXtv38tpg7qa9RyaPfW3X8NlnF7/x9SdvPv68uEf88bH97Y8VlDz96LTxexc9OHz4zM2Duu1YteGjRMG29bHj57Mj/YEnEA/hTbm/TgfYWwqsyGpwRS0y+hacmbJqW29lrjDLJDREejhAfSHnIRmsxecny0zFCgHORh11V3QGusr0bYxLQu+BS0I/JOdBOI38WvZEoPwjoT5RA8cjQhfxJJFSDxyXp3a2MWoUQ0iKeOTkvbOM6utblTuuv/h1vlB3tTfv4Pu5rs2L4imeQBt/SLLxjczGw1mBXEAzGBdRgAO5oIPLMMn0uOF1VCq6iFMRIQeS8pBR9Cv6pAodoJFp4Rqk1+ZoZFpEI9NGdBj8AQQdIwo4/1fyU0h8eBKZQ8PUp9fQM7+S3x3ODbv5T8OFdG/uu9GoHIc4j6GIBQuZDTYTZLmi3ijjWEFrZcC4P6hHiAi9TpsnWyvqOg5t4o2awBulUSo1Sq8zbxQP9pv9z6aeJRekxhNXT2s0sZfRwVkD2wkmK44QxHiT0CCKXmRFaT7zHhU28fA5YhR3LXzzI//AGHfxam/hp/Dl8KnPb9F726QvunlfrPTzx/EMeOTmvlMZsxbjhWzupt5Qqh/oG1B5x0E/nYP1HTcGTdiXqgH1iEdroImSNey3/S4RoGObLHhVWigd4LqrtHLZQI1VZCohhyyhAGEVcxbYEay0llK1gEqIYdD42+cPFL/8fXOOzltIHiCa8Oy7n91672TdiZyaBYItPG9D+QMD+RXXjgU39ZKfS4TnIogJd1PvZTfq28xE3+Y1qU9Qj35NkHoVcOw192aihkEy9SGtSqnJY/uiEC3Ff3Rs5EMwxoeRsdR0Ag15lPT4ExBiF05AjlonNAd/6eTAudeNOTkeojsnXtwz9xfJx7lmD28iK+gzQS9kb/qMDm5PtIfXAA+mEIwQRdi0ZgO16jaBOTS3yguboxlPuaQiOTwVWf+61XD1K+evstMeUE0RNQWu9HgzNAXehOSvdKjJr1AxzII0RXSrCgxgkXnskD8/YZly7m7LlmffWf6H+MHvs/a8udGvSCwfwFtEvlvLJ/vyfmr/ulWxHjS6Z9Tf4lq/+JdrXc8DPEOmM7raOkAkA5tBIEUoL7wOoyit1ItjvGkIIqAAr+aWqy27sXhIMIdHUR9d4GZOLP1D1/eieIEcJrqL4iXyHtH/KR6RlhhdWUmP8dnM3DHp2cz4bPUIHwguXbOns8hPd+tHChl1Wo205IXNYID+p2p9iweN0XUT1XUz1XWjCXF2FAAEBrUVpusyZNCt5CHpfHOZUGdPdu9j1J/69GDLvpQ4aeZyQZ208rJPD1MBNDj0G7z1ijhdLCeNlRE7OSPO3PP4PPoCP18AyWKj8QpIz2BEz15hRAh4uALskd7AeGiaM9HQ4C6aQYgw0fjz+U5z6n78TTwqfi9OIzrTkpc23T9lMY3twtv37W28Tp/nm8Xz7xoJvViQH1iLZ7Wdc3Ib2BMFOYcTYjI9fao45s3EY4bArouTHykh1n6Z2fQLbG6HRFTjZDMx8THwxjLEZWS19TEDD3r60ABlGbLrkXqHU+jt0VZvfZR6p2kgQx8X/FWM8oedhkf+YcLsjZunT3mYD5Li8+IH9LTf3vBO4/VDTyyoGxUeBwMTUl5E8OBz2wA1UCfFZvroOtYrbNEFtN/0tDFp6Vs8V/RxbJHHsUUex/aXjyPlK2pZTDZ96cbNp5fCE2BI9sSCg2h7nIinFJs/FAB5D7E86C7VqJOgv18j5Q+1DGcP84dCEjsY1eA60J0oj/PbrX6r7DynA6BWKevAgDIjG1LKyHYOf3UMWTIxvCeXL+OfX9HjyYkd3//iGjE3iFt+mRQq/6qwiHx+pOfWHaktDgwQv6Oe1mmx13eZKOsbZ9V+xAr0QG8KWpQ4H+tvSBQiAmcsWun0CRQOE0BtKYRIVymiN99E5xSvw+IidD/oohlBGW4HaO4VcbAGDrgqqFsglaWt2HkF7O5qhGVxQIeqFRKq6Qr6SpdSJueUoI1QEgBnbUN3G2kyqgWLNYd4epBJ138l2qD47hdXxD/U4meL+a2rFz36/gPPPPboJ9Pp+m2ltqav+KV4SfxZ7H+GtCTazr7wJN79+u4dZNA/XnvrHfFVGkuvA2wNjKXjuTXNIwq/xhdwqKGOWG+wclQ8MIRgoDf0rN1CiIyiyVFGQmSC/ys5nrA3RAwoDR7soJ5wVYQ0epu826ify8aBdABQLQF5EkCoxoq9h0DXVya1Nx47DRVx5oKKYhzP140gucREQuIHv83aLvYirrnT5tZuWPcCv6Z8w8RvL9PDs3d4h+JM7RTyzeNRviShlvpP3TBfUkffH1KlcUlcDlTosbcB4Cw8hQGrkhqXQrly6qIq4EIQCzndpqEvWbHUnw1NdpqCw9CcW3AYJKBVNLwU8R6V6D3qGhj6kpoFUlqdhvoT9G1MIEXvoSOuhRmsAiL9jf6E2wUESQlGbJDzpLDeRasVx6XtbWgcVZJZ6lQLMDItBZ4M1ccS4UlXq+oWnH6qKxn+mmuiGPh4cQ7fe+fo5RsW//uldz86t2vgo4Oe6vNquZMc+IbsJKltXN3iD1laj31/zbDhe+rfE/f9/c9T4vkZZ2YfnjJsKsOeFIqFWmrJUmmsPVPqaYlXSp1D2crG+rQUC9QU0pQs1o4OUiVGCvN+NYTdiEFZiOYNGgYTGT08zgD4PdaATitjerBZALwhTwOw5ij6tMq4KDNqvGym1dFpgOpniCW48wPx+r5Jnzz9dePZqffe9cDURz7mU4/NX9K//4ytxH+IVPhXPfF1e6FNYNy64Y0fP7rozv69eroOjRzQtsfzMn7fQuxLr5P60pPo85qw0SvajC6hTKlJtBsdSKgDwGNDjeAbgtbkSHIjJZYtkJKK+Otu1gimtYY4vTWFceMwluo2HYk0pB1lcpagAGRAzaz+aw5NGP3EI893eHvPZv9yf3D20IG3b+g99pXq1/cT27AF43plDWpT23v7kGULpm/s2n5M13blbTLeLnCvledcRqtyUf9HSPqfCoVE5HaC9LFN1dhsD2ikUSygGNS4gN/JbEtws6a1TKqlKjXOPRug/8ZvY/WHyNhLNDmSLhl51ildCj0mJlL9yJnl71Sr+HlL7h5fUvFiD3LiJfHH3W99dG7koIfeyE2677bBS/qRpSFS8FooI/nnr/LfcKWG54rnxfa/nmqYOI0YfhleN/ukzFeB+7wn5sJO0/NgCF279ty3XLAYToM2vmA7+Duf+pn0gVt4g/G81MIJfyf7oIvTn+atL3W0M1M9jgPezFJlY8BXAjWKDhgvSjWKYoBNpS/bsPY4yRcpoi+zqJzKmxFrFltCccXx1Aq0sYQS2gB9pg+ucL8E7itC9N8qkU2jDSLM0rJAVhEiLHKBUmRTympJZRzQ0agzqDYgsXk8Mwbq0iiOl1oa9VcDKLqvhIttI5Q7eMpJKc6sqThPRkpWUcs7V91+x8C25X0Hvdag3DL+VO0LpcR1YHBJbivv8BV33D7Y27WyalsDv3X8yfHPl4g/Huym2mNYdumJ6TPj3on/5kNXNvlSzD1DVKY9unlXnpw227nPceIjt1vMI8dOi1dZn4+Ors0GuhZZkKPzYCyuakTpg82t1+s88VB6UzKeX9XxQDqVpxksRSKVJtSwzdCxkJyCQ/Ue5l7oaNwNuTk9+wHwzdkTyxCJzhGJxmNSdDdRo4Mq6rZuf3T5qHEbc6Y8/eimh18rf/fwq3sWzhpeI/7rz5E7fUeG3Tm4Z/fQgIHT6WZa8sjk5S618/7h2/dmy/iO2M89LML5tF2VI+M3KpamRbHzFwuDbspT8X+Rp9I3zVP9/fyZpqj5/w95KnskT1V4tnEy+ZbEh0VSSffQh/cJg8IXeUP4RPgY7w5/C/smeOOcUCOMpn7fNKnTwOxjWG5QNDXI4x9WL/p9luPILZLaDNXbYvFbG0zAI2Jq4GjgRAImqxwmWyLo3QhQwYFjGCSaBARJkPJMpR2px+qkSoq6q4ZESr/MFq17d+/Wa+yDG6etW3z67MEsd8/qgb2HTnxiTCf+oLnz/Hc/fWNC67xrRxRrNJ1WfXUtUMXkn8txyj1U/nbAjwcPPMRpTXYaUUr0BZgLcsSeVs1rA7KnJ0GV44Dp7oYX/p2GDSF2m4YaBOiTos9zBXOrEr+DiUWQUnJVwdGQWW+xyQMKCkEjv5PqBHa5tTagNkp0J247ZpKoIEzUFVJk5yhyfyW5d1rKS8g4UvbryXpeIRb5awzKIF3I4f5ld/BTrm1X9FWor+/lN9x25/X6qA5upTLQQ+yFdQEasGKdkY+pzOqA3tSvReITv+CVsTig90gfUUzwijUsNIFATKlvWhuTIk5ob1/XJOJiaPsw86yFK9zXsaBFIWh1MWGznRVZoThSeK6xmuy+s7Hx7DixZ60wSOxG9lzbTk6Jnua9+dL8SW+0/wMj8xYD8P3gCJfiUXxfKX9etR3fD4hys+F+HsmwtkWHEua37NhJ8JnUU2TyBZxU+5O9qD1+wYfzeAleyE6YfbJHIPmLEvMOVI5iCtnpUgomqzlNvQX9RjPkHpXQcydYpAFytVmFJDsqmWQHxOjEa4L8mWT8jAeuCg4n+slOQW2yOhOSPU3K2R7gQNdJjhTkp9j4OGtMZOPjPIEmruyc6k3E0zDqVPW7n28Sv35n3DcT9h//Y/KYF6dsGkW2TXqpevJocmAPKXpZQ3aIvZMu7N8rfrJFL2aTb5z/+nTOaj1/Sf3ACXG0bsZXjz68zIgy3krXaAjKeATDTRRnIq+Im/uTC6bJXcYObzBNC/mrNKcWUFcYomITIMWMW+f8pC7HkNNkpDdxLq0QzuYIZvK1i+tvkfmTardKNothkocxJLRFVg0EEGlzA0NUZMVw6P2krxNvwlNMo4dQgjXgoodSwGlks/smK8sZa6Vj7CZsRbnbHJchB2HqYsEVNxoyM9y+2T/c0b6dSrXiswXPEFs3hq1YPB+xFcNcu4yMbFP4bTInbsyAz9gM4gYqb5hXSeJ+i/bEMUFiXbA+QWdVGHEeOKa/FgIYAQ5fpK8plIVrlVBH5QaMny+2vYUsJ/75JZOlFWy/1D3X8anzj+PhhYjUgOVpw2scXIP0dZNpYcAYo3I2srl8RK40mszSuxhJQ+cyjYd0ZX4LlOWodKOz+hVElii0rFGh0jMFhbohqeTX9vbe5Q9t8roafz3byeA2aBa+s/gpflX/6ZfFX6uKe3Q5dmoGtTKtO0wr2ryOi+B7nsV+27dYLoQ13aY2aboNGk1OVM4W/1E5IXhOInkAVBnPgCqdetTVSB/uK+evRLApI4oXgPwiwWuMqmWVAdBkwA2tnCZbwA5QnokwS8WYd0HdQq5kRAO4CQI15pWEiyjNo0+KX3z2SdvMe3a3Gkf1b/rkNwtrzp7d5dA88+F9s82aPu9MmL+YWDpN55eGRw/Pm3vlQ/J9ePSAwoXXj5Fj17Yf/X725PtnSP3ddH+j3LzExwWLQGS5KLKAI83rDRbhJi/KoJvc4w1mypu8nm7yhERM+fr+qyQTWMtrKCMR6LekuDKDCrONJEypTH9Trv9K860dYwY8MJRg8mdY/O4GSLw1yoNazga6Xv6kBm4HAqsmuSP99dL7zIKb4VWL2Bq1ymdr5MgtwyA3K4euVQaMayUjhnKavF7ZOa3y/2q94pu8BGORnXOLpbt7Tx4sXWlHXLtN+uz0zKLZ3w+bZhBWHMI13FsHa9j+IbqG1bcXzL18lK5hdd/W3brCIoa5Mo8nC01JixePseXkuWHUv12F8yyp4EVABTMQp2yUKa8CnAoAWeuVLtZqAr58GjYaSF5VgjT/li4tzLLzM1GstgIT9RWVAR5GdVKg4TKkSAHPll5jS5UKawqOffE0GEqJyjjBLvFAcQEXoNdpzFLLpUJqVmb9q6Uu4ogU6lXDcvie4+++d9MbU79c9faexJHTt459YFh1/7p4xZrdYn7i+iX3vz56y+rbppBA+MX144f27u6oYxy9N84qf6IyMFMZZHA/sTPLnyH3nCpluN90NxhXdYIRjKtaGeGEsYAmW2RNtrDkteT4w6CMxBmTTg2Cm7HExI4KxuhwMlYw9qEAky0hZTK06CTh1QXXIL02HZJVok1NknhMSMxrpqrglRttyBgXUOPUeYIt4iiAysXC4UUkaVJAE8f0+Plnx82+fc22C1/s2dG4btTkqiE9R6u0As/X//LrrySvqo6/i4p13eOhL7a89NyEobd1cqTkZaaJuxjjGQ9yVZzAmbQU7pA8k6aMTDrXqxNNEUmmRkbTUrwhhVUWpjSnposZNHz6/LIYsQkgt5QGcOffx7OIKhpr63VFm3uD9BojN5csN1dySoFc8mNiY1KLTI4F1RB7yhNxzaUWhfmQxEZAZLVTHnwldP/JNfvf+ik48cERI0fcbdKS/GE1/N2og9NeH/PKJqZ9XRnOHZdI5VRD42gX5OQT5TjahnwSKsjJJ9ogJw9iSsacfBwb26OWJTE2J2+AnLw5rkwCbI+Urt2lbpY4lAJlzNYkLnjw4VfTxSoPef7TjveUdnnhlYNfPCFe3tl/YdoH5SvX+t1X3Qnb+5w58am4/7UU1q9eeOOcyimM4xx0l7ws5eIdUi4+QRWxGSwCS6PfXGFnufjoVpFc6Jiow0ry5Ax9cpRGqUmdy0FthwPLOw6Wi7ez0CpOysUny7l4AGyhnkYgDTPxyTKLnK8kM5pILS71sER8BCId4pFT5US/++3PF/1r494v+J9q+eLh1QPm9x01cMiCgRCgnPrzzJEPxJ2h0wd7iB6yYuKsxy+umPzAQgmL5dsbf+DMtwuwD6MeWZK8kiZpRCyDBmBub709LclkxNkegC2weXHKTn8cp3eSow5ZdLQOcdPA83JLnhc4XDarG5Cm4KoImW3pbjngTNZD278W+EPh7EEEOWcZC8fVyHybhkMMGQwbJNK3zhBC3Ah7pMLYPJKgd2cmt+qY5a1qs/3CF2RX4y+jxlfckdnn9rt69SDrxwxe2m139ST+HWNJr+pB1va7thygbtaWLj2fnujlr/SpJJWjI5z3EV5YmAGYHInfriK3c082n3M8ilMBXJ7Ue5I0LdcXTOSkrGZWIUJ7/TdKT4Z7k0vlmmtBPA57DNzN+vPvxDB45jIItX9ezGfGJR2kHYi3MbaFZsyeuTR4y0Vmz9ymzJ54swVcg/TatMHgDX1cfLq7heRadDJIFJ8xN2N8jNwI1afHGjJaEoEoDBBPGM8nglW4kEqMehlZNuqj2suasX6qVTI5t5oRM8RQiqmA/5N/LsL/+Y41zqtZeWDRk/HPZ7+xorqkfbu5Oetsc+49kC/xgPa+d+1765/sOzqcuHMr8Ivx3/QvWnj1hFiNawj59F8R7/0Hhket4uR5NpyjToY5ajarIE8ka1XRWQVldFZBEzurkACzCn7nzZMK0TlqFT6pnEWH7V29iihf3TS/8qGx927KIS9lizX8xLvaPTh8yd8PfkkWfkyG7yjfVbz6MX9m9sTZafkHehyXOJGmYs6gSs4hIGeoCvg4pffXUEcvSLNlPyI/51XRIX3uNrQDQRpPaITRXC5XzB2WcvCt6HnXokmaLR2mw7z1Vm8C9LpY4elLCv2u44GWMA1mAegpzMqXRvJUh9ngSgE4UsAN4G/TAClncxsc3msTO7wXMplT2jBXgL5KbRPVqJYw8WWAzGqhNWBFV6BVAsM+8VJz+QZxuLJaFmI5g5rTTPq5dNYE3jR319T9iknkxTpi/TJaFvXqXNl35L2ral56dOSjI16iLtlKcMncjvJBPfsNnLhkbEfFTuqe3VHdry6eP2gun/3Jd9vGFuaLfRPXLZXdtJCqw+LGS6E7SB/ZW+O5YipjsLVOzkOUkmVw+ljVCqo4gEZODyKW+oq3AKFUXLpsIpBQKjOWcyPmIIKJOxqvhZQJdg3L6iSw8rAhJqsTSYTJ1kMJiHQm6DTJYDOmCiekxeIsISFOCbaBRSp66gCG1BkqmAfByRBwhen7WEZEdQZkHxSCOi4+I8YUqGCVLFBxDmqT0tEbgcmuoMGeUiafcO6mPkkxqzZHF6QYUm4zqn8ZP2+YtBROcXEtv112kFkSDpw5JvyKafSYK4v4yFIejtpjquuNkfeLcc83sj0v8VEyfqQI3xHX9TkumofDPPpIlkd/jfkUk+j9hbieydynEk92XCwkTgBaw6BjJNknm4mmkWMywnWxrBCEkRYahZtZFG6mQaUeg8pIKvvWqaJl52fFoHYkW/yuBmgIS3TJ3iF7FRP+xeGUJbjgZhmOLw4WKqmMZYOstltlg2SCDRcp9SliE0GNMrlG/YD9+dXNs0A0/r5/0prwk2RCX/E2ZlsX3zir3qI8zLWFPsgS2AWtWU98spfBYtKQXKcGkDviL4sFm4U8ZStdY6Ad/TvdBDhtqpzc1iXoLFhL6BP4oAZTz6njsluBNRBsAVVODCciww/j42LnBmOBNyQfE1tJccyQX/wGSd3nnz4pd1jpvbseuHfahOnJxedybQMHzDm0cMyI4hHFw1a81vDxpH0X15+9o+PWBz/7iVwlBnL8tzH+lLwPxWX7122bN+vSkari3kPeI89+snRJy/TgmH/9/K44Q/zH4vrRQ4gV5FHLcSrAVIonHIeQRH4bjd94qAsQtQbTDs5boO8Az6yUd5B7HhoGX1kpOwbx8jzo7oaxl6/LWKswVaPBcsGBAb9ulztx6WGO5CIqF97RWEJajY3eif2MHT4TpPdjegXo/xfjKNghMFFpdXY5SUZf2+Q5nSgKUEAJCqhBKlEjpCK5gDFeZmrz2ePTCFH47BFkIIVH4a79pcIgKEhu/pkSy5Nv9j5XKZ5p/ClfeUG8KgwKL68b15v8TtaEa09vIEvJAHF1+NyXZLM4HPk6ca87OBv1cA9K1SMrmwHjYIdqbDJjnxK6FzlsUhSoD6bw1ru02DzgUrPgRYLYE6IolykRd4x17imgxgT70o5uLm9VsFkupR3COQ1etXBlTrD0UxfcUezklUDXa3fFDmoYAUhCrcJUgl3CpbeXuiUvSe6Ac0U6/xfm0eD392LSN1esL6774TfxbfFTceW53HsCO6bPnCvU7Pvzz33i/rd/vSrUXJ+wfN7YkWjH+lK7l6XMQWabs9J8okvKo1C5+DCTEtAkRAWkoAISvPVuvQ2CYLeS0UHFIQoe5A9TJbXMbkZ7qCiAEUUljVKvmPwedujwTpCDh0rJg1KCq1yw0oe08FbJgA6AGJC+j03BaJ0e9Ei1vEKg8nMmeJr6ouBtBvQ2NvbPBAlNLAETQ6OO0Mz/h8xM35zG/F/ySWqO+EPHSTNf3vnAN6sO7E4cOd0/ceaw0cPvhgTNsWO7xZ8Sn1s2LXDnVjj8Xw+/uL62qkdPzNEQ7AOrUh7hsiKRZ5aP0TE5m3eBGYTGerMtFdqcMn0BsxoYGbECTXd/FpVtVpNeMGwEoqYRU+MwG5rTrD6YRc/0LIg+M7NY9JkplVygGwS8cJs1kOQuo+G3GXMEfmKVJqewB8x900yt1O/BesJYFxg3mCwgxi/9o1c99ap4vT3fKTe8V7N51e0vVVeHJv5b/EUtXluMrWBZpHLkgUHfvvNBQY9tb2elHc1MI5nE2KkkPAliphtnlZ9SfzsT5uNQRpmSjG6Kzo3U/7bYUUYeBpOs8MpoL5lUMJlNXCO3BGmY3Swwz6SiyQTReDKZaDxSYO7GwJwLJHAsEWq3UkEFjJamApJDc+lMaSIhOVSH4PzbTiT5wMbHK4vu7jJhYyvyfI5YI0wd12727Utefve4cAZLiF9fLN/lcC+f+1Za3qSH3HkHenxxqEr0sPgc7NcWxCq3A3o0SCYEzb1QLY4AljsK/ZoIroYgUY/LteLtF6zMa8DhAQlvu+HJfy+MIJpbZETz3Q1P/HsX2nsL3Y4W2I5GvJrwaoZrkF5jbL4JaiOQktqhVGkj4Bss/9zkhmT/Ic2jMyARXIBYI0jABmtZBDgdO0G0xMeQ7mYquhD+1OlhQxadXFYlriAnL1k0NpLYAaDU+RXhSfBHUTWrdaBV2UNUXis4TnEZ68oWmGBtKi9ekpf1VvKSYQo/uvD6LeQVuPRCRF7mqLy2XDopj6QpEU3bCNcgvcbICBJ2IAxzpEgXeROVSpCAWCR5YN9VU2lk56gm8U+Q1Le/7dZl+Jd3dROvk9pjaaZSSFiSI2Ix/OFn7HvgHi4y/7yR6o2dSyK57Nx7g4OecOwzUCpiIg0bRBpBrc4oj6PGRcafpUQ5NTl+i1feUQY29gwVeKnsHinASXZnd8fQhRa4y2KmeWN0TgN1C6U000JPQIWdZ2A2WqeGnYk2+U4c3NndsPDfH+JxEA9vg/QaG3zEO/EIUFB3w2iLi3c2PQIMPBWuYLZC9khvDZiAmFBDnRAMIxU2GYCRhuyS3YuKHeaKFMSHekiNXeMcsohUEeHkj8OGLDy5tEpcdZ3MFBsWK3IupWmE5M5g5fhhUbVkqvnL6M6d5rMcJMcpD2DfRzz3EVsT6qvKSyJ330gLEoD1wL4Hh1f2/6LL8R/WQm5/lYYEdnc8cmFD87WICJ0JWhFSUMnJTgdPWNBmsEbEZgsqTdhPp7EG4uIZTAcw7ioBXTheDuRuEpyi8OypatKDqEja299171D95d0dxPPnSaIoTuDfbMiJbZ+Q//ArgKSZv7ENemSUO7gULh2QDXEfAxg9dslIzOoIlOo8LmMtSb0NEWz8+gsFEVyvBIRSiqNKWHXlPnYXG4KkfqCQycoQk0jkFeoOAnkpUxkqjQ6q6GbAxOUCqYAPq9Q5EBVXbQ2otGi/7B35UgWwLqTyTiqLAgIz55iTVBA7GXKmfMqTtb8nCyOTxbIRU9tpUn5NVHfrY3r8jyX62+8qPUq27SZDyNm5C/rqyfeLl4ou09CVC8VycmhmdbiGf37UQ2KZ0CjOJvOofFbRcyGIdfQUbqskH5PZEQfyAdpmcOCwMhF3vN6h4YpoRMmm8/0p3noT3oiBP+SZSCIT+XYqqMf//Ra7a4YTAiqSRiooo4U59CTyCgXlgEKX4GKc7Fqs9Lo42HfwGkBnAkqNJCHSVEI5VEAoHxeZuKfX8zM/j1PsjRdXdq8qMuV97tF26FL7+cTuw/K3kppV/yZTlj9gJePuuktca+1x3xRxB+k29DZBdJCznYeK2xQbxYvEwGyfGvi63cyfTcZ9ZnLEuVE48jRmIAMme5zJKpbPFqiLq/B4I56EmyqVu8lei4u2XZub+bcRu7f1AneTKJX094QUbtht6XBVcAGQHKE7MD69yaZLhlpXSKlyoVo5qEQzJIl6WKXWkInQpACoYcOcorYsoMoAHdVEWvcl6dqAgiSqfh57CeRV7DhnMYevPJMsjEoRS6vvbWuzNzq1TxoX/7HMOLC23ceXj3XuKO5erEijuohu2xHQRPvtK8VfxI/JoS9BE6tm0/Pm0BNdwpNkfcTepblUH9M5D3VLsDvvDQ4UMj2ikSh0GivUK9JcKlZa8WdEklrQX5neXN7NVNcTUd2s5kbuf67DSvrPhBTpsBxp6bgcUaV+QwEv06IBGC6LS1qWpFR5WdzSsmTgGZIGSRUaYwRU7uhS2KNL0VTRpZVwETSO3x6h+u4QV3Qf1toI+l7eFfS9Kn/rD28UthavTuDXrbiKdnIwaL2t5/13x2h9xQhxOxk5PEf0SLpPbtSL3YSJqlNcT24j568sDLSn7nGFF8Yq9QiqX++WiLt6odTLqKjLLAEVlbqPBhI+i7+VFEsAonsrmEv3BnpDp1iZ1dZJr9DpbXEphUUlnSszGRxPbhf63K189Lnd2SCM9pVUYJ2xFZbzsVbYwiLEeQ86U1qBLXDbgomuJEz/qduUZGEpq8nMeklpdg7wdwEwojMOEzMMbZS1yCqhc9jnBeQv+KmZZGT3/ZiYTmyJnWnf9Wb2lOUT8/sNHtza26KFK6PPoNmPf/LmohfEH8T3Nt4zu9udd3a9u2vnaaG3Vr68ae2ajJRHH5has3fBQzDw/kBC75cT7+94R/dM0zxNu9Gpr9yP4+8vLzxyOs3auk0/pdLzXrYgPM44vTeKVYpjyuFcd24D5+9aGCijSt2ByVsJHez1aZK8K5HwrVTD5VB9LmVJnCK5pziX2pIecH6XUinrqJStjuQ2HTp3ZUIOtcrvWAEvi4A/1J9rDaShHSjrSmXdkcm6iMkaWzoyraH45IxcxvIaSkhKdGPzBpV2KXTRNek+lmVNIrKOdiNDdhxlHSPq6t3fL57ZYd+LmdNWPrTpkVc6LZ/aYtSTt/Uc91DX1vmp2Zl92x1cOHvUnZM+OTmvana/FT2nlHUd/+KrS59fM29FuiO/V7t5rHO5vfm2x1yDqh/oa5mna9uj7d57nnKpEx4YPOWpYSm21nl9dTm7cwRhLuRkJV4Xm4rMxxythM9I3/89wq+zFLmr4rk0blhz7qoUauOdcchd5RSac1clxXBXJTHuKgerPGJ1lisLpDjlgcNb8FaVulWlbmmyA9m3rxGnTLp9adOK5y4Uhw2qPP5X5YvL1/whUW+Lx8V/R0i3X9174atW//ZkvfLOGdbfyfpH8VlSo88i152SVdFnkXpZosj9CZL3BynShFs+S3LkWeRxlSjlNnsWaUgFWLf3ffOM+FLDj79MGFOzziO6hCzy7ZjqmjWMcfv0wQ/F7f5/vj3lwZeWuI76psq9VYB395TyAOfk7uSCTsiGGyNgdzZpdpJlMeXRyIa2V3fK+UpnM+Bwpzz3b3PCPIcSeQSNVjbJAQQWal9JqT3GSBD37p9764nK1/tizV0PV3XpXugrH9kpfFm8rtxxfd7aOytXreeFI4sqnA222jnXfmLfuYb6UTXCcCrxjiz3yog1OB+rbkXyrihgDM2grc8K5L5KwRwZMZHQzG/6RjW/lGqV6ta9nqkYOaV3x5aZnqLyFPFuEQDOd0w+sHgNKZ53X4ktaOjW/vqpCH/UU4ArxHsQq7GGmjvAFcLvCbUJnvHp1VA9wdl80aFLVB4Fnjus741UHmK1adGh2SKMszCMSHpfqMIYZOGNeco9qtZcIpdPf6ffQQ0UMhP6cwvr1RJHIaOSSdIh/VGWlOuE0l4WoPIJVh1TrDQHfWd1piCxT641ZOSSstAdpp/R5eRJDWO2zFKcBXPG27Cpl5GlZPPQ14tgriU2qyUHEu4qfuHfSe5+a2WH9p34d46vF//xvrV7+w4V/LvHL9eObT0sv1y/7fODrYfVOLce47v9RJ644CorrmibK35x7g9x5vmk9iVd27YkRX+seCerZ25WIZlJeJI8pM8gn/iEjDP9lDBTqOcS2LPbC+tTBc4QeXZD9NmlNKZHmtKHZ/ck0qfVWSRg7FSYD7PEJ6fLz57IeSLPnh159hLp2ak1tfDSo7OWZjCpWHfAOgN99ur7v37K0rm4qK3quVevn7R0KfW1Vzz3+rmKjoV9u7trZ5a0c3ZoOTi+bg6pf5VkvJNU1LJ1XsbP28UL4lOtir1lRamNr42aFde5vCXhdw58KKmFu3uBeJ3aFKy1aEZzRVxXbgip44IFUs+jBQN9Vm/JYPWWZK+/W2F9d8ZV2rnQ38kXaEMPsWJvqKxNZ01efQekiw20Lgcv+fZYS9qaumpdWd2qqwVOsvpByAga7DFIlxfietymzfMPYkN3WVSXqtju/2P4vj9x93cqMNEjUenvZAkUp16B07E89cruX7gDyHXOZpJK7Xn056GOncqp41YB1yC9GVOLoPcg2dKxjAtRsVewEkRxSWl5x4pOsfmA1mAddYKlANarqzWozoP+A38PW6hNZ1U3uDnIGkqLy8WlTbQFkzPaYV7GUkA3f55UYLKnZckFpnTqAHXoTh2g2wbRX9PZ6u9/c8HJAib25koTzp6xQhMSCqXySPcCzLZqe2kJg1YvbsPa3BZvI1kHWClq2s77z1QFe94fWPrRw9EqVIP40Zfvzx360p2f/MD/4Fg9vXzqlGmdU9zuvjNqRxSNdKVoZjus2XH3VPRfSq4SHfn0IhSpPhKf3C/uGjXY/z1Zsl+uT4lnRfO1B7uUEIeq7+LHs/Kz1ntaeu4VNw/xlFstGmu6c2CPjtWPSGfWWRWvzuVyuQ5cPzKZC+aAfnl8ARM2X+LJBXNs0JXs9PrLC+s7Mv1qV+gv8wXyqX4VeEPe/HZUv4qZfrXE2bb+qF8SdnJLqlEdmH51sAQ60Xd9mX516gv61amS6ldfFqGl0f06QNKvun3nUL/KqH4VUf2inm4B1a8iS6AE9GvmgbdQvwosocKCIqpfZZZQaVkJ1a+2cA3SmzH6Re+BfpVS/SosKm3L9KuA+sKlbcti9aulAeJeUw4oVQdrSKu2oKp0soXy26nK4WVfa8iW6EmSCHWcyYgTHvC1AS0z5VAty4KRG6plFsa6A1pGHeZAcUeqZZV96cfbWf29ogONkKNHAFxQMVvsWBmCeyKR639QL6mNsvrxn599qLZv98rZW3ZMnVc958nA/C53+B6c98LLT1x8aW3dzOVvvMtbqVp1nDrlvhi1coNaOTPbFlf0W0JWHSXDXi3fli9+8t35KVNI2eVP87aWH373e/Gl1wcPPqm8bcnjWXlZ6zNaZkylypRZQZVJ50pv0apXx1FzqH1GW6VO49rSCH7Jf6kMU0vlr/DVt5OUyRKoFBoD5Z1Bc3rcqmTcUyoZ72Ql47L2/61oHGjXjUq7rMP/qXxMSt1m4snxqPHP/7qYzG8yKNoa72/t2ljZOon++d8Wl5VnS0q2TaD/sfMP68zKg9TXyYTud7nSnACgJhlMkClefBvIpNJ0QUd80zJ01n8pQ2f//6gMXa+McyZkMKaxoCPNje6lLWhNTEVzL5WkAwmQXnEmlf11cdreZJH/ulQt6hSluum+xBcrfYkbe3j/U+VauTy6cAR8PMTNdQLvhAyXC0Ufu0/2qamHBhiCDqlPMDGCIfgdy38g+SSbE6QONTBP4BWFYXdgvpcLaGGQl1qdsrJbIetKio8d/vzCz8mY7xFUd92FZVvWjbpr5R+1Z0Q+hajIvp9GHhi0Q9x8dPub7nAZ+cpAWiAviQP76dgz8PJcVZNn0NzyGdadf/v/+AzNuEvkkabqZ4nqZWy3G/vi8KnjakevPnvXtgNk7jHWaLfs8oq66fnhUvKV5gsWK0y5cVWYowTEGM5eqrRn0T9OhVKdhX9y7FO6k7RD4umeJHnnnJ0krbf4z8Mkpad4un5uPe+ZtYkM3zR7EynrJb67adYmcfNmejnUm7TnCKkQ5gu9lfs4K9eK8xtlbnUaPEGt3WjW5gUVRjjmFCotMq5Du5fEQ+6Wx4fdaOUruncn9c7hBQVduot9XEPzi4Tv21feWZDdoS9fjRhkZLjwrTBSeZ7agI0c1MFsPuhh96u8IaK20jM4Hs9gv4HVHEzH63WMlF6qKth/OYBNpn4VPVKFBmXAlnYFeIEAnk8pwDSgg25RB920NDyK6RAL0nvY4yco7Q6WahOUKpvdEbMpdSYsfLHoChvWIVFRKvOueUqRdY33kOFuy4MrBtxTOOF+1Vq+quW4h54eKnz7fPs01101niyHta8nz4Mc7BOFo4pJqm6chSvg/KYoBzuSlNXrmQehh44GTm/EtlsoAsYyvIOFd8YV0F81rNLn9aQUTpw5X7mt++DCrBS3wZ5e7B4QN53xvdfRf2s+/lutke+dSGkfpGaEni74txRmbPHltLCYWm2e/M8VNzuL+brH4q1OD5ypwtFBmR3hnEym52Tvju9xnIbLFfep9ymfQr7uXK6U60ZjvNHcJLKA87cprM9n2tMmH/6tNi3pcxV5YYf199VbmZHvSY28FX6aYKK65ejex+uFjJV/ok9SPf9Yb1CH2qej3zWoGlMLn8gu9I/ySfksf5U3mJ0Gn8hOpp/IGHwHfKJzoXQgBzu3g591bkv/9XKqSpNR4kaUAuxx4A1L9ta72I1cLyA60OOkXsVuMCJ7SPc62I0ML6SAqRfob+uFHBrc6+aFQIFGHv6O3voidq/cC85dd3pvsFcKQfyjvRB6jKG/fRK7MckS6Es/Mdxb34fduMPr72MJTKCfqGXKPoWaIBeQAeoUkNVVQ5ybgFgggdal9HY+jQgCk8bQ2/2rRvWE23360ttjJ+KMtJ3FfB7WGND0naLJO9L0ZyV//aOmvzL2g7nK8RNGTlMNUHbo1s+rrG3yrm+Td+S8chy87a/s0J2+7aM/OGqqWnpDLv+H/3Ga/j35jU9Jjgyvqx2Zn5fTWjQMv6t2FLxSnJRfXTPfcVftyFatcgtVpv3jR8GLa5qbPyYm7q8b3qpViyKO6fMc9Wzl55yaM9PzIY3Lofu1lKugJ4W/LWoUWCTi9SvTj1v9HVFJE2FvdQIyM3+6tz6NrWMaRuz1mexdsjfQGeIBoHdMAocu0wNTiJilbqtk0xdA+VEO/rTNjwd8cbwzjnp59pJSJ43WqZMMhMMFhJSU+pzA99iRAGGuR1lKP0BXpZQG9uAV2otL6Yu47NxTc01d3nkg8GANX7p7sLXrrL411qwa3lZsXay3VmaOsfdKG9PGtpjs4R9+v3vgwbIaa/LItK5pf3vJ1OP9zqf44jHsg+Fdk4fVWDKq0pX5le+NreHL/3HlGv7m/iqBfvDrv82y9O7XbfKw63tr+FaHBlR6D5BvFuvhlxez2r84SXlCPYOeUx4uLE3XIwB6DEKr311Yn4RyDCa5Ya8mpdK9Gs/KMQzyK+QAGvf6BJay5llDcWpMQ/GtYVylGWWl34RjdAGtGXEYb4HkarKEzCbrTUiu9B5yuWjNVoUgNZNwGq0p8lY+MICaN6g3uBlBSECNnayA8RpU6mxlTVFefVCcpuuaQ+xtSn1qHGD0YUKmCfLrpd/Fn8Xfrr/3QmFL9fWtJ7UfCtvqpjhPZP94NLBHRoO95gqvIyv4iz+/wF+bp27vchcvqBr/2kuLpZ7gWYJflUMtcx73hzQRBe3AcdGBcZxzhpxTBpN/Ri7IPyObyj+VkWXcasI0mWp2OluKdMZlyub4/dlQQMDesMJANuPVwNU5fGHNLbqF2aiZjpXCWFkMuoWNEfjIKCZyQEiGwlYi3TqmdBo52QDh34l1hUC22co6N6FhOGiNd5Y1axmmOwVapKD8yCZ5STOxT8qeBR3EPZdNTh3buP+jK2c/3eTUrn1//krCaY4qt9XdG38i58yRwFvEdturfE/sJ77v82Xk2PXa8AEyf+9nq5V3J6cUzx86dvuGxRKunRvx/l0wEW2TcO2gz1NC3a7Xu2xKRqdQr+DxJRvAiUD+J2M3gVkT29i5T8YhVyEOud2GcNtK+lezuRoZzT+kw6sery4E8aenqDQwE+3uZOVFsxPR6qXuTjPWDaNTMM0B/yp/Wp23Muu3TOLIF8/l1535WXxb/GzIJP+O6Q/OFbp9sGXLB9+9+9avVw+zxk6emwl8dSoH9nX+i8V7yOrjLgyYAU+jMKAwUAEolY0BlRbgyQVQRKWGKqI6UgeXUqExwV4qY3WOFL+fPr80gjLGI8oYdHbydJfzaioDFVyhv1Pr0dC3BriClcBGs5AR3gbpNbarkzd6WORGPV6D0RO75xM5tNyIeRuMd0l7H8hNbLaAXhdp8LRxskJ6btXkGTP5qJoZ/+Raz1pfo4+keMTTkyc99Ped93/17O4DPwXvnjF09B2TnDgB+fymX3/dFL4KXZ7+0S9uW183pEdPx3i51wpwgDkT1b1VUveiyRfkQe+ID/qH641mjqcKZ5RaiaN1G2glVsZonAyCzVDfTdDNHzKaXNB9B1dFiBjNcj9/wImExYBEprSiGgGbY0CjZdVpNZWG38X6qqn5g3yjmh5nqjyisFO/OqfUKakVKSb9zvx8qevqvnfNmzzt+eq+he1Xdqx54KEZyh2H3xePL1jWa31C+BR/Vje3x7x+z0waJ/NuDsB4LodbILEhuqROTVbuz0TyTRl7QJ5ZIbGMzBkSrA2AeEGlnXro9rgECMkzrDtUBpM1OSUT3mmh85mx5QaMJngqa9Bgx4akTOgxUaD1URCfPDbG44MCnT09paFah0+LqTEVX0oG7YrTrn9r+cYXHuuypjI/Y+cwjT6h6p2hAzM6r+xQOfC5IRtHiw5Vxz2ffLTzuLhwxNKeT2v88yeI4xRjxkwUlvacO4CQJw5vFq9JWOjCHtUZ6rvMllZeHWnMDKgEYIUMElVM0zTxa2JZ0BSEkSRrb0K/hfVnzYcRPpEYS04VgUdgvgi2qxtbsOhi8jmdT0wMN4qXlDtIoShcc0p4O4qzysXNvqc0KK9S/a+/ZxMEIvl7rjz/3H/9nnb8norCs2Rb1x/uFkfuFwaRMtF4vY7F2NSDEWYjFuTiCCZ5UAE5DyrMeo4YoOGcV0NPOrXbQKtAaGgnAZNjk0hsv7kBkHWh5U3VQF+HeIOC4fyo9Wip4Qr3jXAf8GapjTbG0IowBEgOG8XtYEHgj8denPfMQgWfF24cSTrmifvn/TqPn/I+P+eo2O/98FP8FHwOSI4DvpGRmxfzHLAvqLCbPofyr59j9fmX/u/PQb+/tcn3z3pqPL88TxzZnuhyxMujz9aQg/XkxAHxl3qxPTnI1qFSRL4LLoVrkPQlxRdh7wA4Y7sgsbpZ6bokqQGoKZAkRKbhJSYrpwRRmnZL9U5hHiMbn9DHUlo1m3oHSjBlMjgo9CCNDrungEGwAK2m0xpU4xwpEEYC5FgS/EjnLIvQgACiKxsfZ1PDLGmrhiZ2hSovfKam07BGYnhRPP7ui9PmzH30wN2b1w1tMQd4QYos4pfit+KGA4WfFi8mZP3rb+nC29icr06xna5xMve+JKNkH+N2wckJQSULqj6RySdRHRkXlQamZYAAecTrtQvGGPkkM/kwCDO9hKlwKzQFlI9Lkk903Cs5Ip/45vKxm1iTJwcIuMCFqItnbUvRgzLCDCaLqvDs/1fcl8BHUaR9d/UxZzKZezKZXJPJSY4hM4Qh3LcIETliiAG5QUQBkUtEjMgiIiKnnIoXIosszsUhKgYQWURkWV91WWVd11UMICoqK0c6Xz1V3T2dCLvuu/t9n7+fw0xPTafq6aeqnnqO/59dXSTWdBkY2nlsmfjbhTVjp2yKTR3XpbiWH3JI/Iv1pz+cEBue939YidCfFi4xizXA/yFOIfwfDjl7PWK1BSlDdUsKECfhiJOwDFXYVCYpButqzQZyPRBsIIkES4y3SXRKWitMEAu8wnU7XI/i15b0IPh7iR5kN69NSjZZ7HIW+y78OcWi9lIBkwgUAiRTwjomomMkMqYEgQgiaGE3IBH58e0FZ2qqr88jch7gttVcIs1fiPMoZiTKuCFmZEfiqulYjNftkhsiSNpDxYAgiTfIYMSOlxxH6r+HIBkryWuLTyPFv8SSVGg6wyXmcCk+CBabw22wBfgvISaZcBssYUdqm1KKNNkSa7KEYk1GioEtslDCnIygvP8YcZI4f/8txMna6oFV809Xr9j0KyEnZ83LaIqjOdYP9yVQJ5ubGbNYCrww1nz0DuEN2YyWkVwNg1gKWJT4+lfS9UEKr0INsSv3JaxKsr6oKEVS1NakKntShgw0t2YXkSzMFkQJJsBGxsdxzsQSNh2o8MWvLWEc45xOL20rKMbpjMkJzy2Ln4wmiVIO8lqYFTyjgvoGqEdpRgDPAtCS2JumobS/1Z+tnaNmJjlL9B/YSej6OpdfiNfX64yfvcH4jTccv4Jauf7i1lbjT/m/Ov6WK4IEd2lqEk99MP+T2nso4OXPrK7pE3Ft0260mIBeEp4Fws1iZS5LyEaMVWJNkgZuux5BnSmAxy65m0E0lJdA8qsqwO2KLqy/+AqVhcInZUqiB9ykywkeGoW6rhXfkkxXh9fPlqJS8S3t4fDBN9mUYlGIn2OcNtmiiI4F6jbeDG5WgSyseEFNIlsTVZ2QLaglSKGc1mfTUvVZ1m9pFuqInE0L0KBmZrdv6ZB5ADbe9zk05ElU09S3iUdbd6CldU0fUlsG+Mh2QN0F0jEUFwnYF6O6hBK1ANuUlSiFyNJMZWluLUtHywMbxNr+JoEmElmazZGUbCrL7MvybmVMVLvcAERRKX6J4teWQsXfg3vMlCLLtrsehGsC+FLFq4DinNYkfaYCNtMDM4g3ajAS7G6qlSDakBdpqWwLuH6N56fd1Wth1t+RQdQlYaP82ubcRQO6zAD9vAd1X3G+6UrXpovIvg+NvLvptMR3NIXwB/1ewt4mcgVWlAjs6nGONScpbhZedrMowlZk+MLFUyo4Exsxc/+pe0XRTcnPYoVXLLFWsCUR4B5AeyTni7WF89Amo5QwREQRk6VS5X4Jan2cpHZc3zNLi5f6vsl5vvj5/uwC5GlaiXqIV649NYuvOvbss8fEbezBppHXzrPLxzZ9oGCbLtbYGSdznInaiFycQWlDvhHsiwZv3oJS6ONU1fFEfvCqhOO8nnCcWDhOIhxnS0wXctEBr1H82lo4DpVwHC2E40wIJwXQzJLtrRBaOOJVpfKR4VgKkCdP/LpnYaEGfY3MYgbyiVdOPnYLRWER3448iH4WPU2r0cejxSUK16RIOEUek3CIDUaZaZLlgzKjCAonE4whsJNNygr2BwnLFSw+A8kvUHTiV4ARx1hOn5SglmJ0FiuNFUNqPgUm9qFwMRtczU5FjqZ70CPiD3ij+gYZgE1ERaMFlLcwlio8Fj9eY1qPhVXGornRWGQnY4uxyPXP/6Wx2KoK2C5047mG+os/i+/NPHuIW7+P7jxNH8Cuw62XeCqXEg6cvykcOHTPJWSgLXhTTQSdN1nmsCR8OMxHMr7sLzlTW9A8we/UnHBKCc2mBENlEkUnuT69k4ns2gIspFwKSw/AfJKEPWtKoZUdWh1F8kW7KSOOqTUhDsCPUNvEJhU0s+3rvxF//Awb6X9/ouldUrrM1lAiHCjok+yS7QRz78x1ZcReV0bC9WRkLP6XVFiWG+EYtxTQL82a9BsJKJZ8QzHtoWJKNrViDpJwWmRByTDIB16b/3ntkQQU8rXpYMJAHZ/kG9McI76cl2V+HT0UmRKPPC0H0gHrSZJBSJZ5pIiMTOp8kOvYtCk30hkDWSMp1YfMJgTw5LwBhm2EV7ieRPmFADJARRCoKARe35BaHdjSInG/eOlCQh2OX3XJuoDHyBM/j1TbLxXSJuo5IzpAk0ti5DEK1xuj8YZj/MVj/4/HaJPGqAa0ZnsVidsOqkCt912bRB8j9QVppxNO869pNV2U8WTJnMDgP8zkAfoQiBogV89EKojwg00V0sHrkZoovMjCY8yiYHkSjwOkbOoMCarzlg6iLHM4k2D1PibhSgIcp4eukBIbaIzzwAqZBq9R/Np6hUyDUzxiubSMTNUG54HQVoqJgEtGBag+h4p/uKhzSD4j4jGyXMdj5EPEzcpdWtG97ktk2SJ+1LBl5kO/mX/4npc3DS2b/y0yNJ0B52vTOLP4Z7H5M3HzgfITweVM84adbxiadgCzlowTZ9DkYd3JhEgh0Z00TybIVS8vIyDcDALuLQk37hKIJ8mlVQpAMrEgM80RDxSx6EjKvr0VrmlLX20mxZyUiSA8AN2Jf0VkKiH6x7g0kKkbXqP4tbVM3ZJM3RIGJZVpmkeWqT0hU8KiYyJ+ppTKsAvL1y75mW7kZaJayU2dNLDTzmPLrm1fUHvnnRvjd4/vWlZ7/pA4/iDWT4/savq4kmn+0yOPm8Uabj14kKG+YYdQLxxnipkKYKgrgp3YrG0M54FSZmtVdPOpwSJeBppu3zqJrgRLsoRkl4CiAp5ZpAScDtaCInA6lFt28/pUTXYeqQj0WCM5PhhsEbgqfJXhbAvUaZmtkUyo3wxa4kyy3QP55hF96o2I60l6XSeCZGiVgxgyPwaEMpg8uxTBYBcfQrf/+Tcz+w4dtfLswudWuqxV9514ePXmV9bldejRv+vEbRPr5ojiF+z58qmPDR88j/UiA4pf8B/wvSZGTvzuHfaxg3tQ8ct7o0fETVOtab/3jMxEbT5dNWIwqvjt0+I5Uiexn5/HT2RKmBCzg4m2QZQUg0aavTK9jgEva+6KNiBDN5TKdFAfxJ34oFRKazdLzZEg/pROYteRSqCvAt9jm8pwqSVm4G2FIMKgNaZzZ2nhbbol6vXlE+VpA9y3uZVhryVcSKhqsqAOtsISMznT24I4DW4SPwVxqiqbEt4eLE9VVlULeebn2aHsjYSERq5G3PbA1NyK7gMmrq+9a5TH4c47umX+0kVTsopCXXsOeeTuO+49cIqd77T0H9m76y0oehj12W5J3uV64KeVDz7OFs4f8N6lVQ893sz0SrLvdA3K+e6NijEZFe9MHPuCVKNTSnhB84EXFPw7bCepRqeU4P/nw05J/D6bqV0sTgHeUMYI/BwJ3nVjgBIgUOgKhd+ARlKBUc8EabUR3on3fUFtMunwN3psEWjBZNI0MLuwxS9t+FIint5gVDGtKuTpxGURLuW+KhYX/vXTBV/XfI50wJR+9a9gDWHTl9hCms+xrgTRIMm/W9QGr2DpiiEEscBwUjDiB+hLPIB2RE2COig2hX1PFQ4E4qUE4GU4JyCnONhB8cg655cqsMNpcInsIX5Y9sB3qT5KmsJtzOFiAo1Z2LCvW85P9VQUOVgU2Q0RS/JlyD2W8Un5sAcbTelYRGlgNLkboETYm52DVz/8qopMdzdYrO40T3ZhsTcnEclHe/DVdLjY4hDFQlUsx1dWYpGAf8hPQtVRHUCkV0Z8HpLtGEkBuEjIRffjMxe2UnX6FFcmqR/CGzWJZ7pkMi2tGmS7ol2oKypoJxd3y9CY5/c69Gve+zSHgqI7++tyMtoE5n1eu8TUNsDNuef14gnnlltmTX29dCw/5Pjn52bO2bQiNEvcluPNybU17UX1Bc926fCX87mLfj4uZrHPDSldLH4gFkt1aQzhfO1MdHQ8if+C3TOcIZ6UMBME5TQGVXGsMANPCamsGSk5yKQGo2Ai4FVD5JUeYYgHiFcV1aEgnGHGfx3SJWuCNch/pempSd/dxQ9pOjnw44efYUNXd4hOdBb6NYL2kzFD/WSKnPQEiM0MSgHIIEPiWGlRsY6T5DKK7+UnAXkrBOZT8JLPcmayGEHOuHyuCnFBG7YCtNSKGlGM3LoLFzeiMN76V+pQXrF4useFnih0PI9b1jSOfebaNO9x8SgKMaj5A0luNqYfnttwdkgmIcBwSiBqBDFywbDVT5wkVoopzUkdI6YSb4WDOaGqMSLJw6gNYcNckRPtUmnBlRVfhwSTpnAckRYyFog/9fiuZxRYWU6WXZ6wDwttZ1R8B3Wkdcwr8bkvj5z7Jku2CDnLCDLEkFk5tlpalt7zeOEB7lE+YoDlRd/AROlqgiJwKqX+UaNUF89EBIIKoTNVUrwfKkfqHOXQNLb/lUtRtAqL8dSRj/F6M7dB7M+xbLzp72x6U8emU+QQNqgpTPt8RJzHTyfnsJZ9Zm/YZ4XYROmz4z/tcyX65OtLy1EWsonBF95/8NPaqZvF42wl6xaXolnEqbsXLUILxfmMvLZraoic36Ko4vD8Bb4xitdg4M81CeAOMhn1kINNF3/ghqY7QEqAHiApSXTMqNPqJBY7PwkbJ+hlD9Ekr7IwXwbbseC8DLh1KU4Vn66KUTrBkqSaltwesjEkm9QsshEtTE22UtkjZC5ZLwoXc6eKxVV/AXvjAhDJNtZc8yMDf+bEiatfYaOXZM3xZ7AM6sS5gh0/t3ywe7NljhVHIJpN6BeyU/Hg3QHKakEcKJAxRzDo+HyQQIE/7FMSE6RMuFhqiklXTLOV/IS7olASxvqLvyVDy8dLf56MPSckFn+BEiiYKJtCglxBnSEXF5LNrjxpsefhQ1pefovF3g1Jwqw+A6oGSQE2AHSkWMIOrD+MXmLZk4WmypD7JccKQNPWFXCeArFxkmV+/yfuzRp7brvOl1HYbt4XdZ276PiNRx9dlTqGW79vn5g6uO2iez+ErLgvc7zZ+WQFB66VdUtrpgA5PWI+FqcR3uo05gpDyrGjHA+ENUBDo+dljpUwGyA8tkLg+uw1FsJeQ2INfoJ0nK5st1Iw6Xq81YQuxK6QWay5uI62BX4FG558FngSZgDriCXZk8FTCa9R/Ko6cCTBrgtcFmYLJCCqdt1d+JpypQUFi9VCWK+Tr8N6DVwVkr+HJIJ9bJpxYVrS1pFbapd/J/7wlwVnaz6fN/uVQS/FOFe37mx203dtA4+3yWHDV21NW9FKtnfb/E2UxwavPZTH5idGTQQEcjW05K6RF3AQqFViZJTld/nHNddJ0pz6/RmqmcllUFwhAHCyichQyrBRyTD9P5IhuQwobS0utxamAYzv1nw2Ce21hWTPEOWzSe1wroutb7eLYz2NDXvnf157dJ5u9Z5H17Brb5mGGPGzqmDPm1B0zrXpsDKy9u2E1/JjiV/dgwZTnzlUppmpvlpIgoCCwBnT8pwOOOsgvwxOyFRzQXguLGpIWIaITao/7qLveAqQjNU3lmS16Yql0o+w0R9Pou+sFD3KokrEe+ni36+j2WsvPk/BdsvCSWUAsuzyXoYCVaP3sqL2SnIj/j5mSDVSILNkVxINY6TYzEDNC68UThmu45ZuaBnFr6oHZ6iM4u/hXXJlFP8E3qXgh5nECgZjUnIKPsKkutUA7GiXAa66W1rzyrNyAdayRPwOZiPW/6RZF6YbBgzqt6zP8Aco//uDw3ov6/HK65w70JUtbfp7WX7vPhwaJL6Z0pYywbeziodR8UZG4XOCPTgLrZKybi0yn1OKmTy3bGUiaAIt5gJkNEsVIB5lZsTwtoufEK06Chv80rOS/UPd9D9+15pBQ6NmHikDZvF0c8STcxlA0Qw5l4EA6hSdTlaJgABPGFi6PiYPSWOOCRrAZE03x/TpBhv0JpbkMdIAp8maAuQN5NVOXh3k1Qmv0DKNtMS/zYDfRvGtVKns+Bo8Mn1lFDejMzGK7wXv7IRXygkIikx3M4vtjySTLc2TniFo7A5nWav/UPdkVp8E8zQtQ2j9PZmuFrBXXAlQO4Wux4Rcdvzcte1hmhKEMkiK9IXoRC0s5u4KLQptHZh29vy5blxSnlY3ZFJoYfmKDezqATMR89Z7jjlmxF/qh2rnAgWVpe0K6935otgoPf/e+PnvxvOWxLqoDZbsVPkG4xorcVhp+EZVcAvg2lR+3WSKVB4zJ+FtBgjt9ABpF1BCYJJTUAlc87CxmCAVTkWlboQwGOck/PHwGsWvLR1XMc5oIqscinBy4WAyS7dqs4UA2lkhbC8joCrHrsT5CuLPD9S/3P/lSNKsb+4zbhu5pWaVsLvp9Xa5z6xo16XpQ9bjL1jSJqdpiJxzeQXPjVTmW7kKIyVV5jgE2egcRDY62C/caqZ1K4X1A4QaIoDoD7ktmdZT8bC3XfwHuZhSBjsA3iSSaf4TXku4VBADnyoF7ZNN0hrjgitR/NpCMJAChZuQogts2shFF931DOwMrtRE2YV0sCUgzhrC1UL8pUzEQZOgANVZoEdXIIGmfpcUBIUX4NzjtP7z3xSX5OhX7l68JuQ+39Wg6d3jH3ek8kOOvf/Atmcfr/1uNvKVD+zRT+w/i/ICa/KE40weluQ6JoGYawSruJRvjOdbM40UBTZf20hy1tsSDcPnt7CQgMfVwaKTb2iUasigNJx49sCux7YsuJe4SuJsihozoZIBwILTPARqLbMFTi4wPueC4yrKsCa55CGIV9ZOCNBySbq+7xdIuWUoL5idS9yb/Miuv/dXWwajJSj5yGlxpFg9SfjtszWRB+87PuWa+LVu0Ua2w82oDOWMr3lBvMZNumfwLZ2HoDbo9je3/3TBE3rzjbzyk2U+VIQMWQPYmQMeXTFw0FmSg17efJ4/TvBzy5jNkqxShUZSvw1EDnFbXmYy5dIE5haAVveTojyNjsmiJXdehc2GekulGFQeJbgpkqhdIB1MA4LjiOD4SuL1jCZnAlsqwCRSnrfUTDV6bgk0YchBGkTWnsjM2QlBbhYVmlaFndsFhXLzFNLsck/anuKcIktHVPz2SxExKh4v5u+d3u/xO7e/cfg028ywhqzXPurbaczL7PbCupxuvbPK/4b0Kxfter/ztIfy/K8P/uthb5Z17eRx7du/CjqFz1+gUwVMOdSJEFXy82DXhvOCkUJJjQJqNfKp1aiQqlEWLYWKZpIayEwP1O6YIyWScgUV2ryrdLnKIm4nPpJJGcWYWEZmVjZdiTKypVkla6OPaGMJll/UZfQT10MhLOj5wH7xq/SObO35bMX1NK8aLUZJWPNqxX41VPNe2jPom5r40RuoXgka9ub2y2cl1etjEOvR8gKU/tcW6gf6J84l+gdyPcBQtfNjRbP5w/lYrvidXparSuVyEypXqFK5QrwXZDtydQTNI5qVTZg30/VATUFkDHooy3j3D5VUxtlYxl4s4yw40mdiGWMRe6mMM70yH4WkuLlEcUuysIxTk6mM/YW/WkW1cgbhr9HSJ1dUfT70kSf/taL2NopL0SLf+y8k1LW5GTzD7CTidyshXBTLGUbbUzvXmg+J2mYttwyNBXwoyi0OHBXoS/m6HLsTavH+nC6jIUOOspI+GE72R6y8BEJn5ltnJ6u2aEgI1RsSicovX/yWbsny5ostIC6dJfnJLMlP/kXUyEM2Xo86NzkFEr9gO4kmW91SNqeG1HvwUg5dVO90y6V8kEdHUaSkkJGc70kitZBV6GxafuKr58WPDm+ePX/hw4fu3r7l9mGzpOzCapf4zVefii80+E9WLGl6ZkfU03RCicORPEMP+GSIjDwqNmxJRnLdjhS3VEVsHVLEVj45bL94rSU/NrYSf0WQkrzS4KQsmjBrwYIhC6vDSgRjIYKxJpNqMQiqmQGwJKp3pCp8KlhIhD9Xjqu1V7K3aeah6H1myyJx56K6sVOe3rtoxs19a2gCosimfx45LJ7c5v+w8oc/LXgqVRzLoOYD4hSSh+hiXmWierDpDEGiMpZA2OmHiD3AN8hgDV2OfTuM2CR6PBm1AA8APkGbuirUIlkrBrBWsPXWJXzhBxnbQ6fVY/ngV5XLPW40a3U22SLBZjI+BMkXEkkvnBOowlKoSYKSVLzdacgmVX8iL0Fm6RYq7V07dPKTfTmreOmC2CheuPYpShb3Ln7t/fBg9qij2woUQD+gJNlh1fRz02mS19UcxWvcHH40k808IHEDc1riuM0iCdhZFqimlyHkCCkzIGl7/Qoi8fMXT1JSOCwDk1kgsKbJl8FB50i+zBFWcgLiqzAjA7QocOS5gI48/Tp05PTYfSNK8jdOXjt74vgNaMmvLWw6gBYnqMnpWrGU5Oq/L80DR1Cd8QNLcwr4zmG1SIbMDTvJbrElMjecZI5InHi/zABSsvhbZ26YIJvF2kCTWQSgIOIcLD2B8VaBnMAESk1kd1AIXa1VYhxSg0gQOzSSlCytKhFDCs12lPJ8WMYrzYlQi2yf0z3E98XmF2c+/vArBwLTlCyPK0+Lx8XPy08F3/6aNTdNUdYKyP1xAOOPIiO2tYzUohGuJxrjDUXTOuHjvy4avKpQwURSDCQGBetIsoqNKbF0hFS5Pmc6nzv2+Ph77pvxm4K6BPf5fvGbHyo+6PLia2iH6GuRP3YkkRv1n6eO/bo0sV+T6xTWUtkoOU4gGwEw4vHaQrGqSSmlibFQDjElSYxUkKvV5tJF8Yz43ZVPVWlitDQcUoOIrszj95L4xIHWsvhPUsR+XUbYf0MWaincIAPs0Mkr504cV2WAkfJsKXWI+J+nSP7nn2/of/6nbr2YlVy2UOYdGWgq/Z966aTQVMJJaiJO0kSYQ+WX/i96n60KAfg/9T5D3UlQ8j4T79vWkVtqVn4nvvt5zZkFpwbNfmXQ1mjC+fYEeJ+v9BensCPQvLb5z2CZ7sb7UD3UnSFvS99zmh8iKZIRF0aBG1Cnx6zEx29R1Z29+oNdkSNqMMmCfPHi6Vbu5hRJkmsvPnddF3UYmWMs4igQkEquMSeRLv5K5R7D34CQnVTOSbKYEdvSwYW6G2UndctvEn7qNEXsehpPD3MWSfjtFeET2nUQvsy8vtvU83xX88IHXi11NzZ+MORvC9/yZth1S998fDW7Nnc46iJ+Nsi/5NM/zbq6U5zL9t94f+iFF6S6HM2XWKdTmT9LOQ+21GAwETCVmDWITwdP5FSVI0cmRGWomGnIqeHmyz9RYdqIMCOc7bJA8rFeuniGhuXKQLYRrR1fB3fnoxeric1Eaj7BHWmC1yh+34KahdnNaZPtLiWCB8ydUByalGxTXVWZUQKpHzdLGXA2FXCGNeQDxdUYUW9UgXpN0bAjUa14Beyn766c2Oq4yaBpmn98hsZcuVXYfXUhP58uhZx9DCrIudqT379Z/PHaebomFInzhKOEN+8RuSbQFQxKECXE7NYFFVQwlwoKrEUiG+F1cDYoCTAUcCRFARzhsL2a4iRTFQF6iDORBElAQiK8QcpEs7nah5CU7oLnJR5nfgFXdA4VjTJn9EBzUeXbJ3++cHJ/nOXEtuFxyRzE0OvCt85g11wb33QYLeKqOO21/eyzQ+uuxa93ZlvMMIIOzmxMLj2bMXMJpu/I5vN8A+EV7E15BcsZuT0/TdtVbs9MZmqV9vWEy7M35ZtllPbaPPL3HpN5aTXLCSfoNkbqD/8J+fuF0t+vUu73GPn7/ejfv8zIfGCCRjiO9TuHuUvCjUjnG6MpcupcNueEWsJsrcKN7DYQlAjAkbcaCAsyQWqIGJPIjhrn8aPIIpCL2ekUjlrPycxcKRZCd2Nrl+sNSoeViq4omC0lX8oI1b5svgptQ+FJmu3r3nnv7t8/gFiU+p74zKmTn18aM3yr2GuB+KN4Fg36x/l2+ZGGmpOlBeIH4qUmse8Pb4T71X720WIytlDzee4DfiLjZnwwNkCpjmQIjVEzgaQDcgKvyyzzPlNmAimrUpBw6QAQOU2xpQQYm9mVTcbmzVCNLclGaRaT5bGFJJjICsmv3GJwOZoQugW1K2bvnd536cQxW+84fHqT+I8tz8f+3r3bmO05GW/+EbG7j2dlTHsot+2+sty/HHlHfGXfyuXByvCSe+AZk2cGOsM+KulMPXnGZLygM+xiqjMxRuVH6Cr7EZjJqDrhR4D21I+Ar9cSHTJjXZlM2r8j3d9N7m/A9w+T9l/R+0tY4BrcfjrZ9/tIbLK8RtIgk7Tta7E1bCBbecShtVCIB57SuoZN+MBjdVRSwhULoQPPVFju8GQlxAr4lIsN+nzNoCPVOw4uWro5D+1vulTMdfaJuvgx8U3xi3EHO31YGtrw6F2TdqBnT2wTyw37t34uXivAZ7llopX7BK9BbqaX5K1KAoRaf4SFDTTNHxZoiRKk1doE4txmIqyLlKQCMw5jtlHASILaonVep2/ETTHjufDOw5tW3elDr4tMEZfqFV0vH1kpfh87uvbEiAPPzF+4Bb31xnNihunk9pebmWVV0nwVTmk+wTI9QrC+axiRyJrwkwpLZH5SVONnGKU9eTZHpGfzmar9eYXPdLKGtieY+WR9CUjtD0vrwQU+RNoPoe3PqtoLx60a1iutLwSnHn/OaXk/+P5694N2qvu5cL+WkP5+Sts3XyXtgUt+MtGla9L1oaR9Er7/ZCKPP0ryGE90lfCyEnmMoPKguk3bk/v/UepPpar9ebk9M3mNuv0M5f4jmK1K+4cIHyy9/4ivaPtTEKsm9/9Iuv9S0n+IhU4i/b9E7/+tjKUwhWAp6Jn7GAVDAUENjJTKaVTiXEdomAdvZAykqlj/ZSonQ3I5ZZuU4AzpWwR/aUYY7G0y0sFnnyw4UyPslrI4aQ4ntw3PBT3JN5WgC6I8AqcGr9UXh3WB6/VW3o2V3sqJNS9e/DP5QkWgxsQYqWPX76RN7qT/PLusSByxbu+8LwBVoKkdFJRQHddsJDL/s7QudSIyn4Wf3Rki8yvSs9gu2Ri9CY5IGiDyGKVlBw4deH6HdX58Rg4GI3qAECFJVR6/cqSQEXggn1YjG7bA4qMxx7QaI1TZwSsN5ZtI8aGJHLs1NsgOgmI6U4rVpi6gibCUXheQZhnBTvw4LrxkdEMAj5WA5ghStvOiUHBSprNx4ZqWOCPVnwzwrnukJvSlY9kUBXBEvE9cs3l1KsUcEXsTzJE0ZgOjYI3g02TEQaB4IoY04DoVGiOsttWYZZwR4Od04zFrLMQ5B6lRMdZ9HbARfD0NruNhG92E7Q8wR4zutBbDdphpcJUBuB7qoVQhkWiDCXJ3kERLWJLQJ3296xbWBdqFJmS7ziYgSq6JO/B438IywDsX5C32JnmLqcDfwMgMzHLeIvHd0ugqmOCtPaeCNcbr9C6SbavK61P3qmVS4v5Pq8gjCLW7M9M5r2Vy4vfkQUDHaIYiat6GdbCaxH9b9o39r/WtFp0+89MKlIWsYvC5U329ax+5vV0oeFe6a/pz4glVEuLT4o5n1lChkUxELDe8hoHcLMzARG09VJeHBajbZXTJJGsb3DOGAIDOklRZvF1DJo0JiraTCdgWy5Bi7YiOk7JR8TEh5KXdxc/Y5sUCRJfEYqQ5RYUoliK2WLz0fTODxceuPsbWEvltO9akyA3PYCI3C9NF1Tf2F30T5L4RQNzrdyVIuxLUkmTNGrT884Iv3pZEtujL/AsfXsKSQqfD6DCISuwUFn1SsiaLJcPwz2EZGRgrnFR0FDUJQLzCpoACK8eZdVDalUKQ5Ij/hlbmS7R8stPG3op/VCAZDMRVAyF63iQQjC8BML54LT2ckUlkTlb8CNiIhDMZWI2dEPB6DURdUMbS+gviu+Kes43fX5w1dv4zr6Klf7nKDrnS/713j6MPF0t2/mnCf34TGdcQfD4YSbB9CvFeRri6wo5gxKuFtOio1wPrvteM132LapT5HhhlXmKURerqIxVgi5xI1UZZT/+ouDFzG+RyRTlhxyyn5FjxapOL5ZALcsiDV6hLTLHmyjgs+G2eykuViVUw1UO55ZIcMu4b+F/y5ZM/A+Li5LCoNHko4YZsd4MQh6DBKHv2/Atf6Kt6DhrjGvX9+KKP9k9elzfghQmvvn1x+ODaWfYuNfEGVPMD8rBDrp7Izepz0z1T0AHR23B44E239n7ztaHDJ4xAvucZKWdhssaOTxdtmReZqJdGkyL5lA0hn0Bt5juxbF2UGyFSCktAuZq81oiKZd4DCYYlEmgZUDZRMkNKbAjk7RA+glfiEDHmWqxxPiXT2wbKaZIsEStJZSjNt1hjKUwmpRSw4K28UqEQoMw115GVTyOD5Ukg9+zIxeefqlteojM7qhq/T+7fd/jotE7nepWc3POb57MMz//5+VcuPHfbs3fUjKhZNQzNeRuN+31d7dOj0firq9oF+wy6/yGULh74YP+04e/+cc+xLUi3ePjUteIlPMdPY7mNFo4xpcxOCTXTrG0kEHqRYm1jPNfnBvy8XLx52R2weZX5w+kfhbMCUEEZK0xO1xVHhET5loOSthCZbbt4UcEPtzVQfjiJgY+8EpkVEqhLLJGIkExtfLuF4In7ABsgKZ2wapEG4WJrRCglXnSqZu29AYUyS9tSfBXt2rciNzv9B6SNf/DWb+dN1fStGjrGU/ft+OIPD+3eb5i/6OOCePjwpOEbXhW6PLl37Zr/ydN6Hp627NZbJj+MwqL3vddees43JDh2ePzJR24bNpXs98ux7XOAxNxflU7pydhuS3YS2HAL1jGscSzoWB4+12ZlOi1Ygllwri30h910gfKBZ1CgK5VFwnUsaulbNdGEOUies2HBmcHKIa9EcECLE9FpseAsAmwKTlC1zGSIvbgprwXoWTgPC61ALTRyAhYczgxkbyGxUEJeWFzLDxyMvtnM7H6ibrS72/neRR+9/bvX2Nvv21Awe+kjW+ZEeWv14w+f7iJk7O62YPpMVCoeeP/Qqid7Du4bGzh4Tn8iozew7T0L61UBs5qhOHJ5eCpm+COZGkUQUgWIDWRByov8BArEbQ7nwCWgCCtqaRzyJITnwIa4DSwlK7ZvZfewCpTelCOBpGZmgDyMIAd8O5ADJy3phJYjQW6n0VInVGu1eaP+62X37xn3P3sfW5ac+0n92ZovB5rnzz9XtGPXe3eNju4TKob0rl4/+qUjbt6ycoZn0O/AsEeThmYOH7t/6dzbhs+l55At4jzuAskRWslQxcgRSAFVukTg7qKEK1YC60bQn8LZkoIoaJ83ykBmYuC7pRJQtCPbKk0rYMlKwZJI98gAlTn4trmgEVa1RvwTOWAxbDnwdvSthQtqRgv21+f/taahk3Hs8O0FM554ZMuMONGFu1dmCvY7h7rLx5KqC75tYVWX2KBbqS40H2hu1JrxvpfLXEvEsrOwhZMZADdWKjV3Uij0qYcUZ0eTyW6YbNAT3HIbpQCVhfGLcHcWHMuyGxSD2gTV2tiOxjOCJP4oqxFPXL1WLD47fOP413Hw7nojqFiGVpetTt/WAyFjZpb6qoRvkkx2QybC+ahLBU9F5GkVGE9EJeQFK2RrFSVnr31sW1E9Ia3u24ltPjz4u8OpW8STrUPl1yx3FC+ZMh+vU75333xp/S3TOJZGzVFzFK/r1fxopozZy0RLKY4gMSHsgShHIOo5qdyDBM1hckq5adm0/MlCue3cNPVM4qsViNR9WIQ5DRGT9TLJjZc2R+pUp0UdTNyU4krLkU7H5L1PnTObDYt7HtbCVEs4A2RVSmWVZ4kjnSW7DbG+W0bcW2+RILIbxd+XJt3cu3qkt9OFvsWnGmJ7UyZfPxLfNKai8KZ+41fhvXEXXufXdOuMfpaj8sR/0HxeOwhyeJCQyOGBRAPAMo4a7SBFY4oeOLpbMnt77GCzpSWirDfK7nHRFJaYoHfpqCGnpyS3ZlWM6Loxe7di0UmaTRmVKbuyoGQFwYGRd4NplwavcJ3kCYGNZ7K4FewJ/D7No6430kDtjNFOCIWNUlqzFJH9pfJ2Q4nw7LefmFbWjEuruzC+9MO3dh5x5yWCtD8OyF5y7wOgre+/tn1dtxlxObaPdXU1PndkyKjpgHkJRzbwDUaTHCDnJMkubhHBTXeYk4mZJ0dwW2BgqiK4qVTOYW0Aizo1IWrZZs76J5FdTwMvi1oxA1tYzxlY1hkszUrnPSBlfCU9g0g5is1nSnDLp1g96a3kS+3n9CSyYiRivb9UdWCulSO/q5Or+taM9nQ616Xdp6/jPcihxICb+ncs6NN36iNYn/929vcvrXFXTCa5AeAnnIP34kyofUxvwdNp4BvjDmc6FJM7+AS3pYGAGFAOy4iJAeg/53UL6IELgZeYmULggdUQos7FJ9F9Fy7srpu47rZnRXHFlue2HCoUVxezd2aUvSxePCz+LJ5mC5AG/e77umOB3NfF+O/37N///nvrvhMvLEUloBNwdlqC90wP9JnYpSkyH6de0xi32d3QZ5ug5Icl0UwwbGHCIZlJwn0GThp1nxN8NOoek3DAyBdR2ZFTK2seXXHoy/r7HnzWI54uYK1pHcVvfjp1Ce14F/V4tTreXzzX+OCjixfufVC8fPWcVFdIYja7GTewpRPMKQNeGww2QuJhwjqbElCVkrvBhE7zh52ty+jA3000cANFhgu78RqbqnZFyhHMFgDyQrI5VS4mx2/darxMcO3bCCA1x4KaMQaJM16phfvFehou5c6XivMjpptvHjouffg3ZAq/49wOtefXDgzI7tFv0iN0+m7Z0G0clwk1hfg5LSf+fGX8ml+MH54aKSP81+PfdvGnluM3SeOXoYX/b46/Lo8bXyQeuptuH52/6VP854boXucEqPlrEhObxbuvv7ym50h0UtLTo3hu5TGTmKgPxp+plTLlLfj85HT7jFhPnWD05tM8RkNjTOuBPAAwaArAsAHbjCegX5lgM3grw25LOLsy7KSXwxZsvKYQnmHKeIqXgwqAV6DkJATEwmH3BrW+bItdhlrIH/nxh9MeXPDlqoffHz9jwyuzV6GsF4rWiwOfWLLnwJ6f/noVjf3dB2manA331r8xrmfVjhkP3Hliv/jNxLtHnhx6FHztwebz3JcQy0SrqA0n9ib5iNnMwYQN58HbW1pA9nRmSWmJicS7X9hpHnia6cRO20Jjx2mS5/PXpyW6tbp0VVoi3rfkC4l4uuwAzbKACnB4PUgl6OXXS1Fs4dq7Tq7iz6cH5Kx95PZARcXEbPuF62YsFotrnl9B3HyJtEWSt9ibX4htsCLwYhVKeYvRDCVTMVtDTGB87HGDfrTxR4pb1kuHM0jCImxmKZbLAiQsZlouc0wE3FSQskixdYi7ym0n6h0utJAsDGJOZVtiSEdoEH+Zv9jCBXwjQ2ofcQbD2MEZfKOExjWKaziR1Uji400H+IHCXjmeju5AEv4Gvl5P8Dd6S9dD5Dr+pPlSOwtfb0tiCrPRflSNrwPW004SDxokXY+S9scYRhuH+BHTkVzvhawkNoGPXZqRpH0diQf16stct/1s9Ml12sN1u6p9V6X9ZDQr0Z7Es+qk2MfTdLzi3BbjHccfk/BG5rYY7zh+t5JvMFB7Vmk/RuIcJvkGmvVK+zH8PiWfYZ/2pJLPsFbg5fbCSE293J5by29T7j9d1X5doj2+f6L9Oj6q3H+0rpPSfr3q/tgSU9qv58PK/U/rxirtN6juv1hrVtpv4Hcq8llE5A/tC6h88PiqmTr6O5ATeQ69pe93k/hf9eVEfkZUZ1P+3kYhSzWeA8rf28jvVdo/pWq/SWCv236Tqv1KXa3S/mleTLTXapT2T6ue30nV+J9RtVeP/xk+rox/lbZOGf8wph8a0lpPNDrpd/loGK9oC403Ay6vsFvOJ8HfrJd/x10h+tVPur5WyT9ZSPSrUNKjz+X+cVeIfvWTri9T2m/T9lPaD2cGKeMZIFyS81XQ8B8S8e9niH4VSnp3RtGXHkS/+knXl6r6k2i/LtEe9yfRfl2ivdCL6GOhpHdKe/4M0cd+0vXE/RvI8yiU9C7Rfjx5Hv2k60sT8iT6WCjp23pJH7sp+qgl+thP+n4t1cdPlfFzXiLfEipH7gL5HV6v2LeJfH+Qrq8k7VlxLslPktuP4+YRvTiHr9cIV/D1Kum6zDE+l8T/pXwBNE7oqegJ5AFIHOO4XwdU+QBnlfZjhNWJfADSnyHS894st9cUkOcRkNaT6XJ7YSB5HkOk57dedf9E+3XCNNX9E+3XqdofI88vIK0nifY/kuc3RHp+qvuT5xeQ1pNE++nk+Q2Rnt/6hHzI8wvQ5wPyIc/vsPL8QuT5DZGe3wH6/H5Q8is0H5L8g17Sum9Vxr8cfodovtfsbtdv34uZdt32vVap25+V26ufB26/Xmrf8nl8CPNPaj+cOZVoD/OP3h8Nb2bk8Ws+1NiV9ir9EJbzV5T7y/qxHl9fSvSvg9Q+j1yfhuW0mB8i5atA+49pe/w8lhJ96iD1f2Iiv4XoU63U//1ye62PyKePvI+S9lPwuPxEPn2pPMcy123fS5p3rdv32qRuf1Zuj/szSdV+vdQe+nNI1b6f0n44cyLRnsizL5VnOSPLR+sj8uzTQj5TsJz9RJ59W8iHYDMR/etM+9+8KZHvouSvwPUS2h7LnyHy7yzdZzKZ/6Q9kf8I6e/uUN3/rNJ+DL9Ddf/1SvsxfCdV+35K++FMlir/5pKSTzP8ZbqfBvDzvSYcN+P5Mw3m1UpxAvXHoP3sEHYJwzFe4NSMIHx0RWDZ86SMkDUwOr4YQo8SGo2/FF0qRfuPHfv/+tvD3HPsYvxbF/0tPm4iDfmt+hfFXN9idPjgQWmch7VzfsVvtBnSb2Btp7+xajhiszaXiAE22vyBuYDp2fx182z8tHsyWcxScv853AG2HJ+ZtEwOjYHEtTyjBwZFQvET5w2MAQ9IT/9Ue2soyGp9c3JWDgs/cMs33MdVyLBE/NvH1M8wA9/Lj++lU+7FSPfSk3sJ9F6GxL1cGlY7o/ihjAu6vNVDuAOjUPca51Dxh3p6Ntko/oxqmAuMBp/ogDeVle6mVfdMR+7Gtbfhm2kn3jXqvO6ezeLPF5DO1Qixw8+5A+hD0qcCml8V16j7BM43AqtKEgQ0Ep+P1u7y5bOfp5xCyVvcZcJzzml/3lGH9BDDxfLijhJ5mZhMOkp8ypSEFk4OAOkAuOxU0srDfVMJDa2s3oP/PacIz7kfeSUZsiBD7gjpr1m5f1JQEiSpk7X4JWpYRYJB+oZTJPllcGb2N/qxr6gkeh/Kv8P5qdgE/FxYruwFItdkJh0kG9YGJeGSv2Dyg383IdUgvb0k3DP333pOP+JVWcbIfdr1vvgtPP9jwCOlsTNGpphi+tJbw/wIawg+IdRoMBHEAB6SoDOSQx/QJQe5PG0e50PHilFBzqXlqG+x+M7mn5COO/CHTPS8OCrzD5nXvJzEfcDz+G84mAEM8XPD37DQv2EOhAU/ZH8At5aRlFWB91r+gylWB4S3BUuEAyBSjTXGaw3JSh9CgtwRLe2NrXcpChlGi2/ifzyXHkV9S8WjugnwzztplxahuhNZSHcp62Qmul98LPNk1iXx56wTGeISNAdksR4dZ7fwOiyLMgarGvAL44VB+odANUKxM1ktpH+IbIjnhEa7fDn5619+YvysLSsnTmd3PN0w5b6nG2bAfEZ5zV/w05Adz2cLB1mV+F+2nKziFsSDGmHtXNZ8Xs8Lx/ATtjAZ+HmEmD7MYMDUIpn0AH0a7hWMlAmNwPgLqbfU15omNMaNdgJ+asRvc9rB2/DAIIkGdsYiHUI6bqVV2lbitY5r6Sctof+Ll9BPJWbITIjn0U955kgH/Kkv/dSXsOzGu5FPkaEQW2YoFGyqJWrkAR02EiixWKM5RSmVJDIKuTtVfS3WSK/OBN+uDD/QzJIOfeGB2i2xvEC3KkINZ40wkDaeZoloU1UpDLTkNd8GWIF2WhsM3gTU4tuQ6hvhht8smxybU79o2u4ZD/6mju968OqhEYPaDes0JFRbwY6cHJtd/9i03dPrFx0Y3K62U3W7YZWoaXJ8dv3iabEZ9Y8eGNK+trK6oqYjN2krKli7fuVz4vGNm5tKhd1X+nNjF888N3HhA39tGvgKavPU2uXPi8c2bljz6KyvJy2c8cXUHagoce2Br8ctvO+v1B74kNvK8iS/3yB/5uaTzwJZkwcx49mx3Bd4rjsZeeXkqL7RldNWgVzIph2Eli4W/7ohyualoq2zxai4sor83sCMYDO4T/DvM5XfC8rvKTABD8tmCHEhmwMZkHdj7JQ48wM0EE2tEru7xTqyBzU3f8nPEXZjXeXZLGIx8X/B9xdZvGaweL3jGAbqSUSW73Lo6mGQCF0P57EVnJnocSo+y1AldWBdNOJVVmiUymjiJqpXJhKFlfQREucIlVXEyBMYErOU+mX7xbO10kc7b2J0xiOPjd0998HH3qi5fWptsBY/qVdRzqr1T0XErzZvXrcaZf5u0fRThNeR7c/xwhtYPmaIXhI+Rw4qPGEtNRLy1gifFAhEDUbiZgbizMTqrebGDOvLwlwZRHp0wmXALoqYBChSMcd4HWcrjmnhFX8dM+ghozQJXvd1Hfn9S5QjEz5G8avK/xiBkj3UXQ947XqDCrBd8jwaDYS7DpY9FOSC2P70hQqC3ZBG2zcNnT48d17GAwV7CrYfaZeT3ZO9soStbDq+PBxefnpBkHIPzWArOQ/Jn72d1u3FzZSH2e2X+JdhxbNRtm89cbPrjUBP7/GHNR/FnQTUFfJLAS6aBlX1lghy4olrs0aSLBLdspLhUABZoVplWZwxdcaE8UN6dhzQ7X70F68YDZV0mL74/VeWsFOe6TW6qltXRwht2bAreeGUtbupDtWzIdzfw1iD8pjRVIfietpPpz+eLjFGE9d33E0RZ90ExgPWOegqeMCzcE+jKc6kSlpHric6pU8HsilrDlxMRHDay7DNMsqNKquMjMiE6peceXpI17wOt855KkvT7/4JM2/bNHbh8p2V7XrVVgSL+vm5sTtR4TLbU/aV8+rmTx734vAND3Xpf/dtHbrk9aG21mqsf1X4GYBtRG0tVhqH1k9mdoQD9CIA3LHRsoPV6KQ4I4utcYt+tj/78VPzmlLwrJuMZWMXjuL9NAvvEksZkucZL6JE7jZ/3C1x1RPmYenRxQQnoyOMwyAqJ0XrMtNPZnPYCEBr+fRjPgHpAhmWYhlmQyW+ja0EIGcs6Uwf8AUDbg6UdxRhAe9iBKM505crAVQl8Jm1JPNDJcUCjU3CaAZBT/57ZbuXH73/ybe7Vb2+6ZENu3pUdhx456aZbbP7diovbd+Fc8duLRje+a7FU0a/0KtgzIAHVj84M1DZp2Nd+wrUo7SDM71vWV6wG7W/2E6cTjiCV8scZibeLUEa2VRXHIp26wg/NpGLD3BEAUwORusiPNhxCx0xFDq5AHmLc+ARZ1iiOpNACmc5B1V6nQXPwnAaPKVwtiViTCi+TY6pKuuULaE9mhm9b73U33d3pwkzX1+3cPljZzcO2RYK9q/p2K7PMLZqUxoyFQTnT15/ZN2Tu8S/rGC7tu8y6tbON0+herOWM3GVeHwOZiu1h0lWQNwiKY8TkKYAdjkZP2YH4fhm6Niw/e1Q0JixeRjXUV0w6lJwoyT6VZLyuF1KVuLPNKcFyhSTG/iI0XcZsKiZGIDU0ZQgGdw3wjoIBEskJQlApCykPt+DgtLUV2NtrV252Dx+cfUI85CtNUk39Z2T1pUzsdsXrhpV276reB96rGPmLc/MFSX+FRe2GcMkn/l5ykUEtdYq3lAz4ds0BrGZTRdukyUQiBu05LoBDndWf9hM2Z9trVhEzYR9M4XgpZrNMdbMqfmbDOTV2JrLCZLjpax4k6Ulm4aKTVRCEHZlbz7NisVN50ehH0tFUzGyZIkXOpwJIc1G3nlcrDr27kbxCtLg89J3eJx78V6Zy3ws1U7myJV5Dk1jXNAwUJmnzcADFagiZ+Fh6slVXTq+aqDDN5IQKFCGK4AuFygsLHmGQiQDEttSGwQaAIMKXiO8ymkgxlgSfCRZB+6MVMLbiV+j+Kp6l0qC1NQ9QCmSqpAFyFtUDkO2qIjDoKClQqWXLwTluaEg+R9CizS6r0lBkrw0+MWcO2ZO9n5vQ8Zh36FM/9/e2P9CbYcnuo6c5vShgXi7yES3ZIrhyifYeOkB98LZTy/dsOaTozV7soonTNq2YenT+/qfwCYJ1MZpglJ+d4mS82EIRvNBrgB0L1M4W7WNcZ0xH1JQdVqAMoqneuBTuCRIULZSSZZYqhM2wFJy5iRIRjSHRtA1xooEPIMgWTpSJsn76YuvqUgZDGaCR77wYh9KpIgfQjHEKT0kTikAv4feYCX8HlZSdZFeTMib9EarJ724RJ0xUwR5B0COHMmEujUAoPUyFEdfZ4n4ivAXqZBJY4c9LiqkOCR4HZLGynh9QA6Np2AxQt1YSoQlYdQ6ZHTaEOqANH/6SnxL/KznzGeLdrz2dSe02/b8tKXln/g+qUoqyQ8Nqrl35gOuPsLuo/uuiueAO/rlVUebdo8Yfez0dnFr1/T8Nt7txffe2WUE6oft2QzxDWEQ+LuYD8gJpydUWOFnEWw+z58iuZtjmWguPJMsrOsGOabNoFwDfgRueUqHPYG4RiDXnEH8jlyzByDLE/I3mUhWLh52Dimw8FZGLBp6HDFIJZqhYHtQOStDgtlE5WRt8yrjZyuC3qUpSUuy14xAN/2hdsOgie0n95x9oAda6BWnWg2o2isemLv4/scXRP70d3R+06iSjYhHnpJQPKdk57aNvfpten5152NdEH8NT2PmheYfhW3CIayJHqaQCeJTOtG8MBOMF1PDSkf1L55MPsbLs/N1yfgf+snmJp9s0i7Vzh/mP5L2Jciagw27iH4qMkM2dNwnre0BwvRp4SkWVrolpjM43YBb7C/Cpg7KzyY7WHkx1qN0H1YXm5uW1CdborzRCXaQDpj6SCIW4trROSpRLiggbqidVOba8nCleYHvdehqw4aRv7uvdmzpwB6dR7Wb6++TN2hi/RL2nmEvTnnw8UNb5y3Zfle7W0on3jIezgi8+YGj9xbUZ9+6uGpVqmVR0fKmu+b/ftrqBQe/Wla/ZNDjty4Nw54+vvk8twXbOBlMPuwAqRJnRdSSCjPT4tBTIPi4j6gF1p1ULZYdI22JBZDvGeYCJBU4MxD1mOBXHqQn5w0vIoCkcPrA89QBpo+d4pPayYYJ+KSFWKJeE1iKFih0oosaIOYiQloOCeQ+S5QzZFJ8sYr2IYtCS2GhGSBBYhB0QRokicoxvmv95g0L1kT29+7S/RbNKv2za5/+bTUqH1ldW1aCGjemFKJjz7/48sqd4pXR4pcT7rxrwsHdB3e/7kFZod/9ZtvNo0DHihhGO4twiFqxFVmCPBIqPmMAxAg4X0l8a1q8N2T6UhCWSiaVkauIfHJJMiqVT2FtE6cwL7UPdF5A1dUShg9sm4LZAO+8ZrCq42nUWihrST4pF/GbCIbnwfbfDqWJGIayiMmow9dMES5DgkF4+4eHSC4GgbI0Em5OFUouto0JFyehpDEYk1XJN0CFGNYDCiGFGivw4ocBEI/gPbBaCGeLD5bLNAliDIUoRAc+J3HEopa1WDLvEz6CIlTxMypPyXU9/Ufx2CXxeEHueq7Bx1p8YmXtlin3PzHsuXvnLtsxof3AsgkVg/Dx/+ramo8msKewPs/4ZleTf8sW1jv36MyN9TMPz3hi4cLBS25ZVLMUfI/saWG1cAA/q3KohADbNJKTh58NnebhLGKgkgkfIGapk2qik5JTptNP6VRpy+mncjOoZ7yAamoQGFiMVC6CZRenM9ncpCYk3Ro1W9JAeQvLLdaYL6+4jFS1AwjVbsZbUFhSWg7tbJbueqS3pOe2KS7zwwUTpeskVi22Xgskk17OCHK6JMM+zxLElp7FZwHqXc7nssyZPGKWv2Zs1UN3j5tcPKxvaYeKqql9l855AL3/4Y49763kNftmRTU8x9b763z+vJLRNw2/t2xqQZv8PL83ePtN42fo2JNNZ1lnkx+9MLfpS9YzTayGtWA6+6VA/bepzDyp4lafRE0/kCEXwDs9THBGg5cFPP4A2EJucnAViJCigga+Fzj8vYYg8msYIGg0w7FLAZimNrKJihU8ESmpWG6GJOKDJG4Xr8OHh4taj3s6m/7OKrTi4+27j6/iNXvn4EEKofr6pp3sEPx/yzHNEGvBtwI1x6QGGz1KzjCzmk/zG/l+2O7NYu5gYCGiewScylPpuwx/nJdUJVuxSVIDYJa4JYYogPx0G4DdABgeiYFgJrNCnywxhyuuFKvDayEl+CEXmQtsyGuBTVI7q/7KhvU/PXrt7fKtQ36za0i/safWP3NxYSNbHXix9ncPsNbnmea1T4pNL4lPV/Sd9EjRpgdXI+EH5KjoOQt8WQubz2pywWfEVbELINuAmfc2xICGcuamGP5+GP5+iXAUvucY8IPib2Y1xcwaZta38Pvx+PvF0u9/hN9zg76nv59Bfr8Af58jfV8v/d4Ev+eG/ARyHI1tjBH4rORm8phREh5EuqaRQI+TDE8+h+BB8IKSOZdmIHgQGgkPAhwHmjQouUoyuyjGBZ8DfC82wgcM+Fpmq4QCQdwGKhQIq8UsoUDg9yEQpwmNXn52/Yu3L5rbaVmPHs8P/OTcb8W/79175Mqa+YfyU+/uXvv4bWjBDtT+mVn73ipscyynUDwvfiP+KHY7c+yPp1HahV5D7wPfVfNRvPgXCXuxxidh/aAnBXCZawOyHwuoKGUOyoaayzMU61/XEOHT8crLNWA7k9cRyl5eq1MyvDTUbodaHgOx15HXps3zcvkVGm0ond2BtCuzrp1lBw1Mye2/TCi+cnLJcfbSi2MmrwCb7hPRR/AotUyFNDM1QH6BlDnGBaSwFMF/0pojPJYvZ2iUw1MWL55IXssn/Pwfm+4WfdrVP0/RvH25M9x7M753NeFNaivV+mi0xIuog/OdHJnQGenJXENO5hxgruLb6hGerECW6fBuZkc0xfmJ1/7Kpjad5OZc7S/u5KZx5iXvNlVcOw4xvlnsHD6DK07E64RG+F8dr8M3m8VtY+fEsaXBjG2+KLg1+/AhO5uJamk8g/5A7yeRsgijJbYY+SE4sH1oLGr/Cfop0rTtafFbtvHVppXCyssd2H8wcG5ZhhYLA3kXY8f3K2bqGOAUtQYjPoFM70x/uIhmogOSLfXpSKd6hxmOe2DLyN6afHwa38Vpk60eL9FcSPyMMQYhRXLPgL4qTrkWlZPEQBYSDotlry6O3f9g7PGXdy7cVd9xw9Clr2wdelOHkW1LR3XuXc3a7pjS67ZhvdqPYT94Yu+RhujKx/Yfrbtr1/J+dbfeNnjwHQO23HFz37pbsKysop3zE+7czkzUzoBlomkETSUg2S6wcUmmfCqp+JVyDZMtMUYwWmAvkixTG2xFxMJyOcguZCEDsPbv+lR059iuXW/uPWB3pLaf+GPGG4Jxz1vph7NGj7jyj31veWBNmIbm8sV8OX66flTLQLCPMQNaABapLhBz6PFRLmyXKHyTAgGwjPA50IM/pucGAjGvpxQ3yA5GCvCV1MIAgaUGwGmYaRdmHZwpHfHC2WUQQUnXXg5n4x1ae3nfN88ejEoAkWFdGcBD8hmXwzpzxJxxed+504e6EyuIN8cEXgdeY3gFnC2LHSgFbPBKkeiz8ccseMV/IFZUUog/FsNrFH+lQojKqoziy/CuqDKK70l5paP4RvDOUsnsEbQWW0ZWUXGi4sjMC1qd2WKzp2dkZRcWJc6erTJfUwiiS4TT00N+aQH+N68y4vGS8kpiAsNBi24p5MRQQFSKu8H1aRPW9LxneN+68mB9aOKa3rOrhg0qaV/fbuLq7lNGDK4uqZgfunN1r6m3VQ1rG3wAzd0/xZOX6e5e+dbUbG+erTeqeeue1AKfo0eH/dMyc7NdXcn5chazkc8QkhgbPjNAiDGFoCOEkwMQ6DcGI4KEWmz3A8YrndYhL56hLm3QgU+FDi9XEJqFutwpjkA/L9w64bx4cBLaKmoWbBmNdsZPx1DaTR/ETsfF831O0D0br8lZggbPYAPjkNZksgzgJSqJ/IEgXjdQBXLoESwf1+q4bU03sa/F4+zWuejMQXGb+Ie3pftk/Mv75FXo4VZwn1p2b1M/bls8/vPbqC2qPSi650J/FuL7TMS2psDoGQYvO3rk4/TsQnRoJDoodh35NXIhp3iW/Yz9W1Nmk5f9TCxFHyCaUwwv/GB+MMR08Grs5QdffRX+JzH9LNGuGaTJYioRz0RDeA6H2wTJNPYDozohBQuXBiOV+EpJIOqAFGSnD0+wID6MCPkBoEEi1f4WfzgrSHB50gIEohhqx0wC0GGicEd/pJN0olh9cRUth+EBcCTSznI5bMenhi7fu+iRIoA3NVeDEMkHl1ZOg0BnkB5PCh28htuZY452dvwmYI45Ay78Jt8c8+Xn0K+C8BXH7OL1dldOO3kamHhBp7c7nK4cX34g2O4XUwDPgKAUi+LAeWDzdWOVgzL4skLqT+BlURKhAXSTfPi8e2BRyamY46CjZNfWGaO79O/aZ6jTina7SqIvzxrdtX+XmwY7rV8WfPFZ8a6Vo9p3bv9Y4cdi/88Kd6+u6yQ22o9z4uSqEe+8jJeEmrE1ow9vo2+iV79oeNW1H76++sWbURe2LfHzEgyaLGx73Uz8L1UszROF66mq67fCdYaD69od8HyZLszNaDQT7Qh7Wpfgr3vWMaevU+dc169/3JH0HniRNZnjN/FMKliz/f3hjh9FumBrtos50slYHOmM33aFQtXe2E4Y8L/TCply2/D/RD0iXTrijTYrPS8X/C6du2J7scdNJIJJtSZigoqnrr0r/xP9AbwQdarBf6BPmknnG8+VD+zTvsetPYN9f712oQ/5IVd3CmN7V1e0v2lIOxKrI/qzj+oP6vNvas//YqXo2kJdEFGXSLf/rZZI3Gp8uKM53KkB3zLc+X+5ouyhKtOpc2Jz/bfU5r+xxOixsfmfqMVEVNUo7vl39EFjv3weW3fV4gLtAeEC3j/0JH/FxfiwLetngkyI6cQMYIYyI5jRzHhmOjOHmc8sYBYxS9AXkGUTK2s/ajZePsDBi8+2sZJ2d9yX6wrEeZ4xYRN3ZgB28oeCcbz3uPDn+gDUAQ2YgE//+eQHkaqJ2EYz5HuxjfZIMG6kzRYGwkP98Wp6cG7jj5qGPwqVnR56oWsgnkLbLQbU81jbDmPuhy5Qn0ysvHLsXNyFsM0ct9JezMNq97g/rP8I29ImK3RPQ8NtbJLZCR91eOcm3mlATIH8mlzqU8ilrppM2ross1BXHPHjc5DfH24bjJThd3gpzDRHOuNGVfQn1YFYcueQqTjcIRhpjxt0DISrzJHRWL/HBCKj8IVxgfAgmBK1wXg/8pN4D/rLUebIZGNxfAr9NMUcmYGKYw8+9Mij0MPZtAsPPPybx2Bss83xObTPc/zh+4ORpXgeFfqxMnrzPVAmHRk9CC9YffCCFRnVz2KNTph0L/Ei54O917kyPNQS7lcZrrbuyswtTO3dB37RBuKmPWpJQVS0y933EM9oyBK0YOsK21duFLRwFvjf6/A51OsYnJbBCWfDFpgFWzryv7i1GkPAVyAFMipkcD6lIfFU4XvD7WzBiqAFLlt8FYm/GbRUT5s2rUE8iV+nIX/DysX1Dz22uL5+cf1i/F8RMokXkWkuMovfIfNnO6bcW1bSqe2UkdX9y/Pq+vYsy23j7/QJsojfIsv6YnfN/LtGtrt4aIr4B9R2CvmvAH4/5+AUrpTcYQlKEb9Hi1HbaQea9qzatHH1yqefXnn48NtXd03RiNOmXZ5G/rl6ku3fa2h5bx2f3LvD4NsnFuf1H5uTnZNx9XX69YcTdTVolXjfqHFNWw6KJ/E18Q8HrmwjXV2c+DsMOUNWiwe02/E5i2MymTZ4PoYL/XGr5Okt9gPLBti7ek4+/WlNKAMFoQJYjsero9XV3HZux7VqceeQ5+q6dS3vV93pjyU97rz59Zdu3Tfqpr49b+7Xq18fdjK3/VrNtWHCpOigjv6KAe1739u/kz/Qo3zIQ7WLN3a4pu/W7+au3W/uR/NCIUDXjZzlh0jYWSSGTR1a5GRLz/Nq3DwT7BlcQ0SPF3FdAxNjOYqMh5R3EtycrxuyFYS8KYhzacvTdn2xMYPtlLb7q80ZizrzwU6LF3e6erzzIpqbTPoBudXcfCmHWk9ymeF6RHV9dvN7yvUnE9dRdfM45fpDUMMltZ/cfKdy/c+QKy21H978iHL9AcA8lK7XNP9Gub4Janek68OaB9PrYinIS7lex2xR9b9KuV7LzJPaTxK6C7vNcn9K2eMkt6wHtuu7CM3mAnxdJL8Y3/Rt87rEvSDvDH4jfV7dYkwPKn38l+0YhKr4U/xyTQGTgv8qPuJLIbuoJpk4gwByg5XR0OM8DSnwZvADyZyuET1PcUPblqN2kNKbCKOgKt1xfsfkafZTBV8ei7wuXEjPqFh0+5idzy0l+oWu8Me50Vj/dUwGyTvmeFjuSMYwhSOXUphRBb6jw4S06MqgytPex9rzx9NWPGPv81oFPQctFTuh75oX4vvkMZAzwibuw34EmNsk85jk6WiJT1i6nW/psLZ/yXi4x2Kx5umV9h6v9sZ9+pI/xVVpvPReuE984l4MYXwl99Ip6XiooivCd9No0ZdZ9d2XjCnkTzm6Rnp7dt1Pc6KO82O5GuEIY2ZSmd40fy1u4pkkLGM7fi8n1tGtKaphsNgZjVEPwmf1xRSUzg4xLY6xSLQ4eVoI8mWydCEWiHA02uMoT9/zptT01FB5RU/kvK3bZzNX8B/s6zjIVpKVYrW6XXn+TkHPM2tSn1tzIz1q/bkP1BtIOjuGt0o6O7eFjo/jIPmLvXaUP8Xs1tQzSfg07JVznc08pI5DtgsTMQORDGdIJoOAEE/Q6dL68gs02jz58eKb/LHjpdLpwv3DBy+Yjs7c1eukb2Mv/pT70IA5G1zdxk3sfMg+dYy1oL6YyPZaFn+qeQr+m3q8dnZgICfQQvKryd90yRk24GYj9DZaCU+fNeAtE2mS7cS/hnemTORy+MqQTd2pa1l7Ld2cUwMTV6n7pJliLZ2fZy+bL65KdEoZ/whNIx5/JsQCXOoIgFmKAGQBuk84OaCKF3mwDWGjwQuny2KNa82a1AzwoXkobW2qCwIDDq6SZDaFba1lhyoUfrcQjYq1EuLP3j633rEhZbyhb7ebStWiRC+MN/TsNtvnn4yN01J5DM2ntGZsC+bicwFgKZiCcSdZEGJeZ7pOTl8Kuyk8j/sjiCuSwIuMQAUzohtSdZAQ+GWyZFHA6lrGgt8d/6XuyzpdynlYuP/22oemDHTPuq2gf58emXl++4zK7UX9+3TLLCpJwb3tVF81Yoer0x13dEIDZ85Iz0kvaXvG400vL4L+Nulwf1drDuD+Opl2DFCJ0nSbqEByQQXIBUUBograjyAgCl3VaXFXrTba1VAQfFzSchWS9bBJx843DLtlc5eFvr0rF6//bmTVwazfdhe+s97Se+XyjWvuddTOseQ8XvCLPrT5lX34xV+2UXmVoVZ/eQ4bzugvjGw/SfnbqIetZq4jcH/ib2uhuiAbW+pRN6wtNF/uRv2A0KVF0kavP5zxkRJEN0e0NNcM+keeJ2QbZFnC9spf9FbSOU1C6Vr1+2xu5wHD+vc1jdB17dKzONH5YF1S11DHISlFE/W5Pio/Ho/hA6xzdiaHuYUJZ5NMSOi3mzCOuTOAcSwQtvoh7xJGZgjEtCzQk0qxNiZAkgMdH+F38sSyB0DE7VsrHj6AUZcmHUcTH3g1t6pfT09+iX1Gx5fzBvTtkd4vc8Z8YVjNsPHpC3P2LH/iKU35aax1ZWWfebI9Nb16dO7WddGKJ8E2GiuWkgyZFMDHJPGEZL+SGmoG6GrZxQ97pEEgFB547ZHwRbWWCGOQHQuQZhmU3PubS4JtO9Stm/Gbmf0rxJPm9u1HzJmx4K7ZDvibL4i9UZw5jZ/37aBpcEiPsuTxsho9NchMEEAlCMEpCnzAXmqXaYBOApCAsVkWESCkRF6pq5g1Wmh8TKsGwigY2S4Q7G3te3qgd92C2wNfOjoPRv3FZZuWEqxb0p+dzNF/rz8bLu74T/vT85N+if60F58n/cF204N4z+qK7SkNY39cwoHki/l5JKe9JxM1EkRDTSOUq/AaOaddQp4jkIVayhJBNtwIb4TNwgnYg1qmUsGMUeeztycJ7ezI1Yh54eBHy5teevtPF/bXPD5076MxtOV/0OBo47H/EV+Jnjv83W+Q8HSj+C61V0K4c2f4iYyBqWeiPCKRQJmPFBzIEF8BqyWpJWWViRLtCpRnZV/Xhy92SsQiNMB7y2vUeX+CBssU8JHkTAyOpxZQBMEbEqIBNo40FMJTOYQuHPzm/OCanJJhUa4Adbu6EU1Di+8p6TiHPOvPsGyPYFm6AUuekVhAAcQ5RatgtVslrHYroBCmugl3pxSn1FnwQmSVsOSTaMRSPsRoC+QsJa0ALn0fWvbug3363bpx2L2PfTDrt7tX7xG/YcuKtyH3k8sHV1bd2nvT1MEvrHzw/VlxzQliqzwlPsvt4h/CVq2zebYYI/6tI+I2niEytjG/pUh7EPHTGoLBiFFDg0ZRhigrI9cM2MFbQGw8h4LJ/AKVvB4AtaBYIMw3xLQ6/jqVAhQv6p9VCuzitQY1zQ+UCCTiuIBhX0A4MLRAkJLnhRRMvBtV5nFWxB56q+iNgV8NFLeihQXl/XXO2kxPlNtwbdo+cRmasW/3lz/nzvWCLP4qPstz/F1YFqnNr4As8LyYCDXvwjE8L9z/IDUiYozPJG3Smh+R2nTDbQYLx3Ebzw/wOV98nkf8w7hNevO74i5iyxaIdsCuYLKYUmYoQ7hWIj485zMgRMjhN6kAyGUDD2EbmF9lBLA4m+KAMhEOmBmyCAwhUxlp4wOKoxRdJUV+AzAeGnDqxvqkrGwJFTUkTX5EDrsyBmrBTbuqZ21ym8p11c/VPfHskm9WjX6yXNc9esl/9aM/PY7yqquGPjOqtrpmze0fFLadfl/3fffUnYgfR+PfqRmx+Wr9Xz7rzWVMnPACMiweM2mdeInIgIwPanW5HbQ23M2oruuU68N0qutQq0+u43Md8l3vPtyKebj9/wG52QrheNpjYGRgYGCUnPW4tG9KPL/NVwZ5DgYQOM22/BmM/iP/9yCXJEcSAzMDBwMTSBQAf0ENJXjaY2BkYODo/buCgYFz0x/5fyxckgwpDKIMSIB5LQCRGgZgAHjarVdxSFxHGv+9eTPzrJRQgpArRaQUTyRnl9xW5K4EqSxLKLmQk2APEZFFioQTCUEk3BUpcuyJiPSkIl6QICKy5IJICGEJghxBgicSggQJkpMgQS6UIKWUYp37fbP7NntLJPnjlB+/92Zn3sx83+/7vhm9gVXwT9cAStCED8NObJnTSOo+nLXTGDcjaAueYUsN44Iadl/qDFb526A66WbUKBKqgWNq3DzbuogD3ee+I9eRD8nNxADxFXFe+kh/1eCu8/mqfEc4HMOc3USvzrusfoq0foCs6SY3EwppM8T3EaRVD9F7tKJvIR3+iLTdQco8IjaQ1VPsJ3yHYz5Eg67FEsdN63Hk7SHW9bD7RqeQ1ym3rYbcXliDHfIV3YT6sMml9ICq1XPo1ktIhHnyLSKJbrXi6vRprusu95oUHP2kf1N4jj5AQto5N8e5BzImTHH8DE6ol7THXQyEe+i1Gtd0lcuFL1xHOM35H6JK9wUH6qFbFPsUbO8e8fmfRfuNE5elT/iMexkIcnYRI2obN3QdLnr70/bSFmY5Rz/u+bZ9+mgffex/qO+7B+YsbtLeU8G8S7F9lfPOc3y1/QrfEtfsJP4Yjrkdb/fXwG6T6QvvhzJ4P5SBvmqO/VAJrmuS3C++KIf3BX2mD46OvN1fA7tCe+YLfihHwQ+vwO9cLPmhEqKxKeqZviiH+EJ85ln2K3NWMvfu5z+GvUZveW72ehH7JN/MomfR1LFMrct+YvZ2Tr6O3W2VdAvxu77P/n1sZ4xQp4cSJ6JVgcSL9Cmwm/2f9x3P1eoClPjRz13JF/Bx6bkQb92VHFlkGWvdEoMSBwVmrMfvjEuJjWO5Fn/zccPYLfIiud7rhT57W5Z49zFHjXn/FuNeYq+SVdYpxtyBOeAeHnIvh9TnRfR7++XdqJ6lDhkHokXRsdfSq/X+lev7rfQNRpnPBoIMsaDPBWPk+6oxaNOzqjYYdz18TxPtKudywM8niH8Bh38nL5GTRFYPqXY9xLHUn8StXscn9gN8Elp8ZpvwO9PP93Z8oZZe5cpwnz5eYO4RbXFPohmzjaxowvt/jmsv5knd4HZ8XA6zXWKvzT0RW4t97FnunznSJnHPPKJdZLzYbZkxuOXjJ+Hnvc9cviwxwNjZxTk9gVb5PcyxTWJwBBnfT3TX4qYlD+kG9IZz6PBaacMlneNY6b/Ob+f4zm+ae3xvcdX2FEasxHg8l8QwWdrMu2jXHVzrC/5WzEVmDkveBpKn6JdSXmIMRBm3GnUV+tCPabPpbfKu37/Y7wbXX7Sh6XKfy/fsN26Ce3hP+vr+Mq7TrXobjhRqTMl+MqfYj9+M7Wem2a8V29EWUtERn89hyU6U+p+KXvq5r/v88jVz9RXaYAX1erGQ26Im9yx8jOpSrmqhHa+7ZfMCjfpJMceJnSV3MQdJDRKNm9tsZ41hn349gxts74/OMu++hz/Y95kDL2EwXMX7dohjB9zTUj7lt2R++ZavW8lXdc4Ou2W7zNwm87X4WlfIm3f57ecYs2fwpT7kvmdx3h7RNivMDTW064CbjE7QltSAmXA3ud+paIbvI6IPdzvcdXOiM/F1nDv0FmP1AJmY31lGtqrNx2NWP+Y+Zb6eIsu8cS5+Shv1BK16NOjUo+oy0RftozFaQCP3neb3+vUkuYP5QHwgdqO/wwz3vYdmMsxJiQXW0x/cRHTGPRP/iw9MPWMmyzXPklupFYmnBPeUos+3cN4w35oqjuM89HuiqpZ7zBfz43ZZvaBG6IuEz0c8D5C7wj33yFTzTDLg1uwgzyqd6DSjeKzzuEH9PKY+hH2+Zex3G40zMYu+RaeiFeorLWs0825Vr1EnUjOe+DX4tflvLeFO1IAUc0mjj+uKOhfnt1J9OsezWhItMcdzxXbR7bBauXEfH5J3Yz6mLojuRXsSJ14/FSzxIpqN/SLxIpqlrRrFP3qDdkrzrCRnONH4FC5IvbVraLd75HXs2E8xoZ/zHPQ55qNhxuumW45WkKYOEybPdez6urtkqtHJffic5m2265ZLdmCMSzzF9aOSjz0n/L/4Lc8Px3HZ+UCxxv/nOH+8keNa+CaurL/F2vkmLq/Lr2P7qfu15r2kSu4mRVasmoocdLDtGp9ZMYMZNmzA//m7SBHUaCK6VQDP9r9ibR6S+ix3FvJu+BGGiKthzs3wfL3Os09KfY9pmwnqg38A73RgXO48chdS/bhIVOtG5wJ7pNQvONc+/kSkiavEMDFJXJb3ULNu9+EUzxQvWatbqNNaviftacxxL73RHTTSDkPmCFekzurvMWhHWfPW8IXd4F3hL/haL6BHarr5Dk9Y82b9GbYXGbOI8TCBk8U71WAJOYzo3zOP9fCusl9ANFYACva7JPB22nCbbwNzxm2G6/issp3nk/Ph8+CnkHmYvKduYqOyD88yD4i6IhM/V5VB8z6SCQ7cnIB3lz/rUcZjC21Vx7r0kftWd7k1noP/rS8zz9c4p3vQyn3+krZsiP//C19ATqQAeNp1wn9QUgkCAGCuyNAlj4hYMpdYlzVDVIQnIr3ekhjgj8hcIs6IXDMjlzVk3Y7zjDyPutZljXNbjyPX81zWZRHMdjnXeI8HKdtyHrHW6pOMGqZhGqdxGqZxHKdxnOuP+/fm+3A4HPd/dDj7b4ybOjYXbvZtXsSn4bl4Jd6GR/CLWwhbqFu0W9xbNtJa02JbJVt9W58QGglz6Yx0VbouvTd9OIOa8eSNmjeiRBpRTwxuI2zr3LaUSc3UZE5lrv62g0QgaUjo9pztfdvXyXyynZzYodxh2RGjECgVlHaKl4JRXu6k7jTtfEZlUwfeJLxpobXsIu1S7wplCbJ0uwm7u3bPZouyndnP36p5y0eX0DvoiT3kPeo9FgbEqGdsvG1+zZejzom/o3wnwUxjOpjP3r3y7vNcYi4/V7GXsDdnr35vMI+cZ84b2yfaZ97Xuy/KorGaWT0sO8vF8uWz8wX5Ffm1+ep8bX57/rP8l/kb7Aw2lZ3DLmQL2RJ2HRtjP2W/YL8qSCsgF9ALRAVIQbhgriBRsFywVthURCliFLGLBEUVRbVFag6Vk8Mp5Ag5Ek4dR8Np4VzgdHNWinHFxGJaMbOYUwwWm4s3uBlcKjeHW8gVcp9wn3NXeZt4mbwsXi6Py4N4VTwlr5HXyuvgXeH18QZ5Lt73gAxQAA2ADjACZsAKDABOwAsEgQgQA5JAClgvIZRQShgl7BJByUu+k+/lB/kRfoyf5Kf466WEUkppeam8tL60udRQairtKV0VbBJkCrIEuQKuABJUCZSCcBlYJitTlDWU6cqMZeYyq5AoNAl7hP3CYeGY0Ce8u1++f2n/CogDiSANZIIcEARloAJsAHWgETSDVnAAdIJeMHgg98DsgfiBpQMrEA4iQjSICXEgEJJBCqgB0kFGyAxZoQHICXmhIBSBYlDyPdF7D0RC0eDBrIMTB6fKO8XlYrm4XtwsNohN4h5xv3hYvCxeqWBU1FToKlwV2KGcQ+pDjkMxCVNSKBFIyiXdknHJomRDWi9tluqlJqlFapeOSL3SoDQinZPGZSQZTcaQ5ck4MptsSOaUvZCtyjYqOZWCSmulrTJaiVU+qeqp6qsGq53V3upgdaQ6Vp2sTlWv12gP4w9LDvvkTLlZnjwiOTJwxFHLrgVqzUfTjmYe7a2j1unrQu8z3+9WMBQTx+qOpY6tKwlKipKhZCvjx6uOo8dnjmMqlapJhahCqogqpkr8zl7Pr0frZ+qx+qcnak+oTvhOTJ2YUSvVGnXspOxk+OSchq1xa7waRBPSRDRzmrgmeUp0Snaq9tRUg6TB+0H5B67G3EZzY/y0/vTS6VST5UzaGf2Z+Jlks+ss5Wz22byzXWeXtC3aOW1cm9Qua1e06+fw58bOTbQ0f5jx4YjO8lHmR75Weevw+cLzwfOR8zH9mN7XltlGbaO3sdq4bUnDkMFp8BqChsjH2o9T7YOfcD5JXDBc2Ph9vzHLmPxDR0dGh+2PdZ3UzuhF08UrF3svrpgUpjHT6qVNlzIvZV3KveToov9J3t3+Z6YZZ240h8ypy7mXBy4/uEL4i/4q7Sr2aV9Pds/sZ1WfRS05lguWxc+Fn0d6Nb0b15LXUtfWrZ3WV38d6qvpi32h++LBdf718JfqL6P9ov7lv/XbBLaEbdm29ne5vdxeZe+3P7vBvWG58WxA+xX9q5lBwz/kQ/Kh+D87h8nDI1/Xfb3hSHOQHXTH+DfQN6ERYOTut8pv407Nd4Tvwi6tK+ZKuJZda6P4UdIobZQxyh4VjI64yW66m+Xmu8vdcne92+Ve8+A9JE+2J88DeEQemafWo/ZoPe2eLo/FY/M4POMexBP2zHkSY5yx7rHeMftNys3em/Fx1rhxHLnFuJV3C/ve8APxh0Ev0+v4l2YCN+H9selHdJI82XebfNt0+4qP4RvyuX2TvpBv1hf3LflWYBxMhGkwE+bAICyDFXADrIONsBm2wgOwE56Ew/AcnICX4TUEj5CQbCQPESAyRIE0IDrEiJgRKzKAOBEvEkQiSAxJIik/zk/yZ/vz/IBf5K/xq/xNfr2/03/Vf90/5Hf7J/0h/6w/4U/511ECSkEZKBsVoBVoLapGtWg72oVaUBvqQMdRBA2jc2gCXUbXAvgAKZAdyAsAAVGgJqAKNAX0gc7/yx6YDGCBVDAjSA4ygpJga9AanAwu3cm6I7ljvBO582qKOEWcxk0TpknTnGnFdMO0/jUkJAz1hdZ/YvzkvEu72/dz2s/usD7cGV7+d98MfWb1P7bIpkhGpDViivRGBiNj97LuNd+7fi98LxElRC9EJ39x/5KcJcyyZ6tmVfc598H7sgfaX1t+bZlnzXe8hs7PzGPzT+dfzL/C0jAyRsdYGB+rwGowFdaA6TAXFsVWFrIXtAv6BeOCecG6MBMjxQyxmYfEh1UP3YuExfLFnsUHi4uPch91PYo+isUVcU28Oa6PG+Pd8ZfxjccZj6mPc/4L8Opk6wAAAAABAAADsQCKABYAVAAFAAIAAQACABYAAAEAAeMAAwABeNqFkLFOAkEURc8CEmwoqKzMlBayEX4Bo7GygNjvwggk6y6sEKO1X2Jn52f4HX4GlXdmZw2JJGTzdu689+59by7Q4ZEmUesUKBUVjujpVuEG57wH3KTLR8AthnwFfMIZPwG3idkF/E0eXXDNkrlio3jDMsMoEt0ToSkFK141z3UtlDV8KoZcMVD0Axpwqeytugv1ZdIxjIRLsd0/8foFuebfK2eFDGPlc551Wp5UT9WR+Q3u/PxMuSkvqqZywrE3B9jmCP9B1VJ91XyjXWO/e61U6/T/6eyrTPT6pZ9Wb2K0WeIzc69jwzsrD1O5ZnRbeC9u/jhj1mylVOqz0nau7bOdW/EvtA1Q3wAAAHjabZgFeBtHFscfWFJMgTZlZk4tsKCsBSUOOU3ipklxba/lTWTJFYTKzMzMjClz78oMV2ZmvLsy3sLTWOl3yWf93+zuvN//zc7utzNAAH997/4NwAD8n3+8zP1BIGBoghCEIQKjoBlaoBXaoB1GwxgYC+NgBVgRxsNKsDKsAqvCarA6rAFrwlqwNqwD68J6sD5sABvCRrAxbAKbwmawOWwBW8JWMAG2hg6IQgzikIBOSEIK0pCBbWBb2A62hx1gR9gJsqCBDgaYkIOJMAm6YDJMgakwDaZDN8yAnWEmzILZ0AO7wBzYFebCPNgNdoc9YE/YC/YGCwkuhcPgcLgPzoDP4Ag4AY6F8+FquAwZjoE34FA4FZswBMdjGI6Ch+AdjMAFcA38AN/Dj3AJXA9PwGNwA/RCH5wE/fAU2PA4PAnPwdPwDDwLn7uj9yI8Dy/AjZCH7+BkeAVegpdhEL6Er+FomA8OLIAhKEARLoIS7APDUIYK1KAKC2ERfAGLYSksgX1hf9gP7oSL4UA4AA6Cg+Er+AbuxlHYjC3Yim3YDn/Anzgax+BYHAd/IeAKuCKOR8SVcGVcBVfF1XB1XAPXxLVwbVwH14Wf4RdcD9fHDXBD3Ag3xk1wU9wMN8ctcEvcCifg1tgBv8KrGMUYxjGBnZjEFKYxg9vgtrgdbo874I7wAXyIO2EWNdTRQBNzOBEnYRdOxik4FafhdLgJlmE3zsCdcSbOwtnYg7vgHNwVfoPf4SP4GOfiPNwNd8c9cE/cC/dGC3uxD/vRxgHM4yA6OB8XYAGHsAj3YAmHcR8swyfwKVbgCqxiDRfiIlyMS3Ap7ov74f54AB6IB+HBeAgeiofBa/A+Hg5vwlvwNrwHr8O7eAQeiUfh0XgMHovH4fF4Ap6IJ+HJeAqeiqfh6XgGnoln4dl4DlyF5+J5eD5egBfiRXgxXoKX4mV4OV6BV+JVeDVeg9fidXg9XIg34I14Ey7Dm/EWvBVvw9vxDrwT78K78R68F+/D+/EBOBP/gf/EB+FcfAgfxkfwUXwMH8cn8El8Cp/GZ/BZfA6fxxfwX/givoQv4yv4Kr6Gr+Mb+Ca+hW/jO/guvofv4wf4IX6EH+Mn+Cl+hp/jF/glfoVf4zf4LX6H/8b/4H/xe/wBf8Sf8Gf8BX/F3/B3/AP/xL8ICImIqYlCFKYIjaJmaqFWaqN2Gk1jaCyNoxVoRRpPK9HKtAqtSqvR6rQGrUlr0dq0Dq1L69H6tAFtSBvRxrQJbUqb0ea0BW1JW9EE2po6KEoxilOCOilJKUpThrahbWk72p52oB1pJ8qSRjoZZFKOJtIk6qLJNIWm0jSaTt00g3ammTSLZlMP7UJzaFeaS/NoN9qd9qA9aS/amyzqpT7qJ5sGKE+D5NB8WkAFGqIilWiY9qEyVahKNVpIi2gxLaGltC/tR/vTAXQgHUQH0yF0KB1Gh9MRdCQdRUfTMXQsHUfH0wl0Ip1EJ9MpdCqdRqfTGXQmnUVn0zl0Lp1H59MFdCFdRBfTJXQpXUaX0xV0JV1FV9M1dC1dR9fTDXQj3UTL6Ga6hW6l2+h2uoPupLvobrqH7qX76H56gP5B/6QH6SF6mB6hR+kxepyeoCfpKXqanqFn6Tl6nl6gf9GL9BK9TK/Qq/QavU5v0Jv0Fr1N79C79B69Tx/Qh/QRfUyf0Kf0GX1OX9CX9BV9Td/Qt/Qd/Zv+Q/+l7+kH+pF+op/pF/qVfqPf6Q/6k/5iYGRi5iYOcZgjPIqbuYVbuY3beTSP4bE8jlfgFXk8r8Qr8yq8Kq/Gq/MavCavxWvzOrwur8fr8wa8IW/EG/MmvClvxpvzFrwlb8UTeGvu4CjHOM4J7uQkpzjNGd6Gt+XteHvegXfknTjLGutssMk5nsiTuIsn8xSeytN4OnfzDN6ZZ/Isns09vAvP4V15Ls+Dm+EW3o13h9vhDniY94Bb4TZ4BA6BB+FIuJb3hEd5L94b7ocH2IJ7uZf7uJ9tHuA8D7LD8+EnXsAFHuIil3iY9+EyHMcVrnKNF/IiXgxn8RI4B86Gb+FyOAXOgyvhRDgNToe7eCnvy/vx/nwAH8gH8cF8CB/Kh/HhfAQfyUfx0XwMH8vH8fF8Ap/IJ/HJfAqfyqfx6XwGn8ln8dl8Dp/L5/H5fAFfyBfxxXwJX8qX8eV8BV/JV/HVfA1fy9fx9XwD38g38TK+mW/hW/k2vp3viNSKTkdHtkPUCFSLicZFO0UzkeyQ1VcuFSNWoOFsb9leaIctXyLZUr5UtBdErEBb9T6n3FcbGijYi1v7RuIWvb9Utfr67GK1pU+FYaPP8lL2B2K4+a1qxBSgLUAzANq+tJgjiWwVRkyxYQcaNoOMti+tExtM5RtMTRzJlVdh28S+0tCQJY18Q6N1UkOewZG4aVKvVW4adH/CXVWn0G+HHV8iXVKJI5V0BZU4wdB1iWcnUOqaTM781skNjPkjcduURlcLlmvky7ZdLFjFfqcvPNXqq1XtcMGXtqmN1xUaGuGpwQAVfGma6lbfVHB/wtOD/sWg//TG/sXG/tOD/sVggIvWcKlSLZeGB202i3m2i/lItxRfkuK7g+JLvrR3D9aKeatcGypYtWp7qbEVnhl4KAceZjZ6KDd6mBl4KAcyK+hV8aV1VsMwVhqGcXZjtmpjttlBmmowIrO9W1r1bmlPcEtrwS3tkapqUlVPUFXNl1BP2SnmQzXvt71nuQprja1Ij9z6mjw1cxrcLmqI5zbES0bi8Lyg1qW+tMwbmcZLVRgqlIr5Sqh7sFQuhkr+b4//W/N+/ac7mutoyXpegzSWCiNZM1DLDkazu1KwKoNBXBqJ22Y1jmaloeHnj0Wzolqg8VSzNeA4nalMLBMc0UVz8eZ82Vpouyl6m/3cfuSPuRe1D5ZKC6zeUnCF3yfekWtzq+21C6VF3sFQtVQsVdr7HbtsV5yK32rJFoYHLT9stoqlql2wHavNHK447uj4h0eZVTnfVZKorXvI8e5t0OhpuLile8jOBxeNc9zLl2OFfFaTZlet0ETLHYmIcJrmuYfY5YRmD7pRkwcKTbGGhy33aR3q7bdoWo2m12hXJyJkmuHwzMFSaJaTH7J4tlWLiAueMeiw7v7NqDhtXQ0OxsgF9XaLpQpvsxvLtevlOvVyx9eW7xoU4/dv6vWKyXvFhPrtQtWKSK6mpV5J3smqX5KXLLTAL6kQlFSs0WLHffb9erg8WApXvGKiIV+46tYkXB526+lz/9xmqOQNcFvj2I75m722UuPdqTXenZK6O2HfVnSUjEo07J+K+vMm0dHhz8Johzsh61FnVEUxFY2cTaioU0VJFaVUlFZRph4lFS1Z5xvqSJ0VTai8UZUtqrJFVbbYiHflOKYcx5TPmMoXUz5jKnNMZY6pzHGVOa4yx1XmuBqLuGLEFSOuGHHFiCtGXDESipFQjIRiJBQjoRgj45JQjIRiJBQjMTLeqkdS9UiqHknVI6l6pJSrlPKSUl5SyktKZU6pzCmVOaUyp1TmtMqcVvWmFSOtGGnFSCtGWjHSipFWjLRiZBQjoxgZxcgoRkYxMoqRUYxMKpibnSNjMZKtzoqqJ8f9ryI1hzviKkqoqFNFSRWlVJRWUUb49WcjGlWsTPBNmkh2iCq2mhPRTELO1bVTNCkq9SXTosJLZkU1UV3UEDVFc4GmxENqxIOqRo1rVM3LaEb4qbqKj5T4SImPlPhIiY+U+EiJj5T4SImPtPhIyzslHROVsUrLOKRlHNLCTws3Ldy0cNPCTQs3Ldy0cNM59WYbmW+SKyPs+n2q34uMsOtjUJ9jqp94yIiHjHjIiIeMeMiIh4zULmuXRFZqzwo/K/ys8LPCzwo/K/ys8LPCzwo/K/ys8GVtlMgKPyt8Tfia8GXtlJC1U0ITvqyhEprwNeFrwteErwlfE74mfE34mvA14evC14WvC18Xvi58Xfi68HXh68KXb6+ELnxd+LrwdeHrwteFbwjfEL4hfEP4hvAN4RvCN4Rv1J+OdKJ+RhwY4sAQB4Y4MMSBIQ5McWCKA1McmOLAFAemODCFY4oDU0bAlBEwhW8K3xS+KXxT+Kbwc8LPCT8n/Jzwc8LPCT8n/Jzwc8LPCT8n/Jzwc8LPCT8n/FzA7+zoEI2KxkTjognRTtGkaEo0LZoRzYpqorqoIWqKCj8q/Kjwo8KP+vyoGfhzNRpo3BTNhef4n/nhRYHMCdYxi3xpnlP/xmteVI+CflnJl5V8wRPvqvCCJ97VTtGkaEo0LZoRzYpqorqoISp+gyc+amrC14SvCV8TviZ8Tfia8DXha8LXhK8JXxO+JnxN+JrwNeHrwteFrwtfF74ufF34uvB14evC14WvC18Xvi58Xfi68HXhG8I3hG8I3xC+IXxD+IbwDeEbwjeEbwjfEL4hfEP4hvAN4ZvCN4VvCt8Uvil8U/im8E3hm8I3hW8K3xS+KXxT+KbwTeHnhJ+LhucGE3eJL3JU6Dmh54SeE3pO6MHTHs0lfEqsI3hKXI2KxkTjognRTtGkaEo0LZoRzYpqgUYlfzTaMuDka2W73123+69ebx2Rbq8V++2yu2h3T/QW2vepuctjbxOjXLH7g46xXHjIKfqbKu6yu9jfbC/uc5d37tXB+c5coCkBpcRwSgynxHBKDKfEcEoMp3JNBadshYftireI7C8V801mrVzyPSajMfmMciP53E1G453BIEVjHaLJZrtSdYasqt3fXCratpMfrA62VQfLtsSV1gFnYT1uq7gVFqXhZ4gFw2rK7chpSqOiMdG4qF9lzgxexrlc8LJ21Wgq1gqFUNcEq1Bt6fInSBD6bzcvHNM1sofjtdu76u+54EJ/u8MLW2XnMDjs7y0Fh4P9Ii8e3aW2erxmuGtykLG+rPdao7yWF4xt3Cvwr1Pr2eVaSb/Vt6TsFApOn88d6++HNe6CNsTjGuKyR7ab3UnmWKXFjtUqHyu+cfmAqMfeK6khznrxiiNjozaAGo6p7aEVRo55m0J/u0ztGI323atMQVMlafeb9f7BSdV1bH0AvPMFe8Atsz4i7sRxj/Xofz8yVR/l3pgJw8XaUGSpXS5NKFXC3gFvK2KR1xrlz0g3iAyUamVf3Vnpna84i73z/sT0An9yehcUHT9BKO9PnfzyU6clr2bFKG/v2r/LjZvV3oH/AVWMMRsAAAB42tvB+L91A2Mvg/cGjoCIjYyMfZEb3di0IxQ3CER6bxAJAjIaImU3sGnHRDBsYFFw3cCs7bKBXcF1FwMLozADkzaYz6bguok9FMphBXLYdCEcxg0cUC2cIC0c9f+BWjYyu5UBRbiA6jhLYNzIDSLaAHQcKBoAAAA="

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24aab533f87e7b434be5fa5b1684975c.svg";

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05IDEzLjQ4MjNDOS4yMjU2NiAxMy40ODIzIDkuNDE0ODIgMTMuNDA2IDkuNTY3NDggMTMuMjUzM0M5LjcyMDEzIDEzLjEwMDcgOS43OTY0NiAxMi45MTE1IDkuNzk2NDYgMTIuNjg1OEM5Ljc5NjQ2IDEyLjQ2MDIgOS43MjAxMyAxMi4yNzEgOS41Njc0OCAxMi4xMTg0QzkuNDE0ODIgMTEuOTY1NyA5LjIyNTY2IDExLjg4OTQgOSAxMS44ODk0QzguNzc0MzQgMTEuODg5NCA4LjU4NTE4IDExLjk2NTcgOC40MzI1MiAxMi4xMTg0QzguMjc5ODcgMTIuMjcxIDguMjAzNTQgMTIuNDYwMiA4LjIwMzU0IDEyLjY4NThDOC4yMDM1NCAxMi45MTE1IDguMjc5ODcgMTMuMTAwNyA4LjQzMjUyIDEzLjI1MzNDOC41ODUxOCAxMy40MDYgOC43NzQzNCAxMy40ODIzIDkgMTMuNDgyM1pNOC4yMDM1NCAxMC4yOTY1SDkuNzk2NDZWNS41MTc3SDguMjAzNTRWMTAuMjk2NVpNOSAxOC41TDYuMzMxODYgMTUuODcxN0gyLjYyODMyVjEyLjE2ODFMMCA5LjVMMi42MjgzMiA2LjgzMTg2VjMuMTI4MzJINi4zMzE4Nkw5IDAuNUwxMS42NjgxIDMuMTI4MzJIMTUuMzcxN1Y2LjgzMTg2TDE4IDkuNUwxNS4zNzE3IDEyLjE2ODFWMTUuODcxN0gxMS42NjgxTDkgMTguNVpNOSAxNi4yNjk5TDEwLjk5MTEgMTQuMjc4OEgxMy43Nzg4VjExLjQ5MTFMMTUuNzY5OSA5LjVMMTMuNzc4OCA3LjUwODg1VjQuNzIxMjRIMTAuOTkxMUw5IDIuNzMwMDlMNy4wMDg4NSA0LjcyMTI0SDQuMjIxMjRWNy41MDg4NUwyLjIzMDA5IDkuNUw0LjIyMTI0IDExLjQ5MTFWMTQuMjc4OEg3LjAwODg1TDkgMTYuMjY5OVoiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOdSURBVEiJrZVNTFxlFIaf8917Z5wZ5hdaoMU2pGKpaQyaNkbTmAaNhqYq8afGumnQLlioiTFWdy40qa5duHDhwrho1cQEtRVTGgk7iTbRhVIoBmlJyszAzJRh5v4cFzADWEBLeHdfvnPf97zfOece2GYM/zlxfviPicLYjewJALOd5H2fT/aMTvnPNCcTccuYVwFku8hf+mL8SPXm/E+J3c2yuzX5d3dmJleqVE7aAPmRY12BzzvGJixxL2dZElE0LhausdULfCyxaAAxACrcEoJFhXlRKecXM7w9XOx3wmGJZtLkK7ROlOhpdjhj50aeOOjlzSg2JryvCkYBrVtTQCxWnUB0yXwt5uPfT1NZcGm89+5a4OXWaGU28LCM+s5b6ouxE/4y+Z3h11wXY9MpIo1pQtEIAJnQ9Qvq0Ucg5434ugdAnDsnDzB8euVFRIR4y04AwmaBp1MD11C6j3cd+MZGaQRwgQ8+sXC9jQljUeHdvpWAcxMvUCgoiV07sRwbgIcbvqfgP/g6xrwpImqrSgIgHFb6TyjBJkZsa+UywDB09QGMY4g2ZQBwpMqB2FVybqr02P2PjgLYqIQAKh58+aMh8DcWCIeU088FAAxMPU+5HJBsa0bM0jg91DBI3jvEwchn39WTClQdEBxH6epkU4HQqjoV9Sinjkb5eSFBtgoN1hztkSJtoSEcq7Di2qgYHwiAYqnWiOvDcQVQxosdXPxljvaOBh7vVNzAJV75GqGJlDVG7VWWHIgGIKgPpTKobjzctRp8O/kkluNQjiYYmBIOJ3/jSPISi0EaABWtrjgQcX3AMkLXfkV1Yw/28p9rPNtCrGUHIkLSytKT+JCQFAlZRQAMVOrfLKkJrgdfDZp6F+3IwCu96xdkwQ2TziS5y9ziVPP7xExhzb2qlOsCIswDhIDXTvr4y5zLbb0u4qkwaSfLy00fscuZuD3ABLN1ASSYBYP6hkg42Ji1ln0Z9k6fpf9QntBKomsgnnVzlYBcA1D3P7kBiEbgjd7rm8aoXakHGMvRs8ZRz5+zUH8b1oNyrqH98kztKADZoWfbxKqcUU97xaLNTnuY2OpukhmBEdBAwVfRAoColFWlJKJFgXlU/orue+SiyHvBGoEa8iPH9rqz1qSEAyId9Va+YTz/cHT/pemtGFqzk1O5peLIyrDNicpTWyW/TeBfmJZAu2P3/DC6VXJYZ+nPXjhewGgQ6azeF9szuHm7/A/8AyagZG1tHCfqAAAAAElFTkSuQmCC"

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OCA0ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI5NnB4IiBoZWlnaHQ9Ijk2cHgiPg0KPHBhdGggc3R5bGU9ImZpbGw6I0Y0NDMzNjsiIGQ9Ik00NCwyNGMwLDExLjA0NS04Ljk1NSwyMC0yMCwyMFM0LDM1LjA0NSw0LDI0UzEyLjk1NSw0LDI0LDRTNDQsMTIuOTU1LDQ0LDI0eiIvPg0KPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0yOS42NTYsMTUuNTE2bDIuODI4LDIuODI4bC0xNC4xNCwxNC4xNGwtMi44MjgtMi44MjhMMjkuNjU2LDE1LjUxNnoiLz4NCjxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMzIuNDg0LDI5LjY1NmwtMi44MjgsMi44MjhsLTE0LjE0LTE0LjE0bDIuODI4LTIuODI4TDMyLjQ4NCwyOS42NTZ6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODI2Qjg1QjQ3MDY3MTFFN0IxQkVFMkUxRjY5QzhBOUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODI2Qjg1QjU3MDY3MTFFN0IxQkVFMkUxRjY5QzhBOUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4MjZCODVCMjcwNjcxMUU3QjFCRUUyRTFGNjlDOEE5RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4MjZCODVCMzcwNjcxMUU3QjFCRUUyRTFGNjlDOEE5RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgJ38vUAAAEFSURBVHjarJTREcIgDIYt1wEYoSMwgm6gG9ANHMER3AA30A3sBq0bOILv7V0NmvQiB4Hzmrv/oSR8CU1AzfO8WUtqs6LV0zTx7z1oAD0z+7agF8Z+QXX9U5kDXUE9yAggC7pjnOUOxUDk0BhsEiAXFGA5zIYZEsAQxIHN56h49pgRcIdQl4hb9lfjOEpZKVgLPp9s4A24gFqhQhEUNiAHzIJCGAHPBbBDCIrBvD0Kqoo2TWXmSOqykWAlIBGo/gAlgQovrQRqsTESUBPMFIBywIZgfhS6gopSwNMyJv46gTSoB80oi+sxORbnaN2/tHQ3yY6Ypcv8fIuzduOPY+WJa9lbgAEACHq59luUTp8AAAAASUVORK5CYII="

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhpJREFUeNpi/P//PwOtAQuI2LNnD8OlS5cYNDU1xfT09Dz+/fvHR66BzMzM/968eXP+4MGDx4Fshri4OAZGkE98fHwY7t69a9LW1raOi4tLFmgJ2a5mZGQE09u2bWubPHly9b179yA+AfqAKyIiYrGQkJDsr1+/GJiYmCgKHpBFkZGRVV++fDkBNG8z2DQ7OzsPMTExDZAF1ACg0Pnx4weDh4dHLg8PDwPYEiUlJZu/f/9SNbJ///7NICoqqicsLCzIBPWeMC1SFdBHPECKlwnKoVU6Bpn7n4mBDmDUklFLaGwJsKx6QRPDmZg+ATP6R7AlN27c2AcqlqkJWFlZGZ49e3bq9evXn8CW7N69ez+wSD4GLOapYgHIwWxsbAyrVq3q/fr1KyS43r59+7uvry/21atXp0GlJiGM7hhQ0Q4SA8nx8vKCLPm0dOnSzO3btx/h5OSE1Ccgxu3bt+8lJSXZWFpaWgNLTgFgqYyzPBMUFOQKCAiYAmKC6h6gq/9u2LChHhg8N4H6fp4/f/7KrVu37oMsBldioLIxPj6epOAA1j1Mu3bterJ3797/R48e/ZWYmBiJTR3IZ48ePYL4hFQAdCE30AdAiuv3zJkzIxcsWLCWYEPi+/fvJFkCjEy2nz9/fp4+fXrK2rVr1+FSB6x+wSEFtsTZ2RmcGogFUlJSf4DhHwhMpudiYmJwquPg4AAHGSM92l0AAQYA5czSi9gf7JUAAAAASUVORK5CYII="

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABFZJREFUeNp8VGlIpVUYfu6i19Trlua+78u911HTIVNHEBwtRyNkGpT8o9lIDYFG/RGUfghG4TAlQaBOPxTR0tRccEJFHTfEJQR13CZzve7mvny972GEhskOHLjfPe/+PM8rkyQJ/3UaGxtRXl4Ob2/vx62trR9aW1t3uLi4PMnPz3/i4eExyDYzMzPY2tpCV1cXDAwMYGxsDNk1AWXZ2dmSqampx/Ly8qy5uTnW19fR19cHNzc3JCYmjicnJ5ctLCw0r6ysPHNycsLY2BgCAgKuDYilpSU0NDR8n5eXl5Obm4vz83MUFRW9ZOOm1cAnJGTs/ejoTpWEahs7uz5ZQUHBS0ac4PDwEFSBYXt7+0ZhYaEa15wbdCPUFqg9PsQX337z5wcpKa7KlpYW8ahQKHB8fIyDgwPs7Oxgc3PzHrWpLi4uRnV1NYaHh18JaG71OqJtHTF3eoTNv/d/om6goGGLdjgIzyI+Ph5RUVFsXzYyMmIfGxsLvV6PnJwc+Pj4YHd3V9hz8oWjI/y8sYa3ku9cUCV3f6mrO1DOz8+LbEf0KJPJhENaWlpwW1tbSFhYGCioAESlUmFychLp6ekwMTFBf38/Li8vUVtbixCd7lfqYD0yMhJKhpsDscPi4iL29/eZDp8YGRlBo9GgqakJ7u7uIETFfBnxyspK8RYYGIjT01P2fXRlL+csXB0H4sCZmZkmBMq9s7Mz8X1ycgJPT0/09vZCrVZjY2ND8I0pUlJSAhsbm2dTU1Od09PTGB0dhTIiIgJmZmaibQ5iZ2eXTlUZJyUlCcLa2trC0dFRgMYVDA0NsY0gtJ+fHywtLX8gekGpVIpRyBMSEoQDg8IGRND7DFR4eLigT1BQEAYHB0VSBwcHYceBJyYmuNVzCvR4e3ubK4Wvry/kVlZWIltHRwcbv7m3t6ezt7dHT0+PAMjCwgKkBsTExGBubk5Uwi0zQM7OzjWrq6ubpaWlqK+vh5eXF+Q8P9ZsRUUFZ/iY5oGUlBQhpQiqkhygPzvFukKO35724t33UsR/XAhp+hFdlqIAa3Z2FpxVyI/AUWZlZe2wWKgqyd/fX/qxrEz6iDT9mcpY+i5AI93V3ZC+fvhQ0uh00oNPHyyxH18CVMRgUHD1J6GZRVlY2K/cO9ZvSKU+/tLvulDpc/o2NzSUjiXpqxe+iheXf8uuloOcNLtIunbA/5zX5HJ4XUqIzso81N286fa0u1tP20extraG1NTUC1aVkrlEc5Ro2FOEogOtq2sDHhFn/zA0RKZWW9PS0KCff/6cNX7Bs2OSc0AFf3R3dyM0NLSGsriSn5YRvO68c/s2tBrN/bHx8b+Yo0wnFkdcXBx0Oh0UwcHBAiGq8owUUUd67CTuqWhTu9ECUPFi+PfJyMiYHhgY+JIpxEviag+wjjmg8moHMrfYoLm5uYtK76JHByL6LVdX17eJJt60IGy0Wu0KLYWCqqoqQWTWN3ERV/uAzz8CDAAdeUSzwQQcGwAAAABJRU5ErkJggg=="

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAwSDJDMC44OTcgMCAwIDAuODk3IDAgMlYxNEMwIDE1LjEwMyAwLjg5NyAxNiAyIDE2SDE4QzE5LjEwMyAxNiAyMCAxNS4xMDMgMjAgMTRWMkMyMCAwLjg5NyAxOS4xMDMgMCAxOCAwWk00LjUgM0M0Ljg5NzgyIDMgNS4yNzkzNiAzLjE1ODA0IDUuNTYwNjYgMy40MzkzNEM1Ljg0MTk2IDMuNzIwNjQgNiA0LjEwMjE4IDYgNC41QzYgNC44OTc4MiA1Ljg0MTk2IDUuMjc5MzYgNS41NjA2NiA1LjU2MDY2QzUuMjc5MzYgNS44NDE5NiA0Ljg5NzgyIDYgNC41IDZDNC4xMDIxOCA2IDMuNzIwNjQgNS44NDE5NiAzLjQzOTM0IDUuNTYwNjZDMy4xNTgwNCA1LjI3OTM2IDMgNC44OTc4MiAzIDQuNUMzIDQuMTAyMTggMy4xNTgwNCAzLjcyMDY0IDMuNDM5MzQgMy40MzkzNEMzLjcyMDY0IDMuMTU4MDQgNC4xMDIxOCAzIDQuNSAzWk0xMCAxM0gzTDcgOEw4LjUgMTBMMTEuNSA2TDE3IDEzSDEwWiIgZmlsbD0iIzMyMzMzMSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAADuUlEQVQ4jX2UW2hcVRSGv7XPOTNnOrk0bdJEaRITiYhCwL4ZsLFeEE2gGl8EH4oVteKTUMFiidJqnryBKIoU8yTxQqWpCErRB7EUIqlFIrSgkLQVQ2dS0mYymTln7yXnTMyFJO6nfc7a+9//+te/lnS8PY0qqApGHBgBa7sFM6g2es7ZqF0Q8ZtuLYOZRfS8ceYbhXMOmRVjSZZN7ongs3aJEax9WePqsNqoEQRBQbzkUAMirUCvM+4AyB84jgFfrIUwKzuRFo2jcV1aeIe4moJtvdLYXWLcGMjIRkAxGWz8MdXS4PL3plC64U8KfAT0+CqgCOKiQ1ItDaUHZHNmixEsxVtRNkdB9qc746STqDqSvi+pYhRKluKirWErOGBPm+G+3QanUChDsazrGHtOX1cn232n7gl1Uf4/sPmypb97GxlfmLi8lAKEBj57NOB6xbD3c8v97YJT4ezfjsasLKut94i6fqM2PphSFSiWLA/31HHqmS7eHWijVLVEVulpDmhtMEwVHNdKynv7fE4+meWhDsPcYu1uIpen+rjBVTtEhOtlx2N31jP6VHua5ps/XiPr11g/ckceaw0/X3WEAbx1LsZa5cRAlsEej7klXWYpewzqZG7R0teZ49OhNuqz8OxXlxm7cIOcX6t2f1eO+SXL2SuW5m3ClxeVQ9/H1AeWDx8U7r3FMFdRVGjzRSFWoSmrBEsFCvMRdV5MLuNxs6L0dYS0apGLMwvM3Ggi9JVcYKijTOFKkTAb0JTZgdXE/OqMGk9b8obTlyocPlNOi3Gsz3CgN5PKsLfDY2co/LkQpNWOnfD07WWGewtkPeHViQa+nfZoDtO0Z414/kzSzDtzwujvVQ7/FNNSF3DwbkN9zqcttEROGZ8OU8BEwxd65mnNC69MNjN6KUzB0jqrTvqi3gmF9xN7JPqMTVUolh0LFcvuBo/uRrhpfS4UfbJGcQ6O/rYdzxjOXM3QHLrUWkklrcgp6RqZ6bAsTmkc1SXVtolxFzU1dXNO2HebT9l6TJR2YUyqE3MVQ6zQknWpZZYNPhmLecB34s8I4REl+kBVMSLsytfMmoD/8FeExVHXstoVO7JuQ387J28YdN4kjaUSfKKZ/NdpWHXlYPJ6YCD0/3/2gDsuoqdrw6GmZiSe/6LJ5sc17d9VBknqW4KpIqojIMMrY2I15gr4wX4/bHoJLyxuNqxW00wHw69qZAh4bW1s/cRWh5jwI/Hj75BgABs9ry7uTHgqlAX+EfS8FXNS4BdE59bdB/4FP9ygcAhe7ZMAAAAASUVORK5CYII="

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4Ij4NCjxyZWN0IHg9IjUuNyIgeT0iMjIiIHRyYW5zZm9ybT0ibWF0cml4KDAuNzA3MSAtMC43MDcxIDAuNzA3MSAwLjcwNzEgLTkuOTU2MSAyNC4wMzYxKSIgc3R5bGU9ImZpbGw6I0Q1MDAwMDsiIHdpZHRoPSIzNi44IiBoZWlnaHQ9IjQiLz4NCjxwYXRoIHN0eWxlPSJmaWxsOiNENTAwMDA7IiBkPSJNMjQsNEMxMyw0LDQsMTMsNCwyNHM5LDIwLDIwLDIwczIwLTksMjAtMjBTMzUsNCwyNCw0eiBNMjQsNDBjLTguOCwwLTE2LTcuMi0xNi0xNlMxNS4yLDgsMjQsOCAgczE2LDcuMiwxNiwxNlMzMi44LDQwLDI0LDQweiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQoNCiA8dGl0bGUvPg0KIDxnPg0KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+DQogIDxyZWN0IGZpbGw9Im5vbmUiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgaGVpZ2h0PSI0MDIiIHdpZHRoPSI1ODIiIHk9Ii0xIiB4PSItMSIvPg0KIDwvZz4NCiA8Zz4NCiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPg0KICA8cGF0aCBmaWxsPSIjZmZmZmZmIiBpZD0ic3ZnXzEiIGQ9Im0xNiwzMWExNSwxNSAwIDEgMSAxNSwtMTVhMTUsMTUgMCAwIDEgLTE1LDE1em0wLC0yOGExMywxMyAwIDEgMCAxMywxM2ExMywxMyAwIDAgMCAtMTMsLTEzeiIgY2xhc3M9ImNscy0xIi8+DQogIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGlkPSJzdmdfMiIgZD0ibTE2LDI0YTIsMiAwIDEgMSAyLC0yYTIsMiAwIDAgMSAtMiwyem0wLC0yeiIgY2xhc3M9ImNscy0xIi8+DQogIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGlkPSJzdmdfMyIgZD0ibTE2LDE4YTEsMSAwIDAgMSAtMSwtMWwwLC05YTEsMSAwIDAgMSAyLDBsMCw5YTEsMSAwIDAgMSAtMSwxeiIgY2xhc3M9ImNscy0xIi8+DQogPC9nPg0KPC9zdmc+"

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OC4zNSA0OC40MSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iQ2FtYWRhXzEiPjxwYXRoIGQ9Ik0zNSwyMi4zOGMuMTktNS4zOS04LjE1LTEyLjEzLTE2LThDOCwyMC4yMywxMy43MiwzNy40MiwyNi4zMiwzNS4xYzUuNzYtMS4wNiw2LjE3LTUuMzUsOC41Ny00LjM1LDQuNDgsMS44OC01Ljg0LDEwLjQ1LTE1LjE2LDcuNUExNC42OSwxNC42OSwwLDAsMSw5LjYyLDIyLjExQzExLjg3LDYsMzUuMjMsNS4yOCwzOC41NywyMS4yYzEuMzgsNi41NS0yLjcyLDQuODUtOC4xMSw0Ljg1LTMuMjQsMC0xMC4yLjM5LTEyLjc5LS4zNC0yLjA4LTQuMzQsMy40MS0zLjMxLDYuNjEtMy4zMUMyNy44MiwyMi40LDMxLjQyLDIyLjQ2LDM1LDIyLjM4Wk0yMS42NS4xOUM5LDEuOC0xLjUyLDEyLjUzLjE4LDI3LjE2YTI0LjE4LDI0LjE4LDAsMSwwLDQ4LTYuMDVDNDYuNjYsOS4xOCwzNS41Ny0xLjU5LDIxLjY1LjE5WiIgZmlsbD0iIzEwODhlOSIvPjxwYXRoIGQ9Ik0zNSwyMi4zOGMtMy41My4wOC03LjEzLDAtMTAuNjcsMC0zLjIsMC04LjY5LTEtNi42MSwzLjMxLDIuNTkuNzMsOS41NS4zNCwxMi43OS4zNCw1LjM5LDAsOS40OSwxLjcsOC4xMS00Ljg1QzM1LjIzLDUuMjgsMTEuODcsNiw5LjYyLDIyLjExQTE0LjY5LDE0LjY5LDAsMCwwLDE5LjczLDM4LjI1YzkuMzIsMywxOS42NC01LjYyLDE1LjE2LTcuNS0yLjQtMS0yLjgxLDMuMjktOC41Nyw0LjM1QzEzLjcyLDM3LjQyLDgsMjAuMjMsMTksMTQuNDIsMjYuOCwxMC4yNSwzNS4xNCwxNywzNSwyMi4zOFoiIGZpbGw9IiNmZmYiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KIDxtZXRhZGF0YT5TdmcgVmVjdG9yIEljb25zIDogaHR0cDovL3d3dy5vbmxpbmV3ZWJmb250cy5jb20vaWNvbjwvbWV0YWRhdGE+DQoNCiA8Zz4NCiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPg0KICA8cmVjdCB4PSItMSIgeT0iLTEiIHdpZHRoPSIxMzM1LjM4MjQ4NyIgaGVpZ2h0PSIxMzM1LjM4MjQ4NyIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBmaWxsPSJub25lIi8+DQogPC9nPg0KIDxnPg0KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+DQogIDxlbGxpcHNlIHN0cm9rZT0iI2ZmZmZmZiIgcnk9IjQzNi4wMDc2NjQiIHJ4PSI0MzYuMDA3NjY0IiBpZD0ic3ZnXzgiIGN5PSI1MDAuMDAwMDIiIGN4PSI1MDAuMDAwMDAxIiBzdHJva2Utd2lkdGg9IjAiIGZpbGw9IiNlNDI4MjgiLz4NCiAgPGcgaWQ9InN2Z18xIj4NCiAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAsNTEyKSBzY2FsZSgwLjEwMDAwMDAwMTQ5MDExNjEyLC0wLjEwMDAwMDAwMTQ5MDExNjEyKSAiIGlkPSJzdmdfMiI+DQogICAgPHBhdGggZD0ibTQ1ODYuMjAyNzk5LDUwMDQuMDk5OTA3Yy0xNDc3LjMsLTE1MS40IC0yNzkxLjgsLTk0Mi43IC0zNjI1LjMsLTIxODYuM2MtMzA2LjYsLTQ1OS44IC01OTQsLTExNDMuOCAtNzAzLjIsLTE2ODIuM2MtODIuNCwtNDA2LjIgLTk3LjcsLTU2NS4yIC05Ny43LC0xMDE1LjVjMCwtNDUwLjMgMTUuMywtNjA1LjUgOTcuNywtMTAxNS41YzEwNy4zLC01MzAuOCAzOTQuNywtMTIxNi44IDcwMy4yLC0xNjgyLjRjOTIxLjYsLTEzNzcuNyAyNDU4LjQsLTIyMDcuMyA0MDk0LjcsLTIyMDcuM2MxODUwLjksMCAzNTU2LjMsMTA1OS42IDQzODYsMjcyMi44YzgzMS42LDE2NjguOSA2NTMuNCwzNjMxIC00NjcuNSw1MTIzLjdjLTc3NiwxMDM0LjcgLTE5MjEuOCwxNzE0LjkgLTMyMjguNiwxOTE2LjFjLTIzOS42LDM2LjMgLTkxNC4xLDUzLjYgLTExNTkuMywyNi43em04NTQuNiwtNzY0LjVjMzEwLjQsLTMwLjcgNTk1LjksLTkyIDkwNi4zLC0xOTMuNWMxMjQ3LjQsLTQwOC4xIDIyMzAuMywtMTM5MyAyNjM4LjUsLTI2NDIuM2M0ODQuOCwtMTQ4NSA5Ny43LC0zMTAwLjMgLTEwMDcuOSwtNDIwNS44Yy04NzMuNywtODczLjcgLTIxMDAsLTEzMTYuNCAtMzMxNi44LC0xMTk1LjdjLTE5NzMuNiwxOTUuNCAtMzUyNy41LDE3NTEuMyAtMzcyNC45LDM3MzIuNmMtMTMwLjMsMTMxNi40IDQyNS40LDI2ODIuNiAxNDM3LjEsMzUzMy4zYzg2Mi4yLDcyNC4zIDE5ODEuMiwxMDc4LjcgMzA2Ny43LDk3MS40eiIgaWQ9InN2Z18zIiBmaWxsPSIjZTQyODI4IiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMCIvPg0KICAgIDxwYXRoIGQ9Im0zODE4LjAwMjk4NSwyMjAxYy00Mi4yLC0xOS4yIC03NC43LC01My43IC05OS42LC0xMDkuMmMtMzYuNCwtODAuNSAtMzguNCwtMTQxLjggLTM4LjQsLTE5NjkuOGMwLC0xODI5LjkgMS45LC0xODg5LjMgMzguMywtMTk2OS43YzQ5LjgsLTEwOS4yIDE0My43LC0xNTMuMyAyNjAuNiwtMTIyLjZjMTEzLDMwLjcgMzE5OS45LDE4MzEuOCAzMjkzLjgsMTkyMy44YzY5LDY3LjEgNzYuNyw4Mi40IDc2LjcsMTY4LjZjMCw4Ni4yIC03LjcsMTAxLjYgLTc2LjcsMTY4LjZjLTc4LjUsNzYuNyAtMzE0MC41LDE4NzIgLTMyNjUsMTkxNi4xYy04Mi40LDI4LjcgLTExMS4xLDI4LjcgLTE4OS43LC01Ljh6IiBpZD0ic3ZnXzQiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZT0iI2ZmZmZmZiIgc3Ryb2tlLXdpZHRoPSIwIi8+DQogICA8L2c+DQogIDwvZz4NCiA8L2c+DQo8L3N2Zz4="

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA9lJREFUeNqEVG1oW1UYfs/N/UhuvnZvuumydR0yNlGp21AG2jIQQefcZILoD5UOKdaJY18MlPpL2p8iKjik/lRRHGOCIriW6vwxp2MT183W1bGYkCZ2TZOb2+Qmuef6nHy0aevwhUPenHPf5zzvc55z2NjYGI2Pj1Mrqp5HNue0QVHo8VDo7vv8/kcqnncvljSMvMrY5fO2feHCwkJp3nUpJEnUHvLo6CgNDQ0tToiqF0KhB/YbxqGwojx5m7H1nMjfWke5tZHzPx90nC/enZ0d+aFSmVsG6PP5Fv/EkH++adObPbo+WORcBzPyMM/aCvA/HCXa2RsI7NwVjb766fz84ZMzM9+4ntfYsPVxTJYZwD7apevDt11Xd5pg/xVgXJcFIPcMmOaZD+PxlyBFA1BopiP5rLPzLYAN5KHLqiiVyCsWiRyHGGPLgOdcV+kzjJETHR09dUALOz0bDHb3BINvFwDW3h4JlhjSgQMUOHaM+O7d5Fary79B5FxXPRSLffCQrgekdbJMLxvGYbSgrWIGMI4R6uujjqNHSdq7l5K2XV9qBxX6RX2+7U+Fw89IeyKR+GZVfaLCOd0xyuUGCNjNo/1buRy5mGsHLQH0sWDwefl+TeuFNe7y6P/Dq9XI2LGDAlu3UjGbpcjEBDH4UNQ6ILRFVbslWGMLuCmrWl1YIC7aE5o1D4JXKtQ1MEDbT52itUeO0N9gKSRhS5Yy5KaX2zwBeE0j5eBBYtEoFXCL3GbL9aKmNAy/4hBT2HCDqgrDC0BZRjLLqM2/wqD4YG1/P8mmSZZlURV2aWff+pXAvO4MgG7EVQWWLZU97xc4r7iq5eZpipaJsTvq6sNaHmxT0LfmugnpdD7/62ytNiGvKJK0hhIMtpLAuJUzpSF3a64OKg4FgN/6/b9JU45TPVcsfqK3Xg0BjB2tq1epODlJTiZD9vQ02VNTVE6lqJRI1HP7xo2lW4OOZF33zrrul+z44CCdGR72/7Rt249YfrjWPLUcRkYcgNAIhQwPh7BNi6mHea95TXXUXOvq+ur1S5eek4Jg9hfn5ddSqT7kWdG6kN0E2DoAcBRx6OiK+yxAMCdyMSciALBUNHr5nevX33Bw3xdfx7OFwrUT6fQ+cJoWm3gYMei0Xmgm5BDPnGgRuWArdAsjT5nmxZOJxP5b2exM871cio/n5i6+kkz2XimXRwBa8qMgDsC4LDdaBRtxVLqQIBwunDOM94+n03tu5nLJxQd2pQ2+s6z095bVvy8See/FNWueBuij3ZoW71QUdVKW+U3HSfxjmj9/nUye/j2T+YNWvAH/CjAAdRXMsytIRUwAAAAASUVORK5CYII="

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEYyQjFEMDQ3QzNEMTFFM0JDQjJFRTVBNDlGMDZGMTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEYyQjFEMDU3QzNEMTFFM0JDQjJFRTVBNDlGMDZGMTYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowRjJCMUQwMjdDM0QxMUUzQkNCMkVFNUE0OUYwNkYxNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRjJCMUQwMzdDM0QxMUUzQkNCMkVFNUE0OUYwNkYxNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoX1zpkAAAICSURBVHjanNRPSBVRFMdxfaaUKWh/fPUsAsNIUly8tgpZEREWuKiN2KIIRKIWLVpEQYIEWouCCAJTIqiV/SHa1UZqYbhRsRLBkErTKIs0taTvkd/AcLiCeuDDezNz751z/8zJTKfTGYHYgL3Yj3Ikdf8r+vESPfjmO65x13k4givYjczAyw7jAobQjCf4FT1MxBoW4TYeomyJwaKwZ7twH3eR8hnm4xaOZ6w8TmAdGjAVZXh+lYNFcRQXF1NnU3ZqPeJT/IcJ/NQstiDXMsC42mzU5sX7lSWUsl+vT2hCLerwTPc7dc9ci2+G4qS9/UBgCj/wAjO6HtXvW3zQ/z7Mu377LMPSwIA2vZLYdTJ2EqLYhGzXb4cNOBcYcCtu4rSuv0dTQoteOIkF128+odR9rEcNCnS9Wb8VOIhZbNPA8XhnA3YFBrTFvow2VOKQ7lvbYzoF9chx/bpswOf47B6M4Dqq8UDHw+Kevmf7QqpcH1uWxwmtxVn3cDue4hH26J6t11W8VnZZrs85fMlKpRY/w0H81ltt59Zql/MCm1UcWCI7kzd8cbgTOKi+IPiYUWaXfHGwxmdQuMxv12bTgXb0+npoWTaqtmW7RbasP9qBVVtb7wG810ZOhwrsKbSqBI3hjYrmKxWCudjx+Ksjs2TYgH+0o6Mq790Ydu1ml1vH/gswAOhiZwkvTTqwAAAAAElFTkSuQmCC"

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAASBQTFRF////AAAAAA4cABcXABQdABAZABAgABMcABEcABEcABMdABEcAhIcAhIdAREcARMdBBUfARIbARMdco+gttnwAhMeGCw4JDhFBRYhChwmttrxBhgiARIcARIcAxQeBBcjCRolCiQzDi1ADyw/EiUwEzdNFik1IjZCJWGHK0BNK0FOLEJPM3+xOIq/PVRiPlVjQ1tpRFxrSGFwTrn/T2h4UGl5UGp5V3GBWXODW3WGXXiJYn2OY3+QZYCSaISVbYmbcI2fdJGjdZKkeZeqf52xh6a6iKe6jKu/jKzAkbHFl7fMmLjNnsDVpMbbpMbcpsjep8nfqszjsNPqsdXrs9bttNjvttrxt9ryut71ut/2veH5veL6wOT8wOX9web+wuf/G8orXgAAAB10Uk5TAAISFhofIFFaW2B1gI6wzNHf5O3x+vr6/Pz8/f4ZEo2pAAABDklEQVQ4y52TaVPCMBCGo6AVFFG0HMp63wgicgkoKIJnFQ8ule7//xeSpIyU6RLH51MmfWZ2+2aXMSWuaYKpCfHdFwWKxUku6KkbgiWY4QKUkWAZvCphfm7WLYT7o8NR8ogrsBoJLwjh6SQxSv+2BVUsw5gSQ4L5bAiaiN/yZLRtQtH68b0OXlrHmE1IbsU5B/CG3VvJq13YPeMc9wXnHoaExrmkRgnVHUny3yWchdP1bc4mvBMlGpm04BqJJpVRf93JdF6QCOrKyne/R0StfCxlD4OBuUB8cByYwchle1j/HbnPjRwX9BJVAgtrjyWd+YMmaXyYQT/TIFShVqcSAo0xT4DcPQh4xq+vi/2BH7Zl43zvdHNRAAAAAElFTkSuQmCC"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfxJREFUeNqUlL9vEzEUx5/tu5zvLomuUYmoBC0SEgvdEXPpAAwR/wULgr2slVgKC4WBAWhhYMnCXLU7P0aIhESyBFBoVfLjfvjH2fgoukA4KPf0lc9+8kfv3teW0dmlM/BHXDhXbV1sWraNMe7vx/faPSgKqzBLPbd5asHxqOO55GsEUAZ2XNpYaPp13w9qaRDBX2IKU0pv3LpJiHVnfb1CnaA5V50Paifm6En8YPM6IBvAiBwefltbezQLr6yunl9ePprbjp2RzQYiXq3ur1w6DcjNBO7GxuMcwXnZy1evTP+nYtO6j7CDkAO5wBkOk2db7VnYlK1Wq9OsRSoeBWRlAvJDZife3mpHUTTb8+LSYud9J88igo92myljstvrmcqC46dPXhQY9vD+5q9ZlA8A3W6/1bpd6DYuzOpsUJm0+rkqAadKp6n5aJAAohyslBKMgSG1AC2PvyS/VZYpDxNiGdOR1rwcnIqUhTHCyPFNw6wcLGWajCKtVCokG0/KwYKLeBIpKUUsXFAIgdb/DUcRN7DkgtjcsvD23WvDCTO9CM5e7nzYe9X/Fzw4CJNxKGyb2MS8B+Zmz3sguQ6lfPtucEzlj/3R5y/DRkANiZAxPGufJ3z39adROD120giCAreVftM5oES7ljLWs5glYTzYHz/f6XM57f67AAMAUEDWbTxoKx8AAAAASUVORK5CYII="

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+DQo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS43NSIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiIHN0cm9rZT0iIzMyMzMzMSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4NCjxkZWZzPg0KPHBhdHRlcm4gaWQ9InBhdHRlcm4wIiBwYXR0ZXJuQ29udGVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgd2lkdGg9IjEiIGhlaWdodD0iMSI+DQo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTBfMTdfMzA3IiB0cmFuc2Zvcm09InNjYWxlKDAuMDE1NjI1KSIvPg0KPC9wYXR0ZXJuPg0KPGltYWdlIGlkPSJpbWFnZTBfMTdfMzA3IiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBRUFBQUFCQUNBWUFBQUNxYVhIZUFBQUFBWE5TUjBJQXJzNGM2UUFBQU9OSlJFRlVlRjd0MjBFT2hFQUlSRkc0LzZGN0R2RW5ZZUZ6cnlRSXY2cEJkMmJlaE91OWRQdnNib2craytOTGdBclFBcW1KY3c5aUFBaFNnWktCM0lKa2tBeVNRVEo0Q2lFK2dBOG9CZWcwbUgzQWkwODRQODlIaHF3RXFJQTIwOUlDc1FkakFlYVpJZ2FBWUt4QkRNQ0FZeThmWHdBSWdpQUljb0pwSkVZR0k0VmpCM1lyYkM5Z0wyQXZrQ0I0M2NNNVBnWmdBQVpnUUZuTlpBaGRHeWtRQkVFUUJFRVFEQm1nQW0yZ2xNL3orUVVZaXNZVUdvbGRPN2tZMzJJRUF6Q2c2UmdJUmdqRkFzdytBZ1JCTU5ZZ0JtQ0FUMlRDWWZvUFB6L0hDcVFDWDFlQkh6SG52N0M3V2hCU0FBQUFBRWxGVGtTdVFtQ0MiLz4NCjwvZGVmcz4NCjwvc3ZnPg0K"

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhBwAHAIABAAAAAP///yH5BAEAAAEALAAAAAAHAAcAAAIMjGGJmMH9mHQ0AlYAADs="

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEQANALMPAOXl5T8/P29vb7S0tFdXV/39/djY2N3d3crKyu/v7/f39/Ly8p2dnf///zMzMwAAACH5BAEAAA8ALAAAAAARAA0AAARF0MlJq3uutay75lmGNU9pjiNFCsipqhgxmO9HSgFTgtt9O4EBABWa3AiGwvBlfAgWisPOyCslDDSbSHTa+SzgpmdMbkQAADs="

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	// see https://tools.ietf.org/html/rfc1808
	
	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
	
	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };
	
	  if (true)
	    module.exports = URLToolkit;
	  else if (typeof define === 'function' && define.amd)
	    define([], function () {
	      return URLToolkit;
	    });
	  else if (typeof exports === 'object') exports['URLToolkit'] = URLToolkit;
	  else root['URLToolkit'] = URLToolkit;
	})(this);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @license
	 * Video.js 7.21.7 <http://videojs.com/>
	 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
	 * Available under Apache License Version 2.0
	 * <https://github.com/videojs/video.js/blob/main/LICENSE>
	 *
	 * Includes vtt.js <https://github.com/mozilla/vtt.js>
	 * Available under Apache License Version 2.0
	 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
	 */
	
	'use strict';
	
	var window$1 = __webpack_require__(2);
	var document = __webpack_require__(30);
	var _extends = __webpack_require__(10);
	var keycode = __webpack_require__(201);
	var _assertThisInitialized = __webpack_require__(19);
	var _inheritsLoose = __webpack_require__(21);
	var safeParseTuple = __webpack_require__(318);
	var XHR = __webpack_require__(175);
	var vtt = __webpack_require__(418);
	var _construct = __webpack_require__(20);
	var _inherits = __webpack_require__(161);
	var _resolveUrl = __webpack_require__(25);
	var m3u8Parser = __webpack_require__(202);
	var codecs_js = __webpack_require__(165);
	var mediaTypes_js = __webpack_require__(169);
	var byteHelpers = __webpack_require__(3);
	var mpdParser = __webpack_require__(204);
	var parseSidx = __webpack_require__(205);
	var id3Helpers = __webpack_require__(24);
	var containers = __webpack_require__(166);
	var clock = __webpack_require__(206);
	var _wrapNativeSuper = __webpack_require__(164);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window$1);
	var document__default = /*#__PURE__*/_interopDefaultLegacy(document);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var keycode__default = /*#__PURE__*/_interopDefaultLegacy(keycode);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var safeParseTuple__default = /*#__PURE__*/_interopDefaultLegacy(safeParseTuple);
	var XHR__default = /*#__PURE__*/_interopDefaultLegacy(XHR);
	var vtt__default = /*#__PURE__*/_interopDefaultLegacy(vtt);
	var _construct__default = /*#__PURE__*/_interopDefaultLegacy(_construct);
	var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
	var _resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(_resolveUrl);
	var parseSidx__default = /*#__PURE__*/_interopDefaultLegacy(parseSidx);
	var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);
	
	var version$5 = "7.21.7";
	
	/**
	 * An Object that contains lifecycle hooks as keys which point to an array
	 * of functions that are run when a lifecycle is triggered
	 *
	 * @private
	 */
	var hooks_ = {};
	/**
	 * Get a list of hooks for a specific lifecycle
	 *
	 * @param  {string} type
	 *         the lifecyle to get hooks from
	 *
	 * @param  {Function|Function[]} [fn]
	 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
	 *
	 * @return {Array}
	 *         an array of hooks, or an empty array if there are none.
	 */
	
	var hooks = function hooks(type, fn) {
	  hooks_[type] = hooks_[type] || [];
	
	  if (fn) {
	    hooks_[type] = hooks_[type].concat(fn);
	  }
	
	  return hooks_[type];
	};
	/**
	 * Add a function hook to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hook = function hook(type, fn) {
	  hooks(type, fn);
	};
	/**
	 * Remove a hook from a specific videojs lifecycle.
	 *
	 * @param  {string} type
	 *         the lifecycle that the function hooked to
	 *
	 * @param  {Function} fn
	 *         The hooked function to remove
	 *
	 * @return {boolean}
	 *         The function that was removed or undef
	 */
	
	
	var removeHook = function removeHook(type, fn) {
	  var index = hooks(type).indexOf(fn);
	
	  if (index <= -1) {
	    return false;
	  }
	
	  hooks_[type] = hooks_[type].slice();
	  hooks_[type].splice(index, 1);
	  return true;
	};
	/**
	 * Add a function hook that will only run once to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hookOnce = function hookOnce(type, fn) {
	  hooks(type, [].concat(fn).map(function (original) {
	    var wrapper = function wrapper() {
	      removeHook(type, wrapper);
	      return original.apply(void 0, arguments);
	    };
	
	    return wrapper;
	  }));
	};
	
	/**
	 * @file fullscreen-api.js
	 * @module fullscreen-api
	 * @private
	 */
	/**
	 * Store the browser-specific methods for the fullscreen API.
	 *
	 * @type {Object}
	 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	 */
	
	var FullscreenApi = {
	  prefixed: true
	}; // browser API methods
	
	var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror', 'fullscreen'], // WebKit
	['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror', '-webkit-full-screen'], // Mozilla
	['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror', '-moz-full-screen'], // Microsoft
	['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError', '-ms-fullscreen']];
	var specApi = apiMap[0];
	var browserApi; // determine the supported set of functions
	
	for (var i = 0; i < apiMap.length; i++) {
	  // check for exitFullscreen function
	  if (apiMap[i][1] in document__default['default']) {
	    browserApi = apiMap[i];
	    break;
	  }
	} // map the browser API names to the spec API names
	
	
	if (browserApi) {
	  for (var _i = 0; _i < browserApi.length; _i++) {
	    FullscreenApi[specApi[_i]] = browserApi[_i];
	  }
	
	  FullscreenApi.prefixed = browserApi[0] !== specApi[0];
	}
	
	/**
	 * @file create-logger.js
	 * @module create-logger
	 */
	
	var history = [];
	/**
	 * Log messages to the console and history based on the type of message
	 *
	 * @private
	 * @param  {string} type
	 *         The name of the console method to use.
	 *
	 * @param  {Array} args
	 *         The arguments to be passed to the matching console method.
	 */
	
	var LogByTypeFactory = function LogByTypeFactory(name, log) {
	  return function (type, level, args) {
	    var lvl = log.levels[level];
	    var lvlRegExp = new RegExp("^(" + lvl + ")$");
	
	    if (type !== 'log') {
	      // Add the type to the front of the message when it's not "log".
	      args.unshift(type.toUpperCase() + ':');
	    } // Add console prefix after adding to history.
	
	
	    args.unshift(name + ':'); // Add a clone of the args at this point to history.
	
	    if (history) {
	      history.push([].concat(args)); // only store 1000 history entries
	
	      var splice = history.length - 1000;
	      history.splice(0, splice > 0 ? splice : 0);
	    } // If there's no console then don't try to output messages, but they will
	    // still be stored in history.
	
	
	    if (!window__default['default'].console) {
	      return;
	    } // Was setting these once outside of this function, but containing them
	    // in the function makes it easier to test cases where console doesn't exist
	    // when the module is executed.
	
	
	    var fn = window__default['default'].console[type];
	
	    if (!fn && type === 'debug') {
	      // Certain browsers don't have support for console.debug. For those, we
	      // should default to the closest comparable log.
	      fn = window__default['default'].console.info || window__default['default'].console.log;
	    } // Bail out if there's no console or if this type is not allowed by the
	    // current logging level.
	
	
	    if (!fn || !lvl || !lvlRegExp.test(type)) {
	      return;
	    }
	
	    fn[Array.isArray(args) ? 'apply' : 'call'](window__default['default'].console, args);
	  };
	};
	
	function createLogger$1(name) {
	  // This is the private tracking variable for logging level.
	  var level = 'info'; // the curried logByType bound to the specific log and history
	
	  var logByType;
	  /**
	   * Logs plain debug messages. Similar to `console.log`.
	   *
	   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	   * of our JSDoc template, we cannot properly document this as both a function
	   * and a namespace, so its function signature is documented here.
	   *
	   * #### Arguments
	   * ##### *args
	   * Mixed[]
	   *
	   * Any combination of values that could be passed to `console.log()`.
	   *
	   * #### Return Value
	   *
	   * `undefined`
	   *
	   * @namespace
	   * @param    {Mixed[]} args
	   *           One or more messages or objects that should be logged.
	   */
	
	  var log = function log() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    logByType('log', level, args);
	  }; // This is the logByType helper that the logging methods below use
	
	
	  logByType = LogByTypeFactory(name, log);
	  /**
	   * Create a new sublogger which chains the old name to the new name.
	   *
	   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
	   * ```js
	   *  mylogger('foo');
	   *  // > VIDEOJS: player: foo
	   * ```
	   *
	   * @param {string} name
	   *        The name to add call the new logger
	   * @return {Object}
	   */
	
	  log.createLogger = function (subname) {
	    return createLogger$1(name + ': ' + subname);
	  };
	  /**
	   * Enumeration of available logging levels, where the keys are the level names
	   * and the values are `|`-separated strings containing logging methods allowed
	   * in that logging level. These strings are used to create a regular expression
	   * matching the function name being called.
	   *
	   * Levels provided by Video.js are:
	   *
	   * - `off`: Matches no calls. Any value that can be cast to `false` will have
	   *   this effect. The most restrictive.
	   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
	   *   `log.warn`, and `log.error`).
	   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
	   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
	   * - `warn`: Matches `log.warn` and `log.error` calls.
	   * - `error`: Matches only `log.error` calls.
	   *
	   * @type {Object}
	   */
	
	
	  log.levels = {
	    all: 'debug|log|warn|error',
	    off: '',
	    debug: 'debug|log|warn|error',
	    info: 'log|warn|error',
	    warn: 'warn|error',
	    error: 'error',
	    DEFAULT: level
	  };
	  /**
	   * Get or set the current logging level.
	   *
	   * If a string matching a key from {@link module:log.levels} is provided, acts
	   * as a setter.
	   *
	   * @param  {string} [lvl]
	   *         Pass a valid level to set a new logging level.
	   *
	   * @return {string}
	   *         The current logging level.
	   */
	
	  log.level = function (lvl) {
	    if (typeof lvl === 'string') {
	      if (!log.levels.hasOwnProperty(lvl)) {
	        throw new Error("\"" + lvl + "\" in not a valid log level");
	      }
	
	      level = lvl;
	    }
	
	    return level;
	  };
	  /**
	   * Returns an array containing everything that has been logged to the history.
	   *
	   * This array is a shallow clone of the internal history record. However, its
	   * contents are _not_ cloned; so, mutating objects inside this array will
	   * mutate them in history.
	   *
	   * @return {Array}
	   */
	
	
	  log.history = function () {
	    return history ? [].concat(history) : [];
	  };
	  /**
	   * Allows you to filter the history by the given logger name
	   *
	   * @param {string} fname
	   *        The name to filter by
	   *
	   * @return {Array}
	   *         The filtered list to return
	   */
	
	
	  log.history.filter = function (fname) {
	    return (history || []).filter(function (historyItem) {
	      // if the first item in each historyItem includes `fname`, then it's a match
	      return new RegExp(".*" + fname + ".*").test(historyItem[0]);
	    });
	  };
	  /**
	   * Clears the internal history tracking, but does not prevent further history
	   * tracking.
	   */
	
	
	  log.history.clear = function () {
	    if (history) {
	      history.length = 0;
	    }
	  };
	  /**
	   * Disable history tracking if it is currently enabled.
	   */
	
	
	  log.history.disable = function () {
	    if (history !== null) {
	      history.length = 0;
	      history = null;
	    }
	  };
	  /**
	   * Enable history tracking if it is currently disabled.
	   */
	
	
	  log.history.enable = function () {
	    if (history === null) {
	      history = [];
	    }
	  };
	  /**
	   * Logs error messages. Similar to `console.error`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as an error
	   */
	
	
	  log.error = function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return logByType('error', level, args);
	  };
	  /**
	   * Logs warning messages. Similar to `console.warn`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as a warning.
	   */
	
	
	  log.warn = function () {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return logByType('warn', level, args);
	  };
	  /**
	   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
	   * log if `console.debug` is not available
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as debug.
	   */
	
	
	  log.debug = function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return logByType('debug', level, args);
	  };
	
	  return log;
	}
	
	/**
	 * @file log.js
	 * @module log
	 */
	var log$1 = createLogger$1('VIDEOJS');
	var createLogger = log$1.createLogger;
	
	/**
	 * @file obj.js
	 * @module obj
	 */
	
	/**
	 * @callback obj:EachCallback
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 */
	
	/**
	 * @callback obj:ReduceCallback
	 *
	 * @param {Mixed} accum
	 *        The value that is accumulating over the reduce loop.
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 *
	 * @return {Mixed}
	 *         The new accumulated value.
	 */
	var toString = Object.prototype.toString;
	/**
	 * Get the keys of an Object
	 *
	 * @param {Object}
	 *        The Object to get the keys from
	 *
	 * @return {string[]}
	 *         An array of the keys from the object. Returns an empty array if the
	 *         object passed in was invalid or had no keys.
	 *
	 * @private
	 */
	
	var keys = function keys(object) {
	  return isObject(object) ? Object.keys(object) : [];
	};
	/**
	 * Array-like iteration for objects.
	 *
	 * @param {Object} object
	 *        The object to iterate over
	 *
	 * @param {obj:EachCallback} fn
	 *        The callback function which is called for each key in the object.
	 */
	
	
	function each(object, fn) {
	  keys(object).forEach(function (key) {
	    return fn(object[key], key);
	  });
	}
	/**
	 * Array-like reduce for objects.
	 *
	 * @param {Object} object
	 *        The Object that you want to reduce.
	 *
	 * @param {Function} fn
	 *         A callback function which is called for each key in the object. It
	 *         receives the accumulated value and the per-iteration value and key
	 *         as arguments.
	 *
	 * @param {Mixed} [initial = 0]
	 *        Starting value
	 *
	 * @return {Mixed}
	 *         The final accumulated value.
	 */
	
	function reduce(object, fn, initial) {
	  if (initial === void 0) {
	    initial = 0;
	  }
	
	  return keys(object).reduce(function (accum, key) {
	    return fn(accum, object[key], key);
	  }, initial);
	}
	/**
	 * Object.assign-style object shallow merge/extend.
	 *
	 * @param  {Object} target
	 * @param  {Object} ...sources
	 * @return {Object}
	 */
	
	function assign(target) {
	  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (Object.assign) {
	    return _extends__default['default'].apply(void 0, [target].concat(sources));
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      target[key] = value;
	    });
	  });
	  return target;
	}
	/**
	 * Returns whether a value is an object of any kind - including DOM nodes,
	 * arrays, regular expressions, etc. Not functions, though.
	 *
	 * This avoids the gotcha where using `typeof` on a `null` value
	 * results in `'object'`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isObject(value) {
	  return !!value && typeof value === 'object';
	}
	/**
	 * Returns whether an object appears to be a "plain" object - that is, a
	 * direct instance of `Object`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isPlain(value) {
	  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
	}
	
	/**
	 * @file computed-style.js
	 * @module computed-style
	 */
	/**
	 * A safe getComputedStyle.
	 *
	 * This is needed because in Firefox, if the player is loaded in an iframe with
	 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
	 * null-check to make sure that the player doesn't break in these cases.
	 *
	 * @function
	 * @param    {Element} el
	 *           The element you want the computed style of
	 *
	 * @param    {string} prop
	 *           The property name you want
	 *
	 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	
	function computedStyle(el, prop) {
	  if (!el || !prop) {
	    return '';
	  }
	
	  if (typeof window__default['default'].getComputedStyle === 'function') {
	    var computedStyleValue;
	
	    try {
	      computedStyleValue = window__default['default'].getComputedStyle(el);
	    } catch (e) {
	      return '';
	    }
	
	    return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : '';
	  }
	
	  return '';
	}
	
	/**
	 * @file browser.js
	 * @module browser
	 */
	var USER_AGENT = window__default['default'].navigator && window__default['default'].navigator.userAgent || '';
	var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
	var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	/**
	 * Whether or not this device is an iPod.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	/**
	 * The detected iOS version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {string|null}
	 */
	
	var IOS_VERSION = function () {
	  var match = USER_AGENT.match(/OS (\d+)_/i);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is an Android device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANDROID = /Android/i.test(USER_AGENT);
	/**
	 * The detected Android version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|string|null}
	 */
	
	var ANDROID_VERSION = function () {
	  // This matches Android Major.Minor.Patch versions
	  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
	  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
	
	  if (!match) {
	    return null;
	  }
	
	  var major = match[1] && parseFloat(match[1]);
	  var minor = match[2] && parseFloat(match[2]);
	
	  if (major && minor) {
	    return parseFloat(match[1] + '.' + match[2]);
	  } else if (major) {
	    return major;
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is a native Android browser.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
	/**
	 * Whether or not this is Mozilla Firefox.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
	/**
	 * Whether or not this is Microsoft Edge.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_EDGE = /Edg/i.test(USER_AGENT);
	/**
	 * Whether or not this is Google Chrome.
	 *
	 * This will also be `true` for Chrome on iOS, which will have different support
	 * as it is actually Safari under the hood.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
	/**
	 * The detected Google Chrome version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var CHROME_VERSION = function () {
	  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
	
	  if (match && match[2]) {
	    return parseFloat(match[2]);
	  }
	
	  return null;
	}();
	/**
	 * The detected Internet Explorer version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var IE_VERSION = function () {
	  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
	  var version = result && parseFloat(result[1]);
	
	  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
	    // IE 11 has a different user agent string than other IE versions
	    version = 11.0;
	  }
	
	  return version;
	}();
	/**
	 * Whether or not this is desktop Safari.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
	/**
	 * Whether or not this is a Windows machine.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_WINDOWS = /Windows/i.test(USER_AGENT);
	/**
	 * Whether or not this device is touch-enabled.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var TOUCH_ENABLED = Boolean(isReal() && ('ontouchstart' in window__default['default'] || window__default['default'].navigator.maxTouchPoints || window__default['default'].DocumentTouch && window__default['default'].document instanceof window__default['default'].DocumentTouch));
	/**
	 * Whether or not this device is an iPad.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT) || IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
	/**
	 * Whether or not this device is an iPhone.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	/**
	 * Whether or not this is an iOS device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	/**
	 * Whether or not this is any flavor of Safari - including iOS.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
	
	var browser = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  IS_IPOD: IS_IPOD,
	  IOS_VERSION: IOS_VERSION,
	  IS_ANDROID: IS_ANDROID,
	  ANDROID_VERSION: ANDROID_VERSION,
	  IS_NATIVE_ANDROID: IS_NATIVE_ANDROID,
	  IS_FIREFOX: IS_FIREFOX,
	  IS_EDGE: IS_EDGE,
	  IS_CHROME: IS_CHROME,
	  CHROME_VERSION: CHROME_VERSION,
	  IE_VERSION: IE_VERSION,
	  IS_SAFARI: IS_SAFARI,
	  IS_WINDOWS: IS_WINDOWS,
	  TOUCH_ENABLED: TOUCH_ENABLED,
	  IS_IPAD: IS_IPAD,
	  IS_IPHONE: IS_IPHONE,
	  IS_IOS: IS_IOS,
	  IS_ANY_SAFARI: IS_ANY_SAFARI
	});
	
	/**
	 * @file dom.js
	 * @module dom
	 */
	/**
	 * Detect if a value is a string with any non-whitespace characters.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check
	 *
	 * @return {boolean}
	 *         Will be `true` if the string is non-blank, `false` otherwise.
	 *
	 */
	
	function isNonBlankString(str) {
	  // we use str.trim as it will trim any whitespace characters
	  // from the front or back of non-whitespace characters. aka
	  // Any string that contains non-whitespace characters will
	  // still contain them after `trim` but whitespace only strings
	  // will have a length of 0, failing this check.
	  return typeof str === 'string' && Boolean(str.trim());
	}
	/**
	 * Throws an error if the passed string has whitespace. This is used by
	 * class methods to be relatively consistent with the classList API.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check for whitespace.
	 *
	 * @throws {Error}
	 *         Throws an error if there is whitespace in the string.
	 */
	
	
	function throwIfWhitespace(str) {
	  // str.indexOf instead of regex because str.indexOf is faster performance wise.
	  if (str.indexOf(' ') >= 0) {
	    throw new Error('class has illegal whitespace characters');
	  }
	}
	/**
	 * Produce a regular expression for matching a className within an elements className.
	 *
	 * @private
	 * @param  {string} className
	 *         The className to generate the RegExp for.
	 *
	 * @return {RegExp}
	 *         The RegExp that will check for a specific `className` in an elements
	 *         className.
	 */
	
	
	function classRegExp(className) {
	  return new RegExp('(^|\\s)' + className + '($|\\s)');
	}
	/**
	 * Whether the current DOM interface appears to be real (i.e. not simulated).
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM appears to be real, `false` otherwise.
	 */
	
	
	function isReal() {
	  // Both document and window will never be undefined thanks to `global`.
	  return document__default['default'] === window__default['default'].document;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @param  {Mixed} value
	 *         The value to check.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a DOM element, `false` otherwise.
	 */
	
	function isEl(value) {
	  return isObject(value) && value.nodeType === 1;
	}
	/**
	 * Determines if the current DOM is embedded in an iframe.
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM is embedded in an iframe, `false`
	 *         otherwise.
	 */
	
	function isInFrame() {
	  // We need a try/catch here because Safari will throw errors when attempting
	  // to get either `parent` or `self`
	  try {
	    return window__default['default'].parent !== window__default['default'].self;
	  } catch (x) {
	    return true;
	  }
	}
	/**
	 * Creates functions to query the DOM using a given method.
	 *
	 * @private
	 * @param   {string} method
	 *          The method to create the query with.
	 *
	 * @return  {Function}
	 *          The query method
	 */
	
	function createQuerier(method) {
	  return function (selector, context) {
	    if (!isNonBlankString(selector)) {
	      return document__default['default'][method](null);
	    }
	
	    if (isNonBlankString(context)) {
	      context = document__default['default'].querySelector(context);
	    }
	
	    var ctx = isEl(context) ? context : document__default['default'];
	    return ctx[method] && ctx[method](selector);
	  };
	}
	/**
	 * Creates an element and applies properties, attributes, and inserts content.
	 *
	 * @param  {string} [tagName='div']
	 *         Name of tag to be created.
	 *
	 * @param  {Object} [properties={}]
	 *         Element properties to be applied.
	 *
	 * @param  {Object} [attributes={}]
	 *         Element attributes to be applied.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor object.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	
	function createEl(tagName, properties, attributes, content) {
	  if (tagName === void 0) {
	    tagName = 'div';
	  }
	
	  if (properties === void 0) {
	    properties = {};
	  }
	
	  if (attributes === void 0) {
	    attributes = {};
	  }
	
	  var el = document__default['default'].createElement(tagName);
	  Object.getOwnPropertyNames(properties).forEach(function (propName) {
	    var val = properties[propName]; // See #2176
	    // We originally were accepting both properties and attributes in the
	    // same object, but that doesn't work so well.
	
	    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
	      log$1.warn('Setting attributes in the second argument of createEl()\n' + 'has been deprecated. Use the third argument instead.\n' + ("createEl(type, properties, attributes). Attempting to set " + propName + " to " + val + "."));
	      el.setAttribute(propName, val); // Handle textContent since it's not supported everywhere and we have a
	      // method for it.
	    } else if (propName === 'textContent') {
	      textContent(el, val);
	    } else if (el[propName] !== val || propName === 'tabIndex') {
	      el[propName] = val;
	    }
	  });
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    el.setAttribute(attrName, attributes[attrName]);
	  });
	
	  if (content) {
	    appendContent(el, content);
	  }
	
	  return el;
	}
	/**
	 * Injects text into an element, replacing any existing contents entirely.
	 *
	 * @param  {Element} el
	 *         The element to add text content into
	 *
	 * @param  {string} text
	 *         The text content to add.
	 *
	 * @return {Element}
	 *         The element with added text content.
	 */
	
	function textContent(el, text) {
	  if (typeof el.textContent === 'undefined') {
	    el.innerText = text;
	  } else {
	    el.textContent = text;
	  }
	
	  return el;
	}
	/**
	 * Insert an element as the first child node of another
	 *
	 * @param {Element} child
	 *        Element to insert
	 *
	 * @param {Element} parent
	 *        Element to insert child into
	 */
	
	function prependTo(child, parent) {
	  if (parent.firstChild) {
	    parent.insertBefore(child, parent.firstChild);
	  } else {
	    parent.appendChild(child);
	  }
	}
	/**
	 * Check if an element has a class name.
	 *
	 * @param  {Element} element
	 *         Element to check
	 *
	 * @param  {string} classToCheck
	 *         Class name to check for
	 *
	 * @return {boolean}
	 *         Will be `true` if the element has a class, `false` otherwise.
	 *
	 * @throws {Error}
	 *         Throws an error if `classToCheck` has white space.
	 */
	
	function hasClass(element, classToCheck) {
	  throwIfWhitespace(classToCheck);
	
	  if (element.classList) {
	    return element.classList.contains(classToCheck);
	  }
	
	  return classRegExp(classToCheck).test(element.className);
	}
	/**
	 * Add a class name to an element.
	 *
	 * @param  {Element} element
	 *         Element to add class name to.
	 *
	 * @param  {string} classToAdd
	 *         Class name to add.
	 *
	 * @return {Element}
	 *         The DOM element with the added class name.
	 */
	
	function addClass(element, classToAdd) {
	  if (element.classList) {
	    element.classList.add(classToAdd); // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
	    // in the case of classList not being supported.
	  } else if (!hasClass(element, classToAdd)) {
	    element.className = (element.className + ' ' + classToAdd).trim();
	  }
	
	  return element;
	}
	/**
	 * Remove a class name from an element.
	 *
	 * @param  {Element} element
	 *         Element to remove a class name from.
	 *
	 * @param  {string} classToRemove
	 *         Class name to remove
	 *
	 * @return {Element}
	 *         The DOM element with class name removed.
	 */
	
	function removeClass(element, classToRemove) {
	  // Protect in case the player gets disposed
	  if (!element) {
	    log$1.warn("removeClass was called with an element that doesn't exist");
	    return null;
	  }
	
	  if (element.classList) {
	    element.classList.remove(classToRemove);
	  } else {
	    throwIfWhitespace(classToRemove);
	    element.className = element.className.split(/\s+/).filter(function (c) {
	      return c !== classToRemove;
	    }).join(' ');
	  }
	
	  return element;
	}
	/**
	 * The callback definition for toggleClass.
	 *
	 * @callback module:dom~PredicateCallback
	 * @param    {Element} element
	 *           The DOM element of the Component.
	 *
	 * @param    {string} classToToggle
	 *           The `className` that wants to be toggled
	 *
	 * @return   {boolean|undefined}
	 *           If `true` is returned, the `classToToggle` will be added to the
	 *           `element`. If `false`, the `classToToggle` will be removed from
	 *           the `element`. If `undefined`, the callback will be ignored.
	 */
	
	/**
	 * Adds or removes a class name to/from an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @param  {Element} element
	 *         The element to toggle a class name on.
	 *
	 * @param  {string} classToToggle
	 *         The class that should be toggled.
	 *
	 * @param  {boolean|module:dom~PredicateCallback} [predicate]
	 *         See the return value for {@link module:dom~PredicateCallback}
	 *
	 * @return {Element}
	 *         The element with a class that has been toggled.
	 */
	
	function toggleClass(element, classToToggle, predicate) {
	  // This CANNOT use `classList` internally because IE11 does not support the
	  // second parameter to the `classList.toggle()` method! Which is fine because
	  // `classList` will be used by the add/remove functions.
	  var has = hasClass(element, classToToggle);
	
	  if (typeof predicate === 'function') {
	    predicate = predicate(element, classToToggle);
	  }
	
	  if (typeof predicate !== 'boolean') {
	    predicate = !has;
	  } // If the necessary class operation matches the current state of the
	  // element, no action is required.
	
	
	  if (predicate === has) {
	    return;
	  }
	
	  if (predicate) {
	    addClass(element, classToToggle);
	  } else {
	    removeClass(element, classToToggle);
	  }
	
	  return element;
	}
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @param {Element} el
	 *        Element to add attributes to.
	 *
	 * @param {Object} [attributes]
	 *        Attributes to be applied.
	 */
	
	function setAttributes(el, attributes) {
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    var attrValue = attributes[attrName];
	
	    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
	      el.removeAttribute(attrName);
	    } else {
	      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
	    }
	  });
	}
	/**
	 * Get an element's attribute values, as defined on the HTML tag.
	 *
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute.
	 *
	 * @param  {Element} tag
	 *         Element from which to get tag attributes.
	 *
	 * @return {Object}
	 *         All attributes of the element. Boolean attributes will be `true` or
	 *         `false`, others will be strings.
	 */
	
	function getAttributes(tag) {
	  var obj = {}; // known boolean attributes
	  // we can check for matching boolean properties, but not all browsers
	  // and not all tags know about these attributes, so, we still want to check them manually
	
	  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
	
	  if (tag && tag.attributes && tag.attributes.length > 0) {
	    var attrs = tag.attributes;
	
	    for (var i = attrs.length - 1; i >= 0; i--) {
	      var attrName = attrs[i].name;
	      var attrVal = attrs[i].value; // check for known booleans
	      // the matching element property will return a value for typeof
	
	      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
	        // the value of an included boolean attribute is typically an empty
	        // string ('') which would equal false if we just check for a false value.
	        // we also don't want support bad code like autoplay='false'
	        attrVal = attrVal !== null ? true : false;
	      }
	
	      obj[attrName] = attrVal;
	    }
	  }
	
	  return obj;
	}
	/**
	 * Get the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to get the value of.
	 *
	 * @return {string}
	 *         The value of the attribute.
	 */
	
	function getAttribute(el, attribute) {
	  return el.getAttribute(attribute);
	}
	/**
	 * Set the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to set.
	 *
	 * @param {string} value
	 *        Value to set the attribute to.
	 */
	
	function setAttribute(el, attribute, value) {
	  el.setAttribute(attribute, value);
	}
	/**
	 * Remove an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to remove.
	 */
	
	function removeAttribute(el, attribute) {
	  el.removeAttribute(attribute);
	}
	/**
	 * Attempt to block the ability to select text.
	 */
	
	function blockTextSelection() {
	  document__default['default'].body.focus();
	
	  document__default['default'].onselectstart = function () {
	    return false;
	  };
	}
	/**
	 * Turn off text selection blocking.
	 */
	
	function unblockTextSelection() {
	  document__default['default'].onselectstart = function () {
	    return true;
	  };
	}
	/**
	 * Identical to the native `getBoundingClientRect` function, but ensures that
	 * the method is supported at all (it is in all browsers we claim to support)
	 * and that the element is in the DOM before continuing.
	 *
	 * This wrapper function also shims properties which are not provided by some
	 * older browsers (namely, IE8).
	 *
	 * Additionally, some browsers do not support adding properties to a
	 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
	 * properties (except `x` and `y` which are not widely supported). This helps
	 * avoid implementations where keys are non-enumerable.
	 *
	 * @param  {Element} el
	 *         Element whose `ClientRect` we want to calculate.
	 *
	 * @return {Object|undefined}
	 *         Always returns a plain object - or `undefined` if it cannot.
	 */
	
	function getBoundingClientRect(el) {
	  if (el && el.getBoundingClientRect && el.parentNode) {
	    var rect = el.getBoundingClientRect();
	    var result = {};
	    ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(function (k) {
	      if (rect[k] !== undefined) {
	        result[k] = rect[k];
	      }
	    });
	
	    if (!result.height) {
	      result.height = parseFloat(computedStyle(el, 'height'));
	    }
	
	    if (!result.width) {
	      result.width = parseFloat(computedStyle(el, 'width'));
	    }
	
	    return result;
	  }
	}
	/**
	 * Represents the position of a DOM element on the page.
	 *
	 * @typedef  {Object} module:dom~Position
	 *
	 * @property {number} left
	 *           Pixels to the left.
	 *
	 * @property {number} top
	 *           Pixels from the top.
	 */
	
	/**
	 * Get the position of an element in the DOM.
	 *
	 * Uses `getBoundingClientRect` technique from John Resig.
	 *
	 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @param  {Element} el
	 *         Element from which to get offset.
	 *
	 * @return {module:dom~Position}
	 *         The position of the element that was passed in.
	 */
	
	function findPosition(el) {
	  if (!el || el && !el.offsetParent) {
	    return {
	      left: 0,
	      top: 0,
	      width: 0,
	      height: 0
	    };
	  }
	
	  var width = el.offsetWidth;
	  var height = el.offsetHeight;
	  var left = 0;
	  var top = 0;
	
	  while (el.offsetParent && el !== document__default['default'][FullscreenApi.fullscreenElement]) {
	    left += el.offsetLeft;
	    top += el.offsetTop;
	    el = el.offsetParent;
	  }
	
	  return {
	    left: left,
	    top: top,
	    width: width,
	    height: height
	  };
	}
	/**
	 * Represents x and y coordinates for a DOM element or mouse pointer.
	 *
	 * @typedef  {Object} module:dom~Coordinates
	 *
	 * @property {number} x
	 *           x coordinate in pixels
	 *
	 * @property {number} y
	 *           y coordinate in pixels
	 */
	
	/**
	 * Get the pointer position within an element.
	 *
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @param  {Element} el
	 *         Element on which to get the pointer position on.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {module:dom~Coordinates}
	 *         A coordinates object corresponding to the mouse position.
	 *
	 */
	
	function getPointerPosition(el, event) {
	  var translated = {
	    x: 0,
	    y: 0
	  };
	
	  if (IS_IOS) {
	    var item = el;
	
	    while (item && item.nodeName.toLowerCase() !== 'html') {
	      var transform = computedStyle(item, 'transform');
	
	      if (/^matrix/.test(transform)) {
	        var values = transform.slice(7, -1).split(/,\s/).map(Number);
	        translated.x += values[4];
	        translated.y += values[5];
	      } else if (/^matrix3d/.test(transform)) {
	        var _values = transform.slice(9, -1).split(/,\s/).map(Number);
	
	        translated.x += _values[12];
	        translated.y += _values[13];
	      }
	
	      item = item.parentNode;
	    }
	  }
	
	  var position = {};
	  var boxTarget = findPosition(event.target);
	  var box = findPosition(el);
	  var boxW = box.width;
	  var boxH = box.height;
	  var offsetY = event.offsetY - (box.top - boxTarget.top);
	  var offsetX = event.offsetX - (box.left - boxTarget.left);
	
	  if (event.changedTouches) {
	    offsetX = event.changedTouches[0].pageX - box.left;
	    offsetY = event.changedTouches[0].pageY + box.top;
	
	    if (IS_IOS) {
	      offsetX -= translated.x;
	      offsetY -= translated.y;
	    }
	  }
	
	  position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
	  position.x = Math.max(0, Math.min(1, offsetX / boxW));
	  return position;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @param  {Mixed} value
	 *         Check if this value is a text node.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a text node, `false` otherwise.
	 */
	
	function isTextNode(value) {
	  return isObject(value) && value.nodeType === 3;
	}
	/**
	 * Empties the contents of an element.
	 *
	 * @param  {Element} el
	 *         The element to empty children from
	 *
	 * @return {Element}
	 *         The element with no children
	 */
	
	function emptyEl(el) {
	  while (el.firstChild) {
	    el.removeChild(el.firstChild);
	  }
	
	  return el;
	}
	/**
	 * This is a mixed value that describes content to be injected into the DOM
	 * via some method. It can be of the following types:
	 *
	 * Type       | Description
	 * -----------|-------------
	 * `string`   | The value will be normalized into a text node.
	 * `Element`  | The value will be accepted as-is.
	 * `TextNode` | The value will be accepted as-is.
	 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
	 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
	 *
	 * @typedef {string|Element|TextNode|Array|Function} module:dom~ContentDescriptor
	 */
	
	/**
	 * Normalizes content for eventual insertion into the DOM.
	 *
	 * This allows a wide range of content definition methods, but helps protect
	 * from falling into the trap of simply writing to `innerHTML`, which could
	 * be an XSS concern.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Array}
	 *         All of the content that was passed in, normalized to an array of
	 *         elements or text nodes.
	 */
	
	function normalizeContent(content) {
	  // First, invoke content if it is a function. If it produces an array,
	  // that needs to happen before normalization.
	  if (typeof content === 'function') {
	    content = content();
	  } // Next up, normalize to an array, so one or many items can be normalized,
	  // filtered, and returned.
	
	
	  return (Array.isArray(content) ? content : [content]).map(function (value) {
	    // First, invoke value if it is a function to produce a new value,
	    // which will be subsequently normalized to a Node of some kind.
	    if (typeof value === 'function') {
	      value = value();
	    }
	
	    if (isEl(value) || isTextNode(value)) {
	      return value;
	    }
	
	    if (typeof value === 'string' && /\S/.test(value)) {
	      return document__default['default'].createTextNode(value);
	    }
	  }).filter(function (value) {
	    return value;
	  });
	}
	/**
	 * Normalizes and appends content to an element.
	 *
	 * @param  {Element} el
	 *         Element to append normalized content to.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with appended normalized content.
	 */
	
	function appendContent(el, content) {
	  normalizeContent(content).forEach(function (node) {
	    return el.appendChild(node);
	  });
	  return el;
	}
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * @param {Element} el
	 *        Element to insert normalized content into.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with inserted normalized content.
	 */
	
	function insertContent(el, content) {
	  return appendContent(emptyEl(el), content);
	}
	/**
	 * Check if an event was a single left click.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {boolean}
	 *         Will be `true` if a single left click, `false` otherwise.
	 */
	
	function isSingleLeftClick(event) {
	  // Note: if you create something draggable, be sure to
	  // call it on both `mousedown` and `mousemove` event,
	  // otherwise `mousedown` should be enough for a button
	  if (event.button === undefined && event.buttons === undefined) {
	    // Why do we need `buttons` ?
	    // Because, middle mouse sometimes have this:
	    // e.button === 0 and e.buttons === 4
	    // Furthermore, we want to prevent combination click, something like
	    // HOLD middlemouse then left click, that would be
	    // e.button === 0, e.buttons === 5
	    // just `button` is not gonna work
	    // Alright, then what this block does ?
	    // this is for chrome `simulate mobile devices`
	    // I want to support this as well
	    return true;
	  }
	
	  if (event.button === 0 && event.buttons === undefined) {
	    // Touch screen, sometimes on some specific device, `buttons`
	    // doesn't have anything (safari on ios, blackberry...)
	    return true;
	  } // `mouseup` event on a single left click has
	  // `button` and `buttons` equal to 0
	
	
	  if (event.type === 'mouseup' && event.button === 0 && event.buttons === 0) {
	    return true;
	  }
	
	  if (event.button !== 0 || event.buttons !== 1) {
	    // This is the reason we have those if else block above
	    // if any special case we can catch and let it slide
	    // we do it above, when get to here, this definitely
	    // is-not-left-click
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Finds a single DOM element matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelector`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {Element|null}
	 *         The element that was found or null.
	 */
	
	var $ = createQuerier('querySelector');
	/**
	 * Finds a all DOM elements matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelectorAll`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {NodeList}
	 *         A element list of elements that were found. Will be empty if none
	 *         were found.
	 *
	 */
	
	var $$ = createQuerier('querySelectorAll');
	
	var Dom = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  isReal: isReal,
	  isEl: isEl,
	  isInFrame: isInFrame,
	  createEl: createEl,
	  textContent: textContent,
	  prependTo: prependTo,
	  hasClass: hasClass,
	  addClass: addClass,
	  removeClass: removeClass,
	  toggleClass: toggleClass,
	  setAttributes: setAttributes,
	  getAttributes: getAttributes,
	  getAttribute: getAttribute,
	  setAttribute: setAttribute,
	  removeAttribute: removeAttribute,
	  blockTextSelection: blockTextSelection,
	  unblockTextSelection: unblockTextSelection,
	  getBoundingClientRect: getBoundingClientRect,
	  findPosition: findPosition,
	  getPointerPosition: getPointerPosition,
	  isTextNode: isTextNode,
	  emptyEl: emptyEl,
	  normalizeContent: normalizeContent,
	  appendContent: appendContent,
	  insertContent: insertContent,
	  isSingleLeftClick: isSingleLeftClick,
	  $: $,
	  $$: $$
	});
	
	/**
	 * @file setup.js - Functions for setting up a player without
	 * user interaction based on the data-setup `attribute` of the video tag.
	 *
	 * @module setup
	 */
	var _windowLoaded = false;
	var videojs$1;
	/**
	 * Set up any tags that have a data-setup `attribute` when the player is started.
	 */
	
	var autoSetup = function autoSetup() {
	  if (videojs$1.options.autoSetup === false) {
	    return;
	  }
	
	  var vids = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video'));
	  var audios = Array.prototype.slice.call(document__default['default'].getElementsByTagName('audio'));
	  var divs = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video-js'));
	  var mediaEls = vids.concat(audios, divs); // Check if any media elements exist
	
	  if (mediaEls && mediaEls.length > 0) {
	    for (var i = 0, e = mediaEls.length; i < e; i++) {
	      var mediaEl = mediaEls[i]; // Check if element exists, has getAttribute func.
	
	      if (mediaEl && mediaEl.getAttribute) {
	        // Make sure this player hasn't already been set up.
	        if (mediaEl.player === undefined) {
	          var options = mediaEl.getAttribute('data-setup'); // Check if data-setup attr exists.
	          // We only auto-setup if they've added the data-setup attr.
	
	          if (options !== null) {
	            // Create new video.js instance.
	            videojs$1(mediaEl);
	          }
	        } // If getAttribute isn't defined, we need to wait for the DOM.
	
	      } else {
	        autoSetupTimeout(1);
	        break;
	      }
	    } // No videos were found, so keep looping unless page is finished loading.
	
	  } else if (!_windowLoaded) {
	    autoSetupTimeout(1);
	  }
	};
	/**
	 * Wait until the page is loaded before running autoSetup. This will be called in
	 * autoSetup if `hasLoaded` returns false.
	 *
	 * @param {number} wait
	 *        How long to wait in ms
	 *
	 * @param {module:videojs} [vjs]
	 *        The videojs library function
	 */
	
	
	function autoSetupTimeout(wait, vjs) {
	  // Protect against breakage in non-browser environments
	  if (!isReal()) {
	    return;
	  }
	
	  if (vjs) {
	    videojs$1 = vjs;
	  }
	
	  window__default['default'].setTimeout(autoSetup, wait);
	}
	/**
	 * Used to set the internal tracking of window loaded state to true.
	 *
	 * @private
	 */
	
	
	function setWindowLoaded() {
	  _windowLoaded = true;
	  window__default['default'].removeEventListener('load', setWindowLoaded);
	}
	
	if (isReal()) {
	  if (document__default['default'].readyState === 'complete') {
	    setWindowLoaded();
	  } else {
	    /**
	     * Listen for the load event on window, and set _windowLoaded to true.
	     *
	     * We use a standard event listener here to avoid incrementing the GUID
	     * before any players are created.
	     *
	     * @listens load
	     */
	    window__default['default'].addEventListener('load', setWindowLoaded);
	  }
	}
	
	/**
	 * @file stylesheet.js
	 * @module stylesheet
	 */
	/**
	 * Create a DOM syle element given a className for it.
	 *
	 * @param {string} className
	 *        The className to add to the created style element.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	var createStyleElement = function createStyleElement(className) {
	  var style = document__default['default'].createElement('style');
	  style.className = className;
	  return style;
	};
	/**
	 * Add text to a DOM element.
	 *
	 * @param {Element} el
	 *        The Element to add text content to.
	 *
	 * @param {string} content
	 *        The text to add to the element.
	 */
	
	var setTextContent = function setTextContent(el, content) {
	  if (el.styleSheet) {
	    el.styleSheet.cssText = content;
	  } else {
	    el.textContent = content;
	  }
	};
	
	/**
	 * @file guid.js
	 * @module guid
	 */
	// Default value for GUIDs. This allows us to reset the GUID counter in tests.
	//
	// The initial GUID is 3 because some users have come to rely on the first
	// default player ID ending up as `vjs_video_3`.
	//
	// See: https://github.com/videojs/video.js/pull/6216
	var _initialGuid = 3;
	/**
	 * Unique ID for an element or function
	 *
	 * @type {Number}
	 */
	
	var _guid = _initialGuid;
	/**
	 * Get a unique auto-incrementing ID by number that has not been returned before.
	 *
	 * @return {number}
	 *         A new unique ID.
	 */
	
	function newGUID() {
	  return _guid++;
	}
	
	/**
	 * @file dom-data.js
	 * @module dom-data
	 */
	var FakeWeakMap;
	
	if (!window__default['default'].WeakMap) {
	  FakeWeakMap = /*#__PURE__*/function () {
	    function FakeWeakMap() {
	      this.vdata = 'vdata' + Math.floor(window__default['default'].performance && window__default['default'].performance.now() || Date.now());
	      this.data = {};
	    }
	
	    var _proto = FakeWeakMap.prototype;
	
	    _proto.set = function set(key, value) {
	      var access = key[this.vdata] || newGUID();
	
	      if (!key[this.vdata]) {
	        key[this.vdata] = access;
	      }
	
	      this.data[access] = value;
	      return this;
	    };
	
	    _proto.get = function get(key) {
	      var access = key[this.vdata]; // we have data, return it
	
	      if (access) {
	        return this.data[access];
	      } // we don't have data, return nothing.
	      // return undefined explicitly as that's the contract for this method
	
	
	      log$1('We have no data for this element', key);
	      return undefined;
	    };
	
	    _proto.has = function has(key) {
	      var access = key[this.vdata];
	      return access in this.data;
	    };
	
	    _proto["delete"] = function _delete(key) {
	      var access = key[this.vdata];
	
	      if (access) {
	        delete this.data[access];
	        delete key[this.vdata];
	      }
	    };
	
	    return FakeWeakMap;
	  }();
	}
	/**
	 * Element Data Store.
	 *
	 * Allows for binding data to an element without putting it directly on the
	 * element. Ex. Event listeners are stored here.
	 * (also from jsninja.com, slightly modified and updated for closure compiler)
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	var DomData = window__default['default'].WeakMap ? new WeakMap() : new FakeWeakMap();
	
	/**
	 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	 * robust as jquery's, so there's probably some differences.
	 *
	 * @file events.js
	 * @module events
	 */
	/**
	 * Clean up the listener cache and dispatchers
	 *
	 * @param {Element|Object} elem
	 *        Element to clean up
	 *
	 * @param {string} type
	 *        Type of event to clean up
	 */
	
	function _cleanUpEvents(elem, type) {
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // Remove the events of a particular type if there are none left
	
	  if (data.handlers[type].length === 0) {
	    delete data.handlers[type]; // data.handlers[type] = null;
	    // Setting to null was causing an error with data.handlers
	    // Remove the meta-handler from the element
	
	    if (elem.removeEventListener) {
	      elem.removeEventListener(type, data.dispatcher, false);
	    } else if (elem.detachEvent) {
	      elem.detachEvent('on' + type, data.dispatcher);
	    }
	  } // Remove the events object if there are no types left
	
	
	  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
	    delete data.handlers;
	    delete data.dispatcher;
	    delete data.disabled;
	  } // Finally remove the element data if there is no data left
	
	
	  if (Object.getOwnPropertyNames(data).length === 0) {
	    DomData["delete"](elem);
	  }
	}
	/**
	 * Loops through an array of event types and calls the requested method for each type.
	 *
	 * @param {Function} fn
	 *        The event method we want to use.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} callback
	 *        Event listener.
	 */
	
	
	function _handleMultipleEvents(fn, elem, types, callback) {
	  types.forEach(function (type) {
	    // Call the event method for each one of the types
	    fn(elem, type, callback);
	  });
	}
	/**
	 * Fix a native event to have standard property values
	 *
	 * @param {Object} event
	 *        Event object to fix.
	 *
	 * @return {Object}
	 *         Fixed event object.
	 */
	
	
	function fixEvent(event) {
	  if (event.fixed_) {
	    return event;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function returnFalse() {
	    return false;
	  } // Test if fixing up is needed
	  // Used to check if !event.stopPropagation instead of isPropagationStopped
	  // But native events return true for stopPropagation, but don't have
	  // other expected methods like isPropagationStopped. Seems to be a problem
	  // with the Javascript Ninja code. So we're just overriding all events now.
	
	
	  if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
	    var old = event || window__default['default'].event;
	    event = {}; // Clone the old object so that we can modify the values event = {};
	    // IE8 Doesn't like when you mess with native event properties
	    // Firefox returns false for event.hasOwnProperty('type') and other props
	    //  which makes copying more difficult.
	    // TODO: Probably best to create a whitelist of event props
	
	    for (var key in old) {
	      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
	      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
	      // and webkitMovementX/Y
	      // Lighthouse complains if Event.path is copied
	      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY' && key !== 'path') {
	        // Chrome 32+ warns if you try to copy deprecated returnValue, but
	        // we still want to if preventDefault isn't supported (IE8).
	        if (!(key === 'returnValue' && old.preventDefault)) {
	          event[key] = old[key];
	        }
	      }
	    } // The event occurred on this element
	
	
	    if (!event.target) {
	      event.target = event.srcElement || document__default['default'];
	    } // Handle which other element the event is related to
	
	
	    if (!event.relatedTarget) {
	      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
	    } // Stop the default browser action
	
	
	    event.preventDefault = function () {
	      if (old.preventDefault) {
	        old.preventDefault();
	      }
	
	      event.returnValue = false;
	      old.returnValue = false;
	      event.defaultPrevented = true;
	    };
	
	    event.defaultPrevented = false; // Stop the event from bubbling
	
	    event.stopPropagation = function () {
	      if (old.stopPropagation) {
	        old.stopPropagation();
	      }
	
	      event.cancelBubble = true;
	      old.cancelBubble = true;
	      event.isPropagationStopped = returnTrue;
	    };
	
	    event.isPropagationStopped = returnFalse; // Stop the event from bubbling and executing other handlers
	
	    event.stopImmediatePropagation = function () {
	      if (old.stopImmediatePropagation) {
	        old.stopImmediatePropagation();
	      }
	
	      event.isImmediatePropagationStopped = returnTrue;
	      event.stopPropagation();
	    };
	
	    event.isImmediatePropagationStopped = returnFalse; // Handle mouse position
	
	    if (event.clientX !== null && event.clientX !== undefined) {
	      var doc = document__default['default'].documentElement;
	      var body = document__default['default'].body;
	      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    } // Handle key presses
	
	
	    event.which = event.charCode || event.keyCode; // Fix button for mouse clicks:
	    // 0 == left; 1 == middle; 2 == right
	
	    if (event.button !== null && event.button !== undefined) {
	      // The following is disabled because it does not pass videojs-standard
	      // and... yikes.
	
	      /* eslint-disable */
	      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
	      /* eslint-enable */
	    }
	  }
	
	  event.fixed_ = true; // Returns fixed-up instance
	
	  return event;
	}
	/**
	 * Whether passive event listeners are supported
	 */
	
	var _supportsPassive;
	
	var supportsPassive = function supportsPassive() {
	  if (typeof _supportsPassive !== 'boolean') {
	    _supportsPassive = false;
	
	    try {
	      var opts = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          _supportsPassive = true;
	        }
	      });
	      window__default['default'].addEventListener('test', null, opts);
	      window__default['default'].removeEventListener('test', null, opts);
	    } catch (e) {// disregard
	    }
	  }
	
	  return _supportsPassive;
	};
	/**
	 * Touch events Chrome expects to be passive
	 */
	
	
	var passiveEvents = ['touchstart', 'touchmove'];
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string|string[]} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        Event listener.
	 */
	
	function on(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(on, elem, type, fn);
	  }
	
	  if (!DomData.has(elem)) {
	    DomData.set(elem, {});
	  }
	
	  var data = DomData.get(elem); // We need a place to store all our handler data
	
	  if (!data.handlers) {
	    data.handlers = {};
	  }
	
	  if (!data.handlers[type]) {
	    data.handlers[type] = [];
	  }
	
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  }
	
	  data.handlers[type].push(fn);
	
	  if (!data.dispatcher) {
	    data.disabled = false;
	
	    data.dispatcher = function (event, hash) {
	      if (data.disabled) {
	        return;
	      }
	
	      event = fixEvent(event);
	      var handlers = data.handlers[event.type];
	
	      if (handlers) {
	        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
	        var handlersCopy = handlers.slice(0);
	
	        for (var m = 0, n = handlersCopy.length; m < n; m++) {
	          if (event.isImmediatePropagationStopped()) {
	            break;
	          } else {
	            try {
	              handlersCopy[m].call(elem, event, hash);
	            } catch (e) {
	              log$1.error(e);
	            }
	          }
	        }
	      }
	    };
	  }
	
	  if (data.handlers[type].length === 1) {
	    if (elem.addEventListener) {
	      var options = false;
	
	      if (supportsPassive() && passiveEvents.indexOf(type) > -1) {
	        options = {
	          passive: true
	        };
	      }
	
	      elem.addEventListener(type, data.dispatcher, options);
	    } else if (elem.attachEvent) {
	      elem.attachEvent('on' + type, data.dispatcher);
	    }
	  }
	}
	/**
	 * Removes event listeners from an element
	 *
	 * @param {Element|Object} elem
	 *        Object to remove listeners from.
	 *
	 * @param {string|string[]} [type]
	 *        Type of listener to remove. Don't include to remove all events from element.
	 *
	 * @param {EventTarget~EventListener} [fn]
	 *        Specific listener to remove. Don't include to remove listeners for an event
	 *        type.
	 */
	
	function off(elem, type, fn) {
	  // Don't want to add a cache object through getElData if not needed
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // If no events exist, nothing to unbind
	
	  if (!data.handlers) {
	    return;
	  }
	
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(off, elem, type, fn);
	  } // Utility function
	
	
	  var removeType = function removeType(el, t) {
	    data.handlers[t] = [];
	
	    _cleanUpEvents(el, t);
	  }; // Are we removing all bound events?
	
	
	  if (type === undefined) {
	    for (var t in data.handlers) {
	      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) {
	        removeType(elem, t);
	      }
	    }
	
	    return;
	  }
	
	  var handlers = data.handlers[type]; // If no handlers exist, nothing to unbind
	
	  if (!handlers) {
	    return;
	  } // If no listener was provided, remove all listeners for type
	
	
	  if (!fn) {
	    removeType(elem, type);
	    return;
	  } // We're only removing a single handler
	
	
	  if (fn.guid) {
	    for (var n = 0; n < handlers.length; n++) {
	      if (handlers[n].guid === fn.guid) {
	        handlers.splice(n--, 1);
	      }
	    }
	  }
	
	  _cleanUpEvents(elem, type);
	}
	/**
	 * Trigger an event for an element
	 *
	 * @param {Element|Object} elem
	 *        Element to trigger an event on
	 *
	 * @param {EventTarget~Event|string} event
	 *        A string (the type) or an event object with a type attribute
	 *
	 * @param {Object} [hash]
	 *        data hash to pass along with the event
	 *
	 * @return {boolean|undefined}
	 *         Returns the opposite of `defaultPrevented` if default was
	 *         prevented. Otherwise, returns `undefined`
	 */
	
	function trigger(elem, event, hash) {
	  // Fetches element data and a reference to the parent (for bubbling).
	  // Don't want to add a data object to cache for every parent,
	  // so checking hasElData first.
	  var elemData = DomData.has(elem) ? DomData.get(elem) : {};
	  var parent = elem.parentNode || elem.ownerDocument; // type = event.type || event,
	  // handler;
	  // If an event name was passed as a string, creates an event out of it
	
	  if (typeof event === 'string') {
	    event = {
	      type: event,
	      target: elem
	    };
	  } else if (!event.target) {
	    event.target = elem;
	  } // Normalizes the event properties.
	
	
	  event = fixEvent(event); // If the passed element has a dispatcher, executes the established handlers.
	
	  if (elemData.dispatcher) {
	    elemData.dispatcher.call(elem, event, hash);
	  } // Unless explicitly stopped or the event does not bubble (e.g. media events)
	  // recursively calls this function to bubble the event up the DOM.
	
	
	  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
	    trigger.call(null, parent, event, hash); // If at the top of the DOM, triggers the default action unless disabled.
	  } else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
	    if (!DomData.has(event.target)) {
	      DomData.set(event.target, {});
	    }
	
	    var targetData = DomData.get(event.target); // Checks if the target has a default action for this event.
	
	    if (event.target[event.type]) {
	      // Temporarily disables event dispatching on the target as we have already executed the handler.
	      targetData.disabled = true; // Executes the default action.
	
	      if (typeof event.target[event.type] === 'function') {
	        event.target[event.type]();
	      } // Re-enables event dispatching.
	
	
	      targetData.disabled = false;
	    }
	  } // Inform the triggerer if the default was prevented by returning false
	
	
	  return !event.defaultPrevented;
	}
	/**
	 * Trigger a listener only once for an event.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function one(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(one, elem, type, fn);
	  }
	
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID();
	  on(elem, type, func);
	}
	/**
	 * Trigger a listener only once and then turn if off for all
	 * configured events
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function any(elem, type, fn) {
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID(); // multiple ons, but one off for everything
	
	  on(elem, type, func);
	}
	
	var Events = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  fixEvent: fixEvent,
	  on: on,
	  off: off,
	  trigger: trigger,
	  one: one,
	  any: any
	});
	
	/**
	 * @file fn.js
	 * @module fn
	 */
	var UPDATE_REFRESH_INTERVAL = 30;
	/**
	 * Bind (a.k.a proxy or context). A simple method for changing the context of
	 * a function.
	 *
	 * It also stores a unique id on the function so it can be easily removed from
	 * events.
	 *
	 * @function
	 * @param    {Mixed} context
	 *           The object to bind as scope.
	 *
	 * @param    {Function} fn
	 *           The function to be bound to a scope.
	 *
	 * @param    {number} [uid]
	 *           An optional unique ID for the function to be set
	 *
	 * @return   {Function}
	 *           The new function that will be bound into the context given
	 */
	
	var bind = function bind(context, fn, uid) {
	  // Make sure the function has a unique ID
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  } // Create the new function that changes the context
	
	
	  var bound = fn.bind(context); // Allow for the ability to individualize this function
	  // Needed in the case where multiple objects might share the same prototype
	  // IF both items add an event listener with the same function, then you try to remove just one
	  // it will remove both because they both have the same guid.
	  // when using this, you need to use the bind method when you remove the listener as well.
	  // currently used in text tracks
	
	  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
	  return bound;
	};
	/**
	 * Wraps the given function, `fn`, with a new function that only invokes `fn`
	 * at most once per every `wait` milliseconds.
	 *
	 * @function
	 * @param    {Function} fn
	 *           The function to be throttled.
	 *
	 * @param    {number}   wait
	 *           The number of milliseconds by which to throttle.
	 *
	 * @return   {Function}
	 */
	
	var throttle = function throttle(fn, wait) {
	  var last = window__default['default'].performance.now();
	
	  var throttled = function throttled() {
	    var now = window__default['default'].performance.now();
	
	    if (now - last >= wait) {
	      fn.apply(void 0, arguments);
	      last = now;
	    }
	  };
	
	  return throttled;
	};
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked.
	 *
	 * Inspired by lodash and underscore implementations.
	 *
	 * @function
	 * @param    {Function} func
	 *           The function to wrap with debounce behavior.
	 *
	 * @param    {number} wait
	 *           The number of milliseconds to wait after the last invocation.
	 *
	 * @param    {boolean} [immediate]
	 *           Whether or not to invoke the function immediately upon creation.
	 *
	 * @param    {Object} [context=window]
	 *           The "context" in which the debounced function should debounce. For
	 *           example, if this function should be tied to a Video.js player,
	 *           the player can be passed here. Alternatively, defaults to the
	 *           global `window` object.
	 *
	 * @return   {Function}
	 *           A debounced function.
	 */
	
	var debounce = function debounce(func, wait, immediate, context) {
	  if (context === void 0) {
	    context = window__default['default'];
	  }
	
	  var timeout;
	
	  var cancel = function cancel() {
	    context.clearTimeout(timeout);
	    timeout = null;
	  };
	  /* eslint-disable consistent-this */
	
	
	  var debounced = function debounced() {
	    var self = this;
	    var args = arguments;
	
	    var _later = function later() {
	      timeout = null;
	      _later = null;
	
	      if (!immediate) {
	        func.apply(self, args);
	      }
	    };
	
	    if (!timeout && immediate) {
	      func.apply(self, args);
	    }
	
	    context.clearTimeout(timeout);
	    timeout = context.setTimeout(_later, wait);
	  };
	  /* eslint-enable consistent-this */
	
	
	  debounced.cancel = cancel;
	  return debounced;
	};
	
	/**
	 * @file src/js/event-target.js
	 */
	/**
	 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	 * adds shorthand functions that wrap around lengthy functions. For example:
	 * the `on` function is a wrapper around `addEventListener`.
	 *
	 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	 * @class EventTarget
	 */
	
	var EventTarget$2 = function EventTarget() {};
	/**
	 * A Custom DOM event.
	 *
	 * @typedef {Object} EventTarget~Event
	 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	 */
	
	/**
	 * All event listeners should follow the following format.
	 *
	 * @callback EventTarget~EventListener
	 * @this {EventTarget}
	 *
	 * @param {EventTarget~Event} event
	 *        the event that triggered this function
	 *
	 * @param {Object} [hash]
	 *        hash of data sent during the event
	 */
	
	/**
	 * An object containing event names as keys and booleans as values.
	 *
	 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	 *         will have extra functionality. See that function for more information.
	 *
	 * @property EventTarget.prototype.allowedEvents_
	 * @private
	 */
	
	
	EventTarget$2.prototype.allowedEvents_ = {};
	/**
	 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
	 * function that will get called when an event with a certain name gets triggered.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to call with `EventTarget`s
	 */
	
	EventTarget$2.prototype.on = function (type, fn) {
	  // Remove the addEventListener alias before calling Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  on(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#on}
	 */
	
	
	EventTarget$2.prototype.addEventListener = EventTarget$2.prototype.on;
	/**
	 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
	 * This makes it so that the `event listener` will no longer get called when the
	 * named event happens.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to remove.
	 */
	
	EventTarget$2.prototype.off = function (type, fn) {
	  off(this, type, fn);
	};
	/**
	 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#off}
	 */
	
	
	EventTarget$2.prototype.removeEventListener = EventTarget$2.prototype.off;
	/**
	 * This function will add an `event listener` that gets triggered only once. After the
	 * first trigger it will get removed. This is like adding an `event listener`
	 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to be called once for each event name.
	 */
	
	EventTarget$2.prototype.one = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  one(this, type, fn);
	  this.addEventListener = ael;
	};
	
	EventTarget$2.prototype.any = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  any(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * This function causes an event to happen. This will then cause any `event listeners`
	 * that are waiting for that event, to get called. If there are no `event listeners`
	 * for an event then nothing will happen.
	 *
	 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
	 * Trigger will also call the `on` + `uppercaseEventName` function.
	 *
	 * Example:
	 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
	 * `onClick` if it exists.
	 *
	 * @param {string|EventTarget~Event|Object} event
	 *        The name of the event, an `Event`, or an object with a key of type set to
	 *        an event name.
	 */
	
	
	EventTarget$2.prototype.trigger = function (event) {
	  var type = event.type || event; // deprecation
	  // In a future version we should default target to `this`
	  // similar to how we default the target to `elem` in
	  // `Events.trigger`. Right now the default `target` will be
	  // `document` due to the `Event.fixEvent` call.
	
	  if (typeof event === 'string') {
	    event = {
	      type: type
	    };
	  }
	
	  event = fixEvent(event);
	
	  if (this.allowedEvents_[type] && this['on' + type]) {
	    this['on' + type](event);
	  }
	
	  trigger(this, event);
	};
	/**
	 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#trigger}
	 */
	
	
	EventTarget$2.prototype.dispatchEvent = EventTarget$2.prototype.trigger;
	var EVENT_MAP;
	
	EventTarget$2.prototype.queueTrigger = function (event) {
	  var _this = this;
	
	  // only set up EVENT_MAP if it'll be used
	  if (!EVENT_MAP) {
	    EVENT_MAP = new Map();
	  }
	
	  var type = event.type || event;
	  var map = EVENT_MAP.get(this);
	
	  if (!map) {
	    map = new Map();
	    EVENT_MAP.set(this, map);
	  }
	
	  var oldTimeout = map.get(type);
	  map["delete"](type);
	  window__default['default'].clearTimeout(oldTimeout);
	  var timeout = window__default['default'].setTimeout(function () {
	    map["delete"](type); // if we cleared out all timeouts for the current target, delete its map
	
	    if (map.size === 0) {
	      map = null;
	      EVENT_MAP["delete"](_this);
	    }
	
	    _this.trigger(event);
	  }, 0);
	  map.set(type, timeout);
	};
	
	/**
	 * @file mixins/evented.js
	 * @module evented
	 */
	
	var objName = function objName(obj) {
	  if (typeof obj.name === 'function') {
	    return obj.name();
	  }
	
	  if (typeof obj.name === 'string') {
	    return obj.name;
	  }
	
	  if (obj.name_) {
	    return obj.name_;
	  }
	
	  if (obj.constructor && obj.constructor.name) {
	    return obj.constructor.name;
	  }
	
	  return typeof obj;
	};
	/**
	 * Returns whether or not an object has had the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to test.
	 *
	 * @return {boolean}
	 *         Whether or not the object appears to be evented.
	 */
	
	
	var isEvented = function isEvented(object) {
	  return object instanceof EventTarget$2 || !!object.eventBusEl_ && ['on', 'one', 'off', 'trigger'].every(function (k) {
	    return typeof object[k] === 'function';
	  });
	};
	/**
	 * Adds a callback to run after the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to Add
	 * @param  {Function} callback
	 *         The callback to run.
	 */
	
	
	var addEventedCallback = function addEventedCallback(target, callback) {
	  if (isEvented(target)) {
	    callback();
	  } else {
	    if (!target.eventedCallbacks) {
	      target.eventedCallbacks = [];
	    }
	
	    target.eventedCallbacks.push(callback);
	  }
	};
	/**
	 * Whether a value is a valid event type - non-empty string or array.
	 *
	 * @private
	 * @param  {string|Array} type
	 *         The type value to test.
	 *
	 * @return {boolean}
	 *         Whether or not the type is a valid event type.
	 */
	
	
	var isValidEventType = function isValidEventType(type) {
	  return (// The regex here verifies that the `type` contains at least one non-
	    // whitespace character.
	    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length
	  );
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the target does not appear to be a valid event target.
	 *
	 * @param  {Object} target
	 *         The object to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateTarget = function validateTarget(target, obj, fnName) {
	  if (!target || !target.nodeName && !isEvented(target)) {
	    throw new Error("Invalid target for " + objName(obj) + "#" + fnName + "; must be a DOM node or evented object.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the type does not appear to be a valid event type.
	 *
	 * @param  {string|Array} type
	 *         The type to test.
	 *
	 * @param  {Object} obj
	*         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateEventType = function validateEventType(type, obj, fnName) {
	  if (!isValidEventType(type)) {
	    throw new Error("Invalid event type for " + objName(obj) + "#" + fnName + "; must be a non-empty string or array.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid listener. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the listener is not a function.
	 *
	 * @param  {Function} listener
	 *         The listener to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateListener = function validateListener(listener, obj, fnName) {
	  if (typeof listener !== 'function') {
	    throw new Error("Invalid listener for " + objName(obj) + "#" + fnName + "; must be a function.");
	  }
	};
	/**
	 * Takes an array of arguments given to `on()` or `one()`, validates them, and
	 * normalizes them into an object.
	 *
	 * @private
	 * @param  {Object} self
	 *         The evented object on which `on()` or `one()` was called. This
	 *         object will be bound as the `this` value for the listener.
	 *
	 * @param  {Array} args
	 *         An array of arguments passed to `on()` or `one()`.
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 *
	 * @return {Object}
	 *         An object containing useful values for `on()` or `one()` calls.
	 */
	
	
	var normalizeListenArgs = function normalizeListenArgs(self, args, fnName) {
	  // If the number of arguments is less than 3, the target is always the
	  // evented object itself.
	  var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
	  var target;
	  var type;
	  var listener;
	
	  if (isTargetingSelf) {
	    target = self.eventBusEl_; // Deal with cases where we got 3 arguments, but we are still listening to
	    // the evented object itself.
	
	    if (args.length >= 3) {
	      args.shift();
	    }
	
	    type = args[0];
	    listener = args[1];
	  } else {
	    target = args[0];
	    type = args[1];
	    listener = args[2];
	  }
	
	  validateTarget(target, self, fnName);
	  validateEventType(type, self, fnName);
	  validateListener(listener, self, fnName);
	  listener = bind(self, listener);
	  return {
	    isTargetingSelf: isTargetingSelf,
	    target: target,
	    type: type,
	    listener: listener
	  };
	};
	/**
	 * Adds the listener to the event type(s) on the target, normalizing for
	 * the type of target.
	 *
	 * @private
	 * @param  {Element|Object} target
	 *         A DOM node or evented object.
	 *
	 * @param  {string} method
	 *         The event binding method to use ("on" or "one").
	 *
	 * @param  {string|Array} type
	 *         One or more event type(s).
	 *
	 * @param  {Function} listener
	 *         A listener function.
	 */
	
	
	var listen = function listen(target, method, type, listener) {
	  validateTarget(target, target, method);
	
	  if (target.nodeName) {
	    Events[method](target, type, listener);
	  } else {
	    target[method](type, listener);
	  }
	};
	/**
	 * Contains methods that provide event capabilities to an object which is passed
	 * to {@link module:evented|evented}.
	 *
	 * @mixin EventedMixin
	 */
	
	
	var EventedMixin = {
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  on: function on() {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _normalizeListenArgs = normalizeListenArgs(this, args, 'on'),
	        isTargetingSelf = _normalizeListenArgs.isTargetingSelf,
	        target = _normalizeListenArgs.target,
	        type = _normalizeListenArgs.type,
	        listener = _normalizeListenArgs.listener;
	
	    listen(target, 'on', type, listener); // If this object is listening to another evented object.
	
	    if (!isTargetingSelf) {
	      // If this object is disposed, remove the listener.
	      var removeListenerOnDispose = function removeListenerOnDispose() {
	        return _this.off(target, type, listener);
	      }; // Use the same function ID as the listener so we can remove it later it
	      // using the ID of the original listener.
	
	
	      removeListenerOnDispose.guid = listener.guid; // Add a listener to the target's dispose event as well. This ensures
	      // that if the target is disposed BEFORE this object, we remove the
	      // removal listener that was just added. Otherwise, we create a memory leak.
	
	      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
	        return _this.off('dispose', removeListenerOnDispose);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      removeRemoverOnTargetDispose.guid = listener.guid;
	      listen(this, 'on', 'dispose', removeListenerOnDispose);
	      listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will be called once per event and then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  one: function one() {
	    var _this2 = this;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _normalizeListenArgs2 = normalizeListenArgs(this, args, 'one'),
	        isTargetingSelf = _normalizeListenArgs2.isTargetingSelf,
	        target = _normalizeListenArgs2.target,
	        type = _normalizeListenArgs2.type,
	        listener = _normalizeListenArgs2.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'one', type, listener); // Targeting another evented object.
	    } else {
	      // TODO: This wrapper is incorrect! It should only
	      //       remove the wrapper for the event type that called it.
	      //       Instead all listners are removed on the first trigger!
	      //       see https://github.com/videojs/video.js/issues/5962
	      var wrapper = function wrapper() {
	        _this2.off(target, type, wrapper);
	
	        for (var _len3 = arguments.length, largs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          largs[_key3] = arguments[_key3];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'one', type, wrapper);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will only be called once for the first event that is triggered
	   * then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  any: function any() {
	    var _this3 = this;
	
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    var _normalizeListenArgs3 = normalizeListenArgs(this, args, 'any'),
	        isTargetingSelf = _normalizeListenArgs3.isTargetingSelf,
	        target = _normalizeListenArgs3.target,
	        type = _normalizeListenArgs3.type,
	        listener = _normalizeListenArgs3.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'any', type, listener); // Targeting another evented object.
	    } else {
	      var wrapper = function wrapper() {
	        _this3.off(target, type, wrapper);
	
	        for (var _len5 = arguments.length, largs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          largs[_key5] = arguments[_key5];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'any', type, wrapper);
	    }
	  },
	
	  /**
	   * Removes listener(s) from event(s) on an evented object.
	   *
	   * @param  {string|Array|Element|Object} [targetOrType]
	   *         If this is a string or array, it represents the event type(s).
	   *
	   *         Another evented object can be passed here instead, in which case
	   *         ALL 3 arguments are _required_.
	   *
	   * @param  {string|Array|Function} [typeOrListener]
	   *         If the first argument was a string or array, this may be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function; otherwise, _all_ listeners bound to the
	   *         event type(s) will be removed.
	   */
	  off: function off$1(targetOrType, typeOrListener, listener) {
	    // Targeting this evented object.
	    if (!targetOrType || isValidEventType(targetOrType)) {
	      off(this.eventBusEl_, targetOrType, typeOrListener); // Targeting another evented object.
	    } else {
	      var target = targetOrType;
	      var type = typeOrListener; // Fail fast and in a meaningful way!
	
	      validateTarget(target, this, 'off');
	      validateEventType(type, this, 'off');
	      validateListener(listener, this, 'off'); // Ensure there's at least a guid, even if the function hasn't been used
	
	      listener = bind(this, listener); // Remove the dispose listener on this evented object, which was given
	      // the same guid as the event listener in on().
	
	      this.off('dispose', listener);
	
	      if (target.nodeName) {
	        off(target, type, listener);
	        off(target, 'dispose', listener);
	      } else if (isEvented(target)) {
	        target.off(type, listener);
	        target.off('dispose', listener);
	      }
	    }
	  },
	
	  /**
	   * Fire an event on this evented object, causing its listeners to be called.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash]
	   *          An additional object to pass along to listeners.
	   *
	   * @return {boolean}
	   *          Whether or not the default behavior was prevented.
	   */
	  trigger: function trigger$1(event, hash) {
	    validateTarget(this.eventBusEl_, this, 'trigger');
	    var type = event && typeof event !== 'string' ? event.type : event;
	
	    if (!isValidEventType(type)) {
	      var error = "Invalid event type for " + objName(this) + "#trigger; " + 'must be a non-empty string or object with a type key that has a non-empty value.';
	
	      if (event) {
	        (this.log || log$1).error(error);
	      } else {
	        throw new Error(error);
	      }
	    }
	
	    return trigger(this.eventBusEl_, event, hash);
	  }
	};
	/**
	 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
	 *
	 * @param  {Object} target
	 *         The object to which to add event methods.
	 *
	 * @param  {Object} [options={}]
	 *         Options for customizing the mixin behavior.
	 *
	 * @param  {string} [options.eventBusKey]
	 *         By default, adds a `eventBusEl_` DOM element to the target object,
	 *         which is used as an event bus. If the target object already has a
	 *         DOM element that should be used, pass its key here.
	 *
	 * @return {Object}
	 *         The target object.
	 */
	
	function evented(target, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      eventBusKey = _options.eventBusKey; // Set or create the eventBusEl_.
	
	  if (eventBusKey) {
	    if (!target[eventBusKey].nodeName) {
	      throw new Error("The eventBusKey \"" + eventBusKey + "\" does not refer to an element.");
	    }
	
	    target.eventBusEl_ = target[eventBusKey];
	  } else {
	    target.eventBusEl_ = createEl('span', {
	      className: 'vjs-event-bus'
	    });
	  }
	
	  assign(target, EventedMixin);
	
	  if (target.eventedCallbacks) {
	    target.eventedCallbacks.forEach(function (callback) {
	      callback();
	    });
	  } // When any evented object is disposed, it removes all its listeners.
	
	
	  target.on('dispose', function () {
	    target.off();
	    [target, target.el_, target.eventBusEl_].forEach(function (val) {
	      if (val && DomData.has(val)) {
	        DomData["delete"](val);
	      }
	    });
	    window__default['default'].setTimeout(function () {
	      target.eventBusEl_ = null;
	    }, 0);
	  });
	  return target;
	}
	
	/**
	 * @file mixins/stateful.js
	 * @module stateful
	 */
	/**
	 * Contains methods that provide statefulness to an object which is passed
	 * to {@link module:stateful}.
	 *
	 * @mixin StatefulMixin
	 */
	
	var StatefulMixin = {
	  /**
	   * A hash containing arbitrary keys and values representing the state of
	   * the object.
	   *
	   * @type {Object}
	   */
	  state: {},
	
	  /**
	   * Set the state of an object by mutating its
	   * {@link module:stateful~StatefulMixin.state|state} object in place.
	   *
	   * @fires   module:stateful~StatefulMixin#statechanged
	   * @param   {Object|Function} stateUpdates
	   *          A new set of properties to shallow-merge into the plugin state.
	   *          Can be a plain object or a function returning a plain object.
	   *
	   * @return {Object|undefined}
	   *          An object containing changes that occurred. If no changes
	   *          occurred, returns `undefined`.
	   */
	  setState: function setState(stateUpdates) {
	    var _this = this;
	
	    // Support providing the `stateUpdates` state as a function.
	    if (typeof stateUpdates === 'function') {
	      stateUpdates = stateUpdates();
	    }
	
	    var changes;
	    each(stateUpdates, function (value, key) {
	      // Record the change if the value is different from what's in the
	      // current state.
	      if (_this.state[key] !== value) {
	        changes = changes || {};
	        changes[key] = {
	          from: _this.state[key],
	          to: value
	        };
	      }
	
	      _this.state[key] = value;
	    }); // Only trigger "statechange" if there were changes AND we have a trigger
	    // function. This allows us to not require that the target object be an
	    // evented object.
	
	    if (changes && isEvented(this)) {
	      /**
	       * An event triggered on an object that is both
	       * {@link module:stateful|stateful} and {@link module:evented|evented}
	       * indicating that its state has changed.
	       *
	       * @event    module:stateful~StatefulMixin#statechanged
	       * @type     {Object}
	       * @property {Object} changes
	       *           A hash containing the properties that were changed and
	       *           the values they were changed `from` and `to`.
	       */
	      this.trigger({
	        changes: changes,
	        type: 'statechanged'
	      });
	    }
	
	    return changes;
	  }
	};
	/**
	 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
	 * object.
	 *
	 * If the target object is {@link module:evented|evented} and has a
	 * `handleStateChanged` method, that method will be automatically bound to the
	 * `statechanged` event on itself.
	 *
	 * @param   {Object} target
	 *          The object to be made stateful.
	 *
	 * @param   {Object} [defaultState]
	 *          A default set of properties to populate the newly-stateful object's
	 *          `state` property.
	 *
	 * @return {Object}
	 *          Returns the `target`.
	 */
	
	function stateful(target, defaultState) {
	  assign(target, StatefulMixin); // This happens after the mixing-in because we need to replace the `state`
	  // added in that step.
	
	  target.state = assign({}, target.state, defaultState); // Auto-bind the `handleStateChanged` method of the target object if it exists.
	
	  if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
	    target.on('statechanged', target.handleStateChanged);
	  }
	
	  return target;
	}
	
	/**
	 * @file string-cases.js
	 * @module to-lower-case
	 */
	
	/**
	 * Lowercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be lowercased
	 *
	 * @return {string}
	 *         The string with a lowercased first letter
	 */
	var toLowerCase = function toLowerCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toLowerCase();
	  });
	};
	/**
	 * Uppercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be uppercased
	 *
	 * @return {string}
	 *         The string with an uppercased first letter
	 */
	
	var toTitleCase$1 = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	/**
	 * Compares the TitleCase versions of the two strings for equality.
	 *
	 * @param {string} str1
	 *        The first string to compare
	 *
	 * @param {string} str2
	 *        The second string to compare
	 *
	 * @return {boolean}
	 *         Whether the TitleCase versions of the strings are equal
	 */
	
	var titleCaseEquals = function titleCaseEquals(str1, str2) {
	  return toTitleCase$1(str1) === toTitleCase$1(str2);
	};
	
	/**
	 * @file merge-options.js
	 * @module merge-options
	 */
	/**
	 * Merge two objects recursively.
	 *
	 * Performs a deep merge like
	 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
	 * plain objects (not arrays, elements, or anything else).
	 *
	 * Non-plain object values will be copied directly from the right-most
	 * argument.
	 *
	 * @static
	 * @param   {Object[]} sources
	 *          One or more objects to merge into a new object.
	 *
	 * @return {Object}
	 *          A new object that is the merged result of all sources.
	 */
	
	function mergeOptions$3() {
	  var result = {};
	
	  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      if (!isPlain(value)) {
	        result[key] = value;
	        return;
	      }
	
	      if (!isPlain(result[key])) {
	        result[key] = {};
	      }
	
	      result[key] = mergeOptions$3(result[key], value);
	    });
	  });
	  return result;
	}
	
	var MapSham = /*#__PURE__*/function () {
	  function MapSham() {
	    this.map_ = {};
	  }
	
	  var _proto = MapSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.map_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.map_[key];
	    return has;
	  };
	
	  _proto.set = function set(key, value) {
	    this.map_[key] = value;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.map_) {
	      callback.call(thisArg, this.map_[key], key, this);
	    }
	  };
	
	  return MapSham;
	}();
	
	var Map$1 = window__default['default'].Map ? window__default['default'].Map : MapSham;
	
	var SetSham = /*#__PURE__*/function () {
	  function SetSham() {
	    this.set_ = {};
	  }
	
	  var _proto = SetSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.set_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.set_[key];
	    return has;
	  };
	
	  _proto.add = function add(key) {
	    this.set_[key] = 1;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.set_) {
	      callback.call(thisArg, key, key, this);
	    }
	  };
	
	  return SetSham;
	}();
	
	var Set$1 = window__default['default'].Set ? window__default['default'].Set : SetSham;
	
	/**
	 * Player Component - Base class for all UI objects
	 *
	 * @file component.js
	 */
	/**
	 * Base class for all UI Components.
	 * Components are UI objects which represent both a javascript object and an element
	 * in the DOM. They can be children of other components, and can have
	 * children themselves.
	 *
	 * Components can also use methods from {@link EventTarget}
	 */
	
	var Component$1 = /*#__PURE__*/function () {
	  /**
	   * A callback that is called when a component is ready. Does not have any
	   * paramters and any callback value will be ignored.
	   *
	   * @callback Component~ReadyCallback
	   * @this Component
	   */
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of component options.
	   *
	   * @param {Object[]} [options.children]
	   *        An array of children objects to intialize this component with. Children objects have
	   *        a name property that will be used if more than one component of the same type needs to be
	   *        added.
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Function that gets called when the `Component` is ready.
	   */
	  function Component(player, options, ready) {
	    var _this = this;
	
	    // The component might be the player itself and we can't pass `this` to super
	    if (!player && this.play) {
	      this.player_ = player = this; // eslint-disable-line
	    } else {
	      this.player_ = player;
	    }
	
	    this.isDisposed_ = false; // Hold the reference to the parent component via `addChild` method
	
	    this.parentComponent_ = null; // Make a copy of prototype.options_ to protect against overriding defaults
	
	    this.options_ = mergeOptions$3({}, this.options_); // Updated options with supplied options
	
	    options = this.options_ = mergeOptions$3(this.options_, options); // Get ID from options or options element if one is supplied
	
	    this.id_ = options.id || options.el && options.el.id; // If there was no ID from the options, generate one
	
	    if (!this.id_) {
	      // Don't require the player ID function in the case of mock players
	      var id = player && player.id && player.id() || 'no_player';
	      this.id_ = id + "_component_" + newGUID();
	    }
	
	    this.name_ = options.name || null; // Create element if one wasn't provided in options
	
	    if (options.el) {
	      this.el_ = options.el;
	    } else if (options.createEl !== false) {
	      this.el_ = this.createEl();
	    }
	
	    if (options.className && this.el_) {
	      options.className.split(' ').forEach(function (c) {
	        return _this.addClass(c);
	      });
	    } // if evented is anything except false, we want to mixin in evented
	
	
	    if (options.evented !== false) {
	      // Make this an evented object and use `el_`, if available, as its event bus
	      evented(this, {
	        eventBusKey: this.el_ ? 'el_' : null
	      });
	      this.handleLanguagechange = this.handleLanguagechange.bind(this);
	      this.on(this.player_, 'languagechange', this.handleLanguagechange);
	    }
	
	    stateful(this, this.constructor.defaultState);
	    this.children_ = [];
	    this.childIndex_ = {};
	    this.childNameIndex_ = {};
	    this.setTimeoutIds_ = new Set$1();
	    this.setIntervalIds_ = new Set$1();
	    this.rafIds_ = new Set$1();
	    this.namedRafs_ = new Map$1();
	    this.clearingTimersOnDispose_ = false; // Add any child components in options
	
	    if (options.initChildren !== false) {
	      this.initChildren();
	    } // Don't want to trigger ready here or it will go before init is actually
	    // finished for all children that run this constructor
	
	
	    this.ready(ready);
	
	    if (options.reportTouchActivity !== false) {
	      this.enableTouchActivity();
	    }
	  }
	  /**
	   * Dispose of the `Component` and all child components.
	   *
	   * @fires Component#dispose
	   *
	   * @param {Object} options
	   * @param {Element} options.originalEl element with which to replace player element
	   */
	
	
	  var _proto = Component.prototype;
	
	  _proto.dispose = function dispose(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Bail out if the component has already been disposed.
	    if (this.isDisposed_) {
	      return;
	    }
	
	    if (this.readyQueue_) {
	      this.readyQueue_.length = 0;
	    }
	    /**
	     * Triggered when a `Component` is disposed.
	     *
	     * @event Component#dispose
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the dispose event does not
	     *           bubble up
	     */
	
	
	    this.trigger({
	      type: 'dispose',
	      bubbles: false
	    });
	    this.isDisposed_ = true; // Dispose all children.
	
	    if (this.children_) {
	      for (var i = this.children_.length - 1; i >= 0; i--) {
	        if (this.children_[i].dispose) {
	          this.children_[i].dispose();
	        }
	      }
	    } // Delete child references
	
	
	    this.children_ = null;
	    this.childIndex_ = null;
	    this.childNameIndex_ = null;
	    this.parentComponent_ = null;
	
	    if (this.el_) {
	      // Remove element from DOM
	      if (this.el_.parentNode) {
	        if (options.restoreEl) {
	          this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
	        } else {
	          this.el_.parentNode.removeChild(this.el_);
	        }
	      }
	
	      this.el_ = null;
	    } // remove reference to the player after disposing of the element
	
	
	    this.player_ = null;
	  }
	  /**
	   * Determine whether or not this component has been disposed.
	   *
	   * @return {boolean}
	   *         If the component has been disposed, will be `true`. Otherwise, `false`.
	   */
	  ;
	
	  _proto.isDisposed = function isDisposed() {
	    return Boolean(this.isDisposed_);
	  }
	  /**
	   * Return the {@link Player} that the `Component` has attached to.
	   *
	   * @return {Player}
	   *         The player that this `Component` has attached to.
	   */
	  ;
	
	  _proto.player = function player() {
	    return this.player_;
	  }
	  /**
	   * Deep merge of options objects with new options.
	   * > Note: When both `obj` and `options` contain properties whose values are objects.
	   *         The two properties get merged using {@link module:mergeOptions}
	   *
	   * @param {Object} obj
	   *        The object that contains new options.
	   *
	   * @return {Object}
	   *         A new object of `this.options_` and `obj` merged together.
	   */
	  ;
	
	  _proto.options = function options(obj) {
	    if (!obj) {
	      return this.options_;
	    }
	
	    this.options_ = mergeOptions$3(this.options_, obj);
	    return this.options_;
	  }
	  /**
	   * Get the `Component`s DOM element
	   *
	   * @return {Element}
	   *         The DOM element for this `Component`.
	   */
	  ;
	
	  _proto.el = function el() {
	    return this.el_;
	  }
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tagName]
	   *        Element's DOM node type. e.g. 'div'
	   *
	   * @param {Object} [properties]
	   *        An object of properties that should be set.
	   *
	   * @param {Object} [attributes]
	   *        An object of attributes that should be set.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1(tagName, properties, attributes) {
	    return createEl(tagName, properties, attributes);
	  }
	  /**
	   * Localize a string given the string in english.
	   *
	   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
	   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
	   *
	   * If a `defaultValue` is provided, it'll use that over `string`,
	   * if a value isn't found in provided language files.
	   * This is useful if you want to have a descriptive key for token replacement
	   * but have a succinct localized string and not require `en.json` to be included.
	   *
	   * Currently, it is used for the progress bar timing.
	   * ```js
	   * {
	   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
	   * }
	   * ```
	   * It is then used like so:
	   * ```js
	   * this.localize('progress bar timing: currentTime={1} duration{2}',
	   *               [this.player_.currentTime(), this.player_.duration()],
	   *               '{1} of {2}');
	   * ```
	   *
	   * Which outputs something like: `01:23 of 24:56`.
	   *
	   *
	   * @param {string} string
	   *        The string to localize and the key to lookup in the language files.
	   * @param {string[]} [tokens]
	   *        If the current item has token replacements, provide the tokens here.
	   * @param {string} [defaultValue]
	   *        Defaults to `string`. Can be a default value to use for token replacement
	   *        if the lookup key is needed to be separate.
	   *
	   * @return {string}
	   *         The localized string or if no localization exists the english string.
	   */
	  ;
	
	  _proto.localize = function localize(string, tokens, defaultValue) {
	    if (defaultValue === void 0) {
	      defaultValue = string;
	    }
	
	    var code = this.player_.language && this.player_.language();
	    var languages = this.player_.languages && this.player_.languages();
	    var language = languages && languages[code];
	    var primaryCode = code && code.split('-')[0];
	    var primaryLang = languages && languages[primaryCode];
	    var localizedString = defaultValue;
	
	    if (language && language[string]) {
	      localizedString = language[string];
	    } else if (primaryLang && primaryLang[string]) {
	      localizedString = primaryLang[string];
	    }
	
	    if (tokens) {
	      localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
	        var value = tokens[index - 1];
	        var ret = value;
	
	        if (typeof value === 'undefined') {
	          ret = match;
	        }
	
	        return ret;
	      });
	    }
	
	    return localizedString;
	  }
	  /**
	   * Handles language change for the player in components. Should be overriden by sub-components.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {}
	  /**
	   * Return the `Component`s DOM element. This is where children get inserted.
	   * This will usually be the the same as the element returned in {@link Component#el}.
	   *
	   * @return {Element}
	   *         The content element for this `Component`.
	   */
	  ;
	
	  _proto.contentEl = function contentEl() {
	    return this.contentEl_ || this.el_;
	  }
	  /**
	   * Get this `Component`s ID
	   *
	   * @return {string}
	   *         The id of this `Component`
	   */
	  ;
	
	  _proto.id = function id() {
	    return this.id_;
	  }
	  /**
	   * Get the `Component`s name. The name gets used to reference the `Component`
	   * and is set during registration.
	   *
	   * @return {string}
	   *         The name of this `Component`.
	   */
	  ;
	
	  _proto.name = function name() {
	    return this.name_;
	  }
	  /**
	   * Get an array of all child components
	   *
	   * @return {Array}
	   *         The children
	   */
	  ;
	
	  _proto.children = function children() {
	    return this.children_;
	  }
	  /**
	   * Returns the child `Component` with the given `id`.
	   *
	   * @param {string} id
	   *        The id of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `id` or undefined.
	   */
	  ;
	
	  _proto.getChildById = function getChildById(id) {
	    return this.childIndex_[id];
	  }
	  /**
	   * Returns the child `Component` with the given `name`.
	   *
	   * @param {string} name
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `name` or undefined.
	   */
	  ;
	
	  _proto.getChild = function getChild(name) {
	    if (!name) {
	      return;
	    }
	
	    return this.childNameIndex_[name];
	  }
	  /**
	   * Returns the descendant `Component` following the givent
	   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
	   * try to get 'foo' on the current component, 'bar' on the 'foo'
	   * component and 'baz' on the 'bar' component and return undefined
	   * if any of those don't exist.
	   *
	   * @param {...string[]|...string} names
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The descendant `Component` following the given descendant
	   *         `names` or undefined.
	   */
	  ;
	
	  _proto.getDescendant = function getDescendant() {
	    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
	      names[_key] = arguments[_key];
	    }
	
	    // flatten array argument into the main array
	    names = names.reduce(function (acc, n) {
	      return acc.concat(n);
	    }, []);
	    var currentChild = this;
	
	    for (var i = 0; i < names.length; i++) {
	      currentChild = currentChild.getChild(names[i]);
	
	      if (!currentChild || !currentChild.getChild) {
	        return;
	      }
	    }
	
	    return currentChild;
	  }
	  /**
	   * Add a child `Component` inside the current `Component`.
	   *
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @param {number} [index=this.children_.length]
	   *        The index to attempt to add a child into.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options, index) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (index === void 0) {
	      index = this.children_.length;
	    }
	
	    var component;
	    var componentName; // If child is a string, create component with options
	
	    if (typeof child === 'string') {
	      componentName = toTitleCase$1(child);
	      var componentClassName = options.componentClass || componentName; // Set name through options
	
	      options.name = componentName; // Create a new object & element for this controls set
	      // If there's no .player_, this is a player
	
	      var ComponentClass = Component.getComponent(componentClassName);
	
	      if (!ComponentClass) {
	        throw new Error("Component " + componentClassName + " does not exist");
	      } // data stored directly on the videojs object may be
	      // misidentified as a component to retain
	      // backwards-compatibility with 4.x. check to make sure the
	      // component class can be instantiated.
	
	
	      if (typeof ComponentClass !== 'function') {
	        return null;
	      }
	
	      component = new ComponentClass(this.player_ || this, options); // child is a component instance
	    } else {
	      component = child;
	    }
	
	    if (component.parentComponent_) {
	      component.parentComponent_.removeChild(component);
	    }
	
	    this.children_.splice(index, 0, component);
	    component.parentComponent_ = this;
	
	    if (typeof component.id === 'function') {
	      this.childIndex_[component.id()] = component;
	    } // If a name wasn't used to create the component, check if we can use the
	    // name function of the component
	
	
	    componentName = componentName || component.name && toTitleCase$1(component.name());
	
	    if (componentName) {
	      this.childNameIndex_[componentName] = component;
	      this.childNameIndex_[toLowerCase(componentName)] = component;
	    } // Add the UI object's element to the container div (box)
	    // Having an element is not required
	
	
	    if (typeof component.el === 'function' && component.el()) {
	      // If inserting before a component, insert before that component's element
	      var refNode = null;
	
	      if (this.children_[index + 1]) {
	        // Most children are components, but the video tech is an HTML element
	        if (this.children_[index + 1].el_) {
	          refNode = this.children_[index + 1].el_;
	        } else if (isEl(this.children_[index + 1])) {
	          refNode = this.children_[index + 1];
	        }
	      }
	
	      this.contentEl().insertBefore(component.el(), refNode);
	    } // Return so it can stored on parent object if desired.
	
	
	    return component;
	  }
	  /**
	   * Remove a child `Component` from this `Component`s list of children. Also removes
	   * the child `Component`s element from this `Component`s element.
	   *
	   * @param {Component} component
	   *        The child `Component` to remove.
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    if (!component || !this.children_) {
	      return;
	    }
	
	    var childFound = false;
	
	    for (var i = this.children_.length - 1; i >= 0; i--) {
	      if (this.children_[i] === component) {
	        childFound = true;
	        this.children_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!childFound) {
	      return;
	    }
	
	    component.parentComponent_ = null;
	    this.childIndex_[component.id()] = null;
	    this.childNameIndex_[toTitleCase$1(component.name())] = null;
	    this.childNameIndex_[toLowerCase(component.name())] = null;
	    var compEl = component.el();
	
	    if (compEl && compEl.parentNode === this.contentEl()) {
	      this.contentEl().removeChild(component.el());
	    }
	  }
	  /**
	   * Add and initialize default child `Component`s based upon options.
	   */
	  ;
	
	  _proto.initChildren = function initChildren() {
	    var _this2 = this;
	
	    var children = this.options_.children;
	
	    if (children) {
	      // `this` is `parent`
	      var parentOptions = this.options_;
	
	      var handleAdd = function handleAdd(child) {
	        var name = child.name;
	        var opts = child.opts; // Allow options for children to be set at the parent options
	        // e.g. videojs(id, { controlBar: false });
	        // instead of videojs(id, { children: { controlBar: false });
	
	        if (parentOptions[name] !== undefined) {
	          opts = parentOptions[name];
	        } // Allow for disabling default components
	        // e.g. options['children']['posterImage'] = false
	
	
	        if (opts === false) {
	          return;
	        } // Allow options to be passed as a simple boolean if no configuration
	        // is necessary.
	
	
	        if (opts === true) {
	          opts = {};
	        } // We also want to pass the original player options
	        // to each component as well so they don't need to
	        // reach back into the player for options later.
	
	
	        opts.playerOptions = _this2.options_.playerOptions; // Create and add the child component.
	        // Add a direct reference to the child by name on the parent instance.
	        // If two of the same component are used, different names should be supplied
	        // for each
	
	        var newChild = _this2.addChild(name, opts);
	
	        if (newChild) {
	          _this2[name] = newChild;
	        }
	      }; // Allow for an array of children details to passed in the options
	
	
	      var workingChildren;
	      var Tech = Component.getComponent('Tech');
	
	      if (Array.isArray(children)) {
	        workingChildren = children;
	      } else {
	        workingChildren = Object.keys(children);
	      }
	
	      workingChildren // children that are in this.options_ but also in workingChildren  would
	      // give us extra children we do not want. So, we want to filter them out.
	      .concat(Object.keys(this.options_).filter(function (child) {
	        return !workingChildren.some(function (wchild) {
	          if (typeof wchild === 'string') {
	            return child === wchild;
	          }
	
	          return child === wchild.name;
	        });
	      })).map(function (child) {
	        var name;
	        var opts;
	
	        if (typeof child === 'string') {
	          name = child;
	          opts = children[name] || _this2.options_[name] || {};
	        } else {
	          name = child.name;
	          opts = child;
	        }
	
	        return {
	          name: name,
	          opts: opts
	        };
	      }).filter(function (child) {
	        // we have to make sure that child.name isn't in the techOrder since
	        // techs are registerd as Components but can't aren't compatible
	        // See https://github.com/videojs/video.js/issues/2772
	        var c = Component.getComponent(child.opts.componentClass || toTitleCase$1(child.name));
	        return c && !Tech.isTech(c);
	      }).forEach(handleAdd);
	    }
	  }
	  /**
	   * Builds the default DOM class name. Should be overriden by sub-components.
	   *
	   * @return {string}
	   *         The DOM class name for this object.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    // Child classes can include a function that does:
	    // return 'CLASS NAME' + this._super();
	    return '';
	  }
	  /**
	   * Bind a listener to the component's ready state.
	   * Different from event listeners in that if the ready event has already happened
	   * it will trigger the function immediately.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	  ;
	
	  _proto.ready = function ready(fn, sync) {
	    if (sync === void 0) {
	      sync = false;
	    }
	
	    if (!fn) {
	      return;
	    }
	
	    if (!this.isReady_) {
	      this.readyQueue_ = this.readyQueue_ || [];
	      this.readyQueue_.push(fn);
	      return;
	    }
	
	    if (sync) {
	      fn.call(this);
	    } else {
	      // Call the function asynchronously by default for consistency
	      this.setTimeout(fn, 1);
	    }
	  }
	  /**
	   * Trigger all the ready listeners for this `Component`.
	   *
	   * @fires Component#ready
	   */
	  ;
	
	  _proto.triggerReady = function triggerReady() {
	    this.isReady_ = true; // Ensure ready is triggered asynchronously
	
	    this.setTimeout(function () {
	      var readyQueue = this.readyQueue_; // Reset Ready Queue
	
	      this.readyQueue_ = [];
	
	      if (readyQueue && readyQueue.length > 0) {
	        readyQueue.forEach(function (fn) {
	          fn.call(this);
	        }, this);
	      } // Allow for using event listeners also
	
	      /**
	       * Triggered when a `Component` is ready.
	       *
	       * @event Component#ready
	       * @type {EventTarget~Event}
	       */
	
	
	      this.trigger('ready');
	    }, 1);
	  }
	  /**
	   * Find a single DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelector`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {Element|null}
	   *         the dom element that was found, or null
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$ = function $$1(selector, context) {
	    return $(selector, context || this.contentEl());
	  }
	  /**
	   * Finds all DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelectorAll`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {NodeList}
	   *         a list of dom elements that were found
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$$ = function $$$1(selector, context) {
	    return $$(selector, context || this.contentEl());
	  }
	  /**
	   * Check if a component's element has a CSS class name.
	   *
	   * @param {string} classToCheck
	   *        CSS class name to check.
	   *
	   * @return {boolean}
	   *         - True if the `Component` has the class.
	   *         - False if the `Component` does not have the class`
	   */
	  ;
	
	  _proto.hasClass = function hasClass$1(classToCheck) {
	    return hasClass(this.el_, classToCheck);
	  }
	  /**
	   * Add a CSS class name to the `Component`s element.
	   *
	   * @param {string} classToAdd
	   *        CSS class name to add
	   */
	  ;
	
	  _proto.addClass = function addClass$1(classToAdd) {
	    addClass(this.el_, classToAdd);
	  }
	  /**
	   * Remove a CSS class name from the `Component`s element.
	   *
	   * @param {string} classToRemove
	   *        CSS class name to remove
	   */
	  ;
	
	  _proto.removeClass = function removeClass$1(classToRemove) {
	    removeClass(this.el_, classToRemove);
	  }
	  /**
	   * Add or remove a CSS class name from the component's element.
	   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
	   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
	   *
	   * @param  {string} classToToggle
	   *         The class to add or remove based on (@link Component#hasClass}
	   *
	   * @param  {boolean|Dom~predicate} [predicate]
	   *         An {@link Dom~predicate} function or a boolean
	   */
	  ;
	
	  _proto.toggleClass = function toggleClass$1(classToToggle, predicate) {
	    toggleClass(this.el_, classToToggle, predicate);
	  }
	  /**
	   * Show the `Component`s element if it is hidden by removing the
	   * 'vjs-hidden' class name from it.
	   */
	  ;
	
	  _proto.show = function show() {
	    this.removeClass('vjs-hidden');
	  }
	  /**
	   * Hide the `Component`s element if it is currently showing by adding the
	   * 'vjs-hidden` class name to it.
	   */
	  ;
	
	  _proto.hide = function hide() {
	    this.addClass('vjs-hidden');
	  }
	  /**
	   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
	   * class name to it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.lockShowing = function lockShowing() {
	    this.addClass('vjs-lock-showing');
	  }
	  /**
	   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
	   * class name from it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unlockShowing = function unlockShowing() {
	    this.removeClass('vjs-lock-showing');
	  }
	  /**
	   * Get the value of an attribute on the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to get the value from.
	   *
	   * @return {string|null}
	   *         - The value of the attribute that was asked for.
	   *         - Can be an empty string on some browsers if the attribute does not exist
	   *           or has no value
	   *         - Most browsers will return null if the attibute does not exist or has
	   *           no value.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
	   */
	  ;
	
	  _proto.getAttribute = function getAttribute$1(attribute) {
	    return getAttribute(this.el_, attribute);
	  }
	  /**
	   * Set the value of an attribute on the `Component`'s element
	   *
	   * @param {string} attribute
	   *        Name of the attribute to set.
	   *
	   * @param {string} value
	   *        Value to set the attribute to.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
	   */
	  ;
	
	  _proto.setAttribute = function setAttribute$1(attribute, value) {
	    setAttribute(this.el_, attribute, value);
	  }
	  /**
	   * Remove an attribute from the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to remove.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
	   */
	  ;
	
	  _proto.removeAttribute = function removeAttribute$1(attribute) {
	    removeAttribute(this.el_, attribute);
	  }
	  /**
	   * Get or set the width of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The width that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.width = function width(num, skipListeners) {
	    return this.dimension('width', num, skipListeners);
	  }
	  /**
	   * Get or set the height of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The height that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *         postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.height = function height(num, skipListeners) {
	    return this.dimension('height', num, skipListeners);
	  }
	  /**
	   * Set both the width and height of the `Component` element at the same time.
	   *
	   * @param  {number|string} width
	   *         Width to set the `Component`s element to.
	   *
	   * @param  {number|string} height
	   *         Height to set the `Component`s element to.
	   */
	  ;
	
	  _proto.dimensions = function dimensions(width, height) {
	    // Skip componentresize listeners on width for optimization
	    this.width(width, true);
	    this.height(height);
	  }
	  /**
	   * Get or set width or height of the `Component` element. This is the shared code
	   * for the {@link Component#width} and {@link Component#height}.
	   *
	   * Things to know:
	   * - If the width or height in an number this will return the number postfixed with 'px'.
	   * - If the width/height is a percent this will return the percent postfixed with '%'
	   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
	   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
	   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
	   *   for more information
	   * - If you want the computed style of the component, use {@link Component#currentWidth}
	   *   and {@link {Component#currentHeight}
	   *
	   * @fires Component#componentresize
	   *
	   * @param {string} widthOrHeight
	   8        'width' or 'height'
	   *
	   * @param  {number|string} [num]
	   8         New dimension
	   *
	   * @param  {boolean} [skipListeners]
	   *         Skip componentresize event trigger
	   *
	   * @return {number}
	   *         The dimension when getting or 0 if unset
	   */
	  ;
	
	  _proto.dimension = function dimension(widthOrHeight, num, skipListeners) {
	    if (num !== undefined) {
	      // Set to zero if null or literally NaN (NaN !== NaN)
	      if (num === null || num !== num) {
	        num = 0;
	      } // Check if using css width/height (% or px) and adjust
	
	
	      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
	        this.el_.style[widthOrHeight] = num;
	      } else if (num === 'auto') {
	        this.el_.style[widthOrHeight] = '';
	      } else {
	        this.el_.style[widthOrHeight] = num + 'px';
	      } // skipListeners allows us to avoid triggering the resize event when setting both width and height
	
	
	      if (!skipListeners) {
	        /**
	         * Triggered when a component is resized.
	         *
	         * @event Component#componentresize
	         * @type {EventTarget~Event}
	         */
	        this.trigger('componentresize');
	      }
	
	      return;
	    } // Not setting a value, so getting it
	    // Make sure element exists
	
	
	    if (!this.el_) {
	      return 0;
	    } // Get dimension value from style
	
	
	    var val = this.el_.style[widthOrHeight];
	    var pxIndex = val.indexOf('px');
	
	    if (pxIndex !== -1) {
	      // Return the pixel value with no 'px'
	      return parseInt(val.slice(0, pxIndex), 10);
	    } // No px so using % or no style was set, so falling back to offsetWidth/height
	    // If component has display:none, offset will return 0
	    // TODO: handle display:none and no dimension style using px
	
	
	    return parseInt(this.el_['offset' + toTitleCase$1(widthOrHeight)], 10);
	  }
	  /**
	   * Get the computed width or the height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @param {string} widthOrHeight
	   *        A string containing 'width' or 'height'. Whichever one you want to get.
	   *
	   * @return {number}
	   *         The dimension that gets asked for or 0 if nothing was set
	   *         for that dimension.
	   */
	  ;
	
	  _proto.currentDimension = function currentDimension(widthOrHeight) {
	    var computedWidthOrHeight = 0;
	
	    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
	      throw new Error('currentDimension only accepts width or height value');
	    }
	
	    computedWidthOrHeight = computedStyle(this.el_, widthOrHeight); // remove 'px' from variable and parse as integer
	
	    computedWidthOrHeight = parseFloat(computedWidthOrHeight); // if the computed value is still 0, it's possible that the browser is lying
	    // and we want to check the offset values.
	    // This code also runs wherever getComputedStyle doesn't exist.
	
	    if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
	      var rule = "offset" + toTitleCase$1(widthOrHeight);
	      computedWidthOrHeight = this.el_[rule];
	    }
	
	    return computedWidthOrHeight;
	  }
	  /**
	   * An object that contains width and height values of the `Component`s
	   * computed style. Uses `window.getComputedStyle`.
	   *
	   * @typedef {Object} Component~DimensionObject
	   *
	   * @property {number} width
	   *           The width of the `Component`s computed style.
	   *
	   * @property {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	  /**
	   * Get an object that contains computed width and height values of the
	   * component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {Component~DimensionObject}
	   *         The computed dimensions of the component's element.
	   */
	  ;
	
	  _proto.currentDimensions = function currentDimensions() {
	    return {
	      width: this.currentDimension('width'),
	      height: this.currentDimension('height')
	    };
	  }
	  /**
	   * Get the computed width of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed width of the component's element.
	   */
	  ;
	
	  _proto.currentWidth = function currentWidth() {
	    return this.currentDimension('width');
	  }
	  /**
	   * Get the computed height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed height of the component's element.
	   */
	  ;
	
	  _proto.currentHeight = function currentHeight() {
	    return this.currentDimension('height');
	  }
	  /**
	   * Set the focus to this component
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.el_.focus();
	  }
	  /**
	   * Remove the focus from this component
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.el_.blur();
	  }
	  /**
	   * When this Component receives a `keydown` event which it does not process,
	   *  it passes the event to the Player for handling.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (this.player_) {
	      // We only stop propagation here because we want unhandled events to fall
	      // back to the browser. Exclude Tab for focus trapping.
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.stopPropagation();
	      }
	
	      this.player_.handleKeyDown(event);
	    }
	  }
	  /**
	   * Many components used to have a `handleKeyPress` method, which was poorly
	   * named because it listened to a `keydown` event. This method name now
	   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
	   * will not see their method calls stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    this.handleKeyDown(event);
	  }
	  /**
	   * Emit a 'tap' events when touch event support gets detected. This gets used to
	   * support toggling the controls through a tap on the video. They get enabled
	   * because every sub-component would have extra overhead otherwise.
	   *
	   * @private
	   * @fires Component#tap
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchleave
	   * @listens Component#touchcancel
	   * @listens Component#touchend
	    */
	  ;
	
	  _proto.emitTapEvents = function emitTapEvents() {
	    // Track the start time so we can determine how long the touch lasted
	    var touchStart = 0;
	    var firstTouch = null; // Maximum movement allowed during a touch event to still be considered a tap
	    // Other popular libs use anywhere from 2 (hammer.js) to 15,
	    // so 10 seems like a nice, round number.
	
	    var tapMovementThreshold = 10; // The maximum length a touch can be while still being considered a tap
	
	    var touchTimeThreshold = 200;
	    var couldBeTap;
	    this.on('touchstart', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length === 1) {
	        // Copy pageX/pageY from the object
	        firstTouch = {
	          pageX: event.touches[0].pageX,
	          pageY: event.touches[0].pageY
	        }; // Record start time so we can detect a tap vs. "touch and hold"
	
	        touchStart = window__default['default'].performance.now(); // Reset couldBeTap tracking
	
	        couldBeTap = true;
	      }
	    });
	    this.on('touchmove', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length > 1) {
	        couldBeTap = false;
	      } else if (firstTouch) {
	        // Some devices will throw touchmoves for all but the slightest of taps.
	        // So, if we moved only a small distance, this could still be a tap
	        var xdiff = event.touches[0].pageX - firstTouch.pageX;
	        var ydiff = event.touches[0].pageY - firstTouch.pageY;
	        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	
	        if (touchDistance > tapMovementThreshold) {
	          couldBeTap = false;
	        }
	      }
	    });
	
	    var noTap = function noTap() {
	      couldBeTap = false;
	    }; // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
	
	
	    this.on('touchleave', noTap);
	    this.on('touchcancel', noTap); // When the touch ends, measure how long it took and trigger the appropriate
	    // event
	
	    this.on('touchend', function (event) {
	      firstTouch = null; // Proceed only if the touchmove/leave/cancel event didn't happen
	
	      if (couldBeTap === true) {
	        // Measure how long the touch lasted
	        var touchTime = window__default['default'].performance.now() - touchStart; // Make sure the touch was less than the threshold to be considered a tap
	
	        if (touchTime < touchTimeThreshold) {
	          // Don't let browser turn this into a click
	          event.preventDefault();
	          /**
	           * Triggered when a `Component` is tapped.
	           *
	           * @event Component#tap
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('tap'); // It may be good to copy the touchend event object and change the
	          // type to tap, if the other event properties aren't exact after
	          // Events.fixEvent runs (e.g. event.target)
	        }
	      }
	    });
	  }
	  /**
	   * This function reports user activity whenever touch events happen. This can get
	   * turned off by any sub-components that wants touch events to act another way.
	   *
	   * Report user touch activity when touch events occur. User activity gets used to
	   * determine when controls should show/hide. It is simple when it comes to mouse
	   * events, because any mouse event should show the controls. So we capture mouse
	   * events that bubble up to the player and report activity when that happens.
	   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
	   * controls. So touch events can't help us at the player level either.
	   *
	   * User activity gets checked asynchronously. So what could happen is a tap event
	   * on the video turns the controls off. Then the `touchend` event bubbles up to
	   * the player. Which, if it reported user activity, would turn the controls right
	   * back on. We also don't want to completely block touch events from bubbling up.
	   * Furthermore a `touchmove` event and anything other than a tap, should not turn
	   * controls back on.
	   *
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchend
	   * @listens Component#touchcancel
	   */
	  ;
	
	  _proto.enableTouchActivity = function enableTouchActivity() {
	    // Don't continue if the root player doesn't support reporting user activity
	    if (!this.player() || !this.player().reportUserActivity) {
	      return;
	    } // listener for reporting that the user is active
	
	
	    var report = bind(this.player(), this.player().reportUserActivity);
	    var touchHolding;
	    this.on('touchstart', function () {
	      report(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(touchHolding); // report at the same interval as activityCheck
	
	      touchHolding = this.setInterval(report, 250);
	    });
	
	    var touchEnd = function touchEnd(event) {
	      report(); // stop the interval that maintains activity if the touch is holding
	
	      this.clearInterval(touchHolding);
	    };
	
	    this.on('touchmove', report);
	    this.on('touchend', touchEnd);
	    this.on('touchcancel', touchEnd);
	  }
	  /**
	   * A callback that has no parameters and is bound into `Component`s context.
	   *
	   * @callback Component~GenericCallback
	   * @this Component
	   */
	
	  /**
	   * Creates a function that runs after an `x` millisecond timeout. This function is a
	   * wrapper around `window.setTimeout`. There are a few reasons to use this one
	   * instead though:
	   * 1. It gets cleared via  {@link Component#clearTimeout} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
	   *
	   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
	   *         will cause its dispose listener not to get cleaned up! Please use
	   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function that will be run after `timeout`.
	   *
	   * @param {number} timeout
	   *        Timeout in milliseconds to delay before executing the specified function.
	   *
	   * @return {number}
	   *         Returns a timeout ID that gets used to identify the timeout. It can also
	   *         get used in {@link Component#clearTimeout} to clear the timeout that
	   *         was set.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
	   */
	  ;
	
	  _proto.setTimeout = function setTimeout(fn, timeout) {
	    var _this3 = this;
	
	    // declare as variables so they are properly available in timeout function
	    // eslint-disable-next-line
	    var timeoutId;
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    timeoutId = window__default['default'].setTimeout(function () {
	      if (_this3.setTimeoutIds_.has(timeoutId)) {
	        _this3.setTimeoutIds_["delete"](timeoutId);
	      }
	
	      fn();
	    }, timeout);
	    this.setTimeoutIds_.add(timeoutId);
	    return timeoutId;
	  }
	  /**
	   * Clears a timeout that gets created via `window.setTimeout` or
	   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
	   * use this function instead of `window.clearTimout`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} timeoutId
	   *        The id of the timeout to clear. The return value of
	   *        {@link Component#setTimeout} or `window.setTimeout`.
	   *
	   * @return {number}
	   *         Returns the timeout id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
	   */
	  ;
	
	  _proto.clearTimeout = function clearTimeout(timeoutId) {
	    if (this.setTimeoutIds_.has(timeoutId)) {
	      this.setTimeoutIds_["delete"](timeoutId);
	      window__default['default'].clearTimeout(timeoutId);
	    }
	
	    return timeoutId;
	  }
	  /**
	   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
	   * around `window.setInterval`. There are a few reasons to use this one instead though.
	   * 1. It gets cleared via  {@link Component#clearInterval} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will be a {@link Component~GenericCallback}
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function to run every `x` seconds.
	   *
	   * @param {number} interval
	   *        Execute the specified function every `x` milliseconds.
	   *
	   * @return {number}
	   *         Returns an id that can be used to identify the interval. It can also be be used in
	   *         {@link Component#clearInterval} to clear the interval.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
	   */
	  ;
	
	  _proto.setInterval = function setInterval(fn, interval) {
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    var intervalId = window__default['default'].setInterval(fn, interval);
	    this.setIntervalIds_.add(intervalId);
	    return intervalId;
	  }
	  /**
	   * Clears an interval that gets created via `window.setInterval` or
	   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
	   * use this function instead of `window.clearInterval`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} intervalId
	   *        The id of the interval to clear. The return value of
	   *        {@link Component#setInterval} or `window.setInterval`.
	   *
	   * @return {number}
	   *         Returns the interval id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
	   */
	  ;
	
	  _proto.clearInterval = function clearInterval(intervalId) {
	    if (this.setIntervalIds_.has(intervalId)) {
	      this.setIntervalIds_["delete"](intervalId);
	      window__default['default'].clearInterval(intervalId);
	    }
	
	    return intervalId;
	  }
	  /**
	   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
	   * with a few extra bonuses:
	   *
	   * - Supports browsers that do not support rAF by falling back to
	   *   {@link Component#setTimeout}.
	   *
	   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
	   *   bound to the component).
	   *
	   * - Automatic cancellation of the rAF callback is handled if the component
	   *   is disposed before it is called.
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   *
	   * @return {number}
	   *         Returns an rAF ID that gets used to identify the timeout. It can
	   *         also be used in {@link Component#cancelAnimationFrame} to cancel
	   *         the animation frame callback.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
	   */
	  ;
	
	  _proto.requestAnimationFrame = function requestAnimationFrame(fn) {
	    var _this4 = this;
	
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.setTimeout(fn, 1000 / 60);
	    }
	
	    this.clearTimersOnDispose_(); // declare as variables so they are properly available in rAF function
	    // eslint-disable-next-line
	
	    var id;
	    fn = bind(this, fn);
	    id = window__default['default'].requestAnimationFrame(function () {
	      if (_this4.rafIds_.has(id)) {
	        _this4.rafIds_["delete"](id);
	      }
	
	      fn();
	    });
	    this.rafIds_.add(id);
	    return id;
	  }
	  /**
	   * Request an animation frame, but only one named animation
	   * frame will be queued. Another will never be added until
	   * the previous one finishes.
	   *
	   * @param {string} name
	   *        The name to give this requestAnimationFrame
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   */
	  ;
	
	  _proto.requestNamedAnimationFrame = function requestNamedAnimationFrame(name, fn) {
	    var _this5 = this;
	
	    if (this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.clearTimersOnDispose_();
	    fn = bind(this, fn);
	    var id = this.requestAnimationFrame(function () {
	      fn();
	
	      if (_this5.namedRafs_.has(name)) {
	        _this5.namedRafs_["delete"](name);
	      }
	    });
	    this.namedRafs_.set(name, id);
	    return name;
	  }
	  /**
	   * Cancels a current named animation frame if it exists.
	   *
	   * @param {string} name
	   *        The name of the requestAnimationFrame to cancel.
	   */
	  ;
	
	  _proto.cancelNamedAnimationFrame = function cancelNamedAnimationFrame(name) {
	    if (!this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.cancelAnimationFrame(this.namedRafs_.get(name));
	    this.namedRafs_["delete"](name);
	  }
	  /**
	   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
	   * (rAF).
	   *
	   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
	   * use this function instead of `window.cancelAnimationFrame`. If you don't,
	   * your dispose listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} id
	   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
	   *
	   * @return {number}
	   *         Returns the rAF ID that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
	   */
	  ;
	
	  _proto.cancelAnimationFrame = function cancelAnimationFrame(id) {
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.clearTimeout(id);
	    }
	
	    if (this.rafIds_.has(id)) {
	      this.rafIds_["delete"](id);
	      window__default['default'].cancelAnimationFrame(id);
	    }
	
	    return id;
	  }
	  /**
	   * A function to setup `requestAnimationFrame`, `setTimeout`,
	   * and `setInterval`, clearing on dispose.
	   *
	   * > Previously each timer added and removed dispose listeners on it's own.
	   * For better performance it was decided to batch them all, and use `Set`s
	   * to track outstanding timer ids.
	   *
	   * @private
	   */
	  ;
	
	  _proto.clearTimersOnDispose_ = function clearTimersOnDispose_() {
	    var _this6 = this;
	
	    if (this.clearingTimersOnDispose_) {
	      return;
	    }
	
	    this.clearingTimersOnDispose_ = true;
	    this.one('dispose', function () {
	      [['namedRafs_', 'cancelNamedAnimationFrame'], ['rafIds_', 'cancelAnimationFrame'], ['setTimeoutIds_', 'clearTimeout'], ['setIntervalIds_', 'clearInterval']].forEach(function (_ref) {
	        var idName = _ref[0],
	            cancelName = _ref[1];
	
	        // for a `Set` key will actually be the value again
	        // so forEach((val, val) =>` but for maps we want to use
	        // the key.
	        _this6[idName].forEach(function (val, key) {
	          return _this6[cancelName](key);
	        });
	      });
	      _this6.clearingTimersOnDispose_ = false;
	    });
	  }
	  /**
	   * Register a `Component` with `videojs` given the name and the component.
	   *
	   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
	   *         should be registered using {@link Tech.registerTech} or
	   *         {@link videojs:videojs.registerTech}.
	   *
	   * > NOTE: This function can also be seen on videojs as
	   *         {@link videojs:videojs.registerComponent}.
	   *
	   * @param {string} name
	   *        The name of the `Component` to register.
	   *
	   * @param {Component} ComponentToRegister
	   *        The `Component` class to register.
	   *
	   * @return {Component}
	   *         The `Component` that was registered.
	   */
	  ;
	
	  Component.registerComponent = function registerComponent(name, ComponentToRegister) {
	    if (typeof name !== 'string' || !name) {
	      throw new Error("Illegal component name, \"" + name + "\"; must be a non-empty string.");
	    }
	
	    var Tech = Component.getComponent('Tech'); // We need to make sure this check is only done if Tech has been registered.
	
	    var isTech = Tech && Tech.isTech(ComponentToRegister);
	    var isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);
	
	    if (isTech || !isComp) {
	      var reason;
	
	      if (isTech) {
	        reason = 'techs must be registered using Tech.registerTech()';
	      } else {
	        reason = 'must be a Component subclass';
	      }
	
	      throw new Error("Illegal component, \"" + name + "\"; " + reason + ".");
	    }
	
	    name = toTitleCase$1(name);
	
	    if (!Component.components_) {
	      Component.components_ = {};
	    }
	
	    var Player = Component.getComponent('Player');
	
	    if (name === 'Player' && Player && Player.players) {
	      var players = Player.players;
	      var playerNames = Object.keys(players); // If we have players that were disposed, then their name will still be
	      // in Players.players. So, we must loop through and verify that the value
	      // for each item is not null. This allows registration of the Player component
	      // after all players have been disposed or before any were created.
	
	      if (players && playerNames.length > 0 && playerNames.map(function (pname) {
	        return players[pname];
	      }).every(Boolean)) {
	        throw new Error('Can not register Player component after player has been created.');
	      }
	    }
	
	    Component.components_[name] = ComponentToRegister;
	    Component.components_[toLowerCase(name)] = ComponentToRegister;
	    return ComponentToRegister;
	  }
	  /**
	   * Get a `Component` based on the name it was registered with.
	   *
	   * @param {string} name
	   *        The Name of the component to get.
	   *
	   * @return {Component}
	   *         The `Component` that got registered under the given name.
	   */
	  ;
	
	  Component.getComponent = function getComponent(name) {
	    if (!name || !Component.components_) {
	      return;
	    }
	
	    return Component.components_[name];
	  };
	
	  return Component;
	}();
	/**
	 * Whether or not this component supports `requestAnimationFrame`.
	 *
	 * This is exposed primarily for testing purposes.
	 *
	 * @private
	 * @type {Boolean}
	 */
	
	
	Component$1.prototype.supportsRaf_ = typeof window__default['default'].requestAnimationFrame === 'function' && typeof window__default['default'].cancelAnimationFrame === 'function';
	Component$1.registerComponent('Component', Component$1);
	
	/**
	 * @file time-ranges.js
	 * @module time-ranges
	 */
	/**
	 * Returns the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @typedef    {Function} TimeRangeIndex
	 *
	 * @param      {number} [index=0]
	 *             The range number to return the time for.
	 *
	 * @return     {number}
	 *             The time offset at the specified index.
	 *
	 * @deprecated The index argument must be provided.
	 *             In the future, leaving it out will throw an error.
	 */
	
	/**
	 * An object that contains ranges of time.
	 *
	 * @typedef  {Object} TimeRange
	 *
	 * @property {number} length
	 *           The number of time ranges represented by this object.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} start
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} end
	 *           Returns the time offset at which a specified time range ends.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	 */
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @private
	 * @param   {string} fnName
	 *          The function name to use for logging
	 *
	 * @param   {number} index
	 *          The index to check
	 *
	 * @param   {number} maxIndex
	 *          The maximum possible index
	 *
	 * @throws  {Error} if the timeRanges provided are over the maxIndex
	 */
	
	function rangeCheck(fnName, index, maxIndex) {
	  if (typeof index !== 'number' || index < 0 || index > maxIndex) {
	    throw new Error("Failed to execute '" + fnName + "' on 'TimeRanges': The index provided (" + index + ") is non-numeric or out of bounds (0-" + maxIndex + ").");
	  }
	}
	/**
	 * Get the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @private
	 * @param      {string} fnName
	 *             The function name to use for logging
	 *
	 * @param      {string} valueIndex
	 *             The property that should be used to get the time. should be
	 *             'start' or 'end'
	 *
	 * @param      {Array} ranges
	 *             An array of time ranges
	 *
	 * @param      {Array} [rangeIndex=0]
	 *             The index to start the search at
	 *
	 * @return     {number}
	 *             The time that offset at the specified index.
	 *
	 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
	 * @throws     {Error} if rangeIndex is more than the length of ranges
	 */
	
	
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
	  rangeCheck(fnName, rangeIndex, ranges.length - 1);
	  return ranges[rangeIndex][valueIndex];
	}
	/**
	 * Create a time range object given ranges of time.
	 *
	 * @private
	 * @param   {Array} [ranges]
	 *          An array of time ranges.
	 */
	
	
	function createTimeRangesObj(ranges) {
	  var timeRangesObj;
	
	  if (ranges === undefined || ranges.length === 0) {
	    timeRangesObj = {
	      length: 0,
	      start: function start() {
	        throw new Error('This TimeRanges object is empty');
	      },
	      end: function end() {
	        throw new Error('This TimeRanges object is empty');
	      }
	    };
	  } else {
	    timeRangesObj = {
	      length: ranges.length,
	      start: getRange.bind(null, 'start', 0, ranges),
	      end: getRange.bind(null, 'end', 1, ranges)
	    };
	  }
	
	  if (window__default['default'].Symbol && window__default['default'].Symbol.iterator) {
	    timeRangesObj[window__default['default'].Symbol.iterator] = function () {
	      return (ranges || []).values();
	    };
	  }
	
	  return timeRangesObj;
	}
	/**
	 * Create a `TimeRange` object which mimics an
	 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
	 *
	 * @param {number|Array[]} start
	 *        The start of a single range (a number) or an array of ranges (an
	 *        array of arrays of two numbers each).
	 *
	 * @param {number} end
	 *        The end of a single range. Cannot be used with the array form of
	 *        the `start` argument.
	 */
	
	
	function createTimeRanges(start, end) {
	  if (Array.isArray(start)) {
	    return createTimeRangesObj(start);
	  } else if (start === undefined || end === undefined) {
	    return createTimeRangesObj();
	  }
	
	  return createTimeRangesObj([[start, end]]);
	}
	
	/**
	 * @file buffer.js
	 * @module buffer
	 */
	/**
	 * Compute the percentage of the media that has been buffered.
	 *
	 * @param {TimeRange} buffered
	 *        The current `TimeRange` object representing buffered time ranges
	 *
	 * @param {number} duration
	 *        Total duration of the media
	 *
	 * @return {number}
	 *         Percent buffered of the total duration in decimal form.
	 */
	
	function bufferedPercent(buffered, duration) {
	  var bufferedDuration = 0;
	  var start;
	  var end;
	
	  if (!duration) {
	    return 0;
	  }
	
	  if (!buffered || !buffered.length) {
	    buffered = createTimeRanges(0, 0);
	  }
	
	  for (var i = 0; i < buffered.length; i++) {
	    start = buffered.start(i);
	    end = buffered.end(i); // buffered end can be bigger than duration by a very small fraction
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    bufferedDuration += end - start;
	  }
	
	  return bufferedDuration / duration;
	}
	
	/**
	 * @file media-error.js
	 */
	/**
	 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	 *
	 * @param {number|string|Object|MediaError} value
	 *        This can be of multiple types:
	 *        - number: should be a standard error code
	 *        - string: an error message (the code will be 0)
	 *        - Object: arbitrary properties
	 *        - `MediaError` (native): used to populate a video.js `MediaError` object
	 *        - `MediaError` (video.js): will return itself if it's already a
	 *          video.js `MediaError` object.
	 *
	 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	 *
	 * @class MediaError
	 */
	
	function MediaError(value) {
	  // Allow redundant calls to this constructor to avoid having `instanceof`
	  // checks peppered around the code.
	  if (value instanceof MediaError) {
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    this.code = value;
	  } else if (typeof value === 'string') {
	    // default code is zero, so this is a custom error
	    this.message = value;
	  } else if (isObject(value)) {
	    // We assign the `code` property manually because native `MediaError` objects
	    // do not expose it as an own/enumerable property of the object.
	    if (typeof value.code === 'number') {
	      this.code = value.code;
	    }
	
	    assign(this, value);
	  }
	
	  if (!this.message) {
	    this.message = MediaError.defaultMessages[this.code] || '';
	  }
	}
	/**
	 * The error code that refers two one of the defined `MediaError` types
	 *
	 * @type {Number}
	 */
	
	
	MediaError.prototype.code = 0;
	/**
	 * An optional message that to show with the error. Message is not part of the HTML5
	 * video spec but allows for more informative custom errors.
	 *
	 * @type {String}
	 */
	
	MediaError.prototype.message = '';
	/**
	 * An optional status code that can be set by plugins to allow even more detail about
	 * the error. For example a plugin might provide a specific HTTP status code and an
	 * error message for that code. Then when the plugin gets that error this class will
	 * know how to display an error message for it. This allows a custom message to show
	 * up on the `Player` error overlay.
	 *
	 * @type {Array}
	 */
	
	MediaError.prototype.status = null;
	/**
	 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	 * specification listed under {@link MediaError} for more information.
	 *
	 * @enum {array}
	 * @readonly
	 * @property {string} 0 - MEDIA_ERR_CUSTOM
	 * @property {string} 1 - MEDIA_ERR_ABORTED
	 * @property {string} 2 - MEDIA_ERR_NETWORK
	 * @property {string} 3 - MEDIA_ERR_DECODE
	 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
	 */
	
	MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];
	/**
	 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	 *
	 * @type {Array}
	 * @constant
	 */
	
	MediaError.defaultMessages = {
	  1: 'You aborted the media playback',
	  2: 'A network error caused the media download to fail part-way.',
	  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
	  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
	  5: 'The media is encrypted and we do not have the keys to decrypt it.'
	}; // Add types as properties on MediaError
	// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	
	for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
	  MediaError[MediaError.errorTypes[errNum]] = errNum; // values should be accessible on both the class and instance
	
	  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
	} // jsdocs for instance/static members added above
	
	/**
	 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
	 *
	 * @param  {Object}  value
	 *         An object that may or may not be `Promise`-like.
	 *
	 * @return {boolean}
	 *         Whether or not the object is `Promise`-like.
	 */
	function isPromise(value) {
	  return value !== undefined && value !== null && typeof value.then === 'function';
	}
	/**
	 * Silence a Promise-like object.
	 *
	 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
	 * play promise" rejection error messages.
	 *
	 * @param  {Object} value
	 *         An object that may or may not be `Promise`-like.
	 */
	
	function silencePromise(value) {
	  if (isPromise(value)) {
	    value.then(null, function (e) {});
	  }
	}
	
	/**
	 * @file text-track-list-converter.js Utilities for capturing text track state and
	 * re-creating tracks based on a capture.
	 *
	 * @module text-track-list-converter
	 */
	
	/**
	 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	 * represents the {@link TextTrack}'s state.
	 *
	 * @param {TextTrack} track
	 *        The text track to query.
	 *
	 * @return {Object}
	 *         A serializable javascript representation of the TextTrack.
	 * @private
	 */
	var trackToJson_ = function trackToJson_(track) {
	  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {
	    if (track[prop]) {
	      acc[prop] = track[prop];
	    }
	
	    return acc;
	  }, {
	    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
	      return {
	        startTime: cue.startTime,
	        endTime: cue.endTime,
	        text: cue.text,
	        id: cue.id
	      };
	    })
	  });
	  return ret;
	};
	/**
	 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	 * state of all {@link TextTrack}s currently configured. The return array is compatible with
	 * {@link text-track-list-converter:jsonToTextTracks}.
	 *
	 * @param {Tech} tech
	 *        The tech object to query
	 *
	 * @return {Array}
	 *         A serializable javascript representation of the {@link Tech}s
	 *         {@link TextTrackList}.
	 */
	
	
	var textTracksToJson = function textTracksToJson(tech) {
	  var trackEls = tech.$$('track');
	  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
	    return t.track;
	  });
	  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
	    var json = trackToJson_(trackEl.track);
	
	    if (trackEl.src) {
	      json.src = trackEl.src;
	    }
	
	    return json;
	  });
	  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
	    return trackObjs.indexOf(track) === -1;
	  }).map(trackToJson_));
	};
	/**
	 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	 * object {@link TextTrack} representations.
	 *
	 * @param {Array} json
	 *        An array of `TextTrack` representation objects, like those that would be
	 *        produced by `textTracksToJson`.
	 *
	 * @param {Tech} tech
	 *        The `Tech` to create the `TextTrack`s on.
	 */
	
	
	var jsonToTextTracks = function jsonToTextTracks(json, tech) {
	  json.forEach(function (track) {
	    var addedTrack = tech.addRemoteTextTrack(track).track;
	
	    if (!track.src && track.cues) {
	      track.cues.forEach(function (cue) {
	        return addedTrack.addCue(cue);
	      });
	    }
	  });
	  return tech.textTracks();
	};
	
	var textTrackConverter = {
	  textTracksToJson: textTracksToJson,
	  jsonToTextTracks: jsonToTextTracks,
	  trackToJson_: trackToJson_
	};
	
	var MODAL_CLASS_NAME = 'vjs-modal-dialog';
	/**
	 * The `ModalDialog` displays over the video and its controls, which blocks
	 * interaction with the player until it is closed.
	 *
	 * Modal dialogs include a "Close" button and will close when that button
	 * is activated - or when ESC is pressed anywhere.
	 *
	 * @extends Component
	 */
	
	var ModalDialog = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ModalDialog, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Mixed} [options.content=undefined]
	   *        Provide customized content for this modal.
	   *
	   * @param {string} [options.description]
	   *        A text description for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.fillAlways=false]
	   *        Normally, modals are automatically filled only the first time
	   *        they open. This tells the modal to refresh its content
	   *        every time it opens.
	   *
	   * @param {string} [options.label]
	   *        A text label for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.pauseOnOpen=true]
	   *        If `true`, playback will will be paused if playing when
	   *        the modal opens, and resumed when it closes.
	   *
	   * @param {boolean} [options.temporary=true]
	   *        If `true`, the modal can only be opened once; it will be
	   *        disposed as soon as it's closed.
	   *
	   * @param {boolean} [options.uncloseable=false]
	   *        If `true`, the user will not be able to close the modal
	   *        through the UI in the normal ways. Programmatic closing is
	   *        still possible.
	   */
	  function ModalDialog(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.close_ = function (e) {
	      return _this.close(e);
	    };
	
	    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
	
	    _this.closeable(!_this.options_.uncloseable);
	
	    _this.content(_this.options_.content); // Make sure the contentEl is defined AFTER any children are initialized
	    // because we only want the contents of the modal in the contentEl
	    // (not the UI elements like the close button).
	
	
	    _this.contentEl_ = createEl('div', {
	      className: MODAL_CLASS_NAME + "-content"
	    }, {
	      role: 'document'
	    });
	    _this.descEl_ = createEl('p', {
	      className: MODAL_CLASS_NAME + "-description vjs-control-text",
	      id: _this.el().getAttribute('aria-describedby')
	    });
	    textContent(_this.descEl_, _this.description());
	
	    _this.el_.appendChild(_this.descEl_);
	
	    _this.el_.appendChild(_this.contentEl_);
	
	    return _this;
	  }
	  /**
	   * Create the `ModalDialog`'s DOM element
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  var _proto = ModalDialog.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      tabIndex: -1
	    }, {
	      'aria-describedby': this.id() + "_description",
	      'aria-hidden': 'true',
	      'aria-label': this.label(),
	      'role': 'dialog'
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.descEl_ = null;
	    this.previouslyActiveEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return MODAL_CLASS_NAME + " vjs-hidden " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Returns the label string for this modal. Primarily used for accessibility.
	   *
	   * @return {string}
	   *         the localized or raw label of this modal.
	   */
	  ;
	
	  _proto.label = function label() {
	    return this.localize(this.options_.label || 'Modal Window');
	  }
	  /**
	   * Returns the description string for this modal. Primarily used for
	   * accessibility.
	   *
	   * @return {string}
	   *         The localized or raw description of this modal.
	   */
	  ;
	
	  _proto.description = function description() {
	    var desc = this.options_.description || this.localize('This is a modal window.'); // Append a universal closeability message if the modal is closeable.
	
	    if (this.closeable()) {
	      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
	    }
	
	    return desc;
	  }
	  /**
	   * Opens the modal.
	   *
	   * @fires ModalDialog#beforemodalopen
	   * @fires ModalDialog#modalopen
	   */
	  ;
	
	  _proto.open = function open() {
	    if (!this.opened_) {
	      var player = this.player();
	      /**
	        * Fired just before a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#beforemodalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('beforemodalopen');
	      this.opened_ = true; // Fill content if the modal has never opened before and
	      // never been filled.
	
	      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
	        this.fill();
	      } // If the player was playing, pause it and take note of its previously
	      // playing state.
	
	
	      this.wasPlaying_ = !player.paused();
	
	      if (this.options_.pauseOnOpen && this.wasPlaying_) {
	        player.pause();
	      }
	
	      this.on('keydown', this.handleKeyDown_); // Hide controls and note if they were enabled.
	
	      this.hadControls_ = player.controls();
	      player.controls(false);
	      this.show();
	      this.conditionalFocus_();
	      this.el().setAttribute('aria-hidden', 'false');
	      /**
	        * Fired just after a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#modalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('modalopen');
	      this.hasBeenOpened_ = true;
	    }
	  }
	  /**
	   * If the `ModalDialog` is currently open or closed.
	   *
	   * @param  {boolean} [value]
	   *         If given, it will open (`true`) or close (`false`) the modal.
	   *
	   * @return {boolean}
	   *         the current open state of the modaldialog
	   */
	  ;
	
	  _proto.opened = function opened(value) {
	    if (typeof value === 'boolean') {
	      this[value ? 'open' : 'close']();
	    }
	
	    return this.opened_;
	  }
	  /**
	   * Closes the modal, does nothing if the `ModalDialog` is
	   * not open.
	   *
	   * @fires ModalDialog#beforemodalclose
	   * @fires ModalDialog#modalclose
	   */
	  ;
	
	  _proto.close = function close() {
	    if (!this.opened_) {
	      return;
	    }
	
	    var player = this.player();
	    /**
	      * Fired just before a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#beforemodalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalclose');
	    this.opened_ = false;
	
	    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
	      player.play();
	    }
	
	    this.off('keydown', this.handleKeyDown_);
	
	    if (this.hadControls_) {
	      player.controls(true);
	    }
	
	    this.hide();
	    this.el().setAttribute('aria-hidden', 'true');
	    /**
	      * Fired just after a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#modalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('modalclose');
	    this.conditionalBlur_();
	
	    if (this.options_.temporary) {
	      this.dispose();
	    }
	  }
	  /**
	   * Check to see if the `ModalDialog` is closeable via the UI.
	   *
	   * @param  {boolean} [value]
	   *         If given as a boolean, it will set the `closeable` option.
	   *
	   * @return {boolean}
	   *         Returns the final value of the closable option.
	   */
	  ;
	
	  _proto.closeable = function closeable(value) {
	    if (typeof value === 'boolean') {
	      var closeable = this.closeable_ = !!value;
	      var close = this.getChild('closeButton'); // If this is being made closeable and has no close button, add one.
	
	      if (closeable && !close) {
	        // The close button should be a child of the modal - not its
	        // content element, so temporarily change the content element.
	        var temp = this.contentEl_;
	        this.contentEl_ = this.el_;
	        close = this.addChild('closeButton', {
	          controlText: 'Close Modal Dialog'
	        });
	        this.contentEl_ = temp;
	        this.on(close, 'close', this.close_);
	      } // If this is being made uncloseable and has a close button, remove it.
	
	
	      if (!closeable && close) {
	        this.off(close, 'close', this.close_);
	        this.removeChild(close);
	        close.dispose();
	      }
	    }
	
	    return this.closeable_;
	  }
	  /**
	   * Fill the modal's content element with the modal's "content" option.
	   * The content element will be emptied before this change takes place.
	   */
	  ;
	
	  _proto.fill = function fill() {
	    this.fillWith(this.content());
	  }
	  /**
	   * Fill the modal's content element with arbitrary content.
	   * The content element will be emptied before this change takes place.
	   *
	   * @fires ModalDialog#beforemodalfill
	   * @fires ModalDialog#modalfill
	   *
	   * @param {Mixed} [content]
	   *        The same rules apply to this as apply to the `content` option.
	   */
	  ;
	
	  _proto.fillWith = function fillWith(content) {
	    var contentEl = this.contentEl();
	    var parentEl = contentEl.parentNode;
	    var nextSiblingEl = contentEl.nextSibling;
	    /**
	      * Fired just before a `ModalDialog` is filled with content.
	      *
	      * @event ModalDialog#beforemodalfill
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalfill');
	    this.hasBeenFilled_ = true; // Detach the content element from the DOM before performing
	    // manipulation to avoid modifying the live DOM multiple times.
	
	    parentEl.removeChild(contentEl);
	    this.empty();
	    insertContent(contentEl, content);
	    /**
	     * Fired just after a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#modalfill
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('modalfill'); // Re-inject the re-filled content element.
	
	    if (nextSiblingEl) {
	      parentEl.insertBefore(contentEl, nextSiblingEl);
	    } else {
	      parentEl.appendChild(contentEl);
	    } // make sure that the close button is last in the dialog DOM
	
	
	    var closeButton = this.getChild('closeButton');
	
	    if (closeButton) {
	      parentEl.appendChild(closeButton.el_);
	    }
	  }
	  /**
	   * Empties the content element. This happens anytime the modal is filled.
	   *
	   * @fires ModalDialog#beforemodalempty
	   * @fires ModalDialog#modalempty
	   */
	  ;
	
	  _proto.empty = function empty() {
	    /**
	    * Fired just before a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#beforemodalempty
	    * @type {EventTarget~Event}
	    */
	    this.trigger('beforemodalempty');
	    emptyEl(this.contentEl());
	    /**
	    * Fired just after a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#modalempty
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('modalempty');
	  }
	  /**
	   * Gets or sets the modal content, which gets normalized before being
	   * rendered into the DOM.
	   *
	   * This does not update the DOM or fill the modal, but it is called during
	   * that process.
	   *
	   * @param  {Mixed} [value]
	   *         If defined, sets the internal content value to be used on the
	   *         next call(s) to `fill`. This value is normalized before being
	   *         inserted. To "clear" the internal content value, pass `null`.
	   *
	   * @return {Mixed}
	   *         The current content of the modal dialog
	   */
	  ;
	
	  _proto.content = function content(value) {
	    if (typeof value !== 'undefined') {
	      this.content_ = value;
	    }
	
	    return this.content_;
	  }
	  /**
	   * conditionally focus the modal dialog if focus was previously on the player.
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalFocus_ = function conditionalFocus_() {
	    var activeEl = document__default['default'].activeElement;
	    var playerEl = this.player_.el_;
	    this.previouslyActiveEl_ = null;
	
	    if (playerEl.contains(activeEl) || playerEl === activeEl) {
	      this.previouslyActiveEl_ = activeEl;
	      this.focus();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the last focused element
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    if (this.previouslyActiveEl_) {
	      this.previouslyActiveEl_.focus();
	      this.previouslyActiveEl_ = null;
	    }
	  }
	  /**
	   * Keydown handler. Attached when modal is focused.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Do not allow keydowns to reach out of the modal dialog.
	    event.stopPropagation();
	
	    if (keycode__default['default'].isEventKey(event, 'Escape') && this.closeable()) {
	      event.preventDefault();
	      this.close();
	      return;
	    } // exit early if it isn't a tab key
	
	
	    if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	      return;
	    }
	
	    var focusableEls = this.focusableEls_();
	    var activeEl = this.el_.querySelector(':focus');
	    var focusIndex;
	
	    for (var i = 0; i < focusableEls.length; i++) {
	      if (activeEl === focusableEls[i]) {
	        focusIndex = i;
	        break;
	      }
	    }
	
	    if (document__default['default'].activeElement === this.el_) {
	      focusIndex = 0;
	    }
	
	    if (event.shiftKey && focusIndex === 0) {
	      focusableEls[focusableEls.length - 1].focus();
	      event.preventDefault();
	    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
	      focusableEls[0].focus();
	      event.preventDefault();
	    }
	  }
	  /**
	   * get all focusable elements
	   *
	   * @private
	   */
	  ;
	
	  _proto.focusableEls_ = function focusableEls_() {
	    var allChildren = this.el_.querySelectorAll('*');
	    return Array.prototype.filter.call(allChildren, function (child) {
	      return (child instanceof window__default['default'].HTMLAnchorElement || child instanceof window__default['default'].HTMLAreaElement) && child.hasAttribute('href') || (child instanceof window__default['default'].HTMLInputElement || child instanceof window__default['default'].HTMLSelectElement || child instanceof window__default['default'].HTMLTextAreaElement || child instanceof window__default['default'].HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof window__default['default'].HTMLIFrameElement || child instanceof window__default['default'].HTMLObjectElement || child instanceof window__default['default'].HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
	    });
	  };
	
	  return ModalDialog;
	}(Component$1);
	/**
	 * Default options for `ModalDialog` default options.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ModalDialog.prototype.options_ = {
	  pauseOnOpen: true,
	  temporary: true
	};
	Component$1.registerComponent('ModalDialog', ModalDialog);
	
	/**
	 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	 * {@link VideoTrackList}
	 *
	 * @extends EventTarget
	 */
	
	var TrackList = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](TrackList, _EventTarget);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Track[]} tracks
	   *        A list of tracks to initialize the list with.
	   *
	   * @abstract
	   */
	  function TrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.tracks_ = [];
	    /**
	     * @memberof TrackList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'length', {
	      get: function get() {
	        return this.tracks_.length;
	      }
	    });
	
	    for (var i = 0; i < tracks.length; i++) {
	      _this.addTrack(tracks[i]);
	    }
	
	    return _this;
	  }
	  /**
	   * Add a {@link Track} to the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = TrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    var index = this.tracks_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.tracks_[index];
	        }
	      });
	    } // Do not add duplicate tracks
	
	
	    if (this.tracks_.indexOf(track) === -1) {
	      this.tracks_.push(track);
	      /**
	       * Triggered when a track is added to a track list.
	       *
	       * @event TrackList#addtrack
	       * @type {EventTarget~Event}
	       * @property {Track} track
	       *           A reference to track that was added.
	       */
	
	      this.trigger({
	        track: track,
	        type: 'addtrack',
	        target: this
	      });
	    }
	    /**
	     * Triggered when a track label is changed.
	     *
	     * @event TrackList#addtrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was added.
	     */
	
	
	    track.labelchange_ = function () {
	      _this2.trigger({
	        track: track,
	        type: 'labelchange',
	        target: _this2
	      });
	    };
	
	    if (isEvented(track)) {
	      track.addEventListener('labelchange', track.labelchange_);
	    }
	  }
	  /**
	   * Remove a {@link Track} from the `TrackList`
	   *
	   * @param {Track} rtrack
	   *        The audio, video, or text track to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   */
	  ;
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    var track;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (this[i] === rtrack) {
	        track = this[i];
	
	        if (track.off) {
	          track.off();
	        }
	
	        this.tracks_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!track) {
	      return;
	    }
	    /**
	     * Triggered when a track is removed from track list.
	     *
	     * @event TrackList#removetrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was removed.
	     */
	
	
	    this.trigger({
	      track: track,
	      type: 'removetrack',
	      target: this
	    });
	  }
	  /**
	   * Get a Track from the TrackList by a tracks id
	   *
	   * @param {string} id - the id of the track to get
	   * @method getTrackById
	   * @return {Track}
	   * @private
	   */
	  ;
	
	  _proto.getTrackById = function getTrackById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var track = this[i];
	
	      if (track.id === id) {
	        result = track;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TrackList;
	}(EventTarget$2);
	/**
	 * Triggered when a different track is selected/enabled.
	 *
	 * @event TrackList#change
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Events that can be called with on + eventName. See {@link EventHandler}.
	 *
	 * @property {Object} TrackList#allowedEvents_
	 * @private
	 */
	
	
	TrackList.prototype.allowedEvents_ = {
	  change: 'change',
	  addtrack: 'addtrack',
	  removetrack: 'removetrack',
	  labelchange: 'labelchange'
	}; // emulate attribute EventHandler support to allow for feature detection
	
	for (var event in TrackList.prototype.allowedEvents_) {
	  TrackList.prototype['on' + event] = null;
	}
	
	/**
	 * Anywhere we call this function we diverge from the spec
	 * as we only support one enabled audiotrack at a time
	 *
	 * @param {AudioTrackList} list
	 *        list to work on
	 *
	 * @param {AudioTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers$1 = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another audio track is enabled, disable it
	
	
	    list[i].enabled = false;
	  }
	};
	/**
	 * The current list of {@link AudioTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	 * @extends TrackList
	 */
	
	
	var AudioTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](AudioTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {AudioTrack[]} [tracks=[]]
	   *        A list of `AudioTrack` to instantiate the list with.
	   */
	  function AudioTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].enabled) {
	        disableOthers$1(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    return _this;
	  }
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = AudioTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.enabled) {
	      disableOthers$1(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.enabledChange_ = function () {
	      // when we are disabling other tracks (since we don't support
	      // more than one track at a time) we will set changing_
	      // to true so that we don't trigger additional change events
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers$1(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens AudioTrack#enabledchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('enabledchange', track.enabledChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.enabledChange_) {
	      rtrack.removeEventListener('enabledchange', rtrack.enabledChange_);
	      rtrack.enabledChange_ = null;
	    }
	  };
	
	  return AudioTrackList;
	}(TrackList);
	
	/**
	 * Un-select all other {@link VideoTrack}s that are selected.
	 *
	 * @param {VideoTrackList} list
	 *        list to work on
	 *
	 * @param {VideoTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another video track is enabled, disable it
	
	
	    list[i].selected = false;
	  }
	};
	/**
	 * The current list of {@link VideoTrack} for a video.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	 * @extends TrackList
	 */
	
	
	var VideoTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](VideoTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {VideoTrack[]} [tracks=[]]
	   *        A list of `VideoTrack` to instantiate the list with.
	   */
	  function VideoTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].selected) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    /**
	     * @member {number} VideoTrackList#selectedIndex
	     *         The current index of the selected {@link VideoTrack`}.
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selectedIndex', {
	      get: function get() {
	        for (var _i = 0; _i < this.length; _i++) {
	          if (this[_i].selected) {
	            return _i;
	          }
	        }
	
	        return -1;
	      },
	      set: function set() {}
	    });
	    return _this;
	  }
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = VideoTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.selected) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.selectedChange_ = function () {
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens VideoTrack#selectedchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('selectedchange', track.selectedChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.selectedChange_) {
	      rtrack.removeEventListener('selectedchange', rtrack.selectedChange_);
	      rtrack.selectedChange_ = null;
	    }
	  };
	
	  return VideoTrackList;
	}(TrackList);
	
	/**
	 * The current list of {@link TextTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	 * @extends TrackList
	 */
	
	var TextTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](TextTrackList, _TrackList);
	
	  function TextTrackList() {
	    return _TrackList.apply(this, arguments) || this;
	  }
	
	  var _proto = TextTrackList.prototype;
	
	  /**
	   * Add a {@link TextTrack} to the `TextTrackList`
	   *
	   * @param {TextTrack} track
	   *        The text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	  _proto.addTrack = function addTrack(track) {
	    var _this = this;
	
	    _TrackList.prototype.addTrack.call(this, track);
	
	    if (!this.queueChange_) {
	      this.queueChange_ = function () {
	        return _this.queueTrigger('change');
	      };
	    }
	
	    if (!this.triggerSelectedlanguagechange) {
	      this.triggerSelectedlanguagechange_ = function () {
	        return _this.trigger('selectedlanguagechange');
	      };
	    }
	    /**
	     * @listens TextTrack#modechange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('modechange', this.queueChange_);
	    var nonLanguageTextTrackKind = ['metadata', 'chapters'];
	
	    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
	      track.addEventListener('modechange', this.triggerSelectedlanguagechange_);
	    }
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack); // manually remove the event handlers we added
	
	
	    if (rtrack.removeEventListener) {
	      if (this.queueChange_) {
	        rtrack.removeEventListener('modechange', this.queueChange_);
	      }
	
	      if (this.selectedlanguagechange_) {
	        rtrack.removeEventListener('modechange', this.triggerSelectedlanguagechange_);
	      }
	    }
	  };
	
	  return TextTrackList;
	}(TrackList);
	
	/**
	 * @file html-track-element-list.js
	 */
	
	/**
	 * The current list of {@link HtmlTrackElement}s.
	 */
	var HtmlTrackElementList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class.
	   *
	   * @param {HtmlTrackElement[]} [tracks=[]]
	   *        A list of `HtmlTrackElement` to instantiate the list with.
	   */
	  function HtmlTrackElementList(trackElements) {
	    if (trackElements === void 0) {
	      trackElements = [];
	    }
	
	    this.trackElements_ = [];
	    /**
	     * @memberof HtmlTrackElementList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.trackElements_.length;
	      }
	    });
	
	    for (var i = 0, length = trackElements.length; i < length; i++) {
	      this.addTrackElement_(trackElements[i]);
	    }
	  }
	  /**
	   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to add to the list.
	   *
	   * @private
	   */
	
	
	  var _proto = HtmlTrackElementList.prototype;
	
	  _proto.addTrackElement_ = function addTrackElement_(trackElement) {
	    var index = this.trackElements_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.trackElements_[index];
	        }
	      });
	    } // Do not add duplicate elements
	
	
	    if (this.trackElements_.indexOf(trackElement) === -1) {
	      this.trackElements_.push(trackElement);
	    }
	  }
	  /**
	   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
	   * {@link TextTrack}.
	   *
	   * @param {TextTrack} track
	   *        The track associated with a track element.
	   *
	   * @return {HtmlTrackElement|undefined}
	   *         The track element that was found or undefined.
	   *
	   * @private
	   */
	  ;
	
	  _proto.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
	    var trackElement_;
	
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (track === this.trackElements_[i].track) {
	        trackElement_ = this.trackElements_[i];
	        break;
	      }
	    }
	
	    return trackElement_;
	  }
	  /**
	   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to remove from the list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTrackElement_ = function removeTrackElement_(trackElement) {
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (trackElement === this.trackElements_[i]) {
	        if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === 'function') {
	          this.trackElements_[i].track.off();
	        }
	
	        if (typeof this.trackElements_[i].off === 'function') {
	          this.trackElements_[i].off();
	        }
	
	        this.trackElements_.splice(i, 1);
	        break;
	      }
	    }
	  };
	
	  return HtmlTrackElementList;
	}();
	
	/**
	 * @file text-track-cue-list.js
	 */
	
	/**
	 * @typedef {Object} TextTrackCueList~TextTrackCue
	 *
	 * @property {string} id
	 *           The unique id for this text track cue
	 *
	 * @property {number} startTime
	 *           The start time for this text track cue
	 *
	 * @property {number} endTime
	 *           The end time for this text track cue
	 *
	 * @property {boolean} pauseOnExit
	 *           Pause when the end time is reached if true.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	 */
	
	/**
	 * A List of TextTrackCues.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	 */
	var TextTrackCueList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class..
	   *
	   * @param {Array} cues
	   *        A list of cues to be initialized with
	   */
	  function TextTrackCueList(cues) {
	    TextTrackCueList.prototype.setCues_.call(this, cues);
	    /**
	     * @memberof TextTrackCueList
	     * @member {number} length
	     *         The current number of `TextTrackCue`s in the TextTrackCueList.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.length_;
	      }
	    });
	  }
	  /**
	   * A setter for cues in this list. Creates getters
	   * an an index for the cues.
	   *
	   * @param {Array} cues
	   *        An array of cues to set
	   *
	   * @private
	   */
	
	
	  var _proto = TextTrackCueList.prototype;
	
	  _proto.setCues_ = function setCues_(cues) {
	    var oldLength = this.length || 0;
	    var i = 0;
	    var l = cues.length;
	    this.cues_ = cues;
	    this.length_ = cues.length;
	
	    var defineProp = function defineProp(index) {
	      if (!('' + index in this)) {
	        Object.defineProperty(this, '' + index, {
	          get: function get() {
	            return this.cues_[index];
	          }
	        });
	      }
	    };
	
	    if (oldLength < l) {
	      i = oldLength;
	
	      for (; i < l; i++) {
	        defineProp.call(this, i);
	      }
	    }
	  }
	  /**
	   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
	   *
	   * @param {string} id
	   *        The id of the cue that should be searched for.
	   *
	   * @return {TextTrackCueList~TextTrackCue|null}
	   *         A single cue or null if none was found.
	   */
	  ;
	
	  _proto.getCueById = function getCueById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var cue = this[i];
	
	      if (cue.id === id) {
	        result = cue;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TextTrackCueList;
	}();
	
	/**
	 * @file track-kinds.js
	 */
	
	/**
	 * All possible `VideoTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	 * @typedef VideoTrack~Kind
	 * @enum
	 */
	var VideoTrackKind = {
	  alternative: 'alternative',
	  captions: 'captions',
	  main: 'main',
	  sign: 'sign',
	  subtitles: 'subtitles',
	  commentary: 'commentary'
	};
	/**
	 * All possible `AudioTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	 * @typedef AudioTrack~Kind
	 * @enum
	 */
	
	var AudioTrackKind = {
	  'alternative': 'alternative',
	  'descriptions': 'descriptions',
	  'main': 'main',
	  'main-desc': 'main-desc',
	  'translation': 'translation',
	  'commentary': 'commentary'
	};
	/**
	 * All possible `TextTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	 * @typedef TextTrack~Kind
	 * @enum
	 */
	
	var TextTrackKind = {
	  subtitles: 'subtitles',
	  captions: 'captions',
	  descriptions: 'descriptions',
	  chapters: 'chapters',
	  metadata: 'metadata'
	};
	/**
	 * All possible `TextTrackMode`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	 * @typedef TextTrack~Mode
	 * @enum
	 */
	
	var TextTrackMode = {
	  disabled: 'disabled',
	  hidden: 'hidden',
	  showing: 'showing'
	};
	
	/**
	 * A Track class that contains all of the common functionality for {@link AudioTrack},
	 * {@link VideoTrack}, and {@link TextTrack}.
	 *
	 * > Note: This class should not be used directly
	 *
	 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	 * @extends EventTarget
	 * @abstract
	 */
	
	var Track = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](Track, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid kind for the track type you are creating.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @abstract
	   */
	  function Track(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var trackProps = {
	      id: options.id || 'vjs_track_' + newGUID(),
	      kind: options.kind || '',
	      language: options.language || ''
	    };
	    var label = options.label || '';
	    /**
	     * @memberof Track
	     * @member {string} id
	     *         The id of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} kind
	     *         The kind of track that this is. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} language
	     *         The two letter language code for this track. Cannot be changed after
	     *         creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(_assertThisInitialized__default['default'](_this), key, {
	        get: function get() {
	          return trackProps[key];
	        },
	        set: function set() {}
	      });
	    };
	
	    for (var key in trackProps) {
	      _loop(key);
	    }
	    /**
	     * @memberof Track
	     * @member {string} label
	     *         The label of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @fires Track#labelchange
	     */
	
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'label', {
	      get: function get() {
	        return label;
	      },
	      set: function set(newLabel) {
	        if (newLabel !== label) {
	          label = newLabel;
	          /**
	           * An event that fires when label changes on this track.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event Track#labelchange
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('labelchange');
	        }
	      }
	    });
	    return _this;
	  }
	
	  return Track;
	}(EventTarget$2);
	
	/**
	 * @file url.js
	 * @module url
	 */
	/**
	 * @typedef {Object} url:URLObject
	 *
	 * @property {string} protocol
	 *           The protocol of the url that was parsed.
	 *
	 * @property {string} hostname
	 *           The hostname of the url that was parsed.
	 *
	 * @property {string} port
	 *           The port of the url that was parsed.
	 *
	 * @property {string} pathname
	 *           The pathname of the url that was parsed.
	 *
	 * @property {string} search
	 *           The search query of the url that was parsed.
	 *
	 * @property {string} hash
	 *           The hash of the url that was parsed.
	 *
	 * @property {string} host
	 *           The host of the url that was parsed.
	 */
	
	/**
	 * Resolve and parse the elements of a URL.
	 *
	 * @function
	 * @param    {String} url
	 *           The url to parse
	 *
	 * @return   {url:URLObject}
	 *           An object of url details
	 */
	
	var parseUrl = function parseUrl(url) {
	  // This entire method can be replace with URL once we are able to drop IE11
	  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host']; // add the url to an anchor and let the browser parse the URL
	
	  var a = document__default['default'].createElement('a');
	  a.href = url; // Copy the specific URL properties to a new object
	  // This is also needed for IE because the anchor loses its
	  // properties when it's removed from the dom
	
	  var details = {};
	
	  for (var i = 0; i < props.length; i++) {
	    details[props[i]] = a[props[i]];
	  } // IE adds the port to the host property unlike everyone else. If
	  // a port identifier is added for standard ports, strip it.
	
	
	  if (details.protocol === 'http:') {
	    details.host = details.host.replace(/:80$/, '');
	  }
	
	  if (details.protocol === 'https:') {
	    details.host = details.host.replace(/:443$/, '');
	  }
	
	  if (!details.protocol) {
	    details.protocol = window__default['default'].location.protocol;
	  }
	  /* istanbul ignore if */
	
	
	  if (!details.host) {
	    details.host = window__default['default'].location.host;
	  }
	
	  return details;
	};
	/**
	 * Get absolute version of relative URL. Used to tell Flash the correct URL.
	 *
	 * @function
	 * @param    {string} url
	 *           URL to make absolute
	 *
	 * @return   {string}
	 *           Absolute URL
	 *
	 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
	 */
	
	var getAbsoluteURL = function getAbsoluteURL(url) {
	  // Check if absolute URL
	  if (!url.match(/^https?:\/\//)) {
	    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
	    // add the url to an anchor and let the browser parse the URL
	    var a = document__default['default'].createElement('a');
	    a.href = url;
	    url = a.href;
	  }
	
	  return url;
	};
	/**
	 * Returns the extension of the passed file name. It will return an empty string
	 * if passed an invalid path.
	 *
	 * @function
	 * @param    {string} path
	 *           The fileName path like '/path/to/file.mp4'
	 *
	 * @return  {string}
	 *           The extension in lower case or an empty string if no
	 *           extension could be found.
	 */
	
	var getFileExtension = function getFileExtension(path) {
	  if (typeof path === 'string') {
	    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;
	    var pathParts = splitPathRe.exec(path);
	
	    if (pathParts) {
	      return pathParts.pop().toLowerCase();
	    }
	  }
	
	  return '';
	};
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @function
	 * @param    {string} url
	 *           The url to check.
	 *
	 * @param    {Object} [winLoc]
	 *           the domain to check the url against, defaults to window.location
	 *
	 * @param    {string} [winLoc.protocol]
	 *           The window location protocol defaults to window.location.protocol
	 *
	 * @param    {string} [winLoc.host]
	 *           The window location host defaults to window.location.host
	 *
	 * @return   {boolean}
	 *           Whether it is a cross domain request or not.
	 */
	
	var isCrossOrigin = function isCrossOrigin(url, winLoc) {
	  if (winLoc === void 0) {
	    winLoc = window__default['default'].location;
	  }
	
	  var urlInfo = parseUrl(url); // IE8 protocol relative urls will return ':' for protocol
	
	  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol; // Check if url is for another domain/origin
	  // IE8 doesn't know location.origin, so we won't rely on it here
	
	  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
	  return crossOrigin;
	};
	
	var Url = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  parseUrl: parseUrl,
	  getAbsoluteURL: getAbsoluteURL,
	  getFileExtension: getFileExtension,
	  isCrossOrigin: isCrossOrigin
	});
	
	/**
	 * Takes a webvtt file contents and parses it into cues
	 *
	 * @param {string} srcContent
	 *        webVTT file contents
	 *
	 * @param {TextTrack} track
	 *        TextTrack to add cues to. Cues come from the srcContent.
	 *
	 * @private
	 */
	
	var parseCues = function parseCues(srcContent, track) {
	  var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, window__default['default'].WebVTT.StringDecoder());
	  var errors = [];
	
	  parser.oncue = function (cue) {
	    track.addCue(cue);
	  };
	
	  parser.onparsingerror = function (error) {
	    errors.push(error);
	  };
	
	  parser.onflush = function () {
	    track.trigger({
	      type: 'loadeddata',
	      target: track
	    });
	  };
	
	  parser.parse(srcContent);
	
	  if (errors.length > 0) {
	    if (window__default['default'].console && window__default['default'].console.groupCollapsed) {
	      window__default['default'].console.groupCollapsed("Text Track parsing errors for " + track.src);
	    }
	
	    errors.forEach(function (error) {
	      return log$1.error(error);
	    });
	
	    if (window__default['default'].console && window__default['default'].console.groupEnd) {
	      window__default['default'].console.groupEnd();
	    }
	  }
	
	  parser.flush();
	};
	/**
	 * Load a `TextTrack` from a specified url.
	 *
	 * @param {string} src
	 *        Url to load track from.
	 *
	 * @param {TextTrack} track
	 *        Track to add cues to. Comes from the content at the end of `url`.
	 *
	 * @private
	 */
	
	
	var loadTrack = function loadTrack(src, track) {
	  var opts = {
	    uri: src
	  };
	  var crossOrigin = isCrossOrigin(src);
	
	  if (crossOrigin) {
	    opts.cors = crossOrigin;
	  }
	
	  var withCredentials = track.tech_.crossOrigin() === 'use-credentials';
	
	  if (withCredentials) {
	    opts.withCredentials = withCredentials;
	  }
	
	  XHR__default['default'](opts, bind(this, function (err, response, responseBody) {
	    if (err) {
	      return log$1.error(err, response);
	    }
	
	    track.loaded_ = true; // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	    // NOTE: this is only used for the alt/video.novtt.js build
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      if (track.tech_) {
	        // to prevent use before define eslint error, we define loadHandler
	        // as a let here
	        track.tech_.any(['vttjsloaded', 'vttjserror'], function (event) {
	          if (event.type === 'vttjserror') {
	            log$1.error("vttjs failed to load, stopping trying to process " + track.src);
	            return;
	          }
	
	          return parseCues(responseBody, track);
	        });
	      }
	    } else {
	      parseCues(responseBody, track);
	    }
	  }));
	};
	/**
	 * A representation of a single `TextTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	 * @extends Track
	 */
	
	
	var TextTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](TextTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this TextTrack.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function TextTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!options.tech) {
	      throw new Error('A tech was not provided.');
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: TextTrackKind[options.kind] || 'subtitles',
	      language: options.language || options.srclang || ''
	    });
	    var mode = TextTrackMode[settings.mode] || 'disabled';
	    var default_ = settings["default"];
	
	    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
	      mode = 'hidden';
	    }
	
	    _this = _Track.call(this, settings) || this;
	    _this.tech_ = settings.tech;
	    _this.cues_ = [];
	    _this.activeCues_ = [];
	    _this.preload_ = _this.tech_.preloadTextTracks !== false;
	    var cues = new TextTrackCueList(_this.cues_);
	    var activeCues = new TextTrackCueList(_this.activeCues_);
	    var changed = false;
	    _this.timeupdateHandler = bind(_assertThisInitialized__default['default'](_this), function (event) {
	      if (event === void 0) {
	        event = {};
	      }
	
	      if (this.tech_.isDisposed()) {
	        return;
	      }
	
	      if (!this.tech_.isReady_) {
	        if (event.type !== 'timeupdate') {
	          this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	        }
	
	        return;
	      } // Accessing this.activeCues for the side-effects of updating itself
	      // due to its nature as a getter function. Do not remove or cues will
	      // stop updating!
	      // Use the setter to prevent deletion from uglify (pure_getters rule)
	
	
	      this.activeCues = this.activeCues;
	
	      if (changed) {
	        this.trigger('cuechange');
	        changed = false;
	      }
	
	      if (event.type !== 'timeupdate') {
	        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	      }
	    });
	
	    var disposeHandler = function disposeHandler() {
	      _this.stopTracking();
	    };
	
	    _this.tech_.one('dispose', disposeHandler);
	
	    if (mode !== 'disabled') {
	      _this.startTracking();
	    }
	
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof TextTrack
	       * @member {boolean} default
	       *         If this track was set to be on or off by default. Cannot be changed after
	       *         creation.
	       * @instance
	       *
	       * @readonly
	       */
	      "default": {
	        get: function get() {
	          return default_;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {string} mode
	       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
	       *         not be set if setting to an invalid mode.
	       * @instance
	       *
	       * @fires TextTrack#modechange
	       */
	      mode: {
	        get: function get() {
	          return mode;
	        },
	        set: function set(newMode) {
	          if (!TextTrackMode[newMode]) {
	            return;
	          }
	
	          if (mode === newMode) {
	            return;
	          }
	
	          mode = newMode;
	
	          if (!this.preload_ && mode !== 'disabled' && this.cues.length === 0) {
	            // On-demand load.
	            loadTrack(this.src, this);
	          }
	
	          this.stopTracking();
	
	          if (mode !== 'disabled') {
	            this.startTracking();
	          }
	          /**
	           * An event that fires when mode changes on this track. This allows
	           * the TextTrackList that holds this track to act accordingly.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event TextTrack#modechange
	           * @type {EventTarget~Event}
	           */
	
	
	          this.trigger('modechange');
	        }
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} cues
	       *         The text track cue list for this TextTrack.
	       * @instance
	       */
	      cues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          }
	
	          return cues;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} activeCues
	       *         The list text track cues that are currently active for this TextTrack.
	       * @instance
	       */
	      activeCues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          } // nothing to do
	
	
	          if (this.cues.length === 0) {
	            return activeCues;
	          }
	
	          var ct = this.tech_.currentTime();
	          var active = [];
	
	          for (var i = 0, l = this.cues.length; i < l; i++) {
	            var cue = this.cues[i];
	
	            if (cue.startTime <= ct && cue.endTime >= ct) {
	              active.push(cue);
	            } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
	              active.push(cue);
	            }
	          }
	
	          changed = false;
	
	          if (active.length !== this.activeCues_.length) {
	            changed = true;
	          } else {
	            for (var _i = 0; _i < active.length; _i++) {
	              if (this.activeCues_.indexOf(active[_i]) === -1) {
	                changed = true;
	              }
	            }
	          }
	
	          this.activeCues_ = active;
	          activeCues.setCues_(this.activeCues_);
	          return activeCues;
	        },
	        // /!\ Keep this setter empty (see the timeupdate handler above)
	        set: function set() {}
	      }
	    });
	
	    if (settings.src) {
	      _this.src = settings.src;
	
	      if (!_this.preload_) {
	        // Tracks will load on-demand.
	        // Act like we're loaded for other purposes.
	        _this.loaded_ = true;
	      }
	
	      if (_this.preload_ || settings.kind !== 'subtitles' && settings.kind !== 'captions') {
	        loadTrack(_this.src, _assertThisInitialized__default['default'](_this));
	      }
	    } else {
	      _this.loaded_ = true;
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrack.prototype;
	
	  _proto.startTracking = function startTracking() {
	    // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
	    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler); // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
	
	    this.tech_.on('timeupdate', this.timeupdateHandler);
	  };
	
	  _proto.stopTracking = function stopTracking() {
	    if (this.rvf_) {
	      this.tech_.cancelVideoFrameCallback(this.rvf_);
	      this.rvf_ = undefined;
	    }
	
	    this.tech_.off('timeupdate', this.timeupdateHandler);
	  }
	  /**
	   * Add a cue to the internal list of cues.
	   *
	   * @param {TextTrack~Cue} cue
	   *        The cue to add to our internal list
	   */
	  ;
	
	  _proto.addCue = function addCue(originalCue) {
	    var cue = originalCue; // Testing if the cue is a VTTCue in a way that survives minification
	
	    if (!('getCueAsHTML' in cue)) {
	      cue = new window__default['default'].vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
	
	      for (var prop in originalCue) {
	        if (!(prop in cue)) {
	          cue[prop] = originalCue[prop];
	        }
	      } // make sure that `id` is copied over
	
	
	      cue.id = originalCue.id;
	      cue.originalCue_ = originalCue;
	    }
	
	    var tracks = this.tech_.textTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      if (tracks[i] !== this) {
	        tracks[i].removeCue(cue);
	      }
	    }
	
	    this.cues_.push(cue);
	    this.cues.setCues_(this.cues_);
	  }
	  /**
	   * Remove a cue from our internal list
	   *
	   * @param {TextTrack~Cue} removeCue
	   *        The cue to remove from our internal list
	   */
	  ;
	
	  _proto.removeCue = function removeCue(_removeCue) {
	    var i = this.cues_.length;
	
	    while (i--) {
	      var cue = this.cues_[i];
	
	      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
	        this.cues_.splice(i, 1);
	        this.cues.setCues_(this.cues_);
	        break;
	      }
	    }
	  };
	
	  return TextTrack;
	}(Track);
	/**
	 * cuechange - One or more cues in the track have become active or stopped being active.
	 */
	
	
	TextTrack.prototype.allowedEvents_ = {
	  cuechange: 'cuechange'
	};
	
	/**
	 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	 * only one `AudioTrack` in the list will be enabled at a time.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	 * @extends Track
	 */
	
	var AudioTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](AudioTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {AudioTrack~Kind} [options.kind='']
	   *        A valid audio track kind
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.enabled]
	   *        If this track is the one that is currently playing. If this track is part of
	   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
	   */
	  function AudioTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: AudioTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var enabled = false;
	    /**
	     * @memberof AudioTrack
	     * @member {boolean} enabled
	     *         If this `AudioTrack` is enabled or not. When setting this will
	     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'enabled', {
	      get: function get() {
	        return enabled;
	      },
	      set: function set(newEnabled) {
	        // an invalid or unchanged value
	        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
	          return;
	        }
	
	        enabled = newEnabled;
	        /**
	         * An event that fires when enabled changes on this track. This allows
	         * the AudioTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event AudioTrack#enabledchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('enabledchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.enabled) {
	      _this.enabled = settings.enabled;
	    }
	
	    _this.loaded_ = true;
	    return _this;
	  }
	
	  return AudioTrack;
	}(Track);
	
	/**
	 * A representation of a single `VideoTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	 * @extends Track
	 */
	
	var VideoTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](VideoTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid {@link VideoTrack~Kind}
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.selected]
	   *        If this track is the one that is currently playing.
	   */
	  function VideoTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: VideoTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var selected = false;
	    /**
	     * @memberof VideoTrack
	     * @member {boolean} selected
	     *         If this `VideoTrack` is selected or not. When setting this will
	     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selected', {
	      get: function get() {
	        return selected;
	      },
	      set: function set(newSelected) {
	        // an invalid or unchanged value
	        if (typeof newSelected !== 'boolean' || newSelected === selected) {
	          return;
	        }
	
	        selected = newSelected;
	        /**
	         * An event that fires when selected changes on this track. This allows
	         * the VideoTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event VideoTrack#selectedchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('selectedchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.selected) {
	      _this.selected = settings.selected;
	    }
	
	    return _this;
	  }
	
	  return VideoTrack;
	}(Track);
	
	/**
	 * @memberof HTMLTrackElement
	 * @typedef {HTMLTrackElement~ReadyState}
	 * @enum {number}
	 */
	
	var NONE = 0;
	var LOADING = 1;
	var LOADED = 2;
	var ERROR = 3;
	/**
	 * A single track represented in the DOM.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	 * @extends EventTarget
	 */
	
	var HTMLTrackElement = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](HTMLTrackElement, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this HTMLTrackElement.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function HTMLTrackElement(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var readyState;
	    var track = new TextTrack(options);
	    _this.kind = track.kind;
	    _this.src = track.src;
	    _this.srclang = track.language;
	    _this.label = track.label;
	    _this["default"] = track["default"];
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof HTMLTrackElement
	       * @member {HTMLTrackElement~ReadyState} readyState
	       *         The current ready state of the track element.
	       * @instance
	       */
	      readyState: {
	        get: function get() {
	          return readyState;
	        }
	      },
	
	      /**
	       * @memberof HTMLTrackElement
	       * @member {TextTrack} track
	       *         The underlying TextTrack object.
	       * @instance
	       *
	       */
	      track: {
	        get: function get() {
	          return track;
	        }
	      }
	    });
	    readyState = NONE;
	    /**
	     * @listens TextTrack#loadeddata
	     * @fires HTMLTrackElement#load
	     */
	
	    track.addEventListener('loadeddata', function () {
	      readyState = LOADED;
	
	      _this.trigger({
	        type: 'load',
	        target: _assertThisInitialized__default['default'](_this)
	      });
	    });
	    return _this;
	  }
	
	  return HTMLTrackElement;
	}(EventTarget$2);
	
	HTMLTrackElement.prototype.allowedEvents_ = {
	  load: 'load'
	};
	HTMLTrackElement.NONE = NONE;
	HTMLTrackElement.LOADING = LOADING;
	HTMLTrackElement.LOADED = LOADED;
	HTMLTrackElement.ERROR = ERROR;
	
	/*
	 * This file contains all track properties that are used in
	 * player.js, tech.js, html5.js and possibly other techs in the future.
	 */
	
	var NORMAL = {
	  audio: {
	    ListClass: AudioTrackList,
	    TrackClass: AudioTrack,
	    capitalName: 'Audio'
	  },
	  video: {
	    ListClass: VideoTrackList,
	    TrackClass: VideoTrack,
	    capitalName: 'Video'
	  },
	  text: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'Text'
	  }
	};
	Object.keys(NORMAL).forEach(function (type) {
	  NORMAL[type].getterName = type + "Tracks";
	  NORMAL[type].privateName = type + "Tracks_";
	});
	var REMOTE = {
	  remoteText: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'RemoteText',
	    getterName: 'remoteTextTracks',
	    privateName: 'remoteTextTracks_'
	  },
	  remoteTextEl: {
	    ListClass: HtmlTrackElementList,
	    TrackClass: HTMLTrackElement,
	    capitalName: 'RemoteTextTrackEls',
	    getterName: 'remoteTextTrackEls',
	    privateName: 'remoteTextTrackEls_'
	  }
	};
	
	var ALL = _extends__default['default']({}, NORMAL, REMOTE);
	
	REMOTE.names = Object.keys(REMOTE);
	NORMAL.names = Object.keys(NORMAL);
	ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
	
	/**
	 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	 * that just contains the src url alone.
	 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	   * `var SourceString = 'http://example.com/some-video.mp4';`
	 *
	 * @typedef {Object|string} Tech~SourceObject
	 *
	 * @property {string} src
	 *           The url to the source
	 *
	 * @property {string} type
	 *           The mime type of the source
	 */
	
	/**
	 * A function used by {@link Tech} to create a new {@link TextTrack}.
	 *
	 * @private
	 *
	 * @param {Tech} self
	 *        An instance of the Tech class.
	 *
	 * @param {string} kind
	 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	 *
	 * @param {string} [label]
	 *        Label to identify the text track
	 *
	 * @param {string} [language]
	 *        Two letter language abbreviation
	 *
	 * @param {Object} [options={}]
	 *        An object with additional text track options
	 *
	 * @return {TextTrack}
	 *          The text track that was created.
	 */
	
	function createTrackHelper(self, kind, label, language, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var tracks = self.textTracks();
	  options.kind = kind;
	
	  if (label) {
	    options.label = label;
	  }
	
	  if (language) {
	    options.language = language;
	  }
	
	  options.tech = self;
	  var track = new ALL.text.TrackClass(options);
	  tracks.addTrack(track);
	  return track;
	}
	/**
	 * This is the base class for media playback technology controllers, such as
	 * {@link HTML5}
	 *
	 * @extends Component
	 */
	
	
	var Tech = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Tech, _Component);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Tech(options, ready) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (ready === void 0) {
	      ready = function ready() {};
	    }
	
	    // we don't want the tech to report user activity automatically.
	    // This is done manually in addControlsListeners
	    options.reportTouchActivity = false;
	    _this = _Component.call(this, null, options, ready) || this;
	
	    _this.onDurationChange_ = function (e) {
	      return _this.onDurationChange(e);
	    };
	
	    _this.trackProgress_ = function (e) {
	      return _this.trackProgress(e);
	    };
	
	    _this.trackCurrentTime_ = function (e) {
	      return _this.trackCurrentTime(e);
	    };
	
	    _this.stopTrackingCurrentTime_ = function (e) {
	      return _this.stopTrackingCurrentTime(e);
	    };
	
	    _this.disposeSourceHandler_ = function (e) {
	      return _this.disposeSourceHandler(e);
	    };
	
	    _this.queuedHanders_ = new Set(); // keep track of whether the current source has played at all to
	    // implement a very limited played()
	
	    _this.hasStarted_ = false;
	
	    _this.on('playing', function () {
	      this.hasStarted_ = true;
	    });
	
	    _this.on('loadstart', function () {
	      this.hasStarted_ = false;
	    });
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      if (options && options[props.getterName]) {
	        _this[props.privateName] = options[props.getterName];
	      }
	    }); // Manually track progress in cases where the browser/tech doesn't report it.
	
	    if (!_this.featuresProgressEvents) {
	      _this.manualProgressOn();
	    } // Manually track timeupdates in cases where the browser/tech doesn't report it.
	
	
	    if (!_this.featuresTimeupdateEvents) {
	      _this.manualTimeUpdatesOn();
	    }
	
	    ['Text', 'Audio', 'Video'].forEach(function (track) {
	      if (options["native" + track + "Tracks"] === false) {
	        _this["featuresNative" + track + "Tracks"] = false;
	      }
	    });
	
	    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
	      _this.featuresNativeTextTracks = false;
	    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
	      _this.featuresNativeTextTracks = true;
	    }
	
	    if (!_this.featuresNativeTextTracks) {
	      _this.emulateTextTracks();
	    }
	
	    _this.preloadTextTracks = options.preloadTextTracks !== false;
	    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();
	
	    _this.initTrackListeners(); // Turn on component tap events only if not using native controls
	
	
	    if (!options.nativeControlsForTouch) {
	      _this.emitTapEvents();
	    }
	
	    if (_this.constructor) {
	      _this.name_ = _this.constructor.name || 'Unknown Tech';
	    }
	
	    return _this;
	  }
	  /**
	   * A special function to trigger source set in a way that will allow player
	   * to re-trigger if the player or tech are not ready yet.
	   *
	   * @fires Tech#sourceset
	   * @param {string} src The source string at the time of the source changing.
	   */
	
	
	  var _proto = Tech.prototype;
	
	  _proto.triggerSourceset = function triggerSourceset(src) {
	    var _this2 = this;
	
	    if (!this.isReady_) {
	      // on initial ready we have to trigger source set
	      // 1ms after ready so that player can watch for it.
	      this.one('ready', function () {
	        return _this2.setTimeout(function () {
	          return _this2.triggerSourceset(src);
	        }, 1);
	      });
	    }
	    /**
	     * Fired when the source is set on the tech causing the media element
	     * to reload.
	     *
	     * @see {@link Player#event:sourceset}
	     * @event Tech#sourceset
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger({
	      src: src,
	      type: 'sourceset'
	    });
	  }
	  /* Fallbacks for unsupported event types
	  ================================================================================ */
	
	  /**
	   * Polyfill the `progress` event for browsers that don't support it natively.
	   *
	   * @see {@link Tech#trackProgress}
	   */
	  ;
	
	  _proto.manualProgressOn = function manualProgressOn() {
	    this.on('durationchange', this.onDurationChange_);
	    this.manualProgress = true; // Trigger progress watching when a source begins loading
	
	    this.one('ready', this.trackProgress_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   */
	  ;
	
	  _proto.manualProgressOff = function manualProgressOff() {
	    this.manualProgress = false;
	    this.stopTrackingProgress();
	    this.off('durationchange', this.onDurationChange_);
	  }
	  /**
	   * This is used to trigger a `progress` event when the buffered percent changes. It
	   * sets an interval function that will be called every 500 milliseconds to check if the
	   * buffer end percent has changed.
	   *
	   * > This function is called by {@link Tech#manualProgressOn}
	   *
	   * @param {EventTarget~Event} event
	   *        The `ready` event that caused this to run.
	   *
	   * @listens Tech#ready
	   * @fires Tech#progress
	   */
	  ;
	
	  _proto.trackProgress = function trackProgress(event) {
	    this.stopTrackingProgress();
	    this.progressInterval = this.setInterval(bind(this, function () {
	      // Don't trigger unless buffered amount is greater than last time
	      var numBufferedPercent = this.bufferedPercent();
	
	      if (this.bufferedPercent_ !== numBufferedPercent) {
	        /**
	         * See {@link Player#progress}
	         *
	         * @event Tech#progress
	         * @type {EventTarget~Event}
	         */
	        this.trigger('progress');
	      }
	
	      this.bufferedPercent_ = numBufferedPercent;
	
	      if (numBufferedPercent === 1) {
	        this.stopTrackingProgress();
	      }
	    }), 500);
	  }
	  /**
	   * Update our internal duration on a `durationchange` event by calling
	   * {@link Tech#duration}.
	   *
	   * @param {EventTarget~Event} event
	   *        The `durationchange` event that caused this to run.
	   *
	   * @listens Tech#durationchange
	   */
	  ;
	
	  _proto.onDurationChange = function onDurationChange(event) {
	    this.duration_ = this.duration();
	  }
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    return createTimeRanges(0, 0);
	  }
	  /**
	   * Get the percentage of the current video that is currently buffered.
	   *
	   * @return {number}
	   *         A number from 0 to 1 that represents the decimal percentage of the
	   *         video that is buffered.
	   *
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   * Stop manually tracking progress events by clearing the interval that was set in
	   * {@link Tech#trackProgress}.
	   */
	  ;
	
	  _proto.stopTrackingProgress = function stopTrackingProgress() {
	    this.clearInterval(this.progressInterval);
	  }
	  /**
	   * Polyfill the `timeupdate` event for browsers that don't support it.
	   *
	   * @see {@link Tech#trackCurrentTime}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
	    this.manualTimeUpdates = true;
	    this.on('play', this.trackCurrentTime_);
	    this.on('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Turn off the polyfill for `timeupdate` events that was created in
	   * {@link Tech#manualTimeUpdatesOn}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
	    this.manualTimeUpdates = false;
	    this.stopTrackingCurrentTime();
	    this.off('play', this.trackCurrentTime_);
	    this.off('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Sets up an interval function to track current time and trigger `timeupdate` every
	   * 250 milliseconds.
	   *
	   * @listens Tech#play
	   * @triggers Tech#timeupdate
	   */
	  ;
	
	  _proto.trackCurrentTime = function trackCurrentTime() {
	    if (this.currentTimeInterval) {
	      this.stopTrackingCurrentTime();
	    }
	
	    this.currentTimeInterval = this.setInterval(function () {
	      /**
	       * Triggered at an interval of 250ms to indicated that time is passing in the video.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      }); // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	    }, 250);
	  }
	  /**
	   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
	   * `timeupdate` event is no longer triggered.
	   *
	   * @listens {Tech#pause}
	   */
	  ;
	
	  _proto.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
	    this.clearInterval(this.currentTimeInterval); // #1002 - if the video ends right before the next timeupdate would happen,
	    // the progress bar won't make it all the way to the end
	
	    this.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	  }
	  /**
	   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
	   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
	   *
	   * @fires Component#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    // clear out all tracks because we can't reuse them between techs
	    this.clearTracks(NORMAL.names); // Turn off any manual progress or timeupdate tracking
	
	    if (this.manualProgress) {
	      this.manualProgressOff();
	    }
	
	    if (this.manualTimeUpdates) {
	      this.manualTimeUpdatesOff();
	    }
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
	   *
	   * > Note: Techs without source handlers should call this between sources for `video`
	   *         & `audio` tracks. You don't want to use them between tracks!
	   *
	   * @param {string[]|string} types
	   *        TrackList names to clear, valid names are `video`, `audio`, and
	   *        `text`.
	   */
	  ;
	
	  _proto.clearTracks = function clearTracks(types) {
	    var _this3 = this;
	
	    types = [].concat(types); // clear out all tracks because we can't reuse them between techs
	
	    types.forEach(function (type) {
	      var list = _this3[type + "Tracks"]() || [];
	      var i = list.length;
	
	      while (i--) {
	        var track = list[i];
	
	        if (type === 'text') {
	          _this3.removeRemoteTextTrack(track);
	        }
	
	        list.removeTrack(track);
	      }
	    });
	  }
	  /**
	   * Remove any TextTracks added via addRemoteTextTrack that are
	   * flagged for automatic garbage collection
	   */
	  ;
	
	  _proto.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
	    var list = this.autoRemoteTextTracks_ || [];
	    var i = list.length;
	
	    while (i--) {
	      var track = list[i];
	      this.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Reset the tech, which will removes all sources and reset the internal readyState.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.reset = function reset() {}
	  /**
	   * Get the value of `crossOrigin` from the tech.
	   *
	   * @abstract
	   *
	   * @see {Html5#crossOrigin}
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin() {}
	  /**
	   * Set the value of `crossOrigin` on the tech.
	   *
	   * @abstract
	   *
	   * @param {string} crossOrigin the crossOrigin value
	   * @see {Html5#setCrossOrigin}
	   */
	  ;
	
	  _proto.setCrossOrigin = function setCrossOrigin() {}
	  /**
	   * Get or set an error on the Tech.
	   *
	   * @param {MediaError} [err]
	   *        Error to set on the Tech
	   *
	   * @return {MediaError|null}
	   *         The current error object on the tech, or null if there isn't one.
	   */
	  ;
	
	  _proto.error = function error(err) {
	    if (err !== undefined) {
	      this.error_ = new MediaError(err);
	      this.trigger('error');
	    }
	
	    return this.error_;
	  }
	  /**
	   * Returns the `TimeRange`s that have been played through for the current source.
	   *
	   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
	   *         It only checks whether the source has played at all or not.
	   *
	   * @return {TimeRange}
	   *         - A single time range if this video has played
	   *         - An empty set of ranges if not.
	   */
	  ;
	
	  _proto.played = function played() {
	    if (this.hasStarted_) {
	      return createTimeRanges(0, 0);
	    }
	
	    return createTimeRanges();
	  }
	  /**
	   * Start playback
	   *
	   * @abstract
	   *
	   * @see {Html5#play}
	   */
	  ;
	
	  _proto.play = function play() {}
	  /**
	   * Set whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#setScrubbing}
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing() {}
	  /**
	   * Get whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#scrubbing}
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {}
	  /**
	   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
	   * previously called.
	   *
	   * @fires Tech#timeupdate
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime() {
	    // improve the accuracy of manual timeupdates
	    if (this.manualTimeUpdates) {
	      /**
	       * A manual `timeupdate` event.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      });
	    }
	  }
	  /**
	   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
	   * {@link TextTrackList} events.
	   *
	   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
	   *
	   * @fires Tech#audiotrackchange
	   * @fires Tech#videotrackchange
	   * @fires Tech#texttrackchange
	   */
	  ;
	
	  _proto.initTrackListeners = function initTrackListeners() {
	    var _this4 = this;
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
	      *
	      * @event Tech#audiotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
	      *
	      * @event Tech#videotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
	      *
	      * @event Tech#texttrackchange
	      * @type {EventTarget~Event}
	      */
	    NORMAL.names.forEach(function (name) {
	      var props = NORMAL[name];
	
	      var trackListChanges = function trackListChanges() {
	        _this4.trigger(name + "trackchange");
	      };
	
	      var tracks = _this4[props.getterName]();
	
	      tracks.addEventListener('removetrack', trackListChanges);
	      tracks.addEventListener('addtrack', trackListChanges);
	
	      _this4.on('dispose', function () {
	        tracks.removeEventListener('removetrack', trackListChanges);
	        tracks.removeEventListener('addtrack', trackListChanges);
	      });
	    });
	  }
	  /**
	   * Emulate TextTracks using vtt.js if necessary
	   *
	   * @fires Tech#vttjsloaded
	   * @fires Tech#vttjserror
	   */
	  ;
	
	  _proto.addWebVttScript_ = function addWebVttScript_() {
	    var _this5 = this;
	
	    if (window__default['default'].WebVTT) {
	      return;
	    } // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
	    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
	    // before inserting the WebVTT script
	
	
	    if (document__default['default'].body.contains(this.el())) {
	      // load via require if available and vtt.js script location was not passed in
	      // as an option. novtt builds will turn the above require call into an empty object
	      // which will cause this if check to always fail.
	      if (!this.options_['vtt.js'] && isPlain(vtt__default['default']) && Object.keys(vtt__default['default']).length > 0) {
	        this.trigger('vttjsloaded');
	        return;
	      } // load vtt.js via the script location option or the cdn of no location was
	      // passed in
	
	
	      var script = document__default['default'].createElement('script');
	      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
	
	      script.onload = function () {
	        /**
	         * Fired when vtt.js is loaded.
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjsloaded');
	      };
	
	      script.onerror = function () {
	        /**
	         * Fired when vtt.js was not loaded due to an error
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjserror');
	      };
	
	      this.on('dispose', function () {
	        script.onload = null;
	        script.onerror = null;
	      }); // but have not loaded yet and we set it to true before the inject so that
	      // we don't overwrite the injected window.WebVTT if it loads right away
	
	      window__default['default'].WebVTT = true;
	      this.el().parentNode.appendChild(script);
	    } else {
	      this.ready(this.addWebVttScript_);
	    }
	  }
	  /**
	   * Emulate texttracks
	   *
	   */
	  ;
	
	  _proto.emulateTextTracks = function emulateTextTracks() {
	    var _this6 = this;
	
	    var tracks = this.textTracks();
	    var remoteTracks = this.remoteTextTracks();
	
	    var handleAddTrack = function handleAddTrack(e) {
	      return tracks.addTrack(e.track);
	    };
	
	    var handleRemoveTrack = function handleRemoveTrack(e) {
	      return tracks.removeTrack(e.track);
	    };
	
	    remoteTracks.on('addtrack', handleAddTrack);
	    remoteTracks.on('removetrack', handleRemoveTrack);
	    this.addWebVttScript_();
	
	    var updateDisplay = function updateDisplay() {
	      return _this6.trigger('texttrackchange');
	    };
	
	    var textTracksChanges = function textTracksChanges() {
	      updateDisplay();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	
	        if (track.mode === 'showing') {
	          track.addEventListener('cuechange', updateDisplay);
	        }
	      }
	    };
	
	    textTracksChanges();
	    tracks.addEventListener('change', textTracksChanges);
	    tracks.addEventListener('addtrack', textTracksChanges);
	    tracks.addEventListener('removetrack', textTracksChanges);
	    this.on('dispose', function () {
	      remoteTracks.off('addtrack', handleAddTrack);
	      remoteTracks.off('removetrack', handleRemoveTrack);
	      tracks.removeEventListener('change', textTracksChanges);
	      tracks.removeEventListener('addtrack', textTracksChanges);
	      tracks.removeEventListener('removetrack', textTracksChanges);
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	      }
	    });
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!kind) {
	      throw new Error('TextTrack kind is required but was not provided');
	    }
	
	    return createTrackHelper(this, kind, label, language);
	  }
	  /**
	   * Create an emulated TextTrack for use by addRemoteTextTrack
	   *
	   * This is intended to be overridden by classes that inherit from
	   * Tech in order to create native or custom TextTracks.
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    var track = mergeOptions$3(options, {
	      tech: this
	    });
	    return new REMOTE.remoteTextEl.TrackClass(track);
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
	   *
	   * @param {Object} options
	   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
	   *
	   * @param {boolean} [manualCleanup=true]
	   *        - When false: the TextTrack will be automatically removed from the video
	   *          element whenever the source changes
	   *        - When True: The TextTrack will have to be cleaned up manually
	   *
	   * @return {HTMLTrackElement}
	   *         An Html Track Element.
	   *
	   * @deprecated The default functionality for this function will be equivalent
	   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
	   *             also be removed.
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var _this7 = this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var htmlTrackElement = this.createRemoteTextTrack(options);
	
	    if (manualCleanup !== true && manualCleanup !== false) {
	      // deprecation warning
	      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
	      manualCleanup = true;
	    } // store HTMLTrackElement and TextTrack to remote list
	
	
	    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
	    this.remoteTextTracks().addTrack(htmlTrackElement.track);
	
	    if (manualCleanup !== true) {
	      // create the TextTrackList if it doesn't exist
	      this.ready(function () {
	        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
	      });
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove a remote text track from the remote `TextTrackList`.
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` to remove from the `TextTrackList`
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track); // remove HTMLTrackElement and TextTrack from remote list
	
	    this.remoteTextTrackEls().removeTrackElement_(trackElement);
	    this.remoteTextTracks().removeTrack(track);
	    this.autoRemoteTextTracks_.removeTrack(track);
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return {};
	  }
	  /**
	   * Attempt to create a floating video window always on top of other windows
	   * so that users may continue consuming media while they interact with other
	   * content sites, or applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise|undefined}
	   *         A promise with a Picture-in-Picture window if the browser supports
	   *         Promises (or one was passed in as an option). It returns undefined
	   *         otherwise.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return PromiseClass.reject();
	    }
	  }
	  /**
	   * A method to check for the value of the 'disablePictureInPicture' <video> property.
	   * Defaults to true, as it should be considered disabled if the tech does not support pip
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture() {
	    return true;
	  }
	  /**
	   * A method to set or unset the 'disablePictureInPicture' <video> property.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setDisablePictureInPicture = function setDisablePictureInPicture() {}
	  /**
	   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
	   *
	   * @param {function} cb
	   * @return {number} request id
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    var _this8 = this;
	
	    var id = newGUID();
	
	    if (!this.isReady_ || this.paused()) {
	      this.queuedHanders_.add(id);
	      this.one('playing', function () {
	        if (_this8.queuedHanders_.has(id)) {
	          _this8.queuedHanders_["delete"](id);
	
	          cb();
	        }
	      });
	    } else {
	      this.requestNamedAnimationFrame(id, cb);
	    }
	
	    return id;
	  }
	  /**
	   * A fallback implementation of cancelVideoFrameCallback
	   *
	   * @param {number} id id of callback to be cancelled
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.queuedHanders_.has(id)) {
	      this.queuedHanders_["delete"](id);
	    } else {
	      this.cancelNamedAnimationFrame(id);
	    }
	  }
	  /**
	   * A method to set a poster from a `Tech`.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPoster = function setPoster() {}
	  /**
	   * A method to check for the presence of the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.playsinline = function playsinline() {}
	  /**
	   * A method to set or unset the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPlaysinline = function setPlaysinline() {}
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks() {}
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks() {}
	  /*
	   * Check if the tech can support the given mime-type.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param  {string} type
	   *         The mimetype to check for support
	   *
	   * @return {string}
	   *         'probably', 'maybe', or empty string
	   *
	   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the type is supported by this tech.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param {string} type
	   *        The media type to check
	   * @return {string} Returns the native video element's response
	   */
	  ;
	
	  Tech.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the tech can support the given source
	   *
	   * @param {Object} srcObj
	   *        The source object
	   * @param {Object} options
	   *        The options passed to the tech
	   * @return {string} 'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  Tech.canPlaySource = function canPlaySource(srcObj, options) {
	    return Tech.canPlayType(srcObj.type);
	  }
	  /*
	   * Return whether the argument is a Tech or not.
	   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
	   *
	   * @param {Object} component
	   *        The item to check
	   *
	   * @return {boolean}
	   *         Whether it is a tech or not
	   *         - True if it is a tech
	   *         - False if it is not
	   */
	  ;
	
	  Tech.isTech = function isTech(component) {
	    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
	  }
	  /**
	   * Registers a `Tech` into a shared list for videojs.
	   *
	   * @param {string} name
	   *        Name of the `Tech` to register.
	   *
	   * @param {Object} tech
	   *        The `Tech` class to register.
	   */
	  ;
	
	  Tech.registerTech = function registerTech(name, tech) {
	    if (!Tech.techs_) {
	      Tech.techs_ = {};
	    }
	
	    if (!Tech.isTech(tech)) {
	      throw new Error("Tech " + name + " must be a Tech");
	    }
	
	    if (!Tech.canPlayType) {
	      throw new Error('Techs must have a static canPlayType method on them');
	    }
	
	    if (!Tech.canPlaySource) {
	      throw new Error('Techs must have a static canPlaySource method on them');
	    }
	
	    name = toTitleCase$1(name);
	    Tech.techs_[name] = tech;
	    Tech.techs_[toLowerCase(name)] = tech;
	
	    if (name !== 'Tech') {
	      // camel case the techName for use in techOrder
	      Tech.defaultTechOrder_.push(name);
	    }
	
	    return tech;
	  }
	  /**
	   * Get a `Tech` from the shared list by name.
	   *
	   * @param {string} name
	   *        `camelCase` or `TitleCase` name of the Tech to get
	   *
	   * @return {Tech|undefined}
	   *         The `Tech` or undefined if there was no tech with the name requested.
	   */
	  ;
	
	  Tech.getTech = function getTech(name) {
	    if (!name) {
	      return;
	    }
	
	    if (Tech.techs_ && Tech.techs_[name]) {
	      return Tech.techs_[name];
	    }
	
	    name = toTitleCase$1(name);
	
	    if (window__default['default'] && window__default['default'].videojs && window__default['default'].videojs[name]) {
	      log$1.warn("The " + name + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");
	      return window__default['default'].videojs[name];
	    }
	  };
	
	  return Tech;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 *
	 * @returns {VideoTrackList}
	 * @method Tech.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 *
	 * @returns {AudioTrackList}
	 * @method Tech.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.textTracks
	 */
	
	/**
	 * Get the remote element {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote element {@link HtmlTrackElementList}
	 *
	 * @returns {HtmlTrackElementList}
	 * @method Tech.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Tech.prototype[props.getterName] = function () {
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * List of associated text tracks
	 *
	 * @type {TextTrackList}
	 * @private
	 * @property Tech#textTracks_
	 */
	
	/**
	 * List of associated audio tracks.
	 *
	 * @type {AudioTrackList}
	 * @private
	 * @property Tech#audioTracks_
	 */
	
	/**
	 * List of associated video tracks.
	 *
	 * @type {VideoTrackList}
	 * @private
	 * @property Tech#videoTracks_
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVolumeControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default
	 */
	
	Tech.prototype.featuresMuteControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports fullscreen resize control.
	 * Resizing plugins using request fullscreen reloads the plugin
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresFullscreenResize = false;
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the video
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresPlaybackRate = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualProgressOn} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresProgressEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
	 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
	 * a new source.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresSourceset = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualTimeUpdates} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresTimeupdateEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
	 * This will help us integrate with native `TextTrack`s if the browser supports them.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresNativeTextTracks = false;
	/**
	 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVideoFrameCallback = false;
	/**
	 * A functional mixin for techs that want to use the Source Handler pattern.
	 * Source handlers are scripts for handling specific formats.
	 * The source handler pattern is used for adaptive formats (HLS, DASH) that
	 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
	 * Example: `Tech.withSourceHandlers.call(MyTech);`
	 *
	 * @param {Tech} _Tech
	 *        The tech to add source handler functions to.
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 */
	
	Tech.withSourceHandlers = function (_Tech) {
	  /**
	   * Register a source handler
	   *
	   * @param {Function} handler
	   *        The source handler class
	   *
	   * @param {number} [index]
	   *        Register it at the following index
	   */
	  _Tech.registerSourceHandler = function (handler, index) {
	    var handlers = _Tech.sourceHandlers;
	
	    if (!handlers) {
	      handlers = _Tech.sourceHandlers = [];
	    }
	
	    if (index === undefined) {
	      // add to the end of the list
	      index = handlers.length;
	    }
	
	    handlers.splice(index, 0, handler);
	  };
	  /**
	   * Check if the tech can support the given type. Also checks the
	   * Techs sourceHandlers.
	   *
	   * @param {string} type
	   *         The mimetype to check.
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlayType = function (type) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canPlayType(type);
	
	      if (can) {
	        return can;
	      }
	    }
	
	    return '';
	  };
	  /**
	   * Returns the first source handler that supports the source.
	   *
	   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {SourceHandler|null}
	   *          The first source handler that supports the source or null if
	   *          no SourceHandler supports the source
	   */
	
	
	  _Tech.selectSourceHandler = function (source, options) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canHandleSource(source, options);
	
	      if (can) {
	        return handlers[i];
	      }
	    }
	
	    return null;
	  };
	  /**
	   * Check if the tech can support the given source.
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlaySource = function (srcObj, options) {
	    var sh = _Tech.selectSourceHandler(srcObj, options);
	
	    if (sh) {
	      return sh.canHandleSource(srcObj, options);
	    }
	
	    return '';
	  };
	  /**
	   * When using a source handler, prefer its implementation of
	   * any function normally provided by the tech.
	   */
	
	
	  var deferrable = ['seekable', 'seeking', 'duration'];
	  /**
	   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
	   * function if it exists, with a fallback to the Techs seekable function.
	   *
	   * @method _Tech.seekable
	   */
	
	  /**
	   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
	   * function if it exists, otherwise it will fallback to the techs duration function.
	   *
	   * @method _Tech.duration
	   */
	
	  deferrable.forEach(function (fnName) {
	    var originalFn = this[fnName];
	
	    if (typeof originalFn !== 'function') {
	      return;
	    }
	
	    this[fnName] = function () {
	      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
	        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
	      }
	
	      return originalFn.apply(this, arguments);
	    };
	  }, _Tech.prototype);
	  /**
	   * Create a function for setting the source using a source object
	   * and source handlers.
	   * Should never be called unless a source handler was found.
	   *
	   * @param {Tech~SourceObject} source
	   *        A source object with src and type keys
	   */
	
	  _Tech.prototype.setSource = function (source) {
	    var sh = _Tech.selectSourceHandler(source, this.options_);
	
	    if (!sh) {
	      // Fall back to a native source hander when unsupported sources are
	      // deliberately set
	      if (_Tech.nativeSourceHandler) {
	        sh = _Tech.nativeSourceHandler;
	      } else {
	        log$1.error('No source handler found for the current source.');
	      }
	    } // Dispose any existing source handler
	
	
	    this.disposeSourceHandler();
	    this.off('dispose', this.disposeSourceHandler_);
	
	    if (sh !== _Tech.nativeSourceHandler) {
	      this.currentSource_ = source;
	    }
	
	    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
	    this.one('dispose', this.disposeSourceHandler_);
	  };
	  /**
	   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
	   *
	   * @listens Tech#dispose
	   */
	
	
	  _Tech.prototype.disposeSourceHandler = function () {
	    // if we have a source and get another one
	    // then we are loading something new
	    // than clear all of our current tracks
	    if (this.currentSource_) {
	      this.clearTracks(['audio', 'video']);
	      this.currentSource_ = null;
	    } // always clean up auto-text tracks
	
	
	    this.cleanupAutoTextTracks();
	
	    if (this.sourceHandler_) {
	      if (this.sourceHandler_.dispose) {
	        this.sourceHandler_.dispose();
	      }
	
	      this.sourceHandler_ = null;
	    }
	  };
	}; // The base Tech class needs to be registered as a Component. It is the only
	// Tech that can be registered as a Component.
	
	
	Component$1.registerComponent('Tech', Tech);
	Tech.registerTech('Tech', Tech);
	/**
	 * A list of techs that should be added to techOrder on Players
	 *
	 * @private
	 */
	
	Tech.defaultTechOrder_ = [];
	
	/**
	 * @file middleware.js
	 * @module middleware
	 */
	var middlewares = {};
	var middlewareInstances = {};
	var TERMINATOR = {};
	/**
	 * A middleware object is a plain JavaScript object that has methods that
	 * match the {@link Tech} methods found in the lists of allowed
	 * {@link module:middleware.allowedGetters|getters},
	 * {@link module:middleware.allowedSetters|setters}, and
	 * {@link module:middleware.allowedMediators|mediators}.
	 *
	 * @typedef {Object} MiddlewareObject
	 */
	
	/**
	 * A middleware factory function that should return a
	 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
	 *
	 * This factory will be called for each player when needed, with the player
	 * passed in as an argument.
	 *
	 * @callback MiddlewareFactory
	 * @param {Player} player
	 *        A Video.js player.
	 */
	
	/**
	 * Define a middleware that the player should use by way of a factory function
	 * that returns a middleware object.
	 *
	 * @param  {string} type
	 *         The MIME type to match or `"*"` for all MIME types.
	 *
	 * @param  {MiddlewareFactory} middleware
	 *         A middleware factory function that will be executed for
	 *         matching types.
	 */
	
	function use(type, middleware) {
	  middlewares[type] = middlewares[type] || [];
	  middlewares[type].push(middleware);
	}
	/**
	 * Asynchronously sets a source using middleware by recursing through any
	 * matching middlewares and calling `setSource` on each, passing along the
	 * previous returned value each time.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 *
	 * @param  {Tech~SourceObject} src
	 *         A source object.
	 *
	 * @param  {Function}
	 *         The next middleware to run.
	 */
	
	function setSource(player, src, next) {
	  player.setTimeout(function () {
	    return setSourceHelper(src, middlewares[src.type], next, player);
	  }, 1);
	}
	/**
	 * When the tech is set, passes the tech to each middleware's `setTech` method.
	 *
	 * @param {Object[]} middleware
	 *        An array of middleware instances.
	 *
	 * @param {Tech} tech
	 *        A Video.js tech.
	 */
	
	function setTech(middleware, tech) {
	  middleware.forEach(function (mw) {
	    return mw.setTech && mw.setTech(tech);
	  });
	}
	/**
	 * Calls a getter on the tech first, through each middleware
	 * from right to left to the player.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @return {Mixed}
	 *         The final value from the tech after middleware has intercepted it.
	 */
	
	function get(middleware, tech, method) {
	  return middleware.reduceRight(middlewareIterator(method), tech[method]());
	}
	/**
	 * Takes the argument given to the player and calls the setter method on each
	 * middleware from left to right to the tech.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`.
	 */
	
	function set(middleware, tech, method, arg) {
	  return tech[method](middleware.reduce(middlewareIterator(method), arg));
	}
	/**
	 * Takes the argument given to the player and calls the `call` version of the
	 * method on each middleware from left to right.
	 *
	 * Then, call the passed in method on the tech and return the result unchanged
	 * back to the player, through middleware, this time from right to left.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`, regardless of the
	 *         return values of middlewares.
	 */
	
	function mediate(middleware, tech, method, arg) {
	  if (arg === void 0) {
	    arg = null;
	  }
	
	  var callMethod = 'call' + toTitleCase$1(method);
	  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
	  var terminated = middlewareValue === TERMINATOR; // deprecated. The `null` return value should instead return TERMINATOR to
	  // prevent confusion if a techs method actually returns null.
	
	  var returnValue = terminated ? null : tech[method](middlewareValue);
	  executeRight(middleware, method, returnValue, terminated);
	  return returnValue;
	}
	/**
	 * Enumeration of allowed getters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedGetters = {
	  buffered: 1,
	  currentTime: 1,
	  duration: 1,
	  muted: 1,
	  played: 1,
	  paused: 1,
	  seekable: 1,
	  volume: 1,
	  ended: 1
	};
	/**
	 * Enumeration of allowed setters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedSetters = {
	  setCurrentTime: 1,
	  setMuted: 1,
	  setVolume: 1
	};
	/**
	 * Enumeration of allowed mediators where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedMediators = {
	  play: 1,
	  pause: 1
	};
	
	function middlewareIterator(method) {
	  return function (value, mw) {
	    // if the previous middleware terminated, pass along the termination
	    if (value === TERMINATOR) {
	      return TERMINATOR;
	    }
	
	    if (mw[method]) {
	      return mw[method](value);
	    }
	
	    return value;
	  };
	}
	
	function executeRight(mws, method, value, terminated) {
	  for (var i = mws.length - 1; i >= 0; i--) {
	    var mw = mws[i];
	
	    if (mw[method]) {
	      mw[method](terminated, value);
	    }
	  }
	}
	/**
	 * Clear the middleware cache for a player.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 */
	
	
	function clearCacheForPlayer(player) {
	  middlewareInstances[player.id()] = null;
	}
	/**
	 * {
	 *  [playerId]: [[mwFactory, mwInstance], ...]
	 * }
	 *
	 * @private
	 */
	
	function getOrCreateFactory(player, mwFactory) {
	  var mws = middlewareInstances[player.id()];
	  var mw = null;
	
	  if (mws === undefined || mws === null) {
	    mw = mwFactory(player);
	    middlewareInstances[player.id()] = [[mwFactory, mw]];
	    return mw;
	  }
	
	  for (var i = 0; i < mws.length; i++) {
	    var _mws$i = mws[i],
	        mwf = _mws$i[0],
	        mwi = _mws$i[1];
	
	    if (mwf !== mwFactory) {
	      continue;
	    }
	
	    mw = mwi;
	  }
	
	  if (mw === null) {
	    mw = mwFactory(player);
	    mws.push([mwFactory, mw]);
	  }
	
	  return mw;
	}
	
	function setSourceHelper(src, middleware, next, player, acc, lastRun) {
	  if (src === void 0) {
	    src = {};
	  }
	
	  if (middleware === void 0) {
	    middleware = [];
	  }
	
	  if (acc === void 0) {
	    acc = [];
	  }
	
	  if (lastRun === void 0) {
	    lastRun = false;
	  }
	
	  var _middleware = middleware,
	      mwFactory = _middleware[0],
	      mwrest = _middleware.slice(1); // if mwFactory is a string, then we're at a fork in the road
	
	
	  if (typeof mwFactory === 'string') {
	    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun); // if we have an mwFactory, call it with the player to get the mw,
	    // then call the mw's setSource method
	  } else if (mwFactory) {
	    var mw = getOrCreateFactory(player, mwFactory); // if setSource isn't present, implicitly select this middleware
	
	    if (!mw.setSource) {
	      acc.push(mw);
	      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	    }
	
	    mw.setSource(assign({}, src), function (err, _src) {
	      // something happened, try the next middleware on the current level
	      // make sure to use the old src
	      if (err) {
	        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	      } // we've succeeded, now we need to go deeper
	
	
	      acc.push(mw); // if it's the same type, continue down the current chain
	      // otherwise, we want to go down the new chain
	
	      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
	    });
	  } else if (mwrest.length) {
	    setSourceHelper(src, mwrest, next, player, acc, lastRun);
	  } else if (lastRun) {
	    next(src, acc);
	  } else {
	    setSourceHelper(src, middlewares['*'], next, player, acc, true);
	  }
	}
	
	/**
	 * Mimetypes
	 *
	 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
	 * @typedef Mimetypes~Kind
	 * @enum
	 */
	
	var MimetypesKind = {
	  opus: 'video/ogg',
	  ogv: 'video/ogg',
	  mp4: 'video/mp4',
	  mov: 'video/mp4',
	  m4v: 'video/mp4',
	  mkv: 'video/x-matroska',
	  m4a: 'audio/mp4',
	  mp3: 'audio/mpeg',
	  aac: 'audio/aac',
	  caf: 'audio/x-caf',
	  flac: 'audio/flac',
	  oga: 'audio/ogg',
	  wav: 'audio/wav',
	  m3u8: 'application/x-mpegURL',
	  mpd: 'application/dash+xml',
	  jpg: 'image/jpeg',
	  jpeg: 'image/jpeg',
	  gif: 'image/gif',
	  png: 'image/png',
	  svg: 'image/svg+xml',
	  webp: 'image/webp'
	};
	/**
	 * Get the mimetype of a given src url if possible
	 *
	 * @param {string} src
	 *        The url to the src
	 *
	 * @return {string}
	 *         return the mimetype if it was known or empty string otherwise
	 */
	
	var getMimetype = function getMimetype(src) {
	  if (src === void 0) {
	    src = '';
	  }
	
	  var ext = getFileExtension(src);
	  var mimetype = MimetypesKind[ext.toLowerCase()];
	  return mimetype || '';
	};
	/**
	 * Find the mime type of a given source string if possible. Uses the player
	 * source cache.
	 *
	 * @param {Player} player
	 *        The player object
	 *
	 * @param {string} src
	 *        The source string
	 *
	 * @return {string}
	 *         The type that was found
	 */
	
	var findMimetype = function findMimetype(player, src) {
	  if (!src) {
	    return '';
	  } // 1. check for the type in the `source` cache
	
	
	  if (player.cache_.source.src === src && player.cache_.source.type) {
	    return player.cache_.source.type;
	  } // 2. see if we have this source in our `currentSources` cache
	
	
	  var matchingSources = player.cache_.sources.filter(function (s) {
	    return s.src === src;
	  });
	
	  if (matchingSources.length) {
	    return matchingSources[0].type;
	  } // 3. look for the src url in source elements and use the type there
	
	
	  var sources = player.$$('source');
	
	  for (var i = 0; i < sources.length; i++) {
	    var s = sources[i];
	
	    if (s.type && s.src && s.src === src) {
	      return s.type;
	    }
	  } // 4. finally fallback to our list of mime types based on src url extension
	
	
	  return getMimetype(src);
	};
	
	/**
	 * @module filter-source
	 */
	/**
	 * Filter out single bad source objects or multiple source objects in an
	 * array. Also flattens nested source object arrays into a 1 dimensional
	 * array of source objects.
	 *
	 * @param {Tech~SourceObject|Tech~SourceObject[]} src
	 *        The src object to filter
	 *
	 * @return {Tech~SourceObject[]}
	 *         An array of sourceobjects containing only valid sources
	 *
	 * @private
	 */
	
	var filterSource = function filterSource(src) {
	  // traverse array
	  if (Array.isArray(src)) {
	    var newsrc = [];
	    src.forEach(function (srcobj) {
	      srcobj = filterSource(srcobj);
	
	      if (Array.isArray(srcobj)) {
	        newsrc = newsrc.concat(srcobj);
	      } else if (isObject(srcobj)) {
	        newsrc.push(srcobj);
	      }
	    });
	    src = newsrc;
	  } else if (typeof src === 'string' && src.trim()) {
	    // convert string into object
	    src = [fixSource({
	      src: src
	    })];
	  } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
	    // src is already valid
	    src = [fixSource(src)];
	  } else {
	    // invalid source, turn it into an empty array
	    src = [];
	  }
	
	  return src;
	};
	/**
	 * Checks src mimetype, adding it when possible
	 *
	 * @param {Tech~SourceObject} src
	 *        The src object to check
	 * @return {Tech~SourceObject}
	 *        src Object with known type
	 */
	
	
	function fixSource(src) {
	  if (!src.type) {
	    var mimetype = getMimetype(src.src);
	
	    if (mimetype) {
	      src.type = mimetype;
	    }
	  }
	
	  return src;
	}
	
	/**
	 * The `MediaLoader` is the `Component` that decides which playback technology to load
	 * when a player is initialized.
	 *
	 * @extends Component
	 */
	
	var MediaLoader = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MediaLoader, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function that is run when this component is ready.
	   */
	  function MediaLoader(player, options, ready) {
	    var _this;
	
	    // MediaLoader has no element
	    var options_ = mergeOptions$3({
	      createEl: false
	    }, options);
	    _this = _Component.call(this, player, options_, ready) || this; // If there are no sources when the player is initialized,
	    // load the first supported playback technology.
	
	    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
	      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
	        var techName = toTitleCase$1(j[i]);
	        var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	        // Remove once that deprecated behavior is removed.
	
	        if (!techName) {
	          tech = Component$1.getComponent(techName);
	        } // Check if the browser supports this technology
	
	
	        if (tech && tech.isSupported()) {
	          player.loadTech_(techName);
	          break;
	        }
	      }
	    } else {
	      // Loop through playback technologies (e.g. HTML5) and check for support.
	      // Then load the best source.
	      // A few assumptions here:
	      //   All playback technologies respect preload false.
	      player.src(options.playerOptions.sources);
	    }
	
	    return _this;
	  }
	
	  return MediaLoader;
	}(Component$1);
	
	Component$1.registerComponent('MediaLoader', MediaLoader);
	
	/**
	 * Component which is clickable or keyboard actionable, but is not a
	 * native HTML button.
	 *
	 * @extends Component
	 */
	
	var ClickableComponent = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ClickableComponent, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of component options.
	   *
	   * @param  {function} [options.clickHandler]
	   *         The function to call when the button is clicked / activated
	   *
	   * @param  {string} [options.controlText]
	   *         The text to set on the button
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   */
	  function ClickableComponent(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (_this.options_.controlText) {
	      _this.controlText(_this.options_.controlText);
	    }
	
	    _this.handleMouseOver_ = function (e) {
	      return _this.handleMouseOver(e);
	    };
	
	    _this.handleMouseOut_ = function (e) {
	      return _this.handleMouseOut(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.emitTapEvents();
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `ClickableComponent`s DOM element.
	   *
	   * @param {string} [tag=div]
	   *        The element's node type.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = ClickableComponent.prototype;
	
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    props = assign({
	      className: this.buildCSSClass(),
	      tabIndex: 0
	    }, props);
	
	    if (tag === 'button') {
	      log$1.error("Creating a ClickableComponent with an HTML element of " + tag + " is not supported; use a Button instead.");
	    } // Add ARIA attributes for clickable element which is not a native HTML button
	
	
	    attributes = assign({
	      role: 'button'
	    }, attributes);
	    this.tabIndex_ = props.tabIndex;
	    var el = createEl(tag, props, attributes);
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    // remove controlTextEl_ on dispose
	    this.controlTextEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Create a control text element on this `ClickableComponent`
	   *
	   * @param {Element} [el]
	   *        Parent element for the control text.
	   *
	   * @return {Element}
	   *         The control text element that gets created.
	   */
	  ;
	
	  _proto.createControlTextEl = function createControlTextEl(el) {
	    this.controlTextEl_ = createEl('span', {
	      className: 'vjs-control-text'
	    }, {
	      // let the screen reader user know that the text of the element may change
	      'aria-live': 'polite'
	    });
	
	    if (el) {
	      el.appendChild(this.controlTextEl_);
	    }
	
	    this.controlText(this.controlText_, el);
	    return this.controlTextEl_;
	  }
	  /**
	   * Get or set the localize text to use for the controls on the `ClickableComponent`.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.el();
	    }
	
	    if (text === undefined) {
	      return this.controlText_ || 'Need Text';
	    }
	
	    var localizedText = this.localize(text);
	    this.controlText_ = text;
	    textContent(this.controlTextEl_, localizedText);
	
	    if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) {
	      // Set title attribute if only an icon is shown
	      el.setAttribute('title', localizedText);
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-control vjs-button " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enable this `ClickableComponent`
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (!this.enabled_) {
	      this.enabled_ = true;
	      this.removeClass('vjs-disabled');
	      this.el_.setAttribute('aria-disabled', 'false');
	
	      if (typeof this.tabIndex_ !== 'undefined') {
	        this.el_.setAttribute('tabIndex', this.tabIndex_);
	      }
	
	      this.on(['tap', 'click'], this.handleClick_);
	      this.on('keydown', this.handleKeyDown_);
	    }
	  }
	  /**
	   * Disable this `ClickableComponent`
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'true');
	
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.removeAttribute('tabIndex');
	    }
	
	    this.off('mouseover', this.handleMouseOver_);
	    this.off('mouseout', this.handleMouseOut_);
	    this.off(['tap', 'click'], this.handleClick_);
	    this.off('keydown', this.handleKeyDown_);
	  }
	  /**
	   * Handles language change in ClickableComponent for the player in components
	   *
	   *
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {
	    this.controlText(this.controlText_);
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `click` or `tap` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `tap` or `click` event that caused this function to be called.
	   *
	   * @listens tap
	   * @listens click
	   * @abstract
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.options_.clickHandler) {
	      this.options_.clickHandler.call(this, arguments);
	    }
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Space or Enter, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Support Space or Enter key operation to fire a click event. Also,
	    // prevent the event from propagating through the DOM and triggering
	    // Player hotkeys.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return ClickableComponent;
	}(Component$1);
	
	Component$1.registerComponent('ClickableComponent', ClickableComponent);
	
	/**
	 * A `ClickableComponent` that handles showing the poster image for the player.
	 *
	 * @extends ClickableComponent
	 */
	
	var PosterImage = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](PosterImage, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PosterImage(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	
	    _this.update();
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    };
	
	    player.on('posterchange', _this.update_);
	    return _this;
	  }
	  /**
	   * Clean up and dispose of the `PosterImage`.
	   */
	
	
	  var _proto = PosterImage.prototype;
	
	  _proto.dispose = function dispose() {
	    this.player().off('posterchange', this.update_);
	
	    _ClickableComponent.prototype.dispose.call(this);
	  }
	  /**
	   * Create the `PosterImage`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = createEl('div', {
	      className: 'vjs-poster',
	      // Don't want poster to be tabbable.
	      tabIndex: -1
	    });
	    return el;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
	   *
	   * @listens Player#posterchange
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `Player#posterchange` event that triggered this function.
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var url = this.player().poster();
	    this.setSrc(url); // If there's no poster source we should display:none on this component
	    // so it's not still clickable or right-clickable
	
	    if (url) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  }
	  /**
	   * Set the source of the `PosterImage` depending on the display method.
	   *
	   * @param {string} url
	   *        The URL to the source for the `PosterImage`.
	   */
	  ;
	
	  _proto.setSrc = function setSrc(url) {
	    var backgroundImage = ''; // Any falsy value should stay as an empty string, otherwise
	    // this will throw an extra error
	
	    if (url) {
	      backgroundImage = "url(\"" + url + "\")";
	    }
	
	    this.el_.style.backgroundImage = backgroundImage;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
	   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
	   *
	   * @listens tap
	   * @listens click
	   * @listens keydown
	   *
	   * @param {EventTarget~Event} event
	   +        The `click`, `tap` or `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // We don't want a click to trigger playback when controls are disabled
	    if (!this.player_.controls()) {
	      return;
	    }
	
	    var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	
	    if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	    // calling .focus() on the video element causes the video to go black,
	    // so we avoid it in that specific case
	    !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	      this.player_.tech(true).focus();
	    }
	
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  return PosterImage;
	}(ClickableComponent);
	
	Component$1.registerComponent('PosterImage', PosterImage);
	
	var darkGray = '#222';
	var lightGray = '#ccc';
	var fontMap = {
	  monospace: 'monospace',
	  sansSerif: 'sans-serif',
	  serif: 'serif',
	  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
	  monospaceSerif: '"Courier New", monospace',
	  proportionalSansSerif: 'sans-serif',
	  proportionalSerif: 'serif',
	  casual: '"Comic Sans MS", Impact, fantasy',
	  script: '"Monotype Corsiva", cursive',
	  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
	};
	/**
	 * Construct an rgba color from a given hex color code.
	 *
	 * @param {number} color
	 *        Hex number for color, like #f0e or #f604e2.
	 *
	 * @param {number} opacity
	 *        Value for opacity, 0.0 - 1.0.
	 *
	 * @return {string}
	 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	 */
	
	function constructColor(color, opacity) {
	  var hex;
	
	  if (color.length === 4) {
	    // color looks like "#f0e"
	    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
	  } else if (color.length === 7) {
	    // color looks like "#f604e2"
	    hex = color.slice(1);
	  } else {
	    throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
	  }
	
	  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
	}
	/**
	 * Try to update the style of a DOM element. Some style changes will throw an error,
	 * particularly in IE8. Those should be noops.
	 *
	 * @param {Element} el
	 *        The DOM element to be styled.
	 *
	 * @param {string} style
	 *        The CSS property on the element that should be styled.
	 *
	 * @param {string} rule
	 *        The style rule that should be applied to the property.
	 *
	 * @private
	 */
	
	function tryUpdateStyle(el, style, rule) {
	  try {
	    el.style[style] = rule;
	  } catch (e) {
	    // Satisfies linter.
	    return;
	  }
	}
	/**
	 * The component for displaying text track cues.
	 *
	 * @extends Component
	 */
	
	
	var TextTrackDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TextTrackDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when `TextTrackDisplay` is ready.
	   */
	  function TextTrackDisplay(player, options, ready) {
	    var _this;
	
	    _this = _Component.call(this, player, options, ready) || this;
	
	    var updateDisplayHandler = function updateDisplayHandler(e) {
	      return _this.updateDisplay(e);
	    };
	
	    player.on('loadstart', function (e) {
	      return _this.toggleDisplay(e);
	    });
	    player.on('texttrackchange', updateDisplayHandler);
	    player.on('loadedmetadata', function (e) {
	      return _this.preselectTrack(e);
	    }); // This used to be called during player init, but was causing an error
	    // if a track should show by default and the display hadn't loaded yet.
	    // Should probably be moved to an external track loader when we support
	    // tracks that don't need a display.
	
	    player.ready(bind(_assertThisInitialized__default['default'](_this), function () {
	      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
	        this.hide();
	        return;
	      }
	
	      player.on('fullscreenchange', updateDisplayHandler);
	      player.on('playerresize', updateDisplayHandler);
	      window__default['default'].addEventListener('orientationchange', updateDisplayHandler);
	      player.on('dispose', function () {
	        return window__default['default'].removeEventListener('orientationchange', updateDisplayHandler);
	      });
	      var tracks = this.options_.playerOptions.tracks || [];
	
	      for (var i = 0; i < tracks.length; i++) {
	        this.player_.addRemoteTextTrack(tracks[i], true);
	      }
	
	      this.preselectTrack();
	    }));
	    return _this;
	  }
	  /**
	  * Preselect a track following this precedence:
	  * - matches the previously selected {@link TextTrack}'s language and kind
	  * - matches the previously selected {@link TextTrack}'s language only
	  * - is the first default captions track
	  * - is the first default descriptions track
	  *
	  * @listens Player#loadstart
	  */
	
	
	  var _proto = TextTrackDisplay.prototype;
	
	  _proto.preselectTrack = function preselectTrack() {
	    var modes = {
	      captions: 1,
	      subtitles: 1
	    };
	    var trackList = this.player_.textTracks();
	    var userPref = this.player_.cache_.selectedLanguage;
	    var firstDesc;
	    var firstCaptions;
	    var preferredTrack;
	
	    for (var i = 0; i < trackList.length; i++) {
	      var track = trackList[i];
	
	      if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
	        // Always choose the track that matches both language and kind
	        if (track.kind === userPref.kind) {
	          preferredTrack = track; // or choose the first track that matches language
	        } else if (!preferredTrack) {
	          preferredTrack = track;
	        } // clear everything if offTextTrackMenuItem was clicked
	
	      } else if (userPref && !userPref.enabled) {
	        preferredTrack = null;
	        firstDesc = null;
	        firstCaptions = null;
	      } else if (track["default"]) {
	        if (track.kind === 'descriptions' && !firstDesc) {
	          firstDesc = track;
	        } else if (track.kind in modes && !firstCaptions) {
	          firstCaptions = track;
	        }
	      }
	    } // The preferredTrack matches the user preference and takes
	    // precedence over all the other tracks.
	    // So, display the preferredTrack before the first default track
	    // and the subtitles/captions track before the descriptions track
	
	
	    if (preferredTrack) {
	      preferredTrack.mode = 'showing';
	    } else if (firstCaptions) {
	      firstCaptions.mode = 'showing';
	    } else if (firstDesc) {
	      firstDesc.mode = 'showing';
	    }
	  }
	  /**
	   * Turn display of {@link TextTrack}'s from the current state into the other state.
	   * There are only two states:
	   * - 'shown'
	   * - 'hidden'
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.toggleDisplay = function toggleDisplay() {
	    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  }
	  /**
	   * Create the {@link Component}'s DOM element.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-text-track-display'
	    }, {
	      'translate': 'yes',
	      'aria-live': 'off',
	      'aria-atomic': 'true'
	    });
	  }
	  /**
	   * Clear all displayed {@link TextTrack}s.
	   */
	  ;
	
	  _proto.clearDisplay = function clearDisplay() {
	    if (typeof window__default['default'].WebVTT === 'function') {
	      window__default['default'].WebVTT.processCues(window__default['default'], [], this.el_);
	    }
	  }
	  /**
	   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
	   * a {@link Player#fullscreenchange} is fired.
	   *
	   * @listens Player#texttrackchange
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var tracks = this.player_.textTracks();
	    var allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
	    this.clearDisplay();
	
	    if (allowMultipleShowingTracks) {
	      var showingTracks = [];
	
	      for (var _i = 0; _i < tracks.length; ++_i) {
	        var track = tracks[_i];
	
	        if (track.mode !== 'showing') {
	          continue;
	        }
	
	        showingTracks.push(track);
	      }
	
	      this.updateForTrack(showingTracks);
	      return;
	    } //  Track display prioritization model: if multiple tracks are 'showing',
	    //  display the first 'subtitles' or 'captions' track which is 'showing',
	    //  otherwise display the first 'descriptions' track which is 'showing'
	
	
	    var descriptionsTrack = null;
	    var captionsSubtitlesTrack = null;
	    var i = tracks.length;
	
	    while (i--) {
	      var _track = tracks[i];
	
	      if (_track.mode === 'showing') {
	        if (_track.kind === 'descriptions') {
	          descriptionsTrack = _track;
	        } else {
	          captionsSubtitlesTrack = _track;
	        }
	      }
	    }
	
	    if (captionsSubtitlesTrack) {
	      if (this.getAttribute('aria-live') !== 'off') {
	        this.setAttribute('aria-live', 'off');
	      }
	
	      this.updateForTrack(captionsSubtitlesTrack);
	    } else if (descriptionsTrack) {
	      if (this.getAttribute('aria-live') !== 'assertive') {
	        this.setAttribute('aria-live', 'assertive');
	      }
	
	      this.updateForTrack(descriptionsTrack);
	    }
	  }
	  /**
	   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
	   *
	   * @param {TextTrack} track
	   *        Text track object containing active cues to style.
	   */
	  ;
	
	  _proto.updateDisplayState = function updateDisplayState(track) {
	    var overrides = this.player_.textTrackSettings.getValues();
	    var cues = track.activeCues;
	    var i = cues.length;
	
	    while (i--) {
	      var cue = cues[i];
	
	      if (!cue) {
	        continue;
	      }
	
	      var cueDiv = cue.displayState;
	
	      if (overrides.color) {
	        cueDiv.firstChild.style.color = overrides.color;
	      }
	
	      if (overrides.textOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
	      }
	
	      if (overrides.backgroundColor) {
	        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
	      }
	
	      if (overrides.backgroundOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
	      }
	
	      if (overrides.windowColor) {
	        if (overrides.windowOpacity) {
	          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
	        } else {
	          cueDiv.style.backgroundColor = overrides.windowColor;
	        }
	      }
	
	      if (overrides.edgeStyle) {
	        if (overrides.edgeStyle === 'dropshadow') {
	          cueDiv.firstChild.style.textShadow = "2px 2px 3px " + darkGray + ", 2px 2px 4px " + darkGray + ", 2px 2px 5px " + darkGray;
	        } else if (overrides.edgeStyle === 'raised') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + darkGray + ", 2px 2px " + darkGray + ", 3px 3px " + darkGray;
	        } else if (overrides.edgeStyle === 'depressed') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + lightGray + ", 0 1px " + lightGray + ", -1px -1px " + darkGray + ", 0 -1px " + darkGray;
	        } else if (overrides.edgeStyle === 'uniform') {
	          cueDiv.firstChild.style.textShadow = "0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray;
	        }
	      }
	
	      if (overrides.fontPercent && overrides.fontPercent !== 1) {
	        var fontSize = window__default['default'].parseFloat(cueDiv.style.fontSize);
	        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
	        cueDiv.style.height = 'auto';
	        cueDiv.style.top = 'auto';
	      }
	
	      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
	        if (overrides.fontFamily === 'small-caps') {
	          cueDiv.firstChild.style.fontVariant = 'small-caps';
	        } else {
	          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
	        }
	      }
	    }
	  }
	  /**
	   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
	   *
	   * @param {TextTrack|TextTrack[]} tracks
	   *        Text track object or text track array to be added to the list.
	   */
	  ;
	
	  _proto.updateForTrack = function updateForTrack(tracks) {
	    if (!Array.isArray(tracks)) {
	      tracks = [tracks];
	    }
	
	    if (typeof window__default['default'].WebVTT !== 'function' || tracks.every(function (track) {
	      return !track.activeCues;
	    })) {
	      return;
	    }
	
	    var cues = []; // push all active track cues
	
	    for (var i = 0; i < tracks.length; ++i) {
	      var track = tracks[i];
	
	      for (var j = 0; j < track.activeCues.length; ++j) {
	        cues.push(track.activeCues[j]);
	      }
	    } // removes all cues before it processes new ones
	
	
	    window__default['default'].WebVTT.processCues(window__default['default'], cues, this.el_); // add unique class to each language text track & add settings styling if necessary
	
	    for (var _i2 = 0; _i2 < tracks.length; ++_i2) {
	      var _track2 = tracks[_i2];
	
	      for (var _j = 0; _j < _track2.activeCues.length; ++_j) {
	        var cueEl = _track2.activeCues[_j].displayState;
	        addClass(cueEl, 'vjs-text-track-cue');
	        addClass(cueEl, 'vjs-text-track-cue-' + (_track2.language ? _track2.language : _i2));
	
	        if (_track2.language) {
	          setAttribute(cueEl, 'lang', _track2.language);
	        }
	      }
	
	      if (this.player_.textTrackSettings) {
	        this.updateDisplayState(_track2);
	      }
	    }
	  };
	
	  return TextTrackDisplay;
	}(Component$1);
	
	Component$1.registerComponent('TextTrackDisplay', TextTrackDisplay);
	
	/**
	 * A loading spinner for use during waiting/loading events.
	 *
	 * @extends Component
	 */
	
	var LoadingSpinner = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadingSpinner, _Component);
	
	  function LoadingSpinner() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = LoadingSpinner.prototype;
	
	  /**
	   * Create the `LoadingSpinner`s DOM element.
	   *
	   * @return {Element}
	   *         The dom element that gets created.
	   */
	  _proto.createEl = function createEl$1() {
	    var isAudio = this.player_.isAudio();
	    var playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
	    var controlText = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('{1} is loading.', [playerType])
	    });
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-loading-spinner',
	      dir: 'ltr'
	    });
	
	    el.appendChild(controlText);
	    return el;
	  };
	
	  return LoadingSpinner;
	}(Component$1);
	
	Component$1.registerComponent('LoadingSpinner', LoadingSpinner);
	
	/**
	 * Base class for all buttons.
	 *
	 * @extends ClickableComponent
	 */
	
	var Button = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](Button, _ClickableComponent);
	
	  function Button() {
	    return _ClickableComponent.apply(this, arguments) || this;
	  }
	
	  var _proto = Button.prototype;
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} [tag="button"]
	   *        The element's node type. This argument is IGNORED: no matter what
	   *        is passed, it will always create a `button` element.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    tag = 'button';
	    props = assign({
	      className: this.buildCSSClass()
	    }, props); // Add attributes for button element
	
	    attributes = assign({
	      // Necessary since the default button type is "submit"
	      type: 'button'
	    }, attributes);
	
	    var el = createEl(tag, props, attributes);
	
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  }
	  /**
	   * Add a child `Component` inside of this `Button`.
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   *
	   * @deprecated since version 5
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var className = this.constructor.name;
	    log$1.warn("Adding an actionable (user controllable) child to a Button (" + className + ") is not supported; use a ClickableComponent instead."); // Avoid the error message generated by ClickableComponent's addChild method
	
	    return Component$1.prototype.addChild.call(this, child, options);
	  }
	  /**
	   * Enable the `Button` element so that it can be activated or clicked. Use this with
	   * {@link Button#disable}.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    _ClickableComponent.prototype.enable.call(this);
	
	    this.el_.removeAttribute('disabled');
	  }
	  /**
	   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
	   * {@link Button#enable}.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    _ClickableComponent.prototype.disable.call(this);
	
	    this.el_.setAttribute('disabled', 'disabled');
	  }
	  /**
	   * This gets called when a `Button` has focus and `keydown` is triggered via a key
	   * press.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to get called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Ignore Space or Enter key operation, which is handled by the browser for
	    // a button - though not for its super class, ClickableComponent. Also,
	    // prevent the event from propagating through the DOM and triggering Player
	    // hotkeys. We do not preventDefault here because we _want_ the browser to
	    // handle it.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.stopPropagation();
	      return;
	    } // Pass keypress handling up for unsupported keys
	
	
	    _ClickableComponent.prototype.handleKeyDown.call(this, event);
	  };
	
	  return Button;
	}(ClickableComponent);
	
	Component$1.registerComponent('Button', Button);
	
	/**
	 * The initial play button that shows before the video has played. The hiding of the
	 * `BigPlayButton` get done via CSS and `Player` states.
	 *
	 * @extends Button
	 */
	
	var BigPlayButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](BigPlayButton, _Button);
	
	  function BigPlayButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	    _this.mouseused_ = false;
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
	   */
	
	
	  var _proto = BigPlayButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-big-play-button';
	  }
	  /**
	   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var playPromise = this.player_.play(); // exit early if clicked via the mouse
	
	    if (this.mouseused_ && event.clientX && event.clientY) {
	      var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	      silencePromise(playPromise);
	
	      if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	      // calling .focus() on the video element causes the video to go black,
	      // so we avoid it in that specific case
	      !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	        this.player_.tech(true).focus();
	      }
	
	      return;
	    }
	
	    var cb = this.player_.getChild('controlBar');
	    var playToggle = cb && cb.getChild('playToggle');
	
	    if (!playToggle) {
	      this.player_.tech(true).focus();
	      return;
	    }
	
	    var playFocus = function playFocus() {
	      return playToggle.focus();
	    };
	
	    if (isPromise(playPromise)) {
	      playPromise.then(playFocus, function () {});
	    } else {
	      this.setTimeout(playFocus, 1);
	    }
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    this.mouseused_ = false;
	
	    _Button.prototype.handleKeyDown.call(this, event);
	  };
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    this.mouseused_ = true;
	  };
	
	  return BigPlayButton;
	}(Button);
	/**
	 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	BigPlayButton.prototype.controlText_ = 'Play Video';
	Component$1.registerComponent('BigPlayButton', BigPlayButton);
	
	/**
	 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
	 * it gets clicked.
	 *
	 * @extends Button
	 */
	
	var CloseButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](CloseButton, _Button);
	
	  /**
	  * Creates an instance of the this class.
	  *
	  * @param  {Player} player
	  *         The `Player` that this class should be attached to.
	  *
	  * @param  {Object} [options]
	  *         The key/value store of player options.
	  */
	  function CloseButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.controlText(options && options.controlText || _this.localize('Close'));
	
	    return _this;
	  }
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	
	
	  var _proto = CloseButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-close-button " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when a `CloseButton` gets clicked. See
	   * {@link ClickableComponent#handleClick} for more information on when
	   * this will be triggered
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @fires CloseButton#close
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    /**
	     * Triggered when the a `CloseButton` is clicked.
	     *
	     * @event CloseButton#close
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up to parents if there is no listener
	     */
	    this.trigger({
	      type: 'close',
	      bubbles: false
	    });
	  }
	  /**
	   * Event handler that is called when a `CloseButton` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Esc, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Esc button will trigger `click` event
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Button.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return CloseButton;
	}(Button);
	
	Component$1.registerComponent('CloseButton', CloseButton);
	
	/**
	 * Button to toggle between play and pause.
	 *
	 * @extends Button
	 */
	
	var PlayToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PlayToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function PlayToggle(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Button.call(this, player, options) || this; // show or hide replay icon
	
	    options.replay = options.replay === undefined || options.replay;
	
	    _this.on(player, 'play', function (e) {
	      return _this.handlePlay(e);
	    });
	
	    _this.on(player, 'pause', function (e) {
	      return _this.handlePause(e);
	    });
	
	    if (options.replay) {
	      _this.on(player, 'ended', function (e) {
	        return _this.handleEnded(e);
	      });
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PlayToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-play-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `PlayToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * This gets called once after the video has ended and the user seeks so that
	   * we can change the replay button back to a play button.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#seeked
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked(event) {
	    this.removeClass('vjs-ended');
	
	    if (this.player_.paused()) {
	      this.handlePause(event);
	    } else {
	      this.handlePlay(event);
	    }
	  }
	  /**
	   * Add the vjs-playing class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#play
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay(event) {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // change the button text to "Pause"
	
	    this.controlText('Pause');
	  }
	  /**
	   * Add the vjs-paused class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#pause
	   */
	  ;
	
	  _proto.handlePause = function handlePause(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused'); // change the button text to "Play"
	
	    this.controlText('Play');
	  }
	  /**
	   * Add the vjs-ended class to the element so it can change appearance
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ended
	   */
	  ;
	
	  _proto.handleEnded = function handleEnded(event) {
	    var _this2 = this;
	
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-ended'); // change the button text to "Replay"
	
	    this.controlText('Replay'); // on the next seek remove the replay button
	
	    this.one(this.player_, 'seeked', function (e) {
	      return _this2.handleSeeked(e);
	    });
	  };
	
	  return PlayToggle;
	}(Button);
	/**
	 * The text that should display over the `PlayToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlayToggle.prototype.controlText_ = 'Play';
	Component$1.registerComponent('PlayToggle', PlayToggle);
	
	/**
	 * @file format-time.js
	 * @module format-time
	 */
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
	 * seconds) will force a number of leading zeros to cover the length of the
	 * guide.
	 *
	 * @private
	 * @param  {number} seconds
	 *         Number of seconds to be turned into a string
	 *
	 * @param  {number} guide
	 *         Number (in seconds) to model the string after
	 *
	 * @return {string}
	 *         Time formatted as H:MM:SS or M:SS
	 */
	var defaultImplementation = function defaultImplementation(seconds, guide) {
	  seconds = seconds < 0 ? 0 : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? h + ':' : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':'; // Check if leading zero is need for seconds
	
	  s = s < 10 ? '0' + s : s;
	  return h + m + s;
	}; // Internal pointer to the current implementation.
	
	
	var implementation = defaultImplementation;
	/**
	 * Replaces the default formatTime implementation with a custom implementation.
	 *
	 * @param {Function} customImplementation
	 *        A function which will be used in place of the default formatTime
	 *        implementation. Will receive the current time in seconds and the
	 *        guide (in seconds) as arguments.
	 */
	
	function setFormatTime(customImplementation) {
	  implementation = customImplementation;
	}
	/**
	 * Resets formatTime to the default implementation.
	 */
	
	function resetFormatTime() {
	  implementation = defaultImplementation;
	}
	/**
	 * Delegates to either the default time formatting function or a custom
	 * function supplied via `setFormatTime`.
	 *
	 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
	 * guide (in seconds) will force a number of leading zeros to cover the
	 * length of the guide.
	 *
	 * @static
	 * @example  formatTime(125, 600) === "02:05"
	 * @param    {number} seconds
	 *           Number of seconds to be turned into a string
	 *
	 * @param    {number} guide
	 *           Number (in seconds) to model the string after
	 *
	 * @return   {string}
	 *           Time formatted as H:MM:SS or M:SS
	 */
	
	function formatTime(seconds, guide) {
	  if (guide === void 0) {
	    guide = seconds;
	  }
	
	  return implementation(seconds, guide);
	}
	
	/**
	 * Displays time information about the video
	 *
	 * @extends Component
	 */
	
	var TimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.on(player, ['timeupdate', 'ended'], function (e) {
	      return _this.updateContent(e);
	    });
	
	    _this.updateTextNode_();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var className = this.buildCSSClass();
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: className + " vjs-time-control vjs-control"
	    });
	
	    var span = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize(this.labelText_) + "\xA0"
	    }, {
	      role: 'presentation'
	    });
	    el.appendChild(span);
	    this.contentEl_ = createEl('span', {
	      className: className + "-display"
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off',
	      // span elements have no implicit role, but some screen readers (notably VoiceOver)
	      // treat them as a break between items in the DOM when using arrow keys
	      // (or left-to-right swipes on iOS) to read contents of a page. Using
	      // role='presentation' causes VoiceOver to NOT treat this span as a break.
	      'role': 'presentation'
	    });
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.textNode_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Updates the time display text node with a new time
	   *
	   * @param {number} [time=0] the time to update to
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateTextNode_ = function updateTextNode_(time) {
	    var _this2 = this;
	
	    if (time === void 0) {
	      time = 0;
	    }
	
	    time = formatTime(time);
	
	    if (this.formattedTime_ === time) {
	      return;
	    }
	
	    this.formattedTime_ = time;
	    this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_', function () {
	      if (!_this2.contentEl_) {
	        return;
	      }
	
	      var oldNode = _this2.textNode_;
	
	      if (oldNode && _this2.contentEl_.firstChild !== oldNode) {
	        oldNode = null;
	        log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');
	      }
	
	      _this2.textNode_ = document__default['default'].createTextNode(_this2.formattedTime_);
	
	      if (!_this2.textNode_) {
	        return;
	      }
	
	      if (oldNode) {
	        _this2.contentEl_.replaceChild(_this2.textNode_, oldNode);
	      } else {
	        _this2.contentEl_.appendChild(_this2.textNode_);
	      }
	    });
	  }
	  /**
	   * To be filled out in the child class, should update the displayed time
	   * in accordance with the fact that the current time has changed.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate`  event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {};
	
	  return TimeDisplay;
	}(Component$1);
	/**
	 * The text that is added to the `TimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	TimeDisplay.prototype.labelText_ = 'Time';
	/**
	 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	TimeDisplay.prototype.controlText_ = 'Time';
	Component$1.registerComponent('TimeDisplay', TimeDisplay);
	
	/**
	 * Displays the current time
	 *
	 * @extends Component
	 */
	
	var CurrentTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](CurrentTimeDisplay, _TimeDisplay);
	
	  function CurrentTimeDisplay() {
	    return _TimeDisplay.apply(this, arguments) || this;
	  }
	
	  var _proto = CurrentTimeDisplay.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-current-time';
	  }
	  /**
	   * Update current time display
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time;
	
	    if (this.player_.ended()) {
	      time = this.player_.duration();
	    } else {
	      time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return CurrentTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
	/**
	 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
	Component$1.registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);
	
	/**
	 * Displays the duration
	 *
	 * @extends Component
	 */
	
	var DurationDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](DurationDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function DurationDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    var updateContent = function updateContent(e) {
	      return _this.updateContent(e);
	    }; // we do not want to/need to throttle duration changes,
	    // as they should always display the changed duration as
	    // it has changed
	
	
	    _this.on(player, 'durationchange', updateContent); // Listen to loadstart because the player duration is reset when a new media element is loaded,
	    // but the durationchange on the user agent will not fire.
	    // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	
	    _this.on(player, 'loadstart', updateContent); // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
	    // listeners could have broken dependent applications/libraries. These
	    // can likely be removed for 7.0.
	
	
	    _this.on(player, 'loadedmetadata', updateContent);
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = DurationDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-duration';
	  }
	  /**
	   * Update duration time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
	   *        this function to be called.
	   *
	   * @listens Player#durationchange
	   * @listens Player#timeupdate
	   * @listens Player#loadedmetadata
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    var duration = this.player_.duration();
	    this.updateTextNode_(duration);
	  };
	
	  return DurationDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `DurationDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DurationDisplay.prototype.labelText_ = 'Duration';
	/**
	 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	DurationDisplay.prototype.controlText_ = 'Duration';
	Component$1.registerComponent('DurationDisplay', DurationDisplay);
	
	/**
	 * The separator between the current time and duration.
	 * Can be hidden if it's not needed in the design.
	 *
	 * @extends Component
	 */
	
	var TimeDivider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDivider, _Component);
	
	  function TimeDivider() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TimeDivider.prototype;
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-control vjs-time-divider'
	    }, {
	      // this element and its contents can be hidden from assistive techs since
	      // it is made extraneous by the announcement of the control text
	      // for the current time and duration displays
	      'aria-hidden': true
	    });
	
	    var div = _Component.prototype.createEl.call(this, 'div');
	
	    var span = _Component.prototype.createEl.call(this, 'span', {
	      textContent: '/'
	    });
	
	    div.appendChild(span);
	    el.appendChild(div);
	    return el;
	  };
	
	  return TimeDivider;
	}(Component$1);
	
	Component$1.registerComponent('TimeDivider', TimeDivider);
	
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	
	var RemainingTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](RemainingTimeDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function RemainingTimeDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    _this.on(player, 'durationchange', function (e) {
	      return _this.updateContent(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = RemainingTimeDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-remaining-time';
	  }
	  /**
	   * Create the `Component`'s DOM element with the "minus" characted prepend to the time
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = _TimeDisplay.prototype.createEl.call(this);
	
	    if (this.options_.displayNegative !== false) {
	      el.insertBefore(createEl('span', {}, {
	        'aria-hidden': true
	      }, '-'), this.contentEl_);
	    }
	
	    return el;
	  }
	  /**
	   * Update remaining time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `durationchange` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    if (typeof this.player_.duration() !== 'number') {
	      return;
	    }
	
	    var time; // @deprecated We should only use remainingTimeDisplay
	    // as of video.js 7
	
	    if (this.player_.ended()) {
	      time = 0;
	    } else if (this.player_.remainingTimeDisplay) {
	      time = this.player_.remainingTimeDisplay();
	    } else {
	      time = this.player_.remainingTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return RemainingTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
	/**
	 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
	Component$1.registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var LiveDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LiveDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.updateShowing();
	
	    _this.on(_this.player(), 'durationchange', function (e) {
	      return _this.updateShowing(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LiveDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-live-control vjs-control'
	    });
	
	    this.contentEl_ = createEl('div', {
	      className: 'vjs-live-display'
	    }, {
	      'aria-live': 'off'
	    });
	    this.contentEl_.appendChild(createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('Stream Type') + "\xA0"
	    }));
	    this.contentEl_.appendChild(document__default['default'].createTextNode(this.localize('LIVE')));
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
	   * it accordingly
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#durationchange} event that caused this function to run.
	   *
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateShowing = function updateShowing(event) {
	    if (this.player().duration() === Infinity) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  return LiveDisplay;
	}(Component$1);
	
	Component$1.registerComponent('LiveDisplay', LiveDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var SeekToLive = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](SeekToLive, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekToLive(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.updateLiveEdgeStatus();
	
	    if (_this.player_.liveTracker) {
	      _this.updateLiveEdgeStatusHandler_ = function (e) {
	        return _this.updateLiveEdgeStatus(e);
	      };
	
	      _this.on(_this.player_.liveTracker, 'liveedgechange', _this.updateLiveEdgeStatusHandler_);
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = SeekToLive.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Button.prototype.createEl.call(this, 'button', {
	      className: 'vjs-seek-to-live-control vjs-control'
	    });
	
	    this.textEl_ = createEl('span', {
	      className: 'vjs-seek-to-live-text',
	      textContent: this.localize('LIVE')
	    }, {
	      'aria-hidden': 'true'
	    });
	    el.appendChild(this.textEl_);
	    return el;
	  }
	  /**
	   * Update the state of this button if we are at the live edge
	   * or not
	   */
	  ;
	
	  _proto.updateLiveEdgeStatus = function updateLiveEdgeStatus() {
	    // default to live edge
	    if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
	      this.setAttribute('aria-disabled', true);
	      this.addClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently playing live');
	    } else {
	      this.setAttribute('aria-disabled', false);
	      this.removeClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently behind live');
	    }
	  }
	  /**
	   * On click bring us as near to the live point as possible.
	   * This requires that we wait for the next `live-seekable-change`
	   * event which will happen every segment length seconds.
	   */
	  ;
	
	  _proto.handleClick = function handleClick() {
	    this.player_.liveTracker.seekToLiveEdge();
	  }
	  /**
	   * Dispose of the element and stop tracking
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
	    }
	
	    this.textEl_ = null;
	
	    _Button.prototype.dispose.call(this);
	  };
	
	  return SeekToLive;
	}(Button);
	
	SeekToLive.prototype.controlText_ = 'Seek to live, currently playing live';
	Component$1.registerComponent('SeekToLive', SeekToLive);
	
	/**
	 * Keep a number between a min and a max value
	 *
	 * @param {number} number
	 *        The number to clamp
	 *
	 * @param {number} min
	 *        The minimum value
	 * @param {number} max
	 *        The maximum value
	 *
	 * @return {number}
	 *         the clamped number
	 */
	var clamp = function clamp(number, min, max) {
	  number = Number(number);
	  return Math.min(max, Math.max(min, isNaN(number) ? min : number));
	};
	
	/**
	 * The base functionality for a slider. Can be vertical or horizontal.
	 * For instance the volume bar or the seek bar on a video is a slider.
	 *
	 * @extends Component
	 */
	
	var Slider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Slider, _Component);
	
	  /**
	  * Create an instance of this class
	  *
	  * @param {Player} player
	  *        The `Player` that this class should be attached to.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  */
	  function Slider(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleMouseDown_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.handleMouseUp_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMouseMove_ = function (e) {
	      return _this.handleMouseMove(e);
	    };
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    }; // Set property names to bar to match with the child Slider class is looking for
	
	
	    _this.bar = _this.getChild(_this.options_.barName); // Set a horizontal or vertical class on the slider depending on the slider type
	
	    _this.vertical(!!_this.options_.vertical);
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Are controls are currently enabled for this slider or not.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	
	
	  var _proto = Slider.prototype;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Enable controls for this slider if they are disabled
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on('mousedown', this.handleMouseDown_);
	    this.on('touchstart', this.handleMouseDown_);
	    this.on('keydown', this.handleKeyDown_);
	    this.on('click', this.handleClick_); // TODO: deprecated, controlsvisible does not seem to be fired
	
	    this.on(this.player_, 'controlsvisible', this.update);
	
	    if (this.playerEvent) {
	      this.on(this.player_, this.playerEvent, this.update);
	    }
	
	    this.removeClass('disabled');
	    this.setAttribute('tabindex', 0);
	    this.enabled_ = true;
	  }
	  /**
	   * Disable controls for this slider if they are enabled
	   */
	  ;
	
	  _proto.disable = function disable() {
	    if (!this.enabled()) {
	      return;
	    }
	
	    var doc = this.bar.el_.ownerDocument;
	    this.off('mousedown', this.handleMouseDown_);
	    this.off('touchstart', this.handleMouseDown_);
	    this.off('keydown', this.handleKeyDown_);
	    this.off('click', this.handleClick_);
	    this.off(this.player_, 'controlsvisible', this.update_);
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.removeAttribute('tabindex');
	    this.addClass('disabled');
	
	    if (this.playerEvent) {
	      this.off(this.player_, this.playerEvent, this.update);
	    }
	
	    this.enabled_ = false;
	  }
	  /**
	   * Create the `Slider`s DOM element.
	   *
	   * @param {string} type
	   *        Type of element to create.
	   *
	   * @param {Object} [props={}]
	   *        List of properties in Object form.
	   *
	   * @param {Object} [attributes={}]
	   *        list of attributes in Object form.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl(type, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    // Add the slider element class to all sub classes
	    props.className = props.className + ' vjs-slider';
	    props = assign({
	      tabIndex: 0
	    }, props);
	    attributes = assign({
	      'role': 'slider',
	      'aria-valuenow': 0,
	      'aria-valuemin': 0,
	      'aria-valuemax': 100,
	      'tabIndex': 0
	    }, attributes);
	    return _Component.prototype.createEl.call(this, type, props, attributes);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   * @fires Slider#slideractive
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.bar.el_.ownerDocument;
	
	    if (event.type === 'mousedown') {
	      event.preventDefault();
	    } // Do not call preventDefault() on touchstart in Chrome
	    // to avoid console warnings. Use a 'touch-action: none' style
	    // instead to prevent unintented scrolling.
	    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	    if (event.type === 'touchstart' && !IS_CHROME) {
	      event.preventDefault();
	    }
	
	    blockTextSelection();
	    this.addClass('vjs-sliding');
	    /**
	     * Triggered when the slider is in an active state
	     *
	     * @event Slider#slideractive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('slideractive');
	    this.on(doc, 'mousemove', this.handleMouseMove_);
	    this.on(doc, 'mouseup', this.handleMouseUp_);
	    this.on(doc, 'touchmove', this.handleMouseMove_);
	    this.on(doc, 'touchend', this.handleMouseUp_);
	    this.handleMouseMove(event, true);
	  }
	  /**
	   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
	   * The `mousemove` and `touchmove` events will only only trigger this function during
	   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
	   * {@link Slider#handleMouseUp}.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
	   *        this function
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {}
	  /**
	   * Handle `mouseup` or `touchend` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   * @fires Slider#sliderinactive
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp() {
	    var doc = this.bar.el_.ownerDocument;
	    unblockTextSelection();
	    this.removeClass('vjs-sliding');
	    /**
	     * Triggered when the slider is no longer in an active state.
	     *
	     * @event Slider#sliderinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('sliderinactive');
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.update();
	  }
	  /**
	   * Update the progress bar of the `Slider`.
	   *
	   * @return {number}
	   *          The percentage of progress the progress bar represents as a
	   *          number from 0 to 1.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this2 = this;
	
	    // In VolumeBar init we have a setTimeout for update that pops and update
	    // to the end of the execution stack. The player is destroyed before then
	    // update will cause an error
	    // If there's no bar...
	    if (!this.el_ || !this.bar) {
	      return;
	    } // clamp progress between 0 and 1
	    // and only round to four decimal places, as we round to two below
	
	
	    var progress = this.getProgress();
	
	    if (progress === this.progress_) {
	      return progress;
	    }
	
	    this.progress_ = progress;
	    this.requestNamedAnimationFrame('Slider#update', function () {
	      // Set the new bar width or height
	      var sizeKey = _this2.vertical() ? 'height' : 'width'; // Convert to a percentage for css value
	
	      _this2.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + '%';
	    });
	    return progress;
	  }
	  /**
	   * Get the percentage of the bar that should be filled
	   * but clamped and rounded.
	   *
	   * @return {number}
	   *         percentage filled that the slider is
	   */
	  ;
	
	  _proto.getProgress = function getProgress() {
	    return Number(clamp(this.getPercent(), 0, 1).toFixed(4));
	  }
	  /**
	   * Calculate distance for slider
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @return {number}
	   *         The current position of the Slider.
	   *         - position.x for vertical `Slider`s
	   *         - position.y for horizontal `Slider`s
	   */
	  ;
	
	  _proto.calculateDistance = function calculateDistance(event) {
	    var position = getPointerPosition(this.el_, event);
	
	    if (this.vertical()) {
	      return position.y;
	    }
	
	    return position.x;
	  }
	  /**
	   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
	   * arrow keys. This function will only be called when the slider has focus. See
	   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
	   *
	   * @param {EventTarget~Event} event
	   *        the `keydown` event that caused this function to run.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward();
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Listener for click events on slider, used to prevent clicks
	   *   from bubbling up to parent elements like button menus.
	   *
	   * @param {Object} event
	   *        Event that caused this object to run
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  }
	  /**
	   * Get/set if slider is horizontal for vertical
	   *
	   * @param {boolean} [bool]
	   *        - true if slider is vertical,
	   *        - false is horizontal
	   *
	   * @return {boolean}
	   *         - true if slider is vertical, and getting
	   *         - false if the slider is horizontal, and getting
	   */
	  ;
	
	  _proto.vertical = function vertical(bool) {
	    if (bool === undefined) {
	      return this.vertical_ || false;
	    }
	
	    this.vertical_ = !!bool;
	
	    if (this.vertical_) {
	      this.addClass('vjs-slider-vertical');
	    } else {
	      this.addClass('vjs-slider-horizontal');
	    }
	  };
	
	  return Slider;
	}(Component$1);
	
	Component$1.registerComponent('Slider', Slider);
	
	var percentify = function percentify(time, end) {
	  return clamp(time / end * 100, 0, 100).toFixed(2) + '%';
	};
	/**
	 * Shows loading progress
	 *
	 * @extends Component
	 */
	
	
	var LoadProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LoadProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.partEls_ = [];
	
	    _this.on(player, 'progress', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LoadProgressBar.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-load-progress'
	    });
	
	    var wrapper = createEl('span', {
	      className: 'vjs-control-text'
	    });
	    var loadedText = createEl('span', {
	      textContent: this.localize('Loaded')
	    });
	    var separator = document__default['default'].createTextNode(': ');
	    this.percentageEl_ = createEl('span', {
	      className: 'vjs-control-text-loaded-percentage',
	      textContent: '0%'
	    });
	    el.appendChild(wrapper);
	    wrapper.appendChild(loadedText);
	    wrapper.appendChild(separator);
	    wrapper.appendChild(this.percentageEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.partEls_ = null;
	    this.percentageEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Update progress bar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `progress` event that caused this function to run.
	   *
	   * @listens Player#progress
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('LoadProgressBar#update', function () {
	      var liveTracker = _this2.player_.liveTracker;
	
	      var buffered = _this2.player_.buffered();
	
	      var duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : _this2.player_.duration();
	
	      var bufferedEnd = _this2.player_.bufferedEnd();
	
	      var children = _this2.partEls_;
	      var percent = percentify(bufferedEnd, duration);
	
	      if (_this2.percent_ !== percent) {
	        // update the width of the progress bar
	        _this2.el_.style.width = percent; // update the control-text
	
	        textContent(_this2.percentageEl_, percent);
	        _this2.percent_ = percent;
	      } // add child elements to represent the individual buffered time ranges
	
	
	      for (var i = 0; i < buffered.length; i++) {
	        var start = buffered.start(i);
	        var end = buffered.end(i);
	        var part = children[i];
	
	        if (!part) {
	          part = _this2.el_.appendChild(createEl());
	          children[i] = part;
	        } //  only update if changed
	
	
	        if (part.dataset.start === start && part.dataset.end === end) {
	          continue;
	        }
	
	        part.dataset.start = start;
	        part.dataset.end = end; // set the percent based on the width of the progress bar (bufferedEnd)
	
	        part.style.left = percentify(start, bufferedEnd);
	        part.style.width = percentify(end - start, bufferedEnd);
	      } // remove unused buffered range elements
	
	
	      for (var _i = children.length; _i > buffered.length; _i--) {
	        _this2.el_.removeChild(children[_i - 1]);
	      }
	
	      children.length = buffered.length;
	    });
	  };
	
	  return LoadProgressBar;
	}(Component$1);
	
	Component$1.registerComponent('LoadProgressBar', LoadProgressBar);
	
	/**
	 * Time tooltips display a time above the progress bar.
	 *
	 * @extends Component
	 */
	
	var TimeTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the time tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint, content) {
	    var tooltipRect = findPosition(this.el_);
	    var playerRect = getBoundingClientRect(this.player_.el());
	    var seekBarPointPx = seekBarRect.width * seekBarPoint; // do nothing if either rect isn't available
	    // for example, if the player isn't in the DOM for testing
	
	    if (!playerRect || !tooltipRect) {
	      return;
	    } // This is the space left of the `seekBarPoint` available within the bounds
	    // of the player. We calculate any gap between the left edge of the player
	    // and the left edge of the `SeekBar` and add the number of pixels in the
	    // `SeekBar` before hitting the `seekBarPoint`
	
	
	    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx; // This is the space right of the `seekBarPoint` available within the bounds
	    // of the player. We calculate the number of pixels from the `seekBarPoint`
	    // to the right edge of the `SeekBar` and add to that any gap between the
	    // right edge of the `SeekBar` and the player.
	
	    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right); // This is the number of pixels by which the tooltip will need to be pulled
	    // further to the right to center it over the `seekBarPoint`.
	
	    var pullTooltipBy = tooltipRect.width / 2; // Adjust the `pullTooltipBy` distance to the left or right depending on
	    // the results of the space calculations above.
	
	    if (spaceLeftOfPoint < pullTooltipBy) {
	      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	    } else if (spaceRightOfPoint < pullTooltipBy) {
	      pullTooltipBy = spaceRightOfPoint;
	    } // Due to the imprecision of decimal/ratio based calculations and varying
	    // rounding behaviors, there are cases where the spacing adjustment is off
	    // by a pixel or two. This adds insurance to these calculations.
	
	
	    if (pullTooltipBy < 0) {
	      pullTooltipBy = 0;
	    } else if (pullTooltipBy > tooltipRect.width) {
	      pullTooltipBy = tooltipRect.width;
	    } // prevent small width fluctuations within 0.4px from
	    // changing the value below.
	    // This really helps for live to prevent the play
	    // progress time tooltip from jittering
	
	
	    pullTooltipBy = Math.round(pullTooltipBy);
	    this.el_.style.right = "-" + pullTooltipBy + "px";
	    this.write(content);
	  }
	  /**
	   * Write the time to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted time for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   *
	   * @param {number} time
	   *        The time to update the tooltip to, not used during live playback
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateTime = function updateTime(seekBarRect, seekBarPoint, time, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('TimeTooltip#updateTime', function () {
	      var content;
	
	      var duration = _this2.player_.duration();
	
	      if (_this2.player_.liveTracker && _this2.player_.liveTracker.isLive()) {
	        var liveWindow = _this2.player_.liveTracker.liveWindow();
	
	        var secondsBehind = liveWindow - seekBarPoint * liveWindow;
	        content = (secondsBehind < 1 ? '' : '-') + formatTime(secondsBehind, liveWindow);
	      } else {
	        content = formatTime(time, duration);
	      }
	
	      _this2.update(seekBarRect, seekBarPoint, content);
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return TimeTooltip;
	}(Component$1);
	
	Component$1.registerComponent('TimeTooltip', TimeTooltip);
	
	/**
	 * Used by {@link SeekBar} to display media playback progress as part of the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var PlayProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](PlayProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlayProgressBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-play-progress vjs-slider-bar'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var timeTooltip = this.getChild('timeTooltip');
	
	    if (!timeTooltip) {
	      return;
	    }
	
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
	  };
	
	  return PlayProgressBar;
	}(Component$1);
	/**
	 * Default options for {@link PlayProgressBar}.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	PlayProgressBar.prototype.options_ = {
	  children: []
	}; // Time tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  PlayProgressBar.prototype.options_.children.push('timeTooltip');
	}
	
	Component$1.registerComponent('PlayProgressBar', PlayProgressBar);
	
	/**
	 * The {@link MouseTimeDisplay} component tracks mouse movement over the
	 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
	 * indicating the time which is represented by a given point in the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var MouseTimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseTimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseTimeDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var _this2 = this;
	
	    var time = seekBarPoint * this.player_.duration();
	    this.getChild('timeTooltip').updateTime(seekBarRect, seekBarPoint, time, function () {
	      _this2.el_.style.left = seekBarRect.width * seekBarPoint + "px";
	    });
	  };
	
	  return MouseTimeDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseTimeDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseTimeDisplay.prototype.options_ = {
	  children: ['timeTooltip']
	};
	Component$1.registerComponent('MouseTimeDisplay', MouseTimeDisplay);
	
	var STEP_SECONDS = 5; // The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
	
	var PAGE_KEY_MULTIPLIER = 12;
	/**
	 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
	 * as its `bar`.
	 *
	 * @extends Slider
	 */
	
	var SeekBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](SeekBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.setEventHandlers_();
	
	    return _this;
	  }
	  /**
	   * Sets the event handlers
	   *
	   * @private
	   */
	
	
	  var _proto = SeekBar.prototype;
	
	  _proto.setEventHandlers_ = function setEventHandlers_() {
	    var _this2 = this;
	
	    this.update_ = bind(this, this.update);
	    this.update = throttle(this.update_, UPDATE_REFRESH_INTERVAL);
	    this.on(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.on(this.player_.liveTracker, 'liveedgechange', this.update);
	    } // when playing, let's ensure we smoothly update the play progress bar
	    // via an interval
	
	
	    this.updateInterval = null;
	
	    this.enableIntervalHandler_ = function (e) {
	      return _this2.enableInterval_(e);
	    };
	
	    this.disableIntervalHandler_ = function (e) {
	      return _this2.disableInterval_(e);
	    };
	
	    this.on(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.on(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.on(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	  };
	
	  _proto.toggleVisibility_ = function toggleVisibility_(e) {
	    if (document__default['default'].visibilityState === 'hidden') {
	      this.cancelNamedAnimationFrame('SeekBar#update');
	      this.cancelNamedAnimationFrame('Slider#update');
	      this.disableInterval_(e);
	    } else {
	      if (!this.player_.ended() && !this.player_.paused()) {
	        this.enableInterval_();
	      } // we just switched back to the page and someone may be looking, so, update ASAP
	
	
	      this.update();
	    }
	  };
	
	  _proto.enableInterval_ = function enableInterval_() {
	    if (this.updateInterval) {
	      return;
	    }
	
	    this.updateInterval = this.setInterval(this.update, UPDATE_REFRESH_INTERVAL);
	  };
	
	  _proto.disableInterval_ = function disableInterval_(e) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== 'ended') {
	      return;
	    }
	
	    if (!this.updateInterval) {
	      return;
	    }
	
	    this.clearInterval(this.updateInterval);
	    this.updateInterval = null;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-holder'
	    }, {
	      'aria-label': this.localize('Progress Bar')
	    });
	  }
	  /**
	   * This function updates the play progress bar and accessibility
	   * attributes to whatever is passed in.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   *
	   * @return {number}
	   *          The current percent at a number from 0-1
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this3 = this;
	
	    // ignore updates while the tab is hidden
	    if (document__default['default'].visibilityState === 'hidden') {
	      return;
	    }
	
	    var percent = _Slider.prototype.update.call(this);
	
	    this.requestNamedAnimationFrame('SeekBar#update', function () {
	      var currentTime = _this3.player_.ended() ? _this3.player_.duration() : _this3.getCurrentTime_();
	      var liveTracker = _this3.player_.liveTracker;
	
	      var duration = _this3.player_.duration();
	
	      if (liveTracker && liveTracker.isLive()) {
	        duration = _this3.player_.liveTracker.liveCurrentTime();
	      }
	
	      if (_this3.percent_ !== percent) {
	        // machine readable value of progress bar (percentage complete)
	        _this3.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
	
	        _this3.percent_ = percent;
	      }
	
	      if (_this3.currentTime_ !== currentTime || _this3.duration_ !== duration) {
	        // human readable value of progress bar (time complete)
	        _this3.el_.setAttribute('aria-valuetext', _this3.localize('progress bar timing: currentTime={1} duration={2}', [formatTime(currentTime, duration), formatTime(duration, duration)], '{1} of {2}'));
	
	        _this3.currentTime_ = currentTime;
	        _this3.duration_ = duration;
	      } // update the progress bar time tooltip with the current time
	
	
	      if (_this3.bar) {
	        _this3.bar.update(getBoundingClientRect(_this3.el()), _this3.getProgress());
	      }
	    });
	    return percent;
	  }
	  /**
	   * Prevent liveThreshold from causing seeks to seem like they
	   * are not happening from a user perspective.
	   *
	   * @param {number} ct
	   *        current time to seek to
	   */
	  ;
	
	  _proto.userSeek_ = function userSeek_(ct) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
	      this.player_.liveTracker.nextSeekedFromUser();
	    }
	
	    this.player_.currentTime(ct);
	  }
	  /**
	   * Get the value of current time but allows for smooth scrubbing,
	   * when player can't keep up.
	   *
	   * @return {number}
	   *         The current time value to display
	   *
	   * @private
	   */
	  ;
	
	  _proto.getCurrentTime_ = function getCurrentTime_() {
	    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	  }
	  /**
	   * Get the percentage of media played so far.
	   *
	   * @return {number}
	   *         The percentage of media played so far (0 to 1).
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    var currentTime = this.getCurrentTime_();
	    var percent;
	    var liveTracker = this.player_.liveTracker;
	
	    if (liveTracker && liveTracker.isLive()) {
	      percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow(); // prevent the percent from changing at the live edge
	
	      if (liveTracker.atLiveEdge()) {
	        percent = 1;
	      }
	    } else {
	      percent = currentTime / this.player_.duration();
	    }
	
	    return percent;
	  }
	  /**
	   * Handle mouse down on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    } // Stop event propagation to prevent double fire in progress-control.js
	
	
	    event.stopPropagation();
	    this.videoWasPlaying = !this.player_.paused();
	    this.player_.pause();
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle mouse move on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to run.
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event, mouseDown) {
	    if (mouseDown === void 0) {
	      mouseDown = false;
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    if (!mouseDown && !this.player_.scrubbing()) {
	      this.player_.scrubbing(true);
	    }
	
	    var newTime;
	    var distance = this.calculateDistance(event);
	    var liveTracker = this.player_.liveTracker;
	
	    if (!liveTracker || !liveTracker.isLive()) {
	      newTime = distance * this.player_.duration(); // Don't let video end while scrubbing.
	
	      if (newTime === this.player_.duration()) {
	        newTime = newTime - 0.1;
	      }
	    } else {
	      if (distance >= 0.99) {
	        liveTracker.seekToLiveEdge();
	        return;
	      }
	
	      var seekableStart = liveTracker.seekableStart();
	      var seekableEnd = liveTracker.liveCurrentTime();
	      newTime = seekableStart + distance * liveTracker.liveWindow(); // Don't let video end while scrubbing.
	
	      if (newTime >= seekableEnd) {
	        newTime = seekableEnd;
	      } // Compensate for precision differences so that currentTime is not less
	      // than seekable start
	
	
	      if (newTime <= seekableStart) {
	        newTime = seekableStart + 0.1;
	      } // On android seekableEnd can be Infinity sometimes,
	      // this will cause newTime to be Infinity, which is
	      // not a valid currentTime.
	
	
	      if (newTime === Infinity) {
	        return;
	      }
	    } // Set new time (tell player to seek to new time)
	
	
	    this.userSeek_(newTime);
	  };
	
	  _proto.enable = function enable() {
	    _Slider.prototype.enable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.show();
	  };
	
	  _proto.disable = function disable() {
	    _Slider.prototype.disable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.hide();
	  }
	  /**
	   * Handle mouse up on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseup` event that caused this to run.
	   *
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    _Slider.prototype.handleMouseUp.call(this, event); // Stop event propagation to prevent double fire in progress-control.js
	
	
	    if (event) {
	      event.stopPropagation();
	    }
	
	    this.player_.scrubbing(false);
	    /**
	     * Trigger timeupdate because we're done seeking and the time has changed.
	     * This is particularly useful for if the player is paused to time the time displays.
	     *
	     * @event Tech#timeupdate
	     * @type {EventTarget~Event}
	     */
	
	    this.player_.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	
	    if (this.videoWasPlaying) {
	      silencePromise(this.player_.play());
	    } else {
	      // We're done seeking and the time has changed.
	      // If the player is paused, make sure we display the correct time on the seek bar.
	      this.update_();
	    }
	  }
	  /**
	   * Move more quickly fast forward for keyboard-only users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.userSeek_(this.player_.currentTime() + STEP_SECONDS);
	  }
	  /**
	   * Move more quickly rewind for keyboard-only users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.userSeek_(this.player_.currentTime() - STEP_SECONDS);
	  }
	  /**
	   * Toggles the playback state of the player
	   * This gets called when enter or space is used on the seekbar
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called
	   *
	   */
	  ;
	
	  _proto.handleAction = function handleAction(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * Called when this SeekBar has focus and a key gets pressed down.
	   * Supports the following keys:
	   *
	   *   Space or Enter key fire a click event
	   *   Home key moves to start of the timeline
	   *   End key moves to end of the timeline
	   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
	   *   PageDown key moves back a larger step than ArrowDown
	   *   PageUp key moves forward a large step
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var liveTracker = this.player_.liveTracker;
	
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.handleAction(event);
	    } else if (keycode__default['default'].isEventKey(event, 'Home')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(0);
	    } else if (keycode__default['default'].isEventKey(event, 'End')) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.liveCurrentTime());
	      } else {
	        this.userSeek_(this.player_.duration());
	      }
	    } else if (/^[0-9]$/.test(keycode__default['default'](event))) {
	      event.preventDefault();
	      event.stopPropagation();
	      var gotoFraction = (keycode__default['default'].codes[keycode__default['default'](event)] - keycode__default['default'].codes['0']) * 10.0 / 100.0;
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
	      } else {
	        this.userSeek_(this.player_.duration() * gotoFraction);
	      }
	    } else if (keycode__default['default'].isEventKey(event, 'PgDn')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() - STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else if (keycode__default['default'].isEventKey(event, 'PgUp')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() + STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Slider.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.disableInterval_();
	    this.off(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.update);
	    }
	
	    this.off(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.off(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.off(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	
	    _Slider.prototype.dispose.call(this);
	  };
	
	  return SeekBar;
	}(Slider);
	/**
	 * Default options for the `SeekBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	SeekBar.prototype.options_ = {
	  children: ['loadProgressBar', 'playProgressBar'],
	  barName: 'playProgressBar'
	}; // MouseTimeDisplay tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  SeekBar.prototype.options_.children.splice(1, 0, 'mouseTimeDisplay');
	}
	
	Component$1.registerComponent('SeekBar', SeekBar);
	
	/**
	 * The Progress Control component contains the seek bar, load progress,
	 * and play progress.
	 *
	 * @extends Component
	 */
	
	var ProgressControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ProgressControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ProgressControl(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.handleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	    _this.throttledHandleMouseSeek = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseSeek), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleMouseDownHandler_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = ProgressControl.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-control vjs-control'
	    });
	  }
	  /**
	   * When the mouse moves over the `ProgressControl`, the pointer position
	   * gets passed down to the `MouseTimeDisplay` component.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (!seekBar) {
	      return;
	    }
	
	    var playProgressBar = seekBar.getChild('playProgressBar');
	    var mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
	
	    if (!playProgressBar && !mouseTimeDisplay) {
	      return;
	    }
	
	    var seekBarEl = seekBar.el();
	    var seekBarRect = findPosition(seekBarEl);
	    var seekBarPoint = getPointerPosition(seekBarEl, event).x; // The default skin has a gap on either side of the `SeekBar`. This means
	    // that it's possible to trigger this behavior outside the boundaries of
	    // the `SeekBar`. This ensures we stay within it at all times.
	
	    seekBarPoint = clamp(seekBarPoint, 0, 1);
	
	    if (mouseTimeDisplay) {
	      mouseTimeDisplay.update(seekBarRect, seekBarPoint);
	    }
	
	    if (playProgressBar) {
	      playProgressBar.update(seekBarRect, seekBar.getProgress());
	    }
	  }
	  /**
	   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
	   *
	   * @method ProgressControl#throttledHandleMouseSeek
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   * @listen touchmove
	   */
	
	  /**
	   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseSeek = function handleMouseSeek(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseMove(event);
	    }
	  }
	  /**
	   * Are controls are currently enabled for this progress control.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	  ;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Disable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.children().forEach(function (child) {
	      return child.disable && child.disable();
	    });
	
	    if (!this.enabled()) {
	      return;
	    }
	
	    this.off(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.off(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeListenersAddedOnMousedownAndTouchstart();
	    this.addClass('disabled');
	    this.enabled_ = false; // Restore normal playback state if controls are disabled while scrubbing
	
	    if (this.player_.scrubbing()) {
	      var seekBar = this.getChild('seekBar');
	      this.player_.scrubbing(false);
	
	      if (seekBar.videoWasPlaying) {
	        silencePromise(this.player_.play());
	      }
	    }
	  }
	  /**
	   * Enable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.children().forEach(function (child) {
	      return child.enable && child.enable();
	    });
	
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.on(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeClass('disabled');
	    this.enabled_ = true;
	  }
	  /**
	   * Cleanup listeners after the user finishes interacting with the progress controls
	   */
	  ;
	
	  _proto.removeListenersAddedOnMousedownAndTouchstart = function removeListenersAddedOnMousedownAndTouchstart() {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseDown(event);
	    }
	
	    this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseUp(event);
	    }
	
	    this.removeListenersAddedOnMousedownAndTouchstart();
	  };
	
	  return ProgressControl;
	}(Component$1);
	/**
	 * Default options for `ProgressControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ProgressControl.prototype.options_ = {
	  children: ['seekBar']
	};
	Component$1.registerComponent('ProgressControl', ProgressControl);
	
	/**
	 * Toggle Picture-in-Picture mode
	 *
	 * @extends Button
	 */
	
	var PictureInPictureToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PictureInPictureToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  function PictureInPictureToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, ['enterpictureinpicture', 'leavepictureinpicture'], function (e) {
	      return _this.handlePictureInPictureChange(e);
	    });
	
	    _this.on(player, ['disablepictureinpicturechanged', 'loadedmetadata'], function (e) {
	      return _this.handlePictureInPictureEnabledChange(e);
	    });
	
	    _this.on(player, ['loadedmetadata', 'audioonlymodechange', 'audiopostermodechange'], function () {
	      // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
	      var isSourceAudio = player.currentType().substring(0, 5) === 'audio';
	
	      if (isSourceAudio || player.audioPosterMode() || player.audioOnlyMode()) {
	        if (player.isInPictureInPicture()) {
	          player.exitPictureInPicture();
	        }
	
	        _this.hide();
	      } else {
	        _this.show();
	      }
	    }); // TODO: Deactivate button on player emptied event.
	
	
	    _this.disable();
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PictureInPictureToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-picture-in-picture-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enables or disables button based on document.pictureInPictureEnabled property value
	   * or on value returned by player.disablePictureInPicture() method.
	   */
	  ;
	
	  _proto.handlePictureInPictureEnabledChange = function handlePictureInPictureEnabledChange() {
	    if (document__default['default'].pictureInPictureEnabled && this.player_.disablePictureInPicture() === false) {
	      this.enable();
	    } else {
	      this.disable();
	    }
	  }
	  /**
	   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  ;
	
	  _proto.handlePictureInPictureChange = function handlePictureInPictureChange(event) {
	    if (this.player_.isInPictureInPicture()) {
	      this.controlText('Exit Picture-in-Picture');
	    } else {
	      this.controlText('Picture-in-Picture');
	    }
	
	    this.handlePictureInPictureEnabledChange();
	  }
	  /**
	   * This gets called when an `PictureInPictureToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isInPictureInPicture()) {
	      this.player_.requestPictureInPicture();
	    } else {
	      this.player_.exitPictureInPicture();
	    }
	  };
	
	  return PictureInPictureToggle;
	}(Button);
	/**
	 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PictureInPictureToggle.prototype.controlText_ = 'Picture-in-Picture';
	Component$1.registerComponent('PictureInPictureToggle', PictureInPictureToggle);
	
	/**
	 * Toggle fullscreen video
	 *
	 * @extends Button
	 */
	
	var FullscreenToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](FullscreenToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function FullscreenToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, 'fullscreenchange', function (e) {
	      return _this.handleFullscreenChange(e);
	    });
	
	    if (document__default['default'][player.fsApi_.fullscreenEnabled] === false) {
	      _this.disable();
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = FullscreenToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-fullscreen-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Handles fullscreenchange on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#fullscreenchange} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleFullscreenChange = function handleFullscreenChange(event) {
	    if (this.player_.isFullscreen()) {
	      this.controlText('Non-Fullscreen');
	    } else {
	      this.controlText('Fullscreen');
	    }
	  }
	  /**
	   * This gets called when an `FullscreenToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isFullscreen()) {
	      this.player_.requestFullscreen();
	    } else {
	      this.player_.exitFullscreen();
	    }
	  };
	
	  return FullscreenToggle;
	}(Button);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';
	Component$1.registerComponent('FullscreenToggle', FullscreenToggle);
	
	/**
	 * Check if volume control is supported and if it isn't hide the
	 * `Component` that was passed  using the `vjs-hidden` class.
	 *
	 * @param {Component} self
	 *        The component that should be hidden if volume is unsupported
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkVolumeSupport = function checkVolumeSupport(self, player) {
	  // hide volume controls when they're not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresVolumeControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresVolumeControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * Shows volume level
	 *
	 * @extends Component
	 */
	
	var VolumeLevel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevel, _Component);
	
	  function VolumeLevel() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = VolumeLevel.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-level'
	    });
	
	    el.appendChild(_Component.prototype.createEl.call(this, 'span', {
	      className: 'vjs-control-text'
	    }));
	    return el;
	  };
	
	  return VolumeLevel;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevel', VolumeLevel);
	
	/**
	 * Volume level tooltips display a volume above or side by side the volume bar.
	 *
	 * @extends Component
	 */
	
	var VolumeLevelTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevelTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeLevelTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the volume tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeLevelTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the tooltip relative to the `VolumeBar` and
	   * its content text.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical, content) {
	    if (!vertical) {
	      var tooltipRect = getBoundingClientRect(this.el_);
	      var playerRect = getBoundingClientRect(this.player_.el());
	      var volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
	
	      if (!playerRect || !tooltipRect) {
	        return;
	      }
	
	      var spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
	      var spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
	      var pullTooltipBy = tooltipRect.width / 2;
	
	      if (spaceLeftOfPoint < pullTooltipBy) {
	        pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	      } else if (spaceRightOfPoint < pullTooltipBy) {
	        pullTooltipBy = spaceRightOfPoint;
	      }
	
	      if (pullTooltipBy < 0) {
	        pullTooltipBy = 0;
	      } else if (pullTooltipBy > tooltipRect.width) {
	        pullTooltipBy = tooltipRect.width;
	      }
	
	      this.el_.style.right = "-" + pullTooltipBy + "px";
	    }
	
	    this.write(content + "%");
	  }
	  /**
	   * Write the volume to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted volume for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the volume tooltip relative to the `VolumeBar`.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   * @param {number} volume
	   *        The volume level to update the tooltip to
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateVolume = function updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume', function () {
	      _this2.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return VolumeLevelTooltip;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevelTooltip', VolumeLevelTooltip);
	
	/**
	 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
	 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
	 * indicating the volume level which is represented by a given point in the
	 * {@link VolumeBar}.
	 *
	 * @extends Component
	 */
	
	var MouseVolumeLevelDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseVolumeLevelDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseVolumeLevelDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseVolumeLevelDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enquires updates to its own DOM as well as the DOM of its
	   * {@link VolumeLevelTooltip} child.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical) {
	    var _this2 = this;
	
	    var volume = 100 * rangeBarPoint;
	    this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, function () {
	      if (vertical) {
	        _this2.el_.style.bottom = rangeBarRect.height * rangeBarPoint + "px";
	      } else {
	        _this2.el_.style.left = rangeBarRect.width * rangeBarPoint + "px";
	      }
	    });
	  };
	
	  return MouseVolumeLevelDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseVolumeLevelDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseVolumeLevelDisplay.prototype.options_ = {
	  children: ['volumeLevelTooltip']
	};
	Component$1.registerComponent('MouseVolumeLevelDisplay', MouseVolumeLevelDisplay);
	
	/**
	 * The bar that contains the volume level and can be clicked on to adjust the level
	 *
	 * @extends Slider
	 */
	
	var VolumeBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](VolumeBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.on('slideractive', function (e) {
	      return _this.updateLastVolume_(e);
	    });
	
	    _this.on(player, 'volumechange', function (e) {
	      return _this.updateARIAAttributes(e);
	    });
	
	    player.ready(function () {
	      return _this.updateARIAAttributes();
	    });
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-bar vjs-slider-bar'
	    }, {
	      'aria-label': this.localize('Volume Level'),
	      'aria-live': 'polite'
	    });
	  }
	  /**
	   * Handle mouse down on volume bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle movement events on the {@link VolumeMenuButton}.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var mouseVolumeLevelDisplay = this.getChild('mouseVolumeLevelDisplay');
	
	    if (mouseVolumeLevelDisplay) {
	      var volumeBarEl = this.el();
	      var volumeBarRect = getBoundingClientRect(volumeBarEl);
	      var vertical = this.vertical();
	      var volumeBarPoint = getPointerPosition(volumeBarEl, event);
	      volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x; // The default skin has a gap on either side of the `VolumeBar`. This means
	      // that it's possible to trigger this behavior outside the boundaries of
	      // the `VolumeBar`. This ensures we stay within it at all times.
	
	      volumeBarPoint = clamp(volumeBarPoint, 0, 1);
	      mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    this.checkMuted();
	    this.player_.volume(this.calculateDistance(event));
	  }
	  /**
	   * If the player is muted unmute it.
	   */
	  ;
	
	  _proto.checkMuted = function checkMuted() {
	    if (this.player_.muted()) {
	      this.player_.muted(false);
	    }
	  }
	  /**
	   * Get percent of volume level
	   *
	   * @return {number}
	   *         Volume level percent as a decimal number.
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    if (this.player_.muted()) {
	      return 0;
	    }
	
	    return this.player_.volume();
	  }
	  /**
	   * Increase volume level for keyboard users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() + 0.1);
	  }
	  /**
	   * Decrease volume level for keyboard users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() - 0.1);
	  }
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `volumechange` event that caused this function to run.
	   *
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes(event) {
	    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
	    this.el_.setAttribute('aria-valuenow', ariaValue);
	    this.el_.setAttribute('aria-valuetext', ariaValue + '%');
	  }
	  /**
	   * Returns the current value of the player volume as a percentage
	   *
	   * @private
	   */
	  ;
	
	  _proto.volumeAsPercentage_ = function volumeAsPercentage_() {
	    return Math.round(this.player_.volume() * 100);
	  }
	  /**
	   * When user starts dragging the VolumeBar, store the volume and listen for
	   * the end of the drag. When the drag ends, if the volume was set to zero,
	   * set lastVolume to the stored volume.
	   *
	   * @listens slideractive
	   * @private
	   */
	  ;
	
	  _proto.updateLastVolume_ = function updateLastVolume_() {
	    var _this2 = this;
	
	    var volumeBeforeDrag = this.player_.volume();
	    this.one('sliderinactive', function () {
	      if (_this2.player_.volume() === 0) {
	        _this2.player_.lastVolume_(volumeBeforeDrag);
	      }
	    });
	  };
	
	  return VolumeBar;
	}(Slider);
	/**
	 * Default options for the `VolumeBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeBar.prototype.options_ = {
	  children: ['volumeLevel'],
	  barName: 'volumeLevel'
	}; // MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  VolumeBar.prototype.options_.children.splice(0, 0, 'mouseVolumeLevelDisplay');
	}
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	
	
	VolumeBar.prototype.playerEvent = 'volumechange';
	Component$1.registerComponent('VolumeBar', VolumeBar);
	
	/**
	 * The component for controlling the volume level
	 *
	 * @extends Component
	 */
	
	var VolumeControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeControl(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.vertical = options.vertical || false; // Pass the vertical option down to the VolumeBar if
	    // the VolumeBar is turned on.
	
	    if (typeof options.volumeBar === 'undefined' || isPlain(options.volumeBar)) {
	      options.volumeBar = options.volumeBar || {};
	      options.volumeBar.vertical = options.vertical;
	    }
	
	    _this = _Component.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkVolumeSupport(_assertThisInitialized__default['default'](_this), player);
	    _this.throttledHandleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('touchstart', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('mousemove', function (e) {
	      return _this.handleMouseMove(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) or in focus we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeBar, ['focus', 'slideractive'], function () {
	      _this.volumeBar.addClass('vjs-slider-active');
	
	      _this.addClass('vjs-slider-active');
	
	      _this.trigger('slideractive');
	    });
	
	    _this.on(_this.volumeBar, ['blur', 'sliderinactive'], function () {
	      _this.volumeBar.removeClass('vjs-slider-active');
	
	      _this.removeClass('vjs-slider-active');
	
	      _this.trigger('sliderinactive');
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeControl.prototype;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-horizontal';
	
	    if (this.options_.vertical) {
	      orientationClass = 'vjs-volume-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-control vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    this.on(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.on(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.off(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    this.volumeBar.handleMouseMove(event);
	  };
	
	  return VolumeControl;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeControl.prototype.options_ = {
	  children: ['volumeBar']
	};
	Component$1.registerComponent('VolumeControl', VolumeControl);
	
	/**
	 * Check if muting volume is supported and if it isn't hide the mute toggle
	 * button.
	 *
	 * @param {Component} self
	 *        A reference to the mute toggle button
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkMuteSupport = function checkMuteSupport(self, player) {
	  // hide mute toggle button if it's not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresMuteControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresMuteControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * A button component for muting the audio.
	 *
	 * @extends Button
	 */
	
	var MuteToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](MuteToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MuteToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkMuteSupport(_assertThisInitialized__default['default'](_this), player);
	
	    _this.on(player, ['loadstart', 'volumechange'], function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = MuteToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-mute-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `MuteToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var vol = this.player_.volume();
	    var lastVolume = this.player_.lastVolume_();
	
	    if (vol === 0) {
	      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
	      this.player_.volume(volumeToSet);
	      this.player_.muted(false);
	    } else {
	      this.player_.muted(this.player_.muted() ? false : true);
	    }
	  }
	  /**
	   * Update the `MuteToggle` button based on the state of `volume` and `muted`
	   * on the player.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#loadstart} event if this function was called
	   *        through an event.
	   *
	   * @listens Player#loadstart
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.updateIcon_();
	    this.updateControlText_();
	  }
	  /**
	   * Update the appearance of the `MuteToggle` icon.
	   *
	   * Possible states (given `level` variable below):
	   * - 0: crossed out
	   * - 1: zero bars of volume
	   * - 2: one bar of volume
	   * - 3: two bars of volume
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateIcon_ = function updateIcon_() {
	    var vol = this.player_.volume();
	    var level = 3; // in iOS when a player is loaded with muted attribute
	    // and volume is changed with a native mute button
	    // we want to make sure muted state is updated
	
	    if (IS_IOS && this.player_.tech_ && this.player_.tech_.el_) {
	      this.player_.muted(this.player_.tech_.el_.muted);
	    }
	
	    if (vol === 0 || this.player_.muted()) {
	      level = 0;
	    } else if (vol < 0.33) {
	      level = 1;
	    } else if (vol < 0.67) {
	      level = 2;
	    } // TODO improve muted icon classes
	
	
	    for (var i = 0; i < 4; i++) {
	      removeClass(this.el_, "vjs-vol-" + i);
	    }
	
	    addClass(this.el_, "vjs-vol-" + level);
	  }
	  /**
	   * If `muted` has changed on the player, update the control text
	   * (`title` attribute on `vjs-mute-control` element and content of
	   * `vjs-control-text` element).
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateControlText_ = function updateControlText_() {
	    var soundOff = this.player_.muted() || this.player_.volume() === 0;
	    var text = soundOff ? 'Unmute' : 'Mute';
	
	    if (this.controlText() !== text) {
	      this.controlText(text);
	    }
	  };
	
	  return MuteToggle;
	}(Button);
	/**
	 * The text that should display over the `MuteToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	MuteToggle.prototype.controlText_ = 'Mute';
	Component$1.registerComponent('MuteToggle', MuteToggle);
	
	/**
	 * A Component to contain the MuteToggle and VolumeControl so that
	 * they can work together.
	 *
	 * @extends Component
	 */
	
	var VolumePanel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumePanel, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumePanel(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (typeof options.inline !== 'undefined') {
	      options.inline = options.inline;
	    } else {
	      options.inline = true;
	    } // pass the inline option down to the VolumeControl as vertical if
	    // the VolumeControl is on.
	
	
	    if (typeof options.volumeControl === 'undefined' || isPlain(options.volumeControl)) {
	      options.volumeControl = options.volumeControl || {};
	      options.volumeControl.vertical = !options.inline;
	    }
	
	    _this = _Component.call(this, player, options) || this; // this handler is used by mouse handler methods below
	
	    _this.handleKeyPressHandler_ = function (e) {
	      return _this.handleKeyPress(e);
	    };
	
	    _this.on(player, ['loadstart'], function (e) {
	      return _this.volumePanelState_(e);
	    });
	
	    _this.on(_this.muteToggle, 'keyup', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on(_this.volumeControl, 'keyup', function (e) {
	      return _this.handleVolumeControlKeyUp(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on('mouseover', function (e) {
	      return _this.handleMouseOver(e);
	    });
	
	    _this.on('mouseout', function (e) {
	      return _this.handleMouseOut(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeControl, ['slideractive'], _this.sliderActive_);
	
	    _this.on(_this.volumeControl, ['sliderinactive'], _this.sliderInactive_);
	
	    return _this;
	  }
	  /**
	   * Add vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#slideractive
	   * @private
	   */
	
	
	  var _proto = VolumePanel.prototype;
	
	  _proto.sliderActive_ = function sliderActive_() {
	    this.addClass('vjs-slider-active');
	  }
	  /**
	   * Removes vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#sliderinactive
	   * @private
	   */
	  ;
	
	  _proto.sliderInactive_ = function sliderInactive_() {
	    this.removeClass('vjs-slider-active');
	  }
	  /**
	   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
	   * depending on MuteToggle and VolumeControl state
	   *
	   * @listens Player#loadstart
	   * @private
	   */
	  ;
	
	  _proto.volumePanelState_ = function volumePanelState_() {
	    // hide volume panel if neither volume control or mute toggle
	    // are displayed
	    if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-hidden');
	    } // if only mute toggle is visible we don't want
	    // volume panel expanding when hovered or active
	
	
	    if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-mute-toggle-only');
	    }
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-panel-horizontal';
	
	    if (!this.options_.inline) {
	      orientationClass = 'vjs-volume-panel-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-panel vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Dispose of the `volume-panel` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseOut();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
	   * the volume panel and sets focus on `MuteToggle`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keyup` event that caused this function to be called.
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleVolumeControlKeyUp = function handleVolumeControlKeyUp(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.muteToggle.focus();
	    }
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
	   * Turns on listening for `mouseover` event. When they happen it
	   * calls `this.handleMouseOver`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseover` event that caused this function to be called.
	   *
	   * @listens mouseover
	   */
	  ;
	
	  _proto.handleMouseOver = function handleMouseOver(event) {
	    this.addClass('vjs-hover');
	    on(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
	   * Turns on listening for `mouseout` event. When they happen it
	   * calls `this.handleMouseOut`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseout` event that caused this function to be called.
	   *
	   * @listens mouseout
	   */
	  ;
	
	  _proto.handleMouseOut = function handleMouseOut(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
	   * looking for ESC, which hides the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        The keypress that triggered this event.
	   *
	   * @listens keydown | keyup
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.handleMouseOut();
	    }
	  };
	
	  return VolumePanel;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumePanel.prototype.options_ = {
	  children: ['muteToggle', 'volumeControl']
	};
	Component$1.registerComponent('VolumePanel', VolumePanel);
	
	/**
	 * The Menu component is used to build popup menus, including subtitle and
	 * captions selection menus.
	 *
	 * @extends Component
	 */
	
	var Menu = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Menu, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        the player that this component should attach to
	   *
	   * @param {Object} [options]
	   *        Object of option names and values
	   *
	   */
	  function Menu(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (options) {
	      _this.menuButton_ = options.menuButton;
	    }
	
	    _this.focusedChild_ = -1;
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    }); // All the menu item instances share the same blur handler provided by the menu container.
	
	
	    _this.boundHandleBlur_ = function (e) {
	      return _this.handleBlur(e);
	    };
	
	    _this.boundHandleTapClick_ = function (e) {
	      return _this.handleTapClick(e);
	    };
	
	    return _this;
	  }
	  /**
	   * Add event listeners to the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to add listeners to.
	   *
	   */
	
	
	  var _proto = Menu.prototype;
	
	  _proto.addEventListenerForItem = function addEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.on(component, 'blur', this.boundHandleBlur_);
	    this.on(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * Remove event listeners from the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to remove listeners.
	   *
	   */
	  ;
	
	  _proto.removeEventListenerForItem = function removeEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.off(component, 'blur', this.boundHandleBlur_);
	    this.off(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * This method will be called indirectly when the component has been added
	   * before the component adds to the new menu instance by `addItem`.
	   * In this case, the original menu instance will remove the component
	   * by calling `removeChild`.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem`
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    this.removeEventListenerForItem(component);
	
	    _Component.prototype.removeChild.call(this, component);
	  }
	  /**
	   * Add a {@link MenuItem} to the menu.
	   *
	   * @param {Object|string} component
	   *        The name or instance of the `MenuItem` to add.
	   *
	   */
	  ;
	
	  _proto.addItem = function addItem(component) {
	    var childComponent = this.addChild(component);
	
	    if (childComponent) {
	      this.addEventListenerForItem(childComponent);
	    }
	  }
	  /**
	   * Create the `Menu`s DOM element.
	   *
	   * @return {Element}
	   *         the element that was created
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var contentElType = this.options_.contentElType || 'ul';
	    this.contentEl_ = createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	    this.contentEl_.setAttribute('role', 'menu');
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.appendChild(this.contentEl_); // Prevent clicks from bubbling up. Needed for Menu Buttons,
	    // where a click on the parent is significant
	
	    on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.boundHandleBlur_ = null;
	    this.boundHandleTapClick_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Called when a `MenuItem` loses focus.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	  ;
	
	  _proto.handleBlur = function handleBlur(event) {
	    var relatedTarget = event.relatedTarget || document__default['default'].activeElement; // Close menu popup when a user clicks outside the menu
	
	    if (!this.children().some(function (element) {
	      return element.el() === relatedTarget;
	    })) {
	      var btn = this.menuButton_;
	
	      if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) {
	        btn.unpressButton();
	      }
	    }
	  }
	  /**
	   * Called when a `MenuItem` gets clicked or tapped.
	   *
	   * @param {EventTarget~Event} event
	   *        The `click` or `tap` event that caused this function to be called.
	   *
	   * @listens click,tap
	   */
	  ;
	
	  _proto.handleTapClick = function handleTapClick(event) {
	    // Unpress the associated MenuButton, and move focus back to it
	    if (this.menuButton_) {
	      this.menuButton_.unpressButton();
	      var childComponents = this.children();
	
	      if (!Array.isArray(childComponents)) {
	        return;
	      }
	
	      var foundComponent = childComponents.filter(function (component) {
	        return component.el() === event.target;
	      })[0];
	
	      if (!foundComponent) {
	        return;
	      } // don't focus menu button if item is a caption settings item
	      // because focus will move elsewhere
	
	
	      if (foundComponent.name() !== 'CaptionSettingsMenuItem') {
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Handle a `keydown` event on this menu. This listener is added in the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        A `keydown` event that happened on the menu.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack();
	    }
	  }
	  /**
	   * Move to next (lower) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ + 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Move to previous (higher) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ - 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Set focus on a {@link MenuItem} in the `Menu`.
	   *
	   * @param {Object|string} [item=0]
	   *        Index of child item set focus on.
	   */
	  ;
	
	  _proto.focus = function focus(item) {
	    if (item === void 0) {
	      item = 0;
	    }
	
	    var children = this.children().slice();
	    var haveTitle = children.length && children[0].hasClass('vjs-menu-title');
	
	    if (haveTitle) {
	      children.shift();
	    }
	
	    if (children.length > 0) {
	      if (item < 0) {
	        item = 0;
	      } else if (item >= children.length) {
	        item = children.length - 1;
	      }
	
	      this.focusedChild_ = item;
	      children[item].el_.focus();
	    }
	  };
	
	  return Menu;
	}(Component$1);
	
	Component$1.registerComponent('Menu', Menu);
	
	/**
	 * A `MenuButton` class for any popup {@link Menu}.
	 *
	 * @extends Component
	 */
	
	var MenuButton = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MenuButton, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function MenuButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Component.call(this, player, options) || this;
	    _this.menuButton_ = new Button(player, options);
	
	    _this.menuButton_.controlText(_this.controlText_);
	
	    _this.menuButton_.el_.setAttribute('aria-haspopup', 'true'); // Add buildCSSClass values to the button, not the wrapper
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    _this.menuButton_.el_.className = _this.buildCSSClass() + ' ' + buttonClass;
	
	    _this.menuButton_.removeClass('vjs-control');
	
	    _this.addChild(_this.menuButton_);
	
	    _this.update();
	
	    _this.enabled_ = true;
	
	    var handleClick = function handleClick(e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMenuKeyUp_ = function (e) {
	      return _this.handleMenuKeyUp(e);
	    };
	
	    _this.on(_this.menuButton_, 'tap', handleClick);
	
	    _this.on(_this.menuButton_, 'click', handleClick);
	
	    _this.on(_this.menuButton_, 'keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on(_this.menuButton_, 'mouseenter', function () {
	      _this.addClass('vjs-hover');
	
	      _this.menu.show();
	
	      on(document__default['default'], 'keyup', _this.handleMenuKeyUp_);
	    });
	
	    _this.on('mouseleave', function (e) {
	      return _this.handleMouseLeave(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleSubmenuKeyDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   */
	
	
	  var _proto = MenuButton.prototype;
	
	  _proto.update = function update() {
	    var menu = this.createMenu();
	
	    if (this.menu) {
	      this.menu.dispose();
	      this.removeChild(this.menu);
	    }
	
	    this.menu = menu;
	    this.addChild(menu);
	    /**
	     * Track the state of the menu button
	     *
	     * @type {Boolean}
	     * @private
	     */
	
	    this.buttonPressed_ = false;
	    this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	
	    if (this.items && this.items.length <= this.hideThreshold_) {
	      this.hide();
	      this.menu.contentEl_.removeAttribute('role');
	    } else {
	      this.show();
	      this.menu.contentEl_.setAttribute('role', 'menu');
	    }
	  }
	  /**
	   * Create the menu and add all items to it.
	   *
	   * @return {Menu}
	   *         The constructed menu
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    var menu = new Menu(this.player_, {
	      menuButton: this
	    });
	    /**
	     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
	     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
	     * it here because every time we run `createMenu` we need to reset the value.
	     *
	     * @protected
	     * @type {Number}
	     */
	
	    this.hideThreshold_ = 0; // Add a title list item to the top
	
	    if (this.options_.title) {
	      var titleEl = createEl('li', {
	        className: 'vjs-menu-title',
	        textContent: toTitleCase$1(this.options_.title),
	        tabIndex: -1
	      });
	      var titleComponent = new Component$1(this.player_, {
	        el: titleEl
	      });
	      menu.addItem(titleComponent);
	    }
	
	    this.items = this.createItems();
	
	    if (this.items) {
	      // Add menu items to the menu
	      for (var i = 0; i < this.items.length; i++) {
	        menu.addItem(this.items[i]);
	      }
	    }
	
	    return menu;
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.createItems = function createItems() {}
	  /**
	   * Create the `MenuButtons`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildWrapperCSSClass()
	    }, {});
	  }
	  /**
	   * Allow sub components to stack CSS class names for the wrapper element
	   *
	   * @return {string}
	   *         The constructed wrapper DOM `className`
	   */
	  ;
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    } // TODO: Fix the CSS so that this isn't necessary
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    return "vjs-menu-button " + menuButtonClass + " " + buttonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return "vjs-menu-button " + menuButtonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Get or set the localized control text that will be used for accessibility.
	   *
	   * > NOTE: This will come from the internal `menuButton_` element.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.menuButton_.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.menuButton_.el();
	    }
	
	    return this.menuButton_.controlText(text, el);
	  }
	  /**
	   * Dispose of the `menu-button` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseLeave();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handle a click on a `MenuButton`.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.buttonPressed_) {
	      this.unpressButton();
	    } else {
	      this.pressButton();
	    }
	  }
	  /**
	   * Handle `mouseleave` for `MenuButton`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseleave` event that caused this function to be called.
	   *
	   * @listens mouseleave
	   */
	  ;
	
	  _proto.handleMouseLeave = function handleMouseLeave(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleMenuKeyUp_);
	  }
	  /**
	   * Set the focus to the actual button, not to this element
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.menuButton_.focus();
	  }
	  /**
	   * Remove the focus from the actual button, not this element
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.menuButton_.blur();
	  }
	  /**
	   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      } // Up Arrow or Down Arrow also 'press' the button to open the menu
	
	    } else if (keycode__default['default'].isEventKey(event, 'Up') || keycode__default['default'].isEventKey(event, 'Down')) {
	      if (!this.buttonPressed_) {
	        event.preventDefault();
	        this.pressButton();
	      }
	    }
	  }
	  /**
	   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleMenuKeyUp = function handleMenuKeyUp(event) {
	    // Escape hides popup menu
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      this.removeClass('vjs-hover');
	    }
	  }
	  /**
	   * This method name now delegates to `handleSubmenuKeyDown`. This means
	   * anyone calling `handleSubmenuKeyPress` will not see their method calls
	   * stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
	    this.handleSubmenuKeyDown(event);
	  }
	  /**
	   * Handle a `keydown` event on a sub-menu. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleSubmenuKeyDown = function handleSubmenuKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Put the current `MenuButton` into a pressed state.
	   */
	  ;
	
	  _proto.pressButton = function pressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = true;
	      this.menu.show();
	      this.menu.lockShowing();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'true'); // set the focus into the submenu, except on iOS where it is resulting in
	      // undesired scrolling behavior when the player is in an iframe
	
	      if (IS_IOS && isInFrame()) {
	        // Return early so that the menu isn't focused
	        return;
	      }
	
	      this.menu.focus();
	    }
	  }
	  /**
	   * Take the current `MenuButton` out of a pressed state.
	   */
	  ;
	
	  _proto.unpressButton = function unpressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = false;
	      this.menu.unlockShowing();
	      this.menu.hide();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	    }
	  }
	  /**
	   * Disable the `MenuButton`. Don't allow it to be clicked.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.unpressButton();
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.menuButton_.disable();
	  }
	  /**
	   * Enable the `MenuButton`. Allow it to be clicked.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.enabled_ = true;
	    this.removeClass('vjs-disabled');
	    this.menuButton_.enable();
	  };
	
	  return MenuButton;
	}(Component$1);
	
	Component$1.registerComponent('MenuButton', MenuButton);
	
	/**
	 * The base class for buttons that toggle specific  track types (e.g. subtitles).
	 *
	 * @extends MenuButton
	 */
	
	var TrackButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](TrackButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TrackButton(player, options) {
	    var _this;
	
	    var tracks = options.tracks;
	    _this = _MenuButton.call(this, player, options) || this;
	
	    if (_this.items.length <= 1) {
	      _this.hide();
	    }
	
	    if (!tracks) {
	      return _assertThisInitialized__default['default'](_this);
	    }
	
	    var updateHandler = bind(_assertThisInitialized__default['default'](_this), _this.update);
	    tracks.addEventListener('removetrack', updateHandler);
	    tracks.addEventListener('addtrack', updateHandler);
	    tracks.addEventListener('labelchange', updateHandler);
	
	    _this.player_.on('ready', updateHandler);
	
	    _this.player_.on('dispose', function () {
	      tracks.removeEventListener('removetrack', updateHandler);
	      tracks.removeEventListener('addtrack', updateHandler);
	      tracks.removeEventListener('labelchange', updateHandler);
	    });
	
	    return _this;
	  }
	
	  return TrackButton;
	}(MenuButton);
	
	Component$1.registerComponent('TrackButton', TrackButton);
	
	/**
	 * @file menu-keys.js
	 */
	
	/**
	  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
	  * Note that 'Enter' and 'Space' are not included here (otherwise they would
	  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
	  * @typedef MenuKeys
	  * @array
	  */
	var MenuKeys = ['Tab', 'Esc', 'Up', 'Down', 'Right', 'Left'];
	
	/**
	 * The component for a menu item. `<li>`
	 *
	 * @extends ClickableComponent
	 */
	
	var MenuItem = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](MenuItem, _ClickableComponent);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   *
	   */
	  function MenuItem(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	    _this.selectable = options.selectable;
	    _this.isSelected_ = options.selected || false;
	    _this.multiSelectable = options.multiSelectable;
	
	    _this.selected(_this.isSelected_);
	
	    if (_this.selectable) {
	      if (_this.multiSelectable) {
	        _this.el_.setAttribute('role', 'menuitemcheckbox');
	      } else {
	        _this.el_.setAttribute('role', 'menuitemradio');
	      }
	    } else {
	      _this.el_.setAttribute('role', 'menuitem');
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `MenuItem's DOM element
	   *
	   * @param {string} [type=li]
	   *        Element's node type, not actually used, always set to `li`.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element
	   *
	   * @param {Object} [attrs={}]
	   *        An object of attributes that should be set on the element
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = MenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    // The control is textual, not just an icon
	    this.nonIconControl = true;
	
	    var el = _ClickableComponent.prototype.createEl.call(this, 'li', assign({
	      className: 'vjs-menu-item',
	      tabIndex: -1
	    }, props), attrs); // swap icon with menu item text.
	
	
	    el.replaceChild(createEl('span', {
	      className: 'vjs-menu-item-text',
	      textContent: this.localize(this.options_.label)
	    }), el.querySelector('.vjs-icon-placeholder'));
	    return el;
	  }
	  /**
	   * Ignore keys which are used by the menu, but pass any other ones up. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (!MenuKeys.some(function (key) {
	      return keycode__default['default'].isEventKey(event, key);
	    })) {
	      // Pass keydown handling up for unused keys
	      _ClickableComponent.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Any click on a `MenuItem` puts it into the selected state.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    this.selected(true);
	  }
	  /**
	   * Set the state for this menu item as selected or not.
	   *
	   * @param {boolean} selected
	   *        if the menu item is selected or not
	   */
	  ;
	
	  _proto.selected = function selected(_selected) {
	    if (this.selectable) {
	      if (_selected) {
	        this.addClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'true'); // aria-checked isn't fully supported by browsers/screen readers,
	        // so indicate selected state to screen reader in the control text.
	
	        this.controlText(', selected');
	        this.isSelected_ = true;
	      } else {
	        this.removeClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'false'); // Indicate un-selected state to screen reader
	
	        this.controlText('');
	        this.isSelected_ = false;
	      }
	    }
	  };
	
	  return MenuItem;
	}(ClickableComponent);
	
	Component$1.registerComponent('MenuItem', MenuItem);
	
	/**
	 * The specific menu item type for selecting a language within a text track kind
	 *
	 * @extends MenuItem
	 */
	
	var TextTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](TextTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TextTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.textTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.mode === 'showing';
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track; // Determine the relevant kind(s) of tracks for this component and filter
	    // out empty kinds.
	
	    _this.kinds = (options.kinds || [options.kind || _this.track.kind]).filter(Boolean);
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this.handleSelectedLanguageChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    player.on(['loadstart', 'texttrackchange'], changeHandler);
	    tracks.addEventListener('change', changeHandler);
	    tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	
	    _this.on('dispose', function () {
	      player.off(['loadstart', 'texttrackchange'], changeHandler);
	      tracks.removeEventListener('change', changeHandler);
	      tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	    }); // iOS7 doesn't dispatch change events to TextTrackLists when an
	    // associated track's mode changes. Without something like
	    // Object.observe() (also not present on iOS7), it's not
	    // possible to detect changes to the mode attribute and polyfill
	    // the change event. As a poor substitute, we manually dispatch
	    // change events whenever the controls modify the mode.
	
	
	    if (tracks.onchange === undefined) {
	      var event;
	
	      _this.on(['tap', 'click'], function () {
	        if (typeof window__default['default'].Event !== 'object') {
	          // Android 2.3 throws an Illegal Constructor error for window.Event
	          try {
	            event = new window__default['default'].Event('change');
	          } catch (err) {// continue regardless of error
	          }
	        }
	
	        if (!event) {
	          event = document__default['default'].createEvent('Event');
	          event.initEvent('change', true, true);
	        }
	
	        tracks.dispatchEvent(event);
	      });
	    } // set the default state based on current tracks
	
	
	    _this.handleTracksChange();
	
	    return _this;
	  }
	  /**
	   * This gets called when an `TextTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = TextTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var referenceTrack = this.track;
	    var tracks = this.player_.textTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // If the track from the text tracks list is not of the right kind,
	      // skip it. We do not want to affect tracks of incompatible kind(s).
	
	      if (this.kinds.indexOf(track.kind) === -1) {
	        continue;
	      } // If this text track is the component's track and it is not showing,
	      // set it to showing.
	
	
	      if (track === referenceTrack) {
	        if (track.mode !== 'showing') {
	          track.mode = 'showing';
	        } // If this text track is not the component's track and it is not
	        // disabled, set it to disabled.
	
	      } else if (track.mode !== 'disabled') {
	        track.mode = 'disabled';
	      }
	    }
	  }
	  /**
	   * Handle text track list change
	   *
	   * @param {EventTarget~Event} event
	   *        The `change` event that caused this function to be called.
	   *
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var shouldBeSelected = this.track.mode === 'showing'; // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    if (this.track.mode === 'showing') {
	      var selectedLanguage = this.player_.cache_.selectedLanguage; // Don't replace the kind of track across the same language
	
	      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
	        return;
	      }
	
	      this.player_.cache_.selectedLanguage = {
	        enabled: true,
	        language: this.track.language,
	        kind: this.track.kind
	      };
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    // remove reference to track object on dispose
	    this.track = null;
	
	    _MenuItem.prototype.dispose.call(this);
	  };
	
	  return TextTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('TextTrackMenuItem', TextTrackMenuItem);
	
	/**
	 * A special menu item for turning of a specific type of text track
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var OffTextTrackMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](OffTextTrackMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function OffTextTrackMenuItem(player, options) {
	    // Create pseudo track info
	    // Requires options['kind']
	    options.track = {
	      player: player,
	      // it is no longer necessary to store `kind` or `kinds` on the track itself
	      // since they are now stored in the `kinds` property of all instances of
	      // TextTrackMenuItem, but this will remain for backwards compatibility
	      kind: options.kind,
	      kinds: options.kinds,
	      "default": false,
	      mode: 'disabled'
	    };
	
	    if (!options.kinds) {
	      options.kinds = [options.kind];
	    }
	
	    if (options.label) {
	      options.track.label = options.label;
	    } else {
	      options.track.label = options.kinds.join(' and ') + ' off';
	    } // MenuItem is selectable
	
	
	    options.selectable = true; // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	
	    options.multiSelectable = false;
	    return _TextTrackMenuItem.call(this, player, options) || this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   */
	
	
	  var _proto = OffTextTrackMenuItem.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var shouldBeSelected = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
	        shouldBeSelected = false;
	        break;
	      }
	    } // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    var tracks = this.player().textTracks();
	    var allHidden = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (['captions', 'descriptions', 'subtitles'].indexOf(track.kind) > -1 && track.mode === 'showing') {
	        allHidden = false;
	        break;
	      }
	    }
	
	    if (allHidden) {
	      this.player_.cache_.selectedLanguage = {
	        enabled: false
	      };
	    }
	  };
	
	  return OffTextTrackMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific text track types (e.g. subtitles)
	 *
	 * @extends MenuButton
	 */
	
	var TextTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](TextTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function TextTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.textTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @param {TextTrackMenuItem[]} [items=[]]
	   *        Existing array of items to use during creation
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items that were created
	   */
	
	
	  var _proto = TextTrackButton.prototype;
	
	  _proto.createItems = function createItems(items, TrackMenuItem) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    if (TrackMenuItem === void 0) {
	      TrackMenuItem = TextTrackMenuItem;
	    }
	
	    // Label is an override for the [track] off label
	    // USed to localise captions/subtitles
	    var label;
	
	    if (this.label_) {
	      label = this.label_ + " off";
	    } // Add an OFF menu item to turn all tracks off
	
	
	    items.push(new OffTextTrackMenuItem(this.player_, {
	      kinds: this.kinds_,
	      kind: this.kind_,
	      label: label
	    }));
	    this.hideThreshold_ += 1;
	    var tracks = this.player_.textTracks();
	
	    if (!Array.isArray(this.kinds_)) {
	      this.kinds_ = [this.kind_];
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // only add tracks that are of an appropriate kind and have a label
	
	      if (this.kinds_.indexOf(track.kind) > -1) {
	        var item = new TrackMenuItem(this.player_, {
	          track: track,
	          kinds: this.kinds_,
	          kind: this.kind_,
	          // MenuItem is selectable
	          selectable: true,
	          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	          multiSelectable: false
	        });
	        item.addClass("vjs-" + track.kind + "-menu-item");
	        items.push(item);
	      }
	    }
	
	    return items;
	  };
	
	  return TextTrackButton;
	}(TrackButton);
	
	Component$1.registerComponent('TextTrackButton', TextTrackButton);
	
	/**
	 * The chapter track menu item
	 *
	 * @extends MenuItem
	 */
	
	var ChaptersTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](ChaptersTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ChaptersTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var cue = options.cue;
	    var currentTime = player.currentTime(); // Modify options for parent MenuItem class's init.
	
	    options.selectable = true;
	    options.multiSelectable = false;
	    options.label = cue.text;
	    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	    _this.cue = cue;
	    return _this;
	  }
	  /**
	   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = ChaptersTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player_.currentTime(this.cue.startTime);
	  };
	
	  return ChaptersTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);
	
	/**
	 * The button component for toggling and selecting chapters
	 * Chapters act much differently than other text tracks
	 * Cues are navigation vs. other tracks of alternative languages
	 *
	 * @extends TextTrackButton
	 */
	
	var ChaptersButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](ChaptersButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this function is ready.
	   */
	  function ChaptersButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	
	    _this.selectCurrentItem_ = function () {
	      _this.items.forEach(function (item) {
	        item.selected(_this.track_.activeCues[0] === item.cue);
	      });
	    };
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = ChaptersButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   *
	   * @param {EventTarget~Event} [event]
	   *        An event that triggered this function to run.
	   *
	   * @listens TextTrackList#addtrack
	   * @listens TextTrackList#removetrack
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.update = function update(event) {
	    if (event && event.track && event.track.kind !== 'chapters') {
	      return;
	    }
	
	    var track = this.findChaptersTrack();
	
	    if (track !== this.track_) {
	      this.setTrack(track);
	
	      _TextTrackButton.prototype.update.call(this);
	    } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) {
	      // Update the menu initially or if the number of cues has changed since set
	      _TextTrackButton.prototype.update.call(this);
	    }
	  }
	  /**
	   * Set the currently selected track for the chapters button.
	   *
	   * @param {TextTrack} track
	   *        The new track to select. Nothing will change if this is the currently selected
	   *        track.
	   */
	  ;
	
	  _proto.setTrack = function setTrack(track) {
	    if (this.track_ === track) {
	      return;
	    }
	
	    if (!this.updateHandler_) {
	      this.updateHandler_ = this.update.bind(this);
	    } // here this.track_ refers to the old track instance
	
	
	    if (this.track_) {
	      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (remoteTextTrackEl) {
	        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.removeEventListener('cuechange', this.selectCurrentItem_);
	      this.track_ = null;
	    }
	
	    this.track_ = track; // here this.track_ refers to the new track instance
	
	    if (this.track_) {
	      this.track_.mode = 'hidden';
	
	      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (_remoteTextTrackEl) {
	        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.addEventListener('cuechange', this.selectCurrentItem_);
	    }
	  }
	  /**
	   * Find the track object that is currently in use by this ChaptersButton
	   *
	   * @return {TextTrack|undefined}
	   *         The current track or undefined if none was found.
	   */
	  ;
	
	  _proto.findChaptersTrack = function findChaptersTrack() {
	    var tracks = this.player_.textTracks() || [];
	
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      // We will always choose the last track as our chaptersTrack
	      var track = tracks[i];
	
	      if (track.kind === this.kind_) {
	        return track;
	      }
	    }
	  }
	  /**
	   * Get the caption for the ChaptersButton based on the track label. This will also
	   * use the current tracks localized kind as a fallback if a label does not exist.
	   *
	   * @return {string}
	   *         The tracks current label or the localized track kind.
	   */
	  ;
	
	  _proto.getMenuCaption = function getMenuCaption() {
	    if (this.track_ && this.track_.label) {
	      return this.track_.label;
	    }
	
	    return this.localize(toTitleCase$1(this.kind_));
	  }
	  /**
	   * Create menu from chapter track
	   *
	   * @return {Menu}
	   *         New menu for the chapter buttons
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    this.options_.title = this.getMenuCaption();
	    return _TextTrackButton.prototype.createMenu.call(this);
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!this.track_) {
	      return items;
	    }
	
	    var cues = this.track_.cues;
	
	    if (!cues) {
	      return items;
	    }
	
	    for (var i = 0, l = cues.length; i < l; i++) {
	      var cue = cues[i];
	      var mi = new ChaptersTrackMenuItem(this.player_, {
	        track: this.track_,
	        cue: cue
	      });
	      items.push(mi);
	    }
	
	    return items;
	  };
	
	  return ChaptersButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	ChaptersButton.prototype.kind_ = 'chapters';
	/**
	 * The text that should display over the `ChaptersButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	ChaptersButton.prototype.controlText_ = 'Chapters';
	Component$1.registerComponent('ChaptersButton', ChaptersButton);
	
	/**
	 * The button component for toggling and selecting descriptions
	 *
	 * @extends TextTrackButton
	 */
	
	var DescriptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](DescriptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function DescriptionsButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	    var tracks = player.textTracks();
	    var changeHandler = bind(_assertThisInitialized__default['default'](_this), _this.handleTracksChange);
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  var _proto = DescriptionsButton.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var disabled = false; // Check whether a track of a different kind is showing
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== this.kind_ && track.mode === 'showing') {
	        disabled = true;
	        break;
	      }
	    } // If another track is showing, disable this menu button
	
	
	    if (disabled) {
	      this.disable();
	    } else {
	      this.enable();
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return DescriptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DescriptionsButton.prototype.kind_ = 'descriptions';
	/**
	 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	DescriptionsButton.prototype.controlText_ = 'Descriptions';
	Component$1.registerComponent('DescriptionsButton', DescriptionsButton);
	
	/**
	 * The button component for toggling and selecting subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubtitlesButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubtitlesButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function SubtitlesButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubtitlesButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return SubtitlesButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	SubtitlesButton.prototype.kind_ = 'subtitles';
	/**
	 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	SubtitlesButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubtitlesButton', SubtitlesButton);
	
	/**
	 * The menu item for caption track settings menu
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var CaptionSettingsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](CaptionSettingsMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CaptionSettingsMenuItem(player, options) {
	    var _this;
	
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' settings',
	      selectable: false,
	      "default": false,
	      mode: 'disabled'
	    }; // CaptionSettingsMenuItem has no concept of 'selected'
	
	    options.selectable = false;
	    options.name = 'CaptionSettingsMenuItem';
	    _this = _TextTrackMenuItem.call(this, player, options) || this;
	
	    _this.addClass('vjs-texttrack-settings');
	
	    _this.controlText(', opens ' + options.kind + ' settings dialog');
	
	    return _this;
	  }
	  /**
	   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = CaptionSettingsMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    this.player().getChild('textTrackSettings').open();
	  };
	
	  return CaptionSettingsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions
	 *
	 * @extends TextTrackButton
	 */
	
	var CaptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](CaptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function CaptionsButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = CaptionsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.kind_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    return _TextTrackButton.prototype.createItems.call(this, items);
	  };
	
	  return CaptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CaptionsButton.prototype.kind_ = 'captions';
	/**
	 * The text that should display over the `CaptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	CaptionsButton.prototype.controlText_ = 'Captions';
	Component$1.registerComponent('CaptionsButton', CaptionsButton);
	
	/**
	 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
	 * in the SubsCapsMenu.
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var SubsCapsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](SubsCapsMenuItem, _TextTrackMenuItem);
	
	  function SubsCapsMenuItem() {
	    return _TextTrackMenuItem.apply(this, arguments) || this;
	  }
	
	  var _proto = SubsCapsMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _TextTrackMenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'captions') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        // space added as the text will visually flow with the
	        // label
	        textContent: " " + this.localize('Captions')
	      }));
	    }
	
	    return el;
	  };
	
	  return SubsCapsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('SubsCapsMenuItem', SubsCapsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions and/or subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubsCapsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubsCapsButton, _TextTrackButton);
	
	  function SubsCapsButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _TextTrackButton.call(this, player, options) || this; // Although North America uses "captions" in most cases for
	    // "captions and subtitles" other locales use "subtitles"
	
	    _this.label_ = 'subtitles';
	
	    if (['en', 'en-us', 'en-ca', 'fr-ca'].indexOf(_this.player_.language_) > -1) {
	      _this.label_ = 'captions';
	    }
	
	    _this.menuButton_.controlText(toTitleCase$1(_this.label_));
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubsCapsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption/subtitles menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.label_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
	    return items;
	  };
	
	  return SubsCapsButton;
	}(TextTrackButton);
	/**
	 * `kind`s of TextTrack to look for to associate it with this menu.
	 *
	 * @type {array}
	 * @private
	 */
	
	
	SubsCapsButton.prototype.kinds_ = ['captions', 'subtitles'];
	/**
	 * The text that should display over the `SubsCapsButton`s controls.
	 *
	 *
	 * @type {string}
	 * @private
	 */
	
	SubsCapsButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubsCapsButton', SubsCapsButton);
	
	/**
	 * An {@link AudioTrack} {@link MenuItem}
	 *
	 * @extends MenuItem
	 */
	
	var AudioTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](AudioTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function AudioTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.audioTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.enabled;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	
	    _this.addClass("vjs-" + track.kind + "-menu-item");
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	
	  var _proto = AudioTrackMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _MenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'main-desc') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        textContent: ' ' + this.localize('Descriptions')
	      }));
	    }
	
	    return el;
	  }
	  /**
	   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this, event); // the audio track list will automatically toggle other tracks
	    // off for us.
	
	
	    this.track.enabled = true; // when native audio tracks are used, we want to make sure that other tracks are turned off
	
	    if (this.player_.tech_.featuresNativeAudioTracks) {
	      var tracks = this.player_.audioTracks();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i]; // skip the current track since we enabled it above
	
	        if (track === this.track) {
	          continue;
	        }
	
	        track.enabled = track === this.track;
	      }
	    }
	  }
	  /**
	   * Handle any {@link AudioTrack} change.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link AudioTrackList#change} event that caused this to run.
	   *
	   * @listens AudioTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.enabled);
	  };
	
	  return AudioTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific {@link AudioTrack} types.
	 *
	 * @extends TrackButton
	 */
	
	var AudioTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](AudioTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function AudioTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.audioTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = AudioTrackButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create a menu item for each audio track
	   *
	   * @param {AudioTrackMenuItem[]} [items=[]]
	   *        An array of existing menu items to use.
	   *
	   * @return {AudioTrackMenuItem[]}
	   *         An array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems(items) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    // if there's only one audio track, there no point in showing it
	    this.hideThreshold_ = 1;
	    var tracks = this.player_.audioTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	      items.push(new AudioTrackMenuItem(this.player_, {
	        track: track,
	        // MenuItem is selectable
	        selectable: true,
	        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	        multiSelectable: false
	      }));
	    }
	
	    return items;
	  };
	
	  return AudioTrackButton;
	}(TrackButton);
	/**
	 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	AudioTrackButton.prototype.controlText_ = 'Audio Track';
	Component$1.registerComponent('AudioTrackButton', AudioTrackButton);
	
	/**
	 * The specific menu item type for selecting a playback rate.
	 *
	 * @extends MenuItem
	 */
	
	var PlaybackRateMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](PlaybackRateMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuItem(player, options) {
	    var _this;
	
	    var label = options.rate;
	    var rate = parseFloat(label, 10); // Modify options for parent MenuItem class's init.
	
	    options.label = label;
	    options.selected = rate === player.playbackRate();
	    options.selectable = true;
	    options.multiSelectable = false;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.label = label;
	    _this.rate = rate;
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = PlaybackRateMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player().playbackRate(this.rate);
	  }
	  /**
	   * Update the PlaybackRateMenuItem when the playbackrate changes.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ratechange` event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.selected(this.player().playbackRate() === this.rate);
	  };
	
	  return PlaybackRateMenuItem;
	}(MenuItem);
	/**
	 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuItem.prototype.contentElType = 'button';
	Component$1.registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);
	
	/**
	 * The component for controlling the playback rate.
	 *
	 * @extends MenuButton
	 */
	
	var PlaybackRateMenuButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](PlaybackRateMenuButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuButton(player, options) {
	    var _this;
	
	    _this = _MenuButton.call(this, player, options) || this;
	
	    _this.menuButton_.el_.setAttribute('aria-describedby', _this.labelElId_);
	
	    _this.updateVisibility();
	
	    _this.updateLabel();
	
	    _this.on(player, 'loadstart', function (e) {
	      return _this.updateVisibility(e);
	    });
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.updateLabel(e);
	    });
	
	    _this.on(player, 'playbackrateschange', function (e) {
	      return _this.handlePlaybackRateschange(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlaybackRateMenuButton.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _MenuButton.prototype.createEl.call(this);
	
	    this.labelElId_ = 'vjs-playback-rate-value-label-' + this.id_;
	    this.labelEl_ = createEl('div', {
	      className: 'vjs-playback-rate-value',
	      id: this.labelElId_,
	      textContent: '1x'
	    });
	    el.appendChild(this.labelEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.labelEl_ = null;
	
	    _MenuButton.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var rates = this.playbackRates();
	    var items = [];
	
	    for (var i = rates.length - 1; i >= 0; i--) {
	      items.push(new PlaybackRateMenuItem(this.player(), {
	        rate: rates[i] + 'x'
	      }));
	    }
	
	    return items;
	  }
	  /**
	   * Updates ARIA accessibility attributes
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes() {
	    // Current playback rate
	    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // select next rate option
	    var currentRate = this.player().playbackRate();
	    var rates = this.playbackRates();
	    var currentIndex = rates.indexOf(currentRate); // this get the next rate and it will select first one if the last one currently selected
	
	    var newIndex = (currentIndex + 1) % rates.length;
	    this.player().playbackRate(rates[newIndex]);
	  }
	  /**
	   * On playbackrateschange, update the menu to account for the new items.
	   *
	   * @listens Player#playbackrateschange
	   */
	  ;
	
	  _proto.handlePlaybackRateschange = function handlePlaybackRateschange(event) {
	    this.update();
	  }
	  /**
	   * Get possible playback rates
	   *
	   * @return {Array}
	   *         All possible playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates() {
	    var player = this.player();
	    return player.playbackRates && player.playbackRates() || [];
	  }
	  /**
	   * Get whether playback rates is supported by the tech
	   * and an array of playback rates exists
	   *
	   * @return {boolean}
	   *         Whether changing playback rate is supported
	   */
	  ;
	
	  _proto.playbackRateSupported = function playbackRateSupported() {
	    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
	  }
	  /**
	   * Hide playback rate controls when they're no playback rate options to select
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.updateVisibility = function updateVisibility(event) {
	    if (this.playbackRateSupported()) {
	      this.removeClass('vjs-hidden');
	    } else {
	      this.addClass('vjs-hidden');
	    }
	  }
	  /**
	   * Update button label when rate changed
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.updateLabel = function updateLabel(event) {
	    if (this.playbackRateSupported()) {
	      this.labelEl_.textContent = this.player().playbackRate() + 'x';
	    }
	  };
	
	  return PlaybackRateMenuButton;
	}(MenuButton);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
	Component$1.registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);
	
	/**
	 * Just an empty spacer element that can be used as an append point for plugins, etc.
	 * Also can be used to create space between elements when necessary.
	 *
	 * @extends Component
	 */
	
	var Spacer = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Spacer, _Component);
	
	  function Spacer() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Spacer.prototype;
	
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-spacer " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    if (!props.className) {
	      props.className = this.buildCSSClass();
	    }
	
	    return _Component.prototype.createEl.call(this, tag, props, attributes);
	  };
	
	  return Spacer;
	}(Component$1);
	
	Component$1.registerComponent('Spacer', Spacer);
	
	/**
	 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
	 *
	 * @extends Spacer
	 */
	
	var CustomControlSpacer = /*#__PURE__*/function (_Spacer) {
	  _inheritsLoose__default['default'](CustomControlSpacer, _Spacer);
	
	  function CustomControlSpacer() {
	    return _Spacer.apply(this, arguments) || this;
	  }
	
	  var _proto = CustomControlSpacer.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-custom-control-spacer " + _Spacer.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Spacer.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      // No-flex/table-cell mode requires there be some content
	      // in the cell to fill the remaining space of the table.
	      textContent: "\xA0"
	    });
	  };
	
	  return CustomControlSpacer;
	}(Spacer);
	
	Component$1.registerComponent('CustomControlSpacer', CustomControlSpacer);
	
	/**
	 * Container of main controls.
	 *
	 * @extends Component
	 */
	
	var ControlBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ControlBar, _Component);
	
	  function ControlBar() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ControlBar.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-control-bar',
	      dir: 'ltr'
	    });
	  };
	
	  return ControlBar;
	}(Component$1);
	/**
	 * Default options for `ControlBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ControlBar.prototype.options_ = {
	  children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'seekToLive', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subsCapsButton', 'audioTrackButton', 'fullscreenToggle']
	};
	
	if ('exitPictureInPicture' in document__default['default']) {
	  ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length - 1, 0, 'pictureInPictureToggle');
	}
	
	Component$1.registerComponent('ControlBar', ControlBar);
	
	/**
	 * A display that indicates an error has occurred. This means that the video
	 * is unplayable.
	 *
	 * @extends ModalDialog
	 */
	
	var ErrorDisplay = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](ErrorDisplay, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ErrorDisplay(player, options) {
	    var _this;
	
	    _this = _ModalDialog.call(this, player, options) || this;
	
	    _this.on(player, 'error', function (e) {
	      return _this.open(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  var _proto = ErrorDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-error-display " + _ModalDialog.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Gets the localized error message based on the `Player`s error.
	   *
	   * @return {string}
	   *         The `Player`s error message localized or an empty string.
	   */
	  ;
	
	  _proto.content = function content() {
	    var error = this.player().error();
	    return error ? this.localize(error.message) : '';
	  };
	
	  return ErrorDisplay;
	}(ModalDialog);
	/**
	 * The default options for an `ErrorDisplay`.
	 *
	 * @private
	 */
	
	
	ErrorDisplay.prototype.options_ = _extends__default['default']({}, ModalDialog.prototype.options_, {
	  pauseOnOpen: false,
	  fillAlways: true,
	  temporary: false,
	  uncloseable: true
	});
	Component$1.registerComponent('ErrorDisplay', ErrorDisplay);
	
	var LOCAL_STORAGE_KEY$1 = 'vjs-text-track-settings';
	var COLOR_BLACK = ['#000', 'Black'];
	var COLOR_BLUE = ['#00F', 'Blue'];
	var COLOR_CYAN = ['#0FF', 'Cyan'];
	var COLOR_GREEN = ['#0F0', 'Green'];
	var COLOR_MAGENTA = ['#F0F', 'Magenta'];
	var COLOR_RED = ['#F00', 'Red'];
	var COLOR_WHITE = ['#FFF', 'White'];
	var COLOR_YELLOW = ['#FF0', 'Yellow'];
	var OPACITY_OPAQUE = ['1', 'Opaque'];
	var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
	var OPACITY_TRANS = ['0', 'Transparent']; // Configuration for the various <select> elements in the DOM of this component.
	//
	// Possible keys include:
	//
	// `default`:
	//   The default option index. Only needs to be provided if not zero.
	// `parser`:
	//   A function which is used to parse the value from the selected option in
	//   a customized way.
	// `selector`:
	//   The selector used to find the associated <select> element.
	
	var selectConfigs = {
	  backgroundColor: {
	    selector: '.vjs-bg-color > select',
	    id: 'captions-background-color-%s',
	    label: 'Color',
	    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  backgroundOpacity: {
	    selector: '.vjs-bg-opacity > select',
	    id: 'captions-background-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
	  },
	  color: {
	    selector: '.vjs-fg-color > select',
	    id: 'captions-foreground-color-%s',
	    label: 'Color',
	    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  edgeStyle: {
	    selector: '.vjs-edge-style > select',
	    id: '%s',
	    label: 'Text Edge Style',
	    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
	  },
	  fontFamily: {
	    selector: '.vjs-font-family > select',
	    id: 'captions-font-family-%s',
	    label: 'Font Family',
	    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
	  },
	  fontPercent: {
	    selector: '.vjs-font-percent > select',
	    id: 'captions-font-size-%s',
	    label: 'Font Size',
	    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
	    "default": 2,
	    parser: function parser(v) {
	      return v === '1.00' ? null : Number(v);
	    }
	  },
	  textOpacity: {
	    selector: '.vjs-text-opacity > select',
	    id: 'captions-foreground-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI]
	  },
	  // Options for this object are defined below.
	  windowColor: {
	    selector: '.vjs-window-color > select',
	    id: 'captions-window-color-%s',
	    label: 'Color'
	  },
	  // Options for this object are defined below.
	  windowOpacity: {
	    selector: '.vjs-window-opacity > select',
	    id: 'captions-window-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
	  }
	};
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	/**
	 * Get the actual value of an option.
	 *
	 * @param  {string} value
	 *         The value to get
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	function parseOptionValue(value, parser) {
	  if (parser) {
	    value = parser(value);
	  }
	
	  if (value && value !== 'none') {
	    return value;
	  }
	}
	/**
	 * Gets the value of the selected <option> element within a <select> element.
	 *
	 * @param  {Element} el
	 *         the element to look in
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	
	function getSelectedOptionValue(el, parser) {
	  var value = el.options[el.options.selectedIndex].value;
	  return parseOptionValue(value, parser);
	}
	/**
	 * Sets the selected <option> element within a <select> element based on a
	 * given value.
	 *
	 * @param {Element} el
	 *        The element to look in.
	 *
	 * @param {string} value
	 *        the property to look on.
	 *
	 * @param {Function} [parser]
	 *        Optional function to adjust the value before comparing.
	 *
	 * @private
	 */
	
	
	function setSelectedOption(el, value, parser) {
	  if (!value) {
	    return;
	  }
	
	  for (var i = 0; i < el.options.length; i++) {
	    if (parseOptionValue(el.options[i].value, parser) === value) {
	      el.selectedIndex = i;
	      break;
	    }
	  }
	}
	/**
	 * Manipulate Text Tracks settings.
	 *
	 * @extends ModalDialog
	 */
	
	
	var TextTrackSettings = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](TextTrackSettings, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *         The key/value store of player options.
	   */
	  function TextTrackSettings(player, options) {
	    var _this;
	
	    options.temporary = false;
	    _this = _ModalDialog.call(this, player, options) || this;
	    _this.updateDisplay = _this.updateDisplay.bind(_assertThisInitialized__default['default'](_this)); // fill the modal and pretend we have opened it
	
	    _this.fill();
	
	    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;
	    _this.endDialog = createEl('p', {
	      className: 'vjs-control-text',
	      textContent: _this.localize('End of dialog window.')
	    });
	
	    _this.el().appendChild(_this.endDialog);
	
	    _this.setDefaults(); // Grab `persistTextTrackSettings` from the player options if not passed in child options
	
	
	    if (options.persistTextTrackSettings === undefined) {
	      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
	    }
	
	    _this.on(_this.$('.vjs-done-button'), 'click', function () {
	      _this.saveSettings();
	
	      _this.close();
	    });
	
	    _this.on(_this.$('.vjs-default-button'), 'click', function () {
	      _this.setDefaults();
	
	      _this.updateDisplay();
	    });
	
	    each(selectConfigs, function (config) {
	      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
	    });
	
	    if (_this.options_.persistTextTrackSettings) {
	      _this.restoreSettings();
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrackSettings.prototype;
	
	  _proto.dispose = function dispose() {
	    this.endDialog = null;
	
	    _ModalDialog.prototype.dispose.call(this);
	  }
	  /**
	   * Create a <select> element with configured options.
	   *
	   * @param {string} key
	   *        Configuration key to use during creation.
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElSelect_ = function createElSelect_(key, legendId, type) {
	    var _this2 = this;
	
	    if (legendId === void 0) {
	      legendId = '';
	    }
	
	    if (type === void 0) {
	      type = 'label';
	    }
	
	    var config = selectConfigs[key];
	    var id = config.id.replace('%s', this.id_);
	    var selectLabelledbyIds = [legendId, id].join(' ').trim();
	    return ["<" + type + " id=\"" + id + "\" class=\"" + (type === 'label' ? 'vjs-label' : '') + "\">", this.localize(config.label), "</" + type + ">", "<select aria-labelledby=\"" + selectLabelledbyIds + "\">"].concat(config.options.map(function (o) {
	      var optionId = id + '-' + o[1].replace(/\W+/g, '');
	      return ["<option id=\"" + optionId + "\" value=\"" + o[0] + "\" ", "aria-labelledby=\"" + selectLabelledbyIds + " " + optionId + "\">", _this2.localize(o[1]), '</option>'].join('');
	    })).concat('</select>').join('');
	  }
	  /**
	   * Create foreground color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFgColor_ = function createElFgColor_() {
	    var legendId = "captions-text-legend-" + this.id_;
	    return ['<fieldset class="vjs-fg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Text'), '</legend>', this.createElSelect_('color', legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_('textOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create background color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElBgColor_ = function createElBgColor_() {
	    var legendId = "captions-background-" + this.id_;
	    return ['<fieldset class="vjs-bg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Background'), '</legend>', this.createElSelect_('backgroundColor', legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_('backgroundOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create window color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElWinColor_ = function createElWinColor_() {
	    var legendId = "captions-window-" + this.id_;
	    return ['<fieldset class="vjs-window-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Window'), '</legend>', this.createElSelect_('windowColor', legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_('windowOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create color elements for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElColors_ = function createElColors_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-colors',
	      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join('')
	    });
	  }
	  /**
	   * Create font elements for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFont_ = function createElFont_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-font',
	      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_('fontPercent', '', 'legend'), '</fieldset>', '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_('edgeStyle', '', 'legend'), '</fieldset>', '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_('fontFamily', '', 'legend'), '</fieldset>'].join('')
	    });
	  }
	  /**
	   * Create controls for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElControls_ = function createElControls_() {
	    var defaultsDescription = this.localize('restore all settings to the default values');
	    return createEl('div', {
	      className: 'vjs-track-settings-controls',
	      innerHTML: ["<button type=\"button\" class=\"vjs-default-button\" title=\"" + defaultsDescription + "\">", this.localize('Reset'), "<span class=\"vjs-control-text\"> " + defaultsDescription + "</span>", '</button>', "<button type=\"button\" class=\"vjs-done-button\">" + this.localize('Done') + "</button>"].join('')
	    });
	  };
	
	  _proto.content = function content() {
	    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
	  };
	
	  _proto.label = function label() {
	    return this.localize('Caption Settings Dialog');
	  };
	
	  _proto.description = function description() {
	    return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
	  };
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return _ModalDialog.prototype.buildCSSClass.call(this) + ' vjs-text-track-settings';
	  }
	  /**
	   * Gets an object of text track settings (or null).
	   *
	   * @return {Object}
	   *         An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.getValues = function getValues() {
	    var _this3 = this;
	
	    return reduce(selectConfigs, function (accum, config, key) {
	      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);
	
	      if (value !== undefined) {
	        accum[key] = value;
	      }
	
	      return accum;
	    }, {});
	  }
	  /**
	   * Sets text track settings from an object of values.
	   *
	   * @param {Object} values
	   *        An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.setValues = function setValues(values) {
	    var _this4 = this;
	
	    each(selectConfigs, function (config, key) {
	      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
	    });
	  }
	  /**
	   * Sets all `<select>` elements to their default values.
	   */
	  ;
	
	  _proto.setDefaults = function setDefaults() {
	    var _this5 = this;
	
	    each(selectConfigs, function (config) {
	      var index = config.hasOwnProperty('default') ? config["default"] : 0;
	      _this5.$(config.selector).selectedIndex = index;
	    });
	  }
	  /**
	   * Restore texttrack settings from localStorage
	   */
	  ;
	
	  _proto.restoreSettings = function restoreSettings() {
	    var values;
	
	    try {
	      values = JSON.parse(window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY$1));
	    } catch (err) {
	      log$1.warn(err);
	    }
	
	    if (values) {
	      this.setValues(values);
	    }
	  }
	  /**
	   * Save text track settings to localStorage
	   */
	  ;
	
	  _proto.saveSettings = function saveSettings() {
	    if (!this.options_.persistTextTrackSettings) {
	      return;
	    }
	
	    var values = this.getValues();
	
	    try {
	      if (Object.keys(values).length) {
	        window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY$1, JSON.stringify(values));
	      } else {
	        window__default['default'].localStorage.removeItem(LOCAL_STORAGE_KEY$1);
	      }
	    } catch (err) {
	      log$1.warn(err);
	    }
	  }
	  /**
	   * Update display of text track settings
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var ttDisplay = this.player_.getChild('textTrackDisplay');
	
	    if (ttDisplay) {
	      ttDisplay.updateDisplay();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the captions button
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    this.previouslyActiveEl_ = null;
	    var cb = this.player_.controlBar;
	    var subsCapsBtn = cb && cb.subsCapsButton;
	    var ccBtn = cb && cb.captionsButton;
	
	    if (subsCapsBtn) {
	      subsCapsBtn.focus();
	    } else if (ccBtn) {
	      ccBtn.focus();
	    }
	  };
	
	  return TextTrackSettings;
	}(ModalDialog);
	
	Component$1.registerComponent('TextTrackSettings', TextTrackSettings);
	
	/**
	 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
	 *
	 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
	 *
	 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
	 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
	 * @example <caption>How to disable the resize manager</caption>
	 * const player = videojs('#vid', {
	 *   resizeManager: false
	 * });
	 *
	 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
	 *
	 * @extends Component
	 */
	
	var ResizeManager = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ResizeManager, _Component);
	
	  /**
	   * Create the ResizeManager.
	   *
	   * @param {Object} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of ResizeManager options.
	   *
	   * @param {Object} [options.ResizeObserver]
	   *        A polyfill for ResizeObserver can be passed in here.
	   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
	   */
	  function ResizeManager(player, options) {
	    var _this;
	
	    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window__default['default'].ResizeObserver; // if `null` was passed, we want to disable the ResizeObserver
	
	    if (options.ResizeObserver === null) {
	      RESIZE_OBSERVER_AVAILABLE = false;
	    } // Only create an element when ResizeObserver isn't available
	
	
	    var options_ = mergeOptions$3({
	      createEl: !RESIZE_OBSERVER_AVAILABLE,
	      reportTouchActivity: false
	    }, options);
	    _this = _Component.call(this, player, options_) || this;
	    _this.ResizeObserver = options.ResizeObserver || window__default['default'].ResizeObserver;
	    _this.loadListener_ = null;
	    _this.resizeObserver_ = null;
	    _this.debouncedHandler_ = debounce(function () {
	      _this.resizeHandler();
	    }, 100, false, _assertThisInitialized__default['default'](_this));
	
	    if (RESIZE_OBSERVER_AVAILABLE) {
	      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
	
	      _this.resizeObserver_.observe(player.el());
	    } else {
	      _this.loadListener_ = function () {
	        if (!_this.el_ || !_this.el_.contentWindow) {
	          return;
	        }
	
	        var debouncedHandler_ = _this.debouncedHandler_;
	
	        var unloadListener_ = _this.unloadListener_ = function () {
	          off(this, 'resize', debouncedHandler_);
	          off(this, 'unload', unloadListener_);
	          unloadListener_ = null;
	        }; // safari and edge can unload the iframe before resizemanager dispose
	        // we have to dispose of event handlers correctly before that happens
	
	
	        on(_this.el_.contentWindow, 'unload', unloadListener_);
	        on(_this.el_.contentWindow, 'resize', debouncedHandler_);
	      };
	
	      _this.one('load', _this.loadListener_);
	    }
	
	    return _this;
	  }
	
	  var _proto = ResizeManager.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'iframe', {
	      className: 'vjs-resize-manager',
	      tabIndex: -1,
	      title: this.localize('No content')
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
	   *
	   * @fires Player#playerresize
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler() {
	    /**
	     * Called when the player size has changed
	     *
	     * @event Player#playerresize
	     * @type {EventTarget~Event}
	     */
	    // make sure player is still around to trigger
	    // prevents this from causing an error after dispose
	    if (!this.player_ || !this.player_.trigger) {
	      return;
	    }
	
	    this.player_.trigger('playerresize');
	  };
	
	  _proto.dispose = function dispose() {
	    if (this.debouncedHandler_) {
	      this.debouncedHandler_.cancel();
	    }
	
	    if (this.resizeObserver_) {
	      if (this.player_.el()) {
	        this.resizeObserver_.unobserve(this.player_.el());
	      }
	
	      this.resizeObserver_.disconnect();
	    }
	
	    if (this.loadListener_) {
	      this.off('load', this.loadListener_);
	    }
	
	    if (this.el_ && this.el_.contentWindow && this.unloadListener_) {
	      this.unloadListener_.call(this.el_.contentWindow);
	    }
	
	    this.ResizeObserver = null;
	    this.resizeObserver = null;
	    this.debouncedHandler_ = null;
	    this.loadListener_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return ResizeManager;
	}(Component$1);
	
	Component$1.registerComponent('ResizeManager', ResizeManager);
	
	var defaults = {
	  trackingThreshold: 20,
	  liveTolerance: 15
	};
	/*
	  track when we are at the live edge, and other helpers for live playback */
	
	/**
	 * A class for checking live current time and determining when the player
	 * is at or behind the live edge.
	 */
	
	var LiveTracker = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveTracker, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {number} [options.trackingThreshold=20]
	   *        Number of seconds of live window (seekableEnd - seekableStart) that
	   *        media needs to have before the liveui will be shown.
	   *
	   * @param {number} [options.liveTolerance=15]
	   *        Number of seconds behind live that we have to be
	   *        before we will be considered non-live. Note that this will only
	   *        be used when playing at the live edge. This allows large seekable end
	   *        changes to not effect wether we are live or not.
	   */
	  function LiveTracker(player, options) {
	    var _this;
	
	    // LiveTracker does not need an element
	    var options_ = mergeOptions$3(defaults, options, {
	      createEl: false
	    });
	    _this = _Component.call(this, player, options_) || this;
	
	    _this.handleVisibilityChange_ = function (e) {
	      return _this.handleVisibilityChange(e);
	    };
	
	    _this.trackLiveHandler_ = function () {
	      return _this.trackLive_();
	    };
	
	    _this.handlePlay_ = function (e) {
	      return _this.handlePlay(e);
	    };
	
	    _this.handleFirstTimeupdate_ = function (e) {
	      return _this.handleFirstTimeupdate(e);
	    };
	
	    _this.handleSeeked_ = function (e) {
	      return _this.handleSeeked(e);
	    };
	
	    _this.seekToLiveEdge_ = function (e) {
	      return _this.seekToLiveEdge(e);
	    };
	
	    _this.reset_();
	
	    _this.on(_this.player_, 'durationchange', function (e) {
	      return _this.handleDurationchange(e);
	    }); // we should try to toggle tracking on canplay as native playback engines, like Safari
	    // may not have the proper values for things like seekableEnd until then
	
	
	    _this.on(_this.player_, 'canplay', function () {
	      return _this.toggleTracking();
	    }); // we don't need to track live playback if the document is hidden,
	    // also, tracking when the document is hidden can
	    // cause the CPU to spike and eventually crash the page on IE11.
	
	
	    if (IE_VERSION && 'hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      _this.on(document__default['default'], 'visibilitychange', _this.handleVisibilityChange_);
	    }
	
	    return _this;
	  }
	  /**
	   * toggle tracking based on document visiblility
	   */
	
	
	  var _proto = LiveTracker.prototype;
	
	  _proto.handleVisibilityChange = function handleVisibilityChange() {
	    if (this.player_.duration() !== Infinity) {
	      return;
	    }
	
	    if (document__default['default'].hidden) {
	      this.stopTracking();
	    } else {
	      this.startTracking();
	    }
	  }
	  /**
	   * all the functionality for tracking when seek end changes
	   * and for tracking how far past seek end we should be
	   */
	  ;
	
	  _proto.trackLive_ = function trackLive_() {
	    var seekable = this.player_.seekable(); // skip undefined seekable
	
	    if (!seekable || !seekable.length) {
	      return;
	    }
	
	    var newTime = Number(window__default['default'].performance.now().toFixed(4));
	    var deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
	    this.lastTime_ = newTime;
	    this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
	    var liveCurrentTime = this.liveCurrentTime();
	    var currentTime = this.player_.currentTime(); // we are behind live if any are true
	    // 1. the player is paused
	    // 2. the user seeked to a location 2 seconds away from live
	    // 3. the difference between live and current time is greater
	    //    liveTolerance which defaults to 15s
	
	    var isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance; // we cannot be behind if
	    // 1. until we have not seen a timeupdate yet
	    // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
	
	    if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) {
	      isBehind = false;
	    }
	
	    if (isBehind !== this.behindLiveEdge_) {
	      this.behindLiveEdge_ = isBehind;
	      this.trigger('liveedgechange');
	    }
	  }
	  /**
	   * handle a durationchange event on the player
	   * and start/stop tracking accordingly.
	   */
	  ;
	
	  _proto.handleDurationchange = function handleDurationchange() {
	    this.toggleTracking();
	  }
	  /**
	   * start/stop tracking
	   */
	  ;
	
	  _proto.toggleTracking = function toggleTracking() {
	    if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
	      if (this.player_.options_.liveui) {
	        this.player_.addClass('vjs-liveui');
	      }
	
	      this.startTracking();
	    } else {
	      this.player_.removeClass('vjs-liveui');
	      this.stopTracking();
	    }
	  }
	  /**
	   * start tracking live playback
	   */
	  ;
	
	  _proto.startTracking = function startTracking() {
	    if (this.isTracking()) {
	      return;
	    } // If we haven't seen a timeupdate, we need to check whether playback
	    // began before this component started tracking. This can happen commonly
	    // when using autoplay.
	
	
	    if (!this.timeupdateSeen_) {
	      this.timeupdateSeen_ = this.player_.hasStarted();
	    }
	
	    this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, UPDATE_REFRESH_INTERVAL);
	    this.trackLive_();
	    this.on(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	
	    if (!this.timeupdateSeen_) {
	      this.one(this.player_, 'play', this.handlePlay_);
	      this.one(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    } else {
	      this.on(this.player_, 'seeked', this.handleSeeked_);
	    }
	  }
	  /**
	   * handle the first timeupdate on the player if it wasn't already playing
	   * when live tracker started tracking.
	   */
	  ;
	
	  _proto.handleFirstTimeupdate = function handleFirstTimeupdate() {
	    this.timeupdateSeen_ = true;
	    this.on(this.player_, 'seeked', this.handleSeeked_);
	  }
	  /**
	   * Keep track of what time a seek starts, and listen for seeked
	   * to find where a seek ends.
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked() {
	    var timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
	    this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
	    this.nextSeekedFromUser_ = false;
	    this.trackLive_();
	  }
	  /**
	   * handle the first play on the player, and make sure that we seek
	   * right to the live edge.
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay() {
	    this.one(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * Stop tracking, and set all internal variables to
	   * their initial value.
	   */
	  ;
	
	  _proto.reset_ = function reset_() {
	    this.lastTime_ = -1;
	    this.pastSeekEnd_ = 0;
	    this.lastSeekEnd_ = -1;
	    this.behindLiveEdge_ = true;
	    this.timeupdateSeen_ = false;
	    this.seekedBehindLive_ = false;
	    this.nextSeekedFromUser_ = false;
	    this.clearInterval(this.trackingInterval_);
	    this.trackingInterval_ = null;
	    this.off(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	    this.off(this.player_, 'seeked', this.handleSeeked_);
	    this.off(this.player_, 'play', this.handlePlay_);
	    this.off(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    this.off(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * The next seeked event is from the user. Meaning that any seek
	   * > 2s behind live will be considered behind live for real and
	   * liveTolerance will be ignored.
	   */
	  ;
	
	  _proto.nextSeekedFromUser = function nextSeekedFromUser() {
	    this.nextSeekedFromUser_ = true;
	  }
	  /**
	   * stop tracking live playback
	   */
	  ;
	
	  _proto.stopTracking = function stopTracking() {
	    if (!this.isTracking()) {
	      return;
	    }
	
	    this.reset_();
	    this.trigger('liveedgechange');
	  }
	  /**
	   * A helper to get the player seekable end
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The furthest seekable end or Infinity.
	   */
	  ;
	
	  _proto.seekableEnd = function seekableEnd() {
	    var seekable = this.player_.seekable();
	    var seekableEnds = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableEnds.push(seekable.end(i));
	    } // grab the furthest seekable end after sorting, or if there are none
	    // default to Infinity
	
	
	    return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
	  }
	  /**
	   * A helper to get the player seekable start
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The earliest seekable start or 0.
	   */
	  ;
	
	  _proto.seekableStart = function seekableStart() {
	    var seekable = this.player_.seekable();
	    var seekableStarts = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableStarts.push(seekable.start(i));
	    } // grab the first seekable start after sorting, or if there are none
	    // default to 0
	
	
	    return seekableStarts.length ? seekableStarts.sort()[0] : 0;
	  }
	  /**
	   * Get the live time window aka
	   * the amount of time between seekable start and
	   * live current time.
	   *
	   * @return {number}
	   *         The amount of seconds that are seekable in
	   *         the live video.
	   */
	  ;
	
	  _proto.liveWindow = function liveWindow() {
	    var liveCurrentTime = this.liveCurrentTime(); // if liveCurrenTime is Infinity then we don't have a liveWindow at all
	
	    if (liveCurrentTime === Infinity) {
	      return 0;
	    }
	
	    return liveCurrentTime - this.seekableStart();
	  }
	  /**
	   * Determines if the player is live, only checks if this component
	   * is tracking live playback or not
	   *
	   * @return {boolean}
	   *         Wether liveTracker is tracking
	   */
	  ;
	
	  _proto.isLive = function isLive() {
	    return this.isTracking();
	  }
	  /**
	   * Determines if currentTime is at the live edge and won't fall behind
	   * on each seekableendchange
	   *
	   * @return {boolean}
	   *         Wether playback is at the live edge
	   */
	  ;
	
	  _proto.atLiveEdge = function atLiveEdge() {
	    return !this.behindLiveEdge();
	  }
	  /**
	   * get what we expect the live current time to be
	   *
	   * @return {number}
	   *         The expected live current time
	   */
	  ;
	
	  _proto.liveCurrentTime = function liveCurrentTime() {
	    return this.pastSeekEnd() + this.seekableEnd();
	  }
	  /**
	   * The number of seconds that have occured after seekable end
	   * changed. This will be reset to 0 once seekable end changes.
	   *
	   * @return {number}
	   *         Seconds past the current seekable end
	   */
	  ;
	
	  _proto.pastSeekEnd = function pastSeekEnd() {
	    var seekableEnd = this.seekableEnd();
	
	    if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) {
	      this.pastSeekEnd_ = 0;
	    }
	
	    this.lastSeekEnd_ = seekableEnd;
	    return this.pastSeekEnd_;
	  }
	  /**
	   * If we are currently behind the live edge, aka currentTime will be
	   * behind on a seekableendchange
	   *
	   * @return {boolean}
	   *         If we are behind the live edge
	   */
	  ;
	
	  _proto.behindLiveEdge = function behindLiveEdge() {
	    return this.behindLiveEdge_;
	  }
	  /**
	   * Wether live tracker is currently tracking or not.
	   */
	  ;
	
	  _proto.isTracking = function isTracking() {
	    return typeof this.trackingInterval_ === 'number';
	  }
	  /**
	   * Seek to the live edge if we are behind the live edge
	   */
	  ;
	
	  _proto.seekToLiveEdge = function seekToLiveEdge() {
	    this.seekedBehindLive_ = false;
	
	    if (this.atLiveEdge()) {
	      return;
	    }
	
	    this.nextSeekedFromUser_ = false;
	    this.player_.currentTime(this.liveCurrentTime());
	  }
	  /**
	   * Dispose of liveTracker
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.off(document__default['default'], 'visibilitychange', this.handleVisibilityChange_);
	    this.stopTracking();
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return LiveTracker;
	}(Component$1);
	
	Component$1.registerComponent('LiveTracker', LiveTracker);
	
	/**
	 * This function is used to fire a sourceset when there is something
	 * similar to `mediaEl.load()` being called. It will try to find the source via
	 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
	 * with the source that was found or empty string if we cannot know. If it cannot
	 * find a source then `sourceset` will not be fired.
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset was setup on
	 *
	 * @return {boolean}
	 *         returns false if the sourceset was not fired and true otherwise.
	 */
	
	var sourcesetLoad = function sourcesetLoad(tech) {
	  var el = tech.el(); // if `el.src` is set, that source will be loaded.
	
	  if (el.hasAttribute('src')) {
	    tech.triggerSourceset(el.src);
	    return true;
	  }
	  /**
	   * Since there isn't a src property on the media element, source elements will be used for
	   * implementing the source selection algorithm. This happens asynchronously and
	   * for most cases were there is more than one source we cannot tell what source will
	   * be loaded, without re-implementing the source selection algorithm. At this time we are not
	   * going to do that. There are three special cases that we do handle here though:
	   *
	   * 1. If there are no sources, do not fire `sourceset`.
	   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
	   * 3. If there is more than one `<source>` but all of them have the same `src` url.
	   *    That will be our src.
	   */
	
	
	  var sources = tech.$$('source');
	  var srcUrls = [];
	  var src = ''; // if there are no sources, do not fire sourceset
	
	  if (!sources.length) {
	    return false;
	  } // only count valid/non-duplicate source elements
	
	
	  for (var i = 0; i < sources.length; i++) {
	    var url = sources[i].src;
	
	    if (url && srcUrls.indexOf(url) === -1) {
	      srcUrls.push(url);
	    }
	  } // there were no valid sources
	
	
	  if (!srcUrls.length) {
	    return false;
	  } // there is only one valid source element url
	  // use that
	
	
	  if (srcUrls.length === 1) {
	    src = srcUrls[0];
	  }
	
	  tech.triggerSourceset(src);
	  return true;
	};
	/**
	 * our implementation of an `innerHTML` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
	  get: function get() {
	    return this.cloneNode(true).innerHTML;
	  },
	  set: function set(v) {
	    // make a dummy node to use innerHTML on
	    var dummy = document__default['default'].createElement(this.nodeName.toLowerCase()); // set innerHTML to the value provided
	
	    dummy.innerHTML = v; // make a document fragment to hold the nodes from dummy
	
	    var docFrag = document__default['default'].createDocumentFragment(); // copy all of the nodes created by the innerHTML on dummy
	    // to the document fragment
	
	    while (dummy.childNodes.length) {
	      docFrag.appendChild(dummy.childNodes[0]);
	    } // remove content
	
	
	    this.innerText = ''; // now we add all of that html in one by appending the
	    // document fragment. This is how innerHTML does it.
	
	    window__default['default'].Element.prototype.appendChild.call(this, docFrag); // then return the result that innerHTML's setter would
	
	    return this.innerHTML;
	  }
	});
	/**
	 * Get a property descriptor given a list of priorities and the
	 * property to get.
	 */
	
	var getDescriptor = function getDescriptor(priority, prop) {
	  var descriptor = {};
	
	  for (var i = 0; i < priority.length; i++) {
	    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
	
	    if (descriptor && descriptor.set && descriptor.get) {
	      break;
	    }
	  }
	
	  descriptor.enumerable = true;
	  descriptor.configurable = true;
	  return descriptor;
	};
	
	var getInnerHTMLDescriptor = function getInnerHTMLDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, window__default['default'].Element.prototype, innerHTMLDescriptorPolyfill], 'innerHTML');
	};
	/**
	 * Patches browser internal functions so that we can tell synchronously
	 * if a `<source>` was appended to the media element. For some reason this
	 * causes a `sourceset` if the the media element is ready and has no source.
	 * This happens when:
	 * - The page has just loaded and the media element does not have a source.
	 * - The media element was emptied of all sources, then `load()` was called.
	 *
	 * It does this by patching the following functions/properties when they are supported:
	 *
	 * - `append()` - can be used to add a `<source>` element to the media element
	 * - `appendChild()` - can be used to add a `<source>` element to the media element
	 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
	 * - `innerHTML` -  can be used to add a `<source>` element to the media element
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset is being setup on.
	 */
	
	
	var firstSourceWatch = function firstSourceWatch(tech) {
	  var el = tech.el(); // make sure firstSourceWatch isn't setup twice.
	
	  if (el.resetSourceWatch_) {
	    return;
	  }
	
	  var old = {};
	  var innerDescriptor = getInnerHTMLDescriptor(tech);
	
	  var appendWrapper = function appendWrapper(appendFn) {
	    return function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var retval = appendFn.apply(el, args);
	      sourcesetLoad(tech);
	      return retval;
	    };
	  };
	
	  ['append', 'appendChild', 'insertAdjacentHTML'].forEach(function (k) {
	    if (!el[k]) {
	      return;
	    } // store the old function
	
	
	    old[k] = el[k]; // call the old function with a sourceset if a source
	    // was loaded
	
	    el[k] = appendWrapper(old[k]);
	  });
	  Object.defineProperty(el, 'innerHTML', mergeOptions$3(innerDescriptor, {
	    set: appendWrapper(innerDescriptor.set)
	  }));
	
	  el.resetSourceWatch_ = function () {
	    el.resetSourceWatch_ = null;
	    Object.keys(old).forEach(function (k) {
	      el[k] = old[k];
	    });
	    Object.defineProperty(el, 'innerHTML', innerDescriptor);
	  }; // on the first sourceset, we need to revert our changes
	
	
	  tech.one('sourceset', el.resetSourceWatch_);
	};
	/**
	 * our implementation of a `src` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
	  get: function get() {
	    if (this.hasAttribute('src')) {
	      return getAbsoluteURL(window__default['default'].Element.prototype.getAttribute.call(this, 'src'));
	    }
	
	    return '';
	  },
	  set: function set(v) {
	    window__default['default'].Element.prototype.setAttribute.call(this, 'src', v);
	    return v;
	  }
	});
	
	var getSrcDescriptor = function getSrcDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, srcDescriptorPolyfill], 'src');
	};
	/**
	 * setup `sourceset` handling on the `Html5` tech. This function
	 * patches the following element properties/functions:
	 *
	 * - `src` - to determine when `src` is set
	 * - `setAttribute()` - to determine when `src` is set
	 * - `load()` - this re-triggers the source selection algorithm, and can
	 *              cause a sourceset.
	 *
	 * If there is no source when we are adding `sourceset` support or during a `load()`
	 * we also patch the functions listed in `firstSourceWatch`.
	 *
	 * @param {Html5} tech
	 *        The tech to patch
	 */
	
	
	var setupSourceset = function setupSourceset(tech) {
	  if (!tech.featuresSourceset) {
	    return;
	  }
	
	  var el = tech.el(); // make sure sourceset isn't setup twice.
	
	  if (el.resetSourceset_) {
	    return;
	  }
	
	  var srcDescriptor = getSrcDescriptor(tech);
	  var oldSetAttribute = el.setAttribute;
	  var oldLoad = el.load;
	  Object.defineProperty(el, 'src', mergeOptions$3(srcDescriptor, {
	    set: function set(v) {
	      var retval = srcDescriptor.set.call(el, v); // we use the getter here to get the actual value set on src
	
	      tech.triggerSourceset(el.src);
	      return retval;
	    }
	  }));
	
	  el.setAttribute = function (n, v) {
	    var retval = oldSetAttribute.call(el, n, v);
	
	    if (/src/i.test(n)) {
	      tech.triggerSourceset(el.src);
	    }
	
	    return retval;
	  };
	
	  el.load = function () {
	    var retval = oldLoad.call(el); // if load was called, but there was no source to fire
	    // sourceset on. We have to watch for a source append
	    // as that can trigger a `sourceset` when the media element
	    // has no source
	
	    if (!sourcesetLoad(tech)) {
	      tech.triggerSourceset('');
	      firstSourceWatch(tech);
	    }
	
	    return retval;
	  };
	
	  if (el.currentSrc) {
	    tech.triggerSourceset(el.currentSrc);
	  } else if (!sourcesetLoad(tech)) {
	    firstSourceWatch(tech);
	  }
	
	  el.resetSourceset_ = function () {
	    el.resetSourceset_ = null;
	    el.load = oldLoad;
	    el.setAttribute = oldSetAttribute;
	    Object.defineProperty(el, 'src', srcDescriptor);
	
	    if (el.resetSourceWatch_) {
	      el.resetSourceWatch_();
	    }
	  };
	};
	
	/**
	 * Object.defineProperty but "lazy", which means that the value is only set after
	 * it retrieved the first time, rather than being set right away.
	 *
	 * @param {Object} obj the object to set the property on
	 * @param {string} key the key for the property to set
	 * @param {Function} getValue the function used to get the value when it is needed.
	 * @param {boolean} setter wether a setter shoould be allowed or not
	 */
	var defineLazyProperty = function defineLazyProperty(obj, key, getValue, setter) {
	  if (setter === void 0) {
	    setter = true;
	  }
	
	  var set = function set(value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      writable: true
	    });
	  };
	
	  var options = {
	    configurable: true,
	    enumerable: true,
	    get: function get() {
	      var value = getValue();
	      set(value);
	      return value;
	    }
	  };
	
	  if (setter) {
	    options.set = set;
	  }
	
	  return Object.defineProperty(obj, key, options);
	};
	
	/**
	 * HTML5 Media Controller - Wrapper for HTML5 Media API
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 * @extends Tech
	 */
	
	var Html5 = /*#__PURE__*/function (_Tech) {
	  _inheritsLoose__default['default'](Html5, _Tech);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Html5(options, ready) {
	    var _this;
	
	    _this = _Tech.call(this, options, ready) || this;
	    var source = options.source;
	    var crossoriginTracks = false;
	    _this.featuresVideoFrameCallback = _this.featuresVideoFrameCallback && _this.el_.tagName === 'VIDEO'; // Set the source if one is provided
	    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
	    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
	    // anyway so the error gets fired.
	
	    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
	      _this.setSource(source);
	    } else {
	      _this.handleLateInit_(_this.el_);
	    } // setup sourceset after late sourceset/init
	
	
	    if (options.enableSourceset) {
	      _this.setupSourcesetHandling_();
	    }
	
	    _this.isScrubbing_ = false;
	
	    if (_this.el_.hasChildNodes()) {
	      var nodes = _this.el_.childNodes;
	      var nodesLength = nodes.length;
	      var removeNodes = [];
	
	      while (nodesLength--) {
	        var node = nodes[nodesLength];
	        var nodeName = node.nodeName.toLowerCase();
	
	        if (nodeName === 'track') {
	          if (!_this.featuresNativeTextTracks) {
	            // Empty video tag tracks so the built-in player doesn't use them also.
	            // This may not be fast enough to stop HTML5 browsers from reading the tags
	            // so we'll need to turn off any default tracks if we're manually doing
	            // captions and subtitles. videoElement.textTracks
	            removeNodes.push(node);
	          } else {
	            // store HTMLTrackElement and TextTrack to remote list
	            _this.remoteTextTrackEls().addTrackElement_(node);
	
	            _this.remoteTextTracks().addTrack(node.track);
	
	            _this.textTracks().addTrack(node.track);
	
	            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && isCrossOrigin(node.src)) {
	              crossoriginTracks = true;
	            }
	          }
	        }
	      }
	
	      for (var i = 0; i < removeNodes.length; i++) {
	        _this.el_.removeChild(removeNodes[i]);
	      }
	    }
	
	    _this.proxyNativeTracks_();
	
	    if (_this.featuresNativeTextTracks && crossoriginTracks) {
	      log$1.warn('Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n' + 'This may prevent text tracks from loading.');
	    } // prevent iOS Safari from disabling metadata text tracks during native playback
	
	
	    _this.restoreMetadataTracksInIOSNativePlayer_(); // Determine if native controls should be used
	    // Our goal should be to get the custom controls on mobile solid everywhere
	    // so we can remove this all together. Right now this will block custom
	    // controls on touch enabled laptops like the Chrome Pixel
	
	
	    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
	      _this.setControls(true);
	    } // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
	    // into a `fullscreenchange` event
	
	
	    _this.proxyWebkitFullscreen_();
	
	    _this.triggerReady();
	
	    return _this;
	  }
	  /**
	   * Dispose of `HTML5` media element and remove all tracks.
	   */
	
	
	  var _proto = Html5.prototype;
	
	  _proto.dispose = function dispose() {
	    if (this.el_ && this.el_.resetSourceset_) {
	      this.el_.resetSourceset_();
	    }
	
	    Html5.disposeMediaElement(this.el_);
	    this.options_ = null; // tech will handle clearing of the emulated track list
	
	    _Tech.prototype.dispose.call(this);
	  }
	  /**
	   * Modify the media element so that we can detect when
	   * the source is changed. Fires `sourceset` just after the source has changed
	   */
	  ;
	
	  _proto.setupSourcesetHandling_ = function setupSourcesetHandling_() {
	    setupSourceset(this);
	  }
	  /**
	   * When a captions track is enabled in the iOS Safari native player, all other
	   * tracks are disabled (including metadata tracks), which nulls all of their
	   * associated cue points. This will restore metadata tracks to their pre-fullscreen
	   * state in those cases so that cue points are not needlessly lost.
	   *
	   * @private
	   */
	  ;
	
	  _proto.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
	    var textTracks = this.textTracks();
	    var metadataTracksPreFullscreenState; // captures a snapshot of every metadata track's current state
	
	    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
	      metadataTracksPreFullscreenState = [];
	
	      for (var i = 0; i < textTracks.length; i++) {
	        var track = textTracks[i];
	
	        if (track.kind === 'metadata') {
	          metadataTracksPreFullscreenState.push({
	            track: track,
	            storedMode: track.mode
	          });
	        }
	      }
	    }; // snapshot each metadata track's initial state, and update the snapshot
	    // each time there is a track 'change' event
	
	
	    takeMetadataTrackSnapshot();
	    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	    this.on('dispose', function () {
	      return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	    });
	
	    var restoreTrackMode = function restoreTrackMode() {
	      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
	        var storedTrack = metadataTracksPreFullscreenState[i];
	
	        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
	          storedTrack.track.mode = storedTrack.storedMode;
	        }
	      } // we only want this handler to be executed on the first 'change' event
	
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    }; // when we enter fullscreen playback, stop updating the snapshot and
	    // restore all track modes to their pre-fullscreen state
	
	
	    this.on('webkitbeginfullscreen', function () {
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot); // remove the listener before adding it just in case it wasn't previously removed
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	      textTracks.addEventListener('change', restoreTrackMode);
	    }); // start updating the snapshot again after leaving fullscreen
	
	    this.on('webkitendfullscreen', function () {
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	      textTracks.addEventListener('change', takeMetadataTrackSnapshot); // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    });
	  }
	  /**
	   * Attempt to force override of tracks for the given type
	   *
	   * @param {string} type - Track type to override, possible values include 'Audio',
	   * 'Video', and 'Text'.
	   * @param {boolean} override - If set to true native audio/video will be overridden,
	   * otherwise native audio/video will potentially be used.
	   * @private
	   */
	  ;
	
	  _proto.overrideNative_ = function overrideNative_(type, override) {
	    var _this2 = this;
	
	    // If there is no behavioral change don't add/remove listeners
	    if (override !== this["featuresNative" + type + "Tracks"]) {
	      return;
	    }
	
	    var lowerCaseType = type.toLowerCase();
	
	    if (this[lowerCaseType + "TracksListeners_"]) {
	      Object.keys(this[lowerCaseType + "TracksListeners_"]).forEach(function (eventName) {
	        var elTracks = _this2.el()[lowerCaseType + "Tracks"];
	
	        elTracks.removeEventListener(eventName, _this2[lowerCaseType + "TracksListeners_"][eventName]);
	      });
	    }
	
	    this["featuresNative" + type + "Tracks"] = !override;
	    this[lowerCaseType + "TracksListeners_"] = null;
	    this.proxyNativeTracksForType_(lowerCaseType);
	  }
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks(override) {
	    this.overrideNative_('Audio', override);
	  }
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks(override) {
	    this.overrideNative_('Video', override);
	  }
	  /**
	   * Proxy native track list events for the given type to our track
	   * lists if the browser we are playing in supports that type of track list.
	   *
	   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracksForType_ = function proxyNativeTracksForType_(name) {
	    var _this3 = this;
	
	    var props = NORMAL[name];
	    var elTracks = this.el()[props.getterName];
	    var techTracks = this[props.getterName]();
	
	    if (!this["featuresNative" + props.capitalName + "Tracks"] || !elTracks || !elTracks.addEventListener) {
	      return;
	    }
	
	    var listeners = {
	      change: function change(e) {
	        var event = {
	          type: 'change',
	          target: techTracks,
	          currentTarget: techTracks,
	          srcElement: techTracks
	        };
	        techTracks.trigger(event); // if we are a text track change event, we should also notify the
	        // remote text track list. This can potentially cause a false positive
	        // if we were to get a change event on a non-remote track and
	        // we triggered the event on the remote text track list which doesn't
	        // contain that track. However, best practices mean looping through the
	        // list of tracks and searching for the appropriate mode value, so,
	        // this shouldn't pose an issue
	
	        if (name === 'text') {
	          _this3[REMOTE.remoteText.getterName]().trigger(event);
	        }
	      },
	      addtrack: function addtrack(e) {
	        techTracks.addTrack(e.track);
	      },
	      removetrack: function removetrack(e) {
	        techTracks.removeTrack(e.track);
	      }
	    };
	
	    var removeOldTracks = function removeOldTracks() {
	      var removeTracks = [];
	
	      for (var i = 0; i < techTracks.length; i++) {
	        var found = false;
	
	        for (var j = 0; j < elTracks.length; j++) {
	          if (elTracks[j] === techTracks[i]) {
	            found = true;
	            break;
	          }
	        }
	
	        if (!found) {
	          removeTracks.push(techTracks[i]);
	        }
	      }
	
	      while (removeTracks.length) {
	        techTracks.removeTrack(removeTracks.shift());
	      }
	    };
	
	    this[props.getterName + 'Listeners_'] = listeners;
	    Object.keys(listeners).forEach(function (eventName) {
	      var listener = listeners[eventName];
	      elTracks.addEventListener(eventName, listener);
	
	      _this3.on('dispose', function (e) {
	        return elTracks.removeEventListener(eventName, listener);
	      });
	    }); // Remove (native) tracks that are not used anymore
	
	    this.on('loadstart', removeOldTracks);
	    this.on('dispose', function (e) {
	      return _this3.off('loadstart', removeOldTracks);
	    });
	  }
	  /**
	   * Proxy all native track list events to our track lists if the browser we are playing
	   * in supports that type of track list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracks_ = function proxyNativeTracks_() {
	    var _this4 = this;
	
	    NORMAL.names.forEach(function (name) {
	      _this4.proxyNativeTracksForType_(name);
	    });
	  }
	  /**
	   * Create the `Html5` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var el = this.options_.tag; // Check if this browser supports moving the element into the box.
	    // On the iPhone video will break if you move the element,
	    // So we have to create a brand new element.
	    // If we ingested the player div, we do not need to move the media element.
	
	    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
	      // If the original tag is still there, clone and remove it.
	      if (el) {
	        var clone = el.cloneNode(true);
	
	        if (el.parentNode) {
	          el.parentNode.insertBefore(clone, el);
	        }
	
	        Html5.disposeMediaElement(el);
	        el = clone;
	      } else {
	        el = document__default['default'].createElement('video'); // determine if native controls should be used
	
	        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
	        var attributes = mergeOptions$3({}, tagAttributes);
	
	        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
	          delete attributes.controls;
	        }
	
	        setAttributes(el, assign(attributes, {
	          id: this.options_.techId,
	          "class": 'vjs-tech'
	        }));
	      }
	
	      el.playerId = this.options_.playerId;
	    }
	
	    if (typeof this.options_.preload !== 'undefined') {
	      setAttribute(el, 'preload', this.options_.preload);
	    }
	
	    if (this.options_.disablePictureInPicture !== undefined) {
	      el.disablePictureInPicture = this.options_.disablePictureInPicture;
	    } // Update specific tag settings, in case they were overridden
	    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
	    // when iOS/Safari or other browsers attempt to autoplay.
	
	
	    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];
	
	    for (var i = 0; i < settingsAttrs.length; i++) {
	      var attr = settingsAttrs[i];
	      var value = this.options_[attr];
	
	      if (typeof value !== 'undefined') {
	        if (value) {
	          setAttribute(el, attr, attr);
	        } else {
	          removeAttribute(el, attr);
	        }
	
	        el[attr] = value;
	      }
	    }
	
	    return el;
	  }
	  /**
	   * This will be triggered if the loadstart event has already fired, before videojs was
	   * ready. Two known examples of when this can happen are:
	   * 1. If we're loading the playback object after it has started loading
	   * 2. The media is already playing the (often with autoplay on) then
	   *
	   * This function will fire another loadstart so that videojs can catchup.
	   *
	   * @fires Tech#loadstart
	   *
	   * @return {undefined}
	   *         returns nothing.
	   */
	  ;
	
	  _proto.handleLateInit_ = function handleLateInit_(el) {
	    if (el.networkState === 0 || el.networkState === 3) {
	      // The video element hasn't started loading the source yet
	      // or didn't find a source
	      return;
	    }
	
	    if (el.readyState === 0) {
	      // NetworkState is set synchronously BUT loadstart is fired at the
	      // end of the current stack, usually before setInterval(fn, 0).
	      // So at this point we know loadstart may have already fired or is
	      // about to fire, and either way the player hasn't seen it yet.
	      // We don't want to fire loadstart prematurely here and cause a
	      // double loadstart so we'll wait and see if it happens between now
	      // and the next loop, and fire it if not.
	      // HOWEVER, we also want to make sure it fires before loadedmetadata
	      // which could also happen between now and the next loop, so we'll
	      // watch for that also.
	      var loadstartFired = false;
	
	      var setLoadstartFired = function setLoadstartFired() {
	        loadstartFired = true;
	      };
	
	      this.on('loadstart', setLoadstartFired);
	
	      var triggerLoadstart = function triggerLoadstart() {
	        // We did miss the original loadstart. Make sure the player
	        // sees loadstart before loadedmetadata
	        if (!loadstartFired) {
	          this.trigger('loadstart');
	        }
	      };
	
	      this.on('loadedmetadata', triggerLoadstart);
	      this.ready(function () {
	        this.off('loadstart', setLoadstartFired);
	        this.off('loadedmetadata', triggerLoadstart);
	
	        if (!loadstartFired) {
	          // We did miss the original native loadstart. Fire it now.
	          this.trigger('loadstart');
	        }
	      });
	      return;
	    } // From here on we know that loadstart already fired and we missed it.
	    // The other readyState events aren't as much of a problem if we double
	    // them, so not going to go to as much trouble as loadstart to prevent
	    // that unless we find reason to.
	
	
	    var eventsToTrigger = ['loadstart']; // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
	
	    eventsToTrigger.push('loadedmetadata'); // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
	
	    if (el.readyState >= 2) {
	      eventsToTrigger.push('loadeddata');
	    } // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
	
	
	    if (el.readyState >= 3) {
	      eventsToTrigger.push('canplay');
	    } // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
	
	
	    if (el.readyState >= 4) {
	      eventsToTrigger.push('canplaythrough');
	    } // We still need to give the player time to add event listeners
	
	
	    this.ready(function () {
	      eventsToTrigger.forEach(function (type) {
	        this.trigger(type);
	      }, this);
	    });
	  }
	  /**
	   * Set whether we are scrubbing or not.
	   * This is used to decide whether we should use `fastSeek` or not.
	   * `fastSeek` is used to provide trick play on Safari browsers.
	   *
	   * @param {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing(isScrubbing) {
	    this.isScrubbing_ = isScrubbing;
	  }
	  /**
	   * Get whether we are scrubbing or not.
	   *
	   * @return {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {
	    return this.isScrubbing_;
	  }
	  /**
	   * Set current time for the `HTML5` tech.
	   *
	   * @param {number} seconds
	   *        Set the current time of the media to this.
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(seconds) {
	    try {
	      if (this.isScrubbing_ && this.el_.fastSeek && IS_ANY_SAFARI) {
	        this.el_.fastSeek(seconds);
	      } else {
	        this.el_.currentTime = seconds;
	      }
	    } catch (e) {
	      log$1(e, 'Video is not ready. (Video.js)'); // this.warning(VideoJS.warnings.videoNotReady);
	    }
	  }
	  /**
	   * Get the current duration of the HTML5 media element.
	   *
	   * @return {number}
	   *         The duration of the media or 0 if there is no duration.
	   */
	  ;
	
	  _proto.duration = function duration() {
	    var _this5 = this;
	
	    // Android Chrome will report duration as Infinity for VOD HLS until after
	    // playback has started, which triggers the live display erroneously.
	    // Return NaN if playback has not started and trigger a durationupdate once
	    // the duration can be reliably known.
	    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
	      // Wait for the first `timeupdate` with currentTime > 0 - there may be
	      // several with 0
	      var checkProgress = function checkProgress() {
	        if (_this5.el_.currentTime > 0) {
	          // Trigger durationchange for genuinely live video
	          if (_this5.el_.duration === Infinity) {
	            _this5.trigger('durationchange');
	          }
	
	          _this5.off('timeupdate', checkProgress);
	        }
	      };
	
	      this.on('timeupdate', checkProgress);
	      return NaN;
	    }
	
	    return this.el_.duration || NaN;
	  }
	  /**
	   * Get the current width of the HTML5 media element.
	   *
	   * @return {number}
	   *         The width of the HTML5 media element.
	   */
	  ;
	
	  _proto.width = function width() {
	    return this.el_.offsetWidth;
	  }
	  /**
	   * Get the current height of the HTML5 media element.
	   *
	   * @return {number}
	   *         The height of the HTML5 media element.
	   */
	  ;
	
	  _proto.height = function height() {
	    return this.el_.offsetHeight;
	  }
	  /**
	   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
	   * `fullscreenchange` event.
	   *
	   * @private
	   * @fires fullscreenchange
	   * @listens webkitendfullscreen
	   * @listens webkitbeginfullscreen
	   * @listens webkitbeginfullscreen
	   */
	  ;
	
	  _proto.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
	    var _this6 = this;
	
	    if (!('webkitDisplayingFullscreen' in this.el_)) {
	      return;
	    }
	
	    var endFn = function endFn() {
	      this.trigger('fullscreenchange', {
	        isFullscreen: false
	      }); // Safari will sometimes set contols on the videoelement when existing fullscreen.
	
	      if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) {
	        this.el_.controls = false;
	      }
	    };
	
	    var beginFn = function beginFn() {
	      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
	        this.one('webkitendfullscreen', endFn);
	        this.trigger('fullscreenchange', {
	          isFullscreen: true,
	          // set a flag in case another tech triggers fullscreenchange
	          nativeIOSFullscreen: true
	        });
	      }
	    };
	
	    this.on('webkitbeginfullscreen', beginFn);
	    this.on('dispose', function () {
	      _this6.off('webkitbeginfullscreen', beginFn);
	
	      _this6.off('webkitendfullscreen', endFn);
	    });
	  }
	  /**
	   * Check if fullscreen is supported on the current playback device.
	   *
	   * @return {boolean}
	   *         - True if fullscreen is supported.
	   *         - False if fullscreen is not supported.
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    if (typeof this.el_.webkitEnterFullScreen === 'function') {
	      var userAgent = window__default['default'].navigator && window__default['default'].navigator.userAgent || ''; // Seems to be broken in Chromium/Chrome && Safari in Leopard
	
	      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	  /**
	   * Request that the `HTML5` Tech enter fullscreen.
	   */
	  ;
	
	  _proto.enterFullScreen = function enterFullScreen() {
	    var video = this.el_;
	
	    if (video.paused && video.networkState <= video.HAVE_METADATA) {
	      // attempt to prime the video element for programmatic access
	      // this isn't necessary on the desktop but shouldn't hurt
	      silencePromise(this.el_.play()); // playing and pausing synchronously during the transition to fullscreen
	      // can get iOS ~6.1 devices into a play/pause loop
	
	      this.setTimeout(function () {
	        video.pause();
	
	        try {
	          video.webkitEnterFullScreen();
	        } catch (e) {
	          this.trigger('fullscreenerror', e);
	        }
	      }, 0);
	    } else {
	      try {
	        video.webkitEnterFullScreen();
	      } catch (e) {
	        this.trigger('fullscreenerror', e);
	      }
	    }
	  }
	  /**
	   * Request that the `HTML5` Tech exit fullscreen.
	   */
	  ;
	
	  _proto.exitFullScreen = function exitFullScreen() {
	    if (!this.el_.webkitDisplayingFullscreen) {
	      this.trigger('fullscreenerror', new Error('The video is not fullscreen'));
	      return;
	    }
	
	    this.el_.webkitExitFullScreen();
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    return this.el_.requestPictureInPicture();
	  }
	  /**
	   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
	   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
	   * Needs to be checked later than the constructor
	   * This will be a false positive for clear sources loaded after a Fairplay source
	   *
	   * @param {function} cb function to call
	   * @return {number} id of request
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      return this.el_.requestVideoFrameCallback(cb);
	    }
	
	    return _Tech.prototype.requestVideoFrameCallback.call(this, cb);
	  }
	  /**
	   * Native or fallback requestVideoFrameCallback
	   *
	   * @param {number} id request id to cancel
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      this.el_.cancelVideoFrameCallback(id);
	    } else {
	      _Tech.prototype.cancelVideoFrameCallback.call(this, id);
	    }
	  }
	  /**
	   * A getter/setter for the `Html5` Tech's source object.
	   * > Note: Please use {@link Html5#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `HTML5` techs element.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	  ;
	
	  _proto.src = function src(_src) {
	    if (_src === undefined) {
	      return this.el_.src;
	    } // Setting src through `src` instead of `setSrc` will be deprecated
	
	
	    this.setSrc(_src);
	  }
	  /**
	   * Reset the tech by removing all sources and then calling
	   * {@link Html5.resetMediaElement}.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    Html5.resetMediaElement(this.el_);
	  }
	  /**
	   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
	   * the HTML5 media element.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object from the HTML5 tech. With a fallback to the
	   *         elements source.
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	
	    return this.el_.currentSrc;
	  }
	  /**
	   * Set controls attribute for the HTML5 media Element.
	   *
	   * @param {string} val
	   *        Value to set the controls attribute to
	   */
	  ;
	
	  _proto.setControls = function setControls(val) {
	    this.el_.controls = !!val;
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
	    }
	
	    return this.el_.addTextTrack(kind, label, language);
	  }
	  /**
	   * Creates either native TextTrack or an emulated TextTrack depending
	   * on the value of `featuresNativeTextTracks`
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label]
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @param {boolean} [options.default]
	   *        Default this track to on.
	   *
	   * @param {string} [options.id]
	   *        The internal id to assign this track.
	   *
	   * @param {string} [options.src]
	   *        A source url for the track.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.createRemoteTextTrack.call(this, options);
	    }
	
	    var htmlTrackElement = document__default['default'].createElement('track');
	
	    if (options.kind) {
	      htmlTrackElement.kind = options.kind;
	    }
	
	    if (options.label) {
	      htmlTrackElement.label = options.label;
	    }
	
	    if (options.language || options.srclang) {
	      htmlTrackElement.srclang = options.language || options.srclang;
	    }
	
	    if (options["default"]) {
	      htmlTrackElement["default"] = options["default"];
	    }
	
	    if (options.id) {
	      htmlTrackElement.id = options.id;
	    }
	
	    if (options.src) {
	      htmlTrackElement.src = options.src;
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * @param {Object} options The object should contain values for
	   * kind, language, label, and src (location of the WebVTT file)
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   * automatically removed from the video element whenever the source changes
	   * @return {HTMLTrackElement} An Html Track Element.
	   * This can be an emulated {@link HTMLTrackElement} or a native one.
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   * to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
	
	    if (this.featuresNativeTextTracks) {
	      this.el().appendChild(htmlTrackElement);
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove remote `TextTrack` from `TextTrackList` object
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` object to remove
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    _Tech.prototype.removeRemoteTextTrack.call(this, track);
	
	    if (this.featuresNativeTextTracks) {
	      var tracks = this.$$('track');
	      var i = tracks.length;
	
	      while (i--) {
	        if (track === tracks[i] || track === tracks[i].track) {
	          this.el().removeChild(tracks[i]);
	        }
	      }
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    if (typeof this.el().getVideoPlaybackQuality === 'function') {
	      return this.el().getVideoPlaybackQuality();
	    }
	
	    var videoPlaybackQuality = {};
	
	    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
	      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
	      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
	    }
	
	    if (window__default['default'].performance && typeof window__default['default'].performance.now === 'function') {
	      videoPlaybackQuality.creationTime = window__default['default'].performance.now();
	    } else if (window__default['default'].performance && window__default['default'].performance.timing && typeof window__default['default'].performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = window__default['default'].Date.now() - window__default['default'].performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Html5;
	}(Tech);
	/* HTML5 Support Testing ---------------------------------------------------- */
	
	/**
	 * Element for testing browser HTML5 media capabilities
	 *
	 * @type {Element}
	 * @constant
	 * @private
	 */
	
	
	defineLazyProperty(Html5, 'TEST_VID', function () {
	  if (!isReal()) {
	    return;
	  }
	
	  var video = document__default['default'].createElement('video');
	  var track = document__default['default'].createElement('track');
	  track.kind = 'captions';
	  track.srclang = 'en';
	  track.label = 'English';
	  video.appendChild(track);
	  return video;
	});
	/**
	 * Check if HTML5 media is supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if HTML5 media is supported.
	 *         - False if HTML5 media is not supported.
	 */
	
	Html5.isSupported = function () {
	  // IE with no Media Player is a LIAR! (#984)
	  try {
	    Html5.TEST_VID.volume = 0.5;
	  } catch (e) {
	    return false;
	  }
	
	  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	/**
	 * Check if the tech can support the given type
	 *
	 * @param {string} type
	 *        The mimetype to check
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlayType = function (type) {
	  return Html5.TEST_VID.canPlayType(type);
	};
	/**
	 * Check if the tech can support the given source
	 *
	 * @param {Object} srcObj
	 *        The source object
	 * @param {Object} options
	 *        The options passed to the tech
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlaySource = function (srcObj, options) {
	  return Html5.canPlayType(srcObj.type);
	};
	/**
	 * Check if the volume can be changed in this browser/device.
	 * Volume cannot be changed in a lot of mobile devices.
	 * Specifically, it can't be changed from 1 on iOS.
	 *
	 * @return {boolean}
	 *         - True if volume can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlVolume = function () {
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var volume = Html5.TEST_VID.volume;
	    Html5.TEST_VID.volume = volume / 2 + 0.1;
	    var canControl = volume !== Html5.TEST_VID.volume; // With the introduction of iOS 15, there are cases where the volume is read as
	    // changed but reverts back to its original state at the start of the next tick.
	    // To determine whether volume can be controlled on iOS,
	    // a timeout is set and the volume is checked asynchronously.
	    // Since `features` doesn't currently work asynchronously, the value is manually set.
	
	    if (canControl && IS_IOS) {
	      window__default['default'].setTimeout(function () {
	        if (Html5 && Html5.prototype) {
	          Html5.prototype.featuresVolumeControl = volume !== Html5.TEST_VID.volume;
	        }
	      }); // default iOS to false, which will be updated in the timeout above.
	
	      return false;
	    }
	
	    return canControl;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the volume can be muted in this browser/device.
	 * Some devices, e.g. iOS, don't allow changing volume
	 * but permits muting/unmuting.
	 *
	 * @return {bolean}
	 *      - True if volume can be muted
	 *      - False otherwise
	 */
	
	
	Html5.canMuteVolume = function () {
	  try {
	    var muted = Html5.TEST_VID.muted; // in some versions of iOS muted property doesn't always
	    // work, so we want to set both property and attribute
	
	    Html5.TEST_VID.muted = !muted;
	
	    if (Html5.TEST_VID.muted) {
	      setAttribute(Html5.TEST_VID, 'muted', 'muted');
	    } else {
	      removeAttribute(Html5.TEST_VID, 'muted', 'muted');
	    }
	
	    return muted !== Html5.TEST_VID.muted;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the playback rate can be changed in this browser/device.
	 *
	 * @return {boolean}
	 *         - True if playback rate can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlPlaybackRate = function () {
	  // Playback rate API is implemented in Android Chrome, but doesn't do anything
	  // https://github.com/videojs/video.js/issues/3180
	  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
	    return false;
	  } // IE will error if Windows Media Player not installed #3315
	
	
	  try {
	    var playbackRate = Html5.TEST_VID.playbackRate;
	    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
	    return playbackRate !== Html5.TEST_VID.playbackRate;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if we can override a video/audio elements attributes, with
	 * Object.defineProperty.
	 *
	 * @return {boolean}
	 *         - True if builtin attributes can be overridden
	 *         - False otherwise
	 */
	
	
	Html5.canOverrideAttributes = function () {
	  // if we cannot overwrite the src/innerHTML property, there is no support
	  // iOS 7 safari for instance cannot do this.
	  try {
	    var noop = function noop() {};
	
	    Object.defineProperty(document__default['default'].createElement('video'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('video'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	  } catch (e) {
	    return false;
	  }
	
	  return true;
	};
	/**
	 * Check to see if native `TextTrack`s are supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if native `TextTrack`s are supported.
	 *         - False otherwise
	 */
	
	
	Html5.supportsNativeTextTracks = function () {
	  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
	};
	/**
	 * Check to see if native `VideoTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `VideoTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeVideoTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	/**
	 * Check to see if native `AudioTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `AudioTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeAudioTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	/**
	 * An array of events available on the Html5 tech.
	 *
	 * @private
	 * @type {Array}
	 */
	
	
	Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'resize', 'volumechange'];
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default {@link Html5.canMuteVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the media
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlPlaybackRate}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeTextTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeVideoTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeAudioTracks}
	 */
	
	[['featuresMuteControl', 'canMuteVolume'], ['featuresPlaybackRate', 'canControlPlaybackRate'], ['featuresSourceset', 'canOverrideAttributes'], ['featuresNativeTextTracks', 'supportsNativeTextTracks'], ['featuresNativeVideoTracks', 'supportsNativeVideoTracks'], ['featuresNativeAudioTracks', 'supportsNativeAudioTracks']].forEach(function (_ref) {
	  var key = _ref[0],
	      fn = _ref[1];
	  defineLazyProperty(Html5.prototype, key, function () {
	    return Html5[fn]();
	  }, true);
	});
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the media element
	 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
	 * false there. Everywhere else this should be true.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.movingMediaElementInDOM = !IS_IOS; // TODO: Previous comment: No longer appears to be used. Can probably be removed.
	//       Is this true?
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	 * when going into fullscreen.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresFullscreenResize = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
	 * If this is false, manual `progress` events will be triggered instead.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresProgressEvents = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	 * If this is false, manual `timeupdate` events will be triggered instead.
	 *
	 * @default
	 */
	
	Html5.prototype.featuresTimeupdateEvents = true;
	/**
	 * Whether the HTML5 el supports `requestVideoFrameCallback`
	 *
	 * @type {boolean}
	 */
	
	Html5.prototype.featuresVideoFrameCallback = !!(Html5.TEST_VID && Html5.TEST_VID.requestVideoFrameCallback); // HTML5 Feature detection and Device Fixes --------------------------------- //
	
	var canPlayType;
	
	Html5.patchCanPlayType = function () {
	  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
	  // Firefox and Chrome report correctly
	  if (ANDROID_VERSION >= 4.0 && !IS_FIREFOX && !IS_CHROME) {
	    canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
	
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
	
	      if (type && mpegurlRE.test(type)) {
	        return 'maybe';
	      }
	
	      return canPlayType.call(this, type);
	    };
	  }
	};
	
	Html5.unpatchCanPlayType = function () {
	  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
	
	  if (canPlayType) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
	  }
	
	  return r;
	}; // by default, patch the media element
	
	
	Html5.patchCanPlayType();
	
	Html5.disposeMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  if (el.parentNode) {
	    el.parentNode.removeChild(el);
	  } // remove any child track or source nodes to prevent their loading
	
	
	  while (el.hasChildNodes()) {
	    el.removeChild(el.firstChild);
	  } // remove any src reference. not setting `src=''` because that causes a warning
	  // in firefox
	
	
	  el.removeAttribute('src'); // force the media element to update its loading state by calling load()
	  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// not supported
	      }
	    })();
	  }
	};
	
	Html5.resetMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  var sources = el.querySelectorAll('source');
	  var i = sources.length;
	
	  while (i--) {
	    el.removeChild(sources[i]);
	  } // remove any src reference.
	  // not setting `src=''` because that throws an error
	
	
	  el.removeAttribute('src');
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// satisfy linter
	      }
	    })();
	  }
	};
	/* Native HTML5 element property wrapping ----------------------------------- */
	// Wrap native boolean attributes with getters that check both property and attribute
	// The list is as followed:
	// muted, defaultMuted, autoplay, controls, loop, playsinline
	
	
	[
	/**
	 * Get the value of `muted` from the media element. `muted` indicates
	 * that the volume for the media should be set to silent. This does not actually change
	 * the `volume` attribute.
	 *
	 * @method Html5#muted
	 * @return {boolean}
	 *         - True if the value of `volume` should be ignored and the audio set to silent.
	 *         - False if the value of `volume` should be used.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
	 * current state.
	 *
	 * @method Html5#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the media element.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Get the value of `autoplay` from the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the media element.
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Get the value of `controls` from the media element. `controls` indicates
	 * whether the native media controls should be shown or hidden.
	 *
	 * @method Html5#controls
	 * @return {boolean}
	 *         - The value of `controls` from the media element.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
	 */
	'controls',
	/**
	 * Get the value of `loop` from the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#loop
	 * @return {boolean}
	 *         - The value of `loop` from the media element.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Get the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#playsinline
	 * @return {boolean}
	 *         - The value of `playsinline` from the media element.
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop] || this.el_.hasAttribute(prop);
	  };
	}); // Wrap native boolean attributes with setters that set both property and attribute
	// The list is as followed:
	// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
	// setControls is special-cased above
	
	[
	/**
	 * Set the value of `muted` on the media element. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Html5#setMuted
	 * @param {boolean} muted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
	 * audio level should be silent, but will only effect the muted level on initial playback..
	 *
	 * @method Html5.prototype.setDefaultMuted
	 * @param {boolean} defaultMuted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Set the value of `autoplay` on the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#setAutoplay
	 * @param {boolean} autoplay
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Set the value of `loop` on the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#setLoop
	 * @param {boolean} loop
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Set the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#setPlaysinline
	 * @param {boolean} playsinline
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	
	    if (v) {
	      this.el_.setAttribute(prop, prop);
	    } else {
	      this.el_.removeAttribute(prop);
	    }
	  };
	}); // Wrap native properties with a getter
	// The list is as followed
	// paused, currentTime, buffered, volume, poster, preload, error, seeking
	// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
	// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
	
	[
	/**
	 * Get the value of `paused` from the media element. `paused` indicates whether the media element
	 * is currently paused or not.
	 *
	 * @method Html5#paused
	 * @return {boolean}
	 *         The value of `paused` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
	 */
	'paused',
	/**
	 * Get the value of `currentTime` from the media element. `currentTime` indicates
	 * the current second that the media is at in playback.
	 *
	 * @method Html5#currentTime
	 * @return {number}
	 *         The value of `currentTime` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
	 */
	'currentTime',
	/**
	 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
	 * object that represents the parts of the media that are already downloaded and
	 * available for playback.
	 *
	 * @method Html5#buffered
	 * @return {TimeRange}
	 *         The value of `buffered` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
	 */
	'buffered',
	/**
	 * Get the value of `volume` from the media element. `volume` indicates
	 * the current playback volume of audio for a media. `volume` will be a value from 0
	 * (silent) to 1 (loudest and default).
	 *
	 * @method Html5#volume
	 * @return {number}
	 *         The value of `volume` from the media element. Value will be between 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Get the value of `poster` from the media element. `poster` indicates
	 * that the url of an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#poster
	 * @return {string}
	 *         The value of `poster` from the media element. Value will be a url to an
	 *         image.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
	 */
	'poster',
	/**
	 * Get the value of `preload` from the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#preload
	 * @return {string}
	 *         The value of `preload` from the media element. Will be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Get the value of the `error` from the media element. `error` indicates any
	 * MediaError that may have occurred during playback. If error returns null there is no
	 * current error.
	 *
	 * @method Html5#error
	 * @return {MediaError|null}
	 *         The value of `error` from the media element. Will be `MediaError` if there
	 *         is a current error and null otherwise.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
	 */
	'error',
	/**
	 * Get the value of `seeking` from the media element. `seeking` indicates whether the
	 * media is currently seeking to a new position or not.
	 *
	 * @method Html5#seeking
	 * @return {boolean}
	 *         - The value of `seeking` from the media element.
	 *         - True indicates that the media is currently seeking to a new position.
	 *         - False indicates that the media is not seeking to a new position at this time.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
	 */
	'seeking',
	/**
	 * Get the value of `seekable` from the media element. `seekable` returns a
	 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
	 *
	 * @method Html5#seekable
	 * @return {TimeRange}
	 *         The value of `seekable` from the media element. A `TimeRange` object
	 *         indicating the current ranges of time that can be seeked to.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
	 */
	'seekable',
	/**
	 * Get the value of `ended` from the media element. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Html5#ended
	 * @return {boolean}
	 *         - The value of `ended` from the media element.
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	'ended',
	/**
	 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media is currently playing back. This value will not indicate the current
	 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
	 *
	 * Examples:
	 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
	 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.defaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Get the value of 'disablePictureInPicture' from the video element.
	 *
	 * @method Html5#disablePictureInPicture
	 * @return {boolean} value
	 *         - The value of `disablePictureInPicture` from the video element.
	 *         - True indicates that the video can't be played in Picture-In-Picture mode
	 *         - False indicates that the video can be played in Picture-In-Picture mode
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Get the value of `played` from the media element. `played` returns a `TimeRange`
	 * object representing points in the media timeline that have been played.
	 *
	 * @method Html5#played
	 * @return {TimeRange}
	 *         The value of `played` from the media element. A `TimeRange` object indicating
	 *         the ranges of time that have been played.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
	 */
	'played',
	/**
	 * Get the value of `networkState` from the media element. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NETWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Html5#networkState
	 * @return {number}
	 *         The value of `networkState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
	 */
	'networkState',
	/**
	 * Get the value of `readyState` from the media element. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Html5#readyState
	 * @return {number}
	 *         The value of `readyState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
	 */
	'readyState',
	/**
	 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
	 * the current width of the video in css pixels.
	 *
	 * @method Html5#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoWidth',
	/**
	 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
	 * the current height of the video in css pixels.
	 *
	 * @method Html5#videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoHeight',
	/**
	 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#crossOrigin
	 * @return {string}
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop];
	  };
	}); // Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	// The list is as follows:
	// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
	// setDisablePictureInPicture, setCrossOrigin
	
	[
	/**
	 * Set the value of `volume` on the media element. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Html5#setVolume
	 * @param {number} percentAsDecimal
	 *        The volume percent as a decimal. Valid range is from 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Set the value of `src` on the media element. `src` indicates the current
	 * {@link Tech~SourceObject} for the media.
	 *
	 * @method Html5#setSrc
	 * @param {Tech~SourceObject} src
	 *        The source object to set as the current source.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
	 */
	'src',
	/**
	 * Set the value of `poster` on the media element. `poster` is the url to
	 * an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#setPoster
	 * @param {string} poster
	 *        The url to an image that should be used as the `poster` for the media
	 *        element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
	 */
	'poster',
	/**
	 * Set the value of `preload` on the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#setPreload
	 * @param {string} preload
	 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
	 * the rate at which the media should play back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#setPlaybackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media should play back upon initial startup. Changing this value
	 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
	 *
	 * Example Values:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.setDefaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Prevents the browser from suggesting a Picture-in-Picture context menu
	 * or to request Picture-in-Picture automatically in some cases.
	 *
	 * @method Html5#setDisablePictureInPicture
	 * @param {boolean} value
	 *         The true value will disable Picture-in-Picture mode.
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#setCrossOrigin
	 * @param {string} crossOrigin
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	  };
	}); // wrap native functions with a function
	// The list is as follows:
	// pause, load, play
	
	[
	/**
	 * A wrapper around the media elements `pause` function. This will call the `HTML5`
	 * media elements `pause` function.
	 *
	 * @method Html5#pause
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
	 */
	'pause',
	/**
	 * A wrapper around the media elements `load` function. This will call the `HTML5`s
	 * media element `load` function.
	 *
	 * @method Html5#load
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
	 */
	'load',
	/**
	 * A wrapper around the media elements `play` function. This will call the `HTML5`s
	 * media element `play` function.
	 *
	 * @method Html5#play
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
	 */
	'play'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop]();
	  };
	});
	Tech.withSourceHandlers(Html5);
	/**
	 * Native source handler for Html5, simply passes the source to the media element.
	 *
	 * @property {Tech~SourceObject} source
	 *        The source object
	 *
	 * @property {Html5} tech
	 *        The instance of the HTML5 tech.
	 */
	
	Html5.nativeSourceHandler = {};
	/**
	 * Check if the media element can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string)
	 */
	
	Html5.nativeSourceHandler.canPlayType = function (type) {
	  // IE without MediaPlayer throws an error (#519)
	  try {
	    return Html5.TEST_VID.canPlayType(type);
	  } catch (e) {
	    return '';
	  }
	};
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string).
	 */
	
	
	Html5.nativeSourceHandler.canHandleSource = function (source, options) {
	  // If a type was provided we should rely on that
	  if (source.type) {
	    return Html5.nativeSourceHandler.canPlayType(source.type); // If no type, fall back to checking 'video/[EXTENSION]'
	  } else if (source.src) {
	    var ext = getFileExtension(source.src);
	    return Html5.nativeSourceHandler.canPlayType("video/" + ext);
	  }
	
	  return '';
	};
	/**
	 * Pass the source to the native media element.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Html5} tech
	 *        The instance of the Html5 tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	
	
	Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	/**
	 * A noop for the native dispose function, as cleanup is not needed.
	 */
	
	
	Html5.nativeSourceHandler.dispose = function () {}; // Register the native source handler
	
	
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	Tech.registerTech('Html5', Html5);
	
	// on the player when they happen
	
	var TECH_EVENTS_RETRIGGER = [
	/**
	 * Fired while the user agent is downloading media data.
	 *
	 * @event Player#progress
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `progress` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechProgress_
	 * @fires Player#progress
	 * @listens Tech#progress
	 */
	'progress',
	/**
	 * Fires when the loading of an audio/video is aborted.
	 *
	 * @event Player#abort
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `abort` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechAbort_
	 * @fires Player#abort
	 * @listens Tech#abort
	 */
	'abort',
	/**
	 * Fires when the browser is intentionally not getting media data.
	 *
	 * @event Player#suspend
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechSuspend_
	 * @fires Player#suspend
	 * @listens Tech#suspend
	 */
	'suspend',
	/**
	 * Fires when the current playlist is empty.
	 *
	 * @event Player#emptied
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechEmptied_
	 * @fires Player#emptied
	 * @listens Tech#emptied
	 */
	'emptied',
	/**
	 * Fires when the browser is trying to get media data, but data is not available.
	 *
	 * @event Player#stalled
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechStalled_
	 * @fires Player#stalled
	 * @listens Tech#stalled
	 */
	'stalled',
	/**
	 * Fires when the browser has loaded meta data for the audio/video.
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoadedmetadata_
	 * @fires Player#loadedmetadata
	 * @listens Tech#loadedmetadata
	 */
	'loadedmetadata',
	/**
	 * Fires when the browser has loaded the current frame of the audio/video.
	 *
	 * @event Player#loadeddata
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoaddeddata_
	 * @fires Player#loadeddata
	 * @listens Tech#loadeddata
	 */
	'loadeddata',
	/**
	 * Fires when the current playback position has changed.
	 *
	 * @event Player#timeupdate
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTimeUpdate_
	 * @fires Player#timeupdate
	 * @listens Tech#timeupdate
	 */
	'timeupdate',
	/**
	 * Fires when the video's intrinsic dimensions change
	 *
	 * @event Player#resize
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `resize` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechResize_
	 * @fires Player#resize
	 * @listens Tech#resize
	 */
	'resize',
	/**
	 * Fires when the volume has been changed
	 *
	 * @event Player#volumechange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechVolumechange_
	 * @fires Player#volumechange
	 * @listens Tech#volumechange
	 */
	'volumechange',
	/**
	 * Fires when the text track has been changed
	 *
	 * @event Player#texttrackchange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTexttrackchange_
	 * @fires Player#texttrackchange
	 * @listens Tech#texttrackchange
	 */
	'texttrackchange']; // events to queue when playback rate is zero
	// this is a hash for the sole purpose of mapping non-camel-cased event names
	// to camel-cased function names
	
	var TECH_EVENTS_QUEUE = {
	  canplay: 'CanPlay',
	  canplaythrough: 'CanPlayThrough',
	  playing: 'Playing',
	  seeked: 'Seeked'
	};
	var BREAKPOINT_ORDER = ['tiny', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'huge'];
	var BREAKPOINT_CLASSES = {}; // grep: vjs-layout-tiny
	// grep: vjs-layout-x-small
	// grep: vjs-layout-small
	// grep: vjs-layout-medium
	// grep: vjs-layout-large
	// grep: vjs-layout-x-large
	// grep: vjs-layout-huge
	
	BREAKPOINT_ORDER.forEach(function (k) {
	  var v = k.charAt(0) === 'x' ? "x-" + k.substring(1) : k;
	  BREAKPOINT_CLASSES[k] = "vjs-layout-" + v;
	});
	var DEFAULT_BREAKPOINTS = {
	  tiny: 210,
	  xsmall: 320,
	  small: 425,
	  medium: 768,
	  large: 1440,
	  xlarge: 2560,
	  huge: Infinity
	};
	/**
	 * An instance of the `Player` class is created when any of the Video.js setup methods
	 * are used to initialize a video.
	 *
	 * After an instance has been created it can be accessed globally in two ways:
	 * 1. By calling `videojs('example_video_1');`
	 * 2. By using it directly via  `videojs.players.example_video_1;`
	 *
	 * @extends Component
	 */
	
	var Player = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Player, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Element} tag
	   *        The original video DOM element used for configuring options.
	   *
	   * @param {Object} [options]
	   *        Object of option names and values.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Ready callback function.
	   */
	  function Player(tag, options, ready) {
	    var _this;
	
	    // Make sure tag ID exists
	    tag.id = tag.id || options.id || "vjs_video_" + newGUID(); // Set Options
	    // The options argument overrides options set in the video tag
	    // which overrides globally set options.
	    // This latter part coincides with the load order
	    // (tag must exist before Player)
	
	    options = assign(Player.getTagSettings(tag), options); // Delay the initialization of children because we need to set up
	    // player properties first, and can't use `this` before `super()`
	
	    options.initChildren = false; // Same with creating the element
	
	    options.createEl = false; // don't auto mixin the evented mixin
	
	    options.evented = false; // we don't want the player to report touch activity on itself
	    // see enableTouchActivity in Component
	
	    options.reportTouchActivity = false; // If language is not set, get the closest lang attribute
	
	    if (!options.language) {
	      if (typeof tag.closest === 'function') {
	        var closest = tag.closest('[lang]');
	
	        if (closest && closest.getAttribute) {
	          options.language = closest.getAttribute('lang');
	        }
	      } else {
	        var element = tag;
	
	        while (element && element.nodeType === 1) {
	          if (getAttributes(element).hasOwnProperty('lang')) {
	            options.language = element.getAttribute('lang');
	            break;
	          }
	
	          element = element.parentNode;
	        }
	      }
	    } // Run base component initializing with new options
	
	
	    _this = _Component.call(this, null, options, ready) || this; // Create bound methods for document listeners.
	
	    _this.boundDocumentFullscreenChange_ = function (e) {
	      return _this.documentFullscreenChange_(e);
	    };
	
	    _this.boundFullWindowOnEscKey_ = function (e) {
	      return _this.fullWindowOnEscKey(e);
	    };
	
	    _this.boundUpdateStyleEl_ = function (e) {
	      return _this.updateStyleEl_(e);
	    };
	
	    _this.boundApplyInitTime_ = function (e) {
	      return _this.applyInitTime_(e);
	    };
	
	    _this.boundUpdateCurrentBreakpoint_ = function (e) {
	      return _this.updateCurrentBreakpoint_(e);
	    };
	
	    _this.boundHandleTechClick_ = function (e) {
	      return _this.handleTechClick_(e);
	    };
	
	    _this.boundHandleTechDoubleClick_ = function (e) {
	      return _this.handleTechDoubleClick_(e);
	    };
	
	    _this.boundHandleTechTouchStart_ = function (e) {
	      return _this.handleTechTouchStart_(e);
	    };
	
	    _this.boundHandleTechTouchMove_ = function (e) {
	      return _this.handleTechTouchMove_(e);
	    };
	
	    _this.boundHandleTechTouchEnd_ = function (e) {
	      return _this.handleTechTouchEnd_(e);
	    };
	
	    _this.boundHandleTechTap_ = function (e) {
	      return _this.handleTechTap_(e);
	    }; // default isFullscreen_ to false
	
	
	    _this.isFullscreen_ = false; // create logger
	
	    _this.log = createLogger(_this.id_); // Hold our own reference to fullscreen api so it can be mocked in tests
	
	    _this.fsApi_ = FullscreenApi; // Tracks when a tech changes the poster
	
	    _this.isPosterFromTech_ = false; // Holds callback info that gets queued when playback rate is zero
	    // and a seek is happening
	
	    _this.queuedCallbacks_ = []; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    _this.isReady_ = false; // Init state hasStarted_
	
	    _this.hasStarted_ = false; // Init state userActive_
	
	    _this.userActive_ = false; // Init debugEnabled_
	
	    _this.debugEnabled_ = false; // Init state audioOnlyMode_
	
	    _this.audioOnlyMode_ = false; // Init state audioPosterMode_
	
	    _this.audioPosterMode_ = false; // Init state audioOnlyCache_
	
	    _this.audioOnlyCache_ = {
	      playerHeight: null,
	      hiddenChildren: []
	    }; // if the global option object was accidentally blown away by
	    // someone, bail early with an informative error
	
	    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
	      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
	    } // Store the original tag used to set options
	
	
	    _this.tag = tag; // Store the tag attributes used to restore html5 element
	
	    _this.tagAttributes = tag && getAttributes(tag); // Update current language
	
	    _this.language(_this.options_.language); // Update Supported Languages
	
	
	    if (options.languages) {
	      // Normalise player option languages to lowercase
	      var languagesToLower = {};
	      Object.getOwnPropertyNames(options.languages).forEach(function (name) {
	        languagesToLower[name.toLowerCase()] = options.languages[name];
	      });
	      _this.languages_ = languagesToLower;
	    } else {
	      _this.languages_ = Player.prototype.options_.languages;
	    }
	
	    _this.resetCache_(); // Set poster
	
	
	    _this.poster_ = options.poster || ''; // Set controls
	
	    _this.controls_ = !!options.controls; // Original tag settings stored in options
	    // now remove immediately so native controls don't flash.
	    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
	
	    tag.controls = false;
	    tag.removeAttribute('controls');
	    _this.changingSrc_ = false;
	    _this.playCallbacks_ = [];
	    _this.playTerminatedQueue_ = []; // the attribute overrides the option
	
	    if (tag.hasAttribute('autoplay')) {
	      _this.autoplay(true);
	    } else {
	      // otherwise use the setter to validate and
	      // set the correct value.
	      _this.autoplay(_this.options_.autoplay);
	    } // check plugins
	
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        if (typeof _this[name] !== 'function') {
	          throw new Error("plugin \"" + name + "\" does not exist");
	        }
	      });
	    }
	    /*
	     * Store the internal state of scrubbing
	     *
	     * @private
	     * @return {Boolean} True if the user is scrubbing
	     */
	
	
	    _this.scrubbing_ = false;
	    _this.el_ = _this.createEl(); // Make this an evented object and use `el_` as its event bus.
	
	    evented(_assertThisInitialized__default['default'](_this), {
	      eventBusKey: 'el_'
	    }); // listen to document and player fullscreenchange handlers so we receive those events
	    // before a user can receive them so we can update isFullscreen appropriately.
	    // make sure that we listen to fullscreenchange events before everything else to make sure that
	    // our isFullscreen method is updated properly for internal components as well as external.
	
	    if (_this.fsApi_.requestFullscreen) {
	      on(document__default['default'], _this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	
	      _this.on(_this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	    }
	
	    if (_this.fluid_) {
	      _this.on(['playerreset', 'resize'], _this.boundUpdateStyleEl_);
	    } // We also want to pass the original player options to each component and plugin
	    // as well so they don't need to reach back into the player for options later.
	    // We also need to do another copy of this.options_ so we don't end up with
	    // an infinite loop.
	
	
	    var playerOptionsCopy = mergeOptions$3(_this.options_); // Load plugins
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        _this[name](options.plugins[name]);
	      });
	    } // Enable debug mode to fire debugon event for all plugins.
	
	
	    if (options.debug) {
	      _this.debug(true);
	    }
	
	    _this.options_.playerOptions = playerOptionsCopy;
	    _this.middleware_ = [];
	
	    _this.playbackRates(options.playbackRates);
	
	    _this.initChildren(); // Set isAudio based on whether or not an audio tag was used
	
	
	    _this.isAudio(tag.nodeName.toLowerCase() === 'audio'); // Update controls className. Can't do this when the controls are initially
	    // set because the element doesn't exist yet.
	
	
	    if (_this.controls()) {
	      _this.addClass('vjs-controls-enabled');
	    } else {
	      _this.addClass('vjs-controls-disabled');
	    } // Set ARIA label and region role depending on player type
	
	
	    _this.el_.setAttribute('role', 'region');
	
	    if (_this.isAudio()) {
	      _this.el_.setAttribute('aria-label', _this.localize('Audio Player'));
	    } else {
	      _this.el_.setAttribute('aria-label', _this.localize('Video Player'));
	    }
	
	    if (_this.isAudio()) {
	      _this.addClass('vjs-audio');
	    }
	
	    if (_this.flexNotSupported_()) {
	      _this.addClass('vjs-no-flex');
	    } // TODO: Make this smarter. Toggle user state between touching/mousing
	    // using events, since devices can have both touch and mouse events.
	    // TODO: Make this check be performed again when the window switches between monitors
	    // (See https://github.com/videojs/video.js/issues/5683)
	
	
	    if (TOUCH_ENABLED) {
	      _this.addClass('vjs-touch-enabled');
	    } // iOS Safari has broken hover handling
	
	
	    if (!IS_IOS) {
	      _this.addClass('vjs-workinghover');
	    } // Make player easily findable by ID
	
	
	    Player.players[_this.id_] = _assertThisInitialized__default['default'](_this); // Add a major version class to aid css in plugins
	
	    var majorVersion = version$5.split('.')[0];
	
	    _this.addClass("vjs-v" + majorVersion); // When the player is first initialized, trigger activity so components
	    // like the control bar show themselves if needed
	
	
	    _this.userActive(true);
	
	    _this.reportUserActivity();
	
	    _this.one('play', function (e) {
	      return _this.listenForUserActivity_(e);
	    });
	
	    _this.on('stageclick', function (e) {
	      return _this.handleStageClick_(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on('languagechange', function (e) {
	      return _this.handleLanguagechange(e);
	    });
	
	    _this.breakpoints(_this.options_.breakpoints);
	
	    _this.responsive(_this.options_.responsive); // Calling both the audio mode methods after the player is fully
	    // setup to be able to listen to the events triggered by them
	
	
	    _this.on('ready', function () {
	      // Calling the audioPosterMode method first so that
	      // the audioOnlyMode can take precedence when both options are set to true
	      _this.audioPosterMode(_this.options_.audioPosterMode);
	
	      _this.audioOnlyMode(_this.options_.audioOnlyMode);
	    });
	
	    return _this;
	  }
	  /**
	   * Destroys the video player and does any necessary cleanup.
	   *
	   * This is especially helpful if you are dynamically adding and removing videos
	   * to/from the DOM.
	   *
	   * @fires Player#dispose
	   */
	
	
	  var _proto = Player.prototype;
	
	  _proto.dispose = function dispose() {
	    var _this2 = this;
	
	    /**
	     * Called when the player is being disposed of.
	     *
	     * @event Player#dispose
	     * @type {EventTarget~Event}
	     */
	    this.trigger('dispose'); // prevent dispose from being called twice
	
	    this.off('dispose'); // Make sure all player-specific document listeners are unbound. This is
	
	    off(document__default['default'], this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_);
	
	    if (this.styleEl_ && this.styleEl_.parentNode) {
	      this.styleEl_.parentNode.removeChild(this.styleEl_);
	      this.styleEl_ = null;
	    } // Kill reference to this player
	
	
	    Player.players[this.id_] = null;
	
	    if (this.tag && this.tag.player) {
	      this.tag.player = null;
	    }
	
	    if (this.el_ && this.el_.player) {
	      this.el_.player = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.dispose();
	      this.isPosterFromTech_ = false;
	      this.poster_ = '';
	    }
	
	    if (this.playerElIngest_) {
	      this.playerElIngest_ = null;
	    }
	
	    if (this.tag) {
	      this.tag = null;
	    }
	
	    clearCacheForPlayer(this); // remove all event handlers for track lists
	    // all tracks and track listeners are removed on
	    // tech dispose
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      var list = _this2[props.getterName](); // if it is not a native list
	      // we have to manually remove event listeners
	
	
	      if (list && list.off) {
	        list.off();
	      }
	    }); // the actual .el_ is removed here, or replaced if
	
	    _Component.prototype.dispose.call(this, {
	      restoreEl: this.options_.restoreEl
	    });
	  }
	  /**
	   * Create the `Player`'s DOM element.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var tag = this.tag;
	    var el;
	    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
	    var divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
	
	    if (playerElIngest) {
	      el = this.el_ = tag.parentNode;
	    } else if (!divEmbed) {
	      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
	    } // Copy over all the attributes from the tag, including ID and class
	    // ID will now reference player box, not the video tag
	
	
	    var attrs = getAttributes(tag);
	
	    if (divEmbed) {
	      el = this.el_ = tag;
	      tag = this.tag = document__default['default'].createElement('video');
	
	      while (el.children.length) {
	        tag.appendChild(el.firstChild);
	      }
	
	      if (!hasClass(el, 'video-js')) {
	        addClass(el, 'video-js');
	      }
	
	      el.appendChild(tag);
	      playerElIngest = this.playerElIngest_ = el; // move properties over from our custom `video-js` element
	      // to our new `video` element. This will move things like
	      // `src` or `controls` that were set via js before the player
	      // was initialized.
	
	      Object.keys(el).forEach(function (k) {
	        try {
	          tag[k] = el[k];
	        } catch (e) {// we got a a property like outerHTML which we can't actually copy, ignore it
	        }
	      });
	    } // set tabindex to -1 to remove the video element from the focus order
	
	
	    tag.setAttribute('tabindex', '-1');
	    attrs.tabindex = '-1'; // Workaround for #4583 (JAWS+IE doesn't announce BPB or play button), and
	    // for the same issue with Chrome (on Windows) with JAWS.
	    // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
	    // Note that we can't detect if JAWS is being used, but this ARIA attribute
	    //  doesn't change behavior of IE11 or Chrome if JAWS is not being used
	
	    if (IE_VERSION || IS_CHROME && IS_WINDOWS) {
	      tag.setAttribute('role', 'application');
	      attrs.role = 'application';
	    } // Remove width/height attrs from tag so CSS can make it 100% width/height
	
	
	    tag.removeAttribute('width');
	    tag.removeAttribute('height');
	
	    if ('width' in attrs) {
	      delete attrs.width;
	    }
	
	    if ('height' in attrs) {
	      delete attrs.height;
	    }
	
	    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
	      // don't copy over the class attribute to the player element when we're in a div embed
	      // the class is already set up properly in the divEmbed case
	      // and we want to make sure that the `video-js` class doesn't get lost
	      if (!(divEmbed && attr === 'class')) {
	        el.setAttribute(attr, attrs[attr]);
	      }
	
	      if (divEmbed) {
	        tag.setAttribute(attr, attrs[attr]);
	      }
	    }); // Update tag id/class for use as HTML5 playback tech
	    // Might think we should do this after embedding in container so .vjs-tech class
	    // doesn't flash 100% width/height, but class only applies with .video-js parent
	
	    tag.playerId = tag.id;
	    tag.id += '_html5_api';
	    tag.className = 'vjs-tech'; // Make player findable on elements
	
	    tag.player = el.player = this; // Default state of video is paused
	
	    this.addClass('vjs-paused'); // Add a style element in the player that we'll use to set the width/height
	    // of the player in a way that's still overrideable by CSS, just like the
	    // video element
	
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
	      this.styleEl_ = createStyleElement('vjs-styles-dimensions');
	      var defaultsStyleEl = $('.vjs-styles-defaults');
	      var head = $('head');
	      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
	    }
	
	    this.fill_ = false;
	    this.fluid_ = false; // Pass in the width/height/aspectRatio options which will update the style el
	
	    this.width(this.options_.width);
	    this.height(this.options_.height);
	    this.fill(this.options_.fill);
	    this.fluid(this.options_.fluid);
	    this.aspectRatio(this.options_.aspectRatio); // support both crossOrigin and crossorigin to reduce confusion and issues around the name
	
	    this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin); // Hide any links within the video/audio tag,
	    // because IE doesn't hide them completely from screen readers.
	
	    var links = tag.getElementsByTagName('a');
	
	    for (var i = 0; i < links.length; i++) {
	      var linkEl = links.item(i);
	      addClass(linkEl, 'vjs-hidden');
	      linkEl.setAttribute('hidden', 'hidden');
	    } // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
	    // keep track of the original for later so we can know if the source originally failed
	
	
	    tag.initNetworkState_ = tag.networkState; // Wrap video tag in div (el/box) container
	
	    if (tag.parentNode && !playerElIngest) {
	      tag.parentNode.insertBefore(el, tag);
	    } // insert the tag as the first child of the player element
	    // then manually add it to the children array so that this.addChild
	    // will work properly for other components
	    //
	    // Breaks iPhone, fixed in HTML5 setup.
	
	
	    prependTo(tag, el);
	    this.children_.unshift(tag); // Set lang attr on player to ensure CSS :lang() in consistent with player
	    // if it's been set to something different to the doc
	
	    this.el_.setAttribute('lang', this.language_);
	    this.el_.setAttribute('translate', 'no');
	    this.el_ = el;
	    return el;
	  }
	  /**
	   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
	   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	   * behavior.
	   *
	   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	   *
	   * @param {string} [value]
	   *        The value to set the `Player`'s crossOrigin to. If an argument is
	   *        given, must be one of `anonymous` or `use-credentials`.
	   *
	   * @return {string|undefined}
	   *         - The current crossOrigin value of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin(value) {
	    if (!value) {
	      return this.techGet_('crossOrigin');
	    }
	
	    if (value !== 'anonymous' && value !== 'use-credentials') {
	      log$1.warn("crossOrigin must be \"anonymous\" or \"use-credentials\", given \"" + value + "\"");
	      return;
	    }
	
	    this.techCall_('setCrossOrigin', value);
	    return;
	  }
	  /**
	   * A getter/setter for the `Player`'s width. Returns the player's configured value.
	   * To get the current width use `currentWidth()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s width to.
	   *
	   * @return {number}
	   *         The current width of the `Player` when getting.
	   */
	  ;
	
	  _proto.width = function width(value) {
	    return this.dimension('width', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s height. Returns the player's configured value.
	   * To get the current height use `currentheight()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s heigth to.
	   *
	   * @return {number}
	   *         The current height of the `Player` when getting.
	   */
	  ;
	
	  _proto.height = function height(value) {
	    return this.dimension('height', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s width & height.
	   *
	   * @param {string} dimension
	   *        This string can be:
	   *        - 'width'
	   *        - 'height'
	   *
	   * @param {number} [value]
	   *        Value for dimension specified in the first argument.
	   *
	   * @return {number}
	   *         The dimension arguments value when getting (width/height).
	   */
	  ;
	
	  _proto.dimension = function dimension(_dimension, value) {
	    var privDimension = _dimension + '_';
	
	    if (value === undefined) {
	      return this[privDimension] || 0;
	    }
	
	    if (value === '' || value === 'auto') {
	      // If an empty string is given, reset the dimension to be automatic
	      this[privDimension] = undefined;
	      this.updateStyleEl_();
	      return;
	    }
	
	    var parsedVal = parseFloat(value);
	
	    if (isNaN(parsedVal)) {
	      log$1.error("Improper value \"" + value + "\" supplied for for " + _dimension);
	      return;
	    }
	
	    this[privDimension] = parsedVal;
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
	   *
	   * Turning this on will turn off fill mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fluid = function fluid(bool) {
	    var _this3 = this;
	
	    if (bool === undefined) {
	      return !!this.fluid_;
	    }
	
	    this.fluid_ = !!bool;
	
	    if (isEvented(this)) {
	      this.off(['playerreset', 'resize'], this.boundUpdateStyleEl_);
	    }
	
	    if (bool) {
	      this.addClass('vjs-fluid');
	      this.fill(false);
	      addEventedCallback(this, function () {
	        _this3.on(['playerreset', 'resize'], _this3.boundUpdateStyleEl_);
	      });
	    } else {
	      this.removeClass('vjs-fluid');
	    }
	
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
	   *
	   * Turning this on will turn off fluid mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fill = function fill(bool) {
	    if (bool === undefined) {
	      return !!this.fill_;
	    }
	
	    this.fill_ = !!bool;
	
	    if (bool) {
	      this.addClass('vjs-fill');
	      this.fluid(false);
	    } else {
	      this.removeClass('vjs-fill');
	    }
	  }
	  /**
	   * Get/Set the aspect ratio
	   *
	   * @param {string} [ratio]
	   *        Aspect ratio for player
	   *
	   * @return {string|undefined}
	   *         returns the current aspect ratio when getting
	   */
	
	  /**
	   * A getter/setter for the `Player`'s aspect ratio.
	   *
	   * @param {string} [ratio]
	   *        The value to set the `Player`'s aspect ratio to.
	   *
	   * @return {string|undefined}
	   *         - The current aspect ratio of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.aspectRatio = function aspectRatio(ratio) {
	    if (ratio === undefined) {
	      return this.aspectRatio_;
	    } // Check for width:height format
	
	
	    if (!/^\d+\:\d+$/.test(ratio)) {
	      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
	    }
	
	    this.aspectRatio_ = ratio; // We're assuming if you set an aspect ratio you want fluid mode,
	    // because in fixed mode you could calculate width and height yourself.
	
	    this.fluid(true);
	    this.updateStyleEl_();
	  }
	  /**
	   * Update styles of the `Player` element (height, width and aspect ratio).
	   *
	   * @private
	   * @listens Tech#loadedmetadata
	   */
	  ;
	
	  _proto.updateStyleEl_ = function updateStyleEl_() {
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE === true) {
	      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
	
	      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
	
	      var techEl = this.tech_ && this.tech_.el();
	
	      if (techEl) {
	        if (_width >= 0) {
	          techEl.width = _width;
	        }
	
	        if (_height >= 0) {
	          techEl.height = _height;
	        }
	      }
	
	      return;
	    }
	
	    var width;
	    var height;
	    var aspectRatio;
	    var idClass; // The aspect ratio is either used directly or to calculate width and height.
	
	    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
	      // Use any aspectRatio that's been specifically set
	      aspectRatio = this.aspectRatio_;
	    } else if (this.videoWidth() > 0) {
	      // Otherwise try to get the aspect ratio from the video metadata
	      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
	    } else {
	      // Or use a default. The video element's is 2:1, but 16:9 is more common.
	      aspectRatio = '16:9';
	    } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	    var ratioParts = aspectRatio.split(':');
	    var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	    if (this.width_ !== undefined) {
	      // Use any width that's been specifically set
	      width = this.width_;
	    } else if (this.height_ !== undefined) {
	      // Or calulate the width from the aspect ratio if a height has been set
	      width = this.height_ / ratioMultiplier;
	    } else {
	      // Or use the video's metadata, or use the video el's default of 300
	      width = this.videoWidth() || 300;
	    }
	
	    if (this.height_ !== undefined) {
	      // Use any height that's been specifically set
	      height = this.height_;
	    } else {
	      // Otherwise calculate the height from the ratio and the width
	      height = width * ratioMultiplier;
	    } // Ensure the CSS class is valid by starting with an alpha character
	
	
	    if (/^[^a-zA-Z]/.test(this.id())) {
	      idClass = 'dimensions-' + this.id();
	    } else {
	      idClass = this.id() + '-dimensions';
	    } // Ensure the right class is still on the player for the style element
	
	
	    this.addClass(idClass);
	    setTextContent(this.styleEl_, "\n      ." + idClass + " {\n        width: " + width + "px;\n        height: " + height + "px;\n      }\n\n      ." + idClass + ".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: " + ratioMultiplier * 100 + "%;\n      }\n    ");
	  }
	  /**
	   * Load/Create an instance of playback {@link Tech} including element
	   * and API methods. Then append the `Tech` element in `Player` as a child.
	   *
	   * @param {string} techName
	   *        name of the playback technology
	   *
	   * @param {string} source
	   *        video source
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadTech_ = function loadTech_(techName, source) {
	    var _this4 = this;
	
	    // Pause and remove current playback technology
	    if (this.tech_) {
	      this.unloadTech_();
	    }
	
	    var titleTechName = toTitleCase$1(techName);
	    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1); // get rid of the HTML5 video tag as soon as we are using another tech
	
	    if (titleTechName !== 'Html5' && this.tag) {
	      Tech.getTech('Html5').disposeMediaElement(this.tag);
	      this.tag.player = null;
	      this.tag = null;
	    }
	
	    this.techName_ = titleTechName; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    this.isReady_ = false;
	    var autoplay = this.autoplay(); // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
	    // because the player is going to handle autoplay on `loadstart`
	
	    if (typeof this.autoplay() === 'string' || this.autoplay() === true && this.options_.normalizeAutoplay) {
	      autoplay = false;
	    } // Grab tech-specific options from player options and add source and parent element to use.
	
	
	    var techOptions = {
	      source: source,
	      autoplay: autoplay,
	      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
	      'playerId': this.id(),
	      'techId': this.id() + "_" + camelTechName + "_api",
	      'playsinline': this.options_.playsinline,
	      'preload': this.options_.preload,
	      'loop': this.options_.loop,
	      'disablePictureInPicture': this.options_.disablePictureInPicture,
	      'muted': this.options_.muted,
	      'poster': this.poster(),
	      'language': this.language(),
	      'playerElIngest': this.playerElIngest_ || false,
	      'vtt.js': this.options_['vtt.js'],
	      'canOverridePoster': !!this.options_.techCanOverridePoster,
	      'enableSourceset': this.options_.enableSourceset,
	      'Promise': this.options_.Promise
	    };
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      techOptions[props.getterName] = _this4[props.privateName];
	    });
	    assign(techOptions, this.options_[titleTechName]);
	    assign(techOptions, this.options_[camelTechName]);
	    assign(techOptions, this.options_[techName.toLowerCase()]);
	
	    if (this.tag) {
	      techOptions.tag = this.tag;
	    }
	
	    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
	      techOptions.startTime = this.cache_.currentTime;
	    } // Initialize tech instance
	
	
	    var TechClass = Tech.getTech(techName);
	
	    if (!TechClass) {
	      throw new Error("No Tech named '" + titleTechName + "' exists! '" + titleTechName + "' should be registered using videojs.registerTech()'");
	    }
	
	    this.tech_ = new TechClass(techOptions); // player.triggerReady is always async, so don't need this to be async
	
	    this.tech_.ready(bind(this, this.handleTechReady_), true);
	    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_); // Listen to all HTML5-defined events and trigger them on the player
	
	    TECH_EVENTS_RETRIGGER.forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (e) {
	        return _this4["handleTech" + toTitleCase$1(event) + "_"](e);
	      });
	    });
	    Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (eventObj) {
	        if (_this4.tech_.playbackRate() === 0 && _this4.tech_.seeking()) {
	          _this4.queuedCallbacks_.push({
	            callback: _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"].bind(_this4),
	            event: eventObj
	          });
	
	          return;
	        }
	
	        _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"](eventObj);
	      });
	    });
	    this.on(this.tech_, 'loadstart', function (e) {
	      return _this4.handleTechLoadStart_(e);
	    });
	    this.on(this.tech_, 'sourceset', function (e) {
	      return _this4.handleTechSourceset_(e);
	    });
	    this.on(this.tech_, 'waiting', function (e) {
	      return _this4.handleTechWaiting_(e);
	    });
	    this.on(this.tech_, 'ended', function (e) {
	      return _this4.handleTechEnded_(e);
	    });
	    this.on(this.tech_, 'seeking', function (e) {
	      return _this4.handleTechSeeking_(e);
	    });
	    this.on(this.tech_, 'play', function (e) {
	      return _this4.handleTechPlay_(e);
	    });
	    this.on(this.tech_, 'firstplay', function (e) {
	      return _this4.handleTechFirstPlay_(e);
	    });
	    this.on(this.tech_, 'pause', function (e) {
	      return _this4.handleTechPause_(e);
	    });
	    this.on(this.tech_, 'durationchange', function (e) {
	      return _this4.handleTechDurationChange_(e);
	    });
	    this.on(this.tech_, 'fullscreenchange', function (e, data) {
	      return _this4.handleTechFullscreenChange_(e, data);
	    });
	    this.on(this.tech_, 'fullscreenerror', function (e, err) {
	      return _this4.handleTechFullscreenError_(e, err);
	    });
	    this.on(this.tech_, 'enterpictureinpicture', function (e) {
	      return _this4.handleTechEnterPictureInPicture_(e);
	    });
	    this.on(this.tech_, 'leavepictureinpicture', function (e) {
	      return _this4.handleTechLeavePictureInPicture_(e);
	    });
	    this.on(this.tech_, 'error', function (e) {
	      return _this4.handleTechError_(e);
	    });
	    this.on(this.tech_, 'posterchange', function (e) {
	      return _this4.handleTechPosterChange_(e);
	    });
	    this.on(this.tech_, 'textdata', function (e) {
	      return _this4.handleTechTextData_(e);
	    });
	    this.on(this.tech_, 'ratechange', function (e) {
	      return _this4.handleTechRateChange_(e);
	    });
	    this.on(this.tech_, 'loadedmetadata', this.boundUpdateStyleEl_);
	    this.usingNativeControls(this.techGet_('controls'));
	
	    if (this.controls() && !this.usingNativeControls()) {
	      this.addTechControlsListeners_();
	    } // Add the tech element in the DOM if it was not already there
	    // Make sure to not insert the original video element if using Html5
	
	
	    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) {
	      prependTo(this.tech_.el(), this.el());
	    } // Get rid of the original video tag reference after the first tech is loaded
	
	
	    if (this.tag) {
	      this.tag.player = null;
	      this.tag = null;
	    }
	  }
	  /**
	   * Unload and dispose of the current playback {@link Tech}.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unloadTech_ = function unloadTech_() {
	    var _this5 = this;
	
	    // Save the current text tracks so that we can reuse the same text tracks with the next tech
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      _this5[props.privateName] = _this5[props.getterName]();
	    });
	    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
	    this.isReady_ = false;
	    this.tech_.dispose();
	    this.tech_ = false;
	
	    if (this.isPosterFromTech_) {
	      this.poster_ = '';
	      this.trigger('posterchange');
	    }
	
	    this.isPosterFromTech_ = false;
	  }
	  /**
	   * Return a reference to the current {@link Tech}.
	   * It will print a warning by default about the danger of using the tech directly
	   * but any argument that is passed in will silence the warning.
	   *
	   * @param {*} [safety]
	   *        Anything passed in to silence the warning
	   *
	   * @return {Tech}
	   *         The Tech
	   */
	  ;
	
	  _proto.tech = function tech(safety) {
	    if (safety === undefined) {
	      log$1.warn('Using the tech directly can be dangerous. I hope you know what you\'re doing.\n' + 'See https://github.com/videojs/video.js/issues/2617 for more info.\n');
	    }
	
	    return this.tech_;
	  }
	  /**
	   * Set up click and touch listeners for the playback element
	   *
	   * - On desktops: a click on the video itself will toggle playback
	   * - On mobile devices: a click on the video toggles controls
	   *   which is done by toggling the user state between active and
	   *   inactive
	   * - A tap can signal that a user has become active or has become inactive
	   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
	   *   quick tap should hide them again (signaling the user is in an inactive
	   *   viewing state)
	   * - In addition to this, we still want the user to be considered inactive after
	   *   a few seconds of inactivity.
	   *
	   * > Note: the only part of iOS interaction we can't mimic with this setup
	   * is a touch and hold on the video element counting as activity in order to
	   * keep the controls showing, but that shouldn't be an issue. A touch and hold
	   * on any controls will still keep the user active
	   *
	   * @private
	   */
	  ;
	
	  _proto.addTechControlsListeners_ = function addTechControlsListeners_() {
	    // Make sure to remove all the previous listeners in case we are called multiple times.
	    this.removeTechControlsListeners_();
	    this.on(this.tech_, 'click', this.boundHandleTechClick_);
	    this.on(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_); // If the controls were hidden we don't want that to change without a tap event
	    // so we'll check if the controls were already showing before reporting user
	    // activity
	
	    this.on(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.on(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.on(this.tech_, 'touchend', this.boundHandleTechTouchEnd_); // The tap listener needs to come after the touchend listener because the tap
	    // listener cancels out any reportedUserActivity when setting userActive(false)
	
	    this.on(this.tech_, 'tap', this.boundHandleTechTap_);
	  }
	  /**
	   * Remove the listeners used for click and tap controls. This is needed for
	   * toggling to controls disabled, where a tap/touch should do nothing.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTechControlsListeners_ = function removeTechControlsListeners_() {
	    // We don't want to just use `this.off()` because there might be other needed
	    // listeners added by techs that extend this.
	    this.off(this.tech_, 'tap', this.boundHandleTechTap_);
	    this.off(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.off(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.off(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
	    this.off(this.tech_, 'click', this.boundHandleTechClick_);
	    this.off(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
	  }
	  /**
	   * Player waits for the tech to be ready
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleTechReady_ = function handleTechReady_() {
	    this.triggerReady(); // Keep the same volume as before
	
	    if (this.cache_.volume) {
	      this.techCall_('setVolume', this.cache_.volume);
	    } // Look if the tech found a higher resolution poster while loading
	
	
	    this.handleTechPosterChange_(); // Update the duration if available
	
	    this.handleTechDurationChange_();
	  }
	  /**
	   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
	   * function will also trigger {@link Player#firstplay} if it is the first loadstart
	   * for a video.
	   *
	   * @fires Player#loadstart
	   * @fires Player#firstplay
	   * @listens Tech#loadstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechLoadStart_ = function handleTechLoadStart_() {
	    // TODO: Update to use `emptied` event instead. See #1277.
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-seeking'); // reset the error state
	
	    this.error(null); // Update the duration
	
	    this.handleTechDurationChange_(); // If it's already playing we want to trigger a firstplay event now.
	    // The firstplay event relies on both the play and loadstart events
	    // which can happen in any order for a new source
	
	    if (!this.paused()) {
	      /**
	       * Fired when the user agent begins looking for media data
	       *
	       * @event Player#loadstart
	       * @type {EventTarget~Event}
	       */
	      this.trigger('loadstart');
	      this.trigger('firstplay');
	    } else {
	      // reset the hasStarted state
	      this.hasStarted(false);
	      this.trigger('loadstart');
	    } // autoplay happens after loadstart for the browser,
	    // so we mimic that behavior
	
	
	    this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? 'play' : this.autoplay());
	  }
	  /**
	   * Handle autoplay string values, rather than the typical boolean
	   * values that should be handled by the tech. Note that this is not
	   * part of any specification. Valid values and what they do can be
	   * found on the autoplay getter at Player#autoplay()
	   */
	  ;
	
	  _proto.manualAutoplay_ = function manualAutoplay_(type) {
	    var _this6 = this;
	
	    if (!this.tech_ || typeof type !== 'string') {
	      return;
	    } // Save original muted() value, set muted to true, and attempt to play().
	    // On promise rejection, restore muted from saved value
	
	
	    var resolveMuted = function resolveMuted() {
	      var previouslyMuted = _this6.muted();
	
	      _this6.muted(true);
	
	      var restoreMuted = function restoreMuted() {
	        _this6.muted(previouslyMuted);
	      }; // restore muted on play terminatation
	
	
	      _this6.playTerminatedQueue_.push(restoreMuted);
	
	      var mutedPromise = _this6.play();
	
	      if (!isPromise(mutedPromise)) {
	        return;
	      }
	
	      return mutedPromise["catch"](function (err) {
	        restoreMuted();
	        throw new Error("Rejection at manualAutoplay. Restoring muted value. " + (err ? err : ''));
	      });
	    };
	
	    var promise; // if muted defaults to true
	    // the only thing we can do is call play
	
	    if (type === 'any' && !this.muted()) {
	      promise = this.play();
	
	      if (isPromise(promise)) {
	        promise = promise["catch"](resolveMuted);
	      }
	    } else if (type === 'muted' && !this.muted()) {
	      promise = resolveMuted();
	    } else {
	      promise = this.play();
	    }
	
	    if (!isPromise(promise)) {
	      return;
	    }
	
	    return promise.then(function () {
	      _this6.trigger({
	        type: 'autoplay-success',
	        autoplay: type
	      });
	    })["catch"](function () {
	      _this6.trigger({
	        type: 'autoplay-failure',
	        autoplay: type
	      });
	    });
	  }
	  /**
	   * Update the internal source caches so that we return the correct source from
	   * `src()`, `currentSource()`, and `currentSources()`.
	   *
	   * > Note: `currentSources` will not be updated if the source that is passed in exists
	   *         in the current `currentSources` cache.
	   *
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        A string or object source to update our caches to.
	   */
	  ;
	
	  _proto.updateSourceCaches_ = function updateSourceCaches_(srcObj) {
	    if (srcObj === void 0) {
	      srcObj = '';
	    }
	
	    var src = srcObj;
	    var type = '';
	
	    if (typeof src !== 'string') {
	      src = srcObj.src;
	      type = srcObj.type;
	    } // make sure all the caches are set to default values
	    // to prevent null checking
	
	
	    this.cache_.source = this.cache_.source || {};
	    this.cache_.sources = this.cache_.sources || []; // try to get the type of the src that was passed in
	
	    if (src && !type) {
	      type = findMimetype(this, src);
	    } // update `currentSource` cache always
	
	
	    this.cache_.source = mergeOptions$3({}, srcObj, {
	      src: src,
	      type: type
	    });
	    var matchingSources = this.cache_.sources.filter(function (s) {
	      return s.src && s.src === src;
	    });
	    var sourceElSources = [];
	    var sourceEls = this.$$('source');
	    var matchingSourceEls = [];
	
	    for (var i = 0; i < sourceEls.length; i++) {
	      var sourceObj = getAttributes(sourceEls[i]);
	      sourceElSources.push(sourceObj);
	
	      if (sourceObj.src && sourceObj.src === src) {
	        matchingSourceEls.push(sourceObj.src);
	      }
	    } // if we have matching source els but not matching sources
	    // the current source cache is not up to date
	
	
	    if (matchingSourceEls.length && !matchingSources.length) {
	      this.cache_.sources = sourceElSources; // if we don't have matching source or source els set the
	      // sources cache to the `currentSource` cache
	    } else if (!matchingSources.length) {
	      this.cache_.sources = [this.cache_.source];
	    } // update the tech `src` cache
	
	
	    this.cache_.src = src;
	  }
	  /**
	   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
	   * causing the media element to reload.
	   *
	   * It will fire for the initial source and each subsequent source.
	   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
	   *
	   * The event object for this event contains a `src` property that will contain the source
	   * that was available when the event was triggered. This is generally only necessary if Video.js
	   * is switching techs while the source was being changed.
	   *
	   * It is also fired when `load` is called on the player (or media element)
	   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
	   * says that the resource selection algorithm needs to be aborted and restarted.
	   * In this case, it is very likely that the `src` property will be set to the
	   * empty string `""` to indicate we do not know what the source will be but
	   * that it is changing.
	   *
	   * *This event is currently still experimental and may change in minor releases.*
	   * __To use this, pass `enableSourceset` option to the player.__
	   *
	   * @event Player#sourceset
	   * @type {EventTarget~Event}
	   * @prop {string} src
	   *                The source url available when the `sourceset` was triggered.
	   *                It will be an empty string if we cannot know what the source is
	   *                but know that the source will change.
	   */
	
	  /**
	   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#sourceset
	   * @listens Tech#sourceset
	   * @private
	   */
	  ;
	
	  _proto.handleTechSourceset_ = function handleTechSourceset_(event) {
	    var _this7 = this;
	
	    // only update the source cache when the source
	    // was not updated using the player api
	    if (!this.changingSrc_) {
	      var updateSourceCaches = function updateSourceCaches(src) {
	        return _this7.updateSourceCaches_(src);
	      };
	
	      var playerSrc = this.currentSource().src;
	      var eventSrc = event.src; // if we have a playerSrc that is not a blob, and a tech src that is a blob
	
	      if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
	        // if both the tech source and the player source were updated we assume
	        // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
	        if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) {
	          updateSourceCaches = function updateSourceCaches() {};
	        }
	      } // update the source to the initial source right away
	      // in some cases this will be empty string
	
	
	      updateSourceCaches(eventSrc); // if the `sourceset` `src` was an empty string
	      // wait for a `loadstart` to update the cache to `currentSrc`.
	      // If a sourceset happens before a `loadstart`, we reset the state
	
	      if (!event.src) {
	        this.tech_.any(['sourceset', 'loadstart'], function (e) {
	          // if a sourceset happens before a `loadstart` there
	          // is nothing to do as this `handleTechSourceset_`
	          // will be called again and this will be handled there.
	          if (e.type === 'sourceset') {
	            return;
	          }
	
	          var techSrc = _this7.techGet('currentSrc');
	
	          _this7.lastSource_.tech = techSrc;
	
	          _this7.updateSourceCaches_(techSrc);
	        });
	      }
	    }
	
	    this.lastSource_ = {
	      player: this.currentSource().src,
	      tech: event.src
	    };
	    this.trigger({
	      src: event.src,
	      type: 'sourceset'
	    });
	  }
	  /**
	   * Add/remove the vjs-has-started class
	   *
	   * @fires Player#firstplay
	   *
	   * @param {boolean} request
	   *        - true: adds the class
	   *        - false: remove the class
	   *
	   * @return {boolean}
	   *         the boolean value of hasStarted_
	   */
	  ;
	
	  _proto.hasStarted = function hasStarted(request) {
	    if (request === undefined) {
	      // act as getter, if we have no request to change
	      return this.hasStarted_;
	    }
	
	    if (request === this.hasStarted_) {
	      return;
	    }
	
	    this.hasStarted_ = request;
	
	    if (this.hasStarted_) {
	      this.addClass('vjs-has-started');
	      this.trigger('firstplay');
	    } else {
	      this.removeClass('vjs-has-started');
	    }
	  }
	  /**
	   * Fired whenever the media begins or resumes playback
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
	   * @fires Player#play
	   * @listens Tech#play
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlay_ = function handleTechPlay_() {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // hide the poster when the user hits play
	
	    this.hasStarted(true);
	    /**
	     * Triggered whenever an {@link Tech#play} event happens. Indicates that
	     * playback has started or resumed.
	     *
	     * @event Player#play
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('play');
	  }
	  /**
	   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
	   *
	   * If there were any events queued while the playback rate was zero, fire
	   * those events now.
	   *
	   * @private
	   * @method Player#handleTechRateChange_
	   * @fires Player#ratechange
	   * @listens Tech#ratechange
	   */
	  ;
	
	  _proto.handleTechRateChange_ = function handleTechRateChange_() {
	    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
	      this.queuedCallbacks_.forEach(function (queued) {
	        return queued.callback(queued.event);
	      });
	      this.queuedCallbacks_ = [];
	    }
	
	    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     *
	     * @event Player#ratechange
	     * @type {event}
	     */
	
	    this.trigger('ratechange');
	  }
	  /**
	   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#waiting
	   * @listens Tech#waiting
	   * @private
	   */
	  ;
	
	  _proto.handleTechWaiting_ = function handleTechWaiting_() {
	    var _this8 = this;
	
	    this.addClass('vjs-waiting');
	    /**
	     * A readyState change on the DOM element has caused playback to stop.
	     *
	     * @event Player#waiting
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('waiting'); // Browsers may emit a timeupdate event after a waiting event. In order to prevent
	    // premature removal of the waiting class, wait for the time to change.
	
	    var timeWhenWaiting = this.currentTime();
	
	    var timeUpdateListener = function timeUpdateListener() {
	      if (timeWhenWaiting !== _this8.currentTime()) {
	        _this8.removeClass('vjs-waiting');
	
	        _this8.off('timeupdate', timeUpdateListener);
	      }
	    };
	
	    this.on('timeupdate', timeUpdateListener);
	  }
	  /**
	   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
	   * > Note: This is not consistent between browsers. See #1351
	   *
	   * @fires Player#canplay
	   * @listens Tech#canplay
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlay_ = function handleTechCanPlay_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_FUTURE_DATA or greater.
	     *
	     * @event Player#canplay
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplay');
	  }
	  /**
	   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#canplaythrough
	   * @listens Tech#canplaythrough
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
	     * entire media file can be played without buffering.
	     *
	     * @event Player#canplaythrough
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplaythrough');
	  }
	  /**
	   * Retrigger the `playing` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#playing
	   * @listens Tech#playing
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlaying_ = function handleTechPlaying_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media is no longer blocked from playback, and has started playing.
	     *
	     * @event Player#playing
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('playing');
	  }
	  /**
	   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeking
	   * @listens Tech#seeking
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeking_ = function handleTechSeeking_() {
	    this.addClass('vjs-seeking');
	    /**
	     * Fired whenever the player is jumping to a new time
	     *
	     * @event Player#seeking
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeking');
	  }
	  /**
	   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeked
	   * @listens Tech#seeked
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeked_ = function handleTechSeeked_() {
	    this.removeClass('vjs-seeking');
	    this.removeClass('vjs-ended');
	    /**
	     * Fired when the player has finished jumping to a new time
	     *
	     * @event Player#seeked
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeked');
	  }
	  /**
	   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#firstplay
	   * @listens Tech#firstplay
	   * @deprecated As of 6.0 firstplay event is deprecated.
	   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
	   * @private
	   */
	  ;
	
	  _proto.handleTechFirstPlay_ = function handleTechFirstPlay_() {
	    // If the first starttime attribute is specified
	    // then we will start at the given offset in seconds
	    if (this.options_.starttime) {
	      log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
	      this.currentTime(this.options_.starttime);
	    }
	
	    this.addClass('vjs-has-started');
	    /**
	     * Fired the first time a video is played. Not part of the HLS spec, and this is
	     * probably not the best implementation yet, so use sparingly. If you don't have a
	     * reason to prevent playback, use `myPlayer.one('play');` instead.
	     *
	     * @event Player#firstplay
	     * @deprecated As of 6.0 firstplay event is deprecated.
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('firstplay');
	  }
	  /**
	   * Retrigger the `pause` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#pause
	   * @listens Tech#pause
	   * @private
	   */
	  ;
	
	  _proto.handleTechPause_ = function handleTechPause_() {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    /**
	     * Fired whenever the media has been paused
	     *
	     * @event Player#pause
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('pause');
	  }
	  /**
	   * Retrigger the `ended` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#ended
	   * @listens Tech#ended
	   * @private
	   */
	  ;
	
	  _proto.handleTechEnded_ = function handleTechEnded_() {
	    this.addClass('vjs-ended');
	    this.removeClass('vjs-waiting');
	
	    if (this.options_.loop) {
	      this.currentTime(0);
	      this.play();
	    } else if (!this.paused()) {
	      this.pause();
	    }
	    /**
	     * Fired when the end of the media resource is reached (currentTime == duration)
	     *
	     * @event Player#ended
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('ended');
	  }
	  /**
	   * Fired when the duration of the media resource is first known or changed
	   *
	   * @listens Tech#durationchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechDurationChange_ = function handleTechDurationChange_() {
	    this.duration(this.techGet_('duration'));
	  }
	  /**
	   * Handle a click on the media element to play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#click
	   * @private
	   */
	  ;
	
	  _proto.handleTechClick_ = function handleTechClick_(event) {
	    // When controls are disabled a click should not toggle playback because
	    // the click is considered a control
	    if (!this.controls_) {
	      return;
	    }
	
	    if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
	      if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === 'function') {
	        this.options_.userActions.click.call(this, event);
	      } else if (this.paused()) {
	        silencePromise(this.play());
	      } else {
	        this.pause();
	      }
	    }
	  }
	  /**
	   * Handle a double-click on the media element to enter/exit fullscreen
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#dblclick
	   * @private
	   */
	  ;
	
	  _proto.handleTechDoubleClick_ = function handleTechDoubleClick_(event) {
	    if (!this.controls_) {
	      return;
	    } // we do not want to toggle fullscreen state
	    // when double-clicking inside a control bar or a modal
	
	
	    var inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), function (el) {
	      return el.contains(event.target);
	    });
	
	    if (!inAllowedEls) {
	      /*
	       * options.userActions.doubleClick
	       *
	       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
	       * Set to `false` to disable double-click handling
	       * Set to a function to substitute an external double-click handler
	       */
	      if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
	        if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === 'function') {
	          this.options_.userActions.doubleClick.call(this, event);
	        } else if (this.isFullscreen()) {
	          this.exitFullscreen();
	        } else {
	          this.requestFullscreen();
	        }
	      }
	    }
	  }
	  /**
	   * Handle a tap on the media element. It will toggle the user
	   * activity state, which hides and shows the controls.
	   *
	   * @listens Tech#tap
	   * @private
	   */
	  ;
	
	  _proto.handleTechTap_ = function handleTechTap_() {
	    this.userActive(!this.userActive());
	  }
	  /**
	   * Handle touch to start
	   *
	   * @listens Tech#touchstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchStart_ = function handleTechTouchStart_() {
	    this.userWasActive = this.userActive();
	  }
	  /**
	   * Handle touch to move
	   *
	   * @listens Tech#touchmove
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchMove_ = function handleTechTouchMove_() {
	    if (this.userWasActive) {
	      this.reportUserActivity();
	    }
	  }
	  /**
	   * Handle touch to end
	   *
	   * @param {EventTarget~Event} event
	   *        the touchend event that triggered
	   *        this function
	   *
	   * @listens Tech#touchend
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
	    // Stop the mouse events from also happening
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	  }
	  /**
	   * native click events on the SWF aren't triggered on IE11, Win8.1RT
	   * use stageclick events triggered from inside the SWF instead
	   *
	   * @private
	   * @listens stageclick
	   */
	  ;
	
	  _proto.handleStageClick_ = function handleStageClick_() {
	    this.reportUserActivity();
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.toggleFullscreenClass_ = function toggleFullscreenClass_() {
	    if (this.isFullscreen()) {
	      this.addClass('vjs-fullscreen');
	    } else {
	      this.removeClass('vjs-fullscreen');
	    }
	  }
	  /**
	   * when the document fschange event triggers it calls this
	   */
	  ;
	
	  _proto.documentFullscreenChange_ = function documentFullscreenChange_(e) {
	    var targetPlayer = e.target.player; // if another player was fullscreen
	    // do a null check for targetPlayer because older firefox's would put document as e.target
	
	    if (targetPlayer && targetPlayer !== this) {
	      return;
	    }
	
	    var el = this.el();
	    var isFs = document__default['default'][this.fsApi_.fullscreenElement] === el;
	
	    if (!isFs && el.matches) {
	      isFs = el.matches(':' + this.fsApi_.fullscreen);
	    } else if (!isFs && el.msMatchesSelector) {
	      isFs = el.msMatchesSelector(':' + this.fsApi_.fullscreen);
	    }
	
	    this.isFullscreen(isFs);
	  }
	  /**
	   * Handle Tech Fullscreen Change
	   *
	   * @param {EventTarget~Event} event
	   *        the fullscreenchange event that triggered this function
	   *
	   * @param {Object} data
	   *        the data that was sent with the event
	   *
	   * @private
	   * @listens Tech#fullscreenchange
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
	    var _this9 = this;
	
	    if (data) {
	      if (data.nativeIOSFullscreen) {
	        this.addClass('vjs-ios-native-fs');
	        this.tech_.one('webkitendfullscreen', function () {
	          _this9.removeClass('vjs-ios-native-fs');
	        });
	      }
	
	      this.isFullscreen(data.isFullscreen);
	    }
	  };
	
	  _proto.handleTechFullscreenError_ = function handleTechFullscreenError_(event, err) {
	    this.trigger('fullscreenerror', err);
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.togglePictureInPictureClass_ = function togglePictureInPictureClass_() {
	    if (this.isInPictureInPicture()) {
	      this.addClass('vjs-picture-in-picture');
	    } else {
	      this.removeClass('vjs-picture-in-picture');
	    }
	  }
	  /**
	   * Handle Tech Enter Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the enterpictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#enterpictureinpicture
	   */
	  ;
	
	  _proto.handleTechEnterPictureInPicture_ = function handleTechEnterPictureInPicture_(event) {
	    this.isInPictureInPicture(true);
	  }
	  /**
	   * Handle Tech Leave Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the leavepictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#leavepictureinpicture
	   */
	  ;
	
	  _proto.handleTechLeavePictureInPicture_ = function handleTechLeavePictureInPicture_(event) {
	    this.isInPictureInPicture(false);
	  }
	  /**
	   * Fires when an error occurred during the loading of an audio/video.
	   *
	   * @private
	   * @listens Tech#error
	   */
	  ;
	
	  _proto.handleTechError_ = function handleTechError_() {
	    var error = this.tech_.error();
	    this.error(error);
	  }
	  /**
	   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#textdata
	   * @listens Tech#textdata
	   * @private
	   */
	  ;
	
	  _proto.handleTechTextData_ = function handleTechTextData_() {
	    var data = null;
	
	    if (arguments.length > 1) {
	      data = arguments[1];
	    }
	    /**
	     * Fires when we get a textdata event from tech
	     *
	     * @event Player#textdata
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('textdata', data);
	  }
	  /**
	   * Get object for cached values.
	   *
	   * @return {Object}
	   *         get the current object cache
	   */
	  ;
	
	  _proto.getCache = function getCache() {
	    return this.cache_;
	  }
	  /**
	   * Resets the internal cache object.
	   *
	   * Using this function outside the player constructor or reset method may
	   * have unintended side-effects.
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetCache_ = function resetCache_() {
	    this.cache_ = {
	      // Right now, the currentTime is not _really_ cached because it is always
	      // retrieved from the tech (see: currentTime). However, for completeness,
	      // we set it to zero here to ensure that if we do start actually caching
	      // it, we reset it along with everything else.
	      currentTime: 0,
	      initTime: 0,
	      inactivityTimeout: this.options_.inactivityTimeout,
	      duration: NaN,
	      lastVolume: 1,
	      lastPlaybackRate: this.defaultPlaybackRate(),
	      media: null,
	      src: '',
	      source: {},
	      sources: [],
	      playbackRates: [],
	      volume: 1
	    };
	  }
	  /**
	   * Pass values to the playback tech
	   *
	   * @param {string} [method]
	   *        the method to call
	   *
	   * @param {Object} arg
	   *        the argument to pass
	   *
	   * @private
	   */
	  ;
	
	  _proto.techCall_ = function techCall_(method, arg) {
	    // If it's not ready yet, call method when it is
	    this.ready(function () {
	      if (method in allowedSetters) {
	        return set(this.middleware_, this.tech_, method, arg);
	      } else if (method in allowedMediators) {
	        return mediate(this.middleware_, this.tech_, method, arg);
	      }
	
	      try {
	        if (this.tech_) {
	          this.tech_[method](arg);
	        }
	      } catch (e) {
	        log$1(e);
	        throw e;
	      }
	    }, true);
	  }
	  /**
	   * Get calls can't wait for the tech, and sometimes don't need to.
	   *
	   * @param {string} method
	   *        Tech method
	   *
	   * @return {Function|undefined}
	   *         the method or undefined
	   *
	   * @private
	   */
	  ;
	
	  _proto.techGet_ = function techGet_(method) {
	    if (!this.tech_ || !this.tech_.isReady_) {
	      return;
	    }
	
	    if (method in allowedGetters) {
	      return get(this.middleware_, this.tech_, method);
	    } else if (method in allowedMediators) {
	      return mediate(this.middleware_, this.tech_, method);
	    } // Flash likes to die and reload when you hide or reposition it.
	    // In these cases the object methods go away and we get errors.
	    // TODO: Is this needed for techs other than Flash?
	    // When that happens we'll catch the errors and inform tech that it's not ready any more.
	
	
	    try {
	      return this.tech_[method]();
	    } catch (e) {
	      // When building additional tech libs, an expected method may not be defined yet
	      if (this.tech_[method] === undefined) {
	        log$1("Video.js: " + method + " method not defined for " + this.techName_ + " playback technology.", e);
	        throw e;
	      } // When a method isn't available on the object it throws a TypeError
	
	
	      if (e.name === 'TypeError') {
	        log$1("Video.js: " + method + " unavailable on " + this.techName_ + " playback technology element.", e);
	        this.tech_.isReady_ = false;
	        throw e;
	      } // If error unknown, just log and throw
	
	
	      log$1(e);
	      throw e;
	    }
	  }
	  /**
	   * Attempt to begin playback at the first opportunity.
	   *
	   * @return {Promise|undefined}
	   *         Returns a promise if the browser supports Promises (or one
	   *         was passed in as an option). This promise will be resolved on
	   *         the return value of play. If this is undefined it will fulfill the
	   *         promise chain otherwise the promise chain will be fulfilled when
	   *         the promise from play is fulfilled.
	   */
	  ;
	
	  _proto.play = function play() {
	    var _this10 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return new PromiseClass(function (resolve) {
	        _this10.play_(resolve);
	      });
	    }
	
	    return this.play_();
	  }
	  /**
	   * The actual logic for play, takes a callback that will be resolved on the
	   * return value of play. This allows us to resolve to the play promise if there
	   * is one on modern browsers.
	   *
	   * @private
	   * @param {Function} [callback]
	   *        The callback that should be called when the techs play is actually called
	   */
	  ;
	
	  _proto.play_ = function play_(callback) {
	    var _this11 = this;
	
	    if (callback === void 0) {
	      callback = silencePromise;
	    }
	
	    this.playCallbacks_.push(callback);
	    var isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
	    var isSafariOrIOS = Boolean(IS_ANY_SAFARI || IS_IOS); // treat calls to play_ somewhat like the `one` event function
	
	    if (this.waitToPlay_) {
	      this.off(['ready', 'loadstart'], this.waitToPlay_);
	      this.waitToPlay_ = null;
	    } // if the player/tech is not ready or the src itself is not ready
	    // queue up a call to play on `ready` or `loadstart`
	
	
	    if (!this.isReady_ || !isSrcReady) {
	      this.waitToPlay_ = function (e) {
	        _this11.play_();
	      };
	
	      this.one(['ready', 'loadstart'], this.waitToPlay_); // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
	      // in that case, we need to prime the video element by calling load so it'll be ready in time
	
	      if (!isSrcReady && isSafariOrIOS) {
	        this.load();
	      }
	
	      return;
	    } // If the player/tech is ready and we have a source, we can attempt playback.
	
	
	    var val = this.techGet_('play'); // For native playback, reset the progress bar if we get a play call from a replay.
	
	    var isNativeReplay = isSafariOrIOS && this.hasClass('vjs-ended');
	
	    if (isNativeReplay) {
	      this.resetProgressBar_();
	    } // play was terminated if the returned value is null
	
	
	    if (val === null) {
	      this.runPlayTerminatedQueue_();
	    } else {
	      this.runPlayCallbacks_(val);
	    }
	  }
	  /**
	   * These functions will be run when if play is terminated. If play
	   * runPlayCallbacks_ is run these function will not be run. This allows us
	   * to differenciate between a terminated play and an actual call to play.
	   */
	  ;
	
	  _proto.runPlayTerminatedQueue_ = function runPlayTerminatedQueue_() {
	    var queue = this.playTerminatedQueue_.slice(0);
	    this.playTerminatedQueue_ = [];
	    queue.forEach(function (q) {
	      q();
	    });
	  }
	  /**
	   * When a callback to play is delayed we have to run these
	   * callbacks when play is actually called on the tech. This function
	   * runs the callbacks that were delayed and accepts the return value
	   * from the tech.
	   *
	   * @param {undefined|Promise} val
	   *        The return value from the tech.
	   */
	  ;
	
	  _proto.runPlayCallbacks_ = function runPlayCallbacks_(val) {
	    var callbacks = this.playCallbacks_.slice(0);
	    this.playCallbacks_ = []; // clear play terminatedQueue since we finished a real play
	
	    this.playTerminatedQueue_ = [];
	    callbacks.forEach(function (cb) {
	      cb(val);
	    });
	  }
	  /**
	   * Pause the video playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	  ;
	
	  _proto.pause = function pause() {
	    this.techCall_('pause');
	  }
	  /**
	   * Check if the player is paused or has yet to play
	   *
	   * @return {boolean}
	   *         - false: if the media is currently playing
	   *         - true: if media is not currently playing
	   */
	  ;
	
	  _proto.paused = function paused() {
	    // The initial state of paused should be true (in Safari it's actually false)
	    return this.techGet_('paused') === false ? false : true;
	  }
	  /**
	   * Get a TimeRange object representing the current ranges of time that the user
	   * has played.
	   *
	   * @return {TimeRange}
	   *         A time range object that represents all the increments of time that have
	   *         been played.
	   */
	  ;
	
	  _proto.played = function played() {
	    return this.techGet_('played') || createTimeRanges(0, 0);
	  }
	  /**
	   * Returns whether or not the user is "scrubbing". Scrubbing is
	   * when the user has clicked the progress bar handle and is
	   * dragging it along the progress bar.
	   *
	   * @param {boolean} [isScrubbing]
	   *        whether the user is or is not scrubbing
	   *
	   * @return {boolean}
	   *         The value of scrubbing when getting
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing(isScrubbing) {
	    if (typeof isScrubbing === 'undefined') {
	      return this.scrubbing_;
	    }
	
	    this.scrubbing_ = !!isScrubbing;
	    this.techCall_('setScrubbing', this.scrubbing_);
	
	    if (isScrubbing) {
	      this.addClass('vjs-scrubbing');
	    } else {
	      this.removeClass('vjs-scrubbing');
	    }
	  }
	  /**
	   * Get or set the current time (in seconds)
	   *
	   * @param {number|string} [seconds]
	   *        The time to seek to in seconds
	   *
	   * @return {number}
	   *         - the current time in seconds when getting
	   */
	  ;
	
	  _proto.currentTime = function currentTime(seconds) {
	    if (typeof seconds !== 'undefined') {
	      if (seconds < 0) {
	        seconds = 0;
	      }
	
	      if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
	        this.cache_.initTime = seconds;
	        this.off('canplay', this.boundApplyInitTime_);
	        this.one('canplay', this.boundApplyInitTime_);
	        return;
	      }
	
	      this.techCall_('setCurrentTime', seconds);
	      this.cache_.initTime = 0;
	      return;
	    } // cache last currentTime and return. default to 0 seconds
	    //
	    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
	    // currentTime when scrubbing, but may not provide much performance benefit afterall.
	    // Should be tested. Also something has to read the actual current time or the cache will
	    // never get updated.
	
	
	    this.cache_.currentTime = this.techGet_('currentTime') || 0;
	    return this.cache_.currentTime;
	  }
	  /**
	   * Apply the value of initTime stored in cache as currentTime.
	   *
	   * @private
	   */
	  ;
	
	  _proto.applyInitTime_ = function applyInitTime_() {
	    this.currentTime(this.cache_.initTime);
	  }
	  /**
	   * Normally gets the length in time of the video in seconds;
	   * in all but the rarest use cases an argument will NOT be passed to the method
	   *
	   * > **NOTE**: The video must have started loading before the duration can be
	   * known, and depending on preload behaviour may not be known until the video starts
	   * playing.
	   *
	   * @fires Player#durationchange
	   *
	   * @param {number} [seconds]
	   *        The duration of the video to set in seconds
	   *
	   * @return {number}
	   *         - The duration of the video in seconds when getting
	   */
	  ;
	
	  _proto.duration = function duration(seconds) {
	    if (seconds === undefined) {
	      // return NaN if the duration is not known
	      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
	    }
	
	    seconds = parseFloat(seconds); // Standardize on Infinity for signaling video is live
	
	    if (seconds < 0) {
	      seconds = Infinity;
	    }
	
	    if (seconds !== this.cache_.duration) {
	      // Cache the last set value for optimized scrubbing (esp. Flash)
	      // TODO: Required for techs other than Flash?
	      this.cache_.duration = seconds;
	
	      if (seconds === Infinity) {
	        this.addClass('vjs-live');
	      } else {
	        this.removeClass('vjs-live');
	      }
	
	      if (!isNaN(seconds)) {
	        // Do not fire durationchange unless the duration value is known.
	        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	        /**
	         * @event Player#durationchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('durationchange');
	      }
	    }
	  }
	  /**
	   * Calculates how much time is left in the video. Not part
	   * of the native video API.
	   *
	   * @return {number}
	   *         The time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTime = function remainingTime() {
	    return this.duration() - this.currentTime();
	  }
	  /**
	   * A remaining time function that is intented to be used when
	   * the time is to be displayed directly to the user.
	   *
	   * @return {number}
	   *         The rounded time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTimeDisplay = function remainingTimeDisplay() {
	    return Math.floor(this.duration()) - Math.floor(this.currentTime());
	  } //
	  // Kind of like an array of portions of the video that have been downloaded.
	
	  /**
	   * Get a TimeRange object with an array of the times of the video
	   * that have been downloaded. If you just want the percent of the
	   * video that's been downloaded, use bufferedPercent.
	   *
	   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
	   *
	   * @return {TimeRange}
	   *         A mock TimeRange object (following HTML spec)
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var buffered = this.techGet_('buffered');
	
	    if (!buffered || !buffered.length) {
	      buffered = createTimeRanges(0, 0);
	    }
	
	    return buffered;
	  }
	  /**
	   * Get the percent (as a decimal) of the video that's been downloaded.
	   * This method is not a part of the native HTML video API.
	   *
	   * @return {number}
	   *         A decimal between 0 and 1 representing the percent
	   *         that is buffered 0 being 0% and 1 being 100%
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration());
	  }
	  /**
	   * Get the ending time of the last buffered time range
	   * This is used in the progress bar to encapsulate all time ranges.
	   *
	   * @return {number}
	   *         The end of the last buffered time range
	   */
	  ;
	
	  _proto.bufferedEnd = function bufferedEnd() {
	    var buffered = this.buffered();
	    var duration = this.duration();
	    var end = buffered.end(buffered.length - 1);
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    return end;
	  }
	  /**
	   * Get or set the current volume of the media
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         The current volume as a percent when getting
	   */
	  ;
	
	  _proto.volume = function volume(percentAsDecimal) {
	    var vol;
	
	    if (percentAsDecimal !== undefined) {
	      // Force value to between 0 and 1
	      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
	      this.cache_.volume = vol;
	      this.techCall_('setVolume', vol);
	
	      if (vol > 0) {
	        this.lastVolume_(vol);
	      }
	
	      return;
	    } // Default to 1 when returning current volume.
	
	
	    vol = parseFloat(this.techGet_('volume'));
	    return isNaN(vol) ? 1 : vol;
	  }
	  /**
	   * Get the current muted state, or turn mute on or off
	   *
	   * @param {boolean} [muted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean}
	   *         - true if mute is on and getting
	   *         - false if mute is off and getting
	   */
	  ;
	
	  _proto.muted = function muted(_muted) {
	    if (_muted !== undefined) {
	      this.techCall_('setMuted', _muted);
	      return;
	    }
	
	    return this.techGet_('muted') || false;
	  }
	  /**
	   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
	   * indicates the state of muted on initial playback.
	   *
	   * ```js
	   *   var myPlayer = videojs('some-player-id');
	   *
	   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
	   *
	   *   // get, should be false
	   *   console.log(myPlayer.defaultMuted());
	   *   // set to true
	   *   myPlayer.defaultMuted(true);
	   *   // get should be true
	   *   console.log(myPlayer.defaultMuted());
	   * ```
	   *
	   * @param {boolean} [defaultMuted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean|Player}
	   *         - true if defaultMuted is on and getting
	   *         - false if defaultMuted is off and getting
	   *         - A reference to the current player when setting
	   */
	  ;
	
	  _proto.defaultMuted = function defaultMuted(_defaultMuted) {
	    if (_defaultMuted !== undefined) {
	      return this.techCall_('setDefaultMuted', _defaultMuted);
	    }
	
	    return this.techGet_('defaultMuted') || false;
	  }
	  /**
	   * Get the last volume, or set it
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new last volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         the current value of lastVolume as a percent when getting
	   *
	   * @private
	   */
	  ;
	
	  _proto.lastVolume_ = function lastVolume_(percentAsDecimal) {
	    if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
	      this.cache_.lastVolume = percentAsDecimal;
	      return;
	    }
	
	    return this.cache_.lastVolume;
	  }
	  /**
	   * Check if current tech can support native fullscreen
	   * (e.g. with built in controls like iOS)
	   *
	   * @return {boolean}
	   *         if native fullscreen is supported
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    return this.techGet_('supportsFullScreen') || false;
	  }
	  /**
	   * Check if the player is in fullscreen mode or tell the player that it
	   * is or is not in fullscreen mode.
	   *
	   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
	   * property and instead document.fullscreenElement is used. But isFullscreen is
	   * still a valuable property for internal player workings.
	   *
	   * @param  {boolean} [isFS]
	   *         Set the players current fullscreen state
	   *
	   * @return {boolean}
	   *         - true if fullscreen is on and getting
	   *         - false if fullscreen is off and getting
	   */
	  ;
	
	  _proto.isFullscreen = function isFullscreen(isFS) {
	    if (isFS !== undefined) {
	      var oldValue = this.isFullscreen_;
	      this.isFullscreen_ = Boolean(isFS); // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
	      // this is the only place where we trigger fullscreenchange events for older browsers
	      // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
	
	      if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) {
	        /**
	           * @event Player#fullscreenchange
	           * @type {EventTarget~Event}
	           */
	        this.trigger('fullscreenchange');
	      }
	
	      this.toggleFullscreenClass_();
	      return;
	    }
	
	    return this.isFullscreen_;
	  }
	  /**
	   * Increase the size of the video to full screen
	   * In some browsers, full screen is not supported natively, so it enters
	   * "full window mode", where the video fills the browser window.
	   * In browsers and devices that support native full screen, sometimes the
	   * browser's default controls will be shown, and not the Video.js custom skin.
	   * This includes most mobile devices (iOS, Android) and older versions of
	   * Safari.
	   *
	   * @param  {Object} [fullscreenOptions]
	   *         Override the player fullscreen options
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.requestFullscreen = function requestFullscreen(fullscreenOptions) {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.requestFullscreenHelper_(fullscreenOptions);
	
	        if (promise) {
	          promise.then(offHandler, offHandler);
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.requestFullscreenHelper_();
	  };
	
	  _proto.requestFullscreenHelper_ = function requestFullscreenHelper_(fullscreenOptions) {
	    var _this12 = this;
	
	    var fsOptions; // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
	    // Use defaults or player configured option unless passed directly to this method.
	
	    if (!this.fsApi_.prefixed) {
	      fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
	
	      if (fullscreenOptions !== undefined) {
	        fsOptions = fullscreenOptions;
	      }
	    } // This method works as follows:
	    // 1. if a fullscreen api is available, use it
	    //   1. call requestFullscreen with potential options
	    //   2. if we got a promise from above, use it to update isFullscreen()
	    // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
	    //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
	    // 3. otherwise, use "fullWindow" mode
	
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
	
	      if (promise) {
	        promise.then(function () {
	          return _this12.isFullscreen(true);
	        }, function () {
	          return _this12.isFullscreen(false);
	        });
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      // we can't take the video.js controls fullscreen but we can go fullscreen
	      // with native controls
	      this.techCall_('enterFullScreen');
	    } else {
	      // fullscreen isn't supported so we'll just stretch the video element to
	      // fill the viewport
	      this.enterFullWindow();
	    }
	  }
	  /**
	   * Return the video to its normal size after having been in full screen mode
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.exitFullscreen = function exitFullscreen() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.exitFullscreenHelper_();
	
	        if (promise) {
	          promise.then(offHandler, offHandler); // map the promise to our resolve/reject methods
	
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.exitFullscreenHelper_();
	  };
	
	  _proto.exitFullscreenHelper_ = function exitFullscreenHelper_() {
	    var _this13 = this;
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = document__default['default'][this.fsApi_.exitFullscreen]();
	
	      if (promise) {
	        // we're splitting the promise here, so, we want to catch the
	        // potential error so that this chain doesn't have unhandled errors
	        silencePromise(promise.then(function () {
	          return _this13.isFullscreen(false);
	        }));
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      this.techCall_('exitFullScreen');
	    } else {
	      this.exitFullWindow();
	    }
	  }
	  /**
	   * When fullscreen isn't supported we can stretch the
	   * video container to as wide as the browser will let us.
	   *
	   * @fires Player#enterFullWindow
	   */
	  ;
	
	  _proto.enterFullWindow = function enterFullWindow() {
	    this.isFullscreen(true);
	    this.isFullWindow = true; // Storing original doc overflow value to return to when fullscreen is off
	
	    this.docOrigOverflow = document__default['default'].documentElement.style.overflow; // Add listener for esc key to exit fullscreen
	
	    on(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Hide any scroll bars
	
	    document__default['default'].documentElement.style.overflow = 'hidden'; // Apply fullscreen styles
	
	    addClass(document__default['default'].body, 'vjs-full-window');
	    /**
	     * @event Player#enterFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('enterFullWindow');
	  }
	  /**
	   * Check for call to either exit full window or
	   * full screen on ESC key
	   *
	   * @param {string} event
	   *        Event to check for key press
	   */
	  ;
	
	  _proto.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      if (this.isFullscreen() === true) {
	        if (!this.isFullWindow) {
	          this.exitFullscreen();
	        } else {
	          this.exitFullWindow();
	        }
	      }
	    }
	  }
	  /**
	   * Exit full window
	   *
	   * @fires Player#exitFullWindow
	   */
	  ;
	
	  _proto.exitFullWindow = function exitFullWindow() {
	    this.isFullscreen(false);
	    this.isFullWindow = false;
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Unhide scroll bars.
	
	    document__default['default'].documentElement.style.overflow = this.docOrigOverflow; // Remove fullscreen styles
	
	    removeClass(document__default['default'].body, 'vjs-full-window'); // Resize the box, controller, and poster to original sizes
	    // this.positionAll();
	
	    /**
	     * @event Player#exitFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('exitFullWindow');
	  }
	  /**
	   * Disable Picture-in-Picture mode.
	   *
	   * @param {boolean} value
	   *                  - true will disable Picture-in-Picture mode
	   *                  - false will enable Picture-in-Picture mode
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture(value) {
	    if (value === undefined) {
	      return this.techGet_('disablePictureInPicture');
	    }
	
	    this.techCall_('setDisablePictureInPicture', value);
	    this.options_.disablePictureInPicture = value;
	    this.trigger('disablepictureinpicturechanged');
	  }
	  /**
	   * Check if the player is in Picture-in-Picture mode or tell the player that it
	   * is or is not in Picture-in-Picture mode.
	   *
	   * @param  {boolean} [isPiP]
	   *         Set the players current Picture-in-Picture state
	   *
	   * @return {boolean}
	   *         - true if Picture-in-Picture is on and getting
	   *         - false if Picture-in-Picture is off and getting
	   */
	  ;
	
	  _proto.isInPictureInPicture = function isInPictureInPicture(isPiP) {
	    if (isPiP !== undefined) {
	      this.isInPictureInPicture_ = !!isPiP;
	      this.togglePictureInPictureClass_();
	      return;
	    }
	
	    return !!this.isInPictureInPicture_;
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#enterpictureinpicture
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default'] && this.disablePictureInPicture() === false) {
	      /**
	       * This event fires when the player enters picture in picture mode
	       *
	       * @event Player#enterpictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return this.techGet_('requestPictureInPicture');
	    }
	  }
	  /**
	   * Exit Picture-in-Picture mode.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#leavepictureinpicture
	   *
	   * @return {Promise}
	   *         A promise.
	   */
	  ;
	
	  _proto.exitPictureInPicture = function exitPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default']) {
	      /**
	       * This event fires when the player leaves picture in picture mode
	       *
	       * @event Player#leavepictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return document__default['default'].exitPictureInPicture();
	    }
	  }
	  /**
	   * Called when this Player has focus and a key gets pressed down, or when
	   * any Component of this player receives a key press that it doesn't handle.
	   * This allows player-wide hotkeys (either as defined below, or optionally
	   * by an external function).
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var userActions = this.options_.userActions; // Bail out if hotkeys are not configured.
	
	    if (!userActions || !userActions.hotkeys) {
	      return;
	    } // Function that determines whether or not to exclude an element from
	    // hotkeys handling.
	
	
	    var excludeElement = function excludeElement(el) {
	      var tagName = el.tagName.toLowerCase(); // The first and easiest test is for `contenteditable` elements.
	
	      if (el.isContentEditable) {
	        return true;
	      } // Inputs matching these types will still trigger hotkey handling as
	      // they are not text inputs.
	
	
	      var allowedInputTypes = ['button', 'checkbox', 'hidden', 'radio', 'reset', 'submit'];
	
	      if (tagName === 'input') {
	        return allowedInputTypes.indexOf(el.type) === -1;
	      } // The final test is by tag name. These tags will be excluded entirely.
	
	
	      var excludedTags = ['textarea'];
	      return excludedTags.indexOf(tagName) !== -1;
	    }; // Bail out if the user is focused on an interactive form element.
	
	
	    if (excludeElement(this.el_.ownerDocument.activeElement)) {
	      return;
	    }
	
	    if (typeof userActions.hotkeys === 'function') {
	      userActions.hotkeys.call(this, event);
	    } else {
	      this.handleHotkeys(event);
	    }
	  }
	  /**
	   * Called when this Player receives a hotkey keydown event.
	   * Supported player-wide hotkeys are:
	   *
	   *   f          - toggle fullscreen
	   *   m          - toggle mute
	   *   k or Space - toggle play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleHotkeys = function handleHotkeys(event) {
	    var hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {}; // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
	
	    var _hotkeys$fullscreenKe = hotkeys.fullscreenKey,
	        fullscreenKey = _hotkeys$fullscreenKe === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'f');
	    } : _hotkeys$fullscreenKe,
	        _hotkeys$muteKey = hotkeys.muteKey,
	        muteKey = _hotkeys$muteKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'm');
	    } : _hotkeys$muteKey,
	        _hotkeys$playPauseKey = hotkeys.playPauseKey,
	        playPauseKey = _hotkeys$playPauseKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'k') || keycode__default['default'].isEventKey(keydownEvent, 'Space');
	    } : _hotkeys$playPauseKey;
	
	    if (fullscreenKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var FSToggle = Component$1.getComponent('FullscreenToggle');
	
	      if (document__default['default'][this.fsApi_.fullscreenEnabled] !== false) {
	        FSToggle.prototype.handleClick.call(this, event);
	      }
	    } else if (muteKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var MuteToggle = Component$1.getComponent('MuteToggle');
	      MuteToggle.prototype.handleClick.call(this, event);
	    } else if (playPauseKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var PlayToggle = Component$1.getComponent('PlayToggle');
	      PlayToggle.prototype.handleClick.call(this, event);
	    }
	  }
	  /**
	   * Check whether the player can play a given mimetype
	   *
	   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
	   *
	   * @param {string} type
	   *        The mimetype to check
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType(type) {
	    var can; // Loop through each playback technology in the options order
	
	    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
	      var techName = j[i];
	      var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	      // Remove once that deprecated behavior is removed.
	
	      if (!tech) {
	        tech = Component$1.getComponent(techName);
	      } // Check if the current tech is defined before continuing
	
	
	      if (!tech) {
	        log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	        continue;
	      } // Check if the browser supports this technology
	
	
	      if (tech.isSupported()) {
	        can = tech.canPlayType(type);
	
	        if (can) {
	          return can;
	        }
	      }
	    }
	
	    return '';
	  }
	  /**
	   * Select source based on tech-order or source-order
	   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
	   * defaults to tech-order selection
	   *
	   * @param {Array} sources
	   *        The sources for a media asset
	   *
	   * @return {Object|boolean}
	   *         Object of source and tech order or false
	   */
	  ;
	
	  _proto.selectSource = function selectSource(sources) {
	    var _this14 = this;
	
	    // Get only the techs specified in `techOrder` that exist and are supported by the
	    // current platform
	    var techs = this.options_.techOrder.map(function (techName) {
	      return [techName, Tech.getTech(techName)];
	    }).filter(function (_ref) {
	      var techName = _ref[0],
	          tech = _ref[1];
	
	      // Check if the current tech is defined before continuing
	      if (tech) {
	        // Check if the browser supports this technology
	        return tech.isSupported();
	      }
	
	      log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	      return false;
	    }); // Iterate over each `innerArray` element once per `outerArray` element and execute
	    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
	    // that value.
	
	    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
	      var found;
	      outerArray.some(function (outerChoice) {
	        return innerArray.some(function (innerChoice) {
	          found = tester(outerChoice, innerChoice);
	
	          if (found) {
	            return true;
	          }
	        });
	      });
	      return found;
	    };
	
	    var foundSourceAndTech;
	
	    var flip = function flip(fn) {
	      return function (a, b) {
	        return fn(b, a);
	      };
	    };
	
	    var finder = function finder(_ref2, source) {
	      var techName = _ref2[0],
	          tech = _ref2[1];
	
	      if (tech.canPlaySource(source, _this14.options_[techName.toLowerCase()])) {
	        return {
	          source: source,
	          tech: techName
	        };
	      }
	    }; // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
	    // to select from them based on their priority.
	
	
	    if (this.options_.sourceOrder) {
	      // Source-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
	    } else {
	      // Tech-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
	    }
	
	    return foundSourceAndTech || false;
	  }
	  /**
	   * Executes source setting and getting logic
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   * @param {boolean} isRetry
	   *        Indicates whether this is being called internally as a result of a retry
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.handleSrc_ = function handleSrc_(source, isRetry) {
	    var _this15 = this;
	
	    // getter usage
	    if (typeof source === 'undefined') {
	      return this.cache_.src || '';
	    } // Reset retry behavior for new source
	
	
	    if (this.resetRetryOnError_) {
	      this.resetRetryOnError_();
	    } // filter out invalid sources and turn our source into
	    // an array of source objects
	
	
	    var sources = filterSource(source); // if a source was passed in then it is invalid because
	    // it was filtered to a zero length Array. So we have to
	    // show an error
	
	    if (!sources.length) {
	      this.setTimeout(function () {
	        this.error({
	          code: 4,
	          message: this.options_.notSupportedMessage
	        });
	      }, 0);
	      return;
	    } // initial sources
	
	
	    this.changingSrc_ = true; // Only update the cached source list if we are not retrying a new source after error,
	    // since in that case we want to include the failed source(s) in the cache
	
	    if (!isRetry) {
	      this.cache_.sources = sources;
	    }
	
	    this.updateSourceCaches_(sources[0]); // middlewareSource is the source after it has been changed by middleware
	
	    setSource(this, sources[0], function (middlewareSource, mws) {
	      _this15.middleware_ = mws; // since sourceSet is async we have to update the cache again after we select a source since
	      // the source that is selected could be out of order from the cache update above this callback.
	
	      if (!isRetry) {
	        _this15.cache_.sources = sources;
	      }
	
	      _this15.updateSourceCaches_(middlewareSource);
	
	      var err = _this15.src_(middlewareSource);
	
	      if (err) {
	        if (sources.length > 1) {
	          return _this15.handleSrc_(sources.slice(1));
	        }
	
	        _this15.changingSrc_ = false; // We need to wrap this in a timeout to give folks a chance to add error event handlers
	
	        _this15.setTimeout(function () {
	          this.error({
	            code: 4,
	            message: this.options_.notSupportedMessage
	          });
	        }, 0); // we could not find an appropriate tech, but let's still notify the delegate that this is it
	        // this needs a better comment about why this is needed
	
	
	        _this15.triggerReady();
	
	        return;
	      }
	
	      setTech(mws, _this15.tech_);
	    }); // Try another available source if this one fails before playback.
	
	    if (this.options_.retryOnError && sources.length > 1) {
	      var retry = function retry() {
	        // Remove the error modal
	        _this15.error(null);
	
	        _this15.handleSrc_(sources.slice(1), true);
	      };
	
	      var stopListeningForErrors = function stopListeningForErrors() {
	        _this15.off('error', retry);
	      };
	
	      this.one('error', retry);
	      this.one('playing', stopListeningForErrors);
	
	      this.resetRetryOnError_ = function () {
	        _this15.off('error', retry);
	
	        _this15.off('playing', stopListeningForErrors);
	      };
	    }
	  }
	  /**
	   * Get or set the video source.
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.src = function src(source) {
	    return this.handleSrc_(source, false);
	  }
	  /**
	   * Set the source object on the tech, returns a boolean that indicates whether
	   * there is a tech that can play the source or not
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object to set on the Tech
	   *
	   * @return {boolean}
	   *         - True if there is no Tech to playback this source
	   *         - False otherwise
	   *
	   * @private
	   */
	  ;
	
	  _proto.src_ = function src_(source) {
	    var _this16 = this;
	
	    var sourceTech = this.selectSource([source]);
	
	    if (!sourceTech) {
	      return true;
	    }
	
	    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
	      this.changingSrc_ = true; // load this technology with the chosen source
	
	      this.loadTech_(sourceTech.tech, sourceTech.source);
	      this.tech_.ready(function () {
	        _this16.changingSrc_ = false;
	      });
	      return false;
	    } // wait until the tech is ready to set the source
	    // and set it synchronously if possible (#2326)
	
	
	    this.ready(function () {
	      // The setSource tech method was added with source handlers
	      // so older techs won't support it
	      // We need to check the direct prototype for the case where subclasses
	      // of the tech do not support source handlers
	      if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
	        this.techCall_('setSource', source);
	      } else {
	        this.techCall_('src', source.src);
	      }
	
	      this.changingSrc_ = false;
	    }, true);
	    return false;
	  }
	  /**
	   * Begin loading the src data.
	   */
	  ;
	
	  _proto.load = function load() {
	    this.techCall_('load');
	  }
	  /**
	   * Reset the player. Loads the first tech in the techOrder,
	   * removes all the text tracks in the existing `tech`,
	   * and calls `reset` on the `tech`.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    var _this17 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (this.paused() || !PromiseClass) {
	      this.doReset_();
	    } else {
	      var playPromise = this.play();
	      silencePromise(playPromise.then(function () {
	        return _this17.doReset_();
	      }));
	    }
	  };
	
	  _proto.doReset_ = function doReset_() {
	    if (this.tech_) {
	      this.tech_.clearTracks('text');
	    }
	
	    this.resetCache_();
	    this.poster('');
	    this.loadTech_(this.options_.techOrder[0], null);
	    this.techCall_('reset');
	    this.resetControlBarUI_();
	
	    if (isEvented(this)) {
	      this.trigger('playerreset');
	    }
	  }
	  /**
	   * Reset Control Bar's UI by calling sub-methods that reset
	   * all of Control Bar's components
	   */
	  ;
	
	  _proto.resetControlBarUI_ = function resetControlBarUI_() {
	    this.resetProgressBar_();
	    this.resetPlaybackRate_();
	    this.resetVolumeBar_();
	  }
	  /**
	   * Reset tech's progress so progress bar is reset in the UI
	   */
	  ;
	
	  _proto.resetProgressBar_ = function resetProgressBar_() {
	    this.currentTime(0);
	
	    var _ref3 = this.controlBar || {},
	        durationDisplay = _ref3.durationDisplay,
	        remainingTimeDisplay = _ref3.remainingTimeDisplay;
	
	    if (durationDisplay) {
	      durationDisplay.updateContent();
	    }
	
	    if (remainingTimeDisplay) {
	      remainingTimeDisplay.updateContent();
	    }
	  }
	  /**
	   * Reset Playback ratio
	   */
	  ;
	
	  _proto.resetPlaybackRate_ = function resetPlaybackRate_() {
	    this.playbackRate(this.defaultPlaybackRate());
	    this.handleTechRateChange_();
	  }
	  /**
	   * Reset Volume bar
	   */
	  ;
	
	  _proto.resetVolumeBar_ = function resetVolumeBar_() {
	    this.volume(1.0);
	    this.trigger('volumechange');
	  }
	  /**
	   * Returns all of the current source objects.
	   *
	   * @return {Tech~SourceObject[]}
	   *         The current source objects
	   */
	  ;
	
	  _proto.currentSources = function currentSources() {
	    var source = this.currentSource();
	    var sources = []; // assume `{}` or `{ src }`
	
	    if (Object.keys(source).length !== 0) {
	      sources.push(source);
	    }
	
	    return this.cache_.sources || sources;
	  }
	  /**
	   * Returns the current source object.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object
	   */
	  ;
	
	  _proto.currentSource = function currentSource() {
	    return this.cache_.source || {};
	  }
	  /**
	   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
	   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
	   *
	   * @return {string}
	   *         The current source
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    return this.currentSource() && this.currentSource().src || '';
	  }
	  /**
	   * Get the current source type e.g. video/mp4
	   * This can allow you rebuild the current source object so that you could load the same
	   * source and tech later
	   *
	   * @return {string}
	   *         The source MIME type
	   */
	  ;
	
	  _proto.currentType = function currentType() {
	    return this.currentSource() && this.currentSource().type || '';
	  }
	  /**
	   * Get or set the preload attribute
	   *
	   * @param {boolean} [value]
	   *        - true means that we should preload
	   *        - false means that we should not preload
	   *
	   * @return {string}
	   *         The preload attribute value when getting
	   */
	  ;
	
	  _proto.preload = function preload(value) {
	    if (value !== undefined) {
	      this.techCall_('setPreload', value);
	      this.options_.preload = value;
	      return;
	    }
	
	    return this.techGet_('preload');
	  }
	  /**
	   * Get or set the autoplay option. When this is a boolean it will
	   * modify the attribute on the tech. When this is a string the attribute on
	   * the tech will be removed and `Player` will handle autoplay on loadstarts.
	   *
	   * @param {boolean|string} [value]
	   *        - true: autoplay using the browser behavior
	   *        - false: do not autoplay
	   *        - 'play': call play() on every loadstart
	   *        - 'muted': call muted() then play() on every loadstart
	   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
	   *        - *: values other than those listed here will be set `autoplay` to true
	   *
	   * @return {boolean|string}
	   *         The current value of autoplay when getting
	   */
	  ;
	
	  _proto.autoplay = function autoplay(value) {
	    // getter usage
	    if (value === undefined) {
	      return this.options_.autoplay || false;
	    }
	
	    var techAutoplay; // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
	
	    if (typeof value === 'string' && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
	      this.options_.autoplay = value;
	      this.manualAutoplay_(typeof value === 'string' ? value : 'play');
	      techAutoplay = false; // any falsy value sets autoplay to false in the browser,
	      // lets do the same
	    } else if (!value) {
	      this.options_.autoplay = false; // any other value (ie truthy) sets autoplay to true
	    } else {
	      this.options_.autoplay = true;
	    }
	
	    techAutoplay = typeof techAutoplay === 'undefined' ? this.options_.autoplay : techAutoplay; // if we don't have a tech then we do not queue up
	    // a setAutoplay call on tech ready. We do this because the
	    // autoplay option will be passed in the constructor and we
	    // do not need to set it twice
	
	    if (this.tech_) {
	      this.techCall_('setAutoplay', techAutoplay);
	    }
	  }
	  /**
	   * Set or unset the playsinline attribute.
	   * Playsinline tells the browser that non-fullscreen playback is preferred.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should try to play inline by default
	   *        - false means that we should use the browser's default playback mode,
	   *          which in most cases is inline. iOS Safari is a notable exception
	   *          and plays fullscreen by default.
	   *
	   * @return {string|Player}
	   *         - the current value of playsinline
	   *         - the player when setting
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	   */
	  ;
	
	  _proto.playsinline = function playsinline(value) {
	    if (value !== undefined) {
	      this.techCall_('setPlaysinline', value);
	      this.options_.playsinline = value;
	      return this;
	    }
	
	    return this.techGet_('playsinline');
	  }
	  /**
	   * Get or set the loop attribute on the video element.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should loop the video
	   *        - false means that we should not loop the video
	   *
	   * @return {boolean}
	   *         The current value of loop when getting
	   */
	  ;
	
	  _proto.loop = function loop(value) {
	    if (value !== undefined) {
	      this.techCall_('setLoop', value);
	      this.options_.loop = value;
	      return;
	    }
	
	    return this.techGet_('loop');
	  }
	  /**
	   * Get or set the poster image source url
	   *
	   * @fires Player#posterchange
	   *
	   * @param {string} [src]
	   *        Poster image source URL
	   *
	   * @return {string}
	   *         The current value of poster when getting
	   */
	  ;
	
	  _proto.poster = function poster(src) {
	    if (src === undefined) {
	      return this.poster_;
	    } // The correct way to remove a poster is to set as an empty string
	    // other falsey values will throw errors
	
	
	    if (!src) {
	      src = '';
	    }
	
	    if (src === this.poster_) {
	      return;
	    } // update the internal poster variable
	
	
	    this.poster_ = src; // update the tech's poster
	
	    this.techCall_('setPoster', src);
	    this.isPosterFromTech_ = false; // alert components that the poster has been set
	
	    /**
	     * This event fires when the poster image is changed on the player.
	     *
	     * @event Player#posterchange
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('posterchange');
	  }
	  /**
	   * Some techs (e.g. YouTube) can provide a poster source in an
	   * asynchronous way. We want the poster component to use this
	   * poster source so that it covers up the tech's controls.
	   * (YouTube's play button). However we only want to use this
	   * source if the player user hasn't set a poster through
	   * the normal APIs.
	   *
	   * @fires Player#posterchange
	   * @listens Tech#posterchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechPosterChange_ = function handleTechPosterChange_() {
	    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
	      var newPoster = this.tech_.poster() || '';
	
	      if (newPoster !== this.poster_) {
	        this.poster_ = newPoster;
	        this.isPosterFromTech_ = true; // Let components know the poster has changed
	
	        this.trigger('posterchange');
	      }
	    }
	  }
	  /**
	   * Get or set whether or not the controls are showing.
	   *
	   * @fires Player#controlsenabled
	   *
	   * @param {boolean} [bool]
	   *        - true to turn controls on
	   *        - false to turn controls off
	   *
	   * @return {boolean}
	   *         The current value of controls when getting
	   */
	  ;
	
	  _proto.controls = function controls(bool) {
	    if (bool === undefined) {
	      return !!this.controls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.controls_ === bool) {
	      return;
	    }
	
	    this.controls_ = bool;
	
	    if (this.usingNativeControls()) {
	      this.techCall_('setControls', bool);
	    }
	
	    if (this.controls_) {
	      this.removeClass('vjs-controls-disabled');
	      this.addClass('vjs-controls-enabled');
	      /**
	       * @event Player#controlsenabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsenabled');
	
	      if (!this.usingNativeControls()) {
	        this.addTechControlsListeners_();
	      }
	    } else {
	      this.removeClass('vjs-controls-enabled');
	      this.addClass('vjs-controls-disabled');
	      /**
	       * @event Player#controlsdisabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsdisabled');
	
	      if (!this.usingNativeControls()) {
	        this.removeTechControlsListeners_();
	      }
	    }
	  }
	  /**
	   * Toggle native controls on/off. Native controls are the controls built into
	   * devices (e.g. default iPhone controls) or other techs
	   * (e.g. Vimeo Controls)
	   * **This should only be set by the current tech, because only the tech knows
	   * if it can support native controls**
	   *
	   * @fires Player#usingnativecontrols
	   * @fires Player#usingcustomcontrols
	   *
	   * @param {boolean} [bool]
	   *        - true to turn native controls on
	   *        - false to turn native controls off
	   *
	   * @return {boolean}
	   *         The current value of native controls when getting
	   */
	  ;
	
	  _proto.usingNativeControls = function usingNativeControls(bool) {
	    if (bool === undefined) {
	      return !!this.usingNativeControls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.usingNativeControls_ === bool) {
	      return;
	    }
	
	    this.usingNativeControls_ = bool;
	
	    if (this.usingNativeControls_) {
	      this.addClass('vjs-using-native-controls');
	      /**
	       * player is using the native device controls
	       *
	       * @event Player#usingnativecontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingnativecontrols');
	    } else {
	      this.removeClass('vjs-using-native-controls');
	      /**
	       * player is using the custom HTML controls
	       *
	       * @event Player#usingcustomcontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingcustomcontrols');
	    }
	  }
	  /**
	   * Set or get the current MediaError
	   *
	   * @fires Player#error
	   *
	   * @param  {MediaError|string|number} [err]
	   *         A MediaError or a string/number to be turned
	   *         into a MediaError
	   *
	   * @return {MediaError|null}
	   *         The current MediaError when getting (or null)
	   */
	  ;
	
	  _proto.error = function error(err) {
	    var _this18 = this;
	
	    if (err === undefined) {
	      return this.error_ || null;
	    } // allow hooks to modify error object
	
	
	    hooks('beforeerror').forEach(function (hookFunction) {
	      var newErr = hookFunction(_this18, err);
	
	      if (!(isObject(newErr) && !Array.isArray(newErr) || typeof newErr === 'string' || typeof newErr === 'number' || newErr === null)) {
	        _this18.log.error('please return a value that MediaError expects in beforeerror hooks');
	
	        return;
	      }
	
	      err = newErr;
	    }); // Suppress the first error message for no compatible source until
	    // user interaction
	
	    if (this.options_.suppressNotSupportedError && err && err.code === 4) {
	      var triggerSuppressedError = function triggerSuppressedError() {
	        this.error(err);
	      };
	
	      this.options_.suppressNotSupportedError = false;
	      this.any(['click', 'touchstart'], triggerSuppressedError);
	      this.one('loadstart', function () {
	        this.off(['click', 'touchstart'], triggerSuppressedError);
	      });
	      return;
	    } // restoring to default
	
	
	    if (err === null) {
	      this.error_ = err;
	      this.removeClass('vjs-error');
	
	      if (this.errorDisplay) {
	        this.errorDisplay.close();
	      }
	
	      return;
	    }
	
	    this.error_ = new MediaError(err); // add the vjs-error classname to the player
	
	    this.addClass('vjs-error'); // log the name of the error type and any message
	    // IE11 logs "[object object]" and required you to expand message to see error object
	
	    log$1.error("(CODE:" + this.error_.code + " " + MediaError.errorTypes[this.error_.code] + ")", this.error_.message, this.error_);
	    /**
	     * @event Player#error
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('error'); // notify hooks of the per player error
	
	    hooks('error').forEach(function (hookFunction) {
	      return hookFunction(_this18, _this18.error_);
	    });
	    return;
	  }
	  /**
	   * Report user activity
	   *
	   * @param {Object} event
	   *        Event object
	   */
	  ;
	
	  _proto.reportUserActivity = function reportUserActivity(event) {
	    this.userActivity_ = true;
	  }
	  /**
	   * Get/set if user is active
	   *
	   * @fires Player#useractive
	   * @fires Player#userinactive
	   *
	   * @param {boolean} [bool]
	   *        - true if the user is active
	   *        - false if the user is inactive
	   *
	   * @return {boolean}
	   *         The current value of userActive when getting
	   */
	  ;
	
	  _proto.userActive = function userActive(bool) {
	    if (bool === undefined) {
	      return this.userActive_;
	    }
	
	    bool = !!bool;
	
	    if (bool === this.userActive_) {
	      return;
	    }
	
	    this.userActive_ = bool;
	
	    if (this.userActive_) {
	      this.userActivity_ = true;
	      this.removeClass('vjs-user-inactive');
	      this.addClass('vjs-user-active');
	      /**
	       * @event Player#useractive
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('useractive');
	      return;
	    } // Chrome/Safari/IE have bugs where when you change the cursor it can
	    // trigger a mousemove event. This causes an issue when you're hiding
	    // the cursor when the user is inactive, and a mousemove signals user
	    // activity. Making it impossible to go into inactive mode. Specifically
	    // this happens in fullscreen when we really need to hide the cursor.
	    //
	    // When this gets resolved in ALL browsers it can be removed
	    // https://code.google.com/p/chromium/issues/detail?id=103041
	
	
	    if (this.tech_) {
	      this.tech_.one('mousemove', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	      });
	    }
	
	    this.userActivity_ = false;
	    this.removeClass('vjs-user-active');
	    this.addClass('vjs-user-inactive');
	    /**
	     * @event Player#userinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('userinactive');
	  }
	  /**
	   * Listen for user activity based on timeout value
	   *
	   * @private
	   */
	  ;
	
	  _proto.listenForUserActivity_ = function listenForUserActivity_() {
	    var mouseInProgress;
	    var lastMoveX;
	    var lastMoveY;
	    var handleActivity = bind(this, this.reportUserActivity);
	
	    var handleMouseMove = function handleMouseMove(e) {
	      // #1068 - Prevent mousemove spamming
	      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
	      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
	        lastMoveX = e.screenX;
	        lastMoveY = e.screenY;
	        handleActivity();
	      }
	    };
	
	    var handleMouseDown = function handleMouseDown() {
	      handleActivity(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(mouseInProgress); // Setting userActivity=true now and setting the interval to the same time
	      // as the activityCheck interval (250) should ensure we never miss the
	      // next activityCheck
	
	      mouseInProgress = this.setInterval(handleActivity, 250);
	    };
	
	    var handleMouseUpAndMouseLeave = function handleMouseUpAndMouseLeave(event) {
	      handleActivity(); // Stop the interval that maintains activity if the mouse/touch is down
	
	      this.clearInterval(mouseInProgress);
	    }; // Any mouse movement will be considered user activity
	
	
	    this.on('mousedown', handleMouseDown);
	    this.on('mousemove', handleMouseMove);
	    this.on('mouseup', handleMouseUpAndMouseLeave);
	    this.on('mouseleave', handleMouseUpAndMouseLeave);
	    var controlBar = this.getChild('controlBar'); // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
	    // controlBar would no longer be hidden by default timeout.
	
	    if (controlBar && !IS_IOS && !IS_ANDROID) {
	      controlBar.on('mouseenter', function (event) {
	        if (this.player().options_.inactivityTimeout !== 0) {
	          this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
	        }
	
	        this.player().options_.inactivityTimeout = 0;
	      });
	      controlBar.on('mouseleave', function (event) {
	        this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
	      });
	    } // Listen for keyboard navigation
	    // Shouldn't need to use inProgress interval because of key repeat
	
	
	    this.on('keydown', handleActivity);
	    this.on('keyup', handleActivity); // Run an interval every 250 milliseconds instead of stuffing everything into
	    // the mousemove/touchmove function itself, to prevent performance degradation.
	    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
	    // then gets picked up by this loop
	    // http://ejohn.org/blog/learning-from-twitter/
	
	    var inactivityTimeout;
	    this.setInterval(function () {
	      // Check to see if mouse/touch activity has happened
	      if (!this.userActivity_) {
	        return;
	      } // Reset the activity tracker
	
	
	      this.userActivity_ = false; // If the user state was inactive, set the state to active
	
	      this.userActive(true); // Clear any existing inactivity timeout to start the timer over
	
	      this.clearTimeout(inactivityTimeout);
	      var timeout = this.options_.inactivityTimeout;
	
	      if (timeout <= 0) {
	        return;
	      } // In <timeout> milliseconds, if no more activity has occurred the
	      // user will be considered inactive
	
	
	      inactivityTimeout = this.setTimeout(function () {
	        // Protect against the case where the inactivityTimeout can trigger just
	        // before the next user activity is picked up by the activity check loop
	        // causing a flicker
	        if (!this.userActivity_) {
	          this.userActive(false);
	        }
	      }, timeout);
	    }, 250);
	  }
	  /**
	   * Gets or sets the current playback rate. A playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed
	   * playback, for instance.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
	   *
	   * @param {number} [rate]
	   *       New playback rate to set.
	   *
	   * @return {number}
	   *         The current playback rate when getting or 1.0
	   */
	  ;
	
	  _proto.playbackRate = function playbackRate(rate) {
	    if (rate !== undefined) {
	      // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
	      // that is registered above
	      this.techCall_('setPlaybackRate', rate);
	      return;
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the current default playback rate. A default playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
	   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
	   * not the current playbackRate.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
	   *
	   * @param {number} [rate]
	   *       New default playback rate to set.
	   *
	   * @return {number|Player}
	   *         - The default playback rate when getting or 1.0
	   *         - the player when setting
	   */
	  ;
	
	  _proto.defaultPlaybackRate = function defaultPlaybackRate(rate) {
	    if (rate !== undefined) {
	      return this.techCall_('setDefaultPlaybackRate', rate);
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.techGet_('defaultPlaybackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the audio flag
	   *
	   * @param {boolean} bool
	   *        - true signals that this is an audio player
	   *        - false signals that this is not an audio player
	   *
	   * @return {boolean}
	   *         The current value of isAudio when getting
	   */
	  ;
	
	  _proto.isAudio = function isAudio(bool) {
	    if (bool !== undefined) {
	      this.isAudio_ = !!bool;
	      return;
	    }
	
	    return !!this.isAudio_;
	  };
	
	  _proto.enableAudioOnlyUI_ = function enableAudioOnlyUI_() {
	    var _this19 = this;
	
	    // Update styling immediately to show the control bar so we can get its height
	    this.addClass('vjs-audio-only-mode');
	    var playerChildren = this.children();
	    var controlBar = this.getChild('ControlBar');
	    var controlBarHeight = controlBar && controlBar.currentHeight(); // Hide all player components except the control bar. Control bar components
	    // needed only for video are hidden with CSS
	
	    playerChildren.forEach(function (child) {
	      if (child === controlBar) {
	        return;
	      }
	
	      if (child.el_ && !child.hasClass('vjs-hidden')) {
	        child.hide();
	
	        _this19.audioOnlyCache_.hiddenChildren.push(child);
	      }
	    });
	    this.audioOnlyCache_.playerHeight = this.currentHeight(); // Set the player height the same as the control bar
	
	    this.height(controlBarHeight);
	    this.trigger('audioonlymodechange');
	  };
	
	  _proto.disableAudioOnlyUI_ = function disableAudioOnlyUI_() {
	    this.removeClass('vjs-audio-only-mode'); // Show player components that were previously hidden
	
	    this.audioOnlyCache_.hiddenChildren.forEach(function (child) {
	      return child.show();
	    }); // Reset player height
	
	    this.height(this.audioOnlyCache_.playerHeight);
	    this.trigger('audioonlymodechange');
	  }
	  /**
	   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
	   *
	   * Setting this to `true` will hide all player components except the control bar,
	   * as well as control bar components needed only for video.
	   *
	   * @param {boolean} [value]
	   *         The value to set audioOnlyMode to.
	   *
	   * @return {Promise|boolean}
	   *        A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioOnlyMode = function audioOnlyMode(value) {
	    var _this20 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioOnlyMode_) {
	      return this.audioOnlyMode_;
	    }
	
	    this.audioOnlyMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      // Enable Audio Only Mode
	      if (value) {
	        var exitPromises = []; // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
	
	        if (this.isInPictureInPicture()) {
	          exitPromises.push(this.exitPictureInPicture());
	        }
	
	        if (this.isFullscreen()) {
	          exitPromises.push(this.exitFullscreen());
	        }
	
	        if (this.audioPosterMode()) {
	          exitPromises.push(this.audioPosterMode(false));
	        }
	
	        return PromiseClass.all(exitPromises).then(function () {
	          return _this20.enableAudioOnlyUI_();
	        });
	      } // Disable Audio Only Mode
	
	
	      return PromiseClass.resolve().then(function () {
	        return _this20.disableAudioOnlyUI_();
	      });
	    }
	
	    if (value) {
	      if (this.isInPictureInPicture()) {
	        this.exitPictureInPicture();
	      }
	
	      if (this.isFullscreen()) {
	        this.exitFullscreen();
	      }
	
	      this.enableAudioOnlyUI_();
	    } else {
	      this.disableAudioOnlyUI_();
	    }
	  };
	
	  _proto.enablePosterModeUI_ = function enablePosterModeUI_() {
	    // Hide the video element and show the poster image to enable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.hide();
	    this.addClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  };
	
	  _proto.disablePosterModeUI_ = function disablePosterModeUI_() {
	    // Show the video element and hide the poster image to disable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.show();
	    this.removeClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  }
	  /**
	   * Get the current audioPosterMode state or set audioPosterMode to true or false
	   *
	   * @param {boolean} [value]
	   *         The value to set audioPosterMode to.
	   *
	   * @return {Promise|boolean}
	   *         A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioPosterMode = function audioPosterMode(value) {
	    var _this21 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioPosterMode_) {
	      return this.audioPosterMode_;
	    }
	
	    this.audioPosterMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      if (value) {
	        if (this.audioOnlyMode()) {
	          var audioOnlyModePromise = this.audioOnlyMode(false);
	          return audioOnlyModePromise.then(function () {
	            // enable audio poster mode after audio only mode is disabled
	            _this21.enablePosterModeUI_();
	          });
	        }
	
	        return PromiseClass.resolve().then(function () {
	          // enable audio poster mode
	          _this21.enablePosterModeUI_();
	        });
	      }
	
	      return PromiseClass.resolve().then(function () {
	        // disable audio poster mode
	        _this21.disablePosterModeUI_();
	      });
	    }
	
	    if (value) {
	      if (this.audioOnlyMode()) {
	        this.audioOnlyMode(false);
	      }
	
	      this.enablePosterModeUI_();
	      return;
	    }
	
	    this.disablePosterModeUI_();
	  }
	  /**
	   * A helper method for adding a {@link TextTrack} to our
	   * {@link TextTrackList}.
	   *
	   * In addition to the W3C settings we allow adding additional info through options.
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
	   *
	   * @param {string} [kind]
	   *        the kind of TextTrack you are adding
	   *
	   * @param {string} [label]
	   *        the label to give the TextTrack label
	   *
	   * @param {string} [language]
	   *        the language to set on the TextTrack
	   *
	   * @return {TextTrack|undefined}
	   *         the TextTrack that was added or undefined
	   *         if there is no tech
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (this.tech_) {
	      return this.tech_.addTextTrack(kind, label, language);
	    }
	  }
	  /**
	   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
	   * When manualCleanup is set to false, the track will be automatically removed
	   * on source changes.
	   *
	   * @param {Object} options
	   *        Options to pass to {@link HTMLTrackElement} during creation. See
	   *        {@link HTMLTrackElement} for object properties that you should use.
	   *
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   *                                       removed on a source change
	   *
	   * @return {HtmlTrackElement}
	   *         the HTMLTrackElement that was created and added
	   *         to the HtmlTrackElementList and the remote
	   *         TextTrackList
	   *
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   *             to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    if (this.tech_) {
	      return this.tech_.addRemoteTextTrack(options, manualCleanup);
	    }
	  }
	  /**
	   * Remove a remote {@link TextTrack} from the respective
	   * {@link TextTrackList} and {@link HtmlTrackElementList}.
	   *
	   * @param {Object} track
	   *        Remote {@link TextTrack} to remove
	   *
	   * @return {undefined}
	   *         does not return anything
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(obj) {
	    if (obj === void 0) {
	      obj = {};
	    }
	
	    var _obj = obj,
	        track = _obj.track;
	
	    if (!track) {
	      track = obj;
	    } // destructure the input into an object with a track argument, defaulting to arguments[0]
	    // default the whole argument to an empty object if nothing was passed in
	
	
	    if (this.tech_) {
	      return this.tech_.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object|undefined}
	   *         An object with supported media playback quality metrics or undefined if there
	   *         is no tech or the tech does not support it.
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return this.techGet_('getVideoPlaybackQuality');
	  }
	  /**
	   * Get video width
	   *
	   * @return {number}
	   *         current video width
	   */
	  ;
	
	  _proto.videoWidth = function videoWidth() {
	    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
	  }
	  /**
	   * Get video height
	   *
	   * @return {number}
	   *         current video height
	   */
	  ;
	
	  _proto.videoHeight = function videoHeight() {
	    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
	  }
	  /**
	   * The player's language code.
	   *
	   * Changing the language will trigger
	   * [languagechange]{@link Player#event:languagechange}
	   * which Components can use to update control text.
	   * ClickableComponent will update its control text by default on
	   * [languagechange]{@link Player#event:languagechange}.
	   *
	   * @fires Player#languagechange
	   *
	   * @param {string} [code]
	   *        the language code to set the player to
	   *
	   * @return {string}
	   *         The current language code when getting
	   */
	  ;
	
	  _proto.language = function language(code) {
	    if (code === undefined) {
	      return this.language_;
	    }
	
	    if (this.language_ !== String(code).toLowerCase()) {
	      this.language_ = String(code).toLowerCase(); // during first init, it's possible some things won't be evented
	
	      if (isEvented(this)) {
	        /**
	        * fires when the player language change
	        *
	        * @event Player#languagechange
	        * @type {EventTarget~Event}
	        */
	        this.trigger('languagechange');
	      }
	    }
	  }
	  /**
	   * Get the player's language dictionary
	   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
	   * Languages specified directly in the player options have precedence
	   *
	   * @return {Array}
	   *         An array of of supported languages
	   */
	  ;
	
	  _proto.languages = function languages() {
	    return mergeOptions$3(Player.prototype.options_.languages, this.languages_);
	  }
	  /**
	   * returns a JavaScript object reperesenting the current track
	   * information. **DOES not return it as JSON**
	   *
	   * @return {Object}
	   *         Object representing the current of track info
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    var options = mergeOptions$3(this.options_);
	    var tracks = options.tracks;
	    options.tracks = [];
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // deep merge tracks and null out player so no circular references
	
	      track = mergeOptions$3(track);
	      track.player = undefined;
	      options.tracks[i] = track;
	    }
	
	    return options;
	  }
	  /**
	   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
	   * component) that immediately overlays the player with arbitrary
	   * content and removes itself when closed.
	   *
	   * @param {string|Function|Element|Array|null} content
	   *        Same as {@link ModalDialog#content}'s param of the same name.
	   *        The most straight-forward usage is to provide a string or DOM
	   *        element.
	   *
	   * @param {Object} [options]
	   *        Extra options which will be passed on to the {@link ModalDialog}.
	   *
	   * @return {ModalDialog}
	   *         the {@link ModalDialog} that was created
	   */
	  ;
	
	  _proto.createModal = function createModal(content, options) {
	    var _this22 = this;
	
	    options = options || {};
	    options.content = content || '';
	    var modal = new ModalDialog(this, options);
	    this.addChild(modal);
	    modal.on('dispose', function () {
	      _this22.removeChild(modal);
	    });
	    modal.open();
	    return modal;
	  }
	  /**
	   * Change breakpoint classes when the player resizes.
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateCurrentBreakpoint_ = function updateCurrentBreakpoint_() {
	    if (!this.responsive()) {
	      return;
	    }
	
	    var currentBreakpoint = this.currentBreakpoint();
	    var currentWidth = this.currentWidth();
	
	    for (var i = 0; i < BREAKPOINT_ORDER.length; i++) {
	      var candidateBreakpoint = BREAKPOINT_ORDER[i];
	      var maxWidth = this.breakpoints_[candidateBreakpoint];
	
	      if (currentWidth <= maxWidth) {
	        // The current breakpoint did not change, nothing to do.
	        if (currentBreakpoint === candidateBreakpoint) {
	          return;
	        } // Only remove a class if there is a current breakpoint.
	
	
	        if (currentBreakpoint) {
	          this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);
	        }
	
	        this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);
	        this.breakpoint_ = candidateBreakpoint;
	        break;
	      }
	    }
	  }
	  /**
	   * Removes the current breakpoint.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeCurrentBreakpoint_ = function removeCurrentBreakpoint_() {
	    var className = this.currentBreakpointClass();
	    this.breakpoint_ = '';
	
	    if (className) {
	      this.removeClass(className);
	    }
	  }
	  /**
	   * Get or set breakpoints on the player.
	   *
	   * Calling this method with an object or `true` will remove any previous
	   * custom breakpoints and start from the defaults again.
	   *
	   * @param  {Object|boolean} [breakpoints]
	   *         If an object is given, it can be used to provide custom
	   *         breakpoints. If `true` is given, will set default breakpoints.
	   *         If this argument is not given, will simply return the current
	   *         breakpoints.
	   *
	   * @param  {number} [breakpoints.tiny]
	   *         The maximum width for the "vjs-layout-tiny" class.
	   *
	   * @param  {number} [breakpoints.xsmall]
	   *         The maximum width for the "vjs-layout-x-small" class.
	   *
	   * @param  {number} [breakpoints.small]
	   *         The maximum width for the "vjs-layout-small" class.
	   *
	   * @param  {number} [breakpoints.medium]
	   *         The maximum width for the "vjs-layout-medium" class.
	   *
	   * @param  {number} [breakpoints.large]
	   *         The maximum width for the "vjs-layout-large" class.
	   *
	   * @param  {number} [breakpoints.xlarge]
	   *         The maximum width for the "vjs-layout-x-large" class.
	   *
	   * @param  {number} [breakpoints.huge]
	   *         The maximum width for the "vjs-layout-huge" class.
	   *
	   * @return {Object}
	   *         An object mapping breakpoint names to maximum width values.
	   */
	  ;
	
	  _proto.breakpoints = function breakpoints(_breakpoints) {
	    // Used as a getter.
	    if (_breakpoints === undefined) {
	      return assign(this.breakpoints_);
	    }
	
	    this.breakpoint_ = '';
	    this.breakpoints_ = assign({}, DEFAULT_BREAKPOINTS, _breakpoints); // When breakpoint definitions change, we need to update the currently
	    // selected breakpoint.
	
	    this.updateCurrentBreakpoint_(); // Clone the breakpoints before returning.
	
	    return assign(this.breakpoints_);
	  }
	  /**
	   * Get or set a flag indicating whether or not this player should adjust
	   * its UI based on its dimensions.
	   *
	   * @param  {boolean} value
	   *         Should be `true` if the player should adjust its UI based on its
	   *         dimensions; otherwise, should be `false`.
	   *
	   * @return {boolean}
	   *         Will be `true` if this player should adjust its UI based on its
	   *         dimensions; otherwise, will be `false`.
	   */
	  ;
	
	  _proto.responsive = function responsive(value) {
	    // Used as a getter.
	    if (value === undefined) {
	      return this.responsive_;
	    }
	
	    value = Boolean(value);
	    var current = this.responsive_; // Nothing changed.
	
	    if (value === current) {
	      return;
	    } // The value actually changed, set it.
	
	
	    this.responsive_ = value; // Start listening for breakpoints and set the initial breakpoint if the
	    // player is now responsive.
	
	    if (value) {
	      this.on('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.updateCurrentBreakpoint_(); // Stop listening for breakpoints if the player is no longer responsive.
	    } else {
	      this.off('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.removeCurrentBreakpoint_();
	    }
	
	    return value;
	  }
	  /**
	   * Get current breakpoint name, if any.
	   *
	   * @return {string}
	   *         If there is currently a breakpoint set, returns a the key from the
	   *         breakpoints object matching it. Otherwise, returns an empty string.
	   */
	  ;
	
	  _proto.currentBreakpoint = function currentBreakpoint() {
	    return this.breakpoint_;
	  }
	  /**
	   * Get the current breakpoint class name.
	   *
	   * @return {string}
	   *         The matching class name (e.g. `"vjs-layout-tiny"` or
	   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
	   *         there is no current breakpoint.
	   */
	  ;
	
	  _proto.currentBreakpointClass = function currentBreakpointClass() {
	    return BREAKPOINT_CLASSES[this.breakpoint_] || '';
	  }
	  /**
	   * An object that describes a single piece of media.
	   *
	   * Properties that are not part of this type description will be retained; so,
	   * this can be viewed as a generic metadata storage mechanism as well.
	   *
	   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
	   * @typedef  {Object} Player~MediaObject
	   *
	   * @property {string} [album]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {string} [artist]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [artwork]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API. If not specified, will be populated via the `poster`, if
	   *           available.
	   *
	   * @property {string} [poster]
	   *           URL to an image that will display before playback.
	   *
	   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
	   *           A single source object, an array of source objects, or a string
	   *           referencing a URL to a media source. It is _highly recommended_
	   *           that an object or array of objects is used here, so that source
	   *           selection algorithms can take the `type` into account.
	   *
	   * @property {string} [title]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [textTracks]
	   *           An array of objects to be used to create text tracks, following
	   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
	   *           For ease of removal, these will be created as "remote" text
	   *           tracks and set to automatically clean up on source changes.
	   *
	   *           These objects may have properties like `src`, `kind`, `label`,
	   *           and `language`, see {@link Tech#createRemoteTextTrack}.
	   */
	
	  /**
	   * Populate the player using a {@link Player~MediaObject|MediaObject}.
	   *
	   * @param  {Player~MediaObject} media
	   *         A media object.
	   *
	   * @param  {Function} ready
	   *         A callback to be called when the player is ready.
	   */
	  ;
	
	  _proto.loadMedia = function loadMedia(media, ready) {
	    var _this23 = this;
	
	    if (!media || typeof media !== 'object') {
	      return;
	    }
	
	    this.reset(); // Clone the media object so it cannot be mutated from outside.
	
	    this.cache_.media = mergeOptions$3(media);
	    var _this$cache_$media = this.cache_.media,
	        artwork = _this$cache_$media.artwork,
	        poster = _this$cache_$media.poster,
	        src = _this$cache_$media.src,
	        textTracks = _this$cache_$media.textTracks; // If `artwork` is not given, create it using `poster`.
	
	    if (!artwork && poster) {
	      this.cache_.media.artwork = [{
	        src: poster,
	        type: getMimetype(poster)
	      }];
	    }
	
	    if (src) {
	      this.src(src);
	    }
	
	    if (poster) {
	      this.poster(poster);
	    }
	
	    if (Array.isArray(textTracks)) {
	      textTracks.forEach(function (tt) {
	        return _this23.addRemoteTextTrack(tt, false);
	      });
	    }
	
	    this.ready(ready);
	  }
	  /**
	   * Get a clone of the current {@link Player~MediaObject} for this player.
	   *
	   * If the `loadMedia` method has not been used, will attempt to return a
	   * {@link Player~MediaObject} based on the current state of the player.
	   *
	   * @return {Player~MediaObject}
	   */
	  ;
	
	  _proto.getMedia = function getMedia() {
	    if (!this.cache_.media) {
	      var poster = this.poster();
	      var src = this.currentSources();
	      var textTracks = Array.prototype.map.call(this.remoteTextTracks(), function (tt) {
	        return {
	          kind: tt.kind,
	          label: tt.label,
	          language: tt.language,
	          src: tt.src
	        };
	      });
	      var media = {
	        src: src,
	        textTracks: textTracks
	      };
	
	      if (poster) {
	        media.poster = poster;
	        media.artwork = [{
	          src: media.poster,
	          type: getMimetype(media.poster)
	        }];
	      }
	
	      return media;
	    }
	
	    return mergeOptions$3(this.cache_.media);
	  }
	  /**
	   * Gets tag settings
	   *
	   * @param {Element} tag
	   *        The player tag
	   *
	   * @return {Object}
	   *         An object containing all of the settings
	   *         for a player tag
	   */
	  ;
	
	  Player.getTagSettings = function getTagSettings(tag) {
	    var baseOptions = {
	      sources: [],
	      tracks: []
	    };
	    var tagOptions = getAttributes(tag);
	    var dataSetup = tagOptions['data-setup'];
	
	    if (hasClass(tag, 'vjs-fill')) {
	      tagOptions.fill = true;
	    }
	
	    if (hasClass(tag, 'vjs-fluid')) {
	      tagOptions.fluid = true;
	    } // Check if data-setup attr exists.
	
	
	    if (dataSetup !== null) {
	      // Parse options JSON
	      // If empty string, make it a parsable json object.
	      var _safeParseTuple = safeParseTuple__default['default'](dataSetup || '{}'),
	          err = _safeParseTuple[0],
	          data = _safeParseTuple[1];
	
	      if (err) {
	        log$1.error(err);
	      }
	
	      assign(tagOptions, data);
	    }
	
	    assign(baseOptions, tagOptions); // Get tag children settings
	
	    if (tag.hasChildNodes()) {
	      var children = tag.childNodes;
	
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i]; // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
	
	        var childName = child.nodeName.toLowerCase();
	
	        if (childName === 'source') {
	          baseOptions.sources.push(getAttributes(child));
	        } else if (childName === 'track') {
	          baseOptions.tracks.push(getAttributes(child));
	        }
	      }
	    }
	
	    return baseOptions;
	  }
	  /**
	   * Determine whether or not flexbox is supported
	   *
	   * @return {boolean}
	   *         - true if flexbox is supported
	   *         - false if flexbox is not supported
	   */
	  ;
	
	  _proto.flexNotSupported_ = function flexNotSupported_() {
	    var elem = document__default['default'].createElement('i'); // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
	    // common flex features that we can rely on when checking for flex support.
	
	    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style || // IE10-specific (2012 flex spec), available for completeness
	    'msFlexOrder' in elem.style);
	  }
	  /**
	   * Set debug mode to enable/disable logs at info level.
	   *
	   * @param {boolean} enabled
	   * @fires Player#debugon
	   * @fires Player#debugoff
	   */
	  ;
	
	  _proto.debug = function debug(enabled) {
	    if (enabled === undefined) {
	      return this.debugEnabled_;
	    }
	
	    if (enabled) {
	      this.trigger('debugon');
	      this.previousLogLevel_ = this.log.level;
	      this.log.level('debug');
	      this.debugEnabled_ = true;
	    } else {
	      this.trigger('debugoff');
	      this.log.level(this.previousLogLevel_);
	      this.previousLogLevel_ = undefined;
	      this.debugEnabled_ = false;
	    }
	  }
	  /**
	   * Set or get current playback rates.
	   * Takes an array and updates the playback rates menu with the new items.
	   * Pass in an empty array to hide the menu.
	   * Values other than arrays are ignored.
	   *
	   * @fires Player#playbackrateschange
	   * @param {number[]} newRates
	   *                   The new rates that the playback rates menu should update to.
	   *                   An empty array will hide the menu
	   * @return {number[]} When used as a getter will return the current playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates(newRates) {
	    if (newRates === undefined) {
	      return this.cache_.playbackRates;
	    } // ignore any value that isn't an array
	
	
	    if (!Array.isArray(newRates)) {
	      return;
	    } // ignore any arrays that don't only contain numbers
	
	
	    if (!newRates.every(function (rate) {
	      return typeof rate === 'number';
	    })) {
	      return;
	    }
	
	    this.cache_.playbackRates = newRates;
	    /**
	    * fires when the playback rates in a player are changed
	    *
	    * @event Player#playbackrateschange
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('playbackrateschange');
	  };
	
	  return Player;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	 *
	 * @return {VideoTrackList}
	 *         the current video track list
	 *
	 * @method Player.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	 *
	 * @return {AudioTrackList}
	 *         the current audio track list
	 *
	 * @method Player.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	 *
	 * @return {TextTrackList}
	 *         the current text track list
	 *
	 * @method Player.prototype.textTracks
	 */
	
	/**
	 * Get the remote {@link TextTrackList}
	 *
	 * @return {TextTrackList}
	 *         The current remote text track list
	 *
	 * @method Player.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote {@link HtmlTrackElementList} tracks.
	 *
	 * @return {HtmlTrackElementList}
	 *         The current remote text track element list
	 *
	 * @method Player.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Player.prototype[props.getterName] = function () {
	    if (this.tech_) {
	      return this.tech_[props.getterName]();
	    } // if we have not yet loadTech_, we create {video,audio,text}Tracks_
	    // these will be passed to the tech during loading
	
	
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
	 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	 * behavior.
	 *
	 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	 *
	 * @param {string} [value]
	 *        The value to set the `Player`'s crossorigin to. If an argument is
	 *        given, must be one of `anonymous` or `use-credentials`.
	 *
	 * @return {string|undefined}
	 *         - The current crossorigin value of the `Player` when getting.
	 *         - undefined when setting
	 */
	
	Player.prototype.crossorigin = Player.prototype.crossOrigin;
	/**
	 * Global enumeration of players.
	 *
	 * The keys are the player IDs and the values are either the {@link Player}
	 * instance or `null` for disposed players.
	 *
	 * @type {Object}
	 */
	
	Player.players = {};
	var navigator = window__default['default'].navigator;
	/*
	 * Player instance options, surfaced using options
	 * options = Player.prototype.options_
	 * Make changes in options, not here.
	 *
	 * @type {Object}
	 * @private
	 */
	
	Player.prototype.options_ = {
	  // Default order of fallback technology
	  techOrder: Tech.defaultTechOrder_,
	  html5: {},
	  // default inactivity timeout
	  inactivityTimeout: 2000,
	  // default playback rates
	  playbackRates: [],
	  // Add playback rate selection by adding rates
	  // 'playbackRates': [0.5, 1, 1.5, 2],
	  liveui: false,
	  // Included control sets
	  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'liveTracker', 'controlBar', 'errorDisplay', 'textTrackSettings', 'resizeManager'],
	  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
	  // locales and their language translations
	  languages: {},
	  // Default message to show when a video cannot be played.
	  notSupportedMessage: 'No compatible source was found for this media.',
	  normalizeAutoplay: false,
	  fullscreen: {
	    options: {
	      navigationUI: 'hide'
	    }
	  },
	  breakpoints: {},
	  responsive: false,
	  audioOnlyMode: false,
	  audioPosterMode: false
	};
	[
	/**
	 * Returns whether or not the player is in the "ended" state.
	 *
	 * @return {Boolean} True if the player is in the ended state, false if not.
	 * @method Player#ended
	 */
	'ended',
	/**
	 * Returns whether or not the player is in the "seeking" state.
	 *
	 * @return {Boolean} True if the player is in the seeking state, false if not.
	 * @method Player#seeking
	 */
	'seeking',
	/**
	 * Returns the TimeRanges of the media that are currently available
	 * for seeking to.
	 *
	 * @return {TimeRanges} the seekable intervals of the media timeline
	 * @method Player#seekable
	 */
	'seekable',
	/**
	 * Returns the current state of network activity for the element, from
	 * the codes in the list below.
	 * - NETWORK_EMPTY (numeric value 0)
	 *   The element has not yet been initialised. All attributes are in
	 *   their initial states.
	 * - NETWORK_IDLE (numeric value 1)
	 *   The element's resource selection algorithm is active and has
	 *   selected a resource, but it is not actually using the network at
	 *   this time.
	 * - NETWORK_LOADING (numeric value 2)
	 *   The user agent is actively trying to download data.
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *   The element's resource selection algorithm is active, but it has
	 *   not yet found a resource to use.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
	 * @return {number} the current network activity state
	 * @method Player#networkState
	 */
	'networkState',
	/**
	 * Returns a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from the
	 * codes in the list below.
	 * - HAVE_NOTHING (numeric value 0)
	 *   No information regarding the media resource is available.
	 * - HAVE_METADATA (numeric value 1)
	 *   Enough of the resource has been obtained that the duration of the
	 *   resource is available.
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 *   Data for the immediate current playback position is available.
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 *   Data for the immediate current playback position is available, as
	 *   well as enough data for the user agent to advance the current
	 *   playback position in the direction of playback.
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *   The user agent estimates that enough data is available for
	 *   playback to proceed uninterrupted.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
	 * @return {number} the current playback rendering state
	 * @method Player#readyState
	 */
	'readyState'].forEach(function (fn) {
	  Player.prototype[fn] = function () {
	    return this.techGet_(fn);
	  };
	});
	TECH_EVENTS_RETRIGGER.forEach(function (event) {
	  Player.prototype["handleTech" + toTitleCase$1(event) + "_"] = function () {
	    return this.trigger(event);
	  };
	});
	/**
	 * Fired when the player has initial duration and dimension information
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the player has downloaded data at the current playback position
	 *
	 * @event Player#loadeddata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the current playback position has changed *
	 * During playback this is fired every 15-250 milliseconds, depending on the
	 * playback technology in use.
	 *
	 * @event Player#timeupdate
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the volume changes
	 *
	 * @event Player#volumechange
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Reports whether or not a player has a plugin available.
	 *
	 * This does not report whether or not the plugin has ever been initialized
	 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
	 *
	 * @method Player#hasPlugin
	 * @param  {string}  name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player has the requested plugin available.
	 */
	
	/**
	 * Reports whether or not a player is using a plugin by name.
	 *
	 * For basic plugins, this only reports whether the plugin has _ever_ been
	 * initialized on this player.
	 *
	 * @method Player#usingPlugin
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player is using the requested plugin.
	 */
	
	Component$1.registerComponent('Player', Player);
	
	/**
	 * The base plugin name.
	 *
	 * @private
	 * @constant
	 * @type {string}
	 */
	
	var BASE_PLUGIN_NAME = 'plugin';
	/**
	 * The key on which a player's active plugins cache is stored.
	 *
	 * @private
	 * @constant
	 * @type     {string}
	 */
	
	var PLUGIN_CACHE_KEY = 'activePlugins_';
	/**
	 * Stores registered plugins in a private space.
	 *
	 * @private
	 * @type    {Object}
	 */
	
	var pluginStorage = {};
	/**
	 * Reports whether or not a plugin has been registered.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {boolean}
	 *          Whether or not the plugin has been registered.
	 */
	
	var pluginExists = function pluginExists(name) {
	  return pluginStorage.hasOwnProperty(name);
	};
	/**
	 * Get a single registered plugin by name.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {Function|undefined}
	 *          The plugin (or undefined).
	 */
	
	
	var getPlugin = function getPlugin(name) {
	  return pluginExists(name) ? pluginStorage[name] : undefined;
	};
	/**
	 * Marks a plugin as "active" on a player.
	 *
	 * Also, ensures that the player has an object for tracking active plugins.
	 *
	 * @private
	 * @param   {Player} player
	 *          A Video.js player instance.
	 *
	 * @param   {string} name
	 *          The name of a plugin.
	 */
	
	
	var markPluginAsActive = function markPluginAsActive(player, name) {
	  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
	  player[PLUGIN_CACHE_KEY][name] = true;
	};
	/**
	 * Triggers a pair of plugin setup events.
	 *
	 * @private
	 * @param  {Player} player
	 *         A Video.js player instance.
	 *
	 * @param  {Plugin~PluginEventHash} hash
	 *         A plugin event hash.
	 *
	 * @param  {boolean} [before]
	 *         If true, prefixes the event name with "before". In other words,
	 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
	 */
	
	
	var triggerSetupEvent = function triggerSetupEvent(player, hash, before) {
	  var eventName = (before ? 'before' : '') + 'pluginsetup';
	  player.trigger(eventName, hash);
	  player.trigger(eventName + ':' + hash.name, hash);
	};
	/**
	 * Takes a basic plugin function and returns a wrapper function which marks
	 * on the player that the plugin has been activated.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Function} plugin
	 *          The basic plugin.
	 *
	 * @return {Function}
	 *          A wrapper function for the given plugin.
	 */
	
	
	var createBasicPlugin = function createBasicPlugin(name, plugin) {
	  var basicPluginWrapper = function basicPluginWrapper() {
	    // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
	    // regardless, but we want the hash to be consistent with the hash provided
	    // for advanced plugins.
	    //
	    // The only potentially counter-intuitive thing here is the `instance` in
	    // the "pluginsetup" event is the value returned by the `plugin` function.
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: null
	    }, true);
	    var instance = plugin.apply(this, arguments);
	    markPluginAsActive(this, name);
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: instance
	    });
	    return instance;
	  };
	
	  Object.keys(plugin).forEach(function (prop) {
	    basicPluginWrapper[prop] = plugin[prop];
	  });
	  return basicPluginWrapper;
	};
	/**
	 * Takes a plugin sub-class and returns a factory function for generating
	 * instances of it.
	 *
	 * This factory function will replace itself with an instance of the requested
	 * sub-class of Plugin.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Plugin} PluginSubClass
	 *          The advanced plugin.
	 *
	 * @return {Function}
	 */
	
	
	var createPluginFactory = function createPluginFactory(name, PluginSubClass) {
	  // Add a `name` property to the plugin prototype so that each plugin can
	  // refer to itself by name.
	  PluginSubClass.prototype.name = name;
	  return function () {
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: PluginSubClass,
	      instance: null
	    }, true);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var instance = _construct__default['default'](PluginSubClass, [this].concat(args)); // The plugin is replaced by a function that returns the current instance.
	
	
	    this[name] = function () {
	      return instance;
	    };
	
	    triggerSetupEvent(this, instance.getEventHash());
	    return instance;
	  };
	};
	/**
	 * Parent class for all advanced plugins.
	 *
	 * @mixes   module:evented~EventedMixin
	 * @mixes   module:stateful~StatefulMixin
	 * @fires   Player#beforepluginsetup
	 * @fires   Player#beforepluginsetup:$name
	 * @fires   Player#pluginsetup
	 * @fires   Player#pluginsetup:$name
	 * @listens Player#dispose
	 * @throws  {Error}
	 *          If attempting to instantiate the base {@link Plugin} class
	 *          directly instead of via a sub-class.
	 */
	
	
	var Plugin = /*#__PURE__*/function () {
	  /**
	   * Creates an instance of this class.
	   *
	   * Sub-classes should call `super` to ensure plugins are properly initialized.
	   *
	   * @param {Player} player
	   *        A Video.js player instance.
	   */
	  function Plugin(player) {
	    if (this.constructor === Plugin) {
	      throw new Error('Plugin must be sub-classed; not directly instantiated.');
	    }
	
	    this.player = player;
	
	    if (!this.log) {
	      this.log = this.player.log.createLogger(this.name);
	    } // Make this object evented, but remove the added `trigger` method so we
	    // use the prototype version instead.
	
	
	    evented(this);
	    delete this.trigger;
	    stateful(this, this.constructor.defaultState);
	    markPluginAsActive(player, this.name); // Auto-bind the dispose method so we can use it as a listener and unbind
	    // it later easily.
	
	    this.dispose = this.dispose.bind(this); // If the player is disposed, dispose the plugin.
	
	    player.on('dispose', this.dispose);
	  }
	  /**
	   * Get the version of the plugin that was set on <pluginName>.VERSION
	   */
	
	
	  var _proto = Plugin.prototype;
	
	  _proto.version = function version() {
	    return this.constructor.VERSION;
	  }
	  /**
	   * Each event triggered by plugins includes a hash of additional data with
	   * conventional properties.
	   *
	   * This returns that object or mutates an existing hash.
	   *
	   * @param   {Object} [hash={}]
	   *          An object to be used as event an event hash.
	   *
	   * @return {Plugin~PluginEventHash}
	   *          An event hash object with provided properties mixed-in.
	   */
	  ;
	
	  _proto.getEventHash = function getEventHash(hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    hash.name = this.name;
	    hash.plugin = this.constructor;
	    hash.instance = this;
	    return hash;
	  }
	  /**
	   * Triggers an event on the plugin object and overrides
	   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash={}]
	   *          Additional data hash to merge with a
	   *          {@link Plugin~PluginEventHash|PluginEventHash}.
	   *
	   * @return {boolean}
	   *          Whether or not default was prevented.
	   */
	  ;
	
	  _proto.trigger = function trigger$1(event, hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
	  }
	  /**
	   * Handles "statechanged" events on the plugin. No-op by default, override by
	   * subclassing.
	   *
	   * @abstract
	   * @param    {Event} e
	   *           An event object provided by a "statechanged" event.
	   *
	   * @param    {Object} e.changes
	   *           An object describing changes that occurred with the "statechanged"
	   *           event.
	   */
	  ;
	
	  _proto.handleStateChanged = function handleStateChanged(e) {}
	  /**
	   * Disposes a plugin.
	   *
	   * Subclasses can override this if they want, but for the sake of safety,
	   * it's probably best to subscribe the "dispose" event.
	   *
	   * @fires Plugin#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var name = this.name,
	        player = this.player;
	    /**
	     * Signals that a advanced plugin is about to be disposed.
	     *
	     * @event Plugin#dispose
	     * @type  {EventTarget~Event}
	     */
	
	    this.trigger('dispose');
	    this.off();
	    player.off('dispose', this.dispose); // Eliminate any possible sources of leaking memory by clearing up
	    // references between the player and the plugin instance and nulling out
	    // the plugin's state and replacing methods with a function that throws.
	
	    player[PLUGIN_CACHE_KEY][name] = false;
	    this.player = this.state = null; // Finally, replace the plugin name on the player with a new factory
	    // function, so that the plugin is ready to be set up again.
	
	    player[name] = createPluginFactory(name, pluginStorage[name]);
	  }
	  /**
	   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
	   *
	   * @param   {string|Function} plugin
	   *          If a string, matches the name of a plugin. If a function, will be
	   *          tested directly.
	   *
	   * @return {boolean}
	   *          Whether or not a plugin is a basic plugin.
	   */
	  ;
	
	  Plugin.isBasic = function isBasic(plugin) {
	    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;
	    return typeof p === 'function' && !Plugin.prototype.isPrototypeOf(p.prototype);
	  }
	  /**
	   * Register a Video.js plugin.
	   *
	   * @param   {string} name
	   *          The name of the plugin to be registered. Must be a string and
	   *          must not match an existing plugin or a method on the `Player`
	   *          prototype.
	   *
	   * @param   {Function} plugin
	   *          A sub-class of `Plugin` or a function for basic plugins.
	   *
	   * @return {Function}
	   *          For advanced plugins, a factory function for that plugin. For
	   *          basic plugins, a wrapper function that initializes the plugin.
	   */
	  ;
	
	  Plugin.registerPlugin = function registerPlugin(name, plugin) {
	    if (typeof name !== 'string') {
	      throw new Error("Illegal plugin name, \"" + name + "\", must be a string, was " + typeof name + ".");
	    }
	
	    if (pluginExists(name)) {
	      log$1.warn("A plugin named \"" + name + "\" already exists. You may want to avoid re-registering plugins!");
	    } else if (Player.prototype.hasOwnProperty(name)) {
	      throw new Error("Illegal plugin name, \"" + name + "\", cannot share a name with an existing player method!");
	    }
	
	    if (typeof plugin !== 'function') {
	      throw new Error("Illegal plugin for \"" + name + "\", must be a function, was " + typeof plugin + ".");
	    }
	
	    pluginStorage[name] = plugin; // Add a player prototype method for all sub-classed plugins (but not for
	    // the base Plugin class).
	
	    if (name !== BASE_PLUGIN_NAME) {
	      if (Plugin.isBasic(plugin)) {
	        Player.prototype[name] = createBasicPlugin(name, plugin);
	      } else {
	        Player.prototype[name] = createPluginFactory(name, plugin);
	      }
	    }
	
	    return plugin;
	  }
	  /**
	   * De-register a Video.js plugin.
	   *
	   * @param  {string} name
	   *         The name of the plugin to be de-registered. Must be a string that
	   *         matches an existing plugin.
	   *
	   * @throws {Error}
	   *         If an attempt is made to de-register the base plugin.
	   */
	  ;
	
	  Plugin.deregisterPlugin = function deregisterPlugin(name) {
	    if (name === BASE_PLUGIN_NAME) {
	      throw new Error('Cannot de-register base plugin.');
	    }
	
	    if (pluginExists(name)) {
	      delete pluginStorage[name];
	      delete Player.prototype[name];
	    }
	  }
	  /**
	   * Gets an object containing multiple Video.js plugins.
	   *
	   * @param   {Array} [names]
	   *          If provided, should be an array of plugin names. Defaults to _all_
	   *          plugin names.
	   *
	   * @return {Object|undefined}
	   *          An object containing plugin(s) associated with their name(s) or
	   *          `undefined` if no matching plugins exist).
	   */
	  ;
	
	  Plugin.getPlugins = function getPlugins(names) {
	    if (names === void 0) {
	      names = Object.keys(pluginStorage);
	    }
	
	    var result;
	    names.forEach(function (name) {
	      var plugin = getPlugin(name);
	
	      if (plugin) {
	        result = result || {};
	        result[name] = plugin;
	      }
	    });
	    return result;
	  }
	  /**
	   * Gets a plugin's version, if available
	   *
	   * @param   {string} name
	   *          The name of a plugin.
	   *
	   * @return {string}
	   *          The plugin's version or an empty string.
	   */
	  ;
	
	  Plugin.getPluginVersion = function getPluginVersion(name) {
	    var plugin = getPlugin(name);
	    return plugin && plugin.VERSION || '';
	  };
	
	  return Plugin;
	}();
	/**
	 * Gets a plugin by name if it exists.
	 *
	 * @static
	 * @method   getPlugin
	 * @memberOf Plugin
	 * @param    {string} name
	 *           The name of a plugin.
	 *
	 * @returns  {Function|undefined}
	 *           The plugin (or `undefined`).
	 */
	
	
	Plugin.getPlugin = getPlugin;
	/**
	 * The name of the base plugin class as it is registered.
	 *
	 * @type {string}
	 */
	
	Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
	Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	Player.prototype.usingPlugin = function (name) {
	  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
	};
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	
	Player.prototype.hasPlugin = function (name) {
	  return !!pluginExists(name);
	};
	/**
	 * Signals that a plugin is about to be set up on a player.
	 *
	 * @event    Player#beforepluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin is about to be set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#beforepluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player.
	 *
	 * @event    Player#pluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#pluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * @typedef  {Object} Plugin~PluginEventHash
	 *
	 * @property {string} instance
	 *           For basic plugins, the return value of the plugin function. For
	 *           advanced plugins, the plugin instance on which the event is fired.
	 *
	 * @property {string} name
	 *           The name of the plugin.
	 *
	 * @property {string} plugin
	 *           For basic plugins, the plugin function. For advanced plugins, the
	 *           plugin class/constructor.
	 */
	
	/**
	 * @file extend.js
	 * @module extend
	 */
	var hasLogged = false;
	/**
	 * Used to subclass an existing class by emulating ES subclassing using the
	 * `extends` keyword.
	 *
	 * @function
	 * @deprecated
	 * @example
	 * var MyComponent = videojs.extend(videojs.getComponent('Component'), {
	 *   myCustomMethod: function() {
	 *     // Do things in my method.
	 *   }
	 * });
	 *
	 * @param    {Function} superClass
	 *           The class to inherit from
	 *
	 * @param    {Object}   [subClassMethods={}]
	 *           Methods of the new class
	 *
	 * @return   {Function}
	 *           The new class with subClassMethods that inherited superClass.
	 */
	
	var extend = function extend(superClass, subClassMethods) {
	  if (subClassMethods === void 0) {
	    subClassMethods = {};
	  }
	
	  // Log a warning the first time extend is called to note that it is deprecated
	  // It was previously deprecated in our documentation (guides, specifically),
	  // but was never formally deprecated in code.
	  if (!hasLogged) {
	    log$1.warn('videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0');
	    hasLogged = true;
	  }
	
	  var subClass = function subClass() {
	    superClass.apply(this, arguments);
	  };
	
	  var methods = {};
	
	  if (typeof subClassMethods === 'object') {
	    if (subClassMethods.constructor !== Object.prototype.constructor) {
	      subClass = subClassMethods.constructor;
	    }
	
	    methods = subClassMethods;
	  } else if (typeof subClassMethods === 'function') {
	    subClass = subClassMethods;
	  }
	
	  _inherits__default['default'](subClass, superClass); // this is needed for backward-compatibility and node compatibility.
	
	
	  if (superClass) {
	    subClass.super_ = superClass;
	  } // Extend subObj's prototype with functions and other properties from props
	
	
	  for (var name in methods) {
	    if (methods.hasOwnProperty(name)) {
	      subClass.prototype[name] = methods[name];
	    }
	  }
	
	  return subClass;
	};
	
	/**
	 * @file video.js
	 * @module videojs
	 */
	/**
	 * Normalize an `id` value by trimming off a leading `#`
	 *
	 * @private
	 * @param   {string} id
	 *          A string, maybe with a leading `#`.
	 *
	 * @return {string}
	 *          The string, without any leading `#`.
	 */
	
	var normalizeId = function normalizeId(id) {
	  return id.indexOf('#') === 0 ? id.slice(1) : id;
	};
	/**
	 * The `videojs()` function doubles as the main function for users to create a
	 * {@link Player} instance as well as the main library namespace.
	 *
	 * It can also be used as a getter for a pre-existing {@link Player} instance.
	 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
	 * purpose because it avoids any potential for unintended initialization.
	 *
	 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	 * of our JSDoc template, we cannot properly document this as both a function
	 * and a namespace, so its function signature is documented here.
	 *
	 * #### Arguments
	 * ##### id
	 * string|Element, **required**
	 *
	 * Video element or video element ID.
	 *
	 * ##### options
	 * Object, optional
	 *
	 * Options object for providing settings.
	 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * ##### ready
	 * {@link Component~ReadyCallback}, optional
	 *
	 * A function to be called when the {@link Player} and {@link Tech} are ready.
	 *
	 * #### Return Value
	 *
	 * The `videojs()` function returns a {@link Player} instance.
	 *
	 * @namespace
	 *
	 * @borrows AudioTrack as AudioTrack
	 * @borrows Component.getComponent as getComponent
	 * @borrows module:computed-style~computedStyle as computedStyle
	 * @borrows module:events.on as on
	 * @borrows module:events.one as one
	 * @borrows module:events.off as off
	 * @borrows module:events.trigger as trigger
	 * @borrows EventTarget as EventTarget
	 * @borrows module:extend~extend as extend
	 * @borrows module:fn.bind as bind
	 * @borrows module:format-time.formatTime as formatTime
	 * @borrows module:format-time.resetFormatTime as resetFormatTime
	 * @borrows module:format-time.setFormatTime as setFormatTime
	 * @borrows module:merge-options.mergeOptions as mergeOptions
	 * @borrows module:middleware.use as use
	 * @borrows Player.players as players
	 * @borrows Plugin.registerPlugin as registerPlugin
	 * @borrows Plugin.deregisterPlugin as deregisterPlugin
	 * @borrows Plugin.getPlugins as getPlugins
	 * @borrows Plugin.getPlugin as getPlugin
	 * @borrows Plugin.getPluginVersion as getPluginVersion
	 * @borrows Tech.getTech as getTech
	 * @borrows Tech.registerTech as registerTech
	 * @borrows TextTrack as TextTrack
	 * @borrows module:time-ranges.createTimeRanges as createTimeRange
	 * @borrows module:time-ranges.createTimeRanges as createTimeRanges
	 * @borrows module:url.isCrossOrigin as isCrossOrigin
	 * @borrows module:url.parseUrl as parseUrl
	 * @borrows VideoTrack as VideoTrack
	 *
	 * @param  {string|Element} id
	 *         Video element or video element ID.
	 *
	 * @param  {Object} [options]
	 *         Options object for providing settings.
	 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * @param  {Component~ReadyCallback} [ready]
	 *         A function to be called when the {@link Player} and {@link Tech} are
	 *         ready.
	 *
	 * @return {Player}
	 *         The `videojs()` function returns a {@link Player|Player} instance.
	 */
	
	
	function videojs(id, options, ready) {
	  var player = videojs.getPlayer(id);
	
	  if (player) {
	    if (options) {
	      log$1.warn("Player \"" + id + "\" is already initialised. Options will not be applied.");
	    }
	
	    if (ready) {
	      player.ready(ready);
	    }
	
	    return player;
	  }
	
	  var el = typeof id === 'string' ? $('#' + normalizeId(id)) : id;
	
	  if (!isEl(el)) {
	    throw new TypeError('The element or ID supplied is not valid. (videojs)');
	  } // document.body.contains(el) will only check if el is contained within that one document.
	  // This causes problems for elements in iframes.
	  // Instead, use the element's ownerDocument instead of the global document.
	  // This will make sure that the element is indeed in the dom of that document.
	  // Additionally, check that the document in question has a default view.
	  // If the document is no longer attached to the dom, the defaultView of the document will be null.
	
	
	  if (!el.ownerDocument.defaultView || !el.ownerDocument.body.contains(el)) {
	    log$1.warn('The element supplied is not included in the DOM');
	  }
	
	  options = options || {}; // Store a copy of the el before modification, if it is to be restored in destroy()
	  // If div ingest, store the parent div
	
	  if (options.restoreEl === true) {
	    options.restoreEl = (el.parentNode && el.parentNode.hasAttribute('data-vjs-player') ? el.parentNode : el).cloneNode(true);
	  }
	
	  hooks('beforesetup').forEach(function (hookFunction) {
	    var opts = hookFunction(el, mergeOptions$3(options));
	
	    if (!isObject(opts) || Array.isArray(opts)) {
	      log$1.error('please return an object in beforesetup hooks');
	      return;
	    }
	
	    options = mergeOptions$3(options, opts);
	  }); // We get the current "Player" component here in case an integration has
	  // replaced it with a custom player.
	
	  var PlayerComponent = Component$1.getComponent('Player');
	  player = new PlayerComponent(el, options, ready);
	  hooks('setup').forEach(function (hookFunction) {
	    return hookFunction(player);
	  });
	  return player;
	}
	
	videojs.hooks_ = hooks_;
	videojs.hooks = hooks;
	videojs.hook = hook;
	videojs.hookOnce = hookOnce;
	videojs.removeHook = removeHook; // Add default styles
	
	if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
	  var style = $('.vjs-styles-defaults');
	
	  if (!style) {
	    style = createStyleElement('vjs-styles-defaults');
	    var head = $('head');
	
	    if (head) {
	      head.insertBefore(style, head.firstChild);
	    }
	
	    setTextContent(style, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
	  }
	} // Run Auto-load players
	// You have to wait at least once in case this script is loaded after your
	// video in the DOM (weird behavior only with minified version)
	
	
	autoSetupTimeout(1, videojs);
	/**
	 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
	 *
	 * @type {string}
	 */
	
	videojs.VERSION = version$5;
	/**
	 * The global options object. These are the settings that take effect
	 * if no overrides are specified when the player is created.
	 *
	 * @type {Object}
	 */
	
	videojs.options = Player.prototype.options_;
	/**
	 * Get an object with the currently created players, keyed by player ID
	 *
	 * @return {Object}
	 *         The created players
	 */
	
	videojs.getPlayers = function () {
	  return Player.players;
	};
	/**
	 * Get a single player based on an ID or DOM element.
	 *
	 * This is useful if you want to check if an element or ID has an associated
	 * Video.js player, but not create one if it doesn't.
	 *
	 * @param   {string|Element} id
	 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
	 *          or a string matching the `id` of such an element.
	 *
	 * @return {Player|undefined}
	 *          A player instance or `undefined` if there is no player instance
	 *          matching the argument.
	 */
	
	
	videojs.getPlayer = function (id) {
	  var players = Player.players;
	  var tag;
	
	  if (typeof id === 'string') {
	    var nId = normalizeId(id);
	    var player = players[nId];
	
	    if (player) {
	      return player;
	    }
	
	    tag = $('#' + nId);
	  } else {
	    tag = id;
	  }
	
	  if (isEl(tag)) {
	    var _tag = tag,
	        _player = _tag.player,
	        playerId = _tag.playerId; // Element may have a `player` property referring to an already created
	    // player instance. If so, return that.
	
	    if (_player || players[playerId]) {
	      return _player || players[playerId];
	    }
	  }
	};
	/**
	 * Returns an array of all current players.
	 *
	 * @return {Array}
	 *         An array of all players. The array will be in the order that
	 *         `Object.keys` provides, which could potentially vary between
	 *         JavaScript engines.
	 *
	 */
	
	
	videojs.getAllPlayers = function () {
	  return (// Disposed players leave a key with a `null` value, so we need to make sure
	    // we filter those out.
	    Object.keys(Player.players).map(function (k) {
	      return Player.players[k];
	    }).filter(Boolean)
	  );
	};
	
	videojs.players = Player.players;
	videojs.getComponent = Component$1.getComponent;
	/**
	 * Register a component so it can referred to by name. Used when adding to other
	 * components, either through addChild `component.addChild('myComponent')` or through
	 * default children options  `{ children: ['myComponent'] }`.
	 *
	 * > NOTE: You could also just initialize the component before adding.
	 * `component.addChild(new MyComponent());`
	 *
	 * @param {string} name
	 *        The class name of the component
	 *
	 * @param {Component} comp
	 *        The component class
	 *
	 * @return {Component}
	 *         The newly registered component
	 */
	
	videojs.registerComponent = function (name, comp) {
	  if (Tech.isTech(comp)) {
	    log$1.warn("The " + name + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");
	  }
	
	  Component$1.registerComponent.call(Component$1, name, comp);
	};
	
	videojs.getTech = Tech.getTech;
	videojs.registerTech = Tech.registerTech;
	videojs.use = use;
	/**
	 * An object that can be returned by a middleware to signify
	 * that the middleware is being terminated.
	 *
	 * @type {object}
	 * @property {object} middleware.TERMINATOR
	 */
	
	Object.defineProperty(videojs, 'middleware', {
	  value: {},
	  writeable: false,
	  enumerable: true
	});
	Object.defineProperty(videojs.middleware, 'TERMINATOR', {
	  value: TERMINATOR,
	  writeable: false,
	  enumerable: true
	});
	/**
	 * A reference to the {@link module:browser|browser utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:browser|browser}
	 */
	
	videojs.browser = browser;
	/**
	 * Use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED} instead; only
	 * included for backward-compatibility with 4.x.
	 *
	 * @deprecated Since version 5.0, use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED instead.
	 * @type {boolean}
	 */
	
	videojs.TOUCH_ENABLED = TOUCH_ENABLED;
	videojs.extend = extend;
	videojs.mergeOptions = mergeOptions$3;
	videojs.bind = bind;
	videojs.registerPlugin = Plugin.registerPlugin;
	videojs.deregisterPlugin = Plugin.deregisterPlugin;
	/**
	 * Deprecated method to register a plugin with Video.js
	 *
	 * @deprecated videojs.plugin() is deprecated; use videojs.registerPlugin() instead
	 *
	 * @param {string} name
	 *        The plugin name
	 *
	 * @param {Plugin|Function} plugin
	 *         The plugin sub-class or function
	 */
	
	videojs.plugin = function (name, plugin) {
	  log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
	  return Plugin.registerPlugin(name, plugin);
	};
	
	videojs.getPlugins = Plugin.getPlugins;
	videojs.getPlugin = Plugin.getPlugin;
	videojs.getPluginVersion = Plugin.getPluginVersion;
	/**
	 * Adding languages so that they're available to all players.
	 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	 *
	 * @param {string} code
	 *        The language code or dictionary property
	 *
	 * @param {Object} data
	 *        The data values to be translated
	 *
	 * @return {Object}
	 *         The resulting language dictionary object
	 */
	
	videojs.addLanguage = function (code, data) {
	  var _mergeOptions;
	
	  code = ('' + code).toLowerCase();
	  videojs.options.languages = mergeOptions$3(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
	  return videojs.options.languages[code];
	};
	/**
	 * A reference to the {@link module:log|log utility module} as an object.
	 *
	 * @type {Function}
	 * @see  {@link module:log|log}
	 */
	
	
	videojs.log = log$1;
	videojs.createLogger = createLogger;
	videojs.createTimeRange = videojs.createTimeRanges = createTimeRanges;
	videojs.formatTime = formatTime;
	videojs.setFormatTime = setFormatTime;
	videojs.resetFormatTime = resetFormatTime;
	videojs.parseUrl = parseUrl;
	videojs.isCrossOrigin = isCrossOrigin;
	videojs.EventTarget = EventTarget$2;
	videojs.on = on;
	videojs.one = one;
	videojs.off = off;
	videojs.trigger = trigger;
	/**
	 * A cross-browser XMLHttpRequest wrapper.
	 *
	 * @function
	 * @param    {Object} options
	 *           Settings for the request.
	 *
	 * @return   {XMLHttpRequest|XDomainRequest}
	 *           The request object.
	 *
	 * @see      https://github.com/Raynos/xhr
	 */
	
	videojs.xhr = XHR__default['default'];
	videojs.TextTrack = TextTrack;
	videojs.AudioTrack = AudioTrack;
	videojs.VideoTrack = VideoTrack;
	['isEl', 'isTextNode', 'createEl', 'hasClass', 'addClass', 'removeClass', 'toggleClass', 'setAttributes', 'getAttributes', 'emptyEl', 'appendContent', 'insertContent'].forEach(function (k) {
	  videojs[k] = function () {
	    log$1.warn("videojs." + k + "() is deprecated; use videojs.dom." + k + "() instead");
	    return Dom[k].apply(null, arguments);
	  };
	});
	videojs.computedStyle = computedStyle;
	/**
	 * A reference to the {@link module:dom|DOM utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:dom|dom}
	 */
	
	videojs.dom = Dom;
	/**
	 * A reference to the {@link module:url|URL utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:url|url}
	 */
	
	videojs.url = Url;
	videojs.defineLazyProperty = defineLazyProperty; // Adding less ambiguous text for fullscreen button.
	// In a major update this could become the default text and key.
	
	videojs.addLanguage('en', {
	  'Non-Fullscreen': 'Exit Fullscreen'
	});
	
	/*! @name @videojs/http-streaming @version 2.16.3 @license Apache-2.0 */
	/**
	 * @file resolve-url.js - Handling how URLs are resolved and manipulated
	 */
	
	var resolveUrl = _resolveUrl__default['default'];
	/**
	 * Checks whether xhr request was redirected and returns correct url depending
	 * on `handleManifestRedirects` option
	 *
	 * @api private
	 *
	 * @param  {string} url - an url being requested
	 * @param  {XMLHttpRequest} req - xhr request result
	 *
	 * @return {string}
	 */
	
	var resolveManifestRedirect = function resolveManifestRedirect(handleManifestRedirect, url, req) {
	  // To understand how the responseURL below is set and generated:
	  // - https://fetch.spec.whatwg.org/#concept-response-url
	  // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
	  if (handleManifestRedirect && req && req.responseURL && url !== req.responseURL) {
	    return req.responseURL;
	  }
	
	  return url;
	};
	
	var logger = function logger(source) {
	  if (videojs.log.debug) {
	    return videojs.log.debug.bind(videojs, 'VHS:', source + " >");
	  }
	
	  return function () {};
	};
	/**
	 * ranges
	 *
	 * Utilities for working with TimeRanges.
	 *
	 */
	
	
	var TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
	// can be misleading because of precision differences or when the current media has poorly
	// aligned audio and video, which can cause values to be slightly off from what you would
	// expect. This value is what we consider to be safe to use in such comparisons to account
	// for these scenarios.
	
	var SAFE_TIME_DELTA = TIME_FUDGE_FACTOR * 3;
	
	var filterRanges = function filterRanges(timeRanges, predicate) {
	  var results = [];
	  var i;
	
	  if (timeRanges && timeRanges.length) {
	    // Search for ranges that match the predicate
	    for (i = 0; i < timeRanges.length; i++) {
	      if (predicate(timeRanges.start(i), timeRanges.end(i))) {
	        results.push([timeRanges.start(i), timeRanges.end(i)]);
	      }
	    }
	  }
	
	  return videojs.createTimeRanges(results);
	};
	/**
	 * Attempts to find the buffered TimeRange that contains the specified
	 * time.
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object to query
	 * @param {number} time  - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object
	 */
	
	
	var findRange = function findRange(buffered, time) {
	  return filterRanges(buffered, function (start, end) {
	    return start - SAFE_TIME_DELTA <= time && end + SAFE_TIME_DELTA >= time;
	  });
	};
	/**
	 * Returns the TimeRanges that begin later than the specified time.
	 *
	 * @param {TimeRanges} timeRanges - the TimeRanges object to query
	 * @param {number} time - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object.
	 */
	
	
	var findNextRange = function findNextRange(timeRanges, time) {
	  return filterRanges(timeRanges, function (start) {
	    return start - TIME_FUDGE_FACTOR >= time;
	  });
	};
	/**
	 * Returns gaps within a list of TimeRanges
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object
	 * @return {TimeRanges} a TimeRanges object of gaps
	 */
	
	
	var findGaps = function findGaps(buffered) {
	  if (buffered.length < 2) {
	    return videojs.createTimeRanges();
	  }
	
	  var ranges = [];
	
	  for (var i = 1; i < buffered.length; i++) {
	    var start = buffered.end(i - 1);
	    var end = buffered.start(i);
	    ranges.push([start, end]);
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Calculate the intersection of two TimeRanges
	 *
	 * @param {TimeRanges} bufferA
	 * @param {TimeRanges} bufferB
	 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
	 */
	
	
	var bufferIntersection = function bufferIntersection(bufferA, bufferB) {
	  var start = null;
	  var end = null;
	  var arity = 0;
	  var extents = [];
	  var ranges = [];
	
	  if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) {
	    return videojs.createTimeRange();
	  } // Handle the case where we have both buffers and create an
	  // intersection of the two
	
	
	  var count = bufferA.length; // A) Gather up all start and end times
	
	  while (count--) {
	    extents.push({
	      time: bufferA.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferA.end(count),
	      type: 'end'
	    });
	  }
	
	  count = bufferB.length;
	
	  while (count--) {
	    extents.push({
	      time: bufferB.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferB.end(count),
	      type: 'end'
	    });
	  } // B) Sort them by time
	
	
	  extents.sort(function (a, b) {
	    return a.time - b.time;
	  }); // C) Go along one by one incrementing arity for start and decrementing
	  //    arity for ends
	
	  for (count = 0; count < extents.length; count++) {
	    if (extents[count].type === 'start') {
	      arity++; // D) If arity is ever incremented to 2 we are entering an
	      //    overlapping range
	
	      if (arity === 2) {
	        start = extents[count].time;
	      }
	    } else if (extents[count].type === 'end') {
	      arity--; // E) If arity is ever decremented to 1 we leaving an
	      //    overlapping range
	
	      if (arity === 1) {
	        end = extents[count].time;
	      }
	    } // F) Record overlapping ranges
	
	
	    if (start !== null && end !== null) {
	      ranges.push([start, end]);
	      start = null;
	      end = null;
	    }
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Gets a human readable string for a TimeRange
	 *
	 * @param {TimeRange} range
	 * @return {string} a human readable string
	 */
	
	
	var printableRange = function printableRange(range) {
	  var strArr = [];
	
	  if (!range || !range.length) {
	    return '';
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    strArr.push(range.start(i) + ' => ' + range.end(i));
	  }
	
	  return strArr.join(', ');
	};
	/**
	 * Calculates the amount of time left in seconds until the player hits the end of the
	 * buffer and causes a rebuffer
	 *
	 * @param {TimeRange} buffered
	 *        The state of the buffer
	 * @param {Numnber} currentTime
	 *        The current time of the player
	 * @param {number} playbackRate
	 *        The current playback rate of the player. Defaults to 1.
	 * @return {number}
	 *         Time until the player has to start rebuffering in seconds.
	 * @function timeUntilRebuffer
	 */
	
	
	var timeUntilRebuffer = function timeUntilRebuffer(buffered, currentTime, playbackRate) {
	  if (playbackRate === void 0) {
	    playbackRate = 1;
	  }
	
	  var bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
	  return (bufferedEnd - currentTime) / playbackRate;
	};
	/**
	 * Converts a TimeRanges object into an array representation
	 *
	 * @param {TimeRanges} timeRanges
	 * @return {Array}
	 */
	
	
	var timeRangesToArray = function timeRangesToArray(timeRanges) {
	  var timeRangesList = [];
	
	  for (var i = 0; i < timeRanges.length; i++) {
	    timeRangesList.push({
	      start: timeRanges.start(i),
	      end: timeRanges.end(i)
	    });
	  }
	
	  return timeRangesList;
	};
	/**
	 * Determines if two time range objects are different.
	 *
	 * @param {TimeRange} a
	 *        the first time range object to check
	 *
	 * @param {TimeRange} b
	 *        the second time range object to check
	 *
	 * @return {Boolean}
	 *         Whether the time range objects differ
	 */
	
	
	var isRangeDifferent = function isRangeDifferent(a, b) {
	  // same object
	  if (a === b) {
	    return false;
	  } // one or the other is undefined
	
	
	  if (!a && b || !b && a) {
	    return true;
	  } // length is different
	
	
	  if (a.length !== b.length) {
	    return true;
	  } // see if any start/end pair is different
	
	
	  for (var i = 0; i < a.length; i++) {
	    if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) {
	      return true;
	    }
	  } // if the length and every pair is the same
	  // this is the same time range
	
	
	  return false;
	};
	
	var lastBufferedEnd = function lastBufferedEnd(a) {
	  if (!a || !a.length || !a.end) {
	    return;
	  }
	
	  return a.end(a.length - 1);
	};
	/**
	 * A utility function to add up the amount of time in a timeRange
	 * after a specified startTime.
	 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
	 *     would return 40 as there are 40s seconds after 0 in the timeRange
	 *
	 * @param {TimeRange} range
	 *        The range to check against
	 * @param {number} startTime
	 *        The time in the time range that you should start counting from
	 *
	 * @return {number}
	 *          The number of seconds in the buffer passed the specified time.
	 */
	
	
	var timeAheadOf = function timeAheadOf(range, startTime) {
	  var time = 0;
	
	  if (!range || !range.length) {
	    return time;
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    var start = range.start(i);
	    var end = range.end(i); // startTime is after this range entirely
	
	    if (startTime > end) {
	      continue;
	    } // startTime is within this range
	
	
	    if (startTime > start && startTime <= end) {
	      time += end - startTime;
	      continue;
	    } // startTime is before this range.
	
	
	    time += end - start;
	  }
	
	  return time;
	};
	/**
	 * @file playlist.js
	 *
	 * Playlist related utilities.
	 */
	
	
	var createTimeRange = videojs.createTimeRange;
	/**
	 * Get the duration of a segment, with special cases for
	 * llhls segments that do not have a duration yet.
	 *
	 * @param {Object} playlist
	 *        the playlist that the segment belongs to.
	 * @param {Object} segment
	 *        the segment to get a duration for.
	 *
	 * @return {number}
	 *          the segment duration
	 */
	
	var segmentDurationWithParts = function segmentDurationWithParts(playlist, segment) {
	  // if this isn't a preload segment
	  // then we will have a segment duration that is accurate.
	  if (!segment.preload) {
	    return segment.duration;
	  } // otherwise we have to add up parts and preload hints
	  // to get an up to date duration.
	
	
	  var result = 0;
	  (segment.parts || []).forEach(function (p) {
	    result += p.duration;
	  }); // for preload hints we have to use partTargetDuration
	  // as they won't even have a duration yet.
	
	  (segment.preloadHints || []).forEach(function (p) {
	    if (p.type === 'PART') {
	      result += playlist.partTargetDuration;
	    }
	  });
	  return result;
	};
	/**
	 * A function to get a combined list of parts and segments with durations
	 * and indexes.
	 *
	 * @param {Playlist} playlist the playlist to get the list for.
	 *
	 * @return {Array} The part/segment list.
	 */
	
	
	var getPartsAndSegments = function getPartsAndSegments(playlist) {
	  return (playlist.segments || []).reduce(function (acc, segment, si) {
	    if (segment.parts) {
	      segment.parts.forEach(function (part, pi) {
	        acc.push({
	          duration: part.duration,
	          segmentIndex: si,
	          partIndex: pi,
	          part: part,
	          segment: segment
	        });
	      });
	    } else {
	      acc.push({
	        duration: segment.duration,
	        segmentIndex: si,
	        partIndex: null,
	        segment: segment,
	        part: null
	      });
	    }
	
	    return acc;
	  }, []);
	};
	
	var getLastParts = function getLastParts(media) {
	  var lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
	  return lastSegment && lastSegment.parts || [];
	};
	
	var getKnownPartCount = function getKnownPartCount(_ref) {
	  var preloadSegment = _ref.preloadSegment;
	
	  if (!preloadSegment) {
	    return;
	  }
	
	  var parts = preloadSegment.parts,
	      preloadHints = preloadSegment.preloadHints;
	  var partCount = (preloadHints || []).reduce(function (count, hint) {
	    return count + (hint.type === 'PART' ? 1 : 0);
	  }, 0);
	  partCount += parts && parts.length ? parts.length : 0;
	  return partCount;
	};
	/**
	 * Get the number of seconds to delay from the end of a
	 * live playlist.
	 *
	 * @param {Playlist} master the master playlist
	 * @param {Playlist} media the media playlist
	 * @return {number} the hold back in seconds.
	 */
	
	
	var liveEdgeDelay = function liveEdgeDelay(master, media) {
	  if (media.endList) {
	    return 0;
	  } // dash suggestedPresentationDelay trumps everything
	
	
	  if (master && master.suggestedPresentationDelay) {
	    return master.suggestedPresentationDelay;
	  }
	
	  var hasParts = getLastParts(media).length > 0; // look for "part" delays from ll-hls first
	
	  if (hasParts && media.serverControl && media.serverControl.partHoldBack) {
	    return media.serverControl.partHoldBack;
	  } else if (hasParts && media.partTargetDuration) {
	    return media.partTargetDuration * 3; // finally look for full segment delays
	  } else if (media.serverControl && media.serverControl.holdBack) {
	    return media.serverControl.holdBack;
	  } else if (media.targetDuration) {
	    return media.targetDuration * 3;
	  }
	
	  return 0;
	};
	/**
	 * walk backward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {Number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var backwardDuration = function backwardDuration(playlist, endSequence) {
	  var result = 0;
	  var i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
	  // the interval, use it
	
	  var segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
	  // information that is earlier than endSequence
	
	  if (segment) {
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start,
	        precise: true
	      };
	    }
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - segment.duration,
	        precise: true
	      };
	    }
	  }
	
	  while (i--) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: result + segment.end,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: result + segment.start,
	        precise: true
	      };
	    }
	  }
	
	  return {
	    result: result,
	    precise: false
	  };
	};
	/**
	 * walk forward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var forwardDuration = function forwardDuration(playlist, endSequence) {
	  var result = 0;
	  var segment;
	  var i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
	  // information
	
	  for (; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start - result,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - result,
	        precise: true
	      };
	    }
	  } // indicate we didn't find a useful duration estimate
	
	
	  return {
	    result: -1,
	    precise: false
	  };
	};
	/**
	  * Calculate the media duration from the segments associated with a
	  * playlist. The duration of a subinterval of the available segments
	  * may be calculated by specifying an end index.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper boundary
	  * for the playlist.  Defaults to playlist length.
	  * @param {number} expired the amount of time that has dropped
	  * off the front of the playlist in a live scenario
	  * @return {number} the duration between the first available segment
	  * and end index.
	  */
	
	
	var intervalDuration = function intervalDuration(playlist, endSequence, expired) {
	  if (typeof endSequence === 'undefined') {
	    endSequence = playlist.mediaSequence + playlist.segments.length;
	  }
	
	  if (endSequence < playlist.mediaSequence) {
	    return 0;
	  } // do a backward walk to estimate the duration
	
	
	  var backward = backwardDuration(playlist, endSequence);
	
	  if (backward.precise) {
	    // if we were able to base our duration estimate on timing
	    // information provided directly from the Media Source, return
	    // it
	    return backward.result;
	  } // walk forward to see if a precise duration estimate can be made
	  // that way
	
	
	  var forward = forwardDuration(playlist, endSequence);
	
	  if (forward.precise) {
	    // we found a segment that has been buffered and so it's
	    // position is known precisely
	    return forward.result;
	  } // return the less-precise, playlist-based duration estimate
	
	
	  return backward.result + expired;
	};
	/**
	  * Calculates the duration of a playlist. If a start and end index
	  * are specified, the duration will be for the subset of the media
	  * timeline between those two indices. The total duration for live
	  * playlists is always Infinity.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper
	  * boundary for the playlist. Defaults to the playlist media
	  * sequence number plus its length.
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @return {number} the duration between the start index and end
	  * index.
	  */
	
	
	var duration = function duration(playlist, endSequence, expired) {
	  if (!playlist) {
	    return 0;
	  }
	
	  if (typeof expired !== 'number') {
	    expired = 0;
	  } // if a slice of the total duration is not requested, use
	  // playlist-level duration indicators when they're present
	
	
	  if (typeof endSequence === 'undefined') {
	    // if present, use the duration specified in the playlist
	    if (playlist.totalDuration) {
	      return playlist.totalDuration;
	    } // duration should be Infinity for live playlists
	
	
	    if (!playlist.endList) {
	      return window__default['default'].Infinity;
	    }
	  } // calculate the total duration based on the segment durations
	
	
	  return intervalDuration(playlist, endSequence, expired);
	};
	/**
	  * Calculate the time between two indexes in the current playlist
	  * neight the start- nor the end-index need to be within the current
	  * playlist in which case, the targetDuration of the playlist is used
	  * to approximate the durations of the segments
	  *
	  * @param {Array} options.durationList list to iterate over for durations.
	  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
	  * @param {number} options.startIndex partsAndSegments index to start
	  * @param {number} options.endIndex partsAndSegments index to end.
	  * @return {number} the number of seconds between startIndex and endIndex
	  */
	
	
	var sumDurations = function sumDurations(_ref2) {
	  var defaultDuration = _ref2.defaultDuration,
	      durationList = _ref2.durationList,
	      startIndex = _ref2.startIndex,
	      endIndex = _ref2.endIndex;
	  var durations = 0;
	
	  if (startIndex > endIndex) {
	    var _ref3 = [endIndex, startIndex];
	    startIndex = _ref3[0];
	    endIndex = _ref3[1];
	  }
	
	  if (startIndex < 0) {
	    for (var i = startIndex; i < Math.min(0, endIndex); i++) {
	      durations += defaultDuration;
	    }
	
	    startIndex = 0;
	  }
	
	  for (var _i = startIndex; _i < endIndex; _i++) {
	    durations += durationList[_i].duration;
	  }
	
	  return durations;
	};
	/**
	 * Calculates the playlist end time
	 *
	 * @param {Object} playlist a media playlist object
	 * @param {number=} expired the amount of time that has
	 *                  dropped off the front of the playlist in a live scenario
	 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
	 *                        playlist end calculation should consider the safe live end
	 *                        (truncate the playlist end by three segments). This is normally
	 *                        used for calculating the end of the playlist's seekable range.
	 *                        This takes into account the value of liveEdgePadding.
	 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
	 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
	 *                 If this is provided, it is used in the safe live end calculation.
	 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
	 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
	 * @return {number} the end time of playlist
	 * @function playlistEnd
	 */
	
	
	var playlistEnd = function playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
	  if (!playlist || !playlist.segments) {
	    return null;
	  }
	
	  if (playlist.endList) {
	    return duration(playlist);
	  }
	
	  if (expired === null) {
	    return null;
	  }
	
	  expired = expired || 0;
	  var lastSegmentEndTime = intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
	
	  if (useSafeLiveEnd) {
	    liveEdgePadding = typeof liveEdgePadding === 'number' ? liveEdgePadding : liveEdgeDelay(null, playlist);
	    lastSegmentEndTime -= liveEdgePadding;
	  } // don't return a time less than zero
	
	
	  return Math.max(0, lastSegmentEndTime);
	};
	/**
	  * Calculates the interval of time that is currently seekable in a
	  * playlist. The returned time ranges are relative to the earliest
	  * moment in the specified playlist that is still available. A full
	  * seekable implementation for live streams would need to offset
	  * these values by the duration of content that has expired from the
	  * stream.
	  *
	  * @param {Object} playlist a media playlist object
	  * dropped off the front of the playlist in a live scenario
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
	  *        Corresponds to suggestedPresentationDelay in DASH manifests.
	  * @return {TimeRanges} the periods of time that are valid targets
	  * for seeking
	  */
	
	
	var seekable = function seekable(playlist, expired, liveEdgePadding) {
	  var useSafeLiveEnd = true;
	  var seekableStart = expired || 0;
	  var seekableEnd = playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
	
	  if (seekableEnd === null) {
	    return createTimeRange();
	  }
	
	  return createTimeRange(seekableStart, seekableEnd);
	};
	/**
	 * Determine the index and estimated starting time of the segment that
	 * contains a specified playback position in a media playlist.
	 *
	 * @param {Object} options.playlist the media playlist to query
	 * @param {number} options.currentTime The number of seconds since the earliest
	 * possible position to determine the containing segment for
	 * @param {number} options.startTime the time when the segment/part starts
	 * @param {number} options.startingSegmentIndex the segment index to start looking at.
	 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
	 *
	 * @return {Object} an object with partIndex, segmentIndex, and startTime.
	 */
	
	
	var getMediaInfoForTime = function getMediaInfoForTime(_ref4) {
	  var playlist = _ref4.playlist,
	      currentTime = _ref4.currentTime,
	      startingSegmentIndex = _ref4.startingSegmentIndex,
	      startingPartIndex = _ref4.startingPartIndex,
	      startTime = _ref4.startTime,
	      experimentalExactManifestTimings = _ref4.experimentalExactManifestTimings;
	  var time = currentTime - startTime;
	  var partsAndSegments = getPartsAndSegments(playlist);
	  var startIndex = 0;
	
	  for (var i = 0; i < partsAndSegments.length; i++) {
	    var partAndSegment = partsAndSegments[i];
	
	    if (startingSegmentIndex !== partAndSegment.segmentIndex) {
	      continue;
	    } // skip this if part index does not match.
	
	
	    if (typeof startingPartIndex === 'number' && typeof partAndSegment.partIndex === 'number' && startingPartIndex !== partAndSegment.partIndex) {
	      continue;
	    }
	
	    startIndex = i;
	    break;
	  }
	
	  if (time < 0) {
	    // Walk backward from startIndex in the playlist, adding durations
	    // until we find a segment that contains `time` and return it
	    if (startIndex > 0) {
	      for (var _i2 = startIndex - 1; _i2 >= 0; _i2--) {
	        var _partAndSegment = partsAndSegments[_i2];
	        time += _partAndSegment.duration;
	
	        if (experimentalExactManifestTimings) {
	          if (time < 0) {
	            continue;
	          }
	        } else if (time + TIME_FUDGE_FACTOR <= 0) {
	          continue;
	        }
	
	        return {
	          partIndex: _partAndSegment.partIndex,
	          segmentIndex: _partAndSegment.segmentIndex,
	          startTime: startTime - sumDurations({
	            defaultDuration: playlist.targetDuration,
	            durationList: partsAndSegments,
	            startIndex: startIndex,
	            endIndex: _i2
	          })
	        };
	      }
	    } // We were unable to find a good segment within the playlist
	    // so select the first segment
	
	
	    return {
	      partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	      segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	      startTime: currentTime
	    };
	  } // When startIndex is negative, we first walk forward to first segment
	  // adding target durations. If we "run out of time" before getting to
	  // the first segment, return the first segment
	
	
	  if (startIndex < 0) {
	    for (var _i3 = startIndex; _i3 < 0; _i3++) {
	      time -= playlist.targetDuration;
	
	      if (time < 0) {
	        return {
	          partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	          segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	          startTime: currentTime
	        };
	      }
	    }
	
	    startIndex = 0;
	  } // Walk forward from startIndex in the playlist, subtracting durations
	  // until we find a segment that contains `time` and return it
	
	
	  for (var _i4 = startIndex; _i4 < partsAndSegments.length; _i4++) {
	    var _partAndSegment2 = partsAndSegments[_i4];
	    time -= _partAndSegment2.duration;
	
	    if (experimentalExactManifestTimings) {
	      if (time > 0) {
	        continue;
	      }
	    } else if (time - TIME_FUDGE_FACTOR >= 0) {
	      continue;
	    }
	
	    return {
	      partIndex: _partAndSegment2.partIndex,
	      segmentIndex: _partAndSegment2.segmentIndex,
	      startTime: startTime + sumDurations({
	        defaultDuration: playlist.targetDuration,
	        durationList: partsAndSegments,
	        startIndex: startIndex,
	        endIndex: _i4
	      })
	    };
	  } // We are out of possible candidates so load the last one...
	
	
	  return {
	    segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
	    partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
	    startTime: currentTime
	  };
	};
	/**
	 * Check whether the playlist is blacklisted or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is blacklisted or not
	 * @function isBlacklisted
	 */
	
	
	var isBlacklisted = function isBlacklisted(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil > Date.now();
	};
	/**
	 * Check whether the playlist is compatible with current playback configuration or has
	 * been blacklisted permanently for being incompatible.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is incompatible or not
	 * @function isIncompatible
	 */
	
	
	var isIncompatible = function isIncompatible(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil === Infinity;
	};
	/**
	 * Check whether the playlist is enabled or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is enabled or not
	 * @function isEnabled
	 */
	
	
	var isEnabled = function isEnabled(playlist) {
	  var blacklisted = isBlacklisted(playlist);
	  return !playlist.disabled && !blacklisted;
	};
	/**
	 * Check whether the playlist has been manually disabled through the representations api.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is disabled manually or not
	 * @function isDisabled
	 */
	
	
	var isDisabled = function isDisabled(playlist) {
	  return playlist.disabled;
	};
	/**
	 * Returns whether the current playlist is an AES encrypted HLS stream
	 *
	 * @return {boolean} true if it's an AES encrypted HLS stream
	 */
	
	
	var isAes = function isAes(media) {
	  for (var i = 0; i < media.segments.length; i++) {
	    if (media.segments[i].key) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Checks if the playlist has a value for the specified attribute
	 *
	 * @param {string} attr
	 *        Attribute to check for
	 * @param {Object} playlist
	 *        The media playlist object
	 * @return {boolean}
	 *         Whether the playlist contains a value for the attribute or not
	 * @function hasAttribute
	 */
	
	
	var hasAttribute = function hasAttribute(attr, playlist) {
	  return playlist.attributes && playlist.attributes[attr];
	};
	/**
	 * Estimates the time required to complete a segment download from the specified playlist
	 *
	 * @param {number} segmentDuration
	 *        Duration of requested segment
	 * @param {number} bandwidth
	 *        Current measured bandwidth of the player
	 * @param {Object} playlist
	 *        The media playlist object
	 * @param {number=} bytesReceived
	 *        Number of bytes already received for the request. Defaults to 0
	 * @return {number|NaN}
	 *         The estimated time to request the segment. NaN if bandwidth information for
	 *         the given playlist is unavailable
	 * @function estimateSegmentRequestTime
	 */
	
	
	var estimateSegmentRequestTime = function estimateSegmentRequestTime(segmentDuration, bandwidth, playlist, bytesReceived) {
	  if (bytesReceived === void 0) {
	    bytesReceived = 0;
	  }
	
	  if (!hasAttribute('BANDWIDTH', playlist)) {
	    return NaN;
	  }
	
	  var size = segmentDuration * playlist.attributes.BANDWIDTH;
	  return (size - bytesReceived * 8) / bandwidth;
	};
	/*
	 * Returns whether the current playlist is the lowest rendition
	 *
	 * @return {Boolean} true if on lowest rendition
	 */
	
	
	var isLowestEnabledRendition = function isLowestEnabledRendition(master, media) {
	  if (master.playlists.length === 1) {
	    return true;
	  }
	
	  var currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
	  return master.playlists.filter(function (playlist) {
	    if (!isEnabled(playlist)) {
	      return false;
	    }
	
	    return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
	  }).length === 0;
	};
	
	var playlistMatch = function playlistMatch(a, b) {
	  // both playlits are null
	  // or only one playlist is non-null
	  // no match
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // playlist objects are the same, match
	
	
	  if (a === b) {
	    return true;
	  } // first try to use id as it should be the most
	  // accurate
	
	
	  if (a.id && b.id && a.id === b.id) {
	    return true;
	  } // next try to use reslovedUri as it should be the
	  // second most accurate.
	
	
	  if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) {
	    return true;
	  } // finally try to use uri as it should be accurate
	  // but might miss a few cases for relative uris
	
	
	  if (a.uri && b.uri && a.uri === b.uri) {
	    return true;
	  }
	
	  return false;
	};
	
	var someAudioVariant = function someAudioVariant(master, callback) {
	  var AUDIO = master && master.mediaGroups && master.mediaGroups.AUDIO || {};
	  var found = false;
	
	  for (var groupName in AUDIO) {
	    for (var label in AUDIO[groupName]) {
	      found = callback(AUDIO[groupName][label]);
	
	      if (found) {
	        break;
	      }
	    }
	
	    if (found) {
	      break;
	    }
	  }
	
	  return !!found;
	};
	
	var isAudioOnly = function isAudioOnly(master) {
	  // we are audio only if we have no main playlists but do
	  // have media group playlists.
	  if (!master || !master.playlists || !master.playlists.length) {
	    // without audio variants or playlists this
	    // is not an audio only master.
	    var found = someAudioVariant(master, function (variant) {
	      return variant.playlists && variant.playlists.length || variant.uri;
	    });
	    return found;
	  } // if every playlist has only an audio codec it is audio only
	
	
	  var _loop = function _loop(i) {
	    var playlist = master.playlists[i];
	    var CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
	
	    if (CODECS && CODECS.split(',').every(function (c) {
	      return codecs_js.isAudioCodec(c);
	    })) {
	      return "continue";
	    } // playlist is in an audio group it is audio only
	
	
	    var found = someAudioVariant(master, function (variant) {
	      return playlistMatch(playlist, variant);
	    });
	
	    if (found) {
	      return "continue";
	    } // if we make it here this playlist isn't audio and we
	    // are not audio only
	
	
	    return {
	      v: false
	    };
	  };
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    var _ret = _loop(i);
	
	    if (_ret === "continue") continue;
	    if (typeof _ret === "object") return _ret.v;
	  } // if we make it past every playlist without returning, then
	  // this is an audio only playlist.
	
	
	  return true;
	}; // exports
	
	
	var Playlist = {
	  liveEdgeDelay: liveEdgeDelay,
	  duration: duration,
	  seekable: seekable,
	  getMediaInfoForTime: getMediaInfoForTime,
	  isEnabled: isEnabled,
	  isDisabled: isDisabled,
	  isBlacklisted: isBlacklisted,
	  isIncompatible: isIncompatible,
	  playlistEnd: playlistEnd,
	  isAes: isAes,
	  hasAttribute: hasAttribute,
	  estimateSegmentRequestTime: estimateSegmentRequestTime,
	  isLowestEnabledRendition: isLowestEnabledRendition,
	  isAudioOnly: isAudioOnly,
	  playlistMatch: playlistMatch,
	  segmentDurationWithParts: segmentDurationWithParts
	};
	var log = videojs.log;
	
	var createPlaylistID = function createPlaylistID(index, uri) {
	  return index + "-" + uri;
	}; // default function for creating a group id
	
	
	var groupID = function groupID(type, group, label) {
	  return "placeholder-uri-" + type + "-" + group + "-" + label;
	};
	/**
	 * Parses a given m3u8 playlist
	 *
	 * @param {Function} [onwarn]
	 *        a function to call when the parser triggers a warning event.
	 * @param {Function} [oninfo]
	 *        a function to call when the parser triggers an info event.
	 * @param {string} manifestString
	 *        The downloaded manifest string
	 * @param {Object[]} [customTagParsers]
	 *        An array of custom tag parsers for the m3u8-parser instance
	 * @param {Object[]} [customTagMappers]
	 *        An array of custom tag mappers for the m3u8-parser instance
	 * @param {boolean} [experimentalLLHLS=false]
	 *        Whether to keep ll-hls features in the manifest after parsing.
	 * @return {Object}
	 *         The manifest object
	 */
	
	
	var parseManifest = function parseManifest(_ref) {
	  var onwarn = _ref.onwarn,
	      oninfo = _ref.oninfo,
	      manifestString = _ref.manifestString,
	      _ref$customTagParsers = _ref.customTagParsers,
	      customTagParsers = _ref$customTagParsers === void 0 ? [] : _ref$customTagParsers,
	      _ref$customTagMappers = _ref.customTagMappers,
	      customTagMappers = _ref$customTagMappers === void 0 ? [] : _ref$customTagMappers,
	      experimentalLLHLS = _ref.experimentalLLHLS;
	  var parser = new m3u8Parser.Parser();
	
	  if (onwarn) {
	    parser.on('warn', onwarn);
	  }
	
	  if (oninfo) {
	    parser.on('info', oninfo);
	  }
	
	  customTagParsers.forEach(function (customParser) {
	    return parser.addParser(customParser);
	  });
	  customTagMappers.forEach(function (mapper) {
	    return parser.addTagMapper(mapper);
	  });
	  parser.push(manifestString);
	  parser.end();
	  var manifest = parser.manifest; // remove llhls features from the parsed manifest
	  // if we don't want llhls support.
	
	  if (!experimentalLLHLS) {
	    ['preloadSegment', 'skip', 'serverControl', 'renditionReports', 'partInf', 'partTargetDuration'].forEach(function (k) {
	      if (manifest.hasOwnProperty(k)) {
	        delete manifest[k];
	      }
	    });
	
	    if (manifest.segments) {
	      manifest.segments.forEach(function (segment) {
	        ['parts', 'preloadHints'].forEach(function (k) {
	          if (segment.hasOwnProperty(k)) {
	            delete segment[k];
	          }
	        });
	      });
	    }
	  }
	
	  if (!manifest.targetDuration) {
	    var targetDuration = 10;
	
	    if (manifest.segments && manifest.segments.length) {
	      targetDuration = manifest.segments.reduce(function (acc, s) {
	        return Math.max(acc, s.duration);
	      }, 0);
	    }
	
	    if (onwarn) {
	      onwarn("manifest has no targetDuration defaulting to " + targetDuration);
	    }
	
	    manifest.targetDuration = targetDuration;
	  }
	
	  var parts = getLastParts(manifest);
	
	  if (parts.length && !manifest.partTargetDuration) {
	    var partTargetDuration = parts.reduce(function (acc, p) {
	      return Math.max(acc, p.duration);
	    }, 0);
	
	    if (onwarn) {
	      onwarn("manifest has no partTargetDuration defaulting to " + partTargetDuration);
	      log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');
	    }
	
	    manifest.partTargetDuration = partTargetDuration;
	  }
	
	  return manifest;
	};
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	
	
	var forEachMediaGroup = function forEachMediaGroup(master, callback) {
	  if (!master.mediaGroups) {
	    return;
	  }
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (mediaType) {
	    if (!master.mediaGroups[mediaType]) {
	      return;
	    }
	
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	/**
	 * Adds properties and attributes to the playlist to keep consistent functionality for
	 * playlists throughout VHS.
	 *
	 * @param {Object} config
	 *        Arguments object
	 * @param {Object} config.playlist
	 *        The media playlist
	 * @param {string} [config.uri]
	 *        The uri to the media playlist (if media playlist is not from within a master
	 *        playlist)
	 * @param {string} id
	 *        ID to use for the playlist
	 */
	
	
	var setupMediaPlaylist = function setupMediaPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      uri = _ref2.uri,
	      id = _ref2.id;
	  playlist.id = id;
	  playlist.playlistErrors_ = 0;
	
	  if (uri) {
	    // For media playlists, m3u8-parser does not have access to a URI, as HLS media
	    // playlists do not contain their own source URI, but one is needed for consistency in
	    // VHS.
	    playlist.uri = uri;
	  } // For HLS master playlists, even though certain attributes MUST be defined, the
	  // stream may still be played without them.
	  // For HLS media playlists, m3u8-parser does not attach an attributes object to the
	  // manifest.
	  //
	  // To avoid undefined reference errors through the project, and make the code easier
	  // to write/read, add an empty attributes object for these cases.
	
	
	  playlist.attributes = playlist.attributes || {};
	};
	/**
	 * Adds ID, resolvedUri, and attributes properties to each playlist of the master, where
	 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
	 * playlist references to the playlists array.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var setupMediaPlaylists = function setupMediaPlaylists(master) {
	  var i = master.playlists.length;
	
	  while (i--) {
	    var playlist = master.playlists[i];
	    setupMediaPlaylist({
	      playlist: playlist,
	      id: createPlaylistID(i, playlist.uri)
	    });
	    playlist.resolvedUri = resolveUrl(master.uri, playlist.uri);
	    master.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
	
	    master.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
	    // the stream can be played without it. Although an attributes property may have been
	    // added to the playlist to prevent undefined references, issue a warning to fix the
	    // manifest.
	
	    if (!playlist.attributes.BANDWIDTH) {
	      log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
	    }
	  }
	};
	/**
	 * Adds resolvedUri properties to each media group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var resolveMediaGroupUris = function resolveMediaGroupUris(master) {
	  forEachMediaGroup(master, function (properties) {
	    if (properties.uri) {
	      properties.resolvedUri = resolveUrl(master.uri, properties.uri);
	    }
	  });
	};
	/**
	 * Creates a master playlist wrapper to insert a sole media playlist into.
	 *
	 * @param {Object} media
	 *        Media playlist
	 * @param {string} uri
	 *        The media URI
	 *
	 * @return {Object}
	 *         Master playlist
	 */
	
	
	var masterForMedia = function masterForMedia(media, uri) {
	  var id = createPlaylistID(0, uri);
	  var master = {
	    mediaGroups: {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    },
	    uri: window__default['default'].location.href,
	    resolvedUri: window__default['default'].location.href,
	    playlists: [{
	      uri: uri,
	      id: id,
	      resolvedUri: uri,
	      // m3u8-parser does not attach an attributes property to media playlists so make
	      // sure that the property is attached to avoid undefined reference errors
	      attributes: {}
	    }]
	  }; // set up ID reference
	
	  master.playlists[id] = master.playlists[0]; // URI reference added for backwards compatibility
	
	  master.playlists[uri] = master.playlists[0];
	  return master;
	};
	/**
	 * Does an in-place update of the master manifest to add updated playlist URI references
	 * as well as other properties needed by VHS that aren't included by the parser.
	 *
	 * @param {Object} master
	 *        Master manifest object
	 * @param {string} uri
	 *        The source URI
	 * @param {function} createGroupID
	 *        A function to determine how to create the groupID for mediaGroups
	 */
	
	
	var addPropertiesToMaster = function addPropertiesToMaster(master, uri, createGroupID) {
	  if (createGroupID === void 0) {
	    createGroupID = groupID;
	  }
	
	  master.uri = uri;
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    if (!master.playlists[i].uri) {
	      // Set up phony URIs for the playlists since playlists are referenced by their URIs
	      // throughout VHS, but some formats (e.g., DASH) don't have external URIs
	      // TODO: consider adding dummy URIs in mpd-parser
	      var phonyUri = "placeholder-uri-" + i;
	      master.playlists[i].uri = phonyUri;
	    }
	  }
	
	  var audioOnlyMaster = isAudioOnly(master);
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    // add a playlist array under properties
	    if (!properties.playlists || !properties.playlists.length) {
	      // If the manifest is audio only and this media group does not have a uri, check
	      // if the media group is located in the main list of playlists. If it is, don't add
	      // placeholder properties as it shouldn't be considered an alternate audio track.
	      if (audioOnlyMaster && mediaType === 'AUDIO' && !properties.uri) {
	        for (var _i = 0; _i < master.playlists.length; _i++) {
	          var p = master.playlists[_i];
	
	          if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) {
	            return;
	          }
	        }
	      }
	
	      properties.playlists = [_extends__default['default']({}, properties)];
	    }
	
	    properties.playlists.forEach(function (p, i) {
	      var groupId = createGroupID(mediaType, groupKey, labelKey, p);
	      var id = createPlaylistID(i, groupId);
	
	      if (p.uri) {
	        p.resolvedUri = p.resolvedUri || resolveUrl(master.uri, p.uri);
	      } else {
	        // DEPRECATED, this has been added to prevent a breaking change.
	        // previously we only ever had a single media group playlist, so
	        // we mark the first playlist uri without prepending the index as we used to
	        // ideally we would do all of the playlists the same way.
	        p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
	        // the placeholder again
	
	        p.resolvedUri = p.uri;
	      }
	
	      p.id = p.id || id; // add an empty attributes object, all playlists are
	      // expected to have this.
	
	      p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
	
	      master.playlists[p.id] = p;
	      master.playlists[p.uri] = p;
	    });
	  });
	  setupMediaPlaylists(master);
	  resolveMediaGroupUris(master);
	};
	
	var mergeOptions$2 = videojs.mergeOptions,
	    EventTarget$1 = videojs.EventTarget;
	
	var addLLHLSQueryDirectives = function addLLHLSQueryDirectives(uri, media) {
	  if (media.endList || !media.serverControl) {
	    return uri;
	  }
	
	  var parameters = {};
	
	  if (media.serverControl.canBlockReload) {
	    var preloadSegment = media.preloadSegment; // next msn is a zero based value, length is not.
	
	    var nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
	    // that we are going to request a part of that preload segment.
	    // the logic below is used to determine that.
	
	    if (preloadSegment) {
	      var parts = preloadSegment.parts || []; // _HLS_part is a zero based index
	
	      var nextPart = getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
	      // length of parts, then we know we had part preload hints
	      // and we need to add the _HLS_part= query
	
	      if (nextPart > -1 && nextPart !== parts.length - 1) {
	        // add existing parts to our preload hints
	        // eslint-disable-next-line
	        parameters._HLS_part = nextPart;
	      } // this if statement makes sure that we request the msn
	      // of the preload segment if:
	      // 1. the preload segment had parts (and was not yet a full segment)
	      //    but was added to our segments array
	      // 2. the preload segment had preload hints for parts that are not in
	      //    the manifest yet.
	      // in all other cases we want the segment after the preload segment
	      // which will be given by using media.segments.length because it is 1 based
	      // rather than 0 based.
	
	
	      if (nextPart > -1 || parts.length) {
	        nextMSN--;
	      }
	    } // add _HLS_msn= in front of any _HLS_part query
	    // eslint-disable-next-line
	
	
	    parameters._HLS_msn = nextMSN;
	  }
	
	  if (media.serverControl && media.serverControl.canSkipUntil) {
	    // add _HLS_skip= infront of all other queries.
	    // eslint-disable-next-line
	    parameters._HLS_skip = media.serverControl.canSkipDateranges ? 'v2' : 'YES';
	  }
	
	  if (Object.keys(parameters).length) {
	    var parsedUri = new window__default['default'].URL(uri);
	    ['_HLS_skip', '_HLS_msn', '_HLS_part'].forEach(function (name) {
	      if (!parameters.hasOwnProperty(name)) {
	        return;
	      }
	
	      parsedUri.searchParams.set(name, parameters[name]);
	    });
	    uri = parsedUri.toString();
	  }
	
	  return uri;
	};
	/**
	 * Returns a new segment object with properties and
	 * the parts array merged.
	 *
	 * @param {Object} a the old segment
	 * @param {Object} b the new segment
	 *
	 * @return {Object} the merged segment
	 */
	
	
	var updateSegment = function updateSegment(a, b) {
	  if (!a) {
	    return b;
	  }
	
	  var result = mergeOptions$2(a, b); // if only the old segment has preload hints
	  // and the new one does not, remove preload hints.
	
	  if (a.preloadHints && !b.preloadHints) {
	    delete result.preloadHints;
	  } // if only the old segment has parts
	  // then the parts are no longer valid
	
	
	  if (a.parts && !b.parts) {
	    delete result.parts; // if both segments have parts
	    // copy part propeties from the old segment
	    // to the new one.
	  } else if (a.parts && b.parts) {
	    for (var i = 0; i < b.parts.length; i++) {
	      if (a.parts && a.parts[i]) {
	        result.parts[i] = mergeOptions$2(a.parts[i], b.parts[i]);
	      }
	    }
	  } // set skipped to false for segments that have
	  // have had information merged from the old segment.
	
	
	  if (!a.skipped && b.skipped) {
	    result.skipped = false;
	  } // set preload to false for segments that have
	  // had information added in the new segment.
	
	
	  if (a.preload && !b.preload) {
	    result.preload = false;
	  }
	
	  return result;
	};
	/**
	 * Returns a new array of segments that is the result of merging
	 * properties from an older list of segments onto an updated
	 * list. No properties on the updated playlist will be ovewritten.
	 *
	 * @param {Array} original the outdated list of segments
	 * @param {Array} update the updated list of segments
	 * @param {number=} offset the index of the first update
	 * segment in the original segment list. For non-live playlists,
	 * this should always be zero and does not need to be
	 * specified. For live playlists, it should be the difference
	 * between the media sequence numbers in the original and updated
	 * playlists.
	 * @return {Array} a list of merged segment objects
	 */
	
	
	var updateSegments = function updateSegments(original, update, offset) {
	  var oldSegments = original.slice();
	  var newSegments = update.slice();
	  offset = offset || 0;
	  var result = [];
	  var currentMap;
	
	  for (var newIndex = 0; newIndex < newSegments.length; newIndex++) {
	    var oldSegment = oldSegments[newIndex + offset];
	    var newSegment = newSegments[newIndex];
	
	    if (oldSegment) {
	      currentMap = oldSegment.map || currentMap;
	      result.push(updateSegment(oldSegment, newSegment));
	    } else {
	      // carry over map to new segment if it is missing
	      if (currentMap && !newSegment.map) {
	        newSegment.map = currentMap;
	      }
	
	      result.push(newSegment);
	    }
	  }
	
	  return result;
	};
	
	var resolveSegmentUris = function resolveSegmentUris(segment, baseUri) {
	  // preloadSegment will not have a uri at all
	  // as the segment isn't actually in the manifest yet, only parts
	  if (!segment.resolvedUri && segment.uri) {
	    segment.resolvedUri = resolveUrl(baseUri, segment.uri);
	  }
	
	  if (segment.key && !segment.key.resolvedUri) {
	    segment.key.resolvedUri = resolveUrl(baseUri, segment.key.uri);
	  }
	
	  if (segment.map && !segment.map.resolvedUri) {
	    segment.map.resolvedUri = resolveUrl(baseUri, segment.map.uri);
	  }
	
	  if (segment.map && segment.map.key && !segment.map.key.resolvedUri) {
	    segment.map.key.resolvedUri = resolveUrl(baseUri, segment.map.key.uri);
	  }
	
	  if (segment.parts && segment.parts.length) {
	    segment.parts.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	
	  if (segment.preloadHints && segment.preloadHints.length) {
	    segment.preloadHints.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	};
	
	var getAllSegments = function getAllSegments(media) {
	  var segments = media.segments || [];
	  var preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
	  // a usable segment, only include a preloadSegment that has
	  // parts.
	
	  if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
	    // if preloadHints has a MAP that means that the
	    // init segment is going to change. We cannot use any of the parts
	    // from this preload segment.
	    if (preloadSegment.preloadHints) {
	      for (var i = 0; i < preloadSegment.preloadHints.length; i++) {
	        if (preloadSegment.preloadHints[i].type === 'MAP') {
	          return segments;
	        }
	      }
	    } // set the duration for our preload segment to target duration.
	
	
	    preloadSegment.duration = media.targetDuration;
	    preloadSegment.preload = true;
	    segments.push(preloadSegment);
	  }
	
	  return segments;
	}; // consider the playlist unchanged if the playlist object is the same or
	// the number of segments is equal, the media sequence number is unchanged,
	// and this playlist hasn't become the end of the playlist
	
	
	var isPlaylistUnchanged = function isPlaylistUnchanged(a, b) {
	  return a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
	};
	/**
	  * Returns a new master playlist that is the result of merging an
	  * updated media playlist into the original version. If the
	  * updated media playlist does not match any of the playlist
	  * entries in the original master playlist, null is returned.
	  *
	  * @param {Object} master a parsed master M3U8 object
	  * @param {Object} media a parsed media M3U8 object
	  * @return {Object} a new object that represents the original
	  * master playlist with the updated media playlist merged in, or
	  * null if the merge produced no change.
	  */
	
	
	var updateMaster$1 = function updateMaster(master, newMedia, unchangedCheck) {
	  if (unchangedCheck === void 0) {
	    unchangedCheck = isPlaylistUnchanged;
	  }
	
	  var result = mergeOptions$2(master, {});
	  var oldMedia = result.playlists[newMedia.id];
	
	  if (!oldMedia) {
	    return null;
	  }
	
	  if (unchangedCheck(oldMedia, newMedia)) {
	    return null;
	  }
	
	  newMedia.segments = getAllSegments(newMedia);
	  var mergedPlaylist = mergeOptions$2(oldMedia, newMedia); // always use the new media's preload segment
	
	  if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) {
	    delete mergedPlaylist.preloadSegment;
	  } // if the update could overlap existing segment information, merge the two segment lists
	
	
	  if (oldMedia.segments) {
	    if (newMedia.skip) {
	      newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
	      // old properties into the new segments
	
	      for (var i = 0; i < newMedia.skip.skippedSegments; i++) {
	        newMedia.segments.unshift({
	          skipped: true
	        });
	      }
	    }
	
	    mergedPlaylist.segments = updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
	  } // resolve any segment URIs to prevent us from having to do it later
	
	
	  mergedPlaylist.segments.forEach(function (segment) {
	    resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
	  }); // TODO Right now in the playlists array there are two references to each playlist, one
	  // that is referenced by index, and one by URI. The index reference may no longer be
	  // necessary.
	
	  for (var _i = 0; _i < result.playlists.length; _i++) {
	    if (result.playlists[_i].id === newMedia.id) {
	      result.playlists[_i] = mergedPlaylist;
	    }
	  }
	
	  result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
	
	  result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
	
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (!properties.playlists) {
	      return;
	    }
	
	    for (var _i2 = 0; _i2 < properties.playlists.length; _i2++) {
	      if (newMedia.id === properties.playlists[_i2].id) {
	        properties.playlists[_i2] = mergedPlaylist;
	      }
	    }
	  });
	  return result;
	};
	/**
	 * Calculates the time to wait before refreshing a live playlist
	 *
	 * @param {Object} media
	 *        The current media
	 * @param {boolean} update
	 *        True if there were any updates from the last refresh, false otherwise
	 * @return {number}
	 *         The time in ms to wait before refreshing the live playlist
	 */
	
	
	var refreshDelay = function refreshDelay(media, update) {
	  var segments = media.segments || [];
	  var lastSegment = segments[segments.length - 1];
	  var lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
	  var lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
	
	  if (update && lastDuration) {
	    return lastDuration * 1000;
	  } // if the playlist is unchanged since the last reload or last segment duration
	  // cannot be determined, try again after half the target duration
	
	
	  return (media.partTargetDuration || media.targetDuration || 10) * 500;
	};
	/**
	 * Load a playlist from a remote location
	 *
	 * @class PlaylistLoader
	 * @extends Stream
	 * @param {string|Object} src url or object of manifest
	 * @param {boolean} withCredentials the withCredentials xhr option
	 * @class
	 */
	
	
	var PlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](PlaylistLoader, _EventTarget);
	
	  function PlaylistLoader(src, vhs, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or object is required');
	    }
	
	    _this.logger_ = logger('PlaylistLoader');
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.src = src;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	    var vhsOptions = vhs.options_;
	    _this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
	    _this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
	    _this.experimentalLLHLS = vhsOptions && vhsOptions.experimentalLLHLS || false; // force experimentalLLHLS for IE 11
	
	    if (videojs.browser.IE_VERSION) {
	      _this.experimentalLLHLS = false;
	    } // initialize the loader state
	
	
	    _this.state = 'HAVE_NOTHING'; // live playlist staleness timeout
	
	    _this.handleMediaupdatetimeout_ = _this.handleMediaupdatetimeout_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.on('mediaupdatetimeout', _this.handleMediaupdatetimeout_);
	
	    return _this;
	  }
	
	  var _proto = PlaylistLoader.prototype;
	
	  _proto.handleMediaupdatetimeout_ = function handleMediaupdatetimeout_() {
	    var _this2 = this;
	
	    if (this.state !== 'HAVE_METADATA') {
	      // only refresh the media playlist if no other activity is going on
	      return;
	    }
	
	    var media = this.media();
	    var uri = resolveUrl(this.master.uri, media.uri);
	
	    if (this.experimentalLLHLS) {
	      uri = addLLHLSQueryDirectives(uri, media);
	    }
	
	    this.state = 'HAVE_CURRENT_METADATA';
	    this.request = this.vhs_.xhr({
	      uri: uri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this2.request) {
	        return;
	      }
	
	      if (error) {
	        return _this2.playlistRequestError(_this2.request, _this2.media(), 'HAVE_METADATA');
	      }
	
	      _this2.haveMetadata({
	        playlistString: _this2.request.responseText,
	        url: _this2.media().uri,
	        id: _this2.media().id
	      });
	    });
	  };
	
	  _proto.playlistRequestError = function playlistRequestError(xhr, playlist, startingState) {
	    var uri = playlist.uri,
	        id = playlist.id; // any in-flight request is now finished
	
	    this.request = null;
	
	    if (startingState) {
	      this.state = startingState;
	    }
	
	    this.error = {
	      playlist: this.master.playlists[id],
	      status: xhr.status,
	      message: "HLS playlist request error at URL: " + uri + ".",
	      responseText: xhr.responseText,
	      code: xhr.status >= 500 ? 4 : 2
	    };
	    this.trigger('error');
	  };
	
	  _proto.parseManifest_ = function parseManifest_(_ref) {
	    var _this3 = this;
	
	    var url = _ref.url,
	        manifestString = _ref.manifestString;
	    return parseManifest({
	      onwarn: function onwarn(_ref2) {
	        var message = _ref2.message;
	        return _this3.logger_("m3u8-parser warn for " + url + ": " + message);
	      },
	      oninfo: function oninfo(_ref3) {
	        var message = _ref3.message;
	        return _this3.logger_("m3u8-parser info for " + url + ": " + message);
	      },
	      manifestString: manifestString,
	      customTagParsers: this.customTagParsers,
	      customTagMappers: this.customTagMappers,
	      experimentalLLHLS: this.experimentalLLHLS
	    });
	  }
	  /**
	   * Update the playlist loader's state in response to a new or updated playlist.
	   *
	   * @param {string} [playlistString]
	   *        Playlist string (if playlistObject is not provided)
	   * @param {Object} [playlistObject]
	   *        Playlist object (if playlistString is not provided)
	   * @param {string} url
	   *        URL of playlist
	   * @param {string} id
	   *        ID to use for playlist
	   */
	  ;
	
	  _proto.haveMetadata = function haveMetadata(_ref4) {
	    var playlistString = _ref4.playlistString,
	        playlistObject = _ref4.playlistObject,
	        url = _ref4.url,
	        id = _ref4.id; // any in-flight request is now finished
	
	    this.request = null;
	    this.state = 'HAVE_METADATA';
	    var playlist = playlistObject || this.parseManifest_({
	      url: url,
	      manifestString: playlistString
	    });
	    playlist.lastRequest = Date.now();
	    setupMediaPlaylist({
	      playlist: playlist,
	      uri: url,
	      id: id
	    }); // merge this playlist into the master
	
	    var update = updateMaster$1(this.master, playlist);
	    this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
	    this.pendingMedia_ = null;
	
	    if (update) {
	      this.master = update;
	      this.media_ = this.master.playlists[id];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    this.updateMediaUpdateTimeout_(refreshDelay(this.media(), !!update));
	    this.trigger('loadedplaylist');
	  }
	  /**
	    * Abort any outstanding work and clean up.
	    */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	    this.off();
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  }
	  /**
	    * When called without any arguments, returns the currently
	    * active media playlist. When called with a single argument,
	    * triggers the playlist loader to asynchronously switch to the
	    * specified media playlist. Calling this method while the
	    * loader is in the HAVE_NOTHING causes an error to be emitted
	    * but otherwise has no effect.
	    *
	    * @param {Object=} playlist the parsed media playlist
	    * object to switch to
	    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
	    *
	    * @return {Playlist} the current loaded media
	    */
	  ;
	
	  _proto.media = function media(playlist, shouldDelay) {
	    var _this4 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    } // find the playlist object if the target playlist has been
	    // specified by URI
	
	
	    if (typeof playlist === 'string') {
	      if (!this.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.master.playlists[playlist];
	    }
	
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	
	    if (shouldDelay) {
	      var delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5 * 1000;
	      this.finalRenditionTimeout = window__default['default'].setTimeout(this.media.bind(this, playlist, false), delay);
	      return;
	    }
	
	    var startingState = this.state;
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id;
	    var masterPlaylistRef = this.master.playlists[playlist.id]; // switch to fully loaded playlists immediately
	
	    if (masterPlaylistRef && masterPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
	    // media playlist or, for the case of demuxed audio, a resolved audio media group)
	    playlist.endList && playlist.segments.length) {
	      // abort outstanding playlist requests
	      if (this.request) {
	        this.request.onreadystatechange = null;
	        this.request.abort();
	        this.request = null;
	      }
	
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	
	        if (startingState === 'HAVE_MASTER') {
	          // The initial playlist was a master manifest, and the first media selected was
	          // also provided (in the form of a resolved playlist object) as part of the
	          // source object (rather than just a URL). Therefore, since the media playlist
	          // doesn't need to be requested, loadedmetadata won't trigger as part of the
	          // normal flow, and needs an explicit trigger here.
	          this.trigger('loadedmetadata');
	        } else {
	          this.trigger('mediachange');
	        }
	      }
	
	      return;
	    } // We update/set the timeout here so that live playlists
	    // that are not a media change will "start" the loader as expected.
	    // We expect that this function will start the media update timeout
	    // cycle again. This also prevents a playlist switch failure from
	    // causing us to stall during live.
	
	
	    this.updateMediaUpdateTimeout_(refreshDelay(playlist, true)); // switching to the active playlist is a no-op
	
	    if (!mediaChange) {
	      return;
	    }
	
	    this.state = 'SWITCHING_MEDIA'; // there is already an outstanding playlist request
	
	    if (this.request) {
	      if (playlist.resolvedUri === this.request.url) {
	        // requesting to switch to the same playlist multiple times
	        // has no effect after the first
	        return;
	      }
	
	      this.request.onreadystatechange = null;
	      this.request.abort();
	      this.request = null;
	    } // request the new playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.pendingMedia_ = playlist;
	    this.request = this.vhs_.xhr({
	      uri: playlist.resolvedUri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this4.request) {
	        return;
	      }
	
	      playlist.lastRequest = Date.now();
	      playlist.resolvedUri = resolveManifestRedirect(_this4.handleManifestRedirects, playlist.resolvedUri, req);
	
	      if (error) {
	        return _this4.playlistRequestError(_this4.request, playlist, startingState);
	      }
	
	      _this4.haveMetadata({
	        playlistString: req.responseText,
	        url: playlist.uri,
	        id: playlist.id
	      }); // fire loadedmetadata the first time a media playlist is loaded
	
	
	      if (startingState === 'HAVE_MASTER') {
	        _this4.trigger('loadedmetadata');
	      } else {
	        _this4.trigger('mediachange');
	      }
	    });
	  }
	  /**
	   * pause loading of the playlist
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    this.stopRequest();
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    } // Need to restore state now that no activity is happening
	
	
	    if (this.state === 'SWITCHING_MEDIA') {
	      // if the loader was in the process of switching media, it should either return to
	      // HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
	      // playlist yet. This is determined by the existence of loader.media_
	      if (this.media_) {
	        this.state = 'HAVE_METADATA';
	      } else {
	        this.state = 'HAVE_MASTER';
	      }
	    } else if (this.state === 'HAVE_CURRENT_METADATA') {
	      this.state = 'HAVE_METADATA';
	    }
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.load = function load(shouldDelay) {
	    var _this5 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    var media = this.media();
	
	    if (shouldDelay) {
	      var delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        _this5.mediaUpdateTimeout = null;
	
	        _this5.load();
	      }, delay);
	      return;
	    }
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.updateMediaUpdateTimeout_ = function updateMediaUpdateTimeout_(delay) {
	    var _this6 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    } // we only have use mediaupdatetimeout for live playlists.
	
	
	    if (!this.media() || this.media().endList) {
	      return;
	    }
	
	    this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	      _this6.mediaUpdateTimeout = null;
	
	      _this6.trigger('mediaupdatetimeout');
	
	      _this6.updateMediaUpdateTimeout_(delay);
	    }, delay);
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.start = function start() {
	    var _this7 = this;
	
	    this.started = true;
	
	    if (typeof this.src === 'object') {
	      // in the case of an entirely constructed manifest object (meaning there's no actual
	      // manifest on a server), default the uri to the page's href
	      if (!this.src.uri) {
	        this.src.uri = window__default['default'].location.href;
	      } // resolvedUri is added on internally after the initial request. Since there's no
	      // request for pre-resolved manifests, add on resolvedUri here.
	
	
	      this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
	      // request can be skipped (since the top level of the manifest, at a minimum, is
	      // already available as a parsed manifest object). However, if the manifest object
	      // represents a master playlist, some media playlists may need to be resolved before
	      // the starting segment list is available. Therefore, go directly to setup of the
	      // initial playlist, and let the normal flow continue from there.
	      //
	      // Note that the call to setup is asynchronous, as other sections of VHS may assume
	      // that the first request is asynchronous.
	
	      setTimeout(function () {
	        _this7.setupInitialPlaylist(_this7.src);
	      }, 0);
	      return;
	    } // request the specified URL
	
	
	    this.request = this.vhs_.xhr({
	      uri: this.src,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      } // clear the loader's request reference
	
	
	      _this7.request = null;
	
	      if (error) {
	        _this7.error = {
	          status: req.status,
	          message: "HLS playlist request error at URL: " + _this7.src + ".",
	          responseText: req.responseText,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        };
	
	        if (_this7.state === 'HAVE_NOTHING') {
	          _this7.started = false;
	        }
	
	        return _this7.trigger('error');
	      }
	
	      _this7.src = resolveManifestRedirect(_this7.handleManifestRedirects, _this7.src, req);
	
	      var manifest = _this7.parseManifest_({
	        manifestString: req.responseText,
	        url: _this7.src
	      });
	
	      _this7.setupInitialPlaylist(manifest);
	    });
	  };
	
	  _proto.srcUri = function srcUri() {
	    return typeof this.src === 'string' ? this.src : this.src.uri;
	  }
	  /**
	   * Given a manifest object that's either a master or media playlist, trigger the proper
	   * events and set the state of the playlist loader.
	   *
	   * If the manifest object represents a master playlist, `loadedplaylist` will be
	   * triggered to allow listeners to select a playlist. If none is selected, the loader
	   * will default to the first one in the playlists array.
	   *
	   * If the manifest object represents a media playlist, `loadedplaylist` will be
	   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
	   *
	   * In the case of a media playlist, a master playlist object wrapper with one playlist
	   * will be created so that all logic can handle playlists in the same fashion (as an
	   * assumed manifest object schema).
	   *
	   * @param {Object} manifest
	   *        The parsed manifest object
	   */
	  ;
	
	  _proto.setupInitialPlaylist = function setupInitialPlaylist(manifest) {
	    this.state = 'HAVE_MASTER';
	
	    if (manifest.playlists) {
	      this.master = manifest;
	      addPropertiesToMaster(this.master, this.srcUri()); // If the initial master playlist has playlists wtih segments already resolved,
	      // then resolve URIs in advance, as they are usually done after a playlist request,
	      // which may not happen if the playlist is resolved.
	
	      manifest.playlists.forEach(function (playlist) {
	        playlist.segments = getAllSegments(playlist);
	        playlist.segments.forEach(function (segment) {
	          resolveSegmentUris(segment, playlist.resolvedUri);
	        });
	      });
	      this.trigger('loadedplaylist');
	
	      if (!this.request) {
	        // no media playlist was specifically selected so start
	        // from the first listed one
	        this.media(this.master.playlists[0]);
	      }
	
	      return;
	    } // In order to support media playlists passed in as vhs-json, the case where the uri
	    // is not provided as part of the manifest should be considered, and an appropriate
	    // default used.
	
	
	    var uri = this.srcUri() || window__default['default'].location.href;
	    this.master = masterForMedia(manifest, uri);
	    this.haveMetadata({
	      playlistObject: manifest,
	      url: uri,
	      id: this.master.playlists[0].id
	    });
	    this.trigger('loadedmetadata');
	  };
	
	  return PlaylistLoader;
	}(EventTarget$1);
	/**
	 * @file xhr.js
	 */
	
	
	var videojsXHR = videojs.xhr,
	    mergeOptions$1 = videojs.mergeOptions;
	
	var callbackWrapper = function callbackWrapper(request, error, response, callback) {
	  var reqResponse = request.responseType === 'arraybuffer' ? request.response : request.responseText;
	
	  if (!error && reqResponse) {
	    request.responseTime = Date.now();
	    request.roundTripTime = request.responseTime - request.requestTime;
	    request.bytesReceived = reqResponse.byteLength || reqResponse.length;
	
	    if (!request.bandwidth) {
	      request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8 * 1000);
	    }
	  }
	
	  if (response.headers) {
	    request.responseHeaders = response.headers;
	  } // videojs.xhr now uses a specific code on the error
	  // object to signal that a request has timed out instead
	  // of setting a boolean on the request object
	
	
	  if (error && error.code === 'ETIMEDOUT') {
	    request.timedout = true;
	  } // videojs.xhr no longer considers status codes outside of 200 and 0
	  // (for file uris) to be errors, but the old XHR did, so emulate that
	  // behavior. Status 206 may be used in response to byterange requests.
	
	
	  if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) {
	    error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
	  }
	
	  callback(error, request);
	};
	
	var xhrFactory = function xhrFactory() {
	  var xhr = function XhrFunction(options, callback) {
	    // Add a default timeout
	    options = mergeOptions$1({
	      timeout: 45e3
	    }, options); // Allow an optional user-specified function to modify the option
	    // object before we construct the xhr request
	
	    var beforeRequest = XhrFunction.beforeRequest || videojs.Vhs.xhr.beforeRequest;
	
	    if (beforeRequest && typeof beforeRequest === 'function') {
	      var newOptions = beforeRequest(options);
	
	      if (newOptions) {
	        options = newOptions;
	      }
	    } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
	    // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
	
	
	    var xhrMethod = videojs.Vhs.xhr.original === true ? videojsXHR : videojs.Vhs.xhr;
	    var request = xhrMethod(options, function (error, response) {
	      return callbackWrapper(request, error, response, callback);
	    });
	    var originalAbort = request.abort;
	
	    request.abort = function () {
	      request.aborted = true;
	      return originalAbort.apply(request, arguments);
	    };
	
	    request.uri = options.uri;
	    request.requestTime = Date.now();
	    return request;
	  };
	
	  xhr.original = true;
	  return xhr;
	};
	/**
	 * Turns segment byterange into a string suitable for use in
	 * HTTP Range requests
	 *
	 * @param {Object} byterange - an object with two values defining the start and end
	 *                             of a byte-range
	 */
	
	
	var byterangeStr = function byterangeStr(byterange) {
	  // `byterangeEnd` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var byterangeEnd;
	  var byterangeStart = byterange.offset;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    byterangeEnd = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    byterangeEnd = byterange.offset + byterange.length - 1;
	  }
	
	  return 'bytes=' + byterangeStart + '-' + byterangeEnd;
	};
	/**
	 * Defines headers for use in the xhr request for a particular segment.
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 */
	
	
	var segmentXhrHeaders = function segmentXhrHeaders(segment) {
	  var headers = {};
	
	  if (segment.byterange) {
	    headers.Range = byterangeStr(segment.byterange);
	  }
	
	  return headers;
	};
	/**
	 * @file bin-utils.js
	 */
	
	/**
	 * convert a TimeRange to text
	 *
	 * @param {TimeRange} range the timerange to use for conversion
	 * @param {number} i the iterator on the range to convert
	 * @return {string} the range in string format
	 */
	
	
	var textRange = function textRange(range, i) {
	  return range.start(i) + '-' + range.end(i);
	};
	/**
	 * format a number as hex string
	 *
	 * @param {number} e The number
	 * @param {number} i the iterator
	 * @return {string} the hex formatted number as a string
	 */
	
	
	var formatHexString = function formatHexString(e, i) {
	  var value = e.toString(16);
	  return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
	};
	
	var formatAsciiString = function formatAsciiString(e) {
	  if (e >= 0x20 && e < 0x7e) {
	    return String.fromCharCode(e);
	  }
	
	  return '.';
	};
	/**
	 * Creates an object for sending to a web worker modifying properties that are TypedArrays
	 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	 *
	 * @param {Object} message
	 *        Object of properties and values to send to the web worker
	 * @return {Object}
	 *         Modified message with TypedArray values expanded
	 * @function createTransferableMessage
	 */
	
	
	var createTransferableMessage = function createTransferableMessage(message) {
	  var transferable = {};
	  Object.keys(message).forEach(function (key) {
	    var value = message[key];
	
	    if (byteHelpers.isArrayBufferView(value)) {
	      transferable[key] = {
	        bytes: value.buffer,
	        byteOffset: value.byteOffset,
	        byteLength: value.byteLength
	      };
	    } else {
	      transferable[key] = value;
	    }
	  });
	  return transferable;
	};
	/**
	 * Returns a unique string identifier for a media initialization
	 * segment.
	 *
	 * @param {Object} initSegment
	 *        the init segment object.
	 *
	 * @return {string} the generated init segment id
	 */
	
	
	var initSegmentId = function initSegmentId(initSegment) {
	  var byterange = initSegment.byterange || {
	    length: Infinity,
	    offset: 0
	  };
	  return [byterange.length, byterange.offset, initSegment.resolvedUri].join(',');
	};
	/**
	 * Returns a unique string identifier for a media segment key.
	 *
	 * @param {Object} key the encryption key
	 * @return {string} the unique id for the media segment key.
	 */
	
	
	var segmentKeyId = function segmentKeyId(key) {
	  return key.resolvedUri;
	};
	/**
	 * utils to help dump binary data to the console
	 *
	 * @param {Array|TypedArray} data
	 *        data to dump to a string
	 *
	 * @return {string} the data as a hex string.
	 */
	
	
	var hexDump = function hexDump(data) {
	  var bytes = Array.prototype.slice.call(data);
	  var step = 16;
	  var result = '';
	  var hex;
	  var ascii;
	
	  for (var j = 0; j < bytes.length / step; j++) {
	    hex = bytes.slice(j * step, j * step + step).map(formatHexString).join('');
	    ascii = bytes.slice(j * step, j * step + step).map(formatAsciiString).join('');
	    result += hex + ' ' + ascii + '\n';
	  }
	
	  return result;
	};
	
	var tagDump = function tagDump(_ref) {
	  var bytes = _ref.bytes;
	  return hexDump(bytes);
	};
	
	var textRanges = function textRanges(ranges) {
	  var result = '';
	  var i;
	
	  for (i = 0; i < ranges.length; i++) {
	    result += textRange(ranges, i) + ' ';
	  }
	
	  return result;
	};
	
	var utils = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  createTransferableMessage: createTransferableMessage,
	  initSegmentId: initSegmentId,
	  segmentKeyId: segmentKeyId,
	  hexDump: hexDump,
	  tagDump: tagDump,
	  textRanges: textRanges
	}); // TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
	// 25% was arbitrarily chosen, and may need to be refined over time.
	
	var SEGMENT_END_FUDGE_PERCENT = 0.25;
	/**
	 * Converts a player time (any time that can be gotten/set from player.currentTime(),
	 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
	 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
	 *
	 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
	 * point" (a point where we have a mapping from program time to player time, with player
	 * time being the post transmux start of the segment).
	 *
	 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
	 *
	 * @param {number} playerTime the player time
	 * @param {Object} segment the segment which contains the player time
	 * @return {Date} program time
	 */
	
	var playerTimeToProgramTime = function playerTimeToProgramTime(playerTime, segment) {
	  if (!segment.dateTimeObject) {
	    // Can't convert without an "anchor point" for the program time (i.e., a time that can
	    // be used to map the start of a segment with a real world time).
	    return null;
	  }
	
	  var transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
	  var transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
	
	  var startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
	  var offsetFromSegmentStart = playerTime - startOfSegment;
	  return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
	};
	
	var originalSegmentVideoDuration = function originalSegmentVideoDuration(videoTimingInfo) {
	  return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
	};
	/**
	 * Finds a segment that contains the time requested given as an ISO-8601 string. The
	 * returned segment might be an estimate or an accurate match.
	 *
	 * @param {string} programTime The ISO-8601 programTime to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForProgramTime = function findSegmentForProgramTime(programTime, playlist) {
	  // Assumptions:
	  //  - verifyProgramDateTimeTags has already been run
	  //  - live streams have been started
	  var dateTimeObject;
	
	  try {
	    dateTimeObject = new Date(programTime);
	  } catch (e) {
	    return null;
	  }
	
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segment = playlist.segments[0];
	
	  if (dateTimeObject < segment.dateTimeObject) {
	    // Requested time is before stream start.
	    return null;
	  }
	
	  for (var i = 0; i < playlist.segments.length - 1; i++) {
	    segment = playlist.segments[i];
	    var nextSegmentStart = playlist.segments[i + 1].dateTimeObject;
	
	    if (dateTimeObject < nextSegmentStart) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	  var lastSegmentStart = lastSegment.dateTimeObject;
	  var lastSegmentDuration = lastSegment.videoTimingInfo ? originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT;
	  var lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
	
	  if (dateTimeObject > lastSegmentEnd) {
	    // Beyond the end of the stream, or our best guess of the end of the stream.
	    return null;
	  }
	
	  if (dateTimeObject > lastSegmentStart) {
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
	    // Although, given that all segments have accurate date time objects, the segment
	    // selected should be accurate, unless the video has been transmuxed at some point
	    // (determined by the presence of the videoTimingInfo object), the segment's "player
	    // time" (the start time in the player) can't be considered accurate.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Finds a segment that contains the given player time(in seconds).
	 *
	 * @param {number} time The player time to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForPlayerTime = function findSegmentForPlayerTime(time, playlist) {
	  // Assumptions:
	  // - there will always be a segment.duration
	  // - we can start from zero
	  // - segments are in time order
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segmentEnd = 0;
	  var segment;
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
	    // should contain the most accurate values we have for the segment's player times.
	    //
	    // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
	    // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
	    // calculate an end value.
	
	    segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
	
	    if (time <= segmentEnd) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	
	  if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) {
	    // The time requested is beyond the stream end.
	    return null;
	  }
	
	  if (time > segmentEnd) {
	    // The time is within or beyond the last segment.
	    //
	    // Check to see if the time is beyond a reasonable guess of the end of the stream.
	    if (time > segmentEnd + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT) {
	      // Technically, because the duration value is only an estimate, the time may still
	      // exist in the last segment, however, there isn't enough information to make even
	      // a reasonable estimate.
	      return null;
	    }
	
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
	    // Because videoTimingInfo is only set after transmux, it is the only way to get
	    // accurate timing values.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
	 * If the offset returned is positive, the programTime occurs after the
	 * comparisonTimestamp.
	 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
	 *
	 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
	 * @param {string} programTime The programTime as an ISO-8601 string
	 * @return {number} offset
	 */
	
	
	var getOffsetFromTimestamp = function getOffsetFromTimestamp(comparisonTimeStamp, programTime) {
	  var segmentDateTime;
	  var programDateTime;
	
	  try {
	    segmentDateTime = new Date(comparisonTimeStamp);
	    programDateTime = new Date(programTime);
	  } catch (e) {// TODO handle error
	  }
	
	  var segmentTimeEpoch = segmentDateTime.getTime();
	  var programTimeEpoch = programDateTime.getTime();
	  return (programTimeEpoch - segmentTimeEpoch) / 1000;
	};
	/**
	 * Checks that all segments in this playlist have programDateTime tags.
	 *
	 * @param {Object} playlist A playlist object
	 */
	
	
	var verifyProgramDateTimeTags = function verifyProgramDateTimeTags(playlist) {
	  if (!playlist.segments || playlist.segments.length === 0) {
	    return false;
	  }
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    var segment = playlist.segments[i];
	
	    if (!segment.dateTimeObject) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Returns the programTime of the media given a playlist and a playerTime.
	 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
	 * If the segments containing the time requested have not been buffered yet, an estimate
	 * may be returned to the callback.
	 *
	 * @param {Object} args
	 * @param {Object} args.playlist A playlist object to search within
	 * @param {number} time A playerTime in seconds
	 * @param {Function} callback(err, programTime)
	 * @return {string} err.message A detailed error message
	 * @return {Object} programTime
	 * @return {number} programTime.mediaSeconds The streamTime in seconds
	 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
	 */
	
	
	var getProgramTime = function getProgramTime(_ref) {
	  var playlist = _ref.playlist,
	      _ref$time = _ref.time,
	      time = _ref$time === void 0 ? undefined : _ref$time,
	      callback = _ref.callback;
	
	  if (!callback) {
	    throw new Error('getProgramTime: callback must be provided');
	  }
	
	  if (!playlist || time === undefined) {
	    return callback({
	      message: 'getProgramTime: playlist and time must be provided'
	    });
	  }
	
	  var matchedSegment = findSegmentForPlayerTime(time, playlist);
	
	  if (!matchedSegment) {
	    return callback({
	      message: 'valid programTime was not found'
	    });
	  }
	
	  if (matchedSegment.type === 'estimate') {
	    return callback({
	      message: 'Accurate programTime could not be determined.' + ' Please seek to e.seekTime and try again',
	      seekTime: matchedSegment.estimatedStart
	    });
	  }
	
	  var programTimeObject = {
	    mediaSeconds: time
	  };
	  var programTime = playerTimeToProgramTime(time, matchedSegment.segment);
	
	  if (programTime) {
	    programTimeObject.programDateTime = programTime.toISOString();
	  }
	
	  return callback(null, programTimeObject);
	};
	/**
	 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
	 *
	 * @param {Object} args
	 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
	 * @param {Object} args.playlist A playlist to look within
	 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
	 * @param {Function} args.seekTo A method to perform a seek
	 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
	 * @param {Object} args.tech The tech to seek on
	 * @param {Function} args.callback(err, newTime) A callback to return the new time to
	 * @return {string} err.message A detailed error message
	 * @return {number} newTime The exact time that was seeked to in seconds
	 */
	
	
	var seekToProgramTime = function seekToProgramTime(_ref2) {
	  var programTime = _ref2.programTime,
	      playlist = _ref2.playlist,
	      _ref2$retryCount = _ref2.retryCount,
	      retryCount = _ref2$retryCount === void 0 ? 2 : _ref2$retryCount,
	      seekTo = _ref2.seekTo,
	      _ref2$pauseAfterSeek = _ref2.pauseAfterSeek,
	      pauseAfterSeek = _ref2$pauseAfterSeek === void 0 ? true : _ref2$pauseAfterSeek,
	      tech = _ref2.tech,
	      callback = _ref2.callback;
	
	  if (!callback) {
	    throw new Error('seekToProgramTime: callback must be provided');
	  }
	
	  if (typeof programTime === 'undefined' || !playlist || !seekTo) {
	    return callback({
	      message: 'seekToProgramTime: programTime, seekTo and playlist must be provided'
	    });
	  }
	
	  if (!playlist.endList && !tech.hasStarted_) {
	    return callback({
	      message: 'player must be playing a live stream to start buffering'
	    });
	  }
	
	  if (!verifyProgramDateTimeTags(playlist)) {
	    return callback({
	      message: 'programDateTime tags must be provided in the manifest ' + playlist.resolvedUri
	    });
	  }
	
	  var matchedSegment = findSegmentForProgramTime(programTime, playlist); // no match
	
	  if (!matchedSegment) {
	    return callback({
	      message: programTime + " was not found in the stream"
	    });
	  }
	
	  var segment = matchedSegment.segment;
	  var mediaOffset = getOffsetFromTimestamp(segment.dateTimeObject, programTime);
	
	  if (matchedSegment.type === 'estimate') {
	    // we've run out of retries
	    if (retryCount === 0) {
	      return callback({
	        message: programTime + " is not buffered yet. Try again"
	      });
	    }
	
	    seekTo(matchedSegment.estimatedStart + mediaOffset);
	    tech.one('seeked', function () {
	      seekToProgramTime({
	        programTime: programTime,
	        playlist: playlist,
	        retryCount: retryCount - 1,
	        seekTo: seekTo,
	        pauseAfterSeek: pauseAfterSeek,
	        tech: tech,
	        callback: callback
	      });
	    });
	    return;
	  } // Since the segment.start value is determined from the buffered end or ending time
	  // of the prior segment, the seekToTime doesn't need to account for any transmuxer
	  // modifications.
	
	
	  var seekToTime = segment.start + mediaOffset;
	
	  var seekedCallback = function seekedCallback() {
	    return callback(null, tech.currentTime());
	  }; // listen for seeked event
	
	
	  tech.one('seeked', seekedCallback); // pause before seeking as video.js will restore this state
	
	  if (pauseAfterSeek) {
	    tech.pause();
	  }
	
	  seekTo(seekToTime);
	}; // which will only happen if the request is complete.
	
	
	var callbackOnCompleted = function callbackOnCompleted(request, cb) {
	  if (request.readyState === 4) {
	    return cb();
	  }
	
	  return;
	};
	
	var containerRequest = function containerRequest(uri, xhr, cb) {
	  var bytes = [];
	  var id3Offset;
	  var finished = false;
	
	  var endRequestAndCallback = function endRequestAndCallback(err, req, type, _bytes) {
	    req.abort();
	    finished = true;
	    return cb(err, req, type, _bytes);
	  };
	
	  var progressListener = function progressListener(error, request) {
	    if (finished) {
	      return;
	    }
	
	    if (error) {
	      return endRequestAndCallback(error, request, '', bytes);
	    } // grap the new part of content that was just downloaded
	
	
	    var newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
	
	    bytes = byteHelpers.concatTypedArrays(bytes, byteHelpers.stringToBytes(newPart, true));
	    id3Offset = id3Offset || id3Helpers.getId3Offset(bytes); // we need at least 10 bytes to determine a type
	    // or we need at least two bytes after an id3Offset
	
	    if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    var type = containers.detectContainerForBytes(bytes); // if this looks like a ts segment but we don't have enough data
	    // to see the second sync byte, wait until we have enough data
	    // before declaring it ts
	
	    if (type === 'ts' && bytes.length < 188) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    } // this may be an unsynced ts segment
	    // wait for 376 bytes before detecting no container
	
	
	    if (!type && bytes.length < 376) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    return endRequestAndCallback(null, request, type, bytes);
	  };
	
	  var options = {
	    uri: uri,
	    beforeSend: function beforeSend(request) {
	      // this forces the browser to pass the bytes to us unprocessed
	      request.overrideMimeType('text/plain; charset=x-user-defined');
	      request.addEventListener('progress', function (_ref) {
	        _ref.total;
	        _ref.loaded;
	        return callbackWrapper(request, null, {
	          statusCode: request.status
	        }, progressListener);
	      });
	    }
	  };
	  var request = xhr(options, function (error, response) {
	    return callbackWrapper(request, error, response, progressListener);
	  });
	  return request;
	};
	
	var EventTarget = videojs.EventTarget,
	    mergeOptions = videojs.mergeOptions;
	
	var dashPlaylistUnchanged = function dashPlaylistUnchanged(a, b) {
	  if (!isPlaylistUnchanged(a, b)) {
	    return false;
	  } // for dash the above check will often return true in scenarios where
	  // the playlist actually has changed because mediaSequence isn't a
	  // dash thing, and we often set it to 1. So if the playlists have the same amount
	  // of segments we return true.
	  // So for dash we need to make sure that the underlying segments are different.
	  // if sidx changed then the playlists are different.
	
	
	  if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) {
	    return false;
	  } else if (!a.sidx && b.sidx || a.sidx && !b.sidx) {
	    return false;
	  } // one or the other does not have segments
	  // there was a change.
	
	
	  if (a.segments && !b.segments || !a.segments && b.segments) {
	    return false;
	  } // neither has segments nothing changed
	
	
	  if (!a.segments && !b.segments) {
	    return true;
	  } // check segments themselves
	
	
	  for (var i = 0; i < a.segments.length; i++) {
	    var aSegment = a.segments[i];
	    var bSegment = b.segments[i]; // if uris are different between segments there was a change
	
	    if (aSegment.uri !== bSegment.uri) {
	      return false;
	    } // neither segment has a byterange, there will be no byterange change.
	
	
	    if (!aSegment.byterange && !bSegment.byterange) {
	      continue;
	    }
	
	    var aByterange = aSegment.byterange;
	    var bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
	
	    if (aByterange && !bByterange || !aByterange && bByterange) {
	      return false;
	    } // if both segments have byterange with different offsets, there was a change.
	
	
	    if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) {
	      return false;
	    }
	  } // if everything was the same with segments, this is the same playlist.
	
	
	  return true;
	};
	/**
	 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
	 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
	 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
	 * periods without continuous playback this function may need modification as well as the parser.
	 */
	
	
	var dashGroupId = function dashGroupId(type, group, label, playlist) {
	  // If the manifest somehow does not have an ID (non-dash compliant), use the label.
	  var playlistId = playlist.attributes.NAME || label;
	  return "placeholder-uri-" + type + "-" + group + "-" + playlistId;
	};
	/**
	 * Parses the master XML string and updates playlist URI references.
	 *
	 * @param {Object} config
	 *        Object of arguments
	 * @param {string} config.masterXml
	 *        The mpd XML
	 * @param {string} config.srcUrl
	 *        The mpd URL
	 * @param {Date} config.clientOffset
	 *         A time difference between server and client
	 * @param {Object} config.sidxMapping
	 *        SIDX mappings for moof/mdat URIs and byte ranges
	 * @return {Object}
	 *         The parsed mpd manifest object
	 */
	
	
	var parseMasterXml = function parseMasterXml(_ref) {
	  var masterXml = _ref.masterXml,
	      srcUrl = _ref.srcUrl,
	      clientOffset = _ref.clientOffset,
	      sidxMapping = _ref.sidxMapping,
	      previousManifest = _ref.previousManifest;
	  var manifest = mpdParser.parse(masterXml, {
	    manifestUri: srcUrl,
	    clientOffset: clientOffset,
	    sidxMapping: sidxMapping,
	    previousManifest: previousManifest
	  });
	  addPropertiesToMaster(manifest, srcUrl, dashGroupId);
	  return manifest;
	};
	/**
	 * Removes any mediaGroup labels that no longer exist in the newMaster
	 *
	 * @param {Object} update
	 *         The previous mpd object being updated
	 * @param {Object} newMaster
	 *         The new mpd object
	 */
	
	
	var removeOldMediaGroupLabels = function removeOldMediaGroupLabels(update, newMaster) {
	  forEachMediaGroup(update, function (properties, type, group, label) {
	    if (!(label in newMaster.mediaGroups[type][group])) {
	      delete update.mediaGroups[type][group][label];
	    }
	  });
	};
	/**
	 * Returns a new master manifest that is the result of merging an updated master manifest
	 * into the original version.
	 *
	 * @param {Object} oldMaster
	 *        The old parsed mpd object
	 * @param {Object} newMaster
	 *        The updated parsed mpd object
	 * @return {Object}
	 *         A new object representing the original master manifest with the updated media
	 *         playlists merged in
	 */
	
	
	var updateMaster = function updateMaster(oldMaster, newMaster, sidxMapping) {
	  var noChanges = true;
	  var update = mergeOptions(oldMaster, {
	    // These are top level properties that can be updated
	    duration: newMaster.duration,
	    minimumUpdatePeriod: newMaster.minimumUpdatePeriod,
	    timelineStarts: newMaster.timelineStarts
	  }); // First update the playlists in playlist list
	
	  for (var i = 0; i < newMaster.playlists.length; i++) {
	    var playlist = newMaster.playlists[i];
	
	    if (playlist.sidx) {
	      var sidxKey = mpdParser.generateSidxKey(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
	
	      if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) {
	        mpdParser.addSidxSegmentsToPlaylist(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
	      }
	    }
	
	    var playlistUpdate = updateMaster$1(update, playlist, dashPlaylistUnchanged);
	
	    if (playlistUpdate) {
	      update = playlistUpdate;
	      noChanges = false;
	    }
	  } // Then update media group playlists
	
	
	  forEachMediaGroup(newMaster, function (properties, type, group, label) {
	    if (properties.playlists && properties.playlists.length) {
	      var id = properties.playlists[0].id;
	
	      var _playlistUpdate = updateMaster$1(update, properties.playlists[0], dashPlaylistUnchanged);
	
	      if (_playlistUpdate) {
	        update = _playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
	
	        if (!(label in update.mediaGroups[type][group])) {
	          update.mediaGroups[type][group][label] = properties;
	        } // update the playlist reference within media groups
	
	
	        update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
	        noChanges = false;
	      }
	    }
	  }); // remove mediaGroup labels and references that no longer exist in the newMaster
	
	  removeOldMediaGroupLabels(update, newMaster);
	
	  if (newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	    noChanges = false;
	  }
	
	  if (noChanges) {
	    return null;
	  }
	
	  return update;
	}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
	// If the SIDXs have maps, the two maps should match,
	// both `a` and `b` missing SIDXs is considered matching.
	// If `a` or `b` but not both have a map, they aren't matching.
	
	
	var equivalentSidx = function equivalentSidx(a, b) {
	  var neitherMap = Boolean(!a.map && !b.map);
	  var equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
	  return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
	}; // exported for testing
	
	
	var compareSidxEntry = function compareSidxEntry(playlists, oldSidxMapping) {
	  var newSidxMapping = {};
	
	  for (var id in playlists) {
	    var playlist = playlists[id];
	    var currentSidxInfo = playlist.sidx;
	
	    if (currentSidxInfo) {
	      var key = mpdParser.generateSidxKey(currentSidxInfo);
	
	      if (!oldSidxMapping[key]) {
	        break;
	      }
	
	      var savedSidxInfo = oldSidxMapping[key].sidxInfo;
	
	      if (equivalentSidx(savedSidxInfo, currentSidxInfo)) {
	        newSidxMapping[key] = oldSidxMapping[key];
	      }
	    }
	  }
	
	  return newSidxMapping;
	};
	/**
	 *  A function that filters out changed items as they need to be requested separately.
	 *
	 *  The method is exported for testing
	 *
	 *  @param {Object} master the parsed mpd XML returned via mpd-parser
	 *  @param {Object} oldSidxMapping the SIDX to compare against
	 */
	
	
	var filterChangedSidxMappings = function filterChangedSidxMappings(master, oldSidxMapping) {
	  var videoSidx = compareSidxEntry(master.playlists, oldSidxMapping);
	  var mediaGroupSidx = videoSidx;
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (properties.playlists && properties.playlists.length) {
	      var playlists = properties.playlists;
	      mediaGroupSidx = mergeOptions(mediaGroupSidx, compareSidxEntry(playlists, oldSidxMapping));
	    }
	  });
	  return mediaGroupSidx;
	};
	
	var DashPlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](DashPlaylistLoader, _EventTarget); // DashPlaylistLoader must accept either a src url or a playlist because subsequent
	  // playlist loader setups from media groups will expect to be able to pass a playlist
	  // (since there aren't external URLs to media playlists with DASH)
	
	
	  function DashPlaylistLoader(srcUrlOrPlaylist, vhs, options, masterPlaylistLoader) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.masterPlaylistLoader_ = masterPlaylistLoader || _assertThisInitialized__default['default'](_this);
	
	    if (!masterPlaylistLoader) {
	      _this.isMaster_ = true;
	    }
	
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	
	    if (!srcUrlOrPlaylist) {
	      throw new Error('A non-empty playlist URL or object is required');
	    } // event naming?
	
	
	    _this.on('minimumUpdatePeriod', function () {
	      _this.refreshXml_();
	    }); // live playlist staleness timeout
	
	
	    _this.on('mediaupdatetimeout', function () {
	      _this.refreshMedia_(_this.media().id);
	    });
	
	    _this.state = 'HAVE_NOTHING';
	    _this.loadedPlaylists_ = {};
	    _this.logger_ = logger('DashPlaylistLoader'); // initialize the loader state
	    // The masterPlaylistLoader will be created with a string
	
	    if (_this.isMaster_) {
	      _this.masterPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
	      // once multi-period is refactored
	
	      _this.masterPlaylistLoader_.sidxMapping_ = {};
	    } else {
	      _this.childPlaylist_ = srcUrlOrPlaylist;
	    }
	
	    return _this;
	  }
	
	  var _proto = DashPlaylistLoader.prototype;
	
	  _proto.requestErrored_ = function requestErrored_(err, request, startingState) {
	    // disposed
	    if (!this.request) {
	      return true;
	    } // pending request is cleared
	
	
	    this.request = null;
	
	    if (err) {
	      // use the provided error object or create one
	      // based on the request/response
	      this.error = typeof err === 'object' && !(err instanceof Error) ? err : {
	        status: request.status,
	        message: 'DASH request error at URL: ' + request.uri,
	        response: request.response,
	        // MEDIA_ERR_NETWORK
	        code: 2
	      };
	
	      if (startingState) {
	        this.state = startingState;
	      }
	
	      this.trigger('error');
	      return true;
	    }
	  }
	  /**
	   * Verify that the container of the sidx segment can be parsed
	   * and if it can, get and parse that segment.
	   */
	  ;
	
	  _proto.addSidxSegments_ = function addSidxSegments_(playlist, startingState, cb) {
	    var _this2 = this;
	
	    var sidxKey = playlist.sidx && mpdParser.generateSidxKey(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
	
	    if (!playlist.sidx || !sidxKey || this.masterPlaylistLoader_.sidxMapping_[sidxKey]) {
	      // keep this function async
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return cb(false);
	      }, 0);
	      return;
	    } // resolve the segment URL relative to the playlist
	
	
	    var uri = resolveManifestRedirect(this.handleManifestRedirects, playlist.sidx.resolvedUri);
	
	    var fin = function fin(err, request) {
	      if (_this2.requestErrored_(err, request, startingState)) {
	        return;
	      }
	
	      var sidxMapping = _this2.masterPlaylistLoader_.sidxMapping_;
	      var sidx;
	
	      try {
	        sidx = parseSidx__default['default'](byteHelpers.toUint8(request.response).subarray(8));
	      } catch (e) {
	        // sidx parsing failed.
	        _this2.requestErrored_(e, request, startingState);
	
	        return;
	      }
	
	      sidxMapping[sidxKey] = {
	        sidxInfo: playlist.sidx,
	        sidx: sidx
	      };
	      mpdParser.addSidxSegmentsToPlaylist(playlist, sidx, playlist.sidx.resolvedUri);
	      return cb(true);
	    };
	
	    this.request = containerRequest(uri, this.vhs_.xhr, function (err, request, container, bytes) {
	      if (err) {
	        return fin(err, request);
	      }
	
	      if (!container || container !== 'mp4') {
	        return fin({
	          status: request.status,
	          message: "Unsupported " + (container || 'unknown') + " container type for sidx segment at URL: " + uri,
	          // response is just bytes in this case
	          // but we really don't want to return that.
	          response: '',
	          playlist: playlist,
	          internal: true,
	          blacklistDuration: Infinity,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        }, request);
	      } // if we already downloaded the sidx bytes in the container request, use them
	
	
	      var _playlist$sidx$bytera = playlist.sidx.byterange,
	          offset = _playlist$sidx$bytera.offset,
	          length = _playlist$sidx$bytera.length;
	
	      if (bytes.length >= length + offset) {
	        return fin(err, {
	          response: bytes.subarray(offset, offset + length),
	          status: request.status,
	          uri: request.uri
	        });
	      } // otherwise request sidx bytes
	
	
	      _this2.request = _this2.vhs_.xhr({
	        uri: uri,
	        responseType: 'arraybuffer',
	        headers: segmentXhrHeaders({
	          byterange: playlist.sidx.byterange
	        })
	      }, fin);
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    this.loadedPlaylists_ = {};
	    window__default['default'].clearTimeout(this.minimumUpdatePeriodTimeout_);
	    window__default['default'].clearTimeout(this.mediaRequest_);
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    this.mediaRequest_ = null;
	    this.minimumUpdatePeriodTimeout_ = null;
	
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.off();
	  };
	
	  _proto.hasPendingRequest = function hasPendingRequest() {
	    return this.request || this.mediaRequest_;
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  };
	
	  _proto.media = function media(playlist) {
	    var _this3 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    }
	
	    var startingState = this.state; // find the playlist object if the target playlist has been specified by URI
	
	    if (typeof playlist === 'string') {
	      if (!this.masterPlaylistLoader_.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.masterPlaylistLoader_.master.playlists[playlist];
	    }
	
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
	
	    if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	        this.trigger('mediachange');
	      }
	
	      return;
	    } // switching to the active playlist is a no-op
	
	
	    if (!mediaChange) {
	      return;
	    } // switching from an already loaded playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.addSidxSegments_(playlist, startingState, function (sidxChanged) {
	      // everything is ready just continue to haveMetadata
	      _this3.haveMetadata({
	        startingState: startingState,
	        playlist: playlist
	      });
	    });
	  };
	
	  _proto.haveMetadata = function haveMetadata(_ref2) {
	    var startingState = _ref2.startingState,
	        playlist = _ref2.playlist;
	    this.state = 'HAVE_METADATA';
	    this.loadedPlaylists_[playlist.id] = playlist;
	    this.mediaRequest_ = null; // This will trigger loadedplaylist
	
	    this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
	    // to resolve setup of media groups
	
	    if (startingState === 'HAVE_MASTER') {
	      this.trigger('loadedmetadata');
	    } else {
	      // trigger media change if the active media has been updated
	      this.trigger('mediachange');
	    }
	  };
	
	  _proto.pause = function pause() {
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	
	    if (this.isMaster_) {
	      window__default['default'].clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);
	      this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    }
	  };
	
	  _proto.load = function load(isFinalRendition) {
	    var _this4 = this;
	
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    var media = this.media();
	
	    if (isFinalRendition) {
	      var delay = media ? media.targetDuration / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        return _this4.load();
	      }, delay);
	      return;
	    } // because the playlists are internal to the manifest, load should either load the
	    // main manifest, or do nothing but trigger an event
	
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      // Check to see if this is the master loader and the MUP was cleared (this happens
	      // when the loader was paused). `media` should be set at this point since one is always
	      // set during `start()`.
	      if (this.isMaster_ && !this.minimumUpdatePeriodTimeout_) {
	        // Trigger minimumUpdatePeriod to refresh the master manifest
	        this.trigger('minimumUpdatePeriod'); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
	
	        this.updateMinimumUpdatePeriodTimeout_();
	      }
	
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.start = function start() {
	    var _this5 = this;
	
	    this.started = true; // We don't need to request the master manifest again
	    // Call this asynchronously to match the xhr request behavior below
	
	    if (!this.isMaster_) {
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return _this5.haveMaster_();
	      }, 0);
	      return;
	    }
	
	    this.requestMaster_(function (req, masterChanged) {
	      _this5.haveMaster_();
	
	      if (!_this5.hasPendingRequest() && !_this5.media_) {
	        _this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);
	      }
	    });
	  };
	
	  _proto.requestMaster_ = function requestMaster_(cb) {
	    var _this6 = this;
	
	    this.request = this.vhs_.xhr({
	      uri: this.masterPlaylistLoader_.srcUrl,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      if (_this6.requestErrored_(error, req)) {
	        if (_this6.state === 'HAVE_NOTHING') {
	          _this6.started = false;
	        }
	
	        return;
	      }
	
	      var masterChanged = req.responseText !== _this6.masterPlaylistLoader_.masterXml_;
	      _this6.masterPlaylistLoader_.masterXml_ = req.responseText;
	
	      if (req.responseHeaders && req.responseHeaders.date) {
	        _this6.masterLoaded_ = Date.parse(req.responseHeaders.date);
	      } else {
	        _this6.masterLoaded_ = Date.now();
	      }
	
	      _this6.masterPlaylistLoader_.srcUrl = resolveManifestRedirect(_this6.handleManifestRedirects, _this6.masterPlaylistLoader_.srcUrl, req);
	
	      if (masterChanged) {
	        _this6.handleMaster_();
	
	        _this6.syncClientServerClock_(function () {
	          return cb(req, masterChanged);
	        });
	
	        return;
	      }
	
	      return cb(req, masterChanged);
	    });
	  }
	  /**
	   * Parses the master xml for UTCTiming node to sync the client clock to the server
	   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
	   *
	   * @param {Function} done
	   *        Function to call when clock sync has completed
	   */
	  ;
	
	  _proto.syncClientServerClock_ = function syncClientServerClock_(done) {
	    var _this7 = this;
	
	    var utcTiming = mpdParser.parseUTCTiming(this.masterPlaylistLoader_.masterXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
	    // server clock
	
	    if (utcTiming === null) {
	      this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now();
	      return done();
	    }
	
	    if (utcTiming.method === 'DIRECT') {
	      this.masterPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
	      return done();
	    }
	
	    this.request = this.vhs_.xhr({
	      uri: resolveUrl(this.masterPlaylistLoader_.srcUrl, utcTiming.value),
	      method: utcTiming.method,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      }
	
	      if (error) {
	        // sync request failed, fall back to using date header from mpd
	        // TODO: log warning
	        _this7.masterPlaylistLoader_.clientOffset_ = _this7.masterLoaded_ - Date.now();
	        return done();
	      }
	
	      var serverTime;
	
	      if (utcTiming.method === 'HEAD') {
	        if (!req.responseHeaders || !req.responseHeaders.date) {
	          // expected date header not preset, fall back to using date header from mpd
	          // TODO: log warning
	          serverTime = _this7.masterLoaded_;
	        } else {
	          serverTime = Date.parse(req.responseHeaders.date);
	        }
	      } else {
	        serverTime = Date.parse(req.responseText);
	      }
	
	      _this7.masterPlaylistLoader_.clientOffset_ = serverTime - Date.now();
	      done();
	    });
	  };
	
	  _proto.haveMaster_ = function haveMaster_() {
	    this.state = 'HAVE_MASTER';
	
	    if (this.isMaster_) {
	      // We have the master playlist at this point, so
	      // trigger this to allow MasterPlaylistController
	      // to make an initial playlist selection
	      this.trigger('loadedplaylist');
	    } else if (!this.media_) {
	      // no media playlist was specifically selected so select
	      // the one the child playlist loader was created with
	      this.media(this.childPlaylist_);
	    }
	  };
	
	  _proto.handleMaster_ = function handleMaster_() {
	    // clear media request
	    this.mediaRequest_ = null;
	    var oldMaster = this.masterPlaylistLoader_.master;
	    var newMaster = parseMasterXml({
	      masterXml: this.masterPlaylistLoader_.masterXml_,
	      srcUrl: this.masterPlaylistLoader_.srcUrl,
	      clientOffset: this.masterPlaylistLoader_.clientOffset_,
	      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
	      previousManifest: oldMaster
	    }); // if we have an old master to compare the new master against
	
	    if (oldMaster) {
	      newMaster = updateMaster(oldMaster, newMaster, this.masterPlaylistLoader_.sidxMapping_);
	    } // only update master if we have a new master
	
	
	    this.masterPlaylistLoader_.master = newMaster ? newMaster : oldMaster;
	    var location = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
	
	    if (location && location !== this.masterPlaylistLoader_.srcUrl) {
	      this.masterPlaylistLoader_.srcUrl = location;
	    }
	
	    if (!oldMaster || newMaster && newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	      this.updateMinimumUpdatePeriodTimeout_();
	    }
	
	    return Boolean(newMaster);
	  };
	
	  _proto.updateMinimumUpdatePeriodTimeout_ = function updateMinimumUpdatePeriodTimeout_() {
	    var mpl = this.masterPlaylistLoader_; // cancel any pending creation of mup on media
	    // a new one will be added if needed.
	
	    if (mpl.createMupOnMedia_) {
	      mpl.off('loadedmetadata', mpl.createMupOnMedia_);
	      mpl.createMupOnMedia_ = null;
	    } // clear any pending timeouts
	
	
	    if (mpl.minimumUpdatePeriodTimeout_) {
	      window__default['default'].clearTimeout(mpl.minimumUpdatePeriodTimeout_);
	      mpl.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    var mup = mpl.master && mpl.master.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
	    // MPD has no future validity, so a new one will need to be acquired when new
	    // media segments are to be made available. Thus, we use the target duration
	    // in this case
	
	    if (mup === 0) {
	      if (mpl.media()) {
	        mup = mpl.media().targetDuration * 1000;
	      } else {
	        mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
	        mpl.one('loadedmetadata', mpl.createMupOnMedia_);
	      }
	    } // if minimumUpdatePeriod is invalid or <= zero, which
	    // can happen when a live video becomes VOD. skip timeout
	    // creation.
	
	
	    if (typeof mup !== 'number' || mup <= 0) {
	      if (mup < 0) {
	        this.logger_("found invalid minimumUpdatePeriod of " + mup + ", not setting a timeout");
	      }
	
	      return;
	    }
	
	    this.createMUPTimeout_(mup);
	  };
	
	  _proto.createMUPTimeout_ = function createMUPTimeout_(mup) {
	    var mpl = this.masterPlaylistLoader_;
	    mpl.minimumUpdatePeriodTimeout_ = window__default['default'].setTimeout(function () {
	      mpl.minimumUpdatePeriodTimeout_ = null;
	      mpl.trigger('minimumUpdatePeriod');
	      mpl.createMUPTimeout_(mup);
	    }, mup);
	  }
	  /**
	   * Sends request to refresh the master xml and updates the parsed master manifest
	   */
	  ;
	
	  _proto.refreshXml_ = function refreshXml_() {
	    var _this8 = this;
	
	    this.requestMaster_(function (req, masterChanged) {
	      if (!masterChanged) {
	        return;
	      }
	
	      if (_this8.media_) {
	        _this8.media_ = _this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];
	      } // This will filter out updated sidx info from the mapping
	
	
	      _this8.masterPlaylistLoader_.sidxMapping_ = filterChangedSidxMappings(_this8.masterPlaylistLoader_.master, _this8.masterPlaylistLoader_.sidxMapping_);
	
	      _this8.addSidxSegments_(_this8.media(), _this8.state, function (sidxChanged) {
	        // TODO: do we need to reload the current playlist?
	        _this8.refreshMedia_(_this8.media().id);
	      });
	    });
	  }
	  /**
	   * Refreshes the media playlist by re-parsing the master xml and updating playlist
	   * references. If this is an alternate loader, the updated parsed manifest is retrieved
	   * from the master loader.
	   */
	  ;
	
	  _proto.refreshMedia_ = function refreshMedia_(mediaID) {
	    var _this9 = this;
	
	    if (!mediaID) {
	      throw new Error('refreshMedia_ must take a media id');
	    } // for master we have to reparse the master xml
	    // to re-create segments based on current timing values
	    // which may change media. We only skip updating master
	    // if this is the first time this.media_ is being set.
	    // as master was just parsed in that case.
	
	
	    if (this.media_ && this.isMaster_) {
	      this.handleMaster_();
	    }
	
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
	
	    if (mediaChanged) {
	      this.media_ = playlists[mediaID];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    if (!this.mediaUpdateTimeout) {
	      var createMediaUpdateTimeout = function createMediaUpdateTimeout() {
	        if (_this9.media().endList) {
	          return;
	        }
	
	        _this9.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	          _this9.trigger('mediaupdatetimeout');
	
	          createMediaUpdateTimeout();
	        }, refreshDelay(_this9.media(), Boolean(mediaChanged)));
	      };
	
	      createMediaUpdateTimeout();
	    }
	
	    this.trigger('loadedplaylist');
	  };
	
	  return DashPlaylistLoader;
	}(EventTarget);
	
	var Config = {
	  GOAL_BUFFER_LENGTH: 30,
	  MAX_GOAL_BUFFER_LENGTH: 60,
	  BACK_BUFFER_LENGTH: 30,
	  GOAL_BUFFER_LENGTH_RATE: 1,
	  // 0.5 MB/s
	  INITIAL_BANDWIDTH: 4194304,
	  // A fudge factor to apply to advertised playlist bitrates to account for
	  // temporary flucations in client bandwidth
	  BANDWIDTH_VARIANCE: 1.2,
	  // How much of the buffer must be filled before we consider upswitching
	  BUFFER_LOW_WATER_LINE: 0,
	  MAX_BUFFER_LOW_WATER_LINE: 30,
	  // TODO: Remove this when experimentalBufferBasedABR is removed
	  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
	  BUFFER_LOW_WATER_LINE_RATE: 1,
	  // If the buffer is greater than the high water line, we won't switch down
	  BUFFER_HIGH_WATER_LINE: 30
	};
	
	var stringToArrayBuffer = function stringToArrayBuffer(string) {
	  var view = new Uint8Array(new ArrayBuffer(string.length));
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view.buffer;
	};
	/* global Blob, BlobBuilder, Worker */
	// unify worker interface
	
	
	var browserWorkerPolyFill = function browserWorkerPolyFill(workerObj) {
	  // node only supports on/off
	  workerObj.on = workerObj.addEventListener;
	  workerObj.off = workerObj.removeEventListener;
	  return workerObj;
	};
	
	var createObjectURL = function createObjectURL(str) {
	  try {
	    return URL.createObjectURL(new Blob([str], {
	      type: 'application/javascript'
	    }));
	  } catch (e) {
	    var blob = new BlobBuilder();
	    blob.append(str);
	    return URL.createObjectURL(blob.getBlob());
	  }
	};
	
	var factory = function factory(code) {
	  return function () {
	    var objectUrl = createObjectURL(code);
	    var worker = browserWorkerPolyFill(new Worker(objectUrl));
	    worker.objURL = objectUrl;
	    var terminate = worker.terminate;
	    worker.on = worker.addEventListener;
	    worker.off = worker.removeEventListener;
	
	    worker.terminate = function () {
	      URL.revokeObjectURL(objectUrl);
	      return terminate.call(this);
	    };
	
	    return worker;
	  };
	};
	
	var transform = function transform(code) {
	  return "var browserWorkerPolyFill = " + browserWorkerPolyFill.toString() + ";\n" + 'browserWorkerPolyFill(self);\n' + code;
	};
	
	var getWorkerString = function getWorkerString(fn) {
	  return fn.toString().replace(/^function.+?{/, '').slice(0, -1);
	};
	/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */
	
	
	var workerCode$1 = transform(getWorkerString(function () {
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * A lightweight readable stream implemention that handles event dispatching.
	   * Objects that inherit from streams should call init in their constructors.
	   */
	  var Stream = function Stream() {
	    this.init = function () {
	      var listeners = {};
	      /**
	       * Add a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} the callback to be invoked when an event of
	       * the specified type occurs
	       */
	
	      this.on = function (type, listener) {
	        if (!listeners[type]) {
	          listeners[type] = [];
	        }
	
	        listeners[type] = listeners[type].concat(listener);
	      };
	      /**
	       * Remove a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} a function previously registered for this
	       * type of event through `on`
	       */
	
	
	      this.off = function (type, listener) {
	        var index;
	
	        if (!listeners[type]) {
	          return false;
	        }
	
	        index = listeners[type].indexOf(listener);
	        listeners[type] = listeners[type].slice();
	        listeners[type].splice(index, 1);
	        return index > -1;
	      };
	      /**
	       * Trigger an event of the specified type on this stream. Any additional
	       * arguments to this function are passed as parameters to event listeners.
	       * @param type {string} the event name
	       */
	
	
	      this.trigger = function (type) {
	        var callbacks, i, length, args;
	        callbacks = listeners[type];
	
	        if (!callbacks) {
	          return;
	        } // Slicing the arguments on every invocation of this method
	        // can add a significant amount of overhead. Avoid the
	        // intermediate object creation for the common case of a
	        // single callback argument
	
	
	        if (arguments.length === 2) {
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].call(this, arguments[1]);
	          }
	        } else {
	          args = [];
	          i = arguments.length;
	
	          for (i = 1; i < arguments.length; ++i) {
	            args.push(arguments[i]);
	          }
	
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].apply(this, args);
	          }
	        }
	      };
	      /**
	       * Destroys the stream and cleans up.
	       */
	
	
	      this.dispose = function () {
	        listeners = {};
	      };
	    };
	  };
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   * @param destination {stream} the stream that will receive all `data` events
	   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	   *                            when the current stream emits a 'done' event
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	
	
	  Stream.prototype.pipe = function (destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	    this.on('done', function (flushSource) {
	      destination.flush(flushSource);
	    });
	    this.on('partialdone', function (flushSource) {
	      destination.partialFlush(flushSource);
	    });
	    this.on('endedtimeline', function (flushSource) {
	      destination.endTimeline(flushSource);
	    });
	    this.on('reset', function (flushSource) {
	      destination.reset(flushSource);
	    });
	    return destination;
	  }; // Default stream functions that are expected to be overridden to perform
	  // actual work. These are provided by the prototype as a sort of no-op
	  // implementation so that we don't have to check for their existence in the
	  // `pipe` function above.
	
	
	  Stream.prototype.push = function (data) {
	    this.trigger('data', data);
	  };
	
	  Stream.prototype.flush = function (flushSource) {
	    this.trigger('done', flushSource);
	  };
	
	  Stream.prototype.partialFlush = function (flushSource) {
	    this.trigger('partialdone', flushSource);
	  };
	
	  Stream.prototype.endTimeline = function (flushSource) {
	    this.trigger('endedtimeline', flushSource);
	  };
	
	  Stream.prototype.reset = function (flushSource) {
	    this.trigger('reset', flushSource);
	  };
	
	  var stream = Stream;
	  var MAX_UINT32$1 = Math.pow(2, 32);
	
	  var getUint64$2 = function getUint64(uint8) {
	    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	    var value;
	
	    if (dv.getBigUint64) {
	      value = dv.getBigUint64(0);
	
	      if (value < Number.MAX_SAFE_INTEGER) {
	        return Number(value);
	      }
	
	      return value;
	    }
	
	    return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
	  };
	
	  var numbers = {
	    getUint64: getUint64$2,
	    MAX_UINT32: MAX_UINT32$1
	  };
	  var MAX_UINT32 = numbers.MAX_UINT32;
	  var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
	
	  (function () {
	    var i;
	    types = {
	      avc1: [],
	      // codingname
	      avcC: [],
	      btrt: [],
	      dinf: [],
	      dref: [],
	      esds: [],
	      ftyp: [],
	      hdlr: [],
	      mdat: [],
	      mdhd: [],
	      mdia: [],
	      mfhd: [],
	      minf: [],
	      moof: [],
	      moov: [],
	      mp4a: [],
	      // codingname
	      mvex: [],
	      mvhd: [],
	      pasp: [],
	      sdtp: [],
	      smhd: [],
	      stbl: [],
	      stco: [],
	      stsc: [],
	      stsd: [],
	      stsz: [],
	      stts: [],
	      styp: [],
	      tfdt: [],
	      tfhd: [],
	      traf: [],
	      trak: [],
	      trun: [],
	      trex: [],
	      tkhd: [],
	      vmhd: []
	    }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	    // don't throw an error
	
	    if (typeof Uint8Array === 'undefined') {
	      return;
	    }
	
	    for (i in types) {
	      if (types.hasOwnProperty(i)) {
	        types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	      }
	    }
	
	    MAJOR_BRAND = new Uint8Array(['i'.charCodeAt(0), 's'.charCodeAt(0), 'o'.charCodeAt(0), 'm'.charCodeAt(0)]);
	    AVC1_BRAND = new Uint8Array(['a'.charCodeAt(0), 'v'.charCodeAt(0), 'c'.charCodeAt(0), '1'.charCodeAt(0)]);
	    MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	    VIDEO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	    ]);
	    AUDIO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	    ]);
	    HDLR_TYPES = {
	      video: VIDEO_HDLR,
	      audio: AUDIO_HDLR
	    };
	    DREF = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // entry_count
	    0x00, 0x00, 0x00, 0x0c, // entry_size
	    0x75, 0x72, 0x6c, 0x20, // 'url' type
	    0x00, // version 0
	    0x00, 0x00, 0x01 // entry_flags
	    ]);
	    SMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, // balance, 0 means centered
	    0x00, 0x00 // reserved
	    ]);
	    STCO = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00 // entry_count
	    ]);
	    STSC = STCO;
	    STSZ = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // sample_size
	    0x00, 0x00, 0x00, 0x00 // sample_count
	    ]);
	    STTS = STCO;
	    VMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x01, // flags
	    0x00, 0x00, // graphicsmode
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	    ]);
	  })();
	
	  box = function box(type) {
	    var payload = [],
	        size = 0,
	        i,
	        result,
	        view;
	
	    for (i = 1; i < arguments.length; i++) {
	      payload.push(arguments[i]);
	    }
	
	    i = payload.length; // calculate the total size we need to allocate
	
	    while (i--) {
	      size += payload[i].byteLength;
	    }
	
	    result = new Uint8Array(size + 8);
	    view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	    view.setUint32(0, result.byteLength);
	    result.set(type, 4); // copy the payload into the result
	
	    for (i = 0, size = 8; i < payload.length; i++) {
	      result.set(payload[i], size);
	      size += payload[i].byteLength;
	    }
	
	    return result;
	  };
	
	  dinf = function dinf() {
	    return box(types.dinf, box(types.dref, DREF));
	  };
	
	  esds = function esds(track) {
	    return box(types.esds, new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    // ES_Descriptor
	    0x03, // tag, ES_DescrTag
	    0x19, // length
	    0x00, 0x00, // ES_ID
	    0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	    // DecoderConfigDescriptor
	    0x04, // tag, DecoderConfigDescrTag
	    0x11, // length
	    0x40, // object type
	    0x15, // streamType
	    0x00, 0x06, 0x00, // bufferSizeDB
	    0x00, 0x00, 0xda, 0xc0, // maxBitrate
	    0x00, 0x00, 0xda, 0xc0, // avgBitrate
	    // DecoderSpecificInfo
	    0x05, // tag, DecoderSpecificInfoTag
	    0x02, // length
	    // ISO/IEC 14496-3, AudioSpecificConfig
	    // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	    track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1, track.samplingfrequencyindex << 7 | track.channelcount << 3, 0x06, 0x01, 0x02 // GASpecificConfig
	    ]));
	  };
	
	  ftyp = function ftyp() {
	    return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	  };
	
	  hdlr = function hdlr(type) {
	    return box(types.hdlr, HDLR_TYPES[type]);
	  };
	
	  mdat = function mdat(data) {
	    return box(types.mdat, data);
	  };
	
	  mdhd = function mdhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x03, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    track.duration >>> 24 & 0xFF, track.duration >>> 16 & 0xFF, track.duration >>> 8 & 0xFF, track.duration & 0xFF, // duration
	    0x55, 0xc4, // 'und' language (undetermined)
	    0x00, 0x00]); // Use the sample rate from the track metadata, when it is
	    // defined. The sample rate can be parsed out of an ADTS header, for
	    // instance.
	
	    if (track.samplerate) {
	      result[12] = track.samplerate >>> 24 & 0xFF;
	      result[13] = track.samplerate >>> 16 & 0xFF;
	      result[14] = track.samplerate >>> 8 & 0xFF;
	      result[15] = track.samplerate & 0xFF;
	    }
	
	    return box(types.mdhd, result);
	  };
	
	  mdia = function mdia(track) {
	    return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	  };
	
	  mfhd = function mfhd(sequenceNumber) {
	    return box(types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	    (sequenceNumber & 0xFF000000) >> 24, (sequenceNumber & 0xFF0000) >> 16, (sequenceNumber & 0xFF00) >> 8, sequenceNumber & 0xFF // sequence_number
	    ]));
	  };
	
	  minf = function minf(track) {
	    return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
	  };
	
	  moof = function moof(sequenceNumber, tracks) {
	    var trackFragments = [],
	        i = tracks.length; // build traf boxes for each track fragment
	
	    while (i--) {
	      trackFragments[i] = traf(tracks[i]);
	    }
	
	    return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
	  };
	  /**
	   * Returns a movie box.
	   * @param tracks {array} the tracks associated with this movie
	   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	   */
	
	
	  moov = function moov(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trak(tracks[i]);
	    }
	
	    return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	  };
	
	  mvex = function mvex(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trex(tracks[i]);
	    }
	
	    return box.apply(null, [types.mvex].concat(boxes));
	  };
	
	  mvhd = function mvhd(duration) {
	    var bytes = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // creation_time
	    0x00, 0x00, 0x00, 0x02, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    (duration & 0xFF000000) >> 24, (duration & 0xFF0000) >> 16, (duration & 0xFF00) >> 8, duration & 0xFF, // duration
	    0x00, 0x01, 0x00, 0x00, // 1.0 rate
	    0x01, 0x00, // 1.0 volume
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    0xff, 0xff, 0xff, 0xff // next_track_ID
	    ]);
	    return box(types.mvhd, bytes);
	  };
	
	  sdtp = function sdtp(track) {
	    var samples = track.samples || [],
	        bytes = new Uint8Array(4 + samples.length),
	        flags,
	        i; // leave the full box header (4 bytes) all zero
	    // write the sample table
	
	    for (i = 0; i < samples.length; i++) {
	      flags = samples[i].flags;
	      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	    }
	
	    return box(types.sdtp, bytes);
	  };
	
	  stbl = function stbl(track) {
	    return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
	  };
	
	  (function () {
	    var videoSample, audioSample;
	
	    stsd = function stsd(track) {
	      return box(types.stsd, new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01]), track.type === 'video' ? videoSample(track) : audioSample(track));
	    };
	
	    videoSample = function videoSample(track) {
	      var sps = track.sps || [],
	          pps = track.pps || [],
	          sequenceParameterSets = [],
	          pictureParameterSets = [],
	          i,
	          avc1Box; // assemble the SPSs
	
	      for (i = 0; i < sps.length; i++) {
	        sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	        sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
	
	        sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	      } // assemble the PPSs
	
	
	      for (i = 0; i < pps.length; i++) {
	        pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	        pictureParameterSets.push(pps[i].byteLength & 0xFF);
	        pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	      }
	
	      avc1Box = [types.avc1, new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	      (track.width & 0xff00) >> 8, track.width & 0xff, // width
	      (track.height & 0xff00) >> 8, track.height & 0xff, // height
	      0x00, 0x48, 0x00, 0x00, // horizresolution
	      0x00, 0x48, 0x00, 0x00, // vertresolution
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // frame_count
	      0x13, 0x76, 0x69, 0x64, 0x65, 0x6f, 0x6a, 0x73, 0x2d, 0x63, 0x6f, 0x6e, 0x74, 0x72, 0x69, 0x62, 0x2d, 0x68, 0x6c, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	      0x00, 0x18, // depth = 24
	      0x11, 0x11 // pre_defined = -1
	      ]), box(types.avcC, new Uint8Array([0x01, // configurationVersion
	      track.profileIdc, // AVCProfileIndication
	      track.profileCompatibility, // profile_compatibility
	      track.levelIdc, // AVCLevelIndication
	      0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	      ].concat([sps.length], // numOfSequenceParameterSets
	      sequenceParameterSets, // "SPS"
	      [pps.length], // numOfPictureParameterSets
	      pictureParameterSets // "PPS"
	      ))), box(types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	      0x00, 0x2d, 0xc6, 0xc0 // avgBitrate
	      ]))];
	
	      if (track.sarRatio) {
	        var hSpacing = track.sarRatio[0],
	            vSpacing = track.sarRatio[1];
	        avc1Box.push(box(types.pasp, new Uint8Array([(hSpacing & 0xFF000000) >> 24, (hSpacing & 0xFF0000) >> 16, (hSpacing & 0xFF00) >> 8, hSpacing & 0xFF, (vSpacing & 0xFF000000) >> 24, (vSpacing & 0xFF0000) >> 16, (vSpacing & 0xFF00) >> 8, vSpacing & 0xFF])));
	      }
	
	      return box.apply(null, avc1Box);
	    };
	
	    audioSample = function audioSample(track) {
	      return box(types.mp4a, new Uint8Array([// SampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      // AudioSampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      (track.channelcount & 0xff00) >> 8, track.channelcount & 0xff, // channelcount
	      (track.samplesize & 0xff00) >> 8, track.samplesize & 0xff, // samplesize
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      (track.samplerate & 0xff00) >> 8, track.samplerate & 0xff, 0x00, 0x00 // samplerate, 16.16
	      // MP4AudioSampleEntry, ISO/IEC 14496-14
	      ]), esds(track));
	    };
	  })();
	
	  tkhd = function tkhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x07, // flags
	    0x00, 0x00, 0x00, 0x00, // creation_time
	    0x00, 0x00, 0x00, 0x00, // modification_time
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x00, // reserved
	    (track.duration & 0xFF000000) >> 24, (track.duration & 0xFF0000) >> 16, (track.duration & 0xFF00) >> 8, track.duration & 0xFF, // duration
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, // layer
	    0x00, 0x00, // alternate_group
	    0x01, 0x00, // non-audio track volume
	    0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    (track.width & 0xFF00) >> 8, track.width & 0xFF, 0x00, 0x00, // width
	    (track.height & 0xFF00) >> 8, track.height & 0xFF, 0x00, 0x00 // height
	    ]);
	    return box(types.tkhd, result);
	  };
	  /**
	   * Generate a track fragment (traf) box. A traf box collects metadata
	   * about tracks in a movie fragment (moof) box.
	   */
	
	
	  traf = function traf(track) {
	    var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	    trackFragmentHeader = box(types.tfhd, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x3a, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x00, 0x00, 0x00 // default_sample_flags
	    ]));
	    upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
	    lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
	    trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    // baseMediaDecodeTime
	    upperWordBaseMediaDecodeTime >>> 24 & 0xFF, upperWordBaseMediaDecodeTime >>> 16 & 0xFF, upperWordBaseMediaDecodeTime >>> 8 & 0xFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >>> 24 & 0xFF, lowerWordBaseMediaDecodeTime >>> 16 & 0xFF, lowerWordBaseMediaDecodeTime >>> 8 & 0xFF, lowerWordBaseMediaDecodeTime & 0xFF])); // the data offset specifies the number of bytes from the start of
	    // the containing moof to the first payload byte of the associated
	    // mdat
	
	    dataOffset = 32 + // tfhd
	    20 + // tfdt
	    8 + // traf header
	    16 + // mfhd
	    8 + // moof header
	    8; // mdat header
	    // audio tracks require less metadata
	
	    if (track.type === 'audio') {
	      trackFragmentRun = trun$1(track, dataOffset);
	      return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
	    } // video tracks should contain an independent and disposable samples
	    // box (sdtp)
	    // generate one and adjust offsets to match
	
	
	    sampleDependencyTable = sdtp(track);
	    trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
	    return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
	  };
	  /**
	   * Generate a track box.
	   * @param track {object} a track definition
	   * @return {Uint8Array} the track box
	   */
	
	
	  trak = function trak(track) {
	    track.duration = track.duration || 0xffffffff;
	    return box(types.trak, tkhd(track), mdia(track));
	  };
	
	  trex = function trex(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x01, 0x00, 0x01 // default_sample_flags
	    ]); // the last two bytes of default_sample_flags is the sample
	    // degradation priority, a hint about the importance of this sample
	    // relative to others. Lower the degradation priority for all sample
	    // types other than video.
	
	    if (track.type !== 'video') {
	      result[result.length - 1] = 0x00;
	    }
	
	    return box(types.trex, result);
	  };
	
	  (function () {
	    var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
	    // duration is present for the first sample, it will be present for
	    // all subsequent samples.
	    // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	
	    trunHeader = function trunHeader(samples, offset) {
	      var durationPresent = 0,
	          sizePresent = 0,
	          flagsPresent = 0,
	          compositionTimeOffset = 0; // trun flag constants
	
	      if (samples.length) {
	        if (samples[0].duration !== undefined) {
	          durationPresent = 0x1;
	        }
	
	        if (samples[0].size !== undefined) {
	          sizePresent = 0x2;
	        }
	
	        if (samples[0].flags !== undefined) {
	          flagsPresent = 0x4;
	        }
	
	        if (samples[0].compositionTimeOffset !== undefined) {
	          compositionTimeOffset = 0x8;
	        }
	      }
	
	      return [0x00, // version 0
	      0x00, durationPresent | sizePresent | flagsPresent | compositionTimeOffset, 0x01, // flags
	      (samples.length & 0xFF000000) >>> 24, (samples.length & 0xFF0000) >>> 16, (samples.length & 0xFF00) >>> 8, samples.length & 0xFF, // sample_count
	      (offset & 0xFF000000) >>> 24, (offset & 0xFF0000) >>> 16, (offset & 0xFF00) >>> 8, offset & 0xFF // data_offset
	      ];
	    };
	
	    videoTrun = function videoTrun(track, offset) {
	      var bytesOffest, bytes, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 16 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 16);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	
	        bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
	        bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0xF0 << 8;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
	
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    audioTrun = function audioTrun(track, offset) {
	      var bytes, bytesOffest, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 8 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 8);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    trun$1 = function trun(track, offset) {
	      if (track.type === 'audio') {
	        return audioTrun(track, offset);
	      }
	
	      return videoTrun(track, offset);
	    };
	  })();
	
	  var mp4Generator = {
	    ftyp: ftyp,
	    mdat: mdat,
	    moof: moof,
	    moov: moov,
	    initSegment: function initSegment(tracks) {
	      var fileType = ftyp(),
	          movie = moov(tracks),
	          result;
	      result = new Uint8Array(fileType.byteLength + movie.byteLength);
	      result.set(fileType);
	      result.set(movie, fileType.byteLength);
	      return result;
	    }
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	  // Convert an array of nal units into an array of frames with each frame being
	  // composed of the nal units that make up that frame
	  // Also keep track of cummulative data about the frame from the nal units such
	  // as the frame duration, starting pts, etc.
	
	  var groupNalsIntoFrames = function groupNalsIntoFrames(nalUnits) {
	    var i,
	        currentNal,
	        currentFrame = [],
	        frames = []; // TODO added for LHLS, make sure this is OK
	
	    frames.byteLength = 0;
	    frames.nalCount = 0;
	    frames.duration = 0;
	    currentFrame.byteLength = 0;
	
	    for (i = 0; i < nalUnits.length; i++) {
	      currentNal = nalUnits[i]; // Split on 'aud'-type nal units
	
	      if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	        // Since the very first nal unit is expected to be an AUD
	        // only push to the frames array when currentFrame is not empty
	        if (currentFrame.length) {
	          currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
	
	          frames.byteLength += currentFrame.byteLength;
	          frames.nalCount += currentFrame.length;
	          frames.duration += currentFrame.duration;
	          frames.push(currentFrame);
	        }
	
	        currentFrame = [currentNal];
	        currentFrame.byteLength = currentNal.data.byteLength;
	        currentFrame.pts = currentNal.pts;
	        currentFrame.dts = currentNal.dts;
	      } else {
	        // Specifically flag key frames for ease of use later
	        if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	          currentFrame.keyFrame = true;
	        }
	
	        currentFrame.duration = currentNal.dts - currentFrame.dts;
	        currentFrame.byteLength += currentNal.data.byteLength;
	        currentFrame.push(currentNal);
	      }
	    } // For the last frame, use the duration of the previous frame if we
	    // have nothing better to go on
	
	
	    if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
	      currentFrame.duration = frames[frames.length - 1].duration;
	    } // Push the final frame
	    // TODO added for LHLS, make sure this is OK
	
	
	    frames.byteLength += currentFrame.byteLength;
	    frames.nalCount += currentFrame.length;
	    frames.duration += currentFrame.duration;
	    frames.push(currentFrame);
	    return frames;
	  }; // Convert an array of frames into an array of Gop with each Gop being composed
	  // of the frames that make up that Gop
	  // Also keep track of cummulative data about the Gop from the frames such as the
	  // Gop duration, starting pts, etc.
	
	
	  var groupFramesIntoGops = function groupFramesIntoGops(frames) {
	    var i,
	        currentFrame,
	        currentGop = [],
	        gops = []; // We must pre-set some of the values on the Gop since we
	    // keep running totals of these values
	
	    currentGop.byteLength = 0;
	    currentGop.nalCount = 0;
	    currentGop.duration = 0;
	    currentGop.pts = frames[0].pts;
	    currentGop.dts = frames[0].dts; // store some metadata about all the Gops
	
	    gops.byteLength = 0;
	    gops.nalCount = 0;
	    gops.duration = 0;
	    gops.pts = frames[0].pts;
	    gops.dts = frames[0].dts;
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      if (currentFrame.keyFrame) {
	        // Since the very first frame is expected to be an keyframe
	        // only push to the gops array when currentGop is not empty
	        if (currentGop.length) {
	          gops.push(currentGop);
	          gops.byteLength += currentGop.byteLength;
	          gops.nalCount += currentGop.nalCount;
	          gops.duration += currentGop.duration;
	        }
	
	        currentGop = [currentFrame];
	        currentGop.nalCount = currentFrame.length;
	        currentGop.byteLength = currentFrame.byteLength;
	        currentGop.pts = currentFrame.pts;
	        currentGop.dts = currentFrame.dts;
	        currentGop.duration = currentFrame.duration;
	      } else {
	        currentGop.duration += currentFrame.duration;
	        currentGop.nalCount += currentFrame.length;
	        currentGop.byteLength += currentFrame.byteLength;
	        currentGop.push(currentFrame);
	      }
	    }
	
	    if (gops.length && currentGop.duration <= 0) {
	      currentGop.duration = gops[gops.length - 1].duration;
	    }
	
	    gops.byteLength += currentGop.byteLength;
	    gops.nalCount += currentGop.nalCount;
	    gops.duration += currentGop.duration; // push the final Gop
	
	    gops.push(currentGop);
	    return gops;
	  };
	  /*
	   * Search for the first keyframe in the GOPs and throw away all frames
	   * until that keyframe. Then extend the duration of the pulled keyframe
	   * and pull the PTS and DTS of the keyframe so that it covers the time
	   * range of the frames that were disposed.
	   *
	   * @param {Array} gops video GOPs
	   * @returns {Array} modified video GOPs
	   */
	
	
	  var extendFirstKeyFrame = function extendFirstKeyFrame(gops) {
	    var currentGop;
	
	    if (!gops[0][0].keyFrame && gops.length > 1) {
	      // Remove the first GOP
	      currentGop = gops.shift();
	      gops.byteLength -= currentGop.byteLength;
	      gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
	      // first gop to cover the time period of the
	      // frames we just removed
	
	      gops[0][0].dts = currentGop.dts;
	      gops[0][0].pts = currentGop.pts;
	      gops[0][0].duration += currentGop.duration;
	    }
	
	    return gops;
	  };
	  /**
	   * Default sample object
	   * see ISO/IEC 14496-12:2012, section 8.6.4.3
	   */
	
	
	  var createDefaultSample = function createDefaultSample() {
	    return {
	      size: 0,
	      flags: {
	        isLeading: 0,
	        dependsOn: 1,
	        isDependedOn: 0,
	        hasRedundancy: 0,
	        degradationPriority: 0,
	        isNonSyncSample: 1
	      }
	    };
	  };
	  /*
	   * Collates information from a video frame into an object for eventual
	   * entry into an MP4 sample table.
	   *
	   * @param {Object} frame the video frame
	   * @param {Number} dataOffset the byte offset to position the sample
	   * @return {Object} object containing sample table info for a frame
	   */
	
	
	  var sampleForFrame = function sampleForFrame(frame, dataOffset) {
	    var sample = createDefaultSample();
	    sample.dataOffset = dataOffset;
	    sample.compositionTimeOffset = frame.pts - frame.dts;
	    sample.duration = frame.duration;
	    sample.size = 4 * frame.length; // Space for nal unit size
	
	    sample.size += frame.byteLength;
	
	    if (frame.keyFrame) {
	      sample.flags.dependsOn = 2;
	      sample.flags.isNonSyncSample = 0;
	    }
	
	    return sample;
	  }; // generate the track's sample table from an array of gops
	
	
	  var generateSampleTable$1 = function generateSampleTable(gops, baseDataOffset) {
	    var h,
	        i,
	        sample,
	        currentGop,
	        currentFrame,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h];
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i];
	        sample = sampleForFrame(currentFrame, dataOffset);
	        dataOffset += sample.size;
	        samples.push(sample);
	      }
	    }
	
	    return samples;
	  }; // generate the track's raw mdat data from an array of gops
	
	
	  var concatenateNalData = function concatenateNalData(gops) {
	    var h,
	        i,
	        j,
	        currentGop,
	        currentFrame,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = gops.byteLength,
	        numberOfNals = gops.nalCount,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each Gop..
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h]; // For each Frame..
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i]; // For each NAL..
	
	        for (j = 0; j < currentFrame.length; j++) {
	          currentNal = currentFrame[j];
	          view.setUint32(dataOffset, currentNal.data.byteLength);
	          dataOffset += 4;
	          data.set(currentNal.data, dataOffset);
	          dataOffset += currentNal.data.byteLength;
	        }
	      }
	    }
	
	    return data;
	  }; // generate the track's sample table from a frame
	
	
	  var generateSampleTableForFrame = function generateSampleTableForFrame(frame, baseDataOffset) {
	    var sample,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	    sample = sampleForFrame(frame, dataOffset);
	    samples.push(sample);
	    return samples;
	  }; // generate the track's raw mdat data from a frame
	
	
	  var concatenateNalDataForFrame = function concatenateNalDataForFrame(frame) {
	    var i,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = frame.byteLength,
	        numberOfNals = frame.length,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each NAL..
	
	    for (i = 0; i < frame.length; i++) {
	      currentNal = frame[i];
	      view.setUint32(dataOffset, currentNal.data.byteLength);
	      dataOffset += 4;
	      data.set(currentNal.data, dataOffset);
	      dataOffset += currentNal.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var frameUtils = {
	    groupNalsIntoFrames: groupNalsIntoFrames,
	    groupFramesIntoGops: groupFramesIntoGops,
	    extendFirstKeyFrame: extendFirstKeyFrame,
	    generateSampleTable: generateSampleTable$1,
	    concatenateNalData: concatenateNalData,
	    generateSampleTableForFrame: generateSampleTableForFrame,
	    concatenateNalDataForFrame: concatenateNalDataForFrame
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var highPrefix = [33, 16, 5, 32, 164, 27];
	  var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	
	  var zeroFill = function zeroFill(count) {
	    var a = [];
	
	    while (count--) {
	      a.push(0);
	    }
	
	    return a;
	  };
	
	  var makeTable = function makeTable(metaTable) {
	    return Object.keys(metaTable).reduce(function (obj, key) {
	      obj[key] = new Uint8Array(metaTable[key].reduce(function (arr, part) {
	        return arr.concat(part);
	      }, []));
	      return obj;
	    }, {});
	  };
	
	  var silence;
	
	  var silence_1 = function silence_1() {
	    if (!silence) {
	      // Frames-of-silence to use for filling in missing AAC frames
	      var coneOfSilence = {
	        96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	        88200: [highPrefix, [231], zeroFill(170), [56]],
	        64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	        48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	        44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	        32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	        24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	        16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	        12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	        11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	        8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	      };
	      silence = makeTable(coneOfSilence);
	    }
	
	    return silence;
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	
	  var ONE_SECOND_IN_TS$4 = 90000,
	      // 90kHz clock
	  secondsToVideoTs,
	      secondsToAudioTs,
	      videoTsToSeconds,
	      audioTsToSeconds,
	      audioTsToVideoTs,
	      videoTsToAudioTs,
	      metadataTsToSeconds;
	
	  secondsToVideoTs = function secondsToVideoTs(seconds) {
	    return seconds * ONE_SECOND_IN_TS$4;
	  };
	
	  secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
	    return seconds * sampleRate;
	  };
	
	  videoTsToSeconds = function videoTsToSeconds(timestamp) {
	    return timestamp / ONE_SECOND_IN_TS$4;
	  };
	
	  audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
	    return timestamp / sampleRate;
	  };
	
	  audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
	    return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	  };
	
	  videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
	    return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	  };
	  /**
	   * Adjust ID3 tag or caption timing information by the timeline pts values
	   * (if keepOriginalTimestamps is false) and convert to seconds
	   */
	
	
	  metadataTsToSeconds = function metadataTsToSeconds(timestamp, timelineStartPts, keepOriginalTimestamps) {
	    return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	  };
	
	  var clock = {
	    ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
	    secondsToVideoTs: secondsToVideoTs,
	    secondsToAudioTs: secondsToAudioTs,
	    videoTsToSeconds: videoTsToSeconds,
	    audioTsToSeconds: audioTsToSeconds,
	    audioTsToVideoTs: audioTsToVideoTs,
	    videoTsToAudioTs: videoTsToAudioTs,
	    metadataTsToSeconds: metadataTsToSeconds
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  /**
	   * Sum the `byteLength` properties of the data in each AAC frame
	   */
	
	  var sumFrameByteLengths = function sumFrameByteLengths(array) {
	    var i,
	        currentObj,
	        sum = 0; // sum the byteLength's all each nal unit in the frame
	
	    for (i = 0; i < array.length; i++) {
	      currentObj = array[i];
	      sum += currentObj.data.byteLength;
	    }
	
	    return sum;
	  }; // Possibly pad (prefix) the audio track with silence if appending this track
	  // would lead to the introduction of a gap in the audio buffer
	
	
	  var prefixWithSilence = function prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
	    var baseMediaDecodeTimeTs,
	        frameDuration = 0,
	        audioGapDuration = 0,
	        audioFillFrameCount = 0,
	        audioFillDuration = 0,
	        silentFrame,
	        i,
	        firstFrame;
	
	    if (!frames.length) {
	      return;
	    }
	
	    baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
	
	    frameDuration = Math.ceil(clock.ONE_SECOND_IN_TS / (track.samplerate / 1024));
	
	    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	      // insert the shortest possible amount (audio gap or audio to video gap)
	      audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
	
	      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	      audioFillDuration = audioFillFrameCount * frameDuration;
	    } // don't attempt to fill gaps smaller than a single frame or larger
	    // than a half second
	
	
	    if (audioFillFrameCount < 1 || audioFillDuration > clock.ONE_SECOND_IN_TS / 2) {
	      return;
	    }
	
	    silentFrame = silence_1()[track.samplerate];
	
	    if (!silentFrame) {
	      // we don't have a silent frame pregenerated for the sample rate, so use a frame
	      // from the content instead
	      silentFrame = frames[0].data;
	    }
	
	    for (i = 0; i < audioFillFrameCount; i++) {
	      firstFrame = frames[0];
	      frames.splice(0, 0, {
	        data: silentFrame,
	        dts: firstFrame.dts - frameDuration,
	        pts: firstFrame.pts - frameDuration
	      });
	    }
	
	    track.baseMediaDecodeTime -= Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	    return audioFillDuration;
	  }; // If the audio segment extends before the earliest allowed dts
	  // value, remove AAC frames until starts at or after the earliest
	  // allowed DTS so that we don't end up with a negative baseMedia-
	  // DecodeTime for the audio track
	
	
	  var trimAdtsFramesByEarliestDts = function trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts) {
	    if (track.minSegmentDts >= earliestAllowedDts) {
	      return adtsFrames;
	    } // We will need to recalculate the earliest segment Dts
	
	
	    track.minSegmentDts = Infinity;
	    return adtsFrames.filter(function (currentFrame) {
	      // If this is an allowed frame, keep it and record it's Dts
	      if (currentFrame.dts >= earliestAllowedDts) {
	        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	        track.minSegmentPts = track.minSegmentDts;
	        return true;
	      } // Otherwise, discard it
	
	
	      return false;
	    });
	  }; // generate the track's raw mdat data from an array of frames
	
	
	  var generateSampleTable = function generateSampleTable(frames) {
	    var i,
	        currentFrame,
	        samples = [];
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      samples.push({
	        size: currentFrame.data.byteLength,
	        duration: 1024 // For AAC audio, all samples contain 1024 samples
	
	      });
	    }
	
	    return samples;
	  }; // generate the track's sample table from an array of frames
	
	
	  var concatenateFrameData = function concatenateFrameData(frames) {
	    var i,
	        currentFrame,
	        dataOffset = 0,
	        data = new Uint8Array(sumFrameByteLengths(frames));
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      data.set(currentFrame.data, dataOffset);
	      dataOffset += currentFrame.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var audioFrameUtils = {
	    prefixWithSilence: prefixWithSilence,
	    trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
	    generateSampleTable: generateSampleTable,
	    concatenateFrameData: concatenateFrameData
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ONE_SECOND_IN_TS$3 = clock.ONE_SECOND_IN_TS;
	  /**
	   * Store information about the start and end of the track and the
	   * duration for each frame/sample we process in order to calculate
	   * the baseMediaDecodeTime
	   */
	
	  var collectDtsInfo = function collectDtsInfo(track, data) {
	    if (typeof data.pts === 'number') {
	      if (track.timelineStartInfo.pts === undefined) {
	        track.timelineStartInfo.pts = data.pts;
	      }
	
	      if (track.minSegmentPts === undefined) {
	        track.minSegmentPts = data.pts;
	      } else {
	        track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	      }
	
	      if (track.maxSegmentPts === undefined) {
	        track.maxSegmentPts = data.pts;
	      } else {
	        track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	      }
	    }
	
	    if (typeof data.dts === 'number') {
	      if (track.timelineStartInfo.dts === undefined) {
	        track.timelineStartInfo.dts = data.dts;
	      }
	
	      if (track.minSegmentDts === undefined) {
	        track.minSegmentDts = data.dts;
	      } else {
	        track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	      }
	
	      if (track.maxSegmentDts === undefined) {
	        track.maxSegmentDts = data.dts;
	      } else {
	        track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	      }
	    }
	  };
	  /**
	   * Clear values used to calculate the baseMediaDecodeTime between
	   * tracks
	   */
	
	
	  var clearDtsInfo = function clearDtsInfo(track) {
	    delete track.minSegmentDts;
	    delete track.maxSegmentDts;
	    delete track.minSegmentPts;
	    delete track.maxSegmentPts;
	  };
	  /**
	   * Calculate the track's baseMediaDecodeTime based on the earliest
	   * DTS the transmuxer has ever seen and the minimum DTS for the
	   * current track
	   * @param track {object} track metadata configuration
	   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  var calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime(track, keepOriginalTimestamps) {
	    var baseMediaDecodeTime,
	        scale,
	        minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
	
	    if (!keepOriginalTimestamps) {
	      minSegmentDts -= track.timelineStartInfo.dts;
	    } // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	    // we want the start of the first segment to be placed
	
	
	    baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
	
	    baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
	
	    baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	    if (track.type === 'audio') {
	      // Audio has a different clock equal to the sampling_rate so we need to
	      // scale the PTS values into the clock rate of the track
	      scale = track.samplerate / ONE_SECOND_IN_TS$3;
	      baseMediaDecodeTime *= scale;
	      baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	    }
	
	    return baseMediaDecodeTime;
	  };
	
	  var trackDecodeInfo = {
	    clearDtsInfo: clearDtsInfo,
	    calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
	    collectDtsInfo: collectDtsInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Reads in-band caption information from a video elementary
	   * stream. Captions must follow the CEA-708 standard for injection
	   * into an MPEG-2 transport streams.
	   * @see https://en.wikipedia.org/wiki/CEA-708
	   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	   */
	  // payload type field to indicate how they are to be
	  // interpreted. CEAS-708 caption content is always transmitted with
	  // payload type 0x04.
	
	  var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	      RBSP_TRAILING_BITS = 128;
	  /**
	    * Parse a supplemental enhancement information (SEI) NAL unit.
	    * Stops parsing once a message of type ITU T T35 has been found.
	    *
	    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	    * @return {object} the parsed SEI payload
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	    */
	
	  var parseSei = function parseSei(bytes) {
	    var i = 0,
	        result = {
	      payloadType: -1,
	      payloadSize: 0
	    },
	        payloadType = 0,
	        payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
	
	    while (i < bytes.byteLength) {
	      // stop once we have hit the end of the sei_rbsp
	      if (bytes[i] === RBSP_TRAILING_BITS) {
	        break;
	      } // Parse payload type
	
	
	      while (bytes[i] === 0xFF) {
	        payloadType += 255;
	        i++;
	      }
	
	      payloadType += bytes[i++]; // Parse payload size
	
	      while (bytes[i] === 0xFF) {
	        payloadSize += 255;
	        i++;
	      }
	
	      payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
	      // there can only ever be one caption message in a frame's sei
	
	      if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	        var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
	
	        if (userIdentifier === 'GA94') {
	          result.payloadType = payloadType;
	          result.payloadSize = payloadSize;
	          result.payload = bytes.subarray(i, i + payloadSize);
	          break;
	        } else {
	          result.payload = void 0;
	        }
	      } // skip the payload and parse the next message
	
	
	      i += payloadSize;
	      payloadType = 0;
	      payloadSize = 0;
	    }
	
	    return result;
	  }; // see ANSI/SCTE 128-1 (2013), section 8.1
	
	
	  var parseUserData = function parseUserData(sei) {
	    // itu_t_t35_contry_code must be 181 (United States) for
	    // captions
	    if (sei.payload[0] !== 181) {
	      return null;
	    } // itu_t_t35_provider_code should be 49 (ATSC) for captions
	
	
	    if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
	      return null;
	    } // the user_identifier should be "GA94" to indicate ATSC1 data
	
	
	    if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') {
	      return null;
	    } // finally, user_data_type_code should be 0x03 for caption data
	
	
	    if (sei.payload[7] !== 0x03) {
	      return null;
	    } // return the user_data_type_structure and strip the trailing
	    // marker bits
	
	
	    return sei.payload.subarray(8, sei.payload.length - 1);
	  }; // see CEA-708-D, section 4.4
	
	
	  var parseCaptionPackets = function parseCaptionPackets(pts, userData) {
	    var results = [],
	        i,
	        count,
	        offset,
	        data; // if this is just filler, return immediately
	
	    if (!(userData[0] & 0x40)) {
	      return results;
	    } // parse out the cc_data_1 and cc_data_2 fields
	
	
	    count = userData[0] & 0x1f;
	
	    for (i = 0; i < count; i++) {
	      offset = i * 3;
	      data = {
	        type: userData[offset + 2] & 0x03,
	        pts: pts
	      }; // capture cc data when cc_valid is 1
	
	      if (userData[offset + 2] & 0x04) {
	        data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
	        results.push(data);
	      }
	    }
	
	    return results;
	  };
	
	  var discardEmulationPreventionBytes$1 = function discardEmulationPreventionBytes(data) {
	    var length = data.byteLength,
	        emulationPreventionBytesPositions = [],
	        i = 1,
	        newLength,
	        newData; // Find all `Emulation Prevention Bytes`
	
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    } // If no Emulation Prevention Bytes were found just return the original
	    // array
	
	
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    } // Create a new array to hold the NAL unit data
	
	
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++; // Remove this position index
	
	        emulationPreventionBytesPositions.shift();
	      }
	
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	  }; // exports
	
	
	  var captionPacketParser = {
	    parseSei: parseSei,
	    parseUserData: parseUserData,
	    parseCaptionPackets: parseCaptionPackets,
	    discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
	    USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
	  }; // Link To Transport
	  // -----------------
	
	  var CaptionStream$1 = function CaptionStream(options) {
	    options = options || {};
	    CaptionStream.prototype.init.call(this); // parse708captions flag, default to true
	
	    this.parse708captions_ = typeof options.parse708captions === 'boolean' ? options.parse708captions : true;
	    this.captionPackets_ = [];
	    this.ccStreams_ = [new Cea608Stream(0, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(0, 1), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
	    ];
	
	    if (this.parse708captions_) {
	      this.cc708Stream_ = new Cea708Stream({
	        captionServices: options.captionServices
	      }); // eslint-disable-line no-use-before-define
	    }
	
	    this.reset(); // forward data and done events from CCs to this CaptionStream
	
	    this.ccStreams_.forEach(function (cc) {
	      cc.on('data', this.trigger.bind(this, 'data'));
	      cc.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      cc.on('done', this.trigger.bind(this, 'done'));
	    }, this);
	
	    if (this.parse708captions_) {
	      this.cc708Stream_.on('data', this.trigger.bind(this, 'data'));
	      this.cc708Stream_.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      this.cc708Stream_.on('done', this.trigger.bind(this, 'done'));
	    }
	  };
	
	  CaptionStream$1.prototype = new stream();
	
	  CaptionStream$1.prototype.push = function (event) {
	    var sei, userData, newCaptionPackets; // only examine SEI NALs
	
	    if (event.nalUnitType !== 'sei_rbsp') {
	      return;
	    } // parse the sei
	
	
	    sei = captionPacketParser.parseSei(event.escapedRBSP); // no payload data, skip
	
	    if (!sei.payload) {
	      return;
	    } // ignore everything but user_data_registered_itu_t_t35
	
	
	    if (sei.payloadType !== captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35) {
	      return;
	    } // parse out the user data payload
	
	
	    userData = captionPacketParser.parseUserData(sei); // ignore unrecognized userData
	
	    if (!userData) {
	      return;
	    } // Sometimes, the same segment # will be downloaded twice. To stop the
	    // caption data from being processed twice, we track the latest dts we've
	    // received and ignore everything with a dts before that. However, since
	    // data for a specific dts can be split across packets on either side of
	    // a segment boundary, we need to make sure we *don't* ignore the packets
	    // from the *next* segment that have dts === this.latestDts_. By constantly
	    // tracking the number of packets received with dts === this.latestDts_, we
	    // know how many should be ignored once we start receiving duplicates.
	
	
	    if (event.dts < this.latestDts_) {
	      // We've started getting older data, so set the flag.
	      this.ignoreNextEqualDts_ = true;
	      return;
	    } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
	      this.numSameDts_--;
	
	      if (!this.numSameDts_) {
	        // We've received the last duplicate packet, time to start processing again
	        this.ignoreNextEqualDts_ = false;
	      }
	
	      return;
	    } // parse out CC data packets and save them for later
	
	
	    newCaptionPackets = captionPacketParser.parseCaptionPackets(event.pts, userData);
	    this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
	
	    if (this.latestDts_ !== event.dts) {
	      this.numSameDts_ = 0;
	    }
	
	    this.numSameDts_++;
	    this.latestDts_ = event.dts;
	  };
	
	  CaptionStream$1.prototype.flushCCStreams = function (flushType) {
	    this.ccStreams_.forEach(function (cc) {
	      return flushType === 'flush' ? cc.flush() : cc.partialFlush();
	    }, this);
	  };
	
	  CaptionStream$1.prototype.flushStream = function (flushType) {
	    // make sure we actually parsed captions before proceeding
	    if (!this.captionPackets_.length) {
	      this.flushCCStreams(flushType);
	      return;
	    } // In Chrome, the Array#sort function is not stable so add a
	    // presortIndex that we can use to ensure we get a stable-sort
	
	
	    this.captionPackets_.forEach(function (elem, idx) {
	      elem.presortIndex = idx;
	    }); // sort caption byte-pairs based on their PTS values
	
	    this.captionPackets_.sort(function (a, b) {
	      if (a.pts === b.pts) {
	        return a.presortIndex - b.presortIndex;
	      }
	
	      return a.pts - b.pts;
	    });
	    this.captionPackets_.forEach(function (packet) {
	      if (packet.type < 2) {
	        // Dispatch packet to the right Cea608Stream
	        this.dispatchCea608Packet(packet);
	      } else {
	        // Dispatch packet to the Cea708Stream
	        this.dispatchCea708Packet(packet);
	      }
	    }, this);
	    this.captionPackets_.length = 0;
	    this.flushCCStreams(flushType);
	  };
	
	  CaptionStream$1.prototype.flush = function () {
	    return this.flushStream('flush');
	  }; // Only called if handling partial data
	
	
	  CaptionStream$1.prototype.partialFlush = function () {
	    return this.flushStream('partialFlush');
	  };
	
	  CaptionStream$1.prototype.reset = function () {
	    this.latestDts_ = null;
	    this.ignoreNextEqualDts_ = false;
	    this.numSameDts_ = 0;
	    this.activeCea608Channel_ = [null, null];
	    this.ccStreams_.forEach(function (ccStream) {
	      ccStream.reset();
	    });
	  }; // From the CEA-608 spec:
	
	  /*
	   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
	   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
	   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
	   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
	   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
	   * to switch to captioning or Text.
	  */
	  // With that in mind, we ignore any data between an XDS control code and a
	  // subsequent closed-captioning control code.
	
	
	  CaptionStream$1.prototype.dispatchCea608Packet = function (packet) {
	    // NOTE: packet.type is the CEA608 field
	    if (this.setsTextOrXDSActive(packet)) {
	      this.activeCea608Channel_[packet.type] = null;
	    } else if (this.setsChannel1Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 0;
	    } else if (this.setsChannel2Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 1;
	    }
	
	    if (this.activeCea608Channel_[packet.type] === null) {
	      // If we haven't received anything to set the active channel, or the
	      // packets are Text/XDS data, discard the data; we don't want jumbled
	      // captions
	      return;
	    }
	
	    this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
	  };
	
	  CaptionStream$1.prototype.setsChannel1Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1000;
	  };
	
	  CaptionStream$1.prototype.setsChannel2Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1800;
	  };
	
	  CaptionStream$1.prototype.setsTextOrXDSActive = function (packet) {
	    return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
	  };
	
	  CaptionStream$1.prototype.dispatchCea708Packet = function (packet) {
	    if (this.parse708captions_) {
	      this.cc708Stream_.push(packet);
	    }
	  }; // ----------------------
	  // Session to Application
	  // ----------------------
	  // This hash maps special and extended character codes to their
	  // proper Unicode equivalent. The first one-byte key is just a
	  // non-standard character code. The two-byte keys that follow are
	  // the extended CEA708 character codes, along with the preceding
	  // 0x10 extended character byte to distinguish these codes from
	  // non-extended character codes. Every CEA708 character code that
	  // is not in this object maps directly to a standard unicode
	  // character code.
	  // The transparent space and non-breaking transparent space are
	  // technically not fully supported since there is no code to
	  // make them transparent, so they have normal non-transparent
	  // stand-ins.
	  // The special closed caption (CC) character isn't a standard
	  // unicode character, so a fairly similar unicode character was
	  // chosen in it's place.
	
	
	  var CHARACTER_TRANSLATION_708 = {
	    0x7f: 0x266a,
	    // ♪
	    0x1020: 0x20,
	    // Transparent Space
	    0x1021: 0xa0,
	    // Nob-breaking Transparent Space
	    0x1025: 0x2026,
	    // …
	    0x102a: 0x0160,
	    // Š
	    0x102c: 0x0152,
	    // Œ
	    0x1030: 0x2588,
	    // █
	    0x1031: 0x2018,
	    // ‘
	    0x1032: 0x2019,
	    // ’
	    0x1033: 0x201c,
	    // “
	    0x1034: 0x201d,
	    // ”
	    0x1035: 0x2022,
	    // •
	    0x1039: 0x2122,
	    // ™
	    0x103a: 0x0161,
	    // š
	    0x103c: 0x0153,
	    // œ
	    0x103d: 0x2120,
	    // ℠
	    0x103f: 0x0178,
	    // Ÿ
	    0x1076: 0x215b,
	    // ⅛
	    0x1077: 0x215c,
	    // ⅜
	    0x1078: 0x215d,
	    // ⅝
	    0x1079: 0x215e,
	    // ⅞
	    0x107a: 0x23d0,
	    // ⏐
	    0x107b: 0x23a4,
	    // ⎤
	    0x107c: 0x23a3,
	    // ⎣
	    0x107d: 0x23af,
	    // ⎯
	    0x107e: 0x23a6,
	    // ⎦
	    0x107f: 0x23a1,
	    // ⎡
	    0x10a0: 0x3138 // ㄸ (CC char)
	
	  };
	
	  var get708CharFromCode = function get708CharFromCode(code) {
	    var newCode = CHARACTER_TRANSLATION_708[code] || code;
	
	    if (code & 0x1000 && code === newCode) {
	      // Invalid extended code
	      return '';
	    }
	
	    return String.fromCharCode(newCode);
	  };
	
	  var within708TextBlock = function within708TextBlock(b) {
	    return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
	  };
	
	  var Cea708Window = function Cea708Window(windowNum) {
	    this.windowNum = windowNum;
	    this.reset();
	  };
	
	  Cea708Window.prototype.reset = function () {
	    this.clearText();
	    this.pendingNewLine = false;
	    this.winAttr = {};
	    this.penAttr = {};
	    this.penLoc = {};
	    this.penColor = {}; // These default values are arbitrary,
	    // defineWindow will usually override them
	
	    this.visible = 0;
	    this.rowLock = 0;
	    this.columnLock = 0;
	    this.priority = 0;
	    this.relativePositioning = 0;
	    this.anchorVertical = 0;
	    this.anchorHorizontal = 0;
	    this.anchorPoint = 0;
	    this.rowCount = 1;
	    this.virtualRowCount = this.rowCount + 1;
	    this.columnCount = 41;
	    this.windowStyle = 0;
	    this.penStyle = 0;
	  };
	
	  Cea708Window.prototype.getText = function () {
	    return this.rows.join('\n');
	  };
	
	  Cea708Window.prototype.clearText = function () {
	    this.rows = [''];
	    this.rowIdx = 0;
	  };
	
	  Cea708Window.prototype.newLine = function (pts) {
	    if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === 'function') {
	      this.beforeRowOverflow(pts);
	    }
	
	    if (this.rows.length > 0) {
	      this.rows.push('');
	      this.rowIdx++;
	    } // Show all virtual rows since there's no visible scrolling
	
	
	    while (this.rows.length > this.virtualRowCount) {
	      this.rows.shift();
	      this.rowIdx--;
	    }
	  };
	
	  Cea708Window.prototype.isEmpty = function () {
	    if (this.rows.length === 0) {
	      return true;
	    } else if (this.rows.length === 1) {
	      return this.rows[0] === '';
	    }
	
	    return false;
	  };
	
	  Cea708Window.prototype.addText = function (text) {
	    this.rows[this.rowIdx] += text;
	  };
	
	  Cea708Window.prototype.backspace = function () {
	    if (!this.isEmpty()) {
	      var row = this.rows[this.rowIdx];
	      this.rows[this.rowIdx] = row.substr(0, row.length - 1);
	    }
	  };
	
	  var Cea708Service = function Cea708Service(serviceNum, encoding, stream) {
	    this.serviceNum = serviceNum;
	    this.text = '';
	    this.currentWindow = new Cea708Window(-1);
	    this.windows = [];
	    this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
	
	    if (typeof encoding === 'string') {
	      this.createTextDecoder(encoding);
	    }
	  };
	  /**
	   * Initialize service windows
	   * Must be run before service use
	   *
	   * @param  {Integer}  pts               PTS value
	   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
	   */
	
	
	  Cea708Service.prototype.init = function (pts, beforeRowOverflow) {
	    this.startPts = pts;
	
	    for (var win = 0; win < 8; win++) {
	      this.windows[win] = new Cea708Window(win);
	
	      if (typeof beforeRowOverflow === 'function') {
	        this.windows[win].beforeRowOverflow = beforeRowOverflow;
	      }
	    }
	  };
	  /**
	   * Set current window of service to be affected by commands
	   *
	   * @param  {Integer} windowNum Window number
	   */
	
	
	  Cea708Service.prototype.setCurrentWindow = function (windowNum) {
	    this.currentWindow = this.windows[windowNum];
	  };
	  /**
	   * Try to create a TextDecoder if it is natively supported
	   */
	
	
	  Cea708Service.prototype.createTextDecoder = function (encoding) {
	    if (typeof TextDecoder === 'undefined') {
	      this.stream.trigger('log', {
	        level: 'warn',
	        message: 'The `encoding` option is unsupported without TextDecoder support'
	      });
	    } else {
	      try {
	        this.textDecoder_ = new TextDecoder(encoding);
	      } catch (error) {
	        this.stream.trigger('log', {
	          level: 'warn',
	          message: 'TextDecoder could not be created with ' + encoding + ' encoding. ' + error
	        });
	      }
	    }
	  };
	
	  var Cea708Stream = function Cea708Stream(options) {
	    options = options || {};
	    Cea708Stream.prototype.init.call(this);
	    var self = this;
	    var captionServices = options.captionServices || {};
	    var captionServiceEncodings = {};
	    var serviceProps; // Get service encodings from captionServices option block
	
	    Object.keys(captionServices).forEach(function (serviceName) {
	      serviceProps = captionServices[serviceName];
	
	      if (/^SERVICE/.test(serviceName)) {
	        captionServiceEncodings[serviceName] = serviceProps.encoding;
	      }
	    });
	    this.serviceEncodings = captionServiceEncodings;
	    this.current708Packet = null;
	    this.services = {};
	
	    this.push = function (packet) {
	      if (packet.type === 3) {
	        // 708 packet start
	        self.new708Packet();
	        self.add708Bytes(packet);
	      } else {
	        if (self.current708Packet === null) {
	          // This should only happen at the start of a file if there's no packet start.
	          self.new708Packet();
	        }
	
	        self.add708Bytes(packet);
	      }
	    };
	  };
	
	  Cea708Stream.prototype = new stream();
	  /**
	   * Push current 708 packet, create new 708 packet.
	   */
	
	  Cea708Stream.prototype.new708Packet = function () {
	    if (this.current708Packet !== null) {
	      this.push708Packet();
	    }
	
	    this.current708Packet = {
	      data: [],
	      ptsVals: []
	    };
	  };
	  /**
	   * Add pts and both bytes from packet into current 708 packet.
	   */
	
	
	  Cea708Stream.prototype.add708Bytes = function (packet) {
	    var data = packet.ccData;
	    var byte0 = data >>> 8;
	    var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
	    // that service blocks will always line up with byte pairs.
	
	    this.current708Packet.ptsVals.push(packet.pts);
	    this.current708Packet.data.push(byte0);
	    this.current708Packet.data.push(byte1);
	  };
	  /**
	   * Parse completed 708 packet into service blocks and push each service block.
	   */
	
	
	  Cea708Stream.prototype.push708Packet = function () {
	    var packet708 = this.current708Packet;
	    var packetData = packet708.data;
	    var serviceNum = null;
	    var blockSize = null;
	    var i = 0;
	    var b = packetData[i++];
	    packet708.seq = b >> 6;
	    packet708.sizeCode = b & 0x3f; // 0b00111111;
	
	    for (; i < packetData.length; i++) {
	      b = packetData[i++];
	      serviceNum = b >> 5;
	      blockSize = b & 0x1f; // 0b00011111
	
	      if (serviceNum === 7 && blockSize > 0) {
	        // Extended service num
	        b = packetData[i++];
	        serviceNum = b;
	      }
	
	      this.pushServiceBlock(serviceNum, i, blockSize);
	
	      if (blockSize > 0) {
	        i += blockSize - 1;
	      }
	    }
	  };
	  /**
	   * Parse service block, execute commands, read text.
	   *
	   * Note: While many of these commands serve important purposes,
	   * many others just parse out the parameters or attributes, but
	   * nothing is done with them because this is not a full and complete
	   * implementation of the entire 708 spec.
	   *
	   * @param  {Integer} serviceNum Service number
	   * @param  {Integer} start      Start index of the 708 packet data
	   * @param  {Integer} size       Block size
	   */
	
	
	  Cea708Stream.prototype.pushServiceBlock = function (serviceNum, start, size) {
	    var b;
	    var i = start;
	    var packetData = this.current708Packet.data;
	    var service = this.services[serviceNum];
	
	    if (!service) {
	      service = this.initService(serviceNum, i);
	    }
	
	    for (; i < start + size && i < packetData.length; i++) {
	      b = packetData[i];
	
	      if (within708TextBlock(b)) {
	        i = this.handleText(i, service);
	      } else if (b === 0x18) {
	        i = this.multiByteCharacter(i, service);
	      } else if (b === 0x10) {
	        i = this.extendedCommands(i, service);
	      } else if (0x80 <= b && b <= 0x87) {
	        i = this.setCurrentWindow(i, service);
	      } else if (0x98 <= b && b <= 0x9f) {
	        i = this.defineWindow(i, service);
	      } else if (b === 0x88) {
	        i = this.clearWindows(i, service);
	      } else if (b === 0x8c) {
	        i = this.deleteWindows(i, service);
	      } else if (b === 0x89) {
	        i = this.displayWindows(i, service);
	      } else if (b === 0x8a) {
	        i = this.hideWindows(i, service);
	      } else if (b === 0x8b) {
	        i = this.toggleWindows(i, service);
	      } else if (b === 0x97) {
	        i = this.setWindowAttributes(i, service);
	      } else if (b === 0x90) {
	        i = this.setPenAttributes(i, service);
	      } else if (b === 0x91) {
	        i = this.setPenColor(i, service);
	      } else if (b === 0x92) {
	        i = this.setPenLocation(i, service);
	      } else if (b === 0x8f) {
	        service = this.reset(i, service);
	      } else if (b === 0x08) {
	        // BS: Backspace
	        service.currentWindow.backspace();
	      } else if (b === 0x0c) {
	        // FF: Form feed
	        service.currentWindow.clearText();
	      } else if (b === 0x0d) {
	        // CR: Carriage return
	        service.currentWindow.pendingNewLine = true;
	      } else if (b === 0x0e) {
	        // HCR: Horizontal carriage return
	        service.currentWindow.clearText();
	      } else if (b === 0x8d) {
	        // DLY: Delay, nothing to do
	        i++;
	      } else ;
	    }
	  };
	  /**
	   * Execute an extended command
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.extendedCommands = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	
	    if (within708TextBlock(b)) {
	      i = this.handleText(i, service, {
	        isExtended: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Get PTS value of a given byte index
	   *
	   * @param  {Integer} byteIndex  Index of the byte
	   * @return {Integer}            PTS
	   */
	
	
	  Cea708Stream.prototype.getPts = function (byteIndex) {
	    // There's 1 pts value per 2 bytes
	    return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
	  };
	  /**
	   * Initializes a service
	   *
	   * @param  {Integer} serviceNum Service number
	   * @return {Service}            Initialized service object
	   */
	
	
	  Cea708Stream.prototype.initService = function (serviceNum, i) {
	    var serviceName = 'SERVICE' + serviceNum;
	    var self = this;
	    var serviceName;
	    var encoding;
	
	    if (serviceName in this.serviceEncodings) {
	      encoding = this.serviceEncodings[serviceName];
	    }
	
	    this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self);
	    this.services[serviceNum].init(this.getPts(i), function (pts) {
	      self.flushDisplayed(pts, self.services[serviceNum]);
	    });
	    return this.services[serviceNum];
	  };
	  /**
	   * Execute text writing to current window
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.handleText = function (i, service, options) {
	    var isExtended = options && options.isExtended;
	    var isMultiByte = options && options.isMultiByte;
	    var packetData = this.current708Packet.data;
	    var extended = isExtended ? 0x1000 : 0x0000;
	    var currentByte = packetData[i];
	    var nextByte = packetData[i + 1];
	    var win = service.currentWindow;
	
	    var _char;
	
	    var charCodeArray; // Use the TextDecoder if one was created for this service
	
	    if (service.textDecoder_ && !isExtended) {
	      if (isMultiByte) {
	        charCodeArray = [currentByte, nextByte];
	        i++;
	      } else {
	        charCodeArray = [currentByte];
	      }
	
	      _char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
	    } else {
	      _char = get708CharFromCode(extended | currentByte);
	    }
	
	    if (win.pendingNewLine && !win.isEmpty()) {
	      win.newLine(this.getPts(i));
	    }
	
	    win.pendingNewLine = false;
	    win.addText(_char);
	    return i;
	  };
	  /**
	   * Handle decoding of multibyte character
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.multiByteCharacter = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var firstByte = packetData[i + 1];
	    var secondByte = packetData[i + 2];
	
	    if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) {
	      i = this.handleText(++i, service, {
	        isMultiByte: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CW# command.
	   *
	   * Set the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setCurrentWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    return i;
	  };
	  /**
	   * Parse and execute the DF# command.
	   *
	   * Define a window and set it as the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.defineWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    var win = service.currentWindow;
	    b = packetData[++i];
	    win.visible = (b & 0x20) >> 5; // v
	
	    win.rowLock = (b & 0x10) >> 4; // rl
	
	    win.columnLock = (b & 0x08) >> 3; // cl
	
	    win.priority = b & 0x07; // p
	
	    b = packetData[++i];
	    win.relativePositioning = (b & 0x80) >> 7; // rp
	
	    win.anchorVertical = b & 0x7f; // av
	
	    b = packetData[++i];
	    win.anchorHorizontal = b; // ah
	
	    b = packetData[++i];
	    win.anchorPoint = (b & 0xf0) >> 4; // ap
	
	    win.rowCount = b & 0x0f; // rc
	
	    b = packetData[++i];
	    win.columnCount = b & 0x3f; // cc
	
	    b = packetData[++i];
	    win.windowStyle = (b & 0x38) >> 3; // ws
	
	    win.penStyle = b & 0x07; // ps
	    // The spec says there are (rowCount+1) "virtual rows"
	
	    win.virtualRowCount = win.rowCount + 1;
	    return i;
	  };
	  /**
	   * Parse and execute the SWA command.
	   *
	   * Set attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setWindowAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var winAttr = service.currentWindow.winAttr;
	    b = packetData[++i];
	    winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
	
	    winAttr.fillRed = (b & 0x30) >> 4; // fr
	
	    winAttr.fillGreen = (b & 0x0c) >> 2; // fg
	
	    winAttr.fillBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    winAttr.borderType = (b & 0xc0) >> 6; // bt
	
	    winAttr.borderRed = (b & 0x30) >> 4; // br
	
	    winAttr.borderGreen = (b & 0x0c) >> 2; // bg
	
	    winAttr.borderBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    winAttr.borderType += (b & 0x80) >> 5; // bt
	
	    winAttr.wordWrap = (b & 0x40) >> 6; // ww
	
	    winAttr.printDirection = (b & 0x30) >> 4; // pd
	
	    winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
	
	    winAttr.justify = b & 0x03; // j
	
	    b = packetData[++i];
	    winAttr.effectSpeed = (b & 0xf0) >> 4; // es
	
	    winAttr.effectDirection = (b & 0x0c) >> 2; // ed
	
	    winAttr.displayEffect = b & 0x03; // de
	
	    return i;
	  };
	  /**
	   * Gather text from all displayed windows and push a caption to output.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.flushDisplayed = function (pts, service) {
	    var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
	    // display text in the correct order, but sample files so far have not shown any issue.
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (service.windows[winId].visible && !service.windows[winId].isEmpty()) {
	        displayedText.push(service.windows[winId].getText());
	      }
	    }
	
	    service.endPts = pts;
	    service.text = displayedText.join('\n\n');
	    this.pushCaption(service);
	    service.startPts = pts;
	  };
	  /**
	   * Push a caption to output if the caption contains text.
	   *
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.pushCaption = function (service) {
	    if (service.text !== '') {
	      this.trigger('data', {
	        startPts: service.startPts,
	        endPts: service.endPts,
	        text: service.text,
	        stream: 'cc708_' + service.serviceNum
	      });
	      service.text = '';
	      service.startPts = service.endPts;
	    }
	  };
	  /**
	   * Parse and execute the DSW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.displayWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the HDW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.hideWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 0;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the TGW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.toggleWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible ^= 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CLW command.
	   *
	   * Clear text of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.clearWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].clearText();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the DLW command.
	   *
	   * Re-initialize windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.deleteWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].reset();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPA command.
	   *
	   * Set pen attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penAttr = service.currentWindow.penAttr;
	    b = packetData[++i];
	    penAttr.textTag = (b & 0xf0) >> 4; // tt
	
	    penAttr.offset = (b & 0x0c) >> 2; // o
	
	    penAttr.penSize = b & 0x03; // s
	
	    b = packetData[++i];
	    penAttr.italics = (b & 0x80) >> 7; // i
	
	    penAttr.underline = (b & 0x40) >> 6; // u
	
	    penAttr.edgeType = (b & 0x38) >> 3; // et
	
	    penAttr.fontStyle = b & 0x07; // fs
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPC command.
	   *
	   * Set pen color of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenColor = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penColor = service.currentWindow.penColor;
	    b = packetData[++i];
	    penColor.fgOpacity = (b & 0xc0) >> 6; // fo
	
	    penColor.fgRed = (b & 0x30) >> 4; // fr
	
	    penColor.fgGreen = (b & 0x0c) >> 2; // fg
	
	    penColor.fgBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    penColor.bgOpacity = (b & 0xc0) >> 6; // bo
	
	    penColor.bgRed = (b & 0x30) >> 4; // br
	
	    penColor.bgGreen = (b & 0x0c) >> 2; // bg
	
	    penColor.bgBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    penColor.edgeRed = (b & 0x30) >> 4; // er
	
	    penColor.edgeGreen = (b & 0x0c) >> 2; // eg
	
	    penColor.edgeBlue = b & 0x03; // eb
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPL command.
	   *
	   * Set pen location of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenLocation = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
	
	    service.currentWindow.pendingNewLine = true;
	    b = packetData[++i];
	    penLoc.row = b & 0x0f; // r
	
	    b = packetData[++i];
	    penLoc.column = b & 0x3f; // c
	
	    return i;
	  };
	  /**
	   * Execute the RST command.
	   *
	   * Reset service to a clean slate. Re-initialize.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Service}          Re-initialized service
	   */
	
	
	  Cea708Stream.prototype.reset = function (i, service) {
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	    return this.initService(service.serviceNum, i);
	  }; // This hash maps non-ASCII, special, and extended character codes to their
	  // proper Unicode equivalent. The first keys that are only a single byte
	  // are the non-standard ASCII characters, which simply map the CEA608 byte
	  // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
	  // character codes, but have their MSB bitmasked with 0x03 so that a lookup
	  // can be performed regardless of the field and data channel on which the
	  // character code was received.
	
	
	  var CHARACTER_TRANSLATION = {
	    0x2a: 0xe1,
	    // á
	    0x5c: 0xe9,
	    // é
	    0x5e: 0xed,
	    // í
	    0x5f: 0xf3,
	    // ó
	    0x60: 0xfa,
	    // ú
	    0x7b: 0xe7,
	    // ç
	    0x7c: 0xf7,
	    // ÷
	    0x7d: 0xd1,
	    // Ñ
	    0x7e: 0xf1,
	    // ñ
	    0x7f: 0x2588,
	    // █
	    0x0130: 0xae,
	    // ®
	    0x0131: 0xb0,
	    // °
	    0x0132: 0xbd,
	    // ½
	    0x0133: 0xbf,
	    // ¿
	    0x0134: 0x2122,
	    // ™
	    0x0135: 0xa2,
	    // ¢
	    0x0136: 0xa3,
	    // £
	    0x0137: 0x266a,
	    // ♪
	    0x0138: 0xe0,
	    // à
	    0x0139: 0xa0,
	    //
	    0x013a: 0xe8,
	    // è
	    0x013b: 0xe2,
	    // â
	    0x013c: 0xea,
	    // ê
	    0x013d: 0xee,
	    // î
	    0x013e: 0xf4,
	    // ô
	    0x013f: 0xfb,
	    // û
	    0x0220: 0xc1,
	    // Á
	    0x0221: 0xc9,
	    // É
	    0x0222: 0xd3,
	    // Ó
	    0x0223: 0xda,
	    // Ú
	    0x0224: 0xdc,
	    // Ü
	    0x0225: 0xfc,
	    // ü
	    0x0226: 0x2018,
	    // ‘
	    0x0227: 0xa1,
	    // ¡
	    0x0228: 0x2a,
	    // *
	    0x0229: 0x27,
	    // '
	    0x022a: 0x2014,
	    // —
	    0x022b: 0xa9,
	    // ©
	    0x022c: 0x2120,
	    // ℠
	    0x022d: 0x2022,
	    // •
	    0x022e: 0x201c,
	    // “
	    0x022f: 0x201d,
	    // ”
	    0x0230: 0xc0,
	    // À
	    0x0231: 0xc2,
	    // Â
	    0x0232: 0xc7,
	    // Ç
	    0x0233: 0xc8,
	    // È
	    0x0234: 0xca,
	    // Ê
	    0x0235: 0xcb,
	    // Ë
	    0x0236: 0xeb,
	    // ë
	    0x0237: 0xce,
	    // Î
	    0x0238: 0xcf,
	    // Ï
	    0x0239: 0xef,
	    // ï
	    0x023a: 0xd4,
	    // Ô
	    0x023b: 0xd9,
	    // Ù
	    0x023c: 0xf9,
	    // ù
	    0x023d: 0xdb,
	    // Û
	    0x023e: 0xab,
	    // «
	    0x023f: 0xbb,
	    // »
	    0x0320: 0xc3,
	    // Ã
	    0x0321: 0xe3,
	    // ã
	    0x0322: 0xcd,
	    // Í
	    0x0323: 0xcc,
	    // Ì
	    0x0324: 0xec,
	    // ì
	    0x0325: 0xd2,
	    // Ò
	    0x0326: 0xf2,
	    // ò
	    0x0327: 0xd5,
	    // Õ
	    0x0328: 0xf5,
	    // õ
	    0x0329: 0x7b,
	    // {
	    0x032a: 0x7d,
	    // }
	    0x032b: 0x5c,
	    // \
	    0x032c: 0x5e,
	    // ^
	    0x032d: 0x5f,
	    // _
	    0x032e: 0x7c,
	    // |
	    0x032f: 0x7e,
	    // ~
	    0x0330: 0xc4,
	    // Ä
	    0x0331: 0xe4,
	    // ä
	    0x0332: 0xd6,
	    // Ö
	    0x0333: 0xf6,
	    // ö
	    0x0334: 0xdf,
	    // ß
	    0x0335: 0xa5,
	    // ¥
	    0x0336: 0xa4,
	    // ¤
	    0x0337: 0x2502,
	    // │
	    0x0338: 0xc5,
	    // Å
	    0x0339: 0xe5,
	    // å
	    0x033a: 0xd8,
	    // Ø
	    0x033b: 0xf8,
	    // ø
	    0x033c: 0x250c,
	    // ┌
	    0x033d: 0x2510,
	    // ┐
	    0x033e: 0x2514,
	    // └
	    0x033f: 0x2518 // ┘
	
	  };
	
	  var getCharFromCode = function getCharFromCode(code) {
	    if (code === null) {
	      return '';
	    }
	
	    code = CHARACTER_TRANSLATION[code] || code;
	    return String.fromCharCode(code);
	  }; // the index of the last row in a CEA-608 display buffer
	
	
	  var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
	  // getting it through bit logic.
	
	  var ROWS = [0x1100, 0x1120, 0x1200, 0x1220, 0x1500, 0x1520, 0x1600, 0x1620, 0x1700, 0x1720, 0x1000, 0x1300, 0x1320, 0x1400, 0x1420]; // CEA-608 captions are rendered onto a 34x15 matrix of character
	  // cells. The "bottom" row is the last element in the outer array.
	
	  var createDisplayBuffer = function createDisplayBuffer() {
	    var result = [],
	        i = BOTTOM_ROW + 1;
	
	    while (i--) {
	      result.push('');
	    }
	
	    return result;
	  };
	
	  var Cea608Stream = function Cea608Stream(field, dataChannel) {
	    Cea608Stream.prototype.init.call(this);
	    this.field_ = field || 0;
	    this.dataChannel_ = dataChannel || 0;
	    this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
	    this.setConstants();
	    this.reset();
	
	    this.push = function (packet) {
	      var data, swap, char0, char1, text; // remove the parity bits
	
	      data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
	
	      if (data === this.lastControlCode_) {
	        this.lastControlCode_ = null;
	        return;
	      } // Store control codes
	
	
	      if ((data & 0xf000) === 0x1000) {
	        this.lastControlCode_ = data;
	      } else if (data !== this.PADDING_) {
	        this.lastControlCode_ = null;
	      }
	
	      char0 = data >>> 8;
	      char1 = data & 0xff;
	
	      if (data === this.PADDING_) {
	        return;
	      } else if (data === this.RESUME_CAPTION_LOADING_) {
	        this.mode_ = 'popOn';
	      } else if (data === this.END_OF_CAPTION_) {
	        // If an EOC is received while in paint-on mode, the displayed caption
	        // text should be swapped to non-displayed memory as if it was a pop-on
	        // caption. Because of that, we should explicitly switch back to pop-on
	        // mode
	        this.mode_ = 'popOn';
	        this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
	
	        this.flushDisplayed(packet.pts); // flip memory
	
	        swap = this.displayed_;
	        this.displayed_ = this.nonDisplayed_;
	        this.nonDisplayed_ = swap; // start measuring the time to display the caption
	
	        this.startPts_ = packet.pts;
	      } else if (data === this.ROLL_UP_2_ROWS_) {
	        this.rollUpRows_ = 2;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_3_ROWS_) {
	        this.rollUpRows_ = 3;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_4_ROWS_) {
	        this.rollUpRows_ = 4;
	        this.setRollUp(packet.pts);
	      } else if (data === this.CARRIAGE_RETURN_) {
	        this.clearFormatting(packet.pts);
	        this.flushDisplayed(packet.pts);
	        this.shiftRowsUp_();
	        this.startPts_ = packet.pts;
	      } else if (data === this.BACKSPACE_) {
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        }
	      } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
	        this.flushDisplayed(packet.pts);
	        this.displayed_ = createDisplayBuffer();
	      } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
	        this.nonDisplayed_ = createDisplayBuffer();
	      } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
	        if (this.mode_ !== 'paintOn') {
	          // NOTE: This should be removed when proper caption positioning is
	          // implemented
	          this.flushDisplayed(packet.pts);
	          this.displayed_ = createDisplayBuffer();
	        }
	
	        this.mode_ = 'paintOn';
	        this.startPts_ = packet.pts; // Append special characters to caption text
	      } else if (this.isSpecialCharacter(char0, char1)) {
	        // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Append extended characters to caption text
	      } else if (this.isExtCharacter(char0, char1)) {
	        // Extended characters always follow their "non-extended" equivalents.
	        // IE if a "è" is desired, you'll always receive "eè"; non-compliant
	        // decoders are supposed to drop the "è", while compliant decoders
	        // backspace the "e" and insert "è".
	        // Delete the previous character
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        } // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	
	
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Process mid-row codes
	      } else if (this.isMidRowCode(char0, char1)) {
	        // Attributes are not additive, so clear all formatting
	        this.clearFormatting(packet.pts); // According to the standard, mid-row codes
	        // should be replaced with spaces, so add one now
	
	        this[this.mode_](packet.pts, ' ');
	        this.column_++;
	
	        if ((char1 & 0xe) === 0xe) {
	          this.addFormatting(packet.pts, ['i']);
	        }
	
	        if ((char1 & 0x1) === 0x1) {
	          this.addFormatting(packet.pts, ['u']);
	        } // Detect offset control codes and adjust cursor
	
	      } else if (this.isOffsetControlCode(char0, char1)) {
	        // Cursor position is set by indent PAC (see below) in 4-column
	        // increments, with an additional offset code of 1-3 to reach any
	        // of the 32 columns specified by CEA-608. So all we need to do
	        // here is increment the column cursor by the given offset.
	        this.column_ += char1 & 0x03; // Detect PACs (Preamble Address Codes)
	      } else if (this.isPAC(char0, char1)) {
	        // There's no logic for PAC -> row mapping, so we have to just
	        // find the row code in an array and use its index :(
	        var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
	
	        if (this.mode_ === 'rollUp') {
	          // This implies that the base row is incorrectly set.
	          // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
	          // of roll-up rows set.
	          if (row - this.rollUpRows_ + 1 < 0) {
	            row = this.rollUpRows_ - 1;
	          }
	
	          this.setRollUp(packet.pts, row);
	        }
	
	        if (row !== this.row_) {
	          // formatting is only persistent for current row
	          this.clearFormatting(packet.pts);
	          this.row_ = row;
	        } // All PACs can apply underline, so detect and apply
	        // (All odd-numbered second bytes set underline)
	
	
	        if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) {
	          this.addFormatting(packet.pts, ['u']);
	        }
	
	        if ((data & 0x10) === 0x10) {
	          // We've got an indent level code. Each successive even number
	          // increments the column cursor by 4, so we can get the desired
	          // column position by bit-shifting to the right (to get n/2)
	          // and multiplying by 4.
	          this.column_ = ((data & 0xe) >> 1) * 4;
	        }
	
	        if (this.isColorPAC(char1)) {
	          // it's a color code, though we only support white, which
	          // can be either normal or italicized. white italics can be
	          // either 0x4e or 0x6e depending on the row, so we just
	          // bitwise-and with 0xe to see if italics should be turned on
	          if ((char1 & 0xe) === 0xe) {
	            this.addFormatting(packet.pts, ['i']);
	          }
	        } // We have a normal character in char0, and possibly one in char1
	
	      } else if (this.isNormalChar(char0)) {
	        if (char1 === 0x00) {
	          char1 = null;
	        }
	
	        text = getCharFromCode(char0);
	        text += getCharFromCode(char1);
	        this[this.mode_](packet.pts, text);
	        this.column_ += text.length;
	      } // finish data processing
	
	    };
	  };
	
	  Cea608Stream.prototype = new stream(); // Trigger a cue point that captures the current state of the
	  // display buffer
	
	  Cea608Stream.prototype.flushDisplayed = function (pts) {
	    var content = this.displayed_ // remove spaces from the start and end of the string
	    .map(function (row, index) {
	      try {
	        return row.trim();
	      } catch (e) {
	        // Ordinarily, this shouldn't happen. However, caption
	        // parsing errors should not throw exceptions and
	        // break playback.
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping a malformed 608 caption at index ' + index + '.'
	        });
	        return '';
	      }
	    }, this) // combine all text rows to display in one cue
	    .join('\n') // and remove blank rows from the start and end, but not the middle
	    .replace(/^\n+|\n+$/g, '');
	
	    if (content.length) {
	      this.trigger('data', {
	        startPts: this.startPts_,
	        endPts: pts,
	        text: content,
	        stream: this.name_
	      });
	    }
	  };
	  /**
	   * Zero out the data, used for startup and on seek
	   */
	
	
	  Cea608Stream.prototype.reset = function () {
	    this.mode_ = 'popOn'; // When in roll-up mode, the index of the last row that will
	    // actually display captions. If a caption is shifted to a row
	    // with a lower index than this, it is cleared from the display
	    // buffer
	
	    this.topRow_ = 0;
	    this.startPts_ = 0;
	    this.displayed_ = createDisplayBuffer();
	    this.nonDisplayed_ = createDisplayBuffer();
	    this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
	
	    this.column_ = 0;
	    this.row_ = BOTTOM_ROW;
	    this.rollUpRows_ = 2; // This variable holds currently-applied formatting
	
	    this.formatting_ = [];
	  };
	  /**
	   * Sets up control code and related constants for this instance
	   */
	
	
	  Cea608Stream.prototype.setConstants = function () {
	    // The following attributes have these uses:
	    // ext_ :    char0 for mid-row codes, and the base for extended
	    //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
	    //           extended codes)
	    // control_: char0 for control codes, except byte-shifted to the
	    //           left so that we can do this.control_ | CONTROL_CODE
	    // offset_:  char0 for tab offset codes
	    //
	    // It's also worth noting that control codes, and _only_ control codes,
	    // differ between field 1 and field2. Field 2 control codes are always
	    // their field 1 value plus 1. That's why there's the "| field" on the
	    // control value.
	    if (this.dataChannel_ === 0) {
	      this.BASE_ = 0x10;
	      this.EXT_ = 0x11;
	      this.CONTROL_ = (0x14 | this.field_) << 8;
	      this.OFFSET_ = 0x17;
	    } else if (this.dataChannel_ === 1) {
	      this.BASE_ = 0x18;
	      this.EXT_ = 0x19;
	      this.CONTROL_ = (0x1c | this.field_) << 8;
	      this.OFFSET_ = 0x1f;
	    } // Constants for the LSByte command codes recognized by Cea608Stream. This
	    // list is not exhaustive. For a more comprehensive listing and semantics see
	    // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	    // Padding
	
	
	    this.PADDING_ = 0x0000; // Pop-on Mode
	
	    this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
	    this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
	
	    this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
	    this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
	    this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
	    this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
	
	    this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
	
	    this.BACKSPACE_ = this.CONTROL_ | 0x21;
	    this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
	    this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
	  };
	  /**
	   * Detects if the 2-byte packet data is a special character
	   *
	   * Special characters have a second byte in the range 0x30 to 0x3f,
	   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an special character
	   */
	
	
	  Cea608Stream.prototype.isSpecialCharacter = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet data is an extended character
	   *
	   * Extended characters have a second byte in the range 0x20 to 0x3f,
	   * with the first byte being 0x12 or 0x13 (for data channel 1) or
	   * 0x1a or 0x1b (for data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an extended character
	   */
	
	
	  Cea608Stream.prototype.isExtCharacter = function (char0, char1) {
	    return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet is a mid-row code
	   *
	   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
	   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
	   * channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a mid-row code
	   */
	
	
	  Cea608Stream.prototype.isMidRowCode = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
	  };
	  /**
	   * Detects if the 2-byte packet is an offset control code
	   *
	   * Offset control codes have a second byte in the range 0x21 to 0x23,
	   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an offset control code
	   */
	
	
	  Cea608Stream.prototype.isOffsetControlCode = function (char0, char1) {
	    return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
	  };
	  /**
	   * Detects if the 2-byte packet is a Preamble Address Code
	   *
	   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
	   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
	   * range 0x40 to 0x7f.
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a PAC
	   */
	
	
	  Cea608Stream.prototype.isPAC = function (char0, char1) {
	    return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a packet's second byte is in the range of a PAC color code
	   *
	   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
	   * 0x60 to 0x6f.
	   *
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the byte is a color PAC
	   */
	
	
	  Cea608Stream.prototype.isColorPAC = function (char1) {
	    return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a single byte is in the range of a normal character
	   *
	   * Normal text bytes are in the range 0x20 to 0x7f.
	   *
	   * @param  {Integer} char  The byte
	   * @return {Boolean}       Whether the byte is a normal character
	   */
	
	
	  Cea608Stream.prototype.isNormalChar = function (_char2) {
	    return _char2 >= 0x20 && _char2 <= 0x7f;
	  };
	  /**
	   * Configures roll-up
	   *
	   * @param  {Integer} pts         Current PTS
	   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
	   *                               a new position
	   */
	
	
	  Cea608Stream.prototype.setRollUp = function (pts, newBaseRow) {
	    // Reset the base row to the bottom row when switching modes
	    if (this.mode_ !== 'rollUp') {
	      this.row_ = BOTTOM_ROW;
	      this.mode_ = 'rollUp'; // Spec says to wipe memories when switching to roll-up
	
	      this.flushDisplayed(pts);
	      this.nonDisplayed_ = createDisplayBuffer();
	      this.displayed_ = createDisplayBuffer();
	    }
	
	    if (newBaseRow !== undefined && newBaseRow !== this.row_) {
	      // move currently displayed captions (up or down) to the new base row
	      for (var i = 0; i < this.rollUpRows_; i++) {
	        this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
	        this.displayed_[this.row_ - i] = '';
	      }
	    }
	
	    if (newBaseRow === undefined) {
	      newBaseRow = this.row_;
	    }
	
	    this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
	  }; // Adds the opening HTML tag for the passed character to the caption text,
	  // and keeps track of it for later closing
	
	
	  Cea608Stream.prototype.addFormatting = function (pts, format) {
	    this.formatting_ = this.formatting_.concat(format);
	    var text = format.reduce(function (text, format) {
	      return text + '<' + format + '>';
	    }, '');
	    this[this.mode_](pts, text);
	  }; // Adds HTML closing tags for current formatting to caption text and
	  // clears remembered formatting
	
	
	  Cea608Stream.prototype.clearFormatting = function (pts) {
	    if (!this.formatting_.length) {
	      return;
	    }
	
	    var text = this.formatting_.reverse().reduce(function (text, format) {
	      return text + '</' + format + '>';
	    }, '');
	    this.formatting_ = [];
	    this[this.mode_](pts, text);
	  }; // Mode Implementations
	
	
	  Cea608Stream.prototype.popOn = function (pts, text) {
	    var baseRow = this.nonDisplayed_[this.row_]; // buffer characters
	
	    baseRow += text;
	    this.nonDisplayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.rollUp = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.shiftRowsUp_ = function () {
	    var i; // clear out inactive rows
	
	    for (i = 0; i < this.topRow_; i++) {
	      this.displayed_[i] = '';
	    }
	
	    for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
	      this.displayed_[i] = '';
	    } // shift displayed rows up
	
	
	    for (i = this.topRow_; i < this.row_; i++) {
	      this.displayed_[i] = this.displayed_[i + 1];
	    } // clear out the bottom row
	
	
	    this.displayed_[this.row_] = '';
	  };
	
	  Cea608Stream.prototype.paintOn = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  }; // exports
	
	
	  var captionStream = {
	    CaptionStream: CaptionStream$1,
	    Cea608Stream: Cea608Stream,
	    Cea708Stream: Cea708Stream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var streamTypes = {
	    H264_STREAM_TYPE: 0x1B,
	    ADTS_STREAM_TYPE: 0x0F,
	    METADATA_STREAM_TYPE: 0x15
	  };
	  var MAX_TS = 8589934592;
	  var RO_THRESH = 4294967296;
	  var TYPE_SHARED = 'shared';
	
	  var handleRollover$1 = function handleRollover(value, reference) {
	    var direction = 1;
	
	    if (value > reference) {
	      // If the current timestamp value is greater than our reference timestamp and we detect a
	      // timestamp rollover, this means the roll over is happening in the opposite direction.
	      // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	      // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	      // rollover point. In loading this segment, the timestamp values will be very large,
	      // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	      // the time stamp to be `value - 2^33`.
	      direction = -1;
	    } // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	    // cause an incorrect adjustment.
	
	
	    while (Math.abs(reference - value) > RO_THRESH) {
	      value += direction * MAX_TS;
	    }
	
	    return value;
	  };
	
	  var TimestampRolloverStream$1 = function TimestampRolloverStream(type) {
	    var lastDTS, referenceDTS;
	    TimestampRolloverStream.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
	    // video and audio. We could use `undefined` here, but having a string
	    // makes debugging a little clearer.
	
	    this.type_ = type || TYPE_SHARED;
	
	    this.push = function (data) {
	      // Any "shared" rollover streams will accept _all_ data. Otherwise,
	      // streams will only accept data that matches their type.
	      if (this.type_ !== TYPE_SHARED && data.type !== this.type_) {
	        return;
	      }
	
	      if (referenceDTS === undefined) {
	        referenceDTS = data.dts;
	      }
	
	      data.dts = handleRollover$1(data.dts, referenceDTS);
	      data.pts = handleRollover$1(data.pts, referenceDTS);
	      lastDTS = data.dts;
	      this.trigger('data', data);
	    };
	
	    this.flush = function () {
	      referenceDTS = lastDTS;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.discontinuity = function () {
	      referenceDTS = void 0;
	      lastDTS = void 0;
	    };
	
	    this.reset = function () {
	      this.discontinuity();
	      this.trigger('reset');
	    };
	  };
	
	  TimestampRolloverStream$1.prototype = new stream();
	  var timestampRolloverStream = {
	    TimestampRolloverStream: TimestampRolloverStream$1,
	    handleRollover: handleRollover$1
	  };
	
	  var percentEncode$1 = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as UTf-8.
	  parseUtf8 = function parseUtf8(bytes, start, end) {
	    return decodeURIComponent(percentEncode$1(bytes, start, end));
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	  parseIso88591$1 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
	  },
	      parseSyncSafeInteger$1 = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  },
	      tagParsers = {
	    TXXX: function TXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the text fields
	          tag.description = parseUtf8(tag.data, 1, i); // do not include the null terminator in the tag value
	
	          tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, '');
	          break;
	        }
	      }
	
	      tag.data = tag.value;
	    },
	    WXXX: function WXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.description = parseUtf8(tag.data, 1, i);
	          tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	          break;
	        }
	      }
	    },
	    PRIV: function PRIV(tag) {
	      var i;
	
	      for (i = 0; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.owner = parseIso88591$1(tag.data, 0, i);
	          break;
	        }
	      }
	
	      tag.privateData = tag.data.subarray(i + 1);
	      tag.data = tag.privateData;
	    }
	  },
	      _MetadataStream;
	
	  _MetadataStream = function MetadataStream(options) {
	    var settings = {
	      // the bytes of the program-level descriptor field in MP2T
	      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	      // program element descriptors"
	      descriptor: options && options.descriptor
	    },
	        // the total size in bytes of the ID3 tag being parsed
	    tagSize = 0,
	        // tag data that is not complete enough to be parsed
	    buffer = [],
	        // the total number of bytes currently in the buffer
	    bufferSize = 0,
	        i;
	
	    _MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
	    // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	
	
	    this.dispatchType = streamTypes.METADATA_STREAM_TYPE.toString(16);
	
	    if (settings.descriptor) {
	      for (i = 0; i < settings.descriptor.length; i++) {
	        this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	      }
	    }
	
	    this.push = function (chunk) {
	      var tag, frameStart, frameSize, frame, i, frameHeader;
	
	      if (chunk.type !== 'timed-metadata') {
	        return;
	      } // if data_alignment_indicator is set in the PES header,
	      // we must have the start of a new ID3 tag. Assume anything
	      // remaining in the buffer was malformed and throw it out
	
	
	      if (chunk.dataAlignmentIndicator) {
	        bufferSize = 0;
	        buffer.length = 0;
	      } // ignore events that don't look like ID3 data
	
	
	      if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping unrecognized metadata packet'
	        });
	        return;
	      } // add this chunk to the data we've collected so far
	
	
	      buffer.push(chunk);
	      bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
	
	      if (buffer.length === 1) {
	        // the frame size is transmitted as a 28-bit integer in the
	        // last four bytes of the ID3 header.
	        // The most significant bit of each byte is dropped and the
	        // results concatenated to recover the actual value.
	        tagSize = parseSyncSafeInteger$1(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
	        // convenient for our comparisons to include it
	
	        tagSize += 10;
	      } // if the entire frame has not arrived, wait for more data
	
	
	      if (bufferSize < tagSize) {
	        return;
	      } // collect the entire frame so it can be parsed
	
	
	      tag = {
	        data: new Uint8Array(tagSize),
	        frames: [],
	        pts: buffer[0].pts,
	        dts: buffer[0].dts
	      };
	
	      for (i = 0; i < tagSize;) {
	        tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	        i += buffer[0].data.byteLength;
	        bufferSize -= buffer[0].data.byteLength;
	        buffer.shift();
	      } // find the start of the first frame and the end of the tag
	
	
	      frameStart = 10;
	
	      if (tag.data[5] & 0x40) {
	        // advance the frame start past the extended header
	        frameStart += 4; // header size field
	
	        frameStart += parseSyncSafeInteger$1(tag.data.subarray(10, 14)); // clip any padding off the end
	
	        tagSize -= parseSyncSafeInteger$1(tag.data.subarray(16, 20));
	      } // parse one or more ID3 frames
	      // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	      do {
	        // determine the number of bytes in this frame
	        frameSize = parseSyncSafeInteger$1(tag.data.subarray(frameStart + 4, frameStart + 8));
	
	        if (frameSize < 1) {
	          this.trigger('log', {
	            level: 'warn',
	            message: 'Malformed ID3 frame encountered. Skipping metadata parsing.'
	          });
	          return;
	        }
	
	        frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
	        frame = {
	          id: frameHeader,
	          data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	        };
	        frame.key = frame.id;
	
	        if (tagParsers[frame.id]) {
	          tagParsers[frame.id](frame); // handle the special PRIV frame used to indicate the start
	          // time for raw AAC data
	
	          if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	            var d = frame.data,
	                size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	            size *= 4;
	            size += d[7] & 0x03;
	            frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
	            // on the value of this frame
	            // we couldn't have known the appropriate pts and dts before
	            // parsing this ID3 tag so set those values now
	
	            if (tag.pts === undefined && tag.dts === undefined) {
	              tag.pts = frame.timeStamp;
	              tag.dts = frame.timeStamp;
	            }
	
	            this.trigger('timestamp', frame);
	          }
	        }
	
	        tag.frames.push(frame);
	        frameStart += 10; // advance past the frame header
	
	        frameStart += frameSize; // advance past the frame body
	      } while (frameStart < tagSize);
	
	      this.trigger('data', tag);
	    };
	  };
	
	  _MetadataStream.prototype = new stream();
	  var metadataStream = _MetadataStream;
	  var TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
	
	  var _TransportPacketStream, _TransportParseStream, _ElementaryStream; // constants
	
	
	  var MP2T_PACKET_LENGTH$1 = 188,
	      // bytes
	  SYNC_BYTE$1 = 0x47;
	  /**
	   * Splits an incoming stream of binary data into MPEG-2 Transport
	   * Stream packets.
	   */
	
	  _TransportPacketStream = function TransportPacketStream() {
	    var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1),
	        bytesInBuffer = 0;
	
	    _TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
	
	    /**
	     * Split a stream of data into M2TS packets
	    **/
	
	
	    this.push = function (bytes) {
	      var startIndex = 0,
	          endIndex = MP2T_PACKET_LENGTH$1,
	          everything; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (bytesInBuffer) {
	        everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	        everything.set(buffer.subarray(0, bytesInBuffer));
	        everything.set(bytes, bytesInBuffer);
	        bytesInBuffer = 0;
	      } else {
	        everything = bytes;
	      } // While we have enough data for a packet
	
	
	      while (endIndex < everything.byteLength) {
	        // Look for a pair of start and end sync bytes in the data..
	        if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
	          // We found a packet so emit it and jump one whole packet forward in
	          // the stream
	          this.trigger('data', everything.subarray(startIndex, endIndex));
	          startIndex += MP2T_PACKET_LENGTH$1;
	          endIndex += MP2T_PACKET_LENGTH$1;
	          continue;
	        } // If we get here, we have somehow become de-synchronized and we need to step
	        // forward one byte at a time until we find a pair of sync bytes that denote
	        // a packet
	
	
	        startIndex++;
	        endIndex++;
	      } // If there was some data left over at the end of the segment that couldn't
	      // possibly be a whole packet, keep it because it might be the start of a packet
	      // that continues in the next segment
	
	
	      if (startIndex < everything.byteLength) {
	        buffer.set(everything.subarray(startIndex), 0);
	        bytesInBuffer = everything.byteLength - startIndex;
	      }
	    };
	    /**
	     * Passes identified M2TS packets to the TransportParseStream to be parsed
	    **/
	
	
	    this.flush = function () {
	      // If the buffer contains a whole packet when we are being flushed, emit it
	      // and empty the buffer. Otherwise hold onto the data because it may be
	      // important for decoding the next segment
	      if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
	        this.trigger('data', buffer);
	        bytesInBuffer = 0;
	      }
	
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.reset = function () {
	      bytesInBuffer = 0;
	      this.trigger('reset');
	    };
	  };
	
	  _TransportPacketStream.prototype = new stream();
	  /**
	   * Accepts an MP2T TransportPacketStream and emits data events with parsed
	   * forms of the individual transport stream packets.
	   */
	
	  _TransportParseStream = function TransportParseStream() {
	    var parsePsi, parsePat, parsePmt, self;
	
	    _TransportParseStream.prototype.init.call(this);
	
	    self = this;
	    this.packetsWaitingForPmt = [];
	    this.programMapTable = undefined;
	
	    parsePsi = function parsePsi(payload, psi) {
	      var offset = 0; // PSI packets may be split into multiple sections and those
	      // sections may be split into multiple packets. If a PSI
	      // section starts in this packet, the payload_unit_start_indicator
	      // will be true and the first byte of the payload will indicate
	      // the offset from the current position to the start of the
	      // section.
	
	      if (psi.payloadUnitStartIndicator) {
	        offset += payload[offset] + 1;
	      }
	
	      if (psi.type === 'pat') {
	        parsePat(payload.subarray(offset), psi);
	      } else {
	        parsePmt(payload.subarray(offset), psi);
	      }
	    };
	
	    parsePat = function parsePat(payload, pat) {
	      pat.section_number = payload[7]; // eslint-disable-line camelcase
	
	      pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	      // skip the PSI header and parse the first PMT entry
	
	      self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	      pat.pmtPid = self.pmtPid;
	    };
	    /**
	     * Parse out the relevant fields of a Program Map Table (PMT).
	     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	     * packet. The first byte in this array should be the table_id
	     * field.
	     * @param pmt {object} the object that should be decorated with
	     * fields parsed from the PMT.
	     */
	
	
	    parsePmt = function parsePmt(payload, pmt) {
	      var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
	      // take effect. We don't believe this should ever be the case
	      // for HLS but we'll ignore "forward" PMT declarations if we see
	      // them. Future PMT declarations have the current_next_indicator
	      // set to zero.
	
	      if (!(payload[5] & 0x01)) {
	        return;
	      } // overwrite any existing program map table
	
	
	      self.programMapTable = {
	        video: null,
	        audio: null,
	        'timed-metadata': {}
	      }; // the mapping table ends at the end of the current section
	
	      sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	      tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	      // long the program info descriptors are
	
	      programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
	
	      offset = 12 + programInfoLength;
	
	      while (offset < tableEnd) {
	        var streamType = payload[offset];
	        var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
	        // TODO: should this be done for metadata too? for now maintain behavior of
	        //       multiple metadata streams
	
	        if (streamType === streamTypes.H264_STREAM_TYPE && self.programMapTable.video === null) {
	          self.programMapTable.video = pid;
	        } else if (streamType === streamTypes.ADTS_STREAM_TYPE && self.programMapTable.audio === null) {
	          self.programMapTable.audio = pid;
	        } else if (streamType === streamTypes.METADATA_STREAM_TYPE) {
	          // map pid to stream type for metadata streams
	          self.programMapTable['timed-metadata'][pid] = streamType;
	        } // move to the next table entry
	        // skip past the elementary stream descriptors, if present
	
	
	        offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	      } // record the map on the packet as well
	
	
	      pmt.programMapTable = self.programMapTable;
	    };
	    /**
	     * Deliver a new MP2T packet to the next stream in the pipeline.
	     */
	
	
	    this.push = function (packet) {
	      var result = {},
	          offset = 4;
	      result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
	
	      result.pid = packet[1] & 0x1f;
	      result.pid <<= 8;
	      result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
	      // fifth byte of the TS packet header. The adaptation field is
	      // used to add stuffing to PES packets that don't fill a complete
	      // TS packet, and to specify some forms of timing and control data
	      // that we do not currently use.
	
	      if ((packet[3] & 0x30) >>> 4 > 0x01) {
	        offset += packet[offset] + 1;
	      } // parse the rest of the packet based on the type
	
	
	      if (result.pid === 0) {
	        result.type = 'pat';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result);
	      } else if (result.pid === this.pmtPid) {
	        result.type = 'pmt';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result); // if there are any packets waiting for a PMT to be found, process them now
	
	        while (this.packetsWaitingForPmt.length) {
	          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
	        }
	      } else if (this.programMapTable === undefined) {
	        // When we have not seen a PMT yet, defer further processing of
	        // PES packets until one has been parsed
	        this.packetsWaitingForPmt.push([packet, offset, result]);
	      } else {
	        this.processPes_(packet, offset, result);
	      }
	    };
	
	    this.processPes_ = function (packet, offset, result) {
	      // set the appropriate stream type
	      if (result.pid === this.programMapTable.video) {
	        result.streamType = streamTypes.H264_STREAM_TYPE;
	      } else if (result.pid === this.programMapTable.audio) {
	        result.streamType = streamTypes.ADTS_STREAM_TYPE;
	      } else {
	        // if not video or audio, it is timed-metadata or unknown
	        // if unknown, streamType will be undefined
	        result.streamType = this.programMapTable['timed-metadata'][result.pid];
	      }
	
	      result.type = 'pes';
	      result.data = packet.subarray(offset);
	      this.trigger('data', result);
	    };
	  };
	
	  _TransportParseStream.prototype = new stream();
	  _TransportParseStream.STREAM_TYPES = {
	    h264: 0x1b,
	    adts: 0x0f
	  };
	  /**
	   * Reconsistutes program elementary stream (PES) packets from parsed
	   * transport stream packets. That is, if you pipe an
	   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	   * events will be events which capture the bytes for individual PES
	   * packets plus relevant metadata that has been extracted from the
	   * container.
	   */
	
	  _ElementaryStream = function ElementaryStream() {
	    var self = this,
	        segmentHadPmt = false,
	        // PES packet fragments
	    video = {
	      data: [],
	      size: 0
	    },
	        audio = {
	      data: [],
	      size: 0
	    },
	        timedMetadata = {
	      data: [],
	      size: 0
	    },
	        programMapTable,
	        parsePes = function parsePes(payload, pes) {
	      var ptsDtsFlags;
	      var startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
	
	      pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
	      // that are frame data that is continuing from the previous fragment. This
	      // is to check that the pes data is the start of a new pes payload
	
	      if (startPrefix !== 1) {
	        return;
	      } // get the packet length, this will be 0 for video
	
	
	      pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
	
	      pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
	      // and a DTS value. Determine what combination of values is
	      // available to work with.
	
	      ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	      // performs all bitwise operations on 32-bit integers but javascript
	      // supports a much greater range (52-bits) of integer using standard
	      // mathematical operations.
	      // We construct a 31-bit value using bitwise operators over the 31
	      // most significant bits and then multiply by 4 (equal to a left-shift
	      // of 2) before we add the final 2 least significant bits of the
	      // timestamp (equal to an OR.)
	
	      if (ptsDtsFlags & 0xC0) {
	        // the PTS and DTS are not written out directly. For information
	        // on how they are encoded, see
	        // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	        pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
	        pes.pts *= 4; // Left shift by 2
	
	        pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	
	        pes.dts = pes.pts;
	
	        if (ptsDtsFlags & 0x40) {
	          pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
	          pes.dts *= 4; // Left shift by 2
	
	          pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	        }
	      } // the data section starts immediately after the PES header.
	      // pes_header_data_length specifies the number of header bytes
	      // that follow the last byte of the field.
	
	
	      pes.data = payload.subarray(9 + payload[8]);
	    },
	
	    /**
	      * Pass completely parsed PES packets to the next stream in the pipeline
	     **/
	    flushStream = function flushStream(stream, type, forceFlush) {
	      var packetData = new Uint8Array(stream.size),
	          event = {
	        type: type
	      },
	          i = 0,
	          offset = 0,
	          packetFlushable = false,
	          fragment; // do nothing if there is not enough buffered data for a complete
	      // PES header
	
	      if (!stream.data.length || stream.size < 9) {
	        return;
	      }
	
	      event.trackId = stream.data[0].pid; // reassemble the packet
	
	      for (i = 0; i < stream.data.length; i++) {
	        fragment = stream.data[i];
	        packetData.set(fragment.data, offset);
	        offset += fragment.data.byteLength;
	      } // parse assembled packet's PES header
	
	
	      parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
	      // check that there is enough stream data to fill the packet
	
	      packetFlushable = type === 'video' || event.packetLength <= stream.size; // flush pending packets if the conditions are right
	
	      if (forceFlush || packetFlushable) {
	        stream.size = 0;
	        stream.data.length = 0;
	      } // only emit packets that are complete. this is to avoid assembling
	      // incomplete PES packets due to poor segmentation
	
	
	      if (packetFlushable) {
	        self.trigger('data', event);
	      }
	    };
	
	    _ElementaryStream.prototype.init.call(this);
	    /**
	     * Identifies M2TS packet types and parses PES packets using metadata
	     * parsed from the PMT
	     **/
	
	
	    this.push = function (data) {
	      ({
	        pat: function pat() {// we have to wait for the PMT to arrive as well before we
	          // have any meaningful metadata
	        },
	        pes: function pes() {
	          var stream, streamType;
	
	          switch (data.streamType) {
	            case streamTypes.H264_STREAM_TYPE:
	              stream = video;
	              streamType = 'video';
	              break;
	
	            case streamTypes.ADTS_STREAM_TYPE:
	              stream = audio;
	              streamType = 'audio';
	              break;
	
	            case streamTypes.METADATA_STREAM_TYPE:
	              stream = timedMetadata;
	              streamType = 'timed-metadata';
	              break;
	
	            default:
	              // ignore unknown stream types
	              return;
	          } // if a new packet is starting, we can flush the completed
	          // packet
	
	
	          if (data.payloadUnitStartIndicator) {
	            flushStream(stream, streamType, true);
	          } // buffer this fragment until we are sure we've received the
	          // complete payload
	
	
	          stream.data.push(data);
	          stream.size += data.data.byteLength;
	        },
	        pmt: function pmt() {
	          var event = {
	            type: 'metadata',
	            tracks: []
	          };
	          programMapTable = data.programMapTable; // translate audio and video streams to tracks
	
	          if (programMapTable.video !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.video,
	              codec: 'avc',
	              type: 'video'
	            });
	          }
	
	          if (programMapTable.audio !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.audio,
	              codec: 'adts',
	              type: 'audio'
	            });
	          }
	
	          segmentHadPmt = true;
	          self.trigger('data', event);
	        }
	      })[data.type]();
	    };
	
	    this.reset = function () {
	      video.size = 0;
	      video.data.length = 0;
	      audio.size = 0;
	      audio.data.length = 0;
	      this.trigger('reset');
	    };
	    /**
	     * Flush any remaining input. Video PES packets may be of variable
	     * length. Normally, the start of a new video packet can trigger the
	     * finalization of the previous packet. That is not possible if no
	     * more video is forthcoming, however. In that case, some other
	     * mechanism (like the end of the file) has to be employed. When it is
	     * clear that no additional data is forthcoming, calling this method
	     * will flush the buffered packets.
	     */
	
	
	    this.flushStreams_ = function () {
	      // !!THIS ORDER IS IMPORTANT!!
	      // video first then audio
	      flushStream(video, 'video');
	      flushStream(audio, 'audio');
	      flushStream(timedMetadata, 'timed-metadata');
	    };
	
	    this.flush = function () {
	      // if on flush we haven't had a pmt emitted
	      // and we have a pmt to emit. emit the pmt
	      // so that we trigger a trackinfo downstream.
	      if (!segmentHadPmt && programMapTable) {
	        var pmt = {
	          type: 'metadata',
	          tracks: []
	        }; // translate audio and video streams to tracks
	
	        if (programMapTable.video !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.video,
	            codec: 'avc',
	            type: 'video'
	          });
	        }
	
	        if (programMapTable.audio !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.audio,
	            codec: 'adts',
	            type: 'audio'
	          });
	        }
	
	        self.trigger('data', pmt);
	      }
	
	      segmentHadPmt = false;
	      this.flushStreams_();
	      this.trigger('done');
	    };
	  };
	
	  _ElementaryStream.prototype = new stream();
	  var m2ts = {
	    PAT_PID: 0x0000,
	    MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
	    TransportPacketStream: _TransportPacketStream,
	    TransportParseStream: _TransportParseStream,
	    ElementaryStream: _ElementaryStream,
	    TimestampRolloverStream: TimestampRolloverStream,
	    CaptionStream: captionStream.CaptionStream,
	    Cea608Stream: captionStream.Cea608Stream,
	    Cea708Stream: captionStream.Cea708Stream,
	    MetadataStream: metadataStream
	  };
	
	  for (var type in streamTypes) {
	    if (streamTypes.hasOwnProperty(type)) {
	      m2ts[type] = streamTypes[type];
	    }
	  }
	
	  var m2ts_1 = m2ts;
	  var ONE_SECOND_IN_TS$2 = clock.ONE_SECOND_IN_TS;
	
	  var _AdtsStream;
	
	  var ADTS_SAMPLING_FREQUENCIES$1 = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	  /*
	   * Accepts a ElementaryStream and emits data events with parsed
	   * AAC Audio Frames of the individual packets. Input audio in ADTS
	   * format is unpacked and re-emitted as AAC frames.
	   *
	   * @see http://wiki.multimedia.cx/index.php?title=ADTS
	   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	   */
	
	  _AdtsStream = function AdtsStream(handlePartialSegments) {
	    var buffer,
	        frameNum = 0;
	
	    _AdtsStream.prototype.init.call(this);
	
	    this.skipWarn_ = function (start, end) {
	      this.trigger('log', {
	        level: 'warn',
	        message: "adts skiping bytes " + start + " to " + end + " in frame " + frameNum + " outside syncword"
	      });
	    };
	
	    this.push = function (packet) {
	      var i = 0,
	          frameLength,
	          protectionSkipBytes,
	          oldBuffer,
	          sampleCount,
	          adtsFrameDuration;
	
	      if (!handlePartialSegments) {
	        frameNum = 0;
	      }
	
	      if (packet.type !== 'audio') {
	        // ignore non-audio data
	        return;
	      } // Prepend any data in the buffer to the input data so that we can parse
	      // aac frames the cross a PES packet boundary
	
	
	      if (buffer && buffer.length) {
	        oldBuffer = buffer;
	        buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	        buffer.set(oldBuffer);
	        buffer.set(packet.data, oldBuffer.byteLength);
	      } else {
	        buffer = packet.data;
	      } // unpack any ADTS frames which have been fully received
	      // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	
	
	      var skip; // We use i + 7 here because we want to be able to parse the entire header.
	      // If we don't have enough bytes to do that, then we definitely won't have a full frame.
	
	      while (i + 7 < buffer.length) {
	        // Look for the start of an ADTS header..
	        if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	          if (typeof skip !== 'number') {
	            skip = i;
	          } // If a valid header was not found,  jump one forward and attempt to
	          // find a valid ADTS header starting at the next byte
	
	
	          i++;
	          continue;
	        }
	
	        if (typeof skip === 'number') {
	          this.skipWarn_(skip, i);
	          skip = null;
	        } // The protection skip bit tells us if we have 2 bytes of CRC data at the
	        // end of the ADTS header
	
	
	        protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
	        // end of the sync sequence
	        // NOTE: frame length includes the size of the header
	
	        frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
	        sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	        adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
	        // then we have to wait for more data
	
	        if (buffer.byteLength - i < frameLength) {
	          break;
	        } // Otherwise, deliver the complete AAC frame
	
	
	        this.trigger('data', {
	          pts: packet.pts + frameNum * adtsFrameDuration,
	          dts: packet.dts + frameNum * adtsFrameDuration,
	          sampleCount: sampleCount,
	          audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
	          channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
	          samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
	          samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	          // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	          samplesize: 16,
	          // data is the frame without it's header
	          data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
	        });
	        frameNum++;
	        i += frameLength;
	      }
	
	      if (typeof skip === 'number') {
	        this.skipWarn_(skip, i);
	        skip = null;
	      } // remove processed bytes from the buffer.
	
	
	      buffer = buffer.subarray(i);
	    };
	
	    this.flush = function () {
	      frameNum = 0;
	      this.trigger('done');
	    };
	
	    this.reset = function () {
	      buffer = void 0;
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      buffer = void 0;
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AdtsStream.prototype = new stream();
	  var adts = _AdtsStream;
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ExpGolomb;
	  /**
	   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	   * scheme used by h264.
	   */
	
	  ExpGolomb = function ExpGolomb(workingData) {
	    var // the number of bytes left to examine in workingData
	    workingBytesAvailable = workingData.byteLength,
	        // the current word being examined
	    workingWord = 0,
	        // :uint
	    // the number of bits left to examine in the current word
	    workingBitsAvailable = 0; // :uint;
	    // ():uint
	
	    this.length = function () {
	      return 8 * workingBytesAvailable;
	    }; // ():uint
	
	
	    this.bitsAvailable = function () {
	      return 8 * workingBytesAvailable + workingBitsAvailable;
	    }; // ():void
	
	
	    this.loadWord = function () {
	      var position = workingData.byteLength - workingBytesAvailable,
	          workingBytes = new Uint8Array(4),
	          availableBytes = Math.min(4, workingBytesAvailable);
	
	      if (availableBytes === 0) {
	        throw new Error('no bytes available');
	      }
	
	      workingBytes.set(workingData.subarray(position, position + availableBytes));
	      workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
	
	      workingBitsAvailable = availableBytes * 8;
	      workingBytesAvailable -= availableBytes;
	    }; // (count:int):void
	
	
	    this.skipBits = function (count) {
	      var skipBytes; // :int
	
	      if (workingBitsAvailable > count) {
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      } else {
	        count -= workingBitsAvailable;
	        skipBytes = Math.floor(count / 8);
	        count -= skipBytes * 8;
	        workingBytesAvailable -= skipBytes;
	        this.loadWord();
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      }
	    }; // (size:int):uint
	
	
	    this.readBits = function (size) {
	      var bits = Math.min(workingBitsAvailable, size),
	          // :uint
	      valu = workingWord >>> 32 - bits; // :uint
	      // if size > 31, handle error
	
	      workingBitsAvailable -= bits;
	
	      if (workingBitsAvailable > 0) {
	        workingWord <<= bits;
	      } else if (workingBytesAvailable > 0) {
	        this.loadWord();
	      }
	
	      bits = size - bits;
	
	      if (bits > 0) {
	        return valu << bits | this.readBits(bits);
	      }
	
	      return valu;
	    }; // ():uint
	
	
	    this.skipLeadingZeros = function () {
	      var leadingZeroCount; // :uint
	
	      for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	        if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
	          // the first bit of working word is 1
	          workingWord <<= leadingZeroCount;
	          workingBitsAvailable -= leadingZeroCount;
	          return leadingZeroCount;
	        }
	      } // we exhausted workingWord and still have not found a 1
	
	
	      this.loadWord();
	      return leadingZeroCount + this.skipLeadingZeros();
	    }; // ():void
	
	
	    this.skipUnsignedExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():void
	
	
	    this.skipExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():uint
	
	
	    this.readUnsignedExpGolomb = function () {
	      var clz = this.skipLeadingZeros(); // :uint
	
	      return this.readBits(clz + 1) - 1;
	    }; // ():int
	
	
	    this.readExpGolomb = function () {
	      var valu = this.readUnsignedExpGolomb(); // :int
	
	      if (0x01 & valu) {
	        // the number is odd if the low order bit is set
	        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	      }
	
	      return -1 * (valu >>> 1); // divide by two then make it negative
	    }; // Some convenience functions
	    // :Boolean
	
	
	    this.readBoolean = function () {
	      return this.readBits(1) === 1;
	    }; // ():int
	
	
	    this.readUnsignedByte = function () {
	      return this.readBits(8);
	    };
	
	    this.loadWord();
	  };
	
	  var expGolomb = ExpGolomb;
	
	  var _H264Stream, _NalByteStream;
	
	  var PROFILES_WITH_OPTIONAL_SPS_DATA;
	  /**
	   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	   */
	
	  _NalByteStream = function NalByteStream() {
	    var syncPoint = 0,
	        i,
	        buffer;
	
	    _NalByteStream.prototype.init.call(this);
	    /*
	     * Scans a byte stream and triggers a data event with the NAL units found.
	     * @param {Object} data Event received from H264Stream
	     * @param {Uint8Array} data.data The h264 byte stream to be scanned
	     *
	     * @see H264Stream.push
	     */
	
	
	    this.push = function (data) {
	      var swapBuffer;
	
	      if (!buffer) {
	        buffer = data.data;
	      } else {
	        swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	        swapBuffer.set(buffer);
	        swapBuffer.set(data.data, buffer.byteLength);
	        buffer = swapBuffer;
	      }
	
	      var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
	      // scan for NAL unit boundaries
	      // a match looks like this:
	      // 0 0 1 .. NAL .. 0 0 1
	      // ^ sync point        ^ i
	      // or this:
	      // 0 0 1 .. NAL .. 0 0 0
	      // ^ sync point        ^ i
	      // advance the sync point to a NAL start, if necessary
	
	      for (; syncPoint < len - 3; syncPoint++) {
	        if (buffer[syncPoint + 2] === 1) {
	          // the sync point is properly aligned
	          i = syncPoint + 5;
	          break;
	        }
	      }
	
	      while (i < len) {
	        // look at the current byte to determine if we've hit the end of
	        // a NAL unit boundary
	        switch (buffer[i]) {
	          case 0:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0) {
	              i += 2;
	              break;
	            } else if (buffer[i - 2] !== 0) {
	              i++;
	              break;
	            } // deliver the NAL unit if it isn't empty
	
	
	            if (syncPoint + 3 !== i - 2) {
	              this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            } // drop trailing zeroes
	
	
	            do {
	              i++;
	            } while (buffer[i] !== 1 && i < len);
	
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          case 1:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
	              i += 3;
	              break;
	            } // deliver the NAL unit
	
	
	            this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          default:
	            // the current byte isn't a one or zero, so it cannot be part
	            // of a sync sequence
	            i += 3;
	            break;
	        }
	      } // filter out the NAL units that were delivered
	
	
	      buffer = buffer.subarray(syncPoint);
	      i -= syncPoint;
	      syncPoint = 0;
	    };
	
	    this.reset = function () {
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('reset');
	    };
	
	    this.flush = function () {
	      // deliver the last buffered NAL unit
	      if (buffer && buffer.byteLength > 3) {
	        this.trigger('data', buffer.subarray(syncPoint + 3));
	      } // reset the stream state
	
	
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _NalByteStream.prototype = new stream(); // values of profile_idc that indicate additional fields are included in the SPS
	  // see Recommendation ITU-T H.264 (4/2013),
	  // 7.3.2.1.1 Sequence parameter set data syntax
	
	  PROFILES_WITH_OPTIONAL_SPS_DATA = {
	    100: true,
	    110: true,
	    122: true,
	    244: true,
	    44: true,
	    83: true,
	    86: true,
	    118: true,
	    128: true,
	    // TODO: the three profiles below don't
	    // appear to have sps data in the specificiation anymore?
	    138: true,
	    139: true,
	    134: true
	  };
	  /**
	   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	   * events.
	   */
	
	  _H264Stream = function H264Stream() {
	    var nalByteStream = new _NalByteStream(),
	        self,
	        trackId,
	        currentPts,
	        currentDts,
	        discardEmulationPreventionBytes,
	        readSequenceParameterSet,
	        skipScalingList;
	
	    _H264Stream.prototype.init.call(this);
	
	    self = this;
	    /*
	     * Pushes a packet from a stream onto the NalByteStream
	     *
	     * @param {Object} packet - A packet received from a stream
	     * @param {Uint8Array} packet.data - The raw bytes of the packet
	     * @param {Number} packet.dts - Decode timestamp of the packet
	     * @param {Number} packet.pts - Presentation timestamp of the packet
	     * @param {Number} packet.trackId - The id of the h264 track this packet came from
	     * @param {('video'|'audio')} packet.type - The type of packet
	     *
	     */
	
	    this.push = function (packet) {
	      if (packet.type !== 'video') {
	        return;
	      }
	
	      trackId = packet.trackId;
	      currentPts = packet.pts;
	      currentDts = packet.dts;
	      nalByteStream.push(packet);
	    };
	    /*
	     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
	     * for the NALUs to the next stream component.
	     * Also, preprocess caption and sequence parameter NALUs.
	     *
	     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
	     * @see NalByteStream.push
	     */
	
	
	    nalByteStream.on('data', function (data) {
	      var event = {
	        trackId: trackId,
	        pts: currentPts,
	        dts: currentDts,
	        data: data,
	        nalUnitTypeCode: data[0] & 0x1f
	      };
	
	      switch (event.nalUnitTypeCode) {
	        case 0x05:
	          event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	          break;
	
	        case 0x06:
	          event.nalUnitType = 'sei_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          break;
	
	        case 0x07:
	          event.nalUnitType = 'seq_parameter_set_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          event.config = readSequenceParameterSet(event.escapedRBSP);
	          break;
	
	        case 0x08:
	          event.nalUnitType = 'pic_parameter_set_rbsp';
	          break;
	
	        case 0x09:
	          event.nalUnitType = 'access_unit_delimiter_rbsp';
	          break;
	      } // This triggers data on the H264Stream
	
	
	      self.trigger('data', event);
	    });
	    nalByteStream.on('done', function () {
	      self.trigger('done');
	    });
	    nalByteStream.on('partialdone', function () {
	      self.trigger('partialdone');
	    });
	    nalByteStream.on('reset', function () {
	      self.trigger('reset');
	    });
	    nalByteStream.on('endedtimeline', function () {
	      self.trigger('endedtimeline');
	    });
	
	    this.flush = function () {
	      nalByteStream.flush();
	    };
	
	    this.partialFlush = function () {
	      nalByteStream.partialFlush();
	    };
	
	    this.reset = function () {
	      nalByteStream.reset();
	    };
	
	    this.endTimeline = function () {
	      nalByteStream.endTimeline();
	    };
	    /**
	     * Advance the ExpGolomb decoder past a scaling list. The scaling
	     * list is optionally transmitted as part of a sequence parameter
	     * set and is not relevant to transmuxing.
	     * @param count {number} the number of entries in this scaling list
	     * @param expGolombDecoder {object} an ExpGolomb pointed to the
	     * start of a scaling list
	     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	     */
	
	
	    skipScalingList = function skipScalingList(count, expGolombDecoder) {
	      var lastScale = 8,
	          nextScale = 8,
	          j,
	          deltaScale;
	
	      for (j = 0; j < count; j++) {
	        if (nextScale !== 0) {
	          deltaScale = expGolombDecoder.readExpGolomb();
	          nextScale = (lastScale + deltaScale + 256) % 256;
	        }
	
	        lastScale = nextScale === 0 ? lastScale : nextScale;
	      }
	    };
	    /**
	     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	     * Sequence Payload"
	     * @param data {Uint8Array} the bytes of a RBSP from a NAL
	     * unit
	     * @return {Uint8Array} the RBSP without any Emulation
	     * Prevention Bytes
	     */
	
	
	    discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	      var length = data.byteLength,
	          emulationPreventionBytesPositions = [],
	          i = 1,
	          newLength,
	          newData; // Find all `Emulation Prevention Bytes`
	
	      while (i < length - 2) {
	        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	          emulationPreventionBytesPositions.push(i + 2);
	          i += 2;
	        } else {
	          i++;
	        }
	      } // If no Emulation Prevention Bytes were found just return the original
	      // array
	
	
	      if (emulationPreventionBytesPositions.length === 0) {
	        return data;
	      } // Create a new array to hold the NAL unit data
	
	
	      newLength = length - emulationPreventionBytesPositions.length;
	      newData = new Uint8Array(newLength);
	      var sourceIndex = 0;
	
	      for (i = 0; i < newLength; sourceIndex++, i++) {
	        if (sourceIndex === emulationPreventionBytesPositions[0]) {
	          // Skip this byte
	          sourceIndex++; // Remove this position index
	
	          emulationPreventionBytesPositions.shift();
	        }
	
	        newData[i] = data[sourceIndex];
	      }
	
	      return newData;
	    };
	    /**
	     * Read a sequence parameter set and return some interesting video
	     * properties. A sequence parameter set is the H264 metadata that
	     * describes the properties of upcoming video frames.
	     * @param data {Uint8Array} the bytes of a sequence parameter set
	     * @return {object} an object with configuration parsed from the
	     * sequence parameter set, including the dimensions of the
	     * associated video frames.
	     */
	
	
	    readSequenceParameterSet = function readSequenceParameterSet(data) {
	      var frameCropLeftOffset = 0,
	          frameCropRightOffset = 0,
	          frameCropTopOffset = 0,
	          frameCropBottomOffset = 0,
	          expGolombDecoder,
	          profileIdc,
	          levelIdc,
	          profileCompatibility,
	          chromaFormatIdc,
	          picOrderCntType,
	          numRefFramesInPicOrderCntCycle,
	          picWidthInMbsMinus1,
	          picHeightInMapUnitsMinus1,
	          frameMbsOnlyFlag,
	          scalingListCount,
	          sarRatio = [1, 1],
	          aspectRatioIdc,
	          i;
	      expGolombDecoder = new expGolomb(data);
	      profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	
	      profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	
	      levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	      // some profiles have more optional data we don't need
	
	      if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	        chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	
	        if (chromaFormatIdc === 3) {
	          expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	        }
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	
	        expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	
	        if (expGolombDecoder.readBoolean()) {
	          // seq_scaling_matrix_present_flag
	          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	
	          for (i = 0; i < scalingListCount; i++) {
	            if (expGolombDecoder.readBoolean()) {
	              // seq_scaling_list_present_flag[ i ]
	              if (i < 6) {
	                skipScalingList(16, expGolombDecoder);
	              } else {
	                skipScalingList(64, expGolombDecoder);
	              }
	            }
	          }
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	
	      picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	      if (picOrderCntType === 0) {
	        expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	      } else if (picOrderCntType === 1) {
	        expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	
	        numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	
	        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	          expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	
	      expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	      picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	
	      if (frameMbsOnlyFlag === 0) {
	        expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	      }
	
	      expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	
	      if (expGolombDecoder.readBoolean()) {
	        // frame_cropping_flag
	        frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	      }
	
	      if (expGolombDecoder.readBoolean()) {
	        // vui_parameters_present_flag
	        if (expGolombDecoder.readBoolean()) {
	          // aspect_ratio_info_present_flag
	          aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	
	          switch (aspectRatioIdc) {
	            case 1:
	              sarRatio = [1, 1];
	              break;
	
	            case 2:
	              sarRatio = [12, 11];
	              break;
	
	            case 3:
	              sarRatio = [10, 11];
	              break;
	
	            case 4:
	              sarRatio = [16, 11];
	              break;
	
	            case 5:
	              sarRatio = [40, 33];
	              break;
	
	            case 6:
	              sarRatio = [24, 11];
	              break;
	
	            case 7:
	              sarRatio = [20, 11];
	              break;
	
	            case 8:
	              sarRatio = [32, 11];
	              break;
	
	            case 9:
	              sarRatio = [80, 33];
	              break;
	
	            case 10:
	              sarRatio = [18, 11];
	              break;
	
	            case 11:
	              sarRatio = [15, 11];
	              break;
	
	            case 12:
	              sarRatio = [64, 33];
	              break;
	
	            case 13:
	              sarRatio = [160, 99];
	              break;
	
	            case 14:
	              sarRatio = [4, 3];
	              break;
	
	            case 15:
	              sarRatio = [3, 2];
	              break;
	
	            case 16:
	              sarRatio = [2, 1];
	              break;
	
	            case 255:
	              {
	                sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
	                break;
	              }
	          }
	
	          if (sarRatio) {
	            sarRatio[0] / sarRatio[1];
	          }
	        }
	      }
	
	      return {
	        profileIdc: profileIdc,
	        levelIdc: levelIdc,
	        profileCompatibility: profileCompatibility,
	        width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
	        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
	        // sar is sample aspect ratio
	        sarRatio: sarRatio
	      };
	    };
	  };
	
	  _H264Stream.prototype = new stream();
	  var h264 = {
	    H264Stream: _H264Stream,
	    NalByteStream: _NalByteStream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Utilities to detect basic properties and metadata about Aac data.
	   */
	
	  var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	  var parseId3TagSize = function parseId3TagSize(header, byteIndex) {
	    var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	        flags = header[byteIndex + 5],
	        footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
	
	    returnSize = returnSize >= 0 ? returnSize : 0;
	
	    if (footerPresent) {
	      return returnSize + 20;
	    }
	
	    return returnSize + 10;
	  };
	
	  var getId3Offset = function getId3Offset(data, offset) {
	    if (data.length - offset < 10 || data[offset] !== 'I'.charCodeAt(0) || data[offset + 1] !== 'D'.charCodeAt(0) || data[offset + 2] !== '3'.charCodeAt(0)) {
	      return offset;
	    }
	
	    offset += parseId3TagSize(data, offset);
	    return getId3Offset(data, offset);
	  }; // TODO: use vhs-utils
	
	
	  var isLikelyAacData$1 = function isLikelyAacData(data) {
	    var offset = getId3Offset(data, 0);
	    return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
	    // is not mp3 data but aac data.
	    (data[offset + 1] & 0x16) === 0x10;
	  };
	
	  var parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  }; // return a percent-encoded representation of the specified byte range
	  // @see http://en.wikipedia.org/wiki/Percent-encoding
	
	
	  var percentEncode = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  }; // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	
	
	  var parseIso88591 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	  };
	
	  var parseAdtsSize = function parseAdtsSize(header, byteIndex) {
	    var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	        middle = header[byteIndex + 4] << 3,
	        highTwo = header[byteIndex + 3] & 0x3 << 11;
	    return highTwo | middle | lowThree;
	  };
	
	  var parseType$2 = function parseType(header, byteIndex) {
	    if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) {
	      return 'timed-metadata';
	    } else if (header[byteIndex] & 0xff === 0xff && (header[byteIndex + 1] & 0xf0) === 0xf0) {
	      return 'audio';
	    }
	
	    return null;
	  };
	
	  var parseSampleRate = function parseSampleRate(packet) {
	    var i = 0;
	
	    while (i + 5 < packet.length) {
	      if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
	        // If a valid header was not found,  jump one forward and attempt to
	        // find a valid ADTS header starting at the next byte
	        i++;
	        continue;
	      }
	
	      return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
	    }
	
	    return null;
	  };
	
	  var parseAacTimestamp = function parseAacTimestamp(packet) {
	    var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
	
	    frameStart = 10;
	
	    if (packet[5] & 0x40) {
	      // advance the frame start past the extended header
	      frameStart += 4; // header size field
	
	      frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
	    } // parse one or more ID3 frames
	    // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	    do {
	      // determine the number of bytes in this frame
	      frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
	
	      if (frameSize < 1) {
	        return null;
	      }
	
	      frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
	
	      if (frameHeader === 'PRIV') {
	        frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
	
	        for (var i = 0; i < frame.byteLength; i++) {
	          if (frame[i] === 0) {
	            var owner = parseIso88591(frame, 0, i);
	
	            if (owner === 'com.apple.streaming.transportStreamTimestamp') {
	              var d = frame.subarray(i + 1);
	              var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	              size *= 4;
	              size += d[7] & 0x03;
	              return size;
	            }
	
	            break;
	          }
	        }
	      }
	
	      frameStart += 10; // advance past the frame header
	
	      frameStart += frameSize; // advance past the frame body
	    } while (frameStart < packet.byteLength);
	
	    return null;
	  };
	
	  var utils = {
	    isLikelyAacData: isLikelyAacData$1,
	    parseId3TagSize: parseId3TagSize,
	    parseAdtsSize: parseAdtsSize,
	    parseType: parseType$2,
	    parseSampleRate: parseSampleRate,
	    parseAacTimestamp: parseAacTimestamp
	  };
	
	  var _AacStream;
	  /**
	   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	   */
	
	
	  _AacStream = function AacStream() {
	    var everything = new Uint8Array(),
	        timeStamp = 0;
	
	    _AacStream.prototype.init.call(this);
	
	    this.setTimestamp = function (timestamp) {
	      timeStamp = timestamp;
	    };
	
	    this.push = function (bytes) {
	      var frameSize = 0,
	          byteIndex = 0,
	          bytesLeft,
	          chunk,
	          packet,
	          tempLength; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (everything.length) {
	        tempLength = everything.length;
	        everything = new Uint8Array(bytes.byteLength + tempLength);
	        everything.set(everything.subarray(0, tempLength));
	        everything.set(bytes, tempLength);
	      } else {
	        everything = bytes;
	      }
	
	      while (everything.length - byteIndex >= 3) {
	        if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (everything.length - byteIndex < 10) {
	            break;
	          } // check framesize
	
	
	          frameSize = utils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	          // Add to byteIndex to support multiple ID3 tags in sequence
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          chunk = {
	            type: 'timed-metadata',
	            data: everything.subarray(byteIndex, byteIndex + frameSize)
	          };
	          this.trigger('data', chunk);
	          byteIndex += frameSize;
	          continue;
	        } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (everything.length - byteIndex < 7) {
	            break;
	          }
	
	          frameSize = utils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          packet = {
	            type: 'audio',
	            data: everything.subarray(byteIndex, byteIndex + frameSize),
	            pts: timeStamp,
	            dts: timeStamp
	          };
	          this.trigger('data', packet);
	          byteIndex += frameSize;
	          continue;
	        }
	
	        byteIndex++;
	      }
	
	      bytesLeft = everything.length - byteIndex;
	
	      if (bytesLeft > 0) {
	        everything = everything.subarray(byteIndex);
	      } else {
	        everything = new Uint8Array();
	      }
	    };
	
	    this.reset = function () {
	      everything = new Uint8Array();
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      everything = new Uint8Array();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AacStream.prototype = new stream();
	  var aac = _AacStream; // constants
	
	  var AUDIO_PROPERTIES = ['audioobjecttype', 'channelcount', 'samplerate', 'samplingfrequencyindex', 'samplesize'];
	  var audioProperties = AUDIO_PROPERTIES;
	  var VIDEO_PROPERTIES = ['width', 'height', 'profileIdc', 'levelIdc', 'profileCompatibility', 'sarRatio'];
	  var videoProperties = VIDEO_PROPERTIES;
	  var H264Stream = h264.H264Stream;
	  var isLikelyAacData = utils.isLikelyAacData;
	  var ONE_SECOND_IN_TS$1 = clock.ONE_SECOND_IN_TS; // object types
	
	  var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
	
	  var retriggerForStream = function retriggerForStream(key, event) {
	    event.stream = key;
	    this.trigger('log', event);
	  };
	
	  var addPipelineLogRetriggers = function addPipelineLogRetriggers(transmuxer, pipeline) {
	    var keys = Object.keys(pipeline);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i]; // skip non-stream keys and headOfPipeline
	      // which is just a duplicate
	
	      if (key === 'headOfPipeline' || !pipeline[key].on) {
	        continue;
	      }
	
	      pipeline[key].on('log', retriggerForStream.bind(transmuxer, key));
	    }
	  };
	  /**
	   * Compare two arrays (even typed) for same-ness
	   */
	
	
	  var arrayEquals = function arrayEquals(a, b) {
	    var i;
	
	    if (a.length !== b.length) {
	      return false;
	    } // compare the value of each element in the array
	
	
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  var generateSegmentTimingInfo = function generateSegmentTimingInfo(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
	    var ptsOffsetFromDts = startPts - startDts,
	        decodeDuration = endDts - startDts,
	        presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
	    // however, the player time values will reflect a start from the baseMediaDecodeTime.
	    // In order to provide relevant values for the player times, base timing info on the
	    // baseMediaDecodeTime and the DTS and PTS durations of the segment.
	
	    return {
	      start: {
	        dts: baseMediaDecodeTime,
	        pts: baseMediaDecodeTime + ptsOffsetFromDts
	      },
	      end: {
	        dts: baseMediaDecodeTime + decodeDuration,
	        pts: baseMediaDecodeTime + presentationDuration
	      },
	      prependedContentDuration: prependedContentDuration,
	      baseMediaDecodeTime: baseMediaDecodeTime
	    };
	  };
	  /**
	   * Constructs a single-track, ISO BMFF media segment from AAC data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  _AudioSegmentStream = function AudioSegmentStream(track, options) {
	    var adtsFrames = [],
	        sequenceNumber,
	        earliestAllowedDts = 0,
	        audioAppendStartTs = 0,
	        videoBaseMediaDecodeTime = Infinity;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _AudioSegmentStream.prototype.init.call(this);
	
	    this.push = function (data) {
	      trackDecodeInfo.collectDtsInfo(track, data);
	
	      if (track) {
	        audioProperties.forEach(function (prop) {
	          track[prop] = data[prop];
	        });
	      } // buffer audio data until end() is called
	
	
	      adtsFrames.push(data);
	    };
	
	    this.setEarliestDts = function (earliestDts) {
	      earliestAllowedDts = earliestDts;
	    };
	
	    this.setVideoBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      videoBaseMediaDecodeTime = baseMediaDecodeTime;
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      audioAppendStartTs = timestamp;
	    };
	
	    this.flush = function () {
	      var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
	
	      if (adtsFrames.length === 0) {
	        this.trigger('done', 'AudioSegmentStream');
	        return;
	      }
	
	      frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
	
	      videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
	      // samples (that is, adts frames) in the audio data
	
	      track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
	
	      mdat = mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));
	      adtsFrames = [];
	      moof = mp4Generator.moof(sequenceNumber, [track]);
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      trackDecodeInfo.clearDtsInfo(track);
	      frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
	      // tests) on adding the timingInfo event. However, it seems unlikely that there's a
	      // valid use-case where an init segment/data should be triggered without associated
	      // frames. Leaving for now, but should be looked into.
	
	      if (frames.length) {
	        segmentDuration = frames.length * frameDuration;
	        this.trigger('segmentTimingInfo', generateSegmentTimingInfo( // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
	        // frame info is in video clock cycles. Convert to match expectation of
	        // listeners (that all timestamps will be based on video clock cycles).
	        clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
	        frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
	        this.trigger('timingInfo', {
	          start: frames[0].pts,
	          end: frames[0].pts + segmentDuration
	        });
	      }
	
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.trigger('done', 'AudioSegmentStream');
	    };
	
	    this.reset = function () {
	      trackDecodeInfo.clearDtsInfo(track);
	      adtsFrames = [];
	      this.trigger('reset');
	    };
	  };
	
	  _AudioSegmentStream.prototype = new stream();
	  /**
	   * Constructs a single-track, ISO BMFF media segment from H264 data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
	   *        gopsToAlignWith list when attempting to align gop pts
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	  _VideoSegmentStream = function VideoSegmentStream(track, options) {
	    var sequenceNumber,
	        nalUnits = [],
	        gopsToAlignWith = [],
	        config,
	        pps;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _VideoSegmentStream.prototype.init.call(this);
	
	    delete track.minPTS;
	    this.gopCache_ = [];
	    /**
	      * Constructs a ISO BMFF segment given H264 nalUnits
	      * @param {Object} nalUnit A data event representing a nalUnit
	      * @param {String} nalUnit.nalUnitType
	      * @param {Object} nalUnit.config Properties for a mp4 track
	      * @param {Uint8Array} nalUnit.data The nalUnit bytes
	      * @see lib/codecs/h264.js
	     **/
	
	    this.push = function (nalUnit) {
	      trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
	
	      if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	        config = nalUnit.config;
	        track.sps = [nalUnit.data];
	        videoProperties.forEach(function (prop) {
	          track[prop] = config[prop];
	        }, this);
	      }
	
	      if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
	        pps = nalUnit.data;
	        track.pps = [nalUnit.data];
	      } // buffer video until flush() is called
	
	
	      nalUnits.push(nalUnit);
	    };
	    /**
	      * Pass constructed ISO BMFF track and boxes on to the
	      * next stream in the pipeline
	     **/
	
	
	    this.flush = function () {
	      var frames,
	          gopForFusion,
	          gops,
	          moof,
	          mdat,
	          boxes,
	          prependedContentDuration = 0,
	          firstGop,
	          lastGop; // Throw away nalUnits at the start of the byte stream until
	      // we find the first AUD
	
	      while (nalUnits.length) {
	        if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	          break;
	        }
	
	        nalUnits.shift();
	      } // Return early if no video data has been observed
	
	
	      if (nalUnits.length === 0) {
	        this.resetStream_();
	        this.trigger('done', 'VideoSegmentStream');
	        return;
	      } // Organize the raw nal-units into arrays that represent
	      // higher-level constructs such as frames and gops
	      // (group-of-pictures)
	
	
	      frames = frameUtils.groupNalsIntoFrames(nalUnits);
	      gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
	      // a problem since MSE (on Chrome) requires a leading keyframe.
	      //
	      // We have two approaches to repairing this situation:
	      // 1) GOP-FUSION:
	      //    This is where we keep track of the GOPS (group-of-pictures)
	      //    from previous fragments and attempt to find one that we can
	      //    prepend to the current fragment in order to create a valid
	      //    fragment.
	      // 2) KEYFRAME-PULLING:
	      //    Here we search for the first keyframe in the fragment and
	      //    throw away all the frames between the start of the fragment
	      //    and that keyframe. We then extend the duration and pull the
	      //    PTS of the keyframe forward so that it covers the time range
	      //    of the frames that were disposed of.
	      //
	      // #1 is far prefereable over #2 which can cause "stuttering" but
	      // requires more things to be just right.
	
	      if (!gops[0][0].keyFrame) {
	        // Search for a gop for fusion from our gopCache
	        gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	        if (gopForFusion) {
	          // in order to provide more accurate timing information about the segment, save
	          // the number of seconds prepended to the original segment due to GOP fusion
	          prependedContentDuration = gopForFusion.duration;
	          gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
	          // new gop at the beginning
	
	          gops.byteLength += gopForFusion.byteLength;
	          gops.nalCount += gopForFusion.nalCount;
	          gops.pts = gopForFusion.pts;
	          gops.dts = gopForFusion.dts;
	          gops.duration += gopForFusion.duration;
	        } else {
	          // If we didn't find a candidate gop fall back to keyframe-pulling
	          gops = frameUtils.extendFirstKeyFrame(gops);
	        }
	      } // Trim gops to align with gopsToAlignWith
	
	
	      if (gopsToAlignWith.length) {
	        var alignedGops;
	
	        if (options.alignGopsAtEnd) {
	          alignedGops = this.alignGopsAtEnd_(gops);
	        } else {
	          alignedGops = this.alignGopsAtStart_(gops);
	        }
	
	        if (!alignedGops) {
	          // save all the nals in the last GOP into the gop cache
	          this.gopCache_.unshift({
	            gop: gops.pop(),
	            pps: track.pps,
	            sps: track.sps
	          }); // Keep a maximum of 6 GOPs in the cache
	
	          this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	          nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
	
	          this.resetStream_();
	          this.trigger('done', 'VideoSegmentStream');
	          return;
	        } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
	        // when recalculated before sending off to CoalesceStream
	
	
	        trackDecodeInfo.clearDtsInfo(track);
	        gops = alignedGops;
	      }
	
	      trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
	      // samples (that is, frames) in the video data
	
	      track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
	
	      mdat = mp4Generator.mdat(frameUtils.concatenateNalData(gops));
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
	      this.trigger('processedGopsInfo', gops.map(function (gop) {
	        return {
	          pts: gop.pts,
	          dts: gop.dts,
	          byteLength: gop.byteLength
	        };
	      }));
	      firstGop = gops[0];
	      lastGop = gops[gops.length - 1];
	      this.trigger('segmentTimingInfo', generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
	      this.trigger('timingInfo', {
	        start: gops[0].pts,
	        end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
	      }); // save all the nals in the last GOP into the gop cache
	
	      this.gopCache_.unshift({
	        gop: gops.pop(),
	        pps: track.pps,
	        sps: track.sps
	      }); // Keep a maximum of 6 GOPs in the cache
	
	      this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	      nalUnits = [];
	      this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	      this.trigger('timelineStartInfo', track.timelineStartInfo);
	      moof = mp4Generator.moof(sequenceNumber, [track]); // it would be great to allocate this array up front instead of
	      // throwing away hundreds of media segment fragments
	
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.resetStream_(); // Continue with the flush process now
	
	      this.trigger('done', 'VideoSegmentStream');
	    };
	
	    this.reset = function () {
	      this.resetStream_();
	      nalUnits = [];
	      this.gopCache_.length = 0;
	      gopsToAlignWith.length = 0;
	      this.trigger('reset');
	    };
	
	    this.resetStream_ = function () {
	      trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
	      // for instance, when we are rendition switching
	
	      config = undefined;
	      pps = undefined;
	    }; // Search for a candidate Gop for gop-fusion from the gop cache and
	    // return it or return null if no good candidate was found
	
	
	    this.getGopForFusion_ = function (nalUnit) {
	      var halfSecond = 45000,
	          // Half-a-second in a 90khz clock
	      allowableOverlap = 10000,
	          // About 3 frames @ 30fps
	      nearestDistance = Infinity,
	          dtsDistance,
	          nearestGopObj,
	          currentGop,
	          currentGopObj,
	          i; // Search for the GOP nearest to the beginning of this nal unit
	
	      for (i = 0; i < this.gopCache_.length; i++) {
	        currentGopObj = this.gopCache_[i];
	        currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
	
	        if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	          continue;
	        } // Reject Gops that would require a negative baseMediaDecodeTime
	
	
	        if (currentGop.dts < track.timelineStartInfo.dts) {
	          continue;
	        } // The distance between the end of the gop and the start of the nalUnit
	
	
	        dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
	        // a half-second of the nal unit
	
	        if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
	          // Always use the closest GOP we found if there is more than
	          // one candidate
	          if (!nearestGopObj || nearestDistance > dtsDistance) {
	            nearestGopObj = currentGopObj;
	            nearestDistance = dtsDistance;
	          }
	        }
	      }
	
	      if (nearestGopObj) {
	        return nearestGopObj.gop;
	      }
	
	      return null;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the START of the list
	
	
	    this.alignGopsAtStart_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
	      byteLength = gops.byteLength;
	      nalCount = gops.nalCount;
	      duration = gops.duration;
	      alignIndex = gopIndex = 0;
	
	      while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          break;
	        }
	
	        if (gop.pts > align.pts) {
	          // this current gop starts after the current gop we want to align on, so increment
	          // align index
	          alignIndex++;
	          continue;
	        } // current gop starts before the current gop we want to align on. so increment gop
	        // index
	
	
	        gopIndex++;
	        byteLength -= gop.byteLength;
	        nalCount -= gop.nalCount;
	        duration -= gop.duration;
	      }
	
	      if (gopIndex === 0) {
	        // no gops to trim
	        return gops;
	      }
	
	      if (gopIndex === gops.length) {
	        // all gops trimmed, skip appending all gops
	        return null;
	      }
	
	      alignedGops = gops.slice(gopIndex);
	      alignedGops.byteLength = byteLength;
	      alignedGops.duration = duration;
	      alignedGops.nalCount = nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the END of the list
	
	
	    this.alignGopsAtEnd_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
	      alignIndex = gopsToAlignWith.length - 1;
	      gopIndex = gops.length - 1;
	      alignEndIndex = null;
	      matchFound = false;
	
	      while (alignIndex >= 0 && gopIndex >= 0) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          matchFound = true;
	          break;
	        }
	
	        if (align.pts > gop.pts) {
	          alignIndex--;
	          continue;
	        }
	
	        if (alignIndex === gopsToAlignWith.length - 1) {
	          // gop.pts is greater than the last alignment candidate. If no match is found
	          // by the end of this loop, we still want to append gops that come after this
	          // point
	          alignEndIndex = gopIndex;
	        }
	
	        gopIndex--;
	      }
	
	      if (!matchFound && alignEndIndex === null) {
	        return null;
	      }
	
	      var trimIndex;
	
	      if (matchFound) {
	        trimIndex = gopIndex;
	      } else {
	        trimIndex = alignEndIndex;
	      }
	
	      if (trimIndex === 0) {
	        return gops;
	      }
	
	      var alignedGops = gops.slice(trimIndex);
	      var metadata = alignedGops.reduce(function (total, gop) {
	        total.byteLength += gop.byteLength;
	        total.duration += gop.duration;
	        total.nalCount += gop.nalCount;
	        return total;
	      }, {
	        byteLength: 0,
	        duration: 0,
	        nalCount: 0
	      });
	      alignedGops.byteLength = metadata.byteLength;
	      alignedGops.duration = metadata.duration;
	      alignedGops.nalCount = metadata.nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    };
	
	    this.alignGopsWith = function (newGopsToAlignWith) {
	      gopsToAlignWith = newGopsToAlignWith;
	    };
	  };
	
	  _VideoSegmentStream.prototype = new stream();
	  /**
	   * A Stream that can combine multiple streams (ie. audio & video)
	   * into a single output segment for MSE. Also supports audio-only
	   * and video-only streams.
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at media timeline start.
	   */
	
	  _CoalesceStream = function CoalesceStream(options, metadataStream) {
	    // Number of Tracks per output segment
	    // If greater than 1, we combine multiple
	    // tracks into a single segment
	    this.numberOfTracks = 0;
	    this.metadataStream = metadataStream;
	    options = options || {};
	
	    if (typeof options.remux !== 'undefined') {
	      this.remuxTracks = !!options.remux;
	    } else {
	      this.remuxTracks = true;
	    }
	
	    if (typeof options.keepOriginalTimestamps === 'boolean') {
	      this.keepOriginalTimestamps = options.keepOriginalTimestamps;
	    } else {
	      this.keepOriginalTimestamps = false;
	    }
	
	    this.pendingTracks = [];
	    this.videoTrack = null;
	    this.pendingBoxes = [];
	    this.pendingCaptions = [];
	    this.pendingMetadata = [];
	    this.pendingBytes = 0;
	    this.emittedTracks = 0;
	
	    _CoalesceStream.prototype.init.call(this); // Take output from multiple
	
	
	    this.push = function (output) {
	      // buffer incoming captions until the associated video segment
	      // finishes
	      if (output.text) {
	        return this.pendingCaptions.push(output);
	      } // buffer incoming id3 tags until the final flush
	
	
	      if (output.frames) {
	        return this.pendingMetadata.push(output);
	      } // Add this track to the list of pending tracks and store
	      // important information required for the construction of
	      // the final segment
	
	
	      this.pendingTracks.push(output.track);
	      this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
	      // We unshift audio and push video because
	      // as of Chrome 75 when switching from
	      // one init segment to another if the video
	      // mdat does not appear after the audio mdat
	      // only audio will play for the duration of our transmux.
	
	      if (output.track.type === 'video') {
	        this.videoTrack = output.track;
	        this.pendingBoxes.push(output.boxes);
	      }
	
	      if (output.track.type === 'audio') {
	        this.audioTrack = output.track;
	        this.pendingBoxes.unshift(output.boxes);
	      }
	    };
	  };
	
	  _CoalesceStream.prototype = new stream();
	
	  _CoalesceStream.prototype.flush = function (flushSource) {
	    var offset = 0,
	        event = {
	      captions: [],
	      captionStreams: {},
	      metadata: [],
	      info: {}
	    },
	        caption,
	        id3,
	        initSegment,
	        timelineStartPts = 0,
	        i;
	
	    if (this.pendingTracks.length < this.numberOfTracks) {
	      if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	        // Return because we haven't received a flush from a data-generating
	        // portion of the segment (meaning that we have only recieved meta-data
	        // or captions.)
	        return;
	      } else if (this.remuxTracks) {
	        // Return until we have enough tracks from the pipeline to remux (if we
	        // are remuxing audio and video into a single MP4)
	        return;
	      } else if (this.pendingTracks.length === 0) {
	        // In the case where we receive a flush without any data having been
	        // received we consider it an emitted track for the purposes of coalescing
	        // `done` events.
	        // We do this for the case where there is an audio and video track in the
	        // segment but no audio data. (seen in several playlists with alternate
	        // audio tracks and no audio present in the main TS segments.)
	        this.emittedTracks++;
	
	        if (this.emittedTracks >= this.numberOfTracks) {
	          this.trigger('done');
	          this.emittedTracks = 0;
	        }
	
	        return;
	      }
	    }
	
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      videoProperties.forEach(function (prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    } else if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      audioProperties.forEach(function (prop) {
	        event.info[prop] = this.audioTrack[prop];
	      }, this);
	    }
	
	    if (this.videoTrack || this.audioTrack) {
	      if (this.pendingTracks.length === 1) {
	        event.type = this.pendingTracks[0].type;
	      } else {
	        event.type = 'combined';
	      }
	
	      this.emittedTracks += this.pendingTracks.length;
	      initSegment = mp4Generator.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
	
	      event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
	      // and track definitions
	
	      event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
	
	      event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
	
	      for (i = 0; i < this.pendingBoxes.length; i++) {
	        event.data.set(this.pendingBoxes[i], offset);
	        offset += this.pendingBoxes[i].byteLength;
	      } // Translate caption PTS times into second offsets to match the
	      // video timeline for the segment, and add track info
	
	
	      for (i = 0; i < this.pendingCaptions.length; i++) {
	        caption = this.pendingCaptions[i];
	        caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
	        caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
	        event.captionStreams[caption.stream] = true;
	        event.captions.push(caption);
	      } // Translate ID3 frame PTS times into second offsets to match the
	      // video timeline for the segment
	
	
	      for (i = 0; i < this.pendingMetadata.length; i++) {
	        id3 = this.pendingMetadata[i];
	        id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
	        event.metadata.push(id3);
	      } // We add this to every single emitted segment even though we only need
	      // it for the first
	
	
	      event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
	
	      this.pendingTracks.length = 0;
	      this.videoTrack = null;
	      this.pendingBoxes.length = 0;
	      this.pendingCaptions.length = 0;
	      this.pendingBytes = 0;
	      this.pendingMetadata.length = 0; // Emit the built segment
	      // We include captions and ID3 tags for backwards compatibility,
	      // ideally we should send only video and audio in the data event
	
	      this.trigger('data', event); // Emit each caption to the outside world
	      // Ideally, this would happen immediately on parsing captions,
	      // but we need to ensure that video data is sent back first
	      // so that caption timing can be adjusted to match video timing
	
	      for (i = 0; i < event.captions.length; i++) {
	        caption = event.captions[i];
	        this.trigger('caption', caption);
	      } // Emit each id3 tag to the outside world
	      // Ideally, this would happen immediately on parsing the tag,
	      // but we need to ensure that video data is sent back first
	      // so that ID3 frame timing can be adjusted to match video timing
	
	
	      for (i = 0; i < event.metadata.length; i++) {
	        id3 = event.metadata[i];
	        this.trigger('id3Frame', id3);
	      }
	    } // Only emit `done` if all tracks have been flushed and emitted
	
	
	    if (this.emittedTracks >= this.numberOfTracks) {
	      this.trigger('done');
	      this.emittedTracks = 0;
	    }
	  };
	
	  _CoalesceStream.prototype.setRemux = function (val) {
	    this.remuxTracks = val;
	  };
	  /**
	   * A Stream that expects MP2T binary data as input and produces
	   * corresponding media segments, suitable for use with Media Source
	   * Extension (MSE) implementations that support the ISO BMFF byte
	   * stream format, like Chrome.
	   */
	
	
	  _Transmuxer = function Transmuxer(options) {
	    var self = this,
	        hasFlushed = true,
	        videoTrack,
	        audioTrack;
	
	    _Transmuxer.prototype.init.call(this);
	
	    options = options || {};
	    this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	    this.transmuxPipeline_ = {};
	
	    this.setupAacPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'aac';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.aacStream = new aac();
	      pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('audio');
	      pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('timed-metadata');
	      pipeline.adtsStream = new adts();
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.aacStream;
	      pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	      pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	      pipeline.metadataStream.on('timestamp', function (frame) {
	        pipeline.aacStream.setTimestamp(frame.timeStamp);
	      });
	      pipeline.aacStream.on('data', function (data) {
	        if (data.type !== 'timed-metadata' && data.type !== 'audio' || pipeline.audioSegmentStream) {
	          return;
	        }
	
	        audioTrack = audioTrack || {
	          timelineStartInfo: {
	            baseMediaDecodeTime: self.baseMediaDecodeTime
	          },
	          codec: 'adts',
	          type: 'audio'
	        }; // hook up the audio segment stream to the first track with aac data
	
	        pipeline.coalesceStream.numberOfTracks++;
	        pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	        pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	        pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo')); // Set up the final part of the audio pipeline
	
	        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
	
	        self.trigger('trackinfo', {
	          hasAudio: !!audioTrack,
	          hasVideo: !!videoTrack
	        });
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    };
	
	    this.setupTsPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'ts';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.packetStream = new m2ts_1.TransportPacketStream();
	      pipeline.parseStream = new m2ts_1.TransportParseStream();
	      pipeline.elementaryStream = new m2ts_1.ElementaryStream();
	      pipeline.timestampRolloverStream = new m2ts_1.TimestampRolloverStream();
	      pipeline.adtsStream = new adts();
	      pipeline.h264Stream = new H264Stream();
	      pipeline.captionStream = new m2ts_1.CaptionStream(options);
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
	
	      pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
	      // demux the streams
	
	      pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
	      pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
	      pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
	
	      pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
	      pipeline.elementaryStream.on('data', function (data) {
	        var i;
	
	        if (data.type === 'metadata') {
	          i = data.tracks.length; // scan the tracks listed in the metadata
	
	          while (i--) {
	            if (!videoTrack && data.tracks[i].type === 'video') {
	              videoTrack = data.tracks[i];
	              videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            } else if (!audioTrack && data.tracks[i].type === 'audio') {
	              audioTrack = data.tracks[i];
	              audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            }
	          } // hook up the video segment stream to the first track with h264 data
	
	
	          if (videoTrack && !pipeline.videoSegmentStream) {
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack, options);
	            pipeline.videoSegmentStream.on('log', self.getLogTrigger_('videoSegmentStream'));
	            pipeline.videoSegmentStream.on('timelineStartInfo', function (timelineStartInfo) {
	              // When video emits timelineStartInfo data after a flush, we forward that
	              // info to the AudioSegmentStream, if it exists, because video timeline
	              // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
	              // because this is a particularly subtle form of timestamp alteration.
	              if (audioTrack && !options.keepOriginalTimestamps) {
	                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
	                // very earliest DTS we have seen in video because Chrome will
	                // interpret any video track with a baseMediaDecodeTime that is
	                // non-zero as a gap.
	
	                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self.baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('processedGopsInfo', self.trigger.bind(self, 'gopInfo'));
	            pipeline.videoSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'videoSegmentTimingInfo'));
	            pipeline.videoSegmentStream.on('baseMediaDecodeTime', function (baseMediaDecodeTime) {
	              if (audioTrack) {
	                pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('timingInfo', self.trigger.bind(self, 'videoTimingInfo')); // Set up the final part of the video pipeline
	
	            pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
	          }
	
	          if (audioTrack && !pipeline.audioSegmentStream) {
	            // hook up the audio segment stream to the first track with aac data
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	            pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	            pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo'));
	            pipeline.audioSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'audioSegmentTimingInfo')); // Set up the final part of the audio pipeline
	
	            pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	          } // emit pmt info
	
	
	          self.trigger('trackinfo', {
	            hasAudio: !!audioTrack,
	            hasVideo: !!videoTrack
	          });
	        }
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	      pipeline.coalesceStream.on('id3Frame', function (id3Frame) {
	        id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
	        self.trigger('id3Frame', id3Frame);
	      });
	      pipeline.coalesceStream.on('caption', this.trigger.bind(this, 'caption')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    }; // hook up the segment streams once track metadata is delivered
	
	
	    this.setBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      var pipeline = this.transmuxPipeline_;
	
	      if (!options.keepOriginalTimestamps) {
	        this.baseMediaDecodeTime = baseMediaDecodeTime;
	      }
	
	      if (audioTrack) {
	        audioTrack.timelineStartInfo.dts = undefined;
	        audioTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(audioTrack);
	
	        if (pipeline.audioTimestampRolloverStream) {
	          pipeline.audioTimestampRolloverStream.discontinuity();
	        }
	      }
	
	      if (videoTrack) {
	        if (pipeline.videoSegmentStream) {
	          pipeline.videoSegmentStream.gopCache_ = [];
	        }
	
	        videoTrack.timelineStartInfo.dts = undefined;
	        videoTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(videoTrack);
	        pipeline.captionStream.reset();
	      }
	
	      if (pipeline.timestampRolloverStream) {
	        pipeline.timestampRolloverStream.discontinuity();
	      }
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      if (audioTrack) {
	        this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	      }
	    };
	
	    this.setRemux = function (val) {
	      var pipeline = this.transmuxPipeline_;
	      options.remux = val;
	
	      if (pipeline && pipeline.coalesceStream) {
	        pipeline.coalesceStream.setRemux(val);
	      }
	    };
	
	    this.alignGopsWith = function (gopsToAlignWith) {
	      if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
	        this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
	      }
	    };
	
	    this.getLogTrigger_ = function (key) {
	      var self = this;
	      return function (event) {
	        event.stream = key;
	        self.trigger('log', event);
	      };
	    }; // feed incoming data to the front of the parsing pipeline
	
	
	    this.push = function (data) {
	      if (hasFlushed) {
	        var isAac = isLikelyAacData(data);
	
	        if (isAac && this.transmuxPipeline_.type !== 'aac') {
	          this.setupAacPipeline();
	        } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	          this.setupTsPipeline();
	        }
	
	        hasFlushed = false;
	      }
	
	      this.transmuxPipeline_.headOfPipeline.push(data);
	    }; // flush any buffered data
	
	
	    this.flush = function () {
	      hasFlushed = true; // Start at the top of the pipeline and flush all pending work
	
	      this.transmuxPipeline_.headOfPipeline.flush();
	    };
	
	    this.endTimeline = function () {
	      this.transmuxPipeline_.headOfPipeline.endTimeline();
	    };
	
	    this.reset = function () {
	      if (this.transmuxPipeline_.headOfPipeline) {
	        this.transmuxPipeline_.headOfPipeline.reset();
	      }
	    }; // Caption data has to be reset when seeking outside buffered range
	
	
	    this.resetCaptions = function () {
	      if (this.transmuxPipeline_.captionStream) {
	        this.transmuxPipeline_.captionStream.reset();
	      }
	    };
	  };
	
	  _Transmuxer.prototype = new stream();
	  var transmuxer = {
	    Transmuxer: _Transmuxer,
	    VideoSegmentStream: _VideoSegmentStream,
	    AudioSegmentStream: _AudioSegmentStream,
	    AUDIO_PROPERTIES: audioProperties,
	    VIDEO_PROPERTIES: videoProperties,
	    // exported for testing
	    generateSegmentTimingInfo: generateSegmentTimingInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var toUnsigned$3 = function toUnsigned(value) {
	    return value >>> 0;
	  };
	
	  var toHexString$1 = function toHexString(value) {
	    return ('00' + value.toString(16)).slice(-2);
	  };
	
	  var bin = {
	    toUnsigned: toUnsigned$3,
	    toHexString: toHexString$1
	  };
	
	  var parseType$1 = function parseType(buffer) {
	    var result = '';
	    result += String.fromCharCode(buffer[0]);
	    result += String.fromCharCode(buffer[1]);
	    result += String.fromCharCode(buffer[2]);
	    result += String.fromCharCode(buffer[3]);
	    return result;
	  };
	
	  var parseType_1 = parseType$1;
	  var toUnsigned$2 = bin.toUnsigned;
	
	  var findBox = function findBox(data, path) {
	    var results = [],
	        i,
	        size,
	        type,
	        end,
	        subresults;
	
	    if (!path.length) {
	      // short-circuit the search for empty paths
	      return null;
	    }
	
	    for (i = 0; i < data.byteLength;) {
	      size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
	      type = parseType_1(data.subarray(i + 4, i + 8));
	      end = size > 1 ? i + size : data.byteLength;
	
	      if (type === path[0]) {
	        if (path.length === 1) {
	          // this is the end of the path and we've found the box we were
	          // looking for
	          results.push(data.subarray(i + 8, end));
	        } else {
	          // recursively search for the next box along the path
	          subresults = findBox(data.subarray(i + 8, end), path.slice(1));
	
	          if (subresults.length) {
	            results = results.concat(subresults);
	          }
	        }
	      }
	
	      i = end;
	    } // we've finished searching all of data
	
	
	    return results;
	  };
	
	  var findBox_1 = findBox;
	  var toUnsigned$1 = bin.toUnsigned;
	  var getUint64$1 = numbers.getUint64;
	
	  var tfdt = function tfdt(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	
	    if (result.version === 1) {
	      result.baseMediaDecodeTime = getUint64$1(data.subarray(4));
	    } else {
	      result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
	    }
	
	    return result;
	  };
	
	  var parseTfdt = tfdt;
	
	  var parseSampleFlags = function parseSampleFlags(flags) {
	    return {
	      isLeading: (flags[0] & 0x0c) >>> 2,
	      dependsOn: flags[0] & 0x03,
	      isDependedOn: (flags[1] & 0xc0) >>> 6,
	      hasRedundancy: (flags[1] & 0x30) >>> 4,
	      paddingValue: (flags[1] & 0x0e) >>> 1,
	      isNonSyncSample: flags[1] & 0x01,
	      degradationPriority: flags[2] << 8 | flags[3]
	    };
	  };
	
	  var parseSampleFlags_1 = parseSampleFlags;
	
	  var trun = function trun(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      samples: []
	    },
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        // Flag interpretation
	    dataOffsetPresent = result.flags[2] & 0x01,
	        // compare with 2nd byte of 0x1
	    firstSampleFlagsPresent = result.flags[2] & 0x04,
	        // compare with 2nd byte of 0x4
	    sampleDurationPresent = result.flags[1] & 0x01,
	        // compare with 2nd byte of 0x100
	    sampleSizePresent = result.flags[1] & 0x02,
	        // compare with 2nd byte of 0x200
	    sampleFlagsPresent = result.flags[1] & 0x04,
	        // compare with 2nd byte of 0x400
	    sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08,
	        // compare with 2nd byte of 0x800
	    sampleCount = view.getUint32(4),
	        offset = 8,
	        sample;
	
	    if (dataOffsetPresent) {
	      // 32 bit signed integer
	      result.dataOffset = view.getInt32(offset);
	      offset += 4;
	    } // Overrides the flags for the first sample only. The order of
	    // optional values will be: duration, size, compositionTimeOffset
	
	
	    if (firstSampleFlagsPresent && sampleCount) {
	      sample = {
	        flags: parseSampleFlags_1(data.subarray(offset, offset + 4))
	      };
	      offset += 4;
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	      sampleCount--;
	    }
	
	    while (sampleCount--) {
	      sample = {};
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleFlagsPresent) {
	        sample.flags = parseSampleFlags_1(data.subarray(offset, offset + 4));
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	    }
	
	    return result;
	  };
	
	  var parseTrun = trun;
	
	  var tfhd = function tfhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      trackId: view.getUint32(4)
	    },
	        baseDataOffsetPresent = result.flags[2] & 0x01,
	        sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	        defaultSampleDurationPresent = result.flags[2] & 0x08,
	        defaultSampleSizePresent = result.flags[2] & 0x10,
	        defaultSampleFlagsPresent = result.flags[2] & 0x20,
	        durationIsEmpty = result.flags[0] & 0x010000,
	        defaultBaseIsMoof = result.flags[0] & 0x020000,
	        i;
	    i = 8;
	
	    if (baseDataOffsetPresent) {
	      i += 4; // truncate top 4 bytes
	      // FIXME: should we read the full 64 bits?
	
	      result.baseDataOffset = view.getUint32(12);
	      i += 4;
	    }
	
	    if (sampleDescriptionIndexPresent) {
	      result.sampleDescriptionIndex = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleDurationPresent) {
	      result.defaultSampleDuration = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleSizePresent) {
	      result.defaultSampleSize = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleFlagsPresent) {
	      result.defaultSampleFlags = view.getUint32(i);
	    }
	
	    if (durationIsEmpty) {
	      result.durationIsEmpty = true;
	    }
	
	    if (!baseDataOffsetPresent && defaultBaseIsMoof) {
	      result.baseDataOffsetIsMoof = true;
	    }
	
	    return result;
	  };
	
	  var parseTfhd = tfhd;
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	  var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
	  var CaptionStream = captionStream.CaptionStream;
	  /**
	    * Maps an offset in the mdat to a sample based on the the size of the samples.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Number} offset - The offset into the mdat
	    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
	    * @return {?Object} The matching sample, or null if no match was found.
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	  var mapToSample = function mapToSample(offset, samples) {
	    var approximateOffset = offset;
	
	    for (var i = 0; i < samples.length; i++) {
	      var sample = samples[i];
	
	      if (approximateOffset < sample.size) {
	        return sample;
	      }
	
	      approximateOffset -= sample.size;
	    }
	
	    return null;
	  };
	  /**
	    * Finds SEI nal units contained in a Media Data Box.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Uint8Array} avcStream - The bytes of the mdat
	    * @param {Object[]} samples - The samples parsed out by `parseSamples`
	    * @param {Number} trackId - The trackId of this video track
	    * @return {Object[]} seiNals - the parsed SEI NALUs found.
	    *   The contents of the seiNal should match what is expected by
	    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
	    *
	    * @see ISO-BMFF-12/2015, Section 8.1.1
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	   **/
	
	
	  var findSeiNals = function findSeiNals(avcStream, samples, trackId) {
	    var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	        result = {
	      logs: [],
	      seiNals: []
	    },
	        seiNal,
	        i,
	        length,
	        lastMatchedSample;
	
	    for (i = 0; i + 4 < avcStream.length; i += length) {
	      length = avcView.getUint32(i);
	      i += 4; // Bail if this doesn't appear to be an H264 stream
	
	      if (length <= 0) {
	        continue;
	      }
	
	      switch (avcStream[i] & 0x1F) {
	        case 0x06:
	          var data = avcStream.subarray(i + 1, i + 1 + length);
	          var matchingSample = mapToSample(i, samples);
	          seiNal = {
	            nalUnitType: 'sei_rbsp',
	            size: length,
	            data: data,
	            escapedRBSP: discardEmulationPreventionBytes(data),
	            trackId: trackId
	          };
	
	          if (matchingSample) {
	            seiNal.pts = matchingSample.pts;
	            seiNal.dts = matchingSample.dts;
	            lastMatchedSample = matchingSample;
	          } else if (lastMatchedSample) {
	            // If a matching sample cannot be found, use the last
	            // sample's values as they should be as close as possible
	            seiNal.pts = lastMatchedSample.pts;
	            seiNal.dts = lastMatchedSample.dts;
	          } else {
	            result.logs.push({
	              level: 'warn',
	              message: 'We\'ve encountered a nal unit without data at ' + i + ' for trackId ' + trackId + '. See mux.js#223.'
	            });
	            break;
	          }
	
	          result.seiNals.push(seiNal);
	          break;
	      }
	    }
	
	    return result;
	  };
	  /**
	    * Parses sample information out of Track Run Boxes and calculates
	    * the absolute presentation and decode timestamps of each sample.
	    *
	    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
	    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
	        @see ISO-BMFF-12/2015, Section 8.8.12
	    * @param {Object} tfhd - The parsed Track Fragment Header
	    *   @see inspect.parseTfhd
	    * @return {Object[]} the parsed samples
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	
	  var parseSamples = function parseSamples(truns, baseMediaDecodeTime, tfhd) {
	    var currentDts = baseMediaDecodeTime;
	    var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
	    var defaultSampleSize = tfhd.defaultSampleSize || 0;
	    var trackId = tfhd.trackId;
	    var allSamples = [];
	    truns.forEach(function (trun) {
	      // Note: We currently do not parse the sample table as well
	      // as the trun. It's possible some sources will require this.
	      // moov > trak > mdia > minf > stbl
	      var trackRun = parseTrun(trun);
	      var samples = trackRun.samples;
	      samples.forEach(function (sample) {
	        if (sample.duration === undefined) {
	          sample.duration = defaultSampleDuration;
	        }
	
	        if (sample.size === undefined) {
	          sample.size = defaultSampleSize;
	        }
	
	        sample.trackId = trackId;
	        sample.dts = currentDts;
	
	        if (sample.compositionTimeOffset === undefined) {
	          sample.compositionTimeOffset = 0;
	        }
	
	        if (typeof currentDts === 'bigint') {
	          sample.pts = currentDts + window_1.BigInt(sample.compositionTimeOffset);
	          currentDts += window_1.BigInt(sample.duration);
	        } else {
	          sample.pts = currentDts + sample.compositionTimeOffset;
	          currentDts += sample.duration;
	        }
	      });
	      allSamples = allSamples.concat(samples);
	    });
	    return allSamples;
	  };
	  /**
	    * Parses out caption nals from an FMP4 segment's video tracks.
	    *
	    * @param {Uint8Array} segment - The bytes of a single segment
	    * @param {Number} videoTrackId - The trackId of a video track in the segment
	    * @return {Object.<Number, Object[]>} A mapping of video trackId to
	    *   a list of seiNals found in that track
	   **/
	
	
	  var parseCaptionNals = function parseCaptionNals(segment, videoTrackId) {
	    // To get the samples
	    var trafs = findBox_1(segment, ['moof', 'traf']); // To get SEI NAL units
	
	    var mdats = findBox_1(segment, ['mdat']);
	    var captionNals = {};
	    var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
	
	    mdats.forEach(function (mdat, index) {
	      var matchingTraf = trafs[index];
	      mdatTrafPairs.push({
	        mdat: mdat,
	        traf: matchingTraf
	      });
	    });
	    mdatTrafPairs.forEach(function (pair) {
	      var mdat = pair.mdat;
	      var traf = pair.traf;
	      var tfhd = findBox_1(traf, ['tfhd']); // Exactly 1 tfhd per traf
	
	      var headerInfo = parseTfhd(tfhd[0]);
	      var trackId = headerInfo.trackId;
	      var tfdt = findBox_1(traf, ['tfdt']); // Either 0 or 1 tfdt per traf
	
	      var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt(tfdt[0]).baseMediaDecodeTime : 0;
	      var truns = findBox_1(traf, ['trun']);
	      var samples;
	      var result; // Only parse video data for the chosen video track
	
	      if (videoTrackId === trackId && truns.length > 0) {
	        samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
	        result = findSeiNals(mdat, samples, trackId);
	
	        if (!captionNals[trackId]) {
	          captionNals[trackId] = {
	            seiNals: [],
	            logs: []
	          };
	        }
	
	        captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
	        captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
	      }
	    });
	    return captionNals;
	  };
	  /**
	    * Parses out inband captions from an MP4 container and returns
	    * caption objects that can be used by WebVTT and the TextTrack API.
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
	    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
	    *
	    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	    * @param {Number} trackId - The id of the video track to parse
	    * @param {Number} timescale - The timescale for the video track from the init segment
	    *
	    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
	    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
	    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
	    * @return {String} parsedCaptions[].text - The visible content of the caption
	   **/
	
	
	  var parseEmbeddedCaptions = function parseEmbeddedCaptions(segment, trackId, timescale) {
	    var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	
	    if (trackId === null) {
	      return null;
	    }
	
	    captionNals = parseCaptionNals(segment, trackId);
	    var trackNals = captionNals[trackId] || {};
	    return {
	      seiNals: trackNals.seiNals,
	      logs: trackNals.logs,
	      timescale: timescale
	    };
	  };
	  /**
	    * Converts SEI NALUs into captions that can be used by video.js
	   **/
	
	
	  var CaptionParser = function CaptionParser() {
	    var isInitialized = false;
	    var captionStream; // Stores segments seen before trackId and timescale are set
	
	    var segmentCache; // Stores video track ID of the track being parsed
	
	    var trackId; // Stores the timescale of the track being parsed
	
	    var timescale; // Stores captions parsed so far
	
	    var parsedCaptions; // Stores whether we are receiving partial data or not
	
	    var parsingPartial;
	    /**
	      * A method to indicate whether a CaptionParser has been initalized
	      * @returns {Boolean}
	     **/
	
	    this.isInitialized = function () {
	      return isInitialized;
	    };
	    /**
	      * Initializes the underlying CaptionStream, SEI NAL parsing
	      * and management, and caption collection
	     **/
	
	
	    this.init = function (options) {
	      captionStream = new CaptionStream();
	      isInitialized = true;
	      parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
	
	      captionStream.on('data', function (event) {
	        // Convert to seconds in the source's timescale
	        event.startTime = event.startPts / timescale;
	        event.endTime = event.endPts / timescale;
	        parsedCaptions.captions.push(event);
	        parsedCaptions.captionStreams[event.stream] = true;
	      });
	      captionStream.on('log', function (log) {
	        parsedCaptions.logs.push(log);
	      });
	    };
	    /**
	      * Determines if a new video track will be selected
	      * or if the timescale changed
	      * @return {Boolean}
	     **/
	
	
	    this.isNewInit = function (videoTrackIds, timescales) {
	      if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === 'object' && Object.keys(timescales).length === 0) {
	        return false;
	      }
	
	      return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
	    };
	    /**
	      * Parses out SEI captions and interacts with underlying
	      * CaptionStream to return dispatched captions
	      *
	      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
	      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
	      * @see parseEmbeddedCaptions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.parse = function (segment, videoTrackIds, timescales) {
	      var parsedData;
	
	      if (!this.isInitialized()) {
	        return null; // This is not likely to be a video segment
	      } else if (!videoTrackIds || !timescales) {
	        return null;
	      } else if (this.isNewInit(videoTrackIds, timescales)) {
	        // Use the first video track only as there is no
	        // mechanism to switch to other video tracks
	        trackId = videoTrackIds[0];
	        timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
	        // data until we have one.
	        // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	      } else if (trackId === null || !timescale) {
	        segmentCache.push(segment);
	        return null;
	      } // Now that a timescale and trackId is set, parse cached segments
	
	
	      while (segmentCache.length > 0) {
	        var cachedSegment = segmentCache.shift();
	        this.parse(cachedSegment, videoTrackIds, timescales);
	      }
	
	      parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
	
	      if (parsedData && parsedData.logs) {
	        parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
	      }
	
	      if (parsedData === null || !parsedData.seiNals) {
	        if (parsedCaptions.logs.length) {
	          return {
	            logs: parsedCaptions.logs,
	            captions: [],
	            captionStreams: []
	          };
	        }
	
	        return null;
	      }
	
	      this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
	
	      this.flushStream();
	      return parsedCaptions;
	    };
	    /**
	      * Pushes SEI NALUs onto CaptionStream
	      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
	      * Assumes that `parseCaptionNals` has been called first
	      * @see m2ts/caption-stream.js
	      **/
	
	
	    this.pushNals = function (nals) {
	      if (!this.isInitialized() || !nals || nals.length === 0) {
	        return null;
	      }
	
	      nals.forEach(function (nal) {
	        captionStream.push(nal);
	      });
	    };
	    /**
	      * Flushes underlying CaptionStream to dispatch processed, displayable captions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.flushStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      if (!parsingPartial) {
	        captionStream.flush();
	      } else {
	        captionStream.partialFlush();
	      }
	    };
	    /**
	      * Reset caption buckets for new data
	     **/
	
	
	    this.clearParsedCaptions = function () {
	      parsedCaptions.captions = [];
	      parsedCaptions.captionStreams = {};
	      parsedCaptions.logs = [];
	    };
	    /**
	      * Resets underlying CaptionStream
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.resetCaptionStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      captionStream.reset();
	    };
	    /**
	      * Convenience method to clear all captions flushed from the
	      * CaptionStream and still being parsed
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.clearAllCaptions = function () {
	      this.clearParsedCaptions();
	      this.resetCaptionStream();
	    };
	    /**
	      * Reset caption parser
	     **/
	
	
	    this.reset = function () {
	      segmentCache = [];
	      trackId = null;
	      timescale = null;
	
	      if (!parsedCaptions) {
	        parsedCaptions = {
	          captions: [],
	          // CC1, CC2, CC3, CC4
	          captionStreams: {},
	          logs: []
	        };
	      } else {
	        this.clearParsedCaptions();
	      }
	
	      this.resetCaptionStream();
	    };
	
	    this.reset();
	  };
	
	  var captionParser = CaptionParser;
	  var toUnsigned = bin.toUnsigned;
	  var toHexString = bin.toHexString;
	  var getUint64 = numbers.getUint64;
	  var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader;
	  /**
	   * Parses an MP4 initialization segment and extracts the timescale
	   * values for any declared tracks. Timescale values indicate the
	   * number of clock ticks per second to assume for time-based values
	   * elsewhere in the MP4.
	   *
	   * To determine the start time of an MP4, you need two pieces of
	   * information: the timescale unit and the earliest base media decode
	   * time. Multiple timescales can be specified within an MP4 but the
	   * base media decode time is always expressed in the timescale from
	   * the media header box for the track:
	   * ```
	   * moov > trak > mdia > mdhd.timescale
	   * ```
	   * @param init {Uint8Array} the bytes of the init segment
	   * @return {object} a hash of track ids to timescale values or null if
	   * the init segment is malformed.
	   */
	
	  timescale = function timescale(init) {
	    var result = {},
	        traks = findBox_1(init, ['moov', 'trak']); // mdhd timescale
	
	    return traks.reduce(function (result, trak) {
	      var tkhd, version, index, id, mdhd;
	      tkhd = findBox_1(trak, ['tkhd'])[0];
	
	      if (!tkhd) {
	        return null;
	      }
	
	      version = tkhd[0];
	      index = version === 0 ? 12 : 20;
	      id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
	      mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (!mdhd) {
	        return null;
	      }
	
	      version = mdhd[0];
	      index = version === 0 ? 12 : 20;
	      result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	      return result;
	    }, result);
	  };
	  /**
	   * Determine the base media decode start time, in seconds, for an MP4
	   * fragment. If multiple fragments are specified, the earliest time is
	   * returned.
	   *
	   * The base media decode time can be parsed from track fragment
	   * metadata:
	   * ```
	   * moof > traf > tfdt.baseMediaDecodeTime
	   * ```
	   * It requires the timescale value from the mdhd to interpret.
	   *
	   * @param timescale {object} a hash of track ids to timescale values.
	   * @return {number} the earliest base media decode start time for the
	   * fragment, in seconds
	   */
	
	
	  startTime = function startTime(timescale, fragment) {
	    var trafs; // we need info from two childrend of each track fragment box
	
	    trafs = findBox_1(fragment, ['moof', 'traf']); // determine the start times for each track
	
	    var lowestTime = trafs.reduce(function (acc, traf) {
	      var tfhd = findBox_1(traf, ['tfhd'])[0]; // get the track id from the tfhd
	
	      var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
	
	      var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
	
	      var tfdt = findBox_1(traf, ['tfdt'])[0];
	      var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
	      var baseTime; // version 1 is 64 bit
	
	      if (tfdt[0] === 1) {
	        baseTime = getUint64(tfdt.subarray(4, 12));
	      } else {
	        baseTime = dv.getUint32(4);
	      } // convert base time to seconds if it is a valid number.
	
	
	      var seconds;
	
	      if (typeof baseTime === 'bigint') {
	        seconds = baseTime / window_1.BigInt(scale);
	      } else if (typeof baseTime === 'number' && !isNaN(baseTime)) {
	        seconds = baseTime / scale;
	      }
	
	      if (seconds < Number.MAX_SAFE_INTEGER) {
	        seconds = Number(seconds);
	      }
	
	      if (seconds < acc) {
	        acc = seconds;
	      }
	
	      return acc;
	    }, Infinity);
	    return typeof lowestTime === 'bigint' || isFinite(lowestTime) ? lowestTime : 0;
	  };
	  /**
	   * Determine the composition start, in seconds, for an MP4
	   * fragment.
	   *
	   * The composition start time of a fragment can be calculated using the base
	   * media decode time, composition time offset, and timescale, as follows:
	   *
	   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
	   *
	   * All of the aforementioned information is contained within a media fragment's
	   * `traf` box, except for timescale info, which comes from the initialization
	   * segment, so a track id (also contained within a `traf`) is also necessary to
	   * associate it with a timescale
	   *
	   *
	   * @param timescales {object} - a hash of track ids to timescale values.
	   * @param fragment {Unit8Array} - the bytes of a media segment
	   * @return {number} the composition start time for the fragment, in seconds
	   **/
	
	
	  compositionStartTime = function compositionStartTime(timescales, fragment) {
	    var trafBoxes = findBox_1(fragment, ['moof', 'traf']);
	    var baseMediaDecodeTime = 0;
	    var compositionTimeOffset = 0;
	    var trackId;
	
	    if (trafBoxes && trafBoxes.length) {
	      // The spec states that track run samples contained within a `traf` box are contiguous, but
	      // it does not explicitly state whether the `traf` boxes themselves are contiguous.
	      // We will assume that they are, so we only need the first to calculate start time.
	      var tfhd = findBox_1(trafBoxes[0], ['tfhd'])[0];
	      var trun = findBox_1(trafBoxes[0], ['trun'])[0];
	      var tfdt = findBox_1(trafBoxes[0], ['tfdt'])[0];
	
	      if (tfhd) {
	        var parsedTfhd = parseTfhd(tfhd);
	        trackId = parsedTfhd.trackId;
	      }
	
	      if (tfdt) {
	        var parsedTfdt = parseTfdt(tfdt);
	        baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
	      }
	
	      if (trun) {
	        var parsedTrun = parseTrun(trun);
	
	        if (parsedTrun.samples && parsedTrun.samples.length) {
	          compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
	        }
	      }
	    } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
	    // specified.
	
	
	    var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
	
	    if (typeof baseMediaDecodeTime === 'bigint') {
	      compositionTimeOffset = window_1.BigInt(compositionTimeOffset);
	      timescale = window_1.BigInt(timescale);
	    }
	
	    var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
	
	    if (typeof result === 'bigint' && result < Number.MAX_SAFE_INTEGER) {
	      result = Number(result);
	    }
	
	    return result;
	  };
	  /**
	    * Find the trackIds of the video tracks in this source.
	    * Found by parsing the Handler Reference and Track Header Boxes:
	    *   moov > trak > mdia > hdlr
	    *   moov > trak > tkhd
	    *
	    * @param {Uint8Array} init - The bytes of the init segment for this source
	    * @return {Number[]} A list of trackIds
	    *
	    * @see ISO-BMFF-12/2015, Section 8.4.3
	   **/
	
	
	  getVideoTrackIds = function getVideoTrackIds(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var videoTrackIds = [];
	    traks.forEach(function (trak) {
	      var hdlrs = findBox_1(trak, ['mdia', 'hdlr']);
	      var tkhds = findBox_1(trak, ['tkhd']);
	      hdlrs.forEach(function (hdlr, index) {
	        var handlerType = parseType_1(hdlr.subarray(8, 12));
	        var tkhd = tkhds[index];
	        var view;
	        var version;
	        var trackId;
	
	        if (handlerType === 'vide') {
	          view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	          version = view.getUint8(0);
	          trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
	          videoTrackIds.push(trackId);
	        }
	      });
	    });
	    return videoTrackIds;
	  };
	
	  getTimescaleFromMediaHeader = function getTimescaleFromMediaHeader(mdhd) {
	    // mdhd is a FullBox, meaning it will have its own version as the first byte
	    var version = mdhd[0];
	    var index = version === 0 ? 12 : 20;
	    return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	  };
	  /**
	   * Get all the video, audio, and hint tracks from a non fragmented
	   * mp4 segment
	   */
	
	
	  getTracks = function getTracks(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var tracks = [];
	    traks.forEach(function (trak) {
	      var track = {};
	      var tkhd = findBox_1(trak, ['tkhd'])[0];
	      var view, tkhdVersion; // id
	
	      if (tkhd) {
	        view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	        tkhdVersion = view.getUint8(0);
	        track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	      }
	
	      var hdlr = findBox_1(trak, ['mdia', 'hdlr'])[0]; // type
	
	      if (hdlr) {
	        var type = parseType_1(hdlr.subarray(8, 12));
	
	        if (type === 'vide') {
	          track.type = 'video';
	        } else if (type === 'soun') {
	          track.type = 'audio';
	        } else {
	          track.type = type;
	        }
	      } // codec
	
	
	      var stsd = findBox_1(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
	
	      if (stsd) {
	        var sampleDescriptions = stsd.subarray(8); // gives the codec type string
	
	        track.codec = parseType_1(sampleDescriptions.subarray(4, 8));
	        var codecBox = findBox_1(sampleDescriptions, [track.codec])[0];
	        var codecConfig, codecConfigType;
	
	        if (codecBox) {
	          // https://tools.ietf.org/html/rfc6381#section-3.3
	          if (/^[asm]vc[1-9]$/i.test(track.codec)) {
	            // we don't need anything but the "config" parameter of the
	            // avc1 codecBox
	            codecConfig = codecBox.subarray(78);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'avcC' && codecConfig.length > 11) {
	              track.codec += '.'; // left padded with zeroes for single digit hex
	              // profile idc
	
	              track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
	
	              track.codec += toHexString(codecConfig[10]); // level idc
	
	              track.codec += toHexString(codecConfig[11]);
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'avc1.4d400d';
	            }
	          } else if (/^mp4[a,v]$/i.test(track.codec)) {
	            // we do not need anything but the streamDescriptor of the mp4a codecBox
	            codecConfig = codecBox.subarray(28);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'esds' && codecConfig.length > 20 && codecConfig[19] !== 0) {
	              track.codec += '.' + toHexString(codecConfig[19]); // this value is only a single digit
	
	              track.codec += '.' + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, '');
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'mp4a.40.2';
	            }
	          } else {
	            // flac, opus, etc
	            track.codec = track.codec.toLowerCase();
	          }
	        }
	      }
	
	      var mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (mdhd) {
	        track.timescale = getTimescaleFromMediaHeader(mdhd);
	      }
	
	      tracks.push(track);
	    });
	    return tracks;
	  };
	
	  var probe$2 = {
	    // export mp4 inspector's findBox and parseType for backwards compatibility
	    findBox: findBox_1,
	    parseType: parseType_1,
	    timescale: timescale,
	    startTime: startTime,
	    compositionStartTime: compositionStartTime,
	    videoTrackIds: getVideoTrackIds,
	    tracks: getTracks,
	    getTimescaleFromMediaHeader: getTimescaleFromMediaHeader
	  };
	
	  var parsePid = function parsePid(packet) {
	    var pid = packet[1] & 0x1f;
	    pid <<= 8;
	    pid |= packet[2];
	    return pid;
	  };
	
	  var parsePayloadUnitStartIndicator = function parsePayloadUnitStartIndicator(packet) {
	    return !!(packet[1] & 0x40);
	  };
	
	  var parseAdaptionField = function parseAdaptionField(packet) {
	    var offset = 0; // if an adaption field is present, its length is specified by the
	    // fifth byte of the TS packet header. The adaptation field is
	    // used to add stuffing to PES packets that don't fill a complete
	    // TS packet, and to specify some forms of timing and control data
	    // that we do not currently use.
	
	    if ((packet[3] & 0x30) >>> 4 > 0x01) {
	      offset += packet[4] + 1;
	    }
	
	    return offset;
	  };
	
	  var parseType = function parseType(packet, pmtPid) {
	    var pid = parsePid(packet);
	
	    if (pid === 0) {
	      return 'pat';
	    } else if (pid === pmtPid) {
	      return 'pmt';
	    } else if (pmtPid) {
	      return 'pes';
	    }
	
	    return null;
	  };
	
	  var parsePat = function parsePat(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      offset += packet[offset] + 1;
	    }
	
	    return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
	  };
	
	  var parsePmt = function parsePmt(packet) {
	    var programMapTable = {};
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var payloadOffset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      payloadOffset += packet[payloadOffset] + 1;
	    } // PMTs can be sent ahead of the time when they should actually
	    // take effect. We don't believe this should ever be the case
	    // for HLS but we'll ignore "forward" PMT declarations if we see
	    // them. Future PMT declarations have the current_next_indicator
	    // set to zero.
	
	
	    if (!(packet[payloadOffset + 5] & 0x01)) {
	      return;
	    }
	
	    var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
	
	    sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
	    tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	
	    programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
	
	    var offset = 12 + programInfoLength;
	
	    while (offset < tableEnd) {
	      var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
	
	      programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	
	      offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
	    }
	
	    return programMapTable;
	  };
	
	  var parsePesType = function parsePesType(packet, programMapTable) {
	    var pid = parsePid(packet);
	    var type = programMapTable[pid];
	
	    switch (type) {
	      case streamTypes.H264_STREAM_TYPE:
	        return 'video';
	
	      case streamTypes.ADTS_STREAM_TYPE:
	        return 'audio';
	
	      case streamTypes.METADATA_STREAM_TYPE:
	        return 'timed-metadata';
	
	      default:
	        return null;
	    }
	  };
	
	  var parsePesTime = function parsePesTime(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	
	    if (!pusi) {
	      return null;
	    }
	
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (offset >= packet.byteLength) {
	      // From the H 222.0 MPEG-TS spec
	      // "For transport stream packets carrying PES packets, stuffing is needed when there
	      //  is insufficient PES packet data to completely fill the transport stream packet
	      //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
	      //  the sum of the lengths of the data elements in it, so that the payload bytes
	      //  remaining after the adaptation field exactly accommodates the available PES packet
	      //  data."
	      //
	      // If the offset is >= the length of the packet, then the packet contains no data
	      // and instead is just adaption field stuffing bytes
	      return null;
	    }
	
	    var pes = null;
	    var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
	    // and a DTS value. Determine what combination of values is
	    // available to work with.
	
	    ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	    // performs all bitwise operations on 32-bit integers but javascript
	    // supports a much greater range (52-bits) of integer using standard
	    // mathematical operations.
	    // We construct a 31-bit value using bitwise operators over the 31
	    // most significant bits and then multiply by 4 (equal to a left-shift
	    // of 2) before we add the final 2 least significant bits of the
	    // timestamp (equal to an OR.)
	
	    if (ptsDtsFlags & 0xC0) {
	      pes = {}; // the PTS and DTS are not written out directly. For information
	      // on how they are encoded, see
	      // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	
	      pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
	      pes.pts *= 4; // Left shift by 2
	
	      pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
	
	      pes.dts = pes.pts;
	
	      if (ptsDtsFlags & 0x40) {
	        pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
	        pes.dts *= 4; // Left shift by 2
	
	        pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
	      }
	    }
	
	    return pes;
	  };
	
	  var parseNalUnitType = function parseNalUnitType(type) {
	    switch (type) {
	      case 0x05:
	        return 'slice_layer_without_partitioning_rbsp_idr';
	
	      case 0x06:
	        return 'sei_rbsp';
	
	      case 0x07:
	        return 'seq_parameter_set_rbsp';
	
	      case 0x08:
	        return 'pic_parameter_set_rbsp';
	
	      case 0x09:
	        return 'access_unit_delimiter_rbsp';
	
	      default:
	        return null;
	    }
	  };
	
	  var videoPacketContainsKeyFrame = function videoPacketContainsKeyFrame(packet) {
	    var offset = 4 + parseAdaptionField(packet);
	    var frameBuffer = packet.subarray(offset);
	    var frameI = 0;
	    var frameSyncPoint = 0;
	    var foundKeyFrame = false;
	    var nalType; // advance the sync point to a NAL start, if necessary
	
	    for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
	      if (frameBuffer[frameSyncPoint + 2] === 1) {
	        // the sync point is properly aligned
	        frameI = frameSyncPoint + 5;
	        break;
	      }
	    }
	
	    while (frameI < frameBuffer.byteLength) {
	      // look at the current byte to determine if we've hit the end of
	      // a NAL unit boundary
	      switch (frameBuffer[frameI]) {
	        case 0:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0) {
	            frameI += 2;
	            break;
	          } else if (frameBuffer[frameI - 2] !== 0) {
	            frameI++;
	            break;
	          }
	
	          if (frameSyncPoint + 3 !== frameI - 2) {
	            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	            if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	              foundKeyFrame = true;
	            }
	          } // drop trailing zeroes
	
	
	          do {
	            frameI++;
	          } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        case 1:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
	            frameI += 3;
	            break;
	          }
	
	          nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	          if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	            foundKeyFrame = true;
	          }
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        default:
	          // the current byte isn't a one or zero, so it cannot be part
	          // of a sync sequence
	          frameI += 3;
	          break;
	      }
	    }
	
	    frameBuffer = frameBuffer.subarray(frameSyncPoint);
	    frameI -= frameSyncPoint;
	    frameSyncPoint = 0; // parse the final nal
	
	    if (frameBuffer && frameBuffer.byteLength > 3) {
	      nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	      if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	        foundKeyFrame = true;
	      }
	    }
	
	    return foundKeyFrame;
	  };
	
	  var probe$1 = {
	    parseType: parseType,
	    parsePat: parsePat,
	    parsePmt: parsePmt,
	    parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
	    parsePesType: parsePesType,
	    parsePesTime: parsePesTime,
	    videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
	  };
	  var handleRollover = timestampRolloverStream.handleRollover;
	  var probe = {};
	  probe.ts = probe$1;
	  probe.aac = utils;
	  var ONE_SECOND_IN_TS = clock.ONE_SECOND_IN_TS;
	  var MP2T_PACKET_LENGTH = 188,
	      // bytes
	  SYNC_BYTE = 0x47;
	  /**
	   * walks through segment data looking for pat and pmt packets to parse out
	   * program map table information
	   */
	
	  var parsePsi_ = function parsePsi_(bytes, pmt) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type;
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pat':
	            pmt.pid = probe.ts.parsePat(packet);
	            break;
	
	          case 'pmt':
	            var table = probe.ts.parsePmt(packet);
	            pmt.table = pmt.table || {};
	            Object.keys(table).forEach(function (key) {
	              pmt.table[key] = table[key];
	            });
	            break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last audio pes packets
	   */
	
	
	  var parseAudioPes_ = function parseAudioPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed;
	    var endLoop = false; // Start walking from start of segment to get first audio packet
	
	    while (endIndex <= bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last audio packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last video pes packets as well as timing information for the first
	   * key frame.
	   */
	
	
	  var parseVideoPes_ = function parseVideoPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed,
	        frame,
	        i,
	        pes;
	    var endLoop = false;
	    var currentFrame = {
	      data: [],
	      size: 0
	    }; // Start walking from start of segment to get first video packet
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video') {
	              if (pusi && !endLoop) {
	                parsed = probe.ts.parsePesTime(packet);
	
	                if (parsed) {
	                  parsed.type = 'video';
	                  result.video.push(parsed);
	                  endLoop = true;
	                }
	              }
	
	              if (!result.firstKeyFrame) {
	                if (pusi) {
	                  if (currentFrame.size !== 0) {
	                    frame = new Uint8Array(currentFrame.size);
	                    i = 0;
	
	                    while (currentFrame.data.length) {
	                      pes = currentFrame.data.shift();
	                      frame.set(pes, i);
	                      i += pes.byteLength;
	                    }
	
	                    if (probe.ts.videoPacketContainsKeyFrame(frame)) {
	                      var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
	                      // the keyframe seems to work fine with HLS playback
	                      // and definitely preferable to a crash with TypeError...
	
	                      if (firstKeyFrame) {
	                        result.firstKeyFrame = firstKeyFrame;
	                        result.firstKeyFrame.type = 'video';
	                      } else {
	                        // eslint-disable-next-line
	                        console.warn('Failed to extract PTS/DTS from PES at first keyframe. ' + 'This could be an unusual TS segment, or else mux.js did not ' + 'parse your TS segment correctly. If you know your TS ' + 'segments do contain PTS/DTS on keyframes please file a bug ' + 'report! You can try ffprobe to double check for yourself.');
	                      }
	                    }
	
	                    currentFrame.size = 0;
	                  }
	                }
	
	                currentFrame.data.push(packet);
	                currentFrame.size += packet.byteLength;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop && result.firstKeyFrame) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last video packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'video';
	                result.video.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * Adjusts the timestamp information for the segment to account for
	   * rollover and convert to seconds based on pes packet timescale (90khz clock)
	   */
	
	
	  var adjustTimestamp_ = function adjustTimestamp_(segmentInfo, baseTimestamp) {
	    if (segmentInfo.audio && segmentInfo.audio.length) {
	      var audioBaseTimestamp = baseTimestamp;
	
	      if (typeof audioBaseTimestamp === 'undefined' || isNaN(audioBaseTimestamp)) {
	        audioBaseTimestamp = segmentInfo.audio[0].dts;
	      }
	
	      segmentInfo.audio.forEach(function (info) {
	        info.dts = handleRollover(info.dts, audioBaseTimestamp);
	        info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	    }
	
	    if (segmentInfo.video && segmentInfo.video.length) {
	      var videoBaseTimestamp = baseTimestamp;
	
	      if (typeof videoBaseTimestamp === 'undefined' || isNaN(videoBaseTimestamp)) {
	        videoBaseTimestamp = segmentInfo.video[0].dts;
	      }
	
	      segmentInfo.video.forEach(function (info) {
	        info.dts = handleRollover(info.dts, videoBaseTimestamp);
	        info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	
	      if (segmentInfo.firstKeyFrame) {
	        var frame = segmentInfo.firstKeyFrame;
	        frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
	        frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
	
	        frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
	        frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
	      }
	    }
	  };
	  /**
	   * inspects the aac data stream for start and end time information
	   */
	
	
	  var inspectAac_ = function inspectAac_(bytes) {
	    var endLoop = false,
	        audioCount = 0,
	        sampleRate = null,
	        timestamp = null,
	        frameSize = 0,
	        byteIndex = 0,
	        packet;
	
	    while (bytes.length - byteIndex >= 3) {
	      var type = probe.aac.parseType(bytes, byteIndex);
	
	      switch (type) {
	        case 'timed-metadata':
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (bytes.length - byteIndex < 10) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (timestamp === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            timestamp = probe.aac.parseAacTimestamp(packet);
	          }
	
	          byteIndex += frameSize;
	          break;
	
	        case 'audio':
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (bytes.length - byteIndex < 7) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (sampleRate === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            sampleRate = probe.aac.parseSampleRate(packet);
	          }
	
	          audioCount++;
	          byteIndex += frameSize;
	          break;
	
	        default:
	          byteIndex++;
	          break;
	      }
	
	      if (endLoop) {
	        return null;
	      }
	    }
	
	    if (sampleRate === null || timestamp === null) {
	      return null;
	    }
	
	    var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
	    var result = {
	      audio: [{
	        type: 'audio',
	        dts: timestamp,
	        pts: timestamp
	      }, {
	        type: 'audio',
	        dts: timestamp + audioCount * 1024 * audioTimescale,
	        pts: timestamp + audioCount * 1024 * audioTimescale
	      }]
	    };
	    return result;
	  };
	  /**
	   * inspects the transport stream segment data for start and end time information
	   * of the audio and video tracks (when present) as well as the first key frame's
	   * start time.
	   */
	
	
	  var inspectTs_ = function inspectTs_(bytes) {
	    var pmt = {
	      pid: null,
	      table: null
	    };
	    var result = {};
	    parsePsi_(bytes, pmt);
	
	    for (var pid in pmt.table) {
	      if (pmt.table.hasOwnProperty(pid)) {
	        var type = pmt.table[pid];
	
	        switch (type) {
	          case streamTypes.H264_STREAM_TYPE:
	            result.video = [];
	            parseVideoPes_(bytes, pmt, result);
	
	            if (result.video.length === 0) {
	              delete result.video;
	            }
	
	            break;
	
	          case streamTypes.ADTS_STREAM_TYPE:
	            result.audio = [];
	            parseAudioPes_(bytes, pmt, result);
	
	            if (result.audio.length === 0) {
	              delete result.audio;
	            }
	
	            break;
	        }
	      }
	    }
	
	    return result;
	  };
	  /**
	   * Inspects segment byte data and returns an object with start and end timing information
	   *
	   * @param {Uint8Array} bytes The segment byte data
	   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
	   *  timestamps for rollover. This value must be in 90khz clock.
	   * @return {Object} Object containing start and end frame timing info of segment.
	   */
	
	
	  var inspect = function inspect(bytes, baseTimestamp) {
	    var isAacData = probe.aac.isLikelyAacData(bytes);
	    var result;
	
	    if (isAacData) {
	      result = inspectAac_(bytes);
	    } else {
	      result = inspectTs_(bytes);
	    }
	
	    if (!result || !result.audio && !result.video) {
	      return null;
	    }
	
	    adjustTimestamp_(result, baseTimestamp);
	    return result;
	  };
	
	  var tsInspector = {
	    inspect: inspect,
	    parseAudioPes_: parseAudioPes_
	  };
	  /* global self */
	
	  /**
	   * Re-emits transmuxer events by converting them into messages to the
	   * world outside the worker.
	   *
	   * @param {Object} transmuxer the transmuxer to wire events on
	   * @private
	   */
	
	  var wireTransmuxerEvents = function wireTransmuxerEvents(self, transmuxer) {
	    transmuxer.on('data', function (segment) {
	      // transfer ownership of the underlying ArrayBuffer
	      // instead of doing a copy to save memory
	      // ArrayBuffers are transferable but generic TypedArrays are not
	      // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
	      var initArray = segment.initSegment;
	      segment.initSegment = {
	        data: initArray.buffer,
	        byteOffset: initArray.byteOffset,
	        byteLength: initArray.byteLength
	      };
	      var typedArray = segment.data;
	      segment.data = typedArray.buffer;
	      self.postMessage({
	        action: 'data',
	        segment: segment,
	        byteOffset: typedArray.byteOffset,
	        byteLength: typedArray.byteLength
	      }, [segment.data]);
	    });
	    transmuxer.on('done', function (data) {
	      self.postMessage({
	        action: 'done'
	      });
	    });
	    transmuxer.on('gopInfo', function (gopInfo) {
	      self.postMessage({
	        action: 'gopInfo',
	        gopInfo: gopInfo
	      });
	    });
	    transmuxer.on('videoSegmentTimingInfo', function (timingInfo) {
	      var videoSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        videoSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'videoSegmentTimingInfo',
	        videoSegmentTimingInfo: videoSegmentTimingInfo
	      });
	    });
	    transmuxer.on('audioSegmentTimingInfo', function (timingInfo) {
	      // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
	      var audioSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        audioSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'audioSegmentTimingInfo',
	        audioSegmentTimingInfo: audioSegmentTimingInfo
	      });
	    });
	    transmuxer.on('id3Frame', function (id3Frame) {
	      self.postMessage({
	        action: 'id3Frame',
	        id3Frame: id3Frame
	      });
	    });
	    transmuxer.on('caption', function (caption) {
	      self.postMessage({
	        action: 'caption',
	        caption: caption
	      });
	    });
	    transmuxer.on('trackinfo', function (trackInfo) {
	      self.postMessage({
	        action: 'trackinfo',
	        trackInfo: trackInfo
	      });
	    });
	    transmuxer.on('audioTimingInfo', function (audioTimingInfo) {
	      // convert to video TS since we prioritize video time over audio
	      self.postMessage({
	        action: 'audioTimingInfo',
	        audioTimingInfo: {
	          start: clock.videoTsToSeconds(audioTimingInfo.start),
	          end: clock.videoTsToSeconds(audioTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('videoTimingInfo', function (videoTimingInfo) {
	      self.postMessage({
	        action: 'videoTimingInfo',
	        videoTimingInfo: {
	          start: clock.videoTsToSeconds(videoTimingInfo.start),
	          end: clock.videoTsToSeconds(videoTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('log', function (log) {
	      self.postMessage({
	        action: 'log',
	        log: log
	      });
	    });
	  };
	  /**
	   * All incoming messages route through this hash. If no function exists
	   * to handle an incoming message, then we ignore the message.
	   *
	   * @class MessageHandlers
	   * @param {Object} options the options to initialize with
	   */
	
	
	  var MessageHandlers = /*#__PURE__*/function () {
	    function MessageHandlers(self, options) {
	      this.options = options || {};
	      this.self = self;
	      this.init();
	    }
	    /**
	     * initialize our web worker and wire all the events.
	     */
	
	
	    var _proto = MessageHandlers.prototype;
	
	    _proto.init = function init() {
	      if (this.transmuxer) {
	        this.transmuxer.dispose();
	      }
	
	      this.transmuxer = new transmuxer.Transmuxer(this.options);
	      wireTransmuxerEvents(this.self, this.transmuxer);
	    };
	
	    _proto.pushMp4Captions = function pushMp4Captions(data) {
	      if (!this.captionParser) {
	        this.captionParser = new captionParser();
	        this.captionParser.init();
	      }
	
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      var parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
	      this.self.postMessage({
	        action: 'mp4Captions',
	        captions: parsed && parsed.captions || [],
	        logs: parsed && parsed.logs || [],
	        data: segment.buffer
	      }, [segment.buffer]);
	    };
	
	    _proto.probeMp4StartTime = function probeMp4StartTime(_ref) {
	      var timescales = _ref.timescales,
	          data = _ref.data;
	      var startTime = probe$2.startTime(timescales, data);
	      this.self.postMessage({
	        action: 'probeMp4StartTime',
	        startTime: startTime,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.probeMp4Tracks = function probeMp4Tracks(_ref2) {
	      var data = _ref2.data;
	      var tracks = probe$2.tracks(data);
	      this.self.postMessage({
	        action: 'probeMp4Tracks',
	        tracks: tracks,
	        data: data
	      }, [data.buffer]);
	    }
	    /**
	     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
	     * internal "media time," as well as whether it contains video and/or audio.
	     *
	     * @private
	     * @param {Uint8Array} bytes - segment bytes
	     * @param {number} baseStartTime
	     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
	     *        This value should be in seconds, as it's converted to a 90khz clock within the
	     *        function body.
	     * @return {Object} The start time of the current segment in "media time" as well as
	     *                  whether it contains video and/or audio
	     */
	    ;
	
	    _proto.probeTs = function probeTs(_ref3) {
	      var data = _ref3.data,
	          baseStartTime = _ref3.baseStartTime;
	      var tsStartTime = typeof baseStartTime === 'number' && !isNaN(baseStartTime) ? baseStartTime * clock.ONE_SECOND_IN_TS : void 0;
	      var timeInfo = tsInspector.inspect(data, tsStartTime);
	      var result = null;
	
	      if (timeInfo) {
	        result = {
	          // each type's time info comes back as an array of 2 times, start and end
	          hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
	          hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
	        };
	
	        if (result.hasVideo) {
	          result.videoStart = timeInfo.video[0].ptsTime;
	        }
	
	        if (result.hasAudio) {
	          result.audioStart = timeInfo.audio[0].ptsTime;
	        }
	      }
	
	      this.self.postMessage({
	        action: 'probeTs',
	        result: result,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.clearAllMp4Captions = function clearAllMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearAllCaptions();
	      }
	    };
	
	    _proto.clearParsedMp4Captions = function clearParsedMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearParsedCaptions();
	      }
	    }
	    /**
	     * Adds data (a ts segment) to the start of the transmuxer pipeline for
	     * processing.
	     *
	     * @param {ArrayBuffer} data data to push into the muxer
	     */
	    ;
	
	    _proto.push = function push(data) {
	      // Cast array buffer to correct type for transmuxer
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      this.transmuxer.push(segment);
	    }
	    /**
	     * Recreate the transmuxer so that the next segment added via `push`
	     * start with a fresh transmuxer.
	     */
	    ;
	
	    _proto.reset = function reset() {
	      this.transmuxer.reset();
	    }
	    /**
	     * Set the value that will be used as the `baseMediaDecodeTime` time for the
	     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
	     * set relative to the first based on the PTS values.
	     *
	     * @param {Object} data used to set the timestamp offset in the muxer
	     */
	    ;
	
	    _proto.setTimestampOffset = function setTimestampOffset(data) {
	      var timestampOffset = data.timestampOffset || 0;
	      this.transmuxer.setBaseMediaDecodeTime(Math.round(clock.secondsToVideoTs(timestampOffset)));
	    };
	
	    _proto.setAudioAppendStart = function setAudioAppendStart(data) {
	      this.transmuxer.setAudioAppendStart(Math.ceil(clock.secondsToVideoTs(data.appendStart)));
	    };
	
	    _proto.setRemux = function setRemux(data) {
	      this.transmuxer.setRemux(data.remux);
	    }
	    /**
	     * Forces the pipeline to finish processing the last segment and emit it's
	     * results.
	     *
	     * @param {Object} data event data, not really used
	     */
	    ;
	
	    _proto.flush = function flush(data) {
	      this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
	
	      self.postMessage({
	        action: 'done',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.endTimeline = function endTimeline() {
	      this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
	      // timelines
	
	      self.postMessage({
	        action: 'endedtimeline',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.alignGopsWith = function alignGopsWith(data) {
	      this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
	    };
	
	    return MessageHandlers;
	  }();
	  /**
	   * Our web worker interface so that things can talk to mux.js
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   *
	   * @param {Object} self the scope for the web worker
	   */
	
	
	  self.onmessage = function (event) {
	    if (event.data.action === 'init' && event.data.options) {
	      this.messageHandlers = new MessageHandlers(self, event.data.options);
	      return;
	    }
	
	    if (!this.messageHandlers) {
	      this.messageHandlers = new MessageHandlers(self);
	    }
	
	    if (event.data && event.data.action && event.data.action !== 'init') {
	      if (this.messageHandlers[event.data.action]) {
	        this.messageHandlers[event.data.action](event.data);
	      }
	    }
	  };
	}));
	var TransmuxWorker = factory(workerCode$1);
	/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */
	
	var handleData_ = function handleData_(event, transmuxedData, callback) {
	  var _event$data$segment = event.data.segment,
	      type = _event$data$segment.type,
	      initSegment = _event$data$segment.initSegment,
	      captions = _event$data$segment.captions,
	      captionStreams = _event$data$segment.captionStreams,
	      metadata = _event$data$segment.metadata,
	      videoFrameDtsTime = _event$data$segment.videoFrameDtsTime,
	      videoFramePtsTime = _event$data$segment.videoFramePtsTime;
	  transmuxedData.buffer.push({
	    captions: captions,
	    captionStreams: captionStreams,
	    metadata: metadata
	  });
	  var boxes = event.data.segment.boxes || {
	    data: event.data.segment.data
	  };
	  var result = {
	    type: type,
	    // cast ArrayBuffer to TypedArray
	    data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
	    initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
	  };
	
	  if (typeof videoFrameDtsTime !== 'undefined') {
	    result.videoFrameDtsTime = videoFrameDtsTime;
	  }
	
	  if (typeof videoFramePtsTime !== 'undefined') {
	    result.videoFramePtsTime = videoFramePtsTime;
	  }
	
	  callback(result);
	};
	
	var handleDone_ = function handleDone_(_ref) {
	  var transmuxedData = _ref.transmuxedData,
	      callback = _ref.callback; // Previously we only returned data on data events,
	  // not on done events. Clear out the buffer to keep that consistent.
	
	  transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
	  // have received
	
	  callback(transmuxedData);
	};
	
	var handleGopInfo_ = function handleGopInfo_(event, transmuxedData) {
	  transmuxedData.gopInfo = event.data.gopInfo;
	};
	
	var processTransmux = function processTransmux(options) {
	  var transmuxer = options.transmuxer,
	      bytes = options.bytes,
	      audioAppendStart = options.audioAppendStart,
	      gopsToAlignWith = options.gopsToAlignWith,
	      remux = options.remux,
	      onData = options.onData,
	      onTrackInfo = options.onTrackInfo,
	      onAudioTimingInfo = options.onAudioTimingInfo,
	      onVideoTimingInfo = options.onVideoTimingInfo,
	      onVideoSegmentTimingInfo = options.onVideoSegmentTimingInfo,
	      onAudioSegmentTimingInfo = options.onAudioSegmentTimingInfo,
	      onId3 = options.onId3,
	      onCaptions = options.onCaptions,
	      onDone = options.onDone,
	      onEndedTimeline = options.onEndedTimeline,
	      onTransmuxerLog = options.onTransmuxerLog,
	      isEndOfTimeline = options.isEndOfTimeline;
	  var transmuxedData = {
	    buffer: []
	  };
	  var waitForEndedTimelineEvent = isEndOfTimeline;
	
	  var handleMessage = function handleMessage(event) {
	    if (transmuxer.currentTransmux !== options) {
	      // disposed
	      return;
	    }
	
	    if (event.data.action === 'data') {
	      handleData_(event, transmuxedData, onData);
	    }
	
	    if (event.data.action === 'trackinfo') {
	      onTrackInfo(event.data.trackInfo);
	    }
	
	    if (event.data.action === 'gopInfo') {
	      handleGopInfo_(event, transmuxedData);
	    }
	
	    if (event.data.action === 'audioTimingInfo') {
	      onAudioTimingInfo(event.data.audioTimingInfo);
	    }
	
	    if (event.data.action === 'videoTimingInfo') {
	      onVideoTimingInfo(event.data.videoTimingInfo);
	    }
	
	    if (event.data.action === 'videoSegmentTimingInfo') {
	      onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'audioSegmentTimingInfo') {
	      onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'id3Frame') {
	      onId3([event.data.id3Frame], event.data.id3Frame.dispatchType);
	    }
	
	    if (event.data.action === 'caption') {
	      onCaptions(event.data.caption);
	    }
	
	    if (event.data.action === 'endedtimeline') {
	      waitForEndedTimelineEvent = false;
	      onEndedTimeline();
	    }
	
	    if (event.data.action === 'log') {
	      onTransmuxerLog(event.data.log);
	    } // wait for the transmuxed event since we may have audio and video
	
	
	    if (event.data.type !== 'transmuxed') {
	      return;
	    } // If the "endedtimeline" event has not yet fired, and this segment represents the end
	    // of a timeline, that means there may still be data events before the segment
	    // processing can be considerred complete. In that case, the final event should be
	    // an "endedtimeline" event with the type "transmuxed."
	
	
	    if (waitForEndedTimelineEvent) {
	      return;
	    }
	
	    transmuxer.onmessage = null;
	    handleDone_({
	      transmuxedData: transmuxedData,
	      callback: onDone
	    });
	    /* eslint-disable no-use-before-define */
	
	    dequeue(transmuxer);
	    /* eslint-enable */
	  };
	
	  transmuxer.onmessage = handleMessage;
	
	  if (audioAppendStart) {
	    transmuxer.postMessage({
	      action: 'setAudioAppendStart',
	      appendStart: audioAppendStart
	    });
	  } // allow empty arrays to be passed to clear out GOPs
	
	
	  if (Array.isArray(gopsToAlignWith)) {
	    transmuxer.postMessage({
	      action: 'alignGopsWith',
	      gopsToAlignWith: gopsToAlignWith
	    });
	  }
	
	  if (typeof remux !== 'undefined') {
	    transmuxer.postMessage({
	      action: 'setRemux',
	      remux: remux
	    });
	  }
	
	  if (bytes.byteLength) {
	    var buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
	    var byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
	    transmuxer.postMessage({
	      action: 'push',
	      // Send the typed-array of data as an ArrayBuffer so that
	      // it can be sent as a "Transferable" and avoid the costly
	      // memory copy
	      data: buffer,
	      // To recreate the original typed-array, we need information
	      // about what portion of the ArrayBuffer it was a view into
	      byteOffset: byteOffset,
	      byteLength: bytes.byteLength
	    }, [buffer]);
	  }
	
	  if (isEndOfTimeline) {
	    transmuxer.postMessage({
	      action: 'endTimeline'
	    });
	  } // even if we didn't push any bytes, we have to make sure we flush in case we reached
	  // the end of the segment
	
	
	  transmuxer.postMessage({
	    action: 'flush'
	  });
	};
	
	var dequeue = function dequeue(transmuxer) {
	  transmuxer.currentTransmux = null;
	
	  if (transmuxer.transmuxQueue.length) {
	    transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
	
	    if (typeof transmuxer.currentTransmux === 'function') {
	      transmuxer.currentTransmux();
	    } else {
	      processTransmux(transmuxer.currentTransmux);
	    }
	  }
	};
	
	var processAction = function processAction(transmuxer, action) {
	  transmuxer.postMessage({
	    action: action
	  });
	  dequeue(transmuxer);
	};
	
	var enqueueAction = function enqueueAction(action, transmuxer) {
	  if (!transmuxer.currentTransmux) {
	    transmuxer.currentTransmux = action;
	    processAction(transmuxer, action);
	    return;
	  }
	
	  transmuxer.transmuxQueue.push(processAction.bind(null, transmuxer, action));
	};
	
	var reset = function reset(transmuxer) {
	  enqueueAction('reset', transmuxer);
	};
	
	var endTimeline = function endTimeline(transmuxer) {
	  enqueueAction('endTimeline', transmuxer);
	};
	
	var transmux = function transmux(options) {
	  if (!options.transmuxer.currentTransmux) {
	    options.transmuxer.currentTransmux = options;
	    processTransmux(options);
	    return;
	  }
	
	  options.transmuxer.transmuxQueue.push(options);
	};
	
	var createTransmuxer = function createTransmuxer(options) {
	  var transmuxer = new TransmuxWorker();
	  transmuxer.currentTransmux = null;
	  transmuxer.transmuxQueue = [];
	  var term = transmuxer.terminate;
	
	  transmuxer.terminate = function () {
	    transmuxer.currentTransmux = null;
	    transmuxer.transmuxQueue.length = 0;
	    return term.call(transmuxer);
	  };
	
	  transmuxer.postMessage({
	    action: 'init',
	    options: options
	  });
	  return transmuxer;
	};
	
	var segmentTransmuxer = {
	  reset: reset,
	  endTimeline: endTimeline,
	  transmux: transmux,
	  createTransmuxer: createTransmuxer
	};
	
	var workerCallback = function workerCallback(options) {
	  var transmuxer = options.transmuxer;
	  var endAction = options.endAction || options.action;
	  var callback = options.callback;
	
	  var message = _extends__default['default']({}, options, {
	    endAction: null,
	    transmuxer: null,
	    callback: null
	  });
	
	  var listenForEndEvent = function listenForEndEvent(event) {
	    if (event.data.action !== endAction) {
	      return;
	    }
	
	    transmuxer.removeEventListener('message', listenForEndEvent); // transfer ownership of bytes back to us.
	
	    if (event.data.data) {
	      event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
	
	      if (options.data) {
	        options.data = event.data.data;
	      }
	    }
	
	    callback(event.data);
	  };
	
	  transmuxer.addEventListener('message', listenForEndEvent);
	
	  if (options.data) {
	    var isArrayBuffer = options.data instanceof ArrayBuffer;
	    message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
	    message.byteLength = options.data.byteLength;
	    var transfers = [isArrayBuffer ? options.data : options.data.buffer];
	    transmuxer.postMessage(message, transfers);
	  } else {
	    transmuxer.postMessage(message);
	  }
	};
	
	var REQUEST_ERRORS = {
	  FAILURE: 2,
	  TIMEOUT: -101,
	  ABORTED: -102
	};
	/**
	 * Abort all requests
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 */
	
	var abortAll = function abortAll(activeXhrs) {
	  activeXhrs.forEach(function (xhr) {
	    xhr.abort();
	  });
	};
	/**
	 * Gather important bandwidth stats once a request has completed
	 *
	 * @param {Object} request - the XHR request from which to gather stats
	 */
	
	
	var getRequestStats = function getRequestStats(request) {
	  return {
	    bandwidth: request.bandwidth,
	    bytesReceived: request.bytesReceived || 0,
	    roundTripTime: request.roundTripTime || 0
	  };
	};
	/**
	 * If possible gather bandwidth stats as a request is in
	 * progress
	 *
	 * @param {Event} progressEvent - an event object from an XHR's progress event
	 */
	
	
	var getProgressStats = function getProgressStats(progressEvent) {
	  var request = progressEvent.target;
	  var roundTripTime = Date.now() - request.requestTime;
	  var stats = {
	    bandwidth: Infinity,
	    bytesReceived: 0,
	    roundTripTime: roundTripTime || 0
	  };
	  stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
	  // because we should only use bandwidth stats on progress to determine when
	  // abort a request early due to insufficient bandwidth
	
	  stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8 * 1000);
	  return stats;
	};
	/**
	 * Handle all error conditions in one place and return an object
	 * with all the information
	 *
	 * @param {Error|null} error - if non-null signals an error occured with the XHR
	 * @param {Object} request -  the XHR request that possibly generated the error
	 */
	
	
	var handleErrors = function handleErrors(error, request) {
	  if (request.timedout) {
	    return {
	      status: request.status,
	      message: 'HLS request timed-out at URL: ' + request.uri,
	      code: REQUEST_ERRORS.TIMEOUT,
	      xhr: request
	    };
	  }
	
	  if (request.aborted) {
	    return {
	      status: request.status,
	      message: 'HLS request aborted at URL: ' + request.uri,
	      code: REQUEST_ERRORS.ABORTED,
	      xhr: request
	    };
	  }
	
	  if (error) {
	    return {
	      status: request.status,
	      message: 'HLS request errored at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  if (request.responseType === 'arraybuffer' && request.response.byteLength === 0) {
	    return {
	      status: request.status,
	      message: 'Empty HLS response at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  return null;
	};
	/**
	 * Handle responses for key data and convert the key data to the correct format
	 * for the decryption step later
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Array} objects - objects to add the key bytes to.
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleKeyResponse = function handleKeyResponse(segment, objects, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    if (response.byteLength !== 16) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Invalid HLS key at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    var view = new DataView(response);
	    var bytes = new Uint32Array([view.getUint32(0), view.getUint32(4), view.getUint32(8), view.getUint32(12)]);
	
	    for (var i = 0; i < objects.length; i++) {
	      objects[i].bytes = bytes;
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var parseInitSegment = function parseInitSegment(segment, _callback) {
	  var type = containers.detectContainerForBytes(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
	  // only know how to parse mp4 init segments at the moment
	
	  if (type !== 'mp4') {
	    var uri = segment.map.resolvedUri || segment.map.uri;
	    return _callback({
	      internal: true,
	      message: "Found unsupported " + (type || 'unknown') + " container for initialization segment at URL: " + uri,
	      code: REQUEST_ERRORS.FAILURE
	    });
	  }
	
	  workerCallback({
	    action: 'probeMp4Tracks',
	    data: segment.map.bytes,
	    transmuxer: segment.transmuxer,
	    callback: function callback(_ref) {
	      var tracks = _ref.tracks,
	          data = _ref.data; // transfer bytes back to us
	
	      segment.map.bytes = data;
	      tracks.forEach(function (track) {
	        segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
	
	        if (segment.map.tracks[track.type]) {
	          return;
	        }
	
	        segment.map.tracks[track.type] = track;
	
	        if (typeof track.id === 'number' && track.timescale) {
	          segment.map.timescales = segment.map.timescales || {};
	          segment.map.timescales[track.id] = track.timescale;
	        }
	      });
	      return _callback(null);
	    }
	  });
	};
	/**
	 * Handle init-segment responses
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleInitSegmentResponse = function handleInitSegmentResponse(_ref2) {
	  var segment = _ref2.segment,
	      finishProcessingFn = _ref2.finishProcessingFn;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var bytes = new Uint8Array(request.response); // init segment is encypted, we will have to wait
	    // until the key request is done to decrypt.
	
	    if (segment.map.key) {
	      segment.map.encryptedBytes = bytes;
	      return finishProcessingFn(null, segment);
	    }
	
	    segment.map.bytes = bytes;
	    parseInitSegment(segment, function (parseError) {
	      if (parseError) {
	        parseError.xhr = request;
	        parseError.status = request.status;
	        return finishProcessingFn(parseError, segment);
	      }
	
	      finishProcessingFn(null, segment);
	    });
	  };
	};
	/**
	 * Response handler for segment-requests being sure to set the correct
	 * property depending on whether the segment is encryped or not
	 * Also records and keeps track of stats that are used for ABR purposes
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleSegmentResponse = function handleSegmentResponse(_ref3) {
	  var segment = _ref3.segment,
	      finishProcessingFn = _ref3.finishProcessingFn,
	      responseType = _ref3.responseType;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var newBytes = // although responseText "should" exist, this guard serves to prevent an error being
	    // thrown for two primary cases:
	    // 1. the mime type override stops working, or is not implemented for a specific
	    //    browser
	    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
	    responseType === 'arraybuffer' || !request.responseText ? request.response : stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
	    segment.stats = getRequestStats(request);
	
	    if (segment.key) {
	      segment.encryptedBytes = new Uint8Array(newBytes);
	    } else {
	      segment.bytes = new Uint8Array(newBytes);
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var transmuxAndNotify = function transmuxAndNotify(_ref4) {
	  var segment = _ref4.segment,
	      bytes = _ref4.bytes,
	      trackInfoFn = _ref4.trackInfoFn,
	      timingInfoFn = _ref4.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref4.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref4.audioSegmentTimingInfoFn,
	      id3Fn = _ref4.id3Fn,
	      captionsFn = _ref4.captionsFn,
	      isEndOfTimeline = _ref4.isEndOfTimeline,
	      endedTimelineFn = _ref4.endedTimelineFn,
	      dataFn = _ref4.dataFn,
	      doneFn = _ref4.doneFn,
	      onTransmuxerLog = _ref4.onTransmuxerLog;
	  var fmp4Tracks = segment.map && segment.map.tracks || {};
	  var isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
	  // One reason for this is that in the case of full segments, we want to trust start
	  // times from the probe, rather than the transmuxer.
	
	  var audioStartFn = timingInfoFn.bind(null, segment, 'audio', 'start');
	  var audioEndFn = timingInfoFn.bind(null, segment, 'audio', 'end');
	  var videoStartFn = timingInfoFn.bind(null, segment, 'video', 'start');
	  var videoEndFn = timingInfoFn.bind(null, segment, 'video', 'end');
	
	  var finish = function finish() {
	    return transmux({
	      bytes: bytes,
	      transmuxer: segment.transmuxer,
	      audioAppendStart: segment.audioAppendStart,
	      gopsToAlignWith: segment.gopsToAlignWith,
	      remux: isMuxed,
	      onData: function onData(result) {
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        dataFn(segment, result);
	      },
	      onTrackInfo: function onTrackInfo(trackInfo) {
	        if (trackInfoFn) {
	          if (isMuxed) {
	            trackInfo.isMuxed = true;
	          }
	
	          trackInfoFn(segment, trackInfo);
	        }
	      },
	      onAudioTimingInfo: function onAudioTimingInfo(audioTimingInfo) {
	        // we only want the first start value we encounter
	        if (audioStartFn && typeof audioTimingInfo.start !== 'undefined') {
	          audioStartFn(audioTimingInfo.start);
	          audioStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (audioEndFn && typeof audioTimingInfo.end !== 'undefined') {
	          audioEndFn(audioTimingInfo.end);
	        }
	      },
	      onVideoTimingInfo: function onVideoTimingInfo(videoTimingInfo) {
	        // we only want the first start value we encounter
	        if (videoStartFn && typeof videoTimingInfo.start !== 'undefined') {
	          videoStartFn(videoTimingInfo.start);
	          videoStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (videoEndFn && typeof videoTimingInfo.end !== 'undefined') {
	          videoEndFn(videoTimingInfo.end);
	        }
	      },
	      onVideoSegmentTimingInfo: function onVideoSegmentTimingInfo(videoSegmentTimingInfo) {
	        videoSegmentTimingInfoFn(videoSegmentTimingInfo);
	      },
	      onAudioSegmentTimingInfo: function onAudioSegmentTimingInfo(audioSegmentTimingInfo) {
	        audioSegmentTimingInfoFn(audioSegmentTimingInfo);
	      },
	      onId3: function onId3(id3Frames, dispatchType) {
	        id3Fn(segment, id3Frames, dispatchType);
	      },
	      onCaptions: function onCaptions(captions) {
	        captionsFn(segment, [captions]);
	      },
	      isEndOfTimeline: isEndOfTimeline,
	      onEndedTimeline: function onEndedTimeline() {
	        endedTimelineFn();
	      },
	      onTransmuxerLog: onTransmuxerLog,
	      onDone: function onDone(result) {
	        if (!doneFn) {
	          return;
	        }
	
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        doneFn(null, segment, result);
	      }
	    });
	  }; // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
	  // Meaning cached frame data may corrupt our notion of where this segment
	  // really starts. To get around this, probe for the info needed.
	
	
	  workerCallback({
	    action: 'probeTs',
	    transmuxer: segment.transmuxer,
	    data: bytes,
	    baseStartTime: segment.baseStartTime,
	    callback: function callback(data) {
	      segment.bytes = bytes = data.data;
	      var probeResult = data.result;
	
	      if (probeResult) {
	        trackInfoFn(segment, {
	          hasAudio: probeResult.hasAudio,
	          hasVideo: probeResult.hasVideo,
	          isMuxed: isMuxed
	        });
	        trackInfoFn = null;
	
	        if (probeResult.hasAudio && !isMuxed) {
	          audioStartFn(probeResult.audioStart);
	        }
	
	        if (probeResult.hasVideo) {
	          videoStartFn(probeResult.videoStart);
	        }
	
	        audioStartFn = null;
	        videoStartFn = null;
	      }
	
	      finish();
	    }
	  });
	};
	
	var handleSegmentBytes = function handleSegmentBytes(_ref5) {
	  var segment = _ref5.segment,
	      bytes = _ref5.bytes,
	      trackInfoFn = _ref5.trackInfoFn,
	      timingInfoFn = _ref5.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref5.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref5.audioSegmentTimingInfoFn,
	      id3Fn = _ref5.id3Fn,
	      captionsFn = _ref5.captionsFn,
	      isEndOfTimeline = _ref5.isEndOfTimeline,
	      endedTimelineFn = _ref5.endedTimelineFn,
	      dataFn = _ref5.dataFn,
	      doneFn = _ref5.doneFn,
	      onTransmuxerLog = _ref5.onTransmuxerLog;
	  var bytesAsUint8Array = new Uint8Array(bytes); // TODO:
	  // We should have a handler that fetches the number of bytes required
	  // to check if something is fmp4. This will allow us to save bandwidth
	  // because we can only blacklist a playlist and abort requests
	  // by codec after trackinfo triggers.
	
	  if (containers.isLikelyFmp4MediaSegment(bytesAsUint8Array)) {
	    segment.isFmp4 = true;
	    var tracks = segment.map.tracks;
	    var trackInfo = {
	      isFmp4: true,
	      hasVideo: !!tracks.video,
	      hasAudio: !!tracks.audio
	    }; // if we have a audio track, with a codec that is not set to
	    // encrypted audio
	
	    if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== 'enca') {
	      trackInfo.audioCodec = tracks.audio.codec;
	    } // if we have a video track, with a codec that is not set to
	    // encrypted video
	
	
	    if (tracks.video && tracks.video.codec && tracks.video.codec !== 'encv') {
	      trackInfo.videoCodec = tracks.video.codec;
	    }
	
	    if (tracks.video && tracks.audio) {
	      trackInfo.isMuxed = true;
	    } // since we don't support appending fmp4 data on progress, we know we have the full
	    // segment here
	
	
	    trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
	    // time. The end time can be roughly calculated by the receiver using the duration.
	    //
	    // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
	    // that is the true start of the segment (where the playback engine should begin
	    // decoding).
	
	    var finishLoading = function finishLoading(captions) {
	      // if the track still has audio at this point it is only possible
	      // for it to be audio only. See `tracks.video && tracks.audio` if statement
	      // above.
	      // we make sure to use segment.bytes here as that
	      dataFn(segment, {
	        data: bytesAsUint8Array,
	        type: trackInfo.hasAudio && !trackInfo.isMuxed ? 'audio' : 'video'
	      });
	
	      if (captions && captions.length) {
	        captionsFn(segment, captions);
	      }
	
	      doneFn(null, segment, {});
	    };
	
	    workerCallback({
	      action: 'probeMp4StartTime',
	      timescales: segment.map.timescales,
	      data: bytesAsUint8Array,
	      transmuxer: segment.transmuxer,
	      callback: function callback(_ref6) {
	        var data = _ref6.data,
	            startTime = _ref6.startTime; // transfer bytes back to us
	
	        bytes = data.buffer;
	        segment.bytes = bytesAsUint8Array = data;
	
	        if (trackInfo.hasAudio && !trackInfo.isMuxed) {
	          timingInfoFn(segment, 'audio', 'start', startTime);
	        }
	
	        if (trackInfo.hasVideo) {
	          timingInfoFn(segment, 'video', 'start', startTime);
	        } // Run through the CaptionParser in case there are captions.
	        // Initialize CaptionParser if it hasn't been yet
	
	
	        if (!tracks.video || !data.byteLength || !segment.transmuxer) {
	          finishLoading();
	          return;
	        }
	
	        workerCallback({
	          action: 'pushMp4Captions',
	          endAction: 'mp4Captions',
	          transmuxer: segment.transmuxer,
	          data: bytesAsUint8Array,
	          timescales: segment.map.timescales,
	          trackIds: [tracks.video.id],
	          callback: function callback(message) {
	            // transfer bytes back to us
	            bytes = message.data.buffer;
	            segment.bytes = bytesAsUint8Array = message.data;
	            message.logs.forEach(function (log) {
	              onTransmuxerLog(videojs.mergeOptions(log, {
	                stream: 'mp4CaptionParser'
	              }));
	            });
	            finishLoading(message.captions);
	          }
	        });
	      }
	    });
	    return;
	  } // VTT or other segments that don't need processing
	
	
	  if (!segment.transmuxer) {
	    doneFn(null, segment, {});
	    return;
	  }
	
	  if (typeof segment.container === 'undefined') {
	    segment.container = containers.detectContainerForBytes(bytesAsUint8Array);
	  }
	
	  if (segment.container !== 'ts' && segment.container !== 'aac') {
	    trackInfoFn(segment, {
	      hasAudio: false,
	      hasVideo: false
	    });
	    doneFn(null, segment, {});
	    return;
	  } // ts or aac
	
	
	  transmuxAndNotify({
	    segment: segment,
	    bytes: bytes,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  });
	};
	
	var decrypt = function decrypt(_ref7, callback) {
	  var id = _ref7.id,
	      key = _ref7.key,
	      encryptedBytes = _ref7.encryptedBytes,
	      decryptionWorker = _ref7.decryptionWorker;
	
	  var decryptionHandler = function decryptionHandler(event) {
	    if (event.data.source === id) {
	      decryptionWorker.removeEventListener('message', decryptionHandler);
	      var decrypted = event.data.decrypted;
	      callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
	    }
	  };
	
	  decryptionWorker.addEventListener('message', decryptionHandler);
	  var keyBytes;
	
	  if (key.bytes.slice) {
	    keyBytes = key.bytes.slice();
	  } else {
	    keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
	  } // incrementally decrypt the bytes
	
	
	  decryptionWorker.postMessage(createTransferableMessage({
	    source: id,
	    encrypted: encryptedBytes,
	    key: keyBytes,
	    iv: key.iv
	  }), [encryptedBytes.buffer, keyBytes.buffer]);
	};
	/**
	 * Decrypt the segment via the decryption web worker
	 *
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after decryption has completed
	 */
	
	
	var decryptSegment = function decryptSegment(_ref8) {
	  var decryptionWorker = _ref8.decryptionWorker,
	      segment = _ref8.segment,
	      trackInfoFn = _ref8.trackInfoFn,
	      timingInfoFn = _ref8.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref8.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref8.audioSegmentTimingInfoFn,
	      id3Fn = _ref8.id3Fn,
	      captionsFn = _ref8.captionsFn,
	      isEndOfTimeline = _ref8.isEndOfTimeline,
	      endedTimelineFn = _ref8.endedTimelineFn,
	      dataFn = _ref8.dataFn,
	      doneFn = _ref8.doneFn,
	      onTransmuxerLog = _ref8.onTransmuxerLog;
	  decrypt({
	    id: segment.requestId,
	    key: segment.key,
	    encryptedBytes: segment.encryptedBytes,
	    decryptionWorker: decryptionWorker
	  }, function (decryptedBytes) {
	    segment.bytes = decryptedBytes;
	    handleSegmentBytes({
	      segment: segment,
	      bytes: segment.bytes,
	      trackInfoFn: trackInfoFn,
	      timingInfoFn: timingInfoFn,
	      videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	      id3Fn: id3Fn,
	      captionsFn: captionsFn,
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: endedTimelineFn,
	      dataFn: dataFn,
	      doneFn: doneFn,
	      onTransmuxerLog: onTransmuxerLog
	    });
	  });
	};
	/**
	 * This function waits for all XHRs to finish (with either success or failure)
	 * before continueing processing via it's callback. The function gathers errors
	 * from each request into a single errors array so that the error status for
	 * each request can be examined later.
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after all resources have been
	 *                            downloaded and any decryption completed
	 */
	
	
	var waitForCompletion = function waitForCompletion(_ref9) {
	  var activeXhrs = _ref9.activeXhrs,
	      decryptionWorker = _ref9.decryptionWorker,
	      trackInfoFn = _ref9.trackInfoFn,
	      timingInfoFn = _ref9.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref9.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref9.audioSegmentTimingInfoFn,
	      id3Fn = _ref9.id3Fn,
	      captionsFn = _ref9.captionsFn,
	      isEndOfTimeline = _ref9.isEndOfTimeline,
	      endedTimelineFn = _ref9.endedTimelineFn,
	      dataFn = _ref9.dataFn,
	      doneFn = _ref9.doneFn,
	      onTransmuxerLog = _ref9.onTransmuxerLog;
	  var count = 0;
	  var didError = false;
	  return function (error, segment) {
	    if (didError) {
	      return;
	    }
	
	    if (error) {
	      didError = true; // If there are errors, we have to abort any outstanding requests
	
	      abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
	      // handle the aborted events from those requests, there are some cases where we may
	      // never get an aborted event. For instance, if the network connection is lost and
	      // there were two requests, the first may have triggered an error immediately, while
	      // the second request remains unsent. In that case, the aborted algorithm will not
	      // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
	      //
	      // We also can't rely on the ready state of the XHR, since the request that
	      // triggered the connection error may also show as a ready state of 0 (unsent).
	      // Therefore, we have to finish this group of requests immediately after the first
	      // seen error.
	
	      return doneFn(error, segment);
	    }
	
	    count += 1;
	
	    if (count === activeXhrs.length) {
	      var segmentFinish = function segmentFinish() {
	        if (segment.encryptedBytes) {
	          return decryptSegment({
	            decryptionWorker: decryptionWorker,
	            segment: segment,
	            trackInfoFn: trackInfoFn,
	            timingInfoFn: timingInfoFn,
	            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	            id3Fn: id3Fn,
	            captionsFn: captionsFn,
	            isEndOfTimeline: isEndOfTimeline,
	            endedTimelineFn: endedTimelineFn,
	            dataFn: dataFn,
	            doneFn: doneFn,
	            onTransmuxerLog: onTransmuxerLog
	          });
	        } // Otherwise, everything is ready just continue
	
	
	        handleSegmentBytes({
	          segment: segment,
	          bytes: segment.bytes,
	          trackInfoFn: trackInfoFn,
	          timingInfoFn: timingInfoFn,
	          videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	          audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	          id3Fn: id3Fn,
	          captionsFn: captionsFn,
	          isEndOfTimeline: isEndOfTimeline,
	          endedTimelineFn: endedTimelineFn,
	          dataFn: dataFn,
	          doneFn: doneFn,
	          onTransmuxerLog: onTransmuxerLog
	        });
	      }; // Keep track of when *all* of the requests have completed
	
	
	      segment.endOfAllRequests = Date.now();
	
	      if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
	        return decrypt({
	          decryptionWorker: decryptionWorker,
	          // add -init to the "id" to differentiate between segment
	          // and init segment decryption, just in case they happen
	          // at the same time at some point in the future.
	          id: segment.requestId + '-init',
	          encryptedBytes: segment.map.encryptedBytes,
	          key: segment.map.key
	        }, function (decryptedBytes) {
	          segment.map.bytes = decryptedBytes;
	          parseInitSegment(segment, function (parseError) {
	            if (parseError) {
	              abortAll(activeXhrs);
	              return doneFn(parseError, segment);
	            }
	
	            segmentFinish();
	          });
	        });
	      }
	
	      segmentFinish();
	    }
	  };
	};
	/**
	 * Calls the abort callback if any request within the batch was aborted. Will only call
	 * the callback once per batch of requests, even if multiple were aborted.
	 *
	 * @param {Object} loadendState - state to check to see if the abort function was called
	 * @param {Function} abortFn - callback to call for abort
	 */
	
	
	var handleLoadEnd = function handleLoadEnd(_ref10) {
	  var loadendState = _ref10.loadendState,
	      abortFn = _ref10.abortFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted && abortFn && !loadendState.calledAbortFn) {
	      abortFn();
	      loadendState.calledAbortFn = true;
	    }
	  };
	};
	/**
	 * Simple progress event callback handler that gathers some stats before
	 * executing a provided callback with the `segment` object
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} progressFn - a callback that is executed each time a progress event
	 *                                is received
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Event} event - the progress event object from XMLHttpRequest
	 */
	
	
	var handleProgress = function handleProgress(_ref11) {
	  var segment = _ref11.segment,
	      progressFn = _ref11.progressFn;
	  _ref11.trackInfoFn;
	  _ref11.timingInfoFn;
	  _ref11.videoSegmentTimingInfoFn;
	  _ref11.audioSegmentTimingInfoFn;
	  _ref11.id3Fn;
	  _ref11.captionsFn;
	  _ref11.isEndOfTimeline;
	  _ref11.endedTimelineFn;
	  _ref11.dataFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted) {
	      return;
	    }
	
	    segment.stats = videojs.mergeOptions(segment.stats, getProgressStats(event)); // record the time that we receive the first byte of data
	
	    if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) {
	      segment.stats.firstBytesReceivedAt = Date.now();
	    }
	
	    return progressFn(event, segment);
	  };
	};
	/**
	 * Load all resources and does any processing necessary for a media-segment
	 *
	 * Features:
	 *   decrypts the media-segment if it has a key uri and an iv
	 *   aborts *all* requests if *any* one request fails
	 *
	 * The segment object, at minimum, has the following format:
	 * {
	 *   resolvedUri: String,
	 *   [transmuxer]: Object,
	 *   [byterange]: {
	 *     offset: Number,
	 *     length: Number
	 *   },
	 *   [key]: {
	 *     resolvedUri: String
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     iv: {
	 *       bytes: Uint32Array
	 *     }
	 *   },
	 *   [map]: {
	 *     resolvedUri: String,
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     [bytes]: Uint8Array
	 *   }
	 * }
	 * ...where [name] denotes optional properties
	 *
	 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
	 * @param {Object} xhrOptions - the base options to provide to all xhr requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
	 *                                       decryption routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
	 *                             aborted
	 * @param {Function} progressFn - a callback that receives progress events from the main
	 *                                segment's xhr request
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
	 *                            request, transmuxed if needed
	 * @param {Function} doneFn - a callback that is executed only once all requests have
	 *                            succeeded or failed
	 * @return {Function} a function that, when invoked, immediately aborts all
	 *                     outstanding requests
	 */
	
	
	var mediaSegmentRequest = function mediaSegmentRequest(_ref12) {
	  var xhr = _ref12.xhr,
	      xhrOptions = _ref12.xhrOptions,
	      decryptionWorker = _ref12.decryptionWorker,
	      segment = _ref12.segment,
	      abortFn = _ref12.abortFn,
	      progressFn = _ref12.progressFn,
	      trackInfoFn = _ref12.trackInfoFn,
	      timingInfoFn = _ref12.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref12.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref12.audioSegmentTimingInfoFn,
	      id3Fn = _ref12.id3Fn,
	      captionsFn = _ref12.captionsFn,
	      isEndOfTimeline = _ref12.isEndOfTimeline,
	      endedTimelineFn = _ref12.endedTimelineFn,
	      dataFn = _ref12.dataFn,
	      doneFn = _ref12.doneFn,
	      onTransmuxerLog = _ref12.onTransmuxerLog;
	  var activeXhrs = [];
	  var finishProcessingFn = waitForCompletion({
	    activeXhrs: activeXhrs,
	    decryptionWorker: decryptionWorker,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  }); // optionally, request the decryption key
	
	  if (segment.key && !segment.key.bytes) {
	    var objects = [segment.key];
	
	    if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) {
	      objects.push(segment.map.key);
	    }
	
	    var keyRequestOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.key.resolvedUri,
	      responseType: 'arraybuffer'
	    });
	    var keyRequestCallback = handleKeyResponse(segment, objects, finishProcessingFn);
	    var keyXhr = xhr(keyRequestOptions, keyRequestCallback);
	    activeXhrs.push(keyXhr);
	  } // optionally, request the associated media init segment
	
	
	  if (segment.map && !segment.map.bytes) {
	    var differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
	
	    if (differentMapKey) {
	      var mapKeyRequestOptions = videojs.mergeOptions(xhrOptions, {
	        uri: segment.map.key.resolvedUri,
	        responseType: 'arraybuffer'
	      });
	      var mapKeyRequestCallback = handleKeyResponse(segment, [segment.map.key], finishProcessingFn);
	      var mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
	      activeXhrs.push(mapKeyXhr);
	    }
	
	    var initSegmentOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.map.resolvedUri,
	      responseType: 'arraybuffer',
	      headers: segmentXhrHeaders(segment.map)
	    });
	    var initSegmentRequestCallback = handleInitSegmentResponse({
	      segment: segment,
	      finishProcessingFn: finishProcessingFn
	    });
	    var initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
	    activeXhrs.push(initSegmentXhr);
	  }
	
	  var segmentRequestOptions = videojs.mergeOptions(xhrOptions, {
	    uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
	    responseType: 'arraybuffer',
	    headers: segmentXhrHeaders(segment)
	  });
	  var segmentRequestCallback = handleSegmentResponse({
	    segment: segment,
	    finishProcessingFn: finishProcessingFn,
	    responseType: segmentRequestOptions.responseType
	  });
	  var segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
	  segmentXhr.addEventListener('progress', handleProgress({
	    segment: segment,
	    progressFn: progressFn,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn
	  }));
	  activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
	  // multiple times, provide a shared state object
	
	  var loadendState = {};
	  activeXhrs.forEach(function (activeXhr) {
	    activeXhr.addEventListener('loadend', handleLoadEnd({
	      loadendState: loadendState,
	      abortFn: abortFn
	    }));
	  });
	  return function () {
	    return abortAll(activeXhrs);
	  };
	};
	/**
	 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
	 * codec strings, or translating codec strings into objects that can be examined.
	 */
	
	
	var logFn$1 = logger('CodecUtils');
	/**
	 * Returns a set of codec strings parsed from the playlist or the default
	 * codec strings if no codecs were specified in the playlist
	 *
	 * @param {Playlist} media the current media playlist
	 * @return {Object} an object with the video and audio codecs
	 */
	
	var getCodecs = function getCodecs(media) {
	  // if the codecs were explicitly specified, use them instead of the
	  // defaults
	  var mediaAttributes = media.attributes || {};
	
	  if (mediaAttributes.CODECS) {
	    return codecs_js.parseCodecs(mediaAttributes.CODECS);
	  }
	};
	
	var isMaat = function isMaat(master, media) {
	  var mediaAttributes = media.attributes || {};
	  return master && master.mediaGroups && master.mediaGroups.AUDIO && mediaAttributes.AUDIO && master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	};
	
	var isMuxed = function isMuxed(master, media) {
	  if (!isMaat(master, media)) {
	    return true;
	  }
	
	  var mediaAttributes = media.attributes || {};
	  var audioGroup = master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	
	  for (var groupId in audioGroup) {
	    // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
	    // or there are listed playlists (the case for DASH, as the manifest will have already
	    // provided all of the details necessary to generate the audio playlist, as opposed to
	    // HLS' externally requested playlists), then the content is demuxed.
	    if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var unwrapCodecList = function unwrapCodecList(codecList) {
	  var codecs = {};
	  codecList.forEach(function (_ref) {
	    var mediaType = _ref.mediaType,
	        type = _ref.type,
	        details = _ref.details;
	    codecs[mediaType] = codecs[mediaType] || [];
	    codecs[mediaType].push(codecs_js.translateLegacyCodec("" + type + details));
	  });
	  Object.keys(codecs).forEach(function (mediaType) {
	    if (codecs[mediaType].length > 1) {
	      logFn$1("multiple " + mediaType + " codecs found as attributes: " + codecs[mediaType].join(', ') + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");
	      codecs[mediaType] = null;
	      return;
	    }
	
	    codecs[mediaType] = codecs[mediaType][0];
	  });
	  return codecs;
	};
	
	var codecCount = function codecCount(codecObj) {
	  var count = 0;
	
	  if (codecObj.audio) {
	    count++;
	  }
	
	  if (codecObj.video) {
	    count++;
	  }
	
	  return count;
	};
	/**
	 * Calculates the codec strings for a working configuration of
	 * SourceBuffers to play variant streams in a master playlist. If
	 * there is no possible working configuration, an empty object will be
	 * returned.
	 *
	 * @param master {Object} the m3u8 object for the master playlist
	 * @param media {Object} the m3u8 object for the variant playlist
	 * @return {Object} the codec strings.
	 *
	 * @private
	 */
	
	
	var codecsForPlaylist = function codecsForPlaylist(master, media) {
	  var mediaAttributes = media.attributes || {};
	  var codecInfo = unwrapCodecList(getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
	  // Put another way, there is no way to have a video-only multiple-audio HLS!
	
	  if (isMaat(master, media) && !codecInfo.audio) {
	    if (!isMuxed(master, media)) {
	      // It is possible for codecs to be specified on the audio media group playlist but
	      // not on the rendition playlist. This is mostly the case for DASH, where audio and
	      // video are always separate (and separately specified).
	      var defaultCodecs = unwrapCodecList(codecs_js.codecsFromDefault(master, mediaAttributes.AUDIO) || []);
	
	      if (defaultCodecs.audio) {
	        codecInfo.audio = defaultCodecs.audio;
	      }
	    }
	  }
	
	  return codecInfo;
	};
	
	var logFn = logger('PlaylistSelector');
	
	var representationToString = function representationToString(representation) {
	  if (!representation || !representation.playlist) {
	    return;
	  }
	
	  var playlist = representation.playlist;
	  return JSON.stringify({
	    id: playlist.id,
	    bandwidth: representation.bandwidth,
	    width: representation.width,
	    height: representation.height,
	    codecs: playlist.attributes && playlist.attributes.CODECS || ''
	  });
	}; // Utilities
	
	/**
	 * Returns the CSS value for the specified property on an element
	 * using `getComputedStyle`. Firefox has a long-standing issue where
	 * getComputedStyle() may return null when running in an iframe with
	 * `display: none`.
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 * @param {HTMLElement} el the htmlelement to work on
	 * @param {string} the proprety to get the style for
	 */
	
	
	var safeGetComputedStyle = function safeGetComputedStyle(el, property) {
	  if (!el) {
	    return '';
	  }
	
	  var result = window__default['default'].getComputedStyle(el);
	
	  if (!result) {
	    return '';
	  }
	
	  return result[property];
	};
	/**
	 * Resuable stable sort function
	 *
	 * @param {Playlists} array
	 * @param {Function} sortFn Different comparators
	 * @function stableSort
	 */
	
	
	var stableSort = function stableSort(array, sortFn) {
	  var newArray = array.slice();
	  array.sort(function (left, right) {
	    var cmp = sortFn(left, right);
	
	    if (cmp === 0) {
	      return newArray.indexOf(left) - newArray.indexOf(right);
	    }
	
	    return cmp;
	  });
	};
	/**
	 * A comparator function to sort two playlist object by bandwidth.
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the bandwidth attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the bandwidth of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistBandwidth = function comparePlaylistBandwidth(left, right) {
	  var leftBandwidth;
	  var rightBandwidth;
	
	  if (left.attributes.BANDWIDTH) {
	    leftBandwidth = left.attributes.BANDWIDTH;
	  }
	
	  leftBandwidth = leftBandwidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.BANDWIDTH) {
	    rightBandwidth = right.attributes.BANDWIDTH;
	  }
	
	  rightBandwidth = rightBandwidth || window__default['default'].Number.MAX_VALUE;
	  return leftBandwidth - rightBandwidth;
	};
	/**
	 * A comparator function to sort two playlist object by resolution (width).
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the resolution.width attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the resolution.width of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistResolution = function comparePlaylistResolution(left, right) {
	  var leftWidth;
	  var rightWidth;
	
	  if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) {
	    leftWidth = left.attributes.RESOLUTION.width;
	  }
	
	  leftWidth = leftWidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) {
	    rightWidth = right.attributes.RESOLUTION.width;
	  }
	
	  rightWidth = rightWidth || window__default['default'].Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
	  // have the same media dimensions/ resolution
	
	  if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) {
	    return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
	  }
	
	  return leftWidth - rightWidth;
	};
	/**
	 * Chooses the appropriate media playlist based on bandwidth and player size
	 *
	 * @param {Object} master
	 *        Object representation of the master manifest
	 * @param {number} playerBandwidth
	 *        Current calculated bandwidth of the player
	 * @param {number} playerWidth
	 *        Current width of the player element (should account for the device pixel ratio)
	 * @param {number} playerHeight
	 *        Current height of the player element (should account for the device pixel ratio)
	 * @param {boolean} limitRenditionByPlayerDimensions
	 *        True if the player width and height should be used during the selection, false otherwise
	 * @param {Object} masterPlaylistController
	 *        the current masterPlaylistController object
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var simpleSelector = function simpleSelector(master, playerBandwidth, playerWidth, playerHeight, limitRenditionByPlayerDimensions, masterPlaylistController) {
	  // If we end up getting called before `master` is available, exit early
	  if (!master) {
	    return;
	  }
	
	  var options = {
	    bandwidth: playerBandwidth,
	    width: playerWidth,
	    height: playerHeight,
	    limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
	  };
	  var playlists = master.playlists; // if playlist is audio only, select between currently active audio group playlists.
	
	  if (Playlist.isAudioOnly(master)) {
	    playlists = masterPlaylistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
	    // at the buttom of this function for debugging.
	
	    options.audioOnly = true;
	  } // convert the playlists to an intermediary representation to make comparisons easier
	
	
	  var sortedPlaylistReps = playlists.map(function (playlist) {
	    var bandwidth;
	    var width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
	    var height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
	    bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
	    bandwidth = bandwidth || window__default['default'].Number.MAX_VALUE;
	    return {
	      bandwidth: bandwidth,
	      width: width,
	      height: height,
	      playlist: playlist
	    };
	  });
	  stableSort(sortedPlaylistReps, function (left, right) {
	    return left.bandwidth - right.bandwidth;
	  }); // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  sortedPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return !Playlist.isIncompatible(rep.playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return Playlist.isEnabled(rep.playlist);
	  });
	
	  if (!enabledPlaylistReps.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	      return !Playlist.isDisabled(rep.playlist);
	    });
	  } // filter out any variant that has greater effective bitrate
	  // than the current estimated bandwidth
	
	
	  var bandwidthPlaylistReps = enabledPlaylistReps.filter(function (rep) {
	    return rep.bandwidth * Config.BANDWIDTH_VARIANCE < playerBandwidth;
	  });
	  var highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
	  // and then taking the very first element
	
	  var bandwidthBestRep = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0]; // if we're not going to limit renditions by player size, make an early decision.
	
	  if (limitRenditionByPlayerDimensions === false) {
	    var _chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	    if (_chosenRep && _chosenRep.playlist) {
	      var type = 'sortedPlaylistReps';
	
	      if (bandwidthBestRep) {
	        type = 'bandwidthBestRep';
	      }
	
	      if (enabledPlaylistReps[0]) {
	        type = 'enabledPlaylistReps';
	      }
	
	      logFn("choosing " + representationToString(_chosenRep) + " using " + type + " with options", options);
	      return _chosenRep.playlist;
	    }
	
	    logFn('could not choose a playlist with options', options);
	    return null;
	  } // filter out playlists without resolution information
	
	
	  var haveResolution = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.width && rep.height;
	  }); // sort variants by resolution
	
	  stableSort(haveResolution, function (left, right) {
	    return left.width - right.width;
	  }); // if we have the exact resolution as the player use it
	
	  var resolutionBestRepList = haveResolution.filter(function (rep) {
	    return rep.width === playerWidth && rep.height === playerHeight;
	  });
	  highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
	
	  var resolutionBestRep = resolutionBestRepList.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0];
	  var resolutionPlusOneList;
	  var resolutionPlusOneSmallest;
	  var resolutionPlusOneRep; // find the smallest variant that is larger than the player
	  // if there is no match of exact resolution
	
	  if (!resolutionBestRep) {
	    resolutionPlusOneList = haveResolution.filter(function (rep) {
	      return rep.width > playerWidth || rep.height > playerHeight;
	    }); // find all the variants have the same smallest resolution
	
	    resolutionPlusOneSmallest = resolutionPlusOneList.filter(function (rep) {
	      return rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height;
	    }); // ensure that we also pick the highest bandwidth variant that
	    // is just-larger-than the video player
	
	    highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
	    resolutionPlusOneRep = resolutionPlusOneSmallest.filter(function (rep) {
	      return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	    })[0];
	  }
	
	  var leastPixelDiffRep; // If this selector proves to be better than others,
	  // resolutionPlusOneRep and resolutionBestRep and all
	  // the code involving them should be removed.
	
	  if (masterPlaylistController.experimentalLeastPixelDiffSelector) {
	    // find the variant that is closest to the player's pixel size
	    var leastPixelDiffList = haveResolution.map(function (rep) {
	      rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
	      return rep;
	    }); // get the highest bandwidth, closest resolution playlist
	
	    stableSort(leastPixelDiffList, function (left, right) {
	      // sort by highest bandwidth if pixelDiff is the same
	      if (left.pixelDiff === right.pixelDiff) {
	        return right.bandwidth - left.bandwidth;
	      }
	
	      return left.pixelDiff - right.pixelDiff;
	    });
	    leastPixelDiffRep = leastPixelDiffList[0];
	  } // fallback chain of variants
	
	
	  var chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	  if (chosenRep && chosenRep.playlist) {
	    var _type = 'sortedPlaylistReps';
	
	    if (leastPixelDiffRep) {
	      _type = 'leastPixelDiffRep';
	    } else if (resolutionPlusOneRep) {
	      _type = 'resolutionPlusOneRep';
	    } else if (resolutionBestRep) {
	      _type = 'resolutionBestRep';
	    } else if (bandwidthBestRep) {
	      _type = 'bandwidthBestRep';
	    } else if (enabledPlaylistReps[0]) {
	      _type = 'enabledPlaylistReps';
	    }
	
	    logFn("choosing " + representationToString(chosenRep) + " using " + _type + " with options", options);
	    return chosenRep.playlist;
	  }
	
	  logFn('could not choose a playlist with options', options);
	  return null;
	};
	/**
	 * Chooses the appropriate media playlist based on the most recent
	 * bandwidth estimate and the player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var lastBandwidthSelector = function lastBandwidthSelector() {
	  var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	  return simpleSelector(this.playlists.master, this.systemBandwidth, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	};
	/**
	 * Chooses the appropriate media playlist based on an
	 * exponential-weighted moving average of the bandwidth after
	 * filtering for player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @param {number} decay - a number between 0 and 1. Higher values of
	 * this parameter will cause previous bandwidth estimates to lose
	 * significance more quickly.
	 * @return {Function} a function which can be invoked to create a new
	 * playlist selector function.
	 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
	 */
	
	
	var movingAverageBandwidthSelector = function movingAverageBandwidthSelector(decay) {
	  var average = -1;
	  var lastSystemBandwidth = -1;
	
	  if (decay < 0 || decay > 1) {
	    throw new Error('Moving average bandwidth decay must be between 0 and 1.');
	  }
	
	  return function () {
	    var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	
	    if (average < 0) {
	      average = this.systemBandwidth;
	      lastSystemBandwidth = this.systemBandwidth;
	    } // stop the average value from decaying for every 250ms
	    // when the systemBandwidth is constant
	    // and
	    // stop average from setting to a very low value when the
	    // systemBandwidth becomes 0 in case of chunk cancellation
	
	
	    if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
	      average = decay * this.systemBandwidth + (1 - decay) * average;
	      lastSystemBandwidth = this.systemBandwidth;
	    }
	
	    return simpleSelector(this.playlists.master, average, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	  };
	};
	/**
	 * Chooses the appropriate media playlist based on the potential to rebuffer
	 *
	 * @param {Object} settings
	 *        Object of information required to use this selector
	 * @param {Object} settings.master
	 *        Object representation of the master manifest
	 * @param {number} settings.currentTime
	 *        The current time of the player
	 * @param {number} settings.bandwidth
	 *        Current measured bandwidth
	 * @param {number} settings.duration
	 *        Duration of the media
	 * @param {number} settings.segmentDuration
	 *        Segment duration to be used in round trip time calculations
	 * @param {number} settings.timeUntilRebuffer
	 *        Time left in seconds until the player has to rebuffer
	 * @param {number} settings.currentTimeline
	 *        The current timeline segments are being loaded from
	 * @param {SyncController} settings.syncController
	 *        SyncController for determining if we have a sync point for a given playlist
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The highest bandwidth playlist with the least amount of rebuffering
	 *         {Number} return.rebufferingImpact
	 *         The amount of time in seconds switching to this playlist will rebuffer. A
	 *         negative value means that switching will cause zero rebuffering.
	 */
	
	
	var minRebufferMaxBandwidthSelector = function minRebufferMaxBandwidthSelector(settings) {
	  var master = settings.master,
	      currentTime = settings.currentTime,
	      bandwidth = settings.bandwidth,
	      duration = settings.duration,
	      segmentDuration = settings.segmentDuration,
	      timeUntilRebuffer = settings.timeUntilRebuffer,
	      currentTimeline = settings.currentTimeline,
	      syncController = settings.syncController; // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  var compatiblePlaylists = master.playlists.filter(function (playlist) {
	    return !Playlist.isIncompatible(playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylists = compatiblePlaylists.filter(Playlist.isEnabled);
	
	  if (!enabledPlaylists.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylists = compatiblePlaylists.filter(function (playlist) {
	      return !Playlist.isDisabled(playlist);
	    });
	  }
	
	  var bandwidthPlaylists = enabledPlaylists.filter(Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
	  var rebufferingEstimates = bandwidthPlaylists.map(function (playlist) {
	    var syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
	    // sync request first. This will double the request time
	
	    var numRequests = syncPoint ? 1 : 2;
	    var requestTimeEstimate = Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
	    var rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
	    return {
	      playlist: playlist,
	      rebufferingImpact: rebufferingImpact
	    };
	  });
	  var noRebufferingPlaylists = rebufferingEstimates.filter(function (estimate) {
	    return estimate.rebufferingImpact <= 0;
	  }); // Sort by bandwidth DESC
	
	  stableSort(noRebufferingPlaylists, function (a, b) {
	    return comparePlaylistBandwidth(b.playlist, a.playlist);
	  });
	
	  if (noRebufferingPlaylists.length) {
	    return noRebufferingPlaylists[0];
	  }
	
	  stableSort(rebufferingEstimates, function (a, b) {
	    return a.rebufferingImpact - b.rebufferingImpact;
	  });
	  return rebufferingEstimates[0] || null;
	};
	/**
	 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
	 * one with video.  If no renditions with video exist, return the lowest audio rendition.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
	 *         exists pick the lowest audio rendition.
	 */
	
	
	var lowestBitrateCompatibleVariantSelector = function lowestBitrateCompatibleVariantSelector() {
	  var _this = this; // filter out any playlists that have been excluded due to
	  // incompatible configurations or playback errors
	
	
	  var playlists = this.playlists.master.playlists.filter(Playlist.isEnabled); // Sort ascending by bitrate
	
	  stableSort(playlists, function (a, b) {
	    return comparePlaylistBandwidth(a, b);
	  }); // Parse and assume that playlists with no video codec have no video
	  // (this is not necessarily true, although it is generally true).
	  //
	  // If an entire manifest has no valid videos everything will get filtered
	  // out.
	
	  var playlistsWithVideo = playlists.filter(function (playlist) {
	    return !!codecsForPlaylist(_this.playlists.master, playlist).video;
	  });
	  return playlistsWithVideo[0] || null;
	};
	/**
	 * Combine all segments into a single Uint8Array
	 *
	 * @param {Object} segmentObj
	 * @return {Uint8Array} concatenated bytes
	 * @private
	 */
	
	
	var concatSegments = function concatSegments(segmentObj) {
	  var offset = 0;
	  var tempBuffer;
	
	  if (segmentObj.bytes) {
	    tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
	
	    segmentObj.segments.forEach(function (segment) {
	      tempBuffer.set(segment, offset);
	      offset += segment.byteLength;
	    });
	  }
	
	  return tempBuffer;
	};
	/**
	 * @file text-tracks.js
	 */
	
	/**
	 * Create captions text tracks on video.js if they do not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {Object} tech the video.js tech
	 * @param {Object} captionStream the caption stream to create
	 * @private
	 */
	
	
	var createCaptionsTrackIfNotExists = function createCaptionsTrackIfNotExists(inbandTextTracks, tech, captionStream) {
	  if (!inbandTextTracks[captionStream]) {
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-608'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-608'
	    });
	    var instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
	
	    if (/^cc708_/.test(captionStream)) {
	      instreamId = 'SERVICE' + captionStream.split('_')[1];
	    }
	
	    var track = tech.textTracks().getTrackById(instreamId);
	
	    if (track) {
	      // Resuse an existing track with a CC# id because this was
	      // very likely created by videojs-contrib-hls from information
	      // in the m3u8 for us to use
	      inbandTextTracks[captionStream] = track;
	    } else {
	      // This section gets called when we have caption services that aren't specified in the manifest.
	      // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
	      var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	      var label = captionStream;
	      var language = captionStream;
	      var def = false;
	      var captionService = captionServices[instreamId];
	
	      if (captionService) {
	        label = captionService.label;
	        language = captionService.language;
	        def = captionService["default"];
	      } // Otherwise, create a track with the default `CC#` label and
	      // without a language
	
	
	      inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
	        kind: 'captions',
	        id: instreamId,
	        // TODO: investigate why this doesn't seem to turn the caption on by default
	        "default": def,
	        label: label,
	        language: language
	      }, false).track;
	    }
	  }
	};
	/**
	 * Add caption text track data to a source handler given an array of captions
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {Array} captionArray an array of caption data
	 * @private
	 */
	
	
	var addCaptionData = function addCaptionData(_ref) {
	  var inbandTextTracks = _ref.inbandTextTracks,
	      captionArray = _ref.captionArray,
	      timestampOffset = _ref.timestampOffset;
	
	  if (!captionArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  captionArray.forEach(function (caption) {
	    var track = caption.stream;
	    inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
	  });
	};
	/**
	 * Define properties on a cue for backwards compatability,
	 * but warn the user that the way that they are using it
	 * is depricated and will be removed at a later date.
	 *
	 * @param {Cue} cue the cue to add the properties on
	 * @private
	 */
	
	
	var deprecateOldCue = function deprecateOldCue(cue) {
	  Object.defineProperties(cue.frame, {
	    id: {
	      get: function get() {
	        videojs.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
	        return cue.value.key;
	      }
	    },
	    value: {
	      get: function get() {
	        videojs.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    },
	    privateData: {
	      get: function get() {
	        videojs.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    }
	  });
	};
	/**
	 * Add metadata text track data to a source handler given an array of metadata
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {Array} metadataArray an array of meta data
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {number} videoDuration the duration of the video
	 * @private
	 */
	
	
	var addMetadata = function addMetadata(_ref2) {
	  var inbandTextTracks = _ref2.inbandTextTracks,
	      metadataArray = _ref2.metadataArray,
	      timestampOffset = _ref2.timestampOffset,
	      videoDuration = _ref2.videoDuration;
	
	  if (!metadataArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  var metadataTrack = inbandTextTracks.metadataTrack_;
	
	  if (!metadataTrack) {
	    return;
	  }
	
	  metadataArray.forEach(function (metadata) {
	    var time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
	    // ignore this bit of metadata.
	    // This likely occurs when you have an non-timed ID3 tag like TIT2,
	    // which is the "Title/Songname/Content description" frame
	
	    if (typeof time !== 'number' || window__default['default'].isNaN(time) || time < 0 || !(time < Infinity)) {
	      return;
	    }
	
	    metadata.frames.forEach(function (frame) {
	      var cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
	      cue.frame = frame;
	      cue.value = frame;
	      deprecateOldCue(cue);
	      metadataTrack.addCue(cue);
	    });
	  });
	
	  if (!metadataTrack.cues || !metadataTrack.cues.length) {
	    return;
	  } // Updating the metadeta cues so that
	  // the endTime of each cue is the startTime of the next cue
	  // the endTime of last cue is the duration of the video
	
	
	  var cues = metadataTrack.cues;
	  var cuesArray = []; // Create a copy of the TextTrackCueList...
	  // ...disregarding cues with a falsey value
	
	  for (var i = 0; i < cues.length; i++) {
	    if (cues[i]) {
	      cuesArray.push(cues[i]);
	    }
	  } // Group cues by their startTime value
	
	
	  var cuesGroupedByStartTime = cuesArray.reduce(function (obj, cue) {
	    var timeSlot = obj[cue.startTime] || [];
	    timeSlot.push(cue);
	    obj[cue.startTime] = timeSlot;
	    return obj;
	  }, {}); // Sort startTimes by ascending order
	
	  var sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort(function (a, b) {
	    return Number(a) - Number(b);
	  }); // Map each cue group's endTime to the next group's startTime
	
	  sortedStartTimes.forEach(function (startTime, idx) {
	    var cueGroup = cuesGroupedByStartTime[startTime];
	    var nextTime = Number(sortedStartTimes[idx + 1]) || videoDuration; // Map each cue's endTime the next group's startTime
	
	    cueGroup.forEach(function (cue) {
	      cue.endTime = nextTime;
	    });
	  });
	};
	/**
	 * Create metadata text track on video.js if it does not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {string} dispatchType the inband metadata track dispatch type
	 * @param {Object} tech the video.js tech
	 * @private
	 */
	
	
	var createMetadataTrackIfNotExists = function createMetadataTrackIfNotExists(inbandTextTracks, dispatchType, tech) {
	  if (inbandTextTracks.metadataTrack_) {
	    return;
	  }
	
	  inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
	    kind: 'metadata',
	    label: 'Timed Metadata'
	  }, false).track;
	  inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
	};
	/**
	 * Remove cues from a track on video.js.
	 *
	 * @param {Double} start start of where we should remove the cue
	 * @param {Double} end end of where the we should remove the cue
	 * @param {Object} track the text track to remove the cues from
	 * @private
	 */
	
	
	var removeCuesFromTrack = function removeCuesFromTrack(start, end, track) {
	  var i;
	  var cue;
	
	  if (!track) {
	    return;
	  }
	
	  if (!track.cues) {
	    return;
	  }
	
	  i = track.cues.length;
	
	  while (i--) {
	    cue = track.cues[i]; // Remove any cue within the provided start and end time
	
	    if (cue.startTime >= start && cue.endTime <= end) {
	      track.removeCue(cue);
	    }
	  }
	};
	/**
	 * Remove duplicate cues from a track on video.js (a cue is considered a
	 * duplicate if it has the same time interval and text as another)
	 *
	 * @param {Object} track the text track to remove the duplicate cues from
	 * @private
	 */
	
	
	var removeDuplicateCuesFromTrack = function removeDuplicateCuesFromTrack(track) {
	  var cues = track.cues;
	
	  if (!cues) {
	    return;
	  }
	
	  for (var i = 0; i < cues.length; i++) {
	    var duplicates = [];
	    var occurrences = 0;
	
	    for (var j = 0; j < cues.length; j++) {
	      if (cues[i].startTime === cues[j].startTime && cues[i].endTime === cues[j].endTime && cues[i].text === cues[j].text) {
	        occurrences++;
	
	        if (occurrences > 1) {
	          duplicates.push(cues[j]);
	        }
	      }
	    }
	
	    if (duplicates.length) {
	      duplicates.forEach(function (dupe) {
	        return track.removeCue(dupe);
	      });
	    }
	  }
	};
	/**
	 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
	 * front of current time.
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {number} currentTime
	 *        The current time
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 * @return {Array}
	 *         List of gops considered safe to append over
	 */
	
	
	var gopsSafeToAlignWith = function gopsSafeToAlignWith(buffer, currentTime, mapping) {
	  if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) {
	    return [];
	  } // pts value for current time + 3 seconds to give a bit more wiggle room
	
	
	  var currentTimePts = Math.ceil((currentTime - mapping + 3) * clock.ONE_SECOND_IN_TS);
	  var i;
	
	  for (i = 0; i < buffer.length; i++) {
	    if (buffer[i].pts > currentTimePts) {
	      break;
	    }
	  }
	
	  return buffer.slice(i);
	};
	/**
	 * Appends gop information (timing and byteLength) received by the transmuxer for the
	 * gops appended in the last call to appendBuffer
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Array} gops
	 *        List of new gop information
	 * @param {boolean} replace
	 *        If true, replace the buffer with the new gop information. If false, append the
	 *        new gop information to the buffer in the right location of time.
	 * @return {Array}
	 *         Updated list of gop information
	 */
	
	
	var updateGopBuffer = function updateGopBuffer(buffer, gops, replace) {
	  if (!gops.length) {
	    return buffer;
	  }
	
	  if (replace) {
	    // If we are in safe append mode, then completely overwrite the gop buffer
	    // with the most recent appeneded data. This will make sure that when appending
	    // future segments, we only try to align with gops that are both ahead of current
	    // time and in the last segment appended.
	    return gops.slice();
	  }
	
	  var start = gops[0].pts;
	  var i = 0;
	
	  for (i; i < buffer.length; i++) {
	    if (buffer[i].pts >= start) {
	      break;
	    }
	  }
	
	  return buffer.slice(0, i).concat(gops);
	};
	/**
	 * Removes gop information in buffer that overlaps with provided start and end
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Double} start
	 *        position to start the remove at
	 * @param {Double} end
	 *        position to end the remove at
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 */
	
	
	var removeGopBuffer = function removeGopBuffer(buffer, start, end, mapping) {
	  var startPts = Math.ceil((start - mapping) * clock.ONE_SECOND_IN_TS);
	  var endPts = Math.ceil((end - mapping) * clock.ONE_SECOND_IN_TS);
	  var updatedBuffer = buffer.slice();
	  var i = buffer.length;
	
	  while (i--) {
	    if (buffer[i].pts <= endPts) {
	      break;
	    }
	  }
	
	  if (i === -1) {
	    // no removal because end of remove range is before start of buffer
	    return updatedBuffer;
	  }
	
	  var j = i + 1;
	
	  while (j--) {
	    if (buffer[j].pts <= startPts) {
	      break;
	    }
	  } // clamp remove range start to 0 index
	
	
	  j = Math.max(j, 0);
	  updatedBuffer.splice(j, i - j + 1);
	  return updatedBuffer;
	};
	
	var shallowEqual = function shallowEqual(a, b) {
	  // if both are undefined
	  // or one or the other is undefined
	  // they are not equal
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // they are the same object and thus, equal
	
	
	  if (a === b) {
	    return true;
	  } // sort keys so we can make sure they have
	  // all the same keys later.
	
	
	  var akeys = Object.keys(a).sort();
	  var bkeys = Object.keys(b).sort(); // different number of keys, not equal
	
	  if (akeys.length !== bkeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < akeys.length; i++) {
	    var key = akeys[i]; // different sorted keys, not equal
	
	    if (key !== bkeys[i]) {
	      return false;
	    } // different values, not equal
	
	
	    if (a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	}; // https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
	
	
	var QUOTA_EXCEEDED_ERR = 22;
	/**
	 * The segment loader has no recourse except to fetch a segment in the
	 * current playlist and use the internal timestamps in that segment to
	 * generate a syncPoint. This function returns a good candidate index
	 * for that process.
	 *
	 * @param {Array} segments - the segments array from a playlist.
	 * @return {number} An index of a segment from the playlist to load
	 */
	
	var getSyncSegmentCandidate = function getSyncSegmentCandidate(currentTimeline, segments, targetTime) {
	  segments = segments || [];
	  var timelineSegments = [];
	  var time = 0;
	
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	
	    if (currentTimeline === segment.timeline) {
	      timelineSegments.push(i);
	      time += segment.duration;
	
	      if (time > targetTime) {
	        return i;
	      }
	    }
	  }
	
	  if (timelineSegments.length === 0) {
	    return 0;
	  } // default to the last timeline segment
	
	
	  return timelineSegments[timelineSegments.length - 1];
	}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
	// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
	// as a start to prevent any potential issues with removing content too close to the
	// playhead.
	
	
	var MIN_BACK_BUFFER = 1; // in ms
	
	var CHECK_BUFFER_DELAY = 500;
	
	var finite = function finite(num) {
	  return typeof num === 'number' && isFinite(num);
	}; // With most content hovering around 30fps, if a segment has a duration less than a half
	// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
	// not accurately reflect the rest of the content.
	
	
	var MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
	
	var illegalMediaSwitch = function illegalMediaSwitch(loaderType, startingMedia, trackInfo) {
	  // Although these checks should most likely cover non 'main' types, for now it narrows
	  // the scope of our checks.
	  if (loaderType !== 'main' || !startingMedia || !trackInfo) {
	    return null;
	  }
	
	  if (!trackInfo.hasAudio && !trackInfo.hasVideo) {
	    return 'Neither audio nor video found in segment.';
	  }
	
	  if (startingMedia.hasVideo && !trackInfo.hasVideo) {
	    return 'Only audio found in segment when we expected video.' + ' We can\'t switch to audio only from a stream that had video.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  if (!startingMedia.hasVideo && trackInfo.hasVideo) {
	    return 'Video found in segment when we expected only audio.' + ' We can\'t switch to a stream with video from an audio only stream.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  return null;
	};
	/**
	 * Calculates a time value that is safe to remove from the back buffer without interrupting
	 * playback.
	 *
	 * @param {TimeRange} seekable
	 *        The current seekable range
	 * @param {number} currentTime
	 *        The current time of the player
	 * @param {number} targetDuration
	 *        The target duration of the current playlist
	 * @return {number}
	 *         Time that is safe to remove from the back buffer without interrupting playback
	 */
	
	
	var safeBackBufferTrimTime = function safeBackBufferTrimTime(seekable, currentTime, targetDuration) {
	  // 30 seconds before the playhead provides a safe default for trimming.
	  //
	  // Choosing a reasonable default is particularly important for high bitrate content and
	  // VOD videos/live streams with large windows, as the buffer may end up overfilled and
	  // throw an APPEND_BUFFER_ERR.
	  var trimTime = currentTime - Config.BACK_BUFFER_LENGTH;
	
	  if (seekable.length) {
	    // Some live playlists may have a shorter window of content than the full allowed back
	    // buffer. For these playlists, don't save content that's no longer within the window.
	    trimTime = Math.max(trimTime, seekable.start(0));
	  } // Don't remove within target duration of the current time to avoid the possibility of
	  // removing the GOP currently being played, as removing it can cause playback stalls.
	
	
	  var maxTrimTime = currentTime - targetDuration;
	  return Math.min(maxTrimTime, trimTime);
	};
	
	var segmentInfoString = function segmentInfoString(segmentInfo) {
	  var startOfSegment = segmentInfo.startOfSegment,
	      duration = segmentInfo.duration,
	      segment = segmentInfo.segment,
	      part = segmentInfo.part,
	      _segmentInfo$playlist = segmentInfo.playlist,
	      seq = _segmentInfo$playlist.mediaSequence,
	      id = _segmentInfo$playlist.id,
	      _segmentInfo$playlist2 = _segmentInfo$playlist.segments,
	      segments = _segmentInfo$playlist2 === void 0 ? [] : _segmentInfo$playlist2,
	      index = segmentInfo.mediaIndex,
	      partIndex = segmentInfo.partIndex,
	      timeline = segmentInfo.timeline;
	  var segmentLen = segments.length - 1;
	  var selection = 'mediaIndex/partIndex increment';
	
	  if (segmentInfo.getMediaInfoForTime) {
	    selection = "getMediaInfoForTime (" + segmentInfo.getMediaInfoForTime + ")";
	  } else if (segmentInfo.isSyncRequest) {
	    selection = 'getSyncSegmentCandidate (isSyncRequest)';
	  }
	
	  if (segmentInfo.independent) {
	    selection += " with independent " + segmentInfo.independent;
	  }
	
	  var hasPartIndex = typeof partIndex === 'number';
	  var name = segmentInfo.segment.uri ? 'segment' : 'pre-segment';
	  var zeroBasedPartCount = hasPartIndex ? getKnownPartCount({
	    preloadSegment: segment
	  }) - 1 : 0;
	  return name + " [" + (seq + index) + "/" + (seq + segmentLen) + "]" + (hasPartIndex ? " part [" + partIndex + "/" + zeroBasedPartCount + "]" : '') + (" segment start/end [" + segment.start + " => " + segment.end + "]") + (hasPartIndex ? " part start/end [" + part.start + " => " + part.end + "]" : '') + (" startOfSegment [" + startOfSegment + "]") + (" duration [" + duration + "]") + (" timeline [" + timeline + "]") + (" selected by [" + selection + "]") + (" playlist [" + id + "]");
	};
	
	var timingInfoPropertyForMedia = function timingInfoPropertyForMedia(mediaType) {
	  return mediaType + "TimingInfo";
	};
	/**
	 * Returns the timestamp offset to use for the segment.
	 *
	 * @param {number} segmentTimeline
	 *        The timeline of the segment
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} startOfSegment
	 *        The estimated segment start
	 * @param {TimeRange[]} buffered
	 *        The loader's buffer
	 * @param {boolean} overrideCheck
	 *        If true, no checks are made to see if the timestamp offset value should be set,
	 *        but sets it directly to a value.
	 *
	 * @return {number|null}
	 *         Either a number representing a new timestamp offset, or null if the segment is
	 *         part of the same timeline
	 */
	
	
	var timestampOffsetForSegment = function timestampOffsetForSegment(_ref) {
	  var segmentTimeline = _ref.segmentTimeline,
	      currentTimeline = _ref.currentTimeline,
	      startOfSegment = _ref.startOfSegment,
	      buffered = _ref.buffered,
	      overrideCheck = _ref.overrideCheck; // Check to see if we are crossing a discontinuity to see if we need to set the
	  // timestamp offset on the transmuxer and source buffer.
	  //
	  // Previously, we changed the timestampOffset if the start of this segment was less than
	  // the currently set timestampOffset, but this isn't desirable as it can produce bad
	  // behavior, especially around long running live streams.
	
	  if (!overrideCheck && segmentTimeline === currentTimeline) {
	    return null;
	  } // When changing renditions, it's possible to request a segment on an older timeline. For
	  // instance, given two renditions with the following:
	  //
	  // #EXTINF:10
	  // segment1
	  // #EXT-X-DISCONTINUITY
	  // #EXTINF:10
	  // segment2
	  // #EXTINF:10
	  // segment3
	  //
	  // And the current player state:
	  //
	  // current time: 8
	  // buffer: 0 => 20
	  //
	  // The next segment on the current rendition would be segment3, filling the buffer from
	  // 20s onwards. However, if a rendition switch happens after segment2 was requested,
	  // then the next segment to be requested will be segment1 from the new rendition in
	  // order to fill time 8 and onwards. Using the buffered end would result in repeated
	  // content (since it would position segment1 of the new rendition starting at 20s). This
	  // case can be identified when the new segment's timeline is a prior value. Instead of
	  // using the buffered end, the startOfSegment can be used, which, hopefully, will be
	  // more accurate to the actual start time of the segment.
	
	
	  if (segmentTimeline < currentTimeline) {
	    return startOfSegment;
	  } // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
	  // value uses the end of the last segment if it is available. While this value
	  // should often be correct, it's better to rely on the buffered end, as the new
	  // content post discontinuity should line up with the buffered end as if it were
	  // time 0 for the new content.
	
	
	  return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
	};
	/**
	 * Returns whether or not the loader should wait for a timeline change from the timeline
	 * change controller before processing the segment.
	 *
	 * Primary timing in VHS goes by video. This is different from most media players, as
	 * audio is more often used as the primary timing source. For the foreseeable future, VHS
	 * will continue to use video as the primary timing source, due to the current logic and
	 * expectations built around it.
	
	 * Since the timing follows video, in order to maintain sync, the video loader is
	 * responsible for setting both audio and video source buffer timestamp offsets.
	 *
	 * Setting different values for audio and video source buffers could lead to
	 * desyncing. The following examples demonstrate some of the situations where this
	 * distinction is important. Note that all of these cases involve demuxed content. When
	 * content is muxed, the audio and video are packaged together, therefore syncing
	 * separate media playlists is not an issue.
	 *
	 * CASE 1: Audio prepares to load a new timeline before video:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:                     ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader              ^
	 *
	 * In the above example, the audio loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the video loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the audio loader goes ahead and loads and appends the 6th segment before the video
	 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
	 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
	 * the audio loader must provide the audioAppendStart value to trim the content in the
	 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
	 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
	 * segment until that value is provided.
	 *
	 * CASE 2: Video prepares to load a new timeline before audio:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:             ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader                      ^
	 *
	 * In the above example, the video loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the audio loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the video loader goes ahead and loads and appends the 6th segment, then once the
	 * segment is loaded and processed, both the video and audio timestamp offsets will be
	 * set, since video is used as the primary timing source. This is to ensure content lines
	 * up appropriately, as any modifications to the video timing are reflected by audio when
	 * the video loader sets the audio and video timestamp offsets to the same value. However,
	 * setting the timestamp offset for audio before audio has had a chance to change
	 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
	 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
	 *
	 * CASE 3: When seeking, audio prepares to load a new timeline before video
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:           ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader            ^
	 *
	 * In the above example, both audio and video loaders are loading segments from timeline
	 * 0, but imagine that the seek originated from timeline 1.
	 *
	 * When seeking to a new timeline, the timestamp offset will be set based on the expected
	 * segment start of the loaded video segment. In order to maintain sync, the audio loader
	 * must wait for the video loader to load its segment and update both the audio and video
	 * timestamp offsets before it may load and append its own segment. This is the case
	 * whether the seek results in a mismatched segment request (e.g., the audio loader
	 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
	 * loaders choose to load the same segment index from each playlist, as the segments may
	 * not be aligned perfectly, even for matching segment indexes.
	 *
	 * @param {Object} timelinechangeController
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} segmentTimeline
	 *        The timeline of the segment being loaded
	 * @param {('main'|'audio')} loaderType
	 *        The loader type
	 * @param {boolean} audioDisabled
	 *        Whether the audio is disabled for the loader. This should only be true when the
	 *        loader may have muxed audio in its segment, but should not append it, e.g., for
	 *        the main loader when an alternate audio playlist is active.
	 *
	 * @return {boolean}
	 *         Whether the loader should wait for a timeline change from the timeline change
	 *         controller before processing the segment
	 */
	
	
	var shouldWaitForTimelineChange = function shouldWaitForTimelineChange(_ref2) {
	  var timelineChangeController = _ref2.timelineChangeController,
	      currentTimeline = _ref2.currentTimeline,
	      segmentTimeline = _ref2.segmentTimeline,
	      loaderType = _ref2.loaderType,
	      audioDisabled = _ref2.audioDisabled;
	
	  if (currentTimeline === segmentTimeline) {
	    return false;
	  }
	
	  if (loaderType === 'audio') {
	    var lastMainTimelineChange = timelineChangeController.lastTimelineChange({
	      type: 'main'
	    }); // Audio loader should wait if:
	    //
	    // * main hasn't had a timeline change yet (thus has not loaded its first segment)
	    // * main hasn't yet changed to the timeline audio is looking to load
	
	    return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
	  } // The main loader only needs to wait for timeline changes if there's demuxed audio.
	  // Otherwise, there's nothing to wait for, since audio would be muxed into the main
	  // loader's segments (or the content is audio/video only and handled by the main
	  // loader).
	
	
	  if (loaderType === 'main' && audioDisabled) {
	    var pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
	      type: 'audio'
	    }); // Main loader should wait for the audio loader if audio is not pending a timeline
	    // change to the current timeline.
	    //
	    // Since the main loader is responsible for setting the timestamp offset for both
	    // audio and video, the main loader must wait for audio to be about to change to its
	    // timeline before setting the offset, otherwise, if audio is behind in loading,
	    // segments from the previous timeline would be adjusted by the new timestamp offset.
	    //
	    // This requirement means that video will not cross a timeline until the audio is
	    // about to cross to it, so that way audio and video will always cross the timeline
	    // together.
	    //
	    // In addition to normal timeline changes, these rules also apply to the start of a
	    // stream (going from a non-existent timeline, -1, to timeline 0). It's important
	    // that these rules apply to the first timeline change because if they did not, it's
	    // possible that the main loader will cross two timelines before the audio loader has
	    // crossed one. Logic may be implemented to handle the startup as a special case, but
	    // it's easier to simply treat all timeline changes the same.
	
	    if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) {
	      return false;
	    }
	
	    return true;
	  }
	
	  return false;
	};
	
	var mediaDuration = function mediaDuration(timingInfos) {
	  var maxDuration = 0;
	  ['video', 'audio'].forEach(function (type) {
	    var typeTimingInfo = timingInfos[type + "TimingInfo"];
	
	    if (!typeTimingInfo) {
	      return;
	    }
	
	    var start = typeTimingInfo.start,
	        end = typeTimingInfo.end;
	    var duration;
	
	    if (typeof start === 'bigint' || typeof end === 'bigint') {
	      duration = window__default['default'].BigInt(end) - window__default['default'].BigInt(start);
	    } else if (typeof start === 'number' && typeof end === 'number') {
	      duration = end - start;
	    }
	
	    if (typeof duration !== 'undefined' && duration > maxDuration) {
	      maxDuration = duration;
	    }
	  }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
	  // as we only need BigInt when we are above that.
	
	  if (typeof maxDuration === 'bigint' && maxDuration < Number.MAX_SAFE_INTEGER) {
	    maxDuration = Number(maxDuration);
	  }
	
	  return maxDuration;
	};
	
	var segmentTooLong = function segmentTooLong(_ref3) {
	  var segmentDuration = _ref3.segmentDuration,
	      maxDuration = _ref3.maxDuration; // 0 duration segments are most likely due to metadata only segments or a lack of
	  // information.
	
	  if (!segmentDuration) {
	    return false;
	  } // For HLS:
	  //
	  // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
	  // The EXTINF duration of each Media Segment in the Playlist
	  // file, when rounded to the nearest integer, MUST be less than or equal
	  // to the target duration; longer segments can trigger playback stalls
	  // or other errors.
	  //
	  // For DASH, the mpd-parser uses the largest reported segment duration as the target
	  // duration. Although that reported duration is occasionally approximate (i.e., not
	  // exact), a strict check may report that a segment is too long more often in DASH.
	
	
	  return Math.round(segmentDuration) > maxDuration + TIME_FUDGE_FACTOR;
	};
	
	var getTroublesomeSegmentDurationMessage = function getTroublesomeSegmentDurationMessage(segmentInfo, sourceType) {
	  // Right now we aren't following DASH's timing model exactly, so only perform
	  // this check for HLS content.
	  if (sourceType !== 'hls') {
	    return null;
	  }
	
	  var segmentDuration = mediaDuration({
	    audioTimingInfo: segmentInfo.audioTimingInfo,
	    videoTimingInfo: segmentInfo.videoTimingInfo
	  }); // Don't report if we lack information.
	  //
	  // If the segment has a duration of 0 it is either a lack of information or a
	  // metadata only segment and shouldn't be reported here.
	
	  if (!segmentDuration) {
	    return null;
	  }
	
	  var targetDuration = segmentInfo.playlist.targetDuration;
	  var isSegmentWayTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration * 2
	  });
	  var isSegmentSlightlyTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration
	  });
	  var segmentTooLongMessage = "Segment with index " + segmentInfo.mediaIndex + " " + ("from playlist " + segmentInfo.playlist.id + " ") + ("has a duration of " + segmentDuration + " ") + ("when the reported duration is " + segmentInfo.duration + " ") + ("and the target duration is " + targetDuration + ". ") + 'For HLS content, a duration in excess of the target duration may result in ' + 'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for ' + 'more details: ' + 'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';
	
	  if (isSegmentWayTooLong || isSegmentSlightlyTooLong) {
	    return {
	      severity: isSegmentWayTooLong ? 'warn' : 'info',
	      message: segmentTooLongMessage
	    };
	  }
	
	  return null;
	};
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class SegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var SegmentLoader = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SegmentLoader, _videojs$EventTarget);
	
	  function SegmentLoader(settings, options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // check pre-conditions
	
	    if (!settings) {
	      throw new TypeError('Initialization settings are required');
	    }
	
	    if (typeof settings.currentTime !== 'function') {
	      throw new TypeError('No currentTime getter specified');
	    }
	
	    if (!settings.mediaSource) {
	      throw new TypeError('No MediaSource specified');
	    } // public properties
	
	
	    _this.bandwidth = settings.bandwidth;
	    _this.throughput = {
	      rate: 0,
	      count: 0
	    };
	    _this.roundTrip = NaN;
	
	    _this.resetStats_();
	
	    _this.mediaIndex = null;
	    _this.partIndex = null; // private settings
	
	    _this.hasPlayed_ = settings.hasPlayed;
	    _this.currentTime_ = settings.currentTime;
	    _this.seekable_ = settings.seekable;
	    _this.seeking_ = settings.seeking;
	    _this.duration_ = settings.duration;
	    _this.mediaSource_ = settings.mediaSource;
	    _this.vhs_ = settings.vhs;
	    _this.loaderType_ = settings.loaderType;
	    _this.currentMediaInfo_ = void 0;
	    _this.startingMediaInfo_ = void 0;
	    _this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
	    _this.goalBufferLength_ = settings.goalBufferLength;
	    _this.sourceType_ = settings.sourceType;
	    _this.sourceUpdater_ = settings.sourceUpdater;
	    _this.inbandTextTracks_ = settings.inbandTextTracks;
	    _this.state_ = 'INIT';
	    _this.timelineChangeController_ = settings.timelineChangeController;
	    _this.shouldSaveSegmentTimingInfo_ = true;
	    _this.parse708captions_ = settings.parse708captions;
	    _this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
	    _this.captionServices_ = settings.captionServices;
	    _this.experimentalExactManifestTimings = settings.experimentalExactManifestTimings; // private instance variables
	
	    _this.checkBufferTimeout_ = null;
	    _this.error_ = void 0;
	    _this.currentTimeline_ = -1;
	    _this.pendingSegment_ = null;
	    _this.xhrOptions_ = null;
	    _this.pendingSegments_ = [];
	    _this.audioDisabled_ = false;
	    _this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
	
	    _this.gopBuffer_ = [];
	    _this.timeMapping_ = 0;
	    _this.safeAppend_ = videojs.browser.IE_VERSION >= 11;
	    _this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    _this.playlistOfLastInitSegment_ = {
	      audio: null,
	      video: null
	    };
	    _this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
	    // information yet to start the loading process (e.g., if the audio loader wants to
	    // load a segment from the next timeline but the main loader hasn't yet crossed that
	    // timeline), then the load call will be added to the queue until it is ready to be
	    // processed.
	
	    _this.loadQueue_ = [];
	    _this.metadataQueue_ = {
	      id3: [],
	      caption: []
	    };
	    _this.waitingOnRemove_ = false;
	    _this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
	
	    _this.activeInitSegmentId_ = null;
	    _this.initSegments_ = {}; // HLSe playback
	
	    _this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
	    _this.keyCache_ = {};
	    _this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
	    // between a time in the display time and a segment index within
	    // a playlist
	
	    _this.syncController_ = settings.syncController;
	    _this.syncPoint_ = {
	      segmentIndex: 0,
	      time: 0
	    };
	    _this.transmuxer_ = _this.createTransmuxer_();
	
	    _this.triggerSyncInfoUpdate_ = function () {
	      return _this.trigger('syncinfoupdate');
	    };
	
	    _this.syncController_.on('syncinfoupdate', _this.triggerSyncInfoUpdate_);
	
	    _this.mediaSource_.addEventListener('sourceopen', function () {
	      if (!_this.isEndOfStream_()) {
	        _this.ended_ = false;
	      }
	    }); // ...for determining the fetch location
	
	
	    _this.fetchAtBuffer_ = false;
	    _this.logger_ = logger("SegmentLoader[" + _this.loaderType_ + "]");
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'state', {
	      get: function get() {
	        return this.state_;
	      },
	      set: function set(newState) {
	        if (newState !== this.state_) {
	          this.logger_(this.state_ + " -> " + newState);
	          this.state_ = newState;
	          this.trigger('statechange');
	        }
	      }
	    });
	
	    _this.sourceUpdater_.on('ready', function () {
	      if (_this.hasEnoughInfoToAppend_()) {
	        _this.processCallQueue_();
	      }
	    }); // Only the main loader needs to listen for pending timeline changes, as the main
	    // loader should wait for audio to be ready to change its timeline so that both main
	    // and audio timelines change together. For more details, see the
	    // shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'main') {
	      _this.timelineChangeController_.on('pendingtimelinechange', function () {
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    } // The main loader only listens on pending timeline changes, but the audio loader,
	    // since its loads follow main, needs to listen on timeline changes. For more details,
	    // see the shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'audio') {
	      _this.timelineChangeController_.on('timelinechange', function () {
	        if (_this.hasEnoughInfoToLoad_()) {
	          _this.processLoadQueue_();
	        }
	
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    }
	
	    return _this;
	  }
	
	  var _proto = SegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    return segmentTransmuxer.createTransmuxer({
	      remux: false,
	      alignGopsAtEnd: this.safeAppend_,
	      keepOriginalTimestamps: true,
	      parse708captions: this.parse708captions_,
	      captionServices: this.captionServices_
	    });
	  }
	  /**
	   * reset all of our media stats
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetStats_ = function resetStats_() {
	    this.mediaBytesTransferred = 0;
	    this.mediaRequests = 0;
	    this.mediaRequestsAborted = 0;
	    this.mediaRequestsTimedout = 0;
	    this.mediaRequestsErrored = 0;
	    this.mediaTransferDuration = 0;
	    this.mediaSecondsLoaded = 0;
	    this.mediaAppends = 0;
	  }
	  /**
	   * dispose of the SegmentLoader and reset to the default state
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.state = 'DISPOSED';
	    this.pause();
	    this.abort_();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.terminate();
	    }
	
	    this.resetStats_();
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    if (this.syncController_ && this.triggerSyncInfoUpdate_) {
	      this.syncController_.off('syncinfoupdate', this.triggerSyncInfoUpdate_);
	    }
	
	    this.off();
	  };
	
	  _proto.setAudio = function setAudio(enable) {
	    this.audioDisabled_ = !enable;
	
	    if (enable) {
	      this.appendInitSegment_.audio = true;
	    } else {
	      // remove current track audio if it gets disabled
	      this.sourceUpdater_.removeAudio(0, this.duration_());
	    }
	  }
	  /**
	   * abort anything that is currently doing on with the SegmentLoader
	   * and reset to a default state
	   */
	  ;
	
	  _proto.abort = function abort() {
	    if (this.state !== 'WAITING') {
	      if (this.pendingSegment_) {
	        this.pendingSegment_ = null;
	      }
	
	      return;
	    }
	
	    this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
	    // since we are no longer "waiting" on any requests. XHR callback is not always run
	    // when the request is aborted. This will prevent the loader from being stuck in the
	    // WAITING state indefinitely.
	
	    this.state = 'READY'; // don't wait for buffer check timeouts to begin fetching the
	    // next segment
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * abort all pending xhr requests and null any pending segements
	   *
	   * @private
	   */
	  ;
	
	  _proto.abort_ = function abort_() {
	    if (this.pendingSegment_ && this.pendingSegment_.abortRequests) {
	      this.pendingSegment_.abortRequests();
	    } // clear out the segment being processed
	
	
	    this.pendingSegment_ = null;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
	    this.waitingOnRemove_ = false;
	    window__default['default'].clearTimeout(this.quotaExceededErrorRetryTimeout_);
	    this.quotaExceededErrorRetryTimeout_ = null;
	  };
	
	  _proto.checkForAbort_ = function checkForAbort_(requestId) {
	    // If the state is APPENDING, then aborts will not modify the state, meaning the first
	    // callback that happens should reset the state to READY so that loading can continue.
	    if (this.state === 'APPENDING' && !this.pendingSegment_) {
	      this.state = 'READY';
	      return true;
	    }
	
	    if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * set an error on the segment loader and null out any pending segements
	   *
	   * @param {Error} error the error to set on the SegmentLoader
	   * @return {Error} the error that was set or that is currently set
	   */
	  ;
	
	  _proto.error = function error(_error) {
	    if (typeof _error !== 'undefined') {
	      this.logger_('error occurred:', _error);
	      this.error_ = _error;
	    }
	
	    this.pendingSegment_ = null;
	    return this.error_;
	  };
	
	  _proto.endOfStream = function endOfStream() {
	    this.ended_ = true;
	
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.gopBuffer_.length = 0;
	    this.pause();
	    this.trigger('ended');
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    var trackInfo = this.getMediaInfo_();
	
	    if (!this.sourceUpdater_ || !trackInfo) {
	      return videojs.createTimeRanges();
	    }
	
	    if (this.loaderType_ === 'main') {
	      var hasAudio = trackInfo.hasAudio,
	          hasVideo = trackInfo.hasVideo,
	          isMuxed = trackInfo.isMuxed;
	
	      if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) {
	        return this.sourceUpdater_.buffered();
	      }
	
	      if (hasVideo) {
	        return this.sourceUpdater_.videoBuffered();
	      }
	    } // One case that can be ignored for now is audio only with alt audio,
	    // as we don't yet have proper support for that.
	
	
	    return this.sourceUpdater_.audioBuffered();
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: map.bytes,
	        tracks: map.tracks,
	        timescales: map.timescales
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Gets and sets key for the provided key
	   *
	   * @param {Object} key
	   *        The key object representing the key to get or set
	   * @param {boolean=} set
	   *        If true, the key for the provided key should be saved
	   * @return {Object}
	   *         Key object for desired key
	   */
	  ;
	
	  _proto.segmentKey = function segmentKey(key, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!key) {
	      return null;
	    }
	
	    var id = segmentKeyId(key);
	    var storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
	
	    if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) {
	      this.keyCache_[id] = storedKey = {
	        resolvedUri: key.resolvedUri,
	        bytes: key.bytes
	      };
	    }
	
	    var result = {
	      resolvedUri: (storedKey || key).resolvedUri
	    };
	
	    if (storedKey) {
	      result.bytes = storedKey.bytes;
	    }
	
	    return result;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && !this.paused();
	  }
	  /**
	   * load a playlist and start to fill the buffer
	   */
	  ;
	
	  _proto.load = function load() {
	    // un-pause
	    this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
	    // specified
	
	    if (!this.playlist_) {
	      return;
	    } // if all the configuration is ready, initialize and begin loading
	
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    } // if we're in the middle of processing a segment already, don't
	    // kick off an additional segment request
	
	
	    if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') {
	      return;
	    }
	
	    this.state = 'READY';
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY'; // if this is the audio segment loader, and it hasn't been inited before, then any old
	    // audio data from the muxed content should be removed
	
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * set a playlist on the segment loader
	   *
	   * @param {PlaylistLoader} media the playlist to set on the segment loader
	   */
	  ;
	
	  _proto.playlist = function playlist(newPlaylist, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!newPlaylist) {
	      return;
	    }
	
	    var oldPlaylist = this.playlist_;
	    var segmentInfo = this.pendingSegment_;
	    this.playlist_ = newPlaylist;
	    this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
	    // is always our zero-time so force a sync update each time the playlist
	    // is refreshed from the server
	    //
	    // Use the INIT state to determine if playback has started, as the playlist sync info
	    // should be fixed once requests begin (as sync points are generated based on sync
	    // info), but not before then.
	
	    if (this.state === 'INIT') {
	      newPlaylist.syncInfo = {
	        mediaSequence: newPlaylist.mediaSequence,
	        time: 0
	      }; // Setting the date time mapping means mapping the program date time (if available)
	      // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
	      // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
	      // be updated as the playlist is refreshed before the loader starts loading, the
	      // program date time mapping needs to be updated as well.
	      //
	      // This mapping is only done for the main loader because a program date time should
	      // map equivalently between playlists.
	
	      if (this.loaderType_ === 'main') {
	        this.syncController_.setDateTimeMappingForStart(newPlaylist);
	      }
	    }
	
	    var oldId = null;
	
	    if (oldPlaylist) {
	      if (oldPlaylist.id) {
	        oldId = oldPlaylist.id;
	      } else if (oldPlaylist.uri) {
	        oldId = oldPlaylist.uri;
	      }
	    }
	
	    this.logger_("playlist update [" + oldId + " => " + (newPlaylist.id || newPlaylist.uri) + "]"); // in VOD, this is always a rendition switch (or we updated our syncInfo above)
	    // in LIVE, we always want to update with new playlists (including refreshes)
	
	    this.trigger('syncinfoupdate'); // if we were unpaused but waiting for a playlist, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    }
	
	    if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
	      if (this.mediaIndex !== null) {
	        // we must reset/resync the segment loader when we switch renditions and
	        // the segment loader is already synced to the previous rendition
	        // on playlist changes we want it to be possible to fetch
	        // at the buffer for vod but not for live. So we use resetLoader
	        // for live and resyncLoader for vod. We want this because
	        // if a playlist uses independent and non-independent segments/parts the
	        // buffer may not accurately reflect the next segment that we should try
	        // downloading.
	        if (!newPlaylist.endList) {
	          this.resetLoader();
	        } else {
	          this.resyncLoader();
	        }
	      }
	
	      this.currentMediaInfo_ = void 0;
	      this.trigger('playlistupdate'); // the rest of this function depends on `oldPlaylist` being defined
	
	      return;
	    } // we reloaded the same playlist so we are in a live scenario
	    // and we will likely need to adjust the mediaIndex
	
	
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
	    this.logger_("live window shift [" + mediaSequenceDiff + "]"); // update the mediaIndex on the SegmentLoader
	    // this is important because we can abort a request and this value must be
	    // equal to the last appended mediaIndex
	
	    if (this.mediaIndex !== null) {
	      this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
	      // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
	      // new playlist was incremented by 1.
	
	      if (this.mediaIndex < 0) {
	        this.mediaIndex = null;
	        this.partIndex = null;
	      } else {
	        var segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
	        // unless parts fell off of the playlist for this segment.
	        // In that case we need to reset partIndex and resync
	
	        if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
	          var mediaIndex = this.mediaIndex;
	          this.logger_("currently processing part (index " + this.partIndex + ") no longer exists.");
	          this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
	          // as the part was dropped from our current playlists segment.
	          // The mediaIndex will still be valid so keep that around.
	
	          this.mediaIndex = mediaIndex;
	        }
	      }
	    } // update the mediaIndex on the SegmentInfo object
	    // this is important because we will update this.mediaIndex with this value
	    // in `handleAppendsDone_` after the segment has been successfully appended
	
	
	    if (segmentInfo) {
	      segmentInfo.mediaIndex -= mediaSequenceDiff;
	
	      if (segmentInfo.mediaIndex < 0) {
	        segmentInfo.mediaIndex = null;
	        segmentInfo.partIndex = null;
	      } else {
	        // we need to update the referenced segment so that timing information is
	        // saved for the new playlist's segment, however, if the segment fell off the
	        // playlist, we can leave the old reference and just lose the timing info
	        if (segmentInfo.mediaIndex >= 0) {
	          segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
	        }
	
	        if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) {
	          segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
	        }
	      }
	    }
	
	    this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
	  }
	  /**
	   * Prevent the loader from fetching additional segments. If there
	   * is a segment request outstanding, it will finish processing
	   * before the loader halts. A segment loader can be unpaused by
	   * calling load().
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	      this.checkBufferTimeout_ = null;
	    }
	  }
	  /**
	   * Returns whether the segment loader is fetching additional
	   * segments when given the opportunity. This property can be
	   * modified through calls to pause() and load().
	   */
	  ;
	
	  _proto.paused = function paused() {
	    return this.checkBufferTimeout_ === null;
	  }
	  /**
	   * Delete all the buffered data and reset the SegmentLoader
	   *
	   * @param {Function} [done] an optional callback to be executed when the remove
	   * operation is complete
	   */
	  ;
	
	  _proto.resetEverything = function resetEverything(done) {
	    this.ended_ = false;
	    this.activeInitSegmentId_ = null;
	    this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
	    // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
	    // we then clamp the value to duration if necessary.
	
	    this.remove(0, Infinity, done); // clears fmp4 captions
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearAllMp4Captions'
	      }); // reset the cache in the transmuxer
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	    }
	  }
	  /**
	   * Force the SegmentLoader to resync and start loading around the currentTime instead
	   * of starting at the end of the buffer
	   *
	   * Useful for fast quality changes
	   */
	  ;
	
	  _proto.resetLoader = function resetLoader() {
	    this.fetchAtBuffer_ = false;
	    this.resyncLoader();
	  }
	  /**
	   * Force the SegmentLoader to restart synchronization and make a conservative guess
	   * before returning to the simple walk-forward method
	   */
	  ;
	
	  _proto.resyncLoader = function resyncLoader() {
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.mediaIndex = null;
	    this.partIndex = null;
	    this.syncPoint_ = null;
	    this.isPendingTimestampOffset_ = false;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.abort();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   * @param {Function} [done] - an optional callback to be executed when the remove
	   * @param {boolean} force - force all remove operations to happen
	   * operation is complete
	   */
	  ;
	
	  _proto.remove = function remove(start, end, done, force) {
	    if (done === void 0) {
	      done = function done() {};
	    }
	
	    if (force === void 0) {
	      force = false;
	    } // clamp end to duration if we need to remove everything.
	    // This is due to a browser bug that causes issues if we remove to Infinity.
	    // videojs/videojs-contrib-hls#1225
	
	
	    if (end === Infinity) {
	      end = this.duration_();
	    } // skip removes that would throw an error
	    // commonly happens during a rendition switch at the start of a video
	    // from start 0 to end 0
	
	
	    if (end <= start) {
	      this.logger_('skipping remove because end ${end} is <= start ${start}');
	      return;
	    }
	
	    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
	      this.logger_('skipping remove because no source updater or starting media info'); // nothing to remove if we haven't processed any media
	
	      return;
	    } // set it to one to complete this function's removes
	
	
	    var removesRemaining = 1;
	
	    var removeFinished = function removeFinished() {
	      removesRemaining--;
	
	      if (removesRemaining === 0) {
	        done();
	      }
	    };
	
	    if (force || !this.audioDisabled_) {
	      removesRemaining++;
	      this.sourceUpdater_.removeAudio(start, end, removeFinished);
	    } // While it would be better to only remove video if the main loader has video, this
	    // should be safe with audio only as removeVideo will call back even if there's no
	    // video buffer.
	    //
	    // In theory we can check to see if there's video before calling the remove, but in
	    // the event that we're switching between renditions and from video to audio only
	    // (when we add support for that), we may need to clear the video contents despite
	    // what the new media will contain.
	
	
	    if (force || this.loaderType_ === 'main') {
	      this.gopBuffer_ = removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
	      removesRemaining++;
	      this.sourceUpdater_.removeVideo(start, end, removeFinished);
	    } // remove any captions and ID3 tags
	
	
	    for (var track in this.inbandTextTracks_) {
	      removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
	
	    removeFinished();
	  }
	  /**
	   * (re-)schedule monitorBufferTick_ to run as soon as possible
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBuffer_ = function monitorBuffer_() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), 1);
	  }
	  /**
	   * As long as the SegmentLoader is in the READY state, periodically
	   * invoke fillBuffer_().
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBufferTick_ = function monitorBufferTick_() {
	    if (this.state === 'READY') {
	      this.fillBuffer_();
	    }
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), CHECK_BUFFER_DELAY);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    // TODO since the source buffer maintains a queue, and we shouldn't call this function
	    // except when we're ready for the next segment, this check can most likely be removed
	    if (this.sourceUpdater_.updating()) {
	      return;
	    } // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      this.isPendingTimestampOffset_ = false;
	      this.timelineChangeController_.pendingTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      });
	    }
	
	    this.loadSegment_(segmentInfo);
	  }
	  /**
	   * Determines if we should call endOfStream on the media source based
	   * on the state of the buffer or if appened segment was the final
	   * segment in the playlist.
	   *
	   * @param {number} [mediaIndex] the media index of segment we last appended
	   * @param {Object} [playlist] a media playlist object
	   * @return {boolean} do we need to call endOfStream on the MediaSource
	   */
	  ;
	
	  _proto.isEndOfStream_ = function isEndOfStream_(mediaIndex, playlist, partIndex) {
	    if (mediaIndex === void 0) {
	      mediaIndex = this.mediaIndex;
	    }
	
	    if (playlist === void 0) {
	      playlist = this.playlist_;
	    }
	
	    if (partIndex === void 0) {
	      partIndex = this.partIndex;
	    }
	
	    if (!playlist || !this.mediaSource_) {
	      return false;
	    }
	
	    var segment = typeof mediaIndex === 'number' && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
	
	    var appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
	
	    var appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
	    // so that MediaSources can trigger the `ended` event when it runs out of
	    // buffered data instead of waiting for me
	
	    return playlist.endList && this.mediaSource_.readyState === 'open' && appendedLastSegment && appendedLastPart;
	  }
	  /**
	   * Determines what request should be made given current segment loader state.
	   *
	   * @return {Object} a request object that describes the segment/part to load
	   */
	  ;
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    var buffered = this.buffered_();
	    var bufferedEnd = lastBufferedEnd(buffered) || 0;
	    var bufferedTime = timeAheadOf(buffered, this.currentTime_());
	    var preloaded = !this.hasPlayed_() && bufferedTime >= 1;
	    var haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
	    var segments = this.playlist_.segments; // return no segment if:
	    // 1. we don't have segments
	    // 2. The video has not yet played and we already downloaded a segment
	    // 3. we already have enough buffered time
	
	    if (!segments.length || preloaded || haveEnoughBuffer) {
	      return null;
	    }
	
	    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
	    var next = {
	      partIndex: null,
	      mediaIndex: null,
	      startOfSegment: null,
	      playlist: this.playlist_,
	      isSyncRequest: Boolean(!this.syncPoint_)
	    };
	
	    if (next.isSyncRequest) {
	      next.mediaIndex = getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
	    } else if (this.mediaIndex !== null) {
	      var segment = segments[this.mediaIndex];
	      var partIndex = typeof this.partIndex === 'number' ? this.partIndex : -1;
	      next.startOfSegment = segment.end ? segment.end : bufferedEnd;
	
	      if (segment.parts && segment.parts[partIndex + 1]) {
	        next.mediaIndex = this.mediaIndex;
	        next.partIndex = partIndex + 1;
	      } else {
	        next.mediaIndex = this.mediaIndex + 1;
	      }
	    } else {
	      // Find the segment containing the end of the buffer or current time.
	      var _Playlist$getMediaInf = Playlist.getMediaInfoForTime({
	        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
	        playlist: this.playlist_,
	        currentTime: this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_(),
	        startingPartIndex: this.syncPoint_.partIndex,
	        startingSegmentIndex: this.syncPoint_.segmentIndex,
	        startTime: this.syncPoint_.time
	      }),
	          segmentIndex = _Playlist$getMediaInf.segmentIndex,
	          startTime = _Playlist$getMediaInf.startTime,
	          _partIndex = _Playlist$getMediaInf.partIndex;
	
	      next.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + bufferedEnd : "currentTime " + this.currentTime_();
	      next.mediaIndex = segmentIndex;
	      next.startOfSegment = startTime;
	      next.partIndex = _partIndex;
	    }
	
	    var nextSegment = segments[next.mediaIndex];
	    var nextPart = nextSegment && typeof next.partIndex === 'number' && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
	    // the next partIndex is invalid do not choose a next segment.
	
	    if (!nextSegment || typeof next.partIndex === 'number' && !nextPart) {
	      return null;
	    } // if the next segment has parts, and we don't have a partIndex.
	    // Set partIndex to 0
	
	
	    if (typeof next.partIndex !== 'number' && nextSegment.parts) {
	      next.partIndex = 0;
	      nextPart = nextSegment.parts[0];
	    } // if we have no buffered data then we need to make sure
	    // that the next part we append is "independent" if possible.
	    // So we check if the previous part is independent, and request
	    // it if it is.
	
	
	    if (!bufferedTime && nextPart && !nextPart.independent) {
	      if (next.partIndex === 0) {
	        var lastSegment = segments[next.mediaIndex - 1];
	        var lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
	
	        if (lastSegmentLastPart && lastSegmentLastPart.independent) {
	          next.mediaIndex -= 1;
	          next.partIndex = lastSegment.parts.length - 1;
	          next.independent = 'previous segment';
	        }
	      } else if (nextSegment.parts[next.partIndex - 1].independent) {
	        next.partIndex -= 1;
	        next.independent = 'previous part';
	      }
	    }
	
	    var ended = this.mediaSource_ && this.mediaSource_.readyState === 'ended'; // do not choose a next segment if all of the following:
	    // 1. this is the last segment in the playlist
	    // 2. end of stream has been called on the media source already
	    // 3. the player is not seeking
	
	    if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) {
	      return null;
	    }
	
	    return this.generateSegmentInfo_(next);
	  };
	
	  _proto.generateSegmentInfo_ = function generateSegmentInfo_(options) {
	    var independent = options.independent,
	        playlist = options.playlist,
	        mediaIndex = options.mediaIndex,
	        startOfSegment = options.startOfSegment,
	        isSyncRequest = options.isSyncRequest,
	        partIndex = options.partIndex,
	        forceTimestampOffset = options.forceTimestampOffset,
	        getMediaInfoForTime = options.getMediaInfoForTime;
	    var segment = playlist.segments[mediaIndex];
	    var part = typeof partIndex === 'number' && segment.parts[partIndex];
	    var segmentInfo = {
	      requestId: 'segment-loader-' + Math.random(),
	      // resolve the segment URL relative to the playlist
	      uri: part && part.resolvedUri || segment.resolvedUri,
	      // the segment's mediaIndex at the time it was requested
	      mediaIndex: mediaIndex,
	      partIndex: part ? partIndex : null,
	      // whether or not to update the SegmentLoader's state with this
	      // segment's mediaIndex
	      isSyncRequest: isSyncRequest,
	      startOfSegment: startOfSegment,
	      // the segment's playlist
	      playlist: playlist,
	      // unencrypted bytes of the segment
	      bytes: null,
	      // when a key is defined for this segment, the encrypted bytes
	      encryptedBytes: null,
	      // The target timestampOffset for this segment when we append it
	      // to the source buffer
	      timestampOffset: null,
	      // The timeline that the segment is in
	      timeline: segment.timeline,
	      // The expected duration of the segment in seconds
	      duration: part && part.duration || segment.duration,
	      // retain the segment in case the playlist updates while doing an async process
	      segment: segment,
	      part: part,
	      byteLength: 0,
	      transmuxer: this.transmuxer_,
	      // type of getMediaInfoForTime that was used to get this segment
	      getMediaInfoForTime: getMediaInfoForTime,
	      independent: independent
	    };
	    var overrideCheck = typeof forceTimestampOffset !== 'undefined' ? forceTimestampOffset : this.isPendingTimestampOffset_;
	    segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
	      segmentTimeline: segment.timeline,
	      currentTimeline: this.currentTimeline_,
	      startOfSegment: startOfSegment,
	      buffered: this.buffered_(),
	      overrideCheck: overrideCheck
	    });
	    var audioBufferedEnd = lastBufferedEnd(this.sourceUpdater_.audioBuffered());
	
	    if (typeof audioBufferedEnd === 'number') {
	      // since the transmuxer is using the actual timing values, but the buffer is
	      // adjusted by the timestamp offset, we must adjust the value here
	      segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
	    }
	
	    if (this.sourceUpdater_.videoBuffered().length) {
	      segmentInfo.gopsToAlignWith = gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
	      // adjusted by the timestmap offset, we must adjust the value here
	      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
	    }
	
	    return segmentInfo;
	  } // get the timestampoffset for a segment,
	  // added so that vtt segment loader can override and prevent
	  // adding timestamp offsets.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_(options) {
	    return timestampOffsetForSegment(options);
	  }
	  /**
	   * Determines if the network has enough bandwidth to complete the current segment
	   * request in a timely manner. If not, the request will be aborted early and bandwidth
	   * updated to trigger a playlist switch.
	   *
	   * @param {Object} stats
	   *        Object containing stats about the request timing and size
	   * @private
	   */
	  ;
	
	  _proto.earlyAbortWhenNeeded_ = function earlyAbortWhenNeeded_(stats) {
	    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
	    // TODO: Replace using timeout with a boolean indicating whether this playlist is
	    //       the lowestEnabledRendition.
	    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
	    !this.playlist_.attributes.BANDWIDTH) {
	      return;
	    } // Wait at least 1 second since the first byte of data has been received before
	    // using the calculated bandwidth from the progress event to allow the bitrate
	    // to stabilize
	
	
	    if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) {
	      return;
	    }
	
	    var currentTime = this.currentTime_();
	    var measuredBandwidth = stats.bandwidth;
	    var segmentDuration = this.pendingSegment_.duration;
	    var requestTimeRemaining = Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
	    // if we are only left with less than 1 second when the request completes.
	    // A negative timeUntilRebuffering indicates we are already rebuffering
	
	    var timeUntilRebuffer$1 = timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
	    // is larger than the estimated time until the player runs out of forward buffer
	
	    if (requestTimeRemaining <= timeUntilRebuffer$1) {
	      return;
	    }
	
	    var switchCandidate = minRebufferMaxBandwidthSelector({
	      master: this.vhs_.playlists.master,
	      currentTime: currentTime,
	      bandwidth: measuredBandwidth,
	      duration: this.duration_(),
	      segmentDuration: segmentDuration,
	      timeUntilRebuffer: timeUntilRebuffer$1,
	      currentTimeline: this.currentTimeline_,
	      syncController: this.syncController_
	    });
	
	    if (!switchCandidate) {
	      return;
	    }
	
	    var rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
	    var timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
	    var minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
	    // potential round trip time of the new request so that we are not too aggressive
	    // with switching to a playlist that might save us a fraction of a second.
	
	    if (timeUntilRebuffer$1 <= TIME_FUDGE_FACTOR) {
	      minimumTimeSaving = 1;
	    }
	
	    if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) {
	      return;
	    } // set the bandwidth to that of the desired playlist being sure to scale by
	    // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
	    // don't trigger a bandwidthupdate as the bandwidth is artifial
	
	
	    this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * Config.BANDWIDTH_VARIANCE + 1;
	    this.trigger('earlyabort');
	  };
	
	  _proto.handleAbort_ = function handleAbort_(segmentInfo) {
	    this.logger_("Aborting " + segmentInfoString(segmentInfo));
	    this.mediaRequestsAborted += 1;
	  }
	  /**
	   * XHR `progress` event handler
	   *
	   * @param {Event}
	   *        The XHR `progress` event
	   * @param {Object} simpleSegment
	   *        A simplified segment object copy
	   * @private
	   */
	  ;
	
	  _proto.handleProgress_ = function handleProgress_(event, simpleSegment) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    this.trigger('progress');
	  };
	
	  _proto.handleTrackInfo_ = function handleTrackInfo_(simpleSegment, trackInfo) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    if (this.checkForIllegalMediaSwitch(trackInfo)) {
	      return;
	    }
	
	    trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
	    // Guard against cases where we're not getting track info at all until we are
	    // certain that all streams will provide it.
	
	    if (!shallowEqual(this.currentMediaInfo_, trackInfo)) {
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	      this.startingMediaInfo_ = trackInfo;
	      this.currentMediaInfo_ = trackInfo;
	      this.logger_('trackinfo update', trackInfo);
	      this.trigger('trackinfo');
	    } // trackinfo may cause an abort if the trackinfo
	    // causes a codec change to an unsupported codec.
	
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // set trackinfo on the pending segment so that
	    // it can append.
	
	
	    this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleTimingInfo_ = function handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var timingInfoProperty = timingInfoPropertyForMedia(mediaType);
	    segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
	    segmentInfo[timingInfoProperty][timeType] = time;
	    this.logger_("timinginfo: " + mediaType + " - " + timeType + " - " + time); // check if any calls were waiting on the timing info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleCaptions_ = function handleCaptions_(simpleSegment, captionData) {
	    var _this2 = this;
	
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // This could only happen with fmp4 segments, but
	    // should still not happen in general
	
	
	    if (captionData.length === 0) {
	      this.logger_('SegmentLoader received no captions from a caption event');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
	    // can be adjusted by the timestamp offset
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
	    var captionTracks = {}; // get total start/end and captions for each track/stream
	
	    captionData.forEach(function (caption) {
	      // caption.stream is actually a track name...
	      // set to the existing values in tracks or default values
	      captionTracks[caption.stream] = captionTracks[caption.stream] || {
	        // Infinity, as any other value will be less than this
	        startTime: Infinity,
	        captions: [],
	        // 0 as an other value will be more than this
	        endTime: 0
	      };
	      var captionTrack = captionTracks[caption.stream];
	      captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
	      captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
	      captionTrack.captions.push(caption);
	    });
	    Object.keys(captionTracks).forEach(function (trackName) {
	      var _captionTracks$trackN = captionTracks[trackName],
	          startTime = _captionTracks$trackN.startTime,
	          endTime = _captionTracks$trackN.endTime,
	          captions = _captionTracks$trackN.captions;
	      var inbandTextTracks = _this2.inbandTextTracks_;
	
	      _this2.logger_("adding cues from " + startTime + " -> " + endTime + " for " + trackName);
	
	      createCaptionsTrackIfNotExists(inbandTextTracks, _this2.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
	      // We do this because a rendition change that also changes the timescale for captions
	      // will result in captions being re-parsed for certain segments. If we add them again
	      // without clearing we will have two of the same captions visible.
	
	      removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
	      addCaptionData({
	        captionArray: captions,
	        inbandTextTracks: inbandTextTracks,
	        timestampOffset: timestampOffset
	      });
	    }); // Reset stored captions since we added parsed
	    // captions to a text track at this point
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  };
	
	  _proto.handleId3_ = function handleId3_(simpleSegment, id3Frames, dispatchType) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
	    // audio/video source with a metadata track, and an alt audio with a metadata track.
	    // However, this probably won't happen, and if it does it can be handled then.
	
	    createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.vhs_.tech_);
	    addMetadata({
	      inbandTextTracks: this.inbandTextTracks_,
	      metadataArray: id3Frames,
	      timestampOffset: timestampOffset,
	      videoDuration: this.duration_()
	    });
	  };
	
	  _proto.processMetadataQueue_ = function processMetadataQueue_() {
	    this.metadataQueue_.id3.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.caption.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	  };
	
	  _proto.processCallQueue_ = function processCallQueue_() {
	    var callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.callQueue_ = [];
	    callQueue.forEach(function (fun) {
	      return fun();
	    });
	  };
	
	  _proto.processLoadQueue_ = function processLoadQueue_() {
	    var loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.loadQueue_ = [];
	    loadQueue.forEach(function (fun) {
	      return fun();
	    });
	  }
	  /**
	   * Determines whether the loader has enough info to load the next segment.
	   *
	   * @return {boolean}
	   *         Whether or not the loader has enough info to load the next segment
	   */
	  ;
	
	  _proto.hasEnoughInfoToLoad_ = function hasEnoughInfoToLoad_() {
	    // Since primary timing goes by video, only the audio loader potentially needs to wait
	    // to load.
	    if (this.loaderType_ !== 'audio') {
	      return true;
	    }
	
	    var segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
	    // enough info to load.
	
	    if (!segmentInfo) {
	      return false;
	    } // The first segment can and should be loaded immediately so that source buffers are
	    // created together (before appending). Source buffer creation uses the presence of
	    // audio and video data to determine whether to create audio/video source buffers, and
	    // uses processed (transmuxed or parsed) media to determine the types required.
	
	
	    if (!this.getCurrentMediaInfo_()) {
	      return true;
	    }
	
	    if ( // Technically, instead of waiting to load a segment on timeline changes, a segment
	    // can be requested and downloaded and only wait before it is transmuxed or parsed.
	    // But in practice, there are a few reasons why it is better to wait until a loader
	    // is ready to append that segment before requesting and downloading:
	    //
	    // 1. Because audio and main loaders cross discontinuities together, if this loader
	    //    is waiting for the other to catch up, then instead of requesting another
	    //    segment and using up more bandwidth, by not yet loading, more bandwidth is
	    //    allotted to the loader currently behind.
	    // 2. media-segment-request doesn't have to have logic to consider whether a segment
	    // is ready to be processed or not, isolating the queueing behavior to the loader.
	    // 3. The audio loader bases some of its segment properties on timing information
	    //    provided by the main loader, meaning that, if the logic for waiting on
	    //    processing was in media-segment-request, then it would also need to know how
	    //    to re-generate the segment information after the main loader caught up.
	    shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCurrentMediaInfo_ = function getCurrentMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
	  };
	
	  _proto.getMediaInfo_ = function getMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
	  };
	
	  _proto.getPendingSegmentPlaylist = function getPendingSegmentPlaylist() {
	    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
	  };
	
	  _proto.hasEnoughInfoToAppend_ = function hasEnoughInfoToAppend_() {
	    if (!this.sourceUpdater_.ready()) {
	      return false;
	    } // If content needs to be removed or the loader is waiting on an append reattempt,
	    // then no additional content should be appended until the prior append is resolved.
	
	
	    if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) {
	      return false;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
	    // we do not have information on this specific
	    // segment yet
	
	    if (!segmentInfo || !trackInfo) {
	      return false;
	    }
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	
	    if (hasVideo && !segmentInfo.videoTimingInfo) {
	      return false;
	    } // muxed content only relies on video timing information for now.
	
	
	    if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) {
	      return false;
	    }
	
	    if (shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.handleData_ = function handleData_(simpleSegment, result) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // If there's anything in the call queue, then this data came later and should be
	    // executed after the calls currently queued.
	
	
	    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
	      this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
	
	    this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
	
	    this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
	    // logic may change behavior depending on the state, and changing state too early may
	    // inflate our estimates of bandwidth. In the future this should be re-examined to
	    // note more granular states.
	    // don't process and append data if the mediaSource is closed
	
	    if (this.mediaSource_.readyState === 'closed') {
	      return;
	    } // if this request included an initialization segment, save that data
	    // to the initSegment cache
	
	
	    if (simpleSegment.map) {
	      simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
	
	      segmentInfo.segment.map = simpleSegment.map;
	    } // if this request included a segment key, save that data in the cache
	
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    segmentInfo.isFmp4 = simpleSegment.isFmp4;
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	
	    if (segmentInfo.isFmp4) {
	      this.trigger('fmp4');
	      segmentInfo.timingInfo.start = segmentInfo[timingInfoPropertyForMedia(result.type)].start;
	    } else {
	      var trackInfo = this.getCurrentMediaInfo_();
	      var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	      var firstVideoFrameTimeForData;
	
	      if (useVideoTimingInfo) {
	        firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
	      } // Segment loader knows more about segment timing than the transmuxer (in certain
	      // aspects), so make any changes required for a more accurate start time.
	      // Don't set the end time yet, as the segment may not be finished processing.
	
	
	      segmentInfo.timingInfo.start = this.trueSegmentStart_({
	        currentStart: segmentInfo.timingInfo.start,
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex,
	        currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
	        useVideoTimingInfo: useVideoTimingInfo,
	        firstVideoFrameTimeForData: firstVideoFrameTimeForData,
	        videoTimingInfo: segmentInfo.videoTimingInfo,
	        audioTimingInfo: segmentInfo.audioTimingInfo
	      });
	    } // Init segments for audio and video only need to be appended in certain cases. Now
	    // that data is about to be appended, we can check the final cases to determine
	    // whether we should append an init segment.
	
	
	    this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
	    // as we use the start of the segment to offset the best guess (playlist provided)
	    // timestamp offset.
	
	    this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
	    // be appended or not.
	
	    if (segmentInfo.isSyncRequest) {
	      // first save/update our timing info for this segment.
	      // this is what allows us to choose an accurate segment
	      // and the main reason we make a sync request.
	      this.updateTimingInfoEnd_(segmentInfo);
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	      var next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
	      // after taking into account its timing info, do not append it.
	
	      if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
	        this.logger_('sync segment was incorrect, not appending');
	        return;
	      } // otherwise append it like any other segment as our guess was correct.
	
	
	      this.logger_('sync segment was correct, appending');
	    } // Save some state so that in the future anything waiting on first append (and/or
	    // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
	    // we need some notion of whether the timestamp offset or other relevant information
	    // has had a chance to be set.
	
	
	    segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
	
	    this.processMetadataQueue_();
	    this.appendData_(segmentInfo, result);
	  };
	
	  _proto.updateAppendInitSegmentStatus = function updateAppendInitSegmentStatus(segmentInfo, type) {
	    // alt audio doesn't manage timestamp offset
	    if (this.loaderType_ === 'main' && typeof segmentInfo.timestampOffset === 'number' && // in the case that we're handling partial data, we don't want to append an init
	    // segment for each chunk
	    !segmentInfo.changedTimestampOffset) {
	      // if the timestamp offset changed, the timeline may have changed, so we have to re-
	      // append init segments
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	    }
	
	    if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) {
	      // make sure we append init segment on playlist changes, in case the media config
	      // changed
	      this.appendInitSegment_[type] = true;
	    }
	  };
	
	  _proto.getInitSegmentAndUpdateState_ = function getInitSegmentAndUpdateState_(_ref4) {
	    var type = _ref4.type,
	        initSegment = _ref4.initSegment,
	        map = _ref4.map,
	        playlist = _ref4.playlist; // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
	    // (Section 3) required to parse the applicable Media Segments.  It applies to every
	    // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
	    // or until the end of the playlist."
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
	
	    if (map) {
	      var id = initSegmentId(map);
	
	      if (this.activeInitSegmentId_ === id) {
	        // don't need to re-append the init segment if the ID matches
	        return null;
	      } // a map-specified init segment takes priority over any transmuxed (or otherwise
	      // obtained) init segment
	      //
	      // this also caches the init segment for later use
	
	
	      initSegment = this.initSegmentForMap(map, true).bytes;
	      this.activeInitSegmentId_ = id;
	    } // We used to always prepend init segments for video, however, that shouldn't be
	    // necessary. Instead, we should only append on changes, similar to what we've always
	    // done for audio. This is more important (though may not be that important) for
	    // frame-by-frame appending for LHLS, simply because of the increased quantity of
	    // appends.
	
	
	    if (initSegment && this.appendInitSegment_[type]) {
	      // Make sure we track the playlist that we last used for the init segment, so that
	      // we can re-append the init segment in the event that we get data from a new
	      // playlist. Discontinuities and track changes are handled in other sections.
	      this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
	
	      this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
	      // we are appending the muxer init segment
	
	      this.activeInitSegmentId_ = null;
	      return initSegment;
	    }
	
	    return null;
	  };
	
	  _proto.handleQuotaExceededError_ = function handleQuotaExceededError_(_ref5, error) {
	    var _this3 = this;
	
	    var segmentInfo = _ref5.segmentInfo,
	        type = _ref5.type,
	        bytes = _ref5.bytes;
	    var audioBuffered = this.sourceUpdater_.audioBuffered();
	    var videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
	    // should be cleared out during the buffer removals. However, log in case it helps
	    // debug.
	
	    if (audioBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: ' + timeRangesToArray(audioBuffered).join(', '));
	    }
	
	    if (videoBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: ' + timeRangesToArray(videoBuffered).join(', '));
	    }
	
	    var audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
	    var audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
	    var videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
	    var videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
	
	    if (audioBufferEnd - audioBufferStart <= MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= MIN_BACK_BUFFER) {
	      // Can't remove enough buffer to make room for new segment (or the browser doesn't
	      // allow for appends of segments this size). In the future, it may be possible to
	      // split up the segment and append in pieces, but for now, error out this playlist
	      // in an attempt to switch to a more manageable rendition.
	      this.logger_('On QUOTA_EXCEEDED_ERR, single segment too large to append to ' + 'buffer, triggering an error. ' + ("Appended byte length: " + bytes.byteLength + ", ") + ("audio buffer: " + timeRangesToArray(audioBuffered).join(', ') + ", ") + ("video buffer: " + timeRangesToArray(videoBuffered).join(', ') + ", "));
	      this.error({
	        message: 'Quota exceeded error with append of a single segment of content',
	        excludeUntil: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
	    // that the segment-loader should block on future events until this one is handled, so
	    // that it doesn't keep moving onto further segments. Adding the call to the call
	    // queue will prevent further appends until waitingOnRemove_ and
	    // quotaExceededErrorRetryTimeout_ are cleared.
	    //
	    // Note that this will only block the current loader. In the case of demuxed content,
	    // the other load may keep filling as fast as possible. In practice, this should be
	    // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
	    // source buffer, or video fills without enough room for audio to append (and without
	    // the availability of clearing out seconds of back buffer to make room for audio).
	    // But it might still be good to handle this case in the future as a TODO.
	
	
	    this.waitingOnRemove_ = true;
	    this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	    var currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
	    // before retrying.
	
	    var timeToRemoveUntil = currentTime - MIN_BACK_BUFFER;
	    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + timeToRemoveUntil);
	    this.remove(0, timeToRemoveUntil, function () {
	      _this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + MIN_BACK_BUFFER + "s");
	
	      _this3.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
	      // attempts (since we can't clear less than the minimum)
	
	      _this3.quotaExceededErrorRetryTimeout_ = window__default['default'].setTimeout(function () {
	        _this3.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');
	
	        _this3.quotaExceededErrorRetryTimeout_ = null;
	
	        _this3.processCallQueue_();
	      }, MIN_BACK_BUFFER * 1000);
	    }, true);
	  };
	
	  _proto.handleAppendError_ = function handleAppendError_(_ref6, error) {
	    var segmentInfo = _ref6.segmentInfo,
	        type = _ref6.type,
	        bytes = _ref6.bytes; // if there's no error, nothing to do
	
	    if (!error) {
	      return;
	    }
	
	    if (error.code === QUOTA_EXCEEDED_ERR) {
	      this.handleQuotaExceededError_({
	        segmentInfo: segmentInfo,
	        type: type,
	        bytes: bytes
	      }); // A quota exceeded error should be recoverable with a future re-append, so no need
	      // to trigger an append error.
	
	      return;
	    }
	
	    this.logger_('Received non QUOTA_EXCEEDED_ERR on append', error);
	    this.error(type + " append of " + bytes.length + "b failed for segment " + ("#" + segmentInfo.mediaIndex + " in playlist " + segmentInfo.playlist.id)); // If an append errors, we often can't recover.
	    // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
	    //
	    // Trigger a special error so that it can be handled separately from normal,
	    // recoverable errors.
	
	    this.trigger('appenderror');
	  };
	
	  _proto.appendToSourceBuffer_ = function appendToSourceBuffer_(_ref7) {
	    var segmentInfo = _ref7.segmentInfo,
	        type = _ref7.type,
	        initSegment = _ref7.initSegment,
	        data = _ref7.data,
	        bytes = _ref7.bytes; // If this is a re-append, bytes were already created and don't need to be recreated
	
	    if (!bytes) {
	      var segments = [data];
	      var byteLength = data.byteLength;
	
	      if (initSegment) {
	        // if the media initialization segment is changing, append it before the content
	        // segment
	        segments.unshift(initSegment);
	        byteLength += initSegment.byteLength;
	      } // Technically we should be OK appending the init segment separately, however, we
	      // haven't yet tested that, and prepending is how we have always done things.
	
	
	      bytes = concatSegments({
	        bytes: byteLength,
	        segments: segments
	      });
	    }
	
	    this.sourceUpdater_.appendBuffer({
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }, this.handleAppendError_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	  };
	
	  _proto.handleSegmentTimingInfo_ = function handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
	    if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) {
	      return;
	    }
	
	    var segment = this.pendingSegment_.segment;
	    var timingInfoProperty = type + "TimingInfo";
	
	    if (!segment[timingInfoProperty]) {
	      segment[timingInfoProperty] = {};
	    }
	
	    segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
	    segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
	    segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
	    segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
	    segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
	
	    segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
	  };
	
	  _proto.appendData_ = function appendData_(segmentInfo, result) {
	    var type = result.type,
	        data = result.data;
	
	    if (!data || !data.byteLength) {
	      return;
	    }
	
	    if (type === 'audio' && this.audioDisabled_) {
	      return;
	    }
	
	    var initSegment = this.getInitSegmentAndUpdateState_({
	      type: type,
	      initSegment: result.initSegment,
	      playlist: segmentInfo.playlist,
	      map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
	    });
	    this.appendToSourceBuffer_({
	      segmentInfo: segmentInfo,
	      type: type,
	      initSegment: initSegment,
	      data: data
	    });
	  }
	  /**
	   * load a specific segment from a request into the buffer
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadSegment_ = function loadSegment_(segmentInfo) {
	    var _this4 = this;
	
	    this.state = 'WAITING';
	    this.pendingSegment_ = segmentInfo;
	    this.trimBackBuffer_(segmentInfo);
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      if (this.transmuxer_) {
	        this.transmuxer_.postMessage({
	          action: 'clearAllMp4Captions'
	        });
	      }
	    }
	
	    if (!this.hasEnoughInfoToLoad_()) {
	      this.loadQueue_.push(function () {
	        // regenerate the audioAppendStart, timestampOffset, etc as they
	        // may have changed since this function was added to the queue.
	        var options = _extends__default['default']({}, segmentInfo, {
	          forceTimestampOffset: true
	        });
	
	        _extends__default['default'](segmentInfo, _this4.generateSegmentInfo_(options));
	
	        _this4.isPendingTimestampOffset_ = false;
	
	        _this4.updateTransmuxerAndRequestSegment_(segmentInfo);
	      });
	      return;
	    }
	
	    this.updateTransmuxerAndRequestSegment_(segmentInfo);
	  };
	
	  _proto.updateTransmuxerAndRequestSegment_ = function updateTransmuxerAndRequestSegment_(segmentInfo) {
	    var _this5 = this; // We'll update the source buffer's timestamp offset once we have transmuxed data, but
	    // the transmuxer still needs to be updated before then.
	    //
	    // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
	    // offset must be passed to the transmuxer for stream correcting adjustments.
	
	
	    if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
	      this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
	
	      segmentInfo.gopsToAlignWith = [];
	      this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	      this.transmuxer_.postMessage({
	        action: 'setTimestampOffset',
	        timestampOffset: segmentInfo.timestampOffset
	      });
	    }
	
	    var simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
	    var isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
	    var isWalkingForward = this.mediaIndex !== null;
	    var isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
	    // the first timeline
	    segmentInfo.timeline > 0;
	    var isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
	    this.logger_("Requesting " + segmentInfoString(segmentInfo)); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
	    // then this init segment has never been seen before and should be appended.
	    //
	    // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
	    // both to true and leave the decision of whether to append the init segment to append time.
	
	    if (simpleSegment.map && !simpleSegment.map.bytes) {
	      this.logger_('going to request init segment.');
	      this.appendInitSegment_ = {
	        video: true,
	        audio: true
	      };
	    }
	
	    segmentInfo.abortRequests = mediaSegmentRequest({
	      xhr: this.vhs_.xhr,
	      xhrOptions: this.xhrOptions_,
	      decryptionWorker: this.decrypter_,
	      segment: simpleSegment,
	      abortFn: this.handleAbort_.bind(this, segmentInfo),
	      progressFn: this.handleProgress_.bind(this),
	      trackInfoFn: this.handleTrackInfo_.bind(this),
	      timingInfoFn: this.handleTimingInfo_.bind(this),
	      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'video', segmentInfo.requestId),
	      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'audio', segmentInfo.requestId),
	      captionsFn: this.handleCaptions_.bind(this),
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: function endedTimelineFn() {
	        _this5.logger_('received endedtimeline callback');
	      },
	      id3Fn: this.handleId3_.bind(this),
	      dataFn: this.handleData_.bind(this),
	      doneFn: this.segmentRequestFinished_.bind(this),
	      onTransmuxerLog: function onTransmuxerLog(_ref8) {
	        var message = _ref8.message,
	            level = _ref8.level,
	            stream = _ref8.stream;
	
	        _this5.logger_(segmentInfoString(segmentInfo) + " logged from transmuxer stream " + stream + " as a " + level + ": " + message);
	      }
	    });
	  }
	  /**
	   * trim the back buffer so that we don't have too much data
	   * in the source buffer
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   */
	  ;
	
	  _proto.trimBackBuffer_ = function trimBackBuffer_(segmentInfo) {
	    var removeToTime = safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
	    // buffer and a very conservative "garbage collector"
	    // We manually clear out the old buffer to ensure
	    // we don't trigger the QuotaExceeded error
	    // on the source buffer during subsequent appends
	
	    if (removeToTime > 0) {
	      this.remove(0, removeToTime);
	    }
	  }
	  /**
	   * created a simplified copy of the segment object with just the
	   * information necessary to perform the XHR and decryption
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   * @return {Object} a simplified segment object copy
	   */
	  ;
	
	  _proto.createSimplifiedSegmentObj_ = function createSimplifiedSegmentObj_(segmentInfo) {
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var simpleSegment = {
	      resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
	      byterange: part ? part.byterange : segment.byterange,
	      requestId: segmentInfo.requestId,
	      transmuxer: segmentInfo.transmuxer,
	      audioAppendStart: segmentInfo.audioAppendStart,
	      gopsToAlignWith: segmentInfo.gopsToAlignWith,
	      part: segmentInfo.part
	    };
	    var previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
	
	    if (previousSegment && previousSegment.timeline === segment.timeline) {
	      // The baseStartTime of a segment is used to handle rollover when probing the TS
	      // segment to retrieve timing information. Since the probe only looks at the media's
	      // times (e.g., PTS and DTS values of the segment), and doesn't consider the
	      // player's time (e.g., player.currentTime()), baseStartTime should reflect the
	      // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
	      // seconds of media time, so should be used here. The previous segment is used since
	      // the end of the previous segment should represent the beginning of the current
	      // segment, so long as they are on the same timeline.
	      if (previousSegment.videoTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
	      } else if (previousSegment.audioTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
	      }
	    }
	
	    if (segment.key) {
	      // if the media sequence is greater than 2^32, the IV will be incorrect
	      // assuming 10s segments, that would be about 1300 years
	      var iv = segment.key.iv || new Uint32Array([0, 0, 0, segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence]);
	      simpleSegment.key = this.segmentKey(segment.key);
	      simpleSegment.key.iv = iv;
	    }
	
	    if (segment.map) {
	      simpleSegment.map = this.initSegmentForMap(segment.map);
	    }
	
	    return simpleSegment;
	  };
	
	  _proto.saveTransferStats_ = function saveTransferStats_(stats) {
	    // every request counts as a media request even if it has been aborted
	    // or canceled due to a timeout
	    this.mediaRequests += 1;
	
	    if (stats) {
	      this.mediaBytesTransferred += stats.bytesReceived;
	      this.mediaTransferDuration += stats.roundTripTime;
	    }
	  };
	
	  _proto.saveBandwidthRelatedStats_ = function saveBandwidthRelatedStats_(duration, stats) {
	    // byteLength will be used for throughput, and should be based on bytes receieved,
	    // which we only know at the end of the request and should reflect total bytes
	    // downloaded rather than just bytes processed from components of the segment
	    this.pendingSegment_.byteLength = stats.bytesReceived;
	
	    if (duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's bandwidth because its duration of " + duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    this.bandwidth = stats.bandwidth;
	    this.roundTrip = stats.roundTripTime;
	  };
	
	  _proto.handleTimeout_ = function handleTimeout_() {
	    // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functinality between segment loaders
	    this.mediaRequestsTimedout += 1;
	    this.bandwidth = 1;
	    this.roundTrip = NaN;
	    this.trigger('bandwidthupdate');
	    this.trigger('timeout');
	  }
	  /**
	   * Handle the callback from the segmentRequest function and set the
	   * associated SegmentLoader state and errors if necessary
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
	    // check the call queue directly since this function doesn't need to deal with any
	    // data, and can continue even if the source buffers are not set up and we didn't get
	    // any data from the segment
	    if (this.callQueue_.length) {
	      this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
	
	    if (!this.pendingSegment_) {
	      return;
	    } // the request was aborted and the SegmentLoader has already started
	    // another request. this can happen when the timeout for an aborted
	    // request triggers due to a limitation in the XHR library
	    // do not count this as any sort of request or we risk double-counting
	
	
	    if (simpleSegment.requestId !== this.pendingSegment_.requestId) {
	      return;
	    } // an error occurred from the active pendingSegment_ so reset everything
	
	
	    if (error) {
	      this.pendingSegment_ = null;
	      this.state = 'READY'; // aborts are not a true error condition and nothing corrective needs to be done
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        return;
	      }
	
	      this.pause(); // the error is really just that at least one of the requests timed-out
	      // set the bandwidth to a very low value and trigger an ABR switch to
	      // take emergency action
	
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	        return;
	      } // if control-flow has arrived here, then the error is real
	      // emit an error event to blacklist the current playlist
	
	
	      this.mediaRequestsErrored += 1;
	      this.error(error);
	      this.trigger('error');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
	    // generated for ABR purposes
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
	    segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
	
	    if (result.gopInfo) {
	      this.gopBuffer_ = updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
	    } // Although we may have already started appending on progress, we shouldn't switch the
	    // state away from loading until we are officially done loading the segment data.
	
	
	    this.state = 'APPENDING'; // used for testing
	
	    this.trigger('appending');
	    this.waitForAppendsToComplete_(segmentInfo);
	  };
	
	  _proto.setTimeMapping_ = function setTimeMapping_(timeline) {
	    var timelineMapping = this.syncController_.mappingForTimeline(timeline);
	
	    if (timelineMapping !== null) {
	      this.timeMapping_ = timelineMapping;
	    }
	  };
	
	  _proto.updateMediaSecondsLoaded_ = function updateMediaSecondsLoaded_(segment) {
	    if (typeof segment.start === 'number' && typeof segment.end === 'number') {
	      this.mediaSecondsLoaded += segment.end - segment.start;
	    } else {
	      this.mediaSecondsLoaded += segment.duration;
	    }
	  };
	
	  _proto.shouldUpdateTransmuxerTimestampOffset_ = function shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
	    if (timestampOffset === null) {
	      return false;
	    } // note that we're potentially using the same timestamp offset for both video and
	    // audio
	
	
	    if (this.loaderType_ === 'main' && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      return true;
	    }
	
	    if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.trueSegmentStart_ = function trueSegmentStart_(_ref9) {
	    var currentStart = _ref9.currentStart,
	        playlist = _ref9.playlist,
	        mediaIndex = _ref9.mediaIndex,
	        firstVideoFrameTimeForData = _ref9.firstVideoFrameTimeForData,
	        currentVideoTimestampOffset = _ref9.currentVideoTimestampOffset,
	        useVideoTimingInfo = _ref9.useVideoTimingInfo,
	        videoTimingInfo = _ref9.videoTimingInfo,
	        audioTimingInfo = _ref9.audioTimingInfo;
	
	    if (typeof currentStart !== 'undefined') {
	      // if start was set once, keep using it
	      return currentStart;
	    }
	
	    if (!useVideoTimingInfo) {
	      return audioTimingInfo.start;
	    }
	
	    var previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
	    // within that segment. Since the transmuxer maintains a cache of incomplete data
	    // from and/or the last frame seen, the start time may reflect a frame that starts
	    // in the previous segment. Check for that case and ensure the start time is
	    // accurate for the segment.
	
	    if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === 'undefined' || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) {
	      return firstVideoFrameTimeForData;
	    }
	
	    return videoTimingInfo.start;
	  };
	
	  _proto.waitForAppendsToComplete_ = function waitForAppendsToComplete_(segmentInfo) {
	    var trackInfo = this.getCurrentMediaInfo_(segmentInfo);
	
	    if (!trackInfo) {
	      this.error({
	        message: 'No starting media returned, likely due to an unsupported media format.',
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // Although transmuxing is done, appends may not yet be finished. Throw a marker
	    // on each queue this loader is responsible for to ensure that the appends are
	    // complete.
	
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	    var waitForVideo = this.loaderType_ === 'main' && hasVideo;
	    var waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
	    segmentInfo.waitingOnAppends = 0; // segments with no data
	
	    if (!segmentInfo.hasAppendedData_) {
	      if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === 'number') {
	        // When there's no audio or video data in the segment, there's no audio or video
	        // timing information.
	        //
	        // If there's no audio or video timing information, then the timestamp offset
	        // can't be adjusted to the appropriate value for the transmuxer and source
	        // buffers.
	        //
	        // Therefore, the next segment should be used to set the timestamp offset.
	        this.isPendingTimestampOffset_ = true;
	      } // override settings for metadata only segments
	
	
	      segmentInfo.timingInfo = {
	        start: 0
	      };
	      segmentInfo.waitingOnAppends++;
	
	      if (!this.isPendingTimestampOffset_) {
	        // update the timestampoffset
	        this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
	        // no video/audio data.
	
	        this.processMetadataQueue_();
	      } // append is "done" instantly with no data.
	
	
	      this.checkAppendsDone_(segmentInfo);
	      return;
	    } // Since source updater could call back synchronously, do the increments first.
	
	
	    if (waitForVideo) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForAudio) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForVideo) {
	      this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	
	    if (waitForAudio) {
	      this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	  };
	
	  _proto.checkAppendsDone_ = function checkAppendsDone_(segmentInfo) {
	    if (this.checkForAbort_(segmentInfo.requestId)) {
	      return;
	    }
	
	    segmentInfo.waitingOnAppends--;
	
	    if (segmentInfo.waitingOnAppends === 0) {
	      this.handleAppendsDone_();
	    }
	  };
	
	  _proto.checkForIllegalMediaSwitch = function checkForIllegalMediaSwitch(trackInfo) {
	    var illegalMediaSwitchError = illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
	
	    if (illegalMediaSwitchError) {
	      this.error({
	        message: illegalMediaSwitchError,
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.updateSourceBufferTimestampOffset_ = function updateSourceBufferTimestampOffset_(segmentInfo) {
	    if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
	    // priority, timing-wise, so we must wait
	    typeof segmentInfo.timingInfo.start !== 'number' || // already updated the timestamp offset for this segment
	    segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
	    this.loaderType_ !== 'main') {
	      return;
	    }
	
	    var didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
	    // the timing info here comes from video. In the event that the audio is longer than
	    // the video, this will trim the start of the audio.
	    // This also trims any offset from 0 at the beginning of the media
	
	    segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
	      videoTimingInfo: segmentInfo.segment.videoTimingInfo,
	      audioTimingInfo: segmentInfo.segment.audioTimingInfo,
	      timingInfo: segmentInfo.timingInfo
	    }); // In the event that there are part segment downloads, each will try to update the
	    // timestamp offset. Retaining this bit of state prevents us from updating in the
	    // future (within the same segment), however, there may be a better way to handle it.
	
	    segmentInfo.changedTimestampOffset = true;
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (didChange) {
	      this.trigger('timestampoffset');
	    }
	  };
	
	  _proto.getSegmentStartTimeForTimestampOffsetCalculation_ = function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10) {
	    var videoTimingInfo = _ref10.videoTimingInfo,
	        audioTimingInfo = _ref10.audioTimingInfo,
	        timingInfo = _ref10.timingInfo;
	
	    if (!this.useDtsForTimestampOffset_) {
	      return timingInfo.start;
	    }
	
	    if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === 'number') {
	      return videoTimingInfo.transmuxedDecodeStart;
	    } // handle audio only
	
	
	    if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === 'number') {
	      return audioTimingInfo.transmuxedDecodeStart;
	    } // handle content not transmuxed (e.g., MP4)
	
	
	    return timingInfo.start;
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_(segmentInfo) {
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	    var trackInfo = this.getMediaInfo_();
	    var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	    var prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
	
	    if (!prioritizedTimingInfo) {
	      return;
	    }
	
	    segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === 'number' ? // End time may not exist in a case where we aren't parsing the full segment (one
	    // current example is the case of fmp4), so use the rough duration to calculate an
	    // end time.
	    prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
	  }
	  /**
	   * callback to run when appendBuffer is finished. detects if we are
	   * in a good state to do things with the data we got, or if we need
	   * to wait for more
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleAppendsDone_ = function handleAppendsDone_() {
	    // appendsdone can cause an abort
	    if (this.pendingSegment_) {
	      this.trigger('appendsdone');
	    }
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY'; // TODO should this move into this.checkForAbort to speed up requests post abort in
	      // all appending cases?
	
	      if (!this.paused()) {
	        this.monitorBuffer_();
	      }
	
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Now that the end of the segment has been reached, we can set the end time. It's
	    // best to wait until all appends are done so we're sure that the primary media is
	    // finished (and we have its end time).
	
	    this.updateTimingInfoEnd_(segmentInfo);
	
	    if (this.shouldSaveSegmentTimingInfo_) {
	      // Timeline mappings should only be saved for the main loader. This is for multiple
	      // reasons:
	      //
	      // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
	      //    and the main loader try to save the timeline mapping, whichever comes later
	      //    will overwrite the first. In theory this is OK, as the mappings should be the
	      //    same, however, it breaks for (2)
	      // 2) In the event of a live stream, the initial live point will make for a somewhat
	      //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
	      //    the mapping will be off for one of the streams, dependent on which one was
	      //    first saved (see (1)).
	      // 3) Primary timing goes by video in VHS, so the mapping should be video.
	      //
	      // Since the audio loader will wait for the main loader to load the first segment,
	      // the main loader will save the first timeline mapping, and ensure that there won't
	      // be a case where audio loads two segments without saving a mapping (thus leading
	      // to missing segment timing info).
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	    }
	
	    var segmentDurationMessage = getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
	
	    if (segmentDurationMessage) {
	      if (segmentDurationMessage.severity === 'warn') {
	        videojs.log.warn(segmentDurationMessage.message);
	      } else {
	        this.logger_(segmentDurationMessage.message);
	      }
	    }
	
	    this.recordThroughput_(segmentInfo);
	    this.pendingSegment_ = null;
	    this.state = 'READY';
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate'); // if the sync request was not appended
	      // then it was not the correct segment.
	      // throw it away and use the data it gave us
	      // to get the correct one.
	
	      if (!segmentInfo.hasAppendedData_) {
	        this.logger_("Throwing away un-appended sync request " + segmentInfoString(segmentInfo));
	        return;
	      }
	    }
	
	    this.logger_("Appended " + segmentInfoString(segmentInfo));
	    this.addSegmentMetadataCue_(segmentInfo);
	    this.fetchAtBuffer_ = true;
	
	    if (this.currentTimeline_ !== segmentInfo.timeline) {
	      this.timelineChangeController_.lastTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      }); // If audio is not disabled, the main segment loader is responsible for updating
	      // the audio timeline as well. If the content is video only, this won't have any
	      // impact.
	
	      if (this.loaderType_ === 'main' && !this.audioDisabled_) {
	        this.timelineChangeController_.lastTimelineChange({
	          type: 'audio',
	          from: this.currentTimeline_,
	          to: segmentInfo.timeline
	        });
	      }
	    }
	
	    this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
	    // the following conditional otherwise it may consider this a bad "guess"
	    // and attempt to resync when the post-update seekable window and live
	    // point would mean that this was the perfect segment to fetch
	
	    this.trigger('syncinfoupdate');
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
	    var badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
	    // the currentTime_ that means that our conservative guess was too conservative.
	    // In that case, reset the loader state so that we try to use any information gained
	    // from the previous request to create a new, more accurate, sync-point.
	
	    if (badSegmentGuess || badPartGuess) {
	      this.logger_("bad " + (badSegmentGuess ? 'segment' : 'part') + " " + segmentInfoString(segmentInfo));
	      this.resetEverything();
	      return;
	    }
	
	    var isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
	    // and conservatively guess
	
	    if (isWalkingForward) {
	      this.trigger('bandwidthupdate');
	    }
	
	    this.trigger('progress');
	    this.mediaIndex = segmentInfo.mediaIndex;
	    this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
	    // buffer, end the stream. this ensures the "ended" event will
	    // fire if playback reaches that point.
	
	    if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) {
	      this.endOfStream();
	    } // used for testing
	
	
	    this.trigger('appended');
	
	    if (segmentInfo.hasAppendedData_) {
	      this.mediaAppends++;
	    }
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * Records the current throughput of the decrypt, transmux, and append
	   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
	   * moving average of the throughput. `throughput.count` is the number of
	   * data points in the average.
	   *
	   * @private
	   * @param {Object} segmentInfo the object returned by loadSegment
	   */
	  ;
	
	  _proto.recordThroughput_ = function recordThroughput_(segmentInfo) {
	    if (segmentInfo.duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's throughput because its duration of " + segmentInfo.duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    var rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
	    // by zero in the case where the throughput is ridiculously high
	
	    var segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
	
	    var segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8 * 1000); // This is just a cumulative moving average calculation:
	    //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
	
	    this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
	  }
	  /**
	   * Adds a cue to the segment-metadata track with some metadata information about the
	   * segment
	   *
	   * @private
	   * @param {Object} segmentInfo
	   *        the object returned by loadSegment
	   * @method addSegmentMetadataCue_
	   */
	  ;
	
	  _proto.addSegmentMetadataCue_ = function addSegmentMetadataCue_(segmentInfo) {
	    if (!this.segmentMetadataTrack_) {
	      return;
	    }
	
	    var segment = segmentInfo.segment;
	    var start = segment.start;
	    var end = segment.end; // Do not try adding the cue if the start and end times are invalid.
	
	    if (!finite(start) || !finite(end)) {
	      return;
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
	    var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	    var value = {
	      custom: segment.custom,
	      dateTimeObject: segment.dateTimeObject,
	      dateTimeString: segment.dateTimeString,
	      bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
	      resolution: segmentInfo.playlist.attributes.RESOLUTION,
	      codecs: segmentInfo.playlist.attributes.CODECS,
	      byteLength: segmentInfo.byteLength,
	      uri: segmentInfo.uri,
	      timeline: segmentInfo.timeline,
	      playlist: segmentInfo.playlist.id,
	      start: start,
	      end: end
	    };
	    var data = JSON.stringify(value);
	    var cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
	    // the differences of WebKitDataCue in safari and VTTCue in other browsers
	
	    cue.value = value;
	    this.segmentMetadataTrack_.addCue(cue);
	  };
	
	  return SegmentLoader;
	}(videojs.EventTarget);
	
	function noop() {}
	
	var toTitleCase = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	
	var bufferTypes = ['video', 'audio'];
	
	var _updating = function updating(type, sourceUpdater) {
	  var sourceBuffer = sourceUpdater[type + "Buffer"];
	  return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
	};
	
	var nextQueueIndexOfType = function nextQueueIndexOfType(type, queue) {
	  for (var i = 0; i < queue.length; i++) {
	    var queueEntry = queue[i];
	
	    if (queueEntry.type === 'mediaSource') {
	      // If the next entry is a media source entry (uses multiple source buffers), block
	      // processing to allow it to go through first.
	      return null;
	    }
	
	    if (queueEntry.type === type) {
	      return i;
	    }
	  }
	
	  return null;
	};
	
	var shiftQueue = function shiftQueue(type, sourceUpdater) {
	  if (sourceUpdater.queue.length === 0) {
	    return;
	  }
	
	  var queueIndex = 0;
	  var queueEntry = sourceUpdater.queue[queueIndex];
	
	  if (queueEntry.type === 'mediaSource') {
	    if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== 'closed') {
	      sourceUpdater.queue.shift();
	      queueEntry.action(sourceUpdater);
	
	      if (queueEntry.doneFn) {
	        queueEntry.doneFn();
	      } // Only specific source buffer actions must wait for async updateend events. Media
	      // Source actions process synchronously. Therefore, both audio and video source
	      // buffers are now clear to process the next queue entries.
	
	
	      shiftQueue('audio', sourceUpdater);
	      shiftQueue('video', sourceUpdater);
	    } // Media Source actions require both source buffers, so if the media source action
	    // couldn't process yet (because one or both source buffers are busy), block other
	    // queue actions until both are available and the media source action can process.
	
	
	    return;
	  }
	
	  if (type === 'mediaSource') {
	    // If the queue was shifted by a media source action (this happens when pushing a
	    // media source action onto the queue), then it wasn't from an updateend event from an
	    // audio or video source buffer, so there's no change from previous state, and no
	    // processing should be done.
	    return;
	  } // Media source queue entries don't need to consider whether the source updater is
	  // started (i.e., source buffers are created) as they don't need the source buffers, but
	  // source buffer queue entries do.
	
	
	  if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === 'closed' || _updating(type, sourceUpdater)) {
	    return;
	  }
	
	  if (queueEntry.type !== type) {
	    queueIndex = nextQueueIndexOfType(type, sourceUpdater.queue);
	
	    if (queueIndex === null) {
	      // Either there's no queue entry that uses this source buffer type in the queue, or
	      // there's a media source queue entry before the next entry of this type, in which
	      // case wait for that action to process first.
	      return;
	    }
	
	    queueEntry = sourceUpdater.queue[queueIndex];
	  }
	
	  sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
	  //
	  // The queue pending operation must be set before the action is performed in the event
	  // that the action results in a synchronous event that is acted upon. For instance, if
	  // an exception is thrown that can be handled, it's possible that new actions will be
	  // appended to an empty queue and immediately executed, but would not have the correct
	  // pending information if this property was set after the action was performed.
	
	  sourceUpdater.queuePending[type] = queueEntry;
	  queueEntry.action(type, sourceUpdater);
	
	  if (!queueEntry.doneFn) {
	    // synchronous operation, process next entry
	    sourceUpdater.queuePending[type] = null;
	    shiftQueue(type, sourceUpdater);
	    return;
	  }
	};
	
	var cleanupBuffer = function cleanupBuffer(type, sourceUpdater) {
	  var buffer = sourceUpdater[type + "Buffer"];
	  var titleType = toTitleCase(type);
	
	  if (!buffer) {
	    return;
	  }
	
	  buffer.removeEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	  buffer.removeEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	  sourceUpdater.codecs[type] = null;
	  sourceUpdater[type + "Buffer"] = null;
	};
	
	var inSourceBuffers = function inSourceBuffers(mediaSource, sourceBuffer) {
	  return mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
	};
	
	var actions = {
	  appendBuffer: function appendBuffer(bytes, segmentInfo, onError) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Appending segment " + segmentInfo.mediaIndex + "'s " + bytes.length + " bytes to " + type + "Buffer");
	
	      try {
	        sourceBuffer.appendBuffer(bytes);
	      } catch (e) {
	        sourceUpdater.logger_("Error with code " + e.code + " " + (e.code === QUOTA_EXCEEDED_ERR ? '(QUOTA_EXCEEDED_ERR) ' : '') + ("when appending segment " + segmentInfo.mediaIndex + " to " + type + "Buffer"));
	        sourceUpdater.queuePending[type] = null;
	        onError(e);
	      }
	    };
	  },
	  remove: function remove(start, end) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + start + " to " + end + " from " + type + "Buffer");
	
	      try {
	        sourceBuffer.remove(start, end);
	      } catch (e) {
	        sourceUpdater.logger_("Remove " + start + " to " + end + " from " + type + "Buffer failed");
	      }
	    };
	  },
	  timestampOffset: function timestampOffset(offset) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Setting " + type + "timestampOffset to " + offset);
	      sourceBuffer.timestampOffset = offset;
	    };
	  },
	  callback: function callback(_callback) {
	    return function (type, sourceUpdater) {
	      _callback();
	    };
	  },
	  endOfStream: function endOfStream(error) {
	    return function (sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      sourceUpdater.logger_("Calling mediaSource endOfStream(" + (error || '') + ")");
	
	      try {
	        sourceUpdater.mediaSource.endOfStream(error);
	      } catch (e) {
	        videojs.log.warn('Failed to call media source endOfStream', e);
	      }
	    };
	  },
	  duration: function duration(_duration) {
	    return function (sourceUpdater) {
	      sourceUpdater.logger_("Setting mediaSource duration to " + _duration);
	
	      try {
	        sourceUpdater.mediaSource.duration = _duration;
	      } catch (e) {
	        videojs.log.warn('Failed to set media source duration', e);
	      }
	    };
	  },
	  abort: function abort() {
	    return function (type, sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("calling abort on " + type + "Buffer");
	
	      try {
	        sourceBuffer.abort();
	      } catch (e) {
	        videojs.log.warn("Failed to abort on " + type + "Buffer", e);
	      }
	    };
	  },
	  addSourceBuffer: function addSourceBuffer(type, codec) {
	    return function (sourceUpdater) {
	      var titleType = toTitleCase(type);
	      var mime = codecs_js.getMimeForCodec(codec);
	      sourceUpdater.logger_("Adding " + type + "Buffer with codec " + codec + " to mediaSource");
	      var sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
	      sourceBuffer.addEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	      sourceBuffer.addEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	      sourceUpdater.codecs[type] = codec;
	      sourceUpdater[type + "Buffer"] = sourceBuffer;
	    };
	  },
	  removeSourceBuffer: function removeSourceBuffer(type) {
	    return function (sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + type + "Buffer with codec " + sourceUpdater.codecs[type] + " from mediaSource");
	
	      try {
	        sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
	      } catch (e) {
	        videojs.log.warn("Failed to removeSourceBuffer " + type + "Buffer", e);
	      }
	    };
	  },
	  changeType: function changeType(codec) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      var mime = codecs_js.getMimeForCodec(codec); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      } // do not update codec if we don't need to.
	
	
	      if (sourceUpdater.codecs[type] === codec) {
	        return;
	      }
	
	      sourceUpdater.logger_("changing " + type + "Buffer codec from " + sourceUpdater.codecs[type] + " to " + codec); // check if change to the provided type is supported
	
	      try {
	        sourceBuffer.changeType(mime);
	        sourceUpdater.codecs[type] = codec;
	      } catch (e) {
	        videojs.log.warn("Failed to changeType on " + type + "Buffer", e);
	      }
	    };
	  }
	};
	
	var pushQueue = function pushQueue(_ref) {
	  var type = _ref.type,
	      sourceUpdater = _ref.sourceUpdater,
	      action = _ref.action,
	      doneFn = _ref.doneFn,
	      name = _ref.name;
	  sourceUpdater.queue.push({
	    type: type,
	    action: action,
	    doneFn: doneFn,
	    name: name
	  });
	  shiftQueue(type, sourceUpdater);
	};
	
	var onUpdateend = function onUpdateend(type, sourceUpdater) {
	  return function (e) {
	    // Although there should, in theory, be a pending action for any updateend receieved,
	    // there are some actions that may trigger updateend events without set definitions in
	    // the w3c spec. For instance, setting the duration on the media source may trigger
	    // updateend events on source buffers. This does not appear to be in the spec. As such,
	    // if we encounter an updateend without a corresponding pending action from our queue
	    // for that source buffer type, process the next action.
	    if (sourceUpdater.queuePending[type]) {
	      var doneFn = sourceUpdater.queuePending[type].doneFn;
	      sourceUpdater.queuePending[type] = null;
	
	      if (doneFn) {
	        // if there's an error, report it
	        doneFn(sourceUpdater[type + "Error_"]);
	      }
	    }
	
	    shiftQueue(type, sourceUpdater);
	  };
	};
	/**
	 * A queue of callbacks to be serialized and applied when a
	 * MediaSource and its associated SourceBuffers are not in the
	 * updating state. It is used by the segment loader to update the
	 * underlying SourceBuffers when new data is loaded, for instance.
	 *
	 * @class SourceUpdater
	 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
	 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
	 */
	
	
	var SourceUpdater = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SourceUpdater, _videojs$EventTarget);
	
	  function SourceUpdater(mediaSource) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.mediaSource = mediaSource;
	
	    _this.sourceopenListener_ = function () {
	      return shiftQueue('mediaSource', _assertThisInitialized__default['default'](_this));
	    };
	
	    _this.mediaSource.addEventListener('sourceopen', _this.sourceopenListener_);
	
	    _this.logger_ = logger('SourceUpdater'); // initial timestamp offset is 0
	
	    _this.audioTimestampOffset_ = 0;
	    _this.videoTimestampOffset_ = 0;
	    _this.queue = [];
	    _this.queuePending = {
	      audio: null,
	      video: null
	    };
	    _this.delayedAudioAppendQueue_ = [];
	    _this.videoAppendQueued_ = false;
	    _this.codecs = {};
	    _this.onVideoUpdateEnd_ = onUpdateend('video', _assertThisInitialized__default['default'](_this));
	    _this.onAudioUpdateEnd_ = onUpdateend('audio', _assertThisInitialized__default['default'](_this));
	
	    _this.onVideoError_ = function (e) {
	      // used for debugging
	      _this.videoError_ = e;
	    };
	
	    _this.onAudioError_ = function (e) {
	      // used for debugging
	      _this.audioError_ = e;
	    };
	
	    _this.createdSourceBuffers_ = false;
	    _this.initializedEme_ = false;
	    _this.triggeredReady_ = false;
	    return _this;
	  }
	
	  var _proto = SourceUpdater.prototype;
	
	  _proto.initializedEme = function initializedEme() {
	    this.initializedEme_ = true;
	    this.triggerReady();
	  };
	
	  _proto.hasCreatedSourceBuffers = function hasCreatedSourceBuffers() {
	    // if false, likely waiting on one of the segment loaders to get enough data to create
	    // source buffers
	    return this.createdSourceBuffers_;
	  };
	
	  _proto.hasInitializedAnyEme = function hasInitializedAnyEme() {
	    return this.initializedEme_;
	  };
	
	  _proto.ready = function ready() {
	    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
	  };
	
	  _proto.createSourceBuffers = function createSourceBuffers(codecs) {
	    if (this.hasCreatedSourceBuffers()) {
	      // already created them before
	      return;
	    } // the intial addOrChangeSourceBuffers will always be
	    // two add buffers.
	
	
	    this.addOrChangeSourceBuffers(codecs);
	    this.createdSourceBuffers_ = true;
	    this.trigger('createdsourcebuffers');
	    this.triggerReady();
	  };
	
	  _proto.triggerReady = function triggerReady() {
	    // only allow ready to be triggered once, this prevents the case
	    // where:
	    // 1. we trigger createdsourcebuffers
	    // 2. ie 11 synchronously initializates eme
	    // 3. the synchronous initialization causes us to trigger ready
	    // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
	    if (this.ready() && !this.triggeredReady_) {
	      this.triggeredReady_ = true;
	      this.trigger('ready');
	    }
	  }
	  /**
	   * Add a type of source buffer to the media source.
	   *
	   * @param {string} type
	   *        The type of source buffer to add.
	   *
	   * @param {string} codec
	   *        The codec to add the source buffer with.
	   */
	  ;
	
	  _proto.addSourceBuffer = function addSourceBuffer(type, codec) {
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.addSourceBuffer(type, codec),
	      name: 'addSourceBuffer'
	    });
	  }
	  /**
	   * call abort on a source buffer.
	   *
	   * @param {string} type
	   *        The type of source buffer to call abort on.
	   */
	  ;
	
	  _proto.abort = function abort(type) {
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.abort(type),
	      name: 'abort'
	    });
	  }
	  /**
	   * Call removeSourceBuffer and remove a specific type
	   * of source buffer on the mediaSource.
	   *
	   * @param {string} type
	   *        The type of source buffer to remove.
	   */
	  ;
	
	  _proto.removeSourceBuffer = function removeSourceBuffer(type) {
	    if (!this.canRemoveSourceBuffer()) {
	      videojs.log.error('removeSourceBuffer is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.removeSourceBuffer(type),
	      name: 'removeSourceBuffer'
	    });
	  }
	  /**
	   * Whether or not the removeSourceBuffer function is supported
	   * on the mediaSource.
	   *
	   * @return {boolean}
	   *          if removeSourceBuffer can be called.
	   */
	  ;
	
	  _proto.canRemoveSourceBuffer = function canRemoveSourceBuffer() {
	    // IE reports that it supports removeSourceBuffer, but often throws
	    // errors when attempting to use the function. So we report that it
	    // does not support removeSourceBuffer. As of Firefox 83 removeSourceBuffer
	    // throws errors, so we report that it does not support this as well.
	    return !videojs.browser.IE_VERSION && !videojs.browser.IS_FIREFOX && window__default['default'].MediaSource && window__default['default'].MediaSource.prototype && typeof window__default['default'].MediaSource.prototype.removeSourceBuffer === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  SourceUpdater.canChangeType = function canChangeType() {
	    return window__default['default'].SourceBuffer && window__default['default'].SourceBuffer.prototype && typeof window__default['default'].SourceBuffer.prototype.changeType === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  _proto.canChangeType = function canChangeType() {
	    return this.constructor.canChangeType();
	  }
	  /**
	   * Call the changeType function on a source buffer, given the code and type.
	   *
	   * @param {string} type
	   *        The type of source buffer to call changeType on.
	   *
	   * @param {string} codec
	   *        The codec string to change type with on the source buffer.
	   */
	  ;
	
	  _proto.changeType = function changeType(type, codec) {
	    if (!this.canChangeType()) {
	      videojs.log.error('changeType is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.changeType(codec),
	      name: 'changeType'
	    });
	  }
	  /**
	   * Add source buffers with a codec or, if they are already created,
	   * call changeType on source buffers using changeType.
	   *
	   * @param {Object} codecs
	   *        Codecs to switch to
	   */
	  ;
	
	  _proto.addOrChangeSourceBuffers = function addOrChangeSourceBuffers(codecs) {
	    var _this2 = this;
	
	    if (!codecs || typeof codecs !== 'object' || Object.keys(codecs).length === 0) {
	      throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');
	    }
	
	    Object.keys(codecs).forEach(function (type) {
	      var codec = codecs[type];
	
	      if (!_this2.hasCreatedSourceBuffers()) {
	        return _this2.addSourceBuffer(type, codec);
	      }
	
	      if (_this2.canChangeType()) {
	        _this2.changeType(type, codec);
	      }
	    });
	  }
	  /**
	   * Queue an update to append an ArrayBuffer.
	   *
	   * @param {MediaObject} object containing audioBytes and/or videoBytes
	   * @param {Function} done the function to call when done
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
	   */
	  ;
	
	  _proto.appendBuffer = function appendBuffer(options, doneFn) {
	    var _this3 = this;
	
	    var segmentInfo = options.segmentInfo,
	        type = options.type,
	        bytes = options.bytes;
	    this.processedAppend_ = true;
	
	    if (type === 'audio' && this.videoBuffer && !this.videoAppendQueued_) {
	      this.delayedAudioAppendQueue_.push([options, doneFn]);
	      this.logger_("delayed audio append of " + bytes.length + " until video append");
	      return;
	    } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
	    // not be fired. This means that the queue will be blocked until the next action
	    // taken by the segment-loader. Provide a mechanism for segment-loader to handle
	    // these errors by calling the doneFn with the specific error.
	
	
	    var onError = doneFn;
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.appendBuffer(bytes, segmentInfo || {
	        mediaIndex: -1
	      }, onError),
	      doneFn: doneFn,
	      name: 'appendBuffer'
	    });
	
	    if (type === 'video') {
	      this.videoAppendQueued_ = true;
	
	      if (!this.delayedAudioAppendQueue_.length) {
	        return;
	      }
	
	      var queue = this.delayedAudioAppendQueue_.slice();
	      this.logger_("queuing delayed audio " + queue.length + " appendBuffers");
	      this.delayedAudioAppendQueue_.length = 0;
	      queue.forEach(function (que) {
	        _this3.appendBuffer.apply(_this3, que);
	      });
	    }
	  }
	  /**
	   * Get the audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The audio buffer's buffered time range
	   */
	  ;
	
	  _proto.audioBuffered = function audioBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.audioBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.audioBuffer.buffered ? this.audioBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get the video buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The video buffer's buffered time range
	   */
	  ;
	
	  _proto.videoBuffered = function videoBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.videoBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.videoBuffer.buffered ? this.videoBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get a combined video/audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         the combined time range
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var video = inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
	    var audio = inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
	
	    if (audio && !video) {
	      return this.audioBuffered();
	    }
	
	    if (video && !audio) {
	      return this.videoBuffered();
	    }
	
	    return bufferIntersection(this.audioBuffered(), this.videoBuffered());
	  }
	  /**
	   * Add a callback to the queue that will set duration on the mediaSource.
	   *
	   * @param {number} duration
	   *        The duration to set
	   *
	   * @param {Function} [doneFn]
	   *        function to run after duration has been set.
	   */
	  ;
	
	  _proto.setDuration = function setDuration(duration, doneFn) {
	    if (doneFn === void 0) {
	      doneFn = noop;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.duration(duration),
	      name: 'duration',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Add a mediaSource endOfStream call to the queue
	   *
	   * @param {Error} [error]
	   *        Call endOfStream with an error
	   *
	   * @param {Function} [doneFn]
	   *        A function that should be called when the
	   *        endOfStream call has finished.
	   */
	  ;
	
	  _proto.endOfStream = function endOfStream(error, doneFn) {
	    if (error === void 0) {
	      error = null;
	    }
	
	    if (doneFn === void 0) {
	      doneFn = noop;
	    }
	
	    if (typeof error !== 'string') {
	      error = undefined;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.endOfStream(error),
	      name: 'endOfStream',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeAudio = function removeAudio(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeVideo = function removeVideo(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Whether the underlying sourceBuffer is updating or not
	   *
	   * @return {boolean} the updating status of the SourceBuffer
	   */
	  ;
	
	  _proto.updating = function updating() {
	    // the audio/video source buffer is updating
	    if (_updating('audio', this) || _updating('video', this)) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Set/get the timestampoffset on the audio SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.audioTimestampOffset = function audioTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.audioBuffer && // no point in updating if it's the same
	    this.audioTimestampOffset_ !== offset) {
	      pushQueue({
	        type: 'audio',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.audioTimestampOffset_ = offset;
	    }
	
	    return this.audioTimestampOffset_;
	  }
	  /**
	   * Set/get the timestampoffset on the video SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.videoTimestampOffset = function videoTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.videoBuffer && // no point in updating if it's the same
	    this.videoTimestampOffset !== offset) {
	      pushQueue({
	        type: 'video',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.videoTimestampOffset_ = offset;
	    }
	
	    return this.videoTimestampOffset_;
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the audio queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.audioQueueCallback = function audioQueueCallback(callback) {
	    if (!this.audioBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the video queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.videoQueueCallback = function videoQueueCallback(callback) {
	    if (!this.videoBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * dispose of the source updater and the underlying sourceBuffer
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this4 = this;
	
	    this.trigger('dispose');
	    bufferTypes.forEach(function (type) {
	      _this4.abort(type);
	
	      if (_this4.canRemoveSourceBuffer()) {
	        _this4.removeSourceBuffer(type);
	      } else {
	        _this4[type + "QueueCallback"](function () {
	          return cleanupBuffer(type, _this4);
	        });
	      }
	    });
	    this.videoAppendQueued_ = false;
	    this.delayedAudioAppendQueue_.length = 0;
	
	    if (this.sourceopenListener_) {
	      this.mediaSource.removeEventListener('sourceopen', this.sourceopenListener_);
	    }
	
	    this.off();
	  };
	
	  return SourceUpdater;
	}(videojs.EventTarget);
	
	var uint8ToUtf8 = function uint8ToUtf8(uintArray) {
	  return decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
	};
	
	var VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map(function (_char3) {
	  return _char3.charCodeAt(0);
	}));
	
	var NoVttJsError = /*#__PURE__*/function (_Error) {
	  _inheritsLoose__default['default'](NoVttJsError, _Error);
	
	  function NoVttJsError() {
	    return _Error.call(this, 'Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.') || this;
	  }
	
	  return NoVttJsError;
	}( /*#__PURE__*/_wrapNativeSuper__default['default'](Error));
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class VTTSegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var VTTSegmentLoader = /*#__PURE__*/function (_SegmentLoader) {
	  _inheritsLoose__default['default'](VTTSegmentLoader, _SegmentLoader);
	
	  function VTTSegmentLoader(settings, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _SegmentLoader.call(this, settings, options) || this; // SegmentLoader requires a MediaSource be specified or it will throw an error;
	    // however, VTTSegmentLoader has no need of a media source, so delete the reference
	
	    _this.mediaSource_ = null;
	    _this.subtitlesTrack_ = null;
	    _this.loaderType_ = 'subtitle';
	    _this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
	    _this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
	    // the sync controller leads to improper behavior.
	
	    _this.shouldSaveSegmentTimingInfo_ = false;
	    return _this;
	  }
	
	  var _proto = VTTSegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    // don't need to transmux any subtitles
	    return null;
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) {
	      return videojs.createTimeRanges();
	    }
	
	    var cues = this.subtitlesTrack_.cues;
	    var start = cues[0].startTime;
	    var end = cues[cues.length - 1].startTime;
	    return videojs.createTimeRanges([[start, end]]);
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      // append WebVTT line terminators to the media initialization segment if it exists
	      // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
	      // requires two or more WebVTT line terminators between the WebVTT header and the
	      // rest of the file
	      var combinedByteLength = VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
	      var combinedSegment = new Uint8Array(combinedByteLength);
	      combinedSegment.set(map.bytes);
	      combinedSegment.set(VTT_LINE_TERMINATORS, map.bytes.byteLength);
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: combinedSegment
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY';
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * Set a subtitle track on the segment loader to add subtitles to
	   *
	   * @param {TextTrack=} track
	   *        The text track to add loaded subtitles to
	   * @return {TextTrack}
	   *        Returns the subtitles track
	   */
	  ;
	
	  _proto.track = function track(_track) {
	    if (typeof _track === 'undefined') {
	      return this.subtitlesTrack_;
	    }
	
	    this.subtitlesTrack_ = _track; // if we were unpaused but waiting for a sourceUpdater, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      this.init_();
	    }
	
	    return this.subtitlesTrack_;
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   */
	  ;
	
	  _proto.remove = function remove(start, end) {
	    removeCuesFromTrack(start, end, this.subtitlesTrack_);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    var _this2 = this; // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
	      // We don't have the timestamp offset that we need to sync subtitles.
	      // Rerun on a timestamp offset or user interaction.
	      var checkTimestampOffset = function checkTimestampOffset() {
	        _this2.state = 'READY';
	
	        if (!_this2.paused()) {
	          // if not paused, queue a buffer check as soon as possible
	          _this2.monitorBuffer_();
	        }
	      };
	
	      this.syncController_.one('timestampoffset', checkTimestampOffset);
	      this.state = 'WAITING_ON_TIMELINE';
	      return;
	    }
	
	    this.loadSegment_(segmentInfo);
	  } // never set a timestamp offset for vtt segments.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_() {
	    return null;
	  };
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));
	  }
	  /**
	   * Prevents the segment loader from requesting segments we know contain no subtitles
	   * by walking forward until we find the next segment that we don't know whether it is
	   * empty or not.
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @return {Object}
	   *         a segment info object that describes the current segment
	   */
	  ;
	
	  _proto.skipEmptySegments_ = function skipEmptySegments_(segmentInfo) {
	    while (segmentInfo && segmentInfo.segment.empty) {
	      // stop at the last possible segmentInfo
	      if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
	        segmentInfo = null;
	        break;
	      }
	
	      segmentInfo = this.generateSegmentInfo_({
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex + 1,
	        startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
	        isSyncRequest: segmentInfo.isSyncRequest
	      });
	    }
	
	    return segmentInfo;
	  };
	
	  _proto.stopForError = function stopForError(error) {
	    this.error(error);
	    this.state = 'READY';
	    this.pause();
	    this.trigger('error');
	  }
	  /**
	   * append a decrypted segement to the SourceBuffer through a SourceUpdater
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    var _this3 = this;
	
	    if (!this.subtitlesTrack_) {
	      this.state = 'READY';
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // the request was aborted
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY';
	      this.mediaRequestsAborted += 1;
	      return;
	    }
	
	    if (error) {
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	      }
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        this.mediaRequestsAborted += 1;
	      } else {
	        this.mediaRequestsErrored += 1;
	      }
	
	      this.stopForError(error);
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functionality between segment loaders
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    this.state = 'APPENDING'; // used for tests
	
	    this.trigger('appending');
	    var segment = segmentInfo.segment;
	
	    if (segment.map) {
	      segment.map.bytes = simpleSegment.map.bytes;
	    }
	
	    segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
	
	    if (typeof window__default['default'].WebVTT !== 'function' && typeof this.loadVttJs === 'function') {
	      this.state = 'WAITING_ON_VTTJS'; // should be fine to call multiple times
	      // script will be loaded once but multiple listeners will be added to the queue, which is expected.
	
	      this.loadVttJs().then(function () {
	        return _this3.segmentRequestFinished_(error, simpleSegment, result);
	      }, function () {
	        return _this3.stopForError({
	          message: 'Error loading vtt.js'
	        });
	      });
	      return;
	    }
	
	    segment.requested = true;
	
	    try {
	      this.parseVTTCues_(segmentInfo);
	    } catch (e) {
	      this.stopForError({
	        message: e.message
	      });
	      return;
	    }
	
	    this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
	
	    if (segmentInfo.cues.length) {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.cues[0].startTime,
	        end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
	      };
	    } else {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.startOfSegment,
	        end: segmentInfo.startOfSegment + segmentInfo.duration
	      };
	    }
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate');
	      this.pendingSegment_ = null;
	      this.state = 'READY';
	      return;
	    }
	
	    segmentInfo.byteLength = segmentInfo.bytes.byteLength;
	    this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
	    // the subtitle track
	
	    segmentInfo.cues.forEach(function (cue) {
	      _this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_ ? new window__default['default'].VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
	    }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
	    // cues to have identical time-intervals, but if the text is also identical
	    // we can safely assume it is a duplicate that can be removed (ex. when a cue
	    // "overlaps" VTT segments)
	
	    removeDuplicateCuesFromTrack(this.subtitlesTrack_);
	    this.handleAppendsDone_();
	  };
	
	  _proto.handleData_ = function handleData_() {// noop as we shouldn't be getting video/audio data captions
	    // that we do not support here.
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_() {// noop
	  }
	  /**
	   * Uses the WebVTT parser to parse the segment response
	   *
	   * @throws NoVttJsError
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @private
	   */
	  ;
	
	  _proto.parseVTTCues_ = function parseVTTCues_(segmentInfo) {
	    var decoder;
	    var decodeBytesToString = false;
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      // caller is responsible for exception handling.
	      throw new NoVttJsError();
	    }
	
	    if (typeof window__default['default'].TextDecoder === 'function') {
	      decoder = new window__default['default'].TextDecoder('utf8');
	    } else {
	      decoder = window__default['default'].WebVTT.StringDecoder();
	      decodeBytesToString = true;
	    }
	
	    var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, decoder);
	    segmentInfo.cues = [];
	    segmentInfo.timestampmap = {
	      MPEGTS: 0,
	      LOCAL: 0
	    };
	    parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
	
	    parser.ontimestampmap = function (map) {
	      segmentInfo.timestampmap = map;
	    };
	
	    parser.onparsingerror = function (error) {
	      videojs.log.warn('Error encountered when parsing cues: ' + error.message);
	    };
	
	    if (segmentInfo.segment.map) {
	      var mapData = segmentInfo.segment.map.bytes;
	
	      if (decodeBytesToString) {
	        mapData = uint8ToUtf8(mapData);
	      }
	
	      parser.parse(mapData);
	    }
	
	    var segmentData = segmentInfo.bytes;
	
	    if (decodeBytesToString) {
	      segmentData = uint8ToUtf8(segmentData);
	    }
	
	    parser.parse(segmentData);
	    parser.flush();
	  }
	  /**
	   * Updates the start and end times of any cues parsed by the WebVTT parser using
	   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
	   * from the SyncController
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @param {Object} mappingObj
	   *        object containing a mapping from TS to media time
	   * @param {Object} playlist
	   *        the playlist object containing the segment
	   * @private
	   */
	  ;
	
	  _proto.updateTimeMapping_ = function updateTimeMapping_(segmentInfo, mappingObj, playlist) {
	    var segment = segmentInfo.segment;
	
	    if (!mappingObj) {
	      // If the sync controller does not have a mapping of TS to Media Time for the
	      // timeline, then we don't have enough information to update the cue
	      // start/end times
	      return;
	    }
	
	    if (!segmentInfo.cues.length) {
	      // If there are no cues, we also do not have enough information to figure out
	      // segment timing. Mark that the segment contains no cues so we don't re-request
	      // an empty segment.
	      segment.empty = true;
	      return;
	    }
	
	    var timestampmap = segmentInfo.timestampmap;
	    var diff = timestampmap.MPEGTS / clock.ONE_SECOND_IN_TS - timestampmap.LOCAL + mappingObj.mapping;
	    segmentInfo.cues.forEach(function (cue) {
	      // First convert cue time to TS time using the timestamp-map provided within the vtt
	      cue.startTime += diff;
	      cue.endTime += diff;
	    });
	
	    if (!playlist.syncInfo) {
	      var firstStart = segmentInfo.cues[0].startTime;
	      var lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
	      playlist.syncInfo = {
	        mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
	        time: Math.min(firstStart, lastStart - segment.duration)
	      };
	    }
	  };
	
	  return VTTSegmentLoader;
	}(SegmentLoader);
	/**
	 * @file ad-cue-tags.js
	 */
	
	/**
	 * Searches for an ad cue that overlaps with the given mediaTime
	 *
	 * @param {Object} track
	 *        the track to find the cue for
	 *
	 * @param {number} mediaTime
	 *        the time to find the cue at
	 *
	 * @return {Object|null}
	 *         the found cue or null
	 */
	
	
	var findAdCue = function findAdCue(track, mediaTime) {
	  var cues = track.cues;
	
	  for (var i = 0; i < cues.length; i++) {
	    var cue = cues[i];
	
	    if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) {
	      return cue;
	    }
	  }
	
	  return null;
	};
	
	var updateAdCues = function updateAdCues(media, track, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  if (!media.segments) {
	    return;
	  }
	
	  var mediaTime = offset;
	  var cue;
	
	  for (var i = 0; i < media.segments.length; i++) {
	    var segment = media.segments[i];
	
	    if (!cue) {
	      // Since the cues will span for at least the segment duration, adding a fudge
	      // factor of half segment duration will prevent duplicate cues from being
	      // created when timing info is not exact (e.g. cue start time initialized
	      // at 10.006677, but next call mediaTime is 10.003332 )
	      cue = findAdCue(track, mediaTime + segment.duration / 2);
	    }
	
	    if (cue) {
	      if ('cueIn' in segment) {
	        // Found a CUE-IN so end the cue
	        cue.endTime = mediaTime;
	        cue.adEndTime = mediaTime;
	        mediaTime += segment.duration;
	        cue = null;
	        continue;
	      }
	
	      if (mediaTime < cue.endTime) {
	        // Already processed this mediaTime for this cue
	        mediaTime += segment.duration;
	        continue;
	      } // otherwise extend cue until a CUE-IN is found
	
	
	      cue.endTime += segment.duration;
	    } else {
	      if ('cueOut' in segment) {
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
	        cue.adStartTime = mediaTime; // Assumes tag format to be
	        // #EXT-X-CUE-OUT:30
	
	        cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
	        track.addCue(cue);
	      }
	
	      if ('cueOutCont' in segment) {
	        // Entered into the middle of an ad cue
	        // Assumes tag formate to be
	        // #EXT-X-CUE-OUT-CONT:10/30
	        var _segment$cueOutCont$s = segment.cueOutCont.split('/').map(parseFloat),
	            adOffset = _segment$cueOutCont$s[0],
	            adTotal = _segment$cueOutCont$s[1];
	
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, '');
	        cue.adStartTime = mediaTime - adOffset;
	        cue.adEndTime = cue.adStartTime + adTotal;
	        track.addCue(cue);
	      }
	    }
	
	    mediaTime += segment.duration;
	  }
	}; // synchronize expired playlist segments.
	// the max media sequence diff is 48 hours of live stream
	// content with two second segments. Anything larger than that
	// will likely be invalid.
	
	
	var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
	var syncPointStrategies = [// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
	//                the equivalence display-time 0 === segment-index 0
	{
	  name: 'VOD',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (duration !== Infinity) {
	      var syncPoint = {
	        time: 0,
	        segmentIndex: 0,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}, // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
	{
	  name: 'ProgramDateTime',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (!Object.keys(syncController.timelineToDatetimeMappings).length) {
	      return null;
	    }
	
	    var syncPoint = null;
	    var lastDistance = null;
	    var partsAndSegments = getPartsAndSegments(playlist);
	    currentTime = currentTime || 0;
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
	
	      if (!datetimeMapping || !segment.dateTimeObject) {
	        continue;
	      }
	
	      var segmentTime = segment.dateTimeObject.getTime() / 1000;
	      var start = segmentTime + datetimeMapping; // take part duration into account.
	
	      if (segment.parts && typeof partAndSegment.partIndex === 'number') {
	        for (var z = 0; z < partAndSegment.partIndex; z++) {
	          start += segment.parts[z].duration;
	        }
	      }
	
	      var distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
	      // currentTime and can stop looking for better candidates
	
	      if (lastDistance !== null && (distance === 0 || lastDistance < distance)) {
	        break;
	      }
	
	      lastDistance = distance;
	      syncPoint = {
	        time: start,
	        segmentIndex: partAndSegment.segmentIndex,
	        partIndex: partAndSegment.partIndex
	      };
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Segment": We have a known time mapping for a timeline and a
	//                    segment in the current timeline with timing data
	{
	  name: 'Segment',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    var lastDistance = null;
	    currentTime = currentTime || 0;
	    var partsAndSegments = getPartsAndSegments(playlist);
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
	
	      if (segment.timeline === currentTimeline && typeof start !== 'undefined') {
	        var distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
	        // currentTime and can stop looking for better candidates
	
	        if (lastDistance !== null && lastDistance < distance) {
	          break;
	        }
	
	        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	          lastDistance = distance;
	          syncPoint = {
	            time: start,
	            segmentIndex: partAndSegment.segmentIndex,
	            partIndex: partAndSegment.partIndex
	          };
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Discontinuity": We have a discontinuity with a known
	//                          display-time
	{
	  name: 'Discontinuity',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    currentTime = currentTime || 0;
	
	    if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      var lastDistance = null;
	
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var discontinuitySync = syncController.discontinuities[discontinuity];
	
	        if (discontinuitySync) {
	          var distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
	          // currentTime and can stop looking for better candidates
	
	          if (lastDistance !== null && lastDistance < distance) {
	            break;
	          }
	
	          if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	            lastDistance = distance;
	            syncPoint = {
	              time: discontinuitySync.time,
	              segmentIndex: segmentIndex,
	              partIndex: null
	            };
	          }
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Playlist": We have a playlist with a known mapping of
	//                     segment index to display time
	{
	  name: 'Playlist',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (playlist.syncInfo) {
	      var syncPoint = {
	        time: playlist.syncInfo.time,
	        segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}];
	
	var SyncController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SyncController, _videojs$EventTarget);
	
	  function SyncController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // ...for synching across variants
	
	    _this.timelines = [];
	    _this.discontinuities = [];
	    _this.timelineToDatetimeMappings = {};
	    _this.logger_ = logger('SyncController');
	    return _this;
	  }
	  /**
	   * Find a sync-point for the playlist specified
	   *
	   * A sync-point is defined as a known mapping from display-time to
	   * a segment-index in the current playlist.
	   *
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinite if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Object}
	   *          A sync-point object
	   */
	
	
	  var _proto = SyncController.prototype;
	
	  _proto.getSyncPoint = function getSyncPoint(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime);
	
	    if (!syncPoints.length) {
	      // Signal that we need to attempt to get a sync-point manually
	      // by fetching a segment in the playlist and constructing
	      // a sync-point from that information
	      return null;
	    } // Now find the sync-point that is closest to the currentTime because
	    // that should result in the most accurate guess about which segment
	    // to fetch
	
	
	    return this.selectSyncPoint_(syncPoints, {
	      key: 'time',
	      value: currentTime
	    });
	  }
	  /**
	   * Calculate the amount of time that has expired off the playlist during playback
	   *
	   * @param {Playlist} playlist
	   *        Playlist object to calculate expired from
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playling a live source)
	   * @return {number|null}
	   *          The amount of time that has expired off the playlist during playback. Null
	   *          if no sync-points for the playlist can be found.
	   */
	  ;
	
	  _proto.getExpiredTime = function getExpiredTime(playlist, duration) {
	    if (!playlist || !playlist.segments) {
	      return null;
	    }
	
	    var syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
	
	    if (!syncPoints.length) {
	      return null;
	    }
	
	    var syncPoint = this.selectSyncPoint_(syncPoints, {
	      key: 'segmentIndex',
	      value: 0
	    }); // If the sync-point is beyond the start of the playlist, we want to subtract the
	    // duration from index 0 to syncPoint.segmentIndex instead of adding.
	
	    if (syncPoint.segmentIndex > 0) {
	      syncPoint.time *= -1;
	    }
	
	    return Math.abs(syncPoint.time + sumDurations({
	      defaultDuration: playlist.targetDuration,
	      durationList: playlist.segments,
	      startIndex: syncPoint.segmentIndex,
	      endIndex: 0
	    }));
	  }
	  /**
	   * Runs each sync-point strategy and returns a list of sync-points returned by the
	   * strategies
	   *
	   * @private
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Array}
	   *          A list of sync-point objects
	   */
	  ;
	
	  _proto.runStrategies_ = function runStrategies_(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
	
	    for (var i = 0; i < syncPointStrategies.length; i++) {
	      var strategy = syncPointStrategies[i];
	      var syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime);
	
	      if (syncPoint) {
	        syncPoint.strategy = strategy.name;
	        syncPoints.push({
	          strategy: strategy.name,
	          syncPoint: syncPoint
	        });
	      }
	    }
	
	    return syncPoints;
	  }
	  /**
	   * Selects the sync-point nearest the specified target
	   *
	   * @private
	   * @param {Array} syncPoints
	   *        List of sync-points to select from
	   * @param {Object} target
	   *        Object specifying the property and value we are targeting
	   * @param {string} target.key
	   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
	   * @param {number} target.value
	   *        The value to target for the specified key.
	   * @return {Object}
	   *          The sync-point nearest the target
	   */
	  ;
	
	  _proto.selectSyncPoint_ = function selectSyncPoint_(syncPoints, target) {
	    var bestSyncPoint = syncPoints[0].syncPoint;
	    var bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
	    var bestStrategy = syncPoints[0].strategy;
	
	    for (var i = 1; i < syncPoints.length; i++) {
	      var newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
	
	      if (newDistance < bestDistance) {
	        bestDistance = newDistance;
	        bestSyncPoint = syncPoints[i].syncPoint;
	        bestStrategy = syncPoints[i].strategy;
	      }
	    }
	
	    this.logger_("syncPoint for [" + target.key + ": " + target.value + "] chosen with strategy" + (" [" + bestStrategy + "]: [time:" + bestSyncPoint.time + ",") + (" segmentIndex:" + bestSyncPoint.segmentIndex) + (typeof bestSyncPoint.partIndex === 'number' ? ",partIndex:" + bestSyncPoint.partIndex : '') + ']');
	    return bestSyncPoint;
	  }
	  /**
	   * Save any meta-data present on the segments when segments leave
	   * the live window to the playlist to allow for synchronization at the
	   * playlist level later.
	   *
	   * @param {Playlist} oldPlaylist - The previous active playlist
	   * @param {Playlist} newPlaylist - The updated and most current playlist
	   */
	  ;
	
	  _proto.saveExpiredSegmentInfo = function saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
	
	    if (mediaSequenceDiff > MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
	      videojs.log.warn("Not saving expired segment info. Media sequence gap " + mediaSequenceDiff + " is too large.");
	      return;
	    } // When a segment expires from the playlist and it has a start time
	    // save that information as a possible sync-point reference in future
	
	
	    for (var i = mediaSequenceDiff - 1; i >= 0; i--) {
	      var lastRemovedSegment = oldPlaylist.segments[i];
	
	      if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
	        newPlaylist.syncInfo = {
	          mediaSequence: oldPlaylist.mediaSequence + i,
	          time: lastRemovedSegment.start
	        };
	        this.logger_("playlist refresh sync: [time:" + newPlaylist.syncInfo.time + "," + (" mediaSequence: " + newPlaylist.syncInfo.mediaSequence + "]"));
	        this.trigger('syncinfoupdate');
	        break;
	      }
	    }
	  }
	  /**
	   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
	   * before segments start to load.
	   *
	   * @param {Playlist} playlist - The currently active playlist
	   */
	  ;
	
	  _proto.setDateTimeMappingForStart = function setDateTimeMappingForStart(playlist) {
	    // It's possible for the playlist to be updated before playback starts, meaning time
	    // zero is not yet set. If, during these playlist refreshes, a discontinuity is
	    // crossed, then the old time zero mapping (for the prior timeline) would be retained
	    // unless the mappings are cleared.
	    this.timelineToDatetimeMappings = {};
	
	    if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
	      var firstSegment = playlist.segments[0];
	      var playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
	      this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
	    }
	  }
	  /**
	   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
	   * based on the latest timing information.
	   *
	   * @param {Object} options
	   *        Options object
	   * @param {SegmentInfo} options.segmentInfo
	   *        The current active request information
	   * @param {boolean} options.shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved for timeline mapping and program date time mappings.
	   */
	  ;
	
	  _proto.saveSegmentTimingInfo = function saveSegmentTimingInfo(_ref) {
	    var segmentInfo = _ref.segmentInfo,
	        shouldSaveTimelineMapping = _ref.shouldSaveTimelineMapping;
	    var didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
	    var segment = segmentInfo.segment;
	
	    if (didCalculateSegmentTimeMapping) {
	      this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
	      // now with segment timing information
	
	      if (!segmentInfo.playlist.syncInfo) {
	        segmentInfo.playlist.syncInfo = {
	          mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
	          time: segment.start
	        };
	      }
	    }
	
	    var dateTime = segment.dateTimeObject;
	
	    if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) {
	      this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
	    }
	  };
	
	  _proto.timestampOffsetForTimeline = function timestampOffsetForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].time;
	  };
	
	  _proto.mappingForTimeline = function mappingForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].mapping;
	  }
	  /**
	   * Use the "media time" for a segment to generate a mapping to "display time" and
	   * save that display time to the segment.
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo
	   *        The current active request information
	   * @param {Object} timingInfo
	   *        The start and end time of the current segment in "media time"
	   * @param {boolean} shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved in timelines.
	   * @return {boolean}
	   *          Returns false if segment time mapping could not be calculated
	   */
	  ;
	
	  _proto.calculateSegmentTimeMapping_ = function calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
	    // TODO: remove side effects
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var mappingObj = this.timelines[segmentInfo.timeline];
	    var start;
	    var end;
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      mappingObj = {
	        time: segmentInfo.startOfSegment,
	        mapping: segmentInfo.startOfSegment - timingInfo.start
	      };
	
	      if (shouldSaveTimelineMapping) {
	        this.timelines[segmentInfo.timeline] = mappingObj;
	        this.trigger('timestampoffset');
	        this.logger_("time mapping for timeline " + segmentInfo.timeline + ": " + ("[time: " + mappingObj.time + "] [mapping: " + mappingObj.mapping + "]"));
	      }
	
	      start = segmentInfo.startOfSegment;
	      end = timingInfo.end + mappingObj.mapping;
	    } else if (mappingObj) {
	      start = timingInfo.start + mappingObj.mapping;
	      end = timingInfo.end + mappingObj.mapping;
	    } else {
	      return false;
	    }
	
	    if (part) {
	      part.start = start;
	      part.end = end;
	    } // If we don't have a segment start yet or the start value we got
	    // is less than our current segment.start value, save a new start value.
	    // We have to do this because parts will have segment timing info saved
	    // multiple times and we want segment start to be the earliest part start
	    // value for that segment.
	
	
	    if (!segment.start || start < segment.start) {
	      segment.start = start;
	    }
	
	    segment.end = end;
	    return true;
	  }
	  /**
	   * Each time we have discontinuity in the playlist, attempt to calculate the location
	   * in display of the start of the discontinuity and save that. We also save an accuracy
	   * value so that we save values with the most accuracy (closest to 0.)
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo - The current active request information
	   */
	  ;
	
	  _proto.saveDiscontinuitySyncInfo_ = function saveDiscontinuitySyncInfo_(segmentInfo) {
	    var playlist = segmentInfo.playlist;
	    var segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
	    // the start of the range and it's accuracy is 0 (greater accuracy values
	    // mean more approximation)
	
	    if (segment.discontinuity) {
	      this.discontinuities[segment.timeline] = {
	        time: segment.start,
	        accuracy: 0
	      };
	    } else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      // Search for future discontinuities that we can provide better timing
	      // information for and save that information for sync purposes
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
	        var accuracy = Math.abs(mediaIndexDiff);
	
	        if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
	          var time = void 0;
	
	          if (mediaIndexDiff < 0) {
	            time = segment.start - sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex,
	              endIndex: segmentIndex
	            });
	          } else {
	            time = segment.end + sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex + 1,
	              endIndex: segmentIndex
	            });
	          }
	
	          this.discontinuities[discontinuity] = {
	            time: time,
	            accuracy: accuracy
	          };
	        }
	      }
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.off();
	  };
	
	  return SyncController;
	}(videojs.EventTarget);
	/**
	 * The TimelineChangeController acts as a source for segment loaders to listen for and
	 * keep track of latest and pending timeline changes. This is useful to ensure proper
	 * sync, as each loader may need to make a consideration for what timeline the other
	 * loader is on before making changes which could impact the other loader's media.
	 *
	 * @class TimelineChangeController
	 * @extends videojs.EventTarget
	 */
	
	
	var TimelineChangeController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](TimelineChangeController, _videojs$EventTarget);
	
	  function TimelineChangeController() {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.pendingTimelineChanges_ = {};
	    _this.lastTimelineChanges_ = {};
	    return _this;
	  }
	
	  var _proto = TimelineChangeController.prototype;
	
	  _proto.clearPendingTimelineChange = function clearPendingTimelineChange(type) {
	    this.pendingTimelineChanges_[type] = null;
	    this.trigger('pendingtimelinechange');
	  };
	
	  _proto.pendingTimelineChange = function pendingTimelineChange(_ref) {
	    var type = _ref.type,
	        from = _ref.from,
	        to = _ref.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.pendingTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      this.trigger('pendingtimelinechange');
	    }
	
	    return this.pendingTimelineChanges_[type];
	  };
	
	  _proto.lastTimelineChange = function lastTimelineChange(_ref2) {
	    var type = _ref2.type,
	        from = _ref2.from,
	        to = _ref2.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.lastTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      delete this.pendingTimelineChanges_[type];
	      this.trigger('timelinechange');
	    }
	
	    return this.lastTimelineChanges_[type];
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.pendingTimelineChanges_ = {};
	    this.lastTimelineChanges_ = {};
	    this.off();
	  };
	
	  return TimelineChangeController;
	}(videojs.EventTarget);
	/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */
	
	
	var workerCode = transform(getWorkerString(function () {
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, basedir, module) {
	    return module = {
	      path: basedir,
	      exports: {},
	      require: function require(path, base) {
	        return commonjsRequire(path, base === undefined || base === null ? module.path : base);
	      }
	    }, fn(module, module.exports), module.exports;
	  }
	
	  function commonjsRequire() {
	    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	  }
	
	  var createClass = createCommonjsModule(function (module) {
	    function _defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    function _createClass(Constructor, protoProps, staticProps) {
	      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) _defineProperties(Constructor, staticProps);
	      return Constructor;
	    }
	
	    module.exports = _createClass;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var setPrototypeOf = createCommonjsModule(function (module) {
	    function _setPrototypeOf(o, p) {
	      module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	      };
	
	      module.exports["default"] = module.exports, module.exports.__esModule = true;
	      return _setPrototypeOf(o, p);
	    }
	
	    module.exports = _setPrototypeOf;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var inheritsLoose = createCommonjsModule(function (module) {
	    function _inheritsLoose(subClass, superClass) {
	      subClass.prototype = Object.create(superClass.prototype);
	      subClass.prototype.constructor = subClass;
	      setPrototypeOf(subClass, superClass);
	    }
	
	    module.exports = _inheritsLoose;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  /**
	   * @file stream.js
	   */
	
	  /**
	   * A lightweight readable stream implemention that handles event dispatching.
	   *
	   * @class Stream
	   */
	
	  var Stream = /*#__PURE__*/function () {
	    function Stream() {
	      this.listeners = {};
	    }
	    /**
	     * Add a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener the callback to be invoked when an event of
	     * the specified type occurs
	     */
	
	
	    var _proto = Stream.prototype;
	
	    _proto.on = function on(type, listener) {
	      if (!this.listeners[type]) {
	        this.listeners[type] = [];
	      }
	
	      this.listeners[type].push(listener);
	    }
	    /**
	     * Remove a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener  a function previously registered for this
	     * type of event through `on`
	     * @return {boolean} if we could turn it off or not
	     */
	    ;
	
	    _proto.off = function off(type, listener) {
	      if (!this.listeners[type]) {
	        return false;
	      }
	
	      var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	      // In Video.js we slice listener functions
	      // on trigger so that it does not mess up the order
	      // while we loop through.
	      //
	      // Here we slice on off so that the loop in trigger
	      // can continue using it's old reference to loop without
	      // messing up the order.
	
	      this.listeners[type] = this.listeners[type].slice(0);
	      this.listeners[type].splice(index, 1);
	      return index > -1;
	    }
	    /**
	     * Trigger an event of the specified type on this stream. Any additional
	     * arguments to this function are passed as parameters to event listeners.
	     *
	     * @param {string} type the event name
	     */
	    ;
	
	    _proto.trigger = function trigger(type) {
	      var callbacks = this.listeners[type];
	
	      if (!callbacks) {
	        return;
	      } // Slicing the arguments on every invocation of this method
	      // can add a significant amount of overhead. Avoid the
	      // intermediate object creation for the common case of a
	      // single callback argument
	
	
	      if (arguments.length === 2) {
	        var length = callbacks.length;
	
	        for (var i = 0; i < length; ++i) {
	          callbacks[i].call(this, arguments[1]);
	        }
	      } else {
	        var args = Array.prototype.slice.call(arguments, 1);
	        var _length = callbacks.length;
	
	        for (var _i = 0; _i < _length; ++_i) {
	          callbacks[_i].apply(this, args);
	        }
	      }
	    }
	    /**
	     * Destroys the stream and cleans up.
	     */
	    ;
	
	    _proto.dispose = function dispose() {
	      this.listeners = {};
	    }
	    /**
	     * Forwards all `data` events on this stream to the destination stream. The
	     * destination stream should provide a method `push` to receive the data
	     * events as they arrive.
	     *
	     * @param {Stream} destination the stream that will receive all `data` events
	     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	     */
	    ;
	
	    _proto.pipe = function pipe(destination) {
	      this.on('data', function (data) {
	        destination.push(data);
	      });
	    };
	
	    return Stream;
	  }();
	  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
	
	  /**
	   * Returns the subarray of a Uint8Array without PKCS#7 padding.
	   *
	   * @param padded {Uint8Array} unencrypted bytes that have been padded
	   * @return {Uint8Array} the unpadded bytes
	   * @see http://tools.ietf.org/html/rfc5652
	   */
	
	
	  function unpad(padded) {
	    return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
	  }
	  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
	
	  /**
	   * @file aes.js
	   *
	   * This file contains an adaptation of the AES decryption algorithm
	   * from the Standford Javascript Cryptography Library. That work is
	   * covered by the following copyright and permissions notice:
	   *
	   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
	   * All rights reserved.
	   *
	   * Redistribution and use in source and binary forms, with or without
	   * modification, are permitted provided that the following conditions are
	   * met:
	   *
	   * 1. Redistributions of source code must retain the above copyright
	   *    notice, this list of conditions and the following disclaimer.
	   *
	   * 2. Redistributions in binary form must reproduce the above
	   *    copyright notice, this list of conditions and the following
	   *    disclaimer in the documentation and/or other materials provided
	   *    with the distribution.
	   *
	   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
	   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
	   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
	   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
	   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
	   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   *
	   * The views and conclusions contained in the software and documentation
	   * are those of the authors and should not be interpreted as representing
	   * official policies, either expressed or implied, of the authors.
	   */
	
	  /**
	   * Expand the S-box tables.
	   *
	   * @private
	   */
	
	
	  var precompute = function precompute() {
	    var tables = [[[], [], [], [], []], [[], [], [], [], []]];
	    var encTable = tables[0];
	    var decTable = tables[1];
	    var sbox = encTable[4];
	    var sboxInv = decTable[4];
	    var i;
	    var x;
	    var xInv;
	    var d = [];
	    var th = [];
	    var x2;
	    var x4;
	    var x8;
	    var s;
	    var tEnc;
	    var tDec; // Compute double and third tables
	
	    for (i = 0; i < 256; i++) {
	      th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	    }
	
	    for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	      // Compute sbox
	      s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	      s = s >> 8 ^ s & 255 ^ 99;
	      sbox[x] = s;
	      sboxInv[s] = x; // Compute MixColumns
	
	      x8 = d[x4 = d[x2 = d[x]]];
	      tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	      tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	      for (i = 0; i < 4; i++) {
	        encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	        decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	      }
	    } // Compactify. Considerable speedup on Firefox.
	
	
	    for (i = 0; i < 5; i++) {
	      encTable[i] = encTable[i].slice(0);
	      decTable[i] = decTable[i].slice(0);
	    }
	
	    return tables;
	  };
	
	  var aesTables = null;
	  /**
	   * Schedule out an AES key for both encryption and decryption. This
	   * is a low-level class. Use a cipher mode to do bulk encryption.
	   *
	   * @class AES
	   * @param key {Array} The key as an array of 4, 6 or 8 words.
	   */
	
	  var AES = /*#__PURE__*/function () {
	    function AES(key) {
	      /**
	      * The expanded S-box and inverse S-box tables. These will be computed
	      * on the client so that we don't have to send them down the wire.
	      *
	      * There are two tables, _tables[0] is for encryption and
	      * _tables[1] is for decryption.
	      *
	      * The first 4 sub-tables are the expanded S-box with MixColumns. The
	      * last (_tables[01][4]) is the S-box itself.
	      *
	      * @private
	      */
	      // if we have yet to precompute the S-box tables
	      // do so now
	      if (!aesTables) {
	        aesTables = precompute();
	      } // then make a copy of that object for use
	
	
	      this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
	      var i;
	      var j;
	      var tmp;
	      var sbox = this._tables[0][4];
	      var decTable = this._tables[1];
	      var keyLen = key.length;
	      var rcon = 1;
	
	      if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	        throw new Error('Invalid aes key size');
	      }
	
	      var encKey = key.slice(0);
	      var decKey = [];
	      this._key = [encKey, decKey]; // schedule encryption keys
	
	      for (i = keyLen; i < 4 * keyLen + 28; i++) {
	        tmp = encKey[i - 1]; // apply sbox
	
	        if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	          tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
	
	          if (i % keyLen === 0) {
	            tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	            rcon = rcon << 1 ^ (rcon >> 7) * 283;
	          }
	        }
	
	        encKey[i] = encKey[i - keyLen] ^ tmp;
	      } // schedule decryption keys
	
	
	      for (j = 0; i; j++, i--) {
	        tmp = encKey[j & 3 ? i : i - 4];
	
	        if (i <= 4 || j < 4) {
	          decKey[j] = tmp;
	        } else {
	          decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	        }
	      }
	    }
	    /**
	     * Decrypt 16 bytes, specified as four 32-bit words.
	     *
	     * @param {number} encrypted0 the first word to decrypt
	     * @param {number} encrypted1 the second word to decrypt
	     * @param {number} encrypted2 the third word to decrypt
	     * @param {number} encrypted3 the fourth word to decrypt
	     * @param {Int32Array} out the array to write the decrypted words
	     * into
	     * @param {number} offset the offset into the output array to start
	     * writing results
	     * @return {Array} The plaintext.
	     */
	
	
	    var _proto = AES.prototype;
	
	    _proto.decrypt = function decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
	      var key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
	
	      var a = encrypted0 ^ key[0];
	      var b = encrypted3 ^ key[1];
	      var c = encrypted2 ^ key[2];
	      var d = encrypted1 ^ key[3];
	      var a2;
	      var b2;
	      var c2; // key.length === 2 ?
	
	      var nInnerRounds = key.length / 4 - 2;
	      var i;
	      var kIndex = 4;
	      var table = this._tables[1]; // load up the tables
	
	      var table0 = table[0];
	      var table1 = table[1];
	      var table2 = table[2];
	      var table3 = table[3];
	      var sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
	
	      for (i = 0; i < nInnerRounds; i++) {
	        a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
	        b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
	        c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
	        d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
	        kIndex += 4;
	        a = a2;
	        b = b2;
	        c = c2;
	      } // Last round.
	
	
	      for (i = 0; i < 4; i++) {
	        out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	        a2 = a;
	        a = b;
	        b = c;
	        c = d;
	        d = a2;
	      }
	    };
	
	    return AES;
	  }();
	  /**
	   * A wrapper around the Stream class to use setTimeout
	   * and run stream "jobs" Asynchronously
	   *
	   * @class AsyncStream
	   * @extends Stream
	   */
	
	
	  var AsyncStream = /*#__PURE__*/function (_Stream) {
	    inheritsLoose(AsyncStream, _Stream);
	
	    function AsyncStream() {
	      var _this;
	
	      _this = _Stream.call(this, Stream) || this;
	      _this.jobs = [];
	      _this.delay = 1;
	      _this.timeout_ = null;
	      return _this;
	    }
	    /**
	     * process an async job
	     *
	     * @private
	     */
	
	
	    var _proto = AsyncStream.prototype;
	
	    _proto.processJob_ = function processJob_() {
	      this.jobs.shift()();
	
	      if (this.jobs.length) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      } else {
	        this.timeout_ = null;
	      }
	    }
	    /**
	     * push a job into the stream
	     *
	     * @param {Function} job the job to push into the stream
	     */
	    ;
	
	    _proto.push = function push(job) {
	      this.jobs.push(job);
	
	      if (!this.timeout_) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      }
	    };
	
	    return AsyncStream;
	  }(Stream);
	  /**
	   * Convert network-order (big-endian) bytes into their little-endian
	   * representation.
	   */
	
	
	  var ntoh = function ntoh(word) {
	    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	  };
	  /**
	   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * use for the first round of CBC.
	   * @return {Uint8Array} the decrypted bytes
	   *
	   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
	   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
	   * @see https://tools.ietf.org/html/rfc2315
	   */
	
	
	  var decrypt = function decrypt(encrypted, key, initVector) {
	    // word-level access to the encrypted bytes
	    var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
	    var decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
	
	    var decrypted = new Uint8Array(encrypted.byteLength);
	    var decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
	    // decrypted data
	
	    var init0;
	    var init1;
	    var init2;
	    var init3;
	    var encrypted0;
	    var encrypted1;
	    var encrypted2;
	    var encrypted3; // iteration variable
	
	    var wordIx; // pull out the words of the IV to ensure we don't modify the
	    // passed-in reference and easier access
	
	    init0 = initVector[0];
	    init1 = initVector[1];
	    init2 = initVector[2];
	    init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
	    // to each decrypted block
	
	    for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
	      // convert big-endian (network order) words into little-endian
	      // (javascript order)
	      encrypted0 = ntoh(encrypted32[wordIx]);
	      encrypted1 = ntoh(encrypted32[wordIx + 1]);
	      encrypted2 = ntoh(encrypted32[wordIx + 2]);
	      encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
	
	      decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
	      // plaintext
	
	      decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
	      decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
	      decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
	      decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
	
	      init0 = encrypted0;
	      init1 = encrypted1;
	      init2 = encrypted2;
	      init3 = encrypted3;
	    }
	
	    return decrypted;
	  };
	  /**
	   * The `Decrypter` class that manages decryption of AES
	   * data through `AsyncStream` objects and the `decrypt`
	   * function
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * @param {Function} done the function to run when done
	   * @class Decrypter
	   */
	
	
	  var Decrypter = /*#__PURE__*/function () {
	    function Decrypter(encrypted, key, initVector, done) {
	      var step = Decrypter.STEP;
	      var encrypted32 = new Int32Array(encrypted.buffer);
	      var decrypted = new Uint8Array(encrypted.byteLength);
	      var i = 0;
	      this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
	
	      this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	
	      for (i = step; i < encrypted32.length; i += step) {
	        initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
	        this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	      } // invoke the done() callback when everything is finished
	
	
	      this.asyncStream_.push(function () {
	        // remove pkcs#7 padding from the decrypted bytes
	        done(null, unpad(decrypted));
	      });
	    }
	    /**
	     * a getter for step the maximum number of bytes to process at one time
	     *
	     * @return {number} the value of step 32000
	     */
	
	
	    var _proto = Decrypter.prototype;
	    /**
	     * @private
	     */
	
	    _proto.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
	      return function () {
	        var bytes = decrypt(encrypted, key, initVector);
	        decrypted.set(bytes, encrypted.byteOffset);
	      };
	    };
	
	    createClass(Decrypter, null, [{
	      key: "STEP",
	      get: function get() {
	        // 4 * 8000;
	        return 32000;
	      }
	    }]);
	    return Decrypter;
	  }();
	
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	
	  var isArrayBufferView = function isArrayBufferView(obj) {
	    if (ArrayBuffer.isView === 'function') {
	      return ArrayBuffer.isView(obj);
	    }
	
	    return obj && obj.buffer instanceof ArrayBuffer;
	  };
	
	  var BigInt = window_1.BigInt || Number;
	  [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	  /**
	   * Creates an object for sending to a web worker modifying properties that are TypedArrays
	   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	   *
	   * @param {Object} message
	   *        Object of properties and values to send to the web worker
	   * @return {Object}
	   *         Modified message with TypedArray values expanded
	   * @function createTransferableMessage
	   */
	
	
	  var createTransferableMessage = function createTransferableMessage(message) {
	    var transferable = {};
	    Object.keys(message).forEach(function (key) {
	      var value = message[key];
	
	      if (isArrayBufferView(value)) {
	        transferable[key] = {
	          bytes: value.buffer,
	          byteOffset: value.byteOffset,
	          byteLength: value.byteLength
	        };
	      } else {
	        transferable[key] = value;
	      }
	    });
	    return transferable;
	  };
	  /* global self */
	
	  /**
	   * Our web worker interface so that things can talk to aes-decrypter
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   */
	
	
	  self.onmessage = function (event) {
	    var data = event.data;
	    var encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
	    var key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
	    var iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
	    /* eslint-disable no-new, handle-callback-err */
	
	    new Decrypter(encrypted, key, iv, function (err, bytes) {
	      self.postMessage(createTransferableMessage({
	        source: data.source,
	        decrypted: bytes
	      }), [bytes.buffer]);
	    });
	    /* eslint-enable */
	  };
	}));
	var Decrypter = factory(workerCode);
	/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */
	
	/**
	 * Convert the properties of an HLS track into an audioTrackKind.
	 *
	 * @private
	 */
	
	var audioTrackKind_ = function audioTrackKind_(properties) {
	  var kind = properties["default"] ? 'main' : 'alternative';
	
	  if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) {
	    kind = 'main-desc';
	  }
	
	  return kind;
	};
	/**
	 * Pause provided segment loader and playlist loader if active
	 *
	 * @param {SegmentLoader} segmentLoader
	 *        SegmentLoader to pause
	 * @param {Object} mediaType
	 *        Active media type
	 * @function stopLoaders
	 */
	
	
	var stopLoaders = function stopLoaders(segmentLoader, mediaType) {
	  segmentLoader.abort();
	  segmentLoader.pause();
	
	  if (mediaType && mediaType.activePlaylistLoader) {
	    mediaType.activePlaylistLoader.pause();
	    mediaType.activePlaylistLoader = null;
	  }
	};
	/**
	 * Start loading provided segment loader and playlist loader
	 *
	 * @param {PlaylistLoader} playlistLoader
	 *        PlaylistLoader to start loading
	 * @param {Object} mediaType
	 *        Active media type
	 * @function startLoaders
	 */
	
	
	var startLoaders = function startLoaders(playlistLoader, mediaType) {
	  // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
	  // playlist loader
	  mediaType.activePlaylistLoader = playlistLoader;
	  playlistLoader.load();
	};
	/**
	 * Returns a function to be called when the media group changes. It performs a
	 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
	 * change of group is merely a rendition switch of the same content at another encoding,
	 * rather than a change of content, such as switching audio from English to Spanish.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a non-destructive resync of SegmentLoader when the active media
	 *         group changes.
	 * @function onGroupChanged
	 */
	
	
	var onGroupChanged = function onGroupChanged(type, settings) {
	  return function () {
	    var _settings$segmentLoad = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad[type],
	        mainSegmentLoader = _settings$segmentLoad.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastGroup = mediaType.lastGroup_; // the group did not change do nothing
	
	    if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup || activeGroup.isMasterPlaylist) {
	      // there is no group active or active group is a main playlist and won't change
	      return;
	    }
	
	    if (!activeGroup.playlistLoader) {
	      if (previousActiveLoader) {
	        // The previous group had a playlist loader but the new active group does not
	        // this means we are switching from demuxed to muxed audio. In this case we want to
	        // do a destructive reset of the main segment loader and not restart the audio
	        // loaders.
	        mainSegmentLoader.resetEverything();
	      }
	
	      return;
	    } // Non-destructive resync
	
	
	    segmentLoader.resyncLoader();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onGroupChanging = function onGroupChanging(type, settings) {
	  return function () {
	    var segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    mediaType.lastGroup_ = null;
	    segmentLoader.abort();
	    segmentLoader.pause();
	  };
	};
	/**
	 * Returns a function to be called when the media track changes. It performs a
	 * destructive reset of the SegmentLoader to ensure we start loading as close to
	 * currentTime as possible.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a destructive reset of SegmentLoader when the active media
	 *         track changes.
	 * @function onTrackChanged
	 */
	
	
	var onTrackChanged = function onTrackChanged(type, settings) {
	  return function () {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        _settings$segmentLoad2 = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad2[type],
	        mainSegmentLoader = _settings$segmentLoad2.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastTrack = mediaType.lastTrack_; // track did not change, do nothing
	
	    if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup) {
	      // there is no group active so we do not want to restart loaders
	      return;
	    }
	
	    if (activeGroup.isMasterPlaylist) {
	      // track did not change, do nothing
	      if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) {
	        return;
	      }
	
	      var mpc = settings.vhs.masterPlaylistController_;
	      var newPlaylist = mpc.selectPlaylist(); // media will not change do nothing
	
	      if (mpc.media() === newPlaylist) {
	        return;
	      }
	
	      mediaType.logger_("track change. Switching master audio from " + lastTrack.id + " to " + activeTrack.id);
	      masterPlaylistLoader.pause();
	      mainSegmentLoader.resetEverything();
	      mpc.fastQualityChange_(newPlaylist);
	      return;
	    }
	
	    if (type === 'AUDIO') {
	      if (!activeGroup.playlistLoader) {
	        // when switching from demuxed audio/video to muxed audio/video (noted by no
	        // playlist loader for the audio group), we want to do a destructive reset of the
	        // main segment loader and not restart the audio loaders
	        mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
	        // it should be stopped
	
	        mainSegmentLoader.resetEverything();
	        return;
	      } // although the segment loader is an audio segment loader, call the setAudio
	      // function to ensure it is prepared to re-append the init segment (or handle other
	      // config changes)
	
	
	      segmentLoader.setAudio(true);
	      mainSegmentLoader.setAudio(false);
	    }
	
	    if (previousActiveLoader === activeGroup.playlistLoader) {
	      // Nothing has actually changed. This can happen because track change events can fire
	      // multiple times for a "single" change. One for enabling the new active track, and
	      // one for disabling the track that was active
	      startLoaders(activeGroup.playlistLoader, mediaType);
	      return;
	    }
	
	    if (segmentLoader.track) {
	      // For WebVTT, set the new text track in the segmentloader
	      segmentLoader.track(activeTrack);
	    } // destructive reset
	
	
	    segmentLoader.resetEverything();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onError = {
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
	   *         console and switches back to default audio track.
	   * @function onError.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type],
	          blacklistCurrentPlaylist = settings.blacklistCurrentPlaylist;
	      stopLoaders(segmentLoader, mediaType); // switch back to default audio track
	
	      var activeTrack = mediaType.activeTrack();
	      var activeGroup = mediaType.activeGroup();
	      var id = (activeGroup.filter(function (group) {
	        return group["default"];
	      })[0] || activeGroup[0]).id;
	      var defaultTrack = mediaType.tracks[id];
	
	      if (activeTrack === defaultTrack) {
	        // Default track encountered an error. All we can do now is blacklist the current
	        // rendition and hope another will switch audio groups
	        blacklistCurrentPlaylist({
	          message: 'Problem encountered loading the default audio track.'
	        });
	        return;
	      }
	
	      videojs.log.warn('Problem encountered loading the alternate audio track.' + 'Switching back to default.');
	
	      for (var trackId in mediaType.tracks) {
	        mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
	      }
	
	      mediaType.onTrackChanged();
	    };
	  },
	
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning to console and disables the active subtitle track
	   * @function onError.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type];
	      videojs.log.warn('Problem encountered loading the subtitle track.' + 'Disabling subtitle track.');
	      stopLoaders(segmentLoader, mediaType);
	      var track = mediaType.activeTrack();
	
	      if (track) {
	        track.mode = 'disabled';
	      }
	
	      mediaType.onTrackChanged();
	    };
	  }
	};
	var setupListeners = {
	  /**
	   * Setup event listeners for audio playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.AUDIO
	   */
	  AUDIO: function AUDIO(type, playlistLoader, settings) {
	    if (!playlistLoader) {
	      // no playlist loader means audio will be muxed with the video
	      return;
	    }
	
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup event listeners for subtitle playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, playlistLoader, settings) {
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions);
	      segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  }
	};
	var initialize = {
	  /**
	   * Setup PlaylistLoaders and AudioTracks for the audio groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.AUDIO
	   */
	  'AUDIO': function AUDIO(type, settings) {
	    var vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$ = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$.groups,
	        tracks = _settings$mediaTypes$.tracks,
	        logger_ = _settings$mediaTypes$.logger_,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	    var audioOnlyMaster = isAudioOnly(masterPlaylistLoader.master); // force a default if we have none
	
	    if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
	      mediaGroups[type] = {
	        main: {
	          "default": {
	            "default": true
	          }
	        }
	      };
	
	      if (audioOnlyMaster) {
	        mediaGroups[type].main["default"].playlists = masterPlaylistLoader.master.playlists;
	      }
	    }
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (audioOnlyMaster) {
	          logger_("AUDIO group '" + groupId + "' label '" + variantLabel + "' is a master playlist");
	          properties.isMasterPlaylist = true;
	          playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
	          // use the resolved media playlist object
	        } else if (sourceType === 'vhs-json' && properties.playlists) {
	          playlistLoader = new PlaylistLoader(properties.playlists[0], vhs, requestOptions);
	        } else if (properties.resolvedUri) {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
	          // should we even have properties.playlists in this check.
	        } else if (properties.playlists && sourceType === 'dash') {
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else {
	          // no resolvedUri means the audio is muxed with the video when using this
	          // audio track
	          playlistLoader = null;
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = new videojs.AudioTrack({
	            id: variantLabel,
	            kind: audioTrackKind_(properties),
	            enabled: false,
	            language: properties.language,
	            "default": properties["default"],
	            label: variantLabel
	          });
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup PlaylistLoaders and TextTracks for the subtitle groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.SUBTITLES
	   */
	  'SUBTITLES': function SUBTITLES(type, settings) {
	    var tech = settings.tech,
	        vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$2 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$2.groups,
	        tracks = _settings$mediaTypes$2.tracks,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        if (mediaGroups[type][groupId][variantLabel].forced) {
	          // Subtitle playlists with the forced attribute are not selectable in Safari.
	          // According to Apple's HLS Authoring Specification:
	          //   If content has forced subtitles and regular subtitles in a given language,
	          //   the regular subtitles track in that language MUST contain both the forced
	          //   subtitles and the regular subtitles for that language.
	          // Because of this requirement and that Safari does not add forced subtitles,
	          // forced subtitles are skipped here to maintain consistent experience across
	          // all platforms
	          continue;
	        }
	
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (sourceType === 'hls') {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
	        } else if (sourceType === 'dash') {
	          var playlists = properties.playlists.filter(function (p) {
	            return p.excludeUntil !== Infinity;
	          });
	
	          if (!playlists.length) {
	            return;
	          }
	
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else if (sourceType === 'vhs-json') {
	          playlistLoader = new PlaylistLoader( // if the vhs-json object included the media playlist, use the media playlist
	          // as provided, otherwise use the resolved URI to load the playlist
	          properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: variantLabel,
	            kind: 'subtitles',
	            "default": properties["default"] && properties.autoselect,
	            language: properties.language,
	            label: variantLabel
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup TextTracks for the closed-caption groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize['CLOSED-CAPTIONS']
	   */
	  'CLOSED-CAPTIONS': function CLOSEDCAPTIONS(type, settings) {
	    var tech = settings.tech,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$3 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$3.groups,
	        tracks = _settings$mediaTypes$3.tracks;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
	
	        if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) {
	          continue;
	        }
	
	        var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	        var newProps = {
	          label: variantLabel,
	          language: properties.language,
	          instreamId: properties.instreamId,
	          "default": properties["default"] && properties.autoselect
	        };
	
	        if (captionServices[newProps.instreamId]) {
	          newProps = videojs.mergeOptions(newProps, captionServices[newProps.instreamId]);
	        }
	
	        if (newProps["default"] === undefined) {
	          delete newProps["default"];
	        } // No PlaylistLoader is required for Closed-Captions because the captions are
	        // embedded within the video stream
	
	
	        groups[groupId].push(videojs.mergeOptions({
	          id: variantLabel
	        }, properties));
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: newProps.instreamId,
	            kind: 'captions',
	            "default": newProps["default"],
	            language: newProps.language,
	            label: newProps.label
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	  }
	};
	
	var groupMatch = function groupMatch(list, media) {
	  for (var i = 0; i < list.length; i++) {
	    if (playlistMatch(media, list[i])) {
	      return true;
	    }
	
	    if (list[i].playlists && groupMatch(list[i].playlists, media)) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Returns a function used to get the active group of the provided type
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Function that returns the active media group for the provided type. Takes an
	 *         optional parameter {TextTrack} track. If no track is provided, a list of all
	 *         variants in the group, otherwise the variant corresponding to the provided
	 *         track is returned.
	 * @function activeGroup
	 */
	
	
	var activeGroup = function activeGroup(type, settings) {
	  return function (track) {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        groups = settings.mediaTypes[type].groups;
	    var media = masterPlaylistLoader.media();
	
	    if (!media) {
	      return null;
	    }
	
	    var variants = null; // set to variants to main media active group
	
	    if (media.attributes[type]) {
	      variants = groups[media.attributes[type]];
	    }
	
	    var groupKeys = Object.keys(groups);
	
	    if (!variants) {
	      // find the masterPlaylistLoader media
	      // that is in a media group if we are dealing
	      // with audio only
	      if (type === 'AUDIO' && groupKeys.length > 1 && isAudioOnly(settings.master)) {
	        for (var i = 0; i < groupKeys.length; i++) {
	          var groupPropertyList = groups[groupKeys[i]];
	
	          if (groupMatch(groupPropertyList, media)) {
	            variants = groupPropertyList;
	            break;
	          }
	        } // use the main group if it exists
	
	      } else if (groups.main) {
	        variants = groups.main; // only one group, use that one
	      } else if (groupKeys.length === 1) {
	        variants = groups[groupKeys[0]];
	      }
	    }
	
	    if (typeof track === 'undefined') {
	      return variants;
	    }
	
	    if (track === null || !variants) {
	      // An active track was specified so a corresponding group is expected. track === null
	      // means no track is currently active so there is no corresponding group
	      return null;
	    }
	
	    return variants.filter(function (props) {
	      return props.id === track.id;
	    })[0] || null;
	  };
	};
	
	var activeTrack = {
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].enabled) {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  },
	
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].mode === 'showing' || tracks[id].mode === 'hidden') {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  }
	};
	
	var getActiveGroup = function getActiveGroup(type, _ref) {
	  var mediaTypes = _ref.mediaTypes;
	  return function () {
	    var activeTrack_ = mediaTypes[type].activeTrack();
	
	    if (!activeTrack_) {
	      return null;
	    }
	
	    return mediaTypes[type].activeGroup(activeTrack_);
	  };
	};
	/**
	 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
	 * Closed-Captions) specified in the master manifest.
	 *
	 * @param {Object} settings
	 *        Object containing required information for setting up the media groups
	 * @param {Tech} settings.tech
	 *        The tech of the player
	 * @param {Object} settings.requestOptions
	 *        XHR request options used by the segment loaders
	 * @param {PlaylistLoader} settings.masterPlaylistLoader
	 *        PlaylistLoader for the master source
	 * @param {VhsHandler} settings.vhs
	 *        VHS SourceHandler
	 * @param {Object} settings.master
	 *        The parsed master manifest
	 * @param {Object} settings.mediaTypes
	 *        Object to store the loaders, tracks, and utility methods for each media type
	 * @param {Function} settings.blacklistCurrentPlaylist
	 *        Blacklists the current rendition and forces a rendition switch.
	 * @function setupMediaGroups
	 */
	
	
	var setupMediaGroups = function setupMediaGroups(settings) {
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    initialize[type](type, settings);
	  });
	  var mediaTypes = settings.mediaTypes,
	      masterPlaylistLoader = settings.masterPlaylistLoader,
	      tech = settings.tech,
	      vhs = settings.vhs,
	      _settings$segmentLoad3 = settings.segmentLoaders,
	      audioSegmentLoader = _settings$segmentLoad3['AUDIO'],
	      mainSegmentLoader = _settings$segmentLoad3.main; // setup active group and track getters and change event handlers
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	    mediaTypes[type].activeGroup = activeGroup(type, settings);
	    mediaTypes[type].activeTrack = activeTrack[type](type, settings);
	    mediaTypes[type].onGroupChanged = onGroupChanged(type, settings);
	    mediaTypes[type].onGroupChanging = onGroupChanging(type, settings);
	    mediaTypes[type].onTrackChanged = onTrackChanged(type, settings);
	    mediaTypes[type].getActiveGroup = getActiveGroup(type, settings);
	  }); // DO NOT enable the default subtitle or caption track.
	  // DO enable the default audio track
	
	  var audioGroup = mediaTypes.AUDIO.activeGroup();
	
	  if (audioGroup) {
	    var groupId = (audioGroup.filter(function (group) {
	      return group["default"];
	    })[0] || audioGroup[0]).id;
	    mediaTypes.AUDIO.tracks[groupId].enabled = true;
	    mediaTypes.AUDIO.onGroupChanged();
	    mediaTypes.AUDIO.onTrackChanged();
	    var activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
	    // track is changed, but needs to be handled here since the track may not be considered
	    // changed on the first call to onTrackChanged
	
	    if (!activeAudioGroup.playlistLoader) {
	      // either audio is muxed with video or the stream is audio only
	      mainSegmentLoader.setAudio(true);
	    } else {
	      // audio is demuxed
	      mainSegmentLoader.setAudio(false);
	      audioSegmentLoader.setAudio(true);
	    }
	  }
	
	  masterPlaylistLoader.on('mediachange', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanged();
	    });
	  });
	  masterPlaylistLoader.on('mediachanging', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanging();
	    });
	  }); // custom audio track change event handler for usage event
	
	  var onAudioTrackChanged = function onAudioTrackChanged() {
	    mediaTypes.AUDIO.onTrackChanged();
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-audio-change'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-audio-change'
	    });
	  };
	
	  tech.audioTracks().addEventListener('change', onAudioTrackChanged);
	  tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  vhs.on('dispose', function () {
	    tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
	    tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  }); // clear existing audio tracks and add the ones we just created
	
	  tech.clearTracks('audio');
	
	  for (var id in mediaTypes.AUDIO.tracks) {
	    tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
	  }
	};
	/**
	 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
	 * media type
	 *
	 * @return {Object}
	 *         Object to store the loaders, tracks, and utility methods for each media type
	 * @function createMediaTypes
	 */
	
	
	var createMediaTypes = function createMediaTypes() {
	  var mediaTypes = {};
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    mediaTypes[type] = {
	      groups: {},
	      tracks: {},
	      activePlaylistLoader: null,
	      activeGroup: noop,
	      activeTrack: noop,
	      getActiveGroup: noop,
	      onGroupChanged: noop,
	      onTrackChanged: noop,
	      lastTrack_: null,
	      logger_: logger("MediaGroups[" + type + "]")
	    };
	  });
	  return mediaTypes;
	};
	
	var ABORT_EARLY_BLACKLIST_SECONDS = 60 * 2;
	var Vhs$1; // SegmentLoader stats that need to have each loader's
	// values summed to calculate the final value
	
	var loaderStats = ['mediaRequests', 'mediaRequestsAborted', 'mediaRequestsTimedout', 'mediaRequestsErrored', 'mediaTransferDuration', 'mediaBytesTransferred', 'mediaAppends'];
	
	var sumLoaderStat = function sumLoaderStat(stat) {
	  return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
	};
	
	var shouldSwitchToMedia = function shouldSwitchToMedia(_ref) {
	  var currentPlaylist = _ref.currentPlaylist,
	      buffered = _ref.buffered,
	      currentTime = _ref.currentTime,
	      nextPlaylist = _ref.nextPlaylist,
	      bufferLowWaterLine = _ref.bufferLowWaterLine,
	      bufferHighWaterLine = _ref.bufferHighWaterLine,
	      duration = _ref.duration,
	      experimentalBufferBasedABR = _ref.experimentalBufferBasedABR,
	      log = _ref.log; // we have no other playlist to switch to
	
	  if (!nextPlaylist) {
	    videojs.log.warn('We received no playlist to switch to. Please check your stream.');
	    return false;
	  }
	
	  var sharedLogLine = "allowing switch " + (currentPlaylist && currentPlaylist.id || 'null') + " -> " + nextPlaylist.id;
	
	  if (!currentPlaylist) {
	    log(sharedLogLine + " as current playlist is not set");
	    return true;
	  } // no need to switch if playlist is the same
	
	
	  if (nextPlaylist.id === currentPlaylist.id) {
	    return false;
	  } // determine if current time is in a buffered range.
	
	
	  var isBuffered = Boolean(findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
	  // This is because in LIVE, the player plays 3 segments from the end of the
	  // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
	  // in those segments, a viewer will never experience a rendition upswitch.
	
	  if (!currentPlaylist.endList) {
	    // For LLHLS live streams, don't switch renditions before playback has started, as it almost
	    // doubles the time to first playback.
	    if (!isBuffered && typeof currentPlaylist.partTargetDuration === 'number') {
	      log("not " + sharedLogLine + " as current playlist is live llhls, but currentTime isn't in buffered.");
	      return false;
	    }
	
	    log(sharedLogLine + " as current playlist is live");
	    return true;
	  }
	
	  var forwardBuffer = timeAheadOf(buffered, currentTime);
	  var maxBufferLowWaterLine = experimentalBufferBasedABR ? Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
	  // duration is below the max potential low water line
	
	  if (duration < maxBufferLowWaterLine) {
	    log(sharedLogLine + " as duration < max low water line (" + duration + " < " + maxBufferLowWaterLine + ")");
	    return true;
	  }
	
	  var nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
	  var currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
	  // we can switch down
	
	  if (nextBandwidth < currBandwidth && (!experimentalBufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
	    var logLine = sharedLogLine + " as next bandwidth < current bandwidth (" + nextBandwidth + " < " + currBandwidth + ")";
	
	    if (experimentalBufferBasedABR) {
	      logLine += " and forwardBuffer < bufferHighWaterLine (" + forwardBuffer + " < " + bufferHighWaterLine + ")";
	    }
	
	    log(logLine);
	    return true;
	  } // and if our buffer is higher than the low water line,
	  // we can switch up
	
	
	  if ((!experimentalBufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
	    var _logLine = sharedLogLine + " as forwardBuffer >= bufferLowWaterLine (" + forwardBuffer + " >= " + bufferLowWaterLine + ")";
	
	    if (experimentalBufferBasedABR) {
	      _logLine += " and next bandwidth > current bandwidth (" + nextBandwidth + " > " + currBandwidth + ")";
	    }
	
	    log(_logLine);
	    return true;
	  }
	
	  log("not " + sharedLogLine + " as no switching criteria met");
	  return false;
	};
	/**
	 * the master playlist controller controller all interactons
	 * between playlists and segmentloaders. At this time this mainly
	 * involves a master playlist and a series of audio playlists
	 * if they are available
	 *
	 * @class MasterPlaylistController
	 * @extends videojs.EventTarget
	 */
	
	
	var MasterPlaylistController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](MasterPlaylistController, _videojs$EventTarget);
	
	  function MasterPlaylistController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    var src = options.src,
	        handleManifestRedirects = options.handleManifestRedirects,
	        withCredentials = options.withCredentials,
	        tech = options.tech,
	        bandwidth = options.bandwidth,
	        externVhs = options.externVhs,
	        useCueTags = options.useCueTags,
	        blacklistDuration = options.blacklistDuration,
	        enableLowInitialPlaylist = options.enableLowInitialPlaylist,
	        sourceType = options.sourceType,
	        cacheEncryptionKeys = options.cacheEncryptionKeys,
	        experimentalBufferBasedABR = options.experimentalBufferBasedABR,
	        experimentalLeastPixelDiffSelector = options.experimentalLeastPixelDiffSelector,
	        captionServices = options.captionServices;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or JSON manifest string is required');
	    }
	
	    var maxPlaylistRetries = options.maxPlaylistRetries;
	
	    if (maxPlaylistRetries === null || typeof maxPlaylistRetries === 'undefined') {
	      maxPlaylistRetries = Infinity;
	    }
	
	    Vhs$1 = externVhs;
	    _this.experimentalBufferBasedABR = Boolean(experimentalBufferBasedABR);
	    _this.experimentalLeastPixelDiffSelector = Boolean(experimentalLeastPixelDiffSelector);
	    _this.withCredentials = withCredentials;
	    _this.tech_ = tech;
	    _this.vhs_ = tech.vhs;
	    _this.sourceType_ = sourceType;
	    _this.useCueTags_ = useCueTags;
	    _this.blacklistDuration = blacklistDuration;
	    _this.maxPlaylistRetries = maxPlaylistRetries;
	    _this.enableLowInitialPlaylist = enableLowInitialPlaylist;
	
	    if (_this.useCueTags_) {
	      _this.cueTagsTrack_ = _this.tech_.addTextTrack('metadata', 'ad-cues');
	      _this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
	    }
	
	    _this.requestOptions_ = {
	      withCredentials: withCredentials,
	      handleManifestRedirects: handleManifestRedirects,
	      maxPlaylistRetries: maxPlaylistRetries,
	      timeout: null
	    };
	
	    _this.on('error', _this.pauseLoading);
	
	    _this.mediaTypes_ = createMediaTypes();
	    _this.mediaSource = new window__default['default'].MediaSource();
	    _this.handleDurationChange_ = _this.handleDurationChange_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceOpen_ = _this.handleSourceOpen_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceEnded_ = _this.handleSourceEnded_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.mediaSource.addEventListener('durationchange', _this.handleDurationChange_); // load the media source into the player
	
	
	    _this.mediaSource.addEventListener('sourceopen', _this.handleSourceOpen_);
	
	    _this.mediaSource.addEventListener('sourceended', _this.handleSourceEnded_); // we don't have to handle sourceclose since dispose will handle termination of
	    // everything, and the MediaSource should not be detached without a proper disposal
	
	
	    _this.seekable_ = videojs.createTimeRanges();
	    _this.hasPlayed_ = false;
	    _this.syncController_ = new SyncController(options);
	    _this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
	      kind: 'metadata',
	      label: 'segment-metadata'
	    }, false).track;
	    _this.decrypter_ = new Decrypter();
	    _this.sourceUpdater_ = new SourceUpdater(_this.mediaSource);
	    _this.inbandTextTracks_ = {};
	    _this.timelineChangeController_ = new TimelineChangeController();
	    var segmentLoaderSettings = {
	      vhs: _this.vhs_,
	      parse708captions: options.parse708captions,
	      useDtsForTimestampOffset: options.useDtsForTimestampOffset,
	      captionServices: captionServices,
	      mediaSource: _this.mediaSource,
	      currentTime: _this.tech_.currentTime.bind(_this.tech_),
	      seekable: function seekable() {
	        return _this.seekable();
	      },
	      seeking: function seeking() {
	        return _this.tech_.seeking();
	      },
	      duration: function duration() {
	        return _this.duration();
	      },
	      hasPlayed: function hasPlayed() {
	        return _this.hasPlayed_;
	      },
	      goalBufferLength: function goalBufferLength() {
	        return _this.goalBufferLength();
	      },
	      bandwidth: bandwidth,
	      syncController: _this.syncController_,
	      decrypter: _this.decrypter_,
	      sourceType: _this.sourceType_,
	      inbandTextTracks: _this.inbandTextTracks_,
	      cacheEncryptionKeys: cacheEncryptionKeys,
	      sourceUpdater: _this.sourceUpdater_,
	      timelineChangeController: _this.timelineChangeController_,
	      experimentalExactManifestTimings: options.experimentalExactManifestTimings
	    }; // The source type check not only determines whether a special DASH playlist loader
	    // should be used, but also covers the case where the provided src is a vhs-json
	    // manifest object (instead of a URL). In the case of vhs-json, the default
	    // PlaylistLoader should be used.
	
	    _this.masterPlaylistLoader_ = _this.sourceType_ === 'dash' ? new DashPlaylistLoader(src, _this.vhs_, _this.requestOptions_) : new PlaylistLoader(src, _this.vhs_, _this.requestOptions_);
	
	    _this.setupMasterPlaylistLoaderListeners_(); // setup segment loaders
	    // combined audio/video or just video when alternate audio track is selected
	
	
	    _this.mainSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      segmentMetadataTrack: _this.segmentMetadataTrack_,
	      loaderType: 'main'
	    }), options); // alternate audio track
	
	    _this.audioSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'audio'
	    }), options);
	    _this.subtitleSegmentLoader_ = new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'vtt',
	      featuresNativeTextTracks: _this.tech_.featuresNativeTextTracks,
	      loadVttJs: function loadVttJs() {
	        return new Promise(function (resolve, reject) {
	          function onLoad() {
	            tech.off('vttjserror', onError);
	            resolve();
	          }
	
	          function onError() {
	            tech.off('vttjsloaded', onLoad);
	            reject();
	          }
	
	          tech.one('vttjsloaded', onLoad);
	          tech.one('vttjserror', onError); // safe to call multiple times, script will be loaded only once:
	
	          tech.addWebVttScript_();
	        });
	      }
	    }), options);
	
	    _this.setupSegmentLoaderListeners_();
	
	    if (_this.experimentalBufferBasedABR) {
	      _this.masterPlaylistLoader_.one('loadedplaylist', function () {
	        return _this.startABRTimer_();
	      });
	
	      _this.tech_.on('pause', function () {
	        return _this.stopABRTimer_();
	      });
	
	      _this.tech_.on('play', function () {
	        return _this.startABRTimer_();
	      });
	    } // Create SegmentLoader stat-getters
	    // mediaRequests_
	    // mediaRequestsAborted_
	    // mediaRequestsTimedout_
	    // mediaRequestsErrored_
	    // mediaTransferDuration_
	    // mediaBytesTransferred_
	    // mediaAppends_
	
	
	    loaderStats.forEach(function (stat) {
	      _this[stat + '_'] = sumLoaderStat.bind(_assertThisInitialized__default['default'](_this), stat);
	    });
	    _this.logger_ = logger('MPC');
	    _this.triggeredFmp4Usage = false;
	
	    if (_this.tech_.preload() === 'none') {
	      _this.loadOnPlay_ = function () {
	        _this.loadOnPlay_ = null;
	
	        _this.masterPlaylistLoader_.load();
	      };
	
	      _this.tech_.one('play', _this.loadOnPlay_);
	    } else {
	      _this.masterPlaylistLoader_.load();
	    }
	
	    _this.timeToLoadedData__ = -1;
	    _this.mainAppendsToLoadedData__ = -1;
	    _this.audioAppendsToLoadedData__ = -1;
	    var event = _this.tech_.preload() === 'none' ? 'play' : 'loadstart'; // start the first frame timer on loadstart or play (for preload none)
	
	    _this.tech_.one(event, function () {
	      var timeToLoadedDataStart = Date.now();
	
	      _this.tech_.one('loadeddata', function () {
	        _this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
	        _this.mainAppendsToLoadedData__ = _this.mainSegmentLoader_.mediaAppends;
	        _this.audioAppendsToLoadedData__ = _this.audioSegmentLoader_.mediaAppends;
	      });
	    });
	
	    return _this;
	  }
	
	  var _proto = MasterPlaylistController.prototype;
	
	  _proto.mainAppendsToLoadedData_ = function mainAppendsToLoadedData_() {
	    return this.mainAppendsToLoadedData__;
	  };
	
	  _proto.audioAppendsToLoadedData_ = function audioAppendsToLoadedData_() {
	    return this.audioAppendsToLoadedData__;
	  };
	
	  _proto.appendsToLoadedData_ = function appendsToLoadedData_() {
	    var main = this.mainAppendsToLoadedData_();
	    var audio = this.audioAppendsToLoadedData_();
	
	    if (main === -1 || audio === -1) {
	      return -1;
	    }
	
	    return main + audio;
	  };
	
	  _proto.timeToLoadedData_ = function timeToLoadedData_() {
	    return this.timeToLoadedData__;
	  }
	  /**
	   * Run selectPlaylist and switch to the new playlist if we should
	   *
	   * @param {string} [reason=abr] a reason for why the ABR check is made
	   * @private
	   */
	  ;
	
	  _proto.checkABR_ = function checkABR_(reason) {
	    if (reason === void 0) {
	      reason = 'abr';
	    }
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) {
	      this.switchMedia_(nextPlaylist, reason);
	    }
	  };
	
	  _proto.switchMedia_ = function switchMedia_(playlist, cause, delay) {
	    var oldMedia = this.media();
	    var oldId = oldMedia && (oldMedia.id || oldMedia.uri);
	    var newId = playlist.id || playlist.uri;
	
	    if (oldId && oldId !== newId) {
	      this.logger_("switch media " + oldId + " -> " + newId + " from " + cause);
	      this.tech_.trigger({
	        type: 'usage',
	        name: "vhs-rendition-change-" + cause
	      });
	    }
	
	    this.masterPlaylistLoader_.media(playlist, delay);
	  }
	  /**
	   * Start a timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.startABRTimer_ = function startABRTimer_() {
	    var _this2 = this;
	
	    this.stopABRTimer_();
	    this.abrTimer_ = window__default['default'].setInterval(function () {
	      return _this2.checkABR_();
	    }, 250);
	  }
	  /**
	   * Stop the timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.stopABRTimer_ = function stopABRTimer_() {
	    // if we're scrubbing, we don't need to pause.
	    // This getter will be added to Video.js in version 7.11.
	    if (this.tech_.scrubbing && this.tech_.scrubbing()) {
	      return;
	    }
	
	    window__default['default'].clearInterval(this.abrTimer_);
	    this.abrTimer_ = null;
	  }
	  /**
	   * Get a list of playlists for the currently selected audio playlist
	   *
	   * @return {Array} the array of audio playlists
	   */
	  ;
	
	  _proto.getAudioTrackPlaylists_ = function getAudioTrackPlaylists_() {
	    var master = this.master();
	    var defaultPlaylists = master && master.playlists || []; // if we don't have any audio groups then we can only
	    // assume that the audio tracks are contained in masters
	    // playlist array, use that or an empty array.
	
	    if (!master || !master.mediaGroups || !master.mediaGroups.AUDIO) {
	      return defaultPlaylists;
	    }
	
	    var AUDIO = master.mediaGroups.AUDIO;
	    var groupKeys = Object.keys(AUDIO);
	    var track; // get the current active track
	
	    if (Object.keys(this.mediaTypes_.AUDIO.groups).length) {
	      track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from master if mediaTypes_ isn't setup yet
	    } else {
	      // default group is `main` or just the first group.
	      var defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
	
	      for (var label in defaultGroup) {
	        if (defaultGroup[label]["default"]) {
	          track = {
	            label: label
	          };
	          break;
	        }
	      }
	    } // no active track no playlists.
	
	
	    if (!track) {
	      return defaultPlaylists;
	    }
	
	    var playlists = []; // get all of the playlists that are possible for the
	    // active track.
	
	    for (var group in AUDIO) {
	      if (AUDIO[group][track.label]) {
	        var properties = AUDIO[group][track.label];
	
	        if (properties.playlists && properties.playlists.length) {
	          playlists.push.apply(playlists, properties.playlists);
	        } else if (properties.uri) {
	          playlists.push(properties);
	        } else if (master.playlists.length) {
	          // if an audio group does not have a uri
	          // see if we have main playlists that use it as a group.
	          // if we do then add those to the playlists list.
	          for (var i = 0; i < master.playlists.length; i++) {
	            var playlist = master.playlists[i];
	
	            if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) {
	              playlists.push(playlist);
	            }
	          }
	        }
	      }
	    }
	
	    if (!playlists.length) {
	      return defaultPlaylists;
	    }
	
	    return playlists;
	  }
	  /**
	   * Register event handlers on the master playlist loader. A helper
	   * function for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupMasterPlaylistLoaderListeners_ = function setupMasterPlaylistLoaderListeners_() {
	    var _this3 = this;
	
	    this.masterPlaylistLoader_.on('loadedmetadata', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      } // if this isn't a live video and preload permits, start
	      // downloading segments
	
	
	      if (media.endList && _this3.tech_.preload() !== 'none') {
	        _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	        _this3.mainSegmentLoader_.load();
	      }
	
	      setupMediaGroups({
	        sourceType: _this3.sourceType_,
	        segmentLoaders: {
	          AUDIO: _this3.audioSegmentLoader_,
	          SUBTITLES: _this3.subtitleSegmentLoader_,
	          main: _this3.mainSegmentLoader_
	        },
	        tech: _this3.tech_,
	        requestOptions: _this3.requestOptions_,
	        masterPlaylistLoader: _this3.masterPlaylistLoader_,
	        vhs: _this3.vhs_,
	        master: _this3.master(),
	        mediaTypes: _this3.mediaTypes_,
	        blacklistCurrentPlaylist: _this3.blacklistCurrentPlaylist.bind(_this3)
	      });
	
	      _this3.triggerPresenceUsage_(_this3.master(), media);
	
	      _this3.setupFirstPlay();
	
	      if (!_this3.mediaTypes_.AUDIO.activePlaylistLoader || _this3.mediaTypes_.AUDIO.activePlaylistLoader.media()) {
	        _this3.trigger('selectedinitialmedia');
	      } else {
	        // We must wait for the active audio playlist loader to
	        // finish setting up before triggering this event so the
	        // representations API and EME setup is correct
	        _this3.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata', function () {
	          _this3.trigger('selectedinitialmedia');
	        });
	      }
	    });
	    this.masterPlaylistLoader_.on('loadedplaylist', function () {
	      if (_this3.loadOnPlay_) {
	        _this3.tech_.off('play', _this3.loadOnPlay_);
	      }
	
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media();
	
	      if (!updatedPlaylist) {
	        // exclude any variants that are not supported by the browser before selecting
	        // an initial media as the playlist selectors do not consider browser support
	        _this3.excludeUnsupportedVariants_();
	
	        var selectedMedia;
	
	        if (_this3.enableLowInitialPlaylist) {
	          selectedMedia = _this3.selectInitialPlaylist();
	        }
	
	        if (!selectedMedia) {
	          selectedMedia = _this3.selectPlaylist();
	        }
	
	        if (!selectedMedia || !_this3.shouldSwitchToMedia_(selectedMedia)) {
	          return;
	        }
	
	        _this3.initialMedia_ = selectedMedia;
	
	        _this3.switchMedia_(_this3.initialMedia_, 'initial'); // Under the standard case where a source URL is provided, loadedplaylist will
	        // fire again since the playlist will be requested. In the case of vhs-json
	        // (where the manifest object is provided as the source), when the media
	        // playlist's `segments` list is already available, a media playlist won't be
	        // requested, and loadedplaylist won't fire again, so the playlist handler must be
	        // called on its own here.
	
	
	        var haveJsonSource = _this3.sourceType_ === 'vhs-json' && _this3.initialMedia_.segments;
	
	        if (!haveJsonSource) {
	          return;
	        }
	
	        updatedPlaylist = _this3.initialMedia_;
	      }
	
	      _this3.handleUpdatedMediaPlaylist(updatedPlaylist);
	    });
	    this.masterPlaylistLoader_.on('error', function () {
	      _this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);
	    });
	    this.masterPlaylistLoader_.on('mediachanging', function () {
	      _this3.mainSegmentLoader_.abort();
	
	      _this3.mainSegmentLoader_.pause();
	    });
	    this.masterPlaylistLoader_.on('mediachange', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      }
	
	      _this3.masterPlaylistLoader_.load(); // TODO: Create a new event on the PlaylistLoader that signals
	      // that the segments have changed in some way and use that to
	      // update the SegmentLoader instead of doing it twice here and
	      // on `loadedplaylist`
	
	
	      _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	      _this3.mainSegmentLoader_.load();
	
	      _this3.tech_.trigger({
	        type: 'mediachange',
	        bubbles: true
	      });
	    });
	    this.masterPlaylistLoader_.on('playlistunchanged', function () {
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media(); // ignore unchanged playlists that have already been
	      // excluded for not-changing. We likely just have a really slowly updating
	      // playlist.
	
	
	      if (updatedPlaylist.lastExcludeReason_ === 'playlist-unchanged') {
	        return;
	      }
	
	      var playlistOutdated = _this3.stuckAtPlaylistEnd_(updatedPlaylist);
	
	      if (playlistOutdated) {
	        // Playlist has stopped updating and we're stuck at its end. Try to
	        // blacklist it and switch to another playlist in the hope that that
	        // one is updating (and give the player a chance to re-adjust to the
	        // safe live point).
	        _this3.blacklistCurrentPlaylist({
	          message: 'Playlist no longer updating.',
	          reason: 'playlist-unchanged'
	        }); // useful for monitoring QoS
	
	
	        _this3.tech_.trigger('playliststuck');
	      }
	    });
	    this.masterPlaylistLoader_.on('renditiondisabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-disabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-disabled'
	      });
	    });
	    this.masterPlaylistLoader_.on('renditionenabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-enabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-enabled'
	      });
	    });
	  }
	  /**
	   * Given an updated media playlist (whether it was loaded for the first time, or
	   * refreshed for live playlists), update any relevant properties and state to reflect
	   * changes in the media that should be accounted for (e.g., cues and duration).
	   *
	   * @param {Object} updatedPlaylist the updated media playlist object
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleUpdatedMediaPlaylist = function handleUpdatedMediaPlaylist(updatedPlaylist) {
	    if (this.useCueTags_) {
	      this.updateAdCues_(updatedPlaylist);
	    } // TODO: Create a new event on the PlaylistLoader that signals
	    // that the segments have changed in some way and use that to
	    // update the SegmentLoader instead of doing it twice here and
	    // on `mediachange`
	
	
	    this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
	    this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
	    // as it is possible that it was temporarily stopped while waiting for
	    // a playlist (e.g., in case the playlist errored and we re-requested it).
	
	    if (!this.tech_.paused()) {
	      this.mainSegmentLoader_.load();
	
	      if (this.audioSegmentLoader_) {
	        this.audioSegmentLoader_.load();
	      }
	    }
	  }
	  /**
	   * A helper function for triggerring presence usage events once per source
	   *
	   * @private
	   */
	  ;
	
	  _proto.triggerPresenceUsage_ = function triggerPresenceUsage_(master, media) {
	    var mediaGroups = master.mediaGroups || {};
	    var defaultDemuxed = true;
	    var audioGroupKeys = Object.keys(mediaGroups.AUDIO);
	
	    for (var mediaGroup in mediaGroups.AUDIO) {
	      for (var label in mediaGroups.AUDIO[mediaGroup]) {
	        var properties = mediaGroups.AUDIO[mediaGroup][label];
	
	        if (!properties.uri) {
	          defaultDemuxed = false;
	        }
	      }
	    }
	
	    if (defaultDemuxed) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-demuxed'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-demuxed'
	      });
	    }
	
	    if (Object.keys(mediaGroups.SUBTITLES).length) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-webvtt'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-webvtt'
	      });
	    }
	
	    if (Vhs$1.Playlist.isAes(media)) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-aes'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-aes'
	      });
	    }
	
	    if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-alternate-audio'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-alternate-audio'
	      });
	    }
	
	    if (this.useCueTags_) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-playlist-cue-tags'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-playlist-cue-tags'
	      });
	    }
	  };
	
	  _proto.shouldSwitchToMedia_ = function shouldSwitchToMedia_(nextPlaylist) {
	    var currentPlaylist = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_;
	    var currentTime = this.tech_.currentTime();
	    var bufferLowWaterLine = this.bufferLowWaterLine();
	    var bufferHighWaterLine = this.bufferHighWaterLine();
	    var buffered = this.tech_.buffered();
	    return shouldSwitchToMedia({
	      buffered: buffered,
	      currentTime: currentTime,
	      currentPlaylist: currentPlaylist,
	      nextPlaylist: nextPlaylist,
	      bufferLowWaterLine: bufferLowWaterLine,
	      bufferHighWaterLine: bufferHighWaterLine,
	      duration: this.duration(),
	      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
	      log: this.logger_
	    });
	  }
	  /**
	   * Register event handlers on the segment loaders. A helper function
	   * for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupSegmentLoaderListeners_ = function setupSegmentLoaderListeners_() {
	    var _this4 = this;
	
	    this.mainSegmentLoader_.on('bandwidthupdate', function () {
	      // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
	      // useful to check to see if a rendition switch should be made.
	      _this4.checkABR_('bandwidthupdate');
	
	      _this4.tech_.trigger('bandwidthupdate');
	    });
	    this.mainSegmentLoader_.on('timeout', function () {
	      if (_this4.experimentalBufferBasedABR) {
	        // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
	        // Here the only consideration is that for buffer based ABR there's no guarantee
	        // of an immediate switch (since the bandwidth is averaged with a timeout
	        // bandwidth value of 1), so force a load on the segment loader to keep it going.
	        _this4.mainSegmentLoader_.load();
	      }
	    }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
	    // based ABR.
	
	    if (!this.experimentalBufferBasedABR) {
	      this.mainSegmentLoader_.on('progress', function () {
	        _this4.trigger('progress');
	      });
	    }
	
	    this.mainSegmentLoader_.on('error', function () {
	      _this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());
	    });
	    this.mainSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.mainSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.mainSegmentLoader_.on('timestampoffset', function () {
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-timestamp-offset'
	      });
	
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'hls-timestamp-offset'
	      });
	    });
	    this.audioSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.audioSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.audioSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('ended', function () {
	      _this4.logger_('main segment loader ended');
	
	      _this4.onEndOfStream();
	    });
	    this.mainSegmentLoader_.on('earlyabort', function (event) {
	      // never try to early abort with the new ABR algorithm
	      if (_this4.experimentalBufferBasedABR) {
	        return;
	      }
	
	      _this4.delegateLoaders_('all', ['abort']);
	
	      _this4.blacklistCurrentPlaylist({
	        message: 'Aborted early because there isn\'t enough bandwidth to complete the ' + 'request without rebuffering.'
	      }, ABORT_EARLY_BLACKLIST_SECONDS);
	    });
	
	    var updateCodecs = function updateCodecs() {
	      if (!_this4.sourceUpdater_.hasCreatedSourceBuffers()) {
	        return _this4.tryToCreateSourceBuffers_();
	      }
	
	      var codecs = _this4.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	
	      if (!codecs) {
	        return;
	      }
	
	      _this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);
	    };
	
	    this.mainSegmentLoader_.on('trackinfo', updateCodecs);
	    this.audioSegmentLoader_.on('trackinfo', updateCodecs);
	    this.mainSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('ended', function () {
	      _this4.logger_('audioSegmentLoader ended');
	
	      _this4.onEndOfStream();
	    });
	  };
	
	  _proto.mediaSecondsLoaded_ = function mediaSecondsLoaded_() {
	    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
	  }
	  /**
	   * Call load on our SegmentLoaders
	   */
	  ;
	
	  _proto.load = function load() {
	    this.mainSegmentLoader_.load();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.load();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.load();
	    }
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions without performing destructive actions, like
	   * removing already buffered content
	   *
	   * @private
	   * @deprecated
	   */
	  ;
	
	  _proto.smoothQualityChange_ = function smoothQualityChange_(media) {
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    this.fastQualityChange_(media);
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions. This method will perform destructive actions like removing
	   * already buffered content in order to readjust the currently active
	   * playlist quickly. This is good for manual quality changes
	   *
	   * @private
	   */
	  ;
	
	  _proto.fastQualityChange_ = function fastQualityChange_(media) {
	    var _this5 = this;
	
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    if (media === this.masterPlaylistLoader_.media()) {
	      this.logger_('skipping fastQualityChange because new media is same as old');
	      return;
	    }
	
	    this.switchMedia_(media, 'fast-quality'); // Delete all buffered data to allow an immediate quality switch, then seek to give
	    // the browser a kick to remove any cached frames from the previous rendtion (.04 seconds
	    // ahead is roughly the minimum that will accomplish this across a variety of content
	    // in IE and Edge, but seeking in place is sufficient on all other browsers)
	    // Edge/IE bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14600375/
	    // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=651904
	
	    this.mainSegmentLoader_.resetEverything(function () {
	      // Since this is not a typical seek, we avoid the seekTo method which can cause segments
	      // from the previously enabled rendition to load before the new playlist has finished loading
	      if (videojs.browser.IE_VERSION || videojs.browser.IS_EDGE) {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime() + 0.04);
	      } else {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime());
	      }
	    }); // don't need to reset audio as it is reset when media changes
	  }
	  /**
	   * Begin playback.
	   */
	  ;
	
	  _proto.play = function play() {
	    if (this.setupFirstPlay()) {
	      return;
	    }
	
	    if (this.tech_.ended()) {
	      this.tech_.setCurrentTime(0);
	    }
	
	    if (this.hasPlayed_) {
	      this.load();
	    }
	
	    var seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
	    // seek forward to the live point
	
	    if (this.tech_.duration() === Infinity) {
	      if (this.tech_.currentTime() < seekable.start(0)) {
	        return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
	      }
	    }
	  }
	  /**
	   * Seek to the latest media position if this is a live video and the
	   * player and video are loaded and initialized.
	   */
	  ;
	
	  _proto.setupFirstPlay = function setupFirstPlay() {
	    var _this6 = this;
	
	    var media = this.masterPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
	    //  If 1) there is no active media
	    //     2) the player is paused
	    //     3) the first play has already been setup
	    // then exit early
	
	    if (!media || this.tech_.paused() || this.hasPlayed_) {
	      return false;
	    } // when the video is a live stream
	
	
	    if (!media.endList) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        // without a seekable range, the player cannot seek to begin buffering at the live
	        // point
	        return false;
	      }
	
	      if (videojs.browser.IE_VERSION && this.tech_.readyState() === 0) {
	        // IE11 throws an InvalidStateError if you try to set currentTime while the
	        // readyState is 0, so it must be delayed until the tech fires loadedmetadata.
	        this.tech_.one('loadedmetadata', function () {
	          _this6.trigger('firstplay');
	
	          _this6.tech_.setCurrentTime(seekable.end(0));
	
	          _this6.hasPlayed_ = true;
	        });
	        return false;
	      } // trigger firstplay to inform the source handler to ignore the next seek event
	
	
	      this.trigger('firstplay'); // seek to the live point
	
	      this.tech_.setCurrentTime(seekable.end(0));
	    }
	
	    this.hasPlayed_ = true; // we can begin loading now that everything is ready
	
	    this.load();
	    return true;
	  }
	  /**
	   * handle the sourceopen event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceOpen_ = function handleSourceOpen_() {
	    // Only attempt to create the source buffer if none already exist.
	    // handleSourceOpen is also called when we are "re-opening" a source buffer
	    // after `endOfStream` has been called (in response to a seek for instance)
	    this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
	    // code in video.js but is required because play() must be invoked
	    // *after* the media source has opened.
	
	    if (this.tech_.autoplay()) {
	      var playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
	      // on browsers which return a promise
	
	      if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') {
	        playPromise.then(null, function (e) {});
	      }
	    }
	
	    this.trigger('sourceopen');
	  }
	  /**
	   * handle the sourceended event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceEnded_ = function handleSourceEnded_() {
	    if (!this.inbandTextTracks_.metadataTrack_) {
	      return;
	    }
	
	    var cues = this.inbandTextTracks_.metadataTrack_.cues;
	
	    if (!cues || !cues.length) {
	      return;
	    }
	
	    var duration = this.duration();
	    cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
	  }
	  /**
	   * handle the durationchange event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleDurationChange_ = function handleDurationChange_() {
	    this.tech_.trigger('durationchange');
	  }
	  /**
	   * Calls endOfStream on the media source when all active stream types have called
	   * endOfStream
	   *
	   * @param {string} streamType
	   *        Stream type of the segment loader that called endOfStream
	   * @private
	   */
	  ;
	
	  _proto.onEndOfStream = function onEndOfStream() {
	    var isEndOfStream = this.mainSegmentLoader_.ended_;
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      var mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
	
	      if (!mainMediaInfo || mainMediaInfo.hasVideo) {
	        // if we do not know if the main segment loader contains video yet or if we
	        // definitively know the main segment loader contains video, then we need to wait
	        // for both main and audio segment loaders to call endOfStream
	        isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
	      } else {
	        // otherwise just rely on the audio loader
	        isEndOfStream = this.audioSegmentLoader_.ended_;
	      }
	    }
	
	    if (!isEndOfStream) {
	      return;
	    }
	
	    this.stopABRTimer_();
	    this.sourceUpdater_.endOfStream();
	  }
	  /**
	   * Check if a playlist has stopped being updated
	   *
	   * @param {Object} playlist the media playlist object
	   * @return {boolean} whether the playlist has stopped being updated or not
	   */
	  ;
	
	  _proto.stuckAtPlaylistEnd_ = function stuckAtPlaylistEnd_(playlist) {
	    var seekable = this.seekable();
	
	    if (!seekable.length) {
	      // playlist doesn't have enough information to determine whether we are stuck
	      return false;
	    }
	
	    var expired = this.syncController_.getExpiredTime(playlist, this.duration());
	
	    if (expired === null) {
	      return false;
	    } // does not use the safe live end to calculate playlist end, since we
	    // don't want to say we are stuck while there is still content
	
	
	    var absolutePlaylistEnd = Vhs$1.Playlist.playlistEnd(playlist, expired);
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (!buffered.length) {
	      // return true if the playhead reached the absolute end of the playlist
	      return absolutePlaylistEnd - currentTime <= SAFE_TIME_DELTA;
	    }
	
	    var bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
	    // end of playlist
	
	    return bufferedEnd - currentTime <= SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= SAFE_TIME_DELTA;
	  }
	  /**
	   * Blacklists a playlist when an error occurs for a set amount of time
	   * making it unavailable for selection by the rendition selection algorithm
	   * and then forces a new playlist (rendition) selection.
	   *
	   * @param {Object=} error an optional error that may include the playlist
	   * to blacklist
	   * @param {number=} blacklistDuration an optional number of seconds to blacklist the
	   * playlist
	   */
	  ;
	
	  _proto.blacklistCurrentPlaylist = function blacklistCurrentPlaylist(error, blacklistDuration) {
	    if (error === void 0) {
	      error = {};
	    } // If the `error` was generated by the playlist loader, it will contain
	    // the playlist we were trying to load (but failed) and that should be
	    // blacklisted instead of the currently selected playlist which is likely
	    // out-of-date in this scenario
	
	
	    var currentPlaylist = error.playlist || this.masterPlaylistLoader_.media();
	    blacklistDuration = blacklistDuration || error.blacklistDuration || this.blacklistDuration; // If there is no current playlist, then an error occurred while we were
	    // trying to load the master OR while we were disposing of the tech
	
	    if (!currentPlaylist) {
	      this.error = error;
	
	      if (this.mediaSource.readyState !== 'open') {
	        this.trigger('error');
	      } else {
	        this.sourceUpdater_.endOfStream('network');
	      }
	
	      return;
	    }
	
	    currentPlaylist.playlistErrors_++;
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var enabledPlaylists = playlists.filter(isEnabled);
	    var isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === currentPlaylist; // Don't blacklist the only playlist unless it was blacklisted
	    // forever
	
	    if (playlists.length === 1 && blacklistDuration !== Infinity) {
	      videojs.log.warn("Problem encountered with playlist " + currentPlaylist.id + ". " + 'Trying again since it is the only playlist.');
	      this.tech_.trigger('retryplaylist'); // if this is a final rendition, we should delay
	
	      return this.masterPlaylistLoader_.load(isFinalRendition);
	    }
	
	    if (isFinalRendition) {
	      // Since we're on the final non-blacklisted playlist, and we're about to blacklist
	      // it, instead of erring the player or retrying this playlist, clear out the current
	      // blacklist. This allows other playlists to be attempted in case any have been
	      // fixed.
	      var reincluded = false;
	      playlists.forEach(function (playlist) {
	        // skip current playlist which is about to be blacklisted
	        if (playlist === currentPlaylist) {
	          return;
	        }
	
	        var excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
	
	        if (typeof excludeUntil !== 'undefined' && excludeUntil !== Infinity) {
	          reincluded = true;
	          delete playlist.excludeUntil;
	        }
	      });
	
	      if (reincluded) {
	        videojs.log.warn('Removing other playlists from the exclusion list because the last ' + 'rendition is about to be excluded.'); // Technically we are retrying a playlist, in that we are simply retrying a previous
	        // playlist. This is needed for users relying on the retryplaylist event to catch a
	        // case where the player might be stuck and looping through "dead" playlists.
	
	        this.tech_.trigger('retryplaylist');
	      }
	    } // Blacklist this playlist
	
	
	    var excludeUntil;
	
	    if (currentPlaylist.playlistErrors_ > this.maxPlaylistRetries) {
	      excludeUntil = Infinity;
	    } else {
	      excludeUntil = Date.now() + blacklistDuration * 1000;
	    }
	
	    currentPlaylist.excludeUntil = excludeUntil;
	
	    if (error.reason) {
	      currentPlaylist.lastExcludeReason_ = error.reason;
	    }
	
	    this.tech_.trigger('blacklistplaylist');
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-rendition-blacklisted'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-rendition-blacklisted'
	    }); // TODO: should we select a new playlist if this blacklist wasn't for the currentPlaylist?
	    // Would be something like media().id !=== currentPlaylist.id and we  would need something
	    // like `pendingMedia` in playlist loaders to check against that too. This will prevent us
	    // from loading a new playlist on any blacklist.
	    // Select a new playlist
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (!nextPlaylist) {
	      this.error = 'Playback cannot continue. No available working or supported playlists.';
	      this.trigger('error');
	      return;
	    }
	
	    var logFn = error.internal ? this.logger_ : videojs.log.warn;
	    var errorMessage = error.message ? ' ' + error.message : '';
	    logFn((error.internal ? 'Internal problem' : 'Problem') + " encountered with playlist " + currentPlaylist.id + "." + (errorMessage + " Switching to playlist " + nextPlaylist.id + ".")); // if audio group changed reset audio loaders
	
	    if (nextPlaylist.attributes.AUDIO !== currentPlaylist.attributes.AUDIO) {
	      this.delegateLoaders_('audio', ['abort', 'pause']);
	    } // if subtitle group changed reset subtitle loaders
	
	
	    if (nextPlaylist.attributes.SUBTITLES !== currentPlaylist.attributes.SUBTITLES) {
	      this.delegateLoaders_('subtitle', ['abort', 'pause']);
	    }
	
	    this.delegateLoaders_('main', ['abort', 'pause']);
	    var delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5 * 1000;
	    var shouldDelay = typeof nextPlaylist.lastRequest === 'number' && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
	
	    return this.switchMedia_(nextPlaylist, 'exclude', isFinalRendition || shouldDelay);
	  }
	  /**
	   * Pause all segment/playlist loaders
	   */
	  ;
	
	  _proto.pauseLoading = function pauseLoading() {
	    this.delegateLoaders_('all', ['abort', 'pause']);
	    this.stopABRTimer_();
	  }
	  /**
	   * Call a set of functions in order on playlist loaders, segment loaders,
	   * or both types of loaders.
	   *
	   * @param {string} filter
	   *        Filter loaders that should call fnNames using a string. Can be:
	   *        * all - run on all loaders
	   *        * audio - run on all audio loaders
	   *        * subtitle - run on all subtitle loaders
	   *        * main - run on the main/master loaders
	   *
	   * @param {Array|string} fnNames
	   *        A string or array of function names to call.
	   */
	  ;
	
	  _proto.delegateLoaders_ = function delegateLoaders_(filter, fnNames) {
	    var _this7 = this;
	
	    var loaders = [];
	    var dontFilterPlaylist = filter === 'all';
	
	    if (dontFilterPlaylist || filter === 'main') {
	      loaders.push(this.masterPlaylistLoader_);
	    }
	
	    var mediaTypes = [];
	
	    if (dontFilterPlaylist || filter === 'audio') {
	      mediaTypes.push('AUDIO');
	    }
	
	    if (dontFilterPlaylist || filter === 'subtitle') {
	      mediaTypes.push('CLOSED-CAPTIONS');
	      mediaTypes.push('SUBTITLES');
	    }
	
	    mediaTypes.forEach(function (mediaType) {
	      var loader = _this7.mediaTypes_[mediaType] && _this7.mediaTypes_[mediaType].activePlaylistLoader;
	
	      if (loader) {
	        loaders.push(loader);
	      }
	    });
	    ['main', 'audio', 'subtitle'].forEach(function (name) {
	      var loader = _this7[name + "SegmentLoader_"];
	
	      if (loader && (filter === name || filter === 'all')) {
	        loaders.push(loader);
	      }
	    });
	    loaders.forEach(function (loader) {
	      return fnNames.forEach(function (fnName) {
	        if (typeof loader[fnName] === 'function') {
	          loader[fnName]();
	        }
	      });
	    });
	  }
	  /**
	   * set the current time on all segment loaders
	   *
	   * @param {TimeRange} currentTime the current time to set
	   * @return {TimeRange} the current time
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    var buffered = findRange(this.tech_.buffered(), currentTime);
	
	    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media())) {
	      // return immediately if the metadata is not ready yet
	      return 0;
	    } // it's clearly an edge-case but don't thrown an error if asked to
	    // seek within an empty playlist
	
	
	    if (!this.masterPlaylistLoader_.media().segments) {
	      return 0;
	    } // if the seek location is already buffered, continue buffering as usual
	
	
	    if (buffered && buffered.length) {
	      return currentTime;
	    } // cancel outstanding requests so we begin buffering at the new
	    // location
	
	
	    this.mainSegmentLoader_.resetEverything();
	    this.mainSegmentLoader_.abort();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.resetEverything();
	      this.audioSegmentLoader_.abort();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.resetEverything();
	      this.subtitleSegmentLoader_.abort();
	    } // start segment loader loading in case they are paused
	
	
	    this.load();
	  }
	  /**
	   * get the current duration
	   *
	   * @return {TimeRange} the duration
	   */
	  ;
	
	  _proto.duration = function duration() {
	    if (!this.masterPlaylistLoader_) {
	      return 0;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      // no playlists loaded yet, so can't determine a duration
	      return 0;
	    } // Don't rely on the media source for duration in the case of a live playlist since
	    // setting the native MediaSource's duration to infinity ends up with consequences to
	    // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	    //
	    // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	    // however, few browsers have support for setLiveSeekableRange()
	    // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	    //
	    // Until a time when the duration of the media source can be set to infinity, and a
	    // seekable range specified across browsers, just return Infinity.
	
	
	    if (!media.endList) {
	      return Infinity;
	    } // Since this is a VOD video, it is safe to rely on the media source's duration (if
	    // available). If it's not available, fall back to a playlist-calculated estimate.
	
	
	    if (this.mediaSource) {
	      return this.mediaSource.duration;
	    }
	
	    return Vhs$1.Playlist.duration(media);
	  }
	  /**
	   * check the seekable range
	   *
	   * @return {TimeRange} the seekable range
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.seekable_;
	  };
	
	  _proto.onSyncInfoUpdate_ = function onSyncInfoUpdate_() {
	    var audioSeekable; // TODO check for creation of both source buffers before updating seekable
	    //
	    // A fix was made to this function where a check for
	    // this.sourceUpdater_.hasCreatedSourceBuffers
	    // was added to ensure that both source buffers were created before seekable was
	    // updated. However, it originally had a bug where it was checking for a true and
	    // returning early instead of checking for false. Setting it to check for false to
	    // return early though created other issues. A call to play() would check for seekable
	    // end without verifying that a seekable range was present. In addition, even checking
	    // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
	    // due to a media update calling load on the segment loaders, skipping a seek to live,
	    // thereby starting live streams at the beginning of the stream rather than at the end.
	    //
	    // This conditional should be fixed to wait for the creation of two source buffers at
	    // the same time as the other sections of code are fixed to properly seek to live and
	    // not throw an error due to checking for a seekable end when no seekable range exists.
	    //
	    // For now, fall back to the older behavior, with the understanding that the seekable
	    // range may not be completely correct, leading to a suboptimal initial live point.
	
	    if (!this.masterPlaylistLoader_) {
	      return;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      return;
	    }
	
	    var expired = this.syncController_.getExpiredTime(media, this.duration());
	
	    if (expired === null) {
	      // not enough information to update seekable
	      return;
	    }
	
	    var master = this.masterPlaylistLoader_.master;
	    var mainSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	    if (mainSeekable.length === 0) {
	      return;
	    }
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
	      expired = this.syncController_.getExpiredTime(media, this.duration());
	
	      if (expired === null) {
	        return;
	      }
	
	      audioSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	      if (audioSeekable.length === 0) {
	        return;
	      }
	    }
	
	    var oldEnd;
	    var oldStart;
	
	    if (this.seekable_ && this.seekable_.length) {
	      oldEnd = this.seekable_.end(0);
	      oldStart = this.seekable_.start(0);
	    }
	
	    if (!audioSeekable) {
	      // seekable has been calculated based on buffering video data so it
	      // can be returned directly
	      this.seekable_ = mainSeekable;
	    } else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) {
	      // seekables are pretty far off, rely on main
	      this.seekable_ = mainSeekable;
	    } else {
	      this.seekable_ = videojs.createTimeRanges([[audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0), audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)]]);
	    } // seekable is the same as last time
	
	
	    if (this.seekable_ && this.seekable_.length) {
	      if (this.seekable_.end(0) === oldEnd && this.seekable_.start(0) === oldStart) {
	        return;
	      }
	    }
	
	    this.logger_("seekable updated [" + printableRange(this.seekable_) + "]");
	    this.tech_.trigger('seekablechanged');
	  }
	  /**
	   * Update the player duration
	   */
	  ;
	
	  _proto.updateDuration = function updateDuration(isLive) {
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	      this.updateDuration_ = null;
	    }
	
	    if (this.mediaSource.readyState !== 'open') {
	      this.updateDuration_ = this.updateDuration.bind(this, isLive);
	      this.mediaSource.addEventListener('sourceopen', this.updateDuration_);
	      return;
	    }
	
	    if (isLive) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        return;
	      } // Even in the case of a live playlist, the native MediaSource's duration should not
	      // be set to Infinity (even though this would be expected for a live playlist), since
	      // setting the native MediaSource's duration to infinity ends up with consequences to
	      // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	      //
	      // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	      // however, few browsers have support for setLiveSeekableRange()
	      // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	      //
	      // Until a time when the duration of the media source can be set to infinity, and a
	      // seekable range specified across browsers, the duration should be greater than or
	      // equal to the last possible seekable value.
	      // MediaSource duration starts as NaN
	      // It is possible (and probable) that this case will never be reached for many
	      // sources, since the MediaSource reports duration as the highest value without
	      // accounting for timestamp offset. For example, if the timestamp offset is -100 and
	      // we buffered times 0 to 100 with real times of 100 to 200, even though current
	      // time will be between 0 and 100, the native media source may report the duration
	      // as 200. However, since we report duration separate from the media source (as
	      // Infinity), and as long as the native media source duration value is greater than
	      // our reported seekable range, seeks will work as expected. The large number as
	      // duration for live is actually a strategy used by some players to work around the
	      // issue of live seekable ranges cited above.
	
	
	      if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) {
	        this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
	      }
	
	      return;
	    }
	
	    var buffered = this.tech_.buffered();
	    var duration = Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());
	
	    if (buffered.length > 0) {
	      duration = Math.max(duration, buffered.end(buffered.length - 1));
	    }
	
	    if (this.mediaSource.duration !== duration) {
	      this.sourceUpdater_.setDuration(duration);
	    }
	  }
	  /**
	   * dispose of the MasterPlaylistController and everything
	   * that it controls
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this8 = this;
	
	    this.trigger('dispose');
	    this.decrypter_.terminate();
	    this.masterPlaylistLoader_.dispose();
	    this.mainSegmentLoader_.dispose();
	
	    if (this.loadOnPlay_) {
	      this.tech_.off('play', this.loadOnPlay_);
	    }
	
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      var groups = _this8.mediaTypes_[type].groups;
	
	      for (var id in groups) {
	        groups[id].forEach(function (group) {
	          if (group.playlistLoader) {
	            group.playlistLoader.dispose();
	          }
	        });
	      }
	    });
	    this.audioSegmentLoader_.dispose();
	    this.subtitleSegmentLoader_.dispose();
	    this.sourceUpdater_.dispose();
	    this.timelineChangeController_.dispose();
	    this.stopABRTimer_();
	
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	    }
	
	    this.mediaSource.removeEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
	
	    this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen_);
	    this.mediaSource.removeEventListener('sourceended', this.handleSourceEnded_);
	    this.off();
	  }
	  /**
	   * return the master playlist object if we have one
	   *
	   * @return {Object} the master playlist object that we parsed
	   */
	  ;
	
	  _proto.master = function master() {
	    return this.masterPlaylistLoader_.master;
	  }
	  /**
	   * return the currently selected playlist
	   *
	   * @return {Object} the currently selected playlist object that we parsed
	   */
	  ;
	
	  _proto.media = function media() {
	    // playlist loader will not return media if it has not been fully loaded
	    return this.masterPlaylistLoader_.media() || this.initialMedia_;
	  };
	
	  _proto.areMediaTypesKnown_ = function areMediaTypesKnown_() {
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	    var hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
	    // otherwise check on the segment loader.
	
	    var hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
	
	    if (!hasMainMediaInfo || !hasAudioMediaInfo) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCodecsOrExclude_ = function getCodecsOrExclude_() {
	    var _this9 = this;
	
	    var media = {
	      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
	      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
	    };
	    var playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
	
	    media.video = media.main;
	    var playlistCodecs = codecsForPlaylist(this.master(), playlist);
	    var codecs = {};
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	
	    if (media.main.hasVideo) {
	      codecs.video = playlistCodecs.video || media.main.videoCodec || codecs_js.DEFAULT_VIDEO_CODEC;
	    }
	
	    if (media.main.isMuxed) {
	      codecs.video += "," + (playlistCodecs.audio || media.main.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC);
	    }
	
	    if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
	      codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC; // set audio isFmp4 so we use the correct "supports" function below
	
	      media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
	    } // no codecs, no playback.
	
	
	    if (!codecs.audio && !codecs.video) {
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        message: 'Could not determine codecs for playlist.',
	        blacklistDuration: Infinity
	      });
	      return;
	    } // fmp4 relies on browser support, while ts relies on muxer support
	
	
	    var supportFunction = function supportFunction(isFmp4, codec) {
	      return isFmp4 ? codecs_js.browserSupportsCodec(codec) : codecs_js.muxerSupportsCodec(codec);
	    };
	
	    var unsupportedCodecs = {};
	    var unsupportedAudio;
	    ['video', 'audio'].forEach(function (type) {
	      if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
	        var supporter = media[type].isFmp4 ? 'browser' : 'muxer';
	        unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
	        unsupportedCodecs[supporter].push(codecs[type]);
	
	        if (type === 'audio') {
	          unsupportedAudio = supporter;
	        }
	      }
	    });
	
	    if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
	      var audioGroup = playlist.attributes.AUDIO;
	      this.master().playlists.forEach(function (variant) {
	        var variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
	
	        if (variantAudioGroup === audioGroup && variant !== playlist) {
	          variant.excludeUntil = Infinity;
	        }
	      });
	      this.logger_("excluding audio group " + audioGroup + " as " + unsupportedAudio + " does not support codec(s): \"" + codecs.audio + "\"");
	    } // if we have any unsupported codecs blacklist this playlist.
	
	
	    if (Object.keys(unsupportedCodecs).length) {
	      var message = Object.keys(unsupportedCodecs).reduce(function (acc, supporter) {
	        if (acc) {
	          acc += ', ';
	        }
	
	        acc += supporter + " does not support codec(s): \"" + unsupportedCodecs[supporter].join(',') + "\"";
	        return acc;
	      }, '') + '.';
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        internal: true,
	        message: message,
	        blacklistDuration: Infinity
	      });
	      return;
	    } // check if codec switching is happening
	
	
	    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
	      var switchMessages = [];
	      ['video', 'audio'].forEach(function (type) {
	        var newCodec = (codecs_js.parseCodecs(_this9.sourceUpdater_.codecs[type] || '')[0] || {}).type;
	        var oldCodec = (codecs_js.parseCodecs(codecs[type] || '')[0] || {}).type;
	
	        if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) {
	          switchMessages.push("\"" + _this9.sourceUpdater_.codecs[type] + "\" -> \"" + codecs[type] + "\"");
	        }
	      });
	
	      if (switchMessages.length) {
	        this.blacklistCurrentPlaylist({
	          playlist: playlist,
	          message: "Codec switching not supported: " + switchMessages.join(', ') + ".",
	          blacklistDuration: Infinity,
	          internal: true
	        });
	        return;
	      }
	    } // TODO: when using the muxer shouldn't we just return
	    // the codecs that the muxer outputs?
	
	
	    return codecs;
	  }
	  /**
	   * Create source buffers and exlude any incompatible renditions.
	   *
	   * @private
	   */
	  ;
	
	  _proto.tryToCreateSourceBuffers_ = function tryToCreateSourceBuffers_() {
	    // media source is not ready yet or sourceBuffers are already
	    // created.
	    if (this.mediaSource.readyState !== 'open' || this.sourceUpdater_.hasCreatedSourceBuffers()) {
	      return;
	    }
	
	    if (!this.areMediaTypesKnown_()) {
	      return;
	    }
	
	    var codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	    if (!codecs) {
	      return;
	    }
	
	    this.sourceUpdater_.createSourceBuffers(codecs);
	    var codecString = [codecs.video, codecs.audio].filter(Boolean).join(',');
	    this.excludeIncompatibleVariants_(codecString);
	  }
	  /**
	   * Excludes playlists with codecs that are unsupported by the muxer and browser.
	   */
	  ;
	
	  _proto.excludeUnsupportedVariants_ = function excludeUnsupportedVariants_() {
	    var _this10 = this;
	
	    var playlists = this.master().playlists;
	    var ids = []; // TODO: why don't we have a property to loop through all
	    // playlist? Why did we ever mix indexes and keys?
	
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	
	      if (ids.indexOf(variant.id) !== -1) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var codecs = codecsForPlaylist(_this10.master, variant);
	      var unsupported = [];
	
	      if (codecs.audio && !codecs_js.muxerSupportsCodec(codecs.audio) && !codecs_js.browserSupportsCodec(codecs.audio)) {
	        unsupported.push("audio codec " + codecs.audio);
	      }
	
	      if (codecs.video && !codecs_js.muxerSupportsCodec(codecs.video) && !codecs_js.browserSupportsCodec(codecs.video)) {
	        unsupported.push("video codec " + codecs.video);
	      }
	
	      if (codecs.text && codecs.text === 'stpp.ttml.im1t') {
	        unsupported.push("text codec " + codecs.text);
	      }
	
	      if (unsupported.length) {
	        variant.excludeUntil = Infinity;
	
	        _this10.logger_("excluding " + variant.id + " for unsupported: " + unsupported.join(', '));
	      }
	    });
	  }
	  /**
	   * Blacklist playlists that are known to be codec or
	   * stream-incompatible with the SourceBuffer configuration. For
	   * instance, Media Source Extensions would cause the video element to
	   * stall waiting for video data if you switched from a variant with
	   * video and audio to an audio-only one.
	   *
	   * @param {Object} media a media playlist compatible with the current
	   * set of SourceBuffers. Variants in the current master playlist that
	   * do not appear to have compatible codec or stream configurations
	   * will be excluded from the default playlist selection algorithm
	   * indefinitely.
	   * @private
	   */
	  ;
	
	  _proto.excludeIncompatibleVariants_ = function excludeIncompatibleVariants_(codecString) {
	    var _this11 = this;
	
	    var ids = [];
	    var playlists = this.master().playlists;
	    var codecs = unwrapCodecList(codecs_js.parseCodecs(codecString));
	    var codecCount_ = codecCount(codecs);
	    var videoDetails = codecs.video && codecs_js.parseCodecs(codecs.video)[0] || null;
	    var audioDetails = codecs.audio && codecs_js.parseCodecs(codecs.audio)[0] || null;
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	      // or it if it is already excluded forever.
	
	      if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var blacklistReasons = []; // get codecs from the playlist for this variant
	
	      var variantCodecs = codecsForPlaylist(_this11.masterPlaylistLoader_.master, variant);
	      var variantCodecCount = codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
	      // variant is incompatible. Wait for mux.js to probe
	
	      if (!variantCodecs.audio && !variantCodecs.video) {
	        return;
	      } // TODO: we can support this by removing the
	      // old media source and creating a new one, but it will take some work.
	      // The number of streams cannot change
	
	
	      if (variantCodecCount !== codecCount_) {
	        blacklistReasons.push("codec count \"" + variantCodecCount + "\" !== \"" + codecCount_ + "\"");
	      } // only exclude playlists by codec change, if codecs cannot switch
	      // during playback.
	
	
	      if (!_this11.sourceUpdater_.canChangeType()) {
	        var variantVideoDetails = variantCodecs.video && codecs_js.parseCodecs(variantCodecs.video)[0] || null;
	        var variantAudioDetails = variantCodecs.audio && codecs_js.parseCodecs(variantCodecs.audio)[0] || null; // the video codec cannot change
	
	        if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) {
	          blacklistReasons.push("video codec \"" + variantVideoDetails.type + "\" !== \"" + videoDetails.type + "\"");
	        } // the audio codec cannot change
	
	
	        if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) {
	          blacklistReasons.push("audio codec \"" + variantAudioDetails.type + "\" !== \"" + audioDetails.type + "\"");
	        }
	      }
	
	      if (blacklistReasons.length) {
	        variant.excludeUntil = Infinity;
	
	        _this11.logger_("blacklisting " + variant.id + ": " + blacklistReasons.join(' && '));
	      }
	    });
	  };
	
	  _proto.updateAdCues_ = function updateAdCues_(media) {
	    var offset = 0;
	    var seekable = this.seekable();
	
	    if (seekable.length) {
	      offset = seekable.start(0);
	    }
	
	    updateAdCues(media, this.cueTagsTrack_, offset);
	  }
	  /**
	   * Calculates the desired forward buffer length based on current time
	   *
	   * @return {number} Desired forward buffer length in seconds
	   */
	  ;
	
	  _proto.goalBufferLength = function goalBufferLength() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.GOAL_BUFFER_LENGTH;
	    var rate = Config.GOAL_BUFFER_LENGTH_RATE;
	    var max = Math.max(initial, Config.MAX_GOAL_BUFFER_LENGTH);
	    return Math.min(initial + currentTime * rate, max);
	  }
	  /**
	   * Calculates the desired buffer low water line based on current time
	   *
	   * @return {number} Desired buffer low water line in seconds
	   */
	  ;
	
	  _proto.bufferLowWaterLine = function bufferLowWaterLine() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.BUFFER_LOW_WATER_LINE;
	    var rate = Config.BUFFER_LOW_WATER_LINE_RATE;
	    var max = Math.max(initial, Config.MAX_BUFFER_LOW_WATER_LINE);
	    var newMax = Math.max(initial, Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
	    return Math.min(initial + currentTime * rate, this.experimentalBufferBasedABR ? newMax : max);
	  };
	
	  _proto.bufferHighWaterLine = function bufferHighWaterLine() {
	    return Config.BUFFER_HIGH_WATER_LINE;
	  };
	
	  return MasterPlaylistController;
	}(videojs.EventTarget);
	/**
	 * Returns a function that acts as the Enable/disable playlist function.
	 *
	 * @param {PlaylistLoader} loader - The master playlist loader
	 * @param {string} playlistID - id of the playlist
	 * @param {Function} changePlaylistFn - A function to be called after a
	 * playlist's enabled-state has been changed. Will NOT be called if a
	 * playlist's enabled-state is unchanged
	 * @param {boolean=} enable - Value to set the playlist enabled-state to
	 * or if undefined returns the current enabled-state for the playlist
	 * @return {Function} Function for setting/getting enabled
	 */
	
	
	var enableFunction = function enableFunction(loader, playlistID, changePlaylistFn) {
	  return function (enable) {
	    var playlist = loader.master.playlists[playlistID];
	    var incompatible = isIncompatible(playlist);
	    var currentlyEnabled = isEnabled(playlist);
	
	    if (typeof enable === 'undefined') {
	      return currentlyEnabled;
	    }
	
	    if (enable) {
	      delete playlist.disabled;
	    } else {
	      playlist.disabled = true;
	    }
	
	    if (enable !== currentlyEnabled && !incompatible) {
	      // Ensure the outside world knows about our changes
	      changePlaylistFn();
	
	      if (enable) {
	        loader.trigger('renditionenabled');
	      } else {
	        loader.trigger('renditiondisabled');
	      }
	    }
	
	    return enable;
	  };
	};
	/**
	 * The representation object encapsulates the publicly visible information
	 * in a media playlist along with a setter/getter-type function (enabled)
	 * for changing the enabled-state of a particular playlist entry
	 *
	 * @class Representation
	 */
	
	
	var Representation = function Representation(vhsHandler, playlist, id) {
	  var mpc = vhsHandler.masterPlaylistController_,
	      smoothQualityChange = vhsHandler.options_.smoothQualityChange; // Get a reference to a bound version of the quality change function
	
	  var changeType = smoothQualityChange ? 'smooth' : 'fast';
	  var qualityChangeFunction = mpc[changeType + "QualityChange_"].bind(mpc); // some playlist attributes are optional
	
	  if (playlist.attributes) {
	    var resolution = playlist.attributes.RESOLUTION;
	    this.width = resolution && resolution.width;
	    this.height = resolution && resolution.height;
	    this.bandwidth = playlist.attributes.BANDWIDTH;
	    this.frameRate = playlist.attributes['FRAME-RATE'];
	  }
	
	  this.codecs = codecsForPlaylist(mpc.master(), playlist);
	  this.playlist = playlist; // The id is simply the ordinality of the media playlist
	  // within the master playlist
	
	  this.id = id; // Partially-apply the enableFunction to create a playlist-
	  // specific variant
	
	  this.enabled = enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
	};
	/**
	 * A mixin function that adds the `representations` api to an instance
	 * of the VhsHandler class
	 *
	 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
	 * representation API into
	 */
	
	
	var renditionSelectionMixin = function renditionSelectionMixin(vhsHandler) {
	  // Add a single API-specific function to the VhsHandler instance
	  vhsHandler.representations = function () {
	    var master = vhsHandler.masterPlaylistController_.master();
	    var playlists = isAudioOnly(master) ? vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_() : master.playlists;
	
	    if (!playlists) {
	      return [];
	    }
	
	    return playlists.filter(function (media) {
	      return !isIncompatible(media);
	    }).map(function (e, i) {
	      return new Representation(vhsHandler, e, e.id);
	    });
	  };
	};
	/**
	 * @file playback-watcher.js
	 *
	 * Playback starts, and now my watch begins. It shall not end until my death. I shall
	 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
	 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
	 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
	 * my life and honor to the Playback Watch, for this Player and all the Players to come.
	 */
	
	
	var timerCancelEvents = ['seeking', 'seeked', 'pause', 'playing', 'error'];
	/**
	 * @class PlaybackWatcher
	 */
	
	var PlaybackWatcher = /*#__PURE__*/function () {
	  /**
	   * Represents an PlaybackWatcher object.
	   *
	   * @class
	   * @param {Object} options an object that includes the tech and settings
	   */
	  function PlaybackWatcher(options) {
	    var _this = this;
	
	    this.masterPlaylistController_ = options.masterPlaylistController;
	    this.tech_ = options.tech;
	    this.seekable = options.seekable;
	    this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
	    this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
	    this.media = options.media;
	    this.consecutiveUpdates = 0;
	    this.lastRecordedTime = null;
	    this.timer_ = null;
	    this.checkCurrentTimeTimeout_ = null;
	    this.logger_ = logger('PlaybackWatcher');
	    this.logger_('initialize');
	
	    var playHandler = function playHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var canPlayHandler = function canPlayHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var waitingHandler = function waitingHandler() {
	      return _this.techWaiting_();
	    };
	
	    var cancelTimerHandler = function cancelTimerHandler() {
	      return _this.cancelTimer_();
	    };
	
	    var mpc = this.masterPlaylistController_;
	    var loaderTypes = ['main', 'subtitle', 'audio'];
	    var loaderChecks = {};
	    loaderTypes.forEach(function (type) {
	      loaderChecks[type] = {
	        reset: function reset() {
	          return _this.resetSegmentDownloads_(type);
	        },
	        updateend: function updateend() {
	          return _this.checkSegmentDownloads_(type);
	        }
	      };
	      mpc[type + "SegmentLoader_"].on('appendsdone', loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
	      // isn't changing we want to reset. We cannot assume that the new rendition
	      // will also be stalled, until after new appends.
	
	      mpc[type + "SegmentLoader_"].on('playlistupdate', loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
	      // This prevents one segment playlists (single vtt or single segment content)
	      // from being detected as stalling. As the buffer will not change in those cases, since
	      // the buffer is the entire video duration.
	
	      _this.tech_.on(['seeked', 'seeking'], loaderChecks[type].reset);
	    });
	    /**
	     * We check if a seek was into a gap through the following steps:
	     * 1. We get a seeking event and we do not get a seeked event. This means that
	     *    a seek was attempted but not completed.
	     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
	     *    removed everything from our buffer and appended a segment, and should be ready
	     *    to check for gaps.
	     */
	
	    var setSeekingHandlers = function setSeekingHandlers(fn) {
	      ['main', 'audio'].forEach(function (type) {
	        mpc[type + "SegmentLoader_"][fn]('appended', _this.seekingAppendCheck_);
	      });
	    };
	
	    this.seekingAppendCheck_ = function () {
	      if (_this.fixesBadSeeks_()) {
	        _this.consecutiveUpdates = 0;
	        _this.lastRecordedTime = _this.tech_.currentTime();
	        setSeekingHandlers('off');
	      }
	    };
	
	    this.clearSeekingAppendCheck_ = function () {
	      return setSeekingHandlers('off');
	    };
	
	    this.watchForBadSeeking_ = function () {
	      _this.clearSeekingAppendCheck_();
	
	      setSeekingHandlers('on');
	    };
	
	    this.tech_.on('seeked', this.clearSeekingAppendCheck_);
	    this.tech_.on('seeking', this.watchForBadSeeking_);
	    this.tech_.on('waiting', waitingHandler);
	    this.tech_.on(timerCancelEvents, cancelTimerHandler);
	    this.tech_.on('canplay', canPlayHandler);
	    /*
	      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
	      is surfaced in one of two ways:
	       1)  The `waiting` event is fired before the player has buffered content, making it impossible
	          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
	          we can check if playback is stalled due to a gap, and skip the gap if necessary.
	      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
	          is in a playing state. To catch this case, it's important that our one-time play listener is setup
	          even if the player is in a playing state
	    */
	
	    this.tech_.one('play', playHandler); // Define the dispose function to clean up our events
	
	    this.dispose = function () {
	      _this.clearSeekingAppendCheck_();
	
	      _this.logger_('dispose');
	
	      _this.tech_.off('waiting', waitingHandler);
	
	      _this.tech_.off(timerCancelEvents, cancelTimerHandler);
	
	      _this.tech_.off('canplay', canPlayHandler);
	
	      _this.tech_.off('play', playHandler);
	
	      _this.tech_.off('seeking', _this.watchForBadSeeking_);
	
	      _this.tech_.off('seeked', _this.clearSeekingAppendCheck_);
	
	      loaderTypes.forEach(function (type) {
	        mpc[type + "SegmentLoader_"].off('appendsdone', loaderChecks[type].updateend);
	        mpc[type + "SegmentLoader_"].off('playlistupdate', loaderChecks[type].reset);
	
	        _this.tech_.off(['seeked', 'seeking'], loaderChecks[type].reset);
	      });
	
	      if (_this.checkCurrentTimeTimeout_) {
	        window__default['default'].clearTimeout(_this.checkCurrentTimeTimeout_);
	      }
	
	      _this.cancelTimer_();
	    };
	  }
	  /**
	   * Periodically check current time to see if playback stopped
	   *
	   * @private
	   */
	
	
	  var _proto = PlaybackWatcher.prototype;
	
	  _proto.monitorCurrentTime_ = function monitorCurrentTime_() {
	    this.checkCurrentTime_();
	
	    if (this.checkCurrentTimeTimeout_) {
	      window__default['default'].clearTimeout(this.checkCurrentTimeTimeout_);
	    } // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	
	
	    this.checkCurrentTimeTimeout_ = window__default['default'].setTimeout(this.monitorCurrentTime_.bind(this), 250);
	  }
	  /**
	   * Reset stalled download stats for a specific type of loader
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#playlistupdate
	   * @listens Tech#seeking
	   * @listens Tech#seeked
	   */
	  ;
	
	  _proto.resetSegmentDownloads_ = function resetSegmentDownloads_(type) {
	    var loader = this.masterPlaylistController_[type + "SegmentLoader_"];
	
	    if (this[type + "StalledDownloads_"] > 0) {
	      this.logger_("resetting possible stalled download count for " + type + " loader");
	    }
	
	    this[type + "StalledDownloads_"] = 0;
	    this[type + "Buffered_"] = loader.buffered_();
	  }
	  /**
	   * Checks on every segment `appendsdone` to see
	   * if segment appends are making progress. If they are not
	   * and we are still downloading bytes. We blacklist the playlist.
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#appendsdone
	   */
	  ;
	
	  _proto.checkSegmentDownloads_ = function checkSegmentDownloads_(type) {
	    var mpc = this.masterPlaylistController_;
	    var loader = mpc[type + "SegmentLoader_"];
	    var buffered = loader.buffered_();
	    var isBufferedDifferent = isRangeDifferent(this[type + "Buffered_"], buffered);
	    this[type + "Buffered_"] = buffered; // if another watcher is going to fix the issue or
	    // the buffered value for this loader changed
	    // appends are working
	
	    if (isBufferedDifferent) {
	      this.resetSegmentDownloads_(type);
	      return;
	    }
	
	    this[type + "StalledDownloads_"]++;
	    this.logger_("found #" + this[type + "StalledDownloads_"] + " " + type + " appends that did not increase buffer (possible stalled download)", {
	      playlistId: loader.playlist_ && loader.playlist_.id,
	      buffered: timeRangesToArray(buffered)
	    }); // after 10 possibly stalled appends with no reset, exclude
	
	    if (this[type + "StalledDownloads_"] < 10) {
	      return;
	    }
	
	    this.logger_(type + " loader stalled download exclusion");
	    this.resetSegmentDownloads_(type);
	    this.tech_.trigger({
	      type: 'usage',
	      name: "vhs-" + type + "-download-exclusion"
	    });
	
	    if (type === 'subtitle') {
	      return;
	    } // TODO: should we exclude audio tracks rather than main tracks
	    // when type is audio?
	
	
	    mpc.blacklistCurrentPlaylist({
	      message: "Excessive " + type + " segment downloading detected."
	    }, Infinity);
	  }
	  /**
	   * The purpose of this function is to emulate the "waiting" event on
	   * browsers that do not emit it when they are waiting for more
	   * data to continue playback
	   *
	   * @private
	   */
	  ;
	
	  _proto.checkCurrentTime_ = function checkCurrentTime_() {
	    if (this.tech_.paused() || this.tech_.seeking()) {
	      return;
	    }
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) {
	      // If current time is at the end of the final buffered region, then any playback
	      // stall is most likely caused by buffering in a low bandwidth environment. The tech
	      // should fire a `waiting` event in this scenario, but due to browser and tech
	      // inconsistencies. Calling `techWaiting_` here allows us to simulate
	      // responding to a native `waiting` event when the tech fails to emit one.
	      return this.techWaiting_();
	    }
	
	    if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	      this.waiting_();
	    } else if (currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	    } else {
	      this.consecutiveUpdates = 0;
	      this.lastRecordedTime = currentTime;
	    }
	  }
	  /**
	   * Cancels any pending timers and resets the 'timeupdate' mechanism
	   * designed to detect that we are stalled
	   *
	   * @private
	   */
	  ;
	
	  _proto.cancelTimer_ = function cancelTimer_() {
	    this.consecutiveUpdates = 0;
	
	    if (this.timer_) {
	      this.logger_('cancelTimer_');
	      clearTimeout(this.timer_);
	    }
	
	    this.timer_ = null;
	  }
	  /**
	   * Fixes situations where there's a bad seek
	   *
	   * @return {boolean} whether an action was taken to fix the seek
	   * @private
	   */
	  ;
	
	  _proto.fixesBadSeeks_ = function fixesBadSeeks_() {
	    var seeking = this.tech_.seeking();
	
	    if (!seeking) {
	      return false;
	    } // TODO: It's possible that these seekable checks should be moved out of this function
	    // and into a function that runs on seekablechange. It's also possible that we only need
	    // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
	    // seekable range.
	
	
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	    var isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
	    var seekTo;
	
	    if (isAfterSeekableRange) {
	      var seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
	
	      seekTo = seekableEnd;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var seekableStart = seekable.start(0); // sync to the beginning of the live window
	      // provide a buffer of .1 seconds to handle rounding/imprecise numbers
	
	      seekTo = seekableStart + ( // if the playlist is too short and the seekable range is an exact time (can
	      // happen in live with a 3 segment playlist), then don't use a time delta
	      seekableStart === seekable.end(0) ? 0 : SAFE_TIME_DELTA);
	    }
	
	    if (typeof seekTo !== 'undefined') {
	      this.logger_("Trying to seek outside of seekable at time " + currentTime + " with " + ("seekable range " + printableRange(seekable) + ". Seeking to ") + (seekTo + "."));
	      this.tech_.setCurrentTime(seekTo);
	      return true;
	    }
	
	    var sourceUpdater = this.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
	    var videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
	    var media = this.media(); // verify that at least two segment durations or one part duration have been
	    // appended before checking for a gap.
	
	    var minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
	    // appended before checking for a gap.
	
	    var bufferedToCheck = [audioBuffered, videoBuffered];
	
	    for (var i = 0; i < bufferedToCheck.length; i++) {
	      // skip null buffered
	      if (!bufferedToCheck[i]) {
	        continue;
	      }
	
	      var timeAhead = timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
	      // duration behind we haven't appended enough to call this a bad seek.
	
	      if (timeAhead < minAppendedDuration) {
	        return false;
	      }
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
	    // to seek over the gap
	
	    if (nextRange.length === 0) {
	      return false;
	    }
	
	    seekTo = nextRange.start(0) + SAFE_TIME_DELTA;
	    this.logger_("Buffered region starts (" + nextRange.start(0) + ") " + (" just beyond seek point (" + currentTime + "). Seeking to " + seekTo + "."));
	    this.tech_.setCurrentTime(seekTo);
	    return true;
	  }
	  /**
	   * Handler for situations when we determine the player is waiting.
	   *
	   * @private
	   */
	  ;
	
	  _proto.waiting_ = function waiting_() {
	    if (this.techWaiting_()) {
	      return;
	    } // All tech waiting checks failed. Use last resort correction
	
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	    var currentRange = findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
	    // region with no indication that anything is amiss (seen in Firefox). Seeking to
	    // currentTime is usually enough to kickstart the player. This checks that the player
	    // is currently within a buffered region before attempting a corrective seek.
	    // Chrome does not appear to continue `timeupdate` events after a `waiting` event
	    // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
	    // make sure there is ~3 seconds of forward buffer before taking any corrective action
	    // to avoid triggering an `unknownwaiting` event when the network is slow.
	
	    if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime);
	      this.logger_("Stopped at " + currentTime + " while inside a buffered region " + ("[" + currentRange.start(0) + " -> " + currentRange.end(0) + "]. Attempting to resume ") + 'playback by seeking to the current time.'); // unknown waiting corrections may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-unknown-waiting'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-unknown-waiting'
	      });
	      return;
	    }
	  }
	  /**
	   * Handler for situations when the tech fires a `waiting` event
	   *
	   * @return {boolean}
	   *         True if an action (or none) was needed to correct the waiting. False if no
	   *         checks passed
	   * @private
	   */
	  ;
	
	  _proto.techWaiting_ = function techWaiting_() {
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	
	    if (this.tech_.seeking() || this.timer_ !== null) {
	      // Tech is seeking or already waiting on another action, no action needed
	      return true;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var livePoint = seekable.end(seekable.length - 1);
	      this.logger_("Fell out of live window at time " + currentTime + ". Seeking to " + ("live point (seekable end) " + livePoint));
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-live-resync'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-live-resync'
	      });
	      return true;
	    }
	
	    var sourceUpdater = this.tech_.vhs.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var videoUnderflow = this.videoUnderflow_({
	      audioBuffered: sourceUpdater.audioBuffered(),
	      videoBuffered: sourceUpdater.videoBuffered(),
	      currentTime: currentTime
	    });
	
	    if (videoUnderflow) {
	      // Even though the video underflowed and was stuck in a gap, the audio overplayed
	      // the gap, leading currentTime into a buffered range. Seeking to currentTime
	      // allows the video to catch up to the audio position without losing any audio
	      // (only suffering ~3 seconds of frozen video and a pause in audio playback).
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-video-underflow'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-video-underflow'
	      });
	      return true;
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // check for gap
	
	    if (nextRange.length > 0) {
	      var difference = nextRange.start(0) - currentTime;
	      this.logger_("Stopped at " + currentTime + ", setting timer for " + difference + ", seeking " + ("to " + nextRange.start(0)));
	      this.cancelTimer_();
	      this.timer_ = setTimeout(this.skipTheGap_.bind(this), difference * 1000, currentTime);
	      return true;
	    } // All checks failed. Returning false to indicate failure to correct waiting
	
	
	    return false;
	  };
	
	  _proto.afterSeekableWindow_ = function afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow) {
	    if (allowSeeksWithinUnsafeLiveWindow === void 0) {
	      allowSeeksWithinUnsafeLiveWindow = false;
	    }
	
	    if (!seekable.length) {
	      // we can't make a solid case if there's no seekable, default to false
	      return false;
	    }
	
	    var allowedEnd = seekable.end(seekable.length - 1) + SAFE_TIME_DELTA;
	    var isLive = !playlist.endList;
	
	    if (isLive && allowSeeksWithinUnsafeLiveWindow) {
	      allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
	    }
	
	    if (currentTime > allowedEnd) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.beforeSeekableWindow_ = function beforeSeekableWindow_(seekable, currentTime) {
	    if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
	    seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.videoUnderflow_ = function videoUnderflow_(_ref) {
	    var videoBuffered = _ref.videoBuffered,
	        audioBuffered = _ref.audioBuffered,
	        currentTime = _ref.currentTime; // audio only content will not have video underflow :)
	
	    if (!videoBuffered) {
	      return;
	    }
	
	    var gap; // find a gap in demuxed content.
	
	    if (videoBuffered.length && audioBuffered.length) {
	      // in Chrome audio will continue to play for ~3s when we run out of video
	      // so we have to check that the video buffer did have some buffer in the
	      // past.
	      var lastVideoRange = findRange(videoBuffered, currentTime - 3);
	      var videoRange = findRange(videoBuffered, currentTime);
	      var audioRange = findRange(audioBuffered, currentTime);
	
	      if (audioRange.length && !videoRange.length && lastVideoRange.length) {
	        gap = {
	          start: lastVideoRange.end(0),
	          end: audioRange.end(0)
	        };
	      } // find a gap in muxed content.
	
	    } else {
	      var nextRange = findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
	      // stuck in a gap due to video underflow.
	
	      if (!nextRange.length) {
	        gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
	      }
	    }
	
	    if (gap) {
	      this.logger_("Encountered a gap in video from " + gap.start + " to " + gap.end + ". " + ("Seeking to current time " + currentTime));
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Timer callback. If playback still has not proceeded, then we seek
	   * to the start of the next buffered region.
	   *
	   * @private
	   */
	  ;
	
	  _proto.skipTheGap_ = function skipTheGap_(scheduledCurrentTime) {
	    var buffered = this.tech_.buffered();
	    var currentTime = this.tech_.currentTime();
	    var nextRange = findNextRange(buffered, currentTime);
	    this.cancelTimer_();
	
	    if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) {
	      return;
	    }
	
	    this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0)); // only seek if we still have not played
	
	    this.tech_.setCurrentTime(nextRange.start(0) + TIME_FUDGE_FACTOR);
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-gap-skip'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-gap-skip'
	    });
	  };
	
	  _proto.gapFromVideoUnderflow_ = function gapFromVideoUnderflow_(buffered, currentTime) {
	    // At least in Chrome, if there is a gap in the video buffer, the audio will continue
	    // playing for ~3 seconds after the video gap starts. This is done to account for
	    // video buffer underflow/underrun (note that this is not done when there is audio
	    // buffer underflow/underrun -- in that case the video will stop as soon as it
	    // encounters the gap, as audio stalls are more noticeable/jarring to a user than
	    // video stalls). The player's time will reflect the playthrough of audio, so the
	    // time will appear as if we are in a buffered region, even if we are stuck in a
	    // "gap."
	    //
	    // Example:
	    // video buffer:   0 => 10.1, 10.2 => 20
	    // audio buffer:   0 => 20
	    // overall buffer: 0 => 10.1, 10.2 => 20
	    // current time: 13
	    //
	    // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
	    // however, the audio continued playing until it reached ~3 seconds past the gap
	    // (13 seconds), at which point it stops as well. Since current time is past the
	    // gap, findNextRange will return no ranges.
	    //
	    // To check for this issue, we see if there is a gap that starts somewhere within
	    // a 3 second range (3 seconds +/- 1 second) back from our current time.
	    var gaps = findGaps(buffered);
	
	    for (var i = 0; i < gaps.length; i++) {
	      var start = gaps.start(i);
	      var end = gaps.end(i); // gap is starts no more than 4 seconds back
	
	      if (currentTime - start < 4 && currentTime - start > 2) {
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }
	
	    return null;
	  };
	
	  return PlaybackWatcher;
	}();
	
	var defaultOptions = {
	  errorInterval: 30,
	  getSource: function getSource(next) {
	    var tech = this.tech({
	      IWillNotUseThisInPlugins: true
	    });
	    var sourceObj = tech.currentSource_ || this.currentSource();
	    return next(sourceObj);
	  }
	};
	/**
	 * Main entry point for the plugin
	 *
	 * @param {Player} player a reference to a videojs Player instance
	 * @param {Object} [options] an object with plugin options
	 * @private
	 */
	
	var initPlugin = function initPlugin(player, options) {
	  var lastCalled = 0;
	  var seekTo = 0;
	  var localOptions = videojs.mergeOptions(defaultOptions, options);
	  player.ready(function () {
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload-initialized'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload-initialized'
	    });
	  });
	  /**
	   * Player modifications to perform that must wait until `loadedmetadata`
	   * has been triggered
	   *
	   * @private
	   */
	
	  var loadedMetadataHandler = function loadedMetadataHandler() {
	    if (seekTo) {
	      player.currentTime(seekTo);
	    }
	  };
	  /**
	   * Set the source on the player element, play, and seek if necessary
	   *
	   * @param {Object} sourceObj An object specifying the source url and mime-type to play
	   * @private
	   */
	
	
	  var setSource = function setSource(sourceObj) {
	    if (sourceObj === null || sourceObj === undefined) {
	      return;
	    }
	
	    seekTo = player.duration() !== Infinity && player.currentTime() || 0;
	    player.one('loadedmetadata', loadedMetadataHandler);
	    player.src(sourceObj);
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload'
	    });
	    player.play();
	  };
	  /**
	   * Attempt to get a source from either the built-in getSource function
	   * or a custom function provided via the options
	   *
	   * @private
	   */
	
	
	  var errorHandler = function errorHandler() {
	    // Do not attempt to reload the source if a source-reload occurred before
	    // 'errorInterval' time has elapsed since the last source-reload
	    if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
	      player.trigger({
	        type: 'usage',
	        name: 'vhs-error-reload-canceled'
	      });
	      player.trigger({
	        type: 'usage',
	        name: 'hls-error-reload-canceled'
	      });
	      return;
	    }
	
	    if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
	      videojs.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
	      return;
	    }
	
	    lastCalled = Date.now();
	    return localOptions.getSource.call(player, setSource);
	  };
	  /**
	   * Unbind any event handlers that were bound by the plugin
	   *
	   * @private
	   */
	
	
	  var cleanupEvents = function cleanupEvents() {
	    player.off('loadedmetadata', loadedMetadataHandler);
	    player.off('error', errorHandler);
	    player.off('dispose', cleanupEvents);
	  };
	  /**
	   * Cleanup before re-initializing the plugin
	   *
	   * @param {Object} [newOptions] an object with plugin options
	   * @private
	   */
	
	
	  var reinitPlugin = function reinitPlugin(newOptions) {
	    cleanupEvents();
	    initPlugin(player, newOptions);
	  };
	
	  player.on('error', errorHandler);
	  player.on('dispose', cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
	  // initializing the plugin
	
	  player.reloadSourceOnError = reinitPlugin;
	};
	/**
	 * Reload the source when an error is detected as long as there
	 * wasn't an error previously within the last 30 seconds
	 *
	 * @param {Object} [options] an object with plugin options
	 */
	
	
	var reloadSourceOnError = function reloadSourceOnError(options) {
	  initPlugin(this, options);
	};
	
	var version$4 = "2.16.3";
	var version$3 = "6.0.1";
	var version$2 = "0.22.1";
	var version$1 = "4.8.0";
	var version = "3.1.3";
	var Vhs = {
	  PlaylistLoader: PlaylistLoader,
	  Playlist: Playlist,
	  utils: utils,
	  STANDARD_PLAYLIST_SELECTOR: lastBandwidthSelector,
	  INITIAL_PLAYLIST_SELECTOR: lowestBitrateCompatibleVariantSelector,
	  lastBandwidthSelector: lastBandwidthSelector,
	  movingAverageBandwidthSelector: movingAverageBandwidthSelector,
	  comparePlaylistBandwidth: comparePlaylistBandwidth,
	  comparePlaylistResolution: comparePlaylistResolution,
	  xhr: xhrFactory()
	}; // Define getter/setters for config properties
	
	Object.keys(Config).forEach(function (prop) {
	  Object.defineProperty(Vhs, prop, {
	    get: function get() {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	      return Config[prop];
	    },
	    set: function set(value) {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	
	      if (typeof value !== 'number' || value < 0) {
	        videojs.log.warn("value of Vhs." + prop + " must be greater than or equal to 0");
	        return;
	      }
	
	      Config[prop] = value;
	    }
	  });
	});
	var LOCAL_STORAGE_KEY = 'videojs-vhs';
	/**
	 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
	 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
	 * @function handleVhsMediaChange
	 */
	
	var handleVhsMediaChange = function handleVhsMediaChange(qualityLevels, playlistLoader) {
	  var newPlaylist = playlistLoader.media();
	  var selectedIndex = -1;
	
	  for (var i = 0; i < qualityLevels.length; i++) {
	    if (qualityLevels[i].id === newPlaylist.id) {
	      selectedIndex = i;
	      break;
	    }
	  }
	
	  qualityLevels.selectedIndex_ = selectedIndex;
	  qualityLevels.trigger({
	    selectedIndex: selectedIndex,
	    type: 'change'
	  });
	};
	/**
	 * Adds quality levels to list once playlist metadata is available
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
	 * @param {Object} vhs Vhs object to listen to for media events.
	 * @function handleVhsLoadedMetadata
	 */
	
	
	var handleVhsLoadedMetadata = function handleVhsLoadedMetadata(qualityLevels, vhs) {
	  vhs.representations().forEach(function (rep) {
	    qualityLevels.addQualityLevel(rep);
	  });
	  handleVhsMediaChange(qualityLevels, vhs.playlists);
	}; // HLS is a source handler, not a tech. Make sure attempts to use it
	// as one do not cause exceptions.
	
	
	Vhs.canPlaySource = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var emeKeySystems = function emeKeySystems(keySystemOptions, mainPlaylist, audioPlaylist) {
	  if (!keySystemOptions) {
	    return keySystemOptions;
	  }
	
	  var codecs = {};
	
	  if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) {
	    codecs = unwrapCodecList(codecs_js.parseCodecs(mainPlaylist.attributes.CODECS));
	  }
	
	  if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) {
	    codecs.audio = audioPlaylist.attributes.CODECS;
	  }
	
	  var videoContentType = codecs_js.getMimeForCodec(codecs.video);
	  var audioContentType = codecs_js.getMimeForCodec(codecs.audio); // upsert the content types based on the selected playlist
	
	  var keySystemContentTypes = {};
	
	  for (var keySystem in keySystemOptions) {
	    keySystemContentTypes[keySystem] = {};
	
	    if (audioContentType) {
	      keySystemContentTypes[keySystem].audioContentType = audioContentType;
	    }
	
	    if (videoContentType) {
	      keySystemContentTypes[keySystem].videoContentType = videoContentType;
	    } // Default to using the video playlist's PSSH even though they may be different, as
	    // videojs-contrib-eme will only accept one in the options.
	    //
	    // This shouldn't be an issue for most cases as early intialization will handle all
	    // unique PSSH values, and if they aren't, then encrypted events should have the
	    // specific information needed for the unique license.
	
	
	    if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) {
	      keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
	    } // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
	    // so we need to prevent overwriting the URL entirely
	
	
	    if (typeof keySystemOptions[keySystem] === 'string') {
	      keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
	    }
	  }
	
	  return videojs.mergeOptions(keySystemOptions, keySystemContentTypes);
	};
	/**
	 * @typedef {Object} KeySystems
	 *
	 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
	 * Note: not all options are listed here.
	 *
	 * @property {Uint8Array} [pssh]
	 *           Protection System Specific Header
	 */
	
	/**
	 * Goes through all the playlists and collects an array of KeySystems options objects
	 * containing each playlist's keySystems and their pssh values, if available.
	 *
	 * @param {Object[]} playlists
	 *        The playlists to look through
	 * @param {string[]} keySystems
	 *        The keySystems to collect pssh values for
	 *
	 * @return {KeySystems[]}
	 *         An array of KeySystems objects containing available key systems and their
	 *         pssh values
	 */
	
	
	var getAllPsshKeySystemsOptions = function getAllPsshKeySystemsOptions(playlists, keySystems) {
	  return playlists.reduce(function (keySystemsArr, playlist) {
	    if (!playlist.contentProtection) {
	      return keySystemsArr;
	    }
	
	    var keySystemsOptions = keySystems.reduce(function (keySystemsObj, keySystem) {
	      var keySystemOptions = playlist.contentProtection[keySystem];
	
	      if (keySystemOptions && keySystemOptions.pssh) {
	        keySystemsObj[keySystem] = {
	          pssh: keySystemOptions.pssh
	        };
	      }
	
	      return keySystemsObj;
	    }, {});
	
	    if (Object.keys(keySystemsOptions).length) {
	      keySystemsArr.push(keySystemsOptions);
	    }
	
	    return keySystemsArr;
	  }, []);
	};
	/**
	 * Returns a promise that waits for the
	 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
	 *
	 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
	 * browsers.
	 *
	 * As per the above ticket, this is particularly important for Chrome, where, if
	 * unencrypted content is appended before encrypted content and the key session has not
	 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
	 * during playback.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 * @param {Object[]} mainPlaylists
	 *        The playlists found on the master playlist object
	 *
	 * @return {Object}
	 *         Promise that resolves when the key session has been created
	 */
	
	
	var waitForKeySessionCreation = function waitForKeySessionCreation(_ref) {
	  var player = _ref.player,
	      sourceKeySystems = _ref.sourceKeySystems,
	      audioMedia = _ref.audioMedia,
	      mainPlaylists = _ref.mainPlaylists;
	
	  if (!player.eme.initializeMediaKeys) {
	    return Promise.resolve();
	  } // TODO should all audio PSSH values be initialized for DRM?
	  //
	  // All unique video rendition pssh values are initialized for DRM, but here only
	  // the initial audio playlist license is initialized. In theory, an encrypted
	  // event should be fired if the user switches to an alternative audio playlist
	  // where a license is required, but this case hasn't yet been tested. In addition, there
	  // may be many alternate audio playlists unlikely to be used (e.g., multiple different
	  // languages).
	
	
	  var playlists = audioMedia ? mainPlaylists.concat([audioMedia]) : mainPlaylists;
	  var keySystemsOptionsArr = getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
	  var initializationFinishedPromises = [];
	  var keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
	  // only place where it should not be deduped is for ms-prefixed APIs, but the early
	  // return for IE11 above, and the existence of modern EME APIs in addition to
	  // ms-prefixed APIs on Edge should prevent this from being a concern.
	  // initializeMediaKeys also won't use the webkit-prefixed APIs.
	
	  keySystemsOptionsArr.forEach(function (keySystemsOptions) {
	    keySessionCreatedPromises.push(new Promise(function (resolve, reject) {
	      player.tech_.one('keysessioncreated', resolve);
	    }));
	    initializationFinishedPromises.push(new Promise(function (resolve, reject) {
	      player.eme.initializeMediaKeys({
	        keySystems: keySystemsOptions
	      }, function (err) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve();
	      });
	    }));
	  }); // The reasons Promise.race is chosen over Promise.any:
	  //
	  // * Promise.any is only available in Safari 14+.
	  // * None of these promises are expected to reject. If they do reject, it might be
	  //   better here for the race to surface the rejection, rather than mask it by using
	  //   Promise.any.
	
	  return Promise.race([// If a session was previously created, these will all finish resolving without
	  // creating a new session, otherwise it will take until the end of all license
	  // requests, which is why the key session check is used (to make setup much faster).
	  Promise.all(initializationFinishedPromises), // Once a single session is created, the browser knows DRM will be used.
	  Promise.race(keySessionCreatedPromises)]);
	};
	/**
	 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
	 * there are keySystems on the source, sets up source options to prepare the source for
	 * eme.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} media
	 *        The active media playlist
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 *
	 * @return {boolean}
	 *         Whether or not options were configured and EME is available
	 */
	
	
	var setupEmeOptions = function setupEmeOptions(_ref2) {
	  var player = _ref2.player,
	      sourceKeySystems = _ref2.sourceKeySystems,
	      media = _ref2.media,
	      audioMedia = _ref2.audioMedia;
	  var sourceOptions = emeKeySystems(sourceKeySystems, media, audioMedia);
	
	  if (!sourceOptions) {
	    return false;
	  }
	
	  player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
	  // do nothing.
	
	  if (sourceOptions && !player.eme) {
	    videojs.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');
	    return false;
	  }
	
	  return true;
	};
	
	var getVhsLocalStorage = function getVhsLocalStorage() {
	  if (!window__default['default'].localStorage) {
	    return null;
	  }
	
	  var storedObject = window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY);
	
	  if (!storedObject) {
	    return null;
	  }
	
	  try {
	    return JSON.parse(storedObject);
	  } catch (e) {
	    // someone may have tampered with the value
	    return null;
	  }
	};
	
	var updateVhsLocalStorage = function updateVhsLocalStorage(options) {
	  if (!window__default['default'].localStorage) {
	    return false;
	  }
	
	  var objectToStore = getVhsLocalStorage();
	  objectToStore = objectToStore ? videojs.mergeOptions(objectToStore, options) : options;
	
	  try {
	    window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
	  } catch (e) {
	    // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
	    // storage is set to 0).
	    // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
	    // No need to perform any operation.
	    return false;
	  }
	
	  return objectToStore;
	};
	/**
	 * Parses VHS-supported media types from data URIs. See
	 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
	 * for information on data URIs.
	 *
	 * @param {string} dataUri
	 *        The data URI
	 *
	 * @return {string|Object}
	 *         The parsed object/string, or the original string if no supported media type
	 *         was found
	 */
	
	
	var expandDataUri = function expandDataUri(dataUri) {
	  if (dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,') === 0) {
	    return JSON.parse(dataUri.substring(dataUri.indexOf(',') + 1));
	  } // no known case for this data URI, return the string as-is
	
	
	  return dataUri;
	};
	/**
	 * Whether the browser has built-in HLS support.
	 */
	
	
	Vhs.supportsNativeHls = function () {
	  if (!document__default['default'] || !document__default['default'].createElement) {
	    return false;
	  }
	
	  var video = document__default['default'].createElement('video'); // native HLS is definitely not supported if HTML5 video isn't
	
	  if (!videojs.getTech('Html5').isSupported()) {
	    return false;
	  } // HLS manifests can go by many mime-types
	
	
	  var canPlay = [// Apple santioned
	  'application/vnd.apple.mpegurl', // Apple sanctioned for backwards compatibility
	  'audio/mpegurl', // Very common
	  'audio/x-mpegurl', // Very common
	  'application/x-mpegurl', // Included for completeness
	  'video/x-mpegurl', 'video/mpegurl', 'application/mpegurl'];
	  return canPlay.some(function (canItPlay) {
	    return /maybe|probably/i.test(video.canPlayType(canItPlay));
	  });
	}();
	
	Vhs.supportsNativeDash = function () {
	  if (!document__default['default'] || !document__default['default'].createElement || !videojs.getTech('Html5').isSupported()) {
	    return false;
	  }
	
	  return /maybe|probably/i.test(document__default['default'].createElement('video').canPlayType('application/dash+xml'));
	}();
	
	Vhs.supportsTypeNatively = function (type) {
	  if (type === 'hls') {
	    return Vhs.supportsNativeHls;
	  }
	
	  if (type === 'dash') {
	    return Vhs.supportsNativeDash;
	  }
	
	  return false;
	};
	/**
	 * HLS is a source handler, not a tech. Make sure attempts to use it
	 * as one do not cause exceptions.
	 */
	
	
	Vhs.isSupported = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var Component = videojs.getComponent('Component');
	/**
	 * The Vhs Handler object, where we orchestrate all of the parts
	 * of HLS to interact with video.js
	 *
	 * @class VhsHandler
	 * @extends videojs.Component
	 * @param {Object} source the soruce object
	 * @param {Tech} tech the parent tech object
	 * @param {Object} options optional and required options
	 */
	
	var VhsHandler = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VhsHandler, _Component);
	
	  function VhsHandler(source, tech, options) {
	    var _this;
	
	    _this = _Component.call(this, tech, videojs.mergeOptions(options.hls, options.vhs)) || this;
	
	    if (options.hls && Object.keys(options.hls).length) {
	      videojs.log.warn('Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.');
	    } // if a tech level `initialBandwidth` option was passed
	    // use that over the VHS level `bandwidth` option
	
	
	    if (typeof options.initialBandwidth === 'number') {
	      _this.options_.bandwidth = options.initialBandwidth;
	    }
	
	    _this.logger_ = logger('VhsHandler'); // tech.player() is deprecated but setup a reference to HLS for
	    // backwards-compatibility
	
	    if (tech.options_ && tech.options_.playerId) {
	      var _player = videojs(tech.options_.playerId);
	
	      if (!_player.hasOwnProperty('hls')) {
	        Object.defineProperty(_player, 'hls', {
	          get: function get() {
	            videojs.log.warn('player.hls is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'hls-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('vhs')) {
	        Object.defineProperty(_player, 'vhs', {
	          get: function get() {
	            videojs.log.warn('player.vhs is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'vhs-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('dash')) {
	        Object.defineProperty(_player, 'dash', {
	          get: function get() {
	            videojs.log.warn('player.dash is deprecated. Use player.tech().vhs instead.');
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      _this.player_ = _player;
	    }
	
	    _this.tech_ = tech;
	    _this.source_ = source;
	    _this.stats = {};
	    _this.ignoreNextSeekingEvent_ = false;
	
	    _this.setOptions_();
	
	    if (_this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
	      tech.overrideNativeAudioTracks(true);
	      tech.overrideNativeVideoTracks(true);
	    } else if (_this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) {
	      // overriding native HLS only works if audio tracks have been emulated
	      // error early if we're misconfigured
	      throw new Error('Overriding native HLS requires emulated tracks. ' + 'See https://git.io/vMpjB');
	    } // listen for fullscreenchange events for this player so that we
	    // can adjust our quality selection quickly
	
	
	    _this.on(document__default['default'], ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'], function (event) {
	      var fullscreenElement = document__default['default'].fullscreenElement || document__default['default'].webkitFullscreenElement || document__default['default'].mozFullScreenElement || document__default['default'].msFullscreenElement;
	
	      if (fullscreenElement && fullscreenElement.contains(_this.tech_.el())) {
	        _this.masterPlaylistController_.fastQualityChange_();
	      } else {
	        // When leaving fullscreen, since the in page pixel dimensions should be smaller
	        // than full screen, see if there should be a rendition switch down to preserve
	        // bandwidth.
	        _this.masterPlaylistController_.checkABR_();
	      }
	    });
	
	    _this.on(_this.tech_, 'seeking', function () {
	      if (this.ignoreNextSeekingEvent_) {
	        this.ignoreNextSeekingEvent_ = false;
	        return;
	      }
	
	      this.setCurrentTime(this.tech_.currentTime());
	    });
	
	    _this.on(_this.tech_, 'error', function () {
	      // verify that the error was real and we are loaded
	      // enough to have mpc loaded.
	      if (this.tech_.error() && this.masterPlaylistController_) {
	        this.masterPlaylistController_.pauseLoading();
	      }
	    });
	
	    _this.on(_this.tech_, 'play', _this.play);
	
	    return _this;
	  }
	
	  var _proto = VhsHandler.prototype;
	
	  _proto.setOptions_ = function setOptions_() {
	    var _this2 = this; // defaults
	
	
	    this.options_.withCredentials = this.options_.withCredentials || false;
	    this.options_.handleManifestRedirects = this.options_.handleManifestRedirects === false ? false : true;
	    this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
	    this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
	    this.options_.smoothQualityChange = this.options_.smoothQualityChange || false;
	    this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== 'undefined' ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
	    this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || false;
	    this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
	    this.options_.customTagParsers = this.options_.customTagParsers || [];
	    this.options_.customTagMappers = this.options_.customTagMappers || [];
	    this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
	
	    if (typeof this.options_.blacklistDuration !== 'number') {
	      this.options_.blacklistDuration = 5 * 60;
	    }
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      if (this.options_.useBandwidthFromLocalStorage) {
	        var storedObject = getVhsLocalStorage();
	
	        if (storedObject && storedObject.bandwidth) {
	          this.options_.bandwidth = storedObject.bandwidth;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-bandwidth-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-bandwidth-from-local-storage'
	          });
	        }
	
	        if (storedObject && storedObject.throughput) {
	          this.options_.throughput = storedObject.throughput;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-throughput-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-throughput-from-local-storage'
	          });
	        }
	      }
	    } // if bandwidth was not set by options or pulled from local storage, start playlist
	    // selection at a reasonable bandwidth
	
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      this.options_.bandwidth = Config.INITIAL_BANDWIDTH;
	    } // If the bandwidth number is unchanged from the initial setting
	    // then this takes precedence over the enableLowInitialPlaylist option
	
	
	    this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Config.INITIAL_BANDWIDTH; // grab options passed to player.src
	
	    ['withCredentials', 'useDevicePixelRatio', 'limitRenditionByPlayerDimensions', 'bandwidth', 'smoothQualityChange', 'customTagParsers', 'customTagMappers', 'handleManifestRedirects', 'cacheEncryptionKeys', 'playlistSelector', 'initialPlaylistSelector', 'experimentalBufferBasedABR', 'liveRangeSafeTimeDelta', 'experimentalLLHLS', 'useNetworkInformationApi', 'useDtsForTimestampOffset', 'experimentalExactManifestTimings', 'experimentalLeastPixelDiffSelector'].forEach(function (option) {
	      if (typeof _this2.source_[option] !== 'undefined') {
	        _this2.options_[option] = _this2.source_[option];
	      }
	    });
	    this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
	    this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
	  }
	  /**
	   * called when player.src gets called, handle a new source
	   *
	   * @param {Object} src the source object to handle
	   */
	  ;
	
	  _proto.src = function src(_src, type) {
	    var _this3 = this; // do nothing if the src is falsey
	
	
	    if (!_src) {
	      return;
	    }
	
	    this.setOptions_(); // add master playlist controller options
	
	    this.options_.src = expandDataUri(this.source_.src);
	    this.options_.tech = this.tech_;
	    this.options_.externVhs = Vhs;
	    this.options_.sourceType = mediaTypes_js.simpleTypeFromSourceType(type); // Whenever we seek internally, we should update the tech
	
	    this.options_.seekTo = function (time) {
	      _this3.tech_.setCurrentTime(time);
	    };
	
	    if (this.options_.smoothQualityChange) {
	      videojs.log.warn('smoothQualityChange is deprecated and will be removed in the next major version');
	    }
	
	    this.masterPlaylistController_ = new MasterPlaylistController(this.options_);
	    var playbackWatcherOptions = videojs.mergeOptions({
	      liveRangeSafeTimeDelta: SAFE_TIME_DELTA
	    }, this.options_, {
	      seekable: function seekable() {
	        return _this3.seekable();
	      },
	      media: function media() {
	        return _this3.masterPlaylistController_.media();
	      },
	      masterPlaylistController: this.masterPlaylistController_
	    });
	    this.playbackWatcher_ = new PlaybackWatcher(playbackWatcherOptions);
	    this.masterPlaylistController_.on('error', function () {
	      var player = videojs.players[_this3.tech_.options_.playerId];
	      var error = _this3.masterPlaylistController_.error;
	
	      if (typeof error === 'object' && !error.code) {
	        error.code = 3;
	      } else if (typeof error === 'string') {
	        error = {
	          message: error,
	          code: 3
	        };
	      }
	
	      player.error(error);
	    });
	    var defaultSelector = this.options_.experimentalBufferBasedABR ? Vhs.movingAverageBandwidthSelector(0.55) : Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
	    // compatibility with < v2
	
	    this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
	    this.masterPlaylistController_.selectInitialPlaylist = Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
	
	    this.playlists = this.masterPlaylistController_.masterPlaylistLoader_;
	    this.mediaSource = this.masterPlaylistController_.mediaSource; // Proxy assignment of some properties to the master playlist
	    // controller. Using a custom property for backwards compatibility
	    // with < v2
	
	    Object.defineProperties(this, {
	      selectPlaylist: {
	        get: function get() {
	          return this.masterPlaylistController_.selectPlaylist;
	        },
	        set: function set(selectPlaylist) {
	          this.masterPlaylistController_.selectPlaylist = selectPlaylist.bind(this);
	        }
	      },
	      throughput: {
	        get: function get() {
	          return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
	        },
	        set: function set(throughput) {
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
	          // for the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
	        }
	      },
	      bandwidth: {
	        get: function get() {
	          var playerBandwidthEst = this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
	          var networkInformation = window__default['default'].navigator.connection || window__default['default'].navigator.mozConnection || window__default['default'].navigator.webkitConnection;
	          var tenMbpsAsBitsPerSecond = 10e6;
	
	          if (this.options_.useNetworkInformationApi && networkInformation) {
	            // downlink returns Mbps
	            // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
	            var networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000 * 1000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
	            // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
	            // high quality streams are not filtered out.
	
	            if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) {
	              playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
	            } else {
	              playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
	            }
	          }
	
	          return playerBandwidthEst;
	        },
	        set: function set(bandwidth) {
	          this.masterPlaylistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
	          // `count` is set to zero that current value of `rate` isn't included
	          // in the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput = {
	            rate: 0,
	            count: 0
	          };
	        }
	      },
	
	      /**
	       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
	       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
	       * the entire process after that - decryption, transmuxing, and appending - provided
	       * by `throughput`.
	       *
	       * Since the two process are serial, the overall system bandwidth is given by:
	       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
	       */
	      systemBandwidth: {
	        get: function get() {
	          var invBandwidth = 1 / (this.bandwidth || 1);
	          var invThroughput;
	
	          if (this.throughput > 0) {
	            invThroughput = 1 / this.throughput;
	          } else {
	            invThroughput = 0;
	          }
	
	          var systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
	          return systemBitrate;
	        },
	        set: function set() {
	          videojs.log.error('The "systemBandwidth" property is read-only');
	        }
	      }
	    });
	
	    if (this.options_.bandwidth) {
	      this.bandwidth = this.options_.bandwidth;
	    }
	
	    if (this.options_.throughput) {
	      this.throughput = this.options_.throughput;
	    }
	
	    Object.defineProperties(this.stats, {
	      bandwidth: {
	        get: function get() {
	          return _this3.bandwidth || 0;
	        },
	        enumerable: true
	      },
	      mediaRequests: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequests_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsAborted: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsAborted_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsTimedout: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsTimedout_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsErrored: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsErrored_() || 0;
	        },
	        enumerable: true
	      },
	      mediaTransferDuration: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaTransferDuration_() || 0;
	        },
	        enumerable: true
	      },
	      mediaBytesTransferred: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaBytesTransferred_() || 0;
	        },
	        enumerable: true
	      },
	      mediaSecondsLoaded: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaSecondsLoaded_() || 0;
	        },
	        enumerable: true
	      },
	      mediaAppends: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaAppends_() || 0;
	        },
	        enumerable: true
	      },
	      mainAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      audioAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      appendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.appendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      timeToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.timeToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      buffered: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.buffered());
	        },
	        enumerable: true
	      },
	      currentTime: {
	        get: function get() {
	          return _this3.tech_.currentTime();
	        },
	        enumerable: true
	      },
	      currentSource: {
	        get: function get() {
	          return _this3.tech_.currentSource_;
	        },
	        enumerable: true
	      },
	      currentTech: {
	        get: function get() {
	          return _this3.tech_.name_;
	        },
	        enumerable: true
	      },
	      duration: {
	        get: function get() {
	          return _this3.tech_.duration();
	        },
	        enumerable: true
	      },
	      master: {
	        get: function get() {
	          return _this3.playlists.master;
	        },
	        enumerable: true
	      },
	      playerDimensions: {
	        get: function get() {
	          return _this3.tech_.currentDimensions();
	        },
	        enumerable: true
	      },
	      seekable: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.seekable());
	        },
	        enumerable: true
	      },
	      timestamp: {
	        get: function get() {
	          return Date.now();
	        },
	        enumerable: true
	      },
	      videoPlaybackQuality: {
	        get: function get() {
	          return _this3.tech_.getVideoPlaybackQuality();
	        },
	        enumerable: true
	      }
	    });
	    this.tech_.one('canplay', this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));
	    this.tech_.on('bandwidthupdate', function () {
	      if (_this3.options_.useBandwidthFromLocalStorage) {
	        updateVhsLocalStorage({
	          bandwidth: _this3.bandwidth,
	          throughput: Math.round(_this3.throughput)
	        });
	      }
	    });
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      // Add the manual rendition mix-in to VhsHandler
	      renditionSelectionMixin(_this3);
	    });
	    this.masterPlaylistController_.sourceUpdater_.on('createdsourcebuffers', function () {
	      _this3.setupEme_();
	    }); // the bandwidth of the primary segment loader is our best
	    // estimate of overall bandwidth
	
	    this.on(this.masterPlaylistController_, 'progress', function () {
	      this.tech_.trigger('progress');
	    }); // In the live case, we need to ignore the very first `seeking` event since
	    // that will be the result of the seek-to-live behavior
	
	    this.on(this.masterPlaylistController_, 'firstplay', function () {
	      this.ignoreNextSeekingEvent_ = true;
	    });
	    this.setupQualityLevels_(); // do nothing if the tech has been disposed already
	    // this can occur if someone sets the src in player.ready(), for instance
	
	    if (!this.tech_.el()) {
	      return;
	    }
	
	    this.mediaSourceUrl_ = window__default['default'].URL.createObjectURL(this.masterPlaylistController_.mediaSource);
	    this.tech_.src(this.mediaSourceUrl_);
	  };
	
	  _proto.createKeySessions_ = function createKeySessions_() {
	    var _this4 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    this.logger_('waiting for EME key session creation');
	    waitForKeySessionCreation({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
	      mainPlaylists: this.playlists.master.playlists
	    }).then(function () {
	      _this4.logger_('created EME key session');
	
	      _this4.masterPlaylistController_.sourceUpdater_.initializedEme();
	    })["catch"](function (err) {
	      _this4.logger_('error while creating EME key session', err);
	
	      _this4.player_.error({
	        message: 'Failed to initialize media keys for EME',
	        code: 3
	      });
	    });
	  };
	
	  _proto.handleWaitingForKey_ = function handleWaitingForKey_() {
	    // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
	    // the key is in the manifest. While this should've happened on initial source load, it
	    // may happen again in live streams where the keys change, and the manifest info
	    // reflects the update.
	    //
	    // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
	    // already requested keys for, we don't have to worry about this generating extraneous
	    // requests.
	    this.logger_('waitingforkey fired, attempting to create any new key sessions');
	    this.createKeySessions_();
	  }
	  /**
	   * If necessary and EME is available, sets up EME options and waits for key session
	   * creation.
	   *
	   * This function also updates the source updater so taht it can be used, as for some
	   * browsers, EME must be configured before content is appended (if appending unencrypted
	   * content before encrypted content).
	   */
	  ;
	
	  _proto.setupEme_ = function setupEme_() {
	    var _this5 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    var didSetupEmeOptions = setupEmeOptions({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      media: this.playlists.media(),
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
	    });
	    this.player_.tech_.on('keystatuschange', function (e) {
	      if (e.status !== 'output-restricted') {
	        return;
	      }
	
	      var masterPlaylist = _this5.masterPlaylistController_.master();
	
	      if (!masterPlaylist || !masterPlaylist.playlists) {
	        return;
	      }
	
	      var excludedHDPlaylists = []; // Assume all HD streams are unplayable and exclude them from ABR selection
	
	      masterPlaylist.playlists.forEach(function (playlist) {
	        if (playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height >= 720) {
	          if (!playlist.excludeUntil || playlist.excludeUntil < Infinity) {
	            playlist.excludeUntil = Infinity;
	            excludedHDPlaylists.push(playlist);
	          }
	        }
	      });
	
	      if (excludedHDPlaylists.length) {
	        var _videojs$log;
	
	        (_videojs$log = videojs.log).warn.apply(_videojs$log, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists ' + 'that will most likely fail to play and clearing the buffer. ' + 'This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists)); // Clear the buffer before switching playlists, since it may already contain unplayable segments
	
	
	        _this5.masterPlaylistController_.fastQualityChange_();
	      }
	    });
	    this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
	    this.player_.tech_.on('waitingforkey', this.handleWaitingForKey_); // In IE11 this is too early to initialize media keys, and IE11 does not support
	    // promises.
	
	    if (videojs.browser.IE_VERSION === 11 || !didSetupEmeOptions) {
	      // If EME options were not set up, we've done all we could to initialize EME.
	      this.masterPlaylistController_.sourceUpdater_.initializedEme();
	      return;
	    }
	
	    this.createKeySessions_();
	  }
	  /**
	   * Initializes the quality levels and sets listeners to update them.
	   *
	   * @method setupQualityLevels_
	   * @private
	   */
	  ;
	
	  _proto.setupQualityLevels_ = function setupQualityLevels_() {
	    var _this6 = this;
	
	    var player = videojs.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
	    // or qualityLevels_ listeners have already been setup, do nothing.
	
	    if (!player || !player.qualityLevels || this.qualityLevels_) {
	      return;
	    }
	
	    this.qualityLevels_ = player.qualityLevels();
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      handleVhsLoadedMetadata(_this6.qualityLevels_, _this6);
	    });
	    this.playlists.on('mediachange', function () {
	      handleVhsMediaChange(_this6.qualityLevels_, _this6.playlists);
	    });
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  VhsHandler.version = function version$5() {
	    return {
	      '@videojs/http-streaming': version$4,
	      'mux.js': version$3,
	      'mpd-parser': version$2,
	      'm3u8-parser': version$1,
	      'aes-decrypter': version
	    };
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  _proto.version = function version() {
	    return this.constructor.version();
	  };
	
	  _proto.canChangeType = function canChangeType() {
	    return SourceUpdater.canChangeType();
	  }
	  /**
	   * Begin playing the video.
	   */
	  ;
	
	  _proto.play = function play() {
	    this.masterPlaylistController_.play();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    this.masterPlaylistController_.setCurrentTime(currentTime);
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.duration = function duration() {
	    return this.masterPlaylistController_.duration();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.masterPlaylistController_.seekable();
	  }
	  /**
	   * Abort all outstanding work and cleanup.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.playbackWatcher_) {
	      this.playbackWatcher_.dispose();
	    }
	
	    if (this.masterPlaylistController_) {
	      this.masterPlaylistController_.dispose();
	    }
	
	    if (this.qualityLevels_) {
	      this.qualityLevels_.dispose();
	    }
	
	    if (this.player_) {
	      delete this.player_.vhs;
	      delete this.player_.dash;
	      delete this.player_.hls;
	    }
	
	    if (this.tech_ && this.tech_.vhs) {
	      delete this.tech_.vhs;
	    } // don't check this.tech_.hls as it will log a deprecated warning
	
	
	    if (this.tech_) {
	      delete this.tech_.hls;
	    }
	
	    if (this.mediaSourceUrl_ && window__default['default'].URL.revokeObjectURL) {
	      window__default['default'].URL.revokeObjectURL(this.mediaSourceUrl_);
	      this.mediaSourceUrl_ = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.off('waitingforkey', this.handleWaitingForKey_);
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  _proto.convertToProgramTime = function convertToProgramTime(time, callback) {
	    return getProgramTime({
	      playlist: this.masterPlaylistController_.media(),
	      time: time,
	      callback: callback
	    });
	  } // the player must be playing before calling this
	  ;
	
	  _proto.seekToProgramTime = function seekToProgramTime$1(programTime, callback, pauseAfterSeek, retryCount) {
	    if (pauseAfterSeek === void 0) {
	      pauseAfterSeek = true;
	    }
	
	    if (retryCount === void 0) {
	      retryCount = 2;
	    }
	
	    return seekToProgramTime({
	      programTime: programTime,
	      playlist: this.masterPlaylistController_.media(),
	      retryCount: retryCount,
	      pauseAfterSeek: pauseAfterSeek,
	      seekTo: this.options_.seekTo,
	      tech: this.options_.tech,
	      callback: callback
	    });
	  };
	
	  return VhsHandler;
	}(Component);
	/**
	 * The Source Handler object, which informs video.js what additional
	 * MIME types are supported and sets up playback. It is registered
	 * automatically to the appropriate tech based on the capabilities of
	 * the browser it is running in. It is not necessary to use or modify
	 * this object in normal usage.
	 */
	
	
	var VhsSourceHandler = {
	  name: 'videojs-http-streaming',
	  VERSION: version$4,
	  canHandleSource: function canHandleSource(srcObj, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    return VhsSourceHandler.canPlayType(srcObj.type, localOptions);
	  },
	  handleSource: function handleSource(source, tech, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    tech.vhs = new VhsHandler(source, tech, localOptions);
	
	    if (!videojs.hasOwnProperty('hls')) {
	      Object.defineProperty(tech, 'hls', {
	        get: function get() {
	          videojs.log.warn('player.tech().hls is deprecated. Use player.tech().vhs instead.');
	          return tech.vhs;
	        },
	        configurable: true
	      });
	    }
	
	    tech.vhs.xhr = xhrFactory();
	    tech.vhs.src(source.src, source.type);
	    return tech.vhs;
	  },
	  canPlayType: function canPlayType(type, options) {
	    var simpleType = mediaTypes_js.simpleTypeFromSourceType(type);
	
	    if (!simpleType) {
	      return '';
	    }
	
	    var overrideNative = VhsSourceHandler.getOverrideNative(options);
	    var supportsTypeNatively = Vhs.supportsTypeNatively(simpleType);
	    var canUseMsePlayback = !supportsTypeNatively || overrideNative;
	    return canUseMsePlayback ? 'maybe' : '';
	  },
	  getOverrideNative: function getOverrideNative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$vhs = _options.vhs,
	        vhs = _options$vhs === void 0 ? {} : _options$vhs,
	        _options$hls = _options.hls,
	        hls = _options$hls === void 0 ? {} : _options$hls;
	    var defaultOverrideNative = !(videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS);
	    var _vhs$overrideNative = vhs.overrideNative,
	        overrideNative = _vhs$overrideNative === void 0 ? defaultOverrideNative : _vhs$overrideNative;
	    var _hls$overrideNative = hls.overrideNative,
	        legacyOverrideNative = _hls$overrideNative === void 0 ? false : _hls$overrideNative;
	    return legacyOverrideNative || overrideNative;
	  }
	};
	/**
	 * Check to see if the native MediaSource object exists and supports
	 * an MP4 container with both H.264 video and AAC-LC audio.
	 *
	 * @return {boolean} if  native media sources are supported
	 */
	
	var supportsNativeMediaSources = function supportsNativeMediaSources() {
	  return codecs_js.browserSupportsCodec('avc1.4d400d,mp4a.40.2');
	}; // register source handlers with the appropriate techs
	
	
	if (supportsNativeMediaSources()) {
	  videojs.getTech('Html5').registerSourceHandler(VhsSourceHandler, 0);
	}
	
	videojs.VhsHandler = VhsHandler;
	Object.defineProperty(videojs, 'HlsHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.');
	    return VhsHandler;
	  },
	  configurable: true
	});
	videojs.VhsSourceHandler = VhsSourceHandler;
	Object.defineProperty(videojs, 'HlsSourceHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsSourceHandler is deprecated. ' + 'Use videojs.VhsSourceHandler instead.');
	    return VhsSourceHandler;
	  },
	  configurable: true
	});
	videojs.Vhs = Vhs;
	Object.defineProperty(videojs, 'Hls', {
	  get: function get() {
	    videojs.log.warn('videojs.Hls is deprecated. Use videojs.Vhs instead.');
	    return Vhs;
	  },
	  configurable: true
	});
	
	if (!videojs.use) {
	  videojs.registerComponent('Hls', Vhs);
	  videojs.registerComponent('Vhs', Vhs);
	}
	
	videojs.options.vhs = videojs.options.vhs || {};
	videojs.options.hls = videojs.options.hls || {};
	
	if (!videojs.getPlugin || !videojs.getPlugin('reloadSourceOnError')) {
	  var registerPlugin = videojs.registerPlugin || videojs.plugin;
	  registerPlugin('reloadSourceOnError', reloadSourceOnError);
	}
	
	module.exports = videojs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	// Default exports for Node. Export the extended versions of VTTCue and
	// VTTRegion in Node since we likely want the capability to convert back and
	// forth between JSON. If we don't then it's not that big of a deal since we're
	// off browser.
	
	var window = __webpack_require__(2);
	
	var vttjs = module.exports = {
	  WebVTT: __webpack_require__(419),
	  VTTCue: __webpack_require__(420),
	  VTTRegion: __webpack_require__(421)
	};
	
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	
	vttjs.shim = function() {
	  window.VTTCue = cueShim;
	  window.VTTRegion = regionShim;
	};
	
	vttjs.restore = function() {
	  window.VTTCue = nativeVTTCue;
	  window.VTTRegion = nativeVTTRegion;
	};
	
	if (!window.VTTCue) {
	  vttjs.shim();
	}


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
	/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
	var document = __webpack_require__(30);
	
	var _objCreate = Object.create || (function() {
	  function F() {}
	  return function(o) {
	    if (arguments.length !== 1) {
	      throw new Error('Object.create shim only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  };
	})();
	
	// Creates a new ParserError object from an errorData object. The errorData
	// object should have default code and message properties. The default message
	// property can be overriden by passing in a message parameter.
	// See ParsingError.Errors below for acceptable errors.
	function ParsingError(errorData, message) {
	  this.name = "ParsingError";
	  this.code = errorData.code;
	  this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	
	// ParsingError metadata for acceptable ParsingErrors.
	ParsingError.Errors = {
	  BadSignature: {
	    code: 0,
	    message: "Malformed WebVTT signature."
	  },
	  BadTimeStamp: {
	    code: 1,
	    message: "Malformed time stamp."
	  }
	};
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0,  m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = _objCreate(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function(k, v) {
	    if (!this.get(k) && v !== "") {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function(k, v) {
	    if (/^-?\d+$/.test(v)) { // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function(k, v) {
	    var m;
	    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== "string") {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0].trim();
	    var v = kv[1].trim();
	    callback(k, v);
	  }
	}
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                            "Malformed timestamp: " + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, "");
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	      case "region":
	        // Find the last region we parsed with the same region id.
	        for (var i = regionList.length - 1; i >= 0; i--) {
	          if (regionList[i].id === v) {
	            settings.set(k, regionList[i].region);
	            break;
	          }
	        }
	        break;
	      case "vertical":
	        settings.alt(k, v, ["rl", "lr"]);
	        break;
	      case "line":
	        var vals = v.split(","),
	            vals0 = vals[0];
	        settings.integer(k, vals0);
	        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
	        settings.alt(k, vals0, ["auto"]);
	        if (vals.length === 2) {
	          settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "position":
	        vals = v.split(",");
	        settings.percent(k, vals[0]);
	        if (vals.length === 2) {
	          settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "size":
	        settings.percent(k, v);
	        break;
	      case "align":
	        settings.alt(k, v, ["start", "center", "end", "left", "right"]);
	        break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get("region", null);
	    cue.vertical = settings.get("vertical", "");
	    try {
	      cue.line = settings.get("line", "auto");
	    } catch (e) {}
	    cue.lineAlign = settings.get("lineAlign", "start");
	    cue.snapToLines = settings.get("snapToLines", true);
	    cue.size = settings.get("size", 100);
	    // Safari still uses the old middle value and won't accept center
	    try {
	      cue.align = settings.get("align", "center");
	    } catch (e) {
	      cue.align = settings.get("align", "middle");
	    }
	    try {
	      cue.position = settings.get("position", "auto");
	    } catch (e) {
	      cue.position = settings.get("position", {
	        start: 0,
	        left: 0,
	        center: 50,
	        middle: 50,
	        end: 100,
	        right: 100
	      }, cue.align);
	    }
	
	
	    cue.positionAlign = settings.get("positionAlign", {
	      start: "start",
	      left: "start",
	      center: "center",
	      middle: "center",
	      end: "end",
	      right: "end"
	    }, cue.align);
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, "");
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
	    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                           "Malformed time stamp (time stamps must be separated by '-->'): " +
	                           oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp();     // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	// When evaluating this file as part of a Webpack bundle for server
	// side rendering, `document` is an empty object.
	var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
	
	var TAG_NAME = {
	  c: "span",
	  i: "i",
	  b: "b",
	  u: "u",
	  ruby: "ruby",
	  rt: "rt",
	  v: "span",
	  lang: "span"
	};
	
	// 5.1 default text color
	// 5.2 default text background color is equivalent to text color with bg_ prefix
	var DEFAULT_COLOR_CLASS = {
	  white: 'rgba(255,255,255,1)',
	  lime: 'rgba(0,255,0,1)',
	  cyan: 'rgba(0,255,255,1)',
	  red: 'rgba(255,0,0,1)',
	  yellow: 'rgba(255,255,0,1)',
	  magenta: 'rgba(255,0,255,1)',
	  blue: 'rgba(0,0,255,1)',
	  black: 'rgba(0,0,0,1)'
	};
	
	var TAG_ANNOTATION = {
	  v: "title",
	  lang: "lang"
	};
	
	var NEEDS_PARENT = {
	  rt: "ruby"
	};
	
	// Parse content into a document fragment.
	function parseContent(window, input) {
	  function nextToken() {
	    // Check for end-of-string.
	    if (!input) {
	      return null;
	    }
	
	    // Consume 'n' characters from the input.
	    function consume(result) {
	      input = input.substr(result.length);
	      return result;
	    }
	
	    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
	    // If there is some text before the next tag, return it, otherwise return
	    // the tag.
	    return consume(m[1] ? m[1] : m[2]);
	  }
	
	  function unescape(s) {
	    TEXTAREA_ELEMENT.innerHTML = s;
	    s = TEXTAREA_ELEMENT.textContent;
	    TEXTAREA_ELEMENT.textContent = "";
	    return s;
	  }
	
	  function shouldAdd(current, element) {
	    return !NEEDS_PARENT[element.localName] ||
	           NEEDS_PARENT[element.localName] === current.localName;
	  }
	
	  // Create an element for this tag.
	  function createElement(type, annotation) {
	    var tagName = TAG_NAME[type];
	    if (!tagName) {
	      return null;
	    }
	    var element = window.document.createElement(tagName);
	    var name = TAG_ANNOTATION[type];
	    if (name && annotation) {
	      element[name] = annotation.trim();
	    }
	    return element;
	  }
	
	  var rootDiv = window.document.createElement("div"),
	      current = rootDiv,
	      t,
	      tagStack = [];
	
	  while ((t = nextToken()) !== null) {
	    if (t[0] === '<') {
	      if (t[1] === "/") {
	        // If the closing tag matches, move back up to the parent node.
	        if (tagStack.length &&
	            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
	          tagStack.pop();
	          current = current.parentNode;
	        }
	        // Otherwise just ignore the end tag.
	        continue;
	      }
	      var ts = parseTimeStamp(t.substr(1, t.length - 2));
	      var node;
	      if (ts) {
	        // Timestamps are lead nodes as well.
	        node = window.document.createProcessingInstruction("timestamp", ts);
	        current.appendChild(node);
	        continue;
	      }
	      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
	      // If we can't parse the tag, skip to the next tag.
	      if (!m) {
	        continue;
	      }
	      // Try to construct an element, and ignore the tag if we couldn't.
	      node = createElement(m[1], m[3]);
	      if (!node) {
	        continue;
	      }
	      // Determine if the tag should be added based on the context of where it
	      // is placed in the cuetext.
	      if (!shouldAdd(current, node)) {
	        continue;
	      }
	      // Set the class list (as a list of classes, separated by space).
	      if (m[2]) {
	        var classes = m[2].split('.');
	
	        classes.forEach(function(cl) {
	          var bgColor = /^bg_/.test(cl);
	          // slice out `bg_` if it's a background color
	          var colorName = bgColor ? cl.slice(3) : cl;
	
	          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
	            var propName = bgColor ? 'background-color' : 'color';
	            var propValue = DEFAULT_COLOR_CLASS[colorName];
	
	            node.style[propName] = propValue;
	          }
	        });
	
	        node.className = classes.join(' ');
	      }
	      // Append the node to the current node, and enter the scope of the new
	      // node.
	      tagStack.push(m[1]);
	      current.appendChild(node);
	      current = node;
	      continue;
	    }
	
	    // Text nodes are leaf nodes.
	    current.appendChild(window.document.createTextNode(unescape(t)));
	  }
	
	  return rootDiv;
	}
	
	// This is a list of all the Unicode characters that have a strong
	// right-to-left category. What this means is that these characters are
	// written right-to-left for sure. It was generated by pulling all the strong
	// right-to-left characters out of the Unicode data table. That table can
	// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
	var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
	 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
	 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
	 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
	 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
	 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
	 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
	 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
	 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
	 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
	 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
	 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
	 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
	 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
	 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
	 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
	 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
	 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
	 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
	 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
	 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
	 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
	 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
	 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
	 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
	
	function isStrongRTLChar(charCode) {
	  for (var i = 0; i < strongRTLRanges.length; i++) {
	    var currentRange = strongRTLRanges[i];
	    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function determineBidi(cueDiv) {
	  var nodeStack = [],
	      text = "",
	      charCode;
	
	  if (!cueDiv || !cueDiv.childNodes) {
	    return "ltr";
	  }
	
	  function pushNodes(nodeStack, node) {
	    for (var i = node.childNodes.length - 1; i >= 0; i--) {
	      nodeStack.push(node.childNodes[i]);
	    }
	  }
	
	  function nextTextNode(nodeStack) {
	    if (!nodeStack || !nodeStack.length) {
	      return null;
	    }
	
	    var node = nodeStack.pop(),
	        text = node.textContent || node.innerText;
	    if (text) {
	      // TODO: This should match all unicode type B characters (paragraph
	      // separator characters). See issue #115.
	      var m = text.match(/^.*(\n|\r)/);
	      if (m) {
	        nodeStack.length = 0;
	        return m[0];
	      }
	      return text;
	    }
	    if (node.tagName === "ruby") {
	      return nextTextNode(nodeStack);
	    }
	    if (node.childNodes) {
	      pushNodes(nodeStack, node);
	      return nextTextNode(nodeStack);
	    }
	  }
	
	  pushNodes(nodeStack, cueDiv);
	  while ((text = nextTextNode(nodeStack))) {
	    for (var i = 0; i < text.length; i++) {
	      charCode = text.charCodeAt(i);
	      if (isStrongRTLChar(charCode)) {
	        return "rtl";
	      }
	    }
	  }
	  return "ltr";
	}
	
	function computeLinePos(cue) {
	  if (typeof cue.line === "number" &&
	      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
	    return cue.line;
	  }
	  if (!cue.track || !cue.track.textTrackList ||
	      !cue.track.textTrackList.mediaElement) {
	    return -1;
	  }
	  var track = cue.track,
	      trackList = track.textTrackList,
	      count = 0;
	  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
	    if (trackList[i].mode === "showing") {
	      count++;
	    }
	  }
	  return ++count * -1;
	}
	
	function StyleBox() {
	}
	
	// Apply styles to a div. If there is no div passed then it defaults to the
	// div on 'this'.
	StyleBox.prototype.applyStyles = function(styles, div) {
	  div = div || this.div;
	  for (var prop in styles) {
	    if (styles.hasOwnProperty(prop)) {
	      div.style[prop] = styles[prop];
	    }
	  }
	};
	
	StyleBox.prototype.formatStyle = function(val, unit) {
	  return val === 0 ? 0 : val + unit;
	};
	
	// Constructs the computed display state of the cue (a div). Places the div
	// into the overlay which should be a block level element (usually a div).
	function CueStyleBox(window, cue, styleOptions) {
	  StyleBox.call(this);
	  this.cue = cue;
	
	  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
	  // have inline positioning and will function as the cue background box.
	  this.cueDiv = parseContent(window, cue.text);
	  var styles = {
	    color: "rgba(255, 255, 255, 1)",
	    backgroundColor:  "rgba(0, 0, 0, 0.8)",
	    position: "relative",
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    display: "inline",
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext"
	  };
	
	  this.applyStyles(styles, this.cueDiv);
	
	  // Create an absolutely positioned div that will be used to position the cue
	  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
	  // mirrors of them except middle instead of center on Safari.
	  this.div = window.document.createElement("div");
	  styles = {
	    direction: determineBidi(this.cueDiv),
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext",
	    textAlign: cue.align === "middle" ? "center" : cue.align,
	    font: styleOptions.font,
	    whiteSpace: "pre-line",
	    position: "absolute"
	  };
	
	  this.applyStyles(styles);
	  this.div.appendChild(this.cueDiv);
	
	  // Calculate the distance from the reference edge of the viewport to the text
	  // position of the cue box. The reference edge will be resolved later when
	  // the box orientation styles are applied.
	  var textPos = 0;
	  switch (cue.positionAlign) {
	  case "start":
	  case "line-left":
	    textPos = cue.position;
	    break;
	  case "center":
	    textPos = cue.position - (cue.size / 2);
	    break;
	  case "end":
	  case "line-right":
	    textPos = cue.position - cue.size;
	    break;
	  }
	
	  // Horizontal box orientation; textPos is the distance from the left edge of the
	  // area to the left edge of the box and cue.size is the distance extending to
	  // the right from there.
	  if (cue.vertical === "") {
	    this.applyStyles({
	      left:  this.formatStyle(textPos, "%"),
	      width: this.formatStyle(cue.size, "%")
	    });
	  // Vertical box orientation; textPos is the distance from the top edge of the
	  // area to the top edge of the box and cue.size is the height extending
	  // downwards from there.
	  } else {
	    this.applyStyles({
	      top: this.formatStyle(textPos, "%"),
	      height: this.formatStyle(cue.size, "%")
	    });
	  }
	
	  this.move = function(box) {
	    this.applyStyles({
	      top: this.formatStyle(box.top, "px"),
	      bottom: this.formatStyle(box.bottom, "px"),
	      left: this.formatStyle(box.left, "px"),
	      right: this.formatStyle(box.right, "px"),
	      height: this.formatStyle(box.height, "px"),
	      width: this.formatStyle(box.width, "px")
	    });
	  };
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	
	// Represents the co-ordinates of an Element in a way that we can easily
	// compute things with such as if it overlaps or intersects with another Element.
	// Can initialize it with either a StyleBox or another BoxPosition.
	function BoxPosition(obj) {
	  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
	  // was passed in and we need to copy the results of 'getBoundingClientRect'
	  // as the object returned is readonly. All co-ordinate values are in reference
	  // to the viewport origin (top left).
	  var lh, height, width, top;
	  if (obj.div) {
	    height = obj.div.offsetHeight;
	    width = obj.div.offsetWidth;
	    top = obj.div.offsetTop;
	
	    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
	                rects.getClientRects && rects.getClientRects();
	    obj = obj.div.getBoundingClientRect();
	    // In certain cases the outter div will be slightly larger then the sum of
	    // the inner div's lines. This could be due to bold text, etc, on some platforms.
	    // In this case we should get the average line height and use that. This will
	    // result in the desired behaviour.
	    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
	               : 0;
	
	  }
	  this.left = obj.left;
	  this.right = obj.right;
	  this.top = obj.top || top;
	  this.height = obj.height || height;
	  this.bottom = obj.bottom || (top + (obj.height || height));
	  this.width = obj.width || width;
	  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
	}
	
	// Move the box along a particular axis. Optionally pass in an amount to move
	// the box. If no amount is passed then the default is the line height of the
	// box.
	BoxPosition.prototype.move = function(axis, toMove) {
	  toMove = toMove !== undefined ? toMove : this.lineHeight;
	  switch (axis) {
	  case "+x":
	    this.left += toMove;
	    this.right += toMove;
	    break;
	  case "-x":
	    this.left -= toMove;
	    this.right -= toMove;
	    break;
	  case "+y":
	    this.top += toMove;
	    this.bottom += toMove;
	    break;
	  case "-y":
	    this.top -= toMove;
	    this.bottom -= toMove;
	    break;
	  }
	};
	
	// Check if this box overlaps another box, b2.
	BoxPosition.prototype.overlaps = function(b2) {
	  return this.left < b2.right &&
	         this.right > b2.left &&
	         this.top < b2.bottom &&
	         this.bottom > b2.top;
	};
	
	// Check if this box overlaps any other boxes in boxes.
	BoxPosition.prototype.overlapsAny = function(boxes) {
	  for (var i = 0; i < boxes.length; i++) {
	    if (this.overlaps(boxes[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Check if this box is within another box.
	BoxPosition.prototype.within = function(container) {
	  return this.top >= container.top &&
	         this.bottom <= container.bottom &&
	         this.left >= container.left &&
	         this.right <= container.right;
	};
	
	// Check if this box is entirely within the container or it is overlapping
	// on the edge opposite of the axis direction passed. For example, if "+x" is
	// passed and the box is overlapping on the left edge of the container, then
	// return true.
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
	  switch (axis) {
	  case "+x":
	    return this.left < container.left;
	  case "-x":
	    return this.right > container.right;
	  case "+y":
	    return this.top < container.top;
	  case "-y":
	    return this.bottom > container.bottom;
	  }
	};
	
	// Find the percentage of the area that this box is overlapping with another
	// box.
	BoxPosition.prototype.intersectPercentage = function(b2) {
	  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
	      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
	      intersectArea = x * y;
	  return intersectArea / (this.height * this.width);
	};
	
	// Convert the positions from this box to CSS compatible positions using
	// the reference container's positions. This has to be done because this
	// box's positions are in reference to the viewport origin, whereas, CSS
	// values are in referecne to their respective edges.
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
	  return {
	    top: this.top - reference.top,
	    bottom: reference.bottom - this.bottom,
	    left: this.left - reference.left,
	    right: reference.right - this.right,
	    height: this.height,
	    width: this.width
	  };
	};
	
	// Get an object that represents the box's position without anything extra.
	// Can pass a StyleBox, HTMLElement, or another BoxPositon.
	BoxPosition.getSimpleBoxPosition = function(obj) {
	  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
	  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
	  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
	
	  obj = obj.div ? obj.div.getBoundingClientRect() :
	                obj.tagName ? obj.getBoundingClientRect() : obj;
	  var ret = {
	    left: obj.left,
	    right: obj.right,
	    top: obj.top || top,
	    height: obj.height || height,
	    bottom: obj.bottom || (top + (obj.height || height)),
	    width: obj.width || width
	  };
	  return ret;
	};
	
	// Move a StyleBox to its specified, or next best, position. The containerBox
	// is the box that contains the StyleBox, such as a div. boxPositions are
	// a list of other boxes that the styleBox can't overlap with.
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
	
	  // Find the best position for a cue box, b, on the video. The axis parameter
	  // is a list of axis, the order of which, it will move the box along. For example:
	  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
	  // direction. If it doesn't find a good position for it there it will then move
	  // it along the x axis in the negative direction.
	  function findBestPosition(b, axis) {
	    var bestPosition,
	        specifiedPosition = new BoxPosition(b),
	        percentage = 1; // Highest possible so the first thing we get is better.
	
	    for (var i = 0; i < axis.length; i++) {
	      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
	             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
	        b.move(axis[i]);
	      }
	      // We found a spot where we aren't overlapping anything. This is our
	      // best position.
	      if (b.within(containerBox)) {
	        return b;
	      }
	      var p = b.intersectPercentage(containerBox);
	      // If we're outside the container box less then we were on our last try
	      // then remember this position as the best position.
	      if (percentage > p) {
	        bestPosition = new BoxPosition(b);
	        percentage = p;
	      }
	      // Reset the box position to the specified position.
	      b = new BoxPosition(specifiedPosition);
	    }
	    return bestPosition || specifiedPosition;
	  }
	
	  var boxPosition = new BoxPosition(styleBox),
	      cue = styleBox.cue,
	      linePos = computeLinePos(cue),
	      axis = [];
	
	  // If we have a line number to align the cue to.
	  if (cue.snapToLines) {
	    var size;
	    switch (cue.vertical) {
	    case "":
	      axis = [ "+y", "-y" ];
	      size = "height";
	      break;
	    case "rl":
	      axis = [ "+x", "-x" ];
	      size = "width";
	      break;
	    case "lr":
	      axis = [ "-x", "+x" ];
	      size = "width";
	      break;
	    }
	
	    var step = boxPosition.lineHeight,
	        position = step * Math.round(linePos),
	        maxPosition = containerBox[size] + step,
	        initialAxis = axis[0];
	
	    // If the specified intial position is greater then the max position then
	    // clamp the box to the amount of steps it would take for the box to
	    // reach the max position.
	    if (Math.abs(position) > maxPosition) {
	      position = position < 0 ? -1 : 1;
	      position *= Math.ceil(maxPosition / step) * step;
	    }
	
	    // If computed line position returns negative then line numbers are
	    // relative to the bottom of the video instead of the top. Therefore, we
	    // need to increase our initial position by the length or width of the
	    // video, depending on the writing direction, and reverse our axis directions.
	    if (linePos < 0) {
	      position += cue.vertical === "" ? containerBox.height : containerBox.width;
	      axis = axis.reverse();
	    }
	
	    // Move the box to the specified position. This may not be its best
	    // position.
	    boxPosition.move(initialAxis, position);
	
	  } else {
	    // If we have a percentage line value for the cue.
	    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;
	
	    switch (cue.lineAlign) {
	    case "center":
	      linePos -= (calculatedPercentage / 2);
	      break;
	    case "end":
	      linePos -= calculatedPercentage;
	      break;
	    }
	
	    // Apply initial line position to the cue box.
	    switch (cue.vertical) {
	    case "":
	      styleBox.applyStyles({
	        top: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "rl":
	      styleBox.applyStyles({
	        left: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "lr":
	      styleBox.applyStyles({
	        right: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    }
	
	    axis = [ "+y", "-x", "+x", "-y" ];
	
	    // Get the box position again after we've applied the specified positioning
	    // to it.
	    boxPosition = new BoxPosition(styleBox);
	  }
	
	  var bestPosition = findBestPosition(boxPosition, axis);
	  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	
	function WebVTT() {
	  // Nothing
	}
	
	// Helper to allow strings to be decoded instead of the default binary utf8 data.
	WebVTT.StringDecoder = function() {
	  return {
	    decode: function(data) {
	      if (!data) {
	        return "";
	      }
	      if (typeof data !== "string") {
	        throw new Error("Error - expected string data.");
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
	  if (!window || !cuetext) {
	    return null;
	  }
	  return parseContent(window, cuetext);
	};
	
	var FONT_SIZE_PERCENT = 0.05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	
	// Runs the processing model over the cues and regions passed to it.
	// @param overlay A block level element (usually a div) that the computed cues
	//                and regions will be placed into.
	WebVTT.processCues = function(window, cues, overlay) {
	  if (!window || !cues || !overlay) {
	    return null;
	  }
	
	  // Remove all previous children.
	  while (overlay.firstChild) {
	    overlay.removeChild(overlay.firstChild);
	  }
	
	  var paddedOverlay = window.document.createElement("div");
	  paddedOverlay.style.position = "absolute";
	  paddedOverlay.style.left = "0";
	  paddedOverlay.style.right = "0";
	  paddedOverlay.style.top = "0";
	  paddedOverlay.style.bottom = "0";
	  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
	  overlay.appendChild(paddedOverlay);
	
	  // Determine if we need to compute the display states of the cues. This could
	  // be the case if a cue's state has been changed since the last computation or
	  // if it has not been computed yet.
	  function shouldCompute(cues) {
	    for (var i = 0; i < cues.length; i++) {
	      if (cues[i].hasBeenReset || !cues[i].displayState) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // We don't need to recompute the cues' display states. Just reuse them.
	  if (!shouldCompute(cues)) {
	    for (var i = 0; i < cues.length; i++) {
	      paddedOverlay.appendChild(cues[i].displayState);
	    }
	    return;
	  }
	
	  var boxPositions = [],
	      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
	      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
	  var styleOptions = {
	    font: fontSize + "px " + FONT_STYLE
	  };
	
	  (function() {
	    var styleBox, cue;
	
	    for (var i = 0; i < cues.length; i++) {
	      cue = cues[i];
	
	      // Compute the intial position and styles of the cue div.
	      styleBox = new CueStyleBox(window, cue, styleOptions);
	      paddedOverlay.appendChild(styleBox.div);
	
	      // Move the cue div to it's correct line position.
	      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
	
	      // Remember the computed div so that we don't have to recompute it later
	      // if we don't have too.
	      cue.displayState = styleBox.div;
	
	      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
	    }
	  })();
	};
	
	WebVTT.Parser = function(window, vttjs, decoder) {
	  if (!decoder) {
	    decoder = vttjs;
	    vttjs = {};
	  }
	  if (!vttjs) {
	    vttjs = {};
	  }
	
	  this.window = window;
	  this.vttjs = vttjs;
	  this.state = "INITIAL";
	  this.buffer = "";
	  this.decoder = decoder || new TextDecoder("utf8");
	  this.regionList = [];
	};
	
	WebVTT.Parser.prototype = {
	  // If the error is a ParsingError then report it to the consumer if
	  // possible. If it's not a ParsingError then throw it like normal.
	  reportOrThrowError: function(e) {
	    if (e instanceof ParsingError) {
	      this.onparsingerror && this.onparsingerror(e);
	    } else {
	      throw e;
	    }
	  },
	  parse: function (data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, {stream: true});
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.4 WebVTT region and WebVTT region settings syntax
	    function parseRegion(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function (k, v) {
	        switch (k) {
	        case "id":
	          settings.set(k, v);
	          break;
	        case "width":
	          settings.percent(k, v);
	          break;
	        case "lines":
	          settings.integer(k, v);
	          break;
	        case "regionanchor":
	        case "viewportanchor":
	          var xy = v.split(',');
	          if (xy.length !== 2) {
	            break;
	          }
	          // We have to make sure both x and y parse, so use a temporary
	          // settings object here.
	          var anchor = new Settings();
	          anchor.percent("x", xy[0]);
	          anchor.percent("y", xy[1]);
	          if (!anchor.has("x") || !anchor.has("y")) {
	            break;
	          }
	          settings.set(k + "X", anchor.get("x"));
	          settings.set(k + "Y", anchor.get("y"));
	          break;
	        case "scroll":
	          settings.alt(k, v, ["up"]);
	          break;
	        }
	      }, /=/, /\s/);
	
	      // Create the region, using default values for any values that were not
	      // specified.
	      if (settings.has("id")) {
	        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
	        region.width = settings.get("width", 100);
	        region.lines = settings.get("lines", 3);
	        region.regionAnchorX = settings.get("regionanchorX", 0);
	        region.regionAnchorY = settings.get("regionanchorY", 100);
	        region.viewportAnchorX = settings.get("viewportanchorX", 0);
	        region.viewportAnchorY = settings.get("viewportanchorY", 100);
	        region.scroll = settings.get("scroll", "");
	        // Register the region.
	        self.onregion && self.onregion(region);
	        // Remember the VTTRegion for later in case we parse any VTTCues that
	        // reference it.
	        self.regionList.push({
	          id: settings.get("id"),
	          region: region
	        });
	      }
	    }
	
	    // draft-pantos-http-live-streaming-20
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
	    // 3.5 WebVTT
	    function parseTimestampMap(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function(k, v) {
	        switch(k) {
	        case "MPEGT":
	          settings.integer(k + 'S', v);
	          break;
	        case "LOCA":
	          settings.set(k + 'L', parseTimeStamp(v));
	          break;
	        }
	      }, /[^\d]:/, /,/);
	
	      self.ontimestampmap && self.ontimestampmap({
	        "MPEGTS": settings.get("MPEGTS"),
	        "LOCAL": settings.get("LOCAL")
	      });
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      if (input.match(/X-TIMESTAMP-MAP/)) {
	        // This line contains HLS X-TIMESTAMP-MAP metadata
	        parseOptions(input, function(k, v) {
	          switch(k) {
	          case "X-TIMESTAMP-MAP":
	            parseTimestampMap(v);
	            break;
	          }
	        }, /=/);
	      } else {
	        parseOptions(input, function (k, v) {
	          switch (k) {
	          case "Region":
	            // 3.3 WebVTT region metadata header syntax
	            parseRegion(v);
	            break;
	          }
	        }, /:/);
	      }
	
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === "INITIAL") {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	
	        var m = line.match(/^WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new ParsingError(ParsingError.Errors.BadSignature);
	        }
	
	        self.state = "HEADER";
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	        case "HEADER":
	          // 13-18 - Allow a header (metadata) under the WEBVTT line.
	          if (/:/.test(line)) {
	            parseHeader(line);
	          } else if (!line) {
	            // An empty line terminates the header and starts the body (cues).
	            self.state = "ID";
	          }
	          continue;
	        case "NOTE":
	          // Ignore NOTE blocks.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        case "ID":
	          // Check for the start of NOTE blocks.
	          if (/^NOTE($|[ \t])/.test(line)) {
	            self.state = "NOTE";
	            break;
	          }
	          // 19-29 - Allow any number of line terminators, then initialize new cue values.
	          if (!line) {
	            continue;
	          }
	          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
	          // Safari still uses the old middle value and won't accept center
	          try {
	            self.cue.align = "center";
	          } catch (e) {
	            self.cue.align = "middle";
	          }
	          self.state = "CUE";
	          // 30-39 - Check if self line contains an optional identifier or timing data.
	          if (line.indexOf("-->") === -1) {
	            self.cue.id = line;
	            continue;
	          }
	          // Process line as start of a cue.
	          /*falls through*/
	        case "CUE":
	          // 40 - Collect cue timings and settings.
	          try {
	            parseCue(line, self.cue, self.regionList);
	          } catch (e) {
	            self.reportOrThrowError(e);
	            // In case of an error ignore rest of the cue.
	            self.cue = null;
	            self.state = "BADCUE";
	            continue;
	          }
	          self.state = "CUETEXT";
	          continue;
	        case "CUETEXT":
	          var hasSubstring = line.indexOf("-->") !== -1;
	          // 34 - If we have an empty line then report the cue.
	          // 35 - If we have the special substring '-->' then report the cue,
	          // but do not collect the line as we need to process the current
	          // one as a new cue.
	          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	            // We are done parsing self cue.
	            self.oncue && self.oncue(self.cue);
	            self.cue = null;
	            self.state = "ID";
	            continue;
	          }
	          if (self.cue.text) {
	            self.cue.text += "\n";
	          }
	          self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
	          continue;
	        case "BADCUE": // BADCUE
	          // 54-62 - Collect and discard the remaining cue.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        }
	      }
	    } catch (e) {
	      self.reportOrThrowError(e);
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === "CUETEXT" && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
	    }
	    return this;
	  },
	  flush: function () {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === "HEADER") {
	        self.buffer += "\n\n";
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === "INITIAL") {
	        throw new ParsingError(ParsingError.Errors.BadSignature);
	      }
	    } catch(e) {
	      self.reportOrThrowError(e);
	    }
	    self.onflush && self.onflush();
	    return this;
	  }
	};
	
	module.exports = WebVTT;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var autoKeyword = "auto";
	var directionSetting = {
	  "": 1,
	  "lr": 1,
	  "rl": 1
	};
	var alignSetting = {
	  "start": 1,
	  "center": 1,
	  "end": 1,
	  "left": 1,
	  "right": 1,
	  "auto": 1,
	  "line-left": 1,
	  "line-right": 1
	};
	
	function findDirectionSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var dir = directionSetting[value.toLowerCase()];
	  return dir ? value.toLowerCase() : false;
	}
	
	function findAlignSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var align = alignSetting[value.toLowerCase()];
	  return align ? value.toLowerCase() : false;
	}
	
	function VTTCue(startTime, endTime, text) {
	  /**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
	  // Lets us know when the VTTCue's data has changed in such a way that we need
	  // to recompute its display state. This lets us compute its display state
	  // lazily.
	  this.hasBeenReset = false;
	
	  /**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
	  var _id = "";
	  var _pauseOnExit = false;
	  var _startTime = startTime;
	  var _endTime = endTime;
	  var _text = text;
	  var _region = null;
	  var _vertical = "";
	  var _snapToLines = true;
	  var _line = "auto";
	  var _lineAlign = "start";
	  var _position = "auto";
	  var _positionAlign = "auto";
	  var _size = 100;
	  var _align = "center";
	
	  Object.defineProperties(this, {
	    "id": {
	      enumerable: true,
	      get: function() {
	        return _id;
	      },
	      set: function(value) {
	        _id = "" + value;
	      }
	    },
	
	    "pauseOnExit": {
	      enumerable: true,
	      get: function() {
	        return _pauseOnExit;
	      },
	      set: function(value) {
	        _pauseOnExit = !!value;
	      }
	    },
	
	    "startTime": {
	      enumerable: true,
	      get: function() {
	        return _startTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Start time must be set to a number.");
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "endTime": {
	      enumerable: true,
	      get: function() {
	        return _endTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("End time must be set to a number.");
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "text": {
	      enumerable: true,
	      get: function() {
	        return _text;
	      },
	      set: function(value) {
	        _text = "" + value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "region": {
	      enumerable: true,
	      get: function() {
	        return _region;
	      },
	      set: function(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "vertical": {
	      enumerable: true,
	      get: function() {
	        return _vertical;
	      },
	      set: function(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "snapToLines": {
	      enumerable: true,
	      get: function() {
	        return _snapToLines;
	      },
	      set: function(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "line": {
	      enumerable: true,
	      get: function() {
	        return _line;
	      },
	      set: function(value) {
	        if (typeof value !== "number" && value !== autoKeyword) {
	          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "lineAlign": {
	      enumerable: true,
	      get: function() {
	        return _lineAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("lineAlign: an invalid or illegal string was specified.");
	        } else {
	          _lineAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "position": {
	      enumerable: true,
	      get: function() {
	        return _position;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Position must be between 0 and 100.");
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "positionAlign": {
	      enumerable: true,
	      get: function() {
	        return _positionAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("positionAlign: an invalid or illegal string was specified.");
	        } else {
	          _positionAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "size": {
	      enumerable: true,
	      get: function() {
	        return _size;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Size must be between 0 and 100.");
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "align": {
	      enumerable: true,
	      get: function() {
	        return _align;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }
	  });
	
	  /**
	   * Other <track> spec defined properties
	   */
	
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	  this.displayState = undefined;
	}
	
	/**
	 * VTTCue methods
	 */
	
	VTTCue.prototype.getCueAsHTML = function() {
	  // Assume WebVTT.convertCueToDOMTree is on the global.
	  return WebVTT.convertCueToDOMTree(window, this.text);
	};
	
	module.exports = VTTCue;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var scrollSetting = {
	  "": true,
	  "up": true
	};
	
	function findScrollSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var scroll = scrollSetting[value.toLowerCase()];
	  return scroll ? value.toLowerCase() : false;
	}
	
	function isValidPercentValue(value) {
	  return typeof value === "number" && (value >= 0 && value <= 100);
	}
	
	// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
	function VTTRegion() {
	  var _width = 100;
	  var _lines = 3;
	  var _regionAnchorX = 0;
	  var _regionAnchorY = 100;
	  var _viewportAnchorX = 0;
	  var _viewportAnchorY = 100;
	  var _scroll = "";
	
	  Object.defineProperties(this, {
	    "width": {
	      enumerable: true,
	      get: function() {
	        return _width;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("Width must be between 0 and 100.");
	        }
	        _width = value;
	      }
	    },
	    "lines": {
	      enumerable: true,
	      get: function() {
	        return _lines;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Lines must be set to a number.");
	        }
	        _lines = value;
	      }
	    },
	    "regionAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorX must be between 0 and 100.");
	        }
	        _regionAnchorY = value;
	      }
	    },
	    "regionAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorX;
	      },
	      set: function(value) {
	        if(!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorY must be between 0 and 100.");
	        }
	        _regionAnchorX = value;
	      }
	    },
	    "viewportAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorY must be between 0 and 100.");
	        }
	        _viewportAnchorY = value;
	      }
	    },
	    "viewportAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorX;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorX must be between 0 and 100.");
	        }
	        _viewportAnchorX = value;
	      }
	    },
	    "scroll": {
	      enumerable: true,
	      get: function() {
	        return _scroll;
	      },
	      set: function(value) {
	        var setting = findScrollSetting(value);
	        // Have to check for false as an empty string is a legal value.
	        if (setting === false) {
	          console.warn("Scroll: an invalid or illegal string was specified.");
	        } else {
	          _scroll = setting;
	        }
	      }
	    }
	  });
	}
	
	module.exports = VTTRegion;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	var app = angular.module("app", [
		"ui.router", 
		// "ngAnimate", 
		'ui.tinymce',
		"ui.bootstrap",
		"ui.sortable", 
		"ngStorage",
		'oi.select',
		"dashboardModule",
		"loginModule",
		"servicesModule",
		"postsModule",
		// "blogsModule",
		// "newsServicesModule",
		"ratingsModule",
		"mediaModule",
		"pagesModule",
		"approvalsModule",
		"aiModule",
		"usersModule",
		"pollsModule",
		// "focusModule",
		"commentsModule",
		// "newstickerModule",
		"popularpostsModule",
		"macrositesModule",
		"menusModule",
		"notificationsModule",
		"logsModule",
		"videoModule",
		// "eSportsModule",
		"adsModule",
		// "blicModule",
		// "catalogsModule",
		// "wCupModule",
		// "covidRestrictionsModule"
			// "btford.socket-io",
		
	]);
	
	if(!enviroment.isDevelopment) {		
		console.log('Sentry is enabled in production');
		// ============================================================================
		// SENTRY ANGULAR INTEGRATION
		// ============================================================================
		// Set up Sentry's Angular $exceptionHandler integration
		// All logic is in sentryIntegration.js
		// ============================================================================
		var sentryIntegration = __webpack_require__(159);
		sentryIntegration.setupAngular(app);
		// ============================================================================
	}
	__webpack_require__(426)(app);
	__webpack_require__(461)(app);
	__webpack_require__(424)(app);
	__webpack_require__(425)(app);
	__webpack_require__(423)(app);
	__webpack_require__(459)(app);
	__webpack_require__(460)(app);
	__webpack_require__(442)(app);
	__webpack_require__(443)(app);
	__webpack_require__(432)(app);
	__webpack_require__(436)(app);
	__webpack_require__(440)(app);
	__webpack_require__(433)(app);
	__webpack_require__(438)(app);
	__webpack_require__(451)(app);
	__webpack_require__(446)(app);
	__webpack_require__(445)(app);
	__webpack_require__(434)(app);
	__webpack_require__(439)(app);
	__webpack_require__(457)(app);
	__webpack_require__(455)(app);
	__webpack_require__(456)(app);
	__webpack_require__(431)(app);
	__webpack_require__(435)(app);
	__webpack_require__(437)(app);
	__webpack_require__(430)(app);
	__webpack_require__(454)(app);
	__webpack_require__(449)(app);
	__webpack_require__(444)(app);
	__webpack_require__(453)(app);
	__webpack_require__(452)(app);
	__webpack_require__(448)(app);
	__webpack_require__(450)(app);
	__webpack_require__(447)(app);
	__webpack_require__(441)(app);
	__webpack_require__(428)(app);
	__webpack_require__(429)(app);
	__webpack_require__(427)(app);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

	 module.exports = function(app) {
	  'use strict';
	  // app.config(appConfig);
	  // appConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
	  // function appConfig($stateProvider, $urlRouterProvider) {
	  //   $stateProvider
	  //     .state('home', {
	  //         url: '/home',
	  //         abstract: true,
	  //         template: require('./home.html')
	  //     });
	
	  //   $urlRouterProvider.otherwise(function ($injector) {
	  //       var $state = $injector.get('$state');
	  //       $state.go('login');
	  //   });
	  // }
	}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app
		.controller('appCtrl', appCtrl)
	    .factory('$exceptionHandler', exceptionHandler);
		appCtrl.$inject=['getConfigData','eventStream','$http','API_URL','jwtDecoderService','$interval','getIspTitle','$timeout','$location','config', '$scope', '$localStorage','$state','$stateParams','authtokenService','$rootScope','refreshtokenService','$element','alertService', 'getDataService','jQuery','navigationService','serverError','warningAlertService'];
		function appCtrl(getConfigData,eventStream,$http,API_URL,jwtDecoderService,$interval,getIspTitle,$timeout,$location, config, $scope, $localStorage,$state,$stateParams, authtokenService, $rootScope,refreshtokenService,$element,alertService, getDataService, jQuery, navigationService,serverError,warningAlertService) {
			var vma = this;
			vma.sidebarshow = false;
			vma.title = config.appTitle;
		    $scope.app = config;
			vma.config = config;
		    $scope.$state = $state;
		    $rootScope.ngEscapeAttrsParametars = [];
			// vma.notifications = [];
		    $rootScope.hasLoaded = true;
		    $rootScope.serverError={
		    	'show' : false
		    }
			$rootScope.offlineError = false;
			// vma.focusLocked = {
			// 	locked: false,
			// 	name: '',
			// 	userId: ''
			// }
			
			// vma.socketData = undefined;
			// vma.notificationNews= socketNews.notificationNews;
			vma.refreshTokenInterval = config.refreshTokenInterval;
			// function displayNotification(obj) {
			// 	if(vma.notifications.length>=5) {
			// 		vma.notifications.splice(0,1)
			// 	}
			// 	vma.notifications.push(obj)
			// }
			// function appControllerNewSocketCb(data) {
			// 	if(data.type=='new') {
			// 		$scope.$apply(function () {
			// 			vma.notificationNews.new[data.service]  = vma.notificationNews.new[data.service] + data.count
			// 			vma.notificationNews.newTotalCount = vma.notificationNews.newTotalCount + data.count
			// 		})
			// 		for (var i = 0;i<data.posts.length;i++) {
			// 			if(data.posts[i].pm && data.posts[i].pm.display) {
			// 				$scope.$apply(function () {
			// 					displayNotification({
			// 						headerText: data.posts[i].headerText,
			// 						contentText: data.posts[i].title,
			// 						btnText: "Pogledaj",
			// 						btnFunc: "app."+data.service+"_allnews({id:'"+ data.posts[i]._id + "'})",
			// 						type:'danger',
			// 						id: data.posts[i]._id,
			// 						animation:data.posts[i].pm.animation
			// 					})
			// 				})
			// 			}
			// 		}
			// 	}
			// }
			// function appControllerAssignedSocketCb(data) {
			// 	if(data.type == 'add') {
			// 		//prevent duplicate obj in array
			// 		for (var i = 0; i<vma.notificationNews.assigned.length;i++) {
			// 			if(vma.notificationNews.assigned[i]._id == data.post._id) {
			// 				return
			// 			}
			// 		}
			// 		$scope.$apply(function () {
			// 			vma.notificationNews.assigned.unshift(data.post)
			// 			displayNotification({
			// 				headerText: data.message,
			// 				contentText: data.post.title,
			// 				btnText: "Preuzmi",
			// 				btnFunc: "app.allposts({id:"+ data.post._id + "})",
			// 				type:'primary',
			// 				id: data.post._id,
			// 				animation:data.animation
			// 			})
			// 		})
			// 	} else if(data.type=='delete') {
			// 		for (var i =0;i<vma.notificationNews.assigned.length;i++) {
			// 			if(vma.notificationNews.assigned[i]._id == data.post_id) {
			// 				$scope.$apply(function () {
			// 					vma.notificationNews.assigned.splice(i,1)
			// 				})
			// 				break
			// 			}
			// 		}
			// 		$scope.$apply(function () {	
			// 			vma.notificationsDeleteFunction(data.post_id)
			// 		})
			// 	}
			// }
			// socketNews.socketNewsListener.on('assignedNews', appControllerAssignedSocketCb)
			// socketNews.socketNewsListener.on('newNews', appControllerNewSocketCb)
			// if(window.socketAnalytics) {
			// 	window.socketAnalytics.on('global', function(wsData){
			// 		if(!wsData) return
			// 		$scope.$apply(function () {
			// 			vma.socketData = wsData
			// 			vma.socketData.ispArray = []
			// 			if(wsData.isp instanceof Object) {
			// 				for (var isp in wsData.isp) {
			// 					vma.socketData.ispArray.push({name:isp, count:wsData.isp[isp]});
			// 				}
			// 			} 
			// 		})
			// 	})
			// }
			// function focusTakeoverFunction(takeoverMessage) {
			// 	warningAlertService('Focus takeover',takeoverMessage,function cb() {
			// 		var url = API_URL+ "focus/takeover"
	        //   		var updateDataPost = {}
			// 		var updateFunction = function() {
			// 			$http.put(url , updateDataPost)
			// 			.success(function (data, stat, headers) {
			// 			alertService('success','Success ', data.message, 2000);
			// 			$timeout(function() {
			// 				$state.go('app.allfocus');
			// 			},0)
			// 			})
			// 			.error(function (data, status, header, config) {
			// 			if(!window.navigator.onLine) {
			// 				offlineError()
			// 				alertService('danger','Opps! ', 'Please check your internet connection and try again.');
			// 				return
			// 			}
			// 			if(status ==401) {
			// 				var promise = refreshtokenService.getAccessToken();
			// 				promise.then(
			// 				function(answer) {
			// 					if(answer==200) {   
			// 					updateFunction();
			// 					}
			// 				},
			// 				function(error) {
			// 				},
			// 				function(progress) {
			// 				// report progress
			// 				});
			// 			}else if(status ==502) {
			// 				serverError()  
			// 			} else { 
			// 				alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
			// 			}
			// 			}); 
			// 		}
			// 		updateFunction();
			// 	});
			// }
			// vma.focusTakeover = function() {
			// 	if(!vma.focusLocked.locked) {
			// 		$state.go('app.allfocus');
			// 		return
			// 	}
			// 	var takeoverMessage;
			// 	if(vma.focusLocked.userId == vma.userId) {
			// 		if($state.current.name === 'app.allfocus') return;
			// 		takeoverMessage = "Focus is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?";
			// 	} else {
			// 		takeoverMessage = '<strong>' + vma.focusLocked.name + '</strong> is currently editing the Focus section. Do you want to take control?';
			// 	}
			// 	focusTakeoverFunction(takeoverMessage);
			// }
			// function heartbeatCallback(data) {
			// 	$scope.$apply(function() {
			// 		if(data.type=='focus_locked') {
			// 		  vma.focusLocked.locked = true;
			// 		  vma.focusLocked.name = data.locked_by_name;
			// 		  vma.focusLocked.userId = data.locked_by;
			// 		} else if(data.type=='focus_unlocked') {
			// 		  vma.focusLocked.locked = false;
			// 		  vma.focusLocked.name = '';
			// 		  vma.focusLocked.userId = '';
			// 		}
			// 	});
			// }
			// $scope.$watch(function() {
			// 	return vma.config
			// }, function(newValue, oldValue) {
			// 	if(newValue !== oldValue && !$state.is('login')) {
			// 		if(vma.config.lockingManager && vma.config.lockingManager['focus']) {
			// 			if(!eventStream.getConnection('focus')) {
			// 				eventStream.connect('focus',vma.config.lockingManager['focus']);
			// 			}
			// 			if(!eventStream.hasMessageHandler('focus',heartbeatCallback)) {
			// 				eventStream.onMessage('focus',heartbeatCallback);
			// 			}
			// 		}
			// 		if(vma.config.focus_lock && Object.keys(vma.config.focus_lock).length>0 && vma.config.focus_lock.type == 'focus_locked') {
			// 			vma.focusLocked.locked = true;
			// 			vma.focusLocked.name = vma.config.focus_lock.locked_by_name;
			// 			vma.focusLocked.userId = vma.config.focus_lock.locked_by;
			// 		} else {
			// 			vma.focusLocked.locked = false;
			// 			vma.focusLocked.name = '';
			// 			vma.focusLocked.userId = '';
			// 		}
			// 	}
			// },true);
			// vma.getIspTitle = getIspTitle;
			vma.currentstate = [];
	        setTimeout(function() {
				window.loaded = 'loaded';
			},0);
		    vma.refreshTokenInterval = config.refreshTokenInterval;
			if (angular.isDefined($localStorage.state)){
			    $scope.app.state = $localStorage.state;
			} else {
			    $localStorage.state = $scope.app.state;
			}
			vma.getCredential = function() {
				vma.name = authtokenService.getName();
				vma.avatar = authtokenService.getAvatar();
				$rootScope.role_id = authtokenService.getRoleId();
			}
			$scope.$on('is-aunthenticated', function(evt,data){
				vma.isAuth = data.isAuth;
				vma.getCredential();
				
			});
			vma.getCredential();
			
			$rootScope.isLogout = false;
			function logOutSuccess() {
				$rootScope.isLogout = true;
				$state.go('login');
				$rootScope.alerts = [];
				$rootScope.alertShow = false;
				$timeout(function() {
					authtokenService.removeToken();
					alertService('success','Success ', 'You are now Log Out', 2000);
				}, 0);
			}
			vma.logout =function() {
				$rootScope.hasLoaded = false;
				function logOut() {
					$http.post(API_URL + 'auth/logout',{
						'user_id': authtokenService.getUserId()
					}).success(function(response) {
						$rootScope.hasLoaded = true;
						logOutSuccess();
					}).error(function(error) {
						if(error.status == 401) {
							var promise = refreshtokenService.getAccessToken();
					  		promise.then(
								function(answer) {
								if(answer==200) {
									logOut();
								}
								},
								function(error) {
								},
								function(progress) {
								// report progress
							});
						} else {
							logOutSuccess();
						}
						$rootScope.hasLoaded = true;
					});	
				}
				logOut();
				
			}
			var firstLoad = false;
			vma.changeMenuItem = function(state) {
				for (var i=0; i < $rootScope.navigation.length;i++) {
					if($rootScope.navigation[i].items) {
						for(var j=0; j < $rootScope.navigation[i].items.length; j++) {
							if($rootScope.navigation[i].items[j].state == state && !vma.currentstate.includes(i)) {
								vma.currentstate.push(i);
							}
						}
					}
				} 
			}
			var deregistrationFunction;
			$rootScope.$on('$stateChangeStart',
	        function(event, toState, toParams, fromState, fromParams){
				// // Handle favicon and title changes for allfocus state
				// if(toState.name === 'app.allfocus') {
				// 	// Change favicon to favicon2.ico
				// 	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				// 	link.type = 'image/x-icon';
				// 	link.rel = 'shortcut icon';
				// 	link.href = '/favicon2.ico';
				// 	document.getElementsByTagName('head')[0].appendChild(link);
					
				// 	// Change page title
				// 	document.title = 'Focus - Telegraf CMS';
				// } else if(fromState.name === 'app.allfocus') {
				// 	// Revert favicon back to favicon.ico when leaving allfocus state
				// 	var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				// 	link.type = 'image/x-icon';
				// 	link.rel = 'shortcut icon';
				// 	link.href = '/favicon.ico';
				// 	document.getElementsByTagName('head')[0].appendChild(link);
					
				// 	// Revert page title
				// 	document.title = 'Telegraf CMS';
				// }
				var stateCurrent = toState.name;
				var state = stateCurrent.substr(4);
					//reload to some state exept login             from login   
				if((!fromState.name && toState.name != 'login') || fromState.name === 'login') {
					// socketNews.getAssignedNewsApi()
					// if($scope.app.socketUrl) {
					// 	socketNews.connect()
					// }
					if(deregistrationFunction) {
						deregistrationFunction()
					}
					//active menu item
					deregistrationFunction = $scope.$watch(function(){
						return $rootScope.navigation
					  }, function(newValue, oldValue){
						if (newValue !== oldValue) {
							vma.changeMenuItem(state);
						}
					},true);
					vma.userId = parseInt(authtokenService.getUserId());
				}
				if(fromState.name === 'login' && $rootScope.isLogout) {
					vma.config.load = false;
					$rootScope.isLogout = false;
				}
	            vma.sidebarshow=false;
	            $element.removeClass('overflow-hidden');
	            if(toState.name !== 'login') {
					if(!vma.getRefreshTokenInterval) {
						vma.getRefreshTokenInterval = $interval(function() {
							var refreshToken = authtokenService.getRefreshToken();
							if(!refreshToken) return
							var refreshTokenExpirationDate = jwtDecoderService.getExpirationDate(refreshToken);
							if(!refreshTokenExpirationDate) return
							var now = new Date();
							var timeUntilExpiration = refreshTokenExpirationDate.getTime() - now.getTime();
							var fiveMinutesInMs = 5 * 60 * 1000; // 5 minutes in milliseconds
							
							if(timeUntilExpiration <= fiveMinutesInMs) {
								$http.post(API_URL + 'auth/renewRefreshToken',{
									'user_id': authtokenService.getUserId()
								}).success(function(response) {
									authtokenService.setrefreshToken(response.refresh_token);
								}).error(function(error) {
									$rootScope.alerts = [];
									$rootScope.alertShow = false;
									authtokenService.removeToken();
									$state.go('login');
								});
							}
						}, vma.refreshTokenInterval*1000);
					}
		            if(!$rootScope.navigation && authtokenService.getToken()) {
				 		navigationService.getNavigation();
			       	}
					if(!firstLoad) {
						// $scope.$watch(function(){
						// 	return $scope.app.socketUrl
						//   }, function(newValue, oldValue){
						// 	if (newValue !== oldValue) {
						// 		socketNews.connect()
						// 	}
						// },true);
						firstLoad = true
					}
					if($rootScope.navigation) {
						vma.changeMenuItem(state);
					}
					// if(!eventStream.getConnection('focus') && vma.config.lockingManager && vma.config.lockingManager['focus'] && !$state.is('login')) {
					// 	eventStream.connect('focus',vma.config.lockingManager['focus']);
					// }
					// if(!eventStream.hasMessageHandler('focus',heartbeatCallback)) {
					// 	eventStream.onMessage('focus',heartbeatCallback);
					// }
	            } else {
					// vma.focusLocked = {
					// 	locked: false,
					// 	name: '',
					// 	userId: ''
					// }
					// if(eventStream.getConnection('focus')) {
					// 	eventStream.disconnect('focus');
					// }
					// vma.notifications.length = 0;
					// socketNews.disconnect();
					if(vma.getRefreshTokenInterval) {
						$interval.cancel(vma.getRefreshTokenInterval)
						vma.getRefreshTokenInterval = null;
					}
				}
	
	        });
			angular.element(document).on('touchstart', function(e) {
			  if(!vma.sidebarshow) return;
		      var container = angular.element(document.getElementById("sidebar"));
		      var hamburger = angular.element(document.getElementsByClassName('hamburger')[0]);
		      if (!container.is(e.target) // if the target of the click isn't the container...
		        && container.has(e.target).length === 0 && !hamburger.is(e.target) && hamburger.has(e.target).length === 0) // ... nor a descendant of the container
		      {
		        $scope.$apply(function () {
		          vma.sidebarshow = false;
		          $element.removeClass('overflow-hidden');
		        });
		      }
		    });
	  		vma.toggleNav = function() {
	  			vma.sidebarshow=!vma.sidebarshow;
	  			$element.toggleClass('overflow-hidden');
	  		}
	  		vma.subCategoryOpen = function(index) {
				if(!vma.currentstate.includes(index)) {
					vma.currentstate.push(index);
				}else {
					var indexToRemove = vma.currentstate.indexOf(index);
					if (indexToRemove !== -1) {
						vma.currentstate.splice(indexToRemove, 1);
					}
				}{}
	  		}
	  		vma.currentStateHandler = function($event, state) {
				// if(state == 'allfocus' && vma.focusLocked.locked) {
				// 	var takeoverMessage;
				// 	if(vma.focusLocked.userId != vma.userId) {
				// 		takeoverMessage = '<strong>' + vma.focusLocked.name + '</strong> is currently editing the Focus section. Do you want to take control?';
				// 		focusTakeoverFunction(takeoverMessage);
				// 	} else {
				// 		if($state.current.name !== 'app.allfocus') {
				// 			takeoverMessage = "Focus is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?";
				// 			focusTakeoverFunction(takeoverMessage);
				// 		}
				// 	}
				// 	$event.preventDefault();
				// 	return
				// }
	  			var currentState = $event.target;
	  			if($state.is('app.allposts')) {
	  				if(jQuery(currentState).hasClass('allposts')) {
	  					$timeout($rootScope.closeEditPost, 10);
	  				}
	  			}
				if($state.is('app.myposts')) {
					if(jQuery(currentState).hasClass('myposts')) {
						$timeout($rootScope.closeEditPost, 10);
					}
				}
	  			if($state.is('app.allpages')) {
	  				if(jQuery(currentState).hasClass('allpages')) {
	  					$timeout($rootScope.closeEditPage, 10);
	  				}
	  			}
	  			if($state.is('app.allpolls')) {
	  				if(jQuery(currentState).hasClass('allpolls')) {
	  					$timeout($rootScope.closeEditPoll, 10);
	  				}
	  			}
				if($state.is('app.allratings')) {
					if(jQuery(currentState).hasClass('allratings')) {
						$timeout($rootScope.closeEditRating, 10);
					}
				}
				// if($state.is('app.allliveblogs')) {
				// 	if(jQuery(currentState).hasClass('allliveblogs')) {
				// 		$timeout($rootScope.closeEditLiveblog, 10);
				// 	}
				// }
	  			if($state.is('app.library')) {
	  				if(jQuery(currentState).hasClass('library')) {
	  					$timeout($rootScope.closeEditMedia, 10);
	  				}
	  			}
	  			if($state.is('app.allusers')) {
	  				if(jQuery(currentState).hasClass('allusers')) {
	  					$timeout($rootScope.closeEditUser, 10);
	  				}
	  			}
	  			if($state.is('app.tags')) {
	  				if(jQuery(currentState).hasClass('tags')) {
	  					$timeout($rootScope.closeEditTag, 10);
	  				}
	  			}
	  			if($state.is('app.categories')) {
	  				if(jQuery(currentState).hasClass('categories')) {
	  					$timeout($rootScope.closeEditCategory, 10);
	  				}
	  			}
	  			if($state.is('app.video_categories')) {
	  				if(jQuery(currentState).hasClass('video_categories')) {
	  					$timeout($rootScope.closeEditVideoCategory, 10);
	  				}
	  			}
	  			if($state.is('app.video_tags')) {
	  				if(jQuery(currentState).hasClass('video_tags')) {
	  					$timeout($rootScope.closeEditVideoTag, 10);
	  				}
	  			}
	  			if($state.is('app.allvideos')) {
	  				if(jQuery(currentState).hasClass('allvideos')) {
	  					$timeout($rootScope.closeEditVideo, 10);
	  				}
	  			}
				if($state.is('app.ai_all_configurations')) {
					if(jQuery(currentState).hasClass('ai_all_configurations')) {
						$timeout($rootScope.closeEditConfiguration, 10);
					}
				}
	  		}
		}
	
		exceptionHandler.$inject = ['$log', '$window', '$injector'];
		function exceptionHandler($log, $window, $injector) {
		    return function (exception, cause) {
		      var errors = $window.JSON.parse($window.localStorage.getItem('sing-2-angular-errors')) || {};
		      errors[new Date().getTime()] = arguments;
		      $window.localStorage.setItem('sing-2-angular-errors', $window.JSON.stringify(errors));
		      if ($injector.get('config').debug) {
		        $log.error.apply($log, arguments);
		        $window.alert('check errors');
		      }
		    };
		}		
	}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app
		.constant('API_URL', window.settings.baseUrl)
	
		.config(['$stateProvider', '$urlRouterProvider','$httpProvider', function($stateProvider,$urlRouterProvider,$httpProvider) {
	
			$stateProvider.state('login', {
				url:'/',
				
				resolve:{
					refresh: ['refreshtokenService','$state','$rootScope','authtokenService','alertService','serverError', function(refreshtokenService,$state,$rootScope,authtokenService,alertService,serverError) {
						$rootScope.alerts = [];
						$rootScope.alertShow = false;
						var token = authtokenService.getToken();
						if(token && !$rootScope.isLogout) {
							return refreshtokenService.getAccessToken()
				               	.then(
				                function(answer) {
		                			if(answer==200) {
		                				if($rootScope.role_id == 'comments-moderator') {
		                					$state.go('app.allcomments');	
		                				} else {
		                    				$state.go('app.allposts');
		                				}
		                			}
				                },
				                function(error) {
				                  // report something
				                },
				                function(progress) {
				                 // report progress
				                });
						}
					  	return
			          }]
				},
				template: '<login-dir></login-dir>'
			});
			$stateProvider.state('app', {
				abstract: true,
				resolve: {          
					configData:['getConfigData','tabSessionService','$rootScope',function(getConfigData,tabSessionService,$rootScope){
						$rootScope.tabSessionId = tabSessionService.getSessionId();
						return getConfigData.getData('init')
					}]
				},
				template: __webpack_require__(251),
			});
			$stateProvider.state('app.dashboard', {
				url:'/dashboard',
				template: '<dashboard-dir></dashboard-dir>'
			});
			$stateProvider.state('app.logs', {
				url:'/logs',
				template: '<logs-dir></logs-dir>'
			});
			$stateProvider.state('app.allposts', {
				url:'^/posts/all?id',
				template: '<all-posts-dir></all-posts-dir>'
			});
			$stateProvider.state('app.myposts', {
				url:'^/my-posts/all?id',
				template: '<all-posts-dir my-posts="true"></all-posts-dir>'
			});
			$stateProvider.state('app.newpost', {
				url:'^/posts/new',
				template: '<post-dir></post-dir>'
			});
			$stateProvider.state('app.categories', {
				url:'^/posts/categories?id',
				template: '<categories-dir></categories-dir>'
			});
			$stateProvider.state('app.tags', {
				url:'^/posts/tags?id',
				template: '<tags-dir></tags-dir>'
			});
			// $stateProvider.state('app.us_election', {
			// 	url:'^/posts/us-election',
			// 	template: '<us-election-dir></us-election-dir>'
			// });
			// $stateProvider.state('app.allliveblogs', {
			// 	url:'^/blogs/all?id',
			// 	template: '<all-blogs-dir></all-blogs-dir>'
			// });
			// $stateProvider.state('app.newblog', {
			// 	url:'^/blogs/new',
			// 	template: '<blog-dir></blog-dir>'
			// });
			$stateProvider.state('app.agencies_allnews', {
				url:'^/news-services/agencies?id',
				template: '<news-services-dir type="agencies"></news-services-dir>'
			});
			$stateProvider.state('app.earthquakes_allnews', {
				url:'^/news-services/earthquakes?id',
				template: '<news-services-dir type="earthquakes"></news-services-dir>'
			});
			$stateProvider.state('app.newshub_allnews', {
				url:'^/news-services/newshub?id',
				template: '<news-services-dir type="newshub"></news-services-dir>'
			});
			$stateProvider.state('app.allpages', {
				url:'^/pages/all?id',
				template: '<all-pages-dir></all-pages-dir>'
			});
			$stateProvider.state('app.newpage', {
				url:'^/pages/new',
				template: '<page-dir></page-dir>'
			});
			$stateProvider.state('app.allapprovals', {
				url:'^/approvals/all',
				template: '<all-approvals-dir></all-approvals-dir>'
			});
			$stateProvider.state('app.allcountries', {
				url:'^/travel-restrictions/all-countries?id',
				template: '<all-countries-restriction-dir></all-countries-restriction-dir>'
			});
			$stateProvider.state('app.library', {
				url:'^/photos/all?id',
				template: '<media-library-dir></media-library-dir>'
			});
			$stateProvider.state('app.newmedia', {
				url:'^/photos/new',
				template: '<new-media-dir></new-media-dir>'
			});
			$stateProvider.state('app.related_galleries', {
				url:'^/photos/related-galleries',
				template: '<related-galleries-dir></related-galleries-dir>'
			});
			$stateProvider.state('app.ai_all_configurations', {
				url:'^/ai/configurations/all?id',
				template: '<ai-all-configurations-dir></ai-all-configurations-dir>'
			});
			$stateProvider.state('app.ai_create_config', {
				url:'^/ai/configurations/create',
				template: '<ai-configuration-dir></ai-configuration-dir>'
			});
			$stateProvider.state('app.allusers', {
				url:'^/users/all?id',
				template: '<all-users-dir></all-users-dir>'
			});
			$stateProvider.state('app.newuser', {
				url:'^/users/new',
				template: '<user-dir></user-dir>'
			});
			$stateProvider.state('app.profile', {
				url:'^/users/your-profile',
				template: '<profile-dir></profile-dir>'
			});
			$stateProvider.state('app.allpolls', {
				url:'^/polls/all?id',
				template: '<all-polls-dir></all-polls-dir>'
			});
			$stateProvider.state('app.newpoll', {
				url:'^/polls/new',
				template: '<poll-dir></poll-dir>'
			});
			$stateProvider.state('app.allratings', {
				url:'^/ratings/all?id',
				template: '<all-ratings-dir></all-ratings-dir>'
			});
			$stateProvider.state('app.newrating', {
				url:'^/ratings/new',
				template: '<rating-dir></rating-dir>'
			});
			// $stateProvider.state('app.allfocus', {
			// 	url:'^/focus-news/all',
			// 	template: '<all-focus-dir></all-focus-dir>'
			// });
			// $stateProvider.state('app.allfocustabs', {
			// 	url:'^/focus-news/focus-tabs',
			// 	template: '<focus-tabs-dir></focus-tabs-dir>'
			// });
			// $stateProvider.state('app.weatherfocus', {
			// 	url:'^/focus-news/focus-weather',
			// 	template: '<focus-weather-dir></focus-weather-dir>'
			// });
			// $stateProvider.state('app.allnewsticker', {
			// 	url:'^/news-ticker',
			// 	template: '<news-ticker-dir></news-ticker-dir>'
			// });
			$stateProvider.state('app.allpopularposts', {
				url:'^/popular-posts',
				template: '<popular-posts-dir></popular-posts-dir>'
			});
			// $stateProvider.state('app.macrosites_related_news', {
			// 	url:'^/macrosites/related-news',
			// 	template: '<macrosites-related-news-dir></macrosites-related-news-dir>'
			// });
			$stateProvider.state('app.macrosites_focus_news', {
				url:'^/telegraf/focus-news',
				template: '<macrosites-focus-news-dir></macrosites-focus-news-dir>'
			});
			$stateProvider.state('app.allcomments', {
				url:'^/comments/post',
				template: '<all-comments-dir></all-comments-dir>'
			});
			$stateProvider.state('app.highlightwords', {
				url:'^/comments/highlight-words',
				template: '<highlight-words-dir></highlight-words-dir>'
			});
			$stateProvider.state('app.allvideocomments', {
				url:'^/comments/video',
				template: '<all-comments-dir></all-comments-dir>'
			});
			$stateProvider.state('app.menus', {
				url:'^/menus?id',
				template: '<menus-dir></menus-dir>'
			});
			$stateProvider.state('app.allpush', {
				url:'^/notification/all',
				template: '<all-notifications-dir></all-notifications-dir>'
			});
			$stateProvider.state('app.allpush_eklinika', {
				url:'^/notification/eklinika',
				template: '<all-notifications-dir type="eklinika"></all-notifications-dir>'
			});
			$stateProvider.state('app.notificationsettings', {
				url:'^/notification/settings',
				template: '<notification-settings-dir></notification-settings-dir>'
			});
			
			$stateProvider.state('app.allvideos', {
				url:'^/videos/all?id',
				template: '<all-videos-dir></all-videos-dir>'
			});
			$stateProvider.state('app.newvideo', {
				url:'^/videos/new',
				template: '<new-video-dir></new-video-dir>'
			});
			$stateProvider.state('app.newvideo_mediaoutcast', {
				url:'^/videos/new-mediaoutcast',
				template: '<new-video-mediaoutcast-dir></new-video-mediaoutcast-dir>'
			});
			$stateProvider.state('app.video_categories', {
				url:'^/videos/categories?id',
				template: '<video-categories-dir></video-categories-dir>'
			});
			$stateProvider.state('app.video_tags', {
				url:'^/videos/tags?id',
				template: '<video-tags-dir></video-tags-dir>'
			});
			$stateProvider.state('app.video_livestream', {
				url:'^/videos/livestream',
				template: '<livestream-dir></livestream-dir>'
			});
			$stateProvider.state('app.video_related_box', {
				url:'^/videos/related-video-box',
				template: '<related-video-box-dir></related-video-box-dir>'
			});
			// $stateProvider.state('app.allcatalogs', {
			// 	url:'^/catalogs/all?id',
			// 	template: '<all-catalogs-dir></all-catalogs-dir>'
			// });
			// $stateProvider.state('app.newcatalog', {
			// 	url:'^/catalogs/new',
			// 	template: '<catalog-dir></catalog-dir>'
			// });
			// $stateProvider.state('app.catalog_categories', {
			// 	url:'^/catalogs/categories?id',
			// 	template: '<catalog-categories-stores-dir></catalog-categories-stores-dir>'
			// });
			// $stateProvider.state('app.stores', {
			// 	url:'^/catalogs/stores?id',
			// 	template: '<catalog-categories-stores-dir></catalog-categories-stores-dir>'
			// });
			// $stateProvider.state('app.catalog_tags', {
			// 	url:'^/catalogs/tags?id',
			// 	template: '<catalog-tags-dir></catalog-tags-dir>'
			// });
			// $stateProvider.state('app.custom_widget', {
			// 	url:'^/esports/custom-widget',
			// 	template: '<custom-widget-dir></custom-widget-dir>'
			// });
			$stateProvider.state('app.banner_slider', {
				url:'^/ads/banner-slider',
				template: '<banner-slider-dir></banner-slider-dir>'
			});
			$stateProvider.state('app.txt', {
				url:'^/ads/ads-txt',
				template: '<ads-txt-dir></ads-txt-dir>'
			});
			$stateProvider.state('app.adosettings', {
				url:'^/ads/settings',
				template: '<ads-settings-dir></ads-settings-dir>'
			});
			// $stateProvider.state('app.allblic', {
			// 	url:'^/blic-exchange/all',
			// 	template: '<all-blic-dir></all-blic-dir>'
			// });
			// $stateProvider.state('app.groupphase', {
			// 	url:'^/world-cup-2018/group-phase',
			// 	template: '<group-phase-dir></group-phase-dir>'
			// });
			// $stateProvider.state('app.uploadgroupe', {
			// 	url:'^/world-cup-2018/upload-group-e',
			// 	template: '<upload-group-dir></upload-group-dir>'
			// });
			// $stateProvider.state('app.knockoutphase', {
			// 	url:'^/world-cup-2018/knockout-phase',
			// 	template: '<knockout-phase-dir></knockout-phase-dir>'
			// })
			$urlRouterProvider.otherwise('/');
			$httpProvider.interceptors.push('authInterceptor');
			$httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
			$httpProvider.defaults.useXDomain = true;
	        delete $httpProvider.defaults.headers.common['X-Requested-With'];
		}])
		// .run(['$state','configData', ,function($state, configData) {
		// 	for(var index=0;index<configData.newsServices.length;index++) {
		// 		$state.state('app.'+configData.newsServices[index]+'_allnews', {
		// 			url:'^/news-services/'+configData.newsServices[index]+'?id',
		// 			template: '<news-services-dir type="'+ configData.newsServices[index]+'"></news-services-dir>'
		// 		});
		// 	}
		// }])
	}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	module.exports = function(app) {
	  'use strict';
	
	  	app
	  	.factory('config', configFactory);
	
	  var config = {
	    name: 'dashboard',
	    title: 'Eklinika - dashboard',
	    version: '1.0.5',
	    refreshTokenInterval: 45,
	    baseHref: 'http://eklinika.telegraf.rs/',
	    baseMediaHref:'https://xdn.eklinika.rs/',
	    baseElasticSearchHref:'https://pretraga.telegraf.rs/eklinika_posts/',
	    // baseElasticLogsHref:'http://igit.comtrade.com:9200/logs/user/_search?sort=uts:desc',
	    baseElasticLogsHref:window.settings+'logs?sort=uts:desc',
	    videoUploadVersion: "v1.0",
	    debug: true,
	    /**
	     * In-app constants
	     */
	    limitCharacterMin:0,
	    limitCharacter:Infinity,
	    shared_contents : {},
	    rootMarginLazy : "0px 0px 250px 0px",
	    lockingManager: {},
	    focus_lock: {},
	    'setConfig': function(data, type) {
	      if(type=='init') {
	        config.baseMediaHref = data.global.cdn;
	        config.baseVideoHref = data.global.cdntv;
	        config.refreshTokenInterval = data.global.refreshTokenInterval;
	        config.baseHref = data.global.www;
	        config.baseHrefVideo = data.global.wwwtv;
	        config.baseElasticSearchHref = data.global.searchUrl;
	        config.thumbs = data.thumbs;
	        config.apiUrl =  data.global.url;
	        config.heartbeat = data.global.heartbeat;
	        config.www_biznis = data.global.www_biznis;
	        config.videoUploadVersion = data.global.videoUploadVersion;
	        config.videoUploadUrl = data.global.videoUploadUrl;
	        config.socketUrl = data.global.controllab;
	        config.mediaoutcast = data.mediaoutcast;
	      }
	      if(data.embed && type=='init') {
	        config.embed = data.embed
	      }
	      if(data.scriptVersions && (type=='init' || type=='dashboard')) {
	        config.www_script_version = data.scriptVersions.www_script_version;
	      }
	      if(data.focus && data.focus.minimum_number_items && type == 'init') {
	        config.focus_minimum_number_items = data.focus.minimum_number_items
	      }
	      if(data.focus && data.focus.locked_order && type == 'init') {
	        config.focus_blic_order = data.focus.locked_order.blic
	        config.focus_eklinika_api_order = data.focus.locked_order.eklinika_api
	        if(data.focus.locked_order.pr && data.focus.locked_order.pr.length>0) {
	          config.focus_pr_order = data.focus.locked_order.pr
	        }
	        if(data.focus.locked_order.microsites && data.focus.locked_order.microsites.length>0) {
	          config.focus_microsites_order = data.focus.locked_order.microsites
	        } else {
	          config.focus_microsites_order = []
	        }
	      }
	      if(type == 'init' || type == 'focus_stream') {
	        if(data.focus && data.focus.lock && Object.keys(data.focus.lock).length>0) {
	          for (var key in data.focus.lock) {
	            config.focus_lock[key] = data.focus.lock[key]
	          }
	        } else {
	          // Clear focus_lock object
	          for (var key in config.focus_lock) {
	            if (Object.prototype.hasOwnProperty.call(config.focus_lock, key)) {
	              delete config.focus_lock[key];
	            }
	          }
	        }
	      }
	      if(data.lockingManager && type == 'init') {
	        config.lockingManager = data.lockingManager
	      }
	      if(type == 'init') {
	        config.newsServices = ['agencies','earthquakes', 'newshub']
	        config.getHighlightWords = function(highlightWords) {
	          config.highlightWordsDiacritics = [];
	          config.highlightWordsBase = []
	          config.highlightWordsActive = false;
	          if(highlightWords){ 
	            if(highlightWords.active) {
	              config.highlightWordsActive = true;
	            }
	            if(highlightWords.words && highlightWords.words.length > 0) {
	              config.highlightWordsBase = highlightWords.words
	              if(highlightWords.active) {
	                highlightWords.words.forEach(function(item) {
	                  config.highlightWordsDiacritics.push((getVariationsPattern(item)))
	                })
	              }
	            }
	          }
	        }
	        config.getHighlightWords(data.highlightWords)
	        function getVariationsPattern(word) {
	          var variations = '';
	          for (var i = 0; i < word.length; i++) {
	            var char = word[i];
	            var charVariations = getVariations(char);
	            variations += charVariations;
	          }
	          return escapeRegExp(variations);
	        }
	        function escapeRegExp(string) {
	          return string.replace(/[$.']/g, '\\$&');
	        }
	
	
	        // Function to generate variations of a character
	        function getVariations(char) {
	          switch (char) {
	            case 'Č':
	                return '[ČC]';
	            case 'č':
	                return '[čc]';
	            case 'Ć':
	                return '[ĆC]';
	            case 'ć':
	                return '[ćc]';
	            case 'Š':
	                return '[ŠS]';
	            case 'š':
	                return '[šs]';
	            case 'Ž':
	                return '[ŽZ]';
	            case 'ž':
	                return '[žz]';
	            // Add more cases for other characters and their variations
	            default:
	                return char;
	          }
	        }
	      }
	    },
	    settings: {
	      colors: {
	        'white': '#fff',
	        'black': '#000',
	        'gray-light': '#999',
	        'gray-lighter': '#eee',
	        'gray': '#666',
	        'gray-dark': '#343434',
	        'gray-darker': '#222',
	        'gray-semi-light': '#777',
	        'gray-semi-lighter': '#ddd',
	        'brand-primary': '#5d8fc2',
	        'brand-success': '#64bd63',
	        'brand-warning': '#f0b518',
	        'brand-danger': '#dd5826',
	        'brand-info': '#5dc4bf'
	      },
	      screens: {
	        'xs-max': 767,
	        'sm-min': 768,
	        'sm-max': 991,
	        'md-min': 992,
	        'md-max': 1199,
	        'lg-min': 1200
	      },
	      navCollapseTimeout: 2500
	    },
	    addSafety : [
	        {
	            _id:'babysafe',
	            label:'Babysafe'
	        },
	        {
	            _id:'safe',
	            label:'Safe'
	        },
	        {
	            _id:'semisafe',
	            label:'Semisafe'
	        },
	        {
	            _id:'unsafe',
	            label: 'Unsafe'
	        }
	    ],
	    geoRestrictions: [
	        {
	            _id:'ww',
	            label:'Worldwide'
	        },
	        {
	            _id:'ex-yu',
	            label:'Ex-Yu'
	        },
	        {
	            _id:'exyu-no-si',
	            label:'Ex-Yu  Without Slovenia'
	        },
	        {
	            _id:'exyu-no-si-hr',
	            label:'Ex-Yu Without Slovenia&Croatia'
	        },
	        {
	            _id:'rs-me',
	            label:'Serbia and Montenegro'
	        },
	        {
	            _id:'rs',
	            label:'Serbia'
	        }
	    ],
	    numberFocusItems:19,
	    // thumbs: [
	    //   {
	    //     'width': 50,
	    //     'height':50
	    //   },{
	    //     'width': 70,
	    //     'height':70
	    //   },{
	    //     'width': 140,
	    //     'height':90
	    //   },
	    //   {
	    //     'width': 180,
	    //     'height':120
	    //   },
	    //   {
	    //     'width': 300,
	    //     'height':170
	    //   },
	    //   {
	    //     'width': 300,
	    //     'height':250
	    //   },
	    //   {
	    //     'width': 350,
	    //     'height':170
	    //   },
	    //   {
	    //     'width': 670,
	    //     'height':447
	    //   },
	    //   {
	    //     'width': 830,
	    //     'height':553
	    //   }
	    // ],
	    state: {
	      'nav-static': false
	    },
	    aiTools:[
	      {
	        name:'Title suggestion',
	        funcionality: 'title-suggestion',
	        stripHtml: 'all',
	        multiple: false,
	        editor: false,
	        displayType: 'block',
	        displayTypeObj: false,
	      },
	      {
	        name:'Page title suggestion',
	        funcionality: 'page-title-suggestion',
	        stripHtml: 'all',
	        multiple: false,
	        editor: false,
	        displayType: 'block',
	        displayTypeObj: false,
	      },
	      {
	        name:'Tags suggestion',
	        funcionality: 'tags-suggestion',
	        stripHtml: 'all',
	        multiple: true,
	        editor: false,
	        displayType: 'inline',
	        displayTypeObj: true,
	      },
	      {
	        name:'Text summary',
	        funcionality: 'text-summary',
	        stripHtml: 'all', 
	        multiple: false,
	        editor: true,
	        displayType: 'block',
	        displayTypeObj: false,
	        twoColumns: false,
	      },
	      {
	        name:'Text expansion',
	        funcionality: 'text-expansion',
	        stripHtml: 'replace-shortcodes',
	        multiple: false,
	        editor: true,
	        displayType: 'block',
	        displayTypeObj: false,
	        twoColumns: true,
	      },
	      {
	        name:'Text reformulation',
	        funcionality: 'text-reformulation',
	        stripHtml: 'replace-shortcodes',
	        multiple: false,
	        editor: true,
	        displayType: 'block',
	        displayTypeObj: false,
	        twoColumns: true,
	      },
	      { 
	        name:'Text correction', 
	        funcionality: 'text-correction',
	        stripHtml: 'replace-shortcodes',
	        multiple: false,
	        editor: true,
	        displayType: 'block',
	        displayTypeObj: false,
	        twoColumns: true,
	        diffText: true,
	      }
	    ],
	    aiEditorsTools:[{
	        name:'Expansion',
	        funcionality:'text-expansion',
	      },
	      {
	        name:'Reformulation',
	        funcionality:'text-reformulation',
	      },
	      {
	        name:'Correction',
	        funcionality:'text-correction',
	      },
	      {
	        name:'Summary',
	        funcionality:'text-summary',
	      }      
	    ]
	  };
	 
	  configFactory.$inject = [];
	  function configFactory() {
	    // return {
	    //    'setConfig': function(data) {
	    //     config.baseMediaHref = data.global.cdn;
	    //     config.refreshTokenInterval = data.global.refreshTokenInterval;
	    //     config.baseHref='http://www.telegraf.rs/';
	    //     config.baseElasticSearchHref = data.global.searchUrl;
	    //     config.thumbs = data.thumbs;
	    //    } 
	    // }
	   return config
	    // var Helpers = function(){
	    //   this._initResizeEvent();
	    //   this._initOnScreenSizeCallbacks();
	    // };
	    // Helpers.prototype = {
	    //   _resizeCallbacks: [],
	    //   _screenSizeCallbacks: {
	    //     xs:{enter:[], exit:[]},
	    //     sm:{enter:[], exit:[]},
	    //     md:{enter:[], exit:[]},
	    //     lg:{enter:[], exit:[]}
	    //   },
	
	    //   /**
	    //    * Checks screen size according to Bootstrap default sizes
	    //    * @param size screen size  ('xs','sm','md','lg')
	    //    * @returns {boolean} whether screen is <code>size</code>
	    //    */
	    //   isScreen: function(size){
	    //     var screenPx = $window.innerWidth;
	    //     return (screenPx >= config.settings.screens[size + '-min'] || size === 'xs') && (screenPx <= config.settings.screens[size + '-max'] || size === 'lg');
	    //   },
	
	    //   /**
	    //    * Returns screen size Bootstrap-like string ('xs','sm','md','lg')
	    //    * @returns {string}
	    //    */
	    //   getScreenSize: function(){
	    //     var screenPx = $window.innerWidth;
	    //     if (screenPx <= config.settings.screens['xs-max']) return 'xs';
	    //     if ((screenPx >= config.settings.screens['sm-min']) && (screenPx <= config.settings.screens['sm-max'])) return 'sm';
	    //     if ((screenPx >= config.settings.screens['md-min']) && (screenPx <= config.settings.screens['md-max'])) return 'md';
	    //     if (screenPx >= config.settings.screens['lg-min']) return 'lg';
	    //   },
	
	    //   /**
	    //    * Specify a function to execute when window entered/exited particular size.
	    //    * @param size ('xs','sm','md','lg')
	    //    * @param fn callback(newScreenSize, prevScreenSize)
	    //    * @param onEnter whether to run a callback when screen enters `size` or exits. true by default @optional
	    //    */
	    //   onScreenSize: function(size, fn, /**Boolean=*/ onEnter){
	    //     onEnter = typeof onEnter !== 'undefined' ? onEnter : true;
	    //     this._screenSizeCallbacks[size][onEnter ? 'enter' : 'exit'].push(fn)
	    //   },
	
	    //   /**
	    //    * Change color brightness
	    //    * @param color
	    //    * @param ratio
	    //    * @param darker
	    //    * @returns {string}
	    //    */
	    //   //credit http://stackoverflow.com/questions/1507931/generate-lighter-darker-color-in-css-using-javascript
	    //   changeColor: function(color, ratio, darker) {
	    //     var pad = function(num, totalChars) {
	    //       var pad = '0';
	    //       num = num + '';
	    //       while (num.length < totalChars) {
	    //         num = pad + num;
	    //       }
	    //       return num;
	    //     };
	    //     // Trim trailing/leading whitespace
	    //     color = color.replace(/^\s*|\s*$/, '');
	
	    //     // Expand three-digit hex
	    //     color = color.replace(
	    //       /^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i,
	    //       '#$1$1$2$2$3$3'
	    //     );
	
	    //     // Calculate ratio
	    //     var difference = Math.round(ratio * 256) * (darker ? -1 : 1),
	    //     // Determine if input is RGB(A)
	    //       rgb = color.match(new RegExp('^rgba?\\(\\s*' +
	    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
	    //         '\\s*,\\s*' +
	    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
	    //         '\\s*,\\s*' +
	    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
	    //         '(?:\\s*,\\s*' +
	    //         '(0|1|0?\\.\\d+))?' +
	    //         '\\s*\\)$'
	    //         , 'i')),
	    //       alpha = !!rgb && rgb[4] !== null ? rgb[4] : null,
	
	    //     // Convert hex to decimal
	    //       decimal = !!rgb? [rgb[1], rgb[2], rgb[3]] : color.replace(
	    //         /^#?([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])/i,
	    //         function() {
	    //           return parseInt(arguments[1], 16) + ',' +
	    //             parseInt(arguments[2], 16) + ',' +
	    //             parseInt(arguments[3], 16);
	    //         }
	    //       ).split(/,/);
	
	    //     // Return RGB(A)
	    //     return !!rgb ?
	    //     'rgb' + (alpha !== null ? 'a' : '') + '(' +
	    //     Math[darker ? 'max' : 'min'](
	    //       parseInt(decimal[0], 10) + difference, darker ? 0 : 255
	    //     ) + ', ' +
	    //     Math[darker ? 'max' : 'min'](
	    //       parseInt(decimal[1], 10) + difference, darker ? 0 : 255
	    //     ) + ', ' +
	    //     Math[darker ? 'max' : 'min'](
	    //       parseInt(decimal[2], 10) + difference, darker ? 0 : 255
	    //     ) +
	    //     (alpha !== null ? ', ' + alpha : '') +
	    //     ')' :
	    //       // Return hex
	    //       [
	    //         '#',
	    //         pad(Math[darker ? 'max' : 'min'](
	    //           parseInt(decimal[0], 10) + difference, darker ? 0 : 255
	    //         ).toString(16), 2),
	    //         pad(Math[darker ? 'max' : 'min'](
	    //           parseInt(decimal[1], 10) + difference, darker ? 0 : 255
	    //         ).toString(16), 2),
	    //         pad(Math[darker ? 'max' : 'min'](
	    //           parseInt(decimal[2], 10) + difference, darker ? 0 : 255
	    //         ).toString(16), 2)
	    //       ].join('');
	    //   },
	    //   lightenColor: function(color, ratio) {
	    //     return this.changeColor(color, ratio, false);
	    //   },
	    //   darkenColor: function(color, ratio) {
	    //     return this.changeColor(color, ratio, true);
	    //   },
	
	    //   max: function(array) {
	    //     return Math.max.apply(null, array);
	    //   },
	
	    //   min: function(array) {
	    //     return Math.min.apply(null, array);
	    //   },
	
	    //   /**
	    //    * Triggers sn:resize event. sn:resize is a convenient way to handle both window resize event and
	    //    * sidebar state change.
	    //    * Fired maximum once in 100 millis
	    //    * @private
	    //    */
	    //   _initResizeEvent: function(){
	    //     var resizeTimeout;
	
	    //     jQuery($window).on('resize', function() {
	    //       $timeout.cancel(resizeTimeout);
	    //       resizeTimeout = $timeout(function(){
	    //         jQuery($window).trigger('sn:resize');
	    //       }, 100);
	    //     });
	    //   },
	
	    //   /**
	    //    * Initiates an array of throttle onScreenSize callbacks.
	    //    * @private
	    //    */
	    //   _initOnScreenSizeCallbacks: function(){
	    //     var resizeTimeout,
	    //       helpers = this,
	    //       prevSize = this.getScreenSize();
	
	    //     jQuery($window).resize(function() {
	    //       $timeout.cancel(resizeTimeout);
	    //       resizeTimeout = $timeout(function(){
	    //         var size = helpers.getScreenSize();
	    //         if (size !== prevSize){ //run only if something changed
	    //           //run exit callbacks first
	    //           helpers._screenSizeCallbacks[prevSize]['exit'].forEach(function(fn){
	    //             fn(size, prevSize);
	    //           });
	    //           //run enter callbacks then
	    //           helpers._screenSizeCallbacks[size]['enter'].forEach(function(fn){
	    //             fn(size, prevSize);
	    //           });
	    //           $log.log('screen changed. new: ' + size + ', old: ' + prevSize);
	    //         }
	    //         prevSize = size;
	    //       }, 100);
	    //     });
	    //   }
	    // };
	
	  
	    // config.helpers = new Helpers();
	    
	  }
	}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var globalHelpers = __webpack_require__(18);
	module.exports = function(app) {
		'use strict'
		app.directive('aiEditorDir',aiEditorDir);
		aiEditorDir.$inject=['$timeout'];
		function aiEditorDir($timeout) {
			return {
				restrict: 'E',
				scope:{
					funcionality: '=',
	                resultFromAi: '=',
	                selectedSuggestion: '=',
	                text: '=',
	                twoColumns: '=',
	                diffText: '='
				},      
				replace:true,
				template: __webpack_require__(235),
				link: function(scope, ele, $attrs, ctrl) {
	                // Remove only summaryblock from original text and store it in a way that won't be affected by editor
	                scope.originalText = {content: scope.text.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '')};
	                // Store original content in a closure to prevent it from being modified
	                scope.aiSuggestion = {content: ''};
	                var originalText = scope.originalText.content;
	                var resultFromAi = scope.resultFromAi;
	                // Watch for changes in the aiSuggestion using a function
	                scope.$watch(function() {
	                    return scope.aiSuggestion.content;
	                }, function(newVal, oldVal) {
	                    // Skip if the value hasn't actually changed
	                    if (newVal === oldVal) {
	                        return;
	                    }
	                    if(scope.funcionality === 'text-summary') {
	                        // Remove any trailing paragraph tags
	                        newVal = newVal.replace(/<p>\s*<\/p>$/, '');
	                        // Replace consecutive paragraph tags with |*|
	                        var formattedText = newVal.replace(/<\/p>\s*<p>/g, '|*|');
	                        // Remove any remaining paragraph tags
	                        formattedText = formattedText.replace(/<\/?p>/g, '');
	                        // Wrap in summary shortcode
	                        scope.selectedSuggestion.value = (formattedText.length > 0) ? '[summary]' + formattedText + '[/summary]' : '';
	                    } else {
	                        if (scope.diffText) {
	                            // Remove diff spans and keep their content
	                            newVal = newVal.replace(/<span class="diff"[^>]*>(.*?)<\/span>/g, '$1');
	                        }
	                        // Clean up any empty paragraphs before setting the value
	                        newVal = newVal.replace(/<p>\s*<\/p>/g, '');
	                        scope.selectedSuggestion.value = newVal;
	                    }
	                });
	                if(scope.funcionality === 'text-summary') {
	                    if(scope.resultFromAi.length > 0) {
	                        // timout is needed for watcher on initial load for mac chrome, it's not needed for other browsers
	                        $timeout(function() {
	                            // Convert array of facts to string with paragraph tags
	                            scope.aiSuggestion.content = scope.resultFromAi.map(function(fact) {
	                                // Remove any existing line breaks and trim
	                                return '<p>' + fact.replace(/[\r\n]+/g, '').trim() + '</p>';
	                            }).join('');
	                        }, 0);
	                    }
	                } else {
	                    // Apply diff highlighting only on initial load if diffText is true
	                    if (scope.diffText) {
	                        $timeout(function() {
	                            scope.aiSuggestion.content = globalHelpers.highlightDifferences(originalText, resultFromAi);
	                        }, 0);
	                    } else {
	                        $timeout(function() {
	                            scope.aiSuggestion.content = scope.resultFromAi;
	                        }, 0);
	                    }
	                }
	
				}       
			}
		}
	}


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers = __webpack_require__(157);
	
	module.exports = function(app) {
		'use strict'
		app.directive('aiModalDir',aiModalDir);
		aiModalDir.$inject=['$rootScope','aiModalService','editorExludeShortcode','stripHtml','$timeout'];
		function aiModalDir($rootScope,aiModalService,editorExludeShortcode,stripHtml,$timeout) {
			return {
				restrict: 'E',
				scope:{
					parent:'=',
	                funcionality: '=',
	                stripHtml: '=',
	                name: '=',
	                text: '=',
					onSubmit: '&',
	                multiple: '=',
	                displayType: '=',   // "block" or "inline"
	                displayTypeObj: '=', // "array of objects" or "array of strings"
	                editor: '=',
	                twoColumns: '=',
	                edit: '=',
	                diffText: '='
				},      
				replace:true,
				template: __webpack_require__(236),
				link: function(scope, ele, $attrs, ctrl) {
	                $rootScope.modalShow = true;
	                scope.loading = true;
	                scope.text = scope.text.replace(/[\r\n]+/g, '').replace(/\<br\s*\/?\>/g, '');
	                var postData = {};
	                var errorTimeoutPromise;
	                function errorTimeout(message) {
	                    errorTimeoutPromise = $timeout(function() {
	                        scope.loading = false;
	                        scope.tryAgain = true;
	                        scope.errorMessage = message || 'Something went wrong, please try again.';
	                    }, 100)
	                }
	                // Initialize selection is object because to can change the value from child directive
	                if (scope.multiple) {
	                    scope.selectedSuggestion = {value: []};
	                } else {
	                    scope.selectedSuggestion = {value: null};
	                }
	                // Initialize selection
	                if(scope.stripHtml == 'all') {
	                    // First remove shortcodes, then strip HTML tags
	                    var text = stripHtml(editorExludeShortcode(scope.text,true));
	                    var postData = {
	                        text: text
	                    }
	                } else if(scope.stripHtml == 'replace-shortcodes') {
	                    var postData = {
	                        text: helpers.replaceShortcodesWithPlaceholders(scope.text)
	                    }
	                }
	                if(!scope.edit) {
	                    aiModalService.get('variables/' + scope.funcionality, function(data) {
	                        if(data.variables && data.variables.length > 0) {
	                            data.variables.forEach(function(variable) {
	                            if(variable == 'keyword') {
	                                helpers.addKeywordToPostData(scope.parent.dataPost.keywords, postData)
	                            } else if(variable == 'keywords') {
	                                helpers.addKeywordsToPostData(scope.parent.dataPost.keywords, postData)
	                            }
	                        });
	                    }
	                        postAiHandler()
	                    }, function(message) {
	                        postAiHandler()
	                    });
	                } else {
	                    scope.loading = false;
	                    if(scope.funcionality == 'text-summary') {
	                        // Extract content between [summary] tags
	                        var summaryMatch = scope.text.match(/\[summary\]([\s\S]*?)\[\/summary\]/);
	                        if (summaryMatch && summaryMatch[1]) {
	                            // Split by |*| and trim each fact
	                            scope.resultFromAi = summaryMatch[1].split('|*|').map(function(fact) {
	                                return fact.trim();
	                            });
	                        } else {
	                            scope.resultFromAi = [];
	                        }
	                    }
	                }
	                function postAiHandler() { 
	                    aiModalService.post(scope.funcionality, postData, function(data) {
	                        if(!data.results || data.results.length == 0 || !data.request_id) {
	                            errorTimeout();
	                        }
	                        // Restore shortcodes in the AI results if we have mappings
	                        if (scope.stripHtml == 'replace-shortcodes') {
	                            scope.resultFromAi = helpers.restoreShortcodes(data.results)
	                        } else {
	                            scope.resultFromAi = data.results;
	                        }
	                        scope.request_id = data.request_id;
	                        scope.loading = false;
	                    }, function(message) {
	                        errorTimeout(message);
	                    });
	                }
	                var cancelAiModalFunction = function() {
	                    $rootScope.modalShow = false;
	                    scope.parent.showAiModal = null;
	                    scope.parent.aiToolsObj = null;
	                }
	                scope.cancelAiModal = function() {
	                    cancelAiModalFunction();
	                    if(!scope.edit) {
	                        if(scope.request_id) {
	                            aiModalService.post('feedback', {
	                                request_id: scope.request_id,
	                                feedback: 0
	                            });
	                        }
	                    }
	                }
	                scope.applyAiHandler = function() {
	                    cancelAiModalFunction();
	                    if(!scope.edit) {
	                        if(scope.request_id) {
	                            aiModalService.post('feedback', {
	                                request_id: scope.request_id,
	                                feedback: 1
	                            });
	                        }
	                    }
	                    scope.onSubmit({funcionality: scope.funcionality, selectedSuggestion: scope.selectedSuggestion.value});
	                }
	                scope.tryAgainHandler = function() {
	                    scope.loading = true;
	                    scope.tryAgain = false;
	                    scope.errorMessage = null;
	                    postAiHandler()
	                }
	                
					// Add scope cleanup
					scope.$on('$destroy', function() {
						if (errorTimeoutPromise) {
							$timeout.cancel(errorTimeoutPromise);
						}
						$rootScope.modalShow = false;
					});
				}       
			}
		}
	}


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers = __webpack_require__(157);
	
	module.exports = function(app) {
		'use strict'
		app.directive('aiRecommendationsDir',aiRecommendationsDir);
		aiRecommendationsDir.$inject=['$rootScope','aiModalService','editorExludeShortcode','stripHtml','$timeout','$http','API_URL'];
		function aiRecommendationsDir($rootScope,aiModalService,editorExludeShortcode,stripHtml,$timeout,$http,API_URL) {
			return {
				restrict: 'E',
				scope:{
					funcionality: '=',
	                multiple: '=',
	                displayType: '=',   // "block" or "inline"
	                displayTypeObj: '=', // "array of objects" or "array of strings"
	                resultFromAi: '=',
	                selectedSuggestion: '='
				},      
				replace:true,
				template: __webpack_require__(237),
				link: function(scope, ele, $attrs, ctrl) {
	                scope.recommendations = scope.resultFromAi;
	                if(scope.funcionality == 'tags-suggestion') {
	                    scope.selectedSuggestion.value = scope.recommendations.filter(function(tag){
	                        return tag.exists;
	                    });
	                }
	                scope.isActive = function(rec) {
	                    if (scope.multiple) {
	                        return (scope.selectedSuggestion.value || []).some(function(selected) {
	                            return scope.displayTypeObj ? selected.name === rec.name : selected === rec;
	                        });
	                    } else {
	                        return scope.displayTypeObj 
	                            ? (scope.selectedSuggestion.value && scope.selectedSuggestion.value.name === rec.name)
	                            : scope.selectedSuggestion.value === rec;
	                    }
	                };
	                scope.toggleRecommendation = function(rec) {
	                    if (scope.multiple) {
	                        scope.selectedSuggestion.value = scope.selectedSuggestion.value || [];
	                        var idx = scope.selectedSuggestion.value.findIndex(function(selected) {
	                            return scope.displayTypeObj ? selected.name === rec.name : selected === rec;
	                        });
	                        if (idx === -1) {
	                            scope.selectedSuggestion.value.push(rec);
	                        } else {
	                            scope.selectedSuggestion.value.splice(idx, 1);
	                        }
	                    } else {
	                        scope.selectedSuggestion.value = rec;
	                    }
	                };
				}       
			}
		}
	}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('addApprovalDir',addApprovalDir);
		addApprovalDir.$inject=['API_URL','refreshtokenService','alertService','serverError','postDataService', 'offlineError', 'authtokenService','$rootScope','downloadPdf'];
		function addApprovalDir(API_URL,refreshtokenService, alertService,serverError, postDataService, offlineError,authtokenService, $rootScope, downloadPdf) {
			return {
				restrict: 'E',
	            scope:{
					parent:'=',
	                bulk:'=',
					type:'='
				},
				replace:true,
				template: __webpack_require__(238),
				link: function(scope, ele, $attrs, ctrl) {
	                scope.titleRequired = false;
	                if(scope.bulk) {
	                    scope.ids = scope.$parent.idsForApproval
						scope.approvals = [];
	                } else {
						scope.id = scope.parent._id
	                    scope.ids = [scope.parent._id]
						scope.approvals = scope.parent.approvals || [];
	                }
					var token = authtokenService.getToken();
					scope.dzOptionsApproval = {
				        url : API_URL + 'approvals/upload/' + scope.type,
				        paramName : 'pdf',
				        maxFilesize : '500',
				        parallelUploads: 1,
				        uploadMultiple: false,
				        acceptedFiles : '.pdf',
				        addRemoveLinks : true,
				        autoProcessQueue : false,
				        dictInvalidFileType: 'This file type is not supported.',
				        dictFileTooBig:'File size too Big',
				        dictDefaultMessage : "Drop approval pdf here to upload",
				        headers:{
				          'x-auth': token  
				        },
				        
				    };
				    scope.dzCallbacksApproval = {
				        'addedfile' : function(file){
				        	if(scope.newFileApproval) {
				        		scope.dzMethodsApproval.removeFile(scope.newFileApproval);
				        	}
	                        if(scope.title) {
	                            var promise = refreshtokenService.getAccessToken();
	                            promise.then(
	                                function(answer) {
	                                    token = authtokenService.getToken();
	                                    scope.dzOptionsApproval.headers['x-auth'] = token;
	                                    scope.dzMethodsApproval.processQueue();
	                                    scope.newFileApproval = file;
	                                },
	                                function(error) {
	                                // report something
	                                },
	                                function(progress) {
	                                // report progress
	                            });
	                        } else {
	                            scope.titleRequired = true;
	                            scope.dzMethodsApproval.removeFile(file);
	                            alertService('danger','Opps! ', 'Approval title is required');
	                        }
				        },
				        'success' : function(file, xhr, response){
				       		var data = JSON.parse(response.currentTarget.response);
				       		scope.approvals.push(data.results[0]);
				        },
				        'error' : function(file,message) {
				            // console.log(response.xhr.status);
							if(message && message.error && message.error.message) {
								jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
							}
				        },
				        'sending':function(file, xhr, formData) {
	                        formData.append('document_ids', scope.ids);
	                        formData.append('type', scope.type);
	                        formData.append('title', scope.title);
				        }
				    };
					scope.dzMethodsApproval = {
						//   'getUploadingFiles':function(files) {
						//     console.log(files);
						// }
					};
					scope.loadUrlforDropzone = true;
	                scope.removeApproval = function(approval, index) {
						$rootScope.hasLoaded = false;	
					    postDataService.save({
				          param1:'approvals',
	                      param2:'remove',
				          param3:approval._id,
				        },{
				        	'document_id': scope.id,
	                        'type': scope.type
	
				        }).$promise.then(function(data){
				        	$rootScope.hasLoaded = true;
							alertService('success','Success ', data.message, 2000);
							scope.approvals.splice(index, 1);
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				          	if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {
									  scope.removeApproval(approval, index);
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
								// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
				        });
				    }
					scope.downloadApproval = downloadPdf
				}
			}
		}
	}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('addPostToExchange',addPostToExchange);
		addPostToExchange.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService', 'offlineError'];
		function addPostToExchange($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, offlineError) {
			return {
				restrict: 'E',
				template: __webpack_require__(239),
				link: function(scope, ele, $attrs, ctrl) {
					scope.config = config;
					scope.sharedCategory = angular.copy(scope.config.shared_contents[scope.typeAddToExchange])
					scope.addPostToExchange = function(type,postId) {
						var arr = []
						for(var i = 0; i<scope.sharedCategory.length;i++) {
							if(scope.sharedCategory[i].checked && !scope.sharedCategory[i].disabled) {
								arr.push(scope.sharedCategory[i]['_id'])
							}
						}
						if(arr.length==0) {
							alertService('danger', 'Opps! ', 'Shared content is required!');
							return
						} else {
							var postData = {
								category: arr
							}
							var postFunction = function() {   
								postDataService.save({
								param1:'shared-contents',
								param2:scope.typeAddToExchange,
								param3:postId 
								},postData).$promise.then(function(postData){
								alertService('success','Success ', postData.message, 2000);
								$timeout(function() {
									scope.closeAddPostToExchangeModal()
								},0)
								}, function(error){
									if(!window.navigator.onLine) {
										offlineError()
										$rootScope.hasLoaded = true;
										alertService('danger','Opps! ', 'Please check your internet connection and try again.');
										return
									}
									if(error.status ==401) {
										var promise = refreshtokenService.getAccessToken();
										promise.then(
										function(answer) {
											if(answer==200) {   
											postFunction();
											}
										},
										function(error) {
											// report something
										},
										function(progress) {
											// report progress
										});
									}else if(error.status ==502) {
										serverError();
									} else {
									alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
									}
								});
							}
							postFunction();
						}
					}
					var getCurrentCategory = function() {
						scope.loaded = false;
						getDataService.get({param1:'shared-contents', param2: scope.typeAddToExchange, param3:scope.typeAddToExchangePostId}).$promise.then(function(data){  
							scope.loaded = true;
							if(data.category && data.category.length>0) {
									for(var i=0; i<data.category.length;i++) {
									  for(var item = 0; item<scope.sharedCategory.length;item++) {
										  if(data.category[i] == scope.sharedCategory[item]['_id']) {
											  scope.sharedCategory[item].disabled= true;
											  scope.sharedCategory[item].checked= true;
										  }
									  }
								  }
								   
							}
							
						}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								return
							}
						  	if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {
										getCurrentCategory()
									}
								},
								function(error) {
								},
								function(progress) {
								// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
						  
						});
					}
					getCurrentCategory()
				}
			}
		}
	}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = function(focus) {
		"use strict";
	  focus
	  .directive('autoCompleteDir',autoCompleteDir);
		autoCompleteDir.$inject = ['$timeout','getDataService','$compile','refreshtokenService','serverError','alertService','keyPress','jQuery', 'postDataService', 'offlineError'];
	  function autoCompleteDir($timeout,getDataService,$compile, refreshtokenService,serverError,alertService,keyPress,jQuery, postDataService, offlineError) {
	    return {
	      scope:{
	        datachangelabel:'=',
	        datachangeid:'=',
	        currentTag: '=',
	        typeDir:'=',
	        enterTag:'&'
	      },
	      require: 'ngModel',
	      link: function(scope, element, attrs, ngModel) {
	        var s;
	        var html = angular.element(document.getElementById('template.html')).html();
	        element.after($compile(html)(scope));
	        scope.showDropdown = false;
	        var index = -1;
	        scope.autocompleteView = true; 
	        scope.chooseSearchData = function(dataName,dataId, dataUrl) {
	          ngModel.$setViewValue(dataName);
	          element.val(dataName);
	          scope.showDropdown = false;
	          scope.activeTag = false;
	          scope.datachangelabel = dataName;
	          scope.datachangeid = dataId;
	          scope.tagsTree = [];
	          if(scope.typeDir == 'insertTag') {
	            scope.selectedTagObj = {
	              tagUrl: dataUrl
	            }
	          } else {
	            scope.selectedTagObj = {
	              tagId:dataId,
	              tagName:dataName,
	              tagUrl: dataUrl
	            }
	          }
	          // element.focus();
	          // scope.enterTag();
	          if(scope.typeDir == 'insertTag') {
	            scope.$emit('editor-select-tag', {selectedTagObj:scope.selectedTagObj});
	          } else if(scope.typeDir=='insertTagRecomendedNews') {
	            scope.$emit('recommended-news-select-tag', {selectedTagObj:scope.selectedTagObj});
	          } else {
	            scope.$emit('select-tag', {selectedTagObj:scope.selectedTagObj});
	          }
	        };
	        function mouseDown(e) {
	          if(!scope.autocompleteView) return;
	          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	          if (!container.is(e.target) // if the target of the click isn't the container...
	            && container.has(e.target).length === 0 && scope.showDropdown && !serch_input.is(e.target) && serch_input.has(e.target).length===0 && !element.is(e.target)) // ... nor a descendant of the container
	          {
	            scope.$apply(function () {
	              if(!scope.activeTag && scope.typeDir=='menu') {
	                ngModel.$setViewValue(null);
	                element.val(null);
	              }
	              scope.showDropdown = false;
	              scope.tagsTree = [];
	              index= -1;
	            });
	          }}
	        }
	        angular.element(document).on('mousedown', mouseDown);
	        element.on('keydown', function(event) {
	          if(scope.showResult) {
	            if(event.which === 40) {
	              if(index >=scope.tagsTree.length-1) {
	                index = -1
	              }
	              index++
	              for(var i=0; i<scope.tagsTree.length;i++) {
	                 scope.$apply(function () {
	                  scope.tagsTree[i].active = false;
	                 })
	                if(index==i) {
	                  scope.$apply(function () {
	                    scope.tagsTree[index].active = true;
	                  });  
	                }
	              }
	            } else if(event.which === 38) {
	              if(index <= 0) {
	                index=scope.tagsTree.length
	              }
	              index--
	              for(var i=0; i<scope.tagsTree.length;i++) {
	                 scope.$apply(function () {
	                  scope.tagsTree[i].active = false;
	                 })
	                if(index==i) {
	                  scope.$apply(function () {
	                    scope.tagsTree[index].active = true;
	                  });  
	                }
	              }
	            }
	          }
	        });
	        element.on('keypress', function(event) {
	          // scope.showDropdown = false; 
	          if(event.which === 13) {
	            scope.activeTag = false;
	            if(scope.tagsTree && scope.tagsTree.length>0) {
	              for(var i=0; i<scope.tagsTree.length;i++) {
	                if(scope.tagsTree[i].active) {
	                  $timeout(function() {
	                    scope.chooseSearchData(scope.tagsTree[i].name,scope.tagsTree[i]._id, scope.tagsTree[i].url);
	                  },0)
	                  scope.activeTag = true;
	                  return 
	                }
	              }
	            }
	            if(!scope.activeTag) {
	              if(scope.typeDir =='focus') {
	                  scope.$apply(function () {
	                  ngModel.$setViewValue(null);
	                  element.val(null);
	                  scope.showDropdown = false;
	                  scope.activeTag = false;
	                  scope.datachangelabel = null;
	                  scope.datachangeid = null;
	                })
	              } else if(scope.typeDir =='menu'){
	                scope.$apply(function () {
	                  ngModel.$setViewValue(null);
	                  element.val(null);
	                  scope.showDropdown = false;
	                  scope.activeTag = false;
	                })
	              } else {
	                if(scope.typeDir !='insertTag' && scope.typeDir !='mergeTag' && scope.typeDir !='catalogTag' && scope.typeDir!='insertTagRecomendedNews') {
	                  scope.$apply(function () {
	                    scope.enterTag();
	                    scope.showDropdown = false;
	                  })
	                }
	              }
	            }
	          }
	          keyPress(event);
	        });
	        var getFunction = function(type) {
	          getDataService.get({param1:(type=='video')? 'video-tags':(type=="catalogTag")?'catalogs':'tags',param2:(type=="catalogTag")?'tags':undefined, param3:'search', s:ngModel.$viewValue}).$promise.then(function(data){
	            if(!ngModel.$viewValue || ngModel.$viewValue.length<2) return;
	            index = -1;
	            scope.tagsTree = data.tags;
	            scope.tagsTree = scope.tagsTree.slice(0,30);
	            if(scope.tagsTree.length > 0) {
	              scope.showResult = true;
	              for(var i=0; i<scope.tagsTree.length;i++) {
	                scope.tagsTree[i].active = false;
	              }
	              if(scope.typeDir == 'focus' || scope.typeDir=='menu') {
	                scope.tagsTree[0].active = true;
	                index= 0;
	              }
	            } else {
	              scope.showResult = false;
	            }
	            scope.showDropdown = true;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              scope.showDropdown =false;
	              index= -1;
	              return
	            }
	            if(error.status == 401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getFunction(type);
	                }
	                // do something
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }  
	          });
	        }
	        if(scope.typeDir == 'insertTag') {
	          setTimeout(function(){
	            getFunction(scope.typeDir)
	          },0)
	        }
	        element.on('keyup', function(event) {
	          if(ngModel.$viewValue && ngModel.$viewValue.length >=2) {
	            if(event.which != 38 && event.which != 40 && event.which != 13) {
	              getFunction(scope.typeDir);
	            }
	          } else {
	            scope.$apply(function () {
	              scope.showDropdown =false;
	              index= -1;
	            })
	          }
	        });
	        scope.$on('$destroy', function() {
	          scope.autocompleteView = null;
	          angular.element(document).off('mousedown', mouseDown);
	        })
	      }
	    };
	  }	
	}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app.directive('autoHeight', autoHeight);
		autoHeight.$inject=[];
		function autoHeight() {
			return {
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {
					scope.$watch(function () {
		                return ngModel.$modelValue;
		            }, function(newValue) {
		            	if(newValue) {
			                function resize () {
		                		element[0].style.overflow = 'hidden';
					            element[0].style.height = 'auto';
					            element[0].style.height = element[0].scrollHeight+'px';
						    }
		                	setTimeout(function() {
					    		resize()
		                	},0) 
		            	}
		            }); 
		        }
		    }
		}	
	}


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		'use strict'
		app.directive('bulkDeleteDir',bulkDeleteDir);
		bulkDeleteDir.$inject=['$rootScope','postDataService','refreshtokenService','alertService','serverError','offlineError'];
		function bulkDeleteDir($rootScope, postDataService, refreshtokenService, alertService,serverError,offlineError) {
			return {
				scope:{
					objdata:'=',
					state1:'=',
					state2:'=',
					ids:'=',
					successUpdateFunc:"="	
				},
				link: function(scope, element, attrs,ctrl) {
	                scope.objdata.bulkAction = function(param) {
	                    if(param == 'delete' && scope.ids.length>0 ) {
	                        var postFunction = function() {
	                        $rootScope.hasLoaded = true;
	                        postDataService.save({ 
	                            param1: scope.state1,
	                            param2: (scope.state2)?scope.state2:undefined,
	                            param3:'bulk',
	                            param4: 'delete'
	                        },{
	                            'ids':scope.ids,
	                        }).$promise.then(function(bulkDelete){
	                            alertService('success','Success ', bulkDelete.message, 2000);
	                            $rootScope.hasLoaded = true;
	                            if(scope.successUpdateFunc) {
	                                scope.successUpdateFunc('update')
	                            }
	                        }, function(error){
	                            if(!window.navigator.onLine) {
	                              offlineError()
	                              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                              return
	                            } 
	                            if(error.status ==401) {
	                              var promise = refreshtokenService.getAccessToken();
	                              promise.then(
	                                function(answer) {
	                                  if(answer==200) {   
	                                    postFunction();
	                                  }
	                                },
	                                function(error) {
	                                },
	                                function(progress) {
	                                 // report progress
	                              });
	                            } else if(error.status ==502) {
	                              serverError()
	                            }  else {
	                              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                            } 
	                            $rootScope.hasLoaded = true;
	                          });
	                        }
	                        postFunction();
	                    }
	                }
				}
	
			}
		}
	}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('categoryAccordion',categoryAccordion);
		categoryAccordion.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
		function categoryAccordion($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
			return {
				restrict: 'E',
				scope:{
					parent:'=',
					categories:'=',
					parentCategory:'=',
					open:'='
				},
				replace:true,
				template: __webpack_require__(240),
				link: function(scope, ele, $attrs, ctrl) {
					var parentCategoriesFunc= function(parent,onLoad) {
						if(parent.parentCategory) {
							scope.parent.parentCategoriesChecked[parent.parentCategory._id] = true
							if(onLoad) {
								parent.parentCategory.open = true;
								if(!parent.parentCategory.visible) {
									parent.parentCategory.visible= true;
								}
							}
						}
						if(parent.$parent) {
							if(onLoad) {
								parentCategoriesFunc(parent.$parent,true)
							} else {
								parentCategoriesFunc(parent.$parent)
							}
						}
					}
					scope.$watch(function(){
						return scope.parent.categoryIdOnLoad
					  }, function(newValue, oldValue){
						if (newValue && newValue !== oldValue) {
							if(scope.categories && scope.categories.length>0) {
								onloadLoop:
								for (var i=0; i<scope.categories.length; i++){
									if(scope.categories[i]._id == newValue) {
										scope.parent.categorychecked[newValue] = true;
										scope.parent.category = newValue;
										if(!scope.categories[i].visible) {
											scope.categories[i].visible = true;
										}
										if(scope.parentCategory) {
											scope.parent.parentCategoriesChecked[scope.parentCategory._id]=true;
											scope.parentCategory.open = true;
											if(!scope.parentCategory.visible) {
												scope.parentCategory.visible = true;
											}
											parentCategoriesFunc(scope.$parent, true)
										}
										$timeout(function() {
											var checkedCategory = jQuery(".checkedEditPost");
											if(checkedCategory.length != 0) {
												var topPos = checkedCategory[0].offsetTop;
												jQuery('#categoryscroll').animate({scrollTop: topPos-2},600);
											}
										},300)
										break onloadLoop
									}
								}
							}
						}
						
					},true);
					scope.updateSelection = function(category_id, checked, categoryObj,event) {
						if(categoryObj.children && categoryObj.children.length > 0) {
						  	event.preventDefault();
						  	categoryObj.open = !categoryObj.open
						  	return
						};
						var updateSelectionTree = function(categories) {
						  	if(checked) {
								scope.parent.parentCategoriesChecked = {}
								scope.parent.categorychecked = {};
								for (var i=0; i<categories.length; i++){
									if (categories[i]._id === category_id) {
										scope.parent.categorychecked[category_id] = true;
										scope.parent.category = category_id;
										if(scope.parentCategory) {
											scope.parent.parentCategoriesChecked[scope.parentCategory._id]=true;
											parentCategoriesFunc(scope.$parent)
										}
										break
									}
								}
						  	} else {
								scope.parent.category = null;
								scope.parent.categorychecked = {};
								scope.parent.parentCategoriesChecked= {};
						  	}
						}
						updateSelectionTree(scope.categories);   
					}
				}
			}
		}
	}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('characterCount',characterCount);
		characterCount.$inject = ['config','$compile'];
	  function characterCount(config,$compile) {
	    return {
	        restrict: 'A',
			scope: {
			    ngModel: '=',
	            decode:'='
			},
	        link: function(scope, element, attrs, ngModel) {
	            var html = '<div class="character-count" ng-class="{\'warning\': characterCountLength<=limitCharacter && characterCountLength>limitCharacter-warningLimitCharacter, \'danger\': characterCountLength>limitCharacter || characterCountLength<limitCharacterMin}" ng-show="characterCountLength > 0">{{characterCountLength}}</div>';
	            if(attrs.limitCharacter) {
	                scope.limitCharacter = parseInt(attrs.limitCharacter);
	            } else {
	                scope.limitCharacter = config.limitCharacter
	            }
	            if(attrs.limitCharacterMin) {
	                scope.limitCharacterMin = parseInt(attrs.limitCharacterMin)
	            } else {
	                scope.limitCharacterMin = config.limitCharacterMin;
	            }
	            if(attrs.warningLimitCharacter) {
	                scope.warningLimitCharacter = parseInt(attrs.warningLimitCharacter)
	            } else {
	                scope.warningLimitCharacter = 30
	            }
	            if(attrs.category =="bbc") {
	                scope.limitCharacter = 1000;   
	            }
	            if(attrs.stopTyping) {
	                scope.stopTyping = parseInt(attrs.stopTyping)
	                angular.element(element).on("keypress", function(e) {
	                    if (scope.ngModel && scope.ngModel.length == scope.stopTyping) e.preventDefault();
	                });
	            }
	            element.after($compile(html)(scope));
	            scope.$watch(function () {
	                return scope.ngModel;
	            }, function(newValue) {
	                if (newValue === null || newValue === undefined) return;
	                if(scope.decode) {
	                    scope.characterCountLength = newValue.replace(/"/g, '&quot;').length;
	                } else {
	                    scope.characterCountLength = newValue.length;
	                }
	                if(attrs.exceedName) {
	                    if(scope.characterCountLength>scope.limitCharacter) {
	                        if(attrs.characterCount) {
	                            scope.$parent['vm'+attrs.characterCount][attrs.exceedName + 'Exceed'] = true;
	                        } else {
	                            scope.$parent[attrs.exceedName + 'Exceed'] = true
	                        }
	                    } else {
	                        if(attrs.characterCount) {
	                            scope.$parent['vm'+attrs.characterCount][attrs.exceedName + 'Exceed'] = false;
	                        } else {
	                            scope.$parent[attrs.exceedName + 'Exceed'] = false
	                        }
	                    }
	                }
	            }); 
	        }
	    };
	  }	
	}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('checkedListItemDir',checkedListItemDir);
		checkedListItemDir.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
		function checkedListItemDir($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
			return {
				restrict: 'E',
				scope:{
					parent:'=',
					type:'=',
					list:'=',
					multiUpdate:'='
				},
				replace:true,
				template: __webpack_require__(241),
				link: function(scope, ele, $attrs, ctrl) {
					scope.itemChecked = {item: {}};
					function scrollElement() {
						$timeout(function() {
							var checkedItem = jQuery(".checkedEditPost"+ scope.type);
							if(checkedItem.length != 0) {
								var topPos = checkedItem[0].offsetTop;
								jQuery('#'+ scope.type + 'scroll').animate({scrollTop: topPos-2},600);
							}
							scope.scrollElement = true;
						},300)
					}
					scope.$watch(function(){
						return scope.list
					  }, function(newValue, oldValue){
						if (newValue && newValue !== oldValue) {
							// race condition
							if(scope.parent[scope.type + 'OnLoad']) {
								scrollElement()
							}
						}
						
					},true);
					scope.$watch(function(){
						return scope.parent[scope.type + 'OnLoad']
					  }, function(newValue, oldValue){
						if (newValue && newValue !== oldValue) {
							if(scope.multiUpdate) {
								for (var i =0; i<newValue.length;i++) {
									scope.itemChecked.item[newValue[i]] = true;
								}
							} else {
								scope.itemChecked.item[newValue] = true;
							}
							// race condition
							if(scope.list && scope.list.length>0) {
								scrollElement()
							}
						}
						
					},true);
					scope.updateSelection = function(id, checked) {
						if(checked) {
							if(scope.multiUpdate) {
								scope.parent[scope.type].push(id)
							} else {
								for (var i=0; i<scope.list.length; i++){
									if (scope.list[i]._id !== id) {
										scope.itemChecked.item[scope.list[i]._id] = false;
									}
								}
								scope.parent[scope.type] = id;
							}
						} else {
							if(scope.multiUpdate) {
								scope.parent[scope.type].splice(scope.parent[scope.type].indexOf(id),1)
							} else {
								scope.parent[scope.type] = null;
							}
						}
					}
				}
			}
		}
	}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app.directive('convertToNumber', convertToNumber);
		convertToNumber.$inject=[];
		function convertToNumber() {
			return {
				require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
	                ngModel.$parsers.push(function(val) {
	                    return parseInt(val, 10);
	                });
	                ngModel.$formatters.push(function(val) {
	                    return '' + val;
	                });
	            }
		    }
		}	
	}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		'use strict'
		app.directive('deleteItemDir',deleteItemDir);
		deleteItemDir.$inject=['$rootScope','deleteDataService','refreshtokenService','alertService','serverError','offlineError'];
		function deleteItemDir($rootScope, deleteDataService, refreshtokenService, alertService,serverError,offlineError) {
			return {
				scope:{
					state1:'=',
					state2:'=',
					eleId:'=',
					successDeleteFunc:"="	
				},
	            replace:true,
	            template:'<li><span class="clickable clickable-danger" ng-click="deleteItem()">Delete</span>&nbsp;|</li>',
				link: function(scope, element, attrs,ctrl) {
	                scope.deleteItem = function(tagId) {
	                    var deleteFunction = function() {
	                      deleteDataService.remove({
	                        param1: scope.state1,
	                        param2: (scope.state2)?scope.state2:undefined, 
	                        param3: scope.eleId
	                      }).$promise.then(function(postTag){ 
	                        alertService('success','Success ', postTag.message, 2000);
	                        $rootScope.hasLoaded = true;
	                        if(scope.successDeleteFunc) {
	                            scope.successDeleteFunc('update')
	                        }
	                      }, function(error){
	                        if(!window.navigator.onLine) {
	                          offlineError()
	                          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                          return
	                        }
	                        if(error.status ==401) {
	                          var promise = refreshtokenService.getAccessToken();
	                          promise.then(
	                            function(answer) {
	                              if(answer==200) {   
	                               deleteFunction();
	                              }
	                            },
	                            function(error) {
	                              // report something
	                            },
	                            function(progress) {
	                             // report progress
	                          });
	                        } else if(error.status ==502) {
	                          serverError();
	                        } else {
	                          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                        }  
	                      });
	                    }
	                    deleteFunction();
	                }
			  		
				}
	
			}
		}
	}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		"use strict";
	    app
	    .directive('highlightedChar',highlightedChar);
	    highlightedChar.$inject = [];
	    function highlightedChar() {
	        return {
	            restrict: 'E',
	            scope: {
	                text: '=',
	                decode:'=',
	                limitCharacter:"=",
	                limitCharacterMin:"="
	            },
	            replace:true,
	            template:'<div class="highlighted-text-inner"><span ng-class="{\'danger-color\':index<25}">{{textSubceed}}</span><span ng-if="textExceed.length>0" class="danger-color">{{textExceed}}</span></div>',
	            link: function(scope) {
	                scope.textSubceed='';
	                scope.textExceed = '';
	                scope.index = 0;
	                if(!scope.limitCharacterMin) {
	                    scope.limitCharacterMin = 0
	                }
	                var textArray;
	                scope.$watch(function () {
	                    return scope.text;
	                }, function(newValue) {
	                    if (newValue === null || newValue === undefined) return;
	                    scope.textSubceed=''
	                    scope.textExceed = ''
	                    textArray = newValue.split('');
	                    scope.index = 0;
	                    for (var i = 0; i<textArray.length;i++) {
	                        if(textArray[i] == '"' && scope.decode) {
	                            scope.index +=6
	                        } else {
	                            scope.index ++
	                        }
	                        if(scope.index<=scope.limitCharacter) {
	                            scope.textSubceed += textArray[i]
	                        } else {
	                            scope.textExceed += textArray[i]
	                        }
	                    }
	                })
	            }
	        }
	    }	
	}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('keywordsDir',keywordsDir);
		keywordsDir.$inject=['$http', '$timeout', '$rootScope','editorExludeShortcode'];
		function keywordsDir($http, $timeout, $rootScope,editorExludeShortcode) {
			return {
				restrict: 'E',
				scope:{
					parent:'=',
	                keyWordsList:'=',
					content: '=',
					postTitle: '=',
					update: '='
				},  
				replace:true,
				template: __webpack_require__(242),
				link: function(scope, ele, $attrs, ctrl) {
	
					scope.isCollapsed = false;
					scope.newKeyword = '';
					scope.manualKeyword = '';
					// watch for update keywords
					scope.$watch('update', function(newVal) {
						if (newVal) {
							scope.ensureMainKeyword();
							updateKeywordCounts();
						}
					});
	
					// Modify the content/title watch to only run if we have keywords
					scope.$watch(function() {
						return {
							content: scope.content || (scope.parent && scope.parent.tinymceModel),
							title: scope.postTitle || (scope.parent && scope.parent.dataPost.title)
						};
					}, function(newVal, oldVal) {
						if (scope.keyWordsList && scope.keyWordsList.length) {
							updateKeywordCounts();
						}
					}, true);
	
					// Add these to the top of link function
					scope.MAX_KEYWORDS = 10;
					scope.suggestionsError = '';
					scope.manualError = '';
	
					// Search Google Suggestions
					scope.searchGoogleSuggestions = function() {
						if (!scope.newKeyword) return;
						
						// Show error only if we're already at max when starting the search
						if (scope.keyWordsList.length >= scope.MAX_KEYWORDS) {
							scope.suggestionsError = 'Maximum number of keywords (' + scope.MAX_KEYWORDS + ') reached';
							scope.newKeyword = '';
							$timeout(function() {
								scope.suggestionsError = '';
							}, 3000);
							return;
						}
						
						var url = 'https://suggestqueries.google.com/complete/search';
						
						$http.jsonp(url, {
							params: {
								q: scope.newKeyword,
								client: 'chrome',
								hl: 'sr',
								jsonp: 'JSON_CALLBACK'
							}
						}).then(function(response) {
							if (response.data && Array.isArray(response.data[1])) {
								// Create array with searched keyword as first item
								var suggestions = [scope.newKeyword].concat(response.data[1]);
								
								// Add suggestions until we reach the limit
								suggestions.forEach(function(suggestion) {
									if (scope.keyWordsList.length < scope.MAX_KEYWORDS && !keywordExists(suggestion)) {
										scope.keyWordsList.push(createKeyword(suggestion, scope.keyWordsList.length === 0));
									}
								});
								
								scope.newKeyword = '';
								updateKeywordCounts();
							}
						}).catch(function(error) {
							alertService('danger','Opps! ', 'Error fetching suggestions:' + error);
						});
					};
	
					// This function checks for duplicates
					function keywordExists(keyword) {
						if (!keyword) return true; // Prevent empty keywords
						
						var normalizedNewKeyword = keyword.toLowerCase().trim();
						return scope.keyWordsList.some(function(item) {
							return item.name.toLowerCase().trim() === normalizedNewKeyword;
						});
					}
	
					// Add helper function to create keyword objects
					function createKeyword(name, isFirst) {
						return {
							name: name.trim().toLowerCase(),
							isMain: isFirst, // Will be main if it's the first keyword
							counts: {
								h1: 0,
								h2h3: 0,
								p: 0
							}
						};
					}
	
					// Add manual keyword
					scope.addManualKeyword = function() {
						// Clear manual error
						scope.manualError = '';
	
						// Check for max keywords first
						if (scope.keyWordsList.length >= scope.MAX_KEYWORDS) {
							scope.manualError = 'Maximum number of keywords (' + scope.MAX_KEYWORDS + ') reached';
							scope.manualKeyword = '';
							$timeout(function() {
								scope.manualError = '';
							}, 3000);
							return;
						}
	
						if (!scope.manualKeyword || keywordExists(scope.manualKeyword)) {
							if (scope.manualKeyword && keywordExists(scope.manualKeyword)) {
								scope.existKeyword = true;
								$timeout(function() {
									scope.existKeyword = false;
								}, 2000);
							}
							return;
						}
						
						scope.keyWordsList.push(createKeyword(scope.manualKeyword, scope.keyWordsList.length === 0));
						scope.manualKeyword = '';
						scope.existKeyword = false;
						updateKeywordCounts();
					};
	
					// Add this function to ensure one keyword is always main
					scope.ensureMainKeyword = function() {
						if (!scope.keyWordsList.length) return;
						
						// Check if there's any main keyword
						var hasMain = scope.keyWordsList.some(function(keyword) {
							return keyword.isMain;
						});
						
						// If no main keyword, set the first one as main
						if (!hasMain) {
							scope.keyWordsList[0].isMain = true;
						}
					};
	
					// Modify setMainKeyword to ensure we can't uncheck the last main keyword
					scope.setMainKeyword = function(selectedKeyword) {
						// Set all keywords to not main
						scope.keyWordsList.forEach(function(keyword) {
							keyword.isMain = false;
						});
						
						// Set the selected keyword as main
						selectedKeyword.isMain = true;
						updateKeywordCounts();
					};
	
					// Call ensureMainKeyword when loading keywords from backend
					scope.$watch('keyWordsList', function(newVal) {
						if (newVal && newVal.length) {
							scope.ensureMainKeyword();
						}
					}, true);
	
					// Modify removeKeyword to handle main keyword removal
					scope.removeKeyword = function(index) {
						var wasMain = scope.keyWordsList[index].isMain;
						scope.keyWordsList.splice(index, 1);
						
						// If we removed the main keyword and there are other keywords,
						// make the first remaining keyword main
						if (wasMain && scope.keyWordsList.length > 0) {
							scope.keyWordsList[0].isMain = true;
						}
						
						updateKeywordCounts();
					};
	
					// Cache the textarea element
					var textareaElement = document.createElement("textarea");
					// Normalize Serbian characters because we can got different encoding for same character (copy/paste from word, notepad, chrome, safari, etc.)
					function normalizeSerbian(text) {
						return text
							.replace(/\u0107/g, 'ć')  // ć variants -> ć
							.replace(/\u010D/g, 'č')  // č variants -> č
							.replace(/\u017E/g, 'ž')  // ž variants -> ž
							.replace(/\u0161/g, 'š')  // š variants -> š
							.replace(/\u00F0/g, 'đ')  // ð -> đ
							.replace(/\u0111/g, 'đ'); // đ -> đ
					}
	
					function countOccurrences(text, keyword) {
						if (!text || !keyword) return 0;
						
						// Decode HTML entities
						textareaElement.innerHTML = text;
						text = textareaElement.value;
						
						// Convert text to lowercase once at the beginning since keywords are already lowercase
						text = normalizeSerbian(text.toLowerCase());
						keyword = normalizeSerbian(keyword); // keyword is already lowercase from creation
						
						// Remove quotes and normalize spaces
						text = ' ' + text.replace(/["""'']/g, '')
							.replace(/\s+/g, ' ')
							.trim() + ' ';
						
						keyword = keyword.trim();
						
						// Create regex without 'i' flag since text is already lowercase
						var phraseRegex = new RegExp(
							'(?<=[\\s.,!?;:]|^)' + 
							keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
							'(?=[\\s.,!?;:]|$)', 
							'g'  // Removed 'i' flag since we don't need case-insensitive matching anymore
						);
						
						var matches = text.match(phraseRegex) || [];
						
						return matches.length;
					}
	
					// Update keyword counts with new bindings
					function updateKeywordCounts() {
						if (!Array.isArray(scope.keyWordsList)) {
							scope.keyWordsList = [];
							return;
						}
	
						var title = scope.postTitle || (scope.parent && scope.parent.dataPost.title) || '';
						var content = scope.content || (scope.parent && scope.parent.tinymceModel) || '';
						
						var div = document.createElement('div');
						div.innerHTML = editorExludeShortcode(content);
						
						// Get h2h3 text first
						var h2h3Elements = div.querySelectorAll('h2, h3');
						var h2h3Text = '';
						for (var i = 0; i < h2h3Elements.length; i++) {
							var text = h2h3Elements[i].textContent.trim();
							if (text) {
								h2h3Text += ' ' + text;
							}
						}
						h2h3Text = h2h3Text.trim();
						
						// Remove h2 and h3 elements
						var h2h3Tags = div.querySelectorAll('h2, h3');
						for (var i = 0; i < h2h3Tags.length; i++) {
							h2h3Tags[i].remove();
						}
						
						// Get remaining content and replace all HTML tags with spaces
						var pText = div.innerHTML
							.replace(/<\/?[^>]+(>|$)/g, ' ') // Replace any HTML tag with space
							.replace(/&nbsp;/g, ' ')         // Replace &nbsp; with space
							.replace(/\s+/g, ' ')            // Normalize multiple spaces
							.trim();
						// Update counts for each keyword
						scope.keyWordsList.forEach(function(keyword) {
							if (!keyword) return;
							
							keyword.counts = {
								h1: countOccurrences(title, keyword.name),
								h2h3: countOccurrences(h2h3Text, keyword.name),
								p: countOccurrences(pText, keyword.name)
							};
						});
					}
	
					// Add this helper function
					scope.isMainKeyword = function(keyword) {
						return keyword.isMain;
					};
					scope.clearAllKeywords = function() {
						scope.keyWordsList.length = 0;
					}
					// Add scope cleanup
					scope.$on('$destroy', function() {
						// Clear any timeouts or watchers if needed
						scope.keyWordsList = null;
					});
				}       
			}
		}
	}


/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app.directive('ngEnter', ngEnter);
		ngEnter.$inject=[];
		function ngEnter() {
			return {
				link: function (scope, element, attrs) {
		            element.unbind("keydown keypress").bind("keydown keypress", function (event) {
		                if (event.which === 13) {
		                    scope.$apply(function () {
		                        scope.$eval(attrs.ngEnter);
		                    });
		                    event.preventDefault();
		                }
					});
					scope.$on('$destroy', function() {
						element.unbind("keydown keypress");
					})
		        }
		    }
		}	
	}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app.directive('ngEscape', ngEscape);
		ngEscape.$inject=['$rootScope','$parse','$state','$timeout'];
		function ngEscape($rootScope,$parse, $state, $timeout) {
			return {
				link: function (scope, element, attrs) {
					$rootScope.ngEscapeAttrsParametars.push({parametar:attrs.parametar,method:attrs.ngEscape});
					angular.element(document).off('keyup').on('keyup', function(event) {
			            if (event.which === 27) {
			            	if($rootScope.ngEscapeAttrsParametars.length ===0) {
			            		return
			            	}
			            	if($rootScope.modalShow) {
				            	for(var i=0;i<$rootScope.ngEscapeAttrsParametars.length;i++) {
									if($rootScope.ngEscapeAttrsParametars[i].parametar =='modal') {	
				                    	scope.$apply(function () {
				                        	scope.$eval($rootScope.ngEscapeAttrsParametars[i].method);
				                    	});
				                    	$rootScope.ngEscapeAttrsParametars.splice(i,1);
				            		}
				            	}
			            	} else {
			            		for(var i=0;i<$rootScope.ngEscapeAttrsParametars.length;i++) {
				            		if($rootScope.ngEscapeAttrsParametars[i].parametar =='page') {
										if($state.is('app.allposts')) {
							  				$timeout($rootScope.closeEditPost, 10);
							  			}
							  			if($state.is('app.allpages')) {
							  				$timeout($rootScope.closeEditPage, 10);
							  			}
							  			if($state.is('app.allpolls')) {
							  				$timeout($rootScope.closeEditPoll, 10);
							  			}
							  			if($state.is('app.library')) {
							  				$timeout($rootScope.closeEditMedia, 10);
							  			}
							  			if($state.is('app.allusers')) {
							  				$timeout($rootScope.closeEditUser, 10);
							  			}
							  			if($state.is('app.tags')) {
							  				$timeout($rootScope.closeEditTag, 10);
							  			}
							  			if($state.is('app.categories')) {
							  				$timeout($rootScope.closeEditCategory, 10);
										}
										if($state.is('app.allvideos')) {
											$timeout($rootScope.closeEditVideo, 10);
										}  
										if($state.is('app.allcountries')) {
											$timeout($rootScope.closeEditCountryRestriction, 10);
										} 
										if($state.is('app.ai_all_configurations')) {
											$timeout($rootScope.closeEditConfiguration, 10);
										}
										$rootScope.ngEscapeAttrsParametars=[];
										angular.element(document).off('keyup')
				            		}
				            	}
			            	}
			            	event.preventDefault();
			            }
					});
		        }
		    }
		}	
	}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('notificationCenterDir',notificationCenterDir);
		notificationCenterDir.$inject=['$timeout'];
		function notificationCenterDir($timeout) {
			return {
				restrict: 'E',
	            scope:{
	                obj:"=",
	            },
	            replace:true,
				template: __webpack_require__(243),
				link: function(scope, ele, $attrs, ctrl) {
					scope.closeNotification = function(id) {
	                    var index = -1;
	                    for(var i= 0;i<scope.obj.notifications.length;i++) {
	                        if(id == scope.obj.notifications[i].id) {
	                            index = i
	                            break
	                        }
	                    }
	                    if(index!==-1) {
	                        scope.obj.notifications.splice(index,1)
	                    }
	                }
	                //expose closeNotification func to parent controller
	                scope.obj.notificationsDeleteFunction = scope.closeNotification
				}
			}
		}
	}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		'use strict'
		app.directive('quickEditDir',quickEditDir);
		quickEditDir.$inject=['$rootScope','putDataService','refreshtokenService','alertService','serverError','offlineError'];
		function quickEditDir($rootScope, putDataService, refreshtokenService, alertService,serverError,offlineError) {
			return {
				scope:{
					objdata:'=',
					state1:'=',
					state2:'=',
					description:'=',
					name:"=",
					visible:"=",
					unsafe:"=",
					successUpdateFunc:"="	
				},
				link: function(scope, element, attrs,ctrl) {
					scope.objdata.quickEdit = function() {
				  		scope.objdatacopy = angular.copy(scope.objdata);
				  	}
				  	scope.objdata.cancelQuickEdit = function() {
		  				scope.objdata = scope.objdatacopy;
			  		}
			  		scope.objdata.updateQuickEdit = function() {
						$rootScope.hasLoaded = false;
			  			var putFunction = function() {
				  			putDataService.update({
					          param1:scope.state1,
							  param2: (scope.state2)?scope.state2:undefined, 
					          param3:scope.objdata._id 
					        },{
					          'name':(scope.name)? scope.objdata.name:undefined,
					          'description':(scope.description)? scope.objdata.description:undefined,
							  'visible':(scope.visible)? scope.objdata.visible:undefined,
							  'unsafe':(scope.unsafe)? scope.objdata.unsafe:undefined,
					     	  '_id': scope.objdata._id
					        }).$promise.then(function(putTag){
								$rootScope.hasLoaded = true;
								if(scope.successUpdateFunc) {
									scope.successUpdateFunc('update')
								}
								alertService('success','Success ', putTag.message, 2000);
					        }, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
					            if(error.status ==401) {
					            	var promise = refreshtokenService.getAccessToken();
					            	promise.then(
					              	function(answer) {
					                	if(answer==200) {   
					                 		putFunction();
					                	}
					              	},
					              	function(error) {
					              	},
					              	function(progress) {
					               // report progress
					            	});
					          	} else if(error.status ==502) {
	                				serverError()
	              			  	} else {
									alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								} 
								$rootScope.hasLoaded = true; 
					        });
			  			}
			  			putFunction();
			  		}
			  		
				}
	
			}
		}
	}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('searchAllPostSortableDir',searchAllPostSortableDir);
		searchAllPostSortableDir.$inject=['$window','$timeout','reqursiveService','keyPress','getDataService','$rootScope','refreshtokenService','serverError','alertService', 'offlineError'];
		function searchAllPostSortableDir($window,$timeout,reqursiveService,keyPress,getDataService,$rootScope,refreshtokenService,serverError,alertService, offlineError) {
			return {
				restrict: 'E',
	            scope:{
	                parentObj:"=",
	                sortableDataName:'=',
	                searchTags:'=',
	                searchCategories:'='
	            },
	            replace:true,
				template: __webpack_require__(244),
				link: function(scope, ele, $attrs, ctrl) {
	                scope.windowInnerWdth = window.innerWidth;
					scope.searchData = '';
	                scope.searchTag = '';
	                var title = '';
	                var id = null;
	                var size = 14;
	                var from = 0;
	                var tags = {
	                    id:'',
	                    name:''
	                };
	                var category = '';
	                scope.allPosts = [];
	                scope.removeTagShow = false;
	                scope.removeTitleShow = false;
	                scope.selectedCategory = {value:'all'};
	                scope.loadMoreShow = false;
	                scope.sortableOptions = {
	                    connectWith: ".sortable-container",
	                    start: function(e, ui) {
	                        scope.modelClone = null;
	                        scope.sourceModelClone = ui.item.sortable.sourceModel.slice();
	                        scope.modelClone = angular.copy(ui.item.sortable.model)
	                    },
	                    stop: function(e, ui) {
	                        // if the element is removed from the first container
	                        if (
	                          jQuery(e.target).hasClass("sortableFrom") &&
	                          ui.item.sortable.droptarget &&
	                          e.target != ui.item.sortable.droptarget[0]
	                        ) {
	                          ui.item.sortable.sourceModel.length = 0;
	                          // clone the original model to restore the removed item
	                          Array.prototype.push.apply(
	                            ui.item.sortable.sourceModel,
	                            scope.sourceModelClone
	                          );
	                          scope.sourceModelClone = null;
	                        }
	                    },
	                    update: function(e, ui) {
	                        if (jQuery(e.target).hasClass("sortableFrom") && ui.item.sortable.droptarget && e.target != ui.item.sortable.droptarget[0]) {
	                            if(!scope.modelClone) return
	                            if(scope.sortableDataName=='prFocusNews' || scope.sortableDataName=='focusData') {
	                                parentLoop:
	                                for(var prItem in scope.parentObj.prFocusNews) {
	                                    for(var j = 0; j<scope.parentObj.prFocusNews[prItem].length;j++) {
	                                        if(scope.modelClone.id == scope.parentObj.prFocusNews[prItem][j].document_id && scope.parentObj.prFocusNews[prItem][j].type =='post') {
	                                            ui.item.sortable.cancel();
	                                            alertService('danger', 'Opps! ', 'Post alredy exist in PR focus news!');
	                                            break parentLoop
	                                        }
	                                    }
	                                }
	                                for(var i=0; i<scope.parentObj.focusData.length;i++) {
	                                    if(scope.modelClone.id == scope.parentObj.focusData[i].document_id && scope.parentObj.focusData[i].type =='post') {
	                                        ui.item.sortable.cancel();
	                                        alertService('danger', 'Opps! ', 'Post alredy exist in focus news!');
	                                        break
	                                    }
	                                }
	                            } else {
	                                for(var i = 0; i<scope.parentObj[scope.sortableDataName].length;i++) {
	                                    if(scope.modelClone.id == scope.parentObj[scope.sortableDataName][i].id) {
	                                        ui.item.sortable.cancel();
	                                        alertService('danger', 'Opps! ', 'Post alredy exist!');
	                                        break
	                                    }
	                                    
	                                }
	                            }
	                        }
	                        scope.modelClone = null;
	                    }
	                }
	                scope.searchPress = function(evt) {
	                    keyPress(evt);
	                }
	                scope.$on('recommended-news-select-tag', function(event,data) {
	                    tags.id= data.selectedTagObj.tagId,
	                    tags.name= data.selectedTagObj.tagName
	                    scope.removeTagShow = true;
	                    getPosts()
	                });
	                scope.searchTagChange = function() {
	                    if(scope.searchTag.length == 0) {
	                        tags.id = '';
	                        tags.name = '';
	                        scope.removeTagShow = false;
	                        getPosts()
	                    }
	                }
	                function getAllDescendantsCategory(children) {
	                    for(var i = 0;i<children.length;i++) {
	                        if(!category) {
	                            category +=children[i]._id
	                        }else {
	                            category += ',' + children[i]._id
	                        }
	                        if(children[i].children && children[i].children.length>0) {
	                            getAllDescendantsCategory(children[i].children)
	                        }
	                    }
	
	                }
	                scope.switchCategories = function() {
	                    category = '';
	                    if(scope.selectedCategory.value == 'all') {
	                        category = '';
	                    } else {
	                        for(var i = 0; i<scope.categoriesTreeInput.length;i++) {
	                            if(scope.selectedCategory.value == scope.categoriesTreeInput[i]._id) {
	                                if(scope.categoriesTreeInput[i].children && scope.categoriesTreeInput[i].children.length>0) {
	                                    getAllDescendantsCategory(scope.categoriesTreeInput[i].children)
	                                } else {
	                                category = scope.categoriesTreeInput[i]._id
	                                }
	                                break
	                            }
	                        }
	                    }
	                    scope.searchTag = tags.name;
	                    getPosts()
	                }
	                var categoryTreeFunction= function() {
	                    scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
	                    scope.categoriesTreeSelect = angular.copy(scope.categoriesTreeInput);
	                    for(var i=0; i< scope.categoriesTreeSelect.length; i++) {
	                      if(scope.parentObj.category == scope.categoriesTreeSelect[i]._id && scope.categoriesTreeSelect[i].visible) {
	                        scope.selectedCategory = {value:scope.parentObj.category};
	                        scope.switchCategories()
	                      }
	                      var n = (scope.categoriesTreeSelect[i].ancestors.length)*2;
	                      var empty = "\u00A0";
	                      for(var j=0;j<n;j++) {
	                        scope.categoriesTreeSelect[i].name = empty+scope.categoriesTreeSelect[i].name;
	                      }
	                    }
	                    if(scope.selectedCategory.value == 'all') {
	                      getPosts();
	                    }
	                }
	                scope.addToSortable = function(post) {
	                    for(var i=0; i<scope.parentObj[scope.sortableDataName].length;i++) {
	                      if(scope.sortableDataName=='focusData') {
	                            if(post.id == scope.parentObj[scope.sortableDataName][i].document_id && scope.parentObj[scope.sortableDataName][i].type=='post') {
	                                alertService('danger', 'Opps! ', 'Post alredy exist!');
	                                return
	                            }
	                        } else {
	                            if(post.id == scope.parentObj[scope.sortableDataName][i].id) {
	                                alertService('danger', 'Opps! ', 'Post alredy exist!');
	                                return
	                            }
	                        }
	                    }
	                    scope.parentObj[scope.sortableDataName].push(post)
	                }
	                if(scope.parentObj.categories && scope.parentObj.categories.length>0) {
	                    scope.categories = scope.parentObj.categories
	                    categoryTreeFunction()
	                } else {
	                    var getCategoriesFunction = function() {
	                        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(dataCategory){
	                          scope.categories = dataCategory.categories;
	                          categoryTreeFunction() 
	                        }, function(error){
	                          if(!window.navigator.onLine) {
	                            offlineError()
	                            return
	                          }
	                          if(error.status ==401) {
	                            var promise = refreshtokenService.getAccessToken();
	                            promise.then(
	                                function(answer) {
	                                  if(answer==200) {
	                                    getCategoriesFunction();
	                                  }
	                                // do something
	                              },
	                              function(error) {
	                                // report something
	                              },
	                              function(progress) {
	                               // report progress
	                            });
	                          }
	                        });
	                    } 
	                    getCategoriesFunction();
	                      
	                }
	        
	                scope.loadMore = function() {
	                    from = from + size;
	                    $timeout(function() {
	                      getPosts('loadMore');
	                    },0)
	                }
	                var timer;
	                function debounce(func, timeout){
	                    clearTimeout(timer);
	                    timer = $timeout(function() { 
	                      func(); 
	                    }, timeout);
	                }
	                scope.searchTitleOrIdChange = function() {
	                    if(scope.searchTitle.length>0) { 
	                      scope.removeTitleShow = true; 
	                      debounce(function(){
	                        if(!isNaN(scope.searchTitle)) {
	                          if(scope.searchTitle.length>=5) {
	                            id = scope.searchTitle;
	                            title = ''
	                          } else {
	                            title= scope.searchTitle;
	                            id = null;
	                          }
	                        } else {
	                          title= scope.searchTitle;
	                          id = null;
	                        }
	                        getPosts()
	                      },200)
	                    } else {
	                      title = '';
	                      id = null;
	                      scope.removeTitleShow = false;
	                      getPosts()
	                    }
	                    scope.searchTag = tags.name;
	                }
	                function getPosts(loadMore) {
	                    if(loadMore != 'loadMore') {
	                        from = 0;
	                    }
	                    scope.loadMoreShow = false;
	                    $rootScope.hasLoaded = false;
	                    getDataService.get({
	                        param1:'posts',
	                        param2:'search',
	                        title:title|| undefined,
	                        category:category || undefined,
	                        tags:tags.id || undefined,
	                        id:id || undefined,
	                        from: from,
	                        size:size
	                    }).$promise.then(function(data){
	                        scope.emptyTable = false;
	                        $rootScope.hasLoaded = true;
	                        if(scope.sortableDataName =='focusData' || scope.sortableDataName == 'prFocusNews') {
	                            for(var i =0; i<data.recommended.length;i++) {
	                                data.recommended[i].document_id = data.recommended[i].id;
	                                data.recommended[i].type ='post'
	                                if(!data.recommended[i].images || !data.recommended[i].images['140x105']) {
	                                    data.recommended[i].images = {'140x105':'https://xdn.tf.rs/default/default-140x105.jpg'}
	                                }
	                            }
	                        }
	                        if(!data || !data.recommended) return;
	                        if(loadMore=='loadMore') {
	                            scope.allPosts = scope.allPosts.concat(data.recommended);
	                        } else {
	                            scope.allPosts.length = 0;
	                            scope.allPosts = data.recommended;
	                        }
	                        if(data.total && data.total >scope.allPosts.length) {
	                            scope.loadMoreShow = true;
	                        } else {
	                            scope.loadMoreShow = false;
	                        }
	                        if(scope.allPosts.length==0) {
	                            scope.emptyTable = true;
	                        }
	                    }, function(error){
	                        if(!window.navigator.onLine) {
	                            offlineError()
	                            $rootScope.hasLoaded = true;
	                            return
	                        }  
	                        if(error.status ==401) {
	                            var promise = refreshtokenService.getAccessToken();
	                            promise.then(
	                            function(answer) {
	                                if(answer==200) {
	                                    getPosts();
	                                }
	                                // do something
	                            },
	                            function(error) {
	                            },
	                            function(progress) {
	                                // report progress
	                            });
	                        } else if(error.status ==502) {
	                            serverError()
	                        } else if(error.status ==404) {
	                            scope.emptyTable = true;
	                        } else {
	                            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                        }	   
	                        $rootScope.hasLoaded = true;
	                            
	                    });
	                }
	                var sortableGrid = jQuery('.search-all-post-sortable-wrapper .sortable-grid');
	                var sortableGridPrFocus = jQuery('pr-focus-news-modal .search-all-post-sortable-wrapper .sortable-grid')
	                var statusFilter = jQuery('.search-all-post-sortable-wrapper .status-filter');
	                var eklinkaBlock = jQuery('.pr-focus-news-modal .eklinika-block');
	                function calculateHeightScrollableEl() {
	                    if(scope.sortableDataName =='focusData') {
	                        if(window.innerWidth >800) {
	                            sortableGrid.height(window.innerHeight - 75 - statusFilter.height())
	                        } else {
	                            sortableGrid.height('auto')
	                        }
	                    } else if(scope.sortableDataName == 'recommendedNews') {
	                        if(window.innerWidth >600) {
	                            sortableGrid.height(jQuery('.recommended-news-modal .modal--media-content .left-column').height() - 20 - statusFilter.height())
	                        } else {
	                            sortableGrid.height('auto')
	                        }
	                    } else if (scope.sortableDataName == 'prFocusNews') {
	                        if(window.innerWidth >600) {
	                            sortableGridPrFocus.height(jQuery('.pr-focus-news-modal .modal--media-content .left-column').height() - 20 - statusFilter.height() - eklinkaBlock.height() - 25)
	                        } else {
	                            sortableGrid.height('auto')
	                        }
	                    }
	                }
	                $timeout(function() {
	                    calculateHeightScrollableEl()
	                },100)
	                var onResize = function() {
	                    if(scope.windowInnerWdth!=window.innerWidth) {
	                        scope.$apply(function() {
	                            calculateHeightScrollableEl()
	                        })
	                    }
					}
					angular.element($window).on('resize',onResize);
	                scope.$on('$destroy',function() {
						angular.element($window).off('resize',onResize);
					})
				}
			}
		}
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('searchBlogModalDir',searchBlogModalDir);
		searchBlogModalDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
	    function searchBlogModalDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
	    return {
	      restrict: 'E',
	      scope: {
	          parentObj:"=",
	          postId:'=',
	      },
	      replace:true,
	      template: __webpack_require__(245),
	      link: function(scope, element, attrs, ngModel) {
	          scope.requiredBlog = false;
	          scope.blogResult = false;
	          scope.insertBlog = function() {
	            function addBlogFunc() {
	              if(scope.parentObj.addBlogToEditorShow) {
	                var insertBlogToEditorObj = {
	                  _id: scope.searchObj._id,
	                }
	                scope.$parent.$parent.$broadcast('insert-blog-to-editor', insertBlogToEditorObj);
	                scope.$emit('live-badge',{'display':true})
	              }
	              searchBlogReset()
	              $timeout(function () {
	                scope.parentObj.cancelBlogModal()
	              }, 0)
	            }
	            if(scope.searchObj && scope.searchBlogData) {
	              scope.requiredBlog = false;
	              if(scope.postId) {
	                var postFunction = function() {
	                  postDataService.save({
	                    param1:'liveblogs',
	                    param2:'attach'
	                  },{
	                    'post_id':parseInt(scope.postId),
	                    'blog_id':scope.searchObj._id,
	                  }).$promise.then(function(data){
	                    addBlogFunc()
	                    scope.blogModalShow = false;
	                    $rootScope.modalShow = false;
	                  }, function(error){
	                    if(!window.navigator.onLine) {
	                      offlineError()
	                      alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                      return
	                    }
	                    if(error.status ==401) {
	                      var promise = refreshtokenService.getAccessToken();
	                      promise.then(
	                        function(answer) {
	                          if(answer==200) {
	                            postFunction();
	                          }
	                        },
	                        function(error) {
	                        },
	                        function(progress) {
	                          // report progress
	                      });
	                    } else if(error.status ==502) {
	                      serverError()
	                    } else {
	                      alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                    }  
	                  });
	                }
	                postFunction();
	              } else {
	                addBlogFunc()
	              }
	            } else {
	              alertService('danger','Opps! ', 'Choose blog');
	              scope.requiredBlog = true;
	            }  
	          }
	          scope.hiddenResult = true;
	          scope.hasResult = true;
	          scope.blogArray = [];
	          scope.searchPage = 0;
	          scope.chooseSearchData = function(blog) {
	            scope.searchBlogData = '('+blog._id+') - ' +  blog.title;
	            scope.hiddenResult = true;
	            scope.searchObj = {
	              '_id': blog._id,
	              'title' : blog.title,
	            };
	          };
	          function mouseDown(e) {
	            if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	            var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	            var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	            if (!container.is(e.target) // if the target of the click isn't the container...
	              && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	            {
	              scope.$apply(function () {
	                scope.hiddenResult = true;
	                scope.blogArray = [];
	                scope.searchPage = 1;
	              });
	            }}
	          }
	          angular.element(document).on('mousedown',mouseDown);
	          scope.searchPress = function(evt,star) {
	            keyPress(evt,star);
	          }
	          scope.readMore = function() {
	            scope.searchPage ++;
	            $timeout(function() {
	              scope.search('loadMore');
	            },0)
	          }
	          var getBlogsFunction = function(loadMore) {
	            getDataService.get({
	              param1:'liveblogs', 
	              status:'publish',
	              s: scope.searchBlogData,
	              limit:20,
	              page: scope.searchPage
	            }).$promise.then(function(data){
	              if(loadMore=='loadMore') {
	                scope.blogArray = scope.blogArray.concat(data.blogs);
	              } else {
	                scope.blogArray = data.blogs;
	              }
	              if(scope.blogArray.length > 0) {
	                scope.hasResult = true;
	                scope.loadMore = true;
	              } else {
	                scope.hasResult = false;
	              }
	              scope.hiddenResult = false;
	              if(data.count >scope.blogArray.length) {
	                scope.loadMore = true;
	              } else {
	                scope.loadMore = false;
	              }
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {
	                      getBlogsFunction(loadMore);
	                    }
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                    // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              } else if(error.status ==404){
	                scope.hasResult = false;
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }  
	            });
	          }
	          function searchBlogReset() {
	            scope.searchBlogData = null;
	            scope.searchObj = null;
	          }
	          scope.search = function(loadMore) { 
	            scope.loadMore = false;
	            if(loadMore!='loadMore') {
	              scope.searchPage = 1;
	              scope.blogArray = [];
	            }
	            // scope.hiddenResult = true;
	            if(scope.searchBlogData) { 
	              if(scope.searchBlogData.length >1) {
	                getBlogsFunction(loadMore);
	              } else {
	                scope.hiddenResult = true;
	              } 
	            } else {
	              scope.hiddenResult = true;
	              searchBlogReset()
	            }
	          }
	        scope.$on('$destroy',function(){
	          angular.element(document).off('mousedown',mouseDown);
	        })
	      }
	    }
	  }	
	}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('searchPollDir',searchPollDir);
		searchPollDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
	    function searchPollDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
	    return {
	      restrict: 'E',
	      scope: {
	          parentObj:"=",
	          editor:'=',
	          postId:'=',
	          pollResultDisplay:'='
	      },
	      replace:true,
	      template: __webpack_require__(246),
	      link: function(scope, element, attrs, ngModel) {
	        scope.requiredPoll = false;
	        scope.pollResult = false;
	        scope.insertPoll = function() {
	          function addPollFunc() {
	            if(scope.parentObj.addPollToEditorShow) {
	              var insertPollToEditorObj = {
	                _id: scope.searchObj._id,
	              }
	              if(scope.pollResultDisplay) {
	                insertPollToEditorObj.result = scope.pollResult
	              }
	              scope.$parent.$parent.$broadcast('insert-poll-to-editor', insertPollToEditorObj);
	            } else {
	              scope.parentObj.setRecommnededPoll({
	                _id : scope.searchObj._id,
	                title: scope.searchObj.title
	              })
	            }
	            searchPollReset()
	            // scope.selectedPollAction.value = 'default';
	            $timeout(function () {
	              scope.parentObj.cancelPollModal()
	            }, 0)
	          }
	          if(scope.searchObj && scope.searchPollData) {
	            scope.requiredPoll = false;
	            if(scope.postId) {
	              var postFunction = function() {
	                postDataService.save({
	                  param1:'polls',
	                  param2:'attachToPost'
	                },{
	                  'post_id':scope.postId,
	                  'poll_id':scope.searchObj._id,
	                  'related': (scope.parentObj.addPollToRecomended)? true:false
	                }).$promise.then(function(data){
	                  addPollFunc()
	                  scope.pollModalShow = false;
	                  $rootScope.modalShow = false;
	                }, function(error){
	                  if(!window.navigator.onLine) {
	                    offlineError()
	                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                    return
	                  }
	                  if(error.status ==401) {
	                    var promise = refreshtokenService.getAccessToken();
	                    promise.then(
	                      function(answer) {
	                        if(answer==200) {
	                          postFunction();
	                        }
	                      },
	                      function(error) {
	                      },
	                      function(progress) {
	                        // report progress
	                    });
	                  } else if(error.status ==502) {
	                    serverError()
	                  } else {
	                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                  }  
	                });
	              }
	              postFunction();
	            } else {
	              addPollFunc()
	            }
	          } else {
	            alertService('danger','Opps! ', 'Choose poll');
	            scope.requiredPoll = true;
	          }  
	        }
	        scope.hiddenResult = true;
	        scope.hasResult = true;
	        scope.pollArray = [];
	        scope.searchPage = 0;
	        scope.chooseSearchData = function(poll) {
	          scope.searchPollData = '('+poll._id+') - ' +  poll.title;
	          scope.hiddenResult = true;
	          scope.searchObj = {
	            '_id': poll._id,
	            'title' : poll.title,
	          };
	        };
	        function mouseDown(e) {
	          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	          if (!container.is(e.target) // if the target of the click isn't the container...
	            && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	          {
	            scope.$apply(function () {
	              scope.hiddenResult = true;
	              scope.pollArray = [];
	              scope.searchPage = 1;
	            });
	          }}
	        }
	        angular.element(document).on('mousedown',mouseDown);
	        scope.searchPress = function(evt,star) {
	          keyPress(evt,star);
	        }
	        scope.readMore = function() {
	          scope.searchPage ++;
	          $timeout(function() {
	            scope.search('loadMore');
	          },0)
	        }
	        var getPollsFunction = function(loadMore) {
	          var excludeby;
	          var status = 'publish,finish';
	          if(scope.parentObj.addPollToRecomended) {
	            excludeby = 'content';
	            status = 'publish'
	          }
	          getDataService.get({
	            param1:'polls', 
	            status:status,
	            s: scope.searchPollData,
	            limit:20,
	            page: scope.searchPage,
	            excludeby:excludeby
	          }).$promise.then(function(data){
	            // $element.after($compile(modal)($scope));
	            if(loadMore=='loadMore') {
	              scope.pollArray = scope.pollArray.concat(data.polls);
	            } else {
	              scope.pollArray = data.polls;
	            }
	            if(scope.pollArray.length > 0) {
	              scope.hasResult = true;
	              scope.loadMore = true;
	            } else {
	              scope.hasResult = false;
	            }
	            scope.hiddenResult = false;
	            if(data.count >scope.pollArray.length) {
	              scope.loadMore = true;
	            } else {
	              scope.loadMore = false;
	            }
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getPollsFunction(loadMore);
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                  // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }  
	          });
	        }
	        function searchPollReset() {
	          scope.searchPollData = null;
	          scope.searchObj = null;
	        }
	        scope.search = function(loadMore,initialLoad) { 
	          scope.loadMore = false;
	          if(loadMore!='loadMore') {
	            scope.searchPage = 1;
	            scope.pollArray = [];
	          }
	          if(initialLoad || loadMore) {
	            getPollsFunction(loadMore);
	          } else {
	            if(scope.searchPollData) { 
	              if(scope.searchPollData.length >0) {
	                getPollsFunction(loadMore);
	              } else {
	                scope.hiddenResult = true;
	              } 
	            } else {
	              scope.hiddenResult = true;
	              searchPollReset()
	            }
	          }
	          // scope.hiddenResult = true;
	        }
	        scope.search(null,true)
	        scope.$on('$destroy',function(){
	          angular.element(document).off('mousedown',mouseDown);
	        })
	      }
	    }
	  }	
	}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict'
		app.directive('searchPostDir',searchPostDir);
		searchPostDir.$inject=['elasticSearch','$http','$timeout','keyPress','offlineError'];
		function searchPostDir(elasticSearch,$http,$timeout,keyPress, offlineError) {
			return {
				restrict: 'E',
	      scope:{
	          parentObj:"=",
	          noAddBtn:'=',
	          removeSelected:'=',
	          searchPostObj:'='
	      },
	      replace:true,
				template: __webpack_require__(247),
				link: function(scope, ele, $attrs, ctrl) {
	        scope.hiddenResult = true;
	        scope.hasResult = true;
	        scope.searchPage = 0;
	        scope.postResult = [];
	        scope.$watch(function(){
	          return scope.searchPostObj
	        }, function(newValue, oldValue){
	          if (oldValue !==newValue && newValue) {
	            onloadPopulateSearch()
	          }
	        },true);
	        function onloadPopulateSearch() {
	          if(scope.searchPostObj) {
	            scope.searchPostsData = '('+scope.searchPostObj._id+') - ' +  scope.searchPostObj.title;
	            if(scope.removeSelected) {
	              scope.disableInput = true;
	            }
	            if(scope.noAddBtn) {
	              scope.parentObj.searchPostObj = {
	                'id': scope.searchPostObj._id,
	                'title' : scope.searchPostObj.title,
	                'url' : scope.searchPostObj.url
	              };
	            }
	          } 
	        }
	        if(scope.searchPostObj) {
	          onloadPopulateSearch()
	        }
	        if(scope.noAddBtn) {
	          scope.parentObj.searchPostReset = function() {
	            searchPostReset()
	          };
	        }
	        function searchPostReset() {
	          scope.searchPostsData = null;
	          scope.searchObj = null;
	          if(scope.noAddBtn) {
	            scope.parentObj.searchPostObj = null
	          }
	          if(scope.removeSelected) {
	            scope.disableInput = false;
	          }
	        }
	        scope.addSearchPost = function(searchObj) {
	            if(searchObj && scope.searchPostsData) {
	              scope.parentObj.addPostFromSearch(searchObj);
	            }
	            scope.searchPostsData = null;
	            scope.searchObj = null;
	        }
	        scope.chooseSearchData = function(post) {
	            scope.searchPostsData = '('+post._id+') - ' +  post._source.post_title;
	            scope.hiddenResult = true;
	            scope.searchObj = {
	              'id': post._id,
	              'title' : post._source.post_title,
	              'uri' : post._source.url.substr(23),
	              'url': post._source.url,
	              'image': post._source.image
	            };
	            if(scope.noAddBtn) {
	              scope.parentObj.searchPostObj = {
	                'id': post._id,
	                'title' : post._source.post_title,
	                'url' : post._source.url
	              };
	            }
	            if(scope.removeSelected) {
	              scope.disableInput = true;
	            }
	          };
	          scope.enableInput = function() {
	            searchPostReset()
	          }
	          function mouseDown(e) {
	            if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	              var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	              var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	              if (!container.is(e.target) // if the target of the click isn't the container...
	                && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	              {
	                scope.$apply(function () {
	                  scope.hiddenResult = true;
	                  scope.postResult = [];
	                  scope.searchPage = 0;
	                });
	              }
	            }
	          }
	          angular.element(document).on('mousedown', mouseDown);
	          scope.searchPress = function(evt,star) {
	            keyPress(evt,star);
	          }
	          scope.readMore = function() {
	            scope.searchPage +=10;
	            $timeout(function() {
	              scope.search('loadMore');
	            },0)
	          }
	          scope.search = function(loadMore) { 
	            var size=10;
	            scope.loadMore = false;
	            if(loadMore!='loadMore') {
	              scope.searchPage = 0;
	              scope.postResult = [];
	            }
	            // scope.hiddenResult = true;
	            if(scope.searchPostsData) { 
	              if(scope.searchPostsData.length >1) {
	                var url = elasticSearch.getUrl(scope.searchPostsData);
	                url = url + '&from='+ scope.searchPage +'&size='+ size;
	                
	                $http({
	                  method: 'GET',
	                  url: url
	                }).then(function successCallback(response) {
	                    if(loadMore=='loadMore') {
	                      scope.postResult = scope.postResult.concat(response.data.hits.hits);
	                    } else {
	                      scope.postResult = response.data.hits.hits;
	                    }
	                    if(scope.postResult.length > 0) {
	                      scope.hasResult = true;
	                      scope.loadMore = true;
	                    } else {
	                      scope.hasResult = false;
	                    }
	                    scope.hiddenResult = false;
	                    if(response.data.hits.total >scope.postResult.length) {
	                      scope.loadMore = true;
	                    } else {
	                      scope.loadMore = false;
	                    }
	                    // this callback will be called asynchronously
	                    // when the response is available
	                }, function errorCallback(response) {
	                  if(!window.navigator.onLine) {
	                    offlineError()
	                    return
	                  }
	                    // called asynchronously if an error occurs
	                    // or server returns response with an error status.
	                });
	              } else {
	                scope.hiddenResult = true;
	              } 
	            } else {
	              scope.hiddenResult = true;
	              searchPostReset()
	            }
	        }
	        scope.$on('$destroy',function(){
	          angular.element(document).off('mousedown',mouseDown);
	        })
				}
			}
		}
	}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('searchRatingDir',searchRatingDir);
		searchRatingDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
	    function searchRatingDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
	    return {
	      restrict: 'E',
	      scope: {
	          parentObj:"=",
	          editor:'=',
	          postId:'=',
	          ratingResultDisplay:'='
	      },
	      replace:true,
	      template: __webpack_require__(248),
	      link: function(scope, element, attrs, ngModel) {
	        scope.requiredPoll = false;
	        scope.ratingResult = false;
	        scope.insertRating = function() {
	          function addRatingFunc() {
	              var insertRatingToEditorObj = {
	                _id: scope.searchObj._id,
	              }
	              if(scope.ratingResultDisplay) {
	                insertRatingToEditorObj.result = scope.ratingResult
	              }
	              scope.$parent.$parent.$broadcast('insert-rating-to-editor', insertRatingToEditorObj);
	            searchRatingReset()
	            // scope.selectedPollAction.value = 'default';
	            $timeout(function () {
	              scope.parentObj.cancelRatingModal()
	            }, 0)
	          }
	          if(scope.searchObj && scope.searchRatingData) {
	            scope.requiredRating = false;
	            if(scope.postId) {
	              var postFunction = function() {
	                postDataService.save({
	                  param1:'ratings',
	                  param2:'attachToPost'
	                },{
	                  'post_id':scope.postId,
	                  'rating_id':scope.searchObj._id,
	                }).$promise.then(function(data){
	                  addRatingFunc()
	                  scope.ratingModalShow = false;
	                  $rootScope.modalShow = false;
	                }, function(error){
	                  if(!window.navigator.onLine) {
	                    offlineError()
	                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                    return
	                  }
	                  if(error.status ==401) {
	                    var promise = refreshtokenService.getAccessToken();
	                    promise.then(
	                      function(answer) {
	                        if(answer==200) {
	                          postFunction();
	                        }
	                      },
	                      function(error) {
	                      },
	                      function(progress) {
	                        // report progress
	                    });
	                  } else if(error.status ==502) {
	                    serverError()
	                  } else {
	                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                  }  
	                });
	              }
	              postFunction();
	            } else {
	              addRatingFunc()
	            }
	          } else {
	            alertService('danger','Opps! ', 'Choose rating');
	            scope.requiredRating = true;
	          }  
	        }
	        scope.hiddenResult = true;
	        scope.hasResult = true;
	        scope.ratingArray = [];
	        scope.searchPage = 0;
	        scope.chooseSearchData = function(rating) {
	          scope.searchRatingData = '('+rating._id+') - ' +  rating.title;
	          scope.hiddenResult = true;
	          scope.searchObj = {
	            '_id': rating._id,
	            'title' : rating.title,
	          };
	        };
	        function mouseDown(e) {
	          if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	          var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	          var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	          if (!container.is(e.target) // if the target of the click isn't the container...
	            && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	          {
	            scope.$apply(function () {
	              scope.hiddenResult = true;
	              scope.ratingArray = [];
	              scope.searchPage = 1;
	            });
	          }}
	        }
	        angular.element(document).on('mousedown',mouseDown);
	        scope.searchPress = function(evt,star) {
	          keyPress(evt,star);
	        }
	        scope.readMore = function() {
	          scope.searchPage ++;
	          $timeout(function() {
	            scope.search('loadMore');
	          },0)
	        }
	        var getPollsFunction = function(loadMore) {
	        //   var excludeby;
	          var status = 'publish,finish';
	        //   if(scope.parentObj.addPollToRecomended) {
	        //     excludeby = 'content';
	        //     status = 'publish'
	        //   }
	          getDataService.get({
	            param1:'ratings', 
	            status:status,
	            s: scope.searchRatingData,
	            limit:20,
	            page: scope.searchPage,
	            // excludeby:excludeby
	          }).$promise.then(function(data){
	            // $element.after($compile(modal)($scope));
	            if(loadMore=='loadMore') {
	              scope.ratingArray = scope.ratingArray.concat(data.ratings);
	            } else {
	              scope.ratingArray = data.ratings;
	            }
	            if(scope.ratingArray.length > 0) {
	              scope.hasResult = true;
	              scope.loadMore = true;
	            } else {
	              scope.hasResult = false;
	            }
	            scope.hiddenResult = false;
	            if(data.count >scope.ratingArray.length) {
	              scope.loadMore = true;
	            } else {
	              scope.loadMore = false;
	            }
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getPollsFunction(loadMore);
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                  // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }  
	          });
	        }
	        function searchRatingReset() {
	          scope.searchRatingData = null;
	          scope.searchObj = null;
	        }
	        scope.search = function(loadMore,initialLoad) { 
	          scope.loadMore = false;
	          if(loadMore!='loadMore') {
	            scope.searchPage = 1;
	            scope.ratingArray = [];
	          }
	          if(initialLoad || loadMore) {
	            getPollsFunction(loadMore);
	          } else {
	            if(scope.searchRatingData) { 
	              if(scope.searchRatingData.length >0) {
	                getPollsFunction(loadMore);
	              } else {
	                scope.hiddenResult = true;
	              } 
	            } else {
	              scope.hiddenResult = true;
	              searchRatingReset()
	            }
	          }
	        }
	        scope.search(null,true)
	        scope.$on('$destroy',function(){
	          angular.element(document).off('mousedown',mouseDown);
	        })
	      }
	    }
	  }	
	}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('sortableDir',sortableDir);
		sortableDir.$inject = [];
	  function sortableDir() {
	    return {
	      require: '?ngModel',
	      link: function(scope, element, attrs, ngModel) {
	        if(attrs.type!="noOrder") {
	          scope.$watch(function(){
	            return ngModel.$modelValue
	          }, function(newValue, oldValue){
	            if (newValue!=oldValue) {
	              for (var i=0; i<ngModel.$modelValue.length;i++) {
	                ngModel.$modelValue[i].order = (attrs.type=="videoBox")? i: i+1;
	              }
	            }
	          },true);
	        }
	        var options = {
	          helper:'original',
	          axis:'y',
	          start: function(e, ui) {
	            ui.item.directive = {
	              start: ui.item.index(),
	              startModel: ngModel
	            };
	          },
	          update: function(e, ui) {
	            var start = ui.item.directive.start;
	            var end = ui.item.index();
	            
	            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
	              scope.$apply(function() {
	                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
	                ngModel.$modelValue.splice(end, 0, element);
	              });
	            }
	          }
	        };
	        element.sortable(options);
	      }
	    };
	  }	
	}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var globalHelpers = __webpack_require__(18);
	module.exports = function(app) {
		'use strict'
		app.controller('tinymceBasicController',tinymceBasicController);
		tinymceBasicController.$inject=['countCharacters','editorExludeShortcode','parseOptions','refreshtokenService','getDataService','postDataService','alertService','serverError','offlineError','$rootScope','$element','$timeout','config','$compile',"reverseWpautop","jQuery","$window","$scope"];
		function tinymceBasicController(countCharacters,editorExludeShortcode,parseOptions,refreshtokenService,getDataService,postDataService,alertService,serverError,offlineError,$rootScope,$element,$timeout,config,$compile,reverseWpautop,jQuery, $window,$scope) {   
	    $scope.config = config;
	    $scope.windowWidth = window.innerWidth
	    var editorHeight;
	    var editorHeightFunction = function() {
	        editorHeight = jQuery($element).find('.mce-edit-area').height();
	        return editorHeight;
	    }
	
	    // Add function to handle modal iframe height
	    function setModalEditorHeight() {
	        if ($scope.$parent.editorModal && tinymce.activeEditor) {
	            var viewportHeight = window.innerHeight;
	            var modalHeaderHeight = 50;
	            var padding = 140; // 60px for content paddong and 40px for modal padding and 40 to get some space
	            if(window.innerWidth < 600) {
	              var padding = 120; // 20px modal padding
	            }
	            var toolbarHeight = 36;
	            var statusBarHeight = 36;
	            var availableHeight = viewportHeight - modalHeaderHeight - padding - toolbarHeight - statusBarHeight;
	            
	            // Set height with !important only on the iframe
	            var iframe = jQuery(tinymce.activeEditor.getContainer()).find('iframe');
	            iframe.attr('style', 'height: ' + availableHeight + 'px !important; min-height: ' + availableHeight + 'px !important;max-height: ' + availableHeight + 'px !important;width: 100% !important;display: block !important;');
	        }
	    }
	
	    function autoResizeHeight(ele) {
	      ele.css('height','auto')
	      ele.css('height',ele.scrollHeight + 'px')
	    }
	    $scope.charCount = 0;
	    function updateCharacterCount() {
	      if (tinymce.activeEditor) {
	          var content = tinymce.activeEditor.getContent();
	          $scope.charCount = countCharacters(content);
	          // if (!$scope.$$phase) {
	          //   $scope.$apply();
	          // }
	      }
	    }
	    if($scope.$parent.tag) {
	      var insertTag = angular.element(document.getElementById('insertTag.html')).html();
	    }
	    var editorHtml = angular.element(document.getElementById('editor.html')).html();
	    if($scope.$parent.video || $scope.$parent.quote || $scope.$parent.question) {
	      var modal = angular.element(document.getElementById('modal.html')).html();
	    }
	    if($scope.$parent.news) {
	      var insertPost = angular.element(document.getElementById('insertPost.html')).html();
	    }
	    if($scope.$parent.embed) {
	      var insertEmbedCode = angular.element(document.getElementById('insertEmbedCode.html')).html();
	    }
	    $scope.selectedTypeVideo = {value:'default'};
	    $scope.editor_preview_visual = true;
	    if($scope.$parent.tag) {
	      $scope.cancelInsertTagModal = function() {
	        $scope.searchTag = null;
	        jQuery($element).siblings('.editor-insert-tag').remove();
	        $rootScope.modalShow = false;
	      }
	    }
	    if($scope.$parent.news) {
	      $scope.cancelInsertPostModal = function() {
	        jQuery($element).siblings('.editor-insert-post').remove();
	        $rootScope.modalShow = false;
	      }
	    }
	    if($scope.$parent.embed) {
	      $scope.cancelInsertEmbedCodeModal = function() {
	        $scope.embedCode = '';
	        jQuery($element).siblings('.editor-insert-embedcode').remove();
	        $rootScope.modalShow = false;
	      }
	    }
	    if($scope.$parent.video || $scope.$parent.quote || $scope.$parent.question) {
	      $scope.cancelTinymceModal = function() {
	        jQuery($element).siblings('.tinymce-modal').remove();
	        $scope.videoModalShow = false;
	        $scope.questionModalShow = true;
	        $scope.quoteModalShow = true;
	        $rootScope.modalShow = false;
	      }
	    }
	    $scope.pasteText = function(event){
	      event.preventDefault();
	      var clp = (event.originalEvent || event).clipboardData;
	      var text = clp.getData('text/plain')
	      text = text.replace(/<p>/gmi, "");
	      text = text.replace(/<p ([^>]*)>/gmi, "");
	      text = text.replace(/<\/p>/g, "");
	      document.execCommand('insertText', false, text);
	    } 
	    var minifyHtmlElement = function(content,ele) {
	      var elements = content.getElementsByTagName(ele);
	      for (var i = 0; i < elements.length; i++) {
	        var htmlEl =elements[i].outerHTML;
	        jQuery(elements[i]).replaceWith(htmlEl.replace(/^\s+|\r\n|\n|\r|(>)\s+(<)|\s+$/gm, '$1$2').replace(/<br \/>/g, '').replace(/<\/p>/g, '').replace(/<p>/g, ''));
	      }
	    }
	    var stripEmptyElement = function(content,ele) {
	      var elements = content.getElementsByTagName(ele);
	      var isEmpty = function ( el ){
	        return !jQuery.trim(el.html())
	      }
	      for (var i = 0; i < elements.length; i++) {
	        
	        if (isEmpty(jQuery(elements[i]))) {
	          jQuery(elements[i]).remove();
	        }
	      }
	    }
	    var removeImage = function(parents) {
	      for( var i=0; i < parents.length; i++ ) {
	        if(parents[i].nodeName == 'IMG') {
	          var image = parents[i];
	          jQuery(image).remove();
	        } else if(parents[i].nodeName =='A') {
	          var parentAnchor = parents[i];
	          jQuery(parentAnchor).remove();
	        }else if(parents[i].nodeName == 'CAPTIONBLOCK') {
	          var parentCaption = parents[i];
	          jQuery(parentCaption).remove();
	        }
	      }
	    }
	    var  parseOptionsFunc = parseOptions;
	    var contentSaveFunction = function() {
	      if($scope.$parent.photo || $scope.$parent.aiEditor) {
	        tinyMCE.activeEditor.dom.remove('edit-image');
	      }
	      if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	        tinyMCE.activeEditor.dom.remove('edit-gallery');
	      }
	      if($scope.$parent.embed || $scope.$parent.aiEditor) {
	        tinyMCE.activeEditor.dom.remove('edit-embed');
	      }
	      minifyHtmlElement(tinymce.activeEditor.getBody(),"script")
	      stripEmptyElement(tinymce.activeEditor.getBody(),"a")
	      var postContent = tinymce.activeEditor.getContent();
	      if($scope.$parent.photo || $scope.$parent.aiEditor) {
	        postContent.replace(/\<captionblock([^\]].*?)>([^\]]*?)\<\/captionblock>/g, function(all, attr, con) {
	          var parseOptions = parseOptionsFunc(attr);
	          if(parseOptions.signature_url) {
	            var signatureUrl = parseOptions.signature_url
	          } else {
	            var signatureUrl = ''
	          }
	          if(parseOptions.image_link) {
	            var imageLink = 'image_link="'+parseOptions.image_link+'"'
	          } else {
	            var imageLink = ''
	          }
	          if(parseOptions.image_target_blank) { 
	            var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
	          } else {
	            var imageTargetBlank = ''
	          }
	          var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	          postContent = postContent.replace( all,'[caption id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+']'+con+'[/caption]\n\n');
	        });
	      }
	      if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	        postContent.replace(/\<galleryblock([^\]].*?)>(.*?)\<\/galleryblock>/g, function(all, attr, con) {
	          postContent = postContent.replace( all, con+'\n\n');
	        });
	      }
	      if($scope.$parent.embed || $scope.$parent.aiEditor) {
	        postContent.replace(/\<embedblock([^\]].*?)>(.*?)\<\/embedblock>/g, function(all, attr, con) {
	          var parseOptions = parseOptionsFunc(attr);
	          var type = parseOptions.type || parseOptions.src;
	          postContent = postContent.replace( all,'[embed type="'+type+'"]'+con+'[/embed]\n\n');
	        });
	      }
	      postContent = reverseWpautop(postContent);
	      if($scope.$parent.aiEditor) {
	        // Find the editor instance by looking for the iframe with ui-tinymce prefix
	        var editors = tinymce.editors;
	        var targetEditor = null;
	        
	        // Find the editor that's in our scope
	        for (var i = 0; i < editors.length; i++) {
	            var editorElement = editors[i].getElement();
	            if (editorElement && editorElement.closest('#tinymce-basic-1')) { // order 1 is suggestion editor
	                targetEditor = editors[i];
	                break;
	            }
	        }
	
	        // editorText is actually aiSuggestion from parent scope
	        if (targetEditor) {
	            $scope.$parent.editorText.content = targetEditor.getContent();
	        } else {
	          $scope.$parent.editorText.content = tinymce.activeEditor.getContent();
	        }
	        
	        // Force digest cycle if needed
	        if (!$scope.$$phase && !$scope.$root.$$phase) {
	          $scope.$apply();
	        }
	      } else {
	        $scope.$parent.editorText.content = postContent;
	      }
	    }
	    var optionsToolbar = '';
	    if($scope.$parent.options.length>0) {
	      for(var i = 0;i<$scope.$parent.options.length;i++) {
	        optionsToolbar = optionsToolbar + ' '+ $scope.$parent.options[i] +' |'
	      }
	    }
	    var toolbar = 'formath2 formath3 | bold italic  | bullist numlist | hr | link unlink |'+ optionsToolbar +' pagebreak | undo redo | fullscreen '
	    if($scope.$parent.aiEditor) {
	      toolbar = 'bold italic | link unlink | undo redo'
	    }
	    var validChildren = ''
	    if($scope.$parent.embed || $scope.$parent.aiEditor) {
	      validChildren = validChildren + ',embedblock[blockquote,script,iframe,div]'
	    }
	    var extendedValidElements = '';
	    if($scope.$parent.photo || $scope.$parent.aiEditor) {
	      extendedValidElements = extendedValidElements + ',captionblock[id|align|width|height|signature_url]'
	    }
	    if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	      extendedValidElements = extendedValidElements + ',galleryblock[ids|title|safe|span|id]'
	    }
	    if($scope.$parent.embed || $scope.$parent.aiEditor) {
	      extendedValidElements = extendedValidElements + ',embedblock[*]'
	    }
	    var customElements = '';
	    if($scope.$parent.photo || $scope.$parent.aiEditor) {
	      customElements = customElements + 'captionblock'
	    }
	    if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	      customElements = customElements + ',galleryblock'
	    }
	    if($scope.$parent.embed || $scope.$parent.aiEditor) {
	      customElements = customElements + ',embedblock'
	    }
	    var link = ($scope.$parent.customLink)?'customLink':'link'
	    $scope.tinymceOptions = {
	      selector: "textarea",
	      id: 'tinymce-basic-'+$scope.$parent.order,
	      format:'raw',
	      menubar:false,
	      verify_html : true,
	      plugins: [
	          'lists '+link+' image anchor',
	          'fullscreen',
	          'autoresize hr pagebreak paste'
	      ],
	      skin: false,
	      // Prevent HTML entity conversion to preserve &quot; in title attributes
	      entity_encoding: 'raw',
	      encoding: 'html',
	      // Disable automatic entity conversion
	      convert_urls: false,
	      urlconverter_callback: function(url,node,on_save, name) {
	        var url = url;
	        if(!url.includes('http') && node.nodeName == 'A' && name=='href' && !url.includes('#blogpost_')) {
	          url= 'http://' + url
	        }
	        return url 
	      },
	      // // theme : 'modern',
	      toolbar: toolbar,
	      valid_elements : "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
	      + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
	      + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
	      + "name|href|target|title|class|onfocus|onblur|style],strong/b,em/i,strike,u,"
	      + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
	      + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
	      + "-blockquote[*],-table[border=0|cellspacing|cellpadding|width|frame|rules|"
	      + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
	      + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
	      + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
	      + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,#div,"
	      + "span[*],-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
	      + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
	      + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
	      + "|height|src|*],script[src|type|language|async|defer|charset],map[name],area[shape|coords|href|alt|target],bdo,"
	      + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
	      + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
	      + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
	      + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
	      + "q[cite],samp,select[disabled|multiple|name|size],small,"
	      + "textarea[cols|rows|disabled|name|readonly],tt,var,big,time,iframe[*],-section[*]",
	      extended_valid_elements : "+svg[*],+g[*],+path[*],+video[*],+source[*]" + extendedValidElements,
	      custom_elements: customElements,
	      valid_children: "+p[strong|a|b|img|i|br|em|script|iframe|blockquote|time],+a[div]"+ validChildren, // "+" add valid children
	      content_css: [
	          'tinymce/custom-tinymce.css?v=13'
	      ],
	      body_class: 'custom_class',
	      default_link_target: "_blank",
	      rel_list: [
	        {title: 'DoFollow', value: ''},
	        {title: 'NoFollow', value: 'nofollow'},
	        {title: 'Sponsored', value: 'sponsored'}
	      ],
	      target_list:[
	        { title: 'Current window', value: '' },
	        { title: 'New window', value: '_blank' }
	      ],
	      forced_root_block : false,
	      force_p_newlines : true,
	      remove_linebreaks : false,
	      relative_urls : false,
	      remove_script_host : false,
	      indent: false,
	      // paste_text_sticky_default: true,
	      // force_br_newlines : true,
	      remove_trailing_nbsp : false,
	      style_formats: [
	        {title: 'Heading 2', format: 'h2'},
	        {title: 'Heading 3', format: 'h3'},
	        {title: 'Heading 4', format: 'h4'},
	        {title: 'Heading 5', format: 'h5'},
	        {title: 'Heading 6', format: 'h6'},
	      ],
	      paste_preprocess: function(plugin, args) {
	        // Decode HTML entities while preserving HTML structure
	        function decodeHtml(html) {
	          var txt = document.createElement("textarea");
	          txt.innerHTML = html;
	          return txt.value;
	        }
	
	        var decodedContent = decodeHtml(args.content);
	
	        // Check if content contains embedblock, galleryblock or captionblock
	        if (/<(embed|gallery|caption)block/i.test(decodedContent)) {
	          // Set the decoded HTML content back to args.content so it gets pasted as HTML
	          args.content = decodedContent;
	          return;
	        }
	
	        // Only block actual script/iframe tags or javascript: URLs
	        var dangerousPattern = /(<script|<iframe|&lt;script|&lt;iframe|script<\/span>|iframe<\/span>|javascript:)/i;
	        if (dangerousPattern.test(args.content)) {
	          // Block the paste and notify the user
	          args.content = ''; // Clear the content
	          $scope.$apply(function() {
	            alertService('danger', 'Oops!', 'Pasting of <script> or <iframe> tags is not allowed! Use embed code button.');
	          });
	          return;
	        }
	
	        // For other content, apply the whitelist
	        var whitelist = 'p,strong,i,em,br,a';
	        var content = args.content;
	        if(args.content.match(/<br>|<br \/>/g)) {
	          content = wpautop(args.content.replace(/<br>|<br \/>/g, "\n"));
	        }
	        var stripped = jQuery('<div>' + content + '</div>');
	        var els = stripped.find('*').not(whitelist);
	        for (var i = els.length - 1; i >= 0; i--) {
	          var e = els[i];
	          jQuery(e).replaceWith(e.innerHTML);
	        }
	        // Strip all class and id attributes
	        stripped.find('*').removeAttr('id').removeAttr('class');
	        // Return the clean HTML
	        args.content = stripped.html();
	      },
	      paste_postprocess : function(pl, o) {
	          // remove extra line breaks
	          o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/ig, " ");
	      },
	      init_instance_callback: function (editor) {
	        editor.on('SetContent', function (e) {
	          editor.setDirty(true);
	          editor.fire('change')
	        }); 
	        
	        // Custom serializer to preserve HTML entities in title attributes
	        editor.serializer.addAttributeFilter('title', function(nodes, name) {
	          var i = nodes.length, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.attr('title')) {
	              // Preserve HTML entities in title attributes
	              var title = node.attr('title');
	              // Ensure quotes are properly encoded as &quot;
	              title = title.replace(/"/g, '&quot;');
	              node.attr('title', title);
	            }
	          }
	        });
	
	        $scope.$watch(function(){
	          return $scope.$parent.update
	        }, function(newValue, oldValue){
	          if (newValue) {
	            editor.setContent($scope.$parent.tinymceModel);
	          }
	        },true);  
	        editor.serializer.addNodeFilter('script,style', function(nodes, name) {
	          var i = nodes.length, node, value, type;
	
	          function trim(value) {
	              /*jshint maxlen:255 */
	              /*eslint max-len:0 */
	              return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
	                      .replace(/^[\r\n]*|[\r\n]*$/g, '')
	                      .replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
	                      .replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	          }
	          while (i--) {
	              node = nodes[i];
	              value = node.firstChild ? node.firstChild.value : '';
	
	              if (value.length > 0) {
	                  node.firstChild.value = trim(value);
	              }
	          }
	        });
	      },
	      setup: function(editor) {
	        editor.on('PreInit', function() {
	          tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
	        });
	        if($scope.$parent.photo || $scope.$parent.gallery || $scope.$parent.embed || $scope.$parent.aiEditor || $scope.$parent.aiEditor) {
	          var setCursorAfterCaptionFunction = function(e) {
	            var dom = tinymce.activeEditor.dom; 
	            var parents = dom.getParents( tinymce.activeEditor.selection.getNode() );
	            function setCursorToNewParagraph(){
	              var newParagraph = dom.select( 'p#' + uniqueID )[0];
	              tinymce.activeEditor.selection.setCursorLocation( newParagraph );
	            }
	            for( var i=0; i < parents.length; i++ ) {
	              var currentNode = parents[i];
	              // Insert empty paragraph at the end of the parent of the closest custom tag
	              if( currentNode.nodeName == 'CAPTIONBLOCK' || currentNode.nodeName == 'GALLERYBLOCK' || currentNode.nodeName == 'EMBEDBLOCK') {
	                  // dom.insertAfter doesn't work reliably
	                  if(jQuery(currentNode).parent('p').get(0)) {
	                    currentNode = jQuery(currentNode).parent('p')
	                  }
	                  if(e) {
	                    var event = window.event ? window.event : e;
	                    if(event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
	                      var uniqueID = dom.uniqueId();
	                      if(!e.shiftKey) {
	                        jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
	                        setCursorToNewParagraph() 
	                      } else if (event.keyCode == 13 && e.shiftKey) {
	                        jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertBefore( currentNode );
	                        setCursorToNewParagraph()
	                      }
	                      e.preventDefault();
	                      // Move to the new node
	                    }
	                  } else {
	                    var uniqueID = dom.uniqueId();
	                    jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
	                    
	                    // Move to the new node
	                    setCursorToNewParagraph()
	                  }
	                  // Don't create an extra paragraph
	                  editor.setDirty(true);
	                  editor.fire('change')
	                  break;
	              }
	            }
	          }
	        }
	        if($scope.$parent.photo) {
	          var editImageArray = {};
	          var image_id;
	          var insertOrUpdateImage = function(imgArray,update) {
	            var insertImage={};
	            // var insertImages = '';
	            for(var i=0; i<imgArray.length;i++) {
	              insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
	              if(imgArray[i].link_to) {
	                insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	                if(imgArray[i].target_blank) {
	                 insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	                }
	              }
	              if(imgArray[i].signature) {
	                if(imgArray[i]._id in editImageArray) {
	                  editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
	                }
	                if(imgArray[i].meta && imgArray[i].meta.signature_url) {
	                  var signatureUrl = imgArray[i].meta.signature_url
	                } else {
	                  var signatureUrl = ''
	                }
	                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
	                if (imgArray[i].link_to) {
	                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                  if(imgArray[i].target_blank) {
	                    insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                  }
	                };
	              } else {
	                insertImage[i] = '<p>'+insertImage[i]+'</p>';
	                if(imgArray[i]._id in editImageArray) {
	                  editImageArray[imgArray[i]._id].signature_image = null;
	                }
	              }
	              if(!update) {
	                setCursorAfterCaptionFunction();
	              }
	              tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
	            //  insertImages = insertImages.concat(insertImage[i]);
	            }
	          }
	          var insertOrUpdateImage = function(imgArray,update) {
	            var insertImage={};
	            // var insertImages = '';
	            for(var i=0; i<imgArray.length;i++) {
	              insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
	              if(imgArray[i].link_to) {
	                insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	                if(imgArray[i].target_blank) {
	                 insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	                }
	              }
	              if(imgArray[i].signature) {
	                if(imgArray[i]._id in editImageArray) {
	                  editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
	                }
	                if(imgArray[i].meta && imgArray[i].meta.signature_url) {
	                  var signatureUrl = imgArray[i].meta.signature_url
	                } else {
	                  var signatureUrl = ''
	                }
	                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
	                if (imgArray[i].link_to) {
	                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                  if(imgArray[i].target_blank) {
	                    insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                  }
	                };
	              } else {
	                insertImage[i] = '<p>'+insertImage[i]+'</p>';
	                if(imgArray[i]._id in editImageArray) {
	                  editImageArray[imgArray[i]._id].signature_image = null;
	                }
	              }
	              if(!update) {
	                setCursorAfterCaptionFunction();
	              }
	              tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
	            //  insertImages = insertImages.concat(insertImage[i]);
	            }
	          }
	          var addMediaListener = $scope.$on("add-media-to-editor",function(event, data) {
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            for(var i=0;i<data.insertMediaArray.length;i++) {
	    
	              if(data.insertMediaArray[i].align === 'undefined' || !data.insertMediaArray[i].align) data.insertMediaArray[i].align = 'alignnone' 
	              editImageArray[data.insertMediaArray[i]._id] = {
	                id : data.insertMediaArray[i]._id,
	                align : data.insertMediaArray[i].align,
	                href : data.insertMediaArray[i].href,
	                target_blank : data.insertMediaArray[i].target_blank,
	                signature_image : data.insertMediaArray[i].signature || null
	              }
	            }
	            insertOrUpdateImage(data.insertMediaArray);
	            setTimeout(function() {
	              tinymce.activeEditor.execCommand('mceAutoResize');
	            },100)
	          });
	          $scope.$on('$destroy', addMediaListener);
	          var updateMediaListener = $scope.$on("update-image-editor",function(event, data) {
	            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	            var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            setCursorAfterCaptionFunction();
	            removeImage(parents)
	            if(data.updateImageObject.align === 'undefined' || !data.updateImageObject.align) data.updateImageObject.align = 'alignnone';
	            var insertMediaArray = [data.updateImageObject];
	            insertOrUpdateImage(insertMediaArray,true);
	            var editorContentBody = tinymce.activeEditor.getBody();
	            stripEmptyElement(editorContentBody,"p");
	            tinyMCE.activeEditor.dom.remove(nodeImage);   
	          });
	          $scope.$on('$destroy', updateMediaListener);
	          var deleteMedia = $scope.$on("delete-media",function(event, data) {
	            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	            var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('selected-image')
	            removeImage(parents)
	            editor.setDirty(true);
	            editor.fire('change')   
	          });
	          $scope.$on('$destroy', deleteMedia);
	        }
	        if($scope.$parent.gallery) {
	          var addSlideshowListener = $scope.$on("insert-gallery",function(event, data) {
	            if(data.update) {
	              tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
	              tinyMCE.activeEditor.dom.remove('edit-gallery');
	              setCursorAfterCaptionFunction();
	              tinyMCE.activeEditor.dom.remove('selected-gallery');
	            }
	            var attachments_ids = data.attachments_ids.join();
	            var title;
	            if(data.gallery_title) {
	              title = data.gallery_title
	            } else {
	              title=''
	            }
	            var insertslideShowShortcode = '<galleryblock ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '">[gallery ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '"]</galleryblock>';
	            setCursorAfterCaptionFunction();
	            tinymce.activeEditor.execCommand('mceInsertContent', false, insertslideShowShortcode);
	          });
	          $scope.$on('$destroy', addSlideshowListener);
	        }
	        if($scope.$parent.telegraftv) {
	          var addTelegrafTvListener = $scope.$on("insert-telegraftv",function(event, data) {
	            var postContent = $scope.$parent.editorText.content;
	            var validation = true;
	            postContent.replace(/\[video(.*?)?\](?:([\s\S]*?)(\[\/video\]))?/g, function(all, attr, con) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  if(parseOptions.id == data.videoId) {
	                    validation = false;
	                    alertService('danger','Opps! ', 'This video alredy exist!!!');
	                    return
	                  }
	            });
	            if(validation) {
	              var title=(data.showVideoTitle)? data.title: '';
	              var align = (data.showVideoTitle)? data.align: '';
	              var inserVtelegrafVideoShortcode = '[video id="'+data.videoId + '" title="' + title + '" align="' + align + '"]';
	              setCursorAfterCaptionFunction();
	              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+inserVtelegrafVideoShortcode+'</p>');
	              $timeout(function(){
	                $scope.$parent.cancelVideoModal()
	              },0)
	            }
	          });
	          $scope.$on('$destroy', addTelegrafTvListener);
	        }
	        if($scope.$parent.poll) {
	          var addPollListener = $scope.$on("insert-poll-to-editor",function(event, data) {
	            var postContent = $scope.$parent.editorText.content;
	            var validation = true;
	            postContent.replace(/\[poll(.*?)?\](?:([\s\S]*?)(\[\/poll\]))?/g, function(all, attr, con) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  if(parseOptions.id == data._id) {
	                    validation = false;
	                    alertService('danger','Opps! ', 'This poll alredy exist!!!');
	                    return
	                  }
	            });
	            if(validation) {
	              if(data.hasOwnProperty('result')) {
	                var insertPollShortcode = '[poll id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/poll]';
	              } else {
	                var insertPollShortcode = '[poll id="'+data._id + '"]'+data._id+'[/poll]';
	              }
	              setCursorAfterCaptionFunction();
	              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPollShortcode+'</p>');
	            }
	          });
	          $scope.$on('$destroy', addPollListener);
	        }
	        if($scope.$parent.rating) {
	          var addRatingListener = $scope.$on("insert-rating-to-editor",function(event, data) {
	            var postContent = $scope.$parent.editorText.content;
	            var validation = true;
	            postContent.replace(/\[rating(.*?)?\](?:([\s\S]*?)(\[\/rating\]))?/g, function(all, attr, con) {
	              var parseOptions = parseOptionsFunc(attr);
	              if(parseOptions.id == data._id) {
	                validation = false;
	                alertService('danger','Opps! ', 'This rating alredy exist!!!');
	                return
	              }
	            });
	            if(validation) {  
	              if(data.hasOwnProperty('result')) {
	                var insertRatingShortcode = '[rating id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/rating]';
	              } else {
	                var insertRatingShortcode = '[rating id="'+data._id + '"]'+data._id+'[/rating]';
	              }
	              setCursorAfterCaptionFunction();  
	              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertRatingShortcode+'</p>');
	            }
	          });
	          $scope.$on('$destroy', addRatingListener);
	        }
	        if($scope.$parent.blog) {
	          var addBlogListener = $scope.$on("insert-blog-to-editor",function(event, data) {
	            var postContent = $scope.$parent.editorText.content;
	            var validation = true;
	            postContent.replace(/\[liveblog(.*?)?\](?:([\s\S]*?)(\[\/liveblog\]))?/g, function(all, attr, con) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  if(parseOptions.id == data._id) {
	                    validation = false;
	                    alertService('danger','Opps! ', 'This live blog alredy exist!!!');
	                    return
	                  }
	            });
	            if(validation) {
	              var insertBlogShortcode = '[liveblog id="'+data._id + '"]'+data._id+'[/liveblog]';
	              setCursorAfterCaptionFunction();
	              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertBlogShortcode+'</p>');
	            }
	          });
	          $scope.$on('$destroy', addBlogListener);
	        }
	        editor.on("init", function() {
	          setModalEditorHeight()
	          if($scope.$parent.editorCharCount) {
	            // Add character counter element after the editor
	            var counterHtml = '<div class="editor-character-count">Characters: <span ng-class="{\'danger-color\': charCount < 800}">{{charCount}}</span></div>';
	            jQuery($element).find('.mce-edit-area').after($compile(counterHtml)($scope));
	            // Initial count
	            updateCharacterCount();
	          }
	          var statusbar_editor = jQuery($element).find(".mce-statusbar");
	          if($scope.$parent.textModePermision || $scope.$parent.photo) {
	            var change_preview_wrap = jQuery($element).siblings(".change-preview-wrapper");
	          }
	          if($scope.$parent.photo) {
	            var add_madia_editor = jQuery($element).siblings(".change-preview-wrapper").find(".add-media-editor");
	          }
	          var toolbar_editor = jQuery($element).find(".mce-toolbar-grp");
	          var editarea_editor = jQuery($element).find(".mce-edit-area");
	          jQuery(editarea_editor).after($compile(editorHtml)($scope));
	          var editor_plain_text = jQuery($element).find(".editor-plain-text");
	          jQuery(editor_plain_text).on('input', function () {
	            autoResizeHeight(this)
	          }); 
	          $scope.onScrollAction = function(){
	              var width = jQuery('.single-post--left-col').width() -2;
	              var offset = jQuery($element).offset();
	              var topPos = offset.top;
	              var leftPos = offset.left;
	              editorHeightFunction();
	              //the current height
	              var y = window.scrollY || window.pageYOffset;
	              //If the current Y is bigger than the element. (you scrolled beyond the element)
	              if($scope.$parent.textModePermision || $scope.$parent.photo) {
	                var change_preview_wrapHeight = jQuery(change_preview_wrap).outerHeight()
	              } else {
	                var change_preview_wrapHeight = 0
	              }
	              if(y >= topPos - change_preview_wrapHeight && y< topPos + editorHeight - 150){
	                jQuery(editarea_editor).css('padding-top',jQuery(toolbar_editor).outerHeight()+change_preview_wrapHeight);
	                jQuery(toolbar_editor).css({'position':'fixed','top':change_preview_wrapHeight,'left':leftPos, 'z-index':9999,'width':width,'border':'1px solid rgba(0,0,0,0.2)'});
	                if($scope.$parent.textModePermision || $scope.$parent.photo) {
	                  jQuery(change_preview_wrap).css({'position':'fixed','top':0,'left':leftPos, 'z-index':9999,'width':width +2,'border-bottom':'none'});
	                }
	                if(!$scope.editor_preview_visual && $scope.$parent.textModePermision) {
	                  jQuery(change_preview_wrap).css({'border-bottom':'1px solid rgba(0,0,0,0.2)'});
	                }
	                  //do something
	              } else {
	                jQuery(editarea_editor).css('padding-top',0);
	                jQuery(toolbar_editor).css({'position':'static','top':'auto','left':'auto', 'z-index':9999,'width':'auto','border':'none'});
	                if($scope.$parent.textModePermision || $scope.$parent.photo) {
	                  jQuery(change_preview_wrap).css({'position':'static','width':'100%','border-bottom':'none'});
	                }
	                if(!$scope.editor_preview_visual && $scope.$parent.textModePermision) {
	                  jQuery(change_preview_wrap).css({'border-bottom': 'none'});
	                }
	              }
	          };
	          $scope.onResizeAction = function() {
	            if($scope.windowWidth == window.innerWidth) return
	            $scope.windowWidth = window.innerWidth
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	            $scope.onScrollAction()
	            setModalEditorHeight()
	          }
	          angular.element($window).on('scroll', $scope.onScrollAction);
	          angular.element($window).on('resize', $scope.onResizeAction);
	          $scope.$on("change-editor",function(event, data) {
	            if(data.editor_preview == 'visual') {
	                $scope.editor_preview_visual = true;
	                jQuery(add_madia_editor).removeClass('hidden');
	                jQuery(toolbar_editor).removeClass('hidden');
	                jQuery(editarea_editor).removeClass('hidden');
	                jQuery(statusbar_editor).removeClass('hidden');
	                jQuery(editor_plain_text).addClass('hidden');
	                if($scope.$parent.editorCharCount) {
	                  jQuery($element).find('.editor-character-count').removeClass('hidden');
	                }
	                var editorContent = $scope.$parent.editorText.content;
	                if($scope.$parent.photo) {
	                  editorContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
	                    var parseOptions = parseOptionsFunc(attr);
	                    if(parseOptions.signature_url) {
	                      var signatureUrl = parseOptions.signature_url
	                    } else {
	                    var signatureUrl = ''
	                    }
	                    if(parseOptions.image_link) {
	                      var imageLink = 'image_link="'+parseOptions.image_link+'"'
	                    } else {
	                      var imageLink = ''
	                    }
	                    if(parseOptions.image_target_blank) {
	                      var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
	                    } else {
	                      var imageTargetBlank = ''
	                    }
	                    var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	                    editorContent = editorContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
	                  });
	                }
	                if($scope.$parent.gallery) {
	                  editorContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
	                    var parseOptions = parseOptionsFunc(attr);
	                    var title;
	                    if(parseOptions.title) {
	                      title =parseOptions.title
	                    } else {
	                      title=''
	                    }
	                    editorContent = editorContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
	                  });
	                }
	                if($scope.$parent.embed) {
	                  editorContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
	                    var parseOptions = parseOptionsFunc(attr);
	                    var type = parseOptions.type || parseOptions.src;
	                    editorContent = editorContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
	                  });
	                }
	                editorContent = wpautop(editorContent)
	                tinyMCE.activeEditor.setContent(editorContent);
	                contentSaveFunction();
	            } else {
	                $scope.editor_preview_visual = false;
	                stripEmptyElement(tinymce.activeEditor.getBody(),"p");
	                contentSaveFunction();
	                jQuery(editor_plain_text).removeClass('hidden');
	                autoResizeHeight(editor_plain_text);
	                jQuery(editarea_editor).addClass('hidden');
	                jQuery(statusbar_editor).addClass('hidden');
	                jQuery(toolbar_editor).addClass('hidden');
	                jQuery(add_madia_editor).addClass('hidden');
	                if($scope.$parent.editorCharCount) {
	                  jQuery($element).find('.editor-character-count').addClass('hidden');
	                }
	            }
	          });
	        });
	        editor.on('keydown', function( event ) {
	          if($scope.$parent.photo || $scope.$parent.aiEditor) {
	            tinyMCE.activeEditor.dom.remove('edit-image');
	          }
	          if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	          }
	          if($scope.$parent.embed || $scope.$parent.aiEditor) {
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	          }
	          if($scope.$parent.photo || $scope.$parent.gallery || $scope.$parent.embed || $scope.$parent.aiEditor) {
	            if (event.keyCode === 8) {
	              // Get the currently selected node within the editor
	              var selectedNode = editor.selection.getNode();
	      
	              // Check if the selected node is a paragraph
	              if (selectedNode && selectedNode.nodeName === 'P') {
	                  // Check if the cursor is positioned at the beginning of the paragraph
	                  var selection = editor.selection.getRng();
	                  if (selection.startOffset === 0 && selection.endOffset === 0) {
	                      // Get the previous sibling of the paragraph
	                      var prevSibling = selectedNode.previousSibling;
	      
	                      // Check if the previous sibling is an embedblock
	                      if (prevSibling && (prevSibling.nodeName === 'CAPTIONBLOCK' || prevSibling.nodeName === 'EMBEDBLOCK' || prevSibling.nodeName === 'GALLERYBLOCK')) {
	                          // Prevent the default behavior of the backspace key
	  
	                          event.preventDefault();
	                          if(!selectedNode.textContent.trim()) {
	                            editor.dom.remove(selectedNode);
	                          }
	                          var range = editor.dom.createRng();
	                          range.selectNodeContents(prevSibling);
	                          range.collapse(false); // Move to the end
	                          editor.selection.setRng(range);
	                          return
	                      }
	                  }
	              }
	            }
	            setCursorAfterCaptionFunction(event);
	          }
	        });
	        editor.on("click", function(e) {
	          if($scope.$parent.parentObj.category =='bbc') {
	            jQuery(tinymce.activeEditor.getBody()).addClass('bbc')  
	          } else {
	            jQuery(tinymce.activeEditor.getBody()).removeClass('bbc')
	          }
	          if($scope.$parent.photo || $scope.$parent.aiEditor) {
	            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	          }
	          if($scope.$parent.gallery || $scope.$parent.aiEditor) {
	            var nodeGallery = tinyMCE.activeEditor.dom.get('selected-gallery');
	          }
	          if($scope.$parent.embed || $scope.$parent.aiEditor) {
	            var nodeEmbed = tinyMCE.activeEditor.dom.get('selected-embed');
	          }
	          var classes = jQuery(nodeImage).attr('class');
	          if(classes) {
	            var classesArray = classes.split(' ');
	            if(classesArray.length>1) {
	              image_id = classesArray[1].substr(9);
	            } else {
	              image_id = classesArray[0].substr(9);
	            }
	          }  
	          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	          if(jQuery(e.target).hasClass('mce-i-cut')) {
	            var selectedElement = null;
	            if(nodeImage) {
	              selectedElement = tinyMCE.activeEditor.dom.get('selected-image');
	            } else if(nodeGallery) {
	              selectedElement = tinyMCE.activeEditor.dom.get('selected-gallery');
	            } else if(nodeEmbed) {
	              selectedElement = tinyMCE.activeEditor.dom.get('selected-embed');
	            }
	            
	            if(selectedElement) {
	              var elementToCopy;
	              if(nodeImage) {
	                for(var i=0; i < parents.length; i++) {
	                  if(parents[i].nodeName =='CAPTIONBLOCK') {
	                    elementToCopy = parents[i].outerHTML;
	                  }
	                }
	              } else {
	                elementToCopy = selectedElement.outerHTML;
	              }
	
	              // Copy to clipboard
	              navigator.clipboard.writeText(elementToCopy).then(function() {
	                // Remove the element after successful copy
	                if(nodeImage) {
	                  removeImage(parents);
	                } else if(nodeGallery) {
	                  jQuery(selectedElement).remove();
	                  tinyMCE.activeEditor.dom.remove('edit-gallery');
	                } else if(nodeEmbed) {
	                  jQuery(selectedElement).remove();
	                  tinyMCE.activeEditor.dom.remove('edit-embed');
	                }
	                editor.setDirty(true);
	                editor.fire('change');
	                
	                // // Show success message
	                // alertService('success', 'Success!', 'Element copied to clipboard', 1000);
	              }).catch(function(err) {
	                console.error('Failed to copy: ', err);
	                alertService('danger', 'Opps! ', 'Failed to copy element');
	              });
	            }
	          } else if(jQuery(e.target).hasClass('mce-i-remove')) {
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('selected-image')
	            removeImage(parents)
	            editor.setDirty(true);
	            editor.fire('change')         
	          } else if(jQuery(e.target).hasClass('mce-i-remove-gallery')){
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            setCursorAfterCaptionFunction();
	            tinyMCE.activeEditor.dom.remove('selected-gallery')
	            editor.setDirty(true);
	            editor.fire('change')
	          } else if(jQuery(e.target).hasClass('mce-i-editgallery')) {
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            if(!nodeGallery) return
	            if(jQuery(nodeGallery).attr('title')) {
	              $scope.$parent.imageModalObj.gallery_title = jQuery(nodeGallery).attr('title');
	            }
	            if(jQuery(nodeGallery).attr('safe')) {
	              $scope.$parent.imageModalObj.slideShowUnsafe = !$scope.$eval(jQuery(nodeGallery).attr('safe'))
	            }
	            if(jQuery(nodeGallery).attr('ids')) {
	              $scope.$parent.imageModalObj.galleryUpdateIds = jQuery(nodeGallery).attr('ids'); 
	              $scope.$parent.addGallerytoEditor('update');
	            } else {
	              alertService('danger', 'Opps! ', 'Gallery shortcode is not valid.\nRemove or correct shortcode');
	            }
	          }else if(jQuery(e.target).hasClass('mce-i-remove-embed')){
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-embed')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	            setCursorAfterCaptionFunction();
	            tinyMCE.activeEditor.dom.remove('selected-embed')
	            editor.setDirty(true);
	            editor.fire('change')
	          } else if(jQuery(e.target).hasClass('mce-i-editimage')) {
	            if($scope.$parent.parentObj.category == 'bbc') return
	            $rootScope.modalShow = true;
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            for( var i=0; i < parents.length; i++ ) {
	                if(parents[i].nodeName =='A') {
	                  var parentAnchor = parents[i];
	                  var image_href = jQuery(parentAnchor).attr('href');
	                  var target_blank = jQuery(parentAnchor).attr('target');
	                  if(target_blank) {
	                    var targetblank = true;
	                  } else {
	                    var targetblank = false;
	                  }
	                  tinyMCE.activeEditor.selection.select(parents[i]);
	                } else if(parents[i].nodeName == 'CAPTIONBLOCK') {
	                  var parentCaptionblock = parents[i];
	                  var image_signature = jQuery(parentCaptionblock).text();
	                  var image_align = (!jQuery(parentCaptionblock).attr('align') || jQuery(parentCaptionblock).attr('align') === 'undefined')? 'alignnone': jQuery(parentCaptionblock).attr('align');
	                  tinyMCE.activeEditor.selection.select(parents[i]);
	                }
	
	            }
	            editImageArray[image_id] = {
	              id : image_id,
	              align : image_align,
	              href : image_href,
	              target_blank : targetblank,
	              signature_image : image_signature
	            }
	            $scope.$emit('edit-image', {editImageObj:editImageArray[image_id]});
	          } else {
	            if(!$scope.$parent.photo && !$scope.$parent.gallery && !$scope.$parent.embed && !$scope.$parent.aiEditor) return
	            var ele = e.target.nodeName;
	            if(nodeImage) {
	              jQuery(nodeImage).removeAttr('id');
	            }
	            if(nodeGallery) {
	              jQuery(nodeGallery).removeAttr('id');
	            }
	            if(nodeEmbed) {
	              jQuery(nodeEmbed).removeAttr('id');
	            }
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	            if(ele =="IMG") {
	                jQuery(e.target).attr('id','selected-image'); 
	                var edit_image_content = '<i class="mce-ico mce-i-editimage"></i><i class="mce-ico mce-i-remove"></i>';
	                if($scope.$parent.aiEditor) {
	                  edit_image_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut image"></i><i class="mce-ico mce-i-remove"></i>' : '';
	                }
	                var pos = tinymce.DOM.getPos(e.target);
	                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
	                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
	                    id:'edit-image',
	                    'style':'left:'+pos.x+'px;top:'+(pos.y + scrollTop)+'px;'
	                }, edit_image_content)
	            }
	            if(ele=="GALLERYBLOCK") {
	                jQuery(e.target).attr('id','selected-gallery');
	                var galleryWidth = jQuery(e.target).innerWidth(); 
	                var edit_gallery_content = '<i class="mce-ico mce-i-editgallery" title="Edit gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>';
	                if($scope.$parent.aiEditor) {
	                  edit_gallery_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>' : '';
	                }
	                var pos = tinymce.DOM.getPos(e.target);
	                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
	                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
	                    id:'edit-gallery',
	                    'style':'left:'+(pos.x + galleryWidth - 45)+'px;top:'+(pos.y + scrollTop)+'px;'
	                }, edit_gallery_content)
	            }
	            if(ele=="EMBEDBLOCK") {
	                jQuery(e.target).attr('id','selected-embed');
	                // var embedWidth = jQuery(e.target).innerWidth(); 
	                var edit_embed_content = '<i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>';
	                if($scope.$parent.aiEditor) { 
	                  edit_embed_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut embed"></i><i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>' : '';
	                }
	                var pos = tinymce.DOM.getPos(e.target);
	                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
	                // var posx =($scope.$parent.aiEditor) ? pos.x + embedWidth - 53 : pos.x + embedWidth - 24;
	                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
	                    id:'edit-embed',
	                    'style':'left:'+pos.x+'px;top:'+(pos.y + scrollTop)+'px;'
	                }, edit_embed_content)
	            }
	          }
	         
	        });
	        editor.on("change", function(e) {
	          if($scope.$parent.aiEditor && e.originalEvent && e.originalEvent.type=='blur') return;
	          // Only trigger on actual content changes, not selection changes
	          contentSaveFunction();
	          if($scope.$parent.editorCharCount) {
	            updateCharacterCount();
	          }
	        });
	        // Add a separate handler for selection changes if needed
	        editor.on("SelectionChange", function(e) {
	          // Handle selection changes separately if needed
	          // This won't trigger the content save function
	        });
	        editor.addButton('formath2', {   
	          icon:'h2',
	          tooltip : 'Make h2', 
	          onclick : function() {
	            editor.execCommand('FormatBlock', false, 'h2');
	          }
	        });
	        editor.addButton('formath3', {   
	          icon:'h3',
	          tooltip : 'Make h3', 
	          onclick : function() {
	            editor.execCommand('FormatBlock', false, 'h3');
	          }
	        });
	        if($scope.$parent.poll) {
	          editor.addButton('poll',{
	            tooltip:'Insert poll',
	            icon:'poll',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.addPollToEditor()
	              },0)
	            }
	          });
	        }
	        if($scope.$parent.rating) {
	          editor.addButton('rating',{
	            tooltip:'Insert rating',
	            icon:'rating',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.addRatingToEditor()
	              },0)
	            }
	          });
	        }
	        if($scope.$parent.blog) {
	          editor.addButton('blog',{
	            tooltip:'Insert live blog',
	            icon:'blog',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.addBlogToEditor()
	              },0)
	            }
	          });
	        }
	        if($scope.$parent.quote) {
	          editor.addButton('quote',{
	            tooltip:'Insert quote tag',
	            icon:'quote',
	            onclick:function() {
	              $scope.requiredQuoteText = false;
	              $rootScope.modalShow = true;
	              $scope.videoModalShow = false;
	              $scope.quoteModalShow = true;
	              $scope.questionModalShow = false;
	              $scope.selectedQuoteAlignAction = {value :'left'};
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              $scope.insertQuote = function() {
	                if($scope.quoteText) {
	                  $scope.requiredQuoteText = false;
	                    var insertQuoteShortcode = '[quote align="'+$scope.selectedQuoteAlignAction.value +'"]'+$scope.quoteText+'[/quote]';
	                    setCursorAfterCaptionFunction();
	                    tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertQuoteShortcode+'</p>');
	                    $element.siblings('.tinymce-modal').remove();
	                    $scope.quoteText = null;
	                    $scope.quoteModalShow = false;
	                    $rootScope.modalShow = false;
	                } else {
	                  alertService('danger','Opps! ', 'Quote text is required');
	                  $scope.requiredQuoteText = true;
	                }
	              }
	            }
	          });
	        }
	        if($scope.$parent.video) {
	          editor.addButton('video',{
	            tooltip:'Insert video',
	            icon:'video',
	            onclick:function() {
	              $scope.requiredVideoId = false;
	              $scope.requiredVideoType = false;
	              $rootScope.modalShow = true;
	              $scope.videoModalShow = true;
	              $scope.quoteModalShow = false;
	              $scope.questionModalShow = false;
	              $scope.selectedTypeVideo = {value:'default'};
	              $scope.videoType = $scope.selectedTypeVideo.value;
	              $scope.videoId = null;
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              $scope.switchTypeVideo = function(type) {
	                $scope.videoType = type;
	              }
	              $scope.insertVideo = function() {
	                var validation = true;
	                if($scope.videoType != 'default') {
	                  $scope.requiredVideoType = false;
	                } else {
	                  validation = false;
	                  $scope.requiredVideoType = true;
	                  alertService('danger','Opps! ', 'Choose video service');
	                }
	                if($scope.videoId) {
	                  $scope.requiredVideoId = false;
	                } else {
	                  validation = false;
	                  alertService('danger','Opps! ', 'Video ID is required');
	                  $scope.requiredVideoId = true;
	                }
	                if(validation) {
	                  $element.siblings('.tinymce-modal').remove();
	                  $scope.selectedTypeVideo = {value:'default'};
	                  $scope.videoModalShow = false;
	                  var insertVideoShortcode = '['+ $scope.videoType +' '+ $scope.videoId +']';
	                  setCursorAfterCaptionFunction();
	                  tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertVideoShortcode+'</p>');
	                  $scope.videoId = null;
	                  $rootScope.modalShow = false;
	                }
	              }
	            }
	          });
	        }
	        if($scope.$parent.question) {
	          editor.addButton('question',{
	            tooltip:'Add a Question',
	            icon:'interview',
	            onclick:function() {
	              $scope.requiredQuestionText = false;
	              $rootScope.modalShow = true;
	              $scope.videoModalShow = false;
	              $scope.quoteModalShow = false;
	              $scope.questionModalShow = true;
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              $scope.insertQuestion = function() {
	                if($scope.questionText) {
	                  $scope.requiredQuestionText = false;
	                    setCursorAfterCaptionFunction();
	                    tinyMCE.activeEditor.selection.setContent('<ul><li class="intervju">'+$scope.questionText+'</li></ul>');
	                    $element.siblings('.tinymce-modal').remove();
	                    $scope.questionText  = null;
	                    $scope.quoteModalShow = false;
	                    $rootScope.modalShow = false;
	                } else {
	                  $scope.requiredQuestionText = true;
	                  alertService('danger','Opps! ', 'Question text is required');
	                }
	              }
	            }
	          });
	        }
	        if($scope.$parent.telegraftv) {
	          editor.addButton('telegraftv',{
	            tooltip:'Insert Telegraf TV Video',
	            icon:'telegraf-tv',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.insertVideotoEditor();
	              },0)
	            }
	          });
	        }
	        if($scope.$parent.gallery) {
	          editor.addButton('gallery',{
	            tooltip:'Insert gallery',
	            icon:'gallery',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.addGallerytoEditor();
	              },0)
	            }
	          });
	        }
	        if($scope.$parent.news) {
	          editor.addButton('news',{
	            tooltip:'Insert News',
	            icon:'recommended-news',
	            onclick:function() {
	              $scope.postFromSearchObj = {}
	              $timeout(function() {
	                $element.after($compile(insertPost)($scope));
	                document.getElementById('search-post').focus()
	              },0);
	              $rootScope.modalShow = true;
	              $scope.postFromSearchObj.addPostFromSearch = function(obj){
	                var insertPostShortcode = '[readalso id="'+obj.id +'"][/readalso]';
	                setCursorAfterCaptionFunction();
	                tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPostShortcode+'</p>');
	                setTimeout(function(){
	                  $scope.cancelInsertPostModal()
	                },0)
	              }
	            }
	          });
	        }
	        if($scope.$parent.embed) {
	          editor.addButton('embed',{
	            tooltip:'Insert embed code',
	            icon:'embed',
	            onclick:function() {
	              $timeout(function() {
	                $element.after($compile(insertEmbedCode)($scope));
	                document.getElementById('insert-embedcode').focus()
	              },0);
	              $rootScope.modalShow = true;
	              $scope.insertEmbedCode = function(){
	                if($scope.embedCode) {
	                  var type = 'unknown';
	                  if($scope.config.embed) {
	                    for (var key in $scope.config.embed) {
	                      if($scope.embedCode.includes($scope.config.embed[key])) {
	                        type = key
	                      }
	                    }
	                  }
	                  function replacePWithSpan(html) {
	                    // Define a regular expression pattern to match <p> elements
	                    var pattern = /<p(\s+[^>]*)?>([\s\S]*?)<\/p>/g;
	                
	                    // Replace <p> elements with <span> elements
	                    var newHtml = html.replace(pattern, function(match, attrs, content) {
	                        // Construct the replacement with <span> tag
	                        return '<div' + (attrs || '') + '>' + content + '</div>';
	                    });
	                
	                    return newHtml;
	                }
	                var embed = replacePWithSpan($scope.embedCode);
	                embed = embed.replace(/<br>|<br \/>/g, "");
	                // embed = embed.replace(/\[/g, '(').replace(/\]/g, ')');
	                var insertEmbedShortcode = '<embedblock type="'+type+'">'+embed+'</embedblock>';
	                setCursorAfterCaptionFunction();
	                tinymce.activeEditor.execCommand('mceInsertContent', false, insertEmbedShortcode);
	                setCursorAfterCaptionFunction();
	                setTimeout(function(){
	                  $scope.embedCode = '';
	                  $scope.cancelInsertEmbedCodeModal()
	                },0)
	                } else {
	                  $scope.requiredEmbedCode = true;
	                  alertService('danger','Opps! ', 'Embed code is required');
	                }
	              }
	            }
	          });
	        }
	        if($scope.$parent.tag) {
	          editor.addButton('tag',{
	            tooltip:'Insert tag',
	            icon:'tag',
	            onclick:function() {
	              var edSelection = tinymce.activeEditor.selection;
	              if(!edSelection.getContent()) return;
	              $scope.searchTag = edSelection.getContent({format : 'text'})
	              $timeout(function() {
	                $element.after($compile(insertTag)($scope));
	                document.getElementById('editor-input-tag').focus()
	              },0);
	              $rootScope.modalShow = true;
	              $scope.$on('editor-select-tag', function(event,data) {
	                tinymce.activeEditor.focus();
	                edSelection.setContent('<a id="selected-tag" href="'+data.selectedTagObj.tagUrl+'" target="_blank" rel="noopener">' + edSelection.getContent({format : 'text'}) + '</a>');
	                tinymce.activeEditor.setContent(tinymce.activeEditor.getContent())
	                var edDom = tinymce.activeEditor.dom;
	                var selectedTag = edDom.select('a#selected-tag')[0]
	                edSelection.select(selectedTag);
	                edSelection.collapse(0)
	                $timeout(function(){
	                  edDom.setAttrib('selected-tag', 'id', '');
	                },0)
	                $timeout(function(){
	                  $scope.cancelInsertTagModal()
	                },0)
	              });
	            }
	          });
	        }
	        if($scope.$parent.tolatin) {
	          editor.addButton('tolatin',{
	            tooltip:'Convert to latin',
	            icon:'latin',
	            onclick:function() {
	              var content = tinymce.activeEditor.getContent();
	              
	              content = globalHelpers.specifiedShortcodePlaceholderEditorContent(content, ['embedblock','captionblock']);
	              // Convert remaining content to Latin
	              var latinContent = globalHelpers.cyrillicToLatin(content);
	              // Restore preserved shortcodes
	              latinContent = globalHelpers.specifiedShortcodeRestoreEditorContent(latinContent);
	              tinymce.activeEditor.setContent(latinContent);
	            } 
	          });
	        }
	      }    
	    }
	    $scope.$on('$destroy', function() {
	      angular.element($window).off('scroll', $scope.onScrollAction);
	      angular.element($window).off('resize', $scope.onResizeAction);
	    });
		}
	}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		"use strict";
	  app
	  .directive('tinymceBasic',tinymceBasic);
		tinymceBasic.$inject = ['parseOptions','activeClass','$rootScope'];
	  function tinymceBasic(parseOptions,activeClass,$rootScope) {
	    return {
	      restrict: 'E',
	      scope: {
	          parentObj:"=",
	          update:"=",
	          editorText: '=',
	          order:'=',
	          photo:'=',
	          pollResultDisplay:'=',
	          ratingResultDisplay:'=',
	          galleryInPhoto:'=',
	          attachToPost:'=',
	          editorCharCount:'=',
	          aiEditor:'=',
	          editorModal:'=',
	          customLink:'='
	      },
	      replace:true,
	      template: __webpack_require__(249),
	      link: function(scope, element, attrs, ngModel) {
	        scope.options = []
	        if(scope.aiEditor) {
	          scope.tinymceModel = scope.editorText.content;
	          return;
	        }
	        if(attrs.options) {
	          scope.options = attrs.options.split(',');
	        }
	        if(scope.options.length>0) {
	          for(var i = 0; i<scope.options.length;i++) {
	            scope[scope.options[i]] = true
	          }
	        }
	        if(attrs.photo) {
	          scope.photo = true;
	        }
	        if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
	          scope.textModePermision = true;
	        }
	        var  parseOptionsFunc = parseOptions;
	        scope.$watch(function(){
	          return scope.update
	        }, function(newValue, oldValue){
	          if (newValue) {
	            editorPopulate()
	          }
	        },true);
	        function editorPopulate() {
	          var editorContent = scope.editorText.content
	          if(scope.photo) {
	            editorContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
	              var parseOptions = parseOptionsFunc(attr);
	              if(parseOptions.signature_url) {
	                var signatureUrl = parseOptions.signature_url
	              } else {
	                var signatureUrl = ''
	              }
	              editorContent = editorContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'">'+con+'</captionblock>');
	            });
	          }
	          if(scope.gallery) {
	            editorContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
	              var parseOptions = parseOptionsFunc(attr);
	              var title;
	              if(parseOptions.title) {
	                title =parseOptions.title
	              } else {
	                title=''
	              }
	              editorContent = editorContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
	            });
	          }
	          if(scope.embed) {
	            editorContent.replace(/\[embed([^\]].*?)\]([^\]]*?)\[\/embed\]/g, function(all, attr, con) {
	              var parseOptions = parseOptionsFunc(attr);
	              var type = parseOptions.type || parseOptions.src;
	              editorContent = editorContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
	            });
	          }
	          scope.tinymceModel = wpautop(editorContent);
	        }
	        editorPopulate()
	        scope.editorChangePreviw = function(event, editorPreview) {
	          activeClass.active(event);
	          scope.$broadcast("change-editor",{editor_preview:editorPreview});
	        }
	        scope.pollModalObj = {
	          addPollToEditorShow: false,
	          cancelPollModal:function(){
	            scope.pollModalShow=false;
	            $rootScope.modalShow = false;
	            scope.pollModalObj.addPollToEditorShow= false;
	          }
	        }
	        scope.ratingModalObj = {
	          addRatingToEditorShow: false,
	          cancelRatingModal:function(){
	            scope.ratingModalShow=false;
	            $rootScope.modalShow = false;
	            scope.ratingModalObj.addRatingToEditorShow= false;
	          }
	        }
	        scope.addPollToEditor = function() {
	          scope.pollModalObj.addPollToEditorShow= true;
	          scope.pollModalShow=true;
	          $rootScope.modalShow = true;
	        } 
	        scope.addRatingToEditor = function() {
	          scope.ratingModalObj.addRatingToEditorShow= true;
	          scope.ratingModalShow=true;
	          $rootScope.modalShow = true;
	        }
	        scope.addBlogToEditor = function() {
	          scope.blogModalObj.addBlogToEditorShow = true;
	          scope.blogModalShow=true;
	          $rootScope.modalShow = true;
	        } 
	        scope.blogModalObj = {
	          addBlogToEditorShow:false,
	          cancelBlogModal:function(){
	            scope.blogModalShow=false;
	            $rootScope.modalShow = false;
	            scope.blogModalObj.addBlogToEditorShow = false
	          }
	        }
	        scope.videoModalObj= {
	          insertVideoToEditorModal:false,
	          cancelVideoModal:function() {
	            $rootScope.modalShow = false;
	            scope.videoModalShow = false;
	          }
	        }
	        scope.editImageModalObj ={
	          editImageObj:'',
	          editImagefromEditor:false,
	          cancelImageModal:function() {
	            scope.editImageModalObj.editImagefromEditor = false;
	            $rootScope.modalShow = false;
	          }
	        }
	        scope.imageModalObj = {
	          insertMediatoEditor:false,
	          insertGallery:false,
	          galleryInPhoto:scope.galleryInPhoto,
	          gallery_title:'',
	          galleryUpdateIds:'',
	          slideShowUnsafe:false,
	          updateGallery:false,
	          cancelImageModal:function() {
	            $rootScope.modalShow = false;
	            scope.mediaModal = false;
	            scope.imageModalObj.insertMediatoEditor = false;
	            scope.imageModalObj.insertGallery = false;
	            scope.imageModalObj.updateGallery = false;
	            scope.imageModalObj.gallery_title = '';
	            scope.imageModalObj.slideShowUnsafe = false;
	            scope.imageModalObj.galleryUpdateIds = '';
	          },
	          saveAttachments: function() {
	            scope.$broadcast('attachment-save');
	          }
	        }
	        scope.addMediatoEditor = function() {
	          scope.mediaModal = true;
	          scope.imageModalObj.insertMediatoEditor = true;
	          $rootScope.modalShow = true;
	        }
	        scope.$on("edit-image",function(event, data) {
	          scope.editImageModalObj.editImageObj = data.editImageObj;
	          scope.editImageModalObj.editImagefromEditor = true;
	          event.stopPropagation();
	        });
	        scope.addGallerytoEditor = function(update) {
	          scope.mediaModal = true;
	          scope.imageModalObj.insertGallery = true;
	          $rootScope.modalShow = true;
	          if(update) {
	            scope.imageModalObj.updateGallery = true;
	          }
	        }
	        scope.insertVideotoEditor = function() {
	          $rootScope.modalShow = true;
	          scope.videoModalShow = true;
	          scope.videoModalObj.insertVideoToEditorModal = true;
	        }
	        scope.cancelVideoModal = function() {
	          $rootScope.modalShow = false;
	          scope.videoModalShow = false;
	        }
	      }
	    }
	  }	
	}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(app) {
		'use strict';
		app.directive('uploadPhotoMl',uploadPhotoMl);
		uploadPhotoMl.$inject=['$rootScope', 'API_URL', 'refreshtokenService', 'authtokenService', 'postDataService', 'serverError','alertService','offlineError'];
		function uploadPhotoMl($rootScope, API_URL, refreshtokenService, authtokenService, postDataService, serverError, alertService, offlineError) {
			return {
				restrict: 'E',
				scope: {
	                parentObj:"=",
	                attachToPost:"=",
	                addToMediaLibrary:'='
			    },
			    template: __webpack_require__(250),
			    link: function (scope, element, attrs) {
	                var token = authtokenService.getToken();
	                var state = 'attachments';
	                Dropzone.autoDiscover = false;
	                scope.upload_title = ''
	                scope.upload_signature = 'Foto:';
	                scope.upload_signature_url = '';
	                scope.upload_description = '';
	                scope.selectedPhotoQuality = {value:'medium'};
	                var uploadedFiles = {};
	                scope.ranges = {
	                    'Today': [moment().startOf('day'), moment().endOf('day')],
	                    'Next 30 days': [moment().startOf('day'), moment().add('days', 29).endOf('day')],
	                    'Next 90 days': [moment().startOf('day'), moment().add('days', 89).endOf('day')],
	                    'Next 12 months': [moment().startOf('day'), moment().add('months', 12).subtract('days', 1).endOf('day')]
	                };
	                scope.dzOptions = {
	                    url :API_URL+'upload',
	                    paramName : 'photo',
	                    maxFilesize : '500',
	                    parallelUploads: 1,
	                    acceptedFiles : 'image/jpeg, images/jpg',
	                    addRemoveLinks : true,
	                    autoProcessQueue : true,
	                    dictInvalidFileType: 'This file type is not supported.',
	                    dictFileTooBig:'File size too Big',
	                    headers:{
	                    'x-auth': token,
	                    'x-post-id':(scope.attachToPost)? scope.parentObj.postId:undefined  
	                    },
	                    
	                };
	                scope.dzMethods = {
	                };
	                scope.dzCallbacks = {
	                    'success' : function(file, xhr, response){
	                        if(!scope.parentObj.singleView && scope.attachToPost) return;
	                        file.previewElement.classList.remove("dz-error");
	                        var data = JSON.parse(response.currentTarget.response);
	                        scope.parentObj.data_grid.push(data);
	                        uploadedFiles[data._id] = file
	                        if(scope.addToMediaLibrary) {
	                            scope.$parent.addFileToPhotoLibrary({upload_data:data})
	                        }
	                    },
	                    'error' : function(file,message) {
	                        if(message && message.error && message.error.message) {
	                            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
	                        }
	                    },
	                    'sending':function(file, xhr, formData) {
	                        if(scope.upload_title) {
	                            formData.append('title', scope.upload_title);
	                        }
	                        if(scope.upload_gallery_title) {
	                            formData.append('gallery_title', scope.upload_gallery_title);
	                        }
	                        if(scope.upload_signature) {
	                            formData.append('signature', scope.upload_signature);
	                        }
	                        if(scope.upload_description) {
	                            formData.append('description', scope.upload_description);
	                        }
	                        if(scope.upload_signature_url) {
	                            formData.append('signature_url', scope.upload_signature_url);
	                        }
	                        if(scope.selectedPhotoQuality.value) {
	                            formData.append('quality', scope.selectedPhotoQuality.value);
	                        }
	                    },
	                    'complete':function(file) {
	                        if(file.xhr && file.xhr.status == 401) {
	                            file.previewElement.classList.remove("dz-error");
	                            var promise = refreshtokenService.getAccessToken();
	                            promise.then(
	                                function(answer) {
	                                if(answer==200) {   
	                                    var token = authtokenService.getToken();
	                                    scope.dzOptions.headers['x-auth'] = token;
	                                    if(scope.attachToPost) {
	                                        scope.dzOptions.headers['x-post-id'] = scope.parentObj.postId;
	                                    }
	                                    scope.dzMethods.uploadFile(file)
	                                }
	                                },
	                                function(error) {
	                                },
	                                function(progress) {
	                                // report progress
	                            });
	                        }
	                    }
	                };
	                scope.firstBound = true;
	                var resetRestrictionFunction = function() {
	                    scope.$broadcast('clear-daterange');
	                    scope.numberOfUses = undefined;
	                }
	                scope.addPhotoRestriction = function() {
	                    resetRestrictionFunction();
	                }
	                scope.changeDate = function(value) {
	                  scope.dateRangevalue = value;
	                  scope.switchDate = true;
	            
	                  if(scope.dateRangevalue) {
	                    if(value.startDate && value.endDate) {
	                      scope.date_start = value.startDate.format('YYYY-MM-DD');
	                      scope.date_end = value.endDate.format('YYYY-MM-DD');
	                    } else {
	                      scope.date_start = null;
	                      scope.date_end = null;
	                    }
	                  } else {
	                      scope.date_start = null;
	                      scope.date_end = null;
	                  }
	                }
	                function saveAttachments() {
	                    var attachmentsIds = [];
	                    for (var i=0; i < scope.parentObj.data_grid.length;i++) {
	                        attachmentsIds.push(scope.parentObj.data_grid[i]._id);
	                    }
	                    scope.restrictions = undefined;
	                    if(scope.photoRestriction && (scope.numberOfUses || scope.date_start)) {
	                        scope.restrictions = {
	                            date_from :  (scope.date_start)? scope.date_start: undefined,
	                            date_to :  (scope.date_end)? scope.date_end: undefined,
	                            use_max : (scope.numberOfUses)? parseInt(scope.numberOfUses) : undefined
	                        }
	                    }
	                    if(attachmentsIds.length>0) {
	                        $rootScope.hasLoaded = false;
	                        var saveData = {
	                            'ids': attachmentsIds,
	                            'title': scope.upload_title,
	                            'gallery_title': scope.upload_gallery_title,
	                            'signature': scope.upload_signature,
	                            'description': scope.upload_description,
	                            'signature_url': scope.upload_signature_url,
	                            'restrictions': scope.restrictions
	                        }
	                        var postFunction = function() { 
	                            postDataService.save({
	                              param1:state,
	                              param2:'multi-update'
	                            },saveData).$promise.then(function(data){
	                                if(scope.addToMediaLibrary) {
	                                    scope.$parent.saveUploadedPhoto({'data':saveData})
	                                } else {
	                                    for(var i = 0; i<scope.parentObj.data_grid.length;i++) {
	                                        if(scope.upload_title) {
	                                            scope.parentObj.data_grid[i].title = scope.upload_title;
	                                        }
	                                        if(scope.upload_signature) {
	                                            scope.parentObj.data_grid[i].signature = scope.upload_signature;
	                                        }
	                                        if(scope.upload_description) {
	                                            scope.parentObj.data_grid[i].description = scope.upload_description;    
	                                        }
	                                        if(scope.upload_gallery_title) {
	                                            scope.parentObj.data_grid[i].gallery_title = scope.upload_gallery_title;    
	                                        }
	                                        if(scope.upload_signature_url && scope.parentObj.data_grid[i].meta) {
	                                            scope.parentObj.data_grid[i].meta.signature_url = scope.upload_signature_url;    
	                                        }
	                                    }
	                                }
	                                $rootScope.hasLoaded = true;
	                                alertService('success','Success ', data.message, 2000);
	                            }, function(error){
	                                if(!window.navigator.onLine) {
	                                    offlineError()
	                                    $rootScope.hasLoaded = true;
	                                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                                    return
	                                }
	                                if(error.status ==401) {
	                                    var promise = refreshtokenService.getAccessToken();
	                                    promise.then(
	                                    function(answer) {
	                                        if(answer==200) {
	                                        postFunction();
	                                        }
	                                    },
	                                    function(error) {
	                                        // report something
	                                    },
	                                    function(progress) {
	                                    // report progress
	                                    });
	                                } else if(error.status ==502) {
	                                    serverError()
	                                } else {
	                                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                                }
	                                $rootScope.hasLoaded = true;
	                              
	                            });
	                        }
	                        postFunction();
	                    }
	                }
	                scope.saveAttachments = function() {
	                    saveAttachments()
	                }
	                scope.$on('attachment-save', function (evt, data) {
	                    saveAttachments()
	                })
	                scope.$on('delete-photo-from-upload', function (evt, data) {
	                    for (var i=0; i < scope.parentObj.data_grid.length;i++) {
	                        if(data.id==scope.parentObj.data_grid[i]._id) {
	                            scope.dzMethods.removeFile(uploadedFiles[data.id]);
	                            scope.parentObj.data_grid.splice(i,1);
	                        }
	                    }
	                })
			    }
	        }    
		}
	}


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = function(app) {
	  app.filter('removeCurrentId', function() {
	      return function(array, id) {
	          var filtered = [];
	          if (id) {
	            angular.forEach(array, function(item) {
	              if (item['_id'] != id) {
	                filtered.push(item);
	              }
	            });
	          }else{
	              filtered=array;
	          }
	          return filtered;
	      }
	  })
	  app.filter('sortingCount', function() {
	    return function(array, type, prop) {
	      if(!array || array.length==0) return []
	      return array.sort(function(a,b) {
	        if(type=='descending') {
	          if(isFinite(parseInt(b[prop]) - parseInt(a[prop]))) {
	            return parseInt(b[prop])-parseInt(a[prop])
	          } else {
	            // NaN  na kraj
	            return isFinite(parseInt(a[prop]))? -1:1
	          } 
	        } else if(type=='ascending') {
	          if(isFinite(parseInt(a[prop]) - parseInt(b[prop]))) {
	            return parseInt(a[prop])-parseInt(b[prop])
	          } else {
	            // NaN  na kraj
	            return isFinite(parseInt(a[prop]))? -1:1
	          }
	        }
	      })
	    }
	  })
	}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = function(app) {
	    app.filter('decimalsPersentage', function() {
	      return function(input, decimals) {
	        // Ensure input is a number
	        if (isNaN(input)) return 'N/A';
	        // Default to 2 decimal places if not provided
	        decimals = decimals || 2;
	        // Convert input to fixed decimal places
	        var factor = Math.pow(10, decimals); // 10^decimals
	        return (Math.floor(input * factor*100) / factor).toFixed(decimals);
	      };
	    })
	}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = function(app) {
		app.filter('oiSelectSearchFilter', ['$sce', function($sce) {
	    return function(label, query, item, options, element) {
	
	        var html = '<div title="Remove author">'+ label + ' <span class="select-search-email">(' + item.email + ')</span><span class="close select-search-list-item_selection-remove">×</span></div>';
	
	        return $sce.trustAsHtml(html);
	    };
		}])
		app.filter('oiSelectDropdownFilter', ['$sce', function($sce) {
		    return function(label, query, item, options, element) {
	
		        var html = label + ' <span class="select-search-email">(' + item.email + ')</span>';
	
		        return $sce.trustAsHtml(html);
		 };
		}])	
	}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	(function () {
	    function  intersectionObserverGlobal(ele, cb, rootMargin) {
	        if (typeof Array.isArray === 'undefined') {
	            Array.isArray = function(obj) {
	                return Object.prototype.toString.call(obj) === '[object Array]';
	            }
	        }
	        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype && 'isIntersecting' in window.IntersectionObserverEntry.prototype) {
	            var options = {
	                "rootMargin": (rootMargin)? rootMargin:"0px" 
	            }
	            var lazyEleObserver = new IntersectionObserver(function(entries, observer){
	                entries.forEach(function(entry){
	                    if (entry.isIntersecting) {
	                        var lazyEle = entry.target;
	                        cb(lazyEle);
	                        lazyEleObserver.unobserve(lazyEle);
	                    }
	                });
	            },options);
	            if(Array.isArray(ele)) {
	                ele.forEach(function(item) {
	                    lazyEleObserver.observe(item);
	                })
	            } else {
	                lazyEleObserver.observe(ele);
	            }
	        } else {
	            if(Array.isArray(ele)) {
	                for(var i = 0; i< ele.length;i++) {
	                    cb(ele[i])
	                }
	            } else {
	                cb(ele);
	            }
	        }
	    }
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = intersectionObserverGlobal;
	    } else if (!window.intersectionObserverGlobal) {
	        window.intersectionObserverGlobal = intersectionObserverGlobal;
	    }
	
	})();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	 module.exports = function(app) {
	  'use strict';
	
	  app
	  .directive('snAction', snAction)
	  .directive('snNavigation', snNavigation)
	  ;
	  /* ========================================================================
	   * Sing App actions. Shortcuts available via data-sn-action attribute
	   * ========================================================================
	   */
	  snAction.$inject = ['$rootScope', 'jQuery', '$timeout'];
	  function snAction($rootScope, jQuery, $timeout){
	    var singActions = {
	      'toggle-navigation-state': function(e, scope){
	        scope.app.state['nav-static'] = !scope.app.state['nav-static'];
	      },
	      'toggle-navigation-collapse-state': function(){
	        $rootScope.toggleNavigationCollapseState();
	      },
	      'toggle-chat-sidebar-state': function(){
	        //remove notification sign on a first click
	        jQuery(this).find('.chat-notification-sing').remove();
	        $rootScope.toggleChatSidebarState();
	
	
	        //demo-only stuff. TO-REMOVE in real app!
	        // $timeout(function(){
	        //   // demo: add class & badge to indicate incoming messages from contact
	        //   // .js-notification-added ensures notification added only once
	        //   jQuery('.chat-sidebar-user-group:first-of-type .list-group-item:first-child:not(.js-notification-added)').addClass('active js-notification-added')
	        //     .find('.fa-circle').after('<span class="badge badge-danger pull-right animated bounceInDown">3</span>');
	        // }, 1000)
	      }
	    };
	    return {
	      restrict: 'A',
	      link: function (scope, $el, attrs){
	        if (angular.isDefined(attrs.snAction) && attrs.snAction !== '') {
	          $el.on('click', function(e) {
	            scope.$apply(function(){
	              singActions[attrs.snAction].call($el[0], e, scope);
	            });
	            e.preventDefault();
	          });
	        }
	
	        if (angular.isDefined(attrs.tooltip) && attrs.snAction !== ''){
	          $el.tooltip();
	        }
	      }
	    }
	  }
	
	  /* ========================================================================
	   * Sing App Navigation (Sidebar)
	   * ========================================================================
	   */
	  snNavigation.$inject = ['$timeout', '$rootScope', '$state', 'jQuery', '$window'];
	  function snNavigation($timeout, $rootScope, $state, jQuery, $window){
	    // var SnNavigationDirective = function($el, scope){
	      // this.$el = $el;
	      // this.scope = scope;
	      // this.helpers = scope.app.helpers;
	
	      // publish method to global scope to allow navigation collapsing via api
	    //   $rootScope.toggleNavigationCollapseState = jQuery.proxy(this.toggleNavigationCollapseState, this);
	    // };
	    // SnNavigationDirective.prototype = { // a set of reusable directive private functions
	    //   expandNavigation: function(){
	    //     //this method only makes sense for non-static navigation state
	    //     if (this.isNavigationStatic() && (this.helpers.isScreen('md') || this.helpers.isScreen('lg'))) return;
	
	    //     jQuery('body').removeClass('nav-collapsed');
	
	    //     this.$el.find('.active .active').closest('.collapse').collapse('show')
	    //       .siblings('[data-toggle=collapse]').removeClass('collapsed');
	    //   },
	
	    //   collapseNavigation: function(){
	    //     //this method only makes sense for non-static navigation state
	    //     if (this.isNavigationStatic() && (this.helpers.isScreen('md') || this.helpers.isScreen('lg'))) return;
	
	    //     jQuery('body').addClass('nav-collapsed');
	    //     this.$el.find('.collapse.in').collapse('hide')
	    //       .siblings('[data-toggle=collapse]').addClass('collapsed');
	    //   },
	
	
	    //   /**
	    //    * Check and set navigation collapse according to screen size and navigation state
	    //    */
	    //   checkNavigationState: function(){
	    //     if (this.isNavigationStatic()){
	    //       if (this.helpers.isScreen('sm') || this.helpers.isScreen('xs')){
	    //         this.collapseNavigation();
	    //       }
	    //     } else {
	    //       if (this.helpers.isScreen('md') || this.helpers.isScreen('lg')){
	    //         var view = this;
	    //         $timeout(function(){
	    //           view.collapseNavigation();
	    //         }, this.scope.app.settings.navCollapseTimeout);
	    //       } else {
	    //         this.collapseNavigation();
	    //       }
	    //     }
	    //   },
	
	    //   isNavigationStatic: function(){
	    //     return this.scope.app.state['nav-static'] === true;
	    //   },
	
	    //   changeActiveNavigationItem: function(event, toState, toParams){
	    //     var $newActiveLink = this.$el.find('a[href="' + $state.href(toState, toParams) + '"]');
	
	    //     // collapse .collapse only if new and old active links belong to different .collapse
	    //     if (!$newActiveLink.is('.active > .collapse > li > a')){
	    //       this.$el.find('.active .active').closest('.collapse').collapse('hide');
	    //     }
	    //     this.$el.find('.sidebar-nav .active').removeClass('active');
	
	    //     $newActiveLink.closest('li').addClass('active')
	    //       .parents('li').addClass('active');
	
	    //     // uncollapse parent
	    //     $newActiveLink.closest('.collapse').addClass('in').siblings('a[data-toggle=collapse]').removeClass('collapsed');
	    //   },
	
	    //   toggleNavigationCollapseState: function(){
	    //     if (jQuery('body').is('.nav-collapsed')){
	    //       this.expandNavigation();
	    //     } else {
	    //       this.collapseNavigation();
	    //     }
	    //   },
	
	    //   enableSwipeCollapsing: function(){
	    //     var d = this;
	    //     jQuery('.content-wrap').swipe({
	    //       swipeLeft: function(){
	    //         //this method only makes sense for small screens + ipad
	    //         if (d.helpers.isScreen('lg')) return;
	
	    //         if (!jQuery('body').is('.nav-collapsed')){
	    //           d.collapseNavigation();
	    //         }
	    //       },
	    //       swipeRight: function(){
	    //         //this method only makes sense for small screens + ipad
	    //         if (d.helpers.isScreen('lg')) return;
	
	    //         // check if navigation is collapsing. exiting if true
	    //         if (jQuery('body').is('.nav-busy')) return;
	
	    //         if (jQuery('body').is('.nav-collapsed')){
	    //           d.expandNavigation();
	    //         }
	    //       },
	    //       threshold: this.helpers.isScreen('xs') ? 100 : 200
	    //     });
	    //   },
	
	    //   collapseNavIfSmallScreen: function(){
	    //     if (this.helpers.isScreen('xs') || this.helpers.isScreen('sm')){
	    //       this.collapseNavigation();
	    //     }
	    //   },
	
	    //   _sidebarMouseEnter: function(){
	    //     if (this.helpers.isScreen('md') || this.helpers.isScreen('lg')){
	    //       this.expandNavigation();
	    //     }
	    //   },
	    //   _sidebarMouseLeave: function(){
	    //     if (this.helpers.isScreen('md') || this.helpers.isScreen('lg')){
	    //       this.collapseNavigation();
	    //     }
	    //   }
	    // };
	    return {
	      replace: true,
	      template: __webpack_require__(253),
	      link: function (scope, $el){
	        // var d = new SnNavigationDirective($el, scope);
	
	        // $el.on('mouseenter', jQuery.proxy(d._sidebarMouseEnter, d));
	        // $el.on('mouseleave', jQuery.proxy(d._sidebarMouseLeave, d));
	
	        // // wait until all includes included
	        // $timeout(function(){
	        //   // set active navigation item
	        //   d.changeActiveNavigationItem({}, $state.$current, $state.params);
	
	        //   d.checkNavigationState();
	        // });
	
	        // /**
	        //  * open navigation if collapsed sidebar clicked
	        //  */
	        // $el.on('click', function(){
	        //   if (jQuery('body').is('.nav-collapsed')){
	        //     d.expandNavigation();
	        //   }
	        // });
	
	        // scope.$watch('app.state["nav-static"]', function(newVal, oldVal){
	        //   if (newVal === oldVal) return; // shouldn't they fix it?
	        //   if (!newVal){ // if navigation state is collapsing
	        //     d.collapseNavigation();
	        //   }
	
	        //   // let angular finish doing its stuff so all animation are applied to trigger an event on a ready DOM
	        //   $timeout(function(){
	        //     jQuery($window).trigger('sn:resize');
	        //   })
	        // });
	
	        // // change active navigation item when state change
	        // $rootScope.$on('$stateChangeStart', jQuery.proxy(d.changeActiveNavigationItem, d));
	        // $rootScope.$on('$stateChangeSuccess', jQuery.proxy(d.collapseNavIfSmallScreen, d));
	
	        // // scroll to top manually after page change. seems that it doesn't work out of the box because
	        // // the actual app state is not changed - it remain app.page - only params changed.
	        // $rootScope.$on('$stateChangeSuccess', function(){
	        //   $window.scrollTo(0, 0);
	        // });
	
	        // // enable swipe navigation collapsing
	        // ('ontouchstart' in $window) && d.enableSwipeCollapsing();
	
	        // /* reimplementing bs.collapse data-parent here as we don't want to use BS .panel*/
	        // $el.find('.collapse').on('show.bs.collapse', function(e){
	        //   // execute only if we're actually the .collapse element initiated event
	        //   // return for bubbled events
	        //   if (e.target !== e.currentTarget) return;
	
	        //   var $triggerLink = jQuery(this).prev('[data-toggle=collapse]');
	        //   jQuery($triggerLink.data('parent')).find('.collapse.in').not(jQuery(this)).collapse('hide');
	        // })
	        //   /* adding additional classes to navigation link li-parent for several purposes. see navigation styles */
	        //   .on('show.bs.collapse', function(e){
	        //     // execute only if we're actually the .collapse element initiated event
	        //     // return for bubbled events
	        //     if (e.target !== e.currentTarget) return;
	
	        //     jQuery(this).closest('li').addClass('open');
	        //   }).on('hide.bs.collapse', function(e){
	        //     // execute only if we're actually the .collapse element initiated event
	        //     // return for bubbled events
	        //     if (e.target !== e.currentTarget) return;
	
	        //     jQuery(this).closest('li').removeClass('open');
	        //   });
	
	        // // function initSidebarScroll(){
	        // //   var $sidebarContent = $el.find('.js-sidebar-content');
	        // //   if ($el.find('.slimScrollDiv').length !== 0){
	        // //       $sidebarContent.slimscroll({
	        // //           destroy: true
	        // //       })
	        // //   }
	        // //   $sidebarContent.slimscroll({
	        // //       height: $window.innerHeight,
	        // //       size: '4px'
	        // //   });
	        // // }
	
	        // // jQuery($window).on('sn:resize', initSidebarScroll);
	        // // initSidebarScroll();
	        // jQuery('.collapsed').on('click',function() {
	        //   jQuery(this).closest('li').toggleClass('active');
	        // });
	      }
	    }
	  }
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	 module.exports = function(app) {
	  'use strict';
	  app
	  	.directive('navigationTemplate', navigationTemplate);
	  	navigationTemplate.$inject = [];
	  	function navigationTemplate(){
	  	return {
	  		
	  		template:__webpack_require__(252)
	  	}
	  }
	}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = function(app) {
	  'use strict';
	
	  app
	    .directive('inputGroupNoBorder', inputGroupNoBorder)
	    .directive('inputGroupTransparent', inputGroupNoBorder)
	    .directive('ajaxLoad', ajaxLoad)
	    // .directive('snDemo', snDemo)
	    .directive('snProgressAnimate', snProgressAnimate)
	    .directive('animateNumber', animateNumber)
	    .directive('checkAll', checkAll)
	    // .directive('body', body)
	  ;
	
	  /* ========================================================================
	   * Handle transparent input groups focus
	   * ========================================================================
	   */
	  inputGroupNoBorder.$inject = ['jQuery'];
	  function inputGroupNoBorder(jQuery){
	    return {
	      restrict: 'C',
	      link: function (scope, el){
	        jQuery(el).find('.input-group-addon + .form-control').on('blur focus', function(e){
	          jQuery(this).parents('.input-group')[e.type==='focus' ? 'addClass' : 'removeClass']('focus');
	        });
	      }
	    }
	  }
	
	  /* ========================================================================
	   * Handle transparent input groups focus
	   * ========================================================================
	   */
	  inputGroupTransparent.$inject = ['jQuery'];
	  function inputGroupTransparent(jQuery){
	    return {
	      restrict: 'C',
	      link: function (scope, el){
	        jQuery(el).find('.input-group-addon + .form-control').on('blur focus', function(e){
	          jQuery(this).parents('.input-group')[e.type==='focus' ? 'addClass' : 'removeClass']('focus');
	        });
	      }
	    }
	  }
	
	  /* ========================================================================
	   * Ajax Load micro-plugin
	   * ========================================================================
	   */
	
	  ajaxLoad.$inject = ['jQuery', '$window'];
	  function ajaxLoad(jQuery, $window){
	    return {
	      restrict: 'A',
	      link: function(scope, $el, attrs){
	        $el.on('click change', function(e){
	          var $this = jQuery(this),
	            $target = jQuery($this.data('ajax-target'));
	          if ($target.length > 0 ){
	            e = jQuery.Event('ajax-load:start', {originalEvent: e});
	            $this.trigger(e);
	
	            !e.isDefaultPrevented() && $target.load($this.data('ajax-load'), function(){
	              $this.trigger('ajax-load:end');
	            });
	          }
	          return false;
	        });
	
	        /**
	         * Change to loading state if loading text present
	         */
	        if (attrs.loadingText){
	          $el.on('ajax-load:start', function () {
	            $el.button('loading');
	          });
	          $el.on('ajax-load:end', function () {
	            $el.button('reset');
	          });
	        }
	
	        jQuery($window.document).on('click', '[data-toggle^=button]', function (e) {
	          return jQuery(e.target).find('input').data('ajax-trigger') !== 'change';
	        });
	      }
	    }
	  }
	
	  /* ========================================================================
	   * Sing Demo functions directive. Demo-only functions. Does not affect the core Sing functionality.
	   * Should be removed when used in real app.
	   * ========================================================================
	   */
	  // snDemo.$inject = ['jQuery', '$timeout', '$document'];
	  // function snDemo (jQuery, $timeout, $document){
	  //   return {
	  //     link: function(){
	  //       jQuery($document).on('ajax-load:end', '#load-notifications-btn', function () {
	  //         $timeout(function(){
	  //           jQuery('#notifications-list').find('.bg-attention').removeClass('bg-attention');
	  //         }, 10000)
	  //       });
	  //       jQuery($document).on('ajax-load:end', '#notifications-toggle input', function(){
	  //         jQuery('#notifications-list').find('[data-toggle=tooltip]').tooltip();
	  //       });
	
	  //       $timeout(function(){
	  //         var $chatNotification = jQuery('#chat-notification');
	  //         $chatNotification.removeClass('hide').addClass('animated fadeIn')
	  //           .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
	  //             $chatNotification.removeClass('animated fadeIn');
	  //             $timeout(function(){
	  //               $chatNotification.addClass('animated fadeOut')
	  //                 .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
	  //                   $chatNotification.addClass('hide');
	  //                 });
	  //             }, 4000);
	  //           });
	  //         $chatNotification.siblings('[data-sn-action="toggle-chat-sidebar-state"]').append('<i class="chat-notification-sing animated bounceIn"></i>')
	  //       }, 4000)
	  //     }
	  //   }
	  // }
	
	  /* ========================================================================
	   * Animate Progress Bars
	   * ========================================================================
	   */
	  snProgressAnimate.$inject = ['$timeout'];
	  function snProgressAnimate($timeout){
	    return {
	      link: function (scope, $el){
	        var value = $el.data('value'),
	          $bar = $el.find('.progress-bar');
	        $bar.css('opacity', 0);
	        $timeout(function(){
	          $bar.css({
	            transition: 'none',
	            width: 0,
	            opacity: 1
	          });
	          $timeout(function(){
	            $bar.css('transition', '').css('width', value + '%');
	          })
	        })
	      }
	    }
	  }
	
	  /* ========================================================================
	   * Animate Number jQuery plugin customized wrapper
	   * ========================================================================
	   */
	  animateNumber.$inject = ['jQuery'];
	  function animateNumber(jQuery){
	    return {
	      link: function (scope, $el){
	        $el.animateNumber({
	          number: $el.text().replace(/ /gi, ''),
	          numberStep: jQuery.animateNumber.numberStepFactories.separator(' '),
	          easing: 'easeInQuad'
	        }, 1000);
	      }
	    }
	  }
	  checkAll.$inject = ['jQuery'];
	  function checkAll(jQuery){
	    return {
	      restrict: 'A',
	      link: function (scope, $el){
	        $el.on('click', function() {
	          $el.closest('table').find('input[type=checkbox]')
	            .not(this).prop('checked', jQuery(this).prop('checked'));
	        });
	      }
	    }
	  }
	
	  body.$inject = [];
	  function body () {
	    return {
	      restrict: 'E',
	      link: function(scope, $element) {
	        // prevent unwanted navigation
	        $element.on('click', 'a[href=#]', function(e) {
	          e.preventDefault();
	        })
	      }
	    }
	  }
	
	};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	/*
	 angular-diff-match-patch
	 http://amweiss.github.io/angular-diff-match-patch/
	 @license: MIT
	*/
	angular.module('diff-match-patch', [])
		.factory('dmp', ['$window', function ($window) {
			var DiffMatchPatch = $window.diff_match_patch;
			var displayType = {
				INSDEL: 0,
				LINEDIFF: 1
			};
			var DIFF_DELETE = -1;
			var DIFF_INSERT = 1;
			var DIFF_EQUAL = 0;
			function diffClass(op) {
				switch (op) {
					case DIFF_INSERT:
						return 'ins';
					case DIFF_DELETE:
						return 'del';
					default: // case DIFF_EQUAL:
						return 'match';
				}
			}
	
			function diffSymbol(op) {
				switch (op) {
					case DIFF_INSERT:
						return '+';
					case DIFF_DELETE:
						return '-';
					default: // case DIFF_EQUAL:
						return ' ';
				}
			}
	
			function diffTag(op) {
				switch (op) {
					case DIFF_INSERT:
						return 'ins';
					case DIFF_DELETE:
						return 'del';
					default: // case DIFF_EQUAL:
						return 'span';
				}
			}
	
			function diffAttrName(op) {
				switch (op) {
					case DIFF_INSERT:
						return 'insert';
					case DIFF_DELETE:
						return 'delete';
					default: // case DIFF_EQUAL:
						return 'equal';
				}
			}
	
			function getTagAttrs(options, op, attrs) {
				var tagOptions = {};
				var retVal = [];
				var opName = diffAttrName(op);
	
				if (angular.isDefined(options) && angular.isDefined(options.attrs)) {
					var attributesFromOptions = options.attrs[opName];
					if (angular.isDefined(attributesFromOptions)) {
						angular.merge(tagOptions, attributesFromOptions);
					}
				}
	
				if (angular.isDefined(attrs)) {
					angular.merge(tagOptions, attrs);
				}
	
				if (Object.keys(tagOptions).length === 0) {
					return '';
				}
	
				angular.forEach(tagOptions, function (value, key) {
					retVal.push(key + '="' + value + '"');
				});
	
				return ' ' + retVal.join(' ');
			}
	
			function getHtmlPrefix(op, display, options) {
				switch (display) {
					case displayType.LINEDIFF:
						return '<div class="' + diffClass(op) + '"><span' + getTagAttrs(options, op, {class: 'noselect'}) + '>' + diffSymbol(op) + '</span>';
					default: // case displayType.INSDEL:
						return '<' + diffTag(op) + getTagAttrs(options, op) + '>';
				}
			}
	
			function getHtmlSuffix(op, display) {
				switch (display) {
					case displayType.LINEDIFF:
						return '</div>';
					default: // case displayType.INSDEL:
						return '</' + diffTag(op) + '>';
				}
			}
	
			function createHtmlLines(text, op, options) {
				var lines = text.split('\n');
				var y;
				for (y = 0; y < lines.length; y++) {
					if (lines[y].length === 0) {
						continue;
					}
					lines[y] = getHtmlPrefix(op, displayType.LINEDIFF, options) + lines[y] + getHtmlSuffix(op, displayType.LINEDIFF);
				}
				return lines.join('');
			}
	
			function createHtmlFromDiffs(diffs, display, options, excludeOp) {
				var x;
				var html = [];
				var y;
				var op;
				var text;
				var diffData = diffs;
				var dmp = (display === displayType.LINEDIFF) ? new DiffMatchPatch() : null;
				var intraDiffs;
				var intraHtml1;
				var intraHtml2;
	
				for (x = 0; x < diffData.length; x++) {
					diffData[x][1] = diffData[x][1].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
				}
	
				for (y = 0; y < diffData.length; y++) {
					op = diffData[y][0];
					text = diffData[y][1];
					if (display === displayType.LINEDIFF) {
						if (angular.isDefined(options) && angular.isDefined(options.interLineDiff) && options.interLineDiff && diffs[y][0] === DIFF_DELETE && angular.isDefined(diffs[y + 1]) && diffs[y + 1][0] === DIFF_INSERT && diffs[y][1].indexOf('\n') === -1) {
							intraDiffs = dmp.diff_main(diffs[y][1], diffs[y + 1][1]);
							dmp.diff_cleanupSemantic(intraDiffs);
							intraHtml1 = createHtmlFromDiffs(intraDiffs, displayType.INSDEL, options, DIFF_INSERT);
							intraHtml2 = createHtmlFromDiffs(intraDiffs, displayType.INSDEL, options, DIFF_DELETE);
							html[y] = createHtmlLines(intraHtml1, DIFF_DELETE, options);
							html[y + 1] = createHtmlLines(intraHtml2, DIFF_INSERT, options);
							y++;
						} else {
							html[y] = createHtmlLines(text, op, options);
						}
					} else if (typeof excludeOp === 'undefined' || op !== excludeOp) {
						html[y] = getHtmlPrefix(op, display, options) + text + getHtmlSuffix(op, display);
					}
				}
				return html.join('');
			}
	
			function assertArgumentsIsStrings(left, right) {
				return angular.isString(left) && angular.isString(right);
			}
	
			// Taken from source https://code.google.com/p/google-diff-match-patch/
			// and then modified for style and to strip newline
			function linesToChars(text1, text2, ignoreTrailingNewLines) {
				var lineArray = [];
				var lineHash = {};
				lineArray[0] = '';
	
				function linesToCharsMunge(text) {
					var chars = '';
					var lineStart = 0;
					var lineEnd = -1;
					var lineArrayLength = lineArray.length;
					var hasNewLine = false;
					while (lineEnd < text.length - 1) {
						lineEnd = text.indexOf('\n', lineStart);
						hasNewLine = (lineEnd !== -1);
						if (!hasNewLine) {
							lineEnd = text.length - 1;
						}
	
						var line = text.substring(lineStart, lineEnd + ((ignoreTrailingNewLines && hasNewLine) ? 0 : 1));
						lineStart = lineEnd + 1;
	
						if (Object.prototype.hasOwnProperty.call(lineHash, line)) {
							chars += String.fromCharCode(lineHash[line]);
						} else {
							chars += String.fromCharCode(lineArrayLength);
							lineHash[line] = lineArrayLength;
							lineArray[lineArrayLength++] = line;
						}
					}
					return chars;
				}
	
				var chars1 = linesToCharsMunge(text1);
				var chars2 = linesToCharsMunge(text2);
				return {chars1: chars1, chars2: chars2, lineArray: lineArray};
			}
	
			// Taken from source https://code.google.com/p/google-diff-match-patch/
			// and then modified for style and to strip newline
			function charsToLines(diffs, lineArray, ignoreTrailingNewLines) {
				for (var x = 0; x < diffs.length; x++) {
					var chars = diffs[x][1];
					var text = [];
					for (var y = 0; y < chars.length; y++) {
						text[y] = lineArray[chars.charCodeAt(y)];
					}
					diffs[x][1] = text.join((ignoreTrailingNewLines) ? '\n' : '');
				}
			}
	
			return {
				createDiffHtml: function (left, right, options) {
					var diffs;
					if (assertArgumentsIsStrings(left, right)) {
						diffs = new DiffMatchPatch().diff_main(left, right);
						return createHtmlFromDiffs(diffs, displayType.INSDEL, options);
					}
					return '';
				},
	
				createProcessingDiffHtml: function (left, right, options) {
					var dmp;
					var diffs;
					if (assertArgumentsIsStrings(left, right)) {
						dmp = new DiffMatchPatch();
						diffs = dmp.diff_main(left, right);
	
						if (angular.isDefined(options) && angular.isDefined(options.editCost) && isFinite(options.editCost)) {
							dmp.Diff_EditCost = options.editCost; // eslint-disable-line camelcase
						}
	
						dmp.diff_cleanupEfficiency(diffs);
						return createHtmlFromDiffs(diffs, displayType.INSDEL, options);
					}
					return '';
				},
	
				createSemanticDiffHtml: function (left, right, options) {
					var dmp;
					var diffs;
					if (assertArgumentsIsStrings(left, right)) {
						dmp = new DiffMatchPatch();
						diffs = dmp.diff_main(left, right);
						dmp.diff_cleanupSemantic(diffs);
						return createHtmlFromDiffs(diffs, displayType.INSDEL, options);
					}
					return '';
				},
	
				createLineDiffHtml: function (left, right, options) {
					var dmp;
					var chars;
					var diffs;
					if (assertArgumentsIsStrings(left, right)) {
						dmp = new DiffMatchPatch();
						var ignoreTrailingNewLines = angular.isDefined(options) && angular.isDefined(options.ignoreTrailingNewLines) && options.ignoreTrailingNewLines;
						chars = linesToChars(left, right, ignoreTrailingNewLines);
						diffs = dmp.diff_main(chars.chars1, chars.chars2, false);
						charsToLines(diffs, chars.lineArray, ignoreTrailingNewLines);
						return createHtmlFromDiffs(diffs, displayType.LINEDIFF, options);
					}
					return '';
				}
			};
		}])
		.directive('diff', ['$compile', 'dmp', function ($compile, dmp) {
			var ddo = {
				scope: {
					left: '=leftObj',
					right: '=rightObj',
					options: '=options'
				},
				link: function (scope, iElement) {
					var listener = function () {
						iElement.html(dmp.createDiffHtml(scope.left, scope.right, scope.options));
						// If no options given, or, we have been given options and don't want to skip angular compiling
						// Then compile angular in the diff.
						if (!scope.options || (scope.options && !scope.options.skipAngularCompilingOnDiff)) {
							$compile(iElement.contents())(scope);
						}
					};
					scope.$watch('left', listener);
					scope.$watch('right', listener);
				}
			};
			return ddo;
		}])
		.directive('processingDiff', ['$compile', 'dmp', function ($compile, dmp) {
			var ddo = {
				scope: {
					left: '=leftObj',
					right: '=rightObj',
					options: '=options'
				},
				link: function (scope, iElement) {
					var listener = function () {
						iElement.html(dmp.createProcessingDiffHtml(scope.left, scope.right, scope.options));
						// If no options given, or, we have been given options and don't want to skip angular compiling
						// Then compile angular in the diff.
						if (!scope.options || (scope.options && !scope.options.skipAngularCompilingOnDiff)) {
							$compile(iElement.contents())(scope);
						}
					};
					scope.$watch('left', listener);
					scope.$watch('right', listener);
					scope.$watch('options.editCost', listener, true);
				}
			};
			return ddo;
		}])
		.directive('semanticDiff', ['$compile', 'dmp', function ($compile, dmp) {
			var ddo = {
				scope: {
					left: '=leftObj',
					right: '=rightObj',
					options: '=options'
				},
				link: function (scope, iElement) {
					var listener = function () {
						iElement.html(dmp.createSemanticDiffHtml(scope.left, scope.right, scope.options));
						// If no options given, or, we have been given options and don't want to skip angular compiling
						// Then compile angular in the diff.
						if (!scope.options || (scope.options && !scope.options.skipAngularCompilingOnDiff)) {
							$compile(iElement.contents())(scope);
						}
					};
					scope.$watch('left', listener);
					scope.$watch('right', listener);
				}
			};
			return ddo;
		}])
		.directive('lineDiff', ['$compile', 'dmp', function ($compile, dmp) {
			var ddo = {
				scope: {
					left: '=leftObj',
					right: '=rightObj',
					options: '=options'
				},
				link: function (scope, iElement) {
					var listener = function () {
						iElement.html(dmp.createLineDiffHtml(scope.left, scope.right, scope.options));
						// If no options given, or, we have been given options and don't want to skip angular compiling
						// Then compile angular in the diff.
						if (!scope.options || (scope.options && !scope.options.skipAngularCompilingOnDiff)) {
							$compile(iElement.contents())(scope);
						}
					};
					scope.$watch('left', listener);
					scope.$watch('right', listener);
					scope.$watch('options.interLineDiff', listener, true);
					scope.$watch('options.ignoreTrailingNewLines', listener, true);
				}
			};
			return ddo;
		}]);


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	/**
	 * Binds a TinyMCE widget to <textarea> elements.
	 */
	// angular.module('ui.tinymce', [])
	//   .value('uiTinymceConfig', {})
	//   .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig) {
	//     uiTinymceConfig = uiTinymceConfig || {};
	//     var ID_ATTR = 'ui-tinymce';
	//     if (uiTinymceConfig.baseUrl) {
	//       tinymce.baseURL = uiTinymceConfig.baseUrl;
	//     }
	
	//     return {
	//       require: ['ngModel', '^?form'],
	//       priority: 599,
	//       link: function(scope, element, attrs, ctrls) {
	//         if (!$window.tinymce) {
	//           return;
	//         }
	
	//         var ngModel = ctrls[0],
	//           form = ctrls[1] || null;
	
	//         var expression, options = {
	//           debounce: true
	//         }, tinyInstance,
	//           updateView = function(editor) {
	//             var content = editor.getContent({format: options.format}).trim();
	//             content = $sce.trustAsHtml(content);
	
	//             ngModel.$setViewValue(content);
	//             if (!$rootScope.$$phase) {
	//               scope.$digest();
	//             }
	//           };
	
	//         function toggleDisable(disabled) {
	//           if (disabled) {
	//             ensureInstance();
	
	//             if (tinyInstance) {
	//               tinyInstance.getBody().setAttribute('contenteditable', false);
	//             }
	//           } else {
	//             ensureInstance();
	
	//             if (tinyInstance && !tinyInstance.settings.readonly) {
	//               tinyInstance.getBody().setAttribute('contenteditable', true);
	//             }
	//           }
	//         }
	
	//         // generate an ID
	//         attrs.$set('id', ID_ATTR + '-' + (new Date().valueOf()));
	
	//         expression = {};
	
	//         angular.extend(expression, scope.$eval(attrs.uiTinymce));
	
	//         //Debounce update and save action
	//         var debouncedUpdate = (function(debouncedUpdateDelay) {
	//           var debouncedUpdateTimer;
	//           return function(ed) {
	// 	        $timeout.cancel(debouncedUpdateTimer);
	// 	         debouncedUpdateTimer = $timeout(function() {
	//               return (function(ed) {
	//                 if (ed.isDirty()) {
	//                   ed.save();
	//                   updateView(ed);
	//                 }
	//               })(ed);
	//             }, debouncedUpdateDelay);
	//           };
	//         })(400);
	
	//         var setupOptions = {
	//           // Update model when calling setContent
	//           // (such as from the source editor popup)
	//           setup: function(ed) {
	//             ed.on('init', function() {
	//               ngModel.$render();
	//               ngModel.$setPristine();
	//                 ngModel.$setUntouched();
	//               if (form) {
	//                 form.$setPristine();
	//               }
	//             });
	
	//             // Update model when:
	//             // - a button has been clicked [ExecCommand]
	//             // - the editor content has been modified [change]
	//             // - the node has changed [NodeChange]
	//             // - an object has been resized (table, image) [ObjectResized]
	//             ed.on('ExecCommand change NodeChange ObjectResized', function() {
	//               if (!options.debounce) {
	//                 ed.save();
	//                 updateView(ed);
	//               	return;
	//               }
	//               debouncedUpdate(ed);
	//             });
	
	//             ed.on('blur', function() {
	//               element[0].blur();
	//               ngModel.$setTouched();
	//               if (!$rootScope.$$phase) {
	//                 scope.$digest();
	//               }
	//             });
	//             ed.on('SetContent',function (e) {
	//                 ed.save();
	//                 updateView(ed);
	//             });
	//             ed.on('remove', function() {
	//               element.remove();
	//               ed.save();
	//               updateView(ed);
	//             });
	
	//             if (uiTinymceConfig.setup) {
	//               uiTinymceConfig.setup(ed, {
	//                 updateView: updateView
	//               });
	//             }
	
	//             if (expression.setup) {
	//               expression.setup(ed, {
	//                 updateView: updateView
	//               });
	//             }
	//           },
	//           format: expression.format || 'html',
	//           selector: '#' + attrs.id
	//         };
	//         // extend options with initial uiTinymceConfig and
	//         // options from directive attribute value
	//         angular.extend(options, uiTinymceConfig, expression, setupOptions);
	//         // Wrapped in $timeout due to $tinymce:refresh implementation, requires
	//         // element to be present in DOM before instantiating editor when
	//         // re-rendering directive
	//         $timeout(function() {
	//           if (options.baseURL){
	//             tinymce.baseURL = options.baseURL;
	//           }
	//           var maybeInitPromise = tinymce.init(options);
	//           if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
	//             maybeInitPromise.then(function() {
	//               toggleDisable(scope.$eval(attrs.ngDisabled));
	//             });
	//           } else {
	//             toggleDisable(scope.$eval(attrs.ngDisabled));
	//           }
	//         });
	
	//         ngModel.$formatters.unshift(function(modelValue) {
	//           return modelValue ? $sce.trustAsHtml(modelValue) : '';
	//         });
	
	//         ngModel.$parsers.unshift(function(viewValue) {
	//           return viewValue ? $sce.getTrustedHtml(viewValue) : '';
	//         });
	
	//         ngModel.$render = function() {
	//           ensureInstance();
	
	//           var viewValue = ngModel.$viewValue ?
	//             $sce.getTrustedHtml(ngModel.$viewValue) : '';
	
	//           // instance.getDoc() check is a guard against null value
	//           // when destruction & recreation of instances happen
	//           if (tinyInstance &&
	//             tinyInstance.getDoc()
	//           ) {
	//             tinyInstance.setContent(viewValue);
	//             // Triggering change event due to TinyMCE not firing event &
	//             // becoming out of sync for change callbacks
	//             tinyInstance.fire('change');
	//           }
	//         };
	
	//         attrs.$observe('disabled', toggleDisable);
	
	//         // This block is because of TinyMCE not playing well with removal and
	//         // recreation of instances, requiring instances to have different
	//         // selectors in order to render new instances properly
	//         scope.$on('$tinymce:refresh', function(e, id) {
	//           var eid = attrs.id;
	//           if (angular.isUndefined(id) || id === eid) {
	//             var parentElement = element.parent();
	//             var clonedElement = element.clone();
	//             clonedElement.removeAttr('id');
	//             clonedElement.removeAttr('style');
	//             clonedElement.removeAttr('aria-hidden');
	//             tinymce.execCommand('mceRemoveEditor', false, eid);
	//             parentElement.append($compile(clonedElement)(scope));
	//           }
	//         });
	
	//         scope.$on('$destroy', function() {
	//           ensureInstance();
	
	//           if (tinyInstance) {
	//             tinyInstance.remove();
	//             tinyInstance = null;
	//           }
	//         });
	
	//         function ensureInstance() {
	//           if (!tinyInstance) {
	//             tinyInstance = tinymce.get(attrs.id);
	//           }
	//         }
	//       }
	//     };
	//   }]);
	/**
	 * Binds a TinyMCE widget to <textarea> elements.
	 */
	angular.module('ui.tinymce', [])
	  .value('uiTinymceConfig', {})
	  .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
	    uiTinymceConfig = uiTinymceConfig || {};
	
	    if (uiTinymceConfig.baseUrl) {
	      tinymce.baseURL = uiTinymceConfig.baseUrl;
	    }
	
	    return {
	      require: ['ngModel', '^?form'],
	      priority: 599,
	      link: function(scope, element, attrs, ctrls) {
	        if (!$window.tinymce) {
	          return;
	        }
	
	        var ngModel = ctrls[0],
	          form = ctrls[1] || null;
	
	        var expression, options = {
	          debounce: true
	        }, tinyInstance,
	          updateView = function(editor) {
	            var content = editor.getContent({format: options.format}).trim();
	            content = $sce.trustAsHtml(content);
	
	            ngModel.$setViewValue(content);
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          };
	
	        function toggleDisable(disabled) {
	          if (disabled) {
	            ensureInstance();
	
	            if (tinyInstance) {
	              tinyInstance.getBody().setAttribute('contenteditable', false);
	            }
	          } else {
	            ensureInstance();
	
	            if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
	              tinyInstance.getBody().setAttribute('contenteditable', true);
	            }
	          }
	        }
	
	        // fetch a unique ID from the service
	        var uniqueId = uiTinymceService.getUniqueId();
	        attrs.$set('id', uniqueId);
	
	        expression = {};
	
	        angular.extend(expression, scope.$eval(attrs.uiTinymce));
	
	        //Debounce update and save action
	        var debouncedUpdate = (function(debouncedUpdateDelay) {
	          var debouncedUpdateTimer;
	          return function(ed) {
	          $timeout.cancel(debouncedUpdateTimer);
	           debouncedUpdateTimer = $timeout(function() {
	              return (function(ed) {
	                if (ed.isDirty()) {
	                  ed.save();
	                  updateView(ed);
	                }
	              })(ed);
	            }, debouncedUpdateDelay);
	          };
	        })(400);
	
	        var setupOptions = {
	          // Update model when calling setContent
	          // (such as from the source editor popup)
	          setup: function(ed) {
	            ed.on('init', function() {
	              ngModel.$render();
	              ngModel.$setPristine();
	                ngModel.$setUntouched();
	              if (form) {
	                form.$setPristine();
	              }
	            });
	
	            // Update model when:
	            // - a button has been clicked [ExecCommand]
	            // - the editor content has been modified [change]
	            // - the node has changed [NodeChange]
	            // - an object has been resized (table, image) [ObjectResized]
	            ed.on('ExecCommand change NodeChange ObjectResized', function() {
	              if (!options.debounce) {
	                ed.save();
	                updateView(ed);
	                return;
	              }
	              debouncedUpdate(ed);
	            });
	
	            ed.on('blur', function() {
	              element[0].blur();
	              ngModel.$setTouched();
	              if (!$rootScope.$$phase) {
	                scope.$digest();
	              }
	            });
	
	            ed.on('remove', function() {
	              element.remove();
	            });
	
	            if (uiTinymceConfig.setup) {
	              uiTinymceConfig.setup(ed, {
	                updateView: updateView
	              });
	            }
	
	            if (expression.setup) {
	              expression.setup(ed, {
	                updateView: updateView
	              });
	            }
	          },
	          format: expression.format || 'html',
	          selector: '#' + attrs.id
	        };
	        // extend options with initial uiTinymceConfig and
	        // options from directive attribute value
	        angular.extend(options, uiTinymceConfig, expression, setupOptions);
	        // Wrapped in $timeout due to $tinymce:refresh implementation, requires
	        // element to be present in DOM before instantiating editor when
	        // re-rendering directive
	        $timeout(function() {
	          if (options.baseURL){
	            tinymce.baseURL = options.baseURL;
	          }
	          var maybeInitPromise = tinymce.init(options);
	          if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
	            maybeInitPromise.then(function() {
	              toggleDisable(scope.$eval(attrs.ngDisabled));
	            });
	          } else {
	            toggleDisable(scope.$eval(attrs.ngDisabled));
	          }
	        });
	
	        ngModel.$formatters.unshift(function(modelValue) {
	          return modelValue ? $sce.trustAsHtml(modelValue) : '';
	        });
	
	        ngModel.$parsers.unshift(function(viewValue) {
	          return viewValue ? $sce.getTrustedHtml(viewValue) : '';
	        });
	
	        ngModel.$render = function() {
	          ensureInstance();
	
	          var viewValue = ngModel.$viewValue ?
	            $sce.getTrustedHtml(ngModel.$viewValue) : '';
	
	          // instance.getDoc() check is a guard against null value
	          // when destruction & recreation of instances happen
	          if (tinyInstance &&
	            tinyInstance.getDoc()
	          ) {
	            tinyInstance.setContent(viewValue);
	            // Triggering change event due to TinyMCE not firing event &
	            // becoming out of sync for change callbacks
	            tinyInstance.fire('change');
	          }
	        };
	
	        attrs.$observe('disabled', toggleDisable);
	
	        // This block is because of TinyMCE not playing well with removal and
	        // recreation of instances, requiring instances to have different
	        // selectors in order to render new instances properly
	        scope.$on('$tinymce:refresh', function(e, id) {
	          var eid = attrs.id;
	          if (angular.isUndefined(id) || id === eid) {
	            var parentElement = element.parent();
	            var clonedElement = element.clone();
	            clonedElement.removeAttr('id');
	            clonedElement.removeAttr('style');
	            clonedElement.removeAttr('aria-hidden');
	            tinymce.execCommand('mceRemoveEditor', false, eid);
	            parentElement.append($compile(clonedElement)(scope));
	          }
	        });
	
	        scope.$on('$destroy', function() {
	          ensureInstance();
	
	          if (tinyInstance) {
	            tinyInstance.remove();
	            tinyInstance = null;
	          }
	        });
	
	        function ensureInstance() {
	          if (!tinyInstance) {
	            tinyInstance = tinymce.get(attrs.id);
	          }
	        }
	      }
	    };
	  }])
	  .service('uiTinymceService', [
	    /**
	     * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
	     */
	    function() {
	      var UITinymceService = function() {
	        var ID_ATTR = 'ui-tinymce';
	      // uniqueId keeps track of the latest assigned ID
	      var uniqueId = 0;
	        // getUniqueId returns a unique ID
	      var getUniqueId = function() {
	          uniqueId ++;
	          return ID_ATTR + '-' + uniqueId;
	        };
	        // return the function as a public method of the service
	        return {
	          getUniqueId: getUniqueId
	        };
	      };
	      // return a new instance of the service
	      return new UITinymceService();
	    }
	  ]);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * angularjs-color-picker v3.4.8
	 * https://github.com/ruhley/angular-color-picker/
	 *
	 * Copyright 2017 ruhley
	 *
	 * 2017-10-06 09:51:57
	 *
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(141)) :
		typeof define === 'function' && define.amd ? define(['tinycolor2'], factory) :
		(global.AngularjsColorPicker = factory(global.tinycolor));
	}(this, (function (tinycolor) { 'use strict';
	
	tinycolor = tinycolor && tinycolor.hasOwnProperty('default') ? tinycolor['default'] : tinycolor;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var AngularColorPickerController = function () {
	    function AngularColorPickerController(_$scope, _$element, _$document, _$timeout, _ColorPickerOptions) {
	        classCallCheck(this, AngularColorPickerController);
	
	        // set angular injected variables
	        this.$scope = _$scope;
	        this.$element = _$element;
	        this.$document = _$document;
	        this.$timeout = _$timeout;
	        this.ColorPickerOptions = _ColorPickerOptions;
	
	        // make the init function available from the $scope (for the directive link function)
	        this.$scope.init = this.init.bind(this);
	
	        // set default values
	        this.ngModelOptions = {};
	        this.hue = 0;
	        this.saturation = undefined;
	        this.lightness = undefined;
	        this.opacity = undefined;
	
	        this.basicEventTypes = ['hue', 'saturation', 'lightness', 'opacity'];
	        this.fullEventTypes = ['color', 'hue', 'saturation', 'lightness', 'opacity'];
	    }
	
	    //---------------------------
	    // init functions
	    //---------------------------
	
	    createClass(AngularColorPickerController, [{
	        key: 'init',
	        value: function init() {
	
	            // ng model options
	            if (this.$scope.control[0].$options && this.$scope.control[0].$options.$$options) {
	                this.ngModelOptions = this.$scope.control[0].$options.$$options;
	            }
	
	            // browser variables
	            this.chrome = Boolean(window.chrome);
	            var _android_version = window.navigator.userAgent.match(/Android\s([0-9\.]*)/i);
	            this.android_version = _android_version && _android_version.length > 1 ? parseFloat(_android_version[1]) : NaN;
	
	            // needed variables
	            this.updateModel = true;
	
	            // watchers
	            this.initWatchers();
	
	            // set default config settings
	            this.initConfig();
	
	            // mouse events
	            this.initMouseEvents();
	        }
	    }, {
	        key: 'initConfig',
	        value: function initConfig() {
	            if (!this.options) {
	                this.options = {};
	            }
	
	            this.mergeOptions(this.options, this.ColorPickerOptions);
	
	            this.is_open = this.options.inline;
	
	            if (this.options.inline) {
	                this.options.close.show = false;
	            }
	
	            this.pickerDimensions = {
	                width: 150,
	                height: 150
	            };
	
	            this.sliderDimensions = {
	                width: this.options.horizontal ? this.pickerDimensions.width : 20,
	                height: this.options.horizontal ? 20 : this.pickerDimensions.height
	            };
	        }
	    }, {
	        key: 'mergeOptions',
	        value: function mergeOptions(options, defaultOptions) {
	            for (var attr in defaultOptions) {
	                if (defaultOptions.hasOwnProperty(attr)) {
	                    if (!options || !options.hasOwnProperty(attr)) {
	                        options[attr] = defaultOptions[attr];
	                    } else if (_typeof(defaultOptions[attr]) === 'object') {
	                        this.mergeOptions(options[attr], defaultOptions[attr]);
	                    }
	                }
	            }
	        }
	
	        //---------------------------
	        // watcher functions
	        //---------------------------
	
	    }, {
	        key: 'initWatchers',
	        value: function initWatchers() {
	            var _this = this;
	
	            // ngModel
	
	            this.$scope.$watch('AngularColorPickerController.internalNgModel', this.watchInternalNgModel.bind(this));
	            this.$scope.$watch('AngularColorPickerController.ngModel', this.watchNgModel.bind(this));
	
	            // options
	
	            this.$scope.$watch('AngularColorPickerController.options.swatchPos', function (newValue) {
	                if (newValue !== undefined) {
	                    _this.initConfig();
	
	                    _this.$timeout(function () {
	                        _this.updateSwatchBackground();
	                    });
	                }
	            });
	
	            this.$scope.$watchGroup(['AngularColorPickerController.options.format', 'AngularColorPickerController.options.alpha', 'AngularColorPickerController.options.case', 'AngularColorPickerController.options.round', 'AngularColorPickerController.options.restrictToFormat', 'AngularColorPickerController.options.preserveInputFormat', 'AngularColorPickerController.options.allowEmpty', 'AngularColorPickerController.options.horizontal', 'AngularColorPickerController.options.dynamicHue', 'AngularColorPickerController.options.dynamicSaturation', 'AngularColorPickerController.options.dynamicLightness', 'AngularColorPickerController.options.dynamicAlpha'], function (newValue) {
	                if (newValue !== undefined) {
	                    _this.initConfig();
	                    _this.update();
	                }
	            });
	
	            this.$scope.$watchGroup(['AngularColorPickerController.options.disabled', 'AngularColorPickerController.options.swatchBootstrap', 'AngularColorPickerController.options.swatchOnly', 'AngularColorPickerController.options.swatch', 'AngularColorPickerController.options.pos', 'AngularColorPickerController.options.inline', 'AngularColorPickerController.options.placeholder'], function (newValue) {
	                if (newValue !== undefined) {
	                    _this.initConfig();
	                }
	            });
	
	            // api
	
	            this.$scope.$watch('AngularColorPickerController.api', this.setupApi.bind(this));
	
	            // internal
	
	            this.$scope.$watch('AngularColorPickerController.swatchColor', this.updateSwatchBackground.bind(this));
	
	            this.$scope.$watch('AngularColorPickerController.hue', function () {
	                _this.valueUpdate('hue');
	            });
	
	            this.$scope.$watch('AngularColorPickerController.saturation', function () {
	                _this.valueUpdate('saturation');
	            });
	
	            this.$scope.$watch('AngularColorPickerController.lightness', function () {
	                _this.valueUpdate('lightness');
	            });
	
	            this.$scope.$watch('AngularColorPickerController.opacity', function () {
	                _this.valueUpdate('opacity');
	            });
	        }
	    }, {
	        key: 'watchInternalNgModel',
	        value: function watchInternalNgModel(newValue, oldValue) {
	            // the mouse is still moving so don't do anything yet
	            if (this.colorMouse) {
	                return;
	            }
	
	            // calculate and set color values
	            this.watchNgModelSet(newValue);
	        }
	
	        /** Triggered on change to internal or external ngModel value */
	
	    }, {
	        key: 'watchNgModel',
	        value: function watchNgModel(newValue, oldValue) {
	            // set initial value if not already set
	            if (newValue !== undefined && !this.hasOwnProperty('initialNgModel')) {
	                this.initialNgModel = newValue;
	            }
	
	            // sets the field to pristine or dirty for angular
	            this.checkDirty(newValue);
	
	            // update the internal model from external model
	            this.internalNgModel = this.ngModelOptions.getterSetter ? this.ngModel() : this.ngModel;
	
	            // the mouse is still moving so don't do anything yet
	            if (this.colorMouse) {
	                return;
	            }
	
	            // calculate and set color values
	            this.watchNgModelSet(newValue);
	        }
	
	        /** Helper for watchNgModel to set internal values and validity */
	
	    }, {
	        key: 'watchNgModelSet',
	        value: function watchNgModelSet(newValue) {
	            var _this2 = this;
	
	            if (newValue !== undefined && newValue !== null) {
	                var color = tinycolor(newValue);
	                var isValid = this.isColorValid(color);
	
	                if (isValid) {
	                    this.setColorValue(color);
	
	                    this.updateModel = false;
	
	                    this.$timeout(function () {
	                        _this2.updateModel = true;
	                    });
	                }
	
	                this.$scope.control[0].$setValidity('color', isValid);
	            } else {
	                if (newValue === null || newValue === '') {
	                    this.hue = 0;
	                    this.saturation = undefined;
	                    this.lightness = undefined;
	                    this.opacity = undefined;
	                }
	
	                this.swatchColor = '';
	            }
	        }
	
	        //---------------------------
	        // mouse/touch event functions
	        //---------------------------
	
	    }, {
	        key: 'initMouseEvents',
	        value: function initMouseEvents() {
	            var _this3 = this;
	
	            var eventHandlers = {
	                mouseDown: this.onMouseDown.bind(this),
	                mouseUp: this.onMouseUp.bind(this),
	                mouseMove: this.onMouseMove.bind(this),
	                keyUp: this.onKeyUp.bind(this)
	            };
	
	            // setup mouse events
	            this.$document.on('mousedown', eventHandlers.mouseDown);
	            this.$document.on('mouseup', eventHandlers.mouseUp);
	            this.$document.on('mousemove', eventHandlers.mouseMove);
	
	            // setup touch events
	            this.$document.on('touchstart', eventHandlers.mouseDown);
	            this.$document.on('touchend', eventHandlers.mouseUp);
	            this.$document.on('touchmove', eventHandlers.mouseMove);
	
	            // setup key events
	            this.$document.on('keyup', eventHandlers.keyUp);
	
	            // grid click
	            this.find('.color-picker-grid').on('click', function (event) {
	                _this3.onClick('color', event);
	            });
	            this.find('.color-picker-grid').on('touchend', function (event) {
	                _this3.onClick('color', event);
	            });
	
	            // hue click
	            this.find('.color-picker-hue').on('click', function (event) {
	                _this3.onClick('hue', event);
	            });
	            this.find('.color-picker-hue').on('touchend', function (event) {
	                _this3.onClick('hue', event);
	            });
	
	            // saturation click
	            this.find('.color-picker-saturation').on('click', function (event) {
	                _this3.onClick('saturation', event);
	            });
	            this.find('.color-picker-saturation').on('touchend', function (event) {
	                _this3.onClick('saturation', event);
	            });
	
	            // lightness click
	            this.find('.color-picker-lightness').on('click', function (event) {
	                _this3.onClick('lightness', event);
	            });
	            this.find('.color-picker-lightness').on('touchend', function (event) {
	                _this3.onClick('lightness', event);
	            });
	
	            // opacity click
	            this.find('.color-picker-opacity').on('click', function (event) {
	                _this3.onClick('opacity', event);
	            });
	            this.find('.color-picker-opacity').on('touchend', function (event) {
	                _this3.onClick('opacity', event);
	            });
	
	            this.find('.color-picker-input').on('focusin', this.onFocus.bind(this));
	            this.find('.color-picker-input').on('focusout', this.onBlur.bind(this));
	
	            //---------------------------
	            // destroy
	            //---------------------------
	
	            this.$scope.$on('$destroy', function () {
	                // remove mouse events
	                _this3.$document.off('mousedown', eventHandlers.mouseDown);
	                _this3.$document.off('mouseup', eventHandlers.mouseUp);
	                _this3.$document.off('mousemove', eventHandlers.mouseMove);
	
	                // remove touch events
	                _this3.$document.off('touchstart', eventHandlers.mouseDown);
	                _this3.$document.off('touchend', eventHandlers.mouseUp);
	                _this3.$document.off('touchmove', eventHandlers.mouseMove);
	
	                // remove key events
	                _this3.$document.off('keyup', eventHandlers.keyUp);
	
	                _this3.eventApiDispatch('onDestroy');
	            });
	        }
	    }, {
	        key: 'onMouseDown',
	        value: function onMouseDown(event) {
	            this.has_moused_moved = false;
	
	            // if disabled or not an element in this picker then do nothing
	            if (this.options.disabled || this.find(event.target).length === 0) {
	                return true;
	            }
	
	            for (var i = 0; i < this.fullEventTypes.length; i++) {
	                this.onMouseDownType(this.fullEventTypes[i], event);
	            }
	        }
	    }, {
	        key: 'onMouseDownType',
	        value: function onMouseDownType(type, event) {
	            if (type === 'color' && (event.target.classList.contains('color-picker-grid-inner') || event.target.classList.contains('color-picker-picker') || event.target.parentNode.classList.contains('color-picker-picker'))) {
	                this.mouseEventToggle(type, false, event);
	            } else if (event.target.classList.contains('color-picker-' + type) || event.target.parentNode.classList.contains('color-picker-' + type)) {
	                this.mouseEventToggle(type, false, event);
	            }
	        }
	    }, {
	        key: 'onMouseUp',
	        value: function onMouseUp(event) {
	            // no current mouse events and not an element in the picker
	            if (!this.anyMouseEvents() && this.find(event.target).length === 0) {
	                this.setupApi();
	                if (this.options.hide.click) {
	                    this.api.close(event);
	                }
	                this.$scope.$apply();
	            } else {
	                for (var i = 0; i < this.fullEventTypes.length; i++) {
	                    this.onMouseUpType(this.fullEventTypes[i], event);
	                }
	            }
	        }
	    }, {
	        key: 'onMouseUpType',
	        value: function onMouseUpType(type, event) {
	            if (this[type + 'Mouse'] && this.has_moused_moved) {
	                this.mouseEventToggle(type, true, event);
	                this.onChange(event);
	            }
	        }
	    }, {
	        key: 'onMouseMove',
	        value: function onMouseMove(event) {
	            for (var i = 0; i < this.fullEventTypes.length; i++) {
	                this.onMouseMoveType(this.fullEventTypes[i], event);
	            }
	        }
	    }, {
	        key: 'onMouseMoveType',
	        value: function onMouseMoveType(type, event) {
	            if (this[type + 'Mouse']) {
	                this.has_moused_moved = true;
	                this.valueChange(type, event);
	                this.$scope.$apply();
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            // escape key
	            if (this.options.hide.escape && event.keyCode === 27) {
	                this.api.close(event);
	            }
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(type, event) {
	            if (!this.options.disabled && !this.has_moused_moved) {
	                this.valueChange(type, event);
	                this.mouseEventToggle(type, true, event);
	                this.onChange(event);
	            }
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(event) {
	            // don't fire if it hasn't actually changed
	            if (this.internalNgModel !== this.onChangeValue || this.internalNgModel !== this.ngModel) {
	                this.onChangeValue = this.internalNgModel;
	
	                this.eventApiDispatch('onChange', [event]);
	            }
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(event) {
	            // dodato ako se razlikuje model
	            if (this.internalNgModel !== this.onChangeValue || this.internalNgModel !== this.ngModel) {
	                this.updateModel = true;
	                this.update();
	            }
	
	            this.$scope.control[0].$setTouched();
	
	            this.eventApiDispatch('onBlur', [event]);
	
	            // if clicking outside the color picker
	            if (this.options.hide.blur && this.find(event.relatedTarget).length === 0) {
	                this.api.close(event);
	            }
	        }
	    }, {
	        key: 'onSwatchClick',
	        value: function onSwatchClick($event) {
	            if (this.options.show.swatch && !this.options.disabled) {
	                this.api.open($event);
	            }
	        }
	    }, {
	        key: 'onFocus',
	        value: function onFocus($event) {
	            if (this.options.show.focus) {
	                this.api.open($event);
	            }
	        }
	
	        //---------------------------
	        // api functions
	        //---------------------------
	
	        /** Sets up the external api */
	
	    }, {
	        key: 'setupApi',
	        value: function setupApi() {
	            var _this4 = this;
	
	            if (!this.api) {
	                this.api = {};
	            }
	
	            this.api.open = function (event) {
	                // if already open then don't run show again
	                if (_this4.is_open) {
	                    return true;
	                }
	
	                _this4.is_open = true;
	                _this4.hueMouse = false;
	                _this4.opacityMouse = false;
	                _this4.colorMouse = false;
	
	                // force redraw
	                _this4.$scope.$applyAsync();
	
	                // force the sliders to re-caculate their position
	                for (var i = 0; i < _this4.basicEventTypes.length; i++) {
	                    _this4.valueUpdate(_this4.basicEventTypes[i]);
	                }
	
	                _this4.eventApiDispatch('onOpen', [event]);
	            };
	
	            this.api.close = function (event) {
	                // check that it is not already closed
	                if (!_this4.options.inline && (_this4.is_open || _this4.$element[0].querySelector('.color-picker-panel').offsetParent !== null)) {
	                    _this4.is_open = false;
	                    _this4.$scope.$applyAsync();
	
	                    _this4.update();
	                    _this4.eventApiDispatch('onClose', [event]);
	                }
	            };
	
	            this.api.clear = function (event) {
	                _this4.setNgModel(null);
	
	                _this4.eventApiDispatch('onClear', [event]);
	            };
	
	            this.api.reset = function (event) {
	                if (_this4.internalNgModel !== _this4.initialNgModel) {
	                    _this4.setNgModel(_this4.initialNgModel);
	
	                    _this4.eventApiDispatch('onReset', [event]);
	                }
	            };
	
	            this.api.getElement = function () {
	                return _this4.$element;
	            };
	
	            this.api.getScope = function () {
	                return _this4.$scope;
	            };
	        }
	
	        //---------------------------
	        // model functions
	        //---------------------------
	
	        /** Sets the internal and external ngModel values */
	
	    }, {
	        key: 'setNgModel',
	        value: function setNgModel(value) {
	            this.internalNgModel = value;
	
	            if (this.ngModelOptions.getterSetter) {
	                this.ngModel(value);
	            } else {
	                this.ngModel = value;
	            }
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            if (!this.areAllValuesSet()) {
	                return false;
	            }
	
	            var color = tinycolor(this.getColorValue());
	
	            this.swatchColor = color.toHslString();
	
	            this.updateGridBackground(color);
	            this.updateHueBackground(color);
	            this.huePosUpdate();
	            this.updateSaturationBackground(color);
	            this.saturationPosUpdate();
	            this.updateLightnessBackground(color);
	            this.lightnessPosUpdate();
	            this.updateOpacityBackground(color);
	            this.opacityPosUpdate();
	
	            var skipUpdate = this.options.preserveInputFormat && tinycolor(this.internalNgModel).toHsvString() === color.toHsvString();
	
	            if (this.updateModel && !skipUpdate) {
	                var formats = {
	                    rgb: 'toRgbString',
	                    hex: 'toHex',
	                    hex8: 'toHex8',
	                    hexstring: 'toHexString',
	                    hex8string: 'toHex8String',
	                    hsv: 'toHsvString',
	                    hsl: 'toHslString',
	                    raw: 'clone'
	                };
	
	                var value = color[formats[this.options.format.toLowerCase()]]();
	
	                if (this.options.format.match(/hex/i)) {
	                    value = this.options.case === 'upper' ? value.toUpperCase() : value.toLowerCase();
	                }
	
	                this.setNgModel(value);
	            }
	        }
	
	        //---------------------------
	        // generic value functions
	        //---------------------------
	
	    }, {
	        key: 'mouseEventToggle',
	        value: function mouseEventToggle(type, up, event) {
	            this.stopEvent(event);
	            this[type + 'Mouse'] = !up;
	            this.$scope.$apply();
	        }
	    }, {
	        key: 'valueChange',
	        value: function valueChange(type, event) {
	            this.stopEvent(event);
	
	            if (type === 'color') {
	                return this.colorChange(event);
	            }
	
	            var el = this.find('.color-picker-' + type);
	            var eventPos = this.getEventPos(event);
	            var max = this.getMaxFromType(type);
	
	            this[type] = this.calculateSliderPos(el, eventPos, max);
	
	            if (this[type] > max) {
	                this[type] = max;
	            } else if (this[type] < 0) {
	                this[type] = 0;
	            }
	        }
	    }, {
	        key: 'valueUpdate',
	        value: function valueUpdate(type) {
	            if (this[type] !== undefined) {
	                if (type === 'saturation') {
	                    this[type + 'Pos'] = this[type];
	                } else {
	                    var max = this.getMaxFromType(type);
	                    this[type + 'Pos'] = (1 - this[type] / max) * 100;
	                }
	
	                if (this[type + 'Pos'] < 0) {
	                    this[type + 'Pos'] = 0;
	                } else if (this[type + 'Pos'] > 100) {
	                    this[type + 'Pos'] = 100;
	                }
	
	                if (this.options.round) {
	                    this.getRoundPos();
	                    this.updateRoundPos();
	                }
	
	                this[type + 'PosUpdate']();
	                this.update();
	            }
	        }
	
	        //---------------------------
	        // hue functions
	        //---------------------------
	
	    }, {
	        key: 'huePosUpdate',
	        value: function huePosUpdate() {
	            var el = angular.element(this.$element[0].querySelector('.color-picker-hue .color-picker-slider'));
	
	            if (this.options.horizontal) {
	                el.css({
	                    'left': this.sliderDimensions.width * this.huePos / 100 + 'px',
	                    'top': 0
	                });
	            } else {
	                el.css({
	                    'left': 0,
	                    'top': this.sliderDimensions.height * this.huePos / 100 + 'px'
	                });
	            }
	        }
	    }, {
	        key: 'updateHueBackground',
	        value: function updateHueBackground(color) {
	            var el = this.find('.color-picker-hue .color-picker-overlay');
	            var direction = this.options.horizontal ? 'left' : 'top';
	
	            var zero_sixths = this.getColorValue(this.options.dynamicHue);
	            var one_sixths = this.getColorValue(this.options.dynamicHue);
	            var two_sixths = this.getColorValue(this.options.dynamicHue);
	            var three_sixths = this.getColorValue(this.options.dynamicHue);
	            var four_sixths = this.getColorValue(this.options.dynamicHue);
	            var five_sixths = this.getColorValue(this.options.dynamicHue);
	            var six_sixths = this.getColorValue(this.options.dynamicHue);
	
	            zero_sixths.h = 0;
	            one_sixths.h = 60;
	            two_sixths.h = 120;
	            three_sixths.h = 180;
	            four_sixths.h = 240;
	            five_sixths.h = 300;
	            six_sixths.h = 359;
	
	            el.css({
	                'background': 'linear-gradient(to ' + direction + ', ' + tinycolor(zero_sixths).toRgbString() + ' 0%, ' + tinycolor(one_sixths).toRgbString() + ' 17%, ' + tinycolor(two_sixths).toRgbString() + ' 33%, ' + tinycolor(three_sixths).toRgbString() + ' 50%, ' + tinycolor(four_sixths).toRgbString() + ' 67%, ' + tinycolor(five_sixths).toRgbString() + ' 83%, ' + tinycolor(six_sixths).toRgbString() + ' 100%)'
	            });
	        }
	
	        //---------------------------
	        // saturation functions
	        //---------------------------
	
	    }, {
	        key: 'saturationPosUpdate',
	        value: function saturationPosUpdate() {
	            var el;
	
	            if (!this.options.round) {
	                el = angular.element(this.$element[0].querySelector('.color-picker-grid .color-picker-picker'));
	
	                el.css({
	                    'left': this.pickerDimensions.height * this.saturationPos / 100 + 'px'
	                });
	            }
	
	            el = angular.element(this.$element[0].querySelector('.color-picker-saturation .color-picker-slider'));
	
	            if (this.options.horizontal) {
	                el.css({
	                    'left': this.sliderDimensions.width * (100 - this.saturationPos) / 100 + 'px',
	                    'top': 0
	                });
	            } else {
	                el.css({
	                    'left': 0,
	                    'top': this.sliderDimensions.height * (100 - this.saturationPos) / 100 + 'px'
	                });
	            }
	        }
	    }, {
	        key: 'updateSaturationBackground',
	        value: function updateSaturationBackground(color) {
	            var el = this.find('.color-picker-saturation .color-picker-overlay');
	            var direction = this.options.horizontal ? 'right' : 'bottom';
	            var high = this.getColorValue(this.options.dynamicSaturation);
	            var low = this.getColorValue(this.options.dynamicSaturation);
	
	            high.s = '100%';
	            low.s = '0%';
	
	            el.css({
	                'background': 'linear-gradient(to ' + direction + ', ' + tinycolor(high).toRgbString() + ' 0%, ' + tinycolor(low).toRgbString() + ' 100%)'
	            });
	        }
	
	        //---------------------------
	        // lightness functions
	        //---------------------------
	
	    }, {
	        key: 'lightnessPosUpdate',
	        value: function lightnessPosUpdate() {
	            var el;
	
	            if (!this.options.round) {
	                el = angular.element(this.$element[0].querySelector('.color-picker-grid .color-picker-picker'));
	
	                el.css({
	                    'top': this.pickerDimensions.width * this.lightnessPos / 100 + 'px'
	                });
	            }
	
	            el = angular.element(this.$element[0].querySelector('.color-picker-lightness .color-picker-slider'));
	
	            if (this.options.horizontal) {
	                el.css({
	                    'left': this.sliderDimensions.width * this.lightnessPos / 100 + 'px',
	                    'top': 0
	                });
	            } else {
	                el.css({
	                    'left': 0,
	                    'top': this.sliderDimensions.height * this.lightnessPos / 100 + 'px'
	                });
	            }
	        }
	    }, {
	        key: 'updateLightnessBackground',
	        value: function updateLightnessBackground(color) {
	            var el = this.find('.color-picker-lightness .color-picker-overlay');
	            var direction = this.options.horizontal ? 'right' : 'bottom';
	            var bright = this.getColorValue(this.options.dynamicLightness);
	            var middle = this.getColorValue(this.options.dynamicLightness);
	            var dark = this.getColorValue(this.options.dynamicLightness);
	
	            if (this.options.round) {
	                bright.l = 100;
	                middle.l = 50;
	                dark.l = 0;
	            } else {
	                bright.v = 100;
	                middle.v = 50;
	                dark.v = 0;
	            }
	
	            el.css({
	                'background': 'linear-gradient(to ' + direction + ', ' + tinycolor(bright).toRgbString() + ' 0%, ' + tinycolor(middle).toRgbString() + ' 50%, ' + tinycolor(dark).toRgbString() + ' 100%)'
	            });
	        }
	
	        //---------------------------
	        // opacity functions
	        //---------------------------
	
	    }, {
	        key: 'opacityPosUpdate',
	        value: function opacityPosUpdate() {
	            var el = angular.element(this.$element[0].querySelector('.color-picker-opacity .color-picker-slider'));
	
	            if (this.options.horizontal) {
	                el.css({
	                    'left': this.sliderDimensions.width * this.opacityPos / 100 + 'px',
	                    'top': 0
	                });
	            } else {
	                el.css({
	                    'left': 0,
	                    'top': this.sliderDimensions.height * this.opacityPos / 100 + 'px'
	                });
	            }
	        }
	    }, {
	        key: 'updateOpacityBackground',
	        value: function updateOpacityBackground(color) {
	            var el = this.find('.color-picker-opacity .color-picker-overlay');
	            var direction = this.options.horizontal ? 'right' : 'bottom';
	            var opaque = this.getColorValue(this.options.dynamicAlpha);
	            var transparent = this.getColorValue(this.options.dynamicAlpha);
	
	            opaque.a = 1;
	            transparent.a = 0;
	
	            el.css({
	                'background': 'linear-gradient(to ' + direction + ', ' + tinycolor(opaque).toRgbString() + ' 0%, ' + tinycolor(transparent).toRgbString() + ' 100%)'
	            });
	        }
	
	        //---------------------------
	        // color functions
	        //---------------------------
	
	    }, {
	        key: 'colorChange',
	        value: function colorChange(event) {
	            this.stopEvent(event);
	
	            var el = this.find('.color-picker-grid-inner');
	            var eventPos = this.getEventPos(event);
	            var offset = this.offset(el);
	
	            if (this.options.round) {
	                this.colorChangeRound(el, offset, eventPos);
	            } else {
	                this.colorChangeSquare(el, offset, eventPos);
	            }
	        }
	    }, {
	        key: 'colorChangeRound',
	        value: function colorChangeRound(el, offset, eventPos) {
	            var dx = (eventPos.pageX - offset.left) * 2.0 / el.prop('offsetWidth') - 1.0;
	            var dy = -((eventPos.pageY - offset.top) * 2.0 / el.prop('offsetHeight')) + 1.0;
	
	            var tmpHue = Math.atan2(dy, dx);
	            var degHue = Math.round(tmpHue * 57.29577951308233); // rad to deg
	            if (degHue < 0) {
	                degHue += 360;
	            }
	            this.hue = degHue;
	
	            var tmpSaturation = Math.sqrt(dx * dx + dy * dy);
	
	            if (tmpSaturation > 1) {
	                tmpSaturation = 1;
	            } else if (tmpSaturation < 0) {
	                tmpSaturation = 0;
	            }
	
	            this.saturation = tmpSaturation * 100;
	
	            if (this.lightness === undefined) {
	                this.lightness = 50;
	            }
	        }
	    }, {
	        key: 'colorChangeSquare',
	        value: function colorChangeSquare(el, offset, eventPos) {
	            this.saturation = (eventPos.pageX - offset.left) / el.prop('offsetWidth') * 100;
	            this.lightness = (1 - (eventPos.pageY - offset.top) / el.prop('offsetHeight')) * 100;
	
	            if (this.saturation > 100) {
	                this.saturation = 100;
	            } else if (this.saturation < 0) {
	                this.saturation = 0;
	            }
	
	            if (this.lightness > 100) {
	                this.lightness = 100;
	            } else if (this.lightness < 0) {
	                this.lightness = 0;
	            }
	        }
	    }, {
	        key: 'updateGridBackground',
	        value: function updateGridBackground(color) {
	            var el = this.find('.color-picker-grid .color-picker-overlay');
	            var background = this.getColorValue();
	
	            if (this.options.round) {
	                background.s = '0%';
	            } else {
	                background.s = '100%';
	                background.v = '100%';
	                background.a = 1;
	            }
	
	            el.css({
	                'background-color': tinycolor(background).toRgbString(),
	                'opacity': color.getAlpha()
	            });
	
	            this.find('.color-picker-grid .color-picker-grid-inner').css({
	                'opacity': color.getAlpha()
	            });
	        }
	    }, {
	        key: 'updateSwatchBackground',
	        value: function updateSwatchBackground() {
	            var el = angular.element(this.$element[0].querySelector('.color-picker-swatch'));
	            el.css({
	                'background-color': this.swatchColor
	            });
	        }
	
	        //---------------------------
	        // helper functions
	        //---------------------------
	
	    }, {
	        key: 'isColorValid',
	        value: function isColorValid(color) {
	            var isValid = color.isValid();
	
	            if (isValid && this.options.restrictToFormat) {
	                isValid = color.getFormat() === this.getTinyColorFormat();
	            }
	
	            if (!isValid && this.options.allowEmpty) {
	                var input = color.getOriginalInput();
	
	                if (input === undefined || input === null || input === '') {
	                    isValid = true;
	                }
	            }
	
	            return isValid;
	        }
	    }, {
	        key: 'getTinyColorFormat',
	        value: function getTinyColorFormat() {
	            if (this.options.format === 'hexString') {
	                return 'hex';
	            } else if (this.options.format === 'hex8String') {
	                return 'hex8';
	            }
	
	            return this.options.format;
	        }
	    }, {
	        key: 'areAllValuesSet',
	        value: function areAllValuesSet() {
	            if (this.hue === undefined || this.saturation === undefined || this.lightness === undefined) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'getColorValue',
	        value: function getColorValue() {
	            var dynamicValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var includeOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            var value = {
	                h: this.hue,
	                s: dynamicValues ? this.saturation + '%' : '100%',
	                v: dynamicValues ? this.lightness + '%' : '100%'
	            };
	
	            if (this.options.round) {
	                value = {
	                    h: this.hue,
	                    s: dynamicValues ? this.saturation + '%' : '100%',
	                    l: dynamicValues ? this.lightness + '%' : '50%'
	                };
	            }
	
	            if (includeOpacity) {
	                value.a = dynamicValues ? this.opacity / 100 : 1;
	            }
	
	            return value;
	        }
	
	        /* eslint-disable complexity */
	
	    }, {
	        key: 'setColorValue',
	        value: function setColorValue(color) {
	            var noMouseEvents = !this.anyMouseEvents();
	            var hsl = this.options.round ? color.toHsl() : color.toHsv();
	
	            if (noMouseEvents || this.hueMouse) {
	                this.hue = hsl.h;
	            }
	
	            if (noMouseEvents || this.saturationMouse) {
	                this.saturation = hsl.s * 100;
	            }
	
	            if (noMouseEvents || this.lightnessMouse) {
	                this.lightness = (this.options.round ? hsl.l : hsl.v) * 100;
	            }
	
	            if (this.options.alpha && (noMouseEvents || this.opacityMouse)) {
	                this.opacity = hsl.a * 100;
	            }
	        }
	        /* eslint-enable complexity */
	
	    }, {
	        key: 'checkDirty',
	        value: function checkDirty(color) {
	            // check dirty/pristine state
	            if (this.hasOwnProperty('initialNgModel')) {
	                if (color === this.initialNgModel) {
	                    if (typeof this.$scope.control[0].$setPristine === 'function') {
	                        this.$scope.control[0].$setPristine();
	                    }
	                } else {
	                    if (typeof this.$scope.control[0].$setDirty === 'function') {
	                        this.$scope.control[0].$setDirty();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'stopEvent',
	        value: function stopEvent(event) {
	            event.stopPropagation();
	            event.preventDefault();
	        }
	    }, {
	        key: 'getRoundPos',
	        value: function getRoundPos() {
	            var angle = this.hue * 0.01745329251994; // deg to rad
	            var px = Math.cos(angle) * this.saturation;
	            var py = -Math.sin(angle) * this.saturation;
	
	            this.xPos = (px + 100.0) * 0.5;
	            this.yPos = (py + 100.0) * 0.5;
	
	            // because it are using percentages this can be half of 100%
	            var center = 50;
	            // distance of pointer from the center of the circle
	            var distance = Math.pow(center - this.xPos, 2) + Math.pow(center - this.yPos, 2);
	            // distance of edge of circle from the center of the circle
	            var radius = Math.pow(center, 2);
	
	            // if not inside the circle
	            if (distance > radius) {
	                var rads = Math.atan2(this.yPos - center, this.xPos - center);
	                this.xPos = Math.cos(rads) * center + center;
	                this.yPos = Math.sin(rads) * center + center;
	            }
	        }
	    }, {
	        key: 'updateRoundPos',
	        value: function updateRoundPos() {
	            var el = angular.element(this.$element[0].querySelector('.color-picker-grid .color-picker-picker'));
	
	            el.css({
	                left: this.pickerDimensions.width * this.xPos / 100 + 'px',
	                top: this.pickerDimensions.height * this.yPos / 100 + 'px'
	            });
	        }
	    }, {
	        key: 'getEventPos',
	        value: function getEventPos(event) {
	            // if a touch event
	            if (event.type.search('touch') === 0) {
	                // if event modified by angular
	                if (event.originalEvent && event.originalEvent.changedTouches) {
	                    return event.originalEvent.changedTouches[0];
	                    // if a standard js touch event
	                } else if (event.changedTouches) {
	                    return event.changedTouches[0];
	                }
	            }
	
	            // return a non-touch event
	            return event;
	        }
	    }, {
	        key: 'calculateSliderPos',
	        value: function calculateSliderPos(el, eventPos, multiplier) {
	            if (this.options.horizontal) {
	                return Math.round((1 - (eventPos.pageX - this.offset(el).left) / el.prop('offsetWidth')) * multiplier);
	            }
	
	            return Math.round((1 - (eventPos.pageY - this.offset(el).top) / el.prop('offsetHeight')) * multiplier);
	        }
	    }, {
	        key: 'eventApiDispatch',
	        value: function eventApiDispatch(name, args) {
	            if (this.eventApi && typeof this.eventApi[name] === 'function') {
	                if (!args) {
	                    args = [];
	                }
	
	                args.unshift(this.internalNgModel);
	                args.unshift(this.api);
	
	                this.eventApi[name].apply(this, args);
	            }
	        }
	
	        /** taken and modified from jQuery's find */
	
	    }, {
	        key: 'find',
	        value: function find(selector) {
	            var context = this.wrapper ? this.wrapper[0] : this.$element[0],
	                results = [],
	                nodeType;
	
	            // Same basic safeguard as Sizzle
	            if (!selector) {
	                return results;
	            }
	
	            if (typeof selector === 'string') {
	                // Early return if context is not an element or document
	                if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	                    return [];
	                }
	
	                results = context.querySelectorAll(selector);
	            } else {
	                if (context.contains(selector)) {
	                    results.push(selector);
	                }
	            }
	
	            return angular.element(results);
	        }
	
	        /** taken and modified from jQuery's offset */
	
	    }, {
	        key: 'offset',
	        value: function offset(el) {
	            var docElem,
	                win,
	                rect,
	                doc,
	                elem = el[0];
	
	            if (!elem) {
	                return;
	            }
	
	            // Support: IE<=11+
	            // Running getBoundingClientRect on a
	            // disconnected node in IE throws an error
	            if (!elem.getClientRects().length) {
	                return {
	                    top: 0,
	                    left: 0
	                };
	            }
	
	            rect = elem.getBoundingClientRect();
	
	            // Make sure element is not hidden (display: none)
	            if (rect.width || rect.height) {
	                doc = elem.ownerDocument;
	                win = this.getWindowElements(doc);
	                docElem = doc.documentElement;
	
	                // hack for small chrome screens not position the clicks properly when the page is scrolled
	                if (this.chrome && this.android_version < 6 && screen.width <= 768) {
	                    return {
	                        top: rect.top - docElem.clientTop,
	                        left: rect.left - docElem.clientLeft
	                    };
	                }
	
	                return {
	                    top: rect.top + win.pageYOffset - docElem.clientTop,
	                    left: rect.left + win.pageXOffset - docElem.clientLeft
	                };
	            }
	
	            return rect;
	        }
	    }, {
	        key: 'getWindowElements',
	        value: function getWindowElements(doc) {
	            return doc !== null && doc === doc.window ? doc : doc.nodeType === 9 && doc.defaultView;
	        }
	    }, {
	        key: 'anyMouseEvents',
	        value: function anyMouseEvents() {
	            return this.colorMouse || this.hueMouse || this.saturationMouse || this.lightnessMouse || this.opacityMouse;
	        }
	    }, {
	        key: 'getMaxFromType',
	        value: function getMaxFromType(type) {
	            return type === 'hue' ? 360 : 100;
	        }
	    }]);
	    return AngularColorPickerController;
	}();
	
	AngularColorPickerController.$inject = ['$scope', '$element', '$document', '$timeout', 'ColorPickerOptions'];
	
	function colorPickerDirective() {
	    return {
	        restrict: 'E',
	        require: ['^ngModel'],
	        scope: {
	            ngModel: '=',
	            options: '=?',
	            api: '=?',
	            eventApi: '=?'
	        },
	        bindToController: true,
	        templateUrl: 'template/color-picker/directive.html',
	        controller: AngularColorPickerController,
	        controllerAs: 'AngularColorPickerController',
	        link: function link($scope, element, attrs, control) {
	            $scope.control = control;
	            $scope.init();
	        }
	    };
	}
	
	function template($templateCache) {
	    $templateCache.put('template/color-picker/directive.html', '<div class="color-picker-wrapper" ng-class="{' + '\'color-picker-disabled\': AngularColorPickerController.options.disabled,' + '\'color-picker-swatch-only\': AngularColorPickerController.options.swatchOnly,' + '\'color-picker-open\': AngularColorPickerController.is_open,' + '\'color-picker-closed\': !AngularColorPickerController.is_open,' + '\'color-picker-horizontal\': AngularColorPickerController.options.horizontal,' + '}">' + '<div class="color-picker-input-wrapper" ng-class="{\'input-group\': AngularColorPickerController.options.swatchBootstrap && AngularColorPickerController.options.swatch}">' + '<span ng-if="AngularColorPickerController.options.swatchPos === \'left\'" class="color-picker-swatch" ng-click="AngularColorPickerController.onSwatchClick($event)" ng-show="AngularColorPickerController.options.swatch" ng-class="{\'color-picker-swatch-left\': AngularColorPickerController.options.swatchPos !== \'right\', \'color-picker-swatch-right\': AngularColorPickerController.options.swatchPos === \'right\', \'input-group-addon\': AngularColorPickerController.options.swatchBootstrap}"></span>' + '<input ng-attr-id="{{AngularColorPickerController.options.id}}" ng-attr-name="{{AngularColorPickerController.options.name}}" class="color-picker-input {{AngularColorPickerController.options.inputClass}}" type="text" ng-model="AngularColorPickerController.internalNgModel" ng-model-options="AngularColorPickerController.ngModelOptions" ng-readonly="AngularColorPickerController.options.swatchOnly" ng-disabled="AngularColorPickerController.options.disabled" ng-change="AngularColorPickerController.onChange($event)" size="7" ng-class="{\'color-picker-input-swatch\': AngularColorPickerController.options.swatch && !AngularColorPickerController.options.swatchOnly && AngularColorPickerController.options.swatchPos === \'left\'}" placeholder="{{AngularColorPickerController.options.placeholder}}" ng-required="AngularColorPickerController.options.required">' + '<span ng-if="AngularColorPickerController.options.swatchPos === \'right\'" class="color-picker-swatch" ng-click="AngularColorPickerController.onSwatchClick($event)" ng-show="AngularColorPickerController.options.swatch" ng-class="{\'color-picker-swatch-left\': AngularColorPickerController.options.swatchPos !== \'right\', \'color-picker-swatch-right\': AngularColorPickerController.options.swatchPos === \'right\', \'input-group-addon\': AngularColorPickerController.options.swatchBootstrap}"></span>' + '</div>' + '<div class="color-picker-panel" ng-class="{' + '\'color-picker-panel-top color-picker-panel-right\': AngularColorPickerController.options.pos === \'top right\',' + '\'color-picker-panel-top color-picker-panel-left\': AngularColorPickerController.options.pos === \'top left\',' + '\'color-picker-panel-bottom color-picker-panel-right\': AngularColorPickerController.options.pos === \'bottom right\',' + '\'color-picker-panel-bottom color-picker-panel-left\': AngularColorPickerController.options.pos === \'bottom left\',' + '\'color-picker-panel-round\': AngularColorPickerController.options.round,' + '\'color-picker-show-hue\': AngularColorPickerController.options.hue,' + '\'color-picker-show-saturation\': AngularColorPickerController.options.saturation,' + '\'color-picker-show-lightness\': AngularColorPickerController.options.lightness,' + '\'color-picker-show-alpha\': AngularColorPickerController.options.alpha && AngularColorPickerController.options.format !== \'hex\',' + '\'color-picker-show-inline\': AngularColorPickerController.options.inline,' + '}">' + '<div class="color-picker-grid-wrapper">' + '<div class="color-picker-row">' + '<div class="color-picker-grid">' + '<div class="color-picker-overlay"></div>' + '<div class="color-picker-grid-inner"></div>' + '<div class="color-picker-picker">' + '<div></div>' + '</div>' + '</div>' + '<div class="color-picker-hue" ng-show="AngularColorPickerController.options.hue">' + '<div class="color-picker-overlay"></div>' + '<div class="color-picker-slider"></div>' + '</div>' + '<div class="color-picker-saturation" ng-show="AngularColorPickerController.options.saturation">' + '<div class="color-picker-overlay"></div>' + '<div class="color-picker-slider"></div>' + '</div>' + '<div class="color-picker-lightness" ng-show="AngularColorPickerController.options.lightness">' + '<div class="color-picker-overlay"></div>' + '<div class="color-picker-slider"></div>' + '</div>' + '<div class="color-picker-opacity" ng-show="AngularColorPickerController.options.alpha && AngularColorPickerController.options.format !== \'hex\'">' + '<div class="color-picker-overlay"></div>' + '<div class="color-picker-slider"></div>' + '</div>' + '</div>' + '</div>' + '<div class="color-picker-actions">' + '<button ' + 'type="button"' + 'class="color-picker-action color-picker-action-clear"' + 'tabindex="-1"' + 'ng-class="AngularColorPickerController.options.clear.class"' + 'ng-show="AngularColorPickerController.options.clear.show"' + 'ng-click="AngularColorPickerController.api.clear($event)"' + '>' + '{{AngularColorPickerController.options.clear.label}}' + '</button>' + '<button ' + 'type="button"' + 'class="color-picker-action color-picker-action-reset"' + 'tabindex="-1"' + 'ng-class="AngularColorPickerController.options.reset.class"' + 'ng-show="AngularColorPickerController.options.reset.show"' + 'ng-click="AngularColorPickerController.api.reset($event)"' + '>' + '{{AngularColorPickerController.options.reset.label}}' + '</button>' + '<button ' + 'type="button"' + 'class="color-picker-action color-picker-action-close"' + 'tabindex="-1"' + 'ng-class="AngularColorPickerController.options.close.class"' + 'ng-show="AngularColorPickerController.options.close.show"' + 'ng-click="AngularColorPickerController.api.close($event)"' + '>' + '{{AngularColorPickerController.options.close.label}}' + '</button>' + '</div>' + '</div>' + '</div>');
	}
	
	template.$inject = ['$templateCache'];
	
	var AngularColorPickerOptions = function AngularColorPickerOptions() {
	    classCallCheck(this, AngularColorPickerOptions);
	
	    return {
	        // input attributes
	        id: undefined,
	        name: undefined,
	        required: false,
	        disabled: false,
	        placeholder: '',
	        inputClass: '',
	        // validation
	        restrictToFormat: false,
	        preserveInputFormat: false,
	        allowEmpty: false,
	        // color
	        format: 'hsl',
	        case: 'upper',
	        // sliders
	        hue: true,
	        saturation: false,
	        lightness: false,
	        alpha: true,
	        dynamicHue: true,
	        dynamicSaturation: true,
	        dynamicLightness: true,
	        dynamicAlpha: true,
	        // picker
	        round: false,
	        pos: 'bottom left',
	        inline: false,
	        horizontal: false,
	        // swatch
	        swatch: true,
	        swatchOnly: false,
	        swatchPos: 'left',
	        swatchBootstrap: true,
	        // show/hide events
	        show: {
	            swatch: true,
	            focus: true
	        },
	        hide: {
	            blur: true,
	            escape: true,
	            click: true
	        },
	        // buttons
	        close: {
	            show: false,
	            label: 'Close',
	            class: ''
	        },
	        clear: {
	            show: false,
	            label: 'Clear',
	            class: ''
	        },
	        reset: {
	            show: false,
	            label: 'Reset',
	            class: ''
	        }
	    };
	};
	
	var colorPicker = angular.module('color.picker', []).service('ColorPickerOptions', AngularColorPickerOptions).directive('colorPicker', colorPickerDirective).run(template);
	
	return colorPicker;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 1.3.10
	* @author: Dan Grossman http://www.dangrossman.info/
	* @date: 2014-08-07
	* @copyright: Copyright (c) 2012-2014 Dan Grossman. All rights reserved.
	* @license: Licensed under Apache License v2.0. See http://www.apache.org/licenses/LICENSE-2.0
	* @website: http://www.improvely.com/
	*/
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(12), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(momentjs, $, exports) {
	      root.daterangepicker = factory(root, exports, momentjs, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  } else if (typeof exports !== 'undefined') {
	    var momentjs = require('moment');
	    var jQuery;
	    try {
	      jQuery = require('jquery');
	    } catch (err) {
	      jQuery = window.jQuery;
	      if (!jQuery) throw new Error('jQuery dependency not found');
	    }
	
	    factory(root, exports, momentjs, jQuery);
	
	  // Finally, as a browser global.
	  } else {
	    root.daterangepicker = factory(root, {}, root.moment, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	}(this, function(root, daterangepicker, moment, $) {
	
	    var DateRangePicker = function (element, options, cb) {
	
	        // by default, the daterangepicker element is placed at the bottom of HTML body
	        this.parentEl = 'body';
	
	        //element that triggered the date range picker
	        this.element = $(element);
	
	        //tracks visible state
	        this.isShowing = false;
	
	        //create the picker HTML object
	        var DRPTemplate = '<div class="daterangepicker dropdown-menu">' +
	                '<div class="daterangepicker-inner">'+
	                '<div class="ranges">' +
	                  '<div class="range_inputs">' +
	                    '<div class="daterangepicker_start_input">' +
	                      '<label for="daterangepicker_start"></label>' +
	                      '<input class="input-mini" type="text" name="daterangepicker_start" value="" />' +
	                    '</div>' +
	                    '<div class="daterangepicker_end_input">' +
	                      '<label for="daterangepicker_end"></label>' +
	                      '<input class="input-mini" type="text" name="daterangepicker_end" value="" />' +
	                    '</div>' +
	                    '<button class="applyBtn" disabled="disabled"></button>&nbsp;' +
	                    '<button class="cancelBtn"></button>' +
	                  '</div>' +
	                '</div>' +
	                '<div class="calendar right"></div>' +
	                '<div class="calendar left"></div>' +
	                '</div>'+
	              '</div>';
	
	        //custom options
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        this.parentEl = (typeof options === 'object' && options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(DRPTemplate).appendTo(this.parentEl);
	
	        this.setOptions(options, cb);
	
	        //apply CSS classes and labels to buttons
	        var c = this.container;
	        $.each(this.buttonClasses, function (idx, val) {
	            c.find('button').addClass(val);
	        });
	        this.container.find('.daterangepicker_start_input label').html(this.locale.fromLabel);
	        this.container.find('.daterangepicker_end_input label').html(this.locale.toLabel);
	        if (this.applyClass.length)
	            this.container.find('.applyBtn').addClass(this.applyClass);
	        if (this.cancelClass.length)
	            this.container.find('.cancelBtn').addClass(this.cancelClass);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //event listeners
	
	        this.container.find('.calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('click.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.updateMonthYear, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.updateMonthYear, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.ampmselect', $.proxy(this.updateTime, this));
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	            .on('click.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.showCalendars, this))
	            .on('change.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.inputsChanged, this))
	            .on('keydown.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.inputsKeydown, this))
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	            .on('mouseenter.daterangepicker', 'li', $.proxy(this.enterRange, this))
	            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
	
	        if (this.element.is('input')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                // 'keyup.daterangepicker': $.proxy(this.updateFromControl, this)
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setOptions: function(options, callback) {
	
	            this.startDate = moment().startOf('day');
	            this.endDate = moment().endOf('day');
	            this.minDate = false;
	            this.maxDate = false;
	            this.dateLimit = false;
	
	            this.showDropdowns = false;
	            this.showWeekNumbers = false;
	            this.timePicker = false;
	            this.timePickerIncrement = 30;
	            this.timePicker12Hour = true;
	            this.singleDatePicker = false;
	            this.ranges = {};
	
	            this.opens = 'right';
	            if (this.element.hasClass('pull-right'))
	                this.opens = 'left';
	
	            this.buttonClasses = ['btn', 'btn-small btn-sm'];
	            this.applyClass = 'btn-success';
	            this.cancelClass = 'btn-default';
	
	            this.format = 'MM/DD/YYYY';
	            this.separator = ' - ';
	
	            this.locale = {
	                applyLabel: 'Apply',
	                cancelLabel: 'Cancel',
	                fromLabel: 'From',
	                toLabel: 'To',
	                weekLabel: 'W',
	                customRangeLabel: 'Custom Range',
	                daysOfWeek: moment.weekdaysMin(),
	                monthNames: moment.monthsShort(),
	                firstDay: moment.localeData()._week.dow
	            };
	
	            this.cb = function () { };
	
	            if (typeof options.format === 'string')
	                this.format = options.format;
	
	            if (typeof options.separator === 'string')
	                this.separator = options.separator;
	
	            if (typeof options.startDate === 'string')
	                this.startDate = moment(options.startDate, this.format);
	
	            if (typeof options.endDate === 'string')
	                this.endDate = moment(options.endDate, this.format);
	
	            if (typeof options.minDate === 'string')
	                this.minDate = moment(options.minDate, this.format);
	
	            if (typeof options.maxDate === 'string')
	                this.maxDate = moment(options.maxDate, this.format);
	
	            if (typeof options.startDate === 'object')
	                this.startDate = moment(options.startDate);
	
	            if (typeof options.endDate === 'object')
	                this.endDate = moment(options.endDate);
	
	            if (typeof options.minDate === 'object')
	                this.minDate = moment(options.minDate);
	
	            if (typeof options.maxDate === 'object')
	                this.maxDate = moment(options.maxDate);
	
	            if (typeof options.applyClass === 'string')
	                this.applyClass = options.applyClass;
	
	            if (typeof options.cancelClass === 'string')
	                this.cancelClass = options.cancelClass;
	
	            if (typeof options.dateLimit === 'object')
	                this.dateLimit = options.dateLimit;
	
	            if (typeof options.locale === 'object') {
	
	                if (typeof options.locale.daysOfWeek === 'object') {
	                    // Create a copy of daysOfWeek to avoid modification of original
	                    // options object for reusability in multiple daterangepicker instances
	                    this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	                }
	
	                if (typeof options.locale.monthNames === 'object') {
	                  this.locale.monthNames = options.locale.monthNames.slice();
	                }
	
	                if (typeof options.locale.firstDay === 'number') {
	                  this.locale.firstDay = options.locale.firstDay;
	                }
	
	                if (typeof options.locale.applyLabel === 'string') {
	                  this.locale.applyLabel = options.locale.applyLabel;
	                }
	
	                if (typeof options.locale.cancelLabel === 'string') {
	                  this.locale.cancelLabel = options.locale.cancelLabel;
	                }
	
	                if (typeof options.locale.fromLabel === 'string') {
	                  this.locale.fromLabel = options.locale.fromLabel;
	                }
	
	                if (typeof options.locale.toLabel === 'string') {
	                  this.locale.toLabel = options.locale.toLabel;
	                }
	
	                if (typeof options.locale.weekLabel === 'string') {
	                  this.locale.weekLabel = options.locale.weekLabel;
	                }
	
	                if (typeof options.locale.customRangeLabel === 'string') {
	                  this.locale.customRangeLabel = options.locale.customRangeLabel;
	                }
	            }
	
	            if (typeof options.opens === 'string')
	                this.opens = options.opens;
	
	            if (typeof options.showWeekNumbers === 'boolean') {
	                this.showWeekNumbers = options.showWeekNumbers;
	            }
	
	            if (typeof options.buttonClasses === 'string') {
	                this.buttonClasses = [options.buttonClasses];
	            }
	
	            if (typeof options.buttonClasses === 'object') {
	                this.buttonClasses = options.buttonClasses;
	            }
	
	            if (typeof options.showDropdowns === 'boolean') {
	                this.showDropdowns = options.showDropdowns;
	            }
	
	            if (typeof options.singleDatePicker === 'boolean') {
	                this.singleDatePicker = options.singleDatePicker;
	            }
	
	            if (typeof options.timePicker === 'boolean') {
	                this.timePicker = options.timePicker;
	            }
	
	            if (typeof options.timePickerIncrement === 'number') {
	                this.timePickerIncrement = options.timePickerIncrement;
	            }
	
	            if (typeof options.timePicker12Hour === 'boolean') {
	                this.timePicker12Hour = options.timePicker12Hour;
	            }
	
	            // update day names order to firstDay
	            if (this.locale.firstDay != 0) {
	                var iterator = this.locale.firstDay;
	                while (iterator > 0) {
	                    this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                    iterator--;
	                }
	            }
	
	            var start, end, range;
	
	            //if no start/end dates set, check if an input element contains initial values
	            if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	                if ($(this.element).is('input[type=text]')) {
	                    var val = $(this.element).val();
	                    var split = val.split(this.separator);
	                    start = end = null;
	                    if (split.length == 2) {
	                        start = moment(split[0], this.format);
	                        end = moment(split[1], this.format);
	                    } else if (this.singleDatePicker) {
	                        start = moment(val, this.format);
	                        end = moment(val, this.format);
	                    }
	                    if (start !== null && end !== null) {
	                        this.startDate = start;
	                        this.endDate = end;
	                    }
	                }
	            }
	
	            if (typeof options.ranges === 'object') {
	                for (range in options.ranges) {
	
	                    start = moment(options.ranges[range][0]);
	                    end = moment(options.ranges[range][1]);
	
	                    // If we have a min/max date set, bound this range
	                    // to it, but only if it would otherwise fall
	                    // outside of the min/max.
	                    if (this.minDate && start.isBefore(this.minDate))
	                        start = moment(this.minDate);
	
	                    if (this.maxDate && end.isAfter(this.maxDate))
	                        end = moment(this.maxDate);
	
	                    // If the end of the range is before the minimum (if min is set) OR
	                    // the start of the range is after the max (also if set) don't display this
	                    // range option.
	                    if ((this.minDate && end.isBefore(this.minDate)) || (this.maxDate && start.isAfter(this.maxDate))) {
	                        continue;
	                    }
	
	                    this.ranges[range] = [start, end];
	                }
	
	                var list = '<ul>';
	                for (range in this.ranges) {
	                    list += '<li>' + range + '</li>';
	                }
	                list += '<li>' + this.locale.customRangeLabel + '</li>';
	                list += '</ul>';
	                this.container.find('.ranges ul').remove();
	                this.container.find('.ranges').prepend(list);
	            }
	
	            if (typeof callback === 'function') {
	                this.cb = callback;
	            }
	
	            if (!this.timePicker) {
	                this.startDate = this.startDate.startOf('day');
	                this.endDate = this.endDate.endOf('day');
	            }
	
	            if (this.singleDatePicker) {
	                this.opens = 'right';
	                this.container.find('.calendar.right').show();
	                this.container.find('.calendar.left').hide();
	                this.container.find('.ranges').hide();
	                if (!this.container.find('.calendar.right').hasClass('single'))
	                    this.container.find('.calendar.right').addClass('single');
	            } else {
	                this.container.find('.calendar.right').show().removeClass('single');
	                this.container.find('.calendar.left').show();
	                this.container.find('.ranges').show();
	            }
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.oldChosenLabel = this.chosenLabel;
	
	            this.leftCalendar = {
	                month: moment([this.startDate.year(), this.startDate.month(), 1, this.startDate.hour(), this.startDate.minute()]),
	                calendar: []
	            };
	
	            this.rightCalendar = {
	                month: moment([this.endDate.year(), this.endDate.month(), 1, this.endDate.hour(), this.endDate.minute()]),
	                calendar: []
	            };
	
	            if (this.opens == 'right') {
	                //swap calendar positions
	                var left = this.container.find('.calendar.left');
	                var right = this.container.find('.calendar.right');
	
	                if (right.hasClass('single')) {
	                    right.removeClass('single');
	                    left.addClass('single');
	                }
	
	                left.removeClass('left').addClass('right');
	                right.removeClass('right').addClass('left');
	
	                if (this.singleDatePicker) {
	                    left.show();
	                    right.hide();
	                }
	            }
	
	            if (typeof options.ranges === 'undefined' && !this.singleDatePicker) {
	                this.container.addClass('show-calendar');
	            }
	
	            this.container.addClass('opens' + this.opens);
	
	            this.updateView();
	            this.updateCalendars();
	
	        },
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            this.oldStartDate = this.startDate.clone();
	
	            this.updateView();
	            this.updateCalendars();
	            this.updateInputText();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.endOf('day');
	
	            this.oldEndDate = this.endDate.clone();
	
	            this.updateView();
	            this.updateCalendars();
	            this.updateInputText();
	        },
	
	        updateView: function () {
	            this.leftCalendar.month.month(this.startDate.month()).year(this.startDate.year()).hour(this.startDate.hour()).minute(this.startDate.minute());
	            this.rightCalendar.month.month(this.endDate.month()).year(this.endDate.year()).hour(this.endDate.hour()).minute(this.endDate.minute());
	            this.updateFormInputs();
	        },
	
	        updateFormInputs: function () {
	            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.format));
	            this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.format));
	
	            if (this.startDate.isSame(this.endDate) || this.startDate.isBefore(this.endDate)) {
	                this.container.find('button.applyBtn').removeAttr('disabled');
	            } else {
	                this.container.find('button.applyBtn').attr('disabled', 'disabled');
	            }
	        },
	
	        updateFromControl: function () {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	
	            var dateString = this.element.val().split(this.separator),
	                start = null,
	                end = null;
	
	            if(dateString.length === 2) {
	                start = moment(dateString[0], this.format);
	                end = moment(dateString[1], this.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.format);
	                end = start;
	            }
	
	            if (end.isBefore(start)) return;
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	
	            this.startDate = start;
	            this.endDate = end;
	
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.notify();
	
	            this.updateCalendars();
	        },
	
	        notify: function () {
	            this.updateView();
	            this.cb(this.startDate, this.endDate, this.chosenLabel);
	        },
	
	        move: function () {
	            var parentOffset = { top: 0, left: 0 };
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            if (this.opens == 'left') {
	                this.container.css({
	                    top: this.element.offset().top + this.element.outerHeight() - parentOffset.top,
	                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
	                    left: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else {
	                this.container.css({
	                    top: this.element.offset().top + this.element.outerHeight() - parentOffset.top,
	                    left: this.element.offset().left - parentOffset.left,
	                    right: 'auto'
	                });
	                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
	                    this.container.css({
	                        left: 'auto',
	                        right: 0
	                    });
	                }
	            }
	        },
	
	        toggle: function (e) {
	            if (this.element.hasClass('active')) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        show: function (e) {
	            if (this.isShowing) return;
	
	            this.element.addClass('active');
	            this.container.show();
	            this.move();
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function (e) { this.outsideClick(e); }, this);
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            this.isShowing = true;
	            this.element.trigger('show.daterangepicker', this);
	        },
	
	        outsideClick: function (e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-date').length
	                ) return;
	            this.hide();
	        },
	
	        hide: function (e) {
	            if (!this.isShowing) return;
	
	            $(document)
	              .off('mousedown.daterangepicker')
	              .off('click.daterangepicker', '[data-toggle=dropdown]')
	              .off('focusin.daterangepicker');
	
	            this.element.removeClass('active');
	            this.container.hide();
	
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.notify();
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	
	            this.isShowing = false;
	            this.element.trigger('hide.daterangepicker', this);
	        },
	
	        enterRange: function (e) {
	            // mouse pointer has entered a range label
	            var label = e.target.innerHTML;
	            if (label == this.locale.customRangeLabel) {
	                this.updateView();
	            } else {
	                var dates = this.ranges[label];
	                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.format));
	                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.format));
	            }
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        // when a date is typed into the start to end date textboxes
	        inputsChanged: function (e) {
	            var el = $(e.target);
	            var date = moment(el.val());
	            if (!date.isValid()) return;
	
	            var startDate, endDate;
	            if (el.attr('name') === 'daterangepicker_start') {
	                startDate = date;
	                endDate = this.endDate;
	            } else {
	                startDate = this.startDate;
	                endDate = date;
	            }
	            this.setCustomDates(startDate, endDate);
	        },
	
	        inputsKeydown: function(e) {
	            if (e.keyCode === 13) {
	                this.inputsChanged(e);
	                this.notify();
	            }
	        },
	
	        updateInputText: function() {
	            if (this.element.is('input') && !this.singleDatePicker) {
	                this.element.val(this.startDate.format(this.format) + this.separator + this.endDate.format(this.format));
	            } else if (this.element.is('input')) {
	                this.element.val(this.startDate.format(this.format));
	            }
	        },
	
	        clickRange: function (e) {
	            var label = e.target.innerHTML;
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                // if (!this.timePicker) {
	                //     this.startDate.startOf('day');
	                //     this.endDate.endOf('day');
	                // }
	
	                this.leftCalendar.month.month(this.startDate.month()).year(this.startDate.year()).hour(this.startDate.hour()).minute(this.startDate.minute());
	                this.rightCalendar.month.month(this.endDate.month()).year(this.endDate.year()).hour(this.endDate.hour()).minute(this.endDate.minute());
	                this.updateCalendars();
	
	                this.updateInputText();
	
	                this.hideCalendars();
	                this.hide();
	                this.element.trigger('apply.daterangepicker', this);
	            }
	        },
	
	        clickPrev: function (e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract('month', 1);
	            } else {
	                this.rightCalendar.month.subtract('month', 1);
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function (e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add('month', 1);
	            } else {
	                this.rightCalendar.month.add('month', 1);
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function (e) {
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	
	            if (cal.hasClass('left')) {
	                this.container.find('input[name=daterangepicker_start]').val(this.leftCalendar.calendar[row][col].format(this.format));
	            } else {
	                this.container.find('input[name=daterangepicker_end]').val(this.rightCalendar.calendar[row][col].format(this.format));
	            }
	        },
	
	        setCustomDates: function(startDate, endDate) {
	            this.chosenLabel = this.locale.customRangeLabel;
	            if (startDate.isAfter(endDate)) {
	                var difference = this.endDate.diff(this.startDate);
	                endDate = moment(startDate).add('ms', difference);
	            }
	            this.startDate = startDate;
	            this.endDate = endDate;
	
	            this.updateView();
	            this.updateCalendars();
	        },
	
	        clickDate: function (e) {
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	
	            var startDate, endDate;
	            if (cal.hasClass('left')) {
	                startDate = this.leftCalendar.calendar[row][col];
	                endDate = this.endDate;
	                if (typeof this.dateLimit === 'object') {
	                    var maxDate = moment(startDate).add(this.dateLimit).startOf('day');
	                    if (endDate.isAfter(maxDate)) {
	                        endDate = maxDate;
	                    }
	                }
	            } else {
	                startDate = this.startDate;
	                endDate = this.rightCalendar.calendar[row][col];
	                if (typeof this.dateLimit === 'object') {
	                    var minDate = moment(endDate).subtract(this.dateLimit).startOf('day');
	                    if (startDate.isBefore(minDate)) {
	                        startDate = minDate;
	                    }
	                }
	            }
	
	            if (this.singleDatePicker && cal.hasClass('left')) {
	                endDate = startDate.clone();
	            } else if (this.singleDatePicker && cal.hasClass('right')) {
	                startDate = endDate.clone();
	            }
	
	            cal.find('td').removeClass('active');
	
	            $(e.target).addClass('active');
	
	            this.setCustomDates(startDate, endDate);
	
	            if (!this.timePicker)
	                endDate.endOf('day');
	
	            if (this.singleDatePicker)
	                this.clickApply();
	        },
	
	        clickApply: function (e) {
	            this.updateInputText();
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function (e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.chosenLabel = this.oldChosenLabel;
	            this.updateView();
	            this.updateCalendars();
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        updateMonthYear: function (e) {
	            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            this[leftOrRight+'Calendar'].month.month(month).year(year);
	            this.updateCalendars();
	        },
	
	        updateTime: function(e) {
	
	            var cal = $(e.target).closest('.calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	
	            if (this.timePicker12Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                this.startDate = start;
	                this.leftCalendar.month.hour(hour).minute(minute);
	            } else {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                this.endDate = end;
	                this.rightCalendar.month.hour(hour).minute(minute);
	            }
	
	            this.updateCalendars();
	        },
	
	        updateCalendars: function () {
	            this.leftCalendar.calendar = this.buildCalendar(this.leftCalendar.month.month(), this.leftCalendar.month.year(), this.leftCalendar.month.hour(), this.leftCalendar.month.minute(), 'left');
	            this.rightCalendar.calendar = this.buildCalendar(this.rightCalendar.month.month(), this.rightCalendar.month.year(), this.rightCalendar.month.hour(), this.rightCalendar.month.minute(), 'right');
	            this.container.find('.calendar.left').empty().html(this.renderCalendar(this.leftCalendar.calendar, this.startDate, this.minDate, this.maxDate));
	            this.container.find('.calendar.right').empty().html(this.renderCalendar(this.rightCalendar.calendar, this.endDate, this.startDate, this.maxDate));
	
	            this.container.find('.ranges li').removeClass('active');
	            var customRange = true;
	            var i = 0;
	            for (var range in this.ranges) {
	                if (this.timePicker) {
	                    if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')')
	                            .addClass('active').html();
	                    }
	                } else {
	                    //ignore times when comparing dates if time picker is not enabled
	                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')')
	                            .addClass('active').html();
	                    }
	                }
	                i++;
	            }
	            if (customRange) {
	                this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
	                this.showCalendars();
	            }
	        },
	
	        buildCalendar: function (month, year, hour, minute, side) {
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract('month', 1).month();
	            var lastYear = moment(firstDay).subtract('month', 1).year();
	
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	
	            var dayOfWeek = firstDay.day();
	
	            var i;
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute]);
	            var col, row;
	            for (i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add('hour', 24)) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour);
	                curDate.hour(12);
	            }
	
	            return calendar;
	        },
	
	        renderDropdowns: function (selected, minDate, maxDate) {
	            var currentMonth = selected.month();
	            var monthHtml = '<select class="monthselect">';
	            var inMinYear = false;
	            var inMaxYear = false;
	
	            for (var m = 0; m < 12; m++) {
	                if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
	                    monthHtml += "<option value='" + m + "'" +
	                        (m === currentMonth ? " selected='selected'" : "") +
	                        ">" + this.locale.monthNames[m] + "</option>";
	                }
	            }
	            monthHtml += "</select>";
	
	            var currentYear = selected.year();
	            var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
	            var minYear = (minDate && minDate.year()) || (currentYear - 50);
	            var yearHtml = '<select class="yearselect">';
	
	            for (var y = minYear; y <= maxYear; y++) {
	                yearHtml += '<option value="' + y + '"' +
	                    (y === currentYear ? ' selected="selected"' : '') +
	                    '>' + y + '</option>';
	            }
	
	            yearHtml += '</select>';
	
	            return monthHtml + yearHtml;
	        },
	
	        renderCalendar: function (calendar, selected, minDate, maxDate) {
	
	            var html = '<div class="calendar-date">';
	            html += '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers)
	                html += '<th></th>';
	
	            if (!minDate || minDate.isBefore(calendar.firstDay)) {
	                html += '<th class="prev available"><i class="fa fa-arrow-left icon-arrow-left glyphicon glyphicon-arrow-left"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                dateHtml = this.renderDropdowns(calendar[1][1], minDate, maxDate);
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if (!maxDate || maxDate.isAfter(calendar.lastDay)) {
	                html += '<th class="next available"><i class="fa fa-arrow-right icon-arrow-right glyphicon glyphicon-arrow-right"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	                    var cname = 'available ';
	                    cname += (calendar[row][col].month() == calendar[1][1].month()) ? '' : 'off';
	
	                    if ((minDate && calendar[row][col].isBefore(minDate, 'day')) || (maxDate && calendar[row][col].isAfter(maxDate, 'day'))) {
	                        cname = ' off disabled ';
	                    } else if (calendar[row][col].format('YYYY-MM-DD') == selected.format('YYYY-MM-DD')) {
	                        cname += ' active ';
	                        if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')) {
	                            cname += ' start-date ';
	                        }
	                        if (calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')) {
	                            cname += ' end-date ';
	                        }
	                    } else if (calendar[row][col] >= this.startDate && calendar[row][col] <= this.endDate) {
	                        cname += ' in-range ';
	                        if (calendar[row][col].isSame(this.startDate)) { cname += ' start-date '; }
	                        if (calendar[row][col].isSame(this.endDate)) { cname += ' end-date '; }
	                    }
	
	                    var title = 'r' + row + 'c' + col;
	                    html += '<td class="' + cname.replace(/\s+/g, ' ').replace(/^\s?(.*?)\s?$/, '$1') + '" data-title="' + title + '">' + calendar[row][col].date() + '</td>';
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	            html += '</div>';
	
	            var i;
	            if (this.timePicker) {
	
	                html += '<div class="calendar-time">';
	                html += '<select class="hourselect">';
	                var start = 0;
	                var end = 23;
	                var selected_hour = selected.hour();
	                if (this.timePicker12Hour) {
	                    start = 1;
	                    end = 12;
	                    if (selected_hour >= 12)
	                        selected_hour -= 12;
	                    if (selected_hour === 0)
	                        selected_hour = 12;
	                }
	
	                for (i = start; i <= end; i++) {
	                    if (i == selected_hour) {
	                        html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + i + '</option>';
	                    }
	                }
	
	                html += '</select> : ';
	
	                html += '<select class="minuteselect">';
	
	                for (i = 0; i < 60; i += this.timePickerIncrement) {
	                    var num = i;
	                    if (num < 10)
	                        num = '0' + num;
	                    if (i == selected.minute()) {
	                        html += '<option value="' + i + '" selected="selected">' + num + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + num + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	
	                if (this.timePicker12Hour) {
	                    html += '<select class="ampmselect">';
	                    if (selected.hour() >= 12) {
	                        html += '<option value="AM">AM</option><option value="PM" selected="selected">PM</option>';
	                    } else {
	                        html += '<option value="AM" selected="selected">AM</option><option value="PM">PM</option>';
	                    }
	                    html += '</select>';
	                }
	
	                html += '</div>';
	
	            }
	
	            return html;
	
	        },
	
	        remove: function() {
	
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData('daterangepicker');
	
	        }
	
	    };
	
	    $.fn.daterangepicker = function (options, cb) {
	        this.each(function () {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, options, cb));
	        });
	        return this;
	    };
	
	}));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {
	/*
	 *
	 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
	 *
	 * Copyright (c) 2012, Matias Meno
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persorns to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 */
	
	(function() {
	  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
	    __slice = [].slice,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  noop = function() {};
	
	  Emitter = (function() {
	    function Emitter() {}
	
	    Emitter.prototype.addEventListener = Emitter.prototype.on;
	
	    Emitter.prototype.on = function(event, fn) {
	      this._callbacks = this._callbacks || {};
	      if (!this._callbacks[event]) {
	        this._callbacks[event] = [];
	      }
	      this._callbacks[event].push(fn);
	      return this;
	    };
	
	    Emitter.prototype.emit = function() {
	      var args, callback, callbacks, event, _i, _len;
	      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      this._callbacks = this._callbacks || {};
	      callbacks = this._callbacks[event];
	      if (callbacks) {
	        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
	          callback = callbacks[_i];
	          callback.apply(this, args);
	        }
	      }
	      return this;
	    };
	
	    Emitter.prototype.removeListener = Emitter.prototype.off;
	
	    Emitter.prototype.removeAllListeners = Emitter.prototype.off;
	
	    Emitter.prototype.removeEventListener = Emitter.prototype.off;
	
	    Emitter.prototype.off = function(event, fn) {
	      var callback, callbacks, i, _i, _len;
	      if (!this._callbacks || arguments.length === 0) {
	        this._callbacks = {};
	        return this;
	      }
	      callbacks = this._callbacks[event];
	      if (!callbacks) {
	        return this;
	      }
	      if (arguments.length === 1) {
	        delete this._callbacks[event];
	        return this;
	      }
	      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
	        callback = callbacks[i];
	        if (callback === fn) {
	          callbacks.splice(i, 1);
	          break;
	        }
	      }
	      return this;
	    };
	
	    return Emitter;
	
	  })();
	
	  Dropzone = (function(_super) {
	    var extend, resolveOption;
	
	    __extends(Dropzone, _super);
	
	    Dropzone.prototype.Emitter = Emitter;
	
	
	    /*
	    This is a list of all available events you can register on a dropzone object.
	    
	    You can register an event handler like this:
	    
	        dropzone.on("dragEnter", function() { });
	     */
	
	    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];
	
	    Dropzone.prototype.defaultOptions = {
	      url: null,
	      method: "post",
	      withCredentials: false,
	      parallelUploads: 2,
	      uploadMultiple: false,
	      maxFilesize: 256,
	      paramName: "file",
	      createImageThumbnails: true,
	      maxThumbnailFilesize: 10,
	      thumbnailWidth: 120,
	      thumbnailHeight: 120,
	      filesizeBase: 1000,
	      maxFiles: null,
	      params: {},
	      clickable: true,
	      ignoreHiddenFiles: true,
	      acceptedFiles: null,
	      acceptedMimeTypes: null,
	      autoProcessQueue: true,
	      autoQueue: true,
	      addRemoveLinks: false,
	      previewsContainer: null,
	      hiddenInputContainer: "body",
	      capture: null,
	      renameFilename: null,
	      dictDefaultMessage: "Drop files here to upload",
	      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
	      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
	      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
	      dictInvalidFileType: "You can't upload files of this type.",
	      dictResponseError: "Server responded with {{statusCode}} code.",
	      dictCancelUpload: "Cancel upload",
	      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
	      dictRemoveFile: "Remove file",
	      dictRemoveFileConfirmation: null,
	      dictMaxFilesExceeded: "You can not upload any more files.",
	      accept: function(file, done) {
	        return done();
	      },
	      init: function() {
	        return noop;
	      },
	      forceFallback: false,
	      fallback: function() {
	        var child, messageElement, span, _i, _len, _ref;
	        this.element.className = "" + this.element.className + " dz-browser-not-supported";
	        _ref = this.element.getElementsByTagName("div");
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          child = _ref[_i];
	          if (/(^| )dz-message($| )/.test(child.className)) {
	            messageElement = child;
	            child.className = "dz-message";
	            continue;
	          }
	        }
	        if (!messageElement) {
	          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
	          this.element.appendChild(messageElement);
	        }
	        span = messageElement.getElementsByTagName("span")[0];
	        if (span) {
	          if (span.textContent != null) {
	            span.textContent = this.options.dictFallbackMessage;
	          } else if (span.innerText != null) {
	            span.innerText = this.options.dictFallbackMessage;
	          }
	        }
	        return this.element.appendChild(this.getFallbackForm());
	      },
	      resize: function(file) {
	        var info, srcRatio, trgRatio;
	        info = {
	          srcX: 0,
	          srcY: 0,
	          srcWidth: file.width,
	          srcHeight: file.height
	        };
	        srcRatio = file.width / file.height;
	        info.optWidth = this.options.thumbnailWidth;
	        info.optHeight = this.options.thumbnailHeight;
	        if ((info.optWidth == null) && (info.optHeight == null)) {
	          info.optWidth = info.srcWidth;
	          info.optHeight = info.srcHeight;
	        } else if (info.optWidth == null) {
	          info.optWidth = srcRatio * info.optHeight;
	        } else if (info.optHeight == null) {
	          info.optHeight = (1 / srcRatio) * info.optWidth;
	        }
	        trgRatio = info.optWidth / info.optHeight;
	        if (file.height < info.optHeight || file.width < info.optWidth) {
	          info.trgHeight = info.srcHeight;
	          info.trgWidth = info.srcWidth;
	        } else {
	          if (srcRatio > trgRatio) {
	            info.srcHeight = file.height;
	            info.srcWidth = info.srcHeight * trgRatio;
	          } else {
	            info.srcWidth = file.width;
	            info.srcHeight = info.srcWidth / trgRatio;
	          }
	        }
	        info.srcX = (file.width - info.srcWidth) / 2;
	        info.srcY = (file.height - info.srcHeight) / 2;
	        return info;
	      },
	
	      /*
	      Those functions register themselves to the events on init and handle all
	      the user interface specific stuff. Overwriting them won't break the upload
	      but can break the way it's displayed.
	      You can overwrite them if you don't like the default behavior. If you just
	      want to add an additional event handler, register it on the dropzone object
	      and don't overwrite those options.
	       */
	      drop: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragstart: noop,
	      dragend: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragenter: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragover: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragleave: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      paste: noop,
	      reset: function() {
	        return this.element.classList.remove("dz-started");
	      },
	      addedfile: function(file) {
	        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
	        if (this.element === this.previewsContainer) {
	          this.element.classList.add("dz-started");
	        }
	        if (this.previewsContainer) {
	          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
	          file.previewTemplate = file.previewElement;
	          this.previewsContainer.appendChild(file.previewElement);
	          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            node.textContent = this._renameFilename(file.name);
	          }
	          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
	          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	            node = _ref1[_j];
	            node.innerHTML = this.filesize(file.size);
	          }
	          if (this.options.addRemoveLinks) {
	            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
	            file.previewElement.appendChild(file._removeLink);
	          }
	          removeFileEvent = (function(_this) {
	            return function(e) {
	              e.preventDefault();
	              e.stopPropagation();
	              if (file.status === Dropzone.UPLOADING) {
	                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
	                  return _this.removeFile(file);
	                });
	              } else {
	                if (_this.options.dictRemoveFileConfirmation) {
	                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
	                    return _this.removeFile(file);
	                  });
	                } else {
	                  return _this.removeFile(file);
	                }
	              }
	            };
	          })(this);
	          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
	          _results = [];
	          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	            removeLink = _ref2[_k];
	            _results.push(removeLink.addEventListener("click", removeFileEvent));
	          }
	          return _results;
	        }
	      },
	      removedfile: function(file) {
	        var _ref;
	        if (file.previewElement) {
	          if ((_ref = file.previewElement) != null) {
	            _ref.parentNode.removeChild(file.previewElement);
	          }
	        }
	        return this._updateMaxFilesReachedClass();
	      },
	      thumbnail: function(file, dataUrl) {
	        var thumbnailElement, _i, _len, _ref;
	        if (file.previewElement) {
	          file.previewElement.classList.remove("dz-file-preview");
	          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            thumbnailElement = _ref[_i];
	            thumbnailElement.alt = file.name;
	            thumbnailElement.src = dataUrl;
	          }
	          return setTimeout(((function(_this) {
	            return function() {
	              return file.previewElement.classList.add("dz-image-preview");
	            };
	          })(this)), 1);
	        }
	      },
	      error: function(file, message) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-error");
	          if (typeof message !== "String" && message.error) {
	            message = message.error;
	          }
	          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            _results.push(node.textContent = message);
	          }
	          return _results;
	        }
	      },
	      errormultiple: noop,
	      processing: function(file) {
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-processing");
	          if (file._removeLink) {
	            return file._removeLink.textContent = this.options.dictCancelUpload;
	          }
	        }
	      },
	      processingmultiple: noop,
	      uploadprogress: function(file, progress, bytesSent) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            if (node.nodeName === 'PROGRESS') {
	              _results.push(node.value = progress);
	            } else {
	              _results.push(node.style.width = "" + progress + "%");
	            }
	          }
	          return _results;
	        }
	      },
	      totaluploadprogress: noop,
	      sending: noop,
	      sendingmultiple: noop,
	      success: function(file) {
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-success");
	        }
	      },
	      successmultiple: noop,
	      canceled: function(file) {
	        return this.emit("error", file, "Upload canceled.");
	      },
	      canceledmultiple: noop,
	      complete: function(file) {
	        if (file._removeLink) {
	          file._removeLink.textContent = this.options.dictRemoveFile;
	        }
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-complete");
	        }
	      },
	      completemultiple: noop,
	      maxfilesexceeded: noop,
	      maxfilesreached: noop,
	      queuecomplete: noop,
	      addedfiles: noop,
	      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n <div class=\"dz-image\"><img data-dz-thumbnail class=\"upload-image clickable\"/></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
	    };
	
	    extend = function() {
	      var key, object, objects, target, val, _i, _len;
	      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      for (_i = 0, _len = objects.length; _i < _len; _i++) {
	        object = objects[_i];
	        for (key in object) {
	          val = object[key];
	          target[key] = val;
	        }
	      }
	      return target;
	    };
	
	    function Dropzone(element, options) {
	      var elementOptions, fallback, _ref;
	      this.element = element;
	      this.version = Dropzone.version;
	      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
	      this.clickableElements = [];
	      this.listeners = [];
	      this.files = [];
	      if (typeof this.element === "string") {
	        this.element = document.querySelector(this.element);
	      }
	      if (!(this.element && (this.element.nodeType != null))) {
	        throw new Error("Invalid dropzone element.");
	      }
	      if (this.element.dropzone) {
	        throw new Error("Dropzone already attached.");
	      }
	      Dropzone.instances.push(this);
	      this.element.dropzone = this;
	      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
	      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
	      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
	        return this.options.fallback.call(this);
	      }
	      if (this.options.url == null) {
	        this.options.url = this.element.getAttribute("action");
	      }
	      if (!this.options.url) {
	        throw new Error("No URL provided.");
	      }
	      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
	        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
	      }
	      if (this.options.acceptedMimeTypes) {
	        this.options.acceptedFiles = this.options.acceptedMimeTypes;
	        delete this.options.acceptedMimeTypes;
	      }
	      this.options.method = this.options.method.toUpperCase();
	      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
	        fallback.parentNode.removeChild(fallback);
	      }
	      if (this.options.previewsContainer !== false) {
	        if (this.options.previewsContainer) {
	          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
	        } else {
	          this.previewsContainer = this.element;
	        }
	      }
	      if (this.options.clickable) {
	        if (this.options.clickable === true) {
	          this.clickableElements = [this.element];
	        } else {
	          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
	        }
	      }
	      this.init();
	    }
	
	    Dropzone.prototype.getAcceptedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getRejectedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (!file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getFilesWithStatus = function(status) {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === status) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.getQueuedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.QUEUED);
	    };
	
	    Dropzone.prototype.getUploadingFiles = function() {
	      return this.getFilesWithStatus(Dropzone.UPLOADING);
	    };
	
	    Dropzone.prototype.getAddedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.ADDED);
	    };
	
	    Dropzone.prototype.getActiveFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.init = function() {
	      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
	      if (this.element.tagName === "form") {
	        this.element.setAttribute("enctype", "multipart/form-data");
	      }
	      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
	        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
	      }
	      if (this.clickableElements.length) {
	        setupHiddenFileInput = (function(_this) {
	          return function() {
	            if (_this.hiddenFileInput) {
	              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
	            }
	            _this.hiddenFileInput = document.createElement("input");
	            _this.hiddenFileInput.setAttribute("type", "file");
	            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
	              _this.hiddenFileInput.setAttribute("multiple", "multiple");
	            }
	            _this.hiddenFileInput.className = "dz-hidden-input";
	            if (_this.options.acceptedFiles != null) {
	              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
	            }
	            if (_this.options.capture != null) {
	              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
	            }
	            _this.hiddenFileInput.style.visibility = "hidden";
	            _this.hiddenFileInput.style.position = "absolute";
	            _this.hiddenFileInput.style.top = "0";
	            _this.hiddenFileInput.style.left = "0";
	            _this.hiddenFileInput.style.height = "0";
	            _this.hiddenFileInput.style.width = "0";
	            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
	            return _this.hiddenFileInput.addEventListener("change", function() {
	              var file, files, _i, _len;
	              files = _this.hiddenFileInput.files;
	              if (files.length) {
	                for (_i = 0, _len = files.length; _i < _len; _i++) {
	                  file = files[_i];
	                  _this.addFile(file);
	                }
	              }
	              _this.emit("addedfiles", files);
	              return setupHiddenFileInput();
	            });
	          };
	        })(this);
	        setupHiddenFileInput();
	      }
	      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
	      _ref1 = this.events;
	      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	        eventName = _ref1[_i];
	        this.on(eventName, this.options[eventName]);
	      }
	      this.on("uploadprogress", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("removedfile", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("canceled", (function(_this) {
	        return function(file) {
	          return _this.emit("complete", file);
	        };
	      })(this));
	      this.on("complete", (function(_this) {
	        return function(file) {
	          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
	            return setTimeout((function() {
	              return _this.emit("queuecomplete");
	            }), 0);
	          }
	        };
	      })(this));
	      noPropagation = function(e) {
	        e.stopPropagation();
	        if (e.preventDefault) {
	          return e.preventDefault();
	        } else {
	          return e.returnValue = false;
	        }
	      };
	      this.listeners = [
	        {
	          element: this.element,
	          events: {
	            "dragstart": (function(_this) {
	              return function(e) {
	                return _this.emit("dragstart", e);
	              };
	            })(this),
	            "dragenter": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.emit("dragenter", e);
	              };
	            })(this),
	            "dragover": (function(_this) {
	              return function(e) {
	                var efct;
	                try {
	                  efct = e.dataTransfer.effectAllowed;
	                } catch (_error) {}
	                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
	                noPropagation(e);
	                return _this.emit("dragover", e);
	              };
	            })(this),
	            "dragleave": (function(_this) {
	              return function(e) {
	                return _this.emit("dragleave", e);
	              };
	            })(this),
	            "drop": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.drop(e);
	              };
	            })(this),
	            "dragend": (function(_this) {
	              return function(e) {
	                return _this.emit("dragend", e);
	              };
	            })(this)
	          }
	        }
	      ];
	      this.clickableElements.forEach((function(_this) {
	        return function(clickableElement) {
	          return _this.listeners.push({
	            element: clickableElement,
	            events: {
	              "click": function(evt) {
	                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
	                  _this.hiddenFileInput.click();
	                }
	                return true;
	              }
	            }
	          });
	        };
	      })(this));
	      this.enable();
	      return this.options.init.call(this);
	    };
	
	    Dropzone.prototype.destroy = function() {
	      var _ref;
	      this.disable();
	      this.removeAllFiles(true);
	      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
	        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
	        this.hiddenFileInput = null;
	      }
	      delete this.element.dropzone;
	      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
	    };
	
	    Dropzone.prototype.updateTotalUploadProgress = function() {
	      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
	      totalBytesSent = 0;
	      totalBytes = 0;
	      activeFiles = this.getActiveFiles();
	      if (activeFiles.length) {
	        _ref = this.getActiveFiles();
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          totalBytesSent += file.upload.bytesSent;
	          totalBytes += file.upload.total;
	        }
	        totalUploadProgress = 100 * totalBytesSent / totalBytes;
	      } else {
	        totalUploadProgress = 100;
	      }
	      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
	    };
	
	    Dropzone.prototype._getParamName = function(n) {
	      if (typeof this.options.paramName === "function") {
	        return this.options.paramName(n);
	      } else {
	        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
	      }
	    };
	
	    Dropzone.prototype._renameFilename = function(name) {
	      if (typeof this.options.renameFilename !== "function") {
	        return name;
	      }
	      return this.options.renameFilename(name);
	    };
	
	    Dropzone.prototype.getFallbackForm = function() {
	      var existingFallback, fields, fieldsString, form;
	      if (existingFallback = this.getExistingFallback()) {
	        return existingFallback;
	      }
	      fieldsString = "<div class=\"dz-fallback\">";
	      if (this.options.dictFallbackText) {
	        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
	      }
	      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
	      fields = Dropzone.createElement(fieldsString);
	      if (this.element.tagName !== "FORM") {
	        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
	        form.appendChild(fields);
	      } else {
	        this.element.setAttribute("enctype", "multipart/form-data");
	        this.element.setAttribute("method", this.options.method);
	      }
	      return form != null ? form : fields;
	    };
	
	    Dropzone.prototype.getExistingFallback = function() {
	      var fallback, getFallback, tagName, _i, _len, _ref;
	      getFallback = function(elements) {
	        var el, _i, _len;
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )fallback($| )/.test(el.className)) {
	            return el;
	          }
	        }
	      };
	      _ref = ["div", "form"];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        tagName = _ref[_i];
	        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
	          return fallback;
	        }
	      }
	    };
	
	    Dropzone.prototype.setupEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.addEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.removeEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.disable = function() {
	      var file, _i, _len, _ref, _results;
	      this.clickableElements.forEach(function(element) {
	        return element.classList.remove("dz-clickable");
	      });
	      this.removeEventListeners();
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        _results.push(this.cancelUpload(file));
	      }
	      return _results;
	    };
	
	    Dropzone.prototype.enable = function() {
	      this.clickableElements.forEach(function(element) {
	        return element.classList.add("dz-clickable");
	      });
	      return this.setupEventListeners();
	    };
	
	    Dropzone.prototype.filesize = function(size) {
	      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
	      selectedSize = 0;
	      selectedUnit = "b";
	      if (size > 0) {
	        units = ['TB', 'GB', 'MB', 'KB', 'b'];
	        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
	          unit = units[i];
	          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
	          if (size >= cutoff) {
	            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
	            selectedUnit = unit;
	            break;
	          }
	        }
	        selectedSize = Math.round(10 * selectedSize) / 10;
	      }
	      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
	    };
	
	    Dropzone.prototype._updateMaxFilesReachedClass = function() {
	      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        if (this.getAcceptedFiles().length === this.options.maxFiles) {
	          this.emit('maxfilesreached', this.files);
	        }
	        return this.element.classList.add("dz-max-files-reached");
	      } else {
	        return this.element.classList.remove("dz-max-files-reached");
	      }
	    };
	
	    Dropzone.prototype.drop = function(e) {
	      var files, items;
	      if (!e.dataTransfer) {
	        return;
	      }
	      this.emit("drop", e);
	      files = e.dataTransfer.files;
	      this.emit("addedfiles", files);
	      if (files.length) {
	        items = e.dataTransfer.items;
	        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
	          this._addFilesFromItems(items);
	        } else {
	          this.handleFiles(files);
	        }
	      }
	    };
	
	    Dropzone.prototype.paste = function(e) {
	      var items, _ref;
	      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
	        return;
	      }
	      this.emit("paste", e);
	      items = e.clipboardData.items;
	      if (items.length) {
	        return this._addFilesFromItems(items);
	      }
	    };
	
	    Dropzone.prototype.handleFiles = function(files) {
	      var file, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        _results.push(this.addFile(file));
	      }
	      return _results;
	    };
	
	    Dropzone.prototype._addFilesFromItems = function(items) {
	      var entry, item, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = items.length; _i < _len; _i++) {
	        item = items[_i];
	        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
	          if (entry.isFile) {
	            _results.push(this.addFile(item.getAsFile()));
	          } else if (entry.isDirectory) {
	            _results.push(this._addFilesFromDirectory(entry, entry.name));
	          } else {
	            _results.push(void 0);
	          }
	        } else if (item.getAsFile != null) {
	          if ((item.kind == null) || item.kind === "file") {
	            _results.push(this.addFile(item.getAsFile()));
	          } else {
	            _results.push(void 0);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
	      var dirReader, errorHandler, readEntries;
	      dirReader = directory.createReader();
	      errorHandler = function(error) {
	        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
	      };
	      readEntries = (function(_this) {
	        return function() {
	          return dirReader.readEntries(function(entries) {
	            var entry, _i, _len;
	            if (entries.length > 0) {
	              for (_i = 0, _len = entries.length; _i < _len; _i++) {
	                entry = entries[_i];
	                if (entry.isFile) {
	                  entry.file(function(file) {
	                    if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
	                      return;
	                    }
	                    file.fullPath = "" + path + "/" + file.name;
	                    return _this.addFile(file);
	                  });
	                } else if (entry.isDirectory) {
	                  _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
	                }
	              }
	              readEntries();
	            }
	            return null;
	          }, errorHandler);
	        };
	      })(this);
	      return readEntries();
	    };
	
	    Dropzone.prototype.accept = function(file, done) {
	      if (file.size > this.options.maxFilesize * 1024 * 1024) {
	        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
	      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
	        return done(this.options.dictInvalidFileType);
	      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
	        return this.emit("maxfilesexceeded", file);
	      } else {
	        return this.options.accept.call(this, file, done);
	      }
	    };
	
	    Dropzone.prototype.addFile = function(file) {
	      file.upload = {
	        progress: 0,
	        total: file.size,
	        bytesSent: 0
	      };
	      this.files.push(file);
	      file.status = Dropzone.ADDED;
	      this.emit("addedfile", file);
	      this._enqueueThumbnail(file);
	      return this.accept(file, (function(_this) {
	        return function(error) {
	          if (error) {
	            file.accepted = false;
	            _this._errorProcessing([file], error);
	          } else {
	            file.accepted = true;
	            if (_this.options.autoQueue) {
	              _this.enqueueFile(file);
	            }
	          }
	          return _this._updateMaxFilesReachedClass();
	        };
	      })(this));
	    };
	
	    Dropzone.prototype.enqueueFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        this.enqueueFile(file);
	      }
	      return null;
	    };
	
	    Dropzone.prototype.enqueueFile = function(file) {
	      if (file.status === Dropzone.ADDED && file.accepted === true) {
	        file.status = Dropzone.QUEUED;
	        if (this.options.autoProcessQueue) {
	          return setTimeout(((function(_this) {
	            return function() {
	              return _this.processQueue();
	            };
	          })(this)), 0);
	        }
	      } else {
	        throw new Error("This file can't be queued because it has already been processed or was rejected.");
	      }
	    };
	
	    Dropzone.prototype._thumbnailQueue = [];
	
	    Dropzone.prototype._processingThumbnail = false;
	
	    Dropzone.prototype._enqueueThumbnail = function(file) {
	      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
	        this._thumbnailQueue.push(file);
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this._processThumbnailQueue();
	          };
	        })(this)), 0);
	      }
	    };
	
	    Dropzone.prototype._processThumbnailQueue = function() {
	      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
	        return;
	      }
	      this._processingThumbnail = true;
	      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
	        return function() {
	          _this._processingThumbnail = false;
	          return _this._processThumbnailQueue();
	        };
	      })(this));
	    };
	
	    Dropzone.prototype.removeFile = function(file) {
	      if (file.status === Dropzone.UPLOADING) {
	        this.cancelUpload(file);
	      }
	      this.files = without(this.files, file);
	      this.emit("removedfile", file);
	      if (this.files.length === 0) {
	        return this.emit("reset");
	      }
	    };
	
	    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
	      var file, _i, _len, _ref;
	      if (cancelIfNecessary == null) {
	        cancelIfNecessary = false;
	      }
	      _ref = this.files.slice();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
	          this.removeFile(file);
	        }
	      }
	      return null;
	    };
	
	    Dropzone.prototype.createThumbnail = function(file, callback) {
	      var fileReader;
	      fileReader = new FileReader;
	      fileReader.onload = (function(_this) {
	        return function() {
	          if (file.type === "image/svg+xml") {
	            _this.emit("thumbnail", file, fileReader.result);
	            if (callback != null) {
	              callback();
	            }
	            return;
	          }
	          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
	        };
	      })(this);
	      return fileReader.readAsDataURL(file);
	    };
	
	    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
	      var img;
	      img = document.createElement("img");
	      if (crossOrigin) {
	        img.crossOrigin = crossOrigin;
	      }
	      img.onload = (function(_this) {
	        return function() {
	          var orientation = 0; 
	          EXIF.getData(img, function() { 
	              switch(parseInt(EXIF.getTag(this, "Orientation"))){ 
	                  case 3: 
	                      orientation = 180; 
	                      break; 
	                  case 6: 
	                      orientation = -90; 
	                      break; 
	                  case 8: 
	                      orientation = 90; 
	                      break; 
	              } 
	          });
	          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
	          file.width = img.width;
	          file.height = img.height;
	          resizeInfo = _this.options.resize.call(_this, file);
	          if (resizeInfo.trgWidth == null) {
	            resizeInfo.trgWidth = resizeInfo.optWidth;
	          }
	          if (resizeInfo.trgHeight == null) {
	            resizeInfo.trgHeight = resizeInfo.optHeight;
	          }
	          canvas = document.createElement("canvas");
	          ctx = canvas.getContext("2d");
	          canvas.width = resizeInfo.trgWidth;
	          canvas.height = resizeInfo.trgHeight;
	          drawImageIOSFix(orientation,ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
	          thumbnail = canvas.toDataURL("image/png");
	          _this.emit("thumbnail", file, thumbnail);
	          if (callback != null) {
	            return callback();
	          }
	        };
	      })(this);
	      if (callback != null) {
	        img.onerror = callback;
	      }
	      return img.src = imageUrl;
	    };
	
	    Dropzone.prototype.processQueue = function() {
	      var i, parallelUploads, processingLength, queuedFiles;
	      parallelUploads = this.options.parallelUploads;
	      processingLength = this.getUploadingFiles().length;
	      i = processingLength;
	      if (processingLength >= parallelUploads) {
	        return;
	      }
	      queuedFiles = this.getQueuedFiles();
	      if (!(queuedFiles.length > 0)) {
	        return;
	      }
	      if (this.options.uploadMultiple) {
	        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
	      } else {
	        while (i < parallelUploads) {
	          if (!queuedFiles.length) {
	            return;
	          }
	          this.processFile(queuedFiles.shift());
	          i++;
	        }
	      }
	    };
	
	    Dropzone.prototype.processFile = function(file) {
	      return this.processFiles([file]);
	    };
	
	    Dropzone.prototype.processFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.processing = true;
	        file.status = Dropzone.UPLOADING;
	        this.emit("processing", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("processingmultiple", files);
	      }
	      return this.uploadFiles(files);
	    };
	
	    Dropzone.prototype._getFilesWithXhr = function(xhr) {
	      var file, files;
	      return files = (function() {
	        var _i, _len, _ref, _results;
	        _ref = this.files;
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          if (file.xhr === xhr) {
	            _results.push(file);
	          }
	        }
	        return _results;
	      }).call(this);
	    };
	
	    Dropzone.prototype.cancelUpload = function(file) {
	      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
	      if (file.status === Dropzone.UPLOADING) {
	        groupedFiles = this._getFilesWithXhr(file.xhr);
	        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
	          groupedFile = groupedFiles[_i];
	          groupedFile.status = Dropzone.CANCELED;
	        }
	        file.xhr.abort();
	        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
	          groupedFile = groupedFiles[_j];
	          this.emit("canceled", groupedFile);
	        }
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", groupedFiles);
	        }
	      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
	        file.status = Dropzone.CANCELED;
	        this.emit("canceled", file);
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", [file]);
	        }
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    resolveOption = function() {
	      var args, option;
	      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      if (typeof option === 'function') {
	        return option.apply(this, args);
	      }
	      return option;
	    };
	
	    Dropzone.prototype.uploadFile = function(file) {
	      return this.uploadFiles([file]);
	    };
	
	    Dropzone.prototype.uploadFiles = function(files) {
	      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
	      xhr = new XMLHttpRequest();
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.xhr = xhr;
	      }
	      method = resolveOption(this.options.method, files);
	      url = resolveOption(this.options.url, files);
	      xhr.open(method, url, true);
	      xhr.withCredentials = !!this.options.withCredentials;
	      response = null;
	      handleError = (function(_this) {
	        return function() {
	          var _j, _len1, _results;
	          _results = [];
	          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	            file = files[_j];
	            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
	          }
	          return _results;
	        };
	      })(this);
	      updateProgress = (function(_this) {
	        return function(e) {
	          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
	          if (e != null) {
	            progress = 100 * e.loaded / e.total;
	            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	              file = files[_j];
	              file.upload = {
	                progress: progress,
	                total: e.total,
	                bytesSent: e.loaded
	              };
	            }
	          } else {
	            allFilesFinished = true;
	            progress = 100;
	            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
	              file = files[_k];
	              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
	                allFilesFinished = false;
	              }
	              file.upload.progress = progress;
	              file.upload.bytesSent = file.upload.total;
	            }
	            if (allFilesFinished) {
	              return;
	            }
	          }
	          _results = [];
	          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
	            file = files[_l];
	            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
	          }
	          return _results;
	        };
	      })(this);
	      xhr.onload = (function(_this) {
	        return function(e) {
	          var _ref;
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          if (xhr.readyState !== 4) {
	            return;
	          }
	          response = xhr.responseText;
	          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
	            try {
	              response = JSON.parse(response);
	            } catch (_error) {
	              e = _error;
	              response = "Invalid JSON response from server.";
	            }
	          }
	          updateProgress();
	          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
	            return handleError();
	          } else {
	            return _this._finished(files, response, e);
	          }
	        };
	      })(this);
	      xhr.onerror = (function(_this) {
	        return function() {
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          return handleError();
	        };
	      })(this);
	      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
	      progressObj.onprogress = updateProgress;
	      headers = {
	        "Accept": "application/json",
	        "Cache-Control": "no-cache",
	        "X-Requested-With": "XMLHttpRequest"
	      };
	      if (this.options.headers) {
	        extend(headers, this.options.headers);
	      }
	      for (headerName in headers) {
	        headerValue = headers[headerName];
	        if (headerValue) {
	          xhr.setRequestHeader(headerName, headerValue);
	        }
	      }
	      formData = new FormData();
	      if (this.options.params) {
	        _ref1 = this.options.params;
	        for (key in _ref1) {
	          value = _ref1[key];
	          formData.append(key, value);
	        }
	      }
	      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	        file = files[_j];
	        this.emit("sending", file, xhr, formData);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("sendingmultiple", files, xhr, formData);
	      }
	      if (this.element.tagName === "FORM") {
	        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
	        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	          input = _ref2[_k];
	          inputName = input.getAttribute("name");
	          inputType = input.getAttribute("type");
	          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
	            _ref3 = input.options;
	            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
	              option = _ref3[_l];
	              if (option.selected) {
	                formData.append(inputName, option.value);
	              }
	            }
	          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
	            formData.append(inputName, input.value);
	          }
	        }
	      }
	      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
	        formData.append(this._getParamName(i), files[i], this._renameFilename(files[i].name));
	      }
	      return this.submitRequest(xhr, formData, files);
	    };
	
	    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
	      return xhr.send(formData);
	    };
	
	    Dropzone.prototype._finished = function(files, responseText, e) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.SUCCESS;
	        this.emit("success", file, responseText, e);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("successmultiple", files, responseText, e);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.ERROR;
	        this.emit("error", file, message, xhr);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("errormultiple", files, message, xhr);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };
	
	    return Dropzone;
	
	  })(Emitter);
	
	  Dropzone.version = "4.3.0";
	
	  Dropzone.options = {};
	
	  Dropzone.optionsForElement = function(element) {
	    if (element.getAttribute("id")) {
	      return Dropzone.options[camelize(element.getAttribute("id"))];
	    } else {
	      return void 0;
	    }
	  };
	
	  Dropzone.instances = [];
	
	  Dropzone.forElement = function(element) {
	    if (typeof element === "string") {
	      element = document.querySelector(element);
	    }
	    if ((element != null ? element.dropzone : void 0) == null) {
	      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
	    }
	    return element.dropzone;
	  };
	
	  Dropzone.autoDiscover = true;
	
	  Dropzone.discover = function() {
	    var checkElements, dropzone, dropzones, _i, _len, _results;
	    if (document.querySelectorAll) {
	      dropzones = document.querySelectorAll(".dropzone");
	    } else {
	      dropzones = [];
	      checkElements = function(elements) {
	        var el, _i, _len, _results;
	        _results = [];
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )dropzone($| )/.test(el.className)) {
	            _results.push(dropzones.push(el));
	          } else {
	            _results.push(void 0);
	          }
	        }
	        return _results;
	      };
	      checkElements(document.getElementsByTagName("div"));
	      checkElements(document.getElementsByTagName("form"));
	    }
	    _results = [];
	    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
	      dropzone = dropzones[_i];
	      if (Dropzone.optionsForElement(dropzone) !== false) {
	        _results.push(new Dropzone(dropzone));
	      } else {
	        _results.push(void 0);
	      }
	    }
	    return _results;
	  };
	
	  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];
	
	  Dropzone.isBrowserSupported = function() {
	    var capableBrowser, regex, _i, _len, _ref;
	    capableBrowser = true;
	    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
	      if (!("classList" in document.createElement("a"))) {
	        capableBrowser = false;
	      } else {
	        _ref = Dropzone.blacklistedBrowsers;
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          regex = _ref[_i];
	          if (regex.test(navigator.userAgent)) {
	            capableBrowser = false;
	            continue;
	          }
	        }
	      }
	    } else {
	      capableBrowser = false;
	    }
	    return capableBrowser;
	  };
	
	  without = function(list, rejectedItem) {
	    var item, _i, _len, _results;
	    _results = [];
	    for (_i = 0, _len = list.length; _i < _len; _i++) {
	      item = list[_i];
	      if (item !== rejectedItem) {
	        _results.push(item);
	      }
	    }
	    return _results;
	  };
	
	  camelize = function(str) {
	    return str.replace(/[\-_](\w)/g, function(match) {
	      return match.charAt(1).toUpperCase();
	    });
	  };
	
	  Dropzone.createElement = function(string) {
	    var div;
	    div = document.createElement("div");
	    div.innerHTML = string;
	    return div.childNodes[0];
	  };
	
	  Dropzone.elementInside = function(element, container) {
	    if (element === container) {
	      return true;
	    }
	    while (element = element.parentNode) {
	      if (element === container) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Dropzone.getElement = function(el, name) {
	    var element;
	    if (typeof el === "string") {
	      element = document.querySelector(el);
	    } else if (el.nodeType != null) {
	      element = el;
	    }
	    if (element == null) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
	    }
	    return element;
	  };
	
	  Dropzone.getElements = function(els, name) {
	    var e, el, elements, _i, _j, _len, _len1, _ref;
	    if (els instanceof Array) {
	      elements = [];
	      try {
	        for (_i = 0, _len = els.length; _i < _len; _i++) {
	          el = els[_i];
	          elements.push(this.getElement(el, name));
	        }
	      } catch (_error) {
	        e = _error;
	        elements = null;
	      }
	    } else if (typeof els === "string") {
	      elements = [];
	      _ref = document.querySelectorAll(els);
	      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
	        el = _ref[_j];
	        elements.push(el);
	      }
	    } else if (els.nodeType != null) {
	      elements = [els];
	    }
	    if (!((elements != null) && elements.length)) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
	    }
	    return elements;
	  };
	
	  Dropzone.confirm = function(question, accepted, rejected) {
	    if (window.confirm(question)) {
	      return accepted();
	    } else if (rejected != null) {
	      return rejected();
	    }
	  };
	
	  Dropzone.isValidFile = function(file, acceptedFiles) {
	    var baseMimeType, mimeType, validType, _i, _len;
	    if (!acceptedFiles) {
	      return true;
	    }
	    acceptedFiles = acceptedFiles.split(",");
	    mimeType = file.type;
	    baseMimeType = mimeType.replace(/\/.*$/, "");
	    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
	      validType = acceptedFiles[_i];
	      validType = validType.trim();
	      if (validType.charAt(0) === ".") {
	        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
	          return true;
	        }
	      } else if (/\/\*$/.test(validType)) {
	        if (baseMimeType === validType.replace(/\/.*$/, "")) {
	          return true;
	        }
	      } else {
	        if (mimeType === validType) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  if (typeof jQuery !== "undefined" && jQuery !== null) {
	    jQuery.fn.dropzone = function(options) {
	      return this.each(function() {
	        return new Dropzone(this, options);
	      });
	    };
	  }
	
	  if (typeof module !== "undefined" && module !== null) {
	    module.exports = Dropzone;
	  } else {
	    window.Dropzone = Dropzone;
	  }
	
	  Dropzone.ADDED = "added";
	
	  Dropzone.QUEUED = "queued";
	
	  Dropzone.ACCEPTED = Dropzone.QUEUED;
	
	  Dropzone.UPLOADING = "uploading";
	
	  Dropzone.PROCESSING = Dropzone.UPLOADING;
	
	  Dropzone.CANCELED = "canceled";
	
	  Dropzone.ERROR = "error";
	
	  Dropzone.SUCCESS = "success";
	
	
	  /*
	  
	  Bugfix for iOS 6 and 7
	  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	  based on the work of https://github.com/stomita/ios-imagefile-megapixel
	   */
	
	  detectVerticalSquash = function(img) {
	    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
	    iw = img.naturalWidth;
	    ih = img.naturalHeight;
	    canvas = document.createElement("canvas");
	    canvas.width = 1;
	    canvas.height = ih;
	    ctx = canvas.getContext("2d");
	    ctx.drawImage(img, 0, 0);
	    data = ctx.getImageData(0, 0, 1, ih).data;
	    sy = 0;
	    ey = ih;
	    py = ih;
	    while (py > sy) {
	      alpha = data[(py - 1) * 4 + 3];
	      if (alpha === 0) {
	        ey = py;
	      } else {
	        sy = py;
	      }
	      py = (ey + sy) >> 1;
	    }
	    ratio = py / ih;
	    if (ratio === 0) {
	      return 1;
	    } else {
	      return ratio;
	    }
	  };
	
	  drawImageIOSFix = function(o,ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
	    var vertSquashRatio;
	    vertSquashRatio = detectVerticalSquash(img);
	    dh = dh / vertSquashRatio; 
	    ctx.translate( dx+dw/2, dy+dh/2 ); 
	    ctx.rotate(-o*Math.PI/180); 
	    dx = -dw/2; 
	    dy = -dh/2;
	    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
	  };
	
	
	  /*
	   * contentloaded.js
	   *
	   * Author: Diego Perini (diego.perini at gmail.com)
	   * Summary: cross-browser wrapper for DOMContentLoaded
	   * Updated: 20101020
	   * License: MIT
	   * Version: 1.2
	   *
	   * URL:
	   * http://javascript.nwbox.com/ContentLoaded/
	   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
	   */
	
	  contentLoaded = function(win, fn) {
	    var add, doc, done, init, poll, pre, rem, root, top;
	    done = false;
	    top = true;
	    doc = win.document;
	    root = doc.documentElement;
	    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
	    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
	    pre = (doc.addEventListener ? "" : "on");
	    init = function(e) {
	      if (e.type === "readystatechange" && doc.readyState !== "complete") {
	        return;
	      }
	      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
	      if (!done && (done = true)) {
	        return fn.call(win, e.type || e);
	      }
	    };
	    poll = function() {
	      var e;
	      try {
	        root.doScroll("left");
	      } catch (_error) {
	        e = _error;
	        setTimeout(poll, 50);
	        return;
	      }
	      return init("poll");
	    };
	    if (doc.readyState !== "complete") {
	      if (doc.createEventObject && root.doScroll) {
	        try {
	          top = !win.frameElement;
	        } catch (_error) {}
	        if (top) {
	          poll();
	        }
	      }
	      doc[add](pre + "DOMContentLoaded", init, false);
	      doc[add](pre + "readystatechange", init, false);
	      return win[add](pre + "load", init, false);
	    }
	  };
	
	  Dropzone._autoDiscoverFunction = function() {
	    if (Dropzone.autoDiscover) {
	      return Dropzone.discover();
	    }
	  };
	
	  contentLoaded(window, Dropzone._autoDiscoverFunction);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(156)(module)))

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function(obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	
	        // version tags
	        0x9000 : "ExifVersion",             // EXIF version
	        0xA000 : "FlashpixVersion",         // Flashpix format version
	
	        // colorspace tags
	        0xA001 : "ColorSpace",              // Color space information tag
	
	        // image configuration
	        0xA002 : "PixelXDimension",         // Valid width of meaningful image
	        0xA003 : "PixelYDimension",         // Valid height of meaningful image
	        0x9101 : "ComponentsConfiguration", // Information about channels
	        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel
	
	        // user information
	        0x927C : "MakerNote",               // Any desired information written by the manufacturer
	        0x9286 : "UserComment",             // Comments by user
	
	        // related file
	        0xA004 : "RelatedSoundFile",        // Name of related sound file
	
	        // date and time
	        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized
	
	        // picture-taking conditions
	        0x829A : "ExposureTime",            // Exposure time (in seconds)
	        0x829D : "FNumber",                 // F number
	        0x8822 : "ExposureProgram",         // Exposure program
	        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
	        0x8827 : "ISOSpeedRatings",         // ISO speed rating
	        0x8828 : "OECF",                    // Optoelectric conversion factor
	        0x9201 : "ShutterSpeedValue",       // Shutter speed
	        0x9202 : "ApertureValue",           // Lens aperture
	        0x9203 : "BrightnessValue",         // Value of brightness
	        0x9204 : "ExposureBias",            // Exposure bias
	        0x9205 : "MaxApertureValue",        // Smallest F number of lens
	        0x9206 : "SubjectDistance",         // Distance to subject in meters
	        0x9207 : "MeteringMode",            // Metering mode
	        0x9208 : "LightSource",             // Kind of light source
	        0x9209 : "Flash",                   // Flash status
	        0x9214 : "SubjectArea",             // Location and area of main subject
	        0x920A : "FocalLength",             // Focal length of the lens in mm
	        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C : "SpatialFrequencyResponse",    //
	        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214 : "SubjectLocation",         // Location of subject in image
	        0xA215 : "ExposureIndex",           // Exposure index selected on camera
	        0xA217 : "SensingMethod",           // Image sensor type
	        0xA300 : "FileSource",              // Image source (3 == DSC)
	        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
	        0xA302 : "CFAPattern",              // Color filter array geometric pattern
	        0xA401 : "CustomRendered",          // Special processing
	        0xA402 : "ExposureMode",            // Exposure mode
	        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
	        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406 : "SceneCaptureType",        // Type of scene
	        0xA407 : "GainControl",             // Degree of overall image gain adjustment
	        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
	        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B : "DeviceSettingDescription",    //
	        0xA40C : "SubjectDistanceRange",    // Distance to subject
	
	        // other tags
	        0xA005 : "InteroperabilityIFDPointer",
	        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100 : "ImageWidth",
	        0x0101 : "ImageHeight",
	        0x8769 : "ExifIFDPointer",
	        0x8825 : "GPSInfoIFDPointer",
	        0xA005 : "InteroperabilityIFDPointer",
	        0x0102 : "BitsPerSample",
	        0x0103 : "Compression",
	        0x0106 : "PhotometricInterpretation",
	        0x0112 : "Orientation",
	        0x0115 : "SamplesPerPixel",
	        0x011C : "PlanarConfiguration",
	        0x0212 : "YCbCrSubSampling",
	        0x0213 : "YCbCrPositioning",
	        0x011A : "XResolution",
	        0x011B : "YResolution",
	        0x0128 : "ResolutionUnit",
	        0x0111 : "StripOffsets",
	        0x0116 : "RowsPerStrip",
	        0x0117 : "StripByteCounts",
	        0x0201 : "JPEGInterchangeFormat",
	        0x0202 : "JPEGInterchangeFormatLength",
	        0x012D : "TransferFunction",
	        0x013E : "WhitePoint",
	        0x013F : "PrimaryChromaticities",
	        0x0211 : "YCbCrCoefficients",
	        0x0214 : "ReferenceBlackWhite",
	        0x0132 : "DateTime",
	        0x010E : "ImageDescription",
	        0x010F : "Make",
	        0x0110 : "Model",
	        0x0131 : "Software",
	        0x013B : "Artist",
	        0x8298 : "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000 : "GPSVersionID",
	        0x0001 : "GPSLatitudeRef",
	        0x0002 : "GPSLatitude",
	        0x0003 : "GPSLongitudeRef",
	        0x0004 : "GPSLongitude",
	        0x0005 : "GPSAltitudeRef",
	        0x0006 : "GPSAltitude",
	        0x0007 : "GPSTimeStamp",
	        0x0008 : "GPSSatellites",
	        0x0009 : "GPSStatus",
	        0x000A : "GPSMeasureMode",
	        0x000B : "GPSDOP",
	        0x000C : "GPSSpeedRef",
	        0x000D : "GPSSpeed",
	        0x000E : "GPSTrackRef",
	        0x000F : "GPSTrack",
	        0x0010 : "GPSImgDirectionRef",
	        0x0011 : "GPSImgDirection",
	        0x0012 : "GPSMapDatum",
	        0x0013 : "GPSDestLatitudeRef",
	        0x0014 : "GPSDestLatitude",
	        0x0015 : "GPSDestLongitudeRef",
	        0x0016 : "GPSDestLongitude",
	        0x0017 : "GPSDestBearingRef",
	        0x0018 : "GPSDestBearing",
	        0x0019 : "GPSDestDistanceRef",
	        0x001A : "GPSDestDistance",
	        0x001B : "GPSProcessingMethod",
	        0x001C : "GPSAreaInformation",
	        0x001D : "GPSDateStamp",
	        0x001E : "GPSDifferential"
	    };
	
	     // EXIF 2.3 Spec
	    var IFD1Tags = EXIF.IFD1Tags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0111: "StripOffsets",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x011C: "PlanarConfiguration",
	        0x0128: "ResolutionUnit",
	        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
	        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
	        0x0211: "YCbCrCoefficients",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x0214: "ReferenceBlackWhite"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram : {
	            0 : "Not defined",
	            1 : "Manual",
	            2 : "Normal program",
	            3 : "Aperture priority",
	            4 : "Shutter priority",
	            5 : "Creative program",
	            6 : "Action program",
	            7 : "Portrait mode",
	            8 : "Landscape mode"
	        },
	        MeteringMode : {
	            0 : "Unknown",
	            1 : "Average",
	            2 : "CenterWeightedAverage",
	            3 : "Spot",
	            4 : "MultiSpot",
	            5 : "Pattern",
	            6 : "Partial",
	            255 : "Other"
	        },
	        LightSource : {
	            0 : "Unknown",
	            1 : "Daylight",
	            2 : "Fluorescent",
	            3 : "Tungsten (incandescent light)",
	            4 : "Flash",
	            9 : "Fine weather",
	            10 : "Cloudy weather",
	            11 : "Shade",
	            12 : "Daylight fluorescent (D 5700 - 7100K)",
	            13 : "Day white fluorescent (N 4600 - 5400K)",
	            14 : "Cool white fluorescent (W 3900 - 4500K)",
	            15 : "White fluorescent (WW 3200 - 3700K)",
	            17 : "Standard light A",
	            18 : "Standard light B",
	            19 : "Standard light C",
	            20 : "D55",
	            21 : "D65",
	            22 : "D75",
	            23 : "D50",
	            24 : "ISO studio tungsten",
	            255 : "Other"
	        },
	        Flash : {
	            0x0000 : "Flash did not fire",
	            0x0001 : "Flash fired",
	            0x0005 : "Strobe return light not detected",
	            0x0007 : "Strobe return light detected",
	            0x0009 : "Flash fired, compulsory flash mode",
	            0x000D : "Flash fired, compulsory flash mode, return light not detected",
	            0x000F : "Flash fired, compulsory flash mode, return light detected",
	            0x0010 : "Flash did not fire, compulsory flash mode",
	            0x0018 : "Flash did not fire, auto mode",
	            0x0019 : "Flash fired, auto mode",
	            0x001D : "Flash fired, auto mode, return light not detected",
	            0x001F : "Flash fired, auto mode, return light detected",
	            0x0020 : "No flash function",
	            0x0041 : "Flash fired, red-eye reduction mode",
	            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
	            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
	            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod : {
	            1 : "Not defined",
	            2 : "One-chip color area sensor",
	            3 : "Two-chip color area sensor",
	            4 : "Three-chip color area sensor",
	            5 : "Color sequential area sensor",
	            7 : "Trilinear sensor",
	            8 : "Color sequential linear sensor"
	        },
	        SceneCaptureType : {
	            0 : "Standard",
	            1 : "Landscape",
	            2 : "Portrait",
	            3 : "Night scene"
	        },
	        SceneType : {
	            1 : "Directly photographed"
	        },
	        CustomRendered : {
	            0 : "Normal process",
	            1 : "Custom process"
	        },
	        WhiteBalance : {
	            0 : "Auto white balance",
	            1 : "Manual white balance"
	        },
	        GainControl : {
	            0 : "None",
	            1 : "Low gain up",
	            2 : "High gain up",
	            3 : "Low gain down",
	            4 : "High gain down"
	        },
	        Contrast : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        Saturation : {
	            0 : "Normal",
	            1 : "Low saturation",
	            2 : "High saturation"
	        },
	        Sharpness : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        SubjectDistanceRange : {
	            0 : "Unknown",
	            1 : "Macro",
	            2 : "Close view",
	            3 : "Distant view"
	        },
	        FileSource : {
	            3 : "DSC"
	        },
	
	        Components : {
	            0 : "",
	            1 : "Y",
	            2 : "Cb",
	            3 : "Cr",
	            4 : "R",
	            5 : "G",
	            6 : "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!(img.exifdata);
	    }
	
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function(e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            var iptcdata = findIPTCinJPEG(binFile);
	            var xmpdata= findXMPinJPEG(binFile);
	            img.exifdata = data || {};
	            img.iptcdata = iptcdata || {};
	            img.xmpdata = xmpdata || {};
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	
	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader = new FileReader();
	                fileReader.onload = function(e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function() {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function(e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	
	                // offset += 2 + file.getShortAt(offset+2, true);
	
	            } else {
	                offset += 2 + dataView.getUint16(offset+2);
	            }
	
	        }
	
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	
	        var isFieldSegmentStart = function(dataView, offset){
	            return (
	                dataView.getUint8(offset) === 0x38 &&
	                dataView.getUint8(offset+1) === 0x42 &&
	                dataView.getUint8(offset+2) === 0x49 &&
	                dataView.getUint8(offset+3) === 0x4D &&
	                dataView.getUint8(offset+4) === 0x04 &&
	                dataView.getUint8(offset+5) === 0x04
	            );
	        };
	
	        while (offset < length) {
	
	            if ( isFieldSegmentStart(dataView, offset )){
	
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset+7);
	                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if(nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	
	            }
	
	
	            // Not the marker, continue searching
	            offset++;
	
	        }
	
	    }
	    var IptcFieldMap = {
	        0x78 : 'caption',
	        0x6E : 'credit',
	        0x19 : 'keywords',
	        0x37 : 'dateCreated',
	        0x50 : 'byline',
	        0x55 : 'bylineTitle',
	        0x7A : 'captionWriter',
	        0x69 : 'headline',
	        0x74 : 'copyright',
	        0x0F : 'category'
	    };
	    function readIPTCData(file, startOffset, sectionLength){
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while(segmentStartPos < startOffset+sectionLength) {
	            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
	                segmentType = dataView.getUint8(segmentStartPos+2);
	                if(segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos+3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
	                    // Check if we already stored a value with this name
	                    if(data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if(data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset, tag,
	            i;
	
	        for (i=0;i<entries;i++) {
	            entryOffset = dirStart + i*12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset+2, !bigEnd),
	            numValues = file.getUint32(entryOffset+4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;
	
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues-1);
	
	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset+4, !bigEnd);
	                    val = new Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
	                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
	                        vals[n] = new Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    /**
	    * Given an IFD (Image File Directory) start offset
	    * returns an offset to next IFD or 0 if it's the last IFD.
	    */
	    function getNextIFDOffset(dataView, dirStart, bigEnd){
	        //the first 2bytes means the number of directory entries contains in this IFD
	        var entries = dataView.getUint16(dirStart, !bigEnd);
	
	        // After last directory entry, there is a 4bytes of data,
	        // it means an offset to next IFD.
	        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
	
	        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
	    }
	
	    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
	        // get the IFD1 offset
	        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);
	
	        if (!IFD1OffsetPointer) {
	            // console.log('******** IFD1Offset is empty, image thumb not found ********');
	            return {};
	        }
	        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
	            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
	            return {};
	        }
	        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
	
	        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)
	
	        // EXIF 2.3 specification for JPEG format thumbnail
	
	        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
	        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
	        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
	        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
	        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
	
	        if (thumbTags['Compression']) {
	            // console.log('Thumbnail image found!');
	
	            switch (thumbTags['Compression']) {
	                case 6:
	                    // console.log('Thumbnail image format is JPEG');
	                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
	                    // extract the thumbnail
	                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
	                        var tLength = thumbTags.JpegIFByteCount;
	                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
	                            type: 'image/jpeg'
	                        });
	                    }
	                break;
	
	            case 1:
	                console.log("Thumbnail image format is TIFF, which is not implemented.");
	                break;
	            default:
	                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
	            }
	        }
	        else if (thumbTags['PhotometricInterpretation'] == 2) {
	            console.log("Thumbnail image format is RGB, which is not implemented.");
	        }
	        return thumbTags;
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start+length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;
	
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                            "." + gpsData[tag][1] +
	                            "." + gpsData[tag][2] +
	                            "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        // extract thumbnail
	        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
	
	        return tags;
	    }
	
	   function findXMPinJPEG(file) {
	
	        if (!('DOMParser' in self)) {
	            // console.warn('XML parsing not supported without DOMParser');
	            return;
	        }
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	           if (debug) console.log("Not a valid JPEG");
	           return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            dom = new DOMParser();
	
	        while (offset < (length-4)) {
	            if (getStringFromDB(dataView, offset, 4) == "http") {
	                var startOffset = offset - 1;
	                var sectionLength = dataView.getUint16(offset - 2) - 1;
	                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
	                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
	                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );
	
	                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
	                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
	                //Without these namespaces, XML is thought to be invalid by parsers
	                xmpString = xmpString.slice(0, indexOfXmp)
	                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
	                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
	                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
	                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
	                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
	                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
	                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
	                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
	                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
	                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
	                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
	                            + xmpString.slice(indexOfXmp)
	
	                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
	                return xml2Object(domDocument);
	            } else{
	             offset++;
	            }
	        }
	    }
	
	    function xml2Object(xml) {
	        try {
	            var obj = {};
	            if (xml.children.length > 0) {
	              for (var i = 0; i < xml.children.length; i++) {
	                var item = xml.children.item(i);
	                var attributes = item.attributes;
	                for(var idx in attributes) {
	                    var itemAtt = attributes[idx];
	                    var dataKey = itemAtt.nodeName;
	                    var dataValue = itemAtt.nodeValue;
	
	                    if(dataKey !== undefined) {
	                        obj[dataKey] = dataValue;
	                    }
	                }
	                var nodeName = item.nodeName;
	
	                if (typeof (obj[nodeName]) == "undefined") {
	                  obj[nodeName] = xml2json(item);
	                } else {
	                  if (typeof (obj[nodeName].push) == "undefined") {
	                    var old = obj[nodeName];
	
	                    obj[nodeName] = [];
	                    obj[nodeName].push(old);
	                  }
	                  obj[nodeName].push(xml2json(item));
	                }
	              }
	            } else {
	              obj = xml.textContent;
	            }
	            return obj;
	          } catch (e) {
	              console.log(e.message);
	          }
	    }
	
	    EXIF.getData = function(img, callback) {
	        if ((self.Image && img instanceof self.Image)
	            || (self.HTMLImageElement && img instanceof self.HTMLImageElement)
	            && !img.complete)
	            return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    }
	
	    EXIF.getTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    }
	    
	    EXIF.getIptcTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.iptcdata[tag];
	    }
	
	    EXIF.getAllTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	    
	    EXIF.getAllIptcTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.iptcdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	
	    EXIF.pretty = function(img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    }
	
	    EXIF.readFromBinaryFile = function(file) {
	        return findEXIFinJPEG(file);
	    }
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	/*!
	 * jQuery UI Touch Punch 0.2.3
	 *
	 * Copyright 2011–2014, Dave Furfero
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 *
	 * Depends:
	 *  jquery.ui.widget.js
	 *  jquery.ui.mouse.js
	 */
	!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	/**
	 * @license ng-bs-daterangepicker v0.0.1
	 * (c) 2013 Luis Farzati http://github.com/luisfarzati/ng-bs-daterangepicker
	 * License: MIT
	 */
	(function (angular) {
	'use strict';
	
	angular.module('ngBootstrap', []).
		directive('input',input)
		input.$inject=['$compile','$parse'];
		function input($compile, $parse) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function ($scope, $element, $attributes, ngModel) {
				if ($attributes.type !== 'daterange' || ngModel === null ) return;
				
				// Store the daterangepicker instance for cleanup
				var daterangepickerInstance = null;
				
		        $scope.customDate = function(evt) {
		        	evt = (evt) ? evt : event;
				    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
				    ((evt.which) ? evt.which : 0));
		        	if(charCode == 8) {
						ngModel.$setViewValue('');
						$element.val('');
		          	} else {
		        		evt.preventDefault();
		          	}
		        }
		        $scope.$on('clear-daterange',function(evt,data) {
					ngModel.$setViewValue('');
					$element.val(''); 
		        });
		         $scope.$on('initial-daterange',function(evt,data) {
		        	ngModel.$setViewValue({ startDate: moment(data.date.start_date), endDate: moment(data.date.end_date)});
		        });
				var options = {};
				options.format = $attributes.format || 'YYYY-MM-DD';
				options.separator = $attributes.separator || ' - ';
				options.minDate = $attributes.minDate && moment($attributes.minDate);
				options.maxDate = $attributes.maxDate && moment($attributes.maxDate);
				options.dateLimit = $attributes.limit && moment.duration.apply(this, $attributes.limit.split(' ').map(function (elem, index) { return index === 0 && parseInt(elem, 10) || elem; }) );
				options.ranges = $attributes.ranges && $parse($attributes.ranges)($scope);
				options.opens = $attributes.opens || 'right';
				function format(date) {
					return date.format(options.format);
				}
	
				function formatted(dates) {
					return [format(dates.startDate), format(dates.endDate)].join(options.separator);
				}
	
				ngModel.$formatters.unshift(function (modelValue) {
					if (!modelValue) return '';
					return modelValue;
				});
	
				ngModel.$parsers.unshift(function (viewValue) {
					return viewValue;
				});
	
				ngModel.$render = function () {
					if (!ngModel.$viewValue || !ngModel.$viewValue.startDate) return;
					$element.val(formatted(ngModel.$viewValue));
				};
				$element.on('apply.daterangepicker', function(ev, picker) {
					ngModel.$setViewValue({ startDate: moment(picker.startDate), endDate: moment(picker.endDate) });
				});
				$scope.$watch($attributes.ngModel, function (modelValue) {
					if (!modelValue || (!modelValue.startDate)) {
						//ngModel.$setViewValue({ startDate: moment().startOf('day'), endDate: moment().startOf('day') });
						return;
					}
					if ($element.data('daterangepicker')) {
						$element.data('daterangepicker').startDate = modelValue.startDate;
						$element.data('daterangepicker').endDate = modelValue.endDate;
						$element.data('daterangepicker').updateView();
						$element.data('daterangepicker').updateCalendars();
						$element.data('daterangepicker').updateInputText();
					}
				});
				
				// Initialize daterangepicker
				daterangepickerInstance = $element.daterangepicker(options, function(start, end) {
					if (!ngModel.$viewValue || !ngModel.$viewValue.startDate) return;
					$scope.$apply(function () {
						ngModel.$setViewValue({ startDate: start, endDate: end });
						ngModel.$render();
					});
				});
				
				// Cleanup function to remove daterangepicker instance and associated HTML
				function cleanup() {
					if (daterangepickerInstance && daterangepickerInstance.data('daterangepicker')) {
						daterangepickerInstance.data('daterangepicker').remove();
					}
					// Also remove any orphaned daterangepicker elements that might be in the DOM
					angular.element('.daterangepicker').remove();
				}
				
				// Cleanup when scope is destroyed
				$scope.$on('$destroy', cleanup);
				
				// Cleanup when element is removed
				$element.on('$destroy', cleanup);
			}
		};
	};
	
	})(angular);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(angular, factory) {
	    'use strict';
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = function(angular) {
	            return factory(angular);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        return factory(angular);
	    }
	}(window.angular || null, function(angular) {
	    'use strict';
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    /**
	     * @ngdoc module
	     * @name ngTable
	     * @description ngTable: Table + Angular JS
	     */
	    angular.module('ngTable', []);
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function () {
	    /**
	     * @ngdoc object
	     * @name ngTableDefaultParams
	     * @module ngTable
	     * @description Default Parameters for ngTable
	     */
	    angular.module('ngTable')
	        .value('ngTableDefaults', {
	            params: {},
	            settings: {}
	        });
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .factory('ngTableEventsChannel', ngTableEventsChannel);
	
	    ngTableEventsChannel.$inject = ['$rootScope'];
	
	    /**
	     * @ngdoc service
	     * @name ngTableEventsChannel
	     * @description strongly typed pub/sub for `NgTableParams`
	     *
	     * Supported events:
	     *
	     * * afterCreated - raised when a new instance of `NgTableParams` has finished being constructed
	     * * afterReloadData - raised when the `reload` event has finished loading new data
	     * * datasetChanged - raised when `settings` receives a new data array
	     * * pagesChanged - raised when a new pages array has been generated
	     */
	    function ngTableEventsChannel($rootScope){
	
	        var events = {};
	        events = addChangeEvent('afterCreated', events);
	        events = addChangeEvent('afterReloadData', events);
	        events = addChangeEvent('datasetChanged', events);
	        events = addChangeEvent('pagesChanged', events);
	        return events;
	
	        //////////
	
	        function addChangeEvent(eventName, target){
	            var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
	            var event = {};
	            event['on' + fnName] = createEventSubscriptionFn(eventName);
	            event['publish' + fnName] = createPublishEventFn(eventName);
	            return angular.extend(target, event);
	        }
	
	        function createEventSubscriptionFn(eventName){
	
	            return function subscription(handler/*[, eventSelector or $scope][, eventSelector]*/){
	                var eventSelector = angular.identity;
	                var scope = $rootScope;
	
	                if (arguments.length === 2){
	                    if (angular.isFunction(arguments[1].$new)) {
	                        scope = arguments[1];
	                    } else {
	                        eventSelector = arguments[1]
	                    }
	                } else if (arguments.length > 2){
	                    scope = arguments[1];
	                    eventSelector = arguments[2];
	                }
	
	                // shorthand for subscriber to only receive events from a specific publisher instance
	                if (angular.isObject(eventSelector)) {
	                    var requiredPublisher = eventSelector;
	                    eventSelector = function(publisher){
	                        return publisher === requiredPublisher;
	                    }
	                }
	
	                return scope.$on('ngTable:' + eventName, function(event, params/*, ...args*/){
	                    // don't send events published by the internal NgTableParams created by ngTableController
	                    if (params.isNullInstance) return;
	
	                    var eventArgs = rest(arguments, 2);
	                    var fnArgs = [params].concat(eventArgs);
	                    if (eventSelector.apply(this, fnArgs)){
	                        handler.apply(this, fnArgs);
	                    }
	                });
	            }
	        }
	
	        function createPublishEventFn(eventName){
	            return function publish(/*args*/){
	                var fnArgs = ['ngTable:' + eventName].concat(Array.prototype.slice.call(arguments));
	                $rootScope.$broadcast.apply($rootScope, fnArgs);
	            }
	        }
	
	        function rest(array, n) {
	            return Array.prototype.slice.call(array, n == null ? 1 : n);
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .provider('ngTableFilterConfig', ngTableFilterConfigProvider);
	
	    ngTableFilterConfigProvider.$inject = [];
	
	    function ngTableFilterConfigProvider(){
	        var config;
	        var defaultConfig = {
	            defaultBaseUrl: 'ng-table/filters/',
	            defaultExt: '.html',
	            aliasUrls: {}
	        };
	
	        this.$get = ngTableFilterConfig;
	        this.resetConfigs = resetConfigs;
	        this.setConfig = setConfig;
	
	        init();
	
	        /////////
	
	        function init(){
	            resetConfigs();
	        }
	
	        function resetConfigs(){
	            config = defaultConfig;
	        }
	
	        function setConfig(customConfig){
	            var mergeConfig = angular.extend({}, config, customConfig);
	            mergeConfig.aliasUrls = angular.extend({}, config.aliasUrls, customConfig.aliasUrls);
	            config = mergeConfig;
	        }
	
	        /////////
	
	        ngTableFilterConfig.$inject = [];
	
	        function ngTableFilterConfig(){
	
	            var publicConfig;
	
	            var service = {
	                config: publicConfig,
	                getTemplateUrl: getTemplateUrl,
	                getUrlForAlias: getUrlForAlias
	            };
	            Object.defineProperty(service, "config", {
	                get: function(){
	                    return publicConfig = publicConfig || angular.copy(config);
	                },
	                enumerable: true
	            });
	
	            return service;
	
	            /////////
	
	            function getTemplateUrl(filterDef, filterKey){
	                if (angular.isObject(filterDef)){
	                    filterDef = filterDef.id;
	                }
	                if (filterDef.indexOf('/') !== -1){
	                    return filterDef;
	                }
	
	                return service.getUrlForAlias(filterDef, filterKey);
	            }
	
	            function getUrlForAlias(aliasName/*, filterKey*/){
	                return config.aliasUrls[aliasName] || config.defaultBaseUrl + aliasName + config.defaultExt;
	            }
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	
	    angular.module('ngTable')
	        .provider('ngTableDefaultGetData', ngTableDefaultGetDataProvider);
	
	    ngTableDefaultGetDataProvider.$inject = [];
	
	    /**
	     * @ngdoc provider
	     * @name ngTableDefaultGetDataProvider
	     * @description Allows for the configuration of the ngTableDefaultGetData service.
	     *
	     * Set filterFilterName to the name of a angular filter that knows how to apply the values returned by
	     * `NgTableParams.filter()` to restrict an array of data.
	     *
	     * Set sortingFilterName to the name of a angular filter that knows how to apply the values returned by
	     * `NgTableParams.orderBy()` to sort an array of data.
	     *
	     * Out of the box the `ngTableDefaultGetData` service will be configured to use the angular `filter` and `orderBy`
	     * filters respectively
	     */
	    function ngTableDefaultGetDataProvider(){
	        var provider = this;
	        provider.$get = ngTableDefaultGetData;
	        provider.filterFilterName = 'filter';
	        provider.sortingFilterName = 'orderBy';
	
	        ///////////
	
	        ngTableDefaultGetData.$inject = ['$filter'];
	
	        /**
	         * @ngdoc service
	         * @name ngTableDefaultGetData
	         * @description A default implementation of the getData function that will apply the `filter`, `orderBy` and
	         * paging values from the `NgTableParams` instance supplied to the data array supplied.
	         *
	         * The outcome will be to return the resulting array and to assign the total item count after filtering
	         * to the `total` of the `NgTableParams` instance supplied
	         */
	        function ngTableDefaultGetData($filter) {
	
	            var defaultDataOptions = {applyFilter: true, applySort: true, applyPaging: true};
	
	            getData.applyPaging = applyPaging;
	            getData.getFilterFn = getFilterFn;
	            getData.getOrderByFn = getOrderByFn;
	
	            return getData;
	
	            function getFilterFn(params) {
	                var filterOptions = params.settings().filterOptions;
	                if (angular.isFunction(filterOptions.filterFn)){
	                    return filterOptions.filterFn;
	                } else {
	                    return $filter(filterOptions.filterFilterName || provider.filterFilterName);
	                }
	            }
	
	            function getOrderByFn (/*params*/){
	                return $filter(provider.sortingFilterName);
	            }
	
	            function applyFilter(data, params) {
	                if (!params.hasFilter()) {
	                    return data;
	                }
	
	                var filter = params.filter(true);
	                var filterKeys = Object.keys(filter);
	                var parsedFilter = filterKeys.reduce(function(result, key){
	                    result = setPath(result, filter[key], key);
	                    return result;
	                }, {});
	                var filterFn = getFilterFn(params);
	                return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
	            }
	
	            function applyPaging(data, params) {
	                var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                params.total(data.length); // set total for recalc pagination
	                return pagedData;
	            }
	
	            function applySort(data, params) {
	                var orderBy = params.orderBy();
	                var orderByFn = getOrderByFn(params);
	                return orderBy.length ? orderByFn(data, orderBy) : data;
	            }
	
	            function getData(data, params) {
	                if (data == null){
	                    return [];
	                }
	
	                var options = angular.extend({}, defaultDataOptions, params.settings().dataOptions);
	
	                var fData = options.applyFilter ? applyFilter(data, params) : data;
	                var orderedData = options.applySort ? applySort(fData, params) : fData;
	                return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
	            }
	
	            // Sets the value at any depth in a nested object based on the path
	            // note: adapted from: underscore-contrib#setPath
	            function setPath(obj, value, path) {
	                var keys     = path.split('.');
	                var ret      = obj;
	                var lastKey  = keys[keys.length -1];
	                var target   = ret;
	
	                var parentPathKeys = keys.slice(0, keys.length -1);
	                parentPathKeys.forEach(function(key) {
	                    if (!target.hasOwnProperty(key)) {
	                        target[key] = {};
	                    }
	                    target = target[key];
	                });
	
	                target[lastKey] = value;
	                return ret;
	            }
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function () {
	    /**
	     * @ngdoc service
	     * @name ngTableColumn
	     * @module ngTable
	     * @description
	     * Service to construct a $column definition used by {@link ngTable ngTable} directive
	     */
	    angular.module('ngTable').factory('ngTableColumn', [function () {
	
	        return {
	            buildColumn: buildColumn
	        };
	
	        //////////////
	
	        /**
	         * @ngdoc method
	         * @name ngTableColumn#buildColumn
	         * @description Creates a $column for use within a header template
	         *
	         * @param {Object} column an existing $column or simple column data object
	         * @param {Scope} defaultScope the $scope to supply to the $column getter methods when not supplied by caller
	         * @param {Array} columns a reference to the columns array to make available on the context supplied to the
	         * $column getter methods
	         * @returns {Object} a $column object
	         */
	        function buildColumn(column, defaultScope, columns){
	            // note: we're not modifying the original column object. This helps to avoid unintended side affects
	            var extendedCol = Object.create(column);
	            var defaults = createDefaults();
	            for (var prop in defaults) {
	                if (extendedCol[prop] === undefined) {
	                    extendedCol[prop] = defaults[prop];
	                }
	                if(!angular.isFunction(extendedCol[prop])){
	                    // wrap raw field values with "getter" functions
	                    // - this is to ensure consistency with how ngTable.compile builds columns
	                    // - note that the original column object is being "proxied"; this is important
	                    //   as it ensure that any changes to the original object will be returned by the "getter"
	                    (function(prop1){
	                        var getterSetter = function getterSetter(/*[value] || [$scope, locals]*/) {
	                            if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                getterSetter.assign(null, arguments[0]);
	                            } else {
	                                return column[prop1];
	                            }
	                        };
	                        getterSetter.assign = function($scope, value){
	                            column[prop1] = value;
	                        };
	                        extendedCol[prop1] = getterSetter;
	                    })(prop);
	                }
	                (function(prop1){
	                    // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
	                    var getterFn = extendedCol[prop1];
	                    extendedCol[prop1] = function () {
	                        if (arguments.length === 1 && !isScopeLike(arguments[0])){
	                            getterFn.assign(null, arguments[0]);
	                        } else {
	                            var scope = arguments[0] || defaultScope;
	                            var context = Object.create(scope);
	                            angular.extend(context, {
	                                $column: extendedCol,
	                                $columns: columns
	                            });
	                            return getterFn.call(column, context);
	                        }
	                    };
	                    if (getterFn.assign){
	                        extendedCol[prop1].assign = getterFn.assign;
	                    }
	                })(prop);
	            }
	            return extendedCol;
	        }
	
	        function createDefaults(){
	            return {
	                'class': createGetterSetter(''),
	                filter: createGetterSetter(false),
	                groupable: createGetterSetter(false),
	                filterData: angular.noop,
	                headerTemplateURL: createGetterSetter(false),
	                headerTitle: createGetterSetter(''),
	                sortable: createGetterSetter(false),
	                show: createGetterSetter(true),
	                title: createGetterSetter(''),
	                titleAlt: createGetterSetter('')
	            };
	        }
	
	        function createGetterSetter(initialValue){
	            var value = initialValue;
	            var getterSetter = function getterSetter(/*[value] || [$scope, locals]*/){
	                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                    getterSetter.assign(null, arguments[0]);
	                } else {
	                    return value;
	                }
	            };
	            getterSetter.assign = function($scope, newValue){
	                value = newValue;
	            };
	            return getterSetter;
	        }
	
	        function isScopeLike(object){
	            return object != null && angular.isFunction(object.$new);
	        }
	    }]);
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    /**
	     * @ngdoc service
	     * @name NgTableParams
	     * @module ngTable
	     * @description Parameters manager for ngTable
	     */
	
	    angular.module('ngTable').factory('NgTableParams', ['$q', '$log', '$filter', 'ngTableDefaults', 'ngTableDefaultGetData', 'ngTableEventsChannel','$rootScope', function($q, $log, $filter, ngTableDefaults, ngTableDefaultGetData, ngTableEventsChannel, $rootScope) {
	        var isNumber = function(n) {
	            return !isNaN(parseFloat(n)) && isFinite(n);
	        };
	        var NgTableParams = function(baseParameters, baseSettings) {
	
	            // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
	            // is one of these
	            if (typeof baseParameters === "boolean"){
	                this.isNullInstance = true;
	            }
	
	            var self = this,
	                prevParamsMemento,
	                errParamsMemento,
	                isCommittedDataset = false,
	                initialEvents = [],
	                log = function() {
	                    if (settings.debugMode && $log.debug) {
	                        $log.debug.apply($log, arguments);
	                    }
	                },
	                defaultFilterOptions = {
	                    filterComparator: undefined, // look for a substring match in case insensitive way
	                    filterDelay: 500,
	                    filterDelayThreshold: 10000, // size of dataset array that will trigger the filterDelay being applied
	                    filterFilterName: undefined, // when defined overrides ngTableDefaultGetDataProvider.filterFilterName
	                    filterFn: undefined, // when defined overrides the filter function that ngTableDefaultGetData uses
	                    filterLayout: 'stack' // alternative: 'horizontal'
	                },
	                defaultGroupOptions = {
	                    defaultSort: 'asc', // set to 'asc' or 'desc' to apply sorting to groups
	                    isExpanded: true
	                },
	                defaultSettingsFns = getDefaultSettingFns();
	
	            this.data = [];
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#parameters
	             * @description Set new parameters or get current parameters
	             *
	             * @param {string} newParameters      New parameters
	             * @param {string} parseParamsFromUrl Flag if parse parameters like in url
	             * @returns {Object} Current parameters or `this`
	             */
	            this.parameters = function(newParameters, parseParamsFromUrl) {
	                parseParamsFromUrl = parseParamsFromUrl || false;
	                if (angular.isDefined(newParameters)) {
	                    for (var key in newParameters) {
	                        var value = newParameters[key];
	                        if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                            var keys = key.split(/\[(.*)\]/).reverse()
	                            var lastKey = '';
	                            for (var i = 0, len = keys.length; i < len; i++) {
	                                var name = keys[i];
	                                if (name !== '') {
	                                    var v = value;
	                                    value = {};
	                                    value[lastKey = name] = (isNumber(v) ? parseFloat(v) : v);
	                                }
	                            }
	                            if (lastKey === 'sorting') {
	                                params[lastKey] = {};
	                            }
	                            params[lastKey] = angular.extend(params[lastKey] || {}, value[lastKey]);
	                        } else {
	                            if (key === 'group'){
	                                params[key] = parseGroup(newParameters[key]);
	                            } else {
	                                params[key] = (isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key]);
	                            }
	                        }
	                    }
	                    log('ngTable: set parameters', params);
	                    return this;
	                }
	                return params;
	            };
	
	            function parseGroup(group){
	                var defaultSort = settings.groupOptions && settings.groupOptions.defaultSort;
	                if (angular.isFunction(group)) {
	                    if (group.sortDirection == null){
	                        group.sortDirection = defaultSort;
	                    }
	                    return group;
	                } else if (angular.isString(group)) {
	                    var grp = {};
	                    grp[group] = defaultSort;
	                    return grp;
	                } else if (angular.isObject(group)) {
	                    for (var key in group) {
	                        if (group[key] == null){
	                            group[key] = defaultSort;
	                        }
	                    }
	                    return group;
	                } else {
	                    return group;
	                }
	            }
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#settings
	             * @description Set new settings for table
	             *
	             * @param {string} newSettings New settings or undefined
	             * @returns {Object} Current settings or `this`
	             */
	            this.settings = function(newSettings) {
	                if (angular.isDefined(newSettings)) {
	
	                    // todo: don't modify newSettings object: this introduces unexpected side effects;
	                    // instead take a copy of newSettings
	
	                    if (newSettings.filterOptions){
	                        newSettings.filterOptions = angular.extend({}, settings.filterOptions, newSettings.filterOptions);
	                    }
	                    if (newSettings.groupOptions){
	                        newSettings.groupOptions = angular.extend({}, settings.groupOptions, newSettings.groupOptions);
	                    }
	
	                    if (angular.isArray(newSettings.dataset)) {
	                        //auto-set the total from passed in dataset
	                        newSettings.total = newSettings.dataset.length;
	                    }
	
	                    var originalDataset = settings.dataset;
	                    settings = angular.extend(settings, newSettings);
	
	                    if (angular.isArray(newSettings.dataset)) {
	                        optimizeFilterDelay();
	                    }
	
	                    // note: using != as want null and undefined to be treated the same
	                    var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && (newSettings.dataset != originalDataset);
	                    if (hasDatasetChanged) {
	                        if (isCommittedDataset){
	                            this.page(1); // reset page as a new dataset has been supplied
	                        }
	                        isCommittedDataset = false;
	
	                        var fireEvent = function () {
	                            ngTableEventsChannel.publishDatasetChanged(self, newSettings.dataset, originalDataset);
	                        };
	
	                        if (initialEvents){
	                            initialEvents.push(fireEvent);
	                        } else {
	                            fireEvent();
	                        }
	                    }
	                    log('ngTable: set settings', settings);
	                    return this;
	                }
	                return settings;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#page
	             * @description If parameter page not set return current page else set current page
	             *
	             * @param {string} page Page number
	             * @returns {Object|Number} Current page or `this`
	             */
	            this.page = function(page) {
	                return angular.isDefined(page) ? this.parameters({
	                    'page': page
	                }) : params.page;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#total
	             * @description If parameter total not set return current quantity else set quantity
	             *
	             * @param {string} total Total quantity of items
	             * @returns {Object|Number} Current page or `this`
	             */
	            this.total = function(total) {
	                return angular.isDefined(total) ? this.settings({
	                    'total': total
	                }) : settings.total;
	            };
	
	            this.numPages = function(numPages) {
	                return angular.isDefined(numPages) ? this.settings({
	                    'numPages': numPages
	                }) : settings.numPages;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#count
	             * @description If parameter count not set return current count per page else set count per page
	             *
	             * @param {string} count Count per number
	             * @returns {Object|Number} Count per page or `this`
	             */
	            this.count = function(count) {
	                // reset to first page because can be blank page
	                return angular.isDefined(count) ? this.parameters({
	                    'count': count,
	                    'page': 1
	                }) : params.count;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#filter
	             * @description If 'filter' parameter not set return current filter else set current filter
	             *
	             * Note: when assigning a new filter, {@link NgTableParams#page page} will be set to 1
	             *
	             * @param {Object|Boolean} filter 'object': new filter to assign or
	             * 'true': to return the current filter minus any insignificant values (null,  undefined and empty string); or
	             * 'falsey': to return the current filter "as is"
	             * @returns {Object} Current filter or `this`
	             */
	            this.filter = function(filter) {
	                if (angular.isDefined(filter) && angular.isObject(filter)) {
	                    return this.parameters({
	                        'filter': filter,
	                        'page': 1
	                    });
	                } else if (filter === true){
	                    var keys = Object.keys(params.filter);
	                    var significantFilter = {};
	                    for (var i=0; i < keys.length; i++){
	                        var filterValue = params.filter[keys[i]];
	                        if (filterValue != null && filterValue !== '') {
	                            significantFilter[keys[i]] = filterValue;
	                        }
	                    }
	                    return significantFilter;
	                } else {
	                    return params.filter;
	                }
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#group
	             * @description If 'group' parameter is not set, return current grouping. Otherwise set current group.
	             *
	             * @param {string|Function|Object} group New group field
	             * @param {string} sortDirection Optional direction that the list of groups should be sorted
	             * @returns {Object} Current grouping or `this`
	             */
	            this.group = function(group, sortDirection) {
	                if (!angular.isDefined(group)){
	                    return params.group;
	                }
	
	                var newParameters = {
	                    page: 1
	                };
	                if (angular.isFunction(group) && angular.isDefined(sortDirection)){
	                    group.sortDirection = sortDirection;
	                    newParameters.group = group;
	                } else if (angular.isDefined(group) && angular.isDefined(sortDirection)) {
	                    var groupArray = {};
	                    groupArray[group] = sortDirection;
	                    newParameters.group = groupArray;
	                } else {
	                    newParameters.group = group;
	                }
	                this.parameters(newParameters);
	                return this;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#sorting
	             * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
	             *
	             * @param {string} sorting New sorting
	             * @returns {Object} Current sorting or `this`
	             */
	            this.sorting = function(sorting) {
	                if (arguments.length == 2) {
	                    var sortArray = {};
	                    sortArray[sorting] = arguments[1];
	                    this.parameters({
	                        'sorting': sortArray
	                    });
	                    return this;
	                }
	                return angular.isDefined(sorting) ? this.parameters({
	                    'sorting': sorting
	                }) : params.sorting;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#isSortBy
	             * @description Checks sort field
	             *
	             * @param {string} field     Field name
	             * @param {string} direction Optional direction of sorting ('asc' or 'desc')
	             * @returns {Array} Return true if field sorted by direction
	             */
	            this.isSortBy = function(field, direction) {
	
	                if(direction !== undefined) {
	                    return angular.isDefined(params.sorting[field]) && params.sorting[field] == direction;
	                } else {
	                    return angular.isDefined(params.sorting[field]);
	                }
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#orderBy
	             * @description Return object of sorting parameters for angular filter
	             *
	             * @returns {Array} Array like: [ '-name', '+age' ]
	             */
	            this.orderBy = function() {
	                return convertSortToOrderBy(params.sorting);
	            };
	
	            function convertSortToOrderBy(sorting){
	                var result = [];
	                for (var column in sorting) {
	                    result.push((sorting[column] === "asc" ? "+" : "-") + column);
	                }
	                return result;
	            }
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#generatePagesArray
	             * @description Generate array of pages
	             *
	             * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
	             *
	             * @param {boolean} currentPage which page must be active
	             * @param {boolean} totalItems  Total quantity of items
	             * @param {boolean} pageSize    Quantity of items on page
	             * @param {number} maxBlocks    Quantity of blocks for pagination
	             * @returns {Array} Array of pages
	             */
	            this.generatePagesArray = function(currentPage, totalItems, pageSize, maxBlocks, numPages) {
	                if (!arguments.length){
	                    currentPage = this.page();
	                    totalItems = this.total();
	                    pageSize = this.count();
	                    numPages = this.numPages();
	                }
	
	                var maxPage, maxPivotPages, minPage, numPages, pages;
	                maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;
	
	                pages = [];
	
	
	                if(!numPages) {
	                    numPages = Math.ceil(totalItems / pageSize);
	                }
	
	                if (numPages > 1) {
	                    pages.push({
	                        type: 'prev',
	                        number: Math.max(1, currentPage - 1),
	                        active: currentPage > 1
	                    });
	                    pages.push({
	                        type: 'first',
	                        number: 1,
	                        active: currentPage > 1,
	                        current: currentPage === 1
	                    });
	                    maxPivotPages = Math.round((settings.paginationMaxBlocks - settings.paginationMinBlocks) / 2);
	                    minPage = Math.max(2, currentPage - maxPivotPages);
	                    maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
	                    minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
	                    var i = minPage;
	                    while (i <= maxPage) {
	                        if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
	                            pages.push({
	                                type: 'more',
	                                active: false
	                            });
	                        } else {
	                            pages.push({
	                                type: 'page',
	                                number: i,
	                                active: currentPage !== i,
	                                current: currentPage === i
	                            });
	                        }
	                        i++;
	                    }
	                    pages.push({
	                        type: 'last',
	                        number: numPages,
	                        active: currentPage !== numPages,
	                        current: currentPage === numPages
	                    });
	                    pages.push({
	                        type: 'next',
	                        number: Math.min(numPages, currentPage + 1),
	                        active: currentPage < numPages
	                    });
	                }
	                return pages;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#isDataReloadRequired
	             * @description Return true when a change to this `NgTableParams` instance should require the reload method
	             * to be run so as to ensure the data presented to the user reflects the `NgTableParams`
	             *
	             * Note that this method will return false when the reload method has run but fails. In this case
	             * `hasErrorState` will return true.
	             */
	            this.isDataReloadRequired = function(){
	                // note: using != as want to treat null and undefined the same
	                return !isCommittedDataset || !angular.equals(createComparableParams(), prevParamsMemento)
	                    || hasGlobalSearchFieldChanges();
	            };
	
	            function createComparableParams(){
	                var result = {params: params};
	                if (angular.isFunction(params.group)){
	                    result.groupSortDirection = params.group.sortDirection;
	                }
	                return result
	            }
	            /**
	             * @ngdoc method
	             * @name NgTableParams#hasFilter
	             * @description Determines if NgTableParams#filter has significant filter value(s)
	             * (any value except null, undefined, or empty string)
	             * @returns {Boolean} true when NgTableParams#filter has at least one significant field value
	             */
	            this.hasFilter = function(){
	                return Object.keys(this.filter(true)).length > 0;
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#hasGroup
	             * @description Determines if at least one group has been set
	             * @returns {Boolean}
	             */
	            this.hasGroup = function(group, sortDirection){
	                if (group == null) {
	                    return angular.isFunction(params.group) || Object.keys(params.group).length > 0
	                }
	
	                if (angular.isFunction(group)) {
	                    if (sortDirection == null) {
	                        return params.group === group;
	                    } else {
	                        return params.group === group && group.sortDirection === sortDirection;
	                    }
	                } else {
	                    if (sortDirection == null) {
	                        return Object.keys(params.group).indexOf(group) !== -1;
	                    } else {
	                        return params.group[group] === sortDirection;
	                    }
	                }
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#hasFilterChanges
	             * @description Return true when a change to `NgTableParams.filters`require the reload method
	             * to be run so as to ensure the data presented to the user reflects these filters
	             */
	            this.hasFilterChanges = function(){
	                var previousFilter = (prevParamsMemento && prevParamsMemento.params.filter);
	                return !angular.equals((params.filter), previousFilter) || hasGlobalSearchFieldChanges();
	            };
	
	            function hasGlobalSearchFieldChanges(){
	                var currentVal = (params.filter && params.filter.$);
	                var previousVal =
	                    (prevParamsMemento && prevParamsMemento.params.filter && prevParamsMemento.params.filter.$);
	                return !angular.equals(currentVal, previousVal);
	            }
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#url
	             * @description Return groups for table grouping
	             *
	             * @param {boolean} asString flag indicates return array of string or object
	             * @returns {Array} If asString = true will be return array of url string parameters else key-value object
	             */
	            this.url = function(asString) {
	                asString = asString || false;
	                var pairs = (asString ? [] : {});
	                for (var key in params) {
	                    if (params.hasOwnProperty(key)) {
	                        var item = params[key],
	                            name = encodeURIComponent(key);
	                        if (typeof item === "object") {
	                            for (var subkey in item) {
	                                if (isSignificantValue(item[subkey], key)) {
	                                    var pname = name + "[" + encodeURIComponent(subkey) + "]";
	                                    collectValue(item[subkey], pname);
	                                }
	                            }
	                        } else if (!angular.isFunction(item) && isSignificantValue(item, key)) {
	                            collectValue(item, name);
	                        }
	                    }
	                }
	                return pairs;
	
	                function collectValue(value, key){
	                    if (asString) {
	                        pairs.push(key + "=" + encodeURIComponent(value));
	                    } else {
	                        pairs[key] = encodeURIComponent(value);
	                    }
	                }
	
	                function isSignificantValue(value, key){
	                    return key === "group" ? true : angular.isDefined(value) && value !== "";
	                }
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#reload
	             * @description Reload table data
	             */
	            this.reload = function() {
	                var self = this,
	                    pData = null;
	
	                settings.$loading = true;
	
	                prevParamsMemento = angular.copy(createComparableParams());
	                isCommittedDataset = true;
	
	                if (self.hasGroup()) {
	                    pData = runInterceptorPipeline($q.when(settings.getGroups(self)));
	                } else {
	                    pData = runInterceptorPipeline($q.when(settings.getData(self)));
	                }
	
	                log('ngTable: reload data');
	
	                var oldData = self.data;
	                return pData.then(function(data) {
	                    settings.$loading = false;
	                    errParamsMemento = null;
	
	                    self.data = data;
	                    // note: I think it makes sense to publish this event even when data === oldData
	                    // subscribers can always set a filter to only receive the event when data !== oldData
	                    ngTableEventsChannel.publishAfterReloadData(self, data, oldData);
	                    self.reloadPages();
	
	                    return data;
	                }).catch(function(reason){
	                    errParamsMemento = prevParamsMemento;
	                    // "rethrow"
	                    return $q.reject(reason);
	                });
	            };
	
	            /**
	             * @ngdoc method
	             * @name NgTableParams#hasErrorState
	             * @description Return true when an attempt to `reload` the current `parameter` values have resulted in
	             * a failure
	             *
	             * This method will continue to return true until the reload is successfully called or when the
	             * `parameter` values have changed
	             */
	            this.hasErrorState = function(){
	                return !!(errParamsMemento && angular.equals(errParamsMemento, createComparableParams()));
	            };
	
	            function optimizeFilterDelay(){
	                // don't debounce by default filter input when working with small synchronous datasets
	                if (settings.filterOptions.filterDelay === defaultFilterOptions.filterDelay &&
	                    settings.total <= settings.filterOptions.filterDelayThreshold &&
	                    settings.getData === defaultSettingsFns.getData){
	                    settings.filterOptions.filterDelay = 0;
	                }
	            }
	
	            this.reloadPages = (function() {
	                var currentPages;
	                return function(){                    
	                    var oldPages = currentPages;
	                    var newPages = self.generatePagesArray(self.page(), self.total(), self.count(), self.numPages());
	                    if (!angular.equals(oldPages, newPages)){
	                        currentPages = newPages;
	                        ngTableEventsChannel.publishPagesChanged(this, newPages, oldPages);
	                    }
	                }
	            })();
	
	            function runInterceptorPipeline(fetchedData){
	                var interceptors = settings.interceptors || [];
	
	                return interceptors.reduce(function(result, interceptor){
	                    var thenFn = (interceptor.response && interceptor.response.bind(interceptor)) || $q.when;
	                    var rejectFn = (interceptor.responseError && interceptor.responseError.bind(interceptor)) || $q.reject;
	                    return result.then(function(data){
	                        return thenFn(data, self);
	                    }, function(reason){
	                        return rejectFn(reason, self);
	                    });
	                }, fetchedData);
	            }
	
	            function getDefaultSettingFns(){
	
	                return {
	                    getData: getData,
	                    getGroups: getGroups
	                };
	
	                /**
	                 * @ngdoc method
	                 * @name settings#getData
	                 * @description Returns the data to display in the table
	                 *
	                 * Called by `NgTableParams` whenever it considers new data is to be loaded
	                 *
	                 * @param {Object} params the `NgTableParams` requesting data
	                 */
	                function getData(params) {
	                    return ngTableDefaultGetData(params.settings().dataset, params);
	                }
	
	                /**
	                 * @ngdoc method
	                 * @name settings#getGroups
	                 * @description Return groups of data to display in the table
	                 *
	                 * Called by `NgTableParams` whenever it considers new data is to be loaded
	                 * and when a `group` value has been assigned
	                 *
	                 * @param {Object} params the `NgTableParams` requesting data
	                 */
	                function getGroups(params) {
	
	                    var group = params.group();
	                    var groupFn;
	                    var sortDirection = undefined;
	                    if (angular.isFunction(group)) {
	                        groupFn = group;
	                        sortDirection = group.sortDirection;
	                    } else {
	                        // currently support for only one group implemented
	                        var groupField = Object.keys(group)[0];
	                        sortDirection = group[groupField];
	                        groupFn = function(item){
	                            return getPath(item, groupField);
	                        };
	                    }
	
	                    var settings = params.settings();
	                    var originalDataOptions = settings.dataOptions;
	                    settings.dataOptions = { applyPaging: false };
	                    var gotData = $q.when(settings.getData(params));
	                    return gotData.then(function(data) {
	                        var groups = {};
	                        angular.forEach(data, function(item) {
	                            var groupName = groupFn(item);
	                            groups[groupName] = groups[groupName] || {
	                                    data: [],
	                                    $hideRows: !settings.groupOptions.isExpanded,
	                                    value: groupName
	                                };
	                            groups[groupName].data.push(item);
	                        });
	                        var result = [];
	                        for (var i in groups) {
	                            result.push(groups[i]);
	                        }
	                        if (sortDirection) {
	                            var orderByFn = ngTableDefaultGetData.getOrderByFn();
	                            var orderBy = convertSortToOrderBy({
	                                value: sortDirection
	                            });
	                            result = orderByFn(result, orderBy);
	                        }
	
	                        return ngTableDefaultGetData.applyPaging(result, params);
	                    }).finally(function(){
	                        // restore the real options
	                        settings.dataOptions = originalDataOptions;
	                    });
	                }
	
	                function getPath (obj, ks) {
	                    // origianl source https://github.com/documentcloud/underscore-contrib
	
	                    if (typeof ks == "string") ks = ks.split(".");
	
	                    // If we have reached an undefined property
	                    // then stop executing and return undefined
	                    if (obj === undefined) return void 0;
	
	                    // If the path array has no more elements, we've reached
	                    // the intended property and return its value
	                    if (ks.length === 0) return obj;
	
	                    // If we still have elements in the path array and the current
	                    // value is null, stop executing and return undefined
	                    if (obj === null) return void 0;
	
	                    return getPath(obj[ks[0]], ks.slice(1));
	                }
	            }
	
	            var params = {
	                page: 1,
	                count: 10,
	                filter: {},
	                sorting: {},
	                group: {}
	            };
	            angular.extend(params, ngTableDefaults.params);
	
	            /**
	             * @ngdoc object
	             * @name settings
	             * @module ngTable
	             * @description configuration settings for `NgTableParams`
	             */
	            var settings = {
	                $loading: false,
	                dataset: null, //allows data to be set when table is initialized
	                total: 0,
	                defaultSort: 'desc',
	                filterOptions: angular.copy(defaultFilterOptions),
	                groupOptions: angular.copy(defaultGroupOptions),
	                counts: [10, 20, 50, 100],
	                interceptors: [],
	                paginationMaxBlocks: 11,
	                paginationMinBlocks: 5,
	                sortingIndicator: 'span'
	            };
	
	            this.settings(defaultSettingsFns);
	            this.settings(ngTableDefaults.settings);
	            this.settings(baseSettings);
	            this.parameters(baseParameters, true);
	
	            ngTableEventsChannel.publishAfterCreated(this);
	            // run events during construction after the initial create event. That way a consumer
	            // can subscribe to all events for a table without "dropping" an event
	            angular.forEach(initialEvents, function(event){
	                event();
	            });
	            initialEvents = null;
	
	            return this;
	        };
	        return NgTableParams;
	    }]);
	})();
	
	
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    /**
	     * @ngdoc object
	     * @name ngTableController
	     *
	     * @description
	     * Each {@link ngTable ngTable} directive creates an instance of `ngTableController`
	     */
	    angular.module('ngTable').controller('ngTableController', ['$scope','$rootScope', 'NgTableParams', '$timeout', '$parse', '$compile', '$attrs', '$element',
	        'ngTableColumn', 'ngTableEventsChannel',
	        function($scope, $rootScope, NgTableParams, $timeout, $parse, $compile, $attrs, $element, ngTableColumn, ngTableEventsChannel) {
	            var isFirstTimeLoad = true;
	            $scope.$filterRow = {};
	            $scope.$loading = false;
	
	            // until such times as the directive uses an isolated scope, we need to ensure that the check for
	            // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
	            // field on a $scope higher up in the prototype chain
	            if (!$scope.hasOwnProperty("params")) {
	                $scope.params = new NgTableParams(true);
	
	            }
	            $scope.params.settings().$scope = $scope;
	
	            var delayFilter = (function() {
	                var timer = 0;
	                return function(callback, ms) {
	                    $timeout.cancel(timer);
	                    timer = $timeout(callback, ms);
	                };
	            })();
	
	            function onDataReloadStatusChange (newStatus/*, oldStatus*/) {
	 
	                if (!newStatus || $scope.params.hasErrorState()) {
	                    return;
	                }
	
	                $scope.params.settings().$scope = $scope;
	
	                var currentParams = $scope.params;
	                var filterOptions = currentParams.settings().filterOptions;
	
	                if (currentParams.hasFilterChanges()) {
	                    var applyFilter = function () {
	                        currentParams.page(1);
	                        currentParams.reload();
	                    };
	                    if (filterOptions.filterDelay) {
	                        delayFilter(applyFilter, filterOptions.filterDelay);
	                    } else {
	                        applyFilter();
	                    }
	                } else {
	                    currentParams.reload();
	                }
	            }
	
	            // watch for when a new NgTableParams is bound to the scope
	            // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
	            // the current data page as a field. Checking this for value equality would be terrible for performance
	            // and potentially cause an error if the items in that array has circular references
	            $scope.$watch('params', function(newParams, oldParams){
	
	                if (newParams === oldParams || !newParams) {
	                    return;
	                }
	
	                newParams.reload();
	            }, false);
	
	            $scope.$watch('params.isDataReloadRequired()', onDataReloadStatusChange);
	
	            this.compileDirectiveTemplates = function () {
	                if (!$element.hasClass('ng-table')) {
	                    $scope.templates = {
	                        header: ($attrs.templateHeader ? $attrs.templateHeader : 'ng-table/header.html'),
	                        pagination: ($attrs.templatePagination ? $attrs.templatePagination : 'ng-table/pager.html')
	                    };
	                    $element.addClass('ng-table');
	                    var headerTemplate = null;
	
	                    // $element.find('> thead').length === 0 doesn't work on jqlite
	                    var theadFound = false;
	                    angular.forEach($element.children(), function(e) {
	                        if (e.tagName === 'THEAD') {
	                            theadFound = true;
	                        }
	                    });
	                    if (!theadFound) {
	                        headerTemplate = angular.element(document.createElement('thead')).attr('ng-include', 'templates.header');
	                        $element.prepend(headerTemplate);
	                    }
	                    $scope.paginationTemplate = angular.element(document.createElement('div')).attr({
	                        'ng-table-pagination': 'params',
	                        'template-url': 'templates.pagination',
	                    });
	                    $scope.paginationTemplate2 =  angular.element(document.createElement('div')).attr({
	                        'ng-table-pagination': 'params',
	                        'template-url': 'templates.pagination'
	                    });
	                    $element.before($scope.paginationTemplate2);
	                    $element.after($scope.paginationTemplate);
	                    if (headerTemplate) {
	                        $compile(headerTemplate)($scope);
	                    }
	                    $compile($scope.paginationTemplate)($scope);
	                    $compile($scope.paginationTemplate2)($scope);
	                }
	            };
	
	            this.loadFilterData = function ($columns) {
	                angular.forEach($columns, function ($column) {
	                    var result;
	                    result = $column.filterData($scope);
	                    if (!result) {
	                        delete $column.filterData;
	                        return;
	                    }
	
	                    // if we're working with a deferred object or a promise, let's wait for the promise
	                    /* WARNING: support for returning a $defer is depreciated */
	                    if ((angular.isObject(result) && (angular.isObject(result.promise) || angular.isFunction(result.then)))) {
	                        var pData = angular.isFunction(result.then) ? result : result.promise;
	                        delete $column.filterData;
	                        return pData.then(function(data) {
	                            // our deferred can eventually return arrays, functions and objects
	                            if (!angular.isArray(data) && !angular.isFunction(data) && !angular.isObject(data)) {
	                                // if none of the above was found - we just want an empty array
	                                data = [];
	                            }
	                            $column.data = data;
	                        });
	                    }
	                    // otherwise, we just return what the user gave us. It could be a function, array, object, whatever
	                    else {
	                        return $column.data = result;
	                    }
	                });
	            };
	
	            this.buildColumns = function (columns) {
	                var result = [];
	                (columns || []).forEach(function(col){
	                    result.push(ngTableColumn.buildColumn(col, $scope, result));
	                });
	                return result
	            };
	
	            this.parseNgTableDynamicExpr = function (attr) {
	                if (!attr || attr.indexOf(" with ") > -1) {
	                    var parts = attr.split(/\s+with\s+/);
	                    return {
	                        tableParams: parts[0],
	                        columns: parts[1]
	                    };
	                } else {
	                    throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
	                }
	            };
	
	            this.setupBindingsToInternalScope = function(tableParamsExpr){
	
	                // note: this we're setting up watches to simulate angular's isolated scope bindings
	
	                // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
	                // $watch for value equivalence. This is because ngTableParams references the current page of data as
	                // a field and it's important not to watch this
	                var tableParamsGetter = $parse(tableParamsExpr);
	                $scope.$watch(tableParamsGetter, (function (params) {
	                    if (angular.isUndefined(params)) {
	                        return;
	                    }
	                    $scope.paramsModel = tableParamsGetter;
	                    $scope.params = params;
	                }), false);
	
	                setupFilterRowBindingsToInternalScope();
	                setupGroupRowBindingsToInternalScope();
	            };
	
	            function setupFilterRowBindingsToInternalScope(){
	                if ($attrs.showFilter) {
	                    $scope.$parent.$watch($attrs.showFilter, function(value) {
	                        $scope.show_filter = value;
	                    });
	                } else {
	                    $scope.$watch(hasVisibleFilterColumn, function(value){
	                        $scope.show_filter = value;
	                    })
	                }
	
	                if ($attrs.disableFilter) {
	                    $scope.$parent.$watch($attrs.disableFilter, function(value) {
	                        $scope.$filterRow.disabled = value;
	                    });
	                }
	            }
	
	            function setupGroupRowBindingsToInternalScope(){
	                $scope.$groupRow = {};
	                if ($attrs.showGroup) {
	                    var showGroupGetter = $parse($attrs.showGroup);
	                    $scope.$parent.$watch(showGroupGetter, function(value) {
	                        $scope.$groupRow.show = value;
	                    });
	                    if (showGroupGetter.assign){
	                        // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
	                        $scope.$watch('$groupRow.show', function(value) {
	                            showGroupGetter.assign($scope.$parent, value);
	                        });
	                    }
	                } else{
	                    $scope.$watch('params.hasGroup()', function(newValue) {
	                        $scope.$groupRow.show = newValue;
	                    });
	                }
	            }
	
	            function getVisibleColumns(){
	                return ($scope.$columns || []).filter(function(c){
	                    return c.show($scope);
	                });
	            }
	
	            function hasVisibleFilterColumn(){
	                if (!$scope.$columns) return false;
	
	                return some($scope.$columns, function($column){
	                    return $column.show($scope) && $column.filter($scope);
	                });
	            }
	
	            function some(array, predicate){
	                var found = false;
	                for (var i = 0; i < array.length; i++) {
	                    var obj = array[i];
	                    if (predicate(obj)){
	                        found = true;
	                        break;
	                    }
	                }
	                return found;
	            }
	            
	
	            function commonInit(){
	                ngTableEventsChannel.onAfterReloadData(bindDataToScope, $scope, isMyPublisher);
	                ngTableEventsChannel.onPagesChanged(bindPagesToScope, $scope, isMyPublisher);
	
	                function bindDataToScope(params, newDatapage){
	                    var visibleColumns = getVisibleColumns();
	                    if (params.hasGroup()) {
	                        $scope.$groups = newDatapage || [];
	                        $scope.$groups.visibleColumnCount = visibleColumns.length;
	                    } else {
	                        $scope.$data = newDatapage || [];
	                        $scope.$data.visibleColumnCount = visibleColumns.length;
	                    }
	                }
	
	                function bindPagesToScope(params, newPages){
	                    $scope.pages = newPages
	                }
	
	                function isMyPublisher(publisher){
	                    return $scope.params === publisher;
	                }
	            }
	
	            commonInit();
	        }]);
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    /**
	     * @ngdoc directive
	     * @name ngTable
	     * @module ngTable
	     * @restrict A
	     *
	     * @description
	     * Directive that instantiates {@link ngTableController ngTableController}.
	     */
	    angular.module('ngTable').directive('ngTable', ['$q', '$parse',
	        function($q, $parse) {
	            'use strict';
	
	            return {
	                restrict: 'A',
	                priority: 1001,
	                scope: true,
	                controller: 'ngTableController',
	                compile: function(element) {
	                    var columns = [],
	                        i = 0,
	                        dataRow,
	                        groupRow,
	                        rows = [];
	
	                    angular.forEach(element.find('tr'), function(tr) {
	                        rows.push(angular.element(tr))
	                    });
	                    dataRow = rows.filter(function(tr){
	                        return !tr.hasClass('ng-table-group');
	                    })[0];
	                    groupRow = rows.filter(function(tr){
	                        return tr.hasClass('ng-table-group');
	                    })[0];
	
	                    if (!dataRow) {
	                        return;
	                    }
	                    angular.forEach(dataRow.find('td'), function(item) {
	                        var el = angular.element(item);
	                        if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
	                            return;
	                        }
	
	                        var getAttrValue = function(attr){
	                            return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                        };
	                        var setAttrValue = function(attr, value){
	                            if (el.attr('x-data-' + attr)){
	                                el.attr('x-data-' + attr, value)
	                            } else if (el.attr('data' + attr)){
	                                el.attr('data' + attr, value)
	                            } else {
	                                el.attr(attr, value)
	                            }
	                        };
	
	                        var parsedAttribute = function(attr) {
	                            var expr = getAttrValue(attr);
	                            if (!expr){
	                                return undefined;
	                            }
	
	                            var localValue;
	                            var getter = function (context) {
	                                if (localValue !== undefined){
	                                    return localValue;
	                                }
	                                return $parse(expr)(context);
	                            };
	                            getter.assign = function($scope, value){
	                                var parsedExpr = $parse(expr);
	                                if (parsedExpr.assign) {
	                                    // we should be writing back to the parent scope as this is where the expression
	                                    // came from
	                                    parsedExpr.assign($scope.$parent, value);
	                                } else {
	                                    localValue = value;
	                                }
	                            };
	                            return getter;
	                        };
	                        var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
	                        if (titleExpr){
	                            el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
	                        }
	                        // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
	                        // a corresponding "safe" default
	                        columns.push({
	                            id: i++,
	                            title: parsedAttribute('title'),
	                            titleAlt: parsedAttribute('title-alt'),
	                            headerTitle: parsedAttribute('header-title'),
	                            sortable: parsedAttribute('sortable'),
	                            'class': parsedAttribute('header-class'),
	                            filter: parsedAttribute('filter'),
	                            groupable: parsedAttribute('groupable'),
	                            headerTemplateURL: parsedAttribute('header'),
	                            filterData: parsedAttribute('filter-data'),
	                            show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
	                        });
	
	                        if (groupRow || el.attr("ng-if")){
	                            // change ng-if to bind to our column definition which we know will be writable
	                            // because this will potentially increase the $watch count, only do so if we already have an
	                            // ng-if or when we definitely need to change visibility of the columns.
	                            // currently only ngTableGroupRow directive needs to change visibility
	                            setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
	                        }
	                    });
	                    return function(scope, element, attrs, controller) {
	                        scope.$columns = columns = controller.buildColumns(columns);
	
	                        controller.setupBindingsToInternalScope(attrs.ngTable);
	                        controller.loadFilterData(columns);
	                        controller.compileDirectiveTemplates();
	                    };
	                }
	            }
	        }
	    ]);
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	
	    /**
	     * @ngdoc directive
	     * @name ngTableDynamic
	     * @module ngTable
	     * @restrict A
	     *
	     * @description
	     * A dynamic version of the {@link ngTable ngTable} directive that accepts a dynamic list of columns
	     * definitions to render
	     */
	    angular.module('ngTable').directive('ngTableDynamic', [function (){
	
	        return {
	            restrict: 'A',
	            priority: 1001,
	            scope: true,
	            controller: 'ngTableController',
	            compile: function(tElement) {
	                var row;
	
	                // IE 8 fix :not(.ng-table-group) selector
	                angular.forEach(tElement.find('tr'), function(tr) {
	                    tr = angular.element(tr);
	                    if (!tr.hasClass('ng-table-group') && !row) {
	                        row = tr;
	                    }
	                });
	                if (!row) {
	                    return;
	                }
	
	                angular.forEach(row.find('td'), function(item) {
	                    var el = angular.element(item);
	                    var getAttrValue = function(attr){
	                        return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                    };
	
	                    // this used in responsive table
	                    var titleExpr = getAttrValue('title');
	                    if (!titleExpr){
	                        el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
	                    }
	                    var showExpr = el.attr('ng-if');
	                    if (!showExpr){
	                        el.attr('ng-if', '$columns[$index].show(this)');
	                    }
	                });
	                return function (scope, element, attrs, controller) {
	                    var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
	
	                    controller.setupBindingsToInternalScope(expr.tableParams);
	                    controller.compileDirectiveTemplates();
	
	                    scope.$watchCollection(expr.columns, function (newCols/*, oldCols*/) {
	                        scope.$columns = controller.buildColumns(newCols);
	                        controller.loadFilterData(scope.$columns);
	                    });
	                };
	            }
	        };
	    }]);
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .directive('ngTableColumnsBinding', ngTableColumnsBinding);
	
	    ngTableColumnsBinding.$inject = ["$parse"];
	
	    /**
	     * @ngdoc directive
	     * @name ngTableColumnsBinding
	     * @description One-way data binds the $columns array generated by ngTable/ngTableDynamic to the specified
	     * expression.
	     *
	     * This allows the $columns array to be accessed outside of the html table markup
	     */
	    function ngTableColumnsBinding($parse){
	        var directive = {
	            restrict: 'A',
	            require: 'ngTable',
	            link: linkFn
	        };
	        return directive;
	
	        function linkFn($scope, $element, $attrs){
	            var setter = $parse($attrs.ngTableColumnsBinding).assign;
	            if (setter){
	                $scope.$watch('$columns', function(newColumns){
	                    var shallowClone = (newColumns || []).slice(0);
	                    setter($scope, shallowClone);
	                });
	            }
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    /**
	     * @ngdoc directive
	     * @name ngTablePagination
	     * @module ngTable
	     * @restrict A
	     */
	    angular.module('ngTable').directive('ngTablePagination', ['$rootScope','$compile', 'ngTableEventsChannel',
	        function($rootScope,$compile, ngTableEventsChannel) {
	            'use strict';
	
	            return {
	                restrict: 'A',
	                scope: {
	                    'params': '=ngTablePagination',
	                    'templateUrl': '=',
	                },
	                replace: false,
	                link: function(scope, element/*, attrs*/) {
	                    scope.pagecount = '';
	                    scope.goTo = function(value) {
	                        if(value) {
	                            scope.params.page(value);
	                        }
	                    }
	                    ngTableEventsChannel.onAfterReloadData(function(pubParams) {
	                        scope.pages = pubParams.generatePagesArray();
	                    }, scope, function(pubParams){
	            
	                        return pubParams === scope.params;
	                    });
	
	                    scope.$watch('templateUrl', function(templateUrl) {
	                        if (angular.isUndefined(templateUrl)) {
	                            return;
	                        }
	                        var template = angular.element(document.createElement('div'));
	                        template.attr({
	                            'ng-include': 'templateUrl'
	                        });
	                        element.append(template);
	                        $compile(template)(scope);
	                    });
	                }
	            };
	        }
	    ]);
	
	})();
	
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .controller('ngTableFilterRowController', ngTableFilterRowController);
	
	    ngTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
	
	    function ngTableFilterRowController($scope, ngTableFilterConfig){
	
	        $scope.config = ngTableFilterConfig;
	
	        $scope.getFilterCellCss = function (filter, layout){
	            if (layout !== 'horizontal') {
	                return 's12';
	            }
	
	            var size = Object.keys(filter).length;
	            var width = parseInt(12 / size, 10);
	            return 's' + width;
	        };
	
	        $scope.getFilterPlaceholderValue = function(filterValue/*, filterName*/){
	            if (angular.isObject(filterValue)) {
	                return filterValue.placeholder;
	            } else {
	                return '';
	            }
	        };
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .directive('ngTableFilterRow', ngTableFilterRow);
	
	    ngTableFilterRow.$inject = [];
	
	    function ngTableFilterRow(){
	        var directive = {
	            restrict: 'E',
	            replace: true,
	            templateUrl: 'ng-table/filterRow.html',
	            scope: true,
	            controller: 'ngTableFilterRowController'
	        };
	        return directive;
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .controller('ngTableGroupRowController', ngTableGroupRowController);
	
	    ngTableGroupRowController.$inject = ['$scope'];
	
	    function ngTableGroupRowController($scope){
	
	        var groupFns = [];
	
	        init();
	
	        function init(){
	            $scope.getGroupables = getGroupables;
	            $scope.getGroupTitle = getGroupTitle;
	            $scope.getVisibleColumns = getVisibleColumns;
	            $scope.groupBy = groupBy;
	            $scope.isSelectedGroup = isSelectedGroup;
	            $scope.toggleDetail = toggleDetail;
	
	            $scope.$watch('params.group()', setGroup, true);
	        }
	
	        function changeSortDirection(){
	            var newDirection;
	            if ($scope.params.hasGroup($scope.$selGroup, 'asc')) {
	                newDirection = 'desc';
	            } else if ($scope.params.hasGroup($scope.$selGroup, 'desc')){
	                newDirection = '';
	            } else {
	                newDirection = 'asc';
	            }
	            $scope.params.group($scope.$selGroup, newDirection);
	        }
	
	        function findGroupColumn(groupKey) {
	            return $scope.$columns.filter(function ($column) {
	                return $column.groupable($scope) === groupKey;
	            })[0];
	        }
	
	        function getGroupTitle(group){
	            return angular.isFunction(group) ? group.title : group.title($scope);
	        }
	
	        function getGroupables(){
	            var groupableCols = $scope.$columns.filter(function ($column) {
	                return $column.groupable($scope);
	            });
	            return groupFns.concat(groupableCols);
	        }
	
	        function getVisibleColumns(){
	            return $scope.$columns.filter(function($column){
	                return $column.show($scope);
	            })
	        }
	
	        function groupBy(group){
	            if (isSelectedGroup(group)){
	                changeSortDirection();
	            } else {
	                if (group.groupable){
	                    $scope.params.group(group.groupable($scope));
	                } else{
	                    $scope.params.group(group);
	                }
	            }
	        }
	
	        function isSelectedGroup(group){
	            if (group.groupable){
	                return group.groupable($scope) === $scope.$selGroup;
	            } else {
	                return group === $scope.$selGroup;
	            }
	        }
	
	        function setGroup(group){
	
	            var existingGroupCol = findGroupColumn($scope.$selGroup);
	            if (existingGroupCol && existingGroupCol.show.assign){
	                existingGroupCol.show.assign($scope, true);
	            }
	            if (angular.isFunction(group)) {
	
	                groupFns = [group];
	                $scope.$selGroup = group;
	                $scope.$selGroupTitle = group.title;
	            } else {
	                // note: currently only one group is implemented
	                var groupKey = Object.keys(group || {})[0];
	                var groupedColumn = findGroupColumn(groupKey);
	                if (groupedColumn) {
	                    $scope.$selGroupTitle = groupedColumn.title($scope);
	                    $scope.$selGroup = groupKey;
	                    if (groupedColumn.show.assign) {
	                        groupedColumn.show.assign($scope, false);
	                    }
	                }
	            }
	        }
	
	        function toggleDetail(){
	            $scope.params.settings().groupOptions.isExpanded = !$scope.params.settings().groupOptions.isExpanded;
	            return $scope.params.reload();
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .directive('ngTableGroupRow', ngTableGroupRow);
	
	    ngTableGroupRow.$inject = [];
	
	    function ngTableGroupRow(){
	        var directive = {
	            restrict: 'E',
	            replace: true,
	            templateUrl: 'ng-table/groupRow.html',
	            scope: true,
	            controller: 'ngTableGroupRowController',
	            controllerAs: 'dctrl'
	        };
	        return directive;
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .controller('ngTableSorterRowController', ngTableSorterRowController);
	
	    ngTableSorterRowController.$inject = ['$scope','$rootScope'];
	
	    function ngTableSorterRowController($scope,$rootScope){
	
	        $scope.sortBy = sortBy;
	
	        ///////////
	
	        function sortBy($column, event) {
	            var parsedSortable = $column.sortable && $column.sortable();
	            if (!parsedSortable) {
	                return;
	            }
	            var defaultSort = $scope.params.settings().defaultSort;
	            var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
	            var sorting = $scope.params.sorting() && $scope.params.sorting()[parsedSortable] && ($scope.params.sorting()[parsedSortable] === defaultSort);
	            var sortingParams = (event.ctrlKey || event.metaKey) ? $scope.params.sorting() : {};
	            sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
	            $scope.params.parameters({
	                sorting: sortingParams
	            });
	            $scope.params.page(1);
	            $rootScope.sortby = $column.sortable();
	          
	            if(sortingParams[$rootScope.sortby] ==='desc') {
	                $rootScope.sort = -1
	            } else if(sortingParams[$rootScope.sortby] ==='asc') {
	                $rootScope.sort= 1
	            }
	        }
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    angular.module('ngTable')
	        .directive('ngTableSorterRow', ngTableSorterRow);
	
	    ngTableSorterRow.$inject = [];
	
	    function ngTableSorterRow(){
	        var directive = {
	            restrict: 'E',
	            replace: true,
	            templateUrl: 'ng-table/sorterRow.html',
	            scope: true,
	            controller: 'ngTableSorterRowController'
	        };
	        return directive;
	    }
	})();
	
	/**
	 * ngTable: Table + Angular JS
	 *
	 * @author Vitalii Savchuk <esvit666@gmail.com>
	 * @url https://github.com/esvit/ng-table/
	 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	 */
	
	(function(){
	    'use strict';
	
	    /**
	     * @ngdoc directive
	     * @name ngTableSelectFilterDs
	     * @module ngTable
	     * @restrict A
	     *
	     * @description
	     * Takes the array returned by $column.filterData and makes it available as `$selectData` on the `$scope`.
	     *
	     * The resulting `$selectData` array will contain an extra item that is suitable to represent the user
	     * "deselecting" an item from a `<select>` tag
	     *
	     * This directive is is focused on providing a datasource to an `ngOptions` directive
	     */
	    angular.module('ngTable')
	        .directive('ngTableSelectFilterDs', ngTableSelectFilterDs);
	
	    ngTableSelectFilterDs.$inject = [];
	
	    function ngTableSelectFilterDs(){
	        // note: not using isolated or child scope "by design"
	        // this is to allow this directive to be combined with other directives that do
	
	        var directive = {
	            restrict: 'A',
	            controller: ngTableSelectFilterDsController
	        };
	        return directive;
	    }
	
	    ngTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
	    function ngTableSelectFilterDsController($scope, $parse, $attrs, $q){
	
	        var $column = {};
	        init();
	
	        function init(){
	            $column = $parse($attrs.ngTableSelectFilterDs)($scope);
	            $scope.$watch(function(){
	                return $column.data;
	            }, bindDataSource);
	        }
	
	        function bindDataSource(){
	            getSelectListData($column).then(function(data){
	                if (data && !hasEmptyOption(data)){
	                    data.unshift({ id: '', title: ''});
	                }
	                data = data || [];
	                $scope.$selectData = data;
	            });
	        }
	
	        function hasEmptyOption(data) {
	            var isMatch;
	            for (var i = 0; i < data.length; i++) {
	                var item = data[i];
	                if (item && item.id === '') {
	                    isMatch = true;
	                    break;
	                }
	            }
	            return isMatch;
	        }
	
	        function getSelectListData($column) {
	            var data = angular.isFunction($column.data) ? $column.data() : $column.data;
	            return $q.when(data);
	        }
	    }
	})();
	
	angular.module('ngTable').run(['$templateCache', function ($templateCache) {
		$templateCache.put('ng-table/filterRow.html', '<tr ng-show="show_filter" class="ng-table-filters"> <th data-title-text="{{$column.titleAlt(this) || $column.title(this)}}" ng-repeat="$column in $columns" ng-if="$column.show(this)" class="filter {{$column.class(this)}}" ng-class="params.settings().filterOptions.filterLayout===\'horizontal\' ? \'filter-horizontal\' : \'\'"> <div ng-repeat="(name, filter) in $column.filter(this)" ng-include="config.getTemplateUrl(filter)" class="filter-cell" ng-class="[getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? \'last\' : \'\']"> </div> </th> </tr> ');
		$templateCache.put('ng-table/filters/number.html', '<input type="number" name="{{name}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> ');
		$templateCache.put('ng-table/filters/select-multiple.html', '<select ng-options="data.id as data.title for data in $column.data" ng-disabled="$filterRow.disabled" multiple ng-multiple="true" ng-model="params.filter()[name]" class="filter filter-select-multiple form-control" name="{{name}}"> </select> ');
		$templateCache.put('ng-table/filters/select.html', '<select ng-options="data.id as data.title for data in $selectData" ng-table-select-filter-ds="$column" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="filter filter-select form-control" name="{{name}}"> <option style="display:none" value=""></option> </select> ');
		$templateCache.put('ng-table/filters/text.html', '<input type="text" name="{{name}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> ');
		$templateCache.put('ng-table/groupRow.html', '<tr ng-if="params.hasGroup()" ng-show="$groupRow.show" class="ng-table-group-header"> <th colspan="{{getVisibleColumns().length}}"  class="sortable" ng-class="{ \'sort-asc\': params.hasGroup($selGroup, \'asc\'), \'sort-desc\':params.hasGroup($selGroup, \'desc\') }"> <a href="" ng-click="isSelectorOpen=!isSelectorOpen" class="ng-table-group-selector"> <strong class="sort-indicator">{{$selGroupTitle}}</strong> <button class="btn btn-default btn-xs ng-table-group-close" ng-click="$groupRow.show=false; $event.preventDefault(); $event.stopPropagation();"> <span class="glyphicon glyphicon-remove"></span> </button> <button class="btn btn-default btn-xs ng-table-group-toggle" ng-click="toggleDetail(); $event.preventDefault(); $event.stopPropagation();"> <span class="glyphicon" ng-class="{ \'glyphicon-resize-small\': params.settings().groupOptions.isExpanded, \'glyphicon-resize-full\': !params.settings().groupOptions.isExpanded }"></span> </button> </a> <div class="list-group" ng-if="isSelectorOpen"> <a href="" class="list-group-item" ng-repeat="group in getGroupables()" ng-click="groupBy(group)"> <strong>{{ getGroupTitle(group)}}</strong> <strong ng-class="isSelectedGroup(group) && \'sort-indicator\'"></strong> </a> </div> </th> </tr> ');
		$templateCache.put('ng-table/header.html', '<ng-table-group-row></ng-table-group-row> <ng-table-sorter-row></ng-table-sorter-row> <ng-table-filter-row></ng-table-filter-row> ');
		$templateCache.put('ng-table/pager.html', '<div class="ng-cloak ng-table-pager" ng-if="params.data.length"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-default"> <span ng-bind="count"></span> </button> </div> <ul ng-if="pages.length" class="pagination ng-table-pagination"> <li ng-class="{\'disabled\': !page.active && !page.current, \'active\': page.current}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href="">&laquo;</a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href="">&raquo;</a> </li> </ul> <div class="goTo" ng-if="pages.length"> <input ng-model="pagecount" class="goTo--input form-control" ng-enter="goTo(pagecount)"/> <button ng-click="goTo(pagecount)" class="goTo--button btn btn-primary">Go To</button> </div> </div> ');
		$templateCache.put('ng-table/sorterRow.html', '<tr class="ng-table-sort-header"> <th title="{{$column.headerTitle(this)}}" ng-repeat="$column in $columns" ng-class="{ \'sortable\': $column.sortable(this), \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\', \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\' }" ng-click="sortBy($column, $event)" ng-if="$column.show(this)" ng-init="template=$column.headerTemplateURL(this)" class="header {{$column.class(this)}}"> <div ng-if="!template" class="ng-table-header" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'div\'}"> <span class="{{$column.title(this)}}" ng-bind="$column.title(this)" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'span\'}"></span> </div> <div ng-if="template" ng-include="template"></div> </th> </tr> ');
	}]);
	    return angular.module('ngTable');
	}));


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS dropzone directive
	 * @author Uday Hiwarale <uhiwarale@gmail.com>
	 * https://www.github.com/thatisuday/ngDropzone
	 */
	 
	 
	(function(){
	    'use strict';
	
		angular.module('thatisuday.dropzone', []).provider('dropzoneOps', function(){
			/*
			 *	Add default options here
			**/
			var defOps = {
				//Add your options here
			};
			
			return {
				setOptions : function(newOps){
					angular.extend(defOps, newOps);
				},
				$get : function(){
					return defOps;
				}
			}
		}).directive('ngDropzone', ['$timeout', 'dropzoneOps','$rootScope', function($timeout, dropzoneOps,$rootScope){
			return {
				restrict : 'AE',
				template : '<div></div>',
				replace : true,
				scope : {
					options : '=?', //http://www.dropzonejs.com/#configuration-options
					callbacks : '=?', //http://www.dropzonejs.com/#events
					methods : '=?' //http://www.dropzonejs.com/#dropzone-methods
				},
				link : function(scope, iElem, iAttr){
					var addFileToDropzone = true;
					//Set options for dropzone {override from dropzone options provider}
					scope.options = scope.options || {};
					var initOps = angular.extend({}, dropzoneOps, scope.options);
					
					
					//Instantiate dropzone with initOps
					var myDropzone = new Dropzone(iElem[0], initOps);
					
					
					/*********************************************/
					
					
					//Instantiate Dropzone methods (Control actions)
					scope.methods = scope.methods || {};
					
					scope.methods.getDropzone = function(){ 
						return myDropzone; //Return myDropzone instance
					};
					
					scope.methods.getAllFiles = function(){ 
						return myDropzone.files; //Return all files
					};
					
					var controlMethods = [
						'removeFile', 'removeAllFiles', 'processQueue',
						'getAcceptedFiles', 'getRejectedFiles', 'getQueuedFiles', 'getUploadingFiles',
						'disable', 'enable', 'confirm', 'createThumbnailFromUrl', 'processFile', 'uploadFile'
					];
					
					angular.forEach(controlMethods, function(methodName){
						scope.methods[methodName] = function(){
							myDropzone[methodName].apply(myDropzone, arguments);
							if(!scope.$$phase && !scope.$root.$$phase) scope.$apply();
						}
					});
					
					
					/*********************************************/
					
					
					//Set invents (callbacks)
					if(scope.callbacks){
						var callbackMethods = [
							'drop', 'dragstart', 'dragend',
							'dragenter', 'dragover', 'dragleave', 'addedfile', 'removedfile',
							'thumbnail', 'error', 'processing', 'uploadprogress',
							'sending', 'success', 'complete', 'canceled', 'maxfilesreached',
							'maxfilesexceeded', 'processingmultiple', 'sendingmultiple', 'successmultiple',
							'completemultiple', 'canceledmultiple', 'totaluploadprogress', 'reset', 'queuecomplete'
						];
						angular.forEach(callbackMethods, function(method){
							var callback = (scope.callbacks[method] || angular.noop);
							myDropzone.on(method, function(){
								callback.apply(null, arguments);
								if(!scope.$$phase && !scope.$root.$$phase) scope.$apply();
							});
						});
					}
					myDropzone.on('error', function(file) {
						if(file.xhr && file.xhr.status==502) {
							if(addFileToDropzone) {
								myDropzone.uploadFile(file);
							}
						}
					})
					
					scope.$on('$destroy', function() {
						addFileToDropzone = false;
						myDropzone.destroy();
					})
				}
			}
		}]);
	})();


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	// This code overrides TinyMCE's default menu and tooltip behavior to prevent them from being appended to the body
	// Instead, it attaches them to their respective buttons/toolbar items
	tinymce.on('AddEditor', function(e) {
	  var editor = e.editor;
	  
	  // Wait for editor to be fully initialized before applying our overrides
	  editor.on('init', function() {
	    // Debugger timeout - helps in debugging the initialization
	    // setTimeout(function() {debugger}, 2000)
	
	    // Store original DOM methods so we can restore them later
	    // This is important for cleanup and to prevent memory leaks
	    var originalAppendChild = document.body.appendChild;
	    var originalInsertBefore = document.body.insertBefore;
	    var originalCreateElement = document.createElement;
	
	    // Helper function to identify TinyMCE menu and tooltip elements
	    // Checks if an element has any of the TinyMCE 4.x specific classes
	    function isTinyMCEElement(element) {
	      if (!element || !element.className) return false;
	      
	      var classes = element.className.split(' ');
	      return classes.some(function(className) {
	        // Check for exact matches and partial matches of TinyMCE 4.x classes
	        return className === 'mce-menu' ||
	               className === 'mce-tooltip' ||
	               className.includes('mce-menu') ||
	               className.includes('mce-tooltip');
	      });
	    }
	
	    // Helper function to find where a menu or tooltip should be attached
	    // Returns the appropriate target element (button for menus, toolbar item for tooltips)
	    function findTargetElement(element) {
	      if (!element || !element.className) return null;
	      
	      var editorContainer = editor.getContainer();
	      if (!editorContainer) return null;
	
	      var classes = element.className.split(' ');
	      // Check if this is a menu element
	      var isMenu = classes.some(function(className) {
	        return className === 'mce-menu' || className.includes('mce-menu');
	      });
	      // Check if this is a tooltip element
	      var isTooltip = classes.some(function(className) {
	        return className === 'mce-tooltip' || className.includes('mce-tooltip');
	      });
	
	      // For menus: find the button that triggered the menu (has aria-expanded="true")
	      if (isMenu) {
	        var button = editorContainer.querySelector('.mce-btn[aria-expanded="true"]');
	        if (button) {
	          return button;
	        }
	      }
	
	      // For tooltips: find the toolbar item that's being hovered
	      if (isTooltip) {
	        var target = editorContainer.querySelector('.mce-btn:hover, .mce-toolbar-item:hover');
	        if (target) {
	          return target;
	        }
	      }
	
	      return null;
	    }
	
	    // Override createElement to catch TinyMCE elements as they're created
	    // This helps prevent them from being added to the body
	    document.createElement = function(tagName) {
	      var element = originalCreateElement.call(this, tagName);
	      
	      // Use setTimeout to check the element after TinyMCE has finished setting it up
	      setTimeout(function() {
	        if (isTinyMCEElement(element) && element.parentNode === document.body) {
	          var target = findTargetElement(element);
	          if (target) {
	            target.appendChild(element);
	          }
	        }
	      }, 0);
	
	      return element;
	    };
	
	    // Override appendChild to intercept when TinyMCE tries to add elements to the body
	    document.body.appendChild = function(element) {
	      if (isTinyMCEElement(element)) {
	        var target = findTargetElement(element);
	        if (target) {
	          return target.appendChild(element);
	        }
	      }
	      return originalAppendChild.call(this, element);
	    };
	
	    // Override insertBefore to intercept when TinyMCE tries to insert elements into the body
	    document.body.insertBefore = function(element, referenceNode) {
	      if (isTinyMCEElement(element)) {
	        var target = findTargetElement(element);
	        if (target) {
	          return target.insertBefore(element, target.firstChild);
	        }
	      }
	      return originalInsertBefore.call(this, element, referenceNode);
	    };
	
	    // Create a MutationObserver to catch any elements that might slip through our overrides
	    // This is a backup mechanism to ensure no TinyMCE elements end up in the body
	    var observer = new MutationObserver(function(mutations) {
	      mutations.forEach(function(mutation) {
	        if (mutation.type === 'childList') {
	          mutation.addedNodes.forEach(function(node) {
	            if (node.nodeType === 1 && isTinyMCEElement(node) && node.parentNode === document.body) {
	              var target = findTargetElement(node);
	              if (target) {
	                target.appendChild(node);
	              }
	            }
	          });
	        }
	      });
	    });
	
	    // Start observing the body for any TinyMCE elements being added
	    observer.observe(document.body, {
	      childList: true,  // Watch for changes to the direct children
	      subtree: false    // Don't watch the entire subtree, just direct children
	    });
	
	    // Handle clicks outside menus to close them
	    // This ensures menus close when clicking elsewhere on the page
	    function handleClickOutside(e) {
	      var editorContainer = editor.getContainer();
	      if (!editorContainer) return;
	
	      // Check if click was inside a menu or button
	      var isClickInsideMenu = e.target.closest('.mce-menu, [class*="mce-menu"]');
	      var isClickInsideButton = e.target.closest('.mce-btn');
	      
	      // If click was outside both menu and button, close any open menu
	      if (!isClickInsideMenu && !isClickInsideButton) {
	        var activeButton = editorContainer.querySelector('.mce-btn[aria-expanded="true"]');
	        if (activeButton) {
	          // Just hide the menu instead of removing it
	          activeButton.setAttribute('aria-expanded', 'false');
	          var menu = activeButton.querySelector('.mce-menu, [class*="mce-menu"]');
	          if (menu) {
	            menu.style.display = 'none';
	            // Don't remove the menu from DOM
	            // if (menu.parentNode) {
	            //   menu.parentNode.removeChild(menu);
	            // }
	          }
	        }
	      }
	    }
	
	    // Add click handler to document
	    // Using capture phase (true) to ensure we handle the click before TinyMCE
	    document.addEventListener('mousedown', handleClickOutside, true);
	
	    // Add our custom CSS to style the menus and tooltips
	    var style = document.createElement('style');
	    style.textContent = 
	      /* Style for menus - position them below their buttons */
	      '.mce-toolbar-grp [class*="mce-menu"] {' +
	        'position: absolute !important;' +
	        'top: 100% !important;' +
	        'left: 0 !important;' +
	        'z-index: 10000 !important;' +
	        'margin-top: 0 !important;' +
	        'visibility: visible !important;' +
	      '}' +
	      
	      /* Style for menu items */
	      '.mce-toolbar-grp [class*="mce-menu-item"] {' +
	        'display: block !important;' +
	        'cursor: pointer !important;' +
	        'position: relative !important;' +
	        'white-space: nowrap !important;' +
	      '}' +
	      
	      /* Style for tooltips - position them below their items */
	      '.mce-toolbar-grp .mce-tooltip {' +
	        'position: absolute !important;' +
	        'top: 100% !important;' +
	        'left: 50% !important;' +
	        'transform: translateX(-50%) !important;' +
	      '}' +
	      /* Ensure tooltip text doesn't wrap */
	      '.mce-toolbar-grp .mce-tooltip-inner {' +
	        'white-space: nowrap !important;' +
	      '}' +
	
	      /* Make buttons relative for proper menu positioning */
	      '.mce-toolbar-grp .mce-btn {' +
	        'position: relative !important;' +
	      '}';
	    document.head.appendChild(style);
	
	    // Cleanup function - restore original DOM methods when editor is removed
	    // This prevents memory leaks and ensures other code isn't affected
	    editor.on('remove', function() {
	      // Restore original DOM methods
	      document.createElement = originalCreateElement;
	      document.body.appendChild = originalAppendChild;
	      document.body.insertBefore = originalInsertBefore;
	      // Remove our event listener
	      document.removeEventListener('mousedown', handleClickOutside, true);
	      // Disconnect the observer
	      observer.disconnect();
	    });
	  });
	}); 

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/**
	 * Custom Link Plugin for TinyMCE
	 * Complete replacement for the default link plugin with search post functionality
	 */
	
	(function() {
	  'use strict';
	
	  // Check if TinyMCE is available
	  if (typeof tinymce === 'undefined') {
	    return;
	  }
	
	  // Register the plugin
	  tinymce.PluginManager.add('customLink', function(editor) {
	    'use strict';
	
	    // Override the link command
	    editor.addCommand('mceLink', function() {
	      openLinkDialog();
	    });
	
	             // Override the unlink command
	    editor.addCommand('unlink', function() {
	      var selection = editor.selection;
	      var selectedNode = selection.getNode();
	      var selectedContent = selection.getContent();
	      
	      // Function to check if a node is inside embedblock or captionblock
	      function isInsideProtectedElement(node) {
	        var parent = node.parentNode;
	        while (parent && parent.nodeType === 1) {
	          if (parent.nodeName && 
	              (parent.nodeName.toLowerCase() === 'embedblock' || 
	               parent.nodeName.toLowerCase() === 'captionblock')) {
	            return true;
	          }
	          parent = parent.parentNode;
	        }
	        return false;
	      }
	      
	      // If there's selected content, process all links in the selection
	      if (selectedContent && selectedContent.trim() !== '') {
	        // Get the selection range
	        var range = selection.getRng();
	        var commonAncestor = range.commonAncestorContainer;
	        
	                 // Find all links that are ACTUALLY within the selection range
	         var allLinks = [];
	         
	         // METHOD 1: Find links that are completely within the selection
	         var selectionStart = range.startContainer;
	         var selectionEnd = range.endContainer;
	         
	         // If selection is within a single text node, check if it's inside a link
	         if (selectionStart === selectionEnd && selectionStart.nodeType === Node.TEXT_NODE) {
	           var parentLink = editor.dom.getParent(selectionStart, 'a');
	           if (parentLink && !isInsideProtectedElement(parentLink)) {
	             allLinks.push(parentLink);
	           }
	         } else {
	           // METHOD 2: Find all links in the document and check intersection
	           var allDocumentLinks = editor.dom.select('a');
	           
	           for (var i = 0; i < allDocumentLinks.length; i++) {
	             var link = allDocumentLinks[i];
	             
	             // Skip protected elements
	             if (isInsideProtectedElement(link)) {
	               continue;
	             }
	             
	             // Check if this link intersects with our selection
	             var linkRange = document.createRange();
	             linkRange.selectNodeContents(link);
	             
	             // Check for intersection using multiple methods
	             var hasIntersection = false;
	             
	             // Method A: Selection completely contains link
	             if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) <= 0 &&
	                 range.compareBoundaryPoints(Range.END_TO_START, linkRange) >= 0) {
	               hasIntersection = true;
	             }
	             // Method B: Selection starts inside link
	             else if (link.contains(range.startContainer)) {
	               hasIntersection = true;
	             }
	             // Method C: Selection ends inside link
	             else if (link.contains(range.endContainer)) {
	               hasIntersection = true;
	             }
	             // Method D: Link contains selection
	             else if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) >= 0 &&
	                      range.compareBoundaryPoints(Range.END_TO_START, linkRange) <= 0) {
	               hasIntersection = true;
	             }
	             // Method E: Check if selection and link overlap
	             else {
	               try {
	                 // Create a range for the current selection
	                 var selectionRange = document.createRange();
	                 selectionRange.setStart(range.startContainer, range.startOffset);
	                 selectionRange.setEnd(range.endContainer, range.endOffset);
	                 
	                 // Check if there's any intersection
	                 if (selectionRange.compareBoundaryPoints(Range.START_TO_END, linkRange) < 0 &&
	                     selectionRange.compareBoundaryPoints(Range.END_TO_START, linkRange) > 0) {
	                   hasIntersection = true;
	                 }
	               } catch (e) {
	                 // If range comparison fails, skip this link
	               }
	             }
	             
	             if (hasIntersection) {
	               allLinks.push(link);
	             }
	           }
	         }
	         
	        
	        // Convert to array and filter out protected elements
	        var linksToUnlink = [];
	        for (var i = 0; i < allLinks.length; i++) {
	          var link = allLinks[i];
	          if (!isInsideProtectedElement(link)) {
	            linksToUnlink.push(link);
	          }
	        }
	        
	        // Process each link for partial unlinking
	        if (linksToUnlink.length > 0) {
	          // Sort links by their position in the DOM to avoid conflicts
	          linksToUnlink.sort(function(a, b) {
	            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
	          });
	          
	                     linksToUnlink.forEach(function(linkElement) {
	             var linkText = linkElement.textContent || linkElement.innerText;
	             
	             // Create a range for the entire link
	             var linkRange = document.createRange();
	             linkRange.selectNodeContents(linkElement);
	             
	             // SIMPLIFIED OVERLAP DETECTION: Check if selection intersects with this link
	             var hasOverlap = false;
	             var overlapStart = 0;
	             var overlapEnd = linkText.length;
	             
	             // Check if selection is entirely within a text node inside the link (most common case)
	             if (range.startContainer === range.endContainer && 
	                 range.startContainer.nodeType === Node.TEXT_NODE && 
	                 linkElement.contains(range.startContainer)) {
	               
	               var selectionStartPos = range.startOffset;
	               var selectionEndPos = range.endOffset;
	               
	               // Only consider it overlap if we have a valid selection range
	               if (selectionStartPos < selectionEndPos && selectionEndPos <= linkText.length) {
	                 hasOverlap = true;
	                 overlapStart = selectionStartPos;
	                 overlapEnd = selectionEndPos;
	               }
	             }
	             // Check if selection completely contains this link
	             else if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) <= 0 &&
	                      range.compareBoundaryPoints(Range.END_TO_START, linkRange) >= 0) {
	               hasOverlap = true;
	               overlapStart = 0;
	               overlapEnd = linkText.length;
	             }
	             // Check if selection starts or ends inside this link
	             else if (linkElement.contains(range.startContainer) || linkElement.contains(range.endContainer)) {
	               hasOverlap = true;
	               
	               if (linkElement.contains(range.startContainer)) {
	                 if (range.startContainer === linkElement) {
	                   overlapStart = 0;
	                 } else if (range.startContainer.nodeType === Node.TEXT_NODE) {
	                   overlapStart = range.startOffset;
	                 }
	               }
	               
	               if (linkElement.contains(range.endContainer)) {
	                 if (range.endContainer === linkElement) {
	                   overlapEnd = linkText.length;
	                 } else if (range.endContainer.nodeType === Node.TEXT_NODE) {
	                   overlapEnd = range.endOffset;
	                 }
	               }
	               
	             }
	             
	             if (hasOverlap && (overlapStart < overlapEnd)) {
	               // Partial or full overlap - split the link
	               var beforeText = linkText.substring(0, overlapStart);
	               var selectedText = linkText.substring(overlapStart, overlapEnd);
	               var afterText = linkText.substring(overlapEnd);
	               
	               // Create new content: beforeText + selectedText + afterText
	               var newContent = [];
	               
	               if (beforeText) {
	                 // Create link for the part before selection
	                 var beforeLink = editor.dom.create('a', {
	                   href: linkElement.href,
	                   title: linkElement.title,
	                   target: linkElement.target,
	                   rel: linkElement.rel
	                 }, beforeText);
	                 newContent.push(beforeLink);
	               }
	               
	               // Add the selected text (unlinked)
	               newContent.push(editor.dom.create('text', {}, selectedText));
	               
	               if (afterText) {
	                 // Create link for the part after selection
	                 var afterLink = editor.dom.create('a', {
	                   href: linkElement.href,
	                   title: linkElement.title,
	                   target: linkElement.target,
	                   rel: linkElement.rel
	                 }, afterText);
	                 newContent.push(afterLink);
	               }
	               
	               // Replace the original link with the new content
	               if (newContent.length > 0) {
	                 editor.dom.replace(newContent[0], linkElement);
	                 for (var j = 1; j < newContent.length; j++) {
	                   editor.dom.insertAfter(newContent[j], newContent[j-1]);
	                 }
	               }
	             } else {
	               // No overlap - unlink entire link
	               editor.dom.replace(editor.dom.create('text', {}, linkText), linkElement);
	             }
	           });
	        } else {
	          // No links found in selection, check if we're inside a link
	          var parentLink = editor.dom.getParent(selectedNode, 'a');
	          if (parentLink && !isInsideProtectedElement(parentLink)) {
	            var linkText = parentLink.textContent || parentLink.innerText;
	            editor.dom.replace(editor.dom.create('text', {}, linkText), parentLink);
	          }
	        }
	        
	      } else {
	        // No selection - handle single link at cursor position (unlink entire link)
	        var isLink = selectedNode.nodeName === 'A';
	        
	        // If we're inside a link, get the link element
	        if (!isLink) {
	          var linkElement = editor.dom.getParent(selectedNode, 'a');
	          if (linkElement) {
	            isLink = true;
	            selectedNode = linkElement;
	          }
	        }
	        
	        if (isLink) {
	          // Check if the link is inside embedblock or captionblock custom elements
	          var parent = selectedNode.parentNode;
	          var shouldSkip = false;
	          
	          while (parent && parent.nodeType === 1) {
	            if (parent.nodeName && 
	                (parent.nodeName.toLowerCase() === 'embedblock' || 
	                 parent.nodeName.toLowerCase() === 'captionblock')) {
	              shouldSkip = true;
	              break;
	            }
	            parent = parent.parentNode;
	          }
	          
	          if (!shouldSkip) {
	            // Get the text content of the link
	            var linkText = selectedNode.textContent || selectedNode.innerText;
	            
	            // Replace the link with its text content
	            editor.dom.replace(editor.dom.create('text', {}, linkText), selectedNode);
	            
	            // Set selection to the text
	            selection.setCursorLocation(selectedNode);
	          }
	        }
	      }
	    });
	
	    function openLinkDialog() {
	      // Get current selection
	      var selection = editor.selection;
	      var selectedText = selection.getContent({format: 'text'});
	      var selectedNode = selection.getNode();
	      var isLink = selectedNode.nodeName === 'A';
	      
	      // If we're inside a link, get the link element
	      if (!isLink) {
	        var linkElement = editor.dom.getParent(selectedNode, 'a');
	        if (linkElement) {
	          isLink = true;
	          selectedNode = linkElement;
	        }
	      }
	
	      // Helper function to decode HTML entities from title attributes
	      function decodeTitle(title) {
	        if (!title) return '';
	        // Create a temporary element to decode HTML entities
	        var div = document.createElement('div');
	        div.innerHTML = title;
	        return div.textContent || div.innerText || '';
	      }
	
	      // Helper function to get the correct rel value for the dropdown
	      function getRelValue(rel) {
	        if (!rel) return '';
	        
	        // Split the rel attribute into individual values
	        var relValues = rel.split(' ').map(function(val) { return val.trim(); });
	        
	        // Check for nofollow or sponsored (ignore noopener as it's added automatically)
	        if (relValues.indexOf('nofollow') !== -1) {
	          return 'nofollow';
	        }
	        if (relValues.indexOf('sponsored') !== -1) {
	          return 'sponsored';
	        }
	        
	        return '';
	      }
	
	      // Create modal using TinyMCE's window manager (uses original CSS)
	      var win = editor.windowManager.open({
	        title: 'Insert/edit link',
	        body: {
	          type: 'form',
	          items: [
	            {
	              type: 'textbox',
	              name: 'url',
	              label: 'URL',
	              value: isLink ? selectedNode.href : ''
	            },
	            {
	              type: 'textbox',
	              name: 'search',
	              label: 'Search posts',
	              placeholder: 'Search...'
	            },
	            {
	              type: 'textbox',
	              name: 'text',
	              label: 'Text to display',
	              value: isLink ? (selectedNode.textContent || selectedNode.innerText) : selectedText
	            },
	            {
	              type: 'textbox',
	              name: 'title',
	              label: 'Title',
	              value: isLink ? decodeTitle(selectedNode.title) : ''
	            },
	            {
	              type: 'listbox',
	              name: 'rel',
	              label: 'Rel',
	              values: [
	                {text: 'DoFollow', value: ''},
	                {text: 'NoFollow', value: 'nofollow'},
	                {text: 'Sponsored', value: 'sponsored'}
	              ],
	              value: isLink ? getRelValue(selectedNode.rel) : ''
	            },
	            {
	              type: 'listbox',
	              name: 'target',
	              label: 'Target',
	              values: [
	                {text: 'Current window', value: ''},
	                {text: 'New window', value: '_blank'}
	              ],
	              value: isLink ? (selectedNode.target === '_blank' ? '_blank' : '') : '_blank'
	            }
	          ]
	        },
	        onsubmit: function(e) {
	          var data = e.data;
	          var text = data.text.trim();
	          var url = data.url.trim();
	          var title = data.title.trim();
	          var target = data.target;
	          var rel = data.rel;
	
	          if (!text) {
	            alert('Please enter text to display');
	            return;
	          }
	
	          // If no URL is provided, just close the modal (like native TinyMCE)
	          if (!url) {
	            return;
	          }
	
	          // Add noopener to rel when target is _blank
	          if (target === '_blank') {
	            if (rel && rel !== '') {
	              // Check if noopener is already present
	              if (rel.indexOf('noopener') === -1) {
	                rel = rel + ' noopener';
	              }
	            } else {
	              rel = 'noopener';
	            }
	          }
	
	          // Insert or update the link
	          var selection = editor.selection;
	          var selectedNode = selection.getNode();
	          var isLink = selectedNode.nodeName === 'A';
	          
	          // If we're inside a link, get the link element
	          if (!isLink) {
	            var linkElement = editor.dom.getParent(selectedNode, 'a');
	            if (linkElement) {
	              isLink = true;
	              selectedNode = linkElement;
	            }
	          }
	
	          if (isLink) {
	            // Update existing link using setAttrib to avoid parsing issues
	            selectedNode.href = url;
	            editor.dom.setAttrib(selectedNode, 'data-mce-href', url);
	            if (title) {
	              editor.dom.setAttrib(selectedNode, 'title', title);
	            } else {
	              editor.dom.setAttrib(selectedNode, 'title', null);
	            }
	            editor.dom.setAttrib(selectedNode, 'target', target);
	            editor.dom.setAttrib(selectedNode, 'rel', rel);
	            selectedNode.textContent = text;
	          } else {
	                         // Insert new link - wrap selected text with link
	             var selectedContent = selection.getContent();
	             
	             if (selectedContent && selectedContent.trim() !== '') {
	               // ✅ FIXED: Preserve trailing whitespace from selection
	               var trailingWhitespace = '';
	               
	               // Check if the selected content ends with whitespace
	               if (selectedContent.match(/\s+$/)) {
	                 var whitespaceMatch = selectedContent.match(/(\s+)$/);
	                 if (whitespaceMatch) {
	                   trailingWhitespace = whitespaceMatch[1];
	                 }
	               }
	               
	               // Create the link HTML with the selected text content (without trailing whitespace)
	               var linkHtml = '<a href="' + url + '"';
	               if (title) {
	                 linkHtml += ' title="' + title.replace(/"/g, '&quot;') + '"';
	               }
	               if (target) {
	                 linkHtml += ' target="' + target + '"';
	               }
	               if (rel) {
	                 linkHtml += ' rel="' + rel + '"';
	               }
	               linkHtml += '>' + text + '</a>';
	               
	               // Replace selection with link + preserved whitespace
	               var finalContent = linkHtml + trailingWhitespace;
	               selection.setContent(finalContent);
	            } else {
	              // No selection, insert link at cursor position
	              var linkHtml = '<a href="' + url + '"';
	              if (title) {
	                linkHtml += ' title="' + title.replace(/"/g, '&quot;') + '"';
	              }
	              if (target) {
	                linkHtml += ' target="' + target + '"';
	              }
	              if (rel) {
	                linkHtml += ' rel="' + rel + '"';
	              }
	              linkHtml += '>' + text + '</a>';
	              
	              editor.insertContent(linkHtml);
	            }
	          }
	        }
	      });
	
	      // Fix modal width and spacing after window is created
	      setTimeout(function() {
	        var modalWindow = document.querySelector('.mce-window[aria-label="Insert/edit link"]');
	        if (modalWindow) {
	          modalWindow.style.width = '469px';
	          modalWindow.style.minWidth = '469px';
	          modalWindow.style.maxWidth = '469px';
	          modalWindow.style.height = '350px';
	        }
	        
	        // Fix the modal body
	        var modalBody = modalWindow ? modalWindow.querySelector('.mce-window-body') : null;
	        if (modalBody) {
	          modalBody.style.width = '469px';
	          modalBody.style.height = '260px';
	        }
	        
	        // Fix the main form container
	        var mainForm = modalWindow ? modalWindow.querySelector('.mce-form') : null;
	        if (mainForm) {
	          mainForm.style.width = '469px';
	          mainForm.style.height = '260px';
	        }
	        
	        var mainFormBody = mainForm ? mainForm.querySelector('.mce-container-body') : null;
	        if (mainFormBody) {
	          mainFormBody.style.width = '469px';
	          mainFormBody.style.height = '260px';
	        }
	        
	        // Fix the extra nested form container
	        var nestedForm = modalWindow ? modalWindow.querySelector('.mce-form .mce-form') : null;
	        if (nestedForm) {
	          nestedForm.style.left = '0px';
	          nestedForm.style.top = '0px';
	          nestedForm.style.width = '469px';
	          nestedForm.style.height = '260px';
	        }
	        
	        var nestedFormBody = nestedForm ? nestedForm.querySelector('.mce-container-body') : null;
	        if (nestedFormBody) {
	          nestedFormBody.style.width = '469px';
	          nestedFormBody.style.height = '260px';
	        }
	        
	        // Fix the footer
	        var footer = modalWindow ? modalWindow.querySelector('.mce-foot') : null;
	        if (footer) {
	          footer.style.width = '469px';
	        }
	        
	        var footerBody = footer ? footer.querySelector('.mce-container-body') : null;
	        if (footerBody) {
	          footerBody.style.width = '469px';
	        }
	        
	        // Fix form items to use full width like original
	        var formItems = modalWindow ? modalWindow.querySelectorAll('.mce-formitem') : [];
	        formItems.forEach(function(formItem, index) {
	          formItem.style.width = '439px';
	          formItem.style.left = '15px';
	          formItem.style.top = (15 + (index * 40)) + 'px';
	          formItem.style.height = '30px';
	          
	          var formItemBody = formItem.querySelector('.mce-container-body');
	          if (formItemBody) {
	            formItemBody.style.width = '439px';
	            formItemBody.style.height = '30px';
	          }
	          
	          // Expand input fields to match original widths
	          var inputField = formItem.querySelector('.mce-textbox');
	          if (inputField) {
	            inputField.style.width = '310px';
	          }
	          
	          var listbox = formItem.querySelector('.mce-listbox');
	          if (listbox) {
	            listbox.style.width = '318px';
	          }
	        });
	        
	        // Fix absolute end elements
	        var absEndElements = modalWindow ? modalWindow.querySelectorAll('.mce-abs-end') : [];
	        absEndElements.forEach(function(absEnd) {
	          absEnd.style.width = '0px';
	          absEnd.style.height = '0px';
	        });
	      }, 100);
	
	      // Initialize search functionality after window is created
	      setTimeout(function() {
	        var searchInput = win.find('#search')[0];
	        var urlInput = win.find('#url')[0];
	        
	        if (searchInput && urlInput) {
	          initializeSearchFunctionality(searchInput, urlInput, win);
	        }
	        
	        // Fix listbox dropdown positioning
	        var relListbox = win.find('#rel')[0];
	        var targetListbox = win.find('#target')[0];
	        
	        // Set up MutationObserver to catch dropdown creation
	        var observer = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.type === 'childList') {
	              mutation.addedNodes.forEach(function(node) {
	                if (node.nodeType === 1 && node.classList && 
	                    node.classList.contains('mce-floatpanel') && 
	                    node.classList.contains('mce-menu')) {
	                  // Hide the dropdown immediately
	                  node.style.visibility = 'hidden';
	                  
	                  // Find which listbox triggered this
	                  var activeListbox = document.querySelector('.mce-listbox.mce-active');
	                  if (activeListbox) {
	                    setTimeout(function() {
	                      fixDropdownPosition(activeListbox);
	                    }, 5);
	                  }
	                }
	              });
	            }
	          });
	        });
	        
	        // Start observing
	        observer.observe(document.body, {
	          childList: true,
	          subtree: true
	        });
	        
	        if (relListbox) {
	          relListbox.on('click', function() {
	            // The observer will handle the positioning
	          });
	        }
	        
	        if (targetListbox) {
	          targetListbox.on('click', function() {
	            // The observer will handle the positioning
	          });
	        }
	      }, 100);
	      
	      function fixDropdownPosition(listbox) {
	        var listboxEl = listbox.getEl ? listbox.getEl() : listbox;
	        if (!listboxEl) return;
	        
	        // Find the dropdown menu
	        var dropdown = document.querySelector('.mce-floatpanel.mce-menu.mce-in');
	        if (!dropdown) return;
	        
	        // Get the position of the listbox field
	        var rect = listboxEl.getBoundingClientRect();
	        
	        // Position the dropdown relative to the listbox
	        dropdown.style.left = rect.left + 'px';
	        dropdown.style.top = (rect.bottom + 2) + 'px';
	        dropdown.style.position = 'fixed';
	        dropdown.style.transform = 'none';
	        dropdown.style.width = rect.width + 'px';
	        
	        // Also fix the dropdown body width
	        var dropdownBody = dropdown.querySelector('.mce-container-body');
	        if (dropdownBody) {
	          dropdownBody.style.width = rect.width + 'px';
	        }
	        
	        // Show the dropdown after positioning
	        setTimeout(function() {
	          dropdown.style.visibility = 'visible';
	        }, 10);
	      }
	    }
	
	    function initializeSearchFunctionality(searchInput, urlInput, win) {
	      // Helper function to escape HTML entities
	      function escapeHtml(text) {
	        var div = document.createElement('div');
	        div.textContent = text;
	        return div.innerHTML;
	      }
	      
	      // Helper function to decode HTML entities
	      function decodeHtml(text) {
	        if (!text || text.length === 0) {
	          return '';
	        }
	        
	        var div = document.createElement('div');
	        div.innerHTML = text;
	        var result = div.textContent;
	        
	        return result;
	      }
	      
	      // Create results container
	      var resultsContainer = document.createElement('div');
	      resultsContainer.id = 'search-results';
	      resultsContainer.className = 'mce-menu mce-menu-align';
	      resultsContainer.style.cssText = 'position: absolute; top: calc(100% + -1px); left: 0; right: 0; background: white; border: 1px solid #ccc; max-height: 250px; margin-top:0; border-radius: 0; overflow-y: auto; z-index: 1000; display: none; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
	      
	      // Insert results container after search input
	      var searchGroup = searchInput.getEl().closest('.mce-formitem');
	      if (searchGroup) {
	        searchGroup.style.position = 'relative';
	        searchGroup.appendChild(resultsContainer);
	      }
	      
	      // Pagination variables
	      var searchPage = 0;
	      var allPosts = [];
	      var totalResults = 0;
	      var currentQuery = '';
	      
	      // Search functionality using searchPost directive
	      searchInput.on('input', function() {
	        var query = this.value().trim();
	        
	        if (query.length < 2) {
	          resultsContainer.style.display = 'none';
	          return;
	        }
	        
	        // Reset pagination for new search
	        searchPage = 0;
	        allPosts = [];
	        currentQuery = query;
	        
	        // Show loading state
	        resultsContainer.innerHTML = 
	          '<div style="padding: 10px; text-align: center; color: #666;">' +
	            '<div>Searching for posts...</div>' +
	          '</div>';
	        resultsContainer.style.display = 'block';
	        
	        // Perform search
	        performSearch(query, searchPage, false);
	      });
	      
	      // Function to perform search with pagination
	      function performSearch(query, page, isLoadMore) {
	        // Use the same approach as searchPostDirective
	        // First, we need to construct the elasticSearch URL manually since we can't access the service
	        var searchData = query;
	        
	        // Clean the search data (same logic as elasticSearch service)
	        // Remove words containing special characters
	        searchData = searchData.replace(/\b[a-zA-Z0-9ćĆčČđĐšŠžŽ]*[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]+[a-zA-Z0-9ćĆčČđĐšŠžŽ]*\b/g, '');
	        
	        // Remove all special characters for elastic search
	        searchData = searchData.replace(/[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]/g, '');
	        
	        // Trim whitespace
	        searchData = searchData.trim();
	        
	        // Split into words
	        var words = searchData.split(/\s+/);
	        
	        // Clean empty words
	        words = words.filter(function(word) { return word.length > 0; });
	        
	        var postSearch = '';
	        for(var i = 0; i < words.length; i++) {
	          if(i == 0) { 
	            if(!isNaN(words[i])) {
	              if(words[i].length >= 5) {
	                postSearch = 'id:' + words[i] + '*';
	              } else {
	                if(words[i].indexOf("*") == -1) {
	                  words[i] += '*';
	                }
	                postSearch = postSearch.concat('post_title:' + words[i]);
	              }
	            } else {
	              if(words[i].indexOf("*") == -1) {
	                words[i] += '*';
	              }
	              postSearch = postSearch.concat('post_title:' + words[i]);
	            }
	          } else {
	            if(words[i].indexOf("*") == -1) {
	              words[i] += '*';
	            }
	            postSearch = postSearch.concat('%20AND%20post_title:' + words[i]);
	          }
	        }
	        
	        // Construct the elasticSearch URL (same as searchPostDirective)
	        var baseUrl = 'https://pretraga.telegraf.rs/eklinika_posts/_search';
	        var apiUrl = baseUrl + '?q=' + postSearch + '&sort=uts:desc&from=' + page + '&size=10';
	        
	        // Make direct elasticSearch API call (same as searchPostDirective)
	        fetch(apiUrl, {
	          method: 'GET',
	          headers: {
	            'Accept': 'application/json'
	          }
	        })
	          .then(function(response) {
	            if (!response.ok) {
	              throw new Error('Network response was not ok: ' + response.status);
	            }
	            return response.json();
	          })
	          .then(function(data) {
	            // Handle elasticSearch response format (same as searchPostDirective: data.hits.hits)
	            var posts = data && data.hits && data.hits.hits ? data.hits.hits : [];
	            totalResults = data && data.hits && data.hits.total ? data.hits.total : 0;
	            
	            if (isLoadMore) {
	              // Append to existing posts
	              allPosts = allPosts.concat(posts);
	            } else {
	              // Replace posts for new search
	              allPosts = posts;
	            }
	            
	            if (allPosts.length > 0) {
	              var resultsHtml = '';
	              allPosts.forEach(function(post) {
	                var postData = post._source;
	                var postUrl = postData.url || '/post/' + post._id;
	                var postTitle = postData.post_title || 'Untitled';
	                
	                resultsHtml += 
	                  '<div class="mce-menu-item" style="padding: 8px 12px!important; white-space: normal; border-left:none; cursor: pointer; border-bottom: 1px solid #f0f0f0;" ' +
	                       'data-url="' + encodeURIComponent(postUrl) + '" data-title="' + postTitle.replace(/"/g, '&quot;') + '">' +
	                    '<div style="font-weight: bold; white-space: normal;">(' + post._id + ') - ' + postTitle.replace(/"/g, '&quot;') + '</div>' +
	                  '</div>';
	              });
	              
	              // Add Load More button if there are more results
	              if (totalResults > allPosts.length) {
	                resultsHtml += '<div class="mce-menu-item load-more-btn" style="padding: 10px 12px; text-align: center; background-color: #f8f9fa; border-bottom: none; cursor: pointer;">' +
	                    '<button style="background: #2d8ac7; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-size: 12px;">Load More</button>' +
	                  '</div>';
	              }
	              
	              resultsContainer.innerHTML = resultsHtml;
	              
	              // Add click handlers to results
	              var menuItems = resultsContainer.querySelectorAll('.mce-menu-item:not(.load-more-btn)');
	              menuItems.forEach(function(item) {
	                item.addEventListener('click', function() {
	                  var url = decodeURIComponent(this.getAttribute('data-url'));
	                  var encodedTitle = this.getAttribute('data-title');
	                  var title = encodedTitle.replace(/&quot;/g, '"');
	                  
	                  // Update URL field
	                  urlInput.value(url);
	                  
	                  // Update only the title field (not the display text)
	                  var titleInput = win.find('#title')[0];
	                  
	                  if (titleInput) {
	                    // Try multiple approaches to update the title field properly
	                    
	                    // Approach 1: Direct DOM manipulation first
	                    var domElement = titleInput.getEl();
	                    if (domElement) {
	                      domElement.value = title;
	                      domElement.setAttribute('value', title);
	                      domElement.dispatchEvent(new Event('input', { bubbles: true }));
	                      domElement.dispatchEvent(new Event('change', { bubbles: true }));
	                    }
	                    
	                    // Approach 2: Use TinyMCE field API
	                    setTimeout(function() {
	                      titleInput.value(title);
	                      titleInput.fire('change');
	                    }, 50);
	                    
	                    // Approach 3: Try using the dialog's data API
	                    try {
	                      var dialogData = win.getData();
	                      dialogData.title = title;
	                      win.setData(dialogData);
	                    } catch (e) {
	                    }
	                    
	                    // Approach 4: Force update with multiple methods
	                    setTimeout(function() {
	                      // Try setting value multiple ways
	                      titleInput.value(title);
	                      if (domElement) {
	                        domElement.value = title;
	                        domElement.setAttribute('value', title);
	                        domElement.dispatchEvent(new Event('input', { bubbles: true }));
	                        domElement.dispatchEvent(new Event('change', { bubbles: true }));
	                      }
	                      titleInput.fire('change');
	                    }, 100);
	                    
	                  } else {
	                  }
	                  
	                  // Hide results
	                  resultsContainer.style.display = 'none';
	                  
	                  // Focus on URL field
	                  urlInput.focus();
	                });
	              });
	              
	              // Add click handler for Load More button
	              var loadMoreBtn = resultsContainer.querySelector('.load-more-btn');
	              if (loadMoreBtn) {
	                loadMoreBtn.addEventListener('click', function() {
	                  searchPage += 10;
	                  performSearch(currentQuery, searchPage, true);
	                });
	              }
	            } else {
	              resultsContainer.innerHTML = 
	                '<div style="padding: 10px; text-align: center; color: #666;">' +
	                  '<div>No posts found</div>' +
	                '</div>';
	            }
	          })
	          .catch(function(error) {
	            resultsContainer.innerHTML = 
	              '<div style="padding: 10px; text-align: center; color: #666;">' +
	                '<div>Error searching posts: ' + error.message + '</div>' +
	              '</div>';
	          });
	      }
	      
	      // Hide results when clicking outside
	      document.addEventListener('click', function(e) {
	        if (!searchInput.getEl().contains(e.target) && !resultsContainer.contains(e.target)) {
	          resultsContainer.style.display = 'none';
	        }
	      });
	      
	      // Handle keyboard navigation
	      searchInput.on('keydown', function(e) {
	        if (e.keyCode === 40 || e.keyCode === 38) { // ArrowDown or ArrowUp
	          e.preventDefault();
	          var menuItems = resultsContainer.querySelectorAll('.mce-menu-item:not(.load-more-btn)');
	          var currentIndex = -1;
	          
	          // Find currently selected item
	          for (var i = 0; i < menuItems.length; i++) {
	            if (menuItems[i].classList.contains('mce-selected')) {
	              currentIndex = i;
	              break;
	            }
	          }
	          
	          if (e.keyCode === 40) { // ArrowDown
	            currentIndex = (currentIndex + 1) % menuItems.length;
	          } else { // ArrowUp
	            currentIndex = (currentIndex - 1 + menuItems.length) % menuItems.length;
	          }
	          
	          // Update selection
	          menuItems.forEach(function(item) {
	            item.classList.remove('mce-selected');
	          });
	          
	          if (menuItems[currentIndex]) {
	            menuItems[currentIndex].classList.add('mce-selected');
	          }
	        } else if (e.keyCode === 13) { // Enter
	          e.preventDefault();
	          var selectedItem = resultsContainer.querySelector('.mce-menu-item.mce-selected');
	          if (selectedItem) {
	            selectedItem.click();
	          }
	        }
	      });
	    }
	
	    // Add button to toolbar
	    editor.addButton('link', {
	      title: 'Insert/edit link',
	      cmd: 'mceLink'
	    });
	
	    // Add unlink button to toolbar
	    editor.addButton('unlink', {
	      title: 'Remove link',
	      cmd: 'unlink'
	    });
	
	    // Add menu item
	    editor.addMenuItem('link', {
	      text: 'Link',
	      cmd: 'mceLink',
	      context: 'insert'
	    });
	
	    // Add unlink menu item
	    editor.addMenuItem('unlink', {
	      text: 'Remove link',
	      cmd: 'unlink',
	      context: 'insert'
	    });
	
	    // Update toolbar state when selection changes
	    editor.on('NodeChange', function(e) {
	      try {
	        var selection = editor.selection;
	        var selectedNode = selection.getNode();
	        
	        // Check if we're inside a link
	        var linkElement = editor.dom.getParent(selectedNode, 'a');
	        var isLink = linkElement !== null;
	        
	        // Update button states using DOM manipulation since TinyMCE button API is limited
	        var toolbar = editor.getContainer().querySelector('.mce-toolbar-grp');
	        if (toolbar) {
	          // Find buttons by their command or by looking for buttons with specific text
	          var linkButton = toolbar.querySelector('.mce-btn[data-mce-command="mceLink"], .mce-btn[aria-label*="link"], .mce-btn[title*="link"]');
	          var unlinkButton = toolbar.querySelector('.mce-btn[data-mce-command="unlink"], .mce-btn[aria-label*="unlink"], .mce-btn[title*="unlink"]');
	          
	          // If we can't find by command, try to find by button text content
	          if (!linkButton) {
	            var buttons = toolbar.querySelectorAll('.mce-btn');
	            for (var i = 0; i < buttons.length; i++) {
	              var btn = buttons[i];
	              var btnText = btn.textContent || btn.innerText || '';
	              if (btnText.toLowerCase().includes('link') && !btnText.toLowerCase().includes('unlink')) {
	                linkButton = btn;
	                break;
	              }
	            }
	          }
	          
	          if (!unlinkButton) {
	            var buttons = toolbar.querySelectorAll('.mce-btn');
	            for (var i = 0; i < buttons.length; i++) {
	              var btn = buttons[i];
	              var btnText = btn.textContent || btn.innerText || '';
	              if (btnText.toLowerCase().includes('unlink')) {
	                unlinkButton = btn;
	                break;
	              }
	            }
	          }
	          
	          // Try alternative selectors for unlink button
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[data-mce-command="unlink"]');
	          }
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[title*="unlink"]');
	          }
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[aria-label*="unlink"]');
	          }
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[title*="Unlink"]');
	          }
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[aria-label*="Unlink"]');
	          }
	          
	          // Use the correct aria-label selectors based on debugging
	          if (!linkButton) {
	            linkButton = toolbar.querySelector('.mce-btn[aria-label="Insert/edit link"]');
	          }
	          if (!unlinkButton) {
	            unlinkButton = toolbar.querySelector('.mce-btn[aria-label="Remove link"]');
	          }
	          
	          // Update link button state
	          if (linkButton) {
	            if (isLink) {
	              linkButton.classList.add('mce-active');
	              linkButton.setAttribute('aria-pressed', 'true');
	            } else {
	              linkButton.classList.remove('mce-active');
	              linkButton.setAttribute('aria-pressed', 'false');
	            }
	          }
	          
	          // Update unlink button state
	          if (unlinkButton) {
	            if (isLink) {
	              unlinkButton.classList.add('mce-active');
	              unlinkButton.setAttribute('aria-pressed', 'true');
	            } else {
	              unlinkButton.classList.remove('mce-active');
	              unlinkButton.setAttribute('aria-pressed', 'false');
	            }
	          }
	        } else {
	        }
	      } catch (error) {
	      }
	    });
	  });
	})();
	    

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('pagebreak', function(editor) {
		var pageBreakClass = 'mce-pagebreak', separatorHtml = editor.getParam('pagebreak_separator', '<!--nextpage-->');
	
		var pageBreakSeparatorRegExp = new RegExp(separatorHtml.replace(/[\?\.\*\[\]\(\)\{\}\+\^\$\:]/g, function(a) {
			return '\\' + a;
		}), 'gi');
	
		var pageBreakPlaceHolderHtml = '<img src="' + tinymce.Env.transparentSrc + '" class="' +
			pageBreakClass + '" data-mce-resize="false" data-mce-placeholder />';
	
		// Register commands
		editor.addCommand('mcePageBreak', function() {
			if (editor.settings.pagebreak_split_block) {
				editor.insertContent('<p>' + pageBreakPlaceHolderHtml + '</p>');
			} else {
				editor.insertContent(pageBreakPlaceHolderHtml);
			}
		});
	
		// Register buttons
		editor.addButton('pagebreak', {
			title: 'Page break',
			cmd: 'mcePageBreak'
		});
	
		editor.addMenuItem('pagebreak', {
			text: 'Page break',
			icon: 'pagebreak',
			cmd: 'mcePageBreak',
			context: 'insert'
		});
	
		editor.on('ResolveName', function(e) {
			if (e.target.nodeName == 'IMG' && editor.dom.hasClass(e.target, pageBreakClass)) {
				e.name = 'pagebreak';
			}
		});
	
		editor.on('click', function(e) {
			e = e.target;
	
			if (e.nodeName === 'IMG' && editor.dom.hasClass(e, pageBreakClass)) {
				editor.selection.select(e);
			}
		});
	
		editor.on('BeforeSetContent', function(e) {
			e.content = e.content.replace(pageBreakSeparatorRegExp, pageBreakPlaceHolderHtml);
		});
	
		editor.on('PreInit', function() {
			editor.serializer.addNodeFilter('img', function(nodes) {
				var i = nodes.length, node, className;
	
				while (i--) {
					node = nodes[i];
					className = node.attr('class');
					if (className && className.indexOf('mce-pagebreak') !== -1) {
						// Replace parent block node if pagebreak_split_block is enabled
						var parentNode = node.parent;
						if (editor.schema.getBlockElements()[parentNode.name] && editor.settings.pagebreak_split_block) {
							parentNode.type = 3;
							parentNode.value = separatorHtml;
							parentNode.raw = true;
							node.remove();
							continue;
						}
	
						node.type = 3;
						node.value = separatorHtml;
						node.raw = true;
					}
				}
			});
		});
	});


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/**
	 * JavaScript port of wpautop
	 * @see: http://develop.svn.wordpress.org/trunk/src/wp-includes/formatting.php
	 */
	
	/**
	 * Newline preservation help function for wpautop
	 *
	 * @since 3.1.0
	 * @access private
	 *
	 * @param array $matches preg_replace_callback matches array
	 * @return string
	 */
	 function _autop_newline_preservation_helper( matches ) {
	    return matches[0].replace( "\n", "<WPPreserveNewline />" );
	  }
	  
	  /**
	   * Replaces double line-breaks with paragraph elements.
	   *
	   * A group of regex replaces used to identify text formatted with newlines and
	   * replace double line-breaks with HTML paragraph tags. The remaining
	   * line-breaks after conversion become <<br />> tags, unless $br is set to '0'
	   * or 'false'.
	   *
	   * @since 0.71
	   *
	   * @param string pee The text which has to be formatted.
	   * @param bool br Optional. If set, this will convert all remaining line-breaks after paragraphing. Default true.
	   * @return string Text which has been converted into correct paragraph tags.
	   */
	  function wpautop(pee, br) {
	  
	    if(typeof(br) === 'undefined') {
	      br = true;
	    }
	  
	    var pre_tags = new Map;
	    if ( pee.trim() === '' ) {
	      return '';
	    }
	  
	    pee = pee + "\n"; // just to make things a little easier, pad the end
	    if ( pee.indexOf( '<pre' ) > -1 ) {
	      var pee_parts = pee.split( '</pre>' );
	      var last_pee = pee_parts.pop()
	      pee = '';
	      pee_parts.forEach(function(pee_part, index) {
	        var start = pee_part.indexOf( '<pre' );
	  
	        // Malformed html?
	        if ( start === -1 ) {
	          pee += pee_part;
	          return;
	        }
	  
	        var name = "<pre wp-pre-tag-" + index + "></pre>";
	        pre_tags[name] = pee_part.substr( start ) + '</pre>';
	        pee += pee_part.substr( 0, start ) + name;
	  
	      });
	  
	      pee += last_pee;
	    }
	  
	    pee = pee.replace(/<br \/>\s*<br \/>/, "\n\n");
	  
	    // Space things out a little
	    var allblocks = '(?:table|thead|tfoot|col|colgroup|tbody|tr|td|th|dl|dd|dt|ul|ol|li|pre|form|map|area|address|math|style|p|h[1-6]|hr|fieldset|legend|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)';
	    pee = pee.replace( new RegExp('(<' + allblocks + '[^>]*>)', 'gmi'), "\n$1");
	    pee = pee.replace( new RegExp('(</' + allblocks + '>)', 'gmi'), "$1\n\n");
	    pee = pee.replace( /\r\n|\r/, "\n" ) // cross-platform newlines
	    pee = pee.replace(/\n\n\s*\n\n/gmi, '\n\n\&nbsp;\n\n') // da ostane prazan paragraf
	    if ( pee.indexOf( '<option' ) > -1 ) {
	      // no P/BR around option
	      pee = pee.replace( /\s*<option'/gmi, '<option');
	      pee = pee.replace( /<\/option>\s*/gmi, '</option>');
	    }
	  
	    if ( pee.indexOf('</object>') > -1 ) {
	      // no P/BR around param and embed
	      pee = pee.replace( /(<object[^>]*>)\s*/gmi, '$1');
	      pee = pee.replace( /\s*<\/object>/gmi, '</object>' );
	      pee = pee.replace( /\s*(<\/?(?:param|embed)[^>]*>)\s*/gmi, '$1');
	    }
	  
	    if ( pee.indexOf('<source') > -1 || pee.indexOf('<track') > -1 ) {
	      // no P/BR around source and track
	      pee = pee.replace( /([<\[](?:audio|video)[^>\]]*[>\]])\s*/gmi, '$1');
	      pee = pee.replace( /\s*([<\[]\/(?:audio|video)[>\]])/gmi, '$1');
	      pee = pee.replace( /\s*(<(?:source|track)[^>]*>)\s*/gmi, '$1');
	    }
	  
	    pee = pee.replace(/\n\n+/gmi, "\n\n"); // take care of duplicates
	  
	    // make paragraphs, including one at the end
	    var pees = pee.split(/\n\s*\n/);
	    pee = '';
	    pees.forEach(function(tinkle) {
	      pee += '<p>' + tinkle.replace( /^\s+|\s+$/g, '' ) + "</p>\n";
	    });
	  
	    pee = pee.replace(/<p>\s*<\/p>/gmi, ''); // under certain strange conditions it could create a P of entirely whitespace
	    pee = pee.replace(/<p>([^<]+)<\/(div|address|form)>/gmi, "<p>$1</p></$2>");
	    pee = pee.replace(new RegExp('<p>\s*(</?' + allblocks + '[^>]*>)\s*</p>', 'gmi'), "$1", pee); // don't pee all over a tag
	    pee = pee.replace(/<p>(<li.+?)<\/p>/gmi, "$1"); // problem with nested lists
	    // pee = pee.replace(/<p><blockquote([^>]*)>/gmi, "<blockquote$1><p>");
	    // pee = pee.replace(/<\/blockquote><\/p>/gmi, '</p></blockquote>');
	    pee = pee.replace(new RegExp('<p>\s*(</?' + allblocks + '[^>]*>)', 'gmi'), "$1");
	    pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)\s*</p>', 'gmi'), "$1");
	  
	    if ( br ) {
	      pee = pee.replace(/<(script|style)(?:.|\n)*?<\/\\1>/gmi, _autop_newline_preservation_helper); // /s modifier from php PCRE regexp replaced with (?:.|\n)
	      pee = pee.replace(/(<br \/>)?\s*\n/gmi, "<br />\n"); // optionally make line breaks
	      pee = pee.replace( '<WPPreserveNewline />', "\n" );
	    }
	  
	    pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)\s*<br />', 'gmi'), "$1");
	    pee = pee.replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)[^>]*>)/gmi, '$1');
	    pee = pee.replace(/\n<\/p>$/gmi, '</p>');
	  
	    if ( Object.keys(pre_tags).length ) {
	      pee = pee.replace( new RegExp( Object.keys( pre_tags ).join( '|' ), "gi" ), function (matched) {
	        return pre_tags[matched];
	      });
	    }
	  
	    return pee;
	  }
	  
	  module.exports = wpautop;
	  

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var ads = angular.module('adsModule',[
		'ui.router',
		'servicesModule',
		'ngResource'
	]);
	__webpack_require__(479)(ads);
	__webpack_require__(480)(ads);
	__webpack_require__(477)(ads);
	__webpack_require__(478)(ads);
	__webpack_require__(481)(ads);
	__webpack_require__(484)(ads);
	__webpack_require__(483)(ads);
	__webpack_require__(482)(ads);


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	module.exports = function(ads) {
	  "use strict";
		ads
	    .controller('adsTxtController', adsTxtController)
	
		adsTxtController.$inject = ["$http","getDataService", "refreshtokenService","alertService","serverError", "API_URL","offlineError"];
		
	  function adsTxtController($http,getDataService,refreshtokenService, alertService,serverError, API_URL, offlineError) {
	    var vmat = this;
	    vmat.saveChanges = function() {
	      
	      var putFunction = function() {
	        $http.put(API_URL + 'options/authorized-digital-sellers' , {'txt':vmat.adsTxt})
	        .success(function (data, status, headers) {
	            alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      putFunction();
	    }
	    var getFunction = function() { 
	      getDataService.get({
	        param1: 'options',
	        param2: 'authorized-digital-sellers'   
	      }).$promise.then(function(data){
	        vmat.adsTxt = data.txt
	      },function(error){
	        if(!window.navigator.onLine) {
	          offlineError('refresh')
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                getFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }  
	      });
	    }
	    getFunction();
	  } 
	}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ads) {
		'use strict'
		ads.directive('adsTxtDir',adsTxtDir);
		adsTxtDir.$inject=[];
		function adsTxtDir() {
			return {
				template: __webpack_require__(254),
				controller:'adsTxtController',
				controllerAs:'vmat',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	module.exports = function(ads) {
	  "use strict";
		ads
	    .controller('bannerSliderController', bannerSliderController)
	
		bannerSliderController.$inject = ["jQuery","config","$http", "$rootScope","$scope","getDataService","$state", "refreshtokenService","alertService","$timeout","postDataService","serverError", "API_URL","createRandomHash","authtokenService", "offlineError"];
		
	  function bannerSliderController(jQuery,config,$http,$rootScope,$scope,getDataService,$state,refreshtokenService, alertService, $timeout, postDataService,serverError, API_URL,createRandomHash, authtokenService, offlineError) {
	    var vmbs = this;
	    vmbs.config = config;
	    var token = authtokenService.getToken();
	    vmbs.widgetItems= [];
	    vmbs.requiredTitle = false;
	    vmbs.dropzone = {};
	    vmbs.requiredField = {
	      url:{},
	      images:{
	        incorect:{},
	        mob:{},
	        des:{}
	      }
	    }
	    vmbs.removeImage = function(item,type) {
	      delete item.images[type];
	    }
	    vmbs.removeItem= function(index) {
	      if(vmbs.widgetItems.length==1) {
	        alertService('danger','Opps! ', 'Minimum number of items is 1.')
	        return
	      }
	      vmbs.widgetItems.splice(index,1)
	      alertService('success','Success ', 'Banner slider item has been deleted.', 2000);
	      $timeout(function() {
	        vmbs.saveChanges()
	      },0)
	    }
	    function initalizedDropzone(item) {
	      vmbs.dropzone[item.id]={
	        dzOptions : {
	          url :API_URL+'upload/banner-slider',
	          paramName : 'photo',
	          maxFilesize : '500',
	          parallelUploads: 100,
	          acceptedFiles : 'image/jpeg, images/jpg, image/png',
	          addRemoveLinks : true,
	          autoProcessQueue : false,
	          dictInvalidFileType: 'This file type is not supported.',
	          dictFileTooBig:'File size too Big',
	          headers:{
	            'x-auth': token  
	          }
	        }
	      }
	      vmbs.dropzone[item.id].dzCallbacks = {
	        'addedfile' : function(file){
	          vmbs.requiredField.images.incorect[item.id] = false;
	          if((file.name.includes('-des.jpg') || file.name.includes('-mob.jpg'))) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                token = authtokenService.getToken();
	                vmbs.dropzone[item.id].dzOptions.headers['x-auth'] = token;
	                vmbs.dropzone[item.id].dzMethods.processQueue();
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else {
	            vmbs.dropzone[item.id].dzMethods.removeFile(file);
	            vmbs.requiredField.images.incorect[item.id] = true;
	          }
	        },
	        'success' : function(file, xhr, response){
	          var data = JSON.parse(response.currentTarget.response);
	          if(data.des && file.name.includes('-des.jpg')) {
	            item.images.des = data.des
	            vmbs.requiredField.images.des[item.id] = false;
	          } else if(data.mob && file.name.includes('-mob.jpg')){
	            item.images.mob = data.mob
	            vmbs.requiredField.images.mob[item.id] = false;
	          }
	          $timeout(function() {
	            vmbs.dropzone[item.id].dzMethods.removeFile(file);
	          },1000)
	        },
	        'error' : function(file,message) {
	          if(message && message.error && message.error.message) {
	            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
	          }
	        },
	        'sending':function(file, xhr, formData) {
	        }
	      }
	    }
	    vmbs.addItem = function() {
	      var item = {
	        url:'',
	        id: createRandomHash(10),
	        images:{}
	      }
	      vmbs.widgetItems.push(item)
	      vmbs.requiredField.url[item.id] = false;
	      vmbs.requiredField.images.incorect[item.id] = false;
	      vmbs.requiredField.images.des[item.id] = false;
	      vmbs.requiredField.images.mob[item.id] = false; 
	      initalizedDropzone(item)
	    }
	    function validateProp(arr) {
	      var validate = true;
	      if(!vmbs.bannerSliderTitle) {
	        validate = false;
	        vmbs.requiredTitle = true;
	      } else {
	        vmbs.requiredTitle = false;
	      }
	      for(var i = 0;i<arr.length;i++) {
	        if(!arr[i].url) {
	          validate = false
	          vmbs.requiredField.url[arr[i].id] = true;
	        } else {
	          vmbs.requiredField.url[arr[i].id] = false;
	        }
	        if(!arr[i].images.des) {
	          validate = false
	          vmbs.requiredField.images.des[arr[i].id] = true;
	        } else {
	          vmbs.requiredField.images.des[arr[i].id] = false;
	        }
	        if(!arr[i].images.mob) {
	          validate = false
	          vmbs.requiredField.images.mob[arr[i].id] = true;
	        } else {
	          vmbs.requiredField.images.mob[arr[i].id] = false;
	        }
	
	      }
	      if(!validate) return false;
	      return true
	    }
	    function deleteOrUpdateProp(arr) {
	      for(var i = 0;i<arr.length;i++) {
	        delete arr[i].order;
	        delete arr[i].id;
	        if(arr[i].image) {
	          arr[i].image = arr[i].image['_id']
	        }
	      }
	    } 
	    vmbs.saveChanges = function() {
	      var widget = angular.copy(vmbs.widgetItems)
	      if(!validateProp(widget)) return  
	      $rootScope.hasLoaded = false;
	      deleteOrUpdateProp(widget)
	      var updateData = {
	        'title': vmbs.bannerSliderTitle,
	        'items':widget
	      }
	      var postFunction = function() {
	        postDataService.save({
	          param1:'widgets', 
	          param2: 'banner-slider', 
	        },updateData).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                postFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    var getFunction = function() { 
	      getDataService.get({
	        param1: 'widgets',
	        param2: 'banner-slider'   
	      }).$promise.then(function(data){
	        vmbs.widgetItems = data.items;
	        for(var i = 0; i<vmbs.widgetItems.length;i++) {
	          vmbs.widgetItems[i].id = createRandomHash(10);
	          vmbs.requiredField.url[vmbs.widgetItems[i].id] = false;
	          initalizedDropzone(vmbs.widgetItems[i])
	        }
	        vmbs.bannerSliderTitle = data.title;
	      },function(error){
	        if(!window.navigator.onLine) {
	          offlineError('refresh')
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                getFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }  
	      });
	    }
	    getFunction();
	  } 
	}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ads) {
		'use strict'
		ads.directive('bannerSliderDir',bannerSliderDir);
		bannerSliderDir.$inject=[];
		function bannerSliderDir() {
			return {
				template: __webpack_require__(255),
				controller:'bannerSliderController',
				controllerAs:'vmbs',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	
	module.exports = function(ads) {
	    "use strict";
	      ads
	      .controller('adsSettingsController', adsSettingsController)
	  
	      adsSettingsController.$inject = ["$http","getDataService", "refreshtokenService","alertService","serverError", "API_URL","offlineError"];
	      
	    function adsSettingsController($http,getDataService,refreshtokenService, alertService,serverError, API_URL, offlineError) {
	        var vmas = this;
	        vmas.positions = [];
	        vmas.save = function() {
	            var data = {}
	            vmas.positions.forEach(function(item){
	              if(item.getItems) {
	                data[item.id] = {}
	                data[item.id]['items'] = item.getItems()
	                data[item.id]['post_ids'] = item.post_ids
	              }
	            })
	            data.midas_display = vmas.midas_display
	            data.video_autoplay = vmas.video_autoplay
	            var putFunction = function() {
	                $http.put(API_URL + 'options/ads/settings' , data)
	                .success(function (data, status, headers) {
	                    alertService('success','Success ', data.message, 2000);
	                })
	                .error(function (data, status, header, config) {
	                  if(!window.navigator.onLine) {
	                    offlineError()
	                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                    return
	                  }
	                  if(status ==401) {
	                    var promise = refreshtokenService.getAccessToken();
	                    promise.then(
	                      function(answer) {
	                        if(answer==200) {   
	                          putFunction();
	                        }
	                      },
	                      function(error) {
	                        // report something
	                      },
	                      function(progress) {
	                       // report progress
	                    });
	                  }else if(status ==502) {
	                    serverError();
	                  } else {  
	                    alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	                  }
	                });
	            }
	            putFunction();
	        }
	        var getAdsSettings = function() {
	            getDataService.get({
	              param1: 'options',
	              param2: 'ads',
	              param3: 'settings'
	              }).$promise.then(function(data){
	                if(data.positions && data.positions.length>0) {
	                  vmas.positions = data.positions
	                }
	                vmas.video_autoplay = data.video_autoplay
	                vmas.midas_display = data.midas_display
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError('refresh')
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {
	                      getAdsSettings();
	                    }
	                    // do something
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                  });
	              } else if(error.status ==502) {
	                  serverError()
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              
	            });
	        }
	        var getCategoriesFunction = function() {
	            getDataService.get({param1:'categories', param2: null, tree:1, src:'adosettings'}).$promise.then(function(data){      
	              vmas.categories = data.categories;
	              getAdsSettings()
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                return
	              }
	              if(error.status == 401) {
	                var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {
	                        getCategoriesFunction();
	                      }
	                    },
	                    function(error) {
	                      // report something
	                    },
	                    function(progress) {
	                     // report progress
	                    });
	              } else if(error.status ==502) {
	                serverError()
	              }
	            });
	        }
	        getCategoriesFunction();
	    } 
	  }

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ads) {
		'use strict'
		ads.directive('adItem',adItem);
		adItem.$inject=["checkArray","keyPressOnlyNumberAndDot",'$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
		function adItem(checkArray,keyPressOnlyNumberAndDot,$timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
			return {
				restrict: 'E',
				scope:{
					ad:'=',
	                categories:'='
				},
				replace:true,
				template: __webpack_require__(256),
				link: function(scope, ele, $attrs, ctrl) {
					scope.selectedCategory = {value:'default'};
	                scope.checkedItems = [];
	                scope.categoriesCopy = angular.copy(scope.categories)
	                scope.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
	                scope.addPostIdHandler = function (postId) {
	                    if(!postId) {
	                        scope.postIdRequired = true 
	                    } else {
	                        scope.postIdRequired = false;
	                        if(!checkArray.contains.call(scope.ad.post_ids,postId)) {
	                            scope.ad.post_ids.push(postId);
	                            scope.addPostId = null;
	                            scope.existPostId = false;
	                        } else {
	                            scope.existPostId = true;
	                        }
	                    }
	                }
	                scope.removeFromPostList = function(index) {
	                    scope.ad.post_ids.splice(index, 1);
	                }
	                function checkArrayItems(children, boll){
	                    children.forEach(function(item){
	                        if(item.children && item.children.length>0) {
	                            checkArrayItems(item.children, boll)
	                        }
	                        item.open = false;
	                        if(!item.disabled) {
	                            item.checked = boll;
	                        }
	                    })
	
	                }
	                scope.switchCategories = function(categoryId) {
	                    if(categoryId=='default') return
	                    if(categoryId == 'all') {
	                        scope.checkedItems = []
	                        scope.categoriesCopy.filter(function(item){
	                            return item._id != 'uncategorized'
	                        }).map(function(item){
	                            if(item.children && item.children.length>0) {
	                                checkArrayItems(item.children, true)
	                            }
	                            if(!item.disabled) {
	                                item.checked = true;
	                            }
	                            item.open = false;
	                            scope.checkedItems.push(item)
	                            return item.selected = true
	                        })    
	                    } else if(categoryId == 'none') {
	                        scope.categoriesCopy.map(function(item){
	                            if(item.children && item.children.length>0) {
	                                checkArrayItems(item.children, false)
	                            }
	                            if(!item.disabled) {
	                                item.checked = false;
	                            }
	                            scope.checkedItems = [];
	                            return item.selected = false
	                        })
	                    } else {
	                        scope.categoriesCopy.map(function(item){
	                            if(item._id ==categoryId){
	                                if(item.children && item.children.length>0) {
	                                    checkArrayItems(item.children, true)
	                                }
	                                item.open = false;
	                                if(!item.disabled) {
	                                    item.checked = true;
	                                }
	                                scope.checkedItems.push(item)
	                                return item.selected = true
	                            }
	                        })
	                    }
	                    scope.selectedCategory = {value:'default'};
	                }
	                scope.removeItem = function(itemId) {
	                    scope.checkedItems.splice(scope.checkedItems.findIndex(function(item){
	                        return item._id == itemId
	                    }), 1);
	                    scope.categoriesCopy.map(function(item) {
	                    if(item._id==itemId) {
	                        if(item.children && item.children.length>0) {
	                            checkArrayItems(item.children, false)
	                        }
	                        item.open = false;
	                        return item.selected = false
	                    }
	                    })
	                }
	                function populateAdItemsChecked(children,adItem, firstAncestors) {
	                    children.forEach(function(item){
	                        if(item._id == adItem) {
	                            item.checked = true;
	                            if(!firstAncestors.selected) {
	                                firstAncestors.selected = true
	                            }
	                        } else {
	                            if(item.children && item.children.length>0) {
	                                populateAdItemsChecked(item.children, adItem, firstAncestors)
	                            }
	                        }
	                    })
	        
	                }
	                function populateAdItems(items) {
	                    scope.categoriesCopy.forEach(function(category) {
	                        items.forEach(function(item){
	                            if(item == category._id) {
	                                category.checked = true;
	                                category.selected = true;
	                            } else {
	                                if(category.children && category.children.length>0) {
	                                    populateAdItemsChecked(category.children, item, category)
	                                }
	                            }
	                        })
	                        if(category.selected) {
	                            scope.checkedItems.push(category)
	                        }
	                    })
	                }
	                if(scope.ad.items && scope.ad.items.length>0) {
	                    populateAdItems(scope.ad.items)
	                }
	                if(!scope.ad.post_ids) {
	                    scope.ad.post_ids = []
	                }
	                scope.ad.getItems = function() {
	                    var checkedId = []
	                    function pushToSaveAdItems(children) {
	                        children.forEach(function(item){
	                            if(item.checked) {
	                                checkedId.push(item._id) 
	                            }
	                            if(item.children && item.children.length>0) {
	                                pushToSaveAdItems(item.children)
	                            }
	                        })
	                    }
	                    scope.checkedItems.forEach(function(item){
	                        if(item.checked) {
	                            checkedId.push(item._id)
	                        }
	                        if(item.children && item.children.length>0) {
	                            pushToSaveAdItems(item.children)
	                        }
	                    })
	                    return checkedId
	                }
				}
			}
		}
	}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ads) {
		'use strict'
		ads.directive('adsCategoryAccordion',adsCategoryAccordion);
		adsCategoryAccordion.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
		function adsCategoryAccordion($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
			return {
				restrict: 'E',
				scope:{
					categories:'=',
					open:'=',
					removeItem: '='
				},
				replace:true,
				template: __webpack_require__(257),
				link: function(scope, ele, $attrs, ctrl) {
					// Add the hasCheckedDescendant function
					scope.hasCheckedDescendant = function(category) {
						if (!category.children || category.children.length === 0) {
							return false;
						}
						
						// Check direct children
						for (var i = 0; i < category.children.length; i++) {
							if (category.children[i].checked) {
								return true;
							}
							
							// Check descendants recursively
							if (hasDescendantsChecked(category.children[i])) {
								return true;
							}
						}
						
						return false;
					};
					
					// Helper function to check descendants recursively
					function hasDescendantsChecked(cat) {
						if (!cat.children || cat.children.length === 0) {
							return false;
						}
						
						for (var i = 0; i < cat.children.length; i++) {
							if (cat.children[i].checked) {
								return true;
							}
							
							if (hasDescendantsChecked(cat.children[i])) {
								return true;
							}
						}
						
						return false;
					}
					
					// Only watch categories at the current level - not their children
					// Child categories will be watched by their own directive instances
					if (scope.categories && scope.categories.length) {
						angular.forEach(scope.categories, function(category) {
							// Watch only this category's checked property (not its children)
							scope.$watch(function() { 
								return category.checked; 
							}, function() {
								// Empty callback is sufficient
								// The digest cycle will update the UI
							});
						});
					}
					
					// Also watch for array changes to detect new categories at this level
					scope.$watchCollection('categories', function() {
						// This will re-evaluate hasCheckedDescendant whenever
						// the categories array changes at this level
					});
				}
			}
		}
	}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ads) {
		'use strict'
		ads.directive('adsSettingsDir',adsSettingsDir);
		adsSettingsDir.$inject=[];
		function adsSettingsDir() {
			return {
				template: __webpack_require__(258),
				controller:'adsSettingsController',
				controllerAs:'vmas',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var aiModule = angular.module('aiModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'thatisuday.dropzone',
		'ngSanitize'
		
	]);
	__webpack_require__(487)(aiModule);
	__webpack_require__(486)(aiModule);
	__webpack_require__(489)(aiModule);
	__webpack_require__(488)(aiModule);

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = function(aiModule) {
		'use strict'
	    aiModule
	    .controller('aiAllConfigurationsController', aiAllConfigurationsController)
		aiAllConfigurationsController.$inject = ["$filter","aiModalService","$attrs","watchAllCheckboxesNgTable","removeFromOther","addToOther","warningAlertService","$timeout","config","$stateParams","$state","API_URL","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","authtokenService","serverError","comunicateBetweenViews","checkArray","$window","offlineError"];
		
	    function aiAllConfigurationsController($filter,aiModalService,$attrs,watchAllCheckboxesNgTable,removeFromOther,addToOther,warningAlertService,$timeout,config,$stateParams,$state,API_URL,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval, authtokenService,serverError,comunicateBetweenViews,checkArray,$window, offlineError) {
	        var vmaac = this;
	        if($stateParams.id) {
	            vmaac.configurationEdit = true;
	        } else {
	            vmaac.configurationEdit = false;
	        }
	        var $data;
	        vmaac.selectedFunctionality = {value: 'all'};
	        vmaac.status = 'all';
	        vmaac.searchData = {name: ''};
	
	        function applyAllFilters() {
	            var filteredData = vmaac.copydataConfigurations;
	
	            // Apply status filter
	            if (vmaac.status !== 'all') {
	                filteredData = $filter('filter')(filteredData, { active: vmaac.status === 'active' });
	            }
	
	            // Apply functionality filter
	            if (vmaac.selectedFunctionality.value !== 'all') {
	                filteredData = $filter('filter')(filteredData, function(item) {
	                    return item.functionality === vmaac.selectedFunctionality.value;
	                });
	            }
	
	            // Apply search filter
	            if (vmaac.searchData.name) {
	                filteredData = $filter('filter')(filteredData, vmaac.searchData);
	            }
	
	            vmaac.dataConfigurations = filteredData;
	            tablePopulateFunction();
	        }
	
	        vmaac.changeStatus = function(event, activeStatus) {
	            vmaac.status = activeStatus;
	            applyAllFilters();
	        }
	
	        vmaac.switchFunctionality = function(functionalityId) {
	            vmaac.selectedFunctionality.value = functionalityId;
	            applyAllFilters();
	        }
	
	        vmaac.changeSearch = function(searchData) {
	            vmaac.searchData = searchData;
	            applyAllFilters();
	        }
	
	        vmaac.clearAllFilters = function() {
	            vmaac.selectedFunctionality = {value: 'all'};
	            vmaac.status = 'all';
	            vmaac.searchData = {name: ''};
	            vmaac.dataConfigurations = vmaac.copydataConfigurations;
	            tablePopulateFunction();
	        }
	        vmaac.deleteConfiguration = function(configuration) {
	            if(configuration.active) {
	                alertService('danger','Opps! ', 'This configuration is active and cannot be deleted.');
	                return;
	            }
	            aiModalService.delete('configurations/'+ configuration._id, function(data) {
	                if(data.message) {
	                    alertService('success','Success ', data.message, 3000);
	                }
	                getConfigurations();
	            }, function(message) {
	                alertService('danger','Opps! ', message);
	            })
	        }
	        vmaac.editConfiguration = function(configurationId) {
	            vmaac.configurationEdit= true;
	            jQuery("html, body").animate({
	                scrollTop: 0
	            }, 10);
	            vmaac.configurationId = configurationId;
	            $state.transitionTo('app.ai_all_configurations', {id: vmaac.configurationId}, {
	                location: true,
	                inherit: true,
	                relative: $state.$current,
	                notify: false
	            });
	        }
	        aiModalService.get('functionality-list', function(data) {
	            if(data.results && data.results.length > 0) {
	                vmaac.functionalityList = data.results.map(function(item) {
	                    var name = item.split('-').join(' ');
	                    name = name.charAt(0).toUpperCase() + name.slice(1);
	                    return {
	                        _id: item,
	                        name: name
	                    }
	                });
	            }
	        });
	
	        var tablePopulateFunction = function() {
	            vmaac.tableParams = new NgTableParams({
	              page: 1,
	              count: 20,
	             
	            }, {
	                total:vmaac.dataConfigurations.length,
	                counts: false,
	                getData: function(params) {
	                    $data = vmaac.dataConfigurations; 
	                    $data = params.sorting() ?
	                    $filter('orderBy')($data, params.orderBy()) : $data;
	                    $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                    vmaac.dataGet = $data;
	                    jQuery('.goTo input').val("");  
	                    if(vmaac.dataConfigurations.length == 0) {
	                        $rootScope.emptyTable = true;
	                    } else {
	                        $rootScope.emptyTable = false;
	                    } 
	                    return $data; 
	                }    
	            });  
	        }
	        vmaac.getConfigurations = function(update) {
	            $rootScope.hasLoaded = false;
	            aiModalService.get('configurations',function(data){
	                vmaac.dataConfigurations = data;
	                vmaac.copydataConfigurations = angular.copy(vmaac.dataConfigurations);
	                $rootScope.hasLoaded = true;
	                if(update) {
	                    vmaac.tableParams.reload(vmaac.tableParams.page());
	                } else {
	                    tablePopulateFunction();
	                }
	            }, function(message){ 
	                alertService('danger','Opps! ', message);
	            })
	        }
	        vmaac.getConfigurations();
	        if(!window.navigator.onLine) {
	            offlineError('refresh')
	            return
	        }
	        
	    }	
	}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(aiModule) {
		'use strict'
		aiModule.directive('aiAllConfigurationsDir',aiAllConfigurationsDir);
		aiAllConfigurationsDir.$inject=[];
		function aiAllConfigurationsDir() {
			return {
				template: __webpack_require__(259),
				controller:'aiAllConfigurationsController',
				controllerAs:'vmaac',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	module.exports = function(aiModule) {
		"use strict";
	  aiModule
	  .controller('aiConfigurationController', aiConfigurationController)
		aiConfigurationController.$inject = ["keyPressOnlyNumberAndDot","$attrs","aiModalService","watchAllCheckboxesNgTable","slugifyValidator","keyPressSlugify","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
		
	    function aiConfigurationController(keyPressOnlyNumberAndDot,$attrs,aiModalService,watchAllCheckboxesNgTable,slugifyValidator,keyPressSlugify,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
	        var vmaic = this;
	        vmaic.selectedAiFunctionality = {value: 'none'};
	        vmaic.selectedAiProvider = {value: 'none'};
	        vmaic.selectedAiModel = {value: 'none'};
	        vmaic.modelList = [];
	        vmaic.providerList = [];
	        vmaic.functionalityList = [];
	        vmaic.initialStatus = false;
	        $scope.parent = $scope.$eval($attrs.parent)
	        vmaic.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
	        if($stateParams.id) {
	            vmaic.configurationId = $stateParams.id;
	        }
	        $rootScope.closeEditConfiguration = function() {
	            $scope.parent.configurationEdit = false;
	            vmaic.configuration = null;
	            $scope.parent.getConfigurations(true);
	            $state.transitionTo('app.ai_all_configurations', {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
	        }
	        aiModalService.get('functionality-list', function(data) {
	            if(data.results && data.results.length > 0) {
	                vmaic.functionalityList = data.results.map(function(item) {
	                var name = item.split('-').join(' ');
	                name = name.charAt(0).toUpperCase() + name.slice(1);
	                return {
	                    _id: item,
	                    name: name
	                }
	            });
	            }
	        });
	        vmaic.removeMessage = function(message) {
	            vmaic.configuration.extraSettings.messages.splice(vmaic.configuration.extraSettings.messages.indexOf(message), 1);
	        }
	        vmaic.addNewModel = function() {
	            if(!vmaic.newModelName) {
	                vmaic.newModelNameRequired = true;
	                alertService('danger','Opps! ', 'Model name is required');
	                return;
	            }
	            if(vmaic.selectedAiProvider.value == 'none') {
	                alertService('danger','Opps! ', 'Choose provider first');
	                return;
	            }
	            if(vmaic.modelList.find(function(item) {
	                return item.name == vmaic.newModelName;
	            })) {
	                alertService('danger','Opps! ', 'Model already exists');
	                return;
	            }
	            aiModalService.post('models', {vendor: vmaic.selectedAiProvider.value, model: vmaic.newModelName}, function(data) {
	                vmaic.modelList.push(data);
	                vmaic.newModelName = '';
	            }, function(message) {
	                alertService('danger','Opps! ', message);
	            });
	        }
	        vmaic.addNewMessage = function() {
	            vmaic.configuration.extraSettings.messages.push({
	                role: '',
	                conditionVars: '',
	                content: ''
	            });
	        }
	        
	        aiModalService.get('vendors', function(data) {
	            if(data && data.length > 0) {
	                vmaic.providerList = data;
	            }
	        });
	        vmaic.switchAiProvider = function(provider) {
	            if(provider == 'none') {
	                vmaic.modelList = [];
	                vmaic.selectedAiModel.value = 'none';
	                return;
	            }
	            getAiModels(provider);
	        }
	        function getAiModels(provider) {
	            aiModalService.get('models/'+provider, function(data) {
	                if(data && data.length > 0) {
	                    vmaic.modelList = data;
	                }
	            });
	        }
	        vmaic.updateConfiguration = function() {
	            if(!vmaic.configuration.name) {
	                alertService('danger','Opps! ', 'Name is required');
	                return;
	            }
	            if(vmaic.selectedAiProvider.value == 'none') {
	                alertService('danger','Opps! ', 'Provider is required');
	                return;
	            }
	            if(vmaic.selectedAiModel.value == 'none') {
	                alertService('danger','Opps! ', 'Model is required');
	                return;
	            }
	            if(vmaic.selectedAiFunctionality.value == 'none') {
	                alertService('danger','Opps! ', 'Functionality is required');
	                return;
	            }
	            if(vmaic.configuration.temperature == 0) {
	                alertService('danger','Opps! ', 'Temperature is required');
	                return;
	            }
	            if(!vmaic.configuration.extraSettings || 
	                !vmaic.configuration.extraSettings.messages || 
	                vmaic.configuration.extraSettings.messages.length == 0) {
	                alertService('danger','Opps! ', 'At least one message is required');
	                return;
	            }
	            var hasMessageError = vmaic.configuration.extraSettings.messages.some(function(message, index) {
	                if(!message.role) {
	                    alertService('danger','Opps! ', 'Role is required for message ' + (index + 1));
	                    return true;
	                }
	                if(!message.content) {
	                    alertService('danger','Opps! ', 'Content is required for message ' + (index + 1));
	                    return true;
	                }
	                return false;
	            });
	
	            if (hasMessageError) {
	                return;
	            }
	            var httpUrl = vmaic.newConfiguration ? 'configurations' : 'configurations/'+vmaic.configurationId;
	            var method = vmaic.newConfiguration ? 'post' : 'put';
	            aiModalService[method](httpUrl, {
	                name: vmaic.configuration.name,
	                aiProvider: vmaic.selectedAiProvider.value,
	                model: vmaic.selectedAiModel.value,
	                functionality: vmaic.selectedAiFunctionality.value,
	                temperature: parseFloat(vmaic.configuration.temperature),
	                extraSettings: vmaic.configuration.extraSettings,
	                active: vmaic.configuration.active
	            }, function(data) {
	                if(vmaic.newConfiguration) {
	                    alertService('success','Success ', 'Configuration created successfully', 2000);
	                    if(data._id) {
	                        $state.go('app.ai_all_configurations', {id:data._id});
	                    }
	                } else {
	                    vmaic.configuration = data;
	                    alertService('success','Success ', 'Configuration updated successfully', 2000);
	                }
	                
	            }, function(message) {
	                alertService('danger','Opps! ', message);
	            });
	        }
	        if(vmaic.configurationId) {
	            $rootScope.hasLoaded = false;
	            aiModalService.get('configurations/'+vmaic.configurationId,function(data){
	                $rootScope.hasLoaded = true;
	                vmaic.configuration = data;
	                vmaic.selectedAiFunctionality.value = vmaic.configuration.functionality;
	                vmaic.selectedAiProvider.value = vmaic.configuration.aiProvider;
	                vmaic.selectedAiModel.value = vmaic.configuration.model;
	                vmaic.initialStatus = vmaic.configuration.active;
	                getAiModels(vmaic.configuration.aiProvider);
	            },function(message){
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', message);
	                $scope.parent.configurationEdit = false;
	                $state.transitionTo('app.ai_all_configurations', {id:null}, {
	                    location: true,
	                    inherit: true,
	                    relative: $state.$current,
	                    notify: false
	                });
	            });
	        } else {
	            vmaic.configuration = {
	                extraSettings: {
	                    messages: [
	                        {
	                            role: '',
	                            conditionVars: '',
	                            content: ''
	                        }
	                    ]
	                },
	                active: false,
	                name: '',
	                temperature: 0.5
	            }
	            vmaic.newConfiguration = true;
	        }
	        if(!window.navigator.onLine) {
	        offlineError('refresh')
	        return
	        }
	    }	
	}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(aiModule) {
		'use strict'
	    aiModule.directive('aiConfigurationDir',aiConfigurationDir);
		aiConfigurationDir.$inject=[];
		function aiConfigurationDir() {
			return {
				template: __webpack_require__(260),
				controller:'aiConfigurationController',
				controllerAs:'vmaic',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = function(approval) {
		"use strict";
	  approval
	  .controller('allApprovalsController', allApprovalsController);
		allApprovalsController.$inject = ["$http","cleanObj","API_URL","authtokenService","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","keyPressOnlyNumber","offlineError",'downloadPdf'];
		
	  function allApprovalsController($http,cleanObj, API_URL,authtokenService,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,keyPressOnlyNumber,offlineError, downloadPdf) {
	    var vmaa = this;
	    vmaa.config = config;
	    $rootScope.emptyTable = false;
	    var state = 'approvals';
	    var page = 1;
	    var user;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var s;
	    var type;
	    var document_id;
	    var $data;
	    vmaa.status = 'all';
	    vmaa.switchDate =false;
	    vmaa.switchSearch = false;
	    // vmaa.selectedMediaAction = {value: 'default'};
	    vmaa.selectedUserFilter = {value: 'all'};
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vmaa.state = {
	      'photo':'library',
	      'post': 'allposts',
	      'video': 'allvideos'
	    };
	    vmaa.getUiSref = function(approval,id) {
	      return $state.href('app.' + vmaa.state[approval.type], {'id': id})
	    }
	    vmaa.downloadApproval = downloadPdf;
	    // vmaa.deletePosts = function(approval) {
	    //   $rootScope.hasLoaded = false;	
	    //   postDataService.save({
	    //     param1: state,
	    //     param2:'remove',
	    //     param3:approval._id,
	    //   },{
	    //     'document_ids': approval.document_ids,
	    //     'type': approval.type
	    //   }).$promise.then(function(data){
	    //     $rootScope.hasLoaded = true;
	    //     alertService('success','Success ', data.message, 2000);
	    //     vmaa.tableParams.reload();
	    //   }, function(error){
	    //     if(!window.navigator.onLine) {
	    //       offlineError()
	    //       $rootScope.hasLoaded = true;
	    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //       return
	    //     }
	    //     if(error.status ==401) {
	    //       var promise = refreshtokenService.getAccessToken();
	    //       promise.then(
	    //       function(answer) {
	    //         if(answer==200) {
	    //         unlockFunction()
	    //         }
	    //       },
	    //       function(error) {
	    //         // report something
	    //       },
	    //       function(progress) {
	    //       // report progress
	    //       });
	    //     } else if(error.status ==502) {
	    //       serverError()
	    //     } else {
	    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	    //     }
	    //     $rootScope.hasLoaded = true;
	    //   }); 
	    // }
	    var getusersFunction = function() {
	      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
	        vmaa.usersList = data.users;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getusersFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getusersFunction();
	    vmaa.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        $timeout(function() {
	          vmaa.search();
	        },0)            
	      }
	    }
	    vmaa.switchUserFilter = function(item) {
	      user = item;
	      if (item=='all') {
	        user = null;
	      }
	    }
	    vmaa.changeDate = function(value) {
	      vmaa.dateRangevalue= value;
	      vmaa.switchDate = true;
	      if(vmaa.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	        date_start = null;
	        date_end = null;
	      }
	    }
	    function reloadTableFunction () {
	      if(vmaa.tableParams.page() ==1) {
	        vmaa.tableParams.reload();
	      } else {
	        vmaa.tableParams.page(1);
	      }
	    } 
	    vmaa.mediaFilters = function() {
	      reloadTableFunction();
	    }
	    vmaa.resetAllFilters = function() {
	      vmaa.status = 'all';
	      vmaa.searchData = null;
	      s =null;
	      user = null;
	      vmaa.selectedUserFilter = {value: 'all'};
	      document_id = null;
	      type = null;
	      date_start = null;
	      date_end = null;
	      $scope.$broadcast('clear-daterange',true);
	      reloadTableFunction();
	    }
	    vmaa.userApproval = function(value) {
	      user = value;
	      reloadTableFunction();
	    }
	    vmaa.typeApproval = function(value) {
	      type = value;
	      reloadTableFunction();
	    }
	    vmaa.changeStatus =function(activeStatus) {
	      vmaa.status = activeStatus;
	      if(activeStatus =='all') {
	        type= null
	      } else {
	        type = activeStatus;
	      }
	      reloadTableFunction();
	    }
	    vmaa.search =function(value) {
	      if(value) {
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    vmaa.tableReloadFunction = function(page) { 
	      vmaa.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            page: params.page(),
	            limit: params.count(),
	            user: user,
	            s:s,
	            type:type,
	            document_id:document_id,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end
	            }).$promise.then(function(data){
	              $rootScope.hasLoaded = true;
	              $data =data.approvals;
	              $rootScope.emptyTable = false;
	              params.total(data.count);
	              params.numPages(data.max_pages);
	              jQuery('.goTo input').val("");
	              if(user) {
	                vmaa.selectedUserFilter = {value: user.toString()};
	              }
	              if(type) {
	                vmaa.status = type;
	              }
	              return $data;
	            }, function(error){
	              if(!window.navigator.onLine) {
	                $rootScope.hasLoaded = true;
	                offlineError('refresh')
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {
	                      vmaa.tableReloadFunction(params.page());
	                    }
	                    // do something
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                  });
	              } else if(error.status ==404) {
	                $rootScope.emptyTable = true;
	              } else if(error.status ==502) {
	                serverError();
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;
	            });
	          }    
	      });
	    }
	    vmaa.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(approval) {
		'use strict'
		approval.directive('allApprovalsDir',allApprovalsDir);
		allApprovalsDir.$inject=[];
		function allApprovalsDir() {
			return {
				restrict: 'E',
				template: __webpack_require__(261),
				controller:'allApprovalsController',
				controllerAs:'vmaa',
				link: function(scope, element, attrs, ctrl) {
					
				}
	
			}
		}
	}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var approval = angular.module('approvalsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap'
	]);
	
	__webpack_require__(491)(approval);
	__webpack_require__(490)(approval);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	module.exports = function(comments) {
		'use strict';
	  comments
	  .controller('allcommentsController', allcommentsController)
		allcommentsController.$inject = ["cyrilicToLatin","config","highlightWords","watchAllCheckboxesNgTable","$state","API_URL","$stateParams","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService","jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","serverError","comunicateBetweenViews", "offlineError"];
		
	  function allcommentsController(cyrilicToLatin,config,highlightWords,watchAllCheckboxesNgTable,$state,API_URL,$stateParams,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval,serverError, comunicateBetweenViews, offlineError) {
	    var vmac = this;
	    var state = 'comments';
	    var status = 'pending';
	    var $data;
	    var page;
	    vmac.postId = null;
	    vmac.status = 'pending';
	    vmac.parrent = {};
	    vmac.statusApproved = false;
	    vmac.statusTrash = false;
	    $rootScope.emptyTable = false;
	    vmac.checkedPostsEdit = [];
	    vmac.checkboxes = { 'checked': false, items: {} };
	    vmac.checkedPostsforUpdate = [];
	    vmac.checkedPostsEdit = [];
	    vmac.serchCommentsModalShow = false;
	    if($state.current.name =='app.allvideocomments') {
	      vmac.commentsType = 'video'
	    }
	    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
	      vmac.adminPermisions = true;
	    }
	    // vmac.selectedPriorityFilter = {value:'all'}
	    var arrayPostsIdFunction = function() {
	      if (vmac.checkedPostsEdit.length>0 ) {
	        for(var i=0;i<vmac.checkedPostsEdit.length;i++) {
	          vmac.checkedPostsforUpdate.push(vmac.checkedPostsEdit[i]);
	        }
	      }
	    }
	    vmac.goToPost = function(postId) {
	      if(vmac.commentsType == 'video') {
	        $state.go('app.allvideos',{id:postId});  
	      } else {
	        $state.go('app.allposts',{id:postId});
	      }
	    }
	    var putPostsFunction = function(url) {
	      var updateDataPosts = {
	        "ids": vmac.checkedPostsforUpdate,
	      }
	      $rootScope.hasLoaded = false;
	      var putFunction = function() {
	        $http.put(url , updateDataPosts)
	        .success(function (data, status, headers) {
	            alertService('success','Success ', data.message, 1000);
	            vmac.checkedPostsforUpdate = [];
	            vmac.checkedPostsEdit = [];
	            vmac.tableParams.reload();
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	           
	          }
	          vmac.checkedPostsforUpdate = [];
	          vmac.checkedPostsEdit = [];
	          $rootScope.hasLoaded = true;
	        });
	      }
	      putFunction();
	    }
	    vmac.updateStatusPost = function(post_id, status) {
	      vmac.checkedPostsforUpdate = [];
	      if(vmac.commentsType =='video') {
	        putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
	      } else {
	        putPostsFunction(API_URL + 'comments/bulk/'+status);
	      }
	      vmac.checkedPostsforUpdate.push(post_id);
	      watchAllCheckboxesNgTable.resetCheckBox(vmac)
	    }
	
	    vmac.bulkAction = function(status) {
	      vmac.checkedPostsforUpdate = [];
	      arrayPostsIdFunction();
	      if(status != "default" && vmac.checkedPostsforUpdate.length > 0) {
	        if(vmac.commentsType =='video') {
	          putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
	        } else {
	          putPostsFunction(API_URL + 'comments/bulk/'+status);
	        }
	        watchAllCheckboxesNgTable.resetCheckBox(vmac)
	        // vmac.tableParams.reload();
	      } 
	    }
	    watchAllCheckboxesNgTable.watch($scope, vmac, false, 'comment_ID')
	    vmac.checkedPost = function(postId,checked) {
	      if (checked) {
	        vmac.checkedPostsEdit.push(postId);
	      } else {
	       var index = vmac.checkedPostsEdit.indexOf(postId);
	       if(index > -1) {
	        vmac.checkedPostsEdit.splice(index, 1);
	       } 
	      }
	      
	    }
	    vmac.changeSearch = function(evt) {
	      evt = (evt) ? evt : event;
	        var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
	        ((evt.which) ? evt.which : 0));
	        if (charCode > 32 && (charCode < 48 || charCode > 57) ) {
	            evt.preventDefault();
	        }
	    }
	    vmac.searchComment = function(value) {
	      if(value) {
	        vmac.commentPostId = value;
	        vmac.serchCommentsModalShow = true;
	        $rootScope.modalShow = true;
	      }
	    } 
	    vmac.closeSearchComment = function() {
	      vmac.serchCommentsModalShow = false;
	      vmac.commentPostId = null;
	      $rootScope.modalShow = false;
	    }
	    vmac.tableActionsFunction = function(params) {
	      var reloadTableFunction = function() {
	        params.page(1);
	        vmac.tableParams.reload();
	      }
	      vmac.changeStatus =function(event,activeStatus) {
	        vmac.status = activeStatus;
	        status = activeStatus;
	        vmac.postId = null;
	        vmac.searchData = null;
	        if(activeStatus == 'approved') {
	          vmac.statusApproved = true;
	          vmac.statusTrash = false;
	        } else {
	          vmac.statusApproved = false;
	        }
	        if(activeStatus == 'trashed' || activeStatus == 'spam') {
	          vmac.statusApproved = false;
	          vmac.statusTrash = true;
	        } else {
	          vmac.statusTrash = false;
	        }
	        reloadTableFunction();
	      }
	      // vmac.switchPriorityFilter = function() {
	      //   reloadTableFunction();
	      // }
	    }
	    vmac.tableReloadFunction = function(page) {
	      vmac.tableParams = new NgTableParams({
	            page: page || 1,
	            count: 20,
	            
	        }, {
	        getData: function(params) {
	          
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            status: status,
	            // priority: (vmac.selectedPriorityFilter.value !='all')? vmac.selectedPriorityFilter.value:null, 
	            type:(vmac.commentsType == 'video')? 'video':null,
	            page: params.page(),
	            limit: params.count(),
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            }).$promise.then(function(data){
	           
	            $rootScope.emptyTable = false;
	            $rootScope.hasLoaded = true;
	            $data = data.comments;
	            vmac.dataGet = data.comments;
	            if(data.comments.length == 0) {
	              $rootScope.emptyTable = true;
	            } 
	            watchAllCheckboxesNgTable.resetCheckBox(vmac)
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            vmac.selectedBulkAction = {value: 'default'};
	            for(var i=0; i<vmac.dataGet.length;i++) {
	              vmac.parrent[vmac.dataGet[i].comment_ID] = false;
	              if(vmac.dataGet[i].parrent) {
	                vmac.parrent[vmac.dataGet[i].comment_ID] = true;
	              }
	              if(config.highlightWordsActive && config.highlightWordsDiacritics && config.highlightWordsDiacritics.length>0) {
	                vmac.dataGet[i].comment_author = cyrilicToLatin(vmac.dataGet[i].comment_author) 
	                vmac.dataGet[i].comment_author = highlightWords(vmac.dataGet[i].comment_author, config.highlightWordsDiacritics)
	                vmac.dataGet[i].comment_content = cyrilicToLatin(vmac.dataGet[i].comment_content) 
	                vmac.dataGet[i].comment_content = highlightWords(vmac.dataGet[i].comment_content, config.highlightWordsDiacritics)
	              }
	            }
	            vmac.tableActionsFunction(params);
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	               
	                if(answer==200) {
	                  vmac.tableReloadFunction(params.page());
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	            vmac.tableActionsFunction(params);
	          });
	        }    
	      });
	    }
	    vmac.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	    }
	  }	
	}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(comments) {
		'use strict'
		comments.directive('allCommentsDir',allCommentsDir);
		allCommentsDir.$inject=[];
		function allCommentsDir() {
			return {
				template: __webpack_require__(262),
				controller:'allcommentsController',
				controllerAs:'vmac',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(comments) {
		'use strict';
		comments.directive('searchComments',searchComments);
		searchComments.$inject=["cyrilicToLatin","config","highlightWords",'$http','API_URL','getDataService','$rootScope','refreshtokenService','serverError','postDataService','alertService', 'offlineError'];
		function searchComments(cyrilicToLatin,config,highlightWords,$http,API_URL,getDataService,$rootScope,refreshtokenService,serverError,postDataService,alertService, offlineError) {
			return {
				restrict: 'E',
				scope: {
			      obj:"="
			    },
			 	template: __webpack_require__(263),
			    link: function (scope, element, attrs) {
					var state = 'comments';
					scope.moderator_guide = '';
					if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
						scope.adminPermisions = true;
					}			
					if(scope.obj.serchCommentsModalShow) {
						scope.status='pending';
						var getCommentsFunction = function() {
							$rootScope.hasLoaded = false;
							scope.postComments = [];
			     			getDataService.get({
				              	param1:state,
				              	document_id:scope.obj.commentPostId,
				              	status: scope.status,
								type:(scope.obj.commentsType == 'video')? 'video':null
			              	}).$promise.then(function(data){
				                scope.postComments = data.comments;
								if(config.highlightWordsActive && config.highlightWordsDiacritics && config.highlightWordsDiacritics.length>0) {
									for(var i=0; i<scope.postComments.length;i++) {
										scope.postComments[i].data.comment_author = cyrilicToLatin(scope.postComments[i].data.comment_author) 
										scope.postComments[i].data.comment_author = highlightWords(scope.postComments[i].data.comment_author, config.highlightWordsDiacritics)
										scope.postComments[i].data.comment_content = cyrilicToLatin(scope.postComments[i].data.comment_content) 
										scope.postComments[i].data.comment_content = highlightWords(scope.postComments[i].data.comment_content, config.highlightWordsDiacritics)
									}
								}
								if(data.document) {
									scope.moderator_guide = data.document.moderator_guide
									scope.commentsPriority = data.document.comments_priority;
								}
				            	scope.emptyTable = false;
				              	$rootScope.hasLoaded = true;
			            	}, function(error){
					            if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									return
								}  
				                if(error.status ==401) {
				                	var promise = refreshtokenService.getAccessToken();
					                promise.then(
				                    function(answer) {
					                    if(answer==200) {
					                      getCommentsFunction();
					                    }
					                    // do something
					                },
					                function(error) {
					                },
					                function(progress) {
					                   // report progress
					                });
				              	} else if(error.status ==502) {
				                  serverError()
			                	} else if(error.status ==404) {
					                scope.emptyTable = true;
									scope.commentsPriority = null
					            } else {
					                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
					            }	   
				                $rootScope.hasLoaded = true;
					               
					      	});
						}
						getCommentsFunction();
						var putPostsFunction = function(url) {
					      var updateDataPosts = {
					        "ids": scope.checkedPostsforUpdate,
					      }
						  $rootScope.hasLoaded = false;
					      var putFunction = function() {
					        $http.put(url , updateDataPosts)
					        .success(function (data, status, headers) {
					            alertService('success','Success ', data.message, 500);
					            scope.checkedPostsforUpdate = [];
					            // scope.obj.tableParams.reload();
					            getCommentsFunction();
					        })
					        .error(function (data, status, header, config) {
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									scope.checkedPostsforUpdate = [];
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
					          	if(status ==401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
									function(answer) {
										if(answer==200) {   
										putFunction();
										}
									},
									function(error) {
										// report something
									},
									function(progress) {
									// report progress
									});
								}else if(status ==502) {
									serverError();
								} else {  
									alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
								
								}
								scope.checkedPostsforUpdate = [];
								$rootScope.hasLoaded = true;
					        });
					      }
					      putFunction();
					    }
					   
					    scope.updateStatusPost = function(post_id, status) {
					      scope.checkedPostsforUpdate = [];
						  if(scope.obj.commentsType =='video') {
							putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
						  } else {
							putPostsFunction(API_URL + 'comments/bulk/'+status);
						  }
					      scope.checkedPostsforUpdate.push(post_id);
					    }
					    scope.changeStatus =function(event,activeStatus) {
				          scope.status = activeStatus;
				          getCommentsFunction();			         
				        }
					}
				}    
			}
		}
	}


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var comments = angular.module('commentsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
	]);
	__webpack_require__(494)(comments);
	__webpack_require__(493)(comments);
	__webpack_require__(495)(comments);
	__webpack_require__(498)(comments);
	__webpack_require__(497)(comments);
	


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(comments) {
		'use strict'
		comments.directive('highlightWordsDir',highlightWordsDir);
		highlightWordsDir.$inject=[];
		function highlightWordsDir() {
			return {
				template: __webpack_require__(264),
				controller:'highlightWordsController',
				controllerAs:'vmhwc',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = function(comments) {
		'use strict';
	  comments
	  .controller('highlightWordsController', highlightWordsController)
		highlightWordsController.$inject = ["config","$state","API_URL","$stateParams","$http","$rootScope","refreshtokenService","alertService","putDataService","serverError", "offlineError"];
		
	  function highlightWordsController(config,$state,API_URL,$stateParams,$http,$rootScope,refreshtokenService,alertService, putDataService,serverError, offlineError) {
	    var vmhwc = this;
	    vmhwc.highlightWordsArray =  [];
	    config.highlightWordsBase.forEach(function(item,index){
	      vmhwc.highlightWordsArray.push({word:item,index:index+1})
	    })
	    vmhwc.highlightWordsCheckbox = config.highlightWordsActive
	    if(window.innerWidth<600) {
	      var numberOfColumn = 1
	    } else if(window.innerWidth>=600 && window.innerWidth<995) {
	      var numberOfColumn = 2
	    } else {
	      var numberOfColumn = 4
	    }
	    function createHighlightWordsColum(array) {
	        if(!array || array.length == 0) return
	        vmhwc.highlightWordsArrayPrepared = []
	        if(numberOfColumn != 1) {
	          if(array.length%numberOfColumn ==0) {
	            var numItemsperColumn = array.length/numberOfColumn
	          } else {
	            var numItemsperColumn = Math.floor(array.length/numberOfColumn) + 1
	          }
	          for(var i = 0;i<numberOfColumn;i++) {
	            vmhwc.highlightWordsArrayPrepared[i] = []
	          }
	        } else {
	          vmhwc.highlightWordsArrayPrepared[0] = []
	        }
	        var indexOfColumn;
	        array.forEach(function(item,index){
	          if(numberOfColumn != 1) {
	            indexOfColumn = Math.floor(index/numItemsperColumn)
	          } else {
	            indexOfColumn = 0
	          }
	          vmhwc.highlightWordsArrayPrepared[indexOfColumn].push({word:item.word,index:item.index})
	        })
	    }
	    createHighlightWordsColum(vmhwc.highlightWordsArray)
	    vmhwc.removeWord = function(index) {
	      var arrayIndex = vmhwc.highlightWordsArray.findIndex(function(obj) { 
	       return obj.index === index
	      });
	      if (arrayIndex > -1) {
	        vmhwc.highlightWordsArray.splice(arrayIndex,1)
	      }
	      if(vmhwc.searchData) {
	        vmhwc.changeSearch(vmhwc.searchData)
	      } else {
	        createHighlightWordsColum(vmhwc.highlightWordsArray)
	      }
	    }
	    vmhwc.addNewHighlightWord = function(newWord) {
	      var index = vmhwc.highlightWordsArray.findIndex(function(obj) {
	        return obj.word.toLowerCase() === newWord.toLowerCase();
	      });
	      if(index !== -1){
	        alertService('danger','Opps! ', 'Word alredy exsist');
	      } else {
	        vmhwc.highlightWordsArray.push({word:newWord})
	        vmhwc.highlightWordsArray.sort(function(a,b){
	          return a.word.toLowerCase() > b.word.toLowerCase() ? 1 : -1; 
	        })
	        vmhwc.highlightWordsArray.forEach(function(item,index){
	          item.index = index+1
	        })
	        alertService('success','Success ', 'The word was added', 2000);
	        if(vmhwc.searchData) {
	          vmhwc.changeSearch(vmhwc.searchData)
	        } else {
	          createHighlightWordsColum(vmhwc.highlightWordsArray)
	        }
	      }
	    }
	    vmhwc.changeSearch = function(searchData) {
	      if(!vmhwc.highlightWordsArray || vmhwc.highlightWordsArray.length == 0) return
	      var filteredArray = vmhwc.highlightWordsArray.filter(function(item){
	        return item.word.toLowerCase().includes(searchData.toLowerCase())
	      })
	      if(filteredArray && filteredArray.length>0) {
	        vmhwc.noSerachResult = false
	        createHighlightWordsColum(filteredArray)
	      } else {
	        vmhwc.noSerachResult = true
	      }
	    }
	    vmhwc.saveChanges = function() {
	      var words = []
	      vmhwc.highlightWordsArray.forEach(function(item){
	        words.push(item.word)
	      })
	      var saveWWords = {
	          'active':vmhwc.highlightWordsCheckbox,
	          'words': words
	      }
	      var putFunction = function() {
	        $http.put(API_URL + 'comments/highlightWords', saveWWords)
	        .success(function (data, status, headers) {
	          alertService('success','Success ', data.message, 2000);
	          config.getHighlightWords(saveWWords)
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      putFunction();
	    }
	  }	
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	var dashboard = angular.module("dashboardModule", [
		'ui.router',
		'servicesModule',
		'ngResource',
		// 'angular-rickshaw',
		// "btford.socket-io"
	]);
	__webpack_require__(501)(dashboard);
	__webpack_require__(502)(dashboard);
	__webpack_require__(500)(dashboard);


/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = function(dashboard) {
		"use strict";
		dashboard
	  	.controller('dashboardController', dashboardController);
		dashboardController.$inject = ["getConfigData","keyPressOnlyNumberAndDot","activeClass","config","getIspTitle","putDataService","$scope","$rootScope","getDataService","jQuery","refreshtokenService","alertService","serverError","authtokenService","postDataService","$interval", '$compile','$timeout', 'offlineError'];
		
	  function dashboardController(getConfigData,keyPressOnlyNumberAndDot,activeClass,config,getIspTitle,putDataService,$scope,$rootScope,getDataService,jQuery,refreshtokenService,alertService, serverError, authtokenService,postDataService,$interval, $compile,$timeout, offlineError) {
	    var vmd = this;
	    // vmd.realtime = [];
	    // vmd.loadAnalytics = {};
	    // vmd.ispLabels = [];
	    // vmd.getIspTitle = getIspTitle;
	    getConfigData.getData('dashboard');
	    vmd.config = angular.copy(config);
	    $scope.$watch(function() {
				return config
			}, function(newValue, oldValue) {
				if(newValue !== oldValue) {
					vmd.config = angular.copy(config);
				}
			},true);
	    // vmd.chartOptions = {};
	    vmd.keyPressOnlyNumberAndDot = keyPressOnlyNumberAndDot;
	    // var date_start = null;
	    // var date_end = null;  
	    // $scope.ranges = {
	    //   'Today': [moment().startOf('day'), moment().endOf('day')]
	    // };
	    // function isValidBlackTheme(config) {
	    //   // Check if config exists and is an object
	    //   if (!config || typeof config !== 'object') {
	    //       return false;
	    //   }
	  
	    //   // Check if black_theme exists and is an object
	    //   if (!config.black_theme || typeof config.black_theme !== 'object') {
	    //       return false;
	    //   }
	  
	    //   // Check if date_start exists and is valid number
	    //   if (typeof config.black_theme.date_start !== 'number' || 
	    //       config.black_theme.date_start <= 0) {
	    //       return false;
	    //   }
	  
	    //   // Check if date_end exists and is valid number
	    //   if (typeof config.black_theme.date_end !== 'number' || 
	    //       config.black_theme.date_end <= 0) {
	    //       return false;
	    //   }
	  
	    //   // Check if date_start is before date_end
	    //   if (config.black_theme.date_start > config.black_theme.date_end) {
	    //       return false;
	    //   }
	  
	    //   // Validate moment dates
	    //   try {
	    //     const startMoment = moment(config.black_theme.date_start * 1000);
	    //     const endMoment = moment(config.black_theme.date_end * 1000);
	
	    //     // Check if moments are valid
	    //     if (!startMoment.isValid()) {
	    //         return false;
	    //     }
	
	    //     if (!endMoment.isValid()) {
	    //         return false;
	    //     }
	
	    //   } catch (error) {
	    //     return false;
	    //   }
	  
	    //   return true;
	    // }
	    // if (isValidBlackTheme(vmd.config)) {
	    //   vmd.blackTheme = true;
	    //   date_start = vmd.config.black_theme.date_start;
	    //   date_end = vmd.config.black_theme.date_end;
	    //   $scope.myDateRange = {
	    //     startDate: moment(date_start * 1000),
	    //     endDate: moment(date_end * 1000)
	    //   };
	    // }
	    if($rootScope.role_id == 'superadmin') {
	      vmd.superPermisions = true;
	    }
	    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
	      vmd.adminPermisions = true;
	    }
	    vmd.scriptVersionUpdate = function() {
	      var validate = true;
	      if(vmd.config.www_script_version) {
	        vmd.www_script_versionRequired = false;
	      } else {
	        validate = false;
	        vmd.www_script_versionRequired = true;
	      }
	      if(!validate) return
	      var putFunction = function() {
	        $rootScope.hasLoaded = false; 
	        putDataService.update({
	          param1:'options',
	          param2:'script-version'
	        },{
	          'www_script_version': vmd.config.www_script_version
	        }).$promise.then(function(putdata){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', putdata.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	              // report progress
	            });
	          }else if(error.status ==502) {
	              serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;  
	        });
	      }
	      putFunction();
	    }
	    // vmd.blackThemeUpdate = function() {
	    //   if(vmd.blackTheme && (!date_start || !date_end)) {
	    //     alertService('danger','Opps! ', 'Please enter a date range.');
	    //     return
	    //   }
	    //   putDataService.update({
	    //     param1:'options',
	    //     param2:'black-theme'
	    //   },{
	    //     'black_theme':(vmd.blackTheme)? {
	    //       'date_start':date_start,
	    //       'date_end':date_end,
	    //     } : null
	    //   }).$promise.then(function(putdata){
	    //     $rootScope.hasLoaded = true;
	    //     alertService('success','Success ', putdata.message, 2000);
	    //   }, function(error){
	    //     if(!window.navigator.onLine) {
	    //       offlineError()
	    //       $rootScope.hasLoaded = true;
	    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //       return
	    //     }
	    //     if(error.status ==401) {
	    //       var promise = refreshtokenService.getAccessToken();
	    //       promise.then(
	    //         function(answer) {
	    //           if(answer==200) {
	    //             vmd.blackThemeUpdate();
	    //           }
	    //         },
	    //         function(error) {
	    //         },
	    //         function(progress) {
	    //           // report progress
	    //         });
	    //     } else if(error.status ==502) {
	    //       serverError()
	    //     } else {
	    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	    //     }
	    //     $rootScope.hasLoaded = true;      
	    //   })
	    // }
	    // vmd.blackThemeChange = function(value) {
	    //   if(!value) {
	    //     date_start = null;
	    //     date_end = null;
	    //     $scope.$broadcast('clear-daterange',true);
	    //   }
	    // }
	    // vmd.changeDate = function(value) {
	    //   if(value) {
	    //     if(value.startDate && value.endDate) {
	    //       date_start = Math.floor(value.startDate.valueOf() / 1000);
	    //       date_end = Math.floor(value.endDate.valueOf() / 1000);
	    //     } else {
	    //       date_start = null;
	    //       date_end = null;
	    //     }
	    //   } else {
	    //       date_start = null;
	    //       date_end = null;
	    //   }
	    // }
	    // Highcharts.setOptions({
	    //   global: {
	    //       useUTC: false
	    //   },
	    //   colors: ['#337ab7'],
	    //   style: {
	    //       fontFamily: "Open Sans"
	    //   }
	    // });
	    var putFunction = function() {
	      $rootScope.hasLoaded = false; 
	      putDataService.update({
	        param1:'options',
	        param2:'3rdparty-scripts'
	      },{
	        'scripts':(vmd.thirdparty)? 1:0,
	      }).$promise.then(function(putdata){
	        $rootScope.hasLoaded = true;
	        alertService('success','Success ', putdata.message, 2000);
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                putFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	            // report progress
	          });
	        }else if(error.status ==502) {
	            serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;  
	      });
	    }
	    vmd.thirdpartyChange =function() {
	      putFunction();
	    }
	    var getThirdPartyFunction = function() {
	      getDataService.get({param1:'options', param2:'3rdparty-scripts'}).$promise.then(function(data){
	        if(data && (data.scripts === '0' || data.scripts === 0)) {
	          vmd.thirdparty = false
	        } else {
	          vmd.thirdparty = true
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getThirdPartyFunction();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	              // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      }); 
	    }
	    getThirdPartyFunction()
	    // var getDataFunction = function() {
	    //   getDataService.get({param1:'posts', param2: 'refresh', param3:'latest'}).$promise.then(function(data){
	    //     $rootScope.hasLoaded = true;
	    //     alertService('success','Success ', data.message, 2000);
	    //   }, function(error){
	    //     if(!window.navigator.onLine) {
	    //       offlineError()
	    //       $rootScope.hasLoaded = true;
	    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //       return
	    //     }
	    //     if(error.status ==401) {
	    //       var promise = refreshtokenService.getAccessToken();
	    //       promise.then(
	    //         function(answer) {
	    //           if(answer==200) {
	    //             getDataFunction();
	    //           }
	    //         },
	    //         function(error) {
	    //         },
	    //         function(progress) {
	    //           // report progress
	    //       });
	    //     } else if(error.status ==502) {
	    //       serverError()
	    //     } else {
	    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	    //     }
	    //     $rootScope.hasLoaded = true;
	    // }); 
	    // }
	    // vmd.refreshLatestPost = function() {
	    //   $rootScope.hasLoaded = false;
	    //   getDataFunction();
	    // }
	    // vmd.refreshMobile = function() {
	    //     $rootScope.hasLoaded = false;
	    //     getMobileFunction();
	    // }
	    // var getMobileFunction = function() {
	    //     getDataService.get({param1:'posts', param2: 'refresh', param3:'mobileHome'}).$promise.then(function(data){
	    //         $rootScope.hasLoaded = true;
	    //         alertService('success','Success ', data.message, 2000);
	    //       }, function(error){
	    //         if(!window.navigator.onLine) {
	    //           offlineError()
	    //           $rootScope.hasLoaded = true;
	    //           alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //           return
	    //         }
	    //         if(error.status ==401) {
	    //           var promise = refreshtokenService.getAccessToken();
	    //           promise.then(
	    //             function(answer) {
	    //               if(answer==200) {
	    //                 getDataFunction();
	    //               }
	    //             },
	    //             function(error) {
	    //             },
	    //             function(progress) {
	    //               // report progress
	    //           });
	    //         } else if(error.status ==502) {
	    //           serverError()
	    //         } else {
	    //           alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	    //         }
	    //         $rootScope.hasLoaded = true;
	    //     }); 
	    // }
	    // function getRealTimeAnalytics (eleId,t,redraw) {
	    //   getDataService.get({param1:'analytics', param2: 'realtime_v2', t:t, isp:eleId}).$promise.then(function(data){
	    //     if(data && data.analytics && data.analytics[eleId] && data.analytics[eleId].length>0) {
	    //       var chartPointArray = [];
	    //       for(var i=0; i<data.analytics[eleId].length;i++) {
	    //         var pointItem = [data.analytics[eleId][i].date,data.analytics[eleId][i].count]
	    //         chartPointArray.push(pointItem);	  
	    //       }
	    //       if(redraw) {
	    //         if (chartPointArray.length == 0) return
	    //         $scope.$broadcast('hc-chart-'+eleId, chartPointArray);
	    //       } else {
	    //         vmd.chartOptions[eleId] = {
	    //           chart: {
	    //             type: 'spline',
	    //             animation: Highcharts.svg, // don't animate in old IE
	    //             margin: [10, 0, 0, 0],
	    //             spacing: [0, 0 , 0 , 0],
	    //             events: {
	    //                   load: function () {
	    //                     if(window.socketAnalytics) {
	    //                       window.socketAnalytics.on(eleId, function(wsData){
	    //                         var x = wsData.date // current time
	    //                         if(eleId =='total') {
	    //                           var y = wsData.count
	    //                         } else {
	    //                           var y = wsData.isp[eleId];
	    //                         }
	    //                         $scope.$broadcast('hc-chart-'+eleId, [x,y], 'socket');
	    //                       })
	    //                     }
	    //                   }
	    //               }
	    //           },
	    //           title: {
	    //               enabled:false
	    //           },
	    //           xAxis: {
	    //               type:'datetime',
	    //               ordinal: false,
	    //               labels: {
	    //                 style: {
	    //                     color: '#000',
	    //                     fontSize:'12px',
	    //                     fontWeight: 600
	    //                 }
	    //             }
	    //           },
	    //           yAxis: {
	    //               title: {
	    //                   text: 'Number of users'
	    //               },
	    //               min : 0,
	    //               labels: {
	    //                 style: {
	    //                     color: '#000',
	    //                     fontSize:'14px',
	    //                     fontWeight: 600
	    //                 }
	    //               }
	    //           },
	    //           navigator: {
	    //             xAxis: {
	    //               labels: {
	    //                 style: {
	    //                     color: '#555',
	    //                 }
	    //               }
	    //             }
	    //           },
	    //           legend: {
	    //               enabled: false
	    //           },
	    //           series: [{
	    //             data: chartPointArray,
	    //             name: 'Users',
	    //             type: 'area',
	    //             tooltip: {
	    //               valueDecimals: 0
	    //             }
	    //           }],
	    //           tooltip: {
	    //             dateTimeLabelFormats: {
	    //               millisecond: "%b %e, %H:%M:%S"
	    //             },
	    //             backgroundColor: '#ffff',
	    //             style: {
	    //               fontSize: '14px' 
	    //             }
	    //           },
	    //           plotOptions: {
	    //             area: {
	    //               fillColor: {
	    //                 linearGradient: {
	    //                     x1: 0,
	    //                     y1: 0,
	    //                     x2: 0,
	    //                     y2: 1
	    //                 },
	    //                 stops: [
	    //                   [0, Highcharts.getOptions().colors[0]],
	    //                   [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
	    //                 ]
	    //               },
	    //               marker: {
	    //                   radius: 2
	    //               },
	    //               lineWidth: 1,
	    //               states: {
	    //                   hover: {
	    //                       lineWidth: 1
	    //                   }
	    //               },
	    //               threshold: null
	    //             }
	    //           },
	    //           rangeSelector: {
	    //             enabled:false
	    //           }
	    //           // rangeSelector: {
	    //           //     verticalAlign: 'bottom',
	    //           //     x: 0,
	    //           //     y: 0,
	    //           //     buttons: [
	    //           //     // {
	    //           //     //     count: 30,
	    //           //     //     type: 'minute',
	    //           //     //     text: '30M'
	    //           //     // },
	    //           //     // {
	    //           //     //     count: 60,
	    //           //     //     type: 'minute',
	    //           //     //     text: '60M'
	    //           //     // }, 
	    //           //     {
	    //           //         type: 'all',
	    //           //         text: 'All'
	    //           //     }],
	    //           //     inputEnabled: false,
	    //           //     selected: 0
	    //           // },
	    //         }
	    //         vmd.loadAnalytics[eleId] = true;
	    //       }
	          
	    //     }
	        
	    //   }, function(error){
	    //     if(!window.navigator.onLine) {
	    //       offlineError()
	    //       alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //       return
	    //     }
	    //     if(error.status ==401) {
	    //       var promise = refreshtokenService.getAccessToken();
	    //       promise.then(
	    //         function(answer) {
	    //           if(answer==200) {
	    //             getRealTimeAnalytics();
	    //           }
	    //         },
	    //         function(error) {
	    //         },
	    //         function(progress) {
	    //           // report progress
	    //       });
	    //     } else if(error.status ==502) {
	    //       serverError()
	    //     } else {
	    //       alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	    //     }
	    //   }); 
	    // }
	    // setTimeout(function(){
	    //   var lazyChart = [].slice.call(document.querySelectorAll(".isp-chart-lazy"));
	    //   if(lazyChart.length==0) return;
	    //   intersectionObserverGlobal(lazyChart,loadChart, vmd.config.rootMarginLazy);
	    // },100)
	    // vmd.redrawChart = function(event,zoom,eleId) {
	    //   activeClass.active(event);
	    //   getRealTimeAnalytics(eleId,zoom,'redraw')
	      
	    // }
	    // function loadChart(ele) {
	    //   var eleId = ele.getAttribute('id');
	    //   getRealTimeAnalytics(eleId,vmd.config.isp.zoom[0]) 
	      
	    // }
	    $scope.$on('$destroy', function() {
	      // if(window.socketAnalytics) {
	      //   window.socketAnalytics.eventListenerCb = {
	      //     'global': window.socketAnalytics.eventListenerCb.global
	      //   }
	      // }
	    });
	  }	
	}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(dashboard) {
		'use strict'
		dashboard.directive('dashboardDir', dashboardDir);
		dashboardDir.$inject=[];
		function dashboardDir() {
			return {
				template: __webpack_require__(265),
				controller:'dashboardController',
				controllerAs:'vmd',
				link: function(scope, element, attrs) {
					
				}
			};
		};
	}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = function(dashboard) {
		'use strict'
		dashboard.directive('hcChart', hcChart);
		hcChart.$inject=[];
		function hcChart() {
			return {
	            restrict: 'E',
	            template: '<div></div>',
	            scope: {
	                options: '='
	            },
	            link: function (scope, element, attrs) {
	                var el = Highcharts.stockChart(element[0], scope.options);
	                scope.$on(attrs.id, function(event, args, socket) {
	                    var seriesArr;
	                    if(socket) {
	                        seriesArr = angular.copy(el.series[0].options.data)
	                        seriesArr.push(args)
	                    } else {
	                        el.xAxis[0].setExtremes();
	                        seriesArr = args
	                    }
	                    el.update({
	                        series: [{
	                            data: seriesArr,
	                            name: 'Users',
	                            type: 'area',
	                            tooltip: {
	                                valueDecimals: 0
	                            }
	                        }]
	                    }) 
	                });
	            }
	        };
		};
	}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(login) {
		'use strict'
		login.directive('loginDir',loginDir);
		loginDir.$inject=['$state', '$timeout', '$http','postDataService','alertService', 'authtokenService', '$rootScope', 'refreshtokenService','navigationService','config','serverError','offlineError'];
		function loginDir($state,$timeout, $http,postDataService, alertService, authtokenService, $rootScope, refreshtokenService,navigationService,config,serverError, offlineError) {
			return {
				template: __webpack_require__(266),
				controller: 'loginCtrl',
				controllerAs: 'vml',
				link: function(scope, element, attrs, ctrl) {
					$rootScope.navigation = false;
					scope.signIn = true;
					scope.submitted = false;
					var isAuth = false; 
					scope.submit = function($event) {
						if(scope.userForm.$valid) {	
								postDataService.save({param1:'auth', param2: 'login'},{'email':ctrl.userName,"password": ctrl.password}).$promise.then(function(dataAuth){
									var access_token = dataAuth.access_token;
									var avatar = dataAuth.user.avatar;
									var refresh_token = dataAuth.refresh_token;
									var name = dataAuth.user.name;
									var lastName = dataAuth.user.last_name
									var id = dataAuth.user.id;
									var role_id = dataAuth.user.role._id;
									var aitools = dataAuth.aitools;
									authtokenService.setToken(access_token);
									authtokenService.setrefreshToken(refresh_token);
									authtokenService.setNameandAvatarandIdandroleId(name, lastName, avatar, id, role_id, aitools);
									isAuth =true;
									$rootScope.$broadcast('is-aunthenticated', {isAuth:isAuth});
	     							scope.signIn = true;
									alertService('success','Success ', dataAuth.message, 1000);
									// var promise = navigationService.getNavigation();
									if($rootScope.role_id == 'comments-moderator') {
		                				$state.go('app.allcomments');
		                			}else {
										$state.go('app.allposts');
		                			}	
							  
								}, function(error) {
									if(!window.navigator.onLine) {
										offlineError()
										return
									  }
									if(error.status==502) {
										serverError();
									}else {
										scope.signIn = false;
										alertService('danger','Opps! ',(error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
									}
								});			 	
						} else {
							$event.preventDefault();
							scope.submitted = true;
						}
					}
				}
			}
		}
	}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = function(login) {
		"use strict";
		login.controller('loginCtrl', loginCtrl);
		loginCtrl.$inject = ['$scope', '$rootScope'];
		function loginCtrl($scope, $rootScope) {
			var vml = this;
			vml.userName = '';
			vml.password = '';
			
			// });
		}
	}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var login = angular.module('loginModule',['ui.router','servicesModule']);
	__webpack_require__(503)(login);
	__webpack_require__(504)(login);

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(logs) {
		'use strict'
		logs.directive('logsDir', logsDir);
		logsDir.$inject=[];
		function logsDir() {
			return {
				template: __webpack_require__(267),
				controller:'logsController',
				controllerAs:'vmlg',
				link: function(scope, element, attrs, ctrl) {
					
				}
			};
		};
	}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(logs) {
		'use strict'
		logs.directive('singleLog',singleLog);
		singleLog.$inject=[];
		function singleLog() {
			return {
				template: __webpack_require__(268),
				scope: {
			      obj:"="
			    },
				link: function(scope, element, attrs, ctrl) {	    
				}
			}
		}
	}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = function(logs) {
		"use strict";
		logs
	  .controller('logsController', logsController);
		logsController.$inject = ["escapeElastic","config","$scope","$rootScope","getDataService","jQuery","refreshtokenService","alertService","serverError","authtokenService","NgTableParams","$state","postDataService","offlineError"];
		
	  function logsController(escapeElastic,config,$scope,$rootScope,getDataService,jQuery,refreshtokenService,alertService, serverError, authtokenService, NgTableParams, $state, postDataService, offlineError) {
	    var vmlg = this;
	    var $data;
	    var state = 'logs';
	    vmlg.logModalShow = false;
	    vmlg.logObj = null;
	    vmlg.selectedUser = {value:'default'};
	    vmlg.selectedMethod = {value:'default'};
	    $rootScope.emptyTable = false;
	    vmlg.logModalOpen = function(log) {
	        $rootScope.modalShow = true;
	        vmlg.logObj = log;
	        vmlg.logModalShow = true;
	    }
	    vmlg.filtersMustArray = [];
	    vmlg.closeLogs = function() {
	        $rootScope.modalShow =false;
	        vmlg.logModalShow = false;
	    }
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    var getUsersFunction = function() {
	      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
	        vmlg.allUsers = data.users;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getUsersFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getUsersFunction();
	    vmlg.tableReloadFunction = function(page) {
	      vmlg.tableParams = new NgTableParams({
	            page: page || 1,
	            count: 20,
	        }, {
	        getData: function(params) {
	          vmlg.changeDate = function(value) {
	            vmlg.dateRangevalue = value;
	            if(vmlg.dateRangevalue) {
	              if(value.startDate && value.endDate) {
	                vmlg.date_start = value.startDate.format('x');
	                vmlg.date_end = value.endDate.format('x');
	                console.log(vmlg.date_start)
	                console.log(vmlg.date_end)
	              }
	            } else {
	                vmlg.date_start = null;
	                vmlg.date_end = null;
	            }
	          }
	          var reloadTableFunction = function() {
	            params.page(1);
	            vmlg.tableParams.reload();
	          }
	          vmlg.resetAllFilters =function() {
	            vmlg.filtersMustArray = [];
	            vmlg.selectedUser = {value:'default'};
	            vmlg.selectedMethod = {value:'default'};
	            vmlg.bodyLog = null;
	            vmlg.pathLog = null;
	            vmlg.date_start = null;
	            vmlg.date_end = null;
	            $scope.$broadcast('clear-daterange',true);
	            reloadTableFunction();
	          } 
	          vmlg.postFilter = function() {
	            vmlg.filtersMustArray = [];
	            if(vmlg.selectedUser.value != 'default') {
	              vmlg.filtersMustArray.push({"query_string": {"default_field": "user","query": vmlg.selectedUser.value}})
	            }
	            if(vmlg.selectedMethod.value != 'default') {
	              vmlg.filtersMustArray.push({"match": {"method": vmlg.selectedMethod.value}})
	            }
	            if(vmlg.bodyLog) {
	              var variousLog = escapeElastic(vmlg.bodyLog);
	              vmlg.filtersMustArray.push({"query_string": {"fields": [ "body", "header" ],"query": variousLog+'*', "default_operator": "AND"}});
	            }
	            if(vmlg.pathLog) {
	              var pathLog = escapeElastic(vmlg.pathLog);
	              vmlg.filtersMustArray.push({"query_string": {"default_field": "path","query": pathLog+'*', "default_operator": "AND"}});
	            }
	            if(vmlg.date_start) {
	              vmlg.filtersMustArray.push({"range" : {"uts" : {"gte" : vmlg.date_start,"lte" : vmlg.date_end}}})
	            }
	            reloadTableFunction();
	          }
	          var query = {
	            "from" : (params.page()-1)*params.count(), 
	            "size" : params.count(),
	            "query": {
	              "bool": {
	                "must":  vmlg.filtersMustArray
	              }
	            }
	          }
	 
	          $rootScope.hasLoaded = false;
	          return postDataService.save({
	              param1:state, 
	              sort: 'uts:desc'
	            },
	              JSON.stringify(query)
	            ).$promise.then(function(response){
	            $data = response.hits.hits;
	            params.total(response.hits.total);
	            params.numPages(Math.ceil(response.hits.total/params.count()));
	            if($data.length>0) {
	              $rootScope.emptyTable = false;
	            } else {
	              $rootScope.emptyTable = true;
	            }
	            $rootScope.hasLoaded = true;
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	               
	                if(answer==200) {
	                  vmlg.tableReloadFunction(params.page());
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }    
	      });
	    }
	    vmlg.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }    
	}	


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	var logs = angular.module("logsModule", [
		'ui.router',
		'servicesModule',
		'ngResource',
		// 'angular-rickshaw',
		// "btford.socket-io"
	]);
	__webpack_require__(506)(logs);
	__webpack_require__(508)(logs);
	__webpack_require__(507)(logs);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(macrosites) {
		'use strict'
		macrosites.directive('macrositesFocusNewsDir',macrositesFocusNewsDir);
		macrositesFocusNewsDir.$inject=[];
		function macrositesFocusNewsDir() {
			return {
				template: __webpack_require__(269),
				controller:'macrositesFocusNewsController',
				controllerAs:'vmmfn',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = function(macrosites) {
		"use strict";
	  macrosites
	  .controller('macrositesFocusNewsController', macrositesFocusNewsController)
		macrositesFocusNewsController.$inject = ["config","API_URL","$http","$rootScope","getDataService","refreshtokenService","alertService","serverError", "offlineError"];
	  function macrositesFocusNewsController(config,API_URL,$http,$rootScope,getDataService,refreshtokenService,alertService,serverError, offlineError) {
	    var vmmfn = this;
	    vmmfn.macrositesFocusNewsObj = {};
	    vmmfn.addPostFromSearch = function(obj) {
	      if(vmmfn.macrositesFocusNewsObj._id == obj.id) {
	        alertService('danger', 'Opps! ', 'Post alredy exist!');
	        return
	      }
	      vmmfn.macrositesFocusNewsObj = {
	        '_id':obj.id,
	        'title':obj.title,
	        'url':obj.url,
	        'image':obj.image,
	      }
	    }
	    vmmfn.saveFocusNews = function() {
	      var validation = true
	      var putData;
	      if(!vmmfn.macrositesFocusNewsObj) {
	        alertService('danger','Opps! ', 'The post is required');
	        validation = false
	        return
	      } else {
	        putData = vmmfn.macrositesFocusNewsObj
	      }
	      if(!validation) return 
	      // Get latest focus news data before saving
	      $rootScope.hasLoaded = false;
	
	      var updateFunction = function(url) {
	        $rootScope.hasLoaded = false;
	        $http.put(url , putData)
	        .success(function (data, stat, headers) {
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  updateFunction(url);
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	                // report progress
	            });
	          }else if(status ==502) {
	            serverError()  
	          } else { 
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      updateFunction(API_URL+ "macrosites/embed");
	    }
	    var getFocusNews = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'macrosites', param2: 'embed'}).$promise.then(function(data){  
	        $rootScope.hasLoaded = true;
	        if(data.result) {
	          vmmfn.macrositesFocusNewsObj = data.result
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getFocusNews();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        } 
	        $rootScope.hasLoaded = true;
	      });
	    }
	    getFocusNews()
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }
	}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var macrosites = angular.module('macrositesModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'ui.tinymce'	
	]);
	// require('./relatedNews/js/directive/macrositesRelatedNewsDirective.js')(macrosites);
	// require('./relatedNews/js/macrositesRelatedNewsController.js')(macrosites);
	__webpack_require__(510)(macrosites);
	__webpack_require__(511)(macrosites);

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		'use strict'
		media.directive('lazyLoading',lazyLoading);
		lazyLoading.$inject=[];
		function lazyLoading() {
			return {
				restrict: 'A',
				link: function(scope, element, attrs, ctrl) {
		            scope.$on("change-image",function(event, data) {
		            	scope.changeImage();
		            });
		            scope.changeImage = function() {
		            	element.attr('src','');
		            	element.addClass('spinner-show');
		            	element.removeClass('spinner-hide');
		            }
					element.on('load', function() {
			            // Set visibility: true + remove spinner overlay
			            element.addClass('spinner-hide');
			            element.removeClass('spinner-show');
	          		});
				}
	
			}
		}
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict';
		media.directive('attachToPostModal',attachToPostModal);
		attachToPostModal.$inject=['getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','NgTableParams','serverError','postDataService','alertService','offlineError'];
		function attachToPostModal(getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,NgTableParams,serverError,postDataService,alertService,offlineError) {
			return {
				restrict: 'E',
				scope: {
			      currentPostObj:"="
			    },
			 	template: __webpack_require__(270),
			    link: function (scope, element, attrs) {
					var state = 'posts';
					var sortby ='date';
					var status = 'publish';
					var s;
					var page;
					var $data;
					$rootScope.modalShow = true;
					scope.checkboxes = {item:{}};
					scope.updateSelection = function(post_id, checked) {
				        var updateSelectionTree = function(posts) {
				          if(checked) {
				            for (var i=0; i<posts.length; i++){
				              if (posts[i]._id !== post_id) {
				                scope.checkboxes.item[posts[i]._id] = false;
				              }
				            }
				            scope.post_id = post_id;
				          } else {
				            scope.post_id = null;
				          }
				        }
				        updateSelectionTree(scope.dataGet);
				    } 
				    scope.selectRow = function(postId) {
				    	if(scope.checkboxes.item[postId]){
							scope.checkboxes.item[postId] = false;
						} else {
							scope.checkboxes.item[postId] = true;
						}
						$timeout(function() {
							scope.updateSelection(postId,scope.checkboxes.item[postId])
						},0);
				    } 
	     			scope.selectPostToAttachMedia = function() {
	     				if(scope.post_id) {
	     					var postFunction = function() {	
							    postDataService.save({
						          param1:'attachments',
						          param2:'attach',
						          param3:scope.post_id
						        },{
						        	'ids': scope.currentPostObj.checkedPostsforAttach,
						        }).$promise.then(function(data){
						        	scope.currentPostObj.cancelAttachToPostModal();
									scope.currentPostObj.tableParams.reload();
						            alertService('success','Success ', data.message, 2000);
						        }, function(error){
									if(!window.navigator.onLine) {
										offlineError()
										$rootScope.hasLoaded = true;
										alertService('danger','Opps! ', 'Please check your internet connection and try again.');
										return
									}
									if(error.status ==401) {
										var promise = refreshtokenService.getAccessToken();
										promise.then(
										function(answer) {
											if(answer==200) {
											postFunction();
											}
										},
										function(error) {
											// report something
										},
										function(progress) {
										// report progress
										});
									} else if(error.status ==502) {
										serverError()
									} else {
										alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
									}
									scope.currentPostObj.cancelAttachToPostModal();
						        });
						    }
	     					postFunction()
	     				}
	     			}
					scope.tableReloadFunction = function(page) {
				          scope.tableParams = new NgTableParams({
				              page: page || 1,
				              count: 20,
				              
				          }, {
				          getData: function(params) {
				            $rootScope.hasLoaded = false;
				            return getDataService.get({
				              param1: state,
				              param2: null,
				              s:s,
				              status: status,
				              page: params.page(),
				              limit: params.count(),
				              sortby: $rootScope.sortby,
				              sort : $rootScope.sort,
				              }).$promise.then(function(data){
				             
				              scope.emptyTable = false;
				              $rootScope.hasLoaded = true;
				              $data = data.posts;
				              scope.dataGet = data.posts;
				              if(data.posts.length == 0) {
				                scope.emptyTable = true;
				              }
				              for (var i=0; i<scope.dataGet.length; i++){
				                scope.checkboxes.item[scope.dataGet[i]._id] = false;
				              }
				              params.total(data.count);
				              params.numPages(data.max_pages);
				              jQuery('.goTo input').val("");
				              scope.search =function(value) {
				                if(value) {
				                s = value.toLowerCase();
				                } else {
				                  s = null;
				                }
				                page = 1;
				                params.page(page);
				                scope.tableReloadFunction();
				              }
				              
				              return $data;
				            }, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
				                if(error.status ==401) {
				                	var promise = refreshtokenService.getAccessToken();
					                promise.then(
				                    function(answer) {
					                    if(answer==200) {
					                      scope.tableReloadFunction(params.page());
					                    }
					                    // do something
					                },
					                function(error) {
					                },
					                function(progress) {
					                   // report progress
					                });
				              	} else if(error.status ==502) {
				                  serverError()
			                	} else if(error.status ==404) {
					                scope.emptyTable = true;
					            } else {
					                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
					            }	   
				                $rootScope.hasLoaded = true;
				            });
				          }    
				      });
				    }
				    scope.tableReloadFunction(); 
				}    
			}
		}
	}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('mediaLibraryDir',mediaLibraryDir);
		mediaLibraryDir.$inject=[];
		function mediaLibraryDir() {
			return {
				restrict: 'E',
				template: __webpack_require__(272),
				controller:'libraryController',
				controllerAs:'vml',
				link: function(scope, element, attrs, ctrl) {
					
				}
	
			}
		}
	}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('mediaEditDir',mediaEditDir);
		mediaEditDir.$inject=['downloadImage','jQuery','keyPressOnlyNumber','authtokenService','config','$rootScope','$state','getDataService','refreshtokenService','serverError','alertService','postDataService','deleteDataService','putDataService','$timeout','keyPress', 'checkArray', 'API_URL','offlineError'];
		function mediaEditDir(downloadImage,jQuery,keyPressOnlyNumber,authtokenService,config,$rootScope,$state,getDataService,refreshtokenService,serverError,alertService,postDataService,deleteDataService,putDataService,$timeout,keyPress, checkArray, API_URL,offlineError) {
			return {
				restrict: 'E',
				scope:{
					media:'='
				},
				template: __webpack_require__(271),
				link: function(scope, ele, $attrs, ctrl) {
					var state ='attachments';
					scope.existTag = false;
					scope.editMediaCurrent = null;
					scope.titleRequired = false;
					scope.newTagRequired = false;
					scope.attachmentId = scope.media.attachmentId;
					scope.imageLocked = false;
					scope.photoRestriction = false;
					scope.attachmentIdsArray = [];
					// scope.approvalUrl = false;
					scope.attachmentIdsArray.push(scope.attachmentId) 
					// var token = authtokenService.getToken();
	
					scope.numberOfUses = {
						max:undefined,
						count: 0
					}
					var mainImage = angular.element(document.getElementsByClassName("main-image"));
					mainImage.on('error',function() {
						scope.$apply(function() {
							scope.imageLocked = true;
						})
					});
					scope.downloadImage = downloadImage
					scope.ranges = {
				        'Today': [moment().startOf('day'), moment().endOf('day')],
				        'Next 30 days': [moment().startOf('day'), moment().add('days', 29).endOf('day')],
				        'Next 90 days': [moment().startOf('day'), moment().add('days', 89).endOf('day')],
				        'Next 12 months': [moment().startOf('day'), moment().add('months', 12).subtract('days', 1).endOf('day')]
				    };
					// scope.media.dzOptionsRestriction = {
				    //     url : API_URL + 'upload/pdf/approval',
				    //     paramName : 'pdf',
				    //     maxFilesize : '500',
				    //     parallelUploads: 1,
				    //     uploadMultiple: false,
				    //     acceptedFiles : '.pdf',
				    //     addRemoveLinks : true,
				    //     autoProcessQueue : false,
				    //     dictInvalidFileType: 'This file type is not supported.',
				    //     dictFileTooBig:'File size too Big',
				    //     dictDefaultMessage : "Drop approval pdf here to upload",
				    //     headers:{
				    //       'x-auth': token  
				    //     },
				        
				    // };
				    // scope.media.dzCallbacksRestriction = {
				    //     'addedfile' : function(file){
				    //     	if(scope.newFileRestriction) {
				    //     		scope.media.dzMethodsRestriction.removeFile(scope.newFileRestriction);
				    //     	}
				    //         var promise = refreshtokenService.getAccessToken();
				    //         promise.then(
				    //           function(answer) {
				    //                 token = authtokenService.getToken();
				    //                 scope.media.dzOptionsRestriction.headers['x-auth'] = token;
				    //                 scope.media.dzMethodsRestriction.processQueue();
				    //         		scope.newFileRestriction = file;
				    //           },
				    //           function(error) {
				    //             // report something
				    //           },
				    //           function(progress) {
				    //            // report progress
				    //         });
				    //     },
				    //     'success' : function(file, xhr, response){
				    //    		var data = JSON.parse(response.currentTarget.response);
				    //    		scope.approval = data.approval;
				    //     },
				    //     'error' : function(file,message) {
				    //         // console.log(response.xhr.status);
					// 		if(message && message.error && message.error.message) {
					// 			jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
					// 		}
				    //     },
				    //     'sending':function(file, xhr, formData) {
				    //          formData.append('attachment_ids', scope.attachmentIdsArray);
				    //     }
				    // };
				    var resetRestrictionFunction = function() {
				        scope.$broadcast('clear-daterange');
				        scope.numberOfUses.max = undefined;
				        // scope.approval = undefined; 
				    }
				    scope.addPhotoRestriction = function() {
				    	if(!scope.photoRestriction) {
				         	resetRestrictionFunction();
				    	}
				    }
				    scope.changeDate = function(value) {
				      scope.dateRangevalue = value;
				      scope.switchDate = true;
				      if(scope.dateRangevalue) {
				        if(value.startDate && value.endDate) {
				          scope.date_start = value.startDate.format('YYYY-MM-DD');
				          scope.date_end = value.endDate.format('YYYY-MM-DD');
				        } else {
							scope.date_start = null;
							scope.date_end = null;
						}
				      } else {
				          scope.date_start = null;
				          scope.date_end = null;
				      }
				    }
				    scope.onlyNumber = function(event) {
				       keyPressOnlyNumber(event) 
				    }
					scope.blurMaxUtilization = function() {
						if((scope.numberOfUses.max < scope.numberOfUses.count || !scope.numberOfUses.max) && scope.numberOfUses.count ) {
							scope.numberOfUsesError = true;
						}
					}
				    scope.changeMaxUtilization = function() {
				    	scope.numberOfUsesError = false;
				    	if((scope.numberOfUses.max < scope.numberOfUses.count || !scope.numberOfUses.max) && scope.numberOfUses.count ) {
				    		scope.numberOfUsesError = true;
				    		// scope.numberOfUses.max =  scope.numberOfUses.count;
				    		// $timeout(function() {
				    		// 	scope.numberOfUsesError = false;
				    		// },1000)
				    	}
					}
					function changeMediaStatus(postIds, param) {
						if(!postIds) return;
						$rootScope.hasLoaded = false;
						postDataService.save({
							param1:state,
							param2:'status',
							param3:param
						},{
							'ids': postIds,
						}).$promise.then(function(data){
							$rootScope.hasLoaded = true;
							getFunction();
						}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function(answer) {
										if(answer==200) {
											changeMediaStatus(postIds, param);
										}
									},
									function(error) {
										// report something
									},
									function(progress) {
										// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
					}
					scope.changeMediaStatus = function(postId,param) {
						changeMediaStatus([postId], param)
					} 
					var unlockFunction = function(file_name) {
						$rootScope.hasLoaded = false;	
					    postDataService.save({
				          param1:state,
				          param2:'unlock',
				        },{
				        	'file_name': file_name,
				        }).$promise.then(function(data){
				        	$rootScope.hasLoaded = true;
									alertService('success','Success ', data.message, 2000);
									scope.mainImage = scope.editMediaCurrent.thumbs['830x0'];
									var mainImage = angular.element(document.getElementsByClassName("main-image"));
									mainImage.on('load',function() {
										scope.$apply(function() {
											scope.imageLocked = false;
										})
									})
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				          	if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {
									  unlockFunction(file_name);
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
								// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
				        });
				    }
					scope.unlockMedia = function(file) {
						if(config.baseMediaHref && file) {
							scope.mainImage = undefined;
							var file_name = file.substring(config.baseMediaHref.length)
							unlockFunction(file_name);
						}
					}
					$rootScope.closeEditMedia = function() {
						$rootScope.ngEscapeAttrsParametars = [];
						scope.media.editMediaShow= false;
						scope.editMediaCurrent = null;
						$state.transitionTo('app.library', {id: null}, {
			              location: true,
			              inherit: true,
			              relative: $state.$current,
			              notify: false
			            });
					}
					scope.searchPress = function(evt) {
				     keyPress(evt);
				    }
					scope.addNewTag = function(newTag) {
					    if(newTag) {
					        scope.newTagRequired = false;
				    		var newTag = newTag.toLowerCase();
					    	if(!checkArray.contains.call(scope.editMediaCurrent.tags,newTag)) {
						        scope.editMediaCurrent.tags.push(newTag);
						        scope.searchtagfocus = null;
						        scope.existTag = false;
					    	} else {
					    		scope.existTag = true;
					    	}
					    } else {
					        scope.newTagRequired = true;
					    }
				    }
				    scope.removeFromTagsList = function(index) {
				      scope.editMediaCurrent.tags.splice(index, 1);
				    }
				    // scope.getPdf = function() {
				    // 	token = authtokenService.getToken();
				    // 	var getPdfFunction = function() {
					// 		var req = new XMLHttpRequest();
					// 		var filename = scope.attachmentId + '-approval.pdf';
					// 	    req.open("GET", scope.approvalUrl, true);
					// 	    req.setRequestHeader('x-auth', token)
					// 	    req.responseType = "blob";
					// 	    req.onload = function (event) {
					// 	        var blob = req.response;
					// 	        var link=document.createElement('a');
					// 	        link.href=window.URL.createObjectURL(blob);
					// 	        link.style = "display: none";
	            	// 		document.body.appendChild(link);  
					// 	        link.download=filename;
					// 	        link.click();
					// 	        setTimeout(function(){
					//               document.body.removeChild(link);
					//             },0)
					// 	    };
					// 	    req.send();
					//     }
					//     getPdfFunction();
				    // }
				    // scope.removePdf = function() {
				    // 	scope.approval = undefined;
				    // 	scope.approvalRemoved = true;
				    // 	scope.approvalUrl = undefined;
				    // }
				    var getDataInitFuncion = function(data) {
				    	// scope.approvalUrl = false;
				    	scope.editMediaCurrent = data;
				     	scope.mainImage = scope.editMediaCurrent.thumbs['830x0'];
				     	scope.editMediaCurrent.tags = checkArray.removeDuplicate(data.tags);
				     	// scope.approvalRemoved = false;
				     	if(data.restrictions) {
				     		
				     		if(data.restrictions.use_max && data.restrictions.use_max >=0) {
				     			scope.photoRestriction = true;
				     			scope.numberOfUses.max = data.restrictions.use_max
				     		}
				     		if(data.restrictions.date_to && data.restrictions.date_from) {
				     			scope.photoRestriction = true;
								 console.log(data.restrictions.date_to)
				     			$timeout(function() {
				     				scope.$broadcast('initial-daterange',{date:{start_date:data.restrictions.date_from,end_date:data.restrictions.date_to}})	
				     			},0);	
				     		}
				     		if(data.restrictions.use_count && data.restrictions.use_count>=0) {
				     			scope.numberOfUses.count = parseInt(data.restrictions.use_count);
				     		} else {
								scope.numberOfUses.count = 0;
							}
				     		if(data.restrictions.use_post_id ) {
				     			if(data.restrictions.use_post_id.length > 0) {
				     				scope.arrayOfPostsImageIncluded = data.restrictions.use_post_id
				     			} 
				     		}
				     		if(data.restrictions.locked) {
				     			scope.lockedImage = data.restrictions.locked;
				     		}
				     	}
			     		// if(data.approval_url) {
			     		// 	scope.approvalUrl = data.approval_url;
			     		// }	
				    }
				    var getFunction = function() {
					    getDataService.get({param1:state, param2: scope.attachmentId}).$promise.then(function(data){
					     	getDataInitFuncion(data)
					    }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								return
							}
					        if(error.status ==401) {
						        var promise = refreshtokenService.getAccessToken();
						        promise.then(
						          function(answer) {
						            if(answer==200) {
						              getFunction();
						            }
						          },
						          function(error) {
						            // report something
						          },
						          function(progress) {
						           // report progress
						        });
					        }else if(error.status ==502) {
				                serverError();
			                } else {
						        scope.media.editMediaShow= false;
						        $rootScope.hasLoaded = true;
						        $state.transitionTo('app.library', {id: null}, {
					              location: true,
					              inherit: true,
					              relative: $state.$current,
					              notify: false
					            });
					      	}
					    }); 
				    }
				    getFunction();
				    var postFunction = function() {
				    	scope.restrictions = undefined;
						if(scope.numberOfUsesError) {
							alertService('danger','Opps! ', 'Maximum utilization is incorrect');
							$rootScope.hasLoaded = true;
							return
						}
				    	if(scope.photoRestriction && (scope.numberOfUses.max || scope.date_start)) {
				            scope.restrictions = {
				                date_from : (scope.date_start)? scope.date_start: undefined,
				                date_to : (scope.date_end)? scope.date_end: undefined,
				                use_max : (scope.numberOfUses.max)? parseInt(scope.numberOfUses.max) : undefined
				            }
				        }
				        // if(!scope.approval) scope.approval = undefined;	
					    postDataService.save({
				          param1:state,
				          param2:'update',
				          id:scope.attachmentId
				        },{
				        	'title': scope.editMediaCurrent.title,
				        	'signature': scope.editMediaCurrent.signature,
				        	'image_alt': scope.editMediaCurrent.image_alt,
				        	'description': scope.editMediaCurrent.description,
							'signature_url': scope.editMediaCurrent.meta.signature_url,
							'gallery_title': scope.editMediaCurrent.gallery_title,
				        	'tags': scope.editMediaCurrent.tags,
				        	'restrictions': scope.restrictions,
				        	// 'approval':scope.approval
				        }).$promise.then(function(data){
				        	$rootScope.hasLoaded = true;
				        	getDataInitFuncion(data.post)
				            alertService('success','Success ', data.message, 2000);
				            scope.newFileRestriction = undefined;
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {
									postFunction();
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
								// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
				        });
				    }
				    scope.updateMedia = function() {
				    	var validation = true;
				    	if(!scope.editMediaCurrent.title) {
				    		scope.titleRequired = true;
				    		validation = false
				    	} else {
				    		scope.titleRequired = false;
							}
							// if(scope.titleExceed) {
							// 	validation = false;
							// 	alertService('danger','Opps! ', 'Maximum number of characters in description is 200');
							// }
							if(validation) {
								$rootScope.hasLoaded = false;
								postFunction();
							} 
				    }
				    var deleteFunction = function() {
				      putDataService.update({
				        param1:'attachments', 
				        param2: 'bulk',
				        param3:'delete'
				        },{
				          'delete_ids':scope.checkedPostsforDelete,
				        }).$promise.then(function(bulkDelete){
				        $rootScope.hasLoaded = true;
				          scope.checkedPostsforDelete = [];
				          alertService('success','Success ', bulkDelete.message, 2000);
				          scope.media.tableParams.reload();
				          $timeout(function() {
					          $rootScope.closeEditMedia();
				          },0)
				      }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
				        if(error.status ==401) {
				          var promise = refreshtokenService.getAccessToken();
				          promise.then(
				            function(answer) {
				              if(answer==200) {   
				                deleteFunction();
				              }
				            },
				            function(error) {
				              // report something
				            },
				            function(progress) {
				             // report progress
				          });
				        }else if(error.status ==502) {
				          serverError();
				        } else {
				          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				        }
				        $rootScope.hasLoaded = true;  
				      });
				    }
				    scope.deleteMedia = function() {
				    	$rootScope.hasLoaded = false;
					    scope.checkedPostsforDelete= [];
					    scope.checkedPostsforDelete.push(scope.attachmentId);
					    deleteFunction();  
				    }
				}
				
			}
		}
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('mediaEditModal',mediaEditModal);
		mediaEditModal.$inject=['$rootScope','postDataService','alertService', 'serverError','refreshtokenService','putDataService','$timeout','offlineError'];
		function mediaEditModal($rootScope,postDataService,alertService,serverError,refreshtokenService,putDataService,$timeout,offlineError) {
			return {
				restrict: 'E',
				scope: {
					media:'='
				},
				template: __webpack_require__(273),
				link: function(scope, ele, $attrs, ctrl) {
					scope.changeFieldFlag = false;
					$rootScope.modalShow = true;
					var state = "attachments";
					scope.data_grid = scope.media.data_grid;
					scope.mediaIndex = scope.media.selectedMediatoEdit;
					scope.mediaSelected = scope.media.data_grid[scope.mediaIndex];
					scope.media_id = scope.media.attachmentId;
					function changeMediaStatus(postIds, param) {
						if(!postIds) return;
						$rootScope.hasLoaded = false;
						postDataService.save({
							param1:state,
							param2:'status',
							param3:param
						},{
							'ids': postIds,
						}).$promise.then(function(data){
							$rootScope.hasLoaded = true;
							scope.mediaSelected.status = param;
						}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function(answer) {
										if(answer==200) {
											changeMediaStatus();
										}
									},
									function(error) {
										// report something
									},
									function(progress) {
									 // report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
					}
					scope.changeMediaStatus = function(postId,param) {
						changeMediaStatus([postId], param)
					} 
					scope.resetMediaSelected = function() {
						scope.mediaSelected = undefined;
						scope.$broadcast("change-image", {cancelModal:true});
					}
					scope.beforeImage = function () {
						if(scope.data_grid.length != 1) {
							scope.mediaIndex--;
							if(scope.mediaIndex < 0) {
								scope.mediaIndex = scope.data_grid.length-1;
							} 
							scope.mediaSelected = scope.data_grid[scope.mediaIndex];
							scope.media.selectedImage = scope.mediaIndex;
							scope.media_id = scope.data_grid[scope.mediaIndex]._id;
							scope.$broadcast("change-image", {beforeImage:true});
						}
					}
					scope.afterImage = function() {
						if(scope.data_grid.length != 1) {
							scope.mediaIndex++;
							if(scope.mediaIndex > scope.data_grid.length-1) {
								scope.mediaIndex = 0;
							}
							scope.mediaSelected = scope.data_grid[scope.mediaIndex];
							scope.media.selectedImage = scope.mediaIndex;
							scope.media_id = scope.data_grid[scope.mediaIndex]._id;
							scope.$broadcast("change-image", {afterImage:true});
						}
					}
					var deleteFunction = function() {
				      putDataService.update({
				        param1:'attachments', 
				        param2: 'bulk',
				        param3:'delete'
				        },{
				          'delete_ids':scope.checkedPostsforDelete,
				        }).$promise.then(function(bulkDelete){
				          $rootScope.hasLoaded = true;
				          alertService('success','Success ', bulkDelete.message, 2000);
				          if(scope.media.tableParams) {
				          	scope.media.tableParams.reload();
				          } else {
				          	scope.media.deleteImage(scope.checkedPostsforDelete[0]);
				          }
				          $timeout(function() {
					          scope.media.cancelMediaModal();
					          scope.resetMediaSelected();
				          },0)
				          scope.checkedPostsforDelete = [];
				      }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
				        if(error.status ==401) {
				          var promise = refreshtokenService.getAccessToken();
				          promise.then(
				            function(answer) {
				              if(answer==200) {   
				                deleteFunction();
				              }
				            },
				            function(error) {
				              // report something
				            },
				            function(progress) {
				             // report progress
				          });
				        }else if(error.status ==502) {
				          serverError();
				        } else {
				          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				        }
				        $rootScope.hasLoaded = true;  
				      });
				    }
				    scope.deleteMedia = function() {
				    	$rootScope.hasLoaded = false;
					    scope.checkedPostsforDelete= [];
					    scope.checkedPostsforDelete.push(scope.media_id)
					    deleteFunction();  
				    }
					var postFunction = function() {	
					    postDataService.save({
				          param1:state,
				          param2:'update',
				          id:scope.media_id
				        },{
				        	'title': scope.mediaSelected.title,
				        	'signature': scope.mediaSelected.signature,
				        	'image_alt': scope.mediaSelected.image_alt,
				        	'description': scope.mediaSelected.description,
							'signature_url': scope.mediaSelected.meta.signature_url,
							'gallery_title': scope.mediaSelected.gallery_title
				        }).$promise.then(function(data){
				        	$rootScope.hasLoaded = true;
				          alertService('success','Success ', data.message, 2000);
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				          	if(error.status ==401) {
				            var promise = refreshtokenService.getAccessToken();
				            promise.then(
				              function(answer) {
				                if(answer==200) {
				                  postFunction();
				                }
				              },
				              function(error) {
				                // report something
				              },
				              function(progress) {
				               // report progress
				            });
				          } else if(error.status ==502) {
				            serverError()
				          } else {
				            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				          }
				          $rootScope.hasLoaded = true;
				        });
				    }
				    scope.changeField = function() {
				    	scope.changeFieldFlag = true;
				    }
				    scope.outFocus = function() {
							// if(scope.titleExceed) {
							// 	alertService('danger','Opps! ', 'Maximum number of characters in description is 200');
							// 	return
							// }
				    	if(scope.changeFieldFlag ) {
				    		$rootScope.hasLoaded = false;
				    		scope.changeFieldFlag = false;
				    		postFunction();
				    	}
				    }
				}
			}
		}
	}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict';
		media.directive('uploadApprovalRestrictionsModal',uploadApprovalRestrictionsModal);
		uploadApprovalRestrictionsModal.$inject=['jQuery','$http','API_URL','authtokenService','getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','NgTableParams','serverError','postDataService','alertService','offlineError'];
		function uploadApprovalRestrictionsModal(jQuery,$http,API_URL,authtokenService,getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,NgTableParams,serverError,postDataService,alertService,offlineError) {
			return {
				restrict: 'E',
				scope: {
			      currentPostObj:"="
			    },
			 	template: __webpack_require__(274),
			    link: function (scope, element, attrs) {
					scope.idsForApproval = [];
					for (var i = 0;i<scope.currentPostObj.checkedPostsEdit.length;i++) {
						scope.idsForApproval.push(scope.currentPostObj.checkedPostsEdit[i]._id);
			      
					}
				}	
			}
		}
	}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		"use strict";
	  media
	  .controller('libraryController', libraryController);
		libraryController.$inject = ["downloadImage","watchAllCheckboxesNgTable","$http","cleanObj","API_URL","authtokenService","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","keyPressOnlyNumber","offlineError"];
		
	  function libraryController(downloadImage,watchAllCheckboxesNgTable,$http,cleanObj, API_URL,authtokenService,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,keyPressOnlyNumber,offlineError) {
	    var vml = this;
	    vml.config = config;
	    $rootScope.emptyTable = false;
	    vml.editMediaModalShow = false;
	    vml.showGrid = false;
	    vml.selectedImage = -1;
	    vml.editMediaShow = false;
	    vml.selectedMediatoEdit = 0;
	    var state = 'attachments';
	    var page = 1;
	    var author;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var s;
	    var uploaded_to;
	    var unattached;
	    var $data;
	    vml.status = 'all';
	    vml.checkedTypeSearch =false;
	    vml.selectedDesccription = -1;
	    // vml.selectedMediaAction = {value: 'default'};
	    vml.selectedAuthorFilter = {value: 'all'};
	    vml.selectedBulkAction = {value: 'default'};
	    vml.checkedPostsEdit = [];
	    vml.hiddenBulkEdit = true;
	    vml.checkboxes = { 'checked': false, items: {} };
	    vml.cropModalShow = false;
	    vml.mediaItemToCrop = {};
	    vml.attachToPostModalShow = false;
	    vml.uploadApprovalRestrictionsModal = false;
	    vml.attachtoPost_id = null;
	    vml.attachmentId = $stateParams.id;
	    vml.checkedPostsforAttach = [];
	    vml.checkedPostsforDetach = []; 
	    if($stateParams.id) {
	      vml.editMediaShow = true;
	    } else {
	      vml.editMediaShow = false;
	    }
	    vml.downloadImage = downloadImage;
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vml.onlyNumber = function(event) {
	      keyPressOnlyNumber(event) 
	    }
	    vml.changeDateRestrictions = function(value) {
	      vml.dateRangevalueRestrictions = value;
	      if(vml.dateRangevalueRestrictions) {
	        if(value.startDate && value.endDate) {
	          vml.date_start_restrictions = value.startDate.format('YYYY-MM-DD');
	          vml.date_end_restricitons = value.endDate.format('YYYY-MM-DD');
	        } else {
	          vml.date_start_restrictions = null;
	          vml.date_end_restricitons = null;
	        }
	      } else {
	          vml.date_start_restrictions = null;
	          vml.date_end_restricitons = null;
	      }
	    }
	    angular.element(document).on('mouseup', function(e) {
	      var container = angular.element(document.getElementsByClassName("grid"));
	      var media_modal = angular.element(document.getElementsByClassName("media-modal"));
	      
	      if (!container.is(e.target) // if the target of the click isn't the container...
	        && container.has(e.target).length === 0 && vml.showGrid && !media_modal.is(e.target) && media_modal.has(e.target).length===0) // ... nor a descendant of the container
	      {
	        $scope.$apply(function () {
	          vml.selectedImage = -1;
	        });
	      }
	    });
	    vml.purgeCache = function(filepath) {
	      if(!filepath) return;
	      $rootScope.hasLoaded = false;
	      var postFunction = function() {
	        postDataService.save({
	          param1:state,
	          param2:'purgeVarnish'
	        },{
	          'filepath': filepath
	        }).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	              postFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	              // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction()
	    }
	    function changeMediaStatus(postIds, param) {
	      if(!postIds) return;
	      $rootScope.hasLoaded = false;
	      postDataService.save({
	        param1:state,
	        param2:'status',
	        param3:param
	      },{
	        'ids': postIds,
	      }).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        vml.checkedPostsforLockOrUnlock = [];
	        watchAllCheckboxesNgTable.resetCheckBox(vml) 
	        alertService('success','Success ', data.message, 2000);
	        vml.tableParams.reload();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                changeMediaStatus(postIds, param);
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          console.log(error)
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    vml.changeMediaStatus = function(postId,param) {
	      changeMediaStatus([postId], param)
	    }
	    // vml.getPdf = function(postItem) {
	    //   var token = authtokenService.getToken();
	    //   var getPdfFunction = function() {
	    //   var req = new XMLHttpRequest();
	    //   var filename = postItem._id + '-approval.pdf';
	    //     req.open("GET", postItem.approval_url, true);
	    //     req.setRequestHeader('x-auth', token)
	    //     req.responseType = "blob";
	    //     req.onload = function (event) {
	    //         var blob = req.response;
	    //         var link=document.createElement('a');
	    //         link.href=window.URL.createObjectURL(blob);
	    //         link.style = "display: none";
	    //         document.body.appendChild(link);  
	    //         link.download=filename;
	    //         link.click();
	    //         setTimeout(function(){
	    //           document.body.removeChild(link);
	    //         },0)
	    //     };
	    //     req.send();
	    //   }
	    //   getPdfFunction();
	    // }
	    var detachFunction = function() {
	      postDataService.save({
	        param1:state,
	        param2:'detach'
	      },{
	        'ids': vml.checkedPostsforDetach,
	      }).$promise.then(function(data){
	          vml.checkedPostsforDetach = [];
	          watchAllCheckboxesNgTable.resetCheckBox(vml)
	          vml.selectedBulkAction = {value: 'default'}; 
	          alertService('success','Success ', data.message, 2000);
	          vml.tableParams.reload();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                detachFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        vml.checkedPostsforDetach = [];
	        watchAllCheckboxesNgTable.resetCheckBox(vml)
	        vml.selectedBulkAction = {value: 'default'}; 
	      });
	    }
	    vml.detach = function(attachment_id) {
	      if(attachment_id) {
	        vml.checkedPostsforDetach = [attachment_id];
	        detachFunction();
	      }
	    }
	    vml.attachToPost = function(attachment_id) {
	      if(attachment_id) {
	        vml.checkedPostsforAttach = [attachment_id];
	        vml.attachToPostModalOpen();
	      }
	    }
	    vml.attachToPostModalOpen = function() {
	      vml.attachToPostModalShow = true;
	      $rootScope.modalShow = true;
	    }
	    vml.cancelAttachToPostModal = function() {
	      vml.attachToPostModalShow = false;
	      vml.checkedPostsforAttach = [];
	      $rootScope.modalShow = false;
	      watchAllCheckboxesNgTable.resetCheckBox(vml)
	      vml.selectedBulkAction = {value: 'default'};
	      // vml.tableParams.reload(); 
	    }
	    vml.openCropModal = function(post) {
	        vml.cropModalShow = true;
	        vml.mediaItemToCrop.featured_img_obj = post;
	        vml.mediaItemToCrop.featured_img_id = post._id; 
	        // vml.mediaItemToCrop.featured_img = post.thumbs['830x0'];
	        // vml.mediaItemToCrop.featured_img_width = post.meta.width;
	        // vml.mediaItemToCrop.featured_img_height = post.meta.height;
	        // vml.mediaItemToCrop.featured_img_thumbs = post.thumbs;
	        $rootScope.modalShow = true;
	    }
	    vml.mediaItemToCrop.cancelCropModal = function() {
	      vml.cropModalShow = false;
	      $rootScope.modalShow = false;
	    }
	    vml.editMedia = function(attachmentId) {
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      vml.attachmentId = attachmentId;
	      vml.editMediaShow = true;
	      $state.transitionTo('app.library', {id: vml.attachmentId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vml.editMediaModal = function(index,media_id) {
	      vml.editMediaModalShow = true;
	      vml.selectedImage = index;
	      vml.selectedMediatoEdit = index;
	      vml.attachmentId = media_id;
	      // $scope.$broadcast("editMediaModal", {mediaIndex:index});
	    }
	    vml.cancelMediaModal = function() {
	      vml.editMediaModalShow = false;
	      vml.selectedMediatoEdit = 0;
	      vml.attachmentId = null;
	      $rootScope.modalShow = false;
	    }
	    vml.getGrid = function() {
	      var grid_wrapp = angular.element(document.getElementsByClassName("grid-wrapper"));
	      var table = angular.element(document.getElementsByClassName("table"));
	      table.after(grid_wrapp);    
	    }
	    vml.goToEditPost = function(post_id) {
	      $rootScope.mediaComunicateWithEditPost = post_id;
	      $state.go('app.allposts');
	    }
	    var deleteFunction = function() {
	      putDataService.update({
	        param1:state, 
	        param2: 'bulk',
	        param3:'delete'
	        },{
	          'delete_ids':vml.checkedPostsforDelete,
	        }).$promise.then(function(bulkDelete){
	          $rootScope.hasLoaded = true;
	          vml.checkedPostsforDelete = [];
	          watchAllCheckboxesNgTable.resetCheckBox(vml)
	          vml.selectedBulkAction = {value: 'default'}; 
	          alertService('success','Success ', bulkDelete.message, 2000);
	          vml.tableParams.reload();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                deleteFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(error.status ==502) {
	          serverError();
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;
	        vml.checkedPostsforDelete = [];
	        watchAllCheckboxesNgTable.resetCheckBox(vml)
	        vml.selectedBulkAction = {value: 'default'};   
	      });
	    }
	    vml.uploadApprovalRestrictions = function() {
	      vml.uploadApprovalRestrictionsModal = true;
	      $rootScope.modalShow = true;
	    }
	    vml.cancelUploadApprovalRestrictionsModal = function() {
	      vml.uploadApprovalRestrictionsModal = false;
	      // vml.checkedPostsforRestrictions = [];
	      $rootScope.modalShow = false;
	      watchAllCheckboxesNgTable.resetCheckBox(vml)
	      vml.selectedBulkAction = {value: 'default'};
	      // vml.tableParams.reload(); 
	    }
	    vml.deletePosts = function(post_id) {
	      $rootScope.hasLoaded = false;
	      vml.checkedPostsforDelete = [];
	      vml.checkedPostsforDelete.push(post_id)
	      deleteFunction();  
	    }
	    vml.bulkAction = function(param) {
	      vml.checkedPostsforDelete = []
	      vml.addRestrictions = false;
	      if(param == "edit" && vml.checkedPostsEdit.length > 0) {
	        vml.hiddenBulkEdit =false;
	      } else if(param == 'addRestrictions' && vml.checkedPostsEdit.length>0){
	        vml.hiddenBulkEdit =false;
	        vml.addRestrictions = true;
	      }else if(param == 'removeRestrictions' && vml.checkedPostsEdit.length>0){
	        $timeout(function() {
	          vml.updateBulkAction('remove-restrictions')
	        },0)
	      } else if (param == 'delete' && vml.checkedPostsEdit.length>0 ) {
	        vml.hiddenBulkEdit =true;
	        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
	          vml.checkedPostsforDelete.push(vml.checkedPostsEdit[i]._id);
	        }
	        deleteFunction(param == 'delete' && vml.checkedPostsEdit.length>0);
	      } else if(param == 'attach' && vml.checkedPostsEdit.length>0) {
	        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
	          vml.checkedPostsforAttach.push(vml.checkedPostsEdit[i]._id);
	        }
	        $timeout(function() {
	          vml.attachToPostModalOpen();
	        },0)
	      } else if(param == 'detach' && vml.checkedPostsEdit.length>0) {
	        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
	          vml.checkedPostsforDetach.push(vml.checkedPostsEdit[i]._id);
	        }
	        $timeout(function() {
	          detachFunction();
	        },0)
	      } else if(param == 'uploadApprovalRestrictions' && vml.checkedPostsEdit.length>0) {
	        // vml.checkedPostsforRestrictions = [];
	        // console.log(vml.checkedPostsEdit)
	        // for(var i=0;i<vml.checkedPostsEdit.length;i++) {
	        //   vml.checkedPostsforRestrictions.push(
	        //     {
	        //       '_id' : vml.checkedPostsEdit[i]._id
	        //     }
	        //   );
	        // }
	        vml.uploadApprovalRestrictions();
	      } else if ((param == 'publish' && vml.checkedPostsEdit.length>0) || (param=='lock' && vml.checkedPostsEdit.length>0)) {
	        vml.checkedPostsforLockOrUnlock = []
	        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
	          vml.checkedPostsforLockOrUnlock.push(vml.checkedPostsEdit[i]._id);
	        }
	        changeMediaStatus(vml.checkedPostsforLockOrUnlock, param)
	      }
	    }
	    watchAllCheckboxesNgTable.watch($scope,vml,true)
	    vml.checkedPost = function(checked,post) {
	      if (checked) {
	        vml.checkedPostsEdit.push(post);
	      } else {
	       vml.checkedPostsEdit = vml.checkedPostsEdit.filter(function( obj ) {
	            return obj._id !== post._id;
	        });
	      } 
	    }
	    vml.removeEditPost = function(post_id) {
	      vml.checkedPostsEdit = vml.checkedPostsEdit.filter(function( obj ) {
	            return obj._id !== post_id;
	      });
	      vml.checkboxes.items[post_id] = false;
	      if(!vml.checkedPostsEdit.length > 0) {
	        vml.cancelBulkEdit();
	      }
	    }
	    vml.cancelBulkEdit =function() {
	      vml.hiddenBulkEdit = true;
	      vml.addRestrictions = false;
	      vml.myDateRangeRestrictions = '';
	      vml.numberOfUsesRestrictions = null;
	      vml.date_start_restrictions = null;
	      vml.date_end_restricitons = null;
	      vml.checkboxes.checked= false;
	      vml.bulkTitle = '';
	      vml.bulkGalleryTitle = '';
	      vml.bulkDescription = '';
	      vml.bulkSignature = '';
	      vml.bulkSignatureUrl = '';
	      vml.lockPhoto = false;
	      vml.selectedBulkAction={value:'default'};
	      vml.checkedPostsforUpdate = [];
	      
	    }
	    vml.updateBulkAction = function(param) {
	      vml.checkedPostsforUpdate = [];
	      for(var i = 0; i<vml.checkedPostsEdit.length;i++) {
	        vml.checkedPostsforUpdate.push(vml.checkedPostsEdit[i]._id)
	      }
	      if(vml.checkedPostsforUpdate.length==0) return
	      if(param == 'remove-restrictions') {
	        var updateData = { 
	          'ids': vml.checkedPostsforUpdate,
	          'remove_restrictions': true
	        }
	      } else {
	        if(vml.addRestrictions) {
	          if(!vml.numberOfUsesRestrictions && !vml.date_start_restrictions) {
	            alertService('danger','Opps! ', 'You have to fill at least one field');
	            return
	          }
	          var updateData = { 
	            'ids': vml.checkedPostsforUpdate,
	            'restrictions':{
	              date_from :  (vml.date_start_restrictions)? vml.date_start_restrictions: undefined,
	              date_to :  (vml.date_end_restricitons)? vml.date_end_restricitons: undefined,
	              use_max : (vml.numberOfUsesRestrictions)? parseInt(vml.numberOfUsesRestrictions) : undefined
	            }
	          }
	        } else {
	          if(!vml.bulkTitle && !vml.bulkSignature && !vml.bulkDescription && !vml.bulkSignatureUrl && !vml.lockPhoto && !vml.bulkGalleryTitle) {
	            alertService('danger','Opps! ', 'You have to fill at least one field');
	            return
	          }
	          var updateData = {
	            'ids': vml.checkedPostsforUpdate,
	            'title': (vml.bulkTitle)? vml.bulkTitle:undefined,
	            'gallery_title': (vml.bulkGalleryTitle)? vml.bulkGalleryTitle:undefined,
	            'signature': (vml.bulkSignature)? vml.bulkSignature:undefined,
	            'signature_url': (vml.bulkSignatureUrl)? vml.bulkSignatureUrl:undefined,
	            "description": (vml.bulkDescription)? vml.bulkDescription:undefined,
	            'restrictions': (vml.lockPhoto)? {'use_max': 0 }: undefined  
	          }
	        }
	      }
	      $rootScope.hasLoaded = false;
	      var postFunction = function() { 
	        postDataService.save({
	          param1:state,
	          param2:'multi-update'
	        },updateData).$promise.then(function(data){
	          alertService('success','Success ', data.message, 2000);
	          $rootScope.hasLoaded = true;
	          vml.cancelBulkEdit();
	          vml.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  postFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	                // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	          vml.cancelBulkEdit();
	        });
	      }
	      postFunction();
	    }
	    vml.editDescription = function(index) {
	      vml.selectedDescription = index;
	    }
	    vml.cancelEditDescription = function() {
	      vml.selectedDescription = -1;
	    }
	    vml.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        vml.checkedTypeSearch = false;
	        $timeout(function() {
	          vml.search();
	        },0)            
	      }
	    }
	    vml.switchAuthorFilter = function(item) {
	        author = item;
	        if (item=='all') {
	          author = null;
	        }
	    }
	    vml.changeDate = function(value) {
	      vml.dateRangevalue= value;
	      if(vml.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	        date_start = null;
	        date_end = null;
	      }
	    }
	    var getAuthorsFunction = function() {
	      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
	        vml.authorList = data.users;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getAuthorsFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getAuthorsFunction();
	    var reloadTableFunction = function() {
	      if(vml.tableParams.page() ==1) {
	        vml.tableParams.reload();
	      } else {
	        vml.tableParams.page(1);
	      }
	    } 
	    vml.mediaFilters = function() {
	      reloadTableFunction();
	    }
	    vml.resetAllFilters = function() {
	      vml.status = 'all';
	      uploaded_to = null;
	      vml.searchData = null;
	      s =null;
	      author = null;
	      vml.selectedAuthorFilter = {value: 'all'};
	      date_start = null;
	      date_end = null;
	      $scope.$broadcast('clear-daterange',true);
	      vml.checkedTypeSearch = false;
	      reloadTableFunction();
	    }
	    vml.authorPosts = function(value) {
	      author = value;
	      reloadTableFunction();
	    }
	    vml.uploadeToPost = function(uploadedTo) {
	      uploaded_to = uploadedTo;
	      reloadTableFunction();
	    }
	    vml.changeStatus =function(event,activeStatus) {
	      vml.status = activeStatus;
	      if(activeStatus =='all') {
	        uploaded_to = null;
	      } else {
	        uploaded_to = activeStatus;
	      }
	      reloadTableFunction();
	    }
	    vml.search =function(value) {
	      if(value) {
	        s = value.toLowerCase();
	      } else {
	        vml.checkedTypeSearch = false;
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    vml.tableReloadFunction = function(page) { 
	      vml.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            page: params.page(),
	            limit: params.count(),
	            author: author,
	            s:s,
	            type:(vml.checkedTypeSearch && s)? 'all':undefined,
	            uploaded_to:uploaded_to,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end
	            }).$promise.then(function(data){
	              $rootScope.hasLoaded = true;
	              vml.dataGet = data.attachments;
	              vml.data_grid =data.attachments;
	              $data =data.attachments;
	              $rootScope.emptyTable = false;
	              watchAllCheckboxesNgTable.resetCheckBox(vml)
	              vml.cancelBulkEdit();  
	              params.total(data.count);
	              params.numPages(data.max_pages);
	              jQuery('.goTo input').val("");
	              if(vml.showGrid){
	                $timeout(function() {
	                  vml.getGrid();
	                },0)
	              }
	              return $data;
	            }, function(error){
	              if(!window.navigator.onLine) {
	                $rootScope.hasLoaded = true;
	                offlineError('refresh')
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {
	                      vml.tableReloadFunction(params.page());
	                    }
	                    // do something
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                  });
	              } else if(error.status ==404) {
	                $rootScope.emptyTable = true;
	              } else if(error.status ==502) {
	                serverError();
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true; 
	            });
	          }    
	      });
	    }
	    vml.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var media = angular.module('mediaModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'ui.tinymce',
		'thatisuday.dropzone'	
	]);
	
	__webpack_require__(515)(media);
	__webpack_require__(519)(media);
	__webpack_require__(521)(media);
	__webpack_require__(522)(media);
	__webpack_require__(517)(media);
	__webpack_require__(516)(media);
	__webpack_require__(514)(media);
	__webpack_require__(518)(media);
	__webpack_require__(513)(media);
	__webpack_require__(523)(media);
	__webpack_require__(524)(media);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('newMediaDir',newMediaDir);
		newMediaDir.$inject=[];
		function newMediaDir() {
			return {
				template: __webpack_require__(275),
				controller:"newMediaController",
				controllerAs:"vmnm",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		media
	    .controller('newMediaController', newMediaController)
	
		newMediaController.$inject = ["keyPressOnlyNumber","$state","$scope", 'jQuery','$rootScope'];
		
	    function newMediaController(keyPressOnlyNumber,$state,$scope,jQuery, $rootScope) {
	    var vmnm = this;
	    vmnm.data_grid = [];
	    vmnm.editImageModal = false;
	    vmnm.cancelMediaModal =function() {
	       vmnm.editMediaModalShow = false;
	        $rootScope.modalShow = false; 
	    }
	    vmnm.onlyNumber = function(event) {
	       keyPressOnlyNumber(event) 
	    }
	    vmnm.editMedia = function (attachmentId){
	        jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      $state.transitionTo('app.library', {id: attachmentId});
	    }
	    vmnm.deleteImage = function(id) {
	        $scope.$broadcast('delete-photo-from-upload',{id:id});
	    }
	    
	    jQuery(document).on('click','.upload-image',function() {
	        var name = jQuery(this).attr('alt');
	        for(var i=0; i<vmnm.data_grid.length;i++) {
	            if(name == vmnm.data_grid[i].name) {
	             vmnm.attachment_id = vmnm.data_grid[i]._id;
	            $scope.$apply(function() {
	                vmnm.editMediaModalShow = true;
	                $rootScope.modalShow = true;
	                vmnm.selectedMediatoEdit = i;
	                vmnm.attachmentId = vmnm.data_grid[i]._id;
	            })
	
	            }
	        }
	    });
	  }	
	}


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('relatedGalleriesDir',relatedGalleriesDir);
		relatedGalleriesDir.$inject=[];
		function relatedGalleriesDir() {
			return {
				template: __webpack_require__(276),
				controller:'relatedGalleriesController',
				controllerAs:'vmrg',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		"use strict";
	  media
	  .controller('relatedGalleriesController', relatedGalleriesController)
		relatedGalleriesController.$inject = ["API_URL","$http","$rootScope","getDataService","refreshtokenService","alertService","serverError","offlineError"];
	  function relatedGalleriesController(API_URL,$http,$rootScope,getDataService,refreshtokenService,alertService,serverError,offlineError) {
	    var vmgr = this;
	    var state = 'intext-galleries';
	    vmgr.limitPosts = 3;
	    vmgr.allPosts = [];
	    vmgr.selectedCategoryAction = { value:'vesti'};
	    vmgr.switchCategoryAction= function(category_id) {
	      vmgr.allPosts = [];
	      getSharedPosts();
	    }
	    vmgr.allPostSave = function(categoryName) {
	      var posts =[];
	      if(vmgr.allPosts.length < vmgr.limitPosts) {
	        alertService('danger', 'Opps! ', 'Minimum number of posts is ' +vmgr.limitPosts+'!');
	        return
	      }
	     
	      for (var i=0; i<vmgr.allPosts.length;i++) {
	        posts.push({'_id':vmgr.allPosts[i]._id, 'order':vmgr.allPosts[i].order, "custom_title":vmgr.allPosts[i].custom_title || "", "gallery_number":vmgr.allPosts[i].gallery_number, "post_id":vmgr.allPosts[i].post_id['_id']});
	      }
	      $rootScope.hasLoaded = false;
	      var updateFunction = function(url) {
	        $http.put(url , posts)
	        .success(function (data, stat, headers) {
	          // $rootScope.hasLoaded = true;
	          getSharedPosts()
	          alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  updateFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	                // report progress
	            });
	          }else if(status ==502) {
	            serverError()  
	          } else { 
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      updateFunction(API_URL+ state + "/"+vmgr.selectedCategoryAction.value);
	    }
	    vmgr.removeFromPopularPosts = function(index) {
	      vmgr.allPosts.splice(index,1);
	    }
	    var getSharedPosts = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:state, category:vmgr.selectedCategoryAction.value}).$promise.then(function(data){  
	        $rootScope.hasLoaded = true;
	        if(data.galleries) {
	          vmgr.allPosts = data.galleries;
	          for (var i=0; i<vmgr.allPosts.length;i++) {
	            if(!vmgr.allPosts[i].max_galleries) {
	              vmgr.allPosts[i].max_galleries = 1;
	            }
	            if(!vmgr.allPosts[i].gallery_number) {
	              vmgr.allPosts[i].gallery_number = 1;
	            }
	            if(parseInt(vmgr.allPosts[i].gallery_number)> parseInt(vmgr.allPosts[i].max_galleries)) {
	              vmgr.allPosts[i].gallery_number = vmgr.allPosts[i].max_galleries
	            }  
	            vmgr.allPosts[i].galleriesArray = (function() {
	              return new Array(parseInt(vmgr.allPosts[i].max_galleries));   
	          })()
	          }
	        }
	        if(data.categories) {
	          vmgr.allCategories = data.categories
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getSharedPosts();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        } 
	        $rootScope.hasLoaded = true;
	      });
	    }
	    getSharedPosts()
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }
	}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var menus = angular.module('menusModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		'ngBootstrap',
		'ui.tree',
		'slugifier',
		'color.picker'
	]).config(['$provide',function($provide) {
		$provide.decorator('ColorPickerOptions',['$delegate', function($delegate) {
			var options = angular.copy($delegate);
			options.round = false;
			options.alpha = false;
			options.format = 'hexString';
			options.saturation = false;
			options.reset = {
				show: false
			};
			options.close = {
				show:  true
			};
			options.allowEmpty = true;
			return options;
		}]);
	}]);;
	__webpack_require__(528)(menus);
	__webpack_require__(529)(menus);
	__webpack_require__(527)(menus);
	__webpack_require__(526)(menus);
	
	


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(menus) {
		'use strict'
		menus.directive('checkedListMenuDir',checkedListMenuDir);
		checkedListMenuDir.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
		function checkedListMenuDir($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
			return {
				restrict: 'E',
				scope:{
					type:'=',
					list:'=',
	                itemChecked:'=',
					menu:'=',
				},
				replace:true,
				template: __webpack_require__(277),
				link: function(scope, ele, $attrs, ctrl) {
	                function chechedRecursion(id, title, item, menuChildrenArray) {
	                    scope.itemChecked[id] = true;
						if(!scope.menu) {
							scope.menu = []
						}
						var obj = {
							objId: id,
							title: title,
							type: scope.type,
							url:item.url,
							_id:Math.random().toString(36).substring(2, 32),
							children:[]
						}
						if(item.ancestors && item.ancestors.length>0) {
							obj.ancestors = item.ancestors
						}
						scope.menu.push(obj)
	                    if(item.children && item.children.length>0) {
	                        for(var i = 0;i<item.children.length;i++) {
	                            if(scope.type == 'page') {
	                                chechedRecursion(item.children[i].slug, item.children[i].title, item.children[i], obj.children)
	                            } else {
	                                chechedRecursion(item.children[i]._id, item.children[i].name, item.children[i], obj.children)
	                            }
	                        }
	                    }
	                }
					function uncheckedRecursion(id, item,menu) {
						scope.itemChecked[id] = false;
						if(item.children && item.children.length>0) {
							for(var i = 0;i<item.children.length;i++) {
	                            if(scope.type == 'page') {
	                                uncheckedRecursion(item.children[i].slug, item.children[i])
	                            } else {
	                                uncheckedRecursion(item.children[i]._id, item.children[i])
	                            }
	                        }
						}
						if(scope.menu && scope.menu.length>0) {
							var index =-1;
							for(var i = 0; i<scope.menu.length;i++) {
								if(scope.menu[i].objId == id) {
									index = i
									break
								}
							}
							if(index>-1) {
								scope.menu.splice(index,1)
							}
						}
					}
					scope.updateSelection = function(id, checked, title, item) {
						if(checked) {
	                        chechedRecursion(id, title,item)
						} else {
							uncheckedRecursion(id,item)
						}
					}
				}
			}
		}
	}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(menus) {
		'use strict'
		menus.directive('checkedWidgetDir',checkedWidgetDir);
		checkedWidgetDir.$inject=['checkArray','$filter'];
		function checkedWidgetDir(checkArray, $filter) {
			return {
				restrict: 'E',
				scope:{
					type:'=',
					list:'=',
					parentObj:'='
				},
				replace:true,
				template: __webpack_require__(278),
				link: function(scope, ele, $attrs, ctrl) {
	                scope.menu = []
	                scope.itemChecked = {}
					scope.checkedRequired = false;
					var addedArray = []
					scope.searchData = {}
					function removeAncestors(array) {
						for(var i = 0;i<array.length;i++) {
							delete array[i].ancestors
							if(array[i].children && array[i].children.length>0) {
								removeAncestors(array[i].children)
							}
						}
					}
					function applyFilter() {
						scope.filteredList = scope.list
						var searchData = (scope.type=='category')?scope.searchData.name:scope.searchData.title 
						if(searchData) {
						  scope.filteredList = $filter('filter')(scope.filteredList,scope.searchData)
						}
					}
					scope.changeSearch = function() {
						applyFilter()
					}
					applyFilter()
	                scope.addNavigationItem = function() {
						addedArray.length = 0;
						scope.checkedRequired = false
						if(scope.menu.length == 0) {
							scope.checkedRequired =true;
							return
						}
						addedArray = checkArray.reconstructArrayByAncestors(scope.menu)
						removeAncestors(addedArray)
						for(var i = 0; i<addedArray.length;i++) {
							scope.parentObj.navigationValue.push(addedArray[i])
						}
						scope.menu.length = 0;
						scope.itemChecked = {}
						scope.searchData = {}
						applyFilter()
	                }
				}
			}
		}
	}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(menus) {
		'use strict'
		menus.directive('menusDir',menusDir);
		menusDir.$inject=[];
		function menusDir() {
			return {
				template: __webpack_require__(279),
				controller:'menusController',
				controllerAs:'vmm',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = function(menus) {
		"use strict";
	  menus
	  .controller('menusController', menusController)
		menusController.$inject = ["$state","$stateParams","authtokenService","$window","config","API_URL","Slug","$timeout","$http","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService", "putDataService","postDataService","cleanObj","serverError","offlineError"];
	  function menusController($state,$stateParams,authtokenService,$window,config,API_URL,Slug,$timeout,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService,putDataService,postDataService,cleanObj,serverError,offlineError) {
	    var vmm = this;
	    var token = authtokenService.getToken();
	    Dropzone.autoDiscover = false;
	    vmm.dropzone = {};
	    vmm.selectedMenuAction = {value:'create-new'};
	    vmm.linkUrl = "";
	    vmm.navigationId;
	    vmm.openItem = {};
	    vmm.copyNode = {};
	    vmm.navigationOptions = {};
	    vmm.menuOptions = [];
	    if($rootScope.role_id == 'superadmin') {
	      vmm.superAdminPermisions = true;
	    }
	    vmm.isNumberKey = function(evt) {
	      var charCode = (evt.which) ? evt.which : evt.keyCode;
	      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
	        evt.preventDefault();
	      }
	    }
	    // vmm.treeOptions = {
	    //   dropped: function(event) {
	    //     if(event.dest.nodesScope.depth()==0) {
	    //       event.source.nodeScope.$modelValue.topLevel = true;
	    //     } else {
	    //       event.source.nodeScope.$modelValue.topLevel = false;
	    //       delete event.source.nodeScope.$modelValue.color
	    //     }
	    //   }
	    // }
	    function addEmptyArrayFunction() {
	      var addEmptyArry = function(arry) {
	        for (var i=0; i<arry.length; i++) {
	          arry[i]._id = Math.random().toString(36).substring(2, 32);
	          if(arry[i].children) {
	            addEmptyArry(arry[i].children)
	          } else {
	            arry[i].children = [];
	          }
	        }
	      }
	      addEmptyArry(vmm.navigationValue)
	    }
	    function cleanEmptyArrayFunction() {
	      var cleanEmptyArray = function(array) {
	        for (var i=0; i<array.length; i++) {
	          delete array[i]._id;
	          if(array[i].children) {
	            if(array[i].children.length == 0) {
	              delete array[i]['children'];
	
	            } else {
	              cleanEmptyArray(array[i].children)
	            }
	          }
	        }
	        vmm.openItem = {}
	      }
	      cleanEmptyArray(vmm.navigationValue);
	    }
	    // vmm.previewMenu = function(node) {
	    //   var previewObj =[]
	    //   var uri = '';
	    //   var getItemsWidthColor = function(array, children, parent) {
	    //     for (var i=0; i<array.length; i++) {
	    //       if(node && children && parent && parent.uri && node.objId == array[i].objId) {
	    //         uri = parent.uri
	    //       }
	    //       if(array[i].color) {
	    //         previewObj.push(
	    //           {
	    //             item : array[i].objId,
	    //             type: array[i].type,
	    //             fc : array[i].color.font,
	    //             bc : array[i].color.background
	    //           }
	    //         )
	    //       }
	    //       if(array[i].children && array[i].children.length > 0) {
	    //         getItemsWidthColor(array[i].children, 'children', array[i])
	    //       }
	    //     }
	    //   }
	    //   getItemsWidthColor(vmm.navigationValue)
	    //   if(uri) {
	    //     if(uri.charAt(0) == '/' && config.baseHref.charAt(config.baseHref.length -1) == '/') {
	    //       uri = uri.slice(1,uri.length)
	    //     } else if(uri.charAt(0) != '/' && config.baseHref.charAt(config.baseHref.length -1) != '/') {
	    //       uri = '/' + uri
	    //     } else {
	    //       uri = uri
	    //     }
	    //   }
	    //   $window.open(config.baseHref + uri + "?preview=true&data=" + encodeURIComponent(JSON.stringify(previewObj)), '_view');
	    //   previewObj = null;
	    // }
	    $scope.$on('select-tag', function(event,data) {
	      vmm.tagObj = data.selectedTagObj;
	    });
	    vmm.addNavigationItem = function(node_type) {
	      function addNavigationItemFunction(nodeTitle, nodeUrl, nodeId) {
	        var obj = {
	          title:nodeTitle,
	          type:node_type,
	          url: nodeUrl,
	          _id: Math.random().toString(36).substring(2, 32),
	          objId: nodeId,
	          children:[]
	        }
	        vmm.navigationValue.push(obj);
	      }
	
	      var validationItem = true;
	      if(node_type == 'post_tag') {
	        if(vmm.tag) {
	          vmm.tagRequired = false
	        } else {
	          vmm.tagRequired = true;
	          validationItem = false
	        }
	        if(validationItem) {
	          addNavigationItemFunction(vmm.tagObj.tagName, vmm.tagObj.tagUrl, vmm.tagObj.tagId);
	          vmm.tag = '';
	        }
	      }
	      if (node_type == 'custom') {
	        if(!vmm.linkUrl) {
	          vmm.linkUrlRequired = true;
	          validationItem = false;
	        } else {
	          vmm.linkUrlRequired = false;
	        }
	        if(vmm.linkText) {
	          vmm.linkTextRequired = false;
	        } else {
	          vmm.linkTextRequired = true;
	          validationItem = false;
	        }
	        if(validationItem) {
	          addNavigationItemFunction(vmm.linkText, vmm.linkUrl, Slug.slugify(vmm.linkText));
	          vmm.linkUrl = '';
	          vmm.linkText = null;
	        }
	      }
	      if(node_type == 'post') {
	        if(vmm.searchPostObj) {
	          vmm.singlePostRequired = false
	        } else {
	          vmm.singlePostRequired = true
	          validationItem = false;
	        }
	        if(vmm.singlePostLabel) {
	          vmm.singlePostLabelRequired = false
	        } else {
	          vmm.singlePostLabelRequired = true
	          validationItem = false;
	        }
	        if(validationItem) {
	          addNavigationItemFunction(vmm.singlePostLabel, vmm.searchPostObj.url,vmm.searchPostObj.id)
	          vmm.searchPostReset()
	          vmm.singlePostLabel = '';
	        }
	      }
	    }
	    function transitionTo(id) {
	      $state.transitionTo('app.menus', {id: id}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    function createNewMenu() {
	      vmm.newMenu = true;
	      vmm.navigationValue = [];
	      vmm.navigationOptions = {};
	      vmm.selectedMenuType = {value:'desk'};
	      vmm.selectedMenuAction.value = 'create-new';
	      vmm.createMenuName = '';
	      vmm.createMenuVer = '';
	      vmm.menuExist = false;
	      vmm.menuNameRequired = false;
	      vmm.menuVersionRequired = false;
	    }
	    vmm.createNewMenu = function() {
	      createNewMenu()
	      transitionTo(vmm.selectedMenuAction.value)
	    }
	    vmm.changeNavigationsOptions = function(navigationId) {
	      vmm.openItem = {};
	      vmm.copyNode = {};
	      if(navigationId == 'create-new') {
	        createNewMenu()
	      } else {
	        vmm.newMenu = false;
	        vmm.navigationId = navigationId;
	        getNavigationFunction();
	      }
	      transitionTo(navigationId)
	    }
	    vmm.toggleNavigationItemChildren = function(element) {
	      element.toggle();
	    }
	    vmm.removeItem = function(element) {
	      element.remove();
	    }
	    function initalizedDropzone(node, type) {
	      if(!vmm.dropzone[node._id]) {
	        vmm.dropzone[node._id] = {
	        }
	      }
	      vmm.dropzone[node._id][type]={
	        dzOptions : {
	          url :API_URL+'upload/navigation',
	          paramName : 'photo',
	          maxFilesize : '500',
	          parallelUploads: 1,
	          acceptedFiles : '.svg, image/png',
	          addRemoveLinks : true,
	          autoProcessQueue : false,
	          dictInvalidFileType: 'This file type is not supported.',
	          dictFileTooBig:'File size too Big',
	          headers:{
	            'x-auth': token  
	          }
	        },
	        dzCallbacks : {
	          'addedfile' : function(file){
	            node[type] = null
	            if(vmm.dropzone[node._id][type].file) {
	              vmm.dropzone[node._id][type].dzMethods.removeFile(vmm.dropzone[node._id][type].file);
	            }
	            vmm.dropzone[node._id][type].file = file;
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                token = authtokenService.getToken();
	                vmm.dropzone[node._id][type].dzOptions.headers['x-auth'] = token;
	                vmm.dropzone[node._id][type].dzMethods.processQueue();
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	                // report progress
	            });
	          },
	          'success' : function(file, xhr, response){
	            file.previewElement.classList.remove("dz-error");
	            var data = JSON.parse(response.currentTarget.response);
	            if(data && data.url) {
	              $timeout(function() {
	                node[type] = {
	                  url:data.url,
	                  width: data.width,
	                  height: data.height
	                }
	                vmm.dropzone[node._id][type].dzMethods.removeFile(vmm.dropzone[node._id][type].file);
	                vmm.dropzone[node._id][type].file = null;
	              },1000) 
	            }
	          },
	          'error' : function(file,message) {
	            if(message && message.error && message.error.message) {
	              jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
	            }
	          },
	          'sending':function(file, xhr, formData) {
	          },
	          'complete':function(file) {
	            if(file.xhr && file.xhr.status == 401) {
	                file.previewElement.classList.remove("dz-error");
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                    function(answer) {
	                    if(answer==200) {   
	                      var token = authtokenService.getToken();
	                      vmm.dropzone[node._id][type].dzOptions.headers['x-auth'] = token;
	                      vmm.dropzone[node._id][type].dzMethods.uploadFile(file)
	                    }
	                    },
	                    function(error) {
	                    },
	                    function(progress) {
	                    // report progress
	                });
	            }
	          }
	        },
	        dzMethods : {
	        }
	      }
	    }
	    function destroyDropzone(nodeId,type) {
	      if(type) {
	        vmm.dropzone[nodeId][type] = null
	      } else {
	        vmm.dropzone[nodeId] = null
	      }
	    }
	    vmm.navigationOptionsChange = function(bool,type) {
	      if(bool) {
	        for(var key in vmm.openItem) {
	          if(!vmm.dropzone[key] || !vmm.dropzone[key][type]) {
	            initalizedDropzone(vmm.openItem[key], type)
	          }
	        }
	      } else {
	        for(var key in vmm.openItem) {
	          if(vmm.dropzone[key] && vmm.dropzone[key][type]) {
	            destroyDropzone(key,type)
	            delete vmm.copyNode[key][type]
	          }
	        }
	        var deleteTypeProp = function(array) {
	          for (var i=0; i<array.length; i++) {
	            delete array[i][type];
	            if(array[i].children) {
	              deleteTypeProp(array[i].children)
	            }
	          }
	        }
	        deleteTypeProp(vmm.navigationValue);
	      }
	    }
	    vmm.toggleNavigationItem = function(node) {
	      vmm.copyNode[node._id] = angular.copy(node);
	      if(vmm.openItem[node._id]) {
	        vmm.openItem[node._id] = false
	      } else {
	        vmm.openItem[node._id] = node
	      }
	      if(vmm.openItem[node._id]) {
	        if(vmm.navigationOptions.image) {
	          initalizedDropzone(node, 'image')
	        }
	        if(vmm.navigationOptions.hamburger_image) {
	          initalizedDropzone(node, 'hamburger_image')
	        }
	      } else {
	        destroyDropzone(node._id)
	      }
	    }
	    vmm.cancelEditItem = function(node) {
	      vmm.openItem[node._id] = false;
	      if(vmm.dropzone[node._id]) {
	        destroyDropzone(node._id)
	      }
	      function mergeObjects(obj1, obj2) {
	        for (var key in obj1) {
	            if (!obj2.hasOwnProperty(key)) {
	                delete obj1[key];
	            }
	        }
	        for (var key in obj2) {
	            if(key != 'children') {
	              obj1[key] = obj2[key];
	            }
	        }
	      }
	      //mutate node obj
	      mergeObjects(node, vmm.copyNode[node._id]);
	    }
	    vmm.removeColor = function(node, type) {
	      delete node.color[type];
	      if (Object.keys(node.color).length === 0 && node.color.constructor === Object) {
	        delete node.color;
	      }
	    }
	    vmm.addColor = function(node, type) {
	      if(node.color) {
	        node.color[type] = "#ffffff";
	      } else {
	        node.color = {};
	        node.color[type] = "#ffffff";
	      }
	    }
	    vmm.removeImage = function(node, type) {
	      delete node[type];
	    }
	    var saveOrUpdateMenuFunction = function(state) {
	      var postFunction = function() {
	        postDataService.save({
	          param1:'options', 
	          param2: 'navigation', 
	          param3:'save'
	        },{
	          menu_id: vmm.navigationId,
	          value: vmm.navigationValue,
	          options: (state=='create')? vmm.navigationOptions:undefined
	        }).$promise.then(function(data){
	            $rootScope.hasLoaded = true;
	            alertService('success','Success ', data.message, 2000);
	            addEmptyArrayFunction();
	            if(state=='create') {
	              vmm.newMenu = false;
	              vmm.menuOptions.push(vmm.navigationId);
	              vmm.selectedMenuAction.value = vmm.navigationId;
	              transitionTo(vmm.navigationId)
	            }
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                postFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    vmm.saveMenu = function(state) {
	      var validationSave = true;
	      var saveMenuFuncton = function(state) {
	        $rootScope.hasLoaded = false;
	        cleanEmptyArrayFunction();
	        saveOrUpdateMenuFunction(state);
	      }
	      if(state == 'create') {
	        var slug = Slug.slugify(vmm.createMenuName);
	        vmm.navigationId = vmm.selectedMenuType.value + '_' + slug + '_' + vmm.createMenuVer;
	        if(!vmm.menuOptions.includes(vmm.navigationId)) {
	          vmm.menuExist = false;
	        } else {
	          validationSave = false;
	          vmm.menuExist = true;
	        }
	        if(vmm.createMenuName) {
	          vmm.menuNameRequired = false;
	        }else {
	          validationSave = false;
	          vmm.menuNameRequired = true;
	        }
	        if(vmm.createMenuVer) {
	          vmm.menuVersionRequired = false;
	        }else {
	          validationSave = false;
	          vmm.menuVersionRequired = true;
	        }
	        if(validationSave) {
	          saveMenuFuncton(state);
	          vmm.createMenuName='';
	          vmm.createMenuVer='';
	        }
	      } else {
	        saveMenuFuncton();
	      }
	      
	    }
	    vmm.deleteMenu = function() {
	      $rootScope.hasLoaded = false;
	      var deleteFunction = function() { 
	        deleteDataService.remove({
	          param1:'options',
	          param2:'navigation',
	          param3:vmm.navigationId
	        }).$promise.then(function(data){
	            $rootScope.hasLoaded = true;
	            alertService('success','Success ', data.message, 2000);
	            vmm.menuOptions.splice(vmm.menuOptions.indexOf(vmm.navigationId),1);
	            $timeout(function() {
	              vmm.createNewMenu()
	            },0)
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                deleteFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      deleteFunction();
	    }
	    var getNavigationFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'options', param2: 'navigation',param3:vmm.navigationId}).$promise.then(function(data){
	        if(data.navigation.length>0) {
	          if(data.navigation[0].options) {
	            vmm.navigationOptions = data.navigation[0].options
	          } else {
	            vmm.navigationOptions = {}
	          }
	          if(data.navigation[0].value) {
	            vmm.navigationValue = data.navigation[0].value;
	            addEmptyArrayFunction();
	          }
	        }
	        $rootScope.hasLoaded = true;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	          function(answer) {
	            if(answer==200) {
	              getNavigationFunction();
	            }
	            // do something
	          },
	          function(error) {
	            // report something
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
	          },
	          function(progress) {
	           // report progress
	          });
	        }else if(error.status ==502) {
	            serverError();
	        } else {
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
	        }
	      });
	    };
	    var getCategoryAndPages = function() {
	      var getCategoriesFunction= function() {   
	        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){
	          vmm.categories = data.categories;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                getCategoriesFunction();
	              }
	             
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError();
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
	          }
	        });
	      }
	      var getPagesFunction = function() {
	        getDataService.get({param1:'pages', param2: 'list'}).$promise.then(function(data){
	          vmm.pages = data.pages;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                getPagesFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError();
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
	          }
	        });
	      }
	      getPagesFunction();
	      getCategoriesFunction();
	    }
	    var getNavigationsOptionsFunction = function() {
	      getDataService.get({param1:'options', param2: 'navigations'}).$promise.then(function(data){
	        if(data.navigations.length>0) {
	          vmm.menuOptions = data.navigations;
	          var current;
	          if($stateParams.id) {
	            for(var i = 0; i<vmm.menuOptions.length;i++) {
	              if($stateParams.id == vmm.menuOptions[i]) {
	                vmm.navigationId = vmm.menuOptions[i];
	                vmm.selectedMenuAction.value = vmm.menuOptions[i];
	                current = true
	                break
	              }
	            }
	            if($stateParams.id == 'create-new') {
	              vmm.selectedMenuAction.value = 'create-new'
	              current = true;
	              createNewMenu()
	            }
	          }
	          if(!current) {
	            vmm.navigationId = vmm.menuOptions[0];
	            vmm.selectedMenuAction.value = vmm.menuOptions[0];
	            transitionTo(vmm.menuOptions[0])
	          }
	        } else {
	          vmm.createNewMenu()
	        }
	        if(vmm.navigationId) {
	          getNavigationFunction(); 
	        }
	        getCategoryAndPages();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	          function(answer) {
	            if(answer==200) {
	              getNavigationsOptionsFunction();
	            }
	            // do something
	          },
	          function(error) {
	            // report something
	          },
	          function(progress) {
	           // report progress
	          });
	        }else if(error.status ==502) {
	          serverError();
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
	        }
	      });
	    };
	    getNavigationsOptionsFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }
	}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = function(notifications) {
		"use strict";
	  notifications
	  .controller('allNotificationsController', allNotificationsController)
		allNotificationsController.$inject = ["$timeout","keyPressOnlyNumberAndEnter","API_URL","addToOtherByUrl","deleteDataService","$http","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","postDataService","alertService","serverError","offlineError", "$attrs"];
		
	  function allNotificationsController($timeout,keyPressOnlyNumberAndEnter,API_URL,addToOtherByUrl,deleteDataService,$http,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,postDataService,alertService,serverError,offlineError,$attrs) {
	    var vman = this;
	    var state = 'pushnotifications';
	    var $data;
	    var s;
	    vman.type= $attrs.type
	    vman.notificationStatus = {};
	    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
	      vman.adminPermisions = true;
	    }
	    vman.keyPressOnlyNumberAndEnter = keyPressOnlyNumberAndEnter
	    vman.changeSearch = function(search_data) {
	      if(!search_data) {
	        $timeout(function() {
	          vman.search();
	        },0)            
	      }
	    }
	    vman.reloadNotification = function(post,type) {
	      var postFunction = function() {
	        $rootScope.hasLoaded = false; 
	        postDataService.save({
	          param1: state,
	          param2: (vman.type == 'eklinika')? vman.type:undefined,
	          param3: 'reload',
	          param4: type,
	          param5: post._id
	        },{}).$promise.then(function(postData){
	          function mergeObjects(targetObj, sourceObj) {
	            for (var key in targetObj) {
	                if (targetObj.hasOwnProperty(key)) {
	                    delete targetObj[key];
	                }
	            }
	            for (var prop in sourceObj) {
	                if (sourceObj.hasOwnProperty(prop)) {
	                    targetObj[prop] = sourceObj[prop];
	                }
	            }
	          }
	          if(postData.notification) {
	            mergeObjects(post, postData.notification);
	          }
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', postData.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  postFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    vman.saveEditTitle = function(post,type) {
	      var putData = {}
	      putData[type] = post['edit_'+type]
	      var url = (vman.type == 'eklinika')? API_URL + state + '/eklinika/'+ post._id:API_URL + state + '/'+ post._id
	      var putFunction = function() {
	        $http.put(url , putData)
	        .success(function (data, status, headers) {
	          post[type] = post['edit_'+type];
	          post['edit_'+type] = '';
	          post['edit_'+ type+ 'Show'] = false;
	          alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      putFunction();
	    }
	    vman.addToPushNotificationByUrlSuccessFunc = function(){
	      if(vman.tableParams.page() ==1) {
	        vman.tableParams.reload();
	      } else {
	        vman.tableParams.page(1);
	      }
	    }
	    vman.addToOtherByURL = addToOtherByUrl;
	    vman.sendNotification = function(user,type,notificationId, documentId,inPost) {
	      if(vman.type == 'eklinika') {
	        var data = {
	          'notification_id' : notificationId
	        }
	      } else {
	        var data = {
	          'type': type,
	          'document_id' : documentId,
	          'notification_id' : notificationId,
	          'post_id': (type=='liveblog_post' && inPost) ? inPost:undefined
	        }
	      }
	      var postFunction = function() {
	        $rootScope.hasLoaded = false; 
	        postDataService.save({
	          param1:state,
	          param2: (vman.type == 'eklinika')? vman.type:undefined,
	          param3: 'send',
	          param4: user
	        },data).$promise.then(function(postData){
	          vman.tableParams.reload();
	          alertService('success','Success ', postData.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  postFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    vman.deleteNotification = function(id) {
	      var deleteFunction = function() {
	        deleteDataService.remove({
	          param1:state,
	          param2: (vman.type == 'eklinika')? vman.type:undefined, 
	          param3: id
	        }).$promise.then(function(deleteNotification){ 
	          alertService('success','Success ', deleteNotification.message, 2000);
	          vman.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  deleteFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }  
	        });
	      }
	      deleteFunction();
	    }
	    vman.search =function(value) {
	      if(value) {
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      // user = null;
	      // vmaa.selecteduserFilter = {value: 'all'};
	      // unattached = null;
	      // date_start = null;
	      // date_end= null;
	      // $scope.$broadcast('clear-daterange',true);
	      // uploaded_to = null;
	      vman.tableParams.reload();
	    }
	    vman.tableReloadFunction = function(page) {
	      vman.tableParams = new NgTableParams({
	        page: page || 1,
	        count: 20,
	          
	      }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: (vman.type == 'eklinika')? vman.type:undefined,
	            page: params.page(),
	            limit: params.count(),
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            document_id:s
	            }).$promise.then(function(data){
	            $rootScope.emptyTable = false;
	            $rootScope.hasLoaded = true;
	            $data = data.push_notifications;
	            vman.dataGet = data.push_notifications;
	            if(data.push_notifications.length == 0) {
	              $rootScope.emptyTable = true;
	            } 
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    vman.tableReloadFunction(params.page());
	                  }
	                  // do something
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	                });
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else if(error.status ==502) {
	                serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	            
	          });
	        }    
	      });
	    }
	    vman.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(notifications) {
		'use strict'
		notifications.directive('allNotificationsDir',allNotificationsDir);
		allNotificationsDir.$inject=[];
		function allNotificationsDir() {
			return {
				template: __webpack_require__(280),
				controller:'allNotificationsController',
				controllerAs:'vman',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var notifications = angular.module('notificationsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
	]);
	__webpack_require__(531)(notifications);
	__webpack_require__(530)(notifications);
	__webpack_require__(533)(notifications);
	__webpack_require__(534)(notifications);
	


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(notifications) {
		'use strict'
		notifications.directive('notificationSettingsDir',notificationSettingsDir);
		notificationSettingsDir.$inject=[];
		function notificationSettingsDir() {
			return {
				template: __webpack_require__(281),
				controller:'notificationSettingsController',
				controllerAs:'vmns',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = function(notifications) {
		"use strict";
	  notifications
	  .controller('notificationSettingsController', notificationSettingsController)
		notificationSettingsController.$inject = ["keyPressOnlyNumber", "getDataService","refreshtokenService","postDataService","alertService","serverError","offlineError"];
		
	  function notificationSettingsController(keyPressOnlyNumber, getDataService,refreshtokenService,postDataService,alertService,serverError,offlineError) {
	    var vmns = this;
	    var state = 'pushnotifications';
	    var $data;
	    vmns.notificationStatus = {};
	    vmns.webPushNotificationFrequencyRequest = 1;
	    vmns.ttl = 24;
	    vmns.selectedCategory = {value:'default'};
	    vmns.selectedPusher={value:'ms'};
	    vmns.categories = [];
	    vmns.checkDisabledFunction = function() {
	      vmns.categories.map(function(item) {
	        for (var i = 0;i < vmns.selectedCategoryArray.length;i++) {
	          if(vmns.selectedCategoryArray[i]._id == item._id) {
	            return item.selected = true;
	          }
	        }
	      })
	    }
	    vmns.switchCategories = function(categoryId) {
	      if(categoryId=='default') return
	      vmns.categories.map(function(item){
	        if(item._id ==categoryId){
	          vmns.selectedCategoryArray.push({'_id':item._id, 'name':item.name})
	          return item.selected = true
	        }
	      })
	      vmns.selectedCategory = {value:'default'};
	    }
	    vmns.removeCategory = function(categoryId) {
	      vmns.selectedCategoryArray.splice(vmns.selectedCategoryArray.findIndex(function(item){
	        return item._id == categoryId
	      }), 1);
	      vmns.categories.map(function(item) {
	        if(item._id==categoryId) {
	          return item.selected = false
	        }
	      })
	    }
	    var getCategoriesFunction = function() {
	      getDataService.get({param1:'categories', param2: null, tree:1, src:'pushsettings'}).$promise.then(function(data){      
	        vmns.categories = data.categories;
	        vmns.checkDisabledFunction()
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getCategoriesFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }
	      });
	    }
	    vmns.keyPressOnlyNumber = keyPressOnlyNumber
	    var getNotificationSettings = function() {
	      getDataService.get({
	        param1: state,
	        param2: 'settings'
	        }).$promise.then(function(data){
	        vmns.selectedCategoryArray = data.categories;
	        vmns.selectedPusher.value = data.iosCluster;
	        vmns.webPushNotificationFrequencyRequest = parseInt(data.remindInterval);
	        vmns.ttl = parseInt(data.ttl);
	        getCategoriesFunction();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError('refresh')
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getNotificationSettings();
	              }
	              // do something
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	            });
	        } else if(error.status ==502) {
	            serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        
	      });
	    }
	    getNotificationSettings()  
	    vmns.saveWebSettings = function() {
	      if(!parseInt(vmns.webPushNotificationFrequencyRequest) || !parseInt(vmns.ttl) || vmns.selectedCategoryArray.length==0) return;
	      var data = {
	        'remindInterval': parseInt(vmns.webPushNotificationFrequencyRequest),
	        'ttl': parseInt(vmns.ttl),
	        'categories' : vmns.selectedCategoryArray,
	        'iosCluster': vmns.selectedPusher.value
	      }
	      var postFunction = function() { 
	        postDataService.save({
	          param1:state,
	          param2: 'settings',
	        },data).$promise.then(function(postData){
	          if(data.categories) {
	            vmns.selectedCategoryArray = data.categories;
	          }
	          if(postData.data.remindInterval) {
	            vmns.webPushNotificationFrequencyRequest = parseInt(postData.data.remindInterval);
	          }
	          if(postData.data.ttl) {
	            vmns.ttl = parseInt(postData.data.ttl)
	          }
	          alertService('success','Success ', postData.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  postFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      postFunction();
	    }
	    
	  }	
	}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = function(pages) {
		"use strict";
	  pages
	  .controller('allpagesController', allpagesController);
		allpagesController.$inject = ["watchAllCheckboxesNgTable","$timeout","$state","$stateParams","API_URL","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","putDataService","alertService","$http","postDataService","serverError","offlineError"];
		
	  function allpagesController(watchAllCheckboxesNgTable,$timeout,$state,$stateParams,API_URL,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,putDataService, alertService, $http,postDataService,serverError,offlineError) {
	    var vmapg = this;
	    vmapg.editPostShow = false;
	    $rootScope.emptyTable = false;
	    var state = 'pages';
	    vmapg.status = 'publish';
	    var status = vmapg.status;
	    var page = 1;
	    var author;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var s;
	    var $data;
	    vmapg.reverse = false;
	    vmapg.selectedTitle = -1;
	    vmapg.selectedAuthor = -1;
	    vmapg.selectedTags = -1;
	    vmapg.editCategoryShow = false;
	    vmapg.loadCategory = false;
	    vmapg.selectedBulkAction = {value: 'default'};
	    vmapg.checkedPostsforUpdate = [];
	    vmapg.checkedPostsEdit = [];
	    vmapg.checkboxes = { 'checked': false, items: {} };
	    vmapg.statusTrash = false;
	    vmapg.post_id = $stateParams.id;
	    if($stateParams.id) {
	      vmapg.editPostShow = true;
	    } else {
	      vmapg.editPostShow = false;
	    }
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vmapg.editPost = function(postId) {
	      vmapg.editPostShow = true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      vmapg.post_id = postId;
	      $state.transitionTo('app.allpages', {id: vmapg.post_id}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    var arrayPostsIdFunction = function() {
	      if (vmapg.checkedPostsEdit.length>0 ) {
	        for(var i=0;i<vmapg.checkedPostsEdit.length;i++) {
	          vmapg.checkedPostsforUpdate.push(vmapg.checkedPostsEdit[i]);
	        }
	      }
	    }
	    var putPostsFunction = function(url, status) {
	      var postsStatus = status;
	      var updateDataPosts = {
	        "ids": vmapg.checkedPostsforUpdate,
	        "status": postsStatus,
	      }
	      var putFunction = function() {   
	        $http.put(url , updateDataPosts)
	        .success(function (data, status, headers) {
	            alertService('success','Success ', data.message, 2000);
	            vmapg.tableParams.reload();
	            vmapg.checkedPostsforUpdate = [];
	            vmapg.checkedPostsEdit = [];
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                   putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(status ==502) {
	            serverError()
	          } else{  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	          vmapg.checkedPostsforUpdate = [];
	          vmapg.checkedPostsEdit = [];
	        });
	      }
	      putFunction();
	    }
	    vmapg.updateStatusPost = function(post_id, status) {
	      vmapg.checkedPostsforUpdate = [];
	      putPostsFunction(API_URL + 'pages', status);
	      vmapg.checkedPostsforUpdate.push(post_id);
	    }
	    vmapg.deletePostsFunction = function(data) {
	      var postFunction = function() { 
	        postDataService.save({
	          param1:state,
	          param2:'bulk',
	          param3:'delete' 
	        },{
	          'ids':vmapg.checkedPostsforUpdate
	        }).$promise.then(function(postData){
	          alertService('success','Success ', postData.message, 2000);
	          vmapg.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  postFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      postFunction();
	    }
	    vmapg.deletePosts = function(post_id) {
	      vmapg.checkedPostsforUpdate = [];
	      vmapg.checkedPostsforUpdate.push(post_id)
	      vmapg.deletePostsFunction();  
	    }
	    vmapg.bulkAction = function(status) {
	      vmapg.checkedPostsforUpdate = [];
	      
	      if(status != "delete" && vmapg.checkedPostsEdit.length > 0) {
	        arrayPostsIdFunction();
	        putPostsFunction(API_URL + 'pages', status);
	        watchAllCheckboxesNgTable.resetCheckBox(vmapg)
	        vmapg.tableParams.reload();
	      } else if (status == 'delete' && vmapg.checkedPostsEdit.length>0 ) {
	        vmapg.hiddenBulkEdit =true;
	        arrayPostsIdFunction();
	        vmapg.deletePostsFunction();
	      } 
	    }
	    watchAllCheckboxesNgTable.watch($scope, vmapg)
	    vmapg.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmapg.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmapg.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmapg.checkedPostsEdit.indexOf(id_tag);
	          vmapg.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    vmapg.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        $timeout(function() {
	            vmapg.search();
	          },0)             
	      }
	    }
	    vmapg.changeDate = function(value) {
	      vmapg.dateRangevalue = value;
	      if(vmapg.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	        date_start = null;
	        date_end = null;
	      }
	    }
	    vmapg.pageFilter = function() {
	      reloadTableFunction();
	    }
	    vmapg.resetAllFilters = function() {
	      vmapg.status = 'publish';
	      status = 'publish';
	      author = null;
	      vmapg.searchData = null;
	      s =null;
	      date_start = null;
	      date_end = null;
	      $scope.$broadcast('clear-daterange',true);
	      reloadTableFunction();
	    }
	    vmapg.authorPosts = function(value) {
	      author = value;
	      reloadTableFunction();
	    }
	    vmapg.changeStatus =function(event,activeStatus) {
	      vmapg.status = activeStatus;
	      status = vmapg.status
	      if(activeStatus == 'all') {
	        status = null;
	      } else {
	        status = activeStatus;
	      }
	      if(activeStatus == 'trash') {
	        vmapg.statusTrash = true;
	      } else {
	        vmapg.statusTrash = false;
	      }
	      reloadTableFunction();
	    }
	    vmapg.search =function(value) {
	      if(value) {
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    function reloadTableFunction() {
	      if(vmapg.tableParams.page() ==1) {
	        vmapg.tableParams.reload();
	      } else {
	        vmapg.tableParams.page(1);
	      }
	    } 
	    vmapg.tableReloadFunction = function(page) {
	      vmapg.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	          
	      }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            status: status,
	            page: params.page(),
	            limit: params.count(),
	            author: author,
	            s:s,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end
	            }).$promise.then(function(data){
	            $rootScope.hasLoaded = true;
	            $data =data.pages; 
	            vmapg.dataGet = data.pages;
	            if(data.pages.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            } 
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            watchAllCheckboxesNgTable.resetCheckBox(vmapg)
	            vmapg.checkedPostsforUpdate = [];
	            vmapg.selectedBulkAction = {value: 'default'};
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) { 
	                  if(answer==200) {
	                    vmapg.tableReloadFunction(params.page());
	                  }
	                  // do something
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	                });
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.'); 
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }    
	      });
	    }
	    vmapg.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(pages) {
		'use strict'
		pages.directive('allPagesDir',allPagesDir);
		allPagesDir.$inject=[];
		function allPagesDir() {
			return {
				restrict: 'E',
				template: __webpack_require__(282),
				controller:'allpagesController',
				controllerAs:'vmapg',
				link: function(scope, element, attrs, ctrl) {
					
				}
	
			}
		}
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(pages) {
		'use strict'
		pages.directive('pageDir',pageDir);
		pageDir.$inject=[];
		function pageDir() {
			return {
				template: __webpack_require__(283),
				controller:"pageController",
				controllerAs:"vmpg",
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = function(pages) {
		"use strict";
	  pages
	  .controller('pageController', pageController)
		pageController.$inject = ["postDataService","$state","alertService","$http","API_URL","$scope","getDataService", "jQuery","refreshtokenService","config","$attrs","$rootScope","$filter","cleanObj","$timeout","activeClass","serverError","offlineError"];
		
	  function pageController(postDataService,$state,alertService,$http,API_URL,$scope,getDataService,jQuery,refreshtokenService,config,$attrs,$rootScope,$filter,cleanObj,$timeout,activeClass,serverError,offlineError) {
	    var vmpg = this;
	    var parent = $scope.$eval($attrs.parent);
	    vmpg.newPost = true;
	    vmpg.postId = false;
	    vmpg.hasFeaturedImage = false;
	    vmpg.config = config;
	    vmpg.editSlugShow = false;
	    vmpg.setFeaturedImageShow = false;
	    vmpg.selectedPostStatus = {value:''}
	    vmpg.featured_img = undefined;
	    vmpg.changeImageTrue = false;
	    vmpg.insertMediatoEditor = false;
	    vmpg.mediaModal = false;
	    vmpg.setFeaturedImage = false;
	    vmpg.insertMediatoEditor = false;
	    vmpg.editPostStatusShow = false;
	    vmpg.newTagRequired = false;
	    vmpg.titleRequired = false; 
	    vmpg.featured_img_id;
	    vmpg.singleView = true;
	    vmpg.statusDraft = true;
	    vmpg.dataPost = {};
	    vmpg.dataPost.tags = [];
	    vmpg.editorPreviewVisual = true;
	    vmpg.editPostDateShow = false;
	    vmpg.cropModalShow = false;
	    vmpg.mediaLibrary = true;
	    vmpg.scheduledPost = false;
	    var updateDate = null;
	    vmpg.data_grid =[];
	    vmpg.selectedPhotoQuality={value:'medium'};
	    jQuery(document).on('click','.upload-image',function() {
	      $scope.$apply(function() {
	          vmpg.mediaLibrary = true;
	      })
	    });
	    vmpg.saveAttachments = function() {
	      $scope.$broadcast('attachment-save');
	    }
	    vmpg.openCropModal = function() {
	      vmpg.cropModalShow = true;
	    }
	    vmpg.cancelCropModal = function() {
	      vmpg.cropModalShow = false;
	      $rootScope.modalShow = false;
	    }
	    var parseOptions = function (stringOptions) {
	          var options = {}, set;
	          if (!stringOptions) { return; }
	
	          set = stringOptions
	              .replace(/(\w+=)/g, '\n$1')
	              .split('\n');
	              set.shift();
	
	          for (var i = 0; i < set.length; i++) {
	              var kv = set[i].split('=');
	              options[kv[0]] = kv[1].replace(/\'|\"/g, '').trim();
	          }
	
	          return options;
	      };
	    var publishPostFunction = function(url,state) {
	      var validatePublish = true;
	      vmpg.content = vmpg.textEditorContent;
	      var updateDataPost = {
	        "title": vmpg.dataPost.title,
	        "subtitle": vmpg.dataPost.subtitle,
	        "content": vmpg.content,
	        "slug": vmpg.postSlug,
	        "image": vmpg.featured_img_id,
	        "status": vmpg.dataPost.status,
	        "date": updateDate,
	      }
	      cleanObj.clean(updateDataPost);
	      var putFunction = function() {
	        $rootScope.hasLoaded = false;
	        $http.put(url , updateDataPost)
	        .success(function (data, status, headers) {
	          alertService('success','Success ', data.message, 2000);
	          $rootScope.hasLoaded = true;
	          if(vmpg.dataPost.status !='publish') {
	            vmpg.editPublish = false;
	          }
	          $timeout(function() {
	            if(vmpg.newPost) {
	              $state.go('app.allpages',{id:vmpg.postId});
	            }
	          },1000);
	          if(state=='trash') {
	            parent.editPostShow = false;
	            $state.transitionTo('app.allpages', {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
	          }
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.'); 
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	     
	      if(vmpg.dataPost.title) {
	        vmpg.titleRequired = false;
	      } else {
	        vmpg.titleRequired = true;
	        alertService('danger','Opps! ', 'Title is required');
	        validatePublish = false;
	      }
	      if(!updateDate) {
	        updateDate = moment().toISOString();
	      }
	
	      if(validatePublish) {
	        putFunction();
	        
	      }
	      
	    }
	
	
	    vmpg.publishPost = function() {
	      
	      vmpg.dataPost.status = 'publish';
	      publishPostFunction(API_URL+ "pages/"+vmpg.postId);
	    }
	    vmpg.trashPost = function() {
	      vmpg.dataPost.status = 'trash';
	      publishPostFunction(API_URL+ "pages/"+vmpg.postId,'trash');
	    }
	    vmpg.updateorSavePost =  function() {
	      publishPostFunction(API_URL+ "pages/"+vmpg.postId);
	    }
	    vmpg.editPostStatus = function() {
	      vmpg.editPostStatusShow = true;
	    }
	    vmpg.editPostTime = function() {
	      vmpg.editPostDateShow = true;
	      if(vmpg.newPost || (!vmpg.editPublish && !vmpg.scheduledPost)) {
	        convertTimeFunction(undefined);
	      } 
	    }
	    
	    vmpg.changePostStatus = function() {
	      vmpg.editPostStatusShow = false;
	      vmpg.dataPost.status = vmpg.selectedPostStatus.value;
	    }
	    vmpg.cancelEditPostStatus = function() {
	      vmpg.editPostStatusShow = false;
	      vmpg.selectedPostStatus = {value: vmpg.dataPost.status};
	    }
	    
	    vmpg.editorChangePreviw = function(event, editorPreview) {
	      activeClass.active(event);
	      $scope.$broadcast("change-editor",{editor_preview:editorPreview});
	      if(editorPreview == 'text') {
	        vmpg.editorPreviewVisual = false;
	      } else {
	        vmpg.editorPreviewVisual = true;
	      }    
	    }
	    $rootScope.$on("edit-image",function(event, data) {
	      vmpg.editImageObj = data.editImageObj;
	      vmpg.editImagefromEditor = true;
	    });
	    vmpg.addMediatoEditor = function() {
	      vmpg.mediaModal = true;
	      vmpg.insertMediatoEditor = true;
	      vmpg.setFeaturedImage = false;
	      vmpg.editImagefromEditor = false;
	    }
	    vmpg.openSetFeaturedImage = function() {
	      vmpg.mediaModal = true;
	      vmpg.setFeaturedImage = true;
	      vmpg.insertMediatoEditor = false;
	      vmpg.editImagefromEditor = false;
	    };
	    vmpg.cancelImageModal = function() {
	      vmpg.mediaModal = false;
	      vmpg.editImagefromEditor = false; 
	      $rootScope.modalShow = false;
	    }
	    
	    $scope.$watchCollection(function(){
	        return vmpg.changeImageTrue
	      }, function(newValue, oldValue){
	        if (newValue) {
	          $scope.$broadcast("change-image",{afterImage:true});
	        }
	      },true);
	    vmpg.editSlug = function(slug) {
	      vmpg.copySlug = angular.copy(slug);
	      vmpg.editSlugShow = true;
	    }
	    vmpg.cancelSlug = function() {
	      vmpg.postSlug = vmpg.copySlug;
	      if(!vmpg.postSlug) {
	        vmpg.postSlug = '';
	      } 
	      vmpg.editSlugShow = false; 
	    }
	    vmpg.updateSlug = function(slug) {
	      vmpg.editSlugShow = false; 
	    }
	    vmpg.removeFeaturedImage = function() {
	      vmpg.hasFeaturedImage = false;
	      vmpg.featured_img_id = undefined;
	      vmpg.featured_img_obj = undefined;
	    }
	    vmpg.cancelEditPostDate = function() {
	      vmpg.editPostDateShow = false; 
	    }
	    vmpg.setPublishedDate = function() {
	      vmpg.editPostDateShow = false; 
	      var dateArray = [vmpg.postYear, parseInt(vmpg.selectedPostMont.value)-1, vmpg.postDay, vmpg.postHours, vmpg.postMinutes];
	      if(moment(dateArray).diff(moment())>0) {
	        vmpg.scheduledPost = true;
	      } else {
	        vmpg.scheduledPost = false;
	      }
	      updateDate = moment(dateArray).toISOString();
	      vmpg.dataPost.date = $filter('date')(updateDate, "MMM d, y H:mm");
	    }
	    var convertTimeFunction = function(date) {
	      var a = moment(date);
	      var year = a.format('YYYY');
	      var month = a.format('M');
	      var day = a.format('D');
	      var hour = a.hours();
	      var min = a.minutes();
	      var sec = a.seconds();
	      vmpg.postYear = year;
	      vmpg.selectedPostMont = {value: month};
	      vmpg.postDay = day;
	      vmpg.postHours = hour;
	      vmpg.postMinutes = min;
	    } 
	    vmpg.editPostFunction = function() {
	      $rootScope.hasLoaded = true;
	      vmpg.scheduledPost = false;
	      vmpg.editPublish =false;
	      if(vmpg.dataPost.date) {
	        if(moment(vmpg.dataPost.date).diff(moment())> 0){
	          vmpg.scheduledPost = true;
	        }
	        updateDate = vmpg.dataPost.date;
	      }
	      vmpg.dataPost.date = $filter('date')(vmpg.dataPost.date, "MMM d, y H:mm");
	      convertTimeFunction(vmpg.dataPost.date);
	      if(vmpg.dataPost.status == 'publish') {
	        vmpg.editPublish = true;
	      } else if(vmpg.dataPost.status=='trash') {
	        parent.editPostShow = false;
	        $state.transitionTo('app.allpages', {id: null}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      }
	      vmpg.selectedPostStatus={value:vmpg.dataPost.status};
	      var postContent = vmpg.dataPost.content;
	      if(postContent) {
	
	        postContent.replace(/\[caption([^\]]*)\]([^\]]*)\[\/caption\]/g, function(all, attr, con) {
	            var parsetOpions = parseOptions(attr);
	            // console.log(parsetOpions);
	            postContent = postContent.replace( all,'<captionblock id="'+parsetOpions.id+'" align="'+parsetOpions.align+'" width="' +parsetOpions.width +'">'+con+'</captionblock>');
	        });
	
	        postContent = wpautop(postContent);
	        vmpg.tinymceModel = postContent;
	      }
	      
	      vmpg.postSlug = vmpg.dataPost.slug;
	      if(vmpg.dataPost.slug && vmpg.dataPost.uri) {
	        var slugLength = vmpg.dataPost.slug.length;
	        vmpg.substringUri = vmpg.dataPost.uri.substr(0, vmpg.dataPost.uri.length-slugLength);
	      }
	      if(vmpg.dataPost.image) {
	        vmpg.hasFeaturedImage = true;
	        vmpg.featured_img_file = vmpg.dataPost.image.file;
	        vmpg.featured_img_obj = vmpg.dataPost.image;
	      }
	    }
	    if(parent) {
	      vmpg.postId = parent.post_id;
	    }
	     
	    if(vmpg.postId) {
	      vmpg.newPost = false;
	      $rootScope.closeEditPage = function() {
	        $rootScope.ngEscapeAttrsParametars = [];
	        parent.editPostShow = false;
	        vmpg.dataPost = null;
	        $rootScope.hasLoaded = true;
	        $state.transitionTo('app.allpages', {id: null}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      }
	      var getPostData = function() { 
	         $rootScope.hasLoaded = false;
	        getDataService.get({param1:'pages', param2: vmpg.postId}).$promise.then(function(dataPosts){
	          $rootScope.hasLoaded = true;
	          vmpg.dataPost = dataPosts;
	          vmpg.editPostFunction();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getPostData();
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            }else {
	              parent.editPostShow = false;
	              vmpg.dataPost = null;
	              $rootScope.hasLoaded = true;
	              $state.transitionTo('app.allpages', {id: null}, {
	                location: true,
	                inherit: true,
	                relative: $state.$current,
	                notify: false
	              });
	            }
	        });
	      } 
	      getPostData();  
	      
	    } else {
	      vmpg.dataPost.status = 'draft';
	      vmpg.selectedPostStatus={value:'draft'};
	      $rootScope.hasLoaded = true;
	      var getNewPostData = function() {
	        postDataService.save({
	          param1:'pages' 
	        }).$promise.then(function(data){
	           vmpg.postId = data.page._id;
	           vmpg.postDate = data.page.date;
	           convertTimeFunction(vmpg.postDate);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getNewPostData();
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	        });
	      } 
	      getNewPostData();
	    }
	    $scope.$on('$destroy', function() {
	      vmpg.singleView = null;
	    });
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }   
	  }	
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var pages = angular.module('pagesModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'ui.tinymce'	
	]);
	__webpack_require__(536)(pages);
	__webpack_require__(535)(pages);
	__webpack_require__(537)(pages);
	__webpack_require__(538)(pages);
	// require('./edit-newpage/js/directive/tinymceDirective.js')(pages);
	// require('./editTemplateDirective.js')(pages);
	// require('./quickEditDirective.js')(pages);


/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = function(polls) {
		"use strict";
	  polls
	  .controller('allpollsController', allpollsController)
		allpollsController.$inject = ["$filter","watchAllCheckboxesNgTable","$timeout","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService","putDataService","serverError","offlineError"];
		
	  function allpollsController($filter,watchAllCheckboxesNgTable,$timeout,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService, putDataService,serverError,offlineError) {
	    var vmapl = this;
	    var state = 'polls';
	    var s;
	    var role;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var $data;
	    var page;
	    vmapl.status = 'publish';
	    var status = 'publish';
	    vmapl.selectedTitle = -1;
	    vmapl.editPollsShow = false;
	    vmapl.selectedRole = {value: 'all'}; 
	    vmapl.selectedBulkAction = {value: 'default'};
	    vmapl.checkedPostsEdit = [];
	    vmapl.checkboxes = { 'checked': false, items: {}};
	    vmapl.pollId = $stateParams.id; 
	    if($stateParams.id) {
	      vmapl.editPollShow = true;
	    } else {
	      vmapl.editPollShow = false;
	    }
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vmapl.bulkAction = function(param) {
	      if(param != 'default' && vmapl.checkedPostsEdit.length>0 ) {
	        var putFunction = function() { 
	          putDataService.update({
	            param1:state, 
	            param2: 'bulk',
	            param3:'delete'
	          },{
	            'delete_ids':vmapl.checkedPostsEdit,
	          }).$promise.then(function(bulkDelete){
	            watchAllCheckboxesNgTable.resetCheckBox(vmapl)
	            vmapl.selectedBulkAction = {value: 'default'}; 
	            alertService('success','Success ', bulkDelete.message, 2000);
	            vmapl.tableParams.reload();
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    putFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	              });
	            }else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            } 
	            watchAllCheckboxesNgTable.resetCheckBox(vmapl)
	            vmapl.selectedBulkAction = {value: 'default'}; 
	          });
	        }
	        putFunction();
	      }
	    }
	    watchAllCheckboxesNgTable.watch($scope, vmapl)
	    vmapl.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmapl.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmapl.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmapl.checkedPostsEdit.indexOf(id_tag);
	          vmapl.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    vmapl.editTitle = function(index) {
	      vmapl.selectedTitle = index;
	    }
	    vmapl.cancelEditTitle = function() {
	      vmapl.selectedTitle = -1;
	    }
	    vmapl.editPoll = function(pollId) {
	      
	      vmapl.editPollShow = true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      vmapl.pollId = pollId;
	      $state.transitionTo('app.allpolls', {id: vmapl.pollId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmapl.updateStatus = function(item,status) {
	      $rootScope.hasLoaded = false;
	        var updateData = {
	          'title': item.title,
	          'content': item.content,
	          'status': status,
	          'data':item.data.answers,
	          'multiple': item.multiple,
	          'max_choices': item.max_choices,
	          "image": item.image,
	          "expire_date": (status == 'finish')? $filter('date')(new Date().toISOString(), "MMM d, y HH:mm"): null,
	          "ads": item.ads
	        }
	      var putFunction = function() {
	        putDataService.update({
	          param1:'polls', 
	          param2:item._id
	        },updateData).$promise.then(function(putPoll){
	            $rootScope.hasLoaded = true;
	            vmapl.tableParams.reload();
	            alertService('success','Success ', putPoll.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          }else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;  
	        });
	      }
	      putFunction();
	    }
	    vmapl.deletePoll = function(pollId) {
	      var deleteFunction = function() {
	        deleteDataService.remove({
	          param1:'polls', 
	          param2: pollId
	        }).$promise.then(function(deletePoll){ 
	          alertService('success','Success ', deletePoll.message, 2000);
	          vmapl.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  deleteFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }  
	        });
	      }
	      deleteFunction();
	    }
	    vmapl.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        $timeout(function() {
	          vmapl.search();
	        },0)            
	      }
	    }
	    vmapl.changeDate = function(value) {
	      vmapl.dateRangevalue= value;
	      if(vmapl.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	          date_start = null;
	          date_end = null;
	      }
	    }
	    vmapl.changeStatus =function(event,activeStatus) {
	      vmapl.status = activeStatus;
	      if(activeStatus == 'all') {
	        status = null;
	      } else {
	        status = activeStatus;
	      }
	      reloadTableFunction();
	    }
	    function reloadTableFunction() {
	      if(vmapl.tableParams.page() ==1) {
	        vmapl.tableParams.reload();
	      } else {
	        vmapl.tableParams.page(1);
	      }
	    } 
	    vmapl.postFilter = function() {
	      reloadTableFunction()
	    }
	    vmapl.resetAllFilters = function() {
	      vmapl.searchData = null;
	      s =null;
	      status = 'publish'
	      date_start = null;
	      date_end = null;
	      $scope.$broadcast('clear-daterange',true);
	      reloadTableFunction();
	    }
	    // vmapl.changeStatus =function(event,activeStatus) {
	    //   s=null;
	    //   date_start = null;
	    //   date_end= null;
	    //   reloadTableFunction
	    // }
	     vmapl.search =function(value) {
	      if(value) { 
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    vmapl.tableReloadFunction = function(page) { 
	      vmapl.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	          
	      }, {
	        getData: function(params) {
	          $rootScope.emptyTable = false;
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,   
	            s:s,
	            status: status,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end,
	            page: params.page(),
	            limit: params.count(),
	            }).$promise.then(function(data){
	            
	            $rootScope.hasLoaded = true;
	            $data = data.polls;
	            vmapl.dataGet = data.polls; 
	            if(data.polls.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            }
	            watchAllCheckboxesNgTable.resetCheckBox(vmapl) 
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                 
	                  if(answer==200) {
	                    vmapl.tableReloadFunction(params.page());
	                  }
	                  // do something
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	                });
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }    
	      });
	    }
	    vmapl.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(polls) {
		'use strict'
		polls.directive('allPollsDir',allPollsDir);
		allPollsDir.$inject=[];
		function allPollsDir() {
			return {
				template: __webpack_require__(284),
				controller:'allpollsController',
				controllerAs:'vmapl',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(polls) {
		'use strict'
		polls.directive('pollDir',pollDir);
		pollDir.$inject=[];
		function pollDir() {
			return {
				template: __webpack_require__(285),
				controller:"pollController",
				controllerAs:"vmpl",
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = function(polls) {
		"use strict";
	  polls
	  .controller('pollController', pollController)
		pollController.$inject = ["$timeout","$filter","keyPressOnlyNumber","$parse","$attrs","$rootScope","$scope","getDataService", "jQuery","$state", "$stateParams","refreshtokenService","config","reqursiveService","putDataService","alertService","postDataService","deleteDataService","serverError","offlineError"];
		
	  function pollController($timeout,$filter,keyPressOnlyNumber,$parse,$attrs,$rootScope,$scope,getDataService,jQuery,$state, $stateParams,refreshtokenService, config, reqursiveService, putDataService, alertService,postDataService,deleteDataService,serverError,offlineError) {
	    var vmpl = this;
	    var validation = true;
	    vmpl.usernameRequired = false;
	    vmpl.passwordRequired = false;
	    vmpl.repeatpasswordRequired = false;
	    vmpl.matchedpassword = false;
	    var parent = $scope.$eval($attrs.parent);
	    vmpl.editStatusShow = false;
	    vmpl.minimumNumberOfQuestion = false;
	    vmpl.titleRequired = false;
	    vmpl.dataPoll = {};
	    vmpl.keyPressOnlyNumber = keyPressOnlyNumber;
	    vmpl.dataPoll.ads = false;
	    vmpl.dataPoll.multiple = false; 
	    vmpl.selectedPollStatus = {}
	    var updateDate;
	    vmpl.update = false;
	    vmpl.editPollStatus = function() {
	      vmpl.editPollStatusShow = true;
	    }
	    vmpl.changePollStatus = function() {
	      vmpl.editPollStatusShow = false;
	      vmpl.dataPoll.status = vmpl.selectedPollStatus.value;
	    }
	    vmpl.cancelEditPollStatus = function() {
	      vmpl.editPollStatusShow = false;
	      vmpl.selectedPollStatus = {value: vmpl.dataPoll.status};
	    }
	    vmpl.openSetFeaturedImage = function() {
	      vmpl.mediaModal = true;
	      vmpl.setFeaturedImage = true;
	      $rootScope.modalShow = true;
	    }
	    vmpl.cancelImageModal = function() {
	      $rootScope.modalShow = false;
	      vmpl.mediaModal = false;
	      vmpl.setFeaturedImage = false;
	    }
	    vmpl.removeFeaturedImage = function() {
	      vmpl.hasFeaturedImage = false;
	      vmpl.featured_img_obj = undefined;
	      vmpl.featured_img_id = undefined;
	    }
	    vmpl.cancelEditStatus = function() {
	      vmpl.editStatusShow = false;
	      vmpl.dataPoll.status = vmpl.copyStatus;
	    }
	    vmpl.editStatus = function(status) {
	      if(status) {
	        vmpl.copyStatus = angular.copy(status);  
	      }
	      vmpl.editStatusShow = true;
	    }
	    vmpl.submitEditStatus = function() {
	      vmpl.editStatusShow = false;
	    }
	    vmpl.switchStatus = function(status) {
	      vmpl.dataPoll.status = status;
	    }
	    vmpl.editPollDate = function() {
	      vmpl.editPollDateShow = true;
	      if(!vmpl.dataPoll.expire_date) {
	        convertTimeFunction(undefined);
	      } 
	    }
	    vmpl.cancelEditPollDate = function() {
	      vmpl.editPollDateShow = false; 
	    }
	    
	    vmpl.setPollDate = function() {
	      vmpl.editPostDateShow = false; 
	      var dateArray = [vmpl.pollYear, parseInt(vmpl.selectedPollMonth.value)-1, vmpl.pollDay, vmpl.pollHours, vmpl.pollMinutes];
	      updateDate = moment(dateArray).toISOString();
	      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>60) {
	        vmpl.dataPoll.expire_date = $filter('date')(updateDate, "MMM d, y HH:mm");
	        vmpl.editPollDateShow = false
	      } else {
	        alertService('danger','Opps! ', 'The date is not valid. The set date must be at least 60 minutes from now.');
	      }
	    }
	    function convertTimeFunction(date) {
	      var a = moment(date);
	      var year = a.format('YYYY');
	      var month = a.format('M');
	      var day = a.format('D');
	      var hour = a.hours();
	      var min = a.minutes();
	      vmpl.pollYear = year;
	      vmpl.selectedPollMonth = {value: month};
	      vmpl.pollDay = day;
	      if(hour<10) {
	        vmpl.pollHours = '0'+hour;  
	      } else {
	        vmpl.pollHours = hour;
	      }
	      if(min<10) {
	        vmpl.pollMinutes = '0'+min;  
	      } else {
	        vmpl.pollMinutes = min;
	      }
	    } 
	    vmpl.actionWithPoll = function() {
	      vmpl.validation = true;
	      if(!vmpl.dataPoll.title) {
	        vmpl.titleRequired = true;
	        alertService('danger','Opps! ', 'Title is required');
	        vmpl.validation = false;
	      } else {
	        vmpl.titleRequired = false;
	      }
	      for(var i=0; i<vmpl.choices.length;i++) {
	        if(!vmpl.choices[i].counter) {
	          vmpl.choices[i].counter = 0;
	        }
	        if(!vmpl.choices[i].text) {
	          alertService('danger','Opps! ', 'Text question is required');
	          vmpl.textQuestionRequired = true;
	          vmpl.validation = false;
	        } else {
	          vmpl.textQuestionRequired = false;
	        }
	      }
	      if(vmpl.dataPoll.multiple && vmpl.dataPoll.max_choices && (vmpl.dataPoll.max_choices <2 || vmpl.dataPoll.max_choices >vmpl.choices.length)) {
	        vmpl.validation = false;
	        alertService('danger','Opps! ', 'The maximum number of choices must not exceed the number of questions and should be greater than or equal to 2.');
	        vmpl.maxChoicesInvalid = true;
	      } else {
	        vmpl.maxChoicesInvalid = false
	      }
	      if(vmpl.validation) {
	        $rootScope.hasLoaded = false;
	        var expire_date = null;
	        if(vmpl.dataPoll.status=='finish'){
	          expire_date = $filter('date')(new Date().toISOString(), "MMM d, y HH:mm")
	        } else if(vmpl.dataPoll.status=='publish') {
	          if(vmpl.dataPoll.expire_date && new Date(vmpl.dataPoll.expire_date).getTime() > new Date().getTime()) {
	            expire_date = vmpl.dataPoll.expire_date
	          }
	        }
	        var updateData = {
	          'title':vmpl.dataPoll.title,
	          'content': vmpl.dataPoll.content,
	          'status': vmpl.dataPoll.status,
	          'data':vmpl.choices,
	          'multiple': vmpl.dataPoll.multiple,
	          'max_choices': (vmpl.dataPoll.multiple && vmpl.dataPoll.max_choices)?vmpl.dataPoll.max_choices:null,
	          "image": (vmpl.featured_img_id)? vmpl.featured_img_id: undefined,
	          "expire_date": expire_date,
	          "ads": vmpl.dataPoll.ads
	        }
	        if(!parent) {
	          var postFunction = function() {
	            postDataService.save({
	              param1:'polls', 
	            },updateData).$promise.then(function(postPoll){
	              $rootScope.hasLoaded = true;
	              vmpl.dataPoll = {};
	              vmpl.choices = [{'text': '','counter':0}];
	              alertService('success','Success ', postPoll.message, 2000);
	              if(postPoll && postPoll.obj && postPoll.obj._id) {
	                $state.go('app.allpolls',{id:postPoll.obj._id});
	              }
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                     postFunction();
	                    }
	                  },
	                  function(error) {
	                    // report something
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;  
	            });
	          }
	          postFunction();
	        } else {
	          var putFunction = function() {
	            putDataService.update({
	              param1:'polls', 
	              param2:vmpl.dataPoll._id
	            },updateData).$promise.then(function(putPoll){
	                $rootScope.hasLoaded = true;
	                populateData(putPoll.obj,true)
	                alertService('success','Success ', putPoll.message, 2000);
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                      putFunction();
	                    }
	                  },
	                  function(error) {
	                    // report something
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              }else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;  
	            });
	          }
	          putFunction();
	        }
	      }
	    }
	    vmpl.trashPoll = function() {
	      vmpl.dataPoll.status = 'trash';
	      vmpl.selectedPollStatus = {value:'trash'};
	      vmpl.actionWithPoll();
	    }
	    vmpl.publishPoll = function() {
	      vmpl.dataPoll.status = 'publish';
	      vmpl.selectedPollStatus = {value:'publish'};
	      vmpl.actionWithPoll();
	    }
	    vmpl.updatePoll = function() {
	      vmpl.actionWithPoll();
	    }
	    function populateData(data, update) {
	      vmpl.update = false;
	      vmpl.dataPoll = data;
	      vmpl.dataPoll.content = (vmpl.dataPoll.content)?vmpl.dataPoll.content:'';
	      if(update) {
	        $timeout(function(){
	          vmpl.update = true;
	        },0)
	      }
	      vmpl.choices = vmpl.dataPoll.data.answers;
	      vmpl.selectedPollStatus.value = vmpl.dataPoll.status;
	      if(vmpl.dataPoll.image) {
	        vmpl.hasFeaturedImage = true;
	        vmpl.featured_img_obj = vmpl.dataPoll.image; 
	        vmpl.featured_img_id = vmpl.dataPoll.image._id;
	      }
	      if(vmpl.dataPoll.expire_date) {
	        vmpl.dataPoll.expire_date = $filter('date')(vmpl.dataPoll.expire_date, "MMM d, y HH:mm");
	        convertTimeFunction(vmpl.dataPoll.expire_date);
	      } else {
	        convertTimeFunction(undefined);
	      }
	    }
	    if(parent) {
	      vmpl.pollId = parent.pollId;
	      vmpl.newPoll = false;
	      $rootScope.closeEditPoll = function() {
	        $rootScope.ngEscapeAttrsParametars = [];
	        parent.editPollShow = false;
	        vmpl.dataPoll = null;
	        $state.transitionTo('app.allpolls', {id: null}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      }
	      var getPollFunction = function() { 
	        $rootScope.hasLoaded = false;
	        getDataService.get({param1:'polls', param2: vmpl.pollId, param3:null}).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          populateData(data)
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError('refresh')
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                getPollFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            parent.editPollShow = false;
	            vmpl.dataPoll = null;
	            $rootScope.hasLoaded = false;
	            $state.transitionTo('app.allpolls', {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
	          }
	        });
	      }
	      getPollFunction();
	    } else {
	      vmpl.newPoll = true;
	      vmpl.dataPoll.content = ''
	    }
	    vmpl.choices = [{'text': '','counter':0}, {'text': '','counter':0}];
	    vmpl.addNewChoice = function() {
	      vmpl.choices.push({'text': '','counter':0});
	    };
	    vmpl.removeChoice = function() {
	      var lastItem = vmpl.choices.length-1;
	      if (vmpl.choices.length>2) {
	        vmpl.choices.splice(lastItem);
	      } else {
	        return
	      }
	    }; 
	  }	
	}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var polls = angular.module('pollsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap'
	]);
	__webpack_require__(541)(polls);
	__webpack_require__(540)(polls);
	__webpack_require__(542)(polls);
	__webpack_require__(543)(polls);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var popularposts = angular.module('popularpostsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap'
	]);
	__webpack_require__(546)(popularposts);
	__webpack_require__(547)(popularposts);
	


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(popularposts) {
		'use strict'
		popularposts.directive('popularPostsDir',popularPostsDir);
		popularPostsDir.$inject=[];
		function popularPostsDir() {
			return {
				template: __webpack_require__(286),
				controller:'popularpostsController',
				controllerAs:'vmpp',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	module.exports = function(popularposts) {
		"use strict";
	  popularposts
	  .controller('popularpostsController', popularpostsController)
		popularpostsController.$inject = ["elasticSearch","config","$timeout","$http","$scope","$rootScope","NgTableParams","getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService", "putDataService","postDataService","serverError","keyPress","offlineError"];
	  function popularpostsController(elasticSearch,config,$timeout,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService,putDataService,postDataService,serverError,keyPress,offlineError) {
	    var vmpp = this;
	    vmpp.defaultTab = 'naslovna';
	    vmpp.hasPosts = false;
	    vmpp.noResult = false;
	    vmpp.selectedCategoryAction = { value:vmpp.defaultTab};
	    vmpp.popularPostsSave = [];
	    vmpp.popularposts = [];
	    vmpp.hasPopularPosts = true;
	    // vmpp.hiddenResult = true;
	    // vmpp.hasResult = true;
	    // vmpp.searchPage = 0;
	    // vmpp.postResult = [];
	    vmpp.switchCategoryAction= function(category_id) {
	      // vmpp.searchPostsData = null;
	      vmpp.popularposts = [];
	      vmpp.popularPostsSave = [];
	      vmpp.defaultTab = category_id
	      getPopularPosts(vmpp.defaultTab);
	      if(vmpp.dataGoogle) {
	        if(vmpp.dataGoogle[vmpp.defaultTab]) {
	          vmpp.noResult = false;
	          vmpp.hasPosts = true; 
	          vmpp.popularpostsGoogle = vmpp.dataGoogle[vmpp.defaultTab];
	        } else {
	          vmpp.noResult = true;
	          vmpp.hasPosts = false; 
	        }
	      } 
	    }
	    vmpp.addPostFromSearch = function(obj) {
	      var exist = false;
	      for(var i=0; i<vmpp.popularposts.length; i++) {  
	        if(obj.id==vmpp.popularposts[i].id) {
	          exist = true;
	        }
	      }
	      if(!exist) {
	        vmpp.popularposts.push({'id':obj.id,'title':obj.title,'uri':obj.uri});
	        vmpp.hasPopularPosts = true;
	      }
	    }
	    // vmpp.chooseSearchData = function(post) {
	    //   vmpp.searchPostsData = '('+post._id+') - ' +  post._source.post_title;
	    //   vmpp.searchPostsTitle = post._source.post_title; 
	    //   vmpp.hiddenResult = true;
	    //   vmpp.searchPostId = post._id;
	    //   vmpp.searchPostUri = post._source.url.substr(23);
	    //   vmpp.searchObj = {
	    //     'id': vmpp.searchPostId,
	    //     'title' : vmpp.searchPostsTitle,
	    //     'uri' : vmpp.searchPostUri
	    //   };
	    // };
	    // angular.element(document).on('mousedown', function(e) {
	    //   if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	    //   var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	    //   var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	    //   if (!container.is(e.target) // if the target of the click isn't the container...
	    //     && container.has(e.target).length === 0 && !vmpp.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	    //   {
	    //     $scope.$apply(function () {
	    //       vmpp.hiddenResult = true;
	    //       vmpp.postResult = [];
	    //       vmpp.searchPage = 0;
	    //     });
	    //   }}
	    // });
	    // vmpp.searchPress = function(evt,star) {
	    //   keyPress(evt,star);
	    // }
	    // vmpp.readMore = function() {
	    //   vmpp.searchPage +=10;
	    //   $timeout(function() {
	    //     vmpp.search('loadMore');
	    //   },0)
	    // }
	    // vmpp.search = function(loadMore) { 
	    //   var size=10;
	    //   vmpp.loadMore = false;
	    //   if(loadMore!='loadMore') {
	    //     vmpp.searchPage = 0;
	    //     vmpp.postResult = [];
	    //   }
	    //   // vmpp.hiddenResult = true;
	    //   if(vmpp.searchPostsData) { 
	    //     if(vmpp.searchPostsData.length >1) {
	    //       var url = elasticSearch.getUrl(vmpp.searchPostsData);
	    //       url = url + '&from='+ vmpp.searchPage +'&size='+ size;
	          
	    //       $http({
	    //         method: 'GET',
	    //         url: url
	    //       }).then(function successCallback(response) {
	    //           if(loadMore=='loadMore') {
	    //             vmpp.postResult = vmpp.postResult.concat(response.data.hits.hits);
	    //           } else {
	    //             vmpp.postResult = response.data.hits.hits;
	    //           }
	    //           if(vmpp.postResult.length > 0) {
	    //             vmpp.hasResult = true;
	    //             vmpp.loadMore = true;
	    //           } else {
	    //             vmpp.hasResult = false;
	    //           }
	    //           vmpp.hiddenResult = false;
	    //           if(response.data.hits.total >vmpp.postResult.length) {
	    //             vmpp.loadMore = true;
	    //           } else {
	    //             vmpp.loadMore = false;
	    //           }
	    //           // this callback will be called asynchronously
	    //           // when the response is available
	    //       }, function errorCallback(response) {
	    //         if(!window.navigator.onLine) {
	    //           offlineError()
	    //           return
	    //         }
	    //           // called asynchronously if an error occurs
	    //           // or server returns response with an error status.
	    //       });
	    //     } else {
	    //       vmpp.hiddenResult = true;
	    //     } 
	    //   } else {
	    //     vmpp.hiddenResult = true;
	    //   }
	    // }
	    vmpp.popularPostSave = function(categoryName) {
	      vmpp.popularPostsSave =[];
	      if(vmpp.popularposts.length > 0) {
	        $rootScope.hasLoaded = false;
	        vmpp.popularposts = vmpp.popularposts.slice(0,10);
	
	        for (var i=0; i<vmpp.popularposts.length;i++) {
	          vmpp.popularPostsSave.push({'id':vmpp.popularposts[i].id, 'title':vmpp.popularposts[i].title, "uri":vmpp.popularposts[i].uri});
	        }
	        jQuery("html, body").animate({
	          scrollTop: 0
	        }, 400);
	        var postFunction = function() {
	          postDataService.save({
	            param1:'widgets',
	            param2:'popular' 
	          },{
	            "category": vmpp.defaultTab,
	            "posts"  : vmpp.popularPostsSave, 
	          }).$promise.then(function(postPopular){
	            $rootScope.hasLoaded = true;
	            // vmpp.popularposts = postPopular.posts;
	            alertService('success','Success ', postPopular.message, 2000);
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true; 
	          });
	        }
	        postFunction();
	      }
	    }
	    vmpp.addGoolePostsToPopularPosts = function() {
	      vmpp.hasPopularPosts = true;
	      Array.prototype.unique = function() {
	        var a = this.concat();
	        for(var i=0; i<a.length; ++i) {
	            for(var j=i+1; j<a.length; ++j) {
	                if(a[i].id === a[j].id)
	                    a.splice(j--, 1);
	            }
	        }
	        return a;
	      };
	      vmpp.popularposts = vmpp.popularposts.concat(vmpp.popularpostsGoogle).unique();
	    }
	    vmpp.removeFromPopularPosts = function(index) {
	      vmpp.popularposts.splice(index,1);
	      if(vmpp.popularposts.length == 0) {
	        vmpp.hasPopularPosts = false;
	      }
	    }
	    
	    vmpp.addPost =function(postObj) {
	      vmpp.hasPopularPosts = true;
	      vmpp.addPostFromSearch(postObj);
	    }
	    
	    var getPopularPosts = function(categoryName) {
	      // vmpp.popularposts = [];
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'widgets', param2: 'popular', param3:categoryName}).$promise.then(function(data){
	        
	        $timeout(function(){
	        $rootScope.hasLoaded = true;
	        vmpp.popularposts = data.posts;
	        },300);
	          
	        vmpp.hasPopularPosts = true;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getPopularPosts(vmpp.defaultTab);
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==404) {
	           vmpp.hasPopularPosts = false;
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        } 
	        $rootScope.hasLoaded = true;
	        vmpp.popularposts = [];
	      });
	    }
	    var getCategoriesFunction= function() {
	      getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){
	        vmpp.data = data.categories; 
	        vmpp.categoriesTabs = [];
	        for(var i=0; i< vmpp.data.length; i++) {
	          if(vmpp.data[i]._id != 'uncategorized') {
	            vmpp.categoriesTabs.push(vmpp.data[i]);
	          }
	        }
	        getPopularPosts(vmpp.defaultTab); 
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getCategoriesFunction();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }   
	      });
	    }
	    getCategoriesFunction();
	    vmpp.addGoogleAnalytics = function() {
	      vmpp.popularpostsGoogle = [];
	      vmpp.hasPosts = false;
	      $rootScope.hasLoaded = false;
	      var getPopularPostsAnalytics = function() {
	        getDataService.get({param1:'analytics', param2: 'popular'}).$promise.then(function(data){
	          vmpp.dataGoogle = data;
	          
	          if(vmpp.dataGoogle[vmpp.defaultTab]) {
	            vmpp.popularpostsGoogle = vmpp.dataGoogle[vmpp.defaultTab];
	            vmpp.hasPosts = true;
	            vmpp.noResult = false; 
	          } else {
	            vmpp.hasPosts = false;
	            vmpp.noResult = true;
	          }
	           $rootScope.hasLoaded = true;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getPopularPostsAnalytics();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          } 
	          $rootScope.hasLoaded = true;   
	        });  
	      }
	      getPopularPostsAnalytics();      
	    }
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }
	}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		'use strict'
	  posts
	  .controller('allpostsController', allpostsController)
		allpostsController.$inject = ["eventStream","$attrs","watchAllCheckboxesNgTable","removeFromOther","addToOther","warningAlertService","$timeout","config","$stateParams","$state","API_URL","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","authtokenService","serverError","comunicateBetweenViews","checkArray","$window","offlineError"];
		
	    function allpostsController(eventStream,$attrs,watchAllCheckboxesNgTable,removeFromOther,addToOther,warningAlertService,$timeout,config,$stateParams,$state,API_URL,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval, authtokenService,serverError,comunicateBetweenViews,checkArray,$window, offlineError) {
	      var vmap = this;
	      $rootScope.emptyTable = false;
	      vmap.editPostShow = false;
	      // vmap.intervalHeartBeat = null;
	      vmap.post_id = $stateParams.id;
	      vmap.myPosts = $attrs.myPosts;
	      vmap.config = config;
	      var streamTaxonomy = 'posts';
	      var appState = 'allposts'
	      if(vmap.myPosts) {
	        appState = 'myposts'
	      }
	      vmap.commentPostId = null; 
	      var $data;
	      if($stateParams.id) {
	        vmap.editPostShow = true;
	      } else {
	        vmap.editPostShow = false;
	      }
	      var userId = authtokenService.getUserId();
	      var state = 'posts';
	      var category;
	      var tag;
	      var s;
	      var page = 1;
	      var author;
	      var date_start;
	      var date_end;
	      var sortby ='date';
	      var addtoTarget;
	      var tagPosts = [];
	      var commentsStatus;
	      var postsStatus;
	      vmap.statusTrash = false;
	      vmap.selectedBulkAction = {value: 'default'};
	      vmap.selectedAuthorFilter = {value: 'all'};
	      vmap.postLocked = {};
	      if(vmap.myPosts) {
	        vmap.selectedAuthorFilter.value = userId.toString();
	        author = userId
	      }
	      vmap.selectedCategory = {value: 'all'};
	      if(comunicateBetweenViews.getCategory()) {
	        category = comunicateBetweenViews.getCategory();
	        vmap.selectedCategory= {value: category};
	        comunicateBetweenViews.setCategory(null);
	      }
	      if(comunicateBetweenViews.getTag()) {
	        tag = comunicateBetweenViews.getTag();
	        comunicateBetweenViews.setTag(null);
	      }
	      if(comunicateBetweenViews.getAuthor()) {
	        author = comunicateBetweenViews.getAuthor();
	        comunicateBetweenViews.setAuthor(null);
	        vmap.selectedAuthorFilter = {value: author.toString()};
	      }
	      vmap.status = "publish";
	      var status = vmap.status;
	      vmap.reverse = false;
	      vmap.selectedTitle = -1;
	      vmap.selectedAuthor = -1;
	      vmap.selectedTags = -1;
	      vmap.editCategoryShow = false;
	      vmap.loadCategory = false;
	      vmap.selectedBulkActionAuthor = {value: 'default'};
	      vmap.selectedBulkActionComments = {value: 'default'};
	      vmap.selectedBulkActionStatus = {value: 'default'};
	      vmap.checkedPostsEdit = [];
	      vmap.checkboxes = { 'checked': false, items: {} };
	      vmap.hiddenBulkEdit = true;
	      vmap.category = null;
	      vmap.bulkTags = [];
	      vmap.checkedPostsforUpdate = [];
	      vmap.categorychecked = {item:{}};
	      vmap.existTag = false;
	      vmap.changeOrderFlag = false;
	      vmap.numberOfItems;
	      $scope.ranges = {
	        'Today': [moment().startOf('day'), moment()],
	        'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	        'Last 7 days': [moment().subtract('days', 7), moment()],
	        'Last 30 days': [moment().subtract('days', 30), moment()],
	        'This month': [moment().startOf('month'), moment().endOf('month')],
	        'All days':[moment().subtract('year',5),moment()]
	      };
	      function heartbeatCallback(data) {
	        $scope.$apply(function() {
	          if(data.type=='post_locked') {
	            vmap.postLocked[data.item_id] = {
	              message: data.message
	            };
	            if(data.locked_by == parseInt(userId)) {
	              vmap.postLocked[data.item_id].personal_message = data.personal_message;
	            }
	          } else if(data.type=='post_unlocked' && vmap.postLocked[data.item_id]) {
	            delete vmap.postLocked[data.item_id];
	          }
	        });
	      }
	      $scope.addToExchange = function(typeExchange, postId) {
	        $scope.typeAddToExchange = typeExchange;
	        $scope.typeAddToExchangePostId = postId;
	        $scope.addPostToExchangeModal = true;
	      }
	      $scope.closeAddPostToExchangeModal = function() {
	        $scope.addPostToExchangeModal = false;
	      }
	      vmap.getApi = function(api) {
	        vmap.api = api;
	        vmap.status = undefined;
	        vmap.tableParams.reload();
	      }
	      vmap.getFromApi = function(target,postId) {
	        var ids = [];
	        if(postId) {
	          ids.push(postId);
	        } else {
	          ids = vmap.checkedPostsforUpdate
	        }
	        $rootScope.hasLoaded = false;
	        var postFunction = function() {
	          postDataService.save({
	            param1:state, 
	            param2: 'import', 
	            param3:target
	          },{
	            ids:ids
	          }).$promise.then(function(data){
	            vmap.tableParams.reload();
	            alertService('success','Success ', data.message, 2000);
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status == 401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	                if(answer==200) {
	                  postFunction();
	                }
	                // do something
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	            }else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }
	        postFunction();
	      }
	      vmap.takeover = function(postId) {
	        var takeoverMessage = (vmap.postLocked[postId].personal_message)? "This post is currently being edited in another session. If you take over, any unsaved changes there will be lost. Do you want to continue?" : 'Are you sure you want to take over this post?';
	        warningAlertService('Post takeover',takeoverMessage, function cb() {
	          var url = API_URL+ "posts/takeover"
	          var updateDataPost = {
	            post_id : postId
	          }
	          var updateFunction = function() {
	            $http.put(url , updateDataPost)
	            .success(function (data, stat, headers) {
	              alertService('success','Success ', data.message, 2000);
	              $rootScope.hasLoaded = false;
	              $timeout(function() {
	                vmap.editPost(postId);
	              },0)
	            })
	            .error(function (data, status, header, config) {
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                      updateFunction();
	                    }
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              }else if(status ==502) {
	                serverError()  
	              } else { 
	                alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;
	            }); 
	          }
	          updateFunction();
	        })
	      }
	      var updateOrder = function(url,order) {
	        var updateDataPost = {
	          "order": parseInt(order)
	        }
	        var updateFunction = function() {
	          $http.put(url , updateDataPost)
	          .success(function (data, stat, headers) {
	            $rootScope.hasLoaded = true;
	            alertService('success','Success ', data.message, 2000);
	          })
	          .error(function (data, status, header, config) {
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    updateFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            }else if(status ==502) {
	              serverError()  
	            } else { 
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          }); 
	        }
	        updateFunction();
	      }
	      vmap.changeOrder = function() {
	        vmap.changeOrderFlag = true;
	      }
	      vmap.outOrderFocus = function(postId,order) {
	        if(vmap.changeOrderFlag) {
	          $rootScope.hasLoaded = false;
	          vmap.changeOrderFlag = false;
	          updateOrder(API_URL+ "posts/order/"+postId,order);
	        }
	      }
	      vmap.updateOrder = function(postId,order) {
	        updateOrder(API_URL+ "posts/"+postId,order);
	      }
	      vmap.permisions = true;
	      if($rootScope.role_id == 'author-junior') {
	        vmap.permisions = false;
	      }
	      vmap.superPermisions = false;
	      if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin') {
	        vmap.superPermisions = true;
	      }
	      vmap.takeoverPermisions = false;
	      if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin' || $rootScope.role_id == 'editor' ) {
	        vmap.takeoverPermisions = true;
	      }
	      vmap.previewPost = function(post) {
	        if(post.status!='publish') {
	          $window.open(post.preview+ '&ts=' + Date.now(), '_preview');
	        } else {
	          $window.open(post.url, '_view');
	        }
	      }
	      var addNewTagFunction = function(data) {
	        vmap.newTagRequired = false;
	        if(!checkArray.contains.call(vmap.bulkTags,data.tagId)) {
	          vmap.bulkTags.push(data.tagId);
	          vmap.searchtagfocus = null;
	          vmap.existTag = false;
	        } else {
	          vmap.existTag = true;
	        }
	      }
	      $scope.$on('select-tag', function(event,data) {
	        addNewTagFunction(data.selectedTagObj)
	      });
	      vmap.addNewTag = function() {
	        if(vmap.searchtagfocus && vmap.searchtagfocus.length>2) {
	          var postFunction = function() {
	            postDataService.save({
	              param1:'tags', 
	              // param2: 'create'
	            },{
	              'name': vmap.searchtagfocus
	            }).$promise.then(function(postTag){
	            var data = {
	              tagId:postTag.tag._id,
	              tagname: postTag.tag.name
	            } 
	              addNewTagFunction(data);
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                      postFunction();
	                    }
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              } else if(error.status ==400) {
	                var data = {
	                  tagId:error.data.tag._id,
	                  tagname: error.data.tag.name
	                } 
	                addNewTagFunction(data);
	              }
	            });
	          }
	          postFunction();
	        } else {
	          vmap.newTagRequired = true;
	        }
	      }
	      vmap.removeFromTagsList = function(index) {
	        vmap.bulkTags.splice(index, 1);
	      }
	      var arrayPostsIdFunction = function() {
	        if (vmap.checkedPostsEdit.length>0 ) {
	          for(var i=0;i<vmap.checkedPostsEdit.length;i++) {
	            vmap.checkedPostsforUpdate.push(vmap.checkedPostsEdit[i]._id);
	          }
	        }
	      }
	      var putPostsFunction = function(url, status) {
	        if(vmap.checkedPostsforUpdate.length == 0) return;
	        if(vmap.bulkTags.length > 0) {
	          tagPosts = vmap.bulkTags;
	        } else {
	          tagPosts = null;
	        }
	        if(vmap.selectedBulkActionComments.value == 'default') {
	          commentsStatus = null;
	        } else if (vmap.selectedBulkActionComments.value == "allow"){
	          commentsStatus = "open";
	        } else {                   
	          commentsStatus = "closed";
	        }
	        if(status != 'no-trash') {
	          postsStatus = status;
	        } else { 
	          if(vmap.selectedBulkActionStatus.value == 'default') {
	            postsStatus = null;
	          } else {
	            postsStatus = vmap.selectedBulkActionStatus.value;
	          }
	          if(vmap.editPostsTag) {
	            if(vmap.editPostsTag.length==0) {
	              tagPosts = null;
	            }else {
	              tagPosts = vmap.editPostsTag;
	            }
	          }
	        }
	        var updateDataPosts = {
	          "ids": vmap.checkedPostsforUpdate,
	          "category": vmap.category,
	          "tags": tagPosts,
	          "status": postsStatus,
	          "comment_status": commentsStatus,
	        }
	        cleanObj.clean(updateDataPosts);
	        var putFunction = function() {
	          $http.put(url , updateDataPosts)
	          .success(function (data, status, headers) {
	              alertService('success','Success ', data.message, 2000);
	              vmap.cancelBulkEdit();
	              vmap.tableParams.reload();
	          })
	          .error(function (data, status, header, config) {
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {   
	                  if(answer==200) {
	                    putFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            }else if(status ==502) {
	              serverError();
	            } else {  
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	              vmap.cancelBulkEdit();
	              $rootScope.hasLoaded = true; 
	            }
	          });
	        }
	        putFunction();
	      }
	      vmap.updateStatusPost = function(post_id, status) {
	        vmap.checkedPostsforUpdate = [];
	        vmap.checkedPostsforUpdate.push(post_id);
	        putPostsFunction(API_URL + 'posts', status);
	      }
	      vmap.updateBulkAction = function() {
	        arrayPostsIdFunction();
	        putPostsFunction(API_URL + 'posts', 'no-trash');
	        $rootScope.hasLoaded = false;
	      }
	      vmap.removeFromOther = removeFromOther
	      vmap.addToOther = addToOther
	      vmap.editPost = function(postId) {    
	        vmap.editPostShow = true;
	        vmap.postLocked = {};
	        if(eventStream.hasMessageHandler(streamTaxonomy,heartbeatCallback)) {
	          eventStream.offMessage(streamTaxonomy,heartbeatCallback);
	        }
	        jQuery("html, body").animate({
	          scrollTop: 0
	        }, 600);
	        vmap.post_id = postId;
	        $state.transitionTo('app.'+ appState, {id: vmap.post_id}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	        });
	      }
	      var html = angular.element( document.querySelector('html'));
	      // vmap.editCategory = function(categoryId) { 
	        
	      //   html.addClass('overflow-hidden');
	      //   vmap.editCategoryShow = !vmap.editCategoryShow;
	      //   vmap.categorySelected = categoryId;
	      //   $scope.$broadcast("editCategory", {categorybroadcast:vmap.categorySelected});
	      //   setTimeout(function () {
	      //   if(categoryId) {
	      //     var topPos = jQuery(".checked")[0].offsetTop;
	
	      //       jQuery('#modalCategoryEdit').animate({scrollTop: topPos-60},600);
	      //     } else {
	      //       jQuery('#modalCategoryEdit').animate({scrollTop: 0},600);
	      //     }
	      //   },100);
	      // }
	      vmap.updateSelection = function(category_id, checked,categoryObj,event) {
	        if(categoryObj.children && categoryObj.children.length) {
	          event.preventDefault();
	          return
	        };
	        var updateSelectionTree = function(categories) {
	          if(checked) {
	            for (var i=0; i<categories.length; i++){
	              if (categories[i]._id !== category_id) {
	                vmap.categorychecked.item[categories[i]._id] = false;
	              }
	            }
	            vmap.category = category_id;
	          } else {
	            vmap.category = null;
	          }
	        }
	        updateSelectionTree(vmap.categoriesTreeInput);  
	      }
	      vmap.searchComment = function(post) {
	        vmap.commentPostId =  post._id;        
	        vmap.serchCommentsModalShow = true;
	        $rootScope.modalShow = true;
	      } 
	      vmap.closeSearchComment = function() {
	        vmap.serchCommentsModalShow = false;
	        $rootScope.modalShow = false;
	        vmap.commentPostId = null;
	      }
	      vmap.cancelCategoryModal =function() {
	        html.removeClass('overflow-hidden');
	        vmap.editCategoryShow= false;
	        $scope.$broadcast("CategorCheckAll", {check:false});
	      }
	      vmap.editAuthor = function(index) {
	        vmap.selectedAuthor = index;
	      }
	      vmap.cancelEditAuthor = function() {
	        vmap.selectedAuthor = -1;
	      }
	      vmap.editTitle = function(index) {
	        vmap.selectedTitle = index;
	      }
	      vmap.cancelEditTitle = function() {
	        vmap.selectedTitle = -1;
	      }
	      vmap.editTags = function(index) {
	        vmap.selectedTags = index;
	      }
	      vmap.cancelEditTags = function() {
	        vmap.selectedTags = -1;
	      }
	      vmap.deletePostsFunction = function() {
	        postDataService.save({
	          param1:state,
	          param2:'bulk',
	          param3:'delete' 
	        },{
	          'ids':vmap.checkedPostsforUpdate
	        }).$promise.then(function(postData){
	          alertService('success','Success ', postData.message, 2000);
	          vmap.cancelBulkEdit();
	          vmap.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) { 
	                  if(answer==200) {
	                    vmap.deletePostsFunction();
	                  }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(error.status ==502) {
	            serverError();
	          }else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          vmap.cancelBulkEdit();
	        });
	      }
	      vmap.deletePosts = function(post_id) {
	        vmap.checkedPostsforUpdate = [];
	        vmap.checkedPostsforUpdate.push(post_id)
	        vmap.deletePostsFunction();  
	      }
	      vmap.bulkAction = function(param) {
	        if(param == "edit" && vmap.checkedPostsEdit.length > 0) {
	          vmap.hiddenBulkEdit =false;
	        }else if(param == "trash" && vmap.checkedPostsEdit.length > 0){
	          vmap.checkedPostsforUpdate = [];
	          arrayPostsIdFunction();
	          putPostsFunction(API_URL + 'posts', 'trash');
	        } else if (param == 'delete' && vmap.checkedPostsEdit.length>0 ) {
	          vmap.checkedPostsforUpdate = [];
	          vmap.hiddenBulkEdit =true;
	          $rootScope.hasLoaded = false;
	          arrayPostsIdFunction();
	          vmap.deletePostsFunction();
	        } else if(param=='deskplus' && vmap.checkedPostsEdit.length>0){
	          vmap.checkedPostsforUpdate = [];
	          arrayPostsIdFunction();
	          vmap.getFromApi('deskplus');
	        } 
	      }
	      watchAllCheckboxesNgTable.watch($scope,vmap,true)
	      vmap.checkedPost = function(checked, post) {
	        if (checked) {
	          vmap.checkedPostsEdit.push(post);
	        } else {
	         vmap.checkedPostsEdit = vmap.checkedPostsEdit.filter(function( obj ) {
	              return obj._id !== post._id;
	          });
	        }
	        
	      }
	      vmap.removeEditPost = function(post_id) {
	        vmap.checkedPostsEdit = vmap.checkedPostsEdit.filter(function( obj ) {
	              return obj._id !== post_id;
	        });
	        vmap.checkboxes.items[post_id] = false;
	        if(!vmap.checkedPostsEdit.length > 0) {
	          vmap.cancelBulkEdit();
	        }
	      }
	      vmap.cancelBulkEdit =function() {
	        if(!vmap.hiddenBulkEdit) {
	          var updateSelectionTree = function(categories) {
	            for (var i=0; i<categories.length; i++){
	              vmap.categorychecked.item[categories[i]._id] = false;
	            }
	          }
	          updateSelectionTree(vmap.categoriesTreeInput);
	        }
	        vmap.category = null;
	        vmap.hiddenBulkEdit = true;
	        watchAllCheckboxesNgTable.resetCheckBox(vmap)
	        vmap.checkedPostsforUpdate = [];
	        vmap.selectedBulkActionStatus={value:'default'};
	        vmap.selectedBulkActionComments ={value:'default'};
	        vmap.selectedBulkAction = {value: 'default'};
	        vmap.bulkTags = [];
	      }
	      vmap.categoryTreeFunction= function() {
	        vmap.categoriesTreeInput = reqursiveService.getReqursiveArray(vmap.categories);
	        vmap.categoriesTreeSelect = angular.copy(vmap.categoriesTreeInput);
	        for(var i=0; i< vmap.categoriesTreeSelect.length; i++) {
	          var n = (vmap.categoriesTreeSelect[i].ancestors.length)*2;
	          var empty = "\u00A0";
	          for(var j=0;j<n;j++) {
	            vmap.categoriesTreeSelect[i].name = empty+vmap.categoriesTreeSelect[i].name;
	          }
	        }
	      }
	      var getCategoriesFunction = function() {
	        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){      
	          vmap.loadCategory= true;
	          vmap.categories = data.categories;
	          vmap.categoryTreeFunction();
	          
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getCategoriesFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	                });
	          } else if(error.status ==502) {
	            serverError()
	          }
	        });
	      }
	      var getAuthorsFunction = function() {
	        getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
	          vmap.authorList = data.users;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getAuthorsFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                // report progress
	                });
	          } else if(error.status ==502) {
	            serverError()
	          }else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      getAuthorsFunction();
	      // var setLockedPostFunction = function() {
	        // vmap.postLocked = {};
	        // if(vmap.dataGet && vmap.dataGet.length>0) {
	        //   for(var i=0; i<vmap.dataGet.length;i++) {
	        //     vmap.postLocked[vmap.dataGet[i]._id] = false;
	
	        //   }
	        //   for(var i=0; i<vmap.lockedPosts.length;i++) {
	        //     if(userId !=vmap.lockedPosts[i].edit_last) {
	        //       vmap.postLocked[vmap.lockedPosts[i]._id] = {messagevmap.lockedPosts[i].message};
	        //     }
	        //   }
	        // }
	      // }
	
	      // vmap.intervalHeartBeatFunction = function() {
	      //   if(!$state.is('app.' + appState) && vmap) return;   
	      //   var HeartBeatArray = [];
	      //   for(var i=0; i<vmap.dataGet.length;i++) {
	      //     HeartBeatArray.push(vmap.dataGet[i]._id);
	      //   }
	      //   var intervalFunction = function() { 
	      //     postDataService.save({
	      //       param1:state, 
	      //       param2: 'heartbeat'
	      //     },{
	      //       "ids": HeartBeatArray
	      //     }).$promise.then(function(data){
	      //       vmap.lockedPosts = data.result;
	      //       setLockedPostFunction();
	          
	      //     }, function(error){
	      //       if(!window.navigator.onLine) {
	      //         offlineError(vmap.intervalHeartBeatFunction)
	      //         return
	      //       }
	      //       if(error.status == 401) {
	      //         var promise = refreshtokenService.getAccessToken();
	      //         promise.then(
	      //         function(answer) {
	      //           if(answer==200) {
	      //             intervalFunction();                      
	      //           }
	      //         },
	      //         function(error) {
	      //           // report something
	      //         },
	      //         function(progress) {
	      //           // report progress
	      //         });
	      //       }
	      //     });
	      //   }
	      //   intervalFunction();
	      // }
	      vmap.changeSearch = function(search_data) {
	        if(search_data) {
	          s = search_data;
	        } else {
	          s = null;
	          $timeout(function() {
	            vmap.search();
	          },0)            
	        }
	      }
	      vmap.switchCategories = function(item) {
	          category = item;
	          if (item=='all') {
	            category = null;
	          }
	      }
	      vmap.switchAuthorFilter = function(item) {
	          author = item;
	          if (item=='all') {
	              author = null;
	          }
	      }
	      vmap.changeDate = function(value) {
	        vmap.dateRangevalue = value;
	        if(vmap.dateRangevalue) {
	          if(value.startDate && value.endDate) {
	            date_start = value.startDate.format('YYYY-MM-DD');
	            date_end = value.endDate.format('YYYY-MM-DD');
	          } else {
	            date_start = null;
	            date_end = null;
	          }
	        } else {
	            date_start = null;
	            date_end = null;
	        }
	      }
	      function reloadTableFunction() {
	        if(vmap.tableParams.page() ==1) {
	          vmap.tableParams.reload();
	        } else {
	          vmap.tableParams.page(1);
	        }
	      } 
	      vmap.postFilter = function() {
	        reloadTableFunction();
	      }
	      vmap.resetAllFilters = function() {
	        vmap.status = 'publish';
	        status = vmap.status;
	        vmap.selectedCategory = {value: 'all'};
	        vmap.selectedAuthorFilter = {value: 'all'};
	        author = null;
	        if(vmap.myPosts) {
	          vmap.selectedAuthorFilter.value = userId.toString();
	          author = userId;
	        }
	        vmap.searchData = null;
	        tag = null;
	        s = null;
	        category = null;
	        date_start = null;
	        date_end = null;
	        $scope.$broadcast('clear-daterange',true);
	        reloadTableFunction();
	      }
	      vmap.authorPosts = function(value) {
	        author = value;
	        vmap.selectedAuthorFilter = {value: value.toString()};
	        reloadTableFunction();
	      }
	      vmap.categoryPosts = function(value) {
	        category = value;
	        reloadTableFunction();
	      }
	      vmap.tagPosts =function(value) {
	        tag = value;
	        reloadTableFunction();
	      } 
	      vmap.changeStatus =function(event,activeStatus) {
	        vmap.status = activeStatus;
	        vmap.api = undefined;
	        if(activeStatus == 'all') {
	          status = null;
	        } else {
	          status = activeStatus;
	        }
	        if(activeStatus == 'trash') {
	          vmap.statusTrash = true;
	        } else {
	          vmap.statusTrash = false;
	        }
	        reloadTableFunction();
	      }
	      vmap.search =function(value) {
	        if(value) {
	          s = value.toLowerCase();
	        } else {
	          s = null;
	        }
	        reloadTableFunction();
	      }
	      vmap.tableReloadFunction = function(page) {
	        vmap.tableParams = new NgTableParams({
	            page: page || 1,
	            count: 20,
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            category: (!vmap.api)? category:undefined,
	            tag:(!vmap.api)? tag:undefined,
	            s:(!vmap.api)? s:undefined,
	            status: (!vmap.api)? status:undefined,
	            page: params.page(),
	            limit: params.count(),
	            author:(!vmap.api)? author:undefined,
	            sortby:(!vmap.api)? $rootScope.sortby:undefined, 
	            sort : (!vmap.api)? $rootScope.sort:undefined,
	            date_start: (!vmap.api)? date_start:undefined,
	            date_end: (!vmap.api)? date_end:undefined,
	            api: vmap.api
	            }).$promise.then(function(data){
	            
	            $rootScope.emptyTable = false;
	            $rootScope.hasLoaded = true;
	            $data = data.posts;
	            for (var i=0; i<$data.length;i++) {
	              $data[i].tags = checkArray.removeDuplicate($data[i].tags);
	              if($data[i].lock && Object.keys($data[i].lock).length > 0) {
	                vmap.postLocked[$data[i]._id] = {
	                  message: $data[i].lock.message
	                };
	                if($data[i].lock.locked_by && $data[i].lock.locked_by._id == parseInt(userId)) {
	                  vmap.postLocked[$data[i]._id].personal_message = $data[i].lock.personal_message;
	                }
	              }
	            }
	            vmap.dataGet = data.posts;
	            watchAllCheckboxesNgTable.resetCheckBox(vmap)
	            if ( angular.element('#quick-edit').length >0) {
	                angular.element('#quick-edit').remove();
	            }
	            vmap.cancelBulkEdit();
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            if(!eventStream.getConnection(streamTaxonomy)) {
	              eventStream.connect(streamTaxonomy,vmap.config.lockingManager[streamTaxonomy]);
	            }
	            if(!eventStream.hasMessageHandler(streamTaxonomy,heartbeatCallback)) {
	              eventStream.onMessage(streamTaxonomy,heartbeatCallback);
	            }
	            // if(vmap.intervalHeartBeat) {
	            //   $interval.cancel(vmap.intervalHeartBeat);
	            //   vmap.intervalHeartBeat = null;
	            // }
	            // if( typeof(vmap.intervalHeartBeatFunction) === 'function' && !vmap.api) {
	            //   vmap.intervalHeartBeat = $interval(vmap.intervalHeartBeatFunction,config.heartbeat.pulse*1000);
	            //   vmap.intervalHeartBeatFunction();
	            // }
	            vmap.selectedBulkAction = {value: 'default'};
	            if(!vmap.api) {
	              getCategoriesFunction();
	            }
	            vmap.numberOfItems = data.count;
	            if(category) {
	              vmap.selectedCategory= {value: category};
	            }
	            if(author) {
	              vmap.selectedAuthorFilter = {value: author.toString()};
	            }
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    vmap.tableReloadFunction(params.page());
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                  // report progress
	              });
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	              vmap.numberOfItems = 0;
	              vmap.cancelBulkEdit();
	              if ( angular.element('#quick-edit').length >0) {
	                angular.element('#quick-edit').remove();
	              }
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }    
	      });
	    }
	    vmap.tableReloadFunction();   
	    $scope.$on('$destroy', function() {
	      eventStream.disconnect(streamTaxonomy);
	      $rootScope.eventStreamError = false;
	      // if(vmap.intervalHeartBeat) {
	      //   $interval.cancel(vmap.intervalHeartBeat);
	      // }
	      // vmap.intervalHeartBeat = null;
	      // vmap.intervalHeartBeatFunction = null;
	    });
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('allPostsDir',allPostsDir);
		allPostsDir.$inject=[];
		function allPostsDir() {
			return {
				template: __webpack_require__(287),
				controller:'allpostsController',
				controllerAs:'vmap',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		"use strict";
	  posts
	  .controller('categoriesController', categoriesController)
		categoriesController.$inject = ["watchAllCheckboxesNgTable","slugifyValidator","keyPressSlugify","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
		
	  function categoriesController(watchAllCheckboxesNgTable,slugifyValidator,keyPressSlugify,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
	    var vmc = this;
	    var state = 'categories';
	    var $data;
	    var s;
	    var search;
	    var tree = 1;
	    vmc.categoryEdit = false;
	    $rootScope.alert={hasBeenShown: false};
	    $rootScope.hasLoaded = false;
	    vmc.selectedName = -1;
	    vmc.nameRequired = false;
	    vmc.hasParent = {items:{}};
	    vmc.categoryName = undefined;
	    vmc.categorySlug = undefined;
	    vmc.categoryDescription= undefined;
	    vmc.selectedBulkAction = {value: 'default'};
	    vmc.checkedPostsEdit = [];
	    vmc.checkboxes = { 'checked': false, items: {}};
	    vmc.categoryId = $stateParams.id; 
	    if($stateParams.id) {
	      vmc.categoryEdit = true;
	    } else {
	      vmc.categoryEdit = false;
	    }
	    vmc.slugValid = true;
	    vmc.keyPressSlugify = keyPressSlugify;
	    vmc.categorySlugValidate = function(value) {
	      vmc.slugValid = true;
	      if(value) {
	        vmc.slugValid = slugifyValidator(value);
	      }
	    }
	    // add new category
	    vmc.addNewCategory = function() {
	      if(!vmc.slugValid) return;
	      if(vmc.selectedCategory.value =='none') {
	        vmc.selectedCategory.value = undefined;
	      }
	      if(vmc.categoryName) {
	        var postFunction = function() {  
	          postDataService.save({
	            param1:'categories', 
	            param2: 'create'
	          },{
	            'name':vmc.categoryName,
	            'parent': vmc.selectedCategory.value,
	            "description": vmc.categoryDescription,
	            'slug':vmc.categorySlug
	          }).$promise.then(function(postCategory){
	            vmc.categoryName = undefined;
	            vmc.categorySlug = undefined;
	            vmc.categoryDescription= undefined;
	            vmc.selectedCategory.value ='none';
	            alertService('success','Success ', postCategory.message, 2000);
	            vmc.searchData ={name:''};
	            vmc.getCategories();
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              if(error && error.data && error.data.error && error.data.error.slug) {
	                vmc.categorySlug = error.data.error.slug;
	              }
	              vmc.selectedCategory.value ='none';
	            } 
	          });
	        }
	        postFunction();
	      } else {
	        vmc.selectedCategory.value ='none';
	        alertService('danger','Opps! ', 'Category name is required')
	        vmc.nameRequired=true;
	      }
	    }
	    vmc.editCategory = function(categoryId) {
	      vmc.categoryEdit= true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 10);
	      vmc.categoryId = categoryId;
	      $state.transitionTo('app.categories', {id: vmc.categoryId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmc.quickEdit = function(id) {
	      vmc.selectedName = id;
	    }
	    vmc.cancelQuickEdit = function() {
	      vmc.selectedName = -1;
	    }
	    vmc.goToAllPosts = function(category) {
	      comunicateBetweenViews.setCategory(category);
	      $state.go('app.allposts'); 
	    }
	    vmc.updateBulkDeleteSuccess = function() {
	      watchAllCheckboxesNgTable.resetCheckBox(vmc)
	      vmc.selectedBulkAction = {value: 'default'};
	      vmc.searchData = {name:''};
	      vmc.getCategories('update'); 
	    }
	    watchAllCheckboxesNgTable.watch($scope,vmc)
	    vmc.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmc.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmc.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmc.checkedPostsEdit.indexOf(id_tag);
	          vmc.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    var tablePopulateFunction = function() {
	      vmc.tableParams = new NgTableParams({
	        page: 1,
	        count: 20,
	       
	        }, {
	          total:vmc.categoriesTreeInput.length,
	        getData: function(params) {
	          $data = vmc.categoriesTreeInput; 
	          $data = params.sorting() ?
	          $filter('orderBy')($data, params.orderBy()) : $data;
	          $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	          vmc.dataGet = $data;
	          jQuery('.goTo input').val("");
	          watchAllCheckboxesNgTable.resetCheckBox(vmc)
	          if(vmc.categoriesTreeInput.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            } 
	          return $data; 
	        }    
	      });  
	    }
	    vmc.dataCategoryFunction = function(update) {
	      vmc.categoryTreeFunction= function() {
	        vmc.categoriesTreeInput = reqursiveService.getReqursiveArray(vmc.data);
	        vmc.copycategoriesTreeInput = angular.copy(vmc.categoriesTreeInput);
	        vmc.categoriesTreeSelect = angular.copy(vmc.categoriesTreeInput);
	        for(var i=0; i< vmc.categoriesTreeSelect.length; i++) {
	          var n = (vmc.categoriesTreeSelect[i].ancestors.length)*2;
	          var empty = "\u00A0";
	          for(var j=0;j<n;j++) {
	            vmc.categoriesTreeSelect[i].name = empty+vmc.categoriesTreeSelect[i].name;
	          }
	        }
	      }
	      vmc.categoryTreeFunction();
	      vmc.selectedCategory= {value: 'none'};
	      if(update) {
	        vmc.tableParams.reload()
	      } else {
	        tablePopulateFunction()
	      }
	    }
	    vmc.changeSearch = function(searchData) {
	      vmc.categoriesTreeInput = (searchData.name)? reqursiveService.getReqursiveArray($filter('filter')(vmc.copycategoriesTreeInput,searchData)) : vmc.copycategoriesTreeInput; 
	      vmc.categoriesTreeInput = checkArray.removeObjArryDuplicate(vmc.categoriesTreeInput)
	      tablePopulateFunction()
	    }
	    vmc.getCategories = function(update) {
	      $rootScope.hasLoaded = false;
	      var getCategoriesFunction = function() {
	        getDataService.get({param1:'categories', param2: null,tree:tree, showinvisible:true}).$promise.then(function(data){
	          vmc.data = data.categories;
	          vmc.dataCategoryFunction(update);
	          $rootScope.hasLoaded = true;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getCategoriesFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else if(error.status ==404) {
	            $rootScope.emptyTable = true;
	          } else {
	            alertService('danger','Opps! ', error.data.error.message);
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      getCategoriesFunction();
	    }
	    vmc.getCategories();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('categoriesDir',categoriesDir);
		categoriesDir.$inject=[];
		function categoriesDir() {
			return {
				template: __webpack_require__(288),
				controller:'categoriesController',
				controllerAs:'vmc',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		"use strict";
	  posts
	  .controller('categoryEditController', categoryEditController)
		categoryEditController.$inject = ["$attrs","$scope","$state","$stateParams","getDataService","refreshtokenService","reqursiveService","putDataService","alertService","$rootScope","serverError","offlineError"]
		
	  function categoryEditController($attrs,$scope,$state,$stateParams,getDataService,refreshtokenService,reqursiveService, putDataService, alertService,$rootScope,serverError,offlineError) {
	    var vmce = this;
	    $scope.parent = $scope.$eval($attrs.parent);
	    $rootScope.closeEditCategory = function() {
	      $rootScope.ngEscapeAttrsParametars = [];
	      $scope.parent.categoryEdit = false;
	      vmce.category = null;
	      $state.transitionTo('app.categories', {id: null}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmce.categoryId = $scope.parent.categoryId;
	    var getCategoryFunction = function() { 
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'categories', param2: vmce.categoryId}).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        vmce.category = data;
	        if(vmce.category.parent) {
	          vmce.selectedCategory= {value: vmce.category.parent};
	        } else {
	          vmce.selectedCategory= {value: 'none'};
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getCategoryFunction();
	              }
	              // do something
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        }  else {
	          $scope.parent.categoryEdit = false;
	          $state.transitionTo('app.categories', {id: null}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	          });
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    getCategoryFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('categoryEditDir',categoryEditDir);
		categoryEditDir.$inject=[];
		function categoryEditDir() {
			return {
				template: __webpack_require__(289),
				controller:'categoryEditController',
				controllerAs:'vmce',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('addToDictionaryModal',addToDictionaryModal);
		addToDictionaryModal.$inject=['$timeout','refreshtokenService','alertService','serverError','postDataService','offlineError'];
		function addToDictionaryModal($timeout,refreshtokenService, alertService,serverError,postDataService,offlineError) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj:"="
				},
				template: __webpack_require__(291),
				link: function(scope, ele, $attrs, ctrl) {
					var state = 'posts';
					var postFunction = function() {   
			          postDataService.save({
			            param1:'posts',
			            param2:'addtodictionary' 
			          },{
			            'word':scope.currentPostObj.misspelledWord
			          }).$promise.then(function(postData){
			            alertService('success','Success ', postData.message, 2000);
			            var index = scope.currentPostObj.spelledArray.indexOf(scope.currentPostObj.misspelledWord)
			            scope.currentPostObj.spelledArray.splice(index,1);
			            if(scope.currentPostObj.spelledArray.length>0) {
			            	scope.currentPostObj.titleSpellInCorect = true;
			            } else {
			            	scope.currentPostObj.titleSpellInCorect = false;
			            }
			            $timeout(function() {
			            	scope.currentPostObj.closeDictionaryModal()
			            })
			          }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
			            if(error.status ==401) {
			              var promise = refreshtokenService.getAccessToken();
			              promise.then(
			                function(answer) {
			                  if(answer==200) {   
			                    postFunction();
			                  }
			                },
			                function(error) {
			                  // report something
			                },
			                function(progress) {
			                 // report progress
			              });
			            }else if(error.status ==502) {
			              serverError();
			            }else {
			              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
			            }
			          });
			        }
			        scope.addToDictionary = function() {
			        	postFunction();
			        }
				}
			}
		}
	}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('cropImageModal',cropImageModal);
		cropImageModal.$inject=['$window','getDataService','$rootScope','refreshtokenService','config','$timeout'];
		function cropImageModal($window,getDataService,$rootScope,refreshtokenService,config,$timeout) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj:"=",
					crop:"="
				},
				template: __webpack_require__(290),
				link: function(scope, ele, $attrs, ctrl) {
					$rootScope.modalShow = true;
					scope.loaderImage = true;
					scope.cropthumbs = false;
					if(scope.crop =='thumbs') {
						scope.cropthumbs = true;
					} else {
						scope.cropthumbs = false;
					}
					var onResize = function() {
						console.log('resize');
						scope.$apply(function() {
							scope.currentPostObj.cancelCropModal();
						})
					}
					angular.element($window).on('resize',onResize);
					scope.cropImage = function() {
						scope.$broadcast('crop-image', {'id':scope.currentPostObj.featured_img_id});
					}
					scope.index = 0;
					scope.config = config;
					scope.thumbsArray = [];
					for(var i=config.thumbs.length-1; i>=0;i--) {
						if(config.thumbs[i].height != 0) {
							scope.thumbsArray.push(config.thumbs[i]);
						}
					}
					scope.setCropArea = function(index,width,height,url) {
						scope.selectedImage = width+' pixel x '+height+ ' pixel';
						scope.index = index;
						scope.ratioWidth = width;
						scope.ratioHeight = height;
						scope.$broadcast('set-area', {ratio:{'width':scope.ratioWidth,'height':scope.ratioHeight},'url':url});
					}
					var initCroper = $timeout(function() {
						var width = scope.thumbsArray[scope.index].width;
						var height = scope.thumbsArray[scope.index].height;
						var description = scope.thumbsArray[scope.index].description;
						var url = scope.currentPostObj.featured_img_obj.thumbs[width+'x'+height];
						scope.setCropArea(scope.index, width, height, url);
						$timeout.cancel(initCroper);
						initCroper = null;
					},0)
					scope.$on('$destroy',function() {
						angular.element($window).off('resize',onResize);
					})
				}
			}
		}
	}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('croppieDir',croppieDir);
		croppieDir.$inject=['getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','postDataService','serverError','alertService','$compile','offlineError'];
		function croppieDir(getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,postDataService,serverError,alertService,$compile,offlineError) {
			return {
				restrict: 'E',
				scope: {
			      src: '=',
			      ngModel: '=',
			      postObj:'='
			    },
			    link: function (scope, element, attrs) {
				    if(!scope.src) return;
				    scope.imgWidth = scope.postObj.featured_img_obj.meta.width;
				    scope.imgHeight = scope.postObj.featured_img_obj.meta.height;
			    	var state = "attachments";
			    	var loader = angular.element(document.getElementById('loader.html')).html();
				     $timeout(function() {
		                element.after($compile(loader)(scope));
		             },0);
			    	scope.init = false;
		    		var boundaryHeight;
		      	var boundaryWidth;
			    	var viewportHeight;
						var viewportWidth;
						var browserWidth = window.innerWidth;
						boundaryWidth = 600;
						if(browserWidth < 650) {
						boundaryWidth = browserWidth - 40; 
						}
						console.log(browserWidth);
						var croppieInitFunction = function(width,height) {
							scope.loaderImageShow = true;
							viewportHeight = boundaryWidth/2*height/width;
								viewportWidth = boundaryWidth/2*width/height;
								scope.c = new Croppie(element[0], {
									viewport: {
											width: (scope.imgWidth < scope.imgHeight ? boundaryWidth/2 : viewportWidth),
											height: (scope.imgWidth < scope.imgHeight ? viewportHeight :boundaryWidth/2)
									},
									boundary: { 
										width: boundaryWidth, 
										height: boundaryWidth
									},
									update: function () {
											scope.c.result('canvas').then(function(img) {
												scope.$apply(function () {
													scope.ngModel = img;
												});
											});
									},
									enableZoom : false,
									showZoomer: false,
								});
	
							// bind an image to croppie
								scope.c.bind({
									url: scope.src
							}).then(function(data) {
								scope.loaderImageShow = false;
								scope.$apply();
							});
							
						}
						scope.$on('set-area', function(event, data) {
							if(scope.init) {
								scope.c.destroy();
							}
							scope.init = true;
							croppieInitFunction(data.ratio.width,data.ratio.height);
							scope.cropWidth = data.ratio.width;
							scope.cropHeight = data.ratio.height;
							scope.cropUrl = data.url;
							if(scope.cropUrl) {
								scope.file_name = scope.cropUrl.replace(/^.*[\\\/]/, '');
							}
						});
						var postCordianteFunction = function(id) {
							$timeout(function() {
								var coordinatesUpdate = scope.c.get().points;
							var cropData = {
								'selection': {
									'x': coordinatesUpdate[0],
									'y': coordinatesUpdate[1],
									'x2': (coordinatesUpdate[2] > scope.imgWidth)? scope.imgWidth: coordinatesUpdate[2],
									'y2': (coordinatesUpdate[3] > scope.imgHeight)? scope.imgHeight: coordinatesUpdate[3]  
								},
								'raw_values': {
									'id': id,
									'width': scope.imgWidth,
									'height': scope.imgHeight
								},
								'active_values': {
									'name': 'img-'+scope.cropWidth+'x'+scope.cropHeight,
									'width': scope.cropWidth,
									'height': scope.cropHeight,
									'ratio': scope.cropHeight/scope.cropWidth,
									'file_name': scope.file_name		  					
								}
							}
							console.log(cropData);
							var postFunction = function() {	
								postDataService.save({
										param1:state,
										param2:'crop',
									},cropData).$promise.then(function(data){
										scope.postObj.featured_img_obj.thumbs = data.attachment;
										$rootScope.hasLoaded = true;
											alertService('success','Success ', data.message, 2000);
									}, function(error){
										if(!window.navigator.onLine) {
											offlineError()
											$rootScope.hasLoaded = true;
											alertService('danger','Opps! ', 'Please check your internet connection and try again.');
											return
										}
										if(error.status ==401) {
											var promise = refreshtokenService.getAccessToken();
											promise.then(
												function(answer) {
													if(answer==200) {
														postFunction();
													}
												},
												function(error) {
													// report something
												},
												function(progress) {
													// report progress
											});
										} else if(error.status ==502) {
											serverError()
										} else {
											alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
										}
										$rootScope.hasLoaded = true;
								});
							}
							$rootScope.hasLoaded = false;
							postFunction();
							},0)
						}
						scope.$on('crop-image', function(event, data) {
							var id = data.id;
							var coordinates = scope.c.get().points;
							postCordianteFunction(id);
						});
				}
			}
		}
	}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('editImageModal',editImageModal);
		editImageModal.$inject=["postDataService","putDataService",'getDataService','$rootScope','activeClass','refreshtokenService','cleanObj','alertService','serverError','offlineError'];
		function editImageModal(postDataService,putDataService,getDataService,$rootScope,activeClass,refreshtokenService,cleanObj, alertService,serverError,offlineError) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj:"="
				},
				template: __webpack_require__(292),
				link: function(scope, ele, $attrs, ctrl) {
					scope.activeClassAlign = {
						alignleft : false,
						aligncenter : false,
						alignright : false,
						alignnone : false,
					}
					scope.selectedLink = {value:'none'};
					scope.customUrlShow = false;
					scope.editImageObj = {};
					scope.editImageObj.link_to = 'https://';
					scope.editImageObj.target_blank = false;
					scope.changeLink = function(link) {
						if(link=='url') {
							if(!scope.editImageObj.link_to) {
								scope.editImageObj.link_to = 'https://'
							}
							scope.customUrlShow = true;
						} else {
							scope.editImageObj.link_to = 'https://'
							scope.customUrlShow = false;
						}
					}
					scope.changeAlignStatus = function(event, align_status) {
						activeClass.active(event);
						scope.editImageObj.align = align_status;
					}
					
					scope.updateImage = function() {
						if(!scope.editImageObj.signature) {
							alertService('danger','Opps! ', 'Image does not have caption');
							return
						}
						if (scope.editImageObj.link_to == 'https://') {
							scope.editImageObj.link_to = null;
							scope.editImageObj.target_blank = null;
						};
						cleanObj.clean(scope.editImageObj);
						scope.currentPostObj.editImagefromEditor = false;
						$rootScope.modalShow = false;
						scope.$parent.$parent.$broadcast('update-image-editor', {updateImageObject:scope.editImageObj}); 
					}
					var deleteFunction = function () {
						putDataService.update({
							param1: 'attachments',
							param2: 'bulk',
							param3: 'delete'
						}, {
								'delete_ids': scope.mediaIds,
							}).$promise.then(function (bulkDelete) {
								scope.currentPostObj.editImagefromEditor = false;
								$rootScope.modalShow = false;
								$rootScope.hasLoaded = true;
								alertService('success', 'SUCCESS ', bulkDelete.message, 2000);
								scope.$parent.$parent.$broadcast('delete-media', {updateImageObject:scope.editImageObj});
	
							}, function (error) {
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if (error.status == 401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
										function (answer) {
											if (answer == 200) {
												putFunction();
											}
										},
										function (error) {
											// report something
										},
										function (progress) {
											// report progress
										});
								} else if (error.status == 502) {
									serverError();
								} else {
									alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
								$rootScope.hasLoaded = true;
							});
					}
					scope.deleteMedia = function (id) {
						$rootScope.hasLoaded = false;
						scope.mediaIds = [id];
						deleteFunction();
					}
					function changeMediaStatus(postIds, param) {
						if(!postIds) return;
						$rootScope.hasLoaded = false;
						postDataService.save({
							param1:'attachments',
							param2:'status',
							param3:param
						},{
							'ids': postIds,
						}).$promise.then(function(data){
							$rootScope.hasLoaded = true;
							getAttachmentsFunction()
							alertService('success','Success ', data.message, 2000);
						}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function(answer) {
									if(answer==200) {
										changeMediaStatus(postIds, param);
									}
									},
									function(error) {
									// report something
									},
									function(progress) {
									// report progress
								});
							} else if(error.status ==502) {
							serverError()
							} else {
							console.log(error)
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
					}
					scope.changeMediaStatus = function(postId,param) {
						changeMediaStatus([postId], param)
					}
					var getAttachmentsFunction = function() {
						getDataService.get({
				            param1: 'attachments',
				            param2: scope.currentPostObj.editImageObj.id,  
			            }).$promise.then(function(data){
			            	scope.editImageObj = data;
							scope.editImageObj.file = data.file;
							scope.editImageObj._id = scope.currentPostObj.editImageObj.id;
							if(scope.currentPostObj.editImageObj.signature_image) {
								scope.editImageObj.signature = scope.currentPostObj.editImageObj.signature_image;
							} else if(scope.currentPostObj.editImageObj.signature_image == null || scope.currentPostObj.editImageObj.signature_image == undefined) {
								scope.editImageObj.signature = data.signature;
							}
							if(scope.currentPostObj.editImageObj.align) {
								scope.activeClassAlign[scope.currentPostObj.editImageObj.align] = true;
								scope.editImageObj.align = scope.currentPostObj.editImageObj.align;
							}
							if (scope.currentPostObj.editImageObj.href) {
								scope.customUrlShow = true;
								scope.selectedLink = {value:'url'};
								scope.editImageObj.link_to = scope.currentPostObj.editImageObj.href;
							}
							if(scope.currentPostObj.editImageObj.target_blank) {
								scope.editImageObj.target_blank = true;
							} 
			          	}, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function(answer) {
									if(answer==200) {   
										getAttachmentsFunction();
									}
									},
									function(error) {
									},
									function(progress) {
									// report progress
								});
							} else if(error.status ==502) {
								serverError()
							} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}  
				      	});	
					}
					getAttachmentsFunction();
				}
			}
		}
	}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('onScrollLoad',onScrollLoad);
		onScrollLoad.$inject=['getDataService','jQuery','$compile','alertService','serverError','config','$filter','offlineError','refreshtokenService', 'checkArray'];
		function onScrollLoad(getDataService,jQuery, $compile,alertService,serverError,config, $filter,offlineError, refreshtokenService ,checkArray) {
			return {
				restrict: 'A',
				scope:{
					pageNumber:'=',
					currentLoad:'=',
					featuredImg:'=',
					searchData:'=',
					typeSearch:'=',
					selectedAttachment:'=',
					appState:'=',
					category:'=',
					maxPages:'=',
					scheduled:'=',
					onScrollLoading:'='			
				},
				link: function(scope, ele, $attrs, ctrl) {
					scope.config = config;
					// scope.pageCount=1000;		
					var s,type,uploaded_to;
					var category;
					scope.mediaItemsPage = [];
					var scrollTolerance = 5; //zoom page has rounding issues
					var isAtBottom = false; // to not trigger twice
					scope.onScrollAction =  function() {                                              
		                if((this.scrollHeight - this.scrollTop <= this.clientHeight + scrollTolerance) && ((scope.appState == 'attachments' && scope.selectedAttachment == 'all') || scope.appState != 'attachments')){
							if (!isAtBottom) {
								isAtBottom = true;
								scope.$apply(function() {
									scope.pageNumber++
									scope.loadMoreData();
									console.log('scrool-load-more', scope.pageNumber)	
								})
							}
		                } else {
							isAtBottom = false;
						}
		            };
		            angular.element(ele).on('scroll', scope.onScrollAction)
					scope.loadMoreData = function() {
						if(scope.appState == 'attachments') {
							if(scope.searchData) {
								if(scope.searchData.length>0) {
					              s = scope.searchData.toLowerCase();
					              if(scope.typeSearch) {
					              	type='all'
					              } else {
					              	type=null;
					              }
					            } else if(scope.searchData.length==0){
					              s = null;
					              type = null;
					            }
							} else {
								s = null;
					            type = null;
							}
							if(scope.selectedAttachment =='all') {
								uploaded_to = null
							} else {
								uploaded_to=scope.selectedAttachment
							}
						} else {
					        type = null;
					        uploaded_to = null
							if(scope.searchData) {
								if(scope.searchData.length>0) {
					              s = scope.searchData.toLowerCase();
	
					            } else if(scope.searchData.length==0){
					              s = null;
					            }
							} else {
								s = null;
							}
							if(scope.category) {
								if(scope.category =='all') {
									category =null;
								} else {
									category = scope.category;
								}
							}
						}
						if(scope.pageNumber<=scope.maxPages) {
							scope.onScrollLoading = true;
							var getFunction = function() {
								getDataService.get({
						            param1: (scope.appState=='attachments')? scope.appState: 'video',
						            param2: null,
						            limit: 100,
						         	page:scope.pageNumber,
						         	s:s,
						         	type:type,
				         			uploaded_to:uploaded_to,
				         			status: (scope.appState == 'videos' && scope.scheduled)? 'publish,schedule':(scope.appState == 'videos' && !scope.scheduled)? 'publish': null,
				         			category:category  
					            }).$promise.then(function(data){
					            	if(scope.appState=='attachments') {
						            	for(var i=0;i<data[scope.appState].length;i++) {
						            		if(scope.featuredImg==data[scope.appState][i]._id) {
						            			data[scope.appState].splice(i,1);
						            			break
						            		}
						            	}
					            	}
					            	if(scope.appState=='videos') {
					            		for(var i=0; i<data[scope.appState].length;i++) {
					                    data[scope.appState][i].thumb=scope.config.baseVideoHref + data[scope.appState][i].image.replace('.jpg','-254x191.jpg'); 
					                    data[scope.appState][i].file_video = scope.config.baseVideoHref + data[scope.appState][i].file.m3u8; 
					                    data[scope.appState][i].dateFormated = $filter('date')(data[scope.appState][i].date, "MMM d, y HH:mm")
					                    if(data[scope.appState][i].duration){
					                      var formatedTime;
					                      if(data[scope.appState][i].duration>=3600) {
					                        formatedTime = 'H:mm:ss'
					                      } else{
					                        formatedTime = 'm:ss'
					                      } 
					                      data[scope.appState][i].formated_duration = moment().startOf('day').second(data[scope.appState][i].duration).format(formatedTime);
					                    }
					                  }
					            	}
						            scope.currentLoad = checkArray.removeObjArryDuplicate(scope.currentLoad.concat(data[scope.appState]))
									scope.onScrollLoading = false;
						            // scope.pageCount = data.max_pages;
					          	}, function(error){
									if(!window.navigator.onLine) {
										offlineError()
										return
									}
						            if(error.status == 401) {
						              var promise = refreshtokenService.getAccessToken();
						                promise.then(
					                  	function(answer) {
					                    	if(answer==200) {
					                      		getFunction();                      
					                    	}
					                  	},
					                  	function(error) {
					                    // report something
					                  	},
					                  	function(progress) {
					                   // report progress
					                  	});
						            } else if(error.status ==502) {
	                					serverError();
	              					} else {
	                					alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              					}
									scope.onScrollLoading = false;
						        });
							}
							getFunction();
		        		}
					}
					scope.$on('$destroy', function() {
				      angular.element(ele).off('scroll', scope.onScrollAction);
				    });
				}
			}
		}
	}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('postDir',postDir);
		postDir.$inject=[];
		function postDir() {
			return {
				template: __webpack_require__(293),
				controller:"postController",
				controllerAs:"vmp",
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict';
		posts.directive('recommendedNewsModal',recommendedNewsModal);
		recommendedNewsModal.$inject=['$rootScope'];
		function recommendedNewsModal($rootScope) {
			return {
				restrict: 'E',
				scope: {
	        currentPostObj:"="
			  },
			 	template: __webpack_require__(294),
			  link: function (scope, element, attrs) {
	        $rootScope.modalShow = true;
	        scope.cancelRecommendedNewsModal = function() {
	          $rootScope.modalShow = false;
	          scope.currentPostObj.recommendedNewsModalShow = false;
	        }
	        scope.removeItem = function(index) {
	          scope.currentPostObj.recommendedNews.splice(index,1); 
	        }
	        scope.sortableRecomemendedOptions= {
	          axis: 'y'
	        }
				}    
			}
		}
	}


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('revisionsModal',revisionsModal);
		revisionsModal.$inject=['$timeout','getDataService','$rootScope','activeClass','refreshtokenService','cleanObj','alertService','serverError','offlineError'];
		function revisionsModal($timeout,getDataService,$rootScope,activeClass,refreshtokenService,cleanObj, alertService,serverError,offlineError) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj:"="
				},
				template: __webpack_require__(295),
				link: function(scope, ele, $attrs, ctrl) {
					var state = 'posts';
					scope.loadRevisions = false;
					var selectRevisionFunction = function(index) {
						if(scope.revisions[index].content) {
							scope.leftContent = scope.revisions[index].content;
						} else {
							scope.leftContent = '';
						}
						if(scope.revisions[index].title) {
			          		scope.leftTitle = scope.revisions[index].title;
						} else {
							scope.leftTitle = '';
						}
			          	if(scope.revisions[index].subtitle) {
			          		scope.leftSubtitle = scope.revisions[index].subtitle;
			          	} else {
			          		scope.leftSubtitle = '';
			          	}
			          	scope.revisionAuthor = scope.revisions[index].author.display_name;
			          	scope.revisionDate = scope.revisions[index].date_modified;
					}
					var getPostData = function() { 
				        getDataService.get({param1:'posts', param2:'revisions' ,param3: scope.currentPostObj.postId}).$promise.then(function(data){
				          scope.revisions = data.revisions;
				          scope.loadRevisions = true;
				          var defaultRevisionsIndex = scope.revisions.length-1;
				          scope.selectedRevisions ={value:defaultRevisionsIndex.toString()}; 
				          selectRevisionFunction(defaultRevisionsIndex);
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								return
							}
				          	if(error.status ==401) {
					            var promise = refreshtokenService.getAccessToken();
					            promise.then(
					              function(answer) {
					                if(answer==200) {
					                  getPostData();
					                }
					                // do something
					              },
					              function(error) {
					                // report something
					              },
					              function(progress) {
					               // report progress
					            });
				          	} else if(error.status ==502) {
				            	serverError()
				          	} else if(error.status == 404){
				          		scope.loadRevisions = false;
				          	} else {
				            	alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				          	}
				        });
			      	}
			      	getPostData();
			      	scope.changeRevisions = function(index) {
			      		var index = parseInt(index);
			      		selectRevisionFunction(index);
			      	}
					scope.options = {
						// interLineDiff: false,
	     //    			ignoreTrailingNewLines: true,
	        			attrs: {
				          insert: {
				            'data-attr': 'insert',
				            'class': 'insertion'
				          },
				          delete: {
				            'data-attr': 'delete'
				          },
				          equal: {
				            'data-attr': 'equal'
				          }
				        }
					}	
					scope.rightContent = scope.currentPostObj.textEditorContent;
					scope.rightTitle = scope.currentPostObj.dataPost.title;
					scope.rightSubtitle = scope.currentPostObj.dataPost.subtitle;
					scope.restorePost = function() {
						var post = {
							'title': scope.leftTitle,
							'subtitle': scope.leftSubtitle,
							'content': scope.leftContent,
							'author':scope.revisionAuthor,
							'date':scope.revisionDate
						}
						scope.$emit('restore-post',{post:post});
						$timeout(function() {
							scope.currentPostObj.cancelRevisionsModal();
						},0)
					}
				}
			}
		}
	}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (posts) {
		'use strict'
		posts.directive('setFeaturedImageModal', setFeaturedImageModal);
		setFeaturedImageModal.$inject = ['checkArray','keyPressOnlyNumber', 'authtokenService', 'getDataService', '$rootScope', 'activeClass', 'refreshtokenService', 'alertService', 'serverError', 'putDataService', 'postDataService', '$timeout','offlineError'];
		function setFeaturedImageModal(checkArray,keyPressOnlyNumber, authtokenService, getDataService, $rootScope, activeClass, refreshtokenService, alertService, serverError, putDataService, postDataService, $timeout, offlineError) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj: "=",
					attachToPost:'='
				},
				template: __webpack_require__(296),
				link: function (scope, ele, $attrs, ctrl) {
					$rootScope.modalShow = true;
					var s;
					scope.pageNumber = 1;
					var state = 'attachments';
					var uploaded_to;
					var type = null;
					scope.currentPostObj.data_grid = [];
					scope.checkedTypeSearch = false;
					scope.emptyTable = false;
					scope.currentPostObj.changeImageTrue = false;
					scope.selectedAlign = { value: 'alignnone' };
					scope.selectedLink = { value: 'none' };
					scope.selectedAttachments = { value: 'all' };
					scope.customUrlShow = false;
					scope.changeFieldFlag = false;
					scope.currentPostObj.mediaLibrary = true;
					scope.attachToPostArray = [];
					scope.multiSelect = {};
					scope.unselectAll = true;
					scope.mediaItems = [];
					scope.galleryOrderArray = [];
					scope.searchDataImage = '';
					scope.gallery_title = scope.currentPostObj.gallery_title || '';
					scope.slideShowUnsafe = scope.currentPostObj.slideShowUnsafe;
					scope.onlyNumber = function (event) {
						keyPressOnlyNumber(event)
					}
					if(scope.currentPostObj.galleryUpdateIds && scope.currentPostObj.updateGallery) {
						getDataService.get({
							param1: state,
							ids: scope.currentPostObj.galleryUpdateIds
						}).$promise.then(function (data) {
							var orderArray = scope.currentPostObj.galleryUpdateIds.split(',');
							scope.attachToPostArray = checkArray.sortArrayByIdPredefined(data.attachments,orderArray)
							for(var i = 0; i<scope.attachToPostArray.length;i++) {
								scope.multiSelect[scope.attachToPostArray[i]._id] = true;
							}
						}, function (error) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								return
							}
							if (error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function (answer) {
										if (answer == 200) {
											getimageLoadFunction();
										}
									},
									function (error) {
									},
									function (progress) {
										// report progress
									});
							} else if (error.status == 502) {
								serverError()
							} else {
								alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
						});
					}
					scope.addFileToPhotoLibrary = function(data) {
						$timeout(function(){
							scope.mediaItems.unshift(data.upload_data);
						},500)
					}
					scope.saveUploadedPhoto = function(data) {
						for (var i = 0; i < data.data.ids.length; i++) {
							for (var j = 0; j < scope.mediaItems.length; j++) {
								if (data.data.ids[i] == scope.mediaItems[j]._id) {
									if (data.data.description) {
										scope.mediaItems[j].description = data.data.description;
									}
									if (data.data.title) {
										scope.mediaItems[j].title = data.data.title;
									}
									if (data.data.gallery_title) {
										scope.mediaItems[j].gallery_title = data.data.gallery_title;
									}
									if (data.data.signature) {
										scope.mediaItems[j].signature = data.data.signature;
									}
									if (data.data.signature_url && scope.mediaItems[j].meta) {
										scope.mediaItems[j].meta.signature_url = data.data.signature_url;
									}
									break
								}
							}
						}
						for (var i = 0; i < scope.mediaItems.length; i++) {
							if (scope.multiSelect[i] == true) {
								scope.unselectAll = false;
							}
						}
					}
					scope.changeToInstertGallery = function () {
						// resetFunctionSelection();
					}
					// scope.$on('reset-selection', function (data) {
					// 	// resetFunctionSelection();
					// })
					scope.selectAllImagesFunction = function (model) {
						scope.attachToPostArray = [];
						for (var i = 0; i < scope.mediaItems.length; i++) {
							scope.multiSelect[scope.mediaItems[i]._id] = false;
							if (model) {
								scope.chooseImage(scope.mediaItems[i], i);
							} else {
								scope.unselectAll = true;
							}
						}
					}
					scope.changeAttachments = function (value) {
						if (!s) {
							type = null;
						} else {
							if (scope.checkedTypeSearch) {
								type = 'all';
							} else {
								type = null;
							}
						}
						jQuery(".grid").animate({
							scrollTop: 0
						}, 0);
						scope.pageNumber = 1;
						if (value == 'all') {
							uploaded_to = null;
							getimageLoadFunction();
						} else {
							uploaded_to = value
							getimageLoadFunction();
						}
					}
					var removeSelectedImageFunction = function (media) {
						for (var i = 0; scope.attachToPostArray.length; i++) {
							if (media._id == scope.attachToPostArray[i]._id) {
								scope.attachToPostArray.splice(i, 1);
								break
							}
						}
						scope.selectAllImages = false;
						scope.unselectAll = true;
					}
					scope.removeSelectedImage = function (media) {
						scope.multiSelect[media._id] = false;
						removeSelectedImageFunction(media);
					}
					scope.chooseImage = function (media, index) {
						if (media.restrictions) {
							if (media.restrictions.locked) return
						}
						if(media.status == 'lock') return
						if (scope.currentPostObj.insertMediatoEditor || scope.currentPostObj.insertGallery) {
							scope.selectedAlign = { value: 'alignnone' };
							scope.selectedLink = { value: 'none' };
							scope.customUrlShow = false;
							scope.unselectAll = true;
							scope.multiSelect[media._id] = !scope.multiSelect[media._id];
							scope.selectedImageObj = media;
							scope.selectedImageObj.align = scope.selectedAlign.value;
							scope.selectedImageObj.index = index;
							scope.changeLink = function (link) {
								if (link == 'url') {
									scope.customUrlShow = true;
									scope.selectedImageObj.link_to = 'https://';
								} else {
									scope.customUrlShow = false;
									scope.selectedImageObj.link_to = 'https://';
								}
							}
							scope.changeAlign = function (align) {
								scope.selectedImageObj.align = align;
							}
							if (scope.multiSelect[media._id] == true) {
								scope.unselectAll = false;
								scope.attachToPostArray.push(scope.selectedImageObj);
							} else {
								removeSelectedImageFunction(scope.selectedImageObj)
							}
						} else {
							scope.unselectAll = false;
							scope.selectedImage = media._id;
							scope.selectedImageObj = media;
						}
					}
					// scope.$on('reorder-images',function(event,data){
					// 	if(scope.attachToPostArray.length==0) return;
					// 	for(var i = 0 ;i < scope.attachToPostArray.length; i ++) {
					// 		for(var j = 0; j<data.mediaItems.length;j++) {
					// 			if(scope.attachToPostArray[i]._id == data.mediaItems[j]._id) {
					// 				scope.attachToPostArray[i].index = data.mediaItems[j].index							
					// 			}
					// 		}
					// 	}
					// })
	
					scope.setFeaturedImage = function () {
						scope.currentPostObj.featured_img_obj = scope.selectedImageObj;
						scope.currentPostObj.featured_img_id = scope.selectedImageObj._id;
						scope.currentPostObj.hasFeaturedImage = true;
						if (scope.current_id != scope.currentPostObj.featured_img_id) {
							scope.currentPostObj.changeImageTrue = true;
						}
					}
					scope.setShareImage = function () {
						scope.currentPostObj.shareImageObj = scope.selectedImageObj;
					}
					scope.postAttachFunction = function() {
						var postAttachFunction = function () {
							scope.idsToAttach = [];
							for (var i = 0; i < scope.attachToPostArray.length; i++) {
								scope.idsToAttach.push(scope.attachToPostArray[i]._id);
							}
							postDataService.save({
								param1: state,
								param2: 'attach',
								param3: scope.currentPostObj.postId
							}, {
									'ids': scope.idsToAttach
								}).$promise.then(function (data) {
									// alertService('success','Success ', data.message, 3000);
								}, function (error) {
									if (error.status == 401) {
										var promise = refreshtokenService.getAccessToken();
										promise.then(
											function (answer) {
												if (answer == 200) {
													postAttachFunction();
												}
											},
											function (error) {
												// report something
											},
											function (progress) {
												// report progress
											});
									} else if (error.status == 502) {
										serverError()
									} else {
										// alertService('danger','Opps! ', error.data.error.message);
									}
								});
						}
						if (scope.selectedAttachments.value == 'all') {
							postAttachFunction()
						}
					}
					scope.insertGallery = function() {
						if (scope.attachToPostArray.length > 0) {
							// scope.attachToPostArray = scope.attachToPostArray.sort(function(obj1, obj2){
							//              return  obj1.index - obj2.index
							//          });
							scope.attachToPostArrayIds = [];
							for (var i = 0; i < scope.attachToPostArray.length; i++) {
								scope.attachToPostArrayIds.push(scope.attachToPostArray[i]._id)
							}
							scope.$parent.$parent.$broadcast('insert-gallery', { 
								attachments_ids: scope.attachToPostArrayIds, 
								gallery_title:scope.gallery_title,
								slideShowUnsafe: scope.slideShowUnsafe, 
								update:(scope.currentPostObj.updateGallery)?true:false});
							$timeout(function () {
								scope.currentPostObj.cancelImageModal()
							}, 0)
						} else {
							alertService('danger', 'Opps! ', 'Image is not selected');
						}
						if(scope.attachToPost) {
							scope.postAttachFunction()
						}
					}
					scope.insertMediaToEditor = function () {
						if (scope.attachToPostArray.length > 0) {
							for (var i = 0; i < scope.attachToPostArray.length; i++) {
								if (!scope.attachToPostArray[i].signature) {
									scope.selectedImageObj = scope.attachToPostArray[i];
									alertService('danger', 'Opps! ', 'Image (title:' + scope.attachToPostArray[i].title + ') does not have signature');
									return false
								}
								if (scope.attachToPostArray[i].link_to == 'https://') {
									scope.attachToPostArray[i].link_to = null;
								};
							}
							// scope.attachToPostArray = scope.attachToPostArray.sort(function(obj1, obj2){
							//              return  obj1.index - obj2.index
							//          });
							scope.$parent.$parent.$broadcast('add-media-to-editor', { insertMediaArray: scope.attachToPostArray });
							$timeout(function () {
								scope.currentPostObj.cancelImageModal()
							}, 0)
						} else {
							alertService('danger', 'Opps! ', 'Image is not selected');
						}
						if(scope.attachToPost) {
							scope.postAttachFunction()
						} 
					}
					// scope.reorderImage = function() {
	
					// }
					// scope.changeMediaAction = function (event, actionMedia) {
					// 	resetRestrictionFunction();
					// 	activeClass.active(event);
					// 	if (actionMedia == 'insert-media') {
					// 		scope.currentPostObj.insertMediatoEditor = true;
					// 		scope.currentPostObj.setFeaturedImage = false;
					// 	} else if (actionMedia == 'set-featured-image') {
					// 		scope.currentPostObj.setFeaturedImage = true;
					// 		scope.currentPostObj.insertMediatoEditor = false;
					// 		$timeout(function () {
					// 			scope.chooseImage(scope.mediaItems[0], 0);
					// 		}, 0);
					// 	}
					// }
					scope.searchEmpty = function (value) {
						if (value.length == 0) {
							$timeout(function () {
								scope.search(value)
							}, 0)
						}
					}
					scope.search = function (value) {
						if (scope.checkedTypeSearch) {
							type = 'all';
						} else {
							type = null;
						}
						if (value.length > 0) {
							s = value.toLowerCase();
						} else if (value.length == 0) {
							s = null;
							type = null;
						}
						jQuery(".grid").animate({
							scrollTop: 0
						}, 0);
						scope.pageNumber = 1;
						getimageLoadFunction();
					}
					var deleteFunction = function (post) {
						putDataService.update({
							param1: state,
							param2: 'bulk',
							param3: 'delete'
						}, {
								'delete_ids': scope.mediaIds,
							}).$promise.then(function (bulkDelete) {
								if(post.featuredImage) {
									$timeout(function() {
										scope.currentPostObj.removeFeaturedImage();
	
									},0)
								}
								if(post.shareImage) {
									$timeout(function() {
										scope.currentPostObj.removeShareImage();
	
									},0)
								}
								removeSelectedImageFunction(post);
								$rootScope.hasLoaded = true;
								getimageLoadFunction();
								scope.$broadcast('delete-photo-from-upload',{id:scope.mediaIds[0]});
								scope.mediaIds = null;
								scope.unselectAll = true;
								alertService('success', 'SUCCESS ', bulkDelete.message, 2000);
							}, function (error) {
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if (error.status == 401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
										function (answer) {
											if (answer == 200) {
												putFunction();
											}
										},
										function (error) {
											// report something
										},
										function (progress) {
											// report progress
										});
								} else if (error.status == 502) {
									serverError();
								} else {
									alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
								$rootScope.hasLoaded = true;
							});
					}
					scope.deleteMedia = function (post) {
						$rootScope.hasLoaded = false;
						scope.mediaIds = [post._id];
						deleteFunction(post);
					}
					var postFunction = function () {
						$rootScope.hasLoaded = false;
						postDataService.save({
							param1: state,
							param2: 'update',
							id: scope.selectedImageObj._id
						}, {
								'title': scope.selectedImageObj.title,
								'signature': scope.selectedImageObj.signature,
								'image_alt': scope.selectedImageObj.image_alt,
								'description': scope.selectedImageObj.description,
								'signature_url': scope.selectedImageObj.meta.signature_url,
								'gallery_title': scope.selectedImageObj.gallery_title
							}).$promise.then(function (data) {
								$rootScope.hasLoaded = true;
								alertService('success', 'SUCCESS ', data.message, 2000);
							}, function (error) {
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if (error.status == 401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
										function (answer) {
											if (answer == 200) {
												postFunction();
											}
										},
										function (error) {
											// report something
										},
										function (progress) {
											// report progress
										});
								} else if (error.status == 502) {
									serverError()
								} else {
									alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
								$rootScope.hasLoaded = true;
							});
					}
					scope.changeField = function () {
						scope.changeFieldFlag = true;
					}
					scope.outFocus = function () {
						if (scope.changeFieldFlag) {
							$rootScope.hasLoaded = false;
							scope.changeFieldFlag = false;
							postFunction();
						}
					}
					var getimageLoadFunction = function () {
						$rootScope.hasLoaded = false;
						getDataService.get({
							param1: state,
							param2: null,
							limit: 100,
							page: scope.pageNumber,
							s: s,
							type: type,
							uploaded_to: uploaded_to,
							sortby: (scope.selectedAttachments.value != 'all') ? 'order' : null
						}).$promise.then(function (data) {
							$rootScope.hasLoaded = true;
							scope.emptyTable = false;
							// resetFunctionSelection();
							scope.mediaItems = data.attachments;
	
							scope.maxPages = data.max_pages;
							if (!s && scope.selectedAttachments.value == 'all' && !scope.currentPostObj.insertMediatoEditor && !scope.currentPostObj.insertGallery) {
								var currentObj;
								if(scope.currentPostObj.featured_img_obj && scope.currentPostObj.setFeaturedImage) {
									scope.current_id = scope.currentPostObj.featured_img_obj._id
									currentObj = scope.currentPostObj.featured_img_obj
									scope.currentPostObj.featured_img_obj.featuredImage = true;
								} else if(scope.currentPostObj.setShareImage && scope.currentPostObj.shareImageObj) {
									currentObj = scope.currentPostObj.shareImageObj
									scope.currentPostObj.shareImageObj.shareImage = true;
								}
								if(currentObj) {
									for (var i = 0; i < scope.mediaItems.length; i++) {
										if (currentObj._id == scope.mediaItems[i]._id) {
											scope.mediaItems.splice(i, 1);
											break
										}
									}
									scope.mediaItems.unshift(currentObj);
								}
							}
							if (!scope.currentPostObj.insertMediatoEditor && !scope.currentPostObj.insertGallery) {
								scope.unselectAll = false;
								$timeout(function () {
									scope.chooseImage(scope.mediaItems[0], 0);
									if(scope.currentPostObj.featured_img_obj && !s && scope.currentPostObj.featured_img_obj.status =='lock') {
										scope.chooseImage(scope.mediaItems[1], 1);
									}
								}, 0);
							}
						}, function (error) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								return
							}
							if (error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function (answer) {
										if (answer == 200) {
											getimageLoadFunction();
										}
									},
									function (error) {
									},
									function (progress) {
										// report progress
									});
							} else if (error.status == 502) {
								serverError()
							} else if (error.status == 404) {
								// resetFunctionSelection();
								scope.emptyTable = true;
								scope.mediaItems = [];
							} else {
								scope.mediaItems = [];
								alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
					}
					getimageLoadFunction();
				}
			}
		}
	}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var globalHelpers = __webpack_require__(18);
	module.exports = function(posts) {
		'use strict'
		posts.controller('postEditorCtrl',postEditorCtrl);
		postEditorCtrl.$inject=['countCharacters','editorExludeShortcode','parseOptions','refreshtokenService','$window','config','reverseWpautop','$scope','$timeout','jQuery', '$element','getDataService','$compile','$rootScope', '$attrs', 'alertService','postDataService','serverError','offlineError','authtokenService'];
		function postEditorCtrl(countCharacters,editorExludeShortcode,parseOptions,refreshtokenService,$window,config,reverseWpautop,$scope,$timeout,jQuery, $element, getDataService,$compile,$rootScope, $attrs,alertService,postDataService,serverError,offlineError,authtokenService) {   
	    var vmeditorP = this;
	    vmeditorP.config = config;
	    vmeditorP.postObj = $scope.$eval($attrs.objPost);
	    vmeditorP.typeData = $scope.$eval($attrs.typeData);
	    $scope.windowWidth = window.innerWidth;
	    vmeditorP.aiEditorsTools = config.aiEditorsTools;
	    vmeditorP.aitoolsEnabled = authtokenService.getAitools();
	    vmeditorP.aiEditorToolsEnabled = [];
	    vmeditorP.aiEditorsTools.forEach(function(tool) {
	      if(vmeditorP.aitoolsEnabled.includes(tool.funcionality)) {
	        vmeditorP.aiEditorToolsEnabled.push(tool);
	      }
	    });
	    var editorHeight;
	    var editorHeightFunction = function() {
	        editorHeight = jQuery('.mce-edit-area').height();
	        return  editorHeight;
	    }
	    function autoResizeHeight(ele) {
	      ele.style.height = 'auto';
	      ele.style.height = (ele.scrollHeight) + 'px';
	    }
	    function updateCharacterCount() {
	      if (tinymce.activeEditor) {
	          var content = tinymce.activeEditor.getContent();
	          vmeditorP.postObj.editorCharacterCount = countCharacters(content);
	      }
	    }
	    var modal = angular.element(document.getElementById('modal.html')).html();
	    var editorHtml = angular.element(document.getElementById('editor.html')).html();
	    var insertTag = angular.element(document.getElementById('insertTag.html')).html();
	    var insertPost = angular.element(document.getElementById('insertPost.html')).html();
	    var insertEmbedCode = angular.element(document.getElementById('insertEmbedCode.html')).html();
	    vmeditorP.selectedPollAction = {value:'default'};
	    vmeditorP.selectedTypeVideo = {value:'default'};
	    vmeditorP.requiredPoll = false;
	    vmeditorP.requiredTnowId = false;
	    vmeditorP.requiredVideoType = false;
	    vmeditorP.requiredVideoId = false;
	    vmeditorP.requiredQuoteText = false;
	    vmeditorP.requiredTelegrafVideo = false;
	    // vmeditorP.requiredQuestionText = false;
	    vmeditorP.quoteModalShow = false;
	    vmeditorP.videoModalShow = false;
	    vmeditorP.telegrafVideoModalShow = false;
	    vmeditorP.editor_preview_visual = true;
	    vmeditorP.cancelInsertTagModal = function() {
	      vmeditorP.searchTag = null;
	      $element.siblings('.editor-insert-tag').remove();
	      $rootScope.modalShow = false;
	    }
	    vmeditorP.cancelInsertPostModal = function() {
	      $element.siblings('.editor-insert-post').remove();
	      $rootScope.modalShow = false;
	    }
	    vmeditorP.cancelInsertEmbedCodeModal = function() {
	      vmeditorP.embedCode = '';
	      $element.siblings('.editor-insert-embedcode').remove();
	      $rootScope.modalShow = false;
	    }
	    vmeditorP.cancelTinymceModal = function() {
	      $element.siblings('.tinymce-modal').remove();
	      vmeditorP.videoModalShow = false;
	      vmeditorP.questionModalShow = true;
	      vmeditorP.quoteModalShow = true;
	      $rootScope.modalShow = false;
	    }
	    var minifyHtmlElement = function(content,ele) {
	      var elements = content.getElementsByTagName(ele);
	      for (var i = 0; i < elements.length; i++) {
	        var htmlEl =elements[i].outerHTML;
	        jQuery(elements[i]).replaceWith(htmlEl.replace(/^\s+|\r\n|\n|\r|(>)\s+(<)|\s+$/gm, '$1$2').replace(/<br \/>/g, '').replace(/<\/p>/g, '').replace(/<p>/g, ''));
	      }
	    }
	    vmeditorP.pasteText = function(event){
	      event.preventDefault();
	      var clp = (event.originalEvent || event).clipboardData;
	      var text = clp.getData('text/plain')
	      text = text.replace(/<p>/gmi, "");
	      text = text.replace(/<p ([^>]*)>/gmi, "");
	      text = text.replace(/<\/p>/g, "");
	      document.execCommand('insertText', false, text);
	    } 
	    var stripEmptyElement = function(content,ele) {
	      var elements = content.getElementsByTagName(ele);
	      var isEmpty = function ( el ){
	        return !jQuery.trim(el.html())
	      }
	      for (var i = 0; i < elements.length; i++) {
	        
	        if (isEmpty(jQuery(elements[i]))) {
	          jQuery(elements[i]).remove();
	        }
	      }
	    }
	    var  parseOptionsFunc = parseOptions;
	    var contentSaveFunction = function() {
	      tinyMCE.activeEditor.dom.remove('edit-image');
	      tinyMCE.activeEditor.dom.remove('edit-gallery');
	      tinyMCE.activeEditor.dom.remove('edit-embed');
	      tinyMCE.activeEditor.dom.remove('edit-summary');
	      var selectedSummary = tinyMCE.activeEditor.dom.get('selected-summary');
	      if(selectedSummary) {
	        jQuery(selectedSummary).removeAttr('id')
	      }
	      // jQuery(tinymce.activeEditor.getBody()).find('a:not([target])').attr({'target': '_blank','rel':'noopener'});
	      minifyHtmlElement(tinymce.activeEditor.getBody(),"script")
	      // tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
	      stripEmptyElement(tinymce.activeEditor.getBody(),"a")
	      var postContent = tinymce.activeEditor.getContent();
	      postContent.replace(/\<captionblock([^\]].*?)>([^\]]*?)\<\/captionblock>/g, function(all, attr, con) {
	          var parseOptions = parseOptionsFunc(attr);
	          if(parseOptions.signature_url) {
	            var signatureUrl = parseOptions.signature_url
	          } else {
	            var signatureUrl = ''
	          }
	          if(parseOptions.image_link) { 
	            var imageLink = 'image_link="'+parseOptions.image_link+'"'
	          } else {
	            var imageLink = ''
	          }
	          if(parseOptions.image_target_blank) {
	            var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
	          } else {
	            var imageTargetBlank = ''
	          }
	          var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	          postContent = postContent.replace( all,'[caption id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+']'+con+'[/caption]\n\n');
	      });
	      postContent.replace(/\<galleryblock([^\]].*?)>(.*?)\<\/galleryblock>/g, function(all, attr, con) {
	        postContent = postContent.replace( all, con+'\n\n');
	      });
	      postContent.replace(/\<summaryblock\>(.*?)\<\/summaryblock>/g, function(all, con) {
	        postContent = postContent.replace( all, con+'\n\n');
	      });
	      postContent.replace(/\<embedblock([^\]].*?)>(.*?)\<\/embedblock>/g, function(all, attr, con) {
	        var parseOptions = parseOptionsFunc(attr);
	        var type = parseOptions.type || parseOptions.src;
	        postContent = postContent.replace( all,'[embed type="'+type+'"]'+con+'[/embed]\n\n');
	      });
	      postContent = reverseWpautop(postContent);
	      vmeditorP.postObj.textEditorContent = postContent;
	    }
	    var aitoolsbar = vmeditorP.aiEditorToolsEnabled.length > 0 ? ' ai |' : '';
	    window.editor = tinyMCE;
	    vmeditorP.tinymceOptions = {
		    selector: "textarea",
		    format:'raw',
	      menubar:false,
	      verify_html : true,
	      plugins: [
	          'lists customLink image anchor',
	          'fullscreen',
	          'autoresize hr pagebreak paste'
	      ],
	      skin: false,
	      // Prevent HTML entity conversion to preserve &quot; in title attributes
	      entity_encoding: 'raw',
	      encoding: 'html',
	      // Disable automatic entity conversion
	      convert_urls: false,
	      urlconveter_callback: function(url,node,on_save, name) {
	        var url = url;
	        if(!url.includes('http') && node.nodeName == 'A' && name=='href') {
	          url= 'http://' + url
	        }
	        return url 
	      },
		    // // theme : 'modern',
	      toolbar: (vmeditorP.typeData == 'page')? 'formath2 formath3 | bold italic | bullist numlist | hr | link unlink | tolatin | pagebreak | undo redo | fullscreen ':'formath2 formath3 | bold italic | bullist numlist | hr | link unlink | quote | question | recommendedNews | gallery | video | embed | poll | tag |'+aitoolsbar+' tolatin | pagebreak | undo redo | fullscreen ',
	      valid_elements : "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
	      + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
	      + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
	      + "name|href|target|title|class|onfocus|onblur|style],strong/b,em/i,strike,u,"
	      + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
	      + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
	      + "-blockquote[*],-table[border=0|cellspacing|cellpadding|width|frame|rules|"
	      + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
	      + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
	      + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
	      + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,#div,"
	      + "span[*],-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
	      + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
	      + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
	      + "|height|src|*],script[src|type|language|async|defer|charset],map[name],area[shape|coords|href|alt|target],bdo,"
	      + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
	      + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
	      + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
	      + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
	      + "q[cite],samp,select[disabled|multiple|name|size],small,"
	      + "textarea[cols|rows|disabled|name|readonly],tt,var,big,time,iframe[*],-section[*]",
	      // valid_elements: '[]',
	      // valid_children: '[]',
	      extended_valid_elements : "captionblock[id|align|width|height|signature_url|image_link|image_target_blank],+svg[*],+g[*],+path[*],galleryblock[ids|title|safe|span|id],+video[*],+source[*],embedblock[*],summaryblock[*]",
	      custom_elements: "captionblock,galleryblock,embedblock,summaryblock",
	      valid_children: "+p[strong|a|b|img|i|br|em|script|iframe|blockquote|time],embedblock[blockquote,script,iframe,div],+a[div]", // "+" add valid children 
	      content_css: [
	          'tinymce/custom-tinymce.css?v=13'
	      ],
	      body_class: 'custom_class',
	      default_link_target: "_blank",
	      rel_list: [
	        {title: 'DoFollow', value: ''},
	        {title: 'NoFollow', value: 'nofollow'},
	        {title: 'Sponsored', value: 'sponsored'}
	      ],
	      target_list:[
	        { title: 'Current window', value: '' },
	        { title: 'New window', value: '_blank' }
	      ],
	      forced_root_block : false,
	      force_p_newlines : true,
	      remove_linebreaks : false,
	      relative_urls : false,
	      remove_script_host : false,
	      indent: false,
	      // paste_text_sticky_default: true,
	      // force_br_newlines : true,
	      remove_trailing_nbsp : false,
	      style_formats: [
	        {title: 'Heading 2', format: 'h2'},
	        {title: 'Heading 3', format: 'h3'},
	        {title: 'Heading 4', format: 'h4'},
	        {title: 'Heading 5', format: 'h5'},
	        {title: 'Heading 6', format: 'h6'},
	      ],
	      paste_preprocess: function(plugin, args) {
	        // Only block actual script/iframe tags or javascript: URLs
	        // This pattern looks for opening tags (< or &lt;) followed by script or iframe
	        // Or for javascript: protocol in URLs
	        var dangerousPattern = /(<script|<iframe|&lt;script|&lt;iframe|script<\/span>|iframe<\/span>|javascript:)/i;
	        
	        if (dangerousPattern.test(args.content)) {
	            // Block the paste and notify the user
	            args.content = ''; // Clear the content
	            $scope.$apply(function() {
	              alertService('danger', 'Oops!', 'Pasting of <script> or <iframe> tags is not allowed! Use embed code button.');
	            });
	            return;
	        }
	        
	        // Strip all HTML tags except those we have whitelisted
	        var whitelist = 'p,strong,i,em,br,a';
	        var content = args.content;
	        if(args.content.match(/<br>|<br \/>/g)) {
	          var content = wpautop(args.content.replace(/<br>|<br \/>/g, "\n"));
	        }
	        var stripped = jQuery('<div>' + content + '</div>');
	        // var brs = stripped.find('br')
	        var els = stripped.find('*').not(whitelist);
	        for (var i = els.length - 1; i >= 0; i--) {
	          var e = els[i];
	          jQuery(e).replaceWith(e.innerHTML);
	        }
	          // Strip all class and id attributes
	        stripped.find('*').removeAttr('id').removeAttr('class');
	          // Return the clean HTML
	        args.content = stripped.html();
	      },
	      paste_postprocess : function(pl, o) {
	          // remove extra line breaks
	          o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/ig, " ");
	      },
	      init_instance_callback: function (editor) {
	        editor.on('SetContent', function (e) {
	          editor.setDirty(true);
	          editor.fire('change')
	        });     
	        
	        // Custom serializer to preserve HTML entities in title attributes
	        editor.serializer.addAttributeFilter('title', function(nodes, name) {
	          var i = nodes.length, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.attr('title')) {
	              // Preserve HTML entities in title attributes
	              var title = node.attr('title');
	              // Ensure quotes are properly encoded as &quot;
	              title = title.replace(/"/g, '&quot;');
	              node.attr('title', title);
	            }
	          }
	        });
	        
	        editor.serializer.addNodeFilter('script,style', function(nodes, name) {
	          var i = nodes.length, node, value, type;
	
	          function trim(value) {
	              /*jshint maxlen:255 */
	              /*eslint max-len:0 */
	              return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
	                      .replace(/^[\r\n]*|[\r\n]*$/g, '')
	                      .replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
	                      .replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	          }
	          while (i--) {
	              node = nodes[i];
	              value = node.firstChild ? node.firstChild.value : '';
	
	              if (value.length > 0) {
	                  node.firstChild.value = trim(value);
	              }
	          }
	        });
	      },
	      setup: function(editor) {
	        var selection;
	        var signature;
	        var editImageArray = {};
	        var image_id;
	        editor.on('PreInit', function() {
	          tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
	        });
	        var setCursorAfterCaptionFunction = function(e) {
	          var dom = tinymce.activeEditor.dom; 
	          var parents = dom.getParents( tinymce.activeEditor.selection.getNode() );
	          function setCursorToNewParagraph(){
	            var newParagraph = dom.select( 'p#' + uniqueID )[0];
	            tinymce.activeEditor.selection.setCursorLocation( newParagraph );
	          }
	          for( var i=0; i < parents.length; i++ ) {
	            var currentNode = parents[i];
	            // Insert empty paragraph at the end of the parent of the closest custom tag
	            if( currentNode.nodeName == 'CAPTIONBLOCK' || currentNode.nodeName == 'GALLERYBLOCK' || currentNode.nodeName == 'EMBEDBLOCK' || currentNode.nodeName == 'SUMMARYBLOCK') {
	                // dom.insertAfter doesn't work reliably
	                if(jQuery(currentNode).parent('p').get(0)) {
	                  currentNode = jQuery(currentNode).parent('p')
	                }
	                if(e) {
	                  var event = window.event ? window.event : e;
	                  if(event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
	                    var uniqueID = dom.uniqueId();
	                    if(!e.shiftKey) {
	                      jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
	                      setCursorToNewParagraph() 
	                    } else if (event.keyCode == 13 && e.shiftKey) {
	                      jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertBefore( currentNode );
	                      setCursorToNewParagraph()
	                    }
	                    e.preventDefault();
	                    // Move to the new node
	                  }
	                } else {
	                  var uniqueID = dom.uniqueId();
	                  jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
	                  
	                  // Move to the new node
	                  setCursorToNewParagraph()
	                }
	                // Don't create an extra paragraph
	                editor.setDirty(true);
	                editor.fire('change')
	                break;
	            }
	          }
	        }
	        var insertOrUpdateImage = function(imgArray,update) {
	          var insertImage={};
	          // var insertImages = '';
	          for(var i=0; i<imgArray.length;i++) {
	            console.log(imgArray[i]);
	            insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
	            if(imgArray[i].link_to) {
	              insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	              if(imgArray[i].target_blank) {
	               insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
	              }
	            }
	            if(imgArray[i].signature) {
	              if(imgArray[i]._id in editImageArray) {
	                editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
	              }
	              if(imgArray[i].meta && imgArray[i].meta.signature_url) {
	                var signatureUrl = imgArray[i].meta.signature_url
	              } else {
	                var signatureUrl = ''
	              }
	              insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
	              if (imgArray[i].link_to) {
	                console.log(imgArray[i].link_to)
	                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'" image_link="'+imgArray[i].link_to+'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                if(imgArray[i].target_blank) {
	                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'" image_link="'+imgArray[i].link_to+'" image_target_blank="true"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
	                }
	              };
	            } else {
	              insertImage[i] = '<p>'+insertImage[i]+'</p>';
	              if(imgArray[i]._id in editImageArray) {
	                editImageArray[imgArray[i]._id].signature_image = null;
	              }
	            }
	            if(!update) {
	              setCursorAfterCaptionFunction();
	            }
	            tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
	          //  insertImages = insertImages.concat(insertImage[i]);
	          }
	        }
	        var addMediaListener = $scope.$on("add-media-to-editor",function(event, data) {
	          tinyMCE.activeEditor.dom.remove('edit-image');
	          for(var i=0;i<data.insertMediaArray.length;i++) {
	  
	            if(data.insertMediaArray[i].align === 'undefined' || !data.insertMediaArray[i].align) data.insertMediaArray[i].align = 'alignnone' 
	            editImageArray[data.insertMediaArray[i]._id] = {
	              id : data.insertMediaArray[i]._id,
	              align : data.insertMediaArray[i].align,
	              href : data.insertMediaArray[i].href,
	              target_blank : data.insertMediaArray[i].target_blank,
	              signature_image : data.insertMediaArray[i].signature || null
	            }
	          }
	          insertOrUpdateImage(data.insertMediaArray);
	          $timeout(function() {
	            tinymce.activeEditor.execCommand('mceAutoResize');
	          },100)
	        });
	        var removeImage = function(parents) {
	          for( var i=0; i < parents.length; i++ ) {
	            if(parents[i].nodeName == 'IMG') {
	              var image = parents[i];
	              jQuery(image).remove();
	            } else if(parents[i].nodeName =='A') {
	              var parentAnchor = parents[i];
	              jQuery(parentAnchor).remove();
	            }else if(parents[i].nodeName == 'CAPTIONBLOCK') {
	              var parentCaption = parents[i];
	              jQuery(parentCaption).remove();
	            }
	          }
	        }
	        $scope.$on('$destroy', addMediaListener);
	        var updateMediaListener = $scope.$on("update-image-editor",function(event, data) {
	          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	          tinyMCE.activeEditor.dom.remove('edit-image');
	          setCursorAfterCaptionFunction();
	          removeImage(parents)
	          if(data.updateImageObject.align === 'undefined' || !data.updateImageObject.align) data.updateImageObject.align = 'alignnone';
	          var insertMediaArray = [data.updateImageObject];
	          insertOrUpdateImage(insertMediaArray,true);
	          var editorContentBody = tinymce.activeEditor.getBody();
	          stripEmptyElement(editorContentBody,"p");
	          tinyMCE.activeEditor.dom.remove(nodeImage);   
	        });
	        $scope.$on('$destroy', updateMediaListener);
	        var deleteMedia = $scope.$on("delete-media",function(event, data) {
	          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	          tinyMCE.activeEditor.dom.remove('edit-image');
	          tinyMCE.activeEditor.dom.remove('selected-image')
	          removeImage(parents)
	          editor.setDirty(true);
	          editor.fire('change')   
	        });
	        $scope.$on('$destroy', deleteMedia);
	        var addSlideshowListener = $scope.$on("insert-gallery",function(event, data) {
	          if(data.update) {
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            setCursorAfterCaptionFunction();
	            tinyMCE.activeEditor.dom.remove('selected-gallery');
	          }
	          var attachments_ids = data.attachments_ids.join();
	          var title;
	          if(data.gallery_title) {
	            title = data.gallery_title
	          } else {
	            title=''
	          }
	          var insertslideShowShortcode = '<galleryblock ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '">[gallery ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '"]</galleryblock>';
	          setCursorAfterCaptionFunction();
	          tinymce.activeEditor.execCommand('mceInsertContent', false, insertslideShowShortcode);
	        });
	        $scope.$on('$destroy', addSlideshowListener);
	        // var addTelegrafTvListener = $scope.$on("insert-telegraftv",function(event, data) {
	        //   var postContent = vmeditorP.postObj.textEditorContent;
	        //   var validation = true;
	        //   postContent.replace(/\[video(.*?)?\](?:([\s\S]*?)(\[\/video\]))?/g, function(all, attr, con) {
	        //         var parseOptions = parseOptionsFunc(attr);
	        //         if(parseOptions.id == data.videoId) {
	        //           validation = false;
	        //           alertService('danger','Opps! ', 'This video alredy exist!!!');
	        //           return
	        //         }
	        //   });
	        //   if(validation) {
	        //     var title=(data.showVideoTitle)? data.title: '';
	        //     var align = (data.showVideoTitle)? data.align: '';
	        //     var inserVtelegrafVideoShortcode = '[video id="'+data.videoId + '" title="' + title + '" align="' + align + '"]';
	        //     setCursorAfterCaptionFunction();
	        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+inserVtelegrafVideoShortcode+'</p>');
	        //     $timeout(function(){
	        //       vmeditorP.postObj.cancelVideoModal()
	        //     },0)
	        //   }
	        // });
	        // $scope.$on('$destroy', addTelegrafTvListener);
	        var addPollListener = $scope.$on("insert-poll-to-editor",function(event, data) {
	          var postContent = vmeditorP.postObj.textEditorContent;
	          var validation = true;
	          postContent.replace(/\[poll(.*?)?\](?:([\s\S]*?)(\[\/poll\]))?/g, function(all, attr, con) {
	                var parseOptions = parseOptionsFunc(attr);
	                if(parseOptions.id == data._id) {
	                  validation = false;
	                  alertService('danger','Opps! ', 'This poll alredy exist!!!');
	                  return
	                }
	          });
	          if(validation) {
	            if(data.hasOwnProperty('result')) {
	              var insertPollShortcode = '[poll id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/poll]';
	            } else {
	              var insertPollShortcode = '[poll id="'+data._id + '"]'+data._id+'[/poll]';
	            }
	            setCursorAfterCaptionFunction();
	            tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPollShortcode+'</p>');
	          }
	        });
	        $scope.$on('$destroy', addPollListener);
	        // var addRatingListener = $scope.$on("insert-rating-to-editor",function(event, data) {
	        //   var postContent = vmeditorP.postObj.textEditorContent;
	        //   var validation = true;
	        //   postContent.replace(/\[rating(.*?)?\](?:([\s\S]*?)(\[\/rating\]))?/g, function(all, attr, con) {
	        //         var parseOptions = parseOptionsFunc(attr);
	        //         if(parseOptions.id == data._id) {
	        //           validation = false;
	        //           alertService('danger','Opps! ', 'This rating alredy exist!!!');
	        //           return
	        //         }
	        //   });
	        //   if(validation) {
	        //     if(data.hasOwnProperty('result')) {
	        //       var insertRatingShortcode = '[rating id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/rating]';
	        //     } else {
	        //       var insertRatingShortcode = '[rating id="'+data._id + '"]'+data._id+'[/rating]';
	        //     }
	        //     setCursorAfterCaptionFunction();
	        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertRatingShortcode+'</p>');
	        //   }
	        // });
	        // $scope.$on('$destroy', addRatingListener);
	        // var addBlogListener = $scope.$on("insert-blog-to-editor",function(event, data) {
	        //   var postContent = vmeditorP.postObj.textEditorContent;
	        //   var validation = true;
	        //   postContent.replace(/\[liveblog(.*?)?\](?:([\s\S]*?)(\[\/liveblog\]))?/g, function(all, attr, con) {
	        //         var parseOptions = parseOptionsFunc(attr);
	        //         if(parseOptions.id == data._id) {
	        //           validation = false;
	        //           alertService('danger','Opps! ', 'This blog alredy exist!!!');
	        //           return
	        //         }
	        //   });
	        //   if(validation) {
	        //     var insertBlogShortcode = '[liveblog id="'+data._id + '"]'+data._id+'[/liveblog]';
	        //     setCursorAfterCaptionFunction();
	        //     tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertBlogShortcode+'</p>');
	        //   }
	        // });
	        // $scope.$on('$destroy', addBlogListener);
	        editor.on("init", function() {
	          // Add character counter element after the editor
	          var counterHtml = '<div class="editor-character-count">Characters: <span ng-class="{\'danger-color\': vmeditorP.postObj.editorCharacterCount < 800}">{{vmeditorP.postObj.editorCharacterCount}}</span></div>';
	          jQuery('.mce-edit-area').after($compile(counterHtml)($scope));
	          // Initial count
	          updateCharacterCount();
	          var statusbar_editor = angular.element(document.getElementsByClassName("mce-statusbar"));
	          var toolbar_editor = angular.element(document.getElementsByClassName("mce-toolbar-grp"));
	          var add_madia_editor = angular.element(document.getElementsByClassName("add-media-editor"));
	          var change_preview_wrap = angular.element(document.getElementById("change-preview-wrapper"));
	          var editarea_editor = angular.element(document.getElementsByClassName("mce-edit-area"));
	          jQuery(editarea_editor).after($compile(editorHtml)($scope));
	          var editor_plain_text = document.getElementsByClassName("editor-plain-text")[0];
	          jQuery(editor_plain_text).on('input', function () {
	            autoResizeHeight(this)
	          }); 
	          $scope.onScrollAction = function(){
	              var width = jQuery('.single-post--left-col').width() -2;
	              var offset = jQuery($element).offset();
	              var topPos = offset.top;
	              var leftPos = offset.left;
	              editorHeightFunction();
	              //the current height
	              var y = window.scrollY || window.pageYOffset;
	              //If the current Y is bigger than the element. (you scrolled beyond the element)
	              if(y >= topPos - jQuery(change_preview_wrap).outerHeight() && y< topPos + editorHeight - 150){
	                jQuery(editarea_editor).css('padding-top',jQuery(toolbar_editor).outerHeight()+jQuery(change_preview_wrap).outerHeight());
	                jQuery(toolbar_editor).css({'position':'fixed','top':jQuery(change_preview_wrap).outerHeight(),'left':leftPos, 'z-index':9999,'width':width,'border':'1px solid rgba(0,0,0,0.2)'});
	                jQuery(change_preview_wrap).css({'position':'fixed','top':0,'left':leftPos, 'z-index':9999,'width':width +2,'border-bottom':'none'});
	                if(!vmeditorP.editor_preview_visual) {
	                  jQuery(change_preview_wrap).css({'border-bottom':'1px solid rgba(0,0,0,0.2)'});
	                }
	                  //do something
	              } else {
	                jQuery(editarea_editor).css('padding-top',0);
	                jQuery(toolbar_editor).css({'position':'static','top':'auto','left':'auto', 'z-index':9999,'width':'auto','border':'none'});
	                jQuery(change_preview_wrap).css({'position':'static','width':'100%','border-bottom':'none'});
	                if(!vmeditorP.editor_preview_visual) {
	                  jQuery(change_preview_wrap).css({'border-bottom': 'none'});
	                }
	              }
	          };
	          $scope.onResizeAction = function() {
	            if($scope.windowWidth == window.innerWidth) return
	            $scope.windowWidth = window.innerWidth
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            $scope.onScrollAction()
	          }
	          angular.element($window).on('scroll', $scope.onScrollAction);
	          angular.element($window).on('resize', $scope.onResizeAction);
	          $scope.$on("change-editor",function(event, data) {
	            if(data.editor_preview == 'visual') {
	                vmeditorP.editor_preview_visual = true;
	                jQuery(add_madia_editor).removeClass('hidden');
	                jQuery(toolbar_editor).removeClass('hidden');
	                jQuery(editarea_editor).removeClass('hidden');
	                jQuery(statusbar_editor).removeClass('hidden');
	                jQuery(editor_plain_text).addClass('hidden');
	                jQuery('.editor-character-count').removeClass('hidden');
	                var postContent = vmeditorP.postObj.textEditorContent;
	                postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  if(parseOptions.signature_url) {
	                    var signatureUrl = parseOptions.signature_url
	                  } else {
	                    var signatureUrl = ''
	                  }
	                  if(parseOptions.image_link) {
	                    var imageLink = 'image_link="'+parseOptions.image_link+'"'
	                  } else {
	                    var imageLink = ''
	                  }
	                  if(parseOptions.image_target_blank) {
	                    var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
	                  } else {
	                    var imageTargetBlank = ''
	                  }
	                  var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	                  postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
	                });
	                postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  var title;
	                  if(parseOptions.title) {
	                    title =parseOptions.title
	                  } else {
	                    title=''
	                  }
	                  postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
	                });
	                postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
	                  postContent = postContent.replace( all,'<summaryblock>'+all+'</summaryblock>');
	                });
	                postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
	                  var parseOptions = parseOptionsFunc(attr);
	                  var type = parseOptions.type || parseOptions.src;
	                  postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
	                });
	                postContent = wpautop(postContent)
	                tinyMCE.activeEditor.setContent(postContent);
	                contentSaveFunction();
	            } else {
	                vmeditorP.editor_preview_visual = false;
	                stripEmptyElement(tinymce.activeEditor.getBody(),"p");
	                contentSaveFunction();
	                jQuery(editor_plain_text).removeClass('hidden');
	                autoResizeHeight(editor_plain_text);
	                jQuery(editarea_editor).addClass('hidden');
	                jQuery(statusbar_editor).addClass('hidden');
	                jQuery(toolbar_editor).addClass('hidden');
	                jQuery(add_madia_editor).addClass('hidden');
	                jQuery('.editor-character-count').addClass('hidden');
	            }
	          });
	        });
	        //  editor.on('ExecCommand', function (e) {              
	        //   console.log(e.command);     
	        // })
	        // editor.on('Undo', function () {
	        //   editor.setDirty(true);
	        //   editor.fire('change')
	        // });
	    
	        // editor.on('Redo', function () {
	        //   editor.setDirty(true);
	        //   editor.fire('change')
	        // });
	        editor.on('keydown', function( event ) {
	          tinyMCE.activeEditor.dom.remove('edit-image');
	          tinyMCE.activeEditor.dom.remove('edit-gallery');
	          tinyMCE.activeEditor.dom.remove('edit-embed');
	          tinyMCE.activeEditor.dom.remove('edit-summary');
	          if (event.keyCode === 8) {
	            // Get the currently selected node within the editor
	            var selectedNode = editor.selection.getNode();
	    
	            // Check if the selected node is a paragraph
	            if (selectedNode && selectedNode.nodeName === 'P') {
	                // Check if the cursor is positioned at the beginning of the paragraph
	                var selection = editor.selection.getRng();
	                if (selection.startOffset === 0 && selection.endOffset === 0) {
	                    // Get the previous sibling of the paragraph
	                    var prevSibling = selectedNode.previousSibling;
	    
	                    // Check if the previous sibling is an embedblock
	                    if (prevSibling && (prevSibling.nodeName === 'CAPTIONBLOCK' || prevSibling.nodeName === 'EMBEDBLOCK' || prevSibling.nodeName === 'GALLERYBLOCK' || prevSibling.nodeName === 'SUMMARYBLOCK')) {
	                        // Prevent the default behavior of the backspace key
	
	                        event.preventDefault();
	                        if(!selectedNode.textContent.trim()) {
	                          editor.dom.remove(selectedNode);
	                        }
	                        var range = editor.dom.createRng();
	                        range.selectNodeContents(prevSibling);
	                        range.collapse(false); // Move to the end
	                        editor.selection.setRng(range);
	                        return
	                    }
	                }
	            }
	          }
	          setCursorAfterCaptionFunction(event);
	        });
	        editor.on("click", function(e) {
	          if(vmeditorP.postObj.category =='bbc') {
	            jQuery(tinymce.activeEditor.getBody()).addClass('bbc')  
	          } else {
	            jQuery(tinymce.activeEditor.getBody()).removeClass('bbc')
	          }
	          selection = tinymce.activeEditor.selection.getNode();
	          var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
	          var nodeGallery = tinyMCE.activeEditor.dom.get('selected-gallery');
	          var nodeEmbed = tinyMCE.activeEditor.dom.get('selected-embed');
	          var nodeSummary = tinyMCE.activeEditor.dom.get('selected-summary');
	          var ele = e.target.nodeName;
	          var classes = jQuery(nodeImage).attr('class');
	          if(classes) {
	            var classesArray = classes.split(' ');
	            if(classesArray.length>1) {
	              image_id = classesArray[1].substr(9);
	            } else {
	              image_id = classesArray[0].substr(9);
	            }
	          }  
	          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
	          if(jQuery(e.target).hasClass('mce-i-remove')) {
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('selected-image')
	            removeImage(parents)
	            editor.setDirty(true);
	            editor.fire('change')         
	          } else if(jQuery(e.target).hasClass('mce-i-remove-gallery')){
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            tinyMCE.activeEditor.dom.remove('selected-gallery')
	            setCursorAfterCaptionFunction();
	            editor.setDirty(true);
	            editor.fire('change')
	          }else if(jQuery(e.target).hasClass('mce-i-remove-summary')){
	            console.log('remove summary')
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-summary')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-summary');
	            tinyMCE.activeEditor.dom.remove('selected-summary')
	            setCursorAfterCaptionFunction();
	            editor.setDirty(true);
	            editor.fire('change')
	          } else if(jQuery(e.target).hasClass('mce-i-editsummary')) {
	            tinyMCE.activeEditor.dom.remove('edit-summary');
	            if(nodeSummary) {
	              jQuery(nodeSummary).removeAttr('id')
	            }
	            $scope.$apply(function() {
	              vmeditorP.postObj.openAiModal('text-summary', true);
	            });
	          } else if(jQuery(e.target).hasClass('mce-i-editgallery')) {
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            if(!nodeGallery) return
	            if(jQuery(nodeGallery).attr('title')) {
	              vmeditorP.postObj.gallery_title = jQuery(nodeGallery).attr('title');
	            }
	            if(jQuery(nodeGallery).attr('safe')) {
	              vmeditorP.postObj.slideShowUnsafe = !$scope.$eval(jQuery(nodeGallery).attr('safe'))
	            }
	            if(jQuery(nodeGallery).attr('ids')) {
	              vmeditorP.postObj.galleryUpdateIds = jQuery(nodeGallery).attr('ids'); 
	              vmeditorP.postObj.addGallerytoEditor('update');
	            } else {
	              alertService('danger', 'Opps! ', 'Gallery shortcode is not valid.\nRemove or correct shortcode');
	            }
	          }else if(jQuery(e.target).hasClass('mce-i-remove-embed')){
	            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-embed')[0] )
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	            setCursorAfterCaptionFunction();
	            tinyMCE.activeEditor.dom.remove('selected-embed')
	            editor.setDirty(true);
	            editor.fire('change')
	          } else if(jQuery(e.target).hasClass('mce-i-editimage')) {
	            if(vmeditorP.postObj.category == 'bbc') return
	            $rootScope.modalShow = true;
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            for( var i=0; i < parents.length; i++ ) {
	                if(parents[i].nodeName =='A') {
	                  var parentAnchor = parents[i];
	                  var image_href = jQuery(parentAnchor).attr('href');
	                  var target_blank = jQuery(parentAnchor).attr('target');
	                  if(target_blank) {
	                    var targetblank = true;
	                  } else {
	                    var targetblank = false;
	                  }
	                  tinyMCE.activeEditor.selection.select(parents[i]);
	                } else if(parents[i].nodeName == 'CAPTIONBLOCK') {
	                  var parentCaptionblock = parents[i];
	                  var image_signature = jQuery(parentCaptionblock).text();
	                  var image_align = (!jQuery(parentCaptionblock).attr('align') || jQuery(parentCaptionblock).attr('align') === 'undefined')? 'alignnone': jQuery(parentCaptionblock).attr('align');
	                  tinyMCE.activeEditor.selection.select(parents[i]);
	                }
	
	            }
	            editImageArray[image_id] = {
	              id : image_id,
	              align : image_align,
	              href : image_href,
	              target_blank : targetblank,
	              signature_image : image_signature
	            }
	            $rootScope.$broadcast('edit-image', {editImageObj:editImageArray[image_id]});
	          } else {
	            if(nodeImage) {
	              jQuery(nodeImage).removeAttr('id');
	            }
	            if(nodeGallery) {
	              jQuery(nodeGallery).removeAttr('id');
	            }
	            if(nodeSummary) {
	              jQuery(nodeSummary).removeAttr('id');
	            }
	            if(nodeEmbed) {
	              jQuery(nodeEmbed).removeAttr('id');
	            }
	            tinyMCE.activeEditor.dom.remove('edit-image');
	            tinyMCE.activeEditor.dom.remove('edit-gallery');
	            tinyMCE.activeEditor.dom.remove('edit-embed');
	            tinyMCE.activeEditor.dom.remove('edit-summary');
	            if(ele =="IMG") {
	
	              jQuery(e.target).attr('id','selected-image'); 
	              var edit_image_content = '<i class="mce-ico mce-i-editimage"></i><i class="mce-ico mce-i-remove"></i>';
	              var pos = tinymce.DOM.getPos(e.target);
	              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-image','style':'left:'+pos.x+'px;top:'+pos.y+'px;'}, edit_image_content)
	            }
	            if(ele=="GALLERYBLOCK") {
	              jQuery(e.target).attr('id','selected-gallery');
	              var galleryWidth = jQuery(e.target).innerWidth(); 
	              var edit_gallery_content = '<i class="mce-ico mce-i-editgallery" title="Edit gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>';
	              var pos = tinymce.DOM.getPos(e.target);
	              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-gallery','style':'left:'+(pos.x + galleryWidth - 45) +'px;top:'+pos.y+'px;'}, edit_gallery_content)
	            }
	            if(ele=="SUMMARYBLOCK") {
	              jQuery(e.target).attr('id','selected-summary');
	              var edit_summary_content = '<i class="mce-ico mce-i-editsummary" title="Edit summary"></i><i class="mce-ico mce-i-remove-summary" title="Remove summary"></i>';
	              var pos = tinymce.DOM.getPos(e.target);
	              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-summary','style':'right:0px;top:'+(pos.y)+'px;'}, edit_summary_content)
	            }
	            if(ele=="EMBEDBLOCK") {
	              jQuery(e.target).attr('id','selected-embed');
	              // var embedWidth = jQuery(e.target).innerWidth(); 
	              var edit_embed_content = '<i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>';
	              var pos = tinymce.DOM.getPos(e.target);
	              tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{id:'edit-embed','style':'left:'+pos.x +'px;top:'+(pos.y)+'px;'}, edit_embed_content)
	            }
	          }
	         
	        });
	        editor.on("change", function() {
	          contentSaveFunction();    
	          updateCharacterCount();
	        });
	        editor.addButton('formath2', {   
	          icon:'h2',
	          tooltip : 'Make h2', 
	          onclick : function() {
	            editor.execCommand('FormatBlock', false, 'h2');
	          }
	        });
	        editor.addButton('formath3', {   
	          icon:'h3',
	          tooltip : 'Make h3', 
	          onclick : function() {
	            editor.execCommand('FormatBlock', false, 'h3');
	          }
	        });
	        editor.addButton('tolatin',{
	          tooltip:'Convert to latin',
	          icon:'latin',
	          onclick:function() {
	            var content = tinymce.activeEditor.getContent();
	            
	            content = globalHelpers.specifiedShortcodePlaceholderEditorContent(content, ['embedblock','captionblock']);
	            // Convert remaining content to Latin
	            var latinContent = globalHelpers.cyrillicToLatin(content);
	            // Restore preserved shortcodes
	            latinContent = globalHelpers.specifiedShortcodeRestoreEditorContent(latinContent);
	            tinymce.activeEditor.setContent(latinContent);
	          } 
	        });
	        if(vmeditorP.typeData == 'post') {
	          editor.addButton('poll',{
	            tooltip:'Insert poll',
	            icon:'poll',
	            onclick:function() {
	              $timeout(function(){
	                $scope.$parent.addPollToEditor()
	              },0)
	            }
	          });
	          // editor.addButton('rating',{
	          //   tooltip:'Insert rating',
	          //   icon:'rating',
	          //   onclick:function() {
	          //     $timeout(function(){
	          //       $scope.$parent.addRatingToEditor()
	          //     },0)
	          //   }
	          // });
	          // editor.addButton('blog',{
	          //   tooltip:'Insert live blog',
	          //   icon:'blog',
	          //   onclick:function() {
	          //     $timeout(function(){
	          //       $scope.$parent.addBlogToEditor()
	          //     },0)
	          //   }
	          // });
	          editor.addButton('quote',{
	            tooltip:'Insert quote tag',
	            icon:'quote',
	            onclick:function() {
	              vmeditorP.requiredQuoteText = false;
	              $rootScope.modalShow = true;
	              vmeditorP.videoModalShow = false;
	              vmeditorP.quoteModalShow = true;
	              vmeditorP.questionModalShow = false;
	              vmeditorP.selectedQuoteAlignAction = {value :'left'};
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              vmeditorP.insertQuote = function() {
	                if(vmeditorP.quoteText) {
	                  vmeditorP.requiredQuoteText = false;
	                    var insertQuoteShortcode = '[quote align="'+vmeditorP.selectedQuoteAlignAction.value +'"]'+vmeditorP.quoteText+'[/quote]';
	                    setCursorAfterCaptionFunction();
	                    tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertQuoteShortcode+'</p>');
	                    $element.siblings('.tinymce-modal').remove();
	                    vmeditorP.quoteText = null;
	                    vmeditorP.quoteModalShow = false;
	                    $rootScope.modalShow = false;
	                } else {
	                  alertService('danger','Opps! ', 'Quote text is required');
	                  vmeditorP.requiredQuoteText = true;
	                }
	              }
	            }
	          });
	          editor.addButton('tag',{
	            tooltip:'Insert tag',
	            icon:'tag',
	            onclick:function() {
	              var edSelection = tinymce.activeEditor.selection;
	              if(!edSelection.getContent()) return;
	              vmeditorP.searchTag = edSelection.getContent({format : 'text'})
	              $timeout(function() {
	                $element.after($compile(insertTag)($scope));
	                document.getElementById('editor-input-tag').focus()
	              },0);
	              $rootScope.modalShow = true;
	              $scope.$on('editor-select-tag', function(event,data) {
	                tinymce.activeEditor.focus();
	                edSelection.setContent('<a id="selected-tag" href="'+data.selectedTagObj.tagUrl+'" target="_blank" rel="noopener">' + edSelection.getContent({format : 'text'}) + '</a>');
	                tinymce.activeEditor.setContent(tinymce.activeEditor.getContent())
	                var edDom = tinymce.activeEditor.dom;
	                var selectedTag = edDom.select('a#selected-tag')[0]
	                edSelection.select(selectedTag);
	                edSelection.collapse(0)
	                $timeout(function(){
	                  edDom.setAttrib('selected-tag', 'id', '');
	                },0)
	                $timeout(function(){
	                  vmeditorP.cancelInsertTagModal()
	                },0)
	              });
	            }
	          });
	          editor.addButton('video',{
	            tooltip:'Insert video',
	            icon:'video',
	            onclick:function() {
	              vmeditorP.requiredVideoId = false;
	              vmeditorP.requiredVideoType = false;
	              $rootScope.modalShow = true;
	              vmeditorP.videoModalShow = true;
	              vmeditorP.quoteModalShow = false;
	              vmeditorP.questionModalShow = false;
	              vmeditorP.selectedTypeVideo = {value:'default'};
	              vmeditorP.videoType = vmeditorP.selectedTypeVideo.value;
	              vmeditorP.videoId = null;
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              vmeditorP.switchTypeVideo = function(type) {
	                vmeditorP.videoType = type;
	              }
	              vmeditorP.insertVideo = function() {
	                var validation = true;
	                if(vmeditorP.videoType != 'default') {
	                  vmeditorP.requiredVideoType = false;
	                } else {
	                  validation = false;
	                  vmeditorP.requiredVideoType = true;
	                  alertService('danger','Opps! ', 'Choose video service');
	                }
	                if(vmeditorP.videoId) {
	                  vmeditorP.requiredVideoId = false;
	                } else {
	                  validation = false;
	                  alertService('danger','Opps! ', 'Video ID is required');
	                  vmeditorP.requiredVideoId = true;
	                }
	                if(validation) {
	                  $element.siblings('.tinymce-modal').remove();
	                  vmeditorP.selectedTypeVideo = {value:'default'};
	                  vmeditorP.videoModalShow = false;
	                  var insertVideoShortcode = '['+ vmeditorP.videoType +' '+ vmeditorP.videoId +']';
	                  setCursorAfterCaptionFunction();
	                  tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertVideoShortcode+'</p>');
	                  vmeditorP.videoId = null;
	                  $rootScope.modalShow = false;
	                }
	              }
	            }
	          });
	          editor.addButton('question',{
	            tooltip:'Add a Question',
	            icon:'interview',
	            onclick:function() {
	              vmeditorP.requiredQuestionText = false;
	              $rootScope.modalShow = true;
	              vmeditorP.videoModalShow = false;
	              vmeditorP.quoteModalShow = false;
	              vmeditorP.questionModalShow = true;
	
	              $timeout(function() {
	                $element.after($compile(modal)($scope));
	              },10);
	              vmeditorP.insertQuestion = function() {
	                if(vmeditorP.questionText) {
	                  vmeditorP.requiredQuestionText = false;
	                    setCursorAfterCaptionFunction();
	                    tinyMCE.activeEditor.selection.setContent('<ul><li class="intervju">'+vmeditorP.questionText+'</li></ul>');
	                    $element.siblings('.tinymce-modal').remove();
	                    vmeditorP.questionText  = null;
	                    vmeditorP.quoteModalShow = false;
	                    $rootScope.modalShow = false;
	                } else {
	                  vmeditorP.requiredQuestionText = true;
	                  alertService('danger','Opps! ', 'Question text is required');
	                }
	              }
	            }
	          });
	          // editor.addButton('telegrafvideo',{
	          //   tooltip:'Insert Telegraf TV Video',
	          //   icon:'telegraf-tv',
	          //   onclick:function() {
	          //     $timeout(function(){
	          //       vmeditorP.postObj.insertVideotoEditor();
	          //     },0)
	          //   }
	          // });
	          editor.addButton('gallery',{
	            tooltip:'Insert gallery',
	            icon:'gallery',
	            onclick:function() {
	              $timeout(function(){
	                vmeditorP.postObj.addGallerytoEditor();
	              },0)
	            }
	          });
	          editor.addButton('recommendedNews',{
	            tooltip:'Insert News',
	            icon:'recommended-news',
	            onclick:function() {
	              $timeout(function() {
	                $element.after($compile(insertPost)($scope));
	                document.getElementById('search-post').focus()
	              },0);
	              $rootScope.modalShow = true;
	              vmeditorP.addPostFromSearch = function(obj){
	                var insertPostShortcode = '[readalso id="'+obj.id +'"][/readalso]';
	                setCursorAfterCaptionFunction();
	                tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPostShortcode+'</p>');
	                $timeout(function(){
	                  vmeditorP.cancelInsertPostModal()
	                },0)
	              }
	            }
	          });
	          editor.addButton('embed',{
	            tooltip:'Insert embed code',
	            icon:'embed',
	            onclick:function() {
	
	              $timeout(function() {
	                $element.after($compile(insertEmbedCode)($scope));
	                document.getElementById('insert-embedcode').focus()
	              },0);
	              $rootScope.modalShow = true;
	              vmeditorP.insertEmbedCode = function(){
	                if(vmeditorP.embedCode) {
	                  var type = 'unknown';
	                  if(vmeditorP.config.embed) {
	                    for (var key in vmeditorP.config.embed) {
	                      if(vmeditorP.embedCode.includes(vmeditorP.config.embed[key])) {
	                        type = key
	                      }
	                    }
	                  }
	                  function replacePWithSpan(html) {
	                    // Define a regular expression pattern to match <p> elements
	                    var pattern = /<p(\s+[^>]*)?>([\s\S]*?)<\/p>/g;
	                
	                    // Replace <p> elements with <span> elements
	                    var newHtml = html.replace(pattern, function(match, attrs, content) {
	                        // Construct the replacement with <span> tag
	                        return '<div' + (attrs || '') + '>' + content + '</div>';
	                    });
	                
	                    return newHtml;
	                }
	                var embed = replacePWithSpan(vmeditorP.embedCode);
	                embed = embed.replace(/<br>|<br \/>/g, "");
	                // embed = embed.replace(/\[/g, '(').replace(/\]/g, ')');
	                var insertEmbedShortcode = '<embedblock type="'+type+'">'+embed+'</embedblock>';
	                setCursorAfterCaptionFunction();
	                tinymce.activeEditor.execCommand('mceInsertContent', false, insertEmbedShortcode);
	                setCursorAfterCaptionFunction();
	                $timeout(function(){
	                  vmeditorP.embedCode = '';
	                  vmeditorP.cancelInsertEmbedCodeModal()
	                },0)
	                } else {
	                  vmeditorP.requiredEmbedCode = true;
	                  alertService('danger','Opps! ', 'Embed code is required');
	                }
	              }
	            }
	          });
	          if(vmeditorP.aiEditorToolsEnabled.length > 0) {
	            var menu = [];
	            vmeditorP.aiEditorToolsEnabled.forEach(function(tool) {
	              menu.push({
	                text: tool.name,
	                classes: 'ai-menu-item',
	                onclick: function(e) {
	                  // Prevent event bubbling and default behavior
	                  if (e) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                  }
	                  // Use $timeout to ensure Angular digest cycle
	                  $timeout(function() {
	                    $scope.$apply(function() { 
	                      vmeditorP.postObj.openAiModal(tool.funcionality);
	                    });
	                  });
	                }
	              });
	            });
	            editor.addButton('ai', 
	              {
	              type: 'menubutton',
	              text: 'AI',
	              icon: 'ai',
	              tooltip: 'AI Tools',
	              onPostRender: function() {
	                var button = this.getEl();
	                if (button) {
	                  var buttonContainer = button.parentNode;
	                  if (buttonContainer) {
	                    buttonContainer.className += ' mce-i-ai-button';
	                    // Add touch event handling for the menu items
	                    buttonContainer.addEventListener('touchend', function(e) {
	                      var menuItem = e.target.closest('.mce-menu-item');
	                      if (menuItem) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        // Find the tool associated with this menu item
	                        var toolName = menuItem.textContent.trim();
	                        var tool = vmeditorP.aiEditorToolsEnabled.find(function(t) {
	                          return t.name === toolName;
	                        });
	                        if (tool) {
	                          $timeout(function() {
	                            $scope.$apply(function() {
	                              vmeditorP.postObj.openAiModal(tool.funcionality);
	                            });
	                          });
	                        }
	                      }
	                    }, true);
	                  }
	                }
	              },
	              menu: menu
	            });
	          }
	        }
	      }    
	  	}
	    $scope.$on('$destroy', function() {
	      angular.element($window).off('scroll', $scope.onScrollAction);
	      angular.element($window).off('resize', $scope.onResizeAction);
	    });  
		}
	}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		'use strict'
	  posts
	  .controller('postController', postController)
		postController.$inject = ["tabSessionService","warningAlertService","eventStream","parseOptions","addToOther","authtokenService","$filter","$interval","cleanObj","$timeout","API_URL","postDataService","$http","$attrs","$rootScope","$scope","getDataService","jQuery","$state","refreshtokenService","config","activeClass","alertService","putDataService","$window","serverError",'cleanArray', 'checkArray','keyPressOnlyNumber','offlineError'];
		
	  function postController(tabSessionService,warningAlertService,eventStream,parseOptions,addToOther,authtokenService,$filter,$interval,cleanObj,$timeout,API_URL, postDataService,$http,$attrs,$rootScope,$scope,getDataService,jQuery,$state,refreshtokenService, config, activeClass, alertService,putDataService,$window,serverError,cleanArray, checkArray, keyPressOnlyNumber, offlineError) {
	    var vmp = this;
	    var parent = $scope.$eval($attrs.parent);
	    vmp.myPost = $scope.$eval($attrs.myPost);
	    var appState = 'allposts'
	    if(vmp.myPost) {
	      appState = 'myposts'
	    }
	    var streamTaxonomy = 'posts';
	    vmp.autosaveInterval;
	    var tagPosts = null;
	    var sponsored = null;
	    vmp.recommendedNews = [];
	    vmp.recommendedNewsShow = false;
	    vmp.intervalHeartBeatFunction;
	    vmp.newPost = true;
	    vmp.postId = false;
	    vmp.hasFeaturedImage = false;
	    vmp.config = config;
	    vmp.editurl = false;
	    vmp.setFeaturedImageShow = false;
	    vmp.selectedPostStatus={value:''}
	    vmp.selectedPictureDemonstrate={value:'yes'};
	    vmp.selectedDateDemonstrate={value:'yes'};
	    // vmp.selectedRelatedDemonstrate={value:'no'};
	    // vmp.selectedRelatedDemonstratePositionBottom = {value:'no'}
	    vmp.selectedBannerDemonstrate={value:'yes'};
	    vmp.selectedPrDemonstrate={value: 'no'};
	    vmp.selectedPostMont = {value: "1"};
	    vmp.featured_img = undefined;
	    vmp.changeImageTrue = false;
	    vmp.insertMediatoEditor = false;
	    vmp.mediaModal = false;
	    vmp.setFeaturedImage = false;
	    vmp.cropModalShow = false;
	    vmp.insertMediatoEditor = false;
	    vmp.hiddenResult = -1;
	    vmp.hasResult = true;
	    vmp.editPostStatusShow = false;
	    vmp.newTagRequired = false;
	    vmp.allowcomments = true;
	    vmp.titleRequired = false;
	    vmp.categoryRequired = false;
	    vmp.scheduledPost = false;
	    vmp.category = null;
	    vmp.tnow_data = null;
	    vmp.titleNews = {};
	    vmp.shortTitleNews = {};
	    vmp.featured_img_id;
	    vmp.statusDraft = true;
	    vmp.dataPost = {};
	    vmp.dataPost.tags = [];
	    vmp.editorPreviewVisual = true;
	    vmp.intervalHeartBeatPost = null;
	    vmp.mediaLibrary = true;
	    vmp.singleView = true;
	    vmp.copyEditedSlug = false;
	    vmp.categorychecked = {};
	    vmp.parentCategoriesChecked = {};
	    vmp.commentsPriority ={value:'0'}
	    vmp.userId = parseInt(authtokenService.getUserId());
	    vmp.aitoolsEnabled = authtokenService.getAitools();
	    vmp.aiToolsObj = null;
	    
	    // Add change detection variables
	    vmp.originalPostData = null;
	    vmp.hasUnsavedChanges = false;
	    vmp.isNavigatingAway = false;
	    if(vmp.intervalHeartBeatPost) {
	      $interval.cancel(vmp.intervalHeartBeatPost);
	      vmp.intervalHeartBeatPost = null;
	    }
	    if(vmp.autosaveInterval) {
	      $interval.cancel(vmp.autosaveInterval);
	      vmp.autosaveInterval = null;
	    }
	    vmp.editPostDateShow = false;
	    $rootScope.modalShow = false;
	    vmp.editSlugShow = false; 
	    var userId = authtokenService.getUserId();
	    vmp.featuredImageRequired = false;
	    vmp.revisionsModalShow = false;
	    var updateDate = null;
	    vmp.copySlug = null;
	    vmp.data_grid = [];
	    vmp.pastPost = false;
	    vmp.searchPage = 0;
	    vmp.postResult = [];
	    vmp.selectedPhotoQuality={value:'medium'};
	    vmp.slideShowUnsafe = false;
	    vmp.keyPressOnlyNumber = keyPressOnlyNumber;
	    vmp.focusTitle = false;
	    vmp.titleSpellInorect = false;
	    vmp.allAuthors = [];
	    vmp.assignedPost = false;
	    vmp.dataPost.keywords = []
	    jQuery(document).on('click','.upload-image',function() {
	      $scope.$apply(function() {
	        vmp.mediaLibrary = true;
	      })
	    });
	    vmp.openAiModal = function(funcionality, edit) {
	      if(vmp.editorCharacterCount > 0) {
	        vmp.showAiModal = true;
	        vmp.aiToolsObj = vmp.config.aiTools.find(function(tool) {
	          return tool.funcionality === funcionality;
	        });
	        if(edit) {
	          vmp.aiToolsObj.edit = true;
	        } else {
	          vmp.aiToolsObj.edit = false;
	        }
	      } else {
	        alertService('danger','Opps! ', 'Please write something in the editor before using AI.');
	      }
	
	    }
	    vmp.updateAiResult = function(funcionality, selectedSuggestion) {
	      if(selectedSuggestion.length == 0) return;
	      if(funcionality == 'title-suggestion') {
	        vmp.dataPost.title = selectedSuggestion;
	      } else if(funcionality == 'tags-suggestion') {
	        selectedSuggestion.forEach(function(tag){
	          if(!tag.exists) {
	            saveNewTag(tag.name);
	          }
	          if (!vmp.dataPost.tags.includes(tag._id)) {
	            vmp.dataPost.tags.push(tag._id);
	          }
	        });
	      } else if(funcionality == 'page-title-suggestion') {
	        vmp.dataPost.page_title = selectedSuggestion;
	      }else if(funcionality == 'text-summary') {
	        // Check if there's an existing summary in the content
	        if (vmp.tinymceModel && vmp.tinymceModel.includes('<summaryblock>')) {
	            // Replace existing summary
	            vmp.tinymceModel = vmp.tinymceModel.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/, '<summaryblock>' + selectedSuggestion + '</summaryblock>');
	        } else {
	            // Add new summary at the beginning
	            vmp.tinymceModel = '<summaryblock>' + selectedSuggestion + '</summaryblock>' + (vmp.tinymceModel || '');
	        }
	      } else if(funcionality == 'text-correction' || funcionality == 'text-reformulation' || funcionality == 'text-expansion') {
	        if(vmp.tinymceModel && vmp.tinymceModel.includes('<summaryblock>')) { 
	          var summaryMatch = vmp.tinymceModel.match(/<summaryblock>([\s\S]*?)<\/summaryblock>/);
	          if(summaryMatch && summaryMatch[1]) {
	              var summaryContent = summaryMatch[1];
	              // Keep summary block and apply correction to rest of content
	              vmp.tinymceModel = '<summaryblock>' + summaryContent + '</summaryblock>' + selectedSuggestion;
	          }
	        } else {
	          vmp.tinymceModel = selectedSuggestion;
	        }
	      }
	    }
	    // vmp.assignToFunc = function() {
	    //   var putFunction = function() {
	    //     $http.put(API_URL + 'posts/reassign/' + vmp.postId, {'author':vmp.assignTo.value})
	    //     .success(function (data, status, headers) {
	    //       if(data.post) {
	    //         if(data.post.writers) {
	    //           console.log('usao')
	    //           vmp.dataPost.writers = data.post.writers
	    //           vmp.writers = vmp.dataPost.writers
	    //         }
	    //         if(data.post.author) {
	    //           console.log('usao')
	    //           vmp.dataPost.author = data.post.author
	    //           vmp.assignTo = {value:vmp.dataPost.author.toString()};
	    //         }
	    //       }
	    //       alertService('success','Success ', data.message, 2000);
	    //     })
	    //     .error(function (data, status, header, config) {
	    //       if(!window.navigator.onLine) {
	    //         offlineError()
	    //         alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	    //         return
	    //       }
	    //       if(status ==401) {
	    //         var promise = refreshtokenService.getAccessToken();
	    //         promise.then(
	    //           function(answer) {
	    //             if(answer==200) {   
	    //               putFunction();
	    //             }
	    //           },
	    //           function(error) {
	    //             // report something
	    //           },
	    //           function(progress) {
	    //            // report progress
	    //         });
	    //       }else if(status ==502) {
	    //         serverError();
	    //       } else {  
	    //         alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	    //       }
	    //     });
	    //   }
	    //   putFunction();
	    // }
	    var getImageFunction = function(postId) {
	      getDataService.get({param1:'attachments', param2: postId}).$promise.then(function(data){
	        vmp.hasFeaturedImage = true;
	        vmp.featured_img_obj = data; 
	        vmp.featured_img_id = data._id;
	         $rootScope.hasLoaded = true;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getImageFunction(postId);
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	              // report progress
	          });
	        }else if(error.status ==502) {
	              serverError();
	        } else {
	          $rootScope.hasLoaded = true;
	        }
	      }); 
	    }
	    
	    function changeMediaStatus(postId, param) {
	      if(!postId) return;
	      $rootScope.hasLoaded = false;
	      postDataService.save({
	        param1:'attachments',
	        param2:'status',
	        param3:param
	      },{
	        'ids': [postId],
	      }).$promise.then(function(data){
	        getImageFunction(postId);
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                changeMediaStatus(postId,param);
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    vmp.changeMediaStatus = function(postId,param) {
	      changeMediaStatus(postId, param)
	    } 
	    vmp.focusOutTitle = function(value) {
	
	      vmp.spelledTitle = value;
	      if(value) {
	       var postFunction = function() {   
	          postDataService.save({
	            param1:'posts',
	            param2:'spellcheck' 
	          },{
	            'title':value
	          }).$promise.then(function(postData){
	            if(!postData.bool) {
	              vmp.spelledArray = postData.misspelledWords; 
	              // var array = vmp.spelledTitle.split(" ");
	              // postData.incorectWords.forEach(function(a){ 
	              //   var index = array.indexOf(a);
	              //   if(index !==-1) {
	              //     array[index] = "<span class='highlight-error'>"+a+"</span>";
	              //   }
	              // });
	              // vmp.spelledTitle = array.join(" ");
	              vmp.titleSpellInCorect = true;
	            } else {
	              vmp.titleSpellInCorect = false;
	            }
	            // alertService('success','Success ', postData.message, 2000);
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	              });
	            }else if(error.status ==502) {
	              serverError();
	            }else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	          });
	        }
	        postFunction();
	        // replace each keyword in r with a mark'd replacement:
	      }
	    }
	    vmp.openDictionaryModal = function(word) {
	      vmp.misspelledWord = word;
	      if(word) {
	        vmp.dictionaryModalShow = true;
	        $rootScope.modalShow = true;
	      }
	    }
	    vmp.closeDictionaryModal = function() {
	      $rootScope.modalShow = false;
	      vmp.dictionaryModalShow = false;
	      vmp.misspelledWord = undefined;
	    }
	    vmp.focusInTitle = function(value) {
	      vmp.titleSpellInCorect = false;
	    }
	    vmp.addToOther = addToOther
	    vmp.saveAttachments = function() {
	      $scope.$broadcast('attachment-save');
	    }
	    vmp.permissionsOwnPost = true;
	    vmp.permisions = true;
	    if($rootScope.role_id == 'author-junior') {
	      vmp.permisions = false;
	      vmp.permissionsOwnPost = false;
	    }
	    var parseOptionsFunc = parseOptions
	    var publishPostFunction = function(url, state, status,previewType) {
	      var validatePublish = true;
	      
	      var putFunction = function() {
	        if(status=='publish') {
	          vmp.dataPost.status = 'publish'
	          if(vmp.scheduledPost) {
	            vmp.dataPost.status = 'schedule';
	          }
	        } else if(status=='trash') {
	          vmp.dataPost.status = 'trash'
	        } else {
	          if(vmp.scheduledPost && state=='save') {
	            if(vmp.editScheduledPost) {
	              updateDate = moment().toISOString()
	            } else {
	              vmp.dataPost.status = 'schedule';
	            }
	          }
	        }
	        // if(vmp.relatedNews.length == 1) {
	        //   if(!vmp.titleNews[0]) {
	        //     recommended = null;
	        //   } else {
	        //     recommended = vmp.relatedNews;
	        //     recommended[0].short_title = vmp.shortTitleNews[0];
	        //   }
	        // } else {
	        //   for(var i=0; i<vmp.relatedNews.length; i++) {
	        //     if(vmp.relatedNews[i].id && vmp.titleNews[i]) {
	        //       vmp.relatedNews[i].short_title = vmp.shortTitleNews[i];
	        //       recommended.push(vmp.relatedNews[i]);
	        //     }
	        //   }
	        // }
	        console.log(vmp.content);
	        var updateDataPost = {
	          "title": (vmp.dataPost.title)? (vmp.dataPost.title).replace(/\r?\n|\r/g, ' '): '',
	          "page_title": (vmp.dataPost.page_title)? (vmp.dataPost.page_title).replace(/\r?\n|\r/g, ' '): '',
	          "subtitle": (vmp.dataPost.subtitle)? (vmp.dataPost.subtitle).replace(/\r?\n|\r/g, ' '): '',
	          "content": vmp.content,
	          "category": vmp.category,
	          "tags": tagPosts,
	          // "slug": vmp.postSlug,
	          // "image": vmp.featured_img_id,
	          "status": vmp.dataPost.status,
	          "comment_status": vmp.allowCommentsStatus,
	          "comments_priority": parseInt(vmp.commentsPriority.value),
	          "moderator_guide": vmp.dataPost.moderator_guide,
	          "order": (vmp.dataPost.order)? parseInt(vmp.dataPost.order):undefined,
	          "fixed_position": (vmp.dataPost.fixed_position)? parseInt(vmp.dataPost.fixed_position):undefined,
	          "date": updateDate,
	          "meta": {
	            "options": {
	              "display_feature_image": vmp.pictureDemonstrate,
	              "display_update_time": vmp.dateDemonstrate,
	              "display_intext_banner": vmp.inBannerDemonstrate,
	              // "display_horizontal_block": vmp.relatedDemonstrate,
	              // "display_horizontal_block_position_bottom": vmp.relatedDemonstratePositionBottom,
	              "facebook_custom_title": vmp.facebookTitle,
	              // "push_title":vmp.pushNotificationTitle,
	              // "push_supertitle":vmp.pushNotificationSuperTitle,
	              "mobile_title":vmp.mobileTitle,
	              "display_photo": vmp.photoBadge,
	              "display_video":vmp.videoBadge,
	              "display_live":vmp.liveBadge,
	              "by_comtrade":vmp.displayByComtrade,
	              "copyright":vmp.copyright
	            },
	            'custom_shares':(vmp.dataPost.meta.custom_shares)? parseInt(vmp.dataPost.meta.custom_shares): undefined,
	            "sponsored":sponsored,
	            "recommended": vmp.recommendedNews,
	            "tnow_video_data" : vmp.tnow_data
	          },
	          "writers":writers,
	          // "display_writers":vmp.displayWriters,
	          "display_writer_initials":vmp.displayWriterInitials,
	          "display_writers":true,
	          "preview_hash":vmp.previewHash,
	          "videos": (vmp.featuredVideoObj)? [vmp.featuredVideoObj._id]:[],
	          "liveblog":(vmp.dataPost.liveblog)? true:false,
	          "editor_character_count":vmp.editorCharacterCount,
	          "keywords":vmp.dataPost.keywords
	        }
	        if(state != 'save') {
	          updateDataPost.slug = vmp.copySlug;
	          if(!updateDataPost.slug) {
	            updateDataPost.slug = ''
	          }
	        } else {
	          if( vmp.postSlug != vmp.copySlug) {
	            updateDataPost.slug = vmp.postSlug;
	            if(!updateDataPost.slug) {
								updateDataPost.slug = ''
							}
	            updateDataPost.meta.autoslug = 'false';
	          }
	        }
	        cleanObj.clean(updateDataPost);
	        cleanObj.clean(updateDataPost.meta);
	        cleanObj.clean(updateDataPost.meta.options);
	        updateDataPost.image = vmp.featured_img_id || null;
	        updateDataPost.share_image =(vmp.shareImageObj && vmp.shareImageObj._id)?vmp.shareImageObj._id:null 
	        updateDataPost.description_text = vmp.description_text;
	        updateDataPost.description_custom = vmp.description_custom;
	        updateDataPost.recommended_poll = (vmp.recommendedPollObj)? vmp.recommendedPollObj._id:null;
	        var updateFunction = function() {
	          // recommended = [];
	          $http.put(url , updateDataPost)
	          .success(function (data, stat, headers) {
	            if(!vmp.singleView) return;
	            if(!window.navigator.onLine) {
	              offlineError()
	              return
	            }
	            updateDataPost = {};
	            $rootScope.hasLoaded = true;
	            // recommended = [];
	            if(state=="save") {
	              // Clear unsaved changes flag when post is successfully saved
	              if (vmp.newPost) {
	                vmp.hasUnsavedChanges = false;
	                vmp.isNavigatingAway =  true;
	              }
	              
	              if(status=='trash') {
	                parent.editPostShow = false;
	                $state.transitionTo('app.'+appState, {id: null}, {
	                  location: true,
	                  inherit: true,
	                  relative: $state.$current,
	                  notify: false
	                });
	                alertService('success','Success ', data.message, 2000);
	              } else {
	                alertService('success','Success ', data.message, 2000);
	                if(vmp.newPost) {
	                  $timeout(function() {
	                    $state.go('app.allposts',{id:vmp.postId});
	                  },1000);
	                } else {
	                  getCategoriesFunction('save');
	                }
	              }
	            } else if(state=="preview") {
	              if(previewType) {
	                // if(vmp.editPublish) {
	                //   if(previewType == 'app' && vmp.dataPost.mobile_url) {
	                //     vmp.initQrCodeFunction(vmp.dataPost.mobile_url)
	                //   } else if(previewType == 'web'){
	                //     vmp.initQrCodeFunction(vmp.dataPost.url);
	                //   }
	                // } else {
	                //   if(previewType == 'app' && vmp.dataPost.preview_mobile) {
	                //     vmp.initQrCodeFunction(vmp.dataPost.preview_mobile + '&ts=' + Date.now())
	                //   } else if(previewType == 'web' && vmp.dataPost.preview){
	                //      vmp.initQrCodeFunction(vmp.dataPost.preview + '&ts=' + Date.now())
	                //   }
	                // }
	              } else {
	                if(vmp.editPublish) {
	                  if(status=='preview') {
	                    $window.open(vmp.dataPost.preview + '&ts=' + Date.now(), '_preview');  
	                  }else {
	                    $window.open(vmp.dataPost.url, '_view');
	                  }
	                } else {
	                  $window.open(vmp.dataPost.preview + '&ts=' + Date.now(), '_preview');
	                }
	              }
	            }
	          })
	          .error(function (data, status, header, config) {
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    updateFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                  // report progress
	              });
	            }else if(status ==502) {
	              if(state=="save") {
	                serverError()  
	              }
	            } else {
	              if(state=="save" && ($state.is('app.newpost') || vmp.singleView)) {
	                if(!window.navigator.onLine) {
	                  offlineError()
	                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                } else {
	                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	                }
	                vmp.intervalHeartBeatFunction();
	                if(!vmp.intervalHeartBeatPost) {
	                  vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
	                }
	                if(!vmp.autosaveInterval) {
	                  vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
	                }
	              }
	            }
	            updateDataPost = {};
	            // recommended = [];
	            $rootScope.hasLoaded = true;
	          });
	        }
	        updateFunction();
	      }
	      if(vmp.allowcomments) {
	        vmp.allowCommentsStatus = 'open';
	      } else {
	        vmp.allowCommentsStatus = 'closed';
	      }
	      if(vmp.selectedPictureDemonstrate.value == 'yes') {
	        vmp.pictureDemonstrate = true;
	      } else {
	        vmp.pictureDemonstrate = false;
	      }
	      if(vmp.selectedDateDemonstrate.value == 'yes') {
	        vmp.dateDemonstrate = true;
	      } else {
	        vmp.dateDemonstrate = false;
	      }
	      if( vmp.selectedBannerDemonstrate.value=='yes') {
	        vmp.inBannerDemonstrate = true;
	      } else {
	        vmp.inBannerDemonstrate = false;
	      }
	      if(vmp.selectedPrDemonstrate.value== 'yes') {
	        vmp.prDemonstrate = true;
	      } else {
	        vmp.prDemonstrate = false;
	      }
	      // if(vmp.selectedRelatedDemonstrate.value=='yes') {
	      //   vmp.relatedDemonstrate = true
	      // } else {
	      //   vmp.relatedDemonstrate = false
	      // }
	      // if(vmp.selectedRelatedDemonstratePositionBottom.value=='yes') {
	      //   vmp.relatedDemonstratePositionBottom = true
	      //   vmp.relatedDemonstrate = true
	      // } else {
	      //   vmp.relatedDemonstratePositionBottom = false
	      // }
	      // if(!vmp.pushNotificationTitle) {
	      //   vmp.pushNotificationTitle = null
	      // }
	      // if(!vmp.pushNotificationSuperTitle) {
	      //   vmp.pushNotificationSuperTitle = null
	      // }
	      if(!vmp.facebookTitle) {
	        vmp.facebookTitle = null
	      }
	      var writers = [];
	      if(vmp.writers.length>0) {
	        for(var i=0;i<vmp.writers.length;i++) {
	          writers.push(vmp.writers[i]['_id'])
	        }
	      }
	      if(vmp.dataPost.tags) {
	        if(vmp.dataPost.tags.length==0) {
	          tagPosts = null;
	        }else {
	          tagPosts = vmp.dataPost.tags;
	        }
	      }
	      sponsored = {
	        "display": vmp.prDemonstrate,
	         "title": vmp.prTextTitle
	      }
	      if(!sponsored.display) {
	        sponsored = null
	      }
	      vmp.content = vmp.textEditorContent; 
	      if(state=="save") {
	        if(vmp.dataPost.title) {
	          vmp.titleRequired = false;
	        } else {
	          vmp.titleRequired = true;
	          alertService('danger','Opps! ', 'Title is required');
	          validatePublish = false;
	        }
	        if(vmp.titleExceed && vmp.dataPost.title.length>110 && status != 'trash') {
	          validatePublish = false;
	          alertService('danger','Opps! ', 'Maximum number of characters in title is 110');
	        } 
	        // if(vmp.dataPost.page_title) {
	        //   vmp.pageTitleRequired = false;
	        // } else {
	        //   vmp.pageTitleRequired = true;
	        //   alertService('danger','Opps! ', 'Page title is required');
	        //   validatePublish = false;
	        // }
	        // if(vmp.dataPost.subtitle) {
	        //   vmp.subtitleRequired = false;
	        // } else {
	        //   vmp.subtitleRequired = true;
	        //   validatePublish = false;
	        // }
	       // console.log(vmp.editPublish);
	       // console.log(vmp.editPublish);
	        if(!updateDate) {
	          updateDate = moment().toISOString();
	        }
	        // if(!vmp.editPublish && !vmp.scheduledPost && vmp.dataPost.status=='publish') {
	        //   updateDate = moment().toISOString();
	        // }
	        // if()
	        if(vmp.editSlugShow) {
	          validatePublish = false;
	          alertService('danger','Opps! ', 'Cancel or edit permalink');
	        }
	        if(vmp.category) {
	          vmp.categoryRequired = false;
	          if(status=="publish" && vmp.category == 'uncategorized') {
	            vmp.categoryRequired = true;
	            alertService('danger','Opps! ', 'To publish a post, you must select a category other than "Uncategorized".')
	            validatePublish = false;
	          }
	        } else {
	          vmp.categoryRequired = true;
	          alertService('danger','Opps! ', 'Category is required')
	          validatePublish = false;
	        }
	        if(status =='publish' || (vmp.scheduledPost && status != 'trash')) {
	          if(vmp.featured_img_id) {
	            vmp.featuredImageRequired = false
	          } else {
	            alertService('danger','Opps! ', 'Featured image is required')
	            vmp.featuredImageRequired = true;
	            validatePublish = false;
	          }
	        }
	        if(vmp.displayWriters && vmp.writers.length==0) {
	          vmp.writersRequired = true;
	          alertService('danger','Opps! ', 'Author is required')
	          validatePublish = false;
	        } else {
	          vmp.writersRequired = false;
	        }
	        if(vmp.dataPost.fixed_position) {
	          if(parseInt(vmp.dataPost.fixed_position)<=10 &&  parseInt(vmp.dataPost.fixed_position)>=0) {
	            vmp.fixedPositionValidate = false;
	          } else {
	            alertService('danger','Opps! ', 'Fixed position must be in range 0-10')
	            vmp.fixedPositionValidate = true;
	            validatePublish = false;
	          }
	        }   
	        if(validatePublish) {
	          $rootScope.hasLoaded = false;
	          vmp.featuredImageRequired = false;
	          if(vmp.autosaveInterval) {
	            $interval.cancel(vmp.autosaveInterval);
	            vmp.autosaveInterval = null;
	          }
	          if(vmp.intervalHeartBeatPost) {
	            $interval.cancel(vmp.intervalHeartBeatPost);
	            vmp.intervalHeartBeatPost = null;
	          }
	          vmp.autoSaveFunction();
	          putFunction();
	        }
	        
	      }else if(state=="preview") {
	        if(vmp.dataPost.title) {
	          vmp.titleRequired = false;
	        } else {
	          vmp.titleRequired = true;
	          alertService('danger','Opps! ', 'Title is required');
	          validatePublish = false;
	        }
	        // if(vmp.dataPost.page_title) {
	        //   vmp.pageTitleRequired = false;
	        // } else {
	        //   vmp.pageTitleRequired = true;
	        //   alertService('danger','Opps! ', 'Page title is required');
	        //   validatePublish = false;
	        // }
	        if(vmp.category) {
	          vmp.categoryRequired = false;
	        } else {
	          vmp.categoryRequired = true;
	          alertService('danger','Opps! ', 'Category is required')
	          validatePublish = false;
	        }
	        if(validatePublish) {
	          putFunction();
	        }
	      } else {
	        putFunction();
	      }
	    }
	    // vmp.qrLoad = false;
	    // vmp.qrLoaded = false;
	    // var canvas = document.getElementById('canvas-qr')
	    // vmp.changePreviewQrCode = function(event, type) {
	    //   vmp.qrLoad = true;
	    //   vmp.qrLoaded = false;
	    //   activeClass.active(event)
	    //   if(!vmp.singleView) return; 
	    //   publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", "preview", undefined, type);
	    // }
	    // vmp.initQrCodeFunction = function(url) {
	    //   QRCode.toCanvas(canvas, url,{width:250,height:250}, function (error) {
	    //     if (error) console.error(error)
	    //     console.log('qrcode success!')
	    //       vmp.qrLoaded = true;
	    //   })
	    // }
	    vmp.previewPost = function(preview) {
	      if(!vmp.singleView) return; 
	      publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", "preview", preview);
	    }
	    vmp.autoSaveFunction = function() {
	        if(!vmp.singleView || !vmp.dataPost) return;
	        publishPostFunction(API_URL+ "posts/"+vmp.postId+"/?autosave=true", undefined,undefined);
	    }
	    
	
	    vmp.publishPost = function() {
	      vmp.titleSpellInCorect = false;
	      publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'publish');
	    }
	    vmp.trashPost = function() {
	      publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'trash');
	    }
	    vmp.updateorSavePost =  function() {
	      vmp.titleSpellInCorect = false;
	      if(vmp.dataPost.status == 'publish') {
	        publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', 'publish')
	      } else {
	        publishPostFunction(API_URL+ "posts/"+vmp.postId, 'save', undefined);
	      }
	    }
	    if($rootScope.mediaComunicateWithEditPost) {
	      parent.editPostShow = true;
	      vmp.postId = $rootScope.mediaComunicateWithEditPost;
	    }
	    function takeoverCallback(data) {
	      $scope.$apply(function() {
	        if(data.item_id == vmp.postId && data.type =='post_force_unlocked' && data.locked_session_id != tabSessionService.getSessionId()) {
	          takeOverPostFunc(data.message);
	        }
	      });
	    }
	    if(!eventStream.getConnection(streamTaxonomy)) {
	      eventStream.connect(streamTaxonomy,vmp.config.lockingManager[streamTaxonomy]);
	    }
	    if(!eventStream.hasMessageHandler(streamTaxonomy,takeoverCallback)) {
	      eventStream.onMessage(streamTaxonomy,takeoverCallback);
	    }
	    if(parent) {
	      // if(parent.intervalHeartBeat) {
	      //   $interval.cancel(parent.intervalHeartBeat);
	      //   parent.intervalHeartBeat = null;
	      // }
	      vmp.postId = parent.post_id;
	    }
	    vmp.intervalHeartBeatFunction = function() {
	      if(!vmp || !vmp.singleView) return;
	      var intervalFunction = function() {
	        if($state.is('app.allposts') || $state.is('app.newpost') || $state.is('app.myposts') ) {
	          putDataService.update({
	            param1:'posts', 
	            param2: 'heartbeat',
	            param3: vmp.postId
	          }).$promise.then(function(data){
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError(vmp.intervalHeartBeatFunction)
	              return
	            }
	            if(error.status == 401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	                if(answer==200) {  
	                  intervalFunction();
	                }
	                // do something
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	                // report progress
	              });
	            } else if(error.status == 403 || error.status == 423) {
	              takeOverPostFunc(error.data.error.message);
	            }
	          });
	        }
	      }
	      intervalFunction();
	    }
	    function takeOverPostFunc(message) {
	      $timeout(function() {
	        $rootScope.closeEditPost();
	        alertService('info','Notice! ', message)
	      },0);
	      if(vmp.autosaveInterval) {
	        $interval.cancel(vmp.autosaveInterval);
	        vmp.autosaveInterval = null;
	      }
	      if(vmp.intervalHeartBeatPost) {
	        $interval.cancel(vmp.intervalHeartBeatPost);
	        vmp.intervalHeartBeatPost = null;
	      }
	    }
	    var addNewTagFunction = function(data) {
	      vmp.newTagRequired = false;
	      if(!checkArray.contains.call(vmp.dataPost.tags,data.tagId)) {
	        vmp.dataPost.tags.push(data.tagId);
	        vmp.searchtagfocus = null;
	        vmp.existTag = false;
	      } else {
	        vmp.existTag = true;
	      }
	    }
	    $scope.$on('select-tag', function(event,data) {
	      addNewTagFunction(data.selectedTagObj)
	    });
	    function saveNewTag(newTag,callback) {
	      postDataService.save({
	        param1:'tags', 
	        // param2: 'create'
	      },{
	        'name': newTag
	      }).$promise.then(function(postTag){
	        if(callback) {
	          var data = {
	            tagId:postTag.tag._id,
	            tagname: postTag.tag.name
	          } 
	          callback(data);
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                saveNewTag(newTag,callback);
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else if(error.status ==400) {
	          if(callback) {
	            var data = {
	              tagId:error.data.tag._id,
	              tagname: error.data.tag.name
	            } 
	            callback(data);
	          }
	        }
	      });
	    } 
	    vmp.addNewTag = function() {
	      if(vmp.searchtagfocus && vmp.searchtagfocus.length>2) {
	        saveNewTag(vmp.searchtagfocus,function(data){
	          addNewTagFunction(data);
	        });
	      } else {
	        vmp.newTagRequired = true;
	      }
	    }
	    vmp.removeFromTagsList = function(index) {
	      vmp.dataPost.tags.splice(index, 1);
	    }
	    vmp.editPostStatus = function() {
	      vmp.editPostStatusShow = true;
	    }
	    vmp.editPostTime = function() {
	      vmp.editPostDateShow = true;
	      if(!vmp.pastPost &&!vmp.editPublish && !vmp.scheduledPost) {
	        convertTimeFunction(undefined);
	      } 
	    }
	    $scope.$on('live-badge',function(event,data){
	      vmp.liveBadge = data.display;
	      vmp.dataPost.liveblog = true
	      event.stopPropagation()
	    })
	    vmp.changePostStatus = function() {
	      vmp.editPostStatusShow = false;
	      vmp.dataPost.status = vmp.selectedPostStatus.value;
	    }
	    vmp.cancelEditPostStatus = function() {
	      vmp.editPostStatusShow = false;
	      vmp.selectedPostStatus = {value: vmp.dataPost.status};
	    }
	    // vmp.relatedNews = [{'id': '', 'title': '','url':'','short_title':'','date':''}];
	    // vmp.addNewNews = function() {
	    //   if(vmp.relatedNews.length < 10) {
	    //     vmp.relatedNews.push({'id': '', 'title': '','url':'','short_title':'','date':''});
	    //   }
	    // };
	    // vmp.removeNews = function() {
	    //   var lastItem = vmp.relatedNews.length-1;
	    //   if (vmp.relatedNews.length>1) {
	    //     vmp.relatedNews.splice(lastItem);
	    //     vmp.titleNews[lastItem] =null;
	    //     vmp.shortTitleNews[lastItem] = null;
	    //   } 
	    // };
	    // angular.element(document).on('mousedown', function(e) {
	    //   if(!vmp.singleView) return;
	    //   if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
	    //     var container = angular.element(document.getElementsByClassName("autocomplete-result"));
	    //     var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
	    //     if (!container.is(e.target) // if the target of the click isn't the container...
	    //       && container.has(e.target).length === 0 && vmp.hiddenResult != -1 && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
	    //     {
	    //       $scope.$apply(function () {
	    //         vmp.hiddenResult = -1;
	    //         vmp.postResult = [];
	    //         vmp.searchPage = 0;
	    //       });
	    //     }
	    //   }
	    // });
	    // vmp.searchPress = function(evt,star) {
	    //   keyPress(evt,star);
	    // }
	    // vmp.readMore = function(searchData, index) {
	    //   vmp.searchPage +=10;
	    //   $timeout(function() {
	    //     vmp.searchRelatedNews(searchData, index, 'loadMore');
	    //   },0)
	    // }
	    // vmp.searchRelatedNews = function(searchData, index, loadMore) {
	    //   var size=10;
	    //   vmp.loadMore = false;
	    //   if(loadMore!='loadMore') {
	    //     vmp.searchPage = 0;
	    //     vmp.postResult = [];
	    //   }
	    //   // vmp.hiddenResult = -1;
	    //   if(searchData) {
	    //     if(searchData.length >1) {
	    //       var url = elasticSearch.getUrl(searchData);
	    //       url = url + '&from='+ vmp.searchPage +'&size='+ size;
	    //       $http({
	    //         method: 'GET',
	    //         url: url
	    //       }).then(function successCallback(response) {
	    //         if(!response.data) return;
	    //         if(loadMore=='loadMore') {
	    //           vmp.postResult = vmp.postResult.concat(response.data.hits.hits);
	    //         } else {
	    //           vmp.postResult = response.data.hits.hits;
	    //         }
	    //         vmp.hiddenResult = index;
	    //           if(vmp.postResult.length > 0) {
	    //             vmp.hasResult = true;
	    //             vmp.loadMore = true;
	    //           } else {
	    //             vmp.hasResult = false;
	    //           }
	    //           if(response.data.hits.total >vmp.postResult.length) {
	    //             vmp.loadMore = true;
	    //           } else {
	    //             vmp.loadMore = false;
	    //           }
	    //           vmp.chooseSearchData = function(post) {
	    //             vmp.hiddenResult = -1;
	    //             vmp.postResult = [];
	    //             vmp.searchPage = 0;
	    //             vmp.relatedNews[index].title = post._source.post_title;
	    //             vmp.titleNews[index] = post._source.post_title;
	    //             vmp.relatedNews[index].id = post._id;
	    //             vmp.relatedNews[index].url = post._source.url;
	    //             vmp.relatedNews[index].date = post._source.uts;
	    //             vmp.relatedNews[index].image = post._source.image;
	    //           };
	    //           // this callback will be called asynchronously
	    //           // when the response is available
	    //       }, function errorCallback(response) {
	    //         if(!window.navigator.onLine) {
	    //           offlineError()
	    //           vmp.hiddenResult = -1;
	    //           return
	    //         }
	    //           // called asynchronously if an error occurs
	    //           // or server returns response with an error status.
	    //       });
	    //     } else {
	    //       vmp.hiddenResult = -1;
	    //     } 
	    //   } else {
	    //     vmp.hiddenResult = -1;
	    //   }
	    // }
	    vmp.editorChangePreviw = function(event, editorPreview) {
	      activeClass.active(event);
	      $scope.$broadcast("change-editor",{editor_preview:editorPreview});
	      if(editorPreview == 'text') {
	        vmp.editorPreviewVisual = false;
	      } else {
	        vmp.editorPreviewVisual = true;
	      }    
	    }
	    $rootScope.$on("edit-image",function(event, data) {
	      vmp.editImageObj = data.editImageObj;
	      vmp.editImagefromEditor = true;
	    });
	    vmp.openRevisionsModal = function() {
	      $rootScope.modalShow = true;
	      vmp.revisionsModalShow = true;
	    }
	    vmp.cancelRevisionsModal = function() {
	     $rootScope.modalShow = false;
	      vmp.revisionsModalShow = false; 
	    }
	    vmp.openCropModal = function() {
	      vmp.cropModalShow = true;
	      $rootScope.modalShow = true;
	    }
	    vmp.cancelCropModal = function() {
	      vmp.cropModalShow = false;
	      $rootScope.modalShow = false;
	    }
	    vmp.addMediatoEditor = function() {
	      vmp.mediaModal = true;
	      vmp.insertMediatoEditor = true;
	      vmp.galleryInPhoto = true;
	      $rootScope.modalShow = true;
	    }
	    vmp.addGallerytoEditor = function(update) {
	      vmp.mediaModal = true;
	      vmp.insertGallery = true;
	      $rootScope.modalShow = true;
	      if(update) {
	        vmp.updateGallery = true;
	      }
	    }
	    vmp.insertVideotoEditor = function() {
	      $rootScope.modalShow = true;
	      vmp.videoModalShow = true;
	      vmp.insertVideoToEditorModal = true;
	    }
	    vmp.cancelVideoModal = function() {
	      $rootScope.modalShow = false;
	      vmp.videoModalShow = false;
	      vmp.setFeaturedVideoModal = false;
	      vmp.insertVideoToEditorModal = false;
	    }
	    vmp.openSetFeaturedImage = function() {
	      vmp.mediaModal = true;
	      vmp.setFeaturedImage = true;
	      $rootScope.modalShow = true;
	    };
	    vmp.openSetShareImage = function() {
	      vmp.mediaModal = true;
	      $rootScope.modalShow = true;
	      vmp.setShareImage = true;
	    }
	    vmp.cancelImageModal = function() {
	      $rootScope.modalShow = false;
	      vmp.mediaModal = false;
	      vmp.editImagefromEditor = false;
	      vmp.setFeaturedImage = false;
	      vmp.insertMediatoEditor = false;
	      vmp.insertGallery = false;
	      vmp.updateGallery = false;
	      vmp.gallery_title = '';
	      vmp.slideShowUnsafe = false;
	      vmp.galleryUpdateIds = '';
	      vmp.galleryInPhoto = false;
	      vmp.setShareImage = false;
	    }
	    $scope.addPollToEditor = function() {
	      vmp.addPollToEditorShow= true;
	      vmp.pollResultDisplay = true
	      vmp.pollModalShow=true;
	      $rootScope.modalShow = true;
	    }
	    $scope.addRatingToEditor = function() {
	      vmp.addRatingToEditorShow= true;
	      vmp.ratingResultDisplay = true;
	      vmp.ratingModalShow=true;
	      $rootScope.modalShow = true;
	    }
	    vmp.addRecommendedPoll = function() {
	      vmp.addPollToRecomended = true;
	      vmp.pollResultDisplay = false;
	      vmp.pollModalShow=true;
	      $rootScope.modalShow = true;
	    }
	    vmp.setRecommnededPoll = function(pollObj) {
	      vmp.recommendedPollObj = pollObj;
	    }
	    vmp.removeRecommendedPoll = function() {
	      vmp.recommendedPollObj = null;
	    }
	    vmp.cancelPollModal = function(){
	      vmp.pollModalShow=false;
	      $rootScope.modalShow = false;
	      vmp.addPollToEditorShow= false;
	      vmp.addPollToRecomended = false;
	    }
	    vmp.cancelRatingModal = function(){
	      vmp.ratingModalShow=false;
	      $rootScope.modalShow = false;
	      vmp.addRatingToEditorShow= false;
	    }
	    $scope.addBlogToEditor = function() {
	      vmp.blogModalShow=true;
	      vmp.addBlogToEditorShow= true;
	      $rootScope.modalShow = true;
	    }
	    vmp.cancelBlogModal = function(){
	      vmp.blogModalShow=false;
	      $rootScope.modalShow = false;
	      vmp.addBlogToEditorShow= false;
	    }
	    $scope.$watchCollection(function(){
	        return vmp.changeImageTrue
	      }, function(newValue, oldValue){
	        if (newValue) {
	          $scope.$broadcast("change-image",{afterImage:true});
	        }
	      },true);
	    vmp.editSlug = function(slug) {
	      vmp.copyEditedSlug = angular.copy(slug);
	      vmp.editSlugShow = true;
	    }
	    vmp.cancelSlug = function() {
	      vmp.postSlug = vmp.copyEditedSlug;
	      if(!vmp.postSlug) {
					vmp.postSlug = '';
				} 
	      vmp.editSlugShow = false; 
	    }
	    vmp.updateSlug = function() {
	      vmp.postSlug = slugify(vmp.postSlug)
	      if(!vmp.postSlug) {
					vmp.postSlug = '';
				} 
	      vmp.editSlugShow = false; 
	    }
	    vmp.removeFeaturedImage = function() {
	      vmp.hasFeaturedImage = false;
	      vmp.featured_img_obj = undefined;
	      vmp.featured_img_id = undefined;
	    }
	    vmp.removeShareImage = function() {
	      vmp.shareImageObj = null;
	    }
	    vmp.cancelEditPostDate = function() {
	      vmp.editPostDateShow = false; 
	    }
	    
	    vmp.setPublishedDate = function() {
	      vmp.editPostDateShow = false; 
	      // vmp.scheduledPost = false;
	      var dateArray = [vmp.postYear, parseInt(vmp.selectedPostMont.value)-1, vmp.postDay, vmp.postHours, vmp.postMinutes];
	      updateDate = moment(dateArray).toISOString();
	      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>5) {
	        vmp.scheduledPost = true;
	      } else if(moment.duration(moment(dateArray).diff(moment())).asMinutes()<=5 && moment.duration(moment(dateArray).diff(moment())).asMinutes()>-5 && !vmp.editPublish) {
	          updateDate = moment().toISOString();
	          vmp.scheduledPost = false;
	          vmp.pastPost = false;
	      }
	      else {
	          vmp.pastPost = true;
	          vmp.scheduledPost = false;
	      }
	      vmp.dataPost.date = $filter('date')(updateDate, "MMM d, y HH:mm");
	    }
	    var convertTimeFunction = function(date) {
	      var a = moment(date);
	      var year = a.format('YYYY');
	      var month = a.format('M');
	      var day = a.format('D');
	      var hour = a.hours();
	      var min = a.minutes();
	      var sec = a.seconds();
	      vmp.postYear = year;
	      vmp.selectedPostMont = {value: month};
	      vmp.postDay = day;
	      if(hour<10) {
	        vmp.postHours = '0'+hour;  
	      } else {
	        vmp.postHours = hour;
	      }
	      if(min<10) {
	        vmp.postMinutes = '0'+min;  
	      } else {
	        vmp.postMinutes = min;
	      }
	    } 
	    $scope.$on('restore-post',function(event,data) {
	      console.log(data);
	      var postContent = data.post.content
	      vmp.textEditorContent = data.post.content;
	      if(postContent) {
	        postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
	            var parseOptions = parseOptionsFunc(attr);
	            if(parseOptions.signature_url) {
	              var signatureUrl = parseOptions.signature_url
	            } else {
	              var signatureUrl = ''
	            }
	            if(parseOptions.image_link) {
	              var imageLink = 'image_link="'+parseOptions.image_link+'"'
	            } else {
	              var imageLink = ''
	            }
	            if(parseOptions.image_target_blank) {
	              var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
	            } else {
	              var imageTargetBlank = ''
	            }
	            var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	            postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="' +parseOptions.height +'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
	        });
	        postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
	          var parseOptions = parseOptionsFunc(attr);
	          postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'"]</galleryblock>');
	        });
	        postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
	          var parseOptions = parseOptionsFunc(attr);
	          var type = parseOptions.type || parseOptions.src;
	          postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
	        });
	        postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
	            postContent = postContent.replace(all, '<summaryblock>' + all + '</summaryblock>');
	        });
	        postContent = wpautop(postContent);
	        vmp.tinymceModel = postContent;
	      }
	      var author = data.post.author;
	      var date = $filter('date')(data.post.date, "MMM d, y H:mm");
	      vmp.dataPost.title = data.post.title;
	      vmp.dataPost.subtitle = data.post.subtitle;
	      alertService('success','Success ', 'Post successfully restored. Click on update to save post changes.', 7000);
	    });
	    function initializeFeaturedVideo(videoObj) {
	      vmp.featuredVideoObj = videoObj;
	      vmp.featuredVideoAdded =true;
	      vmp.featuredVideoLoaded = false;
	      if(!vmp.featuredVideoPlayer) {
	        $timeout(function() {
	          var posterDisplayRes = (vmp.featuredVideoObj.orientation == 'portrait')? '-360x640.jpg': '-300x170.jpg';
	          vmp.featuredVideoPlayer = videojs('featured-video',
	          {
	            poster:vmp.config.baseVideoHref + vmp.featuredVideoObj.image.replace('.jpg', posterDisplayRes),  
	            autoplay:false
	          });
	            setupVideo();  
	        },0)
	      } else {
	        $timeout(function() {
	          setupVideo();
	          var posterDisplayRes = (vmp.featuredVideoObj.orientation == 'portrait')? '-360x640.jpg': '-300x170.jpg';
	          vmp.featuredVideoPlayer.poster(vmp.config.baseVideoHref + vmp.featuredVideoObj.image.replace('.jpg', posterDisplayRes));
	        },0)
	      }
	    }
	    function setupVideo() {
	      var video_file = vmp.config.baseVideoHref + vmp.featuredVideoObj.file.m3u8;
	      if(vmp.featuredVideoObj.duration){
	        var formatedTime;
	        if(vmp.featuredVideoObj.duration>=3600) {
	          formatedTime = 'H:mm:ss'
	        } else {
	          formatedTime = 'm:ss'
	        } 
	        vmp.featuredVideoObj.formated_duration = moment().startOf('day').second(vmp.featuredVideoObj.duration).format(formatedTime);
	      }
	      vmp.featuredVideoPlayer.src({
	        src: video_file,
	          type: 'application/x-mpegURL',
	          withCredentials: false
	      });
	      vmp.featuredVideoPlayer.on("play", function() {
	        $scope.$apply(function() {
	          vmp.featuredVideoObjDurationFlag = false;
	        })
	      });
	      vmp.featuredVideoLoaded = true;
	      vmp.featuredVideoObjDurationFlag = true;
	    }
	    vmp.setFeaturedVideoFunction = function(videoObj) {
	      if(!videoObj) return;
	      initializeFeaturedVideo(videoObj);
	    }
	    vmp.disposeVideo = function() {
	      if(vmp.featuredVideoPlayer) {
	        vmp.featuredVideoPlayer.dispose();
	        vmp.featuredVideoPlayer = null;
	      }
	    }
	    vmp.setFeaturedVideo = function() {
	      $rootScope.modalShow = true;
	      vmp.setFeaturedVideoModal = true;
	    }
	    vmp.removeFeaturedVideo = function () {
	      vmp.disposeVideo();
	      vmp.featuredVideoObj = null;
	      vmp.featuredVideoAdded =false;
	    }
	    vmp.editPostFunction = function() {
	      updateDate = null;
	      vmp.pastPost = false;
	      vmp.scheduledPost = false;
	      vmp.editScheduledPost = false;
	      vmp.editPublish =false;
	      vmp.postSlug = null;
	      vmp.copySlug = null;
	      vmp.previewHash = null;
	      vmp.substringUri = null;
	      vmp.mobileTitle = null;
	      vmp.facebookTitle = null;
	      // vmp.pushNotificationTitle = null;
	      // vmp.pushNotificationSuperTitle = null;
	      vmp.prTextTitle = null;
	      vmp.tnow_data = null;
	      vmp.hasFeaturedImage = false;
	      vmp.featured_img_obj = undefined; 
	      vmp.featured_img_id = undefined;
	      vmp.shareImageObj = null;
	      vmp.categoryIdOnLoad = undefined;
	      if(vmp.dataPost.status == 'publish') {
	        vmp.editPublish = true;
	        if(vmp.dataPost.date) {
	          updateDate = vmp.dataPost.date;
	        }
	      }else if(vmp.dataPost.status=='trash') {
	        parent.editPostShow = false;
	        if(vmp.autosaveInterval) {
	          $interval.cancel(vmp.autosaveInterval);
	          vmp.autosaveInterval = null;
	        }
	        if(vmp.intervalHeartBeatPost) {
	          $interval.cancel(vmp.intervalHeartBeatPost);
	          vmp.intervalHeartBeatPost = null;
	        }
	        $state.transitionTo('app.'+appState, {id: null}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      } else if(vmp.dataPost.status=='schedule') {
	        vmp.scheduledPost = true;
	        vmp.editScheduledPost = true;
	        if(vmp.dataPost.date) {
	          updateDate = vmp.dataPost.date;
	        }
	      }
	      if(vmp.dataPost.status=='assigned') {
	        vmp.assignedPost = true
	      } else {
	        vmp.assignedPost = false
	      }
	      if(vmp.dataPost.date) {
	        vmp.dataPost.date = $filter('date')(vmp.dataPost.date, "MMM d, y HH:mm");
	        convertTimeFunction(vmp.dataPost.date);
	      }
	      if('meta' in vmp.dataPost) {
	        if('sponsored' in vmp.dataPost.meta) {
	          if(vmp.dataPost.meta.sponsored.display == true) {
	            vmp.selectedPrDemonstrate.value = 'yes'
	          } else {
	            vmp.selectedPrDemonstrate.value = 'no'
	          }
	          if('title' in vmp.dataPost.meta.sponsored) {
	            vmp.prTextTitle = vmp.dataPost.meta.sponsored.title;
	          }
	        }
	        if('options' in vmp.dataPost.meta) {
	          if(vmp.dataPost.meta.options.display_feature_image == true) {
	            vmp.selectedPictureDemonstrate.value = 'yes'
	          } else {
	            vmp.selectedPictureDemonstrate.value = 'no'
	          }
	          // if(vmp.dataPost.meta.options.display_horizontal_block == true) {
	          //   vmp.selectedRelatedDemonstrate.value = 'yes'
	          // } else {
	          //   vmp.selectedRelatedDemonstrate.value = 'no'
	          // }
	          // if(vmp.dataPost.meta.options.display_horizontal_block_position_bottom == true) {
	          //   vmp.selectedRelatedDemonstratePositionBottom.value = 'yes'
	          // } else {
	          //   vmp.selectedRelatedDemonstratePositionBottom.value = 'no'
	          // }
	          if(vmp.dataPost.meta.options.display_intext_banner == true) {
	            vmp.selectedBannerDemonstrate.value = 'yes'
	          } else {
	            vmp.selectedBannerDemonstrate.value = 'no'
	          }
	          if(vmp.dataPost.meta.options.display_update_time == true) {
	            vmp.selectedDateDemonstrate.value = 'yes'
	          } else {
	            vmp.selectedDateDemonstrate.value = 'no'
	          } 
	          if(vmp.dataPost.meta.options.facebook_custom_title) {
	            vmp.facebookTitle = vmp.dataPost.meta.options.facebook_custom_title
	          }
	          // if(vmp.dataPost.meta.options.push_title) {
	          //   vmp.pushNotificationTitle = vmp.dataPost.meta.options.push_title
	          // }
	          // if(vmp.dataPost.meta.options.push_supertitle) {
	          //   vmp.pushNotificationSuperTitle = vmp.dataPost.meta.options.push_supertitle
	          // }
	          if(vmp.dataPost.meta.options.mobile_title) {
	            vmp.mobileTitle = vmp.dataPost.meta.options.mobile_title
	          }
	          if(vmp.dataPost.meta.options.display_video) {
	            vmp.videoBadge = true;
	          }
	          if(vmp.dataPost.meta.options.display_photo) {
	            vmp.photoBadge = true;
	          }
	          if(vmp.dataPost.meta.options.display_live) {
	            vmp.liveBadge = true;
	          }
	          if(vmp.dataPost.meta.options.by_comtrade) {
	            vmp.displayByComtrade = true
	          }
	          if(vmp.dataPost.meta.options.copyright) {
	            vmp.copyright = true
	          }
	        }
	        if('recommended' in vmp.dataPost.meta) {
	          vmp.recommendedNews = cleanArray.clean(vmp.dataPost.meta.recommended);
	        }
	        if('tnow_video_data' in vmp.dataPost.meta) {
	          vmp.tnow_data = vmp.dataPost.meta.tnow_video_data;
	        }
	
	      }
	      if(vmp.dataPost.display_writers) {
	        vmp.displayWriters = true;
	      } else {
	        vmp.displayWriters = false;
	      }
	      if(vmp.dataPost.display_writer_initials) {
	        vmp.displayWriterInitials = true;
	      } else {
	        vmp.displayWriterInitials = false;
	      }
	      if(vmp.dataPost.writers) {
	        vmp.writers = vmp.dataPost.writers
	      }
	      if(!vmp.dataPost.tags) {
	        vmp.dataPost.tags = [];
	      } else {
	        vmp.dataPost.tags = checkArray.removeDuplicate(vmp.dataPost.tags);
	      }
	      if(vmp.dataPost.recommended_poll) {
	        vmp.recommendedPollObj = {
	          _id : vmp.dataPost.recommended_poll._id,
	          title: vmp.dataPost.recommended_poll.title
	        }
	      }
	      vmp.selectedPostStatus={value:vmp.dataPost.status};
	
	      var postContent = vmp.dataPost.content;
	      // vmp.textEditorContent = vmp.dataPost.content;
	      if(postContent) {
	        postContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
	            var parseOptions = parseOptionsFunc(attr);
	            if(parseOptions.signature_url) {
	              var signatureUrl = parseOptions.signature_url
	            } else {
	              var signatureUrl = ''
	            }
	            if(parseOptions.image_link) {
	              var imageLink = 'image_link="'+parseOptions.image_link+'"'
	            } else {
	              var imageLink = ''
	            }
	            if(parseOptions.image_target_blank) {
	              var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'   
	            } else {
	              var imageTargetBlank = ''
	            }
	            var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
	            postContent = postContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="' +parseOptions.height +'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
	        });
	        postContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
	          var parseOptions = parseOptionsFunc(attr);
	          postContent = postContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' +parseOptions.title +'"]</galleryblock>');
	        });
	        postContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
	          var parseOptions = parseOptionsFunc(attr);
	          var type = parseOptions.type || parseOptions.src;
	          postContent = postContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
	        });
	        postContent.replace(/\[summary\]([\s\S]*?)\[\/summary\]/g, function(all) {
	            postContent = postContent.replace(all, '<summaryblock>' + all + '</summaryblock>');
	        });
	        postContent = wpautop(postContent);
	        vmp.tinymceModel = postContent;
	      }
	      if(vmp.dataPost.comment_status == 'open') {
	        vmp.allowcomments = true;
	      } else {
	        vmp.allowcomments = false;
	      }
	      if(!vmp.dataPost.comments_priority) {
	        vmp.commentsPriority.value = '0';
	      } else {
	        vmp.commentsPriority.value = vmp.dataPost.comments_priority.toString();
	      }
	      if(vmp.dataPost.preview_hash) {
	        vmp.previewHash = vmp.dataPost.preview_hash;
	      }
	      if(vmp.dataPost.slug) {
	        vmp.postSlug = vmp.dataPost.slug;
	        vmp.copySlug = angular.copy(vmp.postSlug); 
	      }
	      if(vmp.dataPost.slug && vmp.dataPost.url) {
	        var slugLength = vmp.dataPost.slug.length;
	        vmp.substringUri = vmp.dataPost.url.substr(0, vmp.dataPost.url.length-slugLength);
	      }
	      if(vmp.dataPost.image) {
	        vmp.hasFeaturedImage = true;
	        vmp.featured_img_obj = vmp.dataPost.image; 
	        vmp.featured_img_id = vmp.dataPost.image._id;
	      }
	      if(vmp.dataPost.share_image) {
	        vmp.shareImageObj = vmp.dataPost.share_image
	      }
	      if(vmp.dataPost.category) {
	        vmp.category = vmp.dataPost.category._id;
	        $timeout(function() {
	          vmp.categoryIdOnLoad = vmp.dataPost.category._id
	        },0) 
	      }
	      if(vmp.dataPost.description) {
	        vmp.description_custom = vmp.dataPost.description.custom
	        vmp.description_text =  vmp.dataPost.description.text
	      }
	      if(vmp.dataPost.videos && vmp.dataPost.videos.length>0) {
	        if(typeof vmp.dataPost.videos[0] !== 'object' || vmp.dataPost.videos[0] === null) return
	        vmp.featuredVideoObj = vmp.dataPost.videos[0];
	        initializeFeaturedVideo(vmp.dataPost.videos[0])
	      }
	      if(vmp.dataPost.keywords && vmp.dataPost.keywords.length>0) {
	        vmp.updateKeywords = false;
	        $timeout(function() {
	          vmp.updateKeywords = true;
	        }, 200);
	      } else {
	        vmp.dataPost.keywords = [];
	      }
	      if(vmp.editPublish) {
	        getRemainingTweets();
	      }
	    }
	    
	    if(vmp.postId) {
	      if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator' || parseInt(vmp.postId) < vmp.config.txt_mode_display) {
	        vmp.textModePermision = true;
	      }
	      $rootScope.mediaComunicateWithEditPost= null;
	      vmp.newPost = false;
	      $rootScope.closeEditPost = function() {
	        if(!vmp.singleView) return;
	        $rootScope.hasLoaded = false;
	        vmp.closeEditPostFlag = true;
	        $rootScope.ngEscapeAttrsParametars = [];
	        if(vmp.autosaveInterval) {
	          $interval.cancel(vmp.autosaveInterval);
	          vmp.autosaveInterval = null;
	        }
	        if(vmp.intervalHeartBeatPost) {
	          $interval.cancel(vmp.intervalHeartBeatPost);
	          vmp.intervalHeartBeatPost = null;
	        }
	        unlockPost()
	      }
	
	      var getPostData = function(type) {
	        // add a version number to the request to avoid caching for restore post
	        var v = new Date().getTime();
	        getDataService.get({param1:'posts', param2: vmp.postId, v:v}).$promise.then(function(dataPosts){
	          if(!vmp.singleView) return;
	          vmp.dataPost = dataPosts;
	          $rootScope.hasLoaded = true;
	          if(!vmp.intervalHeartBeatPost) {
	            vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
	          }
	          if(!vmp.autosaveInterval) {
	            vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
	          }
	          vmp.intervalHeartBeatFunction();
	          vmp.editPostFunction();
	          if(vmp.dataPost.author == userId) {
	            vmp.permissionsOwnPost = true;
	          }
	          vmp.assignTo = {value:vmp.dataPost.author.toString()};
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            if(type== 'save') {
	              if(!vmp.intervalHeartBeatPost) {
	                vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
	              }
	              if(!vmp.autosaveInterval) {
	                vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
	              }
	            }
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getPostData();
	                }
	                // do something
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            vmp.getPostDataError = true;
	            parent.editPostShow = false;
	            if(vmp.autosaveInterval) {
	              $interval.cancel(vmp.autosaveInterval);
	              vmp.autosaveInterval = null;
	            }
	            if(vmp.intervalHeartBeatPost) {
	              $interval.cancel(vmp.intervalHeartBeatPost);
	              vmp.intervalHeartBeatPost = null;
	            }
	            $state.transitionTo('app.'+ appState, {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      var getCategoriesFunction = function(type) {
	        $rootScope.hasLoaded = false;
	        getDataService.get({param1:'categories', param2: null, tree:1, showinvisible:true}).$promise.then(function(dataCategory){
	            if(!vmp.singleView) return;        
	            vmp.categories = dataCategory.categories;
	            if(type=='save') {
	              getPostData('save');
	            } else {
	              getPostData();
	            }
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            if(type== 'save') {
	              if(!vmp.intervalHeartBeatPost) {
	                vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
	              }
	              if(!vmp.autosaveInterval) {
	                vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
	              }
	            }
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getCategoriesFunction();
	                  }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }  
	      getCategoriesFunction();
	    } else {
	      vmp.dataPost.status = 'draft';
	      vmp.selectedPostStatus={value:'draft'};
	      $rootScope.hasLoaded = true;
	      var getNewPostData = function() {
	        postDataService.save({
	          param1:'posts' 
	        }).$promise.then(function(data){
	          if(!$state.is('app.newpost')) return;
	            vmp.postId = data.post._id;
	            vmp.previewHash = data.post.preview_hash;
	            vmp.dataPost.order = data.post.order;
	            vmp.dataPost.fixed_position = '';
	            vmp.dataPost.meta = data.post.meta;
	            vmp.dataPost.writers = data.post.writers;
	            vmp.dataPost.display_writers = data.post.display_writers;
	            vmp.intervalHeartBeatPost = $interval(vmp.intervalHeartBeatFunction,vmp.config.heartbeat.pulse*1000);
	            vmp.autosaveInterval = $interval(vmp.autoSaveFunction,vmp.config.heartbeat.autosave*1000);
	            vmp.intervalHeartBeatFunction();
	            if(data.post.author == userId) {
	              vmp.permissionsOwnPost = true;
	            }
	            if(vmp.dataPost.writers) {
	              vmp.writers = vmp.dataPost.writers
	            }
	            if(vmp.dataPost.display_writers) {
	              vmp.displayWriters = true;
	            } else {
	              vmp.displayWriters = false;
	            }
	
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getNewPostData();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      var getCategoriesFunction = function() {
	        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(dataCategory){
	          if(!$state.is('app.newpost')) return;
	          vmp.categories = dataCategory.categories;
	          getNewPostData(); 
	            
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getCategoriesFunction();
	                  }
	                // do something
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }
	        });
	      } 
	      getCategoriesFunction();
	      
	    }
	    var getAuthorsFunction = function() {
	      getDataService.get({param1:'users', param2: 'all',status:1}).$promise.then(function(data){      
	        vmp.allAuthors = data.users;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getAuthorsFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	              // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getAuthorsFunction();
	    function getRemainingTweets() {
	      $http.get(API_URL + 'posts/social/twitter/remaining-tweets').success(function(response) {
	        vmp.shareOnXRemainingPosts = response.count;
	      }).error(function (data, status, header, config) {
	        if(status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                getRemainingTweets();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	            // report progress
	          });
	        }else if(status ==502) {
	          serverError();
	        } else {  
	          alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    vmp.shareOnX = function() {
	      function shareOnX() {
	        $http.post(API_URL + 'posts/social/twitter/send', {post_id: vmp.postId}).success(function(response) {
	          vmp.shareOnXRemainingPosts = response.remaining;
	          console.log(response);
	          alertService('success','Success! ', response.message,2000);
	        }).error(function (data, status, header, config) {
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  shareOnX();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(status ==502) {
	            serverError();
	          } else {
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      shareOnX();
	    }
	    // Function to detect if there are unsaved changes (only for new posts)
	    function detectChanges() {
	      if (!vmp.newPost) return false; // Only check for new posts
	      
	      // Check if user has entered any content
	      var hasContent = false;
	      
	      // Check title
	      if (vmp.dataPost.title && vmp.dataPost.title.trim() !== '') {
	        hasContent = true;
	      }
	      
	      // Check content
	      if (vmp.tinymceModel && vmp.tinymceModel.trim() !== '') {
	        hasContent = true;
	      }
	      
	      // Check subtitle
	      if (vmp.dataPost.subtitle && vmp.dataPost.subtitle.trim() !== '') {
	        hasContent = true;
	      }
	      
	      // Check page title
	      if (vmp.dataPost.page_title && vmp.dataPost.page_title.trim() !== '') {
	        hasContent = true;
	      }
	      
	      // Check if category is selected
	      if (vmp.category && vmp.category !== 'uncategorized') {
	        hasContent = true;
	      }
	      
	      // Check if tags are added
	      if (vmp.dataPost.tags && vmp.dataPost.tags.length > 0) {
	        hasContent = true;
	      }
	      
	      // Check if featured image is set
	      if (vmp.hasFeaturedImage) {
	        hasContent = true;
	      }
	      
	      vmp.hasUnsavedChanges = hasContent;
	      return hasContent;
	    };
	    
	    // Function to show warning when navigating away (for internal navigation only)
	    function showNavigationWarning(event, toState, toParams) {
	      if (!vmp.newPost) return; // Only for new posts
	
	      if (detectChanges()) {
	
	        warningAlertService('Unsaved Changes',
	          'You have unsaved changes. Are you sure you want to leave without saving?',
	          function cb() {
	            // User confirmed - allow navigation
	            vmp.isNavigatingAway = true;
	            vmp.hasUnsavedChanges = false;
	            // Programmatically navigate to the intended state
	            if (toState && toState.name) {
	              // Use $timeout to ensure this runs after the current event cycle
	              $timeout(function() {
	                $state.go(toState.name, toParams)
	              },0);
	            }
	          },
	          function() {
	            // User cancelled - prevent navigation
	            vmp.isNavigatingAway = false;
	
	            // For other events, we can prevent navigation
	            if (event && event.preventDefault) {
	              event.preventDefault();
	            }
	          }
	        );
	      }
	    };
	    // Add watchers to detect changes in real-time (only for new posts)
	    if (vmp.newPost) {
	      // Watch for changes in title
	      $scope.$watch('vmp.dataPost.title', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	      
	      // Watch for changes in content
	      $scope.$watch('vmp.tinymceModel', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	      
	      // Watch for changes in subtitle
	      $scope.$watch('vmp.dataPost.subtitle', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	      
	      // Watch for changes in page title
	      $scope.$watch('vmp.dataPost.page_title', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	      
	      // Watch for changes in category
	      $scope.$watch('vmp.category', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	      
	      // Watch for changes in tags
	      $scope.$watch('vmp.dataPost.tags', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      }, true);
	      
	      // Watch for changes in featured image
	      $scope.$watch('vmp.hasFeaturedImage', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	          detectChanges();
	        }
	      });
	
	      // Listen for state changes to warn about unsaved changes (only for new posts)
	      $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
	        if (toState.name == 'login') return
	        if (vmp.isNavigatingAway) return
	        if (!detectChanges()) return 
	        event.preventDefault();
	        showNavigationWarning(event, toState, toParams);
	      });
	    }
	
	    function unlockPost(type) {
	      if(vmp.getPostDataError) return
	      $http.delete(API_URL + 'posts/' + vmp.postId + '/unlock').success(function(data){
	        if(!vmp.closeEditPostFlag) return
	        // If the post is being closed, we have race condition bettwen unlockPost and getAllPosts
	        $rootScope.hasLoaded = true;
	        parent.editPostShow = false;
	        vmp.dataPost = null;
	        $state.transitionTo('app.'+appState, {id: null}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	        });
	      }).error(function (data, status, header, config) {
	        if(status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                unlockPost(type);
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(status ==502) {
	          serverError();
	        } else {  
	          alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	        }
	        if(vmp.closeEditPostFlag) {
	          $rootScope.hasLoaded = true;
	        }
	      });
	    }
	    // Define the beforeunload handler function
	    function beforeUnloadHandler(event) {
	      // For new posts, check for unsaved changes
	      if (vmp.newPost && detectChanges()) {
	        // For beforeunload, we can only show browser's native warning
	        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
	        return event.returnValue;
	      }
	      
	      // For existing posts, just unlock
	      if (!vmp.newPost) {
	        unlockPost('beforeunload');
	      }
	    };
	    // Handle cleanup when user closes tab/browser
	    window.addEventListener('beforeunload', beforeUnloadHandler);
	    // Handle cleanup when Angular scope is destroyed (navigation, etc.)
	    $scope.$on('$destroy', function() {
	      // Remove the beforeunload listener to prevent memory leaks
	      window.removeEventListener('beforeunload', beforeUnloadHandler);
	      
	      vmp.disposeVideo();
	      // Make sure that the interval is destroyed too
	      // watchCategory();
	      if(vmp.intervalHeartBeatPost) {
	        $interval.cancel(vmp.intervalHeartBeatPost);
	      }
	      if(vmp.autosaveInterval) {
	        $interval.cancel(vmp.autosaveInterval);
	      }
	      vmp.intervalHeartBeatPost = null;
	      vmp.autosaveInterval = null;
	      vmp.autoSaveFunction = null;
	      vmp.intervalHeartBeatFunction = null;
	      vmp.singleView = null;
	      if(eventStream.hasMessageHandler(streamTaxonomy,takeoverCallback)) {
	        eventStream.offMessage(streamTaxonomy,takeoverCallback);
	      }
	      // In destroy call unlockPost if we're not closing the browser
	      // (beforeunload will handle browser close)
	      if(!vmp.newPost && !vmp.closeEditPostFlag) {
	        unlockPost();
	      }
	    });
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var posts = angular.module('postsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'thatisuday.dropzone',
		'diff-match-patch',
		'ngSanitize'
		
	]);
	__webpack_require__(549)(posts);
	__webpack_require__(548)(posts);
	// require('./allposts/js/directive/categoryModalDirective.js')(posts);
	__webpack_require__(559)(posts);
	__webpack_require__(564)(posts);
	__webpack_require__(563)(posts);
	__webpack_require__(562)(posts);
	__webpack_require__(557)(posts);
	__webpack_require__(555)(posts);
	__webpack_require__(556)(posts);
	__webpack_require__(554)(posts);
	__webpack_require__(558)(posts);
	__webpack_require__(560)(posts);
	__webpack_require__(551)(posts);
	__webpack_require__(550)(posts);
	__webpack_require__(570)(posts);
	__webpack_require__(571)(posts);
	__webpack_require__(553)(posts);
	__webpack_require__(552)(posts);
	__webpack_require__(568)(posts);
	__webpack_require__(569)(posts);
	__webpack_require__(566)(posts);
	__webpack_require__(567)(posts);
	__webpack_require__(561)(posts);
	__webpack_require__(572)(posts);
	__webpack_require__(573)(posts);


/***/ }),
/* 566 */
/***/ (function(module, exports) {

	module.exports = function(post) {
		"use strict";
	  post
	  .directive('sortableGalleryDir',sortableGalleryDir);
		sortableGalleryDir.$inject = ['refreshtokenService','postDataService','$rootScope','alertService','serverError','offlineError'];
	  function sortableGalleryDir(refreshtokenService,postDataService,$rootScope,alertService,serverError,offlineError) {
	    return {
	      require: '?ngModel',
	      link: function(scope, element, attrs, ngModel) {
	        var state = 'attachments';
	        // scope.$watch(function(){
	        //   return ngModel.$modelValue
	        // }, function(newValue, oldValue){
	        //   if (newValue!=oldValue) {
	        //     for (var i=0; i<ngModel.$modelValue.length;i++) {
	        //       ngModel.$modelValue[i].index = i;
	        //     }
	        //   }
	        // },true);
	        var options = {
	          helper:'original',
	          axis:'y,x',
	          start: function(e, ui) {
	            ui.item.directive = {
	              start: ui.item.index(),
	              startModel: ngModel
	            };
	          },
	          update: function(e, ui) {
	            var start = ui.item.directive.start;
	            var end = ui.item.index();
	            
	            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
	              scope.$apply(function() {
	                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
	                ngModel.$modelValue.splice(end, 0, element);
	              });
	            }
	            console.log(ngModel);
	
	            scope.$apply(function() {
	              var postOrderFunction = function() {
	                $rootScope.hasLoaded = false;
	                scope.galleryOrderArray = [];
	                for(var i=0;i<ngModel.$modelValue.length;i++) {
	                  scope.galleryOrderArray.push({'_id':ngModel.$modelValue[i]._id,'order':i+1});
	                } 
	                  postDataService.save({
	                      param1:state,
	                      param2:'reorder'
	                    },{
	                      'new_order': scope.galleryOrderArray
	                    }).$promise.then(function(data){
	                      $rootScope.hasLoaded = true;
	                        alertService('success','Success ', data.message, 2000);
	                    }, function(error){
	                      if(!window.navigator.onLine) {
	                        offlineError()
	                        $rootScope.hasLoaded = true;
	                        alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                        return
	                      }
	                      if(error.status ==401) {
	                        var promise = refreshtokenService.getAccessToken();
	                        promise.then(
	                          function(answer) {
	                            if(answer==200) {
	                              postOrderFunction();
	                            }
	                          },
	                          function(error) {
	                            // report something
	                          },
	                          function(progress) {
	                           // report progress
	                        });
	                      } else if(error.status ==502) {
	                        serverError()
	                      } else {
	                        alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                      }
	                      $rootScope.hasLoaded = true;
	                    });
	                }
	              postOrderFunction()
	            })
	          }
	        };
	        element.sortable(options);
	      }
	    };
	  }	
	}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	module.exports = function(post) {
		"use strict";
	  post
	  .directive('sortableGalleryHorDir',sortableGalleryHorDir);
		sortableGalleryHorDir.$inject = [];
	  function sortableGalleryHorDir() {
	    return {
	      require: '?ngModel',
	      link: function(scope, element, attrs, ngModel) {
	        var state = 'attachments';
	        var options = {
	          helper:'original',
	          axis:'x',
	          start: function(e, ui) {
	            ui.item.directive = {
	              start: ui.item.index(),
	              startModel: ngModel
	            };
	          },
	          update: function(e, ui) {
	            var start = ui.item.directive.start;
	            var end = ui.item.index();
	            
	            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
	              scope.$apply(function() {
	                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
	                ngModel.$modelValue.splice(end, 0, element);
	              });
	            }
	          }
	        };
	        element.sortable(options);
	      }
	    };
	  }	
	}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('tagEditDir',tagEditDir);
		tagEditDir.$inject=[];
		function tagEditDir() {
			return {
				template: __webpack_require__(297),
				controller:'tagEditController',
				controllerAs:'vmte',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		"use strict";
	  posts
	  .controller('tagEditController', tagEditController)
		tagEditController.$inject = ["$scope","$state","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","checkArray","postDataService","offlineError"]
		
	  function tagEditController($scope,$state,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError, checkArray, postDataService,offlineError) {
	    var vmte = this;
	    $scope.parent = $scope.$eval($attrs.parent);
	    vmte.tagId = $scope.parent.tagId;
	    vmte.loadCategory= false;
	    vmte.mergeTagsArr = [];
	    if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin') {
	      vmte.superPermisions = true;
	    }
	    vmte.mergeTags = function() {
	      $rootScope.hasLoaded = false;
	      var mergeTagsIds = {
	        'ids': vmte.mergeTagsArr
	      }
	      var postFunction = function() {
	        postDataService.save({
	          param1:'tags', 
	          param2: 'merge',
	          param3: vmte.tag._id
	        },mergeTagsIds).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	          vmte.mergeTagsArr = []
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                postFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    var addNewTagFunction = function(data) {
	      vmte.newTagRequired = false;
	      if(!checkArray.contains.call(vmte.mergeTagsArr,data.tagId)) {
	        vmte.mergeTagsArr.push(data.tagId);
	        vmte.searchtagfocus = null;
	        vmte.existTag = false;
	      } else {
	        vmte.existTag = true;
	      }
	    }
	    $scope.$on('select-tag', function(event,data) {
	      addNewTagFunction(data.selectedTagObj)
	    });
	    vmte.addNewTag = function() {
	      return
	    }
	    vmte.removeFromTagsList = function(index) {
	      vmte.mergeTagsArr.splice(index, 1);
	    }
	    $rootScope.closeEditTag = function() {
	      $scope.parent.tagEdit = false;
	      vmte.tag = null;
	      $state.transitionTo('app.tags', {id: null}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    var getTagFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'tags', param2: vmte.tagId}).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        vmte.tag = data;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getTagFunction();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          $scope.parent.tagEdit = false;
	          $state.transitionTo('app.tags', {id: null}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	          });
	        }
	        $rootScope.hasLoaded = true;
	      }); 
	    }
	    getTagFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('tagsDir',tagsDir);
		tagsDir.$inject=[];
		function tagsDir() {
			return {
				template: __webpack_require__(298),
				controller:'tagsController',
				controllerAs:'vmt',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		'use strict'
	  posts
	  .controller('tagsController', tagsController)
		tagsController.$inject = ["watchAllCheckboxesNgTable","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","postDataService","alertService", "deleteDataService","putDataService","serverError","comunicateBetweenViews", "offlineError"]
		
	  function tagsController(watchAllCheckboxesNgTable,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,refreshtokenService, postDataService,alertService, deleteDataService, putDataService,serverError, comunicateBetweenViews, offlineError) {
	    var vmt = this;
	    vmt.tagEdit = false;
	    var state = 'tags';
	    var page;  
	    var limit;
	    var sortby;
	    var s;
	    var $data;
	    $rootScope.alert={hasBeenShown: false};
	    $rootScope.hasLoaded = false;
	    vmt.selectedName = -1;
	    vmt.hasParent = {items:{}};
	    vmt.tagName = undefined;
	    vmt.tagSlug = undefined;
	    vmt.tagDescription= undefined;
	    vmt.selectedBulkAction = {value: 'default'};
	    vmt.checkedPostsEdit = [];
	    vmt.checkboxes = { 'checked': false, items: {} };
	    $rootScope.emptyTable = false;
	    vmt.tagId = $stateParams.id; 
	    if($stateParams.id) {
	      vmt.tagEdit= true;
	    } else {
	      vmt.tagEdit = false;
	    }
	    vmt.goToAllPosts = function(tag) {
	      comunicateBetweenViews.setTag(tag);
	      $state.go('app.allposts'); 
	    }
	    vmt.editTag = function(tagId,tagCount) {
	      vmt.tagEdit= true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 10);
	      vmt.tagId = tagId;
	      $state.transitionTo('app.tags', {id: vmt.tagId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmt.addNewTag = function() {
	    
	      if(vmt.tagName) {
	        $rootScope.hasLoaded = false;
	        var postFunction = function() {
	          postDataService.save({
	            param1:'tags', 
	            // param2: 'create'
	          },{
	            'name':vmt.tagName,
	            "description": vmt.tagDescription,
	            'slug':vmt.tagSlug
	          }).$promise.then(function(postTag){ 
	            vmt.tagName = undefined;
	            vmt.tagSlug = undefined;
	            vmt.tagDescription= undefined;
	            alertService('success','Success ', postTag.message, 2000);
	            $rootScope.hasLoaded = true;
	            vmt.tableParams.reload();
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              if(error && error.data && error.data.error && error.data.error.slug) {
	                vmt.tagSlug = error.data.error.slug;
	              }
	            }
	            $rootScope.hasLoaded = true;  
	          });
	        }
	        postFunction();
	      } else {
	        alertService('danger','Opps! ', 'Tag is required')
	        vmt.nameRequired=true;
	      }
	    }
	    vmt.quickEdit = function(id) {
	      vmt.selectedName = id;
	    }
	    vmt.cancelQuickEdit = function() {
	      vmt.selectedName = -1;
	    }
	    vmt.reloadTable = function() {
	      vmt.tableParams.reload()
	    }
	    vmt.updateBulkDeleteSuccess = function() {
	      watchAllCheckboxesNgTable.resetCheckBox(vmt)
	      vmt.selectedBulkAction = {value: 'default'};
	      vmt.tableParams.reload(); 
	    }
	    watchAllCheckboxesNgTable.watch($scope,vmt)
	    vmt.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmt.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmt.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmt.checkedPostsEdit.indexOf(id_tag);
	          vmt.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    vmt.tableActionsFunction = function(params) {
	      vmt.search =function(value) {
	        if(value) {  
	          s = value.toLowerCase();
	        } else {
	          s = null;
	        }
	        page = 1;
	        params.page(page);
	        vmt.tableParams.reload();
	      }
	    }
	    vmt.tableReloadFunction = function(page) {
	      vmt.tableParams = new NgTableParams({
	        page: page || 1,
	        count: 20,
	              
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            page: params.page(),
	            limit: params.count(),
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            s:s
	            }).$promise.then(function(data){
	           
	            $rootScope.hasLoaded = true;
	            $data =data.tags;
	            vmt.dataGet = data.tags;
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            if(data.tags.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            }
	            watchAllCheckboxesNgTable.resetCheckBox(vmt)
	            vmt.tableActionsFunction(params);  
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	                if(answer==200) {
	                  vmt.tableReloadFunction(params.page());
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else {
	              alertService('danger','Opps! ', error.data.error.message); 
	            }
	            $rootScope.hasLoaded = true;
	            vmt.tableActionsFunction(params);
	          });
	        }    
	      });   
	    }
	    vmt.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(posts) {
		'use strict'
		posts.directive('usElectionDir',usElectionDir);
		usElectionDir.$inject=[];
		function usElectionDir() {
			return {
				template: __webpack_require__(299),
				controller:'usElectionController',
				controllerAs:'vmue',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = function(posts) {
		"use strict";
	  posts
	  .controller('usElectionController', usElectionController)
		usElectionController.$inject = ["keyPressOnlyNumber","API_URL","$http","$scope","$state","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","checkArray","postDataService","offlineError"]
		
	  function usElectionController(keyPressOnlyNumber,API_URL,$http,$scope,$state,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError, checkArray, postDataService,offlineError) {
	    var vmue = this;
	    vmue.checkboxes = {}
	    vmue.keyPressOnlyNumber = keyPressOnlyNumber;
	    vmue.saveChanges = function() {
	      if(!vmue.dt_total && vmue.dt_total !== 0) {
	        alertService('danger','Opps! ', 'Total electoral votes is required.');
	        vmue.dtTotalRequied = true
	        return
	      }
	      if(!vmue.kh_total && vmue.kh_total !== 0) {
	        alertService('danger','Opps! ', 'Total electoral votes is required.');
	        vmue.khTotalRequied = true
	        return
	      }
	      for (var i = 0; i< vmue.usElectionArray.length;i++) {
	        vmue.usElectionArray[i].winner = vmue.checkboxes[vmue.usElectionArray[i].id] 
	      }
	      var putData = {
	        'dt_total':parseInt(vmue.dt_total),
	        'kh_total':parseInt(vmue.kh_total),
	        'widget_url':vmue.widgetUrl,
	        'states': vmue.usElectionArray
	      };
	      var putFunction = function() {
	        $http.put(API_URL + 'us_election' , putData)
	        .success(function (data, status, headers) {
	            alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	        });
	      }
	      putFunction();
	    }
	    var getElectionsFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:'us_election'}).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        if(!data.result) return;
	        if(data.result.states && data.result.states.length>0) {
	          vmue.usElectionArray = data.result.states
	          for (var i = 0; i< vmue.usElectionArray.length;i++) {
	            vmue.checkboxes[vmue.usElectionArray[i].id] = vmue.usElectionArray[i].winner
	          }
	        }
	        if('dt_total' in data.result) {
	          vmue.dt_total = data.result.dt_total
	        }
	        if('kh_total' in data.result) {
	          vmue.kh_total = data.result.kh_total
	        }
	        if('widget_url' in data.result) {
	          vmue.widgetUrl = data.result.widget_url
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getElectionsFunction();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }  
	        $rootScope.hasLoaded = true;
	      }); 
	    }
	    getElectionsFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = function(ratings) {
		"use strict";
	  ratings
	  .controller('allratingsController', allratingsController)
		allratingsController.$inject = ["$filter","watchAllCheckboxesNgTable","$timeout","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService","putDataService","serverError","offlineError"];
		
	  function allratingsController($filter,watchAllCheckboxesNgTable,$timeout,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService, putDataService,serverError,offlineError) {
	    var vmratings = this;
	    var state = 'ratings';
	    var s;
	    var role;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var $data;
	    var page;
	    vmratings.status = 'publish';
	    var status = 'publish';
	    vmratings.selectedTitle = -1;
	    vmratings.editRatingShow = false;
	    vmratings.selectedRole = {value: 'all'}; 
	    vmratings.selectedBulkAction = {value: 'default'};
	    vmratings.checkedPostsEdit = [];
	    vmratings.checkboxes = { 'checked': false, items: {}};
	    vmratings.ratingId = $stateParams.id; 
	    if($stateParams.id) {
	      vmratings.editRatingShow = true;
	    } else {
	      vmratings.editRatingShow = false;
	    }
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vmratings.bulkAction = function(param) {
	      if(param != 'default' && vmratings.checkedPostsEdit.length>0 ) {
	        var putFunction = function() { 
	          putDataService.update({
	            param1:state, 
	            param2: 'bulk',
	            param3:'delete'
	          },{
	            'delete_ids':vmratings.checkedPostsEdit,
	          }).$promise.then(function(bulkDelete){
	            watchAllCheckboxesNgTable.resetCheckBox(vmratings)
	            vmratings.selectedBulkAction = {value: 'default'}; 
	            alertService('success','Success ', bulkDelete.message, 2000);
	            vmratings.tableParams.reload();
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    putFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	              });
	            }else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            } 
	            watchAllCheckboxesNgTable.resetCheckBox(vmratings)
	            vmratings.selectedBulkAction = {value: 'default'}; 
	          });
	        }
	        putFunction();
	      }
	    }
	    watchAllCheckboxesNgTable.watch($scope, vmratings)
	    vmratings.checkedPost = function(ratingId, checked) {
	      if(checked) {
	        vmratings.checkedPostsEdit.push(ratingId);
	      } else {
	        if(vmratings.checkedPostsEdit.includes(ratingId)) {
	          var id_tag = ratingId;
	          var position = vmratings.checkedPostsEdit.indexOf(id_tag);
	          vmratings.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    vmratings.editTitle = function(index) {
	      vmratings.selectedTitle = index;
	    }
	    vmratings.cancelEditTitle = function() {
	      vmratings.selectedTitle = -1;
	    }
	    vmratings.editRating = function(ratingId) {
	      
	      vmratings.editRatingShow = true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      vmratings.ratingId = ratingId;
	      $state.transitionTo('app.allratings', {id: vmratings.ratingId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmratings.updateStatus = function(item,status) {
	      $rootScope.hasLoaded = false;
	        var updateData = {
	          'title': item.title,
	          'content': item.content,
	          'status': status,
	          'data':item.data.answers,
	          'multiple': item.multiple,
	          'max_choices': item.max_choices,
	          "image": item.image,
	          "expire_date": (status == 'finish')? $filter('date')(new Date().toISOString(), "MMM d, y HH:mm"): null,
	          "ads": item.ads
	        }
	      var putFunction = function() {
	        putDataService.update({
	          param1:'ratings', 
	          param2:item._id
	        },updateData).$promise.then(function(putRating){
	            $rootScope.hasLoaded = true;
	            vmratings.tableParams.reload();
	            alertService('success','Success ', putRating.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          }else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;  
	        });
	      }
	      putFunction();
	    }
	    vmratings.deleteRating = function(ratingId) {
	      var deleteFunction = function() {
	        deleteDataService.remove({
	          param1:'ratings', 
	          param2: ratingId
	        }).$promise.then(function(deleteRating){ 
	          alertService('success','Success ', deleteRating.message, 2000);
	          vmratings.tableParams.reload();
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  deleteFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }  
	        });
	      }
	      deleteFunction();
	    }
	    vmratings.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        $timeout(function() {
	          vmratings.search();
	        },0)            
	      }
	    }
	    vmratings.changeDate = function(value) {
	      vmratings.dateRangevalue= value;
	      if(vmratings.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	          date_start = null;
	          date_end = null;
	      }
	    }
	    vmratings.changeStatus =function(event,activeStatus) {
	      vmratings.status = activeStatus;
	      if(activeStatus == 'all') {
	        status = null;
	      } else {
	        status = activeStatus;
	      }
	      reloadTableFunction();
	    }
	    function reloadTableFunction() {
	      if(vmratings.tableParams.page() ==1) {
	        vmratings.tableParams.reload();
	      } else {
	        vmratings.tableParams.page(1);
	      }
	    } 
	    vmratings.resetAllFilters = function() {
	      vmratings.searchData = null;
	      s =null;
	      status = 'publish'
	      date_start = null;
	      date_end = null;
	      $scope.$broadcast('clear-daterange',true);
	      reloadTableFunction();
	    }
	    // vmavo.changeStatus =function(event,activeStatus) {
	    //   s=null;
	    //   date_start = null;
	    //   date_end= null;
	    //   reloadTableFunction
	    // }
	     vmratings.search =function(value) {
	      if(value) { 
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    vmratings.tableReloadFunction = function(page) { 
	      vmratings.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	          
	      }, {
	        getData: function(params) {
	          $rootScope.emptyTable = false;
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,   
	            s:s,
	            status: status,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end,
	            page: params.page(),
	            limit: params.count(),
	            }).$promise.then(function(data){
	            
	            $rootScope.hasLoaded = true;
	            $data = data.ratings;
	            vmratings.dataGet = data.ratings; 
	            if(data.ratings.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            }
	            watchAllCheckboxesNgTable.resetCheckBox(vmratings) 
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	            // $rootScope.refreshToken =true;
	              
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                 
	                  if(answer==200) {
	                    vmratings.tableReloadFunction(params.page());
	                  }
	                  // do something
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	                });
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	          });
	        }    
	      });
	    }
	    vmratings.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ratings) {
		'use strict'
		ratings.directive('allRatingsDir',allRatingsDir);
		allRatingsDir.$inject=[];
		function allRatingsDir() {
			return {
				template: __webpack_require__(300),
				controller:'allratingsController',
				controllerAs:'vmratings',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(ratings) {
		'use strict'
		ratings.directive('ratingDir',ratingDir);
		ratingDir.$inject=[];
		function ratingDir() {
			return {
				template: __webpack_require__(301),
				controller:"ratingController",
				controllerAs:"vmrating",
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = function(ratings) {
		"use strict";
	  ratings
	  .controller('ratingController', ratingController)
		ratingController.$inject = ["createRandomHash","authtokenService","API_URL","$timeout","$filter","keyPressOnlyNumber","$parse","$attrs","$rootScope","$scope","getDataService", "jQuery","$state", "$stateParams","refreshtokenService","config","reqursiveService","putDataService","alertService","postDataService","deleteDataService","serverError","offlineError"];
		
	  function ratingController(createRandomHash,authtokenService,API_URL,$timeout,$filter,keyPressOnlyNumber,$parse,$attrs,$rootScope,$scope,getDataService,jQuery,$state, $stateParams,refreshtokenService, config, reqursiveService, putDataService, alertService,postDataService,deleteDataService,serverError,offlineError) {
	    var vmrating = this;
	    var validation = true;
	    var parent = $scope.$eval($attrs.parent);
	    vmrating.editStatusShow = false;
	    vmrating.minimumNumberOfQuestion = false;
	    vmrating.titleRequired = false;
	    vmrating.dataVote = {};
	    vmrating.keyPressOnlyNumber = keyPressOnlyNumber;
	    vmrating.selectedType = {value: 'football'};
	    vmrating.choices = [];
	    vmrating.selectedRatingStatus = {};
	    vmrating.required = {};
	    var token = authtokenService.getToken();
	    Dropzone.autoDiscover = false;
	    vmrating.dzOptions = {
	      url : API_URL + 'upload/ratings',
	      paramName : 'photo',
	      maxFilesize : '500',
	      parallelUploads: 1,
	      uploadMultiple: false,
	      acceptedFiles : 'image/jpeg, images/jpg, image/png',
	      addRemoveLinks : true,
	      autoProcessQueue : false,
	      dictInvalidFileType: 'This file type is not supported. Upload a JPEG or PNG image.',
	      dictFileTooBig:'File size too Big. Maximum size is 500KB.',
	      dictDefaultMessage : "Click or drop image here to upload",
	      headers:{
	        'x-auth': token  
	      }
	    };
	    vmrating.dzCallbacks = {
	      'addedfile' : function(file){
	        // Only process the file if it's accepted
	          vmrating.pendingUpload = true;
	          if(vmrating.newFileRating) {
	            vmrating.dzMethods.removeFile(vmrating.newFileRating);
	          }
	          vmrating.newFileRating = file;
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              token = authtokenService.getToken();
	              vmrating.dzOptions.headers['x-auth'] = token;
	              vmrating.dzMethods.processQueue();
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	              // report progress
	          });
	      },
	      'success' : function(file, xhr, response){
	        var data = JSON.parse(response.currentTarget.response);
	        vmrating.choices.length = 0;
	        if(data && data.data && data.data.data && data.data.data.results && data.data.data.results.length > 0) {
	          for(var i=0; i<data.data.data.results.length;i++) {
	            var choiceData = angular.copy(data.data.data.results[i]);
	            choiceData._id = createRandomHash(10);
	            vmrating.choices.push(choiceData);
	            vmrating.required[choiceData._id] = {};
	          }
	          vmrating.pendingUpload = false;
	        }
	      },
	      'error' : function(file,message) {
	        vmrating.pendingUpload = false;
	        if(message === vmrating.dzOptions.dictInvalidFileType) {
	          jQuery(file.previewElement).find('.dz-error-message').text(vmrating.dzOptions.dictInvalidFileType)
	          return
	        } else if(message === vmrating.dzOptions.dictFileTooBig) {
	          jQuery(file.previewElement).find('.dz-error-message').text(vmrating.dzOptions.dictFileTooBig)
	          return
	        }
	          // console.log(response.xhr.status);
	        if(message && message.error && message.error.message) {
	          jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
	        } else {
	          jQuery(file.previewElement).find('.dz-error-message').text('Cannot POST /upload/rating');
	        }
	      }
	    };
	    vmrating.sortableOptions = {
	      axis: 'y'
	    }
	    vmrating.editRatingStatus = function() {
	      vmrating.editRatingStatusShow = true;
	    }
	    vmrating.changeRatingStatus = function() {
	      vmrating.editRatingStatusShow = false;
	      vmrating.dataRating.status = vmrating.selectedRatingStatus.value;
	    }
	    vmrating.cancelEditRatingStatus = function() {
	      vmrating.editRatingStatusShow = false;
	      vmrating.dataRating.status = vmrating.copyStatus;
	    }
	    vmrating.editRatingStatus = function() {
	      vmrating.copyStatus = angular.copy(vmrating.selectedRatingStatus.value);  
	      vmrating.editRatingStatusShow = true;
	    }
	    vmrating.submitEditRatingStatus = function() {
	      vmrating.editRatingStatusShow = false;
	    }
	    vmrating.switchRatingStatus = function(status) {
	      vmrating.dataRating.status = status;
	    }
	    vmrating.editRatingDate = function() {
	      vmrating.editRatingDateShow = true;
	      if(!vmrating.dataRating.expire_date) {
	        convertTimeFunction(undefined);
	      } 
	    }
	    vmrating.cancelEditRatingDate = function() {
	      vmrating.editRatingDateShow = false; 
	    }
	    
	    vmrating.setRatingDate = function() {
	      vmrating.editRatingDateShow = false; 
	      var dateArray = [vmrating.ratingYear, parseInt(vmrating.selectedRatingMonth.value)-1, vmrating.ratingDay, vmrating.ratingHours, vmrating.ratingMinutes];
	      var updateDate = moment(dateArray).toISOString();
	      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>60) {
	        vmrating.dataRating.expire_date = $filter('date')(updateDate, "MMM d, y HH:mm");
	        vmrating.editRatingDateShow = false
	      } else {
	        alertService('danger','Opps! ', 'The date is not valid. The set date must be at least 60 minutes from now.');
	      }
	    }
	    function convertTimeFunction(date) {
	      var a = moment(date);
	      var year = a.format('YYYY');
	      var month = a.format('M');
	      var day = a.format('D');
	      var hour = a.hours();
	      var min = a.minutes();
	      vmrating.ratingYear = year;
	      vmrating.selectedRatingMonth = {value: month};
	      vmrating.ratingDay = day;
	      if(hour<10) {
	        vmrating.ratingHours = '0'+hour;  
	      } else {
	        vmrating.ratingHours = hour;
	      }
	      if(min<10) {
	        vmrating.ratingMinutes = '0'+min;  
	      } else {
	        vmrating.ratingMinutes = min;
	      }
	    } 
	    vmrating.addNewChoice = function() {
	      var createRandomHashVar = createRandomHash(10);
	      vmrating.required[createRandomHashVar] = {};
	      if(vmrating.selectedType.value === 'other') {
	        vmrating.choices.push({'name': '','_id': createRandomHashVar});
	      } else {
	        vmrating.choices.push({'name': '','number':1,'_id': createRandomHashVar});
	      }
	    };
	    var copyChoice = {};
	    vmrating.editChoiceShow = {}
	    vmrating.deleteOrCancelEditChoice = function(choice) {
	      var index = vmrating.choices.findIndex(function(item) {
	        return item._id === choice._id;
	      });
	      if(vmrating.editChoiceShow[choice._id]) {
	        vmrating.choices[index] = copyChoice[choice._id];
	        delete copyChoice[choice._id];
	        delete vmrating.editChoiceShow[choice._id];
	      } else {
	        vmrating.choices.splice(index, 1);
	        delete vmrating.required[choice._id];
	        delete vmrating.editChoiceShow[choice._id];
	      }
	    }
	    vmrating.editOrSaveChoice = function(choice) {
	      copyChoice[choice._id] = angular.copy(choice);
	      if(vmrating.editChoiceShow[choice._id]) {
	        delete vmrating.editChoiceShow[choice._id];
	      } else {
	        vmrating.editChoiceShow[choice._id] = true;
	      }
	      vmrating.required[choice._id].name = false;
	      vmrating.required[choice._id].number = false;
	    }
	    
	
	    function actionWithRating() {
	      var validation = true;
	      if(!vmrating.dataRating.title) {
	        vmrating.titleRequired = true;
	        alertService('danger','Opps! ', 'Title is required');
	        validation = false;
	      } else {
	        vmrating.titleRequired = false;
	      }
	      if(vmrating.choices.length < 2) {
	        alertService('danger','Opps! ', 'At least two rating items are required');
	        return;
	      }
	      var numberCounts = {};
	      var duplicateFound = false;
	      
	      for(var i=0; i<vmrating.choices.length;i++) {
	        if(!vmrating.choices[i].name) {
	          alertService('danger','Opps! ', 'Name is required');
	          vmrating.required[vmrating.choices[i]._id].name = true;
	          validation = false;
	        } else {
	          vmrating.required[vmrating.choices[i]._id].name = false;
	        }
	        if(vmrating.selectedType.value !== 'other') {
	          if(!vmrating.choices[i].number) {
	            alertService('danger','Opps! ', 'If you select football or basketball, number is required');
	            vmrating.required[vmrating.choices[i]._id].number = true;
	            validation = false;
	          } else {
	            vmrating.required[vmrating.choices[i]._id].number = false;
	            vmrating.choices[i].number = parseInt(vmrating.choices[i].number);
	            
	            // Check for duplicates in the same loop
	            var num = vmrating.choices[i].number.toString();
	            if(!numberCounts[num]) {
	              numberCounts[num] = [];
	            }
	            numberCounts[num].push(i);
	          }
	        }
	      }
	      
	      // Check for duplicates and mark them
	      if(vmrating.selectedType.value !== 'other') {
	        for(var num in numberCounts) {
	          if(numberCounts[num].length > 1) {
	            duplicateFound = true;
	            // Mark all duplicates except the first one
	            for(var j = 1; j < numberCounts[num].length; j++) {
	              var choiceIndex = numberCounts[num][j];
	              vmrating.required[vmrating.choices[choiceIndex]._id].duplicateNumber = true;
	            }
	          }
	        }
	        
	        if(duplicateFound) {
	          alertService('danger','Opps! ', 'Duplicate numbers are not allowed');
	          validation = false;
	        }
	      }
	      if(validation) {
	        $rootScope.hasLoaded = false;
	        var expire_date = null;
	        if(vmrating.dataRating.status=='finish'){
	          expire_date = $filter('date')(new Date().toISOString(), "MMM d, y HH:mm")
	        } else if(vmrating.dataRating.status=='publish') {
	          if(vmrating.dataRating.expire_date && new Date(vmrating.dataRating.expire_date).getTime() > new Date().getTime()) {
	            expire_date = vmrating.dataRating.expire_date
	          }
	        }
	        var updateData = {
	          'title':vmrating.dataRating.title,
	          'status': vmrating.dataRating.status,
	          'type': vmrating.selectedType.value,
	          'data':vmrating.choices,
	          "expire_date": expire_date,
	        }
	        if(!parent) {
	          var postFunction = function() {
	            postDataService.save({
	              param1:'ratings', 
	            },updateData).$promise.then(function(postRating){
	              $rootScope.hasLoaded = true;
	              alertService('success','Success ', postRating.message, 2000);
	              if(postRating && postRating.obj && postRating.obj._id) {
	                $state.go('app.allratings',{id:postRating.obj._id});
	              }
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                     postFunction();
	                    }
	                  },
	                  function(error) {
	                    // report something
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;  
	            });
	          }
	          postFunction();
	        } else {
	          var putFunction = function() {
	            putDataService.update({
	              param1:'ratings', 
	              param2:vmrating.dataRating._id
	            },updateData).$promise.then(function(putRating){
	                $rootScope.hasLoaded = true;
	                populateData(putRating.obj)
	                alertService('success','Success ', putRating.message, 2000);
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {   
	                      putFunction();
	                    }
	                  },
	                  function(error) {
	                    // report something
	                  },
	                  function(progress) {
	                   // report progress
	                });
	              } else if(error.status ==502) {
	                serverError()
	              }else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;  
	            });
	          }
	          putFunction();
	        }
	      }
	    }
	    vmrating.trashRating = function() {
	      vmrating.dataRating.status = 'trash';
	      vmrating.selectedRatingStatus = {value:'trash'};
	      actionWithRating();
	    }
	    vmrating.publishRating = function() {
	      vmrating.dataRating.status = 'publish';
	      vmrating.selectedRatingStatus = {value:'publish'};
	      actionWithRating();
	    }
	    vmrating.updateRating = function() {
	      actionWithRating();
	    }
	    function populateData(data) {
	      vmrating.update = false;
	      vmrating.dataRating = data;
	      vmrating.selectedType = {value: vmrating.dataRating.type};
	      vmrating.choices = vmrating.dataRating.data;
	      for(var i=0; i<vmrating.choices.length;i++) {
	        vmrating.required[vmrating.choices[i]._id] = {};
	      }
	      vmrating.selectedRatingStatus.value = vmrating.dataRating.status;
	      if(vmrating.dataRating.expire_date) {
	        vmrating.dataRating.expire_date = $filter('date')(vmrating.dataRating.expire_date, "MMM d, y HH:mm");
	        convertTimeFunction(vmrating.dataRating.expire_date);
	      } else {
	        convertTimeFunction(undefined);
	      }
	    }
	    if(parent) {
	      vmrating.ratingId = parent.ratingId;
	      vmrating.newRating = false;
	      $rootScope.closeEditRating = function() {
	        $rootScope.ngEscapeAttrsParametars = [];
	        parent.editRatingShow = false;
	        vmrating.dataRating = null;
	        $state.transitionTo('app.allratings', {id: null}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      }
	      var getRatingFunction = function() { 
	        $rootScope.hasLoaded = false;
	        getDataService.get({param1:'ratings', param2: vmrating.ratingId, param3:null}).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          populateData(data)
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError('refresh')
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                getRatingFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            parent.editRatingShow = false;
	            vmrating.dataRating = null;
	            $rootScope.hasLoaded = false;
	            $state.transitionTo('app.allratings', {id: null}, {
	              location: true,
	              inherit: true,
	              relative: $state.$current,
	              notify: false
	            });
	          }
	        });
	      }
	      getRatingFunction();
	    } else {
	      vmrating.newRating = true;
	      vmrating.dataRating = {
	        title: '',
	        status: 'publish',
	        data: [],
	        expire_date: null,
	      }
	    }
	  }	
	}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var ratings = angular.module('ratingsModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap'
	]);
	__webpack_require__(575)(ratings);
	__webpack_require__(574)(ratings);
	__webpack_require__(576)(ratings);
	__webpack_require__(577)(ratings);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var service = angular.module("servicesModule",[
		'ngResource'
		]);
	
	__webpack_require__(610)(service);
	// require('./services/socketService.js')(service);
	__webpack_require__(604)(service);
	__webpack_require__(586)(service);
	__webpack_require__(626)(service);
	__webpack_require__(618)(service);
	__webpack_require__(584)(service);
	__webpack_require__(630)(service);
	__webpack_require__(622)(service);
	__webpack_require__(620)(service);
	__webpack_require__(605)(service);
	__webpack_require__(621)(service);
	__webpack_require__(595)(service);
	__webpack_require__(585)(service);
	__webpack_require__(624)(service);
	__webpack_require__(580)(service);
	__webpack_require__(617)(service);
	__webpack_require__(589)(service);
	__webpack_require__(588)(service);
	__webpack_require__(625)(service);
	__webpack_require__(615)(service);
	__webpack_require__(614)(service);
	__webpack_require__(612)(service);
	__webpack_require__(613)(service);
	__webpack_require__(616)(service);
	__webpack_require__(627)(service);
	__webpack_require__(590)(service);
	__webpack_require__(587)(service);
	__webpack_require__(600)(service);
	__webpack_require__(601)(service);
	__webpack_require__(598)(service);
	__webpack_require__(593)(service);
	__webpack_require__(582)(service);
	__webpack_require__(581)(service);
	__webpack_require__(623)(service);
	__webpack_require__(606)(service);
	__webpack_require__(597)(service);
	__webpack_require__(631)(service);
	__webpack_require__(619)(service);
	__webpack_require__(609)(service);
	__webpack_require__(594)(service);
	// require('./services/socketNewsService.js')(service);
	__webpack_require__(608)(service);
	__webpack_require__(607)(service);
	__webpack_require__(603)(service);
	__webpack_require__(596)(service);
	__webpack_require__(591)(service);
	__webpack_require__(599)(service);
	__webpack_require__(583)(service);
	__webpack_require__(628)(service);
	__webpack_require__(611)(service);
	__webpack_require__(602)(service);
	__webpack_require__(629)(service);
	__webpack_require__(592)(service);

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('activeClass',activeClass);
		activeClass.$inject=['jQuery'];
		function activeClass(jQuery) {
			return {
				active: function(event) {
					var target = event.target;
		           	var siblings = jQuery(target).parent('li').siblings('li');
		            for (var i=0; i<siblings.length; i++){
		              jQuery(siblings[i]).find('a').removeClass('active')
		            }
		            jQuery(target).addClass('active');
	        	}
			}
		}
	}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('addToOtherByUrl',addToOtherByUrl);
		addToOtherByUrl.$inject=['postDataService','refreshtokenService','serverError','alertService','offlineError'];
		function addToOtherByUrl(postDataService,refreshtokenService,serverError, alertService, offlineError) {
	        return function(url, data, type,successFunc, parentObj,order) {
	            if(!postData) {
	              postData = null
	            }
	            if(!data) {
	                alertService('danger','Opps! ', (type)? type[0].toUpperCase() + type.slice(1)+ ' URL is required field.':'URL is required field.');
	                parentObj[type+'UrlRequired'] = true;
	                return
	            }
	            var postData = {
	                'url':data
	            }
	            var postFunction = function() {   
	              postDataService.save(url,postData).$promise.then(function(responseData){
	                parentObj[type+'Url'] = '';
	                if(responseData.addedItem) {
	                  successFunc(responseData.addedItem,order)
	                } else {
	                  successFunc()
	                }
	                if(responseData.message) {
	                  alertService('success','Success ', responseData.message, 2000);
	                }
	              }, function(error){
	                if(!window.navigator.onLine) {
	                  offlineError()
	                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                  return
	                }
	                if(error.status ==401) {
	                  var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {   
	                        postFunction();
	                      }
	                    },
	                    function(error) {
	                      // report something
	                    },
	                    function(progress) {
	                      // report progress
	                  });
	                }else if(error.status ==502) {
	                  serverError();
	                }else {
	                  alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                }
	              });
	            }
	            postFunction();
	          }
		}
	}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('addToOther',addToOther);
		addToOther.$inject=['$rootScope','postDataService','refreshtokenService','serverError','alertService','offlineError'];
		function addToOther($rootScope,postDataService,refreshtokenService,serverError, alertService, offlineError) {
	        return function(url, postData) {
	            if(!postData) {
	              postData = null
	            }
	            $rootScope.hasLoaded = false;
	            var postFunction = function() {   
	              postDataService.save(url,postData).$promise.then(function(postData){
	                $rootScope.hasLoaded = true;
	                alertService('success','Success ', postData.message, 2000);
	              }, function(error){
	                if(!window.navigator.onLine) {
	                  offlineError()
	                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                  return
	                }
	                if(error.status ==401) {
	                  var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {   
	                        postFunction();
	                      }
	                    },
	                    function(error) {
	                      // report something
	                    },
	                    function(progress) {
	                      // report progress
	                  });
	                }else if(error.status ==502) {
	                  serverError();
	                }else {
	                  alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                }
	                $rootScope.hasLoaded = true;
	              });
	            }
	            postFunction();
	          }
		}
	}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('aiModalService', aiModalService);
		aiModalService.$inject = ['$http','alertService','serverError','offlineError','refreshtokenService','API_URL'];
		function aiModalService($http,alertService,serverError,offlineError,refreshtokenService,API_URL) {
			function httpMethod(method, httpFragment, callbackSuccess, callbackError, data) {
	            var url = API_URL + 'aitools/' + httpFragment;
	            var request = method === 'post' || method === 'put' 
	                ? $http[method](url, data)
	                : $http[method](url);
	                
	            request.success(function (data, status, headers) {
	                if(callbackSuccess) {
	                    callbackSuccess(data);
	                }
	            })
	            .error(function (data, status, header, config) {
	                if(!window.navigator.onLine) {
	                    offlineError()
	                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                    return
	                }
	                if(status ==401) {
	                    var promise = refreshtokenService.getAccessToken();
	                    promise.then(
	                        function(answer) {
	                            if(answer==200) {   
	                                httpMethod(method, httpFragment, callbackSuccess, callbackError,data);
	                            }
	                        },
	                        function(error) {
	                            // report something
	                        },
	                        function(progress) {
	                            // report progress
	                        });
	                }else if(status ==502) {
	                    serverError();
	                } else { 
	                    if(callbackError) {
	                        var message = (data && data.message)? data.message:'Failed to load response data.';
	                        callbackError(message);
	                    }
	                }
	            })
	        };
	        return {
				post: function(httpFragment, data, callbackSuccess, callbackError) {
	                httpMethod('post', httpFragment, callbackSuccess, callbackError,data);
				},
	            put: function(httpFragment, data, callbackSuccess, callbackError) {
	                httpMethod('put', httpFragment, callbackSuccess, callbackError,data);
	            },
	            get: function(httpFragment, callbackSuccess, callbackError) {
	                httpMethod('get', httpFragment, callbackSuccess, callbackError);
	            },
	            delete: function(httpFragment, callbackSuccess, callbackError) {
	                httpMethod('delete', httpFragment, callbackSuccess, callbackError);
	            }
	        }
	    }
	}


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.service('alertService',alertService);
		alertService.$inject=['$rootScope','$timeout','createRandomHash'];
		function alertService($rootScope,$timeout,createRandomHash) {
			$rootScope.alerts=[];
			$rootScope.alertShow = false;
			var alertsTimeout = [];
			var alertsWidthClose = []
			var i = -1;
			var j = -1
			var rb = -1;
			return function(type,title,message,timeout) {
				var alertObj = {
					'show':true,
					'type':type,
					'title':title,
					'message':message,
					'close':(timeout)?false:true,
					'id':createRandomHash(10)
				}
				$rootScope.alerts.push(alertObj);
				if(timeout) {
					alertObj.timeout = $timeout(function() {
						var index = $rootScope.alerts.findIndex(function(alert) {		
							return alert.id == alertObj.id;
						});
						if(index != -1) {
							$rootScope.alerts.splice(index,1);	
						}
					},timeout);
				} else {
					$rootScope.alertShow = true;
				}
				$rootScope.closeAlert = function(id) {
					var index = $rootScope.alerts.findIndex(function(alert) {	
						return alert.id == id;
					});
					if(index != -1) {
						$rootScope.alerts.splice(index,1);	
					}
					var closeAlerts = $rootScope.alerts.filter(function(alert) {
						return alert.close;
					});
					if(closeAlerts.length==0) {
						$rootScope.alertShow = false;
					}
				}
			}
		}
	}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('authInterceptor',authInterceptor);
		authInterceptor.$inject=['authtokenService','config','$rootScope'];
		function authInterceptor(authtokenService,config,$rootScope) {
			var appConfig = config;
			return {
				request: function(config) {
					var token;
					if (config.url && (config.url.includes('auth/renewRefreshToken') || config.url.includes('auth/logout')) || config.url.includes('auth/renewToken')) {
						token = authtokenService.getRefreshToken();
					} else {
						token = authtokenService.getToken();
					}
					if(token) {
						config.headers['x-auth'] = token;
					}
					if(appConfig && appConfig.version) {
						config.headers['x-version'] = appConfig.version
					}
					if($rootScope.tabSessionId) {
						config.headers['x-session-id'] = $rootScope.tabSessionId;
					}
					return config; 
				},
				response: function(response) {
					return response;
				}
			}
		}
	}


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('authtokenService',authtokenService);
		authtokenService.$inject=['$rootScope','$timeout','$window'];
		function authtokenService($rootScope, $timeout, $window) {
			var storage = $window.localStorage;
			var cachedName;
			var cachedLastName;
			var cachedAvatar;
			var cachedId;
			var cachedroleId;
			var cachedAitools;
			var userToken = 'userToken';
			var refreshToken = 'refreshToken';
			var userName = 'userName';
			var userLastName = 'userLastName';
			var userAvatar = 'userAvatar';
			var userId = 'userId';
			var roleId = 'roleId' 
			var aitools = 'aitools';
			var authToken = {
				setToken:function(token) {
					storage.setItem(userToken, token);
					
				},
				setrefreshToken:function(refreshtoken) {
					storage.setItem(refreshToken, refreshtoken);
				},
				setNameandAvatarandIdandroleId:function(name, lastName, avatar,id,role_id,aitoolsData) {
					cachedName = name;
					cachedLastName = lastName;
					cachedAvatar= avatar;
					cachedId = 	id;
					cachedroleId = role_id;
					cachedAitools = aitoolsData || [];
					storage.setItem(userName, name || '');
					storage.setItem(userLastName, lastName || '');
					storage.setItem(userAvatar, avatar);
					storage.setItem(userId, id);
					storage.setItem(roleId,role_id);
					storage.setItem(aitools,JSON.stringify(aitoolsData || []));
				},
				getToken:function() {
					return storage.getItem(userToken);  
					
				},
				getRefreshToken:function() {
					return storage.getItem(refreshToken);
				},
				getRoleId:function() {
					if(!cachedroleId) {
						cachedroleId = storage.getItem(roleId);
					}
					return cachedroleId;
				},
				getUserId:function() {
					if(!cachedId) {
						cachedId = storage.getItem(userId);
					}
					return cachedId;
				},
				getName:function(name) {
					if(!cachedName) {
						cachedName = storage.getItem(userName);
					}
					return cachedName || '';
				},
				getLastName:function(name) {
					if(!cachedLastName) {
						cachedLastName = storage.getItem(userLastName);
					}
					return cachedLastName || '';
				},
				getAvatar:function(avatar) {
					if(!cachedAvatar) {
						cachedAvatar = storage.getItem(userAvatar);
					}
					return cachedAvatar;
				},
				getAitools:function() {
					if(!cachedAitools) {
						cachedAitools = storage.getItem(aitools)? JSON.parse(storage.getItem(aitools)) : [];
					}
					return cachedAitools;
				},
				isAuthenticated:function() {
					return !!authToken.getToken(); //return true if get from getToken
				},
				removeToken: function() {
					cachedName = null;
					cachedAvatar =  null;
					cachedId =  null;
					cachedroleId = null;
					storage.removeItem(userAvatar);
					storage.removeItem(refreshToken);
					storage.removeItem(userName);
					storage.removeItem(userLastName);
					storage.removeItem(userToken);
					storage.removeItem(userId);
					storage.removeItem(roleId);
					storage.removeItem(aitools);
				}
			}
			return authToken;
		}
	}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('checkArray', checkArray);
		checkArray.$inject = [];
		function checkArray() {
		   return {
			   	contains : function(needle) {
				    // Per spec, the way to identify NaN is that it is not equal to itself
				    var findNaN = needle !== needle;
				    var indexOf;
	
				    if(!findNaN && typeof Array.prototype.indexOf === 'function') {
				        indexOf = Array.prototype.indexOf;
				    } else {
				        indexOf = function(needle) {
				            var i = -1, index = -1;
	
				            for(i = 0; i < this.length; i++) {
				                var item = this[i];
	
				                if((findNaN && item !== item) || item === needle) {
				                    index = i;
				                    break;
				                }
				            }
	
				            return index;
				        };
				    }
				    return indexOf.call(this, needle) > -1;
				},
				removeDuplicate : function(arr) {
					var newArray = arr.filter( function( item, index, inputArray ) {
				           return inputArray.indexOf(item) == index;
				    });
				    return newArray
				},
				removeObjArryDuplicate: function(arr) {
					var newArry = arr.filter(function(item, index, inputArray){
						 return index === inputArray.findIndex(function(element) {
							return element._id == item._id
						})
						
					})
					return newArry
				},
				sortArrayByIdPredefined: function(arr1,arr2) {
					var sortInsert = function (acc, cur) {
						var toIdx = arr2.indexOf(cur._id.toString());
						if(toIdx>=0) {
							acc[toIdx] = cur;
						}
						return acc;
					};
				   	return arr1.reduce(sortInsert, []).filter(function(el){return el!=null})
				},
				reconstructArrayByAncestors: function(flatArray) {
					flatArray = angular.copy(flatArray)
					var roots = [];
					flatArray.forEach(function(obj) {
						if (obj.ancestors && obj.ancestors.length > 0) {
							var parent = obj.ancestors.reduce(function(acc, ancestorId) {
								return acc.children.find(function(child){ return child.objId === ancestorId}) || acc
							}, { children: roots });
						
							if (!parent.children) {
								parent.children = [];
							}
						
							parent.children.push(obj);
						} else {
							roots.push(obj);
						}
					});
					
					return roots;
				}
		   }
		}
	}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('cleanArray', cleanArray);
		cleanArray.$inject = [];
		function cleanArray() {
		   return {
			   	clean : function(test_array) {
				   	var index = -1,
				        arr_length = test_array ? test_array.length : 0,
				        resIndex = -1,
				        result = [];
	
				    while (++index < arr_length) {
				        var value = test_array[index];
	
				        if (value) {
				            result[++resIndex] = value;
				        }
				    }
	
				    return result;
		        }
		   }
		}
	}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('cleanObj', cleanObj);
		cleanObj.$inject = [];
		function cleanObj() {
		   return {
			   	clean : function(obj) {
				   	for (var propName in obj) { 
			    		if (obj[propName] === null || obj[propName] === undefined) {
			      				delete obj[propName];
			    		}
				  	}
		        }
		   }
		}
	}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('comunicateBetweenViews', comunicateBetweenViews);
		comunicateBetweenViews.$inject = [];
		function comunicateBetweenViews() {
		   	var category;
		   	var tag;
		   	var author;
			var store;
			var service = {
			   	'setCategory':function(data) {
			   		category = data;
			   	},
			   	'getCategory':function() {
			   		return category 
			   	},	
			   	'setTag': function(data) {
			   		tag = data 
			   		
			   	},
			   	'getTag':function() {
			   		return tag
			   	},
			   	'setAuthor': function(data) {
			   		author = data
			   	},
			   	'getAuthor': function() {
			   		return author
			   	},
				'setStore': function(data) {
					store = data
				},
				'getStore': function() {
					return store
				}
			}
			return service 
		}
	}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('copyLink', copyLink);
		copyLink.$inject = ['$timeout'];
		function copyLink($timeout) {
		    return function(event, copyValue, toltipText,toltipEle) {
	            if(document.querySelector('.'+toltipEle)) return
	            var element = event.currentTarget;
	            var textArea = document.createElement("textarea");
	            textArea.style.position = 'fixed';
	            textArea.style.top = 0;
	            textArea.style.left = 0;
	            textArea.style.width = '0.4em';
	            textArea.style.height = '0.4em';
	            textArea.style.padding = 0;
	            textArea.style.border = 'none';
	            textArea.style.outline = 'none';
	            textArea.style.boxShadow = 'none';
	            textArea.style.background = 'transparent';
	            textArea.value = copyValue;
	            textArea.class = 'copy-textarea';
	            if (!document.querySelector("textarea.copy-textarea")) {
	                document.body.appendChild(textArea);
	            }
	            textArea.select();
	            document.execCommand("Copy");
	            document.body.removeChild(textArea);
	            if(!document.querySelector('.'+toltipEle)) {
	                var copiedTitle = document.createElement("span");
	                copiedTitle.innerText = toltipText;
	                copiedTitle.classList.add(toltipEle, 'toltip-el');
	                element.appendChild(copiedTitle);
	            }
	            $timeout(function() {
	                if(document.querySelector('.'+toltipEle)) {
	                    document.querySelector('.'+toltipEle).parentNode.removeChild(document.querySelector('.'+toltipEle));
	                }
	            },1500)
	        }
		}
	}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = function(service) {
	    'use strict';
	    service.factory('countCharacters',countCharacters);
		countCharacters.$inject=['editorExludeShortcode'];
		function countCharacters(editorExludeShortcode) {
	            return function(content) {
	                if(!content) return 0;
	                var cleanContent = editorExludeShortcode(content)
	        // Remove HTML tags but keep their content
	                    .replace(/<[^>]*>/g, '')
	                    // Decode HTML entities
	                    .replace(/&nbsp;/g, ' ')
	                    .replace(/&amp;/g, '&')
	                    .replace(/&lt;/g, '<')
	                    .replace(/&gt;/g, '>')
	                    .replace(/&quot;/g, '"')
	                    // Remove extra whitespace
	                    .replace(/\s+/g, ' ')
	                    .trim();
	                // Create temporary element to decode HTML entities
	                var txt = document.createElement("textarea");
	                txt.innerHTML = cleanContent;
	                // Get decoded text
	                var decodedText = txt.value;
	                
	                return decodedText.length;
	            }
	    }
	};  

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('createRandomHash', createRandomHash);
		createRandomHash.$inject = [];
		function createRandomHash() {
		   return function(length) {
				var result           = '';
			   	var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			   	var charactersLength = characters.length;
			   	for ( var i = 0; i < length; i++ ) {
			      result += characters.charAt(Math.floor(Math.random() * charactersLength));
			   	}
			   	return result;
		   }
		}
	}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('cyrilicToLatin',cyrilicToLatin);
		cyrilicToLatin.$inject=[];
		function cyrilicToLatin() {
			return  function(text) {
	            // Define a mapping of Cyrillic to Latin characters
	            var cyrillicToLatinMap = {
	                'А': 'A', 'а': 'a',
	                'Б': 'B', 'б': 'b',
	                'В': 'V', 'в': 'v',
	                'Г': 'G', 'г': 'g',
	                'Д': 'D', 'д': 'd',
	                'Ђ': 'Đ', 'ђ': 'đ',
	                'Е': 'E', 'е': 'e',
	                'Ж': 'Ž', 'ж': 'ž',
	                'З': 'Z', 'з': 'z',
	                'И': 'I', 'и': 'i',
	                'Ј': 'J', 'ј': 'j',
	                'К': 'K', 'к': 'k',
	                'Л': 'L', 'л': 'l',
	                'Љ': 'Lj', 'љ': 'lj',
	                'М': 'M', 'м': 'm',
	                'Н': 'N', 'н': 'n',
	                'Њ': 'Nj', 'њ': 'nj',
	                'О': 'O', 'о': 'o',
	                'П': 'P', 'п': 'p',
	                'Р': 'R', 'р': 'r',
	                'С': 'S', 'с': 's',
	                'Т': 'T', 'т': 't',
	                'Ћ': 'Ć', 'ћ': 'ć',
	                'У': 'U', 'у': 'u',
	                'Ф': 'F', 'ф': 'f',
	                'Х': 'H', 'х': 'h',
	                'Ц': 'C', 'ц': 'c',
	                'Ч': 'Č', 'ч': 'č',
	                'Џ': 'Dž', 'џ': 'dž',
	                'Ш': 'Š', 'ш': 'š'
	            };
	        
	            // Use regex to replace Cyrillic characters with Latin characters
	            return text.replace(/[АаБбВвГгДдЂђЕеЖжЗзИиЈјКкЛлЉљМмНнЊњОоПпРрСсТтЋћУуФфХхЦцЧчЏџШш]/g, function(match) {
	                return cyrillicToLatinMap[match] || match;
	            });
	        }
		}
	}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		service 
	  .factory("deleteDataService", deleteDataService);
	  deleteDataService.$inject = ['$resource','API_URL'];
	  function deleteDataService($resource, API_URL) {
	   var data = $resource(API_URL+ ":param1/:param2/:param3", {param1:"@param1", param2:'@param2',param3:'@param3'} ,{
	      state: "open"
	    }, {
	      remove: {
	        method: "DELETE"
	      }
	    });
	   return data;
	  }
	}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.service('downloadImage',downloadImage);
		downloadImage.$inject=[];
		function downloadImage() {
			return function(imgObj) {
	            if(!imgObj || !imgObj.file) return
	            var match = imgObj.file.match(/[^/]+$/);
	            var fileName = match[0];
	            if(!fileName) return
	            fetch(imgObj.file)
	            .then(function(response){ return response.blob()})
	            .then(function(imageBlob) {
	                var imageURL = URL.createObjectURL(imageBlob);
	                var link = document.createElement('a');
	                link.href = imageURL;
	                link.download = fileName;
	                document.body.appendChild(link);
	                link.click();
	                document.body.removeChild(link);
	                // Revoke the object URL to free up memory
	                URL.revokeObjectURL(imageURL);
	            })
	            .catch(function(error){
	                console.error('Error fetching or processing the image:', error);
	            });
			}
		}
	}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('downloadPdf',downloadPdf);
		downloadPdf.$inject=['authtokenService','$timeout'];
		function downloadPdf(authtokenService,$timeout) {
	        return function(approval) {
	            var token = authtokenService.getToken();
	            var getPdfFunction = function() {
	                if(!approval.url) return
	                var req = new XMLHttpRequest();
	                var filename = (approval.title)? slugify(approval.title) + '.pdf':'approval.pdf';
	                req.open("GET", approval.url, true);
	                req.setRequestHeader('x-auth', token)
	                req.responseType = "blob";
	                req.onload = function (event) {
	                    var blob = req.response;
	                    var link=document.createElement('a');
	                    link.href=window.URL.createObjectURL(blob);
	                    link.style = "display: none";
	                document.body.appendChild(link);  
	                    link.download=filename;
	                    link.click();
	                    $timeout(function(){
	                        document.body.removeChild(link);
	                    },0)
	                };
	                req.send();
	            }
	            getPdfFunction();
	        }
		}
	}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('durationFormated', durationFormated);
		durationFormated.$inject = [];
		function durationFormated() {
		    return function(duration) {
	            if(!duration) return;
	            var formatedTime;
	            if(duration>=3600) {
	                formatedTime = 'H:mm:ss'
	            } else{
	                formatedTime = 'm:ss'
	            } 
	            return moment().startOf('day').second(duration).format(formatedTime);
	            
		    }
		}
	}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = function(service) {
	    'use strict';
	    service.factory('editorExludeShortcode',editorExludeShortcode);
		editorExludeShortcode.$inject=[];
		function editorExludeShortcode() {
	            return function(content,aiRequest) {
	                if(!content) return '';
	                var cleanContent = content
	                // Remove custom elements first (using [\s\S] instead of . for multiline)
	                .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, '')
	                .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, '')
	                .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, '')
	                // Remove shortcodes that remain in visual mode
	                .replace(/\[video[^\]]*\]/g, '')
	                .replace(/\[poll[^\]]*\][\s\S]*?\[\/poll\]/g, '')
	                .replace(/\[rating[^\]]*\][\s\S]*?\[\/rating\]/g, '')
	                .replace(/\[quote[^\]]*\]([\s\S]*?)\[\/quote\]/g, '<blockquote>$1</blockquote>')
	                .replace(/\[readalso[^\]]*\][\s\S]*?\[\/readalso\]/g, '')
	                .replace(/\[liveblog[^\]]*\][\s\S]*?\[\/liveblog\]/g, '')
	                if(aiRequest) {
	                    cleanContent = cleanContent.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '');
	                } else {
	                    // For non-AI case, process summary blocks
	                    cleanContent = cleanContent.replace(/<summaryblock>\[summary\]([\s\S]*?)\[\/summary\]<\/summaryblock>/g, function(match, content) {
	                        // Split by |*| and wrap each part in paragraph
	                        var facts = content.split(/\|\*\|/).filter(function(fact) {
	                            return fact.trim();
	                        });
	                        var formattedContent = facts.map(function(fact) {
	                            return '<p>' + fact.trim() + '</p>';
	                        }).join('');
	                        return formattedContent;
	                    });
	                }
	                return cleanContent;
	            }
	    }
	};  


/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('elasticSearch', elasticSearch);
		elasticSearch.$inject = ['cleanArray','config'];
		function elasticSearch(cleanArray,config) {
			return {
				'getUrl': function(searchData) {
					// skidanje celih reci koje u sebi sadrze specijalne karaktere
					searchData = searchData.replace(/\b[a-zA-Z0-9ćĆčČđĐšŠžŽ]*[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]+[a-zA-Z0-9ćĆčČđĐšŠžŽ]*\b/g, '');
					
					// skidanje svih specijalnih karaktera za elastic search
					searchData = searchData.replace(/[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]/g, '')
					
					// trim removes whitespace from both ends of this string
					searchData = searchData.trim()
	
					// splits the string by one or more whitespace characters into an array of words.
					var words = searchData.split(/\s+/);
					
		          	cleanArray.clean(words);
		          	var postSearch = '';
		          	for(var i=0;i<words.length;i++) {
			            if(i==0) { 
			              if(!isNaN(words[i])) {
			                if(words[i].length>=5) {
			                  postSearch = 'id:'+ words[i]+'*';
			                } else {
			                //   if(parseInt(words[i])>moment().date()) {
			                //     var month = moment().month();
			                //   } else {
			                //     var month = moment().month()+1;
			                //   }
			                //   if(month<=9) {
			                //     month='0'+month;
			                //   }
			                //   var year = moment().year();
			                //   postSearch = 'post_date:'+ words[0]+ '.'+month+'.'+year;
								if(words[i].indexOf("*")==-1) {
									words[i] += '*';
								}
								postSearch = postSearch.concat('post_title:' + words[i]);
								}
			              }else {
			                  if(words[i].indexOf("*")==-1) {
			                    words[i] += '*';
			                  }
			                postSearch = postSearch.concat('post_title:' + words[i]);
			              }
			            } else {
			              if(words[i].indexOf("*")==-1) {
			                words[i] += '*';
			              }
			              postSearch = postSearch.concat('%20AND%20post_title:' + words[i]);
			            }
		        	}
	          		var url = config.baseElasticSearchHref+'_search?q='+ postSearch+ '&sort=uts:desc';
					return url
				}
			}
		   	 
		}
	}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('escapeElastic', escapeElastic);
		escapeElastic.$inject = [];
		function escapeElastic() {
		   	return function(content) {
				content = content.replace(/\//g, " ");
	          	content = content.replace(/\+/g, "\\\+");
	          	content = content.replace(/\=/g, "\\\=");
	          	content = content.replace(/\-/g, "\\\-");
	          	content = content.replace(/\|\|/g, "\\\|\\\|");
	          	content = content.replace(/\>/g, "\\\>");
	          	content = content.replace(/\</g, "\\\<");
	          	content = content.replace(/\!/g, "\\\!");
	          	content = content.replace(/\(/g, "\\\(");
	          	content = content.replace(/\)/g, "\\\)");
	          	content = content.replace(/\{/g, "\\\{");
	          	content = content.replace(/\}/g, "\\\}");
	          	content = content.replace(/\[/g, "\\\[");
	          	content = content.replace(/\]/g, "\\\]");
	          	content = content.replace(/\?/g, "\\\?");
	          	content = content.replace(/\"/g, "\\\"");
	          	content = content.replace(/\*/g, "\\\*");
	          	content = content.replace(/\~/g, "\\\~");
	          	content = content.replace(/\&\&/g, "\\\&\\\&");
	          	content = content.replace(/\^/g, "\\\^");
		        return content;
		   }
		}
	}


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('eventStream',eventStream);
		eventStream.$inject=['config','$rootScope','$timeout','getConfigData'];
		function eventStream(config, $rootScope, $timeout, getConfigData) {
			
			var eventStreamService = {
				connections: {}, // Store multiple connections by name
				
				// Connect to EventSource with custom URL
				connect: function(connectionName, url, options) {
					// Don't connect if already connected
					if (this.connections[connectionName]) {
						return;
					}
					
					options = options || {};
					
					// Store connection info
					this.connections[connectionName] = {
						name: connectionName,
						url: url,
						connection: null,
						connected: false,
						messageHandlers: [],
						options: options
					};
					
					this._createConnection(connectionName);
				},
				
				// Create the actual EventSource connection
				_createConnection: function(connectionName) {
					var connection = this.connections[connectionName];
					if (!connection) return;
	
					try {
						// Create EventSource without authentication
						connection.connection = new EventSource(connection.url);
						this._setupEventHandlers(connectionName);
					} catch (error) {
						console.log(error);
					}
				},
				
				// Setup event handlers for a connection
				_setupEventHandlers: function(connectionName) {
					var self = this;
					var connection = this.connections[connectionName];
					if (!connection) return;
					// Connection opened
					connection.connection.onopen = function(event) {
						connection.connected = true;
						$rootScope.$apply(function() {
							$rootScope.eventStreamError = false;
						});	
						// // Emit connection event
						// $rootScope.$emit('eventStream:connected', { 
						// 	connectionName: connectionName,
						// 	url: connection.url 
						// });
					};
					
					// Message received
					connection.connection.onmessage = function(event) {
						try {
							var data = JSON.parse(event.data);
							self._handleMessage(connectionName, data);
						} catch (error) {
							
						}
					};
					
					// Error occurred
					connection.connection.onerror = function(event) {
						connection.connected = false;
						// If connection is closed (redyState === 2) 
						// 1. because of server error we createConnection again (reconnect)
						// 2. if is intentionaly disconnect and close connection, createConnection will return because there will not be this this.connections[connectionName]
						// if (readyState === 0) we are not connected to server (internet connection lost) and eventSource reconnect automatically
						if(connection.connection.readyState === 2) {
							$timeout(function() {
								connection.connection.close();
								connection.connection = null;
								self._createConnection(connectionName);
							}, 2000);
						}
			
						$rootScope.$apply(function() {
							$rootScope.eventStreamError = true;
							// get fresh config data for focus connection
							if(connection.name == 'focus') {
								getConfigData.getData('focus_stream');
							}
						});
					};
				},
				
				// Handle incoming messages for a connection
				_handleMessage: function(connectionName, data) {
					var connection = this.connections[connectionName];
					if (!connection) return;
					
					// Call all registered message handlers for this connection
					connection.messageHandlers.forEach(function(handler) {
						try {
							handler(data, connectionName);
						} catch (error) {
							
						}
					});
					
					// // Emit message event for backward compatibility
					// $rootScope.$emit('eventStream:message', { 
					// 	connectionName: connectionName,
					// 	data: data 
					// });
				},
				
	
				
				// Disconnect from a specific connection
				disconnect: function(connectionName) {
					var connection = this.connections[connectionName];
					
					if (connection && connection.connection) {
						connection.connection.close();
						delete this.connections[connectionName];
						
					}
				},
				
				// Disconnect from all connections
				disconnectAll: function() {
					var self = this;
					Object.keys(this.connections).forEach(function(connectionName) {
						self.disconnect(connectionName);
					});
				},
				
				// Add message handler for a specific connection
				onMessage: function(connectionName, handler) {
					var connection = this.connections[connectionName];
					if (connection && typeof handler === 'function') {
						connection.messageHandlers.push(handler);
					}
				},
				
				// Remove message handler for a specific connection
				offMessage: function(connectionName, handler) {
					var connection = this.connections[connectionName];
					if (connection) {
						var index = connection.messageHandlers.indexOf(handler);
						if (index > -1) {
							connection.messageHandlers.splice(index, 1);
						}
					}
				},
				hasMessageHandler: function(connectionName, handler) {
					var connection = this.connections[connectionName];
					if (connection) {
						return connection.messageHandlers.includes(handler);
					}
					return false;
				},
				// Get connection status
				getConnectionStatus: function(connectionName) {
					var connection = this.connections[connectionName];
					return connection ? {
						connected: connection.connected,
						url: connection.url
					} : null;
				},
				
				// Check if a connection is connected
				isConnected: function(connectionName) {
					var connection = this.connections[connectionName];
					return connection ? connection.connected : false;
				},
				
				// Get all connection names
				getConnectionNames: function() {
					return Object.keys(this.connections);
				},
				getConnection: function(connectionName) {
					return this.connections[connectionName];
				},
				
			};
			
			// Cleanup on page unload
			window.addEventListener('beforeunload', function() {
				eventStreamService.disconnectAll();
			});
			
			return eventStreamService;
		}
	}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('fileReaderImage', fileReaderImage);
		fileReaderImage.$inject = [];
		function fileReaderImage() {
		    return function(file,cb) {
	            var reader = new FileReader();
	            reader.onload = function(event) {
	                var img = new Image();
	                img.onload = function() {
	                    var width = img.width;
	                    var height = img.height;
	                    cb(width, height)
	                };
	                img.src = event.target.result;
	            }
	            reader.readAsDataURL(file);
	            
		    }
		}
	}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('getConfigData',getConfigData);
		getConfigData.$inject=['getDataService','serverError','alertService','config','refreshtokenService','$timeout','$state','authtokenService','$rootScope','offlineError'];
		function getConfigData(getDataService,serverError,alertService,config, refreshtokenService,$timeout,$state,authtokenService,$rootScope,offlineError) {
	        return {
	            getData: function(type){
	                return getDataService.get({param1:'config'}).$promise.then(function(data){
	                    config.setConfig(data, type);
	                }, function(error){
	                    // Handle connection refused errors (status -1)
	                    //net::ERR_CONNECTION_REFUSED → error.status = -1
	                    //Server is down or not accepting connections
	                    //Wrong port or firewall blocking
	                    //Server overloaded and refusing connections
	
	                    //net::ERR_INTERNET_DISCONNECTED → error.status = -1
	                    //User is completely offline
	                    //No internet connection available
	                    //Network adapter disabled
	
	                    if(error.status === -1) {
	                        if(!window.navigator.onLine) {
	                            var refresh;
	                            if(type=='init') {
	                                refresh = 'refresh';
	                            }
	                            offlineError(refresh);
	                        } else {
	                            if(type=='init') {
	                                $rootScope.alerts = [];
	                                $rootScope.alertShow = false;
	                                authtokenService.removeToken();
	                                $state.go('login');
	                                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                            }
	                        }
	                        return;
	                    }
	                    
	                    if(error.status ==401) {
	                        var promise = refreshtokenService.getAccessToken();
	                        promise.then(
	                        function(answer) {
	                            if(answer==200) {   
	                                // The 'return' here ensures that the Promise chain correctly returns
	                                // the retried getData call, allowing callers to use .then() as expected
	                                return getConfigData.getData(type);
	                            }
	                        },
	                        function(error) {
	                        },
	                        function(progress) {
	                            // report progress
	                        });
	                    } else if(error.status ==502) {
	                        serverError()
	                    } else {
	                        alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                    }
	                })
	            }
	        }
		}
	}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		service 
	  .factory("getDataService", getDataService);
	  getDataService.$inject = ['$resource','API_URL','$rootScope'];
	  function getDataService($resource,API_URL,$rootscope) {
	   var data = $resource(API_URL+ ":param1/:param2/:param3/:param4", {param1:"@param1", param2:'@param2', param3:'@param3',param4:'@param4'} ,{
	      state: "open"
	    }, {
	      get: {
	        method: "GET"
	        
	      }
	    });
	  
	   return data;
	  }
	}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('getIspTitle', getIspTitle);
		getIspTitle.$inject = [];
		function getIspTitle() {
		   return function(title) {
	            if(!title) return;
	            if(title.includes("isp.", 0)) {
	                title = title.substring(4, title.length)
	            }
	            return title.split('_').join(' ')
	        }
		}
	}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('getMicrositesBaseOnUrl', getMicrositesBaseOnUrl);
		getMicrositesBaseOnUrl.$inject = ['config'];
		function getMicrositesBaseOnUrl(config) {
		    return function(url) {
	            if(!config.microsites || config.microsites.length==0) return 'telegraf'
	            for(var i = 0; i<config.microsites.length;i++) {
	                if(url.includes(config.microsites[i].baseurl)) {
	                    return config.microsites[i]._id 
	                }
	            }
	            return 'telegraf'
		    }
		}
	}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('getSubstringBetween', getSubstringBetween);
		getSubstringBetween.$inject = [];
		function getSubstringBetween() {
		    return function(string, startSubstring, endSubstring) {
	            if (startSubstring && endSubstring) {
	                var startIndex = string.indexOf(startSubstring);
	                if (startIndex === -1) {
	                    return null; // Start substring not found
	                }
	                var endIndex = string.indexOf(endSubstring, startIndex + startSubstring.length);
	                if (endIndex === -1) {
	                    return null; // End substring not found after start substring
	                }
	                return string.substring(startIndex + startSubstring.length, endIndex);
	            } else if (startSubstring) {
	                var startIndex = string.indexOf(startSubstring);
	                if (startIndex === -1) {
	                    return null; // Start substring not found
	                }
	                return string.substring(startIndex + startSubstring.length);
	            } else {
	                return null; // No substring provided
	            }    
		    }
		}
	}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('highlightWords',highlightWords);
		highlightWords.$inject=[];
		function highlightWords() {
			return  function(text,words) {
	            words.forEach(function(word) {
	                var pattern = new RegExp('(?<![ČĆĐŠŽčćđšž\\w])('+word+')(?![ČĆĐŠŽčćđšž\\w])', 'gi');
	                text = text.replace(pattern, '<mark>$1</mark>');
	            });
	            return text;
	        }
		}
	}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('jQuery', jQueryService);
		jQueryService.$inject = ['$window'];
	
		function jQueryService($window) {
		   return $window.jQuery; // assumes jQuery has already been loaded on the page
		}
	}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('jwtDecoderService', jwtDecoderService);
		jwtDecoderService.$inject = [];
		
		function jwtDecoderService() {
			var jwtDecoder = {
				// Decode JWT token and return payload
				decodeToken: function(token) {
					if (!token) {
						return null;
					}
					
					try {
						// Split the token into parts
						var parts = token.split('.');
						if (parts.length !== 3) {
							return null;
						}
						
						// Decode the payload (second part)
						var payload = parts[1];
						
						// Add padding if needed
						while (payload.length % 4) {
							payload += '=';
						}
						
						// Decode base64 and parse JSON
						var decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
						return JSON.parse(decodedPayload);
					} catch (error) {
						console.error('Error decoding JWT token:', error);
						return null;
					}
				},
				
				// Get expiration date from token
				getExpirationDate: function(token) {
					var payload = this.decodeToken(token);
					if (!payload || !payload.exp) {
						return null;
					}
					
					// Convert Unix timestamp to Date object
					return new Date(payload.exp * 1000);
				},
				
				// Check if token is expired
				isTokenExpired: function(token) {
					var expirationDate = this.getExpirationDate(token);
					if (!expirationDate) {
						return true; // Consider invalid tokens as expired
					}
					
					return new Date() > expirationDate;
				},
				
				// Get time until expiration in milliseconds
				getTimeUntilExpiration: function(token) {
					var expirationDate = this.getExpirationDate(token);
					if (!expirationDate) {
						return 0;
					}
					
					return expirationDate.getTime() - new Date().getTime();
				},
				
				// Get user ID from token
				getUserId: function(token) {
					var payload = this.decodeToken(token);
					return payload ? payload.user_id || payload.sub || payload.id : null;
				},
				
				// Get all claims from token
				getClaims: function(token) {
					return this.decodeToken(token);
				}
			};
			
			return jwtDecoder;
		}
	} 

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('keyPressOnlyNumberAndDot', keyPressOnlyNumberAndDot);
		keyPressOnlyNumberAndDot.$inject = [];
		function keyPressOnlyNumberAndDot() {
		   return function(evt) {
				evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
			    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
			        evt.preventDefault();
			    }
		   }
		}
	}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('keyPressOnlyNumberAndEnter', keyPressOnlyNumberAndEnter);
		keyPressOnlyNumberAndEnter.$inject = [];
		function keyPressOnlyNumberAndEnter() {
		   return function(evt,enterCb,searchdata) {
				evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
	            if(charCode == 13) {
	                enterCb(searchdata)
	            }
			    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			        evt.preventDefault();
			    }
		   }
		}
	}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('keyPressOnlyNumber', keyPressOnlyNumber);
		keyPressOnlyNumber.$inject = [];
		function keyPressOnlyNumber() {
		   return function(evt) {
				evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
			    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			        evt.preventDefault();
			    }
		   }
		}
	}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('keyPress', keyPress);
		keyPress.$inject = [];
		function keyPress() {
		   return function(evt,star) {
				evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
			    if(star) {
				    if (charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode != 45 && charCode != 42 && charCode != 269 && charCode != 263 && charCode != 382 && charCode != 353 && charCode != 273 && charCode != 268 && charCode != 262 && charCode != 381 && charCode != 352 && charCode != 272) {
				        evt.preventDefault();
				    }
			    } else {
			      	if (charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode != 269 && charCode != 263 && charCode != 382 && charCode != 353 && charCode != 273 && charCode != 268 && charCode != 262 && charCode != 381 && charCode != 352 && charCode != 272 && charCode !=95) {
				        evt.preventDefault();
				    }
			    }
		   }
		}
	}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('keyPressSlugify', keyPressSlugify);
		keyPressSlugify.$inject = [];
		function keyPressSlugify() {
		   return function(evt) {
				evt = (evt) ? evt : event;
			    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
			    ((evt.which) ? evt.which : 0));
			    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=45 && charCode!=95 && (charCode<97 || charCode>122)) {
			        evt.preventDefault();
			    }
		   }
		}
	}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('navigationService',navigationService);
		navigationService.$inject=['$rootScope','getDataService','refreshtokenService','serverError','offlineError'];
		function navigationService($rootScope, getDataService,refreshtokenService,serverError,offlineError) {
				var navigation = {
			
				getNavigation: function() {
					var getNavigationFunction = function() {
						getDataService.get({param1:'options', param2: "dashboard", param3:"navigation"}).$promise.then(function(dataNavigation){
							$rootScope.navigation = dataNavigation.navigation;
							return $rootScope.navigation
						},function(error) {
							if(!window.navigator.onLine) {
								offlineError('refresh')
								return
							}
							if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
					          	promise.then(
					            function(answer) {
					            	if(answer == 200) {
										getNavigationFunction();
					            	}
								},
					            function(error) {
					              // report something
					            },
					            function(progress) {
					             // report progress
					          });
							} else if(error.status ==502) {
								serverError();
							}
						});
					}		
					getNavigationFunction();	
				}
			}
			return navigation	
		}
	}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.service('offlineError',offlineError);
		offlineError.$inject=['$rootScope','$interval','$window'];
		function offlineError($rootScope,$interval,$window) {
			var offlineErrorInterval;
			return function(cb) {
	            if($rootScope.offlineError) return
	            $rootScope.offlineError = true;
	            offlineErrorInterval = $interval(function() {
	                if(window.navigator.onLine) {
	                    $interval.cancel(offlineErrorInterval);
	                    offlineErrorInterval = null;
	                    $rootScope.offlineError = false;
	                    if(cb && typeof cb === "function") {
	                        cb()
	                    } else if(cb=='refresh') {
	                        $window.location.reload();
	                    }
	                }
	            },1000);
			}
		}
	}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('parseOptions', parseOptions);
		parseOptions.$inject = [];
		function parseOptions() {
		   return function (stringOptions) {
	        var options = {}, set;
	        if (!stringOptions) { return; }
	        set = stringOptions
	            .replace(/(\w+=")/g, '\n$1')
	            .split('\n');
	            set.shift();
	  
	        for (var i = 0; i < set.length; i++) {
	            var kv = set[i].split('="');
	            options[kv[0]] = kv[1].replace(/\'|\"/g, '').trim();
	        }
	        return options;
	      };
		}
	}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		service 
	  .factory("postDataService", postDataService);
	  postDataService.$inject = ['$resource','API_URL'];
	  function postDataService($resource, API_URL) {
	   var data = $resource(API_URL+ ":param1/:param2/:param3/:param4/:param5", {param1:"@param1", param2:'@param2',param3:'@param3',param3:'@param4', param3:'@param5'} ,{
	      state: "open"
	    }, {
	      get: {
	        method: "POST"
	      }
	    });
	   return data;
	  }
	}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		service 
	  .factory("putDataService", putDataService);
	  putDataService.$inject = ['$resource','API_URL'];
	  function putDataService($resource, API_URL) {
	    var data = $resource(API_URL+ ":param1/:param2/:param3/:param4", {param1:"@param1", param2:'@param2',param3:'@param3', param4:"@param4"} ,{
	       
	          update:{
	            method:'PUT'
	         }
	      })
	    // ).update(
	    //   {},
	    //     <BODY_OBJECT>,
	    //     function (successResponse) {},
	    //     function (failResponse) {}
	    // );
	    return data;
	  }
	}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('refreshtokenService',refreshtokenService);
		refreshtokenService.$inject=['$rootScope','$timeout','$state','$window','authtokenService','alertService', 'serverError','postDataService'];
		function refreshtokenService($rootScope, $timeout, $state, $window, authtokenService,alertService, serverError,postDataService) {
			var refreshToken = {
				getAccessToken : function() {
					var status;
					var userId = parseInt(authtokenService.getUserId());
					 return postDataService.save({param1:'auth', param2: 'renewToken'},{'user_id': parseInt(userId)}).$promise.then(function(data){
						authtokenService.setToken(data.access_token);
					 	status = 200;
					 	return status;
					},function(error) {
						if(error.status ==401) {
							$rootScope.isLogout = true;
							authtokenService.removeToken();
							$rootScope.alerts = [];
							$rootScope.alertShow = false;
							$state.go('login');
							status = 401;
						} else if(error.status ==502) {
							// if(!$rootScope.errorServerFlag) {
								serverError();
							// }
							// $rootScope.errorServerFlag = true;
							status = 502;
						}
						return status
					});		
					
				}
			}
			return refreshToken;
		}
	}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('removeFromOther',removeFromOther);
		removeFromOther.$inject=['deleteDataService','refreshtokenService','serverError','alertService','offlineError'];
		function removeFromOther(deleteDataService,refreshtokenService,serverError, alertService, offlineError) {
	        return function(url) {
	            var deleteFunction = function() {
	                deleteDataService.remove(url).$promise.then(function(data){ 
	                alertService('success','Success ', data.message, 2000);
	                }, function(error){
	                if(!window.navigator.onLine) {
	                    offlineError()
	                    $rootScope.hasLoaded = true;
	                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                    return
	                }
	                if(error.status ==401) {
	                    var promise = refreshtokenService.getAccessToken();
	                    promise.then(
	                    function(answer) {
	                        if(answer==200) {   
	                        deleteFunction();
	                        }
	                    },
	                    function(error) {
	                        // report something
	                    },
	                    function(progress) {
	                        // report progress
	                    });
	                }else if(error.status ==502) {
	                    serverError()
	                } else {
	                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	                }  
	                });
	            }
	            deleteFunction();
	        
	        }
		}
	}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('reqursiveService', reqursiveService);
		reqursiveService.$inject = [];
		function reqursiveService() {
		   return {
			   	getReqursiveArray :function(reqursiveObject) {
				   	var reqursiveArray = [];
		          	var print = function(categories) {
			            for (var i=0; i< categories.length; i++) {
			              reqursiveArray.push(categories[i]);
			              if(categories[i].children) {
			                print(categories[i].children);
			              }
			            }
		          	}
		          	print(reqursiveObject);
		          	return reqursiveArray
		        }
		   }
		}
	}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('reverseWpautop', reverseWpautop);
		reverseWpautop.$inject = [];
		function reverseWpautop() {
		   	return function(content) {
				// This removes leading empty paragraphs but keeps content-separating ones
				content = content.replace(/^(<p[^>]*>\s*(?:&nbsp;|\s)*<\/p>\s*)+/gi, "");
				// Replace <br> and <br /> with newlines
				content = content.replace(/<br>|<br \/>/g, "\n");
				content = content.replace(/<br data-mce-bogus="1">/g,"");
				// content = content.replace(/<\/blockquote>/g,'</blockquote>\n\n');
	
				// Special handling for HR tags - ensure double newlines for wpautop
				content = content.replace(/<\/p>\s*(<hr[^>]*>)/g, '\n\n$1'); // Before HR
				content = content.replace(/(<hr[^>]*>)\s*<p>/g, '$1\n\n'); // After HR
				content = content.replace(/(<hr[^>]*>)([^\n])/g, '$1\n\n$2'); // Catch any remaining text after HR
	
				content = content.replace(/<p [\s\w"\=-]*id="edit-image"[\s\w"\=-]*>[\s\w]*<\/p>/g,"<p></p>");
				content = content.replace(/<p([^>]*)><\/p>/g,"");
				content = content.replace(/<p([^>]*)><\/p>/g,"");
				content = content.replace(/<p>/gmi, "");
			   	content = content.replace(/<p ([^>]*)>/gmi, "");
				content = content.replace(/<\/p>/g, "\n\n");
				// content = content.replace(/(?<!&nbsp;)&nbsp;(?!&nbsp;)/g, " ");
				// if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ){
				// 	console.log(content);
	   //   			content = content.replace(/\n/g, "\r\n").replace(/\r\r/g, "\r");
	   //   			console.log('firerox')
	   //   			console.log(content);
				// } 
				var html_entity_decode = function (str){
				  	var ta=document.createElement("textarea");
				  	ta.innerHTML=str;
				  	return ta.value;
				}
				content = html_entity_decode(content)
		        return content;
		   }
		}
	}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.service('serverError',serverError);
		serverError.$inject=['$rootScope','$interval','$window'];
		function serverError($rootScope,$interval,$window) {
			var serverErrorInterval;
			return function() {
				if(!$rootScope.serverError.show) {
					$rootScope.serverError={
						'show': true,
						'i': 10
					}
					serverErrorInterval = $interval(function() {
						if($rootScope.serverError.i==0) {
							$interval.cancel(serverErrorInterval);
							$window.location.reload();
							return
						}
						$rootScope.serverError.i--;	
					},1000);
					$rootScope.retry = function() {
						$interval.cancel(serverErrorInterval);
						$window.location.reload();
					}
				}
			}
		}
	}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('slugifyValidator', slugifyValidator);
		slugifyValidator.$inject = [];
		function slugifyValidator() {
			return function(value) {
				var slugReg = /^(?!-)(?!_)(?!.*?-_)(?!.*?_-)(?!.*?--)(?!.*?__)(?!.*-$)(?!.*_$)[a-z0-9_-]+$/g
		    	return slugReg.test(value);
			}
	
		}
	}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = function(service) {
	    'use strict';
	    service.factory('stripHtml',stripHtml);
		stripHtml.$inject=[];
		function stripHtml() {
	        return function(html) {
	            if (!html) return '';
	            // Replace HTML tags with a space
	            var text = html.replace(/<[^>]*>/g, ' ');
	            // Normalize multiple spaces/newlines to a single space
	            text = text.replace(/\s+/g, ' ').trim();
	            return text;
	        }
	    }
	};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('tabSessionService', tabSessionService);
		tabSessionService.$inject = ['$window'];
		
		function tabSessionService($window) {
			var sessionStorage = $window.sessionStorage;
			var SESSION_ID_KEY = 'tabSessionId';
	
			// Cache tab type on load factory and cache session id after first call to getSessionId
			var sessionIdCache = '';
			var navType = $window.performance.navigation.type;
			
			// Generate a unique session ID
			function generateSessionId() {
				return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
			}
			
			// Check if this tab was duplicated
			function isTabDuplicated(navType) {
				// TYPE_NAVIGATE = 0 (new navigation/duplicated)
				// TYPE_RELOAD = 1 (reload)
				// TYPE_BACK_FORWARD = 2 (back/forward/duplicated tab firefox)
				
				if (navType !== 1) {
					// This is a new navigation, likely duplicated tab	
					return true;
				}
				return false;
			}
			
			// Get or create session ID for current tab
			function getSessionId() {
				if(sessionIdCache) {
					return sessionIdCache;
				}
				var sessionId = sessionStorage.getItem(SESSION_ID_KEY);
				// If no session ID exists, create one
				if (!sessionId) {
					sessionId = generateSessionId();
					sessionStorage.setItem(SESSION_ID_KEY, sessionId);
				}
				
				// If tab was duplicated, generate new session ID
				else if (isTabDuplicated(navType)) {
					sessionId = generateSessionId();
					sessionStorage.setItem(SESSION_ID_KEY, sessionId);
				}
				sessionIdCache = sessionId;
				
				return sessionId;
			}
			
			// Get session info for current tab
			function getSessionInfo() {
				var sessionId = getSessionId();
				
				return {
					sessionId: sessionId,
					isDuplicated: isTabDuplicated()
				};
			}
			
			return {
				getSessionId: getSessionId,
				getSessionInfo: getSessionInfo
			};
		}
	};

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.service('warningAlertService',warningAlertService);
		warningAlertService.$inject=['$rootScope','$timeout'];
		function warningAlertService($rootScope,$timeout) {
			return function(title,message,warningCallback,warningCallbackCancel) {
				$rootScope.warningAlert = {
	                title:title,
	                message:message,
	                warningCallback: warningCallback,
	                warningCallbackCancel: warningCallbackCancel,
	                show: true,
	                closeAlert: function(type) {
	                    this.show= false
	                    if(type !== 'confirm' && this.warningCallbackCancel) this.warningCallbackCancel();
	                }
	            }
			}
		}
	}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = function(service) {
		'use strict'
		service.factory('watchAllCheckboxesNgTable',watchAllCheckboxesNgTable);
		watchAllCheckboxesNgTable.$inject=[];
		function watchAllCheckboxesNgTable() {
	        return {
	            'watch': function(scope, ctrlAs, title, id) {
	                scope.$watch(function(){
	                    return ctrlAs.checkboxes.checked
	                }, function(newValue, oldValue){
	                    if (newValue!=oldValue) {
	                        ctrlAs.checkedPostsEdit = [];
	                        var idProp = '_id'
	                        if(id) {
	                            idProp = id
	                        }
	                        if(newValue) {
	                            if(ctrlAs.dataGet) {
	                                for (var i=0; i<ctrlAs.dataGet.length; i++){
	                                    if(!ctrlAs.dataGet[i].lock || Object.keys(ctrlAs.dataGet[i].lock).length == 0) {
	                                        ctrlAs.checkboxes.items[ctrlAs.dataGet[i][idProp]] = true;
	                                        if(title) {
	                                            ctrlAs.checkedPostsEdit.push(ctrlAs.dataGet[i]);
	                                        } else {
	                                            ctrlAs.checkedPostsEdit.push(ctrlAs.dataGet[i][idProp]);
	                                        }
	                                    }
	                                }
	                                console.log(ctrlAs.checkboxes.items);
	                            }
	                        } else {
	                            ctrlAs.checkboxes.items = {}
	                            if(title) {
	                                ctrlAs.cancelBulkEdit()
	                            }
	                        }
	                    }
	                },true);
	            },
	            resetCheckBox: function(ctrlAs) {
	                ctrlAs.checkboxes.checked = false;
	                ctrlAs.checkboxes.items = {};
	                ctrlAs.checkedPostsEdit = [];
	            }
	        }
		}
	}


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = function(users) {
		"use strict";
	  users
	  .controller('allusersController', allusersController)
		allusersController.$inject = ["comunicateBetweenViews","$timeout","$stateParams","$state","API_URL","$http","$scope","$rootScope","NgTableParams","getDataService",'jQuery','refreshtokenService','reqursiveService','serverError','alertService','offlineError'];
		
	    function allusersController(comunicateBetweenViews,$timeout,$stateParams,$state,API_URL,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,serverError,alertService, offlineError) {
	      var vmau = this;
	      var state = 'users';
	      var s;
	      var role;
	      var $data;
	      var page;
	      var status;
	      vmau.role = 'all';
	      vmau.selectedStatus = {'value':'all'};
	      $rootScope.hasLoaded = false;
	      vmau.editUserShow = false;
	      vmau.userId = $stateParams.id; 
	      if($stateParams.id) {
	        vmau.editUserShow = true;
	      } else {
	        vmau.editUserShow = false;
	      }
	      vmau.selectedRole = {value: 'all'}; 
	      vmau.selectedBulkAction = {value: 'default'};
	      vmau.deleteUserFunction = function(data) {
	        var deleteFunction = function() {
	          $http.delete(API_URL + state , data)
	          .success(function (data, status, headers) {
	              $rootScope.hasLoaded = true;
	              alertService('success','Success ', data.message, 2000);
	              vmau.tableParams.reload();
	          })
	          .error(function (data, status, header, config) {
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    deleteFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {  
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true; 
	          });
	        }
	        deleteFunction();
	      }
	      vmau.deleteUser = function(id) {
	        $rootScope.hasLoaded = false;
	        var dataIds = {
	          'ids':[id]
	        };
	        vmau.deleteUserFunction(dataIds);  
	      }
	      vmau.editUser = function(userId) {
	        vmau.editUserShow = true;
	        jQuery("html, body").animate({
	          scrollTop: 0
	        }, 600);
	        vmau.userId = userId;
	        $state.transitionTo('app.allusers', {id: vmau.userId}, {
	          location: true,
	          inherit: true,
	          relative: $state.$current,
	          notify: false
	        });
	      }
	      vmau.authorPosts = function(userId) {
	        comunicateBetweenViews.setAuthor(userId);
	        $state.go('app.allposts'); 
	      }
	      var getUsersFunction = function() {
	        getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
	          vmau.roles = data.roles;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                getUsersFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError();
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }  
	        });
	      }
	      vmau.switchStatusFilter = function(item) {
	          vmau.selectStatus = item;
	      }
	      vmau.changeSearch = function(search_data) {
	        vmau.switchSearch = true;
	        if(search_data) {
	          vmau.searchData = search_data;
	        } else {
	          vmau.searchData = null;
	          $timeout(function() {
	            vmau.search();
	          },0)            
	        }
	      }
	      vmau.tableActionsFunction = function(params) {
	        var reloadTableFunction = function() {
	          params.page(1);
	          vmau.tableParams.reload();
	        } 
	        vmau.resetAllFilters = function() {
	          vmau.role = 'all';
	          role = null;
	          vmau.searchData = null;
	          s =null;
	          status = null;
	          vmau.selectedStatus = {'value':'all'}
	          $scope.$broadcast('clear-daterange',true);
	          reloadTableFunction();
	        }
	        vmau.postFilter = function() {
	          s=vmau.searchData;
	          if (s) {
	            s = s.toLowerCase();
	          } else {
	            s = null;
	          }
	          status = vmau.selectStatus;
	          if (status == 'all') {
	              vmau.selectStatus = null;
	              status = null;
	          }
	          reloadTableFunction();
	        }
	
	        vmau.changeStatus = function(event,activeRole) {
	          vmau.role = activeRole;
	          if(activeRole) {
	            role = activeRole;
	          } 
	          if(activeRole=='all') {
	            role=null;
	          }
	          vmau.searchData = null;
	          s = null;
	          status = null;
	          vmau.selectedStatus = {'value':'all'}
	          $scope.$broadcast('clear-daterange',true);
	          reloadTableFunction();
	        }
	        vmau.search =function(value) {
	          if(value) {  
	            s = value.toLowerCase();
	          } else {
	            s = null;
	          }
	          // role= null;
	          reloadTableFunction();
	        }
	      }
	      vmau.tableReloadFunction = function(page) {
	        vmau.tableParams = new NgTableParams({
	            page: page || 1,
	            count: 20,
	            
	        }, {
	        getData: function(params) {
	          
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,   
	            s:s,
	            role: role,
	            page: params.page(),
	            limit: params.count(),
	            status: status,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            }).$promise.then(function(data){
	            $rootScope.emptyTable = false;
	            $rootScope.hasLoaded = true;
	            $data = data.users; 
	            if(data.users.length == 0) {
	              $rootScope.emptyTable = true;
	            } 
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            vmau.tableActionsFunction(params);
	            getUsersFunction();
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                 
	                  if(answer==200) {
	                    vmau.tableReloadFunction(params.page());
	                  }
	                  // do something
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                 // report progress
	                });
	            }else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	            }
	            $rootScope.hasLoaded = true;
	            vmau.tableActionsFunction(params);
	          });
	        }    
	      });
	    }
	    vmau.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(users) {
		'use strict'
		users.directive('allUsersDir',allUsersDir);
		allUsersDir.$inject=[];
		function allUsersDir() {
			return {
				template: __webpack_require__(302),
				controller:'allusersController',
				controllerAs:'vmau',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(users) {
		'use strict'
		users.directive('userEditDir',userEditDir);
		userEditDir.$inject=['getDataService','$rootScope','API_URL','$http','cleanObj','alertService','$state','serverError','aiModalService','refreshtokenService'];
		function userEditDir(getDataService,$rootScope,API_URL,$http, cleanObj, alertService,$state,serverError,aiModalService,refreshtokenService) {
			return {
				restrict: 'E',
				template: __webpack_require__(303),
				link: function(scope, ele, $attrs, ctrl) {
					scope.parent = scope.$eval($attrs.parent);
	  				scope.roles = scope.parent.roles;
				    scope.userId = scope.parent.userId;
				    scope.firstnameRequired = false;
				    scope.lastnameRequired = false;
				    scope.passwordWeakRequired = false;
				    scope.matchedpassword = false;
				    scope.passwordWeak = false;
				    scope.passwordStrong = false;
				    scope.passwordChecked = false;
					scope.selectedPosition = {value:'Novinar'}
				    $rootScope.hasLoaded = true;
					scope.functionalityList = [];
				    scope.checkPassword = function(pass) {
				      if(pass) {
				        scope.checkPasswordObj = owasp.test(pass);
				        if(scope.checkPasswordObj.strong == false) {
				          scope.passwordWeak = true;
				          scope.passwordStrong = false;
				          scope.passwordChecked = false;
				        } else {
				          scope.passwordStrong = true;
				          scope.passwordWeak = false;
				          scope.passwordChecked = true;
				        }
				        
				      }
				    }
				    if(scope.userId) {
				    	var getUserFunction = function() {
					      	getDataService.get({param1:'users', param2: scope.userId}).$promise.then(function(dataUser){
					         	scope.dataUser = dataUser;
								scope.selectedPosition.value = (scope.dataUser.position)? scope.dataUser.position:'none'  
					    		scope.selectedRole = {value:scope.dataUser.role._id};
					    		var statusString = scope.dataUser.status.toString();
					    		scope.selectedStatus ={value:statusString};
								aiModalService.get('functionality-list', function(data) {
									if(data.results && data.results.length > 0) {
										scope.functionalityList = data.results.map(function(item) {
											return {
												_id: item,
												name: item.split('-').join(' '),
												checked: scope.dataUser.aitools.includes(item)
											}
										});
									}
								});
					        }, function(error){
					          	if(error.status ==401) {
						            var promise = refreshtokenService.getAccessToken();
						            promise.then(
						              function(answer) {
						             	if(answer=200) {
						             		getUserFunction();
						             	}
						              },
						              function(error) {
						   
						              },
						              function(progress) {
						               // report progress
						            });
					          	} else if(error.status ==502) {
	                				serverError()
	              			    } else {
						          	scope.parent.editUserShow= false;
									scope.userId = null;
						            $state.transitionTo('app.allusers', {id: null}, {
						              location: true,
						              inherit: true,
						              relative: $state.$current,
						              notify: false
						            });
						        }
					        });
				    	} 
						getUserFunction();
						if(!scope.roles) {
							var getUsersFunction = function() {
								getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
									scope.roles = data.roles;
								}, function(error){
								  if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									return
								  }
								  if(error.status == 401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
									function(answer) {
									  if(answer==200) {
										getUsersFunction();
									  }
									  // do something
									},
									function(error) {
									  // report something
									},
									function(progress) {
									 // report progress
									});
								  }else if(error.status ==502) {
									serverError();
								  } else {
									alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								  }  
								});
							}
							getUsersFunction()
						}  
				    }
				    var updateUserFunction = function(url) {
						var aitools = scope.functionalityList.filter(function(item) {
							return item.checked;
						}).map(function(item) {
							return item._id;
						});
						var updateDataUser = {
							'email': scope.dataUser.email,
			                'password': scope.password,
			                'first_name': scope.dataUser.first_name,
			                'last_name' : scope.dataUser.last_name,
			                'role' : scope.selectedRole.value,
			                'status' : parseInt(scope.selectedStatus.value),
							'position': (scope.selectedPosition.value !='none')? scope.selectedPosition.value:'',
							'bio': scope.dataUser.bio,
	        				'social': scope.dataUser.social,
							'aitools': aitools,
							'gemini_api_key': scope.dataUser.gemini_api_key
						}
						cleanObj.clean(updateDataUser);
						var putFunction = function() {
							$http.put(url , updateDataUser)
					        .success(function (data, status, headers) {
					            alertService('success','Success ', data.message, 2000);
					        })
					        .error(function (data, status, header, config) {
					          	if(status ==401) {
					            var promise = refreshtokenService.getAccessToken();
					            promise.then(
					              	function(answer) {
						                if(answer==200) {   
						                  putFunction();
						                }
					              	},
					              	function(error) {
					              	},
					              	function(progress) {
					               // report progress
					            	});
					          	} else if(error.status ==502) {
	                				serverError()
	              				}else {  
						            alertService('danger','Opps! ', data.error.message);
					            
					          	}
					        });
						}
						putFunction();
				    }
				    scope.updateUser = function() {
				      var validation = true;
				      
				      if(!scope.dataUser.first_name) {
				        validation = false;
				        scope.firstnameRequired = true;
				      } else {
				        scope.firstnameRequired = false;
				      }
				      if(!scope.dataUser.last_name) {
				        validation = false;
				        scope.lastnameRequired = true;
				      } else {
				        scope.lastnameRequired = false;
				      }
				      if(scope.password) {
				        if(!scope.passwordChecked) {
				        	validation = false;
				        	scope.passwordWeakRequired = true;
				      	} else {
				        	scope.passwordWeakRequired = false;
				      	}
				      	if(!scope.repeatedpassword) {
					        validation = false;
					        scope.repeatpasswordRequired = true; 
				      	} else {
				        	scope.repeatpasswordRequired = false; 
				      	}
				      	if(scope.repeatedpassword != scope.password) {
				        	validation = false;
				        	scope.matchedpassword = true;
				      	} else {
				        	scope.matchedpassword = false;
				      	}
				      }
				      
				      if(validation) {
				        updateUserFunction(API_URL+ "users/"+scope.userId);
				      }
				    }
					$rootScope.closeEditUser = function() {
						$rootScope.ngEscapeAttrsParametars = [];
						scope.parent.editUserShow= false;
						scope.userId = null;
			            $state.transitionTo('app.allusers', {id: null}, {
			              location: true,
			              inherit: true,
			              relative: $state.$current,
			              notify: false
			            });
					}
				}
			}
		}
	}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(users) {
		'use strict'
		users.directive('userDir',userDir);
		userDir.$inject=[];
		function userDir() {
			return {
				template: __webpack_require__(304),
				controller:"userController",
				controllerAs:"vmu",
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = function(users) {
	  "use strict";
	  users
	  .controller('userController', userController)
		userController.$inject = ["$state","$rootScope","getDataService",'refreshtokenService','postDataService','alertService','$timeout','serverError', 'offlineError'];
		
	  function userController($state,$rootScope,getDataService,refreshtokenService,postDataService, alertService, $timeout,serverError, offlineError) {
	    var vmu = this;
	    var validation = true;
	    vmu.emailRequired = false;
	    vmu.firstnameRequired = false;
	    vmu.lastnameRequired = false;
	    vmu.passwordRequired = false;
	    vmu.passwordWeakRequired = false;
	    vmu.repeatpasswordRequired = false;
	    vmu.matchedpassword = false;
	    vmu.roleRequired = false;
	    vmu.selectedRole = {value:'default'};
	    vmu.selectedStatus = {value:'1'};
	    vmu.passwordWeak = false;
	    vmu.passwordStrong = false;
	    vmu.passwordChecked = false;
	    $rootScope.hasLoaded = true;
	    vmu.checkPassword = function(pass) {
	      if(pass) {
	        vmu.checkPasswordObj = owasp.test(pass);
	        if(vmu.checkPasswordObj.strong == false) {
	          vmu.passwordWeak = true;
	          vmu.passwordStrong = false;
	          vmu.passwordChecked = false;
	        } else {
	          vmu.passwordStrong = true;
	          vmu.passwordWeak = false;
	          vmu.passwordChecked = true;
	        }   
	      }
	    }
	    var getUsersRolesFunction = function() {
	      getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
	        vmu.roles = data.roles; 
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	          function(answer) {
	            if(answer==200) {
	              getUsersRolesFunction();
	            }
	           
	            // do something
	          },
	          function(error) {
	            // report something
	          },
	          function(progress) {
	           // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getUsersRolesFunction(); 
	    var addUserFunction = function() {
	      postDataService.save({
	        param1:'users'
	      },{
	        'email': vmu.email,
	        'password': vmu.password,
	        'first_name': vmu.firstname,
	        'last_name' : vmu.lastname,
	        'role' : vmu.selectedRole.value,
	        'status' : parseInt(vmu.selectedStatus.value)
	      }).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	          $timeout(function() {
	            $state.go('app.allusers', {id: null});
	          }, 1000);
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        } 
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	          function(answer) {
	            if(answer==200) { 
	              addUserFunction();
	            }
	            // do something
	          },
	          function(error) {
	          },
	          function(progress) {
	           // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    vmu.addNewUser = function() {
	      var validation = true;
	      if(!vmu.email) {
	        validation = false;
	        vmu.emailRequired = true;
	        alertService('danger','Opps! ', 'Email is required')
	      } else {
	        vmu.emailRequired = false;
	      }
	      if(!vmu.firstname) {
	        validation = false;
	        vmu.firstnameRequired = true;
	        alertService('danger','Opps! ', 'First name is required')
	      } else {
	        vmu.firstnameRequired = false;
	      }
	      if(!vmu.lastname) {
	        validation = false;
	        vmu.lastnameRequired = true;
	        alertService('danger','Opps! ', 'Last name is required')
	      } else {
	        vmu.lastnameRequired = false;
	      }
	      
	      if(!vmu.password) {
	        validation = false;
	        vmu.passwordRequired = true;
	        alertService('danger','Opps! ', 'Password is required')
	      } else {
	        vmu.passwordRequired = false;
	      }
	      if(!vmu.passwordChecked) {
	        validation = false;
	        vmu.passwordWeakRequired = true;
	      } else {
	        vmu.passwordWeakRequired = false;
	      }
	      if(!vmu.repeatedpassword) {
	        validation = false;
	        vmu.repeatpasswordRequired = true;
	        alertService('danger','Opps! ', 'Repeated Password is required') 
	      } else {
	        vmu.repeatpasswordRequired = false; 
	      }
	      if(vmu.repeatedpassword != vmu.password) {
	        validation = false;
	        vmu.matchedpassword = true;
	      } else {
	        vmu.matchedpassword = false;
	      }
	      if(vmu.selectedRole.value == 'default') {
	        vmu.roleRequired = true;
	        validation = false;
	        alertService('danger','Opps! ', 'Choose role')
	      } else {
	        vmu.roleRequired = false;
	      }
	      if(validation) {
	        $rootScope.hasLoaded = false;
	        addUserFunction();
	      }
	    }
	  }	
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(users) {
		'use strict'
		users.directive('profileDir',profileDir);
		profileDir.$inject=[];
		function profileDir() {
			return {
				template: __webpack_require__(305),
				controller:"userProfileController",
				controllerAs:"vmup",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = function(users) {
		"use strict";
	  users
	  .controller('userProfileController', userProfileController)
		userProfileController.$inject = ["$rootScope","$scope","getDataService",'refreshtokenService','API_URL','$http','cleanObj','alertService','serverError','offlineError'];
		
	  function userProfileController($rootScope,$scope,getDataService,refreshtokenService,API_URL,$http, cleanObj, alertService,serverError, offlineError) {
	    var vmup = this;
	    vmup.firstnameRequired = false;
	    vmup.lastnameRequired = false;
	    vmup.passwordWeakRequired = false;
	    vmup.matchedpassword = false;
	    vmup.passwordWeak = false;
	    vmup.passwordStrong = false;
	    vmup.passwordChecked = false;
	    $rootScope.hasLoaded = true;
	    vmup.selectedPosition = {value:'Novinar'}
	    vmup.permisions = true;
	    if($rootScope.role_id != 'administrator' && $rootScope.role_id != 'superadmin') {
	      vmup.permisions = false;
	    }     
	    vmup.checkPassword = function(pass) {
	      if(pass) {
	        vmup.checkPasswordObj = owasp.test(pass);
	        if(vmup.checkPasswordObj.strong == false) {
	          vmup.passwordWeak = true;
	          vmup.passwordStrong = false;
	          vmup.passwordChecked = false;
	        } else {
	          vmup.passwordStrong = true;
	          vmup.passwordWeak = false;
	          vmup.passwordChecked = true;
	        }
	        
	      }
	    }
	    var updateUserFunction = function(url) {
	      var updateDataUser = {
	        'email': vmup.dataUser.email,
	        'password': vmup.password,
	        'first_name': vmup.dataUser.first_name,
	        'last_name' : vmup.dataUser.last_name,
	        'role' : vmup.selectedRole.value,
	        'status' : parseInt(vmup.selectedStatus.value),
	        'position': (vmup.selectedPosition.value !='none')?vmup.selectedPosition.value:'',
	        'bio': vmup.dataUser.bio,
	        'social': vmup.dataUser.social
	      }
	      cleanObj.clean(updateDataUser);
	      var putFunction = function() { 
	        $http.put(url , updateDataUser)
	        .success(function (data, status, headers) {
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError()
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.'); 
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      putFunction();
	    }
	    vmup.updateUser = function() {
	      var validation = true;
	      
	      if(!vmup.dataUser.first_name) {
	        validation = false;
	        vmup.firstnameRequired = true;
	      } else {
	        vmup.firstnameRequired = false;
	      }
	      if(!vmup.dataUser.last_name) {
	        validation = false;
	        vmup.lastnameRequired = true;
	      } else {
	        vmup.lastnameRequired = false;
	      }
	      if(vmup.password) {
	        if(!vmup.passwordChecked) {
	          validation = false;
	          vmup.passwordWeakRequired = true;
	        } else {
	          vmup.passwordWeakRequired = false;
	        }
	        if(!vmup.repeatedpassword) {
	          validation = false;
	          vmup.repeatpasswordRequired = true; 
	        } else {
	          vmup.repeatpasswordRequired = false; 
	        }
	        if(vmup.repeatedpassword != vmup.password) {
	          validation = false;
	          vmup.matchedpassword = true;
	        } else {
	          vmup.matchedpassword = false;
	        }
	      }
	      
	      if(validation) {
	        $rootScope.hasLoaded = false;
	        updateUserFunction(API_URL+ "users/"+vmup.dataUser._id);
	      }
	    }
	    var getRoleFunction = function() {
	      getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
	        vmup.roles = data.roles; 
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	          function(answer) {
	            if(answer==200) {
	              getRoleFunction();
	            }
	            // do something
	          },
	          function(error) {
	            // report something
	          },
	          function(progress) {
	           // report progress
	          });
	        }else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    var getprofileFunction = function() { 
	      getDataService.get({param1:'users', param2: 'profile'}).$promise.then(function(dataUser){
	        getRoleFunction();
	        vmup.dataUser = dataUser;
	        vmup.selectedPosition.value = (vmup.dataUser.position)? vmup.dataUser.position:'none'  
	        vmup.selectedRole = {value:vmup.dataUser.role._id};
	        var statusString = vmup.dataUser.status.toString();
	        vmup.selectedStatus ={value:statusString};
	        if(vmup.dataUser.status==1) {
	          vmup.status = "Yes"
	        } else {
	          vmup.status = "No"
	        }
	        vmup.roleName = vmup.dataUser.role.name; 
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getprofileFunction();
	              }  
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getprofileFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var users = angular.module('usersModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'ui.tinymce'
	]);
	__webpack_require__(633)(users);
	__webpack_require__(632)(users);
	
	__webpack_require__(634)(users);
	__webpack_require__(635)(users);
	__webpack_require__(636)(users);
	__webpack_require__(637)(users);
	__webpack_require__(638)(users)


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('livestreamDir',livestreamDir);
		livestreamDir.$inject=[];
		function livestreamDir() {
			return {
				template: __webpack_require__(306),
				controller:"livestreamController",
				controllerAs:"vmls",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = function(video) {
	  "use strict";
		video
	    .controller('livestreamController', livestreamController)
	
		livestreamController.$inject = ["$http", "$rootScope","$scope","getDataService","$state", "$stateParams","refreshtokenService","reqursiveService","putDataService","alertService","$timeout","postDataService","deleteDataService","serverError", "API_URL", "offlineError"];
		
	  function livestreamController($http,$rootScope,$scope,getDataService,$state, $stateParams,refreshtokenService, reqursiveService, putDataService, alertService, $timeout, postDataService,deleteDataService,serverError, API_URL, offlineError) {
	    var vmls = this;
	    var validation = true;
	    vmls.titleRequired = false;
	    vmls.urlRequired = false;
	    vmls.imgRequired = false;
	    $rootScope.hasLoaded = true;
	    var livestreamFunction = function(url) {
	      var updateLivestreamData = {
	        'title': vmls.title,
	        'url': vmls.url,
	        'image':vmls.imageSrc
	      }
	      if(vmls.active) {
	        updateLivestreamData.active = 1;
	      }else {
	        updateLivestreamData.active = 0;
	      }
	      var putFunction = function() {
	        $http.put(url , updateLivestreamData)
	        .success(function (data, status, headers) {
	            alertService('success','Success ', data.message, 2000);
	            $rootScope.hasLoaded = true;
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  putFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError();
	          } else {  
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	           
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      putFunction();
	    }
	    var getLivestreamFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({
	          param1:'video',
	          param2:'livestream',
	        }).$promise.then(function(data){
	          vmls.title = data.livestream.title;
	          vmls.url = data.livestream.url;
	          vmls.imageSrc = data.livestream.image;
	          if(data.livestream.active==1) {
	            vmls.active = true;
	          }else {
	            vmls.active = false;
	          }
	          $rootScope.hasLoaded = true;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getLivestreamFunction();
	              }
	              // do something
	          },
	          function(error) {
	          },
	          function(progress) {
	              // report progress
	          });
	          } else if(error.status ==502) {
	            serverError()
	          } else if(error.status ==404) {
	            scope.emptyTable = true;
	        } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }    
	        $rootScope.hasLoaded = true;  
	      });
	    }
	    getLivestreamFunction();
	    vmls.saveLivestream = function() {
	      var validation = true;
	      if(!vmls.title) {
	        validation = false;
	        vmls.titleRequired = true;
	        alertService('danger','Opps! ', 'Title is required')
	      } else {
	        vmls.titleRequired = false;
	      }
	      if(!vmls.url) {
	        validation = false;
	        vmls.urlRequired = true;
	        alertService('danger','Opps! ', 'URL is required')
	      } else {
	        vmls.urlRequired = false;
	      }
	      if(!vmls.imageSrc) {
	        validation = false;
	        vmls.imgRequired = true;
	        alertService('danger','Opps! ', 'URL is required')
	      } else {
	        vmls.imgRequired = false;
	      }
	      if(validation) {
	        $rootScope.hasLoaded = false;
	        livestreamFunction(API_URL + 'video/livestream');
	      }
	    }
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  } 
	}
	  

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('newVideoDir',newVideoDir);
		newVideoDir.$inject=[];
		function newVideoDir() {
			return {
				template: __webpack_require__(308),
				controller:"newVideoController",
				controllerAs:"vmnv",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('newVideoMediaoutcastDir',newVideoMediaoutcastDir);
		newVideoMediaoutcastDir.$inject=[];
		function newVideoMediaoutcastDir() {
			return {
				template: __webpack_require__(307),
				controller:"newVideoMediaoutcastController",
				controllerAs:"vmnvm",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('uppyDashboard',uppyDashboard);
		uppyDashboard.$inject=['$timeout','$interval','alertService'];
		function uppyDashboard($timeout,$interval, alertService) {
			return {
				restrict: 'E',
	            scope: {
	                parentObj:'=',
	                uploadUrl: '=',
	                getVideoUrl: '=',
	                authorization:'='
	            },
	            template: __webpack_require__(309),
	            replace:true,
	            link: function(scope, element) {
	                scope.transcoding = false;
	                scope.transcodingComplete = false;
	                scope.transcodingProgress = 0;
	                var firstUpload;
	                var getVideoInterval;
	                var uppy = new Uppy.Core({
	                    autoProceed: true,
	                    allowMultipleUploadBatches:false,
	                    restrictions: {
	                        maxNumberOfFiles: 1,
	                        maxFileSize: 100 * 1024 * 1024 * 1024, // 100GB limit
	                        allowedFileTypes: ['video/*'] // Specify allowed file types
	                    }
	                })
	                .use(Uppy.Dashboard, {
	                    target: '#uppyDashboard',
	                    inline: true,
	                    replaceTargetContent: true,
	                    showProgressDetails: true,
	                    proudlyDisplayPoweredByUppy: false,
	                    doneButtonHandler :null,
	                    height: 320,
	                    metaFields: [
	                        { id: 'name', name: 'Name', placeholder: 'file name' }
	                    ]
	                })
	                .use(Uppy.Tus, {
	                    endpoint: scope.uploadUrl, // Backend endpoint
	                    resume: true,
	                    chunkSize: 4 * 1024 * 1024, // 4MB chunk size
	                    retryDelays: [0, 1000, 3000, 5000], // Retry delays in milliseconds
	                    onBeforeRequest: function(req,file) {
	                        // if(scope.parentObj.breaking) {
	                        //     // req.url = scope.uploadUrl + '?is_urgent=1';
	                        //     req.open(req.method, scope.uploadUrl + '?is_urgent=1');
	                        // }
	                        req.setHeader('Authorization', scope.authorization)
	                        // req.setHeader('is_urgent',scope.parentObj.breaking)
	                    },
	                    onAfterResponse:function(response) {
	                        var uploadUrl = (scope.parentObj.breaking)? scope.uploadUrl + '?is_urgent=1': scope.uploadUrl;
	                        if(response && response._method == "POST" && response._url == uploadUrl && response._xhr && response._xhr.response) {
	                            var responseObj = JSON.parse(response._xhr.response)
	                            if(responseObj.video) {
	                                scope.videoObjId = responseObj.video.id;
	                            }
	                            if(!firstUpload) {
	                                scope.parentObj.onUpload()
	                                firstUpload = true
	                            }
	                        }
	
	                    }
	                });
	                scope.$watch(function(){
	                    return scope.parentObj.breaking
	                  }, function(newValue, oldValue){
	                    if (newValue!=oldValue) {
	                        uppy.getPlugin('Tus').opts.endpoint = (newValue)? scope.uploadUrl + '?is_urgent=1': scope.uploadUrl;
	                    }
	                  },true);
	                // uppy.on('upload-started', function(file, upload) {
	                    
	                // });
	                // uppy.on('file-added', (file) => {
	                //     console.log('Added file', file);
	                // });
	                // uppy.on('upload', function(data) {
	                //     console.log(data)
	                // });
	                // uppy.on('progress', function(progress) {
	                //     // progress: integer (total progress percentage)
	                //     // console.log(progress);
	                // });
	                // Handle successful uploads
	                // Handle errors
	                // uppy.on('upload-error', function(file,error, response) {
	                //     // console.log('Upload error:', error);
	                //     console.log(error.message)
	                // });
	                uppy.on('complete', function(result) {
	                    // console.log('Upload complete:', result.successful);
	                    // console.log('failed files:', result.failed);
	                    if(result.failed && result.failed.length>0 && result.failed[0] && result.failed[0].error) {
	                        var responseText = result.failed[0].error.match(/\{([^}]*)\}/)
	                        var response;
	                        if(responseText && responseText.length>0) {
	                            responseText = result.failed[0].error.match(/\{([^}]*)\}/)[0]
	                            try {
	                                response = JSON.parse(responseText)
	                            } catch(error) {
	
	                            } 
	                            if(response && response.message) {
	                                scope.$apply(function () {
	                                    alertService('danger','Opps! ', response.message);
	                                })
	                            }
	                        }
	                    } 
	                });
	                // Add your logic to handle successful uploads
	                uppy.on('upload-success', function(file, response){
	                    if(scope.videoObjId) {
	                        getVideo(scope.videoObjId)
	                    } else {
	                        alertService('danger','Opps! ', 'Something went wrong. VideoId is not exist.');
	                    }
	                })
	                function getVideo(videoId){
	                    var options = {
	                        headers: {
	                        'Content-Type': 'application/json',
	                        'Accept': 'application/json',
	                        'Authorization': scope.authorization
	                        }
	                    };
	                    getVideoInterval = $interval(function(){
	                        fetchVideo()
	                    },2000)
	                    fetchVideo()
	                    function fetchVideo() {
	                        fetch(scope.getVideoUrl + videoId, options)
	                        .then(function(response) {
	                            return response.json()
	                        })
	                        .then(function(data){ 
	                            console.log(data.data)
	                            scope.$apply(function () {
	                                scope.transcoding = true;
	                            })
	                            if(data && data.data) {
	                                scope.$apply(function () {
	                                    scope.transcodingProgress = data.data.transcoding_progress;
	                                })
	                            }
	                            if(data.data.transcoding_progress == 100) {
	                                scope.$apply(function () {
	                                    scope.transcodingComplete = true;
	                                    scope.parentObj.transcodingDone(data.data)
	                                    $interval.cancel(getVideoInterval);
	                                    getVideoInterval = null
	                                })
	                            }
	                        })
	                        .catch(function(error) { 
	                            console.error(error)
	                        });
	                    }
	                }
	                scope.$on('$destroy', function() {
	                    // Remove event listeners
	                    uppy.close(); // or uppy.off() to remove specific event listeners
	                    // Destroy the Uppy instance
	                    uppy = null;
	                    $interval.cancel(getVideoInterval);
	                    getVideoInterval = null
	                });
	            }
			}
		}
	}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		media
	    .controller('newVideoController', newVideoController)
	
		newVideoController.$inject = ["API_URL","$interval","$state","$scope","getDataService", 'jQuery', '$stateParams','refreshtokenService','config','authtokenService','postDataService', 'alertService','serverError','$rootScope', 'reqursiveService','checkArray','$http','offlineError'];
		
	  function newVideoController(API_URL,$interval,$state,$scope,getDataService,jQuery, $stateParams,refreshtokenService,config, authtokenService,postDataService, alertService,serverError,$rootScope, reqursiveService, checkArray,$http,offlineError) {
	    var vmnv = this;
	    var state = 'video';
	    vmnv.firstBind = false;
	    vmnv.data_grid = [];
	    vmnv.config = config;
	    vmnv.selectedTranscoding={value:vmnv.config.videoUploadVersion}
	    Dropzone.autoDiscover = false;
	    vmnv.editImageModal = false;
	    vmnv.upload_title = ''
	    vmnv.upload_signature = '';
	    vmnv.upload_description = '';
	    vmnv.tags = [];
	    vmnv.selectedImage = -1;
	    vmnv.uploadedThumb = false;
	    vmnv.uploadVideoRequired = false;
	    vmnv.thumbRequired = false;
	    vmnv.thumbsLoaded = {};
	    vmnv.custom_image = '';
	    vmnv.image = null;
	    vmnv.addSafety =config.addSafety;
	    vmnv.safe = null;
	    vmnv.checkedItems ={};
	    vmnv.videoSafeRequired = false;
	    vmnv.geoAllowance = config.geoRestrictions;
	    vmnv.allowCheckedItems = {};
	    vmnv.selectedVideoQuality = {value:'medium'};
	    var geoAllowanceUpdateFunction = function() {
	      for(var i=0; i<vmnv.geoAllowance.length;i++) {
	        vmnv.allowCheckedItems[vmnv.geoAllowance[i]._id] = false;
	      }
	    }
	    geoAllowanceUpdateFunction();
	    vmnv.allowCheckedItems[vmnv.geoAllowance[0]._id] = true;
	    vmnv.geoAllow = vmnv.geoAllowance[0]._id;
	    vmnv.updateAllowance = function(allowance) {
	      if(vmnv.allowCheckedItems[allowance]) {
	          putGeoAllowanceFunction(allowance);
	      }
	      geoAllowanceUpdateFunction();
	      vmnv.allowCheckedItems[allowance] = true;
	    }
	    var putGeoAllowanceFunction = function(allowance) {
	      var url = API_URL + 'video/georestrictions/'+ vmnv.videoNew._id; 
	        var updateDataPosts = {
	          "allowance": allowance,
	          "video_id": vmnv.videoNew.video_id,
	          "isUpdate": false
	        }
	        var putFunction = function() {
	          $http.put(url , updateDataPosts)
	          .success(function (data, status, headers) {
	              alertService('success','Success ', data.message, 2000);
	              vmnv.geoAllow = allowance;
	          })
	          .error(function (data, status, header, config) {
	            if(!window.navigator.onLine) {
	              offlineError()
	              geoAllowanceUpdateFunction();
	              vmnv.allowCheckedItems[vmnv.geoAllow] = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    putFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                  // report progress
	              });
	            }else if(status ==502) {
	              serverError();
	            } else {  
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	            
	            }
	            geoAllowanceUpdateFunction();
	            vmnv.allowCheckedItems[vmnv.geoAllow] = true;
	          });
	        }
	        putFunction();
	    }
	    vmnv.chooseImage = function(index) {
	        // if(vmnv.thumbsLoaded.all) {
	            vmnv.selectedImage = index;
	            if(vmnv.thumbs.length == vmnv.thumbsLocked.length) {
	              vmnv.image = vmnv.thumbsLocked[index] 
	            } else {
	              if(index==vmnv.thumbs.length-1) {
	                vmnv.image = vmnv.customThumbsLocked;
	              } else {
	                  vmnv.image = vmnv.thumbsLocked[index];
	              }
	            } 
	            jQuery('.upload-image').attr('src', vmnv.thumbs[index])
	        // }
	    }
	    vmnv.uploaded = false;
	    vmnv.dzOptions = {
	        url : config.videoUploadUrl+'api/'+vmnv.selectedTranscoding.value+'/upload',
	        paramName : 'filename',
	        maxFilesize : '500000',
	        parallelUploads: 10,  
	        acceptedFiles : '.mp4',
	        addRemoveLinks : true,
	        autoProcessQueue : false,
	        dictInvalidFileType: 'This file type is not supported.',
	        dictFileTooBig:'File size too Big',
	        dictDefaultMessage : "Drop video here to upload",
	        headers:{
	          'x-auth': null  
	        },
	        
	    };
	    
	    //Handle events for dropzone
	    //Visit http://www.dropzonejs.com/#events for more events
	    vmnv.dzCallbacks = {
	        'processing': function(file) {
	          var dz = vmnv.dzMethods.getDropzone();
	          dz.options.url=config.videoUploadUrl+'api/'+vmnv.selectedTranscoding.value+'/upload';
	        }, 
	        'addedfile' : function(file){
	            vmnv.newFile = file;
	           var getVideoToken = function() {  
	              postDataService.save({
	                param1: state,
	                // param2: 'token'  
	                }).$promise.then(function(data){
	                vmnv.videoNew = data.video;
	                vmnv.dzOptions.headers['x-auth'] = vmnv.videoNew.video_id;
	                vmnv.dzMethods.processQueue();
	              },function(error){
	                if(error.status ==401) {
	                  var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {   
	                        getVideoToken();
	                      }
	
	                    },
	                    function(error) {
	                      // report something
	                    },
	                    function(progress) {
	                     // report progress
	                  });
	                }else if(error.status ==502) {
	                  serverError()
	                } else {
	                  alertService('danger','Opps! ', error.data.error.message);
	                }
	              });
	            }
	            getVideoToken();
	            
	        },
	        'success' : function(file, xhr, response){
	            // vmnv.thumbs = ['https://xdn.tf.rs/2017/06/06/234.jpg','https://xdn.tf.rs/2017/06/06/Tan2017-6-6_173428125_9.jpg','https://xdn.tf.rs/2017/06/06/Tan2017-6-6_17316245_1.jpg'];
	            var data = JSON.parse(response.currentTarget.response);
	            vmnv.thumbsLocked = angular.copy(data.thumbs);
	            vmnv.thumbs = data.thumbs;
	            vmnv.mp4 = data.mp4;
	            vmnv.m3u8 = data.uri;
	            vmnv.encodingId = data.encodingId;
	            vmnv.duration = data.duration;
	            vmnv.resolutions = data.resolutions;
	            var imageThumbElement = [];
	            for(var i=0; i<vmnv.thumbs.length;i++) {
	                vmnv.thumbs[i]=vmnv.config.baseVideoHref + vmnv.thumbs[i].replace('.jpg','-254x191.jpg'); 
	                vmnv.thumbsLoaded[i]=false;
	                vmnv.thumbsLoaded.all=false;
	            }
	            vmnv.uploadVideoRequired = false;
	            vmnv.uploaded = true;
	            // vmnv.image = vmnv.thumbs[0];
	            // if(vmnv.selectedTranscoding.value == vmnv.config.videoUploadVersion) {
	              vmnv.dateDefault = vmnv.m3u8.substring(9,19);  
	            // } else {
	              // vmnv.dateDefault = vmnv.m3u8.substring(1,11);
	            // }
	            vmnv.date = vmnv.dateDefault.replace(/\//g,'-');
	            vmnv.thumbDir = vmnv.m3u8.substring(0, vmnv.m3u8.lastIndexOf('/'));
	            vmnv.loadedInterval = $interval(function(){
	
	                var iLoaded = 0
	                var imageThumbElement = angular.element(document.getElementsByClassName('thumb_upload'));
	                for(var i = 0; i<imageThumbElement.length;i++) {
	                    imageThumbElement[i].src = undefined;
	                    imageThumbElement[i].src = vmnv.thumbs[i];
	                    jQuery(imageThumbElement[i]).off('load').on('load',function(i) {
	                        var index = jQuery(this).attr('index');
	                        iLoaded++
	                        $scope.$apply(function() {
	                            vmnv.thumbsLoaded[index] = true;
	                        })
	                        if(iLoaded==imageThumbElement.length) {
	                           $interval.cancel(vmnv.loadedInterval);
	                           $scope.$apply(function() {
	                                vmnv.thumbsLoaded.all = true;
	                                 vmnv.selectedImage = 0;
	                                 vmnv.image = vmnv.thumbsLocked[0];
	                                 vmnv.thumbRequired = false;
	                           })
	                           jQuery('.upload-image').attr('src', vmnv.thumbs[0]);
	                        }
	                    }); 
	                }
	            },5000)
	        },
	        'error' : function(file,message) {
	          if(message && message.error && message.error.message) {
	            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
	          }
	        },
	        'sending':function(file, xhr, formData) {
	            formData.append('video_id', vmnv.videoNew.video_id);
	            if(vmnv.selectedVideoQuality.value) {
	              formData.append('quality', vmnv.selectedVideoQuality.value);
	          }
	        }
	    };
	    vmnv.dzOptionsThumb = {
	        url : 'https://upload.telegraf.tv/api/'+vmnv.selectedTranscoding.value+'/thumb/update',
	        paramName : 'filename',
	        maxFilesize : '500000',
	        parallelUploads: 10,  
	        acceptedFiles : 'image/jpeg, images/jpg',
	        addRemoveLinks : true,
	        autoProcessQueue : false,
	        dictInvalidFileType: 'This file type is not supported.',
	        dictFileTooBig:'File size too Big',
	        dictDefaultMessage : "Drop image here to upload",
	        headers:{
	          'x-auth': null  
	        },      
	    };
	    vmnv.dzCallbacksThumb = {
	        'processing': function(file) {
	          var dz = vmnv.dzMethodsThumb.getDropzone();
	          dz.options.url= 'https://upload.telegraf.tv/api/'+vmnv.selectedTranscoding.value+'/thumb/update';
	        }, 
	        'addedfile' : function(file){
	            vmnv.newFileThumb = file;
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                    var token = authtokenService.getToken();
	                    vmnv.dzOptionsThumb.headers['x-auth'] = token;
	                    vmnv.dzMethodsThumb.processQueue();
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	            
	        },
	        'success' : function(file, xhr, response){
	            var data = JSON.parse(response.currentTarget.response);
	            vmnv.customThumb = data.image;
	            vmnv.customThumbsLocked = angular.copy(data.image);
	            vmnv.uploadedThumb = true;
	            if(vmnv.thumbsLocked.length == vmnv.thumbs.length) {
	                vmnv.thumbs.push(vmnv.config.baseVideoHref + vmnv.customThumb.replace('.jpg','-254x191.jpg')); 
	            } else {
	                vmnv.thumbs.splice(-1,1);
	                vmnv.thumbs.push(vmnv.config.baseVideoHref + vmnv.customThumb.replace('.jpg','-254x191.jpg'));
	            }
	            vmnv.thumbsLoaded[vmnv.thumbs.length-1] = false;
	            vmnv.selectedImage = vmnv.thumbs.length-1;
	            vmnv.thumbRequired = false;
	            vmnv.image = vmnv.customThumbsLocked;
	            jQuery('.upload-image').attr('src', vmnv.thumbs[vmnv.thumbs.length-1])
	        },
	        'error' : function(response,message) {
	        },
	        'sending':function(file, xhr, formData) {
	            formData.append('video_id', vmnv.videoNew.video_id);
	            formData.append('date', vmnv.date);
	            formData.append('dir', vmnv.thumbDir);
	        }
	    };
	    // Apply methods for dropzone
	    // Visit http://www.dropzonejs.com/#dropzone-methods for more methods
	    // vmnv.dzMethods = {
	    //     'init': function() {
	          
	    //     }
	    // };
	    vmnv.updateSafety = function(safeId, checked) {
	      if(checked) {
	        for(var i = 0; i<vmnv.addSafety.length;i++) {
	          vmnv.checkedItems[vmnv.addSafety[i]._id] = false
	        }
	        vmnv.checkedItems[safeId]= true;
	        vmnv.safe = safeId;  
	      } else {
	        vmnv.safe = null;
	      }
	    }
	    var addNewTagFunction = function(data) {
	      vmnv.newTagRequired = false;
	      if(!checkArray.contains.call(vmnv.tags,data.tagId)) {
	        vmnv.tags.push(data.tagId);
	        vmnv.searchtagfocus = null;
	        vmnv.existTag = false;
	      } else {
	        vmnv.existTag = true;
	      }
	    }
	    $scope.$on('select-tag', function(event,data) {
	      addNewTagFunction(data.selectedTagObj)
	    });
	    vmnv.addNewTag = function() {
	      if(vmnv.searchtagfocus && vmnv.searchtagfocus.length>1) {
	        var postFunction = function() {
	          postDataService.save({
	            param1:'video-tags', 
	            // param2: 'create'
	          },{
	            'name': vmnv.searchtagfocus
	          }).$promise.then(function(postTag){
	          var data = {
	            tagId:postTag.tag._id,
	            tagname: postTag.tag.name
	          } 
	            addNewTagFunction(data);
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else if(error.status ==400) {
	              var data = {
	                tagId:error.data.tag._id,
	                tagname: error.data.tag.name
	              } 
	              addNewTagFunction(data);
	            }
	          });
	        }
	        postFunction();
	      } else {
	        vmnv.newTagRequired = true;
	      }
	    }
	    vmnv.removeFromTagsList = function(index) {
	      vmnv.tags.splice(index, 1);
	    }
	
	    var getVideoCategoriesFunction = function() {
	        getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
	            vmnv.categories = dataCategory.categories;
	            vmnv.categoriesTreeInput = reqursiveService.getReqursiveArray(vmnv.categories);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getVideoCategoriesFunction();
	                  }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	    }  
	    getVideoCategoriesFunction();
	     vmnv.updateSelection = function(category_id, checked) {
	      var updateSelectionTree = function(categories) {
	        if(checked) {
	          for (var i=0; i<categories.length; i++){
	            if (categories[i]._id !== category_id) {
	              vmnv.categorychecked.item[categories[i]._id] = false;
	            }
	          }
	          vmnv.category = category_id;
	        } else {
	          vmnv.category = null;
	        }
	      }
	      updateSelectionTree(vmnv.categoriesTreeInput);   
	    }
	    vmnv.saveVideos = function() {
	        var validation = true;
	        if(vmnv.titleExceed) {
	            validation = false;
	            alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
	        }
	        if(!vmnv.uploaded) {
	            validation = false;
	            vmnv.uploadVideoRequired = true;
	        } else {
	            vmnv.uploadVideoRequired = false;
	        }
	        if(!vmnv.upload_title) {
	            validation = false;
	            vmnv.titleRequired = true;
	        } else {
	            vmnv.titleRequired = false;
	        }
	        if(vmnv.tags.length == 0) {
	            validation = false;
	            vmnv.tagsRequired = true;
	        } else {
	            vmnv.tagsRequired = false;
	        }
	        if(!vmnv.category) {
	            validation = false;
	            vmnv.categoryRequired = true;
	        } else {
	            vmnv.categoryRequired = false;
	        }
	        if(!vmnv.image) {
	            vmnv.thumbRequired = true;
	            validation = false;
	        } else {
	            vmnv.thumbRequired = false;
	        }
	        if(!vmnv.safe) {
	          vmnv.videoSafeRequired = true;
	          validation = false;
	        } else {
	          vmnv.videoSafeRequired = false;
	        }
	        var updateFunction = function() {
	            $rootScope.hasLoaded = false;
	            var url = API_URL + state + '/' + vmnv.videoNew._id;
	            var videoData = {
	              'video_id':vmnv.videoNew.video_id,
	              'title': (vmnv.upload_title)? (vmnv.upload_title).replace(/\r?\n|\r/g, ' '): '',
	              'subtitle': (vmnv.upload_subtitle)? (vmnv.upload_subtitle).replace(/\r?\n|\r/g, ' '): '',
	              'category':vmnv.category,
	              'tags': vmnv.tags,
	              'file': {
	                  'mp4': vmnv.mp4,
	                  'm3u8': vmnv.m3u8
	              },
	              'image': vmnv.image,
	              'custom_image':vmnv.customThumb,
	              'thumbs':vmnv.thumbsLocked,
	              'signature':vmnv.upload_signature,
	              'status': 'draft',
	              'meta':{
	                'safe':vmnv.safe
	              },
	              'allowance':vmnv.geoAllow,
	              'encodingId': vmnv.encodingId,
	              'duration':vmnv.duration,
	              'resolutions':vmnv.resolutions
	            }
	  
	            $http.put(url , videoData)
	            .success(function (data, stat, headers) {
	                $rootScope.hasLoaded = true;
	                $state.go('app.allvideos', {id:vmnv.videoNew._id});
	                alertService('success','Success ', data.message, 2000);   
	            })
	            .error(function (data, status, header, config) {
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(status ==401) {
	                  var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {   
	                        updateFunction();
	                      }
	                    },
	                    function(error) {
	                    },
	                    function(progress) {
	                      // report progress
	              });
	              }else if(status ==502) {
	                  serverError()  
	              }else { 
	                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;
	            }); 
	        }    
	        if(validation) {
	            updateFunction();
	        }
	    }
	    $scope.$on("$destroy", function() {
	        $interval.cancel(vmnv.loadedInterval);
	    });
	  }	
	}


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = function(media) {
		media
	    .controller('newVideoMediaoutcastController', newVideoMediaoutcastController)
	
		newVideoMediaoutcastController.$inject = ["fileReaderImage","$timeout","getSubstringBetween","API_URL","$interval","$state","$scope","getDataService", 'jQuery', '$stateParams','refreshtokenService','config','authtokenService','postDataService', 'alertService','serverError','$rootScope', 'reqursiveService','checkArray','$http','offlineError'];
		
	  function newVideoMediaoutcastController(fileReaderImage,$timeout,getSubstringBetween,API_URL,$interval,$state,$scope,getDataService,jQuery, $stateParams,refreshtokenService,config, authtokenService,postDataService, alertService,serverError,$rootScope, reqursiveService, checkArray,$http,offlineError) {
	    var vmnvm = this;
	    var state = 'video';
	    vmnvm.firstBind = false;
	    vmnvm.data_grid = [];
	    vmnvm.config = config;
	    vmnvm.selectedTranscoding={value:vmnvm.config.videoUploadVersion}
	    Dropzone.autoDiscover = false;
	    vmnvm.editImageModal = false;
	    vmnvm.upload_title = ''
	    vmnvm.upload_signature = '';
	    vmnvm.upload_description = '';
	    vmnvm.tags = [];
	    vmnvm.selectedImage = -1;
	    vmnvm.uploadedThumb = false;
	    vmnvm.thumbRequired = false;
	    vmnvm.thumbsLoaded = {};
	    vmnvm.custom_image = '';
	    vmnvm.image = null;
	    vmnvm.addSafety =config.addSafety;
	    vmnvm.safe = null;
	    vmnvm.checkedItems ={};
	    vmnvm.videoSafeRequired = false;
	    vmnvm.geoAllowance = config.geoRestrictions;
	    vmnvm.allowCheckedItems = {};
	    vmnvm.breaking = false;
	    var displayRes = '-254x191.jpg';
	    var loadedInterval;
	    var geoAllowanceUpdateFunction = function() {
	      for(var i=0; i<vmnvm.geoAllowance.length;i++) {
	        vmnvm.allowCheckedItems[vmnvm.geoAllowance[i]._id] = false;
	      }
	    }
	    geoAllowanceUpdateFunction();
	    vmnvm.allowCheckedItems[vmnvm.geoAllowance[0]._id] = true;
	    vmnvm.geoAllow = vmnvm.geoAllowance[0]._id;
	    vmnvm.updateAllowance = function(allowance) {
	      if(vmnvm.allowCheckedItems[allowance]) {
	          putGeoAllowanceFunction(allowance);
	      }
	      geoAllowanceUpdateFunction();
	      vmnvm.allowCheckedItems[allowance] = true;
	    }
	    var putGeoAllowanceFunction = function(allowance) {
	      var url = API_URL + 'video/georestrictions/mediaoutcast/' + vmnvm.videoNew._id; 
	        var updateDataPosts = {
	          "allowance": allowance,
	          "video_id": vmnvm.uploadVideoObj.id,
	          "isUpdate": false
	        }
	        var putFunction = function() {
	          $http.put(url , updateDataPosts)
	          .success(function (data, status, headers) {
	              alertService('success','Success ', data.message, 2000);
	              vmnvm.geoAllow = allowance;
	          })
	          .error(function (data, status, header, config) {
	            if(!window.navigator.onLine) {
	              offlineError()
	              geoAllowanceUpdateFunction();
	              vmnvm.allowCheckedItems[vmnvm.geoAllow] = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    putFunction();
	                  }
	                },
	                function(error) {
	                  // report something
	                },
	                function(progress) {
	                  // report progress
	              });
	            }else if(status ==502) {
	              serverError();
	            } else {  
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	            
	            }
	            geoAllowanceUpdateFunction();
	            vmnvm.allowCheckedItems[vmnvm.geoAllow] = true;
	          });
	        }
	        putFunction();
	    }
	    vmnvm.chooseImage = function(index) {
	      vmnvm.selectedImage = index;
	      if(vmnvm.thumbs.length == vmnvm.thumbsLocked.length) {
	        vmnvm.image = vmnvm.thumbsLocked[index] 
	      } else {
	        if(index==vmnvm.thumbs.length-1) {
	          vmnvm.image = vmnvm.customThumbsLocked;
	        } else {
	            vmnvm.image = vmnvm.thumbsLocked[index];
	        }
	      } 
	    }
	    vmnvm.uploaded = false;
	    vmnvm.onUpload = function() {
	      var createVideo = function() {  
	        postDataService.save({
	          param1: state,
	          param2: 'mediaoutcast'  
	        }).$promise.then(function(data){
	          vmnvm.videoNew = data.video;
	        },function(error){
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  createVideo();
	                }
	
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	                // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', error.data.error.message);
	          }
	        });
	      }
	      createVideo();
	    }
	    vmnvm.transcodingDone = function(videoObj) {
	      vmnvm.uploadVideoObj = videoObj
	      vmnvm.thumbsLocked = [];
	      vmnvm.orientation = (vmnvm.uploadVideoObj.height>vmnvm.uploadVideoObj.width)? 'portrait': 'landscape';
	      if(vmnvm.orientation == 'portrait') {
	        displayRes = '-360x640.jpg'
	      }
	      var res = ['1080p','720p','360p'];
	      var thumb;
	      var maxRes;
	      if(videoObj.image_urls) {
	        for(var i=0;i<res.length;i++) {
	          if(videoObj.image_urls[res[i]]) {
	            thumb = videoObj.image_urls[res[i]];
	            maxRes = res[i]
	            break
	          }
	        }
	      }
	      vmnvm.date = getSubstringBetween(thumb, vmnvm.config.mediaoutcast.project_id, videoObj.hash);
	      if(maxRes =='360p') {
	        vmnvm.thumbsLocked.push(vmnvm.config.mediaoutcast.default_image[vmnvm.orientation])
	      } else {
	        vmnvm.thumbsLocked.push('/images'+ vmnvm.date + videoObj.hash + '/' +maxRes+'.jpg')
	      }
	      vmnvm.thumbs = angular.copy(vmnvm.thumbsLocked);
	      vmnvm.mp4 = getSubstringBetween(videoObj.published_mp4_url,vmnvm.config.mediaoutcast.project_id);
	      vmnvm.m3u8 = getSubstringBetween(videoObj.published_url,vmnvm.config.mediaoutcast.project_id);
	      vmnvm.duration = videoObj.length;
	      vmnvm.filename = videoObj.title;
	      for(var i=0; i<vmnvm.thumbs.length;i++) {
	          vmnvm.thumbs[i]=vmnvm.config.baseVideoHref + vmnvm.thumbs[i].replace('.jpg',displayRes); 
	          vmnvm.thumbsLoaded[i]=false;
	          vmnvm.thumbsLoaded.all=false;
	      }
	      if(vmnvm.uploadVideoObj.id && vmnvm.mp4 && vmnvm.m3u8 && videoObj.hash) {
	        vmnvm.uploaded = true;
	      }
	      var thumbLoaded = 0
	      var imageThumbElement;
	      function loadThumbs() {
	        imageThumbElement = angular.element(document.getElementsByClassName('thumb-uploading'));
	        for(var i = 0; i<imageThumbElement.length;i++) {
	          imageThumbElement[i].src = undefined;
	          imageThumbElement[i].src = vmnvm.thumbs[i]
	          jQuery(imageThumbElement[i]).off('load').on('load',function(i) {
	              var index = jQuery(this).attr('index');
	              thumbLoaded++
	              $scope.$apply(function() {
	                  vmnvm.thumbsLoaded[index] = true;
	              })
	              if(thumbLoaded==imageThumbElement.length) {
	                  $scope.$apply(function() {
	                    $interval.cancel(loadedInterval);
	                    loadedInterval = null
	                    vmnvm.thumbsLoaded.all = true;
	                    vmnvm.selectedImage = 0;
	                    vmnvm.image = vmnvm.thumbsLocked[0];
	                    vmnvm.thumbRequired = false;
	                  })
	              }
	          }); 
	        }
	      }
	      $timeout(function() {
	        loadThumbs()
	      },100)
	      loadedInterval = $interval(function(){
	        loadThumbs()
	      },2000)
	    }
	    vmnvm.dzOptionsThumb = {
	        url : 'https://upload.telegraf.tv/api/mediaoutcast/thumb/update',
	        paramName : 'filename',
	        maxFilesize : '500000',
	        parallelUploads: 1,  
	        acceptedFiles : 'image/jpeg, images/jpg',
	        addRemoveLinks : true,
	        autoProcessQueue : false,
	        dictInvalidFileType: 'This file type is not supported.',
	        dictFileTooBig:'File size too Big',
	        dictDefaultMessage : "Drop image here to upload",
	        headers:{
	          'x-auth': null  
	        },      
	    };
	    vmnvm.dzCallbacksThumb = {
	        'addedfile' : function(file){
	          fileReaderImage(file,function(width,height){
	            if (((vmnvm.orientation=='portrait') &&  (width < 541 || height < 961)) || 
	            ((vmnvm.orientation!='portrait') &&  (width < 816 || height < 459))) {
	              vmnvm.dzMethodsThumb.removeFile(file);
	              var imageDimensions = (vmnvm.orientation=='portrait')? '541x961':'816x459'
								alertService('danger','Opps! ', "Image dimensions are too small (min-dimensions:"+ imageDimensions +"). The file has been removed.");
	            } else {
	              uploadFile()
	            }
	          })
	          function uploadFile() {
	            vmnvm.newFileThumb = file;
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                    var token = authtokenService.getToken();
	                    vmnvm.dzOptionsThumb.headers['x-auth'] = token;
	                    vmnvm.dzMethodsThumb.processQueue();
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	              // report progress
	            });
	          }
	            
	        },
	        'success' : function(file, xhr, response){
	            var data = JSON.parse(response.currentTarget.response);
	            vmnvm.customThumb = data.image;
	            vmnvm.customThumbsLocked = angular.copy(data.image);
	            vmnvm.uploadedThumb = true;
	            if(vmnvm.thumbsLocked.length != vmnvm.thumbs.length) { 
	              vmnvm.thumbs.splice(-1,1);
	            }
	            vmnvm.thumbs.push(vmnvm.config.baseVideoHref + vmnvm.customThumb.replace('.jpg',displayRes));
	            vmnvm.thumbsLoaded[vmnvm.thumbs.length-1] = false;
	            vmnvm.selectedImage = vmnvm.thumbs.length-1;
	            vmnvm.thumbRequired = false;
	            vmnvm.image = vmnvm.customThumbsLocked;
	        },
	        'error' : function(response,message) {
	        },
	        'sending':function(file, xhr, formData) {
	          formData.append('video_id',vmnvm.uploadVideoObj.id);
	        }
	    };
	    // Apply methods for dropzone
	    // Visit http://www.dropzonejs.com/#dropzone-methods for more methods
	    // vmnvm.dzMethods = {
	    //     'init': function() {
	          
	    //     }
	    // };
	    vmnvm.updateSafety = function(safeId, checked) {
	      if(checked) {
	        for(var i = 0; i<vmnvm.addSafety.length;i++) {
	          vmnvm.checkedItems[vmnvm.addSafety[i]._id] = false
	        }
	        vmnvm.checkedItems[safeId]= true;
	        vmnvm.safe = safeId;  
	      } else {
	        vmnvm.safe = null;
	      }
	    }
	    var addNewTagFunction = function(data) {
	      vmnvm.newTagRequired = false;
	      if(!checkArray.contains.call(vmnvm.tags,data.tagId)) {
	        vmnvm.tags.push(data.tagId);
	        vmnvm.searchtagfocus = null;
	        vmnvm.existTag = false;
	      } else {
	        vmnvm.existTag = true;
	      }
	    }
	    $scope.$on('select-tag', function(event,data) {
	      addNewTagFunction(data.selectedTagObj)
	    });
	    vmnvm.addNewTag = function() {
	      if(vmnvm.searchtagfocus && vmnvm.searchtagfocus.length>1) {
	        var postFunction = function() {
	          postDataService.save({
	            param1:'video-tags', 
	            // param2: 'create'
	          },{
	            'name': vmnvm.searchtagfocus
	          }).$promise.then(function(postTag){
	          var data = {
	            tagId:postTag.tag._id,
	            tagname: postTag.tag.name
	          } 
	            addNewTagFunction(data);
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else if(error.status ==400) {
	              var data = {
	                tagId:error.data.tag._id,
	                tagname: error.data.tag.name
	              } 
	              addNewTagFunction(data);
	            }
	          });
	        }
	        postFunction();
	      } else {
	        vmnvm.newTagRequired = true;
	      }
	    }
	    vmnvm.removeFromTagsList = function(index) {
	      vmnvm.tags.splice(index, 1);
	    }
	
	    var getVideoCategoriesFunction = function() {
	        getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
	            vmnvm.categories = dataCategory.categories;
	            vmnvm.categoriesTreeInput = reqursiveService.getReqursiveArray(vmnvm.categories);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	                function(answer) {
	                  if(answer==200) {
	                    getVideoCategoriesFunction();
	                  }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	    }  
	    getVideoCategoriesFunction();
	     vmnvm.updateSelection = function(category_id, checked) {
	      var updateSelectionTree = function(categories) {
	        if(checked) {
	          for (var i=0; i<categories.length; i++){
	            if (categories[i]._id !== category_id) {
	              vmnvm.categorychecked.item[categories[i]._id] = false;
	            }
	          }
	          vmnvm.category = category_id;
	        } else {
	          vmnvm.category = null;
	        }
	      }
	      updateSelectionTree(vmnvm.categoriesTreeInput);   
	    }
	    vmnvm.saveVideos = function() {
	        var validation = true;
	        if(vmnvm.titleExceed) {
	          validation = false;
	          alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
	        }
	        if(!vmnvm.uploaded) {
	          validation = false;
	          alertService('danger','Opps! ', 'Video has not been uploaded and transcoded yet.');
	        }
	        if(!vmnvm.upload_title) {
	            validation = false;
	            vmnvm.titleRequired = true;
	        } else {
	            vmnvm.titleRequired = false;
	        }
	        if(vmnvm.tags.length == 0) {
	            validation = false;
	            vmnvm.tagsRequired = true;
	        } else {
	            vmnvm.tagsRequired = false;
	        }
	        if(!vmnvm.category) {
	            validation = false;
	            vmnvm.categoryRequired = true;
	        } else {
	            vmnvm.categoryRequired = false;
	        }
	        if(!vmnvm.image) {
	            vmnvm.thumbRequired = true;
	            validation = false;
	        } else {
	            vmnvm.thumbRequired = false;
	        }
	        if(!vmnvm.safe) {
	          vmnvm.videoSafeRequired = true;
	          validation = false;
	        } else {
	          vmnvm.videoSafeRequired = false;
	        }
	        var updateFunction = function() {
	            $rootScope.hasLoaded = false;
	            var url = API_URL + state + '/mediaoutcast/' + vmnvm.videoNew._id;
	            var videoData = {
	              'video_id':vmnvm.uploadVideoObj.id,
	              'hash': vmnvm.uploadVideoObj.hash,
	              'title': (vmnvm.upload_title)? (vmnvm.upload_title).replace(/\r?\n|\r/g, ' '): '',
	              'subtitle': (vmnvm.upload_subtitle)? (vmnvm.upload_subtitle).replace(/\r?\n|\r/g, ' '): '',
	              'category':vmnvm.category,
	              'tags': vmnvm.tags,
	              'file': {
	                'mp4': vmnvm.mp4,
	                'm3u8': vmnvm.m3u8
	              },
	              'filename': vmnvm.filename,
	              'image': vmnvm.image,
	              'custom_image':vmnvm.customThumb,
	              'thumbs':vmnvm.thumbsLocked,
	              'signature':vmnvm.upload_signature,
	              'status': 'draft',
	              'meta':{
	                'safe':vmnvm.safe
	              },
	              'allowance':vmnvm.geoAllow,
	              'encodingId': '',
	              'duration':vmnvm.duration,
	              'transcoding_status': 1,
	              "width":vmnvm.uploadVideoObj.width,
	              "height": vmnvm.uploadVideoObj.height,
	              "orientation": vmnvm.orientation
	            }
	  
	            $http.put(url , videoData)
	            .success(function (data, stat, headers) {
	                $rootScope.hasLoaded = true;
	                $state.go('app.allvideos', {id:vmnvm.videoNew._id});
	                alertService('success','Success ', data.message, 2000);   
	            })
	            .error(function (data, status, header, config) {
	              if(!window.navigator.onLine) {
	                offlineError()
	                $rootScope.hasLoaded = true;
	                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	                return
	              }
	              if(status ==401) {
	                  var promise = refreshtokenService.getAccessToken();
	                  promise.then(
	                    function(answer) {
	                      if(answer==200) {   
	                        updateFunction();
	                      }
	                    },
	                    function(error) {
	                    },
	                    function(progress) {
	                      // report progress
	              });
	              }else if(status ==502) {
	                  serverError()  
	              }else { 
	                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;
	            }); 
	        }    
	        if(validation) {
	            updateFunction();
	        }
	    }
	    $scope.$on("$destroy", function() {
	        $interval.cancel(loadedInterval);
	        loadedInterval = null
	    });
	  }	
	}


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('relatedVideoBoxDir',relatedVideoBoxDir);
		relatedVideoBoxDir.$inject=[];
		function relatedVideoBoxDir() {
			return {
				template: __webpack_require__(310),
				controller:"relatedVideoBoxController",
				controllerAs:"vmrvb",
				link: function(scope, element, attrs, ctrl) {
					    
				}
			}
		}
	}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = function(video) {
	  "use strict";
		video
	    .controller('relatedVideoBoxController', relatedVideoBoxController)
	
		relatedVideoBoxController.$inject = ["config","durationFormated","$http", "$rootScope","$scope","getDataService","$state", "$stateParams","refreshtokenService","reqursiveService","putDataService","alertService","$timeout","postDataService","deleteDataService","serverError", "API_URL","offlineError"];
		
	  function relatedVideoBoxController(config,durationFormated,$http,$rootScope,$scope,getDataService,$state, $stateParams,refreshtokenService, reqursiveService, putDataService, alertService, $timeout, postDataService,deleteDataService,serverError, API_URL, offlineError) {
	    var vmrvb = this;
	    var state = 'video';
	    vmrvb.config = config;
	    vmrvb.allWidgets= [];
	    vmrvb.minimumItem ={
	      ids:{       
	      },
	      number:2
	    }
	    vmrvb.duplicateVideo = {
	      ids:{
	
	      }
	    }
	    vmrvb.durationFormated = durationFormated;
	    vmrvb.addVideo = function(type) {
	      $rootScope.modalShow = true;
	      vmrvb.videoModalShow = true;
	      vmrvb.addCategory = type;
	    }
	    vmrvb.cancelVideoModal = function() {
	      $rootScope.modalShow = false;
	      vmrvb.videoModalShow = false;
	      vmrvb.addCategory = null;
	    }
	    vmrvb.thumbConvert = function(image) {
	      if(!image) return
	      return vmrvb.config.baseVideoHref + image.replace('.jpg','-254x191.jpg')
	    }
	    vmrvb.removeVideoFromWidget = function(categoryId,videoId) {
	      for (var i=0; i<vmrvb.allWidgets.length; i++) {
	        vmrvb.minimumItem.ids[vmrvb.allWidgets[i].category_id] = false;
	        if(vmrvb.allWidgets[i].category_id == categoryId) {
	          for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
	            if(vmrvb.allWidgets[i].videos[j].video_obj._id == videoId) {
	              if(vmrvb.allWidgets[i].videos.length<=2) {
	                vmrvb.minimumItem.ids[vmrvb.allWidgets[i].category_id] = true;
	                $timeout(function() {
	                  resetErrors(vmrvb.minimumItem)
	                },3000)
	              } else {
	                vmrvb.allWidgets[i].videos.splice(j,1)
	              }
	              break
	            }
	          }
	          break
	        }
	      }
	    }
	    function resetErrors (obj) {
	      for (var i=0; i<vmrvb.allWidgets.length; i++) {
	        $scope.$apply(function() {
	          obj.ids[vmrvb.allWidgets[i].category_id] = false;
	        })
	      }
	    }  
	    vmrvb.setVideoFunction = function(videoObj, category) {
	      if(!videoObj) return;
	      for (var i=0; i<vmrvb.allWidgets.length; i++) {
	        vmrvb.duplicateVideo.ids[vmrvb.allWidgets[i].category_id] = false;
	        if(vmrvb.allWidgets[i].category_id == category) {
	          vmrvb.minimumItem.ids[category] = false;
	          for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
	            if(videoObj._id == vmrvb.allWidgets[i].videos[j].video_obj._id) {
	              vmrvb.duplicateVideo.ids[vmrvb.allWidgets[i].category_id] = true;
	              $timeout(function() {
	                resetErrors(vmrvb.duplicateVideo)
	              },3000)
	              return 
	            }
	          }
	          vmrvb.allWidgets[i].videos.push({
	           'video_obj': videoObj,
	           'category_id': videoObj.category._id
	          })
	          break;
	        }
	      }
	    }
	    vmrvb.saveChanges = function() {
	      $rootScope.hasLoaded = false;
	      var videoIds = [];
	      for (var i=0; i<vmrvb.allWidgets.length; i++) {
	        for (var j=0; j<vmrvb.allWidgets[i].videos.length;j++) {
	          videoIds.push({
	            _id: vmrvb.allWidgets[i].videos[j]._id,
	            category_id: vmrvb.allWidgets[i].category_id,
	            order: vmrvb.allWidgets[i].videos[j].order,
	            video_id: vmrvb.allWidgets[i].videos[j].video_obj._id
	          })
	          // if(j==vmrvb.minimumItem.number - 1 ) break;
	        }
	      }
	      var postFunction = function() {
	        postDataService.save({
	          param1:state, 
	          param2: 'related', 
	        },{
	          'related': videoIds
	        }).$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(error.status == 401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	            function(answer) {
	              if(answer==200) {
	                postFunction();
	              }
	              // do something
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	            });
	          }else if(error.status ==502) {
	            serverError()
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        });
	      }
	      postFunction();
	    }
	    var getFunction = function() { 
	      getDataService.get({
	        param1: state,
	        param2: 'related'   
	      }).$promise.then(function(data){
	        vmrvb.allWidgets = data.related;
	      },function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                getFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }  
	      });
	    }
	    getFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  } 
	}
	  

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(media) {
		'use strict'
		media.directive('setFeaturedVideo',setFeaturedVideo);
		setFeaturedVideo.$inject=['$filter','config','$rootScope','getDataService','serverError','refreshtokenService','$timeout','reqursiveService', 'offlineError','alertService'];
		function setFeaturedVideo($filter,config,$rootScope,getDataService,serverError,refreshtokenService,$timeout,reqursiveService, offlineError, alertService) {
			return {
				restrict: 'E',
				scope: {
					currentPostObj:"=",
					scheduled:'='
				},
				template: __webpack_require__(317),
				link: function(scope, ele, $attrs, ctrl) {
					var s;
					scope.pageNumber = 1;
					var state = 'video';
					var category;
					scope.config = config;
					scope.selectedCategory={value:'all'};
					scope.videoDetails = {
						videoTitlePosition:{
							value:'top'
						},
						showVideoTitle: false,
						customVideoTitle:''
					}
					scope.disposeVideo = function() {
						if(scope.player) {
							scope.player.dispose();
							scope.player = null;
						}
					}
					scope.setFeaturedVideo = function() {
						scope.currentPostObj.selectedFeaturedVideo = scope.selectedVideoObj;
						$timeout(function(){
							if(scope.currentPostObj.addCategory) {
								scope.currentPostObj.setVideoFunction(scope.currentPostObj.selectedFeaturedVideo,scope.currentPostObj.addCategory)
							} else {
								if(scope.currentPostObj.setFeaturedVideoModal) {
									scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo);
								}
								// if(scope.currentPostObj.setFeaturedVideoRussiaModal) {
								// 	scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo,'russia')
									
								// } else {
								// 	scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo);
								// }
							}
							scope.currentPostObj.cancelVideoModal();
						},0)
					}
					scope.insertVideoToEditor = function() {
						scope.$parent.$parent.$broadcast('insert-telegraftv', { 
							videoId: scope.selectedVideoId,
							showVideoTitle: scope.videoDetails.showVideoTitle,
							title: scope.videoDetails.customVideoTitle,
							align: scope.videoDetails.videoTitlePosition.value
						});
					}
					scope.chooseVideo = function(index,video) {
	                  	scope.videoLoaded = false;
	                  	scope.selectedVideo = index;
	                  	scope.selectedVideoObj = video;
	                  	scope.selectedVideoId = video._id;
						if(scope.currentPostObj.insertVideoToEditorModal) {
							scope.videoDetails.customVideoTitle = video.title;
							scope.videoDetails.showVideoTitle = false;
							scope.videoDetails.videoTitlePosition.value='top';
						}
	                  	$timeout(function(){
	                    	videoplayerFunction(index);
							var posterDisplayRes = (scope.videoItems[index].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
	                    	scope.player.poster(scope.config.baseVideoHref + scope.videoItems[index].image.replace('.jpg',posterDisplayRes))
	                  	},0)
	                  // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.videoItems[index].image.replace('.jpg','-620x350.jpg')+')')
	              	}
		            scope.searchEmpty = function(value) {
		                if(value.length==0) {
		                  $timeout(function() {
		                    scope.search(value)
		                  },0)
		                }
		            }
		            scope.search =function(value) {
		                if(value.length>0) {
		                  s = value.toLowerCase();
		                } else if(value.length==0){
		                  s = null;
		                }
		                jQuery(".grid").animate({
		                  scrollTop: 0
		                }, 0);
		                scope.pageNumber = 1;
		                getimageLoadFunction();
		            }
		            var videoplayerFunction = function(index) {
		            	scope.player.on("play", function() {
		                  scope.$apply(function() {
		                    scope.durationFlag = false;
		                  })
		                });
		                scope.player.src({
		                  src: scope.videoItems[index].file_video,
		                    type: 'application/x-mpegURL',
		                    withCredentials: false
		                });
		                
		                scope.durationFlag = true;
		                scope.videoLoaded = true;
		            }
		            var getimageLoadFunction = function() {
		              $rootScope.hasLoaded = false;
		                getDataService.get({
		                  param1: state,
		                  param2: null,
		                  limit: 100,
		                  page:scope.pageNumber,
		                  s:s,
		                  status:(scope.scheduled)?'publish,schedule':'publish',
		                  category:category
		                }).$promise.then(function(data){
		                  $rootScope.hasLoaded = true;
		                  scope.emptyTable = false;
		                  scope.videoItems =data.videos;
		                  scope.maxPages = data.max_pages;
		                  for(var i=0; i<scope.videoItems.length;i++) {
							var thumbDisplayRes = (scope.videoItems[i].orientation=='portrait')?'-360x640.jpg' : '-254x191.jpg';
		                    scope.videoItems[i].thumb=scope.config.baseVideoHref + scope.videoItems[i].image.replace('.jpg',thumbDisplayRes); 
		                    scope.videoItems[i].file_video = scope.config.baseVideoHref + scope.videoItems[i].file.m3u8; 
		                    scope.videoItems[i].dateFormated = $filter('date')(scope.videoItems[i].date, "MMM d, y HH:mm")
		                    if(scope.videoItems[i].duration){
		                      var formatedTime;
		                      if(scope.videoItems[i].duration>=3600) {
		                        formatedTime = 'H:mm:ss'
		                      } else{
		                        formatedTime = 'm:ss'
		                      } 
		                      scope.videoItems[i].formated_duration = moment().startOf('day').second(scope.videoItems[i].duration).format(formatedTime);
		                    }
		                  }
		                  scope.selectedVideo = 0;
		                  scope.selectedVideoObj = scope.videoItems[0];
		                  scope.selectedVideoId = scope.videoItems[0]._id;
		                  scope.videoGet = true;
						  if(scope.currentPostObj.insertVideoToEditorModal) {
							scope.videoDetails.customVideoTitle = scope.videoItems[0].title;
							scope.videoDetails.showVideoTitle = false;
							scope.videoDetails.videoTitlePosition.value='top';
						  }
		                  if(!scope.player) {
		                    $timeout(function() {
							var posterDisplayRes = (scope.videoItems[0].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
		                    scope.player = videojs('my-player-directive',
		                    {
								poster:scope.config.baseVideoHref + scope.videoItems[0].image.replace('.jpg',posterDisplayRes),
								// playbackRates: [0.5, 1, 1.5, 2],
								autoplay:false
		                    });
		                      
		                      videoplayerFunction(0);
		                    },0)
		                  } else {
		                    $timeout(function() {
		                      	videoplayerFunction(0);
								var posterDisplayRes = (scope.videoItems[0].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
		                      	scope.player.poster(scope.config.baseVideoHref + scope.videoItems[0].image.replace('.jpg',posterDisplayRes));
		                    },0)
		                  }
		                }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								return
							}
		                  	if(error.status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {   
									getimageLoadFunction(s);
									}
								},
								function(error) {
								},
								function(progress) {
								// report progress
								});
							} else if(error.status ==502) {
									serverError()
							} else if(error.status ==404) {
								scope.emptyTable = true;
								scope.videoItems = [];
								scope.videoGet = false;
								scope.disposeVideo();
								scope.videoLoaded = false;
							} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true; 
		                }); 
		            }
		            getimageLoadFunction();
		            scope.resetAllFilters = function() {
		                jQuery(".grid").animate({
		                  scrollTop: 0
		                }, 0);
		                scope.searchData = null;
		                s =null;
		                category=null;
		                scope.pageNumber = 1;
		                scope.selectedCategory={value:'all'};
		                getimageLoadFunction();
		            }
		            scope.switchCategories = function(item) {
		                if(item=='all') {
		                  category = null;
		                } else {
		                  category = item;
		                }
		                jQuery(".grid").animate({
		                  scrollTop: 0
		                }, 0);
		                scope.pageNumber = 1;
		                getimageLoadFunction();
		            }
		            scope.categoryTreeFunction= function() {
		                scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
		                scope.categoriesTreeSelect = angular.copy(scope.categoriesTreeInput);
		                for(var i=0; i< scope.categoriesTreeSelect.length; i++) {
		                  var n = (scope.categoriesTreeSelect[i].ancestors.length)*2;
		                  var empty = "\u00A0";
		                  for(var j=0;j<n;j++) {
		                    scope.categoriesTreeSelect[i].name = empty+scope.categoriesTreeSelect[i].name;
		                  }
		                }
		            }
		            var getCategoriesFunction = function() {
		                getDataService.get({param1:'video-categories', tree:1}).$promise.then(function(data){      
		                  scope.categories = data.categories;
		                  scope.categoryTreeFunction();
		                  
		                }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								return
							}
		                  	if(error.status == 401) {
		                    var promise = refreshtokenService.getAccessToken();
		                      promise.then(
		                        function(answer) {
		                          if(answer==200) {
		                            getCategoriesFunction();
		                          }
		                        },
		                        function(error) {
		                          // report something
		                        },
		                        function(progress) {
		                         // report progress
		                        });
							} else if(error.status ==502) {
								serverError()
							}
		                });
		            }
		            getCategoriesFunction();
					scope.$on('$destroy',function() {
						scope.disposeVideo();
					})
		        }
			}
		}
	}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('videoCategoriesDir',videoCategoriesDir);
		videoCategoriesDir.$inject=[];
		function videoCategoriesDir() {
			return {
				template: __webpack_require__(311),
				controller:'videoCategoriesController',
				controllerAs:'vmvc',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = function(video) {
		"use strict";
	  video
	  .controller('videoCategoriesController', videoCategoriesController)
		videoCategoriesController.$inject = ["watchAllCheckboxesNgTable","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
		
	  function videoCategoriesController(watchAllCheckboxesNgTable,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
	    var vmvc = this;
	    var state = 'video-categories';
	    vmvc.categoryEdit = false;
	    $rootScope.alert={hasBeenShown: false};
	    $rootScope.hasLoaded = false;
	    vmvc.selectedName = -1;
	    vmvc.nameRequired = false;
	    vmvc.checkboxes = { 'checked': false, items: {} };
	    var $data;
	    var s;
	    var search;
	    var tree;
	    vmvc.categoryName = undefined;
	    vmvc.categorySlug = undefined;
	    vmvc.categoryDescription= undefined;
	    vmvc.selectedBulkAction = {value: 'default'};
	    vmvc.checkedPostsEdit = [];
	    vmvc.checkboxes = { items: {} };
	    vmvc.categoryId = $stateParams.id; 
	    if($stateParams.id) {
	      vmvc.categoryEdit = true;
	    } else {
	      vmvc.categoryEdit = false;
	    }
	    // add new category
	    vmvc.addNewCategory = function() {
	      if(vmvc.selectedCategory.value =='none') {
	        vmvc.selectedCategory.value = undefined;
	      }
	      if(vmvc.categoryName) {
	        var postFunction = function() {  
	          postDataService.save({
	            param1: state, 
	            param2: 'create'
	          },{
	            'name':vmvc.categoryName,
	            'parent': vmvc.selectedCategory.value,
	            "description": vmvc.categoryDescription,
	            'slug':vmvc.categorySlug
	          }).$promise.then(function(postCategory){
	            vmvc.categoryName = undefined;
	            vmvc.categorySlug = undefined;
	            vmvc.categoryDescription= undefined;
	            vmvc.selectedCategory.value ='none';
	            alertService('success','Success ', postCategory.message, 2000);
	            vmvc.getCategories();
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            } 
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              if(error && error.data && error.data.error && error.data.error.slug) {
	                vmvc.categorySlug = error.data.error.slug;
	              }
	              vmvc.selectedCategory.value ='none';
	            } 
	          });
	        }
	        postFunction();
	      } else {
	        vmvc.selectedCategory.value ='none';
	        alertService('danger','Opps! ', 'Category name is required')
	        vmvc.nameRequired=true;
	      }
	    }
	    vmvc.goToAllPosts = function(category) {
	      comunicateBetweenViews.setCategory(category);
	      $state.go('app.allvideos'); 
	    }
	    vmvc.quickEdit = function(id) {
	      vmvc.selectedName = id;
	    }
	    vmvc.cancelQuickEdit = function() {
	      vmvc.selectedName = -1;
	    }
	    vmvc.editCategory = function(categoryId) {
	      vmvc.categoryEdit= true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 10);
	      vmvc.categoryId = categoryId;
	      $state.transitionTo('app.video_categories', {id: vmvc.categoryId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmvc.updateBulkDeleteSuccess = function() {
	      watchAllCheckboxesNgTable.resetCheckBox(vmvc)
	      vmvc.selectedBulkAction = {value: 'default'};
	      vmvc.searchData = {name:''};
	      vmvc.getCategories('update'); 
	    }
	    watchAllCheckboxesNgTable.watch($scope,vmvc)
	    vmvc.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmvc.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmvc.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmvc.checkedPostsEdit.indexOf(id_tag);
	          vmvc.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    var tablePopulateFunction = function() {
	      vmvc.tableParams = new NgTableParams({
	        page: 1,
	        count: 20,
	       
	        }, {
	          total:vmvc.categoriesTreeInput.length,
	        getData: function(params) {
	          $data = vmvc.categoriesTreeInput; 
	          $data = params.sorting() ?
	          $filter('orderBy')($data, params.orderBy()) : $data;
	          $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	          vmvc.dataGet = $data;
	          jQuery('.goTo input').val("");
	          watchAllCheckboxesNgTable.resetCheckBox(vmvc)
	          if(vmvc.categoriesTreeInput.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            } 
	          return $data; 
	        }    
	      });  
	    }
	    vmvc.dataCategoryFunction = function(update) {
	      vmvc.categoryTreeFunction= function() {
	        vmvc.categoriesTreeInput = reqursiveService.getReqursiveArray(vmvc.data);
	        vmvc.copycategoriesTreeInput = angular.copy(vmvc.categoriesTreeInput);
	        vmvc.categoriesTreeSelect = angular.copy(vmvc.categoriesTreeInput);
	        for(var i=0; i< vmvc.categoriesTreeSelect.length; i++) {
	          var n = (vmvc.categoriesTreeSelect[i].ancestors.length)*2;
	          var empty = "\u00A0";
	          for(var j=0;j<n;j++) {
	            vmvc.categoriesTreeSelect[i].name = empty+vmvc.categoriesTreeSelect[i].name;
	          }
	        }
	      }
	      vmvc.categoryTreeFunction();
	      vmvc.selectedCategory= {value: 'none'};
	      if(update) {
	        vmvc.tableParams.reload()
	      } else {
	        tablePopulateFunction()
	      }
	    }
	    vmvc.changeSearch = function(searchData) {
	      vmvc.categoriesTreeInput = (searchData.name)? reqursiveService.getReqursiveArray($filter('filter')(vmvc.copycategoriesTreeInput,searchData)) : vmvc.copycategoriesTreeInput; 
	      vmvc.categoriesTreeInput = checkArray.removeObjArryDuplicate(vmvc.categoriesTreeInput)
	      tablePopulateFunction()
	    }
	    vmvc.getCategories = function(update) {
	      var getCategoriesFunction = function() {
	        getDataService.get({param1: state, param2: null,tree:tree}).$promise.then(function(data){
	          vmvc.data = data.categories;
	          vmvc.dataCategoryFunction(update);
	          $rootScope.hasLoaded = true;
	        }, function(error){
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            return
	          }
	          if(error.status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getCategoriesFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          } else if(error.status ==502) {
	            serverError()
	          } else if(error.status ==404) {
	            $rootScope.emptyTable = true;
	          } else {
	            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      getCategoriesFunction();
	    }
	    vmvc.getCategories();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('videoCategoryEditDir',videoCategoryEditDir);
		videoCategoryEditDir.$inject=[];
		function videoCategoryEditDir() {
			return {
				template: __webpack_require__(312),
				controller:'videoCategoryEditController',
				controllerAs:'vmvce',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = function(video) {
		"use strict";
	  video
	  .controller('videoCategoryEditController', videoCategoryEditController)
		videoCategoryEditController.$inject = ["$attrs","$scope","$state","$stateParams","getDataService","refreshtokenService","reqursiveService","putDataService","alertService","$rootScope","serverError","offlineError"]
		
	  function videoCategoryEditController($attrs,$scope,$state,$stateParams,getDataService,refreshtokenService,reqursiveService, putDataService, alertService,$rootScope,serverError,offlineError) {
	    var vmvce = this;
	    var state = 'video-categories'
	    $scope.parent = $scope.$eval($attrs.parent);
	    $rootScope.closeEditVideoCategory = function() {
	      $scope.parent.categoryEdit = false;
	      vmvce.category = null;
	      vmvce.selectedCategory= {value: 'none'};
	      $state.transitionTo('app.video_categories', {id: null}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmvce.categoryId = $scope.parent.categoryId;
	    var getCategoryFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:state, param2: vmvce.categoryId}).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        vmvce.category = data;
	        // vmvce.getAllCategories();
	        if(vmvce.category.parent) {
	          vmvce.selectedCategory= {value: vmvce.category.parent};
	        } else {
	          vmvce.selectedCategory= {value: 'none'};
	        }
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getCategoryFunction();
	              }
	              // do something
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        }  else {
	          $scope.parent.categoryEdit = false;
	          $state.transitionTo('app.video_categories', {id: null}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	          });
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    getCategoryFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('videoTagEditDir',videoTagEditDir);
		videoTagEditDir.$inject=[];
		function videoTagEditDir() {
			return {
				template: __webpack_require__(313),
				controller:'videoTagEditController',
				controllerAs:'vmvte',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = function(video) {
		"use strict";
	  video
	  .controller('videoTagEditController', videoTagEditController)
		videoTagEditController.$inject = ["$scope","$state","$stateParams","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","offlineError"]
		
	  function videoTagEditController($scope,$state,$stateParams,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError,offlineError) {
	    var vmvte = this;
	    $scope.parent = $scope.$eval($attrs.parent);
	    vmvte.tagId = $scope.parent.tagId;
	    vmvte.loadCategory= false;
	    var state = 'video-tags'; 
	    vmvte.disabled = true;
	    $rootScope.closeEditVideoTag = function() {
	      $scope.parent.tagEdit = false;
	      vmvte.tag = null;
	      $state.transitionTo('app.video_tags', {id: null}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    var getTagFunction = function() {
	      $rootScope.hasLoaded = false;
	      getDataService.get({param1:state, param2: vmvte.tagId}).$promise.then(function(data){
	        $rootScope.hasLoaded = true;
	        vmvte.tag = data;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {
	                getTagFunction();
	              }
	            },
	            function(error) {
	            },
	            function(progress) {
	             // report progress
	          });
	        } else if(error.status ==502) {
	          serverError()
	        } else {
	          $scope.parent.tagEdit = false;
	          $state.transitionTo('app.video_tags', {id: null}, {
	            location: true,
	            inherit: true,
	            relative: $state.$current,
	            notify: false
	          });
	        }
	        $rootScope.hasLoaded = true;
	      }); 
	    }
	    getTagFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('videoTagsDir',videoTagsDir);
		videoTagsDir.$inject=[];
		function videoTagsDir() {
			return {
				template: __webpack_require__(314),
				controller:'videoTagsController',
				controllerAs:'vmvt',
				link: function(scope, element, attrs, ctrl) {
					    
				}
	
			}
		}
	}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = function(video) {
		'use strict'
	  video
	  .controller('videoTagsController', videoTagsController)
		videoTagsController.$inject = ["watchAllCheckboxesNgTable","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","postDataService","alertService", "deleteDataService","putDataService","serverError","comunicateBetweenViews", "offlineError"]
		
	  function videoTagsController(watchAllCheckboxesNgTable,$stateParams,$state,$scope,$rootScope,NgTableParams,getDataService,refreshtokenService, postDataService,alertService, deleteDataService, putDataService,serverError, comunicateBetweenViews, offlineError) {
	    var vmvt = this;
	    vmvt.tagEdit = false;
	    var state = 'video-tags';
	    var page;  
	    var s;
	    var $data;
	    $rootScope.alert={hasBeenShown: false};
	    $rootScope.hasLoaded = false;
	    vmvt.selectedName = -1;
	    vmvt.hasParent = {items:{}};
	    vmvt.tagName = undefined;
	    vmvt.tagSlug = undefined;
	    vmvt.tagDescription= undefined;
	    vmvt.selectedBulkAction = {value: 'default'};
	    vmvt.checkedPostsEdit = [];
	    vmvt.checkboxes = { 'checked': false, items: {} };
	    $rootScope.emptyTable = false;
	    vmvt.tagId = $stateParams.id; 
	    if($stateParams.id) {
	      vmvt.tagEdit= true;
	    } else {
	      vmvt.tagEdit = false;
	    }
	    vmvt.goToAllPosts = function(tag) {
	      comunicateBetweenViews.setTag(tag);
	      $state.go('app.allvideos'); 
	    }
	    vmvt.editTag = function(tagId,tagCount) {
	      vmvt.tagEdit= true;
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 10);
	      vmvt.tagId = tagId;
	      $state.transitionTo('app.video_tags', {id: vmvt.tagId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmvt.addNewTag = function() {
	
	      if(vmvt.tagName) {
	        $rootScope.hasLoaded = false;
	        var postFunction = function() {
	          postDataService.save({
	            param1:state
	          },{
	            'name':vmvt.tagName,
	            "description": vmvt.tagDescription,
	            'slug':vmvt.tagSlug
	          }).$promise.then(function(postTag){ 
	            vmvt.tagName = undefined;
	            vmvt.tagSlug = undefined;
	            vmvt.tagDescription= undefined;
	            alertService('success','Success ', postTag.message, 2000);
	            $rootScope.hasLoaded = true;
	            vmvt.tableReloadFunction(vmvt.tableParams.page());
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError()
	              $rootScope.hasLoaded = true;
	              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	              return
	            }
	            if(error.status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    postFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                 // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              if(error && error.data && error.data.error && error.data.error.slug) {
	                vmvt.tagSlug = error.data.error.slug;
	              }
	            }
	            $rootScope.hasLoaded = true;  
	          });
	        }
	        postFunction();
	      } else {
	        alertService('danger','Opps! ', 'Tag is required')
	        vmvt.nameRequired=true;
	      }
	    }
	   
	    vmvt.quickEdit = function(id) {
	      vmvt.selectedName = id;
	    }
	    vmvt.cancelQuickEdit = function() {
	      vmvt.selectedName = -1;
	    }
	    vmvt.reloadTable = function() {
	      vmvt.tableParams.reload()
	    }
	    vmvt.updateBulkDeleteSuccess = function() {
	      watchAllCheckboxesNgTable.resetCheckBox(vmvt)
	      vmvt.selectedBulkAction = {value: 'default'};
	      vmvt.tableParams.reload(); 
	    }
	    watchAllCheckboxesNgTable.watch($scope,vmvt)
	    vmvt.checkedPost = function(categoryId, checked) {
	      if(checked) {
	        vmvt.checkedPostsEdit.push(categoryId);
	      } else {
	
	        if(vmvt.checkedPostsEdit.includes(categoryId)) {
	          var id_tag = categoryId;
	          var position = vmvt.checkedPostsEdit.indexOf(id_tag);
	          vmvt.checkedPostsEdit.splice(position, 1);
	        }
	      }
	    }
	    vmvt.tableActionsFunction = function(params) {
	      vmvt.search =function(value) {
	        if(value) {  
	          s = value.toLowerCase();
	        } else {
	          s = null;
	        }
	        page = 1;
	        params.page(page);
	        vmvt.tableParams.reload();
	      }
	    }
	    vmvt.tableReloadFunction = function(page) {
	      vmvt.tableParams = new NgTableParams({
	        page: page || 1,
	        count: 20,
	              
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            page: params.page(),
	            limit: params.count(),
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            s:s
	            }).$promise.then(function(data){
	           
	            $rootScope.hasLoaded = true;
	            $data =data.tags;
	            vmvt.dataGet = data.tags;
	            params.total(data.count);
	            params.numPages(data.max_pages);
	            jQuery('.goTo input').val("");
	            if(data.tags.length == 0) {
	              $rootScope.emptyTable = true;
	            } else {
	              $rootScope.emptyTable = false;
	            }
	            watchAllCheckboxesNgTable.resetCheckBox(vmvt)
	            vmvt.tableActionsFunction(params);  
	            return $data;
	          }, function(error){
	            if(!window.navigator.onLine) {
	              offlineError('refresh')
	              $rootScope.hasLoaded = true;
	              return
	            }
	            if(error.status ==401) {
	              
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	              function(answer) {
	                if(answer==200) {
	                  vmvt.tableReloadFunction(params.page());
	                }
	                // do something
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	              });
	            } else if(error.status ==502) {
	              serverError()
	            } else if(error.status ==404) {
	              $rootScope.emptyTable = true;
	            } else {
	              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.'); 
	            }
	            $rootScope.hasLoaded = true;
	            vmvt.tableActionsFunction(params);
	          });
	        }    
	      });   
	    }
	    vmvt.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var video = angular.module('videoModule',[
		'ui.router',
		'servicesModule',
		'ngResource',
		"ngTable",
		'ngBootstrap',
		'ui.tinymce',
		'thatisuday.dropzone'	
	]);
	
	__webpack_require__(660)(video);
	__webpack_require__(659)(video);
	__webpack_require__(642)(video);
	__webpack_require__(645)(video);
	__webpack_require__(643)(video);
	__webpack_require__(646)(video);
	__webpack_require__(644)(video);
	__webpack_require__(661)(video);
	__webpack_require__(650)(video);
	__webpack_require__(651)(video);
	
	__webpack_require__(656)(video);
	__webpack_require__(657)(video);
	
	__webpack_require__(652)(video);
	__webpack_require__(653)(video);
	
	__webpack_require__(654)(video);
	__webpack_require__(655)(video);
	__webpack_require__(649)(video);
	
	__webpack_require__(640)(video);
	__webpack_require__(641)(video);
	__webpack_require__(647)(video);
	__webpack_require__(648)(video);

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = function(video) {
		"use strict";
	  video
	  .controller('allVideosController', allVideosController);
		allVideosController.$inject = ["addToOther","$http","API_URL","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","reqursiveService","deleteDataService","comunicateBetweenViews","offlineError"];
		
	  function allVideosController(addToOther, $http,API_URL,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,reqursiveService, deleteDataService, comunicateBetweenViews,offlineError) {
	    var vmav = this;
	    vmav.config = config;
	    $rootScope.emptyTable = false;
	    vmav.editMediaModalShow = false;
	    vmav.showGrid = false;
	    vmav.selectedImage = -1;
	    vmav.editVideoShow = false;
	    vmav.selectedMediatoEdit = 0;
	    vmav.commentPostId = null;
	    vmav.commentsType = 'video';
	    var state = 'video';
	    var page = 1;
	    var author;
	    var date_start;
	    var date_end;
	    var sortby ='date';
	    var s;
	    var category;
	    var $data;
	    var tag;
	    vmav.status = 'publish';
	    var status = vmav.status;
	    vmav.attachmentId = $stateParams.id;
	    vmav.selectedCategory = {value: 'all'};
	    vmav.selectedAuthorFilter = {value: 'all'};
	    if($stateParams.id) {
	      vmav.editVideoShow = true;
	    } else {
	      vmav.editVideoShow = false;
	    }
	    if(comunicateBetweenViews.getCategory()) {
	      category = comunicateBetweenViews.getCategory();
	      vmav.selectedCategory= {value: category};
	      comunicateBetweenViews.setCategory(null);
	    }
	    if(comunicateBetweenViews.getTag()) {
	      tag = comunicateBetweenViews.getTag();
	      comunicateBetweenViews.setTag(null);
	    }
	    $scope.ranges = {
	      'Today': [moment().startOf('day'), moment()],
	      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
	      'Last 7 days': [moment().subtract('days', 7), moment()],
	      'Last 30 days': [moment().subtract('days', 30), moment()],
	      'This month': [moment().startOf('month'), moment().endOf('month')],
	      'All days':[moment().subtract('year',5),moment()]
	    };
	    vmav.searchComment = function(count,postId) {
	      vmav.commentPostId =  postId;           
	      vmav.serchCommentsModalShow = true;
	      $rootScope.modalShow = true;
	    } 
	    vmav.closeSearchComment = function() {
	      vmav.serchCommentsModalShow = false;
	      $rootScope.modalShow = false;
	      vmav.commentPostId = null;
	    }
	    vmav.addToOther = addToOther;
	    vmav.editVideo = function(attachmentId) {
	      jQuery("html, body").animate({
	        scrollTop: 0
	      }, 600);
	      vmav.attachmentId = attachmentId;
	      vmav.editVideoShow = true;
	      $state.transitionTo('app.allvideos', {id: vmav.attachmentId}, {
	        location: true,
	        inherit: true,
	        relative: $state.$current,
	        notify: false
	      });
	    }
	    vmav.getGrid = function() {
	      var grid_wrapp = angular.element(document.getElementsByClassName("grid-wrapper"));
	      var table = angular.element(document.getElementsByClassName("table"));
	      table.after(grid_wrapp);    
	    }
	    vmav.updateStatusPost = function(video_id,videoStatus) {
	      var updateFunction = function() {
	        $rootScope.hasLoaded = false;
	        var url = API_URL + state + '/status';
	        var videoData = {
	            'status': videoStatus,
	            'id':video_id
	        } 
	        $http.put(url , videoData)
	        .success(function (data, stat, headers) {
	            $rootScope.hasLoaded = true;
	            alertService('success','Success ', data.message, 2000);
	            vmav.tableParams.reload();  
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	              var promise = refreshtokenService.getAccessToken();
	              promise.then(
	                function(answer) {
	                  if(answer==200) {   
	                    updateFunction();
	                  }
	                },
	                function(error) {
	                },
	                function(progress) {
	                  // report progress
	          });
	          }else if(status ==502) {
	              serverError()  
	          }else { 
	              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      updateFunction();    
	    }
	    var deleteFunction = function(videoId) {
	      deleteDataService.remove({
	        param1:state, 
	        param2: videoId,
	        })
	        .$promise.then(function(data){
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	          vmav.tableParams.reload();
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          $rootScope.hasLoaded = true;
	          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	          return
	        }
	        if(error.status ==401) {
	          var promise = refreshtokenService.getAccessToken();
	          promise.then(
	            function(answer) {
	              if(answer==200) {   
	                deleteFunction();
	              }
	            },
	            function(error) {
	              // report something
	            },
	            function(progress) {
	             // report progress
	          });
	        }else if(error.status ==502) {
	          serverError();
	        } else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	        $rootScope.hasLoaded = true;
	      });
	    }
	    var updateOrder = function(url,order) {
	      var updateDataPost = {
	        "order": parseInt(order)
	      }
	      var updateFunction = function() {
	        $http.put(url , updateDataPost)
	        .success(function (data, stat, headers) {
	          $rootScope.hasLoaded = true;
	          alertService('success','Success ', data.message, 2000);
	        })
	        .error(function (data, status, header, config) {
	          if(!window.navigator.onLine) {
	            offlineError()
	            $rootScope.hasLoaded = true;
	            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
	            return
	          }
	          if(status ==401) {
	            var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {   
	                  updateFunction();
	                }
	              },
	              function(error) {
	              },
	              function(progress) {
	               // report progress
	            });
	          }else if(status ==502) {
	            serverError()  
	          } else { 
	            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
	          }
	          $rootScope.hasLoaded = true;
	        }); 
	      }
	      updateFunction();
	    }
	    vmav.changeOrder = function() {
	      vmav.changeOrderFlag = true;
	    }
	    vmav.outOrderFocus = function(postId,order) {
	      if(vmav.changeOrderFlag) {
	        $rootScope.hasLoaded = false;
	        vmav.changeOrderFlag = false;
	        updateOrder(API_URL+ "video/order/"+postId,order);
	      }
	    }
	    vmav.updateOrder = function(postId,order) {
	      updateOrder(API_URL+ "posts/"+postId,order);
	    }
	    vmav.deletePosts = function(post_id) {
	      deleteFunction(post_id);  
	    }
	    vmav.categoryTreeFunction= function() {
	      vmav.categoriesTreeInput = reqursiveService.getReqursiveArray(vmav.categories);
	      vmav.categoriesTreeSelect = angular.copy(vmav.categoriesTreeInput);
	      for(var i=0; i< vmav.categoriesTreeSelect.length; i++) {
	        var n = (vmav.categoriesTreeSelect[i].ancestors.length)*2;
	        var empty = "\u00A0";
	        for(var j=0;j<n;j++) {
	          vmav.categoriesTreeSelect[i].name = empty+vmav.categoriesTreeSelect[i].name;
	        }
	      }
	    }
	    var getCategoriesFunction = function() {
	      getDataService.get({param1:'video-categories', tree:1}).$promise.then(function(data){      
	        vmav.loadCategory= true;
	        vmav.categories = data.categories;
	        vmav.categoryTreeFunction();
	        
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getCategoriesFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }
	      });
	    }
	    getCategoriesFunction();
	    var getAuthorsFunction = function() {
	      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
	        vmav.authorList = data.users;
	      }, function(error){
	        if(!window.navigator.onLine) {
	          offlineError()
	          return
	        }
	        if(error.status == 401) {
	          var promise = refreshtokenService.getAccessToken();
	            promise.then(
	              function(answer) {
	                if(answer==200) {
	                  getAuthorsFunction();
	                }
	              },
	              function(error) {
	                // report something
	              },
	              function(progress) {
	               // report progress
	              });
	        } else if(error.status ==502) {
	          serverError()
	        }else {
	          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	        }
	      });
	    }
	    getAuthorsFunction();
	    var reloadTableFunction = function() {
	      if(vmav.tableParams.page() ==1) {
	        vmav.tableParams.reload();
	      } else {
	        vmav.tableParams.page(1);
	      }
	    } 
	    vmav.changeSearch = function(search_data) {
	      if(search_data) {
	        s = search_data;
	      } else {
	        s = null;
	        $timeout(function() {
	          vmav.search();
	        },0)            
	      }
	    }
	    vmav.switchCategories = function(item) {
	      category = item;
	      if (item =='all') {
	          category = null;
	      }
	    }
	    vmav.switchAuthorFilter = function(item) {
	      author = item;
	      if (item=='all') {
	        author = null;
	      }
	    }
	    vmav.changeDate = function(value) {
	      vmav.dateRangevalue= value;
	      if(vmav.dateRangevalue) {
	        if(value.startDate && value.endDate) {
	          date_start = value.startDate.format('YYYY-MM-DD');
	          date_end = value.endDate.format('YYYY-MM-DD');
	        } else {
	          date_start = null;
	          date_end = null;
	        }
	      } else {
	        date_start = null;
	        date_end = null;
	      }
	    }
	    vmav.mediaFilters = function() {
	      reloadTableFunction();
	    }
	    vmav.resetAllFilters = function() {
	      vmav.status = 'publish';
	      status = vmav.status;
	      vmav.searchData = null;
	      s =null;
	      category=null;
	      author = null;
	      date_start = null;
	      date_end = null;
	      tag = null;
	      vmav.selectedCategory = {value: 'all'};
	      vmav.selectedAuthorFilter = {value: 'all'};
	      $scope.$broadcast('clear-daterange',true);
	      reloadTableFunction();
	    }
	    vmav.authorPosts = function(value) {
	      author = value;
	      reloadTableFunction();
	    }
	    vmav.categoryPosts = function(value) {
	      category = value;
	      reloadTableFunction();
	    }
	    vmav.tagPosts = function(value) {
	      tag = value;
	      reloadTableFunction();
	    }
	    vmav.changeStatus =function(event,activeStatus) {
	      vmav.status = activeStatus; 
	      if(activeStatus == 'all') {
	        status = null;
	      } else {
	        status = activeStatus;
	      }
	      if(activeStatus == 'trash') {
	        vmav.statusTrash = true;
	      } else {
	        vmav.statusTrash = false;
	      }
	      reloadTableFunction();
	    }
	    vmav.search =function(value) {
	      if(value) {
	        s = value.toLowerCase();
	      } else {
	        s = null;
	      }
	      reloadTableFunction();
	    }
	    vmav.tableReloadFunction = function(page) { 
	      vmav.tableParams = new NgTableParams({
	          page: page || 1,
	          count: 20,
	        }, {
	        getData: function(params) {
	          $rootScope.hasLoaded = false;
	          return getDataService.get({
	            param1: state,
	            param2: null,
	            page: params.page(),
	            limit: params.count(),
	            author: author,
	            s:s,
	            status:status,
	            category:category,
	            tag:tag,
	            sortby: $rootScope.sortby,
	            sort : $rootScope.sort,
	            date_start: date_start,
	            date_end: date_end
	            }).$promise.then(function(data){
	              $rootScope.hasLoaded = true;
	              vmav.dataGet = data.videos;
	              vmav.data_grid =data.videos;
	              $data =data.videos;
	              for(var i = 0; i < $data.length;i++) {
	                if($data[i].image && vmav.config.baseVideoHref) {
	                  var displayRes = ($data[i].orientation=='portrait')?'-360x640.jpg' : '-254x191.jpg';
	                  $data[i].imageThumb = vmav.config.baseVideoHref + $data[i].image.replace('.jpg',displayRes)
	                }
	                if($data[i].duration){
	                  var formatedTime;
	                  if($data[i].duration>=3600) {
	                    formatedTime = 'H:mm:ss'
	                  } else{
	                    formatedTime = 'm:ss'
	                  }
	                  $data[i].formated_duration = moment().startOf('day').second($data[i].duration).format(formatedTime);
	                }
	              }
	              $rootScope.emptyTable = false;
	              params.total(data.count);
	              params.numPages(data.max_pages);
	              jQuery('.goTo input').val("");
	              if(vmav.showGrid){
	                $timeout(function() {
	                  vmav.getGrid();
	                },0)
	              }
	              return $data;
	            }, function(error){
	              if(!window.navigator.onLine) {
	                offlineError('refresh')
	                $rootScope.hasLoaded = true;
	                return
	              }
	              if(error.status ==401) {
	                var promise = refreshtokenService.getAccessToken();
	                promise.then(
	                  function(answer) {
	                    if(answer==200) {
	                      vmav.tableReloadFunction(params.page());
	                    }
	                    // do something
	                  },
	                  function(error) {
	                  },
	                  function(progress) {
	                   // report progress
	                  });
	              } else if(error.status ==404) {
	                $rootScope.emptyTable = true;
	              } else if(error.status ==502) {
	                serverError();
	              } else {
	                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
	              }
	              $rootScope.hasLoaded = true;
	            });
	          }    
	      });
	    }
	    vmav.tableReloadFunction();
	    if(!window.navigator.onLine) {
	      offlineError('refresh')
	      return
	    }
	  }	
	}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('allVideosDir',allVideosDir);
		allVideosDir.$inject=[];
		function allVideosDir() {
			return {
				restrict: 'E',
				template: __webpack_require__(315),
				controller:'allVideosController',
				controllerAs:'vmav',
				link: function(scope, element, attrs, ctrl) {
					
				}
	
			}
		}
	}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(video) {
		'use strict'
		video.directive('videoEditDir',videoEditDir);
		videoEditDir.$inject=['fileReaderImage','addToOther','jQuery','$http','API_URL','cleanObj','$filter','authtokenService','config','$rootScope','$state','getDataService','refreshtokenService','serverError','alertService','postDataService','deleteDataService','putDataService','$timeout','keyPress', 'checkArray', 'reqursiveService','offlineError'];
		function videoEditDir(fileReaderImage,addToOther,jQuery,$http,API_URL,cleanObj,$filter,authtokenService,config,$rootScope,$state,getDataService,refreshtokenService,serverError,alertService,postDataService,deleteDataService,putDataService,$timeout,keyPress, checkArray, reqursiveService, offlineError) {
			return {
				restrict: 'E',
				scope:{
					media:'='
				},
			template: __webpack_require__(316),
			link: function(scope, ele, $attrs, ctrl) {
				var state ='video';
				// var parent = scope.$eval($attrs.media);
				// console.log(parent)
				scope.videoGet = false;
				scope.config = config;
				scope.existTag = false;
				scope.editMediaCurrent = null;
				scope.titleRequired = false;
				scope.newTagRequired = false;
				scope.attachmentId = scope.media.attachmentId;
				scope.imageLocked = false;
				scope.categorychecked = {item: {}};
				scope.editSlugShow = false;
				scope.copyEditSlug = false;
				scope.copySlug = null;
				scope.uploadedThumb = false;
				Dropzone.autoDiscover = false;
				var updateDate = null;
				var tagPosts = null;
				scope.publishedSlug = null;
				scope.editPostStatusShow = false;
				scope.videoGet = false;
				scope.videoLoaded = false;
				scope.safe = 'safe';
				scope.safeSelected = 0;
				scope.checkedItems = {};
				scope.videoSafeRequired = false;
				scope.videoVersion = scope.config.videoUploadVersion;
	    		scope.geoAllowance = config.geoRestrictions;
			    scope.allowCheckedItems = {};
				scope.addToOther = addToOther;
			    var geoAllowanceUpdateFunction = function() {
			      	for(var i=0; i<scope.geoAllowance.length;i++) {
			        	scope.allowCheckedItems[scope.geoAllowance[i]._id] = false;
			      	}
			    }
			    geoAllowanceUpdateFunction();
			    scope.allowCheckedItems[scope.geoAllowance[0]._id] = true;
			    scope.geoAllow = scope.geoAllowance[0]._id;
				var posterDisplayRes;
			    var thumbDisplayRes;
				scope.updateAllowance = function(allowance) {
			    	if(scope.allowCheckedItems[allowance]) {
			      		putGeoAllowanceFunction(allowance);
			    	}
			      	geoAllowanceUpdateFunction();
			      	scope.allowCheckedItems[allowance] = true;
			    }
			    var putGeoAllowanceFunction = function(allowance) {
					var geoUrl;
					if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
						geoUrl = API_URL + 'video/georestrictions/mediaoutcast/'+ scope.editMediaCurrent._id
					} else {
						geoUrl = API_URL + 'video/georestrictions/'+ scope.editMediaCurrent._id
					}
			      	var updateDataPosts = {
			        	"allowance": allowance,
			        	"video_id": scope.editMediaCurrent.video_id,
			        	"isUpdate": true
			      	}
			      	var putFunction = function() {
			        	$http.put(geoUrl , updateDataPosts)
			        	.success(function (data, status, headers) {
			           		alertService('success','Success ', data.message, 2000);
			           		scope.geoAllow = allowance;
			        	})
			        	.error(function (data, status, header, config) {
							if(!window.navigator.onLine) {
								offlineError()
								geoAllowanceUpdateFunction();
			          			scope.allowCheckedItems[scope.geoAllow] = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				          	if(status ==401) {
					            var promise = refreshtokenService.getAccessToken();
					            promise.then(
					              function(answer) {
					                if(answer==200) {   
					                  putFunction();
					                }
					              },
					              function(error) {
					                // report something
					              },
					              function(progress) {
					               // report progress
					            });
				          	}else if(status ==502) {
				            	serverError();
				          	} else {  
				            	alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
				           
				          	}
				          	geoAllowanceUpdateFunction();
			          		scope.allowCheckedItems[scope.geoAllow] = true;
			        	});
			      	}
			      	putFunction();
			    }
				var publishPostFunction = function(url, state, status) {
			      	var validatePublish = true;
			      	var putFunction = function() {
			        
				        if(status=='publish') {
				          scope.editMediaCurrent.status = 'publish'
				          if(scope.scheduledPost) {
				            scope.editMediaCurrent.status = 'schedule';
				          }
				        } else if(status=='trash') {
				          scope.editMediaCurrent.status = 'trash'
				        }
				        var updateDataPost = {
					        'video_id':scope.editMediaCurrent.video_id,
			                'title': (scope.editMediaCurrent.title)? (scope.editMediaCurrent.title).replace(/\r?\n|\r/g, ' '): '',
			                'subtitle': (scope.editMediaCurrent.subtitle)? (scope.editMediaCurrent.subtitle).replace(/\r?\n|\r/g, ' '): '',
			                'category':scope.category,
			                'tags': tagPosts,
			                'file':scope.editMediaCurrent.file,
			                'image': scope.image,
			                'custom_image':scope.customThumbsLocked,
			                'thumbs':scope.thumbsLocked,
			                'signature':scope.editMediaCurrent.signature,
			                'status': scope.editMediaCurrent.status,
			                "date": updateDate,
			                "order": scope.editMediaCurrent.order,
							"moderator_guide":scope.editMediaCurrent.moderator_guide,
			                "meta" : {
			                	"safe": scope.safe
			                },
			                "allowance":scope.geoAllow
						}
						if( scope.postSlug != scope.copySlug) {
							updateDataPost.slug = scope.postSlug;
							if(!updateDataPost.slug) {
								updateDataPost.slug = ''
							}
							updateDataPost.meta.autoslug = 'false';
						}
				        cleanObj.clean(updateDataPost);
				        var updateFunction = function() {
				        	$rootScope.hasLoaded = false;
				            $http.put(url , updateDataPost)
				            .success(function (data, stat, headers) {
				              	updateDataPost = {};
				              	$rootScope.hasLoaded = true;
				                if(status=='trash') {
				                  scope.media.editVideoShow = false;
				                  $state.transitionTo('app.allvideos', {id: null}, {
				                    location: true,
				                    inherit: true,
				                    relative: $state.$current,
				                    notify: false
				                  });
				                }else {
				                	getVideoCategoriesFunction();
				                } 
				              	alertService('success','Success ', data.message, 2000);
				            })
				            .error(function (data, status, header, config) {
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if(status ==401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
									function(answer) {
										if(answer==200) {   
										updateFunction();
										}
									},
									function(error) {
									},
									function(progress) {
									// report progress
									});
								}else if(status ==502) {
									if(state=="save") {
									serverError()  
									}
								} else if(status==400) {
									scope.scheduledPost = false;
									scope.editMediaCurrent.status = 'draft';
									alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
								} else { 
									if(state=="save") {
									alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
									}
								}
								updateDataPost = {};
								$rootScope.hasLoaded = true;
				            });
			        	}
			        	updateFunction();
				    }
			      
				    if(scope.editMediaCurrent.tags.length>0) {
				        scope.newTagRequired = false;
				        tagPosts = scope.editMediaCurrent.tags
				    } else {
				      	validatePublish = false;
				      	scope.newTagRequired = true;
				      	tagPosts = null;
				    }
			      if(scope.editSlugShow) {
							validatePublish = false;
							alertService('danger','Opps! ', 'Cancel or edit permalink');
						}
			    
						if(scope.editMediaCurrent.title) {
							scope.titleRequired = false;
						} else {
							scope.titleRequired = true;
							alertService('danger','Opps! ', 'Title is required');
							validatePublish = false;
						}
						if(scope.titleExceed) {
							validatePublish = false;
							alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
							}
						if(!updateDate) {
							updateDate = moment().toISOString();
						}
						if(scope.category) {
							scope.categoryRequired = false;
						} else {
							scope.categoryRequired = true;
							alertService('danger','Opps! ', 'Category is required')
							validatePublish = false;
						}
						if(!scope.safe) {
							scope.videoSafeRequired = true;
							validatePublish = false;
							alertService('danger','Opps! ', 'Video safety is required')
						} else {
							scope.videoSafeRequired = false;
						}
						if(validatePublish) {
							putFunction();
						}
			        
			    }
				function getSaveUrl() {
					if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
						return API_URL + "video/mediaoutcast/"+scope.editMediaCurrent._id
					} else {
						return API_URL + "video/"+scope.editMediaCurrent._id
					}
				}
			    scope.publishPost = function() {
					var url = getSaveUrl()
			      	publishPostFunction(url, 'save', 'publish');
			    }
			    scope.trashPost = function() {
					var url = getSaveUrl()
			      publishPostFunction(url, 'save', 'trash');
			    }
			    scope.updateorSavePost =  function() {
					var url = getSaveUrl()
			      publishPostFunction(url, 'save', undefined);
			    }
				scope.dzOptionsThumb = {
					url : 'https://upload.telegraf.tv',
			        paramName : 'filename',
			        maxFilesize : '500000',
			        parallelUploads: 1,  
			        acceptedFiles : 'image/jpeg, images/jpg',
			        addRemoveLinks : true,
			        autoProcessQueue : false,
			        dictInvalidFileType: 'This file type is not supported.',
			        dictFileTooBig:'File size too Big',
			        dictDefaultMessage : "Drop image here to upload",
			        headers:{
			          'x-auth': null  
			        },       
			    };
			    scope.dzCallbacksThumb = {
					'processing': function(file) {
						var dz =scope.dzMethodsThumb.getDropzone();
						var uploadThumbUrl;
						if(scope.editMediaCurrent.transcoding_provider == 'mediaoutcast') {
							uploadThumbUrl = 'https://upload.telegraf.tv/api/mediaoutcast/thumb/update'
						} else {
							uploadThumbUrl = 'https://upload.telegraf.tv/api/'+scope.videoVersion+'/thumb/update'
						}
						dz.options.url= uploadThumbUrl
					}, 
			        'addedfile' : function(file){
						fileReaderImage(file,function(width,height){
							if (((scope.editMediaCurrent.orientation=='portrait') &&  (width < 541 || height < 961)) || 
	            				((scope.editMediaCurrent.orientation!='portrait') &&  (width < 816 || height < 459))) {
								scope.dzMethodsThumb.removeFile(file);
								var imageDimensions = (scope.editMediaCurrent.orientation=='portrait')? '541x961':'816x459'
								alertService('danger','Opps! ', "Image dimensions are too small (min-dimensions:"+ imageDimensions +"). The file has been removed.");
							} else {
								uploadFile()
							}
						})
						function uploadFile() {
							scope.newFileThumb = file;
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								var token = authtokenService.getToken();
								scope.dzOptionsThumb.headers['x-auth'] = token;
								scope.dzMethodsThumb.processQueue();
							},
							function(error) {
								// report something
							},
							function(progress) {
							// report progress
							});
						}
			        },
			        'success' : function(file, xhr, response){
			        	var data = JSON.parse(response.currentTarget.response);
			            scope.customThumb = data.image;
			            scope.customThumbsLocked = angular.copy(data.image); 
				
			            scope.uploadedThumb = true;
			            if(scope.thumbsLocked.length != scope.thumbs.length) {
			                scope.thumbs.splice(-1,1); 
			            }
						scope.thumbs.push(scope.config.baseVideoHref + scope.customThumb.replace('.jpg',thumbDisplayRes));
			            scope.selectedImage = scope.thumbs.length-1;
			            scope.image = scope.customThumbsLocked;
			            // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg')+')')
			        	scope.player.poster(scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg'));
			        },
			        'error' : function(file,message) {
						if(message && message.error && message.error.message) {
							jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
						}
			        },
			        'sending':function(file, xhr, formData) {
			        	formData.append('video_id', scope.editMediaCurrent.video_id);
	            		formData.append('date', scope.date);
						formData.append('dir', scope.thumbDir);
			            // if(scope.upload_title) {
			            //     formData.append('title', scope.upload_title);
			            // }
			            // if(scope.upload_signature) {
	
			            //     formData.append('signature', scope.upload_signature);
			            // }
			            // if(scope.upload_description) {
			            //     formData.append('description', scope.upload_description);
			            // }
			        }
			    };
			    scope.dzMethodsThumb = {
	
			    }
			    scope.updateSafety = function(safeId, checked) {
			    	// scope.safe = safeId;
			    	if(checked) {
				        for(var i = 0; i<scope.addSafety.length;i++) {
				          scope.checkedItems[scope.addSafety[i]._id] = false
				        }
				        scope.checkedItems[safeId]= true;
				        scope.safe = safeId;  
				      } else {
				        scope.safe = null;
				      }	
			    }
			    scope.chooseImage = function(index) {
		            scope.selectedImage = index;
		            if(scope.thumbs.length == scope.thumbsLocked.length) {
		            	scope.image = scope.thumbsLocked[index] 
		            } else {
		            	if(index==scope.thumbs.length-1) {
		                scope.image = scope.customThumbsLocked;
		            	} else {
		                	scope.image = scope.thumbsLocked[index];
		            	}
		            }
		            // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.image.replace('.jpg','-620x350.jpg')+')')
			    	scope.player.poster(scope.config.baseVideoHref + scope.image.replace('.jpg',posterDisplayRes));
			    }
			    scope.editPostStatus = function() {
			      scope.editPostStatusShow = true;
			    }
			    scope.changePostStatus = function() {
			      scope.editPostStatusShow = false;
			      scope.editMediaCurrent.status = scope.selectedPostStatus.value;
			    }
			    scope.editPostTime = function() {
			      scope.editPostDateShow = true;
			      if(!scope.pastPost &&!scope.editPublish && !scope.scheduledPost) {
			        convertTimeFunction(undefined);
			      } 
			    }
			    scope.cancelEditPostDate = function() {
			      scope.editPostDateShow = false; 
			    }
			    scope.cancelEditPostStatus = function() {
			      scope.editPostStatusShow = false;
			      scope.selectedPostStatus = {value: scope.editMediaCurrent.status};
			    }
				scope.editSlug = function(slug) {
			      scope.copyEditSlug = angular.copy(slug);
			      scope.editSlugShow = true;
			    }
			    scope.cancelSlug = function() {
			      scope.postSlug = scope.copyEditSlug;
				  if(!scope.postSlug) {
					scope.postSlug = '';
				  } 
			      scope.editSlugShow = false; 
			    }
			    scope.updateSlug = function(slug) {
			      scope.postSlug = slugify(scope.postSlug)
				  if(!scope.postSlug) {
					scope.postSlug = '';
				  }
			      scope.editSlugShow = false; 
			    }
				$rootScope.closeEditVideo = function() {
					scope.media.editVideoShow= false;
					scope.editMediaCurrent = null;
					$state.transitionTo('app.allvideos', {id: null}, {
		              location: true,
		              inherit: true,
		              relative: $state.$current,
		              notify: false
		            });
				}
				scope.searchPress = function(evt) {
			     keyPress(evt);
			    }
			    
		// 	    document.getElementById('source_one').addEventListener('click', function() {
		// 			console.log('ajde');
		// // 			document.getElementById('my-player_html5_api').src = 'http://now.tf.rs/ads/2017/11/13/ads_persen.mp4';
		// 		// 		scope.player.load();
		// 			scope.player.src('http://now.tf.rs/ads/2017/11/13/ads_persen.mp4');
		// 			scope.player.currentTime(20);
		// 			scope.player.play();
		// 			});
				var getVideoCategoriesFunction = function() {
			    	getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
							scope.categories = dataCategory.categories;
							scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
				    	getFunction();
				    }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							return
						}
				      	if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function(answer) {
								if(answer==200) {
									getVideoCategoriesFunction();
								}
							},
							function(error) {
								// report something
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
				    });
				}  
				getVideoCategoriesFunction();
				scope.updateSelection = function(category_id, checked) {
				  var updateSelectionTree = function(categories) {
				    if(checked) {
				      for (var i=0; i<categories.length; i++){
				        if (categories[i]._id !== category_id) {
				          scope.categorychecked.item[categories[i]._id] = false;
				        }
				      }
				      scope.category = category_id;
				    } else {
				      scope.category = null;
				    }
				  }
				  updateSelectionTree(scope.categoriesTreeInput);   
				}
				var addNewTagFunction = function(data) {
				    scope.newTagRequired = false;
				    if(!checkArray.contains.call(scope.editMediaCurrent.tags,data.tagId)) {
				        scope.editMediaCurrent.tags.push(data.tagId);
				        scope.searchtagfocus = null;
				        scope.existTag = false;
				    } else {
				        scope.existTag = true;
				    }
			    }
			    scope.$on('select-tag', function(event,data) {
			      	addNewTagFunction(data.selectedTagObj)
			    });
			    scope.addNewTag = function() {
			      	if(scope.searchtagfocus && scope.searchtagfocus.length>1) {
			        	var postFunction = function() {
				          	postDataService.save({
				            	param1:'video-tags', 
				            	// param2: 'create'
				          	},{
				            	'name': scope.searchtagfocus
				          	}).$promise.then(function(postTag){
				          		var data = {
				            	tagId:postTag.tag._id,
				            	tagname: postTag.tag.name
				          		} 
				            	addNewTagFunction(data);
				          	}, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
				            	if(error.status ==401) {
					              	var promise = refreshtokenService.getAccessToken();
					              	promise.then(
					                function(answer) {
					                  if(answer==200) {   
					                    postFunction();
					                  }
					                },
					                function(error) {
					                },
					                function(progress) {
					                 // report progress
					              	});
					            } else if(error.status ==502) {
					              	serverError()
					            } else if(error.status ==400) {
					              	var data = {
						            tagId:error.data.tag._id,
						                tagname: error.data.tag.name
						            } 
					              	addNewTagFunction(data);
					            }
				          	});
			        	}
			        	postFunction();
			      	} else {
			        	scope.newTagRequired = true;
			      	}
			    }
			    scope.removeFromTagsList = function(index) {
			      	scope.editMediaCurrent.tags.splice(index, 1);
			    }
			    scope.setPublishedDate = function() {
			      scope.editPostDateShow = false; 
			      // scope.scheduledPost = false;
			      var dateArray = [scope.postYear, parseInt(scope.selectedPostMont.value)-1, scope.postDay, scope.postHours, scope.postMinutes];
			      updateDate = moment(dateArray).toISOString();
			      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>5) {
			        scope.scheduledPost = true;
			      } else if(moment.duration(moment(dateArray).diff(moment())).asMinutes()<=5 && moment.duration(moment(dateArray).diff(moment())).asMinutes()>-5 && !scope.editPublish) {
			          updateDate = moment().toISOString();
			          scope.scheduledPost = false;
			          scope.pastPost = false;
			      }
			      else {
			          scope.pastPost = true;
			          scope.scheduledPost = false;
			      }
			      scope.editMediaCurrent.date = $filter('date')(updateDate, "MMM d, y HH:mm");
			    }
			    var convertTimeFunction = function(date) {
			      var a = moment(date);
			      var year = a.format('YYYY');
			      var month = a.format('M');
			      var day = a.format('D');
			      var hour = a.hours();
			      var min = a.minutes();
			      var sec = a.seconds();
			      scope.postYear = year;
			      scope.selectedPostMont = {value: month};
			      scope.postDay = day;
			      if(hour<10) {
			        scope.postHours = '0'+hour;  
			      } else {
			        scope.postHours = hour;
			      }
			      if(min<10) {
			        scope.postMinutes = '0'+min;  
			      } else {
			        scope.postMinutes = min;
			      }
			    }
			    scope.getVideoFunction = function() {
			    	scope.selectedPostStatus={value:scope.editMediaCurrent.status};
			    	updateDate = null;
			    	scope.pastPost = false;
			      	scope.scheduledPost = false;
			      	scope.editPublish =false;
			      	scope.postSlug = '';
			      	scope.copySlug = '';
			      	scope.previewHash = null;
			      	scope.substringUri = null;
					posterDisplayRes = (scope.editMediaCurrent.orientation=='portrait')? '-360x640.jpg':'-620x350.jpg';
					thumbDisplayRes = (scope.editMediaCurrent.orientation=='portrait')? '-360x640.jpg':'-254x191.jpg';
			      	if(scope.editMediaCurrent.status == 'publish') {
				        scope.editPublish = true;
				        if(scope.editMediaCurrent.date) {
				          updateDate = scope.editMediaCurrent.date;
				        }
				    }else if(scope.editMediaCurrent.status=='trash') {
				        scope.media.editVideoShow = false;
				        $state.transitionTo('app.allvideos', {id: null}, {
				          location: true,
				          inherit: true,
				          relative: $state.$current,
				          notify: false
				        });
						return
				    } else if(scope.editMediaCurrent.status=='schedule') {
				        scope.scheduledPost = true;
				        if(scope.editMediaCurrent.date) {
				          updateDate = scope.editMediaCurrent.date;
				        }
				    }
			     	if(scope.editMediaCurrent.date) {
			        	scope.editMediaCurrent.date = $filter('date')(scope.editMediaCurrent.date, "MMM d, y HH:mm");
			        	convertTimeFunction(scope.editMediaCurrent.date);
			      	}
			    	scope.editMediaCurrent.video_file = scope.config.baseVideoHref + scope.editMediaCurrent.file.m3u8;
			     	scope.editMediaCurrent.tags = checkArray.removeDuplicate(scope.editMediaCurrent.tags);
			     	
			     	scope.thumbs = scope.editMediaCurrent.thumbs;
			     	scope.thumbsLocked = angular.copy(scope.editMediaCurrent.thumbs);
			     	if(scope.editMediaCurrent.custom_image) {
			     		scope.uploadedThumb = true;
			     		scope.customThumbsLocked = angular.copy(scope.editMediaCurrent.custom_image); 
			     		scope.thumbs.push(scope.editMediaCurrent.custom_image); 
			     	}
			     	scope.image = scope.editMediaCurrent.image;
			     	scope.selectedImage = scope.thumbs.indexOf(scope.editMediaCurrent.image);
		          	for(var i=0; i<scope.thumbs.length;i++) {
		                scope.thumbs[i]=scope.config.baseVideoHref + scope.thumbs[i].replace('.jpg',thumbDisplayRes); 
					}
					if(scope.editMediaCurrent.file.m3u8.includes('encoded')) {
					// 	scope.videoVersion = 'v1.1'
						scope.dateDefault = scope.editMediaCurrent.file.m3u8.substring(9,19);
					} else {
					// 	scope.videoVersion = 'v1.0'
						scope.dateDefault = scope.editMediaCurrent.file.m3u8.substring(1,11);
					}
					scope.thumbDir = scope.editMediaCurrent.file.m3u8.substring(0, scope.editMediaCurrent.file.m3u8.lastIndexOf('/'));
	        		scope.date = scope.dateDefault.replace(/\//g,'-');
		          	if(scope.editMediaCurrent.slug) {
			        	scope.postSlug = scope.editMediaCurrent.slug;
								scope.copySlug = angular.copy(scope.postSlug); 
							
			      	}
			      	if(scope.editMediaCurrent.slug && scope.editMediaCurrent.uri) {
			        	var slugLength = scope.editMediaCurrent.slug.length;
			        	scope.substringUri = scope.editMediaCurrent.uri.substr(0, scope.editMediaCurrent.uri.length-slugLength);
			      	}
			      	if(scope.editMediaCurrent.duration){
	                  var formatedTime;
	                  if(scope.editMediaCurrent.duration>=3600) {
	                    formatedTime = 'H:mm:ss'
	                  } else {
	                    formatedTime = 'm:ss'
	                  } 
	                  scope.editMediaCurrent.formated_duration = moment().startOf('day').second(scope.editMediaCurrent.duration).format(formatedTime);
	                }
	                if(scope.editMediaCurrent.transcoding_status == 0) {
	                	scope.transcodingText = "Transcoding in progress..."
	                } else if(scope.editMediaCurrent.transcoding_status == -1) {
	                	scope.transcodingText = "Transcoding failed"
	                } else {
	                	scope.transcodingText = "Transcoding success"
	                }
	                
	                scope.addSafety =config.addSafety;
	           		if(scope.editMediaCurrent.meta.safe) {
	           			for(var i=0;i<scope.addSafety.length;i++) {
	           				scope.checkedItems[scope.addSafety[i]._id] = false;
	           				if(scope.editMediaCurrent.meta.safe==scope.addSafety[i]._id) {
	           					scope.checkedItems[scope.addSafety[i]._id] = true;
	           					scope.safe = scope.editMediaCurrent.meta.safe;
	           				}
	           			}
	           		}
	           		if(scope.editMediaCurrent.allowance) {
	           			geoAllowanceUpdateFunction();
	           			scope.allowCheckedItems[scope.editMediaCurrent.allowance] = true;
			      		scope.geoAllow = scope.editMediaCurrent.allowance;
	           		}
			      	if(!scope.player) {
	
				      	scope.videoGet = true;
			            $timeout(function() {
	
						    // function examplePlugin(options) {
						    //   this.on('play', function(e) {
						    //     console.log('playback has started!');
						    //   });
						    // };
				      //       videojs.registerPlugin('examplePlugin', examplePlugin);
							scope.player = videojs('my-player',
							{
								poster:scope.config.baseVideoHref + scope.image.replace('.jpg',posterDisplayRes),
						      	playbackRates: [0.5, 1, 1.5, 2],
						      	autoplay:false
						  	});
				            scope.player.src({
								src: scope.editMediaCurrent.video_file,
									type: 'application/x-mpegURL',
									withCredentials: false
				            });
				            scope.player.on("play", function() {
				            	scope.$apply(function() {
				            		scope.durationFlag = false;
				            	})
				            });
				            scope.videoLoaded = true;
				            scope.durationFlag = true;
				            
			            },0)
			      	}
	
			      	if(scope.editMediaCurrent.category) {
				        for (var i=0; i<scope.categoriesTreeInput.length; i++){
				          if (scope.categoriesTreeInput[i]._id === scope.editMediaCurrent.category._id) {
				            scope.categorychecked.item[scope.categoriesTreeInput[i]._id] = true;
				            scope.category = scope.categoriesTreeInput[i]._id;
				          }
				        }
				        $timeout(function() {
				          var checkedCategory = jQuery(".checkedEditPost");
				          if(checkedCategory.length != 0) {
				              var topPos = checkedCategory[0].offsetTop;
				              jQuery('#categoryscroll').animate({scrollTop: topPos-2},600);
				          }
				        },300)
			      	}
				}
			    var getFunction = function() {
				    getDataService.get({param1:state, param2: scope.attachmentId}).$promise.then(function(data){
				     	scope.editMediaCurrent = data;
				     	scope.getVideoFunction();
				     	
				    }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							return
						}
				        if(error.status ==401) {
					        var promise = refreshtokenService.getAccessToken();
					        promise.then(
					          function(answer) {
					            if(answer==200) {
					              getFunction();
					            }
					          },
					          function(error) {
					            // report something
					          },
					          function(progress) {
					           // report progress
					        });
				        }else if(error.status ==502) {
			                serverError();
		                } else {
					        scope.media.editMediaShow= false;
					        $rootScope.hasLoaded = true;
					        $state.transitionTo('app.allvideos', {id: null}, {
				              location: true,
				              inherit: true,
				              relative: $state.$current,
				              notify: false
				            });
				      	}
				    }); 
			    }
			    scope.$on( '$destroy', function() {
				    if(scope.player) {
				    	scope.player.dispose();
				    	scope.player =null;
				    }
				});
				if(!window.navigator.onLine) {
					offlineError('refresh')
					return
				}
			}
		}
	}
	}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// public/bundle.min.js